// @ts-nocheck
/* eslint-disable */
/* prettier-ignore */

type GeometryTypePolygon = 'Polygon';
type GeometryTypeMultiPolygon = 'MultiPolygon';
export type Geometry =
  | { type: GeometryTypePolygon; coordinates: number[][][] }
  | { type: GeometryTypeMultiPolygon; coordinates: number[][][][] };
export interface CountryGeoBorders {
  type: 'FeatureCollection';
  features: {
    type: 'Feature';
    properties: { name: string; iso3: string };
    geometry: Geometry;
  }[];
}

export const countryGeo10: CountryGeoBorders = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {
        name: 'Costa Rica',
        iso3: 'CRI',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-83.69649978585412, 10.936594144736317],
              [-83.68686707685461, 10.937970246495594],
              [-83.68176632278032, 10.935434518184676],
              [-83.67833546290187, 10.935952757867287],
              [-83.67299123886046, 10.933231989430151],
              [-83.67299123886046, 10.931288568122966],
              [-83.67556438376928, 10.929409915424063],
              [-83.67556438376928, 10.92597648493106],
              [-83.67127580892124, 10.926494741135784],
              [-83.66619549717815, 10.931223787193453],
              [-83.66535239648923, 10.935318186754772],
              [-83.66075598899994, 10.934393622000073],
              [-83.64435787699995, 10.925930080000057],
              [-83.62425696499992, 10.902899481000077],
              [-83.59870357999995, 10.856594143000052],
              [-83.58055579299992, 10.807318427000041],
              [-83.58287512899994, 10.77570221600007],
              [-83.59756425699993, 10.79360586100006],
              [-83.6238500639999, 10.857611395000049],
              [-83.60692298099991, 10.777777411000045],
              [-83.60863196499992, 10.745510158000059],
              [-83.6375219389999, 10.721096096000053],
              [-83.62222245999993, 10.723863023000092],
              [-83.61188717399995, 10.730861721000053],
              [-83.60216223899994, 10.739569403000075],
              [-83.58910071499992, 10.747748114000046],
              [-83.59365800699993, 10.742661851000037],
              [-83.59471594999991, 10.73655833500004],
              [-83.59300696499992, 10.729315497000073],
              [-83.58910071499992, 10.721096096000053],
              [-83.5852758449999, 10.732855536000045],
              [-83.58104407499991, 10.755804755000042],
              [-83.57542883999992, 10.768255927000041],
              [-83.52696692599994, 10.636053778000075],
              [-83.46617591099994, 10.494533596000053],
              [-83.39452063699991, 10.37604401200008],
              [-83.20372473899994, 10.129339911000045],
              [-83.18838456899994, 10.117743231000077],
              [-83.12466386599993, 10.040594794000071],
              [-83.08531653599994, 10.002142645000049],
              [-83.06151282499991, 10.015326239000046],
              [-83.05239824099993, 10.009588934000078],
              [-83.02603105399993, 10.005031643000052],
              [-83.02057857999995, 9.997381903000075],
              [-83.01984615799995, 9.978705145000049],
              [-83.01667232999995, 9.96312083500004],
              [-83.00934811099995, 9.949286200000074],
              [-82.99632727799991, 9.935939846000053],
              [-82.94977779899995, 9.867580471000053],
              [-82.9348852199999, 9.857082424000055],
              [-82.87726803299995, 9.780096747000073],
              [-82.83381100199995, 9.739488023000092],
              [-82.80825761599993, 9.747219143000052],
              [-82.80247962099992, 9.73151276200008],
              [-82.79698645699995, 9.691229559000078],
              [-82.78774980399993, 9.672756252000056],
              [-82.77232825399994, 9.661037502000056],
              [-82.70523027299993, 9.637925523000092],
              [-82.68138587099992, 9.63548411700009],
              [-82.65794837099992, 9.636297919000071],
              [-82.63589433499993, 9.634507554000038],
              [-82.61644446499992, 9.624335028000075],
              [-82.59142005099994, 9.58698151200008],
              [-82.57457434799994, 9.57680898600006],
              [-82.57359778599994, 9.576198635000083],
              [-82.56283687399991, 9.53869537300011],
              [-82.57061417699992, 9.538230285000083],
              [-82.58588456299987, 9.546240133000055],
              [-82.6011032719999, 9.548668925000115],
              [-82.60820878199993, 9.537868551000088],
              [-82.61239457299988, 9.499498800000055],
              [-82.61885412599992, 9.486708883000077],
              [-82.63213496999992, 9.484667663000039],
              [-82.65071264699989, 9.487845764000085],
              [-82.66820511899994, 9.493168437000037],
              [-82.67804947999991, 9.497767639000088],
              [-82.68866898699991, 9.509446513000057],
              [-82.70145890399988, 9.53355356900002],
              [-82.71169083699996, 9.544999899000118],
              [-82.71972652199995, 9.541330872000032],
              [-82.72936417699995, 9.54489654600009],
              [-82.77109289599989, 9.579855652000091],
              [-82.82902217599994, 9.6027224730001],
              [-82.84747066299985, 9.600655416000052],
              [-82.8660483409999, 9.5850749720001],
              [-82.87739131699988, 9.569184469000092],
              [-82.8792516689999, 9.55990854900007],
              [-82.86713354499989, 9.538643697000097],
              [-82.86020890299991, 9.511203512000037],
              [-82.85591975899985, 9.505441590000075],
              [-82.84938269099987, 9.503477885000038],
              [-82.84478348899992, 9.500687358000079],
              [-82.84638545799996, 9.492548320000068],
              [-82.86129410899991, 9.484099223000072],
              [-82.9146241869999, 9.476864522000099],
              [-82.93330521699997, 9.470327454000127],
              [-82.94170263699993, 9.45634897900004],
              [-82.94428645899987, 9.437151185000118],
              [-82.94320125399986, 9.354313863000101],
              [-82.94165096099994, 9.234424540000134],
              [-82.93952108499991, 9.070641889000072],
              [-82.93937719799993, 9.059577332000032],
              [-82.90945654399988, 9.072005514000097],
              [-82.90023229999989, 9.072057190000109],
              [-82.89328181999988, 9.066941224000033],
              [-82.88969030799993, 9.059370626000074],
              [-82.88687394299987, 9.05148997000012],
              [-82.88242976999993, 9.04534047500006],
              [-82.87656449499985, 9.041929830000129],
              [-82.85408524699994, 9.031982117000041],
              [-82.80817073599988, 8.9983665970001],
              [-82.76269547599992, 8.98299285900012],
              [-82.74913041199991, 8.974078674000097],
              [-82.72334387199993, 8.930928854000072],
              [-82.71936478699985, 8.921523743000108],
              [-82.72015670999991, 8.920237750000112],
              [-82.73386002599997, 8.897985128000116],
              [-82.76378067999991, 8.879950053000115],
              [-82.86692683999993, 8.838066304000051],
              [-82.8785798749999, 8.82977223800009],
              [-82.88832088299995, 8.816930644000095],
              [-82.88356665099985, 8.81238311800007],
              [-82.87563431899991, 8.807525533000046],
              [-82.87578934799984, 8.793908793000043],
              [-82.88511694399998, 8.78318593400013],
              [-82.91488256899996, 8.764789124000032],
              [-82.92296992999988, 8.756159160000081],
              [-82.9241584889999, 8.741198832000123],
              [-82.91922338899994, 8.72706532800008],
              [-82.91033504299992, 8.713913676000104],
              [-82.87894160999991, 8.679057923000045],
              [-82.86222428499985, 8.655700176000096],
              [-82.84979610299987, 8.629861959000067],
              [-82.84186376999992, 8.599476217000117],
              [-82.83597265699993, 8.52976471000008],
              [-82.83891821399993, 8.494624736000034],
              [-82.84829748599986, 8.46516916900012],
              [-82.87041499899988, 8.438116557000072],
              [-82.89651159699989, 8.425352478000107],
              [-82.92477860499986, 8.41674835200007],
              [-82.95351070199987, 8.402098084000087],
              [-82.9977715659999, 8.360162659000096],
              [-83.04329850299987, 8.334737854000082],
              [-83.05210933499987, 8.327632345000055],
              [-83.05324621699995, 8.315100810000047],
              [-83.04407364999986, 8.305359803000101],
              [-83.01606502399994, 8.289004211000062],
              [-83.01076818899992, 8.283371480000127],
              [-83.00110469599989, 8.269237976000085],
              [-82.99552364099989, 8.264819641000088],
              [-82.98919327799987, 8.264457907000093],
              [-82.97712683099988, 8.269237976000085],
              [-82.96800594099989, 8.267971904000134],
              [-82.95051346899993, 8.258825175000055],
              [-82.94366634199989, 8.248567403000067],
              [-82.93909297799985, 8.216838074000052],
              [-82.88640885499993, 8.102193909000093],
              [-82.89136979199989, 8.057545471000068],
              [-82.8976292589999, 8.034748020000023],
              [-82.91124426999994, 8.045355536000045],
              [-82.9096980459999, 8.060614325000074],
              [-82.9021296869999, 8.077460028000075],
              [-82.89761308499993, 8.092800197000088],
              [-82.90038001199991, 8.105047919000071],
              [-82.96849524599992, 8.221218166000085],
              [-82.99258378799993, 8.24640534100007],
              [-83.11685136599993, 8.336127020000049],
              [-83.15086829299992, 8.369289455000057],
              [-83.12149003799993, 8.40493398600006],
              [-83.11607825399994, 8.407782294000071],
              [-83.11046301999994, 8.418036200000074],
              [-83.09959876199991, 8.431341864000046],
              [-83.09268144399994, 8.446682033000059],
              [-83.09902910099993, 8.462713934000078],
              [-83.13170325399994, 8.503200588000084],
              [-83.13719641799992, 8.514553127000056],
              [-83.1377253899999, 8.529323635000083],
              [-83.13060462099992, 8.534491278000075],
              [-83.11815344999991, 8.53815338700008],
              [-83.10244706899994, 8.548041083000044],
              [-83.11424719999991, 8.551784572000088],
              [-83.14342200399994, 8.55023834800005],
              [-83.15770423099991, 8.555487372000073],
              [-83.16515051999994, 8.563747463000084],
              [-83.18504798099991, 8.602687893000052],
              [-83.18175208199995, 8.607855536000045],
              [-83.18016516799992, 8.611354885000083],
              [-83.17821204299992, 8.616970119000086],
              [-83.17137610599991, 8.616970119000086],
              [-83.16173255099994, 8.600734768000052],
              [-83.15880286399994, 8.592800197000088],
              [-83.15770423099991, 8.579413153000075],
              [-83.15330969999991, 8.577175197000088],
              [-83.12356523299991, 8.589016018000052],
              [-83.12356523299991, 8.596462307000081],
              [-83.13723710799991, 8.60219961100006],
              [-83.15172278599994, 8.612860419000071],
              [-83.16405188699991, 8.62563711100006],
              [-83.17137610599991, 8.637477932000081],
              [-83.17821204299992, 8.637477932000081],
              [-83.18578040299991, 8.625189520000049],
              [-83.20396887899994, 8.62445709800005],
              [-83.22476152299993, 8.62685781500005],
              [-83.2402644519999, 8.623806057000081],
              [-83.2475886709999, 8.637233791000085],
              [-83.2593074209999, 8.651312567000048],
              [-83.27318274599992, 8.658474026000079],
              [-83.2873835929999, 8.651068427000041],
              [-83.31908118399991, 8.669582424000055],
              [-83.32835852799991, 8.684597072000088],
              [-83.32217363199993, 8.70571523600006],
              [-83.32900956899994, 8.706203518000052],
              [-83.33580481699994, 8.70571523600006],
              [-83.33169511599993, 8.722072658000059],
              [-83.34585527299993, 8.72992584800005],
              [-83.36693274599992, 8.73427969000005],
              [-83.38365637899994, 8.739813544000071],
              [-83.38951575399994, 8.728094794000071],
              [-83.3948054679999, 8.728949286000045],
              [-83.4013972649999, 8.733710028000075],
              [-83.41152910099993, 8.733669338000084],
              [-83.4162898429999, 8.728298244000086],
              [-83.4175105459999, 8.721258856000077],
              [-83.4216609369999, 8.71515534100007],
              [-83.43517005099994, 8.712551174000055],
              [-83.46825110599991, 8.717474677000041],
              [-83.4817195299999, 8.712591864000046],
              [-83.48668372299994, 8.692694403000075],
              [-83.47911536399994, 8.698431708000044],
              [-83.47923743399991, 8.698879299000055],
              [-83.47301184799994, 8.698879299000055],
              [-83.43789628799993, 8.646429755000042],
              [-83.43325761599993, 8.630519924000055],
              [-83.41274980399993, 8.598456122000073],
              [-83.40477454299992, 8.589016018000052],
              [-83.39159094999991, 8.582302151000079],
              [-83.35423743399991, 8.571071682000081],
              [-83.33922278599994, 8.569159247000073],
              [-83.3254695299999, 8.560980536000045],
              [-83.31236731699994, 8.545070705000057],
              [-83.29971269399994, 8.534369208000044],
              [-83.2873835929999, 8.541815497000073],
              [-83.28685462099992, 8.517157294000071],
              [-83.2888484369999, 8.507025458000044],
              [-83.29491126199991, 8.500270901000079],
              [-83.29491126199991, 8.493434963000084],
              [-83.27981523299991, 8.472927151000079],
              [-83.2737117179999, 8.437933661000045],
              [-83.27635657499991, 8.401556708000044],
              [-83.2873835929999, 8.376735744000086],
              [-83.3098445299999, 8.375921942000048],
              [-83.34642493399991, 8.387600002000056],
              [-83.3808894519999, 8.404120184000078],
              [-83.3972468739999, 8.417669989000046],
              [-83.39110266799992, 8.417669989000046],
              [-83.38662675699993, 8.414129950000074],
              [-83.38296464799993, 8.412502346000053],
              [-83.36937415299991, 8.410915432000081],
              [-83.38866126199991, 8.419501044000071],
              [-83.39647376199991, 8.424587307000081],
              [-83.40477454299992, 8.43195221600007],
              [-83.40477454299992, 8.417669989000046],
              [-83.4624324209999, 8.442694403000075],
              [-83.48294023299991, 8.44562409100007],
              [-83.54417883999992, 8.438259182000081],
              [-83.56114661399994, 8.438177802000041],
              [-83.57559160099993, 8.444973049000055],
              [-83.5888972649999, 8.458563544000071],
              [-83.61327063699991, 8.490016994000086],
              [-83.7002253899999, 8.570339260000083],
              [-83.70579993399991, 8.579413153000075],
              [-83.71011308499993, 8.580511786000045],
              [-83.73058020699995, 8.588812567000048],
              [-83.73680579299992, 8.592718817000048],
              [-83.73989824099993, 8.623806057000081],
              [-83.70946204299992, 8.670355536000045],
              [-83.70238196499992, 8.678412177000041],
              [-83.68667558499993, 8.687689520000049],
              [-83.67593339799993, 8.691799221000053],
              [-83.67100989499994, 8.68891022300005],
              [-83.66783606699994, 8.682928778000075],
              [-83.6609187489999, 8.689846096000053],
              [-83.63658606699994, 8.726752020000049],
              [-83.63003495999993, 8.733669338000084],
              [-83.64256751199991, 8.74953847900008],
              [-83.62747148299991, 8.767401434000078],
              [-83.60000566299993, 8.782049872000073],
              [-83.57542883999992, 8.788275458000044],
              [-83.57542883999992, 8.79446035400008],
              [-83.59707597599993, 8.797023830000057],
              [-83.60794023299991, 8.796047268000052],
              [-83.61538652299993, 8.79010651200008],
              [-83.62694251199991, 8.777736721000053],
              [-83.63866126199991, 8.772284247000073],
              [-83.64256751199991, 8.78188711100006],
              [-83.63780676999994, 8.798854885000083],
              [-83.6238093739999, 8.815578518000052],
              [-83.59902910099993, 8.827541408000059],
              [-83.58763587099992, 8.835353908000059],
              [-83.58287512899994, 8.846625067000048],
              [-83.58910071499992, 8.856756903000075],
              [-83.60208085799991, 8.863796291000085],
              [-83.61388098899994, 8.873236395000049],
              [-83.61636308499993, 8.890692450000074],
              [-83.59703528599994, 8.880886135000083],
              [-83.5876765619999, 8.87799713700008],
              [-83.57542883999992, 8.877630927000041],
              [-83.58141028599994, 8.884955145000049],
              [-83.58897864499994, 8.89052969000005],
              [-83.60338294199994, 8.898138739000046],
              [-83.60948645699995, 8.903143622000073],
              [-83.61294511599993, 8.907782294000071],
              [-83.61827551999994, 8.910956122000073],
              [-83.63003495999993, 8.911769924000055],
              [-83.61790930899991, 8.91901276200008],
              [-83.61961829299992, 8.924261786000045],
              [-83.62657630099994, 8.928249416000085],
              [-83.63003495999993, 8.931667385000083],
              [-83.62551835799991, 8.942653713000084],
              [-83.6203914049999, 8.950832424000055],
              [-83.61339270699995, 8.95807526200008],
              [-83.60338294199994, 8.966376044000071],
              [-83.62987219999991, 9.035345770000049],
              [-83.63475501199991, 9.044094143000052],
              [-83.6511531239999, 9.06195709800005],
              [-83.6579890619999, 9.055202541000085],
              [-83.6804499989999, 9.084133205000057],
              [-83.70091712099992, 9.117865302000041],
              [-83.72720292899993, 9.144313869000086],
              [-83.76720130099994, 9.151393947000088],
              [-83.76488196499992, 9.17719147300005],
              [-83.7868953119999, 9.199245510000083],
              [-83.81712805899991, 9.214504299000055],
              [-83.83950761599993, 9.220282294000071],
              [-83.91808020699995, 9.294745184000078],
              [-83.99510657499991, 9.330226955000057],
              [-84.00743567599994, 9.33974844000005],
              [-84.10362708199995, 9.37726471600007],
              [-84.10985266799992, 9.37726471600007],
              [-84.11632239499994, 9.37258535400008],
              [-84.12193762899994, 9.372626044000071],
              [-84.12661699099993, 9.376898505000042],
              [-84.13036048099991, 9.384711005000042],
              [-84.1440730459999, 9.378851630000042],
              [-84.15225175699993, 9.385321356000077],
              [-84.16152910099993, 9.394720770000049],
              [-84.17870032499991, 9.397772528000075],
              [-84.16795813699991, 9.416205145000049],
              [-84.18224036399994, 9.442206122000073],
              [-84.20836341099994, 9.464992580000057],
              [-84.23338782499991, 9.473456122000073],
              [-84.23338782499991, 9.46670156500005],
              [-84.22459876199991, 9.464992580000057],
              [-84.21865800699993, 9.462551174000055],
              [-84.20543372299994, 9.45302969000005],
              [-84.23143469999991, 9.457546291000085],
              [-84.27269446499992, 9.481594143000052],
              [-84.2988582019999, 9.487127997000073],
              [-84.32420813699991, 9.489081122000073],
              [-84.45791581899994, 9.52602773600006],
              [-84.48350989499994, 9.528102932000081],
              [-84.49547278599994, 9.52602773600006],
              [-84.50829016799992, 9.521999416000085],
              [-84.52159583199995, 9.519313869000086],
              [-84.53502356699994, 9.521307684000078],
              [-84.54674231699994, 9.531073309000078],
              [-84.55068925699993, 9.54287344000005],
              [-84.55540930899991, 9.552394924000055],
              [-84.5691218739999, 9.555446682000081],
              [-84.56655839799993, 9.55141836100006],
              [-84.56509355399993, 9.548407294000071],
              [-84.56297766799992, 9.541164455000057],
              [-84.57949785099993, 9.554348049000055],
              [-84.61656653599994, 9.578070380000042],
              [-84.62376868399991, 9.592962958000044],
              [-84.62730872299994, 9.606716213000084],
              [-84.63609778599994, 9.613348700000074],
              [-84.64720618399991, 9.617702541000085],
              [-84.65794837099992, 9.624335028000075],
              [-84.66136633999992, 9.634466864000046],
              [-84.6599421869999, 9.644924221000053],
              [-84.66270911399994, 9.651678778000075],
              [-84.67837480399993, 9.65102773600006],
              [-84.67442786399994, 9.662380276000079],
              [-84.67552649599992, 9.67328522300005],
              [-84.67808997299994, 9.683539130000042],
              [-84.67837480399993, 9.692572333000044],
              [-84.67247473899994, 9.703802802000041],
              [-84.65526282499991, 9.720770575000074],
              [-84.6484675769999, 9.737697658000059],
              [-84.64146887899994, 9.746120510000083],
              [-84.63442949099993, 9.757025458000044],
              [-84.63121497299994, 9.771429755000042],
              [-84.6345515619999, 9.783392645000049],
              [-84.6423640619999, 9.793768622000073],
              [-84.65794837099992, 9.809271552000041],
              [-84.69839433499993, 9.868841864000046],
              [-84.70970618399991, 9.87759023600006],
              [-84.72594153599994, 9.884466864000046],
              [-84.72378495999993, 9.899603583000044],
              [-84.70970618399991, 9.922552802000041],
              [-84.73428300699993, 9.942572333000044],
              [-84.73879960799991, 9.952297268000052],
              [-84.73363196499992, 9.966945705000057],
              [-84.76231848899994, 9.97565338700008],
              [-84.85094153599994, 9.966945705000057],
              [-84.85094153599994, 9.974391994000086],
              [-84.8386531239999, 9.97915273600006],
              [-84.82290605399993, 9.980861721000053],
              [-84.78823808499993, 9.980617580000057],
              [-84.78823808499993, 9.987453518000052],
              [-84.8200984369999, 9.988959052000041],
              [-84.84854081899994, 9.993963934000078],
              [-84.87425696499992, 10.002630927000041],
              [-84.89810136599993, 10.015326239000046],
              [-84.92825273299991, 10.04010651200008],
              [-84.93285071499992, 10.045477606000077],
              [-84.93932044199994, 10.046942450000074],
              [-84.95201575399994, 10.055446682000081],
              [-84.9609675769999, 10.064886786000045],
              [-84.95616614499994, 10.069362697000088],
              [-84.97288977799991, 10.077948309000078],
              [-85.01390540299991, 10.115993557000081],
              [-85.03575598899994, 10.126735744000086],
              [-85.04605058499993, 10.136135158000059],
              [-85.05235755099994, 10.138251044000071],
              [-85.05736243399991, 10.136013088000084],
              [-85.06167558499993, 10.13226959800005],
              [-85.06737219999991, 10.131415106000077],
              [-85.0762019519999, 10.138251044000071],
              [-85.07030188699991, 10.148871161000045],
              [-85.06834876199991, 10.155666408000059],
              [-85.07286536399994, 10.158758856000077],
              [-85.07677161399994, 10.160589911000045],
              [-85.0898738269999, 10.172390041000085],
              [-85.10789954299992, 10.166571356000077],
              [-85.1755671869999, 10.16555410400008],
              [-85.19347083199995, 10.170111395000049],
              [-85.20946204299992, 10.18117910400008],
              [-85.23452714799993, 10.207098700000074],
              [-85.23452714799993, 10.213324286000045],
              [-85.2287898429999, 10.231594143000052],
              [-85.24624589799993, 10.252630927000041],
              [-85.28917395699995, 10.282253322000088],
              [-85.28307044199994, 10.26203034100007],
              [-85.2541804679999, 10.241156317000048],
              [-85.24754798099991, 10.216742255000042],
              [-85.2449031239999, 10.170355536000045],
              [-85.23888098899994, 10.143133856000077],
              [-85.22708085799991, 10.124579169000071],
              [-85.24010169199994, 10.11627838700008],
              [-85.23827063699991, 10.102443752000056],
              [-85.22647050699993, 10.08938222900008],
              [-85.19591223899994, 10.07876211100006],
              [-85.18504798099991, 10.067084052000041],
              [-85.17186438699991, 10.04205963700008],
              [-85.16563880099994, 10.04205963700008],
              [-85.15758216099994, 10.045355536000045],
              [-85.1540828119999, 10.042669989000046],
              [-85.15257727799991, 10.035834052000041],
              [-85.16128495999993, 10.035183010000083],
              [-85.17027747299994, 10.036322333000044],
              [-85.17882239499994, 10.038845119000086],
              [-85.18614661399994, 10.04205963700008],
              [-85.18614661399994, 10.035834052000041],
              [-85.16738847599993, 10.01939524900007],
              [-85.14452063699991, 9.999335028000075],
              [-85.08385169199994, 9.97492096600007],
              [-85.0762019519999, 9.970648505000042],
              [-85.06908118399991, 9.973415432000081],
              [-85.05313066299993, 9.966945705000057],
              [-85.01451575399994, 9.944973049000055],
              [-84.99669348899994, 9.939276434000078],
              [-84.9775691399999, 9.938788153000075],
              [-84.95958411399994, 9.946478583000044],
              [-84.94778398299991, 9.937160549000055],
              [-84.92259680899991, 9.921454169000071],
              [-84.91112219999991, 9.911688544000071],
              [-84.91112219999991, 9.905462958000044],
              [-84.93106035099993, 9.90070221600007],
              [-84.93016516799992, 9.886297919000071],
              [-84.91808020699995, 9.869533596000053],
              [-84.90493730399993, 9.857082424000055],
              [-84.91307532499991, 9.854315497000073],
              [-84.92076575399994, 9.848944403000075],
              [-84.93285071499992, 9.836615302000041],
              [-84.91808020699995, 9.830023505000042],
              [-84.90062415299991, 9.828070380000042],
              [-84.86461341099994, 9.82916901200008],
              [-84.86461341099994, 9.822943427000041],
              [-84.8786921869999, 9.81354401200008],
              [-84.89659583199995, 9.80609772300005],
              [-84.91201738199993, 9.795843817000048],
              [-84.91860917899993, 9.778265692000048],
              [-84.92235266799992, 9.774196682000081],
              [-84.94591223899994, 9.760891018000052],
              [-84.95034745999993, 9.753566799000055],
              [-84.95547441299993, 9.735134182000081],
              [-84.95958411399994, 9.727362372000073],
              [-84.99095618399991, 9.742743231000077],
              [-85.0075984369999, 9.744086005000042],
              [-85.01480058499993, 9.73078034100007],
              [-85.01036536399994, 9.722601630000042],
              [-84.99498450399994, 9.703273830000057],
              [-84.99742591099994, 9.699408270000049],
              [-85.02981523299991, 9.683742580000057],
              [-85.03526770699995, 9.682399807000081],
              [-85.03892981699994, 9.67727285400008],
              [-85.06261145699995, 9.665309963000084],
              [-85.06749426999994, 9.657375393000052],
              [-85.08934485599991, 9.588568427000041],
              [-85.09850012899994, 9.571071682000081],
              [-85.11046301999994, 9.555446682000081],
              [-85.11782792899993, 9.555446682000081],
              [-85.1457820299999, 9.612616278000075],
              [-85.22911536399994, 9.724391994000086],
              [-85.23452714799993, 9.737331447000088],
              [-85.23863684799994, 9.742010809000078],
              [-85.24791419199994, 9.747748114000046],
              [-85.2729792959999, 9.758002020000049],
              [-85.27505449099993, 9.76593659100007],
              [-85.2746882799999, 9.775051174000055],
              [-85.27550208199995, 9.782009182000081],
              [-85.29930579299992, 9.808010158000059],
              [-85.33242753799993, 9.826605536000045],
              [-85.43997148299991, 9.864528713000084],
              [-85.44957434799994, 9.862494208000044],
              [-85.4638972649999, 9.85260651200008],
              [-85.47036699099993, 9.85024648600006],
              [-85.4800105459999, 9.852484442000048],
              [-85.49356035099993, 9.862250067000048],
              [-85.50454667899993, 9.864528713000084],
              [-85.51097571499992, 9.865057684000078],
              [-85.5132136709999, 9.86664459800005],
              [-85.51451575399994, 9.869655666000085],
              [-85.51817786399994, 9.874172268000052],
              [-85.5251765619999, 9.877386786000045],
              [-85.53099524599992, 9.875881252000056],
              [-85.53482011599993, 9.872707424000055],
              [-85.53555253799993, 9.870754299000055],
              [-85.5920710929999, 9.888739325000074],
              [-85.61913001199991, 9.89288971600007],
              [-85.62551835799991, 9.89679596600007],
              [-85.63060462099992, 9.901556708000044],
              [-85.63857988199993, 9.905462958000044],
              [-85.64981035099993, 9.904974677000041],
              [-85.65721594999991, 9.900539455000057],
              [-85.66380774599992, 9.900091864000046],
              [-85.67271887899994, 9.911688544000071],
              [-85.6655574209999, 9.93032461100006],
              [-85.67613684799994, 9.955511786000045],
              [-85.77855383999992, 10.079901434000078],
              [-85.78465735599991, 10.09088776200008],
              [-85.79271399599992, 10.11782461100006],
              [-85.80504309799994, 10.136664130000042],
              [-85.8440242179999, 10.231024481000077],
              [-85.84756425699993, 10.259344794000071],
              [-85.8518367179999, 10.276556708000044],
              [-85.8576960929999, 10.289089260000083],
              [-85.84390214799993, 10.302435614000046],
              [-85.8381648429999, 10.31203847900008],
              [-85.84032141799992, 10.320135809000078],
              [-85.8616023429999, 10.346991278000075],
              [-85.87498938699991, 10.355047919000071],
              [-85.86758378799993, 10.364894924000055],
              [-85.85024980399993, 10.378485419000071],
              [-85.83853105399993, 10.395453192000048],
              [-85.8303523429999, 10.41201406500005],
              [-85.8132624989999, 10.405300197000088],
              [-85.8039851549999, 10.41592031500005],
              [-85.79674231699994, 10.431423244000086],
              [-85.77550208199995, 10.447292385000083],
              [-85.78372148299991, 10.465236721000053],
              [-85.79881751199991, 10.483954169000071],
              [-85.80923417899993, 10.494533596000053],
              [-85.80296790299991, 10.498806057000081],
              [-85.80028235599991, 10.500270901000079],
              [-85.79564368399991, 10.501369533000059],
              [-85.79564368399991, 10.508205471000053],
              [-85.80923417899993, 10.508205471000053],
              [-85.80923417899993, 10.515041408000059],
              [-85.79784094999991, 10.517157294000071],
              [-85.79051673099991, 10.524115302000041],
              [-85.78197180899991, 10.542995510000083],
              [-85.77513587099992, 10.542995510000083],
              [-85.76121985599991, 10.531805731000077],
              [-85.74160722599993, 10.539821682000081],
              [-85.72158769399994, 10.550930080000057],
              [-85.70628821499992, 10.54913971600007],
              [-85.70006262899994, 10.54913971600007],
              [-85.70140540299991, 10.562282619000086],
              [-85.69798743399991, 10.568630276000079],
              [-85.69229081899994, 10.572088934000078],
              [-85.68700110599991, 10.57648346600007],
              [-85.67784583199995, 10.59210846600007],
              [-85.67422441299993, 10.59125397300005],
              [-85.66185462099992, 10.590114651000079],
              [-85.63174394399994, 10.621161200000074],
              [-85.63402258999992, 10.629461981000077],
              [-85.63931230399993, 10.63580963700008],
              [-85.65225175699993, 10.644720770000049],
              [-85.69322669199994, 10.603786526000079],
              [-85.69420325399994, 10.607082424000055],
              [-85.69408118399991, 10.61001211100006],
              [-85.69517981699994, 10.61163971600007],
              [-85.70006262899994, 10.61123281500005],
              [-85.70006262899994, 10.617458401000079],
              [-85.68846594999991, 10.62995026200008],
              [-85.68138587099992, 10.635199286000045],
              [-85.67271887899994, 10.637884833000044],
              [-85.67955481699994, 10.644720770000049],
              [-85.6804499989999, 10.643825588000084],
              [-85.68179277299993, 10.641913153000075],
              [-85.6838679679999, 10.639797268000052],
              [-85.68700110599991, 10.637884833000044],
              [-85.68447831899994, 10.646185614000046],
              [-85.68399003799993, 10.64907461100006],
              [-85.67271887899994, 10.652167059000078],
              [-85.67271887899994, 10.658392645000049],
              [-85.67955481699994, 10.658392645000049],
              [-85.67955481699994, 10.665838934000078],
              [-85.6628718739999, 10.678981838000084],
              [-85.65957597599993, 10.712958075000074],
              [-85.66527258999992, 10.77883535400008],
              [-85.68028723899994, 10.79633209800005],
              [-85.71336829299992, 10.81085846600007],
              [-85.74649003799993, 10.816188869000086],
              [-85.7615046869999, 10.80609772300005],
              [-85.76748613199993, 10.80609772300005],
              [-85.79507402299993, 10.828640041000085],
              [-85.80308997299994, 10.837184963000084],
              [-85.79832923099991, 10.835638739000046],
              [-85.79238847599993, 10.838324286000045],
              [-85.78990637899994, 10.843898830000057],
              [-85.79564368399991, 10.850856838000084],
              [-85.80296790299991, 10.852484442000048],
              [-85.8222957019999, 10.850612697000088],
              [-85.8303523429999, 10.850856838000084],
              [-85.85977128799993, 10.861761786000045],
              [-85.88292395699995, 10.875148830000057],
              [-85.90880286399994, 10.886419989000046],
              [-85.94644120999993, 10.891140041000085],
              [-85.94644120999993, 10.898586330000057],
              [-85.92381751199991, 10.90420156500005],
              [-85.88149980399993, 10.923163153000075],
              [-85.8576960929999, 10.925930080000057],
              [-85.86148027299993, 10.932074286000045],
              [-85.86449133999992, 10.93585846600007],
              [-85.86913001199991, 10.93813711100006],
              [-85.87816321499992, 10.939601955000057],
              [-85.87816321499992, 10.94635651200008],
              [-85.82872473899994, 10.949286200000074],
              [-85.81615149599992, 10.94635651200008],
              [-85.81090247299994, 10.938666083000044],
              [-85.81216386599993, 10.929714260000083],
              [-85.81460527299993, 10.922267971000053],
              [-85.81265214799993, 10.919094143000052],
              [-85.80850175699993, 10.917181708000044],
              [-85.79564368399991, 10.905462958000044],
              [-85.78941809799994, 10.905462958000044],
              [-85.78197180899991, 10.912868557000081],
              [-85.78197180899991, 10.919094143000052],
              [-85.79336503799993, 10.930243231000077],
              [-85.78246008999992, 10.937445380000042],
              [-85.76113847599993, 10.940578518000052],
              [-85.7409968739999, 10.939601955000057],
              [-85.7341609369999, 10.936428127000056],
              [-85.72520911399994, 10.927679755000042],
              [-85.7170710929999, 10.925930080000057],
              [-85.71056067599994, 10.928290106000077],
              [-85.7077937489999, 10.934027411000045],
              [-85.70889238199993, 10.940822658000059],
              [-85.71373450399994, 10.94635651200008],
              [-85.71373450399994, 10.953802802000041],
              [-85.69888261599993, 10.959255276000079],
              [-85.69469153599994, 10.97024160400008],
              [-85.69815019399994, 10.983221747000073],
              [-85.70628821499992, 10.994818427000041],
              [-85.71353105399993, 11.000026760000083],
              [-85.73037675699993, 11.00690338700008],
              [-85.7375789049999, 11.011867580000057],
              [-85.74600175699993, 11.020656643000052],
              [-85.74600175699993, 11.023016669000071],
              [-85.74095618399991, 11.02407461100006],
              [-85.7341609369999, 11.028957424000055],
              [-85.71886145699995, 11.042914130000042],
              [-85.7099910149999, 11.038112697000088],
              [-85.69961503799993, 11.028631903000075],
              [-85.67955481699994, 11.028957424000055],
              [-85.6675105459999, 11.039862372000073],
              [-85.6701960929999, 11.054388739000046],
              [-85.68101966099994, 11.068386135000083],
              [-85.69322669199994, 11.077337958000044],
              [-85.70173556599988, 11.080880181000097],
              [-85.67758215399991, 11.11963246700006],
              [-85.65931453499985, 11.158829041000018],
              [-85.6311508799999, 11.196216939000067],
              [-85.59779374199994, 11.209937032000099],
              [-85.56916499899995, 11.195390117000045],
              [-85.54094966699998, 11.17032704600004],
              [-85.50862605899991, 11.15242116300007],
              [-85.4074177659999, 11.115446676000118],
              [-85.27236140999992, 11.066199036000043],
              [-85.23647823899992, 11.053096617000051],
              [-85.09283748399992, 11.000647482000119],
              [-84.93140030999987, 10.941891378000065],
              [-84.90840429699992, 10.939359233000076],
              [-84.88496903499995, 10.94767913800004],
              [-84.78177119999992, 11.01488433900009],
              [-84.70777054899992, 11.063046774000085],
              [-84.6764546309999, 11.070410665000082],
              [-84.65872961499988, 11.0627367150001],
              [-84.62066992199993, 11.035761617000077],
              [-84.60322912599989, 11.03328114900009],
              [-84.58168005399995, 11.034469706000024],
              [-84.55860652699997, 11.027209168000056],
              [-84.50873876999992, 11.005530904000054],
              [-84.50333858299987, 11.004032288000047],
              [-84.49817093999985, 11.001991069000098],
              [-84.49331335499994, 10.999407248000097],
              [-84.48912756399989, 10.99635833700006],
              [-84.46638993399992, 10.968453064000087],
              [-84.4578374839999, 10.961347555000145],
              [-84.44887162399996, 10.956334941000094],
              [-84.43820043999995, 10.952200826000066],
              [-84.42724503599987, 10.95111562100007],
              [-84.4177624109999, 10.955043030000041],
              [-84.36396724499988, 10.989614563000131],
              [-84.35546647199988, 10.994627177000098],
              [-84.3459838469999, 10.989898784000019],
              [-84.34365840699988, 10.982379863000062],
              [-84.34386511299994, 10.972277121000033],
              [-84.34179805599987, 10.959900615000066],
              [-84.33740555899988, 10.952665914000093],
              [-84.32409887699995, 10.936181132000115],
              [-84.3213083499999, 10.9291531370001],
              [-84.31074051999994, 10.919412130000055],
              [-84.26428340699991, 10.901816305000082],
              [-84.25366390099992, 10.89471079600014],
              [-84.24472387799989, 10.88491811100009],
              [-84.2256552739999, 10.875306295000073],
              [-84.2083695069999, 10.860966085000072],
              [-84.2046488039999, 10.836988220000066],
              [-84.21852392599988, 10.829831035000026],
              [-84.2226580409999, 10.827040507000063],
              [-84.2271022139999, 10.819314881000068],
              [-84.2252418629999, 10.81368214900003],
              [-84.22115942399998, 10.809418844000078],
              [-84.21888566099997, 10.80595652300012],
              [-84.19687150099989, 10.788515727000089],
              [-84.19160050499994, 10.781720276000044],
              [-84.18041255799992, 10.789755961000125],
              [-84.16483211299987, 10.789445903000043],
              [-84.15772972499994, 10.788424645000106],
              [-84.14901912499988, 10.787172140000038],
              [-84.13700435499993, 10.78916168200007],
              [-84.11842667699997, 10.771229960000099],
              [-84.10692867099993, 10.766914978000031],
              [-84.09543066399993, 10.775519104000068],
              [-84.08855769899986, 10.775519104000068],
              [-84.07643957499997, 10.763814393000075],
              [-84.05163488799994, 10.779549866000053],
              [-84.03455582699988, 10.775519104000068],
              [-84.02269608599997, 10.78722381700004],
              [-84.00923437599991, 10.789445903000043],
              [-83.99820145699991, 10.782056173000043],
              [-83.99362809299987, 10.765002950000095],
              [-83.93332169599998, 10.718054911000053],
              [-83.92657792199995, 10.714902649000095],
              [-83.91727616399993, 10.7134815470001],
              [-83.90748347999997, 10.715367737000108],
              [-83.89355668199997, 10.724927877000113],
              [-83.88686458399985, 10.72714996400012],
              [-83.85952775099992, 10.721775615000055],
              [-83.85580704799992, 10.723997701000059],
              [-83.83534318099996, 10.74761383100008],
              [-83.76896480299993, 10.77247019500004],
              [-83.76381811499996, 10.773683168000034],
              [-83.69814225299987, 10.78916168200007],
              [-83.66302811699984, 10.807015889000112],
              [-83.66013423699985, 10.834171855000093],
              [-83.66930680399994, 10.869751078000064],
              [-83.66985451049317, 10.891717678072528],
              [-83.6798318473562, 10.897010590307339],
              [-83.67685011450057, 10.910298763549688],
              [-83.67879970906, 10.916154380185779],
              [-83.68097632478583, 10.917119398852687],
              [-83.68875441084572, 10.93458680566807],
              [-83.69649978585412, 10.936594144736317],
            ],
          ],
          [
            [
              [-85.13133704299992, 10.09870026200008],
              [-85.12157141799992, 10.096380927000041],
              [-85.1160375639999, 10.09170156500005],
              [-85.10789954299992, 10.089544989000046],
              [-85.09732011599993, 10.08982982000009],
              [-85.09732011599993, 10.083644924000055],
              [-85.10948645699995, 10.079291083000044],
              [-85.12482662699995, 10.07562897300005],
              [-85.14183508999992, 10.074164130000042],
              [-85.15880286399994, 10.07615794500009],
              [-85.17613684799994, 10.083238023000092],
              [-85.18529212099992, 10.09243398600006],
              [-85.19912675699993, 10.117743231000077],
              [-85.18028723899994, 10.12400950700004],
              [-85.17186438699991, 10.124579169000071],
              [-85.1399633449999, 10.119208075000074],
              [-85.11046301999994, 10.110296942000048],
              [-85.11046301999994, 10.103461005000042],
              [-85.14513098899994, 10.103461005000042],
              [-85.13565019399994, 10.098456122000073],
              [-85.13133704299992, 10.09870026200008],
            ],
          ],
          [
            [
              [-87.09902910099993, 5.516017971000053],
              [-87.11766516799992, 5.51508209800005],
              [-87.10460364499994, 5.53742096600007],
              [-87.09251868399991, 5.546698309000078],
              [-87.07852128799993, 5.555080471000053],
              [-87.06460527299993, 5.557847398000092],
              [-87.06460527299993, 5.54759349200009],
              [-87.06554114499994, 5.53461334800005],
              [-87.07852128799993, 5.520656643000052],
              [-87.09902910099993, 5.516017971000053],
            ],
          ],
          [
            [
              [-83.89661759299992, 8.706491863000053],
              [-83.88346373899992, 8.71299268200005],
              [-83.86911404599994, 8.713587405000055],
              [-83.87030523899995, 8.701776235000068],
              [-83.87807640599993, 8.69882117900005],
              [-83.8906347969999, 8.701178567000056],
              [-83.89661759299992, 8.706491863000053],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Nicaragua',
        iso3: 'NIC',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-85.70173556599988, 11.080880181000097],
              [-85.7024226549999, 11.081203518000052],
              [-85.75230872299994, 11.101711330000057],
              [-85.77171790299991, 11.104681708000044],
              [-85.78579667899993, 11.112250067000048],
              [-85.79369055899991, 11.130031643000052],
              [-85.80308997299994, 11.166083075000074],
              [-85.8213191399999, 11.19281647300005],
              [-85.9280085929999, 11.310736395000049],
              [-85.9367976549999, 11.316961981000077],
              [-85.94151770699995, 11.319118557000081],
              [-85.9568171869999, 11.329779364000046],
              [-85.96011308499993, 11.334011135000083],
              [-85.99486243399991, 11.34365469000005],
              [-86.01036536399994, 11.357977606000077],
              [-86.04393469999991, 11.398098049000055],
              [-86.0705867179999, 11.411688544000071],
              [-86.10472571499992, 11.447292385000083],
              [-86.14830481699994, 11.47174713700008],
              [-86.16274980399993, 11.484523830000057],
              [-86.16665605399993, 11.492621161000045],
              [-86.17613684799994, 11.522406317000048],
              [-86.20714270699995, 11.536037502000056],
              [-86.24437415299991, 11.571600653000075],
              [-86.33645585799991, 11.611354885000083],
              [-86.35208085799991, 11.622626044000071],
              [-86.36538652299993, 11.637966213000084],
              [-86.37661699099993, 11.66946035400008],
              [-86.4963679679999, 11.759426174000055],
              [-86.51561438699991, 11.78310781500005],
              [-86.54238847599993, 11.842352606000077],
              [-86.55321204299992, 11.851345119000086],
              [-86.5632624989999, 11.856634833000044],
              [-86.5896296869999, 11.882839260000083],
              [-86.60521399599992, 11.904689846000053],
              [-86.62222245999993, 11.936102606000077],
              [-86.62547766799992, 11.950995184000078],
              [-86.63036048099991, 11.964911200000074],
              [-86.6418757799999, 11.976507880000042],
              [-86.66649329299992, 11.995306708000044],
              [-86.68980872299994, 12.02407461100006],
              [-86.7275691399999, 12.088283596000053],
              [-86.76268469999991, 12.18227773600006],
              [-86.77257239499994, 12.197414455000057],
              [-86.79751542899993, 12.218532619000086],
              [-87.0022273429999, 12.341376044000071],
              [-87.01504472599993, 12.356838283000059],
              [-87.07140051999994, 12.388698635000083],
              [-87.10195878799993, 12.42096588700008],
              [-87.17100989499994, 12.451442776000079],
              [-87.17357337099992, 12.47451406500005],
              [-87.16209876199991, 12.45962148600006],
              [-87.14248613199993, 12.446844794000071],
              [-87.11961829299992, 12.437689520000049],
              [-87.09780839799993, 12.433539130000042],
              [-87.12267005099994, 12.460353908000059],
              [-87.13548743399991, 12.470485744000086],
              [-87.14932206899994, 12.47451406500005],
              [-87.15786699099993, 12.481024481000077],
              [-87.18040930899991, 12.52297597900008],
              [-87.18663489499994, 12.52297597900008],
              [-87.17642167899993, 12.485907294000071],
              [-87.19273841099994, 12.49990469000005],
              [-87.21886145699995, 12.532253322000088],
              [-87.2380671869999, 12.55023834800005],
              [-87.25047766799992, 12.55532461100006],
              [-87.31297766799992, 12.602809963000084],
              [-87.32127844999991, 12.61123281500005],
              [-87.32579505099994, 12.621608791000085],
              [-87.33120683499993, 12.63898346600007],
              [-87.3340144519999, 12.633571682000081],
              [-87.34178626199991, 12.62409088700008],
              [-87.34483801999994, 12.619167385000083],
              [-87.4548640619999, 12.743801174000055],
              [-87.46776282499991, 12.769964911000045],
              [-87.46349036399994, 12.76516347900008],
              [-87.45933997299994, 12.762396552000041],
              [-87.4472957019999, 12.756293036000045],
              [-87.4472957019999, 12.762518622000073],
              [-87.45205644399994, 12.764186916000085],
              [-87.46092688699991, 12.769964911000045],
              [-87.46092688699991, 12.776190497000073],
              [-87.46349036399994, 12.786322333000044],
              [-87.4802546869999, 12.799994208000044],
              [-87.50291907499991, 12.81195709800005],
              [-87.5229792959999, 12.817165432000081],
              [-87.5229792959999, 12.810939846000053],
              [-87.49644934799994, 12.793850002000056],
              [-87.48253333199995, 12.781195380000042],
              [-87.48204505099994, 12.769964911000045],
              [-87.4922175769999, 12.77138906500005],
              [-87.50698808499993, 12.782416083000044],
              [-87.52920488199993, 12.803493557000081],
              [-87.6465144519999, 12.872381903000075],
              [-87.6709285149999, 12.893500067000048],
              [-87.68565833199995, 12.91828034100007],
              [-87.6858210929999, 12.94757721600007],
              [-87.6670222649999, 12.982245184000078],
              [-87.63882402299993, 13.00649648600006],
              [-87.60997473899994, 13.02407461100006],
              [-87.58877519399994, 13.04633209800005],
              [-87.58385169199994, 13.084662177000041],
              [-87.57762610599991, 13.084662177000041],
              [-87.58043372299994, 13.063177802000041],
              [-87.58385169199994, 13.057318427000041],
              [-87.57262122299994, 13.057318427000041],
              [-87.55907141799992, 13.055568752000056],
              [-87.5476374989999, 13.052150783000059],
              [-87.54283606699994, 13.047430731000077],
              [-87.5381160149999, 13.044501044000071],
              [-87.5127253899999, 13.023220119000086],
              [-87.50637773299991, 13.019680080000057],
              [-87.48827063699991, 12.995917059000078],
              [-87.48387610599991, 12.992621161000045],
              [-87.47105872299994, 12.985052802000041],
              [-87.46776282499991, 12.982245184000078],
              [-87.46690833199995, 12.975734768000052],
              [-87.46898352799991, 12.960638739000046],
              [-87.46776282499991, 12.954291083000044],
              [-87.43504798099991, 12.922390041000085],
              [-87.39248613199993, 12.913397528000075],
              [-87.28958085799991, 12.919582424000055],
              [-87.28958085799991, 12.927028713000084],
              [-87.34166419199994, 12.925726630000042],
              [-87.36778723899994, 12.928534247000073],
              [-87.37901770699995, 12.937567450000074],
              [-87.3689265619999, 12.953558661000045],
              [-87.3205867179999, 12.97719961100006],
              [-87.31403561099995, 12.98155345300006],
              [-87.08465389099993, 12.99592620900006],
              [-87.0698485929999, 12.994375915000134],
              [-87.04685257999995, 12.980552470000077],
              [-87.03504451599994, 12.979777324000068],
              [-87.02961848999988, 12.996081238000102],
              [-87.0087670499999, 13.00608062800012],
              [-86.98318721499996, 13.02186777700011],
              [-86.97181840099995, 13.03388254800008],
              [-86.9484089769999, 13.06969431600001],
              [-86.94272456899995, 13.074060975000094],
              [-86.92799678599994, 13.081243998000048],
              [-86.92293249499997, 13.08638580400013],
              [-86.92024532099995, 13.096178487000103],
              [-86.92417272999992, 13.099795838000077],
              [-86.92980546099994, 13.102224630000137],
              [-86.93233760599992, 13.108529155000056],
              [-86.9237076419999, 13.161135763000047],
              [-86.92551631799998, 13.163642070000037],
              [-86.93306107699993, 13.1797134400001],
              [-86.93492142799994, 13.185527038000075],
              [-86.93321610499987, 13.18818837500001],
              [-86.9259814049999, 13.216352031000056],
              [-86.91885005799986, 13.229762065000088],
              [-86.91078853399998, 13.239580587000063],
              [-86.86272945199991, 13.279939880000128],
              [-86.84950028499992, 13.288828227000053],
              [-86.83342891499987, 13.293349915000078],
              [-86.81622066299988, 13.291928813000084],
              [-86.75865311799993, 13.264178569000052],
              [-86.74929968299989, 13.26128468800006],
              [-86.73984289599994, 13.26371348100011],
              [-86.73271527199995, 13.268469503000077],
              [-86.72547684799991, 13.273299459000029],
              [-86.7117825929999, 13.285675965000081],
              [-86.7040311289999, 13.298827616000068],
              [-86.70186071799992, 13.314201355000137],
              [-86.70780350799993, 13.34283009900011],
              [-86.70992224199989, 13.34890207900007],
              [-86.71715694199986, 13.361640320000035],
              [-86.72361649699991, 13.367324727000067],
              [-86.73043778499988, 13.368900858000103],
              [-86.73638057499988, 13.371949768000121],
              [-86.74020463099993, 13.381923320000041],
              [-86.73865433799992, 13.39621185300011],
              [-86.72594193599986, 13.423832906000115],
              [-86.72428828999992, 13.439413351000056],
              [-86.75658605999988, 13.559380188000148],
              [-86.75710282399993, 13.576407573000083],
              [-86.75090165199992, 13.608421122000081],
              [-86.75157344599992, 13.624414978000033],
              [-86.75539750199997, 13.630874532000078],
              [-86.7641295649999, 13.637335555000078],
              [-86.76821325699984, 13.640357158000057],
              [-86.7721406659999, 13.645524801000064],
              [-86.77405269399992, 13.65459401500003],
              [-86.77116759299986, 13.707890404000082],
              [-86.77022863799988, 13.72523569800012],
              [-86.76790319899996, 13.739162496000105],
              [-86.76619787699988, 13.745260315000067],
              [-86.7614436449999, 13.749342753000064],
              [-86.74991979999987, 13.757120056000076],
              [-86.7272338469999, 13.768256327000103],
              [-86.7063048919999, 13.770013326000083],
              [-86.66268998299995, 13.764690654000049],
              [-86.58114457199991, 13.77985768700006],
              [-86.5416637779999, 13.78213145000008],
              [-86.50853918499988, 13.764380595000148],
              [-86.49081416899986, 13.759497172000124],
              [-86.47629309199993, 13.764018860000064],
              [-86.46285721899997, 13.770943502000137],
              [-86.44823278899989, 13.772958883000086],
              [-86.43247147699992, 13.757120056000076],
              [-86.42652868699992, 13.752985942000066],
              [-86.41707189999994, 13.750014547000148],
              [-86.41009558099992, 13.749032695000082],
              [-86.35847082599992, 13.75226247200007],
              [-86.34012569199993, 13.756654968000063],
              [-86.32519120299986, 13.76376047800008],
              [-86.31356400599992, 13.776602072000074],
              [-86.30777624499984, 13.79169158900008],
              [-86.29992142799989, 13.82132802300012],
              [-86.2841084399999, 13.845719299000052],
              [-86.21858272299991, 13.91437144000011],
              [-86.18406286699991, 13.966874695000072],
              [-86.17357255099998, 13.973670146000117],
              [-86.16179032499988, 13.978114319000028],
              [-86.14969803999989, 13.98426381500009],
              [-86.1380191659999, 13.996175232000041],
              [-86.13083614199988, 14.008913473000092],
              [-86.12690873199989, 14.018551127000109],
              [-86.12168941299987, 14.027206930000062],
              [-86.11047562699991, 14.037128805000066],
              [-86.0967296959999, 14.044079284000048],
              [-86.02019689999989, 14.055163879000062],
              [-86.02045528199997, 14.044079284000048],
              [-86.0312556559999, 14.022581889000023],
              [-86.02841345299993, 13.996071879000098],
              [-85.95777176899995, 13.94610076900004],
              [-85.93611934499995, 13.918195496000052],
              [-85.92940140799993, 13.91209767700009],
              [-85.91550044799996, 13.907446798000123],
              [-85.90630204299995, 13.909358826000044],
              [-85.89720699099988, 13.913027853000045],
              [-85.88356441299987, 13.913854675000067],
              [-85.8616019289999, 13.904423727000108],
              [-85.84987137899992, 13.887086283000087],
              [-85.84010453299996, 13.866570740000029],
              [-85.82416235399984, 13.84768300400009],
              [-85.80201900199992, 13.840215760000063],
              [-85.77866125499989, 13.84093923000006],
              [-85.75830074099994, 13.83928558400001],
              [-85.74499405999993, 13.824686991000135],
              [-85.74311460299992, 13.823958222000059],
              [-85.74246191399993, 13.823705139000069],
              [-85.7402931119999, 13.825639142000043],
              [-85.73339269999988, 13.831792501000066],
              [-85.72512447199992, 13.847941386000059],
              [-85.72300573799996, 13.86341847800007],
              [-85.72869014499989, 13.87501983700011],
              [-85.74367630999987, 13.879567363000149],
              [-85.74744868999989, 13.88827484200003],
              [-85.74328873799996, 13.907550151000052],
              [-85.73339269999988, 13.937625834000116],
              [-85.73220414299993, 13.959536641000085],
              [-85.72734655799994, 13.965014344000068],
              [-85.71698543399992, 13.962688904000046],
              [-85.69923457899989, 13.961500346000022],
              [-85.68649633799993, 13.9673397830001],
              [-85.66618750099991, 13.984470520000059],
              [-85.65766088899989, 13.981990052000086],
              [-85.65148555599993, 13.981990052000086],
              [-85.65195064399984, 13.986692607000066],
              [-85.65040035099992, 13.987855327000076],
              [-85.64766149999988, 13.98780365000006],
              [-85.64461258999995, 13.988785503000116],
              [-85.64786820499992, 13.999301657000089],
              [-85.6128057459999, 14.009740295000114],
              [-85.60306473799994, 14.01953298000008],
              [-85.59360795099988, 14.033459778000065],
              [-85.57169714399993, 14.04051361100008],
              [-85.56314591299991, 14.042012281000098],
              [-85.54663407499993, 14.044906108000077],
              [-85.52795304399987, 14.050900574000096],
              [-85.51862544799991, 14.064594828000025],
              [-85.51640336199992, 14.080537008000064],
              [-85.51064143899995, 14.093792013000055],
              [-85.47467464199988, 14.103403829000072],
              [-85.45762141999984, 14.113041483000089],
              [-85.4317315269999, 14.132833557000069],
              [-85.42015600599987, 14.146863708000083],
              [-85.40912308799997, 14.166164856000123],
              [-85.40088069699993, 14.18518178300009],
              [-85.39362015799995, 14.210761617000045],
              [-85.38400834199985, 14.226445414000096],
              [-85.37251033599992, 14.241095683000083],
              [-85.36287268099991, 14.250113221000035],
              [-85.35853186099993, 14.250888367000044],
              [-85.34780900099992, 14.249234721000093],
              [-85.34362320999986, 14.250113221000035],
              [-85.3408068439999, 14.253368836000021],
              [-85.33796463999994, 14.260681050000102],
              [-85.3308849689999, 14.26900095700006],
              [-85.3268283699999, 14.275744731000088],
              [-85.3213506669999, 14.28132578600011],
              [-85.31197139499997, 14.283651225000142],
              [-85.2882002369999, 14.295149231000067],
              [-85.2778132739999, 14.297319641000058],
              [-85.23996028699992, 14.297319641000058],
              [-85.21520727499987, 14.301582947000028],
              [-85.19019588299997, 14.309644470000109],
              [-85.16962866299988, 14.321762594000091],
              [-85.15802730299993, 14.338273214000083],
              [-85.15903499399991, 14.361062520000075],
              [-85.17187658799992, 14.381009623000097],
              [-85.18973079499995, 14.396848450000093],
              [-85.20582800299994, 14.407157899000097],
              [-85.1784911709999, 14.427647603000068],
              [-85.17735428899991, 14.433977966000086],
              [-85.17967972899993, 14.44924835200004],
              [-85.1784911709999, 14.455604553000072],
              [-85.15539180599993, 14.47947906500005],
              [-85.15182613199994, 14.485964457000108],
              [-85.1498107509999, 14.536504008000051],
              [-85.14546992999993, 14.564254252000083],
              [-85.13753759899987, 14.578491109000055],
              [-85.11932165599993, 14.573969422000033],
              [-85.1033536379999, 14.556864522000083],
              [-85.08637792999988, 14.544539693000033],
              [-85.06524226899984, 14.554254862000064],
              [-85.02963720699995, 14.5889555870001],
              [-85.02365718199988, 14.602540872000063],
              [-85.02222163999994, 14.605802104000077],
              [-85.04816320799989, 14.605776266000063],
              [-85.04222041899988, 14.61347605400006],
              [-85.02020625799989, 14.633733215000063],
              [-85.04852494399998, 14.653318583000086],
              [-85.05392513099986, 14.66305959100012],
              [-85.03821549499989, 14.667219544000062],
              [-85.0330478519999, 14.669570821],
              [-85.0297922369999, 14.675539449000027],
              [-85.02454707899997, 14.712539775000081],
              [-85.01565873299987, 14.728171896000035],
              [-85.00199031699995, 14.740677592000026],
              [-84.9999482899999, 14.742015988000105],
              [-84.98436865199994, 14.752227275000067],
              [-84.96646276899989, 14.764629618000129],
              [-84.92062577299993, 14.807701925000032],
              [-84.90421850699988, 14.81697784400005],
              [-84.84442887399993, 14.827545675000124],
              [-84.81809973199998, 14.828656718000033],
              [-84.79213232499993, 14.821060283000065],
              [-84.77016984099996, 14.805143942000129],
              [-84.75546789599986, 14.781476135000105],
              [-84.7585684819999, 14.778659770000047],
              [-84.76639746199993, 14.768867086000085],
              [-84.7669400639999, 14.766903381000049],
              [-84.74704463799989, 14.764474590000091],
              [-84.74427994799993, 14.752408142000107],
              [-84.7452876379999, 14.73910146100009],
              [-84.72484960999995, 14.725639750000127],
              [-84.71441097099992, 14.708922424000093],
              [-84.69932145199991, 14.674686788000088],
              [-84.6808471279999, 14.68546132500012],
              [-84.66170100999989, 14.683445943000066],
              [-84.62296952399996, 14.667219544000062],
              [-84.60043859899994, 14.662516989000082],
              [-84.5274197999999, 14.6603982540001],
              [-84.53121801799992, 14.653318583000086],
              [-84.53421525099995, 14.633733215000063],
              [-84.51904821799994, 14.638280742000092],
              [-84.50848038799987, 14.632622172000069],
              [-84.4980159099999, 14.623914693000089],
              [-84.48269384799994, 14.619470520000093],
              [-84.47160925299994, 14.622622783000054],
              [-84.4457193609999, 14.636678772000067],
              [-84.40843481499988, 14.649417013000033],
              [-84.39001216699995, 14.671482849000114],
              [-84.3761370449999, 14.696726787000074],
              [-84.3629337159999, 14.715614523000113],
              [-84.35319270899996, 14.705976868000093],
              [-84.34603552299993, 14.679983622000037],
              [-84.33838741099993, 14.674686788000088],
              [-84.32316870199992, 14.673317363000109],
              [-84.2988807779999, 14.667994690000072],
              [-84.28779618399989, 14.667219544000062],
              [-84.26728063999991, 14.67773569800002],
              [-84.26216467299992, 14.699749858000104],
              [-84.26733231699984, 14.746672058000058],
              [-84.26180293899992, 14.758531799000068],
              [-84.24921972699991, 14.759410298000105],
              [-84.23539628099985, 14.754733582000128],
              [-84.2263787439999, 14.749772644000089],
              [-84.2186789559999, 14.743442282000075],
              [-84.1950111489999, 14.718715108000055],
              [-84.18289302699989, 14.713857523000044],
              [-84.16819108199991, 14.714968567000128],
              [-84.14379980499987, 14.721867371000101],
              [-84.13788285399997, 14.725226339000116],
              [-84.13385209199987, 14.73003224700004],
              [-84.12873612499988, 14.734192200000066],
              [-84.11961523499991, 14.736104228000073],
              [-84.11121781499992, 14.734708964000092],
              [-84.10651525899993, 14.732331848000058],
              [-84.10227779199988, 14.731866760000031],
              [-84.09543066399993, 14.736104228000073],
              [-84.09543066399993, 14.743597310000027],
              [-84.1041898199999, 14.751865540000068],
              [-84.1111144619999, 14.761038106000058],
              [-84.12271582099993, 14.784525045000038],
              [-84.11176041699986, 14.793413392000048],
              [-84.10444820199987, 14.793930156000087],
              [-84.08155554199996, 14.779796651000055],
              [-84.07897172099987, 14.77517161100009],
              [-84.07519934099992, 14.771631775000031],
              [-84.06468318699987, 14.770262349000063],
              [-84.04781083299989, 14.770804952000105],
              [-84.0426690269999, 14.76806610100006],
              [-84.04075699899997, 14.76034047400006],
              [-84.02357458499989, 14.758325094000028],
              [-83.92471756999993, 14.763441061],
              [-83.92985937599994, 14.771657613000045],
              [-83.92965266999988, 14.780881857000054],
              [-83.92471756999993, 14.803774516000061],
              [-83.91265112299996, 14.797185771000073],
              [-83.89655391499988, 14.780442606000122],
              [-83.88376399799992, 14.77710947700011],
              [-83.88500423199986, 14.781346944000077],
              [-83.88993933099991, 14.790726216000024],
              [-83.88267879199992, 14.78783233700004],
              [-83.87875138399994, 14.786747132000045],
              [-83.87526322499991, 14.784266663000068],
              [-83.86947546399992, 14.77710947700011],
              [-83.85730566499993, 14.787780661000028],
              [-83.83950313299988, 14.797418315000044],
              [-83.81965938399989, 14.80361948600003],
              [-83.80121089699989, 14.803774516000061],
              [-83.8089881999999, 14.808890483000056],
              [-83.81392329999994, 14.81377390600008],
              [-83.82105464699987, 14.825478618000062],
              [-83.76529577699992, 14.82878590900006],
              [-83.74452185199988, 14.836666565000101],
              [-83.74656306999992, 14.852195333000026],
              [-83.73392818199991, 14.852970480000039],
              [-83.7236187339999, 14.851575216000057],
              [-83.7162031659999, 14.847053528000032],
              [-83.71243078599986, 14.83852691700011],
              [-83.70501521899985, 14.83852691700011],
              [-83.71449784399994, 14.86723317500011],
              [-83.71062211099988, 14.878343607000119],
              [-83.6919669189999, 14.886973572000073],
              [-83.6721490079999, 14.88963490800009],
              [-83.64995397999988, 14.888498027000082],
              [-83.63155716999998, 14.883201192000044],
              [-83.62305639699989, 14.872685038000085],
              [-83.61561499099986, 14.872685038000085],
              [-83.61130000899988, 14.884906514000107],
              [-83.60918127499991, 14.89836822500007],
              [-83.60427201399997, 14.90919443700011],
              [-83.57977738499991, 14.918108623000123],
              [-83.55486934399994, 14.937409770000073],
              [-83.54047745899993, 14.941569723000015],
              [-83.54244116199988, 14.945083720000056],
              [-83.54512833699991, 14.952163391000084],
              [-83.54735042399992, 14.955212301000103],
              [-83.53249344899987, 14.951026509000073],
              [-83.52686071799994, 14.94836517400006],
              [-83.52990962799987, 14.961775207000088],
              [-83.52861771699992, 14.973402405000058],
              [-83.5230366619999, 14.977691548000024],
              [-83.51321813999994, 14.96885487900002],
              [-83.51262386099998, 14.984021911000042],
              [-83.51099605299993, 14.99017140700002],
              [-83.50572505699989, 14.996811829000109],
              [-83.51246883199994, 15.006501160000141],
              [-83.50908402499991, 15.011539612000107],
              [-83.49900712099989, 15.012650655000115],
              [-83.48585546899992, 15.01048024500004],
              [-83.48055863499988, 15.005545146000088],
              [-83.46838883499996, 14.987406719000063],
              [-83.45919042999995, 14.982497457000122],
              [-83.43572932999987, 14.985184631000052],
              [-83.41547216799998, 14.996941020000051],
              [-83.39989172399993, 15.013632508000086],
              [-83.39030574599994, 15.030969950000099],
              [-83.37782588699994, 15.021254781000053],
              [-83.36498429399987, 15.016345521000119],
              [-83.35454565399993, 15.010066834000028],
              [-83.34935217299991, 14.996811829000109],
              [-83.33423681699992, 15.00644948300004],
              [-83.31705440299993, 15.007560526000134],
              [-83.27297440599995, 15.003038839000098],
              [-83.2848858239999, 14.997380269000075],
              [-83.28566097099991, 14.992109274000128],
              [-83.27832291699991, 14.987122498000076],
              [-83.2661531169999, 14.982497457000122],
              [-83.26201900299989, 14.98319508900002],
              [-83.21773230099987, 14.982497457000122],
              [-83.19132564299989, 14.994253845000117],
              [-83.1773988439999, 14.996811829000109],
              [-83.14365413499993, 14.994899801000088],
              [-83.13044447244795, 14.997012021272383],
              [-83.13776607999995, 14.986721096000053],
              [-83.15607662699995, 14.978461005000042],
              [-83.16515051999994, 14.96906159100007],
              [-83.17983964799993, 14.985988674000055],
              [-83.19188391799992, 14.974269924000055],
              [-83.20148678299995, 14.953070380000042],
              [-83.20889238199993, 14.94171784100007],
              [-83.22166907499991, 14.935695705000057],
              [-83.23387610599991, 14.92133209800005],
              [-83.24290930899991, 14.904364325000074],
              [-83.24644934799994, 14.890570380000042],
              [-83.24909420499995, 14.885891018000052],
              [-83.26183020699995, 14.87376536700009],
              [-83.26695716099994, 14.86664459800005],
              [-83.26952063699991, 14.856919664000088],
              [-83.27135169199994, 14.835516669000071],
              [-83.27379309799994, 14.825669664000088],
              [-83.28197180899991, 14.813177802000041],
              [-83.29401607999995, 14.804266669000071],
              [-83.32843990799995, 14.790961005000042],
              [-83.32599850199995, 14.796942450000074],
              [-83.32323157499991, 14.801703192000048],
              [-83.31476803299995, 14.811428127000056],
              [-83.31476803299995, 14.803941148000092],
              [-83.31139075399994, 14.809515692000048],
              [-83.30943762899994, 14.814113674000055],
              [-83.30858313699991, 14.819037177000041],
              [-83.30850175699993, 14.825669664000088],
              [-83.31627356699994, 14.82103099200009],
              [-83.31948808499993, 14.820257880000042],
              [-83.32843990799995, 14.825669664000088],
              [-83.32843990799995, 14.831854559000078],
              [-83.3164770169999, 14.83734772300005],
              [-83.30508378799993, 14.838771877000056],
              [-83.29507402299993, 14.835191148000092],
              [-83.28742428299995, 14.825669664000088],
              [-83.28819739499994, 14.844549872000073],
              [-83.29893958199995, 14.870428778000075],
              [-83.30166581899994, 14.890570380000042],
              [-83.30785071499992, 14.910589911000045],
              [-83.32217363199993, 14.913885809000078],
              [-83.33836829299992, 14.908026434000078],
              [-83.35016842399995, 14.900824286000045],
              [-83.36986243399991, 14.883002020000049],
              [-83.4141332669999, 14.827704169000071],
              [-83.4246313139999, 14.803941148000092],
              [-83.4148656889999, 14.81391022300005],
              [-83.41152910099993, 14.81826406500005],
              [-83.39781653599994, 14.80760325700004],
              [-83.38695227799991, 14.766546942000048],
              [-83.38023841099994, 14.757391669000071],
              [-83.36705481699994, 14.749701239000046],
              [-83.35265051999994, 14.73623281500005],
              [-83.33751380099994, 14.73143138200004],
              [-83.32217363199993, 14.749945380000042],
              [-83.32945716099994, 14.75608958500004],
              [-83.34788977799991, 14.767075914000088],
              [-83.35631262899994, 14.770453192000048],
              [-83.3450414699999, 14.776556708000044],
              [-83.33348548099991, 14.773260809000078],
              [-83.32298743399991, 14.763413804000038],
              [-83.31476803299995, 14.749945380000042],
              [-83.31541907499991, 14.772772528000075],
              [-83.30817623599995, 14.779852606000077],
              [-83.29922441299993, 14.771185614000046],
              [-83.26012122299994, 14.59601471600007],
              [-83.25796464799993, 14.590399481000077],
              [-83.24860592399995, 14.57172272300005],
              [-83.2403051419999, 14.523993231000077],
              [-83.19180253799993, 14.386908270000049],
              [-83.18659420499995, 14.34764232000009],
              [-83.19139563699991, 14.313421942000048],
              [-83.21857662699995, 14.25031159100007],
              [-83.30166581899994, 14.119940497000073],
              [-83.33751380099994, 14.077541408000059],
              [-83.34264075399994, 14.060980536000045],
              [-83.3496801419999, 14.048773505000042],
              [-83.3972875639999, 14.016302802000041],
              [-83.41738847599993, 13.98859284100007],
              [-83.43126380099994, 13.956732489000046],
              [-83.45531165299991, 13.86391836100006],
              [-83.49380449099993, 13.73773834800005],
              [-83.51748613199993, 13.62368398600006],
              [-83.51602128799993, 13.574652411000045],
              [-83.52017167899993, 13.55076732000009],
              [-83.52037512899994, 13.531642971000053],
              [-83.54133053299995, 13.48187897300005],
              [-83.55915279899995, 13.415838934000078],
              [-83.57013912699995, 13.28709544500009],
              [-83.56822669199994, 13.263006903000075],
              [-83.56114661399994, 13.249172268000052],
              [-83.56859290299991, 13.24290599200009],
              [-83.56297766799992, 13.230658270000049],
              [-83.5295710929999, 13.032619533000059],
              [-83.50767981699994, 12.902777411000045],
              [-83.54133053299995, 12.63898346600007],
              [-83.54133053299995, 12.580633856000077],
              [-83.53799394399994, 12.57103099200009],
              [-83.5235082669999, 12.542303778000075],
              [-83.51382402299993, 12.51048411700009],
              [-83.48591061099995, 12.472154039000088],
              [-83.47923743399991, 12.447211005000042],
              [-83.48180091099994, 12.41665273600006],
              [-83.49229895699995, 12.400336005000042],
              [-83.51256262899994, 12.393784898000092],
              [-83.54474850199995, 12.39256419500009],
              [-83.56924394399994, 12.387640692000048],
              [-83.59422766799992, 12.37881094000005],
              [-83.61758378799993, 12.375148830000057],
              [-83.6375219389999, 12.38572825700004],
              [-83.62999426999994, 12.39288971600007],
              [-83.60936438699991, 12.40721263200004],
              [-83.60338294199994, 12.413723049000055],
              [-83.60252844999991, 12.425441799000055],
              [-83.60631262899994, 12.441148179000038],
              [-83.61270097599993, 12.454901434000078],
              [-83.63463294199994, 12.474107164000088],
              [-83.6328832669999, 12.539536851000037],
              [-83.6375219389999, 12.564520575000074],
              [-83.63385982999995, 12.566473700000074],
              [-83.63267981699994, 12.566595770000049],
              [-83.63206946499992, 12.56712474200009],
              [-83.63003495999993, 12.570746161000045],
              [-83.6238500639999, 12.570746161000045],
              [-83.58844967399995, 12.55963776200008],
              [-83.5637914699999, 12.59088776200008],
              [-83.55540930899991, 12.635891018000052],
              [-83.56859290299991, 12.66632721600007],
              [-83.56859290299991, 12.673773505000042],
              [-83.55996660099993, 12.683254299000055],
              [-83.55654863199993, 12.69672272300005],
              [-83.55492102799991, 12.75259023600006],
              [-83.55313066299993, 12.754706122000073],
              [-83.54906165299991, 12.75804271000004],
              [-83.54442298099991, 12.763088283000059],
              [-83.54133053299995, 12.769964911000045],
              [-83.54466712099992, 12.79677969000005],
              [-83.56403561099995, 12.812689520000049],
              [-83.59080969999991, 12.81907786700009],
              [-83.61636308499993, 12.81712474200009],
              [-83.63703365799995, 12.80532461100006],
              [-83.64590410099993, 12.786851304000038],
              [-83.6453344389999, 12.766506252000056],
              [-83.6375219389999, 12.748846747000073],
              [-83.61554928299995, 12.73729075700004],
              [-83.61327063699991, 12.735256252000056],
              [-83.61339270699995, 12.73187897300005],
              [-83.61168372299994, 12.714911200000074],
              [-83.61021887899994, 12.707912502000056],
              [-83.60594641799992, 12.70107656500005],
              [-83.60130774599992, 12.69822825700004],
              [-83.59748287699995, 12.69432200700004],
              [-83.59593665299991, 12.684027411000045],
              [-83.59642493399991, 12.667141018000052],
              [-83.59862219999991, 12.660223700000074],
              [-83.60338294199994, 12.65265534100007],
              [-83.59943600199995, 12.647935289000088],
              [-83.58910071499992, 12.632147528000075],
              [-83.62047278599994, 12.61424388200004],
              [-83.67369544199994, 12.570461330000057],
              [-83.70579993399991, 12.557074286000045],
              [-83.74901282499991, 12.552557684000078],
              [-83.76720130099994, 12.546698309000078],
              [-83.77464758999992, 12.53351471600007],
              [-83.77464758999992, 12.48143138200004],
              [-83.77342688699991, 12.480292059000078],
              [-83.76943925699993, 12.482489325000074],
              [-83.7610570949999, 12.482001044000071],
              [-83.74901282499991, 12.47947825700004],
              [-83.74095618399991, 12.479722398000092],
              [-83.73424231699994, 12.477687893000052],
              [-83.72622636599993, 12.468329169000071],
              [-83.71939042899993, 12.423651434000078],
              [-83.72337805899991, 12.402289130000042],
              [-83.73037675699993, 12.382066148000092],
              [-83.7337133449999, 12.362982489000046],
              [-83.72622636599993, 12.34479401200008],
              [-83.70767167899993, 12.335882880000042],
              [-83.67634029899995, 12.342474677000041],
              [-83.67100989499994, 12.327093817000048],
              [-83.67218990799995, 12.317084052000041],
              [-83.67731686099995, 12.29751211100006],
              [-83.67845618399991, 12.28611888200004],
              [-83.67638098899994, 12.279852606000077],
              [-83.67174231699994, 12.28896719000005],
              [-83.65587317599994, 12.340277411000045],
              [-83.64976966099994, 12.353176174000055],
              [-83.64093990799995, 12.35846588700008],
              [-83.62120520699995, 12.355658270000049],
              [-83.61701412699995, 12.348049221000053],
              [-83.66372636599993, 12.25608958500004],
              [-83.68590247299994, 12.13743724200009],
              [-83.67857825399994, 12.009426174000055],
              [-83.67100989499994, 11.987941799000055],
              [-83.67784583199995, 11.983872789000088],
              [-83.68529212099992, 11.98110586100006],
              [-83.68122311099995, 12.001654364000046],
              [-83.6883031889999, 12.018744208000044],
              [-83.71324622299994, 12.049302476000037],
              [-83.72374426999994, 12.074652411000045],
              [-83.71524003799993, 12.08539459800005],
              [-83.70067298099991, 12.095200914000088],
              [-83.69273841099994, 12.11823151200008],
              [-83.69786536399994, 12.135199286000045],
              [-83.7110082669999, 12.154730536000045],
              [-83.72862708199995, 12.171576239000046],
              [-83.7473852199999, 12.18032461100006],
              [-83.77774003799993, 12.177150783000059],
              [-83.77627519399994, 12.162298895000049],
              [-83.76032467399995, 12.15306224200009],
              [-83.7473852199999, 12.16665273600006],
              [-83.73989824099993, 12.16665273600006],
              [-83.72305253799993, 12.149359442000048],
              [-83.7161352199999, 12.13890208500004],
              [-83.71324622299994, 12.125677802000041],
              [-83.71690833199995, 12.108791408000059],
              [-83.73204505099994, 12.087062893000052],
              [-83.7337133449999, 12.07103099200009],
              [-83.73936926999994, 12.051947333000044],
              [-83.75731360599991, 12.051336981000077],
              [-83.79857337099992, 12.063625393000052],
              [-83.80394446499992, 12.060288804000038],
              [-83.79173743399991, 12.05296458500004],
              [-83.76720130099994, 12.043158270000049],
              [-83.76130123599995, 12.035345770000049],
              [-83.75723222599993, 12.024644273000092],
              [-83.75495357999995, 12.012274481000077],
              [-83.75422115799995, 11.99909088700008],
              [-83.75625566299993, 11.990057684000078],
              [-83.76520748599995, 11.971625067000048],
              [-83.76720130099994, 11.96430084800005],
              [-83.76553300699993, 11.958807684000078],
              [-83.76211503799993, 11.953070380000042],
              [-83.7598363919999, 11.946844794000071],
              [-83.7610570949999, 11.940130927000041],
              [-83.76626542899993, 11.933986721000053],
              [-83.77188066299993, 11.931057033000059],
              [-83.77708899599992, 11.929266669000071],
              [-83.78087317599994, 11.926459052000041],
              [-83.79938717399995, 11.902899481000077],
              [-83.80508378799993, 11.899115302000041],
              [-83.81371008999992, 11.896185614000046],
              [-83.82347571499992, 11.88898346600007],
              [-83.83185787699995, 11.87986888200004],
              [-83.83608964799993, 11.871242580000057],
              [-83.82298743399991, 11.862534898000092],
              [-83.80695553299995, 11.848211981000077],
              [-83.79336503799993, 11.83274974200009],
              [-83.78477942599994, 11.81354401200008],
              [-83.77749589799993, 11.808294989000046],
              [-83.76773027299993, 11.804836330000057],
              [-83.75763912699995, 11.803615627000056],
              [-83.74290930899991, 11.805243231000077],
              [-83.74181067599994, 11.809759833000044],
              [-83.74596106699994, 11.81631094000005],
              [-83.7473852199999, 11.824042059000078],
              [-83.74058997299994, 11.843451239000046],
              [-83.73509680899991, 11.853664455000057],
              [-83.72622636599993, 11.857570705000057],
              [-83.70954342399995, 11.85814036700009],
              [-83.69994055899991, 11.84992096600007],
              [-83.6536352199999, 11.667466539000088],
              [-83.6511938139999, 11.63226959800005],
              [-83.65172278599994, 11.61937083500004],
              [-83.65298417899993, 11.611517645000049],
              [-83.65680904899995, 11.605414130000042],
              [-83.66478430899991, 11.598089911000045],
              [-83.66673743399991, 11.600978908000059],
              [-83.68089758999992, 11.598130601000037],
              [-83.69473222599993, 11.59365469000005],
              [-83.69587154899995, 11.59125397300005],
              [-83.70376542899993, 11.587958075000074],
              [-83.71373450399994, 11.573472398000092],
              [-83.72280839799993, 11.57021719000005],
              [-83.73493404899995, 11.569973049000055],
              [-83.74469967399995, 11.568508205000057],
              [-83.75304114499994, 11.564601955000057],
              [-83.7610570949999, 11.557114976000037],
              [-83.77122962099992, 11.52610911700009],
              [-83.78091386599993, 11.479315497000073],
              [-83.79442298099991, 11.44399648600006],
              [-83.81566321499992, 11.44725169500009],
              [-83.82188880099994, 11.44725169500009],
              [-83.85362708199995, 11.407416083000044],
              [-83.86278235599991, 11.39203522300005],
              [-83.86803137899994, 11.37490469000005],
              [-83.86790930899991, 11.27366771000004],
              [-83.83726966099994, 11.142523505000042],
              [-83.81566321499992, 11.090399481000077],
              [-83.78563391799992, 11.04482656500005],
              [-83.77594967399995, 11.01984284100007],
              [-83.75206458199995, 10.982245184000078],
              [-83.74364173099991, 10.974310614000046],
              [-83.72545325399994, 10.96320221600007],
              [-83.71825110599991, 10.94399648600006],
              [-83.71031653599994, 10.922674872000073],
              [-83.69273841099994, 10.925930080000057],
              [-83.69652258999992, 10.93659088700008],
              [-83.69649978585412, 10.936594144736317],
              [-83.68875441084572, 10.93458680566807],
              [-83.68097632478583, 10.917119398852687],
              [-83.67879970906, 10.916154380185779],
              [-83.67685011450057, 10.910298763549688],
              [-83.6798318473562, 10.897010590307339],
              [-83.66985451049317, 10.891717678072528],
              [-83.66930680399994, 10.869751078000064],
              [-83.66013423699985, 10.834171855000093],
              [-83.66302811699984, 10.807015889000112],
              [-83.69814225299987, 10.78916168200007],
              [-83.76381811499996, 10.773683168000034],
              [-83.76896480299993, 10.77247019500004],
              [-83.83534318099996, 10.74761383100008],
              [-83.85580704799992, 10.723997701000059],
              [-83.85952775099992, 10.721775615000055],
              [-83.88686458399985, 10.72714996400012],
              [-83.89355668199997, 10.724927877000113],
              [-83.90748347999997, 10.715367737000108],
              [-83.91727616399993, 10.7134815470001],
              [-83.92657792199995, 10.714902649000095],
              [-83.93332169599998, 10.718054911000053],
              [-83.99362809299987, 10.765002950000095],
              [-83.99820145699991, 10.782056173000043],
              [-84.00923437599991, 10.789445903000043],
              [-84.02269608599997, 10.78722381700004],
              [-84.03455582699988, 10.775519104000068],
              [-84.05163488799994, 10.779549866000053],
              [-84.07643957499997, 10.763814393000075],
              [-84.08855769899986, 10.775519104000068],
              [-84.09543066399993, 10.775519104000068],
              [-84.10692867099993, 10.766914978000031],
              [-84.11842667699997, 10.771229960000099],
              [-84.13700435499993, 10.78916168200007],
              [-84.14901912499988, 10.787172140000038],
              [-84.15772972499994, 10.788424645000106],
              [-84.16483211299987, 10.789445903000043],
              [-84.18041255799992, 10.789755961000125],
              [-84.19160050499994, 10.781720276000044],
              [-84.19687150099989, 10.788515727000089],
              [-84.21888566099997, 10.80595652300012],
              [-84.22115942399998, 10.809418844000078],
              [-84.2252418629999, 10.81368214900003],
              [-84.2271022139999, 10.819314881000068],
              [-84.2226580409999, 10.827040507000063],
              [-84.21852392599988, 10.829831035000026],
              [-84.2046488039999, 10.836988220000066],
              [-84.2083695069999, 10.860966085000072],
              [-84.2256552739999, 10.875306295000073],
              [-84.24472387799989, 10.88491811100009],
              [-84.25366390099992, 10.89471079600014],
              [-84.26428340699991, 10.901816305000082],
              [-84.31074051999994, 10.919412130000055],
              [-84.3213083499999, 10.9291531370001],
              [-84.32409887699995, 10.936181132000115],
              [-84.33740555899988, 10.952665914000093],
              [-84.34179805599987, 10.959900615000066],
              [-84.34386511299994, 10.972277121000033],
              [-84.34365840699988, 10.982379863000062],
              [-84.3459838469999, 10.989898784000019],
              [-84.35546647199988, 10.994627177000098],
              [-84.36396724499988, 10.989614563000131],
              [-84.4177624109999, 10.955043030000041],
              [-84.42724503599987, 10.95111562100007],
              [-84.43820043999995, 10.952200826000066],
              [-84.44887162399996, 10.956334941000094],
              [-84.4578374839999, 10.961347555000145],
              [-84.46638993399992, 10.968453064000087],
              [-84.48912756399989, 10.99635833700006],
              [-84.49331335499994, 10.999407248000097],
              [-84.49817093999985, 11.001991069000098],
              [-84.50333858299987, 11.004032288000047],
              [-84.50873876999992, 11.005530904000054],
              [-84.55860652699997, 11.027209168000056],
              [-84.58168005399995, 11.034469706000024],
              [-84.60322912599989, 11.03328114900009],
              [-84.62066992199993, 11.035761617000077],
              [-84.65872961499988, 11.0627367150001],
              [-84.6764546309999, 11.070410665000082],
              [-84.70777054899992, 11.063046774000085],
              [-84.78177119999992, 11.01488433900009],
              [-84.88496903499995, 10.94767913800004],
              [-84.90840429699992, 10.939359233000076],
              [-84.93140030999987, 10.941891378000065],
              [-85.09283748399992, 11.000647482000119],
              [-85.23647823899992, 11.053096617000051],
              [-85.27236140999992, 11.066199036000043],
              [-85.4074177659999, 11.115446676000118],
              [-85.50862605899991, 11.15242116300007],
              [-85.54094966699998, 11.17032704600004],
              [-85.56916499899995, 11.195390117000045],
              [-85.59779374199994, 11.209937032000099],
              [-85.6311508799999, 11.196216939000067],
              [-85.65931453499985, 11.158829041000018],
              [-85.67758215399991, 11.11963246700006],
              [-85.70173556599988, 11.080880181000097],
            ],
          ],
          [
            [
              [-83.66535239648923, 10.935318186754772],
              [-83.66619549717815, 10.931223787193453],
              [-83.67127580892124, 10.926494741135784],
              [-83.67556438376928, 10.92597648493106],
              [-83.67556438376928, 10.929409915424063],
              [-83.67299123886046, 10.931288568122966],
              [-83.67299123886046, 10.933231989430151],
              [-83.67833546290187, 10.935952757867287],
              [-83.68176632278032, 10.935434518184676],
              [-83.68686707685461, 10.937970246495594],
              [-83.68199622299994, 10.938666083000044],
              [-83.66535239648923, 10.935318186754772],
            ],
          ],
          [
            [
              [-83.72622636599993, 11.878648179000038],
              [-83.73379472599993, 11.905829169000071],
              [-83.73607337099992, 11.941799221000053],
              [-83.72899329299992, 11.973334052000041],
              [-83.70840410099993, 11.98729075700004],
              [-83.70685787699995, 11.98704661700009],
              [-83.70567786399994, 11.98623281500005],
              [-83.70531165299991, 11.984320380000042],
              [-83.70579993399991, 11.98110586100006],
              [-83.71239173099991, 11.970851955000057],
              [-83.71930904899995, 11.95453522300005],
              [-83.72451738199993, 11.936346747000073],
              [-83.72622636599993, 11.92023346600007],
              [-83.72036699099993, 11.883693752000056],
              [-83.71983801999994, 11.870306708000044],
              [-83.72622636599993, 11.878648179000038],
            ],
          ],
          [
            [
              [-83.05394446499992, 12.143866278000075],
              [-83.0559789699999, 12.166205145000049],
              [-83.04645748599995, 12.183742580000057],
              [-83.0325414699999, 12.190822658000059],
              [-83.02114824099993, 12.181789455000057],
              [-83.02505449099993, 12.175197658000059],
              [-83.05394446499992, 12.143866278000075],
            ],
          ],
          [
            [
              [-82.76732337099992, 14.414129950000074],
              [-82.75104732999995, 14.422023830000057],
              [-82.73778235599991, 14.421942450000074],
              [-82.72899329299992, 14.413763739000046],
              [-82.72569739499994, 14.397406317000048],
              [-82.73253333199995, 14.369574286000045],
              [-82.75084387899994, 14.361476955000057],
              [-82.80394446499992, 14.36595286700009],
              [-82.80825761599993, 14.366359768000052],
              [-82.80435136599993, 14.366359768000052],
              [-82.80370032499991, 14.36631907800006],
              [-82.80162512899994, 14.366848049000055],
              [-82.80044511599993, 14.369289455000057],
              [-82.8008520169999, 14.373236395000049],
              [-82.78477942599994, 14.381984768000052],
              [-82.77822831899994, 14.39321523600006],
              [-82.77464758999992, 14.404689846000053],
              [-82.76732337099992, 14.414129950000074],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'St-Martin',
        iso3: 'MAF',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-63.01756858528839, 18.033391472351283],
            [-63.0858861909999, 18.0585112510001],
            [-63.10700436099995, 18.062119859000063],
            [-63.10700436099995, 18.066961981000077],
            [-63.115305141999954, 18.065375067000048],
            [-63.130523240999935, 18.060248114000046],
            [-63.13434811099995, 18.059475002000056],
            [-63.1438695949999, 18.06468333500004],
            [-63.14683997299994, 18.07029857000009],
            [-63.14362545499995, 18.074164130000042],
            [-63.11375891799992, 18.074652411000045],
            [-63.09609941299993, 18.07880280200004],
            [-63.08381100199995, 18.087958075000074],
            [-63.07909094999991, 18.10419342700004],
            [-63.070871548999946, 18.11001211100006],
            [-63.05211341099994, 18.116848049000055],
            [-63.03140214799993, 18.121893622000073],
            [-63.017648891999954, 18.12213776200008],
            [-63.01793372299994, 18.100531317000048],
            [-63.01109778599994, 18.070746161000045],
            [-63.01073157499991, 18.040838934000078],
            [-63.01756858528839, 18.033391472351283],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Sint Maarten',
        iso3: 'SXM',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-63.10700436099995, 18.062119859000063],
            [-63.0858861909999, 18.0585112510001],
            [-63.01756858528839, 18.033391472351283],
            [-63.03062903599994, 18.01911041900007],
            [-63.097645636999914, 18.035956122000073],
            [-63.112172003999945, 18.043036200000074],
            [-63.11888587099992, 18.05149974200009],
            [-63.10700436099995, 18.059475002000056],
            [-63.10700436099995, 18.062119859000063],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Haiti',
        iso3: 'HTI',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-71.75743567599994, 19.710109768000052],
              [-71.7486132409999, 19.682598165000073],
              [-71.74504756699994, 19.664898987000058],
              [-71.74604140899993, 19.649017002000036],
              [-71.74768306499996, 19.622782695000026],
              [-71.74308386299992, 19.60007090300006],
              [-71.71512691299992, 19.53746490500005],
              [-71.70318965699997, 19.459278463000103],
              [-71.70386145099985, 19.41463002500008],
              [-71.71528194299995, 19.39165985100003],
              [-71.72081132099996, 19.385949606000068],
              [-71.7334720469999, 19.35546051100009],
              [-71.74298050899998, 19.348380839000058],
              [-71.76995560799992, 19.333808085],
              [-71.7765185149999, 19.327503561000086],
              [-71.77155757699995, 19.307556457000075],
              [-71.7537292069999, 19.28378529900003],
              [-71.74951707699992, 19.279707723000072],
              [-71.71652217699989, 19.247766825000028],
              [-71.65173271699987, 19.21792388400003],
              [-71.63911088099988, 19.212110088000045],
              [-71.64365840699989, 19.15247548400005],
              [-71.64877437399988, 19.135293071000078],
              [-71.6613834229999, 19.117593893000063],
              [-71.69528316199992, 19.094546204],
              [-71.71042435699994, 19.081652934000104],
              [-71.74034501199986, 19.041887919000075],
              [-71.78370153799995, 18.996309306000015],
              [-71.79682735199992, 18.988609518000104],
              [-71.84814204899996, 18.97548370400004],
              [-71.86540197799985, 18.964424948000058],
              [-71.86245642199995, 18.947087504000038],
              [-71.84452469899989, 18.949748841000044],
              [-71.81966833499993, 18.957810364000053],
              [-71.79625891099997, 18.957061056000057],
              [-71.78711218299989, 18.950033061000042],
              [-71.77295283999993, 18.921714376000054],
              [-71.76380611199994, 18.911508281000053],
              [-71.74091345299993, 18.89161285400006],
              [-71.7334720469999, 18.882569479],
              [-71.7279426689999, 18.864069316000084],
              [-71.72690913999992, 18.82352915500006],
              [-71.71884761599992, 18.784229228000086],
              [-71.72034623299993, 18.76544484500009],
              [-71.72525549299988, 18.746970520000062],
              [-71.73207678299991, 18.73007232700006],
              [-71.74406571499989, 18.711442973000104],
              [-71.75807002799988, 18.70051340700003],
              [-71.78489763799988, 18.684730213000122],
              [-71.79177913299992, 18.680681698000072],
              [-71.79434688399994, 18.679171041000032],
              [-71.80798946099995, 18.664649964000077],
              [-71.82855668099992, 18.631292827000024],
              [-71.84157914199997, 18.617986145000103],
              [-71.88028479099998, 18.605402934],
              [-71.955474, 18.618606262000085],
              [-71.99262935399992, 18.61113901800006],
              [-72.0098376059999, 18.598814189],
              [-72.00094925999989, 18.58245859800006],
              [-71.91051550299991, 18.494272766],
              [-71.90405594999996, 18.48479014100012],
              [-71.90157547999988, 18.469778138000052],
              [-71.90689815299993, 18.464300436000045],
              [-71.91439123599986, 18.460217997000044],
              [-71.91816361599987, 18.449236755000058],
              [-71.91216914899985, 18.43073659300005],
              [-71.8971829839999, 18.422881775000107],
              [-71.85816727799988, 18.41355417900006],
              [-71.8497440189999, 18.40644867000013],
              [-71.83455114799995, 18.38508046500003],
              [-71.82643794799986, 18.37616628100001],
              [-71.78871415299992, 18.352214254],
              [-71.7349706629999, 18.332938945000066],
              [-71.72070796799994, 18.32397308300004],
              [-71.71150956299994, 18.316144105000106],
              [-71.70933915199993, 18.313250224000015],
              [-71.72111173599984, 18.293973823000087],
              [-71.72170877299996, 18.29299623700011],
              [-71.76613155199988, 18.22025848400004],
              [-71.77403804599993, 18.201474101000045],
              [-71.77682857299988, 18.18178538000008],
              [-71.77532995599998, 18.17232859300013],
              [-71.76458125799985, 18.143674011000044],
              [-71.76220414199992, 18.132486064000105],
              [-71.76287593599989, 18.115846253000072],
              [-71.7606538499999, 18.086804097000098],
              [-71.76427119999997, 18.069492493000084],
              [-71.77623450399994, 18.039252020000063],
              [-71.79259192599994, 18.04987213700008],
              [-71.86245683499993, 18.136542059000078],
              [-71.89297441299993, 18.16278717700004],
              [-71.92808997299994, 18.18378327000005],
              [-72.00674394399994, 18.209458726000037],
              [-72.03929602799991, 18.22565338700008],
              [-72.07176673099991, 18.237534898000092],
              [-72.11070716099994, 18.237616278000075],
              [-72.19054114499994, 18.22483958500004],
              [-72.29454505099994, 18.225775458000044],
              [-72.44029700399994, 18.223944403000075],
              [-72.51878821499992, 18.21035390800006],
              [-72.53888912699995, 18.220445054000038],
              [-72.55093339799993, 18.224758205000057],
              [-72.55630449099993, 18.220851955000057],
              [-72.54954993399991, 18.18235911700009],
              [-72.55899003799993, 18.17255280200004],
              [-72.57066809799994, 18.172308661000045],
              [-72.59797115799995, 18.18235911700009],
              [-72.61327063699991, 18.18500397300005],
              [-72.73086503799993, 18.174709377000056],
              [-72.75499426999994, 18.176174221000053],
              [-72.75300045499995, 18.171576239000046],
              [-72.75011145699995, 18.160305080000057],
              [-72.74815833199995, 18.15570709800005],
              [-72.7630102199999, 18.156724351000037],
              [-72.76895097599993, 18.158270575000074],
              [-72.77603105399993, 18.16315338700008],
              [-72.80370032499991, 18.146144924000055],
              [-72.85887610599991, 18.151312567000048],
              [-72.88589433499993, 18.141424872000073],
              [-72.9121801419999, 18.155910549000055],
              [-72.94749915299991, 18.169094143000052],
              [-72.98534094999991, 18.178656317000048],
              [-73.09080969999991, 18.189846096000053],
              [-73.1172582669999, 18.188625393000052],
              [-73.12555904899995, 18.189846096000053],
              [-73.15465247299994, 18.207505601000037],
              [-73.1634008449999, 18.21035390800006],
              [-73.2962133449999, 18.23078034100007],
              [-73.35586503799993, 18.22492096600007],
              [-73.36510169199994, 18.227362372000073],
              [-73.35985266799992, 18.240383205000057],
              [-73.34658769399994, 18.245347398000092],
              [-73.31045488199993, 18.245062567000048],
              [-73.31045488199993, 18.251288153000075],
              [-73.37726803299995, 18.25812409100007],
              [-73.45824133999992, 18.257513739000046],
              [-73.48180091099994, 18.251288153000075],
              [-73.51398678299995, 18.23314036700009],
              [-73.52619381399995, 18.23078034100007],
              [-73.53416907499991, 18.234767971000053],
              [-73.54279537699995, 18.253119208000044],
              [-73.5501195949999, 18.258734442000048],
              [-73.56346594999991, 18.25104401200008],
              [-73.57070878799993, 18.23151276200008],
              [-73.57811438699991, 18.216864325000074],
              [-73.59166419199994, 18.223944403000075],
              [-73.59788977799991, 18.223944403000075],
              [-73.60968990799995, 18.21678294500009],
              [-73.61961829299992, 18.221909898000092],
              [-73.62401282499991, 18.234849351000037],
              [-73.61900794199994, 18.251288153000075],
              [-73.63320878799993, 18.247259833000044],
              [-73.64561926999994, 18.221096096000053],
              [-73.65998287699995, 18.21035390800006],
              [-73.65929114499994, 18.223822333000044],
              [-73.65599524599992, 18.23582591400009],
              [-73.64631100199995, 18.258734442000048],
              [-73.65416419199994, 18.25267161700009],
              [-73.66543535099993, 18.23851146000004],
              [-73.67357337099992, 18.23078034100007],
              [-73.67438717399995, 18.233221747000073],
              [-73.68024654899995, 18.23541901200008],
              [-73.69098873599995, 18.237616278000075],
              [-73.69456946499992, 18.23590729400007],
              [-73.69416256399995, 18.23191966400009],
              [-73.69298255099994, 18.227443752000056],
              [-73.69408118399991, 18.223944403000075],
              [-73.73778235599991, 18.190741278000075],
              [-73.80931555899991, 18.15916575700004],
              [-73.8274633449999, 18.14203522300005],
              [-73.84487870999993, 18.11469147300005],
              [-73.8028051419999, 18.071926174000055],
              [-73.79649817599994, 18.056341864000046],
              [-73.79141191299993, 18.03668854400007],
              [-73.79381262899994, 18.028998114000046],
              [-73.80703691299993, 18.025946356000077],
              [-73.87328040299991, 18.026190497000073],
              [-73.88296464799993, 18.027736721000053],
              [-73.89268958199995, 18.032171942000048],
              [-73.89997311099995, 18.039129950000074],
              [-73.90379798099991, 18.053859768000052],
              [-73.96776282499991, 18.141424872000073],
              [-73.97093665299991, 18.143703518000052],
              [-73.97850501199991, 18.146877346000053],
              [-73.98204505099994, 18.148871161000045],
              [-73.98558508999992, 18.15265534100007],
              [-73.9863988919999, 18.15570709800005],
              [-73.98688717399995, 18.15888092700004],
              [-73.9895727199999, 18.16315338700008],
              [-74.00820878799993, 18.179754950000074],
              [-74.10505123599995, 18.24762604400007],
              [-74.12242591099994, 18.255682684000078],
              [-74.15294348899994, 18.260565497000073],
              [-74.16576087099992, 18.26561107000009],
              [-74.17666581899994, 18.273179429000038],
              [-74.18130449099993, 18.28261953300006],
              [-74.18342037699995, 18.29328034100007],
              [-74.18907630099994, 18.296535549000055],
              [-74.19758053299995, 18.29706452000005],
              [-74.20799719999991, 18.299709377000056],
              [-74.23379472599993, 18.30927155200004],
              [-74.24217688699991, 18.31395091400009],
              [-74.24893144399994, 18.30654531500005],
              [-74.26781165299991, 18.312974351000037],
              [-74.28783118399991, 18.30491771000004],
              [-74.30894934799994, 18.29246653900009],
              [-74.33092200399994, 18.286037502000056],
              [-74.34935462099992, 18.28969961100006],
              [-74.37218176999994, 18.298488674000055],
              [-74.39159094999991, 18.30878327000005],
              [-74.39976966099994, 18.31708405200004],
              [-74.40831458199995, 18.328273830000057],
              [-74.44591223899994, 18.34638092700004],
              [-74.4544164699999, 18.36481354400007],
              [-74.45665442599994, 18.38434479400007],
              [-74.46320553299995, 18.398179429000038],
              [-74.48916581899994, 18.429388739000046],
              [-74.4544164699999, 18.477769273000092],
              [-74.45742753799993, 18.481756903000075],
              [-74.46182206899994, 18.491441148000092],
              [-74.44351152299993, 18.50381094000005],
              [-74.43175208199995, 18.550116278000075],
              [-74.41685950399994, 18.560370184000078],
              [-74.4141332669999, 18.565578518000052],
              [-74.41584225199995, 18.577297268000052],
              [-74.41978919199994, 18.58982982000009],
              [-74.42369544199994, 18.597601630000042],
              [-74.42625891799992, 18.608221747000073],
              [-74.41852779899995, 18.61749909100007],
              [-74.38463294199994, 18.63629791900007],
              [-74.34019934799994, 18.65338776200008],
              [-74.32127844999991, 18.65656159100007],
              [-74.29820716099994, 18.651190497000073],
              [-74.28799394399994, 18.651516018000052],
              [-74.28376217399995, 18.65965403900009],
              [-74.27879798099991, 18.666571356000077],
              [-74.26768958199995, 18.669623114000046],
              [-74.2559301419999, 18.670314846000053],
              [-74.19977779899995, 18.667303778000075],
              [-74.15998287699995, 18.65916575700004],
              [-74.02912350199995, 18.60374583500004],
              [-73.97154700399994, 18.601304429000038],
              [-73.96947180899991, 18.59979889500005],
              [-73.9629613919999, 18.59284088700008],
              [-73.96157792899993, 18.590765692000048],
              [-73.95929928299995, 18.58299388200004],
              [-73.95372473899994, 18.58356354400007],
              [-73.94676673099991, 18.58698151200008],
              [-73.94050045499995, 18.587632554000038],
              [-73.9114477199999, 18.573187567000048],
              [-73.89854895699995, 18.568793036000045],
              [-73.8535863919999, 18.567206122000073],
              [-73.84292558499993, 18.565252997000073],
              [-73.83120683499993, 18.560370184000078],
              [-73.80968176999994, 18.542792059000078],
              [-73.80333411399994, 18.53925202000005],
              [-73.7930395169999, 18.53851959800005],
              [-73.78807532499991, 18.54132721600007],
              [-73.78473873599995, 18.544867255000042],
              [-73.77940833199995, 18.546698309000078],
              [-73.76943925699993, 18.54515208500004],
              [-73.75706946499992, 18.53937409100007],
              [-73.7481176419999, 18.53925202000005],
              [-73.74201412699995, 18.541937567000048],
              [-73.72923743399991, 18.550930080000057],
              [-73.72508704299992, 18.55292389500005],
              [-73.72386633999992, 18.55532461100006],
              [-73.71117102799991, 18.570257880000042],
              [-73.70445716099994, 18.573472398000092],
              [-73.69652258999992, 18.57379791900007],
              [-73.68830318899995, 18.573146877000056],
              [-73.68040930899991, 18.573431708000044],
              [-73.63508053299995, 18.58592357000009],
              [-73.62205969999991, 18.587632554000038],
              [-73.58641516799992, 18.57916901200008],
              [-73.58584550699993, 18.56199778900009],
              [-73.60610917899993, 18.54901764500005],
              [-73.63263912699995, 18.55292389500005],
              [-73.63263912699995, 18.546698309000078],
              [-73.65420488199993, 18.553615627000056],
              [-73.67345130099994, 18.55609772300005],
              [-73.69277910099993, 18.554022528000075],
              [-73.71458899599992, 18.546698309000078],
              [-73.70799719999991, 18.54242584800005],
              [-73.69139563699991, 18.534002997000073],
              [-73.67491614499994, 18.530178127000056],
              [-73.67381751199991, 18.524318752000056],
              [-73.67422441299993, 18.51666901200008],
              [-73.66982988199993, 18.50885651200008],
              [-73.65221106699994, 18.50136953300006],
              [-73.6204320949999, 18.50576406500005],
              [-73.60472571499992, 18.49827708500004],
              [-73.5696508449999, 18.518377997000073],
              [-73.5266820949999, 18.523504950000074],
              [-73.36851966099994, 18.51194896000004],
              [-73.34829667899993, 18.507635809000078],
              [-73.30846106699994, 18.488348700000074],
              [-73.28624426999994, 18.484035549000055],
              [-73.20612545499995, 18.486802476000037],
              [-73.16698157499991, 18.483547268000052],
              [-73.13170325399994, 18.47101471600007],
              [-73.11314856699994, 18.460760809000078],
              [-73.09801184799994, 18.45526764500005],
              [-73.08116614499994, 18.45416901200008],
              [-73.0559382799999, 18.45844147300005],
              [-72.98558508999992, 18.470404364000046],
              [-72.89899654899995, 18.450506903000075],
              [-72.90416419199994, 18.434149481000077],
              [-72.88508053299995, 18.43768952000005],
              [-72.85830644399994, 18.44668203300006],
              [-72.84064693899995, 18.44676341400009],
              [-72.82603919199994, 18.44082265800006],
              [-72.75499426999994, 18.429388739000046],
              [-72.71646074099993, 18.43773021000004],
              [-72.68932044199994, 18.45966217700004],
              [-72.66934160099993, 18.49046458500004],
              [-72.65257727799991, 18.52558014500005],
              [-72.62828528599994, 18.55414459800005],
              [-72.59654700399994, 18.56085846600007],
              [-72.4297582669999, 18.546698309000078],
              [-72.42369544199994, 18.54881419500009],
              [-72.42113196499992, 18.553534247000073],
              [-72.41950436099995, 18.558254299000055],
              [-72.4160863919999, 18.560370184000078],
              [-72.40982011599993, 18.559149481000077],
              [-72.40689042899993, 18.55662669500009],
              [-72.40493730399993, 18.55410390800006],
              [-72.40176347599993, 18.55292389500005],
              [-72.38097083199995, 18.53070709800005],
              [-72.37140865799995, 18.52558014500005],
              [-72.35383053299995, 18.530096747000073],
              [-72.34569251199991, 18.54686107000009],
              [-72.34341386599993, 18.570135809000078],
              [-72.34508216099994, 18.631008205000057],
              [-72.34341386599993, 18.642279364000046],
              [-72.33641516799992, 18.65582916900007],
              [-72.32868404899995, 18.663885809000078],
              [-72.32506262899994, 18.67137278900009],
              [-72.33043372299994, 18.683294989000046],
              [-72.33942623599995, 18.68943919500009],
              [-72.38508053299995, 18.710598049000055],
              [-72.39736894399994, 18.712632554000038],
              [-72.42170162699995, 18.713364976000037],
              [-72.43346106699994, 18.71678294500009],
              [-72.45372473899994, 18.733343817000048],
              [-72.47175045499995, 18.75409577000005],
              [-72.49107825399994, 18.768500067000048],
              [-72.51537024599992, 18.76581452000005],
              [-72.54954993399991, 18.785630601000037],
              [-72.55809485599991, 18.794623114000046],
              [-72.56651770699995, 18.813625393000052],
              [-72.61778723899994, 18.88934967700004],
              [-72.63194739499994, 18.90306224200009],
              [-72.65196692599994, 18.91860586100006],
              [-72.67300370999993, 18.931301174000055],
              [-72.69009355399993, 18.93650950700004],
              [-72.70872962099992, 18.94554271000004],
              [-72.81354732999995, 19.05292389500005],
              [-72.81834876199991, 19.078558661000045],
              [-72.77603105399993, 19.09479401200008],
              [-72.73766028599994, 19.09723541900007],
              [-72.71646074099993, 19.103949286000045],
              [-72.70718339799993, 19.11863841400009],
              [-72.71312415299991, 19.13743724200009],
              [-72.72769120999993, 19.14720286700009],
              [-72.74583899599992, 19.15379466400009],
              [-72.76244055899991, 19.16307200700004],
              [-72.77301998599995, 19.17576732000009],
              [-72.79702714799993, 19.216009833000044],
              [-72.80337480399993, 19.23191966400009],
              [-72.79653886599993, 19.23655833500004],
              [-72.79576575399994, 19.238348700000074],
              [-72.79686438699991, 19.240301825000074],
              [-72.79596920499995, 19.24559153900009],
              [-72.78620357999995, 19.254299221000053],
              [-72.77521725199995, 19.27732982000009],
              [-72.76862545499995, 19.28656647300005],
              [-72.75767981699994, 19.29169342700004],
              [-72.74181067599994, 19.294663804000038],
              [-72.72569739499994, 19.295314846000053],
              [-72.71397864499994, 19.293402411000045],
              [-72.72834225199995, 19.320379950000074],
              [-72.73867753799993, 19.325873114000046],
              [-72.75869706899994, 19.32758209800005],
              [-72.77057857999995, 19.33616771000004],
              [-72.77448482999995, 19.35569896000004],
              [-72.77293860599991, 19.37645091400009],
              [-72.76862545499995, 19.38898346600007],
              [-72.76231848899994, 19.382757880000042],
              [-72.7539770169999, 19.377346096000053],
              [-72.74437415299991, 19.37445709800005],
              [-72.73448645699995, 19.375921942000048],
              [-72.72345943899995, 19.38349030200004],
              [-72.72288977799991, 19.39081452000005],
              [-72.72642981699994, 19.39907461100006],
              [-72.72809811099995, 19.42206452000005],
              [-72.73062089799993, 19.42641836100006],
              [-72.72834225199995, 19.425604559000078],
              [-72.71397864499994, 19.423163153000075],
              [-72.70897376199991, 19.42015208500004],
              [-72.70197506399995, 19.414496161000045],
              [-72.69237219999991, 19.40973541900007],
              [-72.67983964799993, 19.409491278000075],
              [-72.69912675699993, 19.445868231000077],
              [-72.70921790299991, 19.451239325000074],
              [-72.76089433499993, 19.454331773000035],
              [-72.77399654899995, 19.463364976000037],
              [-72.78278561099995, 19.476711330000057],
              [-72.79596920499995, 19.492010809000078],
              [-72.81476803299995, 19.504828192000048],
              [-72.87848873599995, 19.532375393000052],
              [-72.93154863199993, 19.56346263200004],
              [-72.9505102199999, 19.56777578300006],
              [-72.96690833199995, 19.575018622000073],
              [-73.00218665299991, 19.603461005000042],
              [-73.00885982999995, 19.60496653900009],
              [-73.0188695949999, 19.600734768000052],
              [-73.08079993399991, 19.622381903000075],
              [-73.09105383999992, 19.623480536000045],
              [-73.11074785099993, 19.628119208000044],
              [-73.12079830599993, 19.62909577000005],
              [-73.12214107999995, 19.62921784100007],
              [-73.12718665299991, 19.62693919500009],
              [-73.13182532499991, 19.62205638200004],
              [-73.13841712099992, 19.617132880000042],
              [-73.14907792899993, 19.614935614000046],
              [-73.16392981699994, 19.618394273000035],
              [-73.18602454299992, 19.627101955000057],
              [-73.20759029899995, 19.638413804000038],
              [-73.22109941299993, 19.649644273000035],
              [-73.24128170499995, 19.63104889500005],
              [-73.28425045499995, 19.62571849200009],
              [-73.37954667899993, 19.63027578300006],
              [-73.39842688699991, 19.63495514500005],
              [-73.4094945949999, 19.635972398000035],
              [-73.41657467399995, 19.640326239000046],
              [-73.43423417899993, 19.659084377000056],
              [-73.44395911399994, 19.663316148000035],
              [-73.45783443899995, 19.67218659100007],
              [-73.46336829299992, 19.69212474200009],
              [-73.46524003799993, 19.71308014500005],
              [-73.46812903599994, 19.72479889500005],
              [-73.43244381399995, 19.778957424000055],
              [-73.42715410099993, 19.790269273000035],
              [-73.41734778599994, 19.79051341400009],
              [-73.36510169199994, 19.81354401200008],
              [-73.36510169199994, 19.82099030200004],
              [-73.42031816299993, 19.82099030200004],
              [-73.40416419199994, 19.832505601000037],
              [-73.38512122299994, 19.834418036000045],
              [-73.36473548099991, 19.832831122000073],
              [-73.34459387899994, 19.834051825000074],
              [-73.22276770699995, 19.88694896000004],
              [-73.18712317599994, 19.911444403000075],
              [-73.16710364499994, 19.93768952000005],
              [-73.15514075399994, 19.923976955000057],
              [-73.14370683499993, 19.920314846000053],
              [-73.1153051419999, 19.92340729400007],
              [-73.10069739499994, 19.92137278900009],
              [-73.07433020699995, 19.91233958500004],
              [-73.06037350199995, 19.91034577000005],
              [-73.04845130099994, 19.910589911000045],
              [-73.04181881399995, 19.91152578300006],
              [-73.02183997299994, 19.916571356000077],
              [-73.00706946499992, 19.918402411000045],
              [-72.99176998599995, 19.917181708000044],
              [-72.97789466099994, 19.91229889500005],
              [-72.96727454299992, 19.902899481000077],
              [-72.96011308499993, 19.918402411000045],
              [-72.94127356699994, 19.92804596600007],
              [-72.91832434799994, 19.930161851000037],
              [-72.89899654899995, 19.92340729400007],
              [-72.87230383999992, 19.93378327000005],
              [-72.84044348899994, 19.94163646000004],
              [-72.80711829299992, 19.94562409100007],
              [-72.77603105399993, 19.943915106000077],
              [-72.67398027299993, 19.92137278900009],
              [-72.64883378799993, 19.906642971000053],
              [-72.62804114499994, 19.897284247000073],
              [-72.56871497299994, 19.87986888200004],
              [-72.56517493399991, 19.87571849200009],
              [-72.54434160099993, 19.851263739000046],
              [-72.51756751199991, 19.834133205000057],
              [-72.48973548099991, 19.824652411000045],
              [-72.47443600199995, 19.834051825000074],
              [-72.45620683499993, 19.82485586100006],
              [-72.42593339799993, 19.813788153000075],
              [-72.39757239499994, 19.80695221600007],
              [-72.38508053299995, 19.81045156500005],
              [-72.37873287699995, 19.794663804000038],
              [-72.33043372299994, 19.752101955000057],
              [-72.33043372299994, 19.745835679000038],
              [-72.33519446499992, 19.747870184000078],
              [-72.3509008449999, 19.752101955000057],
              [-72.33824622299994, 19.72296784100007],
              [-72.33385169199994, 19.718573309000078],
              [-72.31615149599992, 19.71482982000009],
              [-72.31240800699993, 19.716131903000075],
              [-72.31615149599992, 19.72479889500005],
              [-72.30308997299994, 19.739081122000073],
              [-72.30638587099992, 19.73924388200004],
              [-72.31289628799993, 19.738755601000037],
              [-72.31615149599992, 19.739081122000073],
              [-72.31590735599991, 19.740301825000074],
              [-72.31383216099994, 19.744533596000053],
              [-72.31139075399994, 19.747788804000038],
              [-72.30992591099994, 19.745835679000038],
              [-72.30992591099994, 19.752101955000057],
              [-72.31224524599992, 19.755194403000075],
              [-72.31615149599992, 19.765692450000074],
              [-72.30992591099994, 19.765692450000074],
              [-72.29507402299993, 19.75804271000004],
              [-72.27464758999992, 19.756252346000053],
              [-72.25641842399995, 19.761867580000057],
              [-72.24844316299993, 19.776597398000035],
              [-72.23839270699995, 19.786444403000075],
              [-72.21865800699993, 19.786932684000078],
              [-72.20523027299993, 19.776190497000073],
              [-72.21373450399994, 19.752101955000057],
              [-72.19676673099991, 19.74249909100007],
              [-72.18040930899991, 19.74087148600006],
              [-72.14085852799991, 19.74746328300006],
              [-72.13744055899991, 19.747219143000052],
              [-72.13182532499991, 19.745835679000038],
              [-72.12490800699993, 19.741441148000035],
              [-72.11050370999993, 19.727687893000052],
              [-72.10081946499992, 19.72479889500005],
              [-72.06631425699993, 19.72479889500005],
              [-72.05821692599994, 19.72264232000009],
              [-72.05378170499995, 19.717962958000044],
              [-72.05060787699995, 19.713283596000053],
              [-72.04124915299991, 19.70897044500009],
              [-72.02765865799995, 19.699611721000053],
              [-72.01854407499991, 19.69745514500005],
              [-72.01081295499995, 19.700873114000046],
              [-72.00572669199994, 19.708319403000075],
              [-71.9993383449999, 19.71556224200009],
              [-71.98786373599995, 19.718573309000078],
              [-71.96886145699995, 19.73232656500005],
              [-71.94050045499995, 19.732123114000046],
              [-71.89159094999991, 19.718573309000078],
              [-71.86473548099991, 19.71507396000004],
              [-71.85757402299993, 19.71002838700008],
              [-71.86363684799994, 19.69745514500005],
              [-71.87230383999992, 19.69212474200009],
              [-71.88418535099993, 19.690252997000073],
              [-71.91209876199991, 19.690619208000044],
              [-71.90160071499992, 19.672308661000045],
              [-71.88426673099991, 19.670396226000037],
              [-71.86546790299991, 19.67536041900007],
              [-71.85065670499995, 19.67763906500005],
              [-71.83259029899995, 19.663275458000044],
              [-71.82144120999993, 19.656683661000045],
              [-71.81651770699995, 19.659857489000046],
              [-71.81114661399994, 19.673570054000038],
              [-71.81330318899995, 19.68073151200008],
              [-71.83535722599993, 19.68618398600006],
              [-71.84243730399993, 19.692328192000048],
              [-71.84601803299995, 19.701117255000042],
              [-71.84439042899993, 19.71112702000005],
              [-71.83674068899995, 19.717352606000077],
              [-71.82530676999994, 19.716620184000078],
              [-71.79942786399994, 19.71112702000005],
              [-71.75743567599994, 19.710109768000052],
            ],
          ],
          [
            [
              [-73.62889563699991, 18.094224351000037],
              [-73.61204993399991, 18.09324778900009],
              [-73.59227454299992, 18.08934153900009],
              [-73.57799231699994, 18.08112213700008],
              [-73.57799231699994, 18.066961981000077],
              [-73.59044348899994, 18.059393622000073],
              [-73.61082923099991, 18.057562567000048],
              [-73.6497289699999, 18.059475002000056],
              [-73.66722571499992, 18.06313711100006],
              [-73.68252519399994, 18.072007554000038],
              [-73.70767167899993, 18.094224351000037],
              [-73.70445716099994, 18.10419342700004],
              [-73.69994055899991, 18.108303127000056],
              [-73.69424394399994, 18.10687897300005],
              [-73.68785559799994, 18.100490627000056],
              [-73.67638098899994, 18.10809967700004],
              [-73.67088782499991, 18.10537344000005],
              [-73.66690019399994, 18.098578192000048],
              [-73.65998287699995, 18.094224351000037],
              [-73.62889563699991, 18.094224351000037],
            ],
          ],
          [
            [
              [-73.79649817599994, 18.628648179000038],
              [-73.77269446499992, 18.63934967700004],
              [-73.73997962099992, 18.636867580000057],
              [-73.71495520699995, 18.623480536000045],
              [-73.71458899599992, 18.601304429000038],
              [-73.7376195949999, 18.58820221600007],
              [-73.76952063699991, 18.588364976000037],
              [-73.79442298099991, 18.60187409100007],
              [-73.79649817599994, 18.628648179000038],
            ],
          ],
          [
            [
              [-72.85057532499991, 20.08852773600006],
              [-72.82168535099993, 20.089789130000042],
              [-72.80239824099993, 20.087225653000075],
              [-72.78514563699991, 20.080023505000042],
              [-72.76244055899991, 20.06736888200004],
              [-72.66779537699995, 20.03229401200008],
              [-72.62755286399994, 20.008246161000045],
              [-72.63890540299991, 19.984849351000037],
              [-72.65514075399994, 19.991400458000044],
              [-72.73985755099994, 20.002427476000037],
              [-72.77916419199994, 20.01699453300006],
              [-72.82774817599994, 20.02732982000009],
              [-72.84430904899995, 20.034491278000075],
              [-72.85578365799995, 20.032416083000044],
              [-72.86766516799992, 20.028225002000056],
              [-72.87848873599995, 20.02643463700008],
              [-72.89940344999991, 20.030422268000052],
              [-72.9238988919999, 20.03815338700008],
              [-72.94611568899995, 20.048773505000042],
              [-72.96035722599993, 20.06122467700004],
              [-72.95596269399994, 20.06118398600006],
              [-72.9531957669999, 20.06248607000009],
              [-72.94737708199995, 20.06736888200004],
              [-72.90111243399991, 20.08201732000009],
              [-72.85057532499991, 20.08852773600006],
            ],
          ],
          [
            [
              [-73.25865637899994, 18.87848541900007],
              [-73.27733313699991, 18.891099351000037],
              [-73.28258216099994, 18.89549388200004],
              [-73.28990637899994, 18.90420156500005],
              [-73.29653886599993, 18.914496161000045],
              [-73.29963131399995, 18.925523179000038],
              [-73.2962133449999, 18.93650950700004],
              [-73.28384355399993, 18.949693101000037],
              [-73.26634680899991, 18.96084219000005],
              [-73.24596106699994, 18.968410549000055],
              [-73.22447669199994, 18.971258856000077],
              [-73.20079505099994, 18.968695380000042],
              [-73.06191972599993, 18.913316148000035],
              [-72.99339758999992, 18.89203522300005],
              [-72.91722571499992, 18.85545482000009],
              [-72.84609941299993, 18.827093817000048],
              [-72.81704667899993, 18.793117580000057],
              [-72.80947831899994, 18.77147044500009],
              [-72.80589758999992, 18.74567291900007],
              [-72.80874589799993, 18.720404364000046],
              [-72.82046464799993, 18.70066966400009],
              [-72.83112545499995, 18.696437893000052],
              [-72.83820553299995, 18.70258209800005],
              [-72.84715735599991, 18.720526434000078],
              [-72.85570227799991, 18.727687893000052],
              [-72.8633520169999, 18.729641018000052],
              [-72.88589433499993, 18.731024481000077],
              [-72.97500566299993, 18.74990469000005],
              [-73.00544186099995, 18.75214264500005],
              [-73.03742428299995, 18.759588934000078],
              [-73.12555904899995, 18.813625393000052],
              [-73.21458899599992, 18.83661530200004],
              [-73.23851477799991, 18.851507880000042],
              [-73.25865637899994, 18.87848541900007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Dominican Rep.',
        iso3: 'DOM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-71.75743567599994, 19.710109768000052],
              [-71.73827063699991, 19.70612213700008],
              [-71.72032630099994, 19.69745514500005],
              [-71.72411048099991, 19.717189846000053],
              [-71.74185136599993, 19.755804755000042],
              [-71.74079342399995, 19.765692450000074],
              [-71.74079342399995, 19.773179429000038],
              [-71.7676488919999, 19.77448151200008],
              [-71.77106686099995, 19.78514232000009],
              [-71.76024329299992, 19.800930080000057],
              [-71.74449622299994, 19.817206122000073],
              [-71.73997962099992, 19.820257880000042],
              [-71.73485266799992, 19.82127513200004],
              [-71.72370357999995, 19.82099030200004],
              [-71.71690833199995, 19.82363515800006],
              [-71.70579993399991, 19.836493231000077],
              [-71.69981848899994, 19.841498114000046],
              [-71.68789628799993, 19.84601471600007],
              [-71.6790258449999, 19.848089911000045],
              [-71.67027747299994, 19.851996161000045],
              [-71.65880286399994, 19.86196523600006],
              [-71.66563880099994, 19.87449778900009],
              [-71.66673743399991, 19.885687567000048],
              [-71.6614477199999, 19.89362213700008],
              [-71.64858964799993, 19.89671458500004],
              [-71.64085852799991, 19.89557526200008],
              [-71.62889563699991, 19.890448309000078],
              [-71.62124589799993, 19.88930898600006],
              [-71.61790930899991, 19.891424872000073],
              [-71.61095130099994, 19.900824286000045],
              [-71.60732988199993, 19.902899481000077],
              [-71.50462805899991, 19.91034577000005],
              [-71.47850501199991, 19.90688711100006],
              [-71.45270748599995, 19.898098049000055],
              [-71.35724850199995, 19.851263739000046],
              [-71.32921301999994, 19.84589264500005],
              [-71.30260169199994, 19.85569896000004],
              [-71.28246008999992, 19.84178294500009],
              [-71.26805579299992, 19.83551666900007],
              [-71.22374426999994, 19.834051825000074],
              [-71.21206620999993, 19.837103583000044],
              [-71.20933997299994, 19.84479401200008],
              [-71.20881100199995, 19.85496653900009],
              [-71.20352128799993, 19.865383205000057],
              [-71.19176184799994, 19.869696356000077],
              [-71.18333899599992, 19.86041901200008],
              [-71.17223059799994, 19.834051825000074],
              [-71.16441809799994, 19.83860911700009],
              [-71.15851803299995, 19.843491929000038],
              [-71.15440833199995, 19.84910716400009],
              [-71.15172278599994, 19.85569896000004],
              [-71.1602270169999, 19.858221747000073],
              [-71.16201738199993, 19.859442450000074],
              [-71.1621801419999, 19.86204661700009],
              [-71.16539466099994, 19.868801174000055],
              [-71.1497289699999, 19.863023179000038],
              [-71.13658606699994, 19.863714911000045],
              [-71.12319902299993, 19.866888739000046],
              [-71.10704505099994, 19.868801174000055],
              [-71.09679114499994, 19.876206773000035],
              [-71.07827714799993, 19.909125067000048],
              [-71.06607011599993, 19.916571356000077],
              [-71.0508520169999, 19.92023346600007],
              [-71.01842200399994, 19.935492255000042],
              [-71.00088456899994, 19.93768952000005],
              [-70.98473059799994, 19.933742580000057],
              [-70.96934973899994, 19.92519765800006],
              [-70.96104895699995, 19.912665106000077],
              [-70.96617591099994, 19.89671458500004],
              [-70.94688880099994, 19.88930898600006],
              [-70.93944251199991, 19.88930898600006],
              [-70.94444739499994, 19.904730536000045],
              [-70.94688880099994, 19.91034577000005],
              [-70.8985082669999, 19.902899481000077],
              [-70.88426673099991, 19.90428294500009],
              [-70.85472571499992, 19.91083405200004],
              [-70.84325110599991, 19.91034577000005],
              [-70.83096269399994, 19.90253327000005],
              [-70.78697669199994, 19.852850653000075],
              [-70.78331458199995, 19.84332916900007],
              [-70.78864498599995, 19.834051825000074],
              [-70.75096594999991, 19.833807684000078],
              [-70.73656165299991, 19.827093817000048],
              [-70.69847571499992, 19.796820380000042],
              [-70.66222083199995, 19.779364325000074],
              [-70.62368730399993, 19.766546942000048],
              [-70.57909094999991, 19.760199286000045],
              [-70.51870683499993, 19.75975169500009],
              [-70.51366126199991, 19.762640692000048],
              [-70.50853430899991, 19.769354559000078],
              [-70.49644934799994, 19.77724844000005],
              [-70.48277747299994, 19.78388092700004],
              [-70.4727270169999, 19.786851304000038],
              [-70.43370520699995, 19.775213934000078],
              [-70.37271074099993, 19.714178778000075],
              [-70.33617102799991, 19.67763906500005],
              [-70.31956946499992, 19.666449286000045],
              [-70.30134029899995, 19.65766022300005],
              [-70.28083248599995, 19.65180084800005],
              [-70.23521887899994, 19.64720286700009],
              [-70.1985570949999, 19.63467031500005],
              [-70.13141842399995, 19.62213776200008],
              [-70.11644446499992, 19.622381903000075],
              [-70.10643469999991, 19.625921942000048],
              [-70.09752356699994, 19.633205471000053],
              [-70.06102454299992, 19.67011139500005],
              [-70.04210364499994, 19.67845286700009],
              [-69.98668372299994, 19.67763906500005],
              [-69.95954342399995, 19.680121161000045],
              [-69.94725501199991, 19.678656317000048],
              [-69.93203691299993, 19.67015208500004],
              [-69.89793860599991, 19.635972398000035],
              [-69.88719641799992, 19.61273834800005],
              [-69.88776607999995, 19.58734772300005],
              [-69.90416419199994, 19.532375393000052],
              [-69.88414466099994, 19.52440013200004],
              [-69.87653561099995, 19.506659247000073],
              [-69.87682044199994, 19.461004950000074],
              [-69.87437903599994, 19.441148179000038],
              [-69.86799068899995, 19.42527903900009],
              [-69.80138098899994, 19.330877997000073],
              [-69.77147376199991, 19.303249416000085],
              [-69.76768958199995, 19.299750067000048],
              [-69.73346920499995, 19.28656647300005],
              [-69.71320553299995, 19.28974030200004],
              [-69.67438717399995, 19.303859768000052],
              [-69.6543676419999, 19.307033596000053],
              [-69.60936438699991, 19.30878327000005],
              [-69.58942623599995, 19.31281159100007],
              [-69.56895911399994, 19.320705471000053],
              [-69.53941809799994, 19.33942291900007],
              [-69.52798417899993, 19.34178294500009],
              [-69.5176488919999, 19.339667059000078],
              [-69.49644934799994, 19.329779364000046],
              [-69.48330644399994, 19.32758209800005],
              [-69.45909583199995, 19.333319403000075],
              [-69.44859778599994, 19.334377346000053],
              [-69.44277910099993, 19.33417389500005],
              [-69.43736731699994, 19.332953192000048],
              [-69.43342037699995, 19.329901434000078],
              [-69.43179277299993, 19.32412344000005],
              [-69.42861894399994, 19.319240627000056],
              [-69.42170162699995, 19.321112372000073],
              [-69.41071529899995, 19.32758209800005],
              [-69.35269120999993, 19.305121161000045],
              [-69.33560136599993, 19.293402411000045],
              [-69.3242895169999, 19.31509023600006],
              [-69.30589758999992, 19.33112213700008],
              [-69.26048743399991, 19.35488515800006],
              [-69.23127193899995, 19.363348700000074],
              [-69.22435462099992, 19.35179271000004],
              [-69.23208574099993, 19.327948309000078],
              [-69.24681555899991, 19.299627997000073],
              [-69.22687740799995, 19.292669989000046],
              [-69.20433508999992, 19.292792059000078],
              [-69.18244381399995, 19.298163153000075],
              [-69.16429602799991, 19.307033596000053],
              [-69.15835527299993, 19.285101630000042],
              [-69.17137610599991, 19.26788971600007],
              [-69.18932044199994, 19.25226471600007],
              [-69.19839433499993, 19.23505280200004],
              [-69.20270748599995, 19.216945705000057],
              [-69.21434485599991, 19.20062897300005],
              [-69.23180091099994, 19.188666083000044],
              [-69.25365149599992, 19.183539130000042],
              [-69.33214270699995, 19.197211005000042],
              [-69.41812089799993, 19.19098541900007],
              [-69.43838456899994, 19.196478583000044],
              [-69.47545325399994, 19.214016018000052],
              [-69.60293535099993, 19.228989976000037],
              [-69.61729895699995, 19.22524648600006],
              [-69.62279212099992, 19.211859442000048],
              [-69.62604732999995, 19.16429271000004],
              [-69.63353430899991, 19.12368398600006],
              [-69.63044186099995, 19.10846588700008],
              [-69.6208796869999, 19.101955471000053],
              [-69.60846920499995, 19.093451239000046],
              [-69.55329342399995, 19.10146719000005],
              [-69.53425045499995, 19.09479401200008],
              [-69.51048743399991, 19.102036851000037],
              [-69.46344967399995, 19.08470286700009],
              [-69.43862870999993, 19.08734772300005],
              [-69.44473222599993, 19.092352606000077],
              [-69.45274817599994, 19.096909898000035],
              [-69.46231035099993, 19.10028717700004],
              [-69.47337805899991, 19.101629950000074],
              [-69.47337805899991, 19.10846588700008],
              [-69.4199926419999, 19.111151434000078],
              [-69.40444902299993, 19.10846588700008],
              [-69.38670813699991, 19.096096096000053],
              [-69.37295488199993, 19.065375067000048],
              [-69.35606848899994, 19.053208726000037],
              [-69.33897864499994, 19.048895575000074],
              [-69.30459550699993, 19.044867255000042],
              [-69.21174068899995, 19.02098216400009],
              [-69.17324785099993, 19.01113515800006],
              [-69.15746008999992, 19.012193101000037],
              [-69.13866126199991, 19.022284247000073],
              [-69.14488684799994, 19.02960846600007],
              [-69.15733801999994, 19.03668854400007],
              [-69.15746008999992, 19.04637278900009],
              [-69.13951575399994, 19.051214911000045],
              [-69.12389075399994, 19.03778717700004],
              [-69.1028539699999, 19.00535716400009],
              [-69.08926347599993, 18.997870184000078],
              [-69.07412675699993, 18.99355703300006],
              [-69.06118730399993, 18.98818594000005],
              [-69.05443274599992, 18.977484442000048],
              [-69.04246985599991, 18.986761786000045],
              [-69.01805579299992, 18.99746328300006],
              [-69.00658118399991, 19.00535716400009],
              [-69.01423092399995, 19.013413804000038],
              [-69.01056881399995, 19.015366929000038],
              [-69.00157630099994, 19.01561107000009],
              [-68.99299068899995, 19.018459377000056],
              [-68.98253333199995, 19.02879466400009],
              [-68.97935950399994, 19.032863674000055],
              [-68.97541256399995, 19.033148505000042],
              [-68.93956458199995, 19.031317450000074],
              [-68.91860917899993, 19.027289130000042],
              [-68.89981035099993, 19.02090078300006],
              [-68.88312740799995, 19.012193101000037],
              [-68.88121497299994, 19.009426174000055],
              [-68.88117428299995, 19.005804755000042],
              [-68.88036048099991, 19.002020575000074],
              [-68.8762914699999, 18.998602606000077],
              [-68.85582434799994, 18.99176666900007],
              [-68.85399329299992, 18.99209219000005],
              [-68.81822669199994, 18.984930731000077],
              [-68.79588782499991, 18.984116929000038],
              [-68.78685462099992, 18.981024481000077],
              [-68.78514563699991, 18.97988515800006],
              [-68.77696692599994, 18.974351304000038],
              [-68.76781165299991, 18.96946849200009],
              [-68.74998938699991, 18.968085028000075],
              [-68.73973548099991, 18.96442291900007],
              [-68.62352454299992, 18.861883856000077],
              [-68.58079993399991, 18.812567450000074],
              [-68.52049719999991, 18.768866278000075],
              [-68.47728430899991, 18.74022044500009],
              [-68.46499589799993, 18.73501211100006],
              [-68.45856686099995, 18.731024481000077],
              [-68.4134008449999, 18.689601955000057],
              [-68.35619055899991, 18.65656159100007],
              [-68.32860266799992, 18.616522528000075],
              [-68.33405514199995, 18.577297268000052],
              [-68.42804928299995, 18.441229559000078],
              [-68.43468176999994, 18.43577708500004],
              [-68.44127356699994, 18.429022528000075],
              [-68.44432532499991, 18.41950104400007],
              [-68.44249426999994, 18.38475169500009],
              [-68.44432532499991, 18.374823309000078],
              [-68.45567786399994, 18.357855536000045],
              [-68.47215735599991, 18.34983958500004],
              [-68.49282792899993, 18.347479559000078],
              [-68.51659094999991, 18.347479559000078],
              [-68.53490149599992, 18.353338934000078],
              [-68.57453365799995, 18.378159898000092],
              [-68.58893795499995, 18.38226959800005],
              [-68.60545813699991, 18.37173086100006],
              [-68.6028539699999, 18.35565827000005],
              [-68.59752356699994, 18.33661530200004],
              [-68.60602779899995, 18.31708405200004],
              [-68.61831620999993, 18.30145905200004],
              [-68.62608801999994, 18.283351955000057],
              [-68.64150956899994, 18.225165106000077],
              [-68.64708411399994, 18.21482982000009],
              [-68.65843665299991, 18.21092357000009],
              [-68.74299068899995, 18.20453522300005],
              [-68.76024329299992, 18.21035390800006],
              [-68.76252193899995, 18.246975002000056],
              [-68.78685462099992, 18.295396226000037],
              [-68.82013912699995, 18.34247467700004],
              [-68.84959876199991, 18.374823309000078],
              [-68.88097083199995, 18.39549388200004],
              [-68.92251542899993, 18.41229889500005],
              [-68.96434485599991, 18.41795482000009],
              [-69.01256262899994, 18.39911530200004],
              [-69.08543860599991, 18.39590078300006],
              [-69.10435950399994, 18.39911530200004],
              [-69.14818274599992, 18.413234768000052],
              [-69.1680395169999, 18.41632721600007],
              [-69.18529212099992, 18.421698309000078],
              [-69.21422278599994, 18.445135809000078],
              [-69.23631751199991, 18.450506903000075],
              [-69.25560462099992, 18.44668203300006],
              [-69.27521725199995, 18.440334377000056],
              [-69.29503333199995, 18.43903229400007],
              [-69.31509355399993, 18.450506903000075],
              [-69.3360082669999, 18.432074286000045],
              [-69.46593176999994, 18.42255280200004],
              [-69.50475012899994, 18.40892161700009],
              [-69.52525794199994, 18.40843333500004],
              [-69.57998613199993, 18.444484768000052],
              [-69.60212154899995, 18.45571523600006],
              [-69.61681067599994, 18.45734284100007],
              [-69.62315833199995, 18.44798411700009],
              [-69.62262936099995, 18.436753648000092],
              [-69.62083899599992, 18.425482489000046],
              [-69.62360592399995, 18.41632721600007],
              [-69.63255774599992, 18.41351959800005],
              [-69.64659583199995, 18.41356028900009],
              [-69.6594945949999, 18.41592031500005],
              [-69.66515051999994, 18.41950104400007],
              [-69.68195553299995, 18.44676341400009],
              [-69.68993079299992, 18.45408763200004],
              [-69.69737708199995, 18.456366278000075],
              [-69.85147050699993, 18.472479559000078],
              [-69.87938391799992, 18.471218166000085],
              [-69.88365637899994, 18.47101471600007],
              [-69.89981035099993, 18.466457424000055],
              [-69.93122311099995, 18.451971747000073],
              [-69.9571020169999, 18.435288804000038],
              [-69.96690833199995, 18.430812893000052],
              [-69.99351966099994, 18.42255280200004],
              [-70.00401770699995, 18.41746653900009],
              [-70.01659094999991, 18.411363023000092],
              [-70.03892981699994, 18.39248281500005],
              [-70.05577551999994, 18.367254950000074],
              [-70.06240800699993, 18.337225653000075],
              [-70.0676977199999, 18.32908763200004],
              [-70.09068762899994, 18.317531643000052],
              [-70.09593665299991, 18.310248114000046],
              [-70.10000566299993, 18.299221096000053],
              [-70.13377844999991, 18.269273179000038],
              [-70.15807044199994, 18.242621161000045],
              [-70.17178300699993, 18.23143138200004],
              [-70.17788652299993, 18.234198309000078],
              [-70.20213782499991, 18.233547268000052],
              [-70.2207738919999, 18.230536200000074],
              [-70.23314368399991, 18.223944403000075],
              [-70.25080318899995, 18.234320380000042],
              [-70.2696020169999, 18.238104559000078],
              [-70.39757239499994, 18.237616278000075],
              [-70.41905676999994, 18.23114655200004],
              [-70.46019446499992, 18.208929755000042],
              [-70.48355058499993, 18.20408763200004],
              [-70.55284583199995, 18.204250393000052],
              [-70.56891842399995, 18.21035390800006],
              [-70.57030188699991, 18.21893952000005],
              [-70.56305904899995, 18.22565338700008],
              [-70.55370032499991, 18.23151276200008],
              [-70.54906165299991, 18.237616278000075],
              [-70.55190995999993, 18.248439846000053],
              [-70.55870520699995, 18.254380601000037],
              [-70.5657445949999, 18.258205471000053],
              [-70.57331295499995, 18.268011786000045],
              [-70.59243730399993, 18.279852606000077],
              [-70.59679114499994, 18.289129950000074],
              [-70.59434973899994, 18.29905833500004],
              [-70.58844967399995, 18.303615627000056],
              [-70.58165442599994, 18.307074286000045],
              [-70.57640540299991, 18.31395091400009],
              [-70.57176673099991, 18.334051825000074],
              [-70.57115637899994, 18.355169989000046],
              [-70.57388261599993, 18.37368398600006],
              [-70.57945716099994, 18.385646877000056],
              [-70.60142981699994, 18.411851304000038],
              [-70.61465410099993, 18.420843817000048],
              [-70.63780676999994, 18.429388739000046],
              [-70.6575414699999, 18.43378327000005],
              [-70.68248450399994, 18.435614325000074],
              [-70.70384680899991, 18.430121161000045],
              [-70.71288001199991, 18.412665106000077],
              [-70.70946204299992, 18.391750393000052],
              [-70.71198482999995, 18.383368231000077],
              [-70.74168860599991, 18.355414130000042],
              [-70.74986731699994, 18.350409247000073],
              [-70.76065019399994, 18.347479559000078],
              [-70.77232825399994, 18.34788646000004],
              [-70.79312089799993, 18.354071356000077],
              [-70.80231686099995, 18.35492584800005],
              [-70.81004798099991, 18.352036851000037],
              [-70.82396399599992, 18.342678127000056],
              [-70.8333227199999, 18.340643622000073],
              [-70.84601803299995, 18.342189846000053],
              [-70.85045325399994, 18.339585679000038],
              [-70.86034094999991, 18.33071523600006],
              [-70.86310787699995, 18.326971747000073],
              [-70.86937415299991, 18.314601955000057],
              [-70.87059485599991, 18.310248114000046],
              [-70.87328040299991, 18.306301174000055],
              [-70.88670813699991, 18.302069403000075],
              [-70.89167232999995, 18.299709377000056],
              [-70.91828365799995, 18.269598700000074],
              [-70.93248450399994, 18.261542059000078],
              [-70.95620683499993, 18.258734442000048],
              [-70.96580969999991, 18.262152411000045],
              [-70.97203528599994, 18.27024974200009],
              [-70.97728430899991, 18.28025950700004],
              [-70.98379472599993, 18.289129950000074],
              [-70.99425208199995, 18.296616929000038],
              [-71.00487219999991, 18.30101146000004],
              [-71.04824785099993, 18.31000397300005],
              [-71.06834876199991, 18.310370184000078],
              [-71.08397376199991, 18.304388739000046],
              [-71.09024003799993, 18.289129950000074],
              [-71.09235592399995, 18.28070709800005],
              [-71.10122636599993, 18.266099351000037],
              [-71.10334225199995, 18.25495026200008],
              [-71.10142981699994, 18.242132880000042],
              [-71.09654700399994, 18.23509349200009],
              [-71.0899145169999, 18.22870514500005],
              [-71.08283443899995, 18.217718817000048],
              [-71.06651770699995, 18.163316148000092],
              [-71.06126868399991, 18.153998114000046],
              [-71.06110592399995, 18.14207591400009],
              [-71.08055579299992, 18.11391836100006],
              [-71.09715735599991, 18.07371653900009],
              [-71.19180253799993, 17.941799221000053],
              [-71.20010331899994, 17.919175523000092],
              [-71.20425370999993, 17.91111888200004],
              [-71.21373450399994, 17.904852606000077],
              [-71.23363196499992, 17.894964911000045],
              [-71.24592037699995, 17.88507721600007],
              [-71.25470943899995, 17.87531159100007],
              [-71.26154537699995, 17.863226630000042],
              [-71.26781165299991, 17.846584377000056],
              [-71.27521725199995, 17.84906647300005],
              [-71.27806555899991, 17.850775458000044],
              [-71.28209387899994, 17.853989976000037],
              [-71.28359941299993, 17.84674713700008],
              [-71.28514563699991, 17.844183661000045],
              [-71.28892981699994, 17.841009833000044],
              [-71.28209387899994, 17.841009833000044],
              [-71.28612219999991, 17.832586981000077],
              [-71.29133053299995, 17.82615794500009],
              [-71.29771887899994, 17.821966864000046],
              [-71.30565344999991, 17.82050202000005],
              [-71.30931555899991, 17.81639232000009],
              [-71.31582597599993, 17.79645416900007],
              [-71.3196508449999, 17.789211330000057],
              [-71.33185787699995, 17.772406317000048],
              [-71.36554928299995, 17.67841217700004],
              [-71.37588456899994, 17.66014232000009],
              [-71.41722571499992, 17.604803778000075],
              [-71.42723548099991, 17.60927969000005],
              [-71.43586178299995, 17.61709219000005],
              [-71.43635006399995, 17.62128327000005],
              [-71.44611568899995, 17.629339911000045],
              [-71.51488196499992, 17.73777903900009],
              [-71.53160559799994, 17.755072333000044],
              [-71.56525631399995, 17.767523505000042],
              [-71.64513098899994, 17.75726959800005],
              [-71.67931067599994, 17.765285549000055],
              [-71.66966712099992, 17.772406317000048],
              [-71.63776607999995, 17.804022528000075],
              [-71.6309301419999, 17.816799221000053],
              [-71.63239498599995, 17.838324286000045],
              [-71.63658606699994, 17.853461005000042],
              [-71.65200761599993, 17.881984768000052],
              [-71.66283118399991, 17.897691148000092],
              [-71.66494706899994, 17.903469143000052],
              [-71.66563880099994, 17.91547272300005],
              [-71.65880286399994, 17.95331452000005],
              [-71.66624915299991, 17.970770575000074],
              [-71.68382727799991, 17.990179755000042],
              [-71.72032630099994, 18.01911041900007],
              [-71.77623450399994, 18.039252020000063],
              [-71.76427119999997, 18.069492493000084],
              [-71.7606538499999, 18.086804097000098],
              [-71.76287593599989, 18.115846253000072],
              [-71.76220414199992, 18.132486064000105],
              [-71.76458125799985, 18.143674011000044],
              [-71.77532995599998, 18.17232859300013],
              [-71.77682857299988, 18.18178538000008],
              [-71.77403804599993, 18.201474101000045],
              [-71.76613155199988, 18.22025848400004],
              [-71.72170877299996, 18.29299623700011],
              [-71.72111173599984, 18.293973823000087],
              [-71.70933915199993, 18.313250224000015],
              [-71.71150956299994, 18.316144105000106],
              [-71.72070796799994, 18.32397308300004],
              [-71.7349706629999, 18.332938945000066],
              [-71.78871415299992, 18.352214254],
              [-71.82643794799986, 18.37616628100001],
              [-71.83455114799995, 18.38508046500003],
              [-71.8497440189999, 18.40644867000013],
              [-71.85816727799988, 18.41355417900006],
              [-71.8971829839999, 18.422881775000107],
              [-71.91216914899985, 18.43073659300005],
              [-71.91816361599987, 18.449236755000058],
              [-71.91439123599986, 18.460217997000044],
              [-71.90689815299993, 18.464300436000045],
              [-71.90157547999988, 18.469778138000052],
              [-71.90405594999996, 18.48479014100012],
              [-71.91051550299991, 18.494272766],
              [-72.00094925999989, 18.58245859800006],
              [-72.0098376059999, 18.598814189],
              [-71.99262935399992, 18.61113901800006],
              [-71.955474, 18.618606262000085],
              [-71.88028479099998, 18.605402934],
              [-71.84157914199997, 18.617986145000103],
              [-71.82855668099992, 18.631292827000024],
              [-71.80798946099995, 18.664649964000077],
              [-71.79434688399994, 18.679171041000032],
              [-71.79177913299992, 18.680681698000072],
              [-71.78489763799988, 18.684730213000122],
              [-71.75807002799988, 18.70051340700003],
              [-71.74406571499989, 18.711442973000104],
              [-71.73207678299991, 18.73007232700006],
              [-71.72525549299988, 18.746970520000062],
              [-71.72034623299993, 18.76544484500009],
              [-71.71884761599992, 18.784229228000086],
              [-71.72690913999992, 18.82352915500006],
              [-71.7279426689999, 18.864069316000084],
              [-71.7334720469999, 18.882569479],
              [-71.74091345299993, 18.89161285400006],
              [-71.76380611199994, 18.911508281000053],
              [-71.77295283999993, 18.921714376000054],
              [-71.78711218299989, 18.950033061000042],
              [-71.79625891099997, 18.957061056000057],
              [-71.81966833499993, 18.957810364000053],
              [-71.84452469899989, 18.949748841000044],
              [-71.86245642199995, 18.947087504000038],
              [-71.86540197799985, 18.964424948000058],
              [-71.84814204899996, 18.97548370400004],
              [-71.79682735199992, 18.988609518000104],
              [-71.78370153799995, 18.996309306000015],
              [-71.74034501199986, 19.041887919000075],
              [-71.71042435699994, 19.081652934000104],
              [-71.69528316199992, 19.094546204],
              [-71.6613834229999, 19.117593893000063],
              [-71.64877437399988, 19.135293071000078],
              [-71.64365840699989, 19.15247548400005],
              [-71.63911088099988, 19.212110088000045],
              [-71.65173271699987, 19.21792388400003],
              [-71.71652217699989, 19.247766825000028],
              [-71.74951707699992, 19.279707723000072],
              [-71.7537292069999, 19.28378529900003],
              [-71.77155757699995, 19.307556457000075],
              [-71.7765185149999, 19.327503561000086],
              [-71.76995560799992, 19.333808085],
              [-71.74298050899998, 19.348380839000058],
              [-71.7334720469999, 19.35546051100009],
              [-71.72081132099996, 19.385949606000068],
              [-71.71528194299995, 19.39165985100003],
              [-71.70386145099985, 19.41463002500008],
              [-71.70318965699997, 19.459278463000103],
              [-71.71512691299992, 19.53746490500005],
              [-71.74308386299992, 19.60007090300006],
              [-71.74768306499996, 19.622782695000026],
              [-71.74604140899993, 19.649017002000036],
              [-71.74504756699994, 19.664898987000058],
              [-71.7486132409999, 19.682598165000073],
              [-71.75743567599994, 19.710109768000052],
            ],
          ],
          [
            [
              [-71.52448482999995, 17.54555898600006],
              [-71.54116777299993, 17.554632880000042],
              [-71.54137122299994, 17.57615794500009],
              [-71.53221594999991, 17.601304429000038],
              [-71.52106686099995, 17.62128327000005],
              [-71.50694739499994, 17.613674221000053],
              [-71.49258378799993, 17.603664455000057],
              [-71.46711178299995, 17.58026764500005],
              [-71.48253333199995, 17.57562897300005],
              [-71.50739498599995, 17.551255601000037],
              [-71.52448482999995, 17.54555898600006],
            ],
          ],
          [
            [
              [-68.66405188699991, 18.16933828300006],
              [-68.61237545499995, 18.170803127000056],
              [-68.59878495999993, 18.16620514500005],
              [-68.58869381399995, 18.15338776200008],
              [-68.57750403599994, 18.133734442000048],
              [-68.57017981699994, 18.115708726000037],
              [-68.57184811099995, 18.107855536000045],
              [-68.58702551999994, 18.111070054000038],
              [-68.61929277299993, 18.125148830000057],
              [-68.63609778599994, 18.12836334800005],
              [-68.65392005099994, 18.126288153000075],
              [-68.6848852199999, 18.116888739000046],
              [-68.70189368399991, 18.11469147300005],
              [-68.73704993399991, 18.123602606000077],
              [-68.76207434799994, 18.14516836100006],
              [-68.77818762899994, 18.172023830000057],
              [-68.78693600199995, 18.19668203300006],
              [-68.77208411399994, 18.200873114000046],
              [-68.75454667899993, 18.197658596000053],
              [-68.73717200399994, 18.189520575000074],
              [-68.72232011599993, 18.17926666900007],
              [-68.71076412699995, 18.17536041900007],
              [-68.66405188699991, 18.16933828300006],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'El Salvador',
        iso3: 'SLV',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-90.09830657513268, 13.731404008980572],
              [-90.11431392499989, 13.796264954000023],
              [-90.11477901199993, 13.81200042800009],
              [-90.11229854299987, 13.828252666000111],
              [-90.10697587099992, 13.844065654000104],
              [-90.09904353899995, 13.85850921600013],
              [-90.0870804439999, 13.870472310000082],
              [-90.05964025899993, 13.884709167000054],
              [-90.0473671069999, 13.894295146000061],
              [-90.03809118699988, 13.908376974000078],
              [-90.0314766029999, 13.922923889000032],
              [-90.02297583099988, 13.936954041000135],
              [-90.00817053299994, 13.949692281000097],
              [-89.91207820699995, 14.015192159],
              [-89.89078751699986, 14.035888570000026],
              [-89.88011633299996, 14.04268402100007],
              [-89.83585546899994, 14.059091289000037],
              [-89.82110184699994, 14.060073141000089],
              [-89.80296341999991, 14.055473938000134],
              [-89.77694433599993, 14.0357852180001],
              [-89.76226822999985, 14.029997457000121],
              [-89.74764379899997, 14.037645569000105],
              [-89.74725622599996, 14.04320078500011],
              [-89.7480100679999, 14.044894904000031],
              [-89.75446508799993, 14.059401347000104],
              [-89.7554469399999, 14.067075297000102],
              [-89.75260473699993, 14.07524017400003],
              [-89.7098683269999, 14.148724060000077],
              [-89.68984370999996, 14.170014750000064],
              [-89.6646256109999, 14.18885081000009],
              [-89.63832230699987, 14.200555522000073],
              [-89.5309386799999, 14.225566915000059],
              [-89.52450496499995, 14.231768087000134],
              [-89.52465999399988, 14.247374369000084],
              [-89.52786393199995, 14.2514568080001],
              [-89.54055049699991, 14.257606303000074],
              [-89.54491715599988, 14.261817932000014],
              [-89.54677750699989, 14.268329163000075],
              [-89.54858618199998, 14.28359954900013],
              [-89.54987809299993, 14.288276265],
              [-89.55569169099991, 14.299024963000122],
              [-89.55858557199991, 14.302823182000054],
              [-89.56437333199997, 14.308145853000099],
              [-89.57127213599995, 14.311143087000104],
              [-89.59217525299994, 14.31383026100005],
              [-89.59835058699991, 14.327989604000095],
              [-89.5924336349999, 14.336387024000075],
              [-89.58240840699997, 14.343363343000064],
              [-89.57607804399996, 14.353130189000112],
              [-89.57897192399994, 14.364783223000089],
              [-89.58628413999992, 14.374679261000082],
              [-89.5905732839999, 14.38597056100005],
              [-89.58406205299991, 14.401809387000057],
              [-89.56987687199987, 14.412015483000118],
              [-89.55517492699997, 14.410826925],
              [-89.54424536199991, 14.400052388000077],
              [-89.54135148099991, 14.381526387000036],
              [-89.52776057999992, 14.391060689000128],
              [-89.50303340699992, 14.420051168000015],
              [-89.49614812999991, 14.42289748400006],
              [-89.48528255199989, 14.427389222000102],
              [-89.46941788699988, 14.425373840000049],
              [-89.4581265869999, 14.419586080000073],
              [-89.44683528699994, 14.415529481000078],
              [-89.43109981299995, 14.418707580000046],
              [-89.40836218299998, 14.441522726000045],
              [-89.39818192599992, 14.445372620000086],
              [-89.39686417699997, 14.426045635000037],
              [-89.39169653399995, 14.43371958500012],
              [-89.39061132899988, 14.43599334800004],
              [-89.36182156232267, 14.41550574579234],
              [-89.36162084999998, 14.415477804000062],
              [-89.34620628999991, 14.413075726000088],
              [-89.30756730199991, 14.407054546000069],
              [-89.27653560499996, 14.392740173000078],
              [-89.22553096599992, 14.382146505],
              [-89.20015783699992, 14.36467987000006],
              [-89.15398494499996, 14.351295675000117],
              [-89.1445023199999, 14.35971893300011],
              [-89.13011043299989, 14.38674570700006],
              [-89.12217810099992, 14.394678040000102],
              [-89.11334143099992, 14.397055156000064],
              [-89.10747615599993, 14.395969951000069],
              [-89.10256689499991, 14.391525777000055],
              [-89.09683081099985, 14.384006856000013],
              [-89.09184403599988, 14.37483429000011],
              [-89.0896736249999, 14.364886577000021],
              [-89.09055212399994, 14.354706320000048],
              [-89.09447953299991, 14.34486195900007],
              [-89.08308487999992, 14.335327657000079],
              [-89.04897843499992, 14.331451925000039],
              [-89.0329845789999, 14.323674622000027],
              [-89.02660253999994, 14.311298117000149],
              [-89.02262345399987, 14.28065399200004],
              [-89.01812760499988, 14.27168813100009],
              [-88.99275447599987, 14.252955424000106],
              [-88.98353023299987, 14.242129211000062],
              [-88.97456437199992, 14.227375590000051],
              [-88.9707919919999, 14.214844056000047],
              [-88.9702284759999, 14.210176262000104],
              [-88.96924169999997, 14.202002462000067],
              [-88.96598608399998, 14.19138295500008],
              [-88.95717525299989, 14.18518178300009],
              [-88.94748592199997, 14.187274679000055],
              [-88.93562618099995, 14.194018453000083],
              [-88.92164770499994, 14.199883728000088],
              [-88.90601558499989, 14.199573670000092],
              [-88.88126257299987, 14.184199931000123],
              [-88.86033361899987, 14.158516744000053],
              [-88.8453216149999, 14.128621928000115],
              [-88.83875870799992, 14.100406596000056],
              [-88.82118872099994, 14.102938741000045],
              [-88.77734126899992, 14.099734802000071],
              [-88.76542985099991, 14.104256490000097],
              [-88.7551204019999, 14.110457662000087],
              [-88.74638708599991, 14.111336162000029],
              [-88.73922989999997, 14.099941508000128],
              [-88.7400567229999, 14.083017477000041],
              [-88.74607702699984, 14.066558533000062],
              [-88.7466454669999, 14.052476705000032],
              [-88.73096166999994, 14.042477316000117],
              [-88.7095159509999, 14.039686788000054],
              [-88.70486507199985, 14.038033142000103],
              [-88.69765620999988, 14.032012838000071],
              [-88.69269527299994, 14.025294902000056],
              [-88.69044734699992, 14.016949157000084],
              [-88.69081175799997, 14.011789871000062],
              [-88.69093827299986, 14.009998678000088],
              [-88.6848146159999, 14.01229827900002],
              [-88.65933813599989, 14.016122335000148],
              [-88.63386165399996, 14.014468689000097],
              [-88.55810400399986, 13.990904236000105],
              [-88.51404984599989, 13.987648621000119],
              [-88.50436051499986, 13.983695374000135],
              [-88.49542049199994, 13.97514292400011],
              [-88.49619563899995, 13.971990662000067],
              [-88.49650569699992, 13.969561870000106],
              [-88.49708534899992, 13.969068092000015],
              [-88.49790096099991, 13.968373311000079],
              [-88.49818257699994, 13.968409755000081],
              [-88.50229345799991, 13.968941752000134],
              [-88.50119810599995, 13.966600438000029],
              [-88.49609228599991, 13.95568674700013],
              [-88.49681575499991, 13.944033712000063],
              [-88.50022639999995, 13.931863912000068],
              [-88.50229345799991, 13.917110291000057],
              [-88.49950293099994, 13.907601827000065],
              [-88.48867671699989, 13.881350200000043],
              [-88.48800492399991, 13.865330506000078],
              [-88.49681575499991, 13.851197002000049],
              [-88.47015071599986, 13.852488912000098],
              [-88.45144384799988, 13.863573507000098],
              [-88.43322790599984, 13.87106659000004],
              [-88.3929461269999, 13.879774068000103],
              [-88.38336014899988, 13.879257304000063],
              [-88.36741796899986, 13.87310780900009],
              [-88.36010575399987, 13.872384338000103],
              [-88.35891719599994, 13.87527821900008],
              [-88.35891719599994, 13.881195170000098],
              [-88.35819372599985, 13.887396343000077],
              [-88.3550673019999, 13.890962016000046],
              [-88.34855607199992, 13.891375427000057],
              [-88.34057206299985, 13.890031840000091],
              [-88.3326138919999, 13.88770640100006],
              [-88.32620601499985, 13.885070903000056],
              [-88.31925553399986, 13.89760243700006],
              [-88.30842932199994, 13.901478170000104],
              [-88.29631119799984, 13.902356669000142],
              [-88.28543330899987, 13.905974019000027],
              [-88.27752681499993, 13.913337911000028],
              [-88.2741707729999, 13.919119724000055],
              [-88.27016292299993, 13.926024475000077],
              [-88.26360001599994, 13.93310414600009],
              [-88.2516369219999, 13.938090922000058],
              [-88.2427744149999, 13.936695658000076],
              [-88.23636653699995, 13.938142599000074],
              [-88.23158646699994, 13.951811015000075],
              [-88.23336930399992, 13.954498190000024],
              [-88.24230932699996, 13.96253387500009],
              [-88.24437638399993, 13.96609954800006],
              [-88.2453582359999, 13.98589162200004],
              [-88.24489314799987, 13.989250591000058],
              [-88.23507462599989, 13.992867941000043],
              [-88.2200626229999, 13.991317647000116],
              [-88.2176588129999, 13.99079670500008],
              [-88.19347509799991, 13.985555725000054],
              [-88.17753291899996, 13.985193990000056],
              [-88.12539139799989, 13.991265971000104],
              [-88.09903641799994, 13.98981903100011],
              [-88.0875384119999, 13.980543112000092],
              [-88.07288814399993, 13.94341359500001],
              [-88.0583929039999, 13.926489563000104],
              [-88.03997025599998, 13.910133972000054],
              [-88.02364050299985, 13.891168722000103],
              [-88.0153205979999, 13.86636403500006],
              [-87.9697419849999, 13.888533223000081],
              [-87.95478165699984, 13.892460633000056],
              [-87.95259489399993, 13.89202903500005],
              [-87.94692683999992, 13.89091033900013],
              [-87.93217321799989, 13.881556905000096],
              [-87.92532609099993, 13.879619039000062],
              [-87.9207527259999, 13.881866963000078],
              [-87.90788529499989, 13.891530457000101],
              [-87.90010799199987, 13.894140117000106],
              [-87.89010860299996, 13.893545837000147],
              [-87.87054907299995, 13.889566752000064],
              [-87.86091141799994, 13.890186870000036],
              [-87.8512220879999, 13.896878968000053],
              [-87.84295385799996, 13.907110901000038],
              [-87.83290279199991, 13.915249939000134],
              [-87.81789078799994, 13.915870057000106],
              [-87.8084598399999, 13.908635356000048],
              [-87.79871883199993, 13.882332051000105],
              [-87.79060563199994, 13.870472310000082],
              [-87.78541215099992, 13.86739756200005],
              [-87.77143367499991, 13.862126567000104],
              [-87.76533585599987, 13.858870952000117],
              [-87.74952872299991, 13.845627388000096],
              [-87.72120418399987, 13.821896464000076],
              [-87.70360835799988, 13.814997661000106],
              [-87.71262589599985, 13.800450745000148],
              [-87.73280554199994, 13.75510467600013],
              [-87.73784399399989, 13.738774923000094],
              [-87.73135860299993, 13.72221262700009],
              [-87.73629370099988, 13.711463929000075],
              [-87.74631892999989, 13.702188009000054],
              [-87.75502640799996, 13.689914857000119],
              [-87.75864375799995, 13.672267355000116],
              [-87.75781693599993, 13.635163676000047],
              [-87.76009069899993, 13.616947734000092],
              [-87.78406856399994, 13.560465394000047],
              [-87.78993383899984, 13.53281850200004],
              [-87.77946936099991, 13.509977519000131],
              [-87.7691599119999, 13.506360168000057],
              [-87.74797257499995, 13.513233135000107],
              [-87.73342565999991, 13.507703756000112],
              [-87.72572587199991, 13.498970439000047],
              [-87.7205840659999, 13.486981507000081],
              [-87.71880122899992, 13.473674825000074],
              [-87.72115250699994, 13.460833232000084],
              [-87.73841243499996, 13.441687113000071],
              [-87.8171687489999, 13.40656159100007],
              [-87.81786048099991, 13.406805731000077],
              [-87.8257136709999, 13.411281643000052],
              [-87.83067786399994, 13.419501044000071],
              [-87.83828691299993, 13.44094472900008],
              [-87.86644446499992, 13.393337307000081],
              [-87.87376868399991, 13.365261135000083],
              [-87.85537675699993, 13.352809963000084],
              [-87.84361731699994, 13.348456122000073],
              [-87.81041419199994, 13.317409572000088],
              [-87.79153398299991, 13.304958401000079],
              [-87.78990637899994, 13.299099026000079],
              [-87.78990637899994, 13.28701406500005],
              [-87.79808508999992, 13.265651760000083],
              [-87.81798255099994, 13.250392971000053],
              [-87.89232337099992, 13.213893947000088],
              [-87.91246497299994, 13.198187567000048],
              [-87.91600501199991, 13.182196356000077],
              [-87.89293372299994, 13.166571356000077],
              [-87.92821204299992, 13.158636786000045],
              [-88.06602942599994, 13.16787344000005],
              [-88.09837805899991, 13.174017645000049],
              [-88.10521399599992, 13.174017645000049],
              [-88.12193762899994, 13.167547919000071],
              [-88.2082820299999, 13.160427151000079],
              [-88.30089270699995, 13.174221096000053],
              [-88.32494055899991, 13.166571356000077],
              [-88.33775794199994, 13.170843817000048],
              [-88.35228430899991, 13.174017645000049],
              [-88.35228430899991, 13.180243231000077],
              [-88.32970130099994, 13.181708075000074],
              [-88.32811438699991, 13.197088934000078],
              [-88.34019934799994, 13.216131903000075],
              [-88.3584285149999, 13.228664455000057],
              [-88.35448157499991, 13.220892645000049],
              [-88.3425593739999, 13.204657294000071],
              [-88.3379207019999, 13.194525458000044],
              [-88.3740535149999, 13.195705471000053],
              [-88.39175370999993, 13.193915106000077],
              [-88.40684973899994, 13.187689520000049],
              [-88.39720618399991, 13.183620510000083],
              [-88.38939368399991, 13.184759833000044],
              [-88.37999426999994, 13.18740469000005],
              [-88.36587480399993, 13.187689520000049],
              [-88.36587480399993, 13.180243231000077],
              [-88.38914954299992, 13.170843817000048],
              [-88.4148249989999, 13.171576239000046],
              [-88.4348445299999, 13.183661200000074],
              [-88.44102942599994, 13.208197333000044],
              [-88.4311824209999, 13.203884182000081],
              [-88.42735755099994, 13.201361395000049],
              [-88.41368567599994, 13.215033270000049],
              [-88.41368567599994, 13.221218166000085],
              [-88.43077551999994, 13.228786526000079],
              [-88.44957434799994, 13.254584052000041],
              [-88.46214758999992, 13.262233791000085],
              [-88.4587703119999, 13.247748114000046],
              [-88.45311438699991, 13.235907294000071],
              [-88.45018469999991, 13.225368557000081],
              [-88.45470130099994, 13.215033270000049],
              [-88.46922766799992, 13.223089911000045],
              [-88.5115046869999, 13.23346588700008],
              [-88.52977454299992, 13.242946682000081],
              [-88.54629472599993, 13.271755276000079],
              [-88.5539851549999, 13.27643463700008],
              [-88.5657039049999, 13.277370510000083],
              [-88.5986628899999, 13.283880927000041],
              [-88.61339270699995, 13.283880927000041],
              [-88.65392005099994, 13.27643463700008],
              [-88.71043860599991, 13.274969794000071],
              [-88.72276770699995, 13.269598700000074],
              [-88.71605383999992, 13.264349677000041],
              [-88.70872962099992, 13.260524807000081],
              [-88.70140540299991, 13.259344794000071],
              [-88.6948542959999, 13.262233791000085],
              [-88.66661536399994, 13.25576406500005],
              [-88.58633378799993, 13.264227606000077],
              [-88.57738196499992, 13.262844143000052],
              [-88.5644832019999, 13.256008205000057],
              [-88.55748450399994, 13.249579169000071],
              [-88.54503333199995, 13.234767971000053],
              [-88.53661048099991, 13.228664455000057],
              [-88.53661048099991, 13.221218166000085],
              [-88.55532792899993, 13.224310614000046],
              [-88.56895911399994, 13.226833401000079],
              [-88.5986628899999, 13.235500393000052],
              [-88.5986628899999, 13.228664455000057],
              [-88.51671301999994, 13.212225653000075],
              [-88.4739070299999, 13.198635158000059],
              [-88.45470130099994, 13.180243231000077],
              [-88.4616999989999, 13.16828034100007],
              [-88.47960364499994, 13.171210028000075],
              [-88.4995417959999, 13.181423244000086],
              [-88.51268469999991, 13.191107489000046],
              [-88.52745520699995, 13.198431708000044],
              [-88.78567460799991, 13.245266018000052],
              [-88.81663977799991, 13.25930410400008],
              [-89.06480872299994, 13.372015692000048],
              [-89.18350175699993, 13.443060614000046],
              [-89.25145423099991, 13.472316799000055],
              [-89.32485917899993, 13.48932526200008],
              [-89.35899817599994, 13.48932526200008],
              [-89.38499915299991, 13.495306708000044],
              [-89.52706672499994, 13.494173340000089],
              [-89.5877900989999, 13.508942124000043],
              [-89.61635256699992, 13.514382675000093],
              [-89.67976587499993, 13.53473242800004],
              [-89.71312760599994, 13.527996506000079],
              [-89.80804823099993, 13.526857633000077],
              [-89.82329652899995, 13.537140191000049],
              [-89.83337667399991, 13.573887876000072],
              [-89.83714758999992, 13.596828518000052],
              [-89.84966205199993, 13.606876111000076],
              [-89.87026259399994, 13.619275773000084],
              [-89.9513182739999, 13.664110063000066],
              [-90.02117074699993, 13.695175041000084],
              [-90.09830657513268, 13.731404008980572],
            ],
          ],
          [
            [
              [-87.72629342699992, 13.198387437000065],
              [-87.72718743999991, 13.211114757000075],
              [-87.71991332599993, 13.21619097200005],
              [-87.70608658799995, 13.211726236000061],
              [-87.6975649709999, 13.193313885000066],
              [-87.69699627599994, 13.178063536000082],
              [-87.69319351199994, 13.167862440000079],
              [-87.70167341099994, 13.163412359000063],
              [-87.71458480599995, 13.167903057000046],
              [-87.72311091099994, 13.164077582000061],
              [-87.72302839899993, 13.174895253000045],
              [-87.72835187999993, 13.185678928000073],
              [-87.72629342699992, 13.198387437000065],
            ],
          ],
          [
            [
              [-87.76578205499993, 13.248011011000074],
              [-87.75793319699994, 13.243557905000046],
              [-87.75138678799993, 13.228924729000084],
              [-87.75726736899992, 13.220651650000036],
              [-87.76380481799993, 13.214287112000079],
              [-87.77689019699994, 13.225736371000039],
              [-87.78016881999991, 13.241643430000067],
              [-87.77428618599993, 13.247372301000041],
              [-87.76578205499993, 13.248011011000074],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Guatemala',
        iso3: 'GTM',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-89.36162084999998, 14.415477804000062],
            [-89.36182156232267, 14.41550574579234],
            [-89.39061132899988, 14.43599334800004],
            [-89.39169653399995, 14.43371958500012],
            [-89.39686417699997, 14.426045635000037],
            [-89.39818192599992, 14.445372620000086],
            [-89.40836218299998, 14.441522726000045],
            [-89.43109981299995, 14.418707580000046],
            [-89.44683528699994, 14.415529481000078],
            [-89.4581265869999, 14.419586080000073],
            [-89.46941788699988, 14.425373840000049],
            [-89.48528255199989, 14.427389222000102],
            [-89.49614812999991, 14.42289748400006],
            [-89.50303340699992, 14.420051168000015],
            [-89.52776057999992, 14.391060689000128],
            [-89.54135148099991, 14.381526387000036],
            [-89.54424536199991, 14.400052388000077],
            [-89.55517492699997, 14.410826925],
            [-89.56987687199987, 14.412015483000118],
            [-89.58406205299991, 14.401809387000057],
            [-89.5905732839999, 14.38597056100005],
            [-89.58628413999992, 14.374679261000082],
            [-89.57897192399994, 14.364783223000089],
            [-89.57607804399996, 14.353130189000112],
            [-89.58240840699997, 14.343363343000064],
            [-89.5924336349999, 14.336387024000075],
            [-89.59835058699991, 14.327989604000095],
            [-89.59217525299994, 14.31383026100005],
            [-89.57127213599995, 14.311143087000104],
            [-89.56437333199997, 14.308145853000099],
            [-89.55858557199991, 14.302823182000054],
            [-89.55569169099991, 14.299024963000122],
            [-89.54987809299993, 14.288276265],
            [-89.54858618199998, 14.28359954900013],
            [-89.54677750699989, 14.268329163000075],
            [-89.54491715599988, 14.261817932000014],
            [-89.54055049699991, 14.257606303000074],
            [-89.52786393199995, 14.2514568080001],
            [-89.52465999399988, 14.247374369000084],
            [-89.52450496499995, 14.231768087000134],
            [-89.5309386799999, 14.225566915000059],
            [-89.63832230699987, 14.200555522000073],
            [-89.6646256109999, 14.18885081000009],
            [-89.68984370999996, 14.170014750000064],
            [-89.7098683269999, 14.148724060000077],
            [-89.75260473699993, 14.07524017400003],
            [-89.7554469399999, 14.067075297000102],
            [-89.75446508799993, 14.059401347000104],
            [-89.7480100679999, 14.044894904000031],
            [-89.74725622599996, 14.04320078500011],
            [-89.74764379899997, 14.037645569000105],
            [-89.76226822999985, 14.029997457000121],
            [-89.77694433599993, 14.0357852180001],
            [-89.80296341999991, 14.055473938000134],
            [-89.82110184699994, 14.060073141000089],
            [-89.83585546899994, 14.059091289000037],
            [-89.88011633299996, 14.04268402100007],
            [-89.89078751699986, 14.035888570000026],
            [-89.91207820699995, 14.015192159],
            [-90.00817053299994, 13.949692281000097],
            [-90.02297583099988, 13.936954041000135],
            [-90.0314766029999, 13.922923889000032],
            [-90.03809118699988, 13.908376974000078],
            [-90.0473671069999, 13.894295146000061],
            [-90.05964025899993, 13.884709167000054],
            [-90.0870804439999, 13.870472310000082],
            [-90.09904353899995, 13.85850921600013],
            [-90.10697587099992, 13.844065654000104],
            [-90.11229854299987, 13.828252666000111],
            [-90.11477901199993, 13.81200042800009],
            [-90.11431392499989, 13.796264954000023],
            [-90.09830657513268, 13.731404008980572],
            [-90.09832812399992, 13.731414130000076],
            [-90.24555320799993, 13.79072571100005],
            [-90.40115945399992, 13.858588018000091],
            [-90.50020878599992, 13.894699659000082],
            [-90.5804128879999, 13.913267343000086],
            [-90.63801879499994, 13.92235803400007],
            [-90.70727773599992, 13.92888858100008],
            [-90.78461482599994, 13.921538447000046],
            [-90.79624657599993, 13.918160508000085],
            [-90.9103332009999, 13.911135082000044],
            [-91.0437404239999, 13.913584837000087],
            [-91.16576087099992, 13.926703192000048],
            [-91.3164612519999, 13.955679359000044],
            [-91.55186926999994, 14.05727773600006],
            [-91.63711503799993, 14.104437567000048],
            [-91.76255767099991, 14.180174112000088],
            [-91.90819251199991, 14.28384023600006],
            [-92.0495906239999, 14.408026434000078],
            [-92.24625650399989, 14.546279476000095],
            [-92.22609716799988, 14.54934560200013],
            [-92.2080620939999, 14.57050710100009],
            [-92.18607377099991, 14.62957326300004],
            [-92.16473140499991, 14.668149720000116],
            [-92.16080399699985, 14.683497620000082],
            [-92.16173417199991, 14.702333679000105],
            [-92.17938167299988, 14.751581320000085],
            [-92.1801051439999, 14.758790182000041],
            [-92.17881323299994, 14.77338877400011],
            [-92.17938167299988, 14.781243591000049],
            [-92.1886575929999, 14.80589324900005],
            [-92.1908280029999, 14.814238993000103],
            [-92.19165482699992, 14.835297140000122],
            [-92.1867972419999, 14.847260233000085],
            [-92.16602331599995, 14.87082468700008],
            [-92.1546803389999, 14.900797018000034],
            [-92.15757421899988, 14.963041280000127],
            [-92.15421525099995, 14.995933329000081],
            [-92.14235550999993, 15.007483012000108],
            [-92.12987565099994, 15.010945333000052],
            [-92.11698238099984, 15.012392274000135],
            [-92.10383072999986, 15.017869975000039],
            [-92.0935987959999, 15.02941965800008],
            [-92.07380672199992, 15.073706360000102],
            [-92.20335953799992, 15.237158915000109],
            [-92.21093013499987, 15.253359477000117],
            [-92.21129187099987, 15.272066345000013],
            [-92.20465144899995, 15.289507141000044],
            [-92.18617712399993, 15.320383810000038],
            [-92.13744624899991, 15.401825866000067],
            [-92.10593123099994, 15.454469062000058],
            [-92.06853572599996, 15.516935120000042],
            [-91.98959997599994, 15.648968404000115],
            [-91.91056087199985, 15.780950013000066],
            [-91.84167618899994, 15.896085103000061],
            [-91.7929711509999, 15.977578837000081],
            [-91.77447098799988, 16.008429667000073],
            [-91.75188838699992, 16.04630849200008],
            [-91.73984777899997, 16.060984599000065],
            [-91.7237764089999, 16.068787740000076],
            [-91.67840450099987, 16.068891093],
            [-91.54048010299991, 16.06914947500009],
            [-91.40260738199993, 16.069304505000034],
            [-91.26478633699989, 16.069511210000073],
            [-91.12691361599994, 16.06976959300006],
            [-90.99479783199988, 16.069868593000066],
            [-90.98898921799986, 16.069872946000075],
            [-90.85111649699991, 16.070131327000055],
            [-90.71329545199984, 16.070338034000102],
            [-90.5754744059999, 16.070596415000082],
            [-90.48573828199991, 16.070699768000097],
            [-90.4661529139999, 16.072921855000104],
            [-90.44819509699988, 16.079259908000054],
            [-90.44784120199992, 16.07968659300009],
            [-90.44416459199991, 16.084652405],
            [-90.43742081699989, 16.098863424000044],
            [-90.4344752609999, 16.107183330000012],
            [-90.44021134499985, 16.104857890000076],
            [-90.44274348999994, 16.104186096000106],
            [-90.44452632699992, 16.103255920000052],
            [-90.4481436769999, 16.0997419240001],
            [-90.45558508399992, 16.0997419240001],
            [-90.45948665399987, 16.11679514600003],
            [-90.43530208399991, 16.136277161000024],
            [-90.4481436769999, 16.148214417000062],
            [-90.4481436769999, 16.15441558900004],
            [-90.42612951699991, 16.163148906000018],
            [-90.43271826199992, 16.173225810000062],
            [-90.46181209399992, 16.18914215100007],
            [-90.46558447299995, 16.20810740200004],
            [-90.45850480199991, 16.22174998000004],
            [-90.44623164899988, 16.230845032],
            [-90.4344752609999, 16.236322734000098],
            [-90.44798864799986, 16.241490377],
            [-90.45783300899984, 16.24913848900009],
            [-90.45943497799996, 16.259060364000064],
            [-90.4481436769999, 16.27110097300006],
            [-90.4437253429999, 16.266863505000103],
            [-90.44062475599986, 16.265313212000066],
            [-90.42767980999994, 16.263607890000017],
            [-90.43142635099986, 16.26893056300007],
            [-90.4375241699999, 16.280040996000068],
            [-90.44129654999995, 16.285363668000016],
            [-90.43674902399991, 16.284846904000077],
            [-90.43550878899987, 16.286242168000072],
            [-90.43550878899987, 16.288774312000058],
            [-90.4344752609999, 16.291564840000106],
            [-90.42855830999989, 16.28763743100005],
            [-90.42023840399992, 16.285363668000016],
            [-90.41406306999994, 16.287844137],
            [-90.41401139299992, 16.298386129000065],
            [-90.42018672799992, 16.296009013000017],
            [-90.43473364299987, 16.301228333000026],
            [-90.4448880619999, 16.308359680000066],
            [-90.43788590499992, 16.312080383000094],
            [-90.4194632569999, 16.317816467000043],
            [-90.4046837979999, 16.33151072200006],
            [-90.39879268399989, 16.347582092000025],
            [-90.40719010499987, 16.360449524000032],
            [-90.41401139299992, 16.360449524000032],
            [-90.41401139299992, 16.353008118],
            [-90.42080684399988, 16.353008118],
            [-90.41822302299997, 16.36716746100005],
            [-90.4087403979999, 16.372335103000054],
            [-90.39512365699989, 16.371404927000086],
            [-90.37985327199993, 16.367270813000076],
            [-90.39137711699988, 16.385977681000057],
            [-90.39269486499984, 16.391713766000024],
            [-90.3929015709999, 16.404839580000086],
            [-90.39491695199985, 16.419205627000096],
            [-90.40060135999988, 16.420549215000065],
            [-90.4094638679999, 16.41667348300011],
            [-90.42080684399988, 16.415123190000074],
            [-90.42669795799989, 16.417707011000076],
            [-90.43411352599989, 16.42240956600007],
            [-90.44437129799988, 16.426802063000068],
            [-90.47584224499994, 16.43072947200004],
            [-90.47842606699993, 16.436413879000057],
            [-90.47708247899996, 16.44499216700008],
            [-90.48230179899988, 16.45605092400011],
            [-90.48821875099989, 16.461580302000087],
            [-90.49775305299988, 16.46803985600006],
            [-90.50891516199991, 16.47108876500009],
            [-90.53289302599993, 16.459926656000064],
            [-90.5390683599999, 16.468866679000072],
            [-90.54371923899987, 16.49020904500007],
            [-90.5534085699999, 16.490260722000087],
            [-90.57935013899996, 16.482767639000073],
            [-90.58472448799992, 16.48023549500006],
            [-90.59061560099991, 16.483387757000045],
            [-90.60467159099994, 16.486178284000076],
            [-90.6207429619999, 16.48674672500003],
            [-90.63309362799995, 16.483336080000115],
            [-90.62787430799995, 16.492896220000105],
            [-90.61898596199993, 16.500079244000077],
            [-90.61206131999984, 16.507624003000032],
            [-90.61262976099991, 16.518114319000077],
            [-90.62415360499992, 16.52493560800012],
            [-90.6395015059999, 16.52586578400006],
            [-90.64818314699994, 16.52958648700009],
            [-90.63996659299991, 16.544831034000126],
            [-90.64353226799989, 16.56100575800012],
            [-90.63702103799992, 16.577903952000028],
            [-90.63376542199984, 16.59216664600008],
            [-90.64735632399993, 16.60007314000005],
            [-90.65025020399992, 16.59340688100012],
            [-90.65360917199993, 16.590099590000122],
            [-90.65882849199994, 16.58844594300008],
            [-90.66720007399991, 16.586999003000088],
            [-90.66720007399991, 16.593200175000064],
            [-90.65402258299994, 16.61660959900003],
            [-90.66771683799996, 16.6525763960001],
            [-90.73530961099993, 16.74657582600004],
            [-90.74977901199986, 16.757686259000067],
            [-90.78559077999998, 16.77499786400007],
            [-90.80037023999989, 16.786831767000066],
            [-90.79695959599988, 16.79866567000009],
            [-90.79695959599988, 16.805435283000023],
            [-90.81060217299998, 16.812928365000076],
            [-90.81995560699991, 16.805331930000094],
            [-90.83173783399994, 16.805435283000023],
            [-90.90062251899994, 16.826002503000026],
            [-90.91907100399996, 16.836337789000126],
            [-90.94816483599996, 16.864708150000027],
            [-90.96888708599988, 16.87437164300006],
            [-90.95276403799991, 16.89090810200007],
            [-90.95519283099986, 16.898762919000077],
            [-90.96883540899998, 16.901036682000026],
            [-90.98625036699991, 16.901088359000127],
            [-90.98795568899988, 16.896902568000073],
            [-90.98428666299989, 16.887755840000082],
            [-90.98325313399991, 16.878609110000113],
            [-90.99307165599996, 16.87437164300006],
            [-90.9983426519999, 16.87716217000012],
            [-91.0109000249999, 16.890287984000096],
            [-91.01668778499987, 16.89483551100004],
            [-91.05492834599997, 16.908013],
            [-91.0668656009999, 16.918193258000073],
            [-91.07130977499992, 16.938915507],
            [-91.07694250499995, 16.949509176000063],
            [-91.11223750899984, 16.990488587000115],
            [-91.11611324099991, 16.999273580000093],
            [-91.12122920799987, 17.018393860000103],
            [-91.12655187999994, 17.02459503200008],
            [-91.13714554899991, 17.0265070600001],
            [-91.16122676599986, 17.02397491500001],
            [-91.17120031799996, 17.02800567700011],
            [-91.20675370399991, 17.065367737000045],
            [-91.21595210799993, 17.079217021000105],
            [-91.22024125199988, 17.089293925000064],
            [-91.22535721899987, 17.107018942000067],
            [-91.22959468599993, 17.113995260000067],
            [-91.23879309099993, 17.119214579000086],
            [-91.25920528199987, 17.12433054700007],
            [-91.26313269099984, 17.130738424000114],
            [-91.2651480719999, 17.146241354000026],
            [-91.27083247999994, 17.164276428000036],
            [-91.2795141199999, 17.18008941600003],
            [-91.29041784699987, 17.189081116000082],
            [-91.31775467999998, 17.19047638000005],
            [-91.34452307199987, 17.18634226500002],
            [-91.36488358599988, 17.189752910000053],
            [-91.37294510899997, 17.21357574500003],
            [-91.38834468599995, 17.22158559200001],
            [-91.41924719299996, 17.227735087000084],
            [-91.44250158699987, 17.237967020000056],
            [-91.43826411999993, 17.253676657000128],
            [-91.43077103699989, 17.254968567000063],
            [-90.99198644999987, 17.251919658000034],
            [-90.99144384799993, 17.52694163050002],
            [-90.99090124599988, 17.801963603],
            [-90.98283972199988, 17.810541890000124],
            [-90.96222082599988, 17.81601959300012],
            [-90.91912268099986, 17.81601959300012],
            [-90.69923946199992, 17.815812887000064],
            [-90.47945959499992, 17.815606181000092],
            [-90.25965389099989, 17.815347799000037],
            [-90.03977067099993, 17.815141093000065],
            [-89.82001664299995, 17.814986064000024],
            [-89.60015926199989, 17.814727681000065],
            [-89.38030188099987, 17.814520976000026],
            [-89.16049617499993, 17.814314270000054],
            [-89.15621739539208, 17.59824334848561],
            [-89.15072787410207, 17.32103207973212],
            [-89.1492048451793, 17.036270806333576],
            [-89.16606739756634, 16.777009063383176],
            [-89.1843527061227, 16.49587244432975],
            [-89.19313967135847, 16.392625602808764],
            [-89.2085168605212, 16.186131919766652],
            [-89.23413509199995, 15.954944560000044],
            [-89.23602227599986, 15.90649316800004],
            [-89.23651220799991, 15.89391469300007],
            [-89.22824397799985, 15.88084055600011],
            [-89.22599605399992, 15.884044495000083],
            [-89.21653926699986, 15.888643697000035],
            [-89.20483455399989, 15.89241607700005],
            [-89.19576533999992, 15.892932841000103],
            [-89.17744604499984, 15.900270894000087],
            [-89.10091324899994, 15.896808574000048],
            [-89.07238785899989, 15.901511129000127],
            [-89.04032263199989, 15.901717834000081],
            [-88.95187841899985, 15.879651999000075],
            [-88.91397050699996, 15.893947658000044],
            [-88.90001380099994, 15.887844143000052],
            [-88.86620032499991, 15.86033763200004],
            [-88.83161373599995, 15.868638414000088],
            [-88.78734290299991, 15.859076239000046],
            [-88.75328528599994, 15.839789130000042],
            [-88.74950110599991, 15.818793036000045],
            [-88.72679602799991, 15.81517161700009],
            [-88.62596594999991, 15.75389232000009],
            [-88.63829505099994, 15.708807684000078],
            [-88.63621985599991, 15.702093817000048],
            [-88.60924231699994, 15.702093817000048],
            [-88.59837805899991, 15.70612213700008],
            [-88.59520423099991, 15.714667059000078],
            [-88.59634355399993, 15.722154039000088],
            [-88.59870357999995, 15.723211981000077],
            [-88.59898841099994, 15.727362372000073],
            [-88.6023656889999, 15.730902411000045],
            [-88.60558020699995, 15.735541083000044],
            [-88.60545813699991, 15.743068752000056],
            [-88.60045325399994, 15.744574286000045],
            [-88.59117591099994, 15.743557033000059],
            [-88.58218339799993, 15.745021877000056],
            [-88.5781957669999, 15.75389232000009],
            [-88.57433020699995, 15.769964911000045],
            [-88.56550045499995, 15.780951239000046],
            [-88.55606035099993, 15.789496161000045],
            [-88.55028235599991, 15.79828522300005],
            [-88.54906165299991, 15.813666083000044],
            [-88.5567113919999, 15.83734772300005],
            [-88.55768795499995, 15.852932033000059],
            [-88.55028235599991, 15.852932033000059],
            [-88.55064856699994, 15.842474677000041],
            [-88.55028235599991, 15.839260158000059],
            [-88.54405676999994, 15.839260158000059],
            [-88.53213456899994, 15.846828518000052],
            [-88.50304114499994, 15.841376044000071],
            [-88.48884029899995, 15.84674713700008],
            [-88.51195227799991, 15.867580471000053],
            [-88.52481035099993, 15.877020575000074],
            [-88.54328365799995, 15.885158596000053],
            [-88.55101477799991, 15.89516836100006],
            [-88.55768795499995, 15.90656159100007],
            [-88.5645238919999, 15.914984442000048],
            [-88.60757402299993, 15.938421942000048],
            [-88.61986243399991, 15.953273830000057],
            [-88.60545813699991, 15.969631252000056],
            [-88.59019934799994, 15.961004950000074],
            [-88.5618383449999, 15.949042059000078],
            [-88.55028235599991, 15.942328192000048],
            [-88.52122962099992, 15.91274648600006],
            [-88.50023352799991, 15.901068427000041],
            [-88.44790605399993, 15.858710028000075],
            [-88.34483801999994, 15.81195709800005],
            [-88.31102454299992, 15.782416083000044],
            [-88.30040442599994, 15.777818101000037],
            [-88.25633704299992, 15.740383205000057],
            [-88.22154700399994, 15.725897528000075],
            [-88.22093665299991, 15.72565338700008],
            [-88.23261999599993, 15.721418762],
            [-88.23574641999997, 15.71242706300005],
            [-88.23491959699996, 15.701575013000095],
            [-88.24158585599986, 15.68824249300009],
            [-88.24776119099994, 15.695683899000088],
            [-88.26499527999994, 15.688604228000074],
            [-88.27969722499992, 15.680749410000047],
            [-88.29558772899995, 15.675013326000098],
            [-88.31667171299995, 15.67459991400007],
            [-88.32230444399991, 15.667261861000085],
            [-88.35256099499992, 15.6169031780001],
            [-88.39899226999992, 15.572797343000033],
            [-88.46743393599988, 15.520739666000068],
            [-88.50001969399997, 15.49590281200004],
            [-88.58737870299993, 15.430299581],
            [-88.6741951089999, 15.365058086000076],
            [-88.76089940199995, 15.29996181400007],
            [-88.84702693699987, 15.235298564000104],
            [-88.97342749099991, 15.140394796000123],
            [-89.0082832439999, 15.124400940000086],
            [-89.10982743399987, 15.09145721400003],
            [-89.1405232349999, 15.076393534000132],
            [-89.14694031899992, 15.071284391000077],
            [-89.16080623499991, 15.060244649000055],
            [-89.17276932899998, 15.042209575000058],
            [-89.18858231699997, 14.996088359000026],
            [-89.16910030099987, 14.97841501900011],
            [-89.16915197799989, 14.952060038000056],
            [-89.18152848299985, 14.923663839000127],
            [-89.18921495599992, 14.913059034000113],
            [-89.19881424999994, 14.899815165000064],
            [-89.2236189379999, 14.879015401000103],
            [-89.23144791699991, 14.867310690000124],
            [-89.23242976899988, 14.848500468000026],
            [-89.22767553799989, 14.83457367000004],
            [-89.21896805899993, 14.821680400000034],
            [-89.19881424999994, 14.798090108000025],
            [-89.1894091399999, 14.783000590000114],
            [-89.17054724099995, 14.738791403000107],
            [-89.15966935299991, 14.725122986000088],
            [-89.15052262499992, 14.717294007000064],
            [-89.14621323399987, 14.710857664000073],
            [-89.1445023199999, 14.708302308000029],
            [-89.1426936449999, 14.691274923],
            [-89.1452257899999, 14.683445943000066],
            [-89.15584529599997, 14.672257995000038],
            [-89.15941097099994, 14.665979309000122],
            [-89.15522517999992, 14.615594788000038],
            [-89.15574194399994, 14.59784393400011],
            [-89.16039282299991, 14.581281637000103],
            [-89.17214921099992, 14.570403747000057],
            [-89.18369889399995, 14.56952524800002],
            [-89.20881363999987, 14.577948507000102],
            [-89.22108679199991, 14.580093079000093],
            [-89.23811417699991, 14.577948507000102],
            [-89.24568477499989, 14.572987570000066],
            [-89.2505423589999, 14.565184428000038],
            [-89.25961157199987, 14.554254862000064],
            [-89.29092748999997, 14.528003235000128],
            [-89.30485428899996, 14.513352966000056],
            [-89.31480200199988, 14.495963847000041],
            [-89.32304439299992, 14.487463074000118],
            [-89.34526525899994, 14.481959534000026],
            [-89.35549719299993, 14.475448303000064],
            [-89.36198258499988, 14.462400004000102],
            [-89.36379125999989, 14.44656117800011],
            [-89.36162084999998, 14.415477804000062],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'USNB Guantanamo Bay',
        iso3: '-99',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-75.0950058107462, 19.897225962598796],
              [-75.10766111999993, 19.89759226600006],
              [-75.13742489299995, 19.892553732000067],
              [-75.16191957099994, 19.891142236000064],
              [-75.16529607899992, 19.897012390000043],
              [-75.16437767299993, 19.91371929400009],
              [-75.15766315899992, 19.91870416000006],
              [-75.14647376199991, 19.92340729400007],
              [-75.12263792099992, 19.94046066100009],
              [-75.11784056199991, 19.944083637000062],
              [-75.10438848599995, 19.94275725300008],
              [-75.10104154399994, 19.953149818000043],
              [-75.10460215699993, 19.959358803000043],
              [-75.11675834999994, 19.967054234000045],
              [-75.12986191999994, 19.95561256600007],
              [-75.13380559799992, 19.958074399000054],
              [-75.13963782499991, 19.964992580000057],
              [-75.13703578043308, 19.971550610171906],
              [-75.09495029099989, 19.97158369],
              [-75.0950058107462, 19.897225962598796],
            ],
          ],
          [
            [
              [-75.1601924439999, 19.970647995000036],
              [-75.16835286299994, 19.96656475000009],
              [-75.17121374499993, 19.957523997000067],
              [-75.1634008449999, 19.950384833000044],
              [-75.15673335199995, 19.938899725000056],
              [-75.17218990799995, 19.93577708500004],
              [-75.1839551079999, 19.933594164000056],
              [-75.19312655199991, 19.92709508100006],
              [-75.1960359599999, 19.921910470000057],
              [-75.20164463599991, 19.922855345000073],
              [-75.2033880589999, 19.928351262000092],
              [-75.20895147699991, 19.92924750600008],
              [-75.21450075799993, 19.926281117000087],
              [-75.21810998199993, 19.924005652000062],
              [-75.21785885299994, 19.919459095000036],
              [-75.20575085199994, 19.911534998000036],
              [-75.19221400399994, 19.909969251000064],
              [-75.19100218099993, 19.906316795000066],
              [-75.20749327899995, 19.90577661000009],
              [-75.23106848899994, 19.900458075000074],
              [-75.23285885299993, 19.900051174000055],
              [-75.22896927899987, 19.937440491000118],
              [-75.17886206299988, 19.97073179300004],
              [-75.1601924439999, 19.970647995000036],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cuba',
        iso3: 'CUB',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-75.0950058107462, 19.897225962598796],
              [-75.09495029099989, 19.97158369],
              [-75.13703578043308, 19.971550610171906],
              [-75.13515971499993, 19.976278928000056],
              [-75.12975012899994, 19.98114655200004],
              [-75.11505226199995, 19.990617325000073],
              [-75.10207692599994, 19.99290049800004],
              [-75.09013265199991, 20.014136874000087],
              [-75.08485710999992, 20.025895131000084],
              [-75.09080969999991, 20.03546784100007],
              [-75.09243730399993, 20.06122467700004],
              [-75.11279121399991, 20.057484937000083],
              [-75.1223807319999, 20.043912247000037],
              [-75.12860947599995, 20.033508485000084],
              [-75.1357947429999, 20.02129578000006],
              [-75.1438117859999, 20.02594842500008],
              [-75.15433299299991, 20.03116577700007],
              [-75.16942545099994, 20.025576828000055],
              [-75.17544511599993, 20.013739325000074],
              [-75.17735755099994, 20.003973700000074],
              [-75.17406165299991, 19.993475653000075],
              [-75.1686802399999, 19.991935841000043],
              [-75.16211192199995, 19.990411082000037],
              [-75.15807044199994, 19.991359768000052],
              [-75.15542558499993, 19.994940497000073],
              [-75.15330969999991, 19.999172268000052],
              [-75.15123450399994, 19.994574286000045],
              [-75.14699664599993, 19.984277612000085],
              [-75.15912652399993, 19.97776874200008],
              [-75.1601924439999, 19.970647995000036],
              [-75.17886206299988, 19.97073179300004],
              [-75.22896927899987, 19.937440491000118],
              [-75.23285885299993, 19.900051174000055],
              [-75.28465735599991, 19.88825104400007],
              [-75.38329016799992, 19.882473049000055],
              [-75.39427649599992, 19.88349030200004],
              [-75.42760169199994, 19.890692450000074],
              [-75.43748938699991, 19.895656643000052],
              [-75.44440670499995, 19.89671458500004],
              [-75.4473363919999, 19.89476146000004],
              [-75.45563717399995, 19.88548411700009],
              [-75.46182206899994, 19.882473049000055],
              [-75.48888098899994, 19.87909577000005],
              [-75.52090410099993, 19.87962474200009],
              [-75.5508520169999, 19.885158596000053],
              [-75.57164466099994, 19.89671458500004],
              [-75.60472571499992, 19.89203522300005],
              [-75.64561926999994, 19.912583726000037],
              [-75.68700110599991, 19.940375067000048],
              [-75.72183183499993, 19.957505601000037],
              [-75.74372311099995, 19.959865627000056],
              [-75.81529700399994, 19.957505601000037],
              [-75.83433997299994, 19.959784247000073],
              [-75.87336178299995, 19.969549872000073],
              [-75.89378821499992, 19.971828518000052],
              [-75.93211829299992, 19.967678127000056],
              [-75.95221920499995, 19.962225653000075],
              [-75.96548417899993, 19.954413153000075],
              [-75.98009192599994, 19.952378648000035],
              [-76.11204993399991, 19.982489325000074],
              [-76.20225989499994, 19.992336330000057],
              [-76.24815833199995, 19.990627346000053],
              [-76.32799231699994, 19.97016022300005],
              [-76.36611894399994, 19.964992580000057],
              [-76.43871008999992, 19.964992580000057],
              [-76.4602758449999, 19.962103583000044],
              [-76.50226803299995, 19.948391018000052],
              [-76.52440344999991, 19.943915106000077],
              [-76.65160071499992, 19.951117255000042],
              [-76.78107662699995, 19.940741278000075],
              [-76.80174719999991, 19.93073151200008],
              [-76.82359778599994, 19.931586005000042],
              [-76.84561113199993, 19.93626536700009],
              [-76.86644446499992, 19.93768952000005],
              [-76.88182532499991, 19.931382554000038],
              [-76.9141332669999, 19.906642971000053],
              [-76.93529212099992, 19.89671458500004],
              [-76.95889238199993, 19.891058661000045],
              [-77.08804277299993, 19.88544342700004],
              [-77.11343339799993, 19.88930898600006],
              [-77.1634008449999, 19.90810781500005],
              [-77.18895423099991, 19.912583726000037],
              [-77.20278886599993, 19.902899481000077],
              [-77.20962480399993, 19.902899481000077],
              [-77.21711178299995, 19.90961334800005],
              [-77.22728430899991, 19.911078192000048],
              [-77.23717200399994, 19.90688711100006],
              [-77.24376380099994, 19.89671458500004],
              [-77.26915442599994, 19.90452708500004],
              [-77.29824785099993, 19.906683661000045],
              [-77.32408606699994, 19.90029531500005],
              [-77.33999589799993, 19.882473049000055],
              [-77.31273352799991, 19.882473049000055],
              [-77.31273352799991, 19.87563711100006],
              [-77.33047441299993, 19.874823309000078],
              [-77.35850989499994, 19.864488023000035],
              [-77.37726803299995, 19.86196523600006],
              [-77.46996008999992, 19.85956452000005],
              [-77.53335527299993, 19.844916083000044],
              [-77.56932532499991, 19.841498114000046],
              [-77.61148027299993, 19.844631252000056],
              [-77.67324785099993, 19.828924872000073],
              [-77.69253495999993, 19.827826239000046],
              [-77.70604407499991, 19.830023505000042],
              [-77.71955318899995, 19.835882880000042],
              [-77.73058020699995, 19.84479401200008],
              [-77.73721269399994, 19.85569896000004],
              [-77.73599199099993, 19.874172268000052],
              [-77.71735592399995, 19.90721263200004],
              [-77.71617591099994, 19.916571356000077],
              [-77.70881100199995, 19.91868724200009],
              [-77.69611568899995, 19.919989325000074],
              [-77.68883216099994, 19.92340729400007],
              [-77.68211829299992, 19.92959219000005],
              [-77.67528235599991, 19.939886786000045],
              [-77.66832434799994, 19.943915106000077],
              [-77.67137610599991, 19.954779364000046],
              [-77.66673743399991, 19.96246979400007],
              [-77.64785722599993, 19.978664455000057],
              [-77.62555904899995, 20.00779857000009],
              [-77.62393144399994, 20.01276276200008],
              [-77.6204320949999, 20.020331122000073],
              [-77.57274329299992, 20.061102606000077],
              [-77.57469641799992, 20.06981028900009],
              [-77.58812415299991, 20.082464911000045],
              [-77.58641516799992, 20.08852773600006],
              [-77.57738196499992, 20.087958075000074],
              [-77.55101477799991, 20.079779364000046],
              [-77.5410863919999, 20.088771877000056],
              [-77.52188066299993, 20.094549872000073],
              [-77.51748613199993, 20.098456122000073],
              [-77.51471920499995, 20.104437567000048],
              [-77.49697831899994, 20.129461981000077],
              [-77.47956295499995, 20.14085521000004],
              [-77.43663489499994, 20.16242096600007],
              [-77.42023678299995, 20.18504466400009],
              [-77.40135657499991, 20.198065497000073],
              [-77.30064856699994, 20.242743231000077],
              [-77.28136145699995, 20.24555084800005],
              [-77.26646887899994, 20.253241278000075],
              [-77.25072180899991, 20.28929271000004],
              [-77.23631751199991, 20.30076732000009],
              [-77.23338782499991, 20.301214911000045],
              [-77.22984778599994, 20.301336981000077],
              [-77.22329667899993, 20.30076732000009],
              [-77.22899329299992, 20.289129950000074],
              [-77.22297115799995, 20.28339264500005],
              [-77.21007239499994, 20.282863674000055],
              [-77.19542395699995, 20.28652578300006],
              [-77.18175208199995, 20.294867255000042],
              [-77.1712133449999, 20.30727773600006],
              [-77.16429602799991, 20.32217031500005],
              [-77.16185462099992, 20.338324286000045],
              [-77.15453040299991, 20.34406159100007],
              [-77.11343339799993, 20.368475653000075],
              [-77.11025956899994, 20.416408596000053],
              [-77.10350501199991, 20.423651434000078],
              [-77.09581458199995, 20.430161851000037],
              [-77.08242753799993, 20.465277411000045],
              [-77.11343339799993, 20.51243724200009],
              [-77.12319902299993, 20.52094147300005],
              [-77.15013587099992, 20.537909247000073],
              [-77.18594316299993, 20.550930080000057],
              [-77.19566809799994, 20.55215078300006],
              [-77.18919837099992, 20.540961005000042],
              [-77.19542395699995, 20.534125067000048],
              [-77.21401933499993, 20.546210028000075],
              [-77.22948157499991, 20.55292389500005],
              [-77.23989824099993, 20.563055731000077],
              [-77.24376380099994, 20.58535390800006],
              [-77.24038652299993, 20.59210846600007],
              [-77.2324926419999, 20.59601471600007],
              [-77.22337805899991, 20.598822333000044],
              [-77.21646074099993, 20.602443752000056],
              [-77.19542395699995, 20.629787502000056],
              [-77.19542395699995, 20.636542059000078],
              [-77.23167883999992, 20.658270575000074],
              [-77.25104732999995, 20.66209544500009],
              [-77.25804602799991, 20.643377997000073],
              [-77.27818762899994, 20.662054755000042],
              [-77.29515540299991, 20.68707916900007],
              [-77.31484941299993, 20.709051825000074],
              [-77.34312903599994, 20.718491929000038],
              [-77.37173417899993, 20.716131903000075],
              [-77.40318762899994, 20.70917389500005],
              [-77.42935136599993, 20.698431708000044],
              [-77.44237219999991, 20.684393622000073],
              [-77.45189368399991, 20.690008856000077],
              [-77.45767167899993, 20.689886786000045],
              [-77.46271725199995, 20.68699778900009],
              [-77.46971594999991, 20.684393622000073],
              [-77.48029537699995, 20.681789455000057],
              [-77.48672441299993, 20.67918528900009],
              [-77.49339758999992, 20.677476304000038],
              [-77.50450598899994, 20.677557684000078],
              [-77.52196204299992, 20.68032461100006],
              [-77.57274329299992, 20.69798411700009],
              [-77.61164303299995, 20.67845286700009],
              [-77.62051347599993, 20.677557684000078],
              [-77.63499915299991, 20.687933661000045],
              [-77.64171301999994, 20.691148179000038],
              [-77.64928137899994, 20.692572333000044],
              [-77.67886308499993, 20.691148179000038],
              [-77.68667558499993, 20.69204336100006],
              [-77.70612545499995, 20.697414455000057],
              [-77.71271725199995, 20.701117255000042],
              [-77.71642005099994, 20.698879299000055],
              [-77.72931881399995, 20.69798411700009],
              [-77.77843176999994, 20.70075104400007],
              [-77.79556230399993, 20.705877997000073],
              [-77.82213294199994, 20.723049221000053],
              [-77.84080969999991, 20.728257554000038],
              [-77.87751217399995, 20.732163804000038],
              [-77.89924068899995, 20.72728099200009],
              [-77.91417395699995, 20.71637604400007],
              [-77.92686926999994, 20.704901434000078],
              [-77.94204667899993, 20.69798411700009],
              [-78.00706946499992, 20.696193752000056],
              [-78.04112708199995, 20.70449453300006],
              [-78.05190995999993, 20.72597890800006],
              [-78.05939693899995, 20.72597890800006],
              [-78.06554114499994, 20.71165599200009],
              [-78.09837805899991, 20.748114325000074],
              [-78.11025956899994, 20.753241278000075],
              [-78.13206946499992, 20.75739166900007],
              [-78.14411373599995, 20.76825592700004],
              [-78.16177324099993, 20.800441799000055],
              [-78.17235266799992, 20.811753648000035],
              [-78.19078528599994, 20.82762278900009],
              [-78.21104895699995, 20.839504299000055],
              [-78.22691809799994, 20.83893463700008],
              [-78.23766028599994, 20.83340078300006],
              [-78.24128170499995, 20.83852773600006],
              [-78.24185136599993, 20.84788646000004],
              [-78.24372311099995, 20.85504791900007],
              [-78.25572669199994, 20.86863841400009],
              [-78.26207434799994, 20.878159898000035],
              [-78.26480058499993, 20.886664130000042],
              [-78.27204342399995, 20.90110911700009],
              [-78.34268144399994, 20.94940827000005],
              [-78.35635331899994, 20.95302969000005],
              [-78.39146887899994, 20.951239325000074],
              [-78.40392005099994, 20.957953192000048],
              [-78.41502844999991, 20.973089911000045],
              [-78.42992102799991, 20.999701239000046],
              [-78.44225012899994, 21.01113515800006],
              [-78.47899329299992, 21.037583726000037],
              [-78.48790442599994, 21.03856028900009],
              [-78.49474036399994, 21.04791901200008],
              [-78.50088456899994, 21.082098700000074],
              [-78.50438391799992, 21.14712148600006],
              [-78.51227779899995, 21.175116278000075],
              [-78.52757727799991, 21.203273830000057],
              [-78.53819739499994, 21.231634833000044],
              [-78.53172766799992, 21.26040273600006],
              [-78.52257239499994, 21.25031159100007],
              [-78.51146399599992, 21.248846747000073],
              [-78.50210527299993, 21.255560614000046],
              [-78.49819902299993, 21.269964911000045],
              [-78.50552324099993, 21.280218817000048],
              [-78.53799394399994, 21.290350653000075],
              [-78.54539954299992, 21.29759349200009],
              [-78.54747473899994, 21.31509023600006],
              [-78.55687415299991, 21.347479559000078],
              [-78.55899003799993, 21.366522528000075],
              [-78.56330318899995, 21.38344961100006],
              [-78.5821020169999, 21.413885809000078],
              [-78.58633378799993, 21.428208726000037],
              [-78.59243730399993, 21.461818752000056],
              [-78.60781816299993, 21.49371979400007],
              [-78.62816321499992, 21.52106354400007],
              [-78.64903723899994, 21.54092031500005],
              [-78.6653539699999, 21.551174221000053],
              [-78.6809789699999, 21.55662669500009],
              [-78.73399817599994, 21.56435781500005],
              [-78.74632727799991, 21.568060614000046],
              [-78.75108801999994, 21.575506903000075],
              [-78.74461829299992, 21.58930084800005],
              [-78.73330644399994, 21.583238023000035],
              [-78.72061113199993, 21.581244208000044],
              [-78.69310462099992, 21.581854559000078],
              [-78.68911699099993, 21.586411851000037],
              [-78.69420325399994, 21.59666575700004],
              [-78.70677649599992, 21.612616278000075],
              [-78.71369381399995, 21.61859772300005],
              [-78.7239477199999, 21.625555731000077],
              [-78.74461829299992, 21.636542059000078],
              [-78.75926673099991, 21.64061107000009],
              [-78.76650956899994, 21.63971588700008],
              [-78.77306067599994, 21.635646877000056],
              [-78.78555253799993, 21.63031647300005],
              [-78.83189856699994, 21.620306708000044],
              [-78.87840735599991, 21.616034247000073],
              [-78.88337154899995, 21.614203192000048],
              [-78.88902747299994, 21.60968659100007],
              [-78.89354407499991, 21.60419342700004],
              [-78.89541581899994, 21.599269924000055],
              [-78.89875240799995, 21.595526434000078],
              [-78.90648352799991, 21.594671942000048],
              [-78.93708248599995, 21.59638092700004],
              [-78.94920813699991, 21.598781643000052],
              [-78.95995032499991, 21.599554755000042],
              [-78.97057044199994, 21.595526434000078],
              [-78.97736568899995, 21.60297272300005],
              [-78.99453691299993, 21.59406159100007],
              [-79.01280676999994, 21.59007396000004],
              [-79.05589758999992, 21.58930084800005],
              [-79.07555091099994, 21.586086330000057],
              [-79.12816321499992, 21.56199778900009],
              [-79.1692602199999, 21.551703192000048],
              [-79.20889238199993, 21.548488674000055],
              [-79.24941972599993, 21.551947333000044],
              [-79.32957923099991, 21.57367584800005],
              [-79.34609941299993, 21.583156643000052],
              [-79.36465410099993, 21.599269924000055],
              [-79.37877356699994, 21.601263739000046],
              [-79.43065344999991, 21.595404364000046],
              [-79.45030676999994, 21.595526434000078],
              [-79.47227942599994, 21.601996161000045],
              [-79.4817602199999, 21.607367255000042],
              [-79.49132239499994, 21.616034247000073],
              [-79.50645911399994, 21.639797268000052],
              [-79.51528886599993, 21.648586330000057],
              [-79.51919511599993, 21.64020416900007],
              [-79.52220618399991, 21.630031643000052],
              [-79.52969316299993, 21.623439846000053],
              [-79.53966223899994, 21.621975002000056],
              [-79.54967200399994, 21.626898505000042],
              [-79.55915279899995, 21.63499583500004],
              [-79.56493079299992, 21.637884833000044],
              [-79.60777747299994, 21.648993231000077],
              [-79.61367753799993, 21.651312567000048],
              [-79.62165279899995, 21.65761953300006],
              [-79.62759355399993, 21.666937567000048],
              [-79.63231360599991, 21.678208726000037],
              [-79.63927161399994, 21.68773021000004],
              [-79.65208899599992, 21.69171784100007],
              [-79.7227270169999, 21.693426825000074],
              [-79.79010982999995, 21.71161530200004],
              [-79.81578528599994, 21.71124909100007],
              [-79.82705644399994, 21.695135809000078],
              [-79.83385169199994, 21.677679755000042],
              [-79.85081946499992, 21.680080471000053],
              [-79.87295488199993, 21.69086334800005],
              [-79.89537512899994, 21.698553778000075],
              [-79.89537512899994, 21.70538971600007],
              [-79.87486731699994, 21.712836005000042],
              [-79.87486731699994, 21.71906159100007],
              [-79.89037024599992, 21.722398179000038],
              [-79.89362545499995, 21.733587958000044],
              [-79.8926488919999, 21.747748114000046],
              [-79.89537512899994, 21.75999583500004],
              [-79.91234290299991, 21.74835846600007],
              [-79.93000240799995, 21.743312893000052],
              [-79.94945227799991, 21.743109442000048],
              [-79.97166907499991, 21.74640534100007],
              [-79.99205481699994, 21.75332265800006],
              [-80.00365149599992, 21.755804755000042],
              [-80.01268469999991, 21.75381094000005],
              [-80.01537024599992, 21.74673086100006],
              [-80.00902258999992, 21.739935614000046],
              [-79.99913489499994, 21.73501211100006],
              [-79.99095618399991, 21.733343817000048],
              [-80.0032445949999, 21.72089264500005],
              [-80.02179928299995, 21.72919342700004],
              [-80.03880774599992, 21.74713776200008],
              [-80.0462133449999, 21.763413804000038],
              [-80.04845130099994, 21.784898179000038],
              [-80.05532792899993, 21.80369700700004],
              [-80.06725012899994, 21.81704336100006],
              [-80.08433997299994, 21.822088934000078],
              [-80.10488847599993, 21.825384833000044],
              [-80.14590410099993, 21.839911200000074],
              [-80.18822180899991, 21.848456122000073],
              [-80.21768144399994, 21.871486721000053],
              [-80.26992753799993, 21.88703034100007],
              [-80.30077063699991, 21.91168854400007],
              [-80.40990149599992, 22.020697333000044],
              [-80.41185462099992, 22.025091864000046],
              [-80.41185462099992, 22.03025950700004],
              [-80.41258704299992, 22.03583405200004],
              [-80.41673743399991, 22.04120514500005],
              [-80.42113196499992, 22.041896877000056],
              [-80.43321692599994, 22.040187893000052],
              [-80.43724524599992, 22.04120514500005],
              [-80.44810950399994, 22.05027903900009],
              [-80.45107988199993, 22.05662669500009],
              [-80.45091712099992, 22.068508205000057],
              [-80.43675696499992, 22.06590403900009],
              [-80.41934160099993, 22.06663646000004],
              [-80.40217037699995, 22.07168203300006],
              [-80.38878333199995, 22.082180080000057],
              [-80.40416419199994, 22.078517971000053],
              [-80.40990149599992, 22.075995184000078],
              [-80.40583248599995, 22.08470286700009],
              [-80.40029863199993, 22.09316640800006],
              [-80.39614824099993, 22.101385809000078],
              [-80.39631100199995, 22.109523830000057],
              [-80.40428626199991, 22.112616278000075],
              [-80.41633053299995, 22.10960521000004],
              [-80.42536373599995, 22.11005280200004],
              [-80.42418372299994, 22.123114325000074],
              [-80.44391842399995, 22.123195705000057],
              [-80.45653235599991, 22.13043854400007],
              [-80.45775305899991, 22.14276764500005],
              [-80.4434301419999, 22.157904364000046],
              [-80.46727454299992, 22.171616929000038],
              [-80.47671464799993, 22.180161851000037],
              [-80.4844457669999, 22.19204336100006],
              [-80.49128170499995, 22.18183014500005],
              [-80.50357011599993, 22.178208726000037],
              [-80.51842200399994, 22.17991771000004],
              [-80.53282630099994, 22.18577708500004],
              [-80.53823808499993, 22.164455471000053],
              [-80.52879798099991, 22.150864976000037],
              [-80.49864661399994, 22.130560614000046],
              [-80.48399817599994, 22.111883856000077],
              [-80.47085527299993, 22.089097398000035],
              [-80.46467037699995, 22.06476471600007],
              [-80.4707738919999, 22.04120514500005],
              [-80.5137426419999, 22.056341864000046],
              [-80.6380102199999, 22.05304596600007],
              [-80.76109778599994, 22.061102606000077],
              [-80.90526282499991, 22.046128648000035],
              [-80.99209550699993, 22.05426666900007],
              [-81.01162675699993, 22.06053294500009],
              [-81.04918372299994, 22.07843659100007],
              [-81.08844967399995, 22.08584219000005],
              [-81.10366777299993, 22.09589264500005],
              [-81.11375891799992, 22.11123281500005],
              [-81.1394750639999, 22.161810614000046],
              [-81.14297441299993, 22.171535549000055],
              [-81.14362545499995, 22.18740469000005],
              [-81.13609778599994, 22.22988515800006],
              [-81.1406957669999, 22.23273346600007],
              [-81.16714433499993, 22.270819403000075],
              [-81.18053137899994, 22.27887604400007],
              [-81.19395911399994, 22.28156159100007],
              [-81.20518958199995, 22.27806224200009],
              [-81.21182206899994, 22.26776764500005],
              [-81.21157792899993, 22.25531647300005],
              [-81.19758053299995, 22.21246979400007],
              [-81.19688880099994, 22.09125397300005],
              [-81.20470130099994, 22.060288804000038],
              [-81.22549394399994, 22.061672268000052],
              [-81.21125240799995, 22.08348216400009],
              [-81.21544348899994, 22.114976304000038],
              [-81.2298070949999, 22.14394765800006],
              [-81.23912512899994, 22.15106842700004],
              [-81.26707923099991, 22.14158763200004],
              [-81.27330481699994, 22.13739655200004],
              [-81.27643795499995, 22.12889232000009],
              [-81.27525794199994, 22.110256252000056],
              [-81.27953040299991, 22.10260651200008],
              [-81.29133053299995, 22.09756094000005],
              [-81.29930579299992, 22.101263739000046],
              [-81.30606035099993, 22.107367255000042],
              [-81.31427975199995, 22.109523830000057],
              [-81.32152258999992, 22.104722398000035],
              [-81.32274329299992, 22.09784577000005],
              [-81.32559160099993, 22.09170156500005],
              [-81.33788001199991, 22.089016018000052],
              [-81.37409420499995, 22.10415273600006],
              [-81.39610755099994, 22.170721747000073],
              [-81.43407141799992, 22.18577708500004],
              [-81.48216712099992, 22.18577708500004],
              [-81.49356035099993, 22.18886953300006],
              [-81.51280676999994, 22.201971747000073],
              [-81.5235082669999, 22.205023505000042],
              [-81.53123938699991, 22.201971747000073],
              [-81.54588782499991, 22.18886953300006],
              [-81.55760657499991, 22.18577708500004],
              [-81.56021074099993, 22.18463776200008],
              [-81.56212317599994, 22.182074286000045],
              [-81.56517493399991, 22.179510809000078],
              [-81.57119706899994, 22.17837148600006],
              [-81.57433020699995, 22.180121161000045],
              [-81.57677161399994, 22.18886953300006],
              [-81.58116614499994, 22.19204336100006],
              [-81.62271074099993, 22.205023505000042],
              [-81.62779700399994, 22.207953192000048],
              [-81.63955644399994, 22.212713934000078],
              [-81.65147864499994, 22.212958075000074],
              [-81.65684973899994, 22.201971747000073],
              [-81.66661536399994, 22.19790273600006],
              [-81.68862870999993, 22.19684479400007],
              [-81.71198482999995, 22.199164130000042],
              [-81.72573808499993, 22.205023505000042],
              [-81.73200436099995, 22.205023505000042],
              [-81.73460852799991, 22.19277578300006],
              [-81.74107825399994, 22.189601955000057],
              [-81.75991777299993, 22.19204336100006],
              [-81.75690670499995, 22.188055731000077],
              [-81.75523841099994, 22.185370184000078],
              [-81.75251217399995, 22.17837148600006],
              [-81.76353919199994, 22.17841217700004],
              [-81.81021074099993, 22.18382396000004],
              [-81.82445227799991, 22.18891022300005],
              [-81.8496801419999, 22.214992580000057],
              [-81.85875403599994, 22.228908596000053],
              [-81.86237545499995, 22.24355703300006],
              [-81.8797094389999, 22.26040273600006],
              [-82.02139238199993, 22.313299872000073],
              [-82.03587805899991, 22.32099030200004],
              [-82.05101477799991, 22.332586981000077],
              [-82.05996660099993, 22.33730703300006],
              [-82.07990475199995, 22.33930084800005],
              [-82.08824622299994, 22.342230536000045],
              [-82.09316972599993, 22.34784577000005],
              [-82.10464433499993, 22.36619700700004],
              [-82.10562089799993, 22.37018463700008],
              [-82.11925208199995, 22.370062567000048],
              [-82.13760331899994, 22.37213776200008],
              [-82.15453040299991, 22.37986888200004],
              [-82.16397050699993, 22.396877346000053],
              [-82.15838438999992, 22.412534203000064],
              [-82.14639238199993, 22.42218659100007],
              [-82.13121497299994, 22.428127346000053],
              [-82.11873706799992, 22.431827964000036],
              [-82.00362935899994, 22.428152882000063],
              [-81.9660797979999, 22.43712357800007],
              [-81.93947250999992, 22.433215589000042],
              [-81.90903530999992, 22.43546427800004],
              [-81.89057523299994, 22.438550096000085],
              [-81.8638915809999, 22.43262648400008],
              [-81.84113834399994, 22.430757290000088],
              [-81.78964164699994, 22.438316738000083],
              [-81.7500707669999, 22.454006252000056],
              [-81.73884029899995, 22.452093817000048],
              [-81.72850501199991, 22.45722077000005],
              [-81.70872962099992, 22.457180080000057],
              [-81.69786536399994, 22.459540106000077],
              [-81.68350178299994, 22.463594853000075],
              [-81.67030253799993, 22.475948351000056],
              [-81.66094918499994, 22.484185962000083],
              [-81.6515626449999, 22.487827104000075],
              [-81.65280376699991, 22.50878298400005],
              [-81.64879309799994, 22.51829661700009],
              [-81.65130848599995, 22.533840785000052],
              [-81.6426488919999, 22.56195709800005],
              [-81.64325500399991, 22.57273673600008],
              [-81.65767724299991, 22.57725539100005],
              [-81.6726311779999, 22.577679783000065],
              [-81.7000219389999, 22.59959544500009],
              [-81.71884866599993, 22.61370227100008],
              [-81.75338596299991, 22.63803690600008],
              [-81.78841218999992, 22.65009702100008],
              [-81.87750093499994, 22.679730389000042],
              [-81.91242428299995, 22.678534247000073],
              [-81.99254309799994, 22.671698309000078],
              [-82.09879344699993, 22.65492148800007],
              [-82.13097083199995, 22.66787344000005],
              [-82.19885519799993, 22.685773595000057],
              [-82.2748413619999, 22.68561680600004],
              [-82.3172094389999, 22.680975653000075],
              [-82.33901933499993, 22.678656317000048],
              [-82.35985266799992, 22.680812893000052],
              [-82.39158381599992, 22.688420458000053],
              [-82.45735629099994, 22.68038488600007],
              [-82.50999915299991, 22.692287502000056],
              [-82.52171790299991, 22.69017161700009],
              [-82.5410863919999, 22.680812893000052],
              [-82.55093339799993, 22.678656317000048],
              [-82.59741800599994, 22.688008495000076],
              [-82.63294536299992, 22.68018494900008],
              [-82.73843339799993, 22.706366278000075],
              [-82.75987708199995, 22.705959377000056],
              [-82.78066972599993, 22.696112372000073],
              [-82.79088294199994, 22.67987702000005],
              [-82.79430091099994, 22.66046784100007],
              [-82.79458574099993, 22.64081452000005],
              [-82.80068925699993, 22.622748114000046],
              [-82.81541907499991, 22.613430080000057],
              [-82.84923255099994, 22.60293203300006],
              [-82.90929114499994, 22.555568752000056],
              [-82.92125403599994, 22.54828522300005],
              [-82.94395911399994, 22.546576239000046],
              [-82.95938066299993, 22.54205963700008],
              [-83.02599036399994, 22.50975169500009],
              [-83.05870520699995, 22.489447333000044],
              [-83.08608964799993, 22.46279531500005],
              [-83.14317786399994, 22.361273505000042],
              [-83.16685950399994, 22.339544989000046],
              [-83.19933020699995, 22.336004950000074],
              [-83.23224850199995, 22.34479401200008],
              [-83.24583899599992, 22.34593333500004],
              [-83.26012122299994, 22.342230536000045],
              [-83.2605688139999, 22.33974844000005],
              [-83.26012122299994, 22.32575104400007],
              [-83.2617895169999, 22.321966864000046],
              [-83.2656957669999, 22.32225169500009],
              [-83.27025305899991, 22.323553778000075],
              [-83.27745520699995, 22.32103099200009],
              [-83.28197180899991, 22.322333075000074],
              [-83.28579667899993, 22.322699286000045],
              [-83.28742428299995, 22.31867096600007],
              [-83.28693600199995, 22.304632880000042],
              [-83.28742428299995, 22.301906643000052],
              [-83.32359778599994, 22.280218817000048],
              [-83.33580481699994, 22.26776764500005],
              [-83.34117591099994, 22.25934479400007],
              [-83.34203040299991, 22.25454336100006],
              [-83.34146074099993, 22.25104401200008],
              [-83.34264075399994, 22.246649481000077],
              [-83.34923255099994, 22.232163804000038],
              [-83.35411536399994, 22.225775458000044],
              [-83.36314856699994, 22.219305731000077],
              [-83.36636308499993, 22.222398179000038],
              [-83.36790930899991, 22.22557200700004],
              [-83.3684789699999, 22.21385325700004],
              [-83.37555904899995, 22.206976630000042],
              [-83.3811475899999, 22.217147133000083],
              [-83.38944052399995, 22.220365092000065],
              [-83.39822260799991, 22.21928046000005],
              [-83.3989912269999, 22.20283141300007],
              [-83.41547243699995, 22.186093371000084],
              [-83.46532141799992, 22.182074286000045],
              [-83.51695716099994, 22.18821849200009],
              [-83.56114661399994, 22.205023505000042],
              [-83.55284583199995, 22.213446356000077],
              [-83.5554906889999, 22.22361888200004],
              [-83.56285559799994, 22.234849351000037],
              [-83.56859290299991, 22.246649481000077],
              [-83.57542883999992, 22.246649481000077],
              [-83.58958899599992, 22.219916083000044],
              [-83.61436926999994, 22.195746161000045],
              [-83.64362545499995, 22.178290106000077],
              [-83.67100989499994, 22.171535549000055],
              [-83.66893469999991, 22.175034898000035],
              [-83.66673743399991, 22.18195221600007],
              [-83.66478430899991, 22.18577708500004],
              [-83.7754613919999, 22.170721747000073],
              [-83.78087317599994, 22.171535549000055],
              [-83.78477942599994, 22.175441799000055],
              [-83.78750566299993, 22.18235911700009],
              [-83.78872636599993, 22.18903229400007],
              [-83.78770911399994, 22.19204336100006],
              [-83.79914303299995, 22.188788153000075],
              [-83.81102454299992, 22.174750067000048],
              [-83.82555091099994, 22.171535549000055],
              [-83.90322831899994, 22.17568594000005],
              [-83.92544511599993, 22.171535549000055],
              [-83.96646074099993, 22.133978583000044],
              [-83.96768144399994, 22.12636953300006],
              [-83.97533118399991, 22.098822333000044],
              [-83.98009192599994, 22.089016018000052],
              [-83.97484290299991, 22.082464911000045],
              [-83.97329667899993, 22.07648346600007],
              [-83.97264563699991, 22.061672268000052],
              [-83.98399817599994, 22.07054271000004],
              [-83.99498450399994, 22.06826406500005],
              [-84.00177975199995, 22.057562567000048],
              [-84.00059973899994, 22.04120514500005],
              [-83.99303137899994, 22.02798086100006],
              [-83.9832250639999, 22.023098049000055],
              [-83.97166907499991, 22.025783596000053],
              [-83.95897376199991, 22.034979559000078],
              [-83.96467037699995, 22.013332424000055],
              [-83.99925696499992, 21.989488023000035],
              [-84.00743567599994, 21.969183661000045],
              [-84.00381425699993, 21.96442291900007],
              [-83.99705969999991, 21.958685614000046],
              [-83.99303137899994, 21.95136139500005],
              [-83.99746660099993, 21.941839911000045],
              [-84.00690670499995, 21.933294989000046],
              [-84.01768958199995, 21.925482489000046],
              [-84.02940833199995, 21.919867255000042],
              [-84.04161536399994, 21.917669989000046],
              [-84.06041419199994, 21.921942450000074],
              [-84.09821529899995, 21.940741278000075],
              [-84.1204320949999, 21.945013739000046],
              [-84.14216061099995, 21.940334377000056],
              [-84.18073482999995, 21.91828034100007],
              [-84.19920813699991, 21.91083405200004],
              [-84.20933997299994, 21.910101630000042],
              [-84.23009192599994, 21.91152578300006],
              [-84.24014238199993, 21.91083405200004],
              [-84.25121008999992, 21.90656159100007],
              [-84.27391516799992, 21.89321523600006],
              [-84.30516516799992, 21.884507554000038],
              [-84.42324785099993, 21.792303778000075],
              [-84.46617591099994, 21.770453192000048],
              [-84.50837154899995, 21.766831773000035],
              [-84.52135169199994, 21.78656647300005],
              [-84.48131262899994, 21.865179755000042],
              [-84.47354081899994, 21.90460846600007],
              [-84.4961645169999, 21.93378327000005],
              [-84.53604081899994, 21.94017161700009],
              [-84.58055579299992, 21.93390534100007],
              [-84.65998287699995, 21.912054755000042],
              [-84.69871985599991, 21.89484284100007],
              [-84.79971269399994, 21.832098700000074],
              [-84.8399145169999, 21.82290273600006],
              [-84.88341223899994, 21.823553778000075],
              [-84.92540442599994, 21.835760809000078],
              [-84.93911699099993, 21.846096096000053],
              [-84.94725501199991, 21.86033763200004],
              [-84.94961503799993, 21.876776434000078],
              [-84.94603430899991, 21.89354075700004],
              [-84.94273841099994, 21.900051174000055],
              [-84.9375707669999, 21.90810781500005],
              [-84.93122311099995, 21.91474030200004],
              [-84.92454993399991, 21.917222398000035],
              [-84.91978919199994, 21.91474030200004],
              [-84.91657467399995, 21.90961334800005],
              [-84.91388912699995, 21.90371328300006],
              [-84.91079667899993, 21.898993231000077],
              [-84.90355383999992, 21.89362213700008],
              [-84.89537512899994, 21.890570380000042],
              [-84.88658606699994, 21.889553127000056],
              [-84.87759355399993, 21.890326239000046],
              [-84.86050370999993, 21.897040106000077],
              [-84.84874426999994, 21.90839264500005],
              [-84.84821529899995, 21.921087958000044],
              [-84.86461341099994, 21.93195221600007],
              [-84.84756425699993, 21.940619208000044],
              [-84.83238684799994, 21.940578518000052],
              [-84.82290605399993, 21.930894273000035],
              [-84.82298743399991, 21.91083405200004],
              [-84.74107825399994, 21.95180898600006],
              [-84.66844641799992, 21.971869208000044],
              [-84.5833227199999, 22.007513739000046],
              [-84.52887936099995, 22.04433828300006],
              [-84.52135169199994, 22.048041083000044],
              [-84.50804602799991, 22.04901764500005],
              [-84.49592037699995, 22.047349351000037],
              [-84.48965410099993, 22.042792059000078],
              [-84.49404863199993, 22.034979559000078],
              [-84.46263587099992, 22.022040106000077],
              [-84.43932044199994, 22.028143622000073],
              [-84.41665605399993, 22.04100169500009],
              [-84.38731848899994, 22.048041083000044],
              [-84.37279212099992, 22.04393138200004],
              [-84.35582434799994, 22.034084377000056],
              [-84.34166419199994, 22.02167389500005],
              [-84.33580481699994, 22.01044342700004],
              [-84.33096269399994, 22.00458405200004],
              [-84.30382239499994, 22.02289459800005],
              [-84.28856360599991, 22.020697333000044],
              [-84.27432206899994, 22.075995184000078],
              [-84.28628495999993, 22.063381252000056],
              [-84.29686438699991, 22.04596588700008],
              [-84.30817623599995, 22.03668854400007],
              [-84.32213294199994, 22.048041083000044],
              [-84.32803300699993, 22.06712474200009],
              [-84.32677161399994, 22.081854559000078],
              [-84.33018958199995, 22.09332916900007],
              [-84.35000566299993, 22.10260651200008],
              [-84.34072831899994, 22.123968817000048],
              [-84.33580481699994, 22.130560614000046],
              [-84.35435950399994, 22.132513739000046],
              [-84.37458248599995, 22.13930898600006],
              [-84.39281165299991, 22.148504950000074],
              [-84.40534420499995, 22.157904364000046],
              [-84.41344153599994, 22.172023830000057],
              [-84.42003333199995, 22.188666083000044],
              [-84.42926998599995, 22.201727606000077],
              [-84.44566809799994, 22.205023505000042],
              [-84.43569902299993, 22.213690497000073],
              [-84.42446855399993, 22.22915273600006],
              [-84.4153539699999, 22.247381903000075],
              [-84.41148841099994, 22.26398346600007],
              [-84.40965735599991, 22.287258205000057],
              [-84.40534420499995, 22.308742580000057],
              [-84.39102128799993, 22.352769273000035],
              [-84.38853919199994, 22.355169989000046],
              [-84.37393144399994, 22.380682684000078],
              [-84.36880449099993, 22.383286851000037],
              [-84.35802161399994, 22.38426341400009],
              [-84.35313880099994, 22.387193101000037],
              [-84.34911048099991, 22.39362213700008],
              [-84.34512285099993, 22.40623607000009],
              [-84.3426000639999, 22.411078192000048],
              [-84.32127844999991, 22.44013092700004],
              [-84.30650794199994, 22.455633856000077],
              [-84.28856360599991, 22.465765692000048],
              [-84.28856360599991, 22.473211981000077],
              [-84.30907141799992, 22.473211981000077],
              [-84.2918188139999, 22.486273505000042],
              [-84.24901282499991, 22.49355703300006],
              [-84.23029537699995, 22.503607489000046],
              [-84.21837317599994, 22.518744208000044],
              [-84.20579993399991, 22.541164455000057],
              [-84.20116126199991, 22.56281159100007],
              [-84.21288001199991, 22.57558828300006],
              [-84.21288001199991, 22.58307526200008],
              [-84.20238196499992, 22.58006419500009],
              [-84.19237219999991, 22.57558828300006],
              [-84.17813066299993, 22.585679429000038],
              [-84.16462154899995, 22.587632554000038],
              [-84.15298417899993, 22.58201732000009],
              [-84.1446020169999, 22.56940338700008],
              [-84.13573157499991, 22.60683828300006],
              [-84.13036048099991, 22.616522528000075],
              [-84.12051347599993, 22.620266018000052],
              [-84.09463456899994, 22.622381903000075],
              [-84.08934485599991, 22.627101955000057],
              [-84.08861243399991, 22.637152411000045],
              [-84.08543860599991, 22.65420156500005],
              [-84.07827714799993, 22.66620514500005],
              [-84.06550045499995, 22.661281643000052],
              [-84.05211341099994, 22.65330638200004],
              [-84.04161536399994, 22.65843333500004],
              [-84.03197180899991, 22.66937897300005],
              [-84.02110755099994, 22.678656317000048],
              [-84.02867591099994, 22.69009023600006],
              [-84.03897050699993, 22.697088934000078],
              [-84.05231686099995, 22.69985586100006],
              [-84.06883704299992, 22.698472398000035],
              [-84.06432044199994, 22.706244208000044],
              [-84.05703691299993, 22.713283596000053],
              [-84.04800370999993, 22.71824778900009],
              [-84.03844153599994, 22.72020091400009],
              [-84.02232825399994, 22.71474844000005],
              [-84.01378333199995, 22.70254140800006],
              [-84.00719153599994, 22.690375067000048],
              [-83.99746660099993, 22.684881903000075],
              [-83.98403886599993, 22.68707916900007],
              [-83.97207597599993, 22.692531643000052],
              [-83.91124426999994, 22.733303127000056],
              [-83.89757239499994, 22.72020091400009],
              [-83.88805091099994, 22.741441148000035],
              [-83.87279212099992, 22.750799872000073],
              [-83.82925370999993, 22.753729559000078],
              [-83.81265214799993, 22.756740627000056],
              [-83.74372311099995, 22.789129950000074],
              [-83.70913652299993, 22.80068594000005],
              [-83.69273841099994, 22.80215078300006],
              [-83.68154863199993, 22.80036041900007],
              [-83.66893469999991, 22.79490794500009],
              [-83.65802975199995, 22.794663804000038],
              [-83.65111243399991, 22.796820380000042],
              [-83.63731848899994, 22.805121161000045],
              [-83.63003495999993, 22.808335679000038],
              [-83.63003495999993, 22.81582265800006],
              [-83.63719641799992, 22.81268952000005],
              [-83.64435787699995, 22.808335679000038],
              [-83.64565995999993, 22.81199778900009],
              [-83.64537512899994, 22.814276434000078],
              [-83.64622962099992, 22.815375067000048],
              [-83.6511938139999, 22.81582265800006],
              [-83.62987219999991, 22.82831452000005],
              [-83.60789954299992, 22.834377346000053],
              [-83.55801347599993, 22.83624909100007],
              [-83.55378170499995, 22.842230536000045],
              [-83.54133053299995, 22.873846747000073],
              [-83.53498287699995, 22.877020575000074],
              [-83.49351966099994, 22.87726471600007],
              [-83.49608313699991, 22.870347398000035],
              [-83.49762936099995, 22.86749909100007],
              [-83.50035559799994, 22.86359284100007],
              [-83.48082434799994, 22.860256252000056],
              [-83.46910559799994, 22.87059153900009],
              [-83.46104895699995, 22.885972398000035],
              [-83.45250403599994, 22.897772528000075],
              [-83.4375707669999, 22.903469143000052],
              [-83.42609615799995, 22.899237372000073],
              [-83.41405188699991, 22.89081452000005],
              [-83.3972875639999, 22.884100653000075],
              [-83.4043676419999, 22.87376536700009],
              [-83.39346269399994, 22.876898505000042],
              [-83.37751217399995, 22.88613515800006],
              [-83.36937415299991, 22.89398834800005],
              [-83.3633520169999, 22.91046784100007],
              [-83.3484594389999, 22.932114976000037],
              [-83.32966061099995, 22.95107656500005],
              [-83.31163489499994, 22.95917389500005],
              [-83.2981664699999, 22.963324286000045],
              [-83.24644934799994, 22.993963934000078],
              [-83.22618567599994, 23.00185781500005],
              [-83.20763098899994, 23.00267161700009],
              [-83.1914770169999, 22.997381903000075],
              [-83.17821204299992, 22.98651764500005],
              [-83.17821204299992, 22.980292059000078],
              [-83.18736731699994, 22.973822333000044],
              [-83.19123287699995, 22.961859442000048],
              [-83.18932044199994, 22.947821356000077],
              [-83.18163001199991, 22.935288804000038],
              [-83.16942298099991, 22.930121161000045],
              [-83.15916907499991, 22.93622467700004],
              [-83.15054277299993, 22.94627513200004],
              [-83.14342200399994, 22.95302969000005],
              [-83.16169186099995, 22.966945705000057],
              [-83.16051184799994, 22.97996653900009],
              [-83.1458227199999, 22.991400458000044],
              [-83.12360592399995, 23.000148830000057],
              [-83.08193925699993, 23.007635809000078],
              [-83.07412675699993, 23.01129791900007],
              [-83.06114661399994, 23.019598700000074],
              [-83.05528723899994, 23.021226304000038],
              [-83.04491126199991, 23.01951732000009],
              [-83.03111731699994, 23.010687567000048],
              [-83.02057857999995, 23.007635809000078],
              [-83.01537024599992, 23.010321356000077],
              [-83.00938880099994, 23.016017971000053],
              [-83.0020238919999, 23.019232489000046],
              [-82.99258378799993, 23.01439036700009],
              [-82.98631751199991, 23.00409577000005],
              [-82.99282792899993, 23.00096263200004],
              [-83.00283769399994, 22.99945709800005],
              [-83.00690670499995, 22.993963934000078],
              [-83.00279700399994, 22.983587958000044],
              [-82.99669348899994, 22.980169989000046],
              [-82.98888098899994, 22.983628648000035],
              [-82.97960364499994, 22.993963934000078],
              [-82.98167883999992, 22.97418854400007],
              [-82.96422278599994, 22.97288646000004],
              [-82.94440670499995, 22.98509349200009],
              [-82.94245357999995, 22.98631419500009],
              [-82.93175208199995, 23.011053778000075],
              [-82.91759192599994, 23.032456773000035],
              [-82.88516191299993, 23.03310781500005],
              [-82.84935462099992, 23.027777411000045],
              [-82.82530676999994, 23.03148021000004],
              [-82.80329342399995, 23.038804429000038],
              [-82.71271725199995, 23.034898179000038],
              [-82.61998450399994, 23.046128648000035],
              [-82.59601803299995, 23.05536530200004],
              [-82.5755102199999, 23.054022528000075],
              [-82.53209387899994, 23.077093817000048],
              [-82.50999915299991, 23.083319403000075],
              [-82.50446529899995, 23.086493231000077],
              [-82.49453691299993, 23.10065338700008],
              [-82.4895727199999, 23.10382721600007],
              [-82.47720292899993, 23.105169989000046],
              [-82.46768144399994, 23.108547268000052],
              [-82.45201575399994, 23.11749909100007],
              [-82.42235266799992, 23.13886139500005],
              [-82.40689042899993, 23.14744700700004],
              [-82.36709550699993, 23.15302155200004],
              [-82.32103430899991, 23.17145416900007],
              [-82.25108801999994, 23.182114976000037],
              [-82.21934973899994, 23.194240627000056],
              [-82.15029863199993, 23.178900458000044],
              [-82.12840735599991, 23.18105703300006],
              [-82.10008704299992, 23.187648830000057],
              [-82.08824622299994, 23.19041575700004],
              [-82.06501217399995, 23.192572333000044],
              [-82.05492102799991, 23.19476959800005],
              [-82.04401607999995, 23.19871653900009],
              [-82.03319251199991, 23.200506903000075],
              [-82.02342688699991, 23.19594961100006],
              [-81.98582923099991, 23.17145416900007],
              [-81.95612545499995, 23.16364166900007],
              [-81.89207923099991, 23.157863674000055],
              [-81.86237545499995, 23.15102773600006],
              [-81.84007727799991, 23.15778229400007],
              [-81.68390865799995, 23.15692780200004],
              [-81.65807044199994, 23.156805731000077],
              [-81.64232337099992, 23.15884023600006],
              [-81.6289770169999, 23.165228583000044],
              [-81.61758378799993, 23.15961334800005],
              [-81.60643469999991, 23.15884023600006],
              [-81.59459387899994, 23.159328518000052],
              [-81.58116614499994, 23.15778229400007],
              [-81.5742895169999, 23.153998114000046],
              [-81.55679277299993, 23.14081452000005],
              [-81.53555253799993, 23.129380601000037],
              [-81.53209387899994, 23.109320380000042],
              [-81.53530839799993, 23.086330471000053],
              [-81.54019120999993, 23.06903717700004],
              [-81.5462133449999, 23.06118398600006],
              [-81.55239824099993, 23.05735911700009],
              [-81.55256100199995, 23.054348049000055],
              [-81.54019120999993, 23.048570054000038],
              [-81.52879798099991, 23.04718659100007],
              [-81.5176488919999, 23.04979075700004],
              [-81.50267493399991, 23.05536530200004],
              [-81.49876868399991, 23.060492255000042],
              [-81.49254309799994, 23.084865627000056],
              [-81.48900305899991, 23.09324778900009],
              [-81.48070227799991, 23.10032786700009],
              [-81.47329667899993, 23.10260651200008],
              [-81.46422278599994, 23.102850653000075],
              [-81.38011633999992, 23.116359768000052],
              [-81.36888587099992, 23.120917059000078],
              [-81.35814368399991, 23.131740627000056],
              [-81.33336341099994, 23.13825104400007],
              [-81.28628495999993, 23.14476146000004],
              [-81.27139238199993, 23.149562893000052],
              [-81.23424231699994, 23.166449286000045],
              [-81.20982825399994, 23.183742580000057],
              [-81.16559811099995, 23.207831122000073],
              [-81.14915930899991, 23.21238841400009],
              [-81.13060462099992, 23.205633856000077],
              [-81.14476477799991, 23.194281317000048],
              [-81.17243404899995, 23.183661200000074],
              [-81.21788489499994, 23.172674872000073],
              [-81.27220618399991, 23.14199453300006],
              [-81.28628495999993, 23.130519924000055],
              [-81.28628495999993, 23.124253648000035],
              [-81.24193274599992, 23.113714911000045],
              [-81.1848852199999, 23.052069403000075],
              [-81.14915930899991, 23.034898179000038],
              [-81.12930253799993, 23.034491278000075],
              [-81.12071692599994, 23.03896719000005],
              [-81.11367753799993, 23.049221096000053],
              [-81.09854081899994, 23.06598541900007],
              [-81.09373938699991, 23.07420482000009],
              [-81.08315995999993, 23.09870026200008],
              [-81.07811438699991, 23.10382721600007],
              [-81.06676184799994, 23.10496653900009],
              [-81.04625403599994, 23.109849351000037],
              [-81.03990637899994, 23.110663153000075],
              [-80.99836178299995, 23.10382721600007],
              [-80.99144446499992, 23.104071356000077],
              [-80.98753821499992, 23.105861721000053],
              [-80.98570716099994, 23.10224030200004],
              [-80.98525956899994, 23.086411851000037],
              [-80.97777258999992, 23.06443919500009],
              [-80.95938066299993, 23.059027411000045],
              [-80.93675696499992, 23.062933661000045],
              [-80.91637122299994, 23.06903717700004],
              [-80.75934811099995, 23.096991278000075],
              [-80.73477128799993, 23.097601630000042],
              [-80.68814042899993, 23.08860911700009],
              [-80.66315670499995, 23.089544989000046],
              [-80.64224199099993, 23.097805080000057],
              [-80.62352454299992, 23.112941799000055],
              [-80.61803137899994, 23.131740627000056],
              [-80.63646399599992, 23.15102773600006],
              [-80.62344316299993, 23.156724351000037],
              [-80.60985266799992, 23.15818919500009],
              [-80.59727942599994, 23.156073309000078],
              [-80.58747311099995, 23.15102773600006],
              [-80.58747311099995, 23.14476146000004],
              [-80.59601803299995, 23.13743724200009],
              [-80.62222245999993, 23.089544989000046],
              [-80.59434973899994, 23.070135809000078],
              [-80.5930883449999, 23.068019924000055],
              [-80.55679277299993, 23.00739166900007],
              [-80.53624426999994, 22.993963934000078],
              [-80.52037512899994, 22.99290599200009],
              [-80.47984778599994, 22.985663153000075],
              [-80.46450761599993, 22.980292059000078],
              [-80.45506751199991, 22.97207265800006],
              [-80.44473222599993, 22.96039459800005],
              [-80.43150794199994, 22.94993724200009],
              [-80.41331946499992, 22.94550202000005],
              [-80.35692298099991, 22.94562409100007],
              [-80.34447180899991, 22.94208405200004],
              [-80.3294164699999, 22.929836330000057],
              [-80.31334387899994, 22.92129140800006],
              [-80.29670162699995, 22.915676174000055],
              [-80.27961178299995, 22.91201406500005],
              [-80.24669348899994, 22.911037502000056],
              [-80.21568762899994, 22.91705963700008],
              [-80.15607662699995, 22.938706773000035],
              [-80.16356360599991, 22.962551174000055],
              [-80.14671790299991, 22.96308014500005],
              [-80.09361731699994, 22.93854401200008],
              [-80.07005774599992, 22.931789455000057],
              [-80.05003821499992, 22.935248114000046],
              [-80.0462133449999, 22.95917389500005],
              [-80.03551184799994, 22.95384349200009],
              [-80.02456620999993, 22.94668203300006],
              [-80.01610266799992, 22.938055731000077],
              [-80.01268469999991, 22.92845286700009],
              [-79.99006100199995, 22.89061107000009],
              [-79.98786373599995, 22.884100653000075],
              [-79.9500219389999, 22.86359284100007],
              [-79.94456946499992, 22.86277903900009],
              [-79.92674719999991, 22.86359284100007],
              [-79.91982988199993, 22.86131419500009],
              [-79.91698157499991, 22.85643138200004],
              [-79.91641191299993, 22.85154857000009],
              [-79.91649329299992, 22.849310614000046],
              [-79.89574133999992, 22.855169989000046],
              [-79.86314856699994, 22.883693752000056],
              [-79.80174719999991, 22.899725653000075],
              [-79.79295813699991, 22.897772528000075],
              [-79.79295813699991, 22.89012278900009],
              [-79.80235755099994, 22.882147528000075],
              [-79.82091223899994, 22.870428778000075],
              [-79.84386145699995, 22.880682684000078],
              [-79.85496985599991, 22.87254466400009],
              [-79.86803137899994, 22.83624909100007],
              [-79.85716712099992, 22.820705471000053],
              [-79.8509008449999, 22.814113674000055],
              [-79.84137936099995, 22.808335679000038],
              [-79.83071855399993, 22.80565013200004],
              [-79.78954016799992, 22.80215078300006],
              [-79.77188066299993, 22.796616929000038],
              [-79.71312415299991, 22.75779857000009],
              [-79.70995032499991, 22.753078518000052],
              [-79.70616614499994, 22.74876536700009],
              [-79.70018469999991, 22.746893622000073],
              [-79.6946508449999, 22.749172268000052],
              [-79.68862870999993, 22.75409577000005],
              [-79.68419348899994, 22.758978583000044],
              [-79.68309485599991, 22.76117584800005],
              [-79.66030839799993, 22.76386139500005],
              [-79.65172278599994, 22.75877513200004],
              [-79.6270238919999, 22.657497463000084],
              [-79.62645423099991, 22.65692780200004],
              [-79.61148027299993, 22.65232982000009],
              [-79.59935462099992, 22.646551825000074],
              [-79.58853105399993, 22.638495184000078],
              [-79.57725989499994, 22.627101955000057],
              [-79.56582597599993, 22.611151434000078],
              [-79.55211341099994, 22.58026764500005],
              [-79.54283606699994, 22.565659898000035],
              [-79.51748613199993, 22.539129950000074],
              [-79.51183020699995, 22.53461334800005],
              [-79.49693762899994, 22.53196849200009],
              [-79.46800696499992, 22.531398830000057],
              [-79.45653235599991, 22.528469143000052],
              [-79.42983964799993, 22.49022044500009],
              [-79.42471269399994, 22.47874583500004],
              [-79.41673743399991, 22.472479559000078],
              [-79.34178626199991, 22.41315338700008],
              [-79.31248938699991, 22.40029531500005],
              [-79.28587805899991, 22.40428294500009],
              [-79.27574622299994, 22.39484284100007],
              [-79.25694739499994, 22.38226959800005],
              [-79.23875891799992, 22.37641022300005],
              [-79.23058020699995, 22.387193101000037],
              [-79.21983801999994, 22.388413804000038],
              [-79.16746985599991, 22.377875067000048],
              [-79.14867102799991, 22.37763092700004],
              [-79.13780676999994, 22.384833075000074],
              [-79.13565019399994, 22.391180731000077],
              [-79.13312740799995, 22.395656643000052],
              [-79.12071692599994, 22.396877346000053],
              [-79.11058508999992, 22.394598700000074],
              [-79.0950414699999, 22.38572825700004],
              [-79.08348548099991, 22.38377513200004],
              [-79.06200110599991, 22.386664130000042],
              [-79.02448482999995, 22.39996979400007],
              [-79.00527910099993, 22.40428294500009],
              [-78.9824926419999, 22.40460846600007],
              [-78.92719479099992, 22.39874909100007],
              [-78.82868404899995, 22.388332424000055],
              [-78.78184973899994, 22.39061107000009],
              [-78.77672278599994, 22.380560614000046],
              [-78.75763912699995, 22.322333075000074],
              [-78.75401770699995, 22.32485586100006],
              [-78.74461829299992, 22.32916901200008],
              [-78.73460852799991, 22.316229559000078],
              [-78.72533118399991, 22.32420482000009],
              [-78.70986894399994, 22.355902411000045],
              [-78.72264563699991, 22.372707424000055],
              [-78.72948157499991, 22.37913646000004],
              [-78.73778235599991, 22.38377513200004],
              [-78.73778235599991, 22.39061107000009],
              [-78.70807857999995, 22.38690827000005],
              [-78.67613684799994, 22.35700104400007],
              [-78.56688391799992, 22.32103099200009],
              [-78.55284583199995, 22.311835028000075],
              [-78.54430091099994, 22.29905833500004],
              [-78.52440344999991, 22.283270575000074],
              [-78.50145423099991, 22.268866278000075],
              [-78.48395748599995, 22.260321356000077],
              [-78.46007239499994, 22.253607489000046],
              [-78.39989173099991, 22.24404531500005],
              [-78.38149980399993, 22.246649481000077],
              [-78.38194739499994, 22.239935614000046],
              [-78.38097083199995, 22.22601959800005],
              [-78.38149980399993, 22.219305731000077],
              [-78.37120520699995, 22.22402578300006],
              [-78.3672582669999, 22.22675202000005],
              [-78.36050370999993, 22.21678294500009],
              [-78.35114498599995, 22.197658596000053],
              [-78.34390214799993, 22.18891022300005],
              [-78.33486894399994, 22.182562567000048],
              [-78.31696529899995, 22.173895575000074],
              [-78.30919348899994, 22.167792059000078],
              [-78.30142167899993, 22.163804429000038],
              [-78.29157467399995, 22.16364166900007],
              [-78.28111731699994, 22.164618231000077],
              [-78.27163652299993, 22.16404857000009],
              [-78.23745683499993, 22.15106842700004],
              [-78.22191321499992, 22.147040106000077],
              [-78.17235266799992, 22.14362213700008],
              [-78.16364498599995, 22.13934967700004],
              [-78.16169186099995, 22.129461981000077],
              [-78.16087805899991, 22.118109442000048],
              [-78.1555883449999, 22.109523830000057],
              [-78.14732825399994, 22.107570705000057],
              [-78.12169348899994, 22.107855536000045],
              [-78.12498938699991, 22.106350002000056],
              [-78.12828528599994, 22.10260651200008],
              [-78.11778723899994, 22.093451239000046],
              [-78.10537675699993, 22.089016018000052],
              [-78.09243730399993, 22.08624909100007],
              [-78.0818171869999, 22.08279043200008],
              [-78.07982337099992, 22.082180080000057],
              [-78.06505286399994, 22.08698151200008],
              [-78.05557206899994, 22.077460028000075],
              [-78.0423070949999, 22.051174221000053],
              [-78.02326412699995, 22.034328518000052],
              [-78.01781165299991, 22.02753327000005],
              [-78.01121985599991, 22.00926341400009],
              [-77.99323482999995, 21.979681708000044],
              [-77.98521887899994, 21.970038153000075],
              [-77.97337805899991, 21.966131903000075],
              [-77.96133378799993, 21.958238023000035],
              [-77.91539466099994, 21.91425202000005],
              [-77.91197669199994, 21.905991929000038],
              [-77.89500891799992, 21.87693919500009],
              [-77.88805091099994, 21.86985911700009],
              [-77.87604732999995, 21.871527411000045],
              [-77.87035071499992, 21.88153717700004],
              [-77.86558997299994, 21.956244208000044],
              [-77.86009680899991, 21.966131903000075],
              [-77.84911048099991, 21.970526434000078],
              [-77.82225501199991, 21.966457424000055],
              [-77.80614173099991, 21.966131903000075],
              [-77.81501217399995, 21.95575592700004],
              [-77.8469945949999, 21.950384833000044],
              [-77.85391191299993, 21.941839911000045],
              [-77.85252844999991, 21.92401764500005],
              [-77.84854081899994, 21.910589911000045],
              [-77.84215247299994, 21.89996979400007],
              [-77.83348548099991, 21.890326239000046],
              [-77.82201087099992, 21.88027578300006],
              [-77.81330318899995, 21.87645091400009],
              [-77.78872636599993, 21.876695054000038],
              [-77.77794348899994, 21.870021877000056],
              [-77.77037512899994, 21.85455963700008],
              [-77.76602128799993, 21.83734772300005],
              [-77.76455644399994, 21.825506903000075],
              [-77.76089433499993, 21.813299872000073],
              [-77.75157630099994, 21.804632880000042],
              [-77.73839270699995, 21.798651434000078],
              [-77.71007239499994, 21.790187893000052],
              [-77.70445716099994, 21.78925202000005],
              [-77.68976803299995, 21.79588450700004],
              [-77.68126380099994, 21.79169342700004],
              [-77.67320716099994, 21.78473541900007],
              [-77.66466223899994, 21.78115469000005],
              [-77.60387122299994, 21.78974030200004],
              [-77.58641516799992, 21.787909247000073],
              [-77.5696508449999, 21.780585028000075],
              [-77.52497311099995, 21.75381094000005],
              [-77.52440344999991, 21.767645575000074],
              [-77.51659094999991, 21.774603583000044],
              [-77.49083411399994, 21.78115469000005],
              [-77.48924719999991, 21.771226304000038],
              [-77.48338782499991, 21.766180731000077],
              [-77.47423255099994, 21.76504140800006],
              [-77.46288001199991, 21.766831773000035],
              [-77.46495520699995, 21.77057526200008],
              [-77.46751868399991, 21.777736721000053],
              [-77.46971594999991, 21.78115469000005],
              [-77.45563717399995, 21.77684153900009],
              [-77.44225012899994, 21.76658763200004],
              [-77.42198645699995, 21.74640534100007],
              [-77.43635006399995, 21.744614976000037],
              [-77.44627844999991, 21.75023021000004],
              [-77.45254472599993, 21.75067780200004],
              [-77.45604407499991, 21.733343817000048],
              [-77.45372473899994, 21.71503327000005],
              [-77.43907630099994, 21.68382396000004],
              [-77.4356176419999, 21.66787344000005],
              [-77.43028723899994, 21.65761953300006],
              [-77.41746985599991, 21.65371328300006],
              [-77.38719641799992, 21.650132554000038],
              [-77.3633520169999, 21.63825104400007],
              [-77.3567602199999, 21.636542059000078],
              [-77.34715735599991, 21.638617255000042],
              [-77.34215247299994, 21.64329661700009],
              [-77.33942623599995, 21.64801666900007],
              [-77.33653723899994, 21.650132554000038],
              [-77.33690344999991, 21.655585028000075],
              [-77.34288489499994, 21.66754791900007],
              [-77.35240637899994, 21.679510809000078],
              [-77.37840735599991, 21.69049713700008],
              [-77.38914954299992, 21.70384349200009],
              [-77.40147864499994, 21.733343817000048],
              [-77.40709387899994, 21.75657786700009],
              [-77.41169186099995, 21.763413804000038],
              [-77.41856848899994, 21.767279364000046],
              [-77.43830318899995, 21.77484772300005],
              [-77.44237219999991, 21.777736721000053],
              [-77.44371497299994, 21.788234768000052],
              [-77.44880123599995, 21.801906643000052],
              [-77.45913652299993, 21.80927155200004],
              [-77.47655188699991, 21.80097077000005],
              [-77.49083411399994, 21.815252997000073],
              [-77.50438391799992, 21.803534247000073],
              [-77.51854407499991, 21.811835028000075],
              [-77.54548092399995, 21.84316640800006],
              [-77.58307857999995, 21.87327708500004],
              [-77.59365800699993, 21.888739325000074],
              [-77.60049394399994, 21.890448309000078],
              [-77.61432857999995, 21.88418203300006],
              [-77.60582434799994, 21.901271877000056],
              [-77.5899145169999, 21.919256903000075],
              [-77.57164466099994, 21.930812893000052],
              [-77.55601966099994, 21.928534247000073],
              [-77.52122962099992, 21.901190497000073],
              [-77.51748613199993, 21.893011786000045],
              [-77.51109778599994, 21.867743231000077],
              [-77.50755774599992, 21.862453518000052],
              [-77.40135657499991, 21.79047272300005],
              [-77.38097083199995, 21.78115469000005],
              [-77.33006751199991, 21.76634349200009],
              [-77.31578528599994, 21.75690338700008],
              [-77.30158443899995, 21.743353583000044],
              [-77.26773027299993, 21.71751536700009],
              [-77.25430253799993, 21.712836005000042],
              [-77.19542395699995, 21.67129140800006],
              [-77.18065344999991, 21.66425202000005],
              [-77.16673743399991, 21.66014232000009],
              [-77.15184485599991, 21.66006094000005],
              [-77.13394120999993, 21.664455471000053],
              [-77.14171301999994, 21.64557526200008],
              [-77.13630123599995, 21.63349030200004],
              [-77.12621008999992, 21.624741929000038],
              [-77.12026933499993, 21.616034247000073],
              [-77.12376868399991, 21.596177476000037],
              [-77.14781653599994, 21.571966864000046],
              [-77.15440833199995, 21.55459219000005],
              [-77.16319739499994, 21.56000397300005],
              [-77.18049068899995, 21.57802969000005],
              [-77.18541419199994, 21.581854559000078],
              [-77.24974524599992, 21.609767971000053],
              [-77.26602128799993, 21.61424388200004],
              [-77.28477942599994, 21.616034247000073],
              [-77.28425045499995, 21.61424388200004],
              [-77.28673255099994, 21.610581773000035],
              [-77.29002844999991, 21.607123114000046],
              [-77.29161536399994, 21.60610586100006],
              [-77.29377193899995, 21.602484442000048],
              [-77.29881751199991, 21.603989976000037],
              [-77.30467688699991, 21.607367255000042],
              [-77.31358801999994, 21.611151434000078],
              [-77.32445227799991, 21.620347398000035],
              [-77.33315995999993, 21.623439846000053],
              [-77.35619055899991, 21.621649481000077],
              [-77.36424719999991, 21.611761786000045],
              [-77.36095130099994, 21.600775458000044],
              [-77.34959876199991, 21.595526434000078],
              [-77.33800208199995, 21.592962958000044],
              [-77.32970130099994, 21.587103583000044],
              [-77.32201087099992, 21.58026764500005],
              [-77.31273352799991, 21.575100002000056],
              [-77.3028051419999, 21.57294342700004],
              [-77.27476966099994, 21.575100002000056],
              [-77.25511633999992, 21.56745026200008],
              [-77.24998938699991, 21.550848700000074],
              [-77.25723222599993, 21.53424713700008],
              [-77.27476966099994, 21.526678778000075],
              [-77.27757727799991, 21.518459377000056],
              [-77.27122962099992, 21.500474351000037],
              [-77.26252193899995, 21.48309967700004],
              [-77.25804602799991, 21.476385809000078],
              [-77.24673417899993, 21.474310614000046],
              [-77.22435462099992, 21.477769273000035],
              [-77.20848548099991, 21.47606028900009],
              [-77.21646074099993, 21.45840078300006],
              [-77.20661373599995, 21.460882880000042],
              [-77.1817113919999, 21.47264232000009],
              [-77.18077551999994, 21.473822333000044],
              [-77.17129472599993, 21.478949286000045],
              [-77.16185462099992, 21.480129299000055],
              [-77.15306555899991, 21.495266018000052],
              [-77.14073645699995, 21.54840729400007],
              [-77.11546790299991, 21.59320709800005],
              [-77.10724850199995, 21.60297272300005],
              [-77.08828691299993, 21.60618724200009],
              [-77.06993567599994, 21.595770575000074],
              [-76.96263587099992, 21.47264232000009],
              [-76.94676673099991, 21.459051825000074],
              [-76.94481360599991, 21.45774974200009],
              [-76.92992102799991, 21.44794342700004],
              [-76.89370683499993, 21.43162669500009],
              [-76.83844967399995, 21.42059967700004],
              [-76.82542883999992, 21.41120026200008],
              [-76.83226477799991, 21.39752838700008],
              [-76.81175696499992, 21.39752838700008],
              [-76.81761633999992, 21.376898505000042],
              [-76.82555091099994, 21.36664459800005],
              [-76.83771725199995, 21.36318594000005],
              [-76.87315833199995, 21.361070054000038],
              [-76.88744055899991, 21.35565827000005],
              [-76.89745032499991, 21.346096096000053],
              [-76.90119381399995, 21.33201732000009],
              [-76.88727779899995, 21.30735911700009],
              [-76.83617102799991, 21.332464911000045],
              [-76.83910071499992, 21.307562567000048],
              [-76.82945716099994, 21.314113674000055],
              [-76.82502193899995, 21.32440827000005],
              [-76.82258053299995, 21.33657461100006],
              [-76.81859290299991, 21.348537502000056],
              [-76.82542883999992, 21.348537502000056],
              [-76.81143144399994, 21.368068752000056],
              [-76.80728105399993, 21.378119208000044],
              [-76.80557206899994, 21.39008209800005],
              [-76.74413001199991, 21.370266018000052],
              [-76.73839270699995, 21.37055084800005],
              [-76.73058020699995, 21.374945380000042],
              [-76.72614498599995, 21.37327708500004],
              [-76.70933997299994, 21.36277903900009],
              [-76.68228105399993, 21.356634833000044],
              [-76.67149817599994, 21.355943101000037],
              [-76.65607662699995, 21.349554755000042],
              [-76.64248613199993, 21.33551666900007],
              [-76.63658606699994, 21.32135651200008],
              [-76.64391028599994, 21.315008856000077],
              [-76.66014563699991, 21.31159088700008],
              [-76.71617591099994, 21.287665106000077],
              [-76.71231035099993, 21.30263906500005],
              [-76.72150631399995, 21.311468817000048],
              [-76.73143469999991, 21.31191640800006],
              [-76.72984778599994, 21.301336981000077],
              [-76.73468990799995, 21.285549221000053],
              [-76.72134355399993, 21.279038804000038],
              [-76.70116126199991, 21.275864976000037],
              [-76.68521074099993, 21.269964911000045],
              [-76.67015540299991, 21.259019273000035],
              [-76.65330969999991, 21.251898505000042],
              [-76.63438880099994, 21.247992255000042],
              [-76.61314856699994, 21.24673086100006],
              [-76.61314856699994, 21.25291575700004],
              [-76.63491777299993, 21.26007721600007],
              [-76.64146887899994, 21.26463450700004],
              [-76.64732825399994, 21.273382880000042],
              [-76.65404212099992, 21.28774648600006],
              [-76.65355383999992, 21.294134833000044],
              [-76.63426673099991, 21.301336981000077],
              [-76.61676998599995, 21.30182526200008],
              [-76.59292558499993, 21.29482656500005],
              [-76.57079016799992, 21.282416083000044],
              [-76.5579320949999, 21.26658763200004],
              [-76.55166581899994, 21.26658763200004],
              [-76.55166581899994, 21.287665106000077],
              [-76.54491126199991, 21.287665106000077],
              [-76.54841061099995, 21.24762604400007],
              [-76.5598852199999, 21.234523830000057],
              [-76.61314856699994, 21.232367255000042],
              [-76.61314856699994, 21.22557200700004],
              [-76.59268144399994, 21.22557200700004],
              [-76.60236568899995, 21.22020091400009],
              [-76.60631262899994, 21.21873607000009],
              [-76.59825598899994, 21.205877997000073],
              [-76.58844967399995, 21.206366278000075],
              [-76.57730058499993, 21.211371161000045],
              [-76.56533769399994, 21.21198151200008],
              [-76.55679277299993, 21.205226955000057],
              [-76.54674231699994, 21.18781159100007],
              [-76.53746497299994, 21.18463776200008],
              [-76.53237870999993, 21.186712958000044],
              [-76.52550208199995, 21.19159577000005],
              [-76.51952063699991, 21.19725169500009],
              [-76.51695716099994, 21.202053127000056],
              [-76.51455644399994, 21.20526764500005],
              [-76.50894120999993, 21.205471096000053],
              [-76.50243079299992, 21.204738674000055],
              [-76.49705969999991, 21.205145575000074],
              [-76.46764075399994, 21.22134023600006],
              [-76.45612545499995, 21.22557200700004],
              [-76.47158769399994, 21.23065827000005],
              [-76.50426184799994, 21.234808661000045],
              [-76.51695716099994, 21.23924388200004],
              [-76.52904212099992, 21.25263092700004],
              [-76.53237870999993, 21.26862213700008],
              [-76.52554277299993, 21.282049872000073],
              [-76.50731360599991, 21.287665106000077],
              [-76.38756262899994, 21.284328518000052],
              [-76.36302649599992, 21.277085679000038],
              [-76.34878495999993, 21.266058661000045],
              [-76.31651770699995, 21.25421784100007],
              [-76.31354732999995, 21.251898505000042],
              [-76.29027258999992, 21.233710028000075],
              [-76.27586829299992, 21.225043036000045],
              [-76.16966712099992, 21.187160549000055],
              [-76.13780676999994, 21.167222398000035],
              [-76.13341223899994, 21.143703518000052],
              [-76.12999426999994, 21.135565497000073],
              [-76.13072669199994, 21.114162502000056],
              [-76.12657630099994, 21.102118231000077],
              [-76.11676998599995, 21.091498114000046],
              [-76.10985266799992, 21.092230536000045],
              [-76.09984290299991, 21.102118231000077],
              [-76.08381100199995, 21.110541083000044],
              [-76.07266191299993, 21.112982489000046],
              [-76.05825761599993, 21.10956452000005],
              [-76.04808508999992, 21.10382721600007],
              [-76.04100501199991, 21.09666575700004],
              [-76.03722083199995, 21.08734772300005],
              [-76.0371801419999, 21.074774481000077],
              [-76.03091386599993, 21.074774481000077],
              [-76.02892005099994, 21.07957591400009],
              [-76.02574622299994, 21.084540106000077],
              [-76.02354895699995, 21.089056708000044],
              [-76.01671301999994, 21.07367584800005],
              [-76.00816809799994, 21.07029857000009],
              [-76.00218665299991, 21.078070380000042],
              [-76.00304114499994, 21.09589264500005],
              [-75.99461829299992, 21.094549872000073],
              [-75.96788489499994, 21.09398021000004],
              [-75.95531165299991, 21.09589264500005],
              [-75.94904537699995, 21.09979889500005],
              [-75.93346106699994, 21.112941799000055],
              [-75.92487545499995, 21.115708726000037],
              [-75.91242428299995, 21.115179755000042],
              [-75.89989173099991, 21.11277903900009],
              [-75.89024817599994, 21.10773346600007],
              [-75.88194739499994, 21.090277411000045],
              [-75.87352454299992, 21.088771877000056],
              [-75.86827551999994, 21.093085028000075],
              [-75.87336178299995, 21.102118231000077],
              [-75.82176673099991, 21.136867580000057],
              [-75.81627356699994, 21.135646877000056],
              [-75.80125891799992, 21.129299221000053],
              [-75.79820716099994, 21.126613674000055],
              [-75.79401607999995, 21.11904531500005],
              [-75.78429114499994, 21.11863841400009],
              [-75.76683508999992, 21.12323639500005],
              [-75.73228919199994, 21.12327708500004],
              [-75.70400956899994, 21.118963934000078],
              [-75.68431555899991, 21.10309479400007],
              [-75.67536373599995, 21.06858958500004],
              [-75.63589433499993, 21.07636139500005],
              [-75.61314856699994, 21.062567450000074],
              [-75.57848059799994, 21.013373114000046],
              [-75.5989477199999, 20.972357489000046],
              [-75.60484778599994, 20.965399481000077],
              [-75.61603756399995, 20.956732489000046],
              [-75.62010657499991, 20.951239325000074],
              [-75.62193762899994, 20.94481028900009],
              [-75.62417558499993, 20.92987702000005],
              [-75.62633216099994, 20.923976955000057],
              [-75.63487708199995, 20.912543036000045],
              [-75.64875240799995, 20.89940013200004],
              [-75.66515051999994, 20.89008209800005],
              [-75.68154863199993, 20.890448309000078],
              [-75.68651282499991, 20.900051174000055],
              [-75.69025631399995, 20.915187893000052],
              [-75.69640051999994, 20.92487213700008],
              [-75.70885169199994, 20.917710679000038],
              [-75.71703040299991, 20.92255280200004],
              [-75.72362219999991, 20.92340729400007],
              [-75.72948157499991, 20.92145416900007],
              [-75.73550370999993, 20.917710679000038],
              [-75.72736568899995, 20.916571356000077],
              [-75.72142493399991, 20.914455471000053],
              [-75.71751868399991, 20.91034577000005],
              [-75.71568762899994, 20.903509833000044],
              [-75.74400794199994, 20.901556708000044],
              [-75.74339758999992, 20.88934967700004],
              [-75.73045813699991, 20.872219143000052],
              [-75.72183183499993, 20.85504791900007],
              [-75.71568762899994, 20.85504791900007],
              [-75.70449785099993, 20.870835679000038],
              [-75.67813066299993, 20.878241278000075],
              [-75.64818274599992, 20.87954336100006],
              [-75.62633216099994, 20.876776434000078],
              [-75.58486894399994, 20.85683828300006],
              [-75.57848059799994, 20.851955471000053],
              [-75.57738196499992, 20.83808014500005],
              [-75.57331295499995, 20.82754140800006],
              [-75.56493079299992, 20.821478583000044],
              [-75.55113684799994, 20.821519273000035],
              [-75.55907141799992, 20.797674872000073],
              [-75.57315019399994, 20.797674872000073],
              [-75.58910071499992, 20.80768463700008],
              [-75.60269120999993, 20.814113674000055],
              [-75.61017818899995, 20.816555080000057],
              [-75.61343339799993, 20.82249583500004],
              [-75.61571204299992, 20.82965729400007],
              [-75.62010657499991, 20.83584219000005],
              [-75.62743079299992, 20.841457424000055],
              [-75.63060462099992, 20.843085028000075],
              [-75.68537350199995, 20.835109768000052],
              [-75.70474199099993, 20.828680731000077],
              [-75.77025305899991, 20.83584219000005],
              [-75.76500403599994, 20.82440827000005],
              [-75.76634680899991, 20.81159088700008],
              [-75.77647864499994, 20.78742096600007],
              [-75.77570553299995, 20.781317450000074],
              [-75.77660071499992, 20.768703518000052],
              [-75.7793676419999, 20.75690338700008],
              [-75.78392493399991, 20.74640534100007],
              [-75.77464758999992, 20.737616278000075],
              [-75.76305091099994, 20.716009833000044],
              [-75.72451738199993, 20.69550202000005],
              [-75.70885169199994, 20.690578518000052],
              [-75.70201575399994, 20.701117255000042],
              [-75.69102942599994, 20.72288646000004],
              [-75.64317786399994, 20.76072825700004],
              [-75.63312740799995, 20.780585028000075],
              [-75.61729895699995, 20.76862213700008],
              [-75.60773678299995, 20.753159898000035],
              [-75.60570227799991, 20.735988674000055],
              [-75.6126195949999, 20.718491929000038],
              [-75.58682206899994, 20.721502997000073],
              [-75.57750403599994, 20.718451239000046],
              [-75.58189856699994, 20.707953192000048],
              [-75.58356686099995, 20.69822825700004],
              [-75.57331295499995, 20.69139232000009],
              [-75.55113684799994, 20.684393622000073],
              [-75.5567113919999, 20.70644765800006],
              [-75.49779212099992, 20.693426825000074],
              [-75.48224850199995, 20.71165599200009],
              [-75.47606360599991, 20.71165599200009],
              [-75.47126217399995, 20.70612213700008],
              [-75.46471106699994, 20.70062897300005],
              [-75.45685787699995, 20.69550202000005],
              [-75.44810950399994, 20.691148179000038],
              [-75.44066321499992, 20.71165599200009],
              [-75.45718339799993, 20.717962958000044],
              [-75.46593176999994, 20.719224351000037],
              [-75.47606360599991, 20.718491929000038],
              [-75.46361243399991, 20.734076239000046],
              [-75.43968665299991, 20.740627346000053],
              [-75.41356360599991, 20.741156317000048],
              [-75.39415442599994, 20.73895905200004],
              [-75.37657630099994, 20.732163804000038],
              [-75.35602779899995, 20.719916083000044],
              [-75.34923255099994, 20.70848216400009],
              [-75.37303626199991, 20.704250393000052],
              [-75.36432857999995, 20.69139232000009],
              [-75.35936438699991, 20.677557684000078],
              [-75.35260982999995, 20.677557684000078],
              [-75.35138912699995, 20.68187083500004],
              [-75.3457738919999, 20.691148179000038],
              [-75.3372289699999, 20.669663804000038],
              [-75.31281490799995, 20.66474030200004],
              [-75.25633704299992, 20.670721747000073],
              [-75.27375240799995, 20.681586005000042],
              [-75.31159420499995, 20.69944896000004],
              [-75.33141028599994, 20.704250393000052],
              [-75.31871497299994, 20.71710846600007],
              [-75.29430091099994, 20.723130601000037],
              [-75.26797441299993, 20.72333405200004],
              [-75.24950110599991, 20.718491929000038],
              [-75.25633704299992, 20.72597890800006],
              [-75.24103756399995, 20.72479889500005],
              [-75.19432532499991, 20.715643622000073],
              [-75.18195553299995, 20.709133205000057],
              [-75.17857825399994, 20.70221588700008],
              [-75.19489498599995, 20.69798411700009],
              [-75.19489498599995, 20.691148179000038],
              [-75.16698157499991, 20.684393622000073],
              [-75.16515051999994, 20.686428127000056],
              [-75.16486568899995, 20.68781159100007],
              [-75.16397050699993, 20.689195054000038],
              [-75.16075598899994, 20.691148179000038],
              [-75.14907792899993, 20.68309153900009],
              [-75.13182532499991, 20.68740469000005],
              [-75.11534583199995, 20.68659088700008],
              [-75.10610917899993, 20.663275458000044],
              [-75.10411536399994, 20.66860586100006],
              [-75.09959876199991, 20.677679755000042],
              [-75.09870357999995, 20.684393622000073],
              [-75.08942623599995, 20.677679755000042],
              [-75.08039303299995, 20.673651434000078],
              [-75.07192949099993, 20.67324453300006],
              [-75.06456458199995, 20.677557684000078],
              [-75.07876542899993, 20.691148179000038],
              [-74.99836178299995, 20.70075104400007],
              [-74.97887122299994, 20.694566148000035],
              [-74.96922766799992, 20.689520575000074],
              [-74.95909583199995, 20.687323309000078],
              [-74.95107988199993, 20.68357982000009],
              [-74.94786536399994, 20.67413971600007],
              [-74.9407445949999, 20.668402411000045],
              [-74.92467200399994, 20.668036200000074],
              [-74.90005449099993, 20.670721747000073],
              [-74.88353430899991, 20.659491278000075],
              [-74.86929277299993, 20.64594147300005],
              [-74.8509008449999, 20.634588934000078],
              [-74.77183997299994, 20.625799872000073],
              [-74.75121008999992, 20.619574286000045],
              [-74.73558508999992, 20.60927969000005],
              [-74.74571692599994, 20.603949286000045],
              [-74.74986731699994, 20.602443752000056],
              [-74.73558508999992, 20.578558661000045],
              [-74.73493404899995, 20.567613023000035],
              [-74.73257402299993, 20.564846096000053],
              [-74.72838294199994, 20.56443919500009],
              [-74.72191321499992, 20.56085846600007],
              [-74.71515865799995, 20.55605703300006],
              [-74.70982825399994, 20.55223216400009],
              [-74.67349199099993, 20.540961005000042],
              [-74.6699926419999, 20.52765534100007],
              [-74.65070553299995, 20.51308828300006],
              [-74.60521399599992, 20.48574453300006],
              [-74.59727942599994, 20.47679271000004],
              [-74.58649654899995, 20.45579661700009],
              [-74.55479895699995, 20.414455471000053],
              [-74.54723059799994, 20.41006094000005],
              [-74.54393469999991, 20.403550523000035],
              [-74.49498450399994, 20.355169989000046],
              [-74.48574785099993, 20.350816148000035],
              [-74.47207597599993, 20.34918854400007],
              [-74.45026607999995, 20.343085028000075],
              [-74.42341061099995, 20.32758209800005],
              [-74.40111243399991, 20.30727773600006],
              [-74.39297441299993, 20.28652578300006],
              [-74.38556881399995, 20.28652578300006],
              [-74.37218176999994, 20.300523179000038],
              [-74.35191809799994, 20.300441799000055],
              [-74.32970130099994, 20.29523346600007],
              [-74.31041419199994, 20.29393138200004],
              [-74.29369055899991, 20.300930080000057],
              [-74.27623450399994, 20.31122467700004],
              [-74.25719153599994, 20.319647528000075],
              [-74.23595130099994, 20.321234442000048],
              [-74.22354081899994, 20.31736888200004],
              [-74.21361243399991, 20.310980536000045],
              [-74.19371497299994, 20.29393138200004],
              [-74.15965735599991, 20.27342357000009],
              [-74.14753170499995, 20.25918203300006],
              [-74.13963782499991, 20.242336330000057],
              [-74.13508053299995, 20.223822333000044],
              [-74.1328832669999, 20.20457591400009],
              [-74.14195716099994, 20.18260325700004],
              [-74.16291256399995, 20.17055898600006],
              [-74.18407141799992, 20.162665106000077],
              [-74.19806881399995, 20.148871161000045],
              [-74.21833248599995, 20.137844143000052],
              [-74.22508704299992, 20.135687567000048],
              [-74.23029537699995, 20.13031647300005],
              [-74.23595130099994, 20.094671942000048],
              [-74.26740475199995, 20.068304755000042],
              [-74.30451412699995, 20.06932200700004],
              [-74.34658769399994, 20.07957591400009],
              [-74.39297441299993, 20.08104075700004],
              [-74.45592200399994, 20.06867096600007],
              [-74.49836178299995, 20.065619208000044],
              [-74.58047695599993, 20.04764237900008],
              [-74.61864998999994, 20.054519508000055],
              [-74.65018391899991, 20.04216363100005],
              [-74.71312417199994, 20.051800607000075],
              [-74.78842485599995, 20.03946681900004],
              [-74.81297766799992, 20.037258205000057],
              [-74.83800208199995, 20.02643463700008],
              [-74.85513261599993, 20.01276276200008],
              [-74.87067623599995, 19.997015692000048],
              [-74.88780676999994, 19.984076239000046],
              [-74.91002356699994, 19.978664455000057],
              [-74.93351676299994, 19.97821893400004],
              [-74.9473341019999, 19.975949496000055],
              [-74.9555159329999, 19.967813299000056],
              [-74.96156074999993, 19.947009654000055],
              [-74.97786795099995, 19.92303486600008],
              [-75.01008053299995, 19.91156647300005],
              [-75.04566773999994, 19.90760060100007],
              [-75.05103469799991, 19.919371866000063],
              [-75.05823143399994, 19.922965563000048],
              [-75.06351788099994, 19.921604784000067],
              [-75.06637802199992, 19.914368366000076],
              [-75.0663328359999, 19.90486197200005],
              [-75.09177983899991, 19.89713258800009],
              [-75.0950058107462, 19.897225962598796],
            ],
          ],
          [
            [
              [-78.33311926999994, 20.554632880000042],
              [-78.32607988199993, 20.535101630000042],
              [-78.32835852799991, 20.521307684000078],
              [-78.33897864499994, 20.518011786000045],
              [-78.35728919199994, 20.530422268000052],
              [-78.36896725199995, 20.53652578300006],
              [-78.38385982999995, 20.54059479400007],
              [-78.39659583199995, 20.54645416900007],
              [-78.40977942599994, 20.57363515800006],
              [-78.42784583199995, 20.585638739000046],
              [-78.46344967399995, 20.602443752000056],
              [-78.44920813699991, 20.612941799000055],
              [-78.43350175699993, 20.609523830000057],
              [-78.41893469999991, 20.59910716400009],
              [-78.40819251199991, 20.588771877000056],
              [-78.39342200399994, 20.569973049000055],
              [-78.38418535099993, 20.562160549000055],
              [-78.3672582669999, 20.554632880000042],
              [-78.36449133999992, 20.57021719000005],
              [-78.35529537699995, 20.573431708000044],
              [-78.34357662699995, 20.567328192000048],
              [-78.33311926999994, 20.554632880000042],
            ],
          ],
          [
            [
              [-78.43614661399994, 20.72597890800006],
              [-78.44912675699993, 20.71161530200004],
              [-78.49575761599993, 20.701239325000074],
              [-78.51183020699995, 20.691148179000038],
              [-78.52782141799992, 20.699286200000074],
              [-78.54539954299992, 20.704250393000052],
              [-78.53319251199991, 20.71279531500005],
              [-78.49836178299995, 20.72016022300005],
              [-78.48395748599995, 20.732163804000038],
              [-78.4785863919999, 20.730169989000046],
              [-78.47842363199993, 20.72919342700004],
              [-78.47647050699993, 20.72597890800006],
              [-78.46589107999995, 20.73118724200009],
              [-78.45579993399991, 20.731756903000075],
              [-78.43614661399994, 20.72597890800006],
            ],
          ],
          [
            [
              [-78.82656816299993, 20.753241278000075],
              [-78.80703691299993, 20.75722890800006],
              [-78.78595943899995, 20.748968817000048],
              [-78.75084387899994, 20.72597890800006],
              [-78.76805579299992, 20.712225653000075],
              [-78.79234778599994, 20.719916083000044],
              [-78.81480872299994, 20.737453518000052],
              [-78.82656816299993, 20.753241278000075],
            ],
          ],
          [
            [
              [-75.51707923099991, 20.794256903000075],
              [-75.50816809799994, 20.78656647300005],
              [-75.49376380099994, 20.761053778000075],
              [-75.48570716099994, 20.749823309000078],
              [-75.48216712099992, 20.73777903900009],
              [-75.50084387899994, 20.737941799000055],
              [-75.53408769399994, 20.74640534100007],
              [-75.55182857999995, 20.74900950700004],
              [-75.56753495999993, 20.756781317000048],
              [-75.57774817599994, 20.76951732000009],
              [-75.57848059799994, 20.78742096600007],
              [-75.52916419199994, 20.795803127000056],
              [-75.51707923099991, 20.794256903000075],
            ],
          ],
          [
            [
              [-78.9258520169999, 20.807847398000035],
              [-78.87661699099993, 20.80923086100006],
              [-78.85855058499993, 20.79954661700009],
              [-78.84703528599994, 20.773138739000046],
              [-78.85448157499991, 20.773138739000046],
              [-78.87149003799993, 20.784857489000046],
              [-78.94163977799991, 20.792629299000055],
              [-78.96434485599991, 20.814113674000055],
              [-78.95213782499991, 20.831366278000075],
              [-78.94225012899994, 20.839585679000038],
              [-78.93272864499994, 20.83893463700008],
              [-78.92808997299994, 20.83112213700008],
              [-78.92613684799994, 20.820746161000045],
              [-78.9258520169999, 20.807847398000035],
            ],
          ],
          [
            [
              [-79.02521725199995, 20.886664130000042],
              [-79.01353919199994, 20.88226959800005],
              [-78.98997962099992, 20.87962474200009],
              [-78.97118079299992, 20.873521226000037],
              [-78.97398841099994, 20.85879140800006],
              [-78.98273678299995, 20.844631252000056],
              [-78.98888098899994, 20.839056708000044],
              [-78.99168860599991, 20.845445054000038],
              [-78.99510657499991, 20.84918854400007],
              [-79.01891028599994, 20.85504791900007],
              [-79.06920325399994, 20.885972398000035],
              [-79.07982337099992, 20.897284247000073],
              [-79.06704667899993, 20.89915599200009],
              [-79.04881751199991, 20.89801666900007],
              [-79.03229732999995, 20.893744208000044],
              [-79.02521725199995, 20.886664130000042],
            ],
          ],
          [
            [
              [-79.07359778599994, 20.917710679000038],
              [-79.07860266799992, 20.91828034100007],
              [-79.09406490799995, 20.917710679000038],
              [-79.09129798099991, 20.91209544500009],
              [-79.0872289699999, 20.897284247000073],
              [-79.11558997299994, 20.91083405200004],
              [-79.13451087099992, 20.927069403000075],
              [-79.16917883999992, 20.964911200000074],
              [-79.16917883999992, 20.972357489000046],
              [-79.15176347599993, 20.966050523000035],
              [-79.13890540299991, 20.95465729400007],
              [-79.12755286399994, 20.94171784100007],
              [-79.1145727199999, 20.930812893000052],
              [-79.12767493399991, 20.950873114000046],
              [-79.14981035099993, 20.97679271000004],
              [-79.17503821499992, 20.997015692000048],
              [-79.19709225199995, 20.999701239000046],
              [-79.19709225199995, 20.992254950000074],
              [-79.19375566299993, 20.988714911000045],
              [-79.19286048099991, 20.986761786000045],
              [-79.19220943899995, 20.98427969000005],
              [-79.18960527299993, 20.97919342700004],
              [-79.20099850199995, 20.98240794500009],
              [-79.21076412699995, 20.98777903900009],
              [-79.21865800699993, 20.99551015800006],
              [-79.22443600199995, 21.00584544500009],
              [-79.18211829299992, 21.00800202000005],
              [-79.13768469999991, 20.98265208500004],
              [-79.0989477199999, 20.947007554000038],
              [-79.07359778599994, 20.917710679000038],
            ],
          ],
          [
            [
              [-79.38890540299991, 21.12323639500005],
              [-79.35732988199993, 21.12759023600006],
              [-79.33189856699994, 21.11318594000005],
              [-79.29263261599993, 21.074774481000077],
              [-79.30801347599993, 21.068793036000045],
              [-79.32477779899995, 21.068304755000042],
              [-79.34072831899994, 21.07290273600006],
              [-79.35411536399994, 21.08222077000005],
              [-79.34740149599992, 21.081691799000055],
              [-79.32681230399993, 21.08222077000005],
              [-79.33116614499994, 21.093003648000035],
              [-79.33853105399993, 21.09983958500004],
              [-79.34679114499994, 21.101263739000046],
              [-79.35411536399994, 21.09589264500005],
              [-79.38023841099994, 21.113836981000077],
              [-79.38890540299991, 21.12323639500005],
            ],
          ],
          [
            [
              [-81.37230383999992, 21.70538971600007],
              [-81.37653561099995, 21.703070380000042],
              [-81.41755123599995, 21.667914130000042],
              [-81.49669348899994, 21.618475653000075],
              [-81.52769934799994, 21.605861721000053],
              [-81.56065833199995, 21.60297272300005],
              [-81.56078040299991, 21.622381903000075],
              [-81.55138098899994, 21.62759023600006],
              [-81.5235082669999, 21.623439846000053],
              [-81.51244055899991, 21.63084544500009],
              [-81.50304114499994, 21.645697333000044],
              [-81.49351966099994, 21.657049872000073],
              [-81.48216712099992, 21.65387604400007],
              [-81.46906490799995, 21.648179429000038],
              [-81.45449785099993, 21.65180084800005],
              [-81.4426977199999, 21.659979559000078],
              [-81.43781490799995, 21.66787344000005],
              [-81.4317113919999, 21.68500397300005],
              [-81.4173070949999, 21.697211005000042],
              [-81.38597571499992, 21.715969143000052],
              [-81.37767493399991, 21.71893952000005],
              [-81.37165279899995, 21.71474844000005],
              [-81.36937415299991, 21.70856354400007],
              [-81.37230383999992, 21.70538971600007],
            ],
          ],
          [
            [
              [-82.56802324099993, 21.636542059000078],
              [-82.57518469999991, 21.624701239000046],
              [-82.56712805899991, 21.61200592700004],
              [-82.55264238199993, 21.601385809000078],
              [-82.54076087099992, 21.595526434000078],
              [-82.55089270699995, 21.58026764500005],
              [-82.57144120999993, 21.559759833000044],
              [-82.59463456899994, 21.541815497000073],
              [-82.61270097599993, 21.534084377000056],
              [-82.63145911399994, 21.53074778900009],
              [-82.75918535099993, 21.47060781500005],
              [-82.83556067599994, 21.44472890800006],
              [-82.90623938699991, 21.43748607000009],
              [-82.91812089799993, 21.44159577000005],
              [-82.92723548099991, 21.450995184000078],
              [-82.99258378799993, 21.45213450700004],
              [-83.00226803299995, 21.455023505000042],
              [-83.02183997299994, 21.46308014500005],
              [-83.03355872299994, 21.46580638200004],
              [-83.06948808499993, 21.46515534100007],
              [-83.07852128799993, 21.469224351000037],
              [-83.11115475199995, 21.50975169500009],
              [-83.12360592399995, 21.520453192000048],
              [-83.15172278599994, 21.537909247000073],
              [-83.16209876199991, 21.549261786000045],
              [-83.17137610599991, 21.56826406500005],
              [-83.17821204299992, 21.595526434000078],
              [-83.1895238919999, 21.620266018000052],
              [-83.19180253799993, 21.63031647300005],
              [-83.18504798099991, 21.63031647300005],
              [-83.17393958199995, 21.62010325700004],
              [-83.12360592399995, 21.585638739000046],
              [-83.11701412699995, 21.57172272300005],
              [-83.10130774599992, 21.559800523000035],
              [-83.08202063699991, 21.55145905200004],
              [-83.0652563139999, 21.54840729400007],
              [-83.02391516799992, 21.54840729400007],
              [-83.02057857999995, 21.552476304000038],
              [-82.99258378799993, 21.575100002000056],
              [-82.97691809799994, 21.584865627000056],
              [-82.96922766799992, 21.59125397300005],
              [-82.96593176999994, 21.599269924000055],
              [-82.96279863199993, 21.59829336100006],
              [-82.95763098899994, 21.592352606000077],
              [-82.95653235599991, 21.582180080000057],
              [-82.96593176999994, 21.56826406500005],
              [-82.95909583199995, 21.56199778900009],
              [-82.94102942599994, 21.593085028000075],
              [-82.9461156889999, 21.604641018000052],
              [-82.9759008449999, 21.609198309000078],
              [-82.98766028599994, 21.61977773600006],
              [-83.07347571499992, 21.760565497000073],
              [-83.08560136599993, 21.80027903900009],
              [-83.07518469999991, 21.84316640800006],
              [-83.03282630099994, 21.874335028000075],
              [-83.02733313699991, 21.887274481000077],
              [-83.01866614499994, 21.897691148000035],
              [-82.99852454299992, 21.910956122000073],
              [-82.97569739499994, 21.921820380000042],
              [-82.95909583199995, 21.925116278000075],
              [-82.97008216099994, 21.92999909100007],
              [-82.98102779899995, 21.93195221600007],
              [-82.99258378799993, 21.93195221600007],
              [-83.0047094389999, 21.937648830000057],
              [-83.00523841099994, 21.939601955000057],
              [-82.99876868399991, 21.941839911000045],
              [-82.98949133999992, 21.948431708000044],
              [-82.85899817599994, 21.933661200000074],
              [-82.77749589799993, 21.914862372000073],
              [-82.72142493399991, 21.900091864000046],
              [-82.70372473899994, 21.89280833500004],
              [-82.69017493399991, 21.88182200700004],
              [-82.68472245999993, 21.866156317000048],
              [-82.68822180899991, 21.84764232000009],
              [-82.69347083199995, 21.83543528900009],
              [-82.69253495999993, 21.824042059000078],
              [-82.67788652299993, 21.807806708000044],
              [-82.63296464799993, 21.77362702000005],
              [-82.61953691299993, 21.774318752000056],
              [-82.60960852799991, 21.769598700000074],
              [-82.60293535099993, 21.75849030200004],
              [-82.59788977799991, 21.746039130000042],
              [-82.5926000639999, 21.736761786000045],
              [-82.59235592399995, 21.729071356000077],
              [-82.5977270169999, 21.71743398600006],
              [-82.60899817599994, 21.698553778000075],
              [-82.61644446499992, 21.698553778000075],
              [-82.61107337099992, 21.69013092700004],
              [-82.60952714799993, 21.681586005000042],
              [-82.61143958199995, 21.67291901200008],
              [-82.61644446499992, 21.664455471000053],
              [-82.59386145699995, 21.65106842700004],
              [-82.58189856699994, 21.645738023000035],
              [-82.56802324099993, 21.64394765800006],
              [-82.56802324099993, 21.636542059000078],
            ],
          ],
          [
            [
              [-77.63418535099993, 22.05426666900007],
              [-77.62657630099994, 22.04205963700008],
              [-77.62437903599994, 22.029730536000045],
              [-77.62706458199995, 22.016180731000077],
              [-77.64867102799991, 21.971136786000045],
              [-77.64557857999995, 21.961493231000077],
              [-77.63418535099993, 21.945013739000046],
              [-77.64964758999992, 21.944484768000052],
              [-77.66152910099993, 21.94013092700004],
              [-77.68260657499991, 21.925116278000075],
              [-77.67788652299993, 21.943019924000055],
              [-77.68431555899991, 21.95115794500009],
              [-77.69505774599992, 21.948065497000073],
              [-77.70311438699991, 21.93195221600007],
              [-77.70042883999992, 21.928859768000052],
              [-77.69615637899994, 21.922267971000053],
              [-77.69542395699995, 21.915187893000052],
              [-77.70311438699991, 21.91083405200004],
              [-77.70889238199993, 21.912176825000074],
              [-77.71263587099992, 21.916937567000048],
              [-77.71589107999995, 21.923041083000044],
              [-77.72817949099993, 21.938788153000075],
              [-77.73298092399995, 21.948187567000048],
              [-77.73912512899994, 21.95722077000005],
              [-77.75153561099995, 21.966131903000075],
              [-77.76577714799993, 21.959784247000073],
              [-77.78726152299993, 21.964056708000044],
              [-77.8086645169999, 21.973578192000048],
              [-77.82258053299995, 21.98314036700009],
              [-77.82510331899994, 21.991848049000055],
              [-77.82115637899994, 22.002427476000037],
              [-77.81529700399994, 22.013617255000042],
              [-77.81236731699994, 22.02411530200004],
              [-77.81712805899991, 22.031317450000074],
              [-77.82795162699995, 22.03611888200004],
              [-77.84707597599993, 22.04120514500005],
              [-77.84203040299991, 22.03261953300006],
              [-77.84007727799991, 22.023993231000077],
              [-77.84166419199994, 22.015366929000038],
              [-77.84707597599993, 22.007025458000044],
              [-77.85391191299993, 22.02753327000005],
              [-77.86009680899991, 22.02753327000005],
              [-77.87022864499994, 22.01325104400007],
              [-77.88658606699994, 22.00922272300005],
              [-77.90184485599991, 22.01520416900007],
              [-77.90855872299994, 22.03123607000009],
              [-77.91722571499992, 22.04315827000005],
              [-77.93447831899994, 22.05613841400009],
              [-77.94713294199994, 22.072821356000077],
              [-77.94204667899993, 22.095851955000057],
              [-77.94945227799991, 22.10260651200008],
              [-77.93016516799992, 22.102118231000077],
              [-77.91624915299991, 22.093817450000074],
              [-77.9036352199999, 22.083238023000035],
              [-77.88805091099994, 22.075995184000078],
              [-77.87169348899994, 22.07562897300005],
              [-77.86042232999995, 22.080959377000056],
              [-77.85081946499992, 22.088690497000073],
              [-77.83967037699995, 22.095851955000057],
              [-77.82249915299991, 22.100531317000048],
              [-77.80850175699993, 22.099554755000042],
              [-77.79637610599991, 22.095038153000075],
              [-77.78502356699994, 22.089016018000052],
              [-77.78123938699991, 22.084784247000073],
              [-77.77196204299992, 22.07135651200008],
              [-77.76768958199995, 22.068508205000057],
              [-77.7591039699999, 22.07062409100007],
              [-77.74469967399995, 22.080023505000042],
              [-77.73721269399994, 22.082180080000057],
              [-77.72630774599992, 22.07762278900009],
              [-77.69420325399994, 22.05801015800006],
              [-77.68260657499991, 22.05426666900007],
              [-77.66966712099992, 22.06085846600007],
              [-77.6614477199999, 22.06932200700004],
              [-77.65172278599994, 22.070257880000042],
              [-77.63418535099993, 22.05426666900007],
            ],
          ],
          [
            [
              [-77.84707597599993, 22.260321356000077],
              [-77.83958899599992, 22.27374909100007],
              [-77.85069739499994, 22.288804429000038],
              [-77.8684789699999, 22.30174388200004],
              [-77.88068600199995, 22.308742580000057],
              [-77.85610917899993, 22.312445380000042],
              [-77.83421790299991, 22.29588450700004],
              [-77.8184301419999, 22.271144924000055],
              [-77.80573482999995, 22.228216864000046],
              [-77.79015051999994, 22.211493231000077],
              [-77.77204342399995, 22.196112372000073],
              [-77.75772050699993, 22.17837148600006],
              [-77.78172766799992, 22.177801825000074],
              [-77.80711829299992, 22.20258209800005],
              [-77.84707597599993, 22.260321356000077],
            ],
          ],
          [
            [
              [-77.99730383999992, 22.147365627000056],
              [-78.00413977799991, 22.162258205000057],
              [-78.03604081899994, 22.183417059000078],
              [-78.04572506399995, 22.198879299000055],
              [-78.02944902299993, 22.20453522300005],
              [-78.01646887899994, 22.21743398600006],
              [-78.00792395699995, 22.23383209800005],
              [-78.00475012899994, 22.250067450000074],
              [-78.00332597599993, 22.286363023000035],
              [-78.00682532499991, 22.297674872000073],
              [-78.01781165299991, 22.314886786000045],
              [-78.00267493399991, 22.31268952000005],
              [-77.98717200399994, 22.307806708000044],
              [-77.97492428299995, 22.298895575000074],
              [-77.96996008999992, 22.284816799000055],
              [-77.97565670499995, 22.27562083500004],
              [-77.98648027299993, 22.265570380000042],
              [-77.99339758999992, 22.253119208000044],
              [-77.98741614499994, 22.236721096000053],
              [-77.97862708199995, 22.233221747000073],
              [-77.95396887899994, 22.23651764500005],
              [-77.94204667899993, 22.232977606000077],
              [-77.93512936099995, 22.22402578300006],
              [-77.93057206899994, 22.21385325700004],
              [-77.92341061099995, 22.206366278000075],
              [-77.90855872299994, 22.205023505000042],
              [-77.92162024599992, 22.21246979400007],
              [-77.91763261599993, 22.218817450000074],
              [-77.91319739499994, 22.224310614000046],
              [-77.90807044199994, 22.228949286000045],
              [-77.90233313699991, 22.232977606000077],
              [-77.89484615799995, 22.220851955000057],
              [-77.88487708199995, 22.214789130000042],
              [-77.8750707669999, 22.21629466400009],
              [-77.86758378799993, 22.22675202000005],
              [-77.85960852799991, 22.20962148600006],
              [-77.87047278599994, 22.20221588700008],
              [-77.88866126199991, 22.198431708000044],
              [-77.90233313699991, 22.19204336100006],
              [-77.89077714799993, 22.189154364000046],
              [-77.88219153599994, 22.183294989000046],
              [-77.87490800699993, 22.176703192000048],
              [-77.86758378799993, 22.171535549000055],
              [-77.85700436099995, 22.16819896000004],
              [-77.83641516799992, 22.164211330000057],
              [-77.82599850199995, 22.157904364000046],
              [-77.84850012899994, 22.116034247000073],
              [-77.86343339799993, 22.09918854400007],
              [-77.87441972599993, 22.109523830000057],
              [-77.8789770169999, 22.107570705000057],
              [-77.89049231699994, 22.104641018000052],
              [-77.89488684799994, 22.10260651200008],
              [-77.89810136599993, 22.110296942000048],
              [-77.90074622299994, 22.114488023000035],
              [-77.90855872299994, 22.123114325000074],
              [-77.91283118399991, 22.14321523600006],
              [-77.93394934799994, 22.150213934000078],
              [-77.95075436099995, 22.14215729400007],
              [-77.94204667899993, 22.116888739000046],
              [-77.95494544199994, 22.122259833000044],
              [-77.99010169199994, 22.141831773000035],
              [-77.99730383999992, 22.147365627000056],
            ],
          ],
          [
            [
              [-78.19652258999992, 22.32916901200008],
              [-78.17536373599995, 22.341620184000078],
              [-78.1848852199999, 22.358221747000073],
              [-78.20518958199995, 22.367987372000073],
              [-78.21642005099994, 22.35960521000004],
              [-78.21768144399994, 22.35028717700004],
              [-78.22154700399994, 22.339911200000074],
              [-78.22813880099994, 22.33344147300005],
              [-78.23745683499993, 22.336004950000074],
              [-78.24372311099995, 22.346625067000048],
              [-78.2442113919999, 22.359116929000038],
              [-78.23961341099994, 22.366929429000038],
              [-78.23070227799991, 22.363348700000074],
              [-78.23045813699991, 22.38076406500005],
              [-78.24632727799991, 22.40062083500004],
              [-78.26976477799991, 22.41014232000009],
              [-78.29214433499993, 22.396877346000053],
              [-78.29723059799994, 22.402044989000046],
              [-78.30174719999991, 22.403225002000056],
              [-78.30654863199993, 22.40302155200004],
              [-78.31261145699995, 22.40428294500009],
              [-78.29873613199993, 22.420396226000037],
              [-78.27904212099992, 22.425441799000055],
              [-78.24372311099995, 22.424750067000048],
              [-78.21157792899993, 22.43659088700008],
              [-78.19762122299994, 22.437201239000046],
              [-78.18968665299991, 22.424750067000048],
              [-78.16974850199995, 22.43504466400009],
              [-78.14419511599993, 22.428941148000035],
              [-78.11904863199993, 22.413763739000046],
              [-78.10033118399991, 22.396877346000053],
              [-78.09072831899994, 22.384466864000046],
              [-78.08202063699991, 22.369696356000077],
              [-78.07555091099994, 22.354071356000077],
              [-78.07164466099994, 22.320868231000077],
              [-78.06704667899993, 22.31045156500005],
              [-78.04572506399995, 22.288234768000052],
              [-78.03722083199995, 22.288031317000048],
              [-78.02334550699993, 22.283026434000078],
              [-78.01097571499992, 22.281398830000057],
              [-78.02765865799995, 22.266017971000053],
              [-78.05158443899995, 22.27220286700009],
              [-78.10033118399991, 22.301906643000052],
              [-78.12214107999995, 22.305853583000044],
              [-78.14631100199995, 22.305853583000044],
              [-78.17153886599993, 22.31073639500005],
              [-78.19652258999992, 22.32916901200008],
            ],
          ],
          [
            [
              [-78.42617753799993, 22.462591864000046],
              [-78.44566809799994, 22.45457591400009],
              [-78.47276770699995, 22.45115794500009],
              [-78.51805579299992, 22.452093817000048],
              [-78.54084225199995, 22.45848216400009],
              [-78.56822669199994, 22.476304429000038],
              [-78.60952714799993, 22.48346588700008],
              [-78.63841712099992, 22.492010809000078],
              [-78.65599524599992, 22.503119208000044],
              [-78.64159094999991, 22.514146226000037],
              [-78.65697180899991, 22.52997467700004],
              [-78.67735755099994, 22.515692450000074],
              [-78.69359290299991, 22.507513739000046],
              [-78.69619706899994, 22.541449286000045],
              [-78.69253495999993, 22.538723049000055],
              [-78.68317623599995, 22.53461334800005],
              [-78.6797582669999, 22.554429429000038],
              [-78.67064368399991, 22.55654531500005],
              [-78.66002356699994, 22.551906643000052],
              [-78.65217037699995, 22.551703192000048],
              [-78.64126542899993, 22.55337148600006],
              [-78.59691321499992, 22.544867255000042],
              [-78.57258053299995, 22.530462958000044],
              [-78.54442298099991, 22.52838776200008],
              [-78.51598059799994, 22.530462958000044],
              [-78.49079342399995, 22.528469143000052],
              [-78.46642005099994, 22.529852606000077],
              [-78.45055091099994, 22.54173411700009],
              [-78.4368383449999, 22.55540599200009],
              [-78.41905676999994, 22.56195709800005],
              [-78.39635169199994, 22.559800523000035],
              [-78.3723852199999, 22.553534247000073],
              [-78.35204016799992, 22.543036200000074],
              [-78.34056555899991, 22.528469143000052],
              [-78.34422766799992, 22.529852606000077],
              [-78.3535863919999, 22.53461334800005],
              [-78.34911048099991, 22.521144924000055],
              [-78.28221594999991, 22.457464911000045],
              [-78.27847245999993, 22.44867584800005],
              [-78.28148352799991, 22.438788153000075],
              [-78.28868567599994, 22.43891022300005],
              [-78.29767818899995, 22.443101304000038],
              [-78.30577551999994, 22.445257880000042],
              [-78.42992102799991, 22.41860586100006],
              [-78.42992102799991, 22.424750067000048],
              [-78.4278051419999, 22.427801825000074],
              [-78.42528235599991, 22.43032461100006],
              [-78.42332923099991, 22.434393622000073],
              [-78.42247473899994, 22.44212474200009],
              [-78.41954505099994, 22.445868231000077],
              [-78.41295325399994, 22.445379950000074],
              [-78.40607662699995, 22.44403717700004],
              [-78.40196692599994, 22.445257880000042],
              [-78.40111243399991, 22.45465729400007],
              [-78.40461178299995, 22.46430084800005],
              [-78.41283118399991, 22.468817450000074],
              [-78.42617753799993, 22.462591864000046],
            ],
          ],
          [
            [
              [-78.98420162699995, 22.63768138200004],
              [-78.98985755099994, 22.65143463700008],
              [-79.00450598899994, 22.656724351000037],
              [-79.06444251199991, 22.66034577000005],
              [-79.07461503799993, 22.66425202000005],
              [-79.0872289699999, 22.671820380000042],
              [-79.0703832669999, 22.67401764500005],
              [-78.97655188699991, 22.668524481000077],
              [-78.96084550699993, 22.66014232000009],
              [-78.96117102799991, 22.64911530200004],
              [-78.98420162699995, 22.63768138200004],
            ],
          ],
          [
            [
              [-79.35753333199995, 22.63768138200004],
              [-79.36636308499993, 22.63934967700004],
              [-79.37555904899995, 22.64321523600006],
              [-79.38890540299991, 22.651312567000048],
              [-79.40379798099991, 22.66364166900007],
              [-79.43736731699994, 22.698472398000035],
              [-79.45539303299995, 22.692287502000056],
              [-79.47374426999994, 22.69432200700004],
              [-79.49083411399994, 22.702053127000056],
              [-79.51357988199993, 22.718410549000055],
              [-79.52009029899995, 22.72068919500009],
              [-79.52403723899994, 22.725002346000053],
              [-79.5254613919999, 22.736395575000074],
              [-79.52887936099995, 22.740301825000074],
              [-79.54482988199993, 22.75141022300005],
              [-79.54967200399994, 22.753729559000078],
              [-79.55797278599994, 22.760158596000053],
              [-79.56309973899994, 22.774237372000073],
              [-79.57176673099991, 22.788275458000044],
              [-79.59064693899995, 22.794663804000038],
              [-79.62035071499992, 22.783148505000042],
              [-79.63365637899994, 22.78384023600006],
              [-79.63532467399995, 22.80215078300006],
              [-79.60692298099991, 22.810248114000046],
              [-79.58653723899994, 22.81122467700004],
              [-79.56997636599993, 22.80410390800006],
              [-79.51797441299993, 22.74957916900007],
              [-79.49632727799991, 22.73314036700009],
              [-79.45026607999995, 22.719916083000044],
              [-79.41291256399995, 22.691351630000042],
              [-79.37197831899994, 22.676662502000056],
              [-79.35191809799994, 22.65729401200008],
              [-79.33560136599993, 22.63467031500005],
              [-79.32681230399993, 22.616522528000075],
              [-79.34947669199994, 22.635321356000077],
              [-79.35753333199995, 22.63768138200004],
            ],
          ],
          [
            [
              [-79.89537512899994, 22.95917389500005],
              [-79.88711503799993, 22.95970286700009],
              [-79.88784745999993, 22.94627513200004],
              [-79.89854895699995, 22.936712958000044],
              [-79.91982988199993, 22.949286200000074],
              [-79.92935136599993, 22.946478583000044],
              [-79.93980872299994, 22.932847398000035],
              [-79.94969641799992, 22.92841217700004],
              [-79.95742753799993, 22.95302969000005],
              [-79.94302324099993, 22.96112702000005],
              [-79.92723548099991, 22.96629466400009],
              [-79.91100012899994, 22.96637604400007],
              [-79.89537512899994, 22.95917389500005],
            ],
          ],
          [
            [
              [-80.32054602799991, 22.98651764500005],
              [-80.27188066299993, 23.008693752000056],
              [-80.24974524599992, 23.010931708000044],
              [-80.23180091099994, 23.000148830000057],
              [-80.23696855399993, 22.997300523000035],
              [-80.24669348899994, 22.989447333000044],
              [-80.25161699099993, 22.98651764500005],
              [-80.24250240799995, 22.982570705000057],
              [-80.23607337099992, 22.97675202000005],
              [-80.23253333199995, 22.96893952000005],
              [-80.23180091099994, 22.95917389500005],
              [-80.33250891799992, 22.97532786700009],
              [-80.34780839799993, 22.98651764500005],
              [-80.34170488199993, 22.991034247000073],
              [-80.33576412699995, 22.993353583000044],
              [-80.32896887899994, 22.992254950000074],
              [-80.32054602799991, 22.98651764500005],
            ],
          ],
          [
            [
              [-80.19701087099992, 23.124253648000035],
              [-80.1907445949999, 23.111395575000074],
              [-80.17983964799993, 23.10024648600006],
              [-80.16649329299992, 23.09247467700004],
              [-80.15265865799995, 23.089544989000046],
              [-80.13658606699994, 23.089016018000052],
              [-80.13125566299993, 23.08698151200008],
              [-80.1341039699999, 23.082831122000073],
              [-80.14240475199995, 23.075873114000046],
              [-80.16242428299995, 23.067328192000048],
              [-80.18272864499994, 23.07094961100006],
              [-80.22496497299994, 23.089544989000046],
              [-80.22264563699991, 23.099758205000057],
              [-80.21739661399994, 23.107123114000046],
              [-80.21080481699994, 23.114447333000044],
              [-80.20445716099994, 23.124253648000035],
              [-80.19701087099992, 23.124253648000035],
            ],
          ],
          [
            [
              [-80.82823645699995, 23.178900458000044],
              [-80.82079016799992, 23.178900458000044],
              [-80.81110592399995, 23.16429271000004],
              [-80.80479895699995, 23.157538153000075],
              [-80.80483964799993, 23.152899481000077],
              [-80.81403561099995, 23.14476146000004],
              [-80.83063717399995, 23.135646877000056],
              [-80.8426000639999, 23.136664130000042],
              [-80.85317949099993, 23.141750393000052],
              [-80.86554928299995, 23.14476146000004],
              [-80.89781653599994, 23.141750393000052],
              [-80.92218990799995, 23.13385651200008],
              [-80.97166907499991, 23.110663153000075],
              [-80.96043860599991, 23.12213776200008],
              [-80.89981035099993, 23.15916575700004],
              [-80.88194739499994, 23.16278717700004],
              [-80.86253821499992, 23.162176825000074],
              [-80.84129798099991, 23.15778229400007],
              [-80.84520423099991, 23.163234768000052],
              [-80.85081946499992, 23.173651434000078],
              [-80.85496985599991, 23.178900458000044],
              [-80.84813391799992, 23.18512604400007],
              [-80.84373938699991, 23.178208726000037],
              [-80.82823645699995, 23.165228583000044],
              [-80.82823645699995, 23.178900458000044],
            ],
          ],
          [
            [
              [-80.49185136599993, 23.192572333000044],
              [-80.48643958199995, 23.193793036000045],
              [-80.47940019399994, 23.19635651200008],
              [-80.47337805899991, 23.19603099200009],
              [-80.4707738919999, 23.18886953300006],
              [-80.47301184799994, 23.18154531500005],
              [-80.47891191299993, 23.177435614000046],
              [-80.48680579299992, 23.173895575000074],
              [-80.49522864499994, 23.168361721000053],
              [-80.50527910099993, 23.169745184000078],
              [-80.52293860599991, 23.17674388200004],
              [-80.54308020699995, 23.182196356000077],
              [-80.56017005099994, 23.178900458000044],
              [-80.56407630099994, 23.184759833000044],
              [-80.56847083199995, 23.18512604400007],
              [-80.58063717399995, 23.178900458000044],
              [-80.5769750639999, 23.192572333000044],
              [-80.57042395699995, 23.200913804000038],
              [-80.55968176999994, 23.20506419500009],
              [-80.54336503799993, 23.206244208000044],
              [-80.53929602799991, 23.204331773000035],
              [-80.53136145699995, 23.195461330000057],
              [-80.52599036399994, 23.192572333000044],
              [-80.51732337099992, 23.191799221000053],
              [-80.49185136599993, 23.192572333000044],
            ],
          ],
          [
            [
              [-78.58169511599993, 20.66160716400009],
              [-78.57848059799994, 20.65766022300005],
              [-78.57827714799993, 20.64842357000009],
              [-78.58568274599992, 20.64362213700008],
              [-78.59398352799991, 20.64288971600007],
              [-78.60098222599993, 20.64524974200009],
              [-78.60631262899994, 20.650213934000078],
              [-78.61172441299993, 20.653631903000075],
              [-78.61339270699995, 20.657945054000038],
              [-78.60903886599993, 20.660711981000077],
              [-78.60407467399995, 20.658351955000057],
              [-78.57994544199994, 20.653998114000046],
              [-78.58071855399993, 20.657375393000052],
              [-78.58128821499992, 20.659002997000073],
              [-78.58169511599993, 20.66160716400009],
            ],
          ],
          [
            [
              [-78.65151933499993, 20.664943752000056],
              [-78.64362545499995, 20.663275458000044],
              [-78.62975012899994, 20.65884023600006],
              [-78.63117428299995, 20.653143622000073],
              [-78.64647376199991, 20.652289130000042],
              [-78.65615800699993, 20.65851471600007],
              [-78.65469316299993, 20.663804429000038],
              [-78.65151933499993, 20.664943752000056],
            ],
          ],
          [
            [
              [-81.98119055899991, 21.647772528000075],
              [-81.97362219999991, 21.639878648000035],
              [-81.97276770699995, 21.622219143000052],
              [-81.98981686099995, 21.60883209800005],
              [-82.02944902299993, 21.59516022300005],
              [-82.05858313699991, 21.58144765800006],
              [-82.06529700399994, 21.579738674000055],
              [-82.07046464799993, 21.57648346600007],
              [-82.07433020699995, 21.572211005000042],
              [-82.08836829299992, 21.568182684000078],
              [-82.11001542899993, 21.56745026200008],
              [-82.11424719999991, 21.57029857000009],
              [-82.10216223899994, 21.57444896000004],
              [-82.08218339799993, 21.59003327000005],
              [-82.07119706899994, 21.592962958000044],
              [-82.0618383449999, 21.59837474200009],
              [-82.05451412699995, 21.60614655200004],
              [-82.04832923099991, 21.610663153000075],
              [-82.01976477799991, 21.621039130000042],
              [-82.0078832669999, 21.621527411000045],
              [-81.99665279899995, 21.626613674000055],
              [-81.9876195949999, 21.634833075000074],
              [-81.98412024599992, 21.641913153000075],
              [-81.98289954299992, 21.646307684000078],
              [-81.98119055899991, 21.647772528000075],
            ],
          ],
          [
            [
              [-81.85252844999991, 21.66356028900009],
              [-81.83901933499993, 21.66620514500005],
              [-81.83779863199993, 21.661078192000048],
              [-81.85265051999994, 21.64988841400009],
              [-81.87010657499991, 21.639471747000073],
              [-81.90135657499991, 21.615627346000053],
              [-81.91885331899994, 21.61546458500004],
              [-81.93236243399991, 21.62848541900007],
              [-81.93569902299993, 21.641913153000075],
              [-81.93285071499992, 21.64020416900007],
              [-81.92218990799995, 21.629339911000045],
              [-81.90562903599994, 21.631008205000057],
              [-81.89220130099994, 21.641058661000045],
              [-81.88817298099991, 21.647040106000077],
              [-81.89207923099991, 21.647406317000048],
              [-81.88914954299992, 21.649359442000048],
              [-81.85920162699995, 21.66156647300005],
              [-81.85252844999991, 21.66356028900009],
            ],
          ],
          [
            [
              [-82.64517167899993, 21.95453522300005],
              [-82.60773678299995, 21.938706773000035],
              [-82.59117591099994, 21.926662502000056],
              [-82.60289466099994, 21.921942450000074],
              [-82.63011633999992, 21.920721747000073],
              [-82.65786699099993, 21.932074286000045],
              [-82.66808020699995, 21.94912344000005],
              [-82.64517167899993, 21.95453522300005],
            ],
          ],
          [
            [
              [-83.55284583199995, 21.961371161000045],
              [-83.55036373599995, 21.961493231000077],
              [-83.54531816299993, 21.96124909100007],
              [-83.55064856699994, 21.959418036000045],
              [-83.57013912699995, 21.958807684000078],
              [-83.5926000639999, 21.960109768000052],
              [-83.60781816299993, 21.966498114000046],
              [-83.59780839799993, 21.97174713700008],
              [-83.56810462099992, 21.96621328300006],
              [-83.55284583199995, 21.961371161000045],
            ],
          ],
          [
            [
              [-81.55626380099994, 22.06598541900007],
              [-81.54938717399995, 22.058417059000078],
              [-81.54702714799993, 22.044582424000055],
              [-81.55492102799991, 22.04401276200008],
              [-81.56541907499991, 22.04987213700008],
              [-81.57575436099995, 22.04905833500004],
              [-81.58185787699995, 22.050604559000078],
              [-81.58633378799993, 22.056789455000057],
              [-81.58885657499991, 22.06435781500005],
              [-81.58885657499991, 22.072699286000045],
              [-81.58250891799992, 22.076605536000045],
              [-81.57152258999992, 22.07412344000005],
              [-81.56114661399994, 22.069159247000073],
              [-81.55626380099994, 22.06598541900007],
            ],
          ],
          [
            [
              [-78.73766028599994, 22.54840729400007],
              [-78.73542232999995, 22.551255601000037],
              [-78.72826087099992, 22.54791901200008],
              [-78.72883053299995, 22.54165273600006],
              [-78.73619544199994, 22.530585028000075],
              [-78.73875891799992, 22.524318752000056],
              [-78.75698808499993, 22.51854075700004],
              [-78.76598059799994, 22.518784898000035],
              [-78.76789303299995, 22.525213934000078],
              [-78.76813717399995, 22.54165273600006],
              [-78.76219641799992, 22.543524481000077],
              [-78.74828040299991, 22.53978099200009],
              [-78.73888098899994, 22.54100169500009],
              [-78.73766028599994, 22.54840729400007],
            ],
          ],
          [
            [
              [-82.5144750639999, 22.625148830000057],
              [-82.51081295499995, 22.61318594000005],
              [-82.50772050699993, 22.59007396000004],
              [-82.51357988199993, 22.57245514500005],
              [-82.51878821499992, 22.565741278000075],
              [-82.52285722599993, 22.55931224200009],
              [-82.52745520699995, 22.56346263200004],
              [-82.52529863199993, 22.62636953300006],
              [-82.52782141799992, 22.63475169500009],
              [-82.52830969999991, 22.64004140800006],
              [-82.52456620999993, 22.64085521000004],
              [-82.51976477799991, 22.636664130000042],
              [-82.51593990799995, 22.62913646000004],
              [-82.5144750639999, 22.625148830000057],
            ],
          ],
          [
            [
              [-79.22451738199993, 22.63971588700008],
              [-79.21572831899994, 22.643011786000045],
              [-79.17686926999994, 22.644680080000057],
              [-79.18976803299995, 22.634507554000038],
              [-79.20641028599994, 22.62441640800006],
              [-79.21324622299994, 22.62441640800006],
              [-79.21320553299995, 22.63104889500005],
              [-79.21642005099994, 22.63662344000005],
              [-79.22451738199993, 22.63971588700008],
            ],
          ],
          [
            [
              [-79.68008378799993, 22.859442450000074],
              [-79.66637122299994, 22.852118231000077],
              [-79.66079667899993, 22.84516022300005],
              [-79.66982988199993, 22.83624909100007],
              [-79.68529212099992, 22.833685614000046],
              [-79.69237219999991, 22.84015534100007],
              [-79.69229081899994, 22.84715403900009],
              [-79.69517981699994, 22.850490627000056],
              [-79.69908606699994, 22.852484442000048],
              [-79.70457923099991, 22.85175202000005],
              [-79.71153723899994, 22.853461005000042],
              [-79.73086503799993, 22.866115627000056],
              [-79.73985755099994, 22.875799872000073],
              [-79.73875891799992, 22.88580963700008],
              [-79.72618567599994, 22.88898346600007],
              [-79.72826087099992, 22.895331122000073],
              [-79.72752844999991, 22.903957424000055],
              [-79.72215735599991, 22.90721263200004],
              [-79.71544348899994, 22.896144924000055],
              [-79.71833248599995, 22.880031643000052],
              [-79.71129309799994, 22.877834377000056],
              [-79.69200598899994, 22.873928127000056],
              [-79.68586178299995, 22.865301825000074],
              [-79.68008378799993, 22.859442450000074],
            ],
          ],
          [
            [
              [-79.82628333199995, 22.964667059000078],
              [-79.81847083199995, 22.954331773000035],
              [-79.81704667899993, 22.94725169500009],
              [-79.82310950399994, 22.94245026200008],
              [-79.83507239499994, 22.93895091400009],
              [-79.84215247299994, 22.931789455000057],
              [-79.83763587099992, 22.926174221000053],
              [-79.82900956899994, 22.924750067000048],
              [-79.82738196499992, 22.919134833000044],
              [-79.83495032499991, 22.911810614000046],
              [-79.8465063139999, 22.91034577000005],
              [-79.85802161399994, 22.916937567000048],
              [-79.86449133999992, 22.92597077000005],
              [-79.86148027299993, 22.93195221600007],
              [-79.85529537699995, 22.936712958000044],
              [-79.85293535099993, 22.94163646000004],
              [-79.86188717399995, 22.94293854400007],
              [-79.8711645169999, 22.947699286000045],
              [-79.86107337099992, 22.962591864000046],
              [-79.83853105399993, 22.968085028000075],
              [-79.82628333199995, 22.964667059000078],
            ],
          ],
          [
            [
              [-80.06139075399994, 23.04979075700004],
              [-80.05760657499991, 23.04242584800005],
              [-80.05357825399994, 23.02920156500005],
              [-80.05630449099993, 23.026678778000075],
              [-80.06191972599993, 23.03424713700008],
              [-80.06655839799993, 23.038885809000078],
              [-80.07070878799993, 23.03856028900009],
              [-80.07730058499993, 23.03729889500005],
              [-80.08535722599993, 23.038316148000035],
              [-80.09121660099993, 23.04287344000005],
              [-80.09479732999995, 23.04832591400009],
              [-80.09447180899991, 23.05068594000005],
              [-80.09105383999992, 23.049994208000044],
              [-80.08946692599994, 23.055487372000073],
              [-80.08763587099992, 23.06745026200008],
              [-80.07677161399994, 23.06989166900007],
              [-80.06460527299993, 23.05801015800006],
              [-80.06139075399994, 23.04979075700004],
            ],
          ],
          [
            [
              [-80.24469967399995, 23.107489325000074],
              [-80.24217688699991, 23.104315497000073],
              [-80.23814856699994, 23.09764232000009],
              [-80.23940995999993, 23.091009833000044],
              [-80.24461829299992, 23.085272528000075],
              [-80.25031490799995, 23.084865627000056],
              [-80.25706946499992, 23.08930084800005],
              [-80.2617895169999, 23.096177476000037],
              [-80.26585852799991, 23.10374583500004],
              [-80.27379309799994, 23.106268622000073],
              [-80.28856360599991, 23.114081122000073],
              [-80.2930395169999, 23.11587148600006],
              [-80.29474850199995, 23.120428778000075],
              [-80.29645748599995, 23.12262604400007],
              [-80.30296790299991, 23.12641022300005],
              [-80.30573482999995, 23.134507554000038],
              [-80.29600989499994, 23.140448309000078],
              [-80.28856360599991, 23.141750393000052],
              [-80.28111731699994, 23.142320054000038],
              [-80.27245032499991, 23.14004140800006],
              [-80.27257239499994, 23.134466864000046],
              [-80.26553300699993, 23.127427476000037],
              [-80.25088456899994, 23.115301825000074],
              [-80.24469967399995, 23.107489325000074],
            ],
          ],
          [
            [
              [-80.40143795499995, 23.15460846600007],
              [-80.39000403599994, 23.15448639500005],
              [-80.3762914699999, 23.152167059000078],
              [-80.37800045499995, 23.147691148000035],
              [-80.38609778599994, 23.145819403000075],
              [-80.39395097599993, 23.146429755000042],
              [-80.41966712099992, 23.143377997000073],
              [-80.42926998599995, 23.13621653900009],
              [-80.44440670499995, 23.130194403000075],
              [-80.45807857999995, 23.126776434000078],
              [-80.4597875639999, 23.128607489000046],
              [-80.4622289699999, 23.135199286000045],
              [-80.45840410099993, 23.137193101000037],
              [-80.44945227799991, 23.13621653900009],
              [-80.45107988199993, 23.145086981000077],
              [-80.4461156889999, 23.15062083500004],
              [-80.43179277299993, 23.15253327000005],
              [-80.42446855399993, 23.152777411000045],
              [-80.40143795499995, 23.15460846600007],
            ],
          ],
          [
            [
              [-80.66852779899995, 23.212225653000075],
              [-80.66588294199994, 23.20917389500005],
              [-80.66364498599995, 23.20140208500004],
              [-80.66612708199995, 23.194484768000052],
              [-80.67052161399994, 23.19481028900009],
              [-80.67369544199994, 23.19403717700004],
              [-80.67467200399994, 23.186835028000075],
              [-80.67983964799993, 23.185614325000074],
              [-80.69131425699993, 23.18773021000004],
              [-80.69884192599994, 23.18390534100007],
              [-80.70083574099993, 23.17719147300005],
              [-80.70425370999993, 23.18032461100006],
              [-80.70494544199994, 23.193060614000046],
              [-80.69489498599995, 23.203924872000073],
              [-80.67760169199994, 23.210272528000075],
              [-80.66852779899995, 23.212225653000075],
            ],
          ],
          [
            [
              [-80.77501380099994, 23.20661041900007],
              [-80.71247311099995, 23.19989655200004],
              [-80.7110082669999, 23.197007554000038],
              [-80.71190344999991, 23.19082265800006],
              [-80.71776282499991, 23.18895091400009],
              [-80.72516842399995, 23.19277578300006],
              [-80.73228919199994, 23.193060614000046],
              [-80.73680579299992, 23.186753648000035],
              [-80.74083411399994, 23.18427155200004],
              [-80.76207434799994, 23.193182684000078],
              [-80.77383378799993, 23.196600653000075],
              [-80.78075110599991, 23.197699286000045],
              [-80.79922441299993, 23.195868231000077],
              [-80.81004798099991, 23.196600653000075],
              [-80.83849036399994, 23.206244208000044],
              [-80.84825598899994, 23.20848216400009],
              [-80.85562089799993, 23.217718817000048],
              [-80.86143958199995, 23.220363674000055],
              [-80.85732988199993, 23.225816148000035],
              [-80.83788001199991, 23.223537502000056],
              [-80.80992591099994, 23.213812567000048],
              [-80.77501380099994, 23.20661041900007],
            ],
          ],
          [
            [
              [-80.87877356699994, 23.250433661000045],
              [-80.87413489499994, 23.248968817000048],
              [-80.87092037699995, 23.240383205000057],
              [-80.87857011599993, 23.232123114000046],
              [-80.89012610599991, 23.23387278900009],
              [-80.90123450399994, 23.237209377000056],
              [-80.91315670499995, 23.238714911000045],
              [-80.92446855399993, 23.243109442000048],
              [-80.92943274599992, 23.250148830000057],
              [-80.93374589799993, 23.254461981000077],
              [-80.9426977199999, 23.25726959800005],
              [-80.93586178299995, 23.26312897300005],
              [-80.91299394399994, 23.265570380000042],
              [-80.88560950399994, 23.250067450000074],
              [-80.87877356699994, 23.250433661000045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Honduras',
        iso3: 'HND',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-89.36162084999998, 14.415477804000062],
              [-89.36379125999989, 14.44656117800011],
              [-89.36198258499988, 14.462400004000102],
              [-89.35549719299993, 14.475448303000064],
              [-89.34526525899994, 14.481959534000026],
              [-89.32304439299992, 14.487463074000118],
              [-89.31480200199988, 14.495963847000041],
              [-89.30485428899996, 14.513352966000056],
              [-89.29092748999997, 14.528003235000128],
              [-89.25961157199987, 14.554254862000064],
              [-89.2505423589999, 14.565184428000038],
              [-89.24568477499989, 14.572987570000066],
              [-89.23811417699991, 14.577948507000102],
              [-89.22108679199991, 14.580093079000093],
              [-89.20881363999987, 14.577948507000102],
              [-89.18369889399995, 14.56952524800002],
              [-89.17214921099992, 14.570403747000057],
              [-89.16039282299991, 14.581281637000103],
              [-89.15574194399994, 14.59784393400011],
              [-89.15522517999992, 14.615594788000038],
              [-89.15941097099994, 14.665979309000122],
              [-89.15584529599997, 14.672257995000038],
              [-89.1452257899999, 14.683445943000066],
              [-89.1426936449999, 14.691274923],
              [-89.1445023199999, 14.708302308000029],
              [-89.14621323399987, 14.710857664000073],
              [-89.15052262499992, 14.717294007000064],
              [-89.15966935299991, 14.725122986000088],
              [-89.17054724099995, 14.738791403000107],
              [-89.1894091399999, 14.783000590000114],
              [-89.19881424999994, 14.798090108000025],
              [-89.21896805899993, 14.821680400000034],
              [-89.22767553799989, 14.83457367000004],
              [-89.23242976899988, 14.848500468000026],
              [-89.23144791699991, 14.867310690000124],
              [-89.2236189379999, 14.879015401000103],
              [-89.19881424999994, 14.899815165000064],
              [-89.18921495599992, 14.913059034000113],
              [-89.18152848299985, 14.923663839000127],
              [-89.16915197799989, 14.952060038000056],
              [-89.16910030099987, 14.97841501900011],
              [-89.18858231699997, 14.996088359000026],
              [-89.17276932899998, 15.042209575000058],
              [-89.16080623499991, 15.060244649000055],
              [-89.14694031899992, 15.071284391000077],
              [-89.1405232349999, 15.076393534000132],
              [-89.10982743399987, 15.09145721400003],
              [-89.0082832439999, 15.124400940000086],
              [-88.97342749099991, 15.140394796000123],
              [-88.84702693699987, 15.235298564000104],
              [-88.76089940199995, 15.29996181400007],
              [-88.6741951089999, 15.365058086000076],
              [-88.58737870299993, 15.430299581],
              [-88.50001969399997, 15.49590281200004],
              [-88.46743393599988, 15.520739666000068],
              [-88.39899226999992, 15.572797343000033],
              [-88.35256099499992, 15.6169031780001],
              [-88.32230444399991, 15.667261861000085],
              [-88.31667171299995, 15.67459991400007],
              [-88.29558772899995, 15.675013326000098],
              [-88.27969722499992, 15.680749410000047],
              [-88.26499527999994, 15.688604228000074],
              [-88.24776119099994, 15.695683899000088],
              [-88.24158585599986, 15.68824249300009],
              [-88.23491959699996, 15.701575013000095],
              [-88.23574641999997, 15.71242706300005],
              [-88.23261999599993, 15.721418762],
              [-88.22093665299991, 15.72565338700008],
              [-88.21507727799991, 15.723211981000077],
              [-88.16974850199995, 15.691961981000077],
              [-88.14525305899991, 15.684515692000048],
              [-88.11888587099992, 15.695868231000077],
              [-88.06090247299994, 15.75576406500005],
              [-88.03628495999993, 15.77094147300005],
              [-88.04161536399994, 15.786688544000071],
              [-88.03160559799994, 15.789862372000073],
              [-87.9922582669999, 15.78461334800005],
              [-87.93390865799995, 15.818793036000045],
              [-87.92666581899994, 15.83234284100007],
              [-87.92454993399991, 15.842189846000053],
              [-87.93016516799992, 15.84674713700008],
              [-87.94131425699993, 15.84983958500004],
              [-87.95042883999992, 15.856919664000088],
              [-87.95457923099991, 15.86399974200009],
              [-87.95099850199995, 15.86717357000009],
              [-87.90876217399995, 15.868068752000056],
              [-87.89195716099994, 15.87295156500005],
              [-87.87555904899995, 15.884263414000088],
              [-87.84605872299994, 15.893866278000075],
              [-87.76008053299995, 15.899562893000052],
              [-87.74209550699993, 15.904486395000049],
              [-87.73631751199991, 15.91860586100006],
              [-87.72834225199995, 15.92100657800006],
              [-87.72215735599991, 15.92291901200008],
              [-87.70433508999992, 15.920721747000073],
              [-87.68748938699991, 15.914984442000048],
              [-87.64305579299992, 15.889227606000077],
              [-87.62604732999995, 15.88768138200004],
              [-87.62604732999995, 15.893947658000059],
              [-87.63630123599995, 15.903509833000044],
              [-87.62596594999991, 15.914943752000056],
              [-87.59129798099991, 15.935492255000042],
              [-87.61042232999995, 15.910101630000042],
              [-87.61729895699995, 15.894598700000074],
              [-87.60863196499992, 15.88768138200004],
              [-87.60313880099994, 15.88076406500005],
              [-87.50963294199994, 15.798651434000078],
              [-87.47940019399994, 15.786037502000056],
              [-87.4473363919999, 15.792141018000052],
              [-87.44176184799994, 15.797756252000056],
              [-87.43154863199993, 15.813950914000088],
              [-87.42682857999995, 15.818793036000045],
              [-87.41714433499993, 15.819525458000044],
              [-87.39118404899995, 15.818426825000074],
              [-87.38585364499994, 15.82249583500004],
              [-87.37995357999995, 15.839504299000055],
              [-87.36497962099992, 15.848334052000041],
              [-87.34508216099994, 15.85032786700009],
              [-87.24176998599995, 15.827378648000092],
              [-87.15172278599994, 15.79686107000009],
              [-87.05899003799993, 15.78701406500005],
              [-86.95250403599994, 15.763332424000055],
              [-86.91685950399994, 15.76040273600006],
              [-86.87873287699995, 15.764146226000037],
              [-86.81737219999991, 15.78188711100006],
              [-86.7996313139999, 15.78461334800005],
              [-86.79686438699991, 15.787583726000037],
              [-86.78018144399994, 15.800197658000059],
              [-86.77635657499991, 15.801988023000092],
              [-86.77065995999993, 15.80654531500005],
              [-86.75845292899993, 15.802313544000071],
              [-86.74644934799994, 15.795599677000041],
              [-86.74156653599994, 15.792141018000052],
              [-86.69908606699994, 15.788641669000071],
              [-86.50381425699993, 15.805080471000053],
              [-86.47057044199994, 15.804185289000088],
              [-86.43993079299992, 15.792141018000052],
              [-86.43785559799994, 15.790838934000078],
              [-86.41466223899994, 15.77643463700008],
              [-86.39903723899994, 15.772406317000048],
              [-86.37474524599992, 15.77094147300005],
              [-86.35496985599991, 15.773993231000077],
              [-86.33828691299993, 15.781398830000057],
              [-86.24323482999995, 15.83860911700009],
              [-86.21849524599992, 15.865057684000078],
              [-86.20714270699995, 15.87400950700004],
              [-86.17259680899991, 15.887518622000073],
              [-86.13780676999994, 15.895656643000052],
              [-85.99486243399991, 15.90070221600007],
              [-85.98228919199994, 15.90420156500005],
              [-85.97215735599991, 15.90916575700004],
              [-85.93325761599993, 15.936672268000052],
              [-85.9121801419999, 15.95929596600007],
              [-85.90318762899994, 15.98346588700008],
              [-85.91917883999992, 16.003729559000078],
              [-85.9824926419999, 16.012518622000073],
              [-86.01276607999995, 16.019964911000045],
              [-86.00792395699995, 16.031073309000078],
              [-85.98184160099993, 16.033148505000042],
              [-85.90455155799992, 16.018383360000087],
              [-85.85100487999995, 16.00873366500008],
              [-85.81346594999991, 16.00454336100006],
              [-85.76633174499995, 15.991582225000059],
              [-85.71934973899994, 15.979722398000092],
              [-85.7031957669999, 15.97646719000005],
              [-85.69204667899993, 15.971502997000073],
              [-85.68944251199991, 15.96002838700008],
              [-85.68960527299993, 15.946437893000052],
              [-85.68700110599991, 15.935492255000042],
              [-85.67955481699994, 15.935492255000042],
              [-85.68008378799993, 15.942206122000073],
              [-85.67804928299995, 15.945379950000074],
              [-85.67503821499992, 15.947088934000078],
              [-85.67271887899994, 15.949164130000042],
              [-85.65622070299992, 15.948768477000044],
              [-85.64733440599991, 15.935942688000068],
              [-85.62956311599993, 15.922042590000046],
              [-85.60846394299995, 15.907071985000073],
              [-85.56405479299991, 15.888874601000055],
              [-85.48857766799995, 15.869566580000082],
              [-85.43639440699991, 15.873762960000079],
              [-85.36199054199994, 15.881110034000073],
              [-85.25425015699994, 15.884084998000048],
              [-85.19635478099991, 15.90744777000009],
              [-85.12378296899993, 15.958574594000083],
              [-85.0757802359999, 15.986247321000064],
              [-84.99994869699992, 15.987941799000055],
              [-84.95077418299991, 15.972006975000056],
              [-84.85446430099995, 15.929750654000088],
              [-84.73358944199992, 15.895029350000073],
              [-84.67655175099992, 15.876203025000052],
              [-84.66227681599992, 15.865637092000043],
              [-84.6684806159999, 15.853211763000047],
              [-84.68085407899991, 15.83491673900005],
              [-84.68093923499993, 15.819181622000087],
              [-84.68107992599994, 15.794266759000038],
              [-84.66005391399995, 15.774494092000054],
              [-84.64029712899992, 15.771775004000062],
              [-84.61571324599993, 15.77951835600004],
              [-84.61218850599994, 15.799820681000085],
              [-84.60940910599993, 15.808983062000038],
              [-84.5998703269999, 15.808277578000059],
              [-84.59312922499993, 15.795787892000078],
              [-84.57548515299993, 15.783895482000048],
              [-84.55025536699992, 15.787693059000048],
              [-84.52643280699994, 15.784936377000065],
              [-84.47743654599992, 15.778755998000065],
              [-84.46851640499995, 15.789188903000081],
              [-84.45281117099995, 15.795647751000047],
              [-84.47386733799993, 15.804293073000053],
              [-84.49903320499993, 15.809683259000053],
              [-84.57797454099995, 15.822580437000056],
              [-84.60788738999992, 15.835195009000074],
              [-84.63305496699991, 15.847125321000078],
              [-84.64182970999991, 15.862907079000081],
              [-84.60164559299994, 15.854824790000066],
              [-84.4641675819999, 15.829792031000068],
              [-84.3743154579999, 15.820715618000065],
              [-84.31504191199991, 15.81770380200004],
              [-84.29463838299995, 15.811010146000058],
              [-84.24039439199993, 15.767350999000087],
              [-84.16707050899993, 15.709697431000052],
              [-84.0583060919999, 15.620248106000076],
              [-83.95293320699994, 15.532886512000061],
              [-83.89417073999994, 15.485180693000075],
              [-83.81753495999993, 15.439886786000045],
              [-83.79906165299991, 15.429348049000055],
              [-83.78087317599994, 15.421535549000055],
              [-83.74567623599995, 15.415838934000078],
              [-83.73680579299992, 15.411322333000044],
              [-83.72996985599991, 15.401556708000044],
              [-83.72935950399994, 15.393744208000044],
              [-83.73591061099995, 15.388617255000042],
              [-83.7508031889999, 15.386786200000074],
              [-83.76829993399991, 15.393377997000073],
              [-83.80622311099995, 15.422349351000037],
              [-83.83446204299992, 15.431789455000057],
              [-83.85342363199993, 15.44476959800005],
              [-83.86278235599991, 15.448879299000055],
              [-83.89313717399995, 15.449164130000042],
              [-83.90636145699995, 15.451971747000073],
              [-83.91808020699995, 15.46312083500004],
              [-83.9134008449999, 15.46482982000009],
              [-83.90916907499991, 15.46784088700008],
              [-83.90440833199995, 15.46938711100006],
              [-83.91307532499991, 15.481838283000059],
              [-83.94595292899993, 15.517767645000049],
              [-83.95278886599993, 15.517767645000049],
              [-83.96373450399994, 15.512518622000073],
              [-83.97716223899994, 15.520209052000041],
              [-83.99120032499991, 15.531683661000045],
              [-84.00401770699995, 15.537583726000037],
              [-84.02452551999994, 15.535101630000042],
              [-84.03392493399991, 15.528876044000071],
              [-84.04116777299993, 15.520209052000041],
              [-84.05524654899995, 15.510931708000044],
              [-84.06159420499995, 15.51508209800005],
              [-84.08934485599991, 15.524603583000044],
              [-84.07656816299993, 15.535549221000053],
              [-84.07115637899994, 15.54165273600006],
              [-84.06883704299992, 15.548163153000075],
              [-84.07363847599993, 15.550482489000046],
              [-84.08438066299993, 15.55219147300005],
              [-84.09618079299992, 15.55263906500005],
              [-84.10362708199995, 15.551214911000045],
              [-84.10643469999991, 15.540432033000059],
              [-84.10000566299993, 15.523260809000078],
              [-84.08836829299992, 15.50486888200004],
              [-84.07575436099995, 15.490423895000049],
              [-84.07823645699995, 15.488226630000042],
              [-84.07933508999992, 15.487534898000092],
              [-84.08031165299991, 15.486395575000074],
              [-84.08250891799992, 15.482977606000077],
              [-84.08934485599991, 15.482977606000077],
              [-84.11929277299993, 15.53929271000004],
              [-84.13036048099991, 15.551214911000045],
              [-84.14175370999993, 15.553127346000053],
              [-84.15489661399994, 15.55068594000005],
              [-84.1719457669999, 15.545070705000057],
              [-84.18382727799991, 15.54588450700004],
              [-84.20099850199995, 15.54987213700008],
              [-84.21288001199991, 15.551214911000045],
              [-84.2051488919999, 15.528509833000044],
              [-84.19871985599991, 15.520738023000092],
              [-84.18040930899991, 15.514471747000073],
              [-84.18016516799992, 15.50617096600007],
              [-84.18346106699994, 15.494940497000073],
              [-84.18553626199991, 15.482977606000077],
              [-84.17870032499991, 15.482977606000077],
              [-84.17560787699995, 15.49827708500004],
              [-84.1555883449999, 15.507391669000071],
              [-84.1465551419999, 15.535101630000042],
              [-84.13711503799993, 15.53807200700004],
              [-84.12779700399994, 15.532619533000059],
              [-84.11424719999991, 15.49990469000005],
              [-84.09805253799993, 15.473456122000073],
              [-84.09215247299994, 15.450913804000038],
              [-84.11359615799995, 15.44139232000009],
              [-84.12417558499993, 15.430243231000077],
              [-84.1165258449999, 15.404974677000041],
              [-84.09951738199993, 15.37759023600006],
              [-84.08250891799992, 15.36009349200009],
              [-84.0567113919999, 15.346828518000052],
              [-84.03538977799991, 15.341864325000074],
              [-84.02586829299992, 15.351223049000055],
              [-84.03538977799991, 15.380560614000046],
              [-84.02196204299992, 15.370306708000044],
              [-84.01008053299995, 15.356756903000075],
              [-84.00536048099991, 15.341294664000088],
              [-84.01357988199993, 15.325344143000052],
              [-83.99990800699993, 15.30882396000004],
              [-83.98062089799993, 15.30573151200008],
              [-83.93175208199995, 15.311672268000052],
              [-83.93175208199995, 15.304877020000049],
              [-83.94139563699991, 15.305243231000077],
              [-83.94790605399993, 15.303412177000041],
              [-83.95897376199991, 15.298041083000044],
              [-83.95897376199991, 15.291815497000073],
              [-83.95067298099991, 15.274807033000059],
              [-83.93838456899994, 15.25922272300005],
              [-83.92198645699995, 15.247870184000078],
              [-83.90099036399994, 15.243394273000092],
              [-83.88280188699991, 15.24555084800005],
              [-83.85952714799993, 15.251288153000075],
              [-83.83714758999992, 15.25999583500004],
              [-83.82188880099994, 15.270697333000044],
              [-83.83454342399995, 15.282619533000059],
              [-83.87706458199995, 15.304877020000049],
              [-83.88426673099991, 15.311712958000044],
              [-83.88760331899994, 15.31834544500009],
              [-83.89167232999995, 15.323391018000052],
              [-83.90099036399994, 15.325344143000052],
              [-83.91173255099994, 15.326117255000042],
              [-83.98814856699994, 15.352362372000073],
              [-84.00059973899994, 15.36009349200009],
              [-84.02379309799994, 15.39256419500009],
              [-84.03538977799991, 15.401068427000041],
              [-84.02651933499993, 15.408677476000037],
              [-84.01671301999994, 15.413723049000055],
              [-83.99437415299991, 15.421535549000055],
              [-83.90514075399994, 15.38353099200009],
              [-83.89073645699995, 15.363226630000042],
              [-83.88508053299995, 15.35260651200008],
              [-83.87132727799991, 15.34284088700008],
              [-83.85440019399994, 15.335598049000055],
              [-83.82591712099992, 15.329738674000055],
              [-83.81407630099994, 15.321682033000059],
              [-83.80386308499993, 15.310492255000042],
              [-83.79515540299991, 15.298041083000044],
              [-83.80182857999995, 15.29368724200009],
              [-83.80992591099994, 15.286688544000071],
              [-83.81566321499992, 15.284369208000044],
              [-83.81566321499992, 15.278143622000073],
              [-83.79922441299993, 15.274603583000044],
              [-83.78530839799993, 15.284409898000092],
              [-83.77452551999994, 15.285711981000077],
              [-83.76720130099994, 15.256415106000077],
              [-83.76943925699993, 15.219224351000037],
              [-83.76720130099994, 15.20929596600007],
              [-83.7598363919999, 15.202093817000048],
              [-83.75226803299995, 15.202541408000059],
              [-83.74718176999994, 15.20970286700009],
              [-83.7473852199999, 15.22288646000004],
              [-83.73989824099993, 15.22288646000004],
              [-83.73102779899995, 15.20343659100007],
              [-83.72264563699991, 15.20807526200008],
              [-83.70579993399991, 15.237209377000056],
              [-83.6902563139999, 15.245917059000078],
              [-83.66954505099994, 15.251898505000042],
              [-83.63377844999991, 15.256415106000077],
              [-83.62938391799992, 15.261135158000059],
              [-83.63145911399994, 15.28384023600006],
              [-83.63003495999993, 15.291815497000073],
              [-83.62336178299995, 15.296087958000044],
              [-83.61701412699995, 15.295599677000041],
              [-83.60948645699995, 15.29328034100007],
              [-83.54466712099992, 15.280991929000038],
              [-83.52765865799995, 15.284369208000044],
              [-83.52765865799995, 15.278143622000073],
              [-83.53359941299993, 15.272162177000041],
              [-83.53294837099992, 15.268133856000077],
              [-83.52965247299994, 15.263739325000074],
              [-83.52765865799995, 15.256415106000077],
              [-83.52765865799995, 15.226304429000038],
              [-83.53286699099993, 15.21124909100007],
              [-83.54442298099991, 15.20498281500005],
              [-83.55589758999992, 15.20929596600007],
              [-83.56114661399994, 15.226304429000038],
              [-83.56480872299994, 15.231390692000048],
              [-83.57347571499992, 15.234767971000053],
              [-83.58385169199994, 15.23663971600007],
              [-83.59251868399991, 15.237209377000056],
              [-83.59850012899994, 15.233099677000041],
              [-83.60391191299993, 15.224025783000059],
              [-83.61021887899994, 15.20929596600007],
              [-83.61473548099991, 15.20408763200004],
              [-83.61913001199991, 15.200873114000046],
              [-83.62246660099993, 15.19594961100006],
              [-83.6238500639999, 15.185370184000078],
              [-83.62144934799994, 15.176174221000053],
              [-83.61579342399995, 15.174505927000041],
              [-83.60899817599994, 15.177394924000055],
              [-83.60338294199994, 15.18195221600007],
              [-83.60846920499995, 15.19041575700004],
              [-83.60948645699995, 15.196926174000055],
              [-83.6074926419999, 15.202826239000046],
              [-83.60338294199994, 15.20929596600007],
              [-83.59593665299991, 15.20929596600007],
              [-83.59386145699995, 15.184759833000044],
              [-83.58702551999994, 15.167181708000044],
              [-83.57445227799991, 15.16046784100007],
              [-83.55492102799991, 15.16828034100007],
              [-83.54954993399991, 15.174017645000049],
              [-83.54043535099993, 15.188666083000044],
              [-83.5344945949999, 15.195013739000046],
              [-83.52660071499992, 15.199896552000041],
              [-83.48180091099994, 15.21556224200009],
              [-83.48216712099992, 15.21906159100007],
              [-83.48668372299994, 15.229722398000092],
              [-83.49087480399993, 15.235907294000071],
              [-83.49657141799992, 15.24046458500004],
              [-83.50230872299994, 15.246283270000049],
              [-83.50649980399993, 15.256415106000077],
              [-83.50987708199995, 15.27057526200008],
              [-83.51720130099994, 15.28969961100006],
              [-83.52961178299995, 15.30101146000004],
              [-83.5481664699999, 15.291815497000073],
              [-83.57787024599992, 15.309068101000037],
              [-83.59264075399994, 15.312241929000038],
              [-83.61021887899994, 15.304877020000049],
              [-83.61636308499993, 15.311672268000052],
              [-83.61412512899994, 15.31541575700004],
              [-83.61021887899994, 15.325344143000052],
              [-83.62633216099994, 15.327460028000075],
              [-83.66958574099993, 15.342922268000052],
              [-83.67845618399991, 15.349269924000055],
              [-83.68895423099991, 15.360581773000092],
              [-83.70982825399994, 15.36709219000005],
              [-83.72533118399991, 15.375881252000056],
              [-83.71939042899993, 15.394232489000046],
              [-83.70299231699994, 15.402004299000055],
              [-83.68740800699993, 15.393744208000044],
              [-83.67332923099991, 15.380601304000038],
              [-83.66136633999992, 15.37376536700009],
              [-83.65062415299991, 15.370306708000044],
              [-83.54259192599994, 15.315741278000075],
              [-83.40802975199995, 15.266424872000073],
              [-83.35631262899994, 15.229722398000092],
              [-83.3445531889999, 15.210882880000042],
              [-83.32843990799995, 15.146633205000057],
              [-83.31086178299995, 15.10643138200004],
              [-83.28429114499994, 15.06834544500009],
              [-83.25381425699993, 15.044623114000046],
              [-83.13044447244795, 14.997012021272383],
              [-83.14365413499993, 14.994899801000088],
              [-83.1773988439999, 14.996811829000109],
              [-83.19132564299989, 14.994253845000117],
              [-83.21773230099987, 14.982497457000122],
              [-83.26201900299989, 14.98319508900002],
              [-83.2661531169999, 14.982497457000122],
              [-83.27832291699991, 14.987122498000076],
              [-83.28566097099991, 14.992109274000128],
              [-83.2848858239999, 14.997380269000075],
              [-83.27297440599995, 15.003038839000098],
              [-83.31705440299993, 15.007560526000134],
              [-83.33423681699992, 15.00644948300004],
              [-83.34935217299991, 14.996811829000109],
              [-83.35454565399993, 15.010066834000028],
              [-83.36498429399987, 15.016345521000119],
              [-83.37782588699994, 15.021254781000053],
              [-83.39030574599994, 15.030969950000099],
              [-83.39989172399993, 15.013632508000086],
              [-83.41547216799998, 14.996941020000051],
              [-83.43572932999987, 14.985184631000052],
              [-83.45919042999995, 14.982497457000122],
              [-83.46838883499996, 14.987406719000063],
              [-83.48055863499988, 15.005545146000088],
              [-83.48585546899992, 15.01048024500004],
              [-83.49900712099989, 15.012650655000115],
              [-83.50908402499991, 15.011539612000107],
              [-83.51246883199994, 15.006501160000141],
              [-83.50572505699989, 14.996811829000109],
              [-83.51099605299993, 14.99017140700002],
              [-83.51262386099998, 14.984021911000042],
              [-83.51321813999994, 14.96885487900002],
              [-83.5230366619999, 14.977691548000024],
              [-83.52861771699992, 14.973402405000058],
              [-83.52990962799987, 14.961775207000088],
              [-83.52686071799994, 14.94836517400006],
              [-83.53249344899987, 14.951026509000073],
              [-83.54735042399992, 14.955212301000103],
              [-83.54512833699991, 14.952163391000084],
              [-83.54244116199988, 14.945083720000056],
              [-83.54047745899993, 14.941569723000015],
              [-83.55486934399994, 14.937409770000073],
              [-83.57977738499991, 14.918108623000123],
              [-83.60427201399997, 14.90919443700011],
              [-83.60918127499991, 14.89836822500007],
              [-83.61130000899988, 14.884906514000107],
              [-83.61561499099986, 14.872685038000085],
              [-83.62305639699989, 14.872685038000085],
              [-83.63155716999998, 14.883201192000044],
              [-83.64995397999988, 14.888498027000082],
              [-83.6721490079999, 14.88963490800009],
              [-83.6919669189999, 14.886973572000073],
              [-83.71062211099988, 14.878343607000119],
              [-83.71449784399994, 14.86723317500011],
              [-83.70501521899985, 14.83852691700011],
              [-83.71243078599986, 14.83852691700011],
              [-83.7162031659999, 14.847053528000032],
              [-83.7236187339999, 14.851575216000057],
              [-83.73392818199991, 14.852970480000039],
              [-83.74656306999992, 14.852195333000026],
              [-83.74452185199988, 14.836666565000101],
              [-83.76529577699992, 14.82878590900006],
              [-83.82105464699987, 14.825478618000062],
              [-83.81392329999994, 14.81377390600008],
              [-83.8089881999999, 14.808890483000056],
              [-83.80121089699989, 14.803774516000061],
              [-83.81965938399989, 14.80361948600003],
              [-83.83950313299988, 14.797418315000044],
              [-83.85730566499993, 14.787780661000028],
              [-83.86947546399992, 14.77710947700011],
              [-83.87526322499991, 14.784266663000068],
              [-83.87875138399994, 14.786747132000045],
              [-83.88267879199992, 14.78783233700004],
              [-83.88993933099991, 14.790726216000024],
              [-83.88500423199986, 14.781346944000077],
              [-83.88376399799992, 14.77710947700011],
              [-83.89655391499988, 14.780442606000122],
              [-83.91265112299996, 14.797185771000073],
              [-83.92471756999993, 14.803774516000061],
              [-83.92965266999988, 14.780881857000054],
              [-83.92985937599994, 14.771657613000045],
              [-83.92471756999993, 14.763441061],
              [-84.02357458499989, 14.758325094000028],
              [-84.04075699899997, 14.76034047400006],
              [-84.0426690269999, 14.76806610100006],
              [-84.04781083299989, 14.770804952000105],
              [-84.06468318699987, 14.770262349000063],
              [-84.07519934099992, 14.771631775000031],
              [-84.07897172099987, 14.77517161100009],
              [-84.08155554199996, 14.779796651000055],
              [-84.10444820199987, 14.793930156000087],
              [-84.11176041699986, 14.793413392000048],
              [-84.12271582099993, 14.784525045000038],
              [-84.1111144619999, 14.761038106000058],
              [-84.1041898199999, 14.751865540000068],
              [-84.09543066399993, 14.743597310000027],
              [-84.09543066399993, 14.736104228000073],
              [-84.10227779199988, 14.731866760000031],
              [-84.10651525899993, 14.732331848000058],
              [-84.11121781499992, 14.734708964000092],
              [-84.11961523499991, 14.736104228000073],
              [-84.12873612499988, 14.734192200000066],
              [-84.13385209199987, 14.73003224700004],
              [-84.13788285399997, 14.725226339000116],
              [-84.14379980499987, 14.721867371000101],
              [-84.16819108199991, 14.714968567000128],
              [-84.18289302699989, 14.713857523000044],
              [-84.1950111489999, 14.718715108000055],
              [-84.2186789559999, 14.743442282000075],
              [-84.2263787439999, 14.749772644000089],
              [-84.23539628099985, 14.754733582000128],
              [-84.24921972699991, 14.759410298000105],
              [-84.26180293899992, 14.758531799000068],
              [-84.26733231699984, 14.746672058000058],
              [-84.26216467299992, 14.699749858000104],
              [-84.26728063999991, 14.67773569800002],
              [-84.28779618399989, 14.667219544000062],
              [-84.2988807779999, 14.667994690000072],
              [-84.32316870199992, 14.673317363000109],
              [-84.33838741099993, 14.674686788000088],
              [-84.34603552299993, 14.679983622000037],
              [-84.35319270899996, 14.705976868000093],
              [-84.3629337159999, 14.715614523000113],
              [-84.3761370449999, 14.696726787000074],
              [-84.39001216699995, 14.671482849000114],
              [-84.40843481499988, 14.649417013000033],
              [-84.4457193609999, 14.636678772000067],
              [-84.47160925299994, 14.622622783000054],
              [-84.48269384799994, 14.619470520000093],
              [-84.4980159099999, 14.623914693000089],
              [-84.50848038799987, 14.632622172000069],
              [-84.51904821799994, 14.638280742000092],
              [-84.53421525099995, 14.633733215000063],
              [-84.53121801799992, 14.653318583000086],
              [-84.5274197999999, 14.6603982540001],
              [-84.60043859899994, 14.662516989000082],
              [-84.62296952399996, 14.667219544000062],
              [-84.66170100999989, 14.683445943000066],
              [-84.6808471279999, 14.68546132500012],
              [-84.69932145199991, 14.674686788000088],
              [-84.71441097099992, 14.708922424000093],
              [-84.72484960999995, 14.725639750000127],
              [-84.7452876379999, 14.73910146100009],
              [-84.74427994799993, 14.752408142000107],
              [-84.74704463799989, 14.764474590000091],
              [-84.7669400639999, 14.766903381000049],
              [-84.76639746199993, 14.768867086000085],
              [-84.7585684819999, 14.778659770000047],
              [-84.75546789599986, 14.781476135000105],
              [-84.77016984099996, 14.805143942000129],
              [-84.79213232499993, 14.821060283000065],
              [-84.81809973199998, 14.828656718000033],
              [-84.84442887399993, 14.827545675000124],
              [-84.90421850699988, 14.81697784400005],
              [-84.92062577299993, 14.807701925000032],
              [-84.96646276899989, 14.764629618000129],
              [-84.98436865199994, 14.752227275000067],
              [-84.9999482899999, 14.742015988000105],
              [-85.00199031699995, 14.740677592000026],
              [-85.01565873299987, 14.728171896000035],
              [-85.02454707899997, 14.712539775000081],
              [-85.0297922369999, 14.675539449000027],
              [-85.0330478519999, 14.669570821],
              [-85.03821549499989, 14.667219544000062],
              [-85.05392513099986, 14.66305959100012],
              [-85.04852494399998, 14.653318583000086],
              [-85.02020625799989, 14.633733215000063],
              [-85.04222041899988, 14.61347605400006],
              [-85.04816320799989, 14.605776266000063],
              [-85.02222163999994, 14.605802104000077],
              [-85.02365718199988, 14.602540872000063],
              [-85.02963720699995, 14.5889555870001],
              [-85.06524226899984, 14.554254862000064],
              [-85.08637792999988, 14.544539693000033],
              [-85.1033536379999, 14.556864522000083],
              [-85.11932165599993, 14.573969422000033],
              [-85.13753759899987, 14.578491109000055],
              [-85.14546992999993, 14.564254252000083],
              [-85.1498107509999, 14.536504008000051],
              [-85.15182613199994, 14.485964457000108],
              [-85.15539180599993, 14.47947906500005],
              [-85.1784911709999, 14.455604553000072],
              [-85.17967972899993, 14.44924835200004],
              [-85.17735428899991, 14.433977966000086],
              [-85.1784911709999, 14.427647603000068],
              [-85.20582800299994, 14.407157899000097],
              [-85.18973079499995, 14.396848450000093],
              [-85.17187658799992, 14.381009623000097],
              [-85.15903499399991, 14.361062520000075],
              [-85.15802730299993, 14.338273214000083],
              [-85.16962866299988, 14.321762594000091],
              [-85.19019588299997, 14.309644470000109],
              [-85.21520727499987, 14.301582947000028],
              [-85.23996028699992, 14.297319641000058],
              [-85.2778132739999, 14.297319641000058],
              [-85.2882002369999, 14.295149231000067],
              [-85.31197139499997, 14.283651225000142],
              [-85.3213506669999, 14.28132578600011],
              [-85.3268283699999, 14.275744731000088],
              [-85.3308849689999, 14.26900095700006],
              [-85.33796463999994, 14.260681050000102],
              [-85.3408068439999, 14.253368836000021],
              [-85.34362320999986, 14.250113221000035],
              [-85.34780900099992, 14.249234721000093],
              [-85.35853186099993, 14.250888367000044],
              [-85.36287268099991, 14.250113221000035],
              [-85.37251033599992, 14.241095683000083],
              [-85.38400834199985, 14.226445414000096],
              [-85.39362015799995, 14.210761617000045],
              [-85.40088069699993, 14.18518178300009],
              [-85.40912308799997, 14.166164856000123],
              [-85.42015600599987, 14.146863708000083],
              [-85.4317315269999, 14.132833557000069],
              [-85.45762141999984, 14.113041483000089],
              [-85.47467464199988, 14.103403829000072],
              [-85.51064143899995, 14.093792013000055],
              [-85.51640336199992, 14.080537008000064],
              [-85.51862544799991, 14.064594828000025],
              [-85.52795304399987, 14.050900574000096],
              [-85.54663407499993, 14.044906108000077],
              [-85.56314591299991, 14.042012281000098],
              [-85.57169714399993, 14.04051361100008],
              [-85.59360795099988, 14.033459778000065],
              [-85.60306473799994, 14.01953298000008],
              [-85.6128057459999, 14.009740295000114],
              [-85.64786820499992, 13.999301657000089],
              [-85.64461258999995, 13.988785503000116],
              [-85.64766149999988, 13.98780365000006],
              [-85.65040035099992, 13.987855327000076],
              [-85.65195064399984, 13.986692607000066],
              [-85.65148555599993, 13.981990052000086],
              [-85.65766088899989, 13.981990052000086],
              [-85.66618750099991, 13.984470520000059],
              [-85.68649633799993, 13.9673397830001],
              [-85.69923457899989, 13.961500346000022],
              [-85.71698543399992, 13.962688904000046],
              [-85.72734655799994, 13.965014344000068],
              [-85.73220414299993, 13.959536641000085],
              [-85.73339269999988, 13.937625834000116],
              [-85.74328873799996, 13.907550151000052],
              [-85.74744868999989, 13.88827484200003],
              [-85.74367630999987, 13.879567363000149],
              [-85.72869014499989, 13.87501983700011],
              [-85.72300573799996, 13.86341847800007],
              [-85.72512447199992, 13.847941386000059],
              [-85.73339269999988, 13.831792501000066],
              [-85.7402931119999, 13.825639142000043],
              [-85.74246191399993, 13.823705139000069],
              [-85.74311460299992, 13.823958222000059],
              [-85.74499405999993, 13.824686991000135],
              [-85.75830074099994, 13.83928558400001],
              [-85.77866125499989, 13.84093923000006],
              [-85.80201900199992, 13.840215760000063],
              [-85.82416235399984, 13.84768300400009],
              [-85.84010453299996, 13.866570740000029],
              [-85.84987137899992, 13.887086283000087],
              [-85.8616019289999, 13.904423727000108],
              [-85.88356441299987, 13.913854675000067],
              [-85.89720699099988, 13.913027853000045],
              [-85.90630204299995, 13.909358826000044],
              [-85.91550044799996, 13.907446798000123],
              [-85.92940140799993, 13.91209767700009],
              [-85.93611934499995, 13.918195496000052],
              [-85.95777176899995, 13.94610076900004],
              [-86.02841345299993, 13.996071879000098],
              [-86.0312556559999, 14.022581889000023],
              [-86.02045528199997, 14.044079284000048],
              [-86.02019689999989, 14.055163879000062],
              [-86.0967296959999, 14.044079284000048],
              [-86.11047562699991, 14.037128805000066],
              [-86.12168941299987, 14.027206930000062],
              [-86.12690873199989, 14.018551127000109],
              [-86.13083614199988, 14.008913473000092],
              [-86.1380191659999, 13.996175232000041],
              [-86.14969803999989, 13.98426381500009],
              [-86.16179032499988, 13.978114319000028],
              [-86.17357255099998, 13.973670146000117],
              [-86.18406286699991, 13.966874695000072],
              [-86.21858272299991, 13.91437144000011],
              [-86.2841084399999, 13.845719299000052],
              [-86.29992142799989, 13.82132802300012],
              [-86.30777624499984, 13.79169158900008],
              [-86.31356400599992, 13.776602072000074],
              [-86.32519120299986, 13.76376047800008],
              [-86.34012569199993, 13.756654968000063],
              [-86.35847082599992, 13.75226247200007],
              [-86.41009558099992, 13.749032695000082],
              [-86.41707189999994, 13.750014547000148],
              [-86.42652868699992, 13.752985942000066],
              [-86.43247147699992, 13.757120056000076],
              [-86.44823278899989, 13.772958883000086],
              [-86.46285721899997, 13.770943502000137],
              [-86.47629309199993, 13.764018860000064],
              [-86.49081416899986, 13.759497172000124],
              [-86.50853918499988, 13.764380595000148],
              [-86.5416637779999, 13.78213145000008],
              [-86.58114457199991, 13.77985768700006],
              [-86.66268998299995, 13.764690654000049],
              [-86.7063048919999, 13.770013326000083],
              [-86.7272338469999, 13.768256327000103],
              [-86.74991979999987, 13.757120056000076],
              [-86.7614436449999, 13.749342753000064],
              [-86.76619787699988, 13.745260315000067],
              [-86.76790319899996, 13.739162496000105],
              [-86.77022863799988, 13.72523569800012],
              [-86.77116759299986, 13.707890404000082],
              [-86.77405269399992, 13.65459401500003],
              [-86.7721406659999, 13.645524801000064],
              [-86.76821325699984, 13.640357158000057],
              [-86.7641295649999, 13.637335555000078],
              [-86.75539750199997, 13.630874532000078],
              [-86.75157344599992, 13.624414978000033],
              [-86.75090165199992, 13.608421122000081],
              [-86.75710282399993, 13.576407573000083],
              [-86.75658605999988, 13.559380188000148],
              [-86.72428828999992, 13.439413351000056],
              [-86.72594193599986, 13.423832906000115],
              [-86.73865433799992, 13.39621185300011],
              [-86.74020463099993, 13.381923320000041],
              [-86.73638057499988, 13.371949768000121],
              [-86.73043778499988, 13.368900858000103],
              [-86.72361649699991, 13.367324727000067],
              [-86.71715694199986, 13.361640320000035],
              [-86.70992224199989, 13.34890207900007],
              [-86.70780350799993, 13.34283009900011],
              [-86.70186071799992, 13.314201355000137],
              [-86.7040311289999, 13.298827616000068],
              [-86.7117825929999, 13.285675965000081],
              [-86.72547684799991, 13.273299459000029],
              [-86.73271527199995, 13.268469503000077],
              [-86.73984289599994, 13.26371348100011],
              [-86.74929968299989, 13.26128468800006],
              [-86.75865311799993, 13.264178569000052],
              [-86.81622066299988, 13.291928813000084],
              [-86.83342891499987, 13.293349915000078],
              [-86.84950028499992, 13.288828227000053],
              [-86.86272945199991, 13.279939880000128],
              [-86.91078853399998, 13.239580587000063],
              [-86.91885005799986, 13.229762065000088],
              [-86.9259814049999, 13.216352031000056],
              [-86.93321610499987, 13.18818837500001],
              [-86.93492142799994, 13.185527038000075],
              [-86.93306107699993, 13.1797134400001],
              [-86.92551631799998, 13.163642070000037],
              [-86.9237076419999, 13.161135763000047],
              [-86.93233760599992, 13.108529155000056],
              [-86.92980546099994, 13.102224630000137],
              [-86.92417272999992, 13.099795838000077],
              [-86.92024532099995, 13.096178487000103],
              [-86.92293249499997, 13.08638580400013],
              [-86.92799678599994, 13.081243998000048],
              [-86.94272456899995, 13.074060975000094],
              [-86.9484089769999, 13.06969431600001],
              [-86.97181840099995, 13.03388254800008],
              [-86.98318721499996, 13.02186777700011],
              [-87.0087670499999, 13.00608062800012],
              [-87.02961848999988, 12.996081238000102],
              [-87.03504451599994, 12.979777324000068],
              [-87.04685257999995, 12.980552470000077],
              [-87.0698485929999, 12.994375915000134],
              [-87.08465389099993, 12.99592620900006],
              [-87.31403561099995, 12.98155345300006],
              [-87.31362870999993, 12.981838283000059],
              [-87.30394446499992, 12.988470770000049],
              [-87.3008113269999, 13.001247463000084],
              [-87.29356848899994, 13.011053778000075],
              [-87.28282630099994, 13.01821523600006],
              [-87.26915442599994, 13.023220119000086],
              [-87.26915442599994, 13.029445705000057],
              [-87.29678300699993, 13.03034088700008],
              [-87.3166804679999, 13.034206447000088],
              [-87.33177649599992, 13.042669989000046],
              [-87.34483801999994, 13.057318427000041],
              [-87.3513484369999, 13.067206122000073],
              [-87.3528132799999, 13.072536526000079],
              [-87.35106360599991, 13.088405666000085],
              [-87.34471594999991, 13.090765692000048],
              [-87.31407630099994, 13.095404364000046],
              [-87.30394446499992, 13.098334052000041],
              [-87.36180579299992, 13.113348700000074],
              [-87.3945613269999, 13.116848049000055],
              [-87.4131160149999, 13.111354885000083],
              [-87.41934160099993, 13.111354885000083],
              [-87.42210852799991, 13.14992910400008],
              [-87.43578040299991, 13.189398505000042],
              [-87.45506751199991, 13.224310614000046],
              [-87.47459876199991, 13.249172268000052],
              [-87.48082434799994, 13.26516347900008],
              [-87.48204505099994, 13.26593659100007],
              [-87.48452714799993, 13.270086981000077],
              [-87.49034583199995, 13.269720770000049],
              [-87.49697831899994, 13.268337307000081],
              [-87.50194251199991, 13.269598700000074],
              [-87.50890051999994, 13.278631903000075],
              [-87.51223710799991, 13.286688544000071],
              [-87.51048743399991, 13.294948635000083],
              [-87.50194251199991, 13.304388739000046],
              [-87.4934382799999, 13.309759833000044],
              [-87.47667395699995, 13.317328192000048],
              [-87.46776282499991, 13.324896552000041],
              [-87.44778398299991, 13.352565822000088],
              [-87.44041907499991, 13.359035549000055],
              [-87.42690995999993, 13.356024481000077],
              [-87.41112219999991, 13.359808661000045],
              [-87.37901770699995, 13.372015692000048],
              [-87.3804011709999, 13.380438544000071],
              [-87.38036048099991, 13.386297919000071],
              [-87.37901770699995, 13.393133856000077],
              [-87.39378821499992, 13.406439520000049],
              [-87.40062415299991, 13.411159572000088],
              [-87.40977942599994, 13.413031317000048],
              [-87.42983964799993, 13.409369208000044],
              [-87.4377742179999, 13.411037502000056],
              [-87.4472957019999, 13.420477606000077],
              [-87.4643855459999, 13.408270575000074],
              [-87.46963456899994, 13.40298086100006],
              [-87.47459876199991, 13.393133856000077],
              [-87.47642981699994, 13.379706122000073],
              [-87.47305253799993, 13.372463283000059],
              [-87.47227942599994, 13.367010809000078],
              [-87.48204505099994, 13.359035549000055],
              [-87.48827063699991, 13.358303127000056],
              [-87.5229792959999, 13.359035549000055],
              [-87.5386042959999, 13.355292059000078],
              [-87.54759680899991, 13.35500722900008],
              [-87.55715898299991, 13.359035549000055],
              [-87.55715898299991, 13.36587148600006],
              [-87.54283606699994, 13.36587148600006],
              [-87.54283606699994, 13.372015692000048],
              [-87.5617976549999, 13.376003322000088],
              [-87.5813289049999, 13.382879950000074],
              [-87.59886633999992, 13.384344794000071],
              [-87.61180579299992, 13.372015692000048],
              [-87.61856035099993, 13.372015692000048],
              [-87.6167292959999, 13.381862697000088],
              [-87.60558020699995, 13.406805731000077],
              [-87.61925208199995, 13.41201406500005],
              [-87.62242591099994, 13.423000393000052],
              [-87.61856035099993, 13.451198635000083],
              [-87.62401282499991, 13.46625397300005],
              [-87.63646399599992, 13.463690497000073],
              [-87.65038001199991, 13.452297268000052],
              [-87.66014563699991, 13.44094472900008],
              [-87.65099036399994, 13.412543036000045],
              [-87.66567949099993, 13.386013088000084],
              [-87.69277910099993, 13.366481838000084],
              [-87.7209773429999, 13.359035549000055],
              [-87.73888098899994, 13.36237213700008],
              [-87.76223710799991, 13.376369533000059],
              [-87.78136145699995, 13.382595119000086],
              [-87.78294837099992, 13.389431057000081],
              [-87.78294837099992, 13.396266994000086],
              [-87.78648841099994, 13.399359442000048],
              [-87.79625403599994, 13.39984772300005],
              [-87.8030085929999, 13.401393947000088],
              [-87.8171687489999, 13.40656159100007],
              [-87.73841243499996, 13.441687113000071],
              [-87.72115250699994, 13.460833232000084],
              [-87.71880122899992, 13.473674825000074],
              [-87.7205840659999, 13.486981507000081],
              [-87.72572587199991, 13.498970439000047],
              [-87.73342565999991, 13.507703756000112],
              [-87.74797257499995, 13.513233135000107],
              [-87.7691599119999, 13.506360168000057],
              [-87.77946936099991, 13.509977519000131],
              [-87.78993383899984, 13.53281850200004],
              [-87.78406856399994, 13.560465394000047],
              [-87.76009069899993, 13.616947734000092],
              [-87.75781693599993, 13.635163676000047],
              [-87.75864375799995, 13.672267355000116],
              [-87.75502640799996, 13.689914857000119],
              [-87.74631892999989, 13.702188009000054],
              [-87.73629370099988, 13.711463929000075],
              [-87.73135860299993, 13.72221262700009],
              [-87.73784399399989, 13.738774923000094],
              [-87.73280554199994, 13.75510467600013],
              [-87.71262589599985, 13.800450745000148],
              [-87.70360835799988, 13.814997661000106],
              [-87.72120418399987, 13.821896464000076],
              [-87.74952872299991, 13.845627388000096],
              [-87.76533585599987, 13.858870952000117],
              [-87.77143367499991, 13.862126567000104],
              [-87.78541215099992, 13.86739756200005],
              [-87.79060563199994, 13.870472310000082],
              [-87.79871883199993, 13.882332051000105],
              [-87.8084598399999, 13.908635356000048],
              [-87.81789078799994, 13.915870057000106],
              [-87.83290279199991, 13.915249939000134],
              [-87.84295385799996, 13.907110901000038],
              [-87.8512220879999, 13.896878968000053],
              [-87.86091141799994, 13.890186870000036],
              [-87.87054907299995, 13.889566752000064],
              [-87.89010860299996, 13.893545837000147],
              [-87.90010799199987, 13.894140117000106],
              [-87.90788529499989, 13.891530457000101],
              [-87.9207527259999, 13.881866963000078],
              [-87.92532609099993, 13.879619039000062],
              [-87.93217321799989, 13.881556905000096],
              [-87.94692683999992, 13.89091033900013],
              [-87.95259489399993, 13.89202903500005],
              [-87.95478165699984, 13.892460633000056],
              [-87.9697419849999, 13.888533223000081],
              [-88.0153205979999, 13.86636403500006],
              [-88.02364050299985, 13.891168722000103],
              [-88.03997025599998, 13.910133972000054],
              [-88.0583929039999, 13.926489563000104],
              [-88.07288814399993, 13.94341359500001],
              [-88.0875384119999, 13.980543112000092],
              [-88.09903641799994, 13.98981903100011],
              [-88.12539139799989, 13.991265971000104],
              [-88.17753291899996, 13.985193990000056],
              [-88.19347509799991, 13.985555725000054],
              [-88.2176588129999, 13.99079670500008],
              [-88.2200626229999, 13.991317647000116],
              [-88.23507462599989, 13.992867941000043],
              [-88.24489314799987, 13.989250591000058],
              [-88.2453582359999, 13.98589162200004],
              [-88.24437638399993, 13.96609954800006],
              [-88.24230932699996, 13.96253387500009],
              [-88.23336930399992, 13.954498190000024],
              [-88.23158646699994, 13.951811015000075],
              [-88.23636653699995, 13.938142599000074],
              [-88.2427744149999, 13.936695658000076],
              [-88.2516369219999, 13.938090922000058],
              [-88.26360001599994, 13.93310414600009],
              [-88.27016292299993, 13.926024475000077],
              [-88.2741707729999, 13.919119724000055],
              [-88.27752681499993, 13.913337911000028],
              [-88.28543330899987, 13.905974019000027],
              [-88.29631119799984, 13.902356669000142],
              [-88.30842932199994, 13.901478170000104],
              [-88.31925553399986, 13.89760243700006],
              [-88.32620601499985, 13.885070903000056],
              [-88.3326138919999, 13.88770640100006],
              [-88.34057206299985, 13.890031840000091],
              [-88.34855607199992, 13.891375427000057],
              [-88.3550673019999, 13.890962016000046],
              [-88.35819372599985, 13.887396343000077],
              [-88.35891719599994, 13.881195170000098],
              [-88.35891719599994, 13.87527821900008],
              [-88.36010575399987, 13.872384338000103],
              [-88.36741796899986, 13.87310780900009],
              [-88.38336014899988, 13.879257304000063],
              [-88.3929461269999, 13.879774068000103],
              [-88.43322790599984, 13.87106659000004],
              [-88.45144384799988, 13.863573507000098],
              [-88.47015071599986, 13.852488912000098],
              [-88.49681575499991, 13.851197002000049],
              [-88.48800492399991, 13.865330506000078],
              [-88.48867671699989, 13.881350200000043],
              [-88.49950293099994, 13.907601827000065],
              [-88.50229345799991, 13.917110291000057],
              [-88.50022639999995, 13.931863912000068],
              [-88.49681575499991, 13.944033712000063],
              [-88.49609228599991, 13.95568674700013],
              [-88.50119810599995, 13.966600438000029],
              [-88.50229345799991, 13.968941752000134],
              [-88.49818257699994, 13.968409755000081],
              [-88.49790096099991, 13.968373311000079],
              [-88.49708534899992, 13.969068092000015],
              [-88.49650569699992, 13.969561870000106],
              [-88.49619563899995, 13.971990662000067],
              [-88.49542049199994, 13.97514292400011],
              [-88.50436051499986, 13.983695374000135],
              [-88.51404984599989, 13.987648621000119],
              [-88.55810400399986, 13.990904236000105],
              [-88.63386165399996, 14.014468689000097],
              [-88.65933813599989, 14.016122335000148],
              [-88.6848146159999, 14.01229827900002],
              [-88.69093827299986, 14.009998678000088],
              [-88.69081175799997, 14.011789871000062],
              [-88.69044734699992, 14.016949157000084],
              [-88.69269527299994, 14.025294902000056],
              [-88.69765620999988, 14.032012838000071],
              [-88.70486507199985, 14.038033142000103],
              [-88.7095159509999, 14.039686788000054],
              [-88.73096166999994, 14.042477316000117],
              [-88.7466454669999, 14.052476705000032],
              [-88.74607702699984, 14.066558533000062],
              [-88.7400567229999, 14.083017477000041],
              [-88.73922989999997, 14.099941508000128],
              [-88.74638708599991, 14.111336162000029],
              [-88.7551204019999, 14.110457662000087],
              [-88.76542985099991, 14.104256490000097],
              [-88.77734126899992, 14.099734802000071],
              [-88.82118872099994, 14.102938741000045],
              [-88.83875870799992, 14.100406596000056],
              [-88.8453216149999, 14.128621928000115],
              [-88.86033361899987, 14.158516744000053],
              [-88.88126257299987, 14.184199931000123],
              [-88.90601558499989, 14.199573670000092],
              [-88.92164770499994, 14.199883728000088],
              [-88.93562618099995, 14.194018453000083],
              [-88.94748592199997, 14.187274679000055],
              [-88.95717525299989, 14.18518178300009],
              [-88.96598608399998, 14.19138295500008],
              [-88.96924169999997, 14.202002462000067],
              [-88.9702284759999, 14.210176262000104],
              [-88.9707919919999, 14.214844056000047],
              [-88.97456437199992, 14.227375590000051],
              [-88.98353023299987, 14.242129211000062],
              [-88.99275447599987, 14.252955424000106],
              [-89.01812760499988, 14.27168813100009],
              [-89.02262345399987, 14.28065399200004],
              [-89.02660253999994, 14.311298117000149],
              [-89.0329845789999, 14.323674622000027],
              [-89.04897843499992, 14.331451925000039],
              [-89.08308487999992, 14.335327657000079],
              [-89.09447953299991, 14.34486195900007],
              [-89.09055212399994, 14.354706320000048],
              [-89.0896736249999, 14.364886577000021],
              [-89.09184403599988, 14.37483429000011],
              [-89.09683081099985, 14.384006856000013],
              [-89.10256689499991, 14.391525777000055],
              [-89.10747615599993, 14.395969951000069],
              [-89.11334143099992, 14.397055156000064],
              [-89.12217810099992, 14.394678040000102],
              [-89.13011043299989, 14.38674570700006],
              [-89.1445023199999, 14.35971893300011],
              [-89.15398494499996, 14.351295675000117],
              [-89.20015783699992, 14.36467987000006],
              [-89.22553096599992, 14.382146505],
              [-89.27653560499996, 14.392740173000078],
              [-89.30756730199991, 14.407054546000069],
              [-89.34620628999991, 14.413075726000088],
              [-89.36162084999998, 14.415477804000062],
            ],
          ],
          [
            [
              [-87.61514238199993, 13.29010651200008],
              [-87.61196855399993, 13.282863674000055],
              [-87.61388098899994, 13.267320054000038],
              [-87.6243383449999, 13.25291575700004],
              [-87.6465551419999, 13.249172268000052],
              [-87.65855872299994, 13.25096263200004],
              [-87.66274980399993, 13.252752997000073],
              [-87.66706295499995, 13.256008205000057],
              [-87.66706295499995, 13.262193101000037],
              [-87.66014563699991, 13.262193101000037],
              [-87.66397050699993, 13.26748281500005],
              [-87.67003333199995, 13.278550523000092],
              [-87.67381751199991, 13.283880927000041],
              [-87.65762285099993, 13.289129950000074],
              [-87.64484615799995, 13.290838934000078],
              [-87.61514238199993, 13.29010651200008],
            ],
          ],
          [
            [
              [-87.62230383999992, 13.368882554000038],
              [-87.61241614499994, 13.366034247000073],
              [-87.58543860599991, 13.37173086100006],
              [-87.57079016799992, 13.372015692000048],
              [-87.57079016799992, 13.36587148600006],
              [-87.58812415299991, 13.357977606000077],
              [-87.57628333199995, 13.318548895000049],
              [-87.59129798099991, 13.304388739000046],
              [-87.63756262899994, 13.319159247000073],
              [-87.6590063139999, 13.331691799000055],
              [-87.65648352799991, 13.34906647300005],
              [-87.64346269399994, 13.367743231000077],
              [-87.63442949099993, 13.373480536000045],
              [-87.62230383999992, 13.368882554000038],
            ],
          ],
          [
            [
              [-86.87873287699995, 16.12726471600007],
              [-86.87254798099991, 16.12099844000005],
              [-86.88117428299995, 16.10455963700008],
              [-86.87873287699995, 16.09316640800006],
              [-86.89757239499994, 16.093817450000074],
              [-86.91319739499994, 16.09015534100007],
              [-86.94017493399991, 16.07949453300006],
              [-86.96372050999992, 16.066387834000068],
              [-86.97893522999993, 16.077789236000058],
              [-86.9974046989999, 16.083959264000043],
              [-86.98873517399994, 16.095466383000087],
              [-86.9442512039999, 16.11650834200009],
              [-86.91836503799993, 16.12205638200004],
              [-86.90392005099994, 16.124172268000052],
              [-86.89053300699993, 16.127834377000056],
              [-86.87873287699995, 16.12726471600007],
            ],
          ],
          [
            [
              [-86.60654222099993, 16.285029102000067],
              [-86.59933288799994, 16.309298272000092],
              [-86.57044680699994, 16.332440401000042],
              [-86.53068158299993, 16.356180794000068],
              [-86.49999980199993, 16.368908871000087],
              [-86.44039043099991, 16.396545291000052],
              [-86.3754442259999, 16.41733268900009],
              [-86.3321254949999, 16.429448093000076],
              [-86.30204736799993, 16.432903318000058],
              [-86.26235147699992, 16.43058202800006],
              [-86.23107686599991, 16.428835329000037],
              [-86.18175088099991, 16.428225143000077],
              [-86.20220896699993, 16.422471073000054],
              [-86.22387007099991, 16.412101045000043],
              [-86.2431121759999, 16.41788107600007],
              [-86.2731858379999, 16.41097205200009],
              [-86.29434160099993, 16.415269273000092],
              [-86.31212317599994, 16.412502346000053],
              [-86.31891842399995, 16.409328518000052],
              [-86.33267167899993, 16.400458075000074],
              [-86.33885657499991, 16.39785390800006],
              [-86.34776770699995, 16.39752838700008],
              [-86.36220588899994, 16.39425436600004],
              [-86.38025356899993, 16.381557601000054],
              [-86.41695974099991, 16.364231547000088],
              [-86.45307127299992, 16.35151137300005],
              [-86.49102177799995, 16.32548782000009],
              [-86.52526554799994, 16.315212384000063],
              [-86.5481526879999, 16.312852734000046],
              [-86.56379927799992, 16.29839045300008],
              [-86.58064996199994, 16.282767],
              [-86.60050418499992, 16.269449111000085],
              [-86.60654222099993, 16.285029102000067],
            ],
          ],
          [
            [
              [-85.91147268399993, 16.462042911000083],
              [-85.89556983199992, 16.48874459600006],
              [-85.88414466099994, 16.502834377000056],
              [-85.8511312089999, 16.517217619000064],
              [-85.83212822699994, 16.510497688000044],
              [-85.81694999599995, 16.498308834000056],
              [-85.82206111399995, 16.48616301000004],
              [-85.84425413999992, 16.483778923000045],
              [-85.84936685799994, 16.46920508700009],
              [-85.86272049099995, 16.452220959000044],
              [-85.88236256199991, 16.451046980000058],
              [-85.89569953599994, 16.436496074000047],
              [-85.94706822099994, 16.403189644000065],
              [-85.95084725299995, 16.41230787300009],
              [-85.94067911899992, 16.42990270000007],
              [-85.92669127699992, 16.45478223000009],
              [-85.91147268399993, 16.462042911000083],
            ],
          ],
          [
            [
              [-83.94115149599992, 17.41864655200004],
              [-83.93358313699991, 17.41787344000005],
              [-83.92613684799994, 17.41632721600007],
              [-83.91893469999991, 17.41404857000009],
              [-83.91234290299991, 17.41111888200004],
              [-83.9219457669999, 17.409084377000056],
              [-83.93032792899993, 17.409409898000092],
              [-83.93687903599994, 17.412543036000045],
              [-83.94115149599992, 17.41864655200004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'United States of America',
        iso3: 'USA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-122.75301682799991, 48.992514547000084],
              [-122.65325801699994, 48.992514547000084],
              [-122.4333747969999, 48.992514547000084],
              [-122.21351741599996, 48.992514547000084],
              [-121.99376338799995, 48.992514547000084],
              [-121.77395768299994, 48.992514547000084],
              [-121.55415197799991, 48.992514547000084],
              [-121.33432043499988, 48.992514547000084],
              [-121.11451472999995, 48.992514547000084],
              [-120.89470902599993, 48.992514547000084],
              [-120.67495499799993, 48.992514547000084],
              [-120.4551492929999, 48.992514547000084],
              [-120.23531774999988, 48.992514547000084],
              [-120.01551204499995, 48.992514547000084],
              [-119.79570633999992, 48.992514547000084],
              [-119.5758747969999, 48.992514547000084],
              [-119.35604325399987, 48.992514547000084],
              [-119.13621171099994, 48.992514547000084],
              [-118.91648352099993, 48.992514547000084],
              [-118.69667781599992, 48.992514547000084],
              [-118.4768721119999, 48.992514547000084],
              [-118.25706640699988, 48.992514547000084],
              [-118.03723486399994, 48.992514547000084],
              [-117.81742915899991, 48.992514547000084],
              [-117.59767513099992, 48.992514547000084],
              [-117.37786942599989, 48.992514547000084],
              [-117.15801204499986, 48.992514547000084],
              [-117.03815110299992, 48.992514547000084],
              [-116.93818050199992, 48.992514547000084],
              [-116.7183747969999, 48.992514547000084],
              [-116.49856909199988, 48.992514547000084],
              [-116.27876338799986, 48.992514547000084],
              [-116.05895768299993, 48.992514547000084],
              [-116.04816312499993, 48.992514547000084],
              [-115.8391261399999, 48.992514547000084],
              [-115.6193721119999, 48.992514547000084],
              [-115.39951473099987, 48.992514547000084],
              [-115.17965734999991, 48.992514547000084],
              [-114.95992915899991, 48.992514547000084],
              [-114.74009761599989, 48.992514547000084],
              [-114.52026607299986, 48.992514547000084],
              [-114.30048620699985, 48.992514547000084],
              [-114.08068050199992, 48.992514547000084],
              [-114.06384012799991, 48.992514547000084],
              [-113.8608747969999, 48.992514547000084],
              [-113.64104325499996, 48.992514547000084],
              [-113.42118587299993, 48.992514547000084],
              [-113.20138016799991, 48.992514547000084],
              [-112.9816261399999, 48.992514547000084],
              [-112.76182043499998, 48.992566223],
              [-112.54198889199985, 48.9926179000001],
              [-112.32218318799993, 48.9926179000001],
              [-112.1023774829999, 48.9926179000001],
              [-111.88257177799997, 48.9926179000001],
              [-111.66271439599986, 48.9926179000001],
              [-111.44288285399992, 48.9926179000001],
              [-111.22307714899989, 48.9926179000001],
              [-111.00332312099988, 48.9926179000001],
              [-110.78351741599995, 48.9926179000001],
              [-110.56371171199993, 48.9926179000001],
              [-110.34388016799991, 48.9926179000001],
              [-110.1241003009999, 48.9926179000001],
              [-109.99932108799989, 48.9926179000001],
              [-109.90426875899996, 48.9926179000001],
              [-109.68454056899986, 48.9926179000001],
              [-109.46470902599992, 48.9926179000001],
              [-109.2448516449999, 48.9926179000001],
              [-109.02504593999987, 48.9926179000001],
              [-108.80524023499994, 48.9926179000001],
              [-108.58543452999993, 48.9926179000001],
              [-108.3656288249999, 48.9926179000001],
              [-108.14579728199988, 48.9926179000001],
              [-107.92604325399986, 48.9926179000001],
              [-107.70623754999994, 48.9926179000001],
              [-107.48643184499991, 48.9926179000001],
              [-107.2666261389999, 48.9926179000001],
              [-107.04679459699987, 48.9926179000001],
              [-106.82698889299985, 48.9926179000001],
              [-106.60718318699992, 48.9926179000001],
              [-106.3873258059999, 48.9926179000001],
              [-106.16752010099987, 48.9926179000001],
              [-105.94774023499994, 48.9926179000001],
              [-105.72793452999993, 48.9926179000001],
              [-105.50815466299991, 48.9926179000001],
              [-105.28832312099988, 48.9926179000001],
              [-105.05750241899992, 48.99261789989612],
              [-104.84871171099994, 48.9926179000001],
              [-104.6288543299999, 48.9926179000001],
              [-104.40904862499988, 48.9926179000001],
              [-104.18924292099986, 48.9926179000001],
              [-104.04757444699989, 48.9926179000001],
              [-103.96948889199984, 48.9926179000001],
              [-103.74968318699992, 48.9926179000001],
              [-103.52985164399989, 48.9926179000001],
              [-103.31004593899988, 48.9926179000001],
              [-103.09024023499985, 48.9926179000001],
              [-102.87038285399991, 48.9926179000001],
              [-102.65057714899989, 48.9926179000001],
              [-102.43074560599986, 48.9926179000001],
              [-102.21093990099993, 48.992669577000115],
              [-101.99118587299992, 48.992669577000115],
              [-101.77138016799991, 48.992669577000115],
              [-101.55157446299988, 48.992669577000115],
              [-101.36433964699988, 48.992669577000115],
              [-101.33169124399984, 48.992669577000115],
              [-101.11188553899991, 48.992669577000115],
              [-100.8921056729999, 48.992669577000115],
              [-100.67227412999996, 48.992669577000115],
              [-100.45249426299995, 48.992669577000115],
              [-100.23266271999992, 48.992669577000115],
              [-100.01288285399991, 48.992669577000115],
              [-99.7931029869999, 48.992669577000115],
              [-99.57329728299996, 48.992669577000115],
              [-99.35349157699994, 48.992669577000115],
              [-99.13366003499992, 48.992669577000115],
              [-98.9138543299999, 48.992669577000115],
              [-98.69404862499997, 48.992669577000115],
              [-98.47419124399994, 48.992669577000115],
              [-98.25443721599993, 48.992669577000115],
              [-98.03460567199988, 48.992669577000115],
              [-97.81479996799987, 48.992669577000115],
              [-97.59499426299993, 48.992669577000115],
              [-97.37518855899992, 48.992669577000115],
              [-97.22608856599996, 48.992669577000115],
              [-97.1553828529999, 48.992669577000115],
              [-96.93560298799989, 48.992669577000115],
              [-96.71579728199987, 48.992669577000115],
              [-96.49599157699993, 48.992669577000115],
              [-96.27621171099992, 48.992669577000115],
              [-96.05632849199989, 48.992669577000115],
              [-95.83649694899995, 48.992669577000115],
              [-95.61671708199992, 48.992669577000115],
              [-95.39693721599991, 48.992669577000115],
              [-95.17710567299989, 48.992669577000115],
              [-95.16852738499995, 48.99504669300008],
              [-95.16188696299986, 49.00114451200004],
              [-95.15932897999997, 49.01178985600002],
              [-95.15966487699987, 49.10950999000006],
              [-95.16002661199985, 49.223353170000095],
              [-95.16033666999994, 49.31301178000005],
              [-95.1605692139999, 49.3694941210001],
              [-95.10282080099992, 49.35393951500008],
              [-94.98251806699992, 49.35616160100007],
              [-94.92608740299988, 49.345567933],
              [-94.8561950289999, 49.31828277600009],
              [-94.83914180499997, 49.308877665000026],
              [-94.82725622599995, 49.292857972],
              [-94.81989233499993, 49.252033590000096],
              [-94.81035803299994, 49.22960601900009],
              [-94.80612056599989, 49.21089915000003],
              [-94.81118485599987, 49.16656077100008],
              [-94.80374344999984, 49.146406963000075],
              [-94.79203873699987, 49.12645986000008],
              [-94.75377233999987, 49.02615590400002],
              [-94.7112167969999, 48.91458648700011],
              [-94.71173356199995, 48.862755026000016],
              [-94.71214697299988, 48.84244618700011],
              [-94.71328385499987, 48.823842672000055],
              [-94.71090673899991, 48.80751292000009],
              [-94.70178584899995, 48.790097962000075],
              [-94.68889257899994, 48.77883249900002],
              [-94.59285192899995, 48.726432597000084],
              [-94.51916133699993, 48.70447011300011],
              [-94.47949967499994, 48.70069773400009],
              [-94.31157710799991, 48.71392690000009],
              [-94.29258601899997, 48.711911520000044],
              [-94.28403356999993, 48.709069316000054],
              [-94.27449926799994, 48.704108378000015],
              [-94.26548172999989, 48.697752177],
              [-94.2584537359999, 48.6908275360001],
              [-94.25576656099986, 48.683541158000125],
              [-94.25245926899996, 48.66240549700008],
              [-94.25103816799987, 48.657289530000085],
              [-94.23215043199994, 48.65201853500007],
              [-94.03484981299994, 48.64331105600009],
              [-93.87488541799988, 48.636205546000056],
              [-93.83574051999994, 48.61713694300009],
              [-93.80938553899998, 48.543575541000095],
              [-93.77866390099993, 48.51946848600004],
              [-93.75677893099987, 48.51654876700006],
              [-93.6162965499999, 48.53130238900006],
              [-93.59988928299995, 48.52634145100002],
              [-93.5665838219999, 48.53827870700006],
              [-93.49175634799988, 48.542309469000045],
              [-93.45992366599992, 48.55739898700004],
              [-93.45224971499994, 48.57272105000003],
              [-93.45377417099985, 48.58695790700007],
              [-93.45147456899991, 48.597422384000126],
              [-93.41731644699985, 48.60411448200004],
              [-93.38571630899986, 48.61486318000006],
              [-93.25773962499989, 48.630314433000066],
              [-93.13170080599994, 48.62463002500003],
              [-92.97972041799994, 48.61767954600005],
              [-92.95558752499988, 48.61222768200004],
              [-92.88419653299991, 48.579878235000066],
              [-92.72554988699989, 48.54869150800009],
              [-92.64860367899988, 48.536263326000025],
              [-92.63018103099998, 48.51946848600004],
              [-92.62746801899993, 48.502776998000016],
              [-92.64674332699988, 48.49742848800007],
              [-92.69136592599989, 48.489857891],
              [-92.71064123599984, 48.48288157200001],
              [-92.71890946499988, 48.45978220700003],
              [-92.70405249099994, 48.445157776000045],
              [-92.67712906899993, 48.44174713200003],
              [-92.65705277599997, 48.43823313400007],
              [-92.57052058899987, 48.446656393000055],
              [-92.52693151899993, 48.44562286400007],
              [-92.49062882499996, 48.433117168000095],
              [-92.4745316159999, 48.41048289000004],
              [-92.46758113699991, 48.394282329000035],
              [-92.46706437199995, 48.35322540300008],
              [-92.46246516999992, 48.32929921500006],
              [-92.45138057499989, 48.31268524200006],
              [-92.4182301429999, 48.28204111800004],
              [-92.38464046299995, 48.23240590400006],
              [-92.37185054599988, 48.22258738200007],
              [-92.35381547099988, 48.22289744100006],
              [-92.32787390199994, 48.22943450900006],
              [-92.30366349299996, 48.23927887000012],
              [-92.29102860599991, 48.24956248000011],
              [-92.2920621349999, 48.270336406000055],
              [-92.30141556899994, 48.29064524400006],
              [-92.30309505299991, 48.310928243],
              [-92.28159765699988, 48.33177968400004],
              [-92.25911840899994, 48.339634502000095],
              [-92.1547320149999, 48.350124818000026],
              [-92.07049943099992, 48.34671417300011],
              [-92.04342097999995, 48.3345960490001],
              [-92.03011429899993, 48.3131761690001],
              [-92.02135514299994, 48.28744130500009],
              [-92.00799678599992, 48.26248158800003],
              [-91.99215795999993, 48.24790883400006],
              [-91.97549230999991, 48.23656585700009],
              [-91.95730220599987, 48.22832346600005],
              [-91.8522440189999, 48.19597401900005],
              [-91.7649883629999, 48.1873440560001],
              [-91.74413692299993, 48.1795925900001],
              [-91.72757462599992, 48.16832712800003],
              [-91.6955093999999, 48.13757965100008],
              [-91.7164383549999, 48.112051494000056],
              [-91.6925121669999, 48.0978663130001],
              [-91.61861486899991, 48.08957224600003],
              [-91.5974792079999, 48.09039906800005],
              [-91.58967606599987, 48.088332012000095],
              [-91.58109777899992, 48.080942281],
              [-91.57980586799988, 48.070968730000075],
              [-91.58512853999991, 48.06084014900004],
              [-91.58698889199994, 48.05257192000009],
              [-91.57484492999993, 48.04820526200011],
              [-91.4870983489999, 48.05347625800003],
              [-91.46472245299992, 48.04895457000002],
              [-91.44627396699991, 48.040738017000066],
              [-91.42792883399991, 48.0364488740001],
              [-91.36540034999993, 48.057842916000126],
              [-91.27636185799994, 48.0647675580001],
              [-91.23806962199993, 48.08264760400006],
              [-91.20396317599995, 48.10765899700006],
              [-91.07110306899995, 48.17085927400002],
              [-91.02815995299989, 48.18483774900004],
              [-91.00810949799987, 48.194372051000116],
              [-90.92315344299996, 48.227109070000026],
              [-90.87380244999986, 48.23434377100007],
              [-90.84067785699995, 48.22010691400003],
              [-90.83793900599991, 48.21054677300002],
              [-90.84884273399987, 48.1987128710001],
              [-90.84972123299991, 48.189566142],
              [-90.84300329599998, 48.1769829310001],
              [-90.8342699799999, 48.17178944900009],
              [-90.8238830169999, 48.16832712800003],
              [-90.81230749599985, 48.160989075000046],
              [-90.80305741399994, 48.1471656290001],
              [-90.79670121299992, 48.11706410700002],
              [-90.78646927899993, 48.1004501340001],
              [-90.7503474529999, 48.08399119100004],
              [-90.7013065189999, 48.08455963200008],
              [-90.61107946799987, 48.10349904400003],
              [-90.5868432209999, 48.10481679300007],
              [-90.57387243699986, 48.09789215100001],
              [-90.56219356299988, 48.088848776000034],
              [-90.5420139169999, 48.08373280900007],
              [-90.53160111499997, 48.08455963200008],
              [-90.5018871669999, 48.094274801000026],
              [-90.4904925139999, 48.09623850600006],
              [-90.48346451899991, 48.09448150700008],
              [-90.47785762599997, 48.09153595000008],
              [-90.47062292599992, 48.08988230400003],
              [-90.17862524499986, 48.116443990000036],
              [-90.12038590599985, 48.115358786000044],
              [-90.07325699899994, 48.101199443],
              [-90.06103552299993, 48.091019186000025],
              [-90.00822220899997, 48.02973093700008],
              [-89.99532893899996, 48.018594666000055],
              [-89.98031693599998, 48.01009389300005],
              [-89.92044978899992, 47.987459615],
              [-89.90244055199992, 47.98590932300009],
              [-89.80345434699984, 48.01376291900006],
              [-89.78097509799991, 48.01719940200009],
              [-89.76330175899992, 48.0173027550001],
              [-89.74596431499992, 48.01376291900006],
              [-89.72459610999991, 48.00590810200002],
              [-89.7127880459999, 48.00337595600003],
              [-89.67865576299994, 48.00869862900008],
              [-89.65658992599992, 48.00797515900008],
              [-89.59310542799997, 47.99650299100004],
              [-89.49896244399989, 47.995094552000054],
              [-89.46184728999992, 47.99453928600012],
              [-89.38709733099992, 47.98053497300002],
              [-89.36363623099993, 47.97960479700005],
              [-89.34038183599992, 47.984152324],
              [-89.24552974499994, 48.02117848800005],
              [-89.09525467899991, 48.079934591000026],
              [-88.90462032099992, 48.154296977000044],
              [-88.78214717599994, 48.202071838],
              [-88.64272416299985, 48.25659047500004],
              [-88.57887792999992, 48.27038808200008],
              [-88.40790645399994, 48.30405527800012],
              [-88.37646134499991, 48.3051146450001],
              [-88.3472641599999, 48.29865509100004],
              [-88.1596787119999, 48.22488698400009],
              [-87.97209326199993, 48.151170553000085],
              [-87.78448197499995, 48.07742828400005],
              [-87.59689652499989, 48.003737692000115],
              [-87.40925939999991, 47.92999542200009],
              [-87.22169978899987, 47.85625315400004],
              [-87.03416601599992, 47.782485047000094],
              [-86.84655472899993, 47.70874277800006],
              [-86.74180660099995, 47.66644561800008],
              [-86.6370584719999, 47.62412262000008],
              [-86.53231034399994, 47.581902975],
              [-86.4276138919999, 47.53957997700009],
              [-86.32286576399994, 47.4972053020001],
              [-86.21811763499997, 47.45493398100011],
              [-86.1133695069999, 47.41266265900002],
              [-86.00856970299995, 47.370365499000044],
              [-85.8836160889999, 47.318559876000066],
              [-85.75861079899991, 47.26678009000007],
              [-85.63363134799997, 47.21502614400002],
              [-85.50862605899991, 47.16322052000005],
              [-85.38364660699995, 47.11144073500007],
              [-85.25864131699987, 47.05968678800012],
              [-85.13366186599993, 47.00782948800013],
              [-85.00865657599985, 46.955998027000035],
              [-84.99240433799994, 46.948789164000075],
              [-84.97620377699994, 46.941476949],
              [-84.95997737699992, 46.934242249000036],
              [-84.94367346199991, 46.92700754800008],
              [-84.9274470629999, 46.919669495000065],
              [-84.91116898599995, 46.91248647000002],
              [-84.89494258699995, 46.90514841700012],
              [-84.87869034799985, 46.897913717000066],
              [-84.86373002199988, 46.88194570000012],
              [-84.85419571999998, 46.861171773000066],
              [-84.8354113369999, 46.80386261000011],
              [-84.81644608599993, 46.74590749100007],
              [-84.78745560699986, 46.65717905700005],
              [-84.77332210299991, 46.6334337360001],
              [-84.69368872099997, 46.564859111000075],
              [-84.58940567999994, 46.47512298600007],
              [-84.56656469699993, 46.4611961880001],
              [-84.54129492199988, 46.45282460600002],
              [-84.51230444299989, 46.45163604700009],
              [-84.49217647399993, 46.456881206000034],
              [-84.47830135099986, 46.466467184000024],
              [-84.46540808099985, 46.478171896],
              [-84.44809647599993, 46.489721578000044],
              [-84.42324011199989, 46.511580709],
              [-84.38970210799988, 46.52026235000004],
              [-84.35246923799988, 46.522742818000026],
              [-84.30534033199987, 46.501607158000084],
              [-84.24201086499994, 46.526463521000025],
              [-84.1972849119999, 46.54635894800005],
              [-84.14767553699991, 46.54134633400007],
              [-84.1104426679999, 46.526463521000025],
              [-84.15881180899996, 46.43334259100003],
              [-84.14767553699991, 46.399882101000046],
              [-84.12904618399995, 46.37502573700009],
              [-84.10543005399984, 46.347740580000064],
              [-84.11289729899997, 46.327870992000086],
              [-84.11909847099986, 46.314228414000056],
              [-84.1141375329999, 46.2955732220001],
              [-84.10667028899988, 46.27696970600006],
              [-84.09922888299985, 46.25087310800005],
              [-84.09922888299985, 46.23723053000005],
              [-84.09677425099989, 46.224828187000085],
              [-84.08680070099987, 46.20121205700006],
              [-84.05582067899988, 46.17144643200008],
              [-84.02104243999992, 46.151602681000085],
              [-84.01416947499985, 46.1159976200001],
              [-84.00876928799988, 46.1123285930001],
              [-83.99582434099995, 46.101166484],
              [-83.97639400199998, 46.07310618100006],
              [-83.96458593799989, 46.06318430700007],
              [-83.94730017199987, 46.06060048400006],
              [-83.93073787499989, 46.06695668600007],
              [-83.87267940299989, 46.107884420000104],
              [-83.85642716599989, 46.115739238000046],
              [-83.83929642799984, 46.119201559],
              [-83.81805741399995, 46.11656606000007],
              [-83.76653601099986, 46.10648915700004],
              [-83.66483679199993, 46.11914988300008],
              [-83.61388382999988, 46.11563588500012],
              [-83.56543717499991, 46.090779521000044],
              [-83.50882564399984, 46.04737131700007],
              [-83.49203080299989, 46.037087707000055],
              [-83.4740990809999, 46.023135071000084],
              [-83.46280778099992, 46.00778717100009],
              [-83.46585668999987, 45.99311106400002],
              [-83.51024674499993, 45.932391256000116],
              [-83.55621293099992, 45.86965606800008],
              [-83.636867, 45.773944],
              [-83.483974, 45.771937],
              [-83.35925282089791, 45.715804524943366],
              [-83.19930965299994, 45.641556295],
              [-83.01901057999996, 45.561871236000044],
              [-82.75943986099992, 45.447201233],
              [-82.58877844299985, 45.3718053190001],
              [-82.54828995799994, 45.334598287000105],
              [-82.53214107299996, 45.29351552300004],
              [-82.48408199099993, 45.08324412000009],
              [-82.43602290899986, 44.87297271800007],
              [-82.38788631299988, 44.662701315000035],
              [-82.33987890599994, 44.45242991200011],
              [-82.29184566299998, 44.242210185],
              [-82.2436832279999, 44.03193878200007],
              [-82.19562414599994, 43.82169321700003],
              [-82.14756506399988, 43.611344299000066],
              [-82.14544632999991, 43.60064727800007],
              [-82.14565303599994, 43.57641103100009],
              [-82.15361120599991, 43.549590963000085],
              [-82.18585729999998, 43.48729502400006],
              [-82.21800004199991, 43.425024923000066],
              [-82.25019445899997, 43.36278066000004],
              [-82.28238887599991, 43.3004847210001],
              [-82.31450577899994, 43.23818878200008],
              [-82.34672603399989, 43.17584116700006],
              [-82.37892045099994, 43.113571066000034],
              [-82.41108902999989, 43.05127512700001],
              [-82.41641170299994, 43.01714284300003],
              [-82.41460302799993, 42.98324310400001],
              [-82.43044185399992, 42.95130706800005],
              [-82.45317948399992, 42.918983460000064],
              [-82.46478084299989, 42.88363678000006],
              [-82.46803645899985, 42.863973898000026],
              [-82.48232499199995, 42.83511261000008],
              [-82.48527054899992, 42.818524476000064],
              [-82.47361751299988, 42.79816396100004],
              [-82.47098201599994, 42.79056752500007],
              [-82.47134374999985, 42.779844666000045],
              [-82.47695064399997, 42.76147369400006],
              [-82.48341019799992, 42.7192540490001],
              [-82.51126379399989, 42.64667450000006],
              [-82.52622412199986, 42.61990610800008],
              [-82.54924597199991, 42.590941468000025],
              [-82.57583349699985, 42.57179534900003],
              [-82.60846716299991, 42.561098328000114],
              [-82.64433060699986, 42.557816874000125],
              [-82.69440506999987, 42.51913706500001],
              [-82.8001350509999, 42.417980449000126],
              [-82.83282039499997, 42.39800750800002],
              [-82.94351131199994, 42.355477804000046],
              [-83.04035294699986, 42.331861674000024],
              [-83.07996293099993, 42.305067444000045],
              [-83.10983190999994, 42.27227874800003],
              [-83.12851293999992, 42.23995514000005],
              [-83.13592850799992, 42.200267639000074],
              [-83.13964921099992, 42.11585418800006],
              [-83.15949296099993, 42.046323548000046],
              [-83.15701249299985, 42.000434876000085],
              [-83.13250661999984, 41.94195280800004],
              [-83.12344864999994, 41.920336405000015],
              [-83.09737788899994, 41.87576548300011],
              [-83.06841324999988, 41.847731019],
              [-82.98379309099988, 41.80806935700012],
              [-82.86522151699995, 41.752491353000025],
              [-82.7111223959999, 41.680247701000084],
              [-82.6669132079999, 41.66908559200006],
              [-82.45131913299991, 41.67190195700003],
              [-82.42486079999992, 41.676811219000044],
              [-82.28135534699993, 41.74329294900012],
              [-82.1377465409999, 41.809800517000085],
              [-81.99424108899993, 41.87620473300002],
              [-81.85073563599994, 41.9427123010001],
              [-81.70728186099987, 42.00921986900006],
              [-81.56372473199994, 42.07567576100003],
              [-81.42021927899995, 42.142157491],
              [-81.27666215099995, 42.20866506000006],
              [-81.14788448099995, 42.228250427],
              [-81.01915848899998, 42.24780995700009],
              [-80.89038081899989, 42.267447002000026],
              [-80.76165482699992, 42.287032369000045],
              [-80.63287715699994, 42.30664357500008],
              [-80.52023319699992, 42.32378209800005],
              [-80.50415116399995, 42.326228943],
              [-80.37537349499988, 42.3457884730001],
              [-80.24659582599989, 42.365477194000064],
              [-80.0931684979999, 42.42015085900003],
              [-79.9397670089999, 42.47477284800006],
              [-79.78639135799992, 42.529368999],
              [-79.76300663499987, 42.53770492800005],
              [-79.63301570699986, 42.58404266400005],
              [-79.47964005599988, 42.63871632900002],
              [-79.32618688999989, 42.693338318000045],
              [-79.17275956299991, 42.74801198400009],
              [-79.01938391099992, 42.802685649000054],
              [-78.96305660099992, 42.84012522400003],
              [-78.91895076599994, 42.88924367300008],
              [-78.90905472799994, 42.93022308400002],
              [-78.91525590099994, 42.94761220300005],
              [-78.93633988499997, 42.96004038500011],
              [-78.95995601399989, 42.96621571900009],
              [-78.98352046799988, 42.976137593],
              [-79.00835099299994, 42.99104624500005],
              [-79.02201940999996, 43.002234193000064],
              [-79.03196712299984, 43.01342214000003],
              [-79.02824641999985, 43.03450612400006],
              [-79.02201940999996, 43.0494147750001],
              [-79.02325964399998, 43.058070578000056],
              [-79.0307527269999, 43.0668038940001],
              [-79.04186315999993, 43.075459697000085],
              [-79.05553157599985, 43.087887879000064],
              [-79.06294714399988, 43.096543681000085],
              [-79.06527258299991, 43.10589711600004],
              [-79.06573767099994, 43.12023732600004],
              [-79.06142268999986, 43.13028839200008],
              [-79.05558325199988, 43.13842743],
              [-79.05160416699988, 43.14685068800007],
              [-79.04933040399996, 43.1598473100001],
              [-79.04860693399988, 43.17062184700002],
              [-79.05377457699987, 43.26035797100012],
              [-79.05842545599992, 43.27779876700005],
              [-79.09162756399988, 43.34252349900005],
              [-79.17430985599992, 43.46453155500008],
              [-79.07899267599993, 43.49894806000013],
              [-78.94618424499993, 43.546722921000125],
              [-78.75082149299996, 43.617054546000034],
              [-78.68808630399991, 43.63180816700013],
              [-78.4572735189999, 43.63098134400012],
              [-78.2264607349999, 43.630206197000106],
              [-77.99567378799989, 43.629431051],
              [-77.76483516399986, 43.62865590400007],
              [-77.53399654199984, 43.627854920000075],
              [-77.30320959499994, 43.62710561200005],
              [-77.0723709719999, 43.62633046500004],
              [-76.84153234899989, 43.62550364200003],
              [-76.83600297099989, 43.62803578800002],
              [-76.83047359199989, 43.63043874100008],
              [-76.82489253699987, 43.63289337200003],
              [-76.81936315899986, 43.63542551700003],
              [-76.81378210499986, 43.63788014800009],
              [-76.80830440299988, 43.640308940000054],
              [-76.80272334899985, 43.64278940900003],
              [-76.79719397099984, 43.645269877],
              [-76.75435420699992, 43.7000985720001],
              [-76.71151444499986, 43.755004781000096],
              [-76.66867468299992, 43.809885153000025],
              [-76.62588659699989, 43.86476552300003],
              [-76.58299515799985, 43.91959421800003],
              [-76.54020707199993, 43.97447458900005],
              [-76.49736730999987, 44.02935496000005],
              [-76.45463090099989, 44.08423533200006],
              [-76.4300329189999, 44.103303935000056],
              [-76.35008947799986, 44.151724752000106],
              [-76.34440506999991, 44.15818430600005],
              [-76.34135616099991, 44.165780742000024],
              [-76.33711869299995, 44.173738912],
              [-76.3277652589999, 44.18149037700009],
              [-76.31717159099992, 44.185056051000046],
              [-76.20663570199989, 44.21740549800005],
              [-76.18575842299992, 44.225673727000085],
              [-76.16932531799995, 44.24236521400003],
              [-76.16973872899987, 44.24768788700008],
              [-76.17805863499993, 44.27213084000003],
              [-76.17867875199988, 44.27864207000009],
              [-76.14979162699984, 44.30453196200001],
              [-76.06726436399993, 44.34799184200004],
              [-75.89869584199991, 44.39997833300005],
              [-75.87032548099992, 44.4086082970001],
              [-75.85570104999994, 44.42204417000006],
              [-75.84541743999995, 44.43904571500006],
              [-75.8309480389999, 44.46431549100005],
              [-75.7911830249999, 44.496768291000066],
              [-75.75462194799988, 44.52756744400001],
              [-75.69968990099994, 44.581672668000024],
              [-75.57819860899994, 44.6615127570001],
              [-75.45595800799993, 44.74176625600002],
              [-75.3418306069999, 44.81674875900008],
              [-75.27023290999995, 44.863774313000064],
              [-75.12964717599996, 44.92516591400006],
              [-75.0755936279999, 44.93550120000005],
              [-75.05872127399991, 44.94103057800005],
              [-75.01489965799988, 44.965990296000044],
              [-74.99864742099987, 44.97239817300009],
              [-74.94020137599989, 44.98774607400004],
              [-74.90374365199997, 45.005212708],
              [-74.88650956299989, 45.00939849900003],
              [-74.8684744869999, 45.010121969000025],
              [-74.74155716999991, 44.99885650700007],
              [-74.7129613919999, 44.999253648000035],
              [-74.69587520399992, 44.99802968400006],
              [-74.5961138509999, 44.998494772000086],
              [-74.49635249799991, 44.99901153600011],
              [-74.3966169849999, 44.999476623000035],
              [-74.2968814699999, 44.99999338800008],
              [-74.1971459559999, 45.000458476000105],
              [-74.0973846039999, 45.000975240000045],
              [-73.9976490889999, 45.00144032800007],
              [-73.89788773699988, 45.00195709300003],
              [-73.79815222199989, 45.002473857000055],
              [-73.69841670799988, 45.00293894500008],
              [-73.59865535599988, 45.003404033000024],
              [-73.49891984099989, 45.00392079700005],
              [-73.39915848799987, 45.004385885000076],
              [-73.35134085899992, 45.004633645000055],
              [-73.2994229739999, 45.0049026490001],
              [-73.19968745999998, 45.00541941400006],
              [-73.09995194499987, 45.005884502000086],
              [-73.0002681069999, 45.00634959000011],
              [-72.9004809169999, 45.00686635400005],
              [-72.80069372599988, 45.00733144200008],
              [-72.70095821199988, 45.00779653000011],
              [-72.6012743739999, 45.00831329400005],
              [-72.50148718299997, 45.00883005800007],
              [-72.40175166899988, 45.009295146000014],
              [-72.30196447799995, 45.00976023300005],
              [-72.20222896399986, 45.01032867400009],
              [-72.10254512599988, 45.010793762000034],
              [-72.00280961099989, 45.01125885000003],
              [-71.90307409699997, 45.011775615],
              [-71.80328690599987, 45.0122407030001],
              [-71.70355139199995, 45.01275746700004],
              [-71.60381587799986, 45.013274231000096],
              [-71.50584813699996, 45.01373107500005],
              [-71.50408036399998, 45.01373931900012],
              [-71.50661250799996, 45.037045390000046],
              [-71.50475215699996, 45.05296173100008],
              [-71.49725907399991, 45.06655263300006],
              [-71.45658972199996, 45.11099436500005],
              [-71.4512153739999, 45.12169138600005],
              [-71.44599605399989, 45.140294902],
              [-71.4416035569999, 45.150681865000124],
              [-71.41302648899992, 45.18618357400008],
              [-71.40656693499997, 45.20494211900008],
              [-71.42268998299994, 45.217189434],
              [-71.44904496299992, 45.22690460300005],
              [-71.43881302899985, 45.233467510000125],
              [-71.3948880619999, 45.241529033000106],
              [-71.3812454829999, 45.250779114000025],
              [-71.35209997599989, 45.2783226530001],
              [-71.33432328399994, 45.28870961600002],
              [-71.31153397699995, 45.294135641000096],
              [-71.29339554899994, 45.29232696600012],
              [-71.20936966999989, 45.25475819900002],
              [-71.18513342299991, 45.24855702700002],
              [-71.16032873599997, 45.24576650000007],
              [-71.14172521999993, 45.25232940700003],
              [-71.11102941899989, 45.287107646],
              [-71.09524226999989, 45.30090525300004],
              [-71.08555293799995, 45.304212545000055],
              [-71.08495196099997, 45.3042925780001],
              [-71.06421057199995, 45.3070547490001],
              [-71.0544178879999, 45.3103620400001],
              [-71.03666703399998, 45.32338450100006],
              [-71.02759781899991, 45.33464996300002],
              [-71.0165390629999, 45.34312489800003],
              [-70.99315547799995, 45.3478274540001],
              [-70.96811824599985, 45.344520162],
              [-70.95160762599997, 45.332014466],
              [-70.90690751199992, 45.24623158800007],
              [-70.89241227299988, 45.23460439000003],
              [-70.87435135999996, 45.24566314800005],
              [-70.87060481799995, 45.25527496400004],
              [-70.87249100799997, 45.274188538],
              [-70.87024308299996, 45.28312856100011],
              [-70.86262080899988, 45.29036326100008],
              [-70.84238948599989, 45.301215312000025],
              [-70.83525813799994, 45.30979359900006],
              [-70.8320800379999, 45.32855214400006],
              [-70.8354648449999, 45.37309722900007],
              [-70.83383703699988, 45.393096008],
              [-70.82598221799992, 45.410459290000105],
              [-70.81298559599989, 45.423430074000024],
              [-70.7948730069999, 45.43040639200002],
              [-70.77187699399994, 45.43004465800003],
              [-70.75255000799987, 45.42234487000003],
              [-70.7180043139999, 45.39728179900003],
              [-70.69673946199993, 45.38865183600008],
              [-70.67578466799992, 45.388703512000106],
              [-70.65358964099988, 45.39547312400005],
              [-70.64131648799986, 45.40849558500007],
              [-70.65025651099998, 45.42746083600012],
              [-70.66816239499985, 45.43903635700006],
              [-70.7073848069999, 45.45639963800009],
              [-70.7228360599999, 45.47092071600004],
              [-70.73200862699989, 45.491591289000056],
              [-70.73032914299995, 45.5079727170001],
              [-70.68679174899992, 45.5727232870001],
              [-70.5896142169999, 45.651788229],
              [-70.57240596599993, 45.662278544000046],
              [-70.51473506699995, 45.68170888300001],
              [-70.48476273599991, 45.699640605000084],
              [-70.47279964199987, 45.703568014000055],
              [-70.45042374699989, 45.703723044000085],
              [-70.4391324469999, 45.70589345300009],
              [-70.41931453499984, 45.71690053300007],
              [-70.40735144099997, 45.73152496400006],
              [-70.40244217999995, 45.749663391000084],
              [-70.40394079599986, 45.77116078700003],
              [-70.40828161699994, 45.78165110300007],
              [-70.4136818039999, 45.787697246],
              [-70.41716996299994, 45.793795065000054],
              [-70.41523209699992, 45.80438873300004],
              [-70.40993526299988, 45.81074493500007],
              [-70.38980729199992, 45.82505930600006],
              [-70.31265437899995, 45.86764068600003],
              [-70.28317297399994, 45.89048166900004],
              [-70.26252823899992, 45.92303782100008],
              [-70.25593949399985, 45.948876038],
              [-70.2631483559999, 45.956834208000075],
              [-70.2804341239999, 45.95931467700005],
              [-70.30394689999989, 45.96861643500007],
              [-70.31629756699994, 45.98298248300007],
              [-70.31689184599992, 45.99900217700012],
              [-70.30614314799988, 46.03533070900009],
              [-70.3036368409999, 46.03848297100005],
              [-70.29430924499988, 46.0449425260001],
              [-70.29200964399985, 46.04866322900001],
              [-70.29301733399993, 46.05403757800006],
              [-70.29609208199986, 46.05786163400002],
              [-70.30079463699994, 46.06173736600006],
              [-70.30477372299993, 46.0659748340001],
              [-70.31136246799991, 46.071865947000035],
              [-70.31262854099995, 46.079565735000116],
              [-70.3003295499999, 46.08928090500005],
              [-70.26444026699994, 46.106592510000056],
              [-70.2494799399999, 46.12059682300007],
              [-70.24400223899991, 46.1410090130001],
              [-70.24924739599993, 46.1627647910001],
              [-70.26332922399985, 46.18322865900008],
              [-70.28480078199988, 46.19185862200003],
              [-70.28089921099993, 46.211857401000046],
              [-70.25340734899996, 46.25149322600002],
              [-70.23617325899997, 46.288338522000046],
              [-70.22369340099988, 46.300792542000025],
              [-70.20188594599995, 46.305495097000104],
              [-70.1995088299999, 46.31526194300004],
              [-70.19702836099992, 46.336862692000025],
              [-70.1883983969999, 46.35841176400008],
              [-70.1674177649999, 46.36817861000013],
              [-70.1530517169999, 46.372829488],
              [-70.0743226729999, 46.419544983],
              [-70.06181697699989, 46.445409037],
              [-70.05008642599992, 46.51127065100009],
              [-70.03272314499989, 46.60976593000008],
              [-70.02362809299993, 46.66128733400008],
              [-70.00776342799992, 46.70407541900009],
              [-69.98996089699997, 46.72169708300008],
              [-69.89970800899994, 46.811562398],
              [-69.8094034419999, 46.90129852300008],
              [-69.71909887699988, 46.99108632400008],
              [-69.62879431199994, 47.08079661100005],
              [-69.5384639079999, 47.17061025000005],
              [-69.44815934299996, 47.260346375000026],
              [-69.35790645399993, 47.350134176000026],
              [-69.2676277269999, 47.43984446200001],
              [-69.25091040099997, 47.45291860000005],
              [-69.23726782299988, 47.458809713000065],
              [-69.22197159899991, 47.459688213],
              [-69.06965531399993, 47.431886292000044],
              [-69.05402319399988, 47.41839874300008],
              [-69.05433325199996, 47.389253235000055],
              [-69.06619299399998, 47.329670309000065],
              [-69.06513362599989, 47.29633901000001],
              [-69.06355977599989, 47.29080926600007],
              [-69.05748551499991, 47.26946726500002],
              [-69.0401997479999, 47.249055074000054],
              [-68.90622859699991, 47.19022145700008],
              [-68.88971797699992, 47.19060902900007],
              [-68.76181880799987, 47.237040304000104],
              [-68.71779048699992, 47.245231018000126],
              [-68.6688012299999, 47.243422343000034],
              [-68.64420324699992, 47.24528269400004],
              [-68.62559973199987, 47.25520457000003],
              [-68.60792639199988, 47.269829000000115],
              [-68.58524043799991, 47.282489726000065],
              [-68.53966182499991, 47.299853008000056],
              [-68.51800939899994, 47.304762268],
              [-68.49201615399997, 47.30755279600005],
              [-68.46674637899991, 47.30569244400006],
              [-68.43532710799988, 47.29127472000003],
              [-68.4225630299999, 47.29310923300004],
              [-68.41021236199995, 47.29742421500002],
              [-68.38561438099987, 47.30171335900006],
              [-68.38339229299996, 47.30713938400005],
              [-68.38483923399986, 47.31587270100003],
              [-68.38204870599989, 47.32780995700007],
              [-68.34783890799991, 47.35850575800002],
              [-68.29972814899992, 47.36783335400004],
              [-68.24644974799995, 47.36057281600007],
              [-68.19704707899993, 47.341400859000046],
              [-68.18433467599988, 47.33313262900002],
              [-68.1560676679999, 47.306674296000025],
              [-68.1450605879999, 47.301454977],
              [-68.11539831599995, 47.29228241000003],
              [-68.10144567999996, 47.286184591000065],
              [-68.03938228399988, 47.245231018000126],
              [-67.99318355299994, 47.22321685900006],
              [-67.96243607599988, 47.197688700000114],
              [-67.95370275899992, 47.1866299440001],
              [-67.9499820559999, 47.172935689000084],
              [-67.94341914899991, 47.16453827000002],
              [-67.89913244699989, 47.138777568000094],
              [-67.87060705599993, 47.10735829700006],
              [-67.85474239099992, 47.09784983400009],
              [-67.81355627499994, 47.08190765400006],
              [-67.80869868999991, 47.075138042],
              [-67.80518469299994, 47.03563140900009],
              [-67.80254919499993, 46.90124684700005],
              [-67.80001704999995, 46.76678477000003],
              [-67.79743322799996, 46.63229685500009],
              [-67.79484940699984, 46.49786061600007],
              [-67.79231726099997, 46.36347605400006],
              [-67.78973343999988, 46.22901397800011],
              [-67.78714961799994, 46.09455190000007],
              [-67.78456579699986, 45.96014150000006],
              [-67.78275712099986, 45.950529684000045],
              [-67.77655594999987, 45.942933248000074],
              [-67.76746089699992, 45.935956930000074],
              [-67.75965775599988, 45.928567200000074],
              [-67.7578490809999, 45.91947214800011],
              [-67.76942460199984, 45.903969218],
              [-67.78735632399992, 45.89001658100001],
              [-67.79924190299994, 45.875650534],
              [-67.79262731899985, 45.85890737000007],
              [-67.77609086199996, 45.84082061800005],
              [-67.77283524599997, 45.82805654000008],
              [-67.77986324099987, 45.81570587200012],
              [-67.79412593599994, 45.79916941300003],
              [-67.80626989799995, 45.781754456],
              [-67.81112748299998, 45.76650990800006],
              [-67.80704504399995, 45.712869772000076],
              [-67.80012040199998, 45.69984731100003],
              [-67.78611608899988, 45.6912173460001],
              [-67.76177648899997, 45.680106913000074],
              [-67.74803055899991, 45.67778147400004],
              [-67.74074418099985, 45.683620911000034],
              [-67.73552486199992, 45.690752258000074],
              [-67.72798010299988, 45.692250875000084],
              [-67.7173864339999, 45.685377910000014],
              [-67.71046179199993, 45.675404358],
              [-67.70482906099988, 45.66419057200004],
              [-67.69077307099988, 45.65380360900012],
              [-67.66033565299989, 45.63737050400006],
              [-67.60752233899987, 45.620058900000046],
              [-67.55186682099992, 45.61044708300004],
              [-67.50639156199989, 45.609826966000085],
              [-67.47579911299997, 45.61297922800013],
              [-67.44996089699993, 45.610808817000034],
              [-67.43130570499997, 45.597941386000045],
              [-67.42210729999996, 45.568795878000046],
              [-67.42618973799998, 45.53344919900003],
              [-67.44303625499995, 45.52218373600006],
              [-67.46753088399993, 45.50828277600009],
              [-67.4932140709999, 45.493141581000074],
              [-67.48231034399993, 45.455521139000055],
              [-67.4288252369999, 45.387049866000055],
              [-67.43456131999994, 45.350307923000074],
              [-67.45905594899992, 45.3184235640001],
              [-67.46866776599992, 45.30183542900009],
              [-67.47502396699986, 45.2823534140001],
              [-67.47130326399994, 45.26628204400005],
              [-67.42758500199994, 45.23656809500007],
              [-67.39053299999989, 45.193108216000056],
              [-67.35627152599989, 45.165926412000076],
              [-67.31921952299993, 45.1538858040001],
              [-67.28464798999991, 45.16969879200009],
              [-67.27958369999993, 45.179052226000024],
              [-67.27922196499995, 45.18737213100009],
              [-67.27720658399991, 45.195071920000075],
              [-67.26733638499991, 45.2025133260001],
              [-67.25498571899996, 45.205045472000094],
              [-67.24242834499995, 45.20256500300012],
              [-67.21907059799992, 45.19212636300007],
              [-67.20616620799987, 45.18940058600005],
              [-67.17601477799994, 45.17865631700006],
              [-67.19127356699994, 45.18036530200004],
              [-67.2043757799999, 45.17820872600004],
              [-67.21031653599994, 45.171087958000044],
              [-67.2038874989999, 45.157497463000084],
              [-67.19989986899992, 45.15660228100006],
              [-67.17967688699991, 45.157497463000084],
              [-67.17239335799991, 45.155137437000064],
              [-67.16844641799992, 45.14952220300006],
              [-67.16596432199992, 45.14284902600008],
              [-67.15961666599992, 45.13235097900008],
              [-67.15416419199994, 45.11916738500008],
              [-67.15208899599992, 45.11656321800007],
              [-67.14598548099991, 45.11517975500004],
              [-67.13939368399991, 45.11155833500004],
              [-67.1282039049999, 45.10289134300007],
              [-67.11347408799992, 45.08694082200009],
              [-67.10029049399992, 45.06936269700009],
              [-67.11119544199994, 45.05365631700005],
              [-67.1045222649999, 45.037949937000064],
              [-67.09003658799992, 45.02586497600004],
              [-67.07701575399994, 45.02098216400009],
              [-67.07164466099994, 45.01439036700003],
              [-67.05199133999992, 44.98338450700004],
              [-67.0400691399999, 44.973171291000085],
              [-67.05223548099991, 44.96128978100006],
              [-67.05601966099994, 44.945420640000066],
              [-67.06273352799991, 44.93142324400009],
              [-67.08348548099991, 44.92540110900006],
              [-67.0945124989999, 44.93305084800005],
              [-67.10594641799992, 44.94578685100004],
              [-67.11729895699995, 44.94835032800006],
              [-67.1282039049999, 44.92540110900006],
              [-67.1130671869999, 44.91555410400008],
              [-67.1120906239999, 44.90407949400009],
              [-67.12169348899994, 44.89455801000008],
              [-67.13841712099992, 44.89065176000008],
              [-67.15135657499991, 44.89594147300005],
              [-67.18476314999992, 44.91677480700008],
              [-67.19648189999992, 44.91856517100007],
              [-67.2033992179999, 44.90489329600007],
              [-67.19054114499994, 44.89057038000004],
              [-67.17231197799993, 44.87722402600008],
              [-67.16295325399994, 44.86672597900008],
              [-67.14867102799991, 44.81553782800006],
              [-67.14598548099991, 44.82571035400008],
              [-67.14378821499992, 44.85573965100008],
              [-67.14183508999992, 44.86330801000008],
              [-67.13036048099991, 44.86473216400009],
              [-67.11436926999994, 44.846909898000035],
              [-67.10029049399992, 44.84963613500008],
              [-67.1076960929999, 44.857123114000046],
              [-67.09410559799994, 44.86330801000008],
              [-67.09711666599992, 44.86778392100007],
              [-67.10228430899991, 44.87795644700009],
              [-67.1076960929999, 44.88316478100006],
              [-67.08849036399994, 44.88812897300005],
              [-67.07473710799991, 44.870794989000046],
              [-67.06712805899991, 44.84442780200004],
              [-67.06615149599992, 44.82229238500008],
              [-67.04364986899992, 44.833970445000034],
              [-67.04198157499991, 44.85443756700005],
              [-67.05931555899991, 44.89744700700004],
              [-67.04369055899991, 44.89402903900009],
              [-67.03294837099992, 44.88438548400006],
              [-67.01215572799993, 44.857123114000046],
              [-67.0090632799999, 44.85639069200005],
              [-66.99474036399994, 44.857123114000046],
              [-66.99140377499992, 44.85565827000005],
              [-66.99144446499992, 44.85191478100006],
              [-66.99229895699995, 44.84739817900004],
              [-66.99168860599991, 44.84349192900004],
              [-66.97948157499991, 44.818793036000045],
              [-66.9773249989999, 44.81553782800006],
              [-66.98497473899994, 44.80491771000004],
              [-67.01939856699994, 44.77492910400008],
              [-67.03258216099994, 44.76711660400008],
              [-67.04246985599991, 44.76622142100007],
              [-67.06395423099991, 44.76858144700009],
              [-67.07359778599994, 44.76711660400008],
              [-67.07408606699994, 44.76369863500008],
              [-67.08226477799991, 44.74571360900006],
              [-67.08661861899992, 44.73977285400008],
              [-67.09410559799994, 44.747259833000044],
              [-67.10399329299992, 44.72898997600004],
              [-67.11322994699992, 44.71625397300005],
              [-67.16917883999992, 44.67092519700009],
              [-67.17796790299991, 44.66758860900006],
              [-67.1953425769999, 44.663275458000044],
              [-67.2038874989999, 44.65725332200009],
              [-67.20136471299992, 44.653591213000084],
              [-67.19648189999992, 44.644232489000046],
              [-67.2243953119999, 44.644232489000046],
              [-67.2326960929999, 44.64675527600008],
              [-67.24876868399991, 44.655503648000035],
              [-67.25108801999994, 44.65725332200009],
              [-67.2619929679999, 44.65770091400009],
              [-67.2690730459999, 44.654811916000085],
              [-67.26903235599991, 44.64634837400007],
              [-67.25853430899991, 44.62990957200009],
              [-67.2805476549999, 44.631374416000085],
              [-67.29478919199994, 44.63963450700004],
              [-67.30805416599992, 44.64976634300007],
              [-67.32685299399992, 44.65725332200009],
              [-67.32685299399992, 44.66474030200004],
              [-67.31098385299993, 44.68239980700008],
              [-67.31407630099994, 44.70071035400008],
              [-67.33202063699991, 44.709499416000085],
              [-67.36095130099994, 44.69883860900006],
              [-67.34736080599993, 44.692653713000084],
              [-67.36078854099992, 44.68557363500008],
              [-67.3733210929999, 44.68589915600006],
              [-67.38512122299994, 44.69118886900009],
              [-67.39574133999992, 44.69883860900006],
              [-67.38939368399991, 44.682481187000064],
              [-67.37755286399994, 44.670762437000064],
              [-67.37132727799991, 44.65770091400009],
              [-67.38206946499992, 44.63739655200004],
              [-67.3672175769999, 44.627468166000085],
              [-67.37035071499992, 44.622300523000035],
              [-67.37938391799992, 44.62128327000005],
              [-67.38206946499992, 44.62376536700003],
              [-67.39842688699991, 44.61180247600004],
              [-67.40453040299991, 44.60569896000004],
              [-67.40941321499992, 44.595811265000066],
              [-67.4221492179999, 44.61497630400004],
              [-67.42674719999991, 44.63939036700003],
              [-67.43468176999994, 44.65920644700009],
              [-67.45714270699995, 44.66474030200004],
              [-67.45079505099994, 44.647650458000044],
              [-67.45185299399992, 44.63226959800005],
              [-67.4504695299999, 44.61937083500004],
              [-67.43671627499992, 44.609483140000066],
              [-67.45433508999992, 44.60460032800006],
              [-67.47252356699994, 44.60313548400006],
              [-67.48997962099992, 44.60492584800005],
              [-67.50560462099992, 44.609483140000066],
              [-67.49946041599992, 44.62380605700008],
              [-67.50572669199994, 44.63357168200008],
              [-67.51703854099992, 44.634873765000066],
              [-67.52607174399992, 44.62376536700003],
              [-67.53290768099993, 44.62376536700003],
              [-67.53905188699991, 44.64622630400004],
              [-67.55439205599993, 44.64406972900008],
              [-67.59373938699991, 44.61631907800006],
              [-67.57319088399993, 44.61753978100006],
              [-67.56586666599992, 44.609808661000045],
              [-67.56708736899992, 44.57904694200005],
              [-67.56928463399993, 44.571153062000064],
              [-67.57323157499991, 44.562486070000034],
              [-67.5749812489999, 44.55349355700008],
              [-67.57042395699995, 44.544907945000034],
              [-67.56904049399992, 44.53868235900006],
              [-67.57787024599992, 44.535264390000066],
              [-67.58979244699992, 44.533189195000034],
              [-67.59740149599992, 44.530951239000046],
              [-67.60346432199992, 44.52810293200008],
              [-67.6120906239999, 44.526597398000035],
              [-67.62128658799992, 44.52639394700009],
              [-67.6284480459999, 44.52753327000005],
              [-67.6387019519999, 44.531683661000045],
              [-67.63975989499994, 44.53477610900006],
              [-67.63866126199991, 44.53933340100008],
              [-67.63984127499992, 44.54755280200004],
              [-67.6404109369999, 44.55487702000005],
              [-67.64374752499992, 44.56391022300005],
              [-67.64895585799991, 44.56854889500005],
              [-67.6592097649999, 44.56667715100008],
              [-67.66856848899994, 44.56146881700005],
              [-67.68370520699995, 44.548041083000044],
              [-67.7141414049999, 44.50075918200008],
              [-67.72801673099991, 44.503200588000084],
              [-67.74018307199992, 44.51036204600007],
              [-67.74876868399991, 44.521999416000085],
              [-67.7519832019999, 44.53807200700004],
              [-67.74046790299991, 44.58824290600006],
              [-67.74457760299993, 44.595811265000066],
              [-67.75560462099992, 44.58962636900009],
              [-67.78612219999991, 44.54177480700008],
              [-67.78331458199995, 44.53729889500005],
              [-67.78612219999991, 44.52753327000005],
              [-67.79015051999994, 44.53172435100004],
              [-67.80052649599992, 44.54120514500005],
              [-67.7964167959999, 44.55447011900009],
              [-67.78551184799994, 44.57058340100008],
              [-67.77928626199991, 44.58588288000004],
              [-67.78266354099992, 44.60150788000004],
              [-67.79051673099991, 44.59988027600008],
              [-67.7995906239999, 44.58860911700003],
              [-67.80663001199991, 44.575384833000044],
              [-67.8171687489999, 44.58376699400009],
              [-67.82835852799991, 44.58425527600008],
              [-67.83714758999992, 44.57774485900006],
              [-67.84593665299991, 44.551296291000085],
              [-67.85728919199994, 44.546087958000044],
              [-67.86900794199994, 44.54454173400006],
              [-67.87486731699994, 44.54177480700008],
              [-67.87205969999991, 44.53005605700008],
              [-67.8523249989999, 44.508653062000064],
              [-67.84760494699992, 44.49709707200009],
              [-67.85228430899991, 44.482530015000066],
              [-67.8635554679999, 44.479356187000064],
              [-67.87730872299994, 44.48236725500004],
              [-67.88914954299992, 44.48655833500004],
              [-67.88499915299991, 44.466905015000066],
              [-67.89960689999992, 44.42210521000004],
              [-67.90221106699994, 44.39720286700003],
              [-67.92125403599994, 44.411363023000035],
              [-67.92345130099994, 44.43777090100008],
              [-67.91502844999991, 44.46629466400009],
              [-67.90221106699994, 44.48655833500004],
              [-67.91710364499994, 44.48155345300006],
              [-67.9280085929999, 44.46828847900008],
              [-67.93468176999994, 44.45136139500005],
              [-67.93700110599991, 44.43504466400009],
              [-67.9343562489999, 44.41636790600006],
              [-67.93700110599991, 44.408636786000045],
              [-67.94721432199992, 44.41425202000005],
              [-67.95356197799993, 44.419134833000044],
              [-67.9590144519999, 44.422390041000085],
              [-67.96283932199992, 44.42674388200004],
              [-67.96430416599992, 44.43504466400009],
              [-67.96772213399993, 44.50075918200008],
              [-67.97789466099994, 44.49913157800006],
              [-67.98289954299992, 44.49416738500008],
              [-67.98456783799992, 44.486314195000034],
              [-67.98473059799994, 44.47601959800005],
              [-67.98875891799992, 44.466498114000046],
              [-67.99815833199995, 44.466498114000046],
              [-68.01581783799992, 44.47292715100008],
              [-68.02879798099991, 44.46853261900009],
              [-68.01585852799991, 44.45884837400007],
              [-67.98473059799994, 44.44558340100008],
              [-67.9844050769999, 44.440659898000035],
              [-67.97398841099994, 44.41351959800005],
              [-67.97114010299993, 44.41083405200004],
              [-67.97215735599991, 44.40375397300005],
              [-67.97472083199995, 44.39529043200008],
              [-67.97887122299994, 44.387884833000044],
              [-67.98473059799994, 44.38353099200003],
              [-67.99461829299992, 44.38353099200003],
              [-67.99779212099992, 44.38926829600007],
              [-67.99946041599992, 44.39553457200009],
              [-68.00523841099994, 44.39720286700003],
              [-68.01500403599994, 44.393744208000044],
              [-68.01532955599993, 44.39057038000004],
              [-68.01410885299993, 44.38552480700008],
              [-68.01952063699991, 44.37669505400004],
              [-68.0503230459999, 44.340358791000085],
              [-68.06053626199991, 44.32831452000005],
              [-68.07298743399991, 44.338324286000045],
              [-68.07640540299991, 44.34935130400004],
              [-68.07347571499992, 44.36204661700003],
              [-68.06663977799991, 44.37669505400004],
              [-68.08238684799994, 44.372341213000084],
              [-68.08840898299991, 44.369248765000066],
              [-68.09752356699994, 44.38572825700004],
              [-68.10741126199991, 44.41555410400008],
              [-68.11241614499994, 44.44135163000004],
              [-68.10802161399994, 44.46360911700003],
              [-68.11152096299992, 44.48008860900006],
              [-68.13935299399992, 44.48655833500004],
              [-68.14325924399992, 44.48928457200009],
              [-68.14305579299992, 44.494981187000064],
              [-68.14350338399993, 44.50002676000008],
              [-68.1491999989999, 44.50075918200008],
              [-68.15807044199994, 44.49681224200003],
              [-68.1599421869999, 44.49172597900008],
              [-68.15990149599992, 44.48586660400008],
              [-68.1628718739999, 44.47911204600007],
              [-68.16262773299991, 44.47357819200005],
              [-68.15892493399991, 44.466782945000034],
              [-68.15815182199992, 44.461045640000066],
              [-68.16661536399994, 44.458685614000046],
              [-68.18158932199992, 44.459092515000066],
              [-68.1872859369999, 44.462184963000084],
              [-68.18956458199995, 44.46950918200008],
              [-68.1902156239999, 44.49754466400009],
              [-68.1936335929999, 44.52000560100004],
              [-68.20201575399994, 44.525091864000046],
              [-68.21751868399991, 44.50075918200008],
              [-68.21983801999994, 44.48594798400006],
              [-68.21922766799992, 44.47203196800007],
              [-68.22211666599992, 44.46629466400009],
              [-68.25426184799994, 44.49351634300007],
              [-68.25926673099991, 44.50417715100008],
              [-68.25849361899992, 44.520697333000044],
              [-68.27635657499991, 44.52049388200004],
              [-68.29430091099994, 44.527777411000045],
              [-68.3081355459999, 44.52903880400004],
              [-68.31371008999992, 44.51048411700003],
              [-68.2815242179999, 44.49937571800007],
              [-68.2698054679999, 44.48607005400004],
              [-68.2864070299999, 44.466091213000084],
              [-68.28144283799992, 44.46267324400009],
              [-68.27830969999991, 44.45901113500008],
              [-68.27582760299993, 44.45530833500004],
              [-68.2727351549999, 44.45184967700004],
              [-68.31708736899992, 44.45119863500008],
              [-68.33763587099992, 44.45510488500008],
              [-68.35468502499992, 44.466091213000084],
              [-68.36192786399994, 44.445827541000085],
              [-68.38646399599992, 44.424343166000085],
              [-68.3825984369999, 44.41083405200004],
              [-68.40929114499994, 44.40464915600006],
              [-68.42296301999994, 44.405137437000064],
              [-68.42670650899993, 44.417222398000035],
              [-68.42332923099991, 44.47097402600008],
              [-68.43187415299991, 44.48659902600008],
              [-68.44994055899991, 44.49367910400008],
              [-68.47822018099993, 44.493394273000035],
              [-68.45982825399994, 44.462103583000044],
              [-68.45775305899991, 44.44871653900009],
              [-68.45950273299991, 44.44289785400008],
              [-68.46283932199992, 44.438666083000044],
              [-68.46446692599994, 44.43427155200004],
              [-68.46113033799992, 44.42820872600004],
              [-68.45604407499991, 44.424343166000085],
              [-68.45189368399991, 44.422308661000045],
              [-68.44969641799992, 44.41872793200008],
              [-68.45030676999994, 44.41083405200004],
              [-68.45518958199995, 44.40180084800005],
              [-68.46479244699992, 44.389837958000044],
              [-68.47406979099992, 44.38243235900006],
              [-68.47822018099993, 44.387233791000085],
              [-68.47813880099994, 44.41083405200004],
              [-68.48009192599994, 44.42161692900004],
              [-68.48505611899992, 44.43191152600008],
              [-68.50442460799991, 44.413356838000084],
              [-68.52599036399994, 44.40562571800007],
              [-68.54942786399994, 44.40574778900009],
              [-68.57441158799992, 44.41083405200004],
              [-68.56301835799991, 44.40058014500005],
              [-68.55150305899991, 44.37722402600008],
              [-68.54308020699995, 44.36615631700005],
              [-68.5417781239999, 44.35691966400009],
              [-68.55614173099991, 44.33002350500004],
              [-68.56017005099994, 44.318345445000034],
              [-68.55585689999992, 44.30617910400008],
              [-68.5459285149999, 44.302435614000046],
              [-68.53453528599994, 44.30064524900007],
              [-68.52599036399994, 44.29478587400007],
              [-68.52086341099994, 44.28001536700003],
              [-68.52318274599992, 44.26955801000008],
              [-68.5320124989999, 44.26662832200009],
              [-68.54649817599994, 44.274278062000064],
              [-68.54100501199991, 44.26369863500008],
              [-68.53364010299993, 44.256374416000085],
              [-68.52436275899993, 44.25092194200005],
              [-68.51292883999992, 44.24636465100008],
              [-68.54137122299994, 44.23733144700009],
              [-68.63349361899992, 44.29625071800007],
              [-68.66694088399993, 44.29820384300007],
              [-68.68370520699995, 44.29446035400008],
              [-68.7041316399999, 44.305121161000045],
              [-68.73204505099994, 44.32831452000005],
              [-68.75621497299994, 44.33445872600004],
              [-68.7917781239999, 44.316392320000034],
              [-68.82079016799992, 44.31464264500005],
              [-68.8117976549999, 44.35158926000008],
              [-68.80394446499992, 44.369248765000066],
              [-68.78978430899991, 44.37669505400004],
              [-68.78026282499991, 44.37453847900008],
              [-68.77086341099994, 44.36517975500004],
              [-68.76280676999994, 44.36306386900009],
              [-68.75328528599994, 44.36753978100006],
              [-68.75426184799994, 44.37787506700005],
              [-68.76044674399992, 44.38934967700004],
              [-68.76622473899994, 44.39720286700003],
              [-68.7532039049999, 44.40497467700004],
              [-68.7419734369999, 44.41425202000005],
              [-68.73530025899993, 44.41465892100007],
              [-68.71479244699992, 44.40530019700009],
              [-68.70478268099993, 44.40403880400004],
              [-68.69933020699995, 44.40969472900008],
              [-68.71739661399994, 44.43158600500004],
              [-68.71837317599994, 44.44558340100008],
              [-68.75621497299994, 44.430894273000035],
              [-68.76622473899994, 44.42450592700004],
              [-68.78441321499992, 44.402777411000045],
              [-68.79584713399993, 44.392564195000034],
              [-68.80711829299992, 44.39097728100006],
              [-68.8161921869999, 44.40208567900004],
              [-68.81440182199992, 44.41799551000008],
              [-68.80724036399994, 44.434108791000085],
              [-68.8003230459999, 44.44558340100008],
              [-68.79657955599993, 44.448513088000084],
              [-68.78465735599991, 44.45384349200003],
              [-68.77924557199992, 44.458685614000046],
              [-68.7766414049999, 44.464951890000066],
              [-68.7749324209999, 44.48021067900004],
              [-68.7729792959999, 44.48655833500004],
              [-68.74262447799993, 44.53729889500005],
              [-68.74620520699995, 44.55487702000005],
              [-68.77924557199992, 44.561712958000044],
              [-68.79584713399993, 44.56199778900009],
              [-68.80162512899994, 44.56028880400004],
              [-68.80711829299992, 44.534369208000044],
              [-68.82762610599991, 44.47911204600007],
              [-68.82140051999994, 44.47846100500004],
              [-68.80711829299992, 44.47292715100008],
              [-68.82469641799992, 44.461045640000066],
              [-68.8452449209999, 44.45380280200004],
              [-68.85712643099993, 44.45608144700009],
              [-68.84813391799992, 44.47292715100008],
              [-68.86274166599992, 44.47536855700008],
              [-68.87962805899991, 44.46853261900009],
              [-68.90648352799991, 44.44871653900009],
              [-68.91942298099991, 44.441392320000034],
              [-68.96544348899994, 44.43191152600008],
              [-68.9866023429999, 44.421169338000084],
              [-68.98228919199994, 44.41360097900008],
              [-68.97191321499992, 44.40578847900008],
              [-68.97508704299992, 44.39406972900008],
              [-68.97276770699995, 44.38381582200009],
              [-68.94456946499992, 44.348822333000044],
              [-68.93748938699991, 44.33197663000004],
              [-68.94554602799991, 44.31716543200008],
              [-68.96410071499992, 44.307806708000044],
              [-68.98460852799991, 44.301214911000045],
              [-68.99897213399993, 44.29478587400007],
              [-69.02159583199995, 44.24778880400004],
              [-69.03624426999994, 44.23261139500005],
              [-69.05357825399994, 44.18492259300007],
              [-69.0679011709999, 44.15896230700008],
              [-69.07774817599994, 44.144964911000045],
              [-69.08832760299993, 44.13650136900009],
              [-69.08832760299993, 44.13031647300005],
              [-69.08287512899994, 44.11526113500008],
              [-69.08954830599993, 44.098089911000045],
              [-69.08690344999991, 44.08669668200008],
              [-69.05357825399994, 44.08930084800005],
              [-69.0652156239999, 44.067613023000035],
              [-69.07579505099994, 44.05251699400009],
              [-69.09150143099993, 44.043809312000064],
              [-69.11876380099994, 44.04087962400007],
              [-69.12621008999992, 44.03103261900009],
              [-69.1306453119999, 44.01174551000008],
              [-69.14203854099992, 43.99872467700004],
              [-69.17027747299994, 44.00743235900006],
              [-69.17182369699992, 43.99717845300006],
              [-69.17589270699995, 43.991400458000044],
              [-69.18248450399994, 43.99001699400009],
              [-69.19139563699991, 43.99310944200005],
              [-69.19957434799994, 43.98187897300005],
              [-69.20364335799991, 43.97032298400006],
              [-69.20164954299992, 43.95998769700009],
              [-69.19139563699991, 43.95217519700009],
              [-69.22704016799992, 43.935248114000046],
              [-69.23851477799991, 43.93166738500008],
              [-69.25800533799992, 43.92800527600008],
              [-69.26341712099992, 43.92991771000004],
              [-69.25963294199994, 43.95526764500005],
              [-69.22923743399991, 43.99099355700008],
              [-69.21947180899991, 44.00849030200004],
              [-69.23851477799991, 44.00743235900006],
              [-69.2988582019999, 43.950384833000044],
              [-69.31053626199991, 43.94163646000004],
              [-69.3137507799999, 43.954331773000035],
              [-69.30317135299993, 43.98122793200008],
              [-69.31395423099991, 43.98627350500004],
              [-69.32831783799992, 43.98338450700004],
              [-69.3533015619999, 43.97243886900009],
              [-69.36949622299994, 43.972642320000034],
              [-69.35326087099992, 43.994655666000085],
              [-69.34715735599991, 44.00775788000004],
              [-69.35179602799991, 44.01361725500004],
              [-69.3694148429999, 44.01585521000004],
              [-69.3701472649999, 44.02151113500008],
              [-69.35179602799991, 44.037543036000045],
              [-69.34727942599994, 44.050767320000034],
              [-69.35419674399992, 44.06049225500004],
              [-69.3642878899999, 44.060532945000034],
              [-69.36949622299994, 44.04466380400004],
              [-69.37657630099994, 44.03672923400006],
              [-69.39098059799994, 44.03192780200004],
              [-69.40221106699994, 44.026597398000035],
              [-69.39488684799994, 44.00242747600004],
              [-69.40770423099991, 43.99433014500005],
              [-69.42426510299993, 43.99164459800005],
              [-69.43036861899992, 43.99310944200005],
              [-69.44090735599991, 43.98139069200005],
              [-69.44778398299991, 43.96755605700008],
              [-69.4787898429999, 43.88031647300005],
              [-69.49413001199991, 43.85110097900008],
              [-69.51292883999992, 43.83490631700005],
              [-69.51435299399992, 43.85565827000005],
              [-69.52167721299992, 43.870347398000035],
              [-69.52989661399994, 43.88300202000005],
              [-69.5339656239999, 43.89756907800006],
              [-69.54023189999992, 43.89756907800006],
              [-69.54544023299991, 43.88328685100004],
              [-69.54759680899991, 43.86786530200004],
              [-69.5476374989999, 43.83490631700005],
              [-69.56126868399991, 43.84910716400009],
              [-69.55382239499994, 43.85655345300006],
              [-69.56908118399991, 43.868394273000035],
              [-69.57050533799992, 43.87791575700004],
              [-69.56541907499991, 43.88698965100008],
              [-69.56126868399991, 43.89756907800006],
              [-69.55980383999992, 43.90407949400009],
              [-69.55492102799991, 43.91579824400009],
              [-69.55382239499994, 43.92084381700005],
              [-69.55601966099994, 43.92767975500004],
              [-69.56537838399993, 43.93427155200004],
              [-69.56749426999994, 43.94163646000004],
              [-69.5588679679999, 43.96458567900004],
              [-69.52904212099992, 44.00438060100004],
              [-69.5339656239999, 44.02102285400008],
              [-69.54487057199992, 44.01194896000004],
              [-69.55406653599994, 43.998561916000085],
              [-69.56749426999994, 43.972642320000034],
              [-69.58055579299992, 43.957017320000034],
              [-69.58580481699994, 43.948472398000035],
              [-69.58458411399994, 43.94163646000004],
              [-69.5818171869999, 43.93455638200004],
              [-69.58421790299991, 43.925767320000034],
              [-69.58930416599992, 43.91734446800007],
              [-69.5947566399999, 43.91115957200009],
              [-69.58934485599991, 43.904811916000085],
              [-69.58751380099994, 43.89724355700008],
              [-69.58930416599992, 43.88963450700004],
              [-69.5947566399999, 43.883246161000045],
              [-69.58482825399994, 43.87071360900006],
              [-69.5779109369999, 43.85565827000005],
              [-69.57603919199994, 43.83897532800006],
              [-69.58116614499994, 43.82180410400008],
              [-69.59239661399994, 43.80772532800006],
              [-69.59614010299993, 43.81590403900009],
              [-69.5947566399999, 43.84910716400009],
              [-69.60989335799991, 43.83958567900004],
              [-69.62446041599992, 43.838405666000085],
              [-69.63963782499991, 43.84446849200003],
              [-69.65693111899992, 43.85655345300006],
              [-69.66889400899993, 43.86705149900007],
              [-69.67011471299992, 43.873561916000085],
              [-69.64940344999991, 43.89756907800006],
              [-69.65379798099991, 43.90497467700004],
              [-69.65501868399991, 43.91050853100006],
              [-69.65343176999994, 43.91620514500005],
              [-69.64940344999991, 43.924261786000045],
              [-69.64244544199994, 43.92125071800007],
              [-69.62934322799993, 43.919216213000084],
              [-69.62279212099992, 43.91742584800005],
              [-69.63121497299994, 43.92922597900008],
              [-69.64268958199995, 43.93345774900007],
              [-69.6526179679999, 43.93899160400008],
              [-69.65693111899992, 43.95526764500005],
              [-69.65367591099994, 43.96775950700004],
              [-69.63642330599993, 44.00368886900009],
              [-69.63011633999992, 44.00804271000004],
              [-69.6191707019999, 44.01752350500004],
              [-69.61510169199994, 44.025905666000085],
              [-69.62958736899992, 44.02728913000004],
              [-69.64317786399994, 44.02098216400009],
              [-69.65697180899991, 44.00922272300005],
              [-69.74970455599993, 43.90066152600008],
              [-69.75922604099992, 43.886419989000046],
              [-69.75267493399991, 43.87913646000004],
              [-69.7402644519999, 43.87486399900007],
              [-69.7319636709999, 43.869574286000045],
              [-69.72972571499992, 43.85594310100004],
              [-69.73265540299991, 43.841905015000066],
              [-69.74628658799992, 43.81439850500004],
              [-69.7358699209999, 43.82058340100008],
              [-69.72240149599992, 43.84422435100004],
              [-69.71214758999992, 43.84910716400009],
              [-69.70470130099994, 43.84202708500004],
              [-69.70726477799991, 43.82693105700008],
              [-69.7307429679999, 43.775905666000085],
              [-69.74498450399994, 43.75877513200004],
              [-69.75800533799992, 43.75950755400004],
              [-69.76679439999992, 43.787624416000085],
              [-69.76622473899994, 43.79486725500004],
              [-69.76362057199992, 43.798936265000066],
              [-69.76069088399993, 43.801621812000064],
              [-69.75926673099991, 43.80442942900004],
              [-69.76146399599992, 43.81155019700009],
              [-69.76630611899992, 43.813666083000044],
              [-69.77118893099993, 43.813666083000044],
              [-69.77354895699995, 43.81439850500004],
              [-69.78038489499994, 43.86277903900009],
              [-69.78364010299993, 43.873480536000045],
              [-69.79072018099993, 43.886704820000034],
              [-69.79405676999994, 43.89756907800006],
              [-69.79527747299994, 43.91042715100008],
              [-69.79487057199992, 43.92214590100008],
              [-69.7956843739999, 43.93345774900007],
              [-69.80089270699995, 43.94468821800007],
              [-69.80337480399993, 43.964911200000074],
              [-69.80728105399993, 43.98314036700003],
              [-69.80467688699991, 43.99746328300006],
              [-69.8020727199999, 44.01439036700003],
              [-69.7903539699999, 44.02871328300006],
              [-69.78123938699991, 44.03652578300006],
              [-69.7708227199999, 44.04564036700003],
              [-69.76821855399993, 44.05345286700003],
              [-69.76821855399993, 44.058661200000074],
              [-69.7747289699999, 44.05996328300006],
              [-69.7825414699999, 44.05735911700003],
              [-69.78905188699991, 44.04954661700003],
              [-69.79946855399993, 44.04433828300006],
              [-69.8176977199999, 44.03652578300006],
              [-69.8450414699999, 44.01048411700003],
              [-69.8645727199999, 43.99746328300006],
              [-69.87498938699991, 43.98704661700003],
              [-69.88280188699991, 43.976629950000074],
              [-69.88280188699991, 43.96360911700003],
              [-69.8723852199999, 43.95840078300006],
              [-69.85415605399993, 43.95840078300006],
              [-69.8411352199999, 43.96621328300006],
              [-69.83202063699991, 43.97402578300006],
              [-69.8255102199999, 43.97011953300006],
              [-69.8216039699999, 43.961004950000074],
              [-69.81509355399993, 43.933661200000074],
              [-69.80223548099991, 43.860541083000044],
              [-69.80089270699995, 43.82518138200004],
              [-69.79194088399993, 43.791001695000034],
              [-69.7825007799999, 43.77293528900009],
              [-69.78038489499994, 43.76345449400009],
              [-69.78730221299992, 43.737534898000035],
              [-69.79063880099994, 43.73309967700004],
              [-69.80317135299993, 43.729681708000044],
              [-69.8142390619999, 43.72117747600004],
              [-69.82286536399994, 43.70994700700004],
              [-69.8281550769999, 43.69826894700009],
              [-69.83930416599992, 43.70925527600008],
              [-69.8418269519999, 43.74026113500008],
              [-69.85208085799991, 43.74669017100007],
              [-69.85789954299992, 43.75425853100006],
              [-69.85838782499991, 43.770778713000084],
              [-69.8554988269999, 43.79389069200005],
              [-69.85179602799991, 43.80080801000008],
              [-69.84703528599994, 43.80373769700009],
              [-69.84300696499992, 43.807806708000044],
              [-69.84125729099992, 43.818060614000046],
              [-69.84459387899994, 43.82676829600007],
              [-69.85960852799991, 43.83653392100007],
              [-69.86298580599993, 43.84572988500008],
              [-69.86021887899994, 43.85622793200008],
              [-69.85619055899991, 43.86208730700008],
              [-69.85712643099993, 43.86570872600004],
              [-69.86913001199991, 43.869574286000045],
              [-69.87926184799994, 43.87055084800005],
              [-69.88853919199994, 43.868353583000044],
              [-69.89683997299994, 43.86355215100008],
              [-69.90392005099994, 43.85655345300006],
              [-69.89171301999994, 43.85134511900009],
              [-69.88133704299992, 43.84402090100008],
              [-69.87535559799994, 43.83230215100008],
              [-69.8760066399999, 43.81439850500004],
              [-69.88300533799992, 43.80056386900009],
              [-69.89476477799991, 43.78933340100008],
              [-69.90562903599994, 43.78729889500005],
              [-69.91014563699991, 43.801296291000085],
              [-69.95112057199992, 43.76036204600007],
              [-69.95820064999992, 43.75633372600004],
              [-69.96528072799993, 43.75462474200003],
              [-69.97069251199991, 43.75149160400008],
              [-69.97435462099992, 43.73497142100007],
              [-69.97850501199991, 43.72943756700005],
              [-69.98485266799992, 43.72634511900009],
              [-69.99266516799992, 43.72561269700009],
              [-69.92629960799991, 43.828558661000045],
              [-69.93065344999991, 43.84910716400009],
              [-69.94212805899991, 43.841498114000046],
              [-69.95836341099994, 43.82180410400008],
              [-69.97276770699995, 43.79950592700004],
              [-69.97899329299992, 43.78396230700008],
              [-69.98294023299991, 43.76744212400007],
              [-69.9934382799999, 43.75181712400007],
              [-70.00890051999994, 43.74123769700009],
              [-70.02745520699995, 43.739935614000046],
              [-70.00947018099993, 43.766872463000084],
              [-69.96263587099992, 43.82103099200003],
              [-69.95112057199992, 43.84910716400009],
              [-69.97309322799993, 43.84711334800005],
              [-70.00637773299991, 43.82709381700005],
              [-70.02000891799992, 43.828640041000085],
              [-70.01085364499994, 43.833278713000084],
              [-70.00068111899992, 43.84084707200009],
              [-69.99168860599991, 43.850856838000084],
              [-69.98582923099991, 43.86277903900009],
              [-69.99937903599994, 43.86151764500005],
              [-70.0117488269999, 43.85565827000005],
              [-70.02232825399994, 43.84719472900008],
              [-70.03958085799991, 43.830064195000034],
              [-70.05003821499992, 43.82396067900004],
              [-70.07465572799993, 43.81439850500004],
              [-70.08800208199995, 43.811061916000085],
              [-70.0989070299999, 43.80992259300007],
              [-70.10883541599992, 43.806748765000066],
              [-70.16087805899991, 43.76654694200005],
              [-70.18260657499991, 43.757066148000035],
              [-70.20868893099993, 43.715277411000045],
              [-70.23912512899994, 43.700059312000064],
              [-70.23847408799992, 43.68703847900008],
              [-70.23375403599994, 43.673041083000044],
              [-70.23228919199994, 43.664170640000066],
              [-70.2429499989999, 43.65391673400006],
              [-70.25670325399994, 43.65013255400004],
              [-70.28685462099992, 43.650498765000066],
              [-70.28685462099992, 43.64305247600004],
              [-70.25776119699992, 43.64048899900007],
              [-70.23155676999994, 43.64154694200005],
              [-70.21088619699992, 43.63503652600008],
              [-70.19810950399994, 43.60956452000005],
              [-70.19823157499991, 43.59865957200009],
              [-70.20287024599992, 43.567613023000035],
              [-70.20494544199994, 43.56114329600007],
              [-70.2202449209999, 43.55906810100004],
              [-70.24583899599992, 43.54979075700004],
              [-70.26020260299993, 43.54747142100007],
              [-70.2558894519999, 43.554388739000046],
              [-70.2527156239999, 43.56114329600007],
              [-70.2715144519999, 43.55691152600008],
              [-70.29259192599994, 43.53453196800007],
              [-70.30797278599994, 43.52696360900006],
              [-70.31053626199991, 43.54836660400008],
              [-70.32542883999992, 43.54954661700003],
              [-70.34373938699991, 43.539496161000045],
              [-70.35643469999991, 43.52696360900006],
              [-70.36738033799992, 43.50531647300005],
              [-70.37071692599994, 43.48635488500008],
              [-70.36839758999992, 43.467230536000045],
              [-70.3625789049999, 43.44505442900004],
              [-70.34321041599992, 43.454291083000044],
              [-70.3327937489999, 43.457546291000085],
              [-70.32164466099994, 43.45872630400004],
              [-70.32164466099994, 43.45250071800007],
              [-70.3352351549999, 43.44729238500008],
              [-70.34691321499992, 43.439439195000034],
              [-70.36640377499992, 43.42084381700005],
              [-70.36949622299994, 43.41551341400009],
              [-70.37352454299992, 43.40188222900008],
              [-70.3762507799999, 43.39724355700008],
              [-70.38243567599994, 43.393744208000044],
              [-70.39504960799991, 43.39260488500008],
              [-70.40355383999992, 43.389837958000044],
              [-70.42259680899991, 43.37689850500004],
              [-70.43769283799992, 43.362982489000046],
              [-70.45445716099994, 43.35061269700009],
              [-70.47870846299992, 43.342637437000064],
              [-70.50873775899993, 43.341498114000046],
              [-70.51952063699991, 43.339544989000046],
              [-70.53049754187015, 43.33177853315683],
              [-70.56187903599994, 43.30105215100008],
              [-70.57054602799991, 43.298488674000055],
              [-70.58165442599994, 43.27488841400009],
              [-70.58311926999994, 43.250881252000056],
              [-70.56891842399995, 43.22898997600004],
              [-70.58360755099994, 43.21393463700008],
              [-70.59679114499994, 43.19546133000006],
              [-70.58259029899995, 43.18862539300005],
              [-70.59951738199993, 43.18223704600007],
              [-70.61172441299993, 43.17300039300005],
              [-70.63097083199995, 43.14708079600007],
              [-70.66014563699991, 43.09414297100005],
              [-70.6719457669999, 43.085598049000055],
              [-70.68712317599994, 43.09214915600006],
              [-70.70030676999994, 43.10846588700008],
              [-70.71467037699995, 43.121934312000064],
              [-70.73338782499991, 43.120428778000075],
              [-70.73127193899995, 43.11465078300006],
              [-70.74233964799993, 43.087958075000074],
              [-70.74408932199992, 43.08380768400008],
              [-70.75450598899994, 43.05898672100005],
              [-70.7324926419999, 43.06329987200007],
              [-70.70954342399995, 43.06517161700003],
              [-70.70421301999994, 43.05890534100007],
              [-70.70848548099991, 43.04523346600007],
              [-70.71589107999995, 43.03217194200005],
              [-70.71971594999991, 43.02757396000004],
              [-70.72838294199994, 43.01129791900007],
              [-70.78180904899995, 42.94912344000005],
              [-70.80329342399995, 42.91388580900008],
              [-70.81187903599994, 42.89313385600008],
              [-70.81427975199995, 42.87730540600006],
              [-70.81533769399994, 42.87026601800005],
              [-70.80724036399994, 42.83494700700004],
              [-70.80915279899995, 42.826239325000074],
              [-70.81826738199993, 42.823919989000046],
              [-70.86375891799992, 42.826239325000074],
              [-70.85362708199995, 42.81696198100008],
              [-70.84414628799993, 42.81199778900009],
              [-70.82274329299992, 42.80442942900004],
              [-70.82022050699993, 42.804348049000055],
              [-70.81265214799993, 42.80524323100008],
              [-70.80915279899995, 42.80442942900004],
              [-70.80577551999994, 42.80125560100004],
              [-70.80077063699991, 42.79254791900007],
              [-70.80435136599993, 42.78038157800006],
              [-70.77509518099993, 42.71633535400008],
              [-70.78262285099993, 42.70892975500004],
              [-70.81240800699993, 42.74213288000004],
              [-70.82359778599994, 42.74986399900007],
              [-70.8196101549999, 42.718736070000034],
              [-70.79845130099994, 42.70189036700003],
              [-70.74160722599993, 42.681626695000034],
              [-70.7571101549999, 42.675482489000046],
              [-70.76528886599993, 42.67430247600004],
              [-70.77509518099993, 42.67479075700004],
              [-70.7571101549999, 42.65721263200004],
              [-70.70132402299993, 42.65330638200004],
              [-70.70006262899994, 42.640611070000034],
              [-70.68228105399993, 42.63218821800007],
              [-70.67768307199992, 42.64134349200003],
              [-70.67955481699994, 42.667954820000034],
              [-70.6714167959999, 42.67711009300007],
              [-70.6589656239999, 42.68431224200003],
              [-70.63174394399994, 42.694606838000084],
              [-70.63365637899994, 42.68003978100006],
              [-70.6299128899999, 42.67206452000005],
              [-70.62124589799993, 42.66868724200003],
              [-70.60785885299993, 42.667954820000034],
              [-70.59805253799993, 42.66498444200005],
              [-70.5993953119999, 42.65770091400009],
              [-70.60220292899993, 42.64866771000004],
              [-70.59703528599994, 42.640611070000034],
              [-70.59703528599994, 42.634466864000046],
              [-70.61148027299993, 42.63450755400004],
              [-70.6184382799999, 42.62885163000004],
              [-70.62344316299993, 42.62046946800007],
              [-70.63174394399994, 42.61273834800005],
              [-70.64248613199993, 42.606675523000035],
              [-70.64732825399994, 42.60451894700009],
              [-70.66588294199994, 42.60647207200009],
              [-70.66694088399993, 42.60850657800006],
              [-70.66909745999993, 42.61168040600006],
              [-70.67475338399993, 42.61229075700004],
              [-70.68639075399994, 42.60647207200009],
              [-70.69566809799994, 42.59739817900004],
              [-70.70132402299993, 42.58856842700004],
              [-70.70889238199993, 42.58181386900009],
              [-70.81029212099992, 42.56281159100007],
              [-70.8613988919999, 42.546942450000074],
              [-70.87800045499995, 42.537543036000045],
              [-70.87059485599991, 42.53070709800005],
              [-70.87889563699991, 42.52594635600008],
              [-70.88512122299994, 42.519964911000045],
              [-70.88931230399993, 42.51227448100008],
              [-70.89167232999995, 42.50275299700007],
              [-70.87779700399994, 42.507879950000074],
              [-70.86432857999995, 42.51829661700003],
              [-70.85411536399994, 42.52366771000004],
              [-70.85008704299992, 42.513657945000034],
              [-70.84032141799992, 42.50486888200004],
              [-70.83820553299995, 42.49917226800005],
              [-70.84675045499995, 42.49656810100004],
              [-70.85529537699995, 42.49506256700005],
              [-70.86074785099993, 42.49135976800005],
              [-70.86522376199991, 42.48688385600008],
              [-70.88512122299994, 42.47284577000005],
              [-70.89167232999995, 42.46930573100008],
              [-70.89940344999991, 42.46816640800006],
              [-70.91551673099991, 42.46942780200004],
              [-70.92210852799991, 42.46556224200003],
              [-70.92540442599994, 42.453192450000074],
              [-70.91755123599995, 42.44277578300006],
              [-70.90428626199991, 42.43439362200007],
              [-70.89167232999995, 42.42829010600008],
              [-70.91637122299994, 42.42243073100008],
              [-70.94367428299995, 42.446966864000046],
              [-70.96304277299993, 42.43829987200007],
              [-70.97337805899991, 42.425116278000075],
              [-70.97435462099992, 42.416449286000045],
              [-70.96617591099994, 42.400376695000034],
              [-70.96304277299993, 42.37836334800005],
              [-70.96031653599994, 42.36904531500005],
              [-70.95250403599994, 42.359442450000074],
              [-70.96727454299992, 42.36074453300006],
              [-70.98363196499992, 42.376613674000055],
              [-70.99718176999994, 42.380560614000046],
              [-71.00723222599993, 42.37759023600006],
              [-71.00584876199991, 42.370794989000046],
              [-70.99767005099994, 42.36367422100005],
              [-70.98721269399994, 42.359442450000074],
              [-71.00601152299993, 42.357123114000046],
              [-71.02269446499992, 42.36664459800005],
              [-71.03685462099992, 42.37246328300006],
              [-71.04869544199994, 42.359442450000074],
              [-71.03742428299995, 42.35700104400007],
              [-71.02769934799994, 42.353583075000074],
              [-71.02000891799992, 42.34796784100007],
              [-71.01455644399994, 42.33893463700008],
              [-71.02985592399995, 42.33783600500004],
              [-71.0423070949999, 42.33177317900004],
              [-71.04678300699993, 42.321519273000035],
              [-71.03844153599994, 42.307928778000075],
              [-71.02721106699994, 42.300482489000046],
              [-71.01781165299991, 42.30019765800006],
              [-70.9934789699999, 42.310980536000045],
              [-70.99889075399994, 42.28375885600008],
              [-70.98350989499994, 42.27960846600007],
              [-70.96288001199991, 42.28021881700005],
              [-70.95250403599994, 42.267238674000055],
              [-70.95531165299991, 42.261786200000074],
              [-70.96617591099994, 42.25381094000005],
              [-70.96617591099994, 42.24957916900007],
              [-70.96178137899994, 42.24624258000006],
              [-70.95531165299991, 42.24331289300005],
              [-70.94953365799995, 42.24282461100006],
              [-70.94688880099994, 42.24648672100005],
              [-70.94050045499995, 42.24599844000005],
              [-70.92577063699991, 42.25039297100005],
              [-70.90953528599994, 42.25722890800006],
              [-70.8985082669999, 42.26386139500005],
              [-70.88719641799992, 42.25055573100008],
              [-70.87539628799993, 42.25446198100008],
              [-70.86733964799993, 42.264837958000044],
              [-70.86709550699993, 42.27065664300005],
              [-70.88011633999992, 42.276678778000075],
              [-70.8919164699999, 42.290716864000046],
              [-70.89907792899993, 42.30658600500004],
              [-70.8985082669999, 42.318426825000074],
              [-70.85578365799995, 42.28392161700003],
              [-70.83141028599994, 42.26968008000006],
              [-70.78380286399994, 42.25967031500005],
              [-70.76158606699994, 42.249212958000044],
              [-70.74181067599994, 42.235663153000075],
              [-70.71629798099991, 42.21185944200005],
              [-70.71373450399994, 42.205145575000074],
              [-70.71349036399994, 42.17536041900007],
              [-70.71312415299991, 42.17243073100008],
              [-70.70836341099994, 42.17218659100007],
              [-70.69587154899995, 42.16388580900008],
              [-70.67821204299992, 42.14411041900007],
              [-70.65298417899993, 42.109035549000055],
              [-70.63097083199995, 42.09251536700003],
              [-70.63613847599993, 42.075425523000035],
              [-70.62775631399995, 42.05914948100008],
              [-70.59756425699993, 42.023098049000055],
              [-70.59219316299993, 42.02008698100008],
              [-70.59080969999991, 42.01732005400004],
              [-70.59679114499994, 42.010646877000056],
              [-70.6067602199999, 42.00458405200004],
              [-70.61729895699995, 42.003241278000075],
              [-70.62791907499991, 42.005560614000046],
              [-70.63780676999994, 42.010646877000056],
              [-70.6328832669999, 42.01211172100005],
              [-70.62360592399995, 42.016058661000045],
              [-70.61729895699995, 42.016791083000044],
              [-70.62930253799993, 42.04433828300006],
              [-70.63890540299991, 42.05890534100007],
              [-70.64834550699993, 42.06525299700007],
              [-70.65575110599991, 42.05801015800006],
              [-70.66510982999995, 42.010646877000056],
              [-70.67503821499992, 42.01471588700008],
              [-70.68285071499992, 42.016058661000045],
              [-70.69033769399994, 42.01471588700008],
              [-70.71483313699991, 42.00267161700003],
              [-70.65493730399993, 41.957098700000074],
              [-70.62368730399993, 41.955064195000034],
              [-70.60496985599991, 41.95254140800006],
              [-70.56582597599993, 41.95538971600007],
              [-70.5449926419999, 41.940619208000044],
              [-70.52965247299994, 41.90648021000004],
              [-70.52391516799992, 41.868394273000035],
              [-70.53164628799993, 41.841782945000034],
              [-70.53311113199993, 41.81622955900008],
              [-70.50426184799994, 41.79002513200004],
              [-70.43919837099992, 41.75608958500004],
              [-70.40086829299992, 41.745021877000056],
              [-70.2747289699999, 41.73627350500004],
              [-70.28986568899995, 41.731634833000044],
              [-70.32648678299995, 41.73139069200005],
              [-70.33950761599993, 41.72573476800005],
              [-70.33519446499992, 41.71922435100004],
              [-70.31525631399995, 41.71556224200003],
              [-70.2747289699999, 41.71515534100007],
              [-70.24372311099995, 41.72410716400009],
              [-70.19131425699993, 41.74705638200004],
              [-70.10081946499992, 41.76593659100007],
              [-70.07024135499995, 41.77345836300009],
              [-70.0364477199999, 41.78583405200004],
              [-70.02147376199991, 41.79092031500005],
              [-70.00011145699995, 41.81631094000005],
              [-70.00384537999992, 41.84629625700006],
              [-70.00182044199994, 41.88190338700008],
              [-70.02147376199991, 41.90692780200004],
              [-70.01158606699994, 41.90688711100006],
              [-70.00316321499992, 41.90859609600005],
              [-69.98668372299994, 41.913763739000046],
              [-69.98668372299994, 41.921210028000075],
              [-70.00601152299993, 41.92283763200004],
              [-70.01866614499994, 41.93008047100005],
              [-70.02814693899995, 41.93797435100004],
              [-70.03791256399995, 41.94163646000004],
              [-70.05182857999995, 41.935248114000046],
              [-70.05736243399991, 41.90424225500004],
              [-70.06867428299995, 41.89329661700003],
              [-70.07184060599991, 41.92767896200007],
              [-70.07449030399994, 41.947629265000046],
              [-70.07979003299994, 41.995005957000046],
              [-70.08378508699991, 42.01245404800005],
              [-70.09985152999991, 42.03739025200008],
              [-70.13809623599991, 42.05735172200008],
              [-70.16561855899994, 42.063835382000036],
              [-70.18979396599991, 42.04938290900009],
              [-70.19212805899991, 42.03790924700007],
              [-70.17666581899994, 42.03750234600005],
              [-70.17162024599992, 42.03790924700007],
              [-70.17080783599994, 42.027879022000036],
              [-70.18927424799995, 42.017859987000065],
              [-70.20255630499992, 42.02620317800006],
              [-70.22461556399992, 42.05038091800009],
              [-70.23135065699995, 42.05723842700007],
              [-70.24009043699994, 42.059226541000044],
              [-70.24681974999993, 42.06146809100005],
              [-70.2443117219999, 42.06871845400008],
              [-70.23659639399995, 42.07585514200008],
              [-70.22937675999992, 42.08061614800005],
              [-70.2157641309999, 42.08464253200009],
              [-70.19221990999995, 42.086062010000035],
              [-70.16766170999995, 42.08297692500008],
              [-70.14646626399991, 42.08101090000008],
              [-70.11786349499994, 42.07380536000005],
              [-70.08119777499991, 42.058353658000044],
              [-70.05112347799991, 42.03975263400008],
              [-70.01401152999995, 41.99894051900009],
              [-69.98216798199991, 41.95362116400008],
              [-69.9432553229999, 41.85762526100007],
              [-69.92467200399994, 41.83808014500005],
              [-69.92772376199991, 41.834865627000056],
              [-69.93101966099994, 41.83295319200005],
              [-69.93468176999994, 41.832098700000074],
              [-69.93887285099993, 41.83185455900008],
              [-69.95335852799991, 41.84088776200008],
              [-69.9639611799999, 41.84353287700009],
              [-69.97203528599994, 41.839178778000075],
              [-69.97573808499993, 41.810532945000034],
              [-69.97984778599994, 41.79706452000005],
              [-69.95665442599994, 41.807806708000044],
              [-69.94200598899994, 41.80646393400008],
              [-69.93423417899993, 41.792954820000034],
              [-69.93252519399994, 41.74103424700007],
              [-69.93887285099993, 41.67422109600005],
              [-69.97813880099994, 41.68183014500005],
              [-70.13687089799993, 41.66054922100005],
              [-70.18529212099992, 41.66054922100005],
              [-70.21735592399995, 41.64826080900008],
              [-70.22964433499993, 41.64622630400004],
              [-70.23989824099993, 41.64325592700004],
              [-70.24852454299992, 41.63568756700005],
              [-70.26414954299992, 41.61615631700005],
              [-70.2727758449999, 41.610581773000035],
              [-70.27122962099992, 41.62103913000004],
              [-70.2610570949999, 41.64622630400004],
              [-70.27599036399994, 41.644232489000046],
              [-70.30304928299995, 41.634751695000034],
              [-70.31908118399991, 41.63263580900008],
              [-70.35195878799993, 41.635199286000045],
              [-70.36587480399993, 41.632798570000034],
              [-70.38084876199991, 41.62299225500004],
              [-70.39159094999991, 41.619208075000074],
              [-70.40587317599994, 41.63751862200007],
              [-70.41808020699995, 41.64004140800006],
              [-70.42837480399993, 41.63190338700008],
              [-70.45909583199995, 41.59162018400008],
              [-70.47984778599994, 41.573879299000055],
              [-70.50426184799994, 41.563706773000035],
              [-70.53270423099991, 41.55914948100008],
              [-70.56582597599993, 41.55817291900007],
              [-70.59605872299994, 41.55304596600007],
              [-70.65868167499991, 41.52134910800004],
              [-70.6856176419999, 41.53082916900007],
              [-70.66173255099994, 41.550482489000046],
              [-70.65249589799993, 41.57802969000005],
              [-70.65200761599993, 41.65424225500004],
              [-70.65709387899994, 41.67055898600006],
              [-70.6582738919999, 41.684475002000056],
              [-70.65200761599993, 41.69391510600008],
              [-70.6399633449999, 41.70229726800005],
              [-70.63190670499995, 41.71112702000005],
              [-70.63780676999994, 41.721991278000075],
              [-70.62816321499992, 41.72809479400007],
              [-70.62360592399995, 41.72943756700005],
              [-70.63060462099992, 41.74013906500005],
              [-70.64000403599994, 41.74095286700003],
              [-70.64818274599992, 41.73419830900008],
              [-70.65143795499995, 41.721991278000075],
              [-70.6582738919999, 41.721991278000075],
              [-70.68980872299994, 41.73969147300005],
              [-70.71043860599991, 41.748032945000034],
              [-70.71971594999991, 41.746161200000074],
              [-70.72329667899993, 41.713771877000056],
              [-70.72191321499992, 41.701605536000045],
              [-70.71288001199991, 41.68781159100007],
              [-70.73932857999995, 41.69013092700004],
              [-70.74909420499995, 41.679754950000074],
              [-70.75609290299991, 41.66303131700005],
              [-70.77432206899994, 41.64622630400004],
              [-70.78604081899994, 41.66046784100007],
              [-70.79784094999991, 41.65888092700004],
              [-70.80573482999995, 41.65102773600006],
              [-70.80573482999995, 41.64622630400004],
              [-70.80500240799995, 41.642564195000034],
              [-70.82111568899995, 41.63499583500004],
              [-70.84056555899991, 41.628892320000034],
              [-70.85008704299992, 41.62954336100006],
              [-70.84398352799991, 41.603949286000045],
              [-70.84520423099991, 41.59247467700004],
              [-70.85692298099991, 41.59162018400008],
              [-70.86290442599994, 41.59723541900007],
              [-70.86998450399994, 41.61587148600006],
              [-70.87425696499992, 41.62299225500004],
              [-70.88101152299993, 41.62791575700004],
              [-70.90538489499994, 41.64004140800006],
              [-70.90733801999994, 41.614935614000046],
              [-70.92096920499995, 41.59833405200004],
              [-70.93163001199991, 41.58026764500005],
              [-70.92516028599994, 41.55072663000004],
              [-70.94762122299994, 41.536444403000075],
              [-70.95970618399991, 41.53119538000004],
              [-70.97362219999991, 41.53082916900007],
              [-70.97223873599995, 41.53510163000004],
              [-70.97093665299991, 41.53766510600008],
              [-71.01545162699995, 41.51227448100008],
              [-71.04015051999994, 41.507147528000075],
              [-71.06981360599991, 41.51715729400007],
              [-71.04946855399993, 41.52374909100007],
              [-71.04385331899994, 41.53685130400004],
              [-71.04930579299992, 41.551947333000044],
              [-71.06236731699994, 41.56435781500005],
              [-71.06212317599994, 41.543850002000056],
              [-71.07371985599991, 41.538723049000055],
              [-71.11074785099993, 41.543850002000056],
              [-71.10155188699991, 41.52830638200004],
              [-71.09715735599991, 41.52338288000004],
              [-71.12189693899995, 41.513006903000075],
              [-71.18590247299994, 41.468736070000034],
              [-71.19912675699993, 41.49213288000004],
              [-71.20201575399994, 41.50263092700004],
              [-71.19640051999994, 41.51341380400004],
              [-71.19566809799994, 41.520819403000075],
              [-71.20693925699993, 41.55817291900007],
              [-71.21051998599995, 41.60224030200004],
              [-71.20970618399991, 41.626166083000044],
              [-71.20693925699993, 41.64622630400004],
              [-71.19395911399994, 41.67686595300006],
              [-71.19025631399995, 41.685614325000074],
              [-71.13556881399995, 41.755519924000055],
              [-71.11074785099993, 41.79706452000005],
              [-71.12604732999995, 41.79242584800005],
              [-71.13809160099993, 41.77993398600006],
              [-71.16954505099994, 41.733303127000056],
              [-71.17625891799992, 41.726629950000074],
              [-71.18590247299994, 41.721991278000075],
              [-71.20799719999991, 41.72915273600006],
              [-71.22105872299994, 41.73139069200005],
              [-71.22687740799995, 41.72573476800005],
              [-71.22899329299992, 41.72093333500004],
              [-71.23684648299991, 41.70958079600007],
              [-71.23839270699995, 41.70734284100007],
              [-71.24054928299995, 41.69806549700007],
              [-71.24022376199991, 41.68463776200008],
              [-71.24103756399995, 41.68121979400007],
              [-71.24486243399991, 41.68032461100006],
              [-71.26040605399993, 41.65110911700003],
              [-71.28571529899995, 41.65961334800005],
              [-71.30182857999995, 41.65961334800005],
              [-71.30882727799991, 41.670803127000056],
              [-71.30675208199995, 41.68471914300005],
              [-71.30150305899991, 41.70262278900009],
              [-71.29405676999994, 41.72016022300005],
              [-71.28091386599993, 41.741400458000044],
              [-71.28302975199995, 41.74884674700007],
              [-71.28970292899993, 41.75409577000005],
              [-71.29881751199991, 41.75608958500004],
              [-71.30199133999992, 41.75169505400004],
              [-71.30443274599992, 41.73004791900007],
              [-71.30882727799991, 41.721991278000075],
              [-71.31818600199995, 41.72479889500005],
              [-71.33706620999993, 41.73379140800006],
              [-71.35562089799993, 41.74628327000005],
              [-71.36400305899991, 41.759833075000074],
              [-71.36558997299994, 41.77765534100007],
              [-71.37035071499992, 41.79205963700008],
              [-71.37881425699993, 41.80499909100007],
              [-71.39134680899991, 41.818793036000045],
              [-71.39500891799992, 41.80573151200008],
              [-71.39631100199995, 41.783270575000074],
              [-71.39509029899995, 41.75950755400004],
              [-71.39134680899991, 41.74249909100007],
              [-71.38475501199991, 41.735663153000075],
              [-71.37559973899994, 41.730536200000074],
              [-71.36750240799995, 41.723822333000044],
              [-71.36400305899991, 41.71206289300005],
              [-71.36685136599993, 41.703558661000045],
              [-71.38027910099993, 41.683661200000074],
              [-71.38442949099993, 41.67422109600005],
              [-71.39146887899994, 41.68301015800006],
              [-71.39842688699991, 41.68976471600007],
              [-71.40689042899993, 41.69383372600004],
              [-71.41860917899993, 41.694647528000075],
              [-71.43024654899995, 41.691107489000046],
              [-71.44163977799991, 41.68406810100004],
              [-71.44676673099991, 41.67723216400009],
              [-71.42332923099991, 41.66815827000005],
              [-71.41380774599992, 41.65289948100008],
              [-71.41026770699995, 41.63296133000006],
              [-71.41246497299994, 41.61273834800005],
              [-71.42369544199994, 41.59430573100008],
              [-71.43736731699994, 41.58478424700007],
              [-71.44277910099993, 41.574652411000045],
              [-71.42951412699995, 41.554388739000046],
              [-71.42463131399995, 41.53888580900008],
              [-71.42341061099995, 41.486395575000074],
              [-71.42609615799995, 41.468736070000034],
              [-71.4547918099999, 41.40613190000005],
              [-71.46961848799992, 41.39133128100008],
              [-71.48395748599995, 41.37995026200008],
              [-71.48827063699991, 41.37059153900009],
              [-71.49771074099993, 41.36627838700008],
              [-71.50780188699991, 41.36810944200005],
              [-71.53038489499994, 41.37645091400009],
              [-71.55582806899992, 41.37484552800004],
              [-71.59888448999993, 41.36752249300008],
              [-71.75381425699993, 41.33104075700004],
              [-71.82897249399991, 41.316984425000044],
              [-71.87147467499994, 41.30257508800008],
              [-71.87791399799994, 41.311512218000075],
              [-71.85653400399991, 41.322501385000066],
              [-71.86237545499995, 41.33258698100008],
              [-71.87214107999995, 41.33926015800006],
              [-71.88536536399994, 41.344631252000056],
              [-71.89806067599994, 41.34650299700007],
              [-71.96324622299994, 41.345363674000055],
              [-71.97288977799991, 41.34369538000004],
              [-72.03624426999994, 41.31785716400009],
              [-72.08340410099993, 41.35203685100004],
              [-72.09512285099993, 41.34609609600005],
              [-72.10114498599995, 41.32245514500005],
              [-72.11070716099994, 41.31110260600008],
              [-72.13540605399993, 41.31207916900007],
              [-72.1680395169999, 41.32245514500005],
              [-72.19432532499991, 41.32379791900007],
              [-72.20006262899994, 41.29743073100008],
              [-72.22691809799994, 41.31069570500006],
              [-72.28795325399994, 41.28294505400004],
              [-72.31989498599995, 41.29368724200003],
              [-72.32701575399994, 41.29873281500005],
              [-72.34105383999992, 41.30337148600006],
              [-72.34715735599991, 41.30731842700004],
              [-72.35041256399995, 41.31464264500005],
              [-72.34780839799993, 41.321600653000075],
              [-72.34398352799991, 41.329291083000044],
              [-72.34341386599993, 41.33836497600004],
              [-72.34837805899991, 41.34833405200004],
              [-72.35822506399995, 41.35797760600008],
              [-72.37271074099993, 41.36473216400009],
              [-72.39183508999992, 41.36627838700008],
              [-72.3801977199999, 41.35008372600004],
              [-72.36363684799994, 41.33690013200004],
              [-72.35435950399994, 41.32123444200005],
              [-72.3645727199999, 41.29743073100008],
              [-72.35488847599993, 41.291449286000045],
              [-72.3509008449999, 41.28998444200005],
              [-72.36978105399993, 41.276597398000035],
              [-72.39077714799993, 41.277777411000045],
              [-72.43346106699994, 41.28998444200005],
              [-72.45262610599991, 41.28790924700007],
              [-72.47508704299992, 41.28107330900008],
              [-72.49526933499993, 41.27033112200007],
              [-72.50792395699995, 41.25641510600008],
              [-72.51333574099993, 41.261053778000075],
              [-72.5169164699999, 41.262925523000035],
              [-72.51952063699991, 41.264960028000075],
              [-72.52220618399991, 41.27016836100006],
              [-72.52965247299994, 41.27016836100006],
              [-72.54063880099994, 41.263657945000034],
              [-72.58189856699994, 41.27875397300005],
              [-72.6048070949999, 41.28375885600008],
              [-72.66177324099993, 41.27407461100006],
              [-72.67105058499993, 41.26748281500005],
              [-72.67878170499995, 41.26048411700003],
              [-72.68667558499993, 41.25641510600008],
              [-72.69933020699995, 41.25657786700003],
              [-72.70909583199995, 41.26056549700007],
              [-72.71788489499994, 41.26585521000004],
              [-72.72765051999994, 41.27016836100006],
              [-72.74132239499994, 41.27216217700004],
              [-72.77944902299993, 41.27016836100006],
              [-72.78978430899991, 41.26732005400004],
              [-72.80601966099994, 41.25775788000004],
              [-72.81334387899994, 41.25958893400008],
              [-72.8265116689999, 41.25650801200004],
              [-72.84289200799992, 41.258471221000036],
              [-72.85606657099993, 41.24541882500006],
              [-72.89242669499993, 41.24497474300006],
              [-72.89572582099993, 41.25558244600006],
              [-72.89525305899991, 41.26585521000004],
              [-72.90314693899995, 41.27716705900008],
              [-72.90583248599995, 41.30052317900004],
              [-72.90998287699995, 41.305121161000045],
              [-72.91893469999991, 41.29865143400008],
              [-72.92735755099994, 41.28880442900004],
              [-72.93004309799994, 41.28375885600008],
              [-72.96727454299992, 41.25641510600008],
              [-72.99290930899991, 41.22898997600004],
              [-73.0020238919999, 41.22174713700008],
              [-73.01382776799994, 41.206723785000065],
              [-73.03843761299993, 41.20522702800008],
              [-73.05353756399995, 41.21173737200007],
              [-73.06371008999992, 41.204779364000046],
              [-73.08551998599995, 41.19700755400004],
              [-73.09447180899991, 41.19131094000005],
              [-73.10374915299991, 41.18036530200004],
              [-73.10741126199991, 41.174709377000056],
              [-73.1105918259999, 41.161942588000045],
              [-73.10848508099991, 41.14870869300006],
              [-73.13423714699991, 41.14720726200005],
              [-73.15508696699993, 41.15885870000005],
              [-73.16433814299995, 41.16510909600004],
              [-73.17010966299995, 41.169571071000064],
              [-73.18406770099995, 41.17410875000007],
              [-73.18427753799995, 41.16177303900008],
              [-73.20891485599992, 41.15672282400004],
              [-73.21580969999991, 41.16303131700005],
              [-73.21910559799994, 41.166001695000034],
              [-73.22109941299993, 41.16714101800005],
              [-73.22516842399995, 41.163275458000044],
              [-73.22423224999994, 41.14981203200006],
              [-73.22785553699993, 41.14279512100006],
              [-73.23380050599991, 41.136681440000075],
              [-73.24446240399993, 41.127966256000036],
              [-73.2621272419999, 41.120185131000085],
              [-73.27152124199995, 41.11762203700005],
              [-73.2783386509999, 41.13001749100005],
              [-73.28645231199994, 41.13449237300006],
              [-73.2936483229999, 41.12309477900004],
              [-73.30193349599995, 41.116990281000085],
              [-73.3159934649999, 41.115338998000084],
              [-73.33238108499995, 41.11371243700006],
              [-73.35002693199993, 41.10679763600007],
              [-73.36406801499993, 41.10602520000003],
              [-73.37193762899994, 41.10195547100005],
              [-73.37975012899994, 41.10016510600008],
              [-73.42373613199993, 41.07770416900007],
              [-73.43761145699995, 41.07306549700007],
              [-73.47459876199991, 41.054754950000074],
              [-73.48521887899994, 41.05385976800005],
              [-73.50419860499994, 41.04256767900006],
              [-73.52321102899992, 41.02149067800008],
              [-73.53712398599993, 41.03127835600009],
              [-73.54670162699995, 41.02887604400007],
              [-73.56484941299993, 41.01894765800006],
              [-73.58999352899991, 41.014791381000066],
              [-73.59687507099994, 41.02367037000005],
              [-73.60392333899995, 41.02281571100008],
              [-73.61114736499991, 41.01133620500008],
              [-73.61936733399995, 41.00873800900007],
              [-73.63458196399995, 41.00705507300006],
              [-73.64170011399995, 41.001773909000065],
              [-73.65025794199994, 40.99656810100004],
              [-73.64801998599995, 40.99209219000005],
              [-73.65314693899995, 40.982123114000046],
              [-73.67438717399995, 40.95880768400008],
              [-73.67699133999992, 40.954779364000046],
              [-73.69871985599991, 40.954779364000046],
              [-73.71076412699995, 40.95302969000005],
              [-73.72036699099993, 40.94700755400004],
              [-73.76439368399991, 40.91010163000004],
              [-73.7774145169999, 40.89411041900007],
              [-73.78282630099994, 40.87604401200008],
              [-73.78815670499995, 40.87177155200004],
              [-73.79991614499994, 40.872259833000044],
              [-73.81167558499993, 40.87103913000004],
              [-73.81696529899995, 40.86200592700004],
              [-73.81991030099994, 40.83912980200006],
              [-73.80505885699995, 40.826147183000046],
              [-73.79768506399995, 40.813193685000044],
              [-73.82972805299994, 40.810897622000084],
              [-73.86602793399993, 40.81183751700007],
              [-73.89383263199994, 40.80385336200004],
              [-73.92682857999995, 40.804795640000066],
              [-73.93228105399993, 40.81777578300006],
              [-73.93228105399993, 40.82558828300006],
              [-73.92577063699991, 40.836004950000074],
              [-73.9153539699999, 40.85683828300006],
              [-73.90884355399993, 40.86855703300006],
              [-73.91274980399993, 40.88157786700003],
              [-73.92186438699991, 40.886786200000074],
              [-73.89801998599995, 40.93048737200007],
              [-73.88947506399995, 40.97215403900009],
              [-73.87539628799993, 41.013332424000055],
              [-73.87218176999994, 41.033636786000045],
              [-73.87157141799992, 41.11554596600007],
              [-73.87531490799995, 41.15326569200005],
              [-73.88589433499993, 41.187567450000074],
              [-73.89574133999992, 41.203192450000074],
              [-73.90758216099994, 41.21336497600004],
              [-73.94050045499995, 41.235988674000055],
              [-73.95702063699991, 41.25775788000004],
              [-73.95348059799994, 41.274725653000075],
              [-73.94513912699995, 41.291001695000034],
              [-73.9473363919999, 41.31110260600008],
              [-73.96597245999993, 41.300116278000075],
              [-73.97594153599994, 41.292181708000044],
              [-73.98204505099994, 41.28375885600008],
              [-73.98497473899994, 41.269598700000074],
              [-73.98216712099992, 41.26113515800006],
              [-73.97760982999995, 41.25287506700005],
              [-73.97020423099991, 41.21906159100007],
              [-73.9630692799999, 41.20569873900007],
              [-73.95227985999992, 41.189293887000076],
              [-73.93232086699993, 41.17826901800004],
              [-73.91787675699993, 41.16351959800005],
              [-73.91665605399993, 41.145697333000044],
              [-73.92064368399991, 41.10195547100005],
              [-73.90636145699995, 41.01626211100006],
              [-73.90713456899994, 40.99079010600008],
              [-73.90770423099991, 40.971869208000044],
              [-73.91808020699995, 40.93146393400008],
              [-73.95474199099993, 40.858587958000044],
              [-73.99191573699994, 40.79845988900007],
              [-74.00625254599993, 40.78061391600005],
              [-74.01431080399993, 40.76584335000007],
              [-74.01863301299994, 40.75168269100004],
              [-74.0209268509999, 40.742051049000054],
              [-74.02802820799991, 40.727857259000075],
              [-74.03192941299994, 40.71418089700006],
              [-74.04808508999992, 40.70062897300005],
              [-74.07103430899991, 40.687201239000046],
              [-74.08934485599991, 40.669256903000075],
              [-74.09600579999994, 40.65475792700005],
              [-74.11065970299995, 40.650361898000085],
              [-74.13102220199994, 40.64517689500008],
              [-74.14208542299991, 40.646322963000046],
              [-74.13899124799991, 40.65784767300005],
              [-74.10556796999992, 40.705192639000074],
              [-74.11243542099993, 40.71789346700007],
              [-74.1260167559999, 40.70317039200006],
              [-74.13331787599992, 40.69123805300006],
              [-74.1421913829999, 40.67612091700005],
              [-74.15001813899994, 40.66418304800004],
              [-74.16075598899994, 40.66246165600006],
              [-74.17906653599994, 40.653509833000044],
              [-74.19032065899995, 40.649383912000076],
              [-74.20964677299992, 40.634230638000076],
              [-74.2152861969999, 40.59165780700005],
              [-74.22166907499991, 40.57208893400008],
              [-74.2330169299999, 40.566537389000075],
              [-74.24904380299995, 40.562974599000086],
              [-74.26048758299993, 40.55181959200007],
              [-74.2598776449999, 40.536731426000074],
              [-74.26393032199991, 40.513289788000066],
              [-74.26964952799995, 40.504920293000055],
              [-74.2826874459999, 40.497318766000035],
              [-74.26954995599993, 40.483058603000075],
              [-74.25633704299992, 40.46002838700008],
              [-74.22191321499992, 40.45189036700009],
              [-74.20592200399994, 40.44293854400007],
              [-74.19713294199994, 40.44086334800005],
              [-74.14590410099993, 40.447699286000045],
              [-74.11994381399995, 40.44525788000004],
              [-74.03233801999994, 40.42161692900004],
              [-73.99299068899995, 40.402411200000074],
              [-73.98800861099994, 40.407833631000074],
              [-73.99531092199993, 40.421852665000074],
              [-73.99819902299993, 40.441107489000046],
              [-74.01821855399993, 40.480536200000074],
              [-73.9895727199999, 40.46820709800005],
              [-73.97915605399993, 40.449286200000074],
              [-73.97570115199994, 40.42927034300004],
              [-73.97092998999995, 40.39474880800009],
              [-73.97239374399993, 40.32765030000007],
              [-73.97988801999992, 40.28015775100005],
              [-73.99205481699994, 40.22687409100007],
              [-74.01075198299992, 40.16755553000007],
              [-74.01822436599991, 40.140894452000055],
              [-74.0256056959999, 40.11103009800007],
              [-74.0305595719999, 40.07934093800009],
              [-74.03671942599993, 40.04858541600004],
              [-74.0404106229999, 40.028078116000074],
              [-74.04656158599994, 39.997336800000085],
              [-74.0588193769999, 39.954516313000056],
              [-74.06250172099993, 39.93309581800008],
              [-74.06742409199995, 39.903305242000044],
              [-74.07233959199993, 39.87537928800003],
              [-74.09301263299994, 39.77633706000006],
              [-74.10043843499994, 39.783232835000035],
              [-74.08073969799995, 39.92287877000007],
              [-74.07217492899991, 39.972990828000036],
              [-74.06604194899995, 39.99255493600003],
              [-74.05746527699995, 40.01212239100005],
              [-74.05132529999992, 40.03539395000007],
              [-74.05028235599991, 40.05499909100007],
              [-74.06069902299993, 40.062160549000055],
              [-74.08048026999995, 40.05126549300007],
              [-74.0780660719999, 40.04381086900008],
              [-74.06712182199993, 40.04193472500003],
              [-74.06350300299994, 40.03075185700004],
              [-74.0756813559999, 40.02517718100006],
              [-74.08301556999993, 40.011209643000086],
              [-74.10368551899995, 40.014023988000076],
              [-74.10948645699995, 40.002834377000056],
              [-74.12205969999991, 39.997300523000035],
              [-74.12608801999994, 39.98159414300005],
              [-74.10582434799994, 39.985541083000044],
              [-74.10228430899991, 39.97093333500004],
              [-74.11237545499995, 39.94969310100004],
              [-74.1328832669999, 39.93378327000005],
              [-74.1136087459999, 39.931076346000054],
              [-74.10999225899991, 39.921740818000046],
              [-74.1270426129999, 39.90589338700005],
              [-74.1367998369999, 39.89096734000009],
              [-74.1319911839999, 39.87229385000006],
              [-74.12588456899994, 39.85561758000006],
              [-74.12726803299995, 39.84845612200007],
              [-74.14590410099993, 39.83075592700004],
              [-74.16586523199993, 39.80656409000005],
              [-74.18651889499995, 39.772110756000075],
              [-74.19019686199994, 39.74416324300006],
              [-74.16331946499992, 39.73517487200007],
              [-74.16113980099993, 39.720868789000065],
              [-74.16601372799994, 39.704098069000054],
              [-74.16755123599995, 39.69936758000006],
              [-74.18177942599993, 39.69198852000005],
              [-74.19876234499992, 39.676139540000065],
              [-74.21090882199991, 39.650965306000046],
              [-74.24362247099992, 39.643485902000066],
              [-74.2521148909999, 39.63135476700006],
              [-74.24754798099991, 39.62140534100007],
              [-74.25641842399995, 39.61163971600007],
              [-74.27636730599994, 39.607072361000064],
              [-74.29090509799994, 39.605187201000035],
              [-74.30666622599995, 39.59489534900007],
              [-74.3284908999999, 39.57618483500005],
              [-74.32970979699991, 39.56217799600006],
              [-74.30353756399995, 39.54165273600006],
              [-74.29019120999993, 39.523138739000046],
              [-74.29735266799992, 39.50861237200007],
              [-74.31090247299994, 39.50665924700007],
              [-74.31627356699994, 39.514553127000056],
              [-74.31818600199995, 39.524644273000035],
              [-74.32127844999991, 39.529730536000045],
              [-74.35879472599993, 39.55019765800006],
              [-74.37364661399994, 39.54344310100004],
              [-74.3867895169999, 39.54441966400009],
              [-74.39801998599995, 39.550034898000035],
              [-74.40721594999991, 39.55703359600005],
              [-74.40648352799991, 39.52008698100008],
              [-74.40127519399994, 39.50242747600004],
              [-74.38927161399994, 39.49494049700007],
              [-74.38011633999992, 39.487494208000044],
              [-74.38369706899994, 39.47109609600005],
              [-74.39635169199994, 39.44717031500005],
              [-74.41124426999994, 39.45018138200004],
              [-74.42210852799991, 39.455145575000074],
              [-74.43297278599994, 39.45620351800005],
              [-74.44815019399994, 39.44717031500005],
              [-74.45490475199995, 39.43903229400007],
              [-74.46206620999993, 39.42641836100006],
              [-74.46751868399991, 39.412095445000034],
              [-74.46865800699993, 39.39935944200005],
              [-74.45030676999994, 39.40643952000005],
              [-74.43439693899995, 39.39500560100004],
              [-74.42178300699993, 39.37523021000004],
              [-74.41344153599994, 39.357123114000046],
              [-74.44440670499995, 39.34711334800005],
              [-74.50283769399994, 39.31818268400008],
              [-74.53014075399994, 39.310614325000074],
              [-74.53014075399994, 39.31622955900008],
              [-74.52110755099994, 39.33038971600007],
              [-74.50885982999995, 39.343451239000046],
              [-74.4817602199999, 39.36465078300006],
              [-74.50963294199994, 39.37885163000004],
              [-74.54234778599994, 39.347316799000055],
              [-74.55524654899995, 39.329291083000044],
              [-74.55064856699994, 39.31622955900008],
              [-74.55064856699994, 39.310614325000074],
              [-74.61449133999992, 39.31240469000005],
              [-74.64207923099991, 39.306708075000074],
              [-74.66047115799995, 39.289496161000045],
              [-74.64256751199991, 39.28900788000004],
              [-74.62950598899994, 39.284369208000044],
              [-74.61815344999991, 39.27875397300005],
              [-74.60521399599992, 39.27521393400008],
              [-74.55064856699994, 39.289496161000045],
              [-74.55064856699994, 39.28266022300005],
              [-74.57896887899994, 39.26776764500005],
              [-74.62083899599992, 39.22321198100008],
              [-74.64305579299992, 39.21381256700005],
              [-74.6543676419999, 39.20136139500005],
              [-74.70148678299995, 39.12441640800006],
              [-74.71182206899994, 39.13100820500006],
              [-74.72280839799993, 39.13182200700004],
              [-74.73326575399994, 39.12742747600004],
              [-74.74242102799991, 39.11815013200004],
              [-74.73753821499992, 39.11774323100008],
              [-74.73672441299993, 39.11676666900007],
              [-74.73696855399993, 39.11469147300005],
              [-74.73558508999992, 39.111395575000074],
              [-74.72524980399993, 39.11595286700009],
              [-74.71637936099995, 39.114935614000046],
              [-74.71019446499992, 39.10879140800006],
              [-74.7083227199999, 39.097723700000074],
              [-74.71373450399994, 39.091131903000075],
              [-74.73717200399994, 39.07025788000004],
              [-74.74571692599994, 39.05451080900008],
              [-74.75381425699993, 39.04877350500004],
              [-74.76406816299993, 39.044256903000075],
              [-74.78807532499991, 39.039048570000034],
              [-74.78937740799995, 39.03119538000004],
              [-74.78526770699995, 39.02204010600008],
              [-74.78335527299993, 39.01512278900009],
              [-74.80329342399995, 38.987616278000075],
              [-74.83608964799993, 38.96344635600008],
              [-74.87511145699995, 38.944525458000044],
              [-74.93309485599991, 38.92633698100008],
              [-74.94424394399994, 38.92438385600008],
              [-74.95470130099994, 38.92641836100006],
              [-74.96764075399994, 38.93577708500004],
              [-74.96933377999994, 38.94599687300007],
              [-74.96515031799993, 38.95701071000008],
              [-74.96179833299993, 38.96932270700006],
              [-74.95676819099992, 38.98811157400007],
              [-74.95256603899992, 39.00754816400007],
              [-74.94432532499991, 39.024725653000075],
              [-74.89443925699993, 39.10761139500005],
              [-74.88727779899995, 39.14679596600007],
              [-74.9063207669999, 39.17963288000004],
              [-74.92223059799994, 39.18854401200008],
              [-74.93858801999994, 39.19253164300005],
              [-74.97887122299994, 39.19330475500004],
              [-74.98643958199995, 39.19232819200005],
              [-75.00373287699995, 39.18805573100008],
              [-75.01305091099994, 39.18707916900007],
              [-75.02220618399991, 39.18927643400008],
              [-75.02342688699991, 39.19489166900007],
              [-75.02285722599993, 39.202460028000075],
              [-75.0266820949999, 39.21067942900004],
              [-75.04027258999992, 39.214544989000046],
              [-75.06114661399994, 39.21352773600006],
              [-75.09243730399993, 39.20758698100008],
              [-75.10659745999993, 39.20014069200005],
              [-75.11717688699991, 39.19281647300005],
              [-75.12889563699991, 39.18768952000005],
              [-75.14647376199991, 39.18707916900007],
              [-75.14500891799992, 39.191473700000074],
              [-75.15933183499993, 39.19863515800006],
              [-75.16698157499991, 39.20758698100008],
              [-75.16881262899994, 39.216009833000044],
              [-75.16563880099994, 39.22833893400008],
              [-75.16698157499991, 39.23427969000005],
              [-75.17577063699991, 39.24201080900008],
              [-75.21165930899991, 39.26434967700004],
              [-75.22594153599994, 39.26898834800005],
              [-75.23420162699995, 39.27338288000004],
              [-75.24209550699993, 39.292629299000055],
              [-75.24950110599991, 39.296942450000074],
              [-75.28742428299995, 39.296942450000074],
              [-75.30361894399994, 39.30329010600008],
              [-75.31322180899991, 39.31781647300005],
              [-75.32091223899994, 39.333685614000046],
              [-75.33141028599994, 39.34414297100005],
              [-75.34056555899991, 39.345038153000075],
              [-75.34821529899995, 39.34202708500004],
              [-75.35448157499991, 39.33856842700004],
              [-75.35936438699991, 39.337876695000034],
              [-75.36717688699991, 39.34259674700007],
              [-75.37193762899994, 39.347723700000074],
              [-75.37555904899995, 39.352728583000044],
              [-75.47765051999994, 39.44086334800005],
              [-75.50816809799994, 39.45734284100007],
              [-75.53160559799994, 39.47797272300005],
              [-75.54133053299995, 39.50885651200008],
              [-75.53734290299991, 39.503159898000035],
              [-75.53164628799993, 39.498480536000045],
              [-75.52383378799993, 39.49494049700007],
              [-75.5215551419999, 39.514105536000045],
              [-75.51040605399993, 39.55963776200008],
              [-75.51366126199991, 39.57379791900007],
              [-75.54747473899994, 39.60106028900009],
              [-75.55821692599994, 39.61347077000005],
              [-75.55744381399995, 39.62124258000006],
              [-75.53538977799991, 39.63890208500004],
              [-75.51650956899994, 39.647772528000075],
              [-75.51024329299992, 39.65265534100007],
              [-75.5071508449999, 39.66229889500005],
              [-75.50499426999994, 39.67601146000004],
              [-75.50112870999993, 39.68829987200007],
              [-75.48753821499992, 39.69684479400007],
              [-75.48314368399991, 39.70416901200008],
              [-75.47667395699995, 39.711371161000045],
              [-75.46519934799994, 39.71466705900008],
              [-75.46336829299992, 39.71938711100006],
              [-75.46182206899994, 39.74823639500005],
              [-75.44017493399991, 39.777004299000055],
              [-75.40611731699994, 39.80292389500005],
              [-75.36729895699995, 39.82379791900007],
              [-75.31090247299994, 39.84320709800005],
              [-75.26829993399991, 39.850775458000044],
              [-75.24608313699991, 39.85187409100007],
              [-75.22907467399995, 39.85455963700008],
              [-75.19294186099995, 39.86749909100007],
              [-75.16885331899994, 39.872707424000055],
              [-75.16759192599994, 39.873480536000045],
              [-75.16624915299991, 39.87335846600007],
              [-75.16075598899994, 39.878566799000055],
              [-75.14415442599994, 39.87490469000005],
              [-75.12938391799992, 39.88385651200008],
              [-75.11481686099995, 39.89716217700004],
              [-75.09870357999995, 39.90643952000005],
              [-75.11367753799993, 39.92206452000005],
              [-75.12022864499994, 39.940741278000075],
              [-75.11595618399991, 39.95258209800005],
              [-75.09870357999995, 39.94745514500005],
              [-75.08503170499995, 39.96108633000006],
              [-75.07876542899993, 39.95359935100004],
              [-75.03941809799994, 40.00263092700004],
              [-75.02358964799993, 40.01630280200004],
              [-75.04653886599993, 40.009100653000075],
              [-75.07998613199993, 39.986395575000074],
              [-75.10240637899994, 39.98159414300005],
              [-75.11969967399995, 39.97418854400007],
              [-75.13292395699995, 39.95612213700008],
              [-75.1387426419999, 39.933579820000034],
              [-75.13341223899994, 39.91266510600008],
              [-75.1477758449999, 39.90257396000004],
              [-75.20791581899994, 39.88540273600006],
              [-75.24868730399993, 39.867254950000074],
              [-75.27310136599993, 39.86408112200007],
              [-75.29735266799992, 39.87173086100006],
              [-75.35887610599991, 39.84833405200004],
              [-75.37645423099991, 39.845038153000075],
              [-75.39171301999994, 39.83958567900004],
              [-75.42764238199993, 39.80341217700004],
              [-75.4629613919999, 39.78461334800005],
              [-75.47671464799993, 39.77212148600006],
              [-75.48766028599994, 39.731675523000035],
              [-75.50072180899991, 39.71426015800006],
              [-75.54576575399994, 39.67023346600007],
              [-75.55113684799994, 39.66624583500004],
              [-75.58682206899994, 39.655951239000046],
              [-75.59215247299994, 39.64923737200007],
              [-75.59520423099991, 39.63849518400008],
              [-75.60114498599995, 39.62726471600007],
              [-75.60521399599992, 39.61668528900009],
              [-75.60269120999993, 39.60789622600004],
              [-75.57404537699995, 39.585598049000055],
              [-75.56550045499995, 39.57684967700004],
              [-75.55581620999993, 39.55927155200004],
              [-75.55459550699993, 39.54116445500006],
              [-75.56118730399993, 39.52301666900007],
              [-75.57506262899994, 39.505194403000075],
              [-75.58356686099995, 39.48334381700005],
              [-75.58793816799994, 39.46277063900004],
              [-75.56886311599993, 39.44035487600007],
              [-75.55276057899994, 39.42579396200006],
              [-75.52789117599991, 39.403390924000064],
              [-75.49079342399995, 39.35346100500004],
              [-75.48851477799991, 39.347316799000055],
              [-75.48241126199991, 39.34467194200005],
              [-75.45916525699994, 39.328292960000056],
              [-75.43441061999994, 39.31487386300006],
              [-75.4284901879999, 39.29129278100004],
              [-75.40770423099991, 39.27024974200009],
              [-75.39801998599995, 39.249335028000075],
              [-75.39415442599994, 39.224595445000034],
              [-75.4047571289999, 39.17223087000008],
              [-75.40611640599991, 39.15199886600004],
              [-75.4045726679999, 39.13064715100006],
              [-75.40161623599994, 39.11716634700008],
              [-75.39744518099991, 39.102636364000034],
              [-75.40140434099993, 39.07828759700004],
              [-75.39378989099993, 39.05555102500006],
              [-75.36920511499994, 39.04025732800005],
              [-75.34258212199995, 39.02021125200008],
              [-75.31484941299993, 38.984076239000046],
              [-75.31112844799992, 38.96795413600006],
              [-75.31107029299994, 38.94946820800004],
              [-75.31032587399994, 38.92781826400005],
              [-75.29662024599992, 38.91307200700004],
              [-75.24435278599992, 38.85979865200005],
              [-75.19548272799994, 38.81549086500007],
              [-75.16632665399993, 38.794382357000075],
              [-75.13041423499993, 38.782771825000054],
              [-75.09992621999993, 38.788048410000044],
              [-75.0958609839999, 38.79755517800004],
              [-75.09925204899992, 38.80548087800008],
              [-75.09247476299993, 38.80759157700004],
              [-75.08434048499993, 38.795966511000074],
              [-75.06612255199991, 38.678024950000065],
              [-75.06480713799994, 38.63260897200007],
              [-75.07184811099995, 38.638332424000055],
              [-75.0776218339999, 38.68647519800004],
              [-75.08641065699993, 38.69334481900006],
              [-75.1209210369999, 38.683834673000035],
              [-75.13918852099994, 38.68805248000007],
              [-75.11978105399993, 38.65888092700004],
              [-75.13394120999993, 38.66038646000004],
              [-75.13939368399991, 38.66205475500004],
              [-75.14586341099994, 38.66152578300006],
              [-75.14720618399991, 38.66006094000005],
              [-75.14997311099995, 38.659816799000055],
              [-75.15330969999991, 38.65888092700004],
              [-75.14256751199991, 38.65053945500006],
              [-75.13044186099995, 38.64305247600004],
              [-75.11611894399994, 38.63841380400004],
              [-75.09870357999995, 38.63841380400004],
              [-75.12140865799995, 38.62132396000004],
              [-75.19005286399994, 38.606675523000035],
              [-75.20791581899994, 38.59003327000005],
              [-75.18740800699993, 38.59003327000005],
              [-75.19151770699995, 38.58270905200004],
              [-75.19644120999993, 38.57684967700004],
              [-75.20197506399995, 38.57245514500005],
              [-75.20791581899994, 38.569525458000044],
              [-75.19176184799994, 38.56696198100008],
              [-75.15221106699994, 38.58844635600008],
              [-75.12604732999995, 38.59003327000005],
              [-75.11961829299992, 38.58429596600007],
              [-75.11168372299994, 38.57416413000004],
              [-75.10326087099992, 38.56590403900009],
              [-75.09557044199994, 38.566392320000034],
              [-75.07518469999991, 38.58649323100008],
              [-75.06956727499994, 38.593535570000085],
              [-75.06920325399994, 38.608303127000056],
              [-75.06533769399994, 38.614935614000046],
              [-75.06009108599994, 38.61254062000006],
              [-75.05874569699995, 38.60514757300007],
              [-75.0567343049999, 38.586665777000064],
              [-75.05772864499994, 38.552720445000034],
              [-75.05284583199995, 38.527329820000034],
              [-75.05002119099993, 38.498985334000054],
              [-75.04732838599995, 38.475732608000044],
              [-75.0439753899999, 38.45380280200004],
              [-75.04405676999994, 38.45343659100007],
              [-75.04474850199995, 38.425034898000035],
              [-75.05113684799994, 38.38776276200008],
              [-75.0670088789999, 38.35351985600005],
              [-75.07876542899993, 38.33673737200007],
              [-75.07579505099994, 38.36627838700008],
              [-75.05923417899993, 38.42279694200005],
              [-75.05772864499994, 38.45343659100007],
              [-75.05809485599991, 38.45372142100007],
              [-75.06273352799991, 38.45734284100007],
              [-75.06859290299991, 38.45990631700005],
              [-75.07579505099994, 38.461004950000074],
              [-75.08503170499995, 38.46088288000004],
              [-75.08389238199993, 38.45359935100004],
              [-75.08291581899994, 38.44745514500005],
              [-75.08988220099991, 38.43220136700006],
              [-75.10201621199991, 38.438538203000064],
              [-75.11819626099992, 38.43748120400005],
              [-75.09797871299992, 38.40791302800005],
              [-75.10404529899995, 38.395242014000075],
              [-75.11213051999994, 38.39946603100009],
              [-75.12762840599993, 38.40580042800008],
              [-75.1478457799999, 38.41371489000005],
              [-75.16536758599995, 38.41687531600007],
              [-75.1795099819999, 38.40842047800004],
              [-75.13975413499992, 38.39946265800006],
              [-75.13234149699991, 38.39418458200004],
              [-75.13341223899994, 38.38515859600005],
              [-75.13341223899994, 38.37767161700009],
              [-75.12604732999995, 38.37767161700009],
              [-75.12604732999995, 38.371527411000045],
              [-75.13060462099992, 38.36928945500006],
              [-75.13536536399994, 38.36603424700007],
              [-75.13963782499991, 38.36408112200007],
              [-75.12547766799992, 38.36033763200004],
              [-75.11213131399995, 38.362494208000044],
              [-75.10073808499993, 38.36212799700007],
              [-75.09243730399993, 38.35101959800005],
              [-75.09422766799992, 38.33535390800006],
              [-75.10440019399994, 38.31622955900008],
              [-75.11799068899995, 38.298163153000075],
              [-75.12975012899994, 38.28554922100005],
              [-75.15428626199991, 38.24091217700004],
              [-75.16388912699995, 38.233710028000075],
              [-75.19749915299991, 38.23257070500006],
              [-75.20067298099991, 38.240301825000074],
              [-75.18740800699993, 38.26166413000004],
              [-75.2200414699999, 38.24762604400007],
              [-75.23306230399993, 38.23895905200004],
              [-75.24266516799992, 38.22695547100005],
              [-75.2571508449999, 38.16815827000005],
              [-75.2669164699999, 38.15924713700008],
              [-75.27171790299991, 38.152329820000034],
              [-75.2832738919999, 38.12055084800005],
              [-75.29043535099993, 38.11082591400009],
              [-75.29735266799992, 38.11078522300005],
              [-75.31590735599991, 38.116888739000046],
              [-75.32526607999995, 38.11701080900008],
              [-75.33389238199993, 38.11155833500004],
              [-75.35016842399995, 38.09406159100007],
              [-75.35602779899995, 38.09031810100004],
              [-75.35118567599994, 38.082098700000074],
              [-75.37303626199991, 38.03196849200009],
              [-75.37515214799993, 38.02383047100005],
              [-75.37828528599994, 38.01166413000004],
              [-75.39098059799994, 38.00267161700009],
              [-75.40684973899994, 37.997381903000075],
              [-75.42145748599995, 37.987941799000055],
              [-75.42617753799993, 37.97650788000004],
              [-75.43434422299993, 37.96183299300009],
              [-75.43188166399995, 37.95183034300004],
              [-75.41915157299991, 37.94327864300004],
              [-75.42516315699993, 37.93611439500006],
              [-75.43542411099992, 37.93370459700009],
              [-75.43478266199992, 37.92560275500006],
              [-75.41965455999991, 37.91992312800005],
              [-75.42385584699991, 37.913716503000046],
              [-75.43892125899993, 37.906050951000054],
              [-75.44792046299995, 37.89363537200006],
              [-75.4430714209999, 37.889360228000044],
              [-75.42557700599991, 37.89274269900005],
              [-75.41710077899995, 37.886091984000075],
              [-75.42489525199994, 37.875113328000054],
              [-75.44659182799995, 37.86743214000006],
              [-75.4706581929999, 37.85116251900007],
              [-75.49228479599992, 37.831084],
              [-75.51208130999993, 37.80862075400006],
              [-75.53126944999991, 37.78788412600005],
              [-75.56050504699994, 37.74390211200006],
              [-75.59814441799995, 37.70001121700005],
              [-75.62707875599995, 37.67383181100007],
              [-75.65282290599993, 37.64255234800004],
              [-75.7059576879999, 37.58018307800006],
              [-75.71668602699992, 37.55955119300006],
              [-75.73346920499995, 37.53607819200005],
              [-75.74487609599993, 37.52420403600007],
              [-75.75979974699993, 37.50795376600007],
              [-75.77147376199991, 37.490301825000074],
              [-75.78392493399991, 37.483587958000044],
              [-75.78831946499992, 37.475897528000075],
              [-75.81049616399991, 37.462182433000066],
              [-75.81870712299991, 37.45423785300005],
              [-75.81031085199993, 37.44309882500005],
              [-75.8148046149999, 37.436493676000055],
              [-75.82383182699994, 37.427559640000084],
              [-75.82167723099991, 37.419019681000066],
              [-75.80630922899991, 37.414503307000075],
              [-75.79587438499993, 37.40568291400007],
              [-75.79996167099995, 37.40006841500008],
              [-75.8115377499999, 37.398357022000084],
              [-75.8201692589999, 37.39172923400008],
              [-75.8284399339999, 37.390693559000056],
              [-75.83635787199995, 37.39590813600006],
              [-75.85500507299992, 37.39743783700004],
              [-75.8758462589999, 37.36935084800007],
              [-75.8873085109999, 37.35696729400007],
              [-75.90047744499992, 37.325513665000074],
              [-75.91152966399994, 37.290766132000044],
              [-75.92349188799994, 37.244441581000046],
              [-75.92729673899993, 37.21136833200006],
              [-75.93415782599993, 37.17330383700005],
              [-75.93504015699995, 37.15841693500005],
              [-75.93592555799995, 37.13501634700009],
              [-75.94911108199994, 37.12495191000005],
              [-75.9664286009999, 37.13479530400008],
              [-75.97612161299992, 37.16151840300006],
              [-76.0007780869999, 37.194365245000085],
              [-76.00096594999991, 37.22016022300005],
              [-75.99620520699995, 37.23383209800005],
              [-75.99620520699995, 37.23997630400004],
              [-76.01695716099994, 37.257798570000034],
              [-76.0149633449999, 37.28156159100007],
              [-76.00011145699995, 37.30353424700007],
              [-75.98253333199995, 37.31635163000004],
              [-75.99592037699995, 37.32025788000004],
              [-76.00145423099991, 37.31948476800005],
              [-76.01056881399995, 37.31635163000004],
              [-75.99079342399995, 37.35301341400009],
              [-75.98477128799993, 37.37189362200007],
              [-75.98997962099992, 37.38458893400008],
              [-75.97378495999993, 37.39154694200005],
              [-75.96214758999992, 37.40326569200005],
              [-75.95588131399995, 37.41592031500005],
              [-75.95531165299991, 37.42560455900008],
              [-75.95645097599993, 37.42495351800005],
              [-75.9622289699999, 37.42572663000004],
              [-75.96617591099994, 37.42450592700004],
              [-75.96825110599991, 37.41815827000005],
              [-75.97569739499994, 37.41815827000005],
              [-75.97288977799991, 37.43512604400007],
              [-75.96564693899995, 37.45294830900008],
              [-75.95400956899994, 37.46698639500005],
              [-75.92617753799993, 37.47842031500005],
              [-75.92463131399995, 37.48899974200009],
              [-75.93415279899995, 37.49506256700005],
              [-75.95531165299991, 37.48700592700004],
              [-75.95177161399994, 37.51593659100007],
              [-75.93781490799995, 37.53729889500005],
              [-75.91710364499994, 37.55247630400004],
              [-75.89378821499992, 37.56273021000004],
              [-75.93472245999993, 37.57640208500004],
              [-75.92125403599994, 37.58576080900008],
              [-75.91104081899994, 37.59487539300005],
              [-75.9094945949999, 37.603216864000046],
              [-75.92174231699994, 37.610541083000044],
              [-75.90461178299995, 37.61985911700009],
              [-75.88267981699994, 37.62376536700009],
              [-75.87144934799994, 37.62954336100006],
              [-75.88634192599994, 37.64468008000006],
              [-75.87572180899991, 37.66071198100008],
              [-75.86082923099991, 37.66901276200008],
              [-75.84170488199993, 37.67210521000004],
              [-75.81867428299995, 37.67259349200009],
              [-75.82494055899991, 37.68781159100007],
              [-75.82384192599994, 37.696519273000035],
              [-75.78868567599994, 37.72748444200005],
              [-75.79051673099991, 37.733303127000056],
              [-75.81187903599994, 37.73346588700008],
              [-75.81187903599994, 37.74091217700004],
              [-75.79084225199995, 37.75385163000004],
              [-75.77745520699995, 37.76642487200007],
              [-75.77790279899995, 37.78009674700007],
              [-75.79820716099994, 37.796128648000035],
              [-75.78685462099992, 37.80939362200007],
              [-75.77554277299993, 37.807928778000075],
              [-75.76447506399995, 37.80052317900004],
              [-75.75348873599995, 37.796128648000035],
              [-75.69456946499992, 37.80231354400007],
              [-75.70372473899994, 37.81073639500005],
              [-75.70848548099991, 37.82168203300006],
              [-75.70811926999994, 37.83315664300005],
              [-75.70201575399994, 37.84332916900007],
              [-75.69481360599991, 37.84471263200004],
              [-75.67137610599991, 37.841498114000046],
              [-75.66104081899994, 37.84332916900007],
              [-75.66950436099995, 37.85203685100004],
              [-75.67430579299992, 37.861395575000074],
              [-75.67422441299993, 37.870347398000035],
              [-75.66783606699994, 37.87807851800005],
              [-75.67096920499995, 37.892564195000034],
              [-75.68927975199995, 37.903998114000046],
              [-75.71751868399991, 37.909409898000035],
              [-75.74299068899995, 37.90599192900004],
              [-75.74299068899995, 37.912176825000074],
              [-75.71914628799993, 37.92763906500005],
              [-75.69456946499992, 37.939520575000074],
              [-75.66177324099993, 37.94476959800005],
              [-75.64586341099994, 37.94953034100007],
              [-75.63312740799995, 37.96002838700008],
              [-75.65367591099994, 37.967962958000044],
              [-75.67259680899991, 37.971991278000075],
              [-75.76317298099991, 37.978216864000046],
              [-75.78628495999993, 37.975897528000075],
              [-75.80817623599995, 37.96344635600008],
              [-75.83812415299991, 37.94122955900008],
              [-75.85802161399994, 37.93113841400009],
              [-75.86709550699993, 37.93610260600008],
              [-75.86896725199995, 37.94330475500004],
              [-75.87246660099993, 37.946966864000046],
              [-75.87498938699991, 37.95111725500004],
              [-75.87336178299995, 37.96002838700008],
              [-75.86750240799995, 37.967230536000045],
              [-75.85879472599993, 37.97321198100008],
              [-75.85041256399995, 37.98110586100006],
              [-75.84536699099993, 37.99408600500004],
              [-75.85484778599994, 37.993353583000044],
              [-75.86270097599993, 37.99079010600008],
              [-75.86888587099992, 37.98651764500005],
              [-75.87336178299995, 37.980454820000034],
              [-75.88011633999992, 37.980454820000034],
              [-75.87954667899993, 37.98533763200004],
              [-75.88101152299993, 37.98663971600007],
              [-75.88365637899994, 37.986761786000045],
              [-75.88634192599994, 37.987941799000055],
              [-75.87865149599992, 37.994574286000045],
              [-75.85724850199995, 38.021144924000055],
              [-75.8528539699999, 38.03196849200009],
              [-75.84642493399991, 38.03961823100008],
              [-75.81826738199993, 38.04271067900004],
              [-75.81187903599994, 38.04596588700008],
              [-75.8020727199999, 38.05805084800005],
              [-75.75658118399991, 38.09259674700007],
              [-75.74299068899995, 38.11082591400009],
              [-75.75767981699994, 38.113267320000034],
              [-75.76862545499995, 38.10561758000006],
              [-75.77953040299991, 38.095404364000046],
              [-75.79450436099995, 38.09031810100004],
              [-75.81908118399991, 38.091009833000044],
              [-75.8333227199999, 38.089178778000075],
              [-75.84536699099993, 38.08348216400009],
              [-75.84756425699993, 38.086371161000045],
              [-75.84776770699995, 38.08746979400007],
              [-75.84862219999991, 38.088324286000045],
              [-75.8528539699999, 38.09031810100004],
              [-75.8528539699999, 38.09780508000006],
              [-75.84260006399995, 38.10130442900004],
              [-75.83238684799994, 38.10757070500006],
              [-75.82388261599993, 38.11554596600007],
              [-75.81867428299995, 38.12445709800005],
              [-75.82485917899993, 38.131293036000045],
              [-75.81444251199991, 38.135199286000045],
              [-75.78441321499992, 38.13947174700007],
              [-75.77647864499994, 38.144964911000045],
              [-75.77969316299993, 38.15521881700005],
              [-75.79401607999995, 38.15888092700004],
              [-75.81163489499994, 38.15729401200008],
              [-75.82485917899993, 38.15924713700008],
              [-75.84813391799992, 38.15216705900008],
              [-75.89346269399994, 38.15607330900008],
              [-75.91429602799991, 38.15180084800005],
              [-75.91954505099994, 38.14484284100007],
              [-75.92064368399991, 38.13572825700004],
              [-75.92275956899994, 38.12787506700005],
              [-75.93130449099993, 38.12445709800005],
              [-75.93740800699993, 38.12763092700004],
              [-75.94050045499995, 38.13540273600006],
              [-75.94155839799993, 38.155462958000044],
              [-75.92845618399991, 38.19354889500005],
              [-75.89631100199995, 38.21067942900004],
              [-75.85602779899995, 38.21971263200004],
              [-75.81867428299995, 38.233710028000075],
              [-75.83458411399994, 38.24017975500004],
              [-75.87873287699995, 38.24286530200004],
              [-75.89720618399991, 38.25112539300005],
              [-75.90664628799993, 38.27098216400009],
              [-75.9024145169999, 38.29376862200007],
              [-75.89122473899994, 38.31513092700004],
              [-75.85806230399993, 38.358587958000044],
              [-75.84911048099991, 38.37396881700005],
              [-75.84337317599994, 38.39545319200005],
              [-75.84072831899994, 38.400824286000045],
              [-75.84325110599991, 38.404364325000074],
              [-75.85627193899995, 38.40566640800006],
              [-75.86314856699994, 38.40176015800006],
              [-75.86644446499992, 38.39240143400008],
              [-75.86900794199994, 38.38108958500004],
              [-75.87336178299995, 38.371527411000045],
              [-75.92471269399994, 38.32489655200004],
              [-75.93130449099993, 38.31688060100004],
              [-75.95567786399994, 38.257798570000034],
              [-75.96271725199995, 38.24799225500004],
              [-75.96825110599991, 38.25405508000006],
              [-75.9680883449999, 38.262600002000056],
              [-75.96662350199995, 38.27228424700007],
              [-75.96825110599991, 38.282131252000056],
              [-75.97411048099991, 38.28815338700008],
              [-75.98363196499992, 38.29547760600008],
              [-75.99233964799993, 38.303900458000044],
              [-75.99620520699995, 38.31317780200004],
              [-75.99010169199994, 38.32599518400008],
              [-75.96239173099991, 38.33584219000005],
              [-75.95531165299991, 38.35101959800005],
              [-75.96483313699991, 38.373480536000045],
              [-75.99046790299991, 38.36204661700009],
              [-76.01891028599994, 38.33478424700007],
              [-76.0371801419999, 38.309475002000056],
              [-76.02672278599994, 38.30418528900009],
              [-76.01927649599992, 38.29441966400009],
              [-76.01732337099992, 38.28180573100008],
              [-76.01732337099992, 38.26780833500004],
              [-76.02867591099994, 38.24176666900007],
              [-76.03791256399995, 38.232489325000074],
              [-76.04881751199991, 38.23932526200008],
              [-76.08120683499993, 38.284084377000056],
              [-76.09117591099994, 38.29242584800005],
              [-76.11750240799995, 38.29828522300005],
              [-76.12437903599994, 38.30483633000006],
              [-76.13341223899994, 38.32306549700007],
              [-76.19294186099995, 38.38275788000004],
              [-76.20970618399991, 38.39203522300005],
              [-76.22085527299993, 38.38361237200007],
              [-76.20653235599991, 38.33856842700004],
              [-76.20970618399991, 38.31688060100004],
              [-76.21593176999994, 38.31688060100004],
              [-76.22109941299993, 38.34389883000006],
              [-76.23985755099994, 38.36823151200008],
              [-76.26988684799994, 38.40566640800006],
              [-76.27513587099992, 38.41156647300005],
              [-76.28233801999994, 38.42182038000004],
              [-76.28888912699995, 38.43353913000004],
              [-76.29548092399995, 38.455511786000045],
              [-76.3040258449999, 38.46328359600005],
              [-76.31330318899995, 38.46869538000004],
              [-76.31895911399994, 38.473944403000075],
              [-76.31981360599991, 38.495021877000056],
              [-76.30467688699991, 38.50263092700004],
              [-76.28636633999992, 38.50014883000006],
              [-76.2774145169999, 38.49095286700009],
              [-76.27310136599993, 38.46747467700004],
              [-76.2637426419999, 38.46552155200004],
              [-76.25430253799993, 38.479803778000075],
              [-76.2500707669999, 38.50495026200008],
              [-76.24233964799993, 38.521185614000046],
              [-76.2239477199999, 38.52960846600007],
              [-76.20148678299995, 38.53510163000004],
              [-76.18179277299993, 38.54279205900008],
              [-76.18724524599992, 38.55329010600008],
              [-76.17198645699995, 38.56622955900008],
              [-76.17495683499993, 38.57697174700007],
              [-76.17926998599995, 38.580511786000045],
              [-76.18447831899994, 38.58258698100008],
              [-76.19098873599995, 38.58356354400007],
              [-76.19884192599994, 38.58380768400008],
              [-76.21051998599995, 38.58270905200004],
              [-76.21336829299992, 38.57949453300006],
              [-76.2141820949999, 38.57404205900008],
              [-76.21934973899994, 38.566392320000034],
              [-76.23021399599992, 38.55951569200005],
              [-76.24266516799992, 38.556708075000074],
              [-76.27367102799991, 38.55646393400008],
              [-76.28604081899994, 38.56281159100007],
              [-76.27847245999993, 38.57684967700004],
              [-76.25625566299993, 38.59739817900004],
              [-76.25625566299993, 38.60423411700009],
              [-76.26260331899994, 38.60781484600005],
              [-76.26732337099992, 38.61180247600004],
              [-76.2774145169999, 38.62474192900004],
              [-76.2324926419999, 38.618068752000056],
              [-76.21593176999994, 38.61790599200009],
              [-76.20128333199995, 38.62067291900007],
              [-76.17540442599994, 38.62921784100007],
              [-76.16128495999993, 38.63100820500006],
              [-76.17613684799994, 38.62067291900007],
              [-76.18179277299993, 38.61790599200009],
              [-76.17186438699991, 38.610256252000056],
              [-76.16128495999993, 38.60423411700009],
              [-76.1426488919999, 38.607489325000074],
              [-76.11497482099992, 38.58797544300006],
              [-76.09235383499993, 38.59363380900004],
              [-76.05358612099991, 38.568038512000044],
              [-76.01166511699995, 38.56565509400008],
              [-75.99429277299993, 38.583685614000046],
              [-75.98253333199995, 38.59003327000005],
              [-75.97020423099991, 38.60659414300005],
              [-75.96532141799992, 38.63739655200004],
              [-75.95531165299991, 38.65265534100007],
              [-75.95938066299993, 38.65570709800005],
              [-75.96271725199995, 38.65888092700004],
              [-75.96825110599991, 38.65888092700004],
              [-75.98997962099992, 38.62396881700005],
              [-75.99992697899995, 38.602595207000036],
              [-76.02424381599991, 38.59284635400007],
              [-76.05934748699991, 38.606201199000054],
              [-76.0769439199999, 38.61560427400008],
              [-76.10502883399994, 38.62491012600009],
              [-76.09239661399994, 38.65888092700004],
              [-76.1074926419999, 38.653998114000046],
              [-76.12051347599993, 38.64793528900009],
              [-76.13499915299991, 38.64594147300005],
              [-76.15444902299993, 38.65265534100007],
              [-76.15444902299993, 38.65888092700004],
              [-76.14537512899994, 38.66502513200004],
              [-76.11961829299992, 38.67560455900008],
              [-76.10606848899994, 38.679388739000046],
              [-76.10606848899994, 38.68622467700004],
              [-76.12686113199993, 38.684881903000075],
              [-76.1485082669999, 38.680894273000035],
              [-76.16612708199995, 38.68146393400008],
              [-76.17495683499993, 38.69367096600007],
              [-76.16832434799994, 38.69989655200004],
              [-76.16454016799992, 38.70815664300005],
              [-76.16429602799991, 38.71771881700005],
              [-76.16812089799993, 38.727728583000044],
              [-76.17699133999992, 38.716131903000075],
              [-76.18146725199995, 38.702378648000035],
              [-76.18691972599993, 38.691066799000055],
              [-76.19864906599992, 38.67505635800006],
              [-76.20906899599993, 38.686724480000066],
              [-76.2265126449999, 38.70097081100005],
              [-76.2364674019999, 38.71515457000004],
              [-76.22781567699991, 38.735726853000074],
              [-76.2018378169999, 38.73230585400006],
              [-76.22187818899994, 38.75093167000006],
              [-76.23385045299995, 38.75744934900007],
              [-76.2543998349999, 38.74923735500005],
              [-76.2736571559999, 38.71452670300005],
              [-76.29194240099991, 38.72131458900009],
              [-76.29731186999993, 38.75093921600006],
              [-76.28844206199994, 38.766697874000045],
              [-76.28803819799992, 38.77552608800005],
              [-76.29438335099991, 38.77385420300004],
              [-76.30983262399991, 38.76123794100005],
              [-76.31058537699994, 38.73533067300008],
              [-76.3265156299999, 38.71824345400006],
              [-76.32674694199994, 38.698754971000085],
              [-76.32200807899994, 38.68943140600004],
              [-76.32582151799994, 38.67753413200006],
              [-76.34129295299994, 38.673172934000036],
              [-76.34626217399995, 38.68992747600004],
              [-76.34361731699994, 38.714178778000075],
              [-76.34032141799992, 38.72842031500005],
              [-76.33120683499993, 38.74591705900008],
              [-76.31163489499994, 38.80426666900007],
              [-76.30654863199993, 38.81435781500005],
              [-76.30467688699991, 38.82273997600004],
              [-76.27725175699993, 38.84088776200008],
              [-76.26034613699994, 38.85804600200004],
              [-76.2531688869999, 38.855002778000085],
              [-76.2595594899999, 38.83921520300004],
              [-76.23932007899992, 38.82207467500007],
              [-76.22100704099995, 38.815277173000084],
              [-76.2124257239999, 38.80763666100006],
              [-76.21210285899991, 38.788244976000044],
              [-76.19843706499995, 38.776205481000034],
              [-76.18359563399991, 38.764383585000076],
              [-76.17311053799995, 38.75661244400004],
              [-76.14391028599994, 38.76813385600008],
              [-76.13145911399994, 38.77289459800005],
              [-76.11754309799994, 38.78506094000005],
              [-76.10903886599993, 38.80072663000004],
              [-76.11290442599994, 38.81655508000006],
              [-76.12633216099994, 38.80072663000004],
              [-76.14683997299994, 38.790350653000075],
              [-76.17696703599995, 38.785550698000065],
              [-76.19437640599995, 38.813917755000034],
              [-76.18816738499993, 38.846690832000036],
              [-76.1569978039999, 38.86012378400005],
              [-76.12706458199995, 38.86603424700007],
              [-76.10606848899994, 38.87799713700008],
              [-76.14785722599993, 38.89154694200005],
              [-76.15444902299993, 38.89533112200007],
              [-76.14732825399994, 38.91592031500005],
              [-76.14834550699993, 38.92495351800005],
              [-76.16128495999993, 38.92641836100006],
              [-76.16441809799994, 38.92059967700004],
              [-76.17178300699993, 38.896918036000045],
              [-76.17837480399993, 38.89166901200008],
              [-76.19788293499994, 38.878455907000045],
              [-76.19505774599992, 38.912176825000074],
              [-76.19277910099993, 38.92829010600008],
              [-76.19690550099995, 38.935648094000044],
              [-76.20795336399993, 38.94404569800008],
              [-76.22992004999992, 38.952344295000046],
              [-76.24327551999994, 38.95062897300005],
              [-76.24718176999994, 38.951157945000034],
              [-76.25544186099995, 38.94383372600004],
              [-76.26276607999995, 38.93537018400008],
              [-76.2637426419999, 38.93260325700004],
              [-76.27375240799995, 38.92788320500006],
              [-76.28050696499992, 38.926662502000056],
              [-76.31126868399991, 38.92462799700007],
              [-76.31932532499991, 38.92267487200007],
              [-76.32884680899991, 38.91648997600004],
              [-76.33189856699994, 38.90696849200009],
              [-76.33198228799995, 38.895480098000064],
              [-76.32706272699994, 38.88095785100006],
              [-76.3283639839999, 38.86515618100009],
              [-76.3469309699999, 38.85645441400004],
              [-76.3592413419999, 38.846602146000066],
              [-76.37474792699993, 38.84157322300007],
              [-76.36631666799991, 38.896320777000085],
              [-76.35628535199993, 38.94863930900004],
              [-76.33885657499991, 38.97760651200008],
              [-76.33576412699995, 38.98501211100006],
              [-76.32209225199995, 39.00641510600008],
              [-76.31529700399994, 39.029364325000074],
              [-76.30638587099992, 39.031317450000074],
              [-76.29503333199995, 39.02765534100007],
              [-76.2932619579999, 39.008770509000044],
              [-76.28514470899995, 38.98942810700004],
              [-76.24438602299995, 38.97890431500008],
              [-76.21621400899994, 38.97431936800007],
              [-76.19756143099994, 38.979339881000044],
              [-76.16787675699993, 38.99632396000004],
              [-76.15099036399994, 39.009100653000075],
              [-76.14704342399995, 39.02948639500005],
              [-76.15489661399994, 39.03367747600004],
              [-76.16087805899991, 39.03974030200004],
              [-76.16519120999993, 39.04751211100006],
              [-76.16812089799993, 39.056708075000074],
              [-76.1446020169999, 39.06012604400007],
              [-76.13341223899994, 39.062933661000045],
              [-76.14085852799991, 39.06976959800005],
              [-76.12165279899995, 39.09247467700004],
              [-76.07721920499995, 39.12836334800005],
              [-76.06509355399993, 39.146144924000055],
              [-76.08779863199993, 39.138657945000034],
              [-76.10899817599994, 39.12592194200005],
              [-76.13052324099993, 39.11782461100006],
              [-76.15444902299993, 39.12441640800006],
              [-76.14085852799991, 39.13182200700004],
              [-76.14085852799991, 39.138657945000034],
              [-76.1751195949999, 39.12409088700008],
              [-76.18512196899991, 39.094164026000044],
              [-76.2039109879999, 39.08023582000004],
              [-76.21246106599995, 39.05179149800006],
              [-76.20762505099992, 39.029812234000076],
              [-76.20420624399992, 39.01453323800007],
              [-76.21721167699991, 39.01311396400007],
              [-76.23487647499991, 39.02475192900005],
              [-76.24261805099991, 39.03325963900005],
              [-76.23110935999995, 39.05827591800005],
              [-76.23571756699994, 39.09820819300006],
              [-76.24304552899991, 39.11575323000005],
              [-76.24259740899993, 39.126783396000064],
              [-76.25144557199991, 39.132604068000035],
              [-76.27268577799992, 39.151551665000056],
              [-76.2726280409999, 39.16799207200006],
              [-76.2558610399999, 39.18853605500004],
              [-76.23409171599991, 39.23044934400008],
              [-76.2128077829999, 39.26196686800006],
              [-76.18057206899994, 39.28807200700004],
              [-76.17861894399994, 39.307847398000035],
              [-76.17495683499993, 39.31622955900008],
              [-76.16486568899995, 39.32330963700008],
              [-76.14293372299994, 39.32664622600004],
              [-76.13341223899994, 39.33047109600005],
              [-76.12779700399994, 39.33852773600006],
              [-76.11998450399994, 39.36017487200007],
              [-76.11660722599993, 39.36465078300006],
              [-76.10536229399992, 39.37204781500009],
              [-76.05960594999993, 39.369628903000034],
              [-76.0278577389999, 39.362445336000064],
              [-75.9996392079999, 39.362216741000054],
              [-75.93149284799995, 39.364984416000084],
              [-75.8856760999999, 39.36252861200006],
              [-75.86009265399991, 39.36178451500007],
              [-75.8391820949999, 39.37148672100005],
              [-75.86401713799995, 39.37959549100009],
              [-75.90470570499991, 39.37428341800006],
              [-76.00659669899994, 39.380548214000044],
              [-76.03426463199992, 39.39287729700004],
              [-76.01390540299991, 39.41616445500006],
              [-75.9739477199999, 39.450832424000055],
              [-75.95197506399995, 39.46580638200004],
              [-75.93472245999993, 39.47451406500005],
              [-75.91246497299994, 39.47638580900008],
              [-75.86611894399994, 39.46430084800005],
              [-75.8391820949999, 39.46076080900008],
              [-75.8391820949999, 39.46698639500005],
              [-75.86876380099994, 39.48065827000005],
              [-75.88402258999992, 39.492254950000074],
              [-75.89378821499992, 39.50861237200007],
              [-75.86913001199991, 39.51947663000004],
              [-75.85130774599992, 39.538397528000075],
              [-75.83926347599993, 39.56146881700005],
              [-75.83169511599993, 39.58437734600005],
              [-75.85602779899995, 39.577378648000035],
              [-75.87340247299994, 39.56289297100005],
              [-75.88914954299992, 39.54547760600008],
              [-75.9049309429999, 39.521531681000056],
              [-75.96605236399995, 39.481731521000086],
              [-76.0007129729999, 39.45279012300006],
              [-75.99966386599993, 39.48550039300005],
              [-75.99063066299993, 39.50446198100008],
              [-75.96548417899993, 39.532863674000055],
              [-75.95466061099995, 39.548081773000035],
              [-75.94684811099995, 39.56537506700005],
              [-75.93472245999993, 39.60419342700004],
              [-75.95103919199994, 39.60101959800005],
              [-75.96255449099993, 39.59076569200005],
              [-75.97915605399993, 39.567287502000056],
              [-76.00835039299994, 39.54868700800006],
              [-76.0382065629999, 39.556620648000035],
              [-76.06479622599994, 39.555634986000086],
              [-76.08299719999991, 39.557806708000044],
              [-76.09239661399994, 39.55019765800006],
              [-76.12035071499992, 39.49494049700007],
              [-76.10973059799994, 39.48501211100006],
              [-76.07306881399995, 39.47508372600004],
              [-76.06509355399993, 39.470770575000074],
              [-76.06753495999993, 39.45783112200007],
              [-76.07412675699993, 39.44879791900007],
              [-76.12242591099994, 39.411037502000056],
              [-76.18370520699995, 39.38300202000005],
              [-76.20970618399991, 39.36465078300006],
              [-76.2259008449999, 39.377834377000056],
              [-76.22960364499994, 39.39752838700008],
              [-76.22276770699995, 39.440334377000056],
              [-76.2161352199999, 39.45937734600005],
              [-76.21580969999991, 39.46759674700007],
              [-76.22276770699995, 39.47451406500005],
              [-76.2324926419999, 39.47451406500005],
              [-76.24014238199993, 39.46702708500004],
              [-76.24681555899991, 39.458238023000035],
              [-76.25316321499992, 39.454006252000056],
              [-76.26683508999992, 39.37885163000004],
              [-76.25267493399991, 39.36151764500005],
              [-76.24522864499994, 39.34955475500004],
              [-76.24665279899995, 39.34414297100005],
              [-76.25401770699995, 39.34007396000004],
              [-76.28416907499991, 39.310614325000074],
              [-76.29165605399993, 39.357123114000046],
              [-76.31151282499991, 39.402777411000045],
              [-76.32518469999991, 39.40766022300005],
              [-76.40147864499994, 39.39252350500004],
              [-76.38556881399995, 39.38226959800005],
              [-76.35806230399993, 39.37710195500006],
              [-76.33665930899991, 39.369208075000074],
              [-76.33885657499991, 39.35097890800006],
              [-76.33263098899994, 39.35097890800006],
              [-76.34166419199994, 39.34048086100006],
              [-76.3516332669999, 39.33820221600007],
              [-76.36237545499995, 39.337225653000075],
              [-76.37360592399995, 39.33047109600005],
              [-76.3665258449999, 39.31732819200005],
              [-76.36913001199991, 39.31317780200004],
              [-76.42446855399993, 39.32367584800005],
              [-76.43081620999993, 39.31810130400004],
              [-76.42345130099994, 39.30565013200004],
              [-76.39049231699994, 39.271551825000074],
              [-76.39118404899995, 39.264878648000035],
              [-76.40147864499994, 39.25600820500006],
              [-76.41690019399994, 39.26398346600007],
              [-76.42593339799993, 39.27374909100007],
              [-76.44249426999994, 39.296942450000074],
              [-76.45067298099991, 39.302069403000075],
              [-76.48346920499995, 39.310614325000074],
              [-76.46776282499991, 39.282904364000046],
              [-76.44774329299992, 39.256740627000056],
              [-76.42153886599993, 39.238348700000074],
              [-76.3968650459999, 39.23798145100005],
              [-76.40277035899993, 39.22781648400007],
              [-76.43196655499992, 39.20593630700006],
              [-76.44917786799994, 39.19495688600006],
              [-76.44855949899994, 39.20843506700004],
              [-76.44523877699993, 39.21790485000008],
              [-76.45531165299991, 39.22016022300005],
              [-76.46300208199995, 39.21381256700005],
              [-76.46947010899993, 39.20754241100008],
              [-76.48250897399993, 39.20738802400007],
              [-76.49731559799994, 39.20855739500007],
              [-76.4924677969999, 39.227464775000044],
              [-76.50829780399994, 39.23602673400006],
              [-76.5319956809999, 39.24583957200008],
              [-76.56457286999995, 39.26496419000006],
              [-76.57081758399994, 39.273637551000036],
              [-76.58116614499994, 39.26732005400004],
              [-76.59105383999992, 39.26349518400008],
              [-76.61656653599994, 39.26219310100004],
              [-76.62319902299993, 39.25971100500004],
              [-76.61046301999994, 39.25446198100008],
              [-76.60259274399994, 39.24832419100005],
              [-76.58584550699993, 39.24852122600004],
              [-76.57027626799993, 39.24469226300005],
              [-76.56390222699991, 39.23130365500003],
              [-76.56359011899991, 39.215819648000036],
              [-76.53652017099995, 39.21144388300007],
              [-76.53026744899995, 39.20344150800008],
              [-76.5282893289999, 39.191345123000076],
              [-76.5246725319999, 39.18465701700006],
              [-76.51756215499995, 39.176663129000076],
              [-76.49998938699991, 39.16486237200007],
              [-76.49379270999992, 39.16146994800005],
              [-76.4800020369999, 39.167023043000086],
              [-76.46933492599993, 39.155031707000035],
              [-76.44102942599994, 39.13515859600005],
              [-76.4332827149999, 39.13121841600008],
              [-76.43022676999993, 39.10633423200005],
              [-76.41950640099992, 39.089620823000075],
              [-76.42530667199992, 39.07405296400009],
              [-76.43299394699994, 39.067224002000046],
              [-76.44357155099993, 39.07652779400007],
              [-76.44326738199993, 39.08869049700007],
              [-76.45592200399994, 39.090725002000056],
              [-76.46914628799993, 39.08344147300005],
              [-76.47837557499992, 39.08082559200005],
              [-76.49743287599995, 39.078572207000036],
              [-76.51320994299994, 39.08645847100007],
              [-76.51927602399991, 39.085708683000064],
              [-76.5164765689999, 39.07563585500009],
              [-76.49984905399992, 39.06842805700006],
              [-76.47632745899995, 39.064003322000076],
              [-76.42913332899991, 39.045707992000075],
              [-76.40991030299995, 39.03784690800006],
              [-76.39419511599993, 39.02456289300005],
              [-76.39854895699995, 39.01439036700009],
              [-76.41519120999993, 39.00995514500005],
              [-76.43871008999992, 39.008978583000044],
              [-76.44595292899993, 39.005194403000075],
              [-76.45556993399993, 38.988734830000055],
              [-76.4726560069999, 38.995129801000076],
              [-76.51194242699995, 39.02196327300004],
              [-76.5246182859999, 39.04539205000009],
              [-76.5395914579999, 39.064068545000055],
              [-76.55166581899994, 39.07721588700008],
              [-76.56354732999995, 39.074286200000074],
              [-76.56916256399995, 39.066392320000034],
              [-76.56851152299993, 39.05609772300005],
              [-76.5711872519999, 39.03864362000007],
              [-76.56158720999991, 39.036066782000034],
              [-76.5432939989999, 39.03158071800004],
              [-76.5309554769999, 39.02163573100006],
              [-76.51250577499991, 39.00572536700008],
              [-76.48615753599995, 38.98652514000008],
              [-76.47640413599993, 38.97520227700005],
              [-76.46992856899993, 38.953739787000075],
              [-76.45242672599994, 38.94386071100007],
              [-76.46519340399993, 38.93293528700008],
              [-76.4596123789999, 38.91213660300008],
              [-76.50144090299995, 38.927118559000064],
              [-76.52529264599991, 38.95105849500004],
              [-76.55748153699994, 38.95873872100009],
              [-76.56860769999992, 38.95254183000009],
              [-76.53490149599992, 38.93764883000006],
              [-76.52440344999991, 38.92641836100006],
              [-76.51239921899992, 38.91285282700005],
              [-76.49310077199993, 38.89895001900004],
              [-76.49619730199993, 38.88006341100004],
              [-76.50742147799991, 38.879255783000076],
              [-76.5214073269999, 38.88716607200007],
              [-76.53746497299994, 38.89166901200008],
              [-76.53652910099993, 38.88739655200004],
              [-76.53530839799993, 38.884466864000046],
              [-76.53062903599994, 38.87799713700008],
              [-76.52368451899991, 38.87030178900005],
              [-76.52697000799992, 38.86150534800004],
              [-76.53899144499991, 38.85664141700005],
              [-76.53172223099995, 38.83922899800007],
              [-76.52227894299995, 38.84271357800009],
              [-76.50588195099994, 38.84426207900009],
              [-76.4929157219999, 38.844419789000085],
              [-76.4942878679999, 38.82554643100008],
              [-76.50377356699994, 38.80756256700005],
              [-76.53065552299995, 38.783315912000035],
              [-76.55166581899994, 38.77558014500005],
              [-76.55028235599991, 38.755113023000035],
              [-76.53888912699995, 38.73769765800006],
              [-76.52152766199993, 38.72489274800006],
              [-76.52707755699993, 38.70264341600006],
              [-76.5295344669999, 38.675760092000075],
              [-76.5215617909999, 38.65017173200005],
              [-76.50914869799993, 38.62813940500007],
              [-76.51219641799992, 38.571478583000044],
              [-76.51197731899993, 38.52773391000005],
              [-76.49550060199994, 38.496018047000064],
              [-76.43550368399991, 38.43822384300006],
              [-76.41398220899993, 38.412336458000084],
              [-76.39605688699993, 38.39127517600008],
              [-76.38190497699992, 38.38457465100004],
              [-76.39276441299995, 38.35356984800006],
              [-76.41935918799993, 38.321705733000044],
              [-76.4535625659999, 38.324052805000065],
              [-76.47130391399992, 38.335501598000064],
              [-76.46914628799993, 38.36408112200007],
              [-76.4739477199999, 38.37327708500004],
              [-76.47496497299994, 38.37958405200004],
              [-76.47671464799993, 38.38515859600005],
              [-76.48346920499995, 38.39203522300005],
              [-76.50011145699995, 38.400091864000046],
              [-76.51134192599994, 38.403998114000046],
              [-76.54283606699994, 38.40961334800005],
              [-76.56164028499995, 38.42421509500008],
              [-76.60245608899993, 38.44433453600004],
              [-76.63647493999991, 38.47416340600006],
              [-76.64769938699993, 38.50568347300003],
              [-76.67178300699993, 38.65444570500006],
              [-76.68146725199995, 38.679388739000046],
              [-76.68407141799992, 38.67255280200004],
              [-76.68285071499992, 38.66474030200004],
              [-76.68423417899993, 38.65326569200005],
              [-76.67882239499994, 38.58038971600007],
              [-76.67467200399994, 38.55841705900008],
              [-76.67520097599993, 38.53534577000005],
              [-76.67591679199995, 38.50943336000006],
              [-76.67364396999994, 38.48605786400009],
              [-76.65705066599992, 38.450487181000085],
              [-76.61974036399994, 38.42332591400009],
              [-76.58584550699993, 38.398871161000045],
              [-76.52131100199995, 38.374212958000044],
              [-76.51073157499991, 38.36782461100006],
              [-76.50609290299991, 38.34955475500004],
              [-76.49380449099993, 38.32982005400004],
              [-76.47638912699995, 38.31289297100005],
              [-76.45063396799992, 38.293140520000065],
              [-76.43230330999995, 38.29403967300004],
              [-76.4245804549999, 38.30166969700008],
              [-76.40636145699995, 38.308294989000046],
              [-76.38578305699991, 38.306302981000044],
              [-76.37338215299991, 38.298892537000086],
              [-76.3871206149999, 38.28296113300007],
              [-76.39645510699995, 38.26707625700004],
              [-76.39329993399991, 38.24599844000005],
              [-76.38727779899995, 38.22695547100005],
              [-76.38048255099994, 38.21938711100006],
              [-76.36008870499995, 38.19471059400007],
              [-76.33410617399994, 38.16337546300008],
              [-76.32050662699993, 38.138776121000035],
              [-76.33083109899991, 38.12905995600005],
              [-76.34030484999994, 38.120726740000066],
              [-76.33263098899994, 38.09031810100004],
              [-76.32804803899995, 38.07614873500006],
              [-76.3260518859999, 38.06378563700008],
              [-76.32389659699993, 38.04384208700009],
              [-76.33634136199993, 38.05337336100007],
              [-76.3512835439999, 38.057357944000046],
              [-76.3959152459999, 38.10299431800007],
              [-76.41525725499991, 38.10829877800006],
              [-76.43408626799993, 38.13214256100008],
              [-76.42675029899993, 38.15899749100004],
              [-76.43358313699991, 38.190334377000056],
              [-76.45612545499995, 38.207017320000034],
              [-76.45523027299993, 38.19790273600006],
              [-76.44994055899991, 38.182806708000044],
              [-76.44871985599991, 38.17597077000005],
              [-76.45091712099992, 38.16620514500005],
              [-76.45579993399991, 38.158270575000074],
              [-76.46080481699994, 38.152329820000034],
              [-76.46886145699995, 38.139105536000045],
              [-76.48216712099992, 38.146144924000055],
              [-76.50389563699991, 38.166001695000034],
              [-76.51012122299994, 38.14008209800005],
              [-76.51716061099995, 38.13178131700005],
              [-76.53062903599994, 38.138739325000074],
              [-76.53237870999993, 38.14740631700005],
              [-76.54032224999992, 38.15977320200005],
              [-76.54780727799994, 38.18369902000006],
              [-76.56296942599994, 38.19861049100007],
              [-76.58766261999995, 38.21064593500006],
              [-76.61674290499991, 38.22330649500009],
              [-76.64383524099992, 38.22500806900007],
              [-76.67809103299993, 38.234835317000034],
              [-76.69736408199992, 38.238002953000034],
              [-76.75472485099993, 38.227602311000055],
              [-76.77764589299994, 38.23755669700006],
              [-76.80420984699992, 38.25362257300009],
              [-76.80101477799991, 38.27631256700005],
              [-76.80858313699991, 38.28974030200004],
              [-76.81175696499992, 38.29922109600005],
              [-76.81558183499993, 38.33633047100005],
              [-76.82762610599991, 38.36286041900007],
              [-76.84898841099994, 38.382513739000046],
              [-76.88068600199995, 38.398871161000045],
              [-76.85594641799992, 38.35521067900004],
              [-76.84609941299993, 38.33087799700007],
              [-76.83910071499992, 38.30263906500005],
              [-76.8392156569999, 38.25721682600005],
              [-76.86576742099993, 38.27189781800007],
              [-76.89572619899991, 38.282406338000044],
              [-76.92217430599993, 38.29159319300004],
              [-76.92363959599993, 38.31488059900005],
              [-76.94853600999994, 38.330945532000044],
              [-76.97337678199995, 38.34426377700004],
              [-76.98668353199992, 38.370720352000035],
              [-77.01402049599994, 38.44162949200006],
              [-77.02158187399993, 38.46139530000005],
              [-77.03156490799995, 38.48139069200005],
              [-77.03237870999993, 38.47162506700005],
              [-77.03490149599992, 38.46271393400008],
              [-77.03888912699995, 38.454331773000035],
              [-77.04454505099994, 38.446600653000075],
              [-77.06012936099995, 38.42853424700007],
              [-77.07323157499991, 38.42084381700005],
              [-77.0946371679999, 38.408720077000055],
              [-77.10521984099995, 38.411281588000065],
              [-77.10362708199995, 38.43451569200005],
              [-77.10529537699995, 38.44546133000006],
              [-77.09976152299993, 38.45343659100007],
              [-77.09976152299993, 38.46088288000004],
              [-77.10317949099993, 38.46308014500005],
              [-77.10435950399994, 38.464056708000044],
              [-77.10505123599995, 38.46515534100007],
              [-77.10724850199995, 38.46771881700005],
              [-77.12083899599992, 38.46149323100008],
              [-77.13394120999993, 38.45343659100007],
              [-77.12718665299991, 38.45001862200007],
              [-77.12295488199993, 38.44599030200004],
              [-77.11343339799993, 38.432928778000075],
              [-77.13394120999993, 38.398871161000045],
              [-77.14525305899991, 38.388739325000074],
              [-77.16779537699995, 38.380926825000074],
              [-77.17833411399994, 38.37457916900007],
              [-77.20365121999993, 38.36429539200009],
              [-77.23193138799991, 38.37406835500008],
              [-77.25525856999991, 38.39352192100006],
              [-77.26232470299993, 38.42492664700006],
              [-77.25785995699994, 38.45106121500004],
              [-77.2663949919999, 38.472844197000086],
              [-77.26704148199991, 38.49407954000009],
              [-77.25704941899994, 38.51140764500008],
              [-77.24775826299992, 38.523244902000044],
              [-77.23884029899995, 38.53766510600008],
              [-77.22752844999991, 38.55687083500004],
              [-77.20913001699995, 38.55571834600005],
              [-77.18637350599994, 38.55681508400005],
              [-77.16808020699995, 38.57697174700007],
              [-77.17559712699995, 38.578256890000034],
              [-77.1893589689999, 38.56909936300008],
              [-77.20592691799993, 38.566058663000035],
              [-77.20443659099993, 38.57499805300006],
              [-77.1935244629999, 38.59164737100008],
              [-77.18443762899994, 38.60496653900009],
              [-77.17894446499992, 38.60761139500005],
              [-77.17259680899991, 38.60952383000006],
              [-77.16494706899994, 38.61481354400007],
              [-77.15831458199995, 38.616522528000075],
              [-77.13634192599994, 38.61554596600007],
              [-77.12645423099991, 38.61790599200009],
              [-77.12100175699993, 38.62376536700009],
              [-77.11481686099995, 38.64085521000004],
              [-77.10606848899994, 38.657131252000056],
              [-77.10240637899994, 38.673895575000074],
              [-77.09634355399993, 38.682806708000044],
              [-77.08869381399995, 38.68919505400004],
              [-77.08079993399991, 38.69403717700004],
              [-77.0618690199999, 38.69739253400007],
              [-77.0456380139999, 38.70069637100005],
              [-77.03734193899993, 38.696186182000076],
              [-77.0218585369999, 38.69549817500007],
              [-77.0124668919999, 38.69735546900006],
              [-77.01556179699992, 38.70062965900007],
              [-77.0241258289999, 38.699790516000064],
              [-77.0306695239999, 38.70333104400004],
              [-77.03467768399992, 38.70825992400006],
              [-77.03015987099991, 38.71569801700008],
              [-77.02972946599994, 38.731442541000035],
              [-77.0247289699999, 38.74079010600008],
              [-77.01842200399994, 38.74396393400008],
              [-77.01116146499993, 38.74382480600008],
              [-77.01168007199993, 38.74716555100008],
              [-77.01953337599991, 38.75172051000004],
              [-77.02433761899994, 38.75465294600008],
              [-77.02806124499995, 38.76530808700005],
              [-77.02621082899992, 38.776392240000064],
              [-77.02122716999992, 38.78283935200005],
              [-77.01799738699992, 38.79059544900008],
              [-77.0211481149999, 38.79590064700005],
              [-77.02738742699995, 38.819906384000035],
              [-77.02149674899994, 38.83672326700008],
              [-77.01784128299994, 38.845179560000076],
              [-77.0159321829999, 38.854279484000074],
              [-77.01957771399992, 38.86127460200004],
              [-77.02593476299995, 38.87259409400008],
              [-77.03607145099994, 38.87982307300007],
              [-77.04963097799993, 38.88831238400007],
              [-77.06008394399993, 38.89906786200004],
              [-77.06833279099993, 38.90193759600004],
              [-77.0636870049999, 38.891255191000084],
              [-77.05181463899993, 38.88109293800005],
              [-77.04524337999993, 38.876192925000055],
              [-77.03901702099995, 38.86826989000008],
              [-77.03495131199992, 38.860972798000034],
              [-77.0330392429999, 38.853970477000075],
              [-77.03280102299993, 38.84526666600004],
              [-77.03695210799992, 38.83984020100007],
              [-77.0438213349999, 38.83939279900005],
              [-77.04327971899994, 38.83538269700006],
              [-77.04004880799994, 38.82739897700009],
              [-77.03757137699995, 38.81505040500008],
              [-77.03835368999995, 38.796282775000066],
              [-77.04295954499992, 38.79185294300004],
              [-77.04974816999993, 38.788726534000034],
              [-77.05261709799993, 38.783655209000074],
              [-77.04769389599994, 38.77636811900004],
              [-77.04658944899995, 38.767685749000066],
              [-77.04475184199993, 38.74797245600007],
              [-77.04252727099993, 38.72890799400005],
              [-77.04777148799991, 38.71572353400006],
              [-77.0699562559999, 38.71066383200008],
              [-77.08922278599994, 38.71039459800005],
              [-77.09935462099992, 38.70685455900008],
              [-77.1094457669999, 38.70750560100004],
              [-77.1172582669999, 38.706244208000044],
              [-77.12401282499991, 38.687201239000046],
              [-77.13103570699991, 38.67719140600008],
              [-77.14240377599992, 38.67699358300007],
              [-77.14905433899992, 38.68572708000005],
              [-77.1582970959999, 38.69162754200005],
              [-77.16778581699992, 38.688958693000075],
              [-77.16933326599991, 38.67933656000008],
              [-77.15429624799992, 38.66364943800005],
              [-77.1379964109999, 38.65043694700006],
              [-77.1348651429999, 38.63628307500005],
              [-77.16292462399991, 38.63152924900004],
              [-77.18716395199993, 38.62079952800008],
              [-77.20088864799993, 38.62375063800005],
              [-77.20928749399991, 38.63105833600008],
              [-77.20497320099992, 38.63894980300006],
              [-77.19542395699995, 38.65574778900009],
              [-77.20177161399994, 38.66502513200004],
              [-77.21589107999995, 38.664943752000056],
              [-77.22988847599993, 38.656683661000045],
              [-77.23631751199991, 38.641791083000044],
              [-77.23936926999994, 38.62641022300005],
              [-77.24742591099994, 38.60927969000005],
              [-77.25865637899994, 38.59393952000005],
              [-77.27171790299991, 38.58380768400008],
              [-77.26695716099994, 38.58075592700004],
              [-77.26292883999992, 38.57453034100007],
              [-77.25804602799991, 38.569525458000044],
              [-77.27647864499994, 38.55927155200004],
              [-77.28477942599994, 38.55646393400008],
              [-77.28477942599994, 38.54901764500005],
              [-77.28734290299991, 38.530178127000056],
              [-77.30538379799992, 38.50215255000006],
              [-77.32659247499993, 38.450933675000044],
              [-77.31425003899994, 38.406128623000086],
              [-77.33470037399991, 38.416707976000055],
              [-77.35182853099991, 38.432825036000054],
              [-77.35871623999992, 38.42926496400008],
              [-77.35022518199992, 38.40955377200004],
              [-77.32337920799995, 38.39018787300006],
              [-77.30905564699992, 38.37949134300004],
              [-77.2973575389999, 38.36874299800007],
              [-77.2907799809999, 38.35378462600005],
              [-77.30216002399993, 38.35426063700004],
              [-77.32389720299994, 38.35042436800006],
              [-77.34307049299991, 38.34869104200004],
              [-77.3385112499999, 38.34261078500003],
              [-77.29213146699993, 38.34073702000006],
              [-77.24897884699993, 38.32988472900007],
              [-77.18541419199994, 38.34357330900008],
              [-77.16673743399991, 38.34788646000004],
              [-77.13353430899991, 38.36713288000004],
              [-77.08564958099993, 38.368411500000036],
              [-77.05846106699994, 38.394191799000055],
              [-77.0408410579999, 38.395909955000036],
              [-77.02036988899994, 38.384585805000086],
              [-77.01478062799993, 38.372328363000065],
              [-77.0169548479999, 38.35514236700004],
              [-77.01400054399994, 38.34352421400007],
              [-77.01447506399995, 38.330511786000045],
              [-77.02299704899991, 38.32005145900007],
              [-77.03886288799993, 38.32254888400007],
              [-77.05203570499992, 38.32302757500008],
              [-77.0527383079999, 38.31684240300007],
              [-77.03859389799993, 38.312947387000065],
              [-77.03013151499994, 38.30768206200008],
              [-77.0004762339999, 38.27730818300006],
              [-76.97492428299995, 38.270697333000044],
              [-76.96544348899994, 38.267238674000055],
              [-76.95981920999992, 38.26014250500009],
              [-76.95511819099994, 38.24718598700008],
              [-76.9565685849999, 38.235503717000086],
              [-76.96136630299992, 38.21828161900004],
              [-76.95417122099991, 38.21016771800004],
              [-76.9128678909999, 38.199167541000065],
              [-76.88177320699992, 38.17702667600008],
              [-76.83003302499992, 38.16546883700005],
              [-76.79698102099991, 38.16940490700006],
              [-76.77512473299993, 38.16698594700006],
              [-76.75641842399995, 38.16095612200007],
              [-76.75035559799994, 38.14838288000004],
              [-76.73932857999995, 38.136704820000034],
              [-76.71519934799994, 38.141913153000075],
              [-76.6914770169999, 38.15314362200007],
              [-76.68146725199995, 38.15924713700008],
              [-76.67003333199995, 38.157416083000044],
              [-76.66193600199995, 38.15289948100008],
              [-76.65510006399995, 38.14789459800005],
              [-76.64732825399994, 38.144964911000045],
              [-76.63536536399994, 38.14500560100004],
              [-76.61461341099994, 38.150376695000034],
              [-76.60716836099994, 38.143451553000034],
              [-76.6014441289999, 38.13253912400006],
              [-76.60715299099991, 38.112956789000066],
              [-76.59531674999994, 38.10506805600005],
              [-76.5812667429999, 38.09760209500007],
              [-76.56113511599995, 38.089453468000045],
              [-76.53442335799991, 38.075170823000065],
              [-76.52871421099991, 38.064256008000086],
              [-76.52074133999992, 38.052801825000074],
              [-76.53311113199993, 38.042669989000046],
              [-76.53189042899993, 38.038723049000055],
              [-76.53062903599994, 38.02513255400004],
              [-76.52562415299991, 38.022691148000035],
              [-76.50448229099993, 38.02363588900005],
              [-76.48513499299992, 38.02179056400007],
              [-76.4705274129999, 38.01626582300008],
              [-76.46307132399994, 38.01491766200007],
              [-76.4544164699999, 38.00617096600007],
              [-76.46178137899994, 38.00234609600005],
              [-76.46914628799993, 38.00096263200004],
              [-76.45864824099993, 37.99555084800005],
              [-76.40818011999994, 37.96961669700005],
              [-76.37303626199991, 37.960598049000055],
              [-76.29124166899993, 37.92499680800006],
              [-76.26200253899992, 37.91430381100008],
              [-76.24790889899992, 37.90347101300006],
              [-76.24245344099995, 37.88159497700008],
              [-76.23582923099991, 37.85960521000004],
              [-76.23961341099994, 37.83608633000006],
              [-76.2500707669999, 37.82282135600008],
              [-76.26789303299995, 37.82444896000004],
              [-76.29938717399995, 37.850897528000075],
              [-76.31525631399995, 37.85761139500005],
              [-76.32485917899993, 37.84870026200008],
              [-76.31786048099991, 37.82880280200004],
              [-76.29784094999991, 37.796128648000035],
              [-76.29385331899994, 37.78066640800006],
              [-76.29409745999993, 37.77142975500004],
              [-76.29784094999991, 37.761379299000055],
              [-76.30467688699991, 37.747748114000046],
              [-76.30915279899995, 37.74640534100007],
              [-76.31602942599994, 37.747748114000046],
              [-76.32237708199995, 37.74827708500004],
              [-76.32518469999991, 37.74433014500005],
              [-76.31704667899993, 37.73224518400008],
              [-76.28551184799994, 37.710923570000034],
              [-76.28416907499991, 37.699286200000074],
              [-76.29222571499992, 37.694566148000035],
              [-76.30370032499991, 37.69403717700004],
              [-76.31566321499992, 37.69611237200007],
              [-76.32518469999991, 37.699286200000074],
              [-76.31973222599993, 37.68549225500004],
              [-76.32530676999994, 37.67951080900008],
              [-76.33413652299993, 37.675767320000034],
              [-76.33885657499991, 37.66889069200005],
              [-76.33543860599991, 37.65912506700005],
              [-76.32111568899995, 37.64398834800005],
              [-76.31786048099991, 37.63719310100004],
              [-76.30467688699991, 37.637884833000044],
              [-76.32111568899995, 37.62400950700004],
              [-76.34943600199995, 37.62799713700008],
              [-76.40465247299994, 37.64468008000006],
              [-76.40880286399994, 37.64996979400007],
              [-76.41930091099994, 37.66010163000004],
              [-76.43008378799993, 37.666896877000056],
              [-76.43504798099991, 37.661769924000055],
              [-76.43862870999993, 37.66290924700007],
              [-76.44644120999993, 37.67084381700005],
              [-76.45376542899993, 37.68353913000004],
              [-76.45612545499995, 37.69245026200008],
              [-76.46890214799993, 37.708644924000055],
              [-76.47866777299993, 37.69505442900004],
              [-76.48961341099994, 37.65835195500006],
              [-76.50499426999994, 37.65692780200004],
              [-76.5169164699999, 37.66893138200004],
              [-76.52391516799992, 37.68789297100005],
              [-76.52440344999991, 37.699286200000074],
              [-76.53551184799994, 37.71552155200004],
              [-76.57135982999995, 37.751288153000075],
              [-76.57900956899994, 37.77130768400008],
              [-76.58348548099991, 37.77728913000004],
              [-76.61314856699994, 37.796128648000035],
              [-76.61778723899994, 37.80385976800005],
              [-76.62193762899994, 37.81391022300005],
              [-76.62857011599993, 37.818426825000074],
              [-76.64049231699994, 37.80914948100008],
              [-76.64956620999993, 37.81305573100008],
              [-76.65782630099994, 37.81899648600006],
              [-76.66266842399995, 37.82851797100005],
              [-76.66152910099993, 37.84332916900007],
              [-76.67414303299995, 37.83299388200004],
              [-76.68765214799993, 37.83161041900007],
              [-76.70091712099992, 37.83690013200004],
              [-76.71275794199994, 37.84707265800006],
              [-76.75035559799994, 37.89516836100006],
              [-76.7695282819999, 37.914496255000074],
              [-76.8322619349999, 37.94297216100006],
              [-76.85029535699994, 37.98195834100005],
              [-76.88006845599995, 37.99095692700007],
              [-76.89573717999991, 38.007308822000084],
              [-76.91539466099994, 38.06989166900007],
              [-76.93496660099993, 38.09369538000004],
              [-76.94709225199995, 38.10333893400008],
              [-76.96263587099992, 38.11082591400009],
              [-77.00743567599994, 38.11810944200005],
              [-77.01720130099994, 38.11701080900008],
              [-77.02660071499992, 38.12885163000004],
              [-77.03620357999995, 38.14520905200004],
              [-77.04759680899991, 38.159816799000055],
              [-77.0625707669999, 38.166001695000034],
              [-77.10716712099992, 38.17495351800005],
              [-77.12588456899994, 38.17601146000004],
              [-77.13394120999993, 38.166001695000034],
              [-77.12669837099992, 38.155462958000044],
              [-77.1094457669999, 38.14899323100008],
              [-77.07591712099992, 38.144964911000045],
              [-77.06314042899993, 38.14984772300005],
              [-77.05549068899995, 38.149644273000035],
              [-77.05199133999992, 38.141831773000035],
              [-77.05089270699995, 38.12885163000004],
              [-77.04735266799992, 38.11896393400008],
              [-77.04100501199991, 38.111029364000046],
              [-77.03156490799995, 38.103949286000045],
              [-76.96056067599994, 38.08958567900004],
              [-76.94896399599992, 38.079779364000046],
              [-76.94469153599994, 38.07453034100007],
              [-76.92589270699995, 38.05882396000004],
              [-76.92170162699995, 38.052801825000074],
              [-76.92641478799993, 37.99671646100006],
              [-76.92261368099992, 37.98083340900007],
              [-76.90579802099995, 37.97579176600004],
              [-76.89171301999994, 37.974310614000046],
              [-76.88023841099994, 37.96967194200005],
              [-76.87744594599991, 37.95636330100007],
              [-76.86592043299993, 37.94197723600007],
              [-76.84703528599994, 37.928941148000035],
              [-76.83116614499994, 37.91836172100005],
              [-76.81645591599994, 37.90355199900006],
              [-76.79528641399992, 37.89195732400009],
              [-76.7878900579999, 37.88323062500007],
              [-76.77780084199992, 37.86209102400005],
              [-76.76689075299993, 37.84204041900006],
              [-76.75267506299991, 37.82262623500009],
              [-76.74173030999992, 37.80996509100004],
              [-76.7291195979999, 37.79946539600007],
              [-76.7162445379999, 37.788097022000045],
              [-76.70303453899993, 37.786955171000045],
              [-76.68797766799992, 37.789496161000045],
              [-76.68399003799993, 37.78925202000005],
              [-76.67992102799991, 37.78969961100006],
              [-76.67520097599993, 37.788723049000055],
              [-76.67442786399994, 37.78510163000004],
              [-76.67601477799991, 37.77187734600005],
              [-76.67520097599993, 37.76821523600006],
              [-76.66865875499991, 37.75550154600006],
              [-76.63193552799993, 37.75042788300004],
              [-76.6134005209999, 37.739539010000044],
              [-76.60172229299991, 37.719650339000054],
              [-76.57998613199993, 37.69818756700005],
              [-76.57900956899994, 37.69586823100008],
              [-76.57721920499995, 37.68817780200004],
              [-76.57402998099991, 37.67324590800007],
              [-76.5708052519999, 37.653244516000086],
              [-76.55198222899992, 37.626757636000036],
              [-76.52222111899994, 37.61488081300007],
              [-76.46349036399994, 37.61855703300006],
              [-76.44302324099993, 37.61859772300005],
              [-76.42821204299992, 37.624212958000044],
              [-76.40428626199991, 37.594183661000045],
              [-76.36758378799993, 37.58421458500004],
              [-76.32526607999995, 37.58063385600008],
              [-76.28416907499991, 37.569566148000035],
              [-76.30190995999993, 37.557928778000075],
              [-76.31924394399994, 37.55292389500005],
              [-76.36611894399994, 37.54905833500004],
              [-76.39297441299993, 37.542181708000044],
              [-76.39338131399995, 37.53314850500004],
              [-76.37767493399991, 37.52521393400008],
              [-76.35651607999995, 37.52179596600007],
              [-76.32266191299993, 37.501288153000075],
              [-76.30125891799992, 37.493841864000046],
              [-76.29165605399993, 37.50438060100004],
              [-76.28981346799992, 37.519404105000035],
              [-76.27006169999993, 37.51735554800007],
              [-76.26277228399994, 37.502927826000075],
              [-76.26390506699994, 37.487302114000045],
              [-76.2676488919999, 37.48102448100008],
              [-76.27721106699994, 37.47044505400004],
              [-76.2774145169999, 37.45970286700009],
              [-76.26740475199995, 37.453192450000074],
              [-76.25572669199994, 37.45327383000006],
              [-76.24453691299993, 37.44953034100007],
              [-76.24463721199993, 37.43058625700007],
              [-76.2454427369999, 37.398187],
              [-76.2492064889999, 37.36342859600006],
              [-76.25764013199995, 37.33551034800007],
              [-76.28070376499994, 37.32135135800007],
              [-76.29825126499992, 37.33506919100006],
              [-76.31895911399994, 37.37091705900008],
              [-76.32164466099994, 37.38629791900007],
              [-76.33356686099995, 37.38495514500005],
              [-76.34805253799993, 37.37995026200008],
              [-76.36611894399994, 37.38458893400008],
              [-76.39659583199995, 37.42959219000005],
              [-76.41515051999994, 37.442694403000075],
              [-76.42821204299992, 37.41815827000005],
              [-76.41681881399995, 37.41498444200005],
              [-76.40929114499994, 37.40778229400007],
              [-76.40461178299995, 37.39891185100004],
              [-76.40147864499994, 37.39081452000005],
              [-76.41169186099995, 37.39492422100005],
              [-76.42251542899993, 37.39752838700008],
              [-76.43317623599995, 37.39671458500004],
              [-76.44249426999994, 37.39081452000005],
              [-76.44758053299995, 37.37986888200004],
              [-76.44273841099994, 37.37201569200005],
              [-76.41588294199994, 37.35569896000004],
              [-76.40855872299994, 37.35366445500006],
              [-76.40343176999994, 37.34979889500005],
              [-76.40147864499994, 37.339911200000074],
              [-76.40648352799991, 37.33771393400008],
              [-76.43504798099991, 37.329331773000035],
              [-76.43504798099991, 37.323146877000056],
              [-76.40265865799995, 37.32501862200007],
              [-76.39403235599991, 37.323146877000056],
              [-76.38609778599994, 37.31513092700004],
              [-76.37686113199993, 37.301214911000045],
              [-76.37189693899995, 37.28803131700005],
              [-76.37850494799994, 37.27233238800005],
              [-76.45743016699993, 37.261052619000054],
              [-76.49602940799991, 37.24911484000006],
              [-76.5093524909999, 37.26956583900005],
              [-76.54000710699995, 37.293235775000085],
              [-76.55468049399991, 37.307945059000076],
              [-76.56163489499994, 37.323146877000056],
              [-76.5742895169999, 37.32518138200004],
              [-76.58202063699991, 37.33047109600005],
              [-76.64248613199993, 37.40900299700007],
              [-76.65819251199991, 37.41815827000005],
              [-76.68089758999992, 37.42747630400004],
              [-76.70010331899994, 37.44940827000005],
              [-76.72984778599994, 37.49445221600007],
              [-76.78107662699995, 37.53546784100007],
              [-76.79027258999992, 37.53270091400009],
              [-76.79539954299992, 37.52558014500005],
              [-76.79767818899995, 37.515611070000034],
              [-76.7981664699999, 37.50438060100004],
              [-76.79409745999993, 37.49827708500004],
              [-76.78477942599994, 37.49445221600007],
              [-76.77367102799991, 37.49135976800005],
              [-76.76463782499991, 37.48700592700004],
              [-76.7219945949999, 37.42723216400009],
              [-76.69078528599994, 37.41107819200005],
              [-76.67638098899994, 37.39492422100005],
              [-76.65477454299992, 37.36351146000004],
              [-76.60622363699991, 37.29578910100008],
              [-76.53352646899992, 37.25550466100009],
              [-76.5043365279999, 37.231813782000074],
              [-76.46807337699994, 37.21396628600007],
              [-76.43229875999992, 37.22242394500006],
              [-76.40298417899993, 37.23383209800005],
              [-76.38560950399994, 37.232489325000074],
              [-76.37360592399995, 37.22016022300005],
              [-76.37580318899995, 37.21775950700004],
              [-76.37840735599991, 37.20726146000004],
              [-76.38023841099994, 37.194566148000035],
              [-76.37975012899994, 37.18537018400008],
              [-76.37315833199995, 37.17597077000005],
              [-76.36172441299993, 37.16657135600008],
              [-76.35106360599991, 37.16421133000006],
              [-76.34626217399995, 37.175482489000046],
              [-76.31725012899994, 37.159491278000075],
              [-76.29820716099994, 37.144598700000074],
              [-76.29165605399993, 37.130113023000035],
              [-76.30321204299992, 37.12592194200005],
              [-76.32559160099993, 37.11408112200007],
              [-76.33861243399991, 37.10171133000006],
              [-76.32209225199995, 37.09593333500004],
              [-76.28160559799994, 37.10415273600006],
              [-76.27037512899994, 37.097642320000034],
              [-76.26988684799994, 37.06928131700005],
              [-76.27452551999994, 37.048041083000044],
              [-76.28294837099992, 37.028225002000056],
              [-76.2962133449999, 37.01357656500005],
              [-76.31525631399995, 37.007879950000074],
              [-76.33971106699994, 37.00739166900007],
              [-76.35704505099994, 37.00482819200005],
              [-76.37144934799994, 36.99852122600004],
              [-76.39952551999994, 36.97833893400008],
              [-76.41543535099993, 36.97256094000005],
              [-76.42918860599991, 36.97630442900004],
              [-76.44029700399994, 37.01577383000006],
              [-76.45299231699994, 37.030178127000056],
              [-76.52394065099992, 37.05766985000008],
              [-76.54606356799991, 37.08940744800009],
              [-76.56319125899995, 37.08575712800007],
              [-76.61118758299995, 37.119442192000065],
              [-76.61859618099993, 37.13078573100006],
              [-76.61998450399994, 37.14443594000005],
              [-76.61082923099991, 37.17255280200004],
              [-76.61733964799993, 37.19916413000004],
              [-76.63402258999992, 37.220689195000034],
              [-76.65477454299992, 37.23383209800005],
              [-76.66930091099994, 37.22711823100008],
              [-76.71080481699994, 37.22402578300006],
              [-76.72984778599994, 37.22016022300005],
              [-76.73521887899994, 37.21320221600007],
              [-76.73875891799992, 37.20331452000005],
              [-76.74376380099994, 37.19749583500004],
              [-76.75377356699994, 37.20307038000004],
              [-76.75845292899993, 37.21124909100007],
              [-76.76207434799994, 37.22142161700009],
              [-76.76667232999995, 37.230129299000055],
              [-76.77424068899995, 37.23383209800005],
              [-76.79181881399995, 37.23696523600006],
              [-76.82896887899994, 37.25104401200008],
              [-76.84284420499995, 37.25429922100005],
              [-76.85558020699995, 37.26243724200009],
              [-76.85741126199991, 37.28188711100006],
              [-76.85631262899994, 37.304673570000034],
              [-76.86021887899994, 37.323146877000056],
              [-76.86986243399991, 37.31549713700008],
              [-76.87352454299992, 37.30516185100004],
              [-76.87319902299993, 37.27846914300005],
              [-76.87816321499992, 37.26898834800005],
              [-76.88923092399995, 37.25918203300006],
              [-76.90802975199995, 37.24746328300006],
              [-76.93146725199995, 37.24526601800005],
              [-76.94395911399994, 37.25604889500005],
              [-76.95303300699993, 37.27362702000005],
              [-76.98192298099991, 37.31240469000005],
              [-76.99054928299995, 37.32025788000004],
              [-77.00357011599993, 37.323146877000056],
              [-77.01451575399994, 37.31875234600005],
              [-77.04552161399994, 37.29840729400007],
              [-77.05199133999992, 37.29181549700007],
              [-77.05549068899995, 37.287176825000074],
              [-77.06289628799993, 37.29702383000006],
              [-77.07017981699994, 37.31028880400004],
              [-77.07249915299991, 37.31635163000004],
              [-77.08275305899991, 37.32440827000005],
              [-77.09105383999992, 37.327826239000046],
              [-77.10033118399991, 37.32709381700005],
              [-77.11343339799993, 37.323146877000056],
              [-77.13442949099993, 37.31688060100004],
              [-77.14443925699993, 37.31635163000004],
              [-77.15526282499991, 37.318345445000034],
              [-77.17267818899995, 37.327337958000044],
              [-77.17833411399994, 37.329331773000035],
              [-77.22008216099994, 37.32851797100005],
              [-77.23497473899994, 37.33417389500005],
              [-77.25059973899994, 37.34983958500004],
              [-77.27794348899994, 37.329331773000035],
              [-77.27432206899994, 37.31635163000004],
              [-77.26488196499992, 37.31118398600006],
              [-77.25511633999992, 37.30927155200004],
              [-77.25059973899994, 37.30609772300005],
              [-77.2395727199999, 37.308661200000074],
              [-77.17491614499994, 37.288397528000075],
              [-77.08922278599994, 37.288397528000075],
              [-77.0833227199999, 37.283270575000074],
              [-77.07616126199991, 37.27326080900008],
              [-77.06712805899991, 37.266506252000056],
              [-77.05540930899991, 37.27138906500005],
              [-77.02525794199994, 37.29197825700004],
              [-77.01720130099994, 37.29523346600007],
              [-76.99518795499995, 37.28807200700004],
              [-76.98615475199995, 37.26898834800005],
              [-76.98167883999992, 37.24917226800005],
              [-76.97321529899995, 37.23997630400004],
              [-76.95067298099991, 37.23517487200007],
              [-76.91356360599991, 37.21283600500004],
              [-76.89370683499993, 37.20648834800005],
              [-76.80186926999994, 37.20648834800005],
              [-76.78770911399994, 37.200100002000056],
              [-76.76280842099993, 37.16425538500005],
              [-76.73966803799993, 37.15657428500003],
              [-76.71799497799992, 37.15001382100007],
              [-76.68911699099993, 37.18862539300005],
              [-76.66997219299992, 37.18500734700007],
              [-76.66628434099994, 37.14729656500003],
              [-76.6553371249999, 37.10512134700008],
              [-76.6731485439999, 37.06713812700008],
              [-76.65974336199992, 37.04331010800007],
              [-76.63816695199995, 37.03902894600009],
              [-76.5716039699999, 37.02773672100005],
              [-76.5716039699999, 37.021470445000034],
              [-76.58120683499993, 37.01585521000004],
              [-76.58409583199995, 37.013739325000074],
              [-76.58584550699993, 37.007879950000074],
              [-76.57966061099995, 37.003973700000074],
              [-76.5664770169999, 37.00291575700004],
              [-76.5579320949999, 37.000433661000045],
              [-76.55109615799995, 36.99664948100008],
              [-76.53746497299994, 36.986761786000045],
              [-76.51354392299993, 36.965187022000066],
              [-76.49472187499993, 36.95398598100007],
              [-76.49290930899991, 36.943426825000074],
              [-76.49103756399995, 36.93317291900007],
              [-76.48159745999993, 36.921535549000055],
              [-76.47598222599993, 36.907904364000046],
              [-76.48192298099991, 36.89858633000006],
              [-76.49583899599992, 36.88735586100006],
              [-76.52440344999991, 36.87067291900007],
              [-76.52440344999991, 36.86322663000004],
              [-76.4973852199999, 36.865220445000034],
              [-76.47598222599993, 36.87518952000005],
              [-76.45653235599991, 36.887884833000044],
              [-76.43504798099991, 36.89801666900007],
              [-76.40884355399993, 36.902044989000046],
              [-76.38068600199995, 36.90062083500004],
              [-76.35407467399995, 36.89435455900008],
              [-76.33263098899994, 36.88373444200005],
              [-76.33495032499991, 36.87181224200009],
              [-76.32481848899994, 36.86050039300005],
              [-76.30833899599992, 36.85224030200004],
              [-76.29165605399993, 36.84955475500004],
              [-76.30996660099993, 36.870428778000075],
              [-76.31773841099994, 36.88353099200009],
              [-76.31525631399995, 36.894598700000074],
              [-76.30101477799991, 36.91160716400009],
              [-76.30626380099994, 36.917629299000055],
              [-76.32836609999993, 36.929285965000076],
              [-76.33042585399994, 36.94978747500005],
              [-76.31001452599992, 36.95961205200007],
              [-76.26890134799993, 36.961415367000086],
              [-76.16877193899995, 36.92841217700004],
              [-76.12598559999992, 36.91625241700007],
              [-76.07811438699991, 36.91160716400009],
              [-76.05579919699994, 36.918246442000054],
              [-76.03546916199991, 36.934849333000045],
              [-76.00459196599991, 36.932358398000076],
              [-75.98893008999994, 36.911958542000036],
              [-75.96024079099993, 36.80675355900007],
              [-75.86343339799993, 36.59056224200009],
              [-75.85309811099995, 36.54901764500005],
              [-75.8528539699999, 36.54791901200008],
              [-75.81187903599994, 36.38344961100006],
              [-75.79698645699995, 36.34284088700008],
              [-75.79238847599993, 36.32217031500005],
              [-75.79076087099992, 36.298081773000035],
              [-75.78636633999992, 36.28196849200009],
              [-75.75723222599993, 36.23261139500005],
              [-75.71426347599993, 36.12982819200005],
              [-75.56395423099991, 35.89533112200007],
              [-75.55394446499992, 35.85366445500006],
              [-75.52383378799993, 35.79437897300005],
              [-75.53160559799994, 35.79840729400007],
              [-75.55125891799992, 35.805121161000045],
              [-75.55797278599994, 35.808661200000074],
              [-75.56065833199995, 35.815619208000044],
              [-75.56041419199994, 35.82469310100004],
              [-75.56163489499994, 35.83258698100008],
              [-75.58360755099994, 35.843817450000074],
              [-75.58946692599994, 35.86204661700009],
              [-75.59215247299994, 35.89744700700004],
              [-75.60700436099995, 35.923814195000034],
              [-75.67536373599995, 35.99990469000005],
              [-75.68154863199993, 35.99990469000005],
              [-75.69448808499993, 35.99355703300006],
              [-75.70978756399995, 35.99778880400004],
              [-75.71947180899991, 36.00999583500004],
              [-75.71568762899994, 36.02716705900008],
              [-75.70742753799993, 36.016506252000056],
              [-75.69896399599992, 36.014960028000075],
              [-75.67536373599995, 36.02094147300005],
              [-75.67979895699995, 36.03668854400007],
              [-75.68716386599993, 36.050034898000035],
              [-75.69692949099993, 36.05560944200005],
              [-75.70885169199994, 36.04828522300005],
              [-75.72354081899994, 36.05882396000004],
              [-75.73078365799995, 36.07489655200004],
              [-75.73558508999992, 36.092962958000044],
              [-75.74299068899995, 36.10976797100005],
              [-75.74299068899995, 36.116522528000075],
              [-75.73863684799994, 36.14118073100008],
              [-75.74901282499991, 36.17161692900004],
              [-75.76317298099991, 36.201239325000074],
              [-75.77367102799991, 36.234035549000055],
              [-75.80166581899994, 36.27903880400004],
              [-75.81529700399994, 36.29124583500004],
              [-75.81847083199995, 36.29677969000005],
              [-75.81700598899994, 36.30023834800005],
              [-75.81383216099994, 36.30174388200004],
              [-75.81187903599994, 36.30149974200009],
              [-75.81867428299995, 36.32884349200009],
              [-75.82485917899993, 36.39427317900004],
              [-75.82811438699991, 36.407538153000075],
              [-75.84215247299994, 36.43203359600005],
              [-75.84536699099993, 36.449204820000034],
              [-75.85968990799995, 36.47345612200007],
              [-75.86709550699993, 36.50755442900004],
              [-75.88084876199991, 36.54254791900007],
              [-75.88011633999992, 36.54791901200008],
              [-75.8806453119999, 36.549261786000045],
              [-75.88573157499991, 36.56244538000004],
              [-75.88390051999994, 36.57404205900008],
              [-75.88023841099994, 36.58470286700009],
              [-75.88011633999992, 36.59634023600006],
              [-75.88402258999992, 36.60447825700004],
              [-75.89561926999994, 36.61676666900007],
              [-75.90062415299991, 36.624253648000035],
              [-75.91766823899991, 36.67966395000008],
              [-75.92788652299993, 36.70620351800005],
              [-75.93517005099994, 36.712103583000044],
              [-75.94688880099994, 36.718451239000046],
              [-75.95783443899995, 36.71942780200004],
              [-75.96271725199995, 36.70929596600007],
              [-75.97569739499994, 36.60626862200007],
              [-75.96825110599991, 36.551662502000056],
              [-75.96690833199995, 36.54979075700004],
              [-75.96198482999995, 36.542954820000034],
              [-75.94981848899994, 36.54336172100005],
              [-75.94298255099994, 36.54962799700007],
              [-75.94220943899995, 36.55036041900007],
              [-75.94904537699995, 36.56159088700008],
              [-75.93224036399994, 36.570379950000074],
              [-75.91429602799991, 36.575873114000046],
              [-75.9089656239999, 36.54942454600007],
              [-75.90880286399994, 36.54865143400008],
              [-75.90807044199994, 36.52122630400004],
              [-75.90534420499995, 36.51190827000005],
              [-75.90111243399991, 36.50287506700005],
              [-75.90111243399991, 36.49603913000004],
              [-75.91120357999995, 36.49331289300005],
              [-75.95213782499991, 36.49331289300005],
              [-75.97288977799991, 36.499701239000046],
              [-75.97667395699995, 36.51382070500006],
              [-75.97842363199993, 36.52789948100008],
              [-76.00658118399991, 36.54181549700007],
              [-76.01325436099995, 36.55015696800007],
              [-76.04458574099993, 36.589504299000055],
              [-76.04393469999991, 36.57575104400007],
              [-76.03990637899994, 36.56732819200005],
              [-76.03482011599993, 36.55955638200004],
              [-76.03172766799992, 36.55027903900009],
              [-76.03091386599993, 36.54791901200008],
              [-76.03091386599993, 36.53587474200009],
              [-76.03693600199995, 36.51675039300005],
              [-76.0371801419999, 36.50079987200007],
              [-76.02904212099992, 36.48029205900008],
              [-76.01170813699991, 36.460598049000055],
              [-75.98989824099993, 36.443793036000045],
              [-75.96825110599991, 36.432521877000056],
              [-75.98582923099991, 36.42527903900009],
              [-75.97370357999995, 36.40106842700004],
              [-75.94871985599991, 36.37518952000005],
              [-75.92788652299993, 36.36359284100007],
              [-75.93687903599994, 36.37221914300005],
              [-75.94310462099992, 36.37958405200004],
              [-75.94688880099994, 36.38751862200007],
              [-75.94904537699995, 36.397691148000035],
              [-75.9453832669999, 36.39695872600004],
              [-75.93907630099994, 36.40867747600004],
              [-75.93130449099993, 36.42869700700004],
              [-75.91856848899994, 36.429348049000055],
              [-75.91637122299994, 36.40265534100007],
              [-75.92174231699994, 36.356756903000075],
              [-75.91283118399991, 36.34129466400009],
              [-75.88044186099995, 36.30068594000005],
              [-75.87336178299995, 36.28473541900007],
              [-75.86994381399995, 36.27220286700009],
              [-75.81615149599992, 36.15615469000005],
              [-75.81187903599994, 36.14077383000006],
              [-75.8040258449999, 36.12132396000004],
              [-75.7903539699999, 36.099269924000055],
              [-75.78551184799994, 36.08161041900007],
              [-75.80443274599992, 36.07558828300006],
              [-75.82115637899994, 36.08266836100006],
              [-75.8379613919999, 36.09780508000006],
              [-75.86339270699995, 36.12710195500006],
              [-75.86839758999992, 36.13666413000004],
              [-75.86644446499992, 36.14545319200005],
              [-75.86204993399991, 36.15371328300006],
              [-75.85968990799995, 36.16156647300005],
              [-75.86221269399994, 36.17177969000005],
              [-75.86807206899994, 36.18301015800006],
              [-75.88011633999992, 36.19912344000005],
              [-75.90257727799991, 36.21430084800005],
              [-75.90807044199994, 36.219631252000056],
              [-75.91030839799993, 36.22614166900007],
              [-75.91104081899994, 36.24038320500006],
              [-75.91429602799991, 36.24689362200007],
              [-75.92845618399991, 36.25527578300006],
              [-75.94298255099994, 36.26044342700004],
              [-75.94823157499991, 36.26911041900007],
              [-75.93472245999993, 36.28782786700009],
              [-75.96174068899995, 36.30695221600007],
              [-75.97655188699991, 36.31403229400007],
              [-75.99620520699995, 36.31517161700009],
              [-75.98717200399994, 36.29987213700008],
              [-75.97614498599995, 36.293036200000074],
              [-75.96666419199994, 36.284369208000044],
              [-75.95836341099994, 36.24677155200004],
              [-75.95107988199993, 36.22760651200008],
              [-75.94969641799992, 36.21206289300005],
              [-75.96271725199995, 36.205959377000056],
              [-75.93716386599993, 36.18504466400009],
              [-75.92300370999993, 36.17682526200008],
              [-75.90807044199994, 36.17182038000004],
              [-75.90807044199994, 36.16498444200005],
              [-75.97887122299994, 36.18317291900007],
              [-75.99962317599994, 36.18545156500005],
              [-76.02041581899994, 36.191473700000074],
              [-76.03746497299994, 36.20579661700009],
              [-76.06167558499993, 36.236314195000034],
              [-76.0696508449999, 36.241522528000075],
              [-76.08779863199993, 36.24559153900009],
              [-76.09609941299993, 36.25063711100006],
              [-76.11359615799995, 36.26732005400004],
              [-76.13341223899994, 36.281683661000045],
              [-76.14948482999995, 36.28896719000005],
              [-76.20225989499994, 36.30149974200009],
              [-76.1934301419999, 36.30581289300005],
              [-76.18614661399994, 36.312933661000045],
              [-76.18610592399995, 36.319647528000075],
              [-76.19884192599994, 36.32265859600005],
              [-76.20856686099995, 36.31712474200009],
              [-76.21739661399994, 36.30524323100008],
              [-76.22215735599991, 36.29328034100007],
              [-76.21934973899994, 36.28782786700009],
              [-76.19676673099991, 36.28339264500005],
              [-76.17438717399995, 36.272650458000044],
              [-76.15485592399995, 36.25918203300006],
              [-76.14085852799991, 36.24689362200007],
              [-76.12474524599992, 36.22313060100004],
              [-76.11440995999993, 36.21112702000005],
              [-76.09015865799995, 36.20058828300006],
              [-76.08023027299993, 36.17715078300006],
              [-76.06851152299993, 36.17182038000004],
              [-76.05736243399991, 36.16876862200007],
              [-76.06346594999991, 36.16201406500005],
              [-76.08556067599994, 36.15070221600007],
              [-76.09707597599993, 36.14728424700007],
              [-76.13341223899994, 36.14447663000004],
              [-76.13341223899994, 36.13703034100007],
              [-76.12657630099994, 36.13703034100007],
              [-76.12657630099994, 36.13080475500004],
              [-76.15807044199994, 36.12982819200005],
              [-76.16812089799993, 36.13080475500004],
              [-76.17796790299991, 36.134019273000035],
              [-76.20938066299993, 36.149725653000075],
              [-76.22618567599994, 36.172756252000056],
              [-76.23265540299991, 36.17796458500004],
              [-76.24176998599995, 36.180975653000075],
              [-76.26988684799994, 36.19912344000005],
              [-76.28526770699995, 36.211818752000056],
              [-76.29198157499991, 36.21271393400008],
              [-76.29165605399993, 36.19912344000005],
              [-76.28722083199995, 36.19037506700005],
              [-76.27912350199995, 36.18146393400008],
              [-76.26927649599992, 36.17454661700009],
              [-76.25999915299991, 36.17182038000004],
              [-76.24864661399994, 36.163397528000075],
              [-76.21385657499991, 36.12323639500005],
              [-76.19542395699995, 36.10976797100005],
              [-76.19542395699995, 36.103501695000034],
              [-76.22012285099993, 36.09951406500005],
              [-76.24449622299994, 36.103949286000045],
              [-76.34943600199995, 36.14199453300006],
              [-76.37743079299992, 36.156236070000034],
              [-76.39403235599991, 36.17796458500004],
              [-76.41038977799991, 36.17430247600004],
              [-76.42772376199991, 36.18301015800006],
              [-76.44542395699995, 36.196193752000056],
              [-76.46300208199995, 36.205959377000056],
              [-76.44994055899991, 36.18260325700004],
              [-76.44237219999991, 36.172308661000045],
              [-76.43504798099991, 36.16498444200005],
              [-76.39915930899991, 36.14862702000005],
              [-76.39403235599991, 36.14077383000006],
              [-76.38312740799995, 36.130113023000035],
              [-76.35789954299992, 36.11737702000005],
              [-76.3301488919999, 36.10700104400007],
              [-76.31151282499991, 36.103501695000034],
              [-76.31151282499991, 36.09609609600005],
              [-76.41173255099994, 36.08295319200005],
              [-76.42821204299992, 36.07558828300006],
              [-76.42821204299992, 36.06810130400004],
              [-76.42491614499994, 36.06777578300006],
              [-76.41454016799992, 36.06810130400004],
              [-76.43594316299993, 36.048163153000075],
              [-76.46764075399994, 36.030910549000055],
              [-76.50031490799995, 36.01862213700008],
              [-76.52440344999991, 36.01349518400008],
              [-76.55870520699995, 36.011419989000046],
              [-76.57725989499994, 36.01239655200004],
              [-76.58926347599993, 36.017238674000055],
              [-76.61754309799994, 36.05369700700004],
              [-76.62682044199994, 36.06195709800005],
              [-76.64366614499994, 36.038397528000075],
              [-76.66665605399993, 36.038397528000075],
              [-76.68700110599991, 36.05609772300005],
              [-76.70103919199994, 36.110541083000044],
              [-76.72451738199993, 36.15534088700008],
              [-76.72984778599994, 36.181708075000074],
              [-76.71617591099994, 36.22638580900008],
              [-76.71080481699994, 36.236761786000045],
              [-76.69652258999992, 36.250433661000045],
              [-76.68887285099993, 36.25991445500006],
              [-76.67955481699994, 36.287543036000045],
              [-76.68834387899994, 36.30516185100004],
              [-76.70759029899995, 36.31586334800005],
              [-76.72984778599994, 36.32265859600005],
              [-76.72370357999995, 36.31110260600008],
              [-76.70567786399994, 36.294134833000044],
              [-76.70197506399995, 36.28473541900007],
              [-76.70421301999994, 36.271551825000074],
              [-76.71007239499994, 36.263373114000046],
              [-76.72614498599995, 36.25063711100006],
              [-76.74290930899991, 36.231634833000044],
              [-76.75230872299994, 36.21401601800005],
              [-76.75641842399995, 36.19330475500004],
              [-76.75719153599994, 36.12710195500006],
              [-76.7539770169999, 36.116115627000056],
              [-76.73989824099993, 36.09332916900007],
              [-76.73355058499993, 36.06509023600006],
              [-76.72606360599991, 36.05621979400007],
              [-76.71711178299995, 36.04913971600007],
              [-76.70933997299994, 36.04083893400008],
              [-76.70665442599994, 36.02879466400009],
              [-76.70738684799994, 36.01715729400007],
              [-76.70396887899994, 36.00885651200008],
              [-76.68887285099993, 36.00665924700007],
              [-76.69497636599993, 35.99249909100007],
              [-76.72984778599994, 35.95270416900007],
              [-76.72984778599994, 35.94525788000004],
              [-76.59162350199995, 35.94472890800006],
              [-76.56533769399994, 35.93842194200005],
              [-76.5579320949999, 35.93842194200005],
              [-76.52562415299991, 35.955145575000074],
              [-76.47301184799994, 35.972357489000046],
              [-76.42023678299995, 35.98126862200007],
              [-76.38727779899995, 35.97313060100004],
              [-76.38316809799994, 35.96312083500004],
              [-76.38442949099993, 35.95307038000004],
              [-76.38703365799995, 35.94440338700008],
              [-76.38727779899995, 35.93842194200005],
              [-76.3801977199999, 35.93203359600005],
              [-76.37303626199991, 35.93496328300006],
              [-76.36436926999994, 35.94135163000004],
              [-76.35313880099994, 35.94525788000004],
              [-76.33165442599994, 35.941839911000045],
              [-76.28921464799993, 35.925848700000074],
              [-76.2637426419999, 35.92475006700005],
              [-76.27696692599994, 35.937486070000034],
              [-76.29792232999995, 35.94721100500004],
              [-76.30679277299993, 35.95783112200007],
              [-76.28416907499991, 35.97313060100004],
              [-76.19542395699995, 35.99363841400009],
              [-76.09984290299991, 35.99990469000005],
              [-76.07591712099992, 35.995021877000056],
              [-76.04832923099991, 35.983710028000075],
              [-76.0293676419999, 35.96869538000004],
              [-76.03091386599993, 35.95270416900007],
              [-76.05308997299994, 35.96263255400004],
              [-76.06403561099995, 35.95327383000006],
              [-76.07192949099993, 35.91852448100008],
              [-76.03766842399995, 35.92910390800006],
              [-76.02354895699995, 35.93158600500004],
              [-76.03246008999992, 35.90965403900009],
              [-76.04588782499991, 35.88861725500004],
              [-76.06358801999994, 35.87368398600006],
              [-76.08556067599994, 35.87010325700004],
              [-76.08556067599994, 35.863267320000034],
              [-76.06314042899993, 35.84804922100005],
              [-76.05113684799994, 35.819240627000056],
              [-76.05630449099993, 35.793402411000045],
              [-76.08556067599994, 35.78693268400008],
              [-76.11245683499993, 35.794582424000055],
              [-76.12417558499993, 35.794582424000055],
              [-76.11660722599993, 35.78388092700004],
              [-76.10496985599991, 35.77716705900008],
              [-76.08922278599994, 35.77179596600007],
              [-76.07262122299994, 35.76837799700007],
              [-76.05825761599993, 35.76776764500005],
              [-76.06509355399993, 35.76776764500005],
              [-76.05675208199995, 35.76154205900008],
              [-76.04727128799993, 35.74945709800005],
              [-76.04246985599991, 35.73769765800006],
              [-76.04800370999993, 35.73236725500004],
              [-76.05825761599993, 35.72646719000005],
              [-76.05353756399995, 35.71381256700005],
              [-76.04328365799995, 35.702053127000056],
              [-76.0371801419999, 35.69879791900007],
              [-76.05426998599995, 35.68390534100007],
              [-76.08454342399995, 35.68891022300005],
              [-76.11705481699994, 35.698879299000055],
              [-76.14085852799991, 35.69879791900007],
              [-76.12360592399995, 35.673529364000046],
              [-76.09996497299994, 35.66518789300005],
              [-76.07274329299992, 35.66673411700009],
              [-76.04458574099993, 35.671535549000055],
              [-76.04539954299992, 35.66828034100007],
              [-76.04450436099995, 35.66396719000005],
              [-76.04181881399995, 35.65835195500006],
              [-76.0371801419999, 35.65102773600006],
              [-76.03091386599993, 35.65102773600006],
              [-75.99486243399991, 35.73029205900008],
              [-75.98997962099992, 35.76398346600007],
              [-75.98997962099992, 35.88690827000005],
              [-75.98241126199991, 35.895819403000075],
              [-75.94920813699991, 35.91437409100007],
              [-75.94155839799993, 35.92161692900004],
              [-75.93492591099994, 35.92487213700008],
              [-75.92039954299992, 35.91274648600006],
              [-75.90062415299991, 35.89004140800006],
              [-75.8762914699999, 35.87913646000004],
              [-75.87022864499994, 35.87759023600006],
              [-75.86143958199995, 35.88068268400008],
              [-75.85924231699994, 35.88751862200007],
              [-75.86245683499993, 35.89435455900008],
              [-75.88255774599992, 35.90180084800005],
              [-75.89378821499992, 35.91250234600005],
              [-75.90265865799995, 35.925848700000074],
              [-75.90807044199994, 35.93842194200005],
              [-75.88727779899995, 35.934027411000045],
              [-75.86603756399995, 35.92649974200009],
              [-75.84496008999992, 35.92324453300006],
              [-75.82485917899993, 35.93158600500004],
              [-75.8340551419999, 35.93862539300005],
              [-75.84406490799995, 35.94293854400007],
              [-75.85496985599991, 35.94505442900004],
              [-75.86709550699993, 35.94525788000004],
              [-75.86074785099993, 35.952785549000055],
              [-75.85631262899994, 35.961004950000074],
              [-75.85366777299993, 35.97011953300006],
              [-75.8528539699999, 35.97996653900009],
              [-75.81891842399995, 35.96051666900007],
              [-75.79051673099991, 35.932521877000056],
              [-75.74299068899995, 35.87010325700004],
              [-75.74299068899995, 35.85687897300005],
              [-75.72614498599995, 35.83608633000006],
              [-75.72183183499993, 35.82916901200008],
              [-75.72203528599994, 35.81073639500005],
              [-75.72956295499995, 35.79629140800006],
              [-75.73843339799993, 35.782863674000055],
              [-75.74299068899995, 35.76776764500005],
              [-75.74010169199994, 35.75828685100004],
              [-75.72622636599993, 35.74038320500006],
              [-75.72183183499993, 35.72614166900007],
              [-75.72085527299993, 35.70502350500004],
              [-75.72492428299995, 35.69822825700004],
              [-75.74982662699995, 35.69879791900007],
              [-75.77342688699991, 35.696926174000055],
              [-75.77358964799993, 35.68976471600007],
              [-75.76341712099992, 35.671535549000055],
              [-75.74095618399991, 35.643011786000045],
              [-75.73961341099994, 35.63263580900008],
              [-75.75381425699993, 35.61180247600004],
              [-75.75829016799992, 35.60724518400008],
              [-75.76439368399991, 35.60390859600005],
              [-75.77334550699993, 35.60260651200008],
              [-75.78233801999994, 35.59918854400007],
              [-75.78335527299993, 35.591131903000075],
              [-75.78205318899995, 35.58222077000005],
              [-75.78392493399991, 35.57591380400004],
              [-75.79503333199995, 35.57094961100006],
              [-75.80833899599992, 35.56883372600004],
              [-75.8391820949999, 35.56850820500006],
              [-75.8391820949999, 35.57591380400004],
              [-75.82591712099992, 35.58087799700007],
              [-75.81867428299995, 35.582098700000074],
              [-75.81956946499992, 35.58612702000005],
              [-75.82091223899994, 35.589544989000046],
              [-75.82262122299994, 35.592678127000056],
              [-75.82485917899993, 35.595770575000074],
              [-75.84947669199994, 35.58706289300005],
              [-75.86644446499992, 35.59564850500004],
              [-75.87804114499994, 35.61473216400009],
              [-75.88634192599994, 35.63735586100006],
              [-75.89439856699994, 35.62201569200005],
              [-75.89533443899995, 35.60455963700008],
              [-75.89452063699991, 35.58893463700008],
              [-75.89720618399991, 35.57904694200005],
              [-75.95445716099994, 35.53034088700008],
              [-75.95933997299994, 35.528225002000056],
              [-75.97789466099994, 35.52521393400008],
              [-75.97940019399994, 35.51972077000005],
              [-75.97655188699991, 35.512925523000035],
              [-75.97569739499994, 35.507025458000044],
              [-75.97280839799993, 35.50214264500005],
              [-75.97321529899995, 35.49713776200008],
              [-75.97915605399993, 35.48969147300005],
              [-75.98542232999995, 35.48615143400008],
              [-76.01056881399995, 35.47907135600008],
              [-76.00332597599993, 35.46503327000005],
              [-76.00885982999995, 35.45604075700004],
              [-76.01842200399994, 35.44916413000004],
              [-76.02354895699995, 35.44122955900008],
              [-76.02464758999992, 35.42731354400007],
              [-76.02822831899994, 35.41933828300006],
              [-76.03477942599994, 35.41815827000005],
              [-76.04458574099993, 35.42450592700004],
              [-76.0371801419999, 35.431341864000046],
              [-76.05614173099991, 35.441473700000074],
              [-76.07103430899991, 35.42723216400009],
              [-76.07599850199995, 35.40485260600008],
              [-76.06509355399993, 35.390326239000046],
              [-76.06509355399993, 35.38418203300006],
              [-76.07974199099993, 35.38296133000006],
              [-76.11827551999994, 35.37278880400004],
              [-76.12999426999994, 35.36615631700005],
              [-76.14244544199994, 35.35248444200005],
              [-76.15038001199991, 35.34715403900009],
              [-76.21812903599994, 35.348863023000035],
              [-76.23574785099993, 35.353216864000046],
              [-76.24644934799994, 35.37201569200005],
              [-76.25348873599995, 35.37372467700004],
              [-76.26048743399991, 35.370021877000056],
              [-76.2637426419999, 35.35932038000004],
              [-76.26870683499993, 35.34837474200009],
              [-76.28018144399994, 35.35073476800005],
              [-76.31065833199995, 35.36766185100004],
              [-76.32433020699995, 35.393744208000044],
              [-76.33263098899994, 35.403998114000046],
              [-76.35533606699994, 35.41347890800006],
              [-76.36351477799991, 35.40521881700005],
              [-76.36375891799992, 35.39142487200007],
              [-76.36302649599992, 35.38418203300006],
              [-76.35562089799993, 35.37767161700009],
              [-76.35240637899994, 35.36359284100007],
              [-76.35716712099992, 35.34951406500005],
              [-76.37360592399995, 35.34316640800006],
              [-76.37962805899991, 35.35325755400004],
              [-76.39403235599991, 35.36245351800005],
              [-76.40294348899994, 35.36517975500004],
              [-76.41026770699995, 35.36432526200008],
              [-76.41616777299993, 35.36603424700007],
              [-76.42076575399994, 35.37669505400004],
              [-76.37975012899994, 35.37669505400004],
              [-76.37975012899994, 35.38418203300006],
              [-76.38849850199995, 35.39232005400004],
              [-76.39268958199995, 35.40900299700007],
              [-76.39403235599991, 35.44122955900008],
              [-76.40233313699991, 35.45962148600006],
              [-76.41832434799994, 35.464504299000055],
              [-76.42886308499993, 35.457017320000034],
              [-76.42076575399994, 35.43817780200004],
              [-76.44249426999994, 35.403998114000046],
              [-76.45400956899994, 35.410142320000034],
              [-76.46556555899991, 35.41128164300005],
              [-76.47581946499992, 35.40729401200008],
              [-76.48346920499995, 35.397772528000075],
              [-76.47642981699994, 35.39443594000005],
              [-76.47069251199991, 35.38979726800005],
              [-76.46617591099994, 35.38385651200008],
              [-76.46300208199995, 35.37669505400004],
              [-76.49836178299995, 35.39134349200009],
              [-76.51183020699995, 35.40102773600006],
              [-76.52440344999991, 35.417669989000046],
              [-76.51545162699995, 35.41909414300005],
              [-76.51065019399994, 35.42129140800006],
              [-76.50767981699994, 35.425034898000035],
              [-76.50389563699991, 35.431341864000046],
              [-76.54605058499993, 35.44521719000005],
              [-76.56012936099995, 35.45587799700007],
              [-76.54491126199991, 35.466050523000035],
              [-76.54491126199991, 35.47223541900007],
              [-76.56444251199991, 35.48387278900009],
              [-76.57518469999991, 35.49746328300006],
              [-76.57066809799994, 35.50861237200007],
              [-76.54491126199991, 35.51325104400007],
              [-76.49469967399995, 35.50678131700005],
              [-76.47789466099994, 35.51386139500005],
              [-76.46300208199995, 35.54116445500006],
              [-76.48892167899993, 35.536810614000046],
              [-76.51170813699991, 35.53766510600008],
              [-76.5579320949999, 35.548041083000044],
              [-76.58495032499991, 35.549709377000056],
              [-76.60594641799992, 35.54246653900009],
              [-76.64732825399994, 35.520697333000044],
              [-76.63198808499993, 35.51748281500005],
              [-76.62075761599993, 35.51080963700008],
              [-76.6126195949999, 35.50214264500005],
              [-76.60631262899994, 35.49274323100008],
              [-76.61632239499994, 35.471136786000045],
              [-76.61998450399994, 35.466050523000035],
              [-76.60578365799995, 35.452460028000075],
              [-76.59919186099995, 35.44773997600004],
              [-76.59268144399994, 35.44432200700004],
              [-76.59268144399994, 35.43817780200004],
              [-76.59825598899994, 35.43549225500004],
              [-76.60106360599991, 35.43235911700009],
              [-76.60301673099991, 35.42865631700005],
              [-76.60631262899994, 35.42450592700004],
              [-76.59630286399994, 35.421128648000035],
              [-76.58844967399995, 35.416896877000056],
              [-76.58267167899993, 35.41128164300005],
              [-76.57900956899994, 35.403998114000046],
              [-76.59976152299993, 35.39508698100008],
              [-76.62877356699994, 35.39996979400007],
              [-76.65001380099994, 35.415350653000075],
              [-76.64732825399994, 35.43817780200004],
              [-76.65660559799994, 35.43667226800005],
              [-76.66421464799993, 35.43423086100006],
              [-76.67039954299992, 35.43036530200004],
              [-76.67520097599993, 35.42450592700004],
              [-76.70433508999992, 35.43036530200004],
              [-76.75841223899994, 35.418850002000056],
              [-76.78107662699995, 35.42788320500006],
              [-76.80199133999992, 35.44489166900007],
              [-76.82184811099995, 35.45302969000005],
              [-76.87319902299993, 35.458644924000055],
              [-76.90127519399994, 35.46552155200004],
              [-76.94896399599992, 35.487982489000046],
              [-76.99404863199993, 35.49705638200004],
              [-77.01414954299992, 35.50775788000004],
              [-77.05199133999992, 35.534369208000044],
              [-77.03579667899993, 35.50385163000004],
              [-77.02550208199995, 35.491522528000075],
              [-77.01414954299992, 35.48655833500004],
              [-76.99449622299994, 35.48159414300005],
              [-76.98501542899993, 35.46922435100004],
              [-76.97630774599992, 35.43817780200004],
              [-76.94513912699995, 35.452460028000075],
              [-76.90392005099994, 35.44391510600008],
              [-76.86290442599994, 35.42401764500005],
              [-76.83226477799991, 35.403998114000046],
              [-76.81704667899993, 35.39630768400008],
              [-76.75719153599994, 35.38418203300006],
              [-76.69408118399991, 35.35366445500006],
              [-76.61164303299995, 35.33771393400008],
              [-76.52098548099991, 35.31313711100006],
              [-76.49705969999991, 35.31150950700004],
              [-76.49425208199995, 35.30097077000005],
              [-76.4876195949999, 35.29148997600004],
              [-76.47264563699991, 35.277411200000074],
              [-76.47036699099993, 35.27057526200008],
              [-76.48045813699991, 35.25332265800006],
              [-76.48346920499995, 35.24290599200009],
              [-76.49282792899993, 35.230169989000046],
              [-76.51528886599993, 35.23037344000005],
              [-76.56533769399994, 35.239488023000035],
              [-76.56533769399994, 35.233303127000056],
              [-76.54165605399993, 35.22435130400004],
              [-76.52961178299995, 35.217678127000056],
              [-76.52440344999991, 35.20848216400009],
              [-76.53026282499991, 35.19993724200009],
              [-76.54405676999994, 35.20184967700004],
              [-76.5716039699999, 35.21161530200004],
              [-76.58828691299993, 35.20913320500006],
              [-76.60041256399995, 35.20189036700009],
              [-76.60936438699991, 35.194525458000044],
              [-76.61656653599994, 35.191107489000046],
              [-76.63198808499993, 35.19025299700007],
              [-76.64858964799993, 35.187160549000055],
              [-76.66392981699994, 35.180894273000035],
              [-76.67520097599993, 35.17059967700004],
              [-76.66185462099992, 35.16681549700007],
              [-76.61998450399994, 35.16445547100005],
              [-76.60802161399994, 35.159084377000056],
              [-76.59829667899993, 35.152329820000034],
              [-76.58731035099993, 35.149725653000075],
              [-76.5716039699999, 35.15696849200009],
              [-76.57652747299994, 35.15888092700004],
              [-76.58120683499993, 35.16225820500006],
              [-76.58584550699993, 35.16445547100005],
              [-76.58584550699993, 35.17059967700004],
              [-76.5716039699999, 35.17804596600007],
              [-76.55483964799993, 35.149725653000075],
              [-76.56053626199991, 35.12441640800006],
              [-76.5821020169999, 35.105454820000034],
              [-76.61314856699994, 35.096136786000045],
              [-76.60798092399995, 35.07982005400004],
              [-76.64329993399991, 35.05805084800005],
              [-76.68761145699995, 35.03725820500006],
              [-76.70933997299994, 35.023504950000074],
              [-76.72594153599994, 35.00055573100008],
              [-76.76447506399995, 34.98920319200005],
              [-76.80776933499993, 34.98725006700005],
              [-76.83910071499992, 34.99249909100007],
              [-76.87364661399994, 35.008693752000056],
              [-76.90119381399995, 35.02724844000005],
              [-76.94627844999991, 35.06858958500004],
              [-76.95954342399995, 35.07501862200007],
              [-76.99624589799993, 35.08763255400004],
              [-77.04336503799993, 35.14362213700008],
              [-77.07933508999992, 35.15696849200009],
              [-77.03673255099994, 35.099310614000046],
              [-77.03490149599992, 35.08869049700007],
              [-77.01537024599992, 35.08087799700007],
              [-76.99937903599994, 35.062160549000055],
              [-76.97630774599992, 35.01976146000004],
              [-76.94025631399995, 34.979803778000075],
              [-76.89915930899991, 34.964056708000044],
              [-76.85407467399995, 34.95742422100005],
              [-76.80557206899994, 34.94472890800006],
              [-76.7708227199999, 34.92422109600005],
              [-76.76610266799992, 34.917222398000035],
              [-76.76195227799991, 34.91242096600007],
              [-76.75719153599994, 34.90989817900004],
              [-76.74998938699991, 34.91156647300005],
              [-76.73997962099992, 34.92177969000005],
              [-76.71336829299992, 34.92987702000005],
              [-76.69570878799993, 34.943345445000034],
              [-76.67894446499992, 34.95937734600005],
              [-76.66152910099993, 34.97260163000004],
              [-76.64244544199994, 34.98383209800005],
              [-76.63182532499991, 34.98704661700009],
              [-76.61998450399994, 34.98627350500004],
              [-76.61058508999992, 34.980454820000034],
              [-76.60260982999995, 34.97101471600007],
              [-76.59740149599992, 34.962225653000075],
              [-76.59609941299993, 34.958319403000075],
              [-76.57848059799994, 34.950425523000035],
              [-76.55532792899993, 34.936712958000044],
              [-76.53986568899995, 34.932074286000045],
              [-76.54491126199991, 34.95148346600007],
              [-76.5664770169999, 34.97919342700004],
              [-76.56859290299991, 34.99323151200008],
              [-76.54824785099993, 34.999335028000075],
              [-76.53359941299993, 34.99941640800006],
              [-76.51829993399991, 34.997300523000035],
              [-76.5032445949999, 34.989569403000075],
              [-76.48961341099994, 34.97260163000004],
              [-76.48363196499992, 34.98712799700007],
              [-76.48289954299992, 35.001654364000046],
              [-76.48399817599994, 35.015285549000055],
              [-76.48346920499995, 35.02724844000005],
              [-76.47695878799993, 35.041083075000074],
              [-76.46515865799995, 35.059800523000035],
              [-76.45376542899993, 35.07339101800005],
              [-76.44871985599991, 35.071600653000075],
              [-76.44652258999992, 35.06720612200007],
              [-76.43716386599993, 35.05491771000004],
              [-76.43504798099991, 35.05117422100005],
              [-76.43618730399993, 35.041449286000045],
              [-76.44131425699993, 35.02562083500004],
              [-76.44249426999994, 35.01666901200008],
              [-76.42446855399993, 34.99591705900008],
              [-76.41885331899994, 34.98651764500005],
              [-76.42414303299995, 34.98086172100005],
              [-76.45030676999994, 34.96954987200007],
              [-76.45783443899995, 34.97016022300005],
              [-76.46434485599991, 34.968451239000046],
              [-76.46914628799993, 34.958319403000075],
              [-76.46955318899995, 34.94993724200009],
              [-76.46666419199994, 34.94428131700005],
              [-76.46182206899994, 34.94057851800005],
              [-76.45612545499995, 34.93789297100005],
              [-76.43976803299995, 34.938666083000044],
              [-76.39610755099994, 34.95014069200005],
              [-76.38727779899995, 34.94806549700007],
              [-76.37755286399994, 34.96580638200004],
              [-76.35627193899995, 34.971991278000075],
              [-76.33486894399994, 34.973089911000045],
              [-76.32518469999991, 34.97573476800005],
              [-76.32823645699995, 34.99115631700005],
              [-76.3450414699999, 35.01227448100008],
              [-76.35313880099994, 35.02724844000005],
              [-76.32217363199993, 35.01992422100005],
              [-76.30663001199991, 35.003119208000044],
              [-76.29352779899995, 34.984808661000045],
              [-76.26988684799994, 34.97260163000004],
              [-76.26988684799994, 34.96515534100007],
              [-76.27940833199995, 34.95966217700004],
              [-76.29352779899995, 34.943793036000045],
              [-76.30467688699991, 34.93789297100005],
              [-76.32046464799993, 34.937486070000034],
              [-76.33202063699991, 34.94114817900004],
              [-76.34040279899995, 34.93968333500004],
              [-76.34626217399995, 34.92422109600005],
              [-76.34410559799994, 34.914048570000034],
              [-76.33775794199994, 34.90778229400007],
              [-76.33568274599992, 34.89948151200008],
              [-76.34626217399995, 34.883246161000045],
              [-76.35484778599994, 34.87742747600004],
              [-76.39403235599991, 34.86273834800005],
              [-76.39590410099993, 34.86815013200004],
              [-76.40025794199994, 34.87759023600006],
              [-76.40147864499994, 34.883246161000045],
              [-76.40778561099995, 34.883246161000045],
              [-76.41120357999995, 34.87567780200004],
              [-76.41173255099994, 34.858710028000075],
              [-76.41454016799992, 34.84906647300005],
              [-76.42064368399991, 34.839544989000046],
              [-76.42658443899995, 34.83372630400004],
              [-76.44249426999994, 34.82176341400009],
              [-76.47598222599993, 34.78705475500004],
              [-76.48302161399994, 34.78261953300006],
              [-76.49014238199993, 34.77924225500004],
              [-76.49718176999994, 34.774603583000044],
              [-76.50389563699991, 34.76654694200005],
              [-76.50389563699991, 34.76117584800005],
              [-76.50064042899993, 34.755113023000035],
              [-76.49909420499995, 34.748114325000074],
              [-76.50389563699991, 34.73981354400007],
              [-76.51276607999995, 34.734361070000034],
              [-76.5227758449999, 34.73191966400009],
              [-76.54491126199991, 34.732407945000034],
              [-76.56623287699995, 34.73851146000004],
              [-76.58356686099995, 34.751288153000075],
              [-76.58824622299994, 34.76658763200004],
              [-76.5716039699999, 34.78082916900007],
              [-76.59333248599995, 34.79677969000005],
              [-76.60753333199995, 34.81391022300005],
              [-76.61595618399991, 34.816066799000055],
              [-76.62218176999994, 34.73102448100008],
              [-76.63296464799993, 34.70917389500005],
              [-76.65819251199991, 34.721869208000044],
              [-76.66510982999995, 34.741522528000075],
              [-76.66698157499991, 34.76776764500005],
              [-76.6712133449999, 34.79083893400008],
              [-76.68521074099993, 34.80072663000004],
              [-76.70978756399995, 34.796576239000046],
              [-76.73460852799991, 34.78587474200009],
              [-76.75617428299995, 34.770819403000075],
              [-76.7708227199999, 34.75348541900007],
              [-76.75479081899994, 34.75413646000004],
              [-76.74571692599994, 34.75657786700009],
              [-76.73741614499994, 34.76068756700005],
              [-76.72984778599994, 34.76654694200005],
              [-76.70807857999995, 34.738267320000034],
              [-76.70197506399995, 34.72557200700004],
              [-76.89610755099994, 34.73920319200005],
              [-76.92853756399995, 34.721869208000044],
              [-77.07286536399994, 34.68626536700009],
              [-77.08242753799993, 34.680853583000044],
              [-77.09325110599991, 34.676988023000035],
              [-77.10265051999994, 34.683254299000055],
              [-77.10269120999993, 34.69432200700004],
              [-77.08551998599995, 34.705145575000074],
              [-77.10724850199995, 34.732407945000034],
              [-77.11359615799995, 34.75576406500005],
              [-77.11343339799993, 34.75971100500004],
              [-77.13170325399994, 34.76239655200004],
              [-77.13198808499993, 34.74762604400007],
              [-77.12474524599992, 34.73037344000005],
              [-77.12026933499993, 34.72557200700004],
              [-77.12189693899995, 34.708319403000075],
              [-77.12775631399995, 34.69330475500004],
              [-77.13687089799993, 34.68235911700009],
              [-77.14826412699995, 34.67719147300005],
              [-77.15477454299992, 34.67991771000004],
              [-77.16026770699995, 34.68695709800005],
              [-77.16641191299993, 34.692572333000044],
              [-77.17491614499994, 34.691473700000074],
              [-77.17577063699991, 34.68496328300006],
              [-77.16698157499991, 34.66714101800005],
              [-77.17149817599994, 34.66351959800005],
              [-77.20152747299994, 34.65070221600007],
              [-77.25357011599993, 34.59438711100006],
              [-77.28136145699995, 34.58152903900009],
              [-77.29344641799992, 34.57843659100007],
              [-77.31802324099993, 34.56427643400008],
              [-77.33653723899994, 34.56110260600008],
              [-77.35684160099993, 34.57709381700005],
              [-77.36046301999994, 34.578192450000074],
              [-77.36571204299992, 34.582017320000034],
              [-77.40147864499994, 34.589056708000044],
              [-77.38687089799993, 34.603501695000034],
              [-77.34312903599994, 34.631293036000045],
              [-77.33315995999993, 34.64984772300005],
              [-77.34044348899994, 34.66095612200007],
              [-77.37840735599991, 34.70132070500006],
              [-77.3946020169999, 34.71190013200004],
              [-77.3946020169999, 34.71816640800006],
              [-77.37804114499994, 34.71865469000005],
              [-77.37511145699995, 34.724310614000046],
              [-77.38190670499995, 34.73232656500005],
              [-77.3946020169999, 34.73981354400007],
              [-77.40347245999993, 34.74005768400008],
              [-77.41372636599993, 34.73786041900007],
              [-77.42467200399994, 34.74013906500005],
              [-77.4356176419999, 34.75348541900007],
              [-77.42845618399991, 34.701239325000074],
              [-77.42198645699995, 34.68455638200004],
              [-77.40916907499991, 34.69090403900009],
              [-77.39679928299995, 34.68378327000005],
              [-77.3867895169999, 34.67011139500005],
              [-77.38097083199995, 34.656683661000045],
              [-77.38243567599994, 34.632025458000044],
              [-77.39704342399995, 34.620021877000056],
              [-77.41388912699995, 34.61692942900004],
              [-77.42198645699995, 34.619126695000034],
              [-77.42613684799994, 34.62323639500005],
              [-77.43545488199993, 34.62250397300005],
              [-77.44497636599993, 34.61758047100005],
              [-77.44981848899994, 34.60887278900009],
              [-77.44619706899994, 34.600816148000035],
              [-77.43708248599995, 34.58942291900007],
              [-77.42650305899991, 34.57916901200008],
              [-77.41856848899994, 34.57477448100008],
              [-77.40062415299991, 34.57111237200007],
              [-77.38320878799993, 34.56224192900004],
              [-77.37559973899994, 34.55109284100007],
              [-77.38719641799992, 34.540676174000055],
              [-77.38719641799992, 34.53384023600006],
              [-77.38182532499991, 34.530503648000035],
              [-77.37889563699991, 34.52716705900008],
              [-77.38792883999992, 34.522650458000044],
              [-77.40404212099992, 34.517645575000074],
              [-77.45563717399995, 34.50531647300005],
              [-77.53587805899991, 34.46857330900008],
              [-77.66832434799994, 34.376166083000044],
              [-77.73045813699991, 34.31586334800005],
              [-77.78502356699994, 34.24640534100007],
              [-77.81655839799993, 34.222357489000046],
              [-77.83267167899993, 34.207017320000034],
              [-77.84447180899991, 34.174994208000044],
              [-77.86709550699993, 34.13841380400004],
              [-77.87441972599993, 34.122259833000044],
              [-77.89313717399995, 34.01203034100007],
              [-77.91112219999991, 33.95815664300005],
              [-77.94204667899993, 33.93048737200007],
              [-77.93374589799993, 33.948919989000046],
              [-77.93228105399993, 33.95774974200009],
              [-77.93586178299995, 33.96523672100005],
              [-77.93586178299995, 33.97142161700009],
              [-77.92125403599994, 34.00104401200008],
              [-77.92955481699994, 34.07982005400004],
              [-77.92162024599992, 34.108587958000044],
              [-77.94066321499992, 34.147650458000044],
              [-77.95628821499992, 34.19114817900004],
              [-77.96255449099993, 34.19114817900004],
              [-77.96288001199991, 34.16315338700008],
              [-77.95230058499993, 34.09174225500004],
              [-77.94204667899993, 34.067613023000035],
              [-77.9485570949999, 34.05369700700004],
              [-77.9505102199999, 34.037176825000074],
              [-77.94945227799991, 34.00275299700007],
              [-77.9531957669999, 33.989488023000035],
              [-77.97215735599991, 33.95262278900009],
              [-78.00894120999993, 33.90468984600005],
              [-78.01781165299991, 33.89630768400008],
              [-78.03233801999994, 33.892279364000046],
              [-78.04930579299992, 33.893866278000075],
              [-78.13955644399994, 33.91518789300005],
              [-78.15868079299992, 33.91681549700007],
              [-78.21397864499994, 33.91547272300005],
              [-78.22691809799994, 33.92059967700004],
              [-78.25251217399995, 33.925116278000075],
              [-78.33348548099991, 33.91010163000004],
              [-78.3672582669999, 33.91681549700007],
              [-78.36237545499995, 33.92422109600005],
              [-78.36172441299993, 33.93235911700009],
              [-78.3672582669999, 33.95091380400004],
              [-78.37466386599993, 33.95091380400004],
              [-78.38491777299993, 33.92259349200009],
              [-78.4082738919999, 33.91054922100005],
              [-78.47085527299993, 33.89630768400008],
              [-78.55899003799993, 33.86904531500005],
              [-78.5501195949999, 33.879787502000056],
              [-78.54539954299992, 33.88328685100004],
              [-78.54539954299992, 33.889553127000056],
              [-78.60000566299993, 33.875881252000056],
              [-78.60000566299993, 33.86904531500005],
              [-78.59044348899994, 33.867621161000045],
              [-78.58287512899994, 33.863714911000045],
              [-78.57721920499995, 33.85716380400004],
              [-78.57331295499995, 33.84796784100007],
              [-78.61506100199995, 33.845770575000074],
              [-78.65697180899991, 33.83193594000005],
              [-78.76333574099993, 33.778550523000035],
              [-78.86750240799995, 33.70453522300005],
              [-78.93797766799992, 33.64207591400009],
              [-79.03148352799991, 33.53359609600005],
              [-79.13312740799995, 33.41742584800005],
              [-79.15611731699994, 33.37555573100008],
              [-79.14867102799991, 33.368801174000055],
              [-79.15611731699994, 33.35781484600005],
              [-79.18260657499991, 33.24127838700008],
              [-79.18346106699994, 33.21792226800005],
              [-79.18960527299993, 33.21792226800005],
              [-79.19737708199995, 33.23232656500005],
              [-79.19863847599993, 33.268459377000056],
              [-79.20327714799993, 33.286810614000046],
              [-79.21369381399995, 33.30068594000005],
              [-79.22687740799995, 33.306301174000055],
              [-79.26846269399994, 33.306708075000074],
              [-79.27204342399995, 33.317287502000056],
              [-79.26317298099991, 33.340277411000045],
              [-79.23717200399994, 33.38654205900008],
              [-79.20099850199995, 33.42210521000004],
              [-79.18960527299993, 33.430853583000044],
              [-79.18960527299993, 33.43699778900009],
              [-79.21202551999994, 33.42837148600006],
              [-79.23228919199994, 33.412095445000034],
              [-79.27708899599992, 33.35911692900004],
              [-79.28823808499993, 33.33926015800006],
              [-79.29637610599991, 33.31777578300006],
              [-79.29946855399993, 33.29677969000005],
              [-79.29141191299993, 33.27773672100005],
              [-79.27204342399995, 33.26146067900004],
              [-79.24828040299991, 33.25014883000006],
              [-79.21401933499993, 33.24249909100007],
              [-79.21133378799993, 33.23395416900007],
              [-79.21239173099991, 33.222723700000074],
              [-79.21011308499993, 33.21112702000005],
              [-79.20295162699995, 33.19293854400007],
              [-79.19725501199991, 33.18789297100005],
              [-79.18346106699994, 33.18378327000005],
              [-79.19591223899994, 33.17519765800006],
              [-79.21019446499992, 33.16779205900008],
              [-79.22288977799991, 33.15794505400004],
              [-79.23058020699995, 33.142238674000055],
              [-79.23932857999995, 33.149725653000075],
              [-79.24722245999993, 33.16681549700007],
              [-79.25511633999992, 33.17015208500004],
              [-79.26891028599994, 33.166083075000074],
              [-79.27000891799992, 33.15656159100007],
              [-79.26280676999994, 33.14524974200009],
              [-79.25169837099992, 33.135972398000035],
              [-79.25633704299992, 33.13060130400004],
              [-79.26089433499993, 33.12669505400004],
              [-79.26598059799994, 33.12409088700008],
              [-79.27220618399991, 33.122300523000035],
              [-79.27920488199993, 33.13934967700004],
              [-79.29727128799993, 33.14911530200004],
              [-79.31989498599995, 33.15387604400007],
              [-79.34044348899994, 33.15582916900007],
              [-79.32982337099992, 33.14248281500005],
              [-79.30760657499991, 33.13751862200007],
              [-79.28986568899995, 33.13003164300005],
              [-79.29263261599993, 33.108710028000075],
              [-79.30768795499995, 33.095404364000046],
              [-79.35179602799991, 33.07884349200009],
              [-79.37149003799993, 33.06403229400007],
              [-79.37873287699995, 33.04633209800005],
              [-79.37979081899994, 33.029730536000045],
              [-79.38703365799995, 33.01732005400004],
              [-79.41246497299994, 33.01243724200009],
              [-79.43537350199995, 33.010972398000035],
              [-79.45763098899994, 33.006740627000056],
              [-79.47704016799992, 33.000067450000074],
              [-79.49132239499994, 32.991400458000044],
              [-79.49571692599994, 33.00189850500004],
              [-79.50902258999992, 33.02167389500005],
              [-79.51183020699995, 33.02924225500004],
              [-79.52000891799992, 33.04120514500005],
              [-79.53864498599995, 33.03628164300005],
              [-79.57013912699995, 33.01927317900004],
              [-79.58482825399994, 33.01382070500006],
              [-79.59715735599991, 33.00047435100004],
              [-79.62291419199994, 32.95530833500004],
              [-79.62450110599991, 32.94383372600004],
              [-79.61945553299995, 32.93219635600008],
              [-79.60741126199991, 32.91624583500004],
              [-79.60216223899994, 32.92413971600007],
              [-79.59447180899991, 32.930121161000045],
              [-79.58486894399994, 32.93439362200007],
              [-79.57384192599994, 32.936753648000035],
              [-79.58141028599994, 32.92169830900008],
              [-79.58873450399994, 32.914129950000074],
              [-79.63780676999994, 32.890692450000074],
              [-79.64525305899991, 32.88890208500004],
              [-79.65371660099993, 32.88580963700008],
              [-79.65819251199991, 32.87872955900008],
              [-79.66152910099993, 32.87164948100008],
              [-79.66637122299994, 32.868475653000075],
              [-79.69302324099993, 32.86009349200009],
              [-79.7122289699999, 32.84039948100008],
              [-79.72793535099993, 32.81753164300005],
              [-79.74453691299993, 32.79962799700007],
              [-79.79865475199995, 32.773098049000055],
              [-79.82872473899994, 32.76276276200008],
              [-79.85098222599993, 32.75861237200007],
              [-79.8621313139999, 32.76406484600005],
              [-79.87083899599992, 32.77602773600006],
              [-79.8816625639999, 32.787990627000056],
              [-79.89907792899993, 32.793402411000045],
              [-79.90623938699991, 32.800441799000055],
              [-79.89745032499991, 32.81614817900004],
              [-79.87486731699994, 32.84121328300006],
              [-79.89232337099992, 32.854803778000075],
              [-79.89915930899991, 32.85175202000005],
              [-79.90343176999994, 32.844916083000044],
              [-79.90469316299993, 32.837958075000074],
              [-79.90282141799992, 32.83437734600005],
              [-79.93809973899994, 32.85407135600008],
              [-79.94375566299993, 32.85146719000005],
              [-79.94163977799991, 32.837551174000055],
              [-79.93224036399994, 32.812201239000046],
              [-79.93008378799993, 32.79645416900007],
              [-79.93407141799992, 32.78343333500004],
              [-79.94395911399994, 32.78237539300005],
              [-79.95742753799993, 32.789048570000034],
              [-79.97166907499991, 32.79962799700007],
              [-79.96764075399994, 32.785223700000074],
              [-79.95742753799993, 32.77204010600008],
              [-79.94310462099992, 32.76235586100006],
              [-79.90778561099995, 32.755519924000055],
              [-79.89915930899991, 32.748032945000034],
              [-79.89305579299992, 32.73908112200007],
              [-79.8789770169999, 32.73139069200005],
              [-79.87596594999991, 32.73224518400008],
              [-79.87486731699994, 32.73810455900008],
              [-79.86803137899994, 32.73810455900008],
              [-79.87140865799995, 32.708319403000075],
              [-79.88731848899994, 32.68813711100006],
              [-79.94570878799993, 32.65326569200005],
              [-79.95592200399994, 32.64935944200005],
              [-79.98131262899994, 32.64874909100007],
              [-80.00597083199995, 32.65314362200007],
              [-80.01667232999995, 32.65371328300006],
              [-80.02570553299995, 32.64874909100007],
              [-80.02570553299995, 32.64252350500004],
              [-80.00279700399994, 32.62946198100008],
              [-79.99547278599994, 32.61904531500005],
              [-80.00511633999992, 32.61155833500004],
              [-80.0579320949999, 32.60398997600004],
              [-80.10423743399991, 32.59080638200004],
              [-80.12564042899993, 32.587958075000074],
              [-80.14907792899993, 32.58144765800006],
              [-80.16307532499991, 32.57025788000004],
              [-80.17711341099994, 32.56704336100006],
              [-80.20075436099995, 32.58421458500004],
              [-80.23232988199993, 32.612982489000046],
              [-80.2512914699999, 32.62376536700009],
              [-80.26593990799995, 32.62140534100007],
              [-80.2539770169999, 32.60854726800005],
              [-80.20742753799993, 32.57322825700004],
              [-80.20177161399994, 32.571519273000035],
              [-80.20075436099995, 32.56940338700008],
              [-80.20445716099994, 32.560614325000074],
              [-80.21129309799994, 32.552069403000075],
              [-80.22093665299991, 32.54682038000004],
              [-80.23155676999994, 32.54242584800005],
              [-80.30345618399991, 32.49795156500005],
              [-80.31566321499992, 32.49445221600007],
              [-80.32323157499991, 32.48843008000006],
              [-80.33120683499993, 32.486395575000074],
              [-80.34447180899991, 32.49481842700004],
              [-80.34996497299994, 32.505194403000075],
              [-80.35138912699995, 32.51666901200008],
              [-80.35537675699993, 32.52692291900007],
              [-80.36896725199995, 32.53335195500006],
              [-80.3660375639999, 32.516913153000075],
              [-80.36925208199995, 32.49876536700009],
              [-80.37816321499992, 32.48411692900004],
              [-80.39256751199991, 32.47809479400007],
              [-80.40933183499993, 32.48110586100006],
              [-80.41881262899994, 32.488267320000034],
              [-80.42784583199995, 32.497259833000044],
              [-80.4434301419999, 32.50535716400009],
              [-80.46226966099994, 32.50922272300005],
              [-80.47573808499993, 32.509751695000034],
              [-80.48786373599995, 32.51235586100006],
              [-80.52501380099994, 32.54018789300005],
              [-80.53258216099994, 32.54783763200004],
              [-80.53966223899994, 32.560614325000074],
              [-80.54710852799991, 32.560614325000074],
              [-80.54727128799993, 32.548895575000074],
              [-80.54417883999992, 32.53790924700007],
              [-80.53892981699994, 32.52789948100008],
              [-80.53282630099994, 32.51902903900009],
              [-80.55797278599994, 32.51634349200009],
              [-80.62901770699995, 32.52586497600004],
              [-80.66006425699993, 32.52586497600004],
              [-80.66978919199994, 32.521144924000055],
              [-80.67796790299991, 32.51146067900004],
              [-80.67747962099992, 32.49795156500005],
              [-80.65941321499992, 32.50600820500006],
              [-80.57095292899993, 32.49168528900009],
              [-80.55919348899994, 32.49266185100004],
              [-80.54084225199995, 32.496975002000056],
              [-80.52940833199995, 32.49795156500005],
              [-80.51610266799992, 32.495428778000075],
              [-80.49185136599993, 32.48297760600008],
              [-80.47817949099993, 32.47809479400007],
              [-80.47817949099993, 32.47064850500004],
              [-80.50527910099993, 32.472357489000046],
              [-80.53490149599992, 32.470770575000074],
              [-80.56354732999995, 32.46564362200007],
              [-80.58747311099995, 32.45693594000005],
              [-80.49522864499994, 32.45075104400007],
              [-80.46983801999994, 32.44212474200009],
              [-80.45836341099994, 32.423163153000075],
              [-80.46349036399994, 32.40412018400008],
              [-80.50674394399994, 32.388739325000074],
              [-80.53038489499994, 32.37352122600004],
              [-80.5476781889999, 32.357123114000046],
              [-80.54710852799991, 32.34711334800005],
              [-80.52830969999991, 32.348944403000075],
              [-80.50153561099995, 32.35883209800005],
              [-80.47691809799994, 32.371527411000045],
              [-80.46450761599993, 32.38190338700008],
              [-80.44937089799993, 32.39398834800005],
              [-80.44163977799991, 32.401271877000056],
              [-80.43724524599992, 32.409816799000055],
              [-80.42979895699995, 32.409816799000055],
              [-80.4336645169999, 32.39020416900007],
              [-80.44107011599993, 32.366115627000056],
              [-80.45164954299992, 32.350043036000045],
              [-80.46450761599993, 32.35455963700008],
              [-80.4707738919999, 32.35455963700008],
              [-80.47028561099995, 32.349310614000046],
              [-80.47203528599994, 32.348089911000045],
              [-80.47500566299993, 32.34829336100006],
              [-80.47817949099993, 32.34711334800005],
              [-80.45986894399994, 32.33730703300006],
              [-80.4707738919999, 32.32273997600004],
              [-80.55329342399995, 32.27879466400009],
              [-80.56419837099992, 32.27716705900008],
              [-80.58018958199995, 32.27912018400008],
              [-80.58747311099995, 32.27879466400009],
              [-80.62604732999995, 32.262600002000056],
              [-80.63683020699995, 32.266791083000044],
              [-80.64268958199995, 32.29311758000006],
              [-80.64220130099994, 32.319240627000056],
              [-80.62901770699995, 32.38190338700008],
              [-80.66441809799994, 32.36823151200008],
              [-80.6699926419999, 32.37360260600008],
              [-80.6511938139999, 32.44554271000004],
              [-80.65729732999995, 32.46271393400008],
              [-80.6836645169999, 32.46442291900007],
              [-80.6809789699999, 32.45648834800005],
              [-80.67935136599993, 32.45457591400009],
              [-80.67650305899991, 32.45575592700004],
              [-80.6699926419999, 32.45693594000005],
              [-80.66885331899994, 32.45380280200004],
              [-80.66315670499995, 32.45075104400007],
              [-80.67284094999991, 32.439113674000055],
              [-80.67690995999993, 32.42568594000005],
              [-80.67747962099992, 32.35765208500004],
              [-80.67520097599993, 32.34992096600007],
              [-80.66539466099994, 32.333970445000034],
              [-80.66315670499995, 32.323553778000075],
              [-80.66746985599991, 32.30536530200004],
              [-80.67829342399995, 32.302720445000034],
              [-80.69176184799994, 32.30963776200008],
              [-80.75934811099995, 32.36078522300005],
              [-80.78441321499992, 32.41624583500004],
              [-80.79600989499994, 32.45327383000006],
              [-80.7969457669999, 32.47435130400004],
              [-80.78302975199995, 32.49168528900009],
              [-80.78555253799993, 32.49673086100006],
              [-80.79808508999992, 32.49819570500006],
              [-80.81403561099995, 32.50535716400009],
              [-80.82249915299991, 32.51813385600008],
              [-80.82750403599994, 32.53139883000006],
              [-80.83592688699991, 32.54010651200008],
              [-80.85496985599991, 32.539496161000045],
              [-80.85496985599991, 32.53335195500006],
              [-80.84276282499991, 32.52423737200007],
              [-80.82843990799995, 32.49567291900007],
              [-80.82079016799992, 32.48484935100004],
              [-80.82079016799992, 32.47809479400007],
              [-80.8289281889999, 32.45526764500005],
              [-80.81578528599994, 32.419256903000075],
              [-80.7969457669999, 32.38255442900004],
              [-80.78734290299991, 32.35765208500004],
              [-80.79857337099992, 32.333644924000055],
              [-80.79893958199995, 32.31972890800006],
              [-80.78355872299994, 32.31362539300005],
              [-80.77578691299993, 32.30573151200008],
              [-80.74510657499991, 32.258978583000044],
              [-80.72704016799992, 32.26593659100007],
              [-80.71214758999992, 32.263006903000075],
              [-80.70018469999991, 32.25446198100008],
              [-80.69107011599993, 32.24469635600008],
              [-80.67731686099995, 32.22532786700009],
              [-80.67784583199995, 32.21474844000005],
              [-80.70470130099994, 32.190659898000035],
              [-80.7371313139999, 32.15208567900004],
              [-80.82079016799992, 32.10814036700009],
              [-80.81159420499995, 32.14468008000006],
              [-80.77721106699994, 32.20726146000004],
              [-80.77985592399995, 32.24469635600008],
              [-80.78799394399994, 32.23582591400009],
              [-80.79059811099995, 32.224310614000046],
              [-80.79112708199995, 32.211004950000074],
              [-80.79352779899995, 32.196926174000055],
              [-80.80077063699991, 32.18622467700004],
              [-80.82347571499992, 32.16575755400004],
              [-80.82823645699995, 32.159084377000056],
              [-80.83214270699995, 32.13434479400007],
              [-80.84190833199995, 32.11595286700009],
              [-80.88756262899994, 32.06940338700008],
              [-80.89452063699991, 32.05882396000004],
              [-80.89598548099991, 32.04669830900008],
              [-80.89028886599993, 32.03266022300005],
              [-80.88939368399991, 32.03042226800005],
              [-80.87901770699995, 32.02651601800005],
              [-80.86522376199991, 32.02651601800005],
              [-80.84813391799992, 32.02216217700004],
              [-80.83568274599992, 32.00291575700004],
              [-80.85391191299993, 31.982163804000038],
              [-80.90339107999995, 31.950506903000075],
              [-80.91266842399995, 31.955877997000073],
              [-80.91950436099995, 31.965236721000053],
              [-80.92345130099994, 31.97402578300006],
              [-80.92381751199991, 31.977769273000035],
              [-80.93736731699994, 31.97646719000005],
              [-80.94432532499991, 31.969183661000045],
              [-80.94863847599993, 31.96112702000005],
              [-80.95466061099995, 31.95734284100007],
              [-80.96475175699993, 31.94879791900007],
              [-80.96312415299991, 31.93065013200004],
              [-80.94953365799995, 31.913723049000055],
              [-80.92381751199991, 31.90888092700004],
              [-80.95815995999993, 31.879339911000045],
              [-80.98045813699991, 31.865383205000057],
              [-80.99522864499994, 31.864488023000035],
              [-81.01260331899994, 31.87445709800005],
              [-81.05768795499995, 31.88190338700008],
              [-81.07469641799992, 31.888413804000038],
              [-81.08067786399994, 31.896633205000057],
              [-81.08682206899994, 31.90766022300005],
              [-81.09532630099994, 31.916001695000034],
              [-81.1082250639999, 31.91632721600007],
              [-81.11823482999995, 31.90766022300005],
              [-81.11180579299992, 31.89801666900007],
              [-81.09142005099994, 31.88499583500004],
              [-81.09032141799992, 31.87571849200009],
              [-81.1301977199999, 31.86676666900007],
              [-81.14297441299993, 31.85492584800005],
              [-81.08771725199995, 31.847479559000078],
              [-81.08189856699994, 31.84398021000004],
              [-81.06102454299992, 31.826971747000073],
              [-81.04515540299991, 31.827826239000046],
              [-81.03990637899994, 31.826971747000073],
              [-81.04954993399991, 31.81354401200008],
              [-81.06090247299994, 31.78815338700008],
              [-81.09137936099995, 31.754339911000045],
              [-81.1055395169999, 31.742661851000037],
              [-81.11904863199993, 31.737616278000075],
              [-81.17137610599991, 31.73663971600007],
              [-81.20457923099991, 31.741441148000035],
              [-81.22862708199995, 31.75495026200008],
              [-81.23863684799994, 31.76308828300006],
              [-81.25316321499992, 31.77024974200009],
              [-81.26659094999991, 31.772406317000048],
              [-81.27330481699994, 31.76552969000005],
              [-81.26919511599993, 31.751695054000038],
              [-81.25621497299994, 31.74477773600006],
              [-81.22549394399994, 31.737616278000075],
              [-81.19627844999991, 31.717596747000073],
              [-81.19896399599992, 31.69944896000004],
              [-81.23912512899994, 31.66307200700004],
              [-81.25193865599994, 31.647172896000086],
              [-81.25886506099994, 31.632098470000074],
              [-81.30093339799993, 31.570786851000037],
              [-81.31826995799992, 31.56555293000008],
              [-81.33109136399992, 31.552431020000085],
              [-81.33336581399993, 31.54439652700006],
              [-81.32019641999995, 31.52244691900006],
              [-81.32823718599991, 31.50234233000009],
              [-81.32702173399991, 31.49834238300008],
              [-81.32697315799993, 31.49333135100005],
              [-81.32690522899992, 31.486315816000058],
              [-81.33143251899992, 31.46723435000007],
              [-81.36527667299993, 31.437886972000058],
              [-81.36389932399993, 31.415830010000036],
              [-81.34836936699992, 31.38886731000008],
              [-81.3352302049999, 31.366905606000046],
              [-81.32565726799993, 31.34892851400008],
              [-81.33618268099991, 31.34282002100008],
              [-81.42886308499993, 31.352850653000075],
              [-81.45079505099994, 31.361476955000057],
              [-81.47093665299991, 31.372870184000078],
              [-81.47996985599991, 31.374212958000044],
              [-81.49242102799991, 31.367661851000037],
              [-81.46703040299991, 31.347805080000057],
              [-81.42650305899991, 31.332953192000048],
              [-81.38198808499993, 31.32367584800005],
              [-81.34471594999991, 31.32050202000005],
              [-81.32827714799993, 31.315252997000073],
              [-81.28506425699993, 31.287665106000077],
              [-81.26988684799994, 31.27484772300005],
              [-81.26768958199995, 31.258734442000048],
              [-81.27464758999992, 31.235541083000044],
              [-81.28856360599991, 31.22093333500004],
              [-81.30748450399994, 31.230454820000034],
              [-81.34316972599993, 31.18065013200004],
              [-81.36754309799994, 31.153550523000035],
              [-81.38597571499992, 31.141750393000052],
              [-81.40925045499995, 31.14325592700004],
              [-81.41795813699991, 31.148993231000077],
              [-81.41856848899994, 31.160589911000045],
              [-81.41551673099991, 31.20722077000005],
              [-81.42300370999993, 31.219631252000056],
              [-81.4446508449999, 31.216782945000034],
              [-81.45482337099992, 31.206000067000048],
              [-81.45653235599991, 31.19041575700004],
              [-81.44863847599993, 31.150946356000077],
              [-81.44692949099993, 31.130845445000034],
              [-81.45173092399995, 31.11709219000005],
              [-81.48729407499991, 31.133612372000073],
              [-81.49583899599992, 31.126206773000035],
              [-81.49258378799993, 31.113674221000053],
              [-81.46401933499993, 31.10260651200008],
              [-81.44098873599995, 31.081366278000075],
              [-81.43028723899994, 31.073431708000044],
              [-81.43089758999992, 31.09320709800005],
              [-81.42491614499994, 31.104722398000035],
              [-81.40367591099994, 31.12128327000005],
              [-81.40538489499994, 31.09479401200008],
              [-81.42414303299995, 31.025051174000055],
              [-81.43028723899994, 31.025051174000055],
              [-81.44302324099993, 31.044745184000078],
              [-81.46344967399995, 31.067328192000048],
              [-81.48810787699995, 31.08584219000005],
              [-81.51353919199994, 31.09332916900007],
              [-81.49937903599994, 31.074611721000053],
              [-81.45913652299993, 31.03864166900007],
              [-81.45079505099994, 31.021918036000045],
              [-81.45677649599992, 31.001654364000046],
              [-81.47248287699995, 30.991888739000046],
              [-81.51968339799993, 30.984076239000046],
              [-81.51968339799993, 30.976629950000074],
              [-81.49925696499992, 30.96820709800005],
              [-81.46410071499992, 30.968451239000046],
              [-81.45079505099994, 30.96356842700004],
              [-81.46231035099993, 30.94867584800005],
              [-81.4929906889999, 30.918524481000077],
              [-81.49925696499992, 30.905585028000075],
              [-81.50035559799994, 30.900051174000055],
              [-81.50511633999992, 30.88617584800005],
              [-81.50601152299993, 30.881659247000073],
              [-81.50279700399994, 30.871975002000056],
              [-81.49754798099991, 30.866156317000048],
              [-81.49315344999991, 30.859442450000074],
              [-81.49242102799991, 30.846869208000044],
              [-81.50157630099994, 30.850775458000044],
              [-81.51170813699991, 30.853338934000078],
              [-81.52232825399994, 30.854437567000048],
              [-81.53335527299993, 30.85370514500005],
              [-81.53335527299993, 30.846869208000044],
              [-81.51903235599991, 30.841782945000034],
              [-81.51488196499992, 30.832017320000034],
              [-81.51504472599993, 30.819484768000052],
              [-81.51353919199994, 30.805975653000075],
              [-81.50865637899994, 30.79677969000005],
              [-81.49673417899993, 30.783351955000057],
              [-81.49242102799991, 30.77179596600007],
              [-81.49478105399993, 30.749212958000044],
              [-81.5012914699999, 30.724351304000038],
              [-81.5000300769999, 30.712184963000084],
              [-81.49925696499992, 30.704331773000035],
              [-81.47565670499995, 30.69603099200009],
              [-81.46934973899994, 30.69717031500005],
              [-81.45563717399995, 30.70180898600006],
              [-81.44774329299992, 30.702866929000038],
              [-81.4402563139999, 30.70075104400007],
              [-81.43822180899991, 30.69603099200009],
              [-81.43761145699995, 30.691351630000042],
              [-81.43407141799992, 30.689195054000038],
              [-81.42857825399994, 30.681708075000074],
              [-81.43053137899994, 30.66474030200004],
              [-81.43781490799995, 30.63776276200008],
              [-81.44151770699995, 30.55304596600007],
              [-81.43781490799995, 30.52411530200004],
              [-81.45384680899991, 30.534491278000075],
              [-81.46190344999991, 30.548529364000046],
              [-81.46471106699994, 30.566839911000045],
              [-81.46507727799991, 30.589911200000074],
              [-81.46694902299993, 30.600002346000053],
              [-81.47203528599994, 30.61005280200004],
              [-81.47964433499993, 30.61786530200004],
              [-81.48900305899991, 30.62099844000005],
              [-81.49795488199993, 30.617661851000037],
              [-81.49998938699991, 30.609361070000034],
              [-81.49925696499992, 30.586818752000056],
              [-81.50153561099995, 30.569281317000048],
              [-81.50031490799995, 30.551255601000037],
              [-81.49258378799993, 30.537258205000057],
              [-81.47565670499995, 30.53156159100007],
              [-81.47492428299995, 30.52765534100007],
              [-81.44774329299992, 30.50800202000005],
              [-81.44163977799991, 30.500148830000057],
              [-81.43512936099995, 30.484849351000037],
              [-81.43028723899994, 30.476996161000045],
              [-81.42446855399993, 30.471584377000056],
              [-81.41954505099994, 30.469305731000077],
              [-81.41494706899994, 30.465725002000056],
              [-81.40982011599993, 30.45648834800005],
              [-81.40636145699995, 30.44358958500004],
              [-81.40982011599993, 30.411444403000075],
              [-81.40660559799994, 30.40582916900007],
              [-81.39956620999993, 30.400539455000057],
              [-81.39256751199991, 30.393866278000075],
              [-81.38939368399991, 30.38422272300005],
              [-81.39614824099993, 30.339789130000042],
              [-81.39492753799993, 30.298570054000038],
              [-81.36266028599994, 30.18895091400009],
              [-81.35399329299992, 30.170803127000056],
              [-81.32828630199992, 30.05283010800008],
              [-81.28766842399995, 29.926174221000053],
              [-81.29381262899994, 29.89411041900007],
              [-81.28799394399994, 29.893011786000045],
              [-81.2793853689999, 29.89954946200004],
              [-81.2737610019999, 29.889873650000084],
              [-81.27185220699994, 29.876151150000055],
              [-81.26646887899994, 29.853216864000046],
              [-81.26162675699993, 29.839016018000052],
              [-81.25584876199991, 29.789455471000053],
              [-81.25013011399994, 29.76959159900008],
              [-81.23887919999993, 29.737301167000055],
              [-81.22549394399994, 29.709784247000073],
              [-81.2099665689999, 29.666519134000055],
              [-81.18907630099994, 29.624172268000052],
              [-81.18464107999995, 29.60374583500004],
              [-81.17829342399995, 29.58551666900007],
              [-81.1379609629999, 29.505083211000056],
              [-81.07191437499995, 29.363031525000054],
              [-81.00628734299994, 29.23526970800009],
              [-80.96266758099995, 29.152056322000078],
              [-80.93212259599994, 29.101178684000047],
              [-80.91454985199994, 29.08745048700007],
              [-80.92210852799991, 29.068304755000042],
              [-80.90933183499993, 29.05695221600007],
              [-80.89175370999993, 29.04555898600006],
              [-80.8828832669999, 29.02765534100007],
              [-80.87767493399991, 29.00849030200004],
              [-80.74322501799992, 28.806909903000076],
              [-80.68004309799994, 28.71702708500004],
              [-80.62706458199995, 28.650864976000037],
              [-80.56761633999992, 28.557806708000044],
              [-80.54308020699995, 28.49249909100007],
              [-80.52822831899994, 28.472601630000042],
              [-80.54043535099993, 28.451605536000045],
              [-80.55842037699995, 28.433335679000038],
              [-80.56761633999992, 28.43183014500005],
              [-80.56969153599994, 28.42641836100006],
              [-80.57526607999995, 28.41795482000009],
              [-80.58275305899991, 28.410305080000057],
              [-80.59089107999995, 28.40692780200004],
              [-80.59406490799995, 28.401597398000035],
              [-80.59471594999991, 28.303859768000052],
              [-80.60171464799993, 28.29092031500005],
              [-80.59430904899995, 28.284084377000056],
              [-80.59683183499993, 28.262640692000048],
              [-80.59219316299993, 28.207912502000056],
              [-80.5711156889999, 28.10614655200004],
              [-80.55663001199991, 28.07754140800006],
              [-80.55329342399995, 28.06159088700008],
              [-80.53233801999994, 28.018784898000035],
              [-80.45189368399991, 27.909409898000035],
              [-80.45091712099992, 27.866359768000052],
              [-80.47500566299993, 27.907904364000046],
              [-80.47817949099993, 27.917222398000035],
              [-80.48232988199993, 27.924261786000045],
              [-80.51231848899994, 27.955145575000074],
              [-80.52159583199995, 27.990179755000042],
              [-80.58063717399995, 28.08543528900009],
              [-80.6106664699999, 28.164943752000056],
              [-80.6199438139999, 28.206976630000042],
              [-80.61790930899991, 28.379339911000045],
              [-80.58788001199991, 28.50576406500005],
              [-80.58706620999993, 28.545355536000045],
              [-80.59430904899995, 28.585109768000052],
              [-80.6004125639999, 28.60028717700004],
              [-80.6094457669999, 28.610174872000073],
              [-80.62303626199991, 28.614569403000075],
              [-80.64268958199995, 28.613023179000038],
              [-80.64606686099995, 28.614406643000052],
              [-80.65086829299992, 28.61786530200004],
              [-80.65664628799993, 28.620754299000055],
              [-80.66315670499995, 28.62051015800006],
              [-80.66380774599992, 28.616848049000055],
              [-80.66250566299993, 28.602362372000073],
              [-80.66315670499995, 28.598781643000052],
              [-80.67503821499992, 28.59560781500005],
              [-80.68394934799994, 28.59520091400009],
              [-80.74779212099992, 28.60492584800005],
              [-80.76593990799995, 28.61229075700004],
              [-80.77985592399995, 28.626654364000046],
              [-80.78425045499995, 28.64166901200008],
              [-80.78425045499995, 28.661281643000052],
              [-80.78038489499994, 28.68073151200008],
              [-80.77301998599995, 28.694973049000055],
              [-80.76561438699991, 28.688706773000035],
              [-80.7571508449999, 28.70380280200004],
              [-80.74925696499992, 28.72410716400009],
              [-80.75234941299993, 28.741929429000038],
              [-80.79527747299994, 28.755601304000038],
              [-80.8289281889999, 28.783026434000078],
              [-80.84813391799992, 28.79059479400007],
              [-80.83193925699993, 28.699367580000057],
              [-80.82079016799992, 28.675116278000075],
              [-80.82079016799992, 28.667669989000046],
              [-80.82823645699995, 28.661444403000075],
              [-80.79747473899994, 28.608303127000056],
              [-80.79352779899995, 28.58885325700004],
              [-80.78966223899994, 28.54783763200004],
              [-80.76610266799992, 28.45107656500005],
              [-80.75682532499991, 28.430853583000044],
              [-80.73827063699991, 28.373480536000045],
              [-80.70881100199995, 28.320461330000057],
              [-80.7012426419999, 28.296616929000038],
              [-80.54110673699992, 27.981350002000056],
              [-80.38097083199995, 27.666083075000074],
              [-80.34536699099993, 27.514593817000048],
              [-80.19782467399995, 27.19599030200004],
              [-80.19701087099992, 27.180487372000073],
              [-80.20579993399991, 27.200344143000052],
              [-80.21715247299994, 27.209418036000045],
              [-80.25723222599993, 27.218573309000078],
              [-80.27961178299995, 27.228908596000053],
              [-80.28648841099994, 27.23379140800006],
              [-80.29271399599992, 27.239488023000035],
              [-80.30101477799991, 27.243353583000044],
              [-80.31432044199994, 27.242580471000053],
              [-80.30842037699995, 27.234320380000042],
              [-80.28302975199995, 27.207831122000073],
              [-80.27594967399995, 27.205877997000073],
              [-80.26016191299993, 27.196966864000046],
              [-80.25161699099993, 27.194159247000073],
              [-80.22899329299992, 27.200384833000044],
              [-80.22126217399995, 27.201605536000045],
              [-80.18333899599992, 27.163763739000046],
              [-80.17699133999992, 27.15070221600007],
              [-80.14879309799994, 27.13825104400007],
              [-80.14240475199995, 27.12213776200008],
              [-80.13927161399994, 27.10765208500004],
              [-80.11510169199994, 27.063788153000075],
              [-80.09459387899994, 27.00975169500009],
              [-80.07555091099994, 26.973211981000077],
              [-80.07412675699993, 26.961371161000045],
              [-80.08128821499992, 26.950425523000035],
              [-80.09154212099992, 26.94725169500009],
              [-80.10338294199994, 26.94603099200009],
              [-80.11510169199994, 26.94090403900009],
              [-80.11510169199994, 26.934719143000052],
              [-80.10240637899994, 26.929510809000078],
              [-80.08031165299991, 26.923570054000038],
              [-80.07070878799993, 26.91697825700004],
              [-80.06432044199994, 26.906683661000045],
              [-80.03823808499993, 26.81118398600006],
              [-80.0384008449999, 26.78424713700008],
              [-80.05361894399994, 26.769598700000074],
              [-80.05361894399994, 26.762152411000045],
              [-80.04051673099991, 26.74640534100007],
              [-80.03453528599994, 26.715318101000037],
              [-80.03237870999993, 26.58734772300005],
              [-80.03807532499991, 26.558539130000042],
              [-80.05361894399994, 26.556708075000074],
              [-80.06208248599995, 26.42088450700004],
              [-80.07188880099994, 26.390448309000078],
              [-80.07412675699993, 26.375474351000037],
              [-80.07315019399994, 26.341009833000044],
              [-80.07506262899994, 26.32420482000009],
              [-80.08092200399994, 26.30963776200008],
              [-80.07770748599995, 26.287583726000037],
              [-80.10265051999994, 26.139960028000075],
              [-80.1121313139999, 26.110174872000073],
              [-80.12877356699994, 26.09861888200004],
              [-80.12877356699994, 26.09121328300006],
              [-80.11278235599991, 26.068833726000037],
              [-80.12877356699994, 25.77529531500005],
              [-80.1355688139999, 25.77529531500005],
              [-80.1355688139999, 25.816839911000045],
              [-80.12877356699994, 25.862127997000073],
              [-80.12926184799994, 25.887884833000044],
              [-80.13243567599994, 25.901271877000056],
              [-80.14061438699991, 25.900824286000045],
              [-80.1765844389999, 25.85838450700004],
              [-80.18272864499994, 25.822088934000078],
              [-80.19546464799993, 25.795843817000048],
              [-80.19619706899994, 25.75381094000005],
              [-80.21068274599992, 25.734930731000077],
              [-80.22126217399995, 25.73110586100006],
              [-80.23094641799992, 25.73118724200009],
              [-80.24071204299992, 25.72955963700008],
              [-80.25161699099993, 25.72060781500005],
              [-80.2551977199999, 25.711086330000057],
              [-80.25690670499995, 25.686835028000075],
              [-80.27757727799991, 25.644232489000046],
              [-80.30687415299991, 25.61823151200008],
              [-80.31041419199994, 25.598944403000075],
              [-80.3113500639999, 25.54979075700004],
              [-80.31745357999995, 25.532904364000046],
              [-80.33397376199991, 25.51190827000005],
              [-80.34243730399993, 25.49363841400009],
              [-80.34430904899995, 25.47524648600006],
              [-80.34105383999992, 25.45376211100006],
              [-80.33649654899995, 25.44822825700004],
              [-80.32945716099994, 25.44403717700004],
              [-80.32567298099991, 25.438666083000044],
              [-80.33372962099992, 25.42479075700004],
              [-80.34105383999992, 25.405951239000046],
              [-80.33291581899994, 25.39801666900007],
              [-80.32042395699995, 25.391546942000048],
              [-80.31309973899994, 25.38349030200004],
              [-80.31432044199994, 25.371161200000074],
              [-80.35073808499993, 25.342230536000045],
              [-80.39586341099994, 25.295396226000037],
              [-80.40062415299991, 25.287909247000073],
              [-80.40249589799993, 25.279364325000074],
              [-80.40591386599993, 25.27016836100006],
              [-80.42300370999993, 25.252386786000045],
              [-80.42418372299994, 25.241441148000035],
              [-80.42690995999993, 25.22174713700008],
              [-80.41478430899991, 25.206854559000078],
              [-80.40196692599994, 25.19554271000004],
              [-80.40249589799993, 25.18622467700004],
              [-80.41755123599995, 25.197414455000057],
              [-80.43712317599994, 25.22337474200009],
              [-80.45091712099992, 25.227769273000035],
              [-80.45079505099994, 25.242987372000073],
              [-80.46642005099994, 25.24176666900007],
              [-80.48619544199994, 25.233343817000048],
              [-80.49864661399994, 25.220363674000055],
              [-80.47691809799994, 25.218573309000078],
              [-80.45872962099992, 25.20917389500005],
              [-80.44664466099994, 25.19358958500004],
              [-80.4434301419999, 25.173163153000075],
              [-80.45091712099992, 25.173163153000075],
              [-80.45400956899994, 25.195257880000042],
              [-80.46914628799993, 25.20807526200008],
              [-80.48892167899993, 25.21035390800006],
              [-80.50617428299995, 25.200506903000075],
              [-80.50926673099991, 25.20722077000005],
              [-80.51366126199991, 25.212836005000042],
              [-80.51919511599993, 25.217189846000053],
              [-80.52599036399994, 25.220363674000055],
              [-80.52236894399994, 25.22679271000004],
              [-80.5196020169999, 25.23078034100007],
              [-80.51500403599994, 25.23305898600006],
              [-80.50617428299995, 25.23460521000004],
              [-80.5071508449999, 25.23891836100006],
              [-80.50837154899995, 25.24176666900007],
              [-80.51231848899994, 25.24827708500004],
              [-80.52525794199994, 25.246527411000045],
              [-80.56550045499995, 25.24599844000005],
              [-80.58063717399995, 25.241441148000035],
              [-80.59044348899994, 25.22532786700009],
              [-80.59748287699995, 25.20343659100007],
              [-80.60651607999995, 25.188666083000044],
              [-80.62222245999993, 25.19367096600007],
              [-80.61904863199993, 25.195746161000045],
              [-80.61754309799994, 25.19554271000004],
              [-80.6165258449999, 25.19603099200009],
              [-80.61473548099991, 25.200506903000075],
              [-80.65135657499991, 25.193060614000046],
              [-80.65697180899991, 25.189927476000037],
              [-80.65493730399993, 25.180568752000056],
              [-80.65160071499992, 25.17401764500005],
              [-80.65099036399994, 25.16787344000005],
              [-80.65697180899991, 25.159491278000075],
              [-80.66315670499995, 25.159491278000075],
              [-80.67813066299993, 25.16787344000005],
              [-80.69115149599992, 25.16274648600006],
              [-80.71092688699991, 25.14524974200009],
              [-80.72305253799993, 25.143133856000077],
              [-80.73981686099995, 25.143784898000035],
              [-80.75584876199991, 25.14874909100007],
              [-80.76561438699991, 25.159491278000075],
              [-80.76781165299991, 25.155462958000044],
              [-80.76992753799993, 25.152777411000045],
              [-80.77171790299991, 25.14984772300005],
              [-80.77301998599995, 25.14524974200009],
              [-80.77782141799992, 25.148260809000078],
              [-80.78294837099992, 25.15062083500004],
              [-80.78823808499993, 25.153957424000055],
              [-80.79352779899995, 25.159491278000075],
              [-80.79702714799993, 25.151312567000048],
              [-80.80028235599991, 25.148382880000042],
              [-80.80524654899995, 25.14911530200004],
              [-80.81403561099995, 25.152085679000038],
              [-80.81403561099995, 25.159491278000075],
              [-80.81053626199991, 25.167792059000078],
              [-80.84024003799993, 25.17340729400007],
              [-80.85496985599991, 25.18622467700004],
              [-80.8828832669999, 25.16950104400007],
              [-80.88719641799992, 25.168361721000053],
              [-80.9102270169999, 25.14524974200009],
              [-80.92878170499995, 25.14215729400007],
              [-80.96715247299994, 25.141546942000048],
              [-80.99958248599995, 25.13507721600007],
              [-81.03990637899994, 25.13157786700009],
              [-81.08653723899994, 25.12140534100007],
              [-81.10195878799993, 25.124741929000038],
              [-81.14915930899991, 25.165716864000046],
              [-81.16551673099991, 25.19725169500009],
              [-81.17711341099994, 25.227769273000035],
              [-81.17577063699991, 25.259019273000035],
              [-81.1648656889999, 25.298081773000035],
              [-81.14834550699993, 25.331203518000052],
              [-81.12995357999995, 25.34446849200009],
              [-81.13609778599994, 25.330226955000057],
              [-81.12401282499991, 25.327948309000078],
              [-81.1121313139999, 25.320746161000045],
              [-81.10191809799994, 25.311712958000044],
              [-81.09512285099993, 25.303534247000073],
              [-81.07787024599992, 25.27285390800006],
              [-81.07469641799992, 25.27244700700004],
              [-81.06175696499992, 25.264227606000077],
              [-80.98525956899994, 25.23460521000004],
              [-80.98525956899994, 25.227769273000035],
              [-80.99083411399994, 25.22614166900007],
              [-81.00011145699995, 25.22207265800006],
              [-81.00576738199993, 25.220363674000055],
              [-81.00576738199993, 25.214178778000075],
              [-80.98802649599992, 25.207505601000037],
              [-80.96629798099991, 25.206854559000078],
              [-80.9446508449999, 25.21230703300006],
              [-80.92723548099991, 25.22406647300005],
              [-80.91722571499992, 25.245754299000055],
              [-80.92414303299995, 25.26357656500005],
              [-80.98078365799995, 25.318304755000042],
              [-80.99913489499994, 25.327053127000056],
              [-81.03429114499994, 25.332464911000045],
              [-81.05166581899994, 25.342230536000045],
              [-81.05728105399993, 25.34446849200009],
              [-81.09512285099993, 25.351304429000038],
              [-81.14134680899991, 25.38475169500009],
              [-81.14915930899991, 25.395412502000056],
              [-81.15038001199991, 25.405951239000046],
              [-81.15542558499993, 25.426581122000073],
              [-81.15660559799994, 25.436346747000073],
              [-81.17088782499991, 25.47483958500004],
              [-81.20343990799995, 25.50800202000005],
              [-81.21467037699995, 25.52757396000004],
              [-81.19595292899993, 25.538885809000078],
              [-81.18993079299992, 25.545355536000045],
              [-81.18610592399995, 25.553168036000045],
              [-81.18765214799993, 25.560207424000055],
              [-81.19725501199991, 25.564276434000078],
              [-81.2200414699999, 25.55927155200004],
              [-81.23167883999992, 25.563625393000052],
              [-81.23542232999995, 25.573146877000056],
              [-81.24596106699994, 25.61823151200008],
              [-81.26671301999994, 25.652818101000037],
              [-81.26646887899994, 25.66665273600006],
              [-81.2747289699999, 25.674709377000056],
              [-81.27843176999994, 25.685980536000045],
              [-81.27953040299991, 25.70416901200008],
              [-81.31314042899993, 25.706203518000052],
              [-81.32168535099993, 25.707586981000077],
              [-81.32835852799991, 25.716050523000035],
              [-81.34024003799993, 25.74286530200004],
              [-81.34471594999991, 25.748521226000037],
              [-81.35724850199995, 25.75348541900007],
              [-81.34797115799995, 25.76463450700004],
              [-81.32168535099993, 25.78270091400009],
              [-81.32933508999992, 25.79047272300005],
              [-81.3484594389999, 25.816839911000045],
              [-81.37214107999995, 25.83612702000005],
              [-81.39614824099993, 25.851629950000074],
              [-81.40904700399994, 25.856350002000056],
              [-81.43834387899994, 25.86131419500009],
              [-81.45079505099994, 25.86587148600006],
              [-81.46214758999992, 25.87449778900009],
              [-81.47520911399994, 25.891017971000053],
              [-81.48558508999992, 25.89940013200004],
              [-81.49876868399991, 25.88670482000009],
              [-81.50951087099992, 25.89081452000005],
              [-81.52106686099995, 25.90106842700004],
              [-81.54157467399995, 25.90892161700009],
              [-81.55528723899994, 25.918361721000053],
              [-81.56407630099994, 25.920477606000077],
              [-81.56822669199994, 25.91864655200004],
              [-81.57990475199995, 25.909857489000046],
              [-81.58800208199995, 25.90688711100006],
              [-81.58381100199995, 25.91437409100007],
              [-81.58397376199991, 25.917303778000075],
              [-81.58617102799991, 25.91982656500005],
              [-81.58800208199995, 25.92609284100007],
              [-81.59642493399991, 25.923773505000042],
              [-81.60741126199991, 25.927394924000055],
              [-81.61742102799991, 25.93553294500009],
              [-81.62271074099993, 25.94717031500005],
              [-81.63280188699991, 25.940008856000077],
              [-81.64037024599992, 25.926255601000037],
              [-81.65005449099993, 25.920477606000077],
              [-81.66242428299995, 25.91819896000004],
              [-81.67430579299992, 25.91990794500009],
              [-81.68431555899991, 25.925116278000075],
              [-81.69102942599994, 25.933539130000042],
              [-81.69444739499994, 25.92792389500005],
              [-81.69786536399994, 25.920477606000077],
              [-81.70030676999994, 25.918443101000037],
              [-81.70579993399991, 25.913763739000046],
              [-81.70531165299991, 25.90688711100006],
              [-81.71149654899995, 25.90688711100006],
              [-81.71849524599992, 25.90810781500005],
              [-81.72223873599995, 25.91006094000005],
              [-81.73200436099995, 25.920477606000077],
              [-81.73582923099991, 25.92837148600006],
              [-81.74254309799994, 25.957464911000045],
              [-81.7285863919999, 25.962713934000078],
              [-81.71666419199994, 25.955959377000056],
              [-81.70567786399994, 25.945705471000053],
              [-81.69444739499994, 25.940375067000048],
              [-81.68504798099991, 25.945013739000046],
              [-81.67540442599994, 25.956244208000044],
              [-81.66779537699995, 25.96971263200004],
              [-81.66437740799995, 25.981350002000056],
              [-81.67918860599991, 25.98183828300006],
              [-81.7019750639999, 25.97923411700009],
              [-81.71149654899995, 25.981350002000056],
              [-81.72248287699995, 25.989081122000073],
              [-81.73167883999992, 26.00063711100006],
              [-81.73436438699991, 26.01276276200008],
              [-81.72573808499993, 26.022284247000073],
              [-81.75438391799992, 26.04205963700008],
              [-81.77009029899995, 26.06777578300006],
              [-81.78722083199995, 26.139593817000048],
              [-81.79149329299992, 26.130194403000075],
              [-81.79369055899991, 26.12018463700008],
              [-81.79417883999992, 26.10960521000004],
              [-81.79344641799992, 26.09861888200004],
              [-81.80089270699995, 26.09861888200004],
              [-81.81899980399993, 26.170314846000053],
              [-81.82754472599993, 26.248846747000073],
              [-81.82135982999995, 26.282945054000038],
              [-81.82140051999994, 26.289618231000077],
              [-81.82213294199994, 26.29287344000005],
              [-81.85179602799991, 26.34198639500005],
              [-81.8555395169999, 26.358710028000075],
              [-81.84870357999995, 26.358710028000075],
              [-81.84870357999995, 26.35187409100007],
              [-81.8418676419999, 26.35187409100007],
              [-81.84386145699995, 26.414211330000057],
              [-81.84870357999995, 26.43378327000005],
              [-81.85594641799992, 26.448879299000055],
              [-81.87584387899994, 26.480292059000078],
              [-81.88280188699991, 26.495835679000038],
              [-81.88243567599994, 26.48118724200009],
              [-81.87848873599995, 26.456244208000044],
              [-81.88280188699991, 26.44745514500005],
              [-81.88731848899994, 26.44476959800005],
              [-81.89403235599991, 26.44749583500004],
              [-81.89867102799991, 26.452093817000048],
              [-81.90330969999991, 26.454901434000078],
              [-81.92373613199993, 26.454901434000078],
              [-81.97838294199994, 26.482163804000038],
              [-81.99156653599994, 26.47601959800005],
              [-81.99469967399995, 26.47724030200004],
              [-82.00011145699995, 26.482163804000038],
              [-82.00633704299992, 26.47479889500005],
              [-82.00865637899994, 26.484523830000057],
              [-82.00885982999995, 26.499335028000075],
              [-82.00617428299995, 26.514064846000053],
              [-82.00011145699995, 26.523179429000038],
              [-81.99596106699994, 26.522772528000075],
              [-81.98924719999991, 26.51170482000009],
              [-81.98208574099993, 26.508937893000052],
              [-81.97447669199994, 26.51044342700004],
              [-81.9700414699999, 26.514146226000037],
              [-81.96572831899994, 26.518866278000075],
              [-81.93846594999991, 26.53546784100007],
              [-81.91177324099993, 26.558661200000074],
              [-81.89305579299992, 26.58612702000005],
              [-81.89708411399994, 26.611273505000042],
              [-81.8855688139999, 26.624172268000052],
              [-81.8418676419999, 26.66315338700008],
              [-81.83812415299991, 26.672430731000077],
              [-81.82917232999995, 26.681382554000038],
              [-81.81798255099994, 26.68545156500005],
              [-81.80772864499994, 26.680243231000077],
              [-81.7976781889999, 26.686753648000035],
              [-81.79010982999995, 26.69407786700009],
              [-81.78453528599994, 26.703070380000042],
              [-81.78038489499994, 26.714992580000057],
              [-81.79531816299993, 26.70970286700009],
              [-81.81920325399994, 26.697007554000038],
              [-81.83812415299991, 26.694525458000044],
              [-81.85460364499994, 26.688421942000048],
              [-81.87389075399994, 26.67405833500004],
              [-81.90672766799992, 26.642645575000074],
              [-81.91759192599994, 26.626654364000046],
              [-81.94774329299992, 26.548895575000074],
              [-81.95173092399995, 26.54364655200004],
              [-81.9597875639999, 26.539862372000073],
              [-81.9832250639999, 26.533758856000077],
              [-81.99266516799992, 26.529364325000074],
              [-81.99266516799992, 26.54364655200004],
              [-82.01276607999995, 26.535956122000073],
              [-82.0266820949999, 26.52802155200004],
              [-82.03905188699991, 26.527899481000077],
              [-82.0547582669999, 26.54364655200004],
              [-82.06309973899994, 26.560980536000045],
              [-82.06126868399991, 26.573431708000044],
              [-82.05614173099991, 26.58787669500009],
              [-82.0547582669999, 26.611273505000042],
              [-82.05968176999994, 26.629461981000077],
              [-82.07725989499994, 26.664984442000048],
              [-82.0821020169999, 26.680243231000077],
              [-82.08128821499992, 26.70270416900007],
              [-82.05687415299991, 26.818915106000077],
              [-82.0547582669999, 26.84125397300005],
              [-82.05703691299993, 26.865790106000077],
              [-82.06456458199995, 26.874945380000042],
              [-82.07811438699991, 26.88108958500004],
              [-82.09850012899994, 26.896551825000074],
              [-82.0969945949999, 26.909369208000044],
              [-82.07750403599994, 26.92291901200008],
              [-82.02757727799991, 26.949693101000037],
              [-82.00572669199994, 26.95380280200004],
              [-81.99640865799995, 26.958238023000035],
              [-81.99083411399994, 26.96556224200009],
              [-81.97838294199994, 26.996161200000074],
              [-81.99510657499991, 26.991522528000075],
              [-82.01683508999992, 26.97296784100007],
              [-82.0574438139999, 26.965318101000037],
              [-82.07457434799994, 26.958929755000042],
              [-82.09268144399994, 26.955633856000077],
              [-82.11558997299994, 26.961371161000045],
              [-82.1199438139999, 26.945461330000057],
              [-82.13198808499993, 26.941839911000045],
              [-82.14452063699991, 26.94041575700004],
              [-82.15029863199993, 26.930975653000075],
              [-82.15518144399994, 26.92763906500005],
              [-82.1660863919999, 26.93618398600006],
              [-82.18443762899994, 26.955145575000074],
              [-82.18073482999995, 26.972357489000046],
              [-82.19098873599995, 26.96938711100006],
              [-82.20738684799994, 26.961818752000056],
              [-82.22232011599993, 26.96515534100007],
              [-82.24201412699995, 26.99551015800006],
              [-82.25328528599994, 27.00682200700004],
              [-82.27383378799993, 27.016017971000053],
              [-82.27090410099993, 27.00771719000005],
              [-82.25914466099994, 26.98924388200004],
              [-82.23021399599992, 26.956854559000078],
              [-82.21922766799992, 26.947739976000037],
              [-82.21178137899994, 26.955145575000074],
              [-82.20128333199995, 26.944159247000073],
              [-82.18732662699995, 26.91315338700008],
              [-82.18101966099994, 26.906805731000077],
              [-82.17568925699993, 26.899237372000073],
              [-82.15990149599992, 26.862250067000048],
              [-82.15094967399995, 26.818019924000055],
              [-82.15025794199994, 26.803168036000045],
              [-82.15656490799995, 26.79002513200004],
              [-82.16559811099995, 26.78579336100006],
              [-82.16901607999995, 26.814113674000055],
              [-82.17764238199993, 26.82485586100006],
              [-82.17857825399994, 26.82127513200004],
              [-82.18431555899991, 26.814276434000078],
              [-82.19188391799992, 26.807074286000045],
              [-82.19810950399994, 26.803127346000053],
              [-82.20107988199993, 26.80499909100007],
              [-82.21076412699995, 26.81509023600006],
              [-82.21548417899993, 26.81736888200004],
              [-82.21861731699994, 26.81631094000005],
              [-82.22044837099992, 26.81395091400009],
              [-82.22321529899995, 26.811672268000052],
              [-82.22915605399993, 26.81053294500009],
              [-82.23607337099992, 26.81207916900007],
              [-82.24551347599993, 26.82050202000005],
              [-82.25340735599991, 26.82485586100006],
              [-82.2676488919999, 26.82957591400009],
              [-82.27456620999993, 26.83071523600006],
              [-82.28380286399994, 26.831000067000048],
              [-82.31383216099994, 26.849351304000038],
              [-82.34292558499993, 26.934881903000075],
              [-82.37002519399994, 26.961371161000045],
              [-82.36693274599992, 26.94562409100007],
              [-82.35362708199995, 26.92210521000004],
              [-82.3489477199999, 26.906805731000077],
              [-82.36099199099993, 26.913275458000044],
              [-82.36595618399991, 26.916815497000073],
              [-82.37002519399994, 26.920396226000037],
              [-82.37661699099993, 26.940334377000056],
              [-82.46715247299994, 27.102036851000037],
              [-82.47720292899993, 27.137518622000073],
              [-82.50088456899994, 27.179022528000075],
              [-82.50658118399991, 27.201605536000045],
              [-82.50182044199994, 27.190334377000056],
              [-82.49819902299993, 27.185248114000046],
              [-82.4929906889999, 27.180487372000073],
              [-82.4929906889999, 27.197211005000042],
              [-82.49632727799991, 27.211493231000077],
              [-82.50316321499992, 27.222357489000046],
              [-82.51341712099992, 27.228908596000053],
              [-82.51341712099992, 27.215277411000045],
              [-82.52086341099994, 27.215277411000045],
              [-82.53262285099993, 27.236883856000077],
              [-82.54918372299994, 27.25657786700009],
              [-82.5618383449999, 27.276271877000056],
              [-82.56187903599994, 27.297796942000048],
              [-82.55760657499991, 27.29437897300005],
              [-82.55406653599994, 27.29242584800005],
              [-82.55089270699995, 27.289496161000045],
              [-82.54759680899991, 27.28351471600007],
              [-82.54076087099992, 27.28351471600007],
              [-82.54190019399994, 27.308539130000042],
              [-82.56273352799991, 27.346828518000052],
              [-82.57363847599993, 27.395086981000077],
              [-82.58788001199991, 27.40818919500009],
              [-82.6067602199999, 27.41705963700008],
              [-82.64541581899994, 27.44293854400007],
              [-82.68272864499994, 27.44871653900009],
              [-82.69839433499993, 27.454820054000038],
              [-82.70982825399994, 27.46938711100006],
              [-82.72915605399993, 27.51471588700008],
              [-82.73253333199995, 27.530585028000075],
              [-82.72569739499994, 27.530585028000075],
              [-82.71051998599995, 27.49750397300005],
              [-82.70523027299993, 27.489569403000075],
              [-82.69481360599991, 27.482896226000037],
              [-82.66836503799993, 27.471625067000048],
              [-82.65746008999992, 27.46165599200009],
              [-82.65013587099992, 27.46865469000005],
              [-82.64549719999991, 27.476629950000074],
              [-82.64366614499994, 27.48574453300006],
              [-82.64439856699994, 27.495835679000038],
              [-82.65062415299991, 27.495835679000038],
              [-82.65770423099991, 27.491522528000075],
              [-82.66490637899994, 27.49241771000004],
              [-82.67178300699993, 27.496893622000073],
              [-82.67788652299993, 27.503241278000075],
              [-82.66075598899994, 27.520331122000073],
              [-82.63630123599995, 27.51390208500004],
              [-82.61050370999993, 27.502101955000057],
              [-82.5891820949999, 27.503241278000075],
              [-82.59947669199994, 27.51117584800005],
              [-82.61042232999995, 27.51715729400007],
              [-82.62254798099991, 27.521307684000078],
              [-82.63695227799991, 27.52374909100007],
              [-82.62140865799995, 27.531195380000042],
              [-82.59203040299991, 27.53847890800006],
              [-82.57860266799992, 27.547308661000045],
              [-82.57241777299993, 27.559515692000048],
              [-82.58820553299995, 27.557196356000077],
              [-82.60098222599993, 27.552394924000055],
              [-82.60419674399992, 27.55109284100007],
              [-82.62267005099994, 27.544175523000035],
              [-82.61778723899994, 27.552557684000078],
              [-82.61514238199993, 27.555812893000052],
              [-82.61131751199991, 27.554836330000057],
              [-82.60570227799991, 27.552883205000057],
              [-82.60342363199993, 27.55292389500005],
              [-82.60118567599994, 27.553900458000044],
              [-82.5891820949999, 27.56468333500004],
              [-82.5918676419999, 27.56834544500009],
              [-82.59601803299995, 27.57770416900007],
              [-82.57457434799994, 27.590725002000056],
              [-82.56460527299993, 27.60895416900007],
              [-82.5574438139999, 27.62962474200009],
              [-82.54417883999992, 27.650051174000055],
              [-82.51667232999995, 27.66990794500009],
              [-82.51341712099992, 27.677679755000042],
              [-82.51012122299994, 27.689398505000042],
              [-82.50218665299991, 27.69440338700008],
              [-82.49307206899994, 27.697088934000078],
              [-82.48615475199995, 27.701239325000074],
              [-82.47036699099993, 27.729315497000073],
              [-82.4656469389999, 27.736029364000046],
              [-82.43773352799991, 27.75336334800005],
              [-82.4304906889999, 27.763739325000074],
              [-82.39818274599992, 27.796047268000052],
              [-82.3899633449999, 27.811102606000077],
              [-82.39268958199995, 27.834051825000074],
              [-82.41246497299994, 27.87571849200009],
              [-82.42174231699994, 27.917181708000044],
              [-82.43374589799993, 27.92914459800005],
              [-82.45116126199991, 27.93073151200008],
              [-82.47183183499993, 27.920355536000045],
              [-82.48070227799991, 27.90843333500004],
              [-82.48485266799992, 27.89256419500009],
              [-82.48615475199995, 27.85578034100007],
              [-82.4798070949999, 27.841498114000046],
              [-82.47809811099995, 27.831284898000035],
              [-82.48273678299995, 27.82135651200008],
              [-82.51829993399991, 27.822658596000053],
              [-82.52708899599992, 27.824774481000077],
              [-82.53962154899995, 27.84398021000004],
              [-82.54092363199993, 27.868801174000055],
              [-82.53453528599994, 27.917222398000035],
              [-82.54112708199995, 27.94277578300006],
              [-82.55882727799991, 27.95579661700009],
              [-82.58495032499991, 27.960638739000046],
              [-82.61644446499992, 27.961330471000053],
              [-82.61644446499992, 27.96873607000009],
              [-82.59601803299995, 27.97557200700004],
              [-82.59601803299995, 27.98305898600006],
              [-82.62352454299992, 27.996527411000045],
              [-82.63621985599991, 28.005804755000042],
              [-82.64439856699994, 28.016546942000048],
              [-82.65062415299991, 28.016546942000048],
              [-82.65094967399995, 28.01325104400007],
              [-82.65062415299991, 28.00291575700004],
              [-82.69098873599995, 28.037665106000077],
              [-82.68834387899994, 28.028998114000046],
              [-82.67979895699995, 28.01325104400007],
              [-82.67788652299993, 28.006293036000045],
              [-82.67910722599993, 27.998439846000053],
              [-82.68415279899995, 27.98729075700004],
              [-82.68472245999993, 27.98305898600006],
              [-82.69054114499994, 27.975531317000048],
              [-82.69033769399994, 27.970851955000057],
              [-82.68130449099993, 27.96873607000009],
              [-82.64439856699994, 27.96873607000009],
              [-82.65684973899994, 27.956244208000044],
              [-82.70274817599994, 27.94472890800006],
              [-82.71886145699995, 27.927801825000074],
              [-82.68024654899995, 27.914129950000074],
              [-82.64321855399993, 27.89476146000004],
              [-82.60472571499992, 27.88149648600006],
              [-82.56187903599994, 27.88617584800005],
              [-82.57079016799992, 27.879828192000048],
              [-82.6028539699999, 27.862982489000046],
              [-82.60130774599992, 27.85114166900007],
              [-82.59581458199995, 27.82998281500005],
              [-82.59601803299995, 27.81793854400007],
              [-82.60016842399995, 27.807928778000075],
              [-82.61363684799994, 27.792710679000038],
              [-82.61644446499992, 27.787502346000053],
              [-82.61790930899991, 27.780991929000038],
              [-82.63011633999992, 27.75031159100007],
              [-82.6231176419999, 27.734035549000055],
              [-82.62657630099994, 27.71580638200004],
              [-82.63776607999995, 27.701117255000042],
              [-82.65404212099992, 27.695054429000038],
              [-82.67247473899994, 27.695054429000038],
              [-82.67926998599995, 27.69684479400007],
              [-82.68472245999993, 27.701239325000074],
              [-82.68708248599995, 27.709865627000056],
              [-82.68602454299992, 27.731634833000044],
              [-82.68785559799994, 27.736029364000046],
              [-82.70921790299991, 27.738430080000057],
              [-82.7215063139999, 27.74510325700004],
              [-82.73936926999994, 27.76951732000009],
              [-82.75719153599994, 27.787665106000077],
              [-82.79596920499995, 27.815334377000056],
              [-82.81509355399993, 27.83222077000005],
              [-82.81883704299992, 27.818182684000078],
              [-82.81069902299993, 27.804429429000038],
              [-82.75133216099994, 27.746568101000037],
              [-82.73936926999994, 27.728583075000074],
              [-82.7246801419999, 27.69407786700009],
              [-82.71800696499992, 27.67206452000005],
              [-82.71886145699995, 27.65965403900009],
              [-82.73131262899994, 27.662054755000042],
              [-82.74254309799994, 27.679754950000074],
              [-82.75055904899995, 27.702093817000048],
              [-82.75365149599992, 27.71865469000005],
              [-82.76748613199993, 27.75153229400007],
              [-82.82852128799993, 27.80499909100007],
              [-82.84239661399994, 27.828517971000053],
              [-82.8445531889999, 27.841864325000074],
              [-82.85391191299993, 27.870347398000035],
              [-82.85606848899994, 27.889960028000075],
              [-82.85228430899991, 27.90818919500009],
              [-82.84316972599993, 27.925441799000055],
              [-82.83202063699991, 27.939398505000042],
              [-82.82188880099994, 27.94830963700008],
              [-82.8313695949999, 27.93512604400007],
              [-82.83849036399994, 27.91819896000004],
              [-82.84072831899994, 27.90070221600007],
              [-82.83556067599994, 27.88617584800005],
              [-82.80223548099991, 27.966620184000078],
              [-82.78034420499995, 28.05817291900007],
              [-82.77904212099992, 28.08470286700009],
              [-82.77623450399994, 28.096828518000052],
              [-82.76732337099992, 28.105902411000045],
              [-82.7766820949999, 28.120306708000044],
              [-82.78246008999992, 28.13544342700004],
              [-82.78774980399993, 28.160549221000053],
              [-82.78848222599993, 28.17401764500005],
              [-82.78734290299991, 28.193752346000053],
              [-82.78282630099994, 28.20701732000009],
              [-82.7735082669999, 28.201564846000053],
              [-82.75991777299993, 28.214667059000078],
              [-82.75381425699993, 28.22797272300005],
              [-82.74620520699995, 28.25617096600007],
              [-82.72492428299995, 28.28416575700004],
              [-82.71678626199991, 28.29832591400009],
              [-82.71886145699995, 28.311428127000056],
              [-82.72264563699991, 28.308254299000055],
              [-82.72549394399994, 28.306708075000074],
              [-82.73253333199995, 28.30459219000005],
              [-82.69668535099993, 28.38886139500005],
              [-82.68472245999993, 28.400783596000053],
              [-82.68472245999993, 28.40692780200004],
              [-82.68590247299994, 28.41429271000004],
              [-82.66421464799993, 28.44794342700004],
              [-82.66307532499991, 28.501898505000042],
              [-82.66079667899993, 28.513739325000074],
              [-82.65050208199995, 28.54364655200004],
              [-82.64712480399993, 28.62958405200004],
              [-82.63695227799991, 28.64716217700004],
              [-82.64077714799993, 28.65379466400009],
              [-82.64378821499992, 28.662502346000053],
              [-82.64435787699995, 28.67133209800005],
              [-82.6406957669999, 28.678534247000073],
              [-82.63243567599994, 28.688421942000048],
              [-82.63194739499994, 28.69529857000009],
              [-82.63499915299991, 28.70213450700004],
              [-82.63695227799991, 28.712062893000052],
              [-82.63695227799991, 28.746486721000053],
              [-82.64020748599995, 28.75495026200008],
              [-82.64720618399991, 28.756415106000077],
              [-82.65420488199993, 28.756252346000053],
              [-82.65746008999992, 28.760158596000053],
              [-82.66222083199995, 28.773260809000078],
              [-82.68203691299993, 28.795843817000048],
              [-82.68472245999993, 28.804836330000057],
              [-82.67100989499994, 28.82021719000005],
              [-82.65501868399991, 28.81195709800005],
              [-82.63011633999992, 28.784369208000044],
              [-82.6375219389999, 28.814154364000046],
              [-82.63853919199994, 28.824693101000037],
              [-82.63109290299991, 28.872992255000042],
              [-82.6336156889999, 28.887640692000048],
              [-82.64439856699994, 28.90037669500009],
              [-82.65123450399994, 28.90298086100006],
              [-82.67027747299994, 28.905422268000052],
              [-82.67788652299993, 28.907904364000046],
              [-82.68517005099994, 28.91307200700004],
              [-82.72716223899994, 28.95917389500005],
              [-82.73228919199994, 28.97646719000005],
              [-82.72569739499994, 28.996649481000077],
              [-82.73778235599991, 28.99762604400007],
              [-82.7493383449999, 29.00226471600007],
              [-82.75511633999992, 29.010158596000053],
              [-82.74990800699993, 29.02049388200004],
              [-82.74718176999994, 29.030422268000052],
              [-82.74705969999991, 29.060614325000074],
              [-82.74620520699995, 29.064886786000045],
              [-82.78335527299993, 29.090969143000052],
              [-82.79474850199995, 29.10805898600006],
              [-82.7735082669999, 29.119533596000053],
              [-82.79051673099991, 29.127427476000037],
              [-82.79849199099993, 29.139064846000053],
              [-82.8008520169999, 29.154689846000053],
              [-82.8008520169999, 29.174750067000048],
              [-82.82070878799993, 29.16592031500005],
              [-82.82872473899994, 29.16111888200004],
              [-82.83336341099994, 29.16665273600006],
              [-82.84463456899994, 29.17649974200009],
              [-82.84923255099994, 29.182196356000077],
              [-82.86888587099992, 29.169623114000046],
              [-82.89195716099994, 29.170355536000045],
              [-82.91429602799991, 29.178656317000048],
              [-82.93175208199995, 29.188421942000048],
              [-82.94351152299993, 29.18512604400007],
              [-82.97183183499993, 29.184515692000048],
              [-82.9863988919999, 29.182196356000077],
              [-83.00422115799995, 29.176174221000053],
              [-83.01113847599993, 29.175034898000035],
              [-83.02391516799992, 29.174750067000048],
              [-83.04067949099993, 29.180121161000045],
              [-83.04527747299994, 29.191839911000045],
              [-83.04605058499993, 29.203558661000045],
              [-83.0515844389999, 29.208929755000042],
              [-83.06582597599993, 29.21157461100006],
              [-83.07371985599991, 29.21824778900009],
              [-83.07298743399991, 29.227362372000073],
              [-83.06151282499991, 29.236802476000037],
              [-83.06895911399994, 29.245754299000055],
              [-83.07567298099991, 29.259507554000038],
              [-83.0847875639999, 29.27220286700009],
              [-83.09902910099993, 29.277777411000045],
              [-83.11440995999993, 29.280503648000035],
              [-83.13231360599991, 29.287258205000057],
              [-83.14826412699995, 29.296087958000044],
              [-83.15770423099991, 29.305121161000045],
              [-83.16124426999994, 29.31159088700008],
              [-83.16356360599991, 29.32168203300006],
              [-83.16515051999994, 29.342678127000056],
              [-83.16787675699993, 29.344305731000077],
              [-83.18504798099991, 29.373968817000048],
              [-83.21568762899994, 29.410589911000045],
              [-83.23281816299993, 29.427069403000075],
              [-83.25328528599994, 29.442287502000056],
              [-83.27818762899994, 29.43854401200008],
              [-83.30573482999995, 29.457953192000048],
              [-83.35631262899994, 29.510565497000073],
              [-83.36660722599993, 29.50926341400009],
              [-83.37950598899994, 29.51508209800005],
              [-83.40477454299992, 29.531683661000045],
              [-83.39989173099991, 29.54092031500005],
              [-83.40099036399994, 29.555121161000045],
              [-83.40562903599994, 29.569525458000044],
              [-83.41152910099993, 29.57949453300006],
              [-83.40111243399991, 29.59056224200009],
              [-83.39464270699995, 29.610541083000044],
              [-83.39297441299993, 29.633734442000048],
              [-83.3972875639999, 29.65452708500004],
              [-83.40892493399991, 29.667303778000075],
              [-83.42593339799993, 29.672023830000057],
              [-83.44591223899994, 29.674750067000048],
              [-83.46617591099994, 29.68183014500005],
              [-83.47484290299991, 29.687567450000074],
              [-83.48664303299995, 29.697699286000045],
              [-83.49351966099994, 29.702337958000044],
              [-83.52765865799995, 29.716009833000044],
              [-83.54381262899994, 29.72809479400007],
              [-83.56200110599991, 29.745754299000055],
              [-83.57677161399994, 29.764960028000075],
              [-83.58287512899994, 29.781805731000077],
              [-83.58385169199994, 29.79197825700004],
              [-83.58910071499992, 29.81590403900009],
              [-83.59337317599994, 29.826157945000034],
              [-83.60277258999992, 29.832505601000037],
              [-83.6121313139999, 29.83730703300006],
              [-83.61636308499993, 29.842596747000073],
              [-83.62490800699993, 29.86432526200008],
              [-83.66246497299994, 29.89866771000004],
              [-83.67100989499994, 29.91156647300005],
              [-83.68057206899994, 29.92129140800006],
              [-83.72447669199994, 29.950140692000048],
              [-83.73680579299992, 29.956203518000052],
              [-83.75413977799991, 29.959865627000056],
              [-83.76646887899994, 29.968817450000074],
              [-83.78770911399994, 29.98969147300005],
              [-83.81159420499995, 29.98533763200004],
              [-83.85643469999991, 30.002386786000045],
              [-83.95059160099993, 30.054429429000038],
              [-84.02403723899994, 30.106594143000052],
              [-84.04356848899994, 30.105169989000046],
              [-84.07575436099995, 30.09332916900007],
              [-84.14761308499993, 30.087876695000034],
              [-84.16820227799991, 30.07636139500005],
              [-84.17833411399994, 30.072821356000077],
              [-84.1836645169999, 30.08161041900007],
              [-84.18814042899993, 30.093573309000078],
              [-84.19579016799992, 30.099554755000042],
              [-84.19880123599995, 30.100775458000044],
              [-84.20042883999992, 30.103338934000078],
              [-84.2031957669999, 30.105902411000045],
              [-84.20913652299993, 30.107082424000055],
              [-84.21556555899991, 30.10496653900009],
              [-84.22126217399995, 30.095770575000074],
              [-84.22716223899994, 30.09332916900007],
              [-84.24767005099994, 30.09332916900007],
              [-84.24722245999993, 30.094916083000044],
              [-84.25039628799993, 30.097601630000042],
              [-84.25536048099991, 30.099676825000074],
              [-84.26065019399994, 30.099554755000042],
              [-84.26964270699995, 30.092678127000056],
              [-84.27794348899994, 30.081284898000035],
              [-84.28368079299992, 30.070746161000045],
              [-84.2852270169999, 30.066066799000055],
              [-84.31688391799992, 30.06781647300005],
              [-84.32852128799993, 30.06598541900007],
              [-84.36436926999994, 30.048529364000046],
              [-84.37071692599994, 30.04047272300005],
              [-84.37051347599993, 30.02448151200008],
              [-84.37706458199995, 30.027289130000042],
              [-84.37979081899994, 30.028957424000055],
              [-84.3836156889999, 30.03192780200004],
              [-84.39102128799993, 30.02448151200008],
              [-84.38727779899995, 30.016424872000073],
              [-84.38670813699991, 30.014146226000037],
              [-84.38825436099995, 30.01190827000005],
              [-84.39102128799993, 30.004055080000057],
              [-84.38784745999993, 29.998928127000056],
              [-84.3836156889999, 29.98969147300005],
              [-84.38072669199994, 29.99359772300005],
              [-84.37360592399995, 30.000392971000053],
              [-84.37051347599993, 30.004055080000057],
              [-84.36412512899994, 29.995021877000056],
              [-84.34386145699995, 29.97402578300006],
              [-84.34630286399994, 29.969875393000052],
              [-84.36021887899994, 29.971991278000075],
              [-84.38512122299994, 29.981390692000048],
              [-84.41905676999994, 29.989976304000038],
              [-84.4383031889999, 30.001206773000035],
              [-84.45352128799993, 30.005194403000075],
              [-84.4661352199999, 29.98969147300005],
              [-84.44994055899991, 29.988836981000077],
              [-84.44644120999993, 29.979315497000073],
              [-84.44517981699994, 29.96832916900007],
              [-84.43569902299993, 29.963039455000057],
              [-84.37393144399994, 29.956203518000052],
              [-84.34300696499992, 29.94676341400009],
              [-84.33608964799993, 29.92536041900007],
              [-84.34898841099994, 29.902044989000046],
              [-84.37734941299993, 29.88735586100006],
              [-84.36782792899993, 29.898098049000055],
              [-84.36367753799993, 29.901556708000044],
              [-84.36367753799993, 29.90778229400007],
              [-84.40135657499991, 29.91860586100006],
              [-84.44253495999993, 29.92206452000005],
              [-84.46206620999993, 29.91864655200004],
              [-84.48106848899994, 29.912909247000073],
              [-84.49718176999994, 29.911810614000046],
              [-84.50837154899995, 29.92206452000005],
              [-84.56297766799992, 29.89411041900007],
              [-84.60435950399994, 29.86469147300005],
              [-84.65318762899994, 29.852769273000035],
              [-84.68321692599994, 29.833929755000042],
              [-84.73363196499992, 29.79169342700004],
              [-84.7461645169999, 29.78583405200004],
              [-84.77293860599991, 29.78278229400007],
              [-84.78823808499993, 29.77871328300006],
              [-84.81191972599993, 29.76276276200008],
              [-84.82787024599992, 29.754380601000037],
              [-84.84723873599995, 29.750799872000073],
              [-84.86099199099993, 29.744289455000057],
              [-84.87535559799994, 29.733221747000073],
              [-84.88662675699993, 29.73004791900007],
              [-84.89126542899993, 29.747381903000075],
              [-84.88695227799991, 29.755601304000038],
              [-84.85716712099992, 29.79791901200008],
              [-84.87328040299991, 29.804632880000042],
              [-84.88646399599992, 29.79913971600007],
              [-84.89940344999991, 29.78978099200009],
              [-84.9148656889999, 29.784898179000038],
              [-84.92813066299993, 29.778469143000052],
              [-84.94579016799992, 29.752834377000056],
              [-84.97093665299991, 29.74957916900007],
              [-84.99107825399994, 29.72284577000005],
              [-85.00426184799994, 29.716009833000044],
              [-85.08364824099993, 29.723456122000073],
              [-85.12425696499992, 29.721828518000052],
              [-85.24071204299992, 29.688706773000035],
              [-85.26231848899994, 29.68935781500005],
              [-85.28563391799992, 29.69281647300005],
              [-85.30785071499992, 29.693426825000074],
              [-85.34609941299993, 29.67837148600006],
              [-85.36583411399994, 29.686346747000073],
              [-85.3821508449999, 29.701564846000053],
              [-85.39159094999991, 29.716009833000044],
              [-85.41063391799992, 29.800116278000075],
              [-85.41348222599993, 29.851385809000078],
              [-85.39842688699991, 29.873602606000077],
              [-85.39574133999992, 29.863714911000045],
              [-85.39842688699991, 29.79482656500005],
              [-85.39586341099994, 29.771877346000053],
              [-85.38878333199995, 29.749212958000044],
              [-85.37779700399994, 29.728176174000055],
              [-85.35147050699993, 29.693426825000074],
              [-85.34398352799991, 29.689113674000055],
              [-85.3301488919999, 29.688706773000035],
              [-85.32054602799991, 29.693304755000042],
              [-85.30894934799994, 29.70270416900007],
              [-85.30186926999994, 29.711859442000048],
              [-85.30557206899994, 29.716009833000044],
              [-85.30654863199993, 29.727728583000044],
              [-85.30215410099993, 29.79791901200008],
              [-85.31167558499993, 29.819525458000044],
              [-85.34361731699994, 29.85578034100007],
              [-85.35057532499991, 29.87018463700008],
              [-85.35651607999995, 29.888739325000074],
              [-85.37083899599992, 29.90696849200009],
              [-85.3887426419999, 29.92324453300006],
              [-85.40518144399994, 29.93512604400007],
              [-85.51976477799991, 29.981756903000075],
              [-85.54918372299994, 30.004055080000057],
              [-85.55426998599995, 30.010199286000045],
              [-85.55785071499992, 30.01593659100007],
              [-85.56053626199991, 30.022691148000035],
              [-85.56285559799994, 30.03192780200004],
              [-85.5554906889999, 30.03192780200004],
              [-85.54401607999995, 30.015326239000046],
              [-85.52342688699991, 29.996893622000073],
              [-85.50015214799993, 29.98383209800005],
              [-85.48033606699994, 29.983547268000052],
              [-85.60789954299992, 30.07444896000004],
              [-85.62120520699995, 30.079738674000055],
              [-85.67088782499991, 30.12295156500005],
              [-85.67955481699994, 30.13434479400007],
              [-85.67153886599993, 30.136379299000055],
              [-85.6106664699999, 30.126898505000042],
              [-85.61143958199995, 30.10846588700008],
              [-85.54600989499994, 30.091009833000044],
              [-85.52871660099993, 30.07636139500005],
              [-85.51268469999991, 30.05532461100006],
              [-85.47752844999991, 30.032863674000055],
              [-85.44237219999991, 30.02016836100006],
              [-85.42634029899995, 30.028225002000056],
              [-85.41832434799994, 30.03579336100006],
              [-85.40225175699993, 30.03969961100006],
              [-85.39049231699994, 30.044745184000078],
              [-85.39500891799992, 30.055568752000056],
              [-85.40200761599993, 30.05878327000005],
              [-85.41836503799993, 30.057847398000035],
              [-85.42634029899995, 30.058661200000074],
              [-85.43053137899994, 30.063055731000077],
              [-85.43000240799995, 30.06826406500005],
              [-85.4309789699999, 30.07050202000005],
              [-85.44001217399995, 30.066066799000055],
              [-85.4519750639999, 30.04360586100006],
              [-85.46206620999993, 30.034898179000038],
              [-85.47691809799994, 30.041571356000077],
              [-85.48591061099995, 30.05817291900007],
              [-85.48387610599991, 30.09210846600007],
              [-85.48778235599991, 30.107082424000055],
              [-85.50560462099992, 30.099269924000055],
              [-85.51268469999991, 30.108343817000048],
              [-85.50894120999993, 30.123602606000077],
              [-85.49461829299992, 30.13434479400007],
              [-85.49461829299992, 30.140570380000042],
              [-85.51349850199995, 30.13934967700004],
              [-85.52887936099995, 30.13239166900007],
              [-85.5442602199999, 30.128078518000052],
              [-85.56285559799994, 30.13434479400007],
              [-85.5633031889999, 30.12759023600006],
              [-85.56517493399991, 30.123032945000034],
              [-85.56761633999992, 30.119086005000042],
              [-85.56969153599994, 30.11391836100006],
              [-85.5833227199999, 30.124212958000044],
              [-85.60521399599992, 30.136867580000057],
              [-85.62828528599994, 30.144598700000074],
              [-85.64541581899994, 30.140570380000042],
              [-85.65306555899991, 30.152167059000078],
              [-85.66258704299992, 30.158758856000077],
              [-85.69737708199995, 30.173651434000078],
              [-85.70543372299994, 30.179022528000075],
              [-85.71271725199995, 30.185939846000053],
              [-85.72052975199995, 30.195786851000037],
              [-85.69920813699991, 30.20652903900009],
              [-85.65729732999995, 30.252101955000057],
              [-85.64199785099993, 30.25413646000004],
              [-85.61807206899994, 30.245835679000038],
              [-85.57921301999994, 30.28611888200004],
              [-85.5554906889999, 30.285142320000034],
              [-85.56794186099995, 30.309393622000073],
              [-85.5769750639999, 30.321193752000056],
              [-85.58678137899994, 30.326117255000042],
              [-85.5965063139999, 30.31826406500005],
              [-85.62075761599993, 30.282049872000073],
              [-85.63857988199993, 30.271470445000034],
              [-85.6433813139999, 30.285101630000042],
              [-85.65489661399994, 30.283596096000053],
              [-85.66942298099991, 30.27606842700004],
              [-85.68325761599993, 30.271470445000034],
              [-85.69473222599993, 30.266017971000053],
              [-85.70173092399995, 30.255031643000052],
              [-85.70864824099993, 30.247015692000048],
              [-85.72052975199995, 30.250433661000045],
              [-85.72032630099994, 30.267564195000034],
              [-85.72940019399994, 30.282416083000044],
              [-85.74254309799994, 30.29840729400007],
              [-85.7547094389999, 30.319281317000048],
              [-85.76598059799994, 30.301581122000073],
              [-85.77757727799991, 30.29441966400009],
              [-85.80923417899993, 30.291408596000053],
              [-85.82555091099994, 30.287176825000074],
              [-85.84390214799993, 30.278225002000056],
              [-85.85435950399994, 30.264837958000044],
              [-85.84715735599991, 30.247300523000035],
              [-85.83177649599992, 30.23590729400007],
              [-85.82046464799993, 30.236029364000046],
              [-85.80719967399995, 30.241115627000056],
              [-85.78571529899995, 30.244208075000074],
              [-85.76724199099993, 30.24054596600007],
              [-85.75597083199995, 30.231594143000052],
              [-85.74669348899994, 30.22028229400007],
              [-85.73420162699995, 30.209418036000045],
              [-85.74913489499994, 30.19049713700008],
              [-85.74136308499993, 30.17837148600006],
              [-85.72301184799994, 30.16815827000005],
              [-85.70628821499992, 30.154852606000077],
              [-85.71373450399994, 30.140570380000042],
              [-85.72638912699995, 30.152167059000078],
              [-85.7344457669999, 30.150213934000078],
              [-85.72834225199995, 30.143866278000075],
              [-85.72052975199995, 30.13434479400007],
              [-85.74425208199995, 30.139471747000073],
              [-85.86449133999992, 30.21625397300005],
              [-85.95006262899994, 30.253078518000052],
              [-86.06598873599995, 30.30605703300006],
              [-86.19286048099991, 30.339789130000042],
              [-86.36481686099995, 30.38076406500005],
              [-86.48497473899994, 30.39276764500005],
              [-86.51089433499993, 30.40761953300006],
              [-86.50975501199991, 30.409125067000048],
              [-86.50987708199995, 30.411810614000046],
              [-86.50877844999991, 30.414943752000056],
              [-86.49303137899994, 30.41046784100007],
              [-86.41266842399995, 30.40810781500005],
              [-86.34715735599991, 30.395005601000037],
              [-86.33482825399994, 30.400091864000046],
              [-86.32721920499995, 30.41201406500005],
              [-86.32188880099994, 30.425604559000078],
              [-86.31639563699991, 30.435980536000045],
              [-86.31167558499993, 30.436468817000048],
              [-86.31041419199994, 30.43496328300006],
              [-86.30955969999991, 30.435980536000045],
              [-86.3054906889999, 30.42446523600006],
              [-86.2981664699999, 30.413234768000052],
              [-86.2871801419999, 30.404689846000053],
              [-86.24193274599992, 30.395005601000037],
              [-86.23574785099993, 30.398993231000077],
              [-86.22923743399991, 30.40570709800005],
              [-86.22630774599992, 30.412054755000042],
              [-86.23106848899994, 30.414943752000056],
              [-86.24649003799993, 30.417303778000075],
              [-86.25845292899993, 30.423041083000044],
              [-86.26089433499993, 30.42999909100007],
              [-86.24815833199995, 30.435980536000045],
              [-86.2344457669999, 30.434475002000056],
              [-86.22008216099994, 30.42674388200004],
              [-86.19286048099991, 30.40810781500005],
              [-86.14517167899993, 30.39606354400007],
              [-86.13512122299994, 30.39130280200004],
              [-86.11742102799991, 30.379339911000045],
              [-86.10777747299994, 30.386704820000034],
              [-86.10659745999993, 30.40058014500005],
              [-86.11436926999994, 30.40810781500005],
              [-86.1153051419999, 30.413316148000035],
              [-86.14565995999993, 30.442206122000073],
              [-86.15147864499994, 30.45726146000004],
              [-86.14631100199995, 30.461737372000073],
              [-86.13898678299995, 30.466742255000042],
              [-86.13825436099995, 30.48314036700009],
              [-86.16441809799994, 30.47207265800006],
              [-86.18203691299993, 30.468817450000074],
              [-86.19493567599994, 30.478216864000046],
              [-86.20714270699995, 30.50486888200004],
              [-86.22325598899994, 30.492254950000074],
              [-86.24331620999993, 30.49095286700009],
              [-86.28600012899994, 30.49746328300006],
              [-86.30528723899994, 30.49518463700008],
              [-86.34854081899994, 30.48541901200008],
              [-86.36790930899991, 30.48314036700009],
              [-86.38219153599994, 30.47842031500005],
              [-86.39468339799993, 30.468817450000074],
              [-86.40835527299993, 30.461411851000037],
              [-86.42625891799992, 30.463324286000045],
              [-86.43980872299994, 30.47614166900007],
              [-86.43521074099993, 30.49091217700004],
              [-86.41266842399995, 30.517971096000053],
              [-86.43663489499994, 30.51825592700004],
              [-86.44640051999994, 30.51634349200009],
              [-86.45360266799992, 30.51113515800006],
              [-86.46043860599991, 30.50023021000004],
              [-86.46983801999994, 30.501695054000038],
              [-86.4798070949999, 30.51113515800006],
              [-86.4883520169999, 30.52411530200004],
              [-86.4876195949999, 30.51235586100006],
              [-86.48253333199995, 30.487494208000044],
              [-86.48460852799991, 30.48004791900007],
              [-86.49498450399994, 30.473089911000045],
              [-86.50690670499995, 30.46775950700004],
              [-86.51976477799991, 30.464504299000055],
              [-86.53270423099991, 30.463324286000045],
              [-86.54165605399993, 30.46002838700008],
              [-86.55406653599994, 30.44550202000005],
              [-86.56651770699995, 30.442206122000073],
              [-86.5899145169999, 30.44521719000005],
              [-86.59117591099994, 30.44082265800006],
              [-86.59072831899994, 30.425482489000046],
              [-86.60228430899991, 30.41828034100007],
              [-86.68008378799993, 30.422308661000045],
              [-86.76138261599993, 30.41474030200004],
              [-86.7825414699999, 30.422308661000045],
              [-86.80459550699993, 30.412543036000045],
              [-86.83291581899994, 30.40851471600007],
              [-86.88898678299995, 30.40810781500005],
              [-87.04450436099995, 30.389593817000048],
              [-87.14395097599993, 30.365708726000037],
              [-87.19408118399991, 30.360296942000048],
              [-87.19005286399994, 30.37132396000004],
              [-87.18358313699991, 30.37571849200009],
              [-87.17544511599993, 30.377427476000037],
              [-87.13809160099993, 30.392645575000074],
              [-87.07774817599994, 30.40688711100006],
              [-87.02310136599993, 30.407375393000052],
              [-87.00523841099994, 30.410223700000074],
              [-86.94017493399991, 30.45648834800005],
              [-86.92699133999992, 30.451727606000077],
              [-86.90835527299993, 30.44277578300006],
              [-86.89378821499992, 30.43891022300005],
              [-86.89240475199995, 30.449652411000045],
              [-86.90453040299991, 30.46161530200004],
              [-86.92520097599993, 30.47016022300005],
              [-86.94758053299995, 30.47524648600006],
              [-86.96442623599995, 30.476996161000045],
              [-86.97337805899991, 30.481350002000056],
              [-86.98680579299992, 30.500555731000077],
              [-86.99136308499993, 30.50486888200004],
              [-87.00121008999992, 30.505031643000052],
              [-87.00869706899994, 30.50657786700009],
              [-87.01353919199994, 30.51129791900007],
              [-87.01528886599993, 30.52106354400007],
              [-87.00934811099995, 30.53538646000004],
              [-86.99474036399994, 30.546128648000035],
              [-86.96068274599992, 30.559515692000048],
              [-86.96149654899995, 30.564154364000046],
              [-86.96271725199995, 30.56704336100006],
              [-86.96812903599994, 30.573187567000048],
              [-86.98721269399994, 30.562567450000074],
              [-86.99754798099991, 30.575873114000046],
              [-87.00845292899993, 30.59642161700009],
              [-87.02961178299995, 30.60732656500005],
              [-87.02013098899994, 30.589667059000078],
              [-87.02122962099992, 30.57965729400007],
              [-87.02643795499995, 30.57245514500005],
              [-87.04784094999991, 30.518133856000077],
              [-87.06045488199993, 30.49485911700009],
              [-87.06753495999993, 30.460598049000055],
              [-87.07738196499992, 30.449652411000045],
              [-87.09292558499993, 30.448919989000046],
              [-87.09837805899991, 30.46051666900007],
              [-87.09675045499995, 30.47687409100007],
              [-87.09097245999993, 30.490627346000053],
              [-87.0977270169999, 30.503892320000034],
              [-87.10118567599994, 30.52171458500004],
              [-87.10960852799991, 30.535956122000073],
              [-87.13133704299992, 30.538397528000075],
              [-87.12950598899994, 30.54319896000004],
              [-87.1270238919999, 30.554754950000074],
              [-87.12511145699995, 30.559515692000048],
              [-87.14224199099993, 30.561835028000075],
              [-87.14928137899994, 30.57054271000004],
              [-87.15440833199995, 30.580552476000037],
              [-87.16612708199995, 30.586818752000056],
              [-87.18057206899994, 30.58466217700004],
              [-87.18419348899994, 30.57412344000005],
              [-87.18040930899991, 30.542141018000052],
              [-87.17613684799994, 30.52993398600006],
              [-87.15733801999994, 30.50458405200004],
              [-87.15306555899991, 30.486883856000077],
              [-87.15680904899995, 30.47451406500005],
              [-87.18040930899991, 30.435980536000045],
              [-87.18663489499994, 30.435980536000045],
              [-87.1887914699999, 30.438421942000048],
              [-87.18984941299993, 30.43935781500005],
              [-87.19408118399991, 30.442206122000073],
              [-87.20238196499992, 30.41893138200004],
              [-87.22154700399994, 30.41278717700004],
              [-87.24413001199991, 30.411078192000048],
              [-87.26292883999992, 30.401271877000056],
              [-87.26537024599992, 30.39158763200004],
              [-87.26235917899993, 30.367010809000078],
              [-87.26602128799993, 30.357163804000038],
              [-87.27476966099994, 30.35301341400009],
              [-87.29991614499994, 30.349676825000074],
              [-87.31012936099995, 30.346625067000048],
              [-87.30654863199993, 30.328558661000045],
              [-87.32884680899991, 30.31972890800006],
              [-87.47105872299994, 30.29368724200009],
              [-87.48827063699991, 30.285142320000034],
              [-87.49640865799995, 30.287502346000053],
              [-87.51846269399994, 30.282171942000048],
              [-87.52920488199993, 30.277736721000053],
              [-87.52920488199993, 30.285142320000034],
              [-87.5176488919999, 30.289211330000057],
              [-87.51073157499991, 30.29450104400007],
              [-87.50475012899994, 30.30023834800005],
              [-87.49571692599994, 30.30565013200004],
              [-87.48424231699994, 30.308661200000074],
              [-87.4473363919999, 30.31313711100006],
              [-87.46442623599995, 30.320868231000077],
              [-87.48204505099994, 30.326117255000042],
              [-87.46983801999994, 30.330226955000057],
              [-87.44505774599992, 30.329738674000055],
              [-87.43301347599993, 30.33234284100007],
              [-87.42145748599995, 30.34003327000005],
              [-87.41392981699994, 30.350165106000077],
              [-87.41454016799992, 30.360256252000056],
              [-87.42682857999995, 30.367743231000077],
              [-87.42682857999995, 30.37457916900007],
              [-87.39736894399994, 30.40534088700008],
              [-87.37877356699994, 30.41746653900009],
              [-87.35484778599994, 30.422308661000045],
              [-87.34561113199993, 30.427679755000042],
              [-87.34483801999994, 30.439886786000045],
              [-87.35008704299992, 30.453599351000037],
              [-87.35850989499994, 30.463324286000045],
              [-87.36709550699993, 30.465277411000045],
              [-87.38707434799994, 30.463283596000053],
              [-87.39574133999992, 30.46637604400007],
              [-87.40269934799994, 30.47134023600006],
              [-87.42682857999995, 30.48314036700009],
              [-87.42682857999995, 30.476996161000045],
              [-87.41958574099993, 30.468085028000075],
              [-87.41193600199995, 30.461086330000057],
              [-87.40294348899994, 30.455064195000034],
              [-87.39207923099991, 30.449652411000045],
              [-87.39952551999994, 30.449652411000045],
              [-87.40111243399991, 30.44013092700004],
              [-87.44391842399995, 30.404689846000053],
              [-87.4544164699999, 30.388373114000046],
              [-87.46157792899993, 30.371975002000056],
              [-87.47370357999995, 30.359198309000078],
              [-87.4988500639999, 30.354071356000077],
              [-87.51357988199993, 30.348211981000077],
              [-87.52253170499995, 30.335638739000046],
              [-87.53408769399994, 30.323553778000075],
              [-87.55719967399995, 30.319281317000048],
              [-87.57286536399994, 30.321519273000035],
              [-87.57725989499994, 30.325425523000035],
              [-87.57823645699995, 30.33144765800006],
              [-87.58385169199994, 30.339789130000042],
              [-87.60122636599993, 30.35370514500005],
              [-87.60558020699995, 30.360296942000048],
              [-87.61180579299992, 30.360296942000048],
              [-87.60997473899994, 30.343573309000078],
              [-87.60326087099992, 30.332831122000073],
              [-87.59927324099993, 30.322211005000042],
              [-87.60558020699995, 30.30565013200004],
              [-87.59447180899991, 30.30487702000005],
              [-87.58360755099994, 30.305975653000075],
              [-87.57359778599994, 30.30878327000005],
              [-87.56456458199995, 30.31313711100006],
              [-87.59015865799995, 30.275376695000034],
              [-87.65453040299991, 30.252101955000057],
              [-87.78648841099994, 30.236761786000045],
              [-87.91030839799993, 30.236761786000045],
              [-87.99840247299994, 30.22361888200004],
              [-88.03014075399994, 30.223781643000052],
              [-88.01817786399994, 30.23383209800005],
              [-87.99575761599993, 30.242336330000057],
              [-87.95750891799992, 30.250433661000045],
              [-87.94884192599994, 30.254706122000073],
              [-87.94294186099995, 30.262152411000045],
              [-87.93578040299991, 30.264593817000048],
              [-87.91454016799992, 30.247870184000078],
              [-87.8750707669999, 30.241522528000075],
              [-87.83820553299995, 30.25218333500004],
              [-87.79234778599994, 30.262884833000044],
              [-87.76423092399995, 30.27952708500004],
              [-87.77623450399994, 30.31313711100006],
              [-87.82347571499992, 30.35179271000004],
              [-87.8308813139999, 30.36399974200009],
              [-87.82835852799991, 30.374945380000042],
              [-87.81956946499992, 30.397040106000077],
              [-87.82127844999991, 30.404689846000053],
              [-87.83039303299995, 30.412543036000045],
              [-87.83446204299992, 30.412502346000053],
              [-87.83788001199991, 30.40766022300005],
              [-87.85114498599995, 30.393500067000048],
              [-87.84959876199991, 30.388657945000034],
              [-87.85073808499993, 30.386704820000034],
              [-87.86563066299993, 30.387600002000056],
              [-87.87710527299993, 30.389593817000048],
              [-87.88703365799995, 30.39325592700004],
              [-87.89574133999992, 30.398382880000042],
              [-87.90347245999993, 30.404689846000053],
              [-87.91136633999992, 30.41356028900009],
              [-87.91657467399995, 30.42332591400009],
              [-87.91934160099993, 30.434068101000037],
              [-87.92027747299994, 30.44594961100006],
              [-87.92332923099991, 30.458197333000044],
              [-87.93008378799993, 30.468817450000074],
              [-87.93712317599994, 30.47728099200009],
              [-87.9407445949999, 30.48314036700009],
              [-87.93883216099994, 30.499823309000078],
              [-87.93065344999991, 30.51911041900007],
              [-87.9199926419999, 30.536851304000038],
              [-87.91030839799993, 30.548976955000057],
              [-87.90689042899993, 30.563666083000044],
              [-87.91246497299994, 30.583726304000038],
              [-87.94253495999993, 30.65973541900007],
              [-87.95384680899991, 30.672430731000077],
              [-87.97549394399994, 30.682440497000073],
              [-87.98818925699993, 30.68431224200009],
              [-87.99889075399994, 30.684515692000048],
              [-88.00625566299993, 30.68781159100007],
              [-88.00902258999992, 30.69953034100007],
              [-88.00869706899994, 30.71385325700004],
              [-88.00987708199995, 30.726629950000074],
              [-88.01598059799994, 30.73533763200004],
              [-88.03014075399994, 30.73769765800006],
              [-88.02281653599994, 30.723578192000048],
              [-88.02301998599995, 30.709377346000053],
              [-88.03014075399994, 30.697211005000042],
              [-88.04381262899994, 30.689195054000038],
              [-88.03766842399995, 30.67519765800006],
              [-88.04328365799995, 30.665187893000052],
              [-88.05256100199995, 30.654364325000074],
              [-88.0574438139999, 30.63776276200008],
              [-88.05874589799993, 30.61782461100006],
              [-88.06289628799993, 30.60447825700004],
              [-88.07030188699991, 30.594142971000053],
              [-88.08104407499991, 30.583156643000052],
              [-88.08458411399994, 30.576157945000034],
              [-88.08556067599994, 30.56708405200004],
              [-88.0847875639999, 30.548976955000057],
              [-88.08682206899994, 30.540961005000042],
              [-88.09630286399994, 30.529730536000045],
              [-88.09837805899991, 30.52106354400007],
              [-88.10049394399994, 30.504787502000056],
              [-88.10993404899995, 30.47089264500005],
              [-88.11204993399991, 30.453070380000042],
              [-88.11021887899994, 30.41120026200008],
              [-88.12010657499991, 30.338324286000045],
              [-88.12633216099994, 30.326117255000042],
              [-88.13768469999991, 30.31976959800005],
              [-88.14224199099993, 30.32257721600007],
              [-88.14391028599994, 30.32880280200004],
              [-88.14614824099993, 30.33234284100007],
              [-88.16685950399994, 30.332831122000073],
              [-88.1673070949999, 30.33234284100007],
              [-88.18407141799992, 30.333970445000034],
              [-88.19408118399991, 30.337103583000044],
              [-88.19566809799994, 30.346625067000048],
              [-88.18712317599994, 30.367743231000077],
              [-88.21629798099991, 30.37726471600007],
              [-88.27794348899994, 30.389064846000053],
              [-88.30382239499994, 30.401271877000056],
              [-88.30532792899993, 30.39362213700008],
              [-88.30711829299992, 30.389593817000048],
              [-88.30899003799993, 30.38621653900009],
              [-88.31126868399991, 30.38076406500005],
              [-88.31749426999994, 30.38076406500005],
              [-88.33543860599991, 30.40387604400007],
              [-88.35533606699994, 30.40375397300005],
              [-88.3777563139999, 30.393866278000075],
              [-88.4031469389999, 30.387600002000056],
              [-88.40733801999994, 30.38239166900007],
              [-88.40656490799995, 30.370835679000038],
              [-88.4075414699999, 30.359320380000042],
              [-88.41738847599993, 30.354071356000077],
              [-88.43053137899994, 30.351996161000045],
              [-88.43675696499992, 30.346625067000048],
              [-88.44090735599991, 30.339585679000038],
              [-88.44782467399995, 30.33234284100007],
              [-88.47057044199994, 30.323879299000055],
              [-88.48770097599993, 30.32998281500005],
              [-88.50625566299993, 30.34080638200004],
              [-88.53319251199991, 30.346625067000048],
              [-88.54613196499992, 30.34674713700008],
              [-88.55846106699994, 30.348456122000073],
              [-88.56773841099994, 30.353583075000074],
              [-88.5742895169999, 30.374660549000055],
              [-88.58755449099993, 30.383612372000073],
              [-88.59121660099993, 30.395005601000037],
              [-88.59870357999995, 30.395005601000037],
              [-88.61693274599992, 30.370347398000035],
              [-88.66222083199995, 30.35455963700008],
              [-88.71165930899991, 30.35028717700004],
              [-88.74205481699994, 30.354071356000077],
              [-88.84585527299993, 30.42259349200009],
              [-88.92764238199993, 30.442206122000073],
              [-88.95189368399991, 30.43235911700009],
              [-88.96605383999992, 30.428900458000044],
              [-88.98228919199994, 30.428534247000073],
              [-88.98228919199994, 30.422308661000045],
              [-88.85936438699991, 30.40810781500005],
              [-88.87608801999994, 30.39520905200004],
              [-88.90713456899994, 30.39280833500004],
              [-88.96861731699994, 30.395005601000037],
              [-88.98232988199993, 30.39093659100007],
              [-89.01341712099992, 30.377427476000037],
              [-89.02696692599994, 30.37457916900007],
              [-89.04356848899994, 30.372748114000046],
              [-89.11473548099991, 30.352362372000073],
              [-89.17788652299993, 30.337225653000075],
              [-89.24022376199991, 30.320746161000045],
              [-89.25348873599995, 30.319281317000048],
              [-89.27098548099991, 30.322821356000077],
              [-89.27334550699993, 30.33079661700009],
              [-89.26488196499992, 30.339992580000057],
              [-89.24974524599992, 30.346625067000048],
              [-89.26797441299993, 30.355210679000038],
              [-89.30016028599994, 30.37653229400007],
              [-89.32176673099991, 30.38076406500005],
              [-89.33193925699993, 30.37714264500005],
              [-89.34496008999992, 30.36863841400009],
              [-89.3548070949999, 30.358587958000044],
              [-89.35558020699995, 30.35032786700009],
              [-89.34727942599994, 30.347479559000078],
              [-89.32359778599994, 30.34642161700009],
              [-89.31867428299995, 30.34320709800005],
              [-89.31834876199991, 30.323960679000038],
              [-89.32054602799991, 30.31207916900007],
              [-89.33023027299993, 30.302883205000057],
              [-89.42105058499993, 30.257798570000034],
              [-89.41380774599992, 30.244696356000077],
              [-89.41808020699995, 30.234116929000038],
              [-89.43472245999993, 30.21625397300005],
              [-89.43781490799995, 30.20575592700004],
              [-89.43858801999994, 30.197333075000074],
              [-89.44253495999993, 30.18976471600007],
              [-89.45518958199995, 30.18154531500005],
              [-89.46202551999994, 30.18895091400009],
              [-89.45677649599992, 30.194647528000075],
              [-89.45954342399995, 30.19717031500005],
              [-89.46825110599991, 30.203273830000057],
              [-89.47687740799995, 30.193345445000034],
              [-89.49107825399994, 30.188666083000044],
              [-89.5059301419999, 30.189439195000034],
              [-89.51667232999995, 30.195786851000037],
              [-89.5235082669999, 30.195786851000037],
              [-89.52599036399994, 30.19277578300006],
              [-89.53636633999992, 30.18032461100006],
              [-89.56550045499995, 30.16347890800006],
              [-89.59593665299991, 30.155910549000055],
              [-89.61290442599994, 30.168524481000077],
              [-89.60317949099993, 30.16864655200004],
              [-89.59691321499992, 30.170396226000037],
              [-89.58556067599994, 30.17527903900009],
              [-89.59601803299995, 30.18699778900009],
              [-89.60977128799993, 30.18573639500005],
              [-89.62584387899994, 30.17918528900009],
              [-89.64329993399991, 30.17527903900009],
              [-89.67638098899994, 30.180609442000048],
              [-89.69225012899994, 30.181301174000055],
              [-89.70840410099993, 30.17527903900009],
              [-89.71544348899994, 30.179429429000038],
              [-89.73607337099992, 30.18496328300006],
              [-89.74323482999995, 30.18895091400009],
              [-89.74815833199995, 30.197211005000042],
              [-89.74754798099991, 30.203680731000077],
              [-89.74486243399991, 30.21051666900007],
              [-89.74323482999995, 30.220038153000075],
              [-89.75145423099991, 30.23737213700008],
              [-89.7703344389999, 30.23969147300005],
              [-89.80467688699991, 30.22992584800005],
              [-89.8262426419999, 30.231594143000052],
              [-89.86204993399991, 30.25800202000005],
              [-89.88377844999991, 30.26471588700008],
              [-89.89476477799991, 30.26357656500005],
              [-89.91356360599991, 30.258978583000044],
              [-89.92442786399994, 30.257798570000034],
              [-89.96914628799993, 30.26471588700008],
              [-89.97850501199991, 30.275376695000034],
              [-89.99982662699995, 30.313055731000077],
              [-90.00389563699991, 30.322699286000045],
              [-90.01268469999991, 30.326239325000074],
              [-90.05850175699993, 30.360296942000048],
              [-90.09601803299995, 30.37372467700004],
              [-90.14346269399994, 30.38507721600007],
              [-90.18944251199991, 30.39081452000005],
              [-90.22240149699991, 30.38757965700006],
              [-90.24547278599994, 30.37372467700004],
              [-90.26842200399994, 30.352687893000052],
              [-90.30557206899994, 30.30565013200004],
              [-90.33116614499994, 30.27602773600006],
              [-90.40501868399991, 30.22016022300005],
              [-90.42845618399991, 30.18895091400009],
              [-90.43297278599994, 30.14329661700009],
              [-90.41405188699991, 30.106594143000052],
              [-90.37999426999994, 30.08038971600007],
              [-90.33910071499992, 30.066066799000055],
              [-90.26622473899994, 30.06012604400007],
              [-90.23102779899995, 30.03974030200004],
              [-90.16836503799993, 30.02448151200008],
              [-90.14517167899993, 30.023830471000053],
              [-90.10448157499991, 30.03506094000005],
              [-90.03697669199994, 30.040269273000035],
              [-90.01626542899993, 30.044582424000055],
              [-89.99644934799994, 30.052435614000046],
              [-89.92731686099995, 30.095526434000078],
              [-89.89952551999994, 30.122748114000046],
              [-89.88044186099995, 30.154852606000077],
              [-89.85728919199994, 30.151190497000073],
              [-89.84927324099993, 30.145331122000073],
              [-89.84626217399995, 30.130601304000038],
              [-89.84072831899994, 30.120266018000052],
              [-89.82762610599991, 30.111070054000038],
              [-89.81167558499993, 30.103908596000053],
              [-89.79784094999991, 30.099554755000042],
              [-89.78880774599992, 30.098863023000035],
              [-89.78624426999994, 30.10309479400007],
              [-89.78351803299995, 30.11155833500004],
              [-89.76158606699994, 30.136542059000078],
              [-89.75283769399994, 30.14911530200004],
              [-89.74693762899994, 30.161851304000038],
              [-89.74323482999995, 30.17527903900009],
              [-89.7363988919999, 30.17527903900009],
              [-89.72891191299993, 30.16168854400007],
              [-89.73924719999991, 30.149318752000056],
              [-89.75035559799994, 30.12335846600007],
              [-89.75690670499995, 30.11391836100006],
              [-89.75413977799991, 30.111395575000074],
              [-89.75031490799995, 30.10887278900009],
              [-89.74640865799995, 30.105292059000078],
              [-89.74323482999995, 30.099554755000042],
              [-89.72956295499995, 30.123480536000045],
              [-89.72891191299993, 30.126898505000042],
              [-89.72280839799993, 30.127508856000077],
              [-89.70767167899993, 30.125433661000045],
              [-89.70225989499994, 30.126898505000042],
              [-89.68846594999991, 30.135239976000037],
              [-89.68342037699995, 30.14004140800006],
              [-89.68114173099991, 30.14801666900007],
              [-89.68358313699991, 30.154242255000042],
              [-89.68911699099993, 30.155585028000075],
              [-89.6941625639999, 30.153143622000073],
              [-89.69481360599991, 30.14801666900007],
              [-89.6985570949999, 30.14789459800005],
              [-89.70645097599993, 30.150213934000078],
              [-89.71198482999995, 30.154771226000037],
              [-89.70840410099993, 30.16168854400007],
              [-89.68114173099991, 30.168524481000077],
              [-89.66738847599993, 30.164007880000042],
              [-89.65001380099994, 30.146429755000042],
              [-89.63955644399994, 30.140570380000042],
              [-89.65294348899994, 30.123480536000045],
              [-89.66649329299992, 30.11359284100007],
              [-89.67690995999993, 30.101223049000055],
              [-89.68114173099991, 30.07636139500005],
              [-89.71051998599995, 30.067531643000052],
              [-89.71898352799991, 30.062323309000078],
              [-89.7219945949999, 30.05182526200008],
              [-89.71861731699994, 30.042222398000035],
              [-89.71792558499993, 30.033270575000074],
              [-89.72891191299993, 30.02448151200008],
              [-89.74767005099994, 30.041001695000034],
              [-89.77358964799993, 30.050482489000046],
              [-89.80044511599993, 30.051214911000045],
              [-89.82209225199995, 30.041571356000077],
              [-89.83511308499993, 30.026312567000048],
              [-89.84040279899995, 30.011419989000046],
              [-89.83893795499995, 29.995347398000035],
              [-89.83193925699993, 29.976711330000057],
              [-89.82192949099993, 29.95734284100007],
              [-89.81114661399994, 29.94717031500005],
              [-89.79434160099993, 29.94326406500005],
              [-89.76683508999992, 29.942572333000044],
              [-89.75121008999992, 29.94684479400007],
              [-89.71662350199995, 29.96051666900007],
              [-89.70840410099993, 29.956203518000052],
              [-89.71092688699991, 29.94993724200009],
              [-89.72524980399993, 29.933417059000078],
              [-89.72891191299993, 29.92206452000005],
              [-89.70531165299991, 29.89789459800005],
              [-89.68651282499991, 29.882554429000038],
              [-89.66454016799992, 29.875474351000037],
              [-89.64159094999991, 29.875148830000057],
              [-89.61969967399995, 29.87986888200004],
              [-89.60240637899994, 29.890773830000057],
              [-89.58690344999991, 29.909125067000048],
              [-89.57559160099993, 29.93105703300006],
              [-89.57127844999991, 29.952460028000075],
              [-89.57119706899994, 29.98847077000005],
              [-89.56558183499993, 30.000921942000048],
              [-89.55142167899993, 30.011419989000046],
              [-89.54161536399994, 30.014878648000035],
              [-89.52114824099993, 30.019354559000078],
              [-89.51048743399991, 30.02448151200008],
              [-89.50308183499993, 30.03074778900009],
              [-89.49889075399994, 30.037095445000034],
              [-89.4954320949999, 30.044134833000044],
              [-89.48997962099992, 30.052435614000046],
              [-89.48827063699991, 30.057806708000044],
              [-89.48932857999995, 30.07054271000004],
              [-89.48623613199993, 30.07636139500005],
              [-89.47907467399995, 30.07998281500005],
              [-89.47362219999991, 30.07831452000005],
              [-89.46825110599991, 30.07290273600006],
              [-89.45718339799993, 30.071112372000073],
              [-89.43472245999993, 30.062567450000074],
              [-89.42731686099995, 30.058661200000074],
              [-89.42731686099995, 30.052435614000046],
              [-89.43472245999993, 30.052435614000046],
              [-89.43472245999993, 30.044989325000074],
              [-89.43122311099995, 30.042792059000078],
              [-89.43008378799993, 30.042710679000038],
              [-89.42935136599993, 30.04205963700008],
              [-89.42731686099995, 30.03807200700004],
              [-89.42105058499993, 30.03807200700004],
              [-89.41502844999991, 30.04364655200004],
              [-89.39370683499993, 30.05654531500005],
              [-89.38634192599994, 30.058661200000074],
              [-89.37254798099991, 30.054673570000034],
              [-89.3660375639999, 30.048651434000078],
              [-89.36815344999991, 30.040838934000078],
              [-89.38011633999992, 30.03192780200004],
              [-89.39370683499993, 30.029120184000078],
              [-89.4219457669999, 30.031236070000034],
              [-89.43472245999993, 30.02448151200008],
              [-89.44058183499993, 30.014227606000077],
              [-89.43883216099994, 30.00608958500004],
              [-89.43496660099993, 29.998439846000053],
              [-89.43472245999993, 29.98969147300005],
              [-89.4422094389999, 29.98305898600006],
              [-89.45189368399991, 29.979641018000052],
              [-89.45470130099994, 29.976385809000078],
              [-89.44155839799993, 29.969875393000052],
              [-89.42894446499992, 29.968695380000042],
              [-89.40074622299994, 29.973049221000053],
              [-89.38634192599994, 29.969875393000052],
              [-89.37022864499994, 29.95075104400007],
              [-89.38174394399994, 29.935532945000034],
              [-89.40078691299993, 29.932114976000037],
              [-89.40746008999992, 29.94879791900007],
              [-89.43472245999993, 29.93512604400007],
              [-89.43472245999993, 29.928900458000044],
              [-89.42048092399995, 29.91201406500005],
              [-89.41364498599995, 29.90778229400007],
              [-89.41502844999991, 29.907131252000056],
              [-89.41331946499992, 29.90615469000005],
              [-89.41364498599995, 29.901556708000044],
              [-89.40746008999992, 29.901556708000044],
              [-89.4016820949999, 29.909125067000048],
              [-89.39045162699995, 29.916449286000045],
              [-89.3782445949999, 29.92055898600006],
              [-89.36953691299993, 29.91864655200004],
              [-89.36668860599991, 29.908026434000078],
              [-89.37425696499992, 29.89907461100006],
              [-89.39378821499992, 29.88735586100006],
              [-89.39378821499992, 29.87986888200004],
              [-89.37877356699994, 29.88377513200004],
              [-89.37287350199995, 29.88739655200004],
              [-89.36644446499992, 29.89411041900007],
              [-89.35985266799992, 29.89008209800005],
              [-89.33169511599993, 29.87986888200004],
              [-89.35244706899994, 29.869289455000057],
              [-89.35899817599994, 29.866848049000055],
              [-89.35301673099991, 29.863714911000045],
              [-89.35033118399991, 29.86078522300005],
              [-89.34862219999991, 29.857407945000034],
              [-89.34532630099994, 29.853216864000046],
              [-89.35789954299992, 29.85187409100007],
              [-89.36754309799994, 29.846828518000052],
              [-89.37474524599992, 29.839992580000057],
              [-89.38011633999992, 29.833319403000075],
              [-89.37218176999994, 29.82184479400007],
              [-89.36620032499991, 29.809719143000052],
              [-89.35850989499994, 29.798976955000057],
              [-89.34532630099994, 29.79169342700004],
              [-89.35562089799993, 29.79242584800005],
              [-89.37889563699991, 29.79783763200004],
              [-89.38634192599994, 29.79791901200008],
              [-89.39464270699995, 29.790838934000078],
              [-89.40428626199991, 29.771307684000078],
              [-89.41364498599995, 29.76439036700009],
              [-89.41173255099994, 29.771144924000055],
              [-89.40973873599995, 29.785101630000042],
              [-89.40746008999992, 29.79169342700004],
              [-89.42003333199995, 29.79197825700004],
              [-89.42723548099991, 29.798041083000044],
              [-89.43814042899993, 29.81590403900009],
              [-89.44640051999994, 29.823187567000048],
              [-89.45677649599992, 29.829250393000052],
              [-89.46906490799995, 29.832912502000056],
              [-89.48253333199995, 29.833319403000075],
              [-89.47809811099995, 29.815659898000035],
              [-89.48717200399994, 29.80292389500005],
              [-89.50243079299992, 29.79169342700004],
              [-89.51667232999995, 29.77871328300006],
              [-89.52725175699993, 29.76072825700004],
              [-89.5325414699999, 29.75584544500009],
              [-89.54458574099993, 29.750799872000073],
              [-89.55431067599994, 29.749823309000078],
              [-89.57628333199995, 29.75259023600006],
              [-89.58556067599994, 29.750799872000073],
              [-89.60147050699993, 29.734849351000037],
              [-89.60383053299995, 29.71625397300005],
              [-89.5969945949999, 29.69940827000005],
              [-89.58556067599994, 29.688706773000035],
              [-89.56566321499992, 29.685939846000053],
              [-89.54255123599995, 29.68821849200009],
              [-89.52212480399993, 29.687323309000078],
              [-89.51048743399991, 29.675034898000035],
              [-89.51724199099993, 29.676336981000077],
              [-89.52212480399993, 29.67601146000004],
              [-89.52627519399994, 29.67519765800006],
              [-89.53091386599993, 29.675034898000035],
              [-89.51602128799993, 29.667303778000075],
              [-89.48253333199995, 29.64085521000004],
              [-89.48253333199995, 29.634100653000075],
              [-89.49990800699993, 29.63548411700009],
              [-89.51382402299993, 29.64398834800005],
              [-89.52574622299994, 29.654364325000074],
              [-89.5371801419999, 29.661363023000035],
              [-89.56818600199995, 29.667222398000035],
              [-89.59581458199995, 29.668850002000056],
              [-89.62376868399991, 29.674627997000073],
              [-89.67251542899993, 29.70148346600007],
              [-89.70225989499994, 29.709784247000073],
              [-89.69351152299993, 29.69879791900007],
              [-89.66722571499992, 29.68500397300005],
              [-89.65387936099995, 29.675034898000035],
              [-89.65794837099992, 29.67373281500005],
              [-89.66746985599991, 29.668850002000056],
              [-89.64704342399995, 29.661363023000035],
              [-89.64659583199995, 29.65656159100007],
              [-89.64704342399995, 29.65452708500004],
              [-89.64541581899994, 29.650091864000046],
              [-89.61969967399995, 29.62726471600007],
              [-89.63906816299993, 29.620266018000052],
              [-89.72223873599995, 29.639878648000035],
              [-89.75690670499995, 29.634100653000075],
              [-89.73265540299991, 29.628119208000044],
              [-89.72276770699995, 29.623195705000057],
              [-89.71593176999994, 29.61359284100007],
              [-89.72573808499993, 29.61395905200004],
              [-89.72891191299993, 29.61359284100007],
              [-89.72325598899994, 29.601629950000074],
              [-89.69481360599991, 29.572007554000038],
              [-89.68960527299993, 29.560288804000038],
              [-89.68374589799993, 29.537990627000056],
              [-89.67804928299995, 29.527899481000077],
              [-89.66836503799993, 29.52179596600007],
              [-89.64098059799994, 29.51365794500009],
              [-89.61754309799994, 29.500555731000077],
              [-89.59243730399993, 29.502875067000048],
              [-89.57811438699991, 29.49750397300005],
              [-89.58263098899994, 29.49445221600007],
              [-89.58324133999992, 29.493353583000044],
              [-89.58556067599994, 29.490057684000078],
              [-89.5691625639999, 29.48460521000004],
              [-89.54157467399995, 29.470851955000057],
              [-89.5235082669999, 29.469631252000056],
              [-89.5235082669999, 29.46279531500005],
              [-89.53368079299992, 29.44912344000005],
              [-89.53742428299995, 29.43500397300005],
              [-89.53246008999992, 29.427801825000074],
              [-89.51667232999995, 29.434800523000035],
              [-89.51895097599993, 29.41815827000005],
              [-89.52879798099991, 29.41156647300005],
              [-89.53962154899995, 29.409979559000078],
              [-89.54458574099993, 29.408148505000042],
              [-89.5398656889999, 29.397772528000075],
              [-89.52916419199994, 29.39321523600006],
              [-89.51577714799993, 29.392523505000042],
              [-89.45612545499995, 29.403509833000044],
              [-89.43394934799994, 29.403469143000052],
              [-89.41364498599995, 29.393866278000075],
              [-89.41063391799992, 29.390773830000057],
              [-89.40099036399994, 29.39248281500005],
              [-89.39273027299993, 29.391791083000044],
              [-89.38634192599994, 29.387640692000048],
              [-89.38011633999992, 29.387640692000048],
              [-89.37214107999995, 29.392645575000074],
              [-89.36164303299995, 29.394354559000078],
              [-89.35016842399995, 29.392645575000074],
              [-89.33678137899994, 29.390570380000042],
              [-89.33702551999994, 29.385239976000037],
              [-89.34357662699995, 29.381293036000045],
              [-89.35179602799991, 29.380194403000075],
              [-89.36270097599993, 29.380194403000075],
              [-89.37352454299992, 29.377020575000074],
              [-89.37979081899994, 29.370021877000056],
              [-89.3809301419999, 29.362941799000055],
              [-89.37637285099993, 29.359767971000053],
              [-89.36774654899995, 29.35761139500005],
              [-89.35317949099993, 29.348211981000077],
              [-89.34227454299992, 29.346096096000053],
              [-89.33409583199995, 29.34715403900009],
              [-89.31920325399994, 29.35179271000004],
              [-89.29824785099993, 29.35447825700004],
              [-89.29002844999991, 29.357123114000046],
              [-89.28136145699995, 29.35761139500005],
              [-89.27025305899991, 29.35293203300006],
              [-89.26406816299993, 29.34528229400007],
              [-89.2610570949999, 29.326320705000057],
              [-89.25719153599994, 29.318793036000045],
              [-89.24445553299995, 29.31598541900007],
              [-89.22712154899995, 29.322211005000042],
              [-89.21104895699995, 29.335272528000075],
              [-89.2019750639999, 29.35293203300006],
              [-89.19709225199995, 29.353461005000042],
              [-89.19566809799994, 29.352036851000037],
              [-89.19554602799991, 29.349351304000038],
              [-89.19448808499993, 29.346096096000053],
              [-89.18993079299992, 29.34638092700004],
              [-89.18773352799991, 29.340399481000077],
              [-89.18736731699994, 29.33038971600007],
              [-89.18834387899994, 29.318793036000045],
              [-89.17804928299995, 29.32298411700009],
              [-89.17406165299991, 29.32562897300005],
              [-89.1687719389999, 29.316229559000078],
              [-89.1621801419999, 29.31012604400007],
              [-89.15636145699995, 29.30296458500004],
              [-89.15355383999992, 29.290838934000078],
              [-89.14362545499995, 29.295843817000048],
              [-89.13988196499992, 29.29828522300005],
              [-89.13044186099995, 29.287502346000053],
              [-89.12694251199991, 29.276516018000052],
              [-89.12315833199995, 29.26788971600007],
              [-89.1126195949999, 29.264146226000037],
              [-89.11856035099993, 29.25543854400007],
              [-89.12653561099995, 29.249701239000046],
              [-89.13613847599993, 29.245917059000078],
              [-89.14736894399994, 29.243068752000056],
              [-89.14736894399994, 29.236802476000037],
              [-89.10578365799995, 29.226263739000046],
              [-89.10024980399993, 29.214585679000038],
              [-89.08714758999992, 29.20693594000005],
              [-89.07135982999995, 29.202826239000046],
              [-89.05797278599994, 29.202093817000048],
              [-89.06094316299993, 29.20612213700008],
              [-89.06480872299994, 29.21637604400007],
              [-89.04698645699995, 29.218451239000046],
              [-89.03246008999992, 29.216620184000078],
              [-89.02041581899994, 29.209458726000037],
              [-89.01016191299993, 29.195868231000077],
              [-89.03062903599994, 29.195868231000077],
              [-89.03062903599994, 29.188421942000048],
              [-89.02147376199991, 29.186835028000075],
              [-89.01740475199995, 29.184515692000048],
              [-89.01016191299993, 29.174750067000048],
              [-89.03189042899993, 29.180080471000053],
              [-89.03892981699994, 29.17792389500005],
              [-89.04369055899991, 29.167914130000042],
              [-89.05113684799994, 29.167914130000042],
              [-89.05101477799991, 29.174709377000056],
              [-89.0520727199999, 29.182562567000048],
              [-89.05113684799994, 29.188421942000048],
              [-89.0652563139999, 29.18496328300006],
              [-89.08311926999994, 29.173651434000078],
              [-89.0969945949999, 29.15961334800005],
              [-89.0989477199999, 29.147406317000048],
              [-89.08926347599993, 29.14862702000005],
              [-89.02318274599992, 29.147406317000048],
              [-89.0515844389999, 29.097357489000046],
              [-89.06480872299994, 29.086004950000074],
              [-89.06554114499994, 29.10114166900007],
              [-89.07152258999992, 29.112494208000044],
              [-89.08263098899994, 29.11904531500005],
              [-89.0989477199999, 29.119533596000053],
              [-89.09276282499991, 29.11090729400007],
              [-89.08751380099994, 29.10106028900009],
              [-89.08438066299993, 29.09015534100007],
              [-89.08462480399993, 29.078558661000045],
              [-89.09630286399994, 29.086859442000048],
              [-89.10130774599992, 29.091864325000074],
              [-89.10578365799995, 29.099676825000074],
              [-89.11107337099992, 29.08612702000005],
              [-89.12360592399995, 29.072088934000078],
              [-89.15050208199995, 29.048163153000075],
              [-89.15343176999994, 29.02993398600006],
              [-89.13365637899994, 28.996242580000057],
              [-89.14736894399994, 28.99042389500005],
              [-89.15778561099995, 28.99746328300006],
              [-89.18814042899993, 29.030462958000044],
              [-89.19448808499993, 29.04132721600007],
              [-89.19985917899993, 29.053127346000053],
              [-89.22476152299993, 29.091457424000055],
              [-89.23241126199991, 29.099676825000074],
              [-89.24278723899994, 29.10610586100006],
              [-89.24767005099994, 29.105902411000045],
              [-89.24974524599992, 29.09593333500004],
              [-89.24803626199991, 29.086371161000045],
              [-89.24522864499994, 29.07916901200008],
              [-89.24461829299992, 29.072699286000045],
              [-89.24974524599992, 29.064886786000045],
              [-89.26553300699993, 29.059393622000073],
              [-89.28868567599994, 29.056463934000078],
              [-89.30955969999991, 29.05019765800006],
              [-89.31867428299995, 29.034409898000035],
              [-89.32103430899991, 29.021551825000074],
              [-89.32705644399994, 29.00844961100006],
              [-89.37401282499991, 28.94745514500005],
              [-89.39167232999995, 28.933986721000053],
              [-89.41364498599995, 28.92837148600006],
              [-89.41014563699991, 28.960109768000052],
              [-89.40746008999992, 28.969305731000077],
              [-89.40176347599993, 28.97492096600007],
              [-89.38390051999994, 28.987616278000075],
              [-89.37718665299991, 28.99762604400007],
              [-89.35558020699995, 29.02049388200004],
              [-89.35057532499991, 29.03070709800005],
              [-89.35069739499994, 29.042181708000044],
              [-89.3523656889999, 29.05215078300006],
              [-89.35216223899994, 29.05805084800005],
              [-89.34333248599995, 29.06435781500005],
              [-89.32091223899994, 29.068426825000074],
              [-89.3118383449999, 29.072333075000074],
              [-89.29442298099991, 29.10651276200008],
              [-89.28722083199995, 29.117580471000053],
              [-89.27806555899991, 29.140448309000078],
              [-89.2761938139999, 29.160101630000042],
              [-89.29067949099993, 29.16111888200004],
              [-89.29271399599992, 29.153957424000055],
              [-89.29308020699995, 29.141180731000077],
              [-89.29576575399994, 29.129828192000048],
              [-89.30435136599993, 29.12693919500009],
              [-89.31094316299993, 29.133978583000044],
              [-89.31289628799993, 29.14667389500005],
              [-89.3118383449999, 29.17133209800005],
              [-89.31493079299992, 29.181341864000046],
              [-89.32176673099991, 29.18195221600007],
              [-89.32860266799992, 29.175482489000046],
              [-89.33169511599993, 29.164496161000045],
              [-89.3301488919999, 29.152777411000045],
              [-89.32445227799991, 29.13153717700004],
              [-89.32485917899993, 29.119533596000053],
              [-89.33751380099994, 29.103461005000042],
              [-89.36099199099993, 29.09170156500005],
              [-89.38365637899994, 29.087836005000042],
              [-89.39378821499992, 29.09593333500004],
              [-89.40489661399994, 29.122870184000078],
              [-89.40396074099993, 29.13035716400009],
              [-89.3985082669999, 29.141913153000075],
              [-89.40623938699991, 29.148138739000046],
              [-89.42731686099995, 29.15493398600006],
              [-89.48253333199995, 29.243068752000056],
              [-89.47386633999992, 29.243353583000044],
              [-89.45518958199995, 29.250474351000037],
              [-89.47447669199994, 29.25918203300006],
              [-89.49510657499991, 29.259507554000038],
              [-89.50609290299991, 29.250148830000057],
              [-89.49620520699995, 29.229396877000056],
              [-89.55500240799995, 29.248439846000053],
              [-89.58185787699995, 29.250474351000037],
              [-89.6082250639999, 29.25604889500005],
              [-89.61701412699995, 29.269354559000078],
              [-89.62267005099994, 29.28514232000009],
              [-89.63560701699993, 29.29323713100007],
              [-89.6620041509999, 29.300930209000057],
              [-89.6690172029999, 29.294730067000046],
              [-89.6866872999999, 29.29630651000008],
              [-89.73234912599992, 29.30610306400007],
              [-89.79499799099995, 29.312683680000077],
              [-89.81814592099994, 29.31615996000005],
              [-89.79353141299993, 29.328088121000064],
              [-89.77462724199995, 29.332415119000075],
              [-89.7577051049999, 29.343163106000077],
              [-89.74978699299993, 29.355809356000066],
              [-89.7438055799999, 29.369842817000062],
              [-89.74521922799994, 29.384948827000073],
              [-89.75009984499991, 29.39219522800005],
              [-89.76305091099994, 29.393866278000075],
              [-89.76829993399991, 29.389105536000045],
              [-89.77171790299991, 29.387152411000045],
              [-89.77440344999991, 29.38499583500004],
              [-89.77733313699991, 29.380194403000075],
              [-89.78180904899995, 29.39166901200008],
              [-89.77887936099995, 29.398871161000045],
              [-89.77342688699991, 29.404689846000053],
              [-89.77057857999995, 29.41156647300005],
              [-89.77550208199995, 29.420803127000056],
              [-89.78697669199994, 29.418524481000077],
              [-89.80842037699995, 29.408148505000042],
              [-89.8145238919999, 29.41083405200004],
              [-89.81981360599991, 29.41705963700008],
              [-89.82380123599995, 29.423976955000057],
              [-89.82579505099994, 29.428615627000056],
              [-89.82738196499992, 29.430487372000073],
              [-89.82982337099992, 29.432440497000073],
              [-89.83185787699995, 29.43585846600007],
              [-89.83193925699993, 29.442287502000056],
              [-89.82949785099993, 29.447333075000074],
              [-89.82485917899993, 29.452785549000055],
              [-89.82030188699991, 29.456366278000075],
              [-89.81826738199993, 29.455959377000056],
              [-89.81387285099993, 29.46816640800006],
              [-89.81631425699993, 29.474351304000038],
              [-89.8399145169999, 29.479437567000048],
              [-89.84740149599992, 29.48240794500009],
              [-89.85171464799993, 29.48004791900007],
              [-89.85309811099995, 29.46621328300006],
              [-89.86025956899994, 29.443752346000053],
              [-89.87694251199991, 29.448919989000046],
              [-89.90770423099991, 29.477036851000037],
              [-89.94163977799991, 29.46442291900007],
              [-89.97118079299992, 29.47337474200009],
              [-90.08039303299995, 29.537258205000057],
              [-90.09947669199994, 29.544663804000038],
              [-90.11620032499991, 29.547023830000057],
              [-90.1297094389999, 29.544663804000038],
              [-90.13316809799994, 29.539129950000074],
              [-90.11998450399994, 29.531683661000045],
              [-90.12743079299992, 29.524237372000073],
              [-90.14362545499995, 29.53742096600007],
              [-90.16685950399994, 29.567694403000075],
              [-90.18203691299993, 29.57949453300006],
              [-90.18785559799994, 29.569281317000048],
              [-90.20299231699994, 29.55231354400007],
              [-90.20933997299994, 29.53847890800006],
              [-90.1887914699999, 29.53782786700009],
              [-90.18203691299993, 29.53847890800006],
              [-90.18203691299993, 29.531683661000045],
              [-90.19782467399995, 29.525783596000053],
              [-90.20592200399994, 29.52411530200004],
              [-90.21556555899991, 29.524237372000073],
              [-90.2102758449999, 29.51512278900009],
              [-90.20604407499991, 29.511419989000046],
              [-90.20156816299993, 29.51243724200009],
              [-90.19570878799993, 29.518011786000045],
              [-90.18610592399995, 29.511867580000057],
              [-90.14346269399994, 29.47679271000004],
              [-90.13345292899993, 29.471625067000048],
              [-90.12368730399993, 29.469631252000056],
              [-90.09496008999992, 29.467271226000037],
              [-90.06981360599991, 29.46002838700008],
              [-90.04662024599992, 29.44725169500009],
              [-90.02375240799995, 29.428615627000056],
              [-90.03917395699995, 29.422756252000056],
              [-90.04735266799992, 29.416815497000073],
              [-90.05052649599992, 29.40729401200008],
              [-90.05109615799995, 29.390773830000057],
              [-90.04515540299991, 29.385565497000073],
              [-90.04059811099995, 29.38043854400007],
              [-90.03742428299995, 29.373968817000048],
              [-90.03628495999993, 29.36587148600006],
              [-90.03742428299995, 29.33926015800006],
              [-90.04051673099991, 29.346869208000044],
              [-90.04454505099994, 29.35309479400007],
              [-90.05028235599991, 29.357489325000074],
              [-90.05850175699993, 29.359767971000053],
              [-90.05638587099992, 29.341131903000075],
              [-90.04751542899993, 29.325018622000073],
              [-90.0340063139999, 29.31268952000005],
              [-90.01756751199991, 29.305121161000045],
              [-90.01756751199991, 29.29828522300005],
              [-90.03742428299995, 29.290838934000078],
              [-90.05089270699995, 29.307562567000048],
              [-90.06745357999995, 29.31012604400007],
              [-90.07579505099994, 29.30145905200004],
              [-90.06476803299995, 29.28461334800005],
              [-90.0950414699999, 29.28384023600006],
              [-90.09996497299994, 29.253851630000042],
              [-90.08385169199994, 29.225409247000073],
              [-90.05109615799995, 29.229396877000056],
              [-90.0574438139999, 29.213446356000077],
              [-90.08023027299993, 29.174709377000056],
              [-90.08584550699993, 29.167914130000042],
              [-90.10020911399994, 29.157945054000038],
              [-90.11388098899994, 29.144191799000055],
              [-90.13076738199993, 29.132025458000044],
              [-90.1472875639999, 29.12693919500009],
              [-90.19847571499992, 29.09829336100006],
              [-90.22923743399991, 29.08665599200009],
              [-90.24404863199993, 29.091498114000046],
              [-90.23770097599993, 29.096828518000052],
              [-90.23595130099994, 29.106594143000052],
              [-90.23668372299994, 29.119533596000053],
              [-90.23973548099991, 29.13182200700004],
              [-90.24600175699993, 29.140366929000038],
              [-90.26740475199995, 29.158026434000078],
              [-90.27131100199995, 29.16742584800005],
              [-90.26716061099995, 29.17763906500005],
              [-90.2605688139999, 29.188299872000073],
              [-90.2571508449999, 29.198919989000046],
              [-90.25621497299994, 29.210760809000078],
              [-90.25169837099992, 29.22479889500005],
              [-90.25035559799994, 29.236802476000037],
              [-90.25108801999994, 29.247381903000075],
              [-90.25446529899995, 29.259914455000057],
              [-90.26081295499995, 29.269476630000042],
              [-90.2708227199999, 29.27098216400009],
              [-90.27208411399994, 29.26357656500005],
              [-90.27928626199991, 29.247300523000035],
              [-90.28746497299994, 29.235174872000073],
              [-90.29124915299991, 29.239935614000046],
              [-90.30068925699993, 29.257554429000038],
              [-90.33751380099994, 29.29360586100006],
              [-90.33910071499992, 29.305121161000045],
              [-90.33910071499992, 29.31126536700009],
              [-90.35142981699994, 29.308539130000042],
              [-90.35985266799992, 29.30337148600006],
              [-90.36481686099995, 29.294623114000046],
              [-90.36636308499993, 29.281195380000042],
              [-90.3699438139999, 29.27090078300006],
              [-90.39370683499993, 29.243068752000056],
              [-90.39370683499993, 29.29828522300005],
              [-90.39956620999993, 29.31159088700008],
              [-90.41954505099994, 29.34056224200009],
              [-90.42503821499992, 29.346096096000053],
              [-90.42589270699995, 29.350409247000073],
              [-90.43443762899994, 29.357245184000078],
              [-90.44424394399994, 29.35765208500004],
              [-90.44896399599992, 29.342678127000056],
              [-90.45201575399994, 29.32713450700004],
              [-90.45995032499991, 29.314113674000055],
              [-90.48306230399993, 29.290838934000078],
              [-90.49644934799994, 29.30613841400009],
              [-90.50625566299993, 29.304510809000078],
              [-90.51561438699991, 29.29596588700008],
              [-90.52745520699995, 29.290838934000078],
              [-90.56200110599991, 29.300726630000042],
              [-90.57184811099995, 29.305121161000045],
              [-90.55821692599994, 29.31126536700009],
              [-90.55821692599994, 29.318793036000045],
              [-90.56932532499991, 29.320705471000053],
              [-90.57811438699991, 29.319525458000044],
              [-90.58364824099993, 29.314520575000074],
              [-90.58551998599995, 29.305121161000045],
              [-90.59496008999992, 29.308335679000038],
              [-90.60277258999992, 29.307562567000048],
              [-90.60741126199991, 29.301988023000035],
              [-90.60724850199995, 29.290838934000078],
              [-90.60244706899994, 29.28782786700009],
              [-90.57925370999993, 29.28461334800005],
              [-90.58128821499992, 29.26630280200004],
              [-90.59219316299993, 29.254787502000056],
              [-90.59821529899995, 29.24433014500005],
              [-90.58551998599995, 29.229396877000056],
              [-90.59528561099995, 29.218573309000078],
              [-90.60309811099995, 29.222316799000055],
              [-90.61082923099991, 29.232977606000077],
              [-90.62022864499994, 29.243068752000056],
              [-90.6270238919999, 29.23574453300006],
              [-90.63239498599995, 29.22528717700004],
              [-90.64073645699995, 29.202093817000048],
              [-90.6360570949999, 29.197821356000077],
              [-90.63390051999994, 29.195868231000077],
              [-90.64085852799991, 29.157416083000044],
              [-90.64073645699995, 29.14061107000009],
              [-90.64704342399995, 29.15371328300006],
              [-90.6524145169999, 29.16229889500005],
              [-90.66368567599994, 29.164618231000077],
              [-90.67487545499995, 29.16111888200004],
              [-90.67686926999994, 29.154771226000037],
              [-90.67544511599993, 29.145697333000044],
              [-90.67638098899994, 29.13739655200004],
              [-90.69029700399994, 29.13153717700004],
              [-90.69359290299991, 29.126654364000046],
              [-90.69786536399994, 29.12177155200004],
              [-90.70592200399994, 29.119533596000053],
              [-90.71153723899994, 29.12372467700004],
              [-90.72712154899995, 29.13035716400009],
              [-90.74323482999995, 29.13084544500009],
              [-90.75059973899994, 29.116400458000044],
              [-90.75796464799993, 29.11591217700004],
              [-90.79308020699995, 29.126206773000035],
              [-90.80524654899995, 29.12693919500009],
              [-90.7969457669999, 29.138820705000057],
              [-90.78075110599991, 29.14276764500005],
              [-90.76984615799995, 29.14911530200004],
              [-90.77725175699993, 29.167914130000042],
              [-90.79531816299993, 29.160630601000037],
              [-90.81208248599995, 29.16624583500004],
              [-90.82860266799992, 29.176336981000077],
              [-90.84618079299992, 29.182196356000077],
              [-90.8399145169999, 29.16624583500004],
              [-90.84414628799993, 29.15729401200008],
              [-90.86668860599991, 29.147406317000048],
              [-90.86986243399991, 29.143703518000052],
              [-90.87059485599991, 29.139146226000037],
              [-90.87364661399994, 29.13540273600006],
              [-90.88402258999992, 29.13377513200004],
              [-90.92992102799991, 29.17129140800006],
              [-90.95518958199995, 29.18573639500005],
              [-90.98232988199993, 29.191555080000057],
              [-91.01065019399994, 29.182196356000077],
              [-91.01121985599991, 29.193304755000042],
              [-91.0078832669999, 29.201564846000053],
              [-91.0008031889999, 29.206773179000038],
              [-90.99014238199993, 29.208929755000042],
              [-90.99925696499992, 29.218085028000075],
              [-91.01549231699994, 29.223537502000056],
              [-91.03099524599992, 29.224310614000046],
              [-91.03795325399994, 29.21979401200008],
              [-91.04124915299991, 29.20465729400007],
              [-91.0501195949999, 29.197007554000038],
              [-91.06334387899994, 29.19481028900009],
              [-91.07957923099991, 29.195868231000077],
              [-91.08901933499993, 29.20066966400009],
              [-91.11229407499991, 29.21906159100007],
              [-91.12393144399994, 29.223211981000077],
              [-91.2285863919999, 29.23859284100007],
              [-91.28514563699991, 29.260891018000052],
              [-91.32799231699994, 29.294867255000042],
              [-91.33967037699995, 29.33926015800006],
              [-91.32949785099993, 29.323919989000046],
              [-91.31212317599994, 29.31932200700004],
              [-91.29312089799993, 29.32322825700004],
              [-91.27818762899994, 29.33307526200008],
              [-91.26659094999991, 29.350816148000035],
              [-91.2586156889999, 29.36709219000005],
              [-91.24657141799992, 29.378119208000044],
              [-91.22297115799995, 29.380194403000075],
              [-91.22716223899994, 29.36351146000004],
              [-91.2149145169999, 29.34332916900007],
              [-91.19131425699993, 29.33144765800006],
              [-91.16148841099994, 29.33926015800006],
              [-91.1621801419999, 29.305812893000052],
              [-91.16616777299993, 29.29092031500005],
              [-91.17577063699991, 29.277777411000045],
              [-91.16527258999992, 29.27496979400007],
              [-91.15770423099991, 29.26976146000004],
              [-91.15367591099994, 29.26170482000009],
              [-91.15404212099992, 29.250474351000037],
              [-91.1323949859999, 29.25739166900007],
              [-91.12222245999993, 29.263006903000075],
              [-91.11310787699995, 29.27098216400009],
              [-91.1179906889999, 29.275783596000053],
              [-91.12254798099991, 29.282131252000056],
              [-91.12734941299993, 29.28461334800005],
              [-91.12734941299993, 29.290838934000078],
              [-91.10985266799992, 29.316555080000057],
              [-91.12157141799992, 29.33812083500004],
              [-91.17711341099994, 29.379339911000045],
              [-91.20860755099994, 29.395697333000044],
              [-91.21983801999994, 29.404445705000057],
              [-91.22240149599992, 29.41160716400009],
              [-91.22105872299994, 29.428290106000077],
              [-91.22297115799995, 29.434800523000035],
              [-91.22801673099991, 29.438381252000056],
              [-91.24111894399994, 29.44171784100007],
              [-91.24742591099994, 29.445705471000053],
              [-91.26256262899994, 29.46906159100007],
              [-91.26748613199993, 29.495794989000046],
              [-91.26329505099994, 29.522284247000073],
              [-91.25084387899994, 29.544663804000038],
              [-91.24046790299991, 29.55304596600007],
              [-91.22911536399994, 29.559881903000075],
              [-91.22008216099994, 29.56940338700008],
              [-91.21670488199993, 29.585638739000046],
              [-91.2200414699999, 29.598863023000035],
              [-91.22838294199994, 29.60805898600006],
              [-91.24120032499991, 29.612982489000046],
              [-91.25767981699994, 29.61359284100007],
              [-91.24779212099992, 29.59052155200004],
              [-91.25316321499992, 29.576320705000057],
              [-91.28189042899993, 29.555568752000056],
              [-91.28612219999991, 29.546047268000052],
              [-91.2844945949999, 29.53546784100007],
              [-91.28050696499992, 29.527085679000038],
              [-91.27818762899994, 29.524237372000073],
              [-91.28237870999993, 29.513820705000057],
              [-91.29442298099991, 29.49433014500005],
              [-91.29865475199995, 29.48383209800005],
              [-91.32091223899994, 29.496649481000077],
              [-91.36351477799991, 29.512111721000053],
              [-91.38744055899991, 29.518011786000045],
              [-91.41185462099992, 29.51894765800006],
              [-91.4238988919999, 29.521185614000046],
              [-91.4290258449999, 29.527899481000077],
              [-91.42438717399995, 29.538397528000075],
              [-91.41673743399991, 29.54791901200008],
              [-91.41515051999994, 29.55683014500005],
              [-91.4290258449999, 29.56582265800006],
              [-91.45250403599994, 29.551581122000073],
              [-91.49323482999995, 29.539618231000077],
              [-91.53433183499993, 29.534002997000073],
              [-91.55931555899991, 29.53847890800006],
              [-91.54539954299992, 29.54881419500009],
              [-91.54124915299991, 29.56903717700004],
              [-91.54515540299991, 29.591864325000074],
              [-91.55565344999991, 29.609849351000037],
              [-91.55882727799991, 29.619208075000074],
              [-91.55899003799993, 29.631659247000073],
              [-91.56078040299991, 29.64248281500005],
              [-91.56895911399994, 29.64712148600006],
              [-91.57970130099994, 29.64520905200004],
              [-91.60179602799991, 29.63662344000005],
              [-91.6133520169999, 29.634100653000075],
              [-91.63971920499995, 29.63548411700009],
              [-91.64415442599994, 29.64516836100006],
              [-91.63829505099994, 29.66209544500009],
              [-91.63385982999995, 29.685288804000038],
              [-91.6304418609999, 29.72882721600007],
              [-91.63792883999992, 29.74209219000005],
              [-91.66173255099994, 29.750799872000073],
              [-91.68468176999994, 29.753119208000044],
              [-91.77843176999994, 29.748480536000045],
              [-91.7957250639999, 29.74237702000005],
              [-91.83307857999995, 29.723456122000073],
              [-91.85846920499995, 29.71906159100007],
              [-91.86668860599991, 29.729396877000056],
              [-91.86750240799995, 29.74363841400009],
              [-91.87059485599991, 29.750799872000073],
              [-91.87791907499991, 29.75934479400007],
              [-91.87441972599993, 29.778143622000073],
              [-91.86465410099993, 29.796942450000074],
              [-91.8535863919999, 29.80536530200004],
              [-91.84605872299994, 29.798773505000042],
              [-91.83706620999993, 29.787665106000077],
              [-91.82945716099994, 29.784409898000035],
              [-91.82628333199995, 29.801703192000048],
              [-91.82868404899995, 29.815334377000056],
              [-91.83580481699994, 29.82526276200008],
              [-91.84752356699994, 29.831244208000044],
              [-91.89395097599993, 29.837632554000038],
              [-91.90672766799992, 29.837103583000044],
              [-91.93350175699993, 29.81940338700008],
              [-91.94513912699995, 29.82184479400007],
              [-91.95555579299992, 29.82916901200008],
              [-91.9668676419999, 29.833319403000075],
              [-91.9844457669999, 29.831976630000042],
              [-91.98631751199991, 29.827378648000035],
              [-91.98448645699995, 29.818793036000045],
              [-91.99071204299992, 29.80536530200004],
              [-92.00047766799992, 29.798895575000074],
              [-92.08641516799992, 29.771470445000034],
              [-92.09996497299994, 29.76439036700009],
              [-92.12246660099993, 29.743882554000038],
              [-92.13463294199994, 29.736151434000078],
              [-92.14899654899995, 29.736476955000057],
              [-92.13646399599992, 29.745306708000044],
              [-92.13414466099994, 29.75682200700004],
              [-92.14146887899994, 29.766913153000075],
              [-92.15831458199995, 29.771226304000038],
              [-92.16197669199994, 29.76829661700009],
              [-92.17023678299995, 29.75462474200009],
              [-92.17568925699993, 29.750799872000073],
              [-92.18089758999992, 29.75193919500009],
              [-92.20238196499992, 29.76439036700009],
              [-92.1988012359999, 29.74673086100006],
              [-92.19102942599994, 29.723781643000052],
              [-92.18150794199994, 29.704006252000056],
              [-92.17227128799993, 29.69550202000005],
              [-92.16466223899994, 29.697739976000037],
              [-92.15021725199995, 29.707505601000037],
              [-92.1265356109999, 29.711371161000045],
              [-92.11717688699991, 29.71393463700008],
              [-92.10879472599993, 29.71442291900007],
              [-92.09996497299994, 29.709784247000073],
              [-92.12926184799994, 29.692613023000035],
              [-92.14150956899994, 29.688706773000035],
              [-92.11359615799995, 29.637640692000048],
              [-92.10741126199991, 29.620428778000075],
              [-92.09996497299994, 29.620428778000075],
              [-92.08446204299992, 29.63031647300005],
              [-92.06017005099994, 29.63694896000004],
              [-92.03701738199993, 29.63703034100007],
              [-92.02489173099991, 29.62726471600007],
              [-92.05528723899994, 29.621527411000045],
              [-92.06737219999991, 29.616156317000048],
              [-92.07331295499995, 29.60614655200004],
              [-92.0528051419999, 29.59992096600007],
              [-92.06590735599991, 29.587836005000042],
              [-92.09337317599994, 29.587144273000035],
              [-92.13686501599994, 29.586862460000077],
              [-92.1738658349999, 29.576188691000084],
              [-92.24116098299993, 29.545530647000078],
              [-92.27649313299992, 29.533836437000048],
              [-92.31430732699994, 29.53436857400004],
              [-92.46507262199992, 29.560103938000054],
              [-92.48976175999991, 29.562993557000084],
              [-92.5143998669999, 29.566359096000042],
              [-92.5462133449999, 29.57168203300006],
              [-92.6830579459999, 29.604132864000064],
              [-92.79533837899993, 29.64424102600009],
              [-92.85266058699995, 29.66741492400007],
              [-92.91567089599994, 29.692979464000075],
              [-93.02684485599991, 29.732855536000045],
              [-93.0944503579999, 29.751526132000038],
              [-93.1995929499999, 29.77281118800005],
              [-93.25353181299994, 29.776355247000083],
              [-93.30851449699992, 29.769151067000053],
              [-93.34549494599992, 29.76204483400005],
              [-93.38542765099993, 29.767576766000047],
              [-93.42081021899992, 29.768261434000067],
              [-93.4533963579999, 29.77042494400007],
              [-93.49742591099994, 29.769191799000055],
              [-93.55851309299993, 29.76312099100005],
              [-93.64081645999994, 29.750313051000035],
              [-93.70118545899993, 29.742633382000065],
              [-93.73937984299994, 29.737247514000046],
              [-93.7669577449999, 29.72633331600008],
              [-93.79293648899994, 29.717555222000044],
              [-93.82137585599992, 29.709450505000063],
              [-93.8310278269999, 29.700134882000043],
              [-93.8509722099999, 29.723283778000052],
              [-93.8791551839999, 29.749883544000056],
              [-93.89369709399995, 29.79081447300007],
              [-93.8882383909999, 29.807175275000077],
              [-93.85735500599992, 29.81885207600004],
              [-93.82066781899994, 29.82421374800009],
              [-93.78194133199992, 29.85651491100009],
              [-93.77208411399994, 29.904689846000053],
              [-93.75995235399995, 29.960576139000068],
              [-93.76936603999991, 29.97831592400007],
              [-93.78890095999992, 29.98506584900008],
              [-93.8186460529999, 29.986755367000058],
              [-93.83459768499995, 29.983621329000073],
              [-93.85407467399995, 29.98655833500004],
              [-93.85802161399994, 29.96824778900009],
              [-93.86754309799994, 29.950018622000073],
              [-93.92439858799992, 29.865621589000057],
              [-93.93811194999995, 29.80590269000004],
              [-93.9327117119999, 29.776194375000046],
              [-93.87584387899994, 29.72337474200009],
              [-93.85993404899995, 29.692572333000044],
              [-93.8758031889999, 29.675034898000035],
              [-93.88731848899994, 29.67454661700009],
              [-93.91673743399991, 29.68183014500005],
              [-94.03758704299992, 29.684027411000045],
              [-94.0601293609999, 29.68183014500005],
              [-94.10195878799993, 29.67059967700004],
              [-94.13145911399994, 29.65888092700004],
              [-94.21597245999993, 29.61749909100007],
              [-94.3352758449999, 29.578192450000074],
              [-94.65428626199991, 29.45189036700009],
              [-94.6907445949999, 29.428615627000056],
              [-94.74242102799991, 29.374660549000055],
              [-94.76276607999995, 29.366522528000075],
              [-94.78620357999995, 29.370306708000044],
              [-94.79063880099994, 29.380031643000052],
              [-94.7820531889999, 29.393377997000073],
              [-94.70099850199995, 29.46279531500005],
              [-94.67516028599994, 29.47479889500005],
              [-94.65160071499992, 29.478257554000038],
              [-94.64012610599991, 29.48143138200004],
              [-94.63003495999993, 29.485663153000075],
              [-94.62242591099994, 29.490057684000078],
              [-94.5926000639999, 29.51756419500009],
              [-94.5808813139999, 29.524237372000073],
              [-94.57213294199994, 29.52643463700008],
              [-94.52188066299993, 29.523993231000077],
              [-94.50446529899995, 29.52602773600006],
              [-94.49181067599994, 29.534125067000048],
              [-94.48525956899994, 29.55215078300006],
              [-94.48595130099994, 29.566107489000046],
              [-94.4949438139999, 29.55878327000005],
              [-94.51012122299994, 29.54901764500005],
              [-94.52965247299994, 29.555568752000056],
              [-94.54552161399994, 29.568426825000074],
              [-94.56143144399994, 29.574611721000053],
              [-94.6054481779999, 29.552650016000086],
              [-94.69523245999994, 29.53895895700009],
              [-94.73681933499995, 29.52847728900008],
              [-94.75523544499993, 29.52427124700006],
              [-94.77905017199993, 29.529876915000045],
              [-94.78742941299993, 29.54071392800006],
              [-94.78508043599993, 29.54693368800008],
              [-94.7737544709999, 29.541801409000072],
              [-94.7612740749999, 29.543918331000043],
              [-94.74945759799994, 29.561037903000056],
              [-94.73577877899993, 29.579235245000064],
              [-94.71613838999991, 29.61140815600004],
              [-94.70311039099994, 29.65043750400008],
              [-94.69274089399994, 29.696340139000085],
              [-94.69547032799994, 29.718122638000068],
              [-94.70214397899991, 29.73530648500008],
              [-94.70353180799992, 29.75136155200005],
              [-94.71017568299993, 29.76051782400009],
              [-94.71949365299992, 29.776550538000038],
              [-94.73405499899991, 29.782240880000074],
              [-94.74462680499994, 29.782205729000054],
              [-94.76045755599995, 29.776416445000052],
              [-94.77365462799992, 29.772927863000064],
              [-94.7947923609999, 29.771705170000075],
              [-94.80674323599993, 29.781989296000063],
              [-94.82649023099992, 29.768144031000077],
              [-94.8263859189999, 29.74978678800005],
              [-94.84866079499994, 29.717577818000052],
              [-94.86298413999992, 29.683106243000054],
              [-94.87607624399993, 29.665842342000076],
              [-94.9064095309999, 29.65768243100007],
              [-94.91959650099994, 29.655327353000075],
              [-94.93155576599992, 29.666740910000044],
              [-94.9383167599999, 29.68965262100005],
              [-94.9489149979999, 29.69419010000007],
              [-94.96617210599993, 29.70443395700005],
              [-94.99917558499993, 29.716009833000044],
              [-95.01550240199992, 29.720300111000086],
              [-95.02674493199993, 29.736093650000043],
              [-95.03399277199992, 29.74846130700007],
              [-95.05228023199993, 29.74974817000009],
              [-95.06407630099994, 29.71287669500009],
              [-95.05032848399992, 29.70702564600009],
              [-95.03681235199991, 29.704342920000045],
              [-95.02882408099993, 29.697496674000035],
              [-95.01848818699995, 29.69548353600004],
              [-95.00894678599991, 29.69346543900008],
              [-94.99857961999993, 29.686629898000035],
              [-94.9858013839999, 29.674985390000074],
              [-95.00869600199991, 29.659713857000042],
              [-95.0157232649999, 29.64452245700005],
              [-95.01003117399995, 29.625952994000045],
              [-94.98451850799995, 29.60612019000007],
              [-94.98919473299992, 29.594386967000048],
              [-95.0054418609999, 29.578599351000037],
              [-95.01598059799994, 29.568915106000077],
              [-95.02391516799992, 29.542181708000044],
              [-94.98391111199993, 29.513819470000044],
              [-94.90779828199993, 29.496309994000057],
              [-94.91487330799993, 29.488005564000048],
              [-94.92350621799994, 29.475557837000053],
              [-94.93639075399994, 29.48004791900007],
              [-94.95059160099993, 29.473781643000052],
              [-94.96507727799991, 29.469631252000056],
              [-94.96507727799991, 29.46279531500005],
              [-94.94823157499991, 29.451971747000073],
              [-94.94709225199995, 29.435370184000078],
              [-94.9429418609999, 29.422023830000057],
              [-94.9173070949999, 29.421128648000035],
              [-94.9173070949999, 29.428615627000056],
              [-94.92149817599994, 29.432114976000037],
              [-94.92198645699995, 29.433986721000053],
              [-94.92178300699993, 29.43650950700004],
              [-94.91958574099993, 29.43650950700004],
              [-94.91832434799994, 29.43699778900009],
              [-94.91820227799991, 29.44009023600006],
              [-94.9173070949999, 29.442287502000056],
              [-94.88955644399994, 29.400824286000045],
              [-94.87877356699994, 29.393866278000075],
              [-94.86579342399995, 29.391750393000052],
              [-94.8211156889999, 29.373968817000048],
              [-94.82494055899991, 29.372788804000038],
              [-94.82827714799993, 29.372259833000044],
              [-94.83128821499992, 29.370754299000055],
              [-94.83409583199995, 29.366522528000075],
              [-94.84943600199995, 29.37596263200004],
              [-94.87035071499992, 29.38084544500009],
              [-94.88882402299993, 29.37596263200004],
              [-94.89679928299995, 29.356350002000056],
              [-94.90135657499991, 29.33462148600006],
              [-94.9129125639999, 29.315578518000052],
              [-94.92821204299992, 29.307562567000048],
              [-94.94395911399994, 29.318793036000045],
              [-94.95079505099994, 29.318793036000045],
              [-94.9551488919999, 29.306341864000046],
              [-94.96446692599994, 29.297796942000048],
              [-94.98493404899995, 29.28461334800005],
              [-94.9878637359999, 29.28388092700004],
              [-94.99620520699995, 29.285223700000074],
              [-94.99917558499993, 29.28461334800005],
              [-94.99986731699994, 29.28196849200009],
              [-94.99864661399994, 29.27374909100007],
              [-94.99917558499993, 29.27098216400009],
              [-95.06517493399991, 29.20416901200008],
              [-95.08836829299992, 29.188625393000052],
              [-95.11587480399993, 29.174750067000048],
              [-95.12425696499992, 29.19354889500005],
              [-95.13719641799992, 29.198919989000046],
              [-95.1531469389999, 29.200873114000046],
              [-95.17052161399994, 29.208929755000042],
              [-95.1629125639999, 29.20062897300005],
              [-95.15001380099994, 29.174750067000048],
              [-95.15916907499991, 29.152411200000074],
              [-95.15811113199993, 29.130926825000074],
              [-95.15001380099994, 29.089097398000035],
              [-95.14964758999992, 29.07217031500005],
              [-95.15123450399994, 29.05849844000005],
              [-95.15892493399991, 29.045721747000073],
              [-95.23151607999995, 28.99551015800006],
              [-95.25999915299991, 28.981756903000075],
              [-95.31387285099993, 28.92837148600006],
              [-95.36774654899995, 28.887152411000045],
              [-95.37938391799992, 28.880560614000046],
              [-95.40172278599994, 28.87836334800005],
              [-95.41917883999992, 28.872300523000035],
              [-95.48717200399994, 28.82965729400007],
              [-95.60191809799994, 28.76386139500005],
              [-95.64488684799994, 28.745917059000078],
              [-95.68887285099993, 28.73631419500009],
              [-95.7339574859999, 28.733587958000044],
              [-95.78001868399991, 28.73590729400007],
              [-95.81737219999991, 28.732489325000074],
              [-95.9519750639999, 28.688706773000035],
              [-95.94579016799992, 28.67645905200004],
              [-95.94713294199994, 28.66624583500004],
              [-95.95099850199995, 28.65696849200009],
              [-95.95238196499992, 28.640326239000046],
              [-95.95494544199994, 28.636379299000055],
              [-95.95592200399994, 28.632635809000078],
              [-95.9519750639999, 28.626654364000046],
              [-95.94725501199991, 28.62531159100007],
              [-95.94017493399991, 28.62571849200009],
              [-95.93370520699995, 28.62759023600006],
              [-95.93081620999993, 28.630072333000044],
              [-95.79344641799992, 28.69944896000004],
              [-95.75495357999995, 28.71246979400007],
              [-95.71922766799992, 28.71548086100006],
              [-95.83714758999992, 28.64647044500009],
              [-95.9024145169999, 28.61786530200004],
              [-96.00511633999992, 28.596502997000073],
              [-96.06627356699994, 28.553859768000052],
              [-96.12368730399993, 28.536810614000046],
              [-96.18822180899991, 28.501654364000046],
              [-96.21886145699995, 28.489488023000035],
              [-96.19456946499992, 28.515570380000042],
              [-96.16087805899991, 28.537258205000057],
              [-96.01724199099993, 28.60224030200004],
              [-95.99600175699993, 28.60618724200009],
              [-95.98493404899995, 28.613104559000078],
              [-95.98135331899994, 28.628607489000046],
              [-95.98778235599991, 28.64484284100007],
              [-96.00658118399991, 28.653998114000046],
              [-96.02643795499995, 28.65102773600006],
              [-96.06476803299995, 28.631333726000037],
              [-96.07795162699995, 28.626654364000046],
              [-96.09837805899991, 28.62327708500004],
              [-96.15737870999993, 28.598781643000052],
              [-96.20490475199995, 28.58665599200009],
              [-96.22647050699993, 28.587144273000035],
              [-96.22227942599994, 28.602484442000048],
              [-96.20474199099993, 28.610581773000035],
              [-96.15892493399991, 28.61513906500005],
              [-96.14313717399995, 28.626654364000046],
              [-96.13687089799993, 28.626654364000046],
              [-96.13687089799993, 28.63353099200009],
              [-96.15392005099994, 28.635199286000045],
              [-96.16828365799995, 28.632554429000038],
              [-96.18138587099992, 28.628648179000038],
              [-96.19493567599994, 28.626654364000046],
              [-96.21544348899994, 28.629380601000037],
              [-96.22044837099992, 28.636867580000057],
              [-96.21544348899994, 28.64789459800005],
              [-96.19225012899994, 28.680894273000035],
              [-96.18805904899995, 28.69086334800005],
              [-96.19505774599992, 28.694484768000052],
              [-96.21544348899994, 28.694973049000055],
              [-96.23082434799994, 28.69281647300005],
              [-96.24453691299993, 28.687567450000074],
              [-96.26667232999995, 28.675116278000075],
              [-96.26040605399993, 28.688706773000035],
              [-96.28140214799993, 28.679754950000074],
              [-96.30809485599991, 28.65106842700004],
              [-96.32872473899994, 28.63971588700008],
              [-96.3457738919999, 28.635321356000077],
              [-96.34984290299991, 28.63739655200004],
              [-96.35020911399994, 28.64411041900007],
              [-96.35602779899995, 28.653998114000046],
              [-96.38516191299993, 28.679348049000055],
              [-96.3902074859999, 28.688706773000035],
              [-96.38003495999993, 28.70026276200008],
              [-96.37759355399993, 28.714911200000074],
              [-96.38329016799992, 28.73004791900007],
              [-96.39761308499993, 28.743394273000035],
              [-96.40371660099993, 28.738755601000037],
              [-96.41307532499991, 28.73383209800005],
              [-96.41685950399994, 28.729722398000035],
              [-96.43504798099991, 28.755682684000078],
              [-96.43858801999994, 28.76386139500005],
              [-96.44481360599991, 28.76386139500005],
              [-96.44395911399994, 28.749253648000035],
              [-96.43838456899994, 28.731756903000075],
              [-96.4309789699999, 28.716498114000046],
              [-96.42430579299992, 28.708644924000055],
              [-96.41710364499994, 28.710679429000038],
              [-96.4082738919999, 28.716945705000057],
              [-96.40078691299993, 28.719875393000052],
              [-96.39761308499993, 28.712062893000052],
              [-96.40029863199993, 28.70258209800005],
              [-96.40648352799991, 28.69676341400009],
              [-96.41299394399994, 28.69281647300005],
              [-96.41685950399994, 28.688706773000035],
              [-96.41637122299994, 28.680975653000075],
              [-96.41270911399994, 28.673773505000042],
              [-96.41030839799993, 28.66632721600007],
              [-96.41372636599993, 28.65770091400009],
              [-96.4168188139999, 28.643703518000052],
              [-96.40343176999994, 28.635565497000073],
              [-96.36969967399995, 28.626654364000046],
              [-96.42764238199993, 28.595404364000046],
              [-96.46251380099994, 28.583197333000044],
              [-96.49323482999995, 28.578924872000073],
              [-96.47789466099994, 28.591620184000078],
              [-96.45982825399994, 28.59332916900007],
              [-96.44481360599991, 28.597357489000046],
              [-96.43858801999994, 28.61676666900007],
              [-96.44713294199994, 28.635646877000056],
              [-96.48468990799995, 28.612616278000075],
              [-96.49323482999995, 28.63662344000005],
              [-96.4973852199999, 28.64476146000004],
              [-96.50747636599993, 28.643459377000056],
              [-96.51976477799991, 28.640448309000078],
              [-96.53042558499993, 28.643459377000056],
              [-96.53628495999993, 28.64606354400007],
              [-96.54987545499995, 28.64549388200004],
              [-96.55467688699991, 28.64716217700004],
              [-96.55947831899994, 28.65428294500009],
              [-96.56029212099992, 28.660711981000077],
              [-96.55996660099993, 28.667222398000035],
              [-96.56151282499991, 28.675116278000075],
              [-96.56578528599994, 28.68891022300005],
              [-96.56725012899994, 28.696519273000035],
              [-96.57017981699994, 28.70262278900009],
              [-96.57852128799993, 28.712062893000052],
              [-96.59044348899994, 28.720363674000055],
              [-96.60383053299995, 28.72370026200008],
              [-96.61750240799995, 28.72207265800006],
              [-96.63036048099991, 28.71548086100006],
              [-96.63451087099992, 28.720851955000057],
              [-96.63914954299992, 28.72418854400007],
              [-96.65086829299992, 28.729722398000035],
              [-96.64981035099993, 28.704820054000038],
              [-96.64565995999993, 28.68707916900007],
              [-96.63719641799992, 28.671616929000038],
              [-96.60879472599993, 28.63776276200008],
              [-96.60488847599993, 28.630560614000046],
              [-96.60244706899994, 28.62051015800006],
              [-96.6030981109999, 28.610174872000073],
              [-96.60850989499994, 28.58616771000004],
              [-96.60863196499992, 28.578924872000073],
              [-96.59984290299991, 28.56834544500009],
              [-96.59190833199995, 28.569647528000075],
              [-96.58193925699993, 28.578924872000073],
              [-96.57017981699994, 28.575384833000044],
              [-96.54100501199991, 28.557806708000044],
              [-96.52037512899994, 28.549221096000053],
              [-96.51366126199991, 28.544134833000044],
              [-96.50658118399991, 28.536851304000038],
              [-96.5012914699999, 28.529120184000078],
              [-96.49323482999995, 28.510646877000056],
              [-96.54552161399994, 28.48773834800005],
              [-96.55467688699991, 28.486070054000038],
              [-96.54759680899991, 28.469305731000077],
              [-96.53156490799995, 28.46946849200009],
              [-96.51423092399995, 28.47797272300005],
              [-96.5034887359999, 28.486070054000038],
              [-96.47350012899994, 28.49355703300006],
              [-96.43565833199995, 28.481350002000056],
              [-96.40680904899995, 28.458726304000038],
              [-96.40379798099991, 28.434881903000075],
              [-96.47581946499992, 28.400783596000053],
              [-96.49510657499991, 28.39647044500009],
              [-96.52916419199994, 28.377752997000073],
              [-96.54474850199995, 28.373480536000045],
              [-96.65371660099993, 28.319484768000052],
              [-96.67137610599991, 28.331854559000078],
              [-96.68773352799991, 28.327378648000035],
              [-96.69831295499995, 28.335882880000042],
              [-96.70384680899991, 28.35179271000004],
              [-96.70592200399994, 28.388495184000078],
              [-96.70921790299991, 28.39984772300005],
              [-96.71849524599992, 28.405462958000044],
              [-96.73648027299993, 28.40692780200004],
              [-96.7417699859999, 28.410589911000045],
              [-96.74356035099993, 28.419094143000052],
              [-96.74437415299991, 28.42845286700009],
              [-96.74644934799994, 28.434881903000075],
              [-96.7512914699999, 28.438666083000044],
              [-96.76227779899995, 28.44432200700004],
              [-96.76695716099994, 28.44794342700004],
              [-96.78465735599991, 28.472601630000042],
              [-96.79332434799994, 28.479722398000035],
              [-96.80166581899994, 28.47524648600006],
              [-96.8101293609999, 28.46784088700008],
              [-96.8133031889999, 28.45799388200004],
              [-96.81065833199995, 28.45184967700004],
              [-96.80166581899994, 28.45538971600007],
              [-96.77745520699995, 28.43740469000005],
              [-96.76976477799991, 28.426214911000045],
              [-96.76695716099994, 28.410711981000077],
              [-96.77513587099992, 28.400458075000074],
              [-96.79385331899994, 28.40818919500009],
              [-96.8145238919999, 28.421698309000078],
              [-96.82835852799991, 28.42869700700004],
              [-96.84447180899991, 28.41559479400007],
              [-96.82510331899994, 28.387925523000035],
              [-96.79556230399993, 28.35651276200008],
              [-96.78115800699993, 28.331854559000078],
              [-96.78746497299994, 28.314276434000078],
              [-96.79710852799991, 28.296942450000074],
              [-96.80125891799992, 28.279120184000078],
              [-96.78233801999994, 28.24160390800006],
              [-96.79238847599993, 28.228664455000057],
              [-96.82835852799991, 28.20897044500009],
              [-96.84512285099993, 28.19326406500005],
              [-96.88023841099994, 28.15062083500004],
              [-96.89590410099993, 28.14081452000005],
              [-96.92821204299992, 28.133246161000045],
              [-96.94505774599992, 28.12645091400009],
              [-96.93346106699994, 28.162909247000073],
              [-96.92454993399991, 28.17918528900009],
              [-96.91030839799993, 28.195257880000042],
              [-96.92471269399994, 28.214097398000035],
              [-96.91893469999991, 28.232123114000046],
              [-96.90880286399994, 28.24876536700009],
              [-96.91030839799993, 28.263617255000042],
              [-96.9219457669999, 28.263332424000055],
              [-96.93578040299991, 28.24827708500004],
              [-96.95933997299994, 28.215765692000048],
              [-96.9461156889999, 28.205145575000074],
              [-96.9434301419999, 28.191351630000042],
              [-96.94871985599991, 28.174221096000053],
              [-96.95933997299994, 28.15375397300005],
              [-96.97301184799994, 28.133937893000052],
              [-96.98436438699991, 28.12954336100006],
              [-97.02017167899993, 28.14008209800005],
              [-97.01626542899993, 28.142279364000046],
              [-97.01292883999992, 28.144964911000045],
              [-97.00975501199991, 28.14866771000004],
              [-97.00649980399993, 28.15375397300005],
              [-97.01305091099994, 28.164007880000042],
              [-97.00743567599994, 28.194525458000044],
              [-97.01398678299995, 28.20897044500009],
              [-97.02017167899993, 28.20897044500009],
              [-97.03620357999995, 28.187648830000057],
              [-97.07135982999995, 28.168117580000057],
              [-97.11021887899994, 28.153631903000075],
              [-97.1375219389999, 28.14752838700008],
              [-97.13084876199991, 28.15778229400007],
              [-97.13857988199993, 28.16559479400007],
              [-97.15265865799995, 28.169256903000075],
              [-97.16478430899991, 28.16738515800006],
              [-97.17324785099993, 28.159002997000073],
              [-97.1773168609999, 28.14801666900007],
              [-97.17320716099994, 28.138373114000046],
              [-97.15733801999994, 28.13385651200008],
              [-97.19859778599994, 28.096828518000052],
              [-97.21751868399991, 28.074774481000077],
              [-97.20885169199994, 28.065008856000077],
              [-97.18667558499993, 28.06248607000009],
              [-97.16844641799992, 28.055609442000048],
              [-97.15428626199991, 28.044623114000046],
              [-97.14427649599992, 28.030218817000048],
              [-97.14439856699994, 28.01976146000004],
              [-97.14867102799991, 28.010199286000045],
              [-97.14907792899993, 28.005519924000055],
              [-97.1375219389999, 28.009711005000042],
              [-97.12987219999991, 28.016750393000052],
              [-97.1231176419999, 28.02830638200004],
              [-97.11823482999995, 28.04173411700009],
              [-97.11636308499993, 28.054388739000046],
              [-97.10610917899993, 28.07094961100006],
              [-97.0574438139999, 28.088812567000048],
              [-97.04124915299991, 28.105902411000045],
              [-97.04491126199991, 28.11041901200008],
              [-97.0464574859999, 28.113714911000045],
              [-97.04539954299992, 28.11481354400007],
              [-97.04165605399993, 28.11660390800006],
              [-97.03441321499992, 28.119574286000045],
              [-97.02407792899993, 28.111802476000037],
              [-97.0210668609999, 28.10032786700009],
              [-97.02765865799995, 28.06159088700008],
              [-97.02627519399994, 28.047674872000073],
              [-97.0249731109999, 28.041449286000045],
              [-97.02749589799993, 28.03668854400007],
              [-97.0379125639999, 28.027085679000038],
              [-97.04458574099993, 28.01911041900007],
              [-97.06114661399994, 27.98924388200004],
              [-97.06607011599993, 27.988674221000053],
              [-97.06745357999995, 27.99013906500005],
              [-97.06753495999993, 27.99282461100006],
              [-97.06859290299991, 27.996039130000042],
              [-97.10533606699994, 27.93699778900009],
              [-97.18407141799992, 27.83661530200004],
              [-97.20628821499992, 27.82172272300005],
              [-97.2324926419999, 27.824774481000077],
              [-97.2324926419999, 27.83222077000005],
              [-97.21198482999995, 27.83222077000005],
              [-97.22325598899994, 27.84906647300005],
              [-97.2359106109999, 27.863836981000077],
              [-97.25031490799995, 27.87457916900007],
              [-97.26720130099994, 27.879380601000037],
              [-97.29084225199995, 27.876654364000046],
              [-97.3313695949999, 27.861070054000038],
              [-97.35594641799992, 27.85956452000005],
              [-97.34898841099994, 27.864935614000046],
              [-97.3465063139999, 27.86871979400007],
              [-97.34532630099994, 27.872748114000046],
              [-97.34227454299992, 27.879380601000037],
              [-97.36815344999991, 27.87323639500005],
              [-97.42438717399995, 27.87518952000005],
              [-97.45213782499991, 27.873195705000057],
              [-97.45759029899995, 27.86981842700004],
              [-97.46019446499992, 27.860663153000075],
              [-97.46580969999991, 27.85956452000005],
              [-97.47337805899991, 27.861029364000046],
              [-97.48119055899991, 27.864569403000075],
              [-97.48692786399994, 27.866359768000052],
              [-97.48827063699991, 27.86863841400009],
              [-97.48912512899994, 27.87295156500005],
              [-97.49229895699995, 27.87718333500004],
              [-97.50059973899994, 27.879380601000037],
              [-97.50454667899993, 27.878851630000042],
              [-97.5210668609999, 27.873195705000057],
              [-97.50487219999991, 27.84902578300006],
              [-97.48704993399991, 27.835272528000075],
              [-97.46397864499994, 27.831732489000046],
              [-97.4317113919999, 27.838446356000077],
              [-97.42218990799995, 27.83270905200004],
              [-97.40982011599993, 27.83234284100007],
              [-97.39818274599992, 27.83690013200004],
              [-97.39073645699995, 27.84589264500005],
              [-97.38560950399994, 27.83006419500009],
              [-97.39403235599991, 27.801703192000048],
              [-97.39073645699995, 27.79124583500004],
              [-97.37181555899991, 27.75531647300005],
              [-97.35606848899994, 27.74176666900007],
              [-97.26720130099994, 27.70807526200008],
              [-97.25959225199995, 27.695054429000038],
              [-97.26280676999994, 27.67926666900007],
              [-97.27253170499995, 27.663397528000075],
              [-97.28429114499994, 27.650051174000055],
              [-97.28929602799991, 27.64199453300006],
              [-97.29259192599994, 27.630926825000074],
              [-97.29515540299991, 27.60879140800006],
              [-97.29881751199991, 27.60057200700004],
              [-97.32933508999992, 27.549627997000073],
              [-97.34642493399991, 27.50576406500005],
              [-97.34976152299993, 27.48582591400009],
              [-97.35293535099993, 27.475734768000052],
              [-97.36705481699994, 27.460760809000078],
              [-97.40831458199995, 27.357367255000042],
              [-97.41120357999995, 27.33502838700008],
              [-97.42235266799992, 27.327785549000055],
              [-97.48692786399994, 27.304022528000075],
              [-97.50841223899994, 27.282416083000044],
              [-97.52257239499994, 27.278509833000044],
              [-97.54157467399995, 27.290350653000075],
              [-97.50527910099993, 27.30760325700004],
              [-97.49315344999991, 27.317694403000075],
              [-97.49868730399993, 27.320786851000037],
              [-97.5012914699999, 27.323919989000046],
              [-97.5032445949999, 27.327378648000035],
              [-97.50674394399994, 27.331284898000035],
              [-97.48680579299992, 27.330226955000057],
              [-97.47638912699995, 27.33148834800005],
              [-97.46922766799992, 27.33502838700008],
              [-97.46129309799994, 27.34365469000005],
              [-97.46092688699991, 27.345770575000074],
              [-97.46548417899993, 27.34674713700008],
              [-97.47264563699991, 27.35175202000005],
              [-97.4741918609999, 27.34837474200009],
              [-97.48135331899994, 27.34707265800006],
              [-97.48936926999994, 27.35065338700008],
              [-97.49315344999991, 27.36204661700009],
              [-97.49120032499991, 27.38149648600006],
              [-97.48692786399994, 27.400213934000078],
              [-97.50617428299995, 27.392523505000042],
              [-97.52920488199993, 27.37213776200008],
              [-97.54157467399995, 27.36546458500004],
              [-97.53408769399994, 27.35175202000005],
              [-97.54491126199991, 27.348089911000045],
              [-97.55308997299994, 27.343817450000074],
              [-97.56883704299992, 27.331284898000035],
              [-97.57510331899994, 27.345648505000042],
              [-97.58470618399991, 27.34178294500009],
              [-97.60301673099991, 27.317694403000075],
              [-97.59972083199995, 27.310939846000053],
              [-97.60065670499995, 27.304510809000078],
              [-97.60619055899991, 27.299709377000056],
              [-97.61693274599992, 27.297796942000048],
              [-97.63023841099994, 27.30023834800005],
              [-97.6341039699999, 27.30654531500005],
              [-97.63451087099992, 27.31513092700004],
              [-97.63776607999995, 27.32444896000004],
              [-97.71764075399994, 27.427435614000046],
              [-97.74290930899991, 27.449693101000037],
              [-97.77428137899994, 27.468491929000038],
              [-97.77049719999991, 27.444566148000035],
              [-97.73643958199995, 27.414129950000074],
              [-97.7259008449999, 27.393377997000073],
              [-97.74014238199993, 27.393377997000073],
              [-97.70376542899993, 27.361070054000038],
              [-97.69176184799994, 27.34048086100006],
              [-97.7122289699999, 27.331284898000035],
              [-97.71056067599994, 27.324164130000042],
              [-97.70909583199995, 27.32135651200008],
              [-97.70665442599994, 27.317694403000075],
              [-97.6870824859999, 27.325140692000048],
              [-97.67223059799994, 27.32135651200008],
              [-97.66763261599993, 27.31085846600007],
              [-97.67870032499991, 27.297796942000048],
              [-97.70069803299992, 27.285942942000077],
              [-97.7247244859999, 27.287669315000073],
              [-97.74998938699991, 27.297308661000045],
              [-97.77428137899994, 27.297796942000048],
              [-97.7605688139999, 27.279120184000078],
              [-97.71519986999994, 27.267359579000072],
              [-97.6787082219999, 27.274019982000084],
              [-97.65888531899992, 27.27412188900007],
              [-97.6421533489999, 27.26680217200004],
              [-97.62952235699993, 27.24466093500007],
              [-97.59823621899994, 27.242959479000035],
              [-97.55966102299993, 27.23480500800008],
              [-97.52112737399995, 27.232190847000084],
              [-97.50139836699992, 27.24336201600005],
              [-97.4764755189999, 27.25639566500007],
              [-97.44011763799995, 27.272232046000056],
              [-97.42609615799995, 27.26365794500009],
              [-97.42715410099993, 27.24998607000009],
              [-97.43407141799992, 27.23924388200004],
              [-97.44595292899993, 27.23509349200009],
              [-97.44383704299992, 27.22418854400007],
              [-97.44347083199995, 27.20571523600006],
              [-97.44505774599992, 27.18821849200009],
              [-97.44908606699994, 27.180487372000073],
              [-97.45836341099994, 27.17479075700004],
              [-97.45543372299994, 27.161322333000044],
              [-97.44859778599994, 27.14549388200004],
              [-97.44595292899993, 27.13271719000005],
              [-97.45311438699991, 27.120754299000055],
              [-97.46580969999991, 27.11237213700008],
              [-97.48131262899994, 27.107570705000057],
              [-97.4968969389999, 27.106024481000077],
              [-97.49819902299993, 27.100734768000052],
              [-97.48818925699993, 27.088324286000045],
              [-97.48155676999994, 27.074286200000074],
              [-97.49315344999991, 27.063788153000075],
              [-97.48094641799992, 27.038723049000055],
              [-97.48070227799991, 27.021958726000037],
              [-97.49449622299994, 27.012640692000048],
              [-97.55020097599993, 27.00918203300006],
              [-97.56094316299993, 27.00486888200004],
              [-97.56281490799995, 26.99371979400007],
              [-97.55996660099993, 26.95075104400007],
              [-97.55431067599994, 26.93305084800005],
              [-97.54552161399994, 26.91864655200004],
              [-97.53408769399994, 26.906805731000077],
              [-97.49453691299993, 26.89052969000005],
              [-97.48131262899994, 26.87763092700004],
              [-97.49315344999991, 26.858343817000048],
              [-97.53770911399994, 26.89557526200008],
              [-97.5484106109999, 26.89988841400009],
              [-97.55524654899995, 26.89020416900007],
              [-97.56004798099991, 26.87140534100007],
              [-97.56248938699991, 26.851385809000078],
              [-97.56200110599991, 26.83787669500009],
              [-97.5547582669999, 26.825140692000048],
              [-97.54369055899991, 26.822211005000042],
              [-97.52965247299994, 26.822007554000038],
              [-97.51366126199991, 26.81736888200004],
              [-97.5012914699999, 26.80662669500009],
              [-97.49303137899994, 26.79173411700009],
              [-97.48839270699995, 26.775091864000046],
              [-97.48151607999995, 26.731350002000056],
              [-97.45763098899994, 26.667222398000035],
              [-97.44725501199991, 26.601304429000038],
              [-97.42491614499994, 26.534898179000038],
              [-97.41860917899993, 26.502020575000074],
              [-97.42227128799993, 26.508978583000044],
              [-97.42886308499993, 26.517726955000057],
              [-97.4317113919999, 26.523179429000038],
              [-97.4368383449999, 26.509914455000057],
              [-97.44603430899991, 26.502875067000048],
              [-97.47264563699991, 26.495835679000038],
              [-97.43854732999995, 26.485296942000048],
              [-97.43968665299991, 26.47646719000005],
              [-97.44481360599991, 26.461371161000045],
              [-97.44798743399991, 26.433335679000038],
              [-97.45042883999992, 26.423895575000074],
              [-97.44786536399994, 26.42015208500004],
              [-97.4351293609999, 26.41950104400007],
              [-97.41706295499995, 26.415187893000052],
              [-97.41193600199995, 26.40452708500004],
              [-97.41079667899993, 26.391180731000077],
              [-97.40501868399991, 26.378566799000055],
              [-97.39806067599994, 26.376288153000075],
              [-97.37637285099993, 26.37441640800006],
              [-97.37022864499994, 26.372300523000035],
              [-97.36986243399991, 26.364081122000073],
              [-97.37881425699993, 26.34398021000004],
              [-97.37706458199995, 26.337591864000046],
              [-97.37010657499991, 26.336818752000056],
              [-97.36327063699991, 26.34015534100007],
              [-97.35806230399993, 26.344956773000035],
              [-97.35594641799992, 26.348456122000073],
              [-97.35191809799994, 26.35382721600007],
              [-97.34439042899993, 26.349351304000038],
              [-97.34019934799994, 26.341620184000078],
              [-97.34605872299994, 26.337591864000046],
              [-97.35529537699995, 26.327948309000078],
              [-97.36107337099992, 26.30687083500004],
              [-97.36107337099992, 26.28579336100006],
              [-97.35289466099994, 26.27610911700009],
              [-97.34373938699991, 26.27798086100006],
              [-97.33653723899994, 26.28115469000005],
              [-97.32982337099992, 26.281724351000037],
              [-97.3218481109999, 26.27610911700009],
              [-97.31578528599994, 26.264878648000035],
              [-97.3191625639999, 26.257147528000075],
              [-97.32567298099991, 26.250392971000053],
              [-97.32925370999993, 26.242010809000078],
              [-97.32762610599991, 26.230414130000042],
              [-97.32290605399993, 26.221502997000073],
              [-97.30874589799993, 26.20107656500005],
              [-97.31395423099991, 26.180121161000045],
              [-97.3152563139999, 26.150132554000038],
              [-97.31053626199991, 26.12327708500004],
              [-97.29824785099993, 26.11163971600007],
              [-97.29271399599992, 26.10960521000004],
              [-97.28563391799992, 26.105169989000046],
              [-97.27623450399994, 26.10065338700008],
              [-97.26378333199995, 26.09861888200004],
              [-97.23643958199995, 26.098089911000045],
              [-97.22386633999992, 26.09589264500005],
              [-97.21198482999995, 26.09121328300006],
              [-97.21540279899995, 26.076320705000057],
              [-97.22215735599991, 26.06708405200004],
              [-97.23253333199995, 26.06476471600007],
              [-97.24669348899994, 26.070705471000053],
              [-97.24803626199991, 26.053168036000045],
              [-97.2598363919999, 26.029120184000078],
              [-97.26036536399994, 26.015448309000078],
              [-97.25560462099992, 25.998928127000056],
              [-97.2520238919999, 25.992987372000073],
              [-97.24669348899994, 25.988755601000037],
              [-97.23623613199993, 25.984198309000078],
              [-97.2332250639999, 25.985541083000044],
              [-97.2317602199999, 25.989976304000038],
              [-97.22622636599993, 25.995021877000056],
              [-97.20173092399995, 26.005072333000044],
              [-97.19261633999992, 26.011542059000078],
              [-97.18529212099992, 26.022284247000073],
              [-97.18146725199995, 26.038031317000048],
              [-97.17955481699994, 26.05605703300006],
              [-97.1753637359999, 26.070868231000077],
              [-97.16478430899991, 26.07689036700009],
              [-97.15184485599991, 26.075018622000073],
              [-97.14317786399994, 26.047756252000056],
              [-97.14073645699995, 26.019191799000055],
              [-97.1375219389999, 25.97451406500005],
              [-97.13927161399994, 25.96580638200004],
              [-97.20494055199987, 25.960638733000067],
              [-97.25305130999993, 25.96348093700003],
              [-97.26635799199994, 25.960638733000067],
              [-97.26920019499994, 25.944360657000047],
              [-97.28764868199994, 25.92865102100008],
              [-97.31098059099989, 25.92208811400009],
              [-97.32844722499993, 25.933301900000046],
              [-97.35110734099987, 25.91841908800008],
              [-97.35511226399987, 25.91278635700006],
              [-97.3522700609999, 25.8944928990001],
              [-97.34516455099987, 25.871703593000106],
              [-97.34573299199991, 25.852221578000112],
              [-97.36599015299993, 25.843901673000047],
              [-97.37601538199993, 25.846743877],
              [-97.38012365799997, 25.85320343100007],
              [-97.38312089099989, 25.860541484000052],
              [-97.38989050399991, 25.865657451000047],
              [-97.39782283599988, 25.86581248],
              [-97.39947648199993, 25.861161601000035],
              [-97.39988989299994, 25.85511545900009],
              [-97.40417903699989, 25.85139475600009],
              [-97.42541805099987, 25.8548570760001],
              [-97.43572749899997, 25.86927480100003],
              [-97.4413085539999, 25.884932760000098],
              [-97.44825903299997, 25.892322490000097],
              [-97.46942053299992, 25.89294260700008],
              [-97.48631872599992, 25.895733134000025],
              [-97.50220922899985, 25.90188263],
              [-97.52027014199984, 25.91278635700006],
              [-97.56517696199987, 25.95474762000005],
              [-97.59432246899988, 25.96637481800012],
              [-97.60478694699992, 25.97996571900002],
              [-97.61305517699995, 25.99598541300007],
              [-97.62264115499997, 26.009059550000117],
              [-97.64145137499989, 26.02249542300008],
              [-97.65987402399989, 26.030660299000075],
              [-97.67961442099994, 26.034639385000062],
              [-97.76694759099988, 26.039651998000025],
              [-97.78030594899991, 26.043217672000097],
              [-97.78232132999995, 26.05861724900008],
              [-97.80201005099991, 26.063733215000084],
              [-97.87818111199991, 26.063733215000084],
              [-97.94166560999994, 26.0568085740001],
              [-97.99923315399988, 26.06430165600004],
              [-98.01305659999994, 26.063681539000058],
              [-98.04416581299989, 26.0487987260001],
              [-98.06545650299998, 26.04218414300003],
              [-98.0751458339999, 26.046628317000042],
              [-98.08331071099994, 26.07091624000013],
              [-98.1031027839999, 26.074947001000012],
              [-98.15023168999991, 26.063681539000058],
              [-98.18506160499987, 26.065231832000066],
              [-98.22265620999988, 26.07541208900004],
              [-98.30042924099993, 26.111430562000024],
              [-98.30980851299995, 26.121094056000047],
              [-98.33303706899997, 26.15303009000003],
              [-98.33926407899989, 26.15985138000009],
              [-98.36577408899987, 26.16016143800006],
              [-98.37727209499991, 26.16357208300009],
              [-98.37727209499991, 26.17364898700005],
              [-98.36933976299994, 26.19400950200007],
              [-98.3971933599999, 26.20114084900011],
              [-98.4288451749999, 26.217728984000118],
              [-98.45654374199984, 26.225945536000054],
              [-98.47238256899993, 26.207652079000084],
              [-98.49294978899994, 26.230596415000022],
              [-98.5215268559999, 26.240931702000026],
              [-98.5527910969999, 26.24832143100012],
              [-98.58162654599991, 26.262274068000025],
              [-98.64056351799994, 26.241810201000064],
              [-98.6536634929999, 26.24429067000004],
              [-98.6646964119999, 26.250646871000058],
              [-98.6852894699999, 26.26847524],
              [-98.69332515499988, 26.270542298000052],
              [-98.7022393389999, 26.27162750300006],
              [-98.70425472099993, 26.276640117000014],
              [-98.69146480399988, 26.290231019000103],
              [-98.70141251699997, 26.299119365000124],
              [-98.71316890499986, 26.30335683300008],
              [-98.72621720399991, 26.304390360000056],
              [-98.73991145899993, 26.30325347900005],
              [-98.73593237299986, 26.32004832000011],
              [-98.7463968509999, 26.332140605000106],
              [-98.78083919299985, 26.351674296000013],
              [-98.79585119699993, 26.368314108000035],
              [-98.80132889899991, 26.37213816300006],
              [-98.81029475999995, 26.372448222000045],
              [-98.81732275399987, 26.368520813000075],
              [-98.82502254299995, 26.36645375600004],
              [-98.83608129899996, 26.37213816300006],
              [-98.84233414799986, 26.36583363900006],
              [-98.85083492099996, 26.36407664000008],
              [-98.8605242519999, 26.366298727000085],
              [-98.87021358199993, 26.37213816300006],
              [-98.89302872799993, 26.36784902],
              [-98.92989986199986, 26.392240295000036],
              [-98.94537695399995, 26.378287659000037],
              [-98.95413610899993, 26.393945618000103],
              [-98.9628435879999, 26.399526673000096],
              [-98.98695064399995, 26.400095114000052],
              [-99.0040555419999, 26.39384226500006],
              [-99.01051509599995, 26.392602031000123],
              [-99.01643204799987, 26.394462383000032],
              [-99.02299495499994, 26.403350729000053],
              [-99.02787837799988, 26.40624460900004],
              [-99.04764461299995, 26.406968079000038],
              [-99.06635148099993, 26.40474599300002],
              [-99.08549759999993, 26.40763987200002],
              [-99.10642655499991, 26.423039450000104],
              [-99.10890702399989, 26.434253235000043],
              [-99.10252498399986, 26.446965637000105],
              [-99.09373999099996, 26.459781393000085],
              [-99.08937333299988, 26.471150208000083],
              [-99.09149206599996, 26.484017639000072],
              [-99.10299007199988, 26.51207794200009],
              [-99.11510819499996, 26.525617167000078],
              [-99.1409464109999, 26.531404928000043],
              [-99.1648725999999, 26.540448303000105],
              [-99.17128047699994, 26.563961080000084],
              [-99.17838598699987, 26.613673808],
              [-99.18112483799992, 26.629900208000024],
              [-99.22135493999994, 26.735733541000073],
              [-99.2340931799999, 26.78363759400007],
              [-99.24827836199987, 26.827097473],
              [-99.2627994389999, 26.8440473430001],
              [-99.2796717939999, 26.859653625000036],
              [-99.29396032799987, 26.876293437000058],
              [-99.32597387799987, 26.91153676300003],
              [-99.33698095699995, 26.92476593000002],
              [-99.3768493249999, 26.953756409],
              [-99.38617692099993, 26.962231344000102],
              [-99.39036271199987, 26.973135071000073],
              [-99.39015600599991, 26.993598938000034],
              [-99.39279150499992, 27.00476104800005],
              [-99.3993285729999, 27.012667542000102],
              [-99.40731258199988, 27.01452789300002],
              [-99.41604589899994, 27.014889628],
              [-99.42465002499998, 27.017886862000026],
              [-99.43986873399992, 27.028945618000122],
              [-99.44374446699996, 27.034578349000057],
              [-99.46172786499994, 27.05695424400004],
              [-99.4420391439999, 27.089613749000094],
              [-99.43940364599989, 27.09834706700009],
              [-99.44141902699994, 27.10749379500008],
              [-99.4457340089999, 27.11472849600004],
              [-99.45017818299992, 27.120464579],
              [-99.45245194599993, 27.125012106000028],
              [-99.45033321199986, 27.14516591400009],
              [-99.4357862959999, 27.18841908800006],
              [-99.43198807799988, 27.20759104400007],
              [-99.43402929799993, 27.226969706000133],
              [-99.4409022629999, 27.244798075000077],
              [-99.45183182799987, 27.261179504000026],
              [-99.46612036199994, 27.276527405000095],
              [-99.46896256599992, 27.27823272700006],
              [-99.48040889499993, 27.283297018000027],
              [-99.48294103999991, 27.28670766300006],
              [-99.48487890699994, 27.294820862000066],
              [-99.4865842289999, 27.29761138900004],
              [-99.4931988119999, 27.30128041600004],
              [-99.52136246799995, 27.311253967000127],
              [-99.51479956099988, 27.321795960000102],
              [-99.4975913089999, 27.338797506000034],
              [-99.49402563499993, 27.34820261700007],
              [-99.49288875399992, 27.358847961000052],
              [-99.48772111099991, 27.3718704220001],
              [-99.48462052399988, 27.391765849000095],
              [-99.47570633999995, 27.41476186200005],
              [-99.4729158129999, 27.42664744100007],
              [-99.4736392819999, 27.46380279600008],
              [-99.4729158129999, 27.468298645000104],
              [-99.47642980999986, 27.482509664000062],
              [-99.48040889499993, 27.4907778930001],
              [-99.48828955199987, 27.494653626000073],
              [-99.50368912899987, 27.495583802000013],
              [-99.50950272699993, 27.500027974000105],
              [-99.5100711669999, 27.510518291000082],
              [-99.50707393499997, 27.53343678800009],
              [-99.5072031249999, 27.573770244000073],
              [-99.51500626599993, 27.5886013800001],
              [-99.53503088399988, 27.604827779000104],
              [-99.5550296629999, 27.613509420000057],
              [-99.57226375399998, 27.618470358000096],
              [-99.57823238199991, 27.622811178000077],
              [-99.59024715199988, 27.6420606490001],
              [-99.60016902699996, 27.64642730700011],
              [-99.6124421789999, 27.64363678000005],
              [-99.63352616399993, 27.633068950000066],
              [-99.64486914099992, 27.63273305200009],
              [-99.64864151999984, 27.636918843000032],
              [-99.65869258599987, 27.654023743000053],
              [-99.66473872999991, 27.659398092000018],
              [-99.7003696299999, 27.659191386000074],
              [-99.70569230199993, 27.663170471000043],
              [-99.7106736549999, 27.670116197000098],
              [-99.72305558299986, 27.68738088000002],
              [-99.73065201899992, 27.691825053000045],
              [-99.73403682499993, 27.702031148000017],
              [-99.73631058799995, 27.713606669000043],
              [-99.74044470299988, 27.722159119000068],
              [-99.74734350599995, 27.726009013000024],
              [-99.76519771399991, 27.731176657000034],
              [-99.77457698599996, 27.735827535000098],
              [-99.7868501389999, 27.748488261000134],
              [-99.79542842699992, 27.76192413400007],
              [-99.80696277699992, 27.771423010000078],
              [-99.80816666699988, 27.77241444900004],
              [-99.83291967799991, 27.77675526900002],
              [-99.83297135499993, 27.782181295000086],
              [-99.84477941899993, 27.793575949000072],
              [-99.8582411299999, 27.803523662000075],
              [-99.86335709699998, 27.804660543000082],
              [-99.86472652299994, 27.814324036000116],
              [-99.86185847999988, 27.83607981400003],
              [-99.86335709699998, 27.845665792000133],
              [-99.87092769399993, 27.854476624000128],
              [-99.88020361399995, 27.859230856000025],
              [-99.88800675499988, 27.86481191000003],
              [-99.89128820899987, 27.87602569600007],
              [-99.88268408299993, 27.891580302000094],
              [-99.87880834999989, 27.901838074000082],
              [-99.88134049599996, 27.90646311500005],
              [-99.89676590999996, 27.91292266900011],
              [-99.91433589699993, 27.928244731000078],
              [-99.92991634199987, 27.946331482000076],
              [-99.93968318799992, 27.961085104000105],
              [-99.92828853399992, 27.975761210000073],
              [-99.9407167159999, 27.983254293000115],
              [-99.96185237699984, 27.987491760000083],
              [-99.97660599799985, 27.992452698000122],
              [-99.9911270759999, 28.007800599000078],
              [-100.00058386299987, 28.02040964800001],
              [-100.00745682799993, 28.033561300000073],
              [-100.01412308799985, 28.050459493000076],
              [-100.01350297099988, 28.05697072400004],
              [-100.01050573799995, 28.063611145000053],
              [-100.01019567899988, 28.06888214100009],
              [-100.01758540899989, 28.070949199000054],
              [-100.03153804599988, 28.081801250000083],
              [-100.04507727099985, 28.095288799000073],
              [-100.04802282699985, 28.102523499000128],
              [-100.0489013269999, 28.115959371000073],
              [-100.05649776199995, 28.137921855000045],
              [-100.07489457299995, 28.154406637000122],
              [-100.17287308799987, 28.198538310000018],
              [-100.18920283999991, 28.201328838000066],
              [-100.1976260989999, 28.207168274000068],
              [-100.20119177299996, 28.220345764000044],
              [-100.20294877199986, 28.234427592000074],
              [-100.20594600499996, 28.242876689000056],
              [-100.21281896999993, 28.245072938000064],
              [-100.2407242439999, 28.2496979780001],
              [-100.25793249499989, 28.260524191000044],
              [-100.27508907199986, 28.277241516000103],
              [-100.28433915299986, 28.29651682500004],
              [-100.27793127499991, 28.314887797000026],
              [-100.2785513919999, 28.33108835900002],
              [-100.29389929199995, 28.3534125770001],
              [-100.32263138899987, 28.3868989060001],
              [-100.33167476499992, 28.422013041000028],
              [-100.33632564399988, 28.458574117000055],
              [-100.34020137599994, 28.464258525],
              [-100.34831457599994, 28.470252991000038],
              [-100.3555492759999, 28.478185323],
              [-100.35678951099995, 28.48932159500002],
              [-100.35162186799994, 28.49671132500002],
              [-100.32263138899987, 28.51040557900005],
              [-100.36402421099991, 28.52479746500005],
              [-100.3842296959999, 28.53717397100003],
              [-100.39776892099988, 28.557586162000078],
              [-100.39875077399995, 28.56864491800006],
              [-100.3970971279999, 28.59272613500012],
              [-100.40143794799988, 28.602260437000027],
              [-100.4114631759999, 28.609314270000127],
              [-100.43482092299986, 28.619132793000077],
              [-100.44618973899993, 28.626496684000088],
              [-100.44489782699989, 28.643782450000074],
              [-100.4813813889999, 28.68605377300007],
              [-100.49393876199991, 28.708377991000035],
              [-100.51905350799984, 28.804961243],
              [-100.52499629799986, 28.814831441000067],
              [-100.52928544199992, 28.81994740800006],
              [-100.53445308499992, 28.83023101800005],
              [-100.53863887599995, 28.835631205000098],
              [-100.54515010599992, 28.838990174000045],
              [-100.55967118399988, 28.83937774700003],
              [-100.56623409099986, 28.842504171000073],
              [-100.5696964109999, 28.849609681000018],
              [-100.56334021099987, 28.86208953900011],
              [-100.56623409099986, 28.869789327],
              [-100.57176346899986, 28.873199972000023],
              [-100.58654292799987, 28.87978871700001],
              [-100.58954016199989, 28.883457743000108],
              [-100.59496618699987, 28.89932240800003],
              [-100.60695511999992, 28.910122782000045],
              [-100.61884069899995, 28.917925924000073],
              [-100.62431839999994, 28.924721375000033],
              [-100.62478348799996, 28.93776967400008],
              [-100.62669551599988, 28.948337504000037],
              [-100.6307779549999, 28.956683248],
              [-100.63790930199993, 28.962884420000094],
              [-100.62891760299989, 28.98433014000001],
              [-100.63279333499993, 29.00515574200007],
              [-100.65222367399991, 29.044817404000057],
              [-100.66085363799996, 29.102669169000066],
              [-100.66896683799987, 29.116208394000054],
              [-100.67816524299987, 29.119412334000017],
              [-100.6908259689999, 29.121014303000052],
              [-100.70203975499994, 29.12364980000008],
              [-100.70684566299987, 29.13018687000006],
              [-100.70973954299986, 29.135561218000092],
              [-100.76250118099998, 29.17377594],
              [-100.77009761699995, 29.187289327000073],
              [-100.76208776899996, 29.20865753200006],
              [-100.7831717539999, 29.24307403600004],
              [-100.79614253799993, 29.257672628000094],
              [-100.81608964099985, 29.270772604000044],
              [-100.86389034099993, 29.290616353000033],
              [-100.87179683499997, 29.296455791000128],
              [-100.89122717299995, 29.318547465000037],
              [-100.91473994999986, 29.337047628000064],
              [-100.9873970139999, 29.36632232700002],
              [-100.99830074099995, 29.372471822000065],
              [-101.00806758599991, 29.380585023],
              [-101.01623246299992, 29.390067648000056],
              [-101.02217525299993, 29.400480449],
              [-101.02594763199995, 29.41435557100006],
              [-101.02961665899996, 29.442984315000032],
              [-101.03778153599988, 29.460063375000075],
              [-101.06796057199998, 29.469494324000053],
              [-101.13477819799994, 29.487658590000066],
              [-101.16356197199985, 29.50130116800007],
              [-101.18270808899986, 29.5223593140001],
              [-101.19141556799993, 29.528147075000064],
              [-101.20177669299993, 29.530653382000068],
              [-101.21286128799994, 29.531583558000094],
              [-101.22278316299995, 29.540781962000025],
              [-101.22647802799995, 29.554450378000027],
              [-101.21777054899988, 29.58419016500001],
              [-101.21901078299992, 29.610286764000094],
              [-101.23391943399987, 29.622663269000057],
              [-101.25877579799992, 29.62015696200008],
              [-101.28358048499987, 29.60780629500003],
              [-101.30096960499989, 29.594137878000097],
              [-101.31215755199993, 29.597858581000125],
              [-101.31086564199988, 29.61276723300007],
              [-101.30272660399996, 29.6338512170001],
              [-101.30107295799992, 29.649509176000052],
              [-101.30978043599988, 29.65454762800003],
              [-101.33623876999988, 29.65431508400006],
              [-101.34902868699994, 29.660102845000026],
              [-101.3576844899999, 29.667440898000038],
              [-101.36435074999991, 29.676665141000043],
              [-101.37662390199993, 29.70064300500006],
              [-101.38336767599988, 29.718497213],
              [-101.39961991499989, 29.740718079000132],
              [-101.40654455599987, 29.752887879000056],
              [-101.40930924499992, 29.765781149000034],
              [-101.40509761599988, 29.77844187400008],
              [-101.4140117999999, 29.774411113],
              [-101.42421789599987, 29.771413880000082],
              [-101.43509578499993, 29.770121969000016],
              [-101.44610286499992, 29.77105214400008],
              [-101.45568884399992, 29.775909729],
              [-101.46243261799995, 29.78893219000004],
              [-101.47090755299986, 29.79151601200003],
              [-101.49028621499993, 29.785547384000026],
              [-101.50576330699992, 29.77389434800004],
              [-101.52180883899989, 29.765936178000075],
              [-101.54289282299992, 29.77105214400008],
              [-101.53968888399994, 29.779191182000076],
              [-101.53051631799987, 29.79647694900008],
              [-101.52860428999993, 29.801437887000034],
              [-101.53191158099993, 29.811101380000068],
              [-101.5391721199999, 29.817974345000025],
              [-101.54645849699989, 29.820144755000015],
              [-101.54976578799989, 29.815700582000105],
              [-101.55397741699993, 29.796683655000052],
              [-101.5649069829999, 29.78647756000008],
              [-101.58028072099988, 29.78156829800004],
              [-101.63221553599989, 29.77565134700002],
              [-101.79453120999989, 29.795856832000098],
              [-101.8029803059999, 29.801437887000034],
              [-101.8059775399999, 29.811928203],
              [-101.81269547499993, 29.812031556000093],
              [-101.82409012899993, 29.80518442800006],
              [-101.85760229499992, 29.80518442800006],
              [-101.87752355999994, 29.81084299700008],
              [-101.88741959699993, 29.81228993800009],
              [-101.89545528199992, 29.80862091100009],
              [-101.9023799239999, 29.803246562000126],
              [-101.91088069699991, 29.799887594000026],
              [-101.92015661699992, 29.798182271000044],
              [-101.9296134039999, 29.797717183000103],
              [-101.94266170299994, 29.803608297000025],
              [-101.95705358899994, 29.814046936000054],
              [-101.97224646099997, 29.81818105100008],
              [-101.98793025699985, 29.80518442800006],
              [-102.01459529599988, 29.810998027000025],
              [-102.10934403499992, 29.802109681000033],
              [-102.14564672899989, 29.815700582000105],
              [-102.15724808799985, 29.8245372520001],
              [-102.20367936299995, 29.846138001000085],
              [-102.23977534999996, 29.849135234000087],
              [-102.25344376599989, 29.855284729000076],
              [-102.25827551399989, 29.873474833],
              [-102.27618139699986, 29.86954742500005],
              [-102.28902299099985, 29.878125712000056],
              [-102.30217464199993, 29.889391174000124],
              [-102.32101070199994, 29.893938700000078],
              [-102.33023494499994, 29.888926087000087],
              [-102.33976924699994, 29.870632629000042],
              [-102.35106054799991, 29.86660186800013],
              [-102.36323034699991, 29.8642764290001],
              [-102.37072342999994, 29.857765198000052],
              [-102.37454748599988, 29.848101705000104],
              [-102.37658870499985, 29.82148834200008],
              [-102.38005102599989, 29.811385600000037],
              [-102.40413224299992, 29.780793152000015],
              [-102.40609594799986, 29.777279155000073],
              [-102.51528824899992, 29.7847205610001],
              [-102.52306555199993, 29.782317607000053],
              [-102.53112707599993, 29.769915263000073],
              [-102.54153987699995, 29.762473857000046],
              [-102.54334855199994, 29.760122579000026],
              [-102.54657832899993, 29.757874654000105],
              [-102.55314123599992, 29.756737773000097],
              [-102.55830887999991, 29.759089050000043],
              [-102.56288224299995, 29.76934682200003],
              [-102.5667579759999, 29.77105214400008],
              [-102.58530981499986, 29.764695944000053],
              [-102.62122493499992, 29.74728098600012],
              [-102.63874324599996, 29.74371531200005],
              [-102.67605362999991, 29.744490458000072],
              [-102.68346919799993, 29.74371531200005],
              [-102.69103979499988, 29.736816508000075],
              [-102.69362361799998, 29.729400940000048],
              [-102.69470882199997, 29.72061594700007],
              [-102.6977577319999, 29.70955719000007],
              [-102.72674820999988, 29.66449534100012],
              [-102.73126989799991, 29.65059438100006],
              [-102.73550736499996, 29.649509176000052],
              [-102.75165624999994, 29.622456564000103],
              [-102.75175960299988, 29.62015696200008],
              [-102.76134558099997, 29.603413798000034],
              [-102.76759842999988, 29.597290141000073],
              [-102.77966487699986, 29.59230336600011],
              [-102.77408382199994, 29.579616801000057],
              [-102.77646093799989, 29.575947774000056],
              [-102.78589188699995, 29.571813660000046],
              [-102.78075008199995, 29.55824859700006],
              [-102.78651200399992, 29.550497131000057],
              [-102.79547786499987, 29.54427012200007],
              [-102.8273105479999, 29.470502014000104],
              [-102.83395096899991, 29.46135528600003],
              [-102.8390669359999, 29.45195017500008],
              [-102.84113399299987, 29.438307597000076],
              [-102.8387052009999, 29.42693878200008],
              [-102.8349844979999, 29.415699158000038],
              [-102.83519120299985, 29.4038394170001],
              [-102.84454463699988, 29.390532736000083],
              [-102.84557816599997, 29.384719137],
              [-102.83803340699991, 29.370533956000045],
              [-102.83767167199991, 29.36632232700002],
              [-102.84656001899994, 29.361748963000068],
              [-102.85387223399992, 29.36099965500007],
              [-102.85986669999994, 29.361154683],
              [-102.86495682799993, 29.35952687600006],
              [-102.8769715989999, 29.350871073000107],
              [-102.88306941799995, 29.343765564000066],
              [-102.88518815199993, 29.333378601000064],
              [-102.88549820999991, 29.31480092400001],
              [-102.8993991699999, 29.276095276],
              [-102.89970922899997, 29.26389963800007],
              [-102.89213863099992, 29.254391175000094],
              [-102.86795406099995, 29.240386862],
              [-102.85878149399986, 29.22914723700005],
              [-102.86986608899987, 29.22478057900004],
              [-102.8968928629999, 29.220284730000046],
              [-102.94226477099994, 29.19020904600005],
              [-102.94753576699988, 29.182018331000037],
              [-102.9697566329999, 29.192844543000078],
              [-102.98838598699987, 29.1771349080001],
              [-103.01582617199992, 29.12677622500003],
              [-103.02427526899992, 29.116156718000028],
              [-103.0326210129999, 29.11021392800002],
              [-103.07254105599993, 29.091403707000026],
              [-103.08075760999988, 29.08520253600004],
              [-103.08558935599989, 29.075719910000046],
              [-103.0915321449999, 29.057865702000086],
              [-103.09535620199993, 29.060294495000065],
              [-103.10468379799997, 29.057865702000086],
              [-103.1092054849999, 29.023371684000026],
              [-103.12277054899988, 28.996474101000032],
              [-103.14798864799994, 28.985105286000035],
              [-103.18710770699995, 28.990221253000115],
              [-103.24175553499991, 29.003502096000133],
              [-103.30154516699986, 29.002365214000022],
              [-103.31624711199994, 29.010065002000104],
              [-103.31151447599987, 29.026042538000027],
              [-103.30999426299987, 29.031174825000036],
              [-103.32479956099988, 29.026808167000056],
              [-103.33048396899991, 29.02373341900004],
              [-103.34260209199991, 29.04122589200007],
              [-103.35167130599989, 29.039417217000093],
              [-103.3605338139999, 29.029831238000085],
              [-103.37208349699992, 29.02373341900004],
              [-103.38663041199987, 29.02879771],
              [-103.41463903799989, 29.05241383900001],
              [-103.42360489999992, 29.057865702000086],
              [-103.43569718499991, 29.061121318000076],
              [-103.47853694699985, 29.082050273000064],
              [-103.52974829199987, 29.12677622500003],
              [-103.53558772799994, 29.135121969000082],
              [-103.53822322699996, 29.142408345000078],
              [-103.54171138599992, 29.1488162240001],
              [-103.55023799699993, 29.154655660000103],
              [-103.55801529999994, 29.156205953000025],
              [-103.58499039699987, 29.154655660000103],
              [-103.67312455299992, 29.173569235000045],
              [-103.7024767669999, 29.187857768000114],
              [-103.74947648199986, 29.22297190400006],
              [-103.75906245999997, 29.226847637],
              [-103.77076717199995, 29.229844869000132],
              [-103.77771765199994, 29.235296733000027],
              [-103.76942358499988, 29.257543437000052],
              [-103.7742294929999, 29.26751698900007],
              [-103.78366044199994, 29.27480336500004],
              [-103.79417659599991, 29.277593893000088],
              [-103.86412064699991, 29.281366272000028],
              [-103.92812190799991, 29.293019308000098],
              [-104.01914994399993, 29.320330303],
              [-104.05731298899991, 29.3390371710001],
              [-104.10542374699988, 29.38567515000007],
              [-104.13978857399991, 29.4005838020001],
              [-104.16164770599995, 29.41675852500002],
              [-104.19451391599998, 29.44892710400005],
              [-104.21229060899991, 29.484661357000064],
              [-104.21869848699995, 29.489829],
              [-104.22714758399985, 29.49303293900003],
              [-104.25102209499994, 29.508587545000054],
              [-104.26717097999992, 29.52657094300004],
              [-104.29275081399987, 29.53282379200006],
              [-104.32060441199994, 29.532255351000103],
              [-104.33848445699991, 29.524012960000064],
              [-104.34902644899987, 29.53757802400004],
              [-104.43044266799988, 29.582794902000032],
              [-104.4378323979999, 29.585430399000032],
              [-104.44400773199987, 29.589202779000075],
              [-104.44855525799991, 29.597677714000056],
              [-104.45206925499987, 29.607108664000023],
              [-104.45522151799992, 29.613387350000053],
              [-104.46938085999996, 29.62540212],
              [-104.5166389579999, 29.65431508400006],
              [-104.53082413799987, 29.667905986000065],
              [-104.53503576699991, 29.67780202200005],
              [-104.53519079599994, 29.687853088000068],
              [-104.53710282499988, 29.702115784000043],
              [-104.54366573199985, 29.716430156000044],
              [-104.56139074799987, 29.745420634000098],
              [-104.57027909399997, 29.787511089000063],
              [-104.5835857749999, 29.802574768000042],
              [-104.60120743799989, 29.81477040700007],
              [-104.6196817629999, 29.83306386400004],
              [-104.62376420099991, 29.841487122000032],
              [-104.63758764699988, 29.88799591100006],
              [-104.65634619199996, 29.908201396000052],
              [-104.66063533599993, 29.918433330000127],
              [-104.6634775399999, 29.923084208],
              [-104.67652583899985, 29.936830140000026],
              [-104.68047908599992, 29.942307841000016],
              [-104.68246862899987, 29.952126363000062],
              [-104.68011734999992, 29.967784322000043],
              [-104.68047908599992, 29.97646596300008],
              [-104.69910843899989, 30.031449687000034],
              [-104.70158890799986, 30.055324199000026],
              [-104.69859167499995, 30.07527130100003],
              [-104.68463903799994, 30.111134746000076],
              [-104.68047908599992, 30.134130758000126],
              [-104.67867041099993, 30.170355937000082],
              [-104.68156429099992, 30.192938538000092],
              [-104.6958528239999, 30.208441467000014],
              [-104.71523148699987, 30.243994853000075],
              [-104.7245849209999, 30.252211406000114],
              [-104.74215490799989, 30.259859518],
              [-104.74938960899995, 30.264458721000054],
              [-104.7616885989999, 30.284199117000085],
              [-104.77414261999988, 30.311587627000037],
              [-104.78876704899994, 30.335927226000067],
              [-104.8077323009999, 30.346417541],
              [-104.81289994399991, 30.350706686000066],
              [-104.81496700099987, 30.360576884000054],
              [-104.81600052899985, 30.371997376000067],
              [-104.81827429199987, 30.380523987000075],
              [-104.82426875799989, 30.387190247],
              [-104.8375496019999, 30.394063212000063],
              [-104.8449393309999, 30.401039530000062],
              [-104.85325923699988, 30.41214996400008],
              [-104.85501623599994, 30.417472636000113],
              [-104.85362097299988, 30.423983866000086],
              [-104.85243241399985, 30.438866679000043],
              [-104.85465450099994, 30.448736877],
              [-104.86447302299992, 30.462017721],
              [-104.86669510999992, 30.47302480000009],
              [-104.86524816999993, 30.479897767000082],
              [-104.8596154389999, 30.49111155200002],
              [-104.8592537039999, 30.497261048],
              [-104.86302608299992, 30.502377015],
              [-104.87971757099986, 30.51085194900007],
              [-104.88214636299992, 30.520928854000104],
              [-104.88400671499993, 30.541857809000092],
              [-104.88659053599993, 30.551883037000025],
              [-104.89816605699987, 30.569401347000095],
              [-104.92824173999993, 30.59952870700009],
              [-104.9343395599999, 30.610535787000074],
              [-104.94105749599993, 30.61404978500012],
              [-104.97273514899993, 30.61802887],
              [-104.98276037599994, 30.620716044000048],
              [-104.98911657799988, 30.62955271400004],
              [-104.99164872299987, 30.640301412000056],
              [-104.99294063399992, 30.6514635220001],
              [-104.9957828379999, 30.661747132000087],
              [-105.00849523999995, 30.676991679000125],
              [-105.02797725499994, 30.690117493000102],
              [-105.04947465099988, 30.699264221000064],
              [-105.06812984299985, 30.70267486600001],
              [-105.08704341699989, 30.70980621400004],
              [-105.13360388299994, 30.757916972000103],
              [-105.14042517099989, 30.750475566],
              [-105.15324092699989, 30.763187969000043],
              [-105.15778845299991, 30.76572011300003],
              [-105.16088903799995, 30.764118144000108],
              [-105.16269771299994, 30.774918518000035],
              [-105.1672969169999, 30.781171367000027],
              [-105.17478999899993, 30.783961894000086],
              [-105.18512528499994, 30.784633688000085],
              [-105.1953055429999, 30.787940980000073],
              [-105.20491735899992, 30.802410381000087],
              [-105.21210038299996, 30.805717672000085],
              [-105.21824987899994, 30.806802877000095],
              [-105.22925695899993, 30.810213522000126],
              [-105.23287430899991, 30.80912831600004],
              [-105.23985062699991, 30.80153188100006],
              [-105.24398474199984, 30.7991030890001],
              [-105.2490490329999, 30.798844706000025],
              [-105.25948767099995, 30.802978821000053],
              [-105.26584387299997, 30.808404847000034],
              [-105.2707531339999, 30.81434763600005],
              [-105.2770059819999, 30.81941192600003],
              [-105.33431514499996, 30.843803202000046],
              [-105.36377071199988, 30.850366109000035],
              [-105.37617305599994, 30.85956451400004],
              [-105.41555049699994, 30.902455954000075],
              [-105.49668249599989, 30.95650950100007],
              [-105.53078894099987, 30.991701152000033],
              [-105.5559553639999, 31.002604879],
              [-105.56572220899994, 31.016660868000102],
              [-105.57864131699995, 31.05216257700006],
              [-105.5909403079999, 31.0714378870001],
              [-105.60587479699987, 31.08192820300006],
              [-105.62349645999986, 31.090351461000054],
              [-105.64380529799988, 31.10368398000007],
              [-105.66804154499995, 31.12786855100005],
              [-105.67522456899991, 31.131950989000032],
              [-105.69227779199993, 31.13763539600008],
              [-105.76819047099987, 31.180010071000098],
              [-105.77785396399989, 31.192722474000064],
              [-105.78483028199989, 31.21101593000013],
              [-105.86198319499994, 31.288375550000055],
              [-105.88014746199988, 31.30088124600003],
              [-105.89699397899996, 31.305997213000026],
              [-105.8971490079999, 31.30951121100007],
              [-105.90880204299987, 31.317004293000124],
              [-105.9280515139999, 31.3264610800001],
              [-105.93456274399996, 31.335504456000038],
              [-105.94177160699992, 31.352350973000043],
              [-105.94851538199995, 31.361239319000035],
              [-105.9612019459999, 31.371006165],
              [-106.00473933899993, 31.39694773400005],
              [-106.02114660699989, 31.40216705300007],
              [-106.04626135299992, 31.404647522000047],
              [-106.06530411899989, 31.410952047000038],
              [-106.09938472499995, 31.428883769000024],
              [-106.14111344499989, 31.439167379000097],
              [-106.1643161629999, 31.44779734300006],
              [-106.17447058199986, 31.46025136300004],
              [-106.2092488199999, 31.477304586000074],
              [-106.21542415499988, 31.48391917000008],
              [-106.21743953499993, 31.48872507700007],
              [-106.21873144499997, 31.494616191],
              [-106.2228913989999, 31.50458974200008],
              [-106.23265824399995, 31.519937643000063],
              [-106.2747486989999, 31.56262237600005],
              [-106.28629838099994, 31.580140687000025],
              [-106.3122916269999, 31.648611959000036],
              [-106.33130855399988, 31.68214996300013],
              [-106.35849035699995, 31.717548320000063],
              [-106.39176997999989, 31.74591868100005],
              [-106.4289511729999, 31.75847605400007],
              [-106.4731345219999, 31.75506540900004],
              [-106.49279740499993, 31.759044495000026],
              [-106.50142524799989, 31.766343684],
              [-106.50605240999994, 31.770258281000068],
              [-106.51718867999996, 31.773823954000036],
              [-106.55896907599993, 31.773875631000053],
              [-106.58485896899995, 31.77392730700008],
              [-106.61069718499988, 31.773978984000095],
              [-106.63658707699992, 31.774082337000024],
              [-106.66247696999994, 31.774134014000126],
              [-106.68831518599987, 31.774237366000065],
              [-106.7142050779999, 31.774237366000065],
              [-106.74009497099993, 31.774289042000063],
              [-106.76593318799986, 31.774392395000106],
              [-106.79182307999989, 31.774444072],
              [-106.81771297299993, 31.774495748000035],
              [-106.84360286499995, 31.77454742500005],
              [-106.86944108099988, 31.77459910100005],
              [-106.89533097399992, 31.774702453000074],
              [-106.92122086599994, 31.774702453000074],
              [-106.94711075899988, 31.77475413000009],
              [-106.97300065199991, 31.77485748300002],
              [-106.99889054399995, 31.774909160000036],
              [-107.02478043699998, 31.774960836000062],
              [-107.05067032899991, 31.77501251300008],
              [-107.07650854499994, 31.775064189],
              [-107.10239843799988, 31.7751675410001],
              [-107.1282883299999, 31.7751675410001],
              [-107.15412654699993, 31.775219218000117],
              [-107.18001643999987, 31.775374248000062],
              [-107.2059063319999, 31.775374248000062],
              [-107.23179622499993, 31.77542592400009],
              [-107.25763444099995, 31.775477601],
              [-107.28352433299989, 31.775529277000103],
              [-107.30941422599992, 31.77563262900013],
              [-107.33525244199986, 31.77568430600006],
              [-107.36114233399988, 31.775787659000073],
              [-107.3870322269999, 31.775787659000073],
              [-107.41289628199993, 31.7758393350001],
              [-107.43878617399987, 31.775942689000104],
              [-107.46467606599991, 31.77599436500013],
              [-107.49056595899994, 31.77609771700007],
              [-107.51640417599987, 31.776149394000086],
              [-107.5422940679999, 31.776201070000084],
              [-107.56818396099993, 31.7762527470001],
              [-107.59407385299995, 31.776304423000013],
              [-107.6199637459999, 31.776407776000056],
              [-107.64585363899994, 31.776459453000072],
              [-107.67174353099996, 31.776459453000072],
              [-107.6976334239999, 31.776562805000097],
              [-107.72347163999993, 31.776614482000085],
              [-107.74936153199987, 31.77666615800011],
              [-107.7752514249999, 31.776717835000042],
              [-107.80114131699993, 31.77676951100004],
              [-107.82697953299994, 31.776872864000083],
              [-107.85286942599988, 31.77692454100007],
              [-107.87875931799992, 31.77692454100007],
              [-107.90459753499994, 31.777027893000096],
              [-107.93048742799996, 31.777079569000122],
              [-107.9563773199999, 31.777131246000053],
              [-107.98221553599993, 31.77718292300007],
              [-108.00810542899987, 31.777234599000067],
              [-108.03399532099989, 31.777337952],
              [-108.05988521399993, 31.777389629000098],
              [-108.08572342899994, 31.777389629000098],
              [-108.11161332199988, 31.777544657000064],
              [-108.13750321499992, 31.777544657000064],
              [-108.16334143099994, 31.777648010000078],
              [-108.18928299999989, 31.777699687000094],
              [-108.2151212169999, 31.777751364000025],
              [-108.2151212169999, 31.770723369],
              [-108.2151212169999, 31.76369537400008],
              [-108.2151212169999, 31.756667379000092],
              [-108.2151212169999, 31.749639384000076],
              [-108.2151212169999, 31.742559713000063],
              [-108.2151212169999, 31.735583395000063],
              [-108.2151212169999, 31.728555400000047],
              [-108.2151212169999, 31.7214757280001],
              [-108.2151212169999, 31.714396057],
              [-108.2151212169999, 31.707419739],
              [-108.2151212169999, 31.7003917440001],
              [-108.2151212169999, 31.693312073000058],
              [-108.2151212169999, 31.68628407900006],
              [-108.2151212169999, 31.679256084000045],
              [-108.2151212169999, 31.67217641200004],
              [-108.2150695399999, 31.665148418000015],
              [-108.21501786399998, 31.658172099000026],
              [-108.21501786399998, 31.651092428000098],
              [-108.21501786399998, 31.644064433],
              [-108.21501786399998, 31.637036438000067],
              [-108.21501786399998, 31.63000844300008],
              [-108.21501786399998, 31.622980449000053],
              [-108.21501786399998, 31.615952454000038],
              [-108.21501786399998, 31.608872782000034],
              [-108.21501786399998, 31.601844788],
              [-108.21501786399998, 31.594816793000106],
              [-108.21501786399998, 31.58778879800009],
              [-108.21501786399998, 31.580760803000075],
              [-108.21501786399998, 31.573732808000088],
              [-108.21501786399998, 31.566653138000063],
              [-108.21501786399998, 31.559625143000048],
              [-108.21496618699987, 31.552597148000032],
              [-108.21496618699987, 31.54556915300013],
              [-108.21496618699987, 31.538489482],
              [-108.21496618699987, 31.5314614870001],
              [-108.21496618699987, 31.5244851690001],
              [-108.21496618699987, 31.51740549800006],
              [-108.21496618699987, 31.510377503000072],
              [-108.21496618699987, 31.503401184000055],
              [-108.21496618699987, 31.49632151300004],
              [-108.21496618699987, 31.489241842000027],
              [-108.21496618699987, 31.482213847000097],
              [-108.21496618699987, 31.475237529000097],
              [-108.21496618699987, 31.468157857000094],
              [-108.21496618699987, 31.461129862000078],
              [-108.21496618699987, 31.45410186800008],
              [-108.21496618699987, 31.447073873000065],
              [-108.21491451099986, 31.44004587800005],
              [-108.21486283399993, 31.432966208000025],
              [-108.21486283399993, 31.425938213000038],
              [-108.21486283399993, 31.418910218000107],
              [-108.21486283399993, 31.41188222300009],
              [-108.21486283399993, 31.404802552000078],
              [-108.21486283399993, 31.39782623300009],
              [-108.21486283399993, 31.390798239000063],
              [-108.21486283399993, 31.38371856700006],
              [-108.21486283399993, 31.37663889600013],
              [-108.21486283399993, 31.36966257800013],
              [-108.21486283399993, 31.36263458300003],
              [-108.21486283399993, 31.355554911000084],
              [-108.21486283399993, 31.348526917000086],
              [-108.21486283399993, 31.341550598000097],
              [-108.21486283399993, 31.334470927000055],
              [-108.21481115799992, 31.327442932000068],
              [-108.25757340499985, 31.32739125600004],
              [-108.30033565299996, 31.32739125600004],
              [-108.34302038599986, 31.32739125600004],
              [-108.38573095799987, 31.32739125600004],
              [-108.42844152899997, 31.32739125600004],
              [-108.47115209999988, 31.32739125600004],
              [-108.51383683299987, 31.32739125600004],
              [-108.55654740399989, 31.32739125600004],
              [-108.5993096519999, 31.32739125600004],
              [-108.6420202229999, 31.32739125600004],
              [-108.6847566329999, 31.32739125600004],
              [-108.72746720399992, 31.32739125600004],
              [-108.77017777599993, 31.32739125600004],
              [-108.81291418599993, 31.32739125600004],
              [-108.85562475699993, 31.32739125600004],
              [-108.89833532799994, 31.32739125600004],
              [-108.94104589899986, 31.32739125600004],
              [-108.9682819669999, 31.32739125600004],
              [-108.98373063199995, 31.32739125600004],
              [-109.02649287999986, 31.32739125600004],
              [-109.04743046299986, 31.32739125600004],
              [-109.06920345099988, 31.32739125600004],
              [-109.11191402299997, 31.32739125600004],
              [-109.15459875599987, 31.32739125600004],
              [-109.19736100399989, 31.32739125600004],
              [-109.2400715749999, 31.327339580000043],
              [-109.2827821459999, 31.327339580000043],
              [-109.32551855499992, 31.327339580000043],
              [-109.36822912599992, 31.327339580000043],
              [-109.41091385899992, 31.327339580000043],
              [-109.45365026899992, 31.327339580000043],
              [-109.49638667799994, 31.327339580000043],
              [-109.53907141199993, 31.327339580000043],
              [-109.58180782099994, 31.327339580000043],
              [-109.62449255399994, 31.327339580000043],
              [-109.66717728799993, 31.327339580000043],
              [-109.70996537299996, 31.327339580000043],
              [-109.75265010599988, 31.327339580000043],
              [-109.79533483999987, 31.327339580000043],
              [-109.8381229249999, 31.327339580000043],
              [-109.88080765899988, 31.327339580000043],
              [-109.92359574399991, 31.327287903000112],
              [-109.96628047799992, 31.327236227000085],
              [-110.0089652109999, 31.327236227000085],
              [-110.05170161999992, 31.327236227000085],
              [-110.09438635299992, 31.327236227000085],
              [-110.13707108599992, 31.327236227000085],
              [-110.17980749599992, 31.327236227000085],
              [-110.22254390599994, 31.327236227000085],
              [-110.26522863799994, 31.327236227000085],
              [-110.30801672399987, 31.327236227000085],
              [-110.35075313299988, 31.327236227000085],
              [-110.39348954299989, 31.327236227000085],
              [-110.43617427699989, 31.327236227000085],
              [-110.47885900899989, 31.327236227000085],
              [-110.5215954189999, 31.327236227000085],
              [-110.5642801519999, 31.327236227000085],
              [-110.6069648849999, 31.327236227000085],
              [-110.64972713299991, 31.327236227000085],
              [-110.69243770399991, 31.327236227000085],
              [-110.73519995099993, 31.327236227000085],
              [-110.77788468499993, 31.327236227000085],
              [-110.82059525599993, 31.327236227000085],
              [-110.86335750399986, 31.327236227000085],
              [-110.90606807499987, 31.327236227000085],
              [-110.94875280799995, 31.327184550000098],
              [-111.00626867799988, 31.327184550000098],
              [-111.06711767599991, 31.333644104000044],
              [-111.09445450899995, 31.342532451000054],
              [-111.14592423599993, 31.359068909000044],
              [-111.19744563799992, 31.375553690000046],
              [-111.2488636879999, 31.392141826000042],
              [-111.30033341499988, 31.40872996000006],
              [-111.35180314199997, 31.425318095000065],
              [-111.40329870599996, 31.441854554000045],
              [-111.45476843299994, 31.45833933500002],
              [-111.50623815999992, 31.47497914700004],
              [-111.91546382699991, 31.601431376],
              [-112.32471533199991, 31.72798695900009],
              [-112.73396683799992, 31.85454254200006],
              [-113.1432183429999, 31.981046448000043],
              [-113.55244401099989, 32.10760203100004],
              [-113.9616955169999, 32.23413177500002],
              [-114.37092118399988, 32.360687358000106],
              [-114.78014685099987, 32.48724294000009],
              [-114.81678544199993, 32.49853424100006],
              [-114.81937311799989, 32.49936330200008],
              [-114.82210811499996, 32.50023956300002],
              [-114.80944738899993, 32.51132415800002],
              [-114.79554642799987, 32.55222605400003],
              [-114.7942028399999, 32.57411102400009],
              [-114.80267777499989, 32.59449737500002],
              [-114.78681311099989, 32.62103322400013],
              [-114.78154211399995, 32.62806121800004],
              [-114.75880448499987, 32.644830221000106],
              [-114.7511563719999, 32.652219951000106],
              [-114.73947749899992, 32.669066468],
              [-114.73120926999988, 32.686636454000066],
              [-114.72387121699988, 32.71151865700001],
              [-114.7242846279999, 32.71283640500009],
              [-114.76454056899993, 32.70983917300008],
              [-114.83807613199991, 32.70420644200003],
              [-114.91161169499989, 32.69870290200005],
              [-114.98519893499989, 32.69312184700003],
              [-115.05873449699996, 32.68756663],
              [-115.13227006099994, 32.6819855750001],
              [-115.20580562399992, 32.67645619700009],
              [-115.27928951099989, 32.67082346600007],
              [-115.35285091199988, 32.66534576500008],
              [-115.42638647499986, 32.65976471000006],
              [-115.49992203799994, 32.65420949300004],
              [-115.57353511599985, 32.648654277000034],
              [-115.64701900299991, 32.64307322200004],
              [-115.72052872799988, 32.637518006],
              [-115.79406429099996, 32.63196278900001],
              [-115.86759985399993, 32.626407573000094],
              [-115.94121293199994, 32.62082651800007],
              [-116.01474849499992, 32.61527130200007],
              [-116.08823238199989, 32.60966440800006],
              [-116.16174210699987, 32.60416086900004],
              [-116.23532934599986, 32.59855397500003],
              [-116.30889074799985, 32.593024597000024],
              [-116.38242631099992, 32.58746938100002],
              [-116.4559618739999, 32.58188832600008],
              [-116.52947159899988, 32.57633311000008],
              [-116.60300716199995, 32.57080373200007],
              [-116.67654272499993, 32.56522267700008],
              [-116.75010412699991, 32.55966746000006],
              [-116.8236396889999, 32.55408640600005],
              [-116.89720109099989, 32.54853118900003],
              [-116.97073665399988, 32.542975973000026],
              [-117.04422054099993, 32.53742075600012],
              [-117.12512148894416, 32.53166949000402],
              [-117.12612870999993, 32.539496161000045],
              [-117.13219153599994, 32.568060614000046],
              [-117.1339489749999, 32.59289568600008],
              [-117.13700664699991, 32.61576069900008],
              [-117.14981035099993, 32.64630768400008],
              [-117.16637122299994, 32.66950104400007],
              [-117.18838456899994, 32.68268463700008],
              [-117.22397483599991, 32.68471444100004],
              [-117.22618603199993, 32.69720666100005],
              [-117.22002959199995, 32.70659624100006],
              [-117.20581376199993, 32.71340310900007],
              [-117.19095610599993, 32.71369924700008],
              [-117.18785949099993, 32.705935569000076],
              [-117.16805804599994, 32.69880508600005],
              [-117.16417395699995, 32.68378327000005],
              [-117.15585345699992, 32.67236702100007],
              [-117.14279661899991, 32.65311594100007],
              [-117.13127776499994, 32.63099088300004],
              [-117.12408553699993, 32.60676615700004],
              [-117.11508920699993, 32.600261543000045],
              [-117.10338415399991, 32.60681045200005],
              [-117.10231105899993, 32.620468257000084],
              [-117.11989198399993, 32.65263396200004],
              [-117.1190165729999, 32.67060997200008],
              [-117.13320878799993, 32.68984609600005],
              [-117.14632505599991, 32.69426202300008],
              [-117.16657467399995, 32.70677317900004],
              [-117.17734338499992, 32.715030606000084],
              [-117.17463812499994, 32.726732120000065],
              [-117.20985776399993, 32.72528414300007],
              [-117.22424391699991, 32.71864055200007],
              [-117.2378335699999, 32.70722308400008],
              [-117.23656165299991, 32.669623114000046],
              [-117.2452796209999, 32.674584210000035],
              [-117.25527910099993, 32.691392320000034],
              [-117.25747636599993, 32.70172760600008],
              [-117.25472727099992, 32.74644966900007],
              [-117.25387719199995, 32.76352008500004],
              [-117.25755620799993, 32.784244680000086],
              [-117.27879301299993, 32.82281247800006],
              [-117.28359725099995, 32.83765398500009],
              [-117.27378915299994, 32.85114569000007],
              [-117.26603869299993, 32.847035410000046],
              [-117.2598737639999, 32.85406683900004],
              [-117.25364093999991, 32.88508136300004],
              [-117.25806555399993, 32.90898331900007],
              [-117.27476966099994, 32.993475653000075],
              [-117.2795646759999, 33.007223916000044],
              [-117.28604081899994, 33.023871161000045],
              [-117.2980752389999, 33.03590398000006],
              [-117.32216122299991, 33.10850061600007],
              [-117.36191411699991, 33.165943481000056],
              [-117.50884421199993, 33.33520533700005],
              [-117.59630286399994, 33.39044830900008],
              [-117.6543676419999, 33.44196198100008],
              [-117.6707250639999, 33.45229726800005],
              [-117.71519934799994, 33.47483958500004],
              [-117.73521887899994, 33.48476797100005],
              [-117.77651933499993, 33.529364325000074],
              [-117.82457434799994, 33.56167226800005],
              [-117.88025104799993, 33.59288017700004],
              [-117.93022019699993, 33.60791849200007],
              [-117.97850501199991, 33.635972398000035],
              [-118.0905362129999, 33.73097720700008],
              [-118.11738749199992, 33.74360654600008],
              [-118.15258092499994, 33.75876540000007],
              [-118.17363927499991, 33.76328316000007],
              [-118.18553315199995, 33.75750689800009],
              [-118.19896675599995, 33.76403565700008],
              [-118.20720976399991, 33.76383356900004],
              [-118.19249813099992, 33.75230892500008],
              [-118.1866181829999, 33.74148433500005],
              [-118.18518891299993, 33.732372421000036],
              [-118.19286265999995, 33.731728564000036],
              [-118.20247916499994, 33.739265809000074],
              [-118.20274549499993, 33.74657520000005],
              [-118.2097349679999, 33.74228685500009],
              [-118.21382720799994, 33.749044833000085],
              [-118.2215063139999, 33.77090078300006],
              [-118.23070227799991, 33.76911041900007],
              [-118.2403355429999, 33.76758313700009],
              [-118.2500910689999, 33.76368354200008],
              [-118.25455189899992, 33.765400526000064],
              [-118.26036536399994, 33.76040273600006],
              [-118.26951448799991, 33.753597021000076],
              [-118.27677037199993, 33.75661592800009],
              [-118.27379138299995, 33.75028920800008],
              [-118.27831692599995, 33.73874587800009],
              [-118.27447190299989, 33.72375460400008],
              [-118.27220618399991, 33.715277411000045],
              [-118.28244112499993, 33.71623738900007],
              [-118.2817251809999, 33.71168255300006],
              [-118.27608414699989, 33.70771156500007],
              [-118.28268967899993, 33.707999821000044],
              [-118.29130663299992, 33.70320826500006],
              [-118.30088189599991, 33.70984876300008],
              [-118.31751837199994, 33.71399035600007],
              [-118.33146024299992, 33.72005143800004],
              [-118.3548165759999, 33.72626481700007],
              [-118.36228628999993, 33.73568704300004],
              [-118.37607887699994, 33.737157499000034],
              [-118.38500141499992, 33.74011612700008],
              [-118.39418866499994, 33.73668722200006],
              [-118.40135795899994, 33.73555897600005],
              [-118.40480844299992, 33.74004856000005],
              [-118.41204094599993, 33.74167819000007],
              [-118.41521668099995, 33.75440951200005],
              [-118.42278279499993, 33.76379888300005],
              [-118.42756864599994, 33.773730759000046],
              [-118.4218185019999, 33.78394388000004],
              [-118.40930293999992, 33.79112391400008],
              [-118.4086357729999, 33.79800318900004],
              [-118.3957152779999, 33.805653987000085],
              [-118.39179996799993, 33.81764675900007],
              [-118.3913880589999, 33.835940991000086],
              [-118.3972113559999, 33.84402286200009],
              [-118.3996732579999, 33.85126502800006],
              [-118.40991604999994, 33.87342034300008],
              [-118.42494561299992, 33.90551341000008],
              [-118.4446508449999, 33.94940827000005],
              [-118.48265540299991, 33.99900950700004],
              [-118.51406816299993, 34.02216217700004],
              [-118.54405676999994, 34.03888580900008],
              [-118.55730367799993, 34.037883194000074],
              [-118.57062402499992, 34.04110557100006],
              [-118.58262757499995, 34.03652933900008],
              [-118.59073835399994, 34.03909274000006],
              [-118.60340040099993, 34.03881841800006],
              [-118.60926576799994, 34.035651389000066],
              [-118.63694225699993, 34.03639243500004],
              [-118.6665890509999, 34.03894451800005],
              [-118.67566404899992, 34.03812074200005],
              [-118.67819925299995, 34.033030377000046],
              [-118.68013695199994, 34.03033038600006],
              [-118.69316066099992, 34.03188372500006],
              [-118.70678045599993, 34.02942726200007],
              [-118.7305261649999, 34.032544976000054],
              [-118.74839232099993, 34.03188851200008],
              [-118.75614431799994, 34.025719679000076],
              [-118.77301849199989, 34.023763951000035],
              [-118.78339865399994, 34.02183923700005],
              [-118.7879295329999, 34.01966392200006],
              [-118.78920803199992, 34.014561763000074],
              [-118.79275121199993, 34.01157132900005],
              [-118.7937038099999, 34.007266866000066],
              [-118.7966123199999, 34.00670570400007],
              [-118.80276808999992, 34.00479618700007],
              [-118.80406027399994, 34.001036196000086],
              [-118.8069690559999, 33.999406269000076],
              [-118.82981426099991, 34.02082363400007],
              [-118.85260382799993, 34.033656929000074],
              [-118.86266249699992, 34.03443339000006],
              [-118.8757194179999, 34.03755120300008],
              [-118.8942207529999, 34.03856136300004],
              [-118.90267163599992, 34.04014894100004],
              [-118.91469361299994, 34.04063740300006],
              [-118.9209036929999, 34.04430167900006],
              [-118.93000607599993, 34.04589626200004],
              [-118.93680748999992, 34.04320030900004],
              [-118.95403653799991, 34.04785799500007],
              [-118.97750382499993, 34.059566],
              [-118.99736639399993, 34.065651406000086],
              [-119.00807992499995, 34.066119549000064],
              [-119.03825899899994, 34.08363988500008],
              [-119.0609049769999, 34.08552960800006],
              [-119.0896982029999, 34.10048386400007],
              [-119.10015881899994, 34.10280702000006],
              [-119.11705176999993, 34.106416041000045],
              [-119.11977854299994, 34.10613152800005],
              [-119.11959433099992, 34.10373920600006],
              [-119.11432857999989, 34.10179271000004],
              [-119.10065187399994, 34.098963103000074],
              [-119.10648159699991, 34.09446610900005],
              [-119.1286529329999, 34.100546906000034],
              [-119.15375763599991, 34.11632543500008],
              [-119.1937016249999, 34.14173784900004],
              [-119.2043798819999, 34.144096672000046],
              [-119.20575006999991, 34.145757407000076],
              [-119.2041986669999, 34.14841381600007],
              [-119.20466455799993, 34.14953572700006],
              [-119.20832263599993, 34.152321691000054],
              [-119.21013591899992, 34.152308076000054],
              [-119.21099450799994, 34.14798726400005],
              [-119.21482288199991, 34.145707164000044],
              [-119.21708747399992, 34.14550181900006],
              [-119.2207995519999, 34.15316553800005],
              [-119.22469729999995, 34.15707525100004],
              [-119.22608056199994, 34.15912833800007],
              [-119.2311609699999, 34.16734425900006],
              [-119.23716449299991, 34.17686509500004],
              [-119.24396725199995, 34.19009023600006],
              [-119.25267493399991, 34.20392487200007],
              [-119.26019404699991, 34.217123971000035],
              [-119.26336174999994, 34.226576832000035],
              [-119.25885862599989, 34.23335293200006],
              [-119.26390540299991, 34.23505280200004],
              [-119.2671606109999, 34.24453359600005],
              [-119.26929996199993, 34.254958566000084],
              [-119.28115800699993, 34.26870351800005],
              [-119.28991519699991, 34.27457603300007],
              [-119.29602821499992, 34.274321504000056],
              [-119.3044166599999, 34.27236225300004],
              [-119.3133921249999, 34.27712827000005],
              [-119.32069048699992, 34.282635808000066],
              [-119.32911819599991, 34.28592955600004],
              [-119.33859565299991, 34.290479935000064],
              [-119.34948825999993, 34.30407496500004],
              [-119.35876892099992, 34.31009389800005],
              [-119.3646987919999, 34.31572568800004],
              [-119.37085853499991, 34.31967452300006],
              [-119.3751910179999, 34.32027340500008],
              [-119.38206237599991, 34.319370141000036],
              [-119.38688765699993, 34.318065223000076],
              [-119.3914824279999, 34.31844489700006],
              [-119.3941060819999, 34.322601149000036],
              [-119.40107790299993, 34.33057152400005],
              [-119.4098238119999, 34.336172815000054],
              [-119.41831676899994, 34.342382299000064],
              [-119.4299527359999, 34.35347150700005],
              [-119.43661713599994, 34.35572768800006],
              [-119.44323618099992, 34.35482157100006],
              [-119.45303379899991, 34.368401221000056],
              [-119.4602290929999, 34.37404041000008],
              [-119.46623507699991, 34.37502182500009],
              [-119.47020464699995, 34.37581377100008],
              [-119.47297244299995, 34.37388862900008],
              [-119.4752420129999, 34.37239325200005],
              [-119.4777979989999, 34.37257934500008],
              [-119.47962223399992, 34.374458883000045],
              [-119.48351043899993, 34.37863298100007],
              [-119.4881671849999, 34.381115701000056],
              [-119.49486272799993, 34.38399710300007],
              [-119.50251414299993, 34.38434220100004],
              [-119.51680633099994, 34.38693807200008],
              [-119.52069145399992, 34.39068908400009],
              [-119.5294283639999, 34.394812854000065],
              [-119.5368397279999, 34.39558041600009],
              [-119.55569451399992, 34.41045053000005],
              [-119.5631751219999, 34.41479451300006],
              [-119.56800921999991, 34.413902574000076],
              [-119.57285497999993, 34.412795620000054],
              [-119.57589369399994, 34.41192422600005],
              [-119.58179119599993, 34.41270141800004],
              [-119.59585527299993, 34.418850002000056],
              [-119.61715964399991, 34.42052717200005],
              [-119.6211967509999, 34.41817319000006],
              [-119.62886085299994, 34.418083970000055],
              [-119.63851164599993, 34.415242456000044],
              [-119.6579285489999, 34.41650624400006],
              [-119.67806091499995, 34.414385001000085],
              [-119.68769993199993, 34.41090310800007],
              [-119.69020758799991, 34.40813791000005],
              [-119.69169396699994, 34.40538390900008],
              [-119.6908978049999, 34.40349819800008],
              [-119.70080462199991, 34.40085630400006],
              [-119.70203685199994, 34.39810493900006],
              [-119.70787935499993, 34.39544085600005],
              [-119.71989584999994, 34.395301310000036],
              [-119.73294749699994, 34.397464126000045],
              [-119.7432150709999, 34.402607612000054],
              [-119.7545045359999, 34.40478592000005],
              [-119.78764887499995, 34.41721116300005],
              [-119.80296475299991, 34.418097903000046],
              [-119.80854875299991, 34.416345410000076],
              [-119.8320353599999, 34.41626430300005],
              [-119.83640736899991, 34.414948130000084],
              [-119.84101173199991, 34.41298291600009],
              [-119.8409422119999, 34.41003977200006],
              [-119.84238967699991, 34.40623308000005],
              [-119.84438479099992, 34.40389249400005],
              [-119.85472013499992, 34.40880686500009],
              [-119.86824157599995, 34.409479315000056],
              [-119.87435016099994, 34.408769703000075],
              [-119.87863581699992, 34.40661306000004],
              [-119.89036627699994, 34.41909243400005],
              [-119.90060145899992, 34.42043595100006],
              [-119.92152797099993, 34.433401349000064],
              [-119.93484071699993, 34.435541072000035],
              [-119.94275591899992, 34.43523731000005],
              [-119.94989736199994, 34.434311362000074],
              [-119.9570721899999, 34.43589230500004],
              [-119.96224848499992, 34.43981498100004],
              [-119.97593204999993, 34.44720980000005],
              [-119.98466738699994, 34.45003496800007],
              [-119.98952735599994, 34.44976752300005],
              [-120.0099676609999, 34.46101195700004],
              [-120.02213620499992, 34.457696147000036],
              [-120.0365989959999, 34.463137087000064],
              [-120.09142005099994, 34.45880768400008],
              [-120.13341223899994, 34.472723700000074],
              [-120.17187110399993, 34.46998475800007],
              [-120.2932065579999, 34.46848556300006],
              [-120.42520097599993, 34.45132070500006],
              [-120.44434240099991, 34.45118213200004],
              [-120.45410749899992, 34.442811833000064],
              [-120.47268143299993, 34.45027297200005],
              [-120.49160722599993, 34.49135976800005],
              [-120.50998579399993, 34.52137453900008],
              [-120.53636322699992, 34.53529329100007],
              [-120.55783556599994, 34.54115959400008],
              [-120.5779314959999, 34.553543183000045],
              [-120.59456853199993, 34.55469682100005],
              [-120.62161600899992, 34.552613560000054],
              [-120.63662675699993, 34.56289297100005],
              [-120.6444366899999, 34.574131281000064],
              [-120.64783419299994, 34.58567558900006],
              [-120.6421091339999, 34.60102323700005],
              [-120.63056668099995, 34.628194386000075],
              [-120.6141356579999, 34.65940330500007],
              [-120.6060546359999, 34.67934998900006],
              [-120.60305365599993, 34.70478195000004],
              [-120.61701412699995, 34.72565338700008],
              [-120.62759355399993, 34.743475653000075],
              [-120.64024817599994, 34.75853099200009],
              [-120.6299179429999, 34.78193265600004],
              [-120.61921216799993, 34.819206217000044],
              [-120.61741248099992, 34.843631567000045],
              [-120.6155731899999, 34.85800259800004],
              [-120.6221884119999, 34.867299625000044],
              [-120.63255774599992, 34.87140534100007],
              [-120.64024817599994, 34.87921784100007],
              [-120.6446104719999, 34.89511285700007],
              [-120.65497302199992, 34.90118597400004],
              [-120.66764685999993, 34.89884811200005],
              [-120.67283934599993, 34.90752128400004],
              [-120.66619504699992, 34.93176927500008],
              [-120.6423755589999, 35.00087331000009],
              [-120.63369706899994, 35.03510163000004],
              [-120.63072669199994, 35.073879299000055],
              [-120.63573157499991, 35.108587958000044],
              [-120.64488684799994, 35.13939036700009],
              [-120.65294348899994, 35.144232489000046],
              [-120.6585548939999, 35.15047967800007],
              [-120.67115998799994, 35.150225857000066],
              [-120.6790258449999, 35.15306224200009],
              [-120.6980688139999, 35.169134833000044],
              [-120.7063695949999, 35.17422109600005],
              [-120.72384941699994, 35.17522603300006],
              [-120.7496692339999, 35.177396791000035],
              [-120.75560839999991, 35.17192249700008],
              [-120.75534616999994, 35.163123925000036],
              [-120.75944029599992, 35.15921462700004],
              [-120.76553376899994, 35.16024215500005],
              [-120.79084225199995, 35.179022528000075],
              [-120.8497927329999, 35.20291323100008],
              [-120.87668247399989, 35.22379035600005],
              [-120.88609778599994, 35.23379140800006],
              [-120.89765418399992, 35.249765515000036],
              [-120.89559061699993, 35.27351358100009],
              [-120.88706759699994, 35.285935479000045],
              [-120.8678311889999, 35.33039216700007],
              [-120.8622436469999, 35.36190504100006],
              [-120.85381463399995, 35.34752936700005],
              [-120.85739189799995, 35.326764807000075],
              [-120.85558020699995, 35.321519273000035],
              [-120.84324204899991, 35.32434774900008],
              [-120.84205910299994, 35.33166981200009],
              [-120.8314049729999, 35.336087589000044],
              [-120.8358349369999, 35.34291295300005],
              [-120.8415580109999, 35.34586681300004],
              [-120.8520741609999, 35.367051064000066],
              [-120.86026366199991, 35.373802556000044],
              [-120.8667496079999, 35.370992622000074],
              [-120.87109671799993, 35.40530839400009],
              [-120.87908121299989, 35.42009304700008],
              [-120.88731848899994, 35.432928778000075],
              [-120.90818414799992, 35.44824381800004],
              [-120.9461922299999, 35.44628513100008],
              [-120.96346562999992, 35.456651356000066],
              [-120.98276867499993, 35.459987898000065],
              [-121.0053621639999, 35.460656967000034],
              [-121.03697669199994, 35.48920319200005],
              [-121.0683115039999, 35.51786927900008],
              [-121.10181169099991, 35.54966720200008],
              [-121.13087019799991, 35.60070117500004],
              [-121.14327538499992, 35.60504282900007],
              [-121.15910836899991, 35.62723528300006],
              [-121.16940155799995, 35.63691940400008],
              [-121.1873669599999, 35.64192058700007],
              [-121.19306683999991, 35.63961576200006],
              [-121.19152573899993, 35.63386471900009],
              [-121.19503088999994, 35.63233633500005],
              [-121.2164960419999, 35.64774764500004],
              [-121.23400323699991, 35.652037747000065],
              [-121.25199004699994, 35.65739446300006],
              [-121.26914589699993, 35.664210591000085],
              [-121.2883128019999, 35.664829516000054],
              [-121.28847444999991, 35.68145825500005],
              [-121.29841445199992, 35.69748896300007],
              [-121.30901580099993, 35.70770939300007],
              [-121.31459022399991, 35.71372375300007],
              [-121.3230688139999, 35.764553127000056],
              [-121.33723230499993, 35.78652867000005],
              [-121.36800677199994, 35.81036106100004],
              [-121.38711692399994, 35.82143193100006],
              [-121.40893092199991, 35.84402073000007],
              [-121.41334977499992, 35.854745748000084],
              [-121.42553675199991, 35.85842044300006],
              [-121.44202524699995, 35.86922183900003],
              [-121.46320087599992, 35.88673133800006],
              [-121.46271725199995, 35.90371328300006],
              [-121.47224774799992, 35.91356852800004],
              [-121.47838152599991, 35.93158161000008],
              [-121.4822264789999, 35.948975515000086],
              [-121.48690362899993, 35.965828066000086],
              [-121.48997962099992, 35.98224518400008],
              [-121.5066775869999, 36.00326004200008],
              [-121.52256902499994, 36.01007073400007],
              [-121.54108352599991, 36.01501304900006],
              [-121.56673886899989, 36.02011726300009],
              [-121.58224375999993, 36.036027173000036],
              [-121.59266137299994, 36.05057001100005],
              [-121.59452231099993, 36.064233426000044],
              [-121.60644404699991, 36.07150486300009],
              [-121.6182213809999, 36.08442900300008],
              [-121.6301551279999, 36.11305683900008],
              [-121.64265948699995, 36.12354988900006],
              [-121.65775869499993, 36.142646683000066],
              [-121.67792076799992, 36.162675352000065],
              [-121.69357641499994, 36.17165647300004],
              [-121.70387955799993, 36.18221673000005],
              [-121.7291390279999, 36.198144643000035],
              [-121.75395387599991, 36.21154651000006],
              [-121.7814414479999, 36.22632573200008],
              [-121.79885769499992, 36.23447965500009],
              [-121.81036663299994, 36.232397340000034],
              [-121.82485917899993, 36.23920319200005],
              [-121.83560136599993, 36.24917226800005],
              [-121.84007727799991, 36.25934479400007],
              [-121.84541803699994, 36.272399878000044],
              [-121.85220292899993, 36.27944570500006],
              [-121.86318925699993, 36.283189195000034],
              [-121.87360592399995, 36.29002513200004],
              [-121.88101152299993, 36.29950592700004],
              [-121.89966052299991, 36.304399527000044],
              [-121.89562881899991, 36.313928729000054],
              [-121.8971258009999, 36.32798120000007],
              [-121.8937239249999, 36.33205755700004],
              [-121.89358632699992, 36.33856849000006],
              [-121.89785607699991, 36.34386834500009],
              [-121.90107238299993, 36.35276012400004],
              [-121.90364536699991, 36.36211621400008],
              [-121.90584484099992, 36.371751793000044],
              [-121.90612695499993, 36.37714037600006],
              [-121.90416813099989, 36.384536730000036],
              [-121.90612344899989, 36.38847771600007],
              [-121.90827468499992, 36.39637134700007],
              [-121.91443150499992, 36.403035903000045],
              [-121.91767174799992, 36.415548510000065],
              [-121.91532913299994, 36.42319358300006],
              [-121.91835124799991, 36.43032732700004],
              [-121.92901213999994, 36.44778604700008],
              [-121.93022497699991, 36.454603356000064],
              [-121.93150662699992, 36.463030718000084],
              [-121.93804032899993, 36.46826458000004],
              [-121.94469907399991, 36.48615182700007],
              [-121.94630901099993, 36.49189143600006],
              [-121.94248050999994, 36.49670503800007],
              [-121.9432079049999, 36.50283235200004],
              [-121.94423749399994, 36.50569475400005],
              [-121.94226954099992, 36.51190084500007],
              [-121.94957475199993, 36.51421753800008],
              [-121.9569296219999, 36.517617502000064],
              [-121.95536253299991, 36.52272768500006],
              [-121.94820416499994, 36.52366179900008],
              [-121.94006480099989, 36.52281564600008],
              [-121.9275331529999, 36.523851999000044],
              [-121.92829965399994, 36.53138031900005],
              [-121.9299445609999, 36.53784567000008],
              [-121.93312377699993, 36.53847538900004],
              [-121.93563282899993, 36.54418777200004],
              [-121.93126894499994, 36.547209922000036],
              [-121.9325277779999, 36.555128979000074],
              [-121.93461662399994, 36.561225309000065],
              [-121.94033548499993, 36.55851743200009],
              [-121.9427987219999, 36.56314622200006],
              [-121.94647692699994, 36.56484838000006],
              [-121.95089043899992, 36.562908855000046],
              [-121.9538914339999, 36.559565391000035],
              [-121.97007538999992, 36.56885441600008],
              [-121.9780022569999, 36.57476745400004],
              [-121.98111521899995, 36.58371687600004],
              [-121.9739344699999, 36.58429122400008],
              [-121.96721988899992, 36.585212701000046],
              [-121.96663598599991, 36.59210137800005],
              [-121.96386739299993, 36.600500741000076],
              [-121.95986254699994, 36.61147279900007],
              [-121.9563798349999, 36.61410358300009],
              [-121.9503338859999, 36.60993839200006],
              [-121.94664431399991, 36.61800656400004],
              [-121.94252160699995, 36.62644775600006],
              [-121.9415311329999, 36.634434026000065],
              [-121.9376946669999, 36.639249335000045],
              [-121.9295261449999, 36.63804021400006],
              [-121.92121077799993, 36.63358124300004],
              [-121.92054885399995, 36.628897996000035],
              [-121.91313548199992, 36.62441195300005],
              [-121.90215412799989, 36.62075213400004],
              [-121.89593684499994, 36.61261148700004],
              [-121.8874213609999, 36.60199449300006],
              [-121.8788360129999, 36.602614043000074],
              [-121.8700038909999, 36.60721214900008],
              [-121.85387454799991, 36.619613892000075],
              [-121.83792876299992, 36.63561195400007],
              [-121.82706092899991, 36.65620001900004],
              [-121.81425824699994, 36.683237837000036],
              [-121.80992591099994, 36.718817450000074],
              [-121.8053594129999, 36.73773902700009],
              [-121.79242379699991, 36.73086781000006],
              [-121.7637426419999, 36.72207265800006],
              [-121.7612743979999, 36.730286095000054],
              [-121.76644216599993, 36.735207993000074],
              [-121.7702149559999, 36.73908317000007],
              [-121.77511171499992, 36.73749977300008],
              [-121.78370748399993, 36.73798364800007],
              [-121.79019012599991, 36.741781238000044],
              [-121.79490139599994, 36.74635155200008],
              [-121.80320486499994, 36.75045947400008],
              [-121.79816220299995, 36.77990716100004],
              [-121.7898117549999, 36.80619896700006],
              [-121.8042459379999, 36.83601824100003],
              [-121.85993404899995, 36.92747630400004],
              [-121.88711503799993, 36.95490143400008],
              [-121.90560118999991, 36.969126309000046],
              [-121.93724316299989, 36.97830698000007],
              [-121.95276730699993, 36.971007662000034],
              [-121.9635661509999, 36.959490179000056],
              [-121.97423536999992, 36.95519927400005],
              [-121.99396725199995, 36.959865627000056],
              [-122.00670120699994, 36.962378329000046],
              [-122.0212103749999, 36.96266785000006],
              [-122.02515609099993, 36.95965331300005],
              [-122.02407544499994, 36.956070354000076],
              [-122.02518938599991, 36.95097400600008],
              [-122.0348239349999, 36.95321256700004],
              [-122.04679408099992, 36.948156804000064],
              [-122.06086782799991, 36.94881313600007],
              [-122.0809013999999, 36.95146259400008],
              [-122.1060040189999, 36.95575536900009],
              [-122.12084298899993, 36.96325587400008],
              [-122.13499069199992, 36.96572602700007],
              [-122.14223751499992, 36.97525052100008],
              [-122.15364315999994, 36.977075436000064],
              [-122.17758685799993, 36.99510466000004],
              [-122.20791581899994, 37.01927317900004],
              [-122.22211757699989, 37.02429494200004],
              [-122.22794563899993, 37.04005955900004],
              [-122.25380212399995, 37.059123309000086],
              [-122.26604190199993, 37.076455525000085],
              [-122.28102986099992, 37.09658291400007],
              [-122.29006162899992, 37.10423608100007],
              [-122.29765844299993, 37.11122669700006],
              [-122.3083544449999, 37.11667500800007],
              [-122.31873046899995, 37.11561724500007],
              [-122.32765564399995, 37.112807727000074],
              [-122.33929005699991, 37.118581815000084],
              [-122.33785320699991, 37.13490240200008],
              [-122.35952753899994, 37.15048541400006],
              [-122.36103852899993, 37.162356196000076],
              [-122.36935319999992, 37.17401999300006],
              [-122.38341210999994, 37.182271109000055],
              [-122.39610933199992, 37.181859916000064],
              [-122.40445697799993, 37.19452597500003],
              [-122.40786794499991, 37.216117025000074],
              [-122.41070366299994, 37.22687068000005],
              [-122.4164992659999, 37.23391985600006],
              [-122.41836340499992, 37.25230971900004],
              [-122.4101503569999, 37.26884518400004],
              [-122.4074123339999, 37.29498380600006],
              [-122.40252231999995, 37.34050411700008],
              [-122.40033781799991, 37.35974113600008],
              [-122.40873625099994, 37.36417159200005],
              [-122.41156908699992, 37.374931261000086],
              [-122.42919380199993, 37.40727084200006],
              [-122.4444464419999, 37.437519345000055],
              [-122.44916018899994, 37.476655219000065],
              [-122.46324622299994, 37.49664948100008],
              [-122.47926758099993, 37.50278345000004],
              [-122.48609613499991, 37.50255644400005],
              [-122.4942119179999, 37.500839443000075],
              [-122.49528482699992, 37.49537100300006],
              [-122.49926316999989, 37.49306618500009],
              [-122.50107414999991, 37.50132903600007],
              [-122.51202543599993, 37.51000308600004],
              [-122.52047188699993, 37.53142146000005],
              [-122.51756539199994, 37.54526576900008],
              [-122.51475929899993, 37.560893426000064],
              [-122.52002787299995, 37.57412481300008],
              [-122.51904002799989, 37.58971351900004],
              [-122.52242428099993, 37.59321744200008],
              [-122.51746818499993, 37.59447256400006],
              [-122.51308925599994, 37.597843855000065],
              [-122.50759715399994, 37.597698121000064],
              [-122.5032328829999, 37.60146264800005],
              [-122.5016984109999, 37.606944275000046],
              [-122.49594698099992, 37.627373970000065],
              [-122.49474036399994, 37.665228583000044],
              [-122.5018742979999, 37.70348839800005],
              [-122.5084930139999, 37.72494382900004],
              [-122.5136102919999, 37.752261117000046],
              [-122.51517164699993, 37.78112611800009],
              [-122.50587366999991, 37.78645571700008],
              [-122.49766998699994, 37.787102375000075],
              [-122.48593013199991, 37.79081053200008],
              [-122.47644909199994, 37.81067501600006],
              [-122.46335856799993, 37.805303535000064],
              [-122.41875724599993, 37.81114348400007],
              [-122.40863666199994, 37.810391705000086],
              [-122.39819511999991, 37.80349479400007],
              [-122.38792883999992, 37.79096100500004],
              [-122.38710365599991, 37.77874526800008],
              [-122.38153215599993, 37.773642615000085],
              [-122.38285761899994, 37.76382925000007],
              [-122.37924469099994, 37.75598598300007],
              [-122.3743169949999, 37.74927110500005],
              [-122.36649429099992, 37.739754832000074],
              [-122.35454394099992, 37.73000829500006],
              [-122.36245975299994, 37.71491608600007],
              [-122.37629019799994, 37.71664109800008],
              [-122.37947175799991, 37.70749155700008],
              [-122.39245468799993, 37.71033033900005],
              [-122.38797374899991, 37.677188425000054],
              [-122.38015767999991, 37.67671027100005],
              [-122.38103341999994, 37.66691910600008],
              [-122.3749114769999, 37.65516330200006],
              [-122.38136019399991, 37.64735284800008],
              [-122.38438880099994, 37.63666413000004],
              [-122.38372976999995, 37.63145992300008],
              [-122.36372201299992, 37.62725074800005],
              [-122.3541419039999, 37.61350742800005],
              [-122.35933988599993, 37.60847144600007],
              [-122.37116586399992, 37.612945368000055],
              [-122.37410881599993, 37.60418704600005],
              [-122.36228659099993, 37.59970804300008],
              [-122.35851968299994, 37.59280508400008],
              [-122.33039220199993, 37.589405158000034],
              [-122.3167696669999, 37.589845310000044],
              [-122.31579035599992, 37.583929682000075],
              [-122.29906874699992, 37.57689786000009],
              [-122.28326872499991, 37.57469864700005],
              [-122.25792395699995, 37.571519273000035],
              [-122.25096594999991, 37.568060614000046],
              [-122.2453475449999, 37.553193097000076],
              [-122.23957608199993, 37.54688725300008],
              [-122.2305395169999, 37.54482656500005],
              [-122.2102924049999, 37.53986420700005],
              [-122.19929836699993, 37.534961906000035],
              [-122.19889416899991, 37.52678070700006],
              [-122.2073461579999, 37.51748281500005],
              [-122.19300012499991, 37.515357176000066],
              [-122.18307110399991, 37.50755389300008],
              [-122.17128542799992, 37.50359044500004],
              [-122.15868079299992, 37.50336334800005],
              [-122.14793860599991, 37.49664948100008],
              [-122.13414466099994, 37.49778880400004],
              [-122.12267005099994, 37.48493073100008],
              [-122.11192786399994, 37.46747467700004],
              [-122.10016842399995, 37.455064195000034],
              [-122.0808813139999, 37.44871653900009],
              [-122.0589086579999, 37.44741445500006],
              [-122.0386449859999, 37.45140208500004],
              [-122.03213982099993, 37.46336413000006],
              [-122.04076087099992, 37.46792226800005],
              [-122.04832923099991, 37.468736070000034],
              [-122.05223548099991, 37.47138092700004],
              [-122.05186926999994, 37.477443752000056],
              [-122.05052649599992, 37.48427969000005],
              [-122.05174719999991, 37.48920319200005],
              [-122.05776933499993, 37.49754466400009],
              [-122.06236731699994, 37.50169505400004],
              [-122.06908118399991, 37.503566799000055],
              [-122.0933324859999, 37.503566799000055],
              [-122.10903886599993, 37.51797109600005],
              [-122.11655019999989, 37.54256204300009],
              [-122.14630966699991, 37.578968426000074],
              [-122.1522183319999, 37.616095750000056],
              [-122.16277899099993, 37.66443382600005],
              [-122.1852426239999, 37.69078357500007],
              [-122.19186342299992, 37.700313007000034],
              [-122.20672606699992, 37.71066876700007],
              [-122.21436033499992, 37.69906841000005],
              [-122.25176604899991, 37.72277746300006],
              [-122.26235038499993, 37.743003384000076],
              [-122.24893343399992, 37.748300638000046],
              [-122.21245197999991, 37.743483524000055],
              [-122.21729286399994, 37.758486264000055],
              [-122.22184987499992, 37.75971706800004],
              [-122.22631845399991, 37.755396800000085],
              [-122.23933611099994, 37.755324872000074],
              [-122.2715507229999, 37.76284709100008],
              [-122.28351210999995, 37.76332893000006],
              [-122.28985429099993, 37.76713096900005],
              [-122.2998814959999, 37.77224586600005],
              [-122.29737140399993, 37.77975919100004],
              [-122.30755698899992, 37.78086545000008],
              [-122.30985121999993, 37.77621795500005],
              [-122.33150880499994, 37.78238805400008],
              [-122.32861608199994, 37.79648861700008],
              [-122.3247001449999, 37.801083119000054],
              [-122.32500895399994, 37.80375077200006],
              [-122.32842202299992, 37.804460378000044],
              [-122.33909396099995, 37.80338052600007],
              [-122.3406565709999, 37.807115783000086],
              [-122.33472757899995, 37.81163050100008],
              [-122.32236131999991, 37.81094243400008],
              [-122.31657137399992, 37.81708958400009],
              [-122.32835963499991, 37.82102557400009],
              [-122.31969141899992, 37.82509264100008],
              [-122.3013850889999, 37.826239299000065],
              [-122.2955022839999, 37.831292182000084],
              [-122.29788807699993, 37.83931107500007],
              [-122.30386310699993, 37.86290225100004],
              [-122.31602365899994, 37.860890743000084],
              [-122.31774712399994, 37.86786490600008],
              [-122.30830677599994, 37.870329380000044],
              [-122.31390203799992, 37.885829354000066],
              [-122.32875988899991, 37.908057592000034],
              [-122.3478321899999, 37.90637152100004],
              [-122.36482959299991, 37.903659221000055],
              [-122.39108785399992, 37.907674614000086],
              [-122.38762834099992, 37.92021839700004],
              [-122.39625925399992, 37.928049189000035],
              [-122.41017338799992, 37.931922281000084],
              [-122.42131568899993, 37.94831608700008],
              [-122.42969815399994, 37.96426198100005],
              [-122.41380724699991, 37.96208342300008],
              [-122.3977251469999, 37.95611727000005],
              [-122.3950317959999, 37.97026700400005],
              [-122.36879565699991, 37.98031641600005],
              [-122.35956561899991, 37.987648655000044],
              [-122.36997619099992, 38.00355579400008],
              [-122.36630595799994, 38.01233558700005],
              [-122.34630286399994, 38.00604889500005],
              [-122.3360082669999, 38.00381094000005],
              [-122.32249915299991, 38.005194403000075],
              [-122.3167698559999, 38.010136438000075],
              [-122.29904056399994, 38.011198076000085],
              [-122.27697261299994, 38.024950739000076],
              [-122.2755704949999, 38.03910111600004],
              [-122.26423611299992, 38.04595215200004],
              [-122.24974524599992, 38.05536530200004],
              [-122.22704016799992, 38.05841705900008],
              [-122.20362973499994, 38.05337843700005],
              [-122.18617024899993, 38.04797627500005],
              [-122.1685530289999, 38.028042939000045],
              [-122.14793860599991, 38.02362702000005],
              [-122.12437903599994, 38.02920156500005],
              [-122.08183676899989, 38.04789564400005],
              [-122.05325504899992, 38.05307545900007],
              [-122.00398992599992, 38.05613559600005],
              [-121.93900866199994, 38.04454375100005],
              [-121.88800433199992, 38.041088916000035],
              [-121.87810163599994, 38.034346317000086],
              [-121.83712276299991, 38.02306403700004],
              [-121.77913371099993, 38.01546119400007],
              [-121.7510823589999, 38.01943575700005],
              [-121.7229711579999, 38.01113515800006],
              [-121.70205644399994, 38.00922272300005],
              [-121.69004367999992, 38.009118724000075],
              [-121.6814428219999, 38.01745310400008],
              [-121.69482475399991, 38.024678330000086],
              [-121.71054776299991, 38.02210575500004],
              [-121.7230809479999, 38.02556299000008],
              [-121.7206057009999, 38.03211678000008],
              [-121.7049055899999, 38.03523202900004],
              [-121.6948949859999, 38.043402411000045],
              [-121.68553626199991, 38.04474518400008],
              [-121.68150794199994, 38.04832591400009],
              [-121.67837480399993, 38.05695221600007],
              [-121.67634029899995, 38.06708405200004],
              [-121.67560787699995, 38.075506903000075],
              [-121.67113196499992, 38.08388906500005],
              [-121.66055253799993, 38.08685944200005],
              [-121.63768469999991, 38.08633047100005],
              [-121.6245177369999, 38.08928593300004],
              [-121.6240577449999, 38.094702176000055],
              [-121.61709550699993, 38.09861888200004],
              [-121.60667883999992, 38.09935130400004],
              [-121.59626217399995, 38.09438711100006],
              [-121.58205438999994, 38.09200048400004],
              [-121.58032618999994, 38.083397639000054],
              [-121.5765186399999, 38.074307486000066],
              [-121.58246852199994, 38.06875122000008],
              [-121.58496653399993, 38.062742692000086],
              [-121.5992322269999, 38.059134431000075],
              [-121.60960708199991, 38.061029046000044],
              [-121.62062294099991, 38.061825336000084],
              [-121.6277126789999, 38.05083272500008],
              [-121.6322394259999, 38.04422942600007],
              [-121.62298843899993, 38.03636180500007],
              [-121.61276044699991, 38.021491498000046],
              [-121.60506405099994, 38.017905994000046],
              [-121.59836794599994, 38.021861896000075],
              [-121.58424341499995, 38.02871018600007],
              [-121.5824777609999, 38.035782157000085],
              [-121.58020503799992, 38.04719090600008],
              [-121.57925820399993, 38.05748429800008],
              [-121.57808693699991, 38.06237798900008],
              [-121.56930531199993, 38.065844333000086],
              [-121.5559221979999, 38.057537194000076],
              [-121.54758120199995, 38.05504497900006],
              [-121.53780054299995, 38.05096593800005],
              [-121.52640527499995, 38.04097947200006],
              [-121.51264183399991, 38.04024011900009],
              [-121.50088456899994, 38.03107330900008],
              [-121.4803383009999, 38.022651050000036],
              [-121.45901319399991, 38.004780726000035],
              [-121.44530188699991, 37.99632396000004],
              [-121.4453832669999, 38.003892320000034],
              [-121.45872962099992, 38.02057526200008],
              [-121.47573808499993, 38.037176825000074],
              [-121.48656165299991, 38.04474518400008],
              [-121.50389563699991, 38.04975006700005],
              [-121.5132358319999, 38.054821675000085],
              [-121.52627125399994, 38.05449732800008],
              [-121.52925719799993, 38.06036842000009],
              [-121.5356074579999, 38.06453338100005],
              [-121.5424241739999, 38.063281536000034],
              [-121.54864224099992, 38.06420615500008],
              [-121.56512468199992, 38.081082783000056],
              [-121.57127774299994, 38.09713945200008],
              [-121.58649654899995, 38.10236237200007],
              [-121.60407467399995, 38.10578034100007],
              [-121.62718665299991, 38.10561758000006],
              [-121.63190670499989, 38.10325755400004],
              [-121.6394750639999, 38.09446849200009],
              [-121.64452063699991, 38.09251536700009],
              [-121.65196692599994, 38.09430573100008],
              [-121.65855872299994, 38.09760163000004],
              [-121.66494706899994, 38.09918854400007],
              [-121.68028184199994, 38.09269063900007],
              [-121.68610592399995, 38.08266836100006],
              [-121.68858801999994, 38.075100002000056],
              [-121.68927975199995, 38.06159088700008],
              [-121.69933020699995, 38.050848700000074],
              [-121.72058934799992, 38.04028200300007],
              [-121.7420631359999, 38.02944881600007],
              [-121.76747498999993, 38.030388394000056],
              [-121.7787087769999, 38.03601910500004],
              [-121.78522242399993, 38.043399355000076],
              [-121.78424621799991, 38.05206668000005],
              [-121.77984961599992, 38.06137499100004],
              [-121.76917430799995, 38.06869542600003],
              [-121.7590253489999, 38.07221500700007],
              [-121.74681555899991, 38.07599518400008],
              [-121.73643958199995, 38.07884349200009],
              [-121.71666779499992, 38.092807082000036],
              [-121.70299231699994, 38.10561758000006],
              [-121.68778744299993, 38.12383070800007],
              [-121.68260154199993, 38.14719259100008],
              [-121.68948423299992, 38.14754736100008],
              [-121.70488477299995, 38.12229282100009],
              [-121.72144658799994, 38.108345944000064],
              [-121.74697831899994, 38.08771393400008],
              [-121.76744544199994, 38.07884349200009],
              [-121.80308012799992, 38.06288340300006],
              [-121.82396805399992, 38.06879920800009],
              [-121.84611846299993, 38.07251123100008],
              [-121.86183629999994, 38.07045261900004],
              [-121.86733964799993, 38.06464264500005],
              [-121.88252738099993, 38.05690041200006],
              [-121.8981700789999, 38.053220639000074],
              [-121.91672498499992, 38.052707385000076],
              [-121.92882239499994, 38.05841705900008],
              [-121.92096920499989, 38.06244538000004],
              [-121.9160863919999, 38.06696198100008],
              [-121.90831458199995, 38.07884349200009],
              [-121.9549848019999, 38.079169842000056],
              [-121.9712694349999, 38.07491764400004],
              [-121.98947899899991, 38.08249815100004],
              [-122.01495547399992, 38.09851061100005],
              [-121.98599224499992, 38.11070447900005],
              [-121.98941989299993, 38.12519801700006],
              [-122.00029623299991, 38.13731244500008],
              [-122.0162073379999, 38.13955023700004],
              [-122.03806434599994, 38.13674660600009],
              [-122.05516516799992, 38.13373444200005],
              [-122.06541907499991, 38.12734609600005],
              [-122.06895534499989, 38.12178041400006],
              [-122.06579728499992, 38.11322666600006],
              [-122.07548987699994, 38.10050771400006],
              [-122.09325093899992, 38.08430417400007],
              [-122.12108313699991, 38.059881903000075],
              [-122.12659702999991, 38.050343342000076],
              [-122.13029038299993, 38.04214243300004],
              [-122.1584781549999, 38.04344542400008],
              [-122.16593111399993, 38.05454683100004],
              [-122.18430159799993, 38.064789216000065],
              [-122.18962849399992, 38.06138184000008],
              [-122.19514241799993, 38.06175204400006],
              [-122.20493356299994, 38.06523303400007],
              [-122.22357093599993, 38.065726736000045],
              [-122.24520797899993, 38.07208563100005],
              [-122.26088795499993, 38.06943282900005],
              [-122.27145916599994, 38.074509308000074],
              [-122.28167411699991, 38.08608469700005],
              [-122.30067748099992, 38.10819557000008],
              [-122.39651964899991, 38.153231178000055],
              [-122.41062979599991, 38.13384619700008],
              [-122.4341308139999, 38.123345321000045],
              [-122.44930787099992, 38.124468515000046],
              [-122.45788029199991, 38.11769899900008],
              [-122.50231747099991, 38.113520866000044],
              [-122.48742194699992, 38.104826882000054],
              [-122.4824884759999, 38.07688102900005],
              [-122.49409100799994, 38.050007846000085],
              [-122.50272452399992, 38.03188021600005],
              [-122.5056847269999, 38.02313140800004],
              [-122.5060499729999, 38.01717217700008],
              [-122.49345613799994, 38.01278303500004],
              [-122.46974641199989, 38.005427059000056],
              [-122.45424160999994, 37.99780528600007],
              [-122.44533578999994, 37.98512305600008],
              [-122.45123996599995, 37.98006180800007],
              [-122.45954161999992, 37.98140704800005],
              [-122.46922137799993, 37.98274565600008],
              [-122.4743555039999, 37.97612186300006],
              [-122.49254309799994, 37.96979401200008],
              [-122.49356035099993, 37.95856354400007],
              [-122.4837133449999, 37.948553778000075],
              [-122.4803455839999, 37.94182013800008],
              [-122.49166750199993, 37.935487565000074],
              [-122.5035928229999, 37.94049531200005],
              [-122.5042211579999, 37.934881903000075],
              [-122.50343963699993, 37.92481173200008],
              [-122.47623197699994, 37.915990882000074],
              [-122.4725527949999, 37.91124578700004],
              [-122.47429034399994, 37.905238230000066],
              [-122.46006377899994, 37.89543694400004],
              [-122.44900301799993, 37.893641492000086],
              [-122.4388005049999, 37.88208259000004],
              [-122.4479499549999, 37.873668560000056],
              [-122.45473302499994, 37.87236117400005],
              [-122.45946261899991, 37.871122781000054],
              [-122.45900921299994, 37.862484926000036],
              [-122.46952014199991, 37.867002837000086],
              [-122.4733411389999, 37.87444507100008],
              [-122.4722595149999, 37.87988875900004],
              [-122.47605243699991, 37.88679154500005],
              [-122.49013543299992, 37.893890372000044],
              [-122.49902873899993, 37.89359014900003],
              [-122.49648569599992, 37.88448346800004],
              [-122.49474208899994, 37.877513015000034],
              [-122.49927992499994, 37.872485288000064],
              [-122.48930875399992, 37.86413137000005],
              [-122.47805238599994, 37.85968078500008],
              [-122.4797671529999, 37.853132619000064],
              [-122.47649014699994, 37.84352103500004],
              [-122.4703911979999, 37.83183162000006],
              [-122.47756480999993, 37.82510439500004],
              [-122.48784029799992, 37.82530312800009],
              [-122.50264085499992, 37.820482206000065],
              [-122.51179686099994, 37.82448963100006],
              [-122.52258614699991, 37.82197001700007],
              [-122.5284258129999, 37.81637159300004],
              [-122.5379540479999, 37.82793964700005],
              [-122.54790397999994, 37.83462263300004],
              [-122.5636904829999, 37.848147881000045],
              [-122.57369863399992, 37.85590833800006],
              [-122.58834125899995, 37.86081040500005],
              [-122.60130442999991, 37.873227615000076],
              [-122.6207305779999, 37.87749648400006],
              [-122.64519885399994, 37.898815966000086],
              [-122.6723915689999, 37.906573792000074],
              [-122.6859731369999, 37.90395900400006],
              [-122.6966706419999, 37.89925733500007],
              [-122.70038307599992, 37.89210095400006],
              [-122.71318201399993, 37.900299208000035],
              [-122.72773825799993, 37.90303961500007],
              [-122.73420474999995, 37.920124324000085],
              [-122.7486409789999, 37.932601282000064],
              [-122.76534840799991, 37.93739640500007],
              [-122.78024385999993, 37.948131095000065],
              [-122.7959987729999, 37.975519631000054],
              [-122.81055040299992, 37.98519380100004],
              [-122.8214322479999, 37.997669778000045],
              [-122.83939709899994, 38.006349484000054],
              [-122.9068432119999, 38.03184398500008],
              [-122.9211119449999, 38.034871294000084],
              [-122.93269553999994, 38.04951933800004],
              [-122.93212270599992, 38.05880550300009],
              [-122.92014206499994, 38.06531240400005],
              [-122.93541419199994, 38.070746161000045],
              [-122.94155839799993, 38.06476471600007],
              [-122.94847571499992, 38.06073639500005],
              [-122.94709913499992, 38.05475450700004],
              [-122.94688880099994, 38.04531484600005],
              [-122.94249426999994, 38.04124583500004],
              [-122.93608552599994, 38.030770371000074],
              [-122.94937089799993, 38.02944570500006],
              [-122.96337693599992, 38.02531491000008],
              [-122.97906967199992, 38.01451559100008],
              [-122.98402720899992, 38.00323086700007],
              [-122.98033049999992, 37.99803906200009],
              [-122.97176500099994, 37.996142070000076],
              [-122.96250400899993, 37.992047822000075],
              [-122.97422910699993, 37.99027722200009],
              [-122.9844803119999, 37.992113214000085],
              [-122.99754706599992, 37.99384217100004],
              [-123.0178155029999, 37.99352168100006],
              [-123.02745302699992, 37.99448874500007],
              [-123.02162165199991, 38.00048283000007],
              [-123.01599822899993, 38.00069532800006],
              [-122.99072631799993, 38.048715678000065],
              [-122.9496480059999, 38.143990916000064],
              [-122.9502851009999, 38.16449325100007],
              [-122.95551003299994, 38.17627198400004],
              [-122.96494531699994, 38.18260229300006],
              [-122.9647881389999, 38.19859819700008],
              [-122.9738394719999, 38.20803831000006],
              [-122.98305035499993, 38.22012947800005],
              [-122.99323038199992, 38.22951866100004],
              [-122.9962966899999, 38.24272982400004],
              [-122.9852542189999, 38.237811760000056],
              [-122.9648161309999, 38.21770038500006],
              [-122.92557009899991, 38.17514066400008],
              [-122.90727724899995, 38.152344259000074],
              [-122.89150956899994, 38.13080475500004],
              [-122.86876380099994, 38.110256252000056],
              [-122.84337317599994, 38.09198639500005],
              [-122.82567298099991, 38.07208893400008],
              [-122.83226477799991, 38.09589264500005],
              [-122.85043186299993, 38.110698133000085],
              [-122.88841712099992, 38.15460846600007],
              [-122.93553626199991, 38.21548086100006],
              [-122.9439986139999, 38.21931125400005],
              [-122.95065501199991, 38.21729476200005],
              [-122.95433603899994, 38.23140219700008],
              [-122.96457100899994, 38.232364285000074],
              [-122.96881528499989, 38.237093637000044],
              [-122.96851762499995, 38.25087276100004],
              [-122.97453518599991, 38.26619422300007],
              [-122.9871161619999, 38.27772299600008],
              [-123.00228036399994, 38.29485919500007],
              [-123.0295215569999, 38.31269155800004],
              [-123.04646037599991, 38.31204844500007],
              [-123.05169682299993, 38.30519213200006],
              [-123.05288652299993, 38.29800039300005],
              [-123.06243964399994, 38.29590274800006],
              [-123.0759672499999, 38.32247308700005],
              [-123.06838791799993, 38.34629023300005],
              [-123.07093227399992, 38.35995419400007],
              [-123.07904469399995, 38.372078026000054],
              [-123.0870301839999, 38.39126237900007],
              [-123.09581026199993, 38.395831515000054],
              [-123.10205716099989, 38.41216428600006],
              [-123.11275980599993, 38.42061913400005],
              [-123.1245786319999, 38.43747928800008],
              [-123.12872916099991, 38.449310265000065],
              [-123.17092403599992, 38.479188398000076],
              [-123.25265797999992, 38.51066562400007],
              [-123.27255673499991, 38.52895071100005],
              [-123.3045470209999, 38.54902420900004],
              [-123.31531993099992, 38.557472947000065],
              [-123.33697942599991, 38.56725947100006],
              [-123.34166769899991, 38.58663059400004],
              [-123.35599489899994, 38.59714943900008],
              [-123.36588676699989, 38.60073847100006],
              [-123.36948774199993, 38.61214440300006],
              [-123.40109530899991, 38.64283242100004],
              [-123.4139816959999, 38.666687392000085],
              [-123.4324608359999, 38.67797137400004],
              [-123.43360667699994, 38.68679466900005],
              [-123.47409662099994, 38.72197455700007],
              [-123.49245728599993, 38.73646867300005],
              [-123.52329295999994, 38.74672398600006],
              [-123.53764325899994, 38.77232914800004],
              [-123.55884513099994, 38.78299056900005],
              [-123.56623287699995, 38.79515208500004],
              [-123.5941709679999, 38.805820716000085],
              [-123.61647232699994, 38.82731501400008],
              [-123.64830661699995, 38.84953497100008],
              [-123.66305923399995, 38.87245069100004],
              [-123.6975613329999, 38.900277721000066],
              [-123.71167236799994, 38.914321002000065],
              [-123.72624223399993, 38.91857608600009],
              [-123.7273012039999, 38.93318295900008],
              [-123.74260670099994, 38.95562391100009],
              [-123.72524161299992, 38.96037225100008],
              [-123.7039281889999, 38.99005768400008],
              [-123.69608687399995, 39.007794611000065],
              [-123.68907630099994, 39.02789948100008],
              [-123.69131425699993, 39.03856028900009],
              [-123.6951507039999, 39.05912667600006],
              [-123.70384054699991, 39.08362843600008],
              [-123.71288221799995, 39.106315400000085],
              [-123.72164871299992, 39.13301934200007],
              [-123.73779584399995, 39.143004947000065],
              [-123.73555056099991, 39.15903412000006],
              [-123.76785035099994, 39.19400673300004],
              [-123.77789808799992, 39.222120515000086],
              [-123.79054342099994, 39.26974584900006],
              [-123.8032633759999, 39.27895400300008],
              [-123.79747473899994, 39.29767487200007],
              [-123.80638587099992, 39.304754950000074],
              [-123.80599765599993, 39.324140097000054],
              [-123.82492424799995, 39.34729559200008],
              [-123.82056891899992, 39.40526009600006],
              [-123.81650937299992, 39.443998058000034],
              [-123.7986381259999, 39.490508910000074],
              [-123.77635657499991, 39.529282945000034],
              [-123.76976831899992, 39.54464580700005],
              [-123.76944436899993, 39.56372821100007],
              [-123.7868278329999, 39.59677697900008],
              [-123.78647945499989, 39.65520462200004],
              [-123.7903764909999, 39.66641482000006],
              [-123.7905816899999, 39.67737373700004],
              [-123.79596738899994, 39.69186760400004],
              [-123.8029348259999, 39.702512754000054],
              [-123.80857390099993, 39.71179794300008],
              [-123.82381696099992, 39.71776210300004],
              [-123.83001957099992, 39.72651417800006],
              [-123.83055579299992, 39.741848049000055],
              [-123.83755566199994, 39.76160177100007],
              [-123.83727505199994, 39.78294420000009],
              [-123.8447314259999, 39.808299108000085],
              [-123.8540188039999, 39.833514269000034],
              [-123.8801766599999, 39.84427130500006],
              [-123.90772097799993, 39.86586720400004],
              [-123.9306962689999, 39.90801781000005],
              [-123.9555543539999, 39.92450624500009],
              [-123.97894719399994, 39.96289615300009],
              [-124.00123998899994, 39.97808314000008],
              [-124.02270607499992, 40.002135431000056],
              [-124.0334577989999, 40.01212592600007],
              [-124.04514908099992, 40.018727169000044],
              [-124.05852030099993, 40.02379638800005],
              [-124.06332797199991, 40.022596871000076],
              [-124.0693701809999, 40.021333145000085],
              [-124.0760520049999, 40.027217164000035],
              [-124.0804069749999, 40.03555970700006],
              [-124.0804804099999, 40.05978918500006],
              [-124.08744171699993, 40.07751537300004],
              [-124.11579342399995, 40.107123114000046],
              [-124.13825136999992, 40.115925651000055],
              [-124.18531738099995, 40.12955148000009],
              [-124.21999641199994, 40.16515220400004],
              [-124.25642272599993, 40.18441513600004],
              [-124.31937787699991, 40.224613110000064],
              [-124.32715432999993, 40.237040215000036],
              [-124.34258148999993, 40.242037329000084],
              [-124.36350979499991, 40.261480937000044],
              [-124.36013698099993, 40.28156716400008],
              [-124.34828314299995, 40.31890737800006],
              [-124.36477798899995, 40.34468345700009],
              [-124.3662052069999, 40.377450740000086],
              [-124.39810962899992, 40.41583572800005],
              [-124.4092019709999, 40.44381766500004],
              [-124.39595955699991, 40.465362732000074],
              [-124.38802815199995, 40.483295],
              [-124.3837827189999, 40.50010035400004],
              [-124.38583202399991, 40.50951536000008],
              [-124.36999971299991, 40.53688962400008],
              [-124.35798092399995, 40.56305573100008],
              [-124.34996497299994, 40.577785549000055],
              [-124.32209225199989, 40.61737702000005],
              [-124.31948808499993, 40.62864817900004],
              [-124.31725012899994, 40.632066148000035],
              [-124.3140356109999, 40.63458893400008],
              [-124.3101293609999, 40.63548411700009],
              [-124.30577551999994, 40.63739655200004],
              [-124.30768795499989, 40.64158763200004],
              [-124.31163489499994, 40.64622630400004],
              [-124.3076163369999, 40.65282504500004],
              [-124.29266295799994, 40.676822617000084],
              [-124.27387476799993, 40.700047055000084],
              [-124.25255286399994, 40.73476797100005],
              [-124.23973767299992, 40.75870946500004],
              [-124.2308853969999, 40.75008100900004],
              [-124.24729441699992, 40.72791237800004],
              [-124.2584772219999, 40.70688272500007],
              [-124.25949774499992, 40.69841007300005],
              [-124.24803626199991, 40.69326406500005],
              [-124.23437341999994, 40.69189955600007],
              [-124.22576009799991, 40.68612308000007],
              [-124.2217029069999, 40.69011080100006],
              [-124.2246199199999, 40.69520205400005],
              [-124.22168811199992, 40.697713875000034],
              [-124.2138446909999, 40.70140247100005],
              [-124.21323603399992, 40.70951123900005],
              [-124.22178329199994, 40.72243168500006],
              [-124.21742907299989, 40.73071773600009],
              [-124.2204549359999, 40.73723849300006],
              [-124.21329590199991, 40.741851361000045],
              [-124.20289856699992, 40.74518552700005],
              [-124.19861015899994, 40.75442490700004],
              [-124.20108402099993, 40.761927160000084],
              [-124.19823536099994, 40.76904071700005],
              [-124.1915884359999, 40.77283896000006],
              [-124.18891189699991, 40.790574382000045],
              [-124.18274332099992, 40.79990301300006],
              [-124.17550180199993, 40.80356189200006],
              [-124.16380965799993, 40.80646671400007],
              [-124.1458675799999, 40.80964862800005],
              [-124.1368970289999, 40.80719127200007],
              [-124.12186467299989, 40.807383196000046],
              [-124.10919491099992, 40.81415104800004],
              [-124.08739831299994, 40.82515617000007],
              [-124.08248331899989, 40.843501684000046],
              [-124.08446204299992, 40.84837474200009],
              [-124.0938207669999, 40.85398997600004],
              [-124.10180206399991, 40.85844398100005],
              [-124.10846685799993, 40.854807297000036],
              [-124.1189746689999, 40.85194723500007],
              [-124.12607293299993, 40.85400186900006],
              [-124.13143172299993, 40.85803921200005],
              [-124.1375538559999, 40.86394674400009],
              [-124.15132441499992, 40.863321058000054],
              [-124.1549676979999, 40.861727478000034],
              [-124.15664444599992, 40.85118118100007],
              [-124.1666082509999, 40.84215954700005],
              [-124.17040739599992, 40.82675683300005],
              [-124.18397468899991, 40.81566263700006],
              [-124.19359848499994, 40.80237045500007],
              [-124.19974479099994, 40.78485271000005],
              [-124.22328814199994, 40.75709610600006],
              [-124.23284111899994, 40.766642871000045],
              [-124.21684853099993, 40.786421734000044],
              [-124.1765751229999, 40.84775433800007],
              [-124.13375761799995, 40.93639875300005],
              [-124.12067639299994, 40.97895437500006],
              [-124.11041334599992, 41.01525282500006],
              [-124.11141221899993, 41.04166033300004],
              [-124.11703013599993, 41.04824710300005],
              [-124.12732576799993, 41.04953142700003],
              [-124.13457304699995, 41.047949403000075],
              [-124.1429285619999, 41.05312728600006],
              [-124.14687839499993, 41.060165416000075],
              [-124.14930237899989, 41.07595670500007],
              [-124.15528282199995, 41.08681197400006],
              [-124.16063391799992, 41.09935130400004],
              [-124.16027754299989, 41.113563001000045],
              [-124.16405283299991, 41.13222009000009],
              [-124.16288978799992, 41.139080266000065],
              [-124.15633161999995, 41.142351715000075],
              [-124.14769066899993, 41.14094843200007],
              [-124.1434738069999, 41.144991874000084],
              [-124.12426181199993, 41.181808722000085],
              [-124.11327063699991, 41.22117747600004],
              [-124.09093176999994, 41.28945547100005],
              [-124.08218339799993, 41.341782945000034],
              [-124.06780931799995, 41.39892056100007],
              [-124.06215535799993, 41.43587598600004],
              [-124.07607988199993, 41.48997630400004],
              [-124.08202063699991, 41.521470445000034],
              [-124.06834876199991, 41.53925202000005],
              [-124.0789281889999, 41.54336172100005],
              [-124.0886938139999, 41.54913971600007],
              [-124.09691321499992, 41.55683014500005],
              [-124.1030981109999, 41.56655508000006],
              [-124.10387122299994, 41.57611725500004],
              [-124.10277258999992, 41.60260651200008],
              [-124.10651607999989, 41.60809967700004],
              [-124.11497962099992, 41.61786530200004],
              [-124.12657630099994, 41.64008209800005],
              [-124.13988196499992, 41.66429271000004],
              [-124.13849850199989, 41.679754950000074],
              [-124.14578494299991, 41.70638124800007],
              [-124.15945881399995, 41.736674780000044],
              [-124.17728645099993, 41.74359991700004],
              [-124.1879213869999, 41.74699112300004],
              [-124.19631423399994, 41.74403301000007],
              [-124.20110746299991, 41.739305330000036],
              [-124.23236084199993, 41.76236256000004],
              [-124.26289518399994, 41.776427858000034],
              [-124.26046399199993, 41.78878311400007],
              [-124.24792411599992, 41.79387373900005],
              [-124.23396333999995, 41.81320590300004],
              [-124.2188371339999, 41.85000637200005],
              [-124.21095850199993, 41.891009920000045],
              [-124.20221920499989, 41.96039459800005],
              [-124.20368404899995, 41.97117747600004],
              [-124.20787512899994, 41.98151276200008],
              [-124.21696831799994, 42.006177337000054],
              [-124.23696829599993, 42.017502766000064],
              [-124.26087523099994, 42.03379747100007],
              [-124.27482614699994, 42.04538699100004],
              [-124.29311856899994, 42.04647370300006],
              [-124.33595054299991, 42.09150293200008],
              [-124.35045799499994, 42.09795819000004],
              [-124.35955577699991, 42.11300239900004],
              [-124.35416434699994, 42.13190324900006],
              [-124.3661686829999, 42.15006025100007],
              [-124.36383788899991, 42.17516287300003],
              [-124.37623528899991, 42.19664726100007],
              [-124.37905904899992, 42.22027805400006],
              [-124.39517167899993, 42.239447333000044],
              [-124.41246497299994, 42.248928127000056],
              [-124.41026770699995, 42.25885651200008],
              [-124.4094487729999, 42.29624445600007],
              [-124.42332923099991, 42.31781647300005],
              [-124.42788652299993, 42.320013739000046],
              [-124.43281358699994, 42.32931074000004],
              [-124.43065344999991, 42.34955475500004],
              [-124.42607544399993, 42.361843874000044],
              [-124.42650048899992, 42.377280563000056],
              [-124.42731863099993, 42.396577619000084],
              [-124.42498011599992, 42.41988893900009],
              [-124.43978839699992, 42.439191830000084],
              [-124.42354186799992, 42.454090670000085],
              [-124.4220250169999, 42.46703634100004],
              [-124.42067499799992, 42.49100483400008],
              [-124.4063207669999, 42.519517320000034],
              [-124.40282141799992, 42.532904364000046],
              [-124.39443925699993, 42.56655508000006],
              [-124.3981810969999, 42.585520691000056],
              [-124.40336644699994, 42.59494515700004],
              [-124.39989126299992, 42.61572987200009],
              [-124.40853374299991, 42.64496433900007],
              [-124.41454016799992, 42.66242096600007],
              [-124.42617753799993, 42.671535549000055],
              [-124.44090735599991, 42.67804596600007],
              [-124.4544164699999, 42.68691640800006],
              [-124.46678626199991, 42.70254140800006],
              [-124.4729271729999, 42.730308576000084],
              [-124.4918197689999, 42.73775836100003],
              [-124.50548255099994, 42.73651764500005],
              [-124.51500403599994, 42.74872467700004],
              [-124.5320531889999, 42.803941148000035],
              [-124.53888912699989, 42.81622955900008],
              [-124.54938717399995, 42.82558828300006],
              [-124.56676184799994, 42.833970445000034],
              [-124.54771887899994, 42.84544505400004],
              [-124.4924472699999, 42.92983629400004],
              [-124.46367206999992, 42.993043181000075],
              [-124.45425370999993, 43.01129791900007],
              [-124.4448834239999, 43.02999907000009],
              [-124.43746364399993, 43.05612324800006],
              [-124.43470285599994, 43.07494314000007],
              [-124.42444518699995, 43.119290092000085],
              [-124.4161514509999, 43.125484449000055],
              [-124.41848524499994, 43.14215128400008],
              [-124.38661223899993, 43.26309906700004],
              [-124.39513674099993, 43.300073771000086],
              [-124.40132379099992, 43.31009613200007],
              [-124.38537490399995, 43.33015824900008],
              [-124.37650426599993, 43.340228799000045],
              [-124.3598674449999, 43.342277409000076],
              [-124.34212305799991, 43.35210375500009],
              [-124.32945515199992, 43.348814444000084],
              [-124.32597167799992, 43.33866440800006],
              [-124.32640753599992, 43.31225209400009],
              [-124.3165142179999, 43.29983247100006],
              [-124.31287316299989, 43.309006546000035],
              [-124.30828360099991, 43.32787775700007],
              [-124.3118175109999, 43.33866264400007],
              [-124.3087075489999, 43.35491127800009],
              [-124.3005599249999, 43.36366093200007],
              [-124.28734290299991, 43.37059153900009],
              [-124.2761938139999, 43.39394765800006],
              [-124.2527563139999, 43.41746653900009],
              [-124.2328735719999, 43.42408145100006],
              [-124.22231501599992, 43.42519798900008],
              [-124.2179937919999, 43.416376566000054],
              [-124.21863295599991, 43.402150876000064],
              [-124.21823878899994, 43.38604181100004],
              [-124.2128733219999, 43.37468093200005],
              [-124.20037795299993, 43.37395190500007],
              [-124.17777655099991, 43.36916023300006],
              [-124.15184485599991, 43.36945221600007],
              [-124.14003492599994, 43.375348974000076],
              [-124.1697421909999, 43.37983307400003],
              [-124.1866717289999, 43.39132792300006],
              [-124.1904697189999, 43.405345899000054],
              [-124.19432777399993, 43.42000884700008],
              [-124.20861091599994, 43.430959561000066],
              [-124.20702575899992, 43.44325738900005],
              [-124.19762122299994, 43.452460028000075],
              [-124.20869823999993, 43.452189747000034],
              [-124.23313194999992, 43.44723619000007],
              [-124.2401918949999, 43.43662484300006],
              [-124.26239906599994, 43.426615851000065],
              [-124.27702748299993, 43.42145488500006],
              [-124.28345782499991, 43.40311596500004],
              [-124.32528261599992, 43.362537133000046],
              [-124.33522928399992, 43.36531642400007],
              [-124.2980292979999, 43.41792560500005],
              [-124.23790317399994, 43.547115862000055],
              [-124.2234659909999, 43.58643132900005],
              [-124.21568762899994, 43.627386786000045],
              [-124.20978775599991, 43.65663013400007],
              [-124.20228323299995, 43.66276122700003],
              [-124.17468629199993, 43.67299544900004],
              [-124.16171284099994, 43.68838431900008],
              [-124.15444902299993, 43.698472398000035],
              [-124.14932206899994, 43.71190013200004],
              [-124.14183508999992, 43.72162506700005],
              [-124.1398121659999, 43.73310579900004],
              [-124.13285421699993, 43.73468738000008],
              [-124.12616810899993, 43.72852657200008],
              [-124.11658510699993, 43.710934713000086],
              [-124.10901797299994, 43.70611686600006],
              [-124.07249915299991, 43.704738674000055],
              [-124.0702181669999, 43.71166144500006],
              [-124.0855393629999, 43.71292483800005],
              [-124.10127095299993, 43.71866731600005],
              [-124.11521079999994, 43.735428056000046],
              [-124.12853327499994, 43.749085285000035],
              [-124.14881408899993, 43.74758755700009],
              [-124.1604752419999, 43.736747354000045],
              [-124.1614477199999, 43.71771881700005],
              [-124.1715148539999, 43.697602817000075],
              [-124.1908346429999, 43.68452342200004],
              [-124.20294541599992, 43.68077271000004],
              [-124.19172403499994, 43.71736278800006],
              [-124.1760184179999, 43.76247677400005],
              [-124.15103105399993, 43.881740627000056],
              [-124.14474733799995, 43.94321116700007],
              [-124.13988196499992, 43.98200104400007],
              [-124.13719641799992, 43.99042389500005],
              [-124.12425696499992, 43.99624258000006],
              [-124.1194555329999, 44.00649648600006],
              [-124.13341874299994, 44.032016558000066],
              [-124.13354093999993, 44.04425574600003],
              [-124.12612870999993, 44.09955475500004],
              [-124.11394579699993, 44.190582723000034],
              [-124.1140844389999, 44.24900950700004],
              [-124.10724850199995, 44.286322333000044],
              [-124.10814368399991, 44.29238515800006],
              [-124.1135961579999, 44.30145905200004],
              [-124.1140844389999, 44.30735911700003],
              [-124.11148027299993, 44.31329987200007],
              [-124.1030981109999, 44.322333075000074],
              [-124.1004125639999, 44.32729726800005],
              [-124.0888439069999, 44.38544496500003],
              [-124.08442714099994, 44.41166449900004],
              [-124.07188880099994, 44.42182038000004],
              [-124.06530979399992, 44.429489071000035],
              [-124.05355179999992, 44.43297538200005],
              [-124.04523922899995, 44.42527598800007],
              [-124.0349770919999, 44.41617415800005],
              [-124.0178930329999, 44.409816799000055],
              [-124.02761581899989, 44.43921613900005],
              [-124.03933712999992, 44.443445670000074],
              [-124.04961248399991, 44.44869587800008],
              [-124.0682391389999, 44.437885694000045],
              [-124.07608050499994, 44.43334357200007],
              [-124.08343370599994, 44.427752110000085],
              [-124.08275305899991, 44.44086334800005],
              [-124.08143410799994, 44.46236175300004],
              [-124.08435201399993, 44.49806604000008],
              [-124.06319396599991, 44.60951951900006],
              [-124.05260726199992, 44.618212423000045],
              [-124.04566302899991, 44.621499811000035],
              [-124.03113492799991, 44.617959933000066],
              [-124.02321475299993, 44.611366461000046],
              [-124.02024871099991, 44.60689426000005],
              [-124.01202007199993, 44.59983535100008],
              [-124.00969077199994, 44.60994500700008],
              [-124.00475494699992, 44.616291370000056],
              [-124.0067066599999, 44.62381400500004],
              [-124.01888343999991, 44.62712008600005],
              [-124.02318931999991, 44.623125955000035],
              [-124.0271557349999, 44.62242424100003],
              [-124.0350803959999, 44.62572451700004],
              [-124.04829422599994, 44.63255495400006],
              [-124.05589972999991, 44.62668213100005],
              [-124.06813834499991, 44.61775280300009],
              [-124.07077849899991, 44.620576774000085],
              [-124.06745831699993, 44.63209925700005],
              [-124.06282999099994, 44.64055204600004],
              [-124.0591855369999, 44.65158865400008],
              [-124.05784401799991, 44.66358018300008],
              [-124.06278756799992, 44.67182026200004],
              [-124.07468672499994, 44.67279720100004],
              [-124.07799203999991, 44.674916636000034],
              [-124.07236454799994, 44.67890974900007],
              [-124.0670630109999, 44.68945150500008],
              [-124.05842037699995, 44.72614166900007],
              [-124.05943762899994, 44.74624258000006],
              [-124.06526104099993, 44.76370249300004],
              [-124.07337430199993, 44.77765319200006],
              [-124.06656211199993, 44.80552779000004],
              [-124.06518479399995, 44.82331108200009],
              [-124.0536396089999, 44.83869852100008],
              [-124.04649817599994, 44.85838450700004],
              [-124.03453528599994, 44.87840403900009],
              [-124.03270423099991, 44.897365627000056],
              [-124.03184973899994, 44.90485260600008],
              [-124.02448482999989, 44.90973541900007],
              [-124.01768958199995, 44.91657135600008],
              [-124.01820425999989, 44.92749587800006],
              [-124.0256465949999, 44.93566194400006],
              [-124.02448482999989, 44.94383372600004],
              [-124.01500403599994, 44.96771881700005],
              [-124.01134192599994, 44.997707424000055],
              [-124.00479081899994, 45.04352448100008],
              [-124.01573645699995, 45.05442942900004],
              [-124.01414954299992, 45.06427643400008],
              [-124.0042211579999, 45.08258698100008],
              [-123.98436438699991, 45.10492584800005],
              [-123.97691809799994, 45.12885163000004],
              [-123.97109941299993, 45.15371328300006],
              [-123.97059048499995, 45.167292770000074],
              [-123.96917652999991, 45.18605669000004],
              [-123.96912234899992, 45.20529980400005],
              [-123.97638912699995, 45.21662018400008],
              [-123.96835632599993, 45.25051370500006],
              [-123.96544348899994, 45.25844961100006],
              [-123.96207792299992, 45.279364813000086],
              [-123.96035722599993, 45.299994208000044],
              [-123.97191321499992, 45.33144765800006],
              [-123.98766028599994, 45.336371161000045],
              [-124.00177975199995, 45.33763255400004],
              [-124.00177975199995, 45.34446849200003],
              [-123.98102779899995, 45.349595445000034],
              [-123.97276770699995, 45.36200592700004],
              [-123.97020423099991, 45.378607489000046],
              [-123.96784420499989, 45.391791083000044],
              [-123.96446692599994, 45.40253327000005],
              [-123.96117102799991, 45.40916575700004],
              [-123.95787512899994, 45.41498444200005],
              [-123.95335852799991, 45.413397528000075],
              [-123.95547441299993, 45.40924713700008],
              [-123.96080481699994, 45.378607489000046],
              [-123.94424394399994, 45.38934967700004],
              [-123.9319555329999, 45.40542226800005],
              [-123.91844641799992, 45.417669989000046],
              [-123.95470130099994, 45.432806708000044],
              [-123.97109941299993, 45.45197174700007],
              [-123.97052975199995, 45.49445221600007],
              [-123.95860755099994, 45.516058661000045],
              [-123.95433508999992, 45.54840729400007],
              [-123.9488012359999, 45.55719635600008],
              [-123.94566809799994, 45.52570221600007],
              [-123.93919837099992, 45.49982330900008],
              [-123.92193004099994, 45.49490697300007],
              [-123.91287647799993, 45.483335974000056],
              [-123.89053300699993, 45.475490627000056],
              [-123.89422026699992, 45.48231079800007],
              [-123.89142371399993, 45.48807302600005],
              [-123.88661341799991, 45.49335589600008],
              [-123.88328706899989, 45.50009048900006],
              [-123.88534730999993, 45.507305306000035],
              [-123.88929108899993, 45.51981474100006],
              [-123.8974873169999, 45.52463788300008],
              [-123.90050208199995, 45.53847890800006],
              [-123.8960668609999, 45.56028880400004],
              [-123.92520097599993, 45.55426666900007],
              [-123.94798743399991, 45.56875234600005],
              [-123.95787512899994, 45.576157945000034],
              [-123.95225069799994, 45.59106385500007],
              [-123.94458127299993, 45.62134100600008],
              [-123.9418757919999, 45.648504864000074],
              [-123.92073228599992, 45.66266321900008],
              [-123.9215954579999, 45.683725751000054],
              [-123.91822946999991, 45.68956633600004],
              [-123.91030148199991, 45.69127981300005],
              [-123.90151805799991, 45.68710930800006],
              [-123.89331285299994, 45.683626771000036],
              [-123.8874284659999, 45.682923249000055],
              [-123.87954667899993, 45.68650950700004],
              [-123.87108313699991, 45.69790273600006],
              [-123.87718665299991, 45.69611237200007],
              [-123.8816625639999, 45.69546133000006],
              [-123.88589433499993, 45.69403717700004],
              [-123.8973227169999, 45.69576431200005],
              [-123.9036158319999, 45.70098870900006],
              [-123.90800991899994, 45.708268126000064],
              [-123.91743251899993, 45.704483054000036],
              [-123.9210391549999, 45.69719540600005],
              [-123.93034415699992, 45.69344253300005],
              [-123.9323656769999, 45.68168891500005],
              [-123.9324152449999, 45.668548308000084],
              [-123.93787972599989, 45.66060352300008],
              [-123.93936113199993, 45.667669989000046],
              [-123.93740800699993, 45.69896067900004],
              [-123.9416771889999, 45.72695436100008],
              [-123.94757791099994, 45.73595540300005],
              [-123.9639289019999, 45.743869249000056],
              [-123.9692989099999, 45.752940150000086],
              [-123.96776723699992, 45.760931776000064],
              [-123.97223922099994, 45.762629693000065],
              [-123.98113863999993, 45.76029374800004],
              [-123.98215208099992, 45.76776941400004],
              [-123.96837583699994, 45.78157828900004],
              [-123.96666419199994, 45.79596588700008],
              [-123.95913652299993, 45.815659898000035],
              [-123.9566137359999, 45.87323639500005],
              [-123.95970618399991, 45.89728424700007],
              [-123.96971594999991, 45.91860586100006],
              [-123.9905492829999, 45.937933661000045],
              [-123.98232988199993, 45.94806549700007],
              [-123.97288977799991, 45.95270416900007],
              [-123.9642926919999, 45.966935428000056],
              [-123.9510913719999, 45.972263102000056],
              [-123.93399003799993, 45.979681708000044],
              [-123.92845618399991, 45.99258047100005],
              [-123.92332923099991, 46.01398346600007],
              [-123.92840235199992, 46.037246131000074],
              [-123.9368417359999, 46.08183125800008],
              [-123.9506328139999, 46.11999888000008],
              [-123.99046790299991, 46.200506903000075],
              [-124.02266442699994, 46.230841603000044],
              [-124.0173399709999, 46.23543291300007],
              [-124.00271757999991, 46.23771766900006],
              [-123.98813087899993, 46.226665894000064],
              [-123.9947904739999, 46.22024085000004],
              [-123.98485589899991, 46.210117],
              [-123.96891676399991, 46.21055530400008],
              [-123.95100431999992, 46.20501458400008],
              [-123.9238353209999, 46.19072139000008],
              [-123.91591067299993, 46.180595906000065],
              [-123.91059538699994, 46.181506366000065],
              [-123.9039626259999, 46.18011361400005],
              [-123.90069477599991, 46.16861797700005],
              [-123.8808035809999, 46.163980793000064],
              [-123.86693274599992, 46.159857489000046],
              [-123.83502983099993, 46.16249077200007],
              [-123.82511649499992, 46.15694823500007],
              [-123.81854314899994, 46.14728054200003],
              [-123.8133031889999, 46.12775299700007],
              [-123.81248938699991, 46.114162502000056],
              [-123.79873613199993, 46.102443752000056],
              [-123.80028235599991, 46.11579010600008],
              [-123.80144372199993, 46.130231826000056],
              [-123.80064714999992, 46.14355333300006],
              [-123.77830969999991, 46.137152411000045],
              [-123.77830969999991, 46.14337799700007],
              [-123.78693600199995, 46.14956289300005],
              [-123.80699622299994, 46.16754791900007],
              [-123.81615149599992, 46.17133209800005],
              [-123.82701575399994, 46.17206452000005],
              [-123.84358415799994, 46.17308541600005],
              [-123.8501943249999, 46.17723958100004],
              [-123.86079849099991, 46.18094165100007],
              [-123.8654187969999, 46.18646779800008],
              [-123.8561051669999, 46.18920485700005],
              [-123.83616995299991, 46.190077064000036],
              [-123.82089145499992, 46.18957863600008],
              [-123.79808508999992, 46.19354889500005],
              [-123.77873965399993, 46.20138617900005],
              [-123.7667706879999, 46.204106413000034],
              [-123.75487702599992, 46.195794868000064],
              [-123.73668372299994, 46.178168036000045],
              [-123.72718891499994, 46.170422303000066],
              [-123.70595320799993, 46.17080546500006],
              [-123.6140844389999, 46.18646881700005],
              [-123.59947669199994, 46.191839911000045],
              [-123.6201144669999, 46.19664426800006],
              [-123.62059485599991, 46.20482005400004],
              [-123.60741126199991, 46.209051825000074],
              [-123.58151374699992, 46.20657293700003],
              [-123.56492902899993, 46.21655545600004],
              [-123.54207561699991, 46.22615403700007],
              [-123.53659135599992, 46.23397326300005],
              [-123.51927318599991, 46.23526921600006],
              [-123.49714107999989, 46.23281484600005],
              [-123.48493404899995, 46.23004791900007],
              [-123.47314329599993, 46.21748928900007],
              [-123.45285927399993, 46.207223568000074],
              [-123.43715407399992, 46.19832191900008],
              [-123.43198948999992, 46.187278527000046],
              [-123.43014189899992, 46.17672391900004],
              [-123.42105058499993, 46.169134833000044],
              [-123.40591141999994, 46.15825358400008],
              [-123.3855209219999, 46.14618309900004],
              [-123.3259613809999, 46.138886428000035],
              [-123.29937916599994, 46.140992194000034],
              [-123.27764068199991, 46.13394123300009],
              [-123.25643886799992, 46.13332119700004],
              [-123.23330644399994, 46.137152411000045],
              [-123.2210308249999, 46.147285974000056],
              [-123.2055403949999, 46.16461405200005],
              [-123.19342799799995, 46.172330970000075],
              [-123.18009481299993, 46.179102095000076],
              [-123.1807325229999, 46.18002792000004],
              [-123.20751799599992, 46.17836337500006],
              [-123.2475017569999, 46.16262675100006],
              [-123.2694460059999, 46.15041476600004],
              [-123.29793851599993, 46.151544598000044],
              [-123.32886597299989, 46.16555550500004],
              [-123.39336181399995, 46.204137166000066],
              [-123.41238873299994, 46.22029463600006],
              [-123.42744140499991, 46.23928855300005],
              [-123.44448855399992, 46.25778187800006],
              [-123.45567610599994, 46.26704433800006],
              [-123.47891191299993, 46.27586497600004],
              [-123.60317949099993, 46.26007721600007],
              [-123.66266842399995, 46.27024974200003],
              [-123.66734778599994, 46.27684153900009],
              [-123.6699926419999, 46.285589911000045],
              [-123.67520097599993, 46.294256903000075],
              [-123.6929674619999, 46.30520225100008],
              [-123.70192519499994, 46.303349998000044],
              [-123.71598445799992, 46.30146479100006],
              [-123.72386192099992, 46.300325281000084],
              [-123.7261891839999, 46.290234704000056],
              [-123.7351963559999, 46.28793403200007],
              [-123.74753274199992, 46.29108030400005],
              [-123.75208759399993, 46.286005474000035],
              [-123.75774344199993, 46.277518513000075],
              [-123.76451291799992, 46.27326731000005],
              [-123.77798404999993, 46.27408452100008],
              [-123.7908611169999, 46.28299272000004],
              [-123.80658277799989, 46.28339623000005],
              [-123.81504291699991, 46.275311884000075],
              [-123.81844384399994, 46.26876154200005],
              [-123.8341636099999, 46.26875901800008],
              [-123.8414999009999, 46.26143428100005],
              [-123.8510412679999, 46.259846355000036],
              [-123.8544520989999, 46.25212964100007],
              [-123.8623229069999, 46.24865317000007],
              [-123.87303348899991, 46.24017172100008],
              [-123.8898550529999, 46.242147971000065],
              [-123.9077961829999, 46.24646068000004],
              [-123.92517429899993, 46.251540584000054],
              [-123.93973006599992, 46.264383621000036],
              [-123.94869604699994, 46.269835381000064],
              [-123.96714923299993, 46.29431579700008],
              [-123.97333268299991, 46.29978195100006],
              [-123.9850910969999, 46.30909712000005],
              [-124.0093038089999, 46.31345550600008],
              [-124.02280113299992, 46.31425305500005],
              [-124.0329362459999, 46.30610912000009],
              [-124.04025192699993, 46.304178006000086],
              [-124.04869500599995, 46.29641835100006],
              [-124.05151136599994, 46.28592994500008],
              [-124.04030187799992, 46.28097450000007],
              [-124.03806392899992, 46.27670470900006],
              [-124.04143864499991, 46.27282800200004],
              [-124.05210299599992, 46.27361176900007],
              [-124.06164186799992, 46.27672225400005],
              [-124.07119289499991, 46.27129553300006],
              [-124.07583574099993, 46.26829661700003],
              [-124.08017487799992, 46.27168795400007],
              [-124.07835852799991, 46.28237539300005],
              [-124.07734167699994, 46.294966302000034],
              [-124.07283610299993, 46.30699260400007],
              [-124.06888586199995, 46.32289834100004],
              [-124.06605768999992, 46.33880652300007],
              [-124.06379013899993, 46.35626714400007],
              [-124.06206843599995, 46.38770537700009],
              [-124.06085709599989, 46.43987082000007],
              [-124.06261145699995, 46.59593333500004],
              [-124.0724995619999, 46.64251004200008],
              [-124.06287610599992, 46.654940829000054],
              [-124.05100742699994, 46.645602075000056],
              [-124.03576003699993, 46.630818343000044],
              [-124.04409745999993, 46.62360260600008],
              [-124.03831946499992, 46.60761139500005],
              [-124.02562415299991, 46.59088776200008],
              [-124.0178930329999, 46.56854889500005],
              [-124.02623450399994, 46.49233633000006],
              [-124.0247289699999, 46.46552155200004],
              [-124.02205088199992, 46.419666094000036],
              [-124.01425110899993, 46.38511863700006],
              [-123.99344585799992, 46.38009918900008],
              [-123.97770136199989, 46.382444289000034],
              [-123.95811926999994, 46.378241278000075],
              [-123.9478803849999, 46.40300459000008],
              [-123.93202437899993, 46.41528259900008],
              [-123.92686366099991, 46.44009966500005],
              [-123.92067816499991, 46.43931468000005],
              [-123.91060209199992, 46.428439955000044],
              [-123.87589026699993, 46.41912029200006],
              [-123.84654700399994, 46.39663320500006],
              [-123.8406469389999, 46.41575755400004],
              [-123.8567602199999, 46.42645905200004],
              [-123.88068600199995, 46.43349844000005],
              [-123.89806067599994, 46.44163646000004],
              [-123.90021725199995, 46.44668203300006],
              [-123.9016820949999, 46.45734284100007],
              [-123.90489661399994, 46.45937734600005],
              [-123.91051184799994, 46.46067942900004],
              [-123.91771399599992, 46.464056708000044],
              [-123.92438717399995, 46.468451239000046],
              [-123.93582543199994, 46.47231129000005],
              [-123.93574186099994, 46.48045747100008],
              [-123.93517005099994, 46.49469635600008],
              [-123.92211185799994, 46.502552018000074],
              [-123.90802975199995, 46.50828685100004],
              [-123.9007055329999, 46.513373114000046],
              [-123.89635169199994, 46.52122630400004],
              [-123.89492753799993, 46.531317450000074],
              [-123.89635169199994, 46.54441966400009],
              [-123.89981035099993, 46.55117422100005],
              [-123.90420488199993, 46.55560944200005],
              [-123.92031816299993, 46.58071523600006],
              [-123.94473222599993, 46.605902411000045],
              [-123.95641028599994, 46.623114325000074],
              [-123.93854732999989, 46.61985911700003],
              [-123.91104081899994, 46.60541413000004],
              [-123.89492753799993, 46.602728583000044],
              [-123.91588294199994, 46.62840403900009],
              [-123.92251542899993, 46.657863674000055],
              [-123.91100012899994, 46.68203359600005],
              [-123.8772680329999, 46.69208405200004],
              [-123.84341386599993, 46.69668203300006],
              [-123.8264867829999, 46.69236888200004],
              [-123.81920325399994, 46.674994208000044],
              [-123.81187903599994, 46.66258372600004],
              [-123.79507402299993, 46.66087474200003],
              [-123.77647864499994, 46.667181708000044],
              [-123.7639867829999, 46.67841217700004],
              [-123.7957250639999, 46.68195221600007],
              [-123.81834876199991, 46.697699286000045],
              [-123.83975175699993, 46.71743398600006],
              [-123.86766516799992, 46.73305898600006],
              [-123.8836156889999, 46.737494208000044],
              [-123.89999627299994, 46.74740644900004],
              [-123.91223228099994, 46.74102285300006],
              [-123.9130021659999, 46.727768694000076],
              [-123.95178555399991, 46.724833801000045],
              [-123.97612882699991, 46.74105450800005],
              [-123.98195567199991, 46.72043824700006],
              [-123.97481769699993, 46.71110213400004],
              [-123.9633460419999, 46.70716242700007],
              [-123.9726975669999, 46.701262049000036],
              [-123.9877601479999, 46.70570411500006],
              [-124.0006807989999, 46.705712031000076],
              [-124.01432285699991, 46.71065279000004],
              [-124.02508994699991, 46.71262814000005],
              [-124.02985592399995, 46.72016022300005],
              [-124.0703254209999, 46.734812839000085],
              [-124.09337895899989, 46.74322839000007],
              [-124.10059902299992, 46.76147780800005],
              [-124.10130774599992, 46.808661200000074],
              [-124.1140844389999, 46.84910716400009],
              [-124.13048255099994, 46.885972398000035],
              [-124.12682044199994, 46.898504950000074],
              [-124.11178154599992, 46.912325889000044],
              [-124.09087899299993, 46.900013011000055],
              [-124.09756425699993, 46.87787506700005],
              [-124.07738196499992, 46.85879140800006],
              [-124.07249915299991, 46.84292226800005],
              [-124.05809485599991, 46.84446849200003],
              [-124.04206295499989, 46.83978913000004],
              [-124.02839107999989, 46.833970445000034],
              [-124.02131100199995, 46.83234284100007],
              [-124.01382402299993, 46.84247467700004],
              [-124.01471920499989, 46.85114166900007],
              [-124.02139238199993, 46.85984935100004],
              [-124.0315649079999, 46.87026601800005],
              [-124.05704504099992, 46.86208588300008],
              [-124.05487035199991, 46.87587261200008],
              [-124.04692792999992, 46.89113583300008],
              [-124.03322586799993, 46.89802445600009],
              [-124.00670325399994, 46.89923737200007],
              [-123.99193274599992, 46.90375397300005],
              [-123.96263587099992, 46.918036200000074],
              [-123.88169294799991, 46.94166443900008],
              [-123.81305904899995, 46.958970445000034],
              [-123.8281096579999, 46.965226545000064],
              [-123.84470892399992, 46.960842987000035],
              [-123.86790930899991, 46.969631252000056],
              [-123.95010125699991, 46.968401732000075],
              [-123.95586549399991, 46.972349620000045],
              [-123.94503173499993, 46.97283116700004],
              [-123.92227128799993, 46.980129299000055],
              [-123.96521848499992, 46.98418469400008],
              [-124.01288372699992, 46.98372611700006],
              [-124.01936405299995, 46.994076730000074],
              [-124.01283557999994, 47.00934839700005],
              [-124.02769934799994, 47.02814362200007],
              [-124.04675881899993, 47.033025147000046],
              [-124.0655463359999, 47.03747054000007],
              [-124.09012093799993, 47.04093233400005],
              [-124.11686993799992, 47.042916937000086],
              [-124.1392773899999, 47.03552702700006],
              [-124.14818274599992, 47.02440013200004],
              [-124.14610755099994, 47.017238674000055],
              [-124.13670813699991, 47.00189850500004],
              [-124.1370690789999, 46.987208957000064],
              [-124.13850473999992, 46.97735142800008],
              [-124.13659938599994, 46.967942881000056],
              [-124.13081187499989, 46.956765767000036],
              [-124.1235822459999, 46.94657441000004],
              [-124.11105931599991, 46.94799595600006],
              [-124.10479728099995, 46.944707092000044],
              [-124.10576002099992, 46.933421287000044],
              [-124.1221334089999, 46.941310025000064],
              [-124.13802946399994, 46.94459645500007],
              [-124.14814233599992, 46.94262057900005],
              [-124.1534365519999, 46.938015980000046],
              [-124.15342767699991, 46.93012399300005],
              [-124.1630563409999, 46.927489121000065],
              [-124.17846065799989, 46.92550682800004],
              [-124.17558805399995, 46.93570403700005],
              [-124.17642167899993, 46.942613023000035],
              [-124.17564856699994, 46.95384349200003],
              [-124.17228600199991, 46.98142681100006],
              [-124.17189232099992, 47.04194853700005],
              [-124.17433613799994, 47.06660759600004],
              [-124.1792699859999, 47.10687897300005],
              [-124.1998348439999, 47.18747979800008],
              [-124.21170743599993, 47.22663804600006],
              [-124.2275443769999, 47.26316761800007],
              [-124.24293218799994, 47.29007865600005],
              [-124.25369317199994, 47.301540153000076],
              [-124.27598376899994, 47.30262840800003],
              [-124.28054791299991, 47.31269282800008],
              [-124.29925653999993, 47.34820463300008],
              [-124.2868529239999, 47.34737646200006],
              [-124.27832112699991, 47.34195914900005],
              [-124.27171790299991, 47.34259674700007],
              [-124.2830915269999, 47.35123405200005],
              [-124.30836406799995, 47.352668881000056],
              [-124.31780793299993, 47.35735118300005],
              [-124.34869608499992, 47.499752570000055],
              [-124.35081946499992, 47.54682038000004],
              [-124.37488720099992, 47.607688120000034],
              [-124.3836063739999, 47.63601669700006],
              [-124.41078160799992, 47.68818354900009],
              [-124.41583523199989, 47.725587044000065],
              [-124.42275956899994, 47.741888739000046],
              [-124.43541419199994, 47.74445221600007],
              [-124.44676673099991, 47.75039297100005],
              [-124.4558813139999, 47.761786200000074],
              [-124.47656568999992, 47.778254609000044],
              [-124.48346920499989, 47.812933661000045],
              [-124.5416121799999, 47.834331149000036],
              [-124.5562646119999, 47.85368210200005],
              [-124.56798255099994, 47.86969635600008],
              [-124.59313293199995, 47.87619952600005],
              [-124.60950710599991, 47.874855198000034],
              [-124.63813010599989, 47.90786426100004],
              [-124.65615800699993, 47.954006252000056],
              [-124.67198645699995, 47.99070872600004],
              [-124.68321692599994, 48.02781810100004],
              [-124.69384694099995, 48.07453032800004],
              [-124.68944251199991, 48.10016510600008],
              [-124.7229711579999, 48.150091864000046],
              [-124.73460723799991, 48.17040360400006],
              [-124.71923587799989, 48.17629576500008],
              [-124.70006628599992, 48.191858653000054],
              [-124.68944251199991, 48.21344635600008],
              [-124.6897680329999, 48.21889883000006],
              [-124.69493567599994, 48.22557200700004],
              [-124.70551651199992, 48.24597908000004],
              [-124.7036272599999, 48.24985458600008],
              [-124.68913306799993, 48.25250801000004],
              [-124.68247849099993, 48.26349982100004],
              [-124.68321692599994, 48.28473541900007],
              [-124.67983964799993, 48.29368724200003],
              [-124.66490637899994, 48.30906810100004],
              [-124.66148841099994, 48.319525458000044],
              [-124.67053656399992, 48.32416871300006],
              [-124.66967764999993, 48.333187560000056],
              [-124.67841909999993, 48.33508434200007],
              [-124.68910879299995, 48.33761605800004],
              [-124.70281518699994, 48.34720208900006],
              [-124.71825110599991, 48.35736725500004],
              [-124.73025557199992, 48.371578287000034],
              [-124.72752846799995, 48.38772774000006],
              [-124.69651797099993, 48.39108644500004],
              [-124.66157605899991, 48.386036912000066],
              [-124.6381599909999, 48.38300116800008],
              [-124.6195549549999, 48.36891544800005],
              [-124.60797431099991, 48.366325912000036],
              [-124.59336672599994, 48.37485614600007],
              [-124.57489390699993, 48.37040762500004],
              [-124.5320723399999, 48.34990991900008],
              [-124.45799719999991, 48.316839911000045],
              [-124.39921398699994, 48.293579925000074],
              [-124.34683183499993, 48.28107330900008],
              [-124.33763587099992, 48.277044989000046],
              [-124.29634240099995, 48.261545235000085],
              [-124.27400683799993, 48.25705125800005],
              [-124.2508462529999, 48.26289908800004],
              [-124.22765051999994, 48.25853099200003],
              [-124.15980254999994, 48.23266201700005],
              [-124.1114142809999, 48.215931080000075],
              [-124.09984094299995, 48.200472681000065],
              [-124.0501819189999, 48.17726302600005],
              [-123.99707727499992, 48.17269396700004],
              [-123.97099138599992, 48.16559843600004],
              [-123.94394835799994, 48.16554333700009],
              [-123.91883313099993, 48.16227674000004],
              [-123.87342522299991, 48.161551778000046],
              [-123.86188353299991, 48.15639424600005],
              [-123.81833923199991, 48.16077541700008],
              [-123.78888912699995, 48.15314362200007],
              [-123.74202050699989, 48.15991492100005],
              [-123.70034372899994, 48.16491069600005],
              [-123.64169479499992, 48.151191692000054],
              [-123.6338728959999, 48.14144709900006],
              [-123.58459962099994, 48.13541681000004],
              [-123.56703737599992, 48.14693419300005],
              [-123.55239345699994, 48.15136218500004],
              [-123.53502843099994, 48.14546475000009],
              [-123.5236169239999, 48.13509975000005],
              [-123.50548255099994, 48.13263580900008],
              [-123.47560609099992, 48.13360736100009],
              [-123.43589582599992, 48.142407182000056],
              [-123.41850625299992, 48.142302973000085],
              [-123.40502183599995, 48.13899837100007],
              [-123.42630174399994, 48.13719214900004],
              [-123.44083569399993, 48.13405542600009],
              [-123.4534286299999, 48.13154865000007],
              [-123.4496606269999, 48.12510875900006],
              [-123.42173417099991, 48.11782789800009],
              [-123.35799863999989, 48.11742233700005],
              [-123.3223261789999, 48.11461325100004],
              [-123.28746124399993, 48.118216558000086],
              [-123.24692672299994, 48.11533374600003],
              [-123.22362219999991, 48.12201569200005],
              [-123.17060080399995, 48.16437427900007],
              [-123.1500332949999, 48.177102253000044],
              [-123.1082505149999, 48.183837639000046],
              [-123.11802433499992, 48.17940744400005],
              [-123.1307217019999, 48.173711893000075],
              [-123.14447123699989, 48.16350826300004],
              [-123.16128495999993, 48.15192291900007],
              [-123.14571375499992, 48.15126993000007],
              [-123.1118094069999, 48.14902750300007],
              [-123.0891820949999, 48.12848541900007],
              [-123.06302914799994, 48.11760338500005],
              [-123.04045427199992, 48.08511328700007],
              [-123.04527747299994, 48.05971914300005],
              [-123.02969316299993, 48.04523346600007],
              [-123.0078832669999, 48.03856028900009],
              [-122.99681555899991, 48.03864166900007],
              [-123.00572669199994, 48.07868073100008],
              [-122.99913489499994, 48.09174225500004],
              [-122.95693925699993, 48.09747955900008],
              [-122.94107011599993, 48.09788646000004],
              [-122.92747962099992, 48.09511953300006],
              [-122.92174231699994, 48.08612702000005],
              [-122.9187719389999, 48.07021719000005],
              [-122.91079667899993, 48.066107489000046],
              [-122.8997289699999, 48.06622955900008],
              [-122.88695227799991, 48.062567450000074],
              [-122.87254798099991, 48.04975006700005],
              [-122.85728919199994, 48.02952708500004],
              [-122.85338294199994, 48.01044342700004],
              [-122.87328040299991, 48.00112539300005],
              [-122.87328040299991, 47.99371979400007],
              [-122.85435950399994, 47.99526601800005],
              [-122.8413793609999, 48.005560614000046],
              [-122.82485917899993, 48.035223700000074],
              [-122.83690344999991, 48.04987213700008],
              [-122.87706458199995, 48.07965729400007],
              [-122.8816625639999, 48.09174225500004],
              [-122.8777563139999, 48.106634833000044],
              [-122.86831620999993, 48.11928945500006],
              [-122.8562719389999, 48.12457916900007],
              [-122.82384192599994, 48.13108958500004],
              [-122.79491126199991, 48.14118073100008],
              [-122.77017167899993, 48.14109935100004],
              [-122.75039628799993, 48.117173570000034],
              [-122.75987708199995, 48.112209377000056],
              [-122.78453528599994, 48.10293203300006],
              [-122.79137122299994, 48.09674713700008],
              [-122.79198157499991, 48.082912502000056],
              [-122.7844945949999, 48.07306549700007],
              [-122.77538001199991, 48.06557851800005],
              [-122.77090410099993, 48.05914948100008],
              [-122.76463782499991, 48.044623114000046],
              [-122.72248287699995, 47.99371979400007],
              [-122.71434485599991, 47.98725006700005],
              [-122.6953832669999, 47.978949286000045],
              [-122.68834387899994, 47.97321198100008],
              [-122.68565833199995, 47.96539948100008],
              [-122.68252519399994, 47.94407786700003],
              [-122.67808997299994, 47.93569570500006],
              [-122.62621008999992, 47.889553127000056],
              [-122.62010657499991, 47.87763092700004],
              [-122.6282445949999, 47.87352122600004],
              [-122.65807044199994, 47.87250397300005],
              [-122.66783606699994, 47.870794989000046],
              [-122.67642167899993, 47.86212799700007],
              [-122.6839086579999, 47.84320709800005],
              [-122.69204667899993, 47.83258698100008],
              [-122.7363988919999, 47.79441966400009],
              [-122.75039628799993, 47.77456289300005],
              [-122.76866614499994, 47.737982489000046],
              [-122.77521725199995, 47.718817450000074],
              [-122.77769934799994, 47.70254140800006],
              [-122.78107662699995, 47.69204336100006],
              [-122.78929602799991, 47.68451569200005],
              [-122.8003637359999, 47.67987702000005],
              [-122.81187903599994, 47.67837148600006],
              [-122.82848059799994, 47.68317291900007],
              [-122.82921301999994, 47.69407786700003],
              [-122.81802324099993, 47.71312083500004],
              [-122.79979407499991, 47.77728913000004],
              [-122.79893958199995, 47.806708075000074],
              [-122.80565344999991, 47.843451239000046],
              [-122.81729081899994, 47.83026764500005],
              [-122.81847083199995, 47.81085846600007],
              [-122.8216039699999, 47.79242584800005],
              [-122.8391820949999, 47.78204987200007],
              [-122.84040279899995, 47.80231354400007],
              [-122.84679114499994, 47.820298570000034],
              [-122.85643469999991, 47.82607656500005],
              [-122.86709550699993, 47.80927155200004],
              [-122.86636308499993, 47.79352448100008],
              [-122.85826575399994, 47.775458075000074],
              [-122.8391820949999, 47.74664948100008],
              [-122.86192786399994, 47.73334381700005],
              [-122.87621008999992, 47.710150458000044],
              [-122.88662675699993, 47.68813711100006],
              [-122.90396074099993, 47.673163153000075],
              [-122.91002356699994, 47.650091864000046],
              [-122.9180395169999, 47.64484284100007],
              [-122.93032792899993, 47.64199453300006],
              [-122.94176184799994, 47.63491445500006],
              [-123.0210668609999, 47.565659898000035],
              [-123.03294837099992, 47.549994208000044],
              [-123.06509355399993, 47.493394273000035],
              [-123.08055579299992, 47.47882721600007],
              [-123.10130774599992, 47.465277411000045],
              [-123.11937415299991, 47.44953034100007],
              [-123.13337154899995, 47.41229889500005],
              [-123.15843665299991, 47.37205638200004],
              [-123.16128495999993, 47.35683828300006],
              [-123.13023841099994, 47.34064362200007],
              [-123.07412675699993, 47.344631252000056],
              [-122.90514075399994, 47.394964911000045],
              [-122.87157141799992, 47.409857489000046],
              [-122.8391820949999, 47.43195221600007],
              [-122.86774654899995, 47.43626536700003],
              [-122.9070531889999, 47.423814195000034],
              [-122.97630774599992, 47.39101797100005],
              [-123.05223548099991, 47.36701080900008],
              [-123.0918676419999, 47.36737702000005],
              [-123.11351477799991, 47.39101797100005],
              [-123.11050370999993, 47.40509674700007],
              [-123.09935462099992, 47.419907945000034],
              [-123.0725805329999, 47.44554271000004],
              [-123.0633031889999, 47.456732489000046],
              [-123.02261308499993, 47.52289459800005],
              [-122.94904537699995, 47.59707265800006],
              [-122.93545488199993, 47.602850653000075],
              [-122.87328040299991, 47.63117096600007],
              [-122.79820716099994, 47.651678778000075],
              [-122.77538001199991, 47.66071198100008],
              [-122.76353919199994, 47.669134833000044],
              [-122.75706946499992, 47.68231842700004],
              [-122.74278723899994, 47.72687409100007],
              [-122.73375403599994, 47.74258047100005],
              [-122.63487708199995, 47.83966705900008],
              [-122.62364661399994, 47.84715403900009],
              [-122.61318925699993, 47.85028717700004],
              [-122.59569251199991, 47.84723541900007],
              [-122.59414628799993, 47.83978913000004],
              [-122.5969945949999, 47.83071523600006],
              [-122.59215247299994, 47.82298411700003],
              [-122.57095292899993, 47.81976959800005],
              [-122.56651770699995, 47.83445872600004],
              [-122.57144120999993, 47.857082424000055],
              [-122.58828691299993, 47.90444570500006],
              [-122.59215247299994, 47.911769924000055],
              [-122.61099199099993, 47.935980536000045],
              [-122.61318925699993, 47.94594961100006],
              [-122.55337480399993, 47.92084381700005],
              [-122.52806555899991, 47.905503648000035],
              [-122.51768958199995, 47.88104889500005],
              [-122.51646887899994, 47.86635976800005],
              [-122.51024329299992, 47.83258698100008],
              [-122.5042211579999, 47.82245514500005],
              [-122.49376380099994, 47.81403229400007],
              [-122.49006100199995, 47.80385976800005],
              [-122.50401770699995, 47.78823476800005],
              [-122.49502519399994, 47.78611888200004],
              [-122.48452714799993, 47.782131252000056],
              [-122.47516842399995, 47.77606842700004],
              [-122.46922766799992, 47.76837799700007],
              [-122.46837317599994, 47.75653717700004],
              [-122.4734594389999, 47.748032945000034],
              [-122.47972571499992, 47.741888739000046],
              [-122.48289954299992, 47.73700592700004],
              [-122.49290930899991, 47.735256252000056],
              [-122.5410863919999, 47.74286530200004],
              [-122.55797278599994, 47.74042389500005],
              [-122.55577551999994, 47.72870514500005],
              [-122.56468665299991, 47.712551174000055],
              [-122.57970130099994, 47.69818756700005],
              [-122.59585527299993, 47.69196198100008],
              [-122.65160071499992, 47.73257070500006],
              [-122.66104081899994, 47.730454820000034],
              [-122.65811113199993, 47.717962958000044],
              [-122.65099036399994, 47.71141185100004],
              [-122.6419164699999, 47.706691799000055],
              [-122.6331274079999, 47.69944896000004],
              [-122.62840735599991, 47.69293854400007],
              [-122.59215247299994, 47.59707265800006],
              [-122.59959876199991, 47.59023672100005],
              [-122.59215247299994, 47.58274974200003],
              [-122.61693274599992, 47.57412344000005],
              [-122.64378821499992, 47.59585195500006],
              [-122.68150794199994, 47.651678778000075],
              [-122.68919837099992, 47.64354075700004],
              [-122.69456946499992, 47.634100653000075],
              [-122.69692949099993, 47.623114325000074],
              [-122.69579016799992, 47.61005280200004],
              [-122.69001217399995, 47.59662506700005],
              [-122.68154863199993, 47.59052155200004],
              [-122.64683997299994, 47.57697174700007],
              [-122.63914954299992, 47.577053127000056],
              [-122.6389867829999, 47.57477448100008],
              [-122.64736894399994, 47.56232330900008],
              [-122.65689042899993, 47.55174388200004],
              [-122.67593339799993, 47.53766510600008],
              [-122.68150794199994, 47.52753327000005],
              [-122.6301977199999, 47.54437897300005],
              [-122.60704505099994, 47.55548737200007],
              [-122.58592688699991, 47.56907786700003],
              [-122.55313066299993, 47.58340078300006],
              [-122.54320227799991, 47.56679922100005],
              [-122.54161536399994, 47.54096100500004],
              [-122.53408769399994, 47.52753327000005],
              [-122.50792395699995, 47.52033112200007],
              [-122.50959225199995, 47.50291575700004],
              [-122.52269446499992, 47.481756903000075],
              [-122.53066972599993, 47.462958075000074],
              [-122.53831946499992, 47.437486070000034],
              [-122.55162512899994, 47.41400788000004],
              [-122.5562231109999, 47.39199453300006],
              [-122.53750566299993, 47.37055084800005],
              [-122.54507402299993, 47.35643138200004],
              [-122.55524654899995, 47.34662506700005],
              [-122.5686742829999, 47.34015534100007],
              [-122.58592688699991, 47.336371161000045],
              [-122.56065833199995, 47.30133698100008],
              [-122.55699622299994, 47.28461334800005],
              [-122.56851152299993, 47.26406484600005],
              [-122.58348548099991, 47.26422760600008],
              [-122.66104081899994, 47.28790924700007],
              [-122.68626868399991, 47.301214911000045],
              [-122.68346106699994, 47.31037018400008],
              [-122.6695043609999, 47.31948476800005],
              [-122.66104081899994, 47.33258698100008],
              [-122.65347245999993, 47.34918854400007],
              [-122.63857988199993, 47.36322663000004],
              [-122.62791907499991, 47.37995026200008],
              [-122.6331274079999, 47.40460846600007],
              [-122.64061438699991, 47.385972398000035],
              [-122.6536352199999, 47.37653229400007],
              [-122.68834387899994, 47.36432526200008],
              [-122.6961156889999, 47.35846588700008],
              [-122.70303300699993, 47.351223049000055],
              [-122.71043860599991, 47.34516022300005],
              [-122.71934973899994, 47.34259674700007],
              [-122.72594153599994, 47.339056708000044],
              [-122.72793535099993, 47.33063385600008],
              [-122.72907467399995, 47.32062409100007],
              [-122.73302161399994, 47.31244538000004],
              [-122.74860592399995, 47.295355536000045],
              [-122.75308183499993, 47.28119538000004],
              [-122.7476293609999, 47.267279364000046],
              [-122.72329667899993, 47.23847077000005],
              [-122.72447669199994, 47.23261139500005],
              [-122.73086503799993, 47.22801341400009],
              [-122.73672441299993, 47.21967194200005],
              [-122.73692786399994, 47.22455475500004],
              [-122.74144446499992, 47.222316799000055],
              [-122.74705969999991, 47.21698639500005],
              [-122.75039628799993, 47.21283600500004],
              [-122.74864661399994, 47.21067942900004],
              [-122.74526933499993, 47.20498281500005],
              [-122.74258378799993, 47.19790273600006],
              [-122.7429906889999, 47.19171784100007],
              [-122.7727758449999, 47.173081773000035],
              [-122.79869544199994, 47.20498281500005],
              [-122.81484941299993, 47.250881252000056],
              [-122.81493079299992, 47.274318752000056],
              [-122.79556230399993, 47.28066640800006],
              [-122.78661048099991, 47.296087958000044],
              [-122.7840063139999, 47.31525299700007],
              [-122.78453528599994, 47.34275950700004],
              [-122.78604081899994, 47.35040924700007],
              [-122.79137122299994, 47.36432526200008],
              [-122.79808508999992, 47.37148672100005],
              [-122.80663001199991, 47.37653229400007],
              [-122.81110592399995, 47.38377513200004],
              [-122.80565344999991, 47.397772528000075],
              [-122.82013912699995, 47.38328685100004],
              [-122.83657792899993, 47.33429596600007],
              [-122.8460180329999, 47.31586334800005],
              [-122.87002519399994, 47.299261786000045],
              [-122.88565019399994, 47.29132721600007],
              [-122.89753170499989, 47.28790924700007],
              [-122.9134008449999, 47.28530508000006],
              [-122.92048092399995, 47.27802155200004],
              [-122.94977779899995, 47.20229726800005],
              [-122.96507727799991, 47.18113841400009],
              [-122.99063066299993, 47.16502513200004],
              [-123.0432836579999, 47.15444570500006],
              [-123.06834876199991, 47.14594147300005],
              [-123.07876542899993, 47.13027578300006],
              [-123.06387285099993, 47.13711172100005],
              [-123.04092363199993, 47.144232489000046],
              [-123.02163652299993, 47.14443594000005],
              [-123.01793372299994, 47.13027578300006],
              [-123.02940833199995, 47.121527411000045],
              [-123.0488988919999, 47.11823151200008],
              [-123.06810462099992, 47.112494208000044],
              [-123.07876542899993, 47.096136786000045],
              [-123.05899003799993, 47.10268789300005],
              [-122.97451738199993, 47.14642975500004],
              [-122.96890214799993, 47.147691148000035],
              [-122.96483313699991, 47.15094635600008],
              [-122.9422094389999, 47.17804596600007],
              [-122.93024654899995, 47.17446523600006],
              [-122.93468176999994, 47.15997955900008],
              [-122.97907467399995, 47.10150788000004],
              [-122.99254309799994, 47.09088776200008],
              [-123.01048743399991, 47.08250560100004],
              [-122.98745683499993, 47.08100006700005],
              [-122.96458899599992, 47.08999258000006],
              [-122.94587154899995, 47.10716380400004],
              [-122.93541419199994, 47.13027578300006],
              [-122.92931067599994, 47.120428778000075],
              [-122.9273168609999, 47.109808661000045],
              [-122.92931067599994, 47.099269924000055],
              [-122.93541419199994, 47.08930084800005],
              [-122.92564856699994, 47.07831452000005],
              [-122.91820227799991, 47.05613841400009],
              [-122.90807044199994, 47.04832591400009],
              [-122.89329993399991, 47.04726797100005],
              [-122.89297441299993, 47.05735911700003],
              [-122.90021725199995, 47.071519273000035],
              [-122.90807044199994, 47.08250560100004],
              [-122.8958227199999, 47.09259674700007],
              [-122.89647376199991, 47.10492584800005],
              [-122.9011938139999, 47.11786530200004],
              [-122.90123450399994, 47.13027578300006],
              [-122.89240475199995, 47.14207591400009],
              [-122.8528539699999, 47.16502513200004],
              [-122.84740149599992, 47.15521881700005],
              [-122.8479711579999, 47.14606354400007],
              [-122.85260982999989, 47.13776276200008],
              [-122.8596899079999, 47.13027578300006],
              [-122.84552975199995, 47.131740627000056],
              [-122.83079993399991, 47.136786200000074],
              [-122.82095292899993, 47.14207591400009],
              [-122.82152258999992, 47.144598700000074],
              [-122.82266191299993, 47.16010163000004],
              [-122.81712805899991, 47.165716864000046],
              [-122.79820716099994, 47.15761953300006],
              [-122.79010982999989, 47.14911530200004],
              [-122.7820531889999, 47.13776276200008],
              [-122.7727758449999, 47.12775299700007],
              [-122.74815833199995, 47.120021877000056],
              [-122.73574785099993, 47.11147695500006],
              [-122.72642981699994, 47.10040924700007],
              [-122.72248287699995, 47.08930084800005],
              [-122.68590247299994, 47.104396877000056],
              [-122.65233313699991, 47.12807851800005],
              [-122.5716039699999, 47.20929596600007],
              [-122.55020097599993, 47.24233633000006],
              [-122.53709876199991, 47.278550523000035],
              [-122.53750566299993, 47.31586334800005],
              [-122.52037512899994, 47.30548737200007],
              [-122.48542232999989, 47.290228583000044],
              [-122.44847571499992, 47.268459377000056],
              [-122.43309485599991, 47.264878648000035],
              [-122.41860917899993, 47.26947663000004],
              [-122.40038001199991, 47.28107330900008],
              [-122.4175512359999, 47.28925202000005],
              [-122.42760169199994, 47.296535549000055],
              [-122.42955481699994, 47.30487702000005],
              [-122.42202714799993, 47.31586334800005],
              [-122.40941321499992, 47.32501862200007],
              [-122.39126542899993, 47.333685614000046],
              [-122.37214107999989, 47.34003327000005],
              [-122.33946692599994, 47.346584377000056],
              [-122.32848059799994, 47.357123114000046],
              [-122.32359778599994, 47.37254466400009],
              [-122.32526607999989, 47.39101797100005],
              [-122.33364824099993, 47.40412018400008],
              [-122.36095130099994, 47.42999909100007],
              [-122.36681067599994, 47.44220612200007],
              [-122.36668860599991, 47.48533763200004],
              [-122.37022864499994, 47.49713776200008],
              [-122.38141842399995, 47.510199286000045],
              [-122.38841712099992, 47.520819403000075],
              [-122.4075414699999, 47.566066799000055],
              [-122.40904700399994, 47.57493724200003],
              [-122.40371660099993, 47.58197663000004],
              [-122.39045162699995, 47.59369538000004],
              [-122.37791907499991, 47.59617747600004],
              [-122.36660722599993, 47.58567942900004],
              [-122.35606848899994, 47.57127513200004],
              [-122.3457738919999, 47.56232330900008],
              [-122.34105383999992, 47.58295319200005],
              [-122.33999589799993, 47.598944403000075],
              [-122.34520423099991, 47.61196523600006],
              [-122.35936438699991, 47.62372467700004],
              [-122.40404212099992, 47.63739655200004],
              [-122.41348222599993, 47.64166901200008],
              [-122.42332923099991, 47.65106842700004],
              [-122.42878170499989, 47.66038646000004],
              [-122.42516028599994, 47.66474030200004],
              [-122.41368567599994, 47.66746653900009],
              [-122.40929114499994, 47.67438385600008],
              [-122.40680904899995, 47.683294989000046],
              [-122.40038001199991, 47.69196198100008],
              [-122.38467363199993, 47.708970445000034],
              [-122.38109290299991, 47.72016022300005],
              [-122.38390051999994, 47.73672109600005],
              [-122.38756262899994, 47.75234609600005],
              [-122.39834550699993, 47.762925523000035],
              [-122.40611731699994, 47.77789948100008],
              [-122.4043676419999, 47.79759349200003],
              [-122.39948482999989, 47.81395091400009],
              [-122.3919164699999, 47.82758209800005],
              [-122.38219153599994, 47.839056708000044],
              [-122.35260982999989, 47.85626862200007],
              [-122.33971106699994, 47.87278880400004],
              [-122.33698482999989, 47.89484284100007],
              [-122.33421790299991, 47.91046784100007],
              [-122.32457434799994, 47.92438385600008],
              [-122.3245336579999, 47.93414948100008],
              [-122.32042395699995, 47.94208405200004],
              [-122.31265214799993, 47.94721100500004],
              [-122.29271399599992, 47.95734284100007],
              [-122.28571529899995, 47.96283600500004],
              [-122.27717037699995, 47.96743398600006],
              [-122.24160722599993, 47.97280508000006],
              [-122.23289954299992, 47.97842031500005],
              [-122.21279863199993, 47.98680247600004],
              [-122.20913652299993, 47.999701239000046],
              [-122.2073461579999, 48.01439036700003],
              [-122.20083574099993, 48.01898834800005],
              [-122.19627844999991, 48.022650458000044],
              [-122.1917211579999, 48.02631256700005],
              [-122.19351152299993, 48.030951239000046],
              [-122.20177161399994, 48.03367747600004],
              [-122.20750891799992, 48.037543036000045],
              [-122.22158769399994, 48.03815338700008],
              [-122.23810787699995, 48.02631256700005],
              [-122.30772864499994, 48.06537506700005],
              [-122.3401586579999, 48.09003327000005],
              [-122.36229407499991, 48.12250397300005],
              [-122.36774654899995, 48.15961334800005],
              [-122.36571204299992, 48.19057851800005],
              [-122.37559973899994, 48.21320221600007],
              [-122.41685950399994, 48.22553131700005],
              [-122.42186438699991, 48.22797272300005],
              [-122.42837480399993, 48.232123114000046],
              [-122.43594316299993, 48.23460521000004],
              [-122.44420325399994, 48.23236725500004],
              [-122.44896399599992, 48.22284577000005],
              [-122.4461156889999, 48.20221588700008],
              [-122.46662350199995, 48.19204336100006],
              [-122.46947180899991, 48.177069403000075],
              [-122.46572831899994, 48.159084377000056],
              [-122.45787512899994, 48.14362213700008],
              [-122.4480688139999, 48.13418203300006],
              [-122.43211829299992, 48.12246328300006],
              [-122.41462154899995, 48.112494208000044],
              [-122.39981035099993, 48.10822174700007],
              [-122.3841039699999, 48.10146719000005],
              [-122.36913001199991, 48.08567942900004],
              [-122.34801184799994, 48.05426666900007],
              [-122.3660375639999, 48.053900458000044],
              [-122.37743079299992, 48.060248114000046],
              [-122.39639238199993, 48.08152903900009],
              [-122.40562903599994, 48.08779531500005],
              [-122.48965410099993, 48.13043854400007],
              [-122.51036536399994, 48.14744700700004],
              [-122.52611243399991, 48.17096588700008],
              [-122.5332738919999, 48.19611237200007],
              [-122.53123938699991, 48.21987539300005],
              [-122.53395031699989, 48.24967680000009],
              [-122.4988500639999, 48.25287506700005],
              [-122.4651586579999, 48.25995514500005],
              [-122.44591223899994, 48.261053778000075],
              [-122.42992102799991, 48.259100653000075],
              [-122.41836503799993, 48.25153229400007],
              [-122.40965735599991, 48.241400458000044],
              [-122.40078691299993, 48.235256252000056],
              [-122.3889867829999, 48.23981354400007],
              [-122.39370683499993, 48.249986070000034],
              [-122.39061438699991, 48.260199286000045],
              [-122.3753149079999, 48.28074778900009],
              [-122.37938391799992, 48.28595612200007],
              [-122.38182532499991, 48.29682038000004],
              [-122.38585364499994, 48.30377838700008],
              [-122.39175370999993, 48.309759833000044],
              [-122.4253637359999, 48.33022695500006],
              [-122.4551488919999, 48.34247467700004],
              [-122.47862708199995, 48.359808661000045],
              [-122.49136308499993, 48.36505768400008],
              [-122.50621497299994, 48.36798737200007],
              [-122.52269446499992, 48.36896393400008],
              [-122.53376217399995, 48.374660549000055],
              [-122.5535375639999, 48.40131256700005],
              [-122.56704667899993, 48.40989817900004],
              [-122.56704667899993, 48.41738515800006],
              [-122.5520727199999, 48.42788320500006],
              [-122.55894934799994, 48.434027411000045],
              [-122.57420813699991, 48.43707916900007],
              [-122.58446204299992, 48.43781159100007],
              [-122.59170488199993, 48.43406810100004],
              [-122.60777747299994, 48.416001695000034],
              [-122.6155492829999, 48.40989817900004],
              [-122.63036048099991, 48.40534088700008],
              [-122.64659583199995, 48.40375397300005],
              [-122.66177324099993, 48.406236070000034],
              [-122.67357337099992, 48.41364166900007],
              [-122.68346106699994, 48.43016185100004],
              [-122.67857825399994, 48.43886953300006],
              [-122.6687719389999, 48.44525788000004],
              [-122.66331946499992, 48.45490143400008],
              [-122.66934160099993, 48.47280508000006],
              [-122.6829320949999, 48.47919342700004],
              [-122.69701087099992, 48.481350002000056],
              [-122.70490475199995, 48.48627350500004],
              [-122.70238196499992, 48.49799225500004],
              [-122.68907630099994, 48.49982330900008],
              [-122.67247473899994, 48.49896881700005],
              [-122.65990149599992, 48.50299713700008],
              [-122.63304602799991, 48.51626211100006],
              [-122.61327063699991, 48.50031159100007],
              [-122.59703528599994, 48.47455475500004],
              [-122.58071855399993, 48.458319403000075],
              [-122.5808813139999, 48.48452383000006],
              [-122.56834876199991, 48.489488023000035],
              [-122.55101477799991, 48.48151276200008],
              [-122.52721106699994, 48.46035390800006],
              [-122.51427161399994, 48.453192450000074],
              [-122.50059973899994, 48.450425523000035],
              [-122.48888098899994, 48.45490143400008],
              [-122.48082434799994, 48.464097398000035],
              [-122.48013261599993, 48.47028229400007],
              [-122.48281816299993, 48.47650788000004],
              [-122.4851781889999, 48.48627350500004],
              [-122.48839270699995, 48.512925523000035],
              [-122.49425208199995, 48.529364325000074],
              [-122.50352942599994, 48.54364655200004],
              [-122.51585852799991, 48.55760325700004],
              [-122.55601966099994, 48.576605536000045],
              [-122.56700598899994, 48.58535390800006],
              [-122.54662024599992, 48.58869049700007],
              [-122.52513587099992, 48.583197333000044],
              [-122.48534094999991, 48.559800523000035],
              [-122.4680883449999, 48.55451080900008],
              [-122.44762122299994, 48.562160549000055],
              [-122.44029700399994, 48.58071523600006],
              [-122.44432532499991, 48.60325755400004],
              [-122.45787512899994, 48.62343984600005],
              [-122.46646074099993, 48.62872955900008],
              [-122.47533118399991, 48.63125234600005],
              [-122.48412024599992, 48.634751695000034],
              [-122.49258378799993, 48.64325592700004],
              [-122.49714107999989, 48.653550523000035],
              [-122.50304114499994, 48.67963288000004],
              [-122.50255286399994, 48.684881903000075],
              [-122.52513587099992, 48.692287502000056],
              [-122.52110755099994, 48.709051825000074],
              [-122.4988500639999, 48.739488023000035],
              [-122.5086156889999, 48.75568268400008],
              [-122.52993730399993, 48.76862213700008],
              [-122.55467688699991, 48.777329820000034],
              [-122.5745336579999, 48.780462958000044],
              [-122.59361731699994, 48.77411530200004],
              [-122.60977128799993, 48.75861237200007],
              [-122.63971920499989, 48.72239817900004],
              [-122.65038001199991, 48.71816640800006],
              [-122.66014563699991, 48.72256094000005],
              [-122.66734778599994, 48.73187897300005],
              [-122.67015540299991, 48.74290599200003],
              [-122.66690019399994, 48.748114325000074],
              [-122.65290279899995, 48.75828685100004],
              [-122.64964758999992, 48.763657945000034],
              [-122.65819251199991, 48.777329820000034],
              [-122.67699133999992, 48.79344310100004],
              [-122.69595292899993, 48.800767320000034],
              [-122.70490475199995, 48.78790924700007],
              [-122.70059160099993, 48.812160549000055],
              [-122.70384680899991, 48.827378648000035],
              [-122.71422278599994, 48.83820221600007],
              [-122.75755774599992, 48.86424388200004],
              [-122.76821855399993, 48.87400950700004],
              [-122.77253170499989, 48.88654205900008],
              [-122.7683813139999, 48.89740631700005],
              [-122.75914466099994, 48.905951239000046],
              [-122.74990800699993, 48.912543036000045],
              [-122.74583899599992, 48.917669989000046],
              [-122.75885982999989, 48.93593984600005],
              [-122.80809485599991, 48.93451569200005],
              [-122.81354732999989, 48.95180898600006],
              [-122.80101477799991, 48.96230703300006],
              [-122.77749589799993, 48.96478913000004],
              [-122.73155676999994, 48.95921458500004],
              [-122.74111894399994, 48.97679271000004],
              [-122.75301682799991, 48.992514547000084],
            ],
          ],
          [
            [
              [-141.00556393099993, 69.65094635600008],
              [-141.00547115099997, 69.5051642860001],
              [-141.00539363699994, 69.35938507100009],
              [-141.00531612199993, 69.21360585600009],
              [-141.0052902839999, 69.06782664000006],
              [-141.0052386069999, 68.92204742500006],
              [-141.00516109299988, 68.77626820900007],
              [-141.00508357799995, 68.63048899400003],
              [-141.00500606299994, 68.48470977900003],
              [-141.0049285489999, 68.33898223900003],
              [-141.0048510339999, 68.19320302300004],
              [-141.00477351899988, 68.04742380800012],
              [-141.00474768199987, 67.90164459300011],
              [-141.00469600499997, 67.7558137010001],
              [-141.00461848999993, 67.61008616200009],
              [-141.00454097599993, 67.46428110800007],
              [-141.0044634609999, 67.31847605400007],
              [-141.00438594599987, 67.17272267700007],
              [-141.00430843199985, 67.02691762400003],
              [-141.00423091699992, 66.88113840800004],
              [-141.00420507799993, 66.73541086800005],
              [-141.00415340199993, 66.58957997600002],
              [-141.00407588799987, 66.443774923],
              [-141.00399837299994, 66.2980215460001],
              [-141.00392085799984, 66.1522681690001],
              [-141.0038433439999, 66.0065147910001],
              [-141.00376582899992, 65.86073557600007],
              [-141.00368831399987, 65.71495636100006],
              [-141.00363663899986, 65.56917714500007],
              [-141.00361079999996, 65.42337209100005],
              [-141.00353328499983, 65.27756703700003],
              [-141.0034557699999, 65.13178782100003],
              [-141.0033782559999, 64.98600860600003],
              [-141.00330074099986, 64.84022939100002],
              [-141.00322322599993, 64.69450185200002],
              [-141.00314571199993, 64.54867096],
              [-141.00309403499992, 64.40289174400009],
              [-141.0030681979999, 64.25711252900005],
              [-141.0029906819999, 64.11128163700003],
              [-141.00291316799988, 63.96550242200003],
              [-141.00283565399997, 63.81977488300005],
              [-141.00275813799993, 63.67409902000007],
              [-141.0026806239999, 63.52826812800005],
              [-141.00260310999988, 63.38248891200003],
              [-141.0025514329999, 63.23665802],
              [-141.00252559399988, 63.090878805],
              [-141.00244807999994, 62.94509959],
              [-141.0023705659999, 62.79932037400006],
              [-141.0022930499999, 62.65359283500008],
              [-141.002215536, 62.50776194300006],
              [-141.00213802199994, 62.36198272800006],
              [-141.00206050599994, 62.216229350000035],
              [-141.00200883099993, 62.070372620000015],
              [-141.0019829919999, 61.924619243],
              [-141.0019054779999, 61.778865865000014],
              [-141.00182796299987, 61.63308665000001],
              [-141.00175044799994, 61.4873332720001],
              [-141.00167293399994, 61.341579896],
              [-141.0015954189999, 61.195826518],
              [-141.0015179039999, 61.04996978800007],
              [-141.00144038999986, 60.904216411000064],
              [-141.00136287499993, 60.75841135700004],
              [-141.00128535999994, 60.612683818000065],
              [-141.00120784599991, 60.46687876500003],
              [-141.0011561689999, 60.32107371000002],
              [-140.9949291599999, 60.304382223000076],
              [-140.97955542099993, 60.29580393500005],
              [-140.9091462809999, 60.28365997300004],
              [-140.76845719499997, 60.259268697000024],
              [-140.66050512799995, 60.240510153000045],
              [-140.5337428389999, 60.218547669000074],
              [-140.51870499699993, 60.22387034100011],
              [-140.50666438899992, 60.23632436100009],
              [-140.47532263199992, 60.27647695000009],
              [-140.4627910979999, 60.28913767500005],
              [-140.44780493299993, 60.29446034800007],
              [-140.4241112879999, 60.293168437000034],
              [-140.32497005299987, 60.26753692700008],
              [-140.16924312399993, 60.22722931000003],
              [-140.01578995799986, 60.1873867800001],
              [-139.9677567139999, 60.18836863200006],
              [-139.9169329439999, 60.20785064700006],
              [-139.826318319, 60.25647817000008],
              [-139.72841731799988, 60.30903310200004],
              [-139.67981563299986, 60.32680979499999],
              [-139.62834590799991, 60.33409617100007],
              [-139.5179650479999, 60.33673167000008],
              [-139.41399206599993, 60.339212138000036],
              [-139.2621925459999, 60.34277781200002],
              [-139.10160803299996, 60.346601868000064],
              [-139.07946468099993, 60.34102081300004],
              [-139.06869014599994, 60.32205556300009],
              [-139.07318599499985, 60.29983469700004],
              [-139.1134677739999, 60.22681589800003],
              [-139.14961543899992, 60.16118682900007],
              [-139.18323095699995, 60.10015696300009],
              [-139.18214575299996, 60.07338857000012],
              [-139.11230505499987, 60.03137563100002],
              [-139.06020662199992, 60.000058906000035],
              [-139.05161108499988, 59.99489207],
              [-139.0037587079999, 59.977218730000075],
              [-138.84242488699994, 59.937686259000046],
              [-138.74258601899993, 59.91319163100009],
              [-138.7048880619999, 59.89846384700009],
              [-138.6971882739999, 59.893709616000095],
              [-138.6920981449999, 59.88688832600006],
              [-138.65434851099997, 59.80549794500003],
              [-138.63745031799994, 59.7840522260001],
              [-138.59920975799986, 59.753821513],
              [-138.48888057499988, 59.696357321000065],
              [-138.36361690299995, 59.631141663000065],
              [-138.2195430099999, 59.556004130000034],
              [-138.06761429899993, 59.476990865000076],
              [-137.91056962199985, 59.39518707300006],
              [-137.7583050139999, 59.31591542600002],
              [-137.61136307799987, 59.239330954000096],
              [-137.5941806649999, 59.22527496400009],
              [-137.5820883789999, 59.20656809600008],
              [-137.5492996839999, 59.13453114900004],
              [-137.5210068369999, 59.07236440100003],
              [-137.48439408499988, 58.99190419600008],
              [-137.5077518319999, 58.93996938100007],
              [-137.50875952199988, 58.91490631200004],
              [-137.48687455299984, 58.900075175000026],
              [-137.45346573899985, 58.89914499900006],
              [-137.42310583599993, 58.90772328700011],
              [-137.33809810499991, 58.955472311000065],
              [-137.28189998399984, 58.98714996400007],
              [-137.17234594799987, 59.02714752300004],
              [-137.06236731699994, 59.06757233300003],
              [-137.0471085279999, 59.07330963800008],
              [-136.94228247099997, 59.11107004800006],
              [-136.8408157969999, 59.14817372700004],
              [-136.78549617599987, 59.157217102000075],
              [-136.6719113779999, 59.15080922500006],
              [-136.61349117099994, 59.15421987000006],
              [-136.56948868899988, 59.17215159100006],
              [-136.48479101599986, 59.253800355000024],
              [-136.48355078199992, 59.257469381000035],
              [-136.4665492359999, 59.28780344700006],
              [-136.46709183799996, 59.38449005200003],
              [-136.46755692599987, 59.46164296500011],
              [-136.41595800799988, 59.452237854000046],
              [-136.3668395599999, 59.44955068000003],
              [-136.3199948729999, 59.459059143],
              [-136.27503637799987, 59.48644765300004],
              [-136.24472814999996, 59.52820221000009],
              [-136.25847408199988, 59.556107483000076],
              [-136.2993501389999, 59.5757445280001],
              [-136.35032893999994, 59.59238433900002],
              [-136.2584999189999, 59.621581523000074],
              [-136.14540604699994, 59.63682607],
              [-136.02686031099984, 59.652845765000066],
              [-135.92381750599995, 59.66674672500004],
              [-135.8309549559999, 59.69325673400003],
              [-135.64125077399987, 59.74736196000005],
              [-135.48275915599993, 59.79247548400009],
              [-135.46513749299993, 59.789684957000034],
              [-135.4043918459999, 59.753304749000065],
              [-135.3457907719999, 59.73103220700001],
              [-135.25987870299994, 59.69821767200007],
              [-135.22189652499992, 59.675273336000046],
              [-135.1920275479999, 59.6471096800001],
              [-135.15779191099992, 59.62328684500004],
              [-135.1066839199999, 59.61315826500008],
              [-135.0878736989999, 59.606543681000076],
              [-135.03294165099987, 59.57310902900009],
              [-135.01852392599997, 59.559363099000066],
              [-135.01619848699994, 59.54344675700004],
              [-135.01947993999994, 59.49316558900007],
              [-135.02325231999995, 59.47714589500002],
              [-135.03748917699994, 59.46159128900008],
              [-135.0785977789999, 59.43833689399999],
              [-135.09575435399987, 59.418854879],
              [-134.99325415099992, 59.38190623000004],
              [-135.00482967199994, 59.36712677000013],
              [-135.01444148899998, 59.35152048800008],
              [-135.01619848699994, 59.33617258700012],
              [-134.9799733079999, 59.297415263000076],
              [-134.9578299559999, 59.2809821580001],
              [-134.93243098999997, 59.27064687200003],
              [-134.83946508799994, 59.258141174000016],
              [-134.74345027799993, 59.24511871400007],
              [-134.70551977599993, 59.2401061],
              [-134.69208390299988, 59.235248515000094],
              [-134.6828596609999, 59.22300120100006],
              [-134.67143916899997, 59.19375234000002],
              [-134.66038041299996, 59.18129832000004],
              [-134.610771038, 59.14455637600004],
              [-134.5827882489999, 59.12884674100009],
              [-134.5567174899999, 59.12305898000001],
              [-134.50907181899993, 59.12280059900003],
              [-134.47757503299988, 59.11494578100009],
              [-134.4510133469999, 59.09789255800008],
              [-134.39801916599987, 59.051952210000096],
              [-134.38716711499993, 59.0368626920001],
              [-134.38559098399992, 59.01882761600008],
              [-134.39938859199995, 58.97495432600006],
              [-134.34342301499993, 58.96885650600002],
              [-134.32965124499992, 58.96301707000002],
              [-134.3200394289999, 58.952681784000035],
              [-134.32314001499992, 58.949167786000075],
              [-134.3303230389999, 58.94534373000003],
              [-134.33303605199993, 58.934129945000066],
              [-134.3274033209999, 58.91645660400006],
              [-134.31693884399994, 58.903795878000025],
              [-134.22219010499992, 58.84271433500005],
              [-134.10883785099992, 58.80824615500008],
              [-133.98310909099996, 58.76990224200004],
              [-133.87122961499983, 58.73589915000012],
              [-133.83112870399995, 58.71801910400005],
              [-133.79640214099993, 58.69342112300008],
              [-133.70007727099994, 58.59937001600012],
              [-133.6262833259999, 58.546401673000034],
              [-133.54706335499986, 58.50557729100005],
              [-133.46308915199984, 58.462220764000065],
              [-133.3922407639999, 58.40387807200001],
              [-133.4301195889999, 58.37209706700007],
              [-133.4150300699999, 58.33054921500009],
              [-133.3745674239999, 58.290965068000034],
              [-133.25726192299993, 58.21029815700011],
              [-133.16558793199994, 58.14730458600009],
              [-133.14212683199995, 58.12058787000002],
              [-133.0948428959999, 58.033099670000055],
              [-133.07515417499994, 58.00788157200002],
              [-132.99335038299992, 57.94191660600008],
              [-132.91715348399993, 57.880499166],
              [-132.83211991399992, 57.791564026000046],
              [-132.70944006399986, 57.66330312200007],
              [-132.62905737299994, 57.57927724200006],
              [-132.55244706299993, 57.49907542000007],
              [-132.45573461999993, 57.42099233000006],
              [-132.36230362999996, 57.34569976799999],
              [-132.3046844079999, 57.28035491900003],
              [-132.23099381599988, 57.19681996700005],
              [-132.2763657229999, 57.14889007600003],
              [-132.34121964599993, 57.080392965],
              [-132.1622899989999, 57.050317281000034],
              [-132.03185868399987, 57.02840647400008],
              [-132.10738378999991, 56.858752747],
              [-131.87155839099992, 56.79345957500006],
              [-131.86587398399988, 56.785708110000044],
              [-131.87241105199985, 56.77296986900008],
              [-131.88261714799992, 56.759146424000036],
              [-131.88796565799987, 56.74795847600008],
              [-131.88602779199994, 56.73705474900002],
              [-131.8807051189999, 56.7288381960001],
              [-131.86478877799988, 56.71349029600002],
              [-131.83897640099985, 56.68227773100004],
              [-131.83042395099994, 56.66475942000007],
              [-131.8265740559999, 56.64460561100002],
              [-131.8321034349999, 56.603367818],
              [-131.82559220399992, 56.59334259100008],
              [-131.79910803299992, 56.58765818300013],
              [-131.69229284699992, 56.585074361000025],
              [-131.5858910729999, 56.59504791300013],
              [-131.56036291499996, 56.59406606100008],
              [-131.53643672799987, 56.585229391000055],
              [-131.4916590989999, 56.56016632100007],
              [-131.34569901599994, 56.503270569],
              [-131.21560359799992, 56.452550151000125],
              [-131.10054602099993, 56.40766916900013],
              [-131.01693355399993, 56.387050273000014],
              [-130.8390891119999, 56.372451681000044],
              [-130.7603342299999, 56.34519236300004],
              [-130.64576757899997, 56.26194163100003],
              [-130.60225602299994, 56.24705881800007],
              [-130.49551835199992, 56.232434388000016],
              [-130.47228979599993, 56.22488962800007],
              [-130.45805293899986, 56.210652771000085],
              [-130.42792557799987, 56.143964335000064],
              [-130.41815873299993, 56.12970164000011],
              [-130.40397355199985, 56.12189849900007],
              [-130.29031123999988, 56.10096954400008],
              [-130.24315649499997, 56.092391256000056],
              [-130.2112462979999, 56.08996246400001],
              [-130.11675594199994, 56.105646261000075],
              [-130.09432836999991, 56.10148630800005],
              [-130.07153906299993, 56.08412302700002],
              [-130.0393188079999, 56.04552073200004],
              [-130.02663224299994, 56.024100851000114],
              [-130.01900996999987, 56.00221588200007],
              [-130.01469498799992, 55.963251852000084],
              [-130.0167878829999, 55.91891347300002],
              [-130.0196184442999, 55.907951850414136],
              [-130.02281653599994, 55.90135325700004],
              [-130.04938717399995, 55.87140534100007],
              [-130.10472571499992, 55.82526276200008],
              [-130.13662675699993, 55.80646393400008],
              [-130.14883378799993, 55.795355536000045],
              [-130.16348222599993, 55.771144924000055],
              [-130.1673070949999, 55.76626211100006],
              [-130.17080644399994, 55.759833075000074],
              [-130.1736547519999, 55.74949778900003],
              [-130.17080644399994, 55.74095286700003],
              [-130.16380774599992, 55.73456452000005],
              [-130.16006425699993, 55.72711823100008],
              [-130.16738847599993, 55.71539948100008],
              [-130.15591386599993, 55.70014069200005],
              [-130.1428930329999, 55.689520575000074],
              [-130.1318253249999, 55.67658112200007],
              [-130.1264542309999, 55.653998114000046],
              [-130.12857011599993, 55.636419989000046],
              [-130.13512122299994, 55.619126695000034],
              [-130.1531469389999, 55.58510976800005],
              [-130.1486710279999, 55.578192450000074],
              [-130.14688066299993, 55.56932200700004],
              [-130.14696204299992, 55.54718659100007],
              [-130.11217200399994, 55.50934479400007],
              [-130.10167395699995, 55.48114655200004],
              [-130.09508216099994, 55.47211334800005],
              [-130.0654190749999, 55.44611237200007],
              [-130.05752519399994, 55.434881903000075],
              [-130.0525610019999, 55.41400788000004],
              [-130.05431067599994, 55.36664459800005],
              [-130.0501195949999, 55.34544505400004],
              [-130.0392960279999, 55.33075592700004],
              [-129.9892471999999, 55.28400299700007],
              [-130.0312393869999, 55.26434967700004],
              [-130.05003821499992, 55.25287506700005],
              [-130.06749426999994, 55.23899974200003],
              [-130.07823645699995, 55.23379140800006],
              [-130.10049394399994, 55.23029205900008],
              [-130.10472571499992, 55.22565338700008],
              [-130.1057022779999, 55.21112702000005],
              [-130.10912024599992, 55.20075104400007],
              [-130.11579342399995, 55.19159577000005],
              [-130.1264542309999, 55.180975653000075],
              [-130.15196692599994, 55.163275458000044],
              [-130.1599828769999, 55.15371328300006],
              [-130.16759192599994, 55.12958405200004],
              [-130.17369544199994, 55.11774323100008],
              [-130.2002660799999, 55.10415273600006],
              [-130.21178137899994, 55.08413320500006],
              [-130.22887122299994, 55.043850002000056],
              [-130.23867753799993, 55.034409898000035],
              [-130.26134192599994, 55.02289459800005],
              [-130.2698461579999, 55.01654694200005],
              [-130.2757055329999, 55.00698476800005],
              [-130.28636633999992, 54.98322174700007],
              [-130.29434160099993, 54.971869208000044],
              [-130.32656816299993, 54.95209381700005],
              [-130.33556067599994, 54.938706773000035],
              [-130.36538652299993, 54.90729401200008],
              [-130.38524329299992, 54.896551825000074],
              [-130.43081620999993, 54.88125234600005],
              [-130.48875891799992, 54.844183661000045],
              [-130.5803116529999, 54.80638255400004],
              [-130.60460364499994, 54.80215078300006],
              [-130.6025284499999, 54.814520575000074],
              [-130.5684301419999, 54.841498114000046],
              [-130.56094316299993, 54.85138580900008],
              [-130.5672094389999, 54.854396877000056],
              [-130.57827714799993, 54.853583075000074],
              [-130.58511308499993, 54.851996161000045],
              [-130.6065160799999, 54.83860911700003],
              [-130.6714574859999, 54.77204010600008],
              [-130.68077551999994, 54.76544830900008],
              [-130.69127356699994, 54.76264069200005],
              [-130.70372473899994, 54.76544830900008],
              [-130.71841386599993, 54.77301666900007],
              [-130.72887122299994, 54.78412506700005],
              [-130.7285050119999, 54.79743073100008],
              [-130.71328691299993, 54.80377838700008],
              [-130.69078528599994, 54.80678945500006],
              [-130.67784583199995, 54.814520575000074],
              [-130.69127356699994, 54.83494700700004],
              [-130.7051488919999, 54.850490627000056],
              [-130.7158096999999, 54.86823151200008],
              [-130.72354081899994, 54.88739655200004],
              [-130.7285050119999, 54.90729401200008],
              [-130.7288305329999, 54.917181708000044],
              [-130.7268774079999, 54.938788153000075],
              [-130.7285050119999, 54.94818756700005],
              [-130.73412024599992, 54.956732489000046],
              [-130.74356035099993, 54.96629466400003],
              [-130.75251217399995, 54.96938711100006],
              [-130.75645911399994, 54.95783112200007],
              [-130.75438391799992, 54.89276764500005],
              [-130.7502335279999, 54.87250397300005],
              [-130.73875891799992, 54.853949286000045],
              [-130.73403886599993, 54.843085028000075],
              [-130.73595130099994, 54.83152903900003],
              [-130.7451879549999, 54.82172272300005],
              [-130.7560929029999, 54.819525458000044],
              [-130.76720130099994, 54.82339101800005],
              [-130.7769262359999, 54.83152903900003],
              [-130.7888891269999, 54.803941148000035],
              [-130.8066300119999, 54.77875397300005],
              [-130.83189856699994, 54.76536692900004],
              [-130.86632239499994, 54.77317942900004],
              [-130.91832434799994, 54.80292389500005],
              [-130.93423417899993, 54.82444896000004],
              [-130.9278051419999, 54.851996161000045],
              [-130.93199622299994, 54.85342031500005],
              [-130.94200598899994, 54.85887278900003],
              [-130.9334203769999, 54.880194403000075],
              [-130.94176184799994, 54.89533112200007],
              [-130.95518958199995, 54.909369208000044],
              [-130.9619034499999, 54.927720445000034],
              [-130.9412328769999, 54.92536041900007],
              [-130.9326879549999, 54.94017161700003],
              [-130.9396866529999, 54.95892975500004],
              [-130.96532141799992, 54.968085028000075],
              [-130.97402910099993, 54.981756903000075],
              [-130.9822485019999, 54.991115627000056],
              [-130.9929093089999, 54.995428778000075],
              [-131.00938880099994, 54.99827708500004],
              [-131.00967363199993, 55.00535716400003],
              [-130.99665279899995, 55.02338288000004],
              [-130.98696855399993, 55.04352448100008],
              [-130.9710180329999, 55.06122467700004],
              [-130.94969641799992, 55.07379791900007],
              [-130.90123450399994, 55.08344147300005],
              [-130.85415605399993, 55.10309479400007],
              [-130.83214270699995, 55.10529205900008],
              [-130.82115637899994, 55.10024648600006],
              [-130.8173721999999, 55.09235260600008],
              [-130.81566321499992, 55.08421458500004],
              [-130.81110592399995, 55.07859935100004],
              [-130.7995499339999, 55.07684967700004],
              [-130.76333574099993, 55.07868073100008],
              [-130.75332597599993, 55.08197663000004],
              [-130.7442113919999, 55.08315664300005],
              [-130.7315160799999, 55.07982005400004],
              [-130.72032630099994, 55.08100006700005],
              [-130.7124731109999, 55.106634833000044],
              [-130.7050675119999, 55.118841864000046],
              [-130.6875707669999, 55.14008209800005],
              [-130.64883378799993, 55.17251211100006],
              [-130.56602942599994, 55.22333405200004],
              [-130.4734594389999, 55.31012604400007],
              [-130.46157792899993, 55.33185455900008],
              [-130.48013261599993, 55.33075592700004],
              [-130.4925024079999, 55.323472398000035],
              [-130.50230872299994, 55.31525299700007],
              [-130.52354895699995, 55.30735911700003],
              [-130.5525610019999, 55.28774648600006],
              [-130.5612686839999, 55.28025950700004],
              [-130.59414628799993, 55.22565338700008],
              [-130.6154679029999, 55.19953034100007],
              [-130.66844641799992, 55.18040599200003],
              [-130.69420325399994, 55.16120026200008],
              [-130.75991777299993, 55.096991278000075],
              [-130.77428137899994, 55.09251536700003],
              [-130.79116777299993, 55.09906647300005],
              [-130.79751542899993, 55.10846588700008],
              [-130.8054093089999, 55.13629791900007],
              [-130.81110592399995, 55.14687734600005],
              [-130.8427628249999, 55.13727448100008],
              [-130.85204016799992, 55.13320547100005],
              [-130.88316809799994, 55.10895416900007],
              [-130.8902074859999, 55.10529205900008],
              [-130.97081458199995, 55.08543528900003],
              [-130.99665279899995, 55.08539459800005],
              [-131.01573645699995, 55.09357330900008],
              [-131.03823808499993, 55.10838450700004],
              [-131.05703691299993, 55.126288153000075],
              [-131.06493079299992, 55.143459377000056],
              [-131.06529700399994, 55.18622467700004],
              [-131.0576065749999, 55.19867584800005],
              [-131.0019425119999, 55.24013906500005],
              [-130.9798070949999, 55.25136953300006],
              [-130.9584854809999, 55.25608958500004],
              [-130.95677649599992, 55.26048411700003],
              [-130.9383031889999, 55.287095445000034],
              [-130.92471269399994, 55.29401276200008],
              [-130.9102270169999, 55.294989325000074],
              [-130.87999426999994, 55.290269273000035],
              [-130.6321508449999, 55.291001695000034],
              [-130.62218176999994, 55.29311758000006],
              [-130.61245683499993, 55.29706452000005],
              [-130.65680904899995, 55.315741278000075],
              [-130.6694229809999, 55.32851797100005],
              [-130.64659583199995, 55.33860911700003],
              [-130.65640214799993, 55.35228099200003],
              [-130.67039954299992, 55.34992096600007],
              [-130.7123917309999, 55.32086823100008],
              [-130.72630774599992, 55.31464264500005],
              [-130.83385169199994, 55.304388739000046],
              [-130.86188717399995, 55.312160549000055],
              [-130.87315833199995, 55.34202708500004],
              [-130.8867895169999, 55.451605536000045],
              [-130.87352454299992, 55.53412506700005],
              [-130.86632239499994, 55.55027903900003],
              [-130.87315833199995, 55.62295156500005],
              [-130.87852942599994, 55.636379299000055],
              [-130.9021703769999, 55.665716864000046],
              [-130.9072973299999, 55.68187083500004],
              [-130.90404212099992, 55.69025299700007],
              [-130.8902074859999, 55.700384833000044],
              [-130.8867895169999, 55.70856354400007],
              [-130.88988196499992, 55.715277411000045],
              [-130.90404212099992, 55.72748444200005],
              [-130.91466223899994, 55.74689362200007],
              [-130.9499405589999, 55.771144924000055],
              [-130.9619034499999, 55.78302643400008],
              [-130.92813066299993, 55.80023834800005],
              [-130.92039954299992, 55.81045156500005],
              [-130.9345596999999, 55.818426825000074],
              [-130.94066321499992, 55.81679922100005],
              [-130.9687393869999, 55.804754950000074],
              [-130.9834692049999, 55.80565013200004],
              [-130.9964086579999, 55.810532945000034],
              [-131.00670325399994, 55.81586334800005],
              [-131.01341712099992, 55.818426825000074],
              [-131.02236894399994, 55.82672760600008],
              [-131.0615128249999, 55.87677643400008],
              [-131.0776261059999, 55.88849518400008],
              [-131.1338598299999, 55.92084381700005],
              [-131.13141842399995, 55.92454661700003],
              [-131.12637285099993, 55.93451569200005],
              [-131.1463110019999, 55.934800523000035],
              [-131.16519120999993, 55.94057851800005],
              [-131.1768285799999, 55.95197174700007],
              [-131.1747940749999, 55.96930573100008],
              [-131.19640051999994, 55.97142161700003],
              [-131.18492591099994, 55.98672109600005],
              [-131.14004472599993, 56.01703522300005],
              [-131.0444229809999, 56.05805084800005],
              [-131.05284583199995, 56.05731842700004],
              [-131.07860266799992, 56.05805084800005],
              [-131.06802324099993, 56.071926174000055],
              [-131.00967363199993, 56.112616278000075],
              [-131.0633031889999, 56.09593333500004],
              [-131.08568274599992, 56.08616771000004],
              [-131.1065160799999, 56.07168203300006],
              [-131.1249893869999, 56.050441799000055],
              [-131.13609778599994, 56.04132721600007],
              [-131.1655167309999, 56.033270575000074],
              [-131.19225012899994, 56.014553127000056],
              [-131.29027258999992, 55.988348700000074],
              [-131.30333411399994, 55.981675523000035],
              [-131.3147680329999, 55.972642320000034],
              [-131.3418676419999, 55.960923570000034],
              [-131.37120520699995, 55.96857330900008],
              [-131.3972875639999, 55.987616278000075],
              [-131.4143774079999, 56.010199286000045],
              [-131.4330948559999, 55.99754466400003],
              [-131.4589737619999, 55.98468659100007],
              [-131.48302161399994, 55.97943756700005],
              [-131.4963272779999, 55.98973216400003],
              [-131.56411699099993, 55.94700755400004],
              [-131.5894262359999, 55.94135163000004],
              [-131.6187231109999, 55.942694403000075],
              [-131.62730872299994, 55.94135163000004],
              [-131.63149980399993, 55.93829987200007],
              [-131.6345922519999, 55.93398672100005],
              [-131.6381729809999, 55.92999909100007],
              [-131.6553442049999, 55.924994208000044],
              [-131.6804093089999, 55.91046784100007],
              [-131.7033585279999, 55.904364325000074],
              [-131.7254125639999, 55.89109935100004],
              [-131.7359106109999, 55.886704820000034],
              [-131.7537328769999, 55.88507721600007],
              [-131.7861221999999, 55.88739655200004],
              [-131.80479895699995, 55.886704820000034],
              [-131.8173721999999, 55.88300202000005],
              [-131.84146074099993, 55.870306708000044],
              [-131.85317949099993, 55.86627838700008],
              [-131.8693741529999, 55.86538320500006],
              [-131.88536536399994, 55.86627838700008],
              [-131.9006241529999, 55.86546458500004],
              [-131.91466223899994, 55.859442450000074],
              [-131.8932999339999, 55.85537344000005],
              [-131.82530676999994, 55.83148834800005],
              [-131.77794348899994, 55.825384833000044],
              [-131.7658585279999, 55.81688060100004],
              [-131.76382402299993, 55.79734935100004],
              [-131.7742406889999, 55.77049388200004],
              [-131.7827856109999, 55.753892320000034],
              [-131.7905167309999, 55.74274323100008],
              [-131.8084203769999, 55.72947825700004],
              [-131.8252660799999, 55.725490627000056],
              [-131.86685136599993, 55.72907135600008],
              [-131.8321020169999, 55.696966864000046],
              [-131.8277074859999, 55.66787344000005],
              [-131.8479711579999, 55.641913153000075],
              [-131.88731848899994, 55.619208075000074],
              [-131.88463294199994, 55.61367422100005],
              [-131.88243567599994, 55.60419342700004],
              [-131.88052324099993, 55.59870026200008],
              [-132.00401770699995, 55.667629299000055],
              [-131.99474036399994, 55.65704987200007],
              [-131.96849524599992, 55.63349030200004],
              [-131.96304277299993, 55.62295156500005],
              [-131.95348059799994, 55.61151764500005],
              [-131.9362686839999, 55.598089911000045],
              [-131.92894446499992, 55.58930084800005],
              [-131.9488012359999, 55.59194570500006],
              [-131.9488012359999, 55.58510976800005],
              [-131.9346410799999, 55.57697174700007],
              [-131.9260147779999, 55.56362539300005],
              [-131.92369544199994, 55.54726797100005],
              [-131.92833411399994, 55.530462958000044],
              [-131.93407141799992, 55.526597398000035],
              [-131.94326738199993, 55.52338288000004],
              [-131.9518936839999, 55.517564195000034],
              [-131.95563717399995, 55.50625234600005],
              [-131.96141516799992, 55.50104401200008],
              [-131.9744360019999, 55.50482819200005],
              [-131.99657141799992, 55.516791083000044],
              [-132.13463294199994, 55.56517161700003],
              [-132.17162024599992, 55.58852773600006],
              [-132.18529212099992, 55.61562734600005],
              [-132.2119034499999, 55.69806549700007],
              [-132.2265518869999, 55.71539948100008],
              [-132.2444555329999, 55.72296784100007],
              [-132.2615453769999, 55.73965078300006],
              [-132.26618404899995, 55.756293036000045],
              [-132.24673417899993, 55.76386139500005],
              [-132.2273656889999, 55.75775788000004],
              [-132.18871008999992, 55.73029205900008],
              [-132.16787675699993, 55.72284577000005],
              [-132.17735755099994, 55.75177643400008],
              [-132.18219967399995, 55.77684153900003],
              [-132.17686926999994, 55.79486725500004],
              [-132.16885331899994, 55.80231354400007],
              [-132.1406143869999, 55.804754950000074],
              [-132.07359778599994, 55.802801825000074],
              [-132.0586645169999, 55.804754950000074],
              [-132.0462133449999, 55.817287502000056],
              [-132.05394446499992, 55.82831452000005],
              [-132.0860082669999, 55.845770575000074],
              [-132.07017981699994, 55.86286041900007],
              [-132.0496313139999, 55.87836334800005],
              [-132.03604081899994, 55.893784898000035],
              [-132.0413305329999, 55.91095612200007],
              [-132.05630449099993, 55.93036530200004],
              [-132.0568741529999, 55.944525458000044],
              [-132.04360917899993, 55.95465729400007],
              [-132.0170792309999, 55.96185944200005],
              [-131.96837317599994, 55.958685614000046],
              [-131.95563717399995, 55.96185944200005],
              [-131.94981848899994, 55.97211334800005],
              [-131.95372473899994, 55.99282461100006],
              [-131.94505774599992, 55.99656810100004],
              [-131.94351152299993, 56.00690338700008],
              [-131.96304277299993, 56.07168203300006],
              [-131.96304277299993, 56.15737539300005],
              [-131.95030676999994, 56.16669342700004],
              [-131.8887426419999, 56.18382396000004],
              [-131.8137914699999, 56.19599030200004],
              [-131.69839433499993, 56.19623444200005],
              [-131.59902910099993, 56.17865631700005],
              [-131.57949785099993, 56.17910390800006],
              [-131.5584203769999, 56.188381252000056],
              [-131.5292862619999, 56.21401601800005],
              [-131.51341712099992, 56.22207265800006],
              [-131.48949133999992, 56.22247955900008],
              [-131.51333574099993, 56.22931549700007],
              [-131.5378311839999, 56.22540924700007],
              [-131.58633378799993, 56.20888906500005],
              [-131.61384029899995, 56.205145575000074],
              [-131.63792883999992, 56.206366278000075],
              [-131.68871008999992, 56.21629466400003],
              [-131.87682044199994, 56.223089911000045],
              [-131.90782630099994, 56.23273346600007],
              [-131.95933997299994, 56.29450104400007],
              [-131.96524003799993, 56.31077708500004],
              [-131.97130286399994, 56.35643138200004],
              [-131.98013261599993, 56.36591217700004],
              [-132.0060929029999, 56.367254950000074],
              [-132.06065833199995, 56.38100820500006],
              [-132.07701575399994, 56.38190338700008],
              [-132.08901933499993, 56.37677643400008],
              [-132.10509192599994, 56.37372467700004],
              [-132.14378821499992, 56.388739325000074],
              [-132.15489661399994, 56.380194403000075],
              [-132.16104081899994, 56.380194403000075],
              [-132.18529212099992, 56.42869700700004],
              [-132.18838456899994, 56.45184967700004],
              [-132.20327714799993, 56.47125885600008],
              [-132.2361547519999, 56.48309967700004],
              [-132.2840063139999, 56.493475653000075],
              [-132.28941809799994, 56.498480536000045],
              [-132.33714758999992, 56.52374909100007],
              [-132.34487870999993, 56.528998114000046],
              [-132.34972083199995, 56.53693268400008],
              [-132.35289466099994, 56.552069403000075],
              [-132.35020911399994, 56.579413153000075],
              [-132.33779863199993, 56.60179271000004],
              [-132.30504309799994, 56.64020416900007],
              [-132.32982337099992, 56.63914622600004],
              [-132.37169348899994, 56.624212958000044],
              [-132.44741777299993, 56.60716380400004],
              [-132.4768774079999, 56.60447825700004],
              [-132.52000891799992, 56.62767161700003],
              [-132.54019120999993, 56.63149648600006],
              [-132.55003821499992, 56.63898346600007],
              [-132.53844153599994, 56.661322333000044],
              [-132.52196204299992, 56.67495351800005],
              [-132.50332597599993, 56.67837148600006],
              [-132.4565323559999, 56.674994208000044],
              [-132.4687393869999, 56.69188060100004],
              [-132.4872940749999, 56.69867584800005],
              [-132.50902258999992, 56.70209381700005],
              [-132.53099524599992, 56.70856354400007],
              [-132.4794815749999, 56.74282461100006],
              [-132.4627172519999, 56.75690338700008],
              [-132.46263587099992, 56.764837958000044],
              [-132.41490637899994, 56.784857489000046],
              [-132.41222083199995, 56.792303778000075],
              [-132.41380774599992, 56.80125560100004],
              [-132.41246497299994, 56.80890534100007],
              [-132.40094967399995, 56.812201239000046],
              [-132.37930253799993, 56.81232330900008],
              [-132.36949622299994, 56.814113674000055],
              [-132.3596899079999, 56.818426825000074],
              [-132.3784073559999, 56.82648346600007],
              [-132.3986710279999, 56.82489655200004],
              [-132.4182022779999, 56.816839911000045],
              [-132.43480383999992, 56.80536530200004],
              [-132.43272864499994, 56.79352448100008],
              [-132.4529516269999, 56.78803131700005],
              [-132.4778539699999, 56.78510163000004],
              [-132.4900610019999, 56.78115469000005],
              [-132.49718176999994, 56.76129791900007],
              [-132.51480058499993, 56.75543854400007],
              [-132.5370987619999, 56.75812409100007],
              [-132.67320716099994, 56.802801825000074],
              [-132.76138261599993, 56.845770575000074],
              [-132.77464758999992, 56.85651276200008],
              [-132.77822831899994, 56.86204661700003],
              [-132.78262285099993, 56.87523021000004],
              [-132.78482011599993, 56.87982819200005],
              [-132.79092363199993, 56.88544342700004],
              [-132.8447159499999, 56.91315338700008],
              [-132.85655676999994, 56.91453685100004],
              [-132.8604223299999, 56.918850002000056],
              [-132.85952714799993, 56.93764883000006],
              [-132.86367753799993, 56.94188060100004],
              [-132.8779190749999, 56.94672272300005],
              [-132.8965551419999, 56.95807526200008],
              [-132.91319739499994, 56.97162506700005],
              [-132.92202714799993, 56.982855536000045],
              [-132.8954971999999, 56.98924388200004],
              [-132.8815811839999, 56.991115627000056],
              [-132.8674210279999, 56.98969147300005],
              [-132.85212154899995, 56.97402578300006],
              [-132.84105383999992, 56.96771881700005],
              [-132.8295792309999, 56.97296784100007],
              [-132.81175696499992, 56.97418854400007],
              [-132.7862035799999, 56.96759674700007],
              [-132.76768958199995, 56.96967194200005],
              [-132.77122962099992, 56.99713776200008],
              [-132.80980383999992, 57.05565013200004],
              [-132.80874589799993, 57.06537506700005],
              [-132.7995499339999, 57.06972890800006],
              [-132.79283606699994, 57.07904694200005],
              [-132.7908422519999, 57.08844635600008],
              [-132.79539954299992, 57.09271881700005],
              [-132.80553137899994, 57.09048086100006],
              [-132.83116614499994, 57.07843659100007],
              [-132.83946692599994, 57.07282135600008],
              [-132.86107337099992, 57.036363023000035],
              [-132.8776749339999, 57.02130768400008],
              [-132.89781653599994, 57.02753327000005],
              [-132.92162024599992, 57.04279205900008],
              [-132.94570878799993, 57.04682038000004],
              [-132.98350989499994, 57.044907945000034],
              [-132.99380449099993, 57.047756252000056],
              [-133.04238847599993, 57.069240627000056],
              [-133.0664770169999, 57.07672760600008],
              [-133.07970130099994, 57.08274974200003],
              [-133.09300696499992, 57.08649323100008],
              [-133.1126195949999, 57.088324286000045],
              [-133.1319067049999, 57.08738841400003],
              [-133.14419511599993, 57.08274974200003],
              [-133.14976966099994, 57.08148834800005],
              [-133.15786699099993, 57.08295319200005],
              [-133.16519120999993, 57.086004950000074],
              [-133.16844641799992, 57.08958567900004],
              [-133.1663305329999, 57.09682851800005],
              [-133.1616918609999, 57.10187409100007],
              [-133.15477454299992, 57.10639069200005],
              [-133.15050208199995, 57.116115627000056],
              [-133.1446020169999, 57.12250397300005],
              [-133.14199785099993, 57.12958405200004],
              [-133.1479386059999, 57.14109935100004],
              [-133.1210831369999, 57.14427317900004],
              [-133.1363012359999, 57.16107819200005],
              [-133.1675512359999, 57.169623114000046],
              [-133.18887285099993, 57.14793528900003],
              [-133.1752823559999, 57.14793528900003],
              [-133.1752823559999, 57.14109935100004],
              [-133.21149654899995, 57.14199453300006],
              [-133.22036699099993, 57.147650458000044],
              [-133.20938066299993, 57.161037502000056],
              [-133.2166235019999, 57.17096588700008],
              [-133.22594153599994, 57.174994208000044],
              [-133.23570716099994, 57.173814195000034],
              [-133.2441300119999, 57.16844310100004],
              [-133.25035559799994, 57.133693752000056],
              [-133.26646887899994, 57.11318594000005],
              [-133.2901098299999, 57.101996161000045],
              [-133.31700598899994, 57.10248444200005],
              [-133.3635961579999, 57.12836334800005],
              [-133.42357337099992, 57.14533112200007],
              [-133.44591223899994, 57.14793528900003],
              [-133.45303300699993, 57.15110911700003],
              [-133.4761449859999, 57.165228583000044],
              [-133.48688717399995, 57.16844310100004],
              [-133.5205785799999, 57.172308661000045],
              [-133.5381567049999, 57.17645905200004],
              [-133.55199133999992, 57.18146393400008],
              [-133.55199133999992, 57.18829987200007],
              [-133.5300186839999, 57.19135163000004],
              [-133.50475012899994, 57.20343659100007],
              [-133.48863684799994, 57.22089264500005],
              [-133.49400794199994, 57.23981354400007],
              [-133.50511633999992, 57.251206773000035],
              [-133.5026749339999, 57.25372955900008],
              [-133.49502519399994, 57.25617096600007],
              [-133.49058997299994, 57.26776764500005],
              [-133.4850968089999, 57.277004299000055],
              [-133.47191321499992, 57.28188711100006],
              [-133.4422094389999, 57.284491278000075],
              [-133.25479081899994, 57.28107330900008],
              [-133.18211829299992, 57.30560944200005],
              [-133.1760961579999, 57.30878327000005],
              [-133.16954505099994, 57.31590403900003],
              [-133.16222083199995, 57.31928131700005],
              [-133.10728919199994, 57.31928131700005],
              [-133.08629309799994, 57.32249583500004],
              [-133.0584203769999, 57.33185455900008],
              [-133.03766842399995, 57.34682851800005],
              [-133.0380753249999, 57.36709219000005],
              [-133.0510961579999, 57.36627838700008],
              [-133.09927324099993, 57.33930084800005],
              [-133.1206762359999, 57.33234284100007],
              [-133.1787003249999, 57.33234284100007],
              [-133.19033769399994, 57.33047109600005],
              [-133.21157792899993, 57.321926174000055],
              [-133.2237035799999, 57.31928131700005],
              [-133.24111894399994, 57.320379950000074],
              [-133.27196204299992, 57.33002350500004],
              [-133.28823808499993, 57.33234284100007],
              [-133.39146887899994, 57.335150458000044],
              [-133.4195043609999, 57.34393952000005],
              [-133.4421280589999, 57.35895416900007],
              [-133.45645097599993, 57.38076406500005],
              [-133.42080644399994, 57.39484284100007],
              [-133.40290279899995, 57.39940013200004],
              [-133.35667883999992, 57.40228913000004],
              [-133.3447973299999, 57.40542226800005],
              [-133.33975175699993, 57.411769924000055],
              [-133.3355199859999, 57.42877838700008],
              [-133.3359268869999, 57.43817780200004],
              [-133.34316972599993, 57.44220612200007],
              [-133.3517960279999, 57.44000885600008],
              [-133.36851966099994, 57.43065013200004],
              [-133.3782445949999, 57.42853424700007],
              [-133.40392005099994, 57.43317291900007],
              [-133.41445878799993, 57.432806708000044],
              [-133.42540442599994, 57.425116278000075],
              [-133.43740800699993, 57.423529364000046],
              [-133.45421301999994, 57.43178945500006],
              [-133.4702856109999, 57.44358958500004],
              [-133.50039628799993, 57.47601959800005],
              [-133.50454667899993, 57.48680247600004],
              [-133.5048721999999, 57.503607489000046],
              [-133.49742591099994, 57.53156159100007],
              [-133.49254309799994, 57.53864166900007],
              [-133.47691809799994, 57.552069403000075],
              [-133.4390356109999, 57.56948476800005],
              [-133.34886633999992, 57.57591380400004],
              [-133.31309973899994, 57.592962958000044],
              [-133.33385169199994, 57.59601471600007],
              [-133.41612708199995, 57.59528229400007],
              [-133.43907630099994, 57.589544989000046],
              [-133.46084550699993, 57.57990143400008],
              [-133.53294837099992, 57.57245514500005],
              [-133.59142005099994, 57.57461172100005],
              [-133.60509192599994, 57.579291083000044],
              [-133.64854895699995, 57.61713288000004],
              [-133.65880286399994, 57.62091705900008],
              [-133.65807044199994, 57.63275788000004],
              [-133.64663652299993, 57.687201239000046],
              [-133.6482641269999, 57.702826239000046],
              [-133.6357315749999, 57.70815664300005],
              [-133.6221410799999, 57.71002838700008],
              [-133.59300696499992, 57.70966217700004],
              [-133.5855199859999, 57.710923570000034],
              [-133.57286536399994, 57.716050523000035],
              [-133.56631425699993, 57.716498114000046],
              [-133.56041419199994, 57.71385325700004],
              [-133.5483292309999, 57.704779364000046],
              [-133.5327042309999, 57.70001862200007],
              [-133.52281653599994, 57.69318268400008],
              [-133.50796464799993, 57.678941148000035],
              [-133.49498450399994, 57.67206452000005],
              [-133.4422094389999, 57.66811758000006],
              [-133.2104386059999, 57.58893463700008],
              [-133.16844641799992, 57.579291083000044],
              [-133.15859941299993, 57.573146877000056],
              [-133.13792883999992, 57.55560944200005],
              [-133.1309301419999, 57.552069403000075],
              [-133.1113988919999, 57.544989325000074],
              [-133.06948808499993, 57.51268138200004],
              [-133.04552161399994, 57.503607489000046],
              [-133.03429114499994, 57.50413646000004],
              [-133.0203344389999, 57.507066148000035],
              [-133.0085343089999, 57.51186758000006],
              [-133.0039770169999, 57.51788971600007],
              [-133.01211503799993, 57.52122630400004],
              [-133.0818578769999, 57.53733958500004],
              [-133.0995987619999, 57.55097077000005],
              [-133.12751217399995, 57.579291083000044],
              [-133.15542558499993, 57.59975820500006],
              [-133.1647843089999, 57.612534898000035],
              [-133.16222083199995, 57.62714264500005],
              [-133.18272864499994, 57.62376536700003],
              [-133.21226966099994, 57.62714264500005],
              [-133.23888098899994, 57.63662344000005],
              [-133.25035559799994, 57.651678778000075],
              [-133.36025956899994, 57.68235911700003],
              [-133.39769446499992, 57.709418036000045],
              [-133.41759192599994, 57.71938711100006],
              [-133.4689835279999, 57.727443752000056],
              [-133.4999893869999, 57.737616278000075],
              [-133.52892005099994, 57.75092194200005],
              [-133.54580644399994, 57.76430898600006],
              [-133.5523168609999, 57.792303778000075],
              [-133.5581762359999, 57.88963450700004],
              [-133.55199133999992, 57.91510651200008],
              [-133.5392960279999, 57.91742584800005],
              [-133.49058997299994, 57.908270575000074],
              [-133.42910722599993, 57.908270575000074],
              [-133.39854895699995, 57.903957424000055],
              [-133.34312903599994, 57.884751695000034],
              [-133.31309973899994, 57.88031647300005],
              [-133.3045141269999, 57.88178131700005],
              [-133.28844153599994, 57.88739655200004],
              [-133.2783096999999, 57.88784414300005],
              [-133.2675675119999, 57.88507721600007],
              [-133.24429277299993, 57.87612539300005],
              [-133.14248613199993, 57.854722398000035],
              [-133.1240942049999, 57.857123114000046],
              [-133.13223222599993, 57.865220445000034],
              [-133.18569902299993, 57.889553127000056],
              [-133.20628821499992, 57.89468008000006],
              [-133.55431067599994, 57.92942942900004],
              [-133.57286536399994, 57.92405833500004],
              [-133.58458411399994, 57.91083405200004],
              [-133.59300696499992, 57.88784414300005],
              [-133.5912979809999, 57.88153717700004],
              [-133.5898331369999, 57.86758047100005],
              [-133.59264075399994, 57.85789622600004],
              [-133.60387122299994, 57.86420319200005],
              [-133.61074785099993, 57.87010325700004],
              [-133.62608801999994, 57.87986888200004],
              [-133.6345922519999, 57.88784414300005],
              [-133.6401261059999, 57.86790599200003],
              [-133.6259659499999, 57.82868073100008],
              [-133.6345922519999, 57.80524323100008],
              [-133.66136633999992, 57.786444403000075],
              [-133.6863500639999, 57.790716864000046],
              [-133.7085668609999, 57.808294989000046],
              [-133.7422582669999, 57.845038153000075],
              [-133.80308997299994, 57.898504950000074],
              [-133.8084203769999, 57.90497467700004],
              [-133.81163489499994, 57.91303131700005],
              [-133.8127335279999, 57.925034898000035],
              [-133.8190811839999, 57.932806708000044],
              [-133.8611547519999, 57.956732489000046],
              [-133.80980383999992, 57.98533763200004],
              [-133.79222571499992, 57.990220445000034],
              [-133.7748917309999, 57.98883698100008],
              [-133.76406816299993, 57.98069896000004],
              [-133.7537328769999, 57.96893952000005],
              [-133.7376195949999, 57.956732489000046],
              [-133.71812903599994, 57.94635651200008],
              [-133.70181230399993, 57.94000885600008],
              [-133.6913956369999, 57.94204336100006],
              [-133.68919837099992, 57.956732489000046],
              [-133.6975805329999, 57.98997630400004],
              [-133.69204667899993, 58.001939195000034],
              [-133.66934160099993, 58.011379299000055],
              [-133.66934160099993, 58.01752350500004],
              [-133.73184160099993, 58.019517320000034],
              [-133.75548255099994, 58.03009674700007],
              [-133.7649633449999, 58.06224192900004],
              [-133.74864661399994, 58.078192450000074],
              [-133.7176000639999, 58.09784577000005],
              [-133.6982315749999, 58.11595286700003],
              [-133.71715247299994, 58.127386786000045],
              [-133.71715247299994, 58.134833075000074],
              [-133.69517981699994, 58.139105536000045],
              [-133.6850479809999, 58.14280833500004],
              [-133.67491614499994, 58.14789459800005],
              [-133.6823624339999, 58.15534088700008],
              [-133.7002660799999, 58.148504950000074],
              [-133.7581274079999, 58.134833075000074],
              [-133.7581274079999, 58.127386786000045],
              [-133.7416886059999, 58.11969635600008],
              [-133.74864661399994, 58.10610586100006],
              [-133.8101293609999, 58.04474518400008],
              [-133.81334387899994, 58.028998114000046],
              [-133.7990616529999, 58.011379299000055],
              [-133.86436926999994, 57.98696523600006],
              [-133.88467363199993, 57.984035549000055],
              [-133.90868079299992, 57.98387278900003],
              [-133.91844641799992, 57.985663153000075],
              [-133.92943274599992, 57.990220445000034],
              [-133.93407141799992, 57.99363841400003],
              [-133.93907630099994, 58.00067780200004],
              [-133.94302324099993, 58.003892320000034],
              [-133.94957434799994, 58.00608958500004],
              [-133.96495520699995, 58.009100653000075],
              [-133.97036699099993, 58.011379299000055],
              [-133.97622636599993, 58.02008698100008],
              [-133.97647050699993, 58.028998114000046],
              [-133.9780167309999, 58.03583405200004],
              [-133.98741614499994, 58.03864166900007],
              [-134.0012914699999, 58.039496161000045],
              [-134.01085364499994, 58.04287344000005],
              [-134.0164281889999, 58.049994208000044],
              [-134.01817786399994, 58.06224192900004],
              [-134.0234268869999, 58.07135651200008],
              [-134.03563391799992, 58.072333075000074],
              [-134.04946855399993, 58.07070547100005],
              [-134.05972245999993, 58.07217031500005],
              [-134.06383216099994, 58.07916901200008],
              [-134.07282467399995, 58.11318594000005],
              [-134.0574438139999, 58.111029364000046],
              [-134.04845130099994, 58.11383698100008],
              [-134.04478919199994, 58.11985911700003],
              [-134.04548092399995, 58.127386786000045],
              [-134.05142167899993, 58.13458893400008],
              [-134.07188880099994, 58.146185614000046],
              [-134.08023027299993, 58.15534088700008],
              [-134.0834854809999, 58.163763739000046],
              [-134.0859268869999, 58.17495351800005],
              [-134.08706620999993, 58.18659088700008],
              [-134.08641516799992, 58.19627513200004],
              [-134.0816137359999, 58.208197333000044],
              [-134.07481848899994, 58.214544989000046],
              [-134.0671280589999, 58.220363674000055],
              [-134.05972245999993, 58.23041413000004],
              [-134.05703691299993, 58.23997630400004],
              [-134.05801347599993, 58.24787018400008],
              [-134.0598852199999, 58.255560614000046],
              [-134.05972245999993, 58.26459381700005],
              [-134.0612686839999, 58.26821523600006],
              [-134.06493079299992, 58.273138739000046],
              [-134.0676977199999, 58.27887604400007],
              [-134.06655839799993, 58.28510163000004],
              [-134.0593969389999, 58.28864166900007],
              [-134.03184973899994, 58.28510163000004],
              [-134.01036536399994, 58.29433828300006],
              [-133.99083411399994, 58.305568752000056],
              [-133.9824112619999, 58.315619208000044],
              [-133.98253333199995, 58.32086823100008],
              [-133.98672441299993, 58.32534414300005],
              [-133.99083411399994, 58.33283112200007],
              [-134.0058487619999, 58.372381903000075],
              [-134.0099991529999, 58.392238674000055],
              [-134.00450598899994, 58.40859609600005],
              [-133.99693762899994, 58.41242096600007],
              [-133.97252356699994, 58.418036200000074],
              [-133.9629613919999, 58.42218659100007],
              [-133.95177161399994, 58.43276601800005],
              [-133.94977779899995, 58.43964264500005],
              [-133.95103919199994, 58.44635651200008],
              [-133.94985917899993, 58.456366278000075],
              [-133.92007402299993, 58.49754466400003],
              [-133.87637285099993, 58.51044342700004],
              [-133.7717992829999, 58.518459377000056],
              [-133.7717992829999, 58.524644273000035],
              [-133.88780676999994, 58.524644273000035],
              [-133.9339086579999, 58.51894765800006],
              [-133.95962480399993, 58.51264069200005],
              [-133.9766332669999, 58.50482819200005],
              [-133.9824112619999, 58.487616278000075],
              [-133.9746801419999, 58.44989655200004],
              [-133.98741614499994, 58.442694403000075],
              [-134.01016191299993, 58.43976471600007],
              [-134.0503637359999, 58.42609284100007],
              [-134.07282467399995, 58.42218659100007],
              [-134.07282467399995, 58.41478099200003],
              [-134.0518285799999, 58.40839264500005],
              [-134.0471085279999, 58.38959381700005],
              [-134.05288652299993, 58.367254950000074],
              [-134.06314042899993, 58.35024648600006],
              [-134.08096269399994, 58.33771393400008],
              [-134.1250707669999, 58.31867096600007],
              [-134.1416723299999, 58.305568752000056],
              [-134.14712480399993, 58.28497955900008],
              [-134.13174394399994, 58.273138739000046],
              [-134.11107337099992, 58.26312897300005],
              [-134.10069739499994, 58.24778880400004],
              [-134.10435950399994, 58.239488023000035],
              [-134.1128637359999, 58.232082424000055],
              [-134.14492753799993, 58.20990631700005],
              [-134.15786699099993, 58.204291083000044],
              [-134.17223059799994, 58.202337958000044],
              [-134.19009355399993, 58.203111070000034],
              [-134.24160722599993, 58.21430084800005],
              [-134.44107011599993, 58.321519273000035],
              [-134.4604386059999, 58.326605536000045],
              [-134.47130286399994, 58.33087799700007],
              [-134.4898168609999, 58.349676825000074],
              [-134.49795488199993, 58.353949286000045],
              [-134.55321204299992, 58.353949286000045],
              [-134.5691625639999, 58.35614655200004],
              [-134.59732011599993, 58.36546458500004],
              [-134.61123613199993, 58.367621161000045],
              [-134.62173417899993, 58.36395905200004],
              [-134.62584387899994, 58.356634833000044],
              [-134.6301977199999, 58.35146719000005],
              [-134.6413468089999, 58.353949286000045],
              [-134.64488684799994, 58.36229075700004],
              [-134.64769446499992, 58.37604401200008],
              [-134.65444902299993, 58.386419989000046],
              [-134.6699112619999, 58.38471100500004],
              [-134.6845596999999, 58.379339911000045],
              [-134.71886145699995, 58.374253648000035],
              [-134.73477128799993, 58.37376536700003],
              [-134.7561742829999, 58.38153717700004],
              [-134.76732337099992, 58.40033600500004],
              [-134.77159583199995, 58.42401764500005],
              [-134.77456620999993, 58.475897528000075],
              [-134.78286699099993, 58.493068752000056],
              [-134.7995499339999, 58.50299713700008],
              [-134.8269750639999, 58.510972398000035],
              [-134.8269750639999, 58.518459377000056],
              [-134.82266191299993, 58.51947663000004],
              [-134.81997636599993, 58.52094147300005],
              [-134.81753495999993, 58.522691148000035],
              [-134.81387285099993, 58.524644273000035],
              [-134.8472387359999, 58.535223700000074],
              [-134.8749893869999, 58.55312734600005],
              [-134.89757239499994, 58.57566966400003],
              [-134.93496660099993, 58.62327708500004],
              [-134.9756567049999, 58.65892161700003],
              [-134.99144446499992, 58.682928778000075],
              [-134.9607641269999, 58.66754791900007],
              [-134.9451391269999, 58.663316148000035],
              [-134.9300024079999, 58.669256903000075],
              [-134.9268285799999, 58.66486237200007],
              [-134.9206436839999, 58.66034577000005],
              [-134.91567949099993, 58.655585028000075],
              [-134.92076575399994, 58.67829010600008],
              [-134.93272864499994, 58.69794342700004],
              [-134.94054114499994, 58.716131903000075],
              [-134.9258520169999, 58.75495026200008],
              [-134.93399003799993, 58.777411200000074],
              [-134.9461156889999, 58.79975006700005],
              [-134.95042883999992, 58.82005442900004],
              [-134.96202551999994, 58.81492747600004],
              [-134.9744360019999, 58.81244538000004],
              [-134.98668372299994, 58.813706773000035],
              [-134.99819902299993, 58.82005442900004],
              [-135.00548255099994, 58.80776601800005],
              [-135.02603105399993, 58.79315827000005],
              [-135.03237870999993, 58.78534577000005],
              [-135.0301000639999, 58.77606842700004],
              [-135.02257239499994, 58.768744208000044],
              [-135.01988684799994, 58.761053778000075],
              [-135.03237870999993, 58.751166083000044],
              [-135.0283096999999, 58.74437083500004],
              [-135.02554277299993, 58.737534898000035],
              [-135.05215410099993, 58.752386786000045],
              [-135.10464433499993, 58.80951569200005],
              [-135.1436254549999, 58.83388906500005],
              [-135.14903723899994, 58.84369538000004],
              [-135.1459854809999, 58.857123114000046],
              [-135.12857011599993, 58.89520905200004],
              [-135.14565995999993, 58.90643952000005],
              [-135.15611731699994, 58.92279694200005],
              [-135.16128495999993, 58.94330475500004],
              [-135.16270911399994, 58.967230536000045],
              [-135.16690019399994, 58.99079010600008],
              [-135.17739824099993, 59.00462474200003],
              [-135.19078528599994, 59.016058661000045],
              [-135.20368404899995, 59.03237539300005],
              [-135.2066137359999, 59.04059479400007],
              [-135.2111710279999, 59.06655508000006],
              [-135.2227270169999, 59.09389883000006],
              [-135.2241918609999, 59.104681708000044],
              [-135.22960364499994, 59.125881252000056],
              [-135.27257239499994, 59.18317291900007],
              [-135.3002823559999, 59.21157461100006],
              [-135.3347061839999, 59.23891836100006],
              [-135.36180579299992, 59.270819403000075],
              [-135.36754309799994, 59.312933661000045],
              [-135.33971106699994, 59.400824286000045],
              [-135.33169511599993, 59.45156484600005],
              [-135.34829667899993, 59.47060781500005],
              [-135.35948645699995, 59.45697663000004],
              [-135.38927161399994, 59.37494538000004],
              [-135.4011124339999, 59.31989166900007],
              [-135.4143774079999, 59.30060455900008],
              [-135.43643144399994, 59.312933661000045],
              [-135.4670304029999, 59.30573151200008],
              [-135.5279027989999, 59.31972890800006],
              [-135.5537817049999, 59.31976959800005],
              [-135.53384355399993, 59.31000397300005],
              [-135.4820043609999, 59.29511139500005],
              [-135.4609268869999, 59.28217194200005],
              [-135.4302465489999, 59.25210195500006],
              [-135.42764238199993, 59.24799225500004],
              [-135.42625891799992, 59.24160390800006],
              [-135.42275956899994, 59.23786041900007],
              [-135.4151098299999, 59.234076239000046],
              [-135.3987524079999, 59.23086172100005],
              [-135.38390051999994, 59.22296784100007],
              [-135.35952714799993, 59.213771877000056],
              [-135.3545629549999, 59.20677317900004],
              [-135.35195878799993, 59.19668203300006],
              [-135.3340551419999, 59.161444403000075],
              [-135.33653723899994, 59.16278717700004],
              [-135.3393448559999, 59.15916575700004],
              [-135.34117591099994, 59.153509833000044],
              [-135.3408910799999, 59.148423570000034],
              [-135.33678137899994, 59.14398834800005],
              [-135.31725012899994, 59.13141510600008],
              [-135.31029212099992, 59.121975002000056],
              [-135.30699622299994, 59.11107005400004],
              [-135.30638587099992, 59.099269924000055],
              [-135.3073624339999, 59.08698151200008],
              [-135.31956946499992, 59.101548570000034],
              [-135.36074785099993, 59.11375560100004],
              [-135.3784073559999, 59.124212958000044],
              [-135.38662675699993, 59.13882070500006],
              [-135.3911840489999, 59.17011139500005],
              [-135.3954971999999, 59.18317291900007],
              [-135.4233292309999, 59.205064195000034],
              [-135.47044837099992, 59.225490627000056],
              [-135.51964270699995, 59.23651764500005],
              [-135.5537817049999, 59.23041413000004],
              [-135.5386449859999, 59.215277411000045],
              [-135.48485266799992, 59.18317291900007],
              [-135.4733780589999, 59.17072174700007],
              [-135.4521378249999, 59.14154694200005],
              [-135.43643144399994, 59.12799713700008],
              [-135.40196692599994, 59.11163971600007],
              [-135.3845922519999, 59.100897528000075],
              [-135.3749893869999, 59.08698151200008],
              [-135.37755286399994, 59.070013739000046],
              [-135.38560950399994, 59.053168036000045],
              [-135.38833574099993, 59.03782786700003],
              [-135.3749893869999, 59.02558014500005],
              [-135.3848363919999, 59.016058661000045],
              [-135.3875219389999, 59.006293036000045],
              [-135.38390051999994, 58.99754466400003],
              [-135.3749893869999, 58.991400458000044],
              [-135.38634192599994, 58.97516510600008],
              [-135.3858129549999, 58.954331773000035],
              [-135.3771866529999, 58.93634674700007],
              [-135.36440995999993, 58.92869700700004],
              [-135.3281957669999, 58.91974518400008],
              [-135.32095292899993, 58.915716864000046],
              [-135.32079016799992, 58.90468984600005],
              [-135.33336341099994, 58.88719310100004],
              [-135.3306371739999, 58.877834377000056],
              [-135.2959692049999, 58.835150458000044],
              [-135.2310277989999, 58.77167389500005],
              [-135.2421768869999, 58.74787018400008],
              [-135.24058997299994, 58.730169989000046],
              [-135.2299698559999, 58.71523672100005],
              [-135.16844641799992, 58.645738023000035],
              [-135.16270911399994, 58.63450755400004],
              [-135.1811417309999, 58.62449778900003],
              [-135.20872962099992, 58.62051015800006],
              [-135.22618567599994, 58.61229075700004],
              [-135.21422278599994, 58.58978913000004],
              [-135.16844641799992, 58.54450104400007],
              [-135.15290279899995, 58.51976146000004],
              [-135.1454971999999, 58.51536692900004],
              [-135.14224199099993, 58.510972398000035],
              [-135.1416723299999, 58.50633372600004],
              [-135.14317786399994, 58.49555084800005],
              [-135.14224199099993, 58.491115627000056],
              [-135.13638261599993, 58.483587958000044],
              [-135.11119544199994, 58.45978424700007],
              [-135.0996801419999, 58.443793036000045],
              [-135.05728105399993, 58.351548570000034],
              [-135.05386308499993, 58.33266836100006],
              [-135.05284583199995, 58.30927155200004],
              [-135.0569555329999, 58.29877350500004],
              [-135.06680253799993, 58.30097077000005],
              [-135.07921301999994, 58.30560944200005],
              [-135.09068762899994, 58.30215078300006],
              [-135.0932511059999, 58.29523346600007],
              [-135.0938207669999, 58.26459381700005],
              [-135.09239661399994, 58.25446198100008],
              [-135.0900772779999, 58.24884674700007],
              [-135.0896703769999, 58.244208075000074],
              [-135.0938207669999, 58.23725006700005],
              [-135.10244706899994, 58.23224518400008],
              [-135.13516191299993, 58.21942780200004],
              [-135.14561926999994, 58.216782945000034],
              [-135.17308508999992, 58.21893952000005],
              [-135.3095596999999, 58.25214264500005],
              [-135.35045325399994, 58.27680084800005],
              [-135.3815811839999, 58.31093984600005],
              [-135.40294348899994, 58.353949286000045],
              [-135.4116918609999, 58.385199286000045],
              [-135.41592363199993, 58.394964911000045],
              [-135.4458715489999, 58.42206452000005],
              [-135.4553116529999, 58.44627513200004],
              [-135.4675186839999, 58.46735260600008],
              [-135.4849340489999, 58.48395416900007],
              [-135.5053604809999, 58.483628648000035],
              [-135.51414954299992, 58.46552155200004],
              [-135.4983617829999, 58.44546133000006],
              [-135.47581946499992, 58.42649974200003],
              [-135.4644262359999, 58.41168854400007],
              [-135.45982825399994, 58.388332424000055],
              [-135.4631241529999, 58.378119208000044],
              [-135.4780167309999, 58.37376536700003],
              [-135.4941300119999, 58.37567780200004],
              [-135.50706946499992, 58.38068268400008],
              [-135.53262285099993, 58.394964911000045],
              [-135.59316972599993, 58.419989325000074],
              [-135.6275121739999, 58.42625560100004],
              [-135.65245520699995, 58.41852448100008],
              [-135.6765844389999, 58.406683661000045],
              [-135.8867081369999, 58.37938060100004],
              [-135.90941321499992, 58.381293036000045],
              [-135.9094945949999, 58.39508698100008],
              [-135.9021703769999, 58.42161692900004],
              [-135.89004472599993, 58.448472398000035],
              [-135.87588456899994, 58.46320221600007],
              [-135.89468339799993, 58.463324286000045],
              [-135.95034745999993, 58.456366278000075],
              [-135.95034745999993, 58.46320221600007],
              [-135.93667558499993, 58.46312083500004],
              [-135.9258520169999, 58.46771881700005],
              [-135.9155167309999, 58.47370026200008],
              [-135.90318762899994, 58.47748444200005],
              [-135.8886612619999, 58.47760651200008],
              [-135.8479711579999, 58.470038153000075],
              [-135.86046301999994, 58.49103424700007],
              [-135.85659745999993, 58.49945709800005],
              [-135.8467504549999, 58.50775788000004],
              [-135.8411352199999, 58.52838776200008],
              [-135.8452856109999, 58.546535549000055],
              [-135.85610917899993, 58.55927155200004],
              [-135.87169348899994, 58.567694403000075],
              [-135.88955644399994, 58.57306549700007],
              [-135.88955644399994, 58.57990143400008],
              [-135.82066809799994, 58.60032786700003],
              [-135.83372962099992, 58.60374583500004],
              [-135.87364661399994, 58.60854726800005],
              [-135.88206946499992, 58.610581773000035],
              [-135.8869522779999, 58.612534898000035],
              [-135.9396866529999, 58.681301174000055],
              [-135.9550675119999, 58.694647528000075],
              [-135.9783422519999, 58.696600653000075],
              [-135.97386633999992, 58.70156484600005],
              [-135.9683324859999, 58.71124909100007],
              [-135.96401933499993, 58.716457424000055],
              [-135.97435462099992, 58.72907135600008],
              [-135.99132239499994, 58.74518463700008],
              [-136.0093481109999, 58.758978583000044],
              [-136.0230199859999, 58.764837958000044],
              [-136.03209387899994, 58.77187734600005],
              [-136.05752519399994, 58.80369700700004],
              [-136.07388261599993, 58.81264883000006],
              [-136.06029212099992, 58.82591380400004],
              [-135.9631241529999, 58.86204661700003],
              [-135.9458715489999, 58.870794989000046],
              [-135.92983964799993, 58.88153717700004],
              [-135.93663489499994, 58.86408112200007],
              [-135.91783606699994, 58.863348700000074],
              [-135.7586156889999, 58.888373114000046],
              [-135.7730199859999, 58.90452708500004],
              [-135.79808508999992, 58.91266510600008],
              [-135.93545488199993, 58.91624583500004],
              [-135.96401933499993, 58.92251211100006],
              [-135.95864824099993, 58.913275458000044],
              [-135.9507543609999, 58.908270575000074],
              [-135.92983964799993, 58.902044989000046],
              [-135.9435929029999, 58.89203522300005],
              [-136.01382402299993, 58.858710028000075],
              [-136.02993730399993, 58.85529205900008],
              [-136.04653886599993, 58.861029364000046],
              [-136.0476781889999, 58.86871979400007],
              [-136.0510961579999, 58.87343984600005],
              [-136.05410722599993, 58.87872955900008],
              [-136.05406653599994, 58.888373114000046],
              [-136.05044511599993, 58.89606354400007],
              [-136.0373429029999, 58.91421133000006],
              [-136.03294837099992, 58.92251211100006],
              [-136.0564672519999, 58.930121161000045],
              [-136.0768936839999, 58.946519273000035],
              [-136.0923559239999, 58.96629466400003],
              [-136.10118567599994, 58.98395416900007],
              [-136.1040746739999, 58.998032945000034],
              [-136.10391191299993, 59.00726959800005],
              [-136.10586503799993, 59.01520416900007],
              [-136.11485755099994, 59.02558014500005],
              [-136.12637285099993, 59.032538153000075],
              [-136.14171301999994, 59.037095445000034],
              [-136.15737870999993, 59.03758372600004],
              [-136.17007402299993, 59.03237539300005],
              [-136.1548559239999, 59.023098049000055],
              [-136.14244544199994, 59.007025458000044],
              [-136.13878333199995, 58.98981354400007],
              [-136.14964758999992, 58.97711823100008],
              [-136.14098059799994, 58.95482005400004],
              [-136.1665746739999, 58.942613023000035],
              [-136.20238196499992, 58.93406810100004],
              [-136.22472083199995, 58.92251211100006],
              [-136.1526586579999, 58.93268463700008],
              [-136.11778723899994, 58.933294989000046],
              [-136.10118567599994, 58.915716864000046],
              [-136.1165258449999, 58.90957265800006],
              [-136.12230383999992, 58.908270575000074],
              [-136.12230383999992, 58.902044989000046],
              [-136.10415605399993, 58.89524974200003],
              [-136.09752356699994, 58.87685781500005],
              [-136.0999242829999, 58.85374583500004],
              [-136.10863196499992, 58.83315664300005],
              [-136.13329016799992, 58.80609772300005],
              [-136.13658606699994, 58.79588450700004],
              [-136.13711503799993, 58.78620026200008],
              [-136.1401261059999, 58.78217194200005],
              [-136.1470434239999, 58.77806224200003],
              [-136.15953528599994, 58.76825592700004],
              [-136.2097061839999, 58.75079987200007],
              [-136.2691137359999, 58.76414622600004],
              [-136.3823949859999, 58.80646393400008],
              [-136.3823949859999, 58.81264883000006],
              [-136.31358801999994, 58.80951569200005],
              [-136.2775772779999, 58.81297435100004],
              [-136.25951087099992, 58.82632070500006],
              [-136.28774980399993, 58.82562897300005],
              [-136.37584387899994, 58.83315664300005],
              [-136.42589270699995, 58.82444896000004],
              [-136.45201575399994, 58.82436758000006],
              [-136.47520911399994, 58.83657461100006],
              [-136.4929906889999, 58.86408112200007],
              [-136.50792395699995, 58.90444570500006],
              [-136.5108129549999, 58.942572333000044],
              [-136.4922582669999, 58.96344635600008],
              [-136.4922582669999, 58.97089264500005],
              [-136.5261938139999, 58.96759674700007],
              [-136.54409745999993, 58.95742422100005],
              [-136.57412675699993, 58.915716864000046],
              [-136.63931230399993, 58.967230536000045],
              [-136.67398027299993, 59.00275299700007],
              [-136.69310462099992, 59.01797109600005],
              [-136.7119848299999, 59.02558014500005],
              [-136.60826575399994, 58.908270575000074],
              [-136.63345292899993, 58.891791083000044],
              [-136.6577042309999, 58.89874909100007],
              [-136.6814672519999, 58.91400788000004],
              [-136.7051488919999, 58.92251211100006],
              [-136.7178442049999, 58.923814195000034],
              [-136.73477128799993, 58.927435614000046],
              [-136.7512914699999, 58.932847398000035],
              [-136.77672278599994, 58.94839101800005],
              [-136.82738196499992, 58.956691799000055],
              [-136.84142005099994, 58.961818752000056],
              [-136.87584387899994, 58.98395416900007],
              [-136.9175512359999, 59.001939195000034],
              [-136.9463598299999, 59.02260976800005],
              [-137.0130102199999, 59.052801825000074],
              [-137.0322159499999, 59.06749095300006],
              [-137.04609127499992, 59.06903717700004],
              [-137.05947831899994, 59.063706773000035],
              [-137.06391354099992, 59.05540599200003],
              [-137.06297766799992, 59.04389069200005],
              [-137.05020097599993, 59.03856028900003],
              [-137.02904212099992, 59.03367747600004],
              [-137.0080460279999, 59.02171458500004],
              [-136.9714249339999, 58.991400458000044],
              [-136.92931067599994, 58.96832916900007],
              [-136.91124426999994, 58.954331773000035],
              [-136.90371660099993, 58.93244049700007],
              [-136.9179581369999, 58.92007070500006],
              [-137.0130102199999, 58.92251211100006],
              [-137.03050696499992, 58.91290924700007],
              [-137.06419837099992, 58.87409088700008],
              [-137.08531653599994, 58.86953359600005],
              [-137.10244706899994, 58.85854726800005],
              [-137.1297094389999, 58.83315664300005],
              [-137.1297094389999, 58.82632070500006],
              [-137.1089574859999, 58.82876211100006],
              [-137.0869034499999, 58.83783600500004],
              [-137.06631425699993, 58.85065338700008],
              [-137.03331458199995, 58.878241278000075],
              [-137.0149633449999, 58.887884833000044],
              [-136.9946996739999, 58.89337799700007],
              [-136.89586341099994, 58.89240143400008],
              [-136.84170488199993, 58.882513739000046],
              [-136.8281957669999, 58.87750885600008],
              [-136.81777910099993, 58.87067291900007],
              [-136.8124893869999, 58.86212799700007],
              [-136.81143144399994, 58.85464101800005],
              [-136.80919348899994, 58.84739817900004],
              [-136.8001195949999, 58.83999258000006],
              [-136.79149329299992, 58.85431549700007],
              [-136.77700761599993, 58.865668036000045],
              [-136.7588598299999, 58.87278880400004],
              [-136.7392471999999, 58.87409088700008],
              [-136.7275284499999, 58.870428778000075],
              [-136.6983129549999, 58.853583075000074],
              [-136.6745499339999, 58.852850653000075],
              [-136.66372636599993, 58.85101959800005],
              [-136.6533096999999, 58.84369538000004],
              [-136.64305579299992, 58.83978913000004],
              [-136.62612870999993, 58.83844635600008],
              [-136.60903886599993, 58.83974844000005],
              [-136.58755449099993, 58.84833405200004],
              [-136.57730058499993, 58.84398021000004],
              [-136.56729081899994, 58.83685944200005],
              [-136.5573624339999, 58.83315664300005],
              [-136.5405981109999, 58.829331773000035],
              [-136.48477128799993, 58.79962799700007],
              [-136.4954320949999, 58.784491278000075],
              [-136.51187089799993, 58.780462958000044],
              [-136.53050696499992, 58.780910549000055],
              [-136.54747473899994, 58.77912018400008],
              [-136.5400284499999, 58.77167389500005],
              [-136.5659073559999, 58.78595612200007],
              [-136.5888565749999, 58.80890534100007],
              [-136.61485755099994, 58.825425523000035],
              [-136.6498917309999, 58.82005442900004],
              [-136.64305579299992, 58.80646393400008],
              [-136.62804114499994, 58.805568752000056],
              [-136.57412675699993, 58.77912018400008],
              [-136.58315995999993, 58.77374909100007],
              [-136.59337317599994, 58.771185614000046],
              [-136.6043188139999, 58.770697333000044],
              [-136.6157934239999, 58.77167389500005],
              [-136.5633031889999, 58.76068756700005],
              [-136.5439346999999, 58.751166083000044],
              [-136.52904212099992, 58.751166083000044],
              [-136.52261308499993, 58.747748114000046],
              [-136.51968339799993, 58.74095286700003],
              [-136.52232825399994, 58.735581773000035],
              [-136.52586829299992, 58.73037344000005],
              [-136.52574622299994, 58.723822333000044],
              [-136.5204971999999, 58.71084219000005],
              [-136.5158585279999, 58.702378648000035],
              [-136.5068253249999, 58.69790273600006],
              [-136.4885147779999, 58.696600653000075],
              [-136.47667395699995, 58.69232819200005],
              [-136.4526261059999, 58.673488674000055],
              [-136.43761145699995, 58.669256903000075],
              [-136.45177161399994, 58.68919505400004],
              [-136.47240149599992, 58.70343659100007],
              [-136.4910375639999, 58.72016022300005],
              [-136.4990942049999, 58.747748114000046],
              [-136.49185136599993, 58.749212958000044],
              [-136.3838598299999, 58.72508372600004],
              [-136.3755590489999, 58.72016022300005],
              [-136.36839758999992, 58.71112702000005],
              [-136.35391191299993, 58.70184967700004],
              [-136.3426000639999, 58.69155508000006],
              [-136.34483801999994, 58.67918528900003],
              [-136.35533606699994, 58.67145416900007],
              [-136.39663652299993, 58.655585028000075],
              [-136.45665442599994, 58.62327708500004],
              [-136.48863684799994, 58.61351146000004],
              [-136.5195206369999, 58.62083567900004],
              [-136.52574622299994, 58.61399974200003],
              [-136.4877823559999, 58.595404364000046],
              [-136.47520911399994, 58.59292226800005],
              [-136.4638565749999, 58.59650299700007],
              [-136.43077551999994, 58.62083567900004],
              [-136.4011938139999, 58.62571849200003],
              [-136.3772680329999, 58.61774323100008],
              [-136.35440019399994, 58.60618724200003],
              [-136.32774817599994, 58.60032786700003],
              [-136.33462480399993, 58.608587958000044],
              [-136.35220292899993, 58.62124258000006],
              [-136.3557022779999, 58.62832265800006],
              [-136.35191809799994, 58.63849518400008],
              [-136.34361731699994, 58.64215729400007],
              [-136.33433997299994, 58.642279364000046],
              [-136.32774817599994, 58.64130280200004],
              [-136.3171280589999, 58.63743724200003],
              [-136.30907141799992, 58.63182200700004],
              [-136.3017471999999, 58.62921784100007],
              [-136.2930395169999, 58.63450755400004],
              [-136.2971899079999, 58.64712148600006],
              [-136.2978409499999, 58.658270575000074],
              [-136.2930395169999, 58.669256903000075],
              [-136.28050696499992, 58.660223700000074],
              [-136.1831762359999, 58.61399974200003],
              [-136.1831762359999, 58.60716380400004],
              [-136.1923721999999, 58.607082424000055],
              [-136.19863847599993, 58.605536200000074],
              [-136.21104895699995, 58.60032786700003],
              [-136.2022192049999, 58.59430573100008],
              [-136.1775610019999, 58.57306549700007],
              [-136.1608780589999, 58.57168203300006],
              [-136.1428116529999, 58.573553778000075],
              [-136.1282445949999, 58.570746161000045],
              [-136.12230383999992, 58.55573151200008],
              [-136.12755286399994, 58.551947333000044],
              [-136.13906816299993, 58.552069403000075],
              [-136.1506241529999, 58.548895575000074],
              [-136.1558324859999, 58.53546784100007],
              [-136.16274980399993, 58.52619049700007],
              [-136.17906653599994, 58.52334219000005],
              [-136.21104895699995, 58.524644273000035],
              [-136.19859778599994, 58.508978583000044],
              [-136.18028723899994, 58.50755442900004],
              [-136.1428116529999, 58.518459377000056],
              [-136.1319067049999, 58.519517320000034],
              [-136.08250891799992, 58.51642487200007],
              [-136.08218339799993, 58.511379299000055],
              [-136.0873917309999, 58.50470612200007],
              [-136.0882055329999, 58.49799225500004],
              [-136.08556067599994, 58.491400458000044],
              [-136.0842992829999, 58.48468659100007],
              [-136.08067786399994, 58.47955963700008],
              [-136.07079016799992, 58.47748444200005],
              [-136.0623266269999, 58.474269924000055],
              [-136.06065833199995, 58.466498114000046],
              [-136.06139075399994, 58.45734284100007],
              [-136.06021074099993, 58.44953034100007],
              [-136.0362035799999, 58.39789459800005],
              [-136.02672278599994, 58.38812897300005],
              [-136.05728105399993, 58.35952383000006],
              [-136.07628333199995, 58.34560781500005],
              [-136.09805253799993, 58.33966705900008],
              [-136.1275121739999, 58.33649323100008],
              [-136.1868383449999, 58.32241445500006],
              [-136.27281653599994, 58.31297435100004],
              [-136.28750566299993, 58.31818268400008],
              [-136.28331458199995, 58.329738674000055],
              [-136.27208411399994, 58.34125397300005],
              [-136.2656957669999, 58.34650299700007],
              [-136.2724503249999, 58.35960521000004],
              [-136.32774817599994, 58.40859609600005],
              [-136.32974199099993, 58.380519924000055],
              [-136.3430883449999, 58.376166083000044],
              [-136.40929114499994, 58.393459377000056],
              [-136.4590551419999, 58.416896877000056],
              [-136.48167883999992, 58.42218659100007],
              [-136.48940995999993, 58.42601146000004],
              [-136.49864661399994, 58.44131094000005],
              [-136.5059301419999, 58.442694403000075],
              [-136.5134985019999, 58.43618398600006],
              [-136.51036536399994, 58.42792389500005],
              [-136.4990942049999, 58.41478099200003],
              [-136.5003149079999, 58.38507721600007],
              [-136.5151261059999, 58.38031647300005],
              [-136.53750566299993, 58.382513739000046],
              [-136.56114661399994, 58.37376536700003],
              [-136.5522354809999, 58.37128327000005],
              [-136.54600989499994, 58.36664459800005],
              [-136.54112708199995, 58.362209377000056],
              [-136.5366104809999, 58.36017487200007],
              [-136.5249731109999, 58.35814036700003],
              [-136.50698808499993, 58.348944403000075],
              [-136.4990942049999, 58.34650299700007],
              [-136.48033606699994, 58.346869208000044],
              [-136.48086503799993, 58.35236237200007],
              [-136.48619544199994, 58.362616278000075],
              [-136.48167883999992, 58.37759023600006],
              [-136.47329667899993, 58.38544342700004],
              [-136.46666419199994, 58.38654205900008],
              [-136.44444739499994, 58.381293036000045],
              [-136.41710364499994, 58.381293036000045],
              [-136.41006425699993, 58.379339911000045],
              [-136.40672766799992, 58.374986070000034],
              [-136.4050186839999, 58.370306708000044],
              [-136.4029027989999, 58.367621161000045],
              [-136.3776749339999, 58.35919830900008],
              [-136.36571204299992, 58.35236237200007],
              [-136.36196855399993, 58.34023672100005],
              [-136.36192786399994, 58.316107489000046],
              [-136.3705948559999, 58.29954661700003],
              [-136.39122473899994, 58.30255768400008],
              [-136.43419348899994, 58.31915924700007],
              [-136.49282792899993, 58.314439195000034],
              [-136.5127660799999, 58.31915924700007],
              [-136.51878821499992, 58.324286200000074],
              [-136.52261308499993, 58.33112213700008],
              [-136.52745520699995, 58.337103583000044],
              [-136.5366104809999, 58.33966705900008],
              [-136.55064856699994, 58.34064362200007],
              [-136.5628149079999, 58.343736070000034],
              [-136.57388261599993, 58.34918854400007],
              [-136.5847061839999, 58.357082424000055],
              [-136.5989477199999, 58.359035549000055],
              [-136.62051347599993, 58.35390859600005],
              [-136.65672766799992, 58.33966705900008],
              [-136.5747777989999, 58.282131252000056],
              [-136.56602942599994, 58.27798086100006],
              [-136.56069902299993, 58.27130768400008],
              [-136.56114661399994, 58.25775788000004],
              [-136.56729081899994, 58.249335028000075],
              [-136.5918676419999, 58.227443752000056],
              [-136.5983780589999, 58.22304922100005],
              [-136.63341223899994, 58.227728583000044],
              [-136.63931230399993, 58.22675202000005],
              [-136.65099036399994, 58.22052643400008],
              [-136.6647843089999, 58.220363674000055],
              [-136.6787003249999, 58.224310614000046],
              [-136.69082597599993, 58.23041413000004],
              [-136.70693925699993, 58.24799225500004],
              [-136.71141516799992, 58.268866278000075],
              [-136.7007543609999, 58.28416575700004],
              [-136.67100989499994, 58.28510163000004],
              [-136.67174231699994, 58.29010651200008],
              [-136.6751195949999, 58.30125560100004],
              [-136.6772354809999, 58.305568752000056],
              [-136.69383704299992, 58.29930247600004],
              [-136.71108964799993, 58.29779694200005],
              [-136.72524980399993, 58.301947333000044],
              [-136.7324926419999, 58.31297435100004],
              [-136.7402237619999, 58.306301174000055],
              [-136.7505590489999, 58.300441799000055],
              [-136.76187089799993, 58.297308661000045],
              [-136.7727758449999, 58.29873281500005],
              [-136.78359941299993, 58.30638255400004],
              [-136.7796117829999, 58.312201239000046],
              [-136.7722061839999, 58.31826406500005],
              [-136.7727758449999, 58.326605536000045],
              [-136.7881567049999, 58.33270905200004],
              [-136.8262426419999, 58.31899648600006],
              [-136.8491104809999, 58.326605536000045],
              [-136.8432511059999, 58.33100006700005],
              [-136.83311926999994, 58.34198639500005],
              [-136.82738196499992, 58.34650299700007],
              [-136.83653723899994, 58.36041901200008],
              [-136.84752356699994, 58.372748114000046],
              [-136.86050370999993, 58.38239166900007],
              [-136.87584387899994, 58.38812897300005],
              [-136.87804114499994, 58.363348700000074],
              [-136.8901261059999, 58.349676825000074],
              [-136.9036352199999, 58.350816148000035],
              [-136.9099828769999, 58.37067291900007],
              [-136.92100989499994, 58.38898346600007],
              [-136.9474991529999, 58.40070221600007],
              [-136.97935950399994, 58.40688711100006],
              [-137.0068253249999, 58.40859609600005],
              [-137.0227758449999, 58.40717194200005],
              [-137.06761633999992, 58.394964911000045],
              [-137.0783585279999, 58.39325592700004],
              [-137.1122940749999, 58.394964911000045],
              [-137.1314184239999, 58.40131256700005],
              [-137.19790605399993, 58.442694403000075],
              [-137.2600805329999, 58.456366278000075],
              [-137.30003821499992, 58.47475820500006],
              [-137.32188880099994, 58.48065827000005],
              [-137.34044348899994, 58.49477773600006],
              [-137.3482152989999, 58.49799225500004],
              [-137.36253821499992, 58.50018952000005],
              [-137.4714249339999, 58.554388739000046],
              [-137.5185440749999, 58.56476471600007],
              [-137.5628149079999, 58.59088776200008],
              [-137.58836829299992, 58.60032786700003],
              [-137.62075761599993, 58.60260651200008],
              [-137.63145911399994, 58.60618724200003],
              [-137.62246660099993, 58.61399974200003],
              [-137.60684160099993, 58.61774323100008],
              [-137.57046464799993, 58.61798737200007],
              [-137.5542699859999, 58.62083567900004],
              [-137.51382402299993, 58.64252350500004],
              [-137.49962317599994, 58.648138739000046],
              [-137.48412024599992, 58.64988841400003],
              [-137.4519750639999, 58.650091864000046],
              [-137.43814042899993, 58.655585028000075],
              [-137.45767167899993, 58.67226797100005],
              [-137.4694718089999, 58.67959219000005],
              [-137.47911536399994, 58.682928778000075],
              [-137.4954320949999, 58.68036530200004],
              [-137.52163652299993, 58.665350653000075],
              [-137.53746497299994, 58.661810614000046],
              [-137.5666397779999, 58.65884023600006],
              [-137.64297441299993, 58.63450755400004],
              [-137.6706436839999, 58.633246161000045],
              [-137.67784583199995, 58.64642975500004],
              [-137.6831762359999, 58.66648997600004],
              [-137.70474199099993, 58.68634674700007],
              [-137.86961829299992, 58.76577383000006],
              [-137.8931371739999, 58.78221263200004],
              [-137.9021703769999, 58.786444403000075],
              [-137.9147843089999, 58.79051341400003],
              [-137.9260961579999, 58.79572174700007],
              [-137.9309789699999, 58.80304596600007],
              [-137.92955481699994, 58.815741278000075],
              [-137.9240616529999, 58.83462148600006],
              [-137.92418372299994, 58.84739817900004],
              [-137.94424394399994, 58.88812897300005],
              [-137.9843643869999, 58.919989325000074],
              [-138.1848852199999, 59.02558014500005],
              [-138.2508031889999, 59.04783763200004],
              [-138.28115800699993, 59.06240469000005],
              [-138.2879125639999, 59.08075592700004],
              [-138.36266028599994, 59.079779364000046],
              [-138.39891516799992, 59.083319403000075],
              [-138.43126380099994, 59.093817450000074],
              [-138.3986710279999, 59.09284088700008],
              [-138.38320878799993, 59.09479401200008],
              [-138.36978105399993, 59.101263739000046],
              [-138.4284561839999, 59.11123281500005],
              [-138.5593969389999, 59.10618724200003],
              [-138.61001542899993, 59.12799713700008],
              [-138.54043535099993, 59.12246328300006],
              [-138.50694739499994, 59.124701239000046],
              [-138.4927465489999, 59.13849518400008],
              [-138.49376380099994, 59.149318752000056],
              [-138.49478105399993, 59.15273672100005],
              [-138.48306230399993, 59.165228583000044],
              [-138.4728897779999, 59.17059967700004],
              [-138.44652258999992, 59.17609284100007],
              [-138.43809973899994, 59.18317291900007],
              [-138.44908606699994, 59.19163646000004],
              [-138.55825761599993, 59.180894273000035],
              [-138.58311926999994, 59.171128648000035],
              [-138.59605872299994, 59.16889069200005],
              [-138.62857011599993, 59.16889069200005],
              [-138.6438695949999, 59.16681549700007],
              [-138.6536352199999, 59.16396719000005],
              [-138.6411840489999, 59.153998114000046],
              [-138.63048255099994, 59.142238674000055],
              [-138.6560766269999, 59.15770091400003],
              [-138.68834387899994, 59.176988023000035],
              [-138.7267960279999, 59.191107489000046],
              [-138.7698461579999, 59.19985586100006],
              [-138.8140356109999, 59.21466705900008],
              [-138.83828691299993, 59.228216864000046],
              [-138.98167883999992, 59.27484772300005],
              [-139.2058813139999, 59.31976959800005],
              [-139.18419348899994, 59.32526276200008],
              [-139.13809160099993, 59.310248114000046],
              [-139.1165258449999, 59.312933661000045],
              [-139.1541235019999, 59.336004950000074],
              [-139.16490637899994, 59.34023672100005],
              [-139.18211829299992, 59.34125397300005],
              [-139.2017309239999, 59.33978913000004],
              [-139.22012285099993, 59.34031810100004],
              [-139.23379472599993, 59.347723700000074],
              [-139.23692786399994, 59.36005280200004],
              [-139.2302953769999, 59.36823151200008],
              [-139.2268774079999, 59.374660549000055],
              [-139.2400610019999, 59.38117096600007],
              [-139.25332597599993, 59.38141510600008],
              [-139.2715958319999, 59.378119208000044],
              [-139.28770911399994, 59.37213776200008],
              [-139.29466712099992, 59.36473216400003],
              [-139.3037003249999, 59.35053131700005],
              [-139.3257543609999, 59.35578034100007],
              [-139.35289466099994, 59.36810944200005],
              [-139.3775121739999, 59.37494538000004],
              [-139.4080297519999, 59.37836334800005],
              [-139.4462784499999, 59.387600002000056],
              [-139.4826554029999, 59.40062083500004],
              [-139.50755774599992, 59.41596100500004],
              [-139.4279679029999, 59.401556708000044],
              [-139.38914954299992, 59.38226959800005],
              [-139.3654679029999, 59.38027578300006],
              [-139.34166419199994, 59.38499583500004],
              [-139.3225805329999, 59.39545319200005],
              [-139.36392167899993, 59.41071198100008],
              [-139.38638261599993, 59.41510651200008],
              [-139.4048559239999, 59.41225820500006],
              [-139.42345130099994, 59.40696849200003],
              [-139.44351152299993, 59.40766022300005],
              [-139.4631241529999, 59.41242096600007],
              [-139.50755774599992, 59.42963288000004],
              [-139.5247289699999, 59.44037506700005],
              [-139.5342504549999, 59.44383372600004],
              [-139.59691321499992, 59.45697663000004],
              [-139.8570043609999, 59.54629140800006],
              [-139.83584550699993, 59.55890534100007],
              [-139.76577714799993, 59.54783763200004],
              [-139.73350989499994, 59.55247630400004],
              [-139.7359106109999, 59.55638255400004],
              [-139.7403051419999, 59.56679922100005],
              [-139.71959387899994, 59.56598541900007],
              [-139.7034399079999, 59.57021719000005],
              [-139.69029700399994, 59.579738674000055],
              [-139.67886308499993, 59.59467194200005],
              [-139.66885331899994, 59.58437734600005],
              [-139.65758216099994, 59.575506903000075],
              [-139.64488684799994, 59.57273997600004],
              [-139.6304418609999, 59.58047109600005],
              [-139.63784745999993, 59.58730703300006],
              [-139.62295488199993, 59.595363674000055],
              [-139.57579505099994, 59.614569403000075],
              [-139.5913793609999, 59.62254466400003],
              [-139.57921301999994, 59.63959381700005],
              [-139.5271703769999, 59.67804596600007],
              [-139.4800512359999, 59.704413153000075],
              [-139.4733780589999, 59.71759674700007],
              [-139.53795325399994, 59.757025458000044],
              [-139.54507402299993, 59.76479726800005],
              [-139.5620824859999, 59.772365627000056],
              [-139.57201087099992, 59.79018789300005],
              [-139.58263098899994, 59.827460028000075],
              [-139.6087133449999, 59.86359284100007],
              [-139.6210831369999, 59.890285549000055],
              [-139.6133520169999, 59.90253327000005],
              [-139.6022843089999, 59.90680573100008],
              [-139.58238684799994, 59.92560455900008],
              [-139.5723770819999, 59.92987702000005],
              [-139.55907141799992, 59.931708075000074],
              [-139.54576575399994, 59.93667226800005],
              [-139.52183997299994, 59.95099518400008],
              [-139.4925024079999, 59.98456452000005],
              [-139.4732152989999, 59.99359772300005],
              [-139.44888261599993, 59.98110586100006],
              [-139.4300024079999, 59.96503327000005],
              [-139.37100175699993, 59.92987702000005],
              [-139.30516516799992, 59.86469147300005],
              [-139.30235755099994, 59.84829336100006],
              [-139.33360755099994, 59.81342194200005],
              [-139.3430883449999, 59.78652578300006],
              [-139.34288489499994, 59.77326080900008],
              [-139.33560136599993, 59.73810455900008],
              [-139.3419083319999, 59.72675202000005],
              [-139.3420304029999, 59.720404364000046],
              [-139.3267309239999, 59.715725002000056],
              [-139.3185929029999, 59.71108633000006],
              [-139.31139075399994, 59.70538971600007],
              [-139.30833899599992, 59.70026276200008],
              [-139.30313066299993, 59.68073151200008],
              [-139.2776586579999, 59.646185614000046],
              [-139.26732337099992, 59.62140534100007],
              [-139.2866104809999, 59.62055084800005],
              [-139.31090247299994, 59.61627838700008],
              [-139.3323461579999, 59.60956452000005],
              [-139.3430883449999, 59.600897528000075],
              [-139.28990637899994, 59.576157945000034],
              [-139.27074133999992, 59.57298411700003],
              [-139.2597550119999, 59.57904694200005],
              [-139.2263891269999, 59.62140534100007],
              [-139.23485266799992, 59.63336823100008],
              [-139.26162675699993, 59.65916575700004],
              [-139.26732337099992, 59.666083075000074],
              [-139.26699785099993, 59.69806549700007],
              [-139.2688695949999, 59.71507396000004],
              [-139.2741593089999, 59.73126862200007],
              [-139.27969316299993, 59.73627350500004],
              [-139.28648841099994, 59.73818594000005],
              [-139.29222571499992, 59.74258047100005],
              [-139.29466712099992, 59.755194403000075],
              [-139.2913305329999, 59.760199286000045],
              [-139.27574622299994, 59.77578359600005],
              [-139.27074133999992, 59.77903880400004],
              [-139.26333574099993, 59.78579336100006],
              [-139.2796117829999, 59.81972890800006],
              [-139.28038489499994, 59.833685614000046],
              [-139.2646378249999, 59.84162018400008],
              [-139.17369544199994, 59.850816148000035],
              [-139.03636633999992, 59.846869208000044],
              [-139.01097571499992, 59.84247467700004],
              [-138.96959387899994, 59.81671784100007],
              [-138.9453018869999, 59.80711497600004],
              [-138.92007402299993, 59.80499909100007],
              [-138.89736894399994, 59.81317780200004],
              [-138.91051184799994, 59.81268952000005],
              [-138.9225968089999, 59.81391022300005],
              [-138.94517981699994, 59.820013739000046],
              [-139.0137833319999, 59.85761139500005],
              [-139.0283096999999, 59.86151764500005],
              [-139.2187393869999, 59.87103913000004],
              [-139.2390030589999, 59.87832265800006],
              [-139.32119706899994, 59.938706773000035],
              [-139.3552953769999, 59.94940827000005],
              [-139.36831620999993, 59.963324286000045],
              [-139.37954667899993, 59.97919342700004],
              [-139.39024817599994, 59.99135976800005],
              [-139.4124242829999, 60.00189850500004],
              [-139.46206620999993, 60.011786200000074],
              [-139.48330644399994, 60.02240631700005],
              [-139.50723222599993, 60.046535549000055],
              [-139.52090410099993, 60.05149974200003],
              [-139.54165605399993, 60.046576239000046],
              [-139.5429581369999, 60.03729889500005],
              [-139.57994544199994, 60.00731028900003],
              [-139.58946692599994, 59.987941799000055],
              [-139.58438066299993, 59.96515534100007],
              [-139.58482825399994, 59.955064195000034],
              [-139.59316972599993, 59.95099518400008],
              [-139.62612870999993, 59.94944896000004],
              [-139.65835527299993, 59.94354889500005],
              [-139.70596269399994, 59.92177969000005],
              [-139.73521887899994, 59.89923737200007],
              [-139.7944229809999, 59.85419342700004],
              [-139.84902910099993, 59.81940338700008],
              [-139.95824133999992, 59.794623114000046],
              [-140.04271399599992, 59.76972077000005],
              [-140.13707434799994, 59.739935614000046],
              [-140.2542211579999, 59.710150458000044],
              [-140.32274329299992, 59.701239325000074],
              [-140.50121008999992, 59.70522695500006],
              [-140.6170141269999, 59.70848216400003],
              [-140.68980872299994, 59.718451239000046],
              [-140.7626846999999, 59.72833893400008],
              [-140.86314856699994, 59.74555084800005],
              [-141.0098363919999, 59.79043203300006],
              [-141.1152237619999, 59.809475002000056],
              [-141.2741593089999, 59.84918854400007],
              [-141.3522843089999, 59.86408112200007],
              [-141.4285375639999, 59.87213776200008],
              [-141.45400956899994, 59.882066148000035],
              [-141.46816972599993, 59.90306224200003],
              [-141.45763098899994, 59.91673411700003],
              [-141.43492591099994, 59.925116278000075],
              [-141.4124242829999, 59.92987702000005],
              [-141.4345596999999, 59.91966380400004],
              [-141.4451391269999, 59.91233958500004],
              [-141.45400956899994, 59.90253327000005],
              [-141.43809973899994, 59.896185614000046],
              [-141.41319739499994, 59.89996979400007],
              [-141.35317949099993, 59.92015208500004],
              [-141.34679114499994, 59.92487213700008],
              [-141.33873450399994, 59.92841217700004],
              [-141.31432044199994, 59.93146393400008],
              [-141.28408769399994, 59.93976471600007],
              [-141.27525794199994, 59.94354889500005],
              [-141.26732337099992, 59.95555247600004],
              [-141.26211503799993, 59.973944403000075],
              [-141.26012122299994, 59.994208075000074],
              [-141.26158606699994, 60.011786200000074],
              [-141.2678930329999, 60.02903880400004],
              [-141.2780655589999, 60.04409414300005],
              [-141.29222571499992, 60.05658600500004],
              [-141.3100479809999, 60.066473700000074],
              [-141.30313066299993, 60.06586334800005],
              [-141.28209387899994, 60.066473700000074],
              [-141.30504309799994, 60.08633047100005],
              [-141.3464249339999, 60.09878164300005],
              [-141.37954667899993, 60.11391836100006],
              [-141.3776749339999, 60.14215729400007],
              [-141.44351152299993, 60.13568756700005],
              [-141.4747208319999, 60.12612539300005],
              [-141.4776098299999, 60.11107005400004],
              [-141.4550675119999, 60.07843659100007],
              [-141.44717363199993, 60.073919989000046],
              [-141.4317113919999, 60.07221100500004],
              [-141.4197485019999, 60.067572333000044],
              [-141.3994034499999, 60.052801825000074],
              [-141.38589433499993, 60.034816799000055],
              [-141.39293372299994, 60.02204010600008],
              [-141.41421464799993, 60.01434967700004],
              [-141.47252356699994, 60.009019273000035],
              [-141.61388098899994, 59.96906159100007],
              [-141.67349199099993, 59.96112702000005],
              [-141.7326554029999, 59.96312083500004],
              [-141.89395097599993, 60.00755442900004],
              [-141.96910559799994, 60.02814362200007],
              [-142.10415605399993, 60.03530508000006],
              [-142.19774329299992, 60.052801825000074],
              [-142.3516332669999, 60.067694403000075],
              [-142.48741614499994, 60.07591380400004],
              [-142.6396378249999, 60.102443752000056],
              [-142.79849199099993, 60.11237213700008],
              [-142.98228919199994, 60.09247467700004],
              [-143.19579016799992, 60.067694403000075],
              [-143.4639379549999, 60.052801825000074],
              [-143.6096085279999, 60.04946523600006],
              [-143.74868730399993, 60.025458075000074],
              [-143.86318925699993, 60.00039297100005],
              [-143.91860917899993, 59.99701569200005],
              [-144.04238847599993, 60.02798086100006],
              [-144.1057022779999, 60.031683661000045],
              [-144.24962317599991, 60.03229401200008],
              [-144.1332087879999, 60.03974030200004],
              [-144.03136145699992, 60.034084377000056],
              [-144.0025528639999, 60.03974030200004],
              [-144.02009029899992, 60.061428127000056],
              [-144.0507706369999, 60.07965729400007],
              [-144.2054744129999, 60.14516836100006],
              [-144.2191462879999, 60.14862702000005],
              [-144.23908443899992, 60.149603583000044],
              [-144.2525528639999, 60.15460846600007],
              [-144.24087480399993, 60.16551341400003],
              [-144.20563717399992, 60.18305084800005],
              [-144.1974991529999, 60.18414948100008],
              [-144.1905411449999, 60.18659088700008],
              [-144.18757076699993, 60.19367096600007],
              [-144.19009355399993, 60.20164622600004],
              [-144.1964412099999, 60.20563385600008],
              [-144.20449785099993, 60.20530833500004],
              [-144.2120255199999, 60.200506903000075],
              [-144.24657141799992, 60.18891022300005],
              [-144.34756425699993, 60.20111725500004],
              [-144.38678951699993, 60.19676341400003],
              [-144.37311764199993, 60.18374258000006],
              [-144.44855709499993, 60.17633698100008],
              [-144.4634903639999, 60.179348049000055],
              [-144.47883053299992, 60.186712958000044],
              [-144.4858292309999, 60.19594961100006],
              [-144.4754939439999, 60.20425039300005],
              [-144.49071204299992, 60.21625397300005],
              [-144.51732337099992, 60.21002838700008],
              [-144.54698645699992, 60.19745514500005],
              [-144.57111568899992, 60.190619208000044],
              [-144.60147050699993, 60.19643789300005],
              [-144.65811113199993, 60.21539948100008],
              [-144.6883845689999, 60.224676825000074],
              [-144.6742244129999, 60.226548570000034],
              [-144.66185462099992, 60.22406647300005],
              [-144.65314693899992, 60.220363674000055],
              [-144.6400040359999, 60.217230536000045],
              [-144.64216061099992, 60.22247955900008],
              [-144.6605118479999, 60.24518463700008],
              [-144.69465084499993, 60.27252838700008],
              [-144.7363175119999, 60.284409898000035],
              [-144.7464493479999, 60.28953685100004],
              [-144.75593014199993, 60.296210028000075],
              [-144.7698868479999, 60.30267975500004],
              [-144.78404700399992, 60.305975653000075],
              [-144.79426021999993, 60.30320872600004],
              [-144.80890865799992, 60.29441966400003],
              [-144.81965084499993, 60.29726797100005],
              [-144.82876542899993, 60.30312734600005],
              [-144.83869381399992, 60.30320872600004],
              [-144.84894771999993, 60.30072663000004],
              [-144.8651016919999, 60.304388739000046],
              [-144.87279212099992, 60.30320872600004],
              [-144.8901261059999, 60.292954820000034],
              [-144.9052628249999, 60.29319896000004],
              [-144.91657467399992, 60.29474518400008],
              [-144.92747962099992, 60.29877350500004],
              [-144.9416397779999, 60.306626695000034],
              [-144.9344783189999, 60.316392320000034],
              [-144.9163712229999, 60.326157945000034],
              [-144.8896378249999, 60.35024648600006],
              [-144.88703365799992, 60.35504791900007],
              [-144.88996334499993, 60.363267320000034],
              [-144.89639238199993, 60.36579010600008],
              [-144.9030655589999, 60.36619700700004],
              [-144.90689042899993, 60.36810944200005],
              [-144.91454016799992, 60.38117096600007],
              [-144.9124649729999, 60.38703034100007],
              [-144.90070553299992, 60.39598216400003],
              [-144.88654537699992, 60.401556708000044],
              [-144.87071692599991, 60.403225002000056],
              [-144.83800208199992, 60.40216705900008],
              [-144.83800208199992, 60.40965403900003],
              [-144.8607071609999, 60.41852448100008],
              [-144.8420304029999, 60.43618398600006],
              [-144.79084225199992, 60.464911200000074],
              [-144.79426021999993, 60.47597890800006],
              [-144.7940974599999, 60.49115631700005],
              [-144.79841061099992, 60.499212958000044],
              [-144.83214270699992, 60.47711823100008],
              [-144.8531794909999, 60.46987539300005],
              [-144.87311764199993, 60.47117747600004],
              [-144.88703365799992, 60.48541901200008],
              [-144.87905839799993, 60.49591705900008],
              [-144.87018795499992, 60.50185781500005],
              [-144.86095130099991, 60.506293036000045],
              [-144.84618079299992, 60.516791083000044],
              [-144.83604895699992, 60.52240631700005],
              [-144.83177649599992, 60.52578359600005],
              [-144.8306778639999, 60.53099192900004],
              [-144.8320206369999, 60.53803131700005],
              [-144.83234615799992, 60.544175523000035],
              [-144.8283585279999, 60.54682038000004],
              [-144.8175349599999, 60.55182526200008],
              [-144.81525631399992, 60.56313711100006],
              [-144.8187556629999, 60.58413320500006],
              [-144.8160701159999, 60.595038153000075],
              [-144.80923417899993, 60.60333893400008],
              [-144.79084225199992, 60.61513906500005],
              [-144.7684626939999, 60.62514883000006],
              [-144.7628067699999, 60.630194403000075],
              [-144.7560929029999, 60.64305247600004],
              [-144.75706946499992, 60.65253327000005],
              [-144.76134192599991, 60.66356028900003],
              [-144.76060950399992, 60.672756252000056],
              [-144.7464493479999, 60.67658112200007],
              [-144.71654212099992, 60.671861070000034],
              [-144.68854732999992, 60.66364166900007],
              [-144.66120357999992, 60.66010163000004],
              [-144.6331680979999, 60.66974518400008],
              [-144.6179093089999, 60.68036530200004],
              [-144.6136775379999, 60.68732330900008],
              [-144.6126602859999, 60.697699286000045],
              [-144.61603756399992, 60.71393463700008],
              [-144.62279212099992, 60.71702708500004],
              [-144.63385982999992, 60.71385325700004],
              [-144.70539303299992, 60.70380280200004],
              [-144.7331436839999, 60.69521719000005],
              [-144.7560929029999, 60.684027411000045],
              [-144.77179928299992, 60.66893138200004],
              [-144.78600012899992, 60.65070221600007],
              [-144.80329342399992, 60.63532135600008],
              [-144.8558650379999, 60.62205638200004],
              [-144.86978105399993, 60.60569896000004],
              [-144.8791397779999, 60.58551666900007],
              [-144.89321855399993, 60.56732819200005],
              [-144.9120987619999, 60.55735911700003],
              [-144.9742732409999, 60.53701406500005],
              [-144.9996638659999, 60.533189195000034],
              [-145.0195206369999, 60.52643463700008],
              [-145.04043535099993, 60.51056549700007],
              [-145.07201087099992, 60.47797272300005],
              [-145.09699459499993, 60.44428131700005],
              [-145.1140030589999, 60.42942942900004],
              [-145.16348222599993, 60.41714101800005],
              [-145.23591061099992, 60.36810944200005],
              [-145.2695206369999, 60.357082424000055],
              [-145.30524654899992, 60.35578034100007],
              [-145.38914954299992, 60.362534898000035],
              [-145.40265865799992, 60.36627838700008],
              [-145.4151912099999, 60.37189362200007],
              [-145.43683834499993, 60.386419989000046],
              [-145.46849524599992, 60.39175039300005],
              [-145.4822891919999, 60.39598216400003],
              [-145.4893692699999, 60.40326569200005],
              [-145.49889075399992, 60.423529364000046],
              [-145.50401770699992, 60.43081289300005],
              [-145.5169571609999, 60.43602122600004],
              [-145.55003821499992, 60.44135163000004],
              [-145.57258053299992, 60.45111725500004],
              [-145.6728387709999, 60.45815991200004],
              [-145.7316158069999, 60.46527700900003],
              [-145.8045041759999, 60.45444902600008],
              [-145.8660636749999, 60.44766242600008],
              [-145.93875364099992, 60.45606615100007],
              [-145.94155839799993, 60.471136786000045],
              [-145.92267818899992, 60.47996653900003],
              [-145.8800349599999, 60.48769765800006],
              [-145.86339270699992, 60.495306708000044],
              [-145.8468318349999, 60.50722890800006],
              [-145.77179928299992, 60.54242584800005],
              [-145.6813044909999, 60.60809967700004],
              [-145.67467200399992, 60.61823151200008],
              [-145.6663712229999, 60.63532135600008],
              [-145.6478165359999, 60.64520905200004],
              [-145.6291397779999, 60.65273672100005],
              [-145.6200251939999, 60.66290924700007],
              [-145.62901770699992, 60.67914459800005],
              [-145.65208899599992, 60.675116278000075],
              [-145.6917618479999, 60.656683661000045],
              [-145.84459387899992, 60.62103913000004],
              [-145.88019771999993, 60.62872955900008],
              [-145.83800208199992, 60.639837958000044],
              [-145.8177384109999, 60.649603583000044],
              [-145.8050430979999, 60.66290924700007],
              [-145.8242081369999, 60.66486237200007],
              [-145.86139889199993, 60.65648021000004],
              [-145.88019771999993, 60.66290924700007],
              [-145.85553951699993, 60.67658112200007],
              [-145.84528561099992, 60.685532945000034],
              [-145.83918209499993, 60.697699286000045],
              [-145.85716712099992, 60.69505442900004],
              [-145.88223222599993, 60.68622467700004],
              [-145.9046524729999, 60.67357005400004],
              [-145.9257706369999, 60.64520905200004],
              [-145.95238196499992, 60.63812897300005],
              [-146.00365149599992, 60.635646877000056],
              [-145.9941300119999, 60.64915599200003],
              [-145.9827774729999, 60.65721263200004],
              [-145.95523027299993, 60.66974518400008],
              [-145.94343014199993, 60.67829010600008],
              [-145.92467200399992, 60.69684479400007],
              [-145.9142960279999, 60.70392487200007],
              [-145.93879146999993, 60.708197333000044],
              [-145.96548417899993, 60.69782135600008],
              [-145.99233964799993, 60.68374258000006],
              [-146.01732337099992, 60.67658112200007],
              [-146.0443009109999, 60.673081773000035],
              [-146.19774329299992, 60.63654205900008],
              [-146.23875891799992, 60.63471100500004],
              [-146.25690670499992, 60.646185614000046],
              [-146.2580460279999, 60.64883047100005],
              [-146.26060950399992, 60.65070221600007],
              [-146.2631729809999, 60.65371328300006],
              [-146.26431230399993, 60.659816799000055],
              [-146.26130123599992, 60.66258372600004],
              [-146.2460017569999, 60.66380442900004],
              [-146.23985755099991, 60.66632721600007],
              [-146.2307022779999, 60.673163153000075],
              [-146.11729895699992, 60.72138092700004],
              [-146.08128821499992, 60.72638580900008],
              [-146.0703018869999, 60.73065827000005],
              [-146.06212317599991, 60.73802317900004],
              [-146.05890865799992, 60.74860260600008],
              [-146.0530899729999, 60.75263092700004],
              [-146.0261124339999, 60.74481842700004],
              [-146.0179337229999, 60.75234609600005],
              [-146.02037512899992, 60.75796133000006],
              [-146.03774980399993, 60.77960846600007],
              [-146.0322159499999, 60.788397528000075],
              [-146.0311173169999, 60.79474518400008],
              [-146.03774980399993, 60.800116278000075],
              [-146.04344641799992, 60.80101146000004],
              [-146.05040442599991, 60.800848700000074],
              [-146.05638587099992, 60.79930247600004],
              [-146.05890865799992, 60.79633209800005],
              [-146.0693253249999, 60.77838776200008],
              [-146.09349524599992, 60.762884833000044],
              [-146.1408585279999, 60.74481842700004],
              [-146.1669815749999, 60.74070872600004],
              [-146.18219967399992, 60.74404531500005],
              [-146.1818741529999, 60.753119208000044],
              [-146.1612849599999, 60.76654694200005],
              [-146.20856686099992, 60.76072825700004],
              [-146.22248287699992, 60.75576406500005],
              [-146.2322891919999, 60.74746328300006],
              [-146.24030514199993, 60.73725006700005],
              [-146.24982662699992, 60.72866445500006],
              [-146.2640274729999, 60.72500234600005],
              [-146.29556230399993, 60.72630442900004],
              [-146.30679277299993, 60.732082424000055],
              [-146.31212317599991, 60.74481842700004],
              [-146.30996660099993, 60.758246161000045],
              [-146.30235755099991, 60.765326239000046],
              [-146.29259192599991, 60.77090078300006],
              [-146.28425045499992, 60.77960846600007],
              [-146.3130997389999, 60.77167389500005],
              [-146.3525284499999, 60.733710028000075],
              [-146.38914954299992, 60.721991278000075],
              [-146.41722571499992, 60.70677317900004],
              [-146.4256892569999, 60.700832424000055],
              [-146.4383845689999, 60.69599030200004],
              [-146.4822891919999, 60.68695709800005],
              [-146.49372311099992, 60.687160549000055],
              [-146.5175675119999, 60.69806549700007],
              [-146.5499161449999, 60.70140208500004],
              [-146.6441951159999, 60.697699286000045],
              [-146.65208899599992, 60.70001862200007],
              [-146.65363521999993, 60.70575592700004],
              [-146.65298417899993, 60.71246979400007],
              [-146.65477454299992, 60.71816640800006],
              [-146.66291256399992, 60.72500234600005],
              [-146.6957087879999, 60.74481842700004],
              [-146.67857825399992, 60.75275299700007],
              [-146.6605118479999, 60.749986070000034],
              [-146.6429744129999, 60.74119700700004],
              [-146.62743079299992, 60.73114655200004],
              [-146.62083899599992, 60.75242747600004],
              [-146.61579342399992, 60.76117584800005],
              [-146.60700436099992, 60.76654694200005],
              [-146.59113521999993, 60.76520416900007],
              [-146.56261145699992, 60.75096263200004],
              [-146.5345352859999, 60.75922272300005],
              [-146.50670325399992, 60.74437083500004],
              [-146.49372311099992, 60.74860260600008],
              [-146.49152584499993, 60.76089101800005],
              [-146.50511633999992, 60.76862213700008],
              [-146.5241593089999, 60.77240631700005],
              [-146.5380753249999, 60.772772528000075],
              [-146.51569576699993, 60.78009674700007],
              [-146.49160722599993, 60.779282945000034],
              [-146.44562740799992, 60.772772528000075],
              [-146.42662512899992, 60.77488841400003],
              [-146.3860977859999, 60.78432851800005],
              [-146.34333248599992, 60.78888580900008],
              [-146.2628474599999, 60.81085846600007],
              [-146.19546464799993, 60.82054271000004],
              [-146.19546464799993, 60.827378648000035],
              [-146.2278946609999, 60.831691799000055],
              [-146.23753821499992, 60.841009833000044],
              [-146.22614498599992, 60.85040924700007],
              [-146.19546464799993, 60.854681708000044],
              [-146.09308834499993, 60.841009833000044],
              [-146.22345943899992, 60.892645575000074],
              [-146.2537735669999, 60.88572825700004],
              [-146.28136145699992, 60.85932038000004],
              [-146.31725012899992, 60.83673737200007],
              [-146.3583064439999, 60.822333075000074],
              [-146.4015193349999, 60.82054271000004],
              [-146.4015193349999, 60.827378648000035],
              [-146.39610755099991, 60.831244208000044],
              [-146.39313717399992, 60.83543528900003],
              [-146.38727779899992, 60.84788646000004],
              [-146.51146399599992, 60.81858958500004],
              [-146.5585831369999, 60.827378648000035],
              [-146.5545955069999, 60.84544505400004],
              [-146.5668025379999, 60.85366445500006],
              [-146.58604895699992, 60.85297272300005],
              [-146.60326087099992, 60.84442780200004],
              [-146.6191300119999, 60.83104075700004],
              [-146.6282852859999, 60.82729726800005],
              [-146.63097083199992, 60.83478424700007],
              [-146.62743079299992, 60.854681708000044],
              [-146.6099747389999, 60.86420319200005],
              [-146.60700436099992, 60.868353583000044],
              [-146.61139889199993, 60.87714264500005],
              [-146.62083899599992, 60.88377513200004],
              [-146.6319473949999, 60.888006903000075],
              [-146.64110266799992, 60.88947174700007],
              [-146.6552628249999, 60.88629791900007],
              [-146.66844641799992, 60.880926825000074],
              [-146.6835017569999, 60.87982819200005],
              [-146.70319576699993, 60.88947174700007],
              [-146.70466061099992, 60.892279364000046],
              [-146.71686764199993, 60.90997955900008],
              [-146.72386633999992, 60.916083075000074],
              [-146.7304581369999, 60.91933828300006],
              [-146.73542232999992, 60.923895575000074],
              [-146.7372940749999, 60.93382396000004],
              [-146.7532852859999, 60.95502350500004],
              [-146.75316321499992, 60.96430084800005],
              [-146.7298477859999, 60.964544989000046],
              [-146.7147110669999, 60.95978424700007],
              [-146.6912735669999, 60.947251695000034],
              [-146.6049698559999, 60.937160549000055],
              [-146.5858455069999, 60.94472890800006],
              [-146.6188044909999, 60.95502350500004],
              [-146.66608639199993, 60.96344635600008],
              [-146.6998184889999, 60.97687409100007],
              [-146.6922908189999, 61.00242747600004],
              [-146.68529212099992, 61.01166413000004],
              [-146.6727595689999, 61.03270091400003],
              [-146.66222083199992, 61.040269273000035],
              [-146.6435440749999, 61.04205963700008],
              [-146.5909317699999, 61.032904364000046],
              [-146.57282467399992, 61.026597398000035],
              [-146.57046464799993, 61.03070709800005],
              [-146.56647701699993, 61.04157135600008],
              [-146.5654190749999, 61.046535549000055],
              [-146.6112361319999, 61.05345286700003],
              [-146.63292395699992, 61.05955638200004],
              [-146.6479386059999, 61.07379791900007],
              [-146.5568741529999, 61.085923570000034],
              [-146.28376217399992, 61.08144765800006],
              [-146.23643958199992, 61.09430573100008],
              [-146.27798417899993, 61.122748114000046],
              [-146.30011959499993, 61.132513739000046],
              [-146.32579505099991, 61.13646067900004],
              [-146.3814591139999, 61.13458893400008],
              [-146.43195553299992, 61.13947174700007],
              [-146.4938044909999, 61.13418203300006],
              [-146.5858455069999, 61.13646067900004],
              [-146.60944576699993, 61.13076406500005],
              [-146.63166256399992, 61.11908600500004],
              [-146.6752823559999, 61.08808014500005],
              [-146.7205704419999, 61.064886786000045],
              [-146.8155411449999, 61.03180573100008],
              [-146.85399329299992, 61.005560614000046],
              [-146.8713272779999, 60.98517487200007],
              [-146.89093990799992, 60.97207265800006],
              [-146.91136633999992, 60.962103583000044],
              [-146.9487198559999, 60.949652411000045],
              [-146.97671464799993, 60.94578685100004],
              [-147.0048721999999, 60.94794342700004],
              [-147.03156490799992, 60.95770905200004],
              [-146.99396725199992, 60.98338450700004],
              [-146.97883053299992, 60.99872467700004],
              [-146.9837540359999, 61.005560614000046],
              [-147.0047908189999, 61.00665924700007],
              [-147.01105709499993, 61.005560614000046],
              [-147.01569576699993, 61.00218333500004],
              [-147.0167537099999, 60.998114325000074],
              [-147.01691646999993, 60.99433014500005],
              [-147.0184626939999, 60.991888739000046],
              [-147.0341690749999, 60.981634833000044],
              [-147.0443009109999, 60.97793203300006],
              [-147.0588272779999, 60.978216864000046],
              [-147.04857337099992, 60.992173570000034],
              [-147.04259192599991, 61.00291575700004],
              [-147.0472305979999, 61.009833075000074],
              [-147.0901993479999, 61.01577383000006],
              [-147.10065670499992, 61.015285549000055],
              [-147.11945553299992, 61.00287506700005],
              [-147.14826412699992, 60.991888739000046],
              [-147.15054277299993, 60.97638580900008],
              [-147.14537512899992, 60.963324286000045],
              [-147.1458634109999, 60.954291083000044],
              [-147.16527258999992, 60.950873114000046],
              [-147.18529212099992, 60.95368073100008],
              [-147.1991267569999, 60.96198151200008],
              [-147.20710201699993, 60.97597890800006],
              [-147.20962480399993, 60.99559153900003],
              [-147.2072647779999, 61.008693752000056],
              [-147.20514889199993, 61.01459381700005],
              [-147.21051998599992, 61.01341380400004],
              [-147.25438391799992, 60.99396393400008],
              [-147.2642716139999, 60.991888739000046],
              [-147.2784317699999, 61.00438060100004],
              [-147.28791256399992, 61.007025458000044],
              [-147.29222571499992, 60.99559153900003],
              [-147.2875056629999, 60.98493073100008],
              [-147.2652888659999, 60.96792226800005],
              [-147.25812740799992, 60.95770905200004],
              [-147.2573136059999, 60.93789297100005],
              [-147.2689102859999, 60.93024323100008],
              [-147.3127335279999, 60.93040599200003],
              [-147.3058162099999, 60.92300039300005],
              [-147.34308834499993, 60.89948151200008],
              [-147.3646134109999, 60.89126211100006],
              [-147.3741348949999, 60.89907461100006],
              [-147.38296464799993, 60.91396719000005],
              [-147.4039607409999, 60.91278717700004],
              [-147.42902584499993, 60.905585028000075],
              [-147.44985917899993, 60.90253327000005],
              [-147.4378962879999, 60.92690664300005],
              [-147.38097083199992, 60.985663153000075],
              [-147.4002579419999, 60.99095286700003],
              [-147.41681881399992, 60.98029205900008],
              [-147.4326065749999, 60.96531810100004],
              [-147.4495743479999, 60.95770905200004],
              [-147.46003170499992, 60.96576569200005],
              [-147.45173092399992, 60.983710028000075],
              [-147.4355362619999, 61.002386786000045],
              [-147.4225968089999, 61.01235586100006],
              [-147.45173092399992, 61.010931708000044],
              [-147.46886145699992, 61.00047435100004],
              [-147.49425208199992, 60.967962958000044],
              [-147.5097550119999, 60.92572663000004],
              [-147.52269446499992, 60.907538153000075],
              [-147.54206295499992, 60.913316148000035],
              [-147.54548092399992, 60.985663153000075],
              [-147.5385636059999, 61.00421784100007],
              [-147.5296931629999, 61.01666901200008],
              [-147.52550208199992, 61.030585028000075],
              [-147.53246008999992, 61.053941148000035],
              [-147.5217179029999, 61.059759833000044],
              [-147.49087480399993, 61.06940338700008],
              [-147.48399817599991, 61.07379791900007],
              [-147.48591061099992, 61.08372630400004],
              [-147.49388587099992, 61.08808014500005],
              [-147.50373287699992, 61.09039948100008],
              [-147.51134192599991, 61.09430573100008],
              [-147.5213516919999, 61.108587958000044],
              [-147.5272517569999, 61.12474192900004],
              [-147.5252579419999, 61.13939036700003],
              [-147.51134192599991, 61.14956289300005],
              [-147.5248917309999, 61.15444570500006],
              [-147.54328365799992, 61.15704987200007],
              [-147.5611466139999, 61.155910549000055],
              [-147.5733943349999, 61.14956289300005],
              [-147.5788468089999, 61.13629791900007],
              [-147.5732315749999, 61.12759023600006],
              [-147.5643611319999, 61.120347398000035],
              [-147.5597224599999, 61.11163971600007],
              [-147.56615149599992, 61.087225653000075],
              [-147.58185787699992, 61.05923086100006],
              [-147.6017960279999, 61.03620026200008],
              [-147.62092037699992, 61.026597398000035],
              [-147.6400040359999, 61.02435944200005],
              [-147.6585994129999, 61.01947663000004],
              [-147.66527258999992, 61.01459381700005],
              [-147.64850826699993, 61.01235586100006],
              [-147.6207576159999, 61.01398346600007],
              [-147.6143692699999, 61.01235586100006],
              [-147.6074112619999, 61.00336334800005],
              [-147.61017818899992, 60.99884674700007],
              [-147.6165665359999, 60.99599844000005],
              [-147.6205948559999, 60.991888739000046],
              [-147.62315833199992, 60.98655833500004],
              [-147.63223222599993, 60.97797272300005],
              [-147.63418535099993, 60.97479889500005],
              [-147.63048255099991, 60.96670156500005],
              [-147.6216934889999, 60.96458567900004],
              [-147.61164303299992, 60.96430084800005],
              [-147.60383053299992, 60.96116771000004],
              [-147.60008704299992, 60.94985586100006],
              [-147.60562089799993, 60.92365143400008],
              [-147.6006973949999, 60.90997955900008],
              [-147.5967911449999, 60.88568756700005],
              [-147.59902910099993, 60.86908600500004],
              [-147.61066646999993, 60.86155833500004],
              [-147.6646622389999, 60.858303127000056],
              [-147.68195553299992, 60.86469147300005],
              [-147.66608639199993, 60.900458075000074],
              [-147.6850479809999, 60.89858633000006],
              [-147.71214758999992, 60.89118073100008],
              [-147.7304581369999, 60.88947174700007],
              [-147.7327774729999, 60.900091864000046],
              [-147.72720292899993, 60.91815827000005],
              [-147.7164607409999, 60.93569570500006],
              [-147.7031143869999, 60.94472890800006],
              [-147.7031143869999, 60.950873114000046],
              [-147.7276505199999, 60.94757721600007],
              [-147.7694392569999, 60.92914459800005],
              [-147.78571529899992, 60.93040599200003],
              [-147.78864498599992, 60.92670319200005],
              [-147.7901912099999, 60.92377350500004],
              [-147.7924698559999, 60.91681549700007],
              [-147.7701309889999, 60.911444403000075],
              [-147.7777400379999, 60.898871161000045],
              [-147.81297766799992, 60.87579987200007],
              [-147.77708899599992, 60.86701080900008],
              [-147.7713923819999, 60.864935614000046],
              [-147.76683508999992, 60.86188385600008],
              [-147.7578018869999, 60.85366445500006],
              [-147.75137285099993, 60.845038153000075],
              [-147.7546280589999, 60.841009833000044],
              [-147.76382402299993, 60.83893463700008],
              [-147.78331458199992, 60.82953522300005],
              [-147.79556230399993, 60.827378648000035],
              [-147.87018795499992, 60.83771393400008],
              [-147.8860977859999, 60.84520091400003],
              [-147.8987930979999, 60.85594310100004],
              [-147.9085587229999, 60.868353583000044],
              [-147.9169815749999, 60.88816966400003],
              [-147.9222305979999, 60.895697333000044],
              [-147.9308162099999, 60.90420156500005],
              [-147.9380997389999, 60.90875885600008],
              [-148.01984615799992, 60.94163646000004],
              [-148.0389298169999, 60.94472890800006],
              [-148.05040442599991, 60.95014069200005],
              [-148.0342911449999, 60.96234772300005],
              [-147.9979141919999, 60.98191966400003],
              [-147.9995011059999, 60.987616278000075],
              [-148.00214596299992, 60.99013906500005],
              [-148.00263424399992, 60.99286530200004],
              [-147.9979141919999, 60.999335028000075],
              [-147.98884029899992, 61.00486888200004],
              [-147.96642005099991, 61.00796133000006],
              [-147.9569392569999, 61.01235586100006],
              [-147.9446915359999, 61.026597398000035],
              [-147.9290665359999, 61.05377838700008],
              [-147.9153946609999, 61.067572333000044],
              [-147.92983964799993, 61.07273997600004],
              [-147.9359024729999, 61.07379791900007],
              [-147.91808020699992, 61.09430573100008],
              [-147.8839412099999, 61.11937083500004],
              [-147.8459366529999, 61.14057038000004],
              [-147.8163956369999, 61.14956289300005],
              [-147.80475826699993, 61.15521881700005],
              [-147.77285722599993, 61.18203359600005],
              [-147.7577205069999, 61.191107489000046],
              [-147.7161759109999, 61.20184967700004],
              [-147.7021378249999, 61.21320221600007],
              [-147.71056067599991, 61.232082424000055],
              [-147.73696855399993, 61.21556224200003],
              [-147.75104732999992, 61.212591864000046],
              [-147.76520748599992, 61.218451239000046],
              [-147.72321529899992, 61.255926825000074],
              [-147.71336829299992, 61.273098049000055],
              [-147.7304581369999, 61.27985260600008],
              [-147.7480362619999, 61.27606842700004],
              [-147.76219641799992, 61.264960028000075],
              [-147.78571529899992, 61.23895905200004],
              [-147.8334854809999, 61.19757721600007],
              [-147.8437393869999, 61.191107489000046],
              [-147.8732804029999, 61.18187083500004],
              [-147.90868079299992, 61.160142320000034],
              [-147.9637751939999, 61.11473216400003],
              [-147.99852454299992, 61.06268952000005],
              [-148.0209854809999, 61.03742096600007],
              [-148.0494278639999, 61.026597398000035],
              [-148.07201087099992, 61.02440013200004],
              [-148.07990475199992, 61.026597398000035],
              [-148.08625240799992, 61.03139883000006],
              [-148.09382076699993, 61.044175523000035],
              [-148.11335201699993, 61.061835028000075],
              [-148.12189693899992, 61.07599518400008],
              [-148.13190670499992, 61.088324286000045],
              [-148.14875240799992, 61.09430573100008],
              [-148.13996334499993, 61.11286041900007],
              [-148.14594479099992, 61.11790599200003],
              [-148.1601456369999, 61.11469147300005],
              [-148.19611568899992, 61.10236237200007],
              [-148.25861568899992, 61.09430573100008],
              [-148.27839107999992, 61.08893463700008],
              [-148.30516516799992, 61.07709381700005],
              [-148.39057369699992, 61.067287502000056],
              [-148.40949459499993, 61.06012604400007],
              [-148.39716549399992, 61.05536530200004],
              [-148.37262936099992, 61.05223216400003],
              [-148.36107337099992, 61.046535549000055],
              [-148.37128658799992, 61.04059479400007],
              [-148.39142818899992, 61.02411530200004],
              [-148.39891516799992, 61.016058661000045],
              [-148.40790768099993, 61.010931708000044],
              [-148.4498184889999, 60.999335028000075],
              [-148.4498184889999, 60.991888739000046],
              [-148.41034908799992, 60.986395575000074],
              [-148.3755997389999, 60.999212958000044],
              [-148.3138321609999, 61.040269273000035],
              [-148.27948971299992, 61.05499909100007],
              [-148.2276505199999, 61.07099030200004],
              [-148.1777237619999, 61.076605536000045],
              [-148.14875240799992, 61.06012604400007],
              [-148.16380774599992, 61.05581289300005],
              [-148.16694088399993, 61.04645416900007],
              [-148.16681881399992, 61.03461334800005],
              [-148.17235266799992, 61.02326080900008],
              [-148.20714270699992, 60.98191966400003],
              [-148.21837317599991, 60.97247955900008],
              [-148.2519425119999, 60.954738674000055],
              [-148.26484127499992, 60.950873114000046],
              [-148.28172766799992, 60.95368073100008],
              [-148.3135880199999, 60.96979401200008],
              [-148.3331192699999, 60.97138092700004],
              [-148.32587643099993, 60.96112702000005],
              [-148.2890518869999, 60.93382396000004],
              [-148.28119869699992, 60.92059967700004],
              [-148.28600012899992, 60.913397528000075],
              [-148.29670162699992, 60.90692780200004],
              [-148.30646725199992, 60.895697333000044],
              [-148.30817623599992, 60.880194403000075],
              [-148.3057755199999, 60.86469147300005],
              [-148.30719967399992, 60.852728583000044],
              [-148.32042395699992, 60.84788646000004],
              [-148.33873450399992, 60.850043036000045],
              [-148.37511145699992, 60.859361070000034],
              [-148.39582271999993, 60.86155833500004],
              [-148.34821529899992, 60.83392975500004],
              [-148.33287512899992, 60.81940338700008],
              [-148.3542374339999, 60.81313711100006],
              [-148.38337154899992, 60.81704336100006],
              [-148.4283341139999, 60.835272528000075],
              [-148.4572647779999, 60.841009833000044],
              [-148.5234268869999, 60.84039948100008],
              [-148.58637447799993, 60.83047109600005],
              [-148.70368404899992, 60.792669989000046],
              [-148.67011471299992, 60.78546784100007],
              [-148.63508053299992, 60.79360586100006],
              [-148.60004635299993, 60.806341864000046],
              [-148.56647701699993, 60.81313711100006],
              [-148.5599259109999, 60.81110260600008],
              [-148.55146236899992, 60.802069403000075],
              [-148.54633541599992, 60.800116278000075],
              [-148.53795325399992, 60.80093008000006],
              [-148.47630774599992, 60.81427643400008],
              [-148.46015377499992, 60.81240469000005],
              [-148.4498184889999, 60.800116278000075],
              [-148.48802649599992, 60.79051341400003],
              [-148.5783585279999, 60.78172435100004],
              [-148.6111954419999, 60.762884833000044],
              [-148.62360592399992, 60.752386786000045],
              [-148.65086829299992, 60.73737213700008],
              [-148.6627091139999, 60.72500234600005],
              [-148.6777237619999, 60.70034414300005],
              [-148.68871008999992, 60.68939850500004],
              [-148.70368404899992, 60.684027411000045],
              [-148.70368404899992, 60.67658112200007],
              [-148.6674698559999, 60.67450592700004],
              [-148.65587317599991, 60.67658112200007],
              [-148.6436661449999, 60.68203359600005],
              [-148.6213272779999, 60.69513580900008],
              [-148.5982559889999, 60.69961172100005],
              [-148.58958899599992, 60.704738674000055],
              [-148.58320064999992, 60.71234772300005],
              [-148.5807999339999, 60.721584377000056],
              [-148.57892818899992, 60.73578522300005],
              [-148.5735977859999, 60.739935614000046],
              [-148.56489010299993, 60.74079010600008],
              [-148.55284583199992, 60.74481842700004],
              [-148.5295304029999, 60.757025458000044],
              [-148.51020260299993, 60.76349518400008],
              [-148.48997962099992, 60.76609935100004],
              [-148.46410071499992, 60.76654694200005],
              [-148.45307369699992, 60.76862213700008],
              [-148.44001217399992, 60.77757396000004],
              [-148.43305416599992, 60.77960846600007],
              [-148.37470455599993, 60.77960846600007],
              [-148.37470455599993, 60.772772528000075],
              [-148.38837643099993, 60.772772528000075],
              [-148.38837643099993, 60.76654694200005],
              [-148.37885494699992, 60.76422760600008],
              [-148.3709610669999, 60.759751695000034],
              [-148.36493893099993, 60.753241278000075],
              [-148.36107337099992, 60.74481842700004],
              [-148.3854874339999, 60.73969147300005],
              [-148.39509029899992, 60.73468659100007],
              [-148.40196692599991, 60.72500234600005],
              [-148.4011124339999, 60.71580638200004],
              [-148.39509029899992, 60.689520575000074],
              [-148.39891516799992, 60.684027411000045],
              [-148.42634029899992, 60.67951080900008],
              [-148.43451900899993, 60.66742584800005],
              [-148.4299210279999, 60.62872955900008],
              [-148.42011471299992, 60.63495514500005],
              [-148.39582271999993, 60.656683661000045],
              [-148.3826798169999, 60.66168854400007],
              [-148.37043209499993, 60.66380442900004],
              [-148.3587540359999, 60.66742584800005],
              [-148.34740149599992, 60.67658112200007],
              [-148.3425186839999, 60.70331452000005],
              [-148.30842037699992, 60.73456452000005],
              [-148.2646378249999, 60.76080963700008],
              [-148.2307022779999, 60.772772528000075],
              [-148.2307022779999, 60.76654694200005],
              [-148.2482804029999, 60.75438060100004],
              [-148.2562149729999, 60.737982489000046],
              [-148.25495357999992, 60.71857330900008],
              [-148.24498450399992, 60.697699286000045],
              [-148.23713131399992, 60.68854401200008],
              [-148.2189835279999, 60.67328522300005],
              [-148.21019446499992, 60.66290924700007],
              [-148.2064102859999, 60.653509833000044],
              [-148.20592200399992, 60.64545319200005],
              [-148.20417232999992, 60.63751862200007],
              [-148.19660396999993, 60.62872955900008],
              [-148.20628821499992, 60.62055084800005],
              [-148.21918697799993, 60.61408112200007],
              [-148.23371334499993, 60.609808661000045],
              [-148.24811764199993, 60.608303127000056],
              [-148.31525631399992, 60.549709377000056],
              [-148.33698482999992, 60.54059479400007],
              [-148.36107337099992, 60.54682038000004],
              [-148.36107337099992, 60.55304596600007],
              [-148.3635147779999, 60.56232330900008],
              [-148.41645260299993, 60.55923086100006],
              [-148.4299210279999, 60.570746161000045],
              [-148.4396866529999, 60.58706289300005],
              [-148.46247311099992, 60.58930084800005],
              [-148.48847408799992, 60.58222077000005],
              [-148.52448482999992, 60.56000397300005],
              [-148.5994766919999, 60.52968984600005],
              [-148.65587317599991, 60.49843984600005],
              [-148.6694229809999, 60.48822663000004],
              [-148.68476314999992, 60.47211334800005],
              [-148.68989010299993, 60.45722077000005],
              [-148.6725968089999, 60.45062897300005],
              [-148.6514786449999, 60.45718008000006],
              [-148.61530514199993, 60.48574453300006],
              [-148.55793209499993, 60.504339911000045],
              [-148.51414954299992, 60.52846914300005],
              [-148.4702042309999, 60.546210028000075],
              [-148.4299210279999, 60.53937409100007],
              [-148.42707271999993, 60.52887604400007],
              [-148.40904700399992, 60.52456289300005],
              [-148.38593502499992, 60.52252838700008],
              [-148.36786861899992, 60.51894765800006],
              [-148.38154049399992, 60.505845445000034],
              [-148.34850012899992, 60.509466864000046],
              [-148.34154212099992, 60.50665924700007],
              [-148.35114498599992, 60.495306708000044],
              [-148.35883541599992, 60.48379140800006],
              [-148.3483780589999, 60.48065827000005],
              [-148.32990475199992, 60.48322174700007],
              [-148.3132218089999, 60.48883698100008],
              [-148.27660071499992, 60.49494049700007],
              [-148.26850338399993, 60.47288646000004],
              [-148.26378333199992, 60.45107656500005],
              [-148.23753821499992, 60.457464911000045],
              [-148.22472083199992, 60.46914297100005],
              [-148.2236221999999, 60.47833893400008],
              [-148.22785396999993, 60.488348700000074],
              [-148.2307022779999, 60.50214264500005],
              [-148.23285885299993, 60.50580475500004],
              [-148.23664303299992, 60.50991445500006],
              [-148.23835201699993, 60.51520416900007],
              [-148.23412024599992, 60.522365627000056],
              [-148.22846432199992, 60.52562083500004],
              [-148.2132462229999, 60.532416083000044],
              [-148.21019446499992, 60.536322333000044],
              [-148.20592200399992, 60.54633209800005],
              [-148.1959122389999, 60.55451080900008],
              [-148.1845596999999, 60.557806708000044],
              [-148.17609615799992, 60.55304596600007],
              [-148.17365475199992, 60.53998444200005],
              [-148.1771134109999, 60.52533600500004],
              [-148.1834610669999, 60.51276276200008],
              [-148.18976803299992, 60.505845445000034],
              [-148.1663712229999, 60.501613674000055],
              [-148.15461178299992, 60.52513255400004],
              [-148.1483048169999, 60.55776601800005],
              [-148.14130611899992, 60.58038971600007],
              [-148.1308487619999, 60.587225653000075],
              [-148.09382076699993, 60.603583075000074],
              [-148.08360755099991, 60.60488515800006],
              [-148.06916256399992, 60.585923570000034],
              [-148.06000729099992, 60.57802969000005],
              [-148.04576575399992, 60.57416413000004],
              [-148.06684322799993, 60.53937409100007],
              [-148.05516516799992, 60.54124583500004],
              [-148.03339596299992, 60.55145905200004],
              [-148.0252579419999, 60.55304596600007],
              [-148.01178951699993, 60.54779694200005],
              [-148.0068253249999, 60.540676174000055],
              [-148.0042618479999, 60.53278229400007],
              [-147.9979141919999, 60.52578359600005],
              [-147.9849747389999, 60.521551825000074],
              [-147.97077389199993, 60.51894765800006],
              [-147.95982825399992, 60.51276276200008],
              [-147.9569392569999, 60.49843984600005],
              [-147.9622696609999, 60.491888739000046],
              [-147.97370357999992, 60.48529694200005],
              [-147.98696855399993, 60.480169989000046],
              [-147.9979141919999, 60.47797272300005],
              [-147.9847305979999, 60.462225653000075],
              [-147.96373450399992, 60.464178778000075],
              [-147.94440670499992, 60.46889883000006],
              [-147.9359024729999, 60.46116771000004],
              [-147.94188391799992, 60.443060614000046],
              [-147.9570206369999, 60.43610260600008],
              [-147.9979141919999, 60.43695709800005],
              [-147.99535071499992, 60.421535549000055],
              [-148.01239986899992, 60.41071198100008],
              [-148.03685462099992, 60.404282945000034],
              [-148.05626380099991, 60.40216705900008],
              [-148.08556067599991, 60.41909414300005],
              [-148.0970352859999, 60.41937897300005],
              [-148.08735104099992, 60.39598216400003],
              [-148.11091061099992, 60.39948151200008],
              [-148.15644283799992, 60.414943752000056],
              [-148.18232174399992, 60.41648997600004],
              [-148.17084713399993, 60.40961334800005],
              [-148.13508053299992, 60.379339911000045],
              [-148.1282852859999, 60.36810944200005],
              [-148.1424454419999, 60.35521067900004],
              [-148.1697891919999, 60.352850653000075],
              [-148.19855709499993, 60.35639069200005],
              [-148.2170304029999, 60.36127350500004],
              [-148.2161759109999, 60.37970612200007],
              [-148.2335098949999, 60.384751695000034],
              [-148.25458736899992, 60.378973700000074],
              [-148.26484127499992, 60.36469147300005],
              [-148.2597550119999, 60.348537502000056],
              [-148.24730383999992, 60.34902578300006],
              [-148.23167883999992, 60.35309479400007],
              [-148.2170304029999, 60.34760163000004],
              [-148.21515865799992, 60.321926174000055],
              [-148.24091549399992, 60.29767487200007],
              [-148.27623450399992, 60.27960846600007],
              [-148.31037350199992, 60.270412502000056],
              [-148.32005774599992, 60.260972398000035],
              [-148.33002682199992, 60.25885651200008],
              [-148.33873450399992, 60.26243724200003],
              [-148.35358639199993, 60.27997467700004],
              [-148.36107337099992, 60.28620026200008],
              [-148.37970943899992, 60.28742096600007],
              [-148.3908585279999, 60.277411200000074],
              [-148.39305579299992, 60.264960028000075],
              [-148.38495846299992, 60.25885651200008],
              [-148.3675430979999, 60.253892320000034],
              [-148.36445064999992, 60.242254950000074],
              [-148.37079830599993, 60.22846100500004],
              [-148.38154049399992, 60.217230536000045],
              [-148.39814205599993, 60.20917389500005],
              [-148.41523189999992, 60.204413153000075],
              [-148.43089758999992, 60.19765859600005],
              [-148.44298255099991, 60.18374258000006],
              [-148.40868079299992, 60.18610260600008],
              [-148.3752335279999, 60.19277578300006],
              [-148.34337317599991, 60.20331452000005],
              [-148.3138321609999, 60.217230536000045],
              [-148.25812740799992, 60.25177643400008],
              [-148.22581946499992, 60.26040273600006],
              [-148.18976803299992, 60.25141022300005],
              [-148.18976803299992, 60.24518463700008],
              [-148.22907467399992, 60.242254950000074],
              [-148.26484127499992, 60.23216380400004],
              [-148.2471817699999, 60.22638580900008],
              [-148.2040909499999, 60.22016022300005],
              [-148.18976803299992, 60.21108633000006],
              [-148.18561764199993, 60.196519273000035],
              [-148.19135494699992, 60.18341705900008],
              [-148.21019446499992, 60.15582916900007],
              [-148.18761145699992, 60.16551341400003],
              [-148.1601456369999, 60.21308014500005],
              [-148.14130611899992, 60.23216380400004],
              [-148.1326798169999, 60.23419830900008],
              [-148.11884518099993, 60.23452383000006],
              [-148.10594641799992, 60.23086172100005],
              [-148.1003311839999, 60.22093333500004],
              [-148.1025284499999, 60.20913320500006],
              [-148.10834713399993, 60.20111725500004],
              [-148.16490637899992, 60.14907461100006],
              [-148.1888321609999, 60.134751695000034],
              [-148.21674557199992, 60.12909577000005],
              [-148.27863521999993, 60.12726471600007],
              [-148.29857337099992, 60.13646067900004],
              [-148.28595943899992, 60.16266510600008],
              [-148.30304928299992, 60.16400788000004],
              [-148.3229874339999, 60.17259349200003],
              [-148.3331192699999, 60.17011139500005],
              [-148.36786861899992, 60.11823151200008],
              [-148.3730362619999, 60.08673737200007],
              [-148.38792883999992, 60.05849844000005],
              [-148.4116104809999, 60.03856028900003],
              [-148.44298255099991, 60.03229401200008],
              [-148.44298255099991, 60.025458075000074],
              [-148.40746008999992, 60.01805247600004],
              [-148.40196692599991, 60.01552969000005],
              [-148.40387936099992, 60.007066148000035],
              [-148.40693111899992, 60.003241278000075],
              [-148.4075821609999, 59.99957916900007],
              [-148.40196692599991, 59.99135976800005],
              [-148.43537350199992, 59.95929596600007],
              [-148.45136471299992, 59.95502350500004],
              [-148.4709366529999, 59.97089264500005],
              [-148.4990128249999, 60.01325104400007],
              [-148.51805579299992, 60.028509833000044],
              [-148.5460098949999, 60.03229401200008],
              [-148.53441321499992, 60.01312897300005],
              [-148.5355118479999, 59.99701569200005],
              [-148.54698645699992, 59.98484935100004],
              [-148.56647701699993, 59.97768789300005],
              [-148.5478409499999, 59.969631252000056],
              [-148.56175696499992, 59.957098700000074],
              [-148.64557857999992, 59.923163153000075],
              [-148.65587317599991, 59.923041083000044],
              [-148.66576087099992, 59.93113841400003],
              [-148.66454016799992, 59.93976471600007],
              [-148.65746008999992, 59.946966864000046],
              [-148.64964758999992, 59.95099518400008],
              [-148.66523189999992, 59.95579661700003],
              [-148.6802872389999, 59.954738674000055],
              [-148.69526119699992, 59.95172760600008],
              [-148.71051998599992, 59.95099518400008],
              [-148.7230118479999, 59.95384349200003],
              [-148.7451065749999, 59.962144273000035],
              [-148.7589005199999, 59.964056708000044],
              [-148.7878311839999, 59.95856354400007],
              [-148.84418697799993, 59.937201239000046],
              [-148.8749893869999, 59.93732330900008],
              [-148.89232337099992, 59.94599030200004],
              [-148.9260147779999, 59.97150299700007],
              [-148.9506729809999, 59.97768789300005],
              [-149.00202389199993, 59.96727122600004],
              [-149.02318274599992, 59.967678127000056],
              [-149.01899166599992, 59.98452383000006],
              [-149.07477779899992, 59.96946849200003],
              [-149.10688229099992, 59.96898021000004],
              [-149.12140865799992, 59.99135976800005],
              [-149.10948645699992, 60.00275299700007],
              [-149.05439205599993, 60.03774648600006],
              [-149.03880774599992, 60.052801825000074],
              [-149.07013912699992, 60.06093984600005],
              [-149.10309811099992, 60.05809153900003],
              [-149.1347550119999, 60.04751211100006],
              [-149.1927384109999, 60.014105536000045],
              [-149.2001846999999, 60.00836823100008],
              [-149.20518958199992, 59.99823639500005],
              [-149.2064102859999, 59.987616278000075],
              [-149.2088516919999, 59.97797272300005],
              [-149.21760006399992, 59.97089264500005],
              [-149.2186173169999, 59.95530833500004],
              [-149.23395748599992, 59.939886786000045],
              [-149.2444962229999, 59.92609284100007],
              [-149.23127193899992, 59.91559479400007],
              [-149.2408341139999, 59.90273672100005],
              [-149.25788326699993, 59.88825104400007],
              [-149.2752579419999, 59.87726471600007],
              [-149.2858780589999, 59.874660549000055],
              [-149.29308020699992, 59.88764069200005],
              [-149.29059811099992, 59.924994208000044],
              [-149.29967200399992, 59.94717031500005],
              [-149.30040442599991, 59.956366278000075],
              [-149.29950924399992, 59.974269924000055],
              [-149.30488033799992, 59.977850653000075],
              [-149.31611080599993, 59.97943756700005],
              [-149.3260391919999, 59.98432038000004],
              [-149.32746334499993, 59.99750397300005],
              [-149.3214005199999, 60.00104401200008],
              [-149.2983292309999, 60.00653717700004],
              [-149.2933243479999, 60.011786200000074],
              [-149.3001602859999, 60.023138739000046],
              [-149.3151749339999, 60.025051174000055],
              [-149.34113521999993, 60.02240631700005],
              [-149.3541153639999, 60.09096914300005],
              [-149.36286373599992, 60.11127350500004],
              [-149.38365637899992, 60.122381903000075],
              [-149.40868079299992, 60.12372467700004],
              [-149.42988033799992, 60.11481354400007],
              [-149.43622799399992, 60.103216864000046],
              [-149.4420059889999, 60.08340078300006],
              [-149.44440670499992, 60.06289297100005],
              [-149.44074459499993, 60.049709377000056],
              [-149.42304439999992, 60.02240631700005],
              [-149.41852779899992, 60.01805247600004],
              [-149.3889054029999, 59.99750397300005],
              [-149.41828365799992, 59.99127838700008],
              [-149.43248450399992, 59.98615143400008],
              [-149.44416256399992, 59.97768789300005],
              [-149.44880123599992, 59.968085028000075],
              [-149.4526261059999, 59.94505442900004],
              [-149.45783443899992, 59.93732330900008],
              [-149.4721573559999, 59.93158600500004],
              [-149.48407955599993, 59.932928778000075],
              [-149.4964493479999, 59.93646881700005],
              [-149.5124405589999, 59.93732330900008],
              [-149.52696692599991, 59.93211497600004],
              [-149.55463619699992, 59.91347890800006],
              [-149.56366939999992, 59.909409898000035],
              [-149.57685299399992, 59.89760976800005],
              [-149.60614986899992, 59.84552643400008],
              [-149.62507076699993, 59.833685614000046],
              [-149.62787838399993, 59.82831452000005],
              [-149.62035071499992, 59.81659577000005],
              [-149.60846920499992, 59.80487702000005],
              [-149.59809322799993, 59.79954661700003],
              [-149.5861710279999, 59.78937409100007],
              [-149.5806778639999, 59.78652578300006],
              [-149.57123775899993, 59.78510163000004],
              [-149.53974361899992, 59.78652578300006],
              [-149.54649817599991, 59.774725653000075],
              [-149.54889889199993, 59.76609935100004],
              [-149.5483292309999, 59.758978583000044],
              [-149.54657955599993, 59.75177643400008],
              [-149.53010006399992, 59.738267320000034],
              [-149.52265377499992, 59.72797272300005],
              [-149.5267227859999, 59.71759674700007],
              [-149.53754635299993, 59.716498114000046],
              [-149.55097408799992, 59.72321198100008],
              [-149.5732315749999, 59.73810455900008],
              [-149.58808346299992, 59.742254950000074],
              [-149.63593502499992, 59.74494049700007],
              [-149.60053463399993, 59.76630280200004],
              [-149.59496008999992, 59.77220286700003],
              [-149.60187740799992, 59.78270091400003],
              [-149.6182755199999, 59.78457265800006],
              [-149.63678951699993, 59.78388092700004],
              [-149.64960689999992, 59.78652578300006],
              [-149.64496822799993, 59.801947333000044],
              [-149.67198645699992, 59.81708405200004],
              [-149.66669674399992, 59.83055247600004],
              [-149.6600235669999, 59.84039948100008],
              [-149.64509029899992, 59.873928127000056],
              [-149.64216061099992, 59.88548411700003],
              [-149.65009518099993, 59.91225820500006],
              [-149.6702774729999, 59.93984609600005],
              [-149.69697018099993, 59.95978424700007],
              [-149.72472083199992, 59.964056708000044],
              [-149.7408341139999, 59.948472398000035],
              [-149.73859615799992, 59.89085521000004],
              [-149.74889075399992, 59.86469147300005],
              [-149.76593990799992, 59.83966705900008],
              [-149.77696692599991, 59.83535390800006],
              [-149.7997940749999, 59.841131903000075],
              [-149.8299454419999, 59.856675523000035],
              [-149.84699459499993, 59.85834381700005],
              [-149.86811275899993, 59.84796784100007],
              [-149.85509192599991, 59.84316640800006],
              [-149.84113521999993, 59.835191148000035],
              [-149.79255123599992, 59.79975006700005],
              [-149.76911373599992, 59.78652578300006],
              [-149.7503555979999, 59.70465729400007],
              [-149.75263424399992, 59.682847398000035],
              [-149.7460831369999, 59.667181708000044],
              [-149.75654049399992, 59.66205475500004],
              [-149.77436275899993, 59.66486237200007],
              [-149.78986568899992, 59.67324453300006],
              [-149.80854244699992, 59.68744538000004],
              [-149.8139542309999, 59.693019924000055],
              [-149.80622311099992, 59.71010976800005],
              [-149.8072403639999, 59.71759674700007],
              [-149.82148189999992, 59.725490627000056],
              [-149.85704505099991, 59.733587958000044],
              [-149.8718155589999, 59.741522528000075],
              [-149.91156979099992, 59.77399323100008],
              [-149.9199112619999, 59.77903880400004],
              [-149.96300208199992, 59.78335195500006],
              [-150.0186661449999, 59.798529364000046],
              [-150.03168697799993, 59.799261786000045],
              [-150.0385636059999, 59.79254791900007],
              [-150.04063880099991, 59.77562083500004],
              [-149.97797604099992, 59.75177643400008],
              [-149.97272701699993, 59.74640534100007],
              [-149.96088619699992, 59.72748444200005],
              [-149.95197506399992, 59.723089911000045],
              [-149.92735755099991, 59.721136786000045],
              [-149.91649329299992, 59.71759674700007],
              [-149.95746822799993, 59.66982656500005],
              [-150.0026749339999, 59.64203522300005],
              [-150.0126846999999, 59.628241278000075],
              [-150.03119869699992, 59.63711172100005],
              [-150.0423477859999, 59.64948151200008],
              [-150.06049557199992, 59.676662502000056],
              [-150.07465572799993, 59.685532945000034],
              [-150.09772701699993, 59.69554271000004],
              [-150.11925208199992, 59.70034414300005],
              [-150.1287735669999, 59.693426825000074],
              [-150.12067623599992, 59.680975653000075],
              [-150.10468502499992, 59.67210521000004],
              [-150.0931290359999, 59.66205475500004],
              [-150.0983780589999, 59.64557526200008],
              [-150.1069229809999, 59.62982819200005],
              [-150.10712643099993, 59.614935614000046],
              [-150.1002091139999, 59.602728583000044],
              [-150.08783932199992, 59.59467194200005],
              [-150.11030025899993, 59.58002350500004],
              [-150.12267005099991, 59.57501862200007],
              [-150.13560950399992, 59.57298411700003],
              [-150.15021725199992, 59.57632070500006],
              [-150.1674698559999, 59.59137604400007],
              [-150.17719479099992, 59.59467194200005],
              [-150.1983536449999, 59.58698151200008],
              [-150.1994522779999, 59.56883372600004],
              [-150.18940182199992, 59.548081773000035],
              [-150.17719479099992, 59.53204987200007],
              [-150.23688717399992, 59.53384023600006],
              [-150.25678463399993, 59.52610911700003],
              [-150.2454727859999, 59.49787018400008],
              [-150.27973385299993, 59.49640534100007],
              [-150.2912491529999, 59.49286530200004],
              [-150.32624264199993, 59.47597890800006],
              [-150.34797115799992, 59.469956773000035],
              [-150.3698624339999, 59.46946849200003],
              [-150.38947506399992, 59.477443752000056],
              [-150.38227291599992, 59.47923411700003],
              [-150.3698624339999, 59.48387278900003],
              [-150.36152096299992, 59.484808661000045],
              [-150.37584387899992, 59.49518463700008],
              [-150.38324947799993, 59.49787018400008],
              [-150.36982174399992, 59.502020575000074],
              [-150.3557022779999, 59.50446198100008],
              [-150.34333248599992, 59.50885651200008],
              [-150.33482825399992, 59.51837799700007],
              [-150.34992428299992, 59.518744208000044],
              [-150.35749264199993, 59.52570221600007],
              [-150.3588761059999, 59.53587474200003],
              [-150.3553360669999, 59.54629140800006],
              [-150.34479732999992, 59.555568752000056],
              [-150.31529700399992, 59.56391022300005],
              [-150.3034561839999, 59.56989166900007],
              [-150.29466712099992, 59.58234284100007],
              [-150.29466712099992, 59.59210846600007],
              [-150.29584713399993, 59.60106028900003],
              [-150.29047604099992, 59.61115143400008],
              [-150.27009029899992, 59.62689850500004],
              [-150.2663468089999, 59.635931708000044],
              [-150.27338619699992, 59.64935944200005],
              [-150.2507218089999, 59.66771067900004],
              [-150.22907467399992, 59.69550202000005],
              [-150.22435462099992, 59.71539948100008],
              [-150.25226803299992, 59.710150458000044],
              [-150.2787979809999, 59.69208405200004],
              [-150.35435950399992, 59.60228099200003],
              [-150.37958736899992, 59.587551174000055],
              [-150.3931778639999, 59.57672760600008],
              [-150.42426510299993, 59.53204987200007],
              [-150.4651993479999, 59.49445221600007],
              [-150.46930904899992, 59.478176174000055],
              [-150.4794815749999, 59.46735260600008],
              [-150.49274654899992, 59.46576569200005],
              [-150.50617428299992, 59.477443752000056],
              [-150.50157630099991, 59.49428945500006],
              [-150.54194088399993, 59.515285549000055],
              [-150.5533341139999, 59.53571198100008],
              [-150.54511471299992, 59.550441799000055],
              [-150.5058487619999, 59.58185455900008],
              [-150.49250240799992, 59.600897528000075],
              [-150.53010006399992, 59.60187409100007],
              [-150.6166886059999, 59.56439850500004],
              [-150.6569718089999, 59.55247630400004],
              [-150.6569718089999, 59.54629140800006],
              [-150.6374405589999, 59.54120514500005],
              [-150.61432857999992, 59.52875397300005],
              [-150.59357662699992, 59.513006903000075],
              [-150.58124752499992, 59.49787018400008],
              [-150.58051510299993, 59.48191966400003],
              [-150.59357662699992, 59.47410716400003],
              [-150.63646399599992, 59.46312083500004],
              [-150.63646399599992, 59.45697663000004],
              [-150.6143692699999, 59.450425523000035],
              [-150.60472571499992, 59.445013739000046],
              [-150.60932369699992, 59.438666083000044],
              [-150.62970943899992, 59.42963288000004],
              [-150.6530655589999, 59.423895575000074],
              [-150.72862708199992, 59.42218659100007],
              [-150.73395748599992, 59.41478099200003],
              [-150.74262447799993, 59.39858633000006],
              [-150.7546280589999, 59.38239166900007],
              [-150.76996822799993, 59.37494538000004],
              [-150.78827877499992, 59.37148672100005],
              [-150.84906979099992, 59.34369538000004],
              [-150.85627193899992, 59.33926015800006],
              [-150.8638809889999, 59.33551666900007],
              [-150.91767330599993, 59.32656484600005],
              [-150.91730709499993, 59.31708405200004],
              [-150.90876217399992, 59.30263906500005],
              [-150.88634192599991, 59.275051174000055],
              [-150.8919571609999, 59.257513739000046],
              [-150.93110104099992, 59.24823639500005],
              [-150.96589107999992, 59.234442450000074],
              [-150.95860755099991, 59.20368073100008],
              [-150.99657141799992, 59.226548570000034],
              [-151.01154537699992, 59.24164459800005],
              [-151.00951087099992, 59.255194403000075],
              [-150.99640865799992, 59.26813385600008],
              [-150.9980362619999, 59.272650458000044],
              [-151.0081680979999, 59.27440013200004],
              [-151.02009029899992, 59.27875397300005],
              [-151.03498287699992, 59.29246653900003],
              [-151.04255123599992, 59.29718659100007],
              [-151.0541886059999, 59.299261786000045],
              [-151.06598873599992, 59.29588450700004],
              [-151.0783585279999, 59.28925202000005],
              [-151.09247799399992, 59.28510163000004],
              [-151.1216934889999, 59.29393138200004],
              [-151.17662512899992, 59.30101146000004],
              [-151.22870846299992, 59.31635163000004],
              [-151.24347896999993, 59.318426825000074],
              [-151.2580460279999, 59.317694403000075],
              [-151.2733048169999, 59.312933661000045],
              [-151.25763912699992, 59.29840729400007],
              [-151.23591061099992, 59.296535549000055],
              [-151.2131241529999, 59.296942450000074],
              [-151.19452877499992, 59.28937409100007],
              [-151.18097896999993, 59.279364325000074],
              [-151.12995357999992, 59.25828685100004],
              [-151.10920162699992, 59.25336334800005],
              [-151.09935462099992, 59.24896881700005],
              [-151.09516354099992, 59.24127838700008],
              [-151.09723873599992, 59.23261139500005],
              [-151.10273189999992, 59.224676825000074],
              [-151.1103409499999, 59.21893952000005],
              [-151.14631100199992, 59.20954010600008],
              [-151.1616104809999, 59.20770905200004],
              [-151.1826065749999, 59.21743398600006],
              [-151.21186275899993, 59.22329336100006],
              [-151.22211666599992, 59.22418854400007],
              [-151.27460689999992, 59.22162506700005],
              [-151.2944229809999, 59.22418854400007],
              [-151.34919186099992, 59.24209219000005],
              [-151.3729141919999, 59.246527411000045],
              [-151.38910885299993, 59.25531647300005],
              [-151.3968399729999, 59.25828685100004],
              [-151.40961666599992, 59.26007721600007],
              [-151.4178360669999, 59.259100653000075],
              [-151.50129146999993, 59.23468659100007],
              [-151.5197647779999, 59.22418854400007],
              [-151.5080460279999, 59.22117747600004],
              [-151.4857071609999, 59.21954987200007],
              [-151.47260494699992, 59.21670156500005],
              [-151.48908443899992, 59.199652411000045],
              [-151.5167130199999, 59.19676341400003],
              [-151.5753067699999, 59.20368073100008],
              [-151.60126705599993, 59.20172760600008],
              [-151.61396236899992, 59.19749583500004],
              [-151.6159561839999, 59.18939850500004],
              [-151.60383053299992, 59.18203359600005],
              [-151.57628333199992, 59.18821849200003],
              [-151.56810462099992, 59.175767320000034],
              [-151.68281002499992, 59.16303131700005],
              [-151.74152584499993, 59.16714101800005],
              [-151.76679439999992, 59.19310130400004],
              [-151.7603653639999, 59.20970286700003],
              [-151.75861568899992, 59.21971263200004],
              [-151.76337643099993, 59.22418854400007],
              [-151.84028072799993, 59.21344635600008],
              [-151.8679093089999, 59.21369049700007],
              [-151.89313717399992, 59.22064850500004],
              [-151.9107559889999, 59.23786041900007],
              [-151.89484615799992, 59.23810455900008],
              [-151.88666744699992, 59.24160390800006],
              [-151.88715572799993, 59.24835846600007],
              [-151.8970841139999, 59.25828685100004],
              [-151.9064835279999, 59.26146067900004],
              [-151.94493567599991, 59.26508209800005],
              [-151.96178137899992, 59.27065664300005],
              [-151.9771622389999, 59.279364325000074],
              [-151.9866837229999, 59.29279205900008],
              [-151.9858292309999, 59.312933661000045],
              [-151.9764298169999, 59.325425523000035],
              [-151.95946204299992, 59.33734772300005],
              [-151.92503821499992, 59.35390859600005],
              [-151.89659583199992, 59.35956452000005],
              [-151.8151749339999, 59.35390859600005],
              [-151.83539791599992, 59.36758047100005],
              [-151.88129635299993, 59.38532135600008],
              [-151.90021725199992, 59.398871161000045],
              [-151.8940323559999, 59.41282786700003],
              [-151.86420650899993, 59.42690664300005],
              [-151.8077286449999, 59.44383372600004],
              [-151.7482804029999, 59.44562409100007],
              [-151.7182511059999, 59.450873114000046],
              [-151.7053116529999, 59.466864325000074],
              [-151.68907630099991, 59.48029205900008],
              [-151.6518448559999, 59.48590729400007],
              [-151.46821041599992, 59.47809479400007],
              [-151.44151770699992, 59.466864325000074],
              [-151.42316646999993, 59.45392487200007],
              [-151.4006241529999, 59.44513580900008],
              [-151.3821915359999, 59.44476959800005],
              [-151.3763321609999, 59.45697663000004],
              [-151.3900040359999, 59.47378164300005],
              [-151.4404190749999, 59.49363841400003],
              [-151.45148678299992, 59.50812409100007],
              [-151.44147701699993, 59.53221263200004],
              [-151.4174698559999, 59.54629140800006],
              [-151.36274166599992, 59.55996328300006],
              [-151.34125729099992, 59.56118398600006],
              [-151.29169674399992, 59.55609772300005],
              [-151.2733048169999, 59.55996328300006],
              [-151.26630611899992, 59.571193752000056],
              [-151.26520748599992, 59.58466217700004],
              [-151.25885982999992, 59.596136786000045],
              [-151.23607337099992, 59.600897528000075],
              [-151.19477291599992, 59.59760163000004],
              [-151.17414303299992, 59.60008372600004],
              [-151.17402096299992, 59.61115143400008],
              [-151.20026607999992, 59.63178131700005],
              [-151.20136471299992, 59.64118073100008],
              [-151.1845596999999, 59.655503648000035],
              [-151.17096920499992, 59.661810614000046],
              [-151.14179439999992, 59.670355536000045],
              [-151.12995357999992, 59.676662502000056],
              [-151.12043209499993, 59.687160549000055],
              [-151.1074112619999, 59.71067942900004],
              [-151.09894771999993, 59.720689195000034],
              [-151.07514400899993, 59.73769765800006],
              [-150.9927872389999, 59.77903880400004],
              [-151.02350826699993, 59.79555898600006],
              [-151.0662735669999, 59.79677969000005],
              [-151.10912024599992, 59.78652578300006],
              [-151.15448971299992, 59.75995514500005],
              [-151.21251380099991, 59.74494049700007],
              [-151.38133704299992, 59.67495351800005],
              [-151.41730709499993, 59.66982656500005],
              [-151.43097896999993, 59.66620514500005],
              [-151.44953365799992, 59.657416083000044],
              [-151.46576900899993, 59.64630768400008],
              [-151.47260494699992, 59.63568756700005],
              [-151.46467037699992, 59.62592194200005],
              [-151.44635982999992, 59.61815013200004],
              [-151.43036861899992, 59.612494208000044],
              [-151.42572994699992, 59.61151764500005],
              [-151.4105118479999, 59.60773346600007],
              [-151.4306534499999, 59.61180247600004],
              [-151.74693762899992, 59.682847398000035],
              [-151.78083248599992, 59.69220612200007],
              [-151.83136959499993, 59.71621328300006],
              [-151.87177486899992, 59.74945709800005],
              [-151.88288326699993, 59.78652578300006],
              [-151.87706458199992, 59.79677969000005],
              [-151.84870357999992, 59.820013739000046],
              [-151.84186764199993, 59.831284898000035],
              [-151.8314102859999, 59.855454820000034],
              [-151.73912512899992, 59.98822663000004],
              [-151.73326575399992, 60.00836823100008],
              [-151.7249649729999, 60.02488841400003],
              [-151.7060440749999, 60.04169342700004],
              [-151.4654434889999, 60.18768952000005],
              [-151.42963619699992, 60.21637604400007],
              [-151.40326900899993, 60.25242747600004],
              [-151.3906143869999, 60.29979075700004],
              [-151.3931778639999, 60.34442780200004],
              [-151.39024817599991, 60.359442450000074],
              [-151.37604732999992, 60.37181224200003],
              [-151.36200924399992, 60.37775299700007],
              [-151.34850012899992, 60.380926825000074],
              [-151.31798255099991, 60.38239166900007],
              [-151.30597896999993, 60.38694896000004],
              [-151.3018692699999, 60.39801666900007],
              [-151.3006485669999, 60.42332591400003],
              [-151.28294837099992, 60.48786041900007],
              [-151.2807511059999, 60.508978583000044],
              [-151.28278561099992, 60.53705475500004],
              [-151.28949947799993, 60.550767320000034],
              [-151.3217667309999, 60.57416413000004],
              [-151.3338516919999, 60.59218984600005],
              [-151.3549698559999, 60.63963450700004],
              [-151.37779700399992, 60.658270575000074],
              [-151.3958634109999, 60.678941148000035],
              [-151.41173255099991, 60.70209381700005],
              [-151.41730709499993, 60.71816640800006],
              [-151.39692135299993, 60.73802317900004],
              [-151.32380123599992, 60.73908112200007],
              [-151.29755611899992, 60.74860260600008],
              [-151.27607174399992, 60.767279364000046],
              [-151.25300045499992, 60.77533600500004],
              [-151.07148189999992, 60.78534577000005],
              [-151.0436905589999, 60.79633209800005],
              [-151.02607174399992, 60.81004466400003],
              [-150.76325436099992, 60.92670319200005],
              [-150.60326087099992, 60.978501695000034],
              [-150.4525040359999, 61.03424713700008],
              [-150.38703365799992, 61.04726797100005],
              [-150.33482825399992, 61.032863674000055],
              [-150.32221432199992, 61.01459381700005],
              [-150.31000729099992, 60.989447333000044],
              [-150.29389400899993, 60.96727122600004],
              [-150.25849361899992, 60.95457591400003],
              [-150.23652096299992, 60.94041575700004],
              [-150.22529049399992, 60.93724192900004],
              [-150.04377193899992, 60.91681549700007],
              [-149.97785396999993, 60.938788153000075],
              [-149.9307755199999, 60.94472890800006],
              [-149.85016842399992, 60.973863023000035],
              [-149.82404537699992, 60.978216864000046],
              [-149.7529190749999, 60.973822333000044],
              [-149.7170304029999, 60.96751536700003],
              [-149.6830948559999, 60.95770905200004],
              [-149.6386612619999, 60.93964264500005],
              [-149.6216934889999, 60.93724192900004],
              [-149.5261124339999, 60.93724192900004],
              [-149.50706946499992, 60.934027411000045],
              [-149.46727454299992, 60.919907945000034],
              [-149.1260880199999, 60.88361237200007],
              [-149.10358639199993, 60.87807851800005],
              [-149.09068762899992, 60.87205638200004],
              [-149.0781143869999, 60.86375560100004],
              [-149.05903072799993, 60.856350002000056],
              [-149.03962154899992, 60.852443752000056],
              [-149.02582760299993, 60.854681708000044],
              [-149.06086178299992, 60.89728424700007],
              [-149.11164303299992, 60.928615627000056],
              [-149.1693009109999, 60.946966864000046],
              [-149.22504635299993, 60.950873114000046],
              [-149.33405514199993, 60.93032461100006],
              [-149.35789954299992, 60.93382396000004],
              [-149.3780411449999, 60.946966864000046],
              [-149.48371334499993, 60.982407945000034],
              [-149.5163468089999, 60.98859284100007],
              [-149.61799068899992, 60.99461497600004],
              [-149.78315182199992, 61.045355536000045],
              [-149.82917232999992, 61.073431708000044],
              [-149.90904700399992, 61.09430573100008],
              [-150.06733150899993, 61.15574778900003],
              [-150.0573624339999, 61.172308661000045],
              [-150.0381973949999, 61.193060614000046],
              [-150.0156143869999, 61.206366278000075],
              [-149.99531002499992, 61.20075104400007],
              [-149.9759415359999, 61.198472398000035],
              [-149.9448136059999, 61.20770905200004],
              [-149.91413326699993, 61.22134023600006],
              [-149.8959854809999, 61.232082424000055],
              [-149.88996334499993, 61.24042389500005],
              [-149.87555904899992, 61.273098049000055],
              [-149.86888587099992, 61.282538153000075],
              [-149.81065833199992, 61.331366278000075],
              [-149.7967423169999, 61.33901601800005],
              [-149.78168697799993, 61.340725002000056],
              [-149.7665909499999, 61.34023672100005],
              [-149.75263424399992, 61.34129466400003],
              [-149.73058020699992, 61.35187409100007],
              [-149.7042130199999, 61.38422272300005],
              [-149.68342037699992, 61.39935944200005],
              [-149.65571041599992, 61.40900299700007],
              [-149.32001705599993, 61.47915273600006],
              [-149.2795304029999, 61.481634833000044],
              [-149.26105709499993, 61.48663971600007],
              [-149.24555416599992, 61.49896881700005],
              [-149.27855383999992, 61.50653717700004],
              [-149.41685950399992, 61.49896881700005],
              [-149.40318762899992, 61.50580475500004],
              [-149.42817135299993, 61.51316966400003],
              [-149.6486710279999, 61.48818594000005],
              [-149.75739498599992, 61.45335521000004],
              [-149.79560299399992, 61.42450592700004],
              [-149.81464596299992, 61.41421133000006],
              [-149.86188717399992, 61.39594147300005],
              [-149.87970943899992, 61.38613515800006],
              [-149.89740963399993, 61.37128327000005],
              [-149.91100012899992, 61.35268789300005],
              [-149.91974850199992, 61.31037018400008],
              [-149.92784583199992, 61.28929271000004],
              [-149.93891354099992, 61.27122630400004],
              [-149.95063229099992, 61.259426174000055],
              [-149.9837540359999, 61.24632396000004],
              [-150.28050696499992, 61.25995514500005],
              [-150.29389400899993, 61.265611070000034],
              [-150.3056534499999, 61.27521393400008],
              [-150.30976314999992, 61.28143952000005],
              [-150.31440182199992, 61.28164297100005],
              [-150.3279923169999, 61.273098049000055],
              [-150.32469641799992, 61.27216217700004],
              [-150.32319088399993, 61.26626211100006],
              [-150.3240860669999, 61.258693752000056],
              [-150.3279923169999, 61.25259023600006],
              [-150.3345841139999, 61.25092194200005],
              [-150.4505509109999, 61.25259023600006],
              [-150.49962317599991, 61.26166413000004],
              [-150.5417374339999, 61.28656647300005],
              [-150.56065833199992, 61.32367584800005],
              [-150.54027258999992, 61.36928945500006],
              [-150.5630997389999, 61.36542389500005],
              [-150.58710689999992, 61.351996161000045],
              [-150.60053463399993, 61.33242422100005],
              [-150.5849503249999, 61.294623114000046],
              [-150.6042374339999, 61.29132721600007],
              [-150.63361568899992, 61.29865143400008],
              [-150.6569718089999, 61.31403229400007],
              [-150.6912735669999, 61.27753327000005],
              [-150.73090572799993, 61.253973700000074],
              [-150.89155025899993, 61.21430084800005],
              [-150.94774329299992, 61.211004950000074],
              [-150.95759029899992, 61.207912502000056],
              [-150.97529049399992, 61.194240627000056],
              [-150.98908443899992, 61.191107489000046],
              [-151.00153561099992, 61.19000885600008],
              [-151.02855383999992, 61.18256256700005],
              [-151.03990637899992, 61.177435614000046],
              [-151.0609024729999, 61.163275458000044],
              [-151.12816321499992, 61.094183661000045],
              [-151.14037024599992, 61.078192450000074],
              [-151.15477454299992, 61.064439195000034],
              [-151.1771134109999, 61.053941148000035],
              [-151.2436417309999, 61.03925202000005],
              [-151.31086178299992, 61.032863674000055],
              [-151.3235977859999, 61.02968984600005],
              [-151.34955807199992, 61.01557038000004],
              [-151.36237545499992, 61.01235586100006],
              [-151.43781490799992, 61.01984284100007],
              [-151.47614498599992, 61.01703522300005],
              [-151.5224503249999, 61.00861237200007],
              [-151.5667618479999, 60.99453359600005],
              [-151.6127823559999, 60.965277411000045],
              [-151.64622962099992, 60.95099518400008],
              [-151.68122311099992, 60.92865631700005],
              [-151.72504635299993, 60.92446523600006],
              [-151.74693762899992, 60.91681549700007],
              [-151.75214596299992, 60.898138739000046],
              [-151.7952774729999, 60.86896393400008],
              [-151.8077286449999, 60.84788646000004],
              [-151.80626380099991, 60.83746979400007],
              [-151.8010147779999, 60.82831452000005],
              [-151.7177628249999, 60.743068752000056],
              [-151.71137447799993, 60.72573476800005],
              [-151.74628658799992, 60.71816640800006],
              [-151.77973385299993, 60.72406647300005],
              [-151.84068762899992, 60.75112539300005],
              [-151.86982174399992, 60.759100653000075],
              [-151.86774654899992, 60.75462474200003],
              [-151.8643692699999, 60.74331289300005],
              [-151.86237545499992, 60.73867422100005],
              [-151.91010494699992, 60.73110586100006],
              [-151.9315079419999, 60.72528717700004],
              [-151.96430416599992, 60.70343659100007],
              [-152.0130509109999, 60.68073151200008],
              [-152.03119869699992, 60.67658112200007],
              [-152.04454505099991, 60.67572663000004],
              [-152.0513809889999, 60.673163153000075],
              [-152.06159420499992, 60.66290924700007],
              [-152.0627335279999, 60.66046784100007],
              [-152.10130774599992, 60.61383698100008],
              [-152.1093643869999, 60.608303127000056],
              [-152.1209610669999, 60.603583075000074],
              [-152.14313717399992, 60.59756094000005],
              [-152.1712540359999, 60.58087799700007],
              [-152.23290106699991, 60.559880906000046],
              [-152.31550045499992, 60.505845445000034],
              [-152.3295792309999, 60.49249909100007],
              [-152.3400772779999, 60.47614166900007],
              [-152.34337317599991, 60.45742422100005],
              [-152.3359268869999, 60.43695709800005],
              [-152.31757564999992, 60.42055898600006],
              [-152.29450436099992, 60.41278717700004],
              [-152.24592037699992, 60.40216705900008],
              [-152.24592037699992, 60.39598216400003],
              [-152.36811275899993, 60.357855536000045],
              [-152.39740963399993, 60.33392975500004],
              [-152.4003800119999, 60.32680898600006],
              [-152.40392005099991, 60.309800523000035],
              [-152.40766354099992, 60.30320872600004],
              [-152.41596432199992, 60.297756252000056],
              [-152.4677628249999, 60.28229401200008],
              [-152.51264400899993, 60.274603583000044],
              [-152.5345352859999, 60.265692450000074],
              [-152.5963028639999, 60.22846100500004],
              [-152.61615963399993, 60.224269924000055],
              [-152.63398189999992, 60.22988515800006],
              [-152.6518448559999, 60.23895905200004],
              [-152.6717423169999, 60.24518463700008],
              [-152.80553137899992, 60.23509349200003],
              [-152.8498429029999, 60.24518463700008],
              [-152.84089107999992, 60.25604889500005],
              [-152.8249405589999, 60.25657786700003],
              [-152.8060196609999, 60.25299713700008],
              [-152.7878311839999, 60.25141022300005],
              [-152.7878311839999, 60.25885651200008],
              [-152.83954830599993, 60.26837799700007],
              [-152.86359615799992, 60.26581452000005],
              [-152.89081783799992, 60.25141022300005],
              [-152.89854895699992, 60.275376695000034],
              [-152.8978165359999, 60.29515208500004],
              [-152.90558834499993, 60.30853913000004],
              [-152.9385880199999, 60.31346263200004],
              [-153.01219641799992, 60.31346263200004],
              [-153.04845130099991, 60.30963776200008],
              [-153.0826309889999, 60.29979075700004],
              [-153.1054581369999, 60.285589911000045],
              [-153.10362708199992, 60.27708567900004],
              [-153.08698482999992, 60.277329820000034],
              [-153.06525631399992, 60.28953685100004],
              [-153.03795325399992, 60.29938385600008],
              [-152.99689693899992, 60.300848700000074],
              [-152.95661373599992, 60.29389069200005],
              [-152.93183346299992, 60.27871328300006],
              [-152.92975826699993, 60.27024974200003],
              [-152.9334610669999, 60.253119208000044],
              [-152.93183346299992, 60.24518463700008],
              [-152.92271887899992, 60.237209377000056],
              [-152.89740963399993, 60.22736237200007],
              [-152.8626602859999, 60.20770905200004],
              [-152.76732337099992, 60.190619208000044],
              [-152.74286861899992, 60.174709377000056],
              [-152.73253333199992, 60.17011139500005],
              [-152.72431393099993, 60.16933828300006],
              [-152.7065323559999, 60.171210028000075],
              [-152.69843502499992, 60.17011139500005],
              [-152.68305416599992, 60.16282786700003],
              [-152.67662512899992, 60.15794505400004],
              [-152.6816300119999, 60.15582916900007],
              [-152.6862686839999, 60.151597398000035],
              [-152.68443762899992, 60.14248281500005],
              [-152.67780514199993, 60.13336823100008],
              [-152.6679581369999, 60.12909577000005],
              [-152.65790768099993, 60.12636953300006],
              [-152.59028072799993, 60.092230536000045],
              [-152.57856197799993, 60.08120351800005],
              [-152.57860266799992, 60.07013580900008],
              [-152.59797115799992, 60.042669989000046],
              [-152.61095130099991, 60.03335195500006],
              [-152.63011633999992, 60.03229401200008],
              [-152.63011633999992, 60.025458075000074],
              [-152.6263321609999, 60.02415599200003],
              [-152.61713619699992, 60.01927317900004],
              [-152.6647843089999, 59.99469635600008],
              [-152.67792721299992, 59.98452383000006],
              [-152.69013424399992, 59.96698639500005],
              [-152.7045792309999, 59.93065013200004],
              [-152.71886145699992, 59.91559479400007],
              [-152.73790442599991, 59.90839264500005],
              [-152.80829830599993, 59.89630768400008],
              [-152.8311661449999, 59.88739655200004],
              [-152.8428848949999, 59.88422272300005],
              [-152.85667883999992, 59.882066148000035],
              [-152.90546627499992, 59.88621653900003],
              [-152.9144180979999, 59.88548411700003],
              [-152.93480383999992, 59.87962474200003],
              [-153.02118893099993, 59.88890208500004],
              [-153.0460098949999, 59.88666413000004],
              [-153.09190833199992, 59.87689850500004],
              [-153.22972571499992, 59.868475653000075],
              [-153.24335689999992, 59.86245351800005],
              [-153.26203365799992, 59.84845612200007],
              [-153.2791641919999, 59.83234284100007],
              [-153.2880753249999, 59.820013739000046],
              [-153.25654049399992, 59.82123444200005],
              [-153.2264298169999, 59.82868073100008],
              [-153.1964005199999, 59.83270905200004],
              [-153.15082760299993, 59.819647528000075],
              [-153.1376846999999, 59.821478583000044],
              [-153.1252335279999, 59.82526276200008],
              [-153.05927486899992, 59.833644924000055],
              [-153.01386471299992, 59.83234284100007],
              [-153.00568600199992, 59.827053127000056],
              [-153.00007076699993, 59.81317780200004],
              [-153.00007076699993, 59.80036041900007],
              [-153.0052384109999, 59.79271067900004],
              [-153.01134192599991, 59.78595612200007],
              [-153.01923580599993, 59.76284414300005],
              [-153.0444229809999, 59.722357489000046],
              [-153.0552872389999, 59.710150458000044],
              [-153.07929439999992, 59.70136139500005],
              [-153.13947506399992, 59.68691640800006],
              [-153.15156002499992, 59.67324453300006],
              [-153.1662491529999, 59.66400788000004],
              [-153.1998184889999, 59.65420156500005],
              [-153.23664303299992, 59.64789459800005],
              [-153.26081295499992, 59.64935944200005],
              [-153.26768958199992, 59.656683661000045],
              [-153.2783096999999, 59.67690664300005],
              [-153.2880753249999, 59.682847398000035],
              [-153.30744381399992, 59.68183014500005],
              [-153.31598873599992, 59.67206452000005],
              [-153.3148087229999, 59.66087474200003],
              [-153.30512447799993, 59.655503648000035],
              [-153.3010147779999, 59.652411200000074],
              [-153.30646725199992, 59.64557526200008],
              [-153.31720943899992, 59.63882070500006],
              [-153.32905025899993, 59.63568756700005],
              [-153.34601803299992, 59.63690827000005],
              [-153.39110266799992, 59.64935944200005],
              [-153.39911861899992, 59.650458075000074],
              [-153.42524166599992, 59.64935944200005],
              [-153.42524166599992, 59.655503648000035],
              [-153.40912838399993, 59.66356028900003],
              [-153.3990372389999, 59.67210521000004],
              [-153.35895748599992, 59.720770575000074],
              [-153.34540768099993, 59.72553131700005],
              [-153.32221432199992, 59.71759674700007],
              [-153.33637447799993, 59.730536200000074],
              [-153.3814591139999, 59.741400458000044],
              [-153.45258541599992, 59.792669989000046],
              [-153.4515274729999, 59.775458075000074],
              [-153.4544571609999, 59.76154205900008],
              [-153.45392818899992, 59.74689362200007],
              [-153.44261633999992, 59.72748444200005],
              [-153.44542395699992, 59.716782945000034],
              [-153.4654434889999, 59.67462799700007],
              [-153.4730118479999, 59.66233958500004],
              [-153.49071204299992, 59.650091864000046],
              [-153.5131729809999, 59.641791083000044],
              [-153.5370987619999, 59.637152411000045],
              [-153.55903072799993, 59.63568756700005],
              [-153.5732315749999, 59.64215729400007],
              [-153.5986221999999, 59.672756252000056],
              [-153.6108292309999, 59.682847398000035],
              [-153.6041153639999, 59.68740469000005],
              [-153.60118567599991, 59.688788153000075],
              [-153.59654700399992, 59.68968333500004],
              [-153.59654700399992, 59.69717031500005],
              [-153.62267005099991, 59.69521719000005],
              [-153.6259659499999, 59.684759833000044],
              [-153.6214493479999, 59.67011139500005],
              [-153.62389075399992, 59.655503648000035],
              [-153.6429337229999, 59.64834219000005],
              [-153.69562740799992, 59.64468008000006],
              [-153.7064102859999, 59.63198476800005],
              [-153.62043209499993, 59.628241278000075],
              [-153.61217200399992, 59.62669505400004],
              [-153.57038326699993, 59.60911692900004],
              [-153.56602942599991, 59.60927969000005],
              [-153.56928463399993, 59.59467194200005],
              [-153.58641516799992, 59.56745026200008],
              [-153.62193762899992, 59.55524323100008],
              [-153.79181881399992, 59.54291413000004],
              [-153.8118790359999, 59.55613841400003],
              [-153.83360755099991, 59.55963776200008],
              [-153.85578365799992, 59.55560944200005],
              [-153.87714596299992, 59.54629140800006],
              [-153.83991451699993, 59.54437897300005],
              [-153.8115128249999, 59.538275458000044],
              [-153.78693600199992, 59.52753327000005],
              [-153.74107825399992, 59.497748114000046],
              [-153.72577877499992, 59.48224518400008],
              [-153.72472083199992, 59.466050523000035],
              [-153.74738521999993, 59.450100002000056],
              [-153.7514542309999, 59.44025299700007],
              [-153.78022213399993, 59.43398672100005],
              [-153.84357662699992, 59.42963288000004],
              [-153.89659583199992, 59.43219635600008],
              [-153.9124649729999, 59.42963288000004],
              [-153.92149817599991, 59.424261786000045],
              [-153.93573971299992, 59.40839264500005],
              [-153.94599361899992, 59.40228913000004],
              [-154.0279434889999, 59.38861725500004],
              [-154.03510494699992, 59.38934967700004],
              [-154.04755611899992, 59.39468008000006],
              [-154.05585689999992, 59.39545319200005],
              [-154.0607804029999, 59.39325592700004],
              [-154.07152258999992, 59.38393789300005],
              [-154.07636471299992, 59.38117096600007],
              [-154.0947159499999, 59.37885163000004],
              [-154.1452530589999, 59.38117096600007],
              [-154.11164303299992, 59.36005280200004],
              [-154.06623287699992, 59.34833405200004],
              [-154.02265377499992, 59.35146719000005],
              [-153.99445553299992, 59.37494538000004],
              [-153.98485266799992, 59.37055084800005],
              [-153.97468014199993, 59.36810944200005],
              [-153.96418209499993, 59.367254950000074],
              [-153.95343990799992, 59.36815013200004],
              [-153.95343990799992, 59.361314195000034],
              [-154.0272110669999, 59.34170156500005],
              [-154.1119278639999, 59.30487702000005],
              [-154.12775631399992, 59.294175523000035],
              [-154.14020748599992, 59.281683661000045],
              [-154.1452530589999, 59.26821523600006],
              [-154.1498917309999, 59.23533763200004],
              [-154.14435787699992, 59.22406647300005],
              [-154.12352454299992, 59.22418854400007],
              [-154.1308487619999, 59.20815664300005],
              [-154.14631100199992, 59.20254140800006],
              [-154.18622799399992, 59.20368073100008],
              [-154.17943274599992, 59.18353913000004],
              [-154.1974991529999, 59.173163153000075],
              [-154.22529049399992, 59.16937897300005],
              [-154.24767005099991, 59.16889069200005],
              [-154.22846432199992, 59.16266510600008],
              [-154.22032630099991, 59.161444403000075],
              [-154.2294815749999, 59.15570709800005],
              [-154.23949133999992, 59.151597398000035],
              [-154.25011145699992, 59.14923737200007],
              [-154.26130123599992, 59.148423570000034],
              [-154.25287838399993, 59.130519924000055],
              [-154.23505611899992, 59.12759023600006],
              [-154.19306393099993, 59.134751695000034],
              [-154.17731686099992, 59.129787502000056],
              [-154.17194576699993, 59.11859772300005],
              [-154.17699133999992, 59.107123114000046],
              [-154.19245357999992, 59.101263739000046],
              [-154.18293209499993, 59.09552643400008],
              [-154.17878170499992, 59.093817450000074],
              [-154.17878170499992, 59.08698151200008],
              [-154.1983536449999, 59.07697174700007],
              [-154.1998184889999, 59.055853583000044],
              [-154.18732662699992, 59.03497955900008],
              [-154.16510982999992, 59.02558014500005],
              [-154.14037024599992, 59.03115469000005],
              [-154.1210831369999, 59.04437897300005],
              [-154.10322018099993, 59.060248114000046],
              [-154.08259029899992, 59.07330963700008],
              [-154.02196204299992, 59.08392975500004],
              [-153.8947647779999, 59.065619208000044],
              [-153.83613033799992, 59.06655508000006],
              [-153.81586666599992, 59.07245514500005],
              [-153.8080948559999, 59.07379791900007],
              [-153.7115372389999, 59.070746161000045],
              [-153.68879146999993, 59.063666083000044],
              [-153.6686905589999, 59.05267975500004],
              [-153.65180416599992, 59.03856028900003],
              [-153.63288326699993, 59.01732005400004],
              [-153.62389075399992, 59.01129791900007],
              [-153.58307857999992, 59.00055573100008],
              [-153.57270260299993, 58.99481842700004],
              [-153.5609024729999, 58.99070872600004],
              [-153.54157467399992, 58.98940664300005],
              [-153.52232825399992, 58.99070872600004],
              [-153.51060950399992, 58.99481842700004],
              [-153.4974259109999, 59.00348541900007],
              [-153.48717200399992, 59.00250885600008],
              [-153.46686764199993, 58.991400458000044],
              [-153.4272354809999, 58.98118724200003],
              [-153.4150284499999, 58.97402578300006],
              [-153.38068600199992, 58.940659898000035],
              [-153.36998450399992, 58.93618398600006],
              [-153.33930416599992, 58.93618398600006],
              [-153.33161373599992, 58.93378327000005],
              [-153.3322647779999, 58.92820872600004],
              [-153.33564205599993, 58.92145416900007],
              [-153.33588619699992, 58.915716864000046],
              [-153.3226212229999, 58.89447663000004],
              [-153.3128555979999, 58.88906484600005],
              [-153.2949112619999, 58.888373114000046],
              [-153.2949112619999, 58.88153717700004],
              [-153.30907141799992, 58.87734609600005],
              [-153.3631485669999, 58.87409088700008],
              [-153.3499649729999, 58.868353583000044],
              [-153.33429928299992, 58.866115627000056],
              [-153.27082271999993, 58.87140534100007],
              [-153.25947018099993, 58.86888255400004],
              [-153.26414954299992, 58.85736725500004],
              [-153.28913326699993, 58.84414297100005],
              [-153.33836829299992, 58.85504791900007],
              [-153.3631485669999, 58.84739817900004],
              [-153.3775528639999, 58.82904694200005],
              [-153.39521236899992, 58.78217194200005],
              [-153.4081925119999, 58.76113515800006],
              [-153.42467200399992, 58.74437083500004],
              [-153.4388321609999, 58.733587958000044],
              [-153.52765865799992, 58.696600653000075],
              [-153.56025143099993, 58.69476959800005],
              [-153.57612057199992, 58.69086334800005],
              [-153.58287512899992, 58.67918528900003],
              [-153.59028072799993, 58.65859609600005],
              [-153.6087540359999, 58.64443594000005],
              [-153.63312740799992, 58.63495514500005],
              [-153.69066321499992, 58.62156810100004],
              [-153.7955216139999, 58.61399974200003],
              [-153.86375891799992, 58.61981842700004],
              [-153.8994034499999, 58.61668528900003],
              [-153.9124649729999, 58.60032786700003],
              [-153.91022701699993, 58.59271881700005],
              [-153.90607662699992, 58.58812083500004],
              [-153.8997696609999, 58.58624909100007],
              [-153.9042862619999, 58.57990143400008],
              [-153.9127091139999, 58.56850820500006],
              [-153.91889400899993, 58.55609772300005],
              [-153.92963619699992, 58.54083893400008],
              [-153.92951412699992, 58.53790924700007],
              [-153.93085689999992, 58.53563060100004],
              [-153.93919837099992, 58.53204987200007],
              [-153.9462784499999, 58.53266022300005],
              [-153.95433508999992, 58.53587474200003],
              [-153.96332760299993, 58.53729889500005],
              [-153.97333736899992, 58.53204987200007],
              [-153.96125240799992, 58.528509833000044],
              [-153.9323624339999, 58.52399323100008],
              [-153.92552649599992, 58.518459377000056],
              [-153.93012447799993, 58.51154205900008],
              [-153.9423721999999, 58.50291575700004],
              [-153.95665442599991, 58.49526601800005],
              [-153.96711178299992, 58.491115627000056],
              [-154.0013321609999, 58.491115627000056],
              [-154.0423477859999, 58.496079820000034],
              [-154.08165442599991, 58.49518463700008],
              [-154.1104630199999, 58.47748444200005],
              [-154.0964249339999, 58.46771881700005],
              [-154.0800675119999, 58.436712958000044],
              [-154.06891842399992, 58.42218659100007],
              [-154.06708736899992, 58.41742584800005],
              [-154.0689591139999, 58.41303131700005],
              [-154.06920325399992, 58.409857489000046],
              [-154.0623673169999, 58.40859609600005],
              [-154.03168697799993, 58.40859609600005],
              [-154.02074133999992, 58.404282945000034],
              [-154.0080460279999, 58.394964911000045],
              [-154.0002335279999, 58.38556549700007],
              [-154.00434322799993, 58.381293036000045],
              [-154.01524817599991, 58.37954336100006],
              [-154.0618790359999, 58.364569403000075],
              [-154.08857174399992, 58.36074453300006],
              [-154.1900528639999, 58.36074453300006],
              [-154.19684811099992, 58.35496653900003],
              [-154.19102942599991, 58.35211823100008],
              [-154.1948136059999, 58.346584377000056],
              [-154.20665442599991, 58.33966705900008],
              [-154.21760006399992, 58.33661530200004],
              [-154.24339758999992, 58.33462148600006],
              [-154.30011959499993, 58.320379950000074],
              [-154.3187149729999, 58.31073639500005],
              [-154.32274329299992, 58.29873281500005],
              [-154.3643692699999, 58.28510163000004],
              [-154.35578365799992, 58.27944570500006],
              [-154.35138912699992, 58.27138906500005],
              [-154.3535050119999, 58.263332424000055],
              [-154.3643692699999, 58.25775788000004],
              [-154.35309811099992, 58.25543854400007],
              [-154.34382076699993, 58.259466864000046],
              [-154.33442135299993, 58.26601797100005],
              [-154.32274329299992, 58.27138906500005],
              [-154.30833899599992, 58.273423570000034],
              [-154.28136145699992, 58.27415599200003],
              [-154.26813717399992, 58.27826569200005],
              [-154.27196204299992, 58.29564036700003],
              [-154.25352942599991, 58.29987213700008],
              [-154.20665442599991, 58.29873281500005],
              [-154.2029923169999, 58.302069403000075],
              [-154.1992081369999, 58.308294989000046],
              [-154.19404049399992, 58.31484609600005],
              [-154.18622799399992, 58.31915924700007],
              [-154.1713761059999, 58.32176341400003],
              [-154.1653946609999, 58.31915924700007],
              [-154.1611221999999, 58.31313711100006],
              [-154.1213272779999, 58.279730536000045],
              [-154.1517227859999, 58.27098216400003],
              [-154.2060440749999, 58.267564195000034],
              [-154.24767005099991, 58.25775788000004],
              [-154.18761145699992, 58.25067780200004],
              [-154.1653946609999, 58.23940664300005],
              [-154.16572018099993, 58.216782945000034],
              [-154.18805904899992, 58.19818756700005],
              [-154.22118079299992, 58.191392320000034],
              [-154.25560462099992, 58.19399648600006],
              [-154.28180904899992, 58.203111070000034],
              [-154.28925533799992, 58.20001862200007],
              [-154.30231686099992, 58.19627513200004],
              [-154.28754635299993, 58.18158600500004],
              [-154.23578854099992, 58.15534088700008],
              [-154.2271622389999, 58.141058661000045],
              [-154.24677486899992, 58.12641022300005],
              [-154.28034420499992, 58.13304271000004],
              [-154.3370255199999, 58.162095445000034],
              [-154.3491104809999, 58.14508698100008],
              [-154.34544837099992, 58.13336823100008],
              [-154.33576412699992, 58.12221914300005],
              [-154.3295792309999, 58.10687897300005],
              [-154.33600826699993, 58.08539459800005],
              [-154.35277258999992, 58.08222077000005],
              [-154.37006588399993, 58.09064362200007],
              [-154.38646399599992, 58.117621161000045],
              [-154.40599524599992, 58.12799713700008],
              [-154.42780514199993, 58.136419989000046],
              [-154.44318600199992, 58.14447663000004],
              [-154.4482315749999, 58.15143463700008],
              [-154.45128333199992, 58.160142320000034],
              [-154.45274817599991, 58.169623114000046],
              [-154.4531143869999, 58.178900458000044],
              [-154.4583634109999, 58.18773021000004],
              [-154.47052975199992, 58.194240627000056],
              [-154.49408932199992, 58.203111070000034],
              [-154.46772213399993, 58.14704010600008],
              [-154.46039791599992, 58.11505768400008],
              [-154.4698380199999, 58.089829820000034],
              [-154.4991348949999, 58.08779531500005],
              [-154.57701575399992, 58.12571849200003],
              [-154.61078854099992, 58.12055084800005],
              [-154.60590572799993, 58.11375560100004],
              [-154.55341549399992, 58.08307526200008],
              [-154.55304928299992, 58.07957591400003],
              [-154.5456436839999, 58.07111237200007],
              [-154.55195064999992, 58.05231354400007],
              [-154.5662735669999, 58.03351471600007],
              [-154.5831192699999, 58.02496979400007],
              [-154.6312149729999, 58.03119538000004],
              [-154.6447647779999, 58.03546784100007],
              [-154.6483048169999, 58.04547760600008],
              [-154.64838619699992, 58.05703359600005],
              [-154.6517227859999, 58.06598541900007],
              [-154.6699112619999, 58.072333075000074],
              [-154.6927384109999, 58.06891510600008],
              [-154.71568762899992, 58.05890534100007],
              [-154.7342423169999, 58.04547760600008],
              [-154.73790442599991, 58.03945547100005],
              [-154.74140377499992, 58.025091864000046],
              [-154.74730383999992, 58.01752350500004],
              [-154.75556393099993, 58.012600002000056],
              [-154.76691646999993, 58.008246161000045],
              [-154.77887936099992, 58.005072333000044],
              [-154.78888912699992, 58.003892320000034],
              [-154.8104141919999, 58.00812409100007],
              [-154.85627193899992, 58.02692291900007],
              [-154.88105221299992, 58.03119538000004],
              [-154.97386633999992, 58.03119538000004],
              [-155.02314205599993, 58.02558014500005],
              [-155.0401505199999, 58.017238674000055],
              [-155.02851314999992, 58.003892320000034],
              [-155.04499264199993, 57.97638580900008],
              [-155.0634659499999, 57.96238841400003],
              [-155.0886124339999, 57.95742422100005],
              [-155.12531490799992, 57.956732489000046],
              [-155.07673092399992, 57.91616445500006],
              [-155.06867428299992, 57.897365627000056],
              [-155.09740149599992, 57.88031647300005],
              [-155.13792883999992, 57.873114325000074],
              [-155.25507564999992, 57.88031647300005],
              [-155.22443600199992, 57.85814036700003],
              [-155.22028561099992, 57.85028717700004],
              [-155.22724361899992, 57.84210846600007],
              [-155.24339758999992, 57.83685944200005],
              [-155.27521725199992, 57.833197333000044],
              [-155.30821692599991, 57.83881256700005],
              [-155.32551021999993, 57.839544989000046],
              [-155.33698482999992, 57.833197333000044],
              [-155.33466549399992, 57.82648346600007],
              [-155.3096817699999, 57.79840729400007],
              [-155.34565182199992, 57.80532461100006],
              [-155.35810299399992, 57.80524323100008],
              [-155.35810299399992, 57.79840729400007],
              [-155.3361710279999, 57.790716864000046],
              [-155.31208248599992, 57.77521393400008],
              [-155.29914303299992, 57.75682200700004],
              [-155.31029212099992, 57.74042389500005],
              [-155.3212784499999, 57.73655833500004],
              [-155.35118567599991, 57.730536200000074],
              [-155.37543697799993, 57.72833893400008],
              [-155.3853653639999, 57.72614166900007],
              [-155.3943985669999, 57.72573476800005],
              [-155.40587317599991, 57.72955963700008],
              [-155.43342037699992, 57.745794989000046],
              [-155.4901016919999, 57.762884833000044],
              [-155.5048721999999, 57.76430898600006],
              [-155.52936764199993, 57.772365627000056],
              [-155.55109615799992, 57.78803131700005],
              [-155.57477779899992, 57.798814195000034],
              [-155.60509192599991, 57.792222398000035],
              [-155.6174210279999, 57.78066640800006],
              [-155.62816321499992, 57.762884833000044],
              [-155.6357315749999, 57.743353583000044],
              [-155.63862057199992, 57.72646719000005],
              [-155.6279190749999, 57.70815664300005],
              [-155.5886124339999, 57.68964264500005],
              [-155.5908096999999, 57.67552317900004],
              [-155.61180579299992, 57.66583893400008],
              [-155.70319576699993, 57.64826080900008],
              [-155.76183020699992, 57.64826080900008],
              [-155.77143307199992, 57.64472077000005],
              [-155.76008053299992, 57.637152411000045],
              [-155.73420162699992, 57.62714264500005],
              [-155.73261471299992, 57.62164948100008],
              [-155.73448645699992, 57.61595286700003],
              [-155.73810787699992, 57.611029364000046],
              [-155.74164791599992, 57.60732656500005],
              [-155.73554439999992, 57.59467194200005],
              [-155.73839270699992, 57.57200755400004],
              [-155.73420162699992, 57.55882396000004],
              [-155.74164791599992, 57.552069403000075],
              [-155.7932022779999, 57.544582424000055],
              [-155.80573482999992, 57.54791901200008],
              [-155.81012936099992, 57.55573151200008],
              [-155.81183834499993, 57.56492747600004],
              [-155.81615149599992, 57.57249583500004],
              [-155.82587643099993, 57.57925039300005],
              [-155.8315323559999, 57.57957591400003],
              [-155.84776770699992, 57.562567450000074],
              [-155.86180579299992, 57.55890534100007],
              [-155.90404212099992, 57.55654531500005],
              [-155.91295325399992, 57.54828522300005],
              [-155.9241837229999, 57.53139883000006],
              [-155.95006262899992, 57.534369208000044],
              [-155.97870846299992, 57.54791901200008],
              [-156.02045650899993, 57.57680898600006],
              [-156.03404700399992, 57.57143789300005],
              [-156.03400631399992, 57.55560944200005],
              [-156.01537024599992, 57.538397528000075],
              [-156.01537024599992, 57.53156159100007],
              [-156.08214270699992, 57.537176825000074],
              [-156.10472571499992, 57.53156159100007],
              [-156.09125729099992, 57.51943594000005],
              [-156.0511368479999, 57.51788971600007],
              [-156.04271399599992, 57.50731028900003],
              [-156.04291744699992, 57.48969147300005],
              [-156.04149329299992, 57.47483958500004],
              [-156.0355118479999, 57.46356842700004],
              [-156.0222061839999, 57.45644765800006],
              [-156.06065833199992, 57.43024323100008],
              [-156.11274166599992, 57.44717031500005],
              [-156.16759192599991, 57.47361888200004],
              [-156.21458899599992, 57.476263739000046],
              [-156.22187252499992, 57.46832916900007],
              [-156.2260636059999, 57.45685455900008],
              [-156.22826087099992, 57.44220612200007],
              [-156.23875891799992, 57.43695709800005],
              [-156.26825924399992, 57.42963288000004],
              [-156.3088272779999, 57.42487213700008],
              [-156.3388565749999, 57.41543203300006],
              [-156.47162838399993, 57.33978913000004],
              [-156.49372311099992, 57.338324286000045],
              [-156.52074133999992, 57.33307526200008],
              [-156.54462643099993, 57.322699286000045],
              [-156.5572403639999, 57.30560944200005],
              [-156.55463619699992, 57.281683661000045],
              [-156.5364884109999, 57.27912018400008],
              [-156.3919571609999, 57.31484609600005],
              [-156.3548477859999, 57.31134674700007],
              [-156.3443497389999, 57.311835028000075],
              [-156.34833736899992, 57.300482489000046],
              [-156.33995520699992, 57.28530508000006],
              [-156.3443497389999, 57.27090078300006],
              [-156.34919186099992, 57.270412502000056],
              [-156.35029049399992, 57.27216217700004],
              [-156.35004635299993, 57.27496979400007],
              [-156.35118567599991, 57.27765534100007],
              [-156.35737057199992, 57.25214264500005],
              [-156.38402258999992, 57.24054596600007],
              [-156.44737708199992, 57.22992584800005],
              [-156.44737708199992, 57.223089911000045],
              [-156.43089758999992, 57.222723700000074],
              [-156.41059322799993, 57.21865469000005],
              [-156.39325924399992, 57.210638739000046],
              [-156.38593502499992, 57.198879299000055],
              [-156.38097083199992, 57.19367096600007],
              [-156.35810299399992, 57.19049713700008],
              [-156.35118567599991, 57.18829987200007],
              [-156.34601803299992, 57.177801825000074],
              [-156.34906979099992, 57.17332591400003],
              [-156.3548477859999, 57.170355536000045],
              [-156.3580216139999, 57.16474030200004],
              [-156.37592525899993, 57.14325592700004],
              [-156.46064205599993, 57.12563711100006],
              [-156.48835201699993, 57.11383698100008],
              [-156.4705704419999, 57.10150788000004],
              [-156.45360266799992, 57.08649323100008],
              [-156.47081458199992, 57.07916901200008],
              [-156.4818009109999, 57.086004950000074],
              [-156.4890030589999, 57.09642161700003],
              [-156.49518795499992, 57.09955475500004],
              [-156.50206458199992, 57.08958567900004],
              [-156.5032852859999, 57.06321849200003],
              [-156.50885982999992, 57.05174388200004],
              [-156.52306067599991, 57.04584381700005],
              [-156.54279537699992, 57.04539622600004],
              [-156.56261145699992, 57.048163153000075],
              [-156.57709713399993, 57.05174388200004],
              [-156.58995520699992, 57.057074286000045],
              [-156.62547766799992, 57.07904694200005],
              [-156.63170325399992, 57.07282135600008],
              [-156.62547766799992, 57.058579820000034],
              [-156.64537512899992, 57.058579820000034],
              [-156.56537838399993, 57.00454336100006],
              [-156.5497940749999, 56.982855536000045],
              [-156.5742081369999, 56.98322174700007],
              [-156.65705318899992, 56.99795156500005],
              [-156.66828365799992, 56.99852122600004],
              [-156.6783341139999, 57.00018952000005],
              [-156.68696041599992, 57.003973700000074],
              [-156.69115149599992, 57.00918203300006],
              [-156.70433508999992, 57.031236070000034],
              [-156.70872962099992, 57.03339264500005],
              [-156.7155655589999, 57.03807200700004],
              [-156.72443600199992, 57.04279205900008],
              [-156.7763565749999, 57.05174388200004],
              [-156.78477942599991, 57.04913971600007],
              [-156.79149329299992, 57.042669989000046],
              [-156.7949112619999, 57.03465403900003],
              [-156.79308020699992, 57.02753327000005],
              [-156.7864884109999, 57.02301666900007],
              [-156.77668209499993, 57.01788971600007],
              [-156.76752682199992, 57.011786200000074],
              [-156.7626846999999, 57.003973700000074],
              [-156.76341712099992, 56.99201080900008],
              [-156.76915442599991, 56.98688385600008],
              [-156.7767227859999, 56.98346588700008],
              [-156.7831925119999, 56.976629950000074],
              [-156.78620357999992, 56.96775950700004],
              [-156.78795325399992, 56.95107656500005],
              [-156.78998775899993, 56.94188060100004],
              [-156.79755611899992, 56.924261786000045],
              [-156.80943762899992, 56.906683661000045],
              [-156.8244522779999, 56.89728424700007],
              [-156.84150143099993, 56.903998114000046],
              [-156.88935299399992, 56.95209381700005],
              [-156.9045304029999, 56.961818752000056],
              [-156.92743893099993, 56.97052643400008],
              [-156.94928951699993, 56.976223049000055],
              [-156.9612930979999, 56.976629950000074],
              [-156.9515274729999, 56.966498114000046],
              [-156.94672604099992, 56.95457591400003],
              [-156.9474991529999, 56.94330475500004],
              [-156.9544571609999, 56.93504466400003],
              [-156.95002193899992, 56.93008047100005],
              [-156.9446915359999, 56.919989325000074],
              [-156.94086666599992, 56.91453685100004],
              [-156.95331783799992, 56.91107819200005],
              [-156.9960831369999, 56.90770091400003],
              [-157.03046627499992, 56.89008209800005],
              [-157.0401505199999, 56.88727448100008],
              [-157.05036373599992, 56.878159898000035],
              [-157.07843990799992, 56.837103583000044],
              [-157.0916641919999, 56.825832424000055],
              [-157.11274166599992, 56.830511786000045],
              [-157.1697891919999, 56.85464101800005],
              [-157.19098873599992, 56.849676825000074],
              [-157.1835831369999, 56.84202708500004],
              [-157.1624649729999, 56.831284898000035],
              [-157.1478165359999, 56.81513092700004],
              [-157.15998287699992, 56.791083075000074],
              [-157.18940182199992, 56.776271877000056],
              [-157.2151993479999, 56.78034088700008],
              [-157.2392471999999, 56.79148997600004],
              [-157.28685462099992, 56.80170319200005],
              [-157.30589758999992, 56.81159088700008],
              [-157.36542721299992, 56.85146719000005],
              [-157.3919571609999, 56.86322663000004],
              [-157.41966712099992, 56.86737702000005],
              [-157.44391842399992, 56.85651276200008],
              [-157.45966549399992, 56.84642161700003],
              [-157.46589107999992, 56.84003327000005],
              [-157.46845455599993, 56.82892487200007],
              [-157.46381588399993, 56.81582265800006],
              [-157.45270748599992, 56.81093984600005],
              [-157.43919837099992, 56.80914948100008],
              [-157.42743893099993, 56.80536530200004],
              [-157.41755123599992, 56.79677969000005],
              [-157.4088028639999, 56.78546784100007],
              [-157.40424557199992, 56.77374909100007],
              [-157.40632076699993, 56.763739325000074],
              [-157.41222083199992, 56.76894765800006],
              [-157.41950436099992, 56.773138739000046],
              [-157.4271134109999, 56.77529531500005],
              [-157.4339493479999, 56.774318752000056],
              [-157.43834387899992, 56.770738023000035],
              [-157.44428463399993, 56.76463450700004],
              [-157.44843502499992, 56.75893789300005],
              [-157.44733639199993, 56.75690338700008],
              [-157.46247311099992, 56.75657786700003],
              [-157.50910396999993, 56.763739325000074],
              [-157.53193111899992, 56.75226471600007],
              [-157.5522354809999, 56.73041413000004],
              [-157.57343502499992, 56.71662018400008],
              [-157.5987442699999, 56.72964101800005],
              [-157.60558020699992, 56.72215403900003],
              [-157.59516354099992, 56.71759674700007],
              [-157.5865372389999, 56.71234772300005],
              [-157.58063717399992, 56.70538971600007],
              [-157.57823645699992, 56.69546133000006],
              [-157.57079016799992, 56.702337958000044],
              [-157.55785071499992, 56.685532945000034],
              [-157.5353897779999, 56.67755768400008],
              [-157.48578854099992, 56.674994208000044],
              [-157.48058020699992, 56.67064036700003],
              [-157.4631241529999, 56.65143463700008],
              [-157.45787512899992, 56.64704010600008],
              [-157.45518958199992, 56.64321523600006],
              [-157.46259518099993, 56.63450755400004],
              [-157.47382564999992, 56.625433661000045],
              [-157.4826554029999, 56.620347398000035],
              [-157.5124405589999, 56.62010325700004],
              [-157.58381100199992, 56.631293036000045],
              [-157.60871334499993, 56.623480536000045],
              [-157.6337784499999, 56.61115143400008],
              [-157.6646622389999, 56.611395575000074],
              [-157.69416256399992, 56.620306708000044],
              [-157.7154434889999, 56.633978583000044],
              [-157.75080318899992, 56.674261786000045],
              [-157.77289791599992, 56.68439362200007],
              [-157.8041886059999, 56.67812734600005],
              [-157.83771725199992, 56.66592031500005],
              [-157.8482559889999, 56.65766022300005],
              [-157.8615616529999, 56.65228913000004],
              [-157.89789791599992, 56.65485260600008],
              [-157.9134415359999, 56.65387604400007],
              [-157.93268795499992, 56.64280833500004],
              [-157.96552486899992, 56.61237213700008],
              [-157.98237057199992, 56.60610586100006],
              [-158.03327389199993, 56.59870026200008],
              [-158.03880774599992, 56.596991278000075],
              [-158.04450436099992, 56.592962958000044],
              [-158.04889889199993, 56.58763255400004],
              [-158.05060787699992, 56.58222077000005],
              [-158.05512447799993, 56.578558661000045],
              [-158.08539791599992, 56.57880280200004],
              [-158.10521399599992, 56.57221100500004],
              [-158.11876380099991, 56.56289297100005],
              [-158.12763424399992, 56.54950592700004],
              [-158.1331680979999, 56.53034088700008],
              [-158.07502193899992, 56.538316148000035],
              [-157.9636124339999, 56.569973049000055],
              [-157.8819473949999, 56.57062409100007],
              [-157.86896725199992, 56.56903717700004],
              [-157.85883541599992, 56.56513092700004],
              [-157.84992428299992, 56.555568752000056],
              [-157.84809322799993, 56.54637278900003],
              [-157.84727942599991, 56.537176825000074],
              [-157.84142005099991, 56.52728913000004],
              [-157.8369034499999, 56.516506252000056],
              [-157.84296627499992, 56.50731028900003],
              [-157.86253821499992, 56.493475653000075],
              [-157.87714596299992, 56.478216864000046],
              [-157.8841446609999, 56.47614166900007],
              [-157.8997696609999, 56.47573476800005],
              [-157.9565323559999, 56.48261139500005],
              [-158.06798255099991, 56.51190827000005],
              [-158.1263321609999, 56.51666901200008],
              [-158.15290279899992, 56.51325104400007],
              [-158.1650284499999, 56.50739166900007],
              [-158.16791744699992, 56.49689362200007],
              [-158.15868079299992, 56.48920319200005],
              [-158.13190670499992, 56.496161200000074],
              [-158.1263321609999, 56.48663971600007],
              [-158.13829505099991, 56.46552155200004],
              [-158.16633053299992, 56.45892975500004],
              [-158.22191321499992, 56.462103583000044],
              [-158.24897213399993, 56.45750560100004],
              [-158.2615860669999, 56.45799388200004],
              [-158.27375240799992, 56.46580638200004],
              [-158.28205318899992, 56.469956773000035],
              [-158.31810462099992, 56.47573476800005],
              [-158.33869381399992, 56.47540924700007],
              [-158.35505123599992, 56.471136786000045],
              [-158.41572018099993, 56.446478583000044],
              [-158.4310196609999, 56.43805573100008],
              [-158.44298255099991, 56.42804596600007],
              [-158.4553116529999, 56.41429271000004],
              [-158.4714249339999, 56.40029531500005],
              [-158.50849361899992, 56.37836334800005],
              [-158.52354895699992, 56.36591217700004],
              [-158.51825924399992, 56.36074453300006],
              [-158.50995846299992, 56.345404364000046],
              [-158.54108639199993, 56.34247467700004],
              [-158.5767716139999, 56.33026764500005],
              [-158.60981197799993, 56.31391022300005],
              [-158.6328018869999, 56.29824453300006],
              [-158.64643307199992, 56.27065664300005],
              [-158.6201065749999, 56.25617096600007],
              [-158.53722083199992, 56.24982330900008],
              [-158.5444229809999, 56.259751695000034],
              [-158.55353756399992, 56.267279364000046],
              [-158.5612686839999, 56.275458075000074],
              [-158.56456458199992, 56.28733958500004],
              [-158.56049557199992, 56.29930247600004],
              [-158.55085201699993, 56.30817291900007],
              [-158.47297115799992, 56.34275950700004],
              [-158.44819088399993, 56.34052155200004],
              [-158.4416397779999, 56.31191640800006],
              [-158.43268795499992, 56.31753164300005],
              [-158.4236954419999, 56.32062409100007],
              [-158.41498775899993, 56.32103099200003],
              [-158.40693111899992, 56.31875234600005],
              [-158.41022701699993, 56.31297435100004],
              [-158.41437740799992, 56.29824453300006],
              [-158.37275143099993, 56.31875234600005],
              [-158.34544837099992, 56.32558828300006],
              [-158.3359268869999, 56.323431708000044],
              [-158.32221432199992, 56.314113674000055],
              [-158.31476803299992, 56.31191640800006],
              [-158.25873775899993, 56.30508047100005],
              [-158.2272843089999, 56.29633209800005],
              [-158.20824133999992, 56.28392161700003],
              [-158.22590084499993, 56.268784898000035],
              [-158.24775143099993, 56.25568268400008],
              [-158.27228756399992, 56.246527411000045],
              [-158.30980383999992, 56.24087148600006],
              [-158.3353165359999, 56.23151276200008],
              [-158.34886633999992, 56.22931549700007],
              [-158.36213131399992, 56.23065827000005],
              [-158.3865860669999, 56.235988674000055],
              [-158.40070553299992, 56.23615143400008],
              [-158.3947647779999, 56.228176174000055],
              [-158.3983048169999, 56.220770575000074],
              [-158.40644283799992, 56.212591864000046],
              [-158.41437740799992, 56.202053127000056],
              [-158.3998917309999, 56.20571523600006],
              [-158.38438880099991, 56.21308014500005],
              [-158.36921139199993, 56.21747467700004],
              [-158.3264054029999, 56.200384833000044],
              [-158.32310950399992, 56.19354889500005],
              [-158.34544837099992, 56.18154531500005],
              [-158.31830807199992, 56.174709377000056],
              [-158.28815670499992, 56.18537018400008],
              [-158.25829016799992, 56.200873114000046],
              [-158.2060440749999, 56.21775950700004],
              [-158.17695064999992, 56.23484935100004],
              [-158.14732825399992, 56.245794989000046],
              [-158.1194962229999, 56.23615143400008],
              [-158.1506241529999, 56.22955963700008],
              [-158.1607559889999, 56.225897528000075],
              [-158.1678360669999, 56.220038153000075],
              [-158.17402096299992, 56.21206289300005],
              [-158.18122311099992, 56.20502350500004],
              [-158.19831295499992, 56.199204820000034],
              [-158.2143448559999, 56.185980536000045],
              [-158.22191321499992, 56.18154531500005],
              [-158.23432369699992, 56.180568752000056],
              [-158.2455948559999, 56.18244049700007],
              [-158.2571915359999, 56.18227773600006],
              [-158.27033443899992, 56.174709377000056],
              [-158.26288814999992, 56.16791413000004],
              [-158.2896622389999, 56.16160716400003],
              [-158.32404537699992, 56.15912506700005],
              [-158.35204016799992, 56.15070221600007],
              [-158.3597305979999, 56.12689850500004],
              [-158.38239498599992, 56.135931708000044],
              [-158.38776607999992, 56.152411200000074],
              [-158.38752193899992, 56.16986725500004],
              [-158.39325924399992, 56.18154531500005],
              [-158.4096573559999, 56.18081289300005],
              [-158.42076575399992, 56.16624583500004],
              [-158.42328854099992, 56.14720286700003],
              [-158.41437740799992, 56.13312409100007],
              [-158.4334610669999, 56.13231028900003],
              [-158.4416397779999, 56.13312409100007],
              [-158.42817135299993, 56.113348700000074],
              [-158.41230221299992, 56.09487539300005],
              [-158.4075821609999, 56.07843659100007],
              [-158.4279679029999, 56.06484609600005],
              [-158.44208736899992, 56.08502838700008],
              [-158.44574947799993, 56.094956773000035],
              [-158.4416397779999, 56.10643138200004],
              [-158.45429439999992, 56.109361070000034],
              [-158.49970455599993, 56.10643138200004],
              [-158.50324459499993, 56.101629950000074],
              [-158.49299068899992, 56.090725002000056],
              [-158.46959387899992, 56.07168203300006],
              [-158.48700924399992, 56.05963776200008],
              [-158.4846085279999, 56.04291413000004],
              [-158.46930904899992, 56.03204987200007],
              [-158.45417232999992, 56.040676174000055],
              [-158.4568985669999, 56.04352448100008],
              [-158.45872962099992, 56.046861070000034],
              [-158.46214758999992, 56.051214911000045],
              [-158.43407141799992, 56.04291413000004],
              [-158.42280025899993, 56.02399323100008],
              [-158.42756100199992, 56.00653717700004],
              [-158.4478653639999, 56.00275299700007],
              [-158.46019446499992, 56.00999583500004],
              [-158.48363196499992, 56.03237539300005],
              [-158.49628658799992, 56.037543036000045],
              [-158.51105709499993, 56.03384023600006],
              [-158.5120743479999, 56.02293528900003],
              [-158.50519771999993, 56.00922272300005],
              [-158.49628658799992, 55.99656810100004],
              [-158.51256262899992, 55.99599844000005],
              [-158.53364010299993, 56.00446198100008],
              [-158.55475826699993, 56.017645575000074],
              [-158.5714005199999, 56.03070709800005],
              [-158.50995846299992, 56.051214911000045],
              [-158.50995846299992, 56.05805084800005],
              [-158.56745357999992, 56.04710521000004],
              [-158.58564205599993, 56.040676174000055],
              [-158.6009415359999, 56.04043203300006],
              [-158.60468502499992, 56.05231354400007],
              [-158.59723873599992, 56.066107489000046],
              [-158.5788468089999, 56.07168203300006],
              [-158.5788468089999, 56.07851797100005],
              [-158.6019180979999, 56.08673737200007],
              [-158.6015518869999, 56.10057200700004],
              [-158.58551998599992, 56.11367422100005],
              [-158.5611466139999, 56.11945221600007],
              [-158.55988521999993, 56.12409088700008],
              [-158.54930579299992, 56.146185614000046],
              [-158.5440567699999, 56.153631903000075],
              [-158.53986568899992, 56.15468984600005],
              [-158.5280655589999, 56.15281810100004],
              [-158.51915442599991, 56.154364325000074],
              [-158.5147598949999, 56.15326569200005],
              [-158.51130123599992, 56.153225002000056],
              [-158.50995846299992, 56.15737539300005],
              [-158.51020260299993, 56.16624583500004],
              [-158.50995846299992, 56.16791413000004],
              [-158.4890030589999, 56.17670319200005],
              [-158.4788712229999, 56.18382396000004],
              [-158.4792374339999, 56.191473700000074],
              [-158.4905899729999, 56.19586823100008],
              [-158.5659073559999, 56.195013739000046],
              [-158.6396378249999, 56.202053127000056],
              [-158.6276749339999, 56.18585846600007],
              [-158.6077774729999, 56.17820872600004],
              [-158.56456458199992, 56.16791413000004],
              [-158.5911759109999, 56.152777411000045],
              [-158.61188717399992, 56.13515859600005],
              [-158.63459225199992, 56.12006256700005],
              [-158.66759192599991, 56.112616278000075],
              [-158.66144771999993, 56.13108958500004],
              [-158.6682022779999, 56.14594147300005],
              [-158.68333899599992, 56.152777411000045],
              [-158.70234127499992, 56.14740631700005],
              [-158.69188391799992, 56.13646067900004],
              [-158.6888321609999, 56.12563711100006],
              [-158.69261633999992, 56.11542389500005],
              [-158.70234127499992, 56.10643138200004],
              [-158.67011471299992, 56.09878164300005],
              [-158.66063391799992, 56.09235260600008],
              [-158.66759192599991, 56.07851797100005],
              [-158.66633053299992, 56.061712958000044],
              [-158.73224850199992, 56.04539622600004],
              [-158.71540279899992, 56.03070709800005],
              [-158.69652258999992, 56.02871328300006],
              [-158.6760147779999, 56.030462958000044],
              [-158.6580704419999, 56.028957424000055],
              [-158.6470841139999, 56.01703522300005],
              [-158.6470841139999, 55.99994538000004],
              [-158.65754146999993, 55.99079010600008],
              [-158.68805904899992, 55.98232656500005],
              [-158.68805904899992, 55.97614166900007],
              [-158.68256588399993, 55.97479889500005],
              [-158.67304439999992, 55.97085195500006],
              [-158.66759192599991, 55.96930573100008],
              [-158.68293209499993, 55.95840078300006],
              [-158.7120255199999, 55.95404694200005],
              [-158.7429093089999, 55.95538971600007],
              [-158.76378333199992, 55.96185944200005],
              [-158.75641842399992, 55.96747467700004],
              [-158.7479141919999, 55.97174713700008],
              [-158.73871822799993, 55.974676825000074],
              [-158.72899329299992, 55.97614166900007],
              [-158.72899329299992, 55.98232656500005],
              [-158.73912512899992, 55.99258047100005],
              [-158.74555416599992, 56.00145091400003],
              [-158.75654049399992, 56.007879950000074],
              [-158.78050696499992, 56.010199286000045],
              [-158.78510494699992, 56.007066148000035],
              [-158.7936905589999, 55.99290599200003],
              [-158.8010147779999, 55.98973216400003],
              [-158.81537838399993, 55.991522528000075],
              [-158.82310950399992, 55.99640534100007],
              [-158.8358048169999, 56.01361725500004],
              [-158.85944576699993, 56.012925523000035],
              [-158.88825436099992, 55.98383209800005],
              [-158.92829342399992, 55.92084381700005],
              [-158.93451900899993, 55.92084381700005],
              [-158.94233150899993, 55.931626695000034],
              [-158.95677649599992, 55.93622467700004],
              [-158.97386633999992, 55.93650950700004],
              [-159.00629635299993, 55.93178945500006],
              [-159.01410885299993, 55.92914459800005],
              [-159.02074133999992, 55.92462799700007],
              [-159.02375240799992, 55.91693756700005],
              [-159.0201309889999, 55.910589911000045],
              [-159.0142716139999, 55.90680573100008],
              [-159.01020260299993, 55.90717194200005],
              [-159.01093502499992, 55.901678778000075],
              [-159.01024329299992, 55.89720286700003],
              [-159.0139054029999, 55.89411041900007],
              [-159.0275772779999, 55.89288971600007],
              [-159.03547115799992, 55.89427317900004],
              [-159.0403946609999, 55.897691148000035],
              [-159.0447891919999, 55.902329820000034],
              [-159.07148189999992, 55.92059967700004],
              [-159.08381100199992, 55.92601146000004],
              [-159.09931393099993, 55.92829010600008],
              [-159.1136368479999, 55.92617422100005],
              [-159.14500891799992, 55.91681549700007],
              [-159.16071529899992, 55.91461823100008],
              [-159.17243404899992, 55.91128164300005],
              [-159.1870011059999, 55.89630768400008],
              [-159.20164954299992, 55.89288971600007],
              [-159.2667130199999, 55.88922760600008],
              [-159.29426021999993, 55.879339911000045],
              [-159.31867428299992, 55.859442450000074],
              [-159.33283443899992, 55.877386786000045],
              [-159.35590572799993, 55.87946198100008],
              [-159.3808487619999, 55.87140534100007],
              [-159.4006241529999, 55.859442450000074],
              [-159.41108150899993, 55.84251536700003],
              [-159.41633053299992, 55.80215078300006],
              [-159.42170162699992, 55.79047272300005],
              [-159.43907630099991, 55.78921133000006],
              [-159.45555579299992, 55.80133698100008],
              [-159.46869869699992, 55.818345445000034],
              [-159.4756973949999, 55.83148834800005],
              [-159.47883053299992, 55.84601471600007],
              [-159.47883053299992, 55.86359284100007],
              [-159.4756973949999, 55.88231028900003],
              [-159.46955318899992, 55.90033600500004],
              [-159.48945064999992, 55.90013255400004],
              [-159.5181778639999, 55.896470445000034],
              [-159.54499264199993, 55.88963450700004],
              [-159.55890865799992, 55.87986888200004],
              [-159.5552872389999, 55.865668036000045],
              [-159.5252579419999, 55.83657461100006],
              [-159.5179337229999, 55.82184479400007],
              [-159.51679439999992, 55.81122467700004],
              [-159.5117081369999, 55.79344310100004],
              [-159.5104874339999, 55.78302643400008],
              [-159.50934811099992, 55.77826569200005],
              [-159.50470943899992, 55.771185614000046],
              [-159.50365149599992, 55.766913153000075],
              [-159.5058487619999, 55.76089101800005],
              [-159.51081295499992, 55.75800202000005],
              [-159.51573645699992, 55.75604889500005],
              [-159.5179337229999, 55.75299713700008],
              [-159.53010006399992, 55.73981354400007],
              [-159.5526016919999, 55.72138092700004],
              [-159.5644425119999, 55.704291083000044],
              [-159.54462643099993, 55.69489166900007],
              [-159.5474747389999, 55.68382396000004],
              [-159.5479630199999, 55.673895575000074],
              [-159.5494278639999, 55.66498444200005],
              [-159.55516516799992, 55.65704987200007],
              [-159.5585831369999, 55.65379466400003],
              [-159.56212317599991, 55.64911530200004],
              [-159.56513424399992, 55.646551825000074],
              [-159.56916256399992, 55.64472077000005],
              [-159.58018958199992, 55.64215729400007],
              [-159.58556067599991, 55.63971588700008],
              [-159.6021622389999, 55.62763092700004],
              [-159.6198624339999, 55.61115143400008],
              [-159.63068600199992, 55.59357330900008],
              [-159.62653561099992, 55.57827383000006],
              [-159.7210587229999, 55.56708405200004],
              [-159.74323482999992, 55.57200755400004],
              [-159.73021399599992, 55.57998281500005],
              [-159.7089737619999, 55.597723700000074],
              [-159.69542395699992, 55.605536200000074],
              [-159.72712154899992, 55.60398997600004],
              [-159.75690670499992, 55.59870026200008],
              [-159.7416886059999, 55.613267320000034],
              [-159.7112930979999, 55.61933014500005],
              [-159.67979895699992, 55.61668528900003],
              [-159.66132564999992, 55.605536200000074],
              [-159.64081783799992, 55.612982489000046],
              [-159.64228268099993, 55.620306708000044],
              [-159.6393936839999, 55.626654364000046],
              [-159.63292395699992, 55.63117096600007],
              [-159.6234024729999, 55.632879950000074],
              [-159.61701412699992, 55.635199286000045],
              [-159.62474524599992, 55.640285549000055],
              [-159.65754146999993, 55.65228913000004],
              [-159.69330807199992, 55.66034577000005],
              [-159.7097061839999, 55.667629299000055],
              [-159.6912735669999, 55.679022528000075],
              [-159.63337154899992, 55.70111725500004],
              [-159.65009518099993, 55.71112702000005],
              [-159.65802975199992, 55.71832916900007],
              [-159.66454016799992, 55.73505280200004],
              [-159.67149817599991, 55.73627350500004],
              [-159.67857825399992, 55.73651764500005],
              [-159.68175208199992, 55.74274323100008],
              [-159.6779679029999, 55.752020575000074],
              [-159.6507462229999, 55.786810614000046],
              [-159.62621008999992, 55.80451080900008],
              [-159.6252335279999, 55.81268952000005],
              [-159.64081783799992, 55.82526276200008],
              [-159.65705318899992, 55.83234284100007],
              [-159.70185299399992, 55.843817450000074],
              [-159.83039303299992, 55.852728583000044],
              [-159.84577389199993, 55.851223049000055],
              [-159.85468502499992, 55.84162018400008],
              [-159.86054439999992, 55.818426825000074],
              [-159.8533829419999, 55.803900458000044],
              [-159.85138912699992, 55.79474518400008],
              [-159.8568009109999, 55.79047272300005],
              [-159.90461178299992, 55.78302643400008],
              [-159.92308508999992, 55.789496161000045],
              [-159.95527096299992, 55.815659898000035],
              [-159.97663326699993, 55.818426825000074],
              [-159.97663326699993, 55.810980536000045],
              [-159.96894283799992, 55.80678945500006],
              [-159.96711178299992, 55.80170319200005],
              [-159.96918697799993, 55.786810614000046],
              [-159.97313391799992, 55.77749258000006],
              [-159.98249264199993, 55.77716705900008],
              [-160.00959225199992, 55.78587474200003],
              [-160.01777096299992, 55.79181549700007],
              [-160.0267227859999, 55.796942450000074],
              [-160.0380753249999, 55.79734935100004],
              [-160.04364986899992, 55.79279205900008],
              [-160.0521134109999, 55.776271877000056],
              [-160.05854244699992, 55.77000560100004],
              [-160.03087317599991, 55.735541083000044],
              [-160.0335587229999, 55.726223049000055],
              [-160.06537838399993, 55.72284577000005],
              [-160.08800208199992, 55.72842031500005],
              [-160.0966690749999, 55.72801341400003],
              [-160.10016842399992, 55.71914297100005],
              [-160.09565182199992, 55.714178778000075],
              [-160.06537838399993, 55.70111725500004],
              [-160.09691321499992, 55.70075104400007],
              [-160.11078854099992, 55.70380280200004],
              [-160.12372799399992, 55.71198151200008],
              [-160.13048255099991, 55.720404364000046],
              [-160.13524329299992, 55.72801341400003],
              [-160.14216061099992, 55.73379140800006],
              [-160.1553848949999, 55.73651764500005],
              [-160.1498917309999, 55.72101471600007],
              [-160.14313717399992, 55.688788153000075],
              [-160.13365637899992, 55.67446523600006],
              [-160.1640518869999, 55.657131252000056],
              [-160.23871822799993, 55.66474030200004],
              [-160.2571915359999, 55.653998114000046],
              [-160.2571915359999, 55.646551825000074],
              [-160.3499649729999, 55.646551825000074],
              [-160.39622962099992, 55.65302155200004],
              [-160.4194229809999, 55.65387604400007],
              [-160.4421280589999, 55.646551825000074],
              [-160.42548580599993, 55.63471100500004],
              [-160.36640377499992, 55.612982489000046],
              [-160.36640377499992, 55.605536200000074],
              [-160.3908585279999, 55.59943268400008],
              [-160.43517005099991, 55.57684967700004],
              [-160.4564102859999, 55.57827383000006],
              [-160.4554337229999, 55.56329987200007],
              [-160.45380611899992, 55.55735911700003],
              [-160.44896399599992, 55.55027903900003],
              [-160.45750891799992, 55.542954820000034],
              [-160.4642227859999, 55.529282945000034],
              [-160.46857662699992, 55.51508209800005],
              [-160.47004146999993, 55.50625234600005],
              [-160.4775284499999, 55.49461497600004],
              [-160.49518795499992, 55.48615143400008],
              [-160.5314835279999, 55.475816148000035],
              [-160.54853268099993, 55.48908112200007],
              [-160.5829971999999, 55.540716864000046],
              [-160.59333248599992, 55.564113674000055],
              [-160.59540768099993, 55.589097398000035],
              [-160.59894771999993, 55.60610586100006],
              [-160.61347408799992, 55.605536200000074],
              [-160.6279190749999, 55.59080638200004],
              [-160.64093990799992, 55.57025788000004],
              [-160.65741939999992, 55.551988023000035],
              [-160.68268795499992, 55.544134833000044],
              [-160.74176998599992, 55.54865143400008],
              [-160.76813717399992, 55.54539622600004],
              [-160.7642716139999, 55.530462958000044],
              [-160.7409561839999, 55.52488841400003],
              [-160.70661373599992, 55.52513255400004],
              [-160.67540442599991, 55.521918036000045],
              [-160.66185462099992, 55.50625234600005],
              [-160.66759192599991, 55.477850653000075],
              [-160.68342037699992, 55.46466705900008],
              [-160.7825821609999, 55.44708893400008],
              [-160.79902096299992, 55.44790273600006],
              [-160.80939693899992, 55.45184967700004],
              [-160.8320206369999, 55.46539948100008],
              [-160.84308834499993, 55.468410549000055],
              [-160.84858150899993, 55.47304922100005],
              [-160.8459366529999, 55.48346588700008],
              [-160.83661861899992, 55.49941640800006],
              [-160.83177649599992, 55.51162344000005],
              [-160.84052486899992, 55.51854075700004],
              [-160.86729895699992, 55.52362702000005],
              [-160.9245499339999, 55.51911041900007],
              [-160.95942135299993, 55.49315013200004],
              [-160.98761959499993, 55.458319403000075],
              [-161.02497311099992, 55.427435614000046],
              [-161.07209225199992, 55.40835195500006],
              [-161.2791641919999, 55.35488515800006],
              [-161.3120011059999, 55.353583075000074],
              [-161.32660885299993, 55.36225006700005],
              [-161.33946692599991, 55.383246161000045],
              [-161.36872311099992, 55.38544342700004],
              [-161.4791153639999, 55.361029364000046],
              [-161.50666256399992, 55.36383698100008],
              [-161.51842200399992, 55.38336823100008],
              [-161.51557369699992, 55.38898346600007],
              [-161.48798580599993, 55.427801825000074],
              [-161.48558508999992, 55.43842194200005],
              [-161.4819229809999, 55.48037344000005],
              [-161.4792374339999, 55.48493073100008],
              [-161.45433508999992, 55.51479726800005],
              [-161.44298255099991, 55.52562083500004],
              [-161.41889400899993, 55.538397528000075],
              [-161.38874264199993, 55.57217031500005],
              [-161.3675430979999, 55.57827383000006],
              [-161.3491104809999, 55.57062409100007],
              [-161.3166397779999, 55.54319896000004],
              [-161.29218502499992, 55.53729889500005],
              [-161.1826065749999, 55.52362702000005],
              [-161.1518448559999, 55.52562083500004],
              [-161.1448868479999, 55.53497955900008],
              [-161.15925045499992, 55.54539622600004],
              [-161.24779212099992, 55.55776601800005],
              [-161.2612198559999, 55.561712958000044],
              [-161.27143307199992, 55.57123444200005],
              [-161.2807511059999, 55.58258698100008],
              [-161.29185950399992, 55.59194570500006],
              [-161.31615149599992, 55.60040924700007],
              [-161.36493893099993, 55.61001211100006],
              [-161.4081925119999, 55.635931708000044],
              [-161.43879146999993, 55.638739325000074],
              [-161.62079830599993, 55.612982489000046],
              [-161.61335201699993, 55.59979889500005],
              [-161.61725826699993, 55.593736070000034],
              [-161.62629146999993, 55.59031810100004],
              [-161.63447018099993, 55.58510976800005],
              [-161.65217037699992, 55.56118398600006],
              [-161.7083634109999, 55.52708567900004],
              [-161.71642005099991, 55.51308828300006],
              [-161.71332760299993, 55.502020575000074],
              [-161.70649166599992, 55.497259833000044],
              [-161.69965572799993, 55.495306708000044],
              [-161.69652258999992, 55.49258047100005],
              [-161.69721432199992, 55.48261139500005],
              [-161.70942135299993, 55.43439362200007],
              [-161.71019446499992, 55.42430247600004],
              [-161.70942135299993, 55.407131252000056],
              [-161.71100826699993, 55.40176015800006],
              [-161.71642005099991, 55.39325592700004],
              [-161.81708736899992, 55.316839911000045],
              [-161.8331192699999, 55.29364655200004],
              [-161.84190833199992, 55.28961823100008],
              [-161.8945206369999, 55.24241771000004],
              [-161.8978165359999, 55.23346588700008],
              [-161.89911861899992, 55.22455475500004],
              [-161.90241451699993, 55.21784088700008],
              [-161.91193600199992, 55.21515534100007],
              [-161.93480383999992, 55.21381256700005],
              [-161.9448136059999, 55.21556224200003],
              [-161.95661373599992, 55.221909898000035],
              [-161.94831295499992, 55.221136786000045],
              [-161.9224747389999, 55.221909898000035],
              [-161.9224747389999, 55.229396877000056],
              [-161.9511612619999, 55.237209377000056],
              [-161.98468990799992, 55.24042389500005],
              [-162.01801510299993, 55.23981354400007],
              [-162.0460098949999, 55.235581773000035],
              [-162.0460098949999, 55.229396877000056],
              [-162.0204971999999, 55.20075104400007],
              [-162.01569576699993, 55.18451569200005],
              [-162.0323380199999, 55.17413971600007],
              [-161.98456783799992, 55.157131252000056],
              [-161.9815567699999, 55.14740631700005],
              [-161.97431393099993, 55.13825104400007],
              [-161.9650772779999, 55.13060130400004],
              [-161.95661373599992, 55.12571849200003],
              [-161.97276770699992, 55.107407945000034],
              [-162.00129146999993, 55.09320709800005],
              [-162.03294837099992, 55.083319403000075],
              [-162.05903072799993, 55.07859935100004],
              [-162.08088131399992, 55.08063385600008],
              [-162.10578365799992, 55.08942291900007],
              [-162.12800045499992, 55.10297272300005],
              [-162.1415909499999, 55.11953359600005],
              [-162.12214107999992, 55.124986070000034],
              [-162.1142471999999, 55.12571849200003],
              [-162.1216934889999, 55.13320547100005],
              [-162.1127823559999, 55.14142487200007],
              [-162.10639400899993, 55.14911530200004],
              [-162.10248775899993, 55.15761953300006],
              [-162.10126705599993, 55.16791413000004],
              [-162.1927384109999, 55.142564195000034],
              [-162.23094641799992, 55.11273834800005],
              [-162.21068274599992, 55.09023672100005],
              [-162.19819088399993, 55.06289297100005],
              [-162.20209713399993, 55.03986237200007],
              [-162.23094641799992, 55.03021881700005],
              [-162.2460831369999, 55.027044989000046],
              [-162.26056881399992, 55.02167389500005],
              [-162.2747696609999, 55.019598700000074],
              [-162.2892960279999, 55.02680084800005],
              [-162.29808508999992, 55.03587474200003],
              [-162.3132218089999, 55.05817291900007],
              [-162.3196915359999, 55.07111237200007],
              [-162.32929439999992, 55.066066799000055],
              [-162.33747311099992, 55.05768463700008],
              [-162.3510636059999, 55.04010651200008],
              [-162.36253821499992, 55.03656647300005],
              [-162.42271887899992, 55.036363023000035],
              [-162.44933020699992, 55.040269273000035],
              [-162.47223873599992, 55.04897695500006],
              [-162.49262447799993, 55.061835028000075],
              [-162.51154537699992, 55.07859935100004],
              [-162.5264786449999, 55.10224030200004],
              [-162.51740475199992, 55.11469147300005],
              [-162.49360104099992, 55.11749909100007],
              [-162.4643448559999, 55.11273834800005],
              [-162.41649329299992, 55.09788646000004],
              [-162.3906143869999, 55.096584377000056],
              [-162.3607071609999, 55.10529205900008],
              [-162.4173477859999, 55.12905508000006],
              [-162.43639075399992, 55.14008209800005],
              [-162.4799698559999, 55.17552317900004],
              [-162.49103756399992, 55.18842194200005],
              [-162.53095455599993, 55.24876536700003],
              [-162.5573624339999, 55.26703522300005],
              [-162.60090084499993, 55.270412502000056],
              [-162.5716446609999, 55.28082916900007],
              [-162.56745357999992, 55.292222398000035],
              [-162.58332271999993, 55.30109284100007],
              [-162.61457271999993, 55.303900458000044],
              [-162.64533443899992, 55.300034898000035],
              [-162.66828365799992, 55.29140859600005],
              [-162.6873673169999, 55.27789948100008],
              [-162.70673580599993, 55.25950755400004],
              [-162.7187393869999, 55.23908112200007],
              [-162.71833248599992, 55.21792226800005],
              [-162.7053116529999, 55.20136139500005],
              [-162.65876217399992, 55.190334377000056],
              [-162.63288326699993, 55.179673570000034],
              [-162.61412512899992, 55.16632721600007],
              [-162.61457271999993, 55.15371328300006],
              [-162.60326087099992, 55.14354075700004],
              [-162.5999649729999, 55.13711172100005],
              [-162.60395260299993, 55.13190338700008],
              [-162.61457271999993, 55.12571849200003],
              [-162.61481686099992, 55.12913646000004],
              [-162.61969967399992, 55.13418203300006],
              [-162.62653561099992, 55.13764069200005],
              [-162.6321915359999, 55.13666413000004],
              [-162.63532467399992, 55.13104889500005],
              [-162.63544674399992, 55.12514883000006],
              [-162.6347550119999, 55.11904531500005],
              [-162.63569088399993, 55.11273834800005],
              [-162.6417130199999, 55.09096914300005],
              [-162.64277096299992, 55.07111237200007],
              [-162.6349991529999, 55.06362539300005],
              [-162.61457271999993, 55.07859935100004],
              [-162.61213131399992, 55.062201239000046],
              [-162.5599259109999, 54.96124909100007],
              [-162.58482825399992, 54.96580638200004],
              [-162.61644446499992, 54.97988515800006],
              [-162.6454971999999, 54.99843984600005],
              [-162.66295325399992, 55.01654694200005],
              [-162.62779700399992, 55.01227448100008],
              [-162.61896725199992, 55.015692450000074],
              [-162.62140865799992, 55.03021881700005],
              [-162.6330460279999, 55.04555898600006],
              [-162.64948482999992, 55.05296458500004],
              [-162.66718502499992, 55.05060455900008],
              [-162.67662512899992, 55.036363023000035],
              [-162.68549557199992, 55.017238674000055],
              [-162.69652258999992, 55.003241278000075],
              [-162.72382564999992, 54.97553131700005],
              [-162.71837317599991, 54.968085028000075],
              [-162.71662350199992, 54.96336497600004],
              [-162.7206925119999, 54.96124909100007],
              [-162.72504635299993, 54.96010976800005],
              [-162.75275631399992, 54.94489166900007],
              [-162.7674454419999, 54.93960195500006],
              [-162.78294837099992, 54.93593984600005],
              [-162.85041256399992, 54.93504466400003],
              [-162.87763424399992, 54.93895091400003],
              [-162.92084713399993, 54.95742422100005],
              [-162.92735755099991, 54.96328359600005],
              [-162.92988033799992, 54.971869208000044],
              [-162.9350479809999, 54.976996161000045],
              [-162.9673966139999, 54.99233633000006],
              [-162.97435462099992, 55.00950755400004],
              [-162.95274817599991, 55.01406484600005],
              [-162.92646236899992, 55.014553127000056],
              [-162.91962643099993, 55.01992422100005],
              [-162.93696041599992, 55.029282945000034],
              [-162.9799698559999, 55.03864166900007],
              [-162.99815833199992, 55.05068594000005],
              [-163.02411861899992, 55.08502838700008],
              [-163.04112708199992, 55.09935130400004],
              [-163.06330318899992, 55.10529205900008],
              [-163.07502193899992, 55.106634833000044],
              [-163.09654700399992, 55.112209377000056],
              [-163.10798092399992, 55.11273834800005],
              [-163.1220596999999, 55.10984935100004],
              [-163.1483048169999, 55.10101959800005],
              [-163.1631973949999, 55.09906647300005],
              [-163.1497696609999, 55.10643138200004],
              [-163.1213272779999, 55.11790599200003],
              [-163.10798092399992, 55.12571849200003],
              [-163.12909908799992, 55.13344961100006],
              [-163.15709387899992, 55.13861725500004],
              [-163.18305416599992, 55.13914622600004],
              [-163.1979874339999, 55.13320547100005],
              [-163.2001846999999, 55.12140534100007],
              [-163.1967667309999, 55.10846588700008],
              [-163.1921280589999, 55.09760163000004],
              [-163.1905411449999, 55.092230536000045],
              [-163.20274817599991, 55.08616771000004],
              [-163.21503658799992, 55.08966705900008],
              [-163.23835201699993, 55.10529205900008],
              [-163.23822994699992, 55.09031810100004],
              [-163.23131262899992, 55.08100006700005],
              [-163.2193497389999, 55.07713450700004],
              [-163.2042130199999, 55.07859935100004],
              [-163.21764075399992, 55.045355536000045],
              [-163.20551510299993, 55.01898834800005],
              [-163.17475338399993, 55.00169505400004],
              [-163.1140030589999, 54.99233633000006],
              [-163.08995520699992, 54.98427969000005],
              [-163.06725012899992, 54.97329336100006],
              [-163.0533341139999, 54.96124909100007],
              [-163.04987545499992, 54.941839911000045],
              [-163.06257076699993, 54.92877838700008],
              [-163.13520260299993, 54.90371328300006],
              [-163.17121334499993, 54.88190338700008],
              [-163.20038814999992, 54.87295156500005],
              [-163.2314346999999, 54.84479401200008],
              [-163.25141354099992, 54.838324286000045],
              [-163.27745520699992, 54.833685614000046],
              [-163.32079016799992, 54.81386953300006],
              [-163.34137936099992, 54.81110260600008],
              [-163.3574112619999, 54.817613023000035],
              [-163.3675430979999, 54.830145575000074],
              [-163.37665768099993, 54.844956773000035],
              [-163.3897598949999, 54.85887278900003],
              [-163.34186764199993, 54.87677643400008],
              [-163.32709713399993, 54.88617584800005],
              [-163.3245743479999, 54.891058661000045],
              [-163.3248184889999, 54.902329820000034],
              [-163.32087154899992, 54.90729401200008],
              [-163.3115128249999, 54.91156647300005],
              [-163.30146236899992, 54.913723049000055],
              [-163.2908829419999, 54.914129950000074],
              [-163.2798966139999, 54.91351959800005],
              [-163.29682369699992, 54.92763906500005],
              [-163.34528561099992, 54.91941966400003],
              [-163.34760494699992, 54.94082265800006],
              [-163.32917232999992, 54.966864325000074],
              [-163.30658932199992, 54.959051825000074],
              [-163.28136145699992, 54.944647528000075],
              [-163.25511633999992, 54.95132070500006],
              [-163.2459610669999, 54.969956773000035],
              [-163.28205318899992, 54.99013906500005],
              [-163.2929581369999, 55.01312897300005],
              [-163.29914303299992, 55.06122467700004],
              [-163.3060196609999, 55.07396067900004],
              [-163.31867428299992, 55.08539459800005],
              [-163.32514400899993, 55.09564850500004],
              [-163.3134659499999, 55.10529205900008],
              [-163.3134659499999, 55.11273834800005],
              [-163.32050533799992, 55.112209377000056],
              [-163.3251846999999, 55.11408112200007],
              [-163.32929439999992, 55.116888739000046],
              [-163.33454342399992, 55.11953359600005],
              [-163.14899654899992, 55.180975653000075],
              [-163.02472896999993, 55.24559153900003],
              [-162.99128170499992, 55.24241771000004],
              [-163.00902258999992, 55.23737213700008],
              [-163.03087317599991, 55.22719961100006],
              [-163.05170650899993, 55.21434153900003],
              [-163.0663956369999, 55.20148346600007],
              [-163.0765274729999, 55.18065013200004],
              [-163.06293697799993, 55.175767320000034],
              [-162.99262447799993, 55.18183014500005],
              [-162.98448645699992, 55.180975653000075],
              [-162.9837540359999, 55.17918528900003],
              [-162.98078365799992, 55.174994208000044],
              [-162.97618567599991, 55.17055898600006],
              [-162.97081458199992, 55.16791413000004],
              [-162.9620255199999, 55.16901276200008],
              [-162.89582271999993, 55.18964264500005],
              [-162.87494869699992, 55.200384833000044],
              [-162.83368893099993, 55.229396877000056],
              [-162.84992428299992, 55.245428778000075],
              [-162.8886612619999, 55.24677155200004],
              [-162.8963516919999, 55.26666901200008],
              [-162.80011959499993, 55.290269273000035],
              [-162.79474850199992, 55.29946523600006],
              [-162.73700924399992, 55.31093984600005],
              [-162.7138565749999, 55.32127513200004],
              [-162.6533096999999, 55.36151764500005],
              [-162.64183508999992, 55.38027578300006],
              [-162.6349991529999, 55.362616278000075],
              [-162.61420650899993, 55.35150788000004],
              [-162.58844967399992, 55.34609609600005],
              [-162.5667618479999, 55.34544505400004],
              [-162.55097408799992, 55.348537502000056],
              [-162.5405167309999, 55.353949286000045],
              [-162.5189102859999, 55.37278880400004],
              [-162.51183020699992, 55.37490469000005],
              [-162.50434322799993, 55.37368398600006],
              [-162.49714107999992, 55.37396881700005],
              [-162.49103756399992, 55.38027578300006],
              [-162.48997962099992, 55.38532135600008],
              [-162.4902237619999, 55.39199453300006],
              [-162.49176998599992, 55.397691148000035],
              [-162.49445553299992, 55.400091864000046],
              [-162.50755774599992, 55.407538153000075],
              [-162.50401770699992, 55.42401764500005],
              [-162.5042618479999, 55.44041575700004],
              [-162.52887936099992, 55.44790273600006],
              [-162.5569962229999, 55.446926174000055],
              [-162.5823868479999, 55.43732330900008],
              [-162.60102291599992, 55.42373281500005],
              [-162.62140865799992, 55.40692780200004],
              [-162.60472571499992, 55.42987702000005],
              [-162.59105383999992, 55.43732330900008],
              [-162.5761612619999, 55.44599030200004],
              [-162.54999752499992, 55.45872630400004],
              [-162.22699947799993, 55.69790273600006],
              [-162.1490372389999, 55.72284577000005],
              [-162.13011633999992, 55.73432038000004],
              [-162.09260006399992, 55.76406484600005],
              [-162.07701575399992, 55.77000560100004],
              [-162.05052649599992, 55.77374909100007],
              [-161.91295325399992, 55.83087799700007],
              [-161.89826412699992, 55.84198639500005],
              [-161.82628333199992, 55.87986888200004],
              [-161.79999752499992, 55.88971588700008],
              [-161.77391516799992, 55.89598216400003],
              [-161.68903561099992, 55.903550523000035],
              [-161.6408585279999, 55.917669989000046],
              [-161.52550208199992, 55.934881903000075],
              [-161.45771236899992, 55.95392487200007],
              [-161.3889054029999, 55.96173737200007],
              [-161.37751217399992, 55.96552155200004],
              [-161.35663814999992, 55.976263739000046],
              [-161.15534420499992, 56.01703522300005],
              [-161.2255753249999, 55.99599844000005],
              [-161.25776119699992, 55.986029364000046],
              [-161.27326412699992, 55.97846100500004],
              [-161.3675430979999, 55.95563385600008],
              [-161.20685787699992, 55.95563385600008],
              [-161.17084713399993, 55.94985586100006],
              [-161.15477454299992, 55.94989655200004],
              [-161.13792883999992, 55.958685614000046],
              [-161.12421627499992, 55.96124909100007],
              [-161.07274329299992, 55.94135163000004],
              [-161.05329342399992, 55.941107489000046],
              [-161.0394180979999, 55.94594961100006],
              [-161.01130123599992, 55.96185944200005],
              [-160.9599503249999, 55.976263739000046],
              [-160.9464005199999, 55.986029364000046],
              [-160.9323624339999, 55.990301825000074],
              [-160.8741348949999, 55.99315013200004],
              [-160.87140865799992, 55.96173737200007],
              [-160.86725826699993, 55.94586823100008],
              [-160.8604630199999, 55.93451569200005],
              [-160.90001380099991, 55.93455638200004],
              [-160.94037838399993, 55.93935781500005],
              [-160.97931881399992, 55.93744538000004],
              [-161.0143936839999, 55.91771067900004],
              [-161.0241593089999, 55.90289948100008],
              [-161.02338619699992, 55.89077383000006],
              [-161.01557369699992, 55.88117096600007],
              [-161.00446529899992, 55.87372467700004],
              [-160.98363196499992, 55.86701080900008],
              [-160.96589107999992, 55.86937083500004],
              [-160.94847571499992, 55.875433661000045],
              [-160.92878170499992, 55.87986888200004],
              [-160.94379635299993, 55.850490627000056],
              [-160.95006262899992, 55.83299388200004],
              [-160.9464005199999, 55.82526276200008],
              [-160.93061275899993, 55.82184479400007],
              [-160.9151505199999, 55.813666083000044],
              [-160.82038326699993, 55.739162502000056],
              [-160.79902096299992, 55.71539948100008],
              [-160.78180904899992, 55.75104401200008],
              [-160.76813717399992, 55.75853099200003],
              [-160.7471817699999, 55.746161200000074],
              [-160.71711178299992, 55.72284577000005],
              [-160.6992081369999, 55.703192450000074],
              [-160.68956458199992, 55.69790273600006],
              [-160.67552649599992, 55.70111725500004],
              [-160.67572994699992, 55.70563385600008],
              [-160.6647843089999, 55.729803778000075],
              [-160.66185462099992, 55.73281484600005],
              [-160.66608639199993, 55.74404531500005],
              [-160.67625891799992, 55.74713776200008],
              [-160.6885880199999, 55.748114325000074],
              [-160.69941158799992, 55.75299713700008],
              [-160.70710201699993, 55.759833075000074],
              [-160.7253311839999, 55.77138906500005],
              [-160.75670325399992, 55.78611888200004],
              [-160.7642716139999, 55.804754950000074],
              [-160.77521725199992, 55.84650299700007],
              [-160.78246008999992, 55.865668036000045],
              [-160.7952774729999, 55.87372467700004],
              [-160.79926510299993, 55.875433661000045],
              [-160.79865475199992, 55.87946198100008],
              [-160.79539954299992, 55.88377513200004],
              [-160.79157467399992, 55.886704820000034],
              [-160.7845352859999, 55.88768138200004],
              [-160.77753658799992, 55.88556549700007],
              [-160.7642716139999, 55.87986888200004],
              [-160.71711178299992, 55.86627838700008],
              [-160.68871008999992, 55.86229075700004],
              [-160.51219641799992, 55.86994049700007],
              [-160.50361080599993, 55.859442450000074],
              [-160.4796036449999, 55.85028717700004],
              [-160.47773189999992, 55.83844635600008],
              [-160.48188229099992, 55.823472398000035],
              [-160.47626705599993, 55.804754950000074],
              [-160.46019446499992, 55.79564036700003],
              [-160.44225012899992, 55.80052317900004],
              [-160.42255611899992, 55.80914948100008],
              [-160.40119381399992, 55.810980536000045],
              [-160.39484615799992, 55.80731842700004],
              [-160.3867081369999, 55.79523346600007],
              [-160.38068600199992, 55.79047272300005],
              [-160.3691300119999, 55.786769924000055],
              [-160.30976314999992, 55.779364325000074],
              [-160.28888912699992, 55.77448151200008],
              [-160.26768958199992, 55.77228424700007],
              [-160.2435196609999, 55.77684153900003],
              [-160.27887936099992, 55.788316148000035],
              [-160.28791256399992, 55.79393138200004],
              [-160.30907141799992, 55.81928131700005],
              [-160.31920325399992, 55.82526276200008],
              [-160.2372940749999, 55.838324286000045],
              [-160.2509659499999, 55.85248444200005],
              [-160.27265377499992, 55.85911692900004],
              [-160.31920325399992, 55.86627838700008],
              [-160.52074133999992, 55.935207424000055],
              [-160.54076087099992, 55.93537018400008],
              [-160.5662735669999, 55.92829010600008],
              [-160.57245846299992, 55.93451569200005],
              [-160.55268307199992, 55.94912344000005],
              [-160.54352779899992, 55.95848216400003],
              [-160.53831946499992, 55.96930573100008],
              [-160.53913326699993, 55.98456452000005],
              [-160.5475968089999, 55.993394273000035],
              [-160.56183834499993, 55.995306708000044],
              [-160.57990475199992, 55.98973216400003],
              [-160.56810462099992, 56.00755442900004],
              [-160.5322159499999, 56.040228583000044],
              [-160.5163468089999, 56.068793036000045],
              [-160.47638912699992, 56.09666575700004],
              [-160.46259518099993, 56.112616278000075],
              [-160.4611710279999, 56.15131256700005],
              [-160.45555579299992, 56.17234935100004],
              [-160.43871008999992, 56.18154531500005],
              [-160.42894446499992, 56.19326406500005],
              [-160.4037979809999, 56.23969147300005],
              [-160.39435787699992, 56.24298737200007],
              [-160.36872311099992, 56.27684153900003],
              [-160.2372940749999, 56.339178778000075],
              [-160.18871008999992, 56.38690827000005],
              [-160.01703854099992, 56.445379950000074],
              [-159.92804928299992, 56.48895905200004],
              [-159.84772701699993, 56.54051341400003],
              [-159.74571692599991, 56.579331773000035],
              [-159.4831436839999, 56.64704010600008],
              [-159.55890865799992, 56.620347398000035],
              [-159.5475968089999, 56.61318594000005],
              [-159.52692623599992, 56.61615631700005],
              [-159.50243079299992, 56.62287018400008],
              [-159.45636959499993, 56.629339911000045],
              [-159.3245743479999, 56.67401764500005],
              [-159.3080948559999, 56.684881903000075],
              [-159.28876705599993, 56.69208405200004],
              [-159.2310684889999, 56.69196198100008],
              [-159.2088516919999, 56.69546133000006],
              [-159.22126217399992, 56.700873114000046],
              [-159.2347305979999, 56.702826239000046],
              [-159.26341712099992, 56.702337958000044],
              [-159.26341712099992, 56.70856354400007],
              [-159.19965572799993, 56.75169505400004],
              [-159.1752823559999, 56.763739325000074],
              [-159.08637447799993, 56.78579336100006],
              [-159.04096432199992, 56.81513092700004],
              [-158.99107825399992, 56.84259674700007],
              [-158.94391842399992, 56.86985911700003],
              [-158.88923092399992, 56.88959381700005],
              [-158.8662003249999, 56.89411041900007],
              [-158.89378821499992, 56.87445709800005],
              [-158.95942135299993, 56.85346100500004],
              [-158.9974259109999, 56.82880280200004],
              [-159.02513587099992, 56.81671784100007],
              [-159.03071041599992, 56.80878327000005],
              [-159.0248917309999, 56.796576239000046],
              [-159.01069088399993, 56.78880442900004],
              [-158.99286861899992, 56.785142320000034],
              [-158.9760636059999, 56.784857489000046],
              [-158.97919674399992, 56.80573151200008],
              [-158.9710587229999, 56.82754140800006],
              [-158.95771236899992, 56.84247467700004],
              [-158.94501705599993, 56.84292226800005],
              [-158.91100012899992, 56.817694403000075],
              [-158.8736466139999, 56.79783763200004],
              [-158.84894771999993, 56.78937409100007],
              [-158.8146866529999, 56.78143952000005],
              [-158.7807511059999, 56.77753327000005],
              [-158.7569473949999, 56.78115469000005],
              [-158.74372311099992, 56.786322333000044],
              [-158.72870846299992, 56.78937409100007],
              [-158.6985977859999, 56.791083075000074],
              [-158.68146725199992, 56.78660716400003],
              [-158.6557511059999, 56.767645575000074],
              [-158.6396378249999, 56.763739325000074],
              [-158.65392005099991, 56.80536530200004],
              [-158.6537979809999, 56.81720612200007],
              [-158.65143795499992, 56.82648346600007],
              [-158.65282141799992, 56.83624909100007],
              [-158.68244381399992, 56.86933014500005],
              [-158.68907630099991, 56.88450755400004],
              [-158.6889542309999, 56.93960195500006],
              [-158.69489498599992, 56.969183661000045],
              [-158.69440670499992, 56.979803778000075],
              [-158.68805904899992, 57.007025458000044],
              [-158.68211829299992, 57.02204010600008],
              [-158.65208899599992, 57.059759833000044],
              [-158.60789954299992, 57.10097890800006],
              [-158.31244869699992, 57.314886786000045],
              [-158.3007706369999, 57.31928131700005],
              [-158.28437252499992, 57.32294342700004],
              [-158.18268795499992, 57.36200592700004],
              [-158.0580948559999, 57.36709219000005],
              [-158.06366939999992, 57.37718333500004],
              [-158.07347571499992, 57.38153717700004],
              [-158.08588619699992, 57.382066148000035],
              [-158.09906979099992, 57.38076406500005],
              [-158.07966061099992, 57.39663320500006],
              [-158.0170792309999, 57.42853424700007],
              [-157.9963272779999, 57.44623444200005],
              [-157.9612930979999, 57.48419830900008],
              [-157.94074459499993, 57.49746328300006],
              [-157.87279212099992, 57.51361725500004],
              [-157.7866104809999, 57.55609772300005],
              [-157.75776119699992, 57.56427643400008],
              [-157.73595130099991, 57.55882396000004],
              [-157.72297115799992, 57.56476471600007],
              [-157.70966549399992, 57.56867096600007],
              [-157.6806534499999, 57.57249583500004],
              [-157.6916397779999, 57.557928778000075],
              [-157.68321692599991, 57.54010651200008],
              [-157.65278072799993, 57.503607489000046],
              [-157.6666153639999, 57.48920319200005],
              [-157.65672766799992, 57.483587958000044],
              [-157.50938880099991, 57.476263739000046],
              [-157.5136612619999, 57.466498114000046],
              [-157.5162247389999, 57.46263255400004],
              [-157.47895260299993, 57.48309967700004],
              [-157.44550533799992, 57.483303127000056],
              [-157.4287003249999, 57.485256252000056],
              [-157.41380774599992, 57.489935614000046],
              [-157.39557857999992, 57.50242747600004],
              [-157.3951309889999, 57.51276276200008],
              [-157.40741939999992, 57.52204010600008],
              [-157.42743893099993, 57.53156159100007],
              [-157.41844641799992, 57.53945547100005],
              [-157.4077042309999, 57.54604726800005],
              [-157.39806067599991, 57.55414459800005],
              [-157.3920792309999, 57.56631094000005],
              [-157.40709387899992, 57.56126536700003],
              [-157.4394425119999, 57.55658600500004],
              [-157.45478268099993, 57.552069403000075],
              [-157.4437149729999, 57.53729889500005],
              [-157.41974850199992, 57.51264069200005],
              [-157.41380774599992, 57.49746328300006],
              [-157.5139054029999, 57.509751695000034],
              [-157.5335587229999, 57.50731028900003],
              [-157.54340572799993, 57.50031159100007],
              [-157.55610104099992, 57.49481842700004],
              [-157.56956946499992, 57.49119700700004],
              [-157.58173580599993, 57.489935614000046],
              [-157.59540768099993, 57.49323151200008],
              [-157.5975235669999, 57.50096263200004],
              [-157.5912979809999, 57.51788971600007],
              [-157.5872696609999, 57.56317780200004],
              [-157.59064693899992, 57.58421458500004],
              [-157.6021622389999, 57.603501695000034],
              [-157.6035050119999, 57.60854726800005],
              [-157.60077877499992, 57.612982489000046],
              [-157.5986221999999, 57.61782461100006],
              [-157.6021622389999, 57.62400950700004],
              [-157.60753333199992, 57.62799713700008],
              [-157.6182755199999, 57.634100653000075],
              [-157.62267005099991, 57.63764069200005],
              [-157.63007564999992, 57.641058661000045],
              [-157.63898678299992, 57.64044830900008],
              [-157.6447647779999, 57.63666413000004],
              [-157.64313717399992, 57.630560614000046],
              [-157.6260880199999, 57.61347077000005],
              [-157.65013587099992, 57.61367422100005],
              [-157.67194576699993, 57.61810944200005],
              [-157.6904190749999, 57.626288153000075],
              [-157.7045792309999, 57.63764069200005],
              [-157.70990963399993, 57.65253327000005],
              [-157.71003170499992, 57.67401764500005],
              [-157.7065323559999, 57.695379950000074],
              [-157.7011612619999, 57.70966217700004],
              [-157.70881100199992, 57.72992584800005],
              [-157.6983536449999, 57.759466864000046],
              [-157.66706295499992, 57.81891510600008],
              [-157.64460201699993, 57.878241278000075],
              [-157.63666744699992, 57.909369208000044],
              [-157.63011633999992, 57.97846100500004],
              [-157.61518307199992, 58.04116445500006],
              [-157.6100968089999, 58.09235260600008],
              [-157.60553951699993, 58.10521067900004],
              [-157.5912979809999, 58.127386786000045],
              [-157.5794571609999, 58.14036692900004],
              [-157.55329342399992, 58.16205475500004],
              [-157.54352779899992, 58.175848700000074],
              [-157.5197647779999, 58.16738515800006],
              [-157.48578854099992, 58.16547272300005],
              [-157.45164954299992, 58.16876862200007],
              [-157.42743893099993, 58.175848700000074],
              [-157.4096573559999, 58.18862539300005],
              [-157.39875240799992, 58.19953034100007],
              [-157.38422604099992, 58.207098700000074],
              [-157.3554581369999, 58.20994700700004],
              [-157.1943253249999, 58.19391510600008],
              [-157.1804093089999, 58.189439195000034],
              [-157.1706436839999, 58.18268463700008],
              [-157.1640518869999, 58.175116278000075],
              [-157.1553848949999, 58.16950104400007],
              [-157.13947506399992, 58.168402411000045],
              [-157.16331946499992, 58.19155508000006],
              [-157.18708248599992, 58.20490143400008],
              [-157.3475235669999, 58.23920319200005],
              [-157.3796280589999, 58.23725006700005],
              [-157.43354244699992, 58.221909898000035],
              [-157.45746822799993, 58.22089264500005],
              [-157.4826554029999, 58.23041413000004],
              [-157.52904212099992, 58.25600820500006],
              [-157.54539954299992, 58.27358633000006],
              [-157.53730221299992, 58.291896877000056],
              [-157.56847083199992, 58.320746161000045],
              [-157.56208248599992, 58.36367422100005],
              [-157.5026749339999, 58.46369049700007],
              [-157.45787512899992, 58.507879950000074],
              [-157.4361466139999, 58.52163320500006],
              [-157.38251705599993, 58.536363023000035],
              [-157.35859127499992, 58.54637278900003],
              [-157.26728268099993, 58.62026601800005],
              [-157.13434811099992, 58.686835028000075],
              [-157.1152237619999, 58.699652411000045],
              [-157.0917862619999, 58.70978424700007],
              [-156.9960831369999, 58.723822333000044],
              [-156.96918697799993, 58.73224518400008],
              [-156.94086666599992, 58.737534898000035],
              [-156.94086666599992, 58.74437083500004],
              [-156.97834225199992, 58.73899974200003],
              [-157.0236710279999, 58.72650788000004],
              [-157.0618790359999, 58.726223049000055],
              [-157.0779923169999, 58.75739166900007],
              [-157.06879635299993, 58.77846914300005],
              [-157.00226803299992, 58.83999258000006],
              [-157.02550208199992, 58.86347077000005],
              [-157.02269446499992, 58.86969635600008],
              [-157.00971432199992, 58.88153717700004],
              [-156.98859615799992, 58.89520905200004],
              [-156.9853409499999, 58.90326569200005],
              [-156.98558508999992, 58.910142320000034],
              [-156.98737545499992, 58.91469961100006],
              [-156.98859615799992, 58.915716864000046],
              [-156.9824112619999, 58.943345445000034],
              [-156.97630774599992, 58.95351797100005],
              [-156.9612930979999, 58.96344635600008],
              [-156.9221085279999, 58.976223049000055],
              [-156.88251705599993, 58.98395416900007],
              [-156.8603409499999, 58.99388255400004],
              [-156.85163326699993, 59.01821523600006],
              [-156.8514298169999, 59.07709381700005],
              [-156.8428848949999, 59.103216864000046],
              [-156.8228653639999, 59.12262604400007],
              [-156.80003821499992, 59.138739325000074],
              [-156.7831925119999, 59.15521881700005],
              [-156.85362708199992, 59.11994049700007],
              [-156.8651016919999, 59.11123281500005],
              [-156.86725826699993, 59.102728583000044],
              [-156.8780411449999, 59.07835521000004],
              [-156.88683020699992, 59.06793854400007],
              [-156.8846329419999, 59.05540599200003],
              [-156.88044186099992, 59.04165273600006],
              [-156.8787735669999, 59.03237539300005],
              [-156.88971920499992, 59.01251862200007],
              [-156.91010494699992, 58.997259833000044],
              [-156.9354141919999, 58.987494208000044],
              [-156.99181067599991, 58.981756903000075],
              [-157.01581783799992, 58.97406647300005],
              [-157.03490149599992, 58.959418036000045],
              [-157.05072994699992, 58.93618398600006],
              [-157.06956946499992, 58.899725653000075],
              [-157.08446204299992, 58.88666413000004],
              [-157.13556881399992, 58.87734609600005],
              [-157.25446529899992, 58.84048086100006],
              [-157.37311764199993, 58.82477448100008],
              [-157.38683020699992, 58.82086823100008],
              [-157.40021725199992, 58.81549713700008],
              [-157.4100235669999, 58.80951569200005],
              [-157.42402096299992, 58.80304596600007],
              [-157.4752091139999, 58.79962799700007],
              [-157.5681785129999, 58.74789321500003],
              [-157.6574597169999, 58.736186718000056],
              [-157.8141819049999, 58.68770884400004],
              [-157.97809811099992, 58.64752838700008],
              [-158.1536759109999, 58.61399974200003],
              [-158.2033585279999, 58.612982489000046],
              [-158.26301021999993, 58.62352122600004],
              [-158.31586666599992, 58.646551825000074],
              [-158.34544837099992, 58.682928778000075],
              [-158.3358048169999, 58.70148346600007],
              [-158.34528561099992, 58.72406647300005],
              [-158.36359615799992, 58.74461497600004],
              [-158.38019771999993, 58.75739166900007],
              [-158.40831458199992, 58.77008698100008],
              [-158.54613196499992, 58.799261786000045],
              [-158.5577286449999, 58.80646393400008],
              [-158.56615149599992, 58.81948476800005],
              [-158.56566321499992, 58.83063385600008],
              [-158.55964107999992, 58.83999258000006],
              [-158.5515030589999, 58.84739817900004],
              [-158.53803463399993, 58.85626862200007],
              [-158.5284317699999, 58.86090729400007],
              [-158.51996822799993, 58.86733633000006],
              [-158.50995846299992, 58.88153717700004],
              [-158.4954727859999, 58.91168854400007],
              [-158.48884029899992, 58.92251211100006],
              [-158.49925696499992, 58.94879791900007],
              [-158.47748775899993, 58.96320221600007],
              [-158.42113196499992, 58.97711823100008],
              [-158.4315079419999, 58.97943756700005],
              [-158.43940182199992, 58.98354726800005],
              [-158.4432266919999, 58.98969147300005],
              [-158.4416397779999, 58.99823639500005],
              [-158.4515274729999, 58.99746328300006],
              [-158.46051998599992, 58.99477773600006],
              [-158.4686173169999, 58.990220445000034],
              [-158.47577877499992, 58.98395416900007],
              [-158.49750729099992, 58.99396393400008],
              [-158.4913223949999, 59.00153229400007],
              [-158.45872962099992, 59.01471588700008],
              [-158.44355221299992, 59.02533600500004],
              [-158.42430579299992, 59.03278229400007],
              [-158.4034317699999, 59.037176825000074],
              [-158.38329016799992, 59.03856028900003],
              [-158.17280025899993, 59.013006903000075],
              [-158.13715572799993, 58.99945709800005],
              [-158.1046036449999, 58.97988515800006],
              [-158.07856197799993, 58.956691799000055],
              [-158.06952877499992, 58.94330475500004],
              [-158.07062740799992, 58.925848700000074],
              [-158.06427975199992, 58.908270575000074],
              [-158.05683346299992, 58.89911530200004],
              [-158.04450436099992, 58.888373114000046],
              [-158.03014075399992, 58.87905508000006],
              [-158.0170792309999, 58.87409088700008],
              [-158.01732337099992, 58.88666413000004],
              [-158.01386471299992, 58.895697333000044],
              [-158.00666256399992, 58.900824286000045],
              [-157.99535071499992, 58.902044989000046],
              [-157.99535071499992, 58.908270575000074],
              [-158.0280655589999, 58.907538153000075],
              [-158.04133053299992, 58.911444403000075],
              [-158.05060787699992, 58.92251211100006],
              [-158.0341690749999, 58.94281647300005],
              [-158.05231686099992, 58.97134023600006],
              [-158.10212154899992, 59.01471588700008],
              [-158.14024817599991, 59.03620026200008],
              [-158.23383541599992, 59.03921133000006],
              [-158.3166397779999, 59.06244538000004],
              [-158.4026993479999, 59.07367584800005],
              [-158.4416397779999, 59.08698151200008],
              [-158.47321529899992, 59.104803778000075],
              [-158.48932857999992, 59.11782461100006],
              [-158.49628658799992, 59.13141510600008],
              [-158.49889075399992, 59.143866278000075],
              [-158.50556393099993, 59.14598216400003],
              [-158.5143936839999, 59.14500560100004],
              [-158.52354895699992, 59.148423570000034],
              [-158.5286759109999, 59.15615469000005],
              [-158.53083248599992, 59.16380442900004],
              [-158.53449459499993, 59.17059967700004],
              [-158.5440567699999, 59.175767320000034],
              [-158.5490616529999, 59.15766022300005],
              [-158.5474747389999, 59.14484284100007],
              [-158.53722083199992, 59.13719310100004],
              [-158.51610266799992, 59.134751695000034],
              [-158.5167130199999, 59.11151764500005],
              [-158.4572647779999, 59.075873114000046],
              [-158.46214758999992, 59.052801825000074],
              [-158.48078365799992, 59.04409414300005],
              [-158.52118893099993, 59.03733958500004],
              [-158.53722083199992, 59.02558014500005],
              [-158.5405167309999, 59.02057526200008],
              [-158.54259192599991, 59.015611070000034],
              [-158.5436905589999, 59.00971100500004],
              [-158.5440567699999, 59.001654364000046],
              [-158.54731197799993, 58.993475653000075],
              [-158.55431067599991, 58.98891836100006],
              [-158.56135006399992, 58.98550039300005],
              [-158.57787024599992, 58.95917389500005],
              [-158.60899817599991, 58.93317291900007],
              [-158.6443985669999, 58.91128164300005],
              [-158.6884659499999, 58.89557526200008],
              [-158.70909583199992, 58.882879950000074],
              [-158.7294815749999, 58.87360260600008],
              [-158.74640865799992, 58.877834377000056],
              [-158.75336666599992, 58.89044830900008],
              [-158.7480362619999, 58.90021393400008],
              [-158.73749752499992, 58.911444403000075],
              [-158.72899329299992, 58.92869700700004],
              [-158.76264400899993, 58.94367096600007],
              [-158.77782141799992, 58.95262278900003],
              [-158.79047604099992, 58.96344635600008],
              [-158.7541397779999, 58.97215403900003],
              [-158.7397354809999, 58.97988515800006],
              [-158.74640865799992, 58.99481842700004],
              [-158.82526607999992, 58.97711823100008],
              [-158.81049557199992, 58.96596914300005],
              [-158.77204342399992, 58.92047760600008],
              [-158.76996822799993, 58.91107819200005],
              [-158.79389400899993, 58.81635163000004],
              [-158.7835587229999, 58.79950592700004],
              [-158.78246008999992, 58.78388092700004],
              [-158.78795325399992, 58.76976146000004],
              [-158.79731197799993, 58.75739166900007],
              [-158.8118790359999, 58.74445221600007],
              [-158.82795162699992, 58.73627350500004],
              [-158.84691321499992, 58.73200104400007],
              [-158.86994381399992, 58.73069896000004],
              [-158.8779190749999, 58.73236725500004],
              [-158.88560950399992, 58.73680247600004],
              [-158.89130611899992, 58.743353583000044],
              [-158.89350338399993, 58.751166083000044],
              [-158.89008541599992, 58.76361725500004],
              [-158.88154049399992, 58.768459377000056],
              [-158.8593643869999, 58.77167389500005],
              [-158.81977291599992, 58.78392161700003],
              [-158.80431067599991, 58.79466380400004],
              [-158.80785071499992, 58.80951569200005],
              [-158.8271378249999, 58.81940338700008],
              [-158.85102291599992, 58.82021719000005],
              [-158.87323971299992, 58.81317780200004],
              [-158.8873184889999, 58.79962799700007],
              [-158.86143958199992, 58.79946523600006],
              [-158.8741348949999, 58.78974030200004],
              [-158.90033932199992, 58.778957424000055],
              [-158.91462154899992, 58.775376695000034],
              [-158.91295325399992, 58.75763580900008],
              [-158.9084366529999, 58.74119700700004],
              [-158.88939585199992, 58.70629295300006],
              [-158.85159509699992, 58.67709056800004],
              [-158.8201510449999, 58.61403374900004],
              [-158.79389400899993, 58.56932200700004],
              [-158.79208704599992, 58.57041654500006],
              [-158.77904212099992, 58.56289297100005],
              [-158.77265377499992, 58.55878327000005],
              [-158.77000891799992, 58.54913971600007],
              [-158.77143307199992, 58.524644273000035],
              [-158.77000891799992, 58.518459377000056],
              [-158.75849361899992, 58.50726959800005],
              [-158.74592037699992, 58.505113023000035],
              [-158.73363196499992, 58.50625234600005],
              [-158.72284908799992, 58.50482819200005],
              [-158.70868893099993, 58.492254950000074],
              [-158.7200821609999, 58.483587958000044],
              [-158.73969479099992, 58.47418854400007],
              [-158.7597550119999, 58.44708893400008],
              [-158.78205318899992, 58.437160549000055],
              [-158.80711829299992, 58.43073151200008],
              [-158.82526607999992, 58.429022528000075],
              [-158.82526607999992, 58.42218659100007],
              [-158.79731197799993, 58.42218659100007],
              [-158.82966061099992, 58.40477122600004],
              [-158.8817339789999, 58.39962014000008],
              [-158.93976118199993, 58.39807054100004],
              [-159.0148557299999, 58.41454823400005],
              [-159.05125891799992, 58.424709377000056],
              [-159.0716446609999, 58.442694403000075],
              [-159.05842037699992, 58.438381252000056],
              [-159.04633541599992, 58.43829987200007],
              [-159.0366104809999, 58.443793036000045],
              [-159.03071041599992, 58.456366278000075],
              [-159.05573482999992, 58.45587799700007],
              [-159.07469641799992, 58.45872630400004],
              [-159.08368893099993, 58.46906159100007],
              [-159.0784805979999, 58.491115627000056],
              [-159.1146134109999, 58.49005768400008],
              [-159.1509903639999, 58.518784898000035],
              [-159.2088516919999, 58.58673737200007],
              [-159.29893958199992, 58.67234935100004],
              [-159.3849544269999, 58.75582395500004],
              [-159.48273678299992, 58.816066799000055],
              [-159.50690670499992, 58.82217031500005],
              [-159.5179337229999, 58.82632070500006],
              [-159.54503333199992, 58.84430573100008],
              [-159.55146236899992, 58.84739817900004],
              [-159.57929439999992, 58.84617747600004],
              [-159.5940645569999, 58.831711013000074],
              [-159.6337784499999, 58.83470286700003],
              [-159.66091830599993, 58.839442828000074],
              [-159.6302429609999, 58.852715096000054],
              [-159.6009682339999, 58.88545449500003],
              [-159.5869406289999, 58.90746285400007],
              [-159.61748656499992, 58.931323761000044],
              [-159.63814764199992, 58.93509772800007],
              [-159.6513354749999, 58.93555416800007],
              [-159.68018255099992, 58.93175312800008],
              [-159.70964888199993, 58.92865685700008],
              [-159.73812726999992, 58.92824720500005],
              [-159.72876240699992, 58.918736967000086],
              [-159.72517723099992, 58.91043894400008],
              [-159.73462458799992, 58.89269182800007],
              [-159.75573160899992, 58.88146798200006],
              [-159.7682293709999, 58.86553133500007],
              [-159.74332894999992, 58.85447744700008],
              [-159.75292350299992, 58.84082576900005],
              [-159.76597284399992, 58.83136932200006],
              [-159.77692652699992, 58.848779473000036],
              [-159.7985002249999, 58.84983291100008],
              [-159.80703976799992, 58.84466227100006],
              [-159.8059776929999, 58.837465301000066],
              [-159.79948463899993, 58.83146084800006],
              [-159.7959200539999, 58.823162764000074],
              [-159.7861806329999, 58.817039471000044],
              [-159.79485136499991, 58.80027681800004],
              [-159.81669794099992, 58.793831596000075],
              [-159.83995520699992, 58.792669989000046],
              [-159.86635986899992, 58.77912303700003],
              [-159.90612961199992, 58.765405788000066],
              [-159.91148010999993, 58.775800839000055],
              [-159.9295393369999, 58.79000746400004],
              [-159.96296139199993, 58.82005442900004],
              [-159.98521887899992, 58.835150458000044],
              [-159.9902237619999, 58.83999258000006],
              [-159.98334772799993, 58.84922754200005],
              [-159.9833026809999, 58.860806849000085],
              [-159.98924518799993, 58.86610987200004],
              [-159.99714107999992, 58.87409088700008],
              [-160.01837954599992, 58.880378119000056],
              [-160.0458151009999, 58.882590479000044],
              [-160.0705647789999, 58.87959732200005],
              [-160.08487286399992, 58.87560164200005],
              [-160.08893569999992, 58.86890966500005],
              [-160.09222354699992, 58.86321649900003],
              [-160.09686256499992, 58.85722361300003],
              [-160.1129120479999, 58.86110700800003],
              [-160.1323136059999, 58.866400458000044],
              [-160.1530951729999, 58.861284684000054],
              [-160.16525347799993, 58.86438193200007],
              [-160.1502486589999, 58.880938240000035],
              [-160.1580704419999, 58.899318752000056],
              [-160.15220167599992, 58.91610405300008],
              [-160.20185647899993, 58.908416558000056],
              [-160.2223353429999, 58.90220448000008],
              [-160.22886944099992, 58.89081087800008],
              [-160.2464417299999, 58.886895905000074],
              [-160.25306271999992, 58.89867404900008],
              [-160.2571915359999, 58.91193268400008],
              [-160.25409908799992, 58.935980536000045],
              [-160.25666256399992, 58.94623444200005],
              [-160.26768958199992, 58.950384833000044],
              [-160.28765062699992, 58.93239836100008],
              [-160.30146291199992, 58.94507065800008],
              [-160.3289308459999, 58.941428804000054],
              [-160.3311286699999, 58.95171983600005],
              [-160.31920325399992, 58.956691799000055],
              [-160.31733150899993, 58.96515534100007],
              [-160.3012258509999, 58.97166411200004],
              [-160.29602236399992, 58.976973024000074],
              [-160.2675389469999, 58.977495470000065],
              [-160.2571915359999, 58.98395416900007],
              [-160.25511633999992, 58.990301825000074],
              [-160.2580460279999, 58.995428778000075],
              [-160.26459713399993, 59.001654364000046],
              [-160.2693985669999, 59.011704820000034],
              [-160.2803848949999, 59.01850006700005],
              [-160.29291744699992, 59.02366771000004],
              [-160.30219479099992, 59.028957424000055],
              [-160.3068741529999, 59.032416083000044],
              [-160.31725012899992, 59.03774648600006],
              [-160.32233639199993, 59.042303778000075],
              [-160.3347231239999, 59.053837343000055],
              [-160.32087154899992, 59.06134674700007],
              [-160.32542883999992, 59.06655508000006],
              [-160.35216913099993, 59.07065938000005],
              [-160.4015355729999, 59.048843531000045],
              [-160.52951963899991, 59.00190395800007],
              [-160.6671557509999, 58.94764329000009],
              [-160.69415067199992, 58.92824736600005],
              [-160.76849564699992, 58.896425942000064],
              [-160.83371966299993, 58.81254635000005],
              [-160.82748648799992, 58.837265165000076],
              [-160.82936804899992, 58.85264654100007],
              [-160.84244190899992, 58.86796174500006],
              [-160.86786926999991, 58.87881738800007],
              [-160.88855118499993, 58.884101928000064],
              [-160.9077503569999, 58.876391108000064],
              [-160.96141396899992, 58.87324700500005],
              [-160.97939498199992, 58.86413050900006],
              [-160.99333381699992, 58.84668766400006],
              [-161.03322738799991, 58.84247571600008],
              [-161.07617725199992, 58.817573406000065],
              [-161.1095859559999, 58.811507963000054],
              [-161.1375873099999, 58.79917279300008],
              [-161.17321814299993, 58.79756598500006],
              [-161.17970067099992, 58.782725861000074],
              [-161.24407419899993, 58.78274814900004],
              [-161.2719733229999, 58.78709297100005],
              [-161.29124438999992, 58.792609707000054],
              [-161.27863521999993, 58.810248114000046],
              [-161.2713516919999, 58.81264883000006],
              [-161.2713516919999, 58.82005442900004],
              [-161.30040442599991, 58.81464264500005],
              [-161.3061417309999, 58.81264883000006],
              [-161.31029212099992, 58.80548737200007],
              [-161.31257076699993, 58.79645416900007],
              [-161.31065833199992, 58.78864166900007],
              [-161.30243893099993, 58.78534577000005],
              [-161.2897816379999, 58.77794636400006],
              [-161.26295270799991, 58.776689813000075],
              [-161.29010982999992, 58.77045319200005],
              [-161.3105132729999, 58.74807437100009],
              [-161.35746944399992, 58.726245282000036],
              [-161.36713185899993, 58.71146943300005],
              [-161.3745822379999, 58.699709848000055],
              [-161.376222, 58.68680187400008],
              [-161.3745011059999, 58.67234935100004],
              [-161.3619046579999, 58.66845776000008],
              [-161.32710073799993, 58.67828065800006],
              [-161.3012849579999, 58.68181770100006],
              [-161.3638876359999, 58.65964736900008],
              [-161.4883251379999, 58.64039231400005],
              [-161.5359955099999, 58.623292881000054],
              [-161.5502826249999, 58.60655561700008],
              [-161.56237259899993, 58.602024664000055],
              [-161.58503170499992, 58.60761139500005],
              [-161.59691321499992, 58.60716380400004],
              [-161.6126602859999, 58.60492584800005],
              [-161.6397598949999, 58.59516022300005],
              [-161.66563880099991, 58.59080638200004],
              [-161.67634029899992, 58.58539459800005],
              [-161.68525143099993, 58.577826239000046],
              [-161.69310462099992, 58.56932200700004],
              [-161.70750891799992, 58.56118398600006],
              [-161.72667395699992, 58.55849844000005],
              [-161.76484127499992, 58.55939362200007],
              [-161.7521866529999, 58.57709381700005],
              [-161.72052975199992, 58.599269924000055],
              [-161.71019446499992, 58.61399974200003],
              [-161.72350012899992, 58.62555573100008],
              [-161.7381485669999, 58.63450755400004],
              [-161.75641842399992, 58.64313385600008],
              [-161.76508541599992, 58.64508698100008],
              [-161.7617081369999, 58.637884833000044],
              [-161.76134192599991, 58.62909577000005],
              [-161.7670792309999, 58.61774323100008],
              [-161.7628850279999, 58.59098617900008],
              [-161.7795304029999, 58.612616278000075],
              [-161.79767818899992, 58.62323639500005],
              [-161.8343012299999, 58.62648240100003],
              [-161.9128453099999, 58.63186297900006],
              [-161.9365160069999, 58.629691850000086],
              [-161.9596851439999, 58.62328157600007],
              [-161.9801398319999, 58.62837399700004],
              [-162.01209927099993, 58.62071422300005],
              [-162.03582065299992, 58.62585117000003],
              [-162.07717137799992, 58.62089330800006],
              [-162.13776607999992, 58.63385651200008],
              [-162.17605360699991, 58.64492345100007],
              [-162.12177508399992, 58.66385613700004],
              [-162.06708736899992, 58.66665273600006],
              [-162.0460098949999, 58.682928778000075],
              [-162.03010006399992, 58.67593008000006],
              [-161.99030514199993, 58.67910390800006],
              [-161.9659317699999, 58.67475006700005],
              [-161.9544571609999, 58.67645905200004],
              [-161.94977779899992, 58.675482489000046],
              [-161.9492081369999, 58.673041083000044],
              [-161.95038814999992, 58.66425202000005],
              [-161.94977779899992, 58.661810614000046],
              [-161.94355221299992, 58.65688711100006],
              [-161.93993079299992, 58.65273672100005],
              [-161.93443762899992, 58.649644273000035],
              [-161.9224747389999, 58.648138739000046],
              [-161.89110266799992, 58.65371328300006],
              [-161.85871334499993, 58.66941966400003],
              [-161.84284420499992, 58.69163646000004],
              [-161.86748851099992, 58.704048422000085],
              [-161.8654184629999, 58.71626323400005],
              [-161.82188880099991, 58.73354726800005],
              [-161.80980383999992, 58.74095286700003],
              [-161.79584713399993, 58.753892320000034],
              [-161.7862442699999, 58.75873444200005],
              [-161.75861568899992, 58.75739166900007],
              [-161.7173755009999, 58.75484288900003],
              [-161.67739790599992, 58.773526668000045],
              [-161.65558834499993, 58.80646393400008],
              [-161.68484021299992, 58.81858586100003],
              [-161.7121632939999, 58.81297008100006],
              [-161.73353055099992, 58.80790291400007],
              [-161.75311722499993, 58.789869757000076],
              [-161.7621258929999, 58.77266840300007],
              [-161.7747368729999, 58.770506674000046],
              [-161.76264400899993, 58.80499909100007],
              [-161.7592667309999, 58.81549713700008],
              [-161.75861568899992, 58.82632070500006],
              [-161.7628067699999, 58.835638739000046],
              [-161.76963131199992, 58.84872806100003],
              [-161.7775958759999, 58.857714463000036],
              [-161.78552110099992, 58.87761920500009],
              [-161.7906685359999, 58.899866805000045],
              [-161.79279537699992, 58.96478913000004],
              [-161.7949112619999, 58.97451406500005],
              [-161.7995499339999, 58.98395416900007],
              [-161.8077286449999, 58.989569403000075],
              [-161.8347061839999, 59.00287506700005],
              [-161.84052486899992, 59.00820547100005],
              [-161.85163326699993, 59.02317942900004],
              [-161.8558243479999, 59.03375885600008],
              [-161.85045325399992, 59.03856028900003],
              [-161.8455704419999, 59.03974030200004],
              [-161.8359268869999, 59.04486725500004],
              [-161.82970130099991, 59.04604726800005],
              [-161.82209225199992, 59.04437897300005],
              [-161.82123775899993, 59.04043203300006],
              [-161.8222550119999, 59.03587474200003],
              [-161.82005774599992, 59.03237539300005],
              [-161.81794186099992, 59.03009674700007],
              [-161.8159073559999, 59.02635325700004],
              [-161.81261145699992, 59.02204010600008],
              [-161.80638587099992, 59.01813385600008],
              [-161.79857337099992, 59.01748281500005],
              [-161.77167721299992, 59.02558014500005],
              [-161.7424210279999, 59.03021881700005],
              [-161.72516842399992, 59.03510163000004],
              [-161.69404049399992, 59.05491771000004],
              [-161.6140030589999, 59.08075592700004],
              [-161.60899817599991, 59.08551666900007],
              [-161.6048477859999, 59.09638092700004],
              [-161.6003311839999, 59.101263739000046],
              [-161.5944718089999, 59.101996161000045],
              [-161.57774817599991, 59.09992096600007],
              [-161.57306881399992, 59.101263739000046],
              [-161.56916256399992, 59.11505768400008],
              [-161.57787024599992, 59.12051015800006],
              [-161.61030025899993, 59.12055084800005],
              [-161.6132706369999, 59.12396881700005],
              [-161.61640377499992, 59.13141510600008],
              [-161.6232804029999, 59.13882070500006],
              [-161.63788814999992, 59.142238674000055],
              [-161.6467179029999, 59.13934967700004],
              [-161.6710098949999, 59.12531159100007],
              [-161.68293209499993, 59.12055084800005],
              [-161.72313391799992, 59.11579010600008],
              [-161.84052486899992, 59.12055084800005],
              [-161.87348385299993, 59.111029364000046],
              [-161.88837643099993, 59.09438711100006],
              [-161.88097083199992, 59.07892487200007],
              [-161.84740149599992, 59.07330963700008],
              [-161.84740149599992, 59.06655508000006],
              [-161.8964737619999, 59.075384833000044],
              [-161.9394425119999, 59.09857819200005],
              [-161.9741104809999, 59.13141510600008],
              [-162.0295304029999, 59.230129299000055],
              [-162.04291744699992, 59.24835846600007],
              [-162.0515030589999, 59.27016836100006],
              [-162.03868567599991, 59.28937409100007],
              [-162.02000891799992, 59.30174388200004],
              [-161.99823971299992, 59.312933661000045],
              [-162.03620357999992, 59.28188711100006],
              [-162.04364986899992, 59.26577383000006],
              [-162.03498287699992, 59.250881252000056],
              [-162.00902258999992, 59.237534898000035],
              [-161.98310299399992, 59.25372955900008],
              [-161.9682511059999, 59.28082916900007],
              [-161.97089596299992, 59.306708075000074],
              [-161.9643448559999, 59.315334377000056],
              [-161.96247311099992, 59.32807038000004],
              [-161.9647110669999, 59.34194570500006],
              [-161.97089596299992, 59.35390859600005],
              [-161.95946204299992, 59.375067450000074],
              [-161.94660396999993, 59.38776276200008],
              [-161.92943274599992, 59.393866278000075],
              [-161.90510006399992, 59.39545319200005],
              [-161.8831680979999, 59.42226797100005],
              [-161.8675430979999, 59.43309153900003],
              [-161.85358639199993, 59.42218659100007],
              [-161.84740149599992, 59.42218659100007],
              [-161.83759518099993, 59.43992747600004],
              [-161.82123775899993, 59.46336497600004],
              [-161.80162512899992, 59.47919342700004],
              [-161.7709854809999, 59.469956773000035],
              [-161.7557266919999, 59.472642320000034],
              [-161.74079342399992, 59.47870514500005],
              [-161.73066158799992, 59.484808661000045],
              [-161.71723385299993, 59.49583567900004],
              [-161.71393795499992, 59.50136953300006],
              [-161.8592423169999, 59.628119208000044],
              [-161.86725826699993, 59.655503648000035],
              [-161.87621008999992, 59.66771067900004],
              [-161.87922115799992, 59.67959219000005],
              [-161.87983150899993, 59.68984609600005],
              [-161.88154049399992, 59.69717031500005],
              [-161.8896378249999, 59.706244208000044],
              [-161.90900631399992, 59.718817450000074],
              [-161.9941300119999, 59.81110260600008],
              [-162.08177649599992, 59.87787506700005],
              [-162.09455318899992, 59.89402903900003],
              [-162.10126705599993, 59.91559479400007],
              [-162.10008704299992, 59.95111725500004],
              [-162.1087540359999, 59.96515534100007],
              [-162.1580704419999, 59.97650788000004],
              [-162.17878170499992, 59.99042389500005],
              [-162.19623775899993, 60.008246161000045],
              [-162.20982825399992, 60.025458075000074],
              [-162.2310684889999, 60.06439850500004],
              [-162.24006100199992, 60.08978913000004],
              [-162.2343643869999, 60.101223049000055],
              [-162.22406979099992, 60.105454820000034],
              [-162.21418209499993, 60.11562734600005],
              [-162.20665442599991, 60.12799713700008],
              [-162.20360266799992, 60.138739325000074],
              [-162.20319576699993, 60.14752838700008],
              [-162.20356197799993, 60.15330638200004],
              [-162.2073868479999, 60.15961334800005],
              [-162.24555416599992, 60.19476959800005],
              [-162.2514100159999, 60.20141918300004],
              [-162.22126217399992, 60.20184967700004],
              [-162.1862686839999, 60.209865627000056],
              [-162.16156260199992, 60.21636674000007],
              [-162.16115868499992, 60.23247786200005],
              [-162.1566055979999, 60.24437083500004],
              [-162.1490372389999, 60.24518463700008],
              [-162.16169186099992, 60.25067780200004],
              [-162.17524166599992, 60.25063711100006],
              [-162.20360266799992, 60.24518463700008],
              [-162.20051021999993, 60.241522528000075],
              [-162.1983536449999, 60.238267320000034],
              [-162.18150114199992, 60.232506079000075],
              [-162.18104397599993, 60.223118739000085],
              [-162.2104386059999, 60.217962958000044],
              [-162.24889075399992, 60.21474844000005],
              [-162.27855383999992, 60.22345612200007],
              [-162.2725723949999, 60.24518463700008],
              [-162.29023189999992, 60.24249909100007],
              [-162.29808508999992, 60.23590729400007],
              [-162.30011959499993, 60.226996161000045],
              [-162.29987545499992, 60.217230536000045],
              [-162.29755611899992, 60.214178778000075],
              [-162.29267330599993, 60.21190013200004],
              [-162.28779049399992, 60.21076080900008],
              [-162.28559322799993, 60.21108633000006],
              [-162.2845352859999, 60.196966864000046],
              [-162.28559322799993, 60.19676341400003],
              [-162.29112708199992, 60.196600653000075],
              [-162.2983292309999, 60.18919505400004],
              [-162.30011959499993, 60.18048737200007],
              [-162.2892960279999, 60.17633698100008],
              [-162.25767673899992, 60.173847152000064],
              [-162.23651868299993, 60.16275217300006],
              [-162.22872560899992, 60.14558587500005],
              [-162.2384199649999, 60.135616635000076],
              [-162.26394025099992, 60.12729391500005],
              [-162.28835510599993, 60.121593730000086],
              [-162.2977819799999, 60.11642402100006],
              [-162.3172430179999, 60.11306035400008],
              [-162.3376510909999, 60.129653327000085],
              [-162.3431290359999, 60.13939036700003],
              [-162.36689205599993, 60.162543036000045],
              [-162.37279212099992, 60.170355536000045],
              [-162.37494869699992, 60.17633698100008],
              [-162.36220062499993, 60.18090757600004],
              [-162.35358639199993, 60.187567450000074],
              [-162.3476456369999, 60.190619208000044],
              [-162.3404434889999, 60.20766836100006],
              [-162.3416641919999, 60.21898021000004],
              [-162.35004635299993, 60.228949286000045],
              [-162.3643692699999, 60.24176666900007],
              [-162.41254635299993, 60.27252838700008],
              [-162.43016516799992, 60.27521393400008],
              [-162.44697018099993, 60.28196849200003],
              [-162.4585796069999, 60.29508559100003],
              [-162.44239243899992, 60.30958829200006],
              [-162.39047498899993, 60.32946637200007],
              [-162.33324133999992, 60.40021393400008],
              [-162.31920325399992, 60.42259349200003],
              [-162.31354732999992, 60.44721100500004],
              [-162.3030899729999, 60.47085195500006],
              [-162.27851314999992, 60.485663153000075],
              [-162.2499893869999, 60.49664948100008],
              [-162.2275284499999, 60.508978583000044],
              [-162.22435462099992, 60.51935455900008],
              [-162.22740637899992, 60.53192780200004],
              [-162.2287491529999, 60.54242584800005],
              [-162.2206925119999, 60.54682038000004],
              [-162.21996008999992, 60.55215078300006],
              [-162.2221573559999, 60.57794830900008],
              [-162.2241104809999, 60.58783600500004],
              [-162.20771236899992, 60.58893463700008],
              [-162.1916397779999, 60.59389883000006],
              [-162.1097305979999, 60.63141510600008],
              [-162.09784908799992, 60.63934967700004],
              [-162.06135006399992, 60.65102773600006],
              [-161.96711178299992, 60.64565664300005],
              [-161.94298255099991, 60.66974518400008],
              [-161.95783443899992, 60.67527903900003],
              [-161.96344967399992, 60.67658112200007],
              [-161.94493567599991, 60.68500397300005],
              [-161.88154049399992, 60.70392487200007],
              [-161.91059322799993, 60.71369049700007],
              [-161.9382218089999, 60.70766836100006],
              [-161.96503658799992, 60.69635651200008],
              [-162.0722550119999, 60.665228583000044],
              [-162.09443111899992, 60.66974518400008],
              [-162.0882462229999, 60.68691640800006],
              [-162.1151016919999, 60.71279531500005],
              [-162.15375729099992, 60.732489325000074],
              [-162.18317623599992, 60.73114655200004],
              [-162.12995357999992, 60.70140208500004],
              [-162.1216934889999, 60.69399648600006],
              [-162.12128658799992, 60.67523834800005],
              [-162.12336178299992, 60.65892161700003],
              [-162.1331680979999, 60.64740631700005],
              [-162.18378658799992, 60.63963450700004],
              [-162.23753821499992, 60.62474192900004],
              [-162.26166744699992, 60.62132396000004],
              [-162.27631588399993, 60.612941799000055],
              [-162.28412838399993, 60.59365469000005],
              [-162.28937740799992, 60.571926174000055],
              [-162.29645748599992, 60.55646393400008],
              [-162.2997940749999, 60.55117422100005],
              [-162.30610104099992, 60.533189195000034],
              [-162.36591549399992, 60.476629950000074],
              [-162.37494869699992, 60.464911200000074],
              [-162.37726803299992, 60.458197333000044],
              [-162.3792618479999, 60.44253164300005],
              [-162.38243567599991, 60.43695709800005],
              [-162.39415442599991, 60.43309153900003],
              [-162.42894446499992, 60.43695709800005],
              [-162.44123287699992, 60.42340729400007],
              [-162.43602454299992, 60.412543036000045],
              [-162.42402096299992, 60.40021393400008],
              [-162.41596432199992, 60.38239166900007],
              [-162.45201575399992, 60.370754299000055],
              [-162.46479244699992, 60.372381903000075],
              [-162.4568985669999, 60.38857656500005],
              [-162.4643448559999, 60.39598216400003],
              [-162.49946041599992, 60.38198476800005],
              [-162.50922604099992, 60.37287018400008],
              [-162.49787350199992, 60.36127350500004],
              [-162.51252193899992, 60.35492584800005],
              [-162.53779049399992, 60.35101959800005],
              [-162.54999752499992, 60.34446849200003],
              [-162.55951900899993, 60.33746979400007],
              [-162.56781979099992, 60.33417389500005],
              [-162.57489986899992, 60.33690013200004],
              [-162.5804337229999, 60.34760163000004],
              [-162.58568274599992, 60.33942291900007],
              [-162.59068762899992, 60.33535390800006],
              [-162.5975235669999, 60.334051825000074],
              [-162.60834713399993, 60.33392975500004],
              [-162.60834713399993, 60.32709381700005],
              [-162.57673092399992, 60.31830475500004],
              [-162.5667618479999, 60.31346263200004],
              [-162.5911759109999, 60.30703359600005],
              [-162.60090084499993, 60.306626695000034],
              [-162.56220455599993, 60.293850002000056],
              [-162.5537003249999, 60.28620026200008],
              [-162.55011959499993, 60.27586497600004],
              [-162.55219479099992, 60.26715729400007],
              [-162.56000729099992, 60.26113515800006],
              [-162.57355709499993, 60.25885651200008],
              [-162.70331783799992, 60.265692450000074],
              [-162.6573380199999, 60.25169505400004],
              [-162.55842037699992, 60.237494208000044],
              [-162.46918697799993, 60.20490143400008],
              [-162.45026607999992, 60.191066799000055],
              [-162.45380611899992, 60.173163153000075],
              [-162.4818009109999, 60.15058014500005],
              [-162.49323482999992, 60.136786200000074],
              [-162.49787350199992, 60.11823151200008],
              [-162.49299068899992, 60.09918854400007],
              [-162.48310299399992, 60.08661530200004],
              [-162.47553463399993, 60.073431708000044],
              [-162.47736568899992, 60.052801825000074],
              [-162.48521887899992, 60.03538646000004],
              [-162.4964493479999, 60.01972077000005],
              [-162.51024329299992, 60.006740627000056],
              [-162.52582760299993, 59.99750397300005],
              [-162.57868404899992, 59.98387278900003],
              [-162.6397598949999, 59.98139069200005],
              [-162.70038814999992, 59.98883698100008],
              [-162.75169837099992, 60.00495026200008],
              [-162.75279700399992, 59.96824778900003],
              [-162.8079727859999, 59.942572333000044],
              [-163.08763587099992, 59.85911692900004],
              [-163.31647701699993, 59.83026764500005],
              [-163.61493893099993, 59.800848700000074],
              [-163.87714596299992, 59.79954661700003],
              [-164.09833736899992, 59.833685614000046],
              [-164.12852942599991, 59.842678127000056],
              [-164.15986080599993, 59.864569403000075],
              [-164.1870011059999, 59.891506252000056],
              [-164.20478268099993, 59.91559479400007],
              [-164.2122696609999, 59.95498281500005],
              [-164.18378658799992, 59.96865469000005],
              [-164.09491939999992, 59.97768789300005],
              [-164.09491939999992, 59.98452383000006],
              [-164.1061905589999, 59.98379140800006],
              [-164.11689205599993, 59.984442450000074],
              [-164.1269425119999, 59.98680247600004],
              [-164.13646399599992, 59.99135976800005],
              [-164.1302384109999, 59.99408600500004],
              [-164.1147354809999, 60.00495026200008],
              [-164.1467179029999, 60.01044342700004],
              [-164.2005509109999, 60.03432851800005],
              [-164.34813391799992, 60.066473700000074],
              [-164.38524329299992, 60.08490631700005],
              [-164.39964758999992, 60.087551174000055],
              [-164.41266842399992, 60.091782945000034],
              [-164.4345596999999, 60.110581773000035],
              [-164.44123287699992, 60.11481354400007],
              [-164.4443253249999, 60.11908600500004],
              [-164.47907467399992, 60.14215729400007],
              [-164.4882706369999, 60.15058014500005],
              [-164.49518795499992, 60.159857489000046],
              [-164.49555416599992, 60.168850002000056],
              [-164.48530025899993, 60.17633698100008],
              [-164.48530025899993, 60.18374258000006],
              [-164.51264400899993, 60.190619208000044],
              [-164.5644425119999, 60.21849192900004],
              [-164.61469479099992, 60.23187897300005],
              [-164.64378821499992, 60.24827708500004],
              [-164.6611221999999, 60.26642487200007],
              [-164.6491593089999, 60.27871328300006],
              [-164.65644283799992, 60.28807200700004],
              [-164.67365475199992, 60.29515208500004],
              [-164.67707271999993, 60.30320872600004],
              [-164.67328854099992, 60.312201239000046],
              [-164.6491593089999, 60.33392975500004],
              [-164.71495520699992, 60.30060455900008],
              [-164.75348873599992, 60.287095445000034],
              [-164.78388424399992, 60.29637278900003],
              [-164.8088272779999, 60.30809153900003],
              [-164.98896236899992, 60.34137604400007],
              [-165.00597083199992, 60.34674713700008],
              [-165.03876705599993, 60.37018463700008],
              [-165.07152258999992, 60.384833075000074],
              [-165.1014298169999, 60.406683661000045],
              [-165.1291397779999, 60.431708075000074],
              [-165.14325924399992, 60.45062897300005],
              [-165.12157141799992, 60.450506903000075],
              [-165.0538223949999, 60.464911200000074],
              [-165.0339249339999, 60.46662018400008],
              [-165.02399654899992, 60.46898021000004],
              [-165.01972408799992, 60.47455475500004],
              [-165.01825924399992, 60.48236725500004],
              [-165.0143936839999, 60.49282461100006],
              [-165.00898189999992, 60.501939195000034],
              [-165.00263424399992, 60.505845445000034],
              [-164.9833878249999, 60.51007721600007],
              [-164.97370357999992, 60.520412502000056],
              [-164.97419186099992, 60.533636786000045],
              [-164.98558508999992, 60.54682038000004],
              [-165.01044674399992, 60.55451080900008],
              [-165.16022701699993, 60.52195872600004],
              [-165.17426510299993, 60.51552969000005],
              [-165.19562740799992, 60.50226471600007],
              [-165.22175045499992, 60.49900950700004],
              [-165.3697403639999, 60.51211172100005],
              [-165.38434811099992, 60.516913153000075],
              [-165.43122311099992, 60.55304596600007],
              [-165.41169186099992, 60.56753164300005],
              [-165.3839005199999, 60.58104075700004],
              [-165.3541153639999, 60.58844635600008],
              [-165.31427975199992, 60.58087799700007],
              [-165.29771887899992, 60.58307526200008],
              [-165.28193111899992, 60.589097398000035],
              [-165.2701309889999, 60.597723700000074],
              [-165.2589005199999, 60.608710028000075],
              [-165.24885006399992, 60.61465078300006],
              [-165.20396887899992, 60.62539297100005],
              [-165.17113196499992, 60.64305247600004],
              [-165.11876380099991, 60.658636786000045],
              [-165.08063717399992, 60.681708075000074],
              [-165.02338619699992, 60.69668203300006],
              [-164.99921627499992, 60.711371161000045],
              [-164.9897354809999, 60.729681708000044],
              [-164.99665279899992, 60.74518463700008],
              [-165.0302628249999, 60.77619049700007],
              [-165.03136145699992, 60.78701406500005],
              [-165.01537024599992, 60.791449286000045],
              [-164.9948624339999, 60.79319896000004],
              [-164.98216712099992, 60.79633209800005],
              [-164.97150631399992, 60.80304596600007],
              [-164.92414303299992, 60.82054271000004],
              [-164.87494869699992, 60.84878164300005],
              [-164.89777584499993, 60.86933014500005],
              [-164.94225012899992, 60.88963450700004],
              [-164.95824133999992, 60.91681549700007],
              [-164.93744869699992, 60.93646881700005],
              [-164.91563880099991, 60.92446523600006],
              [-164.89557857999992, 60.901678778000075],
              [-164.87975012899992, 60.88947174700007],
              [-164.87128658799992, 60.88617584800005],
              [-164.8482559889999, 60.87164948100008],
              [-164.83478756399992, 60.868353583000044],
              [-164.8193253249999, 60.87140534100007],
              [-164.7807511059999, 60.895697333000044],
              [-164.75324459499993, 60.90619538000004],
              [-164.71104895699992, 60.917181708000044],
              [-164.66840572799993, 60.92177969000005],
              [-164.63951575399992, 60.913316148000035],
              [-164.6420792309999, 60.89988841400003],
              [-164.68565833199992, 60.867621161000045],
              [-164.69758053299992, 60.854681708000044],
              [-164.66913814999992, 60.82575104400007],
              [-164.59638424399992, 60.81891510600008],
              [-164.4648331369999, 60.82054271000004],
              [-164.42902584499993, 60.803900458000044],
              [-164.4163712229999, 60.800116278000075],
              [-164.37543697799993, 60.800116278000075],
              [-164.35749264199993, 60.79368724200003],
              [-164.3515518869999, 60.792669989000046],
              [-164.2835587229999, 60.792669989000046],
              [-164.27082271999993, 60.78790924700007],
              [-164.26768958199992, 60.77676015800006],
              [-164.2681778639999, 60.763373114000046],
              [-164.2662247389999, 60.75234609600005],
              [-164.2596329419999, 60.74213288000004],
              [-164.2521866529999, 60.73493073100008],
              [-164.24140377499992, 60.73114655200004],
              [-164.2245987619999, 60.73114655200004],
              [-164.2354630199999, 60.72321198100008],
              [-164.23554439999992, 60.71263255400004],
              [-164.22862708199992, 60.70111725500004],
              [-164.21837317599991, 60.69017161700003],
              [-164.32001705599993, 60.66229889500005],
              [-164.32823645699992, 60.656683661000045],
              [-164.3314102859999, 60.652411200000074],
              [-164.33783932199992, 60.640285549000055],
              [-164.3412979809999, 60.635646877000056],
              [-164.34190833199992, 60.63275788000004],
              [-164.3405655589999, 60.62409088700008],
              [-164.3412979809999, 60.62132396000004],
              [-164.34565182199992, 60.62026601800005],
              [-164.35712643099993, 60.62201569200005],
              [-164.36176510299993, 60.62132396000004],
              [-164.37018795499992, 60.61786530200004],
              [-164.38678951699993, 60.61351146000004],
              [-164.39594479099992, 60.608303127000056],
              [-164.3994034499999, 60.603216864000046],
              [-164.40607662699992, 60.58685944200005],
              [-164.41022701699993, 60.58038971600007],
              [-164.41645260299993, 60.57672760600008],
              [-164.4443253249999, 60.56732819200005],
              [-164.42035885299993, 60.55426666900007],
              [-164.39716549399992, 60.56037018400008],
              [-164.3549698559999, 60.59406159100007],
              [-164.29930579299992, 60.627020575000074],
              [-164.2835587229999, 60.63934967700004],
              [-164.25934811099992, 60.65326569200005],
              [-164.22883053299992, 60.65802643400008],
              [-164.16315670499992, 60.656683661000045],
              [-164.13508053299992, 60.663723049000055],
              [-164.11961829299992, 60.680568752000056],
              [-164.10175533799992, 60.71816640800006],
              [-164.08429928299992, 60.73456452000005],
              [-164.06261145699992, 60.74795156500005],
              [-164.0197647779999, 60.76654694200005],
              [-163.9863175119999, 60.77631256700005],
              [-163.95563717399992, 60.77985260600008],
              [-163.88878333199992, 60.77960846600007],
              [-163.86567135299993, 60.777044989000046],
              [-163.83869381399992, 60.76902903900003],
              [-163.81623287699992, 60.755113023000035],
              [-163.8068741529999, 60.73493073100008],
              [-163.8151749339999, 60.71466705900008],
              [-163.82905025899993, 60.69818756700005],
              [-163.83177649599992, 60.68378327000005],
              [-163.8068741529999, 60.66974518400008],
              [-163.8174942699999, 60.65961334800005],
              [-163.8288468089999, 60.65094635600008],
              [-163.8361710279999, 60.639553127000056],
              [-163.83482825399992, 60.62132396000004],
              [-163.8260391919999, 60.60716380400004],
              [-163.81110592399992, 60.59393952000005],
              [-163.79438229099992, 60.58417389500005],
              [-163.7798966139999, 60.58038971600007],
              [-163.7314346999999, 60.58270905200004],
              [-163.68647213399993, 60.58974844000005],
              [-163.6435440749999, 60.601548570000034],
              [-163.46430416599992, 60.67658112200007],
              [-163.4357804029999, 60.69745514500005],
              [-163.42914791599992, 60.71698639500005],
              [-163.44188391799992, 60.73529694200005],
              [-163.4716690749999, 60.75234609600005],
              [-163.4593399729999, 60.75409577000005],
              [-163.40900631399992, 60.75234609600005],
              [-163.42430579299992, 60.76471588700008],
              [-163.54364986899992, 60.81000397300005],
              [-163.86152096299992, 60.854681708000044],
              [-163.9128311839999, 60.849595445000034],
              [-163.9304093089999, 60.854681708000044],
              [-163.85285396999993, 60.883246161000045],
              [-163.8089493479999, 60.89252350500004],
              [-163.76593990799992, 60.88947174700007],
              [-163.7182511059999, 60.87132396000004],
              [-163.6976212229999, 60.868353583000044],
              [-163.57843990799992, 60.884100653000075],
              [-163.5627335279999, 60.89012278900003],
              [-163.5560196609999, 60.89996979400007],
              [-163.5635880199999, 60.913316148000035],
              [-163.5794571609999, 60.91986725500004],
              [-163.72508704299992, 60.93235911700003],
              [-163.75641842399992, 60.94525788000004],
              [-163.74543209499993, 60.964544989000046],
              [-163.72370357999992, 60.95661041900007],
              [-163.70197506399992, 60.96430084800005],
              [-163.68305416599992, 60.978949286000045],
              [-163.66966712099992, 60.991888739000046],
              [-163.7040909499999, 60.999660549000055],
              [-163.76878821499992, 60.980454820000034],
              [-163.80003821499992, 60.978216864000046],
              [-163.79596920499992, 60.95770905200004],
              [-163.8123673169999, 60.95197174700007],
              [-163.83714758999992, 60.95001862200007],
              [-163.85810299399992, 60.94098541900007],
              [-163.8671768869999, 60.93414948100008],
              [-163.88666744699992, 60.92796458500004],
              [-163.8956192699999, 60.92300039300005],
              [-163.90208899599992, 60.915228583000044],
              [-163.90794837099992, 60.89984772300005],
              [-163.91331946499992, 60.892564195000034],
              [-163.95750891799992, 60.86815013200004],
              [-164.00706946499992, 60.862209377000056],
              [-164.1353653639999, 60.86713288000004],
              [-164.36375891799992, 60.87205638200004],
              [-164.5644425119999, 60.854681708000044],
              [-164.5732315749999, 60.85761139500005],
              [-164.59300696499992, 60.87148672100005],
              [-164.60260982999992, 60.87579987200007],
              [-164.58454342399992, 60.900091864000046],
              [-164.58588619699992, 60.91006094000005],
              [-164.60260982999992, 60.92300039300005],
              [-164.6280411449999, 60.93231842700004],
              [-164.71495520699992, 60.93724192900004],
              [-164.72675533799992, 60.93500397300005],
              [-164.74498450399992, 60.92523834800005],
              [-164.7679337229999, 60.91982656500005],
              [-164.78827877499992, 60.90570709800005],
              [-164.79755611899992, 60.90253327000005],
              [-164.81489010299993, 60.90810781500005],
              [-164.83832760299993, 60.93744538000004],
              [-164.8558243479999, 60.950873114000046],
              [-164.87946529899992, 60.95742422100005],
              [-164.90709387899992, 60.95872630400004],
              [-164.9346817699999, 60.95612213700008],
              [-164.95824133999992, 60.950873114000046],
              [-165.01524817599991, 60.92104726800005],
              [-165.03681393099993, 60.91681549700007],
              [-165.08149166599992, 60.91738515800006],
              [-165.12897701699993, 60.923488674000055],
              [-165.17076575399992, 60.94159577000005],
              [-165.19847571499992, 60.978216864000046],
              [-165.1181534499999, 61.01325104400007],
              [-165.0886124339999, 61.01984284100007],
              [-164.97419186099992, 61.02533600500004],
              [-164.95079505099991, 61.01984284100007],
              [-164.95282955599993, 61.05703359600005],
              [-164.95079505099991, 61.067572333000044],
              [-164.9400528639999, 61.08380768400008],
              [-164.92719479099992, 61.08698151200008],
              [-164.86449133999992, 61.079779364000046],
              [-164.85700436099992, 61.08234284100007],
              [-164.84528561099992, 61.09121328300006],
              [-164.82787024599992, 61.09955475500004],
              [-164.7857559889999, 61.10431549700007],
              [-164.76646887899992, 61.108587958000044],
              [-164.78339596299992, 61.120021877000056],
              [-164.81456458199992, 61.11871979400007],
              [-164.8763321609999, 61.108587958000044],
              [-164.93097896999993, 61.11473216400003],
              [-164.99921627499992, 61.11473216400003],
              [-165.01256262899992, 61.10626862200007],
              [-165.00556393099993, 61.08746979400007],
              [-165.00401770699992, 61.06867096600007],
              [-165.03368079299992, 61.06012604400007],
              [-165.05870520699992, 61.06289297100005],
              [-165.08482825399992, 61.07025788000004],
              [-165.1093643869999, 61.08100006700005],
              [-165.12958736899992, 61.09430573100008],
              [-165.12975012899992, 61.106634833000044],
              [-165.17524166599992, 61.12177155200004],
              [-165.19102942599991, 61.13646067900004],
              [-165.1686905589999, 61.145697333000044],
              [-165.14655514199993, 61.149725653000075],
              [-165.1295059889999, 61.15664297100005],
              [-165.1155899729999, 61.19057851800005],
              [-165.09850012899992, 61.20307038000004],
              [-165.06065833199992, 61.218451239000046],
              [-165.14325924399992, 61.259426174000055],
              [-165.13170325399992, 61.241848049000055],
              [-165.11925208199992, 61.23037344000005],
              [-165.10358639199993, 61.22313060100004],
              [-165.0823868479999, 61.218451239000046],
              [-165.10277258999992, 61.20844147300005],
              [-165.1204727859999, 61.205959377000056],
              [-165.1360977859999, 61.20099518400008],
              [-165.15001380099991, 61.183661200000074],
              [-165.14826412699992, 61.17715078300006],
              [-165.14399166599992, 61.16771067900004],
              [-165.1443985669999, 61.159369208000044],
              [-165.1568497389999, 61.15574778900003],
              [-165.21149654899992, 61.14956289300005],
              [-165.34687252499992, 61.19708893400008],
              [-165.3697403639999, 61.20075104400007],
              [-165.36274166599992, 61.21279531500005],
              [-165.3267716139999, 61.231634833000044],
              [-165.2933243479999, 61.25482819200005],
              [-165.27192135299993, 61.25958893400008],
              [-165.22545325399992, 61.259426174000055],
              [-165.21271725199992, 61.26520416900007],
              [-165.20665442599991, 61.27924225500004],
              [-165.20478268099993, 61.296087958000044],
              [-165.20466061099992, 61.310614325000074],
              [-165.2083634109999, 61.32680898600006],
              [-165.2191055979999, 61.331691799000055],
              [-165.25987708199992, 61.32831452000005],
              [-165.25987708199992, 61.33445872600004],
              [-165.22577877499992, 61.34813060100004],
              [-165.18256588399993, 61.35195547100005],
              [-165.17113196499992, 61.35496653900003],
              [-165.15778561099992, 61.36579010600008],
              [-165.16185462099992, 61.37368398600006],
              [-165.1721085279999, 61.382473049000055],
              [-165.17735755099991, 61.39594147300005],
              [-165.15876217399992, 61.41864655200004],
              [-165.07624264199993, 61.41937897300005],
              [-165.04767818899992, 61.43695709800005],
              [-165.06139075399992, 61.446966864000046],
              [-165.05781002499992, 61.45172760600008],
              [-165.00605221299992, 61.464829820000034],
              [-165.00519771999993, 61.466864325000074],
              [-165.0042618479999, 61.471136786000045],
              [-165.00251217399992, 61.475775458000044],
              [-164.99921627499992, 61.47915273600006],
              [-164.96772213399993, 61.489569403000075],
              [-164.86888587099992, 61.49896881700005],
              [-164.84723873599992, 61.49762604400007],
              [-164.84154212099992, 61.49896881700005],
              [-164.84068762899992, 61.50275299700007],
              [-164.84247799399992, 61.515692450000074],
              [-164.84154212099992, 61.51947663000004],
              [-164.8299454419999, 61.52533600500004],
              [-164.81810462099992, 61.528631903000075],
              [-164.78693600199992, 61.53375885600008],
              [-164.76337643099993, 61.54169342700004],
              [-164.74767005099991, 61.554673570000034],
              [-164.74311275899993, 61.57103099200003],
              [-164.75279700399992, 61.58893463700008],
              [-164.69074459499993, 61.60138580900008],
              [-164.70820064999992, 61.61741771000004],
              [-164.72406979099992, 61.62555573100008],
              [-164.74225826699993, 61.62836334800005],
              [-164.76646887899992, 61.62872955900008],
              [-164.76056881399992, 61.626166083000044],
              [-164.75226803299992, 61.62124258000006],
              [-164.7459610669999, 61.61505768400008],
              [-164.7459610669999, 61.60883209800005],
              [-164.7552384109999, 61.60236237200007],
              [-164.76537024599992, 61.60195547100005],
              [-164.7759903639999, 61.60309479400007],
              [-164.78693600199992, 61.60138580900008],
              [-164.80219479099992, 61.59162018400008],
              [-164.82111568899992, 61.56785716400003],
              [-164.87763424399992, 61.52602773600006],
              [-164.89618893099993, 61.51947663000004],
              [-164.96674557199992, 61.51658763200004],
              [-164.99091549399992, 61.511379299000055],
              [-165.00861568899992, 61.50348541900007],
              [-165.0162247389999, 61.496527411000045],
              [-165.02106686099992, 61.48802317900004],
              [-165.0302628249999, 61.47573476800005],
              [-165.03986568899992, 61.47089264500005],
              [-165.0506485669999, 61.472642320000034],
              [-165.06159420499992, 61.47679271000004],
              [-165.07152258999992, 61.47915273600006],
              [-165.08576412699992, 61.476263739000046],
              [-165.0869034499999, 61.469183661000045],
              [-165.08320064999992, 61.460150458000044],
              [-165.08222408799992, 61.445013739000046],
              [-165.0790909499999, 61.441066799000055],
              [-165.07917232999992, 61.43707916900007],
              [-165.0886124339999, 61.43073151200008],
              [-165.09992428299992, 61.42865631700005],
              [-165.1119278639999, 61.43109772300005],
              [-165.12336178299992, 61.434881903000075],
              [-165.13300533799992, 61.43695709800005],
              [-165.15473385299993, 61.43341705900008],
              [-165.18610592399992, 61.41624583500004],
              [-165.20466061099992, 61.410223700000074],
              [-165.19538326699993, 61.38963450700004],
              [-165.19102942599991, 61.38296133000006],
              [-165.2056778639999, 61.37636953300006],
              [-165.23822994699992, 61.36774323100008],
              [-165.25312252499992, 61.36180247600004],
              [-165.26313229099992, 61.35419342700004],
              [-165.27159583199992, 61.34564850500004],
              [-165.28107662699992, 61.33836497600004],
              [-165.2940567699999, 61.33445872600004],
              [-165.28046627499992, 61.31867096600007],
              [-165.26142330599993, 61.31745026200008],
              [-165.24238033799992, 61.32062409100007],
              [-165.2288712229999, 61.31745026200008],
              [-165.22712154899992, 61.30890534100007],
              [-165.23151607999992, 61.29938385600008],
              [-165.2337540359999, 61.28774648600006],
              [-165.22577877499992, 61.273098049000055],
              [-165.2679337229999, 61.27000560100004],
              [-165.31293697799993, 61.26089101800005],
              [-165.3554581369999, 61.245754299000055],
              [-165.39024817599991, 61.224595445000034],
              [-165.39960689999992, 61.19562409100007],
              [-165.3694962229999, 61.17597077000005],
              [-165.34638424399992, 61.15672435100004],
              [-165.37657630099991, 61.12909577000005],
              [-165.36823482999992, 61.12124258000006],
              [-165.36420650899993, 61.10809967700004],
              [-165.36298580599993, 61.07754140800006],
              [-165.37372799399992, 61.071600653000075],
              [-165.3978165359999, 61.073472398000035],
              [-165.43744869699992, 61.081244208000044],
              [-165.5128067699999, 61.08698151200008],
              [-165.54718990799992, 61.09389883000006],
              [-165.58210201699993, 61.108587958000044],
              [-165.60509192599991, 61.12449778900003],
              [-165.6216934889999, 61.14350006700005],
              [-165.6321915359999, 61.165676174000055],
              [-165.6367081369999, 61.191107489000046],
              [-165.63451087099992, 61.19025299700007],
              [-165.62983150899993, 61.19131094000005],
              [-165.62519283799992, 61.194647528000075],
              [-165.6230362619999, 61.20075104400007],
              [-165.62629146999993, 61.20465729400007],
              [-165.63324947799993, 61.20888906500005],
              [-165.64024817599991, 61.214178778000075],
              [-165.64350338399993, 61.22150299700007],
              [-165.64399166599992, 61.23851146000004],
              [-165.64216061099992, 61.248928127000056],
              [-165.63251705599993, 61.25340403900003],
              [-165.6099747389999, 61.25259023600006],
              [-165.6232804029999, 61.262152411000045],
              [-165.62800045499992, 61.27179596600007],
              [-165.62372799399992, 61.280462958000044],
              [-165.6099747389999, 61.28729889500005],
              [-165.64093990799992, 61.288397528000075],
              [-165.6994522779999, 61.30341217700004],
              [-165.8287247389999, 61.31297435100004],
              [-165.85578365799992, 61.32086823100008],
              [-165.87677975199992, 61.33657461100006],
              [-165.9212540359999, 61.39935944200005],
              [-165.9183243479999, 61.41474030200004],
              [-165.89110266799992, 61.42877838700008],
              [-165.8353165359999, 61.44432200700004],
              [-165.80317135299993, 61.449286200000074],
              [-165.79027258999992, 61.45286692900004],
              [-165.78010006399992, 61.45799388200004],
              [-165.77122962099992, 61.46653880400004],
              [-165.76728268099993, 61.47553131700005],
              [-165.76630611899992, 61.48505280200004],
              [-165.76642818899992, 61.49526601800005],
              [-165.77696692599991, 61.51581452000005],
              [-165.80207271999993, 61.52814362200007],
              [-165.85578365799992, 61.53998444200005],
              [-165.8681534499999, 61.54466380400004],
              [-165.89081783799992, 61.55678945500006],
              [-165.9041641919999, 61.56102122600004],
              [-165.92389889199993, 61.562160549000055],
              [-166.05040442599991, 61.543402411000045],
              [-166.08568274599992, 61.53221263200004],
              [-166.09601803299992, 61.51947663000004],
              [-166.0886124339999, 61.51447174700007],
              [-166.06562252499992, 61.51044342700004],
              [-166.05439205599993, 61.50580475500004],
              [-166.1061905589999, 61.49852122600004],
              [-166.13825436099992, 61.51609935100004],
              [-166.1953018869999, 61.585598049000055],
              [-166.1999405589999, 61.59454987200007],
              [-166.19615637899992, 61.60236237200007],
              [-166.1894425119999, 61.60932038000004],
              [-166.18537350199992, 61.615668036000045],
              [-166.18537350199992, 61.656683661000045],
              [-166.18085689999992, 61.673529364000046],
              [-166.17267818899992, 61.694647528000075],
              [-166.1605118479999, 61.71393463700008],
              [-166.1443985669999, 61.72553131700005],
              [-166.15587317599991, 61.66583893400008],
              [-166.15404212099992, 61.656683661000045],
              [-166.14732825399992, 61.65375397300005],
              [-166.12824459499993, 61.64044830900008],
              [-166.11644446499992, 61.63613515800006],
              [-166.05622311099992, 61.64240143400008],
              [-166.04417883999992, 61.646144924000055],
              [-166.01960201699993, 61.657131252000056],
              [-165.78241939999992, 61.68406810100004],
              [-165.76642818899992, 61.69082265800006],
              [-165.7795304029999, 61.69635651200008],
              [-165.8284805979999, 61.69082265800006],
              [-165.84154212099992, 61.693060614000046],
              [-165.86021887899992, 61.70184967700004],
              [-165.87006588399993, 61.705064195000034],
              [-165.8835343089999, 61.70600006700005],
              [-165.91120357999992, 61.70416901200008],
              [-165.92467200399992, 61.705064195000034],
              [-165.93659420499992, 61.70945872600004],
              [-165.95795650899993, 61.722723700000074],
              [-165.96564693899992, 61.72553131700005],
              [-166.00336666599992, 61.73493073100008],
              [-166.0443009109999, 61.75849030200004],
              [-166.08014889199993, 61.789496161000045],
              [-166.10277258999992, 61.82111237200007],
              [-165.97590084499993, 61.83539459800005],
              [-165.91100012899992, 61.82794830900008],
              [-165.84931393099993, 61.83608633000006],
              [-165.8284805979999, 61.83539459800005],
              [-165.79308020699992, 61.82684967700004],
              [-165.78010006399992, 61.82794830900008],
              [-165.74303137899992, 61.84560781500005],
              [-165.7260636059999, 61.84845612200007],
              [-165.60907955599993, 61.85130442900004],
              [-165.5882462229999, 61.86212799700007],
              [-165.61017818899992, 61.864447333000044],
              [-165.64411373599992, 61.89524974200003],
              [-165.6893204419999, 61.91030508000006],
              [-165.70978756399992, 61.927435614000046],
              [-165.73908443899992, 61.96507396000004],
              [-165.7503555979999, 61.984442450000074],
              [-165.75849361899992, 62.00527578300006],
              [-165.75951087099992, 62.02562083500004],
              [-165.73094641799992, 62.07648346600007],
              [-165.71373450399992, 62.085272528000075],
              [-165.7103165359999, 62.095038153000075],
              [-165.70881100199992, 62.106634833000044],
              [-165.70555579299992, 62.11660390800006],
              [-165.69196529899992, 62.130072333000044],
              [-165.66840572799993, 62.148098049000055],
              [-165.64191646999993, 62.16380442900004],
              [-165.59459387899992, 62.17829010600008],
              [-165.44770260299993, 62.30288320500006],
              [-165.34459387899992, 62.36603424700007],
              [-165.33482825399992, 62.37571849200003],
              [-165.31452389199993, 62.403957424000055],
              [-165.2967423169999, 62.42133209800005],
              [-165.27354895699992, 62.43744538000004],
              [-165.18464107999992, 62.477443752000056],
              [-165.1330460279999, 62.515692450000074],
              [-165.0956925119999, 62.52977122600004],
              [-165.05573482999992, 62.538275458000044],
              [-165.02033443899992, 62.541083075000074],
              [-164.93097896999993, 62.53367747600004],
              [-164.88739986899992, 62.539129950000074],
              [-164.86786861899992, 62.53803131700005],
              [-164.8489884109999, 62.52749258000006],
              [-164.86030025899993, 62.52000560100004],
              [-164.8674210279999, 62.51068756700005],
              [-164.8670548169999, 62.50096263200004],
              [-164.8558243479999, 62.49274323100008],
              [-164.84813391799992, 62.47793203300006],
              [-164.8109024729999, 62.46942780200004],
              [-164.7357071609999, 62.46478913000004],
              [-164.72333736899992, 62.46116771000004],
              [-164.7017716139999, 62.44375234600005],
              [-164.69074459499993, 62.43744538000004],
              [-164.67182369699992, 62.43455638200004],
              [-164.60883541599992, 62.43744538000004],
              [-164.65046139199993, 62.42536041900007],
              [-164.66559811099992, 62.41876862200007],
              [-164.69505774599992, 62.396470445000034],
              [-164.7134903639999, 62.38617584800005],
              [-164.73363196499992, 62.37872955900008],
              [-164.70600338399993, 62.37958405200004],
              [-164.68565833199992, 62.38654205900008],
              [-164.65013587099992, 62.41498444200005],
              [-164.6409805979999, 62.419989325000074],
              [-164.62995357999992, 62.423814195000034],
              [-164.59760494699992, 62.42340729400007],
              [-164.5818985669999, 62.42617422100005],
              [-164.57469641799992, 62.43744538000004],
              [-164.5865372389999, 62.45482005400004],
              [-164.61571204299992, 62.460150458000044],
              [-164.6702774729999, 62.46198151200008],
              [-164.6771134109999, 62.47435130400004],
              [-164.66230221299992, 62.489935614000046],
              [-164.62995357999992, 62.51316966400003],
              [-164.6472061839999, 62.51251862200007],
              [-164.65790768099993, 62.51023997600004],
              [-164.67707271999993, 62.49957916900007],
              [-164.6935929029999, 62.48505280200004],
              [-164.7050675119999, 62.47907135600008],
              [-164.71495520699992, 62.482123114000046],
              [-164.74286861899992, 62.49640534100007],
              [-164.81073971299992, 62.48627350500004],
              [-164.84154212099992, 62.49274323100008],
              [-164.80036373599992, 62.52358633000006],
              [-164.7944229809999, 62.53367747600004],
              [-164.80060787699992, 62.54718659100007],
              [-164.81623287699992, 62.555568752000056],
              [-164.83539791599992, 62.559800523000035],
              [-164.85248775899993, 62.560980536000045],
              [-164.85798092399992, 62.56362539300005],
              [-164.8549698559999, 62.56940338700008],
              [-164.84528561099992, 62.57831452000005],
              [-164.8347061839999, 62.58437734600005],
              [-164.82148189999992, 62.58661530200004],
              [-164.7944229809999, 62.588324286000045],
              [-164.70470130099991, 62.612494208000044],
              [-164.47907467399992, 62.74591705900008],
              [-164.5042618479999, 62.75031159100007],
              [-164.5397843089999, 62.73883698100008],
              [-164.5749405589999, 62.719916083000044],
              [-164.61261959499993, 62.693019924000055],
              [-164.6634415359999, 62.67829010600008],
              [-164.74034583199992, 62.634466864000046],
              [-164.77912350199992, 62.61896393400008],
              [-164.8132218089999, 62.62018463700008],
              [-164.82795162699992, 62.65412018400008],
              [-164.83197994699992, 62.68219635600008],
              [-164.8432511059999, 62.705145575000074],
              [-164.8607071609999, 62.723822333000044],
              [-164.8831680979999, 62.73908112200007],
              [-164.8730362619999, 62.74388255400004],
              [-164.8666886059999, 62.749253648000035],
              [-164.86689205599993, 62.75470612200007],
              [-164.8763321609999, 62.75958893400008],
              [-164.87323971299992, 62.76406484600005],
              [-164.87157141799992, 62.767645575000074],
              [-164.86884518099993, 62.77094147300005],
              [-164.8626602859999, 62.773871161000045],
              [-164.8702286449999, 62.776678778000075],
              [-164.8900040359999, 62.78693268400008],
              [-164.87315833199992, 62.792181708000044],
              [-164.85907955599993, 62.79486725500004],
              [-164.84491939999992, 62.79547760600008],
              [-164.82795162699992, 62.79437897300005],
              [-164.7921036449999, 62.78693268400008],
              [-164.7761124339999, 62.78851959800005],
              [-164.76646887899992, 62.801214911000045],
              [-164.83259029899992, 62.80890534100007],
              [-164.86176510299993, 62.819525458000044],
              [-164.8831680979999, 62.84153880400004],
              [-164.85932369699992, 62.85407135600008],
              [-164.85248775899993, 62.85578034100007],
              [-164.84923255099991, 62.85993073100008],
              [-164.84813391799992, 62.87970612200007],
              [-164.84528561099992, 62.88686758000006],
              [-164.8338516919999, 62.89915599200003],
              [-164.81611080599993, 62.92719147300005],
              [-164.7534073559999, 62.99095286700003],
              [-164.72350012899992, 63.012925523000035],
              [-164.69074459499993, 63.02708567900004],
              [-164.66258704299992, 63.03204987200007],
              [-164.52818762899992, 63.03473541900007],
              [-164.51667232999992, 63.03021881700005],
              [-164.50922604099992, 63.02521393400008],
              [-164.48737545499992, 63.01581452000005],
              [-164.47846432199992, 63.014105536000045],
              [-164.4726456369999, 63.016913153000075],
              [-164.4687393869999, 63.02326080900008],
              [-164.4628800119999, 63.02985260600008],
              [-164.4511612619999, 63.03335195500006],
              [-164.44159908799992, 63.03188711100006],
              [-164.41022701699993, 63.02024974200003],
              [-164.40070553299992, 63.02057526200008],
              [-164.38434811099992, 63.02521393400008],
              [-164.3760880199999, 63.02366771000004],
              [-164.3549698559999, 63.014105536000045],
              [-164.33368893099993, 63.009019273000035],
              [-164.32433020699992, 63.009100653000075],
              [-164.3139542309999, 63.014105536000045],
              [-164.3307999339999, 63.04140859600005],
              [-164.35090084499993, 63.05963776200008],
              [-164.37665768099993, 63.07050202000005],
              [-164.5228165359999, 63.088324286000045],
              [-164.53990637899992, 63.10224030200004],
              [-164.54914303299992, 63.11619700700004],
              [-164.56244869699992, 63.12254466400003],
              [-164.59516354099992, 63.130113023000035],
              [-164.5790909499999, 63.14057038000004],
              [-164.52179928299992, 63.16111888200004],
              [-164.50239010299993, 63.164943752000056],
              [-164.4877823559999, 63.17072174700007],
              [-164.42353268099993, 63.208970445000034],
              [-164.3658341139999, 63.22919342700004],
              [-164.14537512899992, 63.262152411000045],
              [-163.99457760299993, 63.25625234600005],
              [-163.82738196499992, 63.21954987200007],
              [-163.76732337099992, 63.22475820500006],
              [-163.75226803299992, 63.222642320000034],
              [-163.7292374339999, 63.216782945000034],
              [-163.72455807199992, 63.21312083500004],
              [-163.7324112619999, 63.20587799700007],
              [-163.72309322799993, 63.19993724200003],
              [-163.70246334499993, 63.19330475500004],
              [-163.69420325399992, 63.18817780200004],
              [-163.6834610669999, 63.173488674000055],
              [-163.6767471999999, 63.16742584800005],
              [-163.64655514199993, 63.15892161700003],
              [-163.63829505099991, 63.14545319200005],
              [-163.64338131399992, 63.131293036000045],
              [-163.66352291599992, 63.12335846600007],
              [-163.66352291599992, 63.116522528000075],
              [-163.6346329419999, 63.12018463700008],
              [-163.5884903639999, 63.13507721600007],
              [-163.56733150899993, 63.13694896000004],
              [-163.54181881399992, 63.12881094000005],
              [-163.56452389199993, 63.118068752000056],
              [-163.6025284499999, 63.10561758000006],
              [-163.6225479809999, 63.09227122600004],
              [-163.65595455599993, 63.06037018400008],
              [-163.79194088399993, 63.021918036000045],
              [-163.8068741529999, 62.98615143400008],
              [-163.7624405589999, 63.01520416900007],
              [-163.65290279899992, 63.04507070500006],
              [-163.60081946499992, 63.068060614000046],
              [-163.55695553299992, 63.104722398000035],
              [-163.52855383999992, 63.11668528900003],
              [-163.4913223949999, 63.10179271000004],
              [-163.44066321499992, 63.09601471600007],
              [-163.3959854809999, 63.068060614000046],
              [-163.36615963399993, 63.038275458000044],
              [-163.35053463399993, 63.03082916900007],
              [-163.2901505199999, 63.048814195000034],
              [-163.0939835279999, 63.05735911700003],
              [-163.07384192599991, 63.06126536700003],
              [-163.03400631399992, 63.07908763200004],
              [-163.0130509109999, 63.08466217700004],
              [-162.98871822799993, 63.09955475500004],
              [-162.98139400899993, 63.10594310100004],
              [-162.96922766799992, 63.11440664300005],
              [-162.92304439999992, 63.12335846600007],
              [-162.88080807199992, 63.14093659100007],
              [-162.8613175119999, 63.15228913000004],
              [-162.8478897779999, 63.164943752000056],
              [-162.84406490799992, 63.17462799700007],
              [-162.84589596299992, 63.18895091400003],
              [-162.84113521999993, 63.198431708000044],
              [-162.8338516919999, 63.20490143400008],
              [-162.80634518099993, 63.21954987200007],
              [-162.6966446609999, 63.22919342700004],
              [-162.59650631399992, 63.276678778000075],
              [-162.42894446499992, 63.40387604400007],
              [-162.4088028639999, 63.42572663000004],
              [-162.40160071499992, 63.43121979400007],
              [-162.36188717399992, 63.44782135600008],
              [-162.3510636059999, 63.45571523600006],
              [-162.33063717399992, 63.466864325000074],
              [-162.30317135299993, 63.47675202000005],
              [-162.2800186839999, 63.48908112200007],
              [-162.2725723949999, 63.507513739000046],
              [-162.31354732999992, 63.53424713700008],
              [-162.30943762899992, 63.546576239000046],
              [-162.2932022779999, 63.55036041900007],
              [-162.2514542309999, 63.548529364000046],
              [-162.23725338399993, 63.54629140800006],
              [-162.2070206369999, 63.53652578300006],
              [-162.17621822799993, 63.532538153000075],
              [-162.1347550119999, 63.521185614000046],
              [-162.09955807199992, 63.51898834800005],
              [-162.0842179029999, 63.51471588700008],
              [-162.05964107999992, 63.49603913000004],
              [-162.04609127499992, 63.490220445000034],
              [-162.03144283799992, 63.48663971600007],
              [-162.01805579299992, 63.48582591400003],
              [-162.03758704299992, 63.48427969000005],
              [-162.0546768869999, 63.474310614000046],
              [-162.0706680979999, 63.46173737200007],
              [-162.08698482999992, 63.452337958000044],
              [-162.1069229809999, 63.44782135600008],
              [-162.14899654899992, 63.44407786700003],
              [-162.16889400899993, 63.438666083000044],
              [-162.16889400899993, 63.43121979400007],
              [-161.91462154849992, 63.450425523000064],
              [-161.66034908799992, 63.469631252000056],
              [-161.62079830599993, 63.46653880400004],
              [-161.58958899599992, 63.45807526200008],
              [-161.57343502499992, 63.45538971600007],
              [-161.55744381399992, 63.45734284100007],
              [-161.5115860669999, 63.47280508000006],
              [-161.49640865799992, 63.474269924000055],
              [-161.48346920499992, 63.47345612200007],
              [-161.47089596299992, 63.46987539300005],
              [-161.45665442599991, 63.46283600500004],
              [-161.4405411449999, 63.460191148000035],
              [-161.4228409499999, 63.465725002000056],
              [-161.40485592399992, 63.473944403000075],
              [-161.3880509109999, 63.47955963700008],
              [-161.1862686839999, 63.505560614000046],
              [-161.0565079419999, 63.57440827000005],
              [-161.04548092399992, 63.58576080900008],
              [-161.03388424399992, 63.61005280200004],
              [-161.00654049399992, 63.62177155200004],
              [-160.97480221299992, 63.628241278000075],
              [-160.94989986899992, 63.63666413000004],
              [-160.89252682199992, 63.684881903000075],
              [-160.84992428299992, 63.69830963700008],
              [-160.82709713399993, 63.71352773600006],
              [-160.79157467399992, 63.746527411000045],
              [-160.7669571609999, 63.82412344000005],
              [-160.8050430979999, 63.90448639500005],
              [-160.92878170499992, 64.04816315300008],
              [-160.94526119699992, 64.09601471600007],
              [-160.95164954299992, 64.20628489800004],
              [-160.97345943899992, 64.25047435100004],
              [-160.99535071499992, 64.26569245000007],
              [-161.06342525899993, 64.29584381700005],
              [-161.0898331369999, 64.30141836100006],
              [-161.11591549399992, 64.31000397300005],
              [-161.17552649599992, 64.35089752800008],
              [-161.2031143869999, 64.36408112200007],
              [-161.2031143869999, 64.37030670800004],
              [-161.1939591139999, 64.37116120000007],
              [-161.1880997389999, 64.37376536700003],
              [-161.1757706369999, 64.38397858300004],
              [-161.1946915359999, 64.39207591400003],
              [-161.23802649599992, 64.39809804900005],
              [-161.25776119699992, 64.40509674700007],
              [-161.24425208199992, 64.41010163000004],
              [-161.22675533799992, 64.41181061400005],
              [-161.1888321609999, 64.41128164300005],
              [-161.1888321609999, 64.41811758000006],
              [-161.33177649599992, 64.41754791900007],
              [-161.42943274599992, 64.43329498900005],
              [-161.4579971999999, 64.43170807500007],
              [-161.48363196499992, 64.42487213700008],
              [-161.4984024729999, 64.41453685100004],
              [-161.50898189999992, 64.40216705900008],
              [-161.52070064999992, 64.39252350500004],
              [-161.53888912699992, 64.39077383000006],
              [-161.53888912699992, 64.39765045800004],
              [-161.5259903639999, 64.42910390800006],
              [-161.51842200399992, 64.43854401200008],
              [-161.50385494699992, 64.44843170800004],
              [-161.49372311099992, 64.45184967700004],
              [-161.4857071609999, 64.45709870000007],
              [-161.47740637899992, 64.47272370000007],
              [-161.4733780589999, 64.48818594000005],
              [-161.47191321499992, 64.49974192900004],
              [-161.46808834499993, 64.50995514500005],
              [-161.45697994699992, 64.52114492400005],
              [-161.4404190749999, 64.52912018400008],
              [-161.4139298169999, 64.53754303600005],
              [-161.38752193899992, 64.54205963700008],
              [-161.37071692599991, 64.53815338700008],
              [-161.34040279899992, 64.52399323100008],
              [-161.09333248599992, 64.50259023600006],
              [-161.0350235669999, 64.50775788000004],
              [-161.00446529899992, 64.52798086100006],
              [-161.0685929029999, 64.54462311400005],
              [-161.0859268869999, 64.55255768400008],
              [-160.97345943899992, 64.55585358300004],
              [-160.9579971999999, 64.55882396000004],
              [-160.94733639199993, 64.56606679900005],
              [-160.9384659499999, 64.57485586100006],
              [-160.92878170499992, 64.58258698100008],
              [-160.8339737619999, 64.61733633000006],
              [-160.80317135299993, 64.64337799700007],
              [-160.79027258999992, 64.70770905200004],
              [-160.78815670499992, 64.71271393400008],
              [-160.7877091139999, 64.71784088700008],
              [-160.79157467399992, 64.72589752800008],
              [-160.8015030589999, 64.73639557500007],
              [-160.82542883999992, 64.74892812700006],
              [-160.83661861899992, 64.75763580900008],
              [-160.88471432199992, 64.81012604400007],
              [-160.90143795499992, 64.82273997600004],
              [-160.9160050119999, 64.82868073100008],
              [-160.9634903639999, 64.83584219000005],
              [-161.00336666599992, 64.85488515800006],
              [-161.04438229099992, 64.86253489800004],
              [-161.1464737619999, 64.91819896000004],
              [-161.15534420499992, 64.92519765800006],
              [-161.13329016799992, 64.92401764500005],
              [-161.08576412699992, 64.91299062700006],
              [-161.06623287699992, 64.91522858300004],
              [-161.02961178299992, 64.93146393400008],
              [-161.01008053299992, 64.93724192900004],
              [-160.9908341139999, 64.93943919500003],
              [-161.00385494699992, 64.94456614800004],
              [-161.0201309889999, 64.94721100500004],
              [-161.0370987619999, 64.94757721600007],
              [-161.0522354809999, 64.94562409100007],
              [-161.05675208199992, 64.94281647300005],
              [-161.0600479809999, 64.93447500200006],
              [-161.0628555979999, 64.93260325700004],
              [-161.18256588399993, 64.93952057500007],
              [-161.21056067599991, 64.93260325700004],
              [-161.20710201699993, 64.90973541900007],
              [-161.22944088399993, 64.89598216400003],
              [-161.3076065749999, 64.87201569200005],
              [-161.3159073559999, 64.86542389500005],
              [-161.3222550119999, 64.84552643400008],
              [-161.3300675119999, 64.83771393400008],
              [-161.3401993479999, 64.83193594000005],
              [-161.36180579299992, 64.82636139500005],
              [-161.36693274599992, 64.81875234600005],
              [-161.36969967399992, 64.80971914300005],
              [-161.3737686839999, 64.80231354400007],
              [-161.3952530589999, 64.78676992400005],
              [-161.4088028639999, 64.77948639500005],
              [-161.42218990799992, 64.77435944200005],
              [-161.4440811839999, 64.77073802300004],
              [-161.48945064999992, 64.77024974200003],
              [-161.5115860669999, 64.76752350500004],
              [-161.52399654899992, 64.76211172100005],
              [-161.5346573559999, 64.75507233300004],
              [-161.54576575399992, 64.75088125200006],
              [-161.55939693899992, 64.75385163000004],
              [-161.56440182199992, 64.77041250200006],
              [-161.64484615799992, 64.78375885600008],
              [-161.67235266799992, 64.79173411700003],
              [-161.70124264199993, 64.81175364800004],
              [-161.73359127499992, 64.82074616100005],
              [-161.80638587099992, 64.82273997600004],
              [-161.78290768099993, 64.81683991100005],
              [-161.74091549399992, 64.79800039300005],
              [-161.71642005099991, 64.79486725500004],
              [-161.89631100199992, 64.75397370000007],
              [-161.94977779899992, 64.72589752800008],
              [-161.93175208199992, 64.71865469000005],
              [-161.91413326699993, 64.72211334800005],
              [-161.88154049399992, 64.74022044500003],
              [-161.86139889199993, 64.74795156500005],
              [-161.7995499339999, 64.76129791900007],
              [-161.81208248599992, 64.75299713700008],
              [-161.84980221299992, 64.73639557500007],
              [-161.86412512899992, 64.73338450700004],
              [-161.86579342399992, 64.73094310100004],
              [-161.88495846299992, 64.71629466400003],
              [-161.89545650899993, 64.71173737200007],
              [-161.92393958199992, 64.71210358300004],
              [-161.98253333199992, 64.70307038000004],
              [-162.08088131399992, 64.72109609600005],
              [-162.1216934889999, 64.71287669500003],
              [-162.1077774729999, 64.70941803600005],
              [-162.0790909499999, 64.70547109600005],
              [-162.06647701699993, 64.69928620000007],
              [-162.1428116529999, 64.69623444200005],
              [-162.17735755099991, 64.68817780200004],
              [-162.20982825399992, 64.67194245000007],
              [-162.21943111899992, 64.66469961100006],
              [-162.2471817699999, 64.63458893400008],
              [-162.25763912699992, 64.62571849200003],
              [-162.27021236899992, 64.61928945500006],
              [-162.31806393099993, 64.61298248900005],
              [-162.5112198559999, 64.55866120000007],
              [-162.55683346299992, 64.53221263200004],
              [-162.5831192699999, 64.52069733300004],
              [-162.60716712099992, 64.50678131700005],
              [-162.62140865799992, 64.48700592700004],
              [-162.62157141799992, 64.47557200700004],
              [-162.61420650899993, 64.45620351800005],
              [-162.61457271999993, 64.44599030200004],
              [-162.62279212099992, 64.43732330900008],
              [-162.63532467399992, 64.42926666900007],
              [-162.64342200399992, 64.42015208500004],
              [-162.63874264199993, 64.40814850500004],
              [-162.64264889199993, 64.39443594000005],
              [-162.7346085279999, 64.36717357000003],
              [-162.75629635299993, 64.35211823100008],
              [-162.78132076699993, 64.34369538000004],
              [-162.80439205599993, 64.34780508000006],
              [-162.82001705599993, 64.37030670800004],
              [-162.82074947799993, 64.38593170800004],
              [-162.81684322799993, 64.39793528900003],
              [-162.81550045499992, 64.40892161700003],
              [-162.8237198559999, 64.42153554900005],
              [-162.84443111899992, 64.44407786700003],
              [-162.85541744699992, 64.45221588700008],
              [-162.87462317599991, 64.45966217700004],
              [-162.8613175119999, 64.48651764500005],
              [-162.85029049399992, 64.49339427300004],
              [-162.82746334499993, 64.49315013200004],
              [-162.82746334499993, 64.50063711100006],
              [-162.8694962229999, 64.51333242400005],
              [-162.89618893099993, 64.51801178600005],
              [-162.9217423169999, 64.53168366100005],
              [-162.9335831369999, 64.53473541900007],
              [-162.9405411449999, 64.53766510600008],
              [-162.96056067599991, 64.55125560100004],
              [-162.97081458199992, 64.55585358300004],
              [-162.9904679029999, 64.55833567900004],
              [-163.0533341139999, 64.55585358300004],
              [-163.0533341139999, 64.56207916900007],
              [-163.0451554029999, 64.56281159100007],
              [-163.02546139199993, 64.56952545800004],
              [-163.05658932199992, 64.59210846600007],
              [-163.10712643099993, 64.60822174700007],
              [-163.14765377499992, 64.62714264500005],
              [-163.14899654899992, 64.65827057500007],
              [-163.21479244699992, 64.65452708500004],
              [-163.24250240799992, 64.64838288000004],
              [-163.35859127499992, 64.60374583500004],
              [-163.3897598949999, 64.59686920800004],
              [-163.3897598949999, 64.59003327000005],
              [-163.3681534499999, 64.58779531500005],
              [-163.3134659499999, 64.56207916900007],
              [-163.2913712229999, 64.55752187700006],
              [-163.21100826699993, 64.55585358300004],
              [-163.1940811839999, 64.54743073100008],
              [-163.16230221299992, 64.52204010600008],
              [-163.14277096299992, 64.51496002800008],
              [-163.1181534499999, 64.51422760600008],
              [-163.03974361899992, 64.52114492400005],
              [-163.0486954419999, 64.51618073100008],
              [-163.0529679029999, 64.50995514500005],
              [-163.05235755099991, 64.50226471600007],
              [-163.04649817599991, 64.49315013200004],
              [-163.09675045499992, 64.47581614800004],
              [-163.1146134109999, 64.46100495000007],
              [-163.12165279899992, 64.43512604400007],
              [-163.1349991529999, 64.41254303600005],
              [-163.1658829419999, 64.41058991100005],
              [-163.20042883999992, 64.41998932500007],
              [-163.22468014199993, 64.43170807500007],
              [-163.2792862619999, 64.48574453300006],
              [-163.2997940749999, 64.49315013200004],
              [-163.33063717399992, 64.49656810100004],
              [-163.3574112619999, 64.50519440300008],
              [-163.40900631399992, 64.52798086100006],
              [-163.53656979099992, 64.56452057500007],
              [-163.67853756399992, 64.58633047100005],
              [-163.8171280589999, 64.59003327000005],
              [-163.97138424399992, 64.56952545800004],
              [-164.38910885299993, 64.56952545800004],
              [-164.2662247389999, 64.57575104400007],
              [-164.34186764199993, 64.59003327000005],
              [-164.6503800119999, 64.50226471600007],
              [-164.7459610669999, 64.49315013200004],
              [-164.72545325399992, 64.50259023600006],
              [-164.6566055979999, 64.52114492400005],
              [-164.69172115799992, 64.53131745000007],
              [-164.80744381399992, 64.52114492400005],
              [-164.83625240799992, 64.51479726800005],
              [-164.88569088399993, 64.49152252800008],
              [-164.90986080599993, 64.49315013200004],
              [-164.90265865799992, 64.51056549700007],
              [-164.90815182199992, 64.52399323100008],
              [-164.92145748599992, 64.53241608300004],
              [-164.93781490799992, 64.53473541900007],
              [-164.93781490799992, 64.52798086100006],
              [-164.93085689999992, 64.52513255400004],
              [-164.92414303299992, 64.52114492400005],
              [-164.9323624339999, 64.51276276200008],
              [-164.9420059889999, 64.50755442900004],
              [-164.95295162699992, 64.50580475500004],
              [-164.9650772779999, 64.50747304900005],
              [-164.95396887899992, 64.49437083500004],
              [-164.93517005099991, 64.48647695500006],
              [-164.9140518869999, 64.48037344000005],
              [-164.89618893099993, 64.47272370000007],
              [-164.92414303299992, 64.45966217700004],
              [-164.8425186839999, 64.46141185100004],
              [-164.80109615799992, 64.46747467700004],
              [-164.76646887899992, 64.48016998900005],
              [-164.79645748599992, 64.46344635600008],
              [-164.83710689999992, 64.45522695500006],
              [-165.0355118479999, 64.44830963700008],
              [-165.44623775899993, 64.51186758000006],
              [-165.87751217399992, 64.54824453300006],
              [-166.00239010299993, 64.57143789300005],
              [-166.1896866529999, 64.58519114800004],
              [-166.37035071499992, 64.63784414300005],
              [-166.4460343089999, 64.69147370000007],
              [-166.48346920499992, 64.72964101800005],
              [-166.47462335699993, 64.74813762400004],
              [-166.4747374849999, 64.77095498200003],
              [-166.4780167309999, 64.78961823100008],
              [-166.48037689499992, 64.80201013900006],
              [-166.47006686199992, 64.80736687700005],
              [-166.43920787699992, 64.81021571400004],
              [-166.3939102859999, 64.82273997600004],
              [-166.38605709499993, 64.82733795800004],
              [-166.38556881399992, 64.83600495000007],
              [-166.3917130199999, 64.84137604400007],
              [-166.40387936099992, 64.83584219000005],
              [-166.41015719799992, 64.85453031500003],
              [-166.4088349849999, 64.86954864300003],
              [-166.39020748599992, 64.89850495000007],
              [-166.40794837099992, 64.90444570500006],
              [-166.43293209499993, 64.92161692900004],
              [-166.47101803299992, 64.93036530200004],
              [-166.50483150899993, 64.95111725500004],
              [-166.5273331369999, 64.95311107000003],
              [-166.51524817599991, 64.93781159100007],
              [-166.4448136059999, 64.89850495000007],
              [-166.46747799399992, 64.90741608300004],
              [-166.52570553299992, 64.93646881700005],
              [-166.5797219359999, 64.95296861600008],
              [-166.6845292259999, 64.98217990600006],
              [-166.7000664699999, 64.99400635900008],
              [-166.6953503809999, 65.00766484400003],
              [-166.68737597999993, 65.02282700700005],
              [-166.71138881899992, 65.04371344200007],
              [-166.74951017299992, 65.06201045700004],
              [-166.82905025899993, 65.08283112200007],
              [-166.87861080599993, 65.10272858300004],
              [-166.96153091199992, 65.15435925800006],
              [-166.9573868479999, 65.17812734600005],
              [-166.9395721059999, 65.22076512400008],
              [-166.92697362899992, 65.24289696900007],
              [-166.9101861389999, 65.26453338200008],
              [-166.89431613199991, 65.27636351800004],
              [-166.8802384109999, 65.28204987200007],
              [-166.85277258999992, 65.27789948100008],
              [-166.86176510299993, 65.26748281500005],
              [-166.8893569409999, 65.23846039500006],
              [-166.9059001599999, 65.22056930700006],
              [-166.91824712699992, 65.20218226200006],
              [-166.93207760299993, 65.16885000200006],
              [-166.9176583329999, 65.15438559900008],
              [-166.90422359099992, 65.15091126400006],
              [-166.89045162699992, 65.15176015800006],
              [-166.87616939999992, 65.14911530200004],
              [-166.84422766799992, 65.13629791900007],
              [-166.7542618479999, 65.11562734600005],
              [-166.71263587099992, 65.11294179900005],
              [-166.65672766799992, 65.12506745000007],
              [-166.6099747389999, 65.12230052300004],
              [-166.57953854099992, 65.12995026200008],
              [-166.5593155589999, 65.13068268400008],
              [-166.54718990799992, 65.13690827000005],
              [-166.54291744699992, 65.13686758000006],
              [-166.53864498599992, 65.13629791900007],
              [-166.5341690749999, 65.13743724200003],
              [-166.53364010299993, 65.14004140800006],
              [-166.53477942599991, 65.14915599200003],
              [-166.5341690749999, 65.15176015800006],
              [-166.4858292309999, 65.17357005400004],
              [-166.46922766799992, 65.18927643400008],
              [-166.4764298169999, 65.21010976800005],
              [-166.48871822799993, 65.23427969000005],
              [-166.46922766799992, 65.24457428600005],
              [-166.40387936099992, 65.25413646000004],
              [-166.39179439999992, 65.26023997600004],
              [-166.3819473949999, 65.26699453300006],
              [-166.37128658799992, 65.27252838700008],
              [-166.35667883999992, 65.27521393400008],
              [-166.3417965669999, 65.26671864500008],
              [-166.32357984599992, 65.25545696600005],
              [-166.2515999679999, 65.25805683600004],
              [-166.12457385399992, 65.23427362200005],
              [-166.09063450999992, 65.23104407200003],
              [-166.05645118599992, 65.23297632800006],
              [-166.0311878519999, 65.24310361000005],
              [-166.07664964499992, 65.26357868700006],
              [-166.14040990599992, 65.28569272600004],
              [-166.2278943919999, 65.30161763700005],
              [-166.31013074799992, 65.31218833300005],
              [-166.3484637699999, 65.30927920700003],
              [-166.3737686839999, 65.30532461100006],
              [-166.4340554009999, 65.31872403400007],
              [-166.50279700399992, 65.33624909100007],
              [-166.64704988999992, 65.35132645000004],
              [-166.93830318899992, 65.38507721600007],
              [-166.92304439999992, 65.37832265800006],
              [-166.91301102199992, 65.37079122400007],
              [-166.87009806499992, 65.36078105000007],
              [-166.8124091789999, 65.35356719000004],
              [-166.7258795859999, 65.34207473500004],
              [-166.64993559799993, 65.32682037800004],
              [-166.7669210869999, 65.33576330500006],
              [-166.8635875919999, 65.35131964800007],
              [-167.0004498849999, 65.37811575500007],
              [-167.18429579399992, 65.39324134100008],
              [-167.3985545019999, 65.40108154800004],
              [-167.60432712899993, 65.45341941000004],
              [-167.6431229499999, 65.47588578800008],
              [-167.72211764399992, 65.50465834700003],
              [-167.82295751799992, 65.52383783600004],
              [-167.8870161769999, 65.54761405000005],
              [-168.03217525899993, 65.57343170800004],
              [-168.05243893099993, 65.58002350500004],
              [-168.06037350199992, 65.58490631700005],
              [-168.08100338399993, 65.59149811400005],
              [-168.09028072799993, 65.59674713700008],
              [-168.0955704419999, 65.60350169500003],
              [-168.1009415359999, 65.61823151200008],
              [-168.1038712229999, 65.62409088700008],
              [-168.12779700399992, 65.64215729400007],
              [-168.1312149729999, 65.64826080900008],
              [-168.1321915359999, 65.65289948100008],
              [-168.1374405589999, 65.66502513200004],
              [-168.13487708199992, 65.66982656500005],
              [-168.12629146999993, 65.67279694200005],
              [-168.1243790359999, 65.67593008000006],
              [-168.11542721299992, 65.68598053600005],
              [-168.07160396999993, 65.70709870000007],
              [-167.98114986899992, 65.73309967700004],
              [-167.92401891699993, 65.74860786000005],
              [-167.88207979299992, 65.75543983300008],
              [-167.86681067599991, 65.74900950700004],
              [-167.87787838399993, 65.73851146000004],
              [-167.8913468089999, 65.73395416900007],
              [-167.90941321499992, 65.73078034100007],
              [-167.94086666599992, 65.71670156500005],
              [-167.9909561839999, 65.70913320500006],
              [-168.02802486899992, 65.69676341400003],
              [-168.05671139199993, 65.67723216400003],
              [-168.06293697799993, 65.65135325700004],
              [-168.03986568899992, 65.63593170800004],
              [-168.00043697799993, 65.64256419500003],
              [-167.92548580599993, 65.66502513200004],
              [-167.8948868479999, 65.67023346600007],
              [-167.8560684889999, 65.68353913000004],
              [-167.82624264199993, 65.70136139500005],
              [-167.82274329299992, 65.72028229400007],
              [-167.58092200399992, 65.72068919500003],
              [-167.5312393869999, 65.72614166900007],
              [-167.5005997389999, 65.74079010600008],
              [-167.49657141799992, 65.76544830900008],
              [-167.5244034499999, 65.77383047100005],
              [-167.5591934889999, 65.77871328300006],
              [-167.57636471299992, 65.79254791900007],
              [-167.56102454299992, 65.80890534100007],
              [-167.52513587099992, 65.81329987200007],
              [-167.45282955599993, 65.80971914300005],
              [-167.46833248599992, 65.81635163000004],
              [-167.48521887899992, 65.82103099200003],
              [-167.5029190749999, 65.82330963700008],
              [-167.52110755099991, 65.82269928600005],
              [-167.52110755099991, 65.83014557500007],
              [-167.3459366529999, 65.89858633000006],
              [-167.28831946499992, 65.90521881700005],
              [-167.28241939999992, 65.89459870000007],
              [-167.2612198559999, 65.88296133000006],
              [-167.2132462229999, 65.86432526200008],
              [-167.18285071499992, 65.85822174700007],
              [-167.1511124339999, 65.85980866100005],
              [-167.05988521999993, 65.87763092700004],
              [-166.98639889199993, 65.90863678600005],
              [-166.89342200399992, 65.92938873900005],
              [-166.8768204419999, 65.94684479400007],
              [-166.9730118479999, 65.97418854400007],
              [-166.92804928299992, 65.99140045800004],
              [-166.89732825399992, 65.99603913000004],
              [-166.8521622389999, 66.00812409100007],
              [-166.8358048169999, 66.01508209800005],
              [-166.8476456369999, 66.00918203300006],
              [-166.8596085279999, 66.00470612200007],
              [-166.86994381399992, 65.99860260600008],
              [-166.8768204419999, 65.98777903900003],
              [-166.8554581369999, 65.98749420800004],
              [-166.81586666599992, 65.98183828300006],
              [-166.79487057199992, 65.98777903900003],
              [-166.80036373599992, 65.99225495000007],
              [-166.81000729099992, 66.00311920800004],
              [-166.81537838399993, 66.00763580900008],
              [-166.8006485669999, 66.01276276200008],
              [-166.7607315749999, 66.04242584800005],
              [-166.7249649729999, 66.06134674700007],
              [-166.53563391799992, 66.11945221600007],
              [-166.4608048169999, 66.12864817900004],
              [-166.40815182199992, 66.14793528900003],
              [-166.35749264199993, 66.15656159100007],
              [-166.3109024729999, 66.17536041900007],
              [-166.2874649729999, 66.17963288000004],
              [-166.1849259109999, 66.17499420800004],
              [-166.13849850199992, 66.16673411700003],
              [-166.08918209499993, 66.15228913000004],
              [-166.10871334499993, 66.15224844000005],
              [-166.1451309889999, 66.15656159100007],
              [-166.16425533799992, 66.15228913000004],
              [-166.09369869699992, 66.12531159100007],
              [-165.7549942699999, 66.10529205900008],
              [-165.50011145699992, 66.15228913000004],
              [-165.5162247389999, 66.16498444200005],
              [-165.54063880099991, 66.17348867400005],
              [-165.61176510299993, 66.18292877800008],
              [-165.71088619699992, 66.21263255400004],
              [-165.7659805979999, 66.22016022300005],
              [-165.84894771999993, 66.22011953300006],
              [-165.87397213399993, 66.22557200700004],
              [-165.88996334499993, 66.24103424700007],
              [-165.87287350199992, 66.26341380400004],
              [-165.83869381399992, 66.28896719000005],
              [-165.76642818899992, 66.32363515800006],
              [-165.4876602859999, 66.40228913000004],
              [-165.3635147779999, 66.41893138200004],
              [-165.3353165359999, 66.42942942900004],
              [-165.30573482999992, 66.43695709800005],
              [-165.10521399599992, 66.44529857000003],
              [-165.0749405589999, 66.44025299700007],
              [-165.07660885299993, 66.43634674700007],
              [-165.07758541599992, 66.43317291900007],
              [-165.07905025899993, 66.42991771000004],
              [-165.0823868479999, 66.42601146000004],
              [-165.0737198559999, 66.41502513200004],
              [-165.06196041599992, 66.40753815300008],
              [-165.04816646999993, 66.40253327000005],
              [-165.03339596299992, 66.39931875200006],
              [-165.02656002499992, 66.42251211100006],
              [-165.00633704299992, 66.43085358300004],
              [-164.98090572799993, 66.43378327000005],
              [-164.95824133999992, 66.44025299700007],
              [-164.95575924399992, 66.44464752800008],
              [-164.9505509109999, 66.46015045800004],
              [-164.94465084499993, 66.46698639500005],
              [-164.9311417309999, 66.47223541900007],
              [-164.89875240799992, 66.47833893400008],
              [-164.73131262899992, 66.53266022300005],
              [-164.71808834499993, 66.55634186400005],
              [-164.52265377499992, 66.58242422100005],
              [-164.27436275899993, 66.60228099200003],
              [-163.98639889199993, 66.61225006700005],
              [-163.7363175119999, 66.60346100500004],
              [-163.67572994699992, 66.59223053600005],
              [-163.62873287699992, 66.57001373900005],
              [-163.90815182199992, 66.58413320500006],
              [-163.93012447799993, 66.58576080900008],
              [-163.9208878249999, 66.57318756700005],
              [-163.88288326699993, 66.56948476800005],
              [-163.8068741529999, 66.57001373900005],
              [-163.78681393099993, 66.56049225500004],
              [-163.77179928299992, 66.54507070500006],
              [-163.76239986899992, 66.52582428600005],
              [-163.75910396999993, 66.50482819200005],
              [-163.76646887899992, 66.48541901200008],
              [-163.78461666599992, 66.47089264500005],
              [-163.8642471999999, 66.43646881700005],
              [-163.86896725199992, 66.42942942900004],
              [-163.87214107999992, 66.42007070500006],
              [-163.8796280589999, 66.41111888200004],
              [-163.88849850199992, 66.40387604400007],
              [-163.8956192699999, 66.39931875200006],
              [-163.88520260299993, 66.37986888200004],
              [-163.8881729809999, 66.36664459800005],
              [-163.89484615799992, 66.35423411700003],
              [-163.8956192699999, 66.33722565300008],
              [-163.86896725199992, 66.30931224200003],
              [-163.87043209499993, 66.30829498900005],
              [-163.86969967399992, 66.30263906500005],
              [-163.86497962099992, 66.29531484600005],
              [-163.85468502499992, 66.28945547100005],
              [-163.87657630099991, 66.26593659100007],
              [-163.91877193899992, 66.24648672100005],
              [-163.96495520699992, 66.23297760600008],
              [-163.99925696499992, 66.22736237200007],
              [-164.0540665359999, 66.22699616100005],
              [-164.07823645699992, 66.22260163000004],
              [-164.09833736899992, 66.21035390800006],
              [-164.12031002499992, 66.20400625200006],
              [-164.17572994699992, 66.20815664300005],
              [-164.19111080599993, 66.19330475500004],
              [-164.03209387899992, 66.19212474200003],
              [-163.98566646999993, 66.20693594000005],
              [-163.99054928299992, 66.18915436400005],
              [-163.97748775899993, 66.18353913000004],
              [-163.95978756399992, 66.18699778900003],
              [-163.95087643099993, 66.19635651200008],
              [-163.94574947799993, 66.20868561400005],
              [-163.93317623599992, 66.21234772300005],
              [-163.9174698559999, 66.21067942900004],
              [-163.9030655589999, 66.20693594000005],
              [-163.8904923169999, 66.16762929900005],
              [-163.8549698559999, 66.13373444200005],
              [-163.80748450399992, 66.10724518400008],
              [-163.75910396999993, 66.09023672100005],
              [-163.68049068899992, 66.07859935100004],
              [-163.35435950399992, 66.09764232000003],
              [-163.33873450399992, 66.09332916900007],
              [-163.30431067599991, 66.07904694200005],
              [-163.28644771999993, 66.07591380400004],
              [-163.12165279899992, 66.07037995000007],
              [-163.04047604099992, 66.07916901200008],
              [-163.00084387899992, 66.08783600500004],
              [-162.96369381399992, 66.10077545800004],
              [-162.94770260299993, 66.10350169500003],
              [-162.86449133999992, 66.09804922100005],
              [-162.7841690749999, 66.10537344000005],
              [-162.7585343089999, 66.11131419500003],
              [-162.7647598949999, 66.10390859600005],
              [-162.71076412699992, 66.08551666900007],
              [-162.68285071499992, 66.06976959800005],
              [-162.6796768869999, 66.05267975500004],
              [-162.68525143099993, 66.04694245000007],
              [-162.6898087229999, 66.04096100500004],
              [-162.6920059889999, 66.03310781500005],
              [-162.69029700399992, 66.02191803600005],
              [-162.68378658799992, 66.00897858300004],
              [-162.6768692699999, 66.00653717700004],
              [-162.6697891919999, 66.01015859600005],
              [-162.66295325399992, 66.01508209800005],
              [-162.66144771999993, 66.02065664300005],
              [-162.6605118479999, 66.02985260600008],
              [-162.65473385299993, 66.03851959800005],
              [-162.63874264199993, 66.04242584800005],
              [-162.54926510299993, 66.05133698100008],
              [-162.50812740799992, 66.06073639500005],
              [-162.48790442599991, 66.06289297100005],
              [-162.4810684889999, 66.06513092700004],
              [-162.4749649729999, 66.06928131700005],
              [-162.46849524599992, 66.07103099200003],
              [-162.46064205599993, 66.06663646000004],
              [-162.4511612619999, 66.05589427300004],
              [-162.4456680979999, 66.05117422100005],
              [-162.4398087229999, 66.04926178600005],
              [-162.42768307199992, 66.04730866100005],
              [-162.40107174399992, 66.03831614800004],
              [-162.38801021999993, 66.03558991100005],
              [-162.34662838399993, 66.03652578300006],
              [-162.30610104099992, 66.04242584800005],
              [-162.2100723949999, 66.07168203300006],
              [-162.17943274599992, 66.07591380400004],
              [-161.91563880099991, 66.04242584800005],
              [-161.93333899599992, 66.04067617400005],
              [-161.94892330599993, 66.03436920800004],
              [-161.97712154899992, 66.01508209800005],
              [-161.96015377499992, 66.01337311400005],
              [-161.9260147779999, 66.02509186400005],
              [-161.9081925119999, 66.02191803600005],
              [-161.8979386059999, 66.01227448100008],
              [-161.89924068899992, 66.00311920800004],
              [-161.9085587229999, 65.99469635600008],
              [-161.9224747389999, 65.98777903900003],
              [-161.89537512899992, 65.97947825700004],
              [-161.85822506399992, 65.97728099200003],
              [-161.8206680979999, 65.98029205900008],
              [-161.79279537699992, 65.98777903900003],
              [-161.79279537699992, 65.99404531500005],
              [-161.84740149599992, 66.00763580900008],
              [-161.83368893099993, 66.02448151200008],
              [-161.81733150899993, 66.03978099200003],
              [-161.79889889199993, 66.05280182500007],
              [-161.77912350199992, 66.06289297100005],
              [-161.74620520699992, 66.07143789300005],
              [-161.72944088399993, 66.07843659100007],
              [-161.7272843089999, 66.08681875200006],
              [-161.7376602859999, 66.08836497600004],
              [-161.78526770699992, 66.07591380400004],
              [-161.78526770699992, 66.08344147300005],
              [-161.76329505099991, 66.09137604400007],
              [-161.68529212099992, 66.13861725500004],
              [-161.66633053299992, 66.15403880400004],
              [-161.65868079299992, 66.16225820500006],
              [-161.64692135299993, 66.18439362200007],
              [-161.63813229099992, 66.19501373900005],
              [-161.62458248599992, 66.19944896000004],
              [-161.6181534499999, 66.20376211100006],
              [-161.59068762899992, 66.23847077000005],
              [-161.58490963399993, 66.24974192900004],
              [-161.57982337099992, 66.25470612200007],
              [-161.57123775899993, 66.25800202000005],
              [-161.55072994699992, 66.26154205900008],
              [-161.50593014199993, 66.27887604400007],
              [-161.3600968089999, 66.27521393400008],
              [-161.36384029899992, 66.27240631700005],
              [-161.3737686839999, 66.26215241100005],
              [-161.3206680979999, 66.23281484600005],
              [-161.2986954419999, 66.22736237200007],
              [-161.2369278639999, 66.22313060100004],
              [-161.1757706369999, 66.22736237200007],
              [-161.12865149599992, 66.24579498900005],
              [-161.10566158799992, 66.25039297100005],
              [-161.08641516799992, 66.24103424700007],
              [-161.08381100199992, 66.23094310100004],
              [-161.08808346299992, 66.21841054900005],
              [-161.09845943899992, 66.20868561400005],
              [-161.11432857999992, 66.20693594000005],
              [-161.11143958199992, 66.19733307500007],
              [-161.10700436099992, 66.18862539300005],
              [-161.10090084499993, 66.18056875200006],
              [-161.0932511059999, 66.17275625200006],
              [-161.10435950399992, 66.16583893400008],
              [-161.1116837229999, 66.15790436400005],
              [-161.1131485669999, 66.14887116100005],
              [-161.10688229099992, 66.13861725500004],
              [-161.1232804029999, 66.13174062700006],
              [-161.1428116529999, 66.12978750200006],
              [-161.1826065749999, 66.13117096600007],
              [-161.1826065749999, 66.12433502800008],
              [-161.16254635299993, 66.11859772300005],
              [-161.13898678299992, 66.11737702000005],
              [-161.11493893099993, 66.11961497600004],
              [-161.0932511059999, 66.12433502800008],
              [-161.07734127499992, 66.13080475500004],
              [-161.0677384109999, 66.13849518400008],
              [-161.0522354809999, 66.15851471600007],
              [-161.0240372389999, 66.18423086100006],
              [-161.01752682199992, 66.19330475500004],
              [-161.00470943899992, 66.23224518400008],
              [-160.99701900899993, 66.24103424700007],
              [-161.01378333199992, 66.26190827000005],
              [-161.05744381399992, 66.28510163000004],
              [-161.07587643099993, 66.29938385600008],
              [-161.09430904899992, 66.31867096600007],
              [-161.11375891799992, 66.33291250200006],
              [-161.1357315749999, 66.34316640800006],
              [-161.26032467399992, 66.36920807500007],
              [-161.3088272779999, 66.37352122600004],
              [-161.34296627499992, 66.38296133000006],
              [-161.36078854099992, 66.38507721600007],
              [-161.42487545499992, 66.38349030200004],
              [-161.51069088399993, 66.40766022300005],
              [-161.74461829299992, 66.40550364800004],
              [-161.7569473949999, 66.40298086100006],
              [-161.79279537699992, 66.38507721600007],
              [-161.81305904899992, 66.38092682500007],
              [-161.87470455599993, 66.37763092700004],
              [-161.90436764199993, 66.36517975500004],
              [-161.9190567699999, 66.34430573100008],
              [-161.91327877499992, 66.32672760600008],
              [-161.88154049399992, 66.32363515800006],
              [-161.8932999339999, 66.31614817900004],
              [-161.8873184889999, 66.30988190300008],
              [-161.87494869699992, 66.30341217700004],
              [-161.86725826699993, 66.29564036700003],
              [-161.86982174399992, 66.28131745000007],
              [-161.88093014199993, 66.27216217700004],
              [-161.89631100199992, 66.27045319200005],
              [-161.91193600199992, 66.27887604400007],
              [-161.91901607999992, 66.28766510600008],
              [-161.92467200399992, 66.29824453300006],
              [-161.92853756399992, 66.30939362200007],
              [-161.9299210279999, 66.32021719000005],
              [-161.93464107999992, 66.32713450700004],
              [-161.94465084499993, 66.33063385600008],
              [-161.95396887899992, 66.33641185100004],
              [-161.95661373599992, 66.35028717700004],
              [-161.94831295499992, 66.36652252800008],
              [-161.89826412699992, 66.40892161700003],
              [-161.88654537699992, 66.42230866100005],
              [-161.8759659499999, 66.44009023600006],
              [-161.86876380099991, 66.46035390800006],
              [-161.86725826699993, 66.48126862200007],
              [-161.88837643099993, 66.52440013200004],
              [-161.93248450399992, 66.55634186400005],
              [-162.0794571609999, 66.62319570500006],
              [-162.1631973949999, 66.68276601800005],
              [-162.20982825399992, 66.70722077000005],
              [-162.26451575399992, 66.72272370000007],
              [-162.4405411449999, 66.73078034100007],
              [-162.47089596299992, 66.73851146000004],
              [-162.4846085279999, 66.74408600500004],
              [-162.4951065749999, 66.74652741100005],
              [-162.50458736899992, 66.74982330900008],
              [-162.51524817599991, 66.75812409100007],
              [-162.52057857999992, 66.76605866100005],
              [-162.52232825399992, 66.78095123900005],
              [-162.52582760299993, 66.78974030200004],
              [-162.5400284499999, 66.80475495000007],
              [-162.57579505099991, 66.83063385600008],
              [-162.58722896999993, 66.84495677300004],
              [-162.60456295499992, 66.84137604400007],
              [-162.62531490799992, 66.86147695500006],
              [-162.63984127499992, 66.88703034100007],
              [-162.63874264199993, 66.89960358300004],
              [-162.59382076699993, 66.91632721600007],
              [-162.57701575399992, 66.91941966400003],
              [-162.51996822799993, 66.92055898600006],
              [-162.5162247389999, 66.92352936400005],
              [-162.51545162699992, 66.92788320500006],
              [-162.50743567599991, 66.93903229400007],
              [-162.50239010299993, 66.94822825700004],
              [-162.4952286449999, 66.95673248900005],
              [-162.48481197799993, 66.96039459800005],
              [-162.47284908799992, 66.95722077000005],
              [-162.46381588399993, 66.94936758000006],
              [-162.44697018099993, 66.92999909100007],
              [-162.4171036449999, 66.92251211100006],
              [-162.38410396999993, 66.93475983300004],
              [-162.35260982999992, 66.95229726800005],
              [-162.3271378249999, 66.96039459800005],
              [-162.3066300119999, 66.95294830900008],
              [-162.28486080599993, 66.93707916900007],
              [-162.2104386059999, 66.86933014500005],
              [-162.12092037699992, 66.80609772300005],
              [-162.09430904899992, 66.79437897300005],
              [-162.03302975199992, 66.78628164300005],
              [-162.01683508999992, 66.78095123900005],
              [-162.01496334499993, 66.77236562700006],
              [-162.05284583199992, 66.73509349200003],
              [-162.07575436099992, 66.70620351800005],
              [-162.08324133999992, 66.68675364800004],
              [-162.08075924399992, 66.66620514500005],
              [-162.06598873599992, 66.65306224200003],
              [-162.01520748599992, 66.63410065300008],
              [-161.99482174399992, 66.62181224200003],
              [-161.91523189999992, 66.55719635600008],
              [-161.87083899599992, 66.53217194200005],
              [-161.6337784499999, 66.45799388200004],
              [-161.60716712099992, 66.45392487200007],
              [-161.43403072799993, 66.46849192900004],
              [-161.3880509109999, 66.48126862200007],
              [-161.35362708199992, 66.48505280200004],
              [-161.33918209499993, 66.48871491100005],
              [-161.34028072799993, 66.49494049700007],
              [-161.31305904899992, 66.50079987200007],
              [-161.26288814999992, 66.52924225500004],
              [-161.23753821499992, 66.53587474200003],
              [-161.2042130199999, 66.53864166900007],
              [-161.19343014199993, 66.53607819200005],
              [-161.1552628249999, 66.50372955900008],
              [-161.14191646999993, 66.49803294500003],
              [-161.06098385299993, 66.48615143400008],
              [-161.03368079299992, 66.47540924700007],
              [-160.98363196499992, 66.44057851800005],
              [-160.78477942599991, 66.37449778900003],
              [-160.76537024599992, 66.37042877800008],
              [-160.70282955599993, 66.37763092700004],
              [-160.6171768869999, 66.37140534100007],
              [-160.45091712099992, 66.39374420800004],
              [-160.24909420499992, 66.40228913000004],
              [-160.2285050119999, 66.41205475500004],
              [-160.2161759109999, 66.43280670800004],
              [-160.21564693899992, 66.45001862200007],
              [-160.22044837099992, 66.49363841400003],
              [-160.21918697799993, 66.53204987200007],
              [-160.24946041599992, 66.56146881700005],
              [-160.32542883999992, 66.60480377800008],
              [-160.32087154899992, 66.60618724200003],
              [-160.3118790359999, 66.61017487200007],
              [-160.30561275899993, 66.61098867400005],
              [-160.31757564999992, 66.63410065300008],
              [-160.29963131399992, 66.63983795800004],
              [-160.26911373599992, 66.63979726800005],
              [-160.2435196609999, 66.64573802300004],
              [-160.27497311099992, 66.65460846600007],
              [-160.31794186099992, 66.65558502800008],
              [-160.35444088399993, 66.64484284100007],
              [-160.36640377499992, 66.61839427300004],
              [-160.39716549399992, 66.62958405200004],
              [-160.4412735669999, 66.63597239800004],
              [-160.48485266799992, 66.63446686400005],
              [-160.51414954299992, 66.62181224200003],
              [-160.5217179029999, 66.60984935100004],
              [-160.52586829299992, 66.60008372600004],
              [-160.5335587229999, 66.59349192900004],
              [-160.55170650899993, 66.59113190300008],
              [-160.63451087099992, 66.59796784100007],
              [-160.69831295499992, 66.61286041900007],
              [-160.81354732999992, 66.66205475500004],
              [-160.88097083199992, 66.67243073100008],
              [-161.05907141799992, 66.65192291900007],
              [-161.13605709499993, 66.65192291900007],
              [-161.17157955599993, 66.64443594000005],
              [-161.2031143869999, 66.62523021000004],
              [-161.20405025899993, 66.62116120000007],
              [-161.2021378249999, 66.60883209800005],
              [-161.2031143869999, 66.60480377800008],
              [-161.2111710279999, 66.60138580900008],
              [-161.23176021999993, 66.59975820500006],
              [-161.23725338399993, 66.59796784100007],
              [-161.24018307199992, 66.58763255400004],
              [-161.2370499339999, 66.57929108300004],
              [-161.23493404899992, 66.57078685100004],
              [-161.2409561839999, 66.56004466400003],
              [-161.27196204299992, 66.54295482000003],
              [-161.31371008999992, 66.53530508000006],
              [-161.3954971999999, 66.53587474200003],
              [-161.42943274599992, 66.54246653900003],
              [-161.44672604099992, 66.54376862200007],
              [-161.4815567699999, 66.53388092700004],
              [-161.49543209499993, 66.53668854400007],
              [-161.51842200399992, 66.55011627800008],
              [-161.56261145699992, 66.56639232000003],
              [-161.56562252499992, 66.57754140800006],
              [-161.54633541599992, 66.59796784100007],
              [-161.5980118479999, 66.60187409100007],
              [-161.64972896999993, 66.61286041900007],
              [-161.8682755199999, 66.70628489800004],
              [-161.90196692599991, 66.73509349200003],
              [-161.87177486899992, 66.75409577000005],
              [-161.86725826699993, 66.75812409100007],
              [-161.86945553299992, 66.76874420800004],
              [-161.88154049399992, 66.78974030200004],
              [-161.88532467399992, 66.80866120000007],
              [-161.88056393099993, 66.81476471600007],
              [-161.85334225199992, 66.81940338700008],
              [-161.82005774599992, 66.83755117400005],
              [-161.8001602859999, 66.85374583500004],
              [-161.8011368479999, 66.86591217700004],
              [-161.80821692599991, 66.87946198100008],
              [-161.80638587099992, 66.89960358300004],
              [-161.78868567599991, 66.91339752800008],
              [-161.73407955599993, 66.92308177300004],
              [-161.71642005099991, 66.93992747600004],
              [-161.72272701699993, 66.94301992400005],
              [-161.72553463399993, 66.94623444200005],
              [-161.72736568899992, 66.94965241100005],
              [-161.73066158799992, 66.95355866100005],
              [-161.66173255099991, 66.96320221600007],
              [-161.62885494699992, 66.96405670800004],
              [-161.55833899599992, 66.95799388200004],
              [-161.5182999339999, 66.96067942900004],
              [-161.49885006399992, 66.97109609600005],
              [-161.52521725199992, 66.99144114800004],
              [-161.5444229809999, 66.99469635600008],
              [-161.58954830599993, 66.99323151200008],
              [-161.60346432199992, 66.99799225500004],
              [-161.61607825399992, 67.00779857000003],
              [-161.63133704299992, 67.01459381700005],
              [-161.68757076699993, 67.02928294500003],
              [-161.69652258999992, 67.02928294500003],
              [-161.7037247389999, 67.02643463700008],
              [-161.70824133999992, 67.02155182500007],
              [-161.7103165359999, 67.01699453300006],
              [-161.71019446499992, 67.01504140800006],
              [-161.72455807199992, 67.01483795800004],
              [-161.7402237619999, 67.01727936400005],
              [-161.75544186099992, 67.02317942900004],
              [-161.76825924399992, 67.03302643400008],
              [-161.79621334499993, 67.04848867400005],
              [-161.83515377499992, 67.05499909100007],
              [-161.9902237619999, 67.04922109600005],
              [-162.2480362619999, 67.01504140800006],
              [-162.25776119699992, 67.02057526200008],
              [-162.25829016799992, 67.03290436400005],
              [-162.25548255099991, 67.04580312700006],
              [-162.2548721999999, 67.05292389500005],
              [-162.2650040359999, 67.06159088700008],
              [-162.2752579419999, 67.06781647300005],
              [-162.28827877499992, 67.07086823100008],
              [-162.30610104099992, 67.07025788000004],
              [-162.29698645699992, 67.05019765800006],
              [-162.3068741529999, 67.03994375200006],
              [-162.31297766799992, 67.02952708500004],
              [-162.29303951699993, 67.00885651200008],
              [-162.31293697799993, 67.00389232000003],
              [-162.36811275899993, 67.00885651200008],
              [-162.43549557199992, 66.99103424700007],
              [-162.4568985669999, 66.99457428600005],
              [-162.46686764199993, 67.00218333500004],
              [-162.46760006399992, 67.00946686400005],
              [-162.4288223949999, 67.05792877800008],
              [-162.42585201699993, 67.06342194200005],
              [-162.40558834499993, 67.07143789300005],
              [-162.38642330599993, 67.09039948100008],
              [-162.3544815749999, 67.13231028900003],
              [-162.33783932199992, 67.14508698100008],
              [-162.33490963399993, 67.15086497600004],
              [-162.3408096999999, 67.15965403900003],
              [-162.3600968089999, 67.16742584800005],
              [-162.38792883999992, 67.16876862200007],
              [-162.41612708199992, 67.16559479400007],
              [-162.43639075399992, 67.15965403900003],
              [-162.39911861899992, 67.15997955900008],
              [-162.38349361899992, 67.15428294500003],
              [-162.37494869699992, 67.13922760600008],
              [-162.39045162699992, 67.13361237200007],
              [-162.48591061099992, 67.06122467700004],
              [-162.55878658799992, 67.01996491100005],
              [-162.5804337229999, 67.01504140800006],
              [-162.66376705599993, 67.01605866100005],
              [-162.67699133999992, 67.01825592700004],
              [-162.69029700399992, 67.02252838700008],
              [-162.68854732999992, 67.02606842700004],
              [-162.6874893869999, 67.02936432500007],
              [-162.68598385299993, 67.03278229400007],
              [-162.68281002499992, 67.03681061400005],
              [-162.73334713399993, 67.04881419500003],
              [-162.8889054029999, 67.04295482000003],
              [-162.93956458199992, 67.04816315300008],
              [-162.9518936839999, 67.04433828300006],
              [-162.93732662699992, 67.02928294500003],
              [-162.9167374339999, 67.02081940300008],
              [-162.8694962229999, 67.01483795800004],
              [-162.8478897779999, 67.00885651200008],
              [-162.8741348949999, 67.00531647300005],
              [-163.07392330599993, 67.03554922100005],
              [-163.14232337099992, 67.05703359600005],
              [-163.4056290359999, 67.07587311400005],
              [-163.4330948559999, 67.08502838700008],
              [-163.68830318899992, 67.10321686400005],
              [-163.7249649729999, 67.11127350500004],
              [-163.7656143869999, 67.13996002800008],
              [-163.7741593089999, 67.18036530200004],
              [-163.7734268869999, 67.22565338700008],
              [-163.78644771999993, 67.26951732000003],
              [-163.7924698559999, 67.28900788000004],
              [-163.8100479809999, 67.33515045800004],
              [-163.82396399599992, 67.35455963700008],
              [-163.96161861899992, 67.49868398600006],
              [-164.04645748599992, 67.56370677300004],
              [-164.1514786449999, 67.61961497600004],
              [-164.4460343089999, 67.70990631700005],
              [-164.5316055979999, 67.75079987200007],
              [-164.59776770699992, 67.77415599200003],
              [-164.69355221299992, 67.82461172100005],
              [-164.72651119699992, 67.83454010600008],
              [-164.76646887899992, 67.83808014500005],
              [-164.7733048169999, 67.83808014500005],
              [-164.7643936839999, 67.82371653900003],
              [-164.74775143099993, 67.81712474200003],
              [-164.73285885299993, 67.81220123900005],
              [-164.71808834499993, 67.80390045800004],
              [-164.74787350199992, 67.80988190300008],
              [-164.8015030589999, 67.83836497600004],
              [-164.85602779899992, 67.84955475500004],
              [-165.05394446499992, 67.93305084800005],
              [-165.23273678299992, 67.99762604400007],
              [-165.43720455599993, 68.06024811400005],
              [-165.61998450399992, 68.09194570500006],
              [-165.76899166599992, 68.10687897300005],
              [-165.9280899729999, 68.13694896000004],
              [-165.99360104099992, 68.16705963700008],
              [-166.02708899599992, 68.19432200700004],
              [-166.0678604809999, 68.21662018400008],
              [-166.07860266799992, 68.22508372600004],
              [-166.10346432199992, 68.23989492400005],
              [-166.20588131399992, 68.26264069200005],
              [-166.29662024599992, 68.29962799700007],
              [-166.64374752499992, 68.34454987200007],
              [-166.78986568899992, 68.33958567900004],
              [-166.82282467399992, 68.35138580900008],
              [-166.82905025899993, 68.35138580900008],
              [-166.81183834499993, 68.35956452000005],
              [-166.59821529899992, 68.40810781500005],
              [-166.5071915359999, 68.42291901200008],
              [-166.4448136059999, 68.42023346600007],
              [-166.51378333199992, 68.41469961100006],
              [-166.71906490799992, 68.37327708500004],
              [-166.7471817699999, 68.36334870000007],
              [-166.66454016799992, 68.35138580900008],
              [-166.54816646999993, 68.35883209800005],
              [-166.45478268099993, 68.39887116100005],
              [-166.42768307199992, 68.39716217700004],
              [-166.37653561099992, 68.38556549700007],
              [-166.38483639199993, 68.39712148600006],
              [-166.41144771999993, 68.40399811400005],
              [-166.42499752499992, 68.41347890800006],
              [-166.33820553299992, 68.39996979400007],
              [-166.31513424399992, 68.40599192900004],
              [-166.33287512899992, 68.41282786700003],
              [-166.35090084499993, 68.43622467700004],
              [-166.37035071499992, 68.44082265800006],
              [-166.33018958199992, 68.46747467700004],
              [-166.31464596299992, 68.48102448100008],
              [-166.3007706369999, 68.50287506700005],
              [-166.30626380099991, 68.52204010600008],
              [-166.28718014199993, 68.53754303600005],
              [-166.2596329419999, 68.55101146000004],
              [-166.23997962099992, 68.56427643400008],
              [-166.23102779899992, 68.57990143400008],
              [-166.23253333199992, 68.58710358300004],
              [-166.23790442599991, 68.59316640800006],
              [-166.23997962099992, 68.60521067900004],
              [-166.23713131399992, 68.61603424700007],
              [-166.21886145699992, 68.64618561400005],
              [-166.23066158799992, 68.65485260600008],
              [-166.22870846299992, 68.66107819200005],
              [-166.22028561099992, 68.66689687700006],
              [-166.21263587099992, 68.67413971600007],
              [-166.20697994699992, 68.68683502800008],
              [-166.2050675119999, 68.69676341400003],
              [-166.20588131399992, 68.71849192900004],
              [-166.20270748599992, 68.74042389500005],
              [-166.19684811099992, 68.75967031500005],
              [-166.19379635299993, 68.77968984600005],
              [-166.19904537699992, 68.80390045800004],
              [-166.22797604099992, 68.84959544500003],
              [-166.23676510299993, 68.87482330900008],
              [-166.22260494699992, 68.88580963700008],
              [-166.08564205599993, 68.89142487200007],
              [-166.00910396999993, 68.87274811400005],
              [-165.8135880199999, 68.87946198100008],
              [-165.66474361899992, 68.86155833500004],
              [-165.32209225199992, 68.87645091400003],
              [-165.0440567699999, 68.88149648600006],
              [-164.79076087099992, 68.91425202000005],
              [-164.3464249339999, 68.92938873900005],
              [-164.25702877499992, 68.94668203300006],
              [-164.17035885299993, 68.95380280200004],
              [-164.09003658799992, 68.97894928600005],
              [-163.96454830599993, 69.00311920800004],
              [-163.93517005099991, 69.01243724200003],
              [-163.87669837099992, 69.03864166900007],
              [-163.82172604099992, 69.04783763200004],
              [-163.6225479809999, 69.11920807500007],
              [-163.2861221999999, 69.31098053600005],
              [-163.2647598949999, 69.32660553600005],
              [-163.1953018869999, 69.41522858300004],
              [-163.17699133999992, 69.42690664300005],
              [-163.1557511059999, 69.42084381700005],
              [-163.23997962099992, 69.32831452000005],
              [-163.2724503249999, 69.30414459800005],
              [-163.2724503249999, 69.29791901200008],
              [-163.2425430979999, 69.30463288000004],
              [-163.1557511059999, 69.35936107000003],
              [-163.1631973949999, 69.36619700700004],
              [-163.14264889199993, 69.37523021000004],
              [-163.12580318899992, 69.38996002800008],
              [-163.12067623599992, 69.40643952000005],
              [-163.13532467399992, 69.42084381700005],
              [-163.1224259109999, 69.43036530200004],
              [-163.12018795499992, 69.43813711100006],
              [-163.12214107999992, 69.44562409100007],
              [-163.12165279899992, 69.45433177300004],
              [-163.11412512899992, 69.46625397300005],
              [-163.10667883999992, 69.47483958500004],
              [-163.1049698559999, 69.48371002800008],
              [-163.11481686099992, 69.49591705900008],
              [-163.08320064999992, 69.50104401200008],
              [-163.07079016799992, 69.52041250200006],
              [-163.06928463399993, 69.54132721600007],
              [-163.07013912699992, 69.55117422100005],
              [-163.06476803299992, 69.55597565300008],
              [-163.0678604809999, 69.56679922100005],
              [-163.07477779899992, 69.57831452000005],
              [-163.0806778639999, 69.58535390800006],
              [-163.09382076699993, 69.59056224200003],
              [-163.14899654899992, 69.59955475500004],
              [-163.14899654899992, 69.60578034100007],
              [-163.0854386059999, 69.60932038000004],
              [-163.05357825399992, 69.61546458500004],
              [-163.02546139199993, 69.62628815300008],
              [-163.0351456369999, 69.63231028900003],
              [-163.0663956369999, 69.64671458500004],
              [-163.03290768099993, 69.66107819200005],
              [-163.0416153639999, 69.66347890800006],
              [-163.0663956369999, 69.67405833500004],
              [-163.04853268099993, 69.68724192900004],
              [-162.98412024599992, 69.68183014500005],
              [-162.9565323559999, 69.68773021000004],
              [-162.93842525899993, 69.71124909100007],
              [-162.95759029899992, 69.72337474200003],
              [-162.99347896999993, 69.72797272300005],
              [-163.02546139199993, 69.72866445500006],
              [-163.01874752499992, 69.74583567900004],
              [-163.0053604809999, 69.75311920800004],
              [-162.98835201699993, 69.75682200700004],
              [-162.97081458199992, 69.76341380400004],
              [-162.97826087099992, 69.77024974200003],
              [-162.94977779899992, 69.79047272300005],
              [-162.7913712229999, 69.85333893400008],
              [-162.75727291599992, 69.87189362200007],
              [-162.71161861899992, 69.88068268400008],
              [-162.66999264199993, 69.90656159100007],
              [-162.5927628249999, 69.94171784100007],
              [-162.53779049399992, 69.95673248900005],
              [-162.51142330599993, 69.97695547100005],
              [-162.48949133999992, 70.00177643400008],
              [-162.47736568899992, 70.02411530200004],
              [-162.4819229809999, 70.03074778900003],
              [-162.49103756399992, 70.05145905200004],
              [-162.46149654899992, 70.05963776200008],
              [-162.3607071609999, 70.05760325700004],
              [-162.36420650899993, 70.06366608300004],
              [-162.3713272779999, 70.07949453300006],
              [-162.37494869699992, 70.08559804900005],
              [-162.3408096999999, 70.09243398600006],
              [-162.35204016799992, 70.10838450700004],
              [-162.32148189999992, 70.12726471600007],
              [-162.24461829299992, 70.15387604400007],
              [-162.20673580599993, 70.16132233300004],
              [-162.19941158799992, 70.16437409100007],
              [-162.19428463399993, 70.17121002800008],
              [-162.1904190749999, 70.17804596600007],
              [-162.18659420499992, 70.18121979400007],
              [-162.17096920499992, 70.18463776200008],
              [-162.1248673169999, 70.20319245000007],
              [-162.09943600199992, 70.22060781500005],
              [-162.05284583199992, 70.24384186400005],
              [-162.01496334499993, 70.27732982000003],
              [-162.00165768099993, 70.28091054900005],
              [-161.95661373599992, 70.30467357000003],
              [-161.90571041599992, 70.32062409100007],
              [-161.87983150899993, 70.32294342700004],
              [-161.85358639199993, 70.31834544500003],
              [-161.85614986899992, 70.31464264500005],
              [-161.86103268099993, 70.30467357000003],
              [-161.83995520699992, 70.30410390800006],
              [-161.8331192699999, 70.30467357000003],
              [-161.8331192699999, 70.29783763200004],
              [-161.8404434889999, 70.29694245000007],
              [-161.86103268099993, 70.29043203300006],
              [-161.72370357999992, 70.27484772300005],
              [-161.7033585279999, 70.26373932500007],
              [-161.73346920499992, 70.25031159100007],
              [-161.86005611899992, 70.25869375200006],
              [-161.90196692599991, 70.25690338700008],
              [-161.8679093089999, 70.24266185100004],
              [-161.79084225199992, 70.24054596600007],
              [-161.75861568899992, 70.22955963700008],
              [-161.78917395699992, 70.22915273600006],
              [-161.83259029899992, 70.22313060100004],
              [-161.85948645699992, 70.21185944200005],
              [-161.84052486899992, 70.19546133000006],
              [-161.86554928299992, 70.17934804900005],
              [-161.8995255199999, 70.17865631700005],
              [-162.00873775899993, 70.19627513200004],
              [-162.02550208199992, 70.19546133000006],
              [-162.0397843089999, 70.19110748900005],
              [-162.06615149599992, 70.17938873900005],
              [-162.08075924399992, 70.17495351800005],
              [-162.1216934889999, 70.16132233300004],
              [-162.1216934889999, 70.15387604400007],
              [-161.8646134109999, 70.16913483300004],
              [-161.84809322799993, 70.17381419500003],
              [-161.8132218089999, 70.19208405200004],
              [-161.78673255099991, 70.19965241100005],
              [-161.7033585279999, 70.19546133000006],
              [-161.72016354099992, 70.20123932500007],
              [-161.72826087099992, 70.20229726800005],
              [-161.7381485669999, 70.20229726800005],
              [-161.72931881399992, 70.21564362200007],
              [-161.71259518099993, 70.22406647300005],
              [-161.69318600199992, 70.22833893400008],
              [-161.6760147779999, 70.22955963700008],
              [-161.6667374339999, 70.23208242400005],
              [-161.66352291599992, 70.23786041900007],
              [-161.66144771999993, 70.24469635600008],
              [-161.65558834499993, 70.25006745000007],
              [-161.64342200399992, 70.25409577000005],
              [-161.6319473949999, 70.25608958500004],
              [-161.3421524729999, 70.25877513200004],
              [-161.21064205599993, 70.27680084800005],
              [-161.0670059889999, 70.31484609600005],
              [-161.02497311099992, 70.31834544500003],
              [-161.02497311099992, 70.31216054900005],
              [-161.03180904899992, 70.31216054900005],
              [-161.03180904899992, 70.30467357000003],
              [-161.00987708199992, 70.30438873900005],
              [-160.94989986899992, 70.29043203300006],
              [-160.95649166599992, 70.30145905200004],
              [-160.97740637899992, 70.31362539300005],
              [-160.98399817599991, 70.32514069200005],
              [-160.95787512899992, 70.33274974200003],
              [-160.86066646999993, 70.34731679900005],
              [-160.62153072799993, 70.42959219000005],
              [-160.59980221299992, 70.44183991100005],
              [-160.66279049399992, 70.43402741100005],
              [-160.70746822799993, 70.41913483300004],
              [-160.81269283799992, 70.38719310100004],
              [-160.77306067599991, 70.40574778900003],
              [-160.68927975199992, 70.43402741100005],
              [-160.44896399599992, 70.48965078300006],
              [-160.2161759109999, 70.57904694200005],
              [-160.18830318899992, 70.59707265800006],
              [-160.1722305979999, 70.60492584800005],
              [-160.1553848949999, 70.60635000200006],
              [-160.16742916599992, 70.59625885600008],
              [-160.15961666599992, 70.58795807500007],
              [-160.14268958199992, 70.58201732000003],
              [-160.12743079299992, 70.57904694200005],
              [-160.10297604099992, 70.57851797100005],
              [-160.0380753249999, 70.59271881700005],
              [-159.94709225199992, 70.59723541900007],
              [-159.92821204299992, 70.59271881700005],
              [-159.92438717399992, 70.58148834800005],
              [-159.92890377499992, 70.56842682500007],
              [-159.93818111899992, 70.55727773600006],
              [-159.94867916599992, 70.55170319200005],
              [-159.94867916599992, 70.54486725500004],
              [-159.94220943899992, 70.54547760600008],
              [-159.92198645699992, 70.54486725500004],
              [-159.94383704299992, 70.52195872600004],
              [-160.01105709499993, 70.52033112200007],
              [-160.04181881399992, 70.50702545800004],
              [-160.0740860669999, 70.48822663000004],
              [-160.11481686099992, 70.48069896000004],
              [-160.2018936839999, 70.47662995000007],
              [-160.16877193899992, 70.46596914300005],
              [-160.1257218089999, 70.46600983300004],
              [-159.94847571499992, 70.49445221600007],
              [-159.92198645699992, 70.48965078300006],
              [-159.93834387899992, 70.47606028900003],
              [-159.97423255099991, 70.45600006700005],
              [-159.9902237619999, 70.44183991100005],
              [-160.0139054029999, 70.41095612200007],
              [-160.0296524729999, 70.39899323100008],
              [-160.0517471999999, 70.39411041900007],
              [-160.05634518099993, 70.37494538000004],
              [-160.11420650899993, 70.34414297100005],
              [-160.13365637899992, 70.32514069200005],
              [-160.09601803299992, 70.32135651200008],
              [-160.00902258999992, 70.36147695500006],
              [-159.96918697799993, 70.37299225500004],
              [-159.94847571499992, 70.37042877800008],
              [-159.93317623599992, 70.36229075700004],
              [-159.9222305979999, 70.34931061400005],
              [-159.91454016799992, 70.33197663000004],
              [-159.91681881399992, 70.33038971600007],
              [-159.92231197799993, 70.32807038000004],
              [-159.92731686099992, 70.32416413000004],
              [-159.92821204299992, 70.31834544500003],
              [-159.92548580599993, 70.31537506700005],
              [-159.92076575399992, 70.31338125200006],
              [-159.91645260299993, 70.31232330900008],
              [-159.91454016799992, 70.31216054900005],
              [-159.91063391799992, 70.30410390800006],
              [-159.90619869699992, 70.29913971600007],
              [-159.9042862619999, 70.29376862200007],
              [-159.9077042309999, 70.28424713700008],
              [-159.8665665359999, 70.27773672100005],
              [-159.83324133999992, 70.25202057500007],
              [-159.8030899729999, 70.22028229400007],
              [-159.77118893099993, 70.19546133000006],
              [-159.77057857999992, 70.22516510600008],
              [-159.78673255099991, 70.23810455900008],
              [-159.8105362619999, 70.24689362200007],
              [-159.8326309889999, 70.26373932500007],
              [-159.8369034499999, 70.27362702000005],
              [-159.83869381399992, 70.28579336100006],
              [-159.83881588399993, 70.30841705900008],
              [-159.84496008999992, 70.31342194200005],
              [-159.84972083199992, 70.31842682500007],
              [-159.85309811099992, 70.32514069200005],
              [-159.85053463399993, 70.33087799700007],
              [-159.84349524599992, 70.33551666900007],
              [-159.83869381399992, 70.34100983300004],
              [-159.8425186839999, 70.34943268400008],
              [-159.88031979099992, 70.37567780200004],
              [-159.88727779899992, 70.38719310100004],
              [-159.88678951699993, 70.39887116100005],
              [-159.88215084499993, 70.40761953300006],
              [-159.87677975199992, 70.41547272300005],
              [-159.87421627499992, 70.42479075700004],
              [-159.86506100199992, 70.44403717700004],
              [-159.84581458199992, 70.45652903900003],
              [-159.82860266799992, 70.47125885600008],
              [-159.82579505099991, 70.49705638200004],
              [-159.81029212099992, 70.50079987200007],
              [-159.79930579299992, 70.49921295800004],
              [-159.72809811099992, 70.47264232000003],
              [-159.7097061839999, 70.46979401200008],
              [-159.66962643099993, 70.47308991100005],
              [-159.59337317599991, 70.49258047100005],
              [-159.54084225199992, 70.49921295800004],
              [-159.49531002499992, 70.51581452000005],
              [-159.48058020699992, 70.51552969000005],
              [-159.44928951699993, 70.50092194200005],
              [-159.43476314999992, 70.49705638200004],
              [-159.41852779899992, 70.49970123900005],
              [-159.36713619699992, 70.51764557500007],
              [-159.3256729809999, 70.52130768400008],
              [-159.3057755199999, 70.52619049700007],
              [-159.2913712229999, 70.53807200700004],
              [-159.42109127499992, 70.52383047100005],
              [-159.53083248599992, 70.53241608300004],
              [-159.56513424399992, 70.53123607000003],
              [-159.56843014199993, 70.52879466400003],
              [-159.57087154899992, 70.52411530200004],
              [-159.57233639199993, 70.51959870000007],
              [-159.5724991529999, 70.51764557500007],
              [-159.5799454419999, 70.51683177300004],
              [-159.63117428299992, 70.51727936400005],
              [-159.64118404899992, 70.51430898600006],
              [-159.6507462229999, 70.50702545800004],
              [-159.66380774599992, 70.50006745000007],
              [-159.68175208199992, 70.49681224200003],
              [-159.7159317699999, 70.49705638200004],
              [-159.7322891919999, 70.49990469000005],
              [-159.74238033799992, 70.50421784100007],
              [-159.76435299399992, 70.51764557500007],
              [-159.8253067699999, 70.54376862200007],
              [-159.8425186839999, 70.55512116100005],
              [-159.84943600199992, 70.56232330900008],
              [-159.85521399599992, 70.57050202000005],
              [-159.85912024599992, 70.57941315300008],
              [-159.86054439999992, 70.58901601800005],
              [-159.8646134109999, 70.59906647300005],
              [-159.87458248599992, 70.60268789300005],
              [-159.88678951699993, 70.60455963700008],
              [-159.9478653639999, 70.63641998900005],
              [-160.0057266919999, 70.64008209800005],
              [-160.0651749339999, 70.62775299700007],
              [-160.11998450399992, 70.60635000200006],
              [-160.12230383999992, 70.61029694200005],
              [-160.12458248599992, 70.61566803600005],
              [-160.12743079299992, 70.62620677300004],
              [-160.09626217399992, 70.64305247600004],
              [-159.91303463399993, 70.70062897300005],
              [-159.8880509109999, 70.70555247600004],
              [-159.83625240799992, 70.70807526200008],
              [-159.81212317599991, 70.71556224200003],
              [-159.84626217399992, 70.71556224200003],
              [-159.8130997389999, 70.72785065300008],
              [-159.7089737619999, 70.77928294500003],
              [-159.68321692599991, 70.79759349200003],
              [-159.66816158799992, 70.80499909100007],
              [-159.64484615799992, 70.81000397300005],
              [-159.59540768099993, 70.81378815300008],
              [-159.54877682199992, 70.83022695500006],
              [-159.51964270699992, 70.83576080900008],
              [-159.41205807199992, 70.84202708500004],
              [-159.38329016799992, 70.84690989800004],
              [-159.3463028639999, 70.86334870000007],
              [-159.16100012899992, 70.88690827000005],
              [-159.20624752499992, 70.86640045800004],
              [-159.31879635299993, 70.86102936400005],
              [-159.3732804029999, 70.84593333500004],
              [-159.17426510299993, 70.85390859600005],
              [-159.15514075399992, 70.84634023600006],
              [-159.14057369699992, 70.82542552300004],
              [-159.18134518099993, 70.81671784100007],
              [-159.31183834499993, 70.81244538000004],
              [-159.4108780589999, 70.78742096600007],
              [-159.44904537699992, 70.78449127800008],
              [-159.44904537699992, 70.77704498900005],
              [-159.3920792309999, 70.76732005400004],
              [-159.37360592399992, 70.76093170800004],
              [-159.3568009109999, 70.76019928600005],
              [-159.33906002499992, 70.76654694200005],
              [-159.3212784499999, 70.76927317900004],
              [-159.30443274599992, 70.75779857000003],
              [-159.3100479809999, 70.75397370000007],
              [-159.3187149729999, 70.74616120000007],
              [-159.32489986899992, 70.74355703300006],
              [-159.30097408799992, 70.72711823100008],
              [-159.2464493479999, 70.70644765800006],
              [-159.22248287699992, 70.68891022300005],
              [-159.2162979809999, 70.69513580900008],
              [-159.2704971999999, 70.74461497600004],
              [-159.27904212099992, 70.76471588700008],
              [-159.23615475199992, 70.77081940300008],
              [-159.1197403639999, 70.76398346600007],
              [-158.9897354809999, 70.77704498900005],
              [-159.00348873599992, 70.79726797100005],
              [-159.0291641919999, 70.80512116100005],
              [-159.0853165359999, 70.80499909100007],
              [-159.0604141919999, 70.81655508000006],
              [-158.71540279899992, 70.79132721600007],
              [-158.33800208199992, 70.81801992400005],
              [-158.43927975199992, 70.82208893400008],
              [-158.49299068899992, 70.83234284100007],
              [-158.52354895699992, 70.85276927300004],
              [-158.47992916599992, 70.85325755400004],
              [-158.3893936839999, 70.83673737200007],
              [-158.04303951699993, 70.83685944200005],
              [-157.86493893099993, 70.86644114800004],
              [-157.67353268099993, 70.92279694200005],
              [-157.6243790359999, 70.93130117400005],
              [-157.5932511059999, 70.94619375200006],
              [-157.57795162699992, 70.94961172100005],
              [-157.55907141799992, 70.95136139500005],
              [-157.2311905589999, 71.07135651200008],
              [-157.08783932199992, 71.15501536700003],
              [-157.02550208199992, 71.20319245000007],
              [-156.81720943899992, 71.30634186400005],
              [-156.68183346299992, 71.35272858300004],
              [-156.59190833199992, 71.36473216400003],
              [-156.52240963399993, 71.38971588700008],
              [-156.49860592399992, 71.40452708500004],
              [-156.47150631399992, 71.41250234600005],
              [-156.43480383999992, 71.40648021000004],
              [-156.39826412699992, 71.39350006700005],
              [-156.37165279899992, 71.38031647300005],
              [-156.40013587099992, 71.37742747600004],
              [-156.4584854809999, 71.39516836100006],
              [-156.48835201699993, 71.39398834800005],
              [-156.5521134109999, 71.36497630400004],
              [-156.58881588399993, 71.35834381700005],
              [-156.60444088399993, 71.35366445500006],
              [-156.57221432199992, 71.33637116100005],
              [-156.55646725199992, 71.32469310100004],
              [-156.5497940749999, 71.30898672100005],
              [-156.53425045499992, 71.30011627800008],
              [-156.43370520699992, 71.29218170800004],
              [-156.44733639199993, 71.27680084800005],
              [-156.44330807199992, 71.26837799700007],
              [-156.42841549399992, 71.26496002800008],
              [-156.23700924399992, 71.26919179900005],
              [-156.14106197799993, 71.25649648600006],
              [-156.09736080599993, 71.24380117400005],
              [-156.10785885299993, 71.22724030200004],
              [-156.11095130099991, 71.22333405200004],
              [-156.0591934889999, 71.22064850500004],
              [-156.04271399599992, 71.21588776200008],
              [-156.05793209499993, 71.20449453300006],
              [-156.11095130099991, 71.18231842700004],
              [-156.11095130099991, 71.17487213700008],
              [-156.07233639199993, 71.17670319200005],
              [-156.03412838399993, 71.18284739800004],
              [-155.99933834499993, 71.19452545800004],
              [-155.97101803299992, 71.21279531500005],
              [-155.95990963399993, 71.21824778900003],
              [-155.94489498599992, 71.22036367400005],
              [-155.93171139199993, 71.21702708500004],
              [-155.9260147779999, 71.20624420800004],
              [-155.9160050119999, 71.19647858300004],
              [-155.89313717399992, 71.19855377800008],
              [-155.85151119699992, 71.20966217700004],
              [-155.80089270699992, 71.20880768400008],
              [-155.62474524599992, 71.18353913000004],
              [-155.5967911449999, 71.16998932500007],
              [-155.57343502499992, 71.15037669500003],
              [-155.55610104099992, 71.12710195500006],
              [-155.5515030589999, 71.10089752800008],
              [-155.5666397779999, 71.08152903900003],
              [-155.5937393869999, 71.06972890800006],
              [-155.6400040359999, 71.06313711100006],
              [-155.65392005099991, 71.05683014500005],
              [-155.6799210279999, 71.04144928600005],
              [-155.68927975199992, 71.03904857000003],
              [-155.70909583199992, 71.03831614800004],
              [-155.7171524729999, 71.03461334800005],
              [-155.72065182199992, 71.02928294500003],
              [-155.7280167309999, 71.01105377800008],
              [-155.74469967399992, 71.00446198100008],
              [-155.76537024599992, 70.99998607000003],
              [-155.8065079419999, 70.99677155200004],
              [-155.81293697799993, 70.99461497600004],
              [-155.8233536449999, 70.98525625200006],
              [-155.83075924399992, 70.98309967700004],
              [-156.07209225199992, 70.97394440300008],
              [-156.09736080599993, 70.96881745000007],
              [-156.10472571499992, 70.96881745000007],
              [-156.0792130199999, 70.96238841400003],
              [-156.05317135299993, 70.96238841400003],
              [-156.02863521999993, 70.95892975500004],
              [-156.00792395699992, 70.94212474200003],
              [-156.0472305979999, 70.92942942900004],
              [-156.14500891799992, 70.93268463700008],
              [-156.18732662699992, 70.92169830900008],
              [-156.1542862619999, 70.91909414300005],
              [-156.08722896999993, 70.92698802300004],
              [-156.05634518099993, 70.92169830900008],
              [-156.06635494699992, 70.91697825700004],
              [-156.09736080599993, 70.90802643400008],
              [-156.06794186099992, 70.90249258000006],
              [-156.00483150899993, 70.90912506700005],
              [-155.98127193899992, 70.89435455900008],
              [-155.9948624339999, 70.88690827000005],
              [-155.98224850199992, 70.87641022300005],
              [-155.95319576699993, 70.86542389500005],
              [-155.94029700399992, 70.85276927300004],
              [-155.95368404899992, 70.84634023600006],
              [-155.9686173169999, 70.84235260600008],
              [-155.9811905589999, 70.83673737200007],
              [-155.98749752499992, 70.82542552300004],
              [-155.98578854099992, 70.81525299700007],
              [-155.97276770699992, 70.80149974200003],
              [-155.96760006399992, 70.79132721600007],
              [-155.9709366529999, 70.77968984600005],
              [-155.97826087099992, 70.76727936400005],
              [-155.97809811099992, 70.75967031500005],
              [-155.92393958199992, 70.76650625200006],
              [-155.90904700399992, 70.77122630400004],
              [-155.89936275899993, 70.78449127800008],
              [-155.9128311839999, 70.79051341400003],
              [-155.92280025899993, 70.79995351800005],
              [-155.92621822799993, 70.81183502800008],
              [-155.9197891919999, 70.82542552300004],
              [-155.89142818899992, 70.83665599200003],
              [-155.80890865799992, 70.83071523600006],
              [-155.77582760299993, 70.83600495000007],
              [-155.7505997389999, 70.84422435100004],
              [-155.72040768099993, 70.84609609600005],
              [-155.69123287699992, 70.84113190300008],
              [-155.65876217399992, 70.82416413000004],
              [-155.65082760299993, 70.82868073100008],
              [-155.64704342399992, 70.83588288000004],
              [-155.6491593089999, 70.83974844000005],
              [-155.65514075399992, 70.84296295800004],
              [-155.66022701699993, 70.85053131700005],
              [-155.6639298169999, 70.85936107000003],
              [-155.66596432199992, 70.86640045800004],
              [-155.64557857999992, 70.86806875200006],
              [-155.60313880099991, 70.84617747600004],
              [-155.5771378249999, 70.84593333500004],
              [-155.54242916599992, 70.86640045800004],
              [-155.53461666599992, 70.87726471600007],
              [-155.5331925119999, 70.88593170800004],
              [-155.53620357999992, 70.90460846600007],
              [-155.53571529899992, 70.92568594000005],
              [-155.53107662699992, 70.94179922100005],
              [-155.51789303299992, 70.95213450700004],
              [-155.46808834499993, 70.96043528900003],
              [-155.40587317599991, 70.99677155200004],
              [-155.39032955599993, 71.00287506700005],
              [-155.34443111899992, 71.01105377800008],
              [-155.3318985669999, 71.01601797100005],
              [-155.3085831369999, 71.02875397300005],
              [-155.2960098949999, 71.03156159100007],
              [-155.27497311099992, 71.02558014500005],
              [-155.24372311099992, 70.99713776200008],
              [-155.2171524729999, 70.99054596600007],
              [-155.19172115799992, 70.99506256700005],
              [-155.18207760299993, 71.00682200700004],
              [-155.18488521999993, 71.02317942900004],
              [-155.19672604099992, 71.04144928600005],
              [-155.2171524729999, 71.05646393400008],
              [-155.26732337099992, 71.07294342700004],
              [-155.28917395699992, 71.08612702000005],
              [-155.26923580599993, 71.09910716400003],
              [-155.20966549399992, 71.12299225500004],
              [-155.1861466139999, 71.12710195500006],
              [-155.1630753249999, 71.11981842700004],
              [-155.1240128249999, 71.09023672100005],
              [-155.09740149599992, 71.08612702000005],
              [-155.10313880099991, 71.10423411700003],
              [-155.10163326699993, 71.11985911700003],
              [-155.1049698559999, 71.13231028900003],
              [-155.12531490799992, 71.14077383000006],
              [-155.10932369699992, 71.15037669500003],
              [-155.08967037699992, 71.15493398600006],
              [-155.0696915359999, 71.15326569200005],
              [-155.05268307199992, 71.14419179900005],
              [-155.0432022779999, 71.13092682500007],
              [-155.0456436839999, 71.12177155200004],
              [-155.05247962099992, 71.11261627800008],
              [-155.05646725199992, 71.09979889500005],
              [-155.05304928299992, 71.08771393400008],
              [-155.0397843089999, 71.06305573100008],
              [-155.03937740799992, 71.05573151200008],
              [-155.05443274599992, 71.04523346600007],
              [-155.08674068899992, 71.03115469000005],
              [-155.09740149599992, 71.01727936400005],
              [-155.06501217399992, 71.01211172100005],
              [-155.03901119699992, 71.01740143400008],
              [-155.0217179029999, 71.03229401200008],
              [-155.0135391919999, 71.06411367400005],
              [-155.00458736899992, 71.08348216400003],
              [-155.0018204419999, 71.09296295800004],
              [-155.00544186099992, 71.10716380400004],
              [-155.0128067699999, 71.11334870000007],
              [-155.0110977859999, 71.11591217700004],
              [-154.98753821499992, 71.11969635600008],
              [-154.9716690749999, 71.12006256700005],
              [-154.9189346999999, 71.11347077000005],
              [-154.9068497389999, 71.10716380400004],
              [-154.89427649599992, 71.09520091400003],
              [-154.87958736899992, 71.08820221600007],
              [-154.86091061099992, 71.09638092700004],
              [-154.83995520699992, 71.10126373900005],
              [-154.80817623599992, 71.09593333500004],
              [-154.7752579419999, 71.08397044500003],
              [-154.72581946499992, 71.05512116100005],
              [-154.6312149729999, 71.03156159100007],
              [-154.6081436839999, 71.02098216400003],
              [-154.60016842399992, 71.01288483300004],
              [-154.59711666599992, 71.00047435100004],
              [-154.60199947799993, 70.99213288000004],
              [-154.6132706369999, 70.98163483300004],
              [-154.62584387899992, 70.97260163000004],
              [-154.64325924399992, 70.96572500200006],
              [-154.6472061839999, 70.95819733300004],
              [-154.6491593089999, 70.94936758000006],
              [-154.6517227859999, 70.94212474200003],
              [-154.6624649729999, 70.92552317900004],
              [-154.6682022779999, 70.92059967700004],
              [-154.6796768869999, 70.91425202000005],
              [-154.7128800119999, 70.90558502800008],
              [-154.78868567599991, 70.89630768400008],
              [-154.81000729099992, 70.88068268400008],
              [-154.6998184889999, 70.88621653900003],
              [-154.67597408799992, 70.87693919500003],
              [-154.66771399599992, 70.87152741100005],
              [-154.6312149729999, 70.85276927300004],
              [-154.63031979099992, 70.84886302300004],
              [-154.63215084499993, 70.83624909100007],
              [-154.6312149729999, 70.83226146000004],
              [-154.59028072799993, 70.82542552300004],
              [-154.53880774599992, 70.82615794500003],
              [-154.43517005099991, 70.83926015800006],
              [-154.38422604099992, 70.83974844000005],
              [-154.30907141799992, 70.83079661700003],
              [-154.27082271999993, 70.81903717700004],
              [-154.24767005099991, 70.79877350500004],
              [-154.25670325399992, 70.78912995000007],
              [-154.24787350199992, 70.78241608300004],
              [-154.2303360669999, 70.77838776200008],
              [-154.21357174399992, 70.77704498900005],
              [-154.1717423169999, 70.78164297100005],
              [-154.13097083199992, 70.79132721600007],
              [-154.0421036449999, 70.83364492400005],
              [-153.9853409499999, 70.84690989800004],
              [-153.94013424399992, 70.88190338700008],
              [-153.9186905589999, 70.89435455900008],
              [-153.89354594699992, 70.89838266100008],
              [-153.5140274729999, 70.88690827000005],
              [-153.44896399599992, 70.89948151200008],
              [-153.37983150899993, 70.90009186400005],
              [-153.3568009109999, 70.90277741100005],
              [-153.30243893099993, 70.92865631700005],
              [-153.25568600199992, 70.93276601800005],
              [-153.16486568899992, 70.92788320500006],
              [-153.1487930979999, 70.92475006700005],
              [-153.13117428299992, 70.91111888200004],
              [-153.1170548169999, 70.90802643400008],
              [-153.10688229099992, 70.90692780200004],
              [-153.08674068899992, 70.90228913000004],
              [-153.07579505099991, 70.90119049700007],
              [-153.06952877499992, 70.90302155200004],
              [-153.05268307199992, 70.91152578300006],
              [-153.04169674399992, 70.91425202000005],
              [-152.9556778639999, 70.90802643400008],
              [-152.94269771999993, 70.90338776200008],
              [-152.93525143099993, 70.89256419500003],
              [-152.92853756399992, 70.87995026200008],
              [-152.91755123599992, 70.86981842700004],
              [-152.90314693899992, 70.86395905200004],
              [-152.88459225199992, 70.85907623900005],
              [-152.8655899729999, 70.85700104400007],
              [-152.8498429029999, 70.85960521000004],
              [-152.84064693899992, 70.86806875200006],
              [-152.83820553299992, 70.87742747600004],
              [-152.83307857999992, 70.88471100500004],
              [-152.81574459499993, 70.88690827000005],
              [-152.80781002499992, 70.88385651200008],
              [-152.79902096299992, 70.87718333500004],
              [-152.78441321499992, 70.86298248900005],
              [-152.7737930979999, 70.85565827000005],
              [-152.74701900899993, 70.84345123900005],
              [-152.71491451699993, 70.82103099200003],
              [-152.69688880099991, 70.82119375200006],
              [-152.65746008999992, 70.84593333500004],
              [-152.67308508999992, 70.86664459800005],
              [-152.6940811839999, 70.87693919500003],
              [-152.7191055979999, 70.88035716400003],
              [-152.7468155589999, 70.88068268400008],
              [-152.71251380099991, 70.89036692900004],
              [-152.54584713399993, 70.88751862200007],
              [-152.3275040359999, 70.85687897300005],
              [-152.21922766799992, 70.81801992400005],
              [-152.21922766799992, 70.81244538000004],
              [-152.2741593089999, 70.79999420800004],
              [-152.37547766799992, 70.74925364800004],
              [-152.43089758999992, 70.74355703300006],
              [-152.43089758999992, 70.73602936400005],
              [-152.41523189999992, 70.73114655200004],
              [-152.41340084499993, 70.72211334800005],
              [-152.42133541599992, 70.71332428600005],
              [-152.43464107999992, 70.70937734600005],
              [-152.47777258999992, 70.70551178600005],
              [-152.50084387899992, 70.69920482000003],
              [-152.51410885299993, 70.68891022300005],
              [-152.5091446609999, 70.66388580900008],
              [-152.48216712099992, 70.64179108300004],
              [-152.44794674399992, 70.62604401200008],
              [-152.2534073559999, 70.59951406500005],
              [-152.15522213399993, 70.60321686400005],
              [-152.10383053299992, 70.59878164300005],
              [-152.07526607999992, 70.57904694200005],
              [-152.10753333199992, 70.57493724200003],
              [-152.1667374339999, 70.58258698100008],
              [-152.4173477859999, 70.58673737200007],
              [-152.45673580599993, 70.58173248900005],
              [-152.51720130099991, 70.59271881700005],
              [-152.54499264199993, 70.59015534100007],
              [-152.58055579299992, 70.58295319200005],
              [-152.61274166599992, 70.57221100500004],
              [-152.63011633999992, 70.55853913000004],
              [-152.61803137899992, 70.55581289300005],
              [-152.58576412699992, 70.55853913000004],
              [-152.5726212229999, 70.55670807500007],
              [-152.54731197799993, 70.54779694200005],
              [-152.5345352859999, 70.54486725500004],
              [-152.50755774599992, 70.54531484600005],
              [-152.4561661449999, 70.55585358300004],
              [-151.9691055979999, 70.57160065300008],
              [-151.84870357999992, 70.55853913000004],
              [-151.7603653639999, 70.56671784100007],
              [-151.73326575399992, 70.55853913000004],
              [-151.7487686839999, 70.55499909100007],
              [-151.76146399599992, 70.54816315300008],
              [-151.7841690749999, 70.52753327000005],
              [-151.80321204299992, 70.51874420800004],
              [-151.8476456369999, 70.52301666900007],
              [-151.86982174399992, 70.51764557500007],
              [-151.84784908799992, 70.50975169500003],
              [-151.7903946609999, 70.50238678600005],
              [-151.88630123599992, 70.49286530200004],
              [-151.94330807199992, 70.48045482000003],
              [-151.97968502499992, 70.44871653900003],
              [-151.73643958199992, 70.43561432500007],
              [-151.45417232999992, 70.43895091400003],
              [-151.40782630099991, 70.42690664300005],
              [-151.35248775899993, 70.42641836100006],
              [-151.33165442599991, 70.41795482000003],
              [-151.31586666599992, 70.40912506700005],
              [-151.27875729099992, 70.39972565300008],
              [-151.24360104099992, 70.37929922100005],
              [-151.22227942599991, 70.37571849200003],
              [-151.1771134109999, 70.37978750200006],
              [-151.1771134109999, 70.38719310100004],
              [-151.19904537699992, 70.40180084800005],
              [-151.20881100199992, 70.42243073100008],
              [-151.20295162699992, 70.44074127800008],
              [-151.1777237619999, 70.44871653900003],
              [-150.9791153639999, 70.45612213700008],
              [-150.9728897779999, 70.45840078300006],
              [-150.95909583199992, 70.46718984600005],
              [-150.9511612619999, 70.46979401200008],
              [-150.8624161449999, 70.46979401200008],
              [-150.85492916599992, 70.47247955900008],
              [-150.84089107999992, 70.48069896000004],
              [-150.8350723949999, 70.48285553600005],
              [-150.8124893869999, 70.48114655200004],
              [-150.76569576699993, 70.47223541900007],
              [-150.7451065749999, 70.47662995000007],
              [-150.7737930979999, 70.48493073100008],
              [-150.7861221999999, 70.49225495000007],
              [-150.79352779899992, 70.50332265800006],
              [-150.61908932199992, 70.51072825700004],
              [-150.60899817599991, 70.50967031500005],
              [-150.5900772779999, 70.50458405200004],
              [-150.58124752499992, 70.50332265800006],
              [-150.5673721999999, 70.50503164300005],
              [-150.54023189999992, 70.51146067900004],
              [-150.52660071499992, 70.51072825700004],
              [-150.51313229099992, 70.50389232000003],
              [-150.50702877499992, 70.49437083500004],
              [-150.50226803299992, 70.48456452000005],
              [-150.49250240799992, 70.47662995000007],
              [-150.46410071499992, 70.47992584800005],
              [-150.41999264199993, 70.49192942900004],
              [-150.37938391799992, 70.49701569200005],
              [-150.36152096299992, 70.47972239800004],
              [-150.36908932199992, 70.46735260600008],
              [-150.4167374339999, 70.42137278900003],
              [-150.4167374339999, 70.41453685100004],
              [-150.3837784499999, 70.41608307500007],
              [-150.2530411449999, 70.44208405200004],
              [-150.1191300119999, 70.44285716400003],
              [-149.88971920499992, 70.51276276200008],
              [-149.8686417309999, 70.51203034100007],
              [-149.8116348949999, 70.49616120000007],
              [-149.78461666599992, 70.49799225500004],
              [-149.72472083199992, 70.51072825700004],
              [-149.56708736899992, 70.51072825700004],
              [-149.51435299399992, 70.52277252800008],
              [-149.4885147779999, 70.52301666900007],
              [-149.4639786449999, 70.51072825700004],
              [-149.46959387899992, 70.50405508000006],
              [-149.47581946499992, 70.49990469000005],
              [-149.48298092399992, 70.49778880400004],
              [-149.4913223949999, 70.49705638200004],
              [-149.3837784499999, 70.48818594000005],
              [-149.3541153639999, 70.49705638200004],
              [-149.36839758999992, 70.50332265800006],
              [-149.3444718089999, 70.51007721600007],
              [-149.04450436099992, 70.46857330900008],
              [-149.0158585279999, 70.45966217700004],
              [-148.99229895699992, 70.44871653900003],
              [-148.97944088399993, 70.43952057500007],
              [-148.9721573559999, 70.43305084800005],
              [-148.96454830599993, 70.42926666900007],
              [-148.9506729809999, 70.42820872600004],
              [-148.9174698559999, 70.44061920800004],
              [-148.90290279899992, 70.44183991100005],
              [-148.82551021999993, 70.41828034100007],
              [-148.79584713399993, 70.41453685100004],
              [-148.72101803299992, 70.42202383000006],
              [-148.68244381399992, 70.42011139500005],
              [-148.65278072799993, 70.40436432500007],
              [-148.64106197799993, 70.39972565300008],
              [-148.58698482999992, 70.39411041900007],
              [-148.5513809889999, 70.38410065300008],
              [-148.5181778639999, 70.36920807500007],
              [-148.5041397779999, 70.35639069200005],
              [-148.5009659499999, 70.33991120000007],
              [-148.51183020699992, 70.31834544500003],
              [-148.38141842399992, 70.31248607000003],
              [-148.3405655589999, 70.31834544500003],
              [-148.25739498599992, 70.35447825700004],
              [-148.2232559889999, 70.35932038000004],
              [-148.1507462229999, 70.35643138200004],
              [-148.11896725199992, 70.34833405200004],
              [-148.0648087229999, 70.31883372600004],
              [-148.0530899729999, 70.31468333500004],
              [-148.0389298169999, 70.31216054900005],
              [-148.02318274599992, 70.31317780200004],
              [-148.0085343089999, 70.31683991100005],
              [-147.99372311099992, 70.31810130400004],
              [-147.9774470689999, 70.31216054900005],
              [-147.9842830069999, 70.30467357000003],
              [-147.96222896999993, 70.30141836100006],
              [-147.8880509109999, 70.31216054900005],
              [-147.86587480399993, 70.31122467700004],
              [-147.8427628249999, 70.30752187700006],
              [-147.81993567599991, 70.30068594000005],
              [-147.7986954419999, 70.29043203300006],
              [-147.80679277299993, 70.28636302300004],
              [-147.8118790359999, 70.28188711100006],
              [-147.8198136059999, 70.26992422100005],
              [-147.8104141919999, 70.26805247600004],
              [-147.80162512899992, 70.26528554900005],
              [-147.7933650379999, 70.26146067900004],
              [-147.78571529899992, 70.25690338700008],
              [-147.79401607999992, 70.24603913000004],
              [-147.79889889199993, 70.24091217700004],
              [-147.8061417309999, 70.23647695500006],
              [-147.78278561099992, 70.22793203300006],
              [-147.6795955069999, 70.21222565300008],
              [-147.41649329299992, 70.20229726800005],
              [-147.23696855399993, 70.18121979400007],
              [-147.2314346999999, 70.18178945500006],
              [-147.22150631399992, 70.18773021000004],
              [-147.21711178299992, 70.18866608300004],
              [-147.2115372389999, 70.18585846600007],
              [-147.20091712099992, 70.17739492400005],
              [-147.1960343089999, 70.17495351800005],
              [-147.12368730399993, 70.16754791900007],
              [-146.88068600199992, 70.17495351800005],
              [-146.8768204419999, 70.19017161700003],
              [-146.8487849599999, 70.19342682500007],
              [-146.7411189439999, 70.19232819200005],
              [-146.4332576159999, 70.18244049700007],
              [-146.23058020699992, 70.18602122600004],
              [-146.0826309889999, 70.15566640800006],
              [-145.9831436839999, 70.15387604400007],
              [-145.9677628249999, 70.15692780200004],
              [-145.94001217399992, 70.16616445500006],
              [-145.92857825399992, 70.16754791900007],
              [-145.88914954299992, 70.15241120000007],
              [-145.87267005099991, 70.15281810100004],
              [-145.88019771999993, 70.17495351800005],
              [-145.8404434889999, 70.16742584800005],
              [-145.77122962099992, 70.13410065300008],
              [-145.7132869129999, 70.12319570500006],
              [-145.65485592399992, 70.09857819200005],
              [-145.6131892569999, 70.08881256700005],
              [-145.59968014199993, 70.08075592700004],
              [-145.6138809889999, 70.07135651200008],
              [-145.59780839799993, 70.07135651200008],
              [-145.58771725199992, 70.07526276200008],
              [-145.57233639199993, 70.08559804900005],
              [-145.5582576159999, 70.09048086100006],
              [-145.5474747389999, 70.09235260600008],
              [-145.5204971999999, 70.09243398600006],
              [-145.5009659499999, 70.08600495000007],
              [-145.47118079299992, 70.05780670800004],
              [-145.45563717399992, 70.05145905200004],
              [-145.4269099599999, 70.04816315300008],
              [-145.3685196609999, 70.03363678600005],
              [-145.3392227859999, 70.03034088700008],
              [-145.21540279899992, 70.04401276200008],
              [-145.21540279899992, 70.03717682500007],
              [-145.23615475199992, 70.03070709800005],
              [-145.3013809889999, 69.99966054900005],
              [-145.2748917309999, 69.99306875200006],
              [-145.15392005099991, 70.00307851800005],
              [-144.94155839799993, 69.97797272300005],
              [-144.88646399599992, 69.99526601800005],
              [-144.87157141799992, 69.99799225500004],
              [-144.8251033189999, 69.98647695500006],
              [-144.70645097599993, 69.97601959800005],
              [-144.59015865799992, 69.98281484600005],
              [-144.56493079299992, 69.98940664300005],
              [-144.5092667309999, 70.01996491100005],
              [-144.38613847599993, 70.04401276200008],
              [-144.18691972599993, 70.04360586100006],
              [-144.1545304029999, 70.04840729400007],
              [-144.14037024599992, 70.06134674700007],
              [-144.12954667899993, 70.06769440300008],
              [-144.1051326159999, 70.06439850500004],
              [-144.0792537099999, 70.05536530200004],
              [-144.06403561099992, 70.04401276200008],
              [-144.0693253249999, 70.03628164300005],
              [-144.07111568899992, 70.03046295800004],
              [-144.0693253249999, 70.02460358300004],
              [-144.06403561099992, 70.01675039300005],
              [-144.06891842399992, 70.00991445500006],
              [-144.07042395699992, 70.00405508000006],
              [-144.0714412099999, 69.98940664300005],
              [-144.05711829299992, 69.99848053600005],
              [-144.04328365799992, 70.01512278900003],
              [-144.02306067599991, 70.05145905200004],
              [-144.04735266799992, 70.06476471600007],
              [-144.05719967399992, 70.07343170800004],
              [-144.06403561099992, 70.08559804900005],
              [-144.0174454419999, 70.09259674700007],
              [-144.0025528639999, 70.08901601800005],
              [-143.9827367829999, 70.07880280200004],
              [-143.97545325399994, 70.07786692900004],
              [-143.96263587099992, 70.07908763200004],
              [-143.95474199099993, 70.07880280200004],
              [-143.93101966099994, 70.07103099200003],
              [-143.9189346999999, 70.07135651200008],
              [-143.91380774599992, 70.08218008000006],
              [-143.9055883449999, 70.08860911700003],
              [-143.8865453769999, 70.08917877800008],
              [-143.85171464799993, 70.08559804900005],
              [-143.82485917899993, 70.08930084800005],
              [-143.7705785799999, 70.10443756700005],
              [-143.7425024079999, 70.10602448100008],
              [-143.6940811839999, 70.09243398600006],
              [-143.6743871739999, 70.09039948100008],
              [-143.57652747299994, 70.09393952000005],
              [-143.56436113199993, 70.09857819200005],
              [-143.56045488199993, 70.10687897300005],
              [-143.5639542309999, 70.11595286700003],
              [-143.56419837099992, 70.12335846600007],
              [-143.55068925699993, 70.12661367400005],
              [-143.54552161399994, 70.12303294500003],
              [-143.5261938139999, 70.10236237200007],
              [-143.5105688139999, 70.09666575700004],
              [-143.3581436839999, 70.10614655200004],
              [-143.35411536399994, 70.10561758000006],
              [-143.3525284499999, 70.10187409100007],
              [-143.31676184799994, 70.05565013200004],
              [-143.29751542899993, 70.04340241100005],
              [-143.2763565749999, 70.05145905200004],
              [-143.28990637899994, 70.06313711100006],
              [-143.30247962099992, 70.07941315300008],
              [-143.30797278599994, 70.09804922100005],
              [-143.3002823559999, 70.11664459800005],
              [-143.27708899599992, 70.12099844000005],
              [-143.2356664699999, 70.11823151200008],
              [-143.16649329299992, 70.10602448100008],
              [-143.1546117829999, 70.10008372600004],
              [-143.14468339799993, 70.09369538000004],
              [-143.1337784499999, 70.08836497600004],
              [-143.1187231109999, 70.08559804900005],
              [-143.03648841099994, 70.09243398600006],
              [-143.02306067599994, 70.08982982000003],
              [-143.01353919199994, 70.08348216400003],
              [-142.99889075399994, 70.06826406500005],
              [-142.98412024599992, 70.06293366100005],
              [-142.9636124339999, 70.06264883000006],
              [-142.94273841099994, 70.06598541900007],
              [-142.92690995999993, 70.07135651200008],
              [-142.93374589799993, 70.07880280200004],
              [-142.87954667899993, 70.07404205900008],
              [-142.65074622299994, 70.01902903900003],
              [-142.60081946499992, 70.01312897300005],
              [-142.59609941299993, 70.00389232000003],
              [-142.6116430329999, 69.97573476800005],
              [-142.5976456369999, 69.97150299700007],
              [-142.58177649599992, 69.96991608300004],
              [-142.56631425699993, 69.97223541900007],
              [-142.55386308499993, 69.97943756700005],
              [-142.53848222599993, 69.98501211100006],
              [-142.51817786399994, 69.98187897300005],
              [-142.4812719389999, 69.96954987200007],
              [-142.49160722599993, 69.97256094000005],
              [-142.5020645819999, 69.97353750200006],
              [-142.51256262899994, 69.97256094000005],
              [-142.52281653599994, 69.96954987200007],
              [-142.4968969389999, 69.95384349200003],
              [-142.4378149079999, 69.94896067900004],
              [-142.41295325399994, 69.93475983300004],
              [-142.41856848899994, 69.93146393400008],
              [-142.42105058499993, 69.92820872600004],
              [-142.42275956899994, 69.92475006700005],
              [-142.4260147779999, 69.92047760600008],
              [-142.3974503249999, 69.92096588700008],
              [-142.3841039699999, 69.91933828300006],
              [-142.3714086579999, 69.91425202000005],
              [-142.37743079299992, 69.90493398600006],
              [-142.37612870999993, 69.89915599200003],
              [-142.36949622299994, 69.89545319200005],
              [-142.3438614569999, 69.88849518400008],
              [-142.33336341099994, 69.88776276200008],
              [-142.3242895169999, 69.88523997600004],
              [-142.2936905589999, 69.86310455900008],
              [-142.27090410099993, 69.85602448100008],
              [-142.10732988199993, 69.84894440300008],
              [-142.04946855399993, 69.83486562700006],
              [-142.04238847599993, 69.80438873900005],
              [-142.0151261059999, 69.79629140800006],
              [-141.98818925699993, 69.79266998900005],
              [-141.9636938139999, 69.79572174700007],
              [-141.9434301419999, 69.80780670800004],
              [-141.92056230399993, 69.81537506700005],
              [-141.8911840489999, 69.80882396000004],
              [-141.83702551999994, 69.79075755400004],
              [-141.6533096999999, 69.76215241100005],
              [-141.5738012359999, 69.73016998900005],
              [-141.5247289699999, 69.71808502800008],
              [-141.50121008999992, 69.70880768400008],
              [-141.48412024599992, 69.69757721600007],
              [-141.44033769399994, 69.66107819200005],
              [-141.4129125639999, 69.65037669500003],
              [-141.2910863919999, 69.63401927300004],
              [-141.26724199099993, 69.64451732000003],
              [-141.24624589799993, 69.66095612200007],
              [-141.22061113199993, 69.67405833500004],
              [-141.2480362619999, 69.68089427300004],
              [-141.26793372299994, 69.68211497600004],
              [-141.29149329299992, 69.68585846600007],
              [-141.3162328769999, 69.68773021000004],
              [-141.3162328769999, 69.69452545800004],
              [-141.0152074859999, 69.65420156500005],
              [-141.00645911399994, 69.65127187700006],
              [-141.00556393099993, 69.65094635600008],
            ],
          ],
          [
            [
              [-123.09050609499992, 48.992514547000084],
              [-123.03530839799993, 48.99249909100007],
              [-123.04527747299994, 48.984361070000034],
              [-123.08849036399994, 48.97223541900007],
              [-123.08934485599991, 48.987982489000046],
              [-123.09050609499992, 48.992514547000084],
            ],
          ],
          [
            [
              [-73.9333796869999, 40.79718659100007],
              [-73.9464247059999, 40.777234373000056],
              [-73.97221905799995, 40.740679303000036],
              [-73.97229342899993, 40.72720272100008],
              [-73.97580563699995, 40.714012798000056],
              [-74.0022273429999, 40.70404694200005],
              [-74.0169164699999, 40.699286200000074],
              [-74.01197714499995, 40.73003812700006],
              [-74.00315549699991, 40.75587118900006],
              [-73.98696855399993, 40.77871328300006],
              [-73.93915768099993, 40.85423411700009],
              [-73.93281002499992, 40.868841864000046],
              [-73.92804928299995, 40.87750885600008],
              [-73.91795813699991, 40.875067450000074],
              [-73.91665605399993, 40.863348700000074],
              [-73.92967688699991, 40.843817450000074],
              [-73.9387914699999, 40.828192450000074],
              [-73.94009355399993, 40.81386953300006],
              [-73.9333796869999, 40.79718659100007],
            ],
          ],
          [
            [
              [-71.31509355399993, 41.58079661700003],
              [-71.33071855399993, 41.57558828300006],
              [-71.3372289699999, 41.582098700000074],
              [-71.3372289699999, 41.59251536700003],
              [-71.33071855399993, 41.61074453300006],
              [-71.33592688699991, 41.62636953300006],
              [-71.3567602199999, 41.63157786700003],
              [-71.35936438699991, 41.64199453300006],
              [-71.35545813699991, 41.660223700000074],
              [-71.34373938699991, 41.67064036700003],
              [-71.33592688699991, 41.65761953300006],
              [-71.33071855399993, 41.64720286700003],
              [-71.3176977199999, 41.632879950000074],
              [-71.30337480399993, 41.62636953300006],
              [-71.30467688699991, 41.60423411700003],
              [-71.31509355399993, 41.58079661700003],
            ],
          ],
          [
            [
              [-69.66405188699991, 43.789129950000074],
              [-69.6848852199999, 43.81126536700003],
              [-69.6887914699999, 43.828192450000074],
              [-69.6731664699999, 43.85293203300006],
              [-69.64712480399993, 43.83730703300006],
              [-69.64842688699991, 43.81907786700003],
              [-69.65233313699991, 43.79043203300006],
              [-69.66405188699991, 43.789129950000074],
            ],
          ],
          [
            [
              [-69.6692602199999, 43.95579661700003],
              [-69.6692602199999, 43.94277578300006],
              [-69.6809789699999, 43.933661200000074],
              [-69.69009355399993, 43.90501536700003],
              [-69.69012421999992, 43.90486311700005],
              [-69.69016189799993, 43.904677304000074],
              [-69.69021388699991, 43.90442236700005],
              [-69.69027975199992, 43.90410130400005],
              [-69.69035905399994, 43.90371711700004],
              [-69.69045135599993, 43.90327280400004],
              [-69.6905562199999, 43.90277136700007],
              [-69.69067320999994, 43.902215804000036],
              [-69.6908018869999, 43.90160911700008],
              [-69.69094181399993, 43.90095430400004],
              [-69.69109255399991, 43.90025436700006],
              [-69.69125366799994, 43.89951230400004],
              [-69.69142471999993, 43.89873111700007],
              [-69.69160527299994, 43.89791380400004],
              [-69.6917948869999, 43.897063367000044],
              [-69.69199312699993, 43.896182804000034],
              [-69.6921995539999, 43.89527511700004],
              [-69.69241373099993, 43.894343304000074],
              [-69.69263521999994, 43.89339036700005],
              [-69.69286358499994, 43.89241930400004],
              [-69.6930983869999, 43.891433117000076],
              [-69.69333918899991, 43.89043480400005],
              [-69.69358555399992, 43.88942736700005],
              [-69.69383704299992, 43.88841380400004],
              [-69.6940932199999, 43.887397117000035],
              [-69.69435364799995, 43.886380304000056],
              [-69.69461788699994, 43.885366367000074],
              [-69.69488550199992, 43.884358304000045],
              [-69.69515605399994, 43.883359117000055],
              [-69.69542910599995, 43.88237180400006],
              [-69.69570421999993, 43.881399367000085],
              [-69.69598095999993, 43.880444804000035],
              [-69.69625888699994, 43.87951111700005],
              [-69.69653756399993, 43.878601304000085],
              [-69.69681655399995, 43.87771836700006],
              [-69.69709541799995, 43.876865304000034],
              [-69.69737371999992, 43.87604511700005],
              [-69.69765102299993, 43.87526080400005],
              [-69.69792688699994, 43.87451536700007],
              [-69.69820087699992, 43.87381180400007],
              [-69.69847255399992, 43.87315311700007],
              [-69.6987414809999, 43.872542304000035],
              [-69.69900721999994, 43.871982367000044],
              [-69.69926933499994, 43.871476304000055],
              [-69.69952738699993, 43.87102711700004],
              [-69.69978093899994, 43.87063780400007],
              [-69.70002955399991, 43.870311367000056],
              [-69.70027279299995, 43.87005080400007],
              [-69.7005102199999, 43.86985911700003],
              [-69.70100913699991, 43.869522450000034],
              [-69.70128000199992, 43.86933692900004],
              [-69.7015640539999, 43.869140783000034],
              [-69.70186048099993, 43.86893463700005],
              [-69.70216846999995, 43.86871911700007],
              [-69.7024872099999, 43.86849484600003],
              [-69.70281588699993, 43.86826245000009],
              [-69.70315368899992, 43.86802255400005],
              [-69.70349980399993, 43.86777578300007],
              [-69.70385341799994, 43.86752276200008],
              [-69.70421371999993, 43.86726411700005],
              [-69.7045798979999, 43.86700047100004],
              [-69.70495113699991, 43.866732450000086],
              [-69.70532662699992, 43.866460679000056],
              [-69.7057055539999, 43.86618578300005],
              [-69.70608710599993, 43.86590838700005],
              [-69.70647046999994, 43.86562911700008],
              [-69.70685483499994, 43.86534859600005],
              [-69.7072393869999, 43.86506745000008],
              [-69.70762331399993, 43.86478630400006],
              [-69.70800580399992, 43.864505783000084],
              [-69.7083860429999, 43.86422651200007],
              [-69.70876321999992, 43.86394911700006],
              [-69.70913652299993, 43.86367422100005],
              [-69.70950513699995, 43.86340245000008],
              [-69.70986825199992, 43.86313442900007],
              [-69.71022505399992, 43.86287078300006],
              [-69.71057473099995, 43.86261213700004],
              [-69.71091646999992, 43.86235911700004],
              [-69.71124945999992, 43.86211234600006],
              [-69.71157288699993, 43.86187245000008],
              [-69.7118859389999, 43.86164005400008],
              [-69.71218780399994, 43.86141578300004],
              [-69.7124776679999, 43.86120026200007],
              [-69.71275471999991, 43.860994117000075],
              [-69.71301814799995, 43.86079797100007],
              [-69.71326713699995, 43.860612450000076],
              [-69.71350087699994, 43.860438179000084],
              [-69.71371855399991, 43.86027578300008],
              [-69.7139193559999, 43.86012588700004],
              [-69.71410246999994, 43.859989117000055],
              [-69.7142670849999, 43.859866096000076],
              [-69.71441238699992, 43.859757450000075],
              [-69.7145375639999, 43.859663804000036],
              [-69.71464180399994, 43.85958578300006],
              [-69.7147242929999, 43.859524012000065],
              [-69.71483313699991, 43.859442450000074],
              [-69.72134355399993, 43.87246328300006],
              [-69.73045813699991, 43.890692450000074],
              [-69.72264563699991, 43.90761953300006],
              [-69.7005102199999, 43.92715078300006],
              [-69.69399980399993, 43.945379950000074],
              [-69.67837480399993, 43.96751536700003],
              [-69.6692602199999, 43.95579661700003],
            ],
          ],
          [
            [
              [-68.6067602199999, 44.08860911700003],
              [-68.60155188699991, 44.070379950000074],
              [-68.5989477199999, 44.046942450000074],
              [-68.60806230399993, 44.023504950000074],
              [-68.6341039699999, 44.01829661700003],
              [-68.65623938699991, 44.01048411700003],
              [-68.66274980399993, 44.019598700000074],
              [-68.66014563699991, 44.03261953300006],
              [-68.6536352199999, 44.05215078300006],
              [-68.65103105399993, 44.06517161700003],
              [-68.64061438699991, 44.078192450000074],
              [-68.6262914699999, 44.09121328300006],
              [-68.6067602199999, 44.08860911700003],
            ],
          ],
          [
            [
              [-68.81118730399993, 44.148504950000074],
              [-68.82420813699991, 44.144598700000074],
              [-68.8411352199999, 44.13808828300006],
              [-68.85155188699991, 44.125067450000074],
              [-68.86327063699991, 44.11985911700003],
              [-68.8880102199999, 44.13027578300006],
              [-68.90103105399993, 44.13418203300006],
              [-68.9192602199999, 44.125067450000074],
              [-68.93748938699991, 44.105536200000074],
              [-68.9426977199999, 44.117254950000074],
              [-68.94009355399993, 44.125067450000074],
              [-68.92837480399993, 44.14199453300006],
              [-68.88931230399993, 44.164129950000074],
              [-68.8567602199999, 44.18105703300006],
              [-68.82030188699991, 44.17845286700003],
              [-68.81118730399993, 44.16933828300006],
              [-68.81118730399993, 44.148504950000074],
            ],
          ],
          [
            [
              [-68.39061438699991, 44.16282786700003],
              [-68.3919164699999, 44.14590078300006],
              [-68.4036352199999, 44.13418203300006],
              [-68.43228105399993, 44.128973700000074],
              [-68.4426977199999, 44.144598700000074],
              [-68.4544164699999, 44.15110911700003],
              [-68.46353105399993, 44.14980703300006],
              [-68.4895727199999, 44.140692450000074],
              [-68.50259355399993, 44.148504950000074],
              [-68.50649980399993, 44.160223700000074],
              [-68.49217688699991, 44.16933828300006],
              [-68.47524980399993, 44.16673411700003],
              [-68.47264563699991, 44.17715078300006],
              [-68.45962480399993, 44.18496328300006],
              [-68.44399980399993, 44.18105703300006],
              [-68.4387914699999, 44.17454661700003],
              [-68.4270727199999, 44.175848700000074],
              [-68.41665605399993, 44.18235911700003],
              [-68.40233313699991, 44.175848700000074],
              [-68.39061438699991, 44.16282786700003],
            ],
          ],
          [
            [
              [-68.92056230399993, 44.23704661700003],
              [-68.93358313699991, 44.23574453300006],
              [-68.93358313699991, 44.24355703300006],
              [-68.9270727199999, 44.26699453300006],
              [-68.92446855399993, 44.281317450000074],
              [-68.94139563699991, 44.281317450000074],
              [-68.9426977199999, 44.29043203300006],
              [-68.92446855399993, 44.30735911700003],
              [-68.90103105399993, 44.31126536700003],
              [-68.88540605399993, 44.29954661700003],
              [-68.90103105399993, 44.28001536700003],
              [-68.92056230399993, 44.23704661700003],
            ],
          ],
          [
            [
              [-68.4895727199999, 44.347723700000074],
              [-68.48696855399993, 44.33470286700003],
              [-68.47524980399993, 44.324286200000074],
              [-68.48436438699991, 44.31386953300006],
              [-68.4973852199999, 44.320379950000074],
              [-68.5091039699999, 44.32298411700003],
              [-68.52212480399993, 44.32298411700003],
              [-68.52993730399993, 44.33079661700003],
              [-68.52993730399993, 44.34511953300006],
              [-68.5247289699999, 44.359442450000074],
              [-68.51952063699991, 44.367254950000074],
              [-68.51170813699991, 44.378973700000074],
              [-68.50259355399993, 44.38027578300006],
              [-68.49608313699991, 44.37636953300006],
              [-68.49217688699991, 44.36465078300006],
              [-68.4895727199999, 44.347723700000074],
            ],
          ],
          [
            [
              [-68.8684789699999, 44.38157786700003],
              [-68.85936438699991, 44.35814036700003],
              [-68.8684789699999, 44.347723700000074],
              [-68.88540605399993, 44.33079661700003],
              [-68.9036352199999, 44.31907786700003],
              [-68.91665605399993, 44.332098700000074],
              [-68.91665605399993, 44.34511953300006],
              [-68.9114477199999, 44.36595286700003],
              [-68.8997289699999, 44.37767161700003],
              [-68.8841039699999, 44.39199453300006],
              [-68.8684789699999, 44.38157786700003],
            ],
          ],
          [
            [
              [-67.56639563699991, 44.461004950000074],
              [-67.58462480399993, 44.44407786700003],
              [-67.59373938699991, 44.457098700000074],
              [-67.60545813699991, 44.48314036700003],
              [-67.61587480399993, 44.50527578300006],
              [-67.6145727199999, 44.51439036700003],
              [-67.60024980399993, 44.51829661700003],
              [-67.58202063699991, 44.51439036700003],
              [-67.57811438699991, 44.49095286700003],
              [-67.56639563699991, 44.47923411700003],
              [-67.56639563699991, 44.461004950000074],
            ],
          ],
          [
            [
              [-67.28384355399993, 44.61985911700003],
              [-67.2708227199999, 44.613348700000074],
              [-67.27603105399993, 44.60293203300006],
              [-67.3020727199999, 44.59642161700003],
              [-67.3216039699999, 44.60293203300006],
              [-67.31899980399993, 44.61204661700003],
              [-67.30337480399993, 44.625067450000074],
              [-67.28384355399993, 44.61985911700003],
            ],
          ],
          [
            [
              [-67.04511471299992, 44.92715078300006],
              [-67.04511471299992, 44.94448476800005],
              [-67.03815670499995, 44.95490143400008],
              [-67.02948971299992, 44.94448476800005],
              [-67.0034480459999, 44.92540110900006],
              [-66.98607337099992, 44.90977610900006],
              [-66.9895727199999, 44.89760976800005],
              [-67.01211503799993, 44.89935944200005],
              [-67.01732337099992, 44.90802643400008],
              [-67.04511471299992, 44.92715078300006],
            ],
          ],
          [
            [
              [-132.64769446499992, 54.81785716400003],
              [-132.63711503799993, 54.81403229400007],
              [-132.62637285099993, 54.804754950000074],
              [-132.61758378799993, 54.79344310100004],
              [-132.61290442599994, 54.78375885600008],
              [-132.6162003249999, 54.760199286000045],
              [-132.6360570949999, 54.757473049000055],
              [-132.6616104809999, 54.76788971600007],
              [-132.68179277299993, 54.78375885600008],
              [-132.68468176999994, 54.788763739000046],
              [-132.6892797519999, 54.80182526200008],
              [-132.6923721999999, 54.80731842700004],
              [-132.69835364499994, 54.81167226800005],
              [-132.71349036399994, 54.81708405200004],
              [-132.7197159499999, 54.82127513200004],
              [-132.72256425699993, 54.82656484600005],
              [-132.72740637899994, 54.84039948100008],
              [-132.73021399599992, 54.84454987200007],
              [-132.7363988919999, 54.847316799000055],
              [-132.74990800699993, 54.84918854400007],
              [-132.75755774599992, 54.851996161000045],
              [-132.77196204299992, 54.86225006700005],
              [-132.7769262359999, 54.87006256700005],
              [-132.77977454299992, 54.878241278000075],
              [-132.78823808499993, 54.88959381700005],
              [-132.79405676999994, 54.90192291900007],
              [-132.78880774599992, 54.911037502000056],
              [-132.78237870999993, 54.91889069200005],
              [-132.78482011599993, 54.927720445000034],
              [-132.7780655589999, 54.93455638200004],
              [-132.7730199859999, 54.93024323100008],
              [-132.75755774599992, 54.92031484600005],
              [-132.75055904899995, 54.93109772300005],
              [-132.73814856699994, 54.93537018400008],
              [-132.72350012899994, 54.93724192900004],
              [-132.7097875639999, 54.94082265800006],
              [-132.71373450399994, 54.93305084800005],
              [-132.7197973299999, 54.926947333000044],
              [-132.72744706899994, 54.92267487200007],
              [-132.73643958199995, 54.92031484600005],
              [-132.7259008449999, 54.91486237200007],
              [-132.71524003799993, 54.915228583000044],
              [-132.70498613199993, 54.91986725500004],
              [-132.69546464799993, 54.927720445000034],
              [-132.6855362619999, 54.921128648000035],
              [-132.67430579299992, 54.91681549700007],
              [-132.6651098299999, 54.91193268400008],
              [-132.66136633999992, 54.903550523000035],
              [-132.6558324859999, 54.90216705900008],
              [-132.64317786399994, 54.904730536000045],
              [-132.62930253799993, 54.903998114000046],
              [-132.62035071499992, 54.893011786000045],
              [-132.61534583199995, 54.882473049000055],
              [-132.61693274599992, 54.876166083000044],
              [-132.6237686839999, 54.87482330900008],
              [-132.63463294199994, 54.879339911000045],
              [-132.6355688139999, 54.86749909100007],
              [-132.6306860019999, 54.85626862200007],
              [-132.62857011599993, 54.84784577000005],
              [-132.6377660799999, 54.84454987200007],
              [-132.65176347599993, 54.84638092700004],
              [-132.66323808499993, 54.849310614000046],
              [-132.67491614499994, 54.84983958500004],
              [-132.6892797519999, 54.84454987200007],
              [-132.6756078769999, 54.83738841400003],
              [-132.66930091099994, 54.828558661000045],
              [-132.66266842399995, 54.82103099200003],
              [-132.64769446499992, 54.81785716400003],
            ],
          ],
          [
            [
              [-131.2437231109999, 54.93455638200004],
              [-131.2116593089999, 54.92723216400003],
              [-131.1974991529999, 54.92031484600005],
              [-131.19469153599994, 54.90729401200008],
              [-131.2031957669999, 54.90070221600007],
              [-131.23916581899994, 54.88300202000005],
              [-131.2502335279999, 54.879339911000045],
              [-131.28571529899995, 54.88178131700005],
              [-131.2997940749999, 54.87921784100007],
              [-131.3147680329999, 54.86945221600007],
              [-131.33116614499994, 54.86123281500005],
              [-131.35008704299992, 54.86090729400007],
              [-131.3694555329999, 54.865668036000045],
              [-131.38707434799994, 54.87250397300005],
              [-131.38756262899994, 54.88422272300005],
              [-131.42642167899993, 54.90582916900007],
              [-131.4417211579999, 54.92031484600005],
              [-131.46816972599993, 54.91242096600007],
              [-131.48216712099992, 54.92560455900008],
              [-131.47838294199994, 54.94472890800006],
              [-131.45156816299993, 54.954413153000075],
              [-131.43024654899995, 54.95600006700005],
              [-131.37149003799993, 54.96698639500005],
              [-131.3522843089999, 54.97553131700005],
              [-131.33018958199995, 54.961371161000045],
              [-131.26382402299993, 54.99689362200007],
              [-131.23623613199993, 54.995428778000075],
              [-131.2437231109999, 54.98920319200005],
              [-131.24156653599994, 54.974595445000034],
              [-131.23790442599994, 54.96112702000005],
              [-131.23717200399994, 54.94953034100007],
              [-131.2437231109999, 54.94082265800006],
              [-131.2437231109999, 54.93455638200004],
            ],
          ],
          [
            [
              [-132.8264867829999, 55.054388739000046],
              [-132.82339433499993, 55.06586334800005],
              [-132.81607011599993, 55.07485586100006],
              [-132.80703691299993, 55.081284898000035],
              [-132.7991430329999, 55.08539459800005],
              [-132.81065833199995, 55.090277411000045],
              [-132.8272192049999, 55.094631252000056],
              [-132.85655676999994, 55.09906647300005],
              [-132.86180579299992, 55.104803778000075],
              [-132.86538652299993, 55.11782461100006],
              [-132.8674210279999, 55.13165924700007],
              [-132.86685136599993, 55.14642975500004],
              [-132.8692113919999, 55.153998114000046],
              [-132.8674210279999, 55.16054922100005],
              [-132.8631078769999, 55.16205475500004],
              [-132.85594641799992, 55.16156647300005],
              [-132.84927324099993, 55.163275458000044],
              [-132.84268144399994, 55.17914459800005],
              [-132.83385169199994, 55.18646881700005],
              [-132.82266191299993, 55.19049713700008],
              [-132.81216386599993, 55.18842194200005],
              [-132.79157467399995, 55.173081773000035],
              [-132.74160722599993, 55.14911530200004],
              [-132.72276770699995, 55.13320547100005],
              [-132.6682022779999, 55.05068594000005],
              [-132.6826879549999, 55.034369208000044],
              [-132.7507218089999, 54.995428778000075],
              [-132.75869706899994, 55.00836823100008],
              [-132.76817786399994, 55.018744208000044],
              [-132.79165605399993, 55.036363023000035],
              [-132.79157467399995, 55.01361725500004],
              [-132.8155004549999, 55.015692450000074],
              [-132.87364661399994, 55.036363023000035],
              [-132.8616430329999, 55.04547760600008],
              [-132.8322647779999, 55.048814195000034],
              [-132.8264867829999, 55.054388739000046],
            ],
          ],
          [
            [
              [-132.7029516269999, 54.701239325000074],
              [-132.6712133449999, 54.67731354400007],
              [-132.68687903599994, 54.67397695500006],
              [-132.72427324099993, 54.677435614000046],
              [-132.75755774599992, 54.673895575000074],
              [-132.76821855399993, 54.693019924000055],
              [-132.7937719389999, 54.69806549700007],
              [-132.84288489499994, 54.693793036000045],
              [-132.8435766269999, 54.69830963700008],
              [-132.85293535099993, 54.71914297100005],
              [-132.8635961579999, 54.73452383000006],
              [-132.86384029899995, 54.74160390800006],
              [-132.8561905589999, 54.74469635600008],
              [-132.83946692599994, 54.742173570000034],
              [-132.93805904899995, 54.78774648600006],
              [-132.95616614499994, 54.80365631700005],
              [-132.94351152299993, 54.807074286000045],
              [-132.9256078769999, 54.815334377000056],
              [-132.91100012899994, 54.82640208500004],
              [-132.90835527299993, 54.838324286000045],
              [-132.9217016269999, 54.84520091400003],
              [-132.94225012899994, 54.84202708500004],
              [-132.98037675699993, 54.83152903900003],
              [-132.9987686839999, 54.837958075000074],
              [-133.00706946499992, 54.866115627000056],
              [-133.02135169199994, 54.87250397300005],
              [-133.0370987619999, 54.877386786000045],
              [-133.0491430329999, 54.88890208500004],
              [-133.0515030589999, 54.90249258000006],
              [-133.0380753249999, 54.91351959800005],
              [-133.05329342399995, 54.91779205900008],
              [-133.06871497299994, 54.91974518400008],
              [-133.10073808499993, 54.92031484600005],
              [-133.10073808499993, 54.927720445000034],
              [-133.07583574099993, 54.93219635600008],
              [-133.06371008999992, 54.93573639500005],
              [-133.0585831369999, 54.94082265800006],
              [-133.06456458199995, 54.94708893400008],
              [-133.0783585279999, 54.949286200000074],
              [-133.1070043609999, 54.94818756700005],
              [-133.1328018869999, 54.943345445000034],
              [-133.13906816299993, 54.94525788000004],
              [-133.1479386059999, 54.954413153000075],
              [-133.14419511599993, 54.955511786000045],
              [-133.14126542899993, 54.96308014500005],
              [-133.14346269399994, 54.973089911000045],
              [-133.15477454299992, 54.981756903000075],
              [-133.1348363919999, 54.99750397300005],
              [-133.15347245999993, 55.021185614000046],
              [-133.20323645699995, 55.05805084800005],
              [-133.1992895169999, 55.06525299700007],
              [-133.20372473899994, 55.07514069200005],
              [-133.21129309799994, 55.086818752000056],
              [-133.2168676419999, 55.09906647300005],
              [-133.16836503799993, 55.09638092700004],
              [-133.1206762359999, 55.09906647300005],
              [-133.13931230399993, 55.115668036000045],
              [-133.18936113199993, 55.12173086100006],
              [-133.20323645699995, 55.13320547100005],
              [-133.18211829299992, 55.13320547100005],
              [-133.2168676419999, 55.15371328300006],
              [-133.2057999339999, 55.15582916900007],
              [-133.18211829299992, 55.153225002000056],
              [-133.16844641799992, 55.15371328300006],
              [-133.17764238199993, 55.16429271000004],
              [-133.1870011059999, 55.17202383000006],
              [-133.1992081369999, 55.17560455900008],
              [-133.2168676419999, 55.17413971600007],
              [-133.2168676419999, 55.180975653000075],
              [-133.15477454299992, 55.194647528000075],
              [-133.18887285099993, 55.213771877000056],
              [-133.19399980399993, 55.22223541900007],
              [-133.18211829299992, 55.235581773000035],
              [-133.16612708199995, 55.24310944200005],
              [-133.14346269399994, 55.24884674700007],
              [-133.1214086579999, 55.251288153000075],
              [-133.1070043609999, 55.24868398600006],
              [-133.09654700399994, 55.23309967700004],
              [-133.10220292899993, 55.22028229400007],
              [-133.1042374339999, 55.21157461100006],
              [-133.0828344389999, 55.208319403000075],
              [-133.06676184799994, 55.20091380400004],
              [-133.06224524599992, 55.18382396000004],
              [-133.0654190749999, 55.15029531500005],
              [-133.05589758999992, 55.14411041900007],
              [-133.01113847599993, 55.13231028900003],
              [-132.9971410799999, 55.12571849200003],
              [-132.9948624339999, 55.11928945500006],
              [-132.99307206899994, 55.09979889500005],
              [-132.99087480399993, 55.092230536000045],
              [-132.95616614499994, 55.06427643400008],
              [-132.98485266799992, 55.07599518400008],
              [-133.0193578769999, 55.09723541900007],
              [-133.05483964799993, 55.10895416900007],
              [-133.08653723899994, 55.092230536000045],
              [-132.9971410799999, 55.06427643400008],
              [-132.9971410799999, 55.05805084800005],
              [-133.03258216099994, 55.05027903900003],
              [-133.04552161399994, 55.05068594000005],
              [-133.04552161399994, 55.043850002000056],
              [-133.01406816299993, 55.03457265800006],
              [-132.98306230399993, 55.03204987200007],
              [-132.95759029899995, 55.02334219000005],
              [-132.94249426999994, 54.995428778000075],
              [-132.94176184799994, 54.954413153000075],
              [-132.94249426999994, 54.94818756700005],
              [-132.93276933499993, 54.94550202000005],
              [-132.90664628799993, 54.95136139500005],
              [-132.8941137359999, 54.94818756700005],
              [-132.90151933499993, 54.94082265800006],
              [-132.89395097599993, 54.939154364000046],
              [-132.89110266799992, 54.937567450000074],
              [-132.88727779899995, 54.93455638200004],
              [-132.89244544199994, 54.92951080900008],
              [-132.90151933499993, 54.91351959800005],
              [-132.86046301999994, 54.90033600500004],
              [-132.8438207669999, 54.889105536000045],
              [-132.83946692599994, 54.87250397300005],
              [-132.82457434799994, 54.87518952000005],
              [-132.81501217399995, 54.86758047100005],
              [-132.81436113199993, 54.855454820000034],
              [-132.8264867829999, 54.84454987200007],
              [-132.8128149079999, 54.83999258000006],
              [-132.78453528599994, 54.83685944200005],
              [-132.77122962099992, 54.83152903900003],
              [-132.76260331899994, 54.82444896000004],
              [-132.75869706899994, 54.81818268400008],
              [-132.7559301419999, 54.81159088700008],
              [-132.7507218089999, 54.80365631700005],
              [-132.7224828769999, 54.776556708000044],
              [-132.72520911399994, 54.76740143400008],
              [-132.7507218089999, 54.75641510600008],
              [-132.74388587099992, 54.74900950700004],
              [-132.75108801999994, 54.74701569200005],
              [-132.75381425699993, 54.745428778000075],
              [-132.75755774599992, 54.742173570000034],
              [-132.70543372299994, 54.72882721600007],
              [-132.6883031889999, 54.717962958000044],
              [-132.7029516269999, 54.701239325000074],
            ],
          ],
          [
            [
              [-131.4795629549999, 55.006293036000045],
              [-131.4853409499999, 55.01703522300005],
              [-131.4844457669999, 55.02610911700003],
              [-131.4817602199999, 55.03465403900003],
              [-131.4826554029999, 55.043850002000056],
              [-131.49376380099994, 55.05727773600006],
              [-131.5137426419999, 55.07416413000004],
              [-131.5344945949999, 55.087103583000044],
              [-131.5478409499999, 55.08881256700005],
              [-131.5497940749999, 55.07636139500005],
              [-131.5366918609999, 55.064439195000034],
              [-131.5249731109999, 55.049994208000044],
              [-131.53111731699994, 55.03021881700005],
              [-131.5392960279999, 55.02260976800005],
              [-131.55020097599993, 55.01471588700008],
              [-131.57201087099992, 55.00287506700005],
              [-131.5752660799999, 55.000433661000045],
              [-131.5781143869999, 54.99750397300005],
              [-131.5829971999999, 54.995347398000035],
              [-131.5925186839999, 54.995428778000075],
              [-131.59898841099994, 54.99819570500006],
              [-131.6033422519999, 55.00307851800005],
              [-131.60655676999994, 55.00771719000005],
              [-131.6096085279999, 55.00971100500004],
              [-131.6245011059999, 55.01740143400008],
              [-131.61839758999992, 55.035223700000074],
              [-131.5810440749999, 55.09007396000004],
              [-131.58372962099992, 55.095770575000074],
              [-131.59935462099992, 55.09906647300005],
              [-131.58287512899994, 55.12555573100008],
              [-131.5642797519999, 55.126288153000075],
              [-131.5442602199999, 55.11855703300006],
              [-131.52358964799993, 55.11953359600005],
              [-131.51724199099993, 55.13418203300006],
              [-131.5314835279999, 55.15176015800006],
              [-131.55394446499992, 55.166896877000056],
              [-131.57201087099992, 55.17413971600007],
              [-131.5681860019999, 55.177394924000055],
              [-131.56191972599993, 55.18512604400007],
              [-131.5584203769999, 55.18842194200005],
              [-131.57217363199993, 55.19684479400007],
              [-131.58169511599993, 55.206284898000035],
              [-131.58653723899994, 55.21865469000005],
              [-131.58633378799993, 55.235581773000035],
              [-131.58128821499992, 55.25336334800005],
              [-131.5729874339999, 55.26048411700003],
              [-131.5608617829999, 55.26382070500006],
              [-131.54409745999993, 55.270412502000056],
              [-131.5515844389999, 55.276556708000044],
              [-131.5312393869999, 55.27423737200007],
              [-131.50357011599993, 55.26479726800005],
              [-131.4792374339999, 55.25263092700004],
              [-131.45128333199995, 55.22378164300005],
              [-131.3955785799999, 55.21539948100008],
              [-131.37279212099992, 55.20148346600007],
              [-131.3769425119999, 55.182847398000035],
              [-131.3691300119999, 55.163723049000055],
              [-131.35798092399995, 55.14370351800005],
              [-131.3522843089999, 55.12262604400007],
              [-131.35558020699995, 55.11481354400007],
              [-131.36192786399994, 55.10618724200003],
              [-131.36611894399994, 55.09739817900004],
              [-131.36318925699993, 55.08881256700005],
              [-131.34878495999993, 55.07794830900008],
              [-131.34508216099994, 55.07099030200004],
              [-131.3455297519999, 55.05805084800005],
              [-131.35704505099994, 55.032538153000075],
              [-131.3780004549999, 55.01788971600007],
              [-131.4042862619999, 55.01129791900007],
              [-131.47183183499993, 55.00482819200005],
              [-131.4795629549999, 55.006293036000045],
            ],
          ],
          [
            [
              [-133.29137122299994, 55.262925523000035],
              [-133.28038489499994, 55.282131252000056],
              [-133.25963294199994, 55.28156159100007],
              [-133.23424231699994, 55.27362702000005],
              [-133.20938066299993, 55.270412502000056],
              [-133.2266332669999, 55.25287506700005],
              [-133.23375403599994, 55.242254950000074],
              [-133.24014238199993, 55.220363674000055],
              [-133.24889075399994, 55.216498114000046],
              [-133.27208411399994, 55.21515534100007],
              [-133.30654863199993, 55.203111070000034],
              [-133.31615149599992, 55.20148346600007],
              [-133.3284399079999, 55.20294830900008],
              [-133.33433997299994, 55.20661041900007],
              [-133.3388565749999, 55.21108633000006],
              [-133.34658769399994, 55.21515534100007],
              [-133.3694555329999, 55.221991278000075],
              [-133.38243567599994, 55.22333405200004],
              [-133.3881729809999, 55.21857330900008],
              [-133.39183508999992, 55.20917389500005],
              [-133.40078691299993, 55.20327383000006],
              [-133.41197669199994, 55.20075104400007],
              [-133.42227128799993, 55.20148346600007],
              [-133.4365942049999, 55.211371161000045],
              [-133.4456274079999, 55.22915273600006],
              [-133.44985917899993, 55.25023021000004],
              [-133.44961503799993, 55.270412502000056],
              [-133.43740800699993, 55.26581452000005],
              [-133.42467200399994, 55.26308828300006],
              [-133.4123429029999, 55.26390208500004],
              [-133.40123450399994, 55.270412502000056],
              [-133.43443762899994, 55.28587474200003],
              [-133.44277910099993, 55.29779694200005],
              [-133.43224036399994, 55.314439195000034],
              [-133.4141332669999, 55.31818268400008],
              [-133.3920792309999, 55.31557851800005],
              [-133.37751217399995, 55.31671784100007],
              [-133.38194739499994, 55.33185455900008],
              [-133.36025956899994, 55.332912502000056],
              [-133.33877519399994, 55.33734772300005],
              [-133.31810462099992, 55.339056708000044],
              [-133.29873613199993, 55.33185455900008],
              [-133.28526770699995, 55.31793854400007],
              [-133.29157467399995, 55.300848700000074],
              [-133.31924394399994, 55.270412502000056],
              [-133.29137122299994, 55.262925523000035],
            ],
          ],
          [
            [
              [-131.81847083199995, 55.413763739000046],
              [-131.69652258999992, 55.343451239000046],
              [-131.63609778599994, 55.29930247600004],
              [-131.63345292899993, 55.262925523000035],
              [-131.63857988199993, 55.27594635600008],
              [-131.64635169199994, 55.286810614000046],
              [-131.65713456899994, 55.294256903000075],
              [-131.67129472599993, 55.29706452000005],
              [-131.6753637359999, 55.29120514500005],
              [-131.6682836579999, 55.25608958500004],
              [-131.68614661399994, 55.23029205900008],
              [-131.7117406889999, 55.23663971600007],
              [-131.73949133999992, 55.25071849200003],
              [-131.76382402299993, 55.24868398600006],
              [-131.73721269399994, 55.21784088700008],
              [-131.72085527299993, 55.20307038000004],
              [-131.70238196499992, 55.194647528000075],
              [-131.71275794199994, 55.17747630400004],
              [-131.7265518869999, 55.16632721600007],
              [-131.73330644399994, 55.15570709800005],
              [-131.7228897779999, 55.14008209800005],
              [-131.74331620999993, 55.14272695500006],
              [-131.77196204299992, 55.16791413000004],
              [-131.8049210279999, 55.18113841400003],
              [-131.81777910099993, 55.19798411700003],
              [-131.85317949099993, 55.300482489000046],
              [-131.85313880099994, 55.339544989000046],
              [-131.8570043609999, 55.357407945000034],
              [-131.86685136599993, 55.37278880400004],
              [-131.85094153599994, 55.37335846600007],
              [-131.8457738919999, 55.37278880400004],
              [-131.85195878799993, 55.39484284100007],
              [-131.84951738199993, 55.416083075000074],
              [-131.83836829299992, 55.42593008000006],
              [-131.81847083199995, 55.413763739000046],
            ],
          ],
          [
            [
              [-133.44961503799993, 55.40692780200004],
              [-133.4490453769999, 55.39232005400004],
              [-133.4475805329999, 55.38654205900008],
              [-133.4422094389999, 55.38027578300006],
              [-133.44961503799993, 55.37417226800005],
              [-133.45787512899994, 55.36969635600008],
              [-133.46690833199995, 55.366888739000046],
              [-133.49771074099993, 55.36595286700003],
              [-133.5053604809999, 55.364447333000044],
              [-133.50503495999993, 55.36074453300006],
              [-133.50283769399994, 55.35614655200004],
              [-133.5048721999999, 55.35228099200003],
              [-133.51622473899994, 55.34544505400004],
              [-133.5214737619999, 55.34125397300005],
              [-133.5268448559999, 55.339178778000075],
              [-133.53868567599994, 55.33860911700003],
              [-133.5483292309999, 55.33999258000006],
              [-133.56810462099992, 55.34516022300005],
              [-133.57994544199994, 55.34544505400004],
              [-133.5672094389999, 55.33038971600007],
              [-133.5651749339999, 55.31981028900003],
              [-133.57994544199994, 55.290269273000035],
              [-133.58775794199994, 55.25771719000005],
              [-133.59430904899995, 55.24298737200007],
              [-133.60728919199994, 55.235581773000035],
              [-133.6211645169999, 55.24038320500006],
              [-133.6363012359999, 55.253159898000035],
              [-133.65566972599993, 55.276556708000044],
              [-133.6572973299999, 55.28392161700003],
              [-133.65587317599994, 55.30023834800005],
              [-133.65880286399994, 55.30760325700004],
              [-133.66441809799994, 55.310248114000046],
              [-133.68057206899994, 55.30931224200003],
              [-133.68919837099992, 55.31134674700007],
              [-133.66539466099994, 55.32339101800005],
              [-133.65880286399994, 55.32501862200007],
              [-133.64635169199994, 55.32575104400007],
              [-133.64146887899994, 55.328192450000074],
              [-133.63923092399995, 55.332464911000045],
              [-133.62144934799994, 55.35419342700004],
              [-133.6233617829999, 55.361314195000034],
              [-133.65566972599993, 55.37278880400004],
              [-133.64273027299993, 55.382025458000044],
              [-133.6150610019999, 55.39008209800005],
              [-133.60387122299994, 55.39667389500005],
              [-133.59044348899994, 55.417181708000044],
              [-133.58055579299992, 55.426214911000045],
              [-133.56969153599994, 55.42430247600004],
              [-133.54190019399994, 55.41461823100008],
              [-133.47158769399994, 55.416449286000045],
              [-133.44961503799993, 55.40692780200004],
            ],
          ],
          [
            [
              [-133.5384008449999, 55.48265208500004],
              [-133.5247289699999, 55.49957916900007],
              [-133.51768958199995, 55.514837958000044],
              [-133.50572669199994, 55.52260976800005],
              [-133.47691809799994, 55.516791083000044],
              [-133.43175208199995, 55.496527411000045],
              [-133.42227128799993, 55.489447333000044],
              [-133.41844641799992, 55.47557200700004],
              [-133.42076575399994, 55.45966217700004],
              [-133.42808997299994, 55.446519273000035],
              [-133.43907630099994, 55.441066799000055],
              [-133.4571020169999, 55.43891022300005],
              [-133.49478105399993, 55.42951080900008],
              [-133.51138261599993, 55.427435614000046],
              [-133.5330297519999, 55.430121161000045],
              [-133.60045325399994, 55.44790273600006],
              [-133.58975175699993, 55.46328359600005],
              [-133.5742895169999, 55.46979401200008],
              [-133.55630449099993, 55.47406647300005],
              [-133.5384008449999, 55.48265208500004],
            ],
          ],
          [
            [
              [-133.34658769399994, 55.44790273600006],
              [-133.36058508999992, 55.460638739000046],
              [-133.39500891799992, 55.503119208000044],
              [-133.42398027299993, 55.518011786000045],
              [-133.4331762359999, 55.52798086100006],
              [-133.4285375639999, 55.544134833000044],
              [-133.4136449859999, 55.55320872600004],
              [-133.3906143869999, 55.55719635600008],
              [-133.3244522779999, 55.55695221600007],
              [-133.30479895699995, 55.55320872600004],
              [-133.2874242829999, 55.54507070500006],
              [-133.27208411399994, 55.530462958000044],
              [-133.27196204299992, 55.51194896000004],
              [-133.2734268869999, 55.50031159100007],
              [-133.27904212099992, 55.491848049000055],
              [-133.29137122299994, 55.48265208500004],
              [-133.30915279899995, 55.47483958500004],
              [-133.3244522779999, 55.47117747600004],
              [-133.33702551999994, 55.464544989000046],
              [-133.34658769399994, 55.44790273600006],
            ],
          ],
          [
            [
              [-133.60387122299994, 55.489447333000044],
              [-133.6184789699999, 55.48297760600008],
              [-133.63316809799994, 55.454413153000075],
              [-133.65196692599994, 55.44790273600006],
              [-133.67105058499993, 55.45132070500006],
              [-133.70962480399993, 55.46580638200004],
              [-133.73013261599993, 55.468410549000055],
              [-133.74937903599994, 55.464178778000075],
              [-133.77940833199995, 55.44985586100006],
              [-133.7990616529999, 55.44790273600006],
              [-133.7990616529999, 55.45530833500004],
              [-133.77700761599993, 55.46430084800005],
              [-133.7482804029999, 55.496161200000074],
              [-133.70083574099993, 55.50739166900007],
              [-133.70181230399993, 55.516791083000044],
              [-133.71129309799994, 55.52606842700004],
              [-133.7202042309999, 55.532456773000035],
              [-133.72451738199993, 55.531683661000045],
              [-133.7285050119999, 55.532863674000055],
              [-133.73013261599993, 55.540716864000046],
              [-133.72671464799993, 55.54661692900004],
              [-133.7187393869999, 55.55174388200004],
              [-133.70287024599992, 55.55776601800005],
              [-133.67935136599993, 55.54734935100004],
              [-133.6463110019999, 55.542303778000075],
              [-133.61241614499994, 55.54157135600008],
              [-133.58678137899994, 55.544134833000044],
              [-133.58092200399994, 55.52708567900004],
              [-133.57868404899995, 55.50926341400003],
              [-133.5847061839999, 55.49518463700008],
              [-133.60387122299994, 55.489447333000044],
            ],
          ],
          [
            [
              [-133.3056534499999, 55.79734935100004],
              [-133.3100479809999, 55.78221263200004],
              [-133.3682348299999, 55.75873444200005],
              [-133.3915909499999, 55.746161200000074],
              [-133.41787675699993, 55.73847077000005],
              [-133.44859778599994, 55.75071849200003],
              [-133.4755753249999, 55.77179596600007],
              [-133.49058997299994, 55.79047272300005],
              [-133.50381425699993, 55.76618073100008],
              [-133.4885961579999, 55.734361070000034],
              [-133.48717200399994, 55.706732489000046],
              [-133.54210364499994, 55.69489166900007],
              [-133.57868404899995, 55.70490143400008],
              [-133.6238500639999, 55.72947825700004],
              [-133.66323808499993, 55.76072825700004],
              [-133.6823624339999, 55.79047272300005],
              [-133.64932206899994, 55.78856028900003],
              [-133.6414281889999, 55.79047272300005],
              [-133.63931230399993, 55.79645416900007],
              [-133.6389054029999, 55.81708405200004],
              [-133.6345922519999, 55.82526276200008],
              [-133.61489824099993, 55.833197333000044],
              [-133.6013891269999, 55.82489655200004],
              [-133.58910071499992, 55.81167226800005],
              [-133.57310950399994, 55.804754950000074],
              [-133.57896887899994, 55.82440827000005],
              [-133.5652563139999, 55.83030833500004],
              [-133.50450598899994, 55.82290273600006],
              [-133.49522864499994, 55.820298570000034],
              [-133.48688717399995, 55.81476471600007],
              [-133.4824112619999, 55.80658600500004],
              [-133.48110917899993, 55.79877350500004],
              [-133.47769120999993, 55.79279205900008],
              [-133.46694902299993, 55.79047272300005],
              [-133.35167395699995, 55.78778717700004],
              [-133.33975175699993, 55.79047272300005],
              [-133.32974199099993, 55.798814195000034],
              [-133.3229874339999, 55.809027411000045],
              [-133.31602942599994, 55.81167226800005],
              [-133.3056534499999, 55.79734935100004],
            ],
          ],
          [
            [
              [-133.2851456369999, 55.90717194200005],
              [-133.2674047519999, 55.90216705900008],
              [-133.26671301999994, 55.89166901200008],
              [-133.27013098899994, 55.87872955900008],
              [-133.2646378249999, 55.86627838700008],
              [-133.25405839799993, 55.86420319200005],
              [-133.22891191299993, 55.87128327000005],
              [-133.2168676419999, 55.86627838700008],
              [-133.22036699099993, 55.82245514500005],
              [-133.2237035799999, 55.810980536000045],
              [-133.2359106109999, 55.78571198100008],
              [-133.2404679029999, 55.77997467700004],
              [-133.2508031889999, 55.77594635600008],
              [-133.2591039699999, 55.78025950700004],
              [-133.26671301999994, 55.78701406500005],
              [-133.2752172519999, 55.79047272300005],
              [-133.28335527299993, 55.79596588700008],
              [-133.30284583199995, 55.81981028900003],
              [-133.31615149599992, 55.82526276200008],
              [-133.3242895169999, 55.82672760600008],
              [-133.3342992829999, 55.83087799700007],
              [-133.34117591099994, 55.83734772300005],
              [-133.33975175699993, 55.845770575000074],
              [-133.3320206369999, 55.84747955900008],
              [-133.29137122299994, 55.851996161000045],
              [-133.31899980399993, 55.860541083000044],
              [-133.33055579299992, 55.86831289300005],
              [-133.33291581899994, 55.87986888200004],
              [-133.32583574099993, 55.88141510600008],
              [-133.29161536399994, 55.902004299000055],
              [-133.2851456369999, 55.90717194200005],
            ],
          ],
          [
            [
              [-155.6523331369999, 55.88666413000004],
              [-155.63532467399992, 55.90574778900003],
              [-155.5999691639999, 55.91481391800005],
              [-155.55610104099992, 55.91461823100008],
              [-155.5572403639999, 55.89520905200004],
              [-155.56904049399992, 55.868801174000055],
              [-155.57038326699993, 55.851996161000045],
              [-155.55805416599992, 55.817572333000044],
              [-155.5572403639999, 55.800482489000046],
              [-155.57038326699993, 55.78302643400008],
              [-155.59726412199993, 55.760431424000046],
              [-155.62990034999993, 55.76290150700004],
              [-155.6636925599999, 55.77446284700005],
              [-155.69738826999992, 55.77134585400006],
              [-155.71869337299992, 55.77485107500007],
              [-155.7280167309999, 55.804754950000074],
              [-155.7498486759999, 55.81768017400003],
              [-155.74164791599992, 55.83148834800005],
              [-155.70125795299992, 55.84133677300008],
              [-155.6634189549999, 55.85600812000007],
              [-155.6523331369999, 55.88666413000004],
            ],
          ],
          [
            [
              [-134.1792699859999, 55.91461823100008],
              [-134.1220596999999, 55.92373281500005],
              [-134.1015518869999, 55.920803127000056],
              [-134.11436926999994, 55.90033600500004],
              [-134.15318762899994, 55.89362213700008],
              [-134.19595292899993, 55.87335846600007],
              [-134.2338761059999, 55.846136786000045],
              [-134.25841223899994, 55.818426825000074],
              [-134.27627519399994, 55.82880280200004],
              [-134.3184301419999, 55.83380768400008],
              [-134.32664954299992, 55.848822333000044],
              [-134.3184301419999, 55.857855536000045],
              [-134.26455644399994, 55.87372467700004],
              [-134.27916419199994, 55.882147528000075],
              [-134.3347875639999, 55.89508698100008],
              [-134.3471573559999, 55.91095612200007],
              [-134.33218339799993, 55.92251211100006],
              [-134.29869544199994, 55.92649974200003],
              [-134.26357988199993, 55.92523834800005],
              [-134.2441300119999, 55.92084381700005],
              [-134.25792395699995, 55.89988841400003],
              [-134.23485266799992, 55.89996979400007],
              [-134.1792699859999, 55.91461823100008],
            ],
          ],
          [
            [
              [-133.9195043609999, 55.92084381700005],
              [-133.87730872299994, 55.93805573100008],
              [-133.85602779899995, 55.942287502000056],
              [-133.83218339799993, 55.90058014500005],
              [-133.8425186839999, 55.86635976800005],
              [-133.87165279899995, 55.84674713700008],
              [-133.91266842399995, 55.86277903900003],
              [-133.9213761059999, 55.874335028000075],
              [-133.9317113919999, 55.89398834800005],
              [-133.93423417899993, 55.91258372600004],
              [-133.9195043609999, 55.92084381700005],
            ],
          ],
          [
            [
              [-130.9619034499999, 55.58510976800005],
              [-130.94579016799992, 55.58274974200003],
              [-130.94371497299994, 55.572699286000045],
              [-130.9541723299999, 55.565619208000044],
              [-130.9755753249999, 55.57200755400004],
              [-130.9749242829999, 55.53457265800006],
              [-130.9772843089999, 55.51593659100007],
              [-130.98302161399994, 55.503119208000044],
              [-130.9787491529999, 55.49331289300005],
              [-130.9792374339999, 55.485541083000044],
              [-130.98155676999994, 55.47703685100004],
              [-130.98302161399994, 55.465277411000045],
              [-130.97183183499993, 55.44358958500004],
              [-130.9687393869999, 55.434881903000075],
              [-130.96715247299994, 55.42377350500004],
              [-130.9687393869999, 55.39667389500005],
              [-130.9716690749999, 55.38523997600004],
              [-130.97817949099993, 55.38764069200005],
              [-130.98916581899994, 55.400091864000046],
              [-131.00503495999993, 55.413397528000075],
              [-131.0151261059999, 55.417181708000044],
              [-131.02708899599992, 55.41034577000005],
              [-131.03099524599992, 55.400458075000074],
              [-131.02725175699993, 55.391058661000045],
              [-131.0209854809999, 55.382025458000044],
              [-131.0171606109999, 55.37278880400004],
              [-131.0183813139999, 55.35431549700007],
              [-131.02525794199994, 55.34235260600008],
              [-131.03490149599992, 55.33026764500005],
              [-131.0444229809999, 55.31134674700007],
              [-131.0556534499999, 55.27358633000006],
              [-131.0651749339999, 55.261053778000075],
              [-131.0854386059999, 55.24868398600006],
              [-131.10631262899994, 55.23891836100006],
              [-131.1165258449999, 55.236395575000074],
              [-131.13011633999992, 55.235581773000035],
              [-131.13760331899994, 55.23139069200005],
              [-131.14053300699993, 55.22162506700005],
              [-131.1426488919999, 55.210272528000075],
              [-131.1475317049999, 55.20148346600007],
              [-131.19200598899994, 55.18573639500005],
              [-131.2327367829999, 55.20091380400004],
              [-131.2717179029999, 55.22500234600005],
              [-131.31139075399994, 55.235581773000035],
              [-131.25625566299993, 55.27057526200008],
              [-131.23477128799993, 55.29096100500004],
              [-131.21572831899994, 55.317572333000044],
              [-131.21373450399994, 55.32306549700007],
              [-131.2083227199999, 55.34544505400004],
              [-131.20498613199993, 55.34992096600007],
              [-131.2005102199999, 55.35374583500004],
              [-131.19640051999994, 55.359442450000074],
              [-131.19469153599994, 55.36937083500004],
              [-131.19542395699995, 55.38735586100006],
              [-131.1995336579999, 55.399725653000075],
              [-131.2099503249999, 55.406317450000074],
              [-131.22940019399994, 55.40692780200004],
              [-131.2219945949999, 55.39325592700004],
              [-131.2439672519999, 55.393744208000044],
              [-131.26870683499993, 55.38617584800005],
              [-131.28307044199994, 55.371079820000034],
              [-131.27379309799994, 55.348863023000035],
              [-131.2617081369999, 55.32880280200004],
              [-131.26382402299993, 55.30939362200007],
              [-131.27700761599993, 55.29169342700004],
              [-131.2983292309999, 55.276556708000044],
              [-131.3242081369999, 55.26707591400003],
              [-131.35277258999992, 55.26325104400007],
              [-131.40416419199994, 55.262925523000035],
              [-131.42735755099994, 55.26703522300005],
              [-131.45055091099994, 55.27789948100008],
              [-131.4632055329999, 55.293402411000045],
              [-131.45474199099993, 55.31134674700007],
              [-131.4318741529999, 55.320013739000046],
              [-131.40485592399995, 55.32290273600006],
              [-131.38223222599993, 55.329413153000075],
              [-131.37279212099992, 55.348863023000035],
              [-131.37124589799993, 55.36115143400008],
              [-131.36644446499992, 55.371079820000034],
              [-131.35806230399993, 55.377834377000056],
              [-131.34581458199995, 55.38027578300006],
              [-131.3296606109999, 55.38141510600008],
              [-131.32262122299994, 55.38495514500005],
              [-131.31139075399994, 55.400091864000046],
              [-131.27818762899994, 55.43024323100008],
              [-131.27074133999992, 55.447333075000074],
              [-131.28091386599993, 55.465277411000045],
              [-131.28368079299992, 55.47215403900003],
              [-131.29336503799993, 55.514553127000056],
              [-131.29930579299992, 55.52533600500004],
              [-131.33063717399995, 55.56854889500005],
              [-131.3369034499999, 55.57965729400007],
              [-131.3435766269999, 55.63027578300006],
              [-131.35081946499992, 55.64557526200008],
              [-131.36318925699993, 55.64313385600008],
              [-131.37169348899994, 55.61863841400003],
              [-131.3652237619999, 55.58730703300006],
              [-131.3279516269999, 55.50275299700007],
              [-131.32192949099993, 55.47508372600004],
              [-131.32542883999992, 55.44676341400003],
              [-131.34239661399994, 55.41746653900003],
              [-131.34972083199995, 55.410142320000034],
              [-131.37279212099992, 55.39325592700004],
              [-131.38003495999993, 55.38572825700004],
              [-131.3945206369999, 55.36595286700003],
              [-131.40929114499994, 55.35219961100006],
              [-131.4246313139999, 55.34406159100007],
              [-131.46214758999992, 55.33185455900008],
              [-131.45274817599994, 55.343451239000046],
              [-131.42662512899994, 55.36399974200003],
              [-131.42125403599994, 55.37653229400007],
              [-131.42662512899994, 55.392279364000046],
              [-131.4390356109999, 55.40542226800005],
              [-131.45274817599994, 55.416896877000056],
              [-131.46214758999992, 55.427435614000046],
              [-131.4689835279999, 55.458685614000046],
              [-131.45840410099993, 55.483710028000075],
              [-131.42125403599994, 55.530462958000044],
              [-131.43789628799993, 55.530585028000075],
              [-131.46336829299992, 55.52326080900008],
              [-131.4890030589999, 55.511786200000074],
              [-131.50649980399993, 55.49941640800006],
              [-131.51695716099994, 55.48004791900007],
              [-131.51618404899995, 55.46002838700008],
              [-131.5080460279999, 55.44013092700004],
              [-131.4963272779999, 55.421210028000075],
              [-131.46910559799994, 55.38963450700004],
              [-131.46568762899994, 55.372259833000044],
              [-131.4795629549999, 55.348863023000035],
              [-131.5088598299999, 55.311712958000044],
              [-131.52647864499994, 55.29938385600008],
              [-131.5515844389999, 55.29706452000005],
              [-131.57310950399994, 55.30524323100008],
              [-131.6160375639999, 55.33270905200004],
              [-131.66152910099993, 55.34320709800005],
              [-131.68529212099992, 55.35431549700007],
              [-131.7228897779999, 55.38027578300006],
              [-131.72520911399994, 55.38353099200003],
              [-131.73131262899994, 55.39492422100005],
              [-131.7359106109999, 55.400091864000046],
              [-131.7866104809999, 55.42731354400007],
              [-131.80850175699993, 55.44448476800005],
              [-131.82022050699993, 55.46381256700005],
              [-131.81029212099992, 55.476629950000074],
              [-131.7178442049999, 55.51797109600005],
              [-131.7057999339999, 55.527044989000046],
              [-131.68887285099993, 55.542954820000034],
              [-131.67808997299994, 55.54962799700007],
              [-131.6673070949999, 55.550767320000034],
              [-131.65054277299993, 55.55027903900003],
              [-131.6445206369999, 55.557074286000045],
              [-131.61978105399993, 55.59528229400007],
              [-131.63048255099994, 55.604396877000056],
              [-131.6814672519999, 55.610541083000044],
              [-131.69896399599992, 55.616115627000056],
              [-131.70742753799993, 55.62962474200003],
              [-131.7084854809999, 55.64545319200005],
              [-131.7039281889999, 55.66111888200004],
              [-131.6955460279999, 55.67446523600006],
              [-131.6913956369999, 55.67951080900008],
              [-131.68687903599994, 55.68390534100007],
              [-131.6807348299999, 55.68695709800005],
              [-131.67129472599993, 55.68813711100006],
              [-131.63516191299993, 55.68695709800005],
              [-131.62730872299994, 55.68813711100006],
              [-131.62555904899995, 55.69358958500004],
              [-131.62612870999993, 55.712103583000044],
              [-131.62360592399995, 55.71914297100005],
              [-131.61465410099993, 55.72370026200008],
              [-131.60655676999994, 55.72162506700005],
              [-131.59923255099994, 55.71735260600008],
              [-131.5925186839999, 55.71539948100008],
              [-131.5349828769999, 55.723089911000045],
              [-131.51744544199994, 55.72907135600008],
              [-131.51744544199994, 55.73651764500005],
              [-131.53335527299993, 55.73696523600006],
              [-131.5788468089999, 55.72907135600008],
              [-131.62905839799993, 55.734035549000055],
              [-131.64712480399993, 55.72907135600008],
              [-131.69176184799994, 55.70526764500005],
              [-131.7045792309999, 55.70970286700003],
              [-131.7092179029999, 55.73965078300006],
              [-131.69542395699995, 55.751613674000055],
              [-131.66392981699994, 55.76121653900003],
              [-131.62930253799993, 55.76772695500006],
              [-131.51284745999993, 55.774725653000075],
              [-131.4826554029999, 55.78302643400008],
              [-131.49034583199995, 55.79242584800005],
              [-131.5127660799999, 55.80027903900003],
              [-131.51744544199994, 55.807928778000075],
              [-131.52159583199995, 55.81915924700007],
              [-131.5307511059999, 55.82575104400007],
              [-131.53994706899994, 55.825100002000056],
              [-131.54409745999993, 55.81476471600007],
              [-131.55435136599993, 55.79877350500004],
              [-131.5784399079999, 55.79254791900007],
              [-131.60610917899993, 55.78953685100004],
              [-131.62730872299994, 55.78302643400008],
              [-131.6443578769999, 55.793402411000045],
              [-131.6784561839999, 55.79922109600005],
              [-131.68871008999992, 55.810980536000045],
              [-131.6877335279999, 55.83197663000004],
              [-131.6706436839999, 55.839504299000055],
              [-131.47036699099993, 55.83197663000004],
              [-131.43545488199993, 55.845770575000074],
              [-131.45738684799994, 55.85195547100005],
              [-131.5344945949999, 55.851996161000045],
              [-131.54629472599993, 55.85879140800006],
              [-131.5600479809999, 55.87474192900004],
              [-131.57213294199994, 55.89321523600006],
              [-131.5788468089999, 55.90717194200005],
              [-131.51573645699995, 55.90961334800005],
              [-131.4963272779999, 55.91461823100008],
              [-131.48766028599994, 55.919256903000075],
              [-131.47105872299994, 55.930975653000075],
              [-131.46214758999992, 55.93451569200005],
              [-131.4468481109999, 55.93545156500005],
              [-131.40416419199994, 55.92829010600008],
              [-131.3652237619999, 55.937160549000055],
              [-131.32359778599994, 55.95425039300005],
              [-131.2802628249999, 55.96515534100007],
              [-131.23623613199993, 55.95563385600008],
              [-131.20889238199993, 55.94489166900007],
              [-131.17955481699994, 55.923529364000046],
              [-131.0444229809999, 55.79047272300005],
              [-131.04613196499992, 55.76658763200004],
              [-131.02281653599994, 55.74286530200004],
              [-130.9687393869999, 55.70111725500004],
              [-130.96690833199995, 55.69415924700007],
              [-130.9685766269999, 55.67812734600005],
              [-130.96532141799992, 55.67104726800005],
              [-130.9383031889999, 55.65151601800005],
              [-130.9345596999999, 55.64313385600008],
              [-130.9382218089999, 55.624212958000044],
              [-130.95555579299992, 55.600490627000056],
              [-130.9619034499999, 55.58510976800005],
            ],
          ],
          [
            [
              [-133.60728919199994, 56.07851797100005],
              [-133.54157467399995, 56.07477448100008],
              [-133.5095922519999, 56.078111070000034],
              [-133.4831436839999, 56.09218984600005],
              [-133.51353919199994, 56.097357489000046],
              [-133.5965063139999, 56.10097890800006],
              [-133.62096106699994, 56.112616278000075],
              [-133.6170141269999, 56.13153717700004],
              [-133.58063717399995, 56.13190338700008],
              [-133.50796464799993, 56.11945221600007],
              [-133.4949438139999, 56.12067291900007],
              [-133.47907467399995, 56.124212958000044],
              [-133.4638565749999, 56.12962474200003],
              [-133.44229081899994, 56.143011786000045],
              [-133.41576087099992, 56.15078359600005],
              [-133.40489661399994, 56.15737539300005],
              [-133.39268958199995, 56.16046784100007],
              [-133.34316972599993, 56.14740631700005],
              [-133.30260169199994, 56.150824286000045],
              [-133.28530839799993, 56.14720286700003],
              [-133.2851456369999, 56.13312409100007],
              [-133.3088272779999, 56.10301341400003],
              [-133.31309973899994, 56.09218984600005],
              [-133.31191972599993, 56.07990143400008],
              [-133.30138098899994, 56.06386953300006],
              [-133.29873613199993, 56.05463288000004],
              [-133.29775956899994, 56.03294505400004],
              [-133.2995499339999, 56.01203034100007],
              [-133.31114661399994, 55.99787018400008],
              [-133.33975175699993, 55.99656810100004],
              [-133.35826575399994, 56.00617096600007],
              [-133.3760473299999, 56.019964911000045],
              [-133.3954971999999, 56.02635325700004],
              [-133.4396866529999, 56.00267161700003],
              [-133.47032630099994, 56.017279364000046],
              [-133.49058997299994, 56.010199286000045],
              [-133.5108129549999, 55.987941799000055],
              [-133.5178930329999, 55.98232656500005],
              [-133.5600479809999, 55.97089264500005],
              [-133.58975175699993, 55.95575592700004],
              [-133.62954667899993, 55.959418036000045],
              [-133.6414281889999, 55.94818756700005],
              [-133.6384985019999, 55.937933661000045],
              [-133.6181534499999, 55.92804596600007],
              [-133.62096106699994, 55.92084381700005],
              [-133.63097083199995, 55.91864655200004],
              [-133.67861894399994, 55.91461823100008],
              [-133.6913956369999, 55.91111888200004],
              [-133.69737708199995, 55.90497467700004],
              [-133.7027074859999, 55.902777411000045],
              [-133.7228897779999, 55.91771067900004],
              [-133.73228919199994, 55.91982656500005],
              [-133.7581274079999, 55.92084381700005],
              [-133.7949112619999, 55.94358958500004],
              [-133.7710668609999, 55.980454820000034],
              [-133.68919837099992, 56.04376862200007],
              [-133.6845596999999, 56.05353424700007],
              [-133.6845596999999, 56.062486070000034],
              [-133.6809789699999, 56.06915924700007],
              [-133.60728919199994, 56.07851797100005],
            ],
          ],
          [
            [
              [-132.5484106109999, 56.30442942900004],
              [-132.54112708199995, 56.30878327000005],
              [-132.53799394399994, 56.31891510600008],
              [-132.53579667899993, 56.330511786000045],
              [-132.53099524599992, 56.339178778000075],
              [-132.52114824099993, 56.34320709800005],
              [-132.42747962099992, 56.35219961100006],
              [-132.39976966099994, 56.35040924700007],
              [-132.3938695949999, 56.339178778000075],
              [-132.38532467399995, 56.33218008000006],
              [-132.3806860019999, 56.321519273000035],
              [-132.38097083199995, 56.30951569200005],
              [-132.38760331899994, 56.29824453300006],
              [-132.37751217399995, 56.28457265800006],
              [-132.3769425119999, 56.27163320500006],
              [-132.38512122299994, 56.261786200000074],
              [-132.40127519399994, 56.25726959800005],
              [-132.3869522779999, 56.247707424000055],
              [-132.3899633449999, 56.23550039300005],
              [-132.40200761599993, 56.22402578300006],
              [-132.41490637899994, 56.21629466400003],
              [-132.4705297519999, 56.20404694200005],
              [-132.48379472599993, 56.194566148000035],
              [-132.45763098899994, 56.18667226800005],
              [-132.42955481699994, 56.186753648000035],
              [-132.40367591099994, 56.19354889500005],
              [-132.3594457669999, 56.21792226800005],
              [-132.33824622299994, 56.212103583000044],
              [-132.31680253799993, 56.19871653900003],
              [-132.29137122299994, 56.188381252000056],
              [-132.2233780589999, 56.18349844000005],
              [-132.1921280589999, 56.17658112200007],
              [-132.16445878799993, 56.15737539300005],
              [-132.14818274599992, 56.143011786000045],
              [-132.09219316299993, 56.10643138200004],
              [-132.09630286399994, 56.09943268400008],
              [-132.1011449859999, 56.09365469000005],
              [-132.10684160099993, 56.08881256700005],
              [-132.11388098899994, 56.08466217700004],
              [-132.13003495999993, 56.093817450000074],
              [-132.13707434799994, 56.08808014500005],
              [-132.14175370999993, 56.077460028000075],
              [-132.1511938139999, 56.07168203300006],
              [-132.1635636059999, 56.07477448100008],
              [-132.18838456899994, 56.08860911700003],
              [-132.20201575399994, 56.09218984600005],
              [-132.1962784499999, 56.07786692900004],
              [-132.1757706369999, 56.06305573100008],
              [-132.16787675699993, 56.051214911000045],
              [-132.1721899079999, 56.04954661700003],
              [-132.18219967399995, 56.04376862200007],
              [-132.16909745999993, 56.036810614000046],
              [-132.16002356699994, 56.02728913000004],
              [-132.15322831899994, 56.01581452000005],
              [-132.1474503249999, 56.00275299700007],
              [-132.1507055329999, 55.99909088700008],
              [-132.1523331369999, 55.996527411000045],
              [-132.15489661399994, 55.98973216400003],
              [-132.12946529899995, 55.97028229400007],
              [-132.1226293609999, 55.94550202000005],
              [-132.13345292899993, 55.929022528000075],
              [-132.16104081899994, 55.93451569200005],
              [-132.16812089799993, 55.943019924000055],
              [-132.1775610019999, 55.964829820000034],
              [-132.18529212099992, 55.96930573100008],
              [-132.19151770699995, 55.96430084800005],
              [-132.21182206899994, 55.941392320000034],
              [-132.22313391799992, 55.93451569200005],
              [-132.23668372299994, 55.93349844000005],
              [-132.2451879549999, 55.93549225500004],
              [-132.25210527299993, 55.93626536700003],
              [-132.2715551419999, 55.92523834800005],
              [-132.2866918609999, 55.91937897300005],
              [-132.30337480399993, 55.915350653000075],
              [-132.31871497299994, 55.91461823100008],
              [-132.33556067599994, 55.91819896000004],
              [-132.34508216099994, 55.92430247600004],
              [-132.36339270699995, 55.94476959800005],
              [-132.37999426999994, 55.952337958000044],
              [-132.4168188139999, 55.95783112200007],
              [-132.42857825399994, 55.96930573100008],
              [-132.41226152299993, 55.998114325000074],
              [-132.40465247299994, 56.00275299700007],
              [-132.3924047519999, 56.005845445000034],
              [-132.38442949099993, 56.01341380400004],
              [-132.3823136059999, 56.02260976800005],
              [-132.38760331899994, 56.03070709800005],
              [-132.41421464799993, 56.03510163000004],
              [-132.44473222599993, 56.03192780200004],
              [-132.46206620999993, 56.03668854400007],
              [-132.44908606699994, 56.06484609600005],
              [-132.55894934799994, 56.07168203300006],
              [-132.57005774599992, 56.07501862200007],
              [-132.58165442599994, 56.08161041900007],
              [-132.59386145699995, 56.08657461100006],
              [-132.6067602199999, 56.08466217700004],
              [-132.61253821499992, 56.07697174700007],
              [-132.6135147779999, 56.06655508000006],
              [-132.6162817049999, 56.05687083500004],
              [-132.6271866529999, 56.051214911000045],
              [-132.64541581899994, 56.05809153900003],
              [-132.67662512899994, 56.09723541900007],
              [-132.6923721999999, 56.10643138200004],
              [-132.70498613199993, 56.11741771000004],
              [-132.7132055329999, 56.13979726800005],
              [-132.7117406889999, 56.15717194200005],
              [-132.69546464799993, 56.153631903000075],
              [-132.69310462099992, 56.17552317900004],
              [-132.68736731699994, 56.195379950000074],
              [-132.6874893869999, 56.21161530200004],
              [-132.7029516269999, 56.22247955900008],
              [-132.68138587099992, 56.22919342700004],
              [-132.6033422519999, 56.23615143400008],
              [-132.5896703769999, 56.24681224200003],
              [-132.56602942599994, 56.29376862200007],
              [-132.5484106109999, 56.30442942900004],
            ],
          ],
          [
            [
              [-131.97671464799993, 54.83152903900003],
              [-131.95767167899993, 54.828111070000034],
              [-131.9568578769999, 54.81720612200007],
              [-131.9589737619999, 54.80304596600007],
              [-131.9488012359999, 54.78998444200005],
              [-131.9631241529999, 54.78546784100007],
              [-131.97838294199994, 54.78375885600008],
              [-132.01024329299992, 54.78375885600008],
              [-131.99657141799992, 54.77692291900007],
              [-132.00243079299992, 54.76544830900008],
              [-132.00137285099993, 54.75576406500005],
              [-131.99791419199994, 54.74624258000006],
              [-131.99657141799992, 54.73529694200005],
              [-132.0003149079999, 54.722723700000074],
              [-132.00560462099992, 54.712958075000074],
              [-132.00820878799993, 54.704006252000056],
              [-132.00401770699995, 54.693793036000045],
              [-132.06753495999993, 54.69904205900008],
              [-132.0822647779999, 54.70465729400007],
              [-132.09609941299993, 54.71271393400008],
              [-132.11107337099992, 54.71670156500005],
              [-132.11774654899995, 54.71369049700007],
              [-132.1064346999999, 54.701239325000074],
              [-132.1499731109999, 54.69863515800006],
              [-132.20079505099994, 54.72524648600006],
              [-132.24722245999993, 54.74331289300005],
              [-132.27774003799993, 54.714829820000034],
              [-132.29238847599993, 54.72748444200005],
              [-132.2975968089999, 54.74445221600007],
              [-132.2944229809999, 54.762152411000045],
              [-132.2840063139999, 54.77692291900007],
              [-132.2656143869999, 54.78465403900003],
              [-132.22451738199993, 54.79165273600006],
              [-132.2162979809999, 54.80365631700005],
              [-132.21890214799993, 54.81028880400004],
              [-132.22598222599993, 54.81468333500004],
              [-132.2358292309999, 54.81720612200007],
              [-132.24673417899993, 54.81785716400003],
              [-132.25914466099994, 54.81517161700003],
              [-132.26622473899994, 54.809027411000045],
              [-132.27135169199994, 54.80219147300005],
              [-132.27774003799993, 54.79743073100008],
              [-132.2997940749999, 54.79433828300006],
              [-132.33649654899995, 54.80341217700004],
              [-132.3596899079999, 54.80365631700005],
              [-132.33653723899994, 54.814886786000045],
              [-132.2830297519999, 54.83100006700005],
              [-132.26475989499994, 54.84454987200007],
              [-132.27586829299992, 54.85370514500005],
              [-132.31029212099992, 54.85993073100008],
              [-132.32555091099994, 54.86627838700008],
              [-132.31432044199994, 54.87067291900007],
              [-132.3028051419999, 54.872381903000075],
              [-132.27774003799993, 54.87250397300005],
              [-132.27774003799993, 54.879339911000045],
              [-132.3159073559999, 54.88300202000005],
              [-132.33568274599992, 54.887884833000044],
              [-132.34972083199995, 54.89642975500004],
              [-132.35212154899995, 54.90460846600007],
              [-132.34972083199995, 54.91229889500005],
              [-132.3499242829999, 54.918036200000074],
              [-132.35997473899994, 54.92031484600005],
              [-132.36974036399994, 54.921210028000075],
              [-132.37857011599993, 54.92397695500006],
              [-132.38658606699994, 54.92841217700004],
              [-132.3938695949999, 54.93455638200004],
              [-132.37804114499994, 54.94013092700004],
              [-132.36961829299992, 54.94155508000006],
              [-132.3596899079999, 54.94082265800006],
              [-132.3679906889999, 54.95099518400008],
              [-132.38727779899995, 54.96442291900007],
              [-132.3938695949999, 54.97553131700005],
              [-132.3946020169999, 54.98822663000004],
              [-132.39098059799994, 55.00096263200004],
              [-132.3801977199999, 55.02338288000004],
              [-132.40269934799994, 55.015285549000055],
              [-132.41201738199993, 54.99371979400007],
              [-132.41490637899994, 54.97150299700007],
              [-132.4180395169999, 54.96124909100007],
              [-132.41539466099994, 54.95600006700005],
              [-132.4175512359999, 54.94391510600008],
              [-132.4225968089999, 54.93016185100004],
              [-132.42857825399994, 54.92031484600005],
              [-132.43614661399994, 54.91657135600008],
              [-132.4729711579999, 54.90729401200008],
              [-132.48558508999992, 54.90737539300005],
              [-132.49526933499993, 54.90888092700004],
              [-132.5014542309999, 54.913763739000046],
              [-132.5037328769999, 54.92401764500005],
              [-132.49767005099994, 54.93305084800005],
              [-132.48363196499992, 54.93577708500004],
              [-132.46788489499994, 54.93691640800006],
              [-132.4565323559999, 54.94082265800006],
              [-132.4441625639999, 54.96303945500006],
              [-132.4522192049999, 54.980536200000074],
              [-132.47081458199995, 54.99363841400003],
              [-132.4900610019999, 55.00287506700005],
              [-132.49547278599994, 54.965277411000045],
              [-132.5188695949999, 54.94415924700007],
              [-132.55020097599993, 54.94025299700007],
              [-132.5794164699999, 54.954413153000075],
              [-132.59341386599993, 54.96824778900003],
              [-132.59813391799992, 54.97601959800005],
              [-132.5999242829999, 54.98550039300005],
              [-132.5960180329999, 54.98908112200007],
              [-132.57534745999993, 54.97711823100008],
              [-132.56578528599994, 54.97553131700005],
              [-132.55553137899994, 54.986395575000074],
              [-132.55186926999994, 55.00067780200004],
              [-132.54649817599994, 55.01264069200005],
              [-132.53099524599992, 55.01654694200005],
              [-132.5467016269999, 55.02020905200004],
              [-132.56696529899995, 55.02142975500004],
              [-132.57949785099993, 55.027044989000046],
              [-132.57192949099993, 55.043850002000056],
              [-132.5534561839999, 55.052435614000046],
              [-132.52989661399994, 55.050116278000075],
              [-132.50527910099993, 55.04466380400004],
              [-132.48379472599993, 55.043850002000056],
              [-132.46495520699995, 55.05072663000004],
              [-132.53099524599992, 55.05805084800005],
              [-132.5429581369999, 55.07021719000005],
              [-132.53917395699995, 55.083644924000055],
              [-132.51113847599993, 55.11273834800005],
              [-132.5292862619999, 55.11546458500004],
              [-132.5449112619999, 55.121527411000045],
              [-132.55980383999992, 55.12409088700008],
              [-132.5756729809999, 55.11615631700005],
              [-132.6028539699999, 55.069525458000044],
              [-132.61290442599994, 55.06427643400008],
              [-132.62661699099993, 55.085638739000046],
              [-132.60855058499993, 55.119208075000074],
              [-132.5790909499999, 55.15131256700005],
              [-132.55833899599992, 55.16791413000004],
              [-132.57583574099993, 55.174994208000044],
              [-132.5891820949999, 55.18626536700003],
              [-132.60985266799992, 55.21173737200007],
              [-132.63320878799993, 55.230902411000045],
              [-132.6402074859999, 55.24054596600007],
              [-132.6408585279999, 55.25608958500004],
              [-132.65746008999992, 55.241848049000055],
              [-132.6558324859999, 55.21898021000004],
              [-132.64244544199994, 55.19773997600004],
              [-132.6237686839999, 55.18842194200005],
              [-132.61611894399994, 55.18195221600007],
              [-132.6153051419999, 55.167669989000046],
              [-132.62047278599994, 55.15338776200008],
              [-132.6309301419999, 55.14687734600005],
              [-132.6961156889999, 55.14687734600005],
              [-132.7068578769999, 55.14923737200007],
              [-132.73643958199995, 55.16791413000004],
              [-132.7748917309999, 55.18305084800005],
              [-132.78482011599993, 55.18842194200005],
              [-132.79898027299993, 55.205145575000074],
              [-132.80821692599994, 55.228216864000046],
              [-132.8093155589999, 55.25189850500004],
              [-132.7991430329999, 55.270412502000056],
              [-132.82673092399995, 55.275458075000074],
              [-132.84044348899994, 55.27488841400003],
              [-132.84630286399994, 55.26666901200008],
              [-132.84776770699995, 55.257513739000046],
              [-132.85122636599993, 55.24823639500005],
              [-132.85562089799993, 55.24042389500005],
              [-132.85997473899994, 55.235581773000035],
              [-132.88170325399994, 55.225816148000035],
              [-132.9287003249999, 55.21747467700004],
              [-132.94933020699995, 55.208319403000075],
              [-133.03042558499993, 55.214097398000035],
              [-133.03502356699994, 55.22565338700008],
              [-133.02554277299993, 55.230169989000046],
              [-132.98350989499994, 55.235581773000035],
              [-132.91372636599993, 55.26471588700008],
              [-132.9051000639999, 55.27106354400007],
              [-132.90151933499993, 55.28025950700004],
              [-132.90977942599994, 55.285223700000074],
              [-132.92829342399995, 55.28335195500006],
              [-132.95958411399994, 55.276556708000044],
              [-133.08653723899994, 55.276556708000044],
              [-133.08372962099992, 55.272772528000075],
              [-133.0790909499999, 55.262925523000035],
              [-133.09219316299993, 55.270819403000075],
              [-133.10391191299993, 55.27977122600004],
              [-133.11611894399994, 55.287176825000074],
              [-133.1309301419999, 55.290269273000035],
              [-133.1472061839999, 55.28823476800005],
              [-133.1740616529999, 55.27920156500005],
              [-133.18887285099993, 55.276556708000044],
              [-133.2129613919999, 55.27920156500005],
              [-133.2170304029999, 55.288397528000075],
              [-133.2149145169999, 55.30117422100005],
              [-133.2202856109999, 55.314439195000034],
              [-133.2324926419999, 55.32200755400004],
              [-133.24551347599993, 55.327337958000044],
              [-133.25706946499992, 55.33392975500004],
              [-133.2646378249999, 55.34544505400004],
              [-133.24819902299993, 55.34715403900003],
              [-133.24034583199995, 55.354681708000044],
              [-133.2359106109999, 55.364447333000044],
              [-133.22988847599993, 55.37278880400004],
              [-133.21800696499992, 55.38031647300005],
              [-133.2066137359999, 55.384466864000046],
              [-133.1940811839999, 55.38613515800006],
              [-133.1787003249999, 55.386419989000046],
              [-133.17422441299993, 55.38532135600008],
              [-133.1624242829999, 55.37938060100004],
              [-133.15249589799993, 55.372300523000035],
              [-133.1497289699999, 55.37417226800005],
              [-133.1477758449999, 55.37807851800005],
              [-133.14419511599993, 55.38027578300006],
              [-133.06065833199995, 55.36859772300005],
              [-133.05235755099994, 55.36595286700003],
              [-133.03335527299993, 55.353949286000045],
              [-133.03189042899993, 55.35228099200003],
              [-133.01773027299993, 55.35032786700003],
              [-132.87242591099994, 55.359076239000046],
              [-132.84630286399994, 55.35228099200003],
              [-132.8698624339999, 55.36391836100006],
              [-132.95616614499994, 55.37278880400004],
              [-133.0078018869999, 55.38812897300005],
              [-133.02871660099993, 55.40058014500005],
              [-133.0244848299999, 55.413763739000046],
              [-133.0310766269999, 55.42243073100008],
              [-133.04067949099993, 55.426988023000035],
              [-133.05247962099992, 55.42841217700004],
              [-133.0654190749999, 55.427435614000046],
              [-133.0467016269999, 55.43707916900007],
              [-133.02379309799994, 55.44428131700005],
              [-132.99962317599994, 55.44818756700005],
              [-132.9772843089999, 55.44790273600006],
              [-133.00820878799993, 55.457464911000045],
              [-133.07530676999994, 55.45111725500004],
              [-133.1070043609999, 55.462144273000035],
              [-133.12584387899994, 55.483587958000044],
              [-133.12486731699994, 55.50218333500004],
              [-133.1116430329999, 55.519598700000074],
              [-133.09337317599994, 55.53729889500005],
              [-133.08702551999994, 55.54682038000004],
              [-133.07787024599992, 55.570013739000046],
              [-133.07286536399994, 55.57827383000006],
              [-133.06411699099993, 55.582912502000056],
              [-133.0244848299999, 55.59870026200008],
              [-133.00015214799993, 55.61497630400004],
              [-132.98648027299993, 55.62177155200004],
              [-132.96983801999994, 55.626654364000046],
              [-132.9226781889999, 55.62763092700004],
              [-132.90835527299993, 55.632879950000074],
              [-132.92296301999994, 55.63735586100006],
              [-132.93834387899994, 55.63971588700008],
              [-132.96983801999994, 55.63971588700008],
              [-132.98277747299994, 55.63703034100007],
              [-133.01451575399994, 55.626654364000046],
              [-133.06309973899994, 55.623480536000045],
              [-133.20360266799992, 55.58690013200004],
              [-133.2512914699999, 55.58478424700007],
              [-133.35704505099994, 55.61619700700004],
              [-133.37905839799993, 55.629787502000056],
              [-133.3881729809999, 55.65021393400008],
              [-133.3867895169999, 55.66205475500004],
              [-133.38219153599994, 55.66950104400007],
              [-133.3737686839999, 55.67328522300005],
              [-133.34146074099993, 55.677720445000034],
              [-133.34194902299993, 55.68545156500005],
              [-133.36025956899994, 55.70111725500004],
              [-133.3681534499999, 55.703558661000045],
              [-133.37857011599993, 55.70453522300005],
              [-133.38524329299992, 55.70929596600007],
              [-133.38194739499994, 55.72284577000005],
              [-133.3704320949999, 55.73334381700005],
              [-133.35753333199995, 55.73061758000006],
              [-133.3455297519999, 55.72117747600004],
              [-133.33633378799993, 55.71198151200008],
              [-133.32396399599992, 55.70929596600007],
              [-133.31798255099994, 55.72638580900008],
              [-133.3134659499999, 55.74917226800005],
              [-133.3056534499999, 55.76386139500005],
              [-133.29336503799993, 55.75775788000004],
              [-133.2652074859999, 55.74795156500005],
              [-133.23668372299994, 55.74506256700005],
              [-133.2237035799999, 55.76007721600007],
              [-133.21397864499994, 55.78335195500006],
              [-133.1913956369999, 55.79718659100007],
              [-133.1660863919999, 55.807074286000045],
              [-133.1479386059999, 55.818426825000074],
              [-133.14297441299993, 55.83226146000004],
              [-133.13988196499992, 55.85455963700008],
              [-133.13980058499993, 55.876613674000055],
              [-133.14419511599993, 55.889837958000044],
              [-133.15636145699995, 55.89622630400004],
              [-133.15884355399993, 55.89020416900007],
              [-133.15664628799993, 55.88076406500005],
              [-133.15477454299992, 55.87677643400008],
              [-133.1611221999999, 55.865668036000045],
              [-133.17503821499992, 55.865668036000045],
              [-133.21768144399994, 55.883693752000056],
              [-133.2272843089999, 55.89057038000004],
              [-133.23672441299993, 55.90033600500004],
              [-133.24087480399993, 55.90997955900008],
              [-133.24864661399994, 55.935980536000045],
              [-133.2541397779999, 55.94135163000004],
              [-133.2597550119999, 55.945298570000034],
              [-133.25035559799994, 55.95343659100007],
              [-133.23680579299992, 55.95978424700007],
              [-133.22988847599993, 55.958685614000046],
              [-133.2317602199999, 55.970363674000055],
              [-133.2441300119999, 55.99656810100004],
              [-133.24620520699995, 56.035589911000045],
              [-133.2502335279999, 56.055975653000075],
              [-133.2791235019999, 56.07640208500004],
              [-133.2781469389999, 56.10248444200005],
              [-133.2646378249999, 56.14740631700005],
              [-133.28551184799994, 56.16738515800006],
              [-133.33120683499993, 56.17255280200004],
              [-133.42540442599994, 56.16791413000004],
              [-133.44347083199995, 56.16982656500005],
              [-133.4577530589999, 56.174994208000044],
              [-133.4903051419999, 56.191473700000074],
              [-133.50837154899995, 56.19171784100007],
              [-133.56191972599993, 56.18378327000005],
              [-133.57310950399994, 56.18496328300006],
              [-133.5759985019999, 56.18817780200004],
              [-133.59300696499992, 56.202053127000056],
              [-133.6062719389999, 56.20994700700004],
              [-133.61099199099993, 56.21076080900008],
              [-133.61217200399994, 56.21234772300005],
              [-133.6147354809999, 56.22247955900008],
              [-133.61538652299993, 56.23041413000004],
              [-133.61339270699995, 56.24713776200008],
              [-133.6147354809999, 56.25726959800005],
              [-133.61904863199993, 56.26032135600008],
              [-133.62710527299993, 56.26406484600005],
              [-133.63390051999994, 56.269517320000034],
              [-133.6345922519999, 56.277777411000045],
              [-133.61961829299992, 56.289496161000045],
              [-133.57632402299993, 56.292629299000055],
              [-133.56631425699993, 56.30442942900004],
              [-133.57266191299993, 56.31439850500004],
              [-133.58779863199993, 56.327337958000044],
              [-133.6147354809999, 56.345404364000046],
              [-133.6147354809999, 56.352850653000075],
              [-133.58678137899994, 56.352850653000075],
              [-133.43907630099994, 56.33234284100007],
              [-133.34154212099992, 56.33344147300005],
              [-133.31309973899994, 56.32558828300006],
              [-133.31309973899994, 56.31875234600005],
              [-133.3300675119999, 56.30703359600005],
              [-133.32848059799994, 56.28900788000004],
              [-133.31224524599992, 56.27724844000005],
              [-133.2851456369999, 56.28392161700003],
              [-133.28994706899994, 56.285142320000034],
              [-133.29360917899993, 56.287095445000034],
              [-133.2967016269999, 56.28961823100008],
              [-133.29938717399995, 56.29254791900007],
              [-133.29409745999993, 56.313788153000075],
              [-133.25841223899994, 56.327378648000035],
              [-133.2138565749999, 56.33344147300005],
              [-133.18211829299992, 56.33234284100007],
              [-133.16722571499992, 56.32518138200004],
              [-133.15160071499992, 56.31281159100007],
              [-133.13931230399993, 56.29901764500005],
              [-133.1343481109999, 56.28733958500004],
              [-133.13646399599992, 56.28082916900007],
              [-133.14000403599994, 56.27293528900003],
              [-133.1406143869999, 56.26630280200004],
              [-133.13402258999992, 56.26349518400008],
              [-133.1265356109999, 56.26227448100008],
              [-133.10521399599992, 56.255926825000074],
              [-133.09532630099994, 56.25071849200003],
              [-133.06851152299993, 56.24754466400003],
              [-133.0585831369999, 56.24298737200007],
              [-133.05386308499993, 56.234442450000074],
              [-133.05357825399994, 56.226263739000046],
              [-133.0541886059999, 56.21792226800005],
              [-133.05235755099994, 56.20888906500005],
              [-133.0534561839999, 56.20661041900007],
              [-133.05650794199994, 56.203192450000074],
              [-133.05899003799993, 56.19904205900008],
              [-133.0585831369999, 56.194566148000035],
              [-133.0537003249999, 56.190741278000075],
              [-133.04027258999992, 56.18781159100007],
              [-133.03502356699994, 56.18496328300006],
              [-133.03050696499992, 56.180121161000045],
              [-133.0248917309999, 56.17202383000006],
              [-133.02428137899994, 56.16445547100005],
              [-133.03502356699994, 56.16107819200005],
              [-133.04629472599993, 56.15424225500004],
              [-133.06501217399995, 56.12250397300005],
              [-133.07286536399994, 56.112616278000075],
              [-133.09292558499993, 56.10932038000004],
              [-133.1238500639999, 56.12449778900003],
              [-133.14049231699994, 56.11945221600007],
              [-133.09264075399994, 56.06915924700007],
              [-133.0790909499999, 56.05805084800005],
              [-133.0628149079999, 56.05231354400007],
              [-133.04869544199994, 56.052801825000074],
              [-133.01821855399993, 56.05805084800005],
              [-133.0009659499999, 56.05678945500006],
              [-132.95616614499994, 56.04376862200007],
              [-132.95518958199995, 56.05385976800005],
              [-132.95132402299993, 56.061712958000044],
              [-132.94473222599993, 56.067613023000035],
              [-132.93565833199995, 56.07168203300006],
              [-132.91852779899995, 56.06590403900003],
              [-132.9123429029999, 56.05776601800005],
              [-132.90933183499993, 56.04800039300005],
              [-132.8982641269999, 56.03217194200005],
              [-132.8985082669999, 56.02806224200003],
              [-132.89586341099994, 56.025458075000074],
              [-132.8757218089999, 56.024644273000035],
              [-132.86904863199993, 56.02570221600007],
              [-132.8631078769999, 56.028509833000044],
              [-132.85655676999994, 56.03412506700005],
              [-132.84243730399993, 56.039048570000034],
              [-132.82787024599992, 56.03237539300005],
              [-132.81407630099994, 56.02228424700007],
              [-132.8022354809999, 56.01703522300005],
              [-132.7890518869999, 56.01471588700008],
              [-132.73643958199995, 55.99656810100004],
              [-132.71519934799994, 55.98078034100007],
              [-132.69395911399994, 55.96010976800005],
              [-132.6709692049999, 55.94212474200003],
              [-132.6331274079999, 55.931708075000074],
              [-132.62071692599994, 55.92438385600008],
              [-132.6108292309999, 55.914496161000045],
              [-132.6067602199999, 55.90375397300005],
              [-132.60045325399994, 55.89337799700007],
              [-132.56973222599993, 55.88296133000006],
              [-132.55833899599992, 55.87372467700004],
              [-132.56578528599994, 55.86627838700008],
              [-132.53172766799992, 55.848537502000056],
              [-132.50841223899994, 55.82762278900003],
              [-132.4627172519999, 55.77684153900003],
              [-132.47280839799993, 55.76357656500005],
              [-132.46849524599992, 55.75063711100006],
              [-132.45787512899994, 55.73729075700004],
              [-132.44908606699994, 55.72284577000005],
              [-132.44542395699995, 55.70612213700008],
              [-132.44713294199994, 55.69403717700004],
              [-132.4627172519999, 55.667629299000055],
              [-132.44863847599993, 55.66323476800005],
              [-132.4387914699999, 55.65468984600005],
              [-132.4339086579999, 55.64240143400008],
              [-132.43480383999992, 55.626654364000046],
              [-132.4258520169999, 55.633978583000044],
              [-132.39370683499993, 55.668402411000045],
              [-132.37051347599993, 55.667629299000055],
              [-132.3655492829999, 55.66437409100007],
              [-132.34996497299994, 55.64858633000006],
              [-132.3466690749999, 55.64313385600008],
              [-132.34536699099993, 55.62006256700005],
              [-132.34312903599994, 55.61347077000005],
              [-132.33922278599994, 55.605536200000074],
              [-132.2971085279999, 55.54706452000005],
              [-132.28770911399994, 55.53729889500005],
              [-132.2363988919999, 55.53701406500005],
              [-132.2148331369999, 55.53119538000004],
              [-132.15758216099994, 55.49673086100006],
              [-132.1454971999999, 55.48305898600006],
              [-132.1406143869999, 55.465277411000045],
              [-132.15050208199995, 55.44940827000005],
              [-132.17320716099994, 55.452826239000046],
              [-132.2162979809999, 55.475816148000035],
              [-132.25047766799992, 55.503119208000044],
              [-132.29625403599994, 55.51357656500005],
              [-132.33385169199994, 55.53229401200008],
              [-132.4053442049999, 55.54120514500005],
              [-132.43480383999992, 55.55027903900003],
              [-132.4910375639999, 55.60370514500005],
              [-132.5235082669999, 55.62523021000004],
              [-132.55211341099994, 55.619208075000074],
              [-132.54430091099994, 55.614935614000046],
              [-132.5393774079999, 55.61017487200007],
              [-132.53099524599992, 55.59870026200008],
              [-132.5432022779999, 55.59723541900007],
              [-132.55260169199994, 55.591050523000035],
              [-132.55992591099994, 55.582098700000074],
              [-132.56578528599994, 55.57200755400004],
              [-132.5501195949999, 55.571478583000044],
              [-132.52818762899994, 55.56732819200005],
              [-132.51219641799992, 55.55927155200004],
              [-132.51451575399994, 55.54718659100007],
              [-132.5620011059999, 55.50625234600005],
              [-132.5911352199999, 55.49286530200004],
              [-132.65982011599993, 55.47565338700008],
              [-132.68179277299993, 55.45530833500004],
              [-132.66665605399993, 55.45107656500005],
              [-132.65465247299994, 55.44489166900007],
              [-132.64932206899994, 55.43549225500004],
              [-132.6545304029999, 55.421210028000075],
              [-132.64244544199994, 55.432928778000075],
              [-132.6310929029999, 55.44643789300005],
              [-132.6170141269999, 55.45750560100004],
              [-132.55524654899995, 55.468410549000055],
              [-132.5468643869999, 55.47260163000004],
              [-132.5449112619999, 55.482082424000055],
              [-132.54466712099992, 55.491400458000044],
              [-132.54157467399995, 55.49567291900007],
              [-132.53441321499992, 55.49762604400007],
              [-132.5191137359999, 55.50665924700007],
              [-132.51113847599993, 55.50934479400007],
              [-132.50108801999994, 55.50958893400008],
              [-132.49596106699994, 55.50775788000004],
              [-132.49160722599993, 55.505072333000044],
              [-132.48379472599993, 55.503119208000044],
              [-132.46495520699995, 55.50218333500004],
              [-132.44322669199994, 55.503566799000055],
              [-132.4212133449999, 55.50800202000005],
              [-132.40127519399994, 55.516791083000044],
              [-132.38390051999994, 55.50039297100005],
              [-132.3752335279999, 55.48476797100005],
              [-132.3615616529999, 55.47296784100007],
              [-132.30260169199994, 55.46356842700004],
              [-132.2769262359999, 55.45270416900007],
              [-132.26797441299993, 55.44135163000004],
              [-132.29137122299994, 55.434881903000075],
              [-132.30553137899994, 55.436835028000075],
              [-132.32408606699994, 55.44708893400008],
              [-132.33922278599994, 55.44790273600006],
              [-132.35045325399994, 55.44367096600007],
              [-132.35850989499994, 55.436753648000035],
              [-132.36807206899994, 55.43024323100008],
              [-132.38390051999994, 55.427435614000046],
              [-132.44131425699993, 55.427069403000075],
              [-132.4695531889999, 55.42129140800006],
              [-132.48379472599993, 55.40692780200004],
              [-132.47826087099992, 55.39057038000004],
              [-132.45677649599992, 55.39484284100007],
              [-132.41152910099993, 55.413763739000046],
              [-132.40099036399994, 55.41152578300006],
              [-132.38857988199993, 55.40570709800005],
              [-132.37828528599994, 55.39793528900003],
              [-132.3699438139999, 55.38117096600007],
              [-132.3609106109999, 55.383246161000045],
              [-132.3466690749999, 55.39325592700004],
              [-132.3411352199999, 55.395819403000075],
              [-132.3321020169999, 55.403631903000075],
              [-132.32555091099994, 55.40692780200004],
              [-132.32461503799993, 55.40599192900004],
              [-132.25011145699995, 55.413763739000046],
              [-132.24274654899995, 55.40916575700004],
              [-132.2128800119999, 55.37653229400007],
              [-132.2009985019999, 55.369208075000074],
              [-132.18805904899995, 55.36831289300005],
              [-132.1745499339999, 55.368841864000046],
              [-132.16104081899994, 55.36595286700003],
              [-132.15489661399994, 55.36595286700003],
              [-132.1590063139999, 55.35602448100008],
              [-132.16104081899994, 55.35228099200003],
              [-132.15029863199993, 55.34638092700004],
              [-132.14565995999993, 55.337225653000075],
              [-132.14395097599993, 55.32501862200007],
              [-132.1328832669999, 55.32306549700007],
              [-132.12425696499992, 55.318019924000055],
              [-132.12120520699995, 55.31122467700004],
              [-132.1269425119999, 55.303900458000044],
              [-132.1026098299999, 55.28803131700005],
              [-132.09072831899994, 55.27680084800005],
              [-132.0952856109999, 55.26707591400003],
              [-132.1201065749999, 55.25608958500004],
              [-132.14818274599992, 55.24860260600008],
              [-132.1796768869999, 55.24506256700005],
              [-132.21214758999992, 55.24713776200008],
              [-132.24303137899994, 55.25608958500004],
              [-132.2363175119999, 55.24494049700007],
              [-132.24156653599994, 55.234076239000046],
              [-132.24937903599994, 55.22223541900007],
              [-132.25047766799992, 55.208319403000075],
              [-132.2402237619999, 55.19721100500004],
              [-132.2263891269999, 55.19428131700005],
              [-132.2177628249999, 55.198431708000044],
              [-132.22313391799992, 55.208319403000075],
              [-132.2031143869999, 55.22919342700004],
              [-132.17247473899994, 55.22500234600005],
              [-132.11388098899994, 55.20148346600007],
              [-132.08336341099994, 55.21010976800005],
              [-132.05068925699993, 55.25893789300005],
              [-132.0276586579999, 55.270412502000056],
              [-132.00259355399993, 55.271918036000045],
              [-131.99429277299993, 55.26813385600008],
              [-131.98355058499993, 55.25608958500004],
              [-131.97744706899994, 55.245428778000075],
              [-131.97301184799994, 55.23236725500004],
              [-131.9702042309999, 55.218410549000055],
              [-131.96930904899995, 55.20490143400008],
              [-131.97598222599993, 55.176947333000044],
              [-131.99181067599994, 55.158270575000074],
              [-132.0099991529999, 55.14154694200005],
              [-132.02391516799992, 55.11953359600005],
              [-131.9898168609999, 55.11953359600005],
              [-132.0014542309999, 55.10447825700004],
              [-132.01895097599993, 55.09137604400007],
              [-132.0390518869999, 55.082098700000074],
              [-132.05833899599992, 55.07859935100004],
              [-132.06607011599993, 55.08274974200003],
              [-132.08128821499992, 55.10106028900003],
              [-132.0928442049999, 55.10529205900008],
              [-132.1003311839999, 55.101263739000046],
              [-132.09707597599993, 55.09251536700003],
              [-132.0881241529999, 55.08344147300005],
              [-132.07852128799993, 55.07859935100004],
              [-132.08751380099994, 55.07294342700004],
              [-132.09776770699995, 55.070379950000074],
              [-132.10875403599994, 55.070013739000046],
              [-132.1201065749999, 55.07111237200007],
              [-132.1201065749999, 55.06427643400008],
              [-132.0908910799999, 55.05609772300005],
              [-132.0768936839999, 55.04877350500004],
              [-132.07542883999992, 55.04010651200008],
              [-132.08649654899995, 55.03465403900003],
              [-132.1174210279999, 55.03278229400007],
              [-132.1523331369999, 55.016058661000045],
              [-132.20885169199994, 55.00263092700004],
              [-132.22313391799992, 54.98920319200005],
              [-132.1787817049999, 54.98920319200005],
              [-132.1670629549999, 54.98725006700005],
              [-132.15859941299993, 54.98281484600005],
              [-132.1523331369999, 54.978176174000055],
              [-132.1345922519999, 54.97016022300005],
              [-132.12730872299994, 54.97093333500004],
              [-132.10879472599993, 54.98574453300006],
              [-132.10195878799993, 54.98822663000004],
              [-132.0965063139999, 54.985256252000056],
              [-132.09219316299993, 54.97553131700005],
              [-132.06997636599993, 55.00112539300005],
              [-132.0353897779999, 55.022772528000075],
              [-131.9968155589999, 55.034491278000075],
              [-131.96304277299993, 55.03021881700005],
              [-131.97427324099993, 55.024644273000035],
              [-131.9812719389999, 55.01675039300005],
              [-131.98253333199995, 55.00682200700004],
              [-131.97671464799993, 54.995428778000075],
              [-131.9971410799999, 54.984361070000034],
              [-132.0051977199999, 54.97768789300005],
              [-132.01024329299992, 54.968085028000075],
              [-131.97671464799993, 54.96971263200004],
              [-131.96930904899995, 54.968085028000075],
              [-131.96182206899994, 54.95770905200004],
              [-131.96519934799994, 54.95189036700003],
              [-131.9724828769999, 54.947251695000034],
              [-131.97671464799993, 54.94082265800006],
              [-131.9760636059999, 54.90814850500004],
              [-131.98477128799993, 54.905910549000055],
              [-132.01024329299992, 54.90729401200008],
              [-132.03355872299994, 54.905585028000075],
              [-132.04702714799993, 54.89858633000006],
              [-132.04539954299992, 54.88719310100004],
              [-132.02391516799992, 54.87250397300005],
              [-131.98550370999993, 54.86107005400004],
              [-131.96861731699994, 54.853501695000034],
              [-131.95563717399995, 54.838324286000045],
              [-131.96011308499993, 54.834051825000074],
              [-131.96495520699995, 54.83197663000004],
              [-131.97036699099993, 54.831366278000075],
              [-131.97671464799993, 54.83152903900003],
            ],
          ],
          [
            [
              [-132.61290442599994, 56.40062083500004],
              [-132.62437903599994, 56.387600002000056],
              [-132.6596573559999, 56.36823151200008],
              [-132.6682022779999, 56.352850653000075],
              [-132.66392981699994, 56.341864325000074],
              [-132.63463294199994, 56.30442942900004],
              [-132.6472061839999, 56.282416083000044],
              [-132.6679581369999, 56.274603583000044],
              [-132.6916397779999, 56.270697333000044],
              [-132.7327367829999, 56.251654364000046],
              [-132.8196508449999, 56.23615143400008],
              [-132.86888587099992, 56.243475653000075],
              [-132.99087480399993, 56.31191640800006],
              [-133.0388891269999, 56.330511786000045],
              [-133.05524654899995, 56.34479401200008],
              [-133.04893958199995, 56.36277903900003],
              [-132.99282792899993, 56.41860586100006],
              [-132.96983801999994, 56.434800523000035],
              [-132.94668535099993, 56.44578685100004],
              [-132.92422441299993, 56.45197174700007],
              [-132.87425696499992, 56.45526764500005],
              [-132.85757402299993, 56.45327383000006],
              [-132.82559160099993, 56.44428131700005],
              [-132.80874589799993, 56.44220612200007],
              [-132.79674231699994, 56.44391510600008],
              [-132.75755774599992, 56.45526764500005],
              [-132.7029516269999, 56.462103583000044],
              [-132.65290279899995, 56.44867584800005],
              [-132.6408585279999, 56.44220612200007],
              [-132.63267981699994, 56.43065013200004],
              [-132.62340247299994, 56.40875885600008],
              [-132.61290442599994, 56.40062083500004],
            ],
          ],
          [
            [
              [-132.00401770699995, 56.339178778000075],
              [-131.99274654899995, 56.322333075000074],
              [-131.97769120999993, 56.28546784100007],
              [-131.94009355399993, 56.23305898600006],
              [-131.9280492829999, 56.21051666900007],
              [-131.92833411399994, 56.194566148000035],
              [-131.9522192049999, 56.18585846600007],
              [-131.9768774079999, 56.19090403900003],
              [-131.99620520699995, 56.18854401200008],
              [-132.00401770699995, 56.15737539300005],
              [-132.0132543609999, 56.14134349200003],
              [-132.03429114499994, 56.12832265800006],
              [-132.05728105399993, 56.120347398000035],
              [-132.0723363919999, 56.11945221600007],
              [-132.0850317049999, 56.132147528000075],
              [-132.09072831899994, 56.148871161000045],
              [-132.0991918609999, 56.16290924700007],
              [-132.1201065749999, 56.16791413000004],
              [-132.11803137899994, 56.15672435100004],
              [-132.12877356699994, 56.15814850500004],
              [-132.14464270699995, 56.16705963700008],
              [-132.15794837099992, 56.17812734600005],
              [-132.1757706369999, 56.189439195000034],
              [-132.24303137899994, 56.202053127000056],
              [-132.27041581899994, 56.21401601800005],
              [-132.3064672519999, 56.23456452000005],
              [-132.33824622299994, 56.257798570000034],
              [-132.35289466099994, 56.277777411000045],
              [-132.3271378249999, 56.33026764500005],
              [-132.33018958199995, 56.34243398600006],
              [-132.3466690749999, 56.35968659100007],
              [-132.3465063139999, 56.370428778000075],
              [-132.34235592399995, 56.37689850500004],
              [-132.33702551999994, 56.38336823100008],
              [-132.3329971999999, 56.393784898000035],
              [-132.33336341099994, 56.40794505400004],
              [-132.3389379549999, 56.42243073100008],
              [-132.3491918609999, 56.437160549000055],
              [-132.36339270699995, 56.45184967700004],
              [-132.37661699099993, 56.471869208000044],
              [-132.37535559799994, 56.48847077000005],
              [-132.3620499339999, 56.494574286000045],
              [-132.33922278599994, 56.48322174700007],
              [-132.26089433499993, 56.45892975500004],
              [-132.23989824099993, 56.445298570000034],
              [-132.2276098299999, 56.42926666900007],
              [-132.20913652299993, 56.39545319200005],
              [-132.19587154899995, 56.380194403000075],
              [-132.17813066299993, 56.36713288000004],
              [-132.15151933499993, 56.351996161000045],
              [-132.12389075399994, 56.34320709800005],
              [-132.1030167309999, 56.34910716400003],
              [-132.0808813139999, 56.361314195000034],
              [-132.0528051419999, 56.36204661700003],
              [-132.02513587099992, 56.35390859600005],
              [-132.00401770699995, 56.339178778000075],
            ],
          ],
          [
            [
              [-154.0558162099999, 56.53034088700008],
              [-154.04364986899992, 56.54759349200003],
              [-154.02045650899993, 56.55548737200007],
              [-153.87714596299992, 56.56513092700004],
              [-153.87714596299992, 56.552069403000075],
              [-153.89350338399993, 56.535223700000074],
              [-153.92817135299993, 56.51666901200008],
              [-153.96568762899992, 56.50462474200003],
              [-153.99071204299992, 56.507066148000035],
              [-154.00597083199992, 56.513006903000075],
              [-154.02464758999992, 56.511053778000075],
              [-154.05927486899992, 56.50364817900004],
              [-154.1003311839999, 56.502386786000045],
              [-154.1205948559999, 56.50413646000004],
              [-154.1378067699999, 56.51048411700003],
              [-154.11908932199992, 56.52374909100007],
              [-154.0931290359999, 56.53668854400007],
              [-154.06904049399992, 56.54140859600005],
              [-154.0558162099999, 56.53034088700008],
            ],
          ],
          [
            [
              [-157.06061764199993, 56.58222077000005],
              [-157.04474850199992, 56.57298411700003],
              [-157.0087784499999, 56.56395091400003],
              [-156.99238033799992, 56.55516185100004],
              [-156.97826087099992, 56.53652578300006],
              [-156.98835201699993, 56.530585028000075],
              [-157.00629635299993, 56.53343333500004],
              [-157.02594967399992, 56.54995351800005],
              [-157.04893958199992, 56.55292389500005],
              [-157.13947506399992, 56.552069403000075],
              [-157.1454971999999, 56.548895575000074],
              [-157.15587317599991, 56.534409898000035],
              [-157.15998287699992, 56.53034088700008],
              [-157.1685684889999, 56.531236070000034],
              [-157.17792721299992, 56.53583405200004],
              [-157.1877335279999, 56.53864166900007],
              [-157.2054337229999, 56.530178127000056],
              [-157.30870520699992, 56.53066640800006],
              [-157.33124752499992, 56.52415599200003],
              [-157.32709713399993, 56.534857489000046],
              [-157.31757564999992, 56.548488674000055],
              [-157.30711829299992, 56.560207424000055],
              [-157.30052649599992, 56.56513092700004],
              [-157.28636633999992, 56.56867096600007],
              [-157.2592667309999, 56.58340078300006],
              [-157.24250240799992, 56.585638739000046],
              [-157.2026261059999, 56.582098700000074],
              [-157.09858150899993, 56.59398021000004],
              [-157.06061764199993, 56.58222077000005],
            ],
          ],
          [
            [
              [-154.4251602859999, 56.593044338000084],
              [-154.41563880099991, 56.58746979400007],
              [-154.40790768099993, 56.579006252000056],
              [-154.40208899599992, 56.56883372600004],
              [-154.39850826699993, 56.558294989000046],
              [-154.41063391799992, 56.54759349200003],
              [-154.4240616529999, 56.54140859600005],
              [-154.44013424399992, 56.53851959800005],
              [-154.4466446609999, 56.53864166900007],
              [-154.43451900899993, 56.54181549700007],
              [-154.4247940749999, 56.548041083000044],
              [-154.41901607999992, 56.558294989000046],
              [-154.4302872389999, 56.55678945500006],
              [-154.44074459499993, 56.55414459800005],
              [-154.45051021999993, 56.55023834800005],
              [-154.4599503249999, 56.54466380400004],
              [-154.44281979099992, 56.58120351800005],
              [-154.4748429029999, 56.598089911000045],
              [-154.5167130199999, 56.59015534100007],
              [-154.52887936099992, 56.552069403000075],
              [-154.49799557199992, 56.53066640800006],
              [-154.48753821499992, 56.516791083000044],
              [-154.50495357999992, 56.51048411700003],
              [-154.53099524599992, 56.50800202000005],
              [-154.5596817699999, 56.50153229400007],
              [-154.61078854099992, 56.48322174700007],
              [-154.67072506399992, 56.44122955900008],
              [-154.6998184889999, 56.42690664300005],
              [-154.71690833199992, 56.41087474200003],
              [-154.73822994699992, 56.39826080900008],
              [-154.7678116529999, 56.40062083500004],
              [-154.7912491529999, 56.430853583000044],
              [-154.7704971999999, 56.47085195500006],
              [-154.7314346999999, 56.50820547100005],
              [-154.70014400899993, 56.53034088700008],
              [-154.53632564999992, 56.59760163000004],
              [-154.49933834499993, 56.605454820000034],
              [-154.46141516799992, 56.60537344000005],
              [-154.4251602859999, 56.593044338000084],
            ],
          ],
          [
            [
              [-154.08259029899992, 56.552069403000075],
              [-154.0905655589999, 56.54669830900008],
              [-154.1389054029999, 56.531683661000045],
              [-154.14155025899993, 56.53034088700008],
              [-154.15831458199992, 56.52619049700007],
              [-154.1913956369999, 56.507879950000074],
              [-154.2100723949999, 56.50364817900004],
              [-154.28014075399992, 56.50657786700003],
              [-154.3221329419999, 56.51508209800005],
              [-154.33381100199992, 56.519598700000074],
              [-154.34162350199992, 56.52814362200007],
              [-154.35008704299992, 56.54466380400004],
              [-154.3377579419999, 56.56391022300005],
              [-154.3104141919999, 56.58380768400008],
              [-154.27900143099993, 56.59780508000006],
              [-154.24767005099991, 56.60610586100006],
              [-154.22618567599991, 56.60834381700005],
              [-154.16572018099993, 56.60610586100006],
              [-154.12409420499992, 56.612616278000075],
              [-154.1030167309999, 56.61318594000005],
              [-154.08259029899992, 56.60610586100006],
              [-154.07746334499993, 56.591782945000034],
              [-154.06843014199993, 56.580511786000045],
              [-154.0580948559999, 56.57013580900008],
              [-154.0490616529999, 56.558294989000046],
              [-154.08075924399992, 56.57684967700004],
              [-154.09345455599993, 56.57880280200004],
              [-154.10399329299992, 56.57489655200004],
              [-154.10204016799992, 56.56614817900004],
              [-154.09308834499993, 56.557074286000045],
              [-154.08259029899992, 56.552069403000075],
            ],
          ],
          [
            [
              [-132.95958411399994, 56.787990627000056],
              [-132.96279863199993, 56.79979075700004],
              [-132.95152747299994, 56.81045156500005],
              [-132.92202714799993, 56.825832424000055],
              [-132.88223222599993, 56.80117422100005],
              [-132.87051347599993, 56.79783763200004],
              [-132.83364824099993, 56.79913971600007],
              [-132.81631425699993, 56.79734935100004],
              [-132.7519425119999, 56.75922272300005],
              [-132.74388587099992, 56.746975002000056],
              [-132.73326575399994, 56.72597890800006],
              [-132.7097875639999, 56.70990631700005],
              [-132.6862686839999, 56.69867584800005],
              [-132.67564856699994, 56.69208405200004],
              [-132.6714574859999, 56.68382396000004],
              [-132.66152910099993, 56.67963288000004],
              [-132.6408585279999, 56.674994208000044],
              [-132.6291397779999, 56.66901276200008],
              [-132.6233617829999, 56.665269273000035],
              [-132.6083878249999, 56.64801666900007],
              [-132.5991918609999, 56.63377513200004],
              [-132.5930883449999, 56.62653229400007],
              [-132.5838110019999, 56.61810944200005],
              [-132.5772192049999, 56.61408112200007],
              [-132.55833899599992, 56.60610586100006],
              [-132.54849199099993, 56.60374583500004],
              [-132.53970292899993, 56.603501695000034],
              [-132.5334366529999, 56.60032786700003],
              [-132.53099524599992, 56.58930084800005],
              [-132.5334366529999, 56.58030833500004],
              [-132.53945878799993, 56.57640208500004],
              [-132.54735266799992, 56.573879299000055],
              [-132.55524654899995, 56.56854889500005],
              [-132.5737198559999, 56.559475002000056],
              [-132.62157141799992, 56.55573151200008],
              [-132.6377660799999, 56.54840729400007],
              [-132.6504613919999, 56.53705475500004],
              [-132.66616777299993, 56.529730536000045],
              [-132.68399003799993, 56.52716705900008],
              [-132.7029516269999, 56.53034088700008],
              [-132.7178442049999, 56.54096100500004],
              [-132.73204505099994, 56.55451080900008],
              [-132.7470596999999, 56.55951569200005],
              [-132.7643936839999, 56.54466380400004],
              [-132.73013261599993, 56.521185614000046],
              [-132.72276770699995, 56.51048411700003],
              [-132.7405492829999, 56.508246161000045],
              [-132.7736710279999, 56.49909088700008],
              [-132.79165605399993, 56.49689362200007],
              [-132.91860917899993, 56.507025458000044],
              [-132.9374893869999, 56.517564195000034],
              [-132.94517981699994, 56.53656647300005],
              [-132.95449785099993, 56.59227122600004],
              [-132.9522192049999, 56.601629950000074],
              [-132.94249426999994, 56.612941799000055],
              [-132.9280492829999, 56.61969635600008],
              [-132.8908585279999, 56.62938060100004],
              [-132.8810929029999, 56.64020416900007],
              [-132.88658606699994, 56.65058014500005],
              [-132.92202714799993, 56.688666083000044],
              [-132.9241430329999, 56.70221588700008],
              [-132.9234106109999, 56.71792226800005],
              [-132.9201554029999, 56.73281484600005],
              [-132.91462154899995, 56.743841864000046],
              [-132.92442786399994, 56.75755442900004],
              [-132.95958411399994, 56.787990627000056],
            ],
          ],
          [
            [
              [-133.88467363199993, 56.49005768400008],
              [-133.86929277299993, 56.48680247600004],
              [-133.86290442599994, 56.478583075000074],
              [-133.8596085279999, 56.46735260600008],
              [-133.85366777299993, 56.45526764500005],
              [-133.84780839799993, 56.45062897300005],
              [-133.8257543609999, 56.44220612200007],
              [-133.8452042309999, 56.43439362200007],
              [-133.88784745999993, 56.44009023600006],
              [-133.9089249339999, 56.434800523000035],
              [-133.89736894399994, 56.42430247600004],
              [-133.8835343089999, 56.41844310100004],
              [-133.87535559799994, 56.410589911000045],
              [-133.88097083199995, 56.393784898000035],
              [-133.88784745999993, 56.392645575000074],
              [-133.89879309799994, 56.39447663000004],
              [-133.90957597599993, 56.39081452000005],
              [-133.91637122299994, 56.37335846600007],
              [-133.8593643869999, 56.35911692900004],
              [-133.8437393869999, 56.34910716400003],
              [-133.8416235019999, 56.337591864000046],
              [-133.8535863919999, 56.31049225500004],
              [-133.8474828769999, 56.29824453300006],
              [-133.8689672519999, 56.28473541900007],
              [-133.8987524079999, 56.306341864000046],
              [-133.93024654899995, 56.33930084800005],
              [-133.95669511599993, 56.35968659100007],
              [-133.97252356699994, 56.36050039300005],
              [-133.97508704299992, 56.35138580900008],
              [-133.97191321499992, 56.33616771000004],
              [-133.97036699099993, 56.31875234600005],
              [-133.97594153599994, 56.296210028000075],
              [-133.9812719389999, 56.28388092700004],
              [-133.9785050119999, 56.27875397300005],
              [-133.95982825399994, 56.277777411000045],
              [-133.92308508999992, 56.28082916900007],
              [-133.90811113199993, 56.27635325700004],
              [-133.8919164699999, 56.229803778000075],
              [-133.8955785799999, 56.219956773000035],
              [-133.94383704299992, 56.21198151200008],
              [-133.94469153599994, 56.201605536000045],
              [-133.92625891799992, 56.173488674000055],
              [-133.9202367829999, 56.166896877000056],
              [-133.91616777299993, 56.15900299700007],
              [-133.9195043609999, 56.15053945500006],
              [-133.9377335279999, 56.13703034100007],
              [-133.9409887359999, 56.130194403000075],
              [-133.9356176419999, 56.11945221600007],
              [-133.9414770169999, 56.10309479400007],
              [-133.94912675699993, 56.09235260600008],
              [-133.9612524079999, 56.08649323100008],
              [-133.98033606699994, 56.08466217700004],
              [-133.9939672519999, 56.087876695000034],
              [-134.03050696499992, 56.104722398000035],
              [-134.0392960279999, 56.112616278000075],
              [-134.0366918609999, 56.12319570500006],
              [-134.0092667309999, 56.18512604400007],
              [-134.01724199099993, 56.196966864000046],
              [-134.0301000639999, 56.20722077000005],
              [-134.0392960279999, 56.21629466400003],
              [-134.03799394399994, 56.238714911000045],
              [-134.03184973899994, 56.27456289300005],
              [-134.03258216099994, 56.30683014500005],
              [-134.0523168609999, 56.31875234600005],
              [-134.0690811839999, 56.302801825000074],
              [-134.0676977199999, 56.27399323100008],
              [-134.07241777299993, 56.24860260600008],
              [-134.10753333199995, 56.24298737200007],
              [-134.09024003799993, 56.192694403000075],
              [-134.12197831899994, 56.179754950000074],
              [-134.16710364499994, 56.18211497600004],
              [-134.19009355399993, 56.17812734600005],
              [-134.1621801419999, 56.139960028000075],
              [-134.1506241529999, 56.13694896000004],
              [-134.14541581899994, 56.139960028000075],
              [-134.14098059799994, 56.14484284100007],
              [-134.1311742829999, 56.14740631700005],
              [-134.1035863919999, 56.140285549000055],
              [-134.09972083199995, 56.12384674700007],
              [-134.10045325399994, 56.10529205900008],
              [-134.08641516799992, 56.09218984600005],
              [-134.09194902299993, 56.08270905200004],
              [-134.10049394399994, 56.07607656500005],
              [-134.12120520699995, 56.06484609600005],
              [-134.10798092399995, 56.05304596600007],
              [-134.10098222599993, 56.03229401200008],
              [-134.10240637899994, 56.01072825700004],
              [-134.11436926999994, 55.99656810100004],
              [-134.12938391799992, 55.99945709800005],
              [-134.14858964799993, 56.01166413000004],
              [-134.1575414699999, 56.02814362200007],
              [-134.1416723299999, 56.04376862200007],
              [-134.16323808499993, 56.053615627000056],
              [-134.21068274599992, 56.06281159100007],
              [-134.22423255099994, 56.07851797100005],
              [-134.2100317049999, 56.087225653000075],
              [-134.2077530589999, 56.09857819200005],
              [-134.21621660099993, 56.10838450700004],
              [-134.2342016269999, 56.112616278000075],
              [-134.23688717399995, 56.11810944200005],
              [-134.2254125639999, 56.130194403000075],
              [-134.20006262899994, 56.15053945500006],
              [-134.19717363199993, 56.16205475500004],
              [-134.2127172519999, 56.16836172100005],
              [-134.2312719389999, 56.17011139500005],
              [-134.2372940749999, 56.16791413000004],
              [-134.24730383999992, 56.17837148600006],
              [-134.25011145699995, 56.18817780200004],
              [-134.2515356109999, 56.21629466400003],
              [-134.2551977199999, 56.22846100500004],
              [-134.26305091099994, 56.24628327000005],
              [-134.26455644399994, 56.26040273600006],
              [-134.25723222599993, 56.27163320500006],
              [-134.22476152299993, 56.25763580900008],
              [-134.21739661399994, 56.267238674000055],
              [-134.21719316299993, 56.28229401200008],
              [-134.2146703769999, 56.29132721600007],
              [-134.20665442599994, 56.29759349200003],
              [-134.19009355399993, 56.30442942900004],
              [-134.16441809799994, 56.30609772300005],
              [-134.16006425699993, 56.31240469000005],
              [-134.16958574099993, 56.33234284100007],
              [-134.18407141799992, 56.326157945000034],
              [-134.23106848899994, 56.31191640800006],
              [-134.24461829299992, 56.30149974200003],
              [-134.2515356109999, 56.29824453300006],
              [-134.26211503799993, 56.29531484600005],
              [-134.27208411399994, 56.29389069200005],
              [-134.2819718089999, 56.29466380400004],
              [-134.2925512359999, 56.29824453300006],
              [-134.2925512359999, 56.30442942900004],
              [-134.25991777299993, 56.31590403900003],
              [-134.26598059799994, 56.33055247600004],
              [-134.2827042309999, 56.34662506700005],
              [-134.2819718089999, 56.36277903900003],
              [-134.27017167899993, 56.36570872600004],
              [-134.23770097599993, 56.36554596600007],
              [-134.23106848899994, 56.36961497600004],
              [-134.23916581899994, 56.40448639500005],
              [-134.2372940749999, 56.41429271000004],
              [-134.22842363199993, 56.42023346600007],
              [-134.21849524599992, 56.41673411700003],
              [-134.20767167899993, 56.41054922100005],
              [-134.1962784499999, 56.40810781500005],
              [-134.1804093089999, 56.41250234600005],
              [-134.1772354809999, 56.41868724200003],
              [-134.18024654899995, 56.42723216400003],
              [-134.1826879549999, 56.43854401200008],
              [-134.17837480399993, 56.44135163000004],
              [-134.1690160799999, 56.43463776200008],
              [-134.15957597599993, 56.42300039300005],
              [-134.1553442049999, 56.41120026200008],
              [-134.1553442049999, 56.36591217700004],
              [-134.14622962099992, 56.37368398600006],
              [-134.11436926999994, 56.393784898000035],
              [-134.11538652299993, 56.39606354400007],
              [-134.11632239499994, 56.40094635600008],
              [-134.11363684799994, 56.40582916900007],
              [-134.10411536399994, 56.40810781500005],
              [-134.08023027299993, 56.40062083500004],
              [-134.06948808499993, 56.38959381700005],
              [-134.0603735019999, 56.37592194200005],
              [-134.05089270699995, 56.36774323100008],
              [-134.0392960279999, 56.37335846600007],
              [-134.03600012899994, 56.38304271000004],
              [-134.03604081899994, 56.40961334800005],
              [-134.03184973899994, 56.421128648000035],
              [-134.04092363199993, 56.432806708000044],
              [-134.06041419199994, 56.44806549700007],
              [-134.06655839799993, 56.462103583000044],
              [-134.0673721999999, 56.47760651200008],
              [-134.0615942049999, 56.48432038000004],
              [-134.0495499339999, 56.48338450700004],
              [-134.03184973899994, 56.47573476800005],
              [-134.03441321499992, 56.48590729400007],
              [-134.0397843089999, 56.497300523000035],
              [-134.0471899079999, 56.50665924700007],
              [-134.05601966099994, 56.51048411700003],
              [-134.05947831899994, 56.515285549000055],
              [-134.06419837099992, 56.53750234600005],
              [-134.06655839799993, 56.54466380400004],
              [-134.08177649599992, 56.55158112200007],
              [-134.09264075399994, 56.53595612200007],
              [-134.10411536399994, 56.51284414300005],
              [-134.12120520699995, 56.49689362200007],
              [-134.13914954299992, 56.49872467700004],
              [-134.15566972599993, 56.51235586100006],
              [-134.17223059799994, 56.530178127000056],
              [-134.19009355399993, 56.54466380400004],
              [-134.21800696499992, 56.55678945500006],
              [-134.24693762899994, 56.563381252000056],
              [-134.27647864499994, 56.56403229400007],
              [-134.3061417309999, 56.558294989000046],
              [-134.3061417309999, 56.56513092700004],
              [-134.2276098299999, 56.607407945000034],
              [-134.18407141799992, 56.61591217700004],
              [-134.15953528599994, 56.62995026200008],
              [-134.1416723299999, 56.633978583000044],
              [-134.10610917899993, 56.628973700000074],
              [-134.0933324859999, 56.63153717700004],
              [-134.08641516799992, 56.64704010600008],
              [-134.11681067599994, 56.65379466400003],
              [-134.1440323559999, 56.65192291900007],
              [-134.22472083199995, 56.62368398600006],
              [-134.2468969389999, 56.62010325700004],
              [-134.26602128799993, 56.62685781500005],
              [-134.28571529899995, 56.64704010600008],
              [-134.2634985019999, 56.65542226800005],
              [-134.2412817049999, 56.65607330900008],
              [-134.22423255099994, 56.66168854400007],
              [-134.21739661399994, 56.684881903000075],
              [-134.2227270169999, 56.69440338700008],
              [-134.23448645699995, 56.696966864000046],
              [-134.24624589799993, 56.695379950000074],
              [-134.2515356109999, 56.69208405200004],
              [-134.25357011599993, 56.67633698100008],
              [-134.25987708199995, 56.67059967700004],
              [-134.30675208199995, 56.66575755400004],
              [-134.3339737619999, 56.66836172100005],
              [-134.35757402299993, 56.67658112200007],
              [-134.36758378799993, 56.69208405200004],
              [-134.39183508999992, 56.71906159100007],
              [-134.39708411399994, 56.72955963700008],
              [-134.39513098899994, 56.74164459800005],
              [-134.38809160099993, 56.75690338700008],
              [-134.39118404899995, 56.78009674700007],
              [-134.40538489499994, 56.81976959800005],
              [-134.40855872299994, 56.84292226800005],
              [-134.40566972599993, 56.85268789300005],
              [-134.39830481699994, 56.860256252000056],
              [-134.3884985019999, 56.86505768400008],
              [-134.37816321499992, 56.866848049000055],
              [-134.3611547519999, 56.86359284100007],
              [-134.35098222599993, 56.85541413000004],
              [-134.3334854809999, 56.832017320000034],
              [-134.30064856699994, 56.80341217700004],
              [-134.28087317599994, 56.79279205900008],
              [-134.27204342399995, 56.80158112200007],
              [-134.27721106699994, 56.82135651200008],
              [-134.2897843089999, 56.83478424700007],
              [-134.30528723899994, 56.84625885600008],
              [-134.31920325399994, 56.85993073100008],
              [-134.32823645699995, 56.888739325000074],
              [-134.3061417309999, 56.89789459800005],
              [-134.2342016269999, 56.89411041900007],
              [-134.22032630099994, 56.889960028000075],
              [-134.1826879549999, 56.85993073100008],
              [-134.1668188139999, 56.85398997600004],
              [-134.1465551419999, 56.848944403000075],
              [-134.12555904899995, 56.84601471600007],
              [-134.10753333199995, 56.84634023600006],
              [-134.10753333199995, 56.85309479400007],
              [-134.12193762899994, 56.86200592700004],
              [-134.1414281889999, 56.88495514500005],
              [-134.1553442049999, 56.89411041900007],
              [-134.19713294199994, 56.90033600500004],
              [-134.21344967399995, 56.907131252000056],
              [-134.21056067599994, 56.92202383000006],
              [-134.2234594389999, 56.929022528000075],
              [-134.26455644399994, 56.94188060100004],
              [-134.23961341099994, 56.94114817900004],
              [-134.1758520169999, 56.92202383000006],
              [-134.12832597599993, 56.91705963700008],
              [-134.10594641799992, 56.91225820500006],
              [-134.08641516799992, 56.90033600500004],
              [-134.0517471999999, 56.89520905200004],
              [-134.0126846999999, 56.88515859600005],
              [-133.98668372299994, 56.86562734600005],
              [-133.99083411399994, 56.832017320000034],
              [-133.97126217399995, 56.83641185100004],
              [-133.96410071499992, 56.83112213700008],
              [-133.95669511599993, 56.79783763200004],
              [-133.9514867829999, 56.802394924000055],
              [-133.94102942599994, 56.807847398000035],
              [-133.9356176419999, 56.812201239000046],
              [-133.93008378799993, 56.80158112200007],
              [-133.9192602199999, 56.77024974200003],
              [-133.91266842399995, 56.763739325000074],
              [-133.90489661399994, 56.760646877000056],
              [-133.90485592399995, 56.75385163000004],
              [-133.90933183499993, 56.746975002000056],
              [-133.92300370999993, 56.74070872600004],
              [-133.9228409499999, 56.73309967700004],
              [-133.92080644399994, 56.723944403000075],
              [-133.9225968089999, 56.71596914300005],
              [-133.9273168609999, 56.712225653000075],
              [-133.9387914699999, 56.70620351800005],
              [-133.94302324099993, 56.702337958000044],
              [-133.9550675119999, 56.67841217700004],
              [-133.95982825399994, 56.67129140800006],
              [-133.9726456369999, 56.660142320000034],
              [-133.98717200399994, 56.655178127000056],
              [-134.02501380099994, 56.65387604400007],
              [-133.99376380099994, 56.63922760600008],
              [-133.9643448559999, 56.64325592700004],
              [-133.93809973899994, 56.659369208000044],
              [-133.91637122299994, 56.68121979400007],
              [-133.9162491529999, 56.687201239000046],
              [-133.91982988199993, 56.69415924700007],
              [-133.92076575399994, 56.69989655200004],
              [-133.91266842399995, 56.702337958000044],
              [-133.90318762899994, 56.70327383000006],
              [-133.8854874339999, 56.70750560100004],
              [-133.87755286399994, 56.70856354400007],
              [-133.87075761599993, 56.714911200000074],
              [-133.8631078769999, 56.729681708000044],
              [-133.85667883999992, 56.74591705900008],
              [-133.85366777299993, 56.75690338700008],
              [-133.8582250639999, 56.78025950700004],
              [-133.86587480399993, 56.80097077000005],
              [-133.8623754549999, 56.809881903000075],
              [-133.83315995999993, 56.79783763200004],
              [-133.81305904899995, 56.78148021000004],
              [-133.80117753799993, 56.777004299000055],
              [-133.76842200399994, 56.78571198100008],
              [-133.75015214799993, 56.78375885600008],
              [-133.73253333199995, 56.77814362200007],
              [-133.71715247299994, 56.771185614000046],
              [-133.77513587099992, 56.698879299000055],
              [-133.7803442049999, 56.686428127000056],
              [-133.77310136599993, 56.67645905200004],
              [-133.7600805329999, 56.669907945000034],
              [-133.73216712099992, 56.66315338700008],
              [-133.72862708199995, 56.65306224200003],
              [-133.7302953769999, 56.641791083000044],
              [-133.73013261599993, 56.633978583000044],
              [-133.70567786399994, 56.60415273600006],
              [-133.70954342399995, 56.59471263200004],
              [-133.7359106109999, 56.56712474200003],
              [-133.7454320949999, 56.56195709800005],
              [-133.75694739499994, 56.55914948100008],
              [-133.7717992829999, 56.558294989000046],
              [-133.77969316299993, 56.563381252000056],
              [-133.79210364499994, 56.58869049700007],
              [-133.7990616529999, 56.59870026200008],
              [-133.82384192599994, 56.60773346600007],
              [-133.9051000639999, 56.620347398000035],
              [-133.9225968089999, 56.61664459800005],
              [-133.9103897779999, 56.60146719000005],
              [-133.8577367829999, 56.58746979400007],
              [-133.8474828769999, 56.56513092700004],
              [-133.85195878799993, 56.56391022300005],
              [-133.8718969389999, 56.53595612200007],
              [-133.87417558499993, 56.53034088700008],
              [-133.8865453769999, 56.52440013200004],
              [-133.9092504549999, 56.52008698100008],
              [-133.9195043609999, 56.51361725500004],
              [-133.9202367829999, 56.505194403000075],
              [-133.9101456369999, 56.49754466400003],
              [-133.8959854809999, 56.49213288000004],
              [-133.88467363199993, 56.49005768400008],
            ],
          ],
          [
            [
              [-133.91266842399995, 57.08274974200003],
              [-133.9007055329999, 57.08934153900003],
              [-133.8870336579999, 57.09003327000005],
              [-133.7646378249999, 57.07680898600006],
              [-133.6719457669999, 57.060248114000046],
              [-133.58287512899994, 57.050034898000035],
              [-133.54580644399994, 57.03807200700004],
              [-133.49058997299994, 57.031236070000034],
              [-133.46471106699994, 57.02456289300005],
              [-133.41348222599993, 57.00332265800006],
              [-133.3881729809999, 56.99713776200008],
              [-133.33511308499993, 56.997381903000075],
              [-133.3159073559999, 56.99087148600006],
              [-133.29873613199993, 56.969183661000045],
              [-133.29043535099993, 56.95075104400007],
              [-133.27989661399994, 56.93333567900004],
              [-133.2632543609999, 56.92527903900003],
              [-133.23672441299993, 56.93504466400003],
              [-133.27525794199994, 56.96625397300005],
              [-133.2932836579999, 56.988348700000074],
              [-133.29873613199993, 57.010199286000045],
              [-133.23912512899994, 56.99640534100007],
              [-133.10912024599992, 56.99872467700004],
              [-133.05235755099994, 56.982855536000045],
              [-133.04332434799994, 56.96580638200004],
              [-133.0252172519999, 56.950506903000075],
              [-133.0026749339999, 56.93935781500005],
              [-132.98037675699993, 56.93504466400003],
              [-132.96996008999992, 56.92597077000005],
              [-132.95592200399994, 56.90509674700007],
              [-132.93565833199995, 56.866848049000055],
              [-132.9370011059999, 56.85028717700004],
              [-132.94863847599993, 56.83462148600006],
              [-132.96666419199994, 56.82294342700004],
              [-132.98717200399994, 56.818426825000074],
              [-132.99107825399994, 56.80841705900008],
              [-132.9792374339999, 56.786810614000046],
              [-132.95616614499994, 56.75690338700008],
              [-132.95274817599994, 56.74673086100006],
              [-132.94908606699994, 56.709051825000074],
              [-132.95083574099993, 56.70197174700007],
              [-132.94933020699995, 56.69546133000006],
              [-132.94619706899994, 56.691066799000055],
              [-132.9416397779999, 56.68764883000006],
              [-132.9374893869999, 56.68382396000004],
              [-132.93565833199995, 56.67812734600005],
              [-132.93394934799994, 56.64158763200004],
              [-132.9413956369999, 56.62653229400007],
              [-132.96300208199995, 56.612941799000055],
              [-132.97350012899994, 56.609442450000074],
              [-132.99917558499993, 56.605536200000074],
              [-133.0108129549999, 56.60610586100006],
              [-133.02464758999992, 56.61273834800005],
              [-133.0501195949999, 56.63532135600008],
              [-133.0620011059999, 56.64020416900007],
              [-133.08556067599994, 56.646144924000055],
              [-133.1109106109999, 56.660589911000045],
              [-133.18565833199995, 56.72162506700005],
              [-133.19810950399994, 56.736761786000045],
              [-133.20742753799993, 56.77094147300005],
              [-133.21841386599993, 56.78766510600008],
              [-133.23363196499992, 56.80190664300005],
              [-133.25035559799994, 56.812201239000046],
              [-133.2578832669999, 56.80068594000005],
              [-133.27599036399994, 56.80463288000004],
              [-133.33128821499992, 56.83437734600005],
              [-133.3464249339999, 56.837591864000046],
              [-133.35073808499993, 56.83226146000004],
              [-133.32363847599993, 56.79905833500004],
              [-133.32241777299993, 56.78668854400007],
              [-133.3257543609999, 56.77562083500004],
              [-133.32673092399995, 56.763739325000074],
              [-133.31969153599994, 56.75023021000004],
              [-133.30508378799993, 56.73541901200008],
              [-133.28673255099994, 56.72711823100008],
              [-133.2683813139999, 56.73305898600006],
              [-133.2510473299999, 56.74274323100008],
              [-133.2343643869999, 56.74201080900008],
              [-133.22179114499994, 56.731634833000044],
              [-133.2168676419999, 56.712225653000075],
              [-133.2168676419999, 56.67812734600005],
              [-133.22085527299993, 56.67011139500005],
              [-133.23912512899994, 56.65737539300005],
              [-133.2441300119999, 56.64704010600008],
              [-133.24233964799993, 56.634100653000075],
              [-133.23521887899994, 56.63556549700007],
              [-133.22744706899994, 56.64276764500005],
              [-133.2237035799999, 56.64704010600008],
              [-133.21263587099992, 56.64638906500005],
              [-133.19225012899994, 56.64142487200007],
              [-133.1619360019999, 56.63808828300006],
              [-133.1328832669999, 56.63165924700007],
              [-133.10708574099993, 56.62099844000005],
              [-133.09337317599994, 56.60610586100006],
              [-133.1070043609999, 56.59870026200008],
              [-133.12002519399994, 56.60504791900007],
              [-133.13589433499993, 56.60984935100004],
              [-133.15269934799994, 56.61273834800005],
              [-133.16844641799992, 56.612941799000055],
              [-133.16844641799992, 56.60610586100006],
              [-133.1140844389999, 56.593003648000035],
              [-133.10073808499993, 56.585638739000046],
              [-133.09390214799993, 56.57367584800005],
              [-133.0869848299999, 56.54364655200004],
              [-133.0790909499999, 56.53034088700008],
              [-133.1343481109999, 56.53034088700008],
              [-133.12441972599993, 56.51072825700004],
              [-133.1238500639999, 56.49176666900007],
              [-133.1319067049999, 56.47500234600005],
              [-133.1479386059999, 56.462103583000044],
              [-133.16002356699994, 56.45770905200004],
              [-133.17296301999994, 56.45575592700004],
              [-133.1995336579999, 56.45526764500005],
              [-133.2237035799999, 56.462103583000044],
              [-133.22887122299994, 56.46552155200004],
              [-133.23302161399994, 56.47011953300006],
              [-133.23668372299994, 56.47573476800005],
              [-133.26431230399993, 56.47907135600008],
              [-133.31997636599993, 56.471991278000075],
              [-133.34658769399994, 56.47573476800005],
              [-133.35789954299992, 56.48379140800006],
              [-133.36266028599994, 56.49298737200007],
              [-133.36904863199993, 56.50055573100008],
              [-133.3850805329999, 56.50364817900004],
              [-133.43594316299993, 56.50364817900004],
              [-133.42662512899994, 56.49876536700003],
              [-133.41885331899994, 56.49266185100004],
              [-133.4128311839999, 56.48509349200003],
              [-133.40859941299993, 56.47573476800005],
              [-133.42931067599994, 56.47508372600004],
              [-133.42247473899994, 56.46360911700003],
              [-133.44131425699993, 56.45380280200004],
              [-133.5271703769999, 56.43903229400007],
              [-133.62124589799993, 56.44220612200007],
              [-133.65941321499992, 56.464178778000075],
              [-133.65416419199994, 56.556708075000074],
              [-133.68919837099992, 56.571966864000046],
              [-133.67943274599992, 56.584051825000074],
              [-133.6460668609999, 56.59259674700007],
              [-133.6345922519999, 56.60610586100006],
              [-133.65465247299994, 56.605536200000074],
              [-133.65904700399994, 56.61473216400003],
              [-133.6580297519999, 56.628241278000075],
              [-133.66185462099992, 56.64020416900007],
              [-133.67422441299993, 56.64826080900008],
              [-133.6858617829999, 56.65253327000005],
              [-133.69566809799994, 56.659369208000044],
              [-133.70287024599992, 56.674994208000044],
              [-133.70152747299994, 56.694647528000075],
              [-133.69298255099994, 56.71124909100007],
              [-133.68785559799994, 56.730129299000055],
              [-133.69664466099994, 56.75690338700008],
              [-133.68211829299992, 56.75958893400008],
              [-133.6773168609999, 56.765285549000055],
              [-133.67943274599992, 56.77285390800006],
              [-133.6857804029999, 56.78115469000005],
              [-133.6926977199999, 56.79279205900008],
              [-133.6889542309999, 56.79877350500004],
              [-133.67764238199993, 56.79832591400003],
              [-133.66185462099992, 56.791083075000074],
              [-133.67003333199995, 56.81342194200005],
              [-133.67308508999992, 56.83734772300005],
              [-133.6792699859999, 56.85370514500005],
              [-133.69664466099994, 56.85309479400007],
              [-133.6975805329999, 56.84955475500004],
              [-133.69591223899994, 56.836004950000074],
              [-133.69664466099994, 56.832017320000034],
              [-133.70205644399994, 56.829413153000075],
              [-133.71532141799992, 56.825506903000075],
              [-133.72057044199994, 56.82208893400008],
              [-133.7292374339999, 56.81464264500005],
              [-133.74058997299994, 56.80890534100007],
              [-133.7529190749999, 56.80731842700004],
              [-133.7649633449999, 56.812201239000046],
              [-133.7512914699999, 56.818426825000074],
              [-133.7512914699999, 56.825832424000055],
              [-133.76650956899994, 56.82493724200003],
              [-133.7812393869999, 56.82656484600005],
              [-133.79478919199994, 56.83112213700008],
              [-133.80650794199994, 56.839504299000055],
              [-133.8037003249999, 56.84332916900007],
              [-133.7990616529999, 56.85309479400007],
              [-133.81187903599994, 56.85252513200004],
              [-133.8201391269999, 56.85541413000004],
              [-133.82290605399993, 56.86225006700005],
              [-133.81956946499992, 56.87299225500004],
              [-133.83633378799993, 56.87189362200007],
              [-133.8503311839999, 56.86815013200004],
              [-133.86343339799993, 56.86774323100008],
              [-133.87755286399994, 56.87641022300005],
              [-133.8904516269999, 56.89337799700007],
              [-133.8881729809999, 56.90143463700008],
              [-133.8765356109999, 56.90289948100008],
              [-133.8611547519999, 56.90033600500004],
              [-133.79552161399994, 56.88149648600006],
              [-133.7630102199999, 56.880072333000044],
              [-133.7376195949999, 56.89411041900007],
              [-133.7549535799999, 56.90058014500005],
              [-133.8391820949999, 56.91950104400007],
              [-133.88841712099992, 56.955511786000045],
              [-134.01817786399994, 57.017564195000034],
              [-134.01817786399994, 57.02383047100005],
              [-134.0131729809999, 57.02924225500004],
              [-134.0112198559999, 57.03611888200004],
              [-134.01134192599994, 57.05516185100004],
              [-134.00438391799992, 57.063666083000044],
              [-133.9881078769999, 57.066473700000074],
              [-133.95641028599994, 57.06537506700005],
              [-133.9453832669999, 57.06688060100004],
              [-133.93301347599993, 57.070746161000045],
              [-133.9214574859999, 57.07632070500006],
              [-133.91266842399995, 57.08274974200003],
            ],
          ],
          [
            [
              [-152.9078669909999, 57.16474030200004],
              [-152.89997311099992, 57.16474030200004],
              [-152.88874264199993, 57.15884023600006],
              [-152.88451087099992, 57.14996979400007],
              [-152.9105118479999, 57.13190338700008],
              [-152.9261368479999, 57.12596263200004],
              [-153.00690670499992, 57.11383698100008],
              [-153.01593990799992, 57.11749909100007],
              [-153.0201309889999, 57.12335846600007],
              [-153.02460689999992, 57.12787506700005],
              [-153.03425045499992, 57.12742747600004],
              [-153.05903072799993, 57.11469147300005],
              [-153.0833634109999, 57.09837474200003],
              [-153.11078854099992, 57.08881256700005],
              [-153.14472408799992, 57.096136786000045],
              [-153.1595352859999, 57.09711334800005],
              [-153.1940811839999, 57.08295319200005],
              [-153.2092179029999, 57.07904694200005],
              [-153.21564693899992, 57.07221100500004],
              [-153.2187393869999, 57.05703359600005],
              [-153.21979732999992, 57.03465403900003],
              [-153.23558508999992, 57.009833075000074],
              [-153.27216549399992, 56.99852122600004],
              [-153.3132218089999, 56.99762604400007],
              [-153.34272213399993, 57.003973700000074],
              [-153.3255509109999, 57.02204010600008],
              [-153.32221432199992, 57.02383047100005],
              [-153.32685299399992, 57.03172435100004],
              [-153.33368893099993, 57.03571198100008],
              [-153.34272213399993, 57.03807200700004],
              [-153.34137936099992, 57.05292389500005],
              [-153.3318985669999, 57.059881903000075],
              [-153.32115637899992, 57.06464264500005],
              [-153.31602942599991, 57.07282135600008],
              [-153.3290909499999, 57.08002350500004],
              [-153.3593643869999, 57.06850820500006],
              [-153.39183508999992, 57.06073639500005],
              [-153.4116104809999, 57.07904694200005],
              [-153.3951309889999, 57.083319403000075],
              [-153.36217200399992, 57.09674713700008],
              [-153.33832760299993, 57.10175202000005],
              [-153.3386124339999, 57.106675523000035],
              [-153.34459387899992, 57.11151764500005],
              [-153.35358639199993, 57.11383698100008],
              [-153.3616837229999, 57.11225006700005],
              [-153.37995357999992, 57.10639069200005],
              [-153.39110266799992, 57.10639069200005],
              [-153.37897701699993, 57.117621161000045],
              [-153.34272213399993, 57.14109935100004],
              [-153.30976314999992, 57.17031484600005],
              [-153.2983292309999, 57.17462799700007],
              [-153.29076087099992, 57.17865631700005],
              [-153.2701309889999, 57.19822825700004],
              [-153.2604874339999, 57.20563385600008],
              [-153.2443741529999, 57.211004950000074],
              [-153.2292374339999, 57.210638739000046],
              [-153.22114010299993, 57.20351797100005],
              [-153.22602291599992, 57.18829987200007],
              [-153.18732662699992, 57.18500397300005],
              [-153.18085689999992, 57.174994208000044],
              [-153.21235104099992, 57.133693752000056],
              [-153.15440833199992, 57.16453685100004],
              [-153.1237686839999, 57.17059967700004],
              [-153.1010636059999, 57.179754950000074],
              [-153.08946692599991, 57.18146393400008],
              [-153.07966061099992, 57.17910390800006],
              [-153.06847083199992, 57.170355536000045],
              [-153.05842037699992, 57.16844310100004],
              [-152.9792374339999, 57.17641836100006],
              [-152.9522598949999, 57.17462799700007],
              [-152.93366451699993, 57.16205475500004],
              [-152.9202774729999, 57.15794505400004],
              [-152.9078669909999, 57.16474030200004],
            ],
          ],
          [
            [
              [-135.6015518869999, 57.171576239000046],
              [-135.59557044199994, 57.15460846600007],
              [-135.5808813139999, 57.148138739000046],
              [-135.5627335279999, 57.145819403000075],
              [-135.54629472599993, 57.14109935100004],
              [-135.5650121739999, 57.11229075700004],
              [-135.6016332669999, 57.03554922100005],
              [-135.6282445949999, 57.010199286000045],
              [-135.6420792309999, 57.00820547100005],
              [-135.67418372299994, 57.011704820000034],
              [-135.68687903599994, 57.007025458000044],
              [-135.69668535099993, 57.00104401200008],
              [-135.70750891799992, 56.99843984600005],
              [-135.8411352199999, 56.98969147300005],
              [-135.8315323559999, 57.050482489000046],
              [-135.82315019399994, 57.079779364000046],
              [-135.80699622299994, 57.09955475500004],
              [-135.79137122299994, 57.10610586100006],
              [-135.76207434799994, 57.114162502000056],
              [-135.72720292899993, 57.14252350500004],
              [-135.7175186839999, 57.15346914300005],
              [-135.71080481699994, 57.16844310100004],
              [-135.77969316299993, 57.165716864000046],
              [-135.80972245999993, 57.17300039300005],
              [-135.82066809799994, 57.195746161000045],
              [-135.81505286399994, 57.20770905200004],
              [-135.79771887899994, 57.22882721600007],
              [-135.80016028599994, 57.23672109600005],
              [-135.81240800699993, 57.23859284100007],
              [-135.8423559239999, 57.22650788000004],
              [-135.85537675699993, 57.223089911000045],
              [-135.83922278599994, 57.24567291900007],
              [-135.83751380099994, 57.255519924000055],
              [-135.8479711579999, 57.26463450700004],
              [-135.8252660799999, 57.284084377000056],
              [-135.8339737619999, 57.306341864000046],
              [-135.8437393869999, 57.32469310100004],
              [-135.82408606699994, 57.33234284100007],
              [-135.72476152299993, 57.32892487200007],
              [-135.6152237619999, 57.284491278000075],
              [-135.5986221999999, 57.271918036000045],
              [-135.56871497299994, 57.24119700700004],
              [-135.5537817049999, 57.22992584800005],
              [-135.5708715489999, 57.22296784100007],
              [-135.59105383999992, 57.224310614000046],
              [-135.6282445949999, 57.23672109600005],
              [-135.61436926999994, 57.22357819200005],
              [-135.6062719389999, 57.20945872600004],
              [-135.60244706899994, 57.19277578300006],
              [-135.6015518869999, 57.171576239000046],
            ],
          ],
          [
            [
              [-134.62149003799993, 56.743841864000046],
              [-134.61611894399994, 56.72846100500004],
              [-134.60781816299993, 56.59589264500005],
              [-134.61245683499993, 56.56509023600006],
              [-134.61461341099994, 56.558294989000046],
              [-134.62417558499993, 56.54743073100008],
              [-134.62828528599994, 56.54857005400004],
              [-134.63219153599994, 56.556341864000046],
              [-134.6413468089999, 56.56513092700004],
              [-134.6425675119999, 56.57046133000006],
              [-134.65029863199993, 56.58226146000004],
              [-134.6590063139999, 56.58808014500005],
              [-134.6630753249999, 56.575384833000044],
              [-134.6692602199999, 56.53782786700003],
              [-134.6260473299999, 56.48623281500005],
              [-134.62490800699993, 56.472642320000034],
              [-134.6349991529999, 56.455511786000045],
              [-134.63267981699994, 56.439113674000055],
              [-134.62555904899995, 56.42401764500005],
              [-134.62149003799993, 56.41120026200008],
              [-134.62246660099993, 56.39077383000006],
              [-134.6264542309999, 56.37213776200008],
              [-134.6347550119999, 56.35504791900007],
              [-134.64879309799994, 56.339178778000075],
              [-134.62759355399993, 56.33038971600007],
              [-134.63174394399994, 56.30927155200004],
              [-134.6630753249999, 56.25726959800005],
              [-134.63463294199994, 56.26972077000005],
              [-134.62637285099993, 56.26146067900004],
              [-134.63296464799993, 56.24087148600006],
              [-134.64879309799994, 56.21629466400003],
              [-134.6413468089999, 56.20888906500005],
              [-134.6562393869999, 56.174709377000056],
              [-134.6674698559999, 56.17039622600004],
              [-134.6897680329999, 56.18154531500005],
              [-134.6725968089999, 56.20563385600008],
              [-134.6692602199999, 56.21629466400003],
              [-134.67373613199993, 56.21942780200004],
              [-134.6829320949999, 56.22931549700007],
              [-134.6946508449999, 56.23334381700005],
              [-134.69957434799994, 56.23041413000004],
              [-134.7022192049999, 56.22528717700004],
              [-134.70714270699995, 56.22247955900008],
              [-134.73570716099994, 56.21792226800005],
              [-134.7499893869999, 56.21735260600008],
              [-134.76549231699994, 56.22247955900008],
              [-134.75121008999992, 56.23615143400008],
              [-134.77212480399993, 56.237209377000056],
              [-134.7873429029999, 56.24481842700004],
              [-134.79649817599994, 56.25763580900008],
              [-134.7996313139999, 56.27435944200005],
              [-134.80337480399993, 56.28156159100007],
              [-134.81191972599993, 56.28497955900008],
              [-134.82119706899994, 56.287176825000074],
              [-134.8269750639999, 56.29075755400004],
              [-134.8291723299999, 56.29954661700003],
              [-134.82921301999994, 56.309881903000075],
              [-134.8269750639999, 56.32558828300006],
              [-134.84756425699993, 56.32904694200005],
              [-134.8675024079999, 56.325384833000044],
              [-134.88243567599994, 56.32957591400003],
              [-134.88833574099993, 56.35626862200007],
              [-134.89220130099994, 56.36107005400004],
              [-134.9114477199999, 56.37677643400008],
              [-134.91909745999993, 56.380194403000075],
              [-134.92568925699993, 56.38515859600005],
              [-134.93101966099994, 56.39622630400004],
              [-134.9368383449999, 56.41429271000004],
              [-134.9423721999999, 56.421576239000046],
              [-134.99819902299993, 56.472642320000034],
              [-135.0038956369999, 56.49070872600004],
              [-135.0178930329999, 56.509019273000035],
              [-135.03571529899995, 56.525458075000074],
              [-135.05284583199995, 56.53782786700003],
              [-135.04344641799992, 56.53925202000005],
              [-135.03453528599994, 56.542222398000035],
              [-135.0263565749999, 56.546535549000055],
              [-135.0193578769999, 56.552069403000075],
              [-135.0332738919999, 56.56028880400004],
              [-135.03750566299993, 56.56854889500005],
              [-135.03262285099993, 56.57684967700004],
              [-135.0193578769999, 56.585638739000046],
              [-134.9983617829999, 56.58860911700003],
              [-134.94701087099992, 56.58730703300006],
              [-134.9368383449999, 56.59589264500005],
              [-134.92760169199994, 56.620428778000075],
              [-134.90485592399995, 56.64606354400007],
              [-134.84740149599992, 56.688666083000044],
              [-134.86856035099993, 56.68817780200004],
              [-134.8837784499999, 56.68549225500004],
              [-134.89708411399994, 56.67820872600004],
              [-134.91258704299992, 56.66445547100005],
              [-134.93370520699995, 56.639960028000075],
              [-134.94587154899995, 56.63043854400007],
              [-134.9610082669999, 56.62653229400007],
              [-134.97862708199995, 56.63198476800005],
              [-134.9837133449999, 56.64492422100005],
              [-134.98159745999993, 56.66079336100006],
              [-134.97191321499992, 56.692572333000044],
              [-134.96446692599994, 56.70254140800006],
              [-134.9533585279999, 56.709051825000074],
              [-134.9368383449999, 56.71596914300005],
              [-134.96263587099992, 56.721136786000045],
              [-134.98473059799994, 56.714544989000046],
              [-134.9999893869999, 56.69757721600007],
              [-135.01231848899994, 56.65021393400008],
              [-135.02847245999993, 56.63133372600004],
              [-135.0484106109999, 56.61615631700005],
              [-135.06651770699995, 56.60610586100006],
              [-135.0927628249999, 56.59796784100007],
              [-135.10977128799993, 56.60175202000005],
              [-135.11900794199994, 56.61713288000004],
              [-135.12173417899993, 56.64362213700008],
              [-135.11949622299994, 56.66250234600005],
              [-135.11221269399994, 56.67869700700004],
              [-135.09935462099992, 56.69358958500004],
              [-135.08018958199995, 56.70856354400007],
              [-135.01427161399994, 56.73940664300005],
              [-134.99478105399993, 56.75348541900007],
              [-134.9988500639999, 56.76166413000004],
              [-135.0146378249999, 56.77106354400007],
              [-135.03180904899995, 56.77513255400004],
              [-135.0397843089999, 56.76752350500004],
              [-135.0449926419999, 56.75922272300005],
              [-135.1370336579999, 56.694525458000044],
              [-135.1641332669999, 56.685207424000055],
              [-135.1757706369999, 56.679022528000075],
              [-135.18789628799993, 56.67674388200004],
              [-135.20055091099994, 56.684881903000075],
              [-135.20225989499994, 56.69472890800006],
              [-135.1940811839999, 56.702826239000046],
              [-135.1829320949999, 56.70978424700007],
              [-135.1757706369999, 56.71596914300005],
              [-135.17735755099994, 56.72597890800006],
              [-135.18443762899994, 56.73493073100008],
              [-135.1855362619999, 56.741400458000044],
              [-135.15469316299993, 56.74591705900008],
              [-135.15208899599992, 56.751654364000046],
              [-135.15485592399995, 56.76032135600008],
              [-135.1589249339999, 56.79205963700008],
              [-135.15868079299992, 56.80023834800005],
              [-135.15274003799993, 56.80878327000005],
              [-135.1432999339999, 56.815619208000044],
              [-135.13540605399993, 56.81932200700004],
              [-135.12852942599994, 56.823472398000035],
              [-135.12173417899993, 56.832017320000034],
              [-135.17422441299993, 56.82636139500005],
              [-135.26927649599992, 56.78900788000004],
              [-135.32095292899993, 56.79783763200004],
              [-135.3073624339999, 56.82086823100008],
              [-135.3256729809999, 56.825506903000075],
              [-135.3533422519999, 56.82416413000004],
              [-135.36754309799994, 56.82892487200007],
              [-135.36778723899994, 56.87400950700004],
              [-135.36025956899994, 56.887600002000056],
              [-135.3408910799999, 56.87982819200005],
              [-135.32457434799994, 56.89077383000006],
              [-135.30589758999992, 56.890692450000074],
              [-135.2945043609999, 56.89215729400007],
              [-135.29991614499994, 56.90770091400003],
              [-135.3137914699999, 56.92072174700007],
              [-135.3342179029999, 56.93105703300006],
              [-135.3562719389999, 56.93829987200007],
              [-135.3749893869999, 56.94188060100004],
              [-135.36904863199993, 56.94383372600004],
              [-135.36375891799992, 56.94627513200004],
              [-135.3545629549999, 56.955511786000045],
              [-135.35000566299993, 56.970404364000046],
              [-135.3308813139999, 56.978583075000074],
              [-135.30894934799994, 56.982123114000046],
              [-135.2893774079999, 56.982855536000045],
              [-135.28233801999994, 56.98529694200005],
              [-135.26292883999992, 56.99689362200007],
              [-135.25890051999994, 57.00055573100008],
              [-135.2539770169999, 57.00372955900008],
              [-135.2295629549999, 57.00454336100006],
              [-135.2033585279999, 57.01349518400008],
              [-135.1640518869999, 57.01361725500004],
              [-135.1565649079999, 57.020697333000044],
              [-135.1653539699999, 57.04173411700003],
              [-135.18590247299994, 57.04564036700003],
              [-135.2276098299999, 57.03807200700004],
              [-135.26793372299994, 57.03986237200007],
              [-135.31029212099992, 57.04734935100004],
              [-135.34813391799992, 57.06391022300005],
              [-135.3749893869999, 57.09271881700005],
              [-135.37816321499992, 57.12872955900008],
              [-135.35024980399993, 57.14935944200005],
              [-135.3076065749999, 57.15875885600008],
              [-135.2664281889999, 57.161037502000056],
              [-135.2664281889999, 57.16844310100004],
              [-135.28966223899994, 57.17462799700007],
              [-135.3101293609999, 57.17767975500004],
              [-135.3291723299999, 57.17609284100007],
              [-135.34829667899993, 57.16844310100004],
              [-135.37686113199993, 57.150091864000046],
              [-135.39415442599994, 57.147365627000056],
              [-135.4129125639999, 57.157904364000046],
              [-135.41258704299992, 57.169623114000046],
              [-135.39769446499992, 57.182074286000045],
              [-135.37828528599994, 57.191839911000045],
              [-135.36440995999993, 57.195746161000045],
              [-135.36416581899994, 57.20404694200005],
              [-135.3340551419999, 57.25039297100005],
              [-135.41295325399994, 57.24477773600006],
              [-135.42959550699993, 57.24664948100008],
              [-135.45596269399994, 57.25332265800006],
              [-135.4815160799999, 57.24896881700005],
              [-135.50601152299993, 57.24103424700007],
              [-135.52920488199993, 57.23672109600005],
              [-135.54283606699994, 57.24298737200007],
              [-135.5777074859999, 57.28790924700007],
              [-135.6392309239999, 57.316839911000045],
              [-135.6487524079999, 57.32892487200007],
              [-135.67320716099994, 57.349676825000074],
              [-135.67495683499993, 57.358628648000035],
              [-135.6624242829999, 57.36375560100004],
              [-135.6458227199999, 57.36619700700004],
              [-135.6042374339999, 57.36774323100008],
              [-135.4856664699999, 57.35101959800005],
              [-135.4753311839999, 57.35431549700007],
              [-135.47118079299992, 57.36359284100007],
              [-135.4785863919999, 57.36831289300005],
              [-135.52578691299993, 57.373928127000056],
              [-135.56704667899993, 57.38947174700007],
              [-135.58584550699993, 57.392564195000034],
              [-135.60899817599994, 57.387600002000056],
              [-135.60220292899993, 57.39789459800005],
              [-135.5916235019999, 57.40497467700004],
              [-135.55064856699994, 57.42377350500004],
              [-135.5475968089999, 57.427435614000046],
              [-135.5474340489999, 57.43178945500006],
              [-135.5401098299999, 57.44220612200007],
              [-135.5331925119999, 57.44721100500004],
              [-135.51646887899994, 57.454413153000075],
              [-135.5087784499999, 57.45954010600008],
              [-135.5047094389999, 57.466498114000046],
              [-135.5065811839999, 57.472357489000046],
              [-135.51036536399994, 57.477728583000044],
              [-135.51211503799993, 57.48309967700004],
              [-135.51280676999994, 57.49046458500004],
              [-135.5178116529999, 57.501613674000055],
              [-135.5190323559999, 57.50731028900003],
              [-135.51537024599992, 57.515611070000034],
              [-135.50674394399994, 57.51776764500005],
              [-135.49657141799992, 57.518011786000045],
              [-135.4882706369999, 57.52098216400003],
              [-135.4365128249999, 57.549994208000044],
              [-135.3811742829999, 57.553615627000056],
              [-135.32705644399994, 57.538397528000075],
              [-135.27940833199995, 57.511053778000075],
              [-135.3105362619999, 57.49087148600006],
              [-135.3818253249999, 57.47134023600006],
              [-135.40977942599994, 57.44896067900004],
              [-135.3960668609999, 57.442694403000075],
              [-135.38292395699995, 57.445298570000034],
              [-135.3545629549999, 57.46263255400004],
              [-135.31651770699995, 57.47833893400008],
              [-135.29503333199995, 57.481634833000044],
              [-135.28563391799992, 57.47284577000005],
              [-135.2774145169999, 57.46133047100005],
              [-135.25829016799992, 57.46629466400003],
              [-135.2366430329999, 57.47719961100006],
              [-135.2207738919999, 57.48309967700004],
              [-135.18028723899994, 57.48069896000004],
              [-135.14224199099993, 57.46942780200004],
              [-135.1533096999999, 57.45294830900008],
              [-135.1912328769999, 57.44318268400008],
              [-135.20368404899995, 57.42853424700007],
              [-135.18199622299994, 57.436753648000035],
              [-135.1562393869999, 57.44131094000005],
              [-135.13027910099993, 57.441107489000046],
              [-135.0603735019999, 57.42291901200008],
              [-135.05284583199995, 57.41860586100006],
              [-135.0451554029999, 57.411444403000075],
              [-135.0081274079999, 57.40346914300005],
              [-134.99478105399993, 57.397772528000075],
              [-134.9094945949999, 57.33978913000004],
              [-134.9094945949999, 57.33234284100007],
              [-134.9524633449999, 57.34247467700004],
              [-134.99819902299993, 57.346584377000056],
              [-134.99819902299993, 57.33978913000004],
              [-134.95042883999992, 57.325506903000075],
              [-134.95042883999992, 57.31928131700005],
              [-134.97105872299994, 57.31244538000004],
              [-134.9788305329999, 57.30683014500005],
              [-134.98452714799993, 57.298163153000075],
              [-134.96597245999993, 57.29828522300005],
              [-134.9583227199999, 57.300482489000046],
              [-134.95042883999992, 57.30560944200005],
              [-134.93907630099994, 57.29950592700004],
              [-134.93297278599994, 57.29124583500004],
              [-134.9304093089999, 57.28082916900007],
              [-134.9300024079999, 57.26776764500005],
              [-134.92349199099993, 57.25922272300005],
              [-134.90868079299992, 57.25633372600004],
              [-134.8528539699999, 57.26032135600008],
              [-134.83897864499994, 57.257798570000034],
              [-134.83311926999994, 57.24664948100008],
              [-134.8328344389999, 57.23281484600005],
              [-134.8340551419999, 57.22162506700005],
              [-134.84024003799993, 57.21539948100008],
              [-134.85484778599994, 57.21625397300005],
              [-134.8261612619999, 57.19745514500005],
              [-134.80825761599993, 57.18138255400004],
              [-134.80825761599993, 57.16400788000004],
              [-134.83311926999994, 57.14109935100004],
              [-134.81065833199995, 57.133978583000044],
              [-134.78648841099994, 57.11798737200007],
              [-134.7753800119999, 57.098089911000045],
              [-134.79214433499993, 57.07904694200005],
              [-134.77452551999994, 57.07916901200008],
              [-134.7612198559999, 57.07282135600008],
              [-134.75157630099994, 57.06281159100007],
              [-134.74498450399994, 57.05174388200004],
              [-134.74331620999993, 57.04389069200005],
              [-134.7468155589999, 57.03143952000005],
              [-134.74498450399994, 57.02383047100005],
              [-134.74071204299992, 57.021185614000046],
              [-134.73448645699995, 57.020738023000035],
              [-134.72826087099992, 57.01837799700007],
              [-134.72386633999992, 57.010199286000045],
              [-134.7239477199999, 56.99603913000004],
              [-134.73253333199995, 56.97675202000005],
              [-134.73131262899994, 56.962958075000074],
              [-134.72354081899994, 56.95294830900008],
              [-134.71373450399994, 56.94603099200003],
              [-134.70933997299994, 56.93732330900008],
              [-134.71768144399994, 56.92202383000006],
              [-134.6935929029999, 56.90839264500005],
              [-134.68618730399993, 56.89350006700005],
              [-134.6897680329999, 56.849676825000074],
              [-134.6831762359999, 56.835638739000046],
              [-134.6413468089999, 56.79783763200004],
              [-134.6519262359999, 56.77806224200003],
              [-134.64614824099993, 56.765326239000046],
              [-134.6330460279999, 56.75531647300005],
              [-134.62149003799993, 56.743841864000046],
            ],
          ],
          [
            [
              [-153.3017471999999, 57.833197333000044],
              [-153.31965084499993, 57.83454010600008],
              [-153.32770748599992, 57.83641185100004],
              [-153.33588619699992, 57.83942291900007],
              [-153.3310440749999, 57.84129466400003],
              [-153.32701575399992, 57.843736070000034],
              [-153.3224991529999, 57.84585195500006],
              [-153.31602942599991, 57.846869208000044],
              [-153.32526607999992, 57.858628648000035],
              [-153.3425186839999, 57.86225006700005],
              [-153.38056393099993, 57.86050039300005],
              [-153.39692135299993, 57.86383698100008],
              [-153.5224503249999, 57.92096588700008],
              [-153.54194088399993, 57.935614325000074],
              [-153.52826900899993, 57.953192450000074],
              [-153.50666256399992, 57.96979401200008],
              [-153.48224850199992, 57.977769273000035],
              [-153.46003170499992, 57.96971263200004],
              [-153.43268795499992, 57.96356842700004],
              [-153.32664954299992, 57.92658112200007],
              [-153.27973385299993, 57.90289948100008],
              [-153.26081295499992, 57.88784414300005],
              [-153.2287491529999, 57.85390859600005],
              [-153.21296139199993, 57.83030833500004],
              [-153.21235104099992, 57.81268952000005],
              [-153.2241104809999, 57.81159088700008],
              [-153.2812393869999, 57.81891510600008],
              [-153.2839249339999, 57.82143789300005],
              [-153.2874649729999, 57.82636139500005],
              [-153.2929581369999, 57.83104075700004],
              [-153.3017471999999, 57.833197333000044],
            ],
          ],
          [
            [
              [-152.1608780589999, 57.62714264500005],
              [-152.1470841139999, 57.62262604400007],
              [-152.15546627499992, 57.61286041900007],
              [-152.17829342399992, 57.59979889500005],
              [-152.24970455599993, 57.54148997600004],
              [-152.2706192699999, 57.528509833000044],
              [-152.29108639199993, 57.51984284100007],
              [-152.30890865799992, 57.509019273000035],
              [-152.3222550119999, 57.489935614000046],
              [-152.3281143869999, 57.46539948100008],
              [-152.3303116529999, 57.44594961100006],
              [-152.33869381399992, 57.43317291900007],
              [-152.36298580599993, 57.42853424700007],
              [-152.41791744699992, 57.43528880400004],
              [-152.42572994699992, 57.43744538000004],
              [-152.4330948559999, 57.441107489000046],
              [-152.4405411449999, 57.44281647300005],
              [-152.44892330599993, 57.438788153000075],
              [-152.4537247389999, 57.435248114000046],
              [-152.46003170499992, 57.43195221600007],
              [-152.46662350199992, 57.42942942900004],
              [-152.4725235669999, 57.42853424700007],
              [-152.48615475199992, 57.42853424700007],
              [-152.47435462099992, 57.436753648000035],
              [-152.4597061839999, 57.45062897300005],
              [-152.4522598949999, 57.46369049700007],
              [-152.4622696609999, 57.46942780200004],
              [-152.4876602859999, 57.471869208000044],
              [-152.5013321609999, 57.46942780200004],
              [-152.50727291599992, 57.45954010600008],
              [-152.50885982999992, 57.44953034100007],
              [-152.51341712099992, 57.44432200700004],
              [-152.52082271999993, 57.44245026200008],
              [-152.53083248599992, 57.44220612200007],
              [-152.53636633999992, 57.44407786700003],
              [-152.55414791599992, 57.45331452000005],
              [-152.5624893869999, 57.45644765800006],
              [-152.57013912699992, 57.45644765800006],
              [-152.5753067699999, 57.45376211100006],
              [-152.57978268099993, 57.45058828300006],
              [-152.5854386059999, 57.44896067900004],
              [-152.59101314999992, 57.45091380400004],
              [-152.59333248599992, 57.45526764500005],
              [-152.59443111899992, 57.459865627000056],
              [-152.59601803299992, 57.46263255400004],
              [-152.6009415359999, 57.467230536000045],
              [-152.60558020699992, 57.473944403000075],
              [-152.61249752499992, 57.480129299000055],
              [-152.62397213399993, 57.48309967700004],
              [-152.6341446609999, 57.48126862200007],
              [-152.65351314999992, 57.47182851800005],
              [-152.6642960279999, 57.46942780200004],
              [-152.6740616529999, 57.469916083000044],
              [-152.68451900899993, 57.47162506700005],
              [-152.6943253249999, 57.47483958500004],
              [-152.72240149599992, 57.49481842700004],
              [-152.72260494699992, 57.49746328300006],
              [-152.72724361899992, 57.49949778900003],
              [-152.73407955599993, 57.50421784100007],
              [-152.7429093089999, 57.508978583000044],
              [-152.75365149599992, 57.511053778000075],
              [-152.8017471999999, 57.503607489000046],
              [-152.81452389199993, 57.50543854400007],
              [-152.83246822799993, 57.51434967700004],
              [-152.8423966139999, 57.51788971600007],
              [-152.8560684889999, 57.51813385600008],
              [-152.89081783799992, 57.511053778000075],
              [-152.9119766919999, 57.51471588700008],
              [-152.93321692599991, 57.52122630400004],
              [-152.95396887899992, 57.52435944200005],
              [-152.9733780589999, 57.51788971600007],
              [-152.9604386059999, 57.51186758000006],
              [-152.91722571499992, 57.500881252000056],
              [-152.91071529899992, 57.489935614000046],
              [-152.92865963399993, 57.48236725500004],
              [-153.02802486899992, 57.476263739000046],
              [-153.02802486899992, 57.46942780200004],
              [-153.02326412699992, 57.46849192900004],
              [-153.0206192699999, 57.46718984600005],
              [-153.01435299399992, 57.46263255400004],
              [-153.03620357999992, 57.447251695000034],
              [-153.04487057199992, 57.436712958000044],
              [-153.04169674399992, 57.42853424700007],
              [-153.02863521999993, 57.42951080900008],
              [-153.0009659499999, 57.45091380400004],
              [-152.99018307199992, 57.45644765800006],
              [-152.83246822799993, 57.476263739000046],
              [-152.8006485669999, 57.470770575000074],
              [-152.72638912699992, 57.42853424700007],
              [-152.63410396999993, 57.40574778900003],
              [-152.61713619699992, 57.387600002000056],
              [-152.61339270699992, 57.38816966400003],
              [-152.60883541599992, 57.38646067900004],
              [-152.60313880099991, 57.38190338700008],
              [-152.59601803299992, 57.373928127000056],
              [-152.6061905589999, 57.36359284100007],
              [-152.63097083199992, 57.34979889500005],
              [-152.6443985669999, 57.33978913000004],
              [-152.6432999339999, 57.32050202000005],
              [-152.6630753249999, 57.29954661700003],
              [-152.69220943899992, 57.283270575000074],
              [-152.71886145699992, 57.27765534100007],
              [-152.7122696609999, 57.302801825000074],
              [-152.73167883999992, 57.30744049700007],
              [-152.7986954419999, 57.29157135600008],
              [-152.81725012899992, 57.278957424000055],
              [-152.83747311099992, 57.270738023000035],
              [-152.8635147779999, 57.27765534100007],
              [-152.85846920499992, 57.29507070500006],
              [-152.8721817699999, 57.29995351800005],
              [-152.89191646999993, 57.304022528000075],
              [-152.90510006399992, 57.31928131700005],
              [-152.88068600199992, 57.337591864000046],
              [-152.8771866529999, 57.34316640800006],
              [-152.88215084499993, 57.35248444200005],
              [-152.89350338399993, 57.35024648600006],
              [-152.9144180979999, 57.33978913000004],
              [-152.97651119699992, 57.33234284100007],
              [-153.0073136059999, 57.34023672100005],
              [-153.02387447799993, 57.342230536000045],
              [-153.05732174399992, 57.32632070500006],
              [-153.08836829299992, 57.318793036000045],
              [-153.12079830599993, 57.315741278000075],
              [-153.1440323559999, 57.31928131700005],
              [-153.15229244699992, 57.32713450700004],
              [-153.15864010299993, 57.34662506700005],
              [-153.1651505199999, 57.352769273000035],
              [-153.17475338399993, 57.35138580900008],
              [-153.17707271999993, 57.341009833000044],
              [-153.17499752499992, 57.328111070000034],
              [-153.1713761059999, 57.31928131700005],
              [-153.18354244699992, 57.31126536700003],
              [-153.17292232999992, 57.30508047100005],
              [-153.09687252499992, 57.29047272300005],
              [-153.0737198559999, 57.28929271000004],
              [-153.0325821609999, 57.30491771000004],
              [-153.00300045499992, 57.294989325000074],
              [-152.97618567599991, 57.27553945500006],
              [-152.95909583199992, 57.257147528000075],
              [-153.0615128249999, 57.223089911000045],
              [-153.0963028639999, 57.21824778900003],
              [-153.19526119699992, 57.22992584800005],
              [-153.2026261059999, 57.22801341400003],
              [-153.2095841139999, 57.22455475500004],
              [-153.21637936099992, 57.22296784100007],
              [-153.2228897779999, 57.22650788000004],
              [-153.2532852859999, 57.23672109600005],
              [-153.26447506399992, 57.23281484600005],
              [-153.28241939999992, 57.219183661000045],
              [-153.2983292309999, 57.21625397300005],
              [-153.30732174399992, 57.21198151200008],
              [-153.32416744699992, 57.193060614000046],
              [-153.33588619699992, 57.18829987200007],
              [-153.35016842399992, 57.19114817900004],
              [-153.37665768099993, 57.20579661700003],
              [-153.39110266799992, 57.209418036000045],
              [-153.37865149599992, 57.19383372600004],
              [-153.3732804029999, 57.18500397300005],
              [-153.37372799399992, 57.17804596600007],
              [-153.4081925119999, 57.14793528900003],
              [-153.42609615799992, 57.14012278900003],
              [-153.44066321499992, 57.125433661000045],
              [-153.45527096299992, 57.116848049000055],
              [-153.4730118479999, 57.12742747600004],
              [-153.47907467399992, 57.14402903900003],
              [-153.48005123599992, 57.16168854400007],
              [-153.48607337099992, 57.17572663000004],
              [-153.5071915359999, 57.18146393400008],
              [-153.5316055979999, 57.179754950000074],
              [-153.54185950399992, 57.175848700000074],
              [-153.54816646999993, 57.16844310100004],
              [-153.54426021999993, 57.16445547100005],
              [-153.51313229099992, 57.170355536000045],
              [-153.5003555979999, 57.16844310100004],
              [-153.5245255199999, 57.13739655200004],
              [-153.5268448559999, 57.12669505400004],
              [-153.5189102859999, 57.11737702000005],
              [-153.5078018869999, 57.108587958000044],
              [-153.5003555979999, 57.09955475500004],
              [-153.49815833199992, 57.074286200000074],
              [-153.5131729809999, 57.06972890800006],
              [-153.55903072799993, 57.07904694200005],
              [-153.71137447799993, 57.06704336100006],
              [-153.76105709499993, 57.05174388200004],
              [-153.76105709499993, 57.044907945000034],
              [-153.60712643099993, 57.05174388200004],
              [-153.59125729099992, 57.048163153000075],
              [-153.5904434889999, 57.03998444200005],
              [-153.59894771999993, 57.03066640800006],
              [-153.6108292309999, 57.02383047100005],
              [-153.62714596299992, 57.021144924000055],
              [-153.64305579299992, 57.02163320500006],
              [-153.6580704419999, 57.01984284100007],
              [-153.67162024599992, 57.010199286000045],
              [-153.57612057199992, 57.003973700000074],
              [-153.55512447799993, 56.99872467700004],
              [-153.55976314999992, 56.98651764500005],
              [-153.58910071499992, 56.962958075000074],
              [-153.59211178299992, 56.962225653000075],
              [-153.6002091139999, 56.96352773600006],
              [-153.6033829419999, 56.962958075000074],
              [-153.60395260299993, 56.96035390800006],
              [-153.60277258999992, 56.951239325000074],
              [-153.6033829419999, 56.94871653900003],
              [-153.61799068899992, 56.939154364000046],
              [-153.62677975199992, 56.93618398600006],
              [-153.64093990799992, 56.93504466400003],
              [-153.66694088399993, 56.93768952000005],
              [-153.67157955599993, 56.945379950000074],
              [-153.67023678299992, 56.95844147300005],
              [-153.6784561839999, 56.976629950000074],
              [-153.7136124339999, 56.91453685100004],
              [-153.7388809889999, 56.88914622600004],
              [-153.76789303299992, 56.90033600500004],
              [-153.77887936099992, 56.877020575000074],
              [-153.75690670499992, 56.87494538000004],
              [-153.70270748599992, 56.88727448100008],
              [-153.69416256399992, 56.88300202000005],
              [-153.69493567599991, 56.87360260600008],
              [-153.7014054029999, 56.86420319200005],
              [-153.70982825399992, 56.85993073100008],
              [-153.76789303299992, 56.85309479400007],
              [-153.77289791599992, 56.850490627000056],
              [-153.7756241529999, 56.84137604400007],
              [-153.78087317599991, 56.839504299000055],
              [-153.78693600199992, 56.84080638200004],
              [-153.79662024599992, 56.84589264500005],
              [-153.8244522779999, 56.846909898000035],
              [-153.83771725199992, 56.844183661000045],
              [-153.84357662699992, 56.83576080900008],
              [-153.85016842399992, 56.814520575000074],
              [-153.8662003249999, 56.80170319200005],
              [-153.9050186839999, 56.784857489000046],
              [-153.94184322799993, 56.75877513200004],
              [-153.96251380099991, 56.74823639500005],
              [-153.98725338399993, 56.743841864000046],
              [-154.01520748599992, 56.748480536000045],
              [-154.0351456369999, 56.75726959800005],
              [-154.05500240799992, 56.76251862200007],
              [-154.08259029899992, 56.75690338700008],
              [-154.10834713399993, 56.74461497600004],
              [-154.12262936099992, 56.74119700700004],
              [-154.1378067699999, 56.743841864000046],
              [-154.1495255199999, 56.75092194200005],
              [-154.14826412699992, 56.75625234600005],
              [-154.1417130199999, 56.762884833000044],
              [-154.1378067699999, 56.774318752000056],
              [-154.13011633999992, 56.78652578300006],
              [-154.06379146999993, 56.84739817900004],
              [-154.0005997389999, 56.87299225500004],
              [-153.9767960279999, 56.892564195000034],
              [-153.96808834499993, 56.905503648000035],
              [-153.95592200399992, 56.91010163000004],
              [-153.93175208199992, 56.91453685100004],
              [-153.88898678299992, 56.93036530200004],
              [-153.81049557199992, 56.97089264500005],
              [-153.77472896999993, 56.99713776200008],
              [-153.78087317599991, 57.003973700000074],
              [-153.83381100199992, 56.97223541900007],
              [-153.84980221299992, 56.969183661000045],
              [-153.85566158799992, 56.97601959800005],
              [-153.8320206369999, 57.00153229400007],
              [-153.83613033799992, 57.017564195000034],
              [-153.85240637899992, 57.02362702000005],
              [-153.8624161449999, 57.01113515800006],
              [-153.86957760299993, 56.99164459800005],
              [-153.87714596299992, 56.976629950000074],
              [-153.89692135299993, 56.96588776200008],
              [-153.9224747389999, 56.962144273000035],
              [-153.97333736899992, 56.962958075000074],
              [-153.9689835279999, 56.97996653900003],
              [-153.96263587099992, 56.99510325700004],
              [-153.95392818899992, 57.00861237200007],
              [-153.92951412699992, 57.03506094000005],
              [-153.9108780589999, 57.06122467700004],
              [-153.89818274599992, 57.07282135600008],
              [-153.88263912699992, 57.080511786000045],
              [-153.83482825399992, 57.096584377000056],
              [-153.8187149729999, 57.09955475500004],
              [-153.81049557199992, 57.10211823100008],
              [-153.7958878249999, 57.114935614000046],
              [-153.78831946499992, 57.12006256700005],
              [-153.7767227859999, 57.12409088700008],
              [-153.76557369699992, 57.126288153000075],
              [-153.73993893099993, 57.12742747600004],
              [-153.73993893099993, 57.133693752000056],
              [-153.78278561099992, 57.15021393400008],
              [-153.80573482999992, 57.15420156500005],
              [-153.81566321499992, 57.144598700000074],
              [-153.8206680979999, 57.13336823100008],
              [-153.83246822799993, 57.126654364000046],
              [-153.85724850199992, 57.12006256700005],
              [-153.97358150899993, 57.06191640800006],
              [-154.0069473949999, 57.03929271000004],
              [-154.0495499339999, 56.99603913000004],
              [-154.07506262899992, 56.97557200700004],
              [-154.09955807199992, 56.964829820000034],
              [-154.11497962099992, 56.98578522300005],
              [-154.13410396999993, 56.99518463700008],
              [-154.1378067699999, 57.003973700000074],
              [-154.13483639199993, 57.00873444200005],
              [-154.12177486899992, 57.01911041900007],
              [-154.11729895699992, 57.02383047100005],
              [-154.1104630199999, 57.03807200700004],
              [-154.08002682199992, 57.06659577000005],
              [-153.95966549399992, 57.12006256700005],
              [-154.08320064999992, 57.12742747600004],
              [-154.09125729099992, 57.13068268400008],
              [-154.1099747389999, 57.14476146000004],
              [-154.12043209499993, 57.14793528900003],
              [-154.1749161449999, 57.14622630400004],
              [-154.2408341139999, 57.15477122600004],
              [-154.2991837229999, 57.14793528900003],
              [-154.36066646999993, 57.14793528900003],
              [-154.37336178299992, 57.14516836100006],
              [-154.39740963399993, 57.13182200700004],
              [-154.41156979099992, 57.12742747600004],
              [-154.4682511059999, 57.12445709800005],
              [-154.49494381399992, 57.11359284100007],
              [-154.48412024599992, 57.08958567900004],
              [-154.46076412699992, 57.07111237200007],
              [-154.43781490799992, 57.05727773600006],
              [-154.41295325399992, 57.05019765800006],
              [-154.38422604099992, 57.05174388200004],
              [-154.3613175119999, 57.05906810100004],
              [-154.3460587229999, 57.06903717700004],
              [-154.31904049399992, 57.096136786000045],
              [-154.29718990799992, 57.11029694200005],
              [-154.27240963399993, 57.11737702000005],
              [-154.12120520699992, 57.12372467700004],
              [-154.10370846299992, 57.11383698100008],
              [-154.1037491529999, 57.09796784100007],
              [-154.1119278639999, 57.07672760600008],
              [-154.13097083199992, 57.044907945000034],
              [-154.15318762899992, 57.01976146000004],
              [-154.15831458199992, 57.010199286000045],
              [-154.16026770699992, 56.99872467700004],
              [-154.1575821609999, 56.976996161000045],
              [-154.15831458199992, 56.969183661000045],
              [-154.1724747389999, 56.95262278900003],
              [-154.19383704299992, 56.944566148000035],
              [-154.24767005099991, 56.94188060100004],
              [-154.2303360669999, 56.93305084800005],
              [-154.2217911449999, 56.92536041900007],
              [-154.22191321499992, 56.916449286000045],
              [-154.23029537699992, 56.903998114000046],
              [-154.23798580599993, 56.89956289300005],
              [-154.24592037699992, 56.90135325700004],
              [-154.25385494699992, 56.905462958000044],
              [-154.2615860669999, 56.90770091400003],
              [-154.28180904899992, 56.88727448100008],
              [-154.27660071499992, 56.897772528000075],
              [-154.2775772779999, 56.905951239000046],
              [-154.28425045499992, 56.91160716400003],
              [-154.29609127499992, 56.91453685100004],
              [-154.3006485669999, 56.87352122600004],
              [-154.2991837229999, 56.866848049000055],
              [-154.2825821609999, 56.869574286000045],
              [-154.25560462099992, 56.88275788000004],
              [-154.2408341139999, 56.88727448100008],
              [-154.2408341139999, 56.87982819200005],
              [-154.2718399729999, 56.863714911000045],
              [-154.28180904899992, 56.85993073100008],
              [-154.2995499339999, 56.85541413000004],
              [-154.3049210279999, 56.85578034100007],
              [-154.30488033799992, 56.87490469000005],
              [-154.30500240799992, 56.90228913000004],
              [-154.3134659499999, 56.91828034100007],
              [-154.32831783799992, 56.929673570000034],
              [-154.38874264199993, 56.96385325700004],
              [-154.4116104809999, 56.97296784100007],
              [-154.44819088399993, 56.97870514500005],
              [-154.4732559889999, 56.98769765800006],
              [-154.48412024599992, 56.98969147300005],
              [-154.51488196499992, 56.98969147300005],
              [-154.52855383999992, 56.99164459800005],
              [-154.53168697799993, 56.99656810100004],
              [-154.52985592399992, 57.003159898000035],
              [-154.52717037699992, 57.032904364000046],
              [-154.52000891799992, 57.055975653000075],
              [-154.5163468089999, 57.07758209800005],
              [-154.53339596299992, 57.11204661700003],
              [-154.5314835279999, 57.15314362200007],
              [-154.5350235669999, 57.17462799700007],
              [-154.54857337099992, 57.19281647300005],
              [-154.58869381399992, 57.23110586100006],
              [-154.59711666599992, 57.24664948100008],
              [-154.60151119699992, 57.25893789300005],
              [-154.61217200399992, 57.26630280200004],
              [-154.6255997389999, 57.269964911000045],
              [-154.67255611899992, 57.27090078300006],
              [-154.68134518099993, 57.27289459800005],
              [-154.6843155589999, 57.27749258000006],
              [-154.68476314999992, 57.28217194200005],
              [-154.68586178299992, 57.284491278000075],
              [-154.71605383999992, 57.281683661000045],
              [-154.75141354099992, 57.27383047100005],
              [-154.78315182199992, 57.27293528900003],
              [-154.80256100199992, 57.29132721600007],
              [-154.78766842399992, 57.29157135600008],
              [-154.7682999339999, 57.294989325000074],
              [-154.75511633999992, 57.30263906500005],
              [-154.7581680979999, 57.31557851800005],
              [-154.77143307199992, 57.325384833000044],
              [-154.79845130099991, 57.33608633000006],
              [-154.81000729099992, 57.346584377000056],
              [-154.78754635299993, 57.35773346600007],
              [-154.76349850199992, 57.35419342700004],
              [-154.7369278639999, 57.34511953300006],
              [-154.70697994699992, 57.33978913000004],
              [-154.71100826699993, 57.347723700000074],
              [-154.71711178299992, 57.35382721600007],
              [-154.7249649729999, 57.35805898600006],
              [-154.7342423169999, 57.360256252000056],
              [-154.7342423169999, 57.36709219000005],
              [-154.7147110669999, 57.378119208000044],
              [-154.70844479099992, 57.395697333000044],
              [-154.71320553299992, 57.41425202000005],
              [-154.72687740799992, 57.42853424700007],
              [-154.6861466139999, 57.45270416900007],
              [-154.65339107999992, 57.46076080900008],
              [-154.64427649599992, 57.46674225500004],
              [-154.6585587229999, 57.476263739000046],
              [-154.65021725199992, 57.49603913000004],
              [-154.6346329419999, 57.513739325000074],
              [-154.6147354809999, 57.526556708000044],
              [-154.58295650899993, 57.534084377000056],
              [-154.5624893869999, 57.54393138200004],
              [-154.54930579299992, 57.544582424000055],
              [-154.5400284499999, 57.539496161000045],
              [-154.52143307199992, 57.51788971600007],
              [-154.5097550119999, 57.52838776200008],
              [-154.5234268869999, 57.570013739000046],
              [-154.51488196499992, 57.579291083000044],
              [-154.45555579299992, 57.57672760600008],
              [-154.39850826699993, 57.56631094000005],
              [-154.40990149599992, 57.57290273600006],
              [-154.44688880099991, 57.58612702000005],
              [-154.39850826699993, 57.61347077000005],
              [-154.3643692699999, 57.62714264500005],
              [-154.36200924399992, 57.63104889500005],
              [-154.3564346999999, 57.64545319200005],
              [-154.3569229809999, 57.64826080900008],
              [-154.33759518099993, 57.65021393400008],
              [-154.3006485669999, 57.645697333000044],
              [-154.28180904899992, 57.64826080900008],
              [-154.26825924399992, 57.655503648000035],
              [-154.25470943899992, 57.665228583000044],
              [-154.23932857999992, 57.67328522300005],
              [-154.22032630099991, 57.67552317900004],
              [-154.2026261059999, 57.67182038000004],
              [-154.1693009109999, 57.65924713700008],
              [-154.15143795499992, 57.65509674700007],
              [-154.05585689999992, 57.65509674700007],
              [-154.01862545499992, 57.64720286700003],
              [-154.00055904899992, 57.62970612200007],
              [-153.97333736899992, 57.57249583500004],
              [-153.99994869699992, 57.55565013200004],
              [-154.1104630199999, 57.544582424000055],
              [-154.0683487619999, 57.53705475500004],
              [-153.97480221299992, 57.54995351800005],
              [-153.93549557199992, 57.53497955900008],
              [-153.9202774729999, 57.50722890800006],
              [-153.90693111899992, 57.43496328300006],
              [-153.89073645699992, 57.40802643400008],
              [-153.87531490799992, 57.39915599200003],
              [-153.84052486899992, 57.38666413000004],
              [-153.82563229099992, 57.37726471600007],
              [-153.77782141799992, 57.322333075000074],
              [-153.74730383999992, 57.30341217700004],
              [-153.63068600199992, 57.27090078300006],
              [-153.6445206369999, 57.28400299700007],
              [-153.66913814999992, 57.297308661000045],
              [-153.69615637899992, 57.30768463700008],
              [-153.74376380099991, 57.31891510600008],
              [-153.7538956369999, 57.336371161000045],
              [-153.75824947799993, 57.35883209800005],
              [-153.76789303299992, 57.38076406500005],
              [-153.78473873599992, 57.39435455900008],
              [-153.80011959499993, 57.40131256700005],
              [-153.81135006399992, 57.41233958500004],
              [-153.81977291599992, 57.48493073100008],
              [-153.8183487619999, 57.506293036000045],
              [-153.8088272779999, 57.51788971600007],
              [-153.84369869699992, 57.55097077000005],
              [-153.84980221299992, 57.55882396000004],
              [-153.85081946499992, 57.57729726800005],
              [-153.8425186839999, 57.58197663000004],
              [-153.8300675119999, 57.577785549000055],
              [-153.8187149729999, 57.56940338700008],
              [-153.79242916599992, 57.555975653000075],
              [-153.74962317599991, 57.54437897300005],
              [-153.70636959499993, 57.539048570000034],
              [-153.6784561839999, 57.544582424000055],
              [-153.69102942599991, 57.55377838700008],
              [-153.70514889199993, 57.557928778000075],
              [-153.7405899729999, 57.55882396000004],
              [-153.75397701699993, 57.56195709800005],
              [-153.86872311099992, 57.628607489000046],
              [-153.88459225199992, 57.64826080900008],
              [-153.85277258999992, 57.65867747600004],
              [-153.8109024729999, 57.65900299700007],
              [-153.66759192599991, 57.641831773000035],
              [-153.64110266799992, 57.62921784100007],
              [-153.63068600199992, 57.59979889500005],
              [-153.61750240799992, 57.60521067900004],
              [-153.59101314999992, 57.60138580900008],
              [-153.58287512899992, 57.60732656500005],
              [-153.5845841139999, 57.61709219000005],
              [-153.59333248599992, 57.62832265800006],
              [-153.60468502499992, 57.637600002000056],
              [-153.63105221299992, 57.64679596600007],
              [-153.69896399599992, 57.68235911700003],
              [-153.7560929029999, 57.69318268400008],
              [-153.87641354099992, 57.70111725500004],
              [-153.9057511059999, 57.71124909100007],
              [-153.92552649599992, 57.72955963700008],
              [-153.9382218089999, 57.77562083500004],
              [-153.92463131399992, 57.81049225500004],
              [-153.89447994699992, 57.837591864000046],
              [-153.84345455599993, 57.87059153900003],
              [-153.83613033799992, 57.87417226800005],
              [-153.82978268099993, 57.87523021000004],
              [-153.81550045499992, 57.87396881700005],
              [-153.8088272779999, 57.87417226800005],
              [-153.79670162699992, 57.87848541900007],
              [-153.76447506399992, 57.89468008000006],
              [-153.72382564999992, 57.90208567900004],
              [-153.7194718089999, 57.900824286000045],
              [-153.70270748599992, 57.89126211100006],
              [-153.69257564999992, 57.88703034100007],
              [-153.6822403639999, 57.889105536000045],
              [-153.67280025899993, 57.89313385600008],
              [-153.66547604099992, 57.89468008000006],
              [-153.64509029899992, 57.883693752000056],
              [-153.63829505099991, 57.867621161000045],
              [-153.62779700399992, 57.853176174000055],
              [-153.59626217399992, 57.846869208000044],
              [-153.57441158799992, 57.839544989000046],
              [-153.56456458199992, 57.821600653000075],
              [-153.56220455599993, 57.79905833500004],
              [-153.56244869699992, 57.77798086100006],
              [-153.55829830599993, 57.738348700000074],
              [-153.54694576699993, 57.698919989000046],
              [-153.52940833199992, 57.661322333000044],
              [-153.5071915359999, 57.62714264500005],
              [-153.49815833199992, 57.642564195000034],
              [-153.52216549399992, 57.69562409100007],
              [-153.52765865799992, 57.72333405200004],
              [-153.48102779899992, 57.70270416900007],
              [-153.45234127499992, 57.694566148000035],
              [-153.43952389199993, 57.69940827000005],
              [-153.44843502499992, 57.716131903000075],
              [-153.46955318899992, 57.728949286000045],
              [-153.5140274729999, 57.743841864000046],
              [-153.4991348949999, 57.76089101800005],
              [-153.47431393099993, 57.77362702000005],
              [-153.44623775899993, 57.777411200000074],
              [-153.42182369699992, 57.76740143400008],
              [-153.40941321499992, 57.75169505400004],
              [-153.39838619699992, 57.73395416900007],
              [-153.38438880099991, 57.71857330900008],
              [-153.3631485669999, 57.70966217700004],
              [-153.33356686099992, 57.71385325700004],
              [-153.3212784499999, 57.730902411000045],
              [-153.32579505099991, 57.74941640800006],
              [-153.3464249339999, 57.75804271000004],
              [-153.3603409499999, 57.76117584800005],
              [-153.37897701699993, 57.77484772300005],
              [-153.39374752499992, 57.78021881700005],
              [-153.39643307199992, 57.78510163000004],
              [-153.39818274599992, 57.78998444200005],
              [-153.4013565749999, 57.792222398000035],
              [-153.43207760299993, 57.792222398000035],
              [-153.45881100199992, 57.802801825000074],
              [-153.47667395699992, 57.82135651200008],
              [-153.4764298169999, 57.83901601800005],
              [-153.44916744699992, 57.846869208000044],
              [-153.42499752499992, 57.84271881700005],
              [-153.35016842399992, 57.81268952000005],
              [-153.2913712229999, 57.79877350500004],
              [-153.22972571499992, 57.792222398000035],
              [-153.21104895699992, 57.785589911000045],
              [-153.21003170499992, 57.76943594000005],
              [-153.21454830599993, 57.748928127000056],
              [-153.21235104099992, 57.72955963700008],
              [-153.20649166599992, 57.72089264500005],
              [-153.19933020699992, 57.714544989000046],
              [-153.19029700399992, 57.71067942900004],
              [-153.1788223949999, 57.70966217700004],
              [-153.19526119699992, 57.72711823100008],
              [-153.19774329299992, 57.75112539300005],
              [-153.19188391799992, 57.80524323100008],
              [-153.19867916599992, 57.857123114000046],
              [-153.20453854099992, 57.868475653000075],
              [-153.23188229099992, 57.888739325000074],
              [-153.24030514199993, 57.90208567900004],
              [-153.21198482999992, 57.90180084800005],
              [-153.18683834499993, 57.89354075700004],
              [-153.1440323559999, 57.86790599200003],
              [-153.07506262899992, 57.83746979400007],
              [-153.0615128249999, 57.82575104400007],
              [-153.04845130099991, 57.833197333000044],
              [-153.06061764199993, 57.84162018400008],
              [-153.0850723949999, 57.852443752000056],
              [-153.09691321499992, 57.86050039300005],
              [-153.09772701699993, 57.86933014500005],
              [-153.10948645699992, 57.88336823100008],
              [-153.1259659499999, 57.89638906500005],
              [-153.15607662699992, 57.907863674000055],
              [-153.20246334499993, 57.946193752000056],
              [-153.22101803299992, 57.95587799700007],
              [-153.2628067699999, 57.966009833000044],
              [-153.2951554029999, 57.986395575000074],
              [-153.2999161449999, 57.991888739000046],
              [-153.3017471999999, 58.00079987200007],
              [-153.29645748599992, 58.00812409100007],
              [-153.28425045499992, 58.01044342700004],
              [-153.27057857999992, 58.00861237200007],
              [-153.26081295499992, 58.003892320000034],
              [-153.22956295499992, 57.99799225500004],
              [-153.16694088399993, 57.970038153000075],
              [-153.11876380099991, 57.96039459800005],
              [-153.08356686099992, 57.94623444200005],
              [-153.04621334499993, 57.94017161700003],
              [-153.01276607999992, 57.92910390800006],
              [-152.99323482999992, 57.92877838700008],
              [-153.00470943899992, 57.948553778000075],
              [-152.9826554029999, 57.95148346600007],
              [-152.8622940749999, 57.93451569200005],
              [-152.83197994699992, 57.92365143400008],
              [-152.80829830599993, 57.908270575000074],
              [-152.8546036449999, 57.89545319200005],
              [-152.87763424399992, 57.88617584800005],
              [-152.89081783799992, 57.87417226800005],
              [-152.87262936099992, 57.87604401200008],
              [-152.85667883999992, 57.88031647300005],
              [-152.85667883999992, 57.87417226800005],
              [-152.89350338399993, 57.86041901200008],
              [-152.9036759109999, 57.837591864000046],
              [-152.90485592399992, 57.81159088700008],
              [-152.92524166599992, 57.76825592700004],
              [-152.9155167309999, 57.75576406500005],
              [-152.89936275899993, 57.745794989000046],
              [-152.89081783799992, 57.733303127000056],
              [-152.88556881399992, 57.72870514500005],
              [-152.8737686839999, 57.730169989000046],
              [-152.86200924399992, 57.73501211100006],
              [-152.85667883999992, 57.74042389500005],
              [-152.85773678299992, 57.74994538000004],
              [-152.86249752499992, 57.76552969000005],
              [-152.8635147779999, 57.77423737200007],
              [-152.85871334499993, 57.81439850500004],
              [-152.84369869699992, 57.84528229400007],
              [-152.81798255099991, 57.86041901200008],
              [-152.78099524599992, 57.85370514500005],
              [-152.7662247389999, 57.843410549000055],
              [-152.7541397779999, 57.832464911000045],
              [-152.74181067599991, 57.82689036700003],
              [-152.72638912699992, 57.833197333000044],
              [-152.7139786449999, 57.846869208000044],
              [-152.69806881399992, 57.87571849200003],
              [-152.68537350199992, 57.88784414300005],
              [-152.66877193899992, 57.88080475500004],
              [-152.63556881399992, 57.87156810100004],
              [-152.62397213399993, 57.86050039300005],
              [-152.61274166599992, 57.87490469000005],
              [-152.61571204299992, 57.89044830900008],
              [-152.6260880199999, 57.904730536000045],
              [-152.6369522779999, 57.91510651200008],
              [-152.62458248599992, 57.932847398000035],
              [-152.60789954299992, 57.93504466400003],
              [-152.59040279899992, 57.928900458000044],
              [-152.57551021999993, 57.92133209800005],
              [-152.57042395699992, 57.91616445500006],
              [-152.56501217399992, 57.90843333500004],
              [-152.55890865799992, 57.903225002000056],
              [-152.55162512899992, 57.90521881700005],
              [-152.5424698559999, 57.91152578300006],
              [-152.5327042309999, 57.91445547100005],
              [-152.5069473949999, 57.91510651200008],
              [-152.4863175119999, 57.91071198100008],
              [-152.47272701699993, 57.90033600500004],
              [-152.46088619699992, 57.88784414300005],
              [-152.44550533799992, 57.87726471600007],
              [-152.4283341139999, 57.868068752000056],
              [-152.42280025899993, 57.85927969000005],
              [-152.42670650899993, 57.84845612200007],
              [-152.43834387899992, 57.833197333000044],
              [-152.42113196499992, 57.821966864000046],
              [-152.4022110669999, 57.823472398000035],
              [-152.38255774599992, 57.833238023000035],
              [-152.3632706369999, 57.846869208000044],
              [-152.35631262899992, 57.83820221600007],
              [-152.3482559889999, 57.831691799000055],
              [-152.3392227859999, 57.827460028000075],
              [-152.3290909499999, 57.82575104400007],
              [-152.3572891919999, 57.79901764500005],
              [-152.4589737619999, 57.76813385600008],
              [-152.4966934889999, 57.747259833000044],
              [-152.5350235669999, 57.71979401200008],
              [-152.5511368479999, 57.70331452000005],
              [-152.5413712229999, 57.69599030200004],
              [-152.5206192699999, 57.70262278900003],
              [-152.4980362619999, 57.71588776200008],
              [-152.47309322799993, 57.72601959800005],
              [-152.46308346299992, 57.72288646000004],
              [-152.46849524599992, 57.71401601800005],
              [-152.46564693899992, 57.69232819200005],
              [-152.4689835279999, 57.67869700700004],
              [-152.47687740799992, 57.67202383000006],
              [-152.48615475199992, 57.666083075000074],
              [-152.49360104099992, 57.65509674700007],
              [-152.4677628249999, 57.65717194200005],
              [-152.42084713399993, 57.68195221600007],
              [-152.39740963399993, 57.68854401200008],
              [-152.4155167309999, 57.67495351800005],
              [-152.42829342399992, 57.655951239000046],
              [-152.43586178299992, 57.63544342700004],
              [-152.43834387899992, 57.617173570000034],
              [-152.42634029899992, 57.61351146000004],
              [-152.3427628249999, 57.633978583000044],
              [-152.1608780589999, 57.62714264500005],
            ],
          ],
          [
            [
              [-136.38980058499993, 57.96356842700004],
              [-136.37905839799993, 57.93528880400004],
              [-136.39248613199993, 57.898871161000045],
              [-136.4199112619999, 57.86554596600007],
              [-136.45128333199995, 57.846869208000044],
              [-136.4538468089999, 57.86310455900008],
              [-136.46410071499992, 57.87262604400007],
              [-136.47118079299992, 57.88117096600007],
              [-136.46426347599993, 57.89468008000006],
              [-136.47183183499993, 57.89899323100008],
              [-136.48180091099994, 57.902044989000046],
              [-136.49339758999992, 57.90326569200005],
              [-136.5059301419999, 57.90208567900004],
              [-136.50015214799993, 57.91071198100008],
              [-136.49429277299993, 57.91742584800005],
              [-136.48741614499994, 57.923163153000075],
              [-136.4785863919999, 57.92877838700008],
              [-136.4785863919999, 57.935614325000074],
              [-136.49693762899994, 57.93854401200008],
              [-136.51024329299992, 57.93305084800005],
              [-136.52318274599992, 57.92527903900003],
              [-136.5403539699999, 57.92133209800005],
              [-136.55284583199995, 57.925116278000075],
              [-136.5528051419999, 57.93374258000006],
              [-136.5447485019999, 57.94310130400004],
              [-136.5331925119999, 57.949286200000074],
              [-136.5463761059999, 57.962103583000044],
              [-136.5419815749999, 57.97809479400007],
              [-136.5281469389999, 57.99323151200008],
              [-136.5127660799999, 58.003892320000034],
              [-136.52061926999994, 58.01349518400008],
              [-136.54674231699994, 58.01239655200004],
              [-136.56114661399994, 58.01752350500004],
              [-136.55553137899994, 58.02423737200007],
              [-136.55125891799992, 58.03188711100006],
              [-136.54845130099994, 58.04010651200008],
              [-136.54629472599993, 58.06037018400008],
              [-136.54283606699994, 58.06590403900003],
              [-136.5147192049999, 58.08673737200007],
              [-136.49551347599993, 58.094916083000044],
              [-136.4753311839999, 58.09784577000005],
              [-136.45750891799992, 58.09324778900003],
              [-136.4380590489999, 58.07245514500005],
              [-136.36192786399994, 58.03119538000004],
              [-136.33836829299992, 58.01463450700004],
              [-136.33682206899994, 58.007025458000044],
              [-136.37002519399994, 57.99994538000004],
              [-136.3779190749999, 57.99005768400008],
              [-136.38980058499993, 57.96356842700004],
            ],
          ],
          [
            [
              [-153.4183650379999, 58.06598541900007],
              [-153.32221432199992, 58.127386786000045],
              [-153.32966061099992, 58.134833075000074],
              [-153.31305904899992, 58.141791083000044],
              [-153.29548092399992, 58.14642975500004],
              [-153.27778072799993, 58.14679596600007],
              [-153.26081295499992, 58.141058661000045],
              [-153.22508704299992, 58.11212799700007],
              [-153.20270748599992, 58.098822333000044],
              [-153.18195553299992, 58.09324778900003],
              [-153.13105221299992, 58.10024648600006],
              [-153.11676998599992, 58.10008372600004],
              [-153.1061905589999, 58.094631252000056],
              [-153.08796139199993, 58.07611725500004],
              [-153.07892818899992, 58.07217031500005],
              [-153.0742081369999, 58.068060614000046],
              [-153.05842037699992, 58.04205963700008],
              [-153.0475968089999, 58.03705475500004],
              [-153.00007076699993, 58.03119538000004],
              [-152.89081783799992, 57.997707424000055],
              [-152.90351314999992, 57.990668036000045],
              [-152.91657467399992, 57.991888739000046],
              [-152.9304093089999, 57.99599844000005],
              [-152.94542395699992, 57.997707424000055],
              [-152.98371334499993, 57.98574453300006],
              [-153.00007076699993, 57.984035549000055],
              [-153.02692623599992, 57.98875560100004],
              [-153.08165442599991, 58.00722890800006],
              [-153.11554928299992, 58.013657945000034],
              [-153.16864986899992, 58.03270091400003],
              [-153.20270748599992, 58.02977122600004],
              [-153.21605383999992, 58.03489817900004],
              [-153.24445553299992, 58.07172272300005],
              [-153.26264400899993, 58.08535390800006],
              [-153.2880753249999, 58.08641185100004],
              [-153.2631729809999, 58.05914948100008],
              [-153.2532852859999, 58.05231354400007],
              [-153.34032141799992, 58.04645416900007],
              [-153.37958736899992, 58.04950592700004],
              [-153.4183650379999, 58.06598541900007],
            ],
          ],
          [
            [
              [-151.86607825399992, 58.25775788000004],
              [-151.8271378249999, 58.265611070000034],
              [-151.80988521999993, 58.262925523000035],
              [-151.79344641799992, 58.24469635600008],
              [-151.80597896999993, 58.212103583000044],
              [-151.8150528639999, 58.19611237200007],
              [-151.8288468089999, 58.18203359600005],
              [-151.84618079299992, 58.17519765800006],
              [-151.86888587099992, 58.173529364000046],
              [-151.8886612619999, 58.17885976800005],
              [-151.8970841139999, 58.19285716400003],
              [-151.89183508999992, 58.20697663000004],
              [-151.86607825399992, 58.25775788000004],
            ],
          ],
          [
            [
              [-135.8479711579999, 57.39435455900008],
              [-135.8406469389999, 57.414496161000045],
              [-135.85387122299994, 57.425034898000035],
              [-135.89635169199994, 57.43528880400004],
              [-135.93443762899994, 57.45221588700008],
              [-135.94908606699994, 57.46185944200005],
              [-135.95034745999993, 57.46942780200004],
              [-135.9612524079999, 57.48346588700008],
              [-135.97740637899994, 57.49713776200008],
              [-136.0124405589999, 57.51788971600007],
              [-135.98253333199995, 57.52415599200003],
              [-135.9467667309999, 57.51634349200003],
              [-135.88955644399994, 57.489935614000046],
              [-135.83897864499994, 57.45498281500005],
              [-135.81021074099993, 57.439886786000045],
              [-135.77969316299993, 57.43528880400004],
              [-135.80089270699995, 57.46580638200004],
              [-135.83657792899993, 57.488714911000045],
              [-136.03941809799994, 57.57689036700003],
              [-136.07388261599993, 57.60732656500005],
              [-136.06102454299992, 57.61151764500005],
              [-136.04771887899994, 57.61322663000004],
              [-136.01927649599992, 57.61347077000005],
              [-136.0244034499999, 57.601263739000046],
              [-136.0185440749999, 57.59398021000004],
              [-136.0060929029999, 57.59137604400007],
              [-135.99132239499994, 57.592962958000044],
              [-135.99644934799994, 57.607489325000074],
              [-135.98550370999993, 57.61322663000004],
              [-135.95034745999993, 57.61347077000005],
              [-135.95034745999993, 57.62091705900008],
              [-135.9693090489999, 57.62299225500004],
              [-136.00572669199994, 57.63222890800006],
              [-136.01927649599992, 57.633978583000044],
              [-136.05040442599994, 57.628607489000046],
              [-136.05711829299992, 57.630560614000046],
              [-136.06558183499993, 57.63914622600004],
              [-136.07591712099992, 57.64704010600008],
              [-136.08458411399994, 57.648504950000074],
              [-136.0882055329999, 57.63764069200005],
              [-136.0966690749999, 57.62295156500005],
              [-136.1154679029999, 57.62164948100008],
              [-136.1342667309999, 57.630113023000035],
              [-136.1428116529999, 57.64476146000004],
              [-136.1365453769999, 57.657538153000075],
              [-136.12144934799994, 57.66982656500005],
              [-136.1035050119999, 57.678941148000035],
              [-136.0882055329999, 57.68235911700003],
              [-136.0882055329999, 57.68854401200008],
              [-136.20763098899994, 57.74827708500004],
              [-136.22569739499994, 57.76658763200004],
              [-136.22472083199995, 57.784816799000055],
              [-136.23839270699995, 57.792222398000035],
              [-136.26036536399994, 57.77610911700003],
              [-136.27725175699993, 57.77533600500004],
              [-136.29283606699994, 57.78538646000004],
              [-136.3103735019999, 57.80182526200008],
              [-136.31993567599994, 57.80683014500005],
              [-136.3435766269999, 57.81549713700008],
              [-136.34825598899994, 57.822333075000074],
              [-136.3522843089999, 57.83417389500005],
              [-136.36241614499994, 57.84015534100007],
              [-136.37588456899994, 57.841457424000055],
              [-136.38980058499993, 57.83942291900007],
              [-136.39830481699994, 57.82135651200008],
              [-136.40587317599994, 57.81549713700008],
              [-136.41649329299992, 57.82575104400007],
              [-136.41722571499992, 57.83502838700008],
              [-136.40591386599993, 57.85447825700004],
              [-136.3948461579999, 57.88568756700005],
              [-136.3582250639999, 57.91364166900007],
              [-136.34825598899994, 57.92877838700008],
              [-136.3510636059999, 57.935614325000074],
              [-136.3659561839999, 57.95270416900007],
              [-136.3693741529999, 57.96356842700004],
              [-136.36436926999994, 57.975775458000044],
              [-136.35313880099994, 57.98322174700007],
              [-136.34044348899994, 57.98847077000005],
              [-136.33116614499994, 57.99396393400008],
              [-136.31191972599993, 57.99551015800006],
              [-136.28384355399993, 57.981675523000035],
              [-136.16173255099994, 57.902411200000074],
              [-136.0585831369999, 57.85040924700007],
              [-136.04600989499994, 57.84739817900004],
              [-136.03294837099992, 57.846869208000044],
              [-136.0567113919999, 57.86823151200008],
              [-136.1440323559999, 57.90778229400007],
              [-136.2206925119999, 57.96857330900008],
              [-136.23497473899994, 57.976548570000034],
              [-136.25064042899993, 57.98232656500005],
              [-136.2969457669999, 58.01056549700007],
              [-136.3255102199999, 58.03929271000004],
              [-136.4096573559999, 58.07990143400008],
              [-136.43077551999994, 58.10687897300005],
              [-136.42418372299994, 58.12246328300006],
              [-136.4052628249999, 58.13393789300005],
              [-136.38023841099994, 58.14036692900004],
              [-136.3557022779999, 58.141058661000045],
              [-136.33409583199995, 58.13532135600008],
              [-136.29552161399994, 58.115301825000074],
              [-136.2725317049999, 58.10687897300005],
              [-136.28160559799994, 58.11798737200007],
              [-136.2935277989999, 58.12592194200005],
              [-136.30003821499992, 58.13458893400008],
              [-136.2930395169999, 58.14789459800005],
              [-136.33238684799994, 58.179348049000055],
              [-136.3489477199999, 58.19643789300005],
              [-136.3557022779999, 58.21987539300005],
              [-136.30040442599994, 58.216782945000034],
              [-136.27269446499992, 58.22093333500004],
              [-136.2631729809999, 58.21694570500006],
              [-136.25951087099992, 58.19969310100004],
              [-136.25511633999992, 58.19049713700008],
              [-136.23595130099994, 58.171942450000074],
              [-136.23155676999994, 58.15875885600008],
              [-136.2246801419999, 58.14923737200007],
              [-136.19273841099994, 58.13426341400003],
              [-136.1831762359999, 58.12055084800005],
              [-136.18496660099993, 58.11766185100004],
              [-136.1979874339999, 58.088771877000056],
              [-136.19371497299994, 58.083644924000055],
              [-136.16563880099994, 58.06708405200004],
              [-136.10118567599994, 58.05853913000004],
              [-136.1467179029999, 58.08104075700004],
              [-136.15953528599994, 58.089829820000034],
              [-136.1647843089999, 58.10195547100005],
              [-136.1655167309999, 58.11908600500004],
              [-136.16331946499992, 58.134466864000046],
              [-136.15953528599994, 58.141058661000045],
              [-136.1695043609999, 58.146918036000045],
              [-136.17699133999992, 58.16071198100008],
              [-136.1802465489999, 58.17674388200004],
              [-136.1775610019999, 58.189439195000034],
              [-136.1646215489999, 58.196600653000075],
              [-136.14590410099993, 58.20148346600007],
              [-136.1328832669999, 58.20718008000006],
              [-136.13658606699994, 58.216782945000034],
              [-136.13658606699994, 58.22304922100005],
              [-136.10293535099993, 58.22162506700005],
              [-136.07095292899993, 58.21141185100004],
              [-135.98228919199994, 58.167629299000055],
              [-135.96532141799992, 58.16400788000004],
              [-135.9578344389999, 58.17210521000004],
              [-135.9595434239999, 58.196926174000055],
              [-135.9558813139999, 58.20425039300005],
              [-135.94420325399994, 58.216782945000034],
              [-135.9228409499999, 58.23191966400003],
              [-135.8135473299999, 58.27435944200005],
              [-135.78506425699993, 58.27606842700004],
              [-135.7588598299999, 58.26862213700008],
              [-135.71499589799993, 58.229722398000035],
              [-135.68936113199993, 58.226263739000046],
              [-135.66246497299994, 58.23004791900007],
              [-135.63565019399994, 58.23041413000004],
              [-135.6240128249999, 58.22500234600005],
              [-135.60142981699994, 58.20697663000004],
              [-135.59097245999993, 58.203111070000034],
              [-135.55630449099993, 58.19940827000005],
              [-135.54629472599993, 58.19627513200004],
              [-135.5537817049999, 58.189439195000034],
              [-135.5371801419999, 58.18113841400003],
              [-135.5019425119999, 58.173814195000034],
              [-135.48485266799992, 58.162095445000034],
              [-135.49669348899994, 58.150824286000045],
              [-135.5022680329999, 58.138332424000055],
              [-135.50597083199995, 58.12547435100004],
              [-135.51211503799993, 58.11318594000005],
              [-135.5234268869999, 58.102443752000056],
              [-135.53404700399994, 58.09943268400008],
              [-135.5456436839999, 58.09833405200004],
              [-135.5606176419999, 58.09324778900003],
              [-135.58214270699995, 58.07518138200004],
              [-135.6023656889999, 58.054022528000075],
              [-135.62730872299994, 58.04140859600005],
              [-135.6923721999999, 58.05341217700004],
              [-135.76939856699994, 58.04645416900007],
              [-135.78307044199994, 58.04205963700008],
              [-135.75279700399994, 58.02728913000004],
              [-135.69322669199994, 58.04010651200008],
              [-135.6624242829999, 58.03119538000004],
              [-135.66982988199993, 58.02496979400007],
              [-135.6572973299999, 58.02090078300006],
              [-135.63951575399994, 58.01788971600007],
              [-135.6248266269999, 58.01316966400003],
              [-135.6214086579999, 58.003892320000034],
              [-135.6316625639999, 57.997381903000075],
              [-135.6499731109999, 57.99559153900003],
              [-135.7412817049999, 58.00226471600007],
              [-135.7685440749999, 57.99823639500005],
              [-135.79332434799994, 57.984035549000055],
              [-135.7089737619999, 57.97825755400004],
              [-135.66246497299994, 57.97011953300006],
              [-135.65615800699993, 57.949286200000074],
              [-135.64073645699995, 57.95209381700005],
              [-135.62743079299992, 57.95888906500005],
              [-135.62340247299994, 57.967678127000056],
              [-135.63565019399994, 57.976548570000034],
              [-135.63565019399994, 57.984035549000055],
              [-135.61436926999994, 57.98383209800005],
              [-135.59288489499994, 57.98745351800005],
              [-135.57310950399994, 57.995306708000044],
              [-135.5571996739999, 58.00763580900008],
              [-135.51553300699993, 58.05853913000004],
              [-135.43643144399994, 58.07957591400003],
              [-135.42446855399993, 58.09511953300006],
              [-135.4317113919999, 58.10407135600008],
              [-135.44644120999993, 58.11273834800005],
              [-135.45750891799992, 58.127386786000045],
              [-135.43980872299994, 58.128892320000034],
              [-135.4080297519999, 58.13857656500005],
              [-135.38927161399994, 58.141058661000045],
              [-135.36880449099993, 58.13934967700004],
              [-135.34654700399994, 58.13467031500005],
              [-135.3073624339999, 58.12055084800005],
              [-135.3146866529999, 58.11815013200004],
              [-135.3340551419999, 58.10687897300005],
              [-135.31676184799994, 58.10053131700005],
              [-135.30020097599993, 58.101223049000055],
              [-135.2664281889999, 58.10687897300005],
              [-135.2461645169999, 58.104803778000075],
              [-135.2068578769999, 58.095404364000046],
              [-135.18663489499994, 58.09324778900003],
              [-135.11803137899994, 58.10008372600004],
              [-135.1005753249999, 58.09662506700005],
              [-135.08958899599992, 58.089178778000075],
              [-135.09032141799992, 58.082017320000034],
              [-135.10806230399993, 58.07957591400003],
              [-135.10806230399993, 58.07217031500005],
              [-134.9799698559999, 58.05036041900007],
              [-134.9247940749999, 58.02749258000006],
              [-134.90200761599993, 57.97313060100004],
              [-134.9052628249999, 57.96979401200008],
              [-134.91226152299993, 57.96898021000004],
              [-134.91930091099994, 57.96702708500004],
              [-134.92251542899993, 57.960150458000044],
              [-134.92007402299993, 57.95351797100005],
              [-134.9102270169999, 57.94293854400007],
              [-134.9094945949999, 57.935614325000074],
              [-134.91576087099992, 57.92104726800005],
              [-134.92442786399994, 57.91400788000004],
              [-134.95042883999992, 57.90208567900004],
              [-134.9650772779999, 57.886053778000075],
              [-134.96031653599994, 57.87164948100008],
              [-134.94200598899994, 57.858710028000075],
              [-134.91567949099993, 57.846869208000044],
              [-134.94595292899993, 57.85106028900003],
              [-135.0467016269999, 57.90208567900004],
              [-135.10912024599992, 57.919134833000044],
              [-135.12828528599994, 57.92133209800005],
              [-135.14468339799993, 57.924994208000044],
              [-135.1974991529999, 57.949286200000074],
              [-135.20368404899995, 57.943060614000046],
              [-135.18423417899993, 57.92161692900004],
              [-135.16030839799993, 57.90379466400003],
              [-135.1342667309999, 57.889878648000035],
              [-135.10806230399993, 57.88031647300005],
              [-135.0556534499999, 57.87335846600007],
              [-135.0397843089999, 57.86790599200003],
              [-135.0147192049999, 57.84601471600007],
              [-135.00121008999992, 57.84003327000005],
              [-134.98452714799993, 57.846869208000044],
              [-134.9820043609999, 57.829006252000056],
              [-134.9678442049999, 57.82005442900004],
              [-134.9300024079999, 57.81268952000005],
              [-134.9424535799999, 57.80658600500004],
              [-134.9709366529999, 57.80215078300006],
              [-134.98452714799993, 57.79840729400007],
              [-135.0039770169999, 57.788763739000046],
              [-135.01378333199995, 57.78587474200003],
              [-135.20303300699993, 57.78510163000004],
              [-135.25938880099994, 57.79596588700008],
              [-135.4212133449999, 57.863267320000034],
              [-135.4497777989999, 57.871161200000074],
              [-135.48110917899993, 57.87417226800005],
              [-135.49160722599993, 57.87734609600005],
              [-135.5056860019999, 57.89142487200007],
              [-135.69644120999993, 57.93610260600008],
              [-135.84581458199995, 57.992173570000034],
              [-135.8659561839999, 57.99628327000005],
              [-135.88955644399994, 57.997707424000055],
              [-135.88955644399994, 57.990220445000034],
              [-135.8405655589999, 57.975897528000075],
              [-135.81700598899994, 57.96356842700004],
              [-135.80699622299994, 57.946193752000056],
              [-135.79222571499992, 57.93414948100008],
              [-135.61375891799992, 57.89594147300005],
              [-135.5878800119999, 57.884100653000075],
              [-135.57530676999994, 57.88003164300005],
              [-135.54698645699995, 57.87579987200007],
              [-135.5197647779999, 57.861761786000045],
              [-135.51553300699993, 57.86050039300005],
              [-135.51284745999993, 57.85814036700003],
              [-135.5158585279999, 57.84564850500004],
              [-135.51211503799993, 57.83942291900007],
              [-135.49990800699993, 57.83478424700007],
              [-135.40322831899994, 57.81419505400004],
              [-135.3886612619999, 57.81268952000005],
              [-135.3723852199999, 57.80524323100008],
              [-135.32896887899994, 57.76972077000005],
              [-135.32095292899993, 57.75804271000004],
              [-135.32730058499993, 57.751288153000075],
              [-135.35073808499993, 57.74628327000005],
              [-135.3613175119999, 57.73700592700004],
              [-135.36388098899994, 57.726223049000055],
              [-135.35509192599994, 57.72475820500006],
              [-135.32750403599994, 57.72955963700008],
              [-135.2736710279999, 57.73021067900004],
              [-135.2502335279999, 57.726629950000074],
              [-135.2241918609999, 57.716498114000046],
              [-135.2171117829999, 57.71112702000005],
              [-135.21446692599994, 57.70734284100007],
              [-135.2100317049999, 57.70648834800005],
              [-135.1974991529999, 57.70966217700004],
              [-135.1738988919999, 57.72553131700005],
              [-135.16270911399994, 57.72955963700008],
              [-135.11583411399994, 57.73395416900007],
              [-135.10130774599992, 57.73700592700004],
              [-135.08018958199995, 57.75063711100006],
              [-135.07347571499992, 57.751939195000034],
              [-135.06041419199994, 57.752020575000074],
              [-135.0534561839999, 57.754339911000045],
              [-135.03880774599992, 57.75580475500004],
              [-135.02432206899994, 57.75014883000006],
              [-135.0098363919999, 57.746527411000045],
              [-134.98302161399994, 57.76154205900008],
              [-134.9675186839999, 57.76430898600006],
              [-134.9365128249999, 57.76430898600006],
              [-134.9138891269999, 57.755845445000034],
              [-134.90294348899994, 57.73541901200008],
              [-134.8967179029999, 57.71051666900007],
              [-134.88833574099993, 57.68854401200008],
              [-134.89171301999994, 57.673041083000044],
              [-134.8843481109999, 57.65424225500004],
              [-134.85122636599993, 57.60492584800005],
              [-134.84487870999993, 57.58844635600008],
              [-134.8416235019999, 57.57099030200004],
              [-134.8405655589999, 57.552069403000075],
              [-134.84341386599993, 57.53351471600007],
              [-134.84268144399994, 57.522691148000035],
              [-134.83682206899994, 57.51788971600007],
              [-134.8339737619999, 57.514553127000056],
              [-134.81387285099993, 57.49746328300006],
              [-134.81956946499992, 57.48607005400004],
              [-134.85684160099993, 57.498114325000074],
              [-134.87474524599992, 57.489935614000046],
              [-134.84740149599992, 57.46942780200004],
              [-134.8714086579999, 57.461004950000074],
              [-134.90599524599992, 57.45726146000004],
              [-135.02896074099993, 57.46051666900007],
              [-135.0568741529999, 57.46662018400008],
              [-135.1831762359999, 57.51927317900004],
              [-135.32079016799992, 57.58490631700005],
              [-135.45750891799992, 57.633978583000044],
              [-135.51211503799993, 57.64826080900008],
              [-135.55443274599992, 57.67182038000004],
              [-135.56371008999992, 57.67552317900004],
              [-135.5842179029999, 57.68060944200005],
              [-135.62804114499994, 57.70604075700004],
              [-135.76817786399994, 57.75971100500004],
              [-135.8132218089999, 57.76430898600006],
              [-135.80630449099993, 57.75405508000006],
              [-135.79625403599994, 57.743801174000055],
              [-135.78441321499992, 57.73509349200003],
              [-135.7722875639999, 57.72955963700008],
              [-135.75438391799992, 57.72809479400007],
              [-135.73753821499992, 57.72915273600006],
              [-135.72435462099992, 57.72540924700007],
              [-135.71764075399994, 57.70966217700004],
              [-135.7295629549999, 57.70254140800006],
              [-135.7251684239999, 57.694647528000075],
              [-135.71353105399993, 57.68573639500005],
              [-135.70396887899994, 57.67552317900004],
              [-135.76341712099992, 57.67031484600005],
              [-135.79116777299993, 57.66010163000004],
              [-135.80699622299994, 57.64142487200007],
              [-135.73497473899994, 57.65119049700007],
              [-135.71080481699994, 57.64826080900008],
              [-135.6446020169999, 57.61786530200004],
              [-135.62169348899994, 57.61347077000005],
              [-135.60484778599994, 57.607082424000055],
              [-135.58486894399994, 57.592962958000044],
              [-135.5706274079999, 57.57892487200007],
              [-135.57046464799993, 57.57249583500004],
              [-135.6210831369999, 57.575873114000046],
              [-135.6438695949999, 57.57054271000004],
              [-135.65615800699993, 57.552069403000075],
              [-135.61611894399994, 57.56313711100006],
              [-135.5957738919999, 57.564520575000074],
              [-135.5777074859999, 57.55548737200007],
              [-135.56704667899993, 57.54511139500005],
              [-135.55825761599993, 57.53339264500005],
              [-135.5600479809999, 57.52334219000005],
              [-135.5810440749999, 57.51788971600007],
              [-135.5810440749999, 57.511053778000075],
              [-135.56362870999993, 57.50812409100007],
              [-135.5530492829999, 57.49868398600006],
              [-135.54771887899994, 57.48411692900004],
              [-135.54629472599993, 57.466050523000035],
              [-135.55589758999992, 57.45368073100008],
              [-135.5781143869999, 57.448919989000046],
              [-135.6214086579999, 57.44896067900004],
              [-135.5947159499999, 57.42853424700007],
              [-135.5991104809999, 57.419256903000075],
              [-135.6072485019999, 57.41665273600006],
              [-135.61660722599993, 57.41575755400004],
              [-135.6248266269999, 57.411769924000055],
              [-135.6321508449999, 57.411810614000046],
              [-135.64488684799994, 57.41478099200003],
              [-135.6569718089999, 57.41620514500005],
              [-135.6624242829999, 57.411769924000055],
              [-135.6608780589999, 57.40306224200003],
              [-135.65672766799992, 57.39622630400004],
              [-135.6504613919999, 57.39109935100004],
              [-135.64248613199993, 57.387600002000056],
              [-135.65322831899994, 57.387884833000044],
              [-135.66685950399994, 57.38666413000004],
              [-135.6785375639999, 57.383246161000045],
              [-135.69078528599994, 57.36701080900008],
              [-135.70742753799993, 57.366522528000075],
              [-135.8235570949999, 57.38617584800005],
              [-135.8479711579999, 57.39435455900008],
            ],
          ],
          [
            [
              [-134.59727942599994, 58.23725006700005],
              [-134.62047278599994, 58.24640534100007],
              [-134.65078691299993, 58.26772695500006],
              [-134.67495683499993, 58.29181549700007],
              [-134.67983964799993, 58.30927155200004],
              [-134.6628311839999, 58.319647528000075],
              [-134.6210831369999, 58.32322825700004],
              [-134.60411536399994, 58.329779364000046],
              [-134.58433997299994, 58.34096914300005],
              [-134.56334387899994, 58.34454987200007],
              [-134.48184160099993, 58.33348216400003],
              [-134.4462784499999, 58.31513092700004],
              [-134.38125566299993, 58.27138906500005],
              [-134.2793676419999, 58.22064850500004],
              [-134.25841223899994, 58.19627513200004],
              [-134.47032630099994, 58.225816148000035],
              [-134.51227779899995, 58.22304922100005],
              [-134.5353897779999, 58.22410716400003],
              [-134.57803300699993, 58.23468659100007],
              [-134.59727942599994, 58.23725006700005],
            ],
          ],
          [
            [
              [-134.35399329299992, 57.09271881700005],
              [-134.35399329299992, 57.08649323100008],
              [-134.40440833199995, 57.06793854400007],
              [-134.43736731699994, 57.06093984600005],
              [-134.46861731699994, 57.039129950000074],
              [-134.48493404899995, 57.031236070000034],
              [-134.50182044199994, 57.028957424000055],
              [-134.55630449099993, 57.031236070000034],
              [-134.57461503799993, 57.02912018400008],
              [-134.61461341099994, 57.010199286000045],
              [-134.5984594389999, 57.04950592700004],
              [-134.59850012899994, 57.069973049000055],
              [-134.62291419199994, 57.11082591400003],
              [-134.6128637359999, 57.12718333500004],
              [-134.59410559799994, 57.14109935100004],
              [-134.5799047519999, 57.15477122600004],
              [-134.61436926999994, 57.17527903900003],
              [-134.62490800699993, 57.184881903000075],
              [-134.6315811839999, 57.19578685100004],
              [-134.6355688139999, 57.21076080900008],
              [-134.63329016799992, 57.22418854400007],
              [-134.62149003799993, 57.22992584800005],
              [-134.5576879549999, 57.21564362200007],
              [-134.52554277299993, 57.21576569200005],
              [-134.50475012899994, 57.23672109600005],
              [-134.53970292899993, 57.239935614000046],
              [-134.5567113919999, 57.24469635600008],
              [-134.56997636599993, 57.25381094000005],
              [-134.58047441299993, 57.26463450700004],
              [-134.58315995999993, 57.26935455900008],
              [-134.56688391799992, 57.284491278000075],
              [-134.54356848899994, 57.30109284100007],
              [-134.51650956899994, 57.30914948100008],
              [-134.4570206369999, 57.311835028000075],
              [-134.46377519399994, 57.319525458000044],
              [-134.4892471999999, 57.336004950000074],
              [-134.49795488199993, 57.33978913000004],
              [-134.52989661399994, 57.33978913000004],
              [-134.54605058499993, 57.34247467700004],
              [-134.5593969389999, 57.352769273000035],
              [-134.55382239499994, 57.36302317900004],
              [-134.56017005099994, 57.38617584800005],
              [-134.55630449099993, 57.397772528000075],
              [-134.54210364499994, 57.40338776200008],
              [-134.52212480399993, 57.40314362200007],
              [-134.50820878799993, 57.39598216400003],
              [-134.51227779899995, 57.38076406500005],
              [-134.4024145169999, 57.360256252000056],
              [-134.34166419199994, 57.33535390800006],
              [-134.31297766799992, 57.33234284100007],
              [-134.3210343089999, 57.34487539300005],
              [-134.3354386059999, 57.35419342700004],
              [-134.36758378799993, 57.36709219000005],
              [-134.36758378799993, 57.373928127000056],
              [-134.35142981699994, 57.37523021000004],
              [-134.3347875639999, 57.37885163000004],
              [-134.3191625639999, 57.38507721600007],
              [-134.3061417309999, 57.39435455900008],
              [-134.34097245999993, 57.39704010600008],
              [-134.42202714799993, 57.38523997600004],
              [-134.4638565749999, 57.39435455900008],
              [-134.4727270169999, 57.40070221600007],
              [-134.49795488199993, 57.42853424700007],
              [-134.53368079299992, 57.45770905200004],
              [-134.53551184799994, 57.46263255400004],
              [-134.5488988919999, 57.468085028000075],
              [-134.5627335279999, 57.48004791900007],
              [-134.5691625639999, 57.49201080900008],
              [-134.5600479809999, 57.49746328300006],
              [-134.5510961579999, 57.49624258000006],
              [-134.53258216099994, 57.491115627000056],
              [-134.52183997299994, 57.489935614000046],
              [-134.51235917899993, 57.49213288000004],
              [-134.49596106699994, 57.50145091400003],
              [-134.47325598899994, 57.50678131700005],
              [-134.4417211579999, 57.52094147300005],
              [-134.4045304029999, 57.52643463700008],
              [-134.35399329299992, 57.544582424000055],
              [-134.3780004549999, 57.55296458500004],
              [-134.48814856699994, 57.53270091400003],
              [-134.54112708199995, 57.511053778000075],
              [-134.56688391799992, 57.511053778000075],
              [-134.57974199099993, 57.52301666900007],
              [-134.6045629549999, 57.563666083000044],
              [-134.61803137899994, 57.57249583500004],
              [-134.6387426419999, 57.57998281500005],
              [-134.65355383999992, 57.59821198100008],
              [-134.66348222599993, 57.620794989000046],
              [-134.6692602199999, 57.64142487200007],
              [-134.6736547519999, 57.67243073100008],
              [-134.67666581899994, 57.68235911700003],
              [-134.70006262899994, 57.70693594000005],
              [-134.70400956899994, 57.71308014500005],
              [-134.71605383999992, 57.745794989000046],
              [-134.71397864499994, 57.75063711100006],
              [-134.7080785799999, 57.755845445000034],
              [-134.7027074859999, 57.768011786000045],
              [-134.6966039699999, 57.792222398000035],
              [-134.69888261599993, 57.812486070000034],
              [-134.71410071499992, 57.855902411000045],
              [-134.72126217399995, 57.897365627000056],
              [-134.75121008999992, 57.956732489000046],
              [-134.76219641799992, 57.97215403900003],
              [-134.7619522779999, 57.98004791900007],
              [-134.75121008999992, 57.990220445000034],
              [-134.7665909499999, 58.00580475500004],
              [-134.78482011599993, 58.01972077000005],
              [-134.80003821499992, 58.035223700000074],
              [-134.8064672519999, 58.05540599200003],
              [-134.79747473899994, 58.07176341400003],
              [-134.75633704299992, 58.09467194200005],
              [-134.74498450399994, 58.11318594000005],
              [-134.7463272779999, 58.124335028000075],
              [-134.75108801999994, 58.135972398000035],
              [-134.7561742829999, 58.14492422100005],
              [-134.75865637899994, 58.14789459800005],
              [-134.75304114499994, 58.16083405200004],
              [-134.74376380099994, 58.167181708000044],
              [-134.7351781889999, 58.171576239000046],
              [-134.73131262899994, 58.178900458000044],
              [-134.7361547519999, 58.188666083000044],
              [-134.7471410799999, 58.18646881700005],
              [-134.76891028599994, 58.175848700000074],
              [-134.7749731109999, 58.17129140800006],
              [-134.77476966099994, 58.16030508000006],
              [-134.7725317049999, 58.14687734600005],
              [-134.77232825399994, 58.134833075000074],
              [-134.78368079299992, 58.11050039300005],
              [-134.7978409499999, 58.11277903900003],
              [-134.82998613199993, 58.151597398000035],
              [-134.84316972599993, 58.17226797100005],
              [-134.85020911399994, 58.179348049000055],
              [-134.8737686839999, 58.18496328300006],
              [-134.89146887899994, 58.19208405200004],
              [-134.90762285099993, 58.201239325000074],
              [-134.91567949099993, 58.20994700700004],
              [-134.90794837099992, 58.23065827000005],
              [-134.8896378249999, 58.24559153900003],
              [-134.8836156889999, 58.25470612200007],
              [-134.91258704299992, 58.25775788000004],
              [-134.9318741529999, 58.26361725500004],
              [-134.9448949859999, 58.278631903000075],
              [-134.95287024599992, 58.298488674000055],
              [-134.96914628799993, 58.36322663000004],
              [-134.97057044199994, 58.38556549700007],
              [-134.9610082669999, 58.40485260600008],
              [-134.9492895169999, 58.409491278000075],
              [-134.93663489499994, 58.40542226800005],
              [-134.92662512899994, 58.39598216400003],
              [-134.92251542899993, 58.38471100500004],
              [-134.9170629549999, 58.37352122600004],
              [-134.90392005099994, 58.37148672100005],
              [-134.8881729809999, 58.37177155200004],
              [-134.87474524599992, 58.367621161000045],
              [-134.85732988199993, 58.35496653900003],
              [-134.83218339799993, 58.344183661000045],
              [-134.80943762899994, 58.33063385600008],
              [-134.7996313139999, 58.30927155200004],
              [-134.79605058499993, 58.29865143400008],
              [-134.78766842399995, 58.29214101800005],
              [-134.7775772779999, 58.28729889500005],
              [-134.76891028599994, 58.281683661000045],
              [-134.73814856699994, 58.24469635600008],
              [-134.7268774079999, 58.23517487200007],
              [-134.7183324859999, 58.229722398000035],
              [-134.71129309799994, 58.223089911000045],
              [-134.70400956899994, 58.20994700700004],
              [-134.69615637899994, 58.17401764500005],
              [-134.6931860019999, 58.168402411000045],
              [-134.60415605399993, 58.17104726800005],
              [-134.5613500639999, 58.17865631700005],
              [-134.55638587099992, 58.18065013200004],
              [-134.55125891799992, 58.18178945500006],
              [-134.47435462099992, 58.18203359600005],
              [-134.4446508449999, 58.177394924000055],
              [-134.39073645699995, 58.15534088700008],
              [-134.3613988919999, 58.14789459800005],
              [-134.3316137359999, 58.148138739000046],
              [-134.18639075399994, 58.168402411000045],
              [-134.17699133999992, 58.16351959800005],
              [-134.1670629549999, 58.152044989000046],
              [-134.16075598899994, 58.13849518400008],
              [-134.1621801419999, 58.127386786000045],
              [-134.1699926419999, 58.12343984600005],
              [-134.18081620999993, 58.12372467700004],
              [-134.20376542899993, 58.127386786000045],
              [-134.19054114499994, 58.115668036000045],
              [-134.1758520169999, 58.10687897300005],
              [-134.16934160099993, 58.077785549000055],
              [-134.09024003799993, 58.02606842700004],
              [-134.08641516799992, 57.997707424000055],
              [-134.0293676419999, 57.96385325700004],
              [-134.00230872299994, 57.93935781500005],
              [-133.9795629549999, 57.877834377000056],
              [-133.9522192049999, 57.84479401200008],
              [-133.91856848899994, 57.816839911000045],
              [-133.88841712099992, 57.79840729400007],
              [-133.89273027299993, 57.789496161000045],
              [-133.89500891799992, 57.77948639500005],
              [-133.8955785799999, 57.76898834800005],
              [-133.89464270699995, 57.75804271000004],
              [-133.8914281889999, 57.746527411000045],
              [-133.8828018869999, 57.72996653900003],
              [-133.88097083199995, 57.719916083000044],
              [-133.8791397779999, 57.69318268400008],
              [-133.8726293609999, 57.673814195000034],
              [-133.86001542899993, 57.65802643400008],
              [-133.80394446499992, 57.61001211100006],
              [-133.7892960279999, 57.58885325700004],
              [-133.8028051419999, 57.579291083000044],
              [-133.8261612619999, 57.585923570000034],
              [-133.84215247299994, 57.60211823100008],
              [-133.85631262899994, 57.622381903000075],
              [-133.87417558499993, 57.64142487200007],
              [-133.9629613919999, 57.69232819200005],
              [-133.96621660099993, 57.703558661000045],
              [-133.9807022779999, 57.71539948100008],
              [-133.98403886599993, 57.72646719000005],
              [-133.98546301999994, 57.73810455900008],
              [-133.98912512899994, 57.745794989000046],
              [-133.99376380099994, 57.75332265800006],
              [-133.9982804029999, 57.76430898600006],
              [-134.01060950399994, 57.80658600500004],
              [-134.02379309799994, 57.82050202000005],
              [-134.06883704299992, 57.83161041900007],
              [-134.08804277299993, 57.84589264500005],
              [-134.10407467399995, 57.86375560100004],
              [-134.11436926999994, 57.88031647300005],
              [-134.1310929029999, 57.937201239000046],
              [-134.1416723299999, 57.956732489000046],
              [-134.15933183499993, 57.976548570000034],
              [-134.18211829299992, 57.995428778000075],
              [-134.23106848899994, 58.02496979400007],
              [-134.23106848899994, 58.03119538000004],
              [-134.21129309799994, 58.02684153900003],
              [-134.19082597599993, 58.016058661000045],
              [-134.1553442049999, 57.990220445000034],
              [-134.1726781889999, 58.013739325000074],
              [-134.19961503799993, 58.040716864000046],
              [-134.23009192599994, 58.062933661000045],
              [-134.2580460279999, 58.07217031500005],
              [-134.27208411399994, 58.07318756700005],
              [-134.2812393869999, 58.07636139500005],
              [-134.28819739499994, 58.08185455900008],
              [-134.2956436839999, 58.089829820000034],
              [-134.30675208199995, 58.098089911000045],
              [-134.3101293609999, 58.093410549000055],
              [-134.3079320949999, 58.08454010600008],
              [-134.30239824099993, 58.07957591400003],
              [-134.2891332669999, 58.073879299000055],
              [-134.2764379549999, 58.05963776200008],
              [-134.26724199099993, 58.04181549700007],
              [-134.26455644399994, 58.02496979400007],
              [-134.2908422519999, 58.03595612200007],
              [-134.3041886059999, 58.039129950000074],
              [-134.31920325399994, 58.03864166900007],
              [-134.31920325399994, 58.03119538000004],
              [-134.26162675699993, 58.009019273000035],
              [-134.2381078769999, 57.99282461100006],
              [-134.22423255099994, 57.96971263200004],
              [-134.2439672519999, 57.970038153000075],
              [-134.26353919199994, 57.975897528000075],
              [-134.29938717399995, 57.99396393400008],
              [-134.3166397779999, 57.99664948100008],
              [-134.31224524599992, 57.97943756700005],
              [-134.2925512359999, 57.946193752000056],
              [-134.28892981699994, 57.935532945000034],
              [-134.27407792899993, 57.90615469000005],
              [-134.27204342399995, 57.88784414300005],
              [-134.27782141799992, 57.86994049700007],
              [-134.28628495999993, 57.85211823100008],
              [-134.28917395699995, 57.83665599200003],
              [-134.27822831899994, 57.82575104400007],
              [-134.2517797519999, 57.85691966400003],
              [-134.20872962099992, 57.839911200000074],
              [-134.05699622299994, 57.69586823100008],
              [-134.0471085279999, 57.68333567900004],
              [-134.05284583199995, 57.67291901200008],
              [-134.08023027299993, 57.66193268400008],
              [-134.06554114499994, 57.65029531500005],
              [-134.01113847599993, 57.65379466400003],
              [-133.98741614499994, 57.64476146000004],
              [-133.96849524599992, 57.632798570000034],
              [-133.9514054029999, 57.62787506700005],
              [-133.93785559799994, 57.61855703300006],
              [-133.92943274599992, 57.592962958000044],
              [-133.92943274599992, 57.55548737200007],
              [-133.92617753799993, 57.54441966400003],
              [-133.89932206899994, 57.50649648600006],
              [-133.8542374339999, 57.47601959800005],
              [-133.83999589799993, 57.46263255400004],
              [-133.86070716099994, 57.456366278000075],
              [-133.87218176999994, 57.46694570500006],
              [-133.8804418609999, 57.48216380400004],
              [-133.8915909499999, 57.489935614000046],
              [-133.90094967399995, 57.490668036000045],
              [-133.90684973899994, 57.49176666900007],
              [-133.9128311839999, 57.49201080900008],
              [-133.9225968089999, 57.489935614000046],
              [-133.91808020699995, 57.48590729400007],
              [-133.91812089799993, 57.475775458000044],
              [-133.9229223299999, 57.468451239000046],
              [-133.93248450399994, 57.47284577000005],
              [-133.96422278599994, 57.48216380400004],
              [-134.0398656889999, 57.495306708000044],
              [-134.05601966099994, 57.50014883000006],
              [-134.07282467399995, 57.511053778000075],
              [-134.07632402299993, 57.50836823100008],
              [-134.08641516799992, 57.49746328300006],
              [-134.06696529899995, 57.487982489000046],
              [-134.0566300119999, 57.48452383000006],
              [-134.04548092399995, 57.48309967700004],
              [-134.04548092399995, 57.476263739000046],
              [-134.10069739499994, 57.476263739000046],
              [-134.06627356699994, 57.461371161000045],
              [-134.01235917899993, 57.45848216400003],
              [-133.97704016799992, 57.449204820000034],
              [-133.9982804029999, 57.41547272300005],
              [-133.97960364499994, 57.413275458000044],
              [-133.94127356699994, 57.425034898000035],
              [-133.9195043609999, 57.42853424700007],
              [-133.91445878799993, 57.43109772300005],
              [-133.9037979809999, 57.43512604400007],
              [-133.89321855399993, 57.43500397300005],
              [-133.88841712099992, 57.425116278000075],
              [-133.8865453769999, 57.42259349200003],
              [-133.8787328769999, 57.40534088700008],
              [-133.87755286399994, 57.40119049700007],
              [-133.87051347599993, 57.392645575000074],
              [-133.86449133999992, 57.373928127000056],
              [-133.86497962099992, 57.355129299000055],
              [-133.87755286399994, 57.346584377000056],
              [-133.90172278599994, 57.34332916900007],
              [-133.9155981109999, 57.33478424700007],
              [-133.93932044199994, 57.308661200000074],
              [-133.9580785799999, 57.30369700700004],
              [-133.9824112619999, 57.30849844000005],
              [-134.0523168609999, 57.33978913000004],
              [-134.05992591099994, 57.34674713700008],
              [-134.06314042899993, 57.35366445500006],
              [-134.0679418609999, 57.35683828300006],
              [-134.08023027299993, 57.352769273000035],
              [-134.0789281889999, 57.34662506700005],
              [-134.0750219389999, 57.33539459800005],
              [-134.0771378249999, 57.32607656500005],
              [-134.09390214799993, 57.325506903000075],
              [-134.0995987619999, 57.329413153000075],
              [-134.10289466099994, 57.34467194200005],
              [-134.10753333199995, 57.352769273000035],
              [-134.11953691299993, 57.363267320000034],
              [-134.13683020699995, 57.37531159100007],
              [-134.1565649079999, 57.38471100500004],
              [-134.1758520169999, 57.387600002000056],
              [-134.14224199099993, 57.35016510600008],
              [-134.1318253249999, 57.32721588700008],
              [-134.1491593089999, 57.311835028000075],
              [-134.14232337099992, 57.30451080900008],
              [-134.13487708199995, 57.298163153000075],
              [-134.11729895699995, 57.30621979400007],
              [-134.10142981699994, 57.30023834800005],
              [-134.07282467399995, 57.27765534100007],
              [-134.0847875639999, 57.25641510600008],
              [-134.09947669199994, 57.25608958500004],
              [-134.11449133999992, 57.263373114000046],
              [-134.12743079299992, 57.26463450700004],
              [-134.1350805329999, 57.253973700000074],
              [-134.14712480399993, 57.216864325000074],
              [-134.1553442049999, 57.20197174700007],
              [-134.16738847599993, 57.19155508000006],
              [-134.18203691299993, 57.18341705900008],
              [-134.19884192599994, 57.177720445000034],
              [-134.21739661399994, 57.17462799700007],
              [-134.22647050699993, 57.17641836100006],
              [-134.23599199099993, 57.180568752000056],
              [-134.2455948559999, 57.18256256700005],
              [-134.2549535799999, 57.17804596600007],
              [-134.26146399599992, 57.17300039300005],
              [-134.28571529899995, 57.161037502000056],
              [-134.27009029899995, 57.141913153000075],
              [-134.28477942599994, 57.135931708000044],
              [-134.31017005099994, 57.135646877000056],
              [-134.32664954299992, 57.133693752000056],
              [-134.3235570949999, 57.12982819200005],
              [-134.31920325399994, 57.12006256700005],
              [-134.33145097599993, 57.120794989000046],
              [-134.34093176999994, 57.12335846600007],
              [-134.3613988919999, 57.133693752000056],
              [-134.3645727199999, 57.12299225500004],
              [-134.3699438139999, 57.11505768400008],
              [-134.3777563139999, 57.10956452000005],
              [-134.38809160099993, 57.10639069200005],
              [-134.3806860019999, 57.10101959800005],
              [-134.37230383999992, 57.096909898000035],
              [-134.3633520169999, 57.09406159100007],
              [-134.35399329299992, 57.09271881700005],
            ],
          ],
          [
            [
              [-151.96601314999992, 58.33283112200007],
              [-151.96589107999992, 58.320746161000045],
              [-151.97118079299992, 58.309881903000075],
              [-151.9858292309999, 58.291896877000056],
              [-151.96882076699993, 58.28412506700005],
              [-151.98090572799993, 58.253973700000074],
              [-151.97223873599992, 58.23725006700005],
              [-151.99303137899992, 58.22516510600008],
              [-152.03136145699992, 58.20966217700004],
              [-152.04792232999992, 58.19627513200004],
              [-152.04706783799992, 58.195379950000074],
              [-152.04841061099992, 58.18960195500006],
              [-152.0511368479999, 58.18203359600005],
              [-152.05479895699992, 58.175848700000074],
              [-152.05748450399992, 58.173529364000046],
              [-152.11681067599991, 58.14789459800005],
              [-152.1299942699999, 58.16616445500006],
              [-152.1964005199999, 58.185980536000045],
              [-152.21922766799992, 58.203111070000034],
              [-152.2326554029999, 58.24677155200004],
              [-152.24616451699993, 58.26825592700004],
              [-152.26020260299993, 58.25775788000004],
              [-152.2690323559999, 58.26357656500005],
              [-152.27656002499992, 58.26422760600008],
              [-152.28266354099992, 58.259833075000074],
              [-152.28754635299993, 58.25092194200005],
              [-152.30439205599993, 58.25755442900004],
              [-152.31647701699993, 58.24917226800005],
              [-152.32453365799992, 58.23309967700004],
              [-152.3290909499999, 58.216782945000034],
              [-152.3096817699999, 58.214911200000074],
              [-152.2967423169999, 58.207098700000074],
              [-152.29462643099993, 58.197333075000074],
              [-152.30805416599992, 58.189439195000034],
              [-152.32433020699992, 58.19086334800005],
              [-152.35383053299992, 58.20530833500004],
              [-152.37006588399993, 58.203111070000034],
              [-152.3638809889999, 58.193426825000074],
              [-152.35431881399992, 58.18903229400007],
              [-152.34235592399992, 58.18829987200007],
              [-152.3290909499999, 58.189439195000034],
              [-152.3353165359999, 58.173081773000035],
              [-152.33112545499992, 58.16502513200004],
              [-152.30805416599992, 58.15534088700008],
              [-152.28254146999993, 58.138739325000074],
              [-152.27387447799993, 58.134833075000074],
              [-152.28685462099992, 58.13068268400008],
              [-152.30951900899993, 58.135199286000045],
              [-152.31883704299992, 58.13108958500004],
              [-152.3372696609999, 58.110541083000044],
              [-152.3427628249999, 58.10687897300005],
              [-152.34923255099991, 58.10976797100005],
              [-152.36042232999992, 58.12409088700008],
              [-152.3697403639999, 58.127386786000045],
              [-152.3984268869999, 58.12494538000004],
              [-152.41071529899992, 58.12567780200004],
              [-152.42438717399992, 58.13108958500004],
              [-152.4550675119999, 58.13735586100006],
              [-152.4893692699999, 58.12836334800005],
              [-152.52216549399992, 58.10960521000004],
              [-152.5482071609999, 58.08641185100004],
              [-152.55817623599992, 58.10028717700004],
              [-152.56224524599992, 58.11196523600006],
              [-152.56293697799993, 58.17877838700008],
              [-152.5609024729999, 58.19623444200005],
              [-152.5550430979999, 58.20994700700004],
              [-152.57664954299992, 58.206691799000055],
              [-152.5882462229999, 58.197333075000074],
              [-152.59349524599992, 58.18231842700004],
              [-152.5986221999999, 58.14484284100007],
              [-152.60313880099991, 58.13263580900008],
              [-152.61188717399992, 58.12051015800006],
              [-152.62706458199992, 58.10346100500004],
              [-152.63239498599992, 58.09471263200004],
              [-152.63361568899992, 58.08746979400007],
              [-152.63593502499992, 58.08030833500004],
              [-152.6443985669999, 58.07217031500005],
              [-152.6536759109999, 58.069525458000044],
              [-152.6795548169999, 58.06679922100005],
              [-152.70807857999992, 58.052069403000075],
              [-152.73326575399992, 58.05337148600006],
              [-152.7558487619999, 58.063381252000056],
              [-152.76732337099992, 58.07957591400003],
              [-152.77501380099991, 58.06329987200007],
              [-152.76581783799992, 58.02285390800006],
              [-152.77753658799992, 58.00079987200007],
              [-152.8049210279999, 57.991522528000075],
              [-152.92682857999992, 58.014878648000035],
              [-153.01435299399992, 58.04547760600008],
              [-153.03681393099993, 58.05898672100005],
              [-153.05829830599993, 58.07859935100004],
              [-153.06635494699992, 58.09711334800005],
              [-153.04845130099991, 58.10687897300005],
              [-153.0811661449999, 58.111029364000046],
              [-153.1268204419999, 58.10846588700008],
              [-153.1674698559999, 58.11115143400008],
              [-153.1850479809999, 58.13108958500004],
              [-153.2296036449999, 58.16889069200005],
              [-153.22956295499992, 58.18256256700005],
              [-153.1884659499999, 58.21987539300005],
              [-153.16181393099993, 58.21954987200007],
              [-153.02802486899992, 58.19627513200004],
              [-153.02350826699993, 58.19204336100006],
              [-153.01423092399992, 58.17865631700005],
              [-153.01060950399992, 58.175848700000074],
              [-153.00239010299993, 58.17804596600007],
              [-153.00043697799993, 58.182847398000035],
              [-152.99921627499992, 58.18764883000006],
              [-152.99323482999992, 58.189439195000034],
              [-152.97175045499992, 58.18512604400007],
              [-152.92865963399993, 58.17023346600007],
              [-152.90510006399992, 58.168402411000045],
              [-152.90510006399992, 58.175848700000074],
              [-153.00690670499992, 58.21336497600004],
              [-153.01292883999992, 58.22215403900003],
              [-153.02704830599993, 58.229803778000075],
              [-153.04308020699992, 58.235256252000056],
              [-153.0710343089999, 58.24013906500005],
              [-153.0850723949999, 58.24787018400008],
              [-153.10993404899992, 58.27138906500005],
              [-153.05915279899992, 58.298814195000034],
              [-153.04169674399992, 58.305568752000056],
              [-153.01947994699992, 58.30727773600006],
              [-152.98957271999993, 58.30451080900008],
              [-152.96088619699992, 58.298041083000044],
              [-152.9420059889999, 58.28851959800005],
              [-152.9023331369999, 58.27985260600008],
              [-152.84654700399992, 58.28790924700007],
              [-152.8030085929999, 58.28851959800005],
              [-152.79535885299993, 58.28725820500006],
              [-152.79328365799992, 58.286810614000046],
              [-152.76732337099992, 58.25775788000004],
              [-152.7518204419999, 58.272650458000044],
              [-152.75352942599991, 58.28538646000004],
              [-152.76215572799993, 58.29897695500006],
              [-152.76732337099992, 58.316107489000046],
              [-152.76911373599992, 58.332017320000034],
              [-152.77485104099992, 58.33706289300005],
              [-152.7853897779999, 58.341131903000075],
              [-152.80146236899992, 58.353949286000045],
              [-152.79047604099992, 58.35309479400007],
              [-152.77977454299992, 58.35346100500004],
              [-152.7697647779999, 58.35565827000005],
              [-152.7604874339999, 58.36017487200007],
              [-152.78510494699992, 58.37083567900004],
              [-152.86738033799992, 58.39435455900008],
              [-152.88337154899992, 58.40859609600005],
              [-152.86188717399992, 58.414129950000074],
              [-152.8173721999999, 58.41315338700008],
              [-152.77350826699993, 58.41771067900004],
              [-152.75365149599992, 58.43964264500005],
              [-152.74767005099991, 58.45156484600005],
              [-152.7342423169999, 58.45404694200005],
              [-152.72028561099992, 58.45184967700004],
              [-152.71271725199992, 58.44953034100007],
              [-152.7018936839999, 58.44204336100006],
              [-152.6974991529999, 58.43455638200004],
              [-152.69298255099991, 58.43211497600004],
              [-152.6816300119999, 58.43964264500005],
              [-152.67414303299992, 58.450832424000055],
              [-152.67060299399992, 58.46352773600006],
              [-152.6647843089999, 58.47528717700004],
              [-152.6506241529999, 58.483628648000035],
              [-152.63292395699992, 58.48460521000004],
              [-152.6174210279999, 58.47874583500004],
              [-152.6068009109999, 58.468451239000046],
              [-152.60346432199992, 58.456366278000075],
              [-152.58165442599991, 58.46662018400008],
              [-152.55549068899992, 58.467962958000044],
              [-152.49982662699992, 58.46320221600007],
              [-152.50617428299992, 58.44940827000005],
              [-152.52143307199992, 58.42853424700007],
              [-152.52708899599992, 58.41478099200003],
              [-152.49376380099991, 58.414048570000034],
              [-152.4788712229999, 58.41010163000004],
              [-152.46564693899992, 58.40110911700003],
              [-152.48131262899992, 58.38898346600007],
              [-152.48468990799992, 58.37343984600005],
              [-152.47687740799992, 58.36147695500006],
              [-152.4588516919999, 58.36017487200007],
              [-152.4490860669999, 58.36603424700007],
              [-152.44456946499992, 58.372748114000046],
              [-152.43866939999992, 58.37669505400004],
              [-152.42467200399992, 58.37376536700003],
              [-152.41490637899992, 58.36961497600004],
              [-152.40558834499993, 58.36322663000004],
              [-152.40160071499992, 58.35443756700005],
              [-152.41966712099992, 58.32294342700004],
              [-152.39854895699992, 58.32904694200005],
              [-152.37511145699992, 58.344956773000035],
              [-152.3799942699999, 58.353949286000045],
              [-152.37348385299993, 58.36163971600007],
              [-152.36375891799992, 58.37938060100004],
              [-152.35789954299992, 58.399603583000044],
              [-152.3632706369999, 58.41478099200003],
              [-152.34935462099992, 58.421128648000035],
              [-152.32343502499992, 58.41421133000006],
              [-152.31175696499992, 58.41852448100008],
              [-152.2988175119999, 58.42633698100008],
              [-152.28644771999993, 58.425767320000034],
              [-152.26020260299993, 58.41478099200003],
              [-152.26325436099992, 58.41087474200003],
              [-152.26451575399992, 58.40778229400007],
              [-152.26537024599992, 58.404730536000045],
              [-152.26703854099992, 58.40110911700003],
              [-152.24592037699992, 58.394964911000045],
              [-152.26056881399992, 58.38898346600007],
              [-152.26703854099992, 58.38812897300005],
              [-152.25678463399993, 58.37201569200005],
              [-152.23607337099992, 58.36005280200004],
              [-152.2119034499999, 58.353501695000034],
              [-152.1912735669999, 58.353949286000045],
              [-152.15168209499993, 58.385931708000044],
              [-152.14073645699992, 58.39203522300005],
              [-152.11681067599991, 58.40110911700003],
              [-152.1076554029999, 58.38959381700005],
              [-152.09186764199993, 58.38068268400008],
              [-152.08320064999992, 58.37352122600004],
              [-152.0950821609999, 58.367621161000045],
              [-152.1360977859999, 58.30296458500004],
              [-152.1541641919999, 58.26154205900008],
              [-152.1435440749999, 58.23383209800005],
              [-152.1319473949999, 58.237982489000046],
              [-152.12092037699992, 58.25543854400007],
              [-152.1126602859999, 58.27749258000006],
              [-152.1093643869999, 58.29531484600005],
              [-152.09992428299992, 58.31191640800006],
              [-152.08075924399992, 58.31655508000006],
              [-152.06562252499992, 58.306341864000046],
              [-152.06843014199993, 58.27826569200005],
              [-152.05162512899992, 58.289129950000074],
              [-152.03132076699993, 58.306708075000074],
              [-152.01414954299992, 58.32636139500005],
              [-152.0069473949999, 58.343085028000075],
              [-152.00080318899992, 58.35187409100007],
              [-151.9870499339999, 58.34837474200003],
              [-151.9730118479999, 58.33974844000005],
              [-151.96601314999992, 58.33283112200007],
            ],
          ],
          [
            [
              [-152.6443985669999, 58.518459377000056],
              [-152.63914954299992, 58.528957424000055],
              [-152.64301510299993, 58.53729889500005],
              [-152.65245520699992, 58.54328034100007],
              [-152.6642960279999, 58.54637278900003],
              [-152.59186764199993, 58.55524323100008],
              [-152.58173580599993, 58.562486070000034],
              [-152.5726212229999, 58.58022695500006],
              [-152.55121822799993, 58.59052155200004],
              [-152.50727291599992, 58.60032786700003],
              [-152.49665279899992, 58.60496653900003],
              [-152.4725235669999, 58.62083567900004],
              [-152.45368404899992, 58.628159898000035],
              [-152.43464107999992, 58.62832265800006],
              [-152.41108150899993, 58.63153717700004],
              [-152.38984127499992, 58.63694896000004],
              [-152.36957760299993, 58.63808828300006],
              [-152.3489884109999, 58.62832265800006],
              [-152.35081946499992, 58.620428778000075],
              [-152.3502091139999, 58.61318594000005],
              [-152.34748287699992, 58.60651276200008],
              [-152.3427628249999, 58.60032786700003],
              [-152.37035071499992, 58.57526276200008],
              [-152.3748673169999, 58.563788153000075],
              [-152.3632706369999, 58.551947333000044],
              [-152.4560440749999, 58.50287506700005],
              [-152.4830216139999, 58.480536200000074],
              [-152.50202389199993, 58.47345612200007],
              [-152.52643795499992, 58.476548570000034],
              [-152.63060462099992, 58.507879950000074],
              [-152.6443985669999, 58.518459377000056],
            ],
          ],
          [
            [
              [-160.94764331599993, 58.73764846600005],
              [-160.9095365519999, 58.74558271400008],
              [-160.85824336899992, 58.747364926000046],
              [-160.83385750399992, 58.75626412300005],
              [-160.80939987699992, 58.76518768200003],
              [-160.78757661699993, 58.77350958400007],
              [-160.7670078589999, 58.77571718400009],
              [-160.73915142099992, 58.79788516500008],
              [-160.71224973199992, 58.804015864000064],
              [-160.7041063549999, 58.81334860700008],
              [-160.68778644499992, 58.818723910000074],
              [-160.6859239579999, 58.810838610000076],
              [-160.69952273299992, 58.79278902300007],
              [-160.72106395499992, 58.76711138300004],
              [-160.77263, 58.71629238600008],
              [-160.80090345199991, 58.679913886000065],
              [-160.8242115749999, 58.65463465600004],
              [-160.84509151499992, 58.63406230800007],
              [-160.86057095599992, 58.61470738300005],
              [-160.86846796799992, 58.59208244800004],
              [-160.89785828499993, 58.570343310000055],
              [-160.93605906399992, 58.55900603400005],
              [-160.9662531639999, 58.549508364000076],
              [-161.01893756299992, 58.55891607500007],
              [-161.0405479069999, 58.55806141000005],
              [-161.0535624949999, 58.550874314000055],
              [-161.07412550799992, 58.546923941000045],
              [-161.0859789399999, 58.553326076000076],
              [-161.07654728699993, 58.57217638700007],
              [-161.08041619899993, 58.580436518000056],
              [-161.0900672749999, 58.58985065100006],
              [-161.0754244679999, 58.60074776100004],
              [-161.0778184049999, 58.61101574700007],
              [-161.0794860249999, 58.629784047000044],
              [-161.11017818899992, 58.651271877000056],
              [-161.1403112749999, 58.668943513000045],
              [-161.17190298699992, 58.69075370300004],
              [-161.1620948149999, 58.690534864000085],
              [-161.07802970499992, 58.639274569000065],
              [-161.0637102649999, 58.676726219000045],
              [-161.0616757059999, 58.700505074000034],
              [-161.0438444049999, 58.70213370400006],
              [-161.0052095609999, 58.71688732200005],
              [-160.9730873739999, 58.73178674600007],
              [-160.94764331599993, 58.73764846600005],
            ],
          ],
          [
            [
              [-152.24970455599993, 58.92251211100006],
              [-152.3342179029999, 58.91193268400008],
              [-152.3632706369999, 58.915716864000046],
              [-152.3632706369999, 58.92251211100006],
              [-152.34015865799992, 58.92479075700004],
              [-152.32721920499992, 58.93504466400003],
              [-152.32380123599992, 58.95111725500004],
              [-152.3290909499999, 58.97089264500005],
              [-152.30907141799992, 58.970404364000046],
              [-152.27338619699992, 58.959418036000045],
              [-152.25312252499992, 58.956691799000055],
              [-152.15778561099992, 58.956691799000055],
              [-152.15794837099992, 58.952337958000044],
              [-152.1592911449999, 58.949286200000074],
              [-152.16401119699992, 58.943019924000055],
              [-152.17695064999992, 58.939113674000055],
              [-152.2005509109999, 58.94310130400004],
              [-152.2123917309999, 58.943019924000055],
              [-152.22162838399993, 58.93854401200008],
              [-152.23981686099992, 58.92527903900003],
              [-152.24970455599993, 58.92251211100006],
            ],
          ],
          [
            [
              [-150.70417232999992, 59.39545319200005],
              [-150.6819962229999, 59.405178127000056],
              [-150.6537979809999, 59.40721263200004],
              [-150.62690182199992, 59.39984772300005],
              [-150.60859127499992, 59.38117096600007],
              [-150.65510006399992, 59.33299388200004],
              [-150.67747962099992, 59.31976959800005],
              [-150.6999405589999, 59.31391022300005],
              [-150.73163814999992, 59.31150950700004],
              [-150.76183020699992, 59.31679922100005],
              [-150.77985592399992, 59.334051825000074],
              [-150.74620520699992, 59.357855536000045],
              [-150.72358150899993, 59.36603424700007],
              [-150.71495520699992, 59.37685781500005],
              [-150.70417232999992, 59.39545319200005],
            ],
          ],
          [
            [
              [-153.5245255199999, 59.33026764500005],
              [-153.53510494699992, 59.337225653000075],
              [-153.54511471299992, 59.33893463700008],
              [-153.55268307199992, 59.343085028000075],
              [-153.55561275899993, 59.35761139500005],
              [-153.5501602859999, 59.366888739000046],
              [-153.53815670499992, 59.37710195500006],
              [-153.52533932199992, 59.38523997600004],
              [-153.51777096299992, 59.38861725500004],
              [-153.50446529899992, 59.39175039300005],
              [-153.47675533799992, 59.40542226800005],
              [-153.46344967399992, 59.40851471600007],
              [-153.3979386059999, 59.40851471600007],
              [-153.3574112619999, 59.378119208000044],
              [-153.3546036449999, 59.36517975500004],
              [-153.3768204419999, 59.347723700000074],
              [-153.40587317599991, 59.33856842700004],
              [-153.49889075399992, 59.325425523000035],
              [-153.5245255199999, 59.33026764500005],
            ],
          ],
          [
            [
              [-150.33482825399992, 59.45697663000004],
              [-150.3065079419999, 59.46426015800006],
              [-150.29462643099993, 59.46458567900004],
              [-150.29389400899993, 59.45697663000004],
              [-150.30219479099992, 59.44916413000004],
              [-150.3037003249999, 59.43048737200007],
              [-150.31440182199992, 59.42218659100007],
              [-150.3212784499999, 59.42234935100004],
              [-150.3253067699999, 59.42747630400004],
              [-150.32819576699993, 59.43353913000004],
              [-150.3314102859999, 59.436428127000056],
              [-150.33832760299993, 59.435248114000046],
              [-150.3491104809999, 59.43024323100008],
              [-150.3553360669999, 59.42963288000004],
              [-150.37909908799992, 59.43138255400004],
              [-150.38556881399992, 59.42865631700005],
              [-150.39692135299993, 59.42218659100007],
              [-150.41535396999993, 59.407131252000056],
              [-150.42699133999992, 59.401678778000075],
              [-150.44347083199992, 59.40228913000004],
              [-150.4236954419999, 59.435980536000045],
              [-150.4105118479999, 59.44627513200004],
              [-150.33482825399992, 59.45697663000004],
            ],
          ],
          [
            [
              [-144.3417862619999, 59.98452383000006],
              [-144.3080948559999, 59.98875560100004],
              [-144.2457576159999, 60.00755442900004],
              [-144.20860755099991, 60.011786200000074],
              [-144.2132869129999, 60.00226471600007],
              [-144.22081458199992, 59.995794989000046],
              [-144.23062089799993, 59.99237702000005],
              [-144.2421768869999, 59.99135976800005],
              [-144.37710527299993, 59.93235911700003],
              [-144.40371660099993, 59.92719147300005],
              [-144.41218014199993, 59.920355536000045],
              [-144.4189346999999, 59.91152578300006],
              [-144.4277237619999, 59.90253327000005],
              [-144.55459550699993, 59.82709381700005],
              [-144.5788468089999, 59.81777578300006],
              [-144.60529537699992, 59.81317780200004],
              [-144.55235755099991, 59.87323639500005],
              [-144.53384355399993, 59.882066148000035],
              [-144.50934811099992, 59.88898346600007],
              [-144.4420059889999, 59.93732330900008],
              [-144.3929744129999, 59.95661041900007],
              [-144.3417862619999, 59.98452383000006],
            ],
          ],
          [
            [
              [-148.0050349599999, 60.046576239000046],
              [-147.9930720689999, 60.044582424000055],
              [-147.9904679029999, 60.039496161000045],
              [-147.9950251939999, 60.03266022300005],
              [-148.0811661449999, 59.97166575700004],
              [-148.11290442599991, 59.96084219000005],
              [-148.14216061099992, 59.94672272300005],
              [-148.15595455599993, 59.94354889500005],
              [-148.24498450399992, 59.94354889500005],
              [-148.2291153639999, 59.94936758000006],
              [-148.19623775899993, 59.95335521000004],
              [-148.18232174399992, 59.964056708000044],
              [-148.18915768099993, 59.96344635600008],
              [-148.20331783799992, 59.96434153900003],
              [-148.21019446499992, 59.964056708000044],
              [-148.20551510299993, 59.96946849200003],
              [-148.2033585279999, 59.97284577000005],
              [-148.1995743479999, 59.97524648600006],
              [-148.18976803299992, 59.97768789300005],
              [-148.18976803299992, 59.98452383000006],
              [-148.1979874339999, 59.98395416900007],
              [-148.21495520699992, 59.98505280200004],
              [-148.2232559889999, 59.98452383000006],
              [-148.2232559889999, 59.99135976800005],
              [-148.2029923169999, 59.99555084800005],
              [-148.18683834499993, 59.99315013200004],
              [-148.1728409499999, 59.985663153000075],
              [-148.15937252499992, 59.974269924000055],
              [-148.14484615799992, 59.97239817900004],
              [-148.1060684889999, 59.99209219000005],
              [-148.07819576699993, 60.00104401200008],
              [-148.03209387899992, 60.025458075000074],
              [-148.02607174399992, 60.03082916900007],
              [-148.02009029899992, 60.03778717700004],
              [-148.01341712099992, 60.04393138200004],
              [-148.0050349599999, 60.046576239000046],
            ],
          ],
          [
            [
              [-147.82664954299992, 60.052801825000074],
              [-147.8432511059999, 60.030462958000044],
              [-147.86750240799992, 60.00885651200008],
              [-147.89517167899993, 59.99042389500005],
              [-147.9385880199999, 59.971909898000035],
              [-147.98176021999993, 59.959051825000074],
              [-148.03571529899992, 59.95258209800005],
              [-148.0463761059999, 59.957098700000074],
              [-148.0355118479999, 59.974269924000055],
              [-148.00751705599993, 59.99624258000006],
              [-147.9472550119999, 60.02903880400004],
              [-147.8917537099999, 60.06903717700004],
              [-147.87657630099991, 60.07636139500005],
              [-147.86139889199993, 60.08075592700004],
              [-147.8465876939999, 60.081244208000044],
              [-147.82970130099991, 60.07786692900004],
              [-147.8199763659999, 60.06891510600008],
              [-147.82664954299992, 60.052801825000074],
            ],
          ],
          [
            [
              [-147.9637751939999, 60.073919989000046],
              [-148.01915442599991, 60.074652411000045],
              [-148.0444229809999, 60.070298570000034],
              [-148.05939693899992, 60.052801825000074],
              [-148.05085201699993, 60.05426666900007],
              [-148.03209387899992, 60.052801825000074],
              [-148.09333248599992, 60.01776764500005],
              [-148.1248673169999, 60.00413646000004],
              [-148.14130611899992, 60.011786200000074],
              [-148.13312740799992, 60.03107330900008],
              [-148.10956783799992, 60.056301174000055],
              [-148.08055579299992, 60.078192450000074],
              [-148.04539954299992, 60.091782945000034],
              [-148.01825924399992, 60.110581773000035],
              [-148.0013321609999, 60.11481354400007],
              [-147.99860592399992, 60.121161200000074],
              [-147.97565670499992, 60.14789459800005],
              [-147.97004146999993, 60.15273672100005],
              [-147.9664607409999, 60.15656159100007],
              [-147.9592179029999, 60.144964911000045],
              [-147.9531143869999, 60.12946198100008],
              [-147.95323645699992, 60.12164948100008],
              [-147.9147843089999, 60.12547435100004],
              [-147.8990372389999, 60.121975002000056],
              [-147.8812556629999, 60.10736725500004],
              [-147.8964737619999, 60.09560781500005],
              [-147.9183650379999, 60.086004950000074],
              [-147.9637751939999, 60.073919989000046],
            ],
          ],
          [
            [
              [-148.15937252499992, 60.04315827000005],
              [-148.16881262899992, 60.03774648600006],
              [-148.25861568899992, 60.023138739000046],
              [-148.28600012899992, 60.02399323100008],
              [-148.3138321609999, 60.03229401200008],
              [-148.2873429029999, 60.042669989000046],
              [-148.21996008999992, 60.03978099200003],
              [-148.18976803299992, 60.046576239000046],
              [-148.2132462229999, 60.05426666900007],
              [-148.29963131399992, 60.052801825000074],
              [-148.29963131399992, 60.060248114000046],
              [-148.27118893099993, 60.06720612200007],
              [-148.2158096999999, 60.07367584800005],
              [-148.18976803299992, 60.087551174000055],
              [-148.26301021999993, 60.08869049700007],
              [-148.28595943899992, 60.09438711100006],
              [-148.27122962099992, 60.10297272300005],
              [-148.14081783799992, 60.14789459800005],
              [-148.11872311099992, 60.15029531500005],
              [-148.1140030589999, 60.12909577000005],
              [-148.10151119699992, 60.13568756700005],
              [-148.08808346299992, 60.14671458500004],
              [-148.07746334499993, 60.15997955900008],
              [-148.0693253249999, 60.18695709800005],
              [-148.06061764199993, 60.19513580900008],
              [-148.04999752499992, 60.19570547100005],
              [-148.04096432199992, 60.18659088700008],
              [-148.05170650899993, 60.16893138200004],
              [-148.08124752499992, 60.13499583500004],
              [-148.08735104099992, 60.11823151200008],
              [-148.09040279899992, 60.10024648600006],
              [-148.09923255099991, 60.08348216400003],
              [-148.11322994699992, 60.07123444200005],
              [-148.13170325399992, 60.066473700000074],
              [-148.1373184889999, 60.06354401200008],
              [-148.15937252499992, 60.04315827000005],
            ],
          ],
          [
            [
              [-147.10724850199992, 60.28620026200008],
              [-147.0807999339999, 60.28034088700008],
              [-146.9222712879999, 60.31346263200004],
              [-146.9222712879999, 60.306626695000034],
              [-146.9287003249999, 60.30483633000006],
              [-146.93301347599993, 60.30141836100006],
              [-146.9370011059999, 60.29718659100007],
              [-146.9421280589999, 60.292954820000034],
              [-146.9705704419999, 60.25918203300006],
              [-147.0104874339999, 60.233710028000075],
              [-147.23379472599993, 60.13312409100007],
              [-147.32819576699993, 60.07025788000004],
              [-147.3710831369999, 60.02887604400007],
              [-147.3766169909999, 60.01552969000005],
              [-147.3694962229999, 60.00678131700005],
              [-147.35879472599993, 59.999660549000055],
              [-147.35366777299993, 59.99135976800005],
              [-147.36701412699992, 59.97284577000005],
              [-147.4272354809999, 59.976629950000074],
              [-147.4529923169999, 59.96747467700004],
              [-147.4835505849999, 59.946966864000046],
              [-147.4874161449999, 59.94354889500005],
              [-147.49030514199993, 59.93919505400004],
              [-147.47866777299993, 59.929754950000074],
              [-147.45612545499992, 59.91559479400007],
              [-147.45360266799992, 59.89590078300006],
              [-147.4682511059999, 59.87677643400008],
              [-147.49233964799993, 59.86180247600004],
              [-147.51878821499992, 59.85419342700004],
              [-147.60114498599992, 59.86676666900007],
              [-147.6437068349999, 59.862616278000075],
              [-147.66877193899992, 59.81928131700005],
              [-147.68423417899993, 59.81708405200004],
              [-147.7167862619999, 59.820013739000046],
              [-147.80060787699992, 59.80329010600008],
              [-147.8402400379999, 59.78652578300006],
              [-147.86143958199992, 59.782456773000035],
              [-147.8787735669999, 59.78314850500004],
              [-147.9153946609999, 59.792669989000046],
              [-147.9153946609999, 59.79954661700003],
              [-147.8987930979999, 59.810207424000055],
              [-147.8944392569999, 59.83380768400008],
              [-147.88613847599993, 59.85761139500005],
              [-147.8576554029999, 59.868475653000075],
              [-147.82542883999992, 59.870794989000046],
              [-147.79377193899992, 59.87775299700007],
              [-147.7639054029999, 59.88849518400008],
              [-147.7372126939999, 59.90253327000005],
              [-147.7601212229999, 59.90766022300005],
              [-147.7906794909999, 59.91095612200007],
              [-147.8049210279999, 59.920355536000045],
              [-147.7787979809999, 59.94354889500005],
              [-147.75243079299992, 59.95384349200003],
              [-147.6957087879999, 59.962144273000035],
              [-147.6689346999999, 59.97089264500005],
              [-147.67430579299992, 59.98029205900008],
              [-147.6825251939999, 59.98704661700003],
              [-147.7031143869999, 59.99750397300005],
              [-147.68097896999993, 60.00873444200005],
              [-147.5331111319999, 60.058579820000034],
              [-147.51504472599993, 60.07013580900008],
              [-147.42463131399992, 60.11123281500005],
              [-147.38019771999993, 60.13959381700005],
              [-147.3878067699999, 60.16266510600008],
              [-147.37409420499992, 60.17055898600006],
              [-147.3421524729999, 60.179754950000074],
              [-147.3297419909999, 60.187201239000046],
              [-147.3038223949999, 60.22687409100007],
              [-147.2956436839999, 60.23216380400004],
              [-147.2858780589999, 60.23102448100008],
              [-147.2655330069999, 60.225897528000075],
              [-147.25470943899992, 60.224676825000074],
              [-147.2466934889999, 60.22687409100007],
              [-147.22883053299992, 60.23623281500005],
              [-147.2011612619999, 60.242173570000034],
              [-147.19701087099992, 60.251206773000035],
              [-147.20287024599992, 60.26911041900007],
              [-147.2038468089999, 60.274644273000035],
              [-147.2060440749999, 60.28156159100007],
              [-147.2083634109999, 60.28656647300005],
              [-147.20962480399993, 60.28620026200008],
              [-147.20759029899992, 60.294989325000074],
              [-147.2042537099999, 60.29791901200008],
              [-147.20026607999992, 60.300116278000075],
              [-147.1960343089999, 60.306626695000034],
              [-147.1917618479999, 60.310248114000046],
              [-147.1846817699999, 60.31354401200008],
              [-147.17804928299992, 60.31858958500004],
              [-147.17552649599992, 60.32709381700005],
              [-147.1799210279999, 60.332017320000034],
              [-147.19847571499992, 60.33893463700008],
              [-147.20287024599992, 60.34137604400007],
              [-147.18960527299993, 60.362209377000056],
              [-147.15514075399992, 60.37645091400003],
              [-147.11554928299992, 60.38165924700007],
              [-147.08678137899992, 60.37555573100008],
              [-147.10651607999992, 60.36391836100006],
              [-147.1141658189999, 60.356675523000035],
              [-147.1202693349999, 60.34760163000004],
              [-147.01105709499993, 60.34760163000004],
              [-147.0265193349999, 60.33075592700004],
              [-147.10724850199992, 60.28620026200008],
            ],
          ],
          [
            [
              [-147.9774470689999, 60.37555573100008],
              [-147.98306230399993, 60.366441148000035],
              [-148.00475012899992, 60.34446849200003],
              [-148.0062149729999, 60.335638739000046],
              [-148.01410885299993, 60.30833567900004],
              [-148.01842200399992, 60.29979075700004],
              [-148.04222571499992, 60.28656647300005],
              [-148.07331295499992, 60.285142320000034],
              [-148.10444088399993, 60.29287344000005],
              [-148.1282852859999, 60.306626695000034],
              [-148.1351212229999, 60.29979075700004],
              [-148.12706458199992, 60.33494700700004],
              [-148.07563229099992, 60.36937083500004],
              [-148.0143936839999, 60.387925523000035],
              [-147.9774470689999, 60.37555573100008],
            ],
          ],
          [
            [
              [-145.1744278639999, 60.38239166900007],
              [-145.11978105399993, 60.409816799000055],
              [-145.0950821609999, 60.41632721600007],
              [-145.0925186839999, 60.40216705900008],
              [-145.09923255099991, 60.38886139500005],
              [-145.11412512899992, 60.36994049700007],
              [-145.11978105399993, 60.35504791900007],
              [-145.11969967399992, 60.32440827000005],
              [-145.1232804029999, 60.311753648000035],
              [-145.1365860669999, 60.306626695000034],
              [-145.14590410099993, 60.30890534100007],
              [-145.1631973949999, 60.31867096600007],
              [-145.18195553299992, 60.31976959800005],
              [-145.2022598949999, 60.31464264500005],
              [-145.21198482999992, 60.31346263200004],
              [-145.23346920499992, 60.31732819200005],
              [-145.26187089799993, 60.33266836100006],
              [-145.2842911449999, 60.33392975500004],
              [-145.2842911449999, 60.34137604400007],
              [-145.1744278639999, 60.38239166900007],
            ],
          ],
          [
            [
              [-146.1886287099999, 60.40216705900008],
              [-146.0936580069999, 60.41034577000005],
              [-146.07876542899993, 60.40216705900008],
              [-146.08568274599992, 60.40265534100007],
              [-146.09064693899992, 60.40062083500004],
              [-146.0948787099999, 60.39789459800005],
              [-146.0998429029999, 60.39598216400003],
              [-146.18321692599991, 60.38422272300005],
              [-146.1886287099999, 60.38239166900007],
              [-146.19269771999993, 60.37734609600005],
              [-146.1939591139999, 60.370754299000055],
              [-146.19420325399992, 60.36465078300006],
              [-146.19546464799993, 60.36127350500004],
              [-146.2239884109999, 60.35138580900008],
              [-146.2516169909999, 60.35028717700004],
              [-146.3050430979999, 60.35504791900007],
              [-146.33360755099991, 60.35224030200004],
              [-146.4932755199999, 60.30377838700008],
              [-146.55394446499992, 60.26121653900003],
              [-146.5785212879999, 60.24990469000005],
              [-146.60016842399992, 60.24518463700008],
              [-146.62124589799993, 60.24868398600006],
              [-146.64858964799993, 60.257879950000074],
              [-146.67218990799992, 60.27094147300005],
              [-146.6820369129999, 60.28620026200008],
              [-146.6556290359999, 60.30678945500006],
              [-146.49030514199993, 60.36127350500004],
              [-146.5047908189999, 60.370428778000075],
              [-146.56769771999993, 60.36322663000004],
              [-146.59333248599992, 60.36810944200005],
              [-146.5790095689999, 60.37555573100008],
              [-146.5991104809999, 60.37547435100004],
              [-146.6159561839999, 60.371079820000034],
              [-146.6479386059999, 60.35504791900007],
              [-146.61384029899992, 60.35504791900007],
              [-146.65558834499993, 60.34064362200007],
              [-146.7005509109999, 60.354803778000075],
              [-146.7226456369999, 60.38621653900003],
              [-146.6957087879999, 60.42332591400003],
              [-146.66030839799993, 60.43016185100004],
              [-146.65477454299992, 60.43390534100007],
              [-146.65208899599992, 60.44220612200007],
              [-146.6458634109999, 60.45164622600004],
              [-146.63434811099992, 60.464911200000074],
              [-146.6126602859999, 60.47809479400007],
              [-146.5881241529999, 60.484035549000055],
              [-146.5306290359999, 60.48541901200008],
              [-146.5306290359999, 60.47797272300005],
              [-146.5361221999999, 60.47483958500004],
              [-146.53917395699992, 60.47182851800005],
              [-146.54157467399992, 60.46857330900008],
              [-146.5449112619999, 60.464911200000074],
              [-146.44562740799992, 60.464911200000074],
              [-146.42324785099993, 60.46792226800005],
              [-146.4017227859999, 60.47333405200004],
              [-146.37901770699992, 60.47606028900003],
              [-146.35309811099992, 60.471136786000045],
              [-146.3620499339999, 60.45380280200004],
              [-146.36164303299992, 60.426214911000045],
              [-146.36676998599992, 60.40965403900003],
              [-146.32355709499993, 60.41071198100008],
              [-146.23839270699992, 60.431626695000034],
              [-146.1513565749999, 60.438788153000075],
              [-146.1296280589999, 60.43622467700004],
              [-146.12035071499992, 60.427069403000075],
              [-146.12975012899992, 60.42283763200004],
              [-146.1742244129999, 60.409491278000075],
              [-146.1886287099999, 60.40216705900008],
            ],
          ],
          [
            [
              [-147.7713923819999, 60.40965403900003],
              [-147.7858780589999, 60.41054922100005],
              [-147.8211970689999, 60.39948151200008],
              [-147.8402400379999, 60.39598216400003],
              [-147.8124893869999, 60.44623444200005],
              [-147.79279537699992, 60.47174713700008],
              [-147.7713923819999, 60.48541901200008],
              [-147.77253170499992, 60.45392487200007],
              [-147.77668209499993, 60.44171784100007],
              [-147.78571529899992, 60.43081289300005],
              [-147.7299698559999, 60.441392320000034],
              [-147.7101130849999, 60.45258209800005],
              [-147.72052975199992, 60.47455475500004],
              [-147.7237849599999, 60.49290599200003],
              [-147.7081599599999, 60.50678131700005],
              [-147.68927975199992, 60.50372955900008],
              [-147.6826065749999, 60.471136786000045],
              [-147.6584366529999, 60.47996653900003],
              [-147.6452530589999, 60.48309967700004],
              [-147.63451087099992, 60.481675523000035],
              [-147.6271866529999, 60.47443268400008],
              [-147.6285701159999, 60.46698639500005],
              [-147.6347550119999, 60.46088288000004],
              [-147.64167232999992, 60.457464911000045],
              [-147.64167232999992, 60.45062897300005],
              [-147.6337784499999, 60.44863515800006],
              [-147.6143692699999, 60.43695709800005],
              [-147.62905839799993, 60.42617422100005],
              [-147.63418535099993, 60.42332591400003],
              [-147.66242428299992, 60.421210028000075],
              [-147.7109268869999, 60.40180084800005],
              [-147.7372126939999, 60.39598216400003],
              [-147.7154434889999, 60.38328685100004],
              [-147.69351152299993, 60.38471100500004],
              [-147.6712540359999, 60.391791083000044],
              [-147.64850826699993, 60.39598216400003],
              [-147.6253555979999, 60.38959381700005],
              [-147.63101152299993, 60.37482330900008],
              [-147.66218014199993, 60.34760163000004],
              [-147.69473222599993, 60.302801825000074],
              [-147.73875891799992, 60.259833075000074],
              [-147.73875891799992, 60.249986070000034],
              [-147.71056067599991, 60.25141022300005],
              [-147.72370357999992, 60.22138092700004],
              [-147.74128170499992, 60.19358958500004],
              [-147.7656143869999, 60.17438385600008],
              [-147.7986954419999, 60.17011139500005],
              [-147.79621334499993, 60.18805573100008],
              [-147.8114314439999, 60.18935781500005],
              [-147.8307999339999, 60.18691640800006],
              [-147.8402400379999, 60.19367096600007],
              [-147.7924698559999, 60.238348700000074],
              [-147.7986954419999, 60.24518463700008],
              [-147.8224991529999, 60.23236725500004],
              [-147.85171464799993, 60.22793203300006],
              [-147.88190670499992, 60.230454820000034],
              [-147.9085587229999, 60.238348700000074],
              [-147.9033096999999, 60.25287506700005],
              [-147.8959854809999, 60.26032135600008],
              [-147.8675837879999, 60.27252838700008],
              [-147.87775631399992, 60.27826569200005],
              [-147.89899654899992, 60.28693268400008],
              [-147.9085587229999, 60.292954820000034],
              [-147.8704727859999, 60.29242584800005],
              [-147.82282467399992, 60.29913971600007],
              [-147.7803848949999, 60.31484609600005],
              [-147.7577205069999, 60.34137604400007],
              [-147.7845352859999, 60.339178778000075],
              [-147.83372962099992, 60.329413153000075],
              [-147.86074785099993, 60.32709381700005],
              [-147.8727107409999, 60.32892487200007],
              [-147.8749893869999, 60.33340078300006],
              [-147.8701065749999, 60.339056708000044],
              [-147.86074785099993, 60.34446849200003],
              [-147.84780839799993, 60.34642161700003],
              [-147.82062740799992, 60.34275950700004],
              [-147.8061417309999, 60.34760163000004],
              [-147.84618079299992, 60.36627838700008],
              [-147.86058508999992, 60.377386786000045],
              [-147.84707597599993, 60.38239166900007],
              [-147.8203018869999, 60.382798570000034],
              [-147.80134029899992, 60.38589101800005],
              [-147.7862849599999, 60.39398834800005],
              [-147.7713923819999, 60.40965403900003],
            ],
          ],
          [
            [
              [-151.86982174399992, 60.48541901200008],
              [-151.87970943899992, 60.47736237200007],
              [-151.89155025899993, 60.45770905200004],
              [-151.8970841139999, 60.45062897300005],
              [-151.9088028639999, 60.44358958500004],
              [-151.9186905589999, 60.44131094000005],
              [-151.92975826699993, 60.44025299700007],
              [-151.94493567599991, 60.43695709800005],
              [-151.9634903639999, 60.42617422100005],
              [-151.97862708199992, 60.408270575000074],
              [-151.98216712099992, 60.38947174700007],
              [-151.96601314999992, 60.37555573100008],
              [-152.0385636059999, 60.35040924700007],
              [-152.06159420499992, 60.34760163000004],
              [-152.07282467399992, 60.34975820500006],
              [-152.08381100199992, 60.35443756700005],
              [-152.08967037699992, 60.35911692900004],
              [-152.08551998599992, 60.36127350500004],
              [-152.03779049399992, 60.36570872600004],
              [-152.02745520699992, 60.36810944200005],
              [-152.02159583199992, 60.376206773000035],
              [-152.0217179029999, 60.38532135600008],
              [-152.02306067599991, 60.39427317900004],
              [-152.0206192699999, 60.40216705900008],
              [-152.0119522779999, 60.408189195000034],
              [-151.9902237619999, 60.41909414300005],
              [-151.9858292309999, 60.427069403000075],
              [-151.98053951699993, 60.44041575700004],
              [-151.9710587229999, 60.45209381700005],
              [-151.96747799399992, 60.46580638200004],
              [-151.97968502499992, 60.48541901200008],
              [-151.95319576699993, 60.50849030200004],
              [-151.94306393099993, 60.51162344000005],
              [-151.92133541599992, 60.51211172100005],
              [-151.9041641919999, 60.51056549700007],
              [-151.88402258999992, 60.50568268400008],
              [-151.8662003249999, 60.497300523000035],
              [-151.85614986899992, 60.48541901200008],
              [-151.86982174399992, 60.48541901200008],
            ],
          ],
          [
            [
              [-145.75723222599993, 60.62872955900008],
              [-145.74982662699992, 60.62132396000004],
              [-145.77009029899992, 60.61041901200008],
              [-145.7777400379999, 60.608303127000056],
              [-145.7584122389999, 60.60187409100007],
              [-145.74982662699992, 60.60146719000005],
              [-145.7565811839999, 60.59320709800005],
              [-145.76414954299992, 60.587103583000044],
              [-145.7731013659999, 60.58295319200005],
              [-145.7839249339999, 60.58038971600007],
              [-145.87173417899993, 60.54389069200005],
              [-145.91368567599991, 60.536810614000046],
              [-145.96271725199992, 60.51894765800006],
              [-146.0146378249999, 60.50893789300005],
              [-146.0630997389999, 60.488267320000034],
              [-146.09691321499992, 60.479681708000044],
              [-146.29426021999993, 60.454779364000046],
              [-146.3326309889999, 60.464911200000074],
              [-146.31794186099992, 60.493841864000046],
              [-146.30573482999992, 60.51015859600005],
              [-146.28644771999993, 60.51732005400004],
              [-146.1201065749999, 60.51947663000004],
              [-146.09308834499993, 60.52578359600005],
              [-146.1002091139999, 60.528631903000075],
              [-146.12035071499992, 60.53937409100007],
              [-146.0340876939999, 60.558294989000046],
              [-145.94904537699992, 60.56732819200005],
              [-145.94904537699992, 60.57416413000004],
              [-145.95661373599992, 60.577053127000056],
              [-145.9616593089999, 60.580511786000045],
              [-145.96955318899992, 60.58783600500004],
              [-145.8587540359999, 60.59560781500005],
              [-145.80573482999992, 60.60618724200003],
              [-145.75723222599993, 60.62872955900008],
            ],
          ],
          [
            [
              [-147.49767005099991, 60.656683661000045],
              [-147.4872126939999, 60.66128164300005],
              [-147.44985917899993, 60.66974518400008],
              [-147.44847571499992, 60.680975653000075],
              [-147.45539303299992, 60.68781159100007],
              [-147.46637936099992, 60.69082265800006],
              [-147.4771622389999, 60.69017161700003],
              [-147.4662979809999, 60.69806549700007],
              [-147.42878170499992, 60.711371161000045],
              [-147.42056230399993, 60.707098700000074],
              [-147.4130753249999, 60.702053127000056],
              [-147.4066055979999, 60.69627513200004],
              [-147.3851619129999, 60.67255280200004],
              [-147.37433834499993, 60.66486237200007],
              [-147.3642471999999, 60.66632721600007],
              [-147.35293535099993, 60.67377350500004],
              [-147.3389786449999, 60.679348049000055],
              [-147.32469641799992, 60.682806708000044],
              [-147.3127335279999, 60.684027411000045],
              [-147.32502193899992, 60.65717194200005],
              [-147.3397110669999, 60.64557526200008],
              [-147.3597305979999, 60.64447663000004],
              [-147.3878067699999, 60.64923737200007],
              [-147.4029434889999, 60.64838288000004],
              [-147.44928951699993, 60.63812897300005],
              [-147.4771622389999, 60.635646877000056],
              [-147.46104895699992, 60.64834219000005],
              [-147.4549454419999, 60.65493398600006],
              [-147.44985917899993, 60.66290924700007],
              [-147.47402910099993, 60.66111888200004],
              [-147.49767005099991, 60.656683661000045],
            ],
          ],
          [
            [
              [-147.9290665359999, 60.71816640800006],
              [-147.92536373599992, 60.73187897300005],
              [-147.91950436099992, 60.74164459800005],
              [-147.9098201159999, 60.74481842700004],
              [-147.8812556629999, 60.73151276200008],
              [-147.8654679029999, 60.72011953300006],
              [-147.8524470689999, 60.706732489000046],
              [-147.84707597599993, 60.69399648600006],
              [-147.85753333199992, 60.687201239000046],
              [-147.9222305979999, 60.684027411000045],
              [-147.92324785099993, 60.680853583000044],
              [-147.92467200399992, 60.67422109600005],
              [-147.9283341139999, 60.66714101800005],
              [-147.9359024729999, 60.66290924700007],
              [-147.94151770699992, 60.66510651200008],
              [-147.96690833199992, 60.68032461100006],
              [-148.01219641799992, 60.72500234600005],
              [-147.99461829299992, 60.731350002000056],
              [-147.97883053299992, 60.72597890800006],
              [-147.9639786449999, 60.71662018400008],
              [-147.94953365799992, 60.711371161000045],
              [-147.96548417899993, 60.73383209800005],
              [-147.9693497389999, 60.74664948100008],
              [-147.96035722599993, 60.75234609600005],
              [-147.94933020699992, 60.74872467700004],
              [-147.9424942699999, 60.73997630400004],
              [-147.93683834499993, 60.72882721600007],
              [-147.9290665359999, 60.71816640800006],
            ],
          ],
          [
            [
              [-148.16864986899992, 60.66290924700007],
              [-148.19452877499992, 60.68146393400008],
              [-148.22223873599992, 60.70612213700008],
              [-148.23009192599991, 60.729722398000035],
              [-148.19660396999993, 60.74481842700004],
              [-148.2116593089999, 60.75604889500005],
              [-148.2170304029999, 60.759100653000075],
              [-148.15868079299992, 60.76471588700008],
              [-148.14130611899992, 60.759100653000075],
              [-148.12409420499992, 60.75112539300005],
              [-148.11115475199992, 60.73810455900008],
              [-148.11005611899992, 60.72532786700003],
              [-148.1282852859999, 60.71816640800006],
              [-148.1282852859999, 60.711371161000045],
              [-148.1080216139999, 60.70970286700003],
              [-148.0987442699999, 60.69684479400007],
              [-148.09919186099992, 60.67914459800005],
              [-148.1077774729999, 60.66290924700007],
              [-148.12474524599992, 60.65053945500006],
              [-148.1404923169999, 60.64866771000004],
              [-148.15514075399992, 60.653998114000046],
              [-148.16864986899992, 60.66290924700007],
            ],
          ],
          [
            [
              [-148.08735104099992, 60.800116278000075],
              [-148.11603756399992, 60.79755280200004],
              [-148.12714596299992, 60.80060455900008],
              [-148.1351212229999, 60.81313711100006],
              [-148.13683020699992, 60.82636139500005],
              [-148.13422604099992, 60.836818752000056],
              [-148.1302384109999, 60.84662506700005],
              [-148.1282852859999, 60.85809967700004],
              [-148.11139889199993, 60.87750885600008],
              [-148.08149166599992, 60.89203522300005],
              [-148.06989498599992, 60.90424225500004],
              [-148.1077774729999, 60.91681549700007],
              [-148.1077774729999, 60.92300039300005],
              [-148.08946692599991, 60.92243073100008],
              [-148.03209387899992, 60.93040599200003],
              [-147.96764075399992, 60.905585028000075],
              [-147.94050045499992, 60.88580963700008],
              [-147.9432673819999, 60.86155833500004],
              [-147.91934160099993, 60.838324286000045],
              [-147.9123429029999, 60.825425523000035],
              [-147.9153946609999, 60.81313711100006],
              [-147.9291886059999, 60.806341864000046],
              [-147.94298255099991, 60.812201239000046],
              [-147.95592200399992, 60.82221100500004],
              [-147.96690833199992, 60.827378648000035],
              [-148.00849361899992, 60.79633209800005],
              [-148.0237930979999, 60.79120514500005],
              [-148.08735104099992, 60.800116278000075],
            ],
          ],
          [
            [
              [-162.3408096999999, 63.60248444200005],
              [-162.3416641919999, 63.59707265800006],
              [-162.3443497389999, 63.59369538000004],
              [-162.3487442699999, 63.591498114000046],
              [-162.3544815749999, 63.58942291900007],
              [-162.3580216139999, 63.58661530200004],
              [-162.3603409499999, 63.58388906500005],
              [-162.36310787699992, 63.582098700000074],
              [-162.36811275899993, 63.58197663000004],
              [-162.34943600199992, 63.56049225500004],
              [-162.3476456369999, 63.554754950000074],
              [-162.3593643869999, 63.546210028000075],
              [-162.3730362619999, 63.54975006700005],
              [-162.3841446609999, 63.55776601800005],
              [-162.38801021999993, 63.562201239000046],
              [-162.49815833199992, 63.548529364000046],
              [-162.61485755099991, 63.548529364000046],
              [-162.6269425119999, 63.55068594000005],
              [-162.64891516799992, 63.56000397300005],
              [-162.67817135299993, 63.563666083000044],
              [-162.71760006399992, 63.57518138200004],
              [-162.6765030589999, 63.61151764500005],
              [-162.66608639199993, 63.61676666900007],
              [-162.6334122389999, 63.62262604400007],
              [-162.62140865799992, 63.62299225500004],
              [-162.61042232999992, 63.619208075000074],
              [-162.6025284499999, 63.613714911000045],
              [-162.59394283799992, 63.61123281500005],
              [-162.5804337229999, 63.61676666900007],
              [-162.58442135299993, 63.62848541900007],
              [-162.55646725199992, 63.62982819200005],
              [-162.48216712099992, 63.62189362200007],
              [-162.4616593089999, 63.62368398600006],
              [-162.4439591139999, 63.62946198100008],
              [-162.43639075399992, 63.640326239000046],
              [-162.4280899729999, 63.64215729400007],
              [-162.40904700399992, 63.63934967700004],
              [-162.37494869699992, 63.63043854400007],
              [-162.38243567599991, 63.62299225500004],
              [-162.3408096999999, 63.60248444200005],
            ],
          ],
          [
            [
              [-163.18537350199992, 69.61025625200006],
              [-163.17162024599992, 69.65778229400007],
              [-163.15290279899992, 69.67829010600008],
              [-163.1362198559999, 69.68252187700006],
              [-163.12909908799992, 69.68154531500005],
              [-163.15253658799992, 69.66811758000006],
              [-163.16791744699992, 69.63849518400008],
              [-163.1741837229999, 69.60447825700004],
              [-163.17003333199992, 69.57786692900004],
              [-163.1740616529999, 69.56329987200007],
              [-163.17625891799992, 69.48224518400008],
              [-163.18464107999992, 69.51105377800008],
              [-163.18907630099991, 69.53994375200006],
              [-163.19115149599992, 69.54653554900005],
              [-163.18537350199992, 69.61025625200006],
            ],
          ],
          [
            [
              [-141.42308508999992, 69.72186920800004],
              [-141.40880286399994, 69.71499258000006],
              [-141.39663652299993, 69.70587799700007],
              [-141.38512122299994, 69.69452545800004],
              [-141.4129125639999, 69.70506419500003],
              [-141.47256425699993, 69.72077057500007],
              [-141.5842179029999, 69.76642487200007],
              [-141.64541581899994, 69.77456289300005],
              [-141.7134496739999, 69.79328034100007],
              [-141.7657364569999, 69.79975006700005],
              [-141.8002823559999, 69.80914948100008],
              [-141.8579809239999, 69.81509023600006],
              [-141.8984268869999, 69.82489655200004],
              [-141.80923417899993, 69.82192617400005],
              [-141.5286352199999, 69.76032135600008],
              [-141.42308508999992, 69.72186920800004],
            ],
          ],
          [
            [
              [-163.0557755199999, 69.80451080900008],
              [-163.03014075399992, 69.83291250200006],
              [-162.99994869699992, 69.85578034100007],
              [-162.84113521999993, 69.93475983300004],
              [-162.8779190749999, 69.90167877800008],
              [-163.01178951699993, 69.83234284100007],
              [-163.04218502499992, 69.80158112200007],
              [-163.09544837099992, 69.73139069200005],
              [-163.12909908799992, 69.70197174700007],
              [-163.0557755199999, 69.80451080900008],
            ],
          ],
          [
            [
              [-162.7017716139999, 70.02232493700006],
              [-162.67735755099991, 70.04413483300004],
              [-162.64179439999992, 70.06557851800005],
              [-162.60081946499992, 70.08283112200007],
              [-162.5599259109999, 70.09243398600006],
              [-162.55646725199992, 70.09027741100005],
              [-162.6060684889999, 70.06924062700006],
              [-162.67536373599992, 70.02948639500005],
              [-162.69933020699992, 69.99974192900004],
              [-162.73717200399992, 69.97809479400007],
              [-162.80634518099993, 69.94839101800005],
              [-162.72813880099991, 69.99860260600008],
              [-162.7020564439999, 70.02204010600008],
              [-162.7017716139999, 70.02232493700006],
            ],
          ],
          [
            [
              [-162.48452714799993, 70.17316315300008],
              [-162.30854244699992, 70.24127838700008],
              [-162.1627091139999, 70.26992422100005],
              [-162.3437393869999, 70.22020091400003],
              [-162.49103756399992, 70.15387604400007],
              [-162.50987708199992, 70.14081452000005],
              [-162.53913326699993, 70.11371491100005],
              [-162.5599259109999, 70.10602448100008],
              [-162.5032852859999, 70.16128164300005],
              [-162.48452714799993, 70.17316315300008],
            ],
          ],
          [
            [
              [-161.5511368479999, 70.32599518400008],
              [-161.83783932199992, 70.34341054900005],
              [-161.9120987619999, 70.33991120000007],
              [-161.97712154899992, 70.31216054900005],
              [-161.96996008999992, 70.32123444200005],
              [-161.94306393099993, 70.33958567900004],
              [-161.88813229099992, 70.35394928600005],
              [-161.5511368479999, 70.32599518400008],
            ],
          ],
          [
            [
              [-148.8196915359999, 70.46979401200008],
              [-148.82209225199992, 70.46869538000004],
              [-148.91222083199992, 70.48859284100007],
              [-148.95038814999992, 70.48627350500004],
              [-148.9791153639999, 70.48090241100005],
              [-149.01569576699993, 70.48493073100008],
              [-149.19404049399992, 70.53693268400008],
              [-149.25438391799992, 70.54559967700004],
              [-149.31318111899992, 70.54486725500004],
              [-149.3038223949999, 70.54783763200004],
              [-149.27741451699993, 70.55267975500004],
              [-149.23627682199992, 70.55329010600008],
              [-148.99457760299993, 70.49290599200003],
              [-148.9716690749999, 70.49384186400005],
              [-148.9433487619999, 70.50018952000005],
              [-148.92292232999992, 70.50145091400003],
              [-148.89435787699992, 70.49640534100007],
              [-148.8196915359999, 70.46979401200008],
            ],
          ],
          [
            [
              [-81.74624589799993, 24.576117255000042],
              [-81.74087480399993, 24.573187567000048],
              [-81.73668372299994, 24.569525458000044],
              [-81.7337133449999, 24.564154364000046],
              [-81.73200436099995, 24.55621979400007],
              [-81.73766028599994, 24.557806708000044],
              [-81.74132239499994, 24.560695705000057],
              [-81.74380449099993, 24.56464264500005],
              [-81.74624589799993, 24.56989166900007],
              [-81.74722245999993, 24.567572333000044],
              [-81.74730383999992, 24.56443919500009],
              [-81.74840247299994, 24.564113674000055],
              [-81.75251217399995, 24.56989166900007],
              [-81.75572669199994, 24.562445380000042],
              [-81.75991777299993, 24.55621979400007],
              [-81.76939856699994, 24.55019765800006],
              [-81.78441321499992, 24.546128648000035],
              [-81.81456458199995, 24.54254791900007],
              [-81.81029212099992, 24.55817291900007],
              [-81.80186926999994, 24.560288804000038],
              [-81.79124915299991, 24.557074286000045],
              [-81.78038489499994, 24.55621979400007],
              [-81.77293860599991, 24.559719143000052],
              [-81.75251217399995, 24.576117255000042],
              [-81.74624589799993, 24.576117255000042],
            ],
          ],
          [
            [
              [-81.70531165299991, 24.597805080000057],
              [-81.69579016799992, 24.590643622000073],
              [-81.68390865799995, 24.591131903000075],
              [-81.65684973899994, 24.597805080000057],
              [-81.65461178299995, 24.59320709800005],
              [-81.65005449099993, 24.576117255000042],
              [-81.72573808499993, 24.55621979400007],
              [-81.72158769399994, 24.559515692000048],
              [-81.71149654899995, 24.56989166900007],
              [-81.71149654899995, 24.576117255000042],
              [-81.71694902299993, 24.58104075700004],
              [-81.71833248599995, 24.58624909100007],
              [-81.71629798099991, 24.591742255000042],
              [-81.71149654899995, 24.597805080000057],
              [-81.70531165299991, 24.597805080000057],
            ],
          ],
          [
            [
              [-81.50601152299993, 24.638820705000057],
              [-81.50601152299993, 24.631333726000037],
              [-81.53083248599995, 24.61522044500009],
              [-81.56505286399994, 24.60224030200004],
              [-81.63646399599992, 24.58356354400007],
              [-81.63646399599992, 24.590318101000037],
              [-81.61693274599992, 24.60545482000009],
              [-81.6055395169999, 24.60956452000005],
              [-81.59544837099992, 24.603989976000037],
              [-81.57359778599994, 24.613714911000045],
              [-81.56749426999994, 24.617661851000037],
              [-81.56493079299992, 24.621161200000074],
              [-81.56167558499993, 24.622748114000046],
              [-81.55451412699995, 24.631333726000037],
              [-81.56924394399994, 24.64004140800006],
              [-81.57534745999993, 24.644924221000053],
              [-81.58116614499994, 24.65180084800005],
              [-81.55166581899994, 24.644354559000078],
              [-81.53868567599994, 24.636460679000038],
              [-81.53335527299993, 24.62449778900009],
              [-81.52717037699995, 24.62449778900009],
              [-81.52245032499991, 24.637925523000035],
              [-81.52570553299995, 24.64789459800005],
              [-81.53648841099994, 24.65302155200004],
              [-81.55451412699995, 24.65180084800005],
              [-81.55451412699995, 24.65924713700008],
              [-81.54898027299993, 24.664943752000056],
              [-81.55052649599992, 24.668768622000073],
              [-81.55724036399994, 24.671128648000035],
              [-81.56749426999994, 24.672308661000045],
              [-81.56065833199995, 24.693426825000074],
              [-81.55451412699995, 24.693426825000074],
              [-81.55500240799995, 24.68817780200004],
              [-81.55321204299992, 24.68695709800005],
              [-81.55020097599993, 24.687160549000055],
              [-81.54698645699995, 24.685939846000053],
              [-81.54010982999995, 24.67523834800005],
              [-81.50601152299993, 24.638820705000057],
            ],
          ],
          [
            [
              [-81.08771725199995, 24.685939846000053],
              [-81.09276282499991, 24.700873114000046],
              [-81.10391191299993, 24.706773179000038],
              [-81.13609778599994, 24.70701732000009],
              [-81.11558997299994, 24.715725002000056],
              [-81.06143144399994, 24.731350002000056],
              [-81.03990637899994, 24.73436107000009],
              [-81.04063880099994, 24.727362372000073],
              [-81.04369055899991, 24.724310614000046],
              [-81.06712805899991, 24.71588776200008],
              [-81.07616126199991, 24.709051825000074],
              [-81.08250891799992, 24.69944896000004],
              [-81.08771725199995, 24.685939846000053],
            ],
          ],
          [
            [
              [-81.43028723899994, 24.754828192000048],
              [-81.42747962099992, 24.75136953300006],
              [-81.4246313139999, 24.749823309000078],
              [-81.4173070949999, 24.74868398600006],
              [-81.38768469999991, 24.727484442000048],
              [-81.35545813699991, 24.68618398600006],
              [-81.34056555899991, 24.64671458500004],
              [-81.36266028599994, 24.631333726000037],
              [-81.36424719999991, 24.66120026200008],
              [-81.43028723899994, 24.754828192000048],
            ],
          ],
          [
            [
              [-80.92381751199991, 24.76911041900007],
              [-80.92788652299993, 24.765692450000074],
              [-80.93211829299992, 24.763739325000074],
              [-80.94432532499991, 24.761664130000042],
              [-80.95889238199993, 24.749335028000075],
              [-81.03307044199994, 24.72068919500009],
              [-80.95555579299992, 24.768744208000044],
              [-80.92381751199991, 24.775336005000042],
              [-80.92381751199991, 24.76911041900007],
            ],
          ],
          [
            [
              [-80.80036373599995, 24.843573309000078],
              [-80.80215410099993, 24.833685614000046],
              [-80.80231686099995, 24.82689036700009],
              [-80.79971269399994, 24.82526276200008],
              [-80.79352779899995, 24.830552476000037],
              [-80.78734290299991, 24.830552476000037],
              [-80.78709876199991, 24.825995184000078],
              [-80.78844153599994, 24.82294342700004],
              [-80.79352779899995, 24.816880601000037],
              [-80.80215410099993, 24.809881903000075],
              [-80.81847083199995, 24.805812893000052],
              [-80.85496985599991, 24.803290106000077],
              [-80.8450414699999, 24.81435781500005],
              [-80.80036373599995, 24.843573309000078],
            ],
          ],
          [
            [
              [-80.32054602799991, 25.24827708500004],
              [-80.35334225199995, 25.205552476000037],
              [-80.36583411399994, 25.18121979400007],
              [-80.36148027299993, 25.165716864000046],
              [-80.36148027299993, 25.159491278000075],
              [-80.44277910099993, 25.086411851000037],
              [-80.45360266799992, 25.081000067000048],
              [-80.46450761599993, 25.083807684000078],
              [-80.47126217399995, 25.07298411700009],
              [-80.48033606699994, 25.04979075700004],
              [-80.48814856699994, 25.039455471000053],
              [-80.51915442599994, 25.014878648000035],
              [-80.5559789699999, 24.97093333500004],
              [-80.57860266799992, 24.95026276200008],
              [-80.59801184799994, 24.950100002000056],
              [-80.60350501199991, 24.96112702000005],
              [-80.59398352799991, 24.966620184000078],
              [-80.57884680899991, 24.969875393000052],
              [-80.56761633999992, 24.973944403000075],
              [-80.55565344999991, 25.009019273000035],
              [-80.55016028599994, 25.014878648000035],
              [-80.53408769399994, 25.01658763200004],
              [-80.52647864499994, 25.02167389500005],
              [-80.51231848899994, 25.04287344000005],
              [-80.4876195949999, 25.06659577000005],
              [-80.48086503799993, 25.07843659100007],
              [-80.4844457669999, 25.09125397300005],
              [-80.46304277299993, 25.09398021000004],
              [-80.45238196499992, 25.09918854400007],
              [-80.4434301419999, 25.111151434000078],
              [-80.44823157499991, 25.11855703300006],
              [-80.44859778599994, 25.12213776200008],
              [-80.44481360599991, 25.12205638200004],
              [-80.43724524599992, 25.11859772300005],
              [-80.43346106699994, 25.13027578300006],
              [-80.43903561099995, 25.139797268000052],
              [-80.45042883999992, 25.14354075700004],
              [-80.46450761599993, 25.138413804000038],
              [-80.45856686099995, 25.156195380000042],
              [-80.4134008449999, 25.147406317000048],
              [-80.39427649599992, 25.19090403900009],
              [-80.35732988199993, 25.227362372000073],
              [-80.34780839799993, 25.24827708500004],
              [-80.35024980399993, 25.262844143000052],
              [-80.35765540299991, 25.269354559000078],
              [-80.36534583199995, 25.27480703300006],
              [-80.36896725199995, 25.28611888200004],
              [-80.36266028599994, 25.292181708000044],
              [-80.33063717399995, 25.29954661700009],
              [-80.31745357999995, 25.30695221600007],
              [-80.29059811099995, 25.34275950700004],
              [-80.27342688699991, 25.35260651200008],
              [-80.25161699099993, 25.34446849200009],
              [-80.25487219999991, 25.339016018000052],
              [-80.25812740799995, 25.335150458000044],
              [-80.26170813699991, 25.332424221000053],
              [-80.26593990799995, 25.330226955000057],
              [-80.27269446499992, 25.32367584800005],
              [-80.2793676419999, 25.312241929000038],
              [-80.28441321499992, 25.300441799000055],
              [-80.2864477199999, 25.292669989000046],
              [-80.29133053299995, 25.28261953300006],
              [-80.32054602799991, 25.24827708500004],
            ],
          ],
          [
            [
              [-80.19017493399991, 25.481024481000077],
              [-80.19391842399995, 25.45921458500004],
              [-80.20348059799994, 25.43659088700008],
              [-80.21690833199995, 25.41547272300005],
              [-80.23119055899991, 25.40338776200008],
              [-80.23253333199995, 25.404730536000045],
              [-80.23509680899991, 25.404852606000077],
              [-80.23802649599992, 25.405951239000046],
              [-80.22435462099992, 25.416083075000074],
              [-80.21572831899994, 25.432033596000053],
              [-80.19994055899991, 25.48981354400007],
              [-80.19701087099992, 25.494696356000077],
              [-80.18822180899991, 25.49835846600007],
              [-80.18659420499995, 25.493312893000052],
              [-80.18846594999991, 25.48541901200008],
              [-80.19017493399991, 25.481024481000077],
            ],
          ],
          [
            [
              [-80.1629125639999, 25.67283763200004],
              [-80.17560787699995, 25.67340729400007],
              [-80.18179277299993, 25.681301174000055],
              [-80.18032792899993, 25.691880601000037],
              [-80.16974850199995, 25.70075104400007],
              [-80.17357337099992, 25.702866929000038],
              [-80.17613684799994, 25.704820054000038],
              [-80.17886308499993, 25.70648834800005],
              [-80.18333899599992, 25.707586981000077],
              [-80.18333899599992, 25.713812567000048],
              [-80.17568925699993, 25.71832916900007],
              [-80.17007402299993, 25.72284577000005],
              [-80.16600501199991, 25.728176174000055],
              [-80.1629125639999, 25.734930731000077],
              [-80.15607662699995, 25.734930731000077],
              [-80.15831458199995, 25.67926666900007],
              [-80.1629125639999, 25.67283763200004],
            ],
          ],
          [
            [
              [-82.12922115799995, 26.46112702000005],
              [-82.09626217399995, 26.45453522300005],
              [-82.07681230399993, 26.456203518000052],
              [-82.0684301419999, 26.467962958000044],
              [-82.02684485599991, 26.44745514500005],
              [-82.04552161399994, 26.443752346000053],
              [-82.07091223899994, 26.424627997000073],
              [-82.08824622299994, 26.41950104400007],
              [-82.1035863919999, 26.42255280200004],
              [-82.16392981699994, 26.454291083000044],
              [-82.17503821499992, 26.46246979400007],
              [-82.18407141799992, 26.47333405200004],
              [-82.19131425699993, 26.488430080000057],
              [-82.20067298099991, 26.519598700000074],
              [-82.20494544199994, 26.550482489000046],
              [-82.19627844999991, 26.54450104400007],
              [-82.19078528599994, 26.53652578300006],
              [-82.18716386599993, 26.52692291900007],
              [-82.18443762899994, 26.515773830000057],
              [-82.17589270699995, 26.494940497000073],
              [-82.1641332669999, 26.47955963700008],
              [-82.14879309799994, 26.468573309000078],
              [-82.12922115799995, 26.46112702000005],
            ],
          ],
          [
            [
              [-82.26016191299993, 26.701320705000057],
              [-82.25548255099994, 26.701239325000074],
              [-82.25234941299993, 26.699611721000053],
              [-82.24596106699994, 26.694525458000044],
              [-82.24453691299993, 26.670803127000056],
              [-82.2293188139999, 26.63377513200004],
              [-82.22545325399994, 26.611273505000042],
              [-82.2390844389999, 26.63418203300006],
              [-82.24767005099994, 26.654364325000074],
              [-82.26016191299993, 26.701320705000057],
            ],
          ],
          [
            [
              [-82.13670813699991, 26.58466217700004],
              [-82.13243567599994, 26.609808661000045],
              [-82.14574133999992, 26.64012278900009],
              [-82.16466223899994, 26.671942450000074],
              [-82.17764238199993, 26.701320705000057],
              [-82.16397050699993, 26.701320705000057],
              [-82.14391028599994, 26.694647528000075],
              [-82.12450110599991, 26.67645905200004],
              [-82.11363684799994, 26.654364325000074],
              [-82.12319902299993, 26.61871979400007],
              [-82.11156165299991, 26.59638092700004],
              [-82.09601803299995, 26.57493724200009],
              [-82.08824622299994, 26.56045156500005],
              [-82.08096269399994, 26.509019273000035],
              [-82.08202063699991, 26.491522528000075],
              [-82.09508216099994, 26.495835679000038],
              [-82.10850989499994, 26.51630280200004],
              [-82.12364661399994, 26.565375067000048],
              [-82.13670813699991, 26.58466217700004],
            ],
          ],
          [
            [
              [-82.27383378799993, 26.803127346000053],
              [-82.26292883999992, 26.780096747000073],
              [-82.25796464799993, 26.75853099200009],
              [-82.2591039699999, 26.737250067000048],
              [-82.2664281889999, 26.714992580000057],
              [-82.27464758999992, 26.736151434000078],
              [-82.27782141799992, 26.78506094000005],
              [-82.28750566299993, 26.803127346000053],
              [-82.28148352799991, 26.809475002000056],
              [-82.27843176999994, 26.81004466400009],
              [-82.27383378799993, 26.803127346000053],
            ],
          ],
          [
            [
              [-97.19831295499995, 26.27610911700009],
              [-97.18267985699993, 26.231154556000035],
              [-97.17742389499995, 26.20500766400005],
              [-97.17067950899991, 26.17952332100009],
              [-97.1644017779999, 26.131494536000048],
              [-97.16339865099991, 26.11359297900009],
              [-97.1663792359999, 26.10284657300008],
              [-97.17933081399991, 26.119828581000036],
              [-97.18831397999992, 26.14933564200004],
              [-97.2130165669999, 26.29271411600007],
              [-97.22716060399995, 26.337414977000037],
              [-97.23989824099993, 26.364935614000046],
              [-97.24917558499993, 26.39081452000005],
              [-97.26036536399994, 26.467962958000044],
              [-97.2683813139999, 26.490383205000057],
              [-97.29206295499995, 26.52920156500005],
              [-97.30134029899995, 26.550482489000046],
              [-97.31322180899991, 26.606756903000075],
              [-97.31810462099992, 26.616441148000035],
              [-97.32925370999993, 26.63304271000004],
              [-97.33788001199991, 26.653957424000055],
              [-97.35008704299992, 26.697414455000057],
              [-97.36339270699995, 26.721177476000037],
              [-97.35594641799992, 26.728583075000074],
              [-97.36253821499992, 26.734442450000074],
              [-97.36681067599994, 26.740708726000037],
              [-97.3692113919999, 26.747788804000038],
              [-97.37022864499994, 26.755926825000074],
              [-97.36823482999995, 26.75995514500005],
              [-97.35826575399994, 26.762518622000073],
              [-97.35594641799992, 26.76585521000004],
              [-97.3570043609999, 26.771551825000074],
              [-97.36192786399994, 26.77928294500009],
              [-97.36339270699995, 26.783270575000074],
              [-97.36742102799991, 26.79120514500005],
              [-97.39753170499995, 26.831000067000048],
              [-97.38805091099994, 26.86554596600007],
              [-97.38540605399993, 26.90037669500009],
              [-97.39391028599994, 26.994289455000057],
              [-97.40306555899991, 27.030910549000055],
              [-97.40501868399991, 27.05076732000009],
              [-97.3980199859999, 27.088364976000037],
              [-97.39708411399994, 27.10732656500005],
              [-97.40501868399991, 27.12523021000004],
              [-97.39696204299992, 27.146185614000046],
              [-97.39159094999991, 27.193101304000038],
              [-97.37706458199995, 27.207831122000073],
              [-97.38390051999994, 27.187933661000045],
              [-97.3762914699999, 26.93162669500009],
              [-97.34288489499994, 26.756740627000056],
              [-97.23867753799993, 26.445786851000037],
              [-97.23989824099993, 26.43378327000005],
              [-97.2312719389999, 26.421087958000044],
              [-97.22492428299995, 26.39907461100006],
              [-97.21219000499991, 26.340282908000063],
              [-97.20225989499994, 26.298773505000042],
              [-97.19831295499995, 26.27610911700009],
            ],
          ],
          [
            [
              [-82.65746008999992, 27.39679596600007],
              [-82.66441809799994, 27.40448639500005],
              [-82.67662512899994, 27.42177969000005],
              [-82.6809789699999, 27.434068101000037],
              [-82.66421464799993, 27.426906643000052],
              [-82.65428626199991, 27.419663804000038],
              [-82.63011633999992, 27.379706122000073],
              [-82.5930883449999, 27.33982982000009],
              [-82.5891820949999, 27.32444896000004],
              [-82.60667883999992, 27.33665599200009],
              [-82.64903723899994, 27.381333726000037],
              [-82.65746008999992, 27.39679596600007],
            ],
          ],
          [
            [
              [-97.07542883999992, 27.814520575000074],
              [-97.06753495999993, 27.84088776200008],
              [-97.05260169199994, 27.844183661000045],
              [-97.04401607999995, 27.835272528000075],
              [-97.05492102799991, 27.824774481000077],
              [-97.1780072169999, 27.65284366900005],
              [-97.25935460499994, 27.49617465500006],
              [-97.32025632199992, 27.357574337000074],
              [-97.34660941699991, 27.274163730000055],
              [-97.35164248799992, 27.23517058100009],
              [-97.3659124909999, 27.22423140400008],
              [-97.38809160099993, 27.223944403000075],
              [-97.39753170499995, 27.228908596000053],
              [-97.38975989499994, 27.24555084800005],
              [-97.37025264099992, 27.34836641800007],
              [-97.3387587439999, 27.409122490000073],
              [-97.32152783399994, 27.456231586000058],
              [-97.31239711699993, 27.477972228000056],
              [-97.29818255999993, 27.507865422000066],
              [-97.28295436399992, 27.540472627000042],
              [-97.27076783899992, 27.56673760700005],
              [-97.25723222599993, 27.59275950700004],
              [-97.24510657499991, 27.623195705000057],
              [-97.24400794199994, 27.632635809000078],
              [-97.2495824859999, 27.643784898000035],
              [-97.25413977799991, 27.65965403900009],
              [-97.23062089799993, 27.651190497000073],
              [-97.21922766799992, 27.64394765800006],
              [-97.21198482999995, 27.632961330000057],
              [-97.20571855399993, 27.632961330000057],
              [-97.15103105399993, 27.739894924000055],
              [-97.1238500639999, 27.76951732000009],
              [-97.08185787699995, 27.80414459800005],
              [-97.07542883999992, 27.814520575000074],
            ],
          ],
          [
            [
              [-80.38878333199995, 27.71865469000005],
              [-80.39110266799992, 27.727443752000056],
              [-80.40990149599992, 27.75649648600006],
              [-80.43846594999991, 27.830471096000053],
              [-80.45091712099992, 27.852036851000037],
              [-80.44741777299993, 27.855617580000057],
              [-80.44456946499992, 27.857489325000074],
              [-80.43724524599992, 27.85956452000005],
              [-80.43724524599992, 27.85455963700008],
              [-80.43553626199991, 27.851711330000057],
              [-80.43272864499994, 27.849351304000038],
              [-80.42979895699995, 27.84589264500005],
              [-80.42218990799995, 27.80499909100007],
              [-80.40192623599995, 27.764146226000037],
              [-80.36148027299993, 27.701239325000074],
              [-80.34723873599995, 27.664129950000074],
              [-80.34276282499991, 27.64325592700004],
              [-80.34105383999992, 27.62246328300006],
              [-80.33763587099992, 27.606634833000044],
              [-80.16722571499992, 27.197007554000038],
              [-80.1629125639999, 27.173651434000078],
              [-80.17731686099995, 27.20221588700008],
              [-80.19762122299994, 27.223944403000075],
              [-80.20815995999993, 27.262925523000035],
              [-80.26895097599993, 27.38231028900009],
              [-80.2727758449999, 27.39679596600007],
              [-80.27586829299992, 27.40176015800006],
              [-80.28954016799992, 27.411810614000046],
              [-80.29259192599994, 27.417303778000075],
              [-80.29405676999994, 27.42991771000004],
              [-80.30687415299991, 27.46165599200009],
              [-80.34780839799993, 27.612494208000044],
              [-80.3567602199999, 27.629339911000045],
              [-80.36583411399994, 27.642238674000055],
              [-80.37291419199994, 27.65656159100007],
              [-80.37779700399994, 27.686468817000048],
              [-80.3867895169999, 27.706732489000046],
              [-80.38878333199995, 27.71865469000005],
            ],
          ],
          [
            [
              [-96.88023841099994, 28.130113023000035],
              [-96.86758378799993, 28.135565497000073],
              [-96.85484778599994, 28.130682684000078],
              [-96.84536699099993, 28.121242580000057],
              [-96.84264075399994, 28.11277903900009],
              [-96.84569251199991, 28.102850653000075],
              [-96.84715735599991, 28.080471096000053],
              [-96.85008704299992, 28.071193752000056],
              [-96.93822180899991, 27.98305898600006],
              [-96.97923743399991, 27.927801825000074],
              [-97.01463782499991, 27.89093659100007],
              [-97.02867591099994, 27.871527411000045],
              [-97.03441321499992, 27.852036851000037],
              [-97.0430395169999, 27.870306708000044],
              [-97.02977454299992, 27.90058014500005],
              [-96.9934789699999, 27.94830963700008],
              [-96.96397864499994, 27.976711330000057],
              [-96.95933997299994, 27.98305898600006],
              [-96.95303300699993, 27.994208075000074],
              [-96.95335852799991, 28.00031159100007],
              [-96.97256425699993, 28.005031643000052],
              [-96.97256425699993, 28.009914455000057],
              [-96.91405188699991, 28.09910716400009],
              [-96.90025794199994, 28.101955471000053],
              [-96.89289303299995, 28.109198309000078],
              [-96.88760331899994, 28.119208075000074],
              [-96.88023841099994, 28.130113023000035],
            ],
          ],
          [
            [
              [-80.63646399599992, 28.18105703300006],
              [-80.6380102199999, 28.193426825000074],
              [-80.6406957669999, 28.20416901200008],
              [-80.64858964799993, 28.222723700000074],
              [-80.63198808499993, 28.19041575700004],
              [-80.62901770699995, 28.18105703300006],
              [-80.63646399599992, 28.18105703300006],
            ],
          ],
          [
            [
              [-96.42772376199991, 28.39329661700009],
              [-96.41881262899994, 28.395086981000077],
              [-96.41234290299991, 28.39752838700008],
              [-96.40758216099994, 28.39638906500005],
              [-96.40379798099991, 28.387111721000053],
              [-96.40298417899993, 28.36078522300005],
              [-96.40379798099991, 28.352362372000073],
              [-96.40672766799992, 28.34442780200004],
              [-96.41515051999994, 28.33307526200008],
              [-96.41685950399994, 28.32876211100006],
              [-96.48949133999992, 28.29710521000004],
              [-96.52232825399994, 28.289618231000077],
              [-96.5535375639999, 28.271429755000042],
              [-96.60863196499992, 28.229437567000048],
              [-96.70262610599991, 28.18553294500009],
              [-96.72765051999994, 28.16160716400009],
              [-96.78115800699993, 28.12645091400009],
              [-96.80870520699995, 28.103257554000038],
              [-96.82087154899995, 28.088324286000045],
              [-96.82835852799991, 28.071193752000056],
              [-96.83580481699994, 28.071193752000056],
              [-96.83250891799992, 28.088771877000056],
              [-96.8242895169999, 28.107489325000074],
              [-96.81322180899991, 28.12368398600006],
              [-96.80166581899994, 28.13385651200008],
              [-96.80166581899994, 28.14008209800005],
              [-96.80899003799993, 28.15143463700008],
              [-96.81236731699994, 28.17011139500005],
              [-96.80776933499993, 28.187648830000057],
              [-96.79112708199995, 28.195257880000042],
              [-96.77074133999992, 28.19745514500005],
              [-96.73851477799991, 28.206854559000078],
              [-96.7222387359999, 28.20897044500009],
              [-96.71035722599993, 28.213364976000037],
              [-96.67210852799991, 28.233710028000075],
              [-96.66388912699995, 28.23969147300005],
              [-96.65428626199991, 28.257147528000075],
              [-96.61204993399991, 28.277492580000057],
              [-96.60244706899994, 28.287502346000053],
              [-96.59479732999995, 28.292669989000046],
              [-96.54845130099994, 28.311428127000056],
              [-96.52806555899991, 28.330145575000074],
              [-96.5149633449999, 28.336818752000056],
              [-96.49323482999995, 28.33930084800005],
              [-96.45543372299994, 28.336004950000074],
              [-96.44322669199994, 28.34137604400007],
              [-96.43114173099991, 28.359767971000053],
              [-96.4304906889999, 28.36782461100006],
              [-96.43146725199995, 28.38898346600007],
              [-96.42772376199991, 28.39329661700009],
            ],
          ],
          [
            [
              [-96.36969967399995, 28.40692780200004],
              [-96.36969967399995, 28.414455471000053],
              [-96.31289628799993, 28.45856354400007],
              [-96.27525794199994, 28.47870514500005],
              [-96.23253333199995, 28.489488023000035],
              [-96.23253333199995, 28.48273346600007],
              [-96.24046790299991, 28.48191966400009],
              [-96.24461829299992, 28.480169989000046],
              [-96.24787350199995, 28.477769273000035],
              [-96.24673417899993, 28.47524648600006],
              [-96.25495357999995, 28.471096096000053],
              [-96.27603105399993, 28.457098700000074],
              [-96.28392493399991, 28.447658596000053],
              [-96.30821692599994, 28.44171784100007],
              [-96.33372962099992, 28.418850002000056],
              [-96.35008704299992, 28.40888092700004],
              [-96.36969967399995, 28.40692780200004],
            ],
          ],
          [
            [
              [-80.67747962099992, 28.578924872000073],
              [-80.65550696499992, 28.59332916900007],
              [-80.64293372299994, 28.598130601000037],
              [-80.62901770699995, 28.598781643000052],
              [-80.61217200399994, 28.568833726000037],
              [-80.6184789699999, 28.537665106000077],
              [-80.64952551999994, 28.47524648600006],
              [-80.65819251199991, 28.43748607000009],
              [-80.66421464799993, 28.31509023600006],
              [-80.66893469999991, 28.29706452000005],
              [-80.6699926419999, 28.287502346000053],
              [-80.66795813699991, 28.275946356000077],
              [-80.6590063139999, 28.256293036000045],
              [-80.65147864499994, 28.239976304000038],
              [-80.64976966099994, 28.225165106000077],
              [-80.66494706899994, 28.25259023600006],
              [-80.70018469999991, 28.348089911000045],
              [-80.71471106699994, 28.36977773600006],
              [-80.71963456899994, 28.388332424000055],
              [-80.72834225199995, 28.46906159100007],
              [-80.73741614499994, 28.484849351000037],
              [-80.73989824099993, 28.51748281500005],
              [-80.73228919199994, 28.544623114000046],
              [-80.71092688699991, 28.544134833000044],
              [-80.70470130099994, 28.560614325000074],
              [-80.69863847599993, 28.56777578300006],
              [-80.67747962099992, 28.578924872000073],
            ],
          ],
          [
            [
              [-90.94371497299994, 29.06077708500004],
              [-90.90318762899994, 29.057196356000077],
              [-90.87962805899991, 29.051255601000037],
              [-90.91510982999995, 29.051255601000037],
              [-90.94371497299994, 29.06077708500004],
            ],
          ],
          [
            [
              [-90.34654700399994, 29.05805084800005],
              [-90.31859290299991, 29.078558661000045],
              [-90.31078040299991, 29.082424221000053],
              [-90.30256100199995, 29.084906317000048],
              [-90.29360917899993, 29.08612702000005],
              [-90.28384355399993, 29.086004950000074],
              [-90.28384355399993, 29.078558661000045],
              [-90.34654700399994, 29.05805084800005],
            ],
          ],
          [
            [
              [-89.9629613919999, 29.27098216400009],
              [-89.95547441299993, 29.27098216400009],
              [-89.9629613919999, 29.264146226000037],
              [-89.95547441299993, 29.25731028900009],
              [-89.97614498599995, 29.245062567000048],
              [-90.01036536399994, 29.229437567000048],
              [-90.02375240799995, 29.21637604400007],
              [-90.03062903599994, 29.21637604400007],
              [-90.02428137899994, 29.23847077000005],
              [-90.00169837099992, 29.24909088700008],
              [-89.9766332669999, 29.25690338700008],
              [-89.9629613919999, 29.27098216400009],
            ],
          ],
          [
            [
              [-94.81427975199995, 29.35293203300006],
              [-94.72440897099995, 29.333154895000064],
              [-94.8916549839999, 29.224861529000066],
              [-94.94724846499992, 29.19391369300007],
              [-95.07595538699991, 29.114043627000058],
              [-95.1082810499999, 29.088597249000088],
              [-95.11654359099992, 29.088992912000037],
              [-95.10225587999992, 29.111171470000045],
              [-95.08128077599991, 29.136083932000076],
              [-95.03400299099991, 29.162938401000076],
              [-94.9677654169999, 29.20787631400009],
              [-94.94309885699994, 29.22286028800005],
              [-94.92874066899992, 29.23689138800006],
              [-94.9207250639999, 29.250474351000037],
              [-94.91722571499992, 29.25531647300005],
              [-94.87511145699995, 29.28461334800005],
              [-94.86681067599994, 29.299953518000052],
              [-94.86204993399991, 29.305121161000045],
              [-94.83983313699991, 29.310492255000042],
              [-94.83788001199991, 29.31126536700009],
              [-94.82803300699993, 29.317613023000035],
              [-94.82164466099994, 29.33112213700008],
              [-94.8242895169999, 29.34332916900007],
              [-94.84154212099992, 29.346096096000053],
              [-94.84154212099992, 29.35293203300006],
              [-94.83649654899995, 29.352362372000073],
              [-94.8352758449999, 29.353989976000037],
              [-94.8352758449999, 29.35683828300006],
              [-94.83409583199995, 29.359767971000053],
              [-94.83193925699993, 29.360174872000073],
              [-94.82787024599992, 29.359767971000053],
              [-94.82701575399994, 29.353949286000045],
              [-94.81427975199995, 29.35293203300006],
            ],
          ],
          [
            [
              [-89.16783606699994, 29.503729559000078],
              [-89.16315670499995, 29.504461981000077],
              [-89.16161048099991, 29.503159898000035],
              [-89.16136633999992, 29.50063711100006],
              [-89.16038977799991, 29.49750397300005],
              [-89.16624915299991, 29.482367255000042],
              [-89.18260657499991, 29.473130601000037],
              [-89.20323645699995, 29.469142971000053],
              [-89.22183183499993, 29.469631252000056],
              [-89.18781490799995, 29.48037344000005],
              [-89.17300370999993, 29.48932526200008],
              [-89.16783606699994, 29.503729559000078],
            ],
          ],
          [
            [
              [-91.8020727199999, 29.490057684000078],
              [-91.84048417899993, 29.48383209800005],
              [-91.8980199859999, 29.51703522300005],
              [-91.90819251199991, 29.521144924000055],
              [-91.91844641799992, 29.52997467700004],
              [-92.02049719999991, 29.568752346000053],
              [-92.03652910099993, 29.582098700000074],
              [-92.03538977799991, 29.596177476000037],
              [-92.01231848899994, 29.613714911000045],
              [-91.99327551999994, 29.618841864000046],
              [-91.97370357999995, 29.62051015800006],
              [-91.94912675699993, 29.62726471600007],
              [-91.94351152299993, 29.63153717700004],
              [-91.93333899599992, 29.64394765800006],
              [-91.9292699859999, 29.64712148600006],
              [-91.91710364499994, 29.648138739000046],
              [-91.8613988919999, 29.637193101000037],
              [-91.84557044199994, 29.628241278000075],
              [-91.81997636599993, 29.60614655200004],
              [-91.78994706899994, 29.594631252000056],
              [-91.78868567599994, 29.59247467700004],
              [-91.75853430899991, 29.586737372000073],
              [-91.7339574859999, 29.58502838700008],
              [-91.72020423099991, 29.581732489000046],
              [-91.71397864499994, 29.57371653900009],
              [-91.72321529899995, 29.558986721000053],
              [-91.75963294199994, 29.541164455000057],
              [-91.77310136599993, 29.530991929000038],
              [-91.77843176999994, 29.51430898600006],
              [-91.7786352199999, 29.500555731000077],
              [-91.7808324859999, 29.493353583000044],
              [-91.78774980399993, 29.49054596600007],
              [-91.8020727199999, 29.490057684000078],
            ],
          ],
          [
            [
              [-85.14175370999993, 29.64085521000004],
              [-85.1504613919999, 29.644476630000042],
              [-85.15807044199994, 29.65265534100007],
              [-85.16510982999995, 29.661932684000078],
              [-85.17186438699991, 29.668850002000056],
              [-85.18228105399993, 29.673976955000057],
              [-85.20230058499993, 29.680975653000075],
              [-85.21279863199993, 29.688706773000035],
              [-85.17153886599993, 29.683254299000055],
              [-85.15306555899991, 29.68463776200008],
              [-85.13829505099994, 29.69550202000005],
              [-85.11367753799993, 29.691961981000077],
              [-85.10045325399994, 29.688055731000077],
              [-85.08775794199994, 29.686835028000075],
              [-85.08608964799993, 29.68573639500005],
              [-85.08364824099993, 29.675034898000035],
              [-85.08926347599993, 29.67015208500004],
              [-85.09581458199995, 29.66242096600007],
              [-85.10130774599992, 29.653265692000048],
              [-85.1035863919999, 29.64398834800005],
              [-85.1087133449999, 29.634019273000035],
              [-85.12035071499992, 29.633978583000044],
              [-85.14175370999993, 29.64085521000004],
            ],
          ],
          [
            [
              [-84.73737545499995, 29.736476955000057],
              [-84.72411048099991, 29.740301825000074],
              [-84.70523027299993, 29.75849030200004],
              [-84.6926977199999, 29.76439036700009],
              [-84.6926977199999, 29.756984768000052],
              [-84.69835364499994, 29.75458405200004],
              [-84.70661373599995, 29.74803294500009],
              [-84.7063695949999, 29.743963934000078],
              [-84.72891191299993, 29.73582591400009],
              [-84.78823808499993, 29.69550202000005],
              [-84.88784745999993, 29.657945054000038],
              [-84.90876217399995, 29.64248281500005],
              [-84.96947180899991, 29.611761786000045],
              [-84.99087480399993, 29.60614655200004],
              [-85.04918372299994, 29.605861721000053],
              [-85.07127844999991, 29.611761786000045],
              [-85.09732011599993, 29.62726471600007],
              [-85.08120683499993, 29.623968817000048],
              [-85.0540258449999, 29.609442450000074],
              [-85.03156490799995, 29.61090729400007],
              [-84.98745683499993, 29.620428778000075],
              [-84.77456620999993, 29.709784247000073],
              [-84.77131100199995, 29.713812567000048],
              [-84.77090410099993, 29.71832916900007],
              [-84.76817786399994, 29.721909898000035],
              [-84.7578832669999, 29.723456122000073],
              [-84.74998938699991, 29.725490627000056],
              [-84.74559485599991, 29.72996653900009],
              [-84.7422582669999, 29.734442450000074],
              [-84.73737545499995, 29.736476955000057],
            ],
          ],
          [
            [
              [-89.45518958199995, 29.79169342700004],
              [-89.44131425699993, 29.78461334800005],
              [-89.43521074099993, 29.772284247000073],
              [-89.43211829299992, 29.757635809000078],
              [-89.42731686099995, 29.743963934000078],
              [-89.4402563139999, 29.748480536000045],
              [-89.44741777299993, 29.75779857000009],
              [-89.45238196499992, 29.76703522300005],
              [-89.45860755099994, 29.771226304000038],
              [-89.46690833199995, 29.766424872000073],
              [-89.47671464799993, 29.74371979400007],
              [-89.48997962099992, 29.736476955000057],
              [-89.49404863199993, 29.77879466400009],
              [-89.49058997299994, 29.793768622000073],
              [-89.47569739499994, 29.80536530200004],
              [-89.46336829299992, 29.798895575000074],
              [-89.45860755099994, 29.795396226000037],
              [-89.45518958199995, 29.79169342700004],
            ],
          ],
          [
            [
              [-89.30435136599993, 29.80536530200004],
              [-89.29360917899993, 29.807114976000037],
              [-89.28376217399995, 29.811021226000037],
              [-89.27717037699995, 29.81207916900007],
              [-89.27647864499994, 29.80536530200004],
              [-89.29067949099993, 29.771226304000038],
              [-89.33702551999994, 29.806626695000034],
              [-89.33543860599991, 29.812201239000046],
              [-89.30435136599993, 29.80536530200004],
            ],
          ],
          [
            [
              [-84.61701412699995, 29.80536530200004],
              [-84.59341386599993, 29.81854889500005],
              [-84.58360755099994, 29.82184479400007],
              [-84.57640540299991, 29.81976959800005],
              [-84.58633378799993, 29.799953518000052],
              [-84.6087133449999, 29.78925202000005],
              [-84.66470292899993, 29.77871328300006],
              [-84.65684973899994, 29.787054755000042],
              [-84.61701412699995, 29.80536530200004],
            ],
          ],
          [
            [
              [-89.23436438699991, 29.948431708000044],
              [-89.23875891799992, 29.941351630000042],
              [-89.23884029899995, 29.93626536700009],
              [-89.23550370999993, 29.931626695000034],
              [-89.24058997299994, 29.929348049000055],
              [-89.25527910099993, 29.929348049000055],
              [-89.27407792899993, 29.926336981000077],
              [-89.28482011599993, 29.923488674000055],
              [-89.29393469999991, 29.920070705000057],
              [-89.29548092399995, 29.924627997000073],
              [-89.27904212099992, 29.937201239000046],
              [-89.2610570949999, 29.943345445000034],
              [-89.23436438699991, 29.948431708000044],
            ],
          ],
          [
            [
              [-89.27293860599991, 29.982082424000055],
              [-89.28062903599994, 29.965765692000048],
              [-89.29580644399994, 29.942206122000073],
              [-89.30410722599993, 29.93235911700009],
              [-89.32258053299995, 29.917181708000044],
              [-89.32787024599992, 29.91592031500005],
              [-89.31773841099994, 29.92609284100007],
              [-89.30943762899994, 29.93650950700004],
              [-89.30435136599993, 29.94599030200004],
              [-89.29381262899994, 29.962103583000044],
              [-89.27806555899991, 29.982123114000046],
              [-89.27293860599991, 29.982082424000055],
            ],
          ],
          [
            [
              [-88.87242591099994, 30.058661200000074],
              [-88.85045325399994, 30.046820380000042],
              [-88.84007727799991, 30.025458075000074],
              [-88.83214270699995, 30.00185781500005],
              [-88.81777910099993, 29.983547268000052],
              [-88.81094316299993, 29.915228583000044],
              [-88.82103430899991, 29.83266836100006],
              [-88.82957923099991, 29.810288804000038],
              [-88.85456295499995, 29.769191799000055],
              [-88.85338294199994, 29.774603583000044],
              [-88.8535863919999, 29.780218817000048],
              [-88.85545813699991, 29.785956122000073],
              [-88.85936438699991, 29.79169342700004],
              [-88.82994544199994, 29.843410549000055],
              [-88.82396399599992, 29.860663153000075],
              [-88.82335364499994, 29.912990627000056],
              [-88.82396399599992, 29.928900458000044],
              [-88.81777910099993, 29.93512604400007],
              [-88.83214270699995, 29.96234772300005],
              [-88.83625240799995, 29.97842031500005],
              [-88.83141028599994, 29.98969147300005],
              [-88.83824622299994, 29.997219143000052],
              [-88.84801184799994, 30.03310781500005],
              [-88.85757402299993, 30.048041083000044],
              [-88.87242591099994, 30.058661200000074],
            ],
          ],
          [
            [
              [-89.43301347599993, 30.145697333000044],
              [-89.42642167899993, 30.148382880000042],
              [-89.42491614499994, 30.142564195000034],
              [-89.43126380099994, 30.133368231000077],
              [-89.43936113199993, 30.136542059000078],
              [-89.43301347599993, 30.145697333000044],
            ],
          ],
          [
            [
              [-89.18834387899994, 30.079738674000055],
              [-89.18740800699993, 30.06321849200009],
              [-89.19176184799994, 30.04913971600007],
              [-89.20116126199991, 30.041571356000077],
              [-89.2156469389999, 30.044989325000074],
              [-89.22207597599993, 30.033758856000077],
              [-89.22887122299994, 30.035956122000073],
              [-89.2429906889999, 30.052435614000046],
              [-89.24600175699993, 30.057114976000037],
              [-89.24889075399994, 30.06403229400007],
              [-89.25304114499994, 30.070257880000042],
              [-89.26036536399994, 30.07290273600006],
              [-89.26724199099993, 30.07062409100007],
              [-89.27257239499994, 30.065741278000075],
              [-89.27578691299993, 30.06085846600007],
              [-89.27647864499994, 30.058661200000074],
              [-89.28384355399993, 30.059515692000048],
              [-89.28823808499993, 30.06199778900009],
              [-89.29116777299993, 30.064846096000053],
              [-89.29442298099991, 30.066066799000055],
              [-89.30125891799992, 30.06395091400009],
              [-89.30699622299994, 30.05927155200004],
              [-89.31069902299993, 30.05459219000005],
              [-89.3118383449999, 30.052435614000046],
              [-89.3321020169999, 30.048976955000057],
              [-89.33926347599993, 30.052679755000042],
              [-89.34532630099994, 30.066066799000055],
              [-89.33348548099991, 30.067572333000044],
              [-89.31993567599994, 30.07094961100006],
              [-89.30894934799994, 30.07607656500005],
              [-89.30435136599993, 30.083156643000052],
              [-89.29771887899994, 30.083970445000034],
              [-89.28490149599992, 30.083970445000034],
              [-89.2766820949999, 30.089504299000055],
              [-89.28392493399991, 30.107082424000055],
              [-89.26862545499995, 30.11155833500004],
              [-89.25446529899995, 30.117987372000073],
              [-89.2293188139999, 30.13434479400007],
              [-89.20986894399994, 30.154771226000037],
              [-89.19640051999994, 30.164984442000048],
              [-89.18081620999993, 30.168524481000077],
              [-89.18081620999993, 30.16168854400007],
              [-89.19440670499995, 30.15525950700004],
              [-89.20714270699995, 30.146429755000042],
              [-89.23546301999994, 30.12067291900007],
              [-89.24990800699993, 30.101996161000045],
              [-89.23619544199994, 30.093491929000038],
              [-89.21861731699994, 30.086737372000073],
              [-89.22183183499993, 30.07290273600006],
              [-89.21654212099992, 30.06321849200009],
              [-89.2156469389999, 30.058661200000074],
              [-89.20811926999994, 30.06317780200004],
              [-89.20221920499995, 30.06785716400009],
              [-89.19766191299993, 30.073187567000048],
              [-89.19448808499993, 30.079738674000055],
              [-89.18834387899994, 30.079738674000055],
            ],
          ],
          [
            [
              [-88.94078528599994, 30.21751536700009],
              [-88.92784583199995, 30.217596747000073],
              [-88.94273841099994, 30.213812567000048],
              [-88.96930904899995, 30.210638739000046],
              [-88.96735592399995, 30.21430084800005],
              [-88.94078528599994, 30.21751536700009],
            ],
          ],
          [
            [
              [-88.50304114499994, 30.21625397300005],
              [-88.50304114499994, 30.223781643000052],
              [-88.42735755099994, 30.21625397300005],
              [-88.43419348899994, 30.209418036000045],
              [-88.46971594999991, 30.21084219000005],
              [-88.50304114499994, 30.21625397300005],
            ],
          ],
          [
            [
              [-89.05797278599994, 30.257798570000034],
              [-89.05748450399994, 30.25267161700009],
              [-89.06297766799992, 30.249741929000038],
              [-89.06554114499994, 30.246975002000056],
              [-89.06480872299994, 30.236761786000045],
              [-89.06818600199995, 30.225816148000035],
              [-89.08462480399993, 30.195786851000037],
              [-89.08946692599994, 30.196600653000075],
              [-89.09251868399991, 30.197658596000053],
              [-89.09528561099995, 30.19953034100007],
              [-89.0989477199999, 30.203273830000057],
              [-89.09483801999994, 30.20612213700008],
              [-89.08950761599993, 30.21198151200008],
              [-89.08462480399993, 30.21625397300005],
              [-89.09215247299994, 30.223781643000052],
              [-89.0989477199999, 30.21625397300005],
              [-89.10798092399995, 30.227118231000077],
              [-89.12140865799995, 30.230861721000053],
              [-89.15355383999992, 30.22992584800005],
              [-89.15355383999992, 30.236761786000045],
              [-89.10130774599992, 30.23505280200004],
              [-89.07701575399994, 30.240790106000077],
              [-89.06480872299994, 30.257798570000034],
              [-89.05797278599994, 30.257798570000034],
            ],
          ],
          [
            [
              [-88.64305579299992, 30.24046458500004],
              [-88.62120520699995, 30.23151276200008],
              [-88.55968176999994, 30.23114655200004],
              [-88.5379125639999, 30.224432684000078],
              [-88.54645748599995, 30.220363674000055],
              [-88.55626380099994, 30.216742255000042],
              [-88.75633704299992, 30.244208075000074],
              [-88.75633704299992, 30.250433661000045],
              [-88.73131262899994, 30.25722890800006],
              [-88.69782467399995, 30.257879950000074],
              [-88.66519120999993, 30.252386786000045],
              [-88.64305579299992, 30.24046458500004],
            ],
          ],
          [
            [
              [-88.0711156889999, 30.250433661000045],
              [-88.08409583199995, 30.245917059000078],
              [-88.09097245999993, 30.244696356000077],
              [-88.31126868399991, 30.236761786000045],
              [-88.29698645699995, 30.244696356000077],
              [-88.20482337099992, 30.257798570000034],
              [-88.14964758999992, 30.257798570000034],
              [-88.13463294199994, 30.25999583500004],
              [-88.12531490799995, 30.26508209800005],
              [-88.11803137899994, 30.271144924000055],
              [-88.10903886599993, 30.27610911700009],
              [-88.0711156889999, 30.257798570000034],
              [-88.0711156889999, 30.250433661000045],
            ],
          ],
          [
            [
              [-86.69375566299993, 30.40810781500005],
              [-86.65925045499995, 30.415838934000078],
              [-86.61709550699993, 30.41201406500005],
              [-86.52183997299994, 30.401271877000056],
              [-86.53014075399994, 30.396877346000053],
              [-86.54027258999992, 30.395412502000056],
              [-86.55138098899994, 30.39679596600007],
              [-86.56235788303847, 30.401109912618523],
              [-86.56278944821, 30.401264716434135],
              [-86.56273352799991, 30.401190497000073],
              [-86.56248938699991, 30.40110911700009],
              [-86.90184485599991, 30.363613186000066],
              [-87.24120032499991, 30.326117255000042],
              [-87.29649817599994, 30.33234284100007],
              [-87.27822831899994, 30.33812083500004],
              [-87.19713294199994, 30.339789130000042],
              [-87.08116614499994, 30.356634833000044],
              [-87.0227758449999, 30.37457916900007],
              [-86.95173092399995, 30.373928127000056],
              [-86.92711341099994, 30.38076406500005],
              [-86.91820227799991, 30.383978583000044],
              [-86.8906957669999, 30.393133856000077],
              [-86.87531490799995, 30.395005601000037],
              [-86.83141028599994, 30.39362213700008],
              [-86.72402910099993, 30.406236070000034],
              [-86.70059160099993, 30.414943752000056],
              [-86.69375566299993, 30.40810781500005],
            ],
          ],
          [
            [
              [-81.47874915299991, 30.805975653000075],
              [-81.47801673099991, 30.831691799000055],
              [-81.47874915299991, 30.84007396000004],
              [-81.48159745999993, 30.848863023000035],
              [-81.49046790299991, 30.868109442000048],
              [-81.49242102799991, 30.874212958000044],
              [-81.48216712099992, 30.904364325000074],
              [-81.43268795499995, 30.938788153000075],
              [-81.42414303299995, 30.970404364000046],
              [-81.4173070949999, 30.970404364000046],
              [-81.41706295499995, 30.94989655200004],
              [-81.41942298099991, 30.92527903900009],
              [-81.42829342399995, 30.892564195000034],
              [-81.43195553299995, 30.863104559000078],
              [-81.44155839799993, 30.827378648000035],
              [-81.45702063699991, 30.799750067000048],
              [-81.45714270699995, 30.78457265800006],
              [-81.45079505099994, 30.754461981000077],
              [-81.45421301999994, 30.734849351000037],
              [-81.46165930899991, 30.725816148000035],
              [-81.46914628799993, 30.729315497000073],
              [-81.47874915299991, 30.805975653000075],
            ],
          ],
          [
            [
              [-118.3587663919999, 32.82782849700004],
              [-118.35094153599994, 32.81867096600007],
              [-118.3635961579999, 32.816839911000045],
              [-118.38418070099993, 32.82439135700008],
              [-118.40148337999995, 32.81999013800004],
              [-118.40416419199994, 32.81240469000005],
              [-118.41136633999992, 32.809800523000035],
              [-118.4250110879999, 32.80241614000005],
              [-118.42904342299994, 32.802872774000036],
              [-118.4383673879999, 32.81692165800007],
              [-118.44991504599994, 32.818819046000044],
              [-118.47426315399991, 32.838121723000086],
              [-118.4899012489999, 32.84490356400005],
              [-118.49914971899994, 32.85062791900009],
              [-118.50677171099994, 32.86524926000004],
              [-118.50859538399993, 32.876468773000056],
              [-118.52015155999993, 32.88546686900008],
              [-118.53123481199992, 32.903407695000055],
              [-118.53759317099991, 32.905751498000086],
              [-118.54691773899992, 32.91875001400007],
              [-118.54818761999991, 32.93719082400008],
              [-118.5517018509999, 32.945411119000084],
              [-118.55868924599991, 32.95310841300005],
              [-118.57554647899991, 32.96900434100007],
              [-118.57990475199995, 32.98777903900009],
              [-118.58675346699994, 33.00332965800004],
              [-118.59375944499993, 33.013946066000074],
              [-118.60824456899991, 33.014376784000035],
              [-118.60721528699992, 33.03085635200006],
              [-118.59569063399994, 33.035281301000055],
              [-118.5898574879999, 33.02996711600008],
              [-118.57716484499991, 33.032455749000064],
              [-118.56436711299995, 33.02376211100005],
              [-118.56546545899994, 33.018407652000064],
              [-118.56018012599992, 33.00633069700007],
              [-118.54978729899995, 33.001576939000074],
              [-118.54504930999991, 32.98561292900007],
              [-118.51602297599993, 32.95816231800006],
              [-118.50442405699994, 32.94132922400007],
              [-118.48356260199989, 32.92159994200006],
              [-118.4667389409999, 32.914819848000036],
              [-118.45066160199991, 32.89762455500005],
              [-118.40710968799993, 32.864257863000034],
              [-118.38198355999992, 32.84766240200008],
              [-118.3587663919999, 32.82782849700004],
            ],
          ],
          [
            [
              [-79.34044348899994, 33.060248114000046],
              [-79.34162350199995, 33.04523346600007],
              [-79.36095130099994, 33.00568268400008],
              [-79.36839758999992, 33.00568268400008],
              [-79.36807206899994, 33.02488841400009],
              [-79.36310787699995, 33.043036200000074],
              [-79.35309811099995, 33.05756256700005],
              [-79.33775794199994, 33.06614817900004],
              [-79.33556067599994, 33.06468333500004],
              [-79.33511308499993, 33.06317780200004],
              [-79.33657792899993, 33.061712958000044],
              [-79.34044348899994, 33.060248114000046],
            ],
          ],
          [
            [
              [-119.4886044669999, 33.267188126000065],
              [-119.48253091599992, 33.26360334700007],
              [-119.46220396799993, 33.256544526000084],
              [-119.44339065499992, 33.24216971000004],
              [-119.43446258299991, 33.231317053000055],
              [-119.4343369749999, 33.22401178600006],
              [-119.43918244799994, 33.21984398400008],
              [-119.4468126779999, 33.21929584500009],
              [-119.45658263299993, 33.21598048700008],
              [-119.46859456499993, 33.216292155000076],
              [-119.47294205899993, 33.21532426300007],
              [-119.48718059899994, 33.21788618000005],
              [-119.49101544099994, 33.21875213000004],
              [-119.49536509099994, 33.217327140000066],
              [-119.50251455299991, 33.22089116900008],
              [-119.5150999889999, 33.22210224200006],
              [-119.52338228399992, 33.22793284200009],
              [-119.54418833299991, 33.231319744000075],
              [-119.56690933999994, 33.247472164000044],
              [-119.5670036539999, 33.25249603000009],
              [-119.57422547199991, 33.25879713000006],
              [-119.57269858099994, 33.26475566400006],
              [-119.5789260439999, 33.276096675000076],
              [-119.5778941289999, 33.27930804400006],
              [-119.56244784599994, 33.27174124000004],
              [-119.55058211199992, 33.28011705700004],
              [-119.5428864239999, 33.28017829500004],
              [-119.53210348999994, 33.28627825800004],
              [-119.5133399899999, 33.27645666900008],
              [-119.49784820799994, 33.266124827000056],
              [-119.4886044669999, 33.267188126000065],
            ],
          ],
          [
            [
              [-118.51565411899992, 33.42300528000004],
              [-118.52078889799992, 33.42751467100004],
              [-118.53067300299995, 33.42858090300007],
              [-118.53508478499992, 33.42931182500007],
              [-118.54298821899994, 33.43292277100005],
              [-118.55088594699993, 33.433253662000084],
              [-118.55922627799993, 33.43285399200005],
              [-118.56673559899991, 33.43685601400006],
              [-118.57285073199989, 33.437906618000056],
              [-118.57373027699992, 33.440455082000085],
              [-118.57411722599994, 33.44661376700009],
              [-118.57904909799993, 33.44847636500009],
              [-118.58438250599994, 33.45286411400008],
              [-118.5896070259999, 33.460095565000074],
              [-118.5958811989999, 33.466705629000046],
              [-118.60211622299994, 33.47147008300004],
              [-118.6039133679999, 33.47658899900006],
              [-118.59686781099992, 33.476973211000086],
              [-118.58677851199991, 33.47557135900007],
              [-118.57800270799993, 33.47635080500004],
              [-118.56962487699991, 33.47453655400005],
              [-118.5634358989999, 33.473426576000065],
              [-118.5459375399999, 33.47502876200008],
              [-118.54067460499994, 33.47578316600004],
              [-118.5358608379999, 33.47727816200006],
              [-118.53010272599994, 33.469976175000056],
              [-118.52437788599991, 33.46671487800006],
              [-118.51774751599993, 33.45978245200007],
              [-118.50805799699992, 33.45468097300005],
              [-118.49970617399993, 33.451812500000074],
              [-118.4996827949999, 33.448153697000066],
              [-118.49877032099994, 33.44266571300005],
              [-118.49306057799993, 33.44158919800009],
              [-118.49044210499994, 33.44342164500006],
              [-118.48563653699995, 33.44487659300006],
              [-118.48432964099993, 33.44709357600004],
              [-118.47690071499994, 33.447445403000074],
              [-118.47249928899993, 33.44196389800004],
              [-118.4680757839999, 33.44240871100004],
              [-118.4628236929999, 33.43984386600005],
              [-118.45754044199992, 33.43511020400007],
              [-118.45005422299994, 33.43186199300004],
              [-118.44479115899992, 33.428584013000034],
              [-118.43730779599991, 33.429362591000086],
              [-118.4338532139999, 33.42715536500009],
              [-118.42944346299993, 33.42828272600008],
              [-118.42111987099992, 33.42794762600005],
              [-118.39444917799995, 33.41596276300004],
              [-118.38909845599994, 33.41746052800005],
              [-118.38259897699993, 33.41052629700005],
              [-118.37937482699994, 33.410182864000035],
              [-118.3740278009999, 33.41020677200004],
              [-118.3692064839999, 33.40839266200004],
              [-118.36830277299993, 33.40510155100009],
              [-118.36690751399993, 33.39888192800004],
              [-118.36958062699995, 33.39484974000004],
              [-118.3682894609999, 33.389002583000035],
              [-118.36337639499993, 33.38827756100005],
              [-118.3551311519999, 33.37734631900008],
              [-118.34362819599994, 33.366762193000056],
              [-118.3317573139999, 33.359112834000086],
              [-118.3265143399999, 33.348901252000076],
              [-118.32634365699994, 33.34460756800007],
              [-118.32276464099994, 33.34313241700005],
              [-118.31725463899994, 33.34342923600008],
              [-118.30866539599992, 33.33642000100008],
              [-118.30434444999992, 33.319268941000075],
              [-118.30785433299991, 33.31872443900005],
              [-118.31058362999994, 33.31423148400006],
              [-118.3043401139999, 33.30904002300008],
              [-118.31212783799992, 33.305542270000046],
              [-118.31470902199993, 33.30162914500005],
              [-118.3260349069999, 33.29863279700004],
              [-118.3460167319999, 33.30523135900006],
              [-118.35494658399995, 33.312944618000074],
              [-118.3640032479999, 33.315047967000055],
              [-118.37479615899991, 33.31951177900004],
              [-118.39609602799993, 33.32010024300007],
              [-118.4104656849999, 33.320371925000074],
              [-118.42266426299994, 33.31663417400006],
              [-118.44383480599993, 33.31882671300008],
              [-118.46358558599991, 33.323514310000064],
              [-118.4727712699999, 33.33294280600006],
              [-118.4842439439999, 33.34607455200006],
              [-118.48958155899993, 33.35849893900007],
              [-118.48439996999991, 33.36841383600006],
              [-118.48616495699991, 33.37242775400006],
              [-118.48007171099994, 33.38014323300007],
              [-118.47487230999991, 33.382370955000056],
              [-118.4793242369999, 33.38675027600004],
              [-118.4872321769999, 33.402811890000066],
              [-118.48452331699991, 33.40538111300009],
              [-118.48714958099993, 33.40830412200006],
              [-118.48634580099991, 33.41596784400008],
              [-118.4907346409999, 33.41962539900004],
              [-118.4977563789999, 33.42143085400005],
              [-118.50390751399993, 33.42322490200007],
              [-118.51049625099989, 33.42393812500006],
              [-118.51565411899992, 33.42300528000004],
            ],
          ],
          [
            [
              [-77.96996008999992, 33.889553127000056],
              [-77.96328691299993, 33.89447663000004],
              [-77.94204667899993, 33.91681549700007],
              [-77.96239173099991, 33.85687897300005],
              [-77.96996008999992, 33.84796784100007],
              [-77.98131262899994, 33.85382721600007],
              [-77.99771074099993, 33.85895416900007],
              [-78.01227779899995, 33.86562734600005],
              [-78.01781165299991, 33.875881252000056],
              [-78.01008053299995, 33.89203522300005],
              [-77.99522864499994, 33.899318752000056],
              [-77.97972571499992, 33.89817942900004],
              [-77.96996008999992, 33.889553127000056],
            ],
          ],
          [
            [
              [-120.04413872999993, 34.03727270500008],
              [-120.04232451999991, 34.028081162000035],
              [-120.04993767399992, 34.01560537100005],
              [-120.04700351399993, 34.00381258200008],
              [-120.0339685319999, 33.98957719500004],
              [-120.0083373889999, 33.97902667000005],
              [-119.98040727299991, 33.98346712400007],
              [-119.97878144899994, 33.959370996000075],
              [-119.97069278499993, 33.95293107400005],
              [-119.96883015999992, 33.94111657900004],
              [-119.99962846799991, 33.94147922800005],
              [-120.01894977299992, 33.93415329900006],
              [-120.04968837599989, 33.91478129800004],
              [-120.07129052499994, 33.91178508400009],
              [-120.08062679299991, 33.906362829000045],
              [-120.10129847299993, 33.90688890100006],
              [-120.10901104399994, 33.899737962000074],
              [-120.10989116399992, 33.89314015100007],
              [-120.12420565499991, 33.89508637700004],
              [-120.13340063499993, 33.90282440800007],
              [-120.1526355009999, 33.91168770300004],
              [-120.17560998499994, 33.922231553000074],
              [-120.18446748399992, 33.937422165000044],
              [-120.18942804599993, 33.94479976300005],
              [-120.19807957699993, 33.95210149500008],
              [-120.21024398799995, 33.97248773900009],
              [-120.21935946799994, 33.976723149000065],
              [-120.22549272399993, 33.98845845800008],
              [-120.23718143299993, 33.99171331300005],
              [-120.24851670499993, 34.00112715800009],
              [-120.23656499099991, 34.00880322000006],
              [-120.217616, 34.010541155000055],
              [-120.2010553419999, 34.00469562200004],
              [-120.18581999499992, 34.00891818600007],
              [-120.17096285999992, 34.007413919000044],
              [-120.15848553599994, 34.01595182900007],
              [-120.14548093499991, 34.02449689800005],
              [-120.13609778599994, 34.024725653000075],
              [-120.09666530399994, 34.01786067000006],
              [-120.0724775679999, 34.02489454800008],
              [-120.05787483599994, 34.03778486300007],
              [-120.04413872999993, 34.03727270500008],
            ],
          ],
          [
            [
              [-120.34458184199991, 34.04649222000006],
              [-120.33576610699993, 34.04870292600009],
              [-120.3303011409999, 34.04717481300008],
              [-120.31832577499989, 34.040055005000056],
              [-120.3113060099999, 34.03447655500008],
              [-120.30655653399992, 34.02639704400008],
              [-120.3083012699999, 34.01820039000006],
              [-120.3296123419999, 34.01862921800006],
              [-120.35123212299993, 34.01902210800006],
              [-120.36043923999989, 34.01475743300006],
              [-120.37382453899994, 34.01776439200006],
              [-120.3823820589999, 34.024128673000064],
              [-120.39277421299994, 34.02596575100006],
              [-120.40622572799992, 34.03141492300006],
              [-120.41519401099993, 34.03246878400006],
              [-120.42376955399993, 34.024945950000074],
              [-120.43819694199993, 34.02955978300008],
              [-120.44608813399992, 34.03021664100004],
              [-120.44920267599991, 34.03586596300005],
              [-120.43797038499991, 34.038538274000075],
              [-120.41527371399991, 34.05449606500008],
              [-120.40340594899993, 34.05145681300007],
              [-120.39404270099993, 34.05328521800004],
              [-120.3800094959999, 34.060897681000085],
              [-120.36897902899995, 34.07131132600006],
              [-120.36906802899995, 34.076225100000045],
              [-120.36221269399994, 34.07168203300006],
              [-120.35896617299994, 34.06497236100006],
              [-120.35626212699992, 34.05851053300006],
              [-120.36069036099991, 34.05309752900007],
              [-120.3560177739999, 34.04708095600006],
              [-120.34458184199991, 34.04649222000006],
            ],
          ],
          [
            [
              [-119.52942605999993, 34.02524840600006],
              [-119.54266634599992, 34.02016434300009],
              [-119.54452733599993, 34.01361724100008],
              [-119.54783312899991, 34.00384712500005],
              [-119.55952121899992, 33.99430864900006],
              [-119.58032586699994, 33.993586235000066],
              [-119.58949754799994, 33.98900558300005],
              [-119.62482094399991, 33.98731555300009],
              [-119.64545736799994, 33.98621247500006],
              [-119.6576825969999, 33.98606177600004],
              [-119.6670481509999, 33.98305018000008],
              [-119.6732781469999, 33.97809685800007],
              [-119.6821160849999, 33.97633364400008],
              [-119.68494514199995, 33.973874143000046],
              [-119.70017402699995, 33.968738494000036],
              [-119.70647854499992, 33.96867457900004],
              [-119.71269085599994, 33.961674293000044],
              [-119.7195120419999, 33.959134293000034],
              [-119.74221328099992, 33.96244951400007],
              [-119.7534684009999, 33.962301480000065],
              [-119.75923919099989, 33.95734169900004],
              [-119.77204750099992, 33.959598317000086],
              [-119.78825117699989, 33.959765133000076],
              [-119.80156551199991, 33.96321112900006],
              [-119.81720483499993, 33.959337927000036],
              [-119.82519739499992, 33.96653235400004],
              [-119.84050405199991, 33.96957415300005],
              [-119.85076733199992, 33.967383031000054],
              [-119.86671138399993, 33.978934276000075],
              [-119.87410932099993, 33.980046565000066],
              [-119.88126199699991, 33.99134937100007],
              [-119.88437057399995, 34.00183836300005],
              [-119.88706871099993, 34.008776658000045],
              [-119.87708212099994, 34.02438676200006],
              [-119.8772218019999, 34.032482766000044],
              [-119.8862544989999, 34.03810874900006],
              [-119.8991794669999, 34.04960132800005],
              [-119.91356360599991, 34.055894273000035],
              [-119.9191231669999, 34.057536940000034],
              [-119.9215497809999, 34.05467935000007],
              [-119.92846837699994, 34.05580020300005],
              [-119.93301909299993, 34.06022914600004],
              [-119.92429204599989, 34.066858478000086],
              [-119.92101978199992, 34.07344613500004],
              [-119.91722485799994, 34.078820327000074],
              [-119.90462789399993, 34.07430180300008],
              [-119.88704397599992, 34.074300968000045],
              [-119.85641193299995, 34.070551942000066],
              [-119.8351598669999, 34.06358567600006],
              [-119.82437089799993, 34.05508047100005],
              [-119.80699622299994, 34.051947333000044],
              [-119.78774018799993, 34.056188569000085],
              [-119.77785356099992, 34.05586316300008],
              [-119.75926250499992, 34.055808821000085],
              [-119.75283363499994, 34.05228163600009],
              [-119.74429277299993, 34.05215078300006],
              [-119.7370054559999, 34.04643023600005],
              [-119.73214747299994, 34.048557464000055],
              [-119.7118359349999, 34.042254864000085],
              [-119.70379551699995, 34.034561746000065],
              [-119.69238191699992, 34.02822374900006],
              [-119.6853598209999, 34.01987128900004],
              [-119.67702267999994, 34.02075057500008],
              [-119.66663679499993, 34.01676488700008],
              [-119.65439772699995, 34.019084734000046],
              [-119.63318266599993, 34.01363500700006],
              [-119.61563911799993, 34.019543137000085],
              [-119.60793080699995, 34.02947425800005],
              [-119.61007932599995, 34.03964593900008],
              [-119.58864085099992, 34.049712044000046],
              [-119.57540772099992, 34.05067721000006],
              [-119.56493079299992, 34.05532461100006],
              [-119.5325218829999, 34.04142391000005],
              [-119.5214942259999, 34.03429132900004],
              [-119.52942605999993, 34.02524840600006],
            ],
          ],
          [
            [
              [-77.87441972599993, 34.08812083500004],
              [-77.86400305899991, 34.11367422100005],
              [-77.85655676999994, 34.142645575000074],
              [-77.84422766799992, 34.16665273600006],
              [-77.81920325399994, 34.17747630400004],
              [-77.81871497299994, 34.17267487200007],
              [-77.82062740799995, 34.171576239000046],
              [-77.82335364499994, 34.171861070000034],
              [-77.82599850199995, 34.17064036700009],
              [-77.84593665299991, 34.12376536700009],
              [-77.86017818899995, 34.10040924700007],
              [-77.87441972599993, 34.08812083500004],
            ],
          ],
          [
            [
              [-77.43187415299991, 34.499660549000055],
              [-77.41372636599993, 34.503973700000074],
              [-77.37413489499994, 34.523138739000046],
              [-77.35301673099991, 34.52757396000004],
              [-77.35252844999991, 34.52228424700007],
              [-77.35440019399994, 34.521185614000046],
              [-77.35741126199991, 34.52138906500005],
              [-77.36046301999994, 34.52008698100008],
              [-77.38634192599994, 34.50169505400004],
              [-77.46776282499991, 34.46539948100008],
              [-77.50072180899991, 34.458685614000046],
              [-77.51455644399994, 34.45376211100006],
              [-77.61778723899994, 34.37763092700004],
              [-77.63418535099993, 34.362494208000044],
              [-77.61473548099991, 34.39545319200005],
              [-77.57872473899994, 34.42536041900007],
              [-77.44981848899994, 34.49567291900007],
              [-77.43187415299991, 34.499660549000055],
            ],
          ],
          [
            [
              [-76.56533769399994, 34.67096588700008],
              [-76.55479895699995, 34.66421133000006],
              [-76.54214433499993, 34.65289948100008],
              [-76.53770911399994, 34.64215729400007],
              [-76.55166581899994, 34.63686758000006],
              [-76.55622311099995, 34.640611070000034],
              [-76.59268144399994, 34.66351959800005],
              [-76.64321855399993, 34.67841217700004],
              [-76.65477454299992, 34.68455638200004],
              [-76.65477454299992, 34.691473700000074],
              [-76.63426673099991, 34.691473700000074],
              [-76.56533769399994, 34.67096588700008],
            ],
          ],
          [
            [
              [-76.89745032499991, 34.69822825700004],
              [-76.73355058499993, 34.71759674700007],
              [-76.68146725199995, 34.705145575000074],
              [-76.68146725199995, 34.69822825700004],
              [-76.80186926999994, 34.705145575000074],
              [-76.82750403599994, 34.70294830900008],
              [-77.09976152299993, 34.64984772300005],
              [-77.08238684799994, 34.66547272300005],
              [-77.05443274599992, 34.67487213700008],
              [-76.89745032499991, 34.69822825700004],
            ],
          ],
          [
            [
              [-76.25625566299993, 34.91364166900007],
              [-76.24950110599991, 34.921861070000034],
              [-76.23395748599995, 34.931708075000074],
              [-76.21597245999993, 34.940334377000056],
              [-76.20225989499994, 34.94472890800006],
              [-76.22276770699995, 34.91742584800005],
              [-76.24966386599993, 34.903225002000056],
              [-76.29987545499995, 34.858587958000044],
              [-76.32209225199995, 34.84906647300005],
              [-76.34040279899995, 34.83844635600008],
              [-76.39598548099991, 34.78758372600004],
              [-76.51964270699995, 34.61579010600008],
              [-76.53062903599994, 34.589056708000044],
              [-76.53921464799993, 34.60822174700007],
              [-76.52505449099993, 34.63784414300005],
              [-76.40778561099995, 34.79441966400009],
              [-76.30467688699991, 34.883246161000045],
              [-76.26231848899994, 34.90672435100004],
              [-76.25625566299993, 34.91364166900007],
            ],
          ],
          [
            [
              [-76.07811438699991, 35.071600653000075],
              [-76.07249915299991, 35.07477448100008],
              [-76.05968176999994, 35.071478583000044],
              [-76.0371801419999, 35.06134674700007],
              [-76.04059811099995, 35.05768463700008],
              [-76.04393469999991, 35.056301174000055],
              [-76.04751542899993, 35.05573151200008],
              [-76.05142167899993, 35.05459219000005],
              [-76.12559973899994, 35.01154205900008],
              [-76.14085852799991, 34.99249909100007],
              [-76.14704342399995, 34.99249909100007],
              [-76.13727779899995, 35.00340403900009],
              [-76.10643469999991, 35.03034088700008],
              [-76.09984290299991, 35.044623114000046],
              [-76.09650631399995, 35.04962799700007],
              [-76.08897864499994, 35.05524323100008],
              [-76.08153235599991, 35.062201239000046],
              [-76.07811438699991, 35.071600653000075],
            ],
          ],
          [
            [
              [-75.98997962099992, 35.12343984600005],
              [-75.96703040299991, 35.11774323100008],
              [-75.93984941299993, 35.12689850500004],
              [-75.88634192599994, 35.15696849200009],
              [-75.7988988919999, 35.18423086100006],
              [-75.77025305899991, 35.19794342700004],
              [-75.77599036399994, 35.190741278000075],
              [-75.78209387899994, 35.18585846600007],
              [-75.79820716099994, 35.17804596600007],
              [-75.81737219999991, 35.16290924700007],
              [-75.90807044199994, 35.13646067900004],
              [-76.01732337099992, 35.07501862200007],
              [-76.00597083199995, 35.085150458000044],
              [-75.99885006399995, 35.09707265800006],
              [-75.98997962099992, 35.12343984600005],
            ],
          ],
          [
            [
              [-75.47606360599991, 35.695379950000074],
              [-75.47354081899994, 35.67487213700008],
              [-75.45494544199994, 35.623114325000074],
              [-75.45181230399993, 35.58250560100004],
              [-75.47057044199994, 35.504787502000056],
              [-75.49083411399994, 35.33641185100004],
              [-75.51561438699991, 35.260199286000045],
              [-75.52538001199991, 35.24396393400008],
              [-75.54377193899995, 35.233303127000056],
              [-75.55370032499991, 35.23200104400007],
              [-75.58531653599994, 35.233303127000056],
              [-75.62315833199995, 35.21906159100007],
              [-75.64443925699993, 35.21576569200005],
              [-75.68219967399995, 35.201239325000074],
              [-75.69831295499995, 35.19794342700004],
              [-75.70400956899994, 35.19594961100006],
              [-75.71751868399991, 35.18691640800006],
              [-75.72557532499991, 35.184881903000075],
              [-75.73574785099993, 35.18768952000005],
              [-75.73338782499991, 35.19403717700004],
              [-75.7246801419999, 35.20091380400004],
              [-75.71568762899994, 35.20538971600007],
              [-75.70596269399994, 35.206244208000044],
              [-75.70156816299993, 35.21002838700008],
              [-75.69896399599992, 35.214829820000034],
              [-75.69456946499992, 35.21906159100007],
              [-75.69302324099993, 35.221991278000075],
              [-75.69237219999991, 35.22687409100007],
              [-75.69033769399994, 35.231350002000056],
              [-75.68496660099993, 35.233303127000056],
              [-75.68195553299995, 35.23151276200008],
              [-75.68106035099993, 35.22801341400009],
              [-75.67979895699995, 35.22524648600006],
              [-75.67536373599995, 35.225816148000035],
              [-75.6126195949999, 35.25259023600006],
              [-75.54312089799993, 35.273098049000055],
              [-75.51634680899991, 35.291001695000034],
              [-75.51707923099991, 35.321478583000044],
              [-75.51089433499993, 35.333685614000046],
              [-75.49876868399991, 35.382879950000074],
              [-75.49437415299991, 35.42047760600008],
              [-75.48452714799993, 35.456691799000055],
              [-75.48224850199995, 35.47907135600008],
              [-75.48363196499992, 35.489935614000046],
              [-75.48875891799992, 35.50922272300005],
              [-75.48912512899994, 35.520697333000044],
              [-75.48525956899994, 35.53204987200007],
              [-75.47166907499991, 35.554348049000055],
              [-75.46861731699994, 35.56509023600006],
              [-75.46934973899994, 35.588771877000056],
              [-75.47581946499992, 35.630113023000035],
              [-75.50096594999991, 35.70331452000005],
              [-75.50275631399995, 35.722723700000074],
              [-75.52000891799992, 35.75665924700007],
              [-75.52611243399991, 35.77570221600007],
              [-75.51707923099991, 35.78074778900009],
              [-75.49950110599991, 35.76748281500005],
              [-75.48668372299994, 35.743801174000055],
              [-75.47874915299991, 35.717230536000045],
              [-75.47606360599991, 35.695379950000074],
            ],
          ],
          [
            [
              [-75.71568762899994, 35.92475006700005],
              [-75.72126217399995, 35.92999909100007],
              [-75.72777258999992, 35.93455638200004],
              [-75.72988847599993, 35.93939850500004],
              [-75.72183183499993, 35.94525788000004],
              [-75.71304277299993, 35.946966864000046],
              [-75.70376542899993, 35.94570547100005],
              [-75.69522050699993, 35.94245026200008],
              [-75.68834387899994, 35.93842194200005],
              [-75.67406165299991, 35.933294989000046],
              [-75.66738847599993, 35.92951080900008],
              [-75.66104081899994, 35.92475006700005],
              [-75.65933183499993, 35.91543203300006],
              [-75.64704342399995, 35.89923737200007],
              [-75.6126195949999, 35.863267320000034],
              [-75.62189693899995, 35.844916083000044],
              [-75.62214107999995, 35.83466217700004],
              [-75.62535559799994, 35.830145575000074],
              [-75.64395097599993, 35.82916901200008],
              [-75.65929114499994, 35.836004950000074],
              [-75.66616777299993, 35.85228099200009],
              [-75.67064368399991, 35.87132396000004],
              [-75.67845618399991, 35.88690827000005],
              [-75.70775305899991, 35.913397528000075],
              [-75.71568762899994, 35.92475006700005],
            ],
          ],
          [
            [
              [-75.65612742099995, 37.46150550100003],
              [-75.66043040099993, 37.443184451000036],
              [-75.68503757199994, 37.414915019000034],
              [-75.7192143119999, 37.368297608000034],
              [-75.7245737689999, 37.373899392000055],
              [-75.70794593799991, 37.39861533100009],
              [-75.68431912199992, 37.436734982000075],
              [-75.67647746699993, 37.45507299500008],
              [-75.67032944699992, 37.462843914000075],
              [-75.65612742099995, 37.46150550100003],
            ],
          ],
          [
            [
              [-75.62198107299992, 37.57111973600007],
              [-75.61339190599995, 37.578002807000075],
              [-75.59980591999994, 37.575130510000065],
              [-75.60219467699994, 37.56240827900007],
              [-75.64253235099994, 37.51139681800004],
              [-75.6595747099999, 37.48297574900005],
              [-75.67061725099995, 37.477057165000076],
              [-75.67437474699994, 37.48583466200006],
              [-75.66219507699992, 37.50446151600005],
              [-75.6439288489999, 37.534846196000046],
              [-75.6342270049999, 37.55835401600007],
              [-75.62198107299992, 37.57111973600007],
            ],
          ],
          [
            [
              [-76.00536477299994, 38.026514029000055],
              [-75.98720732999993, 38.01879612000005],
              [-75.9812909719999, 37.99283625400005],
              [-75.98976847099993, 37.973150901000054],
              [-75.99565052899993, 37.94514658200006],
              [-76.00504931599994, 37.95047152700005],
              [-76.01015300099994, 37.960734322000064],
              [-76.02135902399993, 37.96113966900003],
              [-76.01687025799993, 37.95038143600004],
              [-76.0192800019999, 37.94398581300004],
              [-76.01982312099994, 37.93760442300004],
              [-76.01722617099995, 37.92879434300005],
              [-76.02281804699993, 37.92826020200005],
              [-76.02636789899992, 37.91351525600004],
              [-76.02949590499992, 37.91496244700005],
              [-76.0315451699999, 37.92966381300005],
              [-76.02983174399992, 37.94194189800004],
              [-76.02745345499994, 37.95079047000007],
              [-76.03310258399995, 37.95467135300004],
              [-76.03678647099991, 37.950718316000064],
              [-76.0436132769999, 37.94919218000007],
              [-76.04506463999991, 37.96537037100006],
              [-76.04525466599995, 37.98008777000007],
              [-76.05142167899993, 37.99408600500004],
              [-76.04613196499992, 37.99941640800006],
              [-76.03056423299995, 37.99982701600004],
              [-76.01364889399991, 37.991614997000056],
              [-76.00304114499994, 38.00096263200004],
              [-76.01353919199994, 38.01048411700009],
              [-76.03945878799993, 38.021144924000055],
              [-76.04028530399995, 38.02919468500005],
              [-76.02912839399994, 38.03369669700004],
              [-76.01735392199993, 38.03869281400006],
              [-76.0104640909999, 38.03579972400007],
              [-76.00536477299994, 38.026514029000055],
            ],
          ],
          [
            [
              [-76.03323029799992, 38.148551101000066],
              [-76.0627599579999, 38.15890671500006],
              [-76.08360776299992, 38.16066637300008],
              [-76.07900940199994, 38.182843810000065],
              [-76.06446130299992, 38.19451030600004],
              [-76.04860768499992, 38.200407545000076],
              [-76.0362178119999, 38.189907737000055],
              [-76.02381862399994, 38.178457834000085],
              [-76.0297821879999, 38.16590116900005],
              [-76.02594439399991, 38.15342095800008],
              [-76.03323029799992, 38.148551101000066],
            ],
          ],
          [
            [
              [-75.15330969999991, 38.207017320000034],
              [-75.11436926999994, 38.28021881700005],
              [-75.09870357999995, 38.30263906500005],
              [-75.09243730399993, 38.30263906500005],
              [-75.10269120999993, 38.273138739000046],
              [-75.13866126199991, 38.218817450000074],
              [-75.17119707599994, 38.14828851100009],
              [-75.18969471899993, 38.08977971400009],
              [-75.22887122299994, 38.04751211100006],
              [-75.23407955599993, 38.03860097900008],
              [-75.31358098599992, 37.919094879000056],
              [-75.32603919199994, 37.892279364000046],
              [-75.34214250799994, 37.875660905000075],
              [-75.35227792499995, 37.86762241900004],
              [-75.36541093599993, 37.862877446000084],
              [-75.37853520999994, 37.85577259900003],
              [-75.3929134039999, 37.86469927200005],
              [-75.40012654299994, 37.874113272000045],
              [-75.38877843199992, 37.878387484000086],
              [-75.3690182979999, 37.869472149000046],
              [-75.35827561299993, 37.874211754000044],
              [-75.34995672999992, 37.889319871000055],
              [-75.36372687599993, 37.894950624000046],
              [-75.37449969499994, 37.89775756900008],
              [-75.36796543999992, 37.909090647000085],
              [-75.35008704299992, 37.91303131700005],
              [-75.33910071499992, 37.91620514500005],
              [-75.33047441299993, 37.92243073100008],
              [-75.32526607999995, 37.93268463700008],
              [-75.31826738199993, 37.94037506700005],
              [-75.3047582669999, 37.97361888200004],
              [-75.29759680899991, 37.98493073100008],
              [-75.27855383999992, 38.00763580900008],
              [-75.25446529899995, 38.030910549000055],
              [-75.25064042899993, 38.03689199400009],
              [-75.22964433499993, 38.06989166900007],
              [-75.19981848899994, 38.10382721600007],
              [-75.19489498599995, 38.11395905200004],
              [-75.19033769399994, 38.14272695500006],
              [-75.17931067599994, 38.16819896000004],
              [-75.15330969999991, 38.207017320000034],
            ],
          ],
          [
            [
              [-74.35879472599993, 39.44717031500005],
              [-74.36754309799994, 39.46503327000005],
              [-74.3516332669999, 39.47020091400009],
              [-74.30211341099994, 39.46474844000005],
              [-74.30492102799991, 39.45978424700007],
              [-74.31334387899994, 39.455145575000074],
              [-74.31786048099991, 39.454006252000056],
              [-74.33092200399994, 39.42609284100007],
              [-74.35924231699994, 39.401556708000044],
              [-74.39338131399995, 39.38914622600004],
              [-74.42552649599992, 39.393744208000044],
              [-74.44815019399994, 39.41986725500004],
              [-74.43089758999992, 39.42536041900007],
              [-74.42170162699995, 39.41693756700005],
              [-74.41356360599991, 39.40477122600004],
              [-74.39976966099994, 39.39935944200005],
              [-74.38662675699993, 39.40648021000004],
              [-74.37173417899993, 39.43659088700008],
              [-74.35879472599993, 39.44717031500005],
            ],
          ],
          [
            [
              [-74.1328832669999, 39.71466705900008],
              [-74.11827551999994, 39.737982489000046],
              [-74.10948645699995, 39.748928127000056],
              [-74.09813391799992, 39.75568268400008],
              [-74.10578365799995, 39.72915273600006],
              [-74.1296816439999, 39.701289716000076],
              [-74.14790146299993, 39.665895583000065],
              [-74.18430835499993, 39.61555470900004],
              [-74.23163242099992, 39.55299124800007],
              [-74.25641842399995, 39.52220286700009],
              [-74.25576738199993, 39.529730536000045],
              [-74.25446529899995, 39.53461334800005],
              [-74.2546397129999, 39.547361925000075],
              [-74.24007209699994, 39.575387884000065],
              [-74.15998658099994, 39.685463525000046],
              [-74.1328832669999, 39.71466705900008],
            ],
          ],
          [
            [
              [-73.25614437599995, 40.63905194800009],
              [-73.3203241679999, 40.63505586500008],
              [-73.38951575399994, 40.61676666900007],
              [-73.57412003499991, 40.57509300600009],
              [-73.56639295699995, 40.590320242000075],
              [-73.44384653799995, 40.61893638300006],
              [-73.40073299199992, 40.62964075500008],
              [-73.37773816799995, 40.634617012000035],
              [-73.35760061099995, 40.64032780900004],
              [-73.33938414499994, 40.64459266700004],
              [-73.31831116699993, 40.646661882000046],
              [-73.26945678299995, 40.649295803000086],
              [-73.24840160199994, 40.64772029100004],
              [-73.25614437599995, 40.63905194800009],
            ],
          ],
          [
            [
              [-74.12608801999994, 40.63349030200004],
              [-74.11025956899994, 40.63776276200008],
              [-74.09732011599993, 40.64350006700005],
              [-74.08353630699992, 40.64951799000005],
              [-74.07671570399992, 40.64874448200004],
              [-74.07305214299993, 40.64437225900008],
              [-74.0714502319999, 40.63803071600006],
              [-74.07461513599992, 40.63403299500004],
              [-74.07194127799994, 40.62333169100009],
              [-74.06145120299993, 40.614608642000064],
              [-74.05356873199992, 40.60270386700006],
              [-74.10210265499995, 40.55457049200004],
              [-74.13391798399994, 40.53266801500007],
              [-74.13967417999993, 40.53464420700004],
              [-74.14803661199994, 40.53462906400006],
              [-74.16316421199991, 40.527446857000086],
              [-74.17985499199995, 40.519861493000064],
              [-74.1923614449999, 40.51148853400008],
              [-74.20906902399992, 40.509462598000084],
              [-74.22836888899991, 40.50225778300006],
              [-74.24298365399994, 40.49943456200003],
              [-74.25083095699995, 40.50139666600006],
              [-74.25294418099992, 40.50735441300009],
              [-74.24825957399992, 40.512937402000034],
              [-74.23939217599991, 40.516939516000036],
              [-74.2389302389999, 40.52725895300006],
              [-74.2416034609999, 40.539165454000056],
              [-74.23275923299991, 40.54792897400006],
              [-74.21866523999995, 40.55313248200008],
              [-74.20719551099995, 40.56031146300006],
              [-74.2014873839999, 40.56985629600007],
              [-74.1978945489999, 40.58495639400007],
              [-74.19435185799995, 40.61276638500004],
              [-74.19180169999993, 40.62826424300005],
              [-74.18241904899992, 40.63742243100006],
              [-74.17092733899995, 40.64341019400007],
              [-74.15363124899994, 40.63748966700007],
              [-74.12608801999994, 40.63349030200004],
            ],
          ],
          [
            [
              [-72.88151109199993, 40.734399851000035],
              [-72.83237011599994, 40.74774433400006],
              [-72.77923011899992, 40.76684323500007],
              [-72.7570827479999, 40.76880210300004],
              [-72.7572392539999, 40.76008574000008],
              [-72.80492102799991, 40.750840562000064],
              [-72.83153235599991, 40.74164459800005],
              [-72.91347653199995, 40.71290121900006],
              [-72.9915258449999, 40.68817780200004],
              [-73.04100501199991, 40.67263418200008],
              [-73.14753170499995, 40.64431386900009],
              [-73.2457830489999, 40.623806097000056],
              [-73.29745864599994, 40.622622436000086],
              [-73.3050460849999, 40.62992183000006],
              [-73.25529154599991, 40.629668423000055],
              [-73.21883025499994, 40.63963458100005],
              [-73.17660996399991, 40.650997904000064],
              [-73.10465864799994, 40.66722030100004],
              [-73.04034297099992, 40.681995243000074],
              [-73.01390540299991, 40.69045644700009],
              [-72.94890381399995, 40.71538570100006],
              [-72.91426856099991, 40.72452721700006],
              [-72.88151109199993, 40.734399851000035],
            ],
          ],
          [
            [
              [-71.91893469999991, 41.064886786000045],
              [-71.9309044009999, 41.07879058000009],
              [-71.9033001809999, 41.08467213700004],
              [-71.87511145699995, 41.07571035400008],
              [-71.85741126199991, 41.07172272300005],
              [-71.86489824099993, 41.06207916900007],
              [-71.88496960299994, 41.045397036000054],
              [-71.92951164199991, 41.03784787500007],
              [-72.0088723309999, 41.00738566100006],
              [-72.08714758999992, 40.98342519700009],
              [-72.15982011599993, 40.95526764500005],
              [-72.21986208499993, 40.933422721000056],
              [-72.3169916999999, 40.89626008200008],
              [-72.37173417899993, 40.875840562000064],
              [-72.40665794899991, 40.86207213500006],
              [-72.44127356699994, 40.85500722900008],
              [-72.46076412699995, 40.85260651200008],
              [-72.44835364499994, 40.86823151200008],
              [-72.44741777299993, 40.87909577000005],
              [-72.45913652299993, 40.88536204600007],
              [-72.48468990799995, 40.88739655200004],
              [-72.49657141799992, 40.884100653000075],
              [-72.50059973899994, 40.87604401200008],
              [-72.49836178299995, 40.86579010600008],
              [-72.4915258449999, 40.85602448100008],
              [-72.49079342399995, 40.846869208000044],
              [-72.50230872299994, 40.839056708000044],
              [-72.54181881399995, 40.82050202000005],
              [-72.60527986099993, 40.80133032400005],
              [-72.70444213999991, 40.776177001000065],
              [-72.72395471999994, 40.770419324000045],
              [-72.73200436099995, 40.769964911000045],
              [-72.73790442599994, 40.77378978100006],
              [-72.73169444199993, 40.77764891000004],
              [-72.72538681799995, 40.778378957000086],
              [-72.67845850599991, 40.79099975200006],
              [-72.65051644899995, 40.79745521800004],
              [-72.66358001799995, 40.800773149000065],
              [-72.67932500099994, 40.80093997000006],
              [-72.70034489699992, 40.79957056500007],
              [-72.72696057899992, 40.80778945700007],
              [-72.7439467769999, 40.79683949400004],
              [-72.76517069099992, 40.78314791400004],
              [-72.80189858299991, 40.782710473000066],
              [-72.8280089029999, 40.78970843600007],
              [-72.81362870999993, 40.78160228100006],
              [-72.81794186099995, 40.768418687000064],
              [-72.83275305899991, 40.75962962400007],
              [-72.85279214499991, 40.74942314800006],
              [-72.87907469899994, 40.74568580200008],
              [-72.8892573839999, 40.76563846800008],
              [-72.91036189899995, 40.758273537000036],
              [-72.92625891799992, 40.75641510600008],
              [-72.94681688299994, 40.74189162300007],
              [-73.01219641799992, 40.74957916900007],
              [-73.02257239499994, 40.74758535400008],
              [-73.0334214049999, 40.731434457000034],
              [-73.05495420299991, 40.72921196900006],
              [-73.08332336199993, 40.72465152400008],
              [-73.09909990199992, 40.72039401100005],
              [-73.11473192999995, 40.728049412000075],
              [-73.12938354799991, 40.73013512400007],
              [-73.14043572699995, 40.726237526000034],
              [-73.14240475199995, 40.716131903000075],
              [-73.14539324799995, 40.70521912700008],
              [-73.15802980099994, 40.69974143200005],
              [-73.17951412699995, 40.70469798400006],
              [-73.21193114999994, 40.705641452000066],
              [-73.23332336899995, 40.71450467100004],
              [-73.24702646199995, 40.707036144000085],
              [-73.26181689999993, 40.69559832200008],
              [-73.2750033289999, 40.686929889000055],
              [-73.31748874499993, 40.68357322600008],
              [-73.37221703599994, 40.662365485000066],
              [-73.4021573949999, 40.65771914900006],
              [-73.50454576599992, 40.64382990000007],
              [-73.56112082499993, 40.63804890500006],
              [-73.62717341699994, 40.61439705200007],
              [-73.64343313799992, 40.60490426100006],
              [-73.65286478999991, 40.60135117900006],
              [-73.66436716399994, 40.60376099500007],
              [-73.65597552799994, 40.60890571600004],
              [-73.65541736699993, 40.618040455000084],
              [-73.6679503709999, 40.626014131000034],
              [-73.69579016799992, 40.621527411000045],
              [-73.71092515099991, 40.61021160300004],
              [-73.71044687299991, 40.59511485000007],
              [-73.60633660899992, 40.594086480000044],
              [-73.57548050199995, 40.593206284000075],
              [-73.58180078799995, 40.58448644500004],
              [-73.7073432389999, 40.58279433900009],
              [-73.7523491469999, 40.58565080500006],
              [-73.76805021099995, 40.58964326600005],
              [-73.81258960799994, 40.58373571700008],
              [-73.89711759999994, 40.554678083000056],
              [-73.93947018499995, 40.54195887100008],
              [-73.93947888899993, 40.55547703700006],
              [-73.85054854599991, 40.58088428100007],
              [-73.7897919639999, 40.60029175300008],
              [-73.77615696299995, 40.61060752100008],
              [-73.76880590199994, 40.61854566900007],
              [-73.7714196899999, 40.62331869700006],
              [-73.78084875899992, 40.62889794200004],
              [-73.7981288499999, 40.63805934700008],
              [-73.81541141999992, 40.64562735000004],
              [-73.82955911499994, 40.648818970000036],
              [-73.85156373699994, 40.64367007300007],
              [-73.86884869699992, 40.640104301000065],
              [-73.8772297889999, 40.63613596700009],
              [-73.88298933099992, 40.63176798100005],
              [-73.89134680899991, 40.62360260600008],
              [-73.89293572399993, 40.614289357000075],
              [-73.88351568099995, 40.600379116000056],
              [-73.87776110499993, 40.582095511000034],
              [-73.89188831999991, 40.57693528100003],
              [-73.8976440479999, 40.583296509000036],
              [-73.91177001199992, 40.58369742500008],
              [-73.92641797699991, 40.58369850100007],
              [-73.93216925099995, 40.57773715600007],
              [-73.94158293099991, 40.57455758400005],
              [-73.98812544599991, 40.569370426000035],
              [-74.00381696399995, 40.57055083700004],
              [-74.01167382599994, 40.57928827400008],
              [-74.00069491199991, 40.58327164000008],
              [-73.99808697299994, 40.58963233900005],
              [-74.00489548799993, 40.59718203400007],
              [-74.03002128499992, 40.605497728000046],
              [-74.03998974599995, 40.61978573400006],
              [-74.03583478099995, 40.638859386000036],
              [-74.02381096499994, 40.64920005500005],
              [-74.01283968699994, 40.66470009400007],
              [-74.01547925799991, 40.677803734000065],
              [-74.00187939799991, 40.690127016000076],
              [-73.99769661999994, 40.69608738900007],
              [-73.99058997299994, 40.69977448100008],
              [-73.98033606699994, 40.70461660400008],
              [-73.96933548499993, 40.708749400000045],
              [-73.9593714419999, 40.72466335100006],
              [-73.95679623599995, 40.743171457000074],
              [-73.93023331699993, 40.77312106200009],
              [-73.90859985299994, 40.78867740900006],
              [-73.8870943469999, 40.77993432000005],
              [-73.87030294099992, 40.78231282100006],
              [-73.86086004999993, 40.776351255000066],
              [-73.82305398699992, 40.79738222000009],
              [-73.7789890379999, 40.792176561000076],
              [-73.75752241799995, 40.77111113500007],
              [-73.75013666099994, 40.79134597400008],
              [-73.76425999299994, 40.810031622000054],
              [-73.75552324099993, 40.83279043200008],
              [-73.73981686099995, 40.83433665600006],
              [-73.72935950399994, 40.82408274900007],
              [-73.72179114499994, 40.81122467700004],
              [-73.71458899599992, 40.804795640000066],
              [-73.70299231699994, 40.81016673400006],
              [-73.69688880099994, 40.82188548400006],
              [-73.70042883999992, 40.83360423400006],
              [-73.73306230399993, 40.84369538000004],
              [-73.73127193899995, 40.85443756700005],
              [-73.72020423099991, 40.86623769700009],
              [-73.70530645499991, 40.86674448300005],
              [-73.67435113999994, 40.85675517800007],
              [-73.66551477399992, 40.83845205700004],
              [-73.65330969999991, 40.823919989000046],
              [-73.64611711599991, 40.83086676700009],
              [-73.65336053399994, 40.86778553700009],
              [-73.63265498699991, 40.89958567600007],
              [-73.56527346799993, 40.91451437500007],
              [-73.5204634779999, 40.91760186000005],
              [-73.51268469999991, 40.90509674700007],
              [-73.51528886599993, 40.90041738500008],
              [-73.52860364199995, 40.89172236300004],
              [-73.5406699209999, 40.895338276000075],
              [-73.54909795099991, 40.890985467000064],
              [-73.5349811939999, 40.87862772900007],
              [-73.51134759699994, 40.87734938500006],
              [-73.50972187999992, 40.88569418900005],
              [-73.5075714809999, 40.89363795400004],
              [-73.49339404299991, 40.89199148700004],
              [-73.4929367599999, 40.88164362100008],
              [-73.47982825399993, 40.877244456000085],
              [-73.47244388699994, 40.882367618000046],
              [-73.4755348509999, 40.890738775000045],
              [-73.46812903599994, 40.89362213700008],
              [-73.46914628799993, 40.90131256700005],
              [-73.48534094999991, 40.91791413000004],
              [-73.49409534199992, 40.92705250900008],
              [-73.48568717099994, 40.945625696000036],
              [-73.46208391599993, 40.93638230700009],
              [-73.43130449099993, 40.933294989000046],
              [-73.44082597599993, 40.91465892100007],
              [-73.43219967399995, 40.90766022300005],
              [-73.42031816299993, 40.90041738500008],
              [-73.40502125299992, 40.90395490100008],
              [-73.38866126199991, 40.905951239000046],
              [-73.37092037699995, 40.900091864000046],
              [-73.35826575399994, 40.90041738500008],
              [-73.35472571499992, 40.914129950000074],
              [-73.36063686499995, 40.925092679000045],
              [-73.37896084499994, 40.92446434900006],
              [-73.39956884899993, 40.92541819300004],
              [-73.41002356699994, 40.939886786000045],
              [-73.40776152799992, 40.94716228900006],
              [-73.40193050099992, 40.954404294000085],
              [-73.39517435999994, 40.95436789200005],
              [-73.3797815339999, 40.94701298400008],
              [-73.3740645439999, 40.93607343800005],
              [-73.3509601479999, 40.93085642200003],
              [-73.32590079199991, 40.92925672200005],
              [-73.29318422699993, 40.924703787000055],
              [-73.26342844699991, 40.91362324000005],
              [-73.24372311099995, 40.910264390000066],
              [-73.23534094999991, 40.90782298400006],
              [-73.22459876199991, 40.908270575000074],
              [-73.17870032499991, 40.91901276200008],
              [-73.1594945949999, 40.93024323100008],
              [-73.14810136599993, 40.94562409100007],
              [-73.15282141799992, 40.96246979400007],
              [-73.13536536399994, 40.968451239000046],
              [-73.11314856699994, 40.97345612200007],
              [-73.09874426999994, 40.96950918200008],
              [-73.10440019399994, 40.94879791900007],
              [-73.09129798099991, 40.94835032800006],
              [-73.08214270699995, 40.951605536000045],
              [-73.07917232999995, 40.95856354400007],
              [-73.08458411399994, 40.96930573100008],
              [-73.07622268499995, 40.971944765000046],
              [-73.04844101399993, 40.96301500900006],
              [-73.00896878799995, 40.96706629000005],
              [-72.9003762879999, 40.963255021000066],
              [-72.83008922599993, 40.96917533300007],
              [-72.7811209109999, 40.965079675000084],
              [-72.69609217699991, 40.981017533000056],
              [-72.62832597599993, 40.983587958000044],
              [-72.60610917899993, 40.989935614000046],
              [-72.54134708499993, 41.02381812600004],
              [-72.47165172099994, 41.055953110000075],
              [-72.45386165999992, 41.07442388100009],
              [-72.4451765849999, 41.085848868000085],
              [-72.41292310599994, 41.08981182000008],
              [-72.38304602799991, 41.10891347900008],
              [-72.3587133449999, 41.13113027600008],
              [-72.34341386599993, 41.14065176000008],
              [-72.28945878799993, 41.16115957200009],
              [-72.27554277299993, 41.162624416000085],
              [-72.25999915299991, 41.16083405200004],
              [-72.24722245999993, 41.15570709800005],
              [-72.24168860599991, 41.14679596600007],
              [-72.24689693899995, 41.13544342700004],
              [-72.26024329299992, 41.12502676000008],
              [-72.27619381399995, 41.11705149900007],
              [-72.28945878799993, 41.113348700000074],
              [-72.30443274599992, 41.13194407800006],
              [-72.34361731699994, 41.11420319200005],
              [-72.41234290299991, 41.064886786000045],
              [-72.41530487799992, 41.054447018000076],
              [-72.39997311099995, 41.05133698100008],
              [-72.39281165299991, 41.04718659100007],
              [-72.38508053299995, 41.04446035400008],
              [-72.3905429369999, 41.03147059400004],
              [-72.41207665799993, 41.03413238200005],
              [-72.4311214249999, 41.03040319400009],
              [-72.43740800699993, 41.02570221600007],
              [-72.43883216099994, 41.01597728100006],
              [-72.43569902299993, 41.00588613500008],
              [-72.43346106699994, 40.99323151200008],
              [-72.43773352799991, 40.98419830900008],
              [-72.44668535099993, 40.991400458000044],
              [-72.45494544199994, 41.00372955900008],
              [-72.46645734499992, 41.003826693000065],
              [-72.47253934799994, 40.99039424600005],
              [-72.49494381399995, 40.98981354400007],
              [-72.49958248599995, 40.98895905200004],
              [-72.51054840499995, 40.98489950600003],
              [-72.52065995999993, 40.98517487200007],
              [-72.53392195899994, 40.97485257200009],
              [-72.54356216999992, 40.96662291700005],
              [-72.54308020699995, 40.95656972900008],
              [-72.56244249899993, 40.94419805400008],
              [-72.5800440779999, 40.93287817200007],
              [-72.59956221899995, 40.93071499600006],
              [-72.61593725699993, 40.92771872700007],
              [-72.62462317599994, 40.90782298400006],
              [-72.61343339799993, 40.90888092700004],
              [-72.6028539699999, 40.90839264500005],
              [-72.59300696499992, 40.90582916900007],
              [-72.58429928299995, 40.90041738500008],
              [-72.56358801999994, 40.91238027600008],
              [-72.54393469999991, 40.91010163000004],
              [-72.52383378799993, 40.90302155200004],
              [-72.50136121499992, 40.897389032000035],
              [-72.48084681199992, 40.89793746000004],
              [-72.45714270699995, 40.910264390000066],
              [-72.44988269999993, 40.91979858600007],
              [-72.44371497299994, 40.931748765000066],
              [-72.44102942599994, 40.94297923400006],
              [-72.42929964699994, 40.94694560100004],
              [-72.4081799459999, 40.950647239000034],
              [-72.3861312649999, 40.97180859300005],
              [-72.36718444699994, 40.994600253000044],
              [-72.34211178299995, 40.99982330900008],
              [-72.32653878899993, 40.99922422900005],
              [-72.32110516599994, 41.00591024600004],
              [-72.33209166799992, 41.03069971700006],
              [-72.32152258999992, 41.03583405200004],
              [-72.30668324399994, 41.03552480900004],
              [-72.3012619509999, 41.02034641700004],
              [-72.29845625899992, 41.006000018000066],
              [-72.27010426299995, 41.002427612000076],
              [-72.26344585599992, 41.015454601000044],
              [-72.2486331369999, 41.01763321800007],
              [-72.24254372899992, 41.02907517500006],
              [-72.24021086399995, 41.037788731000035],
              [-72.23370918199993, 41.04406575100006],
              [-72.2137857429999, 41.03980403600008],
              [-72.18675224399993, 41.00916334400006],
              [-72.18355467899994, 41.027821473000074],
              [-72.18004309799994, 41.04706452000005],
              [-72.16686593899993, 41.056647412000075],
              [-72.15538489499994, 41.05499909100007],
              [-72.12287350199995, 41.01740143400008],
              [-72.11815344999991, 41.00686269700009],
              [-72.10899817599994, 41.00141022300005],
              [-72.08804277299993, 41.00482819200005],
              [-72.04987545499995, 41.017686265000066],
              [-72.01170813699991, 41.04210032800006],
              [-71.99274654899995, 41.04962799700007],
              [-71.97570717799994, 41.04339700100007],
              [-71.95875262999994, 41.04628274700008],
              [-71.95806781699991, 41.06971829000008],
              [-71.94530441599994, 41.073475417000054],
              [-71.93342736199992, 41.06492548700004],
              [-71.91893469999991, 41.058661200000074],
              [-71.91893469999991, 41.064886786000045],
            ],
          ],
          [
            [
              [-71.55947373399994, 41.201024044000064],
              [-71.56615149599992, 41.19375234600005],
              [-71.55992591099994, 41.18374258000006],
              [-71.55186926999994, 41.17572663000004],
              [-71.54447326199994, 41.162887597000065],
              [-71.54909458299994, 41.152042072000086],
              [-71.57157169499993, 41.14976927500004],
              [-71.59955026999995, 41.14577897300006],
              [-71.61374760699994, 41.15518087400005],
              [-71.61271717999995, 41.16746698400004],
              [-71.60802497799995, 41.180589387000055],
              [-71.59748649599993, 41.18766926200004],
              [-71.59121660099993, 41.197333075000074],
              [-71.58267167899993, 41.20404694200005],
              [-71.58043372299994, 41.21478913000004],
              [-71.5791999299999, 41.22557152200005],
              [-71.57258053299995, 41.22882721600007],
              [-71.56704667899993, 41.22483958500004],
              [-71.55354112299995, 41.214571842000055],
              [-71.55947373399994, 41.201024044000064],
            ],
          ],
          [
            [
              [-71.9987335269999, 41.25166610000008],
              [-72.02280651299992, 41.25348677900007],
              [-72.0387976799999, 41.24944682600005],
              [-72.03656317999992, 41.260865196000054],
              [-72.02622800099994, 41.266903798000044],
              [-72.02212989299994, 41.276858134000065],
              [-72.01134922599994, 41.276207975000034],
              [-72.00336231299991, 41.26701278100006],
              [-71.9980771939999, 41.274082014000044],
              [-71.99400380799995, 41.283080978000044],
              [-71.97680935499994, 41.284705958000075],
              [-71.95388826599992, 41.286710664000054],
              [-71.93975672899995, 41.29219705500009],
              [-71.92073232999991, 41.29139648900008],
              [-71.92800076499992, 41.28197883000007],
              [-71.94657542899995, 41.27656789200006],
              [-71.97015291699995, 41.273622163000084],
              [-71.98832875399995, 41.26008536100005],
              [-71.9987335269999, 41.25166610000008],
            ],
          ],
          [
            [
              [-70.05414940499992, 41.39268601900005],
              [-70.05239618899992, 41.39656248300008],
              [-70.0397457759999, 41.394359283000085],
              [-70.02887005299993, 41.38611972100006],
              [-70.0192021339999, 41.37011683800006],
              [-70.00527910099993, 41.34271881700005],
              [-69.97496497299994, 41.30219147300005],
              [-69.95775981999992, 41.275747900000056],
              [-69.9671492459999, 41.24945285400008],
              [-70.00112988399991, 41.239256614000055],
              [-70.04303849099995, 41.24333390600009],
              [-70.09759606099993, 41.24182963800007],
              [-70.1377452289999, 41.24715236600008],
              [-70.23314368399991, 41.28375885600008],
              [-70.25634859899992, 41.29276714200006],
              [-70.2781123979999, 41.30790660900004],
              [-70.27235811699995, 41.311347581000064],
              [-70.2562877869999, 41.30916008500009],
              [-70.24081611899993, 41.30093191600008],
              [-70.21728787799992, 41.29742713200005],
              [-70.16105114699991, 41.292966801000034],
              [-70.12428815699991, 41.29587094200008],
              [-70.10680091099994, 41.29523346600007],
              [-70.09776770699995, 41.29043203300006],
              [-70.08971106699994, 41.28998444200005],
              [-70.08193925699993, 41.29254791900007],
              [-70.07140051999994, 41.30158112200007],
              [-70.04600989499994, 41.30756256700005],
              [-70.03140214799993, 41.31753164300005],
              [-70.02009029899995, 41.33079661700003],
              [-70.01402747299994, 41.344631252000056],
              [-70.03233801999994, 41.339504299000055],
              [-70.06029212099992, 41.31663646000004],
              [-70.07607988199993, 41.31110260600008],
              [-70.04430091099994, 41.35097890800006],
              [-70.03722083199995, 41.37287018400008],
              [-70.05414940499992, 41.39268601900005],
            ],
          ],
          [
            [
              [-70.50059973899994, 41.39362213700008],
              [-70.48692786399994, 41.40265534100007],
              [-70.47069251199991, 41.42031484600005],
              [-70.45571855399993, 41.42963288000004],
              [-70.44603430899991, 41.41351959800005],
              [-70.44493567599994, 41.382025458000044],
              [-70.44668535099993, 41.36741771000004],
              [-70.45287024599992, 41.35887278900009],
              [-70.46548417899993, 41.360256252000056],
              [-70.48127193899995, 41.369574286000045],
              [-70.49478105399993, 41.38231028900009],
              [-70.50059973899994, 41.39362213700008],
            ],
          ],
          [
            [
              [-70.57640540299991, 41.427801825000074],
              [-70.56334387899994, 41.41868724200003],
              [-70.54930579299992, 41.41453685100004],
              [-70.51740475199995, 41.41351959800005],
              [-70.50743567599994, 41.362616278000075],
              [-70.52501380099994, 41.359076239000046],
              [-70.66600501199991, 41.35700104400007],
              [-70.69627844999991, 41.35150788000004],
              [-70.7239477199999, 41.34271881700005],
              [-70.74767005099994, 41.33100006700005],
              [-70.77590898299991, 41.304388739000046],
              [-70.7864070299999, 41.30414459800005],
              [-70.80467688699991, 41.312567450000074],
              [-70.81497148299991, 41.32070547100005],
              [-70.8340551419999, 41.339911200000074],
              [-70.84622148299991, 41.34666575700004],
              [-70.84622148299991, 41.35407135600008],
              [-70.78197180899991, 41.35423411700003],
              [-70.75450598899994, 41.37250397300005],
              [-70.74217688699991, 41.384833075000074],
              [-70.71532141799992, 41.420355536000045],
              [-70.70262610599991, 41.427801825000074],
              [-70.68960527299993, 41.43309153900009],
              [-70.65990149599992, 41.45652903900009],
              [-70.60513261599993, 41.47402578300006],
              [-70.59300696499992, 41.47166575700004],
              [-70.60366777299993, 41.44822825700004],
              [-70.58877519399994, 41.45416901200008],
              [-70.57949785099993, 41.46588776200008],
              [-70.57042395699995, 41.473944403000075],
              [-70.55589758999992, 41.468736070000034],
              [-70.54576575399994, 41.45392487200007],
              [-70.54625403599994, 41.44428131700005],
              [-70.55654863199993, 41.43650950700004],
              [-70.57640540299991, 41.427801825000074],
            ],
          ],
          [
            [
              [-71.35781816299993, 41.55817291900007],
              [-71.35728919199994, 41.53656647300005],
              [-71.36042232999995, 41.514553127000056],
              [-71.36563066299993, 41.495347398000035],
              [-71.37144934799994, 41.48236725500004],
              [-71.37608801999994, 41.476996161000045],
              [-71.38414466099994, 41.46946849200003],
              [-71.3926488919999, 41.46328359600005],
              [-71.39879309799994, 41.46190013200004],
              [-71.40099036399994, 41.468451239000046],
              [-71.39517167899993, 41.49091217700004],
              [-71.39879309799994, 41.50287506700005],
              [-71.39220130099994, 41.505926825000074],
              [-71.38947506399995, 41.50922272300005],
              [-71.38780676999994, 41.512884833000044],
              [-71.38442949099993, 41.51715729400007],
              [-71.39533443899995, 41.52643463700008],
              [-71.39268958199995, 41.542669989000046],
              [-71.37767493399991, 41.57794830900008],
              [-71.36839758999992, 41.576239325000074],
              [-71.36241614499994, 41.57245514500005],
              [-71.35912024599992, 41.566392320000034],
              [-71.35781816299993, 41.55817291900007],
            ],
          ],
          [
            [
              [-69.97301184799994, 41.65371328300006],
              [-69.96507727799991, 41.65135325700004],
              [-69.96129309799994, 41.64695872600004],
              [-69.95995032499991, 41.640692450000074],
              [-69.95938066299993, 41.63263580900008],
              [-69.97622636599993, 41.61229075700004],
              [-70.00210527299993, 41.55377838700008],
              [-70.02147376199991, 41.55072663000004],
              [-69.98102779899995, 41.62767161700003],
              [-69.97301184799994, 41.65371328300006],
            ],
          ],
          [
            [
              [-71.28551184799994, 41.581732489000046],
              [-71.27944902299993, 41.593085028000075],
              [-71.27358964799993, 41.62099844000005],
              [-71.26781165299991, 41.63263580900008],
              [-71.25780188699991, 41.640692450000074],
              [-71.23273678299995, 41.652777411000045],
              [-71.22061113199993, 41.66054922100005],
              [-71.22061113199993, 41.64004140800006],
              [-71.23257402299993, 41.605902411000045],
              [-71.23363196499992, 41.53082916900007],
              [-71.23509680899991, 41.51898834800005],
              [-71.23753821499992, 41.50950755400004],
              [-71.23802649599992, 41.50031159100007],
              [-71.23363196499992, 41.48920319200005],
              [-71.26480058499993, 41.496079820000034],
              [-71.28595943899995, 41.48200104400007],
              [-71.30321204299992, 41.46637604400007],
              [-71.32306881399995, 41.468736070000034],
              [-71.33495032499991, 41.459051825000074],
              [-71.34618079299992, 41.454738674000055],
              [-71.35456295499995, 41.458319403000075],
              [-71.35781816299993, 41.47247955900008],
              [-71.35130774599992, 41.477850653000075],
              [-71.31997636599993, 41.48847077000005],
              [-71.30882727799991, 41.495428778000075],
              [-71.32135982999995, 41.50853099200003],
              [-71.32555091099994, 41.519964911000045],
              [-71.32225501199991, 41.53042226800005],
              [-71.31248938699991, 41.54075755400004],
              [-71.30915279899995, 41.546087958000044],
              [-71.30817623599995, 41.553168036000045],
              [-71.30882727799991, 41.56777578300006],
              [-71.30577551999994, 41.57172272300005],
              [-71.2910863919999, 41.57827383000006],
              [-71.28551184799994, 41.581732489000046],
            ],
          ],
          [
            [
              [-123.97399719799989, 46.49292971500006],
              [-123.97120707199991, 46.48478039300005],
              [-123.9638948189999, 46.48011848500005],
              [-123.94818019999991, 46.46419014800006],
              [-123.94711761199994, 46.448679532000085],
              [-123.9455307959999, 46.41764703400008],
              [-123.96412107099991, 46.40679058000006],
              [-123.97471625899993, 46.440181221000046],
              [-123.9977626189999, 46.45339725700006],
              [-123.99095282499991, 46.47317340600006],
              [-123.99034636399995, 46.48829297700007],
              [-123.98110917899993, 46.49746328300006],
              [-123.97399719799989, 46.49292971500006],
            ],
          ],
          [
            [
              [-122.4351293609999, 47.42572663000004],
              [-122.42243404899995, 47.40884023600006],
              [-122.40615800699993, 47.40033600500004],
              [-122.38735917899993, 47.39398834800005],
              [-122.36681067599994, 47.38353099200003],
              [-122.3743383449999, 47.383246161000045],
              [-122.41779537699995, 47.370794989000046],
              [-122.4495336579999, 47.347723700000074],
              [-122.46922766799992, 47.336371161000045],
              [-122.47472083199995, 47.34955475500004],
              [-122.47378495999993, 47.36286041900007],
              [-122.4663793609999, 47.37319570500006],
              [-122.45221920499989, 47.37734609600005],
              [-122.44225012899994, 47.382513739000046],
              [-122.43984941299993, 47.39280833500004],
              [-122.44640051999994, 47.40058014500005],
              [-122.46304277299993, 47.397772528000075],
              [-122.45563717399995, 47.39101797100005],
              [-122.47524980399993, 47.384466864000046],
              [-122.48542232999989, 47.37982819200005],
              [-122.48973548099991, 47.373928127000056],
              [-122.49022376199991, 47.35382721600007],
              [-122.49217688699991, 47.344183661000045],
              [-122.49657141799992, 47.336371161000045],
              [-122.50340735599991, 47.33152903900009],
              [-122.51048743399991, 47.332098700000074],
              [-122.51829993399991, 47.33730703300006],
              [-122.52725175699993, 47.34625885600008],
              [-122.53148352799991, 47.35691966400009],
              [-122.52757727799991, 47.366441148000035],
              [-122.5210668609999, 47.37441640800006],
              [-122.51768958199995, 47.38043854400007],
              [-122.51024329299992, 47.45579661700003],
              [-122.5039770169999, 47.46747467700004],
              [-122.48900305899991, 47.48265208500004],
              [-122.4710180329999, 47.495794989000046],
              [-122.45563717399995, 47.500881252000056],
              [-122.46206620999993, 47.486761786000045],
              [-122.45763098899994, 47.480169989000046],
              [-122.44859778599994, 47.47540924700007],
              [-122.44131425699993, 47.46674225500004],
              [-122.43911699099993, 47.456244208000044],
              [-122.43805904899995, 47.43585846600007],
              [-122.4351293609999, 47.42572663000004],
            ],
          ],
          [
            [
              [-122.49693762899994, 47.607123114000046],
              [-122.49510657499991, 47.601548570000034],
              [-122.49327551999994, 47.59422435100004],
              [-122.48863684799994, 47.58958567900004],
              [-122.48037675699993, 47.58685944200005],
              [-122.48863684799994, 47.581366278000075],
              [-122.49876868399991, 47.57123444200005],
              [-122.52086341099994, 47.57396067900004],
              [-122.54234778599994, 47.59552643400008],
              [-122.55760657499991, 47.59788646000004],
              [-122.57054602799991, 47.59609609600005],
              [-122.57787024599992, 47.601548570000034],
              [-122.56956946499992, 47.61810944200005],
              [-122.5676977199999, 47.62958405200004],
              [-122.57461503799993, 47.637884833000044],
              [-122.57925370999993, 47.64866771000004],
              [-122.58047441299993, 47.662990627000056],
              [-122.5789281889999, 47.66937897300005],
              [-122.56187903599994, 47.685614325000074],
              [-122.55801347599993, 47.695746161000045],
              [-122.55894934799994, 47.705959377000056],
              [-122.55776933499993, 47.71381256700005],
              [-122.54792232999989, 47.71698639500005],
              [-122.53770911399994, 47.71478913000004],
              [-122.52651933499993, 47.70929596600007],
              [-122.51683508999992, 47.702378648000035],
              [-122.51097571499992, 47.69586823100008],
              [-122.50584876199991, 47.663275458000044],
              [-122.49962317599994, 47.64866771000004],
              [-122.48985755099994, 47.64126211100006],
              [-122.49803626199991, 47.63361237200007],
              [-122.50328528599994, 47.63003164300005],
              [-122.51097571499992, 47.62759023600006],
              [-122.50015214799993, 47.61928945500006],
              [-122.50059973899994, 47.61172109600005],
              [-122.49693762899994, 47.607123114000046],
            ],
          ],
          [
            [
              [-122.7293188139999, 48.09674713700008],
              [-122.71890214799993, 48.10224030200004],
              [-122.70921790299991, 48.10224030200004],
              [-122.70116126199991, 48.09760163000004],
              [-122.68687903599994, 48.07322825700004],
              [-122.67711341099994, 48.04865143400008],
              [-122.67320716099994, 48.02374909100007],
              [-122.68150794199994, 48.00726959800005],
              [-122.70018469999991, 48.00775788000004],
              [-122.7176000639999, 48.02301666900007],
              [-122.7307836579999, 48.04242584800005],
              [-122.73672441299993, 48.05573151200008],
              [-122.74087480399993, 48.07436758000006],
              [-122.73892167899993, 48.08250560100004],
              [-122.7293188139999, 48.08299388200004],
              [-122.72301184799994, 48.076239325000074],
              [-122.72032630099994, 48.054754950000074],
              [-122.71629798099991, 48.04828522300005],
              [-122.7019750639999, 48.04922109600005],
              [-122.70164954299992, 48.06439850500004],
              [-122.71198482999989, 48.083644924000055],
              [-122.7293188139999, 48.09674713700008],
            ],
          ],
          [
            [
              [-122.35936438699991, 47.976629950000074],
              [-122.35065670499989, 47.960923570000034],
              [-122.34679114499994, 47.95058828300006],
              [-122.34947669199994, 47.94594961100006],
              [-122.35521399599992, 47.94196198100008],
              [-122.37364661399994, 47.919175523000035],
              [-122.3784887359999, 47.91469961100006],
              [-122.38190670499989, 47.90778229400007],
              [-122.38670813699991, 47.90493398600006],
              [-122.39297441299993, 47.90509674700007],
              [-122.39468339799993, 47.91034577000005],
              [-122.3958227199999, 47.91648997600004],
              [-122.40038001199991, 47.919175523000035],
              [-122.42227128799993, 47.91233958500004],
              [-122.43541419199994, 47.91046784100007],
              [-122.44131425699993, 47.91547272300005],
              [-122.44334876199991, 47.93691640800006],
              [-122.44969641799992, 47.95945872600004],
              [-122.4605199859999, 47.977850653000075],
              [-122.47606360599991, 47.98688385600008],
              [-122.48851477799991, 47.98509349200003],
              [-122.50706946499992, 47.97085195500006],
              [-122.51768958199995, 47.96629466400009],
              [-122.53034420499989, 47.96735260600008],
              [-122.53921464799993, 47.97215403900009],
              [-122.54808508999992, 47.97996653900009],
              [-122.56200110599991, 47.98737213700008],
              [-122.58018958199995, 48.00486888200004],
              [-122.5933324859999, 48.025376695000034],
              [-122.59215247299994, 48.04205963700008],
              [-122.60977128799993, 48.06049225500004],
              [-122.61485755099994, 48.07489655200004],
              [-122.60016842399995, 48.130113023000035],
              [-122.60724850199995, 48.15375397300005],
              [-122.62295488199993, 48.163316148000035],
              [-122.64439856699994, 48.161444403000075],
              [-122.66844641799992, 48.15058014500005],
              [-122.69322669199994, 48.18024323100008],
              [-122.69977779899995, 48.184759833000044],
              [-122.71011308499993, 48.18707916900007],
              [-122.72354081899994, 48.192694403000075],
              [-122.73615475199995, 48.199652411000045],
              [-122.74413001199991, 48.20587799700007],
              [-122.75572669199994, 48.22964101800005],
              [-122.75121008999992, 48.24994538000004],
              [-122.66844641799992, 48.36286041900007],
              [-122.6565649079999, 48.38507721600007],
              [-122.63084876199991, 48.38467031500005],
              [-122.61668860599991, 48.38959381700005],
              [-122.60545813699991, 48.398423570000034],
              [-122.5957738919999, 48.40192291900007],
              [-122.58649654899995, 48.39081452000005],
              [-122.58458411399994, 48.38336823100008],
              [-122.58287512899994, 48.38031647300005],
              [-122.57900956899994, 48.37714264500005],
              [-122.5777074859999, 48.356675523000035],
              [-122.51598059799994, 48.321966864000046],
              [-122.51756751199991, 48.29401276200008],
              [-122.53087317599994, 48.28384023600006],
              [-122.54637610599991, 48.28139883000006],
              [-122.56212317599994, 48.28620026200008],
              [-122.57591712099992, 48.29767487200007],
              [-122.59398352799991, 48.307928778000075],
              [-122.60899817599994, 48.29913971600007],
              [-122.62035071499992, 48.28192780200004],
              [-122.62743079299992, 48.267279364000046],
              [-122.64126542899993, 48.287990627000056],
              [-122.6467992829999, 48.28082916900007],
              [-122.64854895699995, 48.26264069200005],
              [-122.65135657499991, 48.24994538000004],
              [-122.66592363199993, 48.242173570000034],
              [-122.72370357999989, 48.23379140800006],
              [-122.71007239499994, 48.22142161700003],
              [-122.6961156889999, 48.22016022300005],
              [-122.66502844999991, 48.22638580900008],
              [-122.6519262359999, 48.22406647300005],
              [-122.62832597599993, 48.21430084800005],
              [-122.61693274599992, 48.21206289300005],
              [-122.59552975199995, 48.20538971600007],
              [-122.58063717399995, 48.18846263200004],
              [-122.57103430899991, 48.16624583500004],
              [-122.5586645169999, 48.12132396000004],
              [-122.55459550699993, 48.066066799000055],
              [-122.54662024599992, 48.01703522300005],
              [-122.53551184799994, 48.005926825000074],
              [-122.52204342399995, 48.01194896000004],
              [-122.51024329299992, 48.035223700000074],
              [-122.52285722599993, 48.057074286000045],
              [-122.52403723899994, 48.079413153000075],
              [-122.51402747299994, 48.09076569200005],
              [-122.49315344999991, 48.07965729400007],
              [-122.47695878799993, 48.06525299700007],
              [-122.46003170499989, 48.05345286700003],
              [-122.38109290299991, 48.01581452000005],
              [-122.3655492829999, 47.999660549000055],
              [-122.35936438699991, 47.976629950000074],
            ],
          ],
          [
            [
              [-122.86192786399994, 48.48932526200008],
              [-122.85846920499989, 48.47284577000005],
              [-122.84935462099992, 48.46161530200004],
              [-122.83629309799994, 48.45994700700004],
              [-122.82095292899993, 48.47260163000004],
              [-122.80833899599992, 48.458197333000044],
              [-122.80614173099991, 48.44204336100006],
              [-122.81309973899994, 48.42731354400007],
              [-122.82774817599994, 48.41738515800006],
              [-122.88988196499992, 48.42413971600007],
              [-122.88345292899993, 48.441473700000074],
              [-122.89867102799991, 48.44790273600006],
              [-122.92137610599991, 48.45099518400008],
              [-122.93761145699995, 48.458319403000075],
              [-122.94253495999993, 48.475775458000044],
              [-122.93700110599991, 48.49323151200008],
              [-122.92487545499989, 48.507147528000075],
              [-122.91030839799993, 48.51357656500005],
              [-122.91624915299991, 48.523871161000045],
              [-122.91698157499991, 48.533636786000045],
              [-122.91246497299994, 48.54173411700003],
              [-122.91030839799993, 48.54706452000005],
              [-122.88707434799994, 48.563666083000044],
              [-122.8770238919999, 48.56586334800005],
              [-122.86074785099993, 48.53961823100008],
              [-122.85903886599993, 48.52130768400008],
              [-122.86192786399994, 48.48932526200008],
            ],
          ],
          [
            [
              [-122.69371497299994, 48.585923570000034],
              [-122.67845618399991, 48.57290273600006],
              [-122.67454993399991, 48.568793036000045],
              [-122.6792699859999, 48.564520575000074],
              [-122.68590247299994, 48.55695221600007],
              [-122.68805904899995, 48.54702383000006],
              [-122.69408118399991, 48.54352448100008],
              [-122.70303300699993, 48.541896877000056],
              [-122.71434485599991, 48.54193756700005],
              [-122.72288977799991, 48.548163153000075],
              [-122.73704993399991, 48.57713450700004],
              [-122.73542232999989, 48.59039948100008],
              [-122.72679602799991, 48.60150788000004],
              [-122.71548417899993, 48.60602448100008],
              [-122.70287024599992, 48.60040924700007],
              [-122.69640051999994, 48.59227122600004],
              [-122.69371497299994, 48.585923570000034],
            ],
          ],
          [
            [
              [-123.02017167899993, 48.499335028000075],
              [-123.01683508999992, 48.49664948100008],
              [-122.99913489499994, 48.47260163000004],
              [-122.99132239499994, 48.467678127000056],
              [-122.98289954299992, 48.46360911700003],
              [-122.96495520699995, 48.458319403000075],
              [-122.96495520699995, 48.45148346600007],
              [-122.9793188139999, 48.456366278000075],
              [-122.99038652299993, 48.45587799700007],
              [-123.00161699099993, 48.453111070000034],
              [-123.01646887899994, 48.45148346600007],
              [-123.03001868399991, 48.45380280200004],
              [-123.03844153599994, 48.459418036000045],
              [-123.04527747299994, 48.46637604400007],
              [-123.05370032499991, 48.47260163000004],
              [-123.06541907499991, 48.478501695000034],
              [-123.0703832669999, 48.480129299000055],
              [-123.09162350199995, 48.47882721600007],
              [-123.10265051999994, 48.48029205900008],
              [-123.11636308499993, 48.48419830900008],
              [-123.1297094389999, 48.48973216400009],
              [-123.13931230399993, 48.49583567900004],
              [-123.14915930899991, 48.50560130400004],
              [-123.15444902299993, 48.51312897300005],
              [-123.16657467399995, 48.54352448100008],
              [-123.17393958199995, 48.573431708000044],
              [-123.1741430329999, 48.57843659100007],
              [-123.17756100199995, 48.598822333000044],
              [-123.15843665299991, 48.614569403000075],
              [-123.12913977799991, 48.62006256700005],
              [-123.10212154899995, 48.60911692900004],
              [-123.0938207669999, 48.59760163000004],
              [-123.07664954299992, 48.584051825000074],
              [-123.05776933499993, 48.57290273600006],
              [-123.02464758999992, 48.56281159100007],
              [-123.00430253799993, 48.53945547100005],
              [-122.97765051999994, 48.531317450000074],
              [-122.97996985599991, 48.52513255400004],
              [-122.9922582669999, 48.51357656500005],
              [-123.00234941299993, 48.50918203300006],
              [-123.0105688139999, 48.51162344000005],
              [-123.01659094999991, 48.511419989000046],
              [-123.02017167899993, 48.499335028000075],
            ],
          ],
          [
            [
              [-122.74583899599992, 48.66437409100007],
              [-122.75088456899994, 48.654730536000045],
              [-122.75723222599993, 48.650051174000055],
              [-122.80044511599993, 48.62962474200003],
              [-122.80451412699995, 48.62372467700004],
              [-122.80540930899991, 48.616888739000046],
              [-122.80894934799994, 48.61127350500004],
              [-122.82095292899993, 48.60911692900004],
              [-122.83112545499989, 48.61269765800006],
              [-122.8413793609999, 48.62091705900008],
              [-122.86587480399993, 48.649603583000044],
              [-122.87987219999991, 48.67719147300005],
              [-122.8823949859999, 48.68797435100004],
              [-122.8867895169999, 48.69627513200004],
              [-122.89635169199994, 48.69977448100008],
              [-122.90591386599993, 48.697333075000074],
              [-122.91030839799993, 48.68797435100004],
              [-122.90876217399995, 48.676947333000044],
              [-122.90611731699994, 48.671087958000044],
              [-122.90562903599994, 48.666083075000074],
              [-122.91030839799993, 48.657538153000075],
              [-122.86192786399994, 48.60171133000006],
              [-122.87437903599994, 48.593736070000034],
              [-122.8875219389999, 48.58999258000006],
              [-122.91714433499993, 48.58869049700007],
              [-122.93333899599992, 48.59275950700004],
              [-122.94139563699991, 48.60260651200008],
              [-122.94587154899995, 48.61408112200007],
              [-122.95128333199995, 48.62343984600005],
              [-122.96841386599993, 48.63458893400008],
              [-122.98009192599994, 48.63861725500004],
              [-122.98546301999994, 48.63304271000004],
              [-122.98623613199993, 48.61933014500005],
              [-122.98961341099994, 48.60464101800005],
              [-122.99705969999991, 48.59715403900009],
              [-123.00963294199994, 48.60541413000004],
              [-123.02220618399991, 48.618394273000035],
              [-123.02651933499993, 48.62653229400007],
              [-123.02635657499991, 48.63646067900004],
              [-123.02090410099993, 48.64248281500005],
              [-122.99714107999989, 48.660589911000045],
              [-122.98884029899995, 48.66437409100007],
              [-122.97777258999992, 48.66779205900008],
              [-122.92931067599994, 48.70844147300005],
              [-122.91795813699991, 48.71141185100004],
              [-122.89663652299993, 48.712144273000035],
              [-122.85781816299993, 48.708685614000046],
              [-122.74583899599992, 48.66437409100007],
            ],
          ],
          [
            [
              [-122.6214086579999, 48.66852448100008],
              [-122.61534583199995, 48.658636786000045],
              [-122.61314856699994, 48.648423570000034],
              [-122.62047278599994, 48.64594147300005],
              [-122.6336156889999, 48.651678778000075],
              [-122.65514075399994, 48.66474030200004],
              [-122.66222083199995, 48.67031484600005],
              [-122.67943274599992, 48.68817780200004],
              [-122.70311438699991, 48.707912502000056],
              [-122.71654212099992, 48.71523672100005],
              [-122.7202856109999, 48.72492096600007],
              [-122.7151586579999, 48.73908112200007],
              [-122.69847571499992, 48.73468659100007],
              [-122.67137610599991, 48.70482005400004],
              [-122.66234290299991, 48.697699286000045],
              [-122.64736894399994, 48.690741278000075],
              [-122.63516191299993, 48.683294989000046],
              [-122.62840735599991, 48.677069403000075],
              [-122.6214086579999, 48.66852448100008],
            ],
          ],
          [
            [
              [-166.09455318899992, 53.98065827000005],
              [-166.0877579419999, 53.97793203300006],
              [-166.07953854099992, 53.97089264500005],
              [-166.0889786449999, 53.96165599200003],
              [-166.11152096299992, 53.95600006700005],
              [-166.15392005099991, 53.95530833500004],
              [-166.1690567699999, 53.95677317900004],
              [-166.1912735669999, 53.964911200000074],
              [-166.19611568899992, 53.98102448100008],
              [-166.18915768099993, 53.98969147300005],
              [-166.1802872389999, 53.98981354400007],
              [-166.15656490799992, 53.99359772300005],
              [-166.11579342399992, 53.98867422100005],
              [-166.09455318899992, 53.98065827000005],
            ],
          ],
          [
            [
              [-159.5214737619999, 54.792222398000035],
              [-159.51508541599992, 54.78693268400008],
              [-159.51264400899993, 54.778509833000044],
              [-159.51532955599993, 54.768744208000044],
              [-159.52708899599992, 54.759466864000046],
              [-159.5471085279999, 54.753892320000034],
              [-159.5693253249999, 54.75458405200004],
              [-159.58930416599992, 54.75967031500005],
              [-159.5936173169999, 54.766831773000035],
              [-159.5901993479999, 54.77578359600005],
              [-159.59264075399992, 54.78660716400003],
              [-159.59699459499993, 54.79710521000004],
              [-159.60273189999992, 54.80508047100005],
              [-159.60419674399992, 54.81232330900008],
              [-159.59727942599991, 54.82021719000005],
              [-159.58515377499992, 54.824204820000034],
              [-159.5712784499999, 54.822251695000034],
              [-159.55833899599992, 54.81525299700007],
              [-159.54548092399992, 54.80613841400003],
              [-159.52513587099992, 54.79437897300005],
              [-159.5214737619999, 54.792222398000035],
            ],
          ],
          [
            [
              [-161.33356686099992, 55.191473700000074],
              [-161.33149166599992, 55.18805573100008],
              [-161.33018958199992, 55.18203359600005],
              [-161.33075924399992, 55.170355536000045],
              [-161.34186764199993, 55.16274648600006],
              [-161.3604630199999, 55.16303131700005],
              [-161.36982174399992, 55.165350653000075],
              [-161.42218990799992, 55.18545156500005],
              [-161.4396866529999, 55.197333075000074],
              [-161.43744869699992, 55.20490143400008],
              [-161.42731686099992, 55.21369049700007],
              [-161.41144771999993, 55.21946849200003],
              [-161.37226314999992, 55.21914297100005],
              [-161.35435950399992, 55.22150299700007],
              [-161.34032141799992, 55.21898021000004],
              [-161.33820553299992, 55.214056708000044],
              [-161.34150143099993, 55.20677317900004],
              [-161.33820553299992, 55.19790273600006],
              [-161.33356686099992, 55.191473700000074],
            ],
          ],
          [
            [
              [-161.55903072799993, 55.25446198100008],
              [-161.54857337099992, 55.252834377000056],
              [-161.54401607999992, 55.24062734600005],
              [-161.55744381399992, 55.21576569200005],
              [-161.56407630099991, 55.207912502000056],
              [-161.5740860669999, 55.207017320000034],
              [-161.59264075399992, 55.20750560100004],
              [-161.63719641799992, 55.19354889500005],
              [-161.64533443899992, 55.194525458000044],
              [-161.66417395699992, 55.19867584800005],
              [-161.6768692699999, 55.20018138200004],
              [-161.69172115799992, 55.21161530200004],
              [-161.68333899599992, 55.230902411000045],
              [-161.65888424399992, 55.24237702000005],
              [-161.6124161449999, 55.24510325700004],
              [-161.55903072799993, 55.25446198100008],
            ],
          ],
          [
            [
              [-160.0362442699999, 55.32619863500008],
              [-160.0330704419999, 55.32257721600007],
              [-160.03209387899992, 55.313666083000044],
              [-160.03998775899993, 55.307074286000045],
              [-160.07294674399992, 55.308294989000046],
              [-160.09699459499993, 55.31492747600004],
              [-160.10907955599993, 55.32575104400007],
              [-160.10846920499992, 55.33388906500005],
              [-160.09935462099992, 55.340277411000045],
              [-160.0854386059999, 55.343410549000055],
              [-160.06659908799992, 55.34471263200004],
              [-160.0615128249999, 55.342678127000056],
              [-160.05903072799993, 55.33856842700004],
              [-160.05256100199992, 55.33344147300005],
              [-160.0362442699999, 55.32619863500008],
            ],
          ],
          [
            [
              [-159.3127335279999, 55.81122467700004],
              [-159.29804439999992, 55.79364655200004],
              [-159.2890518869999, 55.778998114000046],
              [-159.28962154899992, 55.76788971600007],
              [-159.3021134109999, 55.75922272300005],
              [-159.31810462099992, 55.76776764500005],
              [-159.32860266799992, 55.77838776200008],
              [-159.3447159499999, 55.78388092700004],
              [-159.3622940749999, 55.78628164300005],
              [-159.35985266799992, 55.798163153000075],
              [-159.33283443899992, 55.81244538000004],
              [-159.3127335279999, 55.81122467700004],
            ],
          ],
          [
            [
              [-156.6804093089999, 56.03900788000004],
              [-156.68053137899992, 56.03693268400008],
              [-156.67735755099991, 56.03359609600005],
              [-156.67821204299992, 56.030462958000044],
              [-156.68085689999992, 56.02415599200003],
              [-156.68175208199992, 56.019517320000034],
              [-156.68073482999992, 56.01805247600004],
              [-156.6800430979999, 56.01666901200008],
              [-156.68366451699993, 56.01243724200003],
              [-156.69493567599991, 56.00934479400007],
              [-156.70636959499993, 56.01422760600008],
              [-156.7181290359999, 56.02167389500005],
              [-156.73407955599993, 56.02619049700007],
              [-156.74616451699993, 56.03489817900004],
              [-156.74494381399992, 56.04092031500005],
              [-156.7347305979999, 56.03998444200005],
              [-156.72516842399992, 56.04132721600007],
              [-156.71686764199993, 56.04450104400007],
              [-156.70978756399992, 56.05109284100007],
              [-156.7076309889999, 56.06102122600004],
              [-156.70128333199992, 56.06614817900004],
              [-156.69013424399992, 56.06045156500005],
              [-156.67890377499992, 56.04596588700008],
              [-156.67804928299992, 56.04148997600004],
              [-156.6804093089999, 56.03900788000004],
            ],
          ],
          [
            [
              [-156.7798966139999, 56.18964264500005],
              [-156.76667232999992, 56.17853424700007],
              [-156.76655025899993, 56.167669989000046],
              [-156.7745255199999, 56.153225002000056],
              [-156.79206295499992, 56.15302155200004],
              [-156.8052872389999, 56.16478099200003],
              [-156.80939693899992, 56.178900458000044],
              [-156.8093155589999, 56.19013092700004],
              [-156.8068741529999, 56.197333075000074],
              [-156.80247962099992, 56.20066966400003],
              [-156.79963131399992, 56.205511786000045],
              [-156.7994278639999, 56.21173737200007],
              [-156.79259192599991, 56.220689195000034],
              [-156.7783096999999, 56.22671133000006],
              [-156.7744034499999, 56.22418854400007],
              [-156.78014075399992, 56.21792226800005],
              [-156.78339596299992, 56.209051825000074],
              [-156.78388424399992, 56.19871653900003],
              [-156.7798966139999, 56.18964264500005],
            ],
          ],
          [
            [
              [-157.81232662699992, 56.34288157800006],
              [-157.80732174399992, 56.33588288000004],
              [-157.8060196609999, 56.32880280200004],
              [-157.81244869699992, 56.32330963700008],
              [-157.82188880099991, 56.31753164300005],
              [-157.83332271999993, 56.313666083000044],
              [-157.84882564999992, 56.31981028900003],
              [-157.8674210279999, 56.32925039300005],
              [-157.88487708199992, 56.33356354400007],
              [-157.89838619699992, 56.339056708000044],
              [-157.89740963399993, 56.34739817900004],
              [-157.8565567699999, 56.36212799700007],
              [-157.8261612619999, 56.36163971600007],
              [-157.81139075399992, 56.35614655200004],
              [-157.8112686839999, 56.35370514500005],
              [-157.8127335279999, 56.34902578300006],
              [-157.81232662699992, 56.34288157800006],
            ],
          ],
          [
            [
              [-153.83381100199992, 57.502020575000074],
              [-153.8306778639999, 57.485256252000056],
              [-153.82929439999992, 57.45107656500005],
              [-153.84357662699992, 57.43622467700004],
              [-153.8677872389999, 57.45258209800005],
              [-153.8814591139999, 57.47614166900007],
              [-153.8870743479999, 57.49494049700007],
              [-153.8878067699999, 57.508978583000044],
              [-153.8803604809999, 57.51520416900007],
              [-153.87584387899992, 57.52171458500004],
              [-153.8757218089999, 57.53310781500005],
              [-153.8679093089999, 57.54336172100005],
              [-153.84675045499992, 57.54059479400007],
              [-153.83149166599992, 57.52570221600007],
              [-153.83177649599992, 57.50999583500004],
              [-153.83381100199992, 57.502020575000074],
            ],
          ],
          [
            [
              [-152.34390214799993, 57.92332591400003],
              [-152.33637447799993, 57.92169830900008],
              [-152.32538814999992, 57.916001695000034],
              [-152.33014889199993, 57.907456773000035],
              [-152.3561905589999, 57.89394765800006],
              [-152.36066646999993, 57.88890208500004],
              [-152.3693741529999, 57.886419989000046],
              [-152.38117428299992, 57.88922760600008],
              [-152.39732825399992, 57.89606354400007],
              [-152.48595130099991, 57.91453685100004],
              [-152.50483150899993, 57.92572663000004],
              [-152.49262447799993, 57.940619208000044],
              [-152.4831436839999, 57.948472398000035],
              [-152.48786373599992, 57.95026276200008],
              [-152.48908443899992, 57.954006252000056],
              [-152.49030514199993, 57.956691799000055],
              [-152.49201412699992, 57.95722077000005],
              [-152.49445553299992, 57.958197333000044],
              [-152.49274654899992, 57.96157461100006],
              [-152.48395748599992, 57.96312083500004],
              [-152.47468014199993, 57.96088288000004],
              [-152.46344967399992, 57.95954010600008],
              [-152.43232174399992, 57.969183661000045],
              [-152.42280025899993, 57.96426015800006],
              [-152.42430579299992, 57.95209381700005],
              [-152.4171036449999, 57.94399648600006],
              [-152.4169815749999, 57.93886953300006],
              [-152.4229630199999, 57.93431224200003],
              [-152.4171036449999, 57.93036530200004],
              [-152.38829505099991, 57.92649974200003],
              [-152.3608292309999, 57.92674388200004],
              [-152.35529537699992, 57.92597077000005],
              [-152.34390214799993, 57.92332591400003],
            ],
          ],
          [
            [
              [-152.7443741529999, 57.98383209800005],
              [-152.73009192599991, 57.98224518400008],
              [-152.72919674399992, 57.973863023000035],
              [-152.7390030589999, 57.96857330900008],
              [-152.74164791599992, 57.962591864000046],
              [-152.73985755099991, 57.95164622600004],
              [-152.74799557199992, 57.939154364000046],
              [-152.76410885299993, 57.93008047100005],
              [-152.78595943899992, 57.92552317900004],
              [-152.80988521999993, 57.92910390800006],
              [-152.82709713399993, 57.93695709800005],
              [-152.85224361899992, 57.94407786700003],
              [-152.8607071609999, 57.95465729400007],
              [-152.85362708199992, 57.96743398600006],
              [-152.83307857999992, 57.974595445000034],
              [-152.75361080599993, 57.98065827000005],
              [-152.7443741529999, 57.98383209800005],
            ],
          ],
          [
            [
              [-152.81135006399992, 58.290350653000075],
              [-152.84935462099992, 58.30133698100008],
              [-152.9026993479999, 58.30768463700008],
              [-152.9190567699999, 58.31537506700005],
              [-152.93061275899993, 58.328558661000045],
              [-152.92467200399992, 58.338324286000045],
              [-152.9062393869999, 58.34218984600005],
              [-152.88959713399993, 58.34125397300005],
              [-152.86485755099991, 58.335150458000044],
              [-152.85826575399992, 58.334865627000056],
              [-152.8460587229999, 58.337591864000046],
              [-152.8421524729999, 58.33624909100007],
              [-152.84142005099991, 58.33413320500006],
              [-152.84284420499992, 58.33299388200004],
              [-152.84540768099993, 58.33344147300005],
              [-152.8428848949999, 58.33258698100008],
              [-152.82738196499992, 58.32982005400004],
              [-152.82404537699992, 58.32684967700004],
              [-152.8193253249999, 58.32111237200007],
              [-152.81073971299992, 58.31635163000004],
              [-152.79987545499992, 58.31659577000005],
              [-152.79548092399992, 58.312201239000046],
              [-152.7884415359999, 58.29791901200008],
              [-152.78241939999992, 58.28864166900007],
              [-152.79381262899992, 58.28742096600007],
              [-152.7954402329999, 58.28774648600006],
              [-152.80215410099993, 58.288763739000046],
              [-152.81135006399992, 58.290350653000075],
            ],
          ],
          [
            [
              [-160.25873775899993, 58.678615627000056],
              [-160.24815833199992, 58.67177969000005],
              [-160.24384518099993, 58.66266510600008],
              [-160.2524494699999, 58.65121136700009],
              [-160.2680457989999, 58.63814624200006],
              [-160.2771801209999, 58.63669272700008],
              [-160.2712967159999, 58.65176452900005],
              [-160.2778770559999, 58.66523412500004],
              [-160.29426546399992, 58.671120751000046],
              [-160.3162596759999, 58.683487176000085],
              [-160.31415768099993, 58.68976471600007],
              [-160.31415768099993, 58.69822825700004],
              [-160.3076322999999, 58.70519345800005],
              [-160.3015472259999, 58.70895169800008],
              [-160.31074739599993, 58.71585650600008],
              [-160.30124243499992, 58.729353976000084],
              [-160.2780655589999, 58.71857330900008],
              [-160.2759877029999, 58.70452091700008],
              [-160.27744902199993, 58.69103896100006],
              [-160.27586709899992, 58.67943625800007],
              [-160.25873775899993, 58.678615627000056],
            ],
          ],
          [
            [
              [-160.38459225199992, 58.73086172100005],
              [-160.3819473949999, 58.726629950000074],
              [-160.3814591139999, 58.72125885600008],
              [-160.38422604099992, 58.71076080900008],
              [-160.39301510299993, 58.699652411000045],
              [-160.40534420499992, 58.68939850500004],
              [-160.41718502499992, 58.68178945500006],
              [-160.4261368479999, 58.68036530200004],
              [-160.4330948559999, 58.68463776200008],
              [-160.4355362619999, 58.69114817900004],
              [-160.4236954419999, 58.72402578300006],
              [-160.41535396999993, 58.738348700000074],
              [-160.40599769199991, 58.75128233000004],
              [-160.39146887899992, 58.73769765800006],
              [-160.38459225199992, 58.73086172100005],
            ],
          ],
          [
            [
              [-150.2108455069999, 61.173041083000044],
              [-150.18451900899993, 61.174261786000045],
              [-150.1777237619999, 61.161363023000035],
              [-150.19623775899993, 61.14130280200004],
              [-150.2275284499999, 61.12718333500004],
              [-150.26524817599991, 61.12343984600005],
              [-150.27643795499992, 61.127386786000045],
              [-150.2599991529999, 61.13312409100007],
              [-150.2452286449999, 61.14606354400007],
              [-150.23176021999993, 61.16290924700007],
              [-150.22435462099992, 61.17039622600004],
              [-150.2108455069999, 61.173041083000044],
            ],
          ],
          [
            [
              [-164.5869034499999, 63.064439195000034],
              [-164.57721920499992, 63.06321849200003],
              [-164.56330318899992, 63.05621979400007],
              [-164.5670059889999, 63.04629140800006],
              [-164.58393307199992, 63.04205963700008],
              [-164.59968014199993, 63.04279205900008],
              [-164.61180579299992, 63.04669830900008],
              [-164.6115616529999, 63.055894273000035],
              [-164.5964249339999, 63.06321849200003],
              [-164.5869034499999, 63.064439195000034],
            ],
          ],
          [
            [
              [-179.1435033839999, 51.275051174000055],
              [-179.1341446609999, 51.28375885600008],
              [-179.11860104099992, 51.29018789300005],
              [-179.0882462229999, 51.296087958000044],
              [-179.08149166599992, 51.286444403000075],
              [-179.0694473949999, 51.26284414300005],
              [-179.06159420499992, 51.25454336100006],
              [-179.06159420499992, 51.247707424000055],
              [-179.08515377499992, 51.24290599200003],
              [-179.10309811099992, 51.22646719000005],
              [-179.1190079419999, 51.21539948100008],
              [-179.13666744699992, 51.22724030200004],
              [-179.12970943899992, 51.24359772300005],
              [-179.13447018099993, 51.25576406500005],
              [-179.14203854099992, 51.26557038000004],
              [-179.1435033839999, 51.275051174000055],
            ],
          ],
          [
            [
              [-178.9858292309999, 51.38422272300005],
              [-178.97223873599992, 51.396551825000074],
              [-178.9544164699999, 51.39520905200004],
              [-178.91755123599992, 51.37742747600004],
              [-178.90424557199992, 51.35382721600007],
              [-178.91388912699992, 51.345770575000074],
              [-178.93305416599992, 51.344183661000045],
              [-178.94831295499992, 51.339829820000034],
              [-178.9736221999999, 51.31244538000004],
              [-178.98688717399992, 51.307521877000056],
              [-178.99266516799992, 51.326239325000074],
              [-178.9904679029999, 51.33417389500005],
              [-178.9783829419999, 51.35382721600007],
              [-178.98029537699992, 51.36286041900007],
              [-178.98688717399992, 51.377020575000074],
              [-178.9858292309999, 51.38422272300005],
            ],
          ],
          [
            [
              [-178.7865291009999, 51.82990143400008],
              [-178.74848385299993, 51.817572333000044],
              [-178.74018307199992, 51.783636786000045],
              [-178.7604874339999, 51.75226471600007],
              [-178.80829830599993, 51.747300523000035],
              [-178.82270260299993, 51.75617096600007],
              [-178.8427221339999, 51.772650458000044],
              [-178.8581436839999, 51.78864166900007],
              [-178.8588761059999, 51.79572174700007],
              [-178.8460587229999, 51.805894273000035],
              [-178.83222408799992, 51.82575104400007],
              [-178.8135880199999, 51.839178778000075],
              [-178.7865291009999, 51.82990143400008],
            ],
          ],
          [
            [
              [-176.26471920499992, 51.81000397300005],
              [-176.27037512899992, 51.80646393400008],
              [-176.27391516799992, 51.80215078300006],
              [-176.2764786449999, 51.79633209800005],
              [-176.27900143099993, 51.788275458000044],
              [-176.2639054029999, 51.78314850500004],
              [-176.2585343089999, 51.782131252000056],
              [-176.2585343089999, 51.77529531500005],
              [-176.2744034499999, 51.77513255400004],
              [-176.2860815089999, 51.76850006700005],
              [-176.29255123599992, 51.756740627000056],
              [-176.29267330599993, 51.74115631700005],
              [-176.30011959499993, 51.74115631700005],
              [-176.30793209499993, 51.752386786000045],
              [-176.31586666599992, 51.74957916900007],
              [-176.33051510299993, 51.73029205900008],
              [-176.34068762899992, 51.725816148000035],
              [-176.35175533799992, 51.74087148600006],
              [-176.36095130099991, 51.733710028000075],
              [-176.3720596999999, 51.73672109600005],
              [-176.38560950399992, 51.73712799700007],
              [-176.39704342399992, 51.741888739000046],
              [-176.40192623599992, 51.75820547100005],
              [-176.40937252499992, 51.82367584800005],
              [-176.40387936099992, 51.82099030200004],
              [-176.3939102859999, 51.81826406500005],
              [-176.38886471299992, 51.81622955900008],
              [-176.39582271999993, 51.82632070500006],
              [-176.42304439999992, 51.85101959800005],
              [-176.3929337229999, 51.86310455900008],
              [-176.3471573559999, 51.86994049700007],
              [-176.30321204299992, 51.86896393400008],
              [-176.27900143099993, 51.85716380400004],
              [-176.29267330599993, 51.843736070000034],
              [-176.31183834499993, 51.83978913000004],
              [-176.3333634109999, 51.83934153900009],
              [-176.3541153639999, 51.83673737200007],
              [-176.3541153639999, 51.82990143400008],
              [-176.3456925119999, 51.83047109600005],
              [-176.3283585279999, 51.82916901200008],
              [-176.31993567599991, 51.82990143400008],
              [-176.3253067699999, 51.81439850500004],
              [-176.32738196499992, 51.81000397300005],
              [-176.29828854099992, 51.821478583000044],
              [-176.28302975199992, 51.82257721600007],
              [-176.26471920499992, 51.81622955900008],
              [-176.26471920499992, 51.81000397300005],
            ],
          ],
          [
            [
              [-176.01146399599992, 51.82990143400008],
              [-176.0189102859999, 51.82367584800005],
              [-175.9993790359999, 51.81195709800005],
              [-175.9909561839999, 51.81000397300005],
              [-175.99848385299993, 51.80255768400008],
              [-176.02623450399992, 51.822333075000074],
              [-176.0319718089999, 51.82990143400008],
              [-176.04963131399992, 51.82485586100006],
              [-176.0659073559999, 51.825384833000044],
              [-176.09748287699992, 51.82990143400008],
              [-176.1063940089999, 51.82648346600007],
              [-176.10492916599992, 51.81781647300005],
              [-176.09406490799992, 51.79572174700007],
              [-176.10920162699992, 51.79897695500006],
              [-176.12177486899992, 51.80565013200004],
              [-176.1308487619999, 51.81590403900009],
              [-176.13560950399992, 51.82990143400008],
              [-176.14838619699992, 51.81793854400007],
              [-176.15241451699993, 51.80451080900008],
              [-176.14964758999992, 51.790228583000044],
              [-176.14183508999992, 51.77529531500005],
              [-176.1486710279999, 51.77529531500005],
              [-176.1517227859999, 51.778998114000046],
              [-176.15900631399992, 51.791449286000045],
              [-176.1623429029999, 51.79572174700007],
              [-176.16295325399992, 51.798529364000046],
              [-176.16169186099992, 51.80731842700004],
              [-176.1623429029999, 51.81000397300005],
              [-176.16645260299993, 51.81126536700003],
              [-176.1752823559999, 51.81077708500004],
              [-176.19416256399992, 51.819973049000055],
              [-176.20832271999993, 51.820013739000046],
              [-176.21906490799992, 51.82436758000006],
              [-176.2237442699999, 51.84357330900008],
              [-176.20124264199993, 51.84088776200008],
              [-176.19904537699992, 51.848863023000035],
              [-176.21068274599992, 51.86713288000004],
              [-176.20453854099992, 51.88100820500006],
              [-176.19013424399992, 51.886704820000034],
              [-176.17389889199993, 51.88532135600008],
              [-176.1623429029999, 51.87767161700003],
              [-176.1370743479999, 51.86859772300005],
              [-176.12816321499992, 51.86399974200003],
              [-176.12816321499992, 51.85952383000006],
              [-176.12079830599993, 51.846869208000044],
              [-176.1119278639999, 51.83856842700004],
              [-176.10773678299992, 51.847316799000055],
              [-176.09386145699992, 51.858587958000044],
              [-176.0628555979999, 51.85496653900009],
              [-176.0302221339999, 51.84316640800006],
              [-176.01146399599992, 51.82990143400008],
            ],
          ],
          [
            [
              [-175.9909561839999, 51.88450755400004],
              [-175.98688717399992, 51.88686758000006],
              [-175.9749649729999, 51.89704010600008],
              [-175.97052975199992, 51.898138739000046],
              [-175.96259518099993, 51.88861725500004],
              [-175.95832271999993, 51.87474192900004],
              [-175.95677649599992, 51.86082591400009],
              [-175.95685787699992, 51.85101959800005],
              [-175.97699947799993, 51.85236237200007],
              [-176.10773678299992, 51.88450755400004],
              [-176.09235592399992, 51.89447663000004],
              [-176.07331295499992, 51.90379466400009],
              [-176.05256100199992, 51.91034577000005],
              [-176.02094479099992, 51.91278717700004],
              [-176.01032467399992, 51.91242096600007],
              [-176.0002335279999, 51.91010163000004],
              [-175.9909561839999, 51.905585028000075],
              [-175.99909420499992, 51.90448639500005],
              [-176.0189102859999, 51.898138739000046],
              [-176.0189102859999, 51.89199453300006],
              [-175.9909561839999, 51.88450755400004],
            ],
          ],
          [
            [
              [-177.8002823559999, 51.79572174700007],
              [-177.79718990799992, 51.786322333000044],
              [-177.79145260299993, 51.77968984600005],
              [-177.78327389199993, 51.77594635600008],
              [-177.77301998599992, 51.77529531500005],
              [-177.79662024599992, 51.75922272300005],
              [-177.80610104099992, 51.74559153900009],
              [-177.80744381399992, 51.72890859600005],
              [-177.8065079419999, 51.70331452000005],
              [-177.81037350199992, 51.695379950000074],
              [-177.83751380099991, 51.67536041900007],
              [-177.84784908799992, 51.671861070000034],
              [-177.8606664699999, 51.675034898000035],
              [-177.88288326699993, 51.68585846600007],
              [-177.88520260299993, 51.67450592700004],
              [-177.89252682199992, 51.66791413000004],
              [-177.90355383999992, 51.66510651200008],
              [-177.9169815749999, 51.66543203300006],
              [-177.9095352859999, 51.65924713700008],
              [-177.91612708199992, 51.64533112200007],
              [-177.9130346339999, 51.630926825000074],
              [-177.8958634109999, 51.603949286000045],
              [-177.90672766799992, 51.598089911000045],
              [-177.92011471299992, 51.59650299700007],
              [-177.9334610669999, 51.59870026200008],
              [-177.9443253249999, 51.603949286000045],
              [-177.94884192599991, 51.61078522300005],
              [-177.95380611899992, 51.630113023000035],
              [-177.9579971999999, 51.63743724200003],
              [-177.9736221999999, 51.64516836100006],
              [-178.01117916599992, 51.648138739000046],
              [-178.03246008999992, 51.65924713700008],
              [-178.04462643099993, 51.66559479400007],
              [-178.08250891799992, 51.66250234600005],
              [-178.10138912699992, 51.66543203300006],
              [-178.09190833199992, 51.69057851800005],
              [-178.0799454419999, 51.70034414300005],
              [-178.02936764199993, 51.70014069200005],
              [-178.0190323559999, 51.702337958000044],
              [-178.00214596299992, 51.71173737200007],
              [-177.97455807199992, 51.71548086100006],
              [-177.96308346299992, 51.72052643400008],
              [-177.95482337099992, 51.72907135600008],
              [-177.9505102199999, 51.74115631700005],
              [-177.95539303299992, 51.763739325000074],
              [-177.9739884109999, 51.77826569200005],
              [-177.99889075399992, 51.786037502000056],
              [-178.0462540359999, 51.791449286000045],
              [-178.06208248599992, 51.79962799700007],
              [-178.09516354099992, 51.82367584800005],
              [-178.18956458199992, 51.85496653900009],
              [-178.2138158839999, 51.87604401200008],
              [-178.1770727199999, 51.905585028000075],
              [-178.1478165359999, 51.91469961100006],
              [-177.9522598949999, 51.92475006700005],
              [-177.93126380099991, 51.91864655200004],
              [-177.93126380099991, 51.911810614000046],
              [-177.8954971999999, 51.88922760600008],
              [-177.88288326699993, 51.88450755400004],
              [-177.88288326699993, 51.87767161700003],
              [-177.89268958199992, 51.86701080900008],
              [-177.84544837099992, 51.85187409100007],
              [-177.84064693899992, 51.83673737200007],
              [-177.7089737619999, 51.83730703300006],
              [-177.64818274599992, 51.84760163000004],
              [-177.6221817699999, 51.85716380400004],
              [-177.62669837099992, 51.83258698100008],
              [-177.6474096339999, 51.82050202000005],
              [-177.6751602859999, 51.81655508000006],
              [-177.70099850199992, 51.81622955900008],
              [-177.7267960279999, 51.812201239000046],
              [-177.77521725199992, 51.796535549000055],
              [-177.8002823559999, 51.79572174700007],
            ],
          ],
          [
            [
              [-177.1221817699999, 51.932928778000075],
              [-177.09980221299992, 51.93036530200004],
              [-177.0748184889999, 51.92259349200003],
              [-177.0546768869999, 51.909816799000055],
              [-177.04682369699992, 51.89199453300006],
              [-177.0611466139999, 51.88784414300005],
              [-177.06696529899992, 51.88157786700003],
              [-177.0677384109999, 51.874253648000035],
              [-177.06725012899992, 51.86713288000004],
              [-177.07433020699992, 51.85883209800005],
              [-177.12189693899992, 51.84357330900008],
              [-177.1369522779999, 51.82282135600008],
              [-177.12897701699993, 51.78359609600005],
              [-177.14240475199992, 51.76162344000005],
              [-177.12775631399992, 51.74746328300006],
              [-177.1323136059999, 51.73065827000005],
              [-177.15668697799993, 51.70014069200005],
              [-177.19261633999992, 51.70917389500005],
              [-177.2038468089999, 51.71381256700005],
              [-177.2020971339999, 51.707098700000074],
              [-177.2024633449999, 51.702053127000056],
              [-177.20356197799993, 51.69757721600007],
              [-177.2038468089999, 51.692694403000075],
              [-177.22382564999992, 51.69708893400008],
              [-177.24921627499992, 51.687201239000046],
              [-177.27765865799992, 51.680121161000045],
              [-177.3068741529999, 51.692694403000075],
              [-177.3150528639999, 51.68732330900008],
              [-177.31956946499992, 51.68695709800005],
              [-177.32734127499992, 51.692694403000075],
              [-177.32831783799992, 51.694240627000056],
              [-177.34101314999992, 51.706366278000075],
              [-177.3567602199999, 51.71775950700004],
              [-177.37079830599993, 51.723863023000035],
              [-177.38544674399992, 51.72638580900008],
              [-177.4361466139999, 51.725897528000075],
              [-177.45433508999992, 51.72296784100007],
              [-177.46764075399992, 51.71694570500006],
              [-177.48481197799993, 51.70587799700007],
              [-177.49885006399992, 51.70331452000005],
              [-177.53278561099992, 51.706366278000075],
              [-177.5985815089999, 51.70270416900007],
              [-177.62958736899992, 51.69163646000004],
              [-177.64264889199993, 51.668850002000056],
              [-177.64806067599991, 51.654730536000045],
              [-177.6600235669999, 51.65298086100006],
              [-177.67198645699992, 51.65912506700005],
              [-177.67743893099993, 51.668850002000056],
              [-177.67878170499992, 51.67853424700007],
              [-177.68333899599992, 51.68626536700003],
              [-177.6917618479999, 51.69330475500004],
              [-177.70470130099991, 51.70014069200005],
              [-177.70470130099991, 51.706366278000075],
              [-177.68818111899992, 51.712103583000044],
              [-177.65904700399992, 51.72992584800005],
              [-177.6463516919999, 51.733710028000075],
              [-177.6263321609999, 51.73159414300005],
              [-177.5888158839999, 51.72215403900009],
              [-177.5706680979999, 51.720038153000075],
              [-177.52289791599992, 51.720038153000075],
              [-177.51899166599992, 51.72333405200004],
              [-177.51911373599992, 51.73061758000006],
              [-177.5175675119999, 51.73786041900007],
              [-177.5089005199999, 51.74115631700005],
              [-177.47472083199992, 51.74115631700005],
              [-177.4719945949999, 51.74331289300005],
              [-177.46906490799992, 51.74795156500005],
              [-177.4638565749999, 51.75263092700004],
              [-177.45429439999992, 51.754787502000056],
              [-177.38776607999992, 51.76166413000004],
              [-177.2924698559999, 51.78278229400007],
              [-177.21552486899992, 51.818793036000045],
              [-177.2038468089999, 51.87018463700008],
              [-177.19928951699993, 51.878607489000046],
              [-177.19550533799992, 51.90094635600008],
              [-177.1901749339999, 51.911810614000046],
              [-177.19440670499992, 51.92999909100007],
              [-177.17345130099991, 51.935614325000074],
              [-177.1221817699999, 51.932928778000075],
            ],
          ],
          [
            [
              [-175.7241104809999, 51.973863023000035],
              [-175.7076309889999, 51.973863023000035],
              [-175.6784561839999, 51.96698639500005],
              [-175.66205807199992, 51.96702708500004],
              [-175.66205807199992, 51.95962148600006],
              [-175.70392818899992, 51.952378648000035],
              [-175.7104386059999, 51.95001862200007],
              [-175.71495520699992, 51.93732330900008],
              [-175.7260636059999, 51.93305084800005],
              [-175.73969479099992, 51.93455638200004],
              [-175.75202389199993, 51.939154364000046],
              [-175.74592037699992, 51.948431708000044],
              [-175.7241104809999, 51.973863023000035],
            ],
          ],
          [
            [
              [-176.43724524599992, 51.788275458000044],
              [-176.4339493479999, 51.77806224200003],
              [-176.42979895699992, 51.768866278000075],
              [-176.42393958199992, 51.760972398000035],
              [-176.41559811099992, 51.754787502000056],
              [-176.4272354809999, 51.741441148000035],
              [-176.45478268099993, 51.730454820000034],
              [-176.47081458199992, 51.720038153000075],
              [-176.49079342399992, 51.75421784100007],
              [-176.5229386059999, 51.741522528000075],
              [-176.5881241529999, 51.68585846600007],
              [-176.5936173169999, 51.69611237200007],
              [-176.60126705599993, 51.70258209800005],
              [-176.6107071609999, 51.704291083000044],
              [-176.62165279899992, 51.70014069200005],
              [-176.61481686099992, 51.692694403000075],
              [-176.6296280589999, 51.69196198100008],
              [-176.64203854099992, 51.686835028000075],
              [-176.65196692599991, 51.68109772300005],
              [-176.65949459499993, 51.67841217700004],
              [-176.6712540359999, 51.680853583000044],
              [-176.6838272779999, 51.68549225500004],
              [-176.69688880099991, 51.68846263200004],
              [-176.71039791599992, 51.68585846600007],
              [-176.71979732999992, 51.66901276200008],
              [-176.72431393099993, 51.65717194200005],
              [-176.72126217399992, 51.65176015800006],
              [-176.7111710279999, 51.647772528000075],
              [-176.7068985669999, 51.638332424000055],
              [-176.70710201699993, 51.62685781500005],
              [-176.71039791599992, 51.61701080900008],
              [-176.7513321609999, 51.63743724200003],
              [-176.7713516919999, 51.61961497600004],
              [-176.78449459499993, 51.61286041900007],
              [-176.7997533839999, 51.61078522300005],
              [-176.8144425119999, 51.61554596600007],
              [-176.82477779899992, 51.62482330900008],
              [-176.8242081369999, 51.63373444200005],
              [-176.80658932199992, 51.63743724200003],
              [-176.80658932199992, 51.644964911000045],
              [-176.81940670499992, 51.65989817900004],
              [-176.82831783799992, 51.673814195000034],
              [-176.82970130099991, 51.69057851800005],
              [-176.82026119699992, 51.71381256700005],
              [-176.8270971339999, 51.720038153000075],
              [-176.8959854809999, 51.63743724200003],
              [-176.90278072799993, 51.626939195000034],
              [-176.9094945949999, 51.613348700000074],
              [-176.91706295499992, 51.601548570000034],
              [-176.9263809889999, 51.59650299700007],
              [-176.9521378249999, 51.59218984600005],
              [-176.9698380199999, 51.592678127000056],
              [-176.9778946609999, 51.60028717700004],
              [-176.9755753249999, 51.64712148600006],
              [-176.96662350199992, 51.669134833000044],
              [-176.90217037699992, 51.70014069200005],
              [-176.8899633449999, 51.710150458000044],
              [-176.8821508449999, 51.720363674000055],
              [-176.87934322799993, 51.73236725500004],
              [-176.8823136059999, 51.747300523000035],
              [-176.8616837229999, 51.74795156500005],
              [-176.8549698559999, 51.747300523000035],
              [-176.85789954299992, 51.75177643400008],
              [-176.8611954419999, 51.754787502000056],
              [-176.82026119699992, 51.76850006700005],
              [-176.82026119699992, 51.77529531500005],
              [-176.84227454299992, 51.77383047100005],
              [-176.8665665359999, 51.768866278000075],
              [-176.88988196499992, 51.76715729400007],
              [-176.90900631399992, 51.77529531500005],
              [-176.91510982999992, 51.79193756700005],
              [-176.90477454299992, 51.80756256700005],
              [-176.88556881399992, 51.81915924700007],
              [-176.86493893099993, 51.82367584800005],
              [-176.8549698559999, 51.81818268400008],
              [-176.84654700399992, 51.805975653000075],
              [-176.83368893099993, 51.793850002000056],
              [-176.81029212099992, 51.788275458000044],
              [-176.7265518869999, 51.78196849200003],
              [-176.70417232999992, 51.788275458000044],
              [-176.7216690749999, 51.79555898600006],
              [-176.75597083199992, 51.80548737200007],
              [-176.7690323559999, 51.81317780200004],
              [-176.77985592399992, 51.82904694200005],
              [-176.77851314999992, 51.84316640800006],
              [-176.76720130099991, 51.85333893400008],
              [-176.74823971299992, 51.85716380400004],
              [-176.7060033839999, 51.85968659100007],
              [-176.7587377589999, 51.883978583000044],
              [-176.7792862619999, 51.90867747600004],
              [-176.78180904899992, 51.93646881700005],
              [-176.7763158839999, 51.94448476800005],
              [-176.7587784499999, 51.95343659100007],
              [-176.74164791599992, 51.958319403000075],
              [-176.72236080599993, 51.96051666900007],
              [-176.68305416599992, 51.95962148600006],
              [-176.6605118479999, 51.953192450000074],
              [-176.6486710279999, 51.95180898600006],
              [-176.63837643099993, 51.95648834800005],
              [-176.62677975199992, 51.97516510600008],
              [-176.62165279899992, 51.980129299000055],
              [-176.60480709499993, 51.986761786000045],
              [-176.58372962099992, 51.98969147300005],
              [-176.56269283799992, 51.98786041900007],
              [-176.5458878249999, 51.980129299000055],
              [-176.5533341139999, 51.973863023000035],
              [-176.55988521999993, 51.96043528900003],
              [-176.56029212099992, 51.94741445500006],
              [-176.55378170499992, 51.93732330900008],
              [-176.5396622389999, 51.932928778000075],
              [-176.5494278639999, 51.914129950000074],
              [-176.56391354099992, 51.90912506700005],
              [-176.58149166599992, 51.90916575700004],
              [-176.6005346339999, 51.905585028000075],
              [-176.61139889199993, 51.89545319200005],
              [-176.6185196609999, 51.88141510600008],
              [-176.6269425119999, 51.86908600500004],
              [-176.64146887899992, 51.86399974200003],
              [-176.64146887899992, 51.85716380400004],
              [-176.5881241529999, 51.85716380400004],
              [-176.5956925119999, 51.84935130400004],
              [-176.5980118479999, 51.84393952000005],
              [-176.59691321499992, 51.838324286000045],
              [-176.59430904899992, 51.82990143400008],
              [-176.5690811839999, 51.839056708000044],
              [-176.54938717399992, 51.83551666900007],
              [-176.52985592399992, 51.82770416900007],
              [-176.50495357999992, 51.82367584800005],
              [-176.50495357999992, 51.82990143400008],
              [-176.51178951699993, 51.82990143400008],
              [-176.50401770699992, 51.83893463700008],
              [-176.4916886059999, 51.843736070000034],
              [-176.4639786449999, 51.85101959800005],
              [-176.4407852859999, 51.841864325000074],
              [-176.42768307199992, 51.83429596600007],
              [-176.4263809889999, 51.82680898600006],
              [-176.4315079419999, 51.81500885600008],
              [-176.42792721299992, 51.803900458000044],
              [-176.42625891799992, 51.79466380400004],
              [-176.43724524599992, 51.788275458000044],
            ],
          ],
          [
            [
              [-175.86750240799992, 51.987494208000044],
              [-175.8509415359999, 51.98883698100008],
              [-175.8347061839999, 51.99274323100008],
              [-175.81956946499992, 51.99396393400008],
              [-175.8060196609999, 51.987494208000044],
              [-175.87641354099992, 51.96893952000005],
              [-175.91034908799992, 51.967230536000045],
              [-175.95002193899992, 51.973863023000035],
              [-175.93915768099993, 51.98647695500006],
              [-175.91950436099992, 51.989447333000044],
              [-175.89789791599992, 51.98627350500004],
              [-175.88117428299992, 51.980129299000055],
              [-175.88044186099992, 51.984808661000045],
              [-175.8787735669999, 51.98777903900003],
              [-175.8768204419999, 51.99046458500004],
              [-175.87494869699992, 51.99437083500004],
              [-175.86750240799992, 51.987494208000044],
            ],
          ],
          [
            [
              [-176.13874264199993, 51.99437083500004],
              [-176.15546627499992, 51.995347398000035],
              [-176.16486568899992, 51.99860260600008],
              [-176.17060299399992, 52.00503164300005],
              [-176.19001217399992, 52.03851959800005],
              [-176.19452877499992, 52.05109284100007],
              [-176.1933487619999, 52.05955638200004],
              [-176.18720455599993, 52.068060614000046],
              [-176.17552649599992, 52.08966705900008],
              [-176.16913814999992, 52.09739817900004],
              [-176.14325924399992, 52.107123114000046],
              [-176.10541744699992, 52.11074453300006],
              [-176.0687149729999, 52.10765208500004],
              [-176.0462540359999, 52.09739817900004],
              [-176.00531979099992, 52.06781647300005],
              [-175.99848385299993, 52.05955638200004],
              [-175.99848385299993, 52.04669830900008],
              [-175.9955948559999, 52.03294505400004],
              [-175.98554439999992, 52.02643463700008],
              [-175.96369381399992, 52.03534577000005],
              [-175.97508704299992, 52.021918036000045],
              [-176.0302628249999, 52.01284414300005],
              [-176.0462540359999, 51.99437083500004],
              [-176.02887936099992, 51.99599844000005],
              [-176.02131100199992, 51.99070872600004],
              [-176.0218399729999, 51.981350002000056],
              [-176.02887936099992, 51.97044505400004],
              [-176.04303951699993, 51.96336497600004],
              [-176.0577286449999, 51.96694570500006],
              [-176.08039303299992, 51.980129299000055],
              [-176.12287350199992, 51.992621161000045],
              [-176.13874264199993, 51.99437083500004],
            ],
          ],
          [
            [
              [-173.1234024729999, 52.10797760600008],
              [-173.1140030589999, 52.10130442900004],
              [-173.10167395699992, 52.09829336100006],
              [-172.9557999339999, 52.089911200000074],
              [-172.9744766919999, 52.08388906500005],
              [-173.0169571609999, 52.08161041900007],
              [-173.03404700399992, 52.07318756700005],
              [-173.0518692699999, 52.06854889500005],
              [-173.1028946609999, 52.07469310100004],
              [-173.1397598949999, 52.058661200000074],
              [-173.16490637899992, 52.056341864000046],
              [-173.18993079299992, 52.05882396000004],
              [-173.21393795499992, 52.070379950000074],
              [-173.22675533799992, 52.074204820000034],
              [-173.23859615799992, 52.07575104400007],
              [-173.24384518099993, 52.07318756700005],
              [-173.24762936099992, 52.06329987200007],
              [-173.2564591139999, 52.06305573100008],
              [-173.27391516799992, 52.06948476800005],
              [-173.30711829299992, 52.06346263200004],
              [-173.37653561099992, 52.038763739000046],
              [-173.41454016799992, 52.03534577000005],
              [-173.44969641799992, 52.04437897300005],
              [-173.46296139199993, 52.04279205900008],
              [-173.4725235669999, 52.03733958500004],
              [-173.4842423169999, 52.024725653000075],
              [-173.4902237619999, 52.02167389500005],
              [-173.50055904899992, 52.02285390800006],
              [-173.51573645699992, 52.032416083000044],
              [-173.5237930979999, 52.03534577000005],
              [-173.5380346339999, 52.03473541900007],
              [-173.5499161449999, 52.03217194200005],
              [-173.5609024729999, 52.03115469000005],
              [-173.57221432199992, 52.03534577000005],
              [-173.55781002499992, 52.044623114000046],
              [-173.5706680979999, 52.048529364000046],
              [-173.68207760299993, 52.04901764500005],
              [-173.67747962099992, 52.055853583000044],
              [-173.67463131399992, 52.06268952000005],
              [-173.6888321609999, 52.06948476800005],
              [-173.71540279899992, 52.05499909100007],
              [-173.7491348949999, 52.04779694200005],
              [-173.83600826699993, 52.04336172100005],
              [-173.8874405589999, 52.05646393400008],
              [-173.92206783799992, 52.05939362200007],
              [-173.92988033799992, 52.06631094000005],
              [-173.92162024599992, 52.08372630400004],
              [-173.93089758999992, 52.08734772300005],
              [-173.95636959499993, 52.089911200000074],
              [-173.9651993479999, 52.09324778900003],
              [-173.98151607999992, 52.10130442900004],
              [-173.99054928299992, 52.10423411700003],
              [-173.99738521999993, 52.104396877000056],
              [-174.01496334499993, 52.102728583000044],
              [-174.02464758999992, 52.10423411700003],
              [-174.03331458199992, 52.10846588700008],
              [-174.05048580599993, 52.12026601800005],
              [-174.05943762899992, 52.124701239000046],
              [-174.05866451699993, 52.12909577000005],
              [-174.05748450399992, 52.132147528000075],
              [-174.05536861899992, 52.13495514500005],
              [-174.05195064999992, 52.138373114000046],
              [-174.04466712099992, 52.13255442900004],
              [-174.02363033799992, 52.128892320000034],
              [-174.01097571499992, 52.124701239000046],
              [-173.9588516919999, 52.12299225500004],
              [-173.94208736899992, 52.124701239000046],
              [-173.9022110669999, 52.13751862200007],
              [-173.8874405589999, 52.138373114000046],
              [-173.89264889199993, 52.124335028000075],
              [-173.89582271999993, 52.11798737200007],
              [-173.9011124339999, 52.11172109600005],
              [-173.88581295499992, 52.11302317900004],
              [-173.85737057199992, 52.12335846600007],
              [-173.84650631399992, 52.124701239000046],
              [-173.8388158839999, 52.119574286000045],
              [-173.80553137899992, 52.089911200000074],
              [-173.79023189999992, 52.115301825000074],
              [-173.76520748599992, 52.127386786000045],
              [-173.73363196499992, 52.130845445000034],
              [-173.69880123599992, 52.130926825000074],
              [-173.68537350199992, 52.133978583000044],
              [-173.66026770699992, 52.14801666900007],
              [-173.64728756399992, 52.152044989000046],
              [-173.6308487619999, 52.151271877000056],
              [-173.61860104099992, 52.14789459800005],
              [-173.6068009109999, 52.14667389500005],
              [-173.5920304029999, 52.152044989000046],
              [-173.57526607999992, 52.143744208000044],
              [-173.54808508999992, 52.14752838700008],
              [-173.53119869699992, 52.144964911000045],
              [-173.54487057199992, 52.11790599200003],
              [-173.5312393869999, 52.124701239000046],
              [-173.5208634109999, 52.115301825000074],
              [-173.50800533799992, 52.11155833500004],
              [-173.43016516799992, 52.112209377000056],
              [-173.4222305979999, 52.11676666900007],
              [-173.41454016799992, 52.11790599200003],
              [-173.40839596299992, 52.11579010600008],
              [-173.40729732999992, 52.11107005400004],
              [-173.40558834499993, 52.10639069200005],
              [-173.3974503249999, 52.10423411700003],
              [-173.3701065749999, 52.108587958000044],
              [-173.36021887899992, 52.105169989000046],
              [-173.35309811099992, 52.089911200000074],
              [-173.33063717399992, 52.09975820500006],
              [-173.3040665359999, 52.10773346600007],
              [-173.27623450399992, 52.11225006700005],
              [-173.25007076699993, 52.11172109600005],
              [-173.2493790359999, 52.10960521000004],
              [-173.24579830599993, 52.104803778000075],
              [-173.2409561839999, 52.09979889500005],
              [-173.23639889199993, 52.09739817900004],
              [-173.22813880099991, 52.09804922100005],
              [-173.2161759109999, 52.10260651200008],
              [-173.20905514199993, 52.10423411700003],
              [-173.15782630099991, 52.10423411700003],
              [-173.14045162699992, 52.109442450000074],
              [-173.1308487619999, 52.11115143400008],
              [-173.1234024729999, 52.10797760600008],
            ],
          ],
          [
            [
              [-172.4071752589999, 52.38544342700004],
              [-172.3835343089999, 52.368801174000055],
              [-172.33710689999992, 52.35838450700004],
              [-172.30158443899992, 52.34430573100008],
              [-172.3109024729999, 52.316473700000074],
              [-172.32599850199992, 52.309475002000056],
              [-172.38727779899992, 52.29604726800005],
              [-172.41279049399992, 52.278550523000035],
              [-172.4257706369999, 52.276678778000075],
              [-172.4412735669999, 52.28921133000006],
              [-172.4794408839999, 52.26479726800005],
              [-172.52940833199992, 52.25023021000004],
              [-172.58324133999992, 52.24823639500005],
              [-172.6330460279999, 52.26129791900007],
              [-172.59882564999992, 52.31342194200005],
              [-172.5790502589999, 52.33584219000005],
              [-172.5579727859999, 52.35065338700008],
              [-172.49653072799993, 52.371161200000074],
              [-172.4412735669999, 52.39907461100006],
              [-172.4355362619999, 52.393784898000035],
              [-172.42735755099991, 52.39057038000004],
              [-172.4071752589999, 52.38544342700004],
            ],
          ],
          [
            [
              [-174.05195064999992, 52.24079010600008],
              [-174.08918209499993, 52.22711823100008],
              [-174.18073482999992, 52.23069896000004],
              [-174.20282955599993, 52.21283600500004],
              [-174.1927384109999, 52.20136139500005],
              [-174.1806534499999, 52.190334377000056],
              [-174.15436764199993, 52.171942450000074],
              [-174.11750240799992, 52.15298086100006],
              [-174.1002091139999, 52.14093659100007],
              [-174.09296627499992, 52.127834377000056],
              [-174.09894771999993, 52.112982489000046],
              [-174.1135147779999, 52.112494208000044],
              [-174.14789791599992, 52.127834377000056],
              [-174.1568497389999, 52.12909577000005],
              [-174.16380774599992, 52.125433661000045],
              [-174.1705216139999, 52.120347398000035],
              [-174.17857825399992, 52.11790599200003],
              [-174.18964596299992, 52.11933014500005],
              [-174.21100826699993, 52.124660549000055],
              [-174.2232559889999, 52.124701239000046],
              [-174.21650143099993, 52.11660390800006],
              [-174.21320553299992, 52.10797760600008],
              [-174.21320553299992, 52.09906647300005],
              [-174.21642005099991, 52.089911200000074],
              [-174.23005123599992, 52.09560781500005],
              [-174.27106686099992, 52.09739817900004],
              [-174.27924557199992, 52.100775458000044],
              [-174.30052649599992, 52.11322663000004],
              [-174.30585689999992, 52.11790599200003],
              [-174.3210343089999, 52.12335846600007],
              [-174.33869381399992, 52.12055084800005],
              [-174.35688229099992, 52.11481354400007],
              [-174.3737686839999, 52.11172109600005],
              [-174.4131973949999, 52.11383698100008],
              [-174.4299210279999, 52.11005280200004],
              [-174.4355362619999, 52.09739817900004],
              [-174.42133541599992, 52.10228099200003],
              [-174.40619869699992, 52.10419342700004],
              [-174.3741348949999, 52.10423411700003],
              [-174.3741348949999, 52.09739817900004],
              [-174.39277096299992, 52.09284088700008],
              [-174.39814205599993, 52.05263906500005],
              [-174.41136633999992, 52.04279205900008],
              [-174.43586178299992, 52.04450104400007],
              [-174.4444473949999, 52.050848700000074],
              [-174.44916744699992, 52.06342194200005],
              [-174.4622696609999, 52.08372630400004],
              [-174.4756973949999, 52.06891510600008],
              [-174.4932755199999, 52.07200755400004],
              [-174.51093502499992, 52.08437734600005],
              [-174.52497311099992, 52.09739817900004],
              [-174.52607174399992, 52.08197663000004],
              [-174.49779212099992, 52.053168036000045],
              [-174.49018307199992, 52.03534577000005],
              [-174.5048315089999, 52.04751211100006],
              [-174.52314205599993, 52.05731842700004],
              [-174.54218502499992, 52.061428127000056],
              [-174.55907141799992, 52.05646393400008],
              [-174.5526016919999, 52.05296458500004],
              [-174.54364986899992, 52.04572174700007],
              [-174.5385636059999, 52.04279205900008],
              [-174.5385636059999, 52.03534577000005],
              [-174.5506485669999, 52.036769924000055],
              [-174.5712784499999, 52.04169342700004],
              [-174.5829565089999, 52.04279205900008],
              [-174.5923966139999, 52.040716864000046],
              [-174.6154679029999, 52.031317450000074],
              [-174.62739010299993, 52.028509833000044],
              [-174.6507462229999, 52.03266022300005],
              [-174.69420325399992, 52.05158112200007],
              [-174.70929928299992, 52.04901764500005],
              [-174.69933020699992, 52.04254791900007],
              [-174.69770260299993, 52.03583405200004],
              [-174.7037247389999, 52.030585028000075],
              [-174.71674557199992, 52.028509833000044],
              [-174.7021378249999, 52.02057526200008],
              [-174.71528072799993, 52.016506252000056],
              [-174.7542618479999, 52.014837958000044],
              [-174.7630509109999, 52.01699453300006],
              [-174.78327389199993, 52.02635325700004],
              [-174.8880509109999, 52.04279205900008],
              [-174.8990372389999, 52.03978099200003],
              [-174.91864986899992, 52.030462958000044],
              [-174.92902584499993, 52.028509833000044],
              [-174.96747799399992, 52.030585028000075],
              [-174.98481197799993, 52.02789948100008],
              [-175.0009659499999, 52.01825592700004],
              [-175.0350235669999, 52.004339911000045],
              [-175.32355709499993, 52.00775788000004],
              [-175.34052486899992, 52.014837958000044],
              [-175.3107804029999, 52.026678778000075],
              [-175.21019446499992, 52.03534577000005],
              [-175.16132564999992, 52.048529364000046],
              [-175.14130611899992, 52.04901764500005],
              [-175.1245011059999, 52.04755280200004],
              [-175.11021887899992, 52.044623114000046],
              [-175.10631262899992, 52.038763739000046],
              [-175.12079830599993, 52.028509833000044],
              [-175.1041153639999, 52.02985260600008],
              [-175.07599850199992, 52.04059479400007],
              [-175.0593155589999, 52.04279205900008],
              [-175.0424698559999, 52.038723049000055],
              [-175.02985592399992, 52.032538153000075],
              [-175.01984615799992, 52.03148021000004],
              [-175.01093502499992, 52.04279205900008],
              [-175.02350826699993, 52.04840729400007],
              [-175.02704830599993, 52.054022528000075],
              [-175.02460689999992, 52.066107489000046],
              [-175.01996822799993, 52.07453034100007],
              [-175.00995846299992, 52.07477448100008],
              [-175.00047766799992, 52.071478583000044],
              [-174.99726314999992, 52.06948476800005],
              [-174.9941300119999, 52.06631094000005],
              [-174.9846085279999, 52.060532945000034],
              [-174.9745987619999, 52.05833567900004],
              [-174.96996008999992, 52.066107489000046],
              [-174.9659317699999, 52.079738674000055],
              [-174.95673580599993, 52.08218008000006],
              [-174.9389542309999, 52.07689036700003],
              [-174.9302872389999, 52.08661530200004],
              [-174.91779537699992, 52.104681708000044],
              [-174.90656490799992, 52.114894924000055],
              [-174.9017227859999, 52.100816148000035],
              [-174.89378821499992, 52.08893463700008],
              [-174.85509192599991, 52.104803778000075],
              [-174.8401993479999, 52.089911200000074],
              [-174.8249405589999, 52.09760163000004],
              [-174.80866451699993, 52.09804922100005],
              [-174.79450436099992, 52.091131903000075],
              [-174.78563391799992, 52.07689036700003],
              [-174.75548255099991, 52.09487539300005],
              [-174.7440079419999, 52.103501695000034],
              [-174.7440079419999, 52.11790599200003],
              [-174.72297115799992, 52.124701239000046],
              [-174.69782467399992, 52.110988674000055],
              [-174.6503800119999, 52.10431549700007],
              [-174.6015518869999, 52.10464101800005],
              [-174.5721329419999, 52.11172109600005],
              [-174.5921524729999, 52.115301825000074],
              [-174.5978897779999, 52.12262604400007],
              [-174.59068762899992, 52.13104889500005],
              [-174.5721329419999, 52.138373114000046],
              [-174.55162512899992, 52.139105536000045],
              [-174.52912350199992, 52.13711172100005],
              [-174.50947018099993, 52.139105536000045],
              [-174.49762936099992, 52.152044989000046],
              [-174.5267227859999, 52.15131256700005],
              [-174.54047604099992, 52.153225002000056],
              [-174.55284583199992, 52.15888092700004],
              [-174.54539954299992, 52.165716864000046],
              [-174.55003821499992, 52.16852448100008],
              [-174.55235755099991, 52.170803127000056],
              [-174.55907141799992, 52.179348049000055],
              [-174.4492081369999, 52.179348049000055],
              [-174.4244278639999, 52.17084381700005],
              [-174.41266842399992, 52.171210028000075],
              [-174.40766354099992, 52.18276601800005],
              [-174.4130346339999, 52.18960195500006],
              [-174.42560787699992, 52.19668203300006],
              [-174.4492081369999, 52.206691799000055],
              [-174.4492081369999, 52.21283600500004],
              [-174.3870743479999, 52.212958075000074],
              [-174.3611954419999, 52.20538971600007],
              [-174.3393448559999, 52.18618398600006],
              [-174.33088131399992, 52.202337958000044],
              [-174.3154190749999, 52.21466705900008],
              [-174.29828854099992, 52.21942780200004],
              [-174.28473873599992, 52.21283600500004],
              [-174.27765865799992, 52.21954987200007],
              [-174.2725723949999, 52.231350002000056],
              [-174.26764889199993, 52.23769765800006],
              [-174.2591446609999, 52.24091217700004],
              [-174.2363175119999, 52.24371979400007],
              [-174.2294815749999, 52.24823639500005],
              [-174.22826087099992, 52.26752350500004],
              [-174.2447403639999, 52.27415599200003],
              [-174.28473873599992, 52.27558014500005],
              [-174.29967200399992, 52.28314850500004],
              [-174.3095190089999, 52.293036200000074],
              [-174.3171280589999, 52.30267975500004],
              [-174.3256729809999, 52.30963776200008],
              [-174.34491939999992, 52.31537506700005],
              [-174.35529537699992, 52.31118398600006],
              [-174.35627193899992, 52.299261786000045],
              [-174.3467911449999, 52.28180573100008],
              [-174.37677975199992, 52.28384023600006],
              [-174.41584225199992, 52.29344310100004],
              [-174.44257564999992, 52.307521877000056],
              [-174.4355362619999, 52.322699286000045],
              [-174.3693741529999, 52.32477448100008],
              [-174.3386124339999, 52.33551666900007],
              [-174.3467911449999, 52.36432526200008],
              [-174.33442135299993, 52.37026601800005],
              [-174.32306881399992, 52.36786530200004],
              [-174.3114721339999, 52.36375560100004],
              [-174.29841061099992, 52.36432526200008],
              [-174.28831946499992, 52.37177155200004],
              [-174.28229732999992, 52.38841380400004],
              [-174.2420548169999, 52.39687734600005],
              [-174.19029700399992, 52.41787344000005],
              [-174.16181393099993, 52.419582424000055],
              [-174.1454565089999, 52.409491278000075],
              [-174.12389075399992, 52.399725653000075],
              [-174.10240637899992, 52.39472077000005],
              [-174.08613033799992, 52.39907461100006],
              [-174.07172604099992, 52.382025458000044],
              [-174.05451412699992, 52.368475653000075],
              [-174.03441321499992, 52.35993073100008],
              [-174.01097571499992, 52.35809967700004],
              [-174.0104874339999, 52.34210846600007],
              [-173.99962317599991, 52.32802969000005],
              [-173.99189205599993, 52.312567450000074],
              [-174.00047766799992, 52.292629299000055],
              [-174.0069473949999, 52.287095445000034],
              [-174.0158585279999, 52.28148021000004],
              [-174.0256241529999, 52.27728913000004],
              [-174.03461666599992, 52.27558014500005],
              [-174.0462540359999, 52.27122630400004],
              [-174.04938717399992, 52.261053778000075],
              [-174.04950924399992, 52.24945709800005],
              [-174.05195064999992, 52.24079010600008],
            ],
          ],
          [
            [
              [-171.25641842399992, 52.52944570500006],
              [-171.2216690749999, 52.51080963700008],
              [-171.2076309889999, 52.49872467700004],
              [-171.2116593089999, 52.484442450000074],
              [-171.21601314999992, 52.47724030200004],
              [-171.21808834499993, 52.46938711100006],
              [-171.2221573559999, 52.46308014500005],
              [-171.2768448559999, 52.45368073100008],
              [-171.3116348949999, 52.46426015800006],
              [-171.31464596299992, 52.48843008000006],
              [-171.2935684889999, 52.514105536000045],
              [-171.25641842399992, 52.52944570500006],
            ],
          ],
          [
            [
              [-170.6046443349999, 52.68707916900007],
              [-170.59345455599993, 52.685207424000055],
              [-170.5831192699999, 52.68235911700003],
              [-170.5733536449999, 52.67837148600006],
              [-170.56371008999992, 52.67279694200005],
              [-170.56611080599993, 52.662176825000074],
              [-170.5659073559999, 52.65615469000005],
              [-170.56725012899992, 52.65070221600007],
              [-170.59784908799992, 52.611395575000074],
              [-170.62193762899992, 52.59389883000006],
              [-170.64545650899993, 52.587103583000044],
              [-170.67084713399993, 52.58901601800005],
              [-170.70087643099993, 52.597723700000074],
              [-170.75279700399992, 52.574286200000074],
              [-170.76915442599991, 52.562933661000045],
              [-170.78608150899993, 52.54751211100006],
              [-170.7978409499999, 52.540269273000035],
              [-170.8107804029999, 52.54291413000004],
              [-170.83124752499992, 52.556708075000074],
              [-170.8373917309999, 52.549261786000045],
              [-170.8466690749999, 52.58437734600005],
              [-170.82123775899993, 52.61603424700007],
              [-170.75548255099991, 52.65912506700005],
              [-170.7486466139999, 52.667669989000046],
              [-170.7470596999999, 52.67438385600008],
              [-170.74372311099992, 52.67869700700004],
              [-170.7319229809999, 52.68024323100008],
              [-170.7150772779999, 52.68032461100006],
              [-170.7034805979999, 52.68187083500004],
              [-170.6940811839999, 52.686835028000075],
              [-170.68407141799992, 52.696966864000046],
              [-170.67048092399992, 52.700832424000055],
              [-170.6470841139999, 52.69916413000004],
              [-170.62230383999992, 52.69399648600006],
              [-170.6046443349999, 52.68707916900007],
            ],
          ],
          [
            [
              [-170.1044001939999, 52.78266022300005],
              [-170.08625240799992, 52.77912018400008],
              [-170.0657852859999, 52.77106354400007],
              [-170.05610104099992, 52.76032135600008],
              [-170.07026119699992, 52.748480536000045],
              [-170.06720943899992, 52.744574286000045],
              [-170.06574459499993, 52.741441148000035],
              [-170.06342525899993, 52.73427969000005],
              [-170.12812252499992, 52.727443752000056],
              [-170.19440670499992, 52.727443752000056],
              [-170.18024654899992, 52.766791083000044],
              [-170.17328854099992, 52.77521393400008],
              [-170.1796768869999, 52.78001536700003],
              [-170.18244381399992, 52.78148021000004],
              [-170.18696041599992, 52.78266022300005],
              [-170.16901607999992, 52.78978099200003],
              [-170.14655514199993, 52.791001695000034],
              [-170.1236466139999, 52.78807200700004],
              [-170.1044001939999, 52.78266022300005],
            ],
          ],
          [
            [
              [-169.6866348949999, 52.87201569200005],
              [-169.6866348949999, 52.86692942900004],
              [-169.68476314999992, 52.86399974200003],
              [-169.6819962229999, 52.86147695500006],
              [-169.67926998599992, 52.85773346600007],
              [-169.68305416599992, 52.851996161000045],
              [-169.69347083199992, 52.83047109600005],
              [-169.67926998599992, 52.82363515800006],
              [-169.69257564999992, 52.813788153000075],
              [-169.7065323559999, 52.805568752000056],
              [-169.7138565749999, 52.796128648000035],
              [-169.70714270699992, 52.78266022300005],
              [-169.7233780589999, 52.77448151200008],
              [-169.73790442599991, 52.77830638200004],
              [-169.76178951699993, 52.79572174700007],
              [-169.78144283799992, 52.803900458000044],
              [-169.86481686099992, 52.82086823100008],
              [-169.8773087229999, 52.819525458000044],
              [-169.91486568899992, 52.79938385600008],
              [-169.92206783799992, 52.79755280200004],
              [-169.93993079299992, 52.79572174700007],
              [-169.95710201699993, 52.790350653000075],
              [-169.96410071499992, 52.789496161000045],
              [-169.97016354099992, 52.79165273600006],
              [-169.97899329299992, 52.80101146000004],
              [-170.0007218089999, 52.80951569200005],
              [-170.0110977859999, 52.82363515800006],
              [-170.01166744699992, 52.83771393400008],
              [-169.9732559889999, 52.85565827000005],
              [-169.96410071499992, 52.85773346600007],
              [-169.9228409499999, 52.850897528000075],
              [-169.89936275899993, 52.85179271000004],
              [-169.8874405589999, 52.85529205900008],
              [-169.8685196609999, 52.87514883000006],
              [-169.85029049399992, 52.882513739000046],
              [-169.8029679029999, 52.88226959800005],
              [-169.78290768099993, 52.89252350500004],
              [-169.76752682199992, 52.88471100500004],
              [-169.75548255099991, 52.88491445500006],
              [-169.74335689999992, 52.88711172100005],
              [-169.72760982999992, 52.88507721600007],
              [-169.71589107999992, 52.87905508000006],
              [-169.70722408799992, 52.872748114000046],
              [-169.69855709499993, 52.86933014500005],
              [-169.6866348949999, 52.87201569200005],
            ],
          ],
          [
            [
              [-170.07026119699992, 52.919175523000035],
              [-170.0142716139999, 52.90582916900007],
              [-169.99457760299993, 52.905585028000075],
              [-170.0110977859999, 52.88226959800005],
              [-170.03058834499993, 52.864569403000075],
              [-170.05610104099992, 52.857082424000055],
              [-170.09076900899993, 52.864569403000075],
              [-170.10480709499993, 52.871161200000074],
              [-170.1170548169999, 52.87921784100007],
              [-170.12482662699992, 52.88861725500004],
              [-170.12547766799992, 52.89935944200005],
              [-170.11729895699992, 52.90965403900003],
              [-170.10322018099993, 52.91632721600007],
              [-170.08637447799993, 52.91950104400007],
              [-170.07026119699992, 52.919175523000035],
            ],
          ],
          [
            [
              [-169.69347083199992, 53.03587474200003],
              [-169.68073482999992, 53.033189195000034],
              [-169.6732071609999, 53.02521393400008],
              [-169.66913814999992, 53.01386139500005],
              [-169.66620846299992, 53.001166083000044],
              [-169.68635006399992, 52.98899974200003],
              [-169.7014054029999, 52.96820709800005],
              [-169.7193497389999, 52.95014069200005],
              [-169.74811764199993, 52.946519273000035],
              [-169.74193274599992, 52.960150458000044],
              [-169.7604874339999, 52.96869538000004],
              [-169.75800533799992, 52.98273346600007],
              [-169.7498673169999, 52.998480536000045],
              [-169.7532852859999, 53.02480703300006],
              [-169.7342423169999, 53.032904364000046],
              [-169.70942135299993, 53.03652578300006],
              [-169.69347083199992, 53.03587474200003],
            ],
          ],
          [
            [
              [-167.85749264199993, 53.39276764500005],
              [-167.85004635299993, 53.38540273600006],
              [-167.87555904899992, 53.37189362200007],
              [-167.9377335279999, 53.34845612200007],
              [-167.96642005099991, 53.34442780200004],
              [-167.98810787699992, 53.33856842700004],
              [-168.1381729809999, 53.27326080900008],
              [-168.1722305979999, 53.26504140800006],
              [-168.22577877499992, 53.25971100500004],
              [-168.2564591139999, 53.25031159100007],
              [-168.27118893099993, 53.24819570500006],
              [-168.28758704299992, 53.24298737200007],
              [-168.31171627499992, 53.220038153000075],
              [-168.3292130199999, 53.21466705900008],
              [-168.32542883999992, 53.204779364000046],
              [-168.3229874339999, 53.20099518400008],
              [-168.3401993479999, 53.18939850500004],
              [-168.34943600199992, 53.17243073100008],
              [-168.35912024599992, 53.16107819200005],
              [-168.37763424399992, 53.16620514500005],
              [-168.37657630099991, 53.14020416900007],
              [-168.39069576699993, 53.124701239000046],
              [-168.4120987619999, 53.112616278000075],
              [-168.43285071499992, 53.097357489000046],
              [-168.46605383999992, 53.056626695000034],
              [-168.48993893099993, 53.04205963700008],
              [-168.51545162699992, 53.05019765800006],
              [-168.53119869699992, 53.03461334800005],
              [-168.58405514199993, 53.030462958000044],
              [-168.6072891919999, 53.018866278000075],
              [-168.62621008999992, 53.00495026200008],
              [-168.67157955599993, 52.98236725500004],
              [-168.68610592399992, 52.96759674700007],
              [-168.68146725199992, 52.96308014500005],
              [-168.67931067599991, 52.960150458000044],
              [-168.75129146999993, 52.960150458000044],
              [-168.7745255199999, 52.956366278000075],
              [-168.77863521999993, 52.947333075000074],
              [-168.7698868479999, 52.93626536700003],
              [-168.75438391799992, 52.926662502000056],
              [-168.76606197799993, 52.91388580900008],
              [-168.7803848949999, 52.91364166900007],
              [-168.79539954299992, 52.92182038000004],
              [-168.80903072799993, 52.93349844000005],
              [-168.8183487619999, 52.919623114000046],
              [-168.83177649599992, 52.91852448100008],
              [-168.84662838399993, 52.92059967700004],
              [-168.86021887899992, 52.916083075000074],
              [-168.8857315749999, 52.896185614000046],
              [-168.90082760299993, 52.88825104400007],
              [-168.9346817699999, 52.88263580900008],
              [-168.98839270699992, 52.864569403000075],
              [-169.02424068899992, 52.85956452000005],
              [-169.03990637899992, 52.85366445500006],
              [-169.03559322799993, 52.84414297100005],
              [-169.03559322799993, 52.83730703300006],
              [-169.11127682199992, 52.82363515800006],
              [-169.09532630099991, 52.83490631700005],
              [-169.07721920499992, 52.837591864000046],
              [-169.06086178299992, 52.841782945000034],
              [-169.04987545499992, 52.85773346600007],
              [-169.05317135299993, 52.859808661000045],
              [-169.0538223949999, 52.86033763200004],
              [-169.0540665359999, 52.861314195000034],
              [-169.0560196609999, 52.864569403000075],
              [-168.99657141799992, 52.871527411000045],
              [-168.98094641799992, 52.878241278000075],
              [-168.97044837099992, 52.89472077000005],
              [-168.9678848949999, 52.92719147300005],
              [-168.9529923169999, 52.940334377000056],
              [-168.93024654899992, 52.94428131700005],
              [-168.91010494699992, 52.940619208000044],
              [-168.8909805979999, 52.940334377000056],
              [-168.8710831369999, 52.954006252000056],
              [-168.8632706369999, 52.971584377000056],
              [-168.86200924399992, 53.00690338700008],
              [-168.8505753249999, 53.02220286700003],
              [-168.82892818899992, 53.01609935100004],
              [-168.80805416599992, 53.02838776200008],
              [-168.7720841139999, 53.06696198100008],
              [-168.76862545499992, 53.08144765800006],
              [-168.79450436099992, 53.11554596600007],
              [-168.79596920499992, 53.138332424000055],
              [-168.78852291599992, 53.152329820000034],
              [-168.77533932199992, 53.170803127000056],
              [-168.75951087099992, 53.186712958000044],
              [-168.72740637899992, 53.199286200000074],
              [-168.69782467399992, 53.22370026200008],
              [-168.68610592399992, 53.22833893400008],
              [-168.63756262899992, 53.25047435100004],
              [-168.6308487619999, 53.25873444200005],
              [-168.62336178299992, 53.27423737200007],
              [-168.6057022779999, 53.27513255400004],
              [-168.5694473949999, 53.261786200000074],
              [-168.55048580599993, 53.25242747600004],
              [-168.54133053299992, 53.249335028000075],
              [-168.52818762899992, 53.24819570500006],
              [-168.52082271999993, 53.251288153000075],
              [-168.50153561099992, 53.26544830900008],
              [-168.4824112619999, 53.27049388200004],
              [-168.4737442699999, 53.27423737200007],
              [-168.46430416599992, 53.27680084800005],
              [-168.4533585279999, 53.275458075000074],
              [-168.4478653639999, 53.270819403000075],
              [-168.43891354099992, 53.25470612200007],
              [-168.43285071499992, 53.24819570500006],
              [-168.40436764199993, 53.25796133000006],
              [-168.37946529899992, 53.260972398000035],
              [-168.36078854099992, 53.27130768400008],
              [-168.3509415359999, 53.302801825000074],
              [-168.3622940749999, 53.297308661000045],
              [-168.37153072799993, 53.29832591400003],
              [-168.37547766799992, 53.30516185100004],
              [-168.37079830599993, 53.31708405200004],
              [-168.3860977859999, 53.32257721600007],
              [-168.41779537699992, 53.326239325000074],
              [-168.43285071499992, 53.330064195000034],
              [-168.43285071499992, 53.337591864000046],
              [-168.41974850199992, 53.34271881700005],
              [-168.40619869699992, 53.35366445500006],
              [-168.39570064999992, 53.366848049000055],
              [-168.39191646999993, 53.37848541900007],
              [-168.39696204299992, 53.39667389500005],
              [-168.40404212099992, 53.403225002000056],
              [-168.40656490799992, 53.409491278000075],
              [-168.39814205599993, 53.426947333000044],
              [-168.37360592399992, 53.460150458000044],
              [-168.3646134109999, 53.46792226800005],
              [-168.34972083199992, 53.473822333000044],
              [-168.31456458199992, 53.48200104400007],
              [-168.27070064999992, 53.51386139500005],
              [-168.23680579299992, 53.53009674700007],
              [-168.1998184889999, 53.540228583000044],
              [-168.12547766799992, 53.54669830900008],
              [-168.10700436099992, 53.55170319200005],
              [-168.09337317599991, 53.559759833000044],
              [-168.07787024599992, 53.563381252000056],
              [-168.02887936099992, 53.56049225500004],
              [-168.00829016799992, 53.570298570000034],
              [-167.95990963399993, 53.53778717700004],
              [-167.9346817699999, 53.52676015800006],
              [-167.90156002499992, 53.52252838700008],
              [-167.8373917309999, 53.525458075000074],
              [-167.8069962229999, 53.52008698100008],
              [-167.7947891919999, 53.502020575000074],
              [-167.8080948559999, 53.47793203300006],
              [-167.85297604099992, 53.447251695000034],
              [-167.87116451699993, 53.426947333000044],
              [-167.8616837229999, 53.42145416900007],
              [-167.8538712229999, 53.41364166900007],
              [-167.85130774599992, 53.40387604400007],
              [-167.85749264199993, 53.39276764500005],
            ],
          ],
          [
            [
              [-166.1369522779999, 53.83783600500004],
              [-166.12458248599992, 53.84121328300006],
              [-166.11603756399992, 53.845770575000074],
              [-166.10594641799992, 53.84804922100005],
              [-166.08918209499993, 53.84467194200005],
              [-166.09919186099992, 53.83392975500004],
              [-166.10277258999992, 53.83100006700005],
              [-166.11290442599991, 53.83030833500004],
              [-166.1209610669999, 53.82648346600007],
              [-166.1268204419999, 53.81981028900003],
              [-166.13011633999992, 53.81049225500004],
              [-166.11961829299992, 53.80263906500005],
              [-166.1171768869999, 53.793036200000074],
              [-166.12120520699992, 53.783636786000045],
              [-166.13011633999992, 53.77635325700004],
              [-166.14447994699992, 53.77252838700008],
              [-166.17426510299993, 53.77631256700005],
              [-166.19159908799992, 53.77635325700004],
              [-166.17670650899993, 53.75763580900008],
              [-166.17157955599993, 53.74787018400008],
              [-166.1747940749999, 53.73851146000004],
              [-166.18451900899993, 53.73387278900003],
              [-166.22630774599992, 53.72797272300005],
              [-166.22211666599992, 53.72284577000005],
              [-166.21263587099992, 53.70807526200008],
              [-166.23289954299992, 53.716782945000034],
              [-166.27192135299993, 53.743353583000044],
              [-166.2908829419999, 53.74909088700008],
              [-166.2978409499999, 53.760199286000045],
              [-166.29926510299993, 53.781683661000045],
              [-166.2905167309999, 53.795355536000045],
              [-166.26728268099993, 53.78314850500004],
              [-166.26752682199992, 53.79682038000004],
              [-166.26203365799992, 53.80320872600004],
              [-166.25324459499993, 53.80731842700004],
              [-166.24339758999992, 53.81391022300005],
              [-166.23786373599992, 53.81525299700007],
              [-166.23680579299992, 53.80613841400003],
              [-166.23997962099992, 53.78314850500004],
              [-166.23253333199992, 53.78314850500004],
              [-166.21235104099992, 53.82294342700004],
              [-166.19782467399992, 53.837103583000044],
              [-166.17792721299992, 53.83100006700005],
              [-166.16974850199992, 53.842962958000044],
              [-166.16083736899992, 53.84357330900008],
              [-166.1502579419999, 53.83958567900004],
              [-166.1369522779999, 53.83783600500004],
            ],
          ],
          [
            [
              [-166.2943009109999, 53.72797272300005],
              [-166.27814693899992, 53.723863023000035],
              [-166.27521725199992, 53.71369049700007],
              [-166.27668209499993, 53.700384833000044],
              [-166.27350826699993, 53.68699778900003],
              [-166.28949947799993, 53.67991771000004],
              [-166.33128821499992, 53.67401764500005],
              [-166.40778561099992, 53.67267487200007],
              [-166.42499752499992, 53.66648997600004],
              [-166.40941321499992, 53.65570709800005],
              [-166.40387936099992, 53.65281810100004],
              [-166.4276016919999, 53.65110911700003],
              [-166.4492081369999, 53.64350006700005],
              [-166.47040768099993, 53.638739325000074],
              [-166.49323482999992, 53.64606354400007],
              [-166.5472305979999, 53.62592194200005],
              [-166.56212317599991, 53.61810944200005],
              [-166.5462540359999, 53.61538320500006],
              [-166.5345352859999, 53.60895416900007],
              [-166.52643795499992, 53.59878164300005],
              [-166.52118893099993, 53.58462148600006],
              [-166.54950924399992, 53.60106028900003],
              [-166.57579505099991, 53.59369538000004],
              [-166.59337317599991, 53.569566148000035],
              [-166.59565182199992, 53.53620026200008],
              [-166.60863196499992, 53.555121161000045],
              [-166.66454016799992, 53.59821198100008],
              [-166.6658829419999, 53.581732489000046],
              [-166.64289303299992, 53.550034898000035],
              [-166.6365860669999, 53.53278229400007],
              [-166.64740963399993, 53.52912018400008],
              [-166.71296139199993, 53.54979075700004],
              [-166.70844479099992, 53.53628164300005],
              [-166.69652258999992, 53.53034088700008],
              [-166.6816300119999, 53.526556708000044],
              [-166.6679581369999, 53.51943594000005],
              [-166.65636145699992, 53.502386786000045],
              [-166.6591690749999, 53.49091217700004],
              [-166.67149817599991, 53.48847077000005],
              [-166.69782467399992, 53.50531647300005],
              [-166.70771236899992, 53.508246161000045],
              [-166.72968502499992, 53.50885651200008],
              [-166.7343643869999, 53.51154205900008],
              [-166.74262447799993, 53.524725653000075],
              [-166.7464493479999, 53.529364325000074],
              [-166.77155514199993, 53.548163153000075],
              [-166.79487057199992, 53.570298570000034],
              [-166.80915279899992, 53.556626695000034],
              [-166.8002823559999, 53.546087958000044],
              [-166.7812393869999, 53.50885651200008],
              [-166.7505997389999, 53.47919342700004],
              [-166.7464493479999, 53.46792226800005],
              [-166.7521866529999, 53.450873114000046],
              [-166.76447506399992, 53.44912344000005],
              [-166.79487057199992, 53.46108633000006],
              [-166.8002823559999, 53.46474844000005],
              [-166.80182857999992, 53.46898021000004],
              [-166.80500240799992, 53.47101471600007],
              [-166.81537838399993, 53.46792226800005],
              [-166.81611080599993, 53.46442291900007],
              [-166.82502193899992, 53.44586823100008],
              [-166.82905025899993, 53.43992747600004],
              [-166.86884518099993, 53.47601959800005],
              [-166.8768204419999, 53.48151276200008],
              [-166.89305579299992, 53.47597890800006],
              [-166.90448971299992, 53.44684479400007],
              [-166.91779537699992, 53.43992747600004],
              [-166.9304093089999, 53.44513580900008],
              [-166.93451900899993, 53.45579661700003],
              [-166.93891354099992, 53.46381256700005],
              [-166.9525040359999, 53.46108633000006],
              [-166.9603165359999, 53.45148346600007],
              [-166.96320553299992, 53.439520575000074],
              [-166.96918697799993, 53.429673570000034],
              [-166.9866837229999, 53.426947333000044],
              [-166.9843643869999, 53.431341864000046],
              [-166.9792374339999, 53.44741445500006],
              [-167.00739498599992, 53.45258209800005],
              [-167.0683487619999, 53.426988023000035],
              [-167.0999649729999, 53.41950104400007],
              [-167.12055416599992, 53.41852448100008],
              [-167.13666744699992, 53.41592031500005],
              [-167.21222896999993, 53.38751862200007],
              [-167.24299068899992, 53.38320547100005],
              [-167.27363033799992, 53.37384674700007],
              [-167.2917374339999, 53.37164948100008],
              [-167.2991837229999, 53.36591217700004],
              [-167.3128555979999, 53.33869049700007],
              [-167.32184811099992, 53.330064195000034],
              [-167.3913468089999, 53.34442780200004],
              [-167.40729732999992, 53.34056224200003],
              [-167.43903561099992, 53.32526276200008],
              [-167.4589737619999, 53.323919989000046],
              [-167.45502682199992, 53.31346263200004],
              [-167.45282955599993, 53.30963776200008],
              [-167.4693497389999, 53.30451080900008],
              [-167.48053951699993, 53.29584381700005],
              [-167.5005997389999, 53.275458075000074],
              [-167.5026749339999, 53.270412502000056],
              [-167.5042618479999, 53.26341380400004],
              [-167.50824947799993, 53.25991445500006],
              [-167.52708899599992, 53.27220286700003],
              [-167.53644771999993, 53.27513255400004],
              [-167.55927486899992, 53.275458075000074],
              [-167.59211178299992, 53.280951239000046],
              [-167.6060684889999, 53.28070709800005],
              [-167.62006588399993, 53.27204010600008],
              [-167.62580318899992, 53.265692450000074],
              [-167.62787838399993, 53.26264069200005],
              [-167.63048255099991, 53.260199286000045],
              [-167.66510982999992, 53.24192942900004],
              [-167.67231197799993, 53.26162344000005],
              [-167.6971329419999, 53.27094147300005],
              [-167.75385494699992, 53.275458075000074],
              [-167.78058834499993, 53.28070709800005],
              [-167.8022354809999, 53.289129950000074],
              [-167.80915279899992, 53.294134833000044],
              [-167.81147213399993, 53.298529364000046],
              [-167.81513424399992, 53.30158112200007],
              [-167.83429928299992, 53.30312734600005],
              [-167.84032141799992, 53.30426666900007],
              [-167.8452042309999, 53.306341864000046],
              [-167.85004635299993, 53.30963776200008],
              [-167.71845455599993, 53.381293036000045],
              [-167.70295162699992, 53.38540273600006],
              [-167.67039954299992, 53.38544342700004],
              [-167.6546524729999, 53.38255442900004],
              [-167.64146887899992, 53.375067450000074],
              [-167.6380509109999, 53.378159898000035],
              [-167.59418697799993, 53.378607489000046],
              [-167.59211178299992, 53.38231028900003],
              [-167.5967911449999, 53.39276764500005],
              [-167.5705460279999, 53.39630768400008],
              [-167.51655025899993, 53.38141510600008],
              [-167.4869278639999, 53.37848541900007],
              [-167.49535071499992, 53.385199286000045],
              [-167.51362057199992, 53.40643952000005],
              [-167.51362057199992, 53.41266510600008],
              [-167.50458736899992, 53.414129950000074],
              [-167.4991348949999, 53.41754791900007],
              [-167.4943741529999, 53.42202383000006],
              [-167.4745987619999, 53.434027411000045],
              [-167.4589737619999, 53.43374258000006],
              [-167.44086666599992, 53.43040599200003],
              [-167.4084366529999, 53.419256903000075],
              [-167.39073645699992, 53.41950104400007],
              [-167.39545650899993, 53.42405833500004],
              [-167.4007462229999, 53.43073151200008],
              [-167.40440833199992, 53.43374258000006],
              [-167.3784073559999, 53.43195221600007],
              [-167.34321041599992, 53.41876862200007],
              [-167.32152258999992, 53.416449286000045],
              [-167.33613033799992, 53.44741445500006],
              [-167.3130997389999, 53.44196198100008],
              [-167.30357825399992, 53.44525788000004],
              [-167.30195064999992, 53.455511786000045],
              [-167.3026016919999, 53.47134023600006],
              [-167.2916153639999, 53.47601959800005],
              [-167.22626705599993, 53.46108633000006],
              [-167.2127579419999, 53.46198151200008],
              [-167.16962643099993, 53.47020091400003],
              [-167.15864010299993, 53.47711823100008],
              [-167.1614884109999, 53.48236725500004],
              [-167.16657467399992, 53.497300523000035],
              [-167.1647843089999, 53.49518463700008],
              [-167.1724747389999, 53.510199286000045],
              [-167.17747962099992, 53.51634349200003],
              [-167.18529212099992, 53.52252838700008],
              [-167.1701554029999, 53.52326080900008],
              [-167.1072891919999, 53.51447174700007],
              [-167.04308020699992, 53.51776764500005],
              [-166.98005123599992, 53.52806224200003],
              [-166.96003170499992, 53.53620026200008],
              [-166.98188229099992, 53.54486725500004],
              [-167.00409908799992, 53.54389069200005],
              [-167.0518692699999, 53.53620026200008],
              [-167.09813391799992, 53.53925202000005],
              [-167.12067623599992, 53.54539622600004],
              [-167.14435787699992, 53.556626695000034],
              [-167.1396378249999, 53.55927155200004],
              [-167.13727779899992, 53.56199778900003],
              [-167.13495846299992, 53.56549713700008],
              [-167.13007564999992, 53.570298570000034],
              [-167.15363521999993, 53.58144765800006],
              [-167.16205807199992, 53.60236237200007],
              [-167.1553848949999, 53.62262604400007],
              [-167.1337784499999, 53.63178131700005],
              [-167.09272213399993, 53.62864817900004],
              [-167.08287512899992, 53.62555573100008],
              [-167.0733536449999, 53.618801174000055],
              [-167.05976314999992, 53.60346100500004],
              [-167.04816646999993, 53.59821198100008],
              [-167.0501602859999, 53.60179271000004],
              [-167.05158443899992, 53.602443752000056],
              [-167.0530899729999, 53.60248444200005],
              [-167.05553137899992, 53.60443756700005],
              [-167.04816646999993, 53.61127350500004],
              [-167.05357825399992, 53.62750885600008],
              [-167.03779049399992, 53.62872955900008],
              [-166.9935196609999, 53.61810944200005],
              [-167.0068253249999, 53.63727448100008],
              [-167.0449112619999, 53.65273672100005],
              [-167.0623673169999, 53.66648997600004],
              [-167.06464596299992, 53.68268463700008],
              [-167.0506485669999, 53.69586823100008],
              [-167.02802486899992, 53.704779364000046],
              [-166.94652258999992, 53.71576569200005],
              [-166.9163712229999, 53.715725002000056],
              [-166.89415442599991, 53.704331773000035],
              [-166.87043209499993, 53.673895575000074],
              [-166.86493893099993, 53.65717194200005],
              [-166.8631485669999, 53.63178131700005],
              [-166.85631262899992, 53.63178131700005],
              [-166.85358639199993, 53.64081452000005],
              [-166.85016842399992, 53.64785390800006],
              [-166.84264075399992, 53.65965403900003],
              [-166.83075924399992, 53.65289948100008],
              [-166.80170650899993, 53.63178131700005],
              [-166.82709713399993, 53.69086334800005],
              [-166.82905025899993, 53.70807526200008],
              [-166.78673255099991, 53.69196198100008],
              [-166.76691646999993, 53.69086334800005],
              [-166.7464493479999, 53.70062897300005],
              [-166.75763912699992, 53.69969310100004],
              [-166.76842200399992, 53.700873114000046],
              [-166.77851314999992, 53.70376211100006],
              [-166.7874649729999, 53.70807526200008],
              [-166.76813717399992, 53.714544989000046],
              [-166.72480221299992, 53.714097398000035],
              [-166.70551510299993, 53.721136786000045],
              [-166.73399817599991, 53.72646719000005],
              [-166.80768795499992, 53.72955963700008],
              [-166.88398189999992, 53.75527578300006],
              [-166.89863033799992, 53.75690338700008],
              [-166.93830318899992, 53.769517320000034],
              [-166.9686173169999, 53.77260976800005],
              [-166.99054928299992, 53.76703522300005],
              [-167.01130123599992, 53.75922272300005],
              [-167.0381973949999, 53.75527578300006],
              [-167.1033829419999, 53.80365631700005],
              [-167.10081946499992, 53.805568752000056],
              [-167.09760494699992, 53.811753648000035],
              [-167.09552975199992, 53.81903717700004],
              [-167.09654700399992, 53.82416413000004],
              [-167.10199947799993, 53.82562897300005],
              [-167.1175430979999, 53.82367584800005],
              [-167.13007564999992, 53.82469310100004],
              [-167.1452530589999, 53.82290273600006],
              [-167.1511124339999, 53.82416413000004],
              [-167.15619869699992, 53.829779364000046],
              [-167.15815182199992, 53.84218984600005],
              [-167.16136633999992, 53.848089911000045],
              [-167.16340084499993, 53.85736725500004],
              [-167.15192623599992, 53.86225006700005],
              [-167.13727779899992, 53.86517975500004],
              [-167.13007564999992, 53.86855703300006],
              [-167.12677975199992, 53.875067450000074],
              [-167.1033829419999, 53.90615469000005],
              [-167.0866593089999, 53.92031484600005],
              [-167.04967200399992, 53.94163646000004],
              [-167.03107662699992, 53.95766836100006],
              [-167.02159583199992, 53.96124909100007],
              [-166.98289954299992, 53.95384349200003],
              [-166.9726456369999, 53.956732489000046],
              [-166.93830318899992, 53.97500234600005],
              [-166.91620846299992, 53.97988515800006],
              [-166.8952530589999, 53.980902411000045],
              [-166.87531490799992, 53.97719961100006],
              [-166.85631262899992, 53.96759674700007],
              [-166.83185787699992, 53.982123114000046],
              [-166.77900143099993, 54.00275299700007],
              [-166.7538956369999, 54.01601797100005],
              [-166.74189205599993, 54.00543854400007],
              [-166.7464493479999, 53.99481842700004],
              [-166.75287838399993, 53.984442450000074],
              [-166.7464493479999, 53.97500234600005],
              [-166.73102779899992, 53.97410716400003],
              [-166.7193497389999, 53.98456452000005],
              [-166.70946204299992, 53.998480536000045],
              [-166.69928951699993, 54.00849030200004],
              [-166.6683243479999, 54.01357656500005],
              [-166.63459225199992, 54.00458405200004],
              [-166.6057022779999, 53.98578522300005],
              [-166.58942623599992, 53.961371161000045],
              [-166.61274166599992, 53.955511786000045],
              [-166.62507076699993, 53.95066966400003],
              [-166.63044186099992, 53.94399648600006],
              [-166.63133704299992, 53.93903229400007],
              [-166.63560950399992, 53.929388739000046],
              [-166.6365860669999, 53.923488674000055],
              [-166.63459225199992, 53.91705963700008],
              [-166.63019771999993, 53.91046784100007],
              [-166.62568111899992, 53.90607330900008],
              [-166.62360592399992, 53.90615469000005],
              [-166.6360977859999, 53.87653229400007],
              [-166.63349361899992, 53.871975002000056],
              [-166.61969967399992, 53.87518952000005],
              [-166.6081436839999, 53.881293036000045],
              [-166.5964249339999, 53.88450755400004],
              [-166.58197994699992, 53.87938060100004],
              [-166.60667883999992, 53.84479401200008],
              [-166.60993404899992, 53.83100006700005],
              [-166.58698482999992, 53.83930084800005],
              [-166.48949133999992, 53.900091864000046],
              [-166.4753311839999, 53.89907461100006],
              [-166.45909583199992, 53.88556549700007],
              [-166.4557999339999, 53.896144924000055],
              [-166.4385880199999, 53.92658112200007],
              [-166.43956458199992, 53.92812734600005],
              [-166.43976803299992, 53.94171784100007],
              [-166.4385880199999, 53.94708893400008],
              [-166.42271887899992, 53.951157945000034],
              [-166.41808020699992, 53.95384349200003],
              [-166.40986080599993, 53.980169989000046],
              [-166.40387936099992, 53.98924388200004],
              [-166.37035071499992, 54.00849030200004],
              [-166.36017818899992, 53.99282461100006],
              [-166.3691300119999, 53.973822333000044],
              [-166.3734024729999, 53.95677317900004],
              [-166.34923255099991, 53.94708893400008],
              [-166.3260391919999, 53.95286692900004],
              [-166.30024166599992, 53.966131903000075],
              [-166.2767227859999, 53.97492096600007],
              [-166.2604874339999, 53.96759674700007],
              [-166.25422115799992, 53.95140208500004],
              [-166.2509659499999, 53.93659088700008],
              [-166.25422115799992, 53.923488674000055],
              [-166.26728268099993, 53.91290924700007],
              [-166.2532852859999, 53.91351959800005],
              [-166.24103756399992, 53.91901276200008],
              [-166.21886145699992, 53.934027411000045],
              [-166.2187393869999, 53.91860586100006],
              [-166.22492428299992, 53.905462958000044],
              [-166.23505611899992, 53.89447663000004],
              [-166.2468155589999, 53.88556549700007],
              [-166.26655025899993, 53.874335028000075],
              [-166.2839249339999, 53.86896393400008],
              [-166.30170650899993, 53.868475653000075],
              [-166.3224991529999, 53.871975002000056],
              [-166.32774817599991, 53.87653229400007],
              [-166.33149166599992, 53.88361237200007],
              [-166.3365372389999, 53.88743724200003],
              [-166.34581458199992, 53.882513739000046],
              [-166.3494766919999, 53.87592194200005],
              [-166.35297604099992, 53.85834381700005],
              [-166.35667883999992, 53.85150788000004],
              [-166.37433834499993, 53.84210846600007],
              [-166.4142960279999, 53.837958075000074],
              [-166.43175208199992, 53.83100006700005],
              [-166.41840572799993, 53.81541575700004],
              [-166.41132564999992, 53.81049225500004],
              [-166.4241837229999, 53.804754950000074],
              [-166.52159583199992, 53.78900788000004],
              [-166.5416153639999, 53.79002513200004],
              [-166.5178116529999, 53.780585028000075],
              [-166.50670325399992, 53.77789948100008],
              [-166.49323482999992, 53.77635325700004],
              [-166.49323482999992, 53.769517320000034],
              [-166.52070064999992, 53.76459381700005],
              [-166.5408829419999, 53.75177643400008],
              [-166.57514400899993, 53.71430084800005],
              [-166.55951900899993, 53.71564362200007],
              [-166.55089270699992, 53.710598049000055],
              [-166.54930579299992, 53.70058828300006],
              [-166.5546768869999, 53.68699778900003],
              [-166.54063880099991, 53.69513580900008],
              [-166.52159583199992, 53.72142161700003],
              [-166.51374264199993, 53.72797272300005],
              [-166.4984024729999, 53.72284577000005],
              [-166.48798580599993, 53.69481028900003],
              [-166.4764298169999, 53.69757721600007],
              [-166.47321529899992, 53.70294830900008],
              [-166.4721573559999, 53.70994700700004],
              [-166.47272701699993, 53.72455475500004],
              [-166.4713028639999, 53.73395416900007],
              [-166.4675186839999, 53.73802317900004],
              [-166.4620255199999, 53.74054596600007],
              [-166.4556778639999, 53.745347398000035],
              [-166.44037838399993, 53.75446198100008],
              [-166.4202774729999, 53.75873444200005],
              [-166.40497799399992, 53.75531647300005],
              [-166.40387936099992, 53.74164459800005],
              [-166.39386959499993, 53.74062734600005],
              [-166.38617916599992, 53.73672109600005],
              [-166.38048255099991, 53.730129299000055],
              [-166.37653561099992, 53.721136786000045],
              [-166.36969967399992, 53.73484935100004],
              [-166.3682755199999, 53.75873444200005],
              [-166.35981197799993, 53.77293528900003],
              [-166.34618079299992, 53.78270091400003],
              [-166.33409583199992, 53.782416083000044],
              [-166.32367916599992, 53.774725653000075],
              [-166.31513424399992, 53.76211172100005],
              [-166.3144425119999, 53.748032945000034],
              [-166.31977291599992, 53.73729075700004],
              [-166.31757564999992, 53.73041413000004],
              [-166.2943009109999, 53.72797272300005],
            ],
          ],
          [
            [
              [-165.2667130199999, 54.091050523000035],
              [-165.25995846299992, 54.08539459800005],
              [-165.25279700399992, 54.07770416900007],
              [-165.24730383999992, 54.06818268400008],
              [-165.24567623599992, 54.05695221600007],
              [-165.2619522779999, 54.06317780200004],
              [-165.2713516919999, 54.06468333500004],
              [-165.2803848949999, 54.063788153000075],
              [-165.2842911449999, 54.06012604400007],
              [-165.2928360669999, 54.04682038000004],
              [-165.2940567699999, 54.04389069200005],
              [-165.30781002499992, 54.04783763200004],
              [-165.3260391919999, 54.066839911000045],
              [-165.33844967399992, 54.07123444200005],
              [-165.3878067699999, 54.07013580900008],
              [-165.42243404899992, 54.077460028000075],
              [-165.46528072799993, 54.073879299000055],
              [-165.4858292309999, 54.077460028000075],
              [-165.37657630099991, 54.091050523000035],
              [-165.2667130199999, 54.091050523000035],
            ],
          ],
          [
            [
              [-165.73908443899992, 54.12518952000005],
              [-165.6721085279999, 54.12885163000004],
              [-165.65717525899993, 54.12518952000005],
              [-165.66462154899992, 54.118353583000044],
              [-165.67951412699992, 54.09906647300005],
              [-165.69953365799992, 54.08869049700007],
              [-165.7706192699999, 54.070746161000045],
              [-165.78099524599992, 54.070013739000046],
              [-165.7943009109999, 54.07123444200005],
              [-165.82892818899992, 54.08299388200004],
              [-165.83906002499992, 54.084865627000056],
              [-165.85224361899992, 54.075100002000056],
              [-165.8873184889999, 54.036322333000044],
              [-165.9007462229999, 54.03335195500006],
              [-165.9085587229999, 54.04401276200008],
              [-165.9124649729999, 54.05385976800005],
              [-165.9182022779999, 54.060980536000045],
              [-165.9315079419999, 54.063788153000075],
              [-165.9568985669999, 54.06073639500005],
              [-165.96613521999993, 54.06244538000004],
              [-165.97248287699992, 54.07123444200005],
              [-165.98871822799993, 54.05914948100008],
              [-166.02318274599992, 54.04588450700004],
              [-166.04076087099992, 54.036444403000075],
              [-166.07551021999993, 54.063788153000075],
              [-166.06598873599992, 54.07758209800005],
              [-166.08018958199992, 54.09218984600005],
              [-166.12267005099991, 54.118353583000044],
              [-166.10899817599991, 54.13263580900008],
              [-166.11644446499992, 54.13947174700007],
              [-166.1064346999999, 54.14956289300005],
              [-166.0916641919999, 54.17129140800006],
              [-166.08173580599993, 54.18048737200007],
              [-166.07123775899993, 54.185207424000055],
              [-166.0345352859999, 54.19407786700003],
              [-165.97138424399992, 54.21946849200003],
              [-165.94550533799992, 54.22207265800006],
              [-165.93415279899992, 54.22089264500005],
              [-165.9120987619999, 54.21576569200005],
              [-165.8796280589999, 54.21344635600008],
              [-165.87677975199992, 54.20962148600006],
              [-165.88068600199992, 54.20229726800005],
              [-165.88373775899993, 54.190659898000035],
              [-165.8748673169999, 54.17438385600008],
              [-165.85435950399992, 54.167669989000046],
              [-165.83136959499993, 54.171535549000055],
              [-165.8148087229999, 54.18732330900008],
              [-165.79987545499992, 54.173895575000074],
              [-165.75971432199992, 54.16315338700008],
              [-165.73908443899992, 54.15314362200007],
              [-165.75951087099992, 54.14447663000004],
              [-165.8216446609999, 54.13947174700007],
              [-165.8216446609999, 54.13263580900008],
              [-165.8099259109999, 54.13271719000005],
              [-165.78010006399992, 54.12518952000005],
              [-165.73908443899992, 54.12518952000005],
            ],
          ],
          [
            [
              [-165.4858292309999, 54.17365143400008],
              [-165.4739884109999, 54.16592031500005],
              [-165.47968502499992, 54.16266510600008],
              [-165.50633704299992, 54.15932851800005],
              [-165.52855383999992, 54.14858633000006],
              [-165.53990637899992, 54.14520905200004],
              [-165.55475826699993, 54.145697333000044],
              [-165.54108639199993, 54.13947174700007],
              [-165.55085201699993, 54.122300523000035],
              [-165.56794186099992, 54.112494208000044],
              [-165.58881588399993, 54.11090729400007],
              [-165.6099747389999, 54.118353583000044],
              [-165.6248673169999, 54.13239166900007],
              [-165.62389075399992, 54.14508698100008],
              [-165.61237545499992, 54.158270575000074],
              [-165.5956925119999, 54.17365143400008],
              [-165.63178463399993, 54.18964264500005],
              [-165.62348385299993, 54.200832424000055],
              [-165.59601803299992, 54.21369049700007],
              [-165.5745743479999, 54.23505280200004],
              [-165.6006973949999, 54.24201080900008],
              [-165.68443762899992, 54.23505280200004],
              [-165.67979895699992, 54.248928127000056],
              [-165.67357337099992, 54.26235586100006],
              [-165.66425533799992, 54.27260976800005],
              [-165.65033932199992, 54.276597398000035],
              [-165.63483639199993, 54.27631256700005],
              [-165.63068600199992, 54.27924225500004],
              [-165.62706458199992, 54.29645416900007],
              [-165.62157141799992, 54.29661692900004],
              [-165.61420650899993, 54.29279205900008],
              [-165.59845943899992, 54.28729889500005],
              [-165.59687252499992, 54.280503648000035],
              [-165.59723873599992, 54.27338288000004],
              [-165.5956925119999, 54.269191799000055],
              [-165.58722896999993, 54.26654694200005],
              [-165.58503170499992, 54.26805247600004],
              [-165.58287512899992, 54.27212148600006],
              [-165.5745743479999, 54.276597398000035],
              [-165.53119869699992, 54.29437897300005],
              [-165.5131729809999, 54.29718659100007],
              [-165.49433346299992, 54.29637278900003],
              [-165.49128170499992, 54.28998444200005],
              [-165.50084387899992, 54.28388092700004],
              [-165.51996822799993, 54.28351471600007],
              [-165.5190323559999, 54.27020905200004],
              [-165.5298966139999, 54.26089101800005],
              [-165.5462540359999, 54.25263092700004],
              [-165.56159420499992, 54.24249909100007],
              [-165.55475826699993, 54.23505280200004],
              [-165.54792232999992, 54.23924388200004],
              [-165.54108639199993, 54.24249909100007],
              [-165.5449112619999, 54.22748444200005],
              [-165.54731197799993, 54.22207265800006],
              [-165.44383704299992, 54.20014069200005],
              [-165.4182022779999, 54.20774974200003],
              [-165.4045304029999, 54.191839911000045],
              [-165.42389889199993, 54.18309153900003],
              [-165.45734615799992, 54.17987702000005],
              [-165.4858292309999, 54.18048737200007],
              [-165.4858292309999, 54.17365143400008],
            ],
          ],
          [
            [
              [-159.2845352859999, 54.94082265800006],
              [-159.26899166599992, 54.92963288000004],
              [-159.24767005099991, 54.93016185100004],
              [-159.22687740799992, 54.933579820000034],
              [-159.21259518099993, 54.93113841400003],
              [-159.20881100199992, 54.91852448100008],
              [-159.2194718089999, 54.90680573100008],
              [-159.24640865799992, 54.88959381700005],
              [-159.2866104809999, 54.87173086100006],
              [-159.31781979099992, 54.88471100500004],
              [-159.3261612619999, 54.907863674000055],
              [-159.2982071609999, 54.92031484600005],
              [-159.30695553299992, 54.92963288000004],
              [-159.3177384109999, 54.93378327000005],
              [-159.32905025899993, 54.934759833000044],
              [-159.33918209499993, 54.93455638200004],
              [-159.3222550119999, 54.938381252000056],
              [-159.3069962229999, 54.94623444200005],
              [-159.2923477859999, 54.95172760600008],
              [-159.27708899599992, 54.94818756700005],
              [-159.2845352859999, 54.94082265800006],
            ],
          ],
          [
            [
              [-159.39008541599992, 55.02338288000004],
              [-159.37922115799992, 55.01707591400003],
              [-159.36322994699992, 55.00267161700003],
              [-159.33918209499993, 54.97553131700005],
              [-159.40107174399992, 54.95034414300005],
              [-159.4343155589999, 54.941839911000045],
              [-159.46271725199992, 54.94818756700005],
              [-159.45148678299992, 54.95648834800005],
              [-159.45221920499992, 54.966009833000044],
              [-159.45636959499993, 54.97500234600005],
              [-159.45527096299992, 54.981756903000075],
              [-159.4456680979999, 54.98505280200004],
              [-159.42145748599992, 54.98187897300005],
              [-159.4080704419999, 54.981756903000075],
              [-159.4130753249999, 54.991848049000055],
              [-159.4247940749999, 55.03021881700005],
              [-159.43907630099991, 55.02871328300006],
              [-159.4831436839999, 55.01654694200005],
              [-159.45982825399992, 55.03815338700008],
              [-159.45429439999992, 55.04975006700005],
              [-159.46271725199992, 55.05805084800005],
              [-159.46271725199992, 55.06427643400008],
              [-159.44416256399992, 55.060980536000045],
              [-159.36449133999992, 55.05756256700005],
              [-159.3544815749999, 55.054754950000074],
              [-159.34540768099993, 55.05068594000005],
              [-159.3491104809999, 55.041449286000045],
              [-159.35505123599992, 55.03729889500005],
              [-159.36322994699992, 55.036322333000044],
              [-159.37360592399992, 55.036363023000035],
              [-159.3831680979999, 55.034369208000044],
              [-159.3913468089999, 55.02985260600008],
              [-159.39472408799992, 55.025376695000034],
              [-159.39008541599992, 55.02338288000004],
            ],
          ],
          [
            [
              [-159.5241593089999, 55.07111237200007],
              [-159.49445553299992, 55.06313711100006],
              [-159.48997962099992, 55.05805084800005],
              [-159.4936417309999, 55.04759349200003],
              [-159.50446529899992, 55.04246653900003],
              [-159.51740475199992, 55.04242584800005],
              [-159.52753658799992, 55.04726797100005],
              [-159.54999752499992, 55.07379791900007],
              [-159.56297766799992, 55.08543528900003],
              [-159.5787247389999, 55.092230536000045],
              [-159.5822647779999, 55.08161041900007],
              [-159.58368893099993, 55.07086823100008],
              [-159.5826309889999, 55.06049225500004],
              [-159.5787247389999, 55.05068594000005],
              [-159.59394283799992, 55.05072663000004],
              [-159.6201065749999, 55.05703359600005],
              [-159.63337154899992, 55.05805084800005],
              [-159.63971920499992, 55.05385976800005],
              [-159.6436661449999, 55.04661692900004],
              [-159.64777584499993, 55.04328034100007],
              [-159.65448971299992, 55.05068594000005],
              [-159.65925045499992, 55.06513092700004],
              [-159.65436764199993, 55.07339101800005],
              [-159.63337154899992, 55.08539459800005],
              [-159.62714596299992, 55.08763255400004],
              [-159.62165279899992, 55.086371161000045],
              [-159.61689205599993, 55.086371161000045],
              [-159.61290442599991, 55.092230536000045],
              [-159.61164303299992, 55.098944403000075],
              [-159.6132706369999, 55.10297272300005],
              [-159.6174210279999, 55.104803778000075],
              [-159.6234024729999, 55.10529205900008],
              [-159.64537512899992, 55.11269765800006],
              [-159.6503800119999, 55.12636953300006],
              [-159.64024817599991, 55.13393789300005],
              [-159.59260006399992, 55.11017487200007],
              [-159.5771378249999, 55.11200592700004],
              [-159.5772598949999, 55.12173086100006],
              [-159.5998429029999, 55.13320547100005],
              [-159.58576412699992, 55.14093659100007],
              [-159.5513809889999, 55.14215729400007],
              [-159.54462643099993, 55.15029531500005],
              [-159.5526016919999, 55.15892161700003],
              [-159.5917862619999, 55.163763739000046],
              [-159.6060684889999, 55.16791413000004],
              [-159.58250891799992, 55.17715078300006],
              [-159.58417721299992, 55.19318268400008],
              [-159.5892227859999, 55.20840078300006],
              [-159.5756729809999, 55.21515534100007],
              [-159.56224524599992, 55.21548086100006],
              [-159.55711829299992, 55.21702708500004],
              [-159.5534561839999, 55.22134023600006],
              [-159.54462643099993, 55.229396877000056],
              [-159.54076087099992, 55.237616278000075],
              [-159.53925533799992, 55.24713776200008],
              [-159.53364010299993, 55.25104401200008],
              [-159.5179337229999, 55.24241771000004],
              [-159.5209854809999, 55.22638580900008],
              [-159.5302628249999, 55.21662018400008],
              [-159.54010982999992, 55.208685614000046],
              [-159.54462643099993, 55.19806549700007],
              [-159.53831946499992, 55.18353913000004],
              [-159.52464758999992, 55.17617422100005],
              [-159.51154537699992, 55.17291901200008],
              [-159.50706946499992, 55.171087958000044],
              [-159.51219641799992, 55.161322333000044],
              [-159.5241593089999, 55.11953359600005],
              [-159.52269446499992, 55.07880280200004],
              [-159.5241593089999, 55.07111237200007],
            ],
          ],
          [
            [
              [-159.9014786449999, 55.14008209800005],
              [-159.8869522779999, 55.14911530200004],
              [-159.87511145699992, 55.17267487200007],
              [-159.85753333199992, 55.19025299700007],
              [-159.82579505099991, 55.180975653000075],
              [-159.83287512899992, 55.17161692900004],
              [-159.83930416599992, 55.14516836100006],
              [-159.84626217399992, 55.13320547100005],
              [-159.8482559889999, 55.134426174000055],
              [-159.87421627499992, 55.12571849200003],
              [-159.87653561099992, 55.120794989000046],
              [-159.8752335279999, 55.11505768400008],
              [-159.8748673169999, 55.10956452000005],
              [-159.87975012899992, 55.10529205900008],
              [-159.89740963399993, 55.10488515800006],
              [-159.90925045499992, 55.11481354400007],
              [-159.9201554029999, 55.127020575000074],
              [-159.93500729099992, 55.13320547100005],
              [-159.9494522779999, 55.128892320000034],
              [-159.9678848949999, 55.106756903000075],
              [-159.98285885299993, 55.09906647300005],
              [-159.95588131399992, 55.08148834800005],
              [-159.94611568899992, 55.069647528000075],
              [-159.95954342399992, 55.06427643400008],
              [-160.01264400899993, 55.07135651200008],
              [-160.0312393869999, 55.07111237200007],
              [-160.01728268099993, 55.05288320500006],
              [-160.01703854099992, 55.04531484600005],
              [-160.0455216139999, 55.03021881700005],
              [-160.08368893099993, 54.99583567900004],
              [-160.12983150899993, 54.96596914300005],
              [-160.1553848949999, 54.94082265800006],
              [-160.18329830599993, 54.91893138200004],
              [-160.19635982999992, 54.90521881700005],
              [-160.20844479099992, 54.87384674700007],
              [-160.22272701699993, 54.87612539300005],
              [-160.2370499339999, 54.88857656500005],
              [-160.2435196609999, 54.903550523000035],
              [-160.2402237619999, 54.927069403000075],
              [-160.23029537699992, 54.934475002000056],
              [-160.21332760299993, 54.93764883000006],
              [-160.18891354099992, 54.94818756700005],
              [-160.1445206369999, 55.006293036000045],
              [-160.13068600199992, 55.015692450000074],
              [-160.11481686099992, 55.02383047100005],
              [-160.10081946499992, 55.03424713700008],
              [-160.09272213399993, 55.05068594000005],
              [-160.17463131399992, 55.05805084800005],
              [-160.17463131399992, 55.06427643400008],
              [-160.1619766919999, 55.06903717700004],
              [-160.14854895699992, 55.07099030200004],
              [-160.11998450399992, 55.07111237200007],
              [-160.12519283799992, 55.082464911000045],
              [-160.1341446609999, 55.09125397300005],
              [-160.1456192699999, 55.096991278000075],
              [-160.17393958199992, 55.103216864000046],
              [-160.18919837099992, 55.11237213700008],
              [-160.1948136059999, 55.121527411000045],
              [-160.18175208199992, 55.12571849200003],
              [-160.15290279899992, 55.12164948100008],
              [-160.10065670499992, 55.10342031500005],
              [-160.07221432199992, 55.09906647300005],
              [-160.08409583199992, 55.115301825000074],
              [-160.11347408799992, 55.13930898600006],
              [-160.12743079299992, 55.15371328300006],
              [-160.11058508999992, 55.16083405200004],
              [-160.09430904899992, 55.15692780200004],
              [-160.07990475199992, 55.14704010600008],
              [-160.06879635299993, 55.13666413000004],
              [-160.06407630099991, 55.12885163000004],
              [-160.0635880199999, 55.12352122600004],
              [-160.06065833199992, 55.12051015800006],
              [-160.0397843089999, 55.118475653000075],
              [-160.03156490799992, 55.11554596600007],
              [-160.0240372389999, 55.111029364000046],
              [-160.0175675119999, 55.10529205900008],
              [-160.01398678299992, 55.10805898600006],
              [-160.01020260299993, 55.111761786000045],
              [-160.0038956369999, 55.11953359600005],
              [-160.01915442599991, 55.13373444200005],
              [-160.05610104099992, 55.18138255400004],
              [-160.06537838399993, 55.20148346600007],
              [-159.98127193899992, 55.17788320500006],
              [-159.95360266799992, 55.175848700000074],
              [-159.97663326699993, 55.208319403000075],
              [-159.9648331369999, 55.21051666900007],
              [-159.9540909499999, 55.20970286700003],
              [-159.9433487619999, 55.21076080900008],
              [-159.9316300119999, 55.21857330900008],
              [-159.9306534499999, 55.22614166900007],
              [-159.93696041599992, 55.235256252000056],
              [-159.9448136059999, 55.24445221600007],
              [-159.94867916599992, 55.252386786000045],
              [-159.9396866529999, 55.25600820500006],
              [-159.8986710279999, 55.28534577000005],
              [-159.88727779899992, 55.29706452000005],
              [-159.87690182199992, 55.28758372600004],
              [-159.87421627499992, 55.28400299700007],
              [-159.86497962099992, 55.251166083000044],
              [-159.87511145699992, 55.23883698100008],
              [-159.8967179029999, 55.233628648000035],
              [-159.92198645699992, 55.221909898000035],
              [-159.90440833199992, 55.207464911000045],
              [-159.91694088399993, 55.15692780200004],
              [-159.9014786449999, 55.14008209800005],
            ],
          ],
          [
            [
              [-163.1390274729999, 55.403509833000044],
              [-163.15168209499993, 55.39695872600004],
              [-163.16258704299992, 55.39899323100008],
              [-163.17194576699993, 55.40403880400004],
              [-163.19505774599992, 55.41266510600008],
              [-163.18818111899992, 55.425116278000075],
              [-163.16791744699992, 55.43699778900003],
              [-163.14277096299992, 55.441066799000055],
              [-163.13312740799992, 55.43244049700007],
              [-163.12938391799992, 55.423041083000044],
              [-163.13141842399992, 55.413275458000044],
              [-163.1390274729999, 55.403509833000044],
            ],
          ],
          [
            [
              [-154.89962160299993, 19.56701629300005],
              [-154.84662324899992, 19.544937986000036],
              [-154.8253105199999, 19.527487875000077],
              [-154.8140635659999, 19.506579211000087],
              [-154.81720943899992, 19.479722398000035],
              [-154.82990475199992, 19.464056708000044],
              [-154.87473623499992, 19.412884155000086],
              [-154.9189322189999, 19.397311606000073],
              [-154.98230051299993, 19.339243956000075],
              [-155.02509518099993, 19.32758209800005],
              [-155.02666307099992, 19.31617095300004],
              [-155.0626129709999, 19.307820063000065],
              [-155.0930314219999, 19.28620959700004],
              [-155.1530410309999, 19.26920424000008],
              [-155.20295757199992, 19.25557960200007],
              [-155.24505936499992, 19.265539102000048],
              [-155.2692813719999, 19.266181593000056],
              [-155.29112743399992, 19.259523502000036],
              [-155.31444461799992, 19.245659319000083],
              [-155.3456868879999, 19.22480465500007],
              [-155.36413604799992, 19.203574675000084],
              [-155.3846584759999, 19.200530529000048],
              [-155.40014934799993, 19.193686082000056],
              [-155.4225968089999, 19.180121161000045],
              [-155.43683834499993, 19.169867255000042],
              [-155.4877823559999, 19.142523505000042],
              [-155.50279700399992, 19.13768138200004],
              [-155.54613196499992, 19.098211981000077],
              [-155.5537372119999, 19.08196080500005],
              [-155.5522599159999, 19.045618945000058],
              [-155.5706379169999, 19.026771030000077],
              [-155.60206039099992, 18.997379625000065],
              [-155.61852255699992, 18.955543680000062],
              [-155.6329688079999, 18.94020311400004],
              [-155.65124157199992, 18.926103771000044],
              [-155.6747556239999, 18.906117143000074],
              [-155.6835439269999, 18.911156771000037],
              [-155.68293237999993, 18.93288639000008],
              [-155.7041667029999, 18.949084649000042],
              [-155.7444144389999, 18.969342794000056],
              [-155.79217075999992, 18.996975708000036],
              [-155.8172532559999, 19.013230752000084],
              [-155.85913308999992, 19.02381241100005],
              [-155.87812988099992, 19.029072187000054],
              [-155.88404725599992, 19.04729461900007],
              [-155.89104864799992, 19.06565446400009],
              [-155.90390607199993, 19.06945906800007],
              [-155.91213327199992, 19.096188743000084],
              [-155.91993046899992, 19.13860065600005],
              [-155.90838559699992, 19.18898577400006],
              [-155.8855304539999, 19.33415695800005],
              [-155.88737398499993, 19.359568177000085],
              [-155.9008890609999, 19.382749774000047],
              [-155.91295857999992, 19.414314596000054],
              [-155.92949094899993, 19.461815958000045],
              [-155.93657771399992, 19.481310354000072],
              [-155.9464478779999, 19.49361106200007],
              [-155.95638810199992, 19.514236062000066],
              [-155.95396887899992, 19.536078192000048],
              [-155.9656358299999, 19.556630668000082],
              [-155.9713653009999, 19.57969801300004],
              [-155.9821971949999, 19.60767473100009],
              [-155.9995243969999, 19.63217940700008],
              [-156.0147840799999, 19.643355435000046],
              [-156.03625514499993, 19.66793548600009],
              [-156.06016392799992, 19.73122055300007],
              [-156.0501602859999, 19.759507554000038],
              [-156.03880774599992, 19.783148505000042],
              [-156.0174454419999, 19.80109284100007],
              [-155.99677486899992, 19.81443919500009],
              [-155.98749752499992, 19.824367580000057],
              [-155.98204505099991, 19.84332916900007],
              [-155.96796627499992, 19.85423411700009],
              [-155.9260147779999, 19.868801174000055],
              [-155.90583248599992, 19.902044989000046],
              [-155.8958634109999, 19.91347890800006],
              [-155.8734018789999, 19.951321249000046],
              [-155.85090084499993, 19.97528717700004],
              [-155.8354576179999, 19.975703442000054],
              [-155.82832005199992, 20.006960726000045],
              [-155.82408327899992, 20.020092445000046],
              [-155.83106861599992, 20.03937195000009],
              [-155.84770986799992, 20.054519035000055],
              [-155.88255598299992, 20.104942986000083],
              [-155.8969804319999, 20.148846149000065],
              [-155.89936275899993, 20.184068101000037],
              [-155.8992704929999, 20.216690077000067],
              [-155.88048255099991, 20.252020575000074],
              [-155.8672421619999, 20.26313203600006],
              [-155.83112924399992, 20.263429107000036],
              [-155.76606197799993, 20.249172268000052],
              [-155.73798580599993, 20.243801174000055],
              [-155.73261471299992, 20.238836981000077],
              [-155.72919674399992, 20.231350002000056],
              [-155.7280167309999, 20.221625067000048],
              [-155.71166938899992, 20.196149105000075],
              [-155.67334951599992, 20.18166990800006],
              [-155.6481305419999, 20.16800639300004],
              [-155.63065357999992, 20.148211666000066],
              [-155.6065189699999, 20.137955566000073],
              [-155.58636330899992, 20.122935923000057],
              [-155.56309786399993, 20.128402875000063],
              [-155.52719399699993, 20.12626898600007],
              [-155.49107825399992, 20.113023179000038],
              [-155.42071461799992, 20.090185489000078],
              [-155.33231277899992, 20.04672144300008],
              [-155.21510593099993, 19.97564539700005],
              [-155.16804273399993, 19.94682721500004],
              [-155.11585335499993, 19.896732304000068],
              [-155.0871411889999, 19.86037983400007],
              [-155.08639926199993, 19.821029192000083],
              [-155.0880615019999, 19.768645245000073],
              [-155.08537090599992, 19.727409311000088],
              [-155.05749289999991, 19.72853043200007],
              [-155.0185440749999, 19.745835679000038],
              [-154.98992338099993, 19.72670745100004],
              [-154.97667173399992, 19.705757273000074],
              [-154.98004376799992, 19.662806468000042],
              [-154.9669701269999, 19.63625192300009],
              [-154.94990596099993, 19.611445574000072],
              [-154.89962160299993, 19.56701629300005],
            ],
          ],
          [
            [
              [-156.56177406499992, 20.598007555000038],
              [-156.53656993599992, 20.570942072000037],
              [-156.5497675119999, 20.541472931000044],
              [-156.53412841099993, 20.53178747600009],
              [-156.54455506199992, 20.513216689000046],
              [-156.57291864099992, 20.512983613000074],
              [-156.59951072899992, 20.517403037000065],
              [-156.61886799899992, 20.513808491000077],
              [-156.6464985169999, 20.50808384800007],
              [-156.67926130299992, 20.504712932000075],
              [-156.70056182399992, 20.52542656500009],
              [-156.68845790499992, 20.540104408000047],
              [-156.66715906599993, 20.557717171000036],
              [-156.63914954299992, 20.575140692000048],
              [-156.60881453599993, 20.591045980000047],
              [-156.58262141199992, 20.599956701000053],
              [-156.56177406499992, 20.598007555000038],
            ],
          ],
          [
            [
              [-156.8483780589999, 20.87681712400007],
              [-156.8326722349999, 20.860743402000082],
              [-156.8163384329999, 20.84170417000007],
              [-156.80579730899993, 20.825107881000065],
              [-156.80353909899992, 20.812564416000043],
              [-156.8097313309999, 20.795479580000062],
              [-156.8312571289999, 20.76380716600005],
              [-156.8767747349999, 20.74426528400005],
              [-156.9137375269999, 20.73472409100009],
              [-156.96228010299993, 20.732387730000085],
              [-156.9823861449999, 20.75941401500006],
              [-156.9870786939999, 20.782873410000036],
              [-156.98835201699993, 20.80145905200004],
              [-156.98859615799992, 20.82493724200009],
              [-156.99213619699992, 20.84634023600006],
              [-157.0092241639999, 20.85588005900007],
              [-157.05080962099993, 20.871405682000045],
              [-157.0631360579999, 20.890386641000077],
              [-157.05521360199992, 20.911371030000055],
              [-157.0315509609999, 20.922717910000074],
              [-156.99041420499992, 20.92750878700008],
              [-156.89271962499993, 20.914141356000073],
              [-156.8483780589999, 20.87681712400007],
            ],
          ],
          [
            [
              [-156.00169837099992, 20.800441799000055],
              [-155.9795529099999, 20.75737428000008],
              [-155.98469586899992, 20.717591061000064],
              [-156.00313353899992, 20.685897726000064],
              [-156.0277404999999, 20.67936624300006],
              [-156.0484229989999, 20.650887888000057],
              [-156.07540389099992, 20.65067153700005],
              [-156.12950442099992, 20.62447291700005],
              [-156.1654377909999, 20.62523603200009],
              [-156.1854228429999, 20.62722037700007],
              [-156.2038298129999, 20.626042974000086],
              [-156.25369369999993, 20.604422509000074],
              [-156.2848926609999, 20.588638968000055],
              [-156.3025938039999, 20.581179336000048],
              [-156.32671484399992, 20.587171478000073],
              [-156.3358897669999, 20.588152080000043],
              [-156.3525130529999, 20.59242850600009],
              [-156.3654679029999, 20.588771877000056],
              [-156.4076531949999, 20.587206654000056],
              [-156.4354883739999, 20.611975966000045],
              [-156.43858219499992, 20.622197897000092],
              [-156.45166446099992, 20.635737885000083],
              [-156.4431428519999, 20.64260154400006],
              [-156.4427499809999, 20.660569389000045],
              [-156.4504815839999, 20.726380496000047],
              [-156.4584408599999, 20.74451703200009],
              [-156.4579918169999, 20.764835405000042],
              [-156.4643193999999, 20.781383147000042],
              [-156.4684269939999, 20.78458766400007],
              [-156.4753311839999, 20.790838934000078],
              [-156.48572697499992, 20.796661417000053],
              [-156.5016310999999, 20.796191426000064],
              [-156.5158802169999, 20.790087373000063],
              [-156.52130121699992, 20.77624129900005],
              [-156.53389852599992, 20.774138960000073],
              [-156.5486339599999, 20.78211058000005],
              [-156.5627259899999, 20.791837343000054],
              [-156.58448244099992, 20.79545238600008],
              [-156.6059757479999, 20.80837725100008],
              [-156.62023427199992, 20.80708809500004],
              [-156.63325604899993, 20.823737830000084],
              [-156.6570527659999, 20.84766082100009],
              [-156.6849066839999, 20.881887778000078],
              [-156.6861331769999, 20.90382201500006],
              [-156.6960091969999, 20.915801977000058],
              [-156.6922601189999, 20.936102735000077],
              [-156.68587926799992, 20.964236004000043],
              [-156.6768384449999, 20.987970972000085],
              [-156.66646901099992, 21.003438187000086],
              [-156.65384959699992, 21.004755317000047],
              [-156.64537512899992, 21.013373114000046],
              [-156.64484615799992, 21.021185614000046],
              [-156.63579034399993, 21.02712427000006],
              [-156.62658104699992, 21.02616196000008],
              [-156.6156795919999, 21.02514997600008],
              [-156.60725533099992, 21.02734320500008],
              [-156.60381995499992, 21.03199248800007],
              [-156.5979293139999, 21.03265327300005],
              [-156.58959970499993, 21.02773881300004],
              [-156.58138591199992, 21.018149872000038],
              [-156.57141335699993, 21.016456133000077],
              [-156.5556655389999, 21.008334336000075],
              [-156.54236772599992, 21.00338958800006],
              [-156.5375248279999, 20.99065166200006],
              [-156.52588858099992, 20.987321553000072],
              [-156.5228749089999, 20.97404530700004],
              [-156.52304721899992, 20.962198095000076],
              [-156.5091409739999, 20.95029633000007],
              [-156.5001891009999, 20.937583783000036],
              [-156.49299287099993, 20.92179827500007],
              [-156.4816715519999, 20.904397075000077],
              [-156.4640708309999, 20.905623498000068],
              [-156.45292111799992, 20.917917610000075],
              [-156.43370520699992, 20.917710679000038],
              [-156.41881262899992, 20.92011139500005],
              [-156.3896378249999, 20.921535549000055],
              [-156.37848873599992, 20.923976955000057],
              [-156.3464249339999, 20.945868231000077],
              [-156.3306778639999, 20.951239325000074],
              [-156.3154190749999, 20.952948309000078],
              [-156.2983292309999, 20.95270416900007],
              [-156.28193111899992, 20.95026276200008],
              [-156.26862545499992, 20.945054429000038],
              [-156.2643936839999, 20.944525458000044],
              [-156.26097571499992, 20.94367096600007],
              [-156.25812740799992, 20.94159577000005],
              [-156.25556393099993, 20.937648830000057],
              [-156.2429093089999, 20.941555080000057],
              [-156.22687740799992, 20.93195221600007],
              [-156.2218447459999, 20.92033718600004],
              [-156.2152814099999, 20.91472759600009],
              [-156.20722408799992, 20.90688711100006],
              [-156.1972550119999, 20.895005601000037],
              [-156.17919186199993, 20.883483182000077],
              [-156.16608840199993, 20.87148096800007],
              [-156.1647602449999, 20.86278635700006],
              [-156.1529896309999, 20.86179400900005],
              [-156.14793578899992, 20.861703227000078],
              [-156.1444231419999, 20.867117877000055],
              [-156.13126936199993, 20.857453126000053],
              [-156.12572920899993, 20.84404131200006],
              [-156.11928101799992, 20.836070945000074],
              [-156.0849891789999, 20.831451060000063],
              [-156.05100864999991, 20.81586326000007],
              [-156.00169837099992, 20.800441799000055],
            ],
          ],
          [
            [
              [-156.7490128249999, 21.17096588700008],
              [-156.7390060259999, 21.17276101400006],
              [-156.7332084319999, 21.16875073700004],
              [-156.73592061099993, 21.164081597000063],
              [-156.72914964999993, 21.160864427000035],
              [-156.71317627899992, 21.161368156000037],
              [-156.7057249359999, 21.15654296300005],
              [-156.7248429029999, 21.12372467700004],
              [-156.75560462099992, 21.095526434000078],
              [-156.79340572799993, 21.075873114000046],
              [-156.83100338399993, 21.061102606000077],
              [-156.86957760299993, 21.05337148600006],
              [-156.9085587229999, 21.057033596000053],
              [-156.94740522599992, 21.064542367000058],
              [-157.02491686599993, 21.08377873200004],
              [-157.07237381099992, 21.09938126500009],
              [-157.14032003399993, 21.094190171000037],
              [-157.1872703299999, 21.091781320000052],
              [-157.2225715609999, 21.08683923400008],
              [-157.2509659499999, 21.088446356000077],
              [-157.27306067599991, 21.08734772300005],
              [-157.29259192599991, 21.09471263200004],
              [-157.30394446499992, 21.10956452000005],
              [-157.30426998599992, 21.128241278000075],
              [-157.29645748599992, 21.14394765800006],
              [-157.2853897779999, 21.156073309000078],
              [-157.2673910199999, 21.16254177500008],
              [-157.2511633199999, 21.180283960000054],
              [-157.2466335469999, 21.19975686500004],
              [-157.25903621999993, 21.214829310000084],
              [-157.25975904299992, 21.221879885000078],
              [-157.24884316499993, 21.22171060700009],
              [-157.23292649099992, 21.21911695600005],
              [-157.20941306699993, 21.22032303800006],
              [-157.1968978939999, 21.217014816000074],
              [-157.1886843469999, 21.205141852000054],
              [-157.17357337099992, 21.205145575000074],
              [-157.0790840479999, 21.191713201000084],
              [-157.0280794919999, 21.18461390200008],
              [-156.9897354809999, 21.182847398000035],
              [-156.98180822999993, 21.194046789000083],
              [-156.98078888199993, 21.203420475000087],
              [-156.9756146089999, 21.211148396000056],
              [-156.96576900899993, 21.213324286000045],
              [-156.9524102999999, 21.196706858000084],
              [-156.94775751799992, 21.177849860000038],
              [-156.92523310899992, 21.17124498000004],
              [-156.89704547199992, 21.16519102300009],
              [-156.8466796429999, 21.166728943000066],
              [-156.82465843799991, 21.169547648000048],
              [-156.81063546099992, 21.173875442000053],
              [-156.8003122009999, 21.177676245000043],
              [-156.7917916099999, 21.17602790300009],
              [-156.77351917599992, 21.177205020000088],
              [-156.75949604599992, 21.173010679000072],
              [-156.7490128249999, 21.17096588700008],
            ],
          ],
          [
            [
              [-157.7068244589999, 21.35199519400004],
              [-157.69614600699992, 21.336397484000088],
              [-157.6744833349999, 21.322944104000044],
              [-157.65359865699992, 21.312566109000045],
              [-157.6471673949999, 21.306431478000036],
              [-157.6588840969999, 21.293833358000086],
              [-157.6837067179999, 21.27268686000008],
              [-157.69321165099993, 21.26274204400005],
              [-157.70407609699993, 21.25953043700008],
              [-157.70759887399993, 21.265616065000074],
              [-157.70676233299992, 21.27500557600007],
              [-157.71534558399992, 21.281838803000085],
              [-157.7421010399999, 21.275470596000048],
              [-157.7638140239999, 21.273104395000075],
              [-157.78188350399992, 21.264573042000052],
              [-157.7949652599999, 21.25466332600007],
              [-157.8108178889999, 21.25418992400006],
              [-157.81797924399993, 21.25763482600007],
              [-157.82292181999992, 21.26642563900009],
              [-157.8307136829999, 21.27725756700005],
              [-157.8636739629999, 21.290393167000047],
              [-157.88013648999993, 21.297962188000042],
              [-157.89075965599991, 21.31284138700005],
              [-157.8949671389999, 21.322282812000083],
              [-157.89487635299992, 21.331684863000078],
              [-157.90208601199993, 21.32838978300009],
              [-157.9151799379999, 21.31646648700007],
              [-157.9052385619999, 21.305631189000053],
              [-157.94700349599992, 21.30274280100008],
              [-157.9462289109999, 21.307427894000057],
              [-157.94043502899993, 21.310716966000086],
              [-157.94827431099992, 21.316833192000047],
              [-157.9641068139999, 21.31633453900008],
              [-157.96470917399992, 21.326398306000044],
              [-157.96749261199992, 21.334473519000085],
              [-157.96525828199992, 21.341151686000046],
              [-157.9680619739999, 21.347886951000078],
              [-157.95720876099992, 21.352459097000065],
              [-157.94708624499992, 21.357040236000046],
              [-157.93621674399992, 21.362954478000063],
              [-157.9318453909999, 21.37166236900009],
              [-157.9439514199999, 21.380486568000038],
              [-157.95396126799992, 21.38460120700006],
              [-157.9609268869999, 21.388820705000057],
              [-157.9654751399999, 21.384727590000068],
              [-157.96920995599993, 21.37202164000007],
              [-157.97779206299992, 21.376131111000063],
              [-157.9856257449999, 21.384953133000067],
              [-157.9913320329999, 21.391072595000082],
              [-157.99072921299992, 21.37761230800004],
              [-157.98443137499993, 21.36212908100009],
              [-157.98950627199991, 21.358831482000085],
              [-158.01161218099992, 21.376504880000084],
              [-158.0201735539999, 21.38331316400007],
              [-158.01314913299993, 21.367118178000055],
              [-157.9967961369999, 21.350871245000064],
              [-157.98467730399992, 21.34135922300004],
              [-157.9754130629999, 21.333886618000065],
              [-157.98062699899992, 21.31852093300006],
              [-157.99869171199992, 21.311337541000057],
              [-158.0224689279999, 21.307561571000065],
              [-158.05923422299992, 21.299886721000064],
              [-158.0779520069999, 21.298060788000043],
              [-158.09430904899992, 21.29360586100006],
              [-158.09886633999992, 21.295396226000037],
              [-158.1033829419999, 21.299261786000045],
              [-158.1152679889999, 21.30512142100008],
              [-158.12423623599992, 21.338739434000047],
              [-158.13471880199992, 21.36565543100005],
              [-158.1482328499999, 21.381164271000046],
              [-158.15743577799992, 21.394653557000083],
              [-158.1760522579999, 21.403530111000066],
              [-158.18080246899993, 21.430369488000053],
              [-158.18712001199992, 21.444498301000067],
              [-158.2049539639999, 21.45872782300006],
              [-158.21567735699992, 21.465522252000085],
              [-158.2276003229999, 21.483046969000043],
              [-158.2281210129999, 21.50379942300009],
              [-158.2293221909999, 21.53260499000004],
              [-158.23595130099991, 21.541571356000077],
              [-158.2789330139999, 21.575264710000056],
              [-158.27241910499993, 21.578559037000048],
              [-158.2363382439999, 21.58494071000007],
              [-158.19381632199992, 21.587236919000077],
              [-158.1657374469999, 21.585642587000052],
              [-158.14916452499992, 21.58615894600007],
              [-158.1365860669999, 21.58930084800005],
              [-158.12107246399992, 21.58589498200007],
              [-158.11762447799993, 21.598089911000045],
              [-158.1129463839999, 21.603906081000048],
              [-158.09481973799993, 21.613784087000056],
              [-158.0737839189999, 21.628957722000052],
              [-158.0657855169999, 21.63557441200004],
              [-158.06720943899992, 21.641424872000073],
              [-158.0600479809999, 21.652492580000057],
              [-158.05060787699992, 21.67129140800006],
              [-158.03534908799992, 21.683417059000078],
              [-158.0144451099999, 21.701498576000063],
              [-157.98264568699992, 21.709850429000085],
              [-157.96965529599993, 21.709060736000083],
              [-157.9624325199999, 21.705012456000077],
              [-157.9567324239999, 21.69892202400007],
              [-157.9501846999999, 21.690619208000044],
              [-157.9339122469999, 21.67789751500004],
              [-157.9333265649999, 21.667164656000068],
              [-157.9246855119999, 21.66307117200006],
              [-157.92409174999992, 21.65433981600006],
              [-157.91553391999992, 21.64553978500004],
              [-157.92018111099992, 21.627451070000063],
              [-157.9073256149999, 21.61059113600004],
              [-157.89376363699992, 21.59838170200004],
              [-157.88750281799992, 21.580882287000065],
              [-157.87672769899993, 21.57540770500009],
              [-157.87392491499992, 21.569342261000088],
              [-157.87118099399993, 21.55791608700008],
              [-157.86357947599993, 21.559794776000047],
              [-157.85350021399992, 21.55633974400007],
              [-157.8459366529999, 21.548041083000044],
              [-157.83644887699992, 21.534049337000056],
              [-157.83631291999993, 21.518645190000086],
              [-157.83639205999992, 21.51127032800008],
              [-157.84437393599993, 21.511359894000066],
              [-157.8495249549999, 21.50538434300006],
              [-157.8475604909999, 21.488600903000076],
              [-157.8455183629999, 21.477849332000062],
              [-157.8421273559999, 21.461048946000062],
              [-157.8327650589999, 21.458257287000038],
              [-157.82051899099991, 21.453415894000045],
              [-157.8112682699999, 21.441904753000074],
              [-157.8035128939999, 21.429072422000047],
              [-157.7883659139999, 21.42418664300004],
              [-157.78632353499992, 21.416788890000078],
              [-157.77622749499992, 21.413305523000076],
              [-157.76961904799992, 21.420603638000046],
              [-157.7600499229999, 21.43323432400007],
              [-157.77511743199992, 21.44281247100008],
              [-157.77352449999992, 21.454198992000045],
              [-157.76261822499993, 21.45876424100004],
              [-157.7380552529999, 21.45578118900005],
              [-157.7257075269999, 21.458985098000085],
              [-157.72292086099992, 21.451569411000037],
              [-157.73761959499993, 21.43768952000005],
              [-157.74054928299992, 21.419582424000055],
              [-157.73870430699992, 21.405451046000053],
              [-157.72217799199993, 21.395840616000044],
              [-157.7093042029999, 21.38358753300008],
              [-157.7057999339999, 21.37490469000005],
              [-157.71030534399992, 21.36346084900009],
              [-157.7068244589999, 21.35199519400004],
            ],
          ],
          [
            [
              [-160.11375891799992, 22.00027090100008],
              [-160.0958624939999, 22.007756812000082],
              [-160.07889226299991, 22.007177039000055],
              [-160.05996362099992, 22.00056297000009],
              [-160.0514363519999, 21.983050251000066],
              [-160.0598785059999, 21.973971993000077],
              [-160.07223035599992, 21.95945265000006],
              [-160.07953854099992, 21.937892971000053],
              [-160.07221432199992, 21.91083405200004],
              [-160.0852460909999, 21.893535615000076],
              [-160.10253417899992, 21.886283768000055],
              [-160.1174862139999, 21.878397755000037],
              [-160.13634066499992, 21.87291758100008],
              [-160.15866236199992, 21.859563610000066],
              [-160.17167726999992, 21.84864838100009],
              [-160.17946091099992, 21.833515584000054],
              [-160.19102942599991, 21.80467357000009],
              [-160.19824030599992, 21.783883779000064],
              [-160.21128488999992, 21.780209463000062],
              [-160.22435918699992, 21.789242828000056],
              [-160.2354661219999, 21.792821383000046],
              [-160.2480362619999, 21.82802969000005],
              [-160.2454626059999, 21.85083912500005],
              [-160.2344235239999, 21.874455639000075],
              [-160.19538282999991, 21.912044980000076],
              [-160.16402566999992, 21.93446802400007],
              [-160.1236196719999, 21.95629587700006],
              [-160.11726442399993, 21.96964151600008],
              [-160.1127389739999, 21.981737514000088],
              [-160.11375891799992, 22.00027090100008],
            ],
          ],
          [
            [
              [-159.30125891799992, 22.15102773600006],
              [-159.29279537699992, 22.146429755000042],
              [-159.29259192599991, 22.135565497000073],
              [-159.29470434299992, 22.10762722900006],
              [-159.30414101699992, 22.095614122000086],
              [-159.31869426999992, 22.05755984700005],
              [-159.3331755579999, 22.049568974000067],
              [-159.33466549399992, 22.021551825000074],
              [-159.33165442599991, 22.004055080000057],
              [-159.33063717399992, 21.984767971000053],
              [-159.33173580599993, 21.966131903000075],
              [-159.3341275889999, 21.958057444000076],
              [-159.34789362499993, 21.95810694800008],
              [-159.35912242299992, 21.952900339000053],
              [-159.35161538699992, 21.945454166000047],
              [-159.3478623199999, 21.936710490000053],
              [-159.3536428849999, 21.93004392100005],
              [-159.36540977299993, 21.930833024000037],
              [-159.38249247299993, 21.917418699000052],
              [-159.38971851999992, 21.90541018400006],
              [-159.39837222399993, 21.898077845000046],
              [-159.41496175999993, 21.888098166000077],
              [-159.41641106999992, 21.880747968000037],
              [-159.42722672099993, 21.87944692700006],
              [-159.4337168499999, 21.874116960000038],
              [-159.43731532299992, 21.868769246000056],
              [-159.48192211399993, 21.88354664600007],
              [-159.5092655359999, 21.886252262000085],
              [-159.52961755099992, 21.88565103400009],
              [-159.5675545539999, 21.893029933000037],
              [-159.58194862899992, 21.894351836000055],
              [-159.59057490499993, 21.901714646000073],
              [-159.59489227699993, 21.900387702000046],
              [-159.5963412309999, 21.89369892700006],
              [-159.60497869399993, 21.89170254000004],
              [-159.61000958199992, 21.899719360000063],
              [-159.62296792799992, 21.905057252000063],
              [-159.63448238799992, 21.913747819000037],
              [-159.6416646419999, 21.92310713800009],
              [-159.6459720549999, 21.931796147000057],
              [-159.6502913649999, 21.93980781600004],
              [-159.6618163889999, 21.942477516000054],
              [-159.66612450399992, 21.950496926000085],
              [-159.67620855799993, 21.95517090000004],
              [-159.69611568899992, 21.958156643000052],
              [-159.7115111239999, 21.963849810000056],
              [-159.72375758599992, 21.96985969900004],
              [-159.74321276299992, 21.97319534400009],
              [-159.7597937319999, 21.97853337300006],
              [-159.7684493579999, 21.99522978600004],
              [-159.77133289999992, 22.005248072000086],
              [-159.77998975399993, 22.009253388000047],
              [-159.78721108599993, 22.01927012100009],
              [-159.78721974299992, 22.033298974000047],
              [-159.7857842399999, 22.044656149000048],
              [-159.78506601799992, 22.057349453000086],
              [-159.7865150719999, 22.066034131000038],
              [-159.77656002499992, 22.069525458000044],
              [-159.7497481139999, 22.098106817000087],
              [-159.73568048599992, 22.11524585300009],
              [-159.73432369699992, 22.12498607000009],
              [-159.73420162699992, 22.133734442000048],
              [-159.73261471299992, 22.140773830000057],
              [-159.72590084499993, 22.14362213700008],
              [-159.72345943899992, 22.146551825000074],
              [-159.71653372999992, 22.157514047000063],
              [-159.69417764599993, 22.163517926000054],
              [-159.66818841799991, 22.16947814200006],
              [-159.63937456399992, 22.18555923400004],
              [-159.6213488429999, 22.20029138600006],
              [-159.5982343009999, 22.210864550000053],
              [-159.5895821039999, 22.220953807000058],
              [-159.5765935089999, 22.225661440000067],
              [-159.56576758799991, 22.225647018000075],
              [-159.5585431959999, 22.232995262000088],
              [-159.54844145599992, 22.230979673000036],
              [-159.5412323749999, 22.22495373000004],
              [-159.5376335699999, 22.21826062300005],
              [-159.5296962939999, 22.217584970000075],
              [-159.51671244899993, 22.213565231000075],
              [-159.5080631429999, 22.208204068000043],
              [-159.4994077609999, 22.208847302000038],
              [-159.50227644499992, 22.216221266000048],
              [-159.4993762359999, 22.22357433400009],
              [-159.4813214959999, 22.23023532500008],
              [-159.46257753799992, 22.227500218000046],
              [-159.4401781669999, 22.22751840400008],
              [-159.42865345799993, 22.220800936000046],
              [-159.41925912599993, 22.222135396000056],
              [-159.40768297699992, 22.228815741000062],
              [-159.39971985999992, 22.235494671000083],
              [-159.3881845189999, 22.228789014000085],
              [-159.3737553189999, 22.222087383000087],
              [-159.35786585499991, 22.222729077000054],
              [-159.33873450399992, 22.213039455000057],
              [-159.33122478599992, 22.197941195000055],
              [-159.31867428299992, 22.18577708500004],
              [-159.3118119869999, 22.184503118000066],
              [-159.30757581499992, 22.17109365400006],
              [-159.3046578299999, 22.161103188000084],
              [-159.30134029899992, 22.15106842700004],
              [-159.30125891799992, 22.15102773600006],
            ],
          ],
          [
            [
              [179.40007571700005, 51.40843333500004],
              [179.45850670700008, 51.381293036000045],
              [179.47234134200005, 51.37055084800005],
              [179.45427493600005, 51.370347398000035],
              [179.42115319100003, 51.364162502000056],
              [179.40357506600003, 51.36440664300005],
              [179.40577233200008, 51.368394273000035],
              [179.40691165500004, 51.36863841400009],
              [179.41041100400003, 51.37055084800005],
              [179.39665774800005, 51.37689850500004],
              [179.3828231130001, 51.37734609600005],
              [179.35515384200005, 51.37055084800005],
              [179.3486434250001, 51.36741771000004],
              [179.340668165, 51.35927969000005],
              [179.33521569100003, 51.35757070500006],
              [179.32699629, 51.358587958000044],
              [179.31072024800005, 51.363267320000034],
              [179.301117384, 51.36440664300005],
              [179.28785241000003, 51.361029364000046],
              [179.27116946700005, 51.35455963700008],
              [179.2548934250001, 51.35028717700004],
              [179.243011915, 51.35382721600007],
              [179.23585045700008, 51.36347077000005],
              [179.23422285200002, 51.37201569200005],
              [179.23780358200008, 51.38076406500005],
              [179.246429884, 51.391058661000045],
              [179.07691491000003, 51.453558661000045],
              [179.05844160200002, 51.46759674700007],
              [179.0410262380001, 51.47703685100004],
              [179.0390731130001, 51.48289622600004],
              [179.034515821, 51.49062734600005],
              [179.02686608200008, 51.50092194200005],
              [179.0141707690001, 51.509019273000035],
              [178.98812910200002, 51.52216217700004],
              [178.96013431100005, 51.54214101800005],
              [178.9414168630001, 51.55036041900007],
              [178.87232506600003, 51.57135651200008],
              [178.8383895190001, 51.57664622600004],
              [178.79997806100005, 51.57111237200007],
              [178.78296959700003, 51.57217031500005],
              [178.779633009, 51.58283112200007],
              [178.75359134200005, 51.58283112200007],
              [178.73511803500003, 51.58490631700005],
              [178.71941165500004, 51.59210846600007],
              [178.70191491000003, 51.60736725500004],
              [178.6894637380001, 51.61538320500006],
              [178.63640384200005, 51.63743724200003],
              [178.66667728000004, 51.65501536700003],
              [178.6826278000001, 51.65900299700007],
              [178.7212020190001, 51.64280833500004],
              [178.76921634200005, 51.63971588700008],
              [178.7871199880001, 51.62384674700007],
              [178.80030358200008, 51.63544342700004],
              [178.814789259, 51.635931708000044],
              [178.82927493600005, 51.628607489000046],
              [178.8418074880001, 51.61701080900008],
              [178.85377037900003, 51.62067291900007],
              [178.86988366000003, 51.62181224200003],
              [178.88738040500004, 51.62055084800005],
              [178.92017662900003, 51.61180247600004],
              [178.92790774800005, 51.60716380400004],
              [178.93116295700008, 51.60028717700004],
              [178.93433678500003, 51.58860911700003],
              [178.9419051440001, 51.58494700700004],
              [178.95183353000004, 51.58380768400008],
              [178.96168053500003, 51.579779364000046],
              [178.96664472700002, 51.57892487200007],
              [178.9863387380001, 51.577826239000046],
              [178.9926863940001, 51.57664622600004],
              [178.99683678500003, 51.572333075000074],
              [179.00611412900003, 51.55853913000004],
              [179.00928795700008, 51.555568752000056],
              [179.02076256600003, 51.54995351800005],
              [179.06031334700003, 51.51459381700005],
              [179.12289472700002, 51.48041413000004],
              [179.139984571, 51.47679271000004],
              [179.18344160200002, 51.47321198100008],
              [179.1953231130001, 51.47052643400008],
              [179.20427493600005, 51.46308014500005],
              [179.22803795700008, 51.43919505400004],
              [179.24008222700002, 51.41669342700004],
              [179.25757897200003, 51.41364166900007],
              [179.294281446, 51.41901276200008],
              [179.2910262380001, 51.41498444200005],
              [179.28874759200005, 51.411322333000044],
              [179.2856551440001, 51.40802643400008],
              [179.28003991000003, 51.404730536000045],
              [179.28003991000003, 51.398504950000074],
              [179.379242384, 51.40192291900007],
              [179.40007571700005, 51.40843333500004],
            ],
          ],
          [
            [
              [178.25220787900003, 51.82990143400008],
              [178.271820509, 51.82501862200007],
              [178.31364993600005, 51.821926174000055],
              [178.3339949880001, 51.81622955900008],
              [178.35035241000003, 51.80695221600007],
              [178.39616946700005, 51.76850006700005],
              [178.38111412900003, 51.772365627000056],
              [178.3564559250001, 51.76740143400008],
              [178.34148196700005, 51.76850006700005],
              [178.33122806100005, 51.77423737200007],
              [178.31169681100005, 51.79205963700008],
              [178.3037215500001, 51.79572174700007],
              [178.285980665, 51.79975006700005],
              [178.2602645190001, 51.80963776200008],
              [178.23658287900003, 51.82294342700004],
              [178.22486412900003, 51.83673737200007],
              [178.231293165, 51.83177317900004],
              [178.23715254, 51.830511786000045],
              [178.24382571700005, 51.83071523600006],
              [178.25220787900003, 51.82990143400008],
            ],
          ],
          [
            [
              [178.53394616000003, 51.987494208000044],
              [178.57341556100005, 51.97565338700008],
              [178.59050540500004, 51.96824778900003],
              [178.60230553500003, 51.95343659100007],
              [178.60425866000003, 51.93768952000005],
              [178.5962020190001, 51.92914459800005],
              [178.5825301440001, 51.92234935100004],
              [178.56804446700005, 51.911810614000046],
              [178.5742293630001, 51.905585028000075],
              [178.5590926440001, 51.90070221600007],
              [178.53785241000003, 51.89667389500005],
              [178.51677493600005, 51.896185614000046],
              [178.50261478000004, 51.90192291900007],
              [178.47136478000004, 51.92625560100004],
              [178.46452884200005, 51.932928778000075],
              [178.4599715500001, 51.94440338700008],
              [178.463226759, 51.952053127000056],
              [178.46900475400003, 51.96116771000004],
              [178.47193444100003, 51.976996161000045],
              [178.47730553500003, 51.98590729400007],
              [178.49040774800005, 51.98867422100005],
              [178.50611412900003, 51.989935614000046],
              [178.51970462300005, 51.99437083500004],
              [178.52295983200008, 51.99054596600007],
              [178.52613366000003, 51.98895905200004],
              [178.53394616000003, 51.987494208000044],
            ],
          ],
          [
            [
              [179.78093509200005, 51.96702708500004],
              [179.77507571700005, 51.95547109600005],
              [179.76384524800005, 51.946193752000056],
              [179.75342858200008, 51.93964264500005],
              [179.74984785200002, 51.93602122600004],
              [179.75538170700008, 51.92267487200007],
              [179.7465926440001, 51.91347890800006],
              [179.7226668630001, 51.90192291900007],
              [179.6997176440001, 51.88654205900008],
              [179.67139733200008, 51.87718333500004],
              [179.64210045700008, 51.87417226800005],
              [179.566742384, 51.88523997600004],
              [179.55779056100005, 51.88825104400007],
              [179.5493270190001, 51.89492422100005],
              [179.52271569100003, 51.90912506700005],
              [179.49822024800005, 51.91640859600005],
              [179.49732506600003, 51.926214911000045],
              [179.50261478000004, 51.935614325000074],
              [179.50660241000003, 51.939154364000046],
              [179.50367272200003, 51.950100002000056],
              [179.499359571, 51.95892975500004],
              [179.493500196, 51.96653880400004],
              [179.48609459700003, 51.973863023000035],
              [179.49626712300005, 51.97801341400003],
              [179.51636803500003, 51.978216864000046],
              [179.52711022200003, 51.980129299000055],
              [179.55827884200005, 52.00185781500005],
              [179.57447350400003, 52.00438060100004],
              [179.59791100400003, 52.01154205900008],
              [179.62126712300005, 52.02216217700004],
              [179.63697350400003, 52.03534577000005],
              [179.64340254, 52.03034088700008],
              [179.649261915, 52.02903880400004],
              [179.66423587300005, 52.028509833000044],
              [179.67009524800005, 52.01984284100007],
              [179.67652428500003, 52.015692450000074],
              [179.68376712300005, 52.01284414300005],
              [179.69214928500003, 52.00804271000004],
              [179.71892337300005, 51.987494208000044],
              [179.73454837300005, 51.97882721600007],
              [179.74927819100003, 51.97357819200005],
              [179.78093509200005, 51.96702708500004],
            ],
          ],
          [
            [
              [177.6425887380001, 52.124701239000046],
              [177.672211134, 52.11269765800006],
              [177.68376712300005, 52.10504791900007],
              [177.6904403000001, 52.089911200000074],
              [177.6821395190001, 52.08283112200007],
              [177.66391035200002, 52.075506903000075],
              [177.6562606130001, 52.06948476800005],
              [177.65105228000004, 52.05963776200008],
              [177.6484481130001, 52.04364655200004],
              [177.6425887380001, 52.03534577000005],
              [177.6269637380001, 52.02521393400008],
              [177.56763756600003, 52.00185781500005],
              [177.57699629, 51.98891836100006],
              [177.56397545700008, 51.97907135600008],
              [177.55445397200003, 51.968451239000046],
              [177.57447350400003, 51.95343659100007],
              [177.60914147200003, 51.952460028000075],
              [177.61475670700008, 51.95001862200007],
              [177.61443118600005, 51.93691640800006],
              [177.61207116000003, 51.92792389500005],
              [177.6059676440001, 51.92572663000004],
              [177.5942488940001, 51.932928778000075],
              [177.58033287900003, 51.925116278000075],
              [177.57309004, 51.919582424000055],
              [177.56763756600003, 51.911810614000046],
              [177.55534915500004, 51.92059967700004],
              [177.53874759200005, 51.92829010600008],
              [177.52125084700003, 51.932928778000075],
              [177.50554446700005, 51.932928778000075],
              [177.4941512380001, 51.92568594000005],
              [177.48609459700003, 51.91596100500004],
              [177.47779381600003, 51.912990627000056],
              [177.46509850400003, 51.925482489000046],
              [177.47136478000004, 51.939154364000046],
              [177.41358483200008, 51.93065013200004],
              [177.39234459700003, 51.92088450700004],
              [177.36597741000003, 51.912095445000034],
              [177.35425866000003, 51.89606354400007],
              [177.3344832690001, 51.83966705900008],
              [177.33090254, 51.83380768400008],
              [177.323578321, 51.82680898600006],
              [177.3169051440001, 51.82876211100006],
              [177.30681399800005, 51.83698151200008],
              [177.2973738940001, 51.846991278000075],
              [177.29314212300005, 51.85407135600008],
              [177.28337649800005, 51.862494208000044],
              [177.23780358200008, 51.88312409100007],
              [177.22429446700005, 51.89199453300006],
              [177.29371178500003, 51.92218659100007],
              [177.316742384, 51.925482489000046],
              [177.32886803500003, 51.929673570000034],
              [177.34001712300005, 51.93976471600007],
              [177.3584090500001, 51.963324286000045],
              [177.37256920700008, 51.974676825000074],
              [177.388031446, 51.978583075000074],
              [177.42351321700005, 51.980129299000055],
              [177.4453231130001, 51.98651764500005],
              [177.45427493600005, 51.987494208000044],
              [177.477875196, 51.986761786000045],
              [177.48503665500004, 51.987494208000044],
              [177.50847415500004, 51.994574286000045],
              [177.51628665500004, 52.00096263200004],
              [177.52711022200003, 52.034816799000055],
              [177.556000196, 52.08490631700005],
              [177.55388431100005, 52.10423411700003],
              [177.59343509200005, 52.125067450000074],
              [177.61540774800005, 52.130072333000044],
              [177.6425887380001, 52.124701239000046],
            ],
          ],
          [
            [
              [175.8818465500001, 52.37799713700008],
              [175.91586347700002, 52.37799713700008],
              [175.9365340500001, 52.37164948100008],
              [175.97331790500004, 52.36465078300006],
              [175.99097741000003, 52.35809967700004],
              [175.9629012380001, 52.34406159100007],
              [175.92888431100005, 52.33926015800006],
              [175.89861087300005, 52.348822333000044],
              [175.8818465500001, 52.37799713700008],
            ],
          ],
          [
            [
              [173.79127037900003, 52.50153229400007],
              [173.73064212300005, 52.47211334800005],
              [173.71306399800005, 52.45058828300006],
              [173.72608483200008, 52.42291901200008],
              [173.73365319100003, 52.41120026200008],
              [173.73894290500004, 52.39443594000005],
              [173.74244225400003, 52.37641022300005],
              [173.74341881600003, 52.36123281500005],
              [173.66089928500003, 52.35065338700008],
              [173.66358483200008, 52.35610586100006],
              [173.66423587300005, 52.358710028000075],
              [173.6650496750001, 52.360663153000075],
              [173.6684676440001, 52.36432526200008],
              [173.6684676440001, 52.371161200000074],
              [173.65601647200003, 52.37006256700005],
              [173.6445418630001, 52.371161200000074],
              [173.63453209700003, 52.37396881700005],
              [173.62671959700003, 52.37799713700008],
              [173.62761478000004, 52.394598700000074],
              [173.60531660200002, 52.39679596600007],
              [173.50066165500004, 52.38703034100007],
              [173.401703321, 52.39667389500005],
              [173.38892662900003, 52.40379466400003],
              [173.39405358200008, 52.419582424000055],
              [173.40845787900003, 52.430121161000045],
              [173.43132571700005, 52.44049713700008],
              [173.45427493600005, 52.44721100500004],
              [173.469086134, 52.44684479400007],
              [173.49146569100003, 52.44204336100006],
              [173.51050866000003, 52.44159577000005],
              [173.5278426440001, 52.44550202000005],
              [173.5449324880001, 52.45368073100008],
              [173.56706790500004, 52.47117747600004],
              [173.575531446, 52.47357819200005],
              [173.5927840500001, 52.47406647300005],
              [173.59929446700005, 52.47638580900008],
              [173.60230553500003, 52.481675523000035],
              [173.60954837300005, 52.49127838700008],
              [173.61866295700008, 52.49872467700004],
              [173.62452233200008, 52.50071849200003],
              [173.63111412900003, 52.500433661000045],
              [173.73747806100005, 52.51080963700008],
              [173.76734459700003, 52.509426174000055],
              [173.79127037900003, 52.50153229400007],
            ],
          ],
          [
            [
              [174.0966903000001, 52.713771877000056],
              [174.08033287900003, 52.717678127000056],
              [174.08350670700008, 52.72650788000004],
              [174.0976668630001, 52.73578522300005],
              [174.11394290500004, 52.74103424700007],
              [174.16480553500003, 52.72093333500004],
              [174.18230228000004, 52.70693594000005],
              [174.0966903000001, 52.713771877000056],
            ],
          ],
          [
            [
              [173.37663821700005, 52.83047109600005],
              [173.33741295700008, 52.826239325000074],
              [173.32203209700003, 52.82021719000005],
              [173.32154381600003, 52.81085846600007],
              [173.29615319100003, 52.82953522300005],
              [173.28199303500003, 52.83738841400003],
              [173.263031446, 52.84414297100005],
              [173.24195397200003, 52.84711334800005],
              [173.2226668630001, 52.843817450000074],
              [173.20655358200008, 52.83392975500004],
              [173.19483483200008, 52.81679922100005],
              [173.18864993600005, 52.81679922100005],
              [173.18864993600005, 52.82363515800006],
              [173.18116295700008, 52.82363515800006],
              [173.1743270190001, 52.80931224200003],
              [173.18864993600005, 52.803168036000045],
              [173.18864993600005, 52.79572174700007],
              [173.16374759200005, 52.79352448100008],
              [173.1464949880001, 52.788275458000044],
              [173.13152103000004, 52.78864166900007],
              [173.11280358200008, 52.803168036000045],
              [173.09400475400003, 52.82656484600005],
              [173.08936608200008, 52.83047109600005],
              [173.077484571, 52.82831452000005],
              [173.05787194100003, 52.81891510600008],
              [173.04835045700008, 52.81679922100005],
              [173.0166121750001, 52.80219147300005],
              [172.981293165, 52.772772528000075],
              [172.9443465500001, 52.74982330900008],
              [172.90748131600003, 52.75470612200007],
              [172.91081790500004, 52.76015859600005],
              [172.91285241000003, 52.77008698100008],
              [172.9121199880001, 52.78099192900004],
              [172.90748131600003, 52.789496161000045],
              [172.89380944100003, 52.796087958000044],
              [172.880218946, 52.79531484600005],
              [172.85621178500003, 52.789496161000045],
              [172.84937584700003, 52.79181549700007],
              [172.83936608200008, 52.80158112200007],
              [172.83228600400003, 52.803168036000045],
              [172.82699629, 52.79938385600008],
              [172.82178795700008, 52.78563060100004],
              [172.81462649800005, 52.78266022300005],
              [172.8017684250001, 52.784409898000035],
              [172.77662194100003, 52.79287344000005],
              [172.76343834700003, 52.79572174700007],
              [172.76343834700003, 52.803168036000045],
              [172.776703321, 52.810980536000045],
              [172.7832137380001, 52.82282135600008],
              [172.79078209700003, 52.850897528000075],
              [172.80876712300005, 52.87750885600008],
              [172.8110457690001, 52.887925523000035],
              [172.79761803500003, 52.89252350500004],
              [172.78785241000003, 52.89081452000005],
              [172.75603274800005, 52.878241278000075],
              [172.744476759, 52.87710195500006],
              [172.70818118600005, 52.878241278000075],
              [172.64039147200003, 52.868801174000055],
              [172.62614993600005, 52.87201569200005],
              [172.63559004, 52.879339911000045],
              [172.66041100400003, 52.91303131700005],
              [172.6528426440001, 52.92438385600008],
              [172.63990319100003, 52.92804596600007],
              [172.60515384200005, 52.926662502000056],
              [172.54761803500003, 52.91290924700007],
              [172.53402754, 52.916083075000074],
              [172.52019290500004, 52.92259349200003],
              [172.49187259200005, 52.92011139500005],
              [172.47608483200008, 52.926662502000056],
              [172.551117384, 52.96759674700007],
              [172.55738366000003, 52.960150458000044],
              [172.57691491000003, 52.97797272300005],
              [172.66041100400003, 53.00861237200007],
              [172.730804884, 53.00039297100005],
              [172.74675540500004, 53.00486888200004],
              [172.76286868600005, 53.01414622600004],
              [172.78109785200002, 53.01552969000005],
              [172.90406334700003, 53.001166083000044],
              [172.91138756600003, 52.99860260600008],
              [172.91423587300005, 52.99266185100004],
              [172.91627037900003, 52.98623281500005],
              [172.92107181100005, 52.98187897300005],
              [172.9340926440001, 52.97988515800006],
              [172.95728600400003, 52.97964101800005],
              [172.96941165500004, 52.97443268400008],
              [173.00806725400003, 52.98969147300005],
              [173.02719160200002, 52.99359772300005],
              [173.12720787900003, 52.99494049700007],
              [173.14332116000003, 52.99038320500006],
              [173.17505944100003, 52.97174713700008],
              [173.18474368600005, 52.96759674700007],
              [173.1860457690001, 52.961818752000056],
              [173.17139733200008, 52.94863515800006],
              [173.14014733200008, 52.926662502000056],
              [173.15154056100005, 52.92877838700008],
              [173.16032962300005, 52.927720445000034],
              [173.16586347700002, 52.922756252000056],
              [173.16749108200008, 52.91303131700005],
              [173.22217858200008, 52.93732330900008],
              [173.24984785200002, 52.94440338700008],
              [173.2568465500001, 52.93349844000005],
              [173.3012801440001, 52.92560455900008],
              [173.32252037900003, 52.916001695000034],
              [173.32178795700008, 52.90249258000006],
              [173.30933678500003, 52.89276764500005],
              [173.29639733200008, 52.88548411700003],
              [173.263031446, 52.87201569200005],
              [173.30152428500003, 52.85932038000004],
              [173.3515731130001, 52.85248444200005],
              [173.40186608200008, 52.85187409100007],
              [173.4419051440001, 52.85773346600007],
              [173.43311608200008, 52.83856842700004],
              [173.41871178500003, 52.83075592700004],
              [173.37663821700005, 52.83047109600005],
            ],
          ],
          [
            [
              [-164.9725235669999, 54.12518952000005],
              [-164.9638565749999, 54.13108958500004],
              [-164.9550675119999, 54.13312409100007],
              [-164.94615637899992, 54.13108958500004],
              [-164.93781490799992, 54.12518952000005],
              [-164.9327286449999, 54.11399974200003],
              [-164.93993079299992, 54.099310614000046],
              [-164.95287024599992, 54.085598049000055],
              [-164.9650772779999, 54.077460028000075],
              [-164.97602291599992, 54.07575104400007],
              [-165.0538223949999, 54.077460028000075],
              [-165.08918209499993, 54.07086823100008],
              [-165.10224361899992, 54.07123444200005],
              [-165.10773678299992, 54.073879299000055],
              [-165.1163223949999, 54.08295319200005],
              [-165.1230362619999, 54.084865627000056],
              [-165.12852942599991, 54.083685614000046],
              [-165.14325924399992, 54.077460028000075],
              [-165.20677649599992, 54.08535390800006],
              [-165.22577877499992, 54.091050523000035],
              [-165.2193497389999, 54.101629950000074],
              [-165.21259518099993, 54.109361070000034],
              [-165.20368404899992, 54.11473216400003],
              [-165.19102942599991, 54.118353583000044],
              [-165.18321692599991, 54.118353583000044],
              [-165.1712540359999, 54.11347077000005],
              [-165.16437740799992, 54.11212799700007],
              [-165.15497799399992, 54.11538320500006],
              [-165.14093990799992, 54.12946198100008],
              [-165.13300533799992, 54.13263580900008],
              [-165.12621008999992, 54.13035716400003],
              [-165.1204727859999, 54.12555573100008],
              [-165.11689205599993, 54.12059153900003],
              [-165.11652584499993, 54.118353583000044],
              [-165.10944576699993, 54.11945221600007],
              [-165.09740149599992, 54.12417226800005],
              [-165.09174557199992, 54.12518952000005],
              [-165.07738196499992, 54.12360260600008],
              [-165.06415768099993, 54.11928945500006],
              [-165.05182857999992, 54.11277903900003],
              [-165.0401505199999, 54.104681708000044],
              [-165.0268448559999, 54.11147695500006],
              [-164.98859615799992, 54.12360260600008],
              [-164.9810684889999, 54.13068268400008],
              [-164.9725235669999, 54.12518952000005],
            ],
          ],
          [
            [
              [-162.40912838399993, 54.40639883000006],
              [-162.4073380199999, 54.39740631700005],
              [-162.40514075399992, 54.39057038000004],
              [-162.40160071499992, 54.38589101800005],
              [-162.39574133999992, 54.38589101800005],
              [-162.36811275899993, 54.39207591400003],
              [-162.36811275899993, 54.38589101800005],
              [-162.4131973949999, 54.37181224200003],
              [-162.4354141919999, 54.37201569200005],
              [-162.45380611899992, 54.382473049000055],
              [-162.48017330599993, 54.40192291900007],
              [-162.48481197799993, 54.40639883000006],
              [-162.48542232999992, 54.41388580900008],
              [-162.48151607999992, 54.419582424000055],
              [-162.47223873599992, 54.42210521000004],
              [-162.4568985669999, 54.42007070500006],
              [-162.40912838399993, 54.40639883000006],
            ],
          ],
          [
            [
              [-162.58722896999993, 54.441107489000046],
              [-162.54999752499992, 54.42007070500006],
              [-162.54649817599991, 54.41469961100006],
              [-162.54535885299993, 54.40298086100006],
              [-162.54649817599991, 54.39126211100006],
              [-162.54999752499992, 54.38589101800005],
              [-162.65550696499992, 54.39207591400003],
              [-162.64655514199993, 54.38568756700005],
              [-162.63683020699992, 54.38141510600008],
              [-162.62621008999992, 54.379339911000045],
              [-162.61457271999993, 54.37909577000005],
              [-162.61457271999993, 54.372259833000044],
              [-162.6326798169999, 54.37189362200007],
              [-162.6475723949999, 54.375433661000045],
              [-162.67662512899992, 54.38589101800005],
              [-162.72858639199993, 54.395819403000075],
              [-162.75401770699992, 54.40957265800006],
              [-162.78364010299993, 54.41640859600005],
              [-162.7963761059999, 54.423488674000055],
              [-162.84113521999993, 54.461004950000074],
              [-162.8216446609999, 54.46246979400007],
              [-162.8224991529999, 54.473822333000044],
              [-162.82917232999992, 54.48908112200007],
              [-162.82746334499993, 54.501939195000034],
              [-162.8138321609999, 54.504339911000045],
              [-162.79308020699992, 54.50031159100007],
              [-162.7585343089999, 54.488267320000034],
              [-162.73456783799992, 54.48456452000005],
              [-162.69013424399992, 54.47134023600006],
              [-162.65680904899992, 54.466782945000034],
              [-162.62140865799992, 54.454779364000046],
              [-162.61542721299992, 54.454291083000044],
              [-162.60212154899992, 54.45600006700005],
              [-162.59467525899993, 54.454779364000046],
              [-162.59459387899992, 54.453111070000034],
              [-162.59260006399992, 54.44871653900003],
              [-162.58967037699992, 54.44403717700004],
              [-162.58722896999993, 54.441107489000046],
            ],
          ],
          [
            [
              [-162.37494869699992, 54.954413153000075],
              [-162.3443497389999, 54.96979401200008],
              [-162.30256100199992, 54.985663153000075],
              [-162.2626846999999, 54.98920319200005],
              [-162.2377823559999, 54.968085028000075],
              [-162.2333878249999, 54.95697663000004],
              [-162.23041744699992, 54.939154364000046],
              [-162.22931881399992, 54.92059967700004],
              [-162.23094641799992, 54.90729401200008],
              [-162.2390030589999, 54.89398834800005],
              [-162.27875729099992, 54.851996161000045],
              [-162.30903072799993, 54.83734772300005],
              [-162.3421524729999, 54.839544989000046],
              [-162.3743790359999, 54.85309479400007],
              [-162.40160071499992, 54.87250397300005],
              [-162.4241837229999, 54.89793528900003],
              [-162.43415279899992, 54.91437409100007],
              [-162.43639075399992, 54.927720445000034],
              [-162.42670650899993, 54.938666083000044],
              [-162.37494869699992, 54.954413153000075],
            ],
          ],
          [
            [
              [-163.07384192599991, 54.687567450000074],
              [-163.0677384109999, 54.683579820000034],
              [-163.05610104099992, 54.673895575000074],
              [-163.0506485669999, 54.664129950000074],
              [-163.06330318899992, 54.65961334800005],
              [-163.15550696499992, 54.66620514500005],
              [-163.17003333199992, 54.673895575000074],
              [-163.15485592399992, 54.67568594000005],
              [-163.11481686099992, 54.687567450000074],
              [-163.12706458199992, 54.69550202000005],
              [-163.1401261059999, 54.69985586100006],
              [-163.15436764199993, 54.70140208500004],
              [-163.17003333199992, 54.701239325000074],
              [-163.18525143099993, 54.69749583500004],
              [-163.2158096999999, 54.683294989000046],
              [-163.22809811099992, 54.68008047100005],
              [-163.23847408799992, 54.68305084800005],
              [-163.24775143099993, 54.689886786000045],
              [-163.26191158799992, 54.70465729400007],
              [-163.27228756399992, 54.70913320500006],
              [-163.2991837229999, 54.70990631700005],
              [-163.3134659499999, 54.714829820000034],
              [-163.34776770699992, 54.75226471600007],
              [-163.3694962229999, 54.764553127000056],
              [-163.4026993479999, 54.74713776200008],
              [-163.41755123599992, 54.74176666900007],
              [-163.43110104099992, 54.73501211100006],
              [-163.43696041599992, 54.72508372600004],
              [-163.4295548169999, 54.69212474200003],
              [-163.43073482999992, 54.68008047100005],
              [-163.44916744699992, 54.66351959800005],
              [-163.50666256399992, 54.65574778900003],
              [-163.51886959499993, 54.636379299000055],
              [-163.53388424399992, 54.63532135600008],
              [-163.6225479809999, 54.61180247600004],
              [-163.6780899729999, 54.61635976800005],
              [-163.78986568899992, 54.637925523000035],
              [-164.1326798169999, 54.62323639500005],
              [-164.18305416599992, 54.610256252000056],
              [-164.21837317599991, 54.59813060100004],
              [-164.32970130099991, 54.534816799000055],
              [-164.33446204299992, 54.52680084800005],
              [-164.33283443899992, 54.51557038000004],
              [-164.3300675119999, 54.50958893400008],
              [-164.32953854099992, 54.50250885600008],
              [-164.33446204299992, 54.488267320000034],
              [-164.3613175119999, 54.45848216400003],
              [-164.40558834499993, 54.435980536000045],
              [-164.45710201699993, 54.42104726800005],
              [-164.50580807199992, 54.41380442900004],
              [-164.57331295499992, 54.413397528000075],
              [-164.60871334499993, 54.40892161700003],
              [-164.6330460279999, 54.395819403000075],
              [-164.6525772779999, 54.39199453300006],
              [-164.80231686099992, 54.40403880400004],
              [-164.82599850199992, 54.411322333000044],
              [-164.84528561099992, 54.423488674000055],
              [-164.8730362619999, 54.45722077000005],
              [-164.88914954299992, 54.47093333500004],
              [-164.90986080599993, 54.47528717700004],
              [-164.9042862619999, 54.49664948100008],
              [-164.91254635299993, 54.50873444200005],
              [-164.92475338399993, 54.516913153000075],
              [-164.93097896999993, 54.52680084800005],
              [-164.93366451699993, 54.542954820000034],
              [-164.9404190749999, 54.558661200000074],
              [-164.95824133999992, 54.585150458000044],
              [-164.93830318899992, 54.598863023000035],
              [-164.90925045499992, 54.61212799700007],
              [-164.87909908799992, 54.62213776200008],
              [-164.79682369699992, 54.634466864000046],
              [-164.73920650899993, 54.652777411000045],
              [-164.7006729809999, 54.67829010600008],
              [-164.56952877499992, 54.83698151200008],
              [-164.5576065749999, 54.84454987200007],
              [-164.54735266799992, 54.88275788000004],
              [-164.54181881399992, 54.88743724200003],
              [-164.4775284499999, 54.91889069200005],
              [-164.45319576699993, 54.924994208000044],
              [-164.39964758999992, 54.927720445000034],
              [-164.37816321499992, 54.92283763200004],
              [-164.33600826699993, 54.900051174000055],
              [-164.3139542309999, 54.893011786000045],
              [-164.22508704299992, 54.89472077000005],
              [-164.21296139199993, 54.89988841400003],
              [-164.2109268869999, 54.90843333500004],
              [-164.2245987619999, 54.92031484600005],
              [-164.19066321499992, 54.94212474200003],
              [-164.1568497389999, 54.95697663000004],
              [-164.1193741529999, 54.96539948100008],
              [-164.05072994699992, 54.971136786000045],
              [-164.02643795499992, 54.97833893400008],
              [-163.98566646999993, 54.995428778000075],
              [-163.9370011059999, 55.02912018400008],
              [-163.9167374339999, 55.036363023000035],
              [-163.82396399599992, 55.043850002000056],
              [-163.80321204299992, 55.048041083000044],
              [-163.78058834499993, 55.055853583000044],
              [-163.75654049399992, 55.06037018400008],
              [-163.68175208199992, 55.04437897300005],
              [-163.5716446609999, 55.05703359600005],
              [-163.52570553299992, 55.043850002000056],
              [-163.53913326699993, 55.04344310100004],
              [-163.54572506399992, 55.03758372600004],
              [-163.5458878249999, 55.02802155200004],
              [-163.53998775899993, 55.01654694200005],
              [-163.5312393869999, 55.00971100500004],
              [-163.50849361899992, 55.002020575000074],
              [-163.4796036449999, 54.98493073100008],
              [-163.46141516799992, 54.970770575000074],
              [-163.4448136059999, 54.95368073100008],
              [-163.43073482999992, 54.93455638200004],
              [-163.42316646999993, 54.91201406500005],
              [-163.42113196499992, 54.86591217700004],
              [-163.4127091139999, 54.84833405200004],
              [-163.3730362619999, 54.792669989000046],
              [-163.35435950399992, 54.77692291900007],
              [-163.3288468089999, 54.765692450000074],
              [-163.3033341139999, 54.761786200000074],
              [-163.23310299399992, 54.76349518400008],
              [-163.2233780589999, 54.76642487200007],
              [-163.21605383999992, 54.771918036000045],
              [-163.2076309889999, 54.78034088700008],
              [-163.19884192599991, 54.78388092700004],
              [-163.18834387899992, 54.78229401200008],
              [-163.1771134109999, 54.77879466400003],
              [-163.16669674399992, 54.77692291900007],
              [-163.14415442599991, 54.77033112200007],
              [-163.12885494699992, 54.75413646000004],
              [-163.10798092399992, 54.714829820000034],
              [-163.09968014199993, 54.704738674000055],
              [-163.0908096999999, 54.698472398000035],
              [-163.0820206369999, 54.69367096600007],
              [-163.07384192599991, 54.687567450000074],
            ],
          ],
          [
            [
              [-161.73066158799992, 55.16054922100005],
              [-161.73021399599992, 55.155910549000055],
              [-161.73163814999992, 55.15448639500005],
              [-161.73444576699993, 55.154364325000074],
              [-161.7381485669999, 55.15371328300006],
              [-161.7131241529999, 55.14398834800005],
              [-161.66083736899992, 55.13068268400008],
              [-161.64130611899992, 55.11953359600005],
              [-161.65278072799993, 55.10626862200007],
              [-161.6857804029999, 55.09039948100008],
              [-161.69652258999992, 55.07111237200007],
              [-161.71186275899993, 55.079006252000056],
              [-161.72472083199992, 55.074286200000074],
              [-161.73725338399993, 55.06476471600007],
              [-161.75116939999992, 55.05805084800005],
              [-161.7704971999999, 55.059027411000045],
              [-161.7845352859999, 55.06679922100005],
              [-161.79743404899992, 55.077053127000056],
              [-161.8132218089999, 55.08539459800005],
              [-161.8068741529999, 55.09564850500004],
              [-161.7753800119999, 55.12262604400007],
              [-161.77167721299992, 55.13434479400007],
              [-161.7831925119999, 55.14492422100005],
              [-161.8132218089999, 55.16054922100005],
              [-161.80903072799993, 55.14500560100004],
              [-161.81220455599993, 55.129787502000056],
              [-161.82628333199992, 55.09906647300005],
              [-161.84032141799992, 55.111761786000045],
              [-161.87193762899992, 55.12140534100007],
              [-161.89313717399992, 55.13393789300005],
              [-161.9006241529999, 55.13349030200004],
              [-161.90607662699992, 55.13458893400008],
              [-161.9081925119999, 55.143459377000056],
              [-161.90607662699992, 55.15485260600008],
              [-161.90013587099992, 55.15802643400008],
              [-161.89167232999992, 55.15814850500004],
              [-161.84382076699993, 55.17133209800005],
              [-161.73066158799992, 55.16054922100005],
            ],
          ],
          [
            [
              [-160.32542883999992, 55.35854726800005],
              [-160.33287512899992, 55.35228099200003],
              [-160.32477779899992, 55.31391022300005],
              [-160.3237198559999, 55.29523346600007],
              [-160.32542883999992, 55.276556708000044],
              [-160.3362930979999, 55.24868398600006],
              [-160.34691321499992, 55.25055573100008],
              [-160.36176510299993, 55.255113023000035],
              [-160.3749893869999, 55.261053778000075],
              [-160.4011124339999, 55.286769924000055],
              [-160.49848385299993, 55.30223216400003],
              [-160.5314835279999, 55.32501862200007],
              [-160.51899166599992, 55.32713450700004],
              [-160.5084122389999, 55.331732489000046],
              [-160.5042618479999, 55.33803945500006],
              [-160.51105709499993, 55.34544505400004],
              [-160.4869278639999, 55.353216864000046],
              [-160.4616593089999, 55.35114166900007],
              [-160.43712317599991, 55.34617747600004],
              [-160.41547604099992, 55.34544505400004],
              [-160.36738033799992, 55.366522528000075],
              [-160.3452042309999, 55.371079820000034],
              [-160.32542883999992, 55.35854726800005],
            ],
          ],
          [
            [
              [-160.49738521999993, 55.194647528000075],
              [-160.4863175119999, 55.19367096600007],
              [-160.47748775899993, 55.19757721600007],
              [-160.4698380199999, 55.198472398000035],
              [-160.46259518099993, 55.18842194200005],
              [-160.4861954419999, 55.18146393400008],
              [-160.5335587229999, 55.187933661000045],
              [-160.5588272779999, 55.18842194200005],
              [-160.51862545499992, 55.17877838700008],
              [-160.51105709499993, 55.17413971600007],
              [-160.51329505099991, 55.16498444200005],
              [-160.53831946499992, 55.13320547100005],
              [-160.55524654899992, 55.157456773000035],
              [-160.57526607999992, 55.16266510600008],
              [-160.62706458199992, 55.15371328300006],
              [-160.6376846999999, 55.15493398600006],
              [-160.6663712229999, 55.16315338700008],
              [-160.67552649599992, 55.16791413000004],
              [-160.68525143099993, 55.18036530200004],
              [-160.68248450399992, 55.18695709800005],
              [-160.6761368479999, 55.19253164300005],
              [-160.67552649599992, 55.20148346600007],
              [-160.68333899599992, 55.211371161000045],
              [-160.69233150899993, 55.20917389500005],
              [-160.70331783799992, 55.20136139500005],
              [-160.71711178299992, 55.194647528000075],
              [-160.73334713399993, 55.19196198100008],
              [-160.74583899599992, 55.191473700000074],
              [-160.7576798169999, 55.189113674000055],
              [-160.7717179029999, 55.180975653000075],
              [-160.78388424399992, 55.16693756700005],
              [-160.80284583199992, 55.13336823100008],
              [-160.81891842399992, 55.11953359600005],
              [-160.82050533799992, 55.13540273600006],
              [-160.8127335279999, 55.166083075000074],
              [-160.8157852859999, 55.17755768400008],
              [-160.8392227859999, 55.19794342700004],
              [-160.84740149599992, 55.207098700000074],
              [-160.85362708199992, 55.221909898000035],
              [-160.85236568899992, 55.22500234600005],
              [-160.84723873599992, 55.24209219000005],
              [-160.84618079299992, 55.24868398600006],
              [-160.8486221999999, 55.25608958500004],
              [-160.85826575399992, 55.265692450000074],
              [-160.8604630199999, 55.273504950000074],
              [-160.8569229809999, 55.288723049000055],
              [-160.85053463399993, 55.303168036000045],
              [-160.84727942599991, 55.31732819200005],
              [-160.85362708199992, 55.33185455900008],
              [-160.8214005199999, 55.36322663000004],
              [-160.78404700399992, 55.389878648000035],
              [-160.7420548169999, 55.406317450000074],
              [-160.69599361899992, 55.40692780200004],
              [-160.66576087099992, 55.38385651200008],
              [-160.65876217399992, 55.36383698100008],
              [-160.67198645699992, 55.343085028000075],
              [-160.70282955599993, 55.317572333000044],
              [-160.69066321499992, 55.307806708000044],
              [-160.67939205599993, 55.306708075000074],
              [-160.65815182199992, 55.31134674700007],
              [-160.65404212099992, 55.314520575000074],
              [-160.65013587099992, 55.321600653000075],
              [-160.64521236899992, 55.32859935100004],
              [-160.63792883999992, 55.33185455900008],
              [-160.6302384109999, 55.33075592700004],
              [-160.61803137899992, 55.32611725500004],
              [-160.6103409499999, 55.32501862200007],
              [-160.60472571499992, 55.33075592700004],
              [-160.60248775899993, 55.36009349200003],
              [-160.59980221299992, 55.37278880400004],
              [-160.59015865799992, 55.38385651200008],
              [-160.5755509109999, 55.39142487200007],
              [-160.55927486899992, 55.39313385600008],
              [-160.54454505099991, 55.386419989000046],
              [-160.53559322799993, 55.36432526200008],
              [-160.55158443899992, 55.345038153000075],
              [-160.5744522779999, 55.32493724200003],
              [-160.58613033799992, 55.300482489000046],
              [-160.5823868479999, 55.28554922100005],
              [-160.5732315749999, 55.27806224200003],
              [-160.5620011059999, 55.27240631700005],
              [-160.55199133999992, 55.262925523000035],
              [-160.54609127499992, 55.250433661000045],
              [-160.54987545499992, 55.245021877000056],
              [-160.57990475199992, 55.235581773000035],
              [-160.56371008999992, 55.229803778000075],
              [-160.52802486899992, 55.22752513200004],
              [-160.51105709499993, 55.221909898000035],
              [-160.5076798169999, 55.21694570500006],
              [-160.5023087229999, 55.20026276200008],
              [-160.49738521999993, 55.194647528000075],
            ],
          ],
          [
            [
              [-160.1479386059999, 55.386419989000046],
              [-160.15986080599993, 55.38080475500004],
              [-160.1669815749999, 55.384426174000055],
              [-160.17308508999992, 55.39248281500005],
              [-160.18207760299993, 55.400091864000046],
              [-160.19721432199992, 55.40424225500004],
              [-160.23371334499993, 55.40997955900008],
              [-160.24693762899992, 55.41746653900003],
              [-160.25947018099993, 55.422308661000045],
              [-160.27338619699992, 55.41665273600006],
              [-160.29877682199992, 55.400091864000046],
              [-160.3123673169999, 55.39744700700004],
              [-160.3281143869999, 55.398138739000046],
              [-160.34113521999993, 55.40412018400008],
              [-160.34654700399992, 55.41746653900003],
              [-160.33409583199992, 55.44367096600007],
              [-160.30475826699993, 55.458319403000075],
              [-160.27057857999992, 55.46369049700007],
              [-160.2435196609999, 55.462144273000035],
              [-160.23875891799992, 55.459051825000074],
              [-160.2369278639999, 55.44985586100006],
              [-160.23359127499992, 55.44790273600006],
              [-160.22382564999992, 55.44904205900008],
              [-160.20628821499992, 55.45416901200008],
              [-160.19884192599991, 55.45530833500004],
              [-160.17113196499992, 55.45376211100006],
              [-160.15990149599992, 55.44953034100007],
              [-160.1553848949999, 55.441066799000055],
              [-160.15986080599993, 55.426988023000035],
              [-160.15941321499992, 55.41266510600008],
              [-160.15510006399992, 55.398871161000045],
              [-160.1479386059999, 55.386419989000046],
            ],
          ],
          [
            [
              [-158.70856686099992, 55.83148834800005],
              [-158.81122799399992, 55.85952383000006],
              [-158.8583878249999, 55.862982489000046],
              [-158.8873184889999, 55.83148834800005],
              [-158.87474524599992, 55.82794830900008],
              [-158.86176510299993, 55.825832424000055],
              [-158.85114498599992, 55.82143789300005],
              [-158.84577389199993, 55.810980536000045],
              [-158.86628170499992, 55.80573151200008],
              [-158.8837784499999, 55.80524323100008],
              [-158.89765377499992, 55.81134674700007],
              [-158.90717525899993, 55.82526276200008],
              [-158.90868079299992, 55.84129466400003],
              [-158.89732825399992, 55.860581773000035],
              [-158.90033932199992, 55.87372467700004],
              [-158.8537491529999, 55.89093659100007],
              [-158.8281143869999, 55.89671458500004],
              [-158.7917374339999, 55.890285549000055],
              [-158.7768448559999, 55.880926825000074],
              [-158.7603653639999, 55.86627838700008],
              [-158.74531002499992, 55.86318594000005],
              [-158.73009192599991, 55.855169989000046],
              [-158.7170304029999, 55.84398021000004],
              [-158.70856686099992, 55.83148834800005],
            ],
          ],
          [
            [
              [-169.58088131399992, 56.60952383000006],
              [-169.5569962229999, 56.61810944200005],
              [-169.52314205599993, 56.61627838700008],
              [-169.49152584499993, 56.60691966400003],
              [-169.47435462099992, 56.593003648000035],
              [-169.51508541599992, 56.57851797100005],
              [-169.5501602859999, 56.55695221600007],
              [-169.5869034499999, 56.54140859600005],
              [-169.6326798169999, 56.54466380400004],
              [-169.65302486899992, 56.55414459800005],
              [-169.6784561839999, 56.57611725500004],
              [-169.69347083199992, 56.585638739000046],
              [-169.7662247389999, 56.60687897300005],
              [-169.7890518869999, 56.620347398000035],
              [-169.74299068899992, 56.620347398000035],
              [-169.6080216139999, 56.60333893400008],
              [-169.58088131399992, 56.60952383000006],
            ],
          ],
          [
            [
              [-170.2415665359999, 57.21625397300005],
              [-170.14740963399993, 57.234076239000046],
              [-170.13569088399993, 57.24274323100008],
              [-170.1230362619999, 57.25014883000006],
              [-170.10444088399993, 57.25039297100005],
              [-170.11335201699993, 57.239894924000055],
              [-170.13678951699993, 57.22455475500004],
              [-170.14537512899992, 57.209418036000045],
              [-170.1495255199999, 57.20575592700004],
              [-170.15424557199992, 57.19989655200004],
              [-170.15802975199992, 57.192572333000044],
              [-170.16218014199993, 57.17479075700004],
              [-170.1685684889999, 57.16901276200008],
              [-170.20307369699992, 57.154364325000074],
              [-170.2552384109999, 57.14109935100004],
              [-170.25409908799992, 57.12929922100005],
              [-170.2628067699999, 57.11888255400004],
              [-170.27643795499992, 57.110988674000055],
              [-170.28998775899993, 57.10639069200005],
              [-170.27533932199992, 57.12714264500005],
              [-170.2722061839999, 57.13654205900008],
              [-170.27570553299992, 57.14793528900003],
              [-170.28172766799992, 57.14760976800005],
              [-170.31989498599992, 57.15468984600005],
              [-170.34727942599991, 57.147365627000056],
              [-170.3659561839999, 57.14858633000006],
              [-170.38520260299993, 57.153550523000035],
              [-170.39924068899992, 57.161037502000056],
              [-170.40709387899992, 57.171128648000035],
              [-170.4120987619999, 57.184800523000035],
              [-170.40990149599992, 57.19684479400007],
              [-170.39610755099991, 57.20197174700007],
              [-170.35826575399992, 57.20197174700007],
              [-170.3478897779999, 57.20425039300005],
              [-170.3331192699999, 57.21401601800005],
              [-170.32380123599992, 57.21625397300005],
              [-170.2628067699999, 57.21401601800005],
              [-170.2415665359999, 57.21625397300005],
            ],
          ],
          [
            [
              [-165.58210201699993, 59.95099518400008],
              [-165.5690811839999, 59.95099518400008],
              [-165.55980383999992, 59.94940827000005],
              [-165.55475826699993, 59.94354889500005],
              [-165.5549210279999, 59.93463776200008],
              [-165.55866451699993, 59.92963288000004],
              [-165.56464596299992, 59.92552317900004],
              [-165.57148189999992, 59.91933828300006],
              [-165.5986221999999, 59.90965403900003],
              [-165.69225012899992, 59.90298086100006],
              [-165.7158096999999, 59.90599192900004],
              [-165.72748775899993, 59.91575755400004],
              [-165.74225826699993, 59.92422109600005],
              [-165.75483150899993, 59.925116278000075],
              [-165.76020260299993, 59.912543036000045],
              [-165.77106686099992, 59.90696849200003],
              [-165.86493893099993, 59.88275788000004],
              [-165.8837784499999, 59.88100820500006],
              [-165.92780514199993, 59.882066148000035],
              [-165.9443253249999, 59.88743724200003],
              [-165.95856686099992, 59.89752838700008],
              [-165.97386633999992, 59.903509833000044],
              [-165.99360104099992, 59.89630768400008],
              [-165.96369381399992, 59.887884833000044],
              [-165.9791153639999, 59.876166083000044],
              [-166.0101212229999, 59.86664459800005],
              [-166.02708899599992, 59.86469147300005],
              [-166.0403946609999, 59.85761139500005],
              [-166.12267005099991, 59.841131903000075],
              [-166.13251705599993, 59.85822174700007],
              [-166.18781490799992, 59.86225006700005],
              [-166.2466934889999, 59.85390859600005],
              [-166.26728268099993, 59.833685614000046],
              [-166.25959225199992, 59.83270905200004],
              [-166.21576900899993, 59.820013739000046],
              [-166.15741939999992, 59.827460028000075],
              [-166.13422604099992, 59.822333075000074],
              [-166.11274166599992, 59.81085846600007],
              [-166.09467525899993, 59.79559967700004],
              [-166.08173580599993, 59.77903880400004],
              [-166.1042374339999, 59.76585521000004],
              [-166.14411373599992, 59.75796133000006],
              [-166.18207760299993, 59.756293036000045],
              [-166.19904537699992, 59.76166413000004],
              [-166.20588131399992, 59.77789948100008],
              [-166.22276770699992, 59.79474518400008],
              [-166.2440079419999, 59.807847398000035],
              [-166.27513587099992, 59.81635163000004],
              [-166.29841061099992, 59.830511786000045],
              [-166.31171627499992, 59.833685614000046],
              [-166.3299454419999, 59.83490631700005],
              [-166.40644283799992, 59.854803778000075],
              [-166.4385880199999, 59.85822174700007],
              [-166.47065182199992, 59.856634833000044],
              [-166.50007076699993, 59.84796784100007],
              [-166.50629635299993, 59.86017487200007],
              [-166.52110755099991, 59.861029364000046],
              [-166.5552872389999, 59.85419342700004],
              [-166.61335201699993, 59.85639069200005],
              [-166.63044186099992, 59.861029364000046],
              [-166.67076575399992, 59.88544342700004],
              [-166.68500729099992, 59.88890208500004],
              [-166.72663326699993, 59.89240143400008],
              [-166.74860592399992, 59.89760976800005],
              [-166.7878311839999, 59.921128648000035],
              [-167.02082271999993, 59.99135976800005],
              [-167.0009659499999, 60.00234609600005],
              [-166.9935196609999, 60.00495026200008],
              [-167.01146399599992, 60.01227448100008],
              [-167.02826900899993, 60.00893789300005],
              [-167.0447891919999, 60.001654364000046],
              [-167.0623673169999, 59.99750397300005],
              [-167.06012936099992, 60.00458405200004],
              [-167.06073971299992, 60.00812409100007],
              [-167.06212317599991, 60.01186758000006],
              [-167.0623673169999, 60.01927317900004],
              [-167.0749405589999, 60.01007721600007],
              [-167.07933508999992, 60.00340403900003],
              [-167.08551998599992, 59.999212958000044],
              [-167.1033829419999, 59.99750397300005],
              [-167.12193762899992, 60.00071849200003],
              [-167.1529434889999, 60.01581452000005],
              [-167.16791744699992, 60.01927317900004],
              [-167.1898087229999, 60.027777411000045],
              [-167.21698971299992, 60.047756252000056],
              [-167.24107825399992, 60.07050202000005],
              [-167.25422115799992, 60.087551174000055],
              [-167.26097571499992, 60.087551174000055],
              [-167.26789303299992, 60.070298570000034],
              [-167.28608150899993, 60.06549713700008],
              [-167.30695553299992, 60.070013739000046],
              [-167.32184811099992, 60.08075592700004],
              [-167.3210343089999, 60.08437734600005],
              [-167.32184811099992, 60.11107005400004],
              [-167.3237198559999, 60.12099844000005],
              [-167.3287247389999, 60.128607489000046],
              [-167.34357662699992, 60.14215729400007],
              [-167.4361466139999, 60.195379950000074],
              [-167.45282955599993, 60.217230536000045],
              [-167.43647213399993, 60.21206289300005],
              [-167.42109127499992, 60.21173737200007],
              [-167.3428848949999, 60.224269924000055],
              [-167.33271236899992, 60.22846100500004],
              [-167.32111568899992, 60.23541901200008],
              [-167.3049210279999, 60.23883698100008],
              [-167.2880753249999, 60.238714911000045],
              [-167.27436275899993, 60.23529694200005],
              [-167.25898189999992, 60.22955963700008],
              [-167.24689693899992, 60.22825755400004],
              [-167.15815182199992, 60.23452383000006],
              [-166.87397213399993, 60.210638739000046],
              [-166.82042395699992, 60.21759674700007],
              [-166.79487057199992, 60.25885651200008],
              [-166.79792232999992, 60.266831773000035],
              [-166.80439205599993, 60.270738023000035],
              [-166.80781002499992, 60.275458075000074],
              [-166.80170650899993, 60.28620026200008],
              [-166.79230709499993, 60.292303778000075],
              [-166.7608536449999, 60.30442942900004],
              [-166.7213028639999, 60.31110260600008],
              [-166.66767330599993, 60.32770416900007],
              [-166.6365860669999, 60.32709381700005],
              [-166.5978897779999, 60.31513092700004],
              [-166.57770748599992, 60.31525299700007],
              [-166.5689591139999, 60.330511786000045],
              [-166.56651770699992, 60.350490627000056],
              [-166.5589493479999, 60.359442450000074],
              [-166.4592179029999, 60.387152411000045],
              [-166.42198645699992, 60.38434479400007],
              [-166.39020748599992, 60.36127350500004],
              [-166.39464270699992, 60.35822174700007],
              [-166.3990372389999, 60.35224030200004],
              [-166.40387936099992, 60.34760163000004],
              [-166.37983150899993, 60.348944403000075],
              [-166.30821692599991, 60.38239166900007],
              [-166.18537350199992, 60.40216705900008],
              [-166.18907630099991, 60.385646877000056],
              [-166.17341061099992, 60.37938060100004],
              [-166.15156002499992, 60.38117096600007],
              [-166.1369522779999, 60.38857656500005],
              [-166.13471432199992, 60.401556708000044],
              [-166.1408585279999, 60.41559479400007],
              [-166.15741939999992, 60.43695709800005],
              [-166.13129635299993, 60.43146393400008],
              [-166.1190079419999, 60.426214911000045],
              [-166.10899817599991, 60.41648997600004],
              [-166.11644446499992, 60.40965403900003],
              [-166.10273189999992, 60.39199453300006],
              [-166.0921524729999, 60.374660549000055],
              [-166.08014889199993, 60.35932038000004],
              [-166.06183834499993, 60.34760163000004],
              [-166.06794186099992, 60.34467194200005],
              [-166.07062740799992, 60.34162018400008],
              [-166.07237708199992, 60.33808014500005],
              [-166.07551021999993, 60.33392975500004],
              [-166.0517471999999, 60.32794830900008],
              [-165.98822994699992, 60.32062409100007],
              [-165.9212540359999, 60.32709381700005],
              [-165.8972061839999, 60.34442780200004],
              [-165.88678951699993, 60.34760163000004],
              [-165.81049557199992, 60.34589264500005],
              [-165.78754635299993, 60.34137604400007],
              [-165.7792862619999, 60.33698151200008],
              [-165.76646887899992, 60.324652411000045],
              [-165.76020260299993, 60.32094961100006],
              [-165.74555416599992, 60.31903717700004],
              [-165.71845455599993, 60.319525458000044],
              [-165.70555579299992, 60.31346263200004],
              [-165.7260636059999, 60.306626695000034],
              [-165.68443762899992, 60.29979075700004],
              [-165.68696041599992, 60.29287344000005],
              [-165.68854732999992, 60.28998444200005],
              [-165.69188391799992, 60.28620026200008],
              [-165.6791886059999, 60.278509833000044],
              [-165.6854141919999, 60.266831773000035],
              [-165.70087643099993, 60.25608958500004],
              [-165.7158096999999, 60.25141022300005],
              [-165.71821041599992, 60.24555084800005],
              [-165.70551510299993, 60.23236725500004],
              [-165.67829342399992, 60.21108633000006],
              [-165.72126217399992, 60.18158600500004],
              [-165.73289954299992, 60.17633698100008],
              [-165.72468014199993, 60.16388580900008],
              [-165.71137447799993, 60.15704987200007],
              [-165.69513912699992, 60.154730536000045],
              [-165.67829342399992, 60.15582916900007],
              [-165.6829727859999, 60.15106842700004],
              [-165.68757076699993, 60.14520905200004],
              [-165.69188391799992, 60.14215729400007],
              [-165.69188391799992, 60.13532135600008],
              [-165.68285071499992, 60.13385651200008],
              [-165.67951412699992, 60.13182200700004],
              [-165.67719479099992, 60.128159898000035],
              [-165.67145748599992, 60.12164948100008],
              [-165.68122311099992, 60.106756903000075],
              [-165.6937149729999, 60.09320709800005],
              [-165.7260636059999, 60.066473700000074],
              [-165.6913956369999, 60.06777578300006],
              [-165.67719479099992, 60.06317780200004],
              [-165.66620846299992, 60.038763739000046],
              [-165.65351314999992, 60.032904364000046],
              [-165.6230362619999, 60.025458075000074],
              [-165.63093014199993, 60.01479726800005],
              [-165.63642330599993, 60.00967031500005],
              [-165.64350338399993, 60.00495026200008],
              [-165.64350338399993, 59.99750397300005],
              [-165.62885494699992, 59.99290599200003],
              [-165.61339270699992, 59.97565338700008],
              [-165.6025284499999, 59.97089264500005],
              [-165.5888565749999, 59.97260163000004],
              [-165.55785071499992, 59.98305898600006],
              [-165.54108639199993, 59.98452383000006],
              [-165.5538223949999, 59.97650788000004],
              [-165.56757564999992, 59.97011953300006],
              [-165.57831783799992, 59.962551174000055],
              [-165.58210201699993, 59.95099518400008],
            ],
          ],
          [
            [
              [-172.29731197799993, 60.35134511900009],
              [-172.2845352859999, 60.34259674700007],
              [-172.22577877499992, 60.32363515800006],
              [-172.20856686099992, 60.31346263200004],
              [-172.2228897779999, 60.313706773000035],
              [-172.2631729809999, 60.306626695000034],
              [-172.27887936099992, 60.309800523000035],
              [-172.30321204299992, 60.32396067900004],
              [-172.36652584499993, 60.34446849200003],
              [-172.3853653639999, 60.34760163000004],
              [-172.4247533839999, 60.34247467700004],
              [-172.47443600199992, 60.34983958500004],
              [-172.5080460279999, 60.342962958000044],
              [-172.5408829419999, 60.33250560100004],
              [-172.57197018099993, 60.32709381700005],
              [-172.5999649729999, 60.32982005400004],
              [-172.6257218089999, 60.33698151200008],
              [-172.67467200399992, 60.35814036700003],
              [-172.68622799399992, 60.36163971600007],
              [-172.71113033799992, 60.364935614000046],
              [-172.72248287699992, 60.36810944200005],
              [-172.73517818899992, 60.37547435100004],
              [-172.75157630099991, 60.39276764500005],
              [-172.76341712099992, 60.40216705900008],
              [-172.78331458199992, 60.41233958500004],
              [-173.00422115799992, 60.49017975500004],
              [-173.0576065749999, 60.49843984600005],
              [-173.04377193899992, 60.504339911000045],
              [-173.03779049399992, 60.505845445000034],
              [-173.04108639199993, 60.51715729400007],
              [-173.0424698559999, 60.52757396000004],
              [-173.04157467399992, 60.53729889500005],
              [-173.03779049399992, 60.54682038000004],
              [-173.03673255099991, 60.55377838700008],
              [-173.03815670499992, 60.56037018400008],
              [-173.03766842399992, 60.56537506700005],
              [-173.03095455599993, 60.56732819200005],
              [-173.02155514199993, 60.56810130400004],
              [-173.01374264199993, 60.57013580900008],
              [-173.00300045499992, 60.57416413000004],
              [-172.95234127499992, 60.60097890800006],
              [-172.92503821499992, 60.606675523000035],
              [-172.91425533799992, 60.58783600500004],
              [-172.92662512899992, 60.57282135600008],
              [-172.92145748599992, 60.54962799700007],
              [-172.90668697799993, 60.52826569200005],
              [-172.89037024599992, 60.51894765800006],
              [-172.87641354099992, 60.51349518400008],
              [-172.81183834499993, 60.47797272300005],
              [-172.53364010299993, 60.391506252000056],
              [-172.50336666599992, 60.38857656500005],
              [-172.4107559889999, 60.401678778000075],
              [-172.3798315089999, 60.39598216400003],
              [-172.29731197799993, 60.35134511900009],
            ],
          ],
          [
            [
              [-169.8099666009999, 63.06464264500005],
              [-169.7900284499999, 63.051662502000056],
              [-169.78205318899992, 63.043402411000045],
              [-169.77708899599992, 63.03506094000005],
              [-169.8557022779999, 63.08869049700007],
              [-169.88080807199992, 63.10956452000005],
              [-169.9318741529999, 63.13914622600004],
              [-169.9272354809999, 63.13869863500008],
              [-169.86884518099993, 63.10614655200004],
              [-169.8099666009999, 63.06464264500005],
            ],
          ],
          [
            [
              [-169.44094285999992, 63.363539856000045],
              [-169.48932857999992, 63.36782461100006],
              [-169.5123184889999, 63.37376536700003],
              [-169.52900143099993, 63.38336823100008],
              [-169.50812740799992, 63.37335846600007],
              [-169.44094285999992, 63.363539856000045],
            ],
          ],
          [
            [
              [-170.29621334499993, 63.23940664300005],
              [-170.3691300119999, 63.29059479400007],
              [-170.44965572799993, 63.325100002000056],
              [-170.70783443899992, 63.39520905200004],
              [-170.4854630199999, 63.34467194200005],
              [-170.3818253249999, 63.30141836100006],
              [-170.29621334499993, 63.23940664300005],
            ],
          ],
          [
            [
              [-170.9752091139999, 63.43121979400007],
              [-171.05854244699992, 63.430121161000045],
              [-171.07289548499992, 63.43732557100003],
              [-171.02924557199992, 63.438666083000044],
              [-170.78404700399992, 63.40851471600007],
              [-170.9752091139999, 63.43121979400007],
            ],
          ],
          [
            [
              [-171.09003658799992, 63.60390859600005],
              [-171.07079016799992, 63.60248444200005],
              [-171.07489986899992, 63.60224030200004],
              [-171.09003658799992, 63.60390859600005],
            ],
          ],
          [
            [
              [-171.09003658799992, 63.60390859600005],
              [-171.1576557159999, 63.609736818000044],
              [-171.1440323559999, 63.611761786000045],
              [-171.09003658799992, 63.60390859600005],
            ],
          ],
          [
            [
              [-168.74071204299992, 63.28099192900004],
              [-168.71711178299992, 63.26089101800005],
              [-168.7288712229999, 63.23383209800005],
              [-168.77550208199992, 63.19159577000005],
              [-168.81183834499993, 63.17011139500005],
              [-168.85081946499992, 63.16282786700003],
              [-168.95160885299993, 63.166001695000034],
              [-169.0029190749999, 63.17430247600004],
              [-169.01850338399993, 63.181341864000046],
              [-169.03925533799992, 63.18805573100008],
              [-169.28364010299993, 63.17829010600008],
              [-169.33100338399993, 63.164943752000056],
              [-169.28791256399992, 63.17983633000006],
              [-169.26537024599992, 63.18353913000004],
              [-169.18712317599991, 63.18744538000004],
              [-169.15925045499992, 63.19375234600005],
              [-169.14484615799992, 63.20587799700007],
              [-169.2873429029999, 63.19330475500004],
              [-169.35114498599992, 63.176214911000045],
              [-169.41295325399992, 63.15070221600007],
              [-169.39928137899992, 63.14321523600006],
              [-169.39928137899992, 63.13694896000004],
              [-169.41596432199992, 63.13035716400003],
              [-169.4456680979999, 63.11318594000005],
              [-169.5048721999999, 63.10114166900007],
              [-169.5264786449999, 63.09137604400007],
              [-169.53583736899992, 63.07859935100004],
              [-169.54185950399992, 63.07208893400008],
              [-169.5694473949999, 63.051947333000044],
              [-169.57746334499993, 63.04075755400004],
              [-169.57823645699992, 63.022650458000044],
              [-169.57115637899992, 63.011379299000055],
              [-169.54267330599993, 62.99359772300005],
              [-169.55939693899992, 62.98651764500005],
              [-169.5975235669999, 62.98387278900003],
              [-169.61469479099992, 62.976223049000055],
              [-169.63683020699992, 62.95579661700003],
              [-169.6494034499999, 62.948431708000044],
              [-169.66620846299992, 62.94521719000005],
              [-169.7092179029999, 62.96149323100008],
              [-169.73176021999993, 62.96588776200008],
              [-169.75556393099993, 62.96564362200007],
              [-169.7471817699999, 62.97988515800006],
              [-169.7468155589999, 62.992173570000034],
              [-169.75239010299993, 63.003241278000075],
              [-169.76178951699993, 63.014105536000045],
              [-169.73798580599993, 63.01593659100007],
              [-169.7161759109999, 63.02484772300005],
              [-169.7053116529999, 63.04018789300005],
              [-169.71458899599992, 63.06126536700003],
              [-169.72211666599992, 63.06476471600007],
              [-169.74299068899992, 63.06720612200007],
              [-169.7518204419999, 63.07184479400007],
              [-169.77607174399992, 63.09601471600007],
              [-169.81745357999992, 63.12677643400008],
              [-169.86693274599992, 63.14447663000004],
              [-169.97468014199993, 63.164943752000056],
              [-169.97468014199993, 63.157456773000035],
              [-170.02460689999992, 63.17064036700003],
              [-170.03986568899992, 63.181341864000046],
              [-170.04926510299993, 63.185207424000055],
              [-170.0714005199999, 63.18439362200007],
              [-170.0807999339999, 63.18817780200004],
              [-170.0847061839999, 63.19476959800005],
              [-170.0849503249999, 63.200425523000035],
              [-170.0865372389999, 63.204413153000075],
              [-170.0944718089999, 63.20587799700007],
              [-170.11339270699992, 63.202785549000055],
              [-170.14570064999992, 63.188706773000035],
              [-170.1596573559999, 63.184759833000044],
              [-170.1843155589999, 63.18622467700004],
              [-170.23603268099993, 63.19745514500005],
              [-170.26203365799992, 63.198431708000044],
              [-170.2557266919999, 63.20917389500005],
              [-170.2447403639999, 63.21165599200003],
              [-170.23224850199992, 63.21283600500004],
              [-170.2210587229999, 63.21954987200007],
              [-170.21837317599991, 63.22793203300006],
              [-170.21601314999992, 63.25470612200007],
              [-170.21764075399992, 63.26048411700003],
              [-170.22297115799992, 63.26479726800005],
              [-170.22826087099992, 63.27415599200003],
              [-170.2349747389999, 63.28351471600007],
              [-170.24498450399992, 63.28778717700004],
              [-170.26134192599991, 63.289129950000074],
              [-170.32982337099992, 63.305853583000044],
              [-170.4123429029999, 63.33869049700007],
              [-170.4443253249999, 63.35919830900008],
              [-170.5964249339999, 63.39915599200003],
              [-170.66303463399993, 63.40387604400007],
              [-170.66645260299993, 63.40615469000005],
              [-170.6683243479999, 63.411037502000056],
              [-170.67113196499992, 63.41592031500005],
              [-170.67731686099992, 63.41815827000005],
              [-170.7763565749999, 63.42055898600006],
              [-170.79645748599992, 63.42438385600008],
              [-170.80707760299993, 63.429754950000074],
              [-170.8224991529999, 63.44525788000004],
              [-170.83124752499992, 63.452337958000044],
              [-170.84467525899993, 63.45856354400007],
              [-170.85614986899992, 63.46035390800006],
              [-171.0838516919999, 63.44489166900007],
              [-171.0831192699999, 63.44293854400007],
              [-171.0820206369999, 63.44122955900008],
              [-171.07917232999992, 63.43817780200004],
              [-171.12189693899992, 63.43219635600008],
              [-171.14073645699992, 63.42523834800005],
              [-171.15644283799992, 63.41474030200004],
              [-171.18370520699992, 63.40228913000004],
              [-171.25279700399992, 63.39606354400007],
              [-171.28368079299992, 63.38336823100008],
              [-171.2905167309999, 63.38336823100008],
              [-171.29487057199992, 63.36204661700003],
              [-171.3251440089999, 63.351223049000055],
              [-171.36103268099993, 63.34528229400007],
              [-171.38239498599992, 63.33869049700007],
              [-171.40794837099992, 63.32257721600007],
              [-171.4393204419999, 63.31976959800005],
              [-171.55744381399992, 63.33502838700008],
              [-171.5589493479999, 63.33673737200007],
              [-171.57258053299992, 63.34617747600004],
              [-171.57856197799993, 63.349269924000055],
              [-171.58641516799992, 63.350490627000056],
              [-171.61237545499992, 63.349269924000055],
              [-171.62604732999992, 63.35138580900008],
              [-171.65436764199993, 63.36078522300005],
              [-171.70482337099992, 63.36782461100006],
              [-171.73558508999992, 63.37592194200005],
              [-171.7591446609999, 63.390326239000046],
              [-171.8212377589999, 63.44171784100007],
              [-171.82787024599992, 63.45075104400007],
              [-171.8294571609999, 63.467678127000056],
              [-171.8417862619999, 63.48517487200007],
              [-171.84727942599991, 63.496975002000056],
              [-171.85114498599992, 63.50958893400008],
              [-171.8528946609999, 63.521185614000046],
              [-171.8505753249999, 63.52065664300005],
              [-171.84577389199993, 63.52374909100007],
              [-171.8409317699999, 63.52879466400003],
              [-171.83857174399992, 63.53424713700008],
              [-171.83954830599993, 63.53986237200007],
              [-171.84544837099992, 63.554754950000074],
              [-171.84137936099992, 63.57697174700007],
              [-171.8370255199999, 63.58340078300006],
              [-171.82807369699992, 63.59251536700003],
              [-171.8196915359999, 63.59837474200003],
              [-171.80964107999992, 63.603949286000045],
              [-171.8011368479999, 63.610663153000075],
              [-171.7975968089999, 63.61985911700003],
              [-171.8002823559999, 63.62604401200008],
              [-171.80553137899992, 63.63076406500005],
              [-171.80939693899992, 63.63515859600005],
              [-171.80785071499992, 63.640326239000046],
              [-171.80048580599993, 63.64447663000004],
              [-171.77977454299992, 63.64789459800005],
              [-171.77033443899992, 63.65086497600004],
              [-171.75165768099993, 63.664048570000034],
              [-171.74787350199992, 63.674994208000044],
              [-171.74994869699992, 63.68744538000004],
              [-171.74921627499992, 63.705511786000045],
              [-171.72773189999992, 63.73452383000006],
              [-171.7205704419999, 63.75267161700003],
              [-171.73249264199993, 63.76072825700004],
              [-171.73542232999992, 63.764837958000044],
              [-171.73884029899992, 63.77407461100006],
              [-171.7408341139999, 63.78424713700008],
              [-171.73932857999992, 63.79120514500005],
              [-171.7280167309999, 63.796128648000035],
              [-171.71552486899992, 63.794256903000075],
              [-171.70380611899992, 63.79083893400008],
              [-171.69456946499992, 63.79120514500005],
              [-171.6725968089999, 63.79633209800005],
              [-171.65217037699992, 63.79043203300006],
              [-171.6357315749999, 63.77728913000004],
              [-171.6257218089999, 63.76072825700004],
              [-171.63646399599992, 63.75409577000005],
              [-171.64509029899992, 63.741848049000055],
              [-171.6491593089999, 63.72687409100007],
              [-171.64618893099993, 63.71234772300005],
              [-171.6339005199999, 63.700384833000044],
              [-171.6163223949999, 63.69354889500005],
              [-171.44652258999992, 63.658636786000045],
              [-171.4072159499999, 63.64411041900007],
              [-171.42931067599991, 63.644517320000034],
              [-171.4682511059999, 63.65501536700003],
              [-171.48912512899992, 63.65770091400003],
              [-171.50434322799993, 63.65326569200005],
              [-171.5302221339999, 63.631293036000045],
              [-171.54377193899992, 63.62299225500004],
              [-171.54377193899992, 63.61676666900007],
              [-171.52936764199993, 63.62164948100008],
              [-171.5185440749999, 63.61969635600008],
              [-171.5084122389999, 63.61465078300006],
              [-171.4959610669999, 63.60993073100008],
              [-171.48717200399992, 63.60895416900007],
              [-171.3431290359999, 63.615301825000074],
              [-171.3104141919999, 63.62299225500004],
              [-171.32538814999992, 63.62970612200007],
              [-171.34296627499992, 63.63165924700007],
              [-171.3792618479999, 63.63043854400007],
              [-171.3792618479999, 63.63666413000004],
              [-171.1592911449999, 63.609808661000045],
              [-171.16417395699992, 63.60773346600007],
              [-171.16840572799993, 63.60488515800006],
              [-171.17170162699992, 63.600897528000075],
              [-171.1738175119999, 63.59564850500004],
              [-171.1257218089999, 63.59564850500004],
              [-171.11237545499992, 63.59349192900004],
              [-171.09675045499992, 63.58417389500005],
              [-171.08759518099993, 63.58197663000004],
              [-170.9752091139999, 63.58942291900007],
              [-170.9775284499999, 63.58612702000005],
              [-170.97797604099992, 63.58502838700008],
              [-170.97883053299992, 63.58429596600007],
              [-170.9826554029999, 63.58197663000004],
              [-170.93696041599992, 63.57168203300006],
              [-170.88874264199993, 63.58539459800005],
              [-170.84003658799992, 63.60610586100006],
              [-170.77350826699993, 63.62051015800006],
              [-170.72199459499993, 63.65086497600004],
              [-170.66258704299992, 63.67251211100006],
              [-170.64622962099992, 63.68504466400003],
              [-170.62462317599991, 63.67059967700004],
              [-170.59589596299992, 63.66966380400004],
              [-170.49657141799992, 63.700100002000056],
              [-170.47040768099993, 63.70408763200004],
              [-170.4407852859999, 63.705511786000045],
              [-170.42829342399992, 63.70343659100007],
              [-170.40192623599992, 63.69399648600006],
              [-170.3892716139999, 63.691839911000045],
              [-170.3377579419999, 63.699286200000074],
              [-170.3100479809999, 63.69867584800005],
              [-170.29735266799992, 63.69554271000004],
              [-170.2763565749999, 63.680853583000044],
              [-170.26642818899992, 63.67767975500004],
              [-170.2553604809999, 63.67568594000005],
              [-170.2415665359999, 63.67137278900003],
              [-170.18818111899992, 63.639105536000045],
              [-170.1671036449999, 63.63043854400007],
              [-170.11095130099991, 63.62319570500006],
              [-170.08246822799993, 63.61517975500004],
              [-170.0670059889999, 63.59414297100005],
              [-170.0529679029999, 63.579413153000075],
              [-170.0497940749999, 63.571478583000044],
              [-170.05207271999993, 63.560614325000074],
              [-170.05536861899992, 63.55540599200003],
              [-170.05414791599992, 63.55158112200007],
              [-170.0429581369999, 63.54474518400008],
              [-170.0385636059999, 63.53192780200004],
              [-170.05321204299992, 63.51577383000006],
              [-170.0732315749999, 63.499335028000075],
              [-170.08454342399992, 63.48582591400003],
              [-170.06891842399992, 63.49135976800005],
              [-170.05121822799993, 63.49371979400007],
              [-169.95368404899992, 63.488714911000045],
              [-169.89106197799993, 63.46735260600008],
              [-169.8476456369999, 63.45807526200008],
              [-169.75556393099993, 63.452337958000044],
              [-169.77424068899992, 63.44818756700005],
              [-169.8206680979999, 63.44944896000004],
              [-169.84369869699992, 63.44489166900007],
              [-169.7822159499999, 63.43537018400008],
              [-169.6573380199999, 63.43964264500005],
              [-169.59727942599991, 63.42438385600008],
              [-169.57990475199992, 63.41079336100006],
              [-169.56562252499992, 63.37905508000006],
              [-169.54950924399992, 63.362941799000055],
              [-169.52155514199993, 63.35297272300005],
              [-169.4810684889999, 63.34739817900004],
              [-169.44066321499992, 63.34804922100005],
              [-169.41295325399992, 63.356675523000035],
              [-169.42426510299993, 63.360663153000075],
              [-169.4361466139999, 63.36322663000004],
              [-169.3255509109999, 63.36310455900008],
              [-169.29149329299992, 63.35932038000004],
              [-169.26215572799993, 63.349269924000055],
              [-169.20592200399992, 63.30731842700004],
              [-169.18671627499992, 63.30145905200004],
              [-169.12397213399993, 63.30060455900008],
              [-169.0925186839999, 63.30605703300006],
              [-169.0703018869999, 63.32135651200008],
              [-169.10285396999993, 63.33270905200004],
              [-169.14325924399992, 63.339056708000044],
              [-169.22114010299993, 63.34247467700004],
              [-169.22114010299993, 63.349269924000055],
              [-169.0703018869999, 63.34247467700004],
              [-169.00763912699992, 63.349269924000055],
              [-168.9924210279999, 63.346869208000044],
              [-168.96149654899992, 63.337144273000035],
              [-168.7151993479999, 63.31195709800005],
              [-168.68610592399992, 63.30145905200004],
              [-168.69969641799992, 63.29559967700004],
              [-168.7275284499999, 63.28733958500004],
              [-168.74071204299992, 63.28099192900004],
            ],
          ],
          [
            [
              [-68.84813391799992, 44.09552643400008],
              [-68.82738196499992, 44.08978913000004],
              [-68.7827449209999, 44.08466217700004],
              [-68.7729792959999, 44.08189524900007],
              [-68.77464758999992, 44.06187571800007],
              [-68.78673255099994, 44.05235423400006],
              [-68.8005671869999, 44.046576239000046],
              [-68.80711829299992, 44.037543036000045],
              [-68.8154597649999, 44.03192780200004],
              [-68.83458411399994, 44.03510163000004],
              [-68.86925208199995, 44.04836660400008],
              [-68.86009680899991, 44.06521230700008],
              [-68.86803137899994, 44.079372463000084],
              [-68.8867488269999, 44.08987051000008],
              [-68.9101863269999, 44.09552643400008],
              [-68.90156002499992, 44.11404043200008],
              [-68.88414466099994, 44.11383698100008],
              [-68.84813391799992, 44.09552643400008],
            ],
          ],
          [
            [
              [-68.64207923099991, 44.26003652600008],
              [-68.6230769519999, 44.24986399900007],
              [-68.6164851549999, 44.23708730700008],
              [-68.6142878899999, 44.22398509300007],
              [-68.60850989499994, 44.21283600500004],
              [-68.62010657499991, 44.20844147300005],
              [-68.6443171869999, 44.203192450000074],
              [-68.65636145699995, 44.19916413000004],
              [-68.65062415299991, 44.190293687000064],
              [-68.64305579299992, 44.18463776200008],
              [-68.62279212099992, 44.17751699400009],
              [-68.62279212099992, 44.17133209800005],
              [-68.66205807199992, 44.15619538000004],
              [-68.68199622299994, 44.15261465100008],
              [-68.7163386709999, 44.16734446800007],
              [-68.72020423099991, 44.17214590100008],
              [-68.7146296869999, 44.18121979400007],
              [-68.71088619699992, 44.19045644700009],
              [-68.71332760299993, 44.20099518400008],
              [-68.72459876199991, 44.21906159100007],
              [-68.71625729099992, 44.218451239000046],
              [-68.69892330599993, 44.21967194200005],
              [-68.6904597649999, 44.21906159100007],
              [-68.69505774599992, 44.228623765000066],
              [-68.69676673099991, 44.239528713000084],
              [-68.69530188699991, 44.250433661000045],
              [-68.6904597649999, 44.26003652600008],
              [-68.67894446499992, 44.269639390000066],
              [-68.66746985599991, 44.27012767100007],
              [-68.64207923099991, 44.26003652600008],
            ],
          ],
          [
            [
              [-68.24482174399992, 44.42450592700004],
              [-68.24193274599992, 44.40497467700004],
              [-68.18529212099992, 44.35700104400007],
              [-68.1765437489999, 44.32831452000005],
              [-68.19892330599993, 44.30862051000008],
              [-68.24083411399994, 44.29454173400006],
              [-68.28331458199995, 44.29242584800005],
              [-68.30687415299991, 44.30841705900008],
              [-68.31371008999992, 44.30841705900008],
              [-68.3200984369999, 44.28493886900009],
              [-68.30943762899994, 44.27094147300005],
              [-68.29649817599994, 44.26109446800007],
              [-68.29633541599992, 44.250067450000074],
              [-68.30878658799992, 44.23786041900007],
              [-68.32603919199994, 44.225897528000075],
              [-68.34129798099991, 44.22357819200005],
              [-68.34784908799992, 44.24017975500004],
              [-68.35228430899991, 44.23806386900009],
              [-68.36375891799992, 44.23472728100006],
              [-68.36835689999992, 44.23273346600007],
              [-68.38011633999992, 44.24644603100006],
              [-68.41405188699991, 44.25861237200007],
              [-68.42357337099992, 44.274278062000064],
              [-68.4084773429999, 44.27834707200009],
              [-68.40546627499992, 44.285264390000066],
              [-68.4123835929999, 44.291856187000064],
              [-68.4272761709999, 44.29478587400007],
              [-68.43480383999992, 44.299994208000044],
              [-68.4338679679999, 44.31203847900008],
              [-68.4287410149999, 44.32571035400008],
              [-68.41010494699992, 44.36005280200004],
              [-68.40135657499991, 44.37177155200004],
              [-68.39256751199991, 44.37673574400009],
              [-68.3789363269999, 44.37950267100007],
              [-68.3674617179999, 44.386419989000046],
              [-68.3642878899999, 44.39533112200007],
              [-68.3757624989999, 44.40407949400009],
              [-68.35496985599991, 44.42328522300005],
              [-68.31590735599991, 44.43695709800005],
              [-68.27403723899994, 44.43927643400008],
              [-68.24482174399992, 44.42450592700004],
            ],
          ],
          [
            [
              [-161.9478653639999, 23.038031317000048],
              [-161.94635982999992, 23.041449286000045],
              [-161.9460343089999, 23.044582424000055],
              [-161.94477291599992, 23.046210028000075],
              [-161.9404190749999, 23.04559967700004],
              [-161.9409073559999, 23.04197825700004],
              [-161.94269771999993, 23.040676174000055],
              [-161.9451798169999, 23.039862372000073],
              [-161.9478653639999, 23.038031317000048],
            ],
          ],
          [
            [
              [-164.70433508999992, 23.579331773000035],
              [-164.6990860669999, 23.57054271000004],
              [-164.7072647779999, 23.57257721600007],
              [-164.7084854809999, 23.57453034100007],
              [-164.70636959499993, 23.576605536000045],
              [-164.70433508999992, 23.579331773000035],
            ],
          ],
          [
            [
              [-167.99677486899992, 25.001125393000052],
              [-168.00279700399992, 25.014797268000052],
              [-167.9998673169999, 25.016424872000073],
              [-167.99555416599992, 25.011664130000042],
              [-167.99506588399993, 25.007757880000042],
              [-167.99616451699993, 25.004339911000045],
              [-167.99677486899992, 25.001125393000052],
            ],
          ],
          [
            [
              [-171.72284908799992, 25.77301666900007],
              [-171.72935950399992, 25.75193919500009],
              [-171.73908443899992, 25.756293036000045],
              [-171.74067135299993, 25.76902903900009],
              [-171.72284908799992, 25.77301666900007],
            ],
          ],
          [
            [
              [-173.96499589799993, 26.07135651200008],
              [-173.96283932199992, 26.06663646000004],
              [-173.96051998599992, 26.06313711100006],
              [-173.95917721299992, 26.05963776200008],
              [-173.9599503249999, 26.05532461100006],
              [-173.96564693899992, 26.05857982000009],
              [-173.96637936099992, 26.06195709800005],
              [-173.9651993479999, 26.066107489000046],
              [-173.96499589799993, 26.07135651200008],
            ],
          ],
          [
            [
              [-178.29038113899992, 28.401678575000062],
              [-178.28790478099992, 28.39298946100007],
              [-178.2922247619999, 28.39009085400005],
              [-178.29839705799992, 28.387372162000077],
              [-178.3027183659999, 28.386464725000053],
              [-178.3043661629999, 28.38791219700005],
              [-178.29798837599992, 28.390993294000054],
              [-178.29428678199992, 28.394978087000084],
              [-178.29243673899992, 28.398056736000058],
              [-178.29038113899992, 28.401678575000062],
            ],
          ],
          [
            [
              [-122.7053930329999, 47.18195221600007],
              [-122.68553626199991, 47.18060944200005],
              [-122.67560787699995, 47.17633698100008],
              [-122.67137610599991, 47.16498444200005],
              [-122.67275956899994, 47.15509674700007],
              [-122.6770727199999, 47.139553127000056],
              [-122.6897680329999, 47.12958405200004],
              [-122.70107988199993, 47.12396881700005],
              [-122.70677649599992, 47.12396881700005],
              [-122.71524003799993, 47.128159898000035],
              [-122.72374426999994, 47.13239166900007],
              [-122.73790442599994, 47.14232005400004],
              [-122.74217688699991, 47.143744208000044],
              [-122.7464086579999, 47.15371328300006],
              [-122.73790442599994, 47.157904364000046],
              [-122.72940019399994, 47.162176825000074],
              [-122.72374426999994, 47.17206452000005],
              [-122.7180883449999, 47.18060944200005],
              [-122.7053930329999, 47.18195221600007],
            ],
          ],
          [
            [
              [-122.86815344999991, 47.26829661700003],
              [-122.86815344999991, 47.255560614000046],
              [-122.86953691299993, 47.24286530200004],
              [-122.8582250639999, 47.23151276200008],
              [-122.84829667899993, 47.22020091400009],
              [-122.84829667899993, 47.207464911000045],
              [-122.84829667899993, 47.19330475500004],
              [-122.8596899079999, 47.177720445000034],
              [-122.8738500639999, 47.16787344000005],
              [-122.87946529899995, 47.17206452000005],
              [-122.88231360599991, 47.18060944200005],
              [-122.8880102199999, 47.19330475500004],
              [-122.89077714799993, 47.200384833000044],
              [-122.89785722599993, 47.20888906500005],
              [-122.91201738199993, 47.218817450000074],
              [-122.9219457669999, 47.22870514500005],
              [-122.9219457669999, 47.237209377000056],
              [-122.9148656889999, 47.255560614000046],
              [-122.91201738199993, 47.26972077000005],
              [-122.90493730399993, 47.27826569200005],
              [-122.89077714799993, 47.27826569200005],
              [-122.88231360599991, 47.28388092700004],
              [-122.8653051419999, 47.28953685100004],
              [-122.8582250639999, 47.29242584800005],
              [-122.84691321499992, 47.298041083000044],
              [-122.85260982999989, 47.28534577000005],
              [-122.8667699859999, 47.27826569200005],
              [-122.86815344999991, 47.26829661700003],
            ],
          ],
          [
            [
              [-82.11839758999992, 24.556463934000078],
              [-82.11375891799992, 24.55731842700004],
              [-82.11880449099993, 24.553615627000056],
              [-82.12877356699994, 24.550848700000074],
              [-82.12828528599994, 24.55369700700004],
              [-82.11839758999992, 24.556463934000078],
            ],
          ],
          [
            [
              [-82.11961829299992, 24.585109768000052],
              [-82.12791907499991, 24.58926015800006],
              [-82.13475501199991, 24.592962958000044],
              [-82.1399633449999, 24.59332916900007],
              [-82.14574133999992, 24.592718817000048],
              [-82.14293372299994, 24.595851955000057],
              [-82.13174394399994, 24.598089911000045],
              [-82.11937415299991, 24.594671942000048],
              [-82.10960852799991, 24.58612702000005],
              [-82.10773678299995, 24.57526276200008],
              [-82.11046301999994, 24.56549713700008],
              [-82.11156165299991, 24.57094961100006],
              [-82.11961829299992, 24.585109768000052],
            ],
          ],
          [
            [
              [-81.42446855399993, 24.65497467700004],
              [-81.41759192599994, 24.659409898000035],
              [-81.41063391799992, 24.655422268000052],
              [-81.41478430899991, 24.647691148000035],
              [-81.42174231699994, 24.65176015800006],
              [-81.42446855399993, 24.65497467700004],
            ],
          ],
          [
            [
              [-81.26520748599995, 24.67129140800006],
              [-81.26024329299992, 24.671698309000078],
              [-81.25837154899995, 24.667629299000055],
              [-81.26634680899991, 24.66038646000004],
              [-81.27603105399993, 24.655585028000075],
              [-81.27749589799993, 24.65761953300006],
              [-81.26520748599995, 24.67129140800006],
            ],
          ],
          [
            [
              [-81.4480688139999, 24.680568752000056],
              [-81.4422094389999, 24.671535549000055],
              [-81.43932044199994, 24.66038646000004],
              [-81.44139563699991, 24.650539455000057],
              [-81.44684811099995, 24.650783596000053],
              [-81.44908606699994, 24.655218817000048],
              [-81.46068274599992, 24.66437409100007],
              [-81.46198482999995, 24.67096588700008],
              [-81.45543372299994, 24.67609284100007],
              [-81.45384680899991, 24.677679755000042],
              [-81.45738684799994, 24.67792389500005],
              [-81.45543372299994, 24.681341864000046],
              [-81.4480688139999, 24.680568752000056],
            ],
          ],
          [
            [
              [-81.48241126199991, 24.683254299000055],
              [-81.47972571499992, 24.67251211100006],
              [-81.47842363199993, 24.654120184000078],
              [-81.48131262899994, 24.64984772300005],
              [-81.48542232999995, 24.65696849200009],
              [-81.49111894399994, 24.662258205000057],
              [-81.4973852199999, 24.66396719000005],
              [-81.50243079299992, 24.662665106000077],
              [-81.50645911399994, 24.660101630000042],
              [-81.51113847599993, 24.661322333000044],
              [-81.5137426419999, 24.663275458000044],
              [-81.51610266799992, 24.66547272300005],
              [-81.52017167899993, 24.67405833500004],
              [-81.51903235599991, 24.687323309000078],
              [-81.51500403599994, 24.697739976000037],
              [-81.51162675699993, 24.698431708000044],
              [-81.50698808499993, 24.695868231000077],
              [-81.50088456899994, 24.695257880000042],
              [-81.49315344999991, 24.69212474200009],
              [-81.48574785099993, 24.68650950700004],
              [-81.48241126199991, 24.683254299000055],
            ],
          ],
          [
            [
              [-81.32945716099994, 24.70331452000005],
              [-81.32066809799994, 24.694484768000052],
              [-81.31554114499994, 24.679632880000042],
              [-81.31777910099993, 24.674953518000052],
              [-81.3255102199999, 24.68427155200004],
              [-81.33470618399991, 24.689846096000053],
              [-81.33788001199991, 24.693304755000042],
              [-81.34089107999995, 24.700100002000056],
              [-81.33690344999991, 24.70380280200004],
              [-81.32945716099994, 24.70331452000005],
            ],
          ],
          [
            [
              [-80.70083574099993, 24.881008205000057],
              [-80.69933020699995, 24.876288153000075],
              [-80.71084550699993, 24.86432526200008],
              [-80.71825110599991, 24.859442450000074],
              [-80.73355058499993, 24.85032786700009],
              [-80.7383520169999, 24.850734768000052],
              [-80.73599199099993, 24.857367255000042],
              [-80.72972571499992, 24.86277903900009],
              [-80.72105872299994, 24.86668528900009],
              [-80.70083574099993, 24.881008205000057],
            ],
          ],
          [
            [
              [-80.62547766799992, 24.93622467700004],
              [-80.61851966099994, 24.941555080000057],
              [-80.61750240799995, 24.93813711100006],
              [-80.61774654899995, 24.936021226000037],
              [-80.62621008999992, 24.92413971600007],
              [-80.64696204299992, 24.904730536000045],
              [-80.65713456899994, 24.90110911700009],
              [-80.62547766799992, 24.93622467700004],
            ],
          ],
          [
            [
              [-81.04747473899994, 25.309393622000073],
              [-81.04279537699995, 25.307440497000073],
              [-81.03978430899991, 25.296698309000078],
              [-81.04849199099993, 25.284979559000078],
              [-81.05174719999991, 25.27830638200004],
              [-81.05874589799993, 25.273993231000077],
              [-81.06688391799992, 25.27676015800006],
              [-81.07461503799993, 25.288723049000055],
              [-81.07835852799991, 25.301703192000048],
              [-81.07286536399994, 25.31004466400009],
              [-81.05980383999992, 25.311712958000044],
              [-81.04747473899994, 25.309393622000073],
            ],
          ],
          [
            [
              [-81.08901933499993, 25.33885325700004],
              [-81.08629309799994, 25.331244208000044],
              [-81.08568274599992, 25.32689036700009],
              [-81.08812415299991, 25.322414455000057],
              [-81.09072831899994, 25.31281159100007],
              [-81.10033118399991, 25.318182684000078],
              [-81.10863196499992, 25.323960679000038],
              [-81.12222245999993, 25.33657461100006],
              [-81.1165258449999, 25.341945705000057],
              [-81.11042232999995, 25.340318101000037],
              [-81.11270097599993, 25.33820221600007],
              [-81.1087133449999, 25.337632554000038],
              [-81.09727942599994, 25.34007396000004],
              [-81.08901933499993, 25.33885325700004],
            ],
          ],
          [
            [
              [-81.38048255099994, 25.82094961100006],
              [-81.37319902299993, 25.816107489000046],
              [-81.37071692599994, 25.81012604400007],
              [-81.37743079299992, 25.807033596000053],
              [-81.38756262899994, 25.80609772300005],
              [-81.39321855399993, 25.80219147300005],
              [-81.39708411399994, 25.79759349200009],
              [-81.39989173099991, 25.794867255000042],
              [-81.3997289699999, 25.791815497000073],
              [-81.40322831899994, 25.793524481000077],
              [-81.40680904899995, 25.796698309000078],
              [-81.41771399599992, 25.80878327000005],
              [-81.42516028599994, 25.811468817000048],
              [-81.43333899599992, 25.804754950000074],
              [-81.43956458199995, 25.803900458000044],
              [-81.43984941299993, 25.82648346600007],
              [-81.44123287699995, 25.832505601000037],
              [-81.44050045499995, 25.84243398600006],
              [-81.42951412699995, 25.850897528000075],
              [-81.41222083199995, 25.84324778900009],
              [-81.40518144399994, 25.83698151200008],
              [-81.38707434799994, 25.82412344000005],
              [-81.38048255099994, 25.82094961100006],
            ],
          ],
          [
            [
              [-81.45335852799991, 25.825506903000075],
              [-81.45962480399993, 25.822821356000077],
              [-81.46694902299993, 25.829331773000035],
              [-81.47105872299994, 25.835272528000075],
              [-81.47386633999992, 25.840399481000077],
              [-81.47956295499995, 25.847601630000042],
              [-81.49526933499993, 25.84870026200008],
              [-81.49803626199991, 25.852118231000077],
              [-81.50283769399994, 25.85545482000009],
              [-81.5078832669999, 25.852036851000037],
              [-81.50837154899995, 25.847316799000055],
              [-81.5091039699999, 25.843491929000038],
              [-81.51097571499992, 25.836859442000048],
              [-81.51203365799995, 25.83612702000005],
              [-81.51211503799993, 25.840277411000045],
              [-81.5149633449999, 25.843003648000035],
              [-81.51976477799991, 25.84870026200008],
              [-81.5169164699999, 25.859767971000053],
              [-81.50304114499994, 25.86587148600006],
              [-81.49445553299995, 25.867621161000045],
              [-81.48981686099995, 25.86981842700004],
              [-81.47435462099992, 25.87246328300006],
              [-81.46515865799995, 25.865668036000045],
              [-81.45799719999991, 25.850409247000073],
              [-81.45612545499995, 25.841864325000074],
              [-81.45343990799995, 25.838812567000048],
              [-81.4505102199999, 25.83234284100007],
              [-81.45335852799991, 25.825506903000075],
            ],
          ],
          [
            [
              [-81.67613684799994, 25.901271877000056],
              [-81.6634008449999, 25.896918036000045],
              [-81.66002356699994, 25.886542059000078],
              [-81.67202714799993, 25.867254950000074],
              [-81.67739824099993, 25.861476955000057],
              [-81.6902563139999, 25.863104559000078],
              [-81.69615637899994, 25.865790106000077],
              [-81.69880123599995, 25.87262604400007],
              [-81.70156816299993, 25.877508856000077],
              [-81.7063695949999, 25.88149648600006],
              [-81.70856686099995, 25.88377513200004],
              [-81.71076412699995, 25.88971588700008],
              [-81.70840410099993, 25.89866771000004],
              [-81.69896399599992, 25.89984772300005],
              [-81.68887285099993, 25.899318752000056],
              [-81.67613684799994, 25.901271877000056],
            ],
          ],
          [
            [
              [-81.54100501199991, 25.89012278900009],
              [-81.53604081899994, 25.88499583500004],
              [-81.53355872299994, 25.878648179000038],
              [-81.53648841099994, 25.870917059000078],
              [-81.54576575399994, 25.853664455000057],
              [-81.54849199099993, 25.857489325000074],
              [-81.54645748599995, 25.872748114000046],
              [-81.54784094999991, 25.881659247000073],
              [-81.5540258449999, 25.884507554000038],
              [-81.55870520699995, 25.889064846000053],
              [-81.56102454299992, 25.89484284100007],
              [-81.55833899599992, 25.90338776200008],
              [-81.54588782499991, 25.902411200000074],
              [-81.53921464799993, 25.895331122000073],
              [-81.54222571499992, 25.893866278000075],
              [-81.54312089799993, 25.893011786000045],
              [-81.54100501199991, 25.89012278900009],
            ],
          ],
          [
            [
              [-82.66600501199991, 28.734442450000074],
              [-82.66706295499995, 28.722357489000046],
              [-82.67227128799993, 28.715236721000053],
              [-82.67373613199993, 28.71442291900007],
              [-82.67821204299992, 28.71426015800006],
              [-82.68187415299991, 28.716945705000057],
              [-82.68187415299991, 28.720851955000057],
              [-82.69603430899991, 28.72557200700004],
              [-82.69587154899995, 28.728949286000045],
              [-82.69200598899994, 28.72915273600006],
              [-82.68814042899993, 28.728989976000037],
              [-82.6856176419999, 28.73004791900007],
              [-82.68927975199995, 28.731756903000075],
              [-82.68895423099991, 28.735296942000048],
              [-82.68321692599994, 28.73773834800005],
              [-82.67760169199994, 28.736070054000038],
              [-82.67271887899994, 28.73704661700009],
              [-82.66600501199991, 28.734442450000074],
            ],
          ],
          [
            [
              [-82.69640051999994, 28.76398346600007],
              [-82.69273841099994, 28.769354559000078],
              [-82.69163977799991, 28.773098049000055],
              [-82.69546464799993, 28.77643463700008],
              [-82.69758053299995, 28.78229401200008],
              [-82.69493567599994, 28.787583726000037],
              [-82.68809973899994, 28.78815338700008],
              [-82.67992102799991, 28.78465403900009],
              [-82.67349199099993, 28.777085679000038],
              [-82.67381751199991, 28.76666901200008],
              [-82.68219967399995, 28.760321356000077],
              [-82.69253495999993, 28.760239976000037],
              [-82.69737708199995, 28.761460679000038],
              [-82.69640051999994, 28.76398346600007],
            ],
          ],
          [
            [
              [-90.65208899599992, 29.067206122000073],
              [-90.64883378799993, 29.06940338700008],
              [-90.64220130099994, 29.07294342700004],
              [-90.64395097599993, 29.07062409100007],
              [-90.6563207669999, 29.06321849200009],
              [-90.67275956899994, 29.05727773600006],
              [-90.74941972599993, 29.040961005000042],
              [-90.76520748599995, 29.040961005000042],
              [-90.76716061099995, 29.04706452000005],
              [-90.73997962099992, 29.052883205000057],
              [-90.73501542899993, 29.05760325700004],
              [-90.71410071499992, 29.06541575700004],
              [-90.70824133999992, 29.06541575700004],
              [-90.70543372299994, 29.061753648000035],
              [-90.69684811099995, 29.05923086100006],
              [-90.68407141799992, 29.06085846600007],
              [-90.67662512899994, 29.06517161700009],
              [-90.67357337099992, 29.06793854400007],
              [-90.65709387899994, 29.066839911000045],
              [-90.65208899599992, 29.067206122000073],
            ],
          ],
          [
            [
              [-90.41738847599993, 29.055487372000073],
              [-90.41397050699993, 29.052435614000046],
              [-90.4134008449999, 29.048570054000038],
              [-90.42015540299991, 29.04873281500005],
              [-90.46458899599992, 29.057806708000044],
              [-90.51235917899993, 29.07485586100006],
              [-90.51097571499992, 29.08030833500004],
              [-90.45230058499993, 29.069566148000035],
              [-90.42857825399994, 29.06122467700004],
              [-90.41738847599993, 29.055487372000073],
            ],
          ],
          [
            [
              [-83.03819739499994, 29.14520905200004],
              [-83.03294837099992, 29.14126211100006],
              [-83.02965247299994, 29.139797268000052],
              [-83.03677324099993, 29.137518622000073],
              [-83.04995683499993, 29.131984768000052],
              [-83.05817623599995, 29.13617584800005],
              [-83.05752519399994, 29.150091864000046],
              [-83.05028235599991, 29.15570709800005],
              [-83.04295813699991, 29.151271877000056],
              [-83.03819739499994, 29.14520905200004],
            ],
          ],
          [
            [
              [-90.4500219389999, 29.23509349200009],
              [-90.45254472599993, 29.22402578300006],
              [-90.45360266799992, 29.237982489000046],
              [-90.44627844999991, 29.260321356000077],
              [-90.43455969999991, 29.264471747000073],
              [-90.43382727799991, 29.255113023000035],
              [-90.4402563139999, 29.247707424000055],
              [-90.44676673099991, 29.242132880000042],
              [-90.4500219389999, 29.23509349200009],
            ],
          ],
          [
            [
              [-89.92784583199995, 29.28815338700008],
              [-89.92275956899994, 29.28929271000004],
              [-89.91315670499995, 29.290228583000044],
              [-89.91445878799993, 29.284857489000046],
              [-89.92926998599995, 29.276597398000035],
              [-89.93895423099991, 29.27724844000005],
              [-89.93382727799991, 29.28457265800006],
              [-89.92784583199995, 29.28815338700008],
            ],
          ],
          [
            [
              [-89.9949438139999, 29.45661041900007],
              [-89.99323482999995, 29.45844147300005],
              [-89.9915258449999, 29.45571523600006],
              [-89.99168860599991, 29.44863515800006],
              [-89.99583899599992, 29.44481028900009],
              [-90.00104732999995, 29.445705471000053],
              [-90.01573645699995, 29.443793036000045],
              [-90.02131100199995, 29.44830963700008],
              [-90.02489173099991, 29.456854559000078],
              [-90.03148352799991, 29.463283596000053],
              [-90.03921464799993, 29.46442291900007],
              [-90.04434160099993, 29.461411851000037],
              [-90.04995683499993, 29.461411851000037],
              [-90.05378170499995, 29.46352773600006],
              [-90.05768795499995, 29.46621328300006],
              [-90.06208248599995, 29.47284577000005],
              [-90.0613500639999, 29.47724030200004],
              [-90.05882727799991, 29.47801341400009],
              [-90.06419837099992, 29.478664455000057],
              [-90.07860266799992, 29.476629950000074],
              [-90.09194902299993, 29.473537502000056],
              [-90.10179602799991, 29.478338934000078],
              [-90.11900794199994, 29.496242580000057],
              [-90.11986243399991, 29.505519924000055],
              [-90.11351477799991, 29.51072825700004],
              [-90.10464433499993, 29.511379299000055],
              [-90.09581458199995, 29.51007721600007],
              [-90.08177649599992, 29.51129791900007],
              [-90.06110592399995, 29.50454336100006],
              [-90.05357825399994, 29.500474351000037],
              [-90.04898027299993, 29.496649481000077],
              [-90.0410863919999, 29.493394273000035],
              [-90.0301000639999, 29.49091217700004],
              [-90.02041581899994, 29.48663971600007],
              [-90.01455644399994, 29.478583075000074],
              [-90.01805579299992, 29.474351304000038],
              [-90.02839107999995, 29.475409247000073],
              [-90.0281469389999, 29.471909898000035],
              [-90.01805579299992, 29.461330471000053],
              [-90.0091039699999, 29.457586981000077],
              [-90.00186113199993, 29.45962148600006],
              [-89.99844316299993, 29.46124909100007],
              [-89.99730383999992, 29.46556224200009],
              [-89.99571692599994, 29.46474844000005],
              [-89.99486243399991, 29.459377346000053],
              [-89.9949438139999, 29.45661041900007],
            ],
          ],
          [
            [
              [-89.05703691299993, 29.56207916900007],
              [-89.05479895699995, 29.563625393000052],
              [-89.04991614499994, 29.565008856000077],
              [-89.0540258449999, 29.559515692000048],
              [-89.08409583199995, 29.529445705000057],
              [-89.09142005099994, 29.523911851000037],
              [-89.09850012899994, 29.52094147300005],
              [-89.05703691299993, 29.56207916900007],
            ],
          ],
          [
            [
              [-88.97960364499994, 29.632879950000074],
              [-88.97008216099994, 29.639797268000052],
              [-88.96450761599993, 29.64276764500005],
              [-88.9688207669999, 29.63857656500005],
              [-88.97826087099992, 29.631659247000073],
              [-88.97960364499994, 29.632879950000074],
            ],
          ],
          [
            [
              [-88.92540442599994, 29.68309153900009],
              [-88.93883216099994, 29.67328522300005],
              [-88.87409420499995, 29.74746328300006],
              [-88.88955644399994, 29.72532786700009],
              [-88.92540442599994, 29.68309153900009],
            ],
          ],
          [
            [
              [-81.2512893839999, 31.504578069000047],
              [-81.23485087599994, 31.526501102000054],
              [-81.22078058499994, 31.527681633000043],
              [-81.20290879399994, 31.534334064000063],
              [-81.18496334999992, 31.530085360000044],
              [-81.17465025799993, 31.521421082000074],
              [-81.18600798799991, 31.50281225200007],
              [-81.19863114399993, 31.48310231800008],
              [-81.2137149049999, 31.453559403000042],
              [-81.23528985199994, 31.43378470400006],
              [-81.26171836599991, 31.387792473000047],
              [-81.27961053799993, 31.38548129900005],
              [-81.29121018299992, 31.39521708600006],
              [-81.3003204389999, 31.41151639700007],
              [-81.2890763659999, 31.43995590500009],
              [-81.2713674339999, 31.46190300300009],
              [-81.25755547199992, 31.490356090000034],
              [-81.2512893839999, 31.504578069000047],
            ],
          ],
          [
            [
              [-81.16055492399994, 31.669889304000037],
              [-81.14925805099995, 31.698338704000037],
              [-81.1364345319999, 31.698409526000034],
              [-81.13125953399992, 31.69297829800007],
              [-81.13371571699992, 31.679863862000047],
              [-81.13352662599993, 31.656941275000065],
              [-81.12816894999992, 31.628596155000082],
              [-81.13828311299994, 31.61217242200007],
              [-81.14960126499994, 31.587015093000048],
              [-81.16095992399994, 31.56731375000004],
              [-81.17507115399991, 31.570502761000057],
              [-81.17009019999995, 31.586896920000072],
              [-81.16763960299994, 31.600002680000046],
              [-81.17799249799992, 31.611943952000047],
              [-81.17948452999991, 31.635942425000053],
              [-81.17193917999992, 31.652357992000077],
              [-81.16055492399994, 31.669889304000037],
            ],
          ],
          [
            [
              [-118.23467597599989, 33.763152826000066],
              [-118.22657762499995, 33.76544958300008],
              [-118.2239186249999, 33.756066514000054],
              [-118.2438782299999, 33.750844216000075],
              [-118.23634610999994, 33.728046034000045],
              [-118.25013442599993, 33.72361820800006],
              [-118.2455714969999, 33.71487945800004],
              [-118.25762853399993, 33.716554070000086],
              [-118.2613263419999, 33.725000144000035],
              [-118.2591264809999, 33.729407138000056],
              [-118.24432006199993, 33.73429096000007],
              [-118.24899386399994, 33.74942726000006],
              [-118.25385396199994, 33.74621895900009],
              [-118.25110728999994, 33.73626911900004],
              [-118.26056233199989, 33.733453944000075],
              [-118.26861511099992, 33.72893144600005],
              [-118.27085914999992, 33.739639570000065],
              [-118.26750609599992, 33.747028786000044],
              [-118.25498886199995, 33.75808264400007],
              [-118.25031995199993, 33.75755544000009],
              [-118.24554711299993, 33.759683031000066],
              [-118.23467597599989, 33.763152826000066],
            ],
          ],
          [
            [
              [-75.90377292999995, 37.129214309000076],
              [-75.89281625599995, 37.14067425400009],
              [-75.89432347799993, 37.16123954600005],
              [-75.90179454399993, 37.17559371700008],
              [-75.90621378799995, 37.19459019400006],
              [-75.90541986799991, 37.23442645600005],
              [-75.89560335599992, 37.252969990000054],
              [-75.88948344599993, 37.280404557000054],
              [-75.87397053399991, 37.290379804000054],
              [-75.85867491699992, 37.28251412600008],
              [-75.85175154899991, 37.27077289600004],
              [-75.85405520599994, 37.26088484500008],
              [-75.86719605199994, 37.25411214800005],
              [-75.87666617499991, 37.240672164000046],
              [-75.88324570999993, 37.21864807600008],
              [-75.8771394179999, 37.205592522000074],
              [-75.86931388599993, 37.198439284000074],
              [-75.8576435839999, 37.19405349200008],
              [-75.8395503129999, 37.19279357800008],
              [-75.82322689199992, 37.196322534000046],
              [-75.81730165399995, 37.20699019600005],
              [-75.81172420799993, 37.209081221000076],
              [-75.8107792909999, 37.200169376000076],
              [-75.81624217199993, 37.18607639700008],
              [-75.82906399599995, 37.17674031300004],
              [-75.84959102699992, 37.16358423200006],
              [-75.87132791999994, 37.14287224200007],
              [-75.88652022399992, 37.123105777000035],
              [-75.89946046999995, 37.117310204000034],
              [-75.91453745199993, 37.11232258400008],
              [-75.92860193899992, 37.112221513000065],
              [-75.92631689699994, 37.11784389200005],
              [-75.9153836399999, 37.118544935000045],
              [-75.90761563199993, 37.122960471000056],
              [-75.90377292999995, 37.129214309000076],
            ],
          ],
          [
            [
              [-72.34155907199994, 41.09065164000003],
              [-72.34015878299994, 41.10368310800004],
              [-72.32784494799995, 41.10505563300006],
              [-72.32271337399993, 41.094572403000086],
              [-72.30524873699994, 41.084218047000036],
              [-72.29533676999995, 41.08184163800007],
              [-72.28048150099994, 41.07889484600008],
              [-72.28276975599994, 41.06895326500006],
              [-72.27846995399995, 41.05845957900004],
              [-72.28238998299992, 41.04788112600005],
              [-72.2756603009999, 41.03927114700008],
              [-72.27552668699991, 41.03183321700004],
              [-72.28625314199991, 41.03420304000008],
              [-72.29789104399993, 41.04152259400007],
              [-72.31775021599992, 41.048753110000064],
              [-72.34076269299993, 41.04850660400007],
              [-72.35879771099991, 41.04583065700007],
              [-72.37130575499992, 41.05499178600007],
              [-72.37239126599991, 41.06861794300005],
              [-72.36191680899992, 41.07989203500006],
              [-72.34155907199994, 41.09065164000003],
            ],
          ],
          [
            [
              [-72.1310218719999, 41.12047220800008],
              [-72.10907184299992, 41.10686088500006],
              [-72.09135388699991, 41.101899546000084],
              [-72.0784307159999, 41.099964284000066],
              [-72.0790335929999, 41.09484476500006],
              [-72.08509264599991, 41.09172515900008],
              [-72.08497102799993, 41.08354295400005],
              [-72.08145065699995, 41.07487881900005],
              [-72.08610076799994, 41.068189192000034],
              [-72.0927894699999, 41.061478812000075],
              [-72.10082292899995, 41.05424624400007],
              [-72.10102065199993, 41.06754587100005],
              [-72.10258450399994, 41.081343332000074],
              [-72.10813839499991, 41.09050581200006],
              [-72.12243856599991, 41.092932896000036],
              [-72.13602549199993, 41.09280736000005],
              [-72.14152082999993, 41.096849278000036],
              [-72.13480758199995, 41.10202611300008],
              [-72.1281319279999, 41.10924651800008],
              [-72.1310218719999, 41.12047220800008],
            ],
          ],
          [
            [
              [-70.83047103799993, 41.26036556200006],
              [-70.82193459099994, 41.260392670000044],
              [-70.81402061699993, 41.26316742900008],
              [-70.80912644199992, 41.25951425400007],
              [-70.80179750899993, 41.25678454500007],
              [-70.8017562949999, 41.24807623400005],
              [-70.81090254999992, 41.24804580500006],
              [-70.82310823699993, 41.25075996500004],
              [-70.83228243899993, 41.25669179800008],
              [-70.83047103799993, 41.26036556200006],
            ],
          ],
          [
            [
              [-70.8711762289999, 41.43866951000007],
              [-70.85946451599995, 41.44826505300006],
              [-70.8564935519999, 41.443127761000085],
              [-70.84859848799994, 41.43433214200007],
              [-70.85445358399994, 41.42916762300007],
              [-70.87598375899995, 41.42248052900004],
              [-70.89265393499994, 41.42242208300007],
              [-70.90638582199995, 41.42237109700005],
              [-70.92791669299993, 41.418619697000054],
              [-70.9386654939999, 41.41122005500006],
              [-70.9485034089999, 41.414123560000064],
              [-70.94067753399992, 41.42077491500004],
              [-70.92602989099993, 41.428916850000064],
              [-70.91133513999995, 41.429705943000044],
              [-70.89764619599993, 41.43637180800005],
              [-70.8711762289999, 41.43866951000007],
            ],
          ],
          [
            [
              [-70.72435438399992, 41.511099655000066],
              [-70.71063815799994, 41.51921397600006],
              [-70.69492550799993, 41.517037162000065],
              [-70.6791940139999, 41.51044955600008],
              [-70.69978432199991, 41.502326750000066],
              [-70.71839838799991, 41.49199817900006],
              [-70.74289323599993, 41.48165437100005],
              [-70.75856515699991, 41.47574058100008],
              [-70.75755400899993, 41.46839261900004],
              [-70.76830594199993, 41.45954623300008],
              [-70.79081634399995, 41.44919885200005],
              [-70.80845740399991, 41.44694615900005],
              [-70.8329506959999, 41.442465380000044],
              [-70.8398605889999, 41.45053076500005],
              [-70.82812519599992, 41.45718182300004],
              [-70.81340283799994, 41.455017817000055],
              [-70.8026527049999, 41.46313310700003],
              [-70.78212384299991, 41.47862341900009],
              [-70.74296665299994, 41.50076586100005],
              [-70.72435438399992, 41.511099655000066],
            ],
          ],
          [
            [
              [-123.41708489099994, 46.20484238700004],
              [-123.40504284399992, 46.20093409900005],
              [-123.3883685379999, 46.190369727000075],
              [-123.36620832499995, 46.179202599000064],
              [-123.34885952399992, 46.166408939000064],
              [-123.32432682399991, 46.15466172300006],
              [-123.31566112899992, 46.148536334000084],
              [-123.33798285299991, 46.14759423000004],
              [-123.35786054699992, 46.150489106000066],
              [-123.37690053199992, 46.15612957700006],
              [-123.39663805899994, 46.168933311000046],
              [-123.41104639299994, 46.175079562000064],
              [-123.4205705139999, 46.18559215700009],
              [-123.42295632199995, 46.18780596400006],
              [-123.41708489099994, 46.20484238700004],
            ],
          ],
          [
            [
              [-123.48074680299993, 46.255943786000046],
              [-123.4711947639999, 46.254788491000056],
              [-123.46012657699993, 46.247562316000085],
              [-123.44433492199994, 46.23589907600007],
              [-123.43668424799989, 46.220399101000055],
              [-123.44084031199992, 46.21324806000007],
              [-123.45266382599993, 46.21828556500009],
              [-123.46843930599994, 46.22500342300003],
              [-123.4778060189999, 46.23609268000007],
              [-123.48242404099994, 46.24934078500007],
              [-123.48074680299993, 46.255943786000046],
            ],
          ],
          [
            [
              [-133.5203344389999, 54.814113674000055],
              [-133.52013098899994, 54.80821360900006],
              [-133.51577714799993, 54.796861070000034],
              [-133.5151667959999, 54.782456773000035],
              [-133.5217585929999, 54.76675039300005],
              [-133.52924557199992, 54.76833730700008],
              [-133.5439753899999, 54.77944570500006],
              [-133.54609127499992, 54.78502024900007],
              [-133.5437719389999, 54.79405345300006],
              [-133.54356848899994, 54.79958730700008],
              [-133.5457250639999, 54.80182526200008],
              [-133.54503333199995, 54.80544668200008],
              [-133.5451554029999, 54.81602610900006],
              [-133.54352779899995, 54.82229238500008],
              [-133.5447485019999, 54.831691799000055],
              [-133.5378311839999, 54.83498769700009],
              [-133.5298152329999, 54.83104075700004],
              [-133.5205785799999, 54.82025788000004],
              [-133.5203344389999, 54.81419505400004],
              [-133.5203344389999, 54.814113674000055],
            ],
          ],
          [
            [
              [-131.1891499099999, 55.103431457000056],
              [-131.18807945899994, 55.07507419700005],
              [-131.18999231899994, 55.04833726000004],
              [-131.2162002899999, 55.04802402200005],
              [-131.2548945289999, 55.06923656200007],
              [-131.2441483789999, 55.09274368200005],
              [-131.20397197099993, 55.10993296700008],
              [-131.1891499099999, 55.103431457000056],
            ],
          ],
          [
            [
              [-133.3072766109999, 55.43218723000007],
              [-133.26925098399994, 55.44395017100004],
              [-133.23605675499994, 55.440219968000065],
              [-133.23828299899992, 55.41380271500003],
              [-133.27449343099994, 55.40427994500004],
              [-133.31519653999993, 55.40454704200005],
              [-133.32026955999993, 55.42312659900006],
              [-133.3072766109999, 55.43218723000007],
            ],
          ],
          [
            [
              [-152.2881886989999, 57.39698450600008],
              [-152.2627300419999, 57.390629629000045],
              [-152.2559221749999, 57.38424344200007],
              [-152.26774368199992, 57.37508687900004],
              [-152.29818332099993, 57.36315467700007],
              [-152.31512421399992, 57.36312123100004],
              [-152.2999352239999, 57.374117520000084],
              [-152.2881886989999, 57.39698450600008],
            ],
          ],
          [
            [
              [-136.13757281699992, 58.265089394000086],
              [-136.1436892719999, 58.28536632700008],
              [-136.10698368099992, 58.30340946800004],
              [-136.04505320499993, 58.31859551200006],
              [-136.02793923399992, 58.29496935200007],
              [-136.05999702499992, 58.26778492400007],
              [-136.1119532429999, 58.258534061000034],
              [-136.13757281699992, 58.265089394000086],
            ],
          ],
          [
            [
              [-135.7185034019999, 58.34614449400004],
              [-135.7142304649999, 58.370477950000065],
              [-135.6549038299999, 58.379797404000044],
              [-135.5688981479999, 58.373150673000055],
              [-135.5433445289999, 58.33483223800005],
              [-135.59222181799993, 58.32775138100004],
              [-135.67062290099994, 58.330899652000085],
              [-135.7185034019999, 58.34614449400004],
            ],
          ],
          [
            [
              [-152.03522701699993, 58.951686916000085],
              [-152.0130509109999, 58.945298570000034],
              [-152.01313229099992, 58.93984609600005],
              [-152.0425105459999, 58.929754950000074],
              [-152.0507706369999, 58.922715562000064],
              [-152.05516516799992, 58.91429271000004],
              [-152.06509355399993, 58.91128164300005],
              [-152.07465572799993, 58.91429271000004],
              [-152.07514400899993, 58.91966380400004],
              [-152.0701798169999, 58.92654043200008],
              [-152.06379146999993, 58.932481187000064],
              [-152.06183834499993, 58.93809642100007],
              [-152.0624893869999, 58.94277578300006],
              [-152.0604548819999, 58.94440338700008],
              [-152.0472712879999, 58.944240627000056],
              [-152.0448298819999, 58.94639720300006],
              [-152.04181881399992, 58.95156484600005],
              [-152.03522701699993, 58.951686916000085],
            ],
          ],
          [
            [
              [-151.68785894799993, 59.12965601900004],
              [-151.67016564199992, 59.11808021400003],
              [-151.64371964799992, 59.115749133000065],
              [-151.6469235639999, 59.10393569800004],
              [-151.6625595559999, 59.09818980300008],
              [-151.67835956699992, 59.09991916000007],
              [-151.69983780299992, 59.097939428000075],
              [-151.71364668799993, 59.105835305000085],
              [-151.7215821789999, 59.121897371000045],
              [-151.7085143639999, 59.13072031200005],
              [-151.68785894799993, 59.12965601900004],
            ],
          ],
          [
            [
              [-151.4651331789999, 59.138190644000076],
              [-151.44812698599992, 59.13643971600004],
              [-151.4335610079999, 59.135292063000065],
              [-151.4382092609999, 59.12718227600004],
              [-151.4282806319999, 59.11730169500004],
              [-151.4389327179999, 59.10728602900008],
              [-151.4595558999999, 59.10901380900003],
              [-151.48158351799992, 59.11818777700006],
              [-151.50850122499992, 59.12856629200007],
              [-151.5002505399999, 59.13732668800009],
              [-151.4651331789999, 59.138190644000076],
            ],
          ],
          [
            [
              [-151.85898718599992, 59.163867345000085],
              [-151.81682197999993, 59.17066415600004],
              [-151.7887815059999, 59.153052899000045],
              [-151.80075834299993, 59.138892749000036],
              [-151.8533123359999, 59.14476644900003],
              [-151.89318997299992, 59.14436431100006],
              [-151.88867580599992, 59.15718263100007],
              [-151.85898718599992, 59.163867345000085],
            ],
          ],
          [
            [
              [-146.3235977859999, 59.45213450700004],
              [-146.3130997389999, 59.45575592700004],
              [-146.30821692599991, 59.44708893400008],
              [-146.32241777299993, 59.425848700000074],
              [-146.34068762899992, 59.411444403000075],
              [-146.3585505849999, 59.41010163000004],
              [-146.35863196499992, 59.42243073100008],
              [-146.3235977859999, 59.45213450700004],
            ],
          ],
          [
            [
              [-152.56318111899992, 60.14996979400007],
              [-152.55829830599993, 60.13499583500004],
              [-152.55821692599991, 60.10834381700005],
              [-152.58014889199993, 60.10724518400008],
              [-152.61115475199992, 60.13104889500005],
              [-152.6282852859999, 60.14862702000005],
              [-152.63569088399993, 60.15794505400004],
              [-152.63813229099992, 60.167303778000075],
              [-152.63239498599992, 60.17479075700004],
              [-152.6204727859999, 60.17926666900007],
              [-152.6046036449999, 60.178615627000056],
              [-152.5861710279999, 60.17206452000005],
              [-152.5694473949999, 60.15875885600008],
              [-152.56318111899992, 60.14996979400007],
            ],
          ],
          [
            [
              [-147.36042232999992, 60.30072663000004],
              [-147.34923255099991, 60.30170319200005],
              [-147.3434138659999, 60.29873281500005],
              [-147.34386145699992, 60.28510163000004],
              [-147.34780839799993, 60.27358633000006],
              [-147.3702693349999, 60.26284414300005],
              [-147.47272701699993, 60.22955963700008],
              [-147.49181067599991, 60.22882721600007],
              [-147.4948624339999, 60.23712799700007],
              [-147.49225826699993, 60.25259023600006],
              [-147.5009659499999, 60.25836823100008],
              [-147.49388587099992, 60.26312897300005],
              [-147.46784420499992, 60.26666901200008],
              [-147.45006262899992, 60.27228424700007],
              [-147.44456946499992, 60.273098049000055],
              [-147.4389542309999, 60.27334219000005],
              [-147.36603756399992, 60.29901764500005],
              [-147.36042232999992, 60.30072663000004],
            ],
          ],
          [
            [
              [-173.0643204419999, 60.64252350500004],
              [-173.0541886059999, 60.630560614000046],
              [-173.0529679029999, 60.623928127000056],
              [-173.05842037699992, 60.62128327000005],
              [-173.0687149729999, 60.624212958000044],
              [-173.1042374339999, 60.64484284100007],
              [-173.11359615799992, 60.65302155200004],
              [-173.11139889199993, 60.66421133000006],
              [-173.09369869699992, 60.67983633000006],
              [-173.07172604099992, 60.68622467700004],
              [-173.06244869699992, 60.67853424700007],
              [-173.06212317599991, 60.669623114000046],
              [-173.0604141919999, 60.65916575700004],
              [-173.06232662699992, 60.64789459800005],
              [-173.0643204419999, 60.64252350500004],
            ],
          ],
          [
            [
              [-146.82030575299993, 60.84169370900008],
              [-146.80643006499992, 60.85418601300006],
              [-146.7753097579999, 60.85709499700005],
              [-146.76137625599992, 60.86821061100005],
              [-146.7616196179999, 60.879249842000036],
              [-146.7387405849999, 60.87107057600008],
              [-146.7128514579999, 60.853251674000035],
              [-146.70406332599993, 60.839485677000084],
              [-146.7180085429999, 60.82839300400008],
              [-146.73471076599992, 60.814519733000054],
              [-146.7655795569999, 60.801955632000045],
              [-146.79680853599993, 60.80593887100008],
              [-146.81125463199993, 60.81828304900006],
              [-146.82030575299993, 60.84169370900008],
            ],
          ],
          [
            [
              [-147.0941462879999, 60.89793528900003],
              [-147.07823645699992, 60.89276764500005],
              [-147.07664954299992, 60.88690827000005],
              [-147.0831599599999, 60.87848541900007],
              [-147.1041153639999, 60.86615631700005],
              [-147.1396378249999, 60.85561758000006],
              [-147.1662491529999, 60.85492584800005],
              [-147.18268795499992, 60.85822174700007],
              [-147.19029700399992, 60.862982489000046],
              [-147.18537350199992, 60.86945221600007],
              [-147.18285071499992, 60.87571849200003],
              [-147.1894425119999, 60.87750885600008],
              [-147.2099503249999, 60.87641022300005],
              [-147.21637936099992, 60.87710195500006],
              [-147.22199459499993, 60.875433661000045],
              [-147.21959387899992, 60.87140534100007],
              [-147.2296443349999, 60.86782461100006],
              [-147.2537735669999, 60.86810944200005],
              [-147.3105362619999, 60.87445709800005],
              [-147.31891842399992, 60.87726471600007],
              [-147.3187149729999, 60.87962474200003],
              [-147.3104141919999, 60.88080475500004],
              [-147.3034561839999, 60.88271719000005],
              [-147.2987361319999, 60.88662344000005],
              [-147.29010982999992, 60.88930898600006],
              [-147.27741451699993, 60.88812897300005],
              [-147.26610266799992, 60.88922760600008],
              [-147.2562149729999, 60.89667389500005],
              [-147.24665279899992, 60.90180084800005],
              [-147.2331436839999, 60.90468984600005],
              [-147.2269180979999, 60.90680573100008],
              [-147.2152400379999, 60.90729401200008],
              [-147.21271725199992, 60.902044989000046],
              [-147.2175186839999, 60.89468008000006],
              [-147.21467037699992, 60.89248281500005],
              [-147.20555579299992, 60.89907461100006],
              [-147.19440670499992, 60.90424225500004],
              [-147.18097896999993, 60.90314362200007],
              [-147.17585201699993, 60.89996979400007],
              [-147.1800430979999, 60.89663320500006],
              [-147.1776423819999, 60.89435455900008],
              [-147.16803951699993, 60.89252350500004],
              [-147.14232337099992, 60.90916575700004],
              [-147.1365860669999, 60.908270575000074],
              [-147.1358943349999, 60.90131256700005],
              [-147.12706458199992, 60.902329820000034],
              [-147.11921139199993, 60.90566640800006],
              [-147.11969967399992, 60.898138739000046],
              [-147.1319473949999, 60.88768138200004],
              [-147.1581925119999, 60.87547435100004],
              [-147.1526993479999, 60.87352122600004],
              [-147.1315811839999, 60.87799713700008],
              [-147.12165279899992, 60.88178131700005],
              [-147.1122940749999, 60.884426174000055],
              [-147.1078181629999, 60.88735586100006],
              [-147.10220292899993, 60.897691148000035],
              [-147.09707597599993, 60.899644273000035],
              [-147.0941462879999, 60.89793528900003],
            ],
          ],
          [
            [
              [-165.94892330599993, 62.02952708500004],
              [-165.94697018099993, 62.02570221600007],
              [-165.94440670499992, 62.01797109600005],
              [-165.94782467399992, 62.01593659100007],
              [-165.95649166599992, 62.02008698100008],
              [-165.9634903639999, 62.02179596600007],
              [-165.96821041599992, 62.020697333000044],
              [-165.97394771999993, 62.018744208000044],
              [-165.98053951699993, 62.015611070000034],
              [-165.9857071609999, 62.01536692900004],
              [-165.9892471999999, 62.01797109600005],
              [-165.9982804029999, 62.01850006700005],
              [-166.00983639199993, 62.02293528900003],
              [-166.00873775899993, 62.03725820500006],
              [-165.9955948559999, 62.05426666900007],
              [-165.98289954299992, 62.06590403900003],
              [-165.97211666599992, 62.07217031500005],
              [-165.96605383999992, 62.070379950000074],
              [-165.9716690749999, 62.05951569200005],
              [-165.97618567599991, 62.044582424000055],
              [-165.96198482999992, 62.032904364000046],
              [-165.94892330599993, 62.02952708500004],
            ],
          ],
          [
            [
              [-168.0355118479999, 64.98529694200005],
              [-168.0276993479999, 64.97992584800005],
              [-168.02656002499992, 64.96808502800008],
              [-168.04841061099992, 64.95892975500004],
              [-168.0787247389999, 64.95685455900008],
              [-168.09675045499992, 64.96539948100008],
              [-168.08759518099993, 64.97882721600007],
              [-168.0655411449999, 64.98484935100004],
              [-168.0355118479999, 64.98529694200005],
            ],
          ],
          [
            [
              [-168.90790768099993, 65.76829661700003],
              [-168.90278072799993, 65.76154205900008],
              [-168.89960689999992, 65.74762604400007],
              [-168.90986080599993, 65.73956940300008],
              [-168.92621822799993, 65.73989492400005],
              [-168.9421280589999, 65.74371979400007],
              [-168.95173092399992, 65.75315989800004],
              [-168.94298255099991, 65.76471588700008],
              [-168.92011471299992, 65.76886627800008],
              [-168.90790768099993, 65.76829661700003],
            ],
          ],
          [
            [
              [-167.7770076159999, 65.77301666900007],
              [-167.75116939999992, 65.77676015800006],
              [-167.7382706369999, 65.77716705900008],
              [-167.74339758999992, 65.77252838700008],
              [-167.76044674399992, 65.76463450700004],
              [-167.7800186839999, 65.75958893400008],
              [-167.7940567699999, 65.75397370000007],
              [-167.8089493479999, 65.74551015800006],
              [-167.82721920499992, 65.73859284100007],
              [-167.84333248599992, 65.73777903900003],
              [-167.84870357999992, 65.74282461100006],
              [-167.83356686099992, 65.75287506700005],
              [-167.81940670499992, 65.75934479400007],
              [-167.7770076159999, 65.77301666900007],
            ],
          ],
          [
            [
              [-167.67096920499992, 65.79368724200003],
              [-167.56647701699993, 65.81663646000004],
              [-167.55646725199992, 65.81736888200004],
              [-167.57270260299993, 65.80923086100006],
              [-167.64728756399992, 65.79132721600007],
              [-167.6628311839999, 65.78204987200007],
              [-167.6595352859999, 65.77301666900007],
              [-167.63996334499993, 65.77342357000003],
              [-167.69542395699992, 65.74091217700004],
              [-167.71698971299992, 65.73822663000004],
              [-167.73053951699993, 65.74567291900007],
              [-167.7237442699999, 65.75812409100007],
              [-167.71943111899992, 65.76894765800006],
              [-167.7186173169999, 65.77781810100004],
              [-167.70323645699992, 65.78538646000004],
              [-167.67096920499992, 65.79368724200003],
            ],
          ],
          [
            [
              [-166.85948645699992, 66.03974030200004],
              [-166.83979244699992, 66.04360586100006],
              [-166.8358048169999, 66.04181549700007],
              [-166.8631485669999, 66.02798086100006],
              [-166.98717200399992, 65.98354726800005],
              [-167.02704830599993, 65.97467682500007],
              [-167.10883541599992, 65.94855377800008],
              [-167.12584387899992, 65.93988678600005],
              [-167.12360592399992, 65.93903229400007],
              [-167.1302384109999, 65.93659088700008],
              [-167.16490637899992, 65.93170807500007],
              [-167.21113033799992, 65.91274648600006],
              [-167.22602291599992, 65.90912506700005],
              [-167.23949133999992, 65.90924713700008],
              [-167.23204505099991, 65.91791413000004],
              [-166.8698624339999, 66.03607819200005],
              [-166.85948645699992, 66.03974030200004],
            ],
          ],
          [
            [
              [-166.28351803299992, 66.20062897300005],
              [-166.18708248599992, 66.21027252800008],
              [-166.22541256399992, 66.20184967700004],
              [-166.2498673169999, 66.19293854400007],
              [-166.27318274599992, 66.18683502800008],
              [-166.31354732999992, 66.18260325700004],
              [-166.38654537699992, 66.16071198100008],
              [-166.46886145699992, 66.14590078300006],
              [-166.48652096299992, 66.14028554900005],
              [-166.50470943899992, 66.13251373900005],
              [-166.54670162699992, 66.12274811400005],
              [-166.5970352859999, 66.10480377800008],
              [-166.6866348949999, 66.08478424700007],
              [-166.7331436839999, 66.06781647300005],
              [-166.80052649599992, 66.05149974200003],
              [-166.79539954299992, 66.05829498900005],
              [-166.76276607999992, 66.07119375200006],
              [-166.32221432199992, 66.19285716400003],
              [-166.28351803299992, 66.20062897300005],
            ],
          ],
          [
            [
              [-166.0885310539999, 66.25617096600007],
              [-166.05394446499992, 66.26203034100007],
              [-166.04181881399992, 66.25999583500004],
              [-166.0471085279999, 66.25482819200005],
              [-166.10309811099992, 66.23883698100008],
              [-166.12787838399993, 66.22581614800004],
              [-166.14740963399993, 66.22036367400005],
              [-166.1561173169999, 66.22626373900005],
              [-166.14740963399993, 66.23541901200008],
              [-166.12751217399992, 66.24380117400005],
              [-166.0885310539999, 66.25617096600007],
            ],
          ],
          [
            [
              [-165.86432857999992, 66.31688060100004],
              [-165.81464596299992, 66.32636139500005],
              [-165.81403561099992, 66.32245514500005],
              [-165.87315833199992, 66.30011627800008],
              [-165.8972061839999, 66.29413483300004],
              [-165.94367428299992, 66.27118561400005],
              [-165.96446692599991, 66.26447174700007],
              [-166.0103653639999, 66.25771719000005],
              [-166.0062149729999, 66.26691315300008],
              [-165.98298092399992, 66.28107330900008],
              [-165.97004146999993, 66.28668854400007],
              [-165.86432857999992, 66.31688060100004],
            ],
          ],
          [
            [
              [-165.48871822799993, 66.40900299700007],
              [-165.48969479099992, 66.40867747600004],
              [-165.49518795499992, 66.40639883000006],
              [-165.53376217399992, 66.39862702000005],
              [-165.60138912699992, 66.37665436400005],
              [-165.6263321609999, 66.37763092700004],
              [-165.6354874339999, 66.37449778900003],
              [-165.64765377499992, 66.36871979400007],
              [-165.68053137899992, 66.35932038000004],
              [-165.69774329299992, 66.35683828300006],
              [-165.7045792309999, 66.36172109600005],
              [-165.69086666599992, 66.37075429900005],
              [-165.48871822799993, 66.40900299700007],
            ],
          ],
          [
            [
              [-165.48871822799993, 66.40900299700007],
              [-165.4847712879999, 66.41030508000006],
              [-165.44831295499992, 66.41876862200007],
              [-165.4239395749999, 66.42133209900004],
              [-165.48871822799993, 66.40900299700007],
            ],
          ],
          [
            [
              [-165.34264075399992, 66.43671295800004],
              [-165.37836666599992, 66.42890045800004],
              [-165.38166256399992, 66.42568594000005],
              [-165.4230394829999, 66.42144899300007],
              [-165.34264075399992, 66.43671295800004],
            ],
          ],
          [
            [
              [-165.34264075399992, 66.43671295800004],
              [-165.3264054029999, 66.44025299700007],
              [-165.32270260299993, 66.44041575700004],
              [-165.34264075399992, 66.43671295800004],
            ],
          ],
          [
            [
              [-164.7633357409999, 66.54645416900007],
              [-164.75202389199993, 66.54547760600008],
              [-164.7459610669999, 66.54092031500005],
              [-164.75824947799993, 66.53803131700005],
              [-164.77122962099992, 66.53660716400003],
              [-164.77741451699993, 66.53449127800008],
              [-164.78315182199992, 66.53192780200004],
              [-164.79535885299993, 66.52912018400008],
              [-164.83161373599992, 66.52855052300004],
              [-164.8443497389999, 66.52472565300008],
              [-164.85045325399992, 66.51764557500007],
              [-164.85785885299993, 66.51141998900005],
              [-164.86213131399992, 66.50901927300004],
              [-164.8665665359999, 66.50702545800004],
              [-164.88292395699992, 66.50482819200005],
              [-164.92931067599991, 66.50482819200005],
              [-165.06261145699992, 66.47968170800004],
              [-165.12372799399992, 66.47793203300006],
              [-165.1409805979999, 66.47382233300004],
              [-165.18146725199992, 66.45856354400007],
              [-165.2620743479999, 66.44428131700005],
              [-165.3208496569999, 66.44058193700005],
              [-165.0420926989999, 66.49351805300006],
              [-164.7633357409999, 66.54645416900007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Canada',
        iso3: 'CAN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-95.1605692139999, 49.3694941210001],
              [-95.16033666999994, 49.31301178000005],
              [-95.16002661199985, 49.223353170000095],
              [-95.15966487699987, 49.10950999000006],
              [-95.15932897999997, 49.01178985600002],
              [-95.16188696299986, 49.00114451200004],
              [-95.16852738499995, 48.99504669300008],
              [-95.17710567299989, 48.992669577000115],
              [-95.39693721599991, 48.992669577000115],
              [-95.61671708199992, 48.992669577000115],
              [-95.83649694899995, 48.992669577000115],
              [-96.05632849199989, 48.992669577000115],
              [-96.27621171099992, 48.992669577000115],
              [-96.49599157699993, 48.992669577000115],
              [-96.71579728199987, 48.992669577000115],
              [-96.93560298799989, 48.992669577000115],
              [-97.1553828529999, 48.992669577000115],
              [-97.22608856599996, 48.992669577000115],
              [-97.37518855899992, 48.992669577000115],
              [-97.59499426299993, 48.992669577000115],
              [-97.81479996799987, 48.992669577000115],
              [-98.03460567199988, 48.992669577000115],
              [-98.25443721599993, 48.992669577000115],
              [-98.47419124399994, 48.992669577000115],
              [-98.69404862499997, 48.992669577000115],
              [-98.9138543299999, 48.992669577000115],
              [-99.13366003499992, 48.992669577000115],
              [-99.35349157699994, 48.992669577000115],
              [-99.57329728299996, 48.992669577000115],
              [-99.7931029869999, 48.992669577000115],
              [-100.01288285399991, 48.992669577000115],
              [-100.23266271999992, 48.992669577000115],
              [-100.45249426299995, 48.992669577000115],
              [-100.67227412999996, 48.992669577000115],
              [-100.8921056729999, 48.992669577000115],
              [-101.11188553899991, 48.992669577000115],
              [-101.33169124399984, 48.992669577000115],
              [-101.36433964699988, 48.992669577000115],
              [-101.55157446299988, 48.992669577000115],
              [-101.77138016799991, 48.992669577000115],
              [-101.99118587299992, 48.992669577000115],
              [-102.21093990099993, 48.992669577000115],
              [-102.43074560599986, 48.9926179000001],
              [-102.65057714899989, 48.9926179000001],
              [-102.87038285399991, 48.9926179000001],
              [-103.09024023499985, 48.9926179000001],
              [-103.31004593899988, 48.9926179000001],
              [-103.52985164399989, 48.9926179000001],
              [-103.74968318699992, 48.9926179000001],
              [-103.96948889199984, 48.9926179000001],
              [-104.04757444699989, 48.9926179000001],
              [-104.18924292099986, 48.9926179000001],
              [-104.40904862499988, 48.9926179000001],
              [-104.6288543299999, 48.9926179000001],
              [-104.84871171099994, 48.9926179000001],
              [-105.05750241899992, 48.99261789989612],
              [-105.28832312099988, 48.9926179000001],
              [-105.50815466299991, 48.9926179000001],
              [-105.72793452999993, 48.9926179000001],
              [-105.94774023499994, 48.9926179000001],
              [-106.16752010099987, 48.9926179000001],
              [-106.3873258059999, 48.9926179000001],
              [-106.60718318699992, 48.9926179000001],
              [-106.82698889299985, 48.9926179000001],
              [-107.04679459699987, 48.9926179000001],
              [-107.2666261389999, 48.9926179000001],
              [-107.48643184499991, 48.9926179000001],
              [-107.70623754999994, 48.9926179000001],
              [-107.92604325399986, 48.9926179000001],
              [-108.14579728199988, 48.9926179000001],
              [-108.3656288249999, 48.9926179000001],
              [-108.58543452999993, 48.9926179000001],
              [-108.80524023499994, 48.9926179000001],
              [-109.02504593999987, 48.9926179000001],
              [-109.2448516449999, 48.9926179000001],
              [-109.46470902599992, 48.9926179000001],
              [-109.68454056899986, 48.9926179000001],
              [-109.90426875899996, 48.9926179000001],
              [-109.99932108799989, 48.9926179000001],
              [-110.1241003009999, 48.9926179000001],
              [-110.34388016799991, 48.9926179000001],
              [-110.56371171199993, 48.9926179000001],
              [-110.78351741599995, 48.9926179000001],
              [-111.00332312099988, 48.9926179000001],
              [-111.22307714899989, 48.9926179000001],
              [-111.44288285399992, 48.9926179000001],
              [-111.66271439599986, 48.9926179000001],
              [-111.88257177799997, 48.9926179000001],
              [-112.1023774829999, 48.9926179000001],
              [-112.32218318799993, 48.9926179000001],
              [-112.54198889199985, 48.9926179000001],
              [-112.76182043499998, 48.992566223],
              [-112.9816261399999, 48.992514547000084],
              [-113.20138016799991, 48.992514547000084],
              [-113.42118587299993, 48.992514547000084],
              [-113.64104325499996, 48.992514547000084],
              [-113.8608747969999, 48.992514547000084],
              [-114.06384012799991, 48.992514547000084],
              [-114.08068050199992, 48.992514547000084],
              [-114.30048620699985, 48.992514547000084],
              [-114.52026607299986, 48.992514547000084],
              [-114.74009761599989, 48.992514547000084],
              [-114.95992915899991, 48.992514547000084],
              [-115.17965734999991, 48.992514547000084],
              [-115.39951473099987, 48.992514547000084],
              [-115.6193721119999, 48.992514547000084],
              [-115.8391261399999, 48.992514547000084],
              [-116.04816312499993, 48.992514547000084],
              [-116.05895768299993, 48.992514547000084],
              [-116.27876338799986, 48.992514547000084],
              [-116.49856909199988, 48.992514547000084],
              [-116.7183747969999, 48.992514547000084],
              [-116.93818050199992, 48.992514547000084],
              [-117.03815110299992, 48.992514547000084],
              [-117.15801204499986, 48.992514547000084],
              [-117.37786942599989, 48.992514547000084],
              [-117.59767513099992, 48.992514547000084],
              [-117.81742915899991, 48.992514547000084],
              [-118.03723486399994, 48.992514547000084],
              [-118.25706640699988, 48.992514547000084],
              [-118.4768721119999, 48.992514547000084],
              [-118.69667781599992, 48.992514547000084],
              [-118.91648352099993, 48.992514547000084],
              [-119.13621171099994, 48.992514547000084],
              [-119.35604325399987, 48.992514547000084],
              [-119.5758747969999, 48.992514547000084],
              [-119.79570633999992, 48.992514547000084],
              [-120.01551204499995, 48.992514547000084],
              [-120.23531774999988, 48.992514547000084],
              [-120.4551492929999, 48.992514547000084],
              [-120.67495499799993, 48.992514547000084],
              [-120.89470902599993, 48.992514547000084],
              [-121.11451472999995, 48.992514547000084],
              [-121.33432043499988, 48.992514547000084],
              [-121.55415197799991, 48.992514547000084],
              [-121.77395768299994, 48.992514547000084],
              [-121.99376338799995, 48.992514547000084],
              [-122.21351741599996, 48.992514547000084],
              [-122.4333747969999, 48.992514547000084],
              [-122.65325801699994, 48.992514547000084],
              [-122.75301682799991, 48.992514547000084],
              [-122.75951087099992, 49.001166083000044],
              [-122.78180904899995, 49.01732005400004],
              [-122.80357825399994, 49.01007721600007],
              [-122.82323157499991, 49.00698476800005],
              [-122.85301673099991, 49.01703522300005],
              [-122.87604732999989, 49.03652578300006],
              [-122.87559973899994, 49.054754950000074],
              [-122.86534583199995, 49.07005442900004],
              [-122.86774654899995, 49.08047109600005],
              [-122.88174394399994, 49.08649323100008],
              [-122.90660559799994, 49.088324286000045],
              [-122.93004309799994, 49.08685944200005],
              [-122.95128333199995, 49.08295319200005],
              [-123.03282630099994, 49.05060455900008],
              [-123.04857337099992, 49.035223700000074],
              [-123.04405676999994, 49.017279364000046],
              [-123.0320531889999, 48.99518463700008],
              [-123.03530839799993, 48.99249909100007],
              [-123.09050609499992, 48.992514547000084],
              [-123.09373938699991, 49.005113023000035],
              [-123.10049394399994, 49.021185614000046],
              [-123.10830644399994, 49.03367747600004],
              [-123.12462317599994, 49.04677969000005],
              [-123.13878333199995, 49.05377838700008],
              [-123.14297441299993, 49.06093984600005],
              [-123.12946529899995, 49.074652411000045],
              [-123.07567298099991, 49.10565827000005],
              [-123.0542699859999, 49.12323639500005],
              [-123.04067949099993, 49.15102773600006],
              [-123.08112545499989, 49.12836334800005],
              [-123.12340247299994, 49.11587148600006],
              [-123.16714433499993, 49.11562734600005],
              [-123.21198482999989, 49.12995026200008],
              [-123.21198482999989, 49.136704820000034],
              [-123.20010331899994, 49.148504950000074],
              [-123.20470130099994, 49.18984609600005],
              [-123.19831295499989, 49.20563385600008],
              [-123.17979895699995, 49.209865627000056],
              [-123.15697180899991, 49.20530833500004],
              [-123.13760331899994, 49.19570547100005],
              [-123.1433813139999, 49.207464911000045],
              [-123.1753637359999, 49.22370026200008],
              [-123.2110082669999, 49.23663971600007],
              [-123.2359106109999, 49.249986070000034],
              [-123.2468969389999, 49.274644273000035],
              [-123.21825110599991, 49.27920156500005],
              [-123.17528235599991, 49.276597398000035],
              [-123.14305579299992, 49.28009674700007],
              [-123.16193600199995, 49.299994208000044],
              [-123.15489661399994, 49.30853913000004],
              [-123.13853919199994, 49.309027411000045],
              [-123.12946529899995, 49.30491771000004],
              [-123.1233617829999, 49.29437897300005],
              [-123.10863196499992, 49.288763739000046],
              [-123.09044348899994, 49.28864166900007],
              [-123.07420813699991, 49.29437897300005],
              [-123.06737219999991, 49.287543036000045],
              [-123.05654863199993, 49.294256903000075],
              [-123.03941809799994, 49.29588450700004],
              [-123.02098548099991, 49.293402411000045],
              [-123.00649980399993, 49.287543036000045],
              [-122.96084550699993, 49.28188711100006],
              [-122.9219457669999, 49.29954661700003],
              [-122.89248613199993, 49.333685614000046],
              [-122.86266028599994, 49.40643952000005],
              [-122.8577367829999, 49.423529364000046],
              [-122.85570227799991, 49.44179922100005],
              [-122.85985266799992, 49.44985586100006],
              [-122.86904863199993, 49.456366278000075],
              [-122.87828528599994, 49.45734284100007],
              [-122.8823949859999, 49.44863515800006],
              [-122.87962805899991, 49.417181708000044],
              [-122.8823949859999, 49.40424225500004],
              [-122.93814042899993, 49.325832424000055],
              [-123.02065995999993, 49.30683014500005],
              [-123.21198482999989, 49.34275950700004],
              [-123.22842363199993, 49.343451239000046],
              [-123.27000891799992, 49.33535390800006],
              [-123.27660071499992, 49.351548570000034],
              [-123.28355872299994, 49.363348700000074],
              [-123.29393469999991, 49.37010325700004],
              [-123.28384355399993, 49.38255442900004],
              [-123.25645911399994, 49.396551825000074],
              [-123.24547278599994, 49.41107819200005],
              [-123.24107825399994, 49.42609284100007],
              [-123.24010169199994, 49.44155508000006],
              [-123.25218665299991, 49.511786200000074],
              [-123.25112870999993, 49.52285390800006],
              [-123.24010169199994, 49.55499909100007],
              [-123.22581946499992, 49.58470286700003],
              [-123.21816972599993, 49.59601471600007],
              [-123.22183183499993, 49.596909898000035],
              [-123.22472083199995, 49.596991278000075],
              [-123.22618567599994, 49.598537502000056],
              [-123.22565670499989, 49.60346100500004],
              [-123.21507727799991, 49.60993073100008],
              [-123.20689856699994, 49.62156810100004],
              [-123.2046606109999, 49.63580963700008],
              [-123.21198482999989, 49.650051174000055],
              [-123.1699926419999, 49.674994208000044],
              [-123.15396074099993, 49.69293854400007],
              [-123.17100989499994, 49.70526764500005],
              [-123.18814042899993, 49.69159577000005],
              [-123.20278886599993, 49.68227773600006],
              [-123.21507727799991, 49.67796458500004],
              [-123.22842363199993, 49.67487213700008],
              [-123.23924719999991, 49.66742584800005],
              [-123.24742591099994, 49.658270575000074],
              [-123.25291907499991, 49.650051174000055],
              [-123.24657141799992, 49.62555573100008],
              [-123.24547278599994, 49.61310455900008],
              [-123.24860592399995, 49.59780508000006],
              [-123.25641842399995, 49.593003648000035],
              [-123.26659094999991, 49.59137604400007],
              [-123.28726152299993, 49.58087799700007],
              [-123.31582597599993, 49.58258698100008],
              [-123.32803300699993, 49.58177317900004],
              [-123.33568274599992, 49.57664622600004],
              [-123.34898841099994, 49.56012604400007],
              [-123.35533606699994, 49.55508047100005],
              [-123.38060462099992, 49.558579820000034],
              [-123.39659583199995, 49.558294989000046],
              [-123.40379798099991, 49.551662502000056],
              [-123.4097387359999, 49.547756252000056],
              [-123.43822180899991, 49.536810614000046],
              [-123.44815019399994, 49.530910549000055],
              [-123.48949133999992, 49.51504140800006],
              [-123.50267493399991, 49.50543854400007],
              [-123.48570716099994, 49.49359772300005],
              [-123.49132239499994, 49.473089911000045],
              [-123.47321529899995, 49.43451569200005],
              [-123.48228919199994, 49.41421133000006],
              [-123.49986731699994, 49.39988841400009],
              [-123.51618404899995, 49.39166901200008],
              [-123.53355872299994, 49.38849518400008],
              [-123.55459550699993, 49.389960028000075],
              [-123.78111731699994, 49.46548086100006],
              [-123.8067113919999, 49.47052643400008],
              [-123.86522376199991, 49.47333405200004],
              [-123.8855688139999, 49.47728099200003],
              [-123.90343176999994, 49.48615143400008],
              [-123.91038977799991, 49.493801174000055],
              [-123.91421464799993, 49.500881252000056],
              [-123.91954505099994, 49.507473049000055],
              [-123.93077551999994, 49.51349518400008],
              [-123.94627844999991, 49.517564195000034],
              [-123.95571855399993, 49.518459377000056],
              [-123.96377519399994, 49.521144924000055],
              [-123.97545325399994, 49.530910549000055],
              [-123.99315344999991, 49.55023834800005],
              [-124.02696692599994, 49.60346100500004],
              [-124.03429114499994, 49.61115143400008],
              [-124.05313066299993, 49.62278880400004],
              [-124.06110592399995, 49.63080475500004],
              [-124.06607011599993, 49.64402903900009],
              [-124.06798255099994, 49.66233958500004],
              [-124.06383216099994, 49.67845286700003],
              [-124.05113684799994, 49.68545156500005],
              [-124.04430091099994, 49.69122955900008],
              [-124.02920488199993, 49.72044505400004],
              [-124.02013098899994, 49.73261139500005],
              [-124.00609290299991, 49.74079010600008],
              [-123.99006100199995, 49.74506256700005],
              [-123.95494544199994, 49.74689362200007],
              [-123.93927975199995, 49.74359772300005],
              [-123.93211829299992, 49.735663153000075],
              [-123.92788652299993, 49.72557200700004],
              [-123.92080644399994, 49.71580638200004],
              [-123.86925208199995, 49.67177969000005],
              [-123.8406469389999, 49.63812897300005],
              [-123.83511308499993, 49.63393789300005],
              [-123.82725989499994, 49.59520091400009],
              [-123.82835852799991, 49.58177317900004],
              [-123.81973222599993, 49.56704336100006],
              [-123.80508378799993, 49.528631903000075],
              [-123.79417883999992, 49.51349518400008],
              [-123.77708899599992, 49.50531647300005],
              [-123.7671606109999, 49.51316966400009],
              [-123.76032467399995, 49.52802155200004],
              [-123.75259355399993, 49.54075755400004],
              [-123.76341712099992, 49.55687083500004],
              [-123.77163652299993, 49.575425523000035],
              [-123.7722875639999, 49.59393952000005],
              [-123.7600805329999, 49.60968659100007],
              [-123.75096594999991, 49.61273834800005],
              [-123.71849524599992, 49.616522528000075],
              [-123.70889238199993, 49.62278880400004],
              [-123.70181230399993, 49.62946198100008],
              [-123.6936742829999, 49.634833075000074],
              [-123.6380102199999, 49.64109935100004],
              [-123.58975175699993, 49.653631903000075],
              [-123.55020097599993, 49.67487213700008],
              [-123.5335180329999, 49.70526764500005],
              [-123.66445878799993, 49.65615469000005],
              [-123.79454505099994, 49.64402903900009],
              [-123.80785071499992, 49.646918036000045],
              [-123.8120824859999, 49.66714101800005],
              [-123.82323157499991, 49.68317291900007],
              [-123.8836156889999, 49.73940664300005],
              [-123.91836503799993, 49.75625234600005],
              [-123.92760169199994, 49.76361725500004],
              [-123.93370520699995, 49.783270575000074],
              [-123.9226781889999, 49.79962799700007],
              [-123.88975989499994, 49.82880280200004],
              [-123.88182532499991, 49.847357489000046],
              [-123.88048255099994, 49.86542389500005],
              [-123.8836156889999, 49.90110911700003],
              [-123.89061438699991, 49.92145416900007],
              [-123.9075414699999, 49.930975653000075],
              [-123.9278051419999, 49.93646881700005],
              [-123.94497636599993, 49.94489166900007],
              [-123.95787512899994, 49.96710846600007],
              [-123.95360266799992, 49.98969147300005],
              [-123.9356176419999, 50.00731028900009],
              [-123.89574133999992, 50.01752350500004],
              [-123.87808183499993, 50.03119538000004],
              [-123.86587480399993, 50.03424713700008],
              [-123.81997636599993, 50.03815338700008],
              [-123.80785071499992, 50.041083075000074],
              [-123.77196204299992, 50.07294342700004],
              [-123.75454667899993, 50.093736070000034],
              [-123.75633704299992, 50.103176174000055],
              [-123.7774145169999, 50.11163971600007],
              [-123.81480872299994, 50.14915599200003],
              [-123.82835852799991, 50.15839264500005],
              [-123.88756262899994, 50.18183014500005],
              [-123.92894446499992, 50.19049713700008],
              [-123.97061113199993, 50.21442291900007],
              [-123.9934789699999, 50.21979401200008],
              [-123.9844457669999, 50.20600006700005],
              [-123.9722387359999, 50.192694403000075],
              [-123.95848548099991, 50.18105703300006],
              [-123.94497636599993, 50.17206452000005],
              [-123.92471269399994, 50.164129950000074],
              [-123.88145911399994, 50.15375397300005],
              [-123.86245683499993, 50.14411041900007],
              [-123.85802161399994, 50.13934967700004],
              [-123.85057532499991, 50.12669505400004],
              [-123.84569251199991, 50.12051015800006],
              [-123.83714758999992, 50.11595286700003],
              [-123.81334387899994, 50.10781484600005],
              [-123.80785071499992, 50.103176174000055],
              [-123.81468665299991, 50.09031810100004],
              [-123.83315995999993, 50.075506903000075],
              [-123.86925208199995, 50.054754950000074],
              [-123.98110917899993, 50.02138906500005],
              [-123.99315344999991, 50.01080963700008],
              [-123.99962317599994, 49.99331289300005],
              [-124.0000707669999, 49.97361888200004],
              [-123.99624589799993, 49.95302969000005],
              [-123.98900305899991, 49.93378327000005],
              [-123.97911536399994, 49.91815827000005],
              [-123.96190344999991, 49.903998114000046],
              [-123.9260961579999, 49.88617584800005],
              [-123.91087805899991, 49.86977773600006],
              [-123.91787675699993, 49.861395575000074],
              [-123.92992102799991, 49.83844635600008],
              [-123.93822180899991, 49.82880280200004],
              [-123.96344967399995, 49.81671784100007],
              [-123.96548417899993, 49.81513092700004],
              [-123.97069251199991, 49.81281159100007],
              [-123.97398841099994, 49.81069570500006],
              [-123.97817949099993, 49.809027411000045],
              [-123.98595130099994, 49.808294989000046],
              [-124.00112870999993, 49.811835028000075],
              [-124.00853430899991, 49.82062409100007],
              [-124.01329505099994, 49.84243398600006],
              [-124.01349850199995, 49.84813060100004],
              [-124.01170813699991, 49.850897528000075],
              [-124.01065019399994, 49.854681708000044],
              [-124.01329505099994, 49.86359284100007],
              [-124.01707923099991, 49.86863841400009],
              [-124.02912350199995, 49.878241278000075],
              [-124.03441321499992, 49.88344961100006],
              [-124.02562415299991, 49.89398834800005],
              [-124.02041581899994, 49.90778229400007],
              [-124.0230199859999, 49.91986725500004],
              [-124.03746497299994, 49.924994208000044],
              [-124.0452367829999, 49.91742584800005],
              [-124.07477779899995, 49.86977773600006],
              [-124.06407630099994, 49.86359284100007],
              [-124.05272376199991, 49.85224030200004],
              [-124.0481664699999, 49.841131903000075],
              [-124.05768795499989, 49.83624909100007],
              [-124.07298743399991, 49.83494700700004],
              [-124.08495032499991, 49.830511786000045],
              [-124.08922278599994, 49.821926174000055],
              [-124.0816137359999, 49.808294989000046],
              [-124.10216223899994, 49.798163153000075],
              [-124.14781653599994, 49.784369208000044],
              [-124.17096920499989, 49.78099192900004],
              [-124.24966386599993, 49.78099192900004],
              [-124.27399654899995, 49.77415599200003],
              [-124.26748613199993, 49.751654364000046],
              [-124.28302975199989, 49.74656810100004],
              [-124.3042699859999, 49.75267161700003],
              [-124.32721920499989, 49.77435944200005],
              [-124.3550512359999, 49.77448151200008],
              [-124.40371660099993, 49.76732005400004],
              [-124.43028723899994, 49.771551825000074],
              [-124.47760982999989, 49.790350653000075],
              [-124.5132543609999, 49.79751211100006],
              [-124.5208227199999, 49.80483633000006],
              [-124.52554277299993, 49.81484609600005],
              [-124.52847245999993, 49.83771393400008],
              [-124.53221594999991, 49.84438711100006],
              [-124.58311926999994, 49.882473049000055],
              [-124.6055395169999, 49.89325592700004],
              [-124.62686113199993, 49.897650458000044],
              [-124.63491777299993, 49.902004299000055],
              [-124.6497289699999, 49.92072174700007],
              [-124.66100012899994, 49.924994208000044],
              [-124.67544511599993, 49.92715078300006],
              [-124.73216712099992, 49.954291083000044],
              [-124.76439368399991, 49.97736237200007],
              [-124.82209225199989, 50.04010651200008],
              [-124.8289281889999, 50.054754950000074],
              [-124.8203832669999, 50.071478583000044],
              [-124.80093339799993, 50.062201239000046],
              [-124.77916419199994, 50.044134833000044],
              [-124.76341712099992, 50.03424713700008],
              [-124.74242102799991, 50.027777411000045],
              [-124.70376542899993, 49.99689362200007],
              [-124.6848852199999, 49.98647695500006],
              [-124.70189368399991, 50.02317942900004],
              [-124.70445716099994, 50.04096100500004],
              [-124.68858801999994, 50.048529364000046],
              [-124.68301347599993, 50.05247630400004],
              [-124.67690995999993, 50.06191640800006],
              [-124.67251542899993, 50.07318756700005],
              [-124.67186438699991, 50.08270905200004],
              [-124.67739824099993, 50.08885325700004],
              [-124.7053930329999, 50.103176174000055],
              [-124.69334876199991, 50.11440664300005],
              [-124.67642167899993, 50.119574286000045],
              [-124.66563880099994, 50.12677643400008],
              [-124.67186438699991, 50.14411041900007],
              [-124.64883378799993, 50.15257396000004],
              [-124.62832597599993, 50.16937897300005],
              [-124.6175024079999, 50.18891022300005],
              [-124.62340247299994, 50.20555247600004],
              [-124.60521399599992, 50.232855536000045],
              [-124.60293535099993, 50.240301825000074],
              [-124.60789954299992, 50.25063711100006],
              [-124.62621008999992, 50.26593659100007],
              [-124.63023841099994, 50.27789948100008],
              [-124.63988196499992, 50.293850002000056],
              [-124.6621801419999, 50.30418528900009],
              [-124.68732662699989, 50.312567450000074],
              [-124.7053930329999, 50.322251695000034],
              [-124.71344967399995, 50.331366278000075],
              [-124.71153723899994, 50.33372630400004],
              [-124.70327714799993, 50.33539459800005],
              [-124.67747962099992, 50.354681708000044],
              [-124.67332923099991, 50.361029364000046],
              [-124.67186438699991, 50.37376536700003],
              [-124.65982011599993, 50.39207591400009],
              [-124.63182532499991, 50.40180084800005],
              [-124.59972083199995, 50.40521881700005],
              [-124.57567298099991, 50.40477122600004],
              [-124.54596920499989, 50.39704010600008],
              [-124.53404700399994, 50.397365627000056],
              [-124.52379309799994, 50.40192291900007],
              [-124.50625566299993, 50.416083075000074],
              [-124.49620520699995, 50.41909414300005],
              [-124.47655188699991, 50.42177969000005],
              [-124.4292699859999, 50.43724192900004],
              [-124.41120357999989, 50.445746161000045],
              [-124.3567602199999, 50.48615143400008],
              [-124.34850012899994, 50.497259833000044],
              [-124.35899817599994, 50.50926341400009],
              [-124.38296464799993, 50.49787018400008],
              [-124.42479407499991, 50.46625397300005],
              [-124.50426184799994, 50.43846263200004],
              [-124.58926347599993, 50.42527903900009],
              [-124.67198645699995, 50.430853583000044],
              [-124.6848852199999, 50.42218659100007],
              [-124.69351152299993, 50.40224844000005],
              [-124.73151607999989, 50.37103913000004],
              [-124.74010169199994, 50.36009349200003],
              [-124.74990800699993, 50.35211823100008],
              [-124.80842037699989, 50.322251695000034],
              [-124.8301488919999, 50.317613023000035],
              [-124.85220292899993, 50.32046133000006],
              [-124.87466386599993, 50.32562897300005],
              [-124.8977758449999, 50.32843659100007],
              [-124.94127356699994, 50.32599518400008],
              [-124.95177161399994, 50.32843659100007],
              [-124.96271725199989, 50.34076569200005],
              [-124.95885169199994, 50.34951406500005],
              [-124.94985917899993, 50.35822174700007],
              [-124.94554602799991, 50.37067291900007],
              [-124.95213782499991, 50.391791083000044],
              [-124.96670488199993, 50.41242096600007],
              [-124.98599199099993, 50.42755768400008],
              [-125.00698808499993, 50.43211497600004],
              [-124.99767005099994, 50.41111888200004],
              [-124.9905492829999, 50.38385651200008],
              [-124.99518795499989, 50.36029694200005],
              [-125.03856360599991, 50.34174225500004],
              [-125.06167558499993, 50.32758209800005],
              [-125.08153235599991, 50.32469310100004],
              [-125.08897864499994, 50.35016510600008],
              [-125.0855199859999, 50.36383698100008],
              [-125.07835852799991, 50.367621161000045],
              [-125.0696508449999, 50.36937083500004],
              [-125.06163489499994, 50.37689850500004],
              [-125.06554114499994, 50.41063060100004],
              [-125.06505286399994, 50.415350653000075],
              [-125.06851152299993, 50.42422109600005],
              [-125.06688391799992, 50.43451569200005],
              [-125.06354732999989, 50.44546133000006],
              [-125.06065833199995, 50.46979401200008],
              [-125.0574438139999, 50.47728099200003],
              [-125.05125891799992, 50.48183828300006],
              [-125.04173743399991, 50.486761786000045],
              [-124.97044837099992, 50.500881252000056],
              [-124.95921790299991, 50.510646877000056],
              [-124.95299231699994, 50.537176825000074],
              [-124.9368383449999, 50.54726797100005],
              [-124.89098059799994, 50.55499909100007],
              [-124.88581295499989, 50.55931224200003],
              [-124.8731176419999, 50.57636139500005],
              [-124.86986243399991, 50.58295319200005],
              [-124.8704320949999, 50.589056708000044],
              [-124.87425696499992, 50.60781484600005],
              [-124.87328040299991, 50.61367422100005],
              [-124.8655492829999, 50.62986888200004],
              [-124.86400305899991, 50.67161692900004],
              [-124.85619055899991, 50.69281647300005],
              [-124.8289281889999, 50.71971263200004],
              [-124.82363847599993, 50.73452383000006],
              [-124.83568274599992, 50.75421784100007],
              [-124.89610755099994, 50.77358633000006],
              [-124.90636145699995, 50.778550523000035],
              [-124.91079667899993, 50.78465403900009],
              [-124.9104711579999, 50.79360586100006],
              [-124.90855872299994, 50.79755280200004],
              [-124.88540605399993, 50.81907786700003],
              [-124.86318925699993, 50.831284898000035],
              [-124.85277258999992, 50.839911200000074],
              [-124.82506262899994, 50.86969635600008],
              [-124.8089086579999, 50.87962474200003],
              [-124.78726152299993, 50.88458893400008],
              [-124.80345618399991, 50.91551341400009],
              [-124.81383216099994, 50.92719147300005],
              [-124.8323461579999, 50.93178945500006],
              [-124.84886633999992, 50.931341864000046],
              [-124.86058508999992, 50.927435614000046],
              [-124.86754309799994, 50.91640859600005],
              [-124.86986243399991, 50.894517320000034],
              [-124.87706458199995, 50.88422272300005],
              [-124.9182836579999, 50.84365469000005],
              [-124.93529212099992, 50.83437734600005],
              [-124.97130286399994, 50.820379950000074],
              [-124.98648027299993, 50.808254299000055],
              [-124.96642005099994, 50.80337148600006],
              [-124.95616614499994, 50.79873281500005],
              [-124.95177161399994, 50.79181549700007],
              [-124.95030676999994, 50.76544830900008],
              [-124.94863847599993, 50.761053778000075],
              [-124.92813066299993, 50.75800202000005],
              [-124.90933183499993, 50.749212958000044],
              [-124.90001380099994, 50.735256252000056],
              [-124.91307532499991, 50.70587799700007],
              [-124.92365475199989, 50.66974518400008],
              [-124.9251195949999, 50.65802643400008],
              [-124.9182836579999, 50.644598700000074],
              [-124.90929114499994, 50.63662344000005],
              [-124.90819251199991, 50.627386786000045],
              [-124.93370520699995, 50.60150788000004],
              [-124.93960527299993, 50.59796784100007],
              [-124.94863847599993, 50.59662506700005],
              [-124.95128333199995, 50.59833405200004],
              [-124.95250403599994, 50.60195547100005],
              [-124.95445716099994, 50.60447825700004],
              [-124.95921790299991, 50.60346100500004],
              [-124.96312415299991, 50.59951406500005],
              [-124.96666419199994, 50.59080638200004],
              [-125.02749589799993, 50.55874258000006],
              [-125.04039466099994, 50.53119538000004],
              [-125.10216223899994, 50.498928127000056],
              [-125.12368730399993, 50.47370026200008],
              [-125.11241614499994, 50.454413153000075],
              [-125.12783769399994, 50.43699778900009],
              [-125.15485592399995, 50.42438385600008],
              [-125.17833411399994, 50.41909414300005],
              [-125.19688880099994, 50.42055898600006],
              [-125.20815995999993, 50.42670319200005],
              [-125.22671464799993, 50.45258209800005],
              [-125.24266516799992, 50.46653880400004],
              [-125.24722245999993, 50.47370026200008],
              [-125.24649003799993, 50.480902411000045],
              [-125.2417699859999, 50.48822663000004],
              [-125.23888098899994, 50.49591705900008],
              [-125.24351966099994, 50.50409577000005],
              [-125.25572669199994, 50.50665924700007],
              [-125.26707923099991, 50.49819570500006],
              [-125.28477942599994, 50.47650788000004],
              [-125.29869544199994, 50.46662018400008],
              [-125.30467688699991, 50.46670156500005],
              [-125.31094316299993, 50.47093333500004],
              [-125.32542883999992, 50.47370026200008],
              [-125.34215247299994, 50.48924388200004],
              [-125.34756425699993, 50.52024974200003],
              [-125.35667883999992, 50.54311758000006],
              [-125.38438880099994, 50.53457265800006],
              [-125.38267981699994, 50.52610911700003],
              [-125.38548743399991, 50.51203034100007],
              [-125.39102128799993, 50.497259833000044],
              [-125.39745032499991, 50.486761786000045],
              [-125.4136449859999, 50.473863023000035],
              [-125.43224036399994, 50.466050523000035],
              [-125.51821855399993, 50.45563385600008],
              [-125.54409745999993, 50.45563385600008],
              [-125.5625707669999, 50.459418036000045],
              [-125.57705644399994, 50.470689195000034],
              [-125.57310950399994, 50.47825755400004],
              [-125.56029212099992, 50.48493073100008],
              [-125.54824785099993, 50.49355703300006],
              [-125.54124915299991, 50.50625234600005],
              [-125.52953040299991, 50.542303778000075],
              [-125.52843176999994, 50.55499909100007],
              [-125.53148352799991, 50.56468333500004],
              [-125.54002844999991, 50.58038971600007],
              [-125.54206295499989, 50.589178778000075],
              [-125.53457597599993, 50.61709219000005],
              [-125.5266820949999, 50.636053778000075],
              [-125.51744544199994, 50.65078359600005],
              [-125.50499426999994, 50.66242096600007],
              [-125.48741614499994, 50.672308661000045],
              [-125.4622289699999, 50.67987702000005],
              [-125.4527074859999, 50.68528880400004],
              [-125.4453832669999, 50.69163646000004],
              [-125.43297278599994, 50.70587799700007],
              [-125.42471269399994, 50.713324286000045],
              [-125.45457923099991, 50.720363674000055],
              [-125.47956295499989, 50.70697663000004],
              [-125.50381425699993, 50.68813711100006],
              [-125.53148352799991, 50.67853424700007],
              [-125.55557206899994, 50.66620514500005],
              [-125.56871497299994, 50.63816966400009],
              [-125.57091223899994, 50.60797760600008],
              [-125.5625707669999, 50.589178778000075],
              [-125.57241777299993, 50.57265859600005],
              [-125.57725989499994, 50.55219147300005],
              [-125.58568274599992, 50.53497955900008],
              [-125.62230383999992, 50.52240631700005],
              [-125.6218969389999, 50.51072825700004],
              [-125.6148168609999, 50.49909088700008],
              [-125.61034094999991, 50.49355703300006],
              [-125.61318925699993, 50.47919342700004],
              [-125.61774654899995, 50.47125885600008],
              [-125.63390051999994, 50.45600006700005],
              [-125.6438695949999, 50.448431708000044],
              [-125.65664628799993, 50.44285716400009],
              [-125.6702367829999, 50.439439195000034],
              [-125.70327714799993, 50.437933661000045],
              [-125.70954342399995, 50.43992747600004],
              [-125.72020423099991, 50.445746161000045],
              [-125.77358964799993, 50.487982489000046],
              [-125.79527747299994, 50.49355703300006],
              [-125.78571529899995, 50.50625234600005],
              [-125.7522680329999, 50.50873444200005],
              [-125.74006100199989, 50.52024974200003],
              [-125.78722083199995, 50.53164297100005],
              [-125.81407630099994, 50.53314850500004],
              [-125.8362524079999, 50.52765534100007],
              [-125.84235592399995, 50.52240631700005],
              [-125.85435950399994, 50.507473049000055],
              [-125.8635961579999, 50.50096263200004],
              [-125.95457923099991, 50.47573476800005],
              [-126.00772050699993, 50.47150299700007],
              [-126.05736243399991, 50.478501695000034],
              [-126.08950761599993, 50.50096263200004],
              [-126.11115475199989, 50.491400458000044],
              [-126.13121497299994, 50.48973216400009],
              [-126.2422582669999, 50.50104401200008],
              [-126.26081295499989, 50.50722890800006],
              [-126.28062903599994, 50.51943594000005],
              [-126.27603105399993, 50.525091864000046],
              [-126.25959225199989, 50.52960846600007],
              [-126.24376380099994, 50.538275458000044],
              [-126.22777258999992, 50.54433828300006],
              [-126.20921790299991, 50.538275458000044],
              [-126.17886308499993, 50.52024974200003],
              [-126.18565833199995, 50.54877350500004],
              [-126.18529212099992, 50.563666083000044],
              [-126.17886308499993, 50.575506903000075],
              [-126.17162024599992, 50.57794830900008],
              [-126.13792883999992, 50.58295319200005],
              [-126.11473548099991, 50.593736070000034],
              [-126.10374915299991, 50.59662506700005],
              [-126.09715735599991, 50.59520091400009],
              [-126.09166419199994, 50.59129466400009],
              [-126.08629309799994, 50.589178778000075],
              [-126.0628149079999, 50.60346100500004],
              [-125.97752844999991, 50.61322663000004],
              [-125.95811926999994, 50.61831289300005],
              [-125.93862870999993, 50.630113023000035],
              [-125.95986894399994, 50.64557526200008],
              [-125.98534094999991, 50.643866278000075],
              [-126.03490149599992, 50.630113023000035],
              [-126.06236731699994, 50.62726471600007],
              [-126.13170325399994, 50.60346100500004],
              [-126.16030839799993, 50.597723700000074],
              [-126.24376380099994, 50.59662506700005],
              [-126.25182044199994, 50.600897528000075],
              [-126.26480058499993, 50.61961497600004],
              [-126.27163652299993, 50.623928127000056],
              [-126.27725175699993, 50.625881252000056],
              [-126.26895097599993, 50.63027578300006],
              [-126.24714107999989, 50.63751862200007],
              [-126.22154700399994, 50.642645575000074],
              [-126.11880449099993, 50.64679596600007],
              [-126.04849199099993, 50.66486237200007],
              [-126.01870683499993, 50.666001695000034],
              [-125.93895423099991, 50.65184153900009],
              [-125.91445878799993, 50.65403880400004],
              [-125.82640540299991, 50.677069403000075],
              [-125.7503149079999, 50.68528880400004],
              [-125.74156653599994, 50.68427155200004],
              [-125.72704016799992, 50.67959219000005],
              [-125.71646074099993, 50.67853424700007],
              [-125.70563717399995, 50.681708075000074],
              [-125.69912675699993, 50.68939850500004],
              [-125.68358313699991, 50.725816148000035],
              [-125.67870032499991, 50.733587958000044],
              [-125.67178300699993, 50.739935614000046],
              [-125.65859941299993, 50.74567291900007],
              [-125.63194739499994, 50.75096263200004],
              [-125.62022864499994, 50.75771719000005],
              [-125.60814368399991, 50.780910549000055],
              [-125.61998450399994, 50.79905833500004],
              [-125.63971920499989, 50.81622955900008],
              [-125.65127519399994, 50.83616771000004],
              [-125.64541581899994, 50.85492584800005],
              [-125.62783769399994, 50.86269765800006],
              [-125.55968176999994, 50.86562734600005],
              [-125.55003821499992, 50.87327708500004],
              [-125.54548092399995, 50.88808828300006],
              [-125.53457597599993, 50.91193268400008],
              [-125.52725175699993, 50.91852448100008],
              [-125.51891028599994, 50.92169830900008],
              [-125.51162675699993, 50.92682526200008],
              [-125.50731360599991, 50.93919505400004],
              [-125.50796464799993, 50.95066966400009],
              [-125.51211503799993, 50.96084219000005],
              [-125.51817786399994, 50.96942780200004],
              [-125.5247289699999, 50.97646719000005],
              [-125.53831946499992, 50.99494049700007],
              [-125.5625707669999, 51.05532461100006],
              [-125.57754472599993, 51.072333075000074],
              [-125.6370336579999, 51.10370514500005],
              [-125.6350805329999, 51.08002350500004],
              [-125.63076738199993, 51.06268952000005],
              [-125.61034094999991, 51.014960028000075],
              [-125.58299719999991, 50.96653880400004],
              [-125.57323157499991, 50.95848216400009],
              [-125.55040442599994, 50.946966864000046],
              [-125.54206295499989, 50.93919505400004],
              [-125.5574438139999, 50.91982656500005],
              [-125.57559160099993, 50.90717194200005],
              [-125.59829667899993, 50.90033600500004],
              [-125.62734941299993, 50.89826080900008],
              [-125.63878333199995, 50.89524974200003],
              [-125.65444902299993, 50.888006903000075],
              [-125.66958574099993, 50.87885163000004],
              [-125.6792699859999, 50.870306708000044],
              [-125.68219967399995, 50.86078522300005],
              [-125.68496660099993, 50.84430573100008],
              [-125.68565833199995, 50.82880280200004],
              [-125.68228105399993, 50.821926174000055],
              [-125.6504613919999, 50.80451080900008],
              [-125.64443925699993, 50.79865143400008],
              [-125.64769446499992, 50.782416083000044],
              [-125.65648352799991, 50.77789948100008],
              [-125.66954505099994, 50.777777411000045],
              [-125.68541419199994, 50.774725653000075],
              [-125.70881100199989, 50.75820547100005],
              [-125.7434789699999, 50.717230536000045],
              [-125.76740475199989, 50.70648834800005],
              [-125.76740475199989, 50.713324286000045],
              [-125.87962805899991, 50.70913320500006],
              [-125.89769446499992, 50.69586823100008],
              [-125.90485592399995, 50.68919505400004],
              [-125.92125403599994, 50.684881903000075],
              [-125.9397680329999, 50.68341705900008],
              [-125.95295162699989, 50.68528880400004],
              [-125.96617591099994, 50.69611237200007],
              [-125.97411048099991, 50.70770905200004],
              [-125.98509680899991, 50.71507396000004],
              [-126.00755774599992, 50.713324286000045],
              [-126.02013098899994, 50.70718008000006],
              [-126.04662024599992, 50.689113674000055],
              [-126.05907141799992, 50.68528880400004],
              [-126.18663489499994, 50.671861070000034],
              [-126.21226966099994, 50.675116278000075],
              [-126.22667395699995, 50.69281647300005],
              [-126.21007239499994, 50.709418036000045],
              [-126.16763261599993, 50.71820709800005],
              [-126.14785722599993, 50.73037344000005],
              [-126.12584387899994, 50.748480536000045],
              [-126.05532792899993, 50.774725653000075],
              [-126.03123938699991, 50.78937409100007],
              [-126.03453528599994, 50.79511139500005],
              [-126.07990475199989, 50.79515208500004],
              [-126.10399329299992, 50.78986237200007],
              [-126.12734941299993, 50.77993398600006],
              [-126.15184485599991, 50.77399323100008],
              [-126.17886308499993, 50.780951239000046],
              [-126.19644120999993, 50.79800039300005],
              [-126.19448808499993, 50.81464264500005],
              [-126.18472245999993, 50.83258698100008],
              [-126.17886308499993, 50.853216864000046],
              [-126.18382727799991, 50.86786530200004],
              [-126.1966039699999, 50.86147695500006],
              [-126.21397864499994, 50.84845612200007],
              [-126.23289954299992, 50.84365469000005],
              [-126.23818925699993, 50.84760163000004],
              [-126.2395727199999, 50.85398997600004],
              [-126.23936926999994, 50.860256252000056],
              [-126.24034583199995, 50.86347077000005],
              [-126.25438391799992, 50.86395905200004],
              [-126.25462805899991, 50.86347077000005],
              [-126.27013098899994, 50.86424388200004],
              [-126.31265214799993, 50.856634833000044],
              [-126.36465410099993, 50.85578034100007],
              [-126.38829505099994, 50.851996161000045],
              [-126.4597875639999, 50.821966864000046],
              [-126.48867753799993, 50.81671784100007],
              [-126.51121985599991, 50.82562897300005],
              [-126.5217992829999, 50.831732489000046],
              [-126.54735266799992, 50.83738841400009],
              [-126.55626380099994, 50.84365469000005],
              [-126.5593969389999, 50.85325755400004],
              [-126.55703691299993, 50.86871979400007],
              [-126.56240800699993, 50.87714264500005],
              [-126.54979407499991, 50.88857656500005],
              [-126.49893144399994, 50.92234935100004],
              [-126.4895727199999, 50.92084381700005],
              [-126.47996985599991, 50.91575755400004],
              [-126.4668676419999, 50.91193268400008],
              [-126.36070716099994, 50.904282945000034],
              [-126.31891842399995, 50.91421133000006],
              [-126.22325598899994, 50.90501536700003],
              [-126.20368404899995, 50.910223700000074],
              [-126.18415279899995, 50.92291901200008],
              [-126.17308508999992, 50.938788153000075],
              [-126.17886308499993, 50.95351797100005],
              [-126.19188391799992, 50.94953034100007],
              [-126.22667395699995, 50.93178945500006],
              [-126.24327551999994, 50.92812734600005],
              [-126.40542558499993, 50.93919505400004],
              [-126.45946204299992, 50.95172760600008],
              [-126.48350989499994, 50.96466705900008],
              [-126.50560462099992, 51.01154205900008],
              [-126.51488196499992, 51.06232330900008],
              [-126.51471920499989, 51.07636139500005],
              [-126.52147376199991, 51.07636139500005],
              [-126.54454505099994, 51.03164297100005],
              [-126.55215410099993, 51.005072333000044],
              [-126.54539954299992, 50.983587958000044],
              [-126.52684485599991, 50.95587799700007],
              [-126.53506425699993, 50.94171784100007],
              [-126.55272376199991, 50.931341864000046],
              [-126.56240800699993, 50.91498444200005],
              [-126.57542883999992, 50.90643952000005],
              [-126.67422441299993, 50.878159898000035],
              [-126.69619706899994, 50.87742747600004],
              [-126.71987870999993, 50.88182200700004],
              [-126.74742591099994, 50.89081452000005],
              [-126.74876868399991, 50.89740631700005],
              [-126.75694739499994, 50.90424225500004],
              [-126.76988684799994, 50.90973541900007],
              [-126.8040258449999, 50.913397528000075],
              [-126.81529700399994, 50.91779205900008],
              [-126.83307857999989, 50.93549225500004],
              [-126.84618079299992, 50.943426825000074],
              [-126.85855058499993, 50.94310130400004],
              [-126.86953691299993, 50.93813711100006],
              [-126.87840735599991, 50.93178945500006],
              [-126.88866126199991, 50.92023346600007],
              [-126.89220130099994, 50.91201406500005],
              [-126.89915930899991, 50.90692780200004],
              [-127.02721106699994, 50.90643952000005],
              [-127.05215410099993, 50.91498444200005],
              [-127.06456458199995, 50.92202383000006],
              [-127.0803930329999, 50.92690664300005],
              [-127.11115475199989, 50.93178945500006],
              [-127.13613847599993, 50.93081289300005],
              [-127.15172278599994, 50.93244049700007],
              [-127.16576087099992, 50.93919505400004],
              [-127.17418372299994, 50.92593008000006],
              [-127.1563207669999, 50.91510651200008],
              [-127.12857011599993, 50.90778229400007],
              [-127.08470618399991, 50.902044989000046],
              [-127.03392493399991, 50.888332424000055],
              [-127.00747636599993, 50.88458893400008],
              [-126.95348059799994, 50.88458893400008],
              [-126.93936113199993, 50.88141510600008],
              [-126.92601477799991, 50.876613674000055],
              [-126.92198645699995, 50.872259833000044],
              [-126.93614661399994, 50.870306708000044],
              [-126.95750891799992, 50.86351146000004],
              [-127.00121008999992, 50.83177317900004],
              [-127.0217992829999, 50.821926174000055],
              [-127.04234778599994, 50.82290273600006],
              [-127.06737219999991, 50.83075592700004],
              [-127.13097083199995, 50.866115627000056],
              [-127.21353105399993, 50.87714264500005],
              [-127.22374426999994, 50.88141510600008],
              [-127.2483617829999, 50.89826080900008],
              [-127.25511633999992, 50.91815827000005],
              [-127.26305091099994, 50.91868724200003],
              [-127.27790279899995, 50.913397528000075],
              [-127.28526770699995, 50.91193268400008],
              [-127.31037350199989, 50.91290924700007],
              [-127.32957923099991, 50.91575755400004],
              [-127.4290258449999, 50.94310130400004],
              [-127.44692949099993, 50.95351797100005],
              [-127.42625891799992, 50.96369049700007],
              [-127.41710364499994, 50.970404364000046],
              [-127.41588294199994, 50.97646719000005],
              [-127.42369544199994, 50.98322174700007],
              [-127.43285071499992, 50.98704661700003],
              [-127.44302324099993, 50.988267320000034],
              [-127.45376542899993, 50.98700592700004],
              [-127.44692949099993, 50.98700592700004],
              [-127.47321529899995, 50.984076239000046],
              [-127.50609290299991, 50.99103424700007],
              [-127.53075110599991, 51.00372955900008],
              [-127.53229732999989, 51.018011786000045],
              [-127.51878821499992, 51.04132721600007],
              [-127.50999915299991, 51.07078685100004],
              [-127.4995824859999, 51.095363674000055],
              [-127.48106848899994, 51.10370514500005],
              [-127.48106848899994, 51.10993073100008],
              [-127.50267493399991, 51.11977773600006],
              [-127.52696692599994, 51.116522528000075],
              [-127.55296790299991, 51.108303127000056],
              [-127.63463294199994, 51.09662506700005],
              [-127.66193600199989, 51.09747955900008],
              [-127.68651282499991, 51.10993073100008],
              [-127.68993079299992, 51.128973700000074],
              [-127.77700761599993, 51.167222398000035],
              [-127.7827856109999, 51.18622467700004],
              [-127.79393469999991, 51.19794342700004],
              [-127.7925512359999, 51.20880768400008],
              [-127.7879125639999, 51.22020091400009],
              [-127.78954016799992, 51.23338450700004],
              [-127.77017167899993, 51.24042389500005],
              [-127.75430253799993, 51.249701239000046],
              [-127.7363988919999, 51.257879950000074],
              [-127.62633216099994, 51.27533600500004],
              [-127.6077367829999, 51.285589911000045],
              [-127.57144120999993, 51.30060455900008],
              [-127.41588294199994, 51.28925202000005],
              [-127.40562903599994, 51.28725820500006],
              [-127.38731848899994, 51.27781810100004],
              [-127.37804114499994, 51.275051174000055],
              [-127.2210180329999, 51.28925202000005],
              [-127.17943274599992, 51.30914948100008],
              [-127.14586341099994, 51.31928131700005],
              [-127.13849850199989, 51.32282135600008],
              [-127.12661699099993, 51.33881256700005],
              [-127.11782792899993, 51.36041901200008],
              [-127.11412512899994, 51.382147528000075],
              [-127.11733964799993, 51.398504950000074],
              [-127.13267981699994, 51.38491445500006],
              [-127.16510982999989, 51.34479401200008],
              [-127.17601477799991, 51.33641185100004],
              [-127.20067298099991, 51.33152903900009],
              [-127.25576738199993, 51.30882396000004],
              [-127.28184973899994, 51.30231354400007],
              [-127.5152074859999, 51.31659577000005],
              [-127.5152074859999, 51.32282135600008],
              [-127.49356035099993, 51.33148834800005],
              [-127.47203528599994, 51.343003648000035],
              [-127.46434485599991, 51.353216864000046],
              [-127.48448645699995, 51.35757070500006],
              [-127.5137426419999, 51.353176174000055],
              [-127.56261145699995, 51.33392975500004],
              [-127.59032141799992, 51.32965729400007],
              [-127.6487524079999, 51.33624909100007],
              [-127.68032792899993, 51.33612702000005],
              [-127.70360266799992, 51.326239325000074],
              [-127.7215063139999, 51.32135651200008],
              [-127.75186113199993, 51.321926174000055],
              [-127.77965247299994, 51.33055247600004],
              [-127.78954016799992, 51.35008372600004],
              [-127.77843176999994, 51.364894924000055],
              [-127.7554418609999, 51.37807851800005],
              [-127.72887122299994, 51.38743724200003],
              [-127.7073461579999, 51.391058661000045],
              [-127.68016516799992, 51.392645575000074],
              [-127.66429602799991, 51.398138739000046],
              [-127.62120520699995, 51.443019924000055],
              [-127.60448157499991, 51.456244208000044],
              [-127.58495032499991, 51.464544989000046],
              [-127.55992591099994, 51.46743398600006],
              [-127.55186926999994, 51.47089264500005],
              [-127.55235755099994, 51.47919342700004],
              [-127.55479895699995, 51.489162502000056],
              [-127.5528051419999, 51.49750397300005],
              [-127.54238847599993, 51.50458405200004],
              [-127.53136145699995, 51.509466864000046],
              [-127.52171790299991, 51.516058661000045],
              [-127.5152074859999, 51.52826569200005],
              [-127.5149633449999, 51.54922109600005],
              [-127.5196020169999, 51.569525458000044],
              [-127.52122962099992, 51.589056708000044],
              [-127.51183020699995, 51.60736725500004],
              [-127.49201412699989, 51.62059153900009],
              [-127.46800696499992, 51.62840403900009],
              [-127.3157445949999, 51.65574778900009],
              [-127.04352779899995, 51.66860586100006],
              [-126.7092992829999, 51.644517320000034],
              [-126.67723548099991, 51.645738023000035],
              [-126.65526282499991, 51.655503648000035],
              [-126.65257727799991, 51.65989817900004],
              [-126.6516820949999, 51.66474030200004],
              [-126.65184485599991, 51.67536041900007],
              [-126.64818274599992, 51.67910390800006],
              [-126.63068600199989, 51.67719147300005],
              [-126.62450110599991, 51.67841217700004],
              [-126.6199438139999, 51.68695709800005],
              [-126.6165258449999, 51.69757721600007],
              [-126.61188717399995, 51.707464911000045],
              [-126.60342363199993, 51.71381256700005],
              [-126.63756262899994, 51.76162344000005],
              [-126.63805091099994, 51.77326080900008],
              [-126.6465551419999, 51.78359609600005],
              [-126.65758216099994, 51.79311758000006],
              [-126.66612708199995, 51.80255768400008],
              [-126.66429602799991, 51.79482656500005],
              [-126.66266842399995, 51.79157135600008],
              [-126.65868079299992, 51.788275458000044],
              [-126.66771399599992, 51.76642487200007],
              [-126.6609594389999, 51.74957916900007],
              [-126.64948482999989, 51.73505280200004],
              [-126.64439856699994, 51.720038153000075],
              [-126.64867102799991, 51.70661041900007],
              [-126.6565649079999, 51.70140208500004],
              [-126.6668188139999, 51.69879791900007],
              [-126.6785375639999, 51.692694403000075],
              [-126.69933020699995, 51.66543203300006],
              [-127.09552975199989, 51.70416901200008],
              [-127.25853430899991, 51.68585846600007],
              [-127.28498287699989, 51.69086334800005],
              [-127.32876542899993, 51.71133047100005],
              [-127.35008704299992, 51.71381256700005],
              [-127.35448157499991, 51.688666083000044],
              [-127.38560950399994, 51.67377350500004],
              [-127.42320716099994, 51.671861070000034],
              [-127.44692949099993, 51.68585846600007],
              [-127.44017493399991, 51.68842194200005],
              [-127.43687903599994, 51.69179922100005],
              [-127.4368383449999, 51.69391510600008],
              [-127.4395238919999, 51.692694403000075],
              [-127.43248450399994, 51.69757721600007],
              [-127.42935136599993, 51.70091380400004],
              [-127.42642167899993, 51.706366278000075],
              [-127.43268795499989, 51.706366278000075],
              [-127.43447831899994, 51.74591705900008],
              [-127.43268795499989, 51.754787502000056],
              [-127.42243404899995, 51.75971100500004],
              [-127.38658606699994, 51.767279364000046],
              [-127.37490800699993, 51.76850006700005],
              [-127.36237545499989, 51.78021881700005],
              [-127.33706620999993, 51.85716380400004],
              [-127.35008704299992, 51.87018463700008],
              [-127.36237545499989, 51.857082424000055],
              [-127.37604732999989, 51.83746979400007],
              [-127.38711503799993, 51.81635163000004],
              [-127.39171301999994, 51.79913971600007],
              [-127.3938695949999, 51.78375885600008],
              [-127.40029863199993, 51.77773672100005],
              [-127.44200598899994, 51.77513255400004],
              [-127.44908606699994, 51.777004299000055],
              [-127.45327714799993, 51.77456289300005],
              [-127.45995032499991, 51.76162344000005],
              [-127.47671464799993, 51.71344635600008],
              [-127.49266516799992, 51.69871653900009],
              [-127.52204342399995, 51.70331452000005],
              [-127.5503637359999, 51.71076080900008],
              [-127.58291581899994, 51.71185944200005],
              [-127.6160375639999, 51.70783112200007],
              [-127.64557857999989, 51.70014069200005],
              [-127.64557857999989, 51.692694403000075],
              [-127.6211645169999, 51.68927643400008],
              [-127.57420813699991, 51.67633698100008],
              [-127.54938717399995, 51.67226797100005],
              [-127.49893144399994, 51.67690664300005],
              [-127.47671464799993, 51.67519765800006],
              [-127.46743730399993, 51.66229889500005],
              [-127.47842363199993, 51.651556708000044],
              [-127.54564368399991, 51.63434479400007],
              [-127.55882727799991, 51.618841864000046],
              [-127.57510331899994, 51.58844635600008],
              [-127.59032141799992, 51.57664622600004],
              [-127.59032141799992, 51.569240627000056],
              [-127.57315019399994, 51.557928778000075],
              [-127.56700598899994, 51.54393138200004],
              [-127.5716039699999, 51.52814362200007],
              [-127.62271074099993, 51.478176174000055],
              [-127.64293372299994, 51.46515534100007],
              [-127.66637122299994, 51.45994700700004],
              [-127.71385657499991, 51.45774974200003],
              [-127.72813880099994, 51.45994700700004],
              [-127.75698808499993, 51.487982489000046],
              [-127.76162675699993, 51.49408600500004],
              [-127.74551347599993, 51.50531647300005],
              [-127.68065344999991, 51.505194403000075],
              [-127.65925045499989, 51.50836823100008],
              [-127.65925045499989, 51.51459381700005],
              [-127.67003333199995, 51.51829661700003],
              [-127.68643144399994, 51.529730536000045],
              [-127.70018469999991, 51.53506094000005],
              [-127.7180883449999, 51.536322333000044],
              [-127.79137122299994, 51.52692291900007],
              [-127.79637610599991, 51.52826569200005],
              [-127.80272376199991, 51.53766510600008],
              [-127.7991430329999, 51.54376862200007],
              [-127.79238847599993, 51.54897695500006],
              [-127.78954016799992, 51.555568752000056],
              [-127.79308020699995, 51.56720612200007],
              [-127.79800370999993, 51.57758209800005],
              [-127.80199133999992, 51.58901601800005],
              [-127.80260169199994, 51.603949286000045],
              [-127.82640540299991, 51.59870026200008],
              [-127.83311926999994, 51.608710028000075],
              [-127.8333227199999, 51.626654364000046],
              [-127.83739173099991, 51.644964911000045],
              [-127.85049394399994, 51.658270575000074],
              [-127.86363684799994, 51.66425202000005],
              [-127.87368730399993, 51.67340729400007],
              [-127.87767493399991, 51.696478583000044],
              [-127.87706458199995, 51.714829820000034],
              [-127.87425696499992, 51.72239817900004],
              [-127.86807206899994, 51.73029205900008],
              [-127.86489824099993, 51.73769765800006],
              [-127.8687231109999, 51.74408600500004],
              [-127.87462317599994, 51.75055573100008],
              [-127.87767493399991, 51.75820547100005],
              [-127.87767493399991, 51.785223700000074],
              [-127.87975012899994, 51.79214101800005],
              [-127.88927161399994, 51.80560944200005],
              [-127.89195716099994, 51.81622955900008],
              [-127.89012610599991, 51.821478583000044],
              [-127.87767493399991, 51.84357330900008],
              [-127.87901770699995, 51.84516022300005],
              [-127.88353430899991, 51.85639069200005],
              [-127.88451087099992, 51.860581773000035],
              [-127.88255774599992, 51.86554596600007],
              [-127.87816321499992, 51.86810944200005],
              [-127.87149003799993, 51.87018463700008],
              [-127.86693274599992, 51.88857656500005],
              [-127.8601781889999, 51.90648021000004],
              [-127.84959876199991, 51.92011139500005],
              [-127.81676184799994, 51.92983633000006],
              [-127.78221594999991, 51.94904205900008],
              [-127.76537024599992, 51.95343659100007],
              [-127.71178137899994, 51.948879299000055],
              [-127.68492591099994, 51.95001862200007],
              [-127.6660863919999, 51.95962148600006],
              [-127.67349199099993, 51.96702708500004],
              [-127.65916907499991, 51.99201080900008],
              [-127.64785722599993, 52.05703359600005],
              [-127.63809160099993, 52.08372630400004],
              [-127.61489824099993, 52.107489325000074],
              [-127.58263098899994, 52.127834377000056],
              [-127.54735266799992, 52.14325592700004],
              [-127.5152074859999, 52.152044989000046],
              [-127.49327551999994, 52.15387604400007],
              [-127.47704016799992, 52.15058014500005],
              [-127.46800696499992, 52.14118073100008],
              [-127.46743730399993, 52.124701239000046],
              [-127.47545325399994, 52.106634833000044],
              [-127.48912512899994, 52.09813060100004],
              [-127.50723222599993, 52.096136786000045],
              [-127.5657445949999, 52.100043036000045],
              [-127.57652747299994, 52.09369538000004],
              [-127.62441972599993, 52.028509833000044],
              [-127.59032141799992, 52.050116278000075],
              [-127.56065833199995, 52.077826239000046],
              [-127.54954993399991, 52.08226146000004],
              [-127.46532141799992, 52.08315664300005],
              [-127.4304906889999, 52.08881256700005],
              [-127.40534420499989, 52.10423411700003],
              [-127.4395238919999, 52.15131256700005],
              [-127.44322669199994, 52.15888092700004],
              [-127.44945227799991, 52.16315338700008],
              [-127.45368404899995, 52.17255280200004],
              [-127.45173092399995, 52.18187083500004],
              [-127.43980872299994, 52.18618398600006],
              [-127.41344153599994, 52.191066799000055],
              [-127.39834550699993, 52.19643789300005],
              [-127.39171301999994, 52.20327383000006],
              [-127.38145911399994, 52.21967194200005],
              [-127.35728919199994, 52.22919342700004],
              [-127.28359941299993, 52.23769765800006],
              [-127.2637426419999, 52.24603913000004],
              [-127.24624589799993, 52.25796133000006],
              [-127.18643144399994, 52.30931224200003],
              [-127.17259680899991, 52.316473700000074],
              [-127.14826412699989, 52.31903717700004],
              [-127.09508216099994, 52.31146881700005],
              [-127.04308020699995, 52.309759833000044],
              [-127.01976477799991, 52.30621979400007],
              [-126.9976293609999, 52.29751211100006],
              [-126.95742753799993, 52.26862213700008],
              [-126.94302324099993, 52.253119208000044],
              [-126.93724524599992, 52.23468659100007],
              [-126.94664466099994, 52.21283600500004],
              [-126.90770423099991, 52.17845286700003],
              [-126.77879798099991, 52.097642320000034],
              [-126.75426184799994, 52.07689036700003],
              [-126.74071204299992, 52.06976959800005],
              [-126.71068274599992, 52.04682038000004],
              [-126.69961503799993, 52.03534577000005],
              [-126.68101966099994, 52.00014883000006],
              [-126.67227128799993, 51.987494208000044],
              [-126.67202714799993, 52.011704820000034],
              [-126.66978919199994, 52.030951239000046],
              [-126.6721899079999, 52.04734935100004],
              [-126.68594316299993, 52.06268952000005],
              [-126.69635982999989, 52.067572333000044],
              [-126.70750891799992, 52.07143789300005],
              [-126.71646074099993, 52.07697174700007],
              [-126.72329667899993, 52.09511953300006],
              [-126.74132239499994, 52.11815013200004],
              [-126.75084387899994, 52.127834377000056],
              [-126.7925512359999, 52.153225002000056],
              [-126.88512122299994, 52.194525458000044],
              [-126.91250566299993, 52.22711823100008],
              [-126.90322831899994, 52.24518463700008],
              [-126.90257727799991, 52.257879950000074],
              [-126.90855872299994, 52.268866278000075],
              [-126.93004309799994, 52.293402411000045],
              [-126.93854732999989, 52.305853583000044],
              [-126.9390356109999, 52.32005442900004],
              [-126.92552649599992, 52.33698151200008],
              [-126.91763261599993, 52.34015534100007],
              [-126.88463294199994, 52.34442780200004],
              [-126.88027910099993, 52.347723700000074],
              [-126.87808183499993, 52.356350002000056],
              [-126.87466386599993, 52.35809967700004],
              [-126.85586503799993, 52.35716380400004],
              [-126.81411699099993, 52.36798737200007],
              [-126.77476966099994, 52.371161200000074],
              [-126.73375403599994, 52.371161200000074],
              [-126.75304114499994, 52.39337799700007],
              [-126.78506425699993, 52.39744700700004],
              [-126.91295325399994, 52.371975002000056],
              [-126.94102942599994, 52.36273834800005],
              [-126.96715247299994, 52.35065338700008],
              [-127.00230872299994, 52.33930084800005],
              [-127.04161536399994, 52.33783600500004],
              [-127.11733964799993, 52.35065338700008],
              [-127.12584387899994, 52.35114166900007],
              [-127.14403235599991, 52.349310614000046],
              [-127.15217037699989, 52.35065338700008],
              [-127.1590063139999, 52.355536200000074],
              [-127.1616918609999, 52.36123281500005],
              [-127.16295325399994, 52.36668528900003],
              [-127.16576087099992, 52.371161200000074],
              [-127.18968665299991, 52.387884833000044],
              [-127.1929418609999, 52.39874909100007],
              [-127.17943274599992, 52.412095445000034],
              [-127.19985917899993, 52.43939850500004],
              [-127.21043860599991, 52.44672272300005],
              [-127.21910559799994, 52.45026276200008],
              [-127.22496497299994, 52.45612213700008],
              [-127.2327367829999, 52.507879950000074],
              [-127.22765051999994, 52.52285390800006],
              [-127.19082597599993, 52.554754950000074],
              [-127.1712133449999, 52.568345445000034],
              [-127.14964758999992, 52.579413153000075],
              [-127.10903886599993, 52.58930084800005],
              [-127.0755102199999, 52.61513906500005],
              [-127.05589758999992, 52.624986070000034],
              [-127.00304114499994, 52.63361237200007],
              [-126.98232988199993, 52.64472077000005],
              [-126.97398841099994, 52.66937897300005],
              [-126.96597245999993, 52.685614325000074],
              [-126.93179277299993, 52.71283600500004],
              [-126.92552649599992, 52.73427969000005],
              [-126.93187415299991, 52.75287506700005],
              [-126.95518958199995, 52.788275458000044],
              [-126.9695531889999, 52.829413153000075],
              [-126.99168860599991, 52.843817450000074],
              [-127.0423070949999, 52.864569403000075],
              [-127.05101477799991, 52.87164948100008],
              [-127.05760657499991, 52.87832265800006],
              [-127.06505286399994, 52.883246161000045],
              [-127.07640540299991, 52.88507721600007],
              [-127.06090247299994, 52.859808661000045],
              [-127.01720130099994, 52.813666083000044],
              [-127.0012914699999, 52.78266022300005],
              [-127.00023352799991, 52.775458075000074],
              [-127.0012914699999, 52.751613674000055],
              [-126.99795488199993, 52.74746328300006],
              [-126.98350989499994, 52.73273346600007],
              [-126.98013261599993, 52.724310614000046],
              [-126.98688717399995, 52.71088288000004],
              [-127.05382239499994, 52.65302155200004],
              [-127.15217037699989, 52.611395575000074],
              [-127.21353105399993, 52.57379791900007],
              [-127.22337805899991, 52.56631094000005],
              [-127.24323482999989, 52.56134674700007],
              [-127.25865637899994, 52.55329010600008],
              [-127.25511633999992, 52.53620026200008],
              [-127.26927649599992, 52.52875397300005],
              [-127.27757727799991, 52.52220286700003],
              [-127.28184973899994, 52.51512278900003],
              [-127.27977454299992, 52.50364817900004],
              [-127.27281653599994, 52.49567291900007],
              [-127.26545162699989, 52.48969147300005],
              [-127.26195227799991, 52.484442450000074],
              [-127.2688695949999, 52.46898021000004],
              [-127.28551184799994, 52.459051825000074],
              [-127.4524633449999, 52.411769924000055],
              [-127.47362219999991, 52.38857656500005],
              [-127.49510657499991, 52.35883209800005],
              [-127.54222571499992, 52.341782945000034],
              [-127.58934485599991, 52.33087799700007],
              [-127.61082923099991, 52.319647528000075],
              [-127.61656653599994, 52.298529364000046],
              [-127.63141842399995, 52.29604726800005],
              [-127.65160071499992, 52.30133698100008],
              [-127.67349199099993, 52.30345286700003],
              [-127.69200598899994, 52.295803127000056],
              [-127.71007239499994, 52.28384023600006],
              [-127.73033606699994, 52.276271877000056],
              [-127.7554418609999, 52.28180573100008],
              [-127.75047766799992, 52.29197825700004],
              [-127.74767005099994, 52.31281159100007],
              [-127.74453691299993, 52.319647528000075],
              [-127.73574785099993, 52.32892487200007],
              [-127.71446692599994, 52.35809967700004],
              [-127.7366430329999, 52.354396877000056],
              [-127.75584876199991, 52.33930084800005],
              [-127.7827856109999, 52.30345286700003],
              [-127.7913305329999, 52.28693268400008],
              [-127.79491126199991, 52.27586497600004],
              [-127.79637610599991, 52.26471588700008],
              [-127.80052649599992, 52.256293036000045],
              [-127.81021074099993, 52.25039297100005],
              [-127.82135982999989, 52.24559153900003],
              [-127.82994544199994, 52.24079010600008],
              [-127.84732011599993, 52.22475820500006],
              [-127.86074785099993, 52.216009833000044],
              [-127.87242591099994, 52.21954987200007],
              [-127.88451087099992, 52.24079010600008],
              [-127.88597571499992, 52.25250885600008],
              [-127.8860570949999, 52.26601797100005],
              [-127.88980058499993, 52.27708567900004],
              [-127.91441809799994, 52.285142320000034],
              [-127.92332923099991, 52.29368724200003],
              [-127.92943274599992, 52.30499909100007],
              [-127.9329320949999, 52.316473700000074],
              [-127.92332923099991, 52.323553778000075],
              [-127.91885331899994, 52.33100006700005],
              [-127.91551673099991, 52.33901601800005],
              [-127.90933183499993, 52.34756094000005],
              [-127.89712480399993, 52.35443756700005],
              [-127.87071692599994, 52.354803778000075],
              [-127.85781816299993, 52.35809967700004],
              [-127.84748287699989, 52.37132396000004],
              [-127.85659745999993, 52.38507721600007],
              [-127.89195716099994, 52.412095445000034],
              [-127.9148656889999, 52.441107489000046],
              [-127.91869055899991, 52.45026276200008],
              [-127.91478430899991, 52.46442291900007],
              [-127.90550696499992, 52.472642320000034],
              [-127.89427649599992, 52.47915273600006],
              [-127.88451087099992, 52.48786041900007],
              [-127.87852942599994, 52.49506256700005],
              [-127.8726293609999, 52.50413646000004],
              [-127.87360592399995, 52.51190827000005],
              [-127.8882543609999, 52.51512278900003],
              [-127.89663652299993, 52.512152411000045],
              [-127.90916907499991, 52.49591705900008],
              [-127.91869055899991, 52.48786041900007],
              [-127.91466223899994, 52.479722398000035],
              [-127.91710364499994, 52.47089264500005],
              [-127.9221899079999, 52.46035390800006],
              [-127.92613684799994, 52.44684479400007],
              [-127.92520097599993, 52.432847398000035],
              [-127.91860917899993, 52.426947333000044],
              [-127.9090063139999, 52.42072174700007],
              [-127.89879309799994, 52.405910549000055],
              [-127.90257727799991, 52.38532135600008],
              [-127.92243404899995, 52.36225006700005],
              [-127.96768144399994, 52.322699286000045],
              [-128.00059973899994, 52.337103583000044],
              [-128.0159399079999, 52.34674713700008],
              [-128.02745520699995, 52.37596263200004],
              [-128.03941809799994, 52.38515859600005],
              [-128.05321204299992, 52.39350006700005],
              [-128.06387285099993, 52.405910549000055],
              [-128.0564672519999, 52.412095445000034],
              [-128.06655839799993, 52.449652411000045],
              [-128.05308997299994, 52.48517487200007],
              [-128.02330481699994, 52.51154205900008],
              [-127.98448645699995, 52.52195872600004],
              [-127.97158769399994, 52.518744208000044],
              [-127.96060136599993, 52.51166413000004],
              [-127.95225989499994, 52.50458405200004],
              [-127.94725501199991, 52.50153229400007],
              [-127.93423417899993, 52.505926825000074],
              [-127.93399003799993, 52.514553127000056],
              [-127.93846594999991, 52.52358633000006],
              [-127.93980872299994, 52.52944570500006],
              [-127.93024654899995, 52.535142320000034],
              [-127.90811113199993, 52.53856028900003],
              [-127.89879309799994, 52.54242584800005],
              [-127.8914281889999, 52.55093008000006],
              [-127.88581295499989, 52.561835028000075],
              [-127.87767493399991, 52.584051825000074],
              [-127.89557857999989, 52.578192450000074],
              [-127.9317113919999, 52.56049225500004],
              [-128.02818762899994, 52.54755280200004],
              [-128.04649817599994, 52.53937409100007],
              [-128.06236731699994, 52.524318752000056],
              [-128.07119706899994, 52.51780833500004],
              [-128.0803116529999, 52.51512278900003],
              [-128.09235592399995, 52.51325104400007],
              [-128.09752356699994, 52.50836823100008],
              [-128.10008704299992, 52.50177643400008],
              [-128.1042374339999, 52.49461497600004],
              [-128.1526586579999, 52.43256256700005],
              [-128.15660559799994, 52.424994208000044],
              [-128.16002356699994, 52.41351959800005],
              [-128.16567949099993, 52.405910549000055],
              [-128.1728409499999, 52.40062083500004],
              [-128.1896866529999, 52.39325592700004],
              [-128.1970922519999, 52.38857656500005],
              [-128.2346085279999, 52.32640208500004],
              [-128.2830297519999, 52.28392161700003],
              [-128.2967016269999, 52.27558014500005],
              [-128.31094316299993, 52.27570221600007],
              [-128.32144120999993, 52.280585028000075],
              [-128.33067786399994, 52.286444403000075],
              [-128.34105383999992, 52.28921133000006],
              [-128.36782792899993, 52.28986237200007],
              [-128.38027910099993, 52.29181549700007],
              [-128.39224199099993, 52.29604726800005],
              [-128.37954667899993, 52.30939362200007],
              [-128.3635147779999, 52.31818268400008],
              [-128.33018958199995, 52.33022695500006],
              [-128.3391820949999, 52.348822333000044],
              [-128.33836829299992, 52.36859772300005],
              [-128.32848059799994, 52.386379299000055],
              [-128.3103735019999, 52.39907461100006],
              [-128.29869544199994, 52.402411200000074],
              [-128.2905167309999, 52.402044989000046],
              [-128.28262285099993, 52.40021393400008],
              [-128.27212480399993, 52.39907461100006],
              [-128.2604874339999, 52.402411200000074],
              [-128.2571508449999, 52.41054922100005],
              [-128.2560929029999, 52.42059967700004],
              [-128.25161699099993, 52.42942942900004],
              [-128.2381078769999, 52.44318268400008],
              [-128.22622636599993, 52.46051666900007],
              [-128.2219945949999, 52.47943756700005],
              [-128.2339574859999, 52.50535716400003],
              [-128.23485266799992, 52.525824286000045],
              [-128.2346085279999, 52.52944570500006],
              [-128.2429906889999, 52.55878327000005],
              [-128.24205481699994, 52.570379950000074],
              [-128.23306230399993, 52.58860911700003],
              [-128.1935929029999, 52.63930898600006],
              [-128.19188391799992, 52.64704010600008],
              [-128.1907445949999, 52.65717194200005],
              [-128.18838456899994, 52.667669989000046],
              [-128.1830948559999, 52.67649974200003],
              [-128.15664628799993, 52.69562409100007],
              [-128.1526586579999, 52.70380280200004],
              [-128.15147864499994, 52.71478913000004],
              [-128.1484268869999, 52.72060781500005],
              [-128.1438695949999, 52.72557200700004],
              [-128.13247636599993, 52.743475653000075],
              [-128.1282445949999, 52.74754466400003],
              [-128.12559973899994, 52.752834377000056],
              [-128.12474524599992, 52.765285549000055],
              [-128.1269425119999, 52.78510163000004],
              [-128.13646399599992, 52.82322825700004],
              [-128.13833574099993, 52.84414297100005],
              [-128.13223222599993, 52.873114325000074],
              [-128.10952714799993, 52.89207591400003],
              [-128.07827714799993, 52.902411200000074],
              [-128.03766842399995, 52.90704987200007],
              [-128.0305883449999, 52.911037502000056],
              [-128.0287979809999, 52.91665273600006],
              [-128.03571529899995, 52.92291901200008],
              [-128.0417374339999, 52.92357005400004],
              [-128.10513261599993, 52.91205475500004],
              [-128.12149003799993, 52.91400788000004],
              [-128.13219153599994, 52.926662502000056],
              [-128.13833574099993, 52.926662502000056],
              [-128.1415909499999, 52.907416083000044],
              [-128.15347245999993, 52.88434479400007],
              [-128.16808020699995, 52.86351146000004],
              [-128.17935136599993, 52.850897528000075],
              [-128.21410071499992, 52.83047109600005],
              [-128.2237035799999, 52.82176341400003],
              [-128.2299698559999, 52.81427643400008],
              [-128.23692786399994, 52.80817291900007],
              [-128.24819902299993, 52.803168036000045],
              [-128.27550208199995, 52.79975006700005],
              [-128.3054906889999, 52.802801825000074],
              [-128.3714086579999, 52.82021719000005],
              [-128.43301347599993, 52.82367584800005],
              [-128.44298255099994, 52.82770416900007],
              [-128.45042883999992, 52.85175202000005],
              [-128.45889238199993, 52.85773346600007],
              [-128.46914628799993, 52.86212799700007],
              [-128.47789466099994, 52.86831289300005],
              [-128.49746660099993, 52.89472077000005],
              [-128.49868730399993, 52.89935944200005],
              [-128.49254309799994, 52.908636786000045],
              [-128.49669348899994, 52.92942942900004],
              [-128.50837154899995, 52.96393463700008],
              [-128.51040605399993, 52.98517487200007],
              [-128.5198461579999, 53.025376695000034],
              [-128.52196204299992, 53.04645416900007],
              [-128.5241593089999, 53.05170319200005],
              [-128.53404700399994, 53.06915924700007],
              [-128.53624426999994, 53.08026764500005],
              [-128.53184973899994, 53.089504299000055],
              [-128.52114824099993, 53.093003648000035],
              [-128.5078018869999, 53.09446849200003],
              [-128.49526933499993, 53.097357489000046],
              [-128.51187089799993, 53.10736725500004],
              [-128.5322973299999, 53.10687897300005],
              [-128.54946855399993, 53.109442450000074],
              [-128.55675208199995, 53.12872955900008],
              [-128.54674231699994, 53.135972398000035],
              [-128.4983617829999, 53.14109935100004],
              [-128.48102779899995, 53.145738023000035],
              [-128.49771074099993, 53.14996979400007],
              [-128.5598852199999, 53.145738023000035],
              [-128.57591712099992, 53.15033600500004],
              [-128.58975175699993, 53.161444403000075],
              [-128.64806067599994, 53.22361888200004],
              [-128.65294348899994, 53.231756903000075],
              [-128.65562903599994, 53.23969147300005],
              [-128.66173255099994, 53.242173570000034],
              [-128.66844641799992, 53.240301825000074],
              [-128.6728409499999, 53.23517487200007],
              [-128.67247473899994, 53.22724030200004],
              [-128.66856848899994, 53.217230536000045],
              [-128.6591690749999, 53.20099518400008],
              [-128.68024654899995, 53.19281647300005],
              [-128.7005102199999, 53.19830963700008],
              [-128.79971269399994, 53.25649648600006],
              [-128.81371008999992, 53.261786200000074],
              [-128.83250891799992, 53.26675039300005],
              [-128.8491104809999, 53.278550523000035],
              [-128.87547766799992, 53.30621979400007],
              [-128.8842667309999, 53.32632070500006],
              [-128.87608801999994, 53.344956773000035],
              [-128.85985266799992, 53.360581773000035],
              [-128.8447159499999, 53.37164948100008],
              [-128.87633216099994, 53.37213776200008],
              [-128.88760331899994, 53.37710195500006],
              [-128.8826391269999, 53.38906484600005],
              [-128.8738500639999, 53.40058014500005],
              [-128.87555904899995, 53.40696849200003],
              [-128.88170325399994, 53.41388580900008],
              [-128.88634192599994, 53.426947333000044],
              [-128.88060462099992, 53.447699286000045],
              [-128.84422766799992, 53.47089264500005],
              [-128.8310440749999, 53.488348700000074],
              [-128.86245683499993, 53.489162502000056],
              [-128.87710527299993, 53.486314195000034],
              [-128.8893936839999, 53.47809479400007],
              [-128.89981035099993, 53.46588776200008],
              [-128.90794837099992, 53.458685614000046],
              [-128.91763261599993, 53.458685614000046],
              [-128.93285071499992, 53.46792226800005],
              [-128.9473363919999, 53.48582591400003],
              [-128.96263587099992, 53.53294505400004],
              [-128.97447669199994, 53.556626695000034],
              [-128.94570878799993, 53.55451080900008],
              [-128.8924047519999, 53.53660716400003],
              [-128.86461341099994, 53.53620026200008],
              [-128.84691321499992, 53.546210028000075],
              [-128.83071855399993, 53.56167226800005],
              [-128.8127335279999, 53.57294342700004],
              [-128.78945878799993, 53.570298570000034],
              [-128.77554277299993, 53.55560944200005],
              [-128.7586156889999, 53.51056549700007],
              [-128.74852454299992, 53.49518463700008],
              [-128.74038652299993, 53.491441148000035],
              [-128.70759029899995, 53.48151276200008],
              [-128.6970922519999, 53.47479889500005],
              [-128.6728409499999, 53.45359935100004],
              [-128.66661536399994, 53.46108633000006],
              [-128.6830948559999, 53.473944403000075],
              [-128.6916397779999, 53.48232656500005],
              [-128.69391842399995, 53.488348700000074],
              [-128.6834203769999, 53.493068752000056],
              [-128.66763261599993, 53.48932526200008],
              [-128.63927161399994, 53.47475820500006],
              [-128.56297766799992, 53.41950104400007],
              [-128.5202530589999, 53.401556708000044],
              [-128.50837154899995, 53.39276764500005],
              [-128.5056860019999, 53.39215729400007],
              [-128.4975479809999, 53.387152411000045],
              [-128.4925024079999, 53.381293036000045],
              [-128.49868730399993, 53.37848541900007],
              [-128.5014542309999, 53.37604401200008],
              [-128.50283769399994, 53.37018463700008],
              [-128.50304114499994, 53.363348700000074],
              [-128.50210527299993, 53.35805898600006],
              [-128.49388587099992, 53.34406159100007],
              [-128.48766028599994, 53.34585195500006],
              [-128.4834692049999, 53.357123114000046],
              [-128.47988847599993, 53.38666413000004],
              [-128.48208574099993, 53.39801666900007],
              [-128.49058997299994, 53.40493398600006],
              [-128.50837154899995, 53.40643952000005],
              [-128.50837154899995, 53.41266510600008],
              [-128.4964086579999, 53.41620514500005],
              [-128.47712154899995, 53.42877838700008],
              [-128.46735592399995, 53.43374258000006],
              [-128.37950598899994, 53.44749583500004],
              [-128.36318925699993, 53.45888906500005],
              [-128.35191809799994, 53.48151276200008],
              [-128.30870520699995, 53.460638739000046],
              [-128.25352942599994, 53.452826239000046],
              [-128.14891516799992, 53.45359935100004],
              [-128.1270238919999, 53.450873114000046],
              [-128.10586503799993, 53.443060614000046],
              [-128.08999589799993, 53.43121979400007],
              [-128.0816137359999, 53.41120026200008],
              [-128.0720922519999, 53.403225002000056],
              [-128.0701391269999, 53.39899323100008],
              [-128.07217363199993, 53.39248281500005],
              [-128.08071855399993, 53.38385651200008],
              [-128.08372962099992, 53.37848541900007],
              [-128.08751380099994, 53.36908600500004],
              [-128.1042374339999, 53.337591864000046],
              [-128.07070878799993, 53.364569403000075],
              [-128.0510147779999, 53.37384674700007],
              [-128.0322973299999, 53.36823151200008],
              [-128.0166723299999, 53.35879140800006],
              [-127.97695878799993, 53.34235260600008],
              [-127.96084550699993, 53.330064195000034],
              [-127.9563695949999, 53.318426825000074],
              [-127.9534399079999, 53.26520416900007],
              [-127.94261633999992, 53.25372955900008],
              [-127.87149003799993, 53.22833893400008],
              [-127.87710527299993, 53.25014883000006],
              [-127.89574133999992, 53.26146067900004],
              [-127.91759192599994, 53.27142975500004],
              [-127.9329320949999, 53.289129950000074],
              [-127.93407141799992, 53.30267975500004],
              [-127.92808997299994, 53.32453034100007],
              [-127.9329320949999, 53.337591864000046],
              [-127.94318600199989, 53.34430573100008],
              [-127.97887122299994, 53.35602448100008],
              [-127.99128170499989, 53.35805898600006],
              [-128.00182044199994, 53.36225006700005],
              [-128.03018144399994, 53.38226959800005],
              [-128.03600012899994, 53.38906484600005],
              [-128.03970292899993, 53.39166901200008],
              [-128.06017005099994, 53.41950104400007],
              [-128.0672094389999, 53.42487213700008],
              [-128.08511308499993, 53.44822825700004],
              [-128.09434973899994, 53.45359935100004],
              [-128.10362708199995, 53.45685455900008],
              [-128.1123754549999, 53.46515534100007],
              [-128.11632239499994, 53.47630442900004],
              [-128.11107337099992, 53.488348700000074],
              [-128.13272050699993, 53.484076239000046],
              [-128.2005102199999, 53.488348700000074],
              [-128.3001195949999, 53.48151276200008],
              [-128.34825598899994, 53.49852122600004],
              [-128.37413489499994, 53.503566799000055],
              [-128.38540605399993, 53.49176666900007],
              [-128.39024817599994, 53.474595445000034],
              [-128.40294348899994, 53.46165599200003],
              [-128.42052161399994, 53.45270416900007],
              [-128.44005286399994, 53.44741445500006],
              [-128.4526261059999, 53.446193752000056],
              [-128.49185136599993, 53.44741445500006],
              [-128.5026749339999, 53.444566148000035],
              [-128.50918535099993, 53.438788153000075],
              [-128.5164281889999, 53.43390534100007],
              [-128.52940833199995, 53.43374258000006],
              [-128.53917395699995, 53.43935781500005],
              [-128.5528051419999, 53.45722077000005],
              [-128.5598852199999, 53.46108633000006],
              [-128.5718481109999, 53.46234772300005],
              [-128.58438066299993, 53.46653880400004],
              [-128.59430904899995, 53.473944403000075],
              [-128.59829667899993, 53.48493073100008],
              [-128.61217200399994, 53.50458405200004],
              [-128.64268958199995, 53.513332424000055],
              [-128.67320716099994, 53.516506252000056],
              [-128.6870824859999, 53.51943594000005],
              [-128.69082597599993, 53.53392161700003],
              [-128.70055091099994, 53.54710521000004],
              [-128.7280981109999, 53.570298570000034],
              [-128.74913489499994, 53.56244538000004],
              [-128.7654516269999, 53.57562897300005],
              [-128.7792862619999, 53.59471263200004],
              [-128.7932022779999, 53.60443756700005],
              [-128.79967200399994, 53.60761139500005],
              [-128.80772864499994, 53.61538320500006],
              [-128.8145238919999, 53.62547435100004],
              [-128.8174535799999, 53.63548411700003],
              [-128.81602942599994, 53.65033600500004],
              [-128.81212317599994, 53.65778229400007],
              [-128.7969457669999, 53.672756252000056],
              [-128.77379309799994, 53.704738674000055],
              [-128.77037512899994, 53.72142161700003],
              [-128.79190019399994, 53.760199286000045],
              [-128.7888891269999, 53.780910549000055],
              [-128.77513587099992, 53.79828522300005],
              [-128.7553604809999, 53.81049225500004],
              [-128.73180091099994, 53.81509023600006],
              [-128.7097875639999, 53.81557851800005],
              [-128.69347083199995, 53.82123444200005],
              [-128.6870824859999, 53.84125397300005],
              [-128.67784583199995, 53.85932038000004],
              [-128.6563207669999, 53.86225006700005],
              [-128.5589086579999, 53.84170156500005],
              [-128.4794815749999, 53.83685944200005],
              [-128.47374426999994, 53.841498114000046],
              [-128.48473059799994, 53.85455963700008],
              [-128.50112870999993, 53.86269765800006],
              [-128.51773027299993, 53.862982489000046],
              [-128.54991614499994, 53.85765208500004],
              [-128.5724991529999, 53.86090729400007],
              [-128.61681067599994, 53.87596263200004],
              [-128.64488684799994, 53.882066148000035],
              [-128.6542862619999, 53.88739655200004],
              [-128.6628311839999, 53.891058661000045],
              [-128.67516028599994, 53.88727448100008],
              [-128.6826065749999, 53.88930898600006],
              [-128.6896866529999, 53.89370351800005],
              [-128.69391842399995, 53.899318752000056],
              [-128.69383704299992, 53.90643952000005],
              [-128.6890356109999, 53.90973541900007],
              [-128.6830948559999, 53.91128164300005],
              [-128.67959550699993, 53.91290924700007],
              [-128.67080644399994, 53.92991771000004],
              [-128.6355688139999, 53.97125885600008],
              [-128.63198808499993, 53.978176174000055],
              [-128.63101152299993, 53.98725006700005],
              [-128.6318253249999, 54.00535716400003],
              [-128.6276749339999, 54.013006903000075],
              [-128.6179093089999, 54.02016836100006],
              [-128.59829667899993, 54.03021881700005],
              [-128.62193762899994, 54.032131252000056],
              [-128.65269934799994, 54.01984284100007],
              [-128.68175208199995, 54.00067780200004],
              [-128.70010331899994, 53.98183828300006],
              [-128.71593176999994, 53.95652903900003],
              [-128.73485266799992, 53.934027411000045],
              [-128.73818925699993, 53.93260325700004],
              [-128.7480362619999, 53.92601146000004],
              [-128.74852454299992, 53.920355536000045],
              [-128.76451575399994, 53.91351959800005],
              [-128.7722875639999, 53.91400788000004],
              [-128.7827042309999, 53.920355536000045],
              [-128.78921464799993, 53.892564195000034],
              [-128.81334387899994, 53.877386786000045],
              [-128.8393448559999, 53.86562734600005],
              [-128.8616430329999, 53.83022695500006],
              [-128.93285071499992, 53.77635325700004],
              [-128.92833411399994, 53.79588450700004],
              [-128.9080297519999, 53.82729726800005],
              [-128.90615800699993, 53.84467194200005],
              [-128.9148656889999, 53.85761139500005],
              [-128.92568925699993, 53.84662506700005],
              [-128.94713294199994, 53.81049225500004],
              [-128.94766191299993, 53.83926015800006],
              [-128.94579016799992, 53.85293203300006],
              [-128.94029700399994, 53.86513906500005],
              [-128.9658910799999, 53.89052969000005],
              [-128.98350989499994, 53.89834219000005],
              [-129.00918535099993, 53.899318752000056],
              [-129.00918535099993, 53.89248281500005],
              [-128.97777258999992, 53.866888739000046],
              [-128.96540279899995, 53.82054271000004],
              [-128.97321529899995, 53.77757396000004],
              [-129.0017797519999, 53.76211172100005],
              [-129.0195206369999, 53.77435944200005],
              [-129.04800370999993, 53.81232330900008],
              [-129.06383216099994, 53.81049225500004],
              [-129.0644425119999, 53.79120514500005],
              [-129.0332738919999, 53.74949778900003],
              [-129.0464574859999, 53.74164459800005],
              [-129.06602942599994, 53.73883698100008],
              [-129.08950761599993, 53.731634833000044],
              [-129.1121313139999, 53.721869208000044],
              [-129.12901770699995, 53.71116771000004],
              [-129.13467363199993, 53.702053127000056],
              [-129.1397192049999, 53.689154364000046],
              [-129.14614824099993, 53.67767975500004],
              [-129.1563207669999, 53.672756252000056],
              [-129.16661536399994, 53.671210028000075],
              [-129.17837480399993, 53.66746653900003],
              [-129.1894425119999, 53.662176825000074],
              [-129.2283422519999, 53.63271719000005],
              [-129.2382706369999, 53.618801174000055],
              [-129.2420141269999, 53.59446849200003],
              [-129.23936926999994, 53.55145905200004],
              [-129.24474036399994, 53.53034088700008],
              [-129.2624405589999, 53.52252838700008],
              [-129.2624405589999, 53.51630280200004],
              [-129.24233964799993, 53.51186758000006],
              [-129.23570716099994, 53.49201080900008],
              [-129.2372940749999, 53.467230536000045],
              [-129.2420141269999, 53.44741445500006],
              [-129.24990800699993, 53.43121979400007],
              [-129.26333574099993, 53.41063060100004],
              [-129.2780655589999, 53.39288971600007],
              [-129.2897843089999, 53.38540273600006],
              [-129.3349503249999, 53.396918036000045],
              [-129.59312903599994, 53.57221100500004],
              [-129.61534583199995, 53.57713450700004],
              [-129.6699112619999, 53.618353583000044],
              [-129.68016516799992, 53.62864817900004],
              [-129.68785559799994, 53.64008209800005],
              [-129.72667395699995, 53.67169830900008],
              [-129.7429093089999, 53.68016185100004],
              [-129.7429093089999, 53.68699778900003],
              [-129.73155676999994, 53.68577708500004],
              [-129.72118079299992, 53.68235911700003],
              [-129.7018936839999, 53.672756252000056],
              [-129.71572831899994, 53.69546133000006],
              [-129.73302161399994, 53.70547109600005],
              [-129.75332597599993, 53.71116771000004],
              [-129.7764379549999, 53.721136786000045],
              [-129.78441321499992, 53.72890859600005],
              [-129.80308997299994, 53.75527578300006],
              [-129.8118383449999, 53.757025458000044],
              [-129.83446204299992, 53.75409577000005],
              [-129.8452856109999, 53.75527578300006],
              [-129.8523656889999, 53.75991445500006],
              [-129.87938391799992, 53.78314850500004],
              [-129.91136633999992, 53.79767487200007],
              [-129.92039954299992, 53.80365631700005],
              [-129.9275610019999, 53.812201239000046],
              [-129.93919837099992, 53.83030833500004],
              [-129.9483129549999, 53.83783600500004],
              [-129.95872962099992, 53.84194570500006],
              [-129.9961645169999, 53.85150788000004],
              [-129.97423255099994, 53.86587148600006],
              [-129.9651586579999, 53.87592194200005],
              [-129.96133378799993, 53.88898346600007],
              [-129.9690649079999, 53.89126211100006],
              [-130.00633704299992, 53.87457916900007],
              [-130.01968339799993, 53.87567780200004],
              [-130.0293676419999, 53.884019273000035],
              [-130.05337480399993, 53.89817942900004],
              [-130.0637914699999, 53.90615469000005],
              [-130.09337317599994, 53.94009023600006],
              [-130.10472571499992, 53.94708893400008],
              [-130.0866593089999, 53.97060781500005],
              [-130.08389238199993, 54.00470612200007],
              [-130.09166419199994, 54.08112213700008],
              [-130.0852758449999, 54.10053131700005],
              [-130.0566300119999, 54.139553127000056],
              [-130.0501195949999, 54.15619538000004],
              [-130.0378311839999, 54.15424225500004],
              [-129.97988847599993, 54.16111888200004],
              [-129.96133378799993, 54.16681549700007],
              [-129.95042883999992, 54.15932851800005],
              [-129.9467667309999, 54.14996979400007],
              [-129.94517981699994, 54.14044830900008],
              [-129.9409073559999, 54.13263580900008],
              [-129.93175208199995, 54.126939195000034],
              [-129.90990149599992, 54.11798737200007],
              [-129.8998917309999, 54.11212799700007],
              [-129.8732804029999, 54.085598049000055],
              [-129.85212154899995, 54.05695221600007],
              [-129.8484594389999, 54.04877350500004],
              [-129.8466690749999, 54.04205963700008],
              [-129.84414628799993, 54.03607819200005],
              [-129.83844967399995, 54.03021881700005],
              [-129.8290909499999, 54.02553945500006],
              [-129.82070878799993, 54.024644273000035],
              [-129.81236731699994, 54.024725653000075],
              [-129.80308997299994, 54.022772528000075],
              [-129.7979223299999, 54.018784898000035],
              [-129.7890518869999, 54.00653717700004],
              [-129.78380286399994, 54.00234609600005],
              [-129.7775772779999, 54.00169505400004],
              [-129.7620336579999, 54.00385163000004],
              [-129.75649980399993, 54.00234609600005],
              [-129.7530004549999, 53.996975002000056],
              [-129.75088456899994, 53.985663153000075],
              [-129.7490942049999, 53.98183828300006],
              [-129.7350968089999, 53.964544989000046],
              [-129.7273656889999, 53.95783112200007],
              [-129.71495520699995, 53.95384349200003],
              [-129.72520911399994, 53.971869208000044],
              [-129.73363196499992, 53.992173570000034],
              [-129.7454320949999, 54.008978583000044],
              [-129.78233801999994, 54.02179596600007],
              [-129.82469641799992, 54.05133698100008],
              [-129.83844967399995, 54.063788153000075],
              [-129.8467504549999, 54.07444896000004],
              [-129.8587133449999, 54.09520091400003],
              [-129.86579342399995, 54.104681708000044],
              [-129.89488684799994, 54.12449778900003],
              [-129.8998917309999, 54.128973700000074],
              [-129.9072973299999, 54.14468008000006],
              [-129.9218643869999, 54.155951239000046],
              [-129.93228105399993, 54.16828034100007],
              [-129.9272354809999, 54.18732330900008],
              [-129.91100012899994, 54.200873114000046],
              [-129.88658606699994, 54.21190013200004],
              [-129.8601781889999, 54.21930573100008],
              [-129.8381241529999, 54.22207265800006],
              [-129.80699622299994, 54.22117747600004],
              [-129.79210364499994, 54.218003648000035],
              [-129.7656143869999, 54.20416901200008],
              [-129.74962317599994, 54.20404694200005],
              [-129.72109941299993, 54.20774974200003],
              [-129.6369522779999, 54.18113841400003],
              [-129.61192786399994, 54.18390534100007],
              [-129.5827530589999, 54.196926174000055],
              [-129.56309973899994, 54.21271393400008],
              [-129.55337480399993, 54.21637604400007],
              [-129.5293676419999, 54.22207265800006],
              [-129.50401770699995, 54.23224518400008],
              [-129.49063066299993, 54.23541901200008],
              [-129.4753311839999, 54.23505280200004],
              [-129.49181067599994, 54.25145091400003],
              [-129.5178930329999, 54.24721914300005],
              [-129.56725012899994, 54.228216864000046],
              [-129.57530676999994, 54.223863023000035],
              [-129.58926347599993, 54.20465729400007],
              [-129.59512285099993, 54.20034414300005],
              [-129.62555904899995, 54.20180898600006],
              [-129.7678116529999, 54.23651764500005],
              [-129.82896887899994, 54.24213288000004],
              [-129.8863012359999, 54.23505280200004],
              [-129.95421301999994, 54.21084219000005],
              [-129.9787491529999, 54.20774974200003],
              [-129.98875891799992, 54.20343659100007],
              [-130.0087784499999, 54.18471914300005],
              [-130.01968339799993, 54.18048737200007],
              [-130.0644425119999, 54.18211497600004],
              [-130.07803300699993, 54.18048737200007],
              [-130.08853105399993, 54.17536041900007],
              [-130.10167395699995, 54.16225820500006],
              [-130.11217200399994, 54.15932851800005],
              [-130.12490800699993, 54.16087474200003],
              [-130.14077714799993, 54.16583893400008],
              [-130.1542862619999, 54.17365143400008],
              [-130.1599828769999, 54.18390534100007],
              [-130.17634029899995, 54.19521719000005],
              [-130.27725175699993, 54.20774974200003],
              [-130.2814835279999, 54.21442291900007],
              [-130.28404700399994, 54.23159414300005],
              [-130.28722083199995, 54.23505280200004],
              [-130.29287675699993, 54.23745351800005],
              [-130.2827042309999, 54.24249909100007],
              [-130.23102779899995, 54.26007721600007],
              [-130.19473222599993, 54.263006903000075],
              [-130.20669511599993, 54.270738023000035],
              [-130.2298070949999, 54.27968984600005],
              [-130.23940995999993, 54.28685130400004],
              [-130.24083411399994, 54.296087958000044],
              [-130.24063066299993, 54.31134674700007],
              [-130.2431534499999, 54.32562897300005],
              [-130.25279700399994, 54.33185455900008],
              [-130.25816809799994, 54.341009833000044],
              [-130.24644934799994, 54.38719310100004],
              [-130.24937903599994, 54.40639883000006],
              [-130.2578018869999, 54.39126211100006],
              [-130.2639054029999, 54.37323639500005],
              [-130.2722061839999, 54.35809967700004],
              [-130.28722083199995, 54.35175202000005],
              [-130.3089086579999, 54.34821198100008],
              [-130.34886633999992, 54.33372630400004],
              [-130.3728735019999, 54.33185455900008],
              [-130.4236547519999, 54.34316640800006],
              [-130.44424394399994, 54.344916083000044],
              [-130.45824133999992, 54.34861888200004],
              [-130.4739477199999, 54.358710028000075],
              [-130.48253333199995, 54.37368398600006],
              [-130.47524980399993, 54.39207591400003],
              [-130.48253333199995, 54.403550523000035],
              [-130.48106848899994, 54.41868724200003],
              [-130.47423255099994, 54.43353913000004],
              [-130.46540279899995, 54.444240627000056],
              [-130.44505774599992, 54.453192450000074],
              [-130.40029863199993, 54.454006252000056],
              [-130.3797094389999, 54.461004950000074],
              [-130.42056230399993, 54.48578522300005],
              [-130.4353735019999, 54.50218333500004],
              [-130.44115149599992, 54.52680084800005],
              [-130.43984941299993, 54.54897695500006],
              [-130.43691972599993, 54.55923086100006],
              [-130.4312231109999, 54.56777578300006],
              [-130.41844641799992, 54.569647528000075],
              [-130.40086829299992, 54.565741278000075],
              [-130.3855688139999, 54.56525299700007],
              [-130.3797094389999, 54.57770416900007],
              [-130.39317786399994, 54.58502838700008],
              [-130.4199926419999, 54.60419342700004],
              [-130.43956458199995, 54.623928127000056],
              [-130.4312231109999, 54.63296133000006],
              [-130.40599524599992, 54.63043854400007],
              [-130.38296464799993, 54.62327708500004],
              [-130.36270097599993, 54.61225006700005],
              [-130.34557044199994, 54.59813060100004],
              [-130.31822669199994, 54.56464264500005],
              [-130.28819739499994, 54.539048570000034],
              [-130.2835180329999, 54.53335195500006],
              [-130.27603105399993, 54.51984284100007],
              [-130.0529679029999, 54.33738841400003],
              [-130.03099524599992, 54.32672760600008],
              [-130.0060929029999, 54.319973049000055],
              [-129.9787491529999, 54.317613023000035],
              [-129.9638565749999, 54.31883372600004],
              [-129.95889238199993, 54.32208893400008],
              [-129.9631241529999, 54.32672760600008],
              [-129.9756567049999, 54.33185455900008],
              [-129.9871313139999, 54.33315664300005],
              [-129.9999893869999, 54.33258698100008],
              [-130.0134985019999, 54.33417389500005],
              [-130.02651933499993, 54.341498114000046],
              [-130.07315019399994, 54.377020575000074],
              [-130.08486894399994, 54.39207591400003],
              [-130.08458411399994, 54.41128164300005],
              [-130.06407630099994, 54.44684479400007],
              [-130.07119706899994, 54.461004950000074],
              [-130.06309973899994, 54.478949286000045],
              [-130.05190995999993, 54.48533763200004],
              [-130.0165909499999, 54.488267320000034],
              [-129.9990128249999, 54.49453359600005],
              [-129.98485266799992, 54.50470612200007],
              [-129.9814346999999, 54.51544830900008],
              [-129.9961645169999, 54.52366771000004],
              [-130.0047094389999, 54.51968008000006],
              [-130.0637914699999, 54.501939195000034],
              [-130.07673092399995, 54.49119700700004],
              [-130.08287512899994, 54.478583075000074],
              [-130.0847875639999, 54.46320221600007],
              [-130.08486894399994, 54.444240627000056],
              [-130.1011449859999, 54.42633698100008],
              [-130.1370336579999, 54.44204336100006],
              [-130.19131425699993, 54.482123114000046],
              [-130.2116593089999, 54.493353583000044],
              [-130.29092363199993, 54.57078685100004],
              [-130.28795325399994, 54.57489655200004],
              [-130.2835180329999, 54.585150458000044],
              [-130.32262122299994, 54.60366445500006],
              [-130.35977128799993, 54.632147528000075],
              [-130.37242591099994, 54.66425202000005],
              [-130.3381241529999, 54.693793036000045],
              [-130.28766842399995, 54.70774974200003],
              [-130.2344457669999, 54.71141185100004],
              [-130.1816300119999, 54.704779364000046],
              [-130.1213272779999, 54.683661200000074],
              [-130.09557044199994, 54.67792389500005],
              [-130.08486894399994, 54.673895575000074],
              [-130.07860266799992, 54.66860586100006],
              [-130.06065833199995, 54.64321523600006],
              [-130.03966223899994, 54.628892320000034],
              [-130.01162675699993, 54.61985911700003],
              [-129.9236547519999, 54.60919830900008],
              [-129.9064835279999, 54.60919830900008],
              [-129.89366614499994, 54.61180247600004],
              [-129.87954667899993, 54.62059153900003],
              [-129.88076738199993, 54.62474192900004],
              [-129.8908585279999, 54.62604401200008],
              [-129.96182206899994, 54.626613674000055],
              [-129.98985755099994, 54.630519924000055],
              [-130.0165909499999, 54.63979726800005],
              [-130.03636633999992, 54.654730536000045],
              [-130.0757543609999, 54.693345445000034],
              [-130.09508216099994, 54.701239325000074],
              [-130.1104223299999, 54.70258209800005],
              [-130.12022864499994, 54.706366278000075],
              [-130.13980058499993, 54.71824778900003],
              [-130.15493730399993, 54.72256094000005],
              [-130.18667558499993, 54.72455475500004],
              [-130.20152747299994, 54.728501695000034],
              [-130.19473222599993, 54.75641510600008],
              [-130.19005286399994, 54.763373114000046],
              [-130.17764238199993, 54.77293528900003],
              [-130.1736547519999, 54.77692291900007],
              [-130.1599828769999, 54.79743073100008],
              [-130.1577042309999, 54.80369700700004],
              [-130.1572973299999, 54.817572333000044],
              [-130.1531469389999, 54.82469310100004],
              [-130.1474503249999, 54.82794830900008],
              [-130.1328832669999, 54.82990143400008],
              [-130.1264542309999, 54.83152903900003],
              [-130.09850012899994, 54.84454987200007],
              [-130.08446204299992, 54.85423411700003],
              [-130.0713598299999, 54.86579010600008],
              [-130.05968176999994, 54.87885163000004],
              [-130.0501195949999, 54.893011786000045],
              [-130.06725012899994, 54.89667389500005],
              [-130.08023027299993, 54.89012278900003],
              [-130.10472571499992, 54.86627838700008],
              [-130.1199438139999, 54.85919830900008],
              [-130.15518144399994, 54.85224030200004],
              [-130.1736547519999, 54.84454987200007],
              [-130.16490637899994, 54.85736725500004],
              [-130.15005449099993, 54.873480536000045],
              [-130.1343481109999, 54.88719310100004],
              [-130.10435950399994, 54.90086497600004],
              [-130.0637914699999, 54.954413153000075],
              [-130.0459692049999, 54.96552155200004],
              [-130.02204342399995, 54.973863023000035],
              [-129.99673417899993, 54.97695547100005],
              [-129.97500566299993, 54.971869208000044],
              [-129.95665442599994, 54.95742422100005],
              [-129.96202551999994, 54.94806549700007],
              [-129.97744706899994, 54.93768952000005],
              [-129.9892471999999, 54.92031484600005],
              [-129.9753311839999, 54.92096588700008],
              [-129.96524003799993, 54.925034898000035],
              [-129.95689856699994, 54.93036530200004],
              [-129.9483129549999, 54.93455638200004],
              [-129.93911699099993, 54.94525788000004],
              [-129.9346410799999, 54.94818756700005],
              [-129.9317113919999, 54.94757721600007],
              [-129.9033096999999, 54.94818756700005],
              [-129.88072669199994, 54.95526764500005],
              [-129.8452042309999, 54.98704661700003],
              [-129.82481848899994, 54.995428778000075],
              [-129.81102454299992, 54.99310944200005],
              [-129.78359941299993, 54.979396877000056],
              [-129.7696020169999, 54.97553131700005],
              [-129.7556860019999, 54.97719961100006],
              [-129.72972571499992, 54.98688385600008],
              [-129.7180883449999, 54.98920319200005],
              [-129.66331946499992, 54.984361070000034],
              [-129.6413468089999, 54.989569403000075],
              [-129.62559973899994, 55.00971100500004],
              [-129.67564856699994, 54.994574286000045],
              [-129.95482337099992, 55.00971100500004],
              [-129.97740637899994, 55.00531647300005],
              [-129.9878637359999, 55.00576406500005],
              [-129.99986731699994, 55.01312897300005],
              [-130.0010473299999, 55.02244700700004],
              [-129.99351966099994, 55.03506094000005],
              [-129.9756567049999, 55.05805084800005],
              [-129.95669511599993, 55.10138580900008],
              [-129.9413956369999, 55.11871979400007],
              [-129.91665605399993, 55.12571849200003],
              [-129.89000403599994, 55.157131252000056],
              [-129.8796280589999, 55.16486237200007],
              [-129.87002519399994, 55.170355536000045],
              [-129.86095130099994, 55.17715078300006],
              [-129.85212154899995, 55.18842194200005],
              [-129.85122636599993, 55.19293854400007],
              [-129.85289466099994, 55.20380280200004],
              [-129.85212154899995, 55.208319403000075],
              [-129.8444718089999, 55.21662018400008],
              [-129.83844967399995, 55.221909898000035],
              [-129.82754472599993, 55.24310944200005],
              [-129.8213598299999, 55.25145091400003],
              [-129.8139542309999, 55.25950755400004],
              [-129.8037817049999, 55.26642487200007],
              [-129.7814835279999, 55.274644273000035],
              [-129.76817786399994, 55.28335195500006],
              [-129.75796464799993, 55.28461334800005],
              [-129.75279700399994, 55.287095445000034],
              [-129.7493383449999, 55.29271067900004],
              [-129.74962317599994, 55.298895575000074],
              [-129.75055904899995, 55.30532461100006],
              [-129.7490942049999, 55.31134674700007],
              [-129.72134355399993, 55.34902578300006],
              [-129.70278886599993, 55.36579010600008],
              [-129.6839086579999, 55.37278880400004],
              [-129.6752823559999, 55.378119208000044],
              [-129.67393958199995, 55.389837958000044],
              [-129.67422441299993, 55.401556708000044],
              [-129.67056230399993, 55.40692780200004],
              [-129.66295325399994, 55.411444403000075],
              [-129.64708411399994, 55.43317291900007],
              [-129.63923092399995, 55.441066799000055],
              [-129.6104223299999, 55.446478583000044],
              [-129.5432022779999, 55.43789297100005],
              [-129.51939856699994, 55.44448476800005],
              [-129.4865616529999, 55.45994700700004],
              [-129.4787491529999, 55.462144273000035],
              [-129.47569739499994, 55.464056708000044],
              [-129.47476152299993, 55.46865469000005],
              [-129.4753311839999, 55.47923411700003],
              [-129.4780167309999, 55.48346588700008],
              [-129.48403886599993, 55.48183828300006],
              [-129.49522864499994, 55.475816148000035],
              [-129.50633704299992, 55.47211334800005],
              [-129.53062903599994, 55.459051825000074],
              [-129.54360917899993, 55.45530833500004],
              [-129.55919348899994, 55.455511786000045],
              [-129.59190833199995, 55.46084219000005],
              [-129.63467363199993, 55.46161530200004],
              [-129.64696204299992, 55.45856354400007],
              [-129.65660559799994, 55.451605536000045],
              [-129.6863500639999, 55.419582424000055],
              [-129.69444739499994, 55.413763739000046],
              [-129.7129613919999, 55.420803127000056],
              [-129.7161352199999, 55.465277411000045],
              [-129.74339758999992, 55.48354726800005],
              [-129.75405839799993, 55.501613674000055],
              [-129.7905167309999, 55.59833405200004],
              [-129.80650794199994, 55.62449778900003],
              [-129.82481848899994, 55.619208075000074],
              [-129.8159073559999, 55.60146719000005],
              [-129.81175696499992, 55.58266836100006],
              [-129.8105362619999, 55.540716864000046],
              [-129.7884008449999, 55.50385163000004],
              [-129.77700761599993, 55.47943756700005],
              [-129.78014075399994, 55.468410549000055],
              [-129.79015051999994, 55.46381256700005],
              [-129.79190019399994, 55.45331452000005],
              [-129.79019120999993, 55.44204336100006],
              [-129.7900284499999, 55.434881903000075],
              [-129.7983292309999, 55.42633698100008],
              [-129.81631425699993, 55.42007070500006],
              [-129.82481848899994, 55.413763739000046],
              [-129.83214270699995, 55.40448639500005],
              [-129.83731035099993, 55.395412502000056],
              [-129.8396703769999, 55.385199286000045],
              [-129.83844967399995, 55.37278880400004],
              [-129.83287512899994, 55.366441148000035],
              [-129.82477779899995, 55.36733633000006],
              [-129.8201391269999, 55.374335028000075],
              [-129.82481848899994, 55.386419989000046],
              [-129.8171280589999, 55.392279364000046],
              [-129.80874589799993, 55.396551825000074],
              [-129.79971269399994, 55.39911530200004],
              [-129.7900284499999, 55.400091864000046],
              [-129.7986547519999, 55.38776276200008],
              [-129.80308997299994, 55.38385651200008],
              [-129.8105362619999, 55.38027578300006],
              [-129.80606035099993, 55.37205638200004],
              [-129.80125891799992, 55.36741771000004],
              [-129.79434160099993, 55.36554596600007],
              [-129.78380286399994, 55.36595286700003],
              [-129.7862035799999, 55.356756903000075],
              [-129.79088294199994, 55.34788646000004],
              [-129.79775956899994, 55.34125397300005],
              [-129.82017981699994, 55.33551666900007],
              [-129.82457434799994, 55.328192450000074],
              [-129.82530676999994, 55.301988023000035],
              [-129.82274329299992, 55.296210028000075],
              [-129.82192949099993, 55.290228583000044],
              [-129.8279516269999, 55.28025950700004],
              [-129.8620499339999, 55.25608958500004],
              [-129.87755286399994, 55.248114325000074],
              [-129.8874405589999, 55.22907135600008],
              [-129.8998917309999, 55.18842194200005],
              [-129.9123429029999, 55.168850002000056],
              [-129.9961645169999, 55.09906647300005],
              [-130.01968339799993, 55.067694403000075],
              [-130.0370987619999, 55.036363023000035],
              [-130.0564672519999, 55.00934479400007],
              [-130.0637914699999, 55.00287506700005],
              [-130.08311926999994, 54.99677155200004],
              [-130.10582434799994, 54.99754466400003],
              [-130.1248266269999, 55.00527578300006],
              [-130.13267981699994, 55.01992422100005],
              [-130.13638261599993, 55.03701406500005],
              [-130.16738847599993, 55.08539459800005],
              [-130.13951575399994, 55.11273834800005],
              [-130.12022864499994, 55.14834219000005],
              [-130.11558997299994, 55.15371328300006],
              [-130.10806230399993, 55.15794505400004],
              [-130.08877519399994, 55.17820872600004],
              [-130.08486894399994, 55.18471914300005],
              [-130.07860266799992, 55.192572333000044],
              [-130.01618404899995, 55.22890859600005],
              [-129.95791581899994, 55.273504950000074],
              [-129.94937089799993, 55.29315827000005],
              [-129.96108964799993, 55.31073639500005],
              [-129.9961645169999, 55.33860911700003],
              [-130.00304114499994, 55.356756903000075],
              [-130.0041397779999, 55.398504950000074],
              [-130.0066625639999, 55.41034577000005],
              [-130.01162675699993, 55.41828034100007],
              [-130.02110755099994, 55.44232819200005],
              [-130.02505449099993, 55.46548086100006],
              [-130.03111731699994, 55.47333405200004],
              [-130.0398656889999, 55.47988515800006],
              [-130.0501195949999, 55.489447333000044],
              [-130.07656816299993, 55.52228424700007],
              [-130.0939835279999, 55.55263906500005],
              [-130.09976152299993, 55.587225653000075],
              [-130.09166419199994, 55.632879950000074],
              [-130.0799047519999, 55.65997955900008],
              [-130.07803300699993, 55.67104726800005],
              [-130.08071855399993, 55.68500397300005],
              [-130.08804277299993, 55.69090403900003],
              [-130.09886633999992, 55.69440338700008],
              [-130.11217200399994, 55.70111725500004],
              [-130.1240128249999, 55.71548086100006],
              [-130.13060462099992, 55.73627350500004],
              [-130.12881425699993, 55.75922272300005],
              [-130.11558997299994, 55.77997467700004],
              [-130.03368079299992, 55.848822333000044],
              [-129.98473059799994, 55.905462958000044],
              [-129.96133378799993, 55.92084381700005],
              [-129.96996008999992, 55.931626695000034],
              [-129.98208574099993, 55.93512604400007],
              [-129.99596106699994, 55.93341705900008],
              [-130.0097550119999, 55.92829010600008],
              [-130.0196184442999, 55.907951850414136],
              [-130.0167878829999, 55.91891347300002],
              [-130.01469498799992, 55.963251852000084],
              [-130.01900996999987, 56.00221588200007],
              [-130.02663224299994, 56.024100851000114],
              [-130.0393188079999, 56.04552073200004],
              [-130.07153906299993, 56.08412302700002],
              [-130.09432836999991, 56.10148630800005],
              [-130.11675594199994, 56.105646261000075],
              [-130.2112462979999, 56.08996246400001],
              [-130.24315649499997, 56.092391256000056],
              [-130.29031123999988, 56.10096954400008],
              [-130.40397355199985, 56.12189849900007],
              [-130.41815873299993, 56.12970164000011],
              [-130.42792557799987, 56.143964335000064],
              [-130.45805293899986, 56.210652771000085],
              [-130.47228979599993, 56.22488962800007],
              [-130.49551835199992, 56.232434388000016],
              [-130.60225602299994, 56.24705881800007],
              [-130.64576757899997, 56.26194163100003],
              [-130.7603342299999, 56.34519236300004],
              [-130.8390891119999, 56.372451681000044],
              [-131.01693355399993, 56.387050273000014],
              [-131.10054602099993, 56.40766916900013],
              [-131.21560359799992, 56.452550151000125],
              [-131.34569901599994, 56.503270569],
              [-131.4916590989999, 56.56016632100007],
              [-131.53643672799987, 56.585229391000055],
              [-131.56036291499996, 56.59406606100008],
              [-131.5858910729999, 56.59504791300013],
              [-131.69229284699992, 56.585074361000025],
              [-131.79910803299992, 56.58765818300013],
              [-131.82559220399992, 56.59334259100008],
              [-131.8321034349999, 56.603367818],
              [-131.8265740559999, 56.64460561100002],
              [-131.83042395099994, 56.66475942000007],
              [-131.83897640099985, 56.68227773100004],
              [-131.86478877799988, 56.71349029600002],
              [-131.8807051189999, 56.7288381960001],
              [-131.88602779199994, 56.73705474900002],
              [-131.88796565799987, 56.74795847600008],
              [-131.88261714799992, 56.759146424000036],
              [-131.87241105199985, 56.77296986900008],
              [-131.86587398399988, 56.785708110000044],
              [-131.87155839099992, 56.79345957500006],
              [-132.10738378999991, 56.858752747],
              [-132.03185868399987, 57.02840647400008],
              [-132.1622899989999, 57.050317281000034],
              [-132.34121964599993, 57.080392965],
              [-132.2763657229999, 57.14889007600003],
              [-132.23099381599988, 57.19681996700005],
              [-132.3046844079999, 57.28035491900003],
              [-132.36230362999996, 57.34569976799999],
              [-132.45573461999993, 57.42099233000006],
              [-132.55244706299993, 57.49907542000007],
              [-132.62905737299994, 57.57927724200006],
              [-132.70944006399986, 57.66330312200007],
              [-132.83211991399992, 57.791564026000046],
              [-132.91715348399993, 57.880499166],
              [-132.99335038299992, 57.94191660600008],
              [-133.07515417499994, 58.00788157200002],
              [-133.0948428959999, 58.033099670000055],
              [-133.14212683199995, 58.12058787000002],
              [-133.16558793199994, 58.14730458600009],
              [-133.25726192299993, 58.21029815700011],
              [-133.3745674239999, 58.290965068000034],
              [-133.4150300699999, 58.33054921500009],
              [-133.4301195889999, 58.37209706700007],
              [-133.3922407639999, 58.40387807200001],
              [-133.46308915199984, 58.462220764000065],
              [-133.54706335499986, 58.50557729100005],
              [-133.6262833259999, 58.546401673000034],
              [-133.70007727099994, 58.59937001600012],
              [-133.79640214099993, 58.69342112300008],
              [-133.83112870399995, 58.71801910400005],
              [-133.87122961499983, 58.73589915000012],
              [-133.98310909099996, 58.76990224200004],
              [-134.10883785099992, 58.80824615500008],
              [-134.22219010499992, 58.84271433500005],
              [-134.31693884399994, 58.903795878000025],
              [-134.3274033209999, 58.91645660400006],
              [-134.33303605199993, 58.934129945000066],
              [-134.3303230389999, 58.94534373000003],
              [-134.32314001499992, 58.949167786000075],
              [-134.3200394289999, 58.952681784000035],
              [-134.32965124499992, 58.96301707000002],
              [-134.34342301499993, 58.96885650600002],
              [-134.39938859199995, 58.97495432600006],
              [-134.38559098399992, 59.01882761600008],
              [-134.38716711499993, 59.0368626920001],
              [-134.39801916599987, 59.051952210000096],
              [-134.4510133469999, 59.09789255800008],
              [-134.47757503299988, 59.11494578100009],
              [-134.50907181899993, 59.12280059900003],
              [-134.5567174899999, 59.12305898000001],
              [-134.5827882489999, 59.12884674100009],
              [-134.610771038, 59.14455637600004],
              [-134.66038041299996, 59.18129832000004],
              [-134.67143916899997, 59.19375234000002],
              [-134.6828596609999, 59.22300120100006],
              [-134.69208390299988, 59.235248515000094],
              [-134.70551977599993, 59.2401061],
              [-134.74345027799993, 59.24511871400007],
              [-134.83946508799994, 59.258141174000016],
              [-134.93243098999997, 59.27064687200003],
              [-134.9578299559999, 59.2809821580001],
              [-134.9799733079999, 59.297415263000076],
              [-135.01619848699994, 59.33617258700012],
              [-135.01444148899998, 59.35152048800008],
              [-135.00482967199994, 59.36712677000013],
              [-134.99325415099992, 59.38190623000004],
              [-135.09575435399987, 59.418854879],
              [-135.0785977789999, 59.43833689399999],
              [-135.03748917699994, 59.46159128900008],
              [-135.02325231999995, 59.47714589500002],
              [-135.01947993999994, 59.49316558900007],
              [-135.01619848699994, 59.54344675700004],
              [-135.01852392599997, 59.559363099000066],
              [-135.03294165099987, 59.57310902900009],
              [-135.0878736989999, 59.606543681000076],
              [-135.1066839199999, 59.61315826500008],
              [-135.15779191099992, 59.62328684500004],
              [-135.1920275479999, 59.6471096800001],
              [-135.22189652499992, 59.675273336000046],
              [-135.25987870299994, 59.69821767200007],
              [-135.3457907719999, 59.73103220700001],
              [-135.4043918459999, 59.753304749000065],
              [-135.46513749299993, 59.789684957000034],
              [-135.48275915599993, 59.79247548400009],
              [-135.64125077399987, 59.74736196000005],
              [-135.8309549559999, 59.69325673400003],
              [-135.92381750599995, 59.66674672500004],
              [-136.02686031099984, 59.652845765000066],
              [-136.14540604699994, 59.63682607],
              [-136.2584999189999, 59.621581523000074],
              [-136.35032893999994, 59.59238433900002],
              [-136.2993501389999, 59.5757445280001],
              [-136.25847408199988, 59.556107483000076],
              [-136.24472814999996, 59.52820221000009],
              [-136.27503637799987, 59.48644765300004],
              [-136.3199948729999, 59.459059143],
              [-136.3668395599999, 59.44955068000003],
              [-136.41595800799988, 59.452237854000046],
              [-136.46755692599987, 59.46164296500011],
              [-136.46709183799996, 59.38449005200003],
              [-136.4665492359999, 59.28780344700006],
              [-136.48355078199992, 59.257469381000035],
              [-136.48479101599986, 59.253800355000024],
              [-136.56948868899988, 59.17215159100006],
              [-136.61349117099994, 59.15421987000006],
              [-136.6719113779999, 59.15080922500006],
              [-136.78549617599987, 59.157217102000075],
              [-136.8408157969999, 59.14817372700004],
              [-136.94228247099997, 59.11107004800006],
              [-137.0471085279999, 59.07330963800008],
              [-137.06236731699994, 59.06757233300003],
              [-137.17234594799987, 59.02714752300004],
              [-137.28189998399984, 58.98714996400007],
              [-137.33809810499991, 58.955472311000065],
              [-137.42310583599993, 58.90772328700011],
              [-137.45346573899985, 58.89914499900006],
              [-137.48687455299984, 58.900075175000026],
              [-137.50875952199988, 58.91490631200004],
              [-137.5077518319999, 58.93996938100007],
              [-137.48439408499988, 58.99190419600008],
              [-137.5210068369999, 59.07236440100003],
              [-137.5492996839999, 59.13453114900004],
              [-137.5820883789999, 59.20656809600008],
              [-137.5941806649999, 59.22527496400009],
              [-137.61136307799987, 59.239330954000096],
              [-137.7583050139999, 59.31591542600002],
              [-137.91056962199985, 59.39518707300006],
              [-138.06761429899993, 59.476990865000076],
              [-138.2195430099999, 59.556004130000034],
              [-138.36361690299995, 59.631141663000065],
              [-138.48888057499988, 59.696357321000065],
              [-138.59920975799986, 59.753821513],
              [-138.63745031799994, 59.7840522260001],
              [-138.65434851099997, 59.80549794500003],
              [-138.6920981449999, 59.88688832600006],
              [-138.6971882739999, 59.893709616000095],
              [-138.7048880619999, 59.89846384700009],
              [-138.74258601899993, 59.91319163100009],
              [-138.84242488699994, 59.937686259000046],
              [-139.0037587079999, 59.977218730000075],
              [-139.05161108499988, 59.99489207],
              [-139.06020662199992, 60.000058906000035],
              [-139.11230505499987, 60.03137563100002],
              [-139.18214575299996, 60.07338857000012],
              [-139.18323095699995, 60.10015696300009],
              [-139.14961543899992, 60.16118682900007],
              [-139.1134677739999, 60.22681589800003],
              [-139.07318599499985, 60.29983469700004],
              [-139.06869014599994, 60.32205556300009],
              [-139.07946468099993, 60.34102081300004],
              [-139.10160803299996, 60.346601868000064],
              [-139.2621925459999, 60.34277781200002],
              [-139.41399206599993, 60.339212138000036],
              [-139.5179650479999, 60.33673167000008],
              [-139.62834590799991, 60.33409617100007],
              [-139.67981563299986, 60.32680979499999],
              [-139.72841731799988, 60.30903310200004],
              [-139.826318319, 60.25647817000008],
              [-139.9169329439999, 60.20785064700006],
              [-139.9677567139999, 60.18836863200006],
              [-140.01578995799986, 60.1873867800001],
              [-140.16924312399993, 60.22722931000003],
              [-140.32497005299987, 60.26753692700008],
              [-140.4241112879999, 60.293168437000034],
              [-140.44780493299993, 60.29446034800007],
              [-140.4627910979999, 60.28913767500005],
              [-140.47532263199992, 60.27647695000009],
              [-140.50666438899992, 60.23632436100009],
              [-140.51870499699993, 60.22387034100011],
              [-140.5337428389999, 60.218547669000074],
              [-140.66050512799995, 60.240510153000045],
              [-140.76845719499997, 60.259268697000024],
              [-140.9091462809999, 60.28365997300004],
              [-140.97955542099993, 60.29580393500005],
              [-140.9949291599999, 60.304382223000076],
              [-141.0011561689999, 60.32107371000002],
              [-141.00120784599991, 60.46687876500003],
              [-141.00128535999994, 60.612683818000065],
              [-141.00136287499993, 60.75841135700004],
              [-141.00144038999986, 60.904216411000064],
              [-141.0015179039999, 61.04996978800007],
              [-141.0015954189999, 61.195826518],
              [-141.00167293399994, 61.341579896],
              [-141.00175044799994, 61.4873332720001],
              [-141.00182796299987, 61.63308665000001],
              [-141.0019054779999, 61.778865865000014],
              [-141.0019829919999, 61.924619243],
              [-141.00200883099993, 62.070372620000015],
              [-141.00206050599994, 62.216229350000035],
              [-141.00213802199994, 62.36198272800006],
              [-141.002215536, 62.50776194300006],
              [-141.0022930499999, 62.65359283500008],
              [-141.0023705659999, 62.79932037400006],
              [-141.00244807999994, 62.94509959],
              [-141.00252559399988, 63.090878805],
              [-141.0025514329999, 63.23665802],
              [-141.00260310999988, 63.38248891200003],
              [-141.0026806239999, 63.52826812800005],
              [-141.00275813799993, 63.67409902000007],
              [-141.00283565399997, 63.81977488300005],
              [-141.00291316799988, 63.96550242200003],
              [-141.0029906819999, 64.11128163700003],
              [-141.0030681979999, 64.25711252900005],
              [-141.00309403499992, 64.40289174400009],
              [-141.00314571199993, 64.54867096],
              [-141.00322322599993, 64.69450185200002],
              [-141.00330074099986, 64.84022939100002],
              [-141.0033782559999, 64.98600860600003],
              [-141.0034557699999, 65.13178782100003],
              [-141.00353328499983, 65.27756703700003],
              [-141.00361079999996, 65.42337209100005],
              [-141.00363663899986, 65.56917714500007],
              [-141.00368831399987, 65.71495636100006],
              [-141.00376582899992, 65.86073557600007],
              [-141.0038433439999, 66.0065147910001],
              [-141.00392085799984, 66.1522681690001],
              [-141.00399837299994, 66.2980215460001],
              [-141.00407588799987, 66.443774923],
              [-141.00415340199993, 66.58957997600002],
              [-141.00420507799993, 66.73541086800005],
              [-141.00423091699992, 66.88113840800004],
              [-141.00430843199985, 67.02691762400003],
              [-141.00438594599987, 67.17272267700007],
              [-141.0044634609999, 67.31847605400007],
              [-141.00454097599993, 67.46428110800007],
              [-141.00461848999993, 67.61008616200009],
              [-141.00469600499997, 67.7558137010001],
              [-141.00474768199987, 67.90164459300011],
              [-141.00477351899988, 68.04742380800012],
              [-141.0048510339999, 68.19320302300004],
              [-141.0049285489999, 68.33898223900003],
              [-141.00500606299994, 68.48470977900003],
              [-141.00508357799995, 68.63048899400003],
              [-141.00516109299988, 68.77626820900007],
              [-141.0052386069999, 68.92204742500006],
              [-141.0052902839999, 69.06782664000006],
              [-141.00531612199993, 69.21360585600009],
              [-141.00539363699994, 69.35938507100009],
              [-141.00547115099997, 69.5051642860001],
              [-141.00556393099993, 69.65094635600008],
              [-140.9898168609999, 69.64565664300005],
              [-140.8985082669999, 69.64057038000004],
              [-140.90078691299993, 69.63711172100005],
              [-140.90099036399994, 69.63597239800004],
              [-140.90172278599994, 69.63532135600008],
              [-140.90591386599993, 69.63312409100007],
              [-140.89037024599992, 69.62718333500004],
              [-140.8730362619999, 69.62543366100005],
              [-140.83702551999994, 69.62628815300008],
              [-140.8399145169999, 69.63035716400003],
              [-140.8432511059999, 69.63312409100007],
              [-140.81924394399994, 69.63812897300005],
              [-140.6435440749999, 69.61635976800005],
              [-140.40514075399994, 69.60146719000005],
              [-140.2227270169999, 69.59910716400003],
              [-140.15269934799994, 69.61880117400005],
              [-139.9179581369999, 69.62132396000004],
              [-139.60997473899994, 69.58295319200005],
              [-139.5998429029999, 69.57973867400005],
              [-139.7127172519999, 69.58779531500005],
              [-139.77456620999993, 69.60016510600008],
              [-139.7475479809999, 69.58535390800006],
              [-139.70055091099994, 69.57436758000006],
              [-139.3635147779999, 69.54433828300006],
              [-139.3135473299999, 69.52033112200007],
              [-139.2949926419999, 69.51703522300005],
              [-139.14378821499992, 69.51365794500003],
              [-139.1093643869999, 69.49900950700004],
              [-139.0475968089999, 69.45433177300004],
              [-139.0303442049999, 69.44220612200007],
              [-138.9939672519999, 69.42218659100007],
              [-138.95567786399994, 69.40664297100005],
              [-138.76646887899994, 69.35911692900004],
              [-138.7245987619999, 69.33038971600007],
              [-138.6643774079999, 69.30133698100008],
              [-138.6367081369999, 69.28367747600004],
              [-138.60850989499994, 69.24860260600008],
              [-138.6026098299999, 69.24266185100004],
              [-138.5891820949999, 69.24119700700004],
              [-138.57949785099993, 69.24567291900007],
              [-138.5711156889999, 69.25202057500007],
              [-138.56163489499994, 69.25633372600004],
              [-138.5484106109999, 69.25771719000005],
              [-138.50698808499993, 69.25633372600004],
              [-138.50698808499993, 69.24949778900003],
              [-138.52745520699995, 69.24949778900003],
              [-138.51528886599993, 69.24445221600007],
              [-138.4846899079999, 69.23651764500005],
              [-138.4514867829999, 69.23432038000004],
              [-138.44493567599994, 69.23525625200006],
              [-138.44383704299992, 69.23798248900005],
              [-138.44505774599992, 69.24286530200004],
              [-138.4453832669999, 69.24746328300006],
              [-138.44151770699995, 69.24949778900003],
              [-138.4182836579999, 69.25458405200004],
              [-138.40957597599993, 69.26707591400003],
              [-138.40591386599993, 69.28290436400005],
              [-138.3977758449999, 69.29791901200008],
              [-138.41201738199993, 69.29755280200004],
              [-138.42564856699994, 69.29437897300005],
              [-138.45177161399994, 69.28367747600004],
              [-138.4270727199999, 69.30158112200007],
              [-138.39037024599992, 69.30902741100005],
              [-138.35704505099994, 69.30467357000003],
              [-138.3425186839999, 69.28705475500004],
              [-138.33926347599993, 69.25849030200004],
              [-138.32933508999992, 69.24160390800006],
              [-138.31236731699994, 69.22947825700004],
              [-138.22716223899994, 69.18329498900005],
              [-138.0955297519999, 69.14012278900003],
              [-137.8694555329999, 69.09186432500007],
              [-137.51821855399993, 69.01683177300004],
              [-137.42471269399994, 69.01422760600008],
              [-137.38292395699995, 69.00311920800004],
              [-137.43130449099993, 69.00311920800004],
              [-137.43130449099993, 68.99567291900007],
              [-137.30040442599994, 68.97516510600008],
              [-137.22374426999994, 68.95091380400004],
              [-137.19115149599992, 68.94790273600006],
              [-137.0607804029999, 68.95473867400005],
              [-136.9925024079999, 68.94790273600006],
              [-136.98607337099992, 68.94464752800008],
              [-136.9712621739999, 68.93060944200005],
              [-136.96178137899994, 68.92739492400005],
              [-136.9053442049999, 68.92072174700007],
              [-136.8010961579999, 68.88910553600005],
              [-136.74547278599994, 68.87897370000007],
              [-136.66299394399994, 68.87579987200007],
              [-136.64305579299992, 68.87897370000007],
              [-136.63390051999994, 68.88410065300008],
              [-136.62608801999994, 68.89093659100007],
              [-136.61632239499994, 68.89691803600005],
              [-136.60147050699993, 68.89948151200008],
              [-136.52574622299994, 68.89325592700004],
              [-136.53604081899994, 68.89809804900005],
              [-136.5400284499999, 68.89948151200008],
              [-136.5400284499999, 68.90692780200004],
              [-136.50064042899993, 68.91592031500005],
              [-136.45885169199994, 68.91254303600005],
              [-136.4448542959999, 68.90989817900004],
              [-136.41649329299992, 68.90448639500005],
              [-136.23912512899994, 68.88641998900005],
              [-136.06761633999992, 68.88532135600008],
              [-135.88149980399993, 68.85024648600006],
              [-135.85366777299993, 68.83730703300006],
              [-135.78160559799994, 68.82160065300008],
              [-135.7720434239999, 68.81362539300005],
              [-135.7586156889999, 68.79706452000005],
              [-135.73375403599994, 68.78457265800006],
              [-135.7026261059999, 68.77505117400005],
              [-135.63565019399994, 68.76288483300004],
              [-135.5185440749999, 68.75507233300004],
              [-135.4882706369999, 68.73899974200003],
              [-135.48009192599994, 68.73135000200006],
              [-135.46206620999993, 68.71800364800004],
              [-135.4439184239999, 68.70819733300004],
              [-135.4265844389999, 68.70246002800008],
              [-135.41934160099993, 68.70140208500004],
              [-135.41226152299993, 68.69863515800006],
              [-135.41079667899993, 68.69204336100006],
              [-135.4112035799999, 68.68504466400003],
              [-135.40977942599994, 68.68097565300008],
              [-135.37877356699994, 68.67401764500005],
              [-135.2912491529999, 68.68720123900005],
              [-135.25601152299993, 68.68227773600006],
              [-135.18675696499992, 68.66242096600007],
              [-135.14903723899994, 68.66046784100007],
              [-135.1624242829999, 68.67243073100008],
              [-135.19977779899995, 68.67475006700005],
              [-135.2111710279999, 68.68720123900005],
              [-135.2051488919999, 68.68854401200008],
              [-135.19005286399994, 68.69399648600006],
              [-135.21890214799993, 68.69696686400005],
              [-135.2717992829999, 68.71710846600007],
              [-135.32168535099993, 68.72614166900007],
              [-135.3354386059999, 68.73655833500004],
              [-135.3588761059999, 68.77041250200006],
              [-135.36172441299993, 68.77716705900008],
              [-135.3679093089999, 68.78213125200006],
              [-135.39708411399994, 68.78603750200006],
              [-135.42593339799993, 68.79498932500007],
              [-135.46182206899994, 68.80093008000006],
              [-135.48033606699994, 68.81142812700006],
              [-135.49502519399994, 68.82672760600008],
              [-135.5053604809999, 68.84544505400004],
              [-135.3408910799999, 68.83860911700003],
              [-135.40953528599994, 68.85350169500003],
              [-135.5703018869999, 68.85927969000005],
              [-135.6282445949999, 68.89325592700004],
              [-135.61510169199994, 68.89964427300004],
              [-135.60606848899994, 68.91136302300004],
              [-135.82485917899993, 68.90338776200008],
              [-135.8684789699999, 68.90692780200004],
              [-136.00499426999994, 68.94790273600006],
              [-135.99356035099993, 68.96596914300005],
              [-135.97134355399993, 68.96824778900003],
              [-135.92308508999992, 68.96214427300004],
              [-135.92308508999992, 68.96832916900007],
              [-135.97378495999993, 68.99551015800006],
              [-135.99058997299994, 69.01593659100007],
              [-135.9817602199999, 69.04067617400005],
              [-135.9541723299999, 69.04840729400007],
              [-135.91649329299992, 69.03925202000005],
              [-135.8479711579999, 69.00934479400007],
              [-135.76992753799993, 68.99152252800008],
              [-135.68130449099993, 68.99152252800008],
              [-135.5938207669999, 69.00556061400005],
              [-135.5190323559999, 69.02977122600004],
              [-135.69497636599993, 69.01536692900004],
              [-135.70738684799994, 69.02020905200004],
              [-135.7122289699999, 69.02728913000004],
              [-135.71568762899994, 69.04035065300008],
              [-135.72134355399993, 69.04718659100007],
              [-135.74254309799994, 69.05931224200003],
              [-135.9194229809999, 69.09349192900004],
              [-135.93667558499993, 69.10553620000007],
              [-135.95034745999993, 69.16014232000003],
              [-135.96328691299993, 69.18891022300005],
              [-135.96910559799994, 69.20722077000005],
              [-135.9677628249999, 69.22215403900003],
              [-135.9338272779999, 69.25413646000004],
              [-135.8945206369999, 69.25165436400005],
              [-135.8132218089999, 69.21539948100008],
              [-135.7879125639999, 69.20917389500005],
              [-135.77822831899994, 69.20514557500007],
              [-135.75157630099994, 69.18398672100005],
              [-135.58804277299993, 69.12490469000005],
              [-135.47203528599994, 69.11513906500005],
              [-135.41592363199993, 69.09870026200008],
              [-135.4331762359999, 69.11758047100005],
              [-135.47622636599993, 69.13027578300006],
              [-135.59300696499992, 69.14325592700004],
              [-135.62535559799994, 69.15265534100007],
              [-135.83629309799994, 69.26093170800004],
              [-135.85537675699993, 69.29047272300005],
              [-135.8378800119999, 69.30906810100004],
              [-135.8041886059999, 69.32184479400007],
              [-135.76683508999992, 69.32908763200004],
              [-135.70152747299994, 69.33283112200007],
              [-135.6821996739999, 69.33026764500005],
              [-135.66612708199995, 69.32184479400007],
              [-135.6612035799999, 69.31818268400008],
              [-135.65086829299992, 69.31220123900005],
              [-135.64561926999994, 69.30756256700005],
              [-135.6431371739999, 69.30174388200004],
              [-135.6440323559999, 69.28900788000004],
              [-135.64248613199993, 69.28367747600004],
              [-135.62804114499994, 69.26862213700008],
              [-135.58385169199994, 69.23541901200008],
              [-135.5673721999999, 69.22907135600008],
              [-135.55703691299993, 69.23871491100005],
              [-135.56956946499992, 69.26068756700005],
              [-135.6015518869999, 69.29791901200008],
              [-135.6096899079999, 69.31216054900005],
              [-135.61314856699994, 69.32160065300008],
              [-135.6121313139999, 69.32831452000005],
              [-135.60098222599993, 69.33584219000005],
              [-135.58568274599992, 69.34174225500004],
              [-135.5693253249999, 69.34467194200005],
              [-135.51553300699993, 69.33828359600005],
              [-135.47354081899994, 69.33836497600004],
              [-135.4334203769999, 69.33392975500004],
              [-135.3740942049999, 69.29954661700003],
              [-135.3393448559999, 69.28896719000005],
              [-135.17589270699995, 69.26215241100005],
              [-135.16665605399993, 69.26300690300008],
              [-135.16270911399994, 69.26654694200005],
              [-135.1629125639999, 69.27228424700007],
              [-135.16397050699993, 69.27781810100004],
              [-135.16690019399994, 69.28204987200007],
              [-135.1726781889999, 69.28367747600004],
              [-135.1863500639999, 69.28554922100005],
              [-135.20348059799994, 69.29047272300005],
              [-135.2197973299999, 69.29706452000005],
              [-135.2310277989999, 69.30414459800005],
              [-135.2398168609999, 69.31500885600008],
              [-135.23997962099992, 69.32168203300006],
              [-135.23745683499993, 69.32827383000006],
              [-135.23843339799993, 69.33893463700008],
              [-135.2448624339999, 69.35675690300008],
              [-135.24868730399993, 69.36245351800005],
              [-135.25548255099994, 69.36961497600004],
              [-135.27599036399994, 69.40033600500004],
              [-135.28237870999993, 69.40460846600007],
              [-135.28433183499993, 69.41453685100004],
              [-135.2830297519999, 69.42597077000005],
              [-135.27940833199995, 69.43451569200005],
              [-135.2671606109999, 69.44183991100005],
              [-135.2111710279999, 69.45433177300004],
              [-135.15538489499994, 69.47972239800004],
              [-135.12661699099993, 69.48236725500004],
              [-135.10806230399993, 69.46181875200006],
              [-135.09947669199994, 69.47247955900008],
              [-135.08873450399994, 69.47846100500004],
              [-135.0756729809999, 69.48118724200003],
              [-135.06029212099992, 69.48224518400008],
              [-135.06651770699995, 69.48224518400008],
              [-135.0353897779999, 69.48859284100007],
              [-134.97899329299992, 69.47821686400005],
              [-134.95042883999992, 69.47606028900003],
              [-134.8935440749999, 69.48969147300005],
              [-134.86294511599993, 69.49339427300004],
              [-134.81891842399995, 69.48265208500004],
              [-134.81114661399994, 69.48908112200007],
              [-134.8064672519999, 69.50275299700007],
              [-134.79405676999994, 69.49957916900007],
              [-134.78795325399994, 69.49323151200008],
              [-134.7841690749999, 69.48647695500006],
              [-134.7791235019999, 69.48224518400008],
              [-134.7460831369999, 69.47809479400007],
              [-134.6413468089999, 69.48224518400008],
              [-134.53355872299994, 69.45038483300004],
              [-134.47630774599992, 69.44379303600005],
              [-134.42593339799993, 69.46523672100005],
              [-134.41641191299993, 69.49746328300006],
              [-134.45030676999994, 69.51675039300005],
              [-134.5003149079999, 69.51788971600007],
              [-134.53892981699994, 69.49591705900008],
              [-134.5288793609999, 69.48529694200005],
              [-134.52525794199994, 69.48224518400008],
              [-134.54137122299994, 69.47557200700004],
              [-134.5573624339999, 69.47931549700007],
              [-134.58731035099993, 69.49591705900008],
              [-134.57681230399993, 69.50665924700007],
              [-134.5730688139999, 69.50958893400008],
              [-134.5944718089999, 69.51288483300004],
              [-134.59459387899994, 69.52753327000005],
              [-134.58413652299993, 69.54364655200004],
              [-134.57335364499994, 69.55117422100005],
              [-134.55972245999993, 69.54922109600005],
              [-134.53921464799993, 69.53994375200006],
              [-134.52525794199994, 69.53685130400004],
              [-134.51162675699993, 69.53766510600008],
              [-134.48521887899994, 69.54368724200003],
              [-134.47126217399995, 69.54433828300006],
              [-134.49111894399994, 69.56419505400004],
              [-134.48717200399994, 69.56834544500003],
              [-134.4683324859999, 69.58226146000004],
              [-134.4416397779999, 69.59105052300004],
              [-134.42735755099994, 69.60488515800006],
              [-134.40550696499992, 69.63686758000006],
              [-134.41006425699993, 69.65692780200004],
              [-134.4387914699999, 69.68183014500005],
              [-134.49795488199993, 69.72247955900008],
              [-134.48094641799992, 69.72748444200005],
              [-134.4641820949999, 69.72418854400007],
              [-134.44713294199994, 69.71824778900003],
              [-134.42935136599993, 69.71503327000005],
              [-134.41051184799994, 69.71775950700004],
              [-134.3749893869999, 69.72711823100008],
              [-134.34300696499992, 69.72280508000006],
              [-134.32852128799993, 69.72516510600008],
              [-134.3198949859999, 69.72357819200005],
              [-134.31920325399994, 69.70880768400008],
              [-134.32347571499992, 69.69672272300005],
              [-134.33096269399994, 69.68960195500006],
              [-134.34117591099994, 69.68524811400005],
              [-134.35399329299992, 69.68154531500005],
              [-134.3347875639999, 69.67328522300005],
              [-134.25572669199994, 69.68260325700004],
              [-134.22423255099994, 69.68154531500005],
              [-134.2058813139999, 69.67011139500005],
              [-134.19115149599992, 69.65550364800004],
              [-134.17418372299994, 69.64374420800004],
              [-134.1491593089999, 69.64057038000004],
              [-134.1491593089999, 69.63312409100007],
              [-134.19701087099992, 69.62042877800008],
              [-134.21963456899994, 69.60952383000006],
              [-134.2372940749999, 69.59210846600007],
              [-134.2424210279999, 69.57721588700008],
              [-134.22940019399994, 69.57892487200007],
              [-134.20759029899995, 69.58714427300004],
              [-134.18639075399994, 69.59210846600007],
              [-134.17784583199995, 69.58779531500005],
              [-134.17393958199995, 69.56854889500005],
              [-134.16588294199994, 69.56419505400004],
              [-134.1538793609999, 69.56110260600008],
              [-134.13243567599994, 69.54743073100008],
              [-134.1209203769999, 69.54433828300006],
              [-134.09142005099994, 69.54865143400008],
              [-134.06432044199994, 69.55687083500004],
              [-134.03636633999992, 69.56224192900004],
              [-134.00450598899994, 69.55805084800005],
              [-134.01187089799993, 69.54669830900008],
              [-134.0241593089999, 69.53998444200005],
              [-134.0523168609999, 69.53070709800005],
              [-133.9982804029999, 69.53070709800005],
              [-133.9850968089999, 69.52814362200007],
              [-133.9766332669999, 69.52440013200004],
              [-133.97008216099994, 69.52041250200006],
              [-133.9629613919999, 69.51703522300005],
              [-133.94249426999994, 69.51300690300008],
              [-133.91466223899994, 69.51166413000004],
              [-133.8854874339999, 69.51459381700005],
              [-133.8611547519999, 69.52326080900008],
              [-133.8662003249999, 69.52619049700007],
              [-133.8757218089999, 69.53388092700004],
              [-133.88097083199995, 69.53685130400004],
              [-133.8609106109999, 69.54385000200006],
              [-133.8184301419999, 69.54450104400007],
              [-133.7990616529999, 69.55117422100005],
              [-133.80581620999993, 69.55288320500006],
              [-133.8181860019999, 69.55735911700003],
              [-133.8257543609999, 69.55805084800005],
              [-133.81899980399993, 69.56952545800004],
              [-133.80772864499994, 69.57611725500004],
              [-133.79360917899993, 69.57868073100008],
              [-133.77855383999992, 69.57786692900004],
              [-133.78099524599992, 69.57412344000005],
              [-133.78477942599994, 69.57168203300006],
              [-133.7783096999999, 69.56289297100005],
              [-133.7704971999999, 69.55646393400008],
              [-133.76146399599992, 69.55247630400004],
              [-133.7512914699999, 69.55117422100005],
              [-133.76024329299992, 69.53925202000005],
              [-133.7866918609999, 69.53668854400007],
              [-133.79222571499992, 69.52700429900005],
              [-133.78994706899994, 69.52138906500005],
              [-133.7802628249999, 69.50812409100007],
              [-133.77855383999992, 69.50275299700007],
              [-133.78111731699994, 69.49388255400004],
              [-133.78404700399994, 69.49201080900008],
              [-133.78844153599994, 69.49140045800004],
              [-133.81810462099992, 69.46735260600008],
              [-133.84536699099993, 69.45209381700005],
              [-134.0301000639999, 69.38320547100005],
              [-134.09219316299993, 69.34479401200008],
              [-134.10069739499994, 69.29791901200008],
              [-134.1690160799999, 69.29791901200008],
              [-134.1807348299999, 69.29462311400005],
              [-134.20348059799994, 69.28017812700006],
              [-134.21397864499994, 69.27680084800005],
              [-134.2222387359999, 69.27260976800005],
              [-134.22500566299993, 69.26312897300005],
              [-134.22899329299992, 69.25381094000005],
              [-134.24071204299992, 69.24949778900003],
              [-134.25308183499993, 69.24713776200008],
              [-134.26333574099993, 69.24091217700004],
              [-134.2717179029999, 69.23212311400005],
              [-134.27822831899994, 69.22215403900003],
              [-134.28160559799994, 69.21234772300005],
              [-134.27920488199993, 69.20770905200004],
              [-134.2764379549999, 69.20355866100005],
              [-134.27822831899994, 69.19489166900007],
              [-134.2834366529999, 69.18561432500007],
              [-134.28819739499994, 69.18158600500004],
              [-134.3046768869999, 69.17365143400008],
              [-134.31297766799992, 69.15395742400005],
              [-134.30186926999994, 69.15753815300008],
              [-134.27647864499994, 69.15802643400008],
              [-134.26455644399994, 69.16014232000003],
              [-134.2460831369999, 69.16950104400007],
              [-134.2372940749999, 69.17999909100007],
              [-134.22423255099994, 69.20856354400007],
              [-134.19810950399994, 69.23651764500005],
              [-134.1629125639999, 69.25568268400008],
              [-134.12222245999993, 69.26654694200005],
              [-134.00011145699995, 69.27313873900005],
              [-133.9545792309999, 69.28636302300004],
              [-133.9063207669999, 69.29051341400003],
              [-133.88467363199993, 69.30101146000004],
              [-133.8720596999999, 69.31586334800005],
              [-133.8710831369999, 69.32514069200005],
              [-133.86929277299993, 69.33250560100004],
              [-133.8543188139999, 69.34198639500005],
              [-133.8416235019999, 69.34540436400005],
              [-133.79938717399995, 69.34511953300006],
              [-133.78555253799993, 69.34715403900003],
              [-133.75816809799994, 69.35675690300008],
              [-133.74380449099993, 69.35936107000003],
              [-133.7459203769999, 69.35492584800005],
              [-133.74925696499992, 69.34357330900008],
              [-133.7512914699999, 69.33893463700008],
              [-133.70396887899994, 69.33926015800006],
              [-133.68203691299993, 69.34316640800006],
              [-133.66185462099992, 69.35252513200004],
              [-133.6785375639999, 69.36029694200005],
              [-133.69664466099994, 69.36619700700004],
              [-133.6713761059999, 69.38837311400005],
              [-133.6319067049999, 69.39915599200003],
              [-133.46336829299992, 69.41771067900004],
              [-133.2578018869999, 69.41400788000004],
              [-133.24840247299994, 69.41107819200005],
              [-133.23692786399994, 69.40224844000005],
              [-133.2267960279999, 69.40033600500004],
              [-133.21572831899994, 69.40159739800004],
              [-133.2097061839999, 69.40493398600006],
              [-133.20449785099993, 69.40932851800005],
              [-133.19579016799992, 69.41400788000004],
              [-133.0894262359999, 69.44505442900004],
              [-133.0828344389999, 69.44472890800006],
              [-133.0749405589999, 69.43952057500007],
              [-133.06554114499994, 69.43622467700004],
              [-133.0554093089999, 69.43455638200004],
              [-133.04552161399994, 69.43451569200005],
              [-133.05211341099994, 69.44798411700003],
              [-133.0550024079999, 69.46377187700006],
              [-133.0495499339999, 69.47687409100007],
              [-133.0313207669999, 69.48224518400008],
              [-133.00723222599993, 69.48655833500004],
              [-132.99669348899994, 69.49652741100005],
              [-132.98802649599992, 69.50812409100007],
              [-132.96983801999994, 69.51703522300005],
              [-132.98399817599994, 69.52509186400005],
              [-132.98110917899993, 69.53546784100007],
              [-132.95958411399994, 69.55459219000005],
              [-132.95421301999994, 69.56818268400008],
              [-132.96336829299992, 69.57843659100007],
              [-132.99087480399993, 69.59210846600007],
              [-132.9756567049999, 69.61432526200008],
              [-132.94688880099994, 69.63458893400008],
              [-132.88727779899995, 69.66107819200005],
              [-132.77122962099992, 69.66107819200005],
              [-132.77940833199995, 69.65692780200004],
              [-132.7870987619999, 69.65200429900005],
              [-132.79381262899994, 69.64642975500004],
              [-132.7991430329999, 69.64057038000004],
              [-132.72378495999993, 69.63800690300008],
              [-132.7063695949999, 69.64362213700008],
              [-132.68797766799992, 69.65517812700006],
              [-132.67052161399994, 69.65770091400003],
              [-132.60684160099993, 69.65180084800005],
              [-132.55211341099994, 69.63312409100007],
              [-132.5301000639999, 69.63198476800005],
              [-132.3850805329999, 69.64667389500005],
              [-132.34854081899994, 69.65985748900005],
              [-132.3329971999999, 69.68463776200008],
              [-132.35167395699995, 69.69179922100005],
              [-132.4627172519999, 69.66107819200005],
              [-132.4518936839999, 69.66889069200005],
              [-132.44009355399993, 69.67519765800006],
              [-132.43106035099993, 69.68280670800004],
              [-132.42857825399994, 69.69452545800004],
              [-132.43590247299994, 69.70441315300008],
              [-132.4505102199999, 69.70783112200007],
              [-132.4671117829999, 69.70551178600005],
              [-132.4929093089999, 69.69188060100004],
              [-132.51341712099992, 69.68650950700004],
              [-132.5484106109999, 69.68154531500005],
              [-132.55528723899994, 69.67938873900005],
              [-132.56993567599994, 69.66998932500007],
              [-132.57876542899993, 69.66787344000005],
              [-132.6035050119999, 69.66909414300005],
              [-132.6271866529999, 69.67405833500004],
              [-132.6204320949999, 69.68170807500007],
              [-132.61050370999993, 69.68821849200003],
              [-132.59874426999994, 69.69281647300005],
              [-132.5862524079999, 69.69452545800004],
              [-132.56578528599994, 69.71503327000005],
              [-132.5484106109999, 69.74298737200007],
              [-132.39317786399994, 69.75238678600005],
              [-132.3437393869999, 69.76683177300004],
              [-132.3101293609999, 69.77240631700005],
              [-132.2774145169999, 69.77431875200006],
              [-132.25723222599993, 69.77024974200003],
              [-132.28384355399993, 69.76943594000005],
              [-132.3596899079999, 69.74982330900008],
              [-132.4492081369999, 69.74420807500007],
              [-132.48379472599993, 69.74298737200007],
              [-132.48379472599993, 69.73615143400008],
              [-132.29137122299994, 69.73615143400008],
              [-132.29576575399994, 69.72842031500005],
              [-132.30190995999993, 69.72235748900005],
              [-132.30968176999994, 69.71796295800004],
              [-132.31871497299994, 69.71503327000005],
              [-132.26414954299992, 69.70880768400008],
              [-132.25747636599993, 69.70990631700005],
              [-132.24181067599994, 69.71442291900007],
              [-132.23680579299992, 69.71503327000005],
              [-132.23228919199994, 69.71234772300005],
              [-132.2249242829999, 69.70380280200004],
              [-132.16763261599993, 69.68781159100007],
              [-132.1389054029999, 69.68793366100005],
              [-132.1201065749999, 69.70880768400008],
              [-132.1214086579999, 69.71898021000004],
              [-132.0999242829999, 69.72768789300005],
              [-131.99966386599993, 69.74079010600008],
              [-131.97179114499994, 69.74799225500004],
              [-131.92931067599994, 69.77073802300004],
              [-131.83950761599993, 69.77024974200003],
              [-131.81899980399993, 69.77667877800008],
              [-131.77306067599994, 69.79840729400007],
              [-131.75641842399995, 69.81122467700004],
              [-131.7647192049999, 69.82689036700003],
              [-131.74941972599993, 69.83637116100005],
              [-131.70238196499992, 69.84540436400005],
              [-131.6201065749999, 69.87641022300005],
              [-131.45128333199995, 69.89630768400008],
              [-131.42125403599994, 69.91425202000005],
              [-131.42788652299993, 69.91376373900005],
              [-131.44180253799993, 69.91478099200003],
              [-131.4485570949999, 69.91425202000005],
              [-131.44033769399994, 69.93280670800004],
              [-131.42642167899993, 69.95062897300005],
              [-131.40831458199995, 69.96149323100008],
              [-131.38735917899993, 69.95897044500003],
              [-131.35680091099994, 69.95050690300008],
              [-131.28823808499993, 69.94904205900008],
              [-131.25674394399994, 69.94220612200007],
              [-131.24058997299994, 69.93305084800005],
              [-131.2224828769999, 69.91844310100004],
              [-131.20763098899994, 69.90094635600008],
              [-131.20152747299994, 69.88324616100005],
              [-131.20494544199994, 69.87518952000005],
              [-131.2194718089999, 69.86188385600008],
              [-131.2219945949999, 69.85285065300008],
              [-131.2177628249999, 69.84186432500007],
              [-131.20933997299994, 69.83421458500004],
              [-131.1884659499999, 69.82489655200004],
              [-131.15977942599994, 69.85468170800004],
              [-131.15367591099994, 69.86587148600006],
              [-131.1799210279999, 69.86660390800006],
              [-131.1884659499999, 69.86587148600006],
              [-131.1679581369999, 69.88694896000004],
              [-131.14883378799993, 69.89227936400005],
              [-131.09972083199995, 69.88694896000004],
              [-131.08482825399994, 69.89264557500007],
              [-131.0745336579999, 69.90599192900004],
              [-131.0580948559999, 69.93475983300004],
              [-131.02774003799993, 69.96360911700003],
              [-131.0149633449999, 69.98053620000007],
              [-131.00967363199993, 69.99966054900005],
              [-130.9990128249999, 70.01211172100005],
              [-130.94692949099993, 70.02065664300005],
              [-130.9278051419999, 70.03034088700008],
              [-130.95034745999993, 70.03742096600007],
              [-131.0012914699999, 70.02826569200005],
              [-131.02399654899995, 70.03034088700008],
              [-131.00694739499994, 70.03632233300004],
              [-130.9428604809999, 70.07880280200004],
              [-130.90859941299993, 70.09495677300004],
              [-130.8936254549999, 70.10602448100008],
              [-130.89391028599994, 70.09332916900007],
              [-130.90444902299993, 70.08600495000007],
              [-130.91543535099993, 70.08095937700006],
              [-130.91722571499992, 70.07501862200007],
              [-130.90298417899993, 70.06830475500004],
              [-130.88853919199994, 70.07538483300004],
              [-130.87389075399994, 70.08657461100006],
              [-130.8592016269999, 70.09243398600006],
              [-130.84142005099994, 70.09393952000005],
              [-130.80483964799993, 70.10602448100008],
              [-130.7714737619999, 70.10748932500007],
              [-130.76024329299992, 70.11066315300008],
              [-130.7639054029999, 70.12034739800004],
              [-130.75121008999992, 70.12970612200007],
              [-130.73721269399994, 70.13324616100005],
              [-130.72280839799993, 70.13202545800004],
              [-130.70864824099993, 70.12661367400005],
              [-130.73623613199993, 70.10276927300004],
              [-130.7470596999999, 70.08999258000006],
              [-130.74278723899994, 70.07880280200004],
              [-130.7229711579999, 70.07859935100004],
              [-130.6912328769999, 70.08637116100005],
              [-130.6638891269999, 70.09808991100005],
              [-130.65713456899994, 70.10952383000006],
              [-130.66490637899994, 70.12470123900005],
              [-130.6608780589999, 70.13646067900004],
              [-130.64712480399993, 70.14175039300005],
              [-130.6258031889999, 70.13715241100005],
              [-130.60488847599993, 70.13593170800004],
              [-130.57664954299992, 70.14142487200007],
              [-130.55601966099994, 70.15078359600005],
              [-130.55785071499992, 70.16132233300004],
              [-130.54190019399994, 70.17365143400008],
              [-130.51528886599993, 70.17719147300005],
              [-130.46157792899993, 70.17495351800005],
              [-130.48216712099992, 70.16803620000007],
              [-130.51146399599992, 70.16250234600005],
              [-130.5380753249999, 70.15289948100008],
              [-130.55040442599994, 70.13397858300004],
              [-130.54141191299993, 70.11469147300005],
              [-130.5197647779999, 70.10480377800008],
              [-130.49644934799994, 70.10602448100008],
              [-130.4827367829999, 70.12034739800004],
              [-130.5237524079999, 70.12661367400005],
              [-130.50438391799992, 70.13886139500005],
              [-130.4814346999999, 70.14012278900003],
              [-130.4346410799999, 70.13397858300004],
              [-130.41982988199993, 70.13621653900003],
              [-130.40615800699993, 70.14223867400005],
              [-130.39964758999992, 70.15094635600008],
              [-130.40636145699995, 70.16132233300004],
              [-130.3850805329999, 70.16567617400005],
              [-130.3523656889999, 70.13491445500006],
              [-130.3244522779999, 70.14020416900007],
              [-130.32974199099993, 70.11981842700004],
              [-130.3264054029999, 70.10976797100005],
              [-130.31362870999993, 70.10639069200005],
              [-130.29092363199993, 70.10602448100008],
              [-130.32725989499994, 70.09357330900008],
              [-130.3381241529999, 70.08559804900005],
              [-130.31851152299993, 70.08161041900007],
              [-130.24937903599994, 70.08559804900005],
              [-130.2261449859999, 70.09027741100005],
              [-130.18126380099994, 70.10586172100005],
              [-130.1599828769999, 70.10602448100008],
              [-130.18199622299994, 70.08466217700004],
              [-130.19102942599994, 70.07290273600006],
              [-130.19473222599993, 70.06134674700007],
              [-130.18687903599994, 70.05255768400008],
              [-130.16917883999992, 70.05878327000005],
              [-130.15050208199995, 70.07074616100005],
              [-130.10732988199993, 70.10862864800004],
              [-130.09821529899995, 70.11286041900007],
              [-130.0821020169999, 70.10952383000006],
              [-130.07860266799992, 70.10101959800005],
              [-130.0849503249999, 70.08991120000007],
              [-130.09850012899994, 70.07880280200004],
              [-130.0556534499999, 70.08274974200003],
              [-129.9754125639999, 70.10162995000007],
              [-129.95368404899995, 70.10272858300004],
              [-129.9346410799999, 70.09857819200005],
              [-129.97630774599992, 70.08372630400004],
              [-129.9925024079999, 70.07514069200005],
              [-129.9824926419999, 70.07135651200008],
              [-129.9317113919999, 70.07611725500004],
              [-129.8863012359999, 70.08559804900005],
              [-129.8894750639999, 70.08917877800008],
              [-129.89110266799992, 70.09202708500004],
              [-129.89366614499994, 70.09857819200005],
              [-129.86766516799992, 70.10516998900005],
              [-129.85830644399994, 70.10602448100008],
              [-129.86412512899994, 70.13361237200007],
              [-129.8456925119999, 70.15289948100008],
              [-129.7900284499999, 70.18121979400007],
              [-129.7988175119999, 70.18768952000005],
              [-129.80870520699995, 70.19208405200004],
              [-129.81956946499992, 70.19464752800008],
              [-129.83096269399994, 70.19546133000006],
              [-129.83096269399994, 70.20229726800005],
              [-129.81529700399994, 70.20184967700004],
              [-129.80435136599993, 70.20652903900003],
              [-129.7957250639999, 70.21499258000006],
              [-129.7869360019999, 70.22581614800004],
              [-129.77529863199993, 70.22947825700004],
              [-129.7382706369999, 70.22508372600004],
              [-129.72109941299993, 70.22955963700008],
              [-129.74014238199993, 70.24339427300004],
              [-129.7285050119999, 70.25617096600007],
              [-129.70128333199995, 70.26577383000006],
              [-129.67393958199995, 70.26992422100005],
              [-129.67393958199995, 70.26373932500007],
              [-129.68016516799992, 70.26373932500007],
              [-129.68016516799992, 70.25690338700008],
              [-129.66030839799993, 70.25800202000005],
              [-129.6485082669999, 70.25153229400007],
              [-129.64586341099994, 70.23908112200007],
              [-129.65347245999993, 70.22211334800005],
              [-129.6402074859999, 70.22308991100005],
              [-129.62706458199995, 70.22162506700005],
              [-129.6150610019999, 70.21698639500005],
              [-129.60509192599994, 70.20848216400003],
              [-129.59732011599993, 70.19822825700004],
              [-129.5920304029999, 70.19546133000006],
              [-129.60997473899994, 70.17601146000004],
              [-129.62022864499994, 70.16958242400005],
              [-129.63296464799993, 70.16754791900007],
              [-129.60289466099994, 70.16229889500005],
              [-129.54405676999994, 70.16762929900005],
              [-129.51573645699995, 70.16132233300004],
              [-129.52310136599993, 70.15387604400007],
              [-129.5054418609999, 70.14813873900005],
              [-129.4700414699999, 70.15330638200004],
              [-129.4549047519999, 70.14704010600008],
              [-129.47276770699995, 70.13467031500005],
              [-129.49034583199995, 70.12665436400005],
              [-129.49941972599993, 70.11774323100008],
              [-129.49181067599994, 70.10236237200007],
              [-129.46816972599993, 70.09076569200005],
              [-129.45107988199993, 70.10496653900003],
              [-129.43643144399994, 70.12579987200007],
              [-129.42007402299993, 70.13397858300004],
              [-129.4064835279999, 70.12116120000007],
              [-129.41152910099993, 70.10057200700004],
              [-129.42593339799993, 70.08022695500006],
              [-129.44058183499993, 70.06826406500005],
              [-129.46344967399995, 70.05683014500005],
              [-129.4748429029999, 70.05292389500005],
              [-129.48867753799993, 70.05145905200004],
              [-129.52354895699995, 70.05194733300004],
              [-129.54214433499993, 70.04987213700008],
              [-129.55728105399993, 70.04401276200008],
              [-129.5093481109999, 70.03644440300008],
              [-129.49522864499994, 70.03034088700008],
              [-129.51602128799993, 70.02106354400007],
              [-129.5635473299999, 70.00958893400008],
              [-129.59976152299993, 69.99119700700004],
              [-129.7100317049999, 69.97256094000005],
              [-129.75511633999992, 69.95595937700006],
              [-130.1106664699999, 69.86908600500004],
              [-130.19473222599993, 69.85968659100007],
              [-130.26870683499993, 69.84031810100004],
              [-130.29775956899994, 69.83856842700004],
              [-130.30138098899994, 69.85028717700004],
              [-130.31920325399994, 69.84902578300006],
              [-130.34166419199994, 69.84096914300005],
              [-130.35924231699994, 69.83234284100007],
              [-130.39574133999992, 69.80792877800008],
              [-130.4141332669999, 69.80036041900007],
              [-130.45230058499993, 69.79657623900005],
              [-130.4617406889999, 69.79328034100007],
              [-130.4702042309999, 69.78803131700005],
              [-130.47899329299992, 69.78050364800004],
              [-130.52708899599992, 69.78388092700004],
              [-130.5354711579999, 69.78074778900003],
              [-130.5525610019999, 69.76666901200008],
              [-130.57115637899994, 69.75958893400008],
              [-130.5717667309999, 69.75141022300005],
              [-130.5679418609999, 69.74408600500004],
              [-130.5646866529999, 69.74298737200007],
              [-130.57201087099992, 69.72516510600008],
              [-130.57921301999994, 69.71442291900007],
              [-130.5911352199999, 69.70770905200004],
              [-130.67056230399993, 69.69188060100004],
              [-130.77086341099994, 69.68451569200005],
              [-130.78966223899994, 69.67755768400008],
              [-130.80410722599993, 69.65525950700004],
              [-130.8357641269999, 69.63214752800008],
              [-130.84581458199995, 69.61945221600007],
              [-130.83836829299992, 69.61261627800008],
              [-130.84679114499994, 69.60618724200003],
              [-130.87315833199995, 69.59955475500004],
              [-130.8977758449999, 69.58722565300008],
              [-130.91661536399994, 69.58022695500006],
              [-130.92813066299993, 69.57074616100005],
              [-130.94115149599992, 69.56590403900003],
              [-130.97569739499994, 69.58478424700007],
              [-131.0124405589999, 69.59194570500006],
              [-131.03018144399994, 69.59955475500004],
              [-131.04116777299993, 69.61009349200003],
              [-131.0398656889999, 69.61652252800008],
              [-131.03551184799994, 69.62274811400005],
              [-131.03766842399995, 69.63312409100007],
              [-131.04796301999994, 69.64374420800004],
              [-131.0576065749999, 69.64264557500007],
              [-131.0691625639999, 69.63666413000004],
              [-131.0857641269999, 69.63312409100007],
              [-131.16592363199993, 69.63617584800005],
              [-131.18472245999993, 69.62970612200007],
              [-131.2195531889999, 69.61005280200004],
              [-131.2600805329999, 69.60358307500007],
              [-131.3455297519999, 69.60578034100007],
              [-131.3418676419999, 69.59967682500007],
              [-131.33519446499992, 69.58380768400008],
              [-131.3318578769999, 69.57786692900004],
              [-131.39391028599994, 69.57786692900004],
              [-131.4024145169999, 69.57990143400008],
              [-131.4121801419999, 69.58930084800005],
              [-131.42125403599994, 69.59210846600007],
              [-131.4414770169999, 69.59031810100004],
              [-131.48257402299993, 69.57599518400008],
              [-131.50316321499992, 69.57168203300006],
              [-131.5137426419999, 69.57221100500004],
              [-131.53380286399994, 69.57680898600006],
              [-131.54409745999993, 69.57786692900004],
              [-131.55406653599994, 69.57689036700003],
              [-131.57168535099993, 69.57257721600007],
              [-131.58259029899995, 69.57168203300006],
              [-131.6682836579999, 69.57786692900004],
              [-131.66258704299992, 69.57208893400008],
              [-131.65640214799993, 69.56370677300004],
              [-131.6525772779999, 69.55402252800008],
              [-131.65396074099993, 69.54433828300006],
              [-131.66344153599994, 69.53579336100006],
              [-131.67349199099993, 69.53969961100006],
              [-131.6955460279999, 69.55805084800005],
              [-131.72704016799992, 69.56834544500003],
              [-131.75942949099993, 69.57001373900005],
              [-131.82530676999994, 69.55805084800005],
              [-131.89415442599994, 69.53685130400004],
              [-131.9170629549999, 69.53485748900005],
              [-131.96080481699994, 69.53823476800005],
              [-131.98355058499993, 69.53685130400004],
              [-132.01305091099994, 69.52753327000005],
              [-132.07852128799993, 69.48224518400008],
              [-132.05516516799992, 69.47426992400005],
              [-132.04678300699993, 69.46503327000005],
              [-132.0545141269999, 69.45746491100005],
              [-132.0964249339999, 69.45066966400003],
              [-132.10606848899994, 69.44183991100005],
              [-132.1054581369999, 69.43085358300004],
              [-132.09219316299993, 69.42084381700005],
              [-132.11782792899993, 69.42104726800005],
              [-132.12950598899994, 69.41913483300004],
              [-132.1406143869999, 69.41400788000004],
              [-132.09097245999993, 69.39459870000007],
              [-132.07852128799993, 69.38605377800008],
              [-132.1143285799999, 69.36147695500006],
              [-132.33462480399993, 69.31574127800008],
              [-132.3466690749999, 69.30756256700005],
              [-132.3405655589999, 69.29629140800006],
              [-132.31533769399994, 69.26727936400005],
              [-132.31187903599994, 69.25633372600004],
              [-132.32485917899993, 69.24921295800004],
              [-132.34337317599994, 69.25739166900007],
              [-132.35997473899994, 69.27277252800008],
              [-132.36709550699993, 69.28705475500004],
              [-132.36969967399995, 69.29401276200008],
              [-132.37555904899995, 69.30190664300005],
              [-132.3821508449999, 69.30829498900005],
              [-132.3870336579999, 69.31098053600005],
              [-132.43480383999992, 69.30414459800005],
              [-132.4422094389999, 69.29328034100007],
              [-132.44131425699993, 69.28290436400005],
              [-132.43724524599992, 69.27041250200006],
              [-132.43480383999992, 69.25291575700004],
              [-132.44668535099993, 69.24697500200006],
              [-132.4700414699999, 69.24274323100008],
              [-132.4861547519999, 69.23590729400007],
              [-132.4763891269999, 69.22215403900003],
              [-132.4827367829999, 69.20669179900005],
              [-132.48648027299993, 69.17401764500005],
              [-132.49746660099993, 69.16014232000003],
              [-132.5049535799999, 69.19188060100004],
              [-132.50723222599993, 69.23090241100005],
              [-132.5164281889999, 69.26715729400007],
              [-132.54466712099992, 69.29047272300005],
              [-132.5605362619999, 69.29311758000006],
              [-132.58218339799993, 69.29385000200006],
              [-132.62035071499992, 69.29047272300005],
              [-132.6321508449999, 69.28461334800005],
              [-132.65680904899995, 69.26691315300008],
              [-132.66852779899995, 69.26312897300005],
              [-132.71910559799994, 69.26251862200007],
              [-132.77122962099992, 69.25633372600004],
              [-132.77204342399995, 69.23615143400008],
              [-132.7964574859999, 69.22907135600008],
              [-132.82701575399994, 69.22357819200005],
              [-132.84630286399994, 69.20856354400007],
              [-132.82579505099994, 69.20433177300004],
              [-132.8334854809999, 69.18756745000007],
              [-132.87051347599993, 69.15053945500006],
              [-132.8815811839999, 69.14427317900004],
              [-132.8965551419999, 69.13849518400008],
              [-132.90794837099992, 69.13084544500003],
              [-132.90835527299993, 69.11920807500007],
              [-132.8952530589999, 69.11196523600006],
              [-132.87279212099992, 69.11054108300004],
              [-132.83263098899994, 69.11298248900005],
              [-132.84707597599993, 69.10553620000007],
              [-132.8808487619999, 69.09369538000004],
              [-132.8941137359999, 69.08502838700008],
              [-132.89981035099993, 69.07636139500005],
              [-132.90835527299993, 69.04409414300005],
              [-132.89781653599994, 69.03522370000007],
              [-132.88906816299993, 69.02094147300005],
              [-132.88320878799993, 69.00527578300006],
              [-132.8810929029999, 68.99225495000007],
              [-132.89199785099993, 68.98273346600007],
              [-132.91368567599994, 68.98590729400007],
              [-132.92931067599994, 69.00006745000007],
              [-132.92202714799993, 69.02362702000005],
              [-132.9296768869999, 69.02773672100005],
              [-132.94933020699995, 69.04409414300005],
              [-132.92910722599993, 69.06273021000004],
              [-132.9234106109999, 69.07322825700004],
              [-132.92886308499993, 69.08161041900007],
              [-132.9431860019999, 69.08242422100005],
              [-132.96841386599993, 69.06293366100005],
              [-132.98412024599992, 69.05776601800005],
              [-133.02257239499994, 69.05516185100004],
              [-133.0380753249999, 69.05776601800005],
              [-133.0842179029999, 69.07257721600007],
              [-133.10073808499993, 69.07200755400004],
              [-133.1045629549999, 69.06907786700003],
              [-133.1067602199999, 69.06395091400003],
              [-133.10830644399994, 69.05829498900005],
              [-133.1104223299999, 69.05394114800004],
              [-133.1191300119999, 69.04975006700005],
              [-133.13145911399994, 69.04889557500007],
              [-133.1551000639999, 69.05027903900003],
              [-133.1690160799999, 69.04913971600007],
              [-133.1870824859999, 69.04515208500004],
              [-133.20274817599994, 69.03790924700007],
              [-133.20938066299993, 69.02667877800008],
              [-133.21056067599994, 69.02122630400004],
              [-133.21548417899993, 69.01312897300005],
              [-133.2168676419999, 69.00934479400007],
              [-133.2148331369999, 69.00372955900008],
              [-133.2050675119999, 68.99188873900005],
              [-133.20323645699995, 68.98883698100008],
              [-133.21084550699993, 68.97846100500004],
              [-133.22085527299993, 68.97455475500004],
              [-133.23379472599993, 68.97264232000003],
              [-133.25035559799994, 68.96832916900007],
              [-133.24071204299992, 68.96173737200007],
              [-133.20938066299993, 68.94790273600006],
              [-133.22842363199993, 68.92096588700008],
              [-133.23672441299993, 68.91376373900005],
              [-133.25133216099994, 68.90680573100008],
              [-133.28331458199995, 68.89931875200006],
              [-133.29873613199993, 68.89325592700004],
              [-133.3218481109999, 68.87494538000004],
              [-133.3354386059999, 68.86762116100005],
              [-133.35399329299992, 68.86591217700004],
              [-133.3684789699999, 68.86847565300008],
              [-133.38292395699995, 68.87384674700007],
              [-133.39468339799993, 68.88202545800004],
              [-133.40123450399994, 68.89325592700004],
              [-133.37584387899994, 68.89533112200007],
              [-133.3609106109999, 68.90363190300008],
              [-133.36290442599994, 68.91181061400005],
              [-133.3881729809999, 68.91376373900005],
              [-133.47012285099993, 68.89325592700004],
              [-133.46231035099993, 68.88165924700007],
              [-133.45368404899995, 68.87181224200003],
              [-133.4429418609999, 68.86395905200004],
              [-133.4285375639999, 68.85846588700008],
              [-133.4553116529999, 68.85053131700005],
              [-133.47911536399994, 68.84935130400004],
              [-133.49132239499994, 68.84251536700003],
              [-133.4831436839999, 68.81753164300005],
              [-133.4697973299999, 68.80239492400005],
              [-133.45103919199994, 68.79116445500006],
              [-133.40859941299993, 68.77655670800004],
              [-133.33975175699993, 68.76288483300004],
              [-133.3276261059999, 68.75726959800005],
              [-133.3164770169999, 68.75043366100005],
              [-133.3040258449999, 68.74481842700004],
              [-133.23521887899994, 68.73773834800005],
              [-133.21149654899995, 68.72955963700008],
              [-133.20938066299993, 68.71507396000004],
              [-133.1740616529999, 68.71515534100007],
              [-133.0657445949999, 68.69399648600006],
              [-132.95787512899994, 68.69944896000004],
              [-132.92202714799993, 68.69399648600006],
              [-132.92202714799993, 68.70140208500004],
              [-132.9468481109999, 68.71417877800008],
              [-132.97435462099992, 68.72028229400007],
              [-133.0380753249999, 68.72199127800008],
              [-133.0039770169999, 68.71507396000004],
              [-133.0039770169999, 68.70766836100006],
              [-133.14891516799992, 68.72382233300004],
              [-133.15249589799993, 68.72866445500006],
              [-133.15392005099994, 68.73517487200007],
              [-133.16222083199995, 68.74241771000004],
              [-133.17662512899994, 68.74843984600005],
              [-133.1912328769999, 68.75267161700003],
              [-133.20665442599994, 68.75527578300006],
              [-133.2233780589999, 68.75604889500005],
              [-133.2561742829999, 68.76386139500005],
              [-133.26183020699995, 68.77936432500007],
              [-133.2507218089999, 68.79108307500007],
              [-133.23330644399994, 68.78709544500003],
              [-133.21544348899994, 68.77521393400008],
              [-133.1924535799999, 68.76679108300004],
              [-133.1668188139999, 68.76251862200007],
              [-133.14049231699994, 68.76288483300004],
              [-133.15672766799992, 68.77562083500004],
              [-133.24351966099994, 68.80048248900005],
              [-133.27183997299994, 68.80508047100005],
              [-133.33043372299994, 68.79458242400005],
              [-133.36025956899994, 68.80390045800004],
              [-133.36025956899994, 68.81126536700003],
              [-133.3548070949999, 68.81220123900005],
              [-133.33975175699993, 68.81753164300005],
              [-133.3510636059999, 68.82754140800006],
              [-133.36123613199993, 68.83356354400007],
              [-133.3881729809999, 68.84544505400004],
              [-133.3701065749999, 68.84926992400005],
              [-133.31309973899994, 68.85228099200003],
              [-133.25674394399994, 68.86497630400004],
              [-133.23672441299993, 68.86591217700004],
              [-133.22044837099992, 68.86359284100007],
              [-133.20470130099994, 68.85871002800008],
              [-133.1752823559999, 68.84544505400004],
              [-133.1697485019999, 68.84121328300006],
              [-133.1603897779999, 68.82953522300005],
              [-133.15477454299992, 68.82493724200003],
              [-133.14537512899994, 68.82233307500007],
              [-133.12441972599993, 68.82127513200004],
              [-133.11384029899995, 68.81753164300005],
              [-133.1206762359999, 68.81126536700003],
              [-133.10753333199995, 68.80585358300004],
              [-133.09390214799993, 68.80369700700004],
              [-133.0654190749999, 68.80390045800004],
              [-133.0701391269999, 68.81366608300004],
              [-133.07286536399994, 68.81753164300005],
              [-133.0371801419999, 68.82575104400007],
              [-132.9607641269999, 68.80337148600006],
              [-132.92886308499993, 68.80390045800004],
              [-132.9533585279999, 68.82835521000004],
              [-132.96397864499994, 68.84467194200005],
              [-132.96300208199995, 68.85846588700008],
              [-132.94029700399994, 68.86326732000003],
              [-132.90245520699995, 68.85748932500007],
              [-132.86485755099994, 68.84625885600008],
              [-132.82262122299994, 68.82330963700008],
              [-132.76988684799994, 68.81321849200003],
              [-132.72569739499994, 68.79071686400005],
              [-132.70946204299992, 68.79657623900005],
              [-132.71129309799994, 68.81049225500004],
              [-132.74388587099992, 68.82493724200003],
              [-132.74388587099992, 68.83120351800005],
              [-132.7053930329999, 68.83698151200008],
              [-132.51423092399995, 68.80532461100006],
              [-132.4832250639999, 68.80540599200003],
              [-132.4695531889999, 68.81439850500004],
              [-132.46715247299994, 68.83071523600006],
              [-132.45909583199995, 68.83759186400005],
              [-132.44420325399994, 68.83901601800005],
              [-132.42113196499992, 68.83860911700003],
              [-132.41421464799993, 68.84296295800004],
              [-132.40811113199993, 68.84544505400004],
              [-132.3994034499999, 68.85504791900007],
              [-132.39622962099992, 68.85952383000006],
              [-132.3938695949999, 68.86591217700004],
              [-132.49380449099993, 68.90591054900005],
              [-132.55020097599993, 68.92011139500005],
              [-132.5794164699999, 68.90692780200004],
              [-132.48379472599993, 68.88580963700008],
              [-132.5107315749999, 68.87799713700008],
              [-132.53673255099994, 68.88060130400004],
              [-132.58560136599993, 68.89325592700004],
              [-132.60171464799993, 68.89394765800006],
              [-132.61998450399994, 68.89199453300006],
              [-132.6382543609999, 68.88703034100007],
              [-132.6545304029999, 68.87897370000007],
              [-132.64488684799994, 68.85883209800005],
              [-132.6760147779999, 68.84857819200005],
              [-132.72044837099992, 68.84516022300005],
              [-132.76793372299994, 68.84711334800005],
              [-132.78453528599994, 68.85101959800005],
              [-132.7910863919999, 68.85895416900007],
              [-132.7780655589999, 68.87274811400005],
              [-132.7612198559999, 68.87693919500003],
              [-132.74307206899994, 68.87457916900007],
              [-132.7253311839999, 68.87457916900007],
              [-132.7097875639999, 68.88580963700008],
              [-132.73839270699995, 68.88792552300004],
              [-132.77977454299992, 68.89590078300006],
              [-132.81688391799992, 68.90766022300005],
              [-132.83263098899994, 68.92112864800004],
              [-132.81090247299994, 68.93732330900008],
              [-132.76280676999994, 68.93707916900007],
              [-132.67564856699994, 68.92739492400005],
              [-132.69969641799992, 68.94546133000006],
              [-132.74038652299993, 68.96067942900004],
              [-132.7846573559999, 68.97117747600004],
              [-132.8193253249999, 68.97516510600008],
              [-132.8498429029999, 68.98578522300005],
              [-132.86465410099993, 69.00922272300005],
              [-132.85863196499992, 69.03290436400005],
              [-132.8264867829999, 69.04409414300005],
              [-132.8340551419999, 69.05463288000004],
              [-132.84496008999992, 69.05833567900004],
              [-132.87364661399994, 69.05776601800005],
              [-132.86217200399994, 69.07330963700008],
              [-132.83897864499994, 69.08319733300004],
              [-132.79165605399993, 69.09186432500007],
              [-132.66136633999992, 69.09186432500007],
              [-132.64492753799993, 69.09642161700003],
              [-132.57876542899993, 69.12970612200007],
              [-132.5529679029999, 69.13686758000006],
              [-132.50755774599992, 69.13861725500004],
              [-132.48379472599993, 69.14712148600006],
              [-132.4677628249999, 69.15753815300008],
              [-132.45278886599993, 69.17072174700007],
              [-132.44896399599992, 69.17910390800006],
              [-132.45059160099993, 69.18732330900008],
              [-132.45433508999992, 69.19330475500004],
              [-132.4565323559999, 69.19489166900007],
              [-132.44786536399994, 69.20966217700004],
              [-132.43130449099993, 69.22825755400004],
              [-132.41527258999992, 69.23786041900007],
              [-132.40811113199993, 69.22565338700008],
              [-132.42007402299993, 69.17426178600005],
              [-132.4248754549999, 69.16351959800005],
              [-132.42747962099992, 69.16054922100005],
              [-132.42857825399994, 69.15766022300005],
              [-132.42857825399994, 69.15053945500006],
              [-132.43106035099993, 69.14288971600007],
              [-132.43687903599994, 69.14130280200004],
              [-132.44371497299994, 69.14158763200004],
              [-132.44908606699994, 69.13963450700004],
              [-132.4572647779999, 69.13226959800005],
              [-132.4636124339999, 69.12783437700006],
              [-132.46788489499994, 69.12262604400007],
              [-132.4695531889999, 69.11298248900005],
              [-132.4037979809999, 69.13165924700007],
              [-132.37279212099992, 69.14931875200006],
              [-132.3596899079999, 69.17755768400008],
              [-132.35798092399995, 69.18797435100004],
              [-132.34821529899995, 69.21694570500006],
              [-132.34292558499993, 69.22565338700008],
              [-132.3269750639999, 69.23371002800008],
              [-132.30772864499994, 69.23623281500005],
              [-132.2949926419999, 69.23078034100007],
              [-132.29824785099993, 69.21539948100008],
              [-132.29576575399994, 69.20538971600007],
              [-132.30907141799992, 69.19904205900008],
              [-132.3290909499999, 69.19570547100005],
              [-132.3466690749999, 69.19489166900007],
              [-132.30089270699995, 69.18195221600007],
              [-132.28457597599993, 69.18060944200005],
              [-132.27660071499992, 69.18402741100005],
              [-132.25047766799992, 69.20856354400007],
              [-132.2405492829999, 69.21328359600005],
              [-132.2267960279999, 69.21767812700006],
              [-132.2129613919999, 69.22003815300008],
              [-132.2026261059999, 69.21881745000007],
              [-132.19579016799992, 69.21124909100007],
              [-132.20006262899994, 69.20351797100005],
              [-132.2162979809999, 69.18805573100008],
              [-132.2350968089999, 69.15908437700006],
              [-132.2361547519999, 69.14813873900005],
              [-132.2162979809999, 69.15395742400005],
              [-132.20445716099994, 69.16474030200004],
              [-132.16787675699993, 69.21539948100008],
              [-132.17491614499994, 69.22597890800006],
              [-132.17552649599992, 69.23387278900003],
              [-132.17076575399994, 69.24030182500007],
              [-132.16136633999992, 69.24607982000003],
              [-132.15347245999993, 69.24896881700005],
              [-132.1445206369999, 69.25039297100005],
              [-132.13540605399993, 69.25043366100005],
              [-132.1269425119999, 69.24949778900003],
              [-132.12157141799992, 69.24664948100008],
              [-132.12083899599992, 69.24213288000004],
              [-132.12144934799994, 69.23777903900003],
              [-132.1201065749999, 69.23525625200006],
              [-132.0882055329999, 69.23371002800008],
              [-132.0312393869999, 69.25446198100008],
              [-131.9997859369999, 69.25617096600007],
              [-131.98493404899995, 69.25556061400005],
              [-131.9658910799999, 69.25926341400003],
              [-131.9538468089999, 69.26829661700003],
              [-131.95563717399995, 69.28367747600004],
              [-131.9370824859999, 69.28831614800004],
              [-131.9051000639999, 69.31386953300006],
              [-131.88052324099993, 69.31842682500007],
              [-131.89427649599992, 69.30487702000005],
              [-131.90933183499993, 69.29462311400005],
              [-131.91344153599994, 69.28754303600005],
              [-131.89415442599994, 69.28367747600004],
              [-131.8804418609999, 69.28465403900003],
              [-131.87193762899994, 69.28864166900007],
              [-131.8659561839999, 69.29376862200007],
              [-131.8594457669999, 69.29791901200008],
              [-131.82530676999994, 69.31098053600005],
              [-131.8080948559999, 69.32037995000007],
              [-131.75792395699995, 69.37132396000004],
              [-131.71544348899994, 69.40033600500004],
              [-131.73033606699994, 69.40444570500006],
              [-131.75055904899995, 69.40224844000005],
              [-131.8464249339999, 69.37775299700007],
              [-131.85631262899994, 69.37641022300005],
              [-131.85903886599993, 69.38344961100006],
              [-131.85488847599993, 69.39435455900008],
              [-131.8594457669999, 69.40033600500004],
              [-131.8665258449999, 69.40350983300004],
              [-131.8938695949999, 69.41087474200003],
              [-131.9147843089999, 69.41258372600004],
              [-131.95555579299992, 69.39948151200008],
              [-131.97671464799993, 69.40778229400007],
              [-131.91124426999994, 69.42812734600005],
              [-131.87315833199995, 69.43353913000004],
              [-131.8457738919999, 69.42829010600008],
              [-131.85317949099993, 69.42084381700005],
              [-131.8310440749999, 69.42161692900004],
              [-131.7866104809999, 69.43195221600007],
              [-131.76353919199994, 69.43451569200005],
              [-131.64712480399993, 69.42829010600008],
              [-131.6767471999999, 69.44879791900007],
              [-131.67357337099992, 69.46369049700007],
              [-131.6486710279999, 69.47296784100007],
              [-131.61302649599992, 69.47606028900003],
              [-131.5952042309999, 69.47431061400005],
              [-131.54409745999993, 69.46181875200006],
              [-131.47594153599994, 69.45718008000006],
              [-131.4553930329999, 69.45123932500007],
              [-131.4275610019999, 69.43512604400007],
              [-131.4389542309999, 69.42885976800005],
              [-131.46715247299994, 69.42108795800004],
              [-131.48949133999992, 69.40033600500004],
              [-131.4895727199999, 69.39004140800006],
              [-131.48094641799992, 69.37006256700005],
              [-131.4826554029999, 69.35936107000003],
              [-131.49193274599992, 69.35236237200007],
              [-131.5078832669999, 69.34613678600005],
              [-131.5379125639999, 69.33893463700008],
              [-131.51488196499992, 69.33592357000003],
              [-131.47647050699993, 69.34438711100006],
              [-131.43785559799994, 69.35858795800004],
              [-131.4143774079999, 69.37299225500004],
              [-131.4030655589999, 69.39691803600005],
              [-131.4021703769999, 69.41412995000007],
              [-131.39370683499993, 69.42275625200006],
              [-131.35973059799994, 69.42084381700005],
              [-131.38023841099994, 69.45433177300004],
              [-131.3674210279999, 69.45502350500004],
              [-131.35488847599993, 69.45416901200008],
              [-131.34292558499993, 69.45184967700004],
              [-131.3318578769999, 69.44814687700006],
              [-131.3318578769999, 69.45433177300004],
              [-131.33922278599994, 69.46230703300006],
              [-131.3394262359999, 69.47020091400003],
              [-131.33507239499994, 69.47821686400005],
              [-131.32872473899994, 69.48602936400005],
              [-131.31704667899993, 69.49380117400005],
              [-131.3085831369999, 69.48932526200008],
              [-131.30166581899994, 69.48069896000004],
              [-131.29458574099993, 69.47606028900003],
              [-131.26085364499994, 69.42108795800004],
              [-131.2437231109999, 69.40778229400007],
              [-131.2482804029999, 69.42926666900007],
              [-131.27090410099993, 69.48566315300008],
              [-131.27379309799994, 69.49933502800008],
              [-131.25206458199995, 69.50385163000004],
              [-131.2339574859999, 69.48305898600006],
              [-131.22130286399994, 69.45408763200004],
              [-131.20933997299994, 69.40949127800008],
              [-131.2111710279999, 69.39842357000003],
              [-131.2219945949999, 69.38605377800008],
              [-131.2363175119999, 69.38080475500004],
              [-131.31944739499994, 69.36261627800008],
              [-131.3594457669999, 69.33515045800004],
              [-131.3941137359999, 69.32339101800005],
              [-131.40746008999992, 69.31476471600007],
              [-131.4143774079999, 69.29791901200008],
              [-131.39317786399994, 69.30658600500004],
              [-131.34780839799993, 69.31708405200004],
              [-131.32559160099993, 69.32526276200008],
              [-131.27989661399994, 69.35830312700006],
              [-131.26292883999992, 69.36619700700004],
              [-131.2385961579999, 69.36994049700007],
              [-131.2185766269999, 69.36985911700003],
              [-131.2001846999999, 69.37295156500005],
              [-131.18101966099994, 69.38605377800008],
              [-131.17638098899994, 69.38800690300008],
              [-131.17105058499993, 69.38764069200005],
              [-131.16576087099992, 69.38837311400005],
              [-131.1611221999999, 69.39354075700004],
              [-131.16222083199995, 69.39549388200004],
              [-131.16494706899994, 69.39899323100008],
              [-131.16738847599993, 69.40338776200008],
              [-131.16734778599994, 69.40778229400007],
              [-131.1643774079999, 69.41575755400004],
              [-131.1640518869999, 69.42080312700006],
              [-131.16734778599994, 69.42829010600008],
              [-131.16201738199993, 69.43276601800005],
              [-131.15269934799994, 69.44367096600007],
              [-131.1475317049999, 69.44814687700006],
              [-131.16104081899994, 69.45506419500003],
              [-131.16738847599993, 69.46751536700003],
              [-131.16714433499993, 69.48224518400008],
              [-131.1611221999999, 69.49591705900008],
              [-131.2324926419999, 69.54189687700006],
              [-131.24815833199995, 69.56761302300004],
              [-131.2554418609999, 69.57562897300005],
              [-131.25674394399994, 69.58242422100005],
              [-131.24307206899994, 69.58535390800006],
              [-131.22972571499992, 69.58258698100008],
              [-131.22179114499994, 69.57587311400005],
              [-131.2083227199999, 69.55805084800005],
              [-131.1992081369999, 69.55166250200006],
              [-131.16734778599994, 69.53685130400004],
              [-131.16470292899993, 69.53510163000004],
              [-131.16274980399993, 69.53270091400003],
              [-131.16152910099993, 69.52993398600006],
              [-131.1611221999999, 69.52700429900005],
              [-131.15876217399995, 69.52244700700004],
              [-131.15294348899994, 69.52244700700004],
              [-131.1459854809999, 69.52374909100007],
              [-131.14004472599993, 69.52326080900008],
              [-131.13023841099994, 69.52065664300005],
              [-131.12149003799993, 69.52000560100004],
              [-131.11514238199993, 69.51675039300005],
              [-131.11270097599993, 69.50617096600007],
              [-131.1205948559999, 69.46010976800005],
              [-131.12535559799994, 69.45066966400003],
              [-131.12637285099993, 69.44472890800006],
              [-131.12389075399994, 69.43817780200004],
              [-131.11384029899995, 69.42820872600004],
              [-131.11270097599993, 69.42084381700005],
              [-131.1193741529999, 69.40949127800008],
              [-131.14118404899995, 69.39598216400003],
              [-131.1475317049999, 69.38605377800008],
              [-131.14663652299993, 69.37164948100008],
              [-131.13805091099994, 69.36977773600006],
              [-131.12633216099994, 69.37523021000004],
              [-131.11611894399994, 69.38296133000006],
              [-131.10798092399995, 69.39118073100008],
              [-131.08910071499992, 69.41498444200005],
              [-131.0854386059999, 69.42454661700003],
              [-131.0840551419999, 69.43846263200004],
              [-131.08055579299992, 69.44643789300005],
              [-131.0761612619999, 69.45270416900007],
              [-131.06297766799992, 69.48090241100005],
              [-131.06175696499992, 69.48908112200007],
              [-131.06883704299992, 69.51439036700003],
              [-131.07437089799993, 69.52545807500007],
              [-131.08291581899994, 69.53363678600005],
              [-131.0960180329999, 69.53685130400004],
              [-131.10680091099994, 69.54120514500005],
              [-131.1284073559999, 69.55996328300006],
              [-131.1406957669999, 69.56419505400004],
              [-131.15562903599994, 69.56590403900003],
              [-131.17349199099993, 69.57103099200003],
              [-131.18838456899994, 69.57973867400005],
              [-131.19469153599994, 69.59210846600007],
              [-131.18333899599992, 69.60687897300005],
              [-131.1572159499999, 69.61664459800005],
              [-131.12779700399994, 69.62103913000004],
              [-131.1065160799999, 69.61945221600007],
              [-131.09288489499994, 69.61050039300005],
              [-131.08653723899994, 69.59784577000005],
              [-131.09024003799993, 69.58563873900005],
              [-131.1065160799999, 69.57786692900004],
              [-131.07774817599994, 69.55634186400005],
              [-131.05215410099993, 69.53095123900005],
              [-131.0347387359999, 69.49994538000004],
              [-131.03018144399994, 69.46181875200006],
              [-131.03453528599994, 69.44261302300004],
              [-131.04344641799992, 69.42352936400005],
              [-131.05524654899995, 69.40566640800006],
              [-131.0683487619999, 69.38979726800005],
              [-131.07266191299993, 69.38202545800004],
              [-131.0762426419999, 69.36481354400007],
              [-131.0820206369999, 69.35594310100004],
              [-131.11172441299993, 69.33519114800004],
              [-131.11953691299993, 69.32526276200008],
              [-131.0966690749999, 69.33234284100007],
              [-131.06696529899995, 69.34808991100005],
              [-131.04112708199995, 69.36684804900005],
              [-131.03018144399994, 69.38296133000006],
              [-131.02476966099994, 69.40228913000004],
              [-130.97496497299994, 69.47211334800005],
              [-130.9705297519999, 69.47528717700004],
              [-130.97044837099992, 69.47870514500005],
              [-130.9755753249999, 69.48969147300005],
              [-130.99071204299992, 69.50751373900005],
              [-130.99718176999994, 69.51837799700007],
              [-130.9929093089999, 69.52326080900008],
              [-130.9890030589999, 69.52928294500003],
              [-130.98607337099992, 69.54140859600005],
              [-130.97887122299994, 69.55052317900004],
              [-130.9619034499999, 69.54779694200005],
              [-130.94774329299992, 69.53888580900008],
              [-130.94493567599994, 69.53192780200004],
              [-130.94713294199994, 69.52334219000005],
              [-130.9482315749999, 69.50958893400008],
              [-130.94640051999994, 69.49323151200008],
              [-130.93643144399994, 69.45917389500005],
              [-130.9350479809999, 69.45050690300008],
              [-130.9345596999999, 69.43793366100005],
              [-130.93883216099994, 69.42430247600004],
              [-130.9482315749999, 69.41632721600007],
              [-130.95763098899994, 69.41063060100004],
              [-130.9619034499999, 69.40412018400008],
              [-130.96727454299992, 69.40062083500004],
              [-130.99665279899995, 69.36619700700004],
              [-131.00987708199995, 69.36172109600005],
              [-131.0266820949999, 69.35830312700006],
              [-131.04214433499993, 69.35199616100005],
              [-131.05125891799992, 69.33893463700008],
              [-131.0468643869999, 69.32859935100004],
              [-131.03502356699994, 69.31635163000004],
              [-131.0227758449999, 69.30923086100006],
              [-131.0171606109999, 69.31468333500004],
              [-131.00755774599992, 69.33380768400008],
              [-130.9846085279999, 69.35809967700004],
              [-130.9572647779999, 69.38031647300005],
              [-130.9345596999999, 69.39354075700004],
              [-130.91128495999993, 69.39622630400004],
              [-130.90086829299992, 69.38564687700006],
              [-130.9004613919999, 69.36684804900005],
              [-130.9072973299999, 69.34511953300006],
              [-130.91856848899994, 69.32648346600007],
              [-130.9336645169999, 69.31061432500007],
              [-130.9921768869999, 69.27098216400003],
              [-130.9943741529999, 69.25934479400007],
              [-130.9915258449999, 69.24778880400004],
              [-130.99974524599992, 69.23212311400005],
              [-131.01797441299993, 69.21674225500004],
              [-131.0261938139999, 69.20600006700005],
              [-131.0205785799999, 69.20111725500004],
              [-131.0080460279999, 69.19757721600007],
              [-131.00694739499994, 69.18943919500003],
              [-131.0134985019999, 69.18048737200007],
              [-131.02399654899995, 69.17446523600006],
              [-131.0171606109999, 69.15200429900005],
              [-131.01187089799993, 69.14508698100008],
              [-131.00283769399994, 69.13963450700004],
              [-130.9929093089999, 69.13837311400005],
              [-130.98375403599994, 69.14118073100008],
              [-130.9755753249999, 69.14508698100008],
              [-130.9687393869999, 69.14712148600006],
              [-130.9584854809999, 69.14569733300004],
              [-130.93883216099994, 69.14012278900003],
              [-130.9278051419999, 69.13963450700004],
              [-130.95164954299992, 69.16518789300005],
              [-130.9541723299999, 69.17877838700008],
              [-130.9383031889999, 69.19798411700003],
              [-130.93154863199993, 69.21369049700007],
              [-130.9394425119999, 69.23065827000005],
              [-130.95091712099992, 69.24754466400003],
              [-130.9550675119999, 69.26312897300005],
              [-130.9451391269999, 69.27667877800008],
              [-130.8698624339999, 69.32697174700007],
              [-130.8193253249999, 69.33852773600006],
              [-130.79743404899995, 69.35252513200004],
              [-130.80968176999994, 69.35976797100005],
              [-130.82213294199994, 69.37103913000004],
              [-130.8256729809999, 69.38153717700004],
              [-130.81139075399994, 69.38605377800008],
              [-130.7923070949999, 69.38886139500005],
              [-130.7658585279999, 69.40253327000005],
              [-130.7502335279999, 69.40778229400007],
              [-130.6868383449999, 69.41828034100007],
              [-130.66148841099994, 69.43268463700008],
              [-130.64659583199995, 69.46181875200006],
              [-130.67223059799994, 69.46230703300006],
              [-130.7502335279999, 69.45433177300004],
              [-130.53477942599994, 69.54230377800008],
              [-130.50633704299992, 69.56110260600008],
              [-130.49307206899994, 69.56769440300008],
              [-130.45738684799994, 69.57916901200008],
              [-130.44737708199995, 69.58535390800006],
              [-130.4460343089999, 69.59593333500004],
              [-130.4533585279999, 69.60301341400003],
              [-130.4585668609999, 69.61058177300004],
              [-130.45107988199993, 69.62287018400008],
              [-130.43814042899993, 69.63056061400005],
              [-130.40636145699995, 69.64032623900005],
              [-130.39273027299993, 69.64671458500004],
              [-130.37999426999994, 69.65851471600007],
              [-130.3709203769999, 69.66933828300006],
              [-130.35899817599994, 69.67755768400008],
              [-130.3381241529999, 69.68154531500005],
              [-130.3381241529999, 69.68773021000004],
              [-130.34898841099994, 69.68691640800006],
              [-130.35952714799993, 69.68773021000004],
              [-130.3698624339999, 69.69033437700006],
              [-130.3797094389999, 69.69452545800004],
              [-130.33824622299994, 69.70229726800005],
              [-130.16714433499993, 69.71173737200007],
              [-129.95523027299993, 69.75421784100007],
              [-129.8998917309999, 69.75600820500006],
              [-129.7019750639999, 69.78904857000003],
              [-129.60509192599994, 69.82489655200004],
              [-129.58141028599994, 69.82697174700007],
              [-129.5088598299999, 69.82489655200004],
              [-129.45181230399993, 69.83673737200007],
              [-129.12291419199994, 69.85610586100006],
              [-129.08462480399993, 69.86957428600005],
              [-129.04356848899994, 69.88987864800004],
              [-129.02969316299993, 69.90062083500004],
              [-129.0193578769999, 69.91120026200008],
              [-128.99551347599993, 69.94220612200007],
              [-128.96544348899994, 69.96450429900005],
              [-128.9253637359999, 69.97760651200008],
              [-128.8860570949999, 69.97626373900005],
              [-128.8583878249999, 69.95526764500005],
              [-128.89073645699995, 69.97052643400008],
              [-128.89834550699993, 69.95709870000007],
              [-128.8997289699999, 69.93158600500004],
              [-128.91299394399994, 69.91087474200003],
              [-128.94399980399993, 69.90180084800005],
              [-128.95791581899994, 69.89411041900007],
              [-128.95767167899993, 69.88324616100005],
              [-128.94298255099994, 69.86546458500004],
              [-128.9377335279999, 69.85687897300005],
              [-128.93285071499992, 69.84540436400005],
              [-129.1140030589999, 69.84772370000007],
              [-129.17369544199994, 69.83234284100007],
              [-129.13272050699993, 69.77708567900004],
              [-129.13532467399995, 69.76825592700004],
              [-129.13683020699995, 69.75824616100005],
              [-129.1404516269999, 69.74652741100005],
              [-129.15855872299994, 69.71482982000003],
              [-129.1536352199999, 69.70351797100005],
              [-129.13906816299993, 69.69708893400008],
              [-129.11904863199993, 69.69452545800004],
              [-129.0425512359999, 69.69293854400007],
              [-128.9941300119999, 69.67938873900005],
              [-128.9678442049999, 69.67918528900003],
              [-128.94151770699995, 69.68244049700007],
              [-128.91982988199993, 69.68773021000004],
              [-128.95872962099992, 69.70644765800006],
              [-128.9746801419999, 69.71922435100004],
              [-128.96764075399994, 69.73240794500003],
              [-128.94082597599993, 69.74298737200007],
              [-128.9120987619999, 69.74811432500007],
              [-128.82925370999993, 69.75202057500007],
              [-128.80329342399995, 69.75836823100008],
              [-128.7783096999999, 69.76805247600004],
              [-128.73839270699995, 69.79409414300005],
              [-128.69579016799992, 69.80939362200007],
              [-128.64028886599993, 69.84857819200005],
              [-128.60045325399994, 69.86933014500005],
              [-128.42638098899994, 69.93475983300004],
              [-128.33629309799994, 69.95038483300004],
              [-128.3103735019999, 69.96271393400008],
              [-128.31993567599994, 69.96808502800008],
              [-128.32396399599992, 69.96954987200007],
              [-128.3210343089999, 69.97406647300005],
              [-128.3185929029999, 69.97931549700007],
              [-128.31533769399994, 69.98468659100007],
              [-128.3103735019999, 69.98940664300005],
              [-128.31265214799993, 69.99896881700005],
              [-128.3134659499999, 70.01561107000003],
              [-128.3171280589999, 70.02411530200004],
              [-128.32481848899994, 70.02924225500004],
              [-128.33653723899994, 70.03388092700004],
              [-128.3472387359999, 70.03961823100008],
              [-128.35191809799994, 70.04775625200006],
              [-128.35684160099993, 70.06293366100005],
              [-128.36583411399994, 70.07949453300006],
              [-128.37022864499994, 70.09739817900004],
              [-128.36148027299993, 70.11664459800005],
              [-128.3372289699999, 70.12982819200005],
              [-128.26992753799993, 70.14081452000005],
              [-128.2429906889999, 70.15078359600005],
              [-128.2267960279999, 70.15888092700004],
              [-128.2077530589999, 70.16400788000004],
              [-128.1694229809999, 70.16754791900007],
              [-128.15489661399994, 70.17055898600006],
              [-128.12547766799992, 70.18451569200005],
              [-128.11107337099992, 70.18866608300004],
              [-127.99282792899993, 70.18146393400008],
              [-127.92096920499989, 70.20392487200007],
              [-127.88638261599993, 70.20905182500007],
              [-127.81688391799992, 70.20848216400003],
              [-127.58682206899994, 70.23769765800006],
              [-127.5152074859999, 70.22211334800005],
              [-127.54466712099992, 70.24046458500004],
              [-127.58202063699991, 70.25092194200005],
              [-127.74315344999991, 70.26186758000006],
              [-127.87222245999993, 70.27179596600007],
              [-128.03237870999993, 70.29368724200003],
              [-128.0605362619999, 70.30638255400004],
              [-128.06387285099993, 70.32514069200005],
              [-128.0799047519999, 70.33144765800006],
              [-128.0928442049999, 70.34153880400004],
              [-128.10313880099994, 70.35394928600005],
              [-128.11107337099992, 70.36676666900007],
              [-128.08311926999994, 70.36758047100005],
              [-128.0065811839999, 70.35761139500005],
              [-127.9807836579999, 70.34943268400008],
              [-127.95840410099993, 70.34821198100008],
              [-127.92829342399995, 70.38572825700004],
              [-127.90623938699991, 70.39411041900007],
              [-127.9422094389999, 70.40184153900003],
              [-128.0633031889999, 70.37978750200006],
              [-128.14073645699995, 70.37466054900005],
              [-128.17821204299992, 70.37995026200008],
              [-128.2005102199999, 70.40086497600004],
              [-128.19591223899994, 70.44696686400005],
              [-128.16344153599994, 70.49551015800006],
              [-128.11851966099994, 70.53607819200005],
              [-128.0769750639999, 70.55853913000004],
              [-128.0092667309999, 70.57904694200005],
              [-128.00747636599993, 70.58193594000005],
              [-128.00820878799993, 70.58588288000004],
              [-128.0076391269999, 70.58978913000004],
              [-128.00182044199994, 70.59271881700005],
              [-127.9915258449999, 70.59292226800005],
              [-127.97850501199991, 70.59076569200005],
              [-127.96597245999993, 70.58685944200005],
              [-127.92829342399995, 70.56708405200004],
              [-127.69839433499993, 70.50018952000005],
              [-127.44517981699994, 70.40591054900005],
              [-127.23082434799994, 70.30988190300008],
              [-127.1917211579999, 70.28221263200004],
              [-127.13646399599992, 70.25287506700005],
              [-127.12482662699989, 70.24017975500004],
              [-127.11587480399993, 70.22516510600008],
              [-127.05589758999992, 70.18121979400007],
              [-126.99079342399995, 70.10952383000006],
              [-126.92894446499992, 70.06443919500003],
              [-126.91250566299993, 70.04401276200008],
              [-126.89940344999991, 70.02358633000006],
              [-126.89293372299994, 70.01691315300008],
              [-126.88463294199994, 70.01048411700003],
              [-126.8667699859999, 70.00165436400005],
              [-126.82868404899995, 69.99298737200007],
              [-126.79991614499994, 69.98314036700003],
              [-126.78331458199995, 69.98012929900005],
              [-126.77476966099994, 69.97573476800005],
              [-126.7952367829999, 69.97573476800005],
              [-126.79165605399993, 69.95026276200008],
              [-126.78579667899993, 69.94159577000005],
              [-126.76854407499991, 69.93475983300004],
              [-126.79784094999991, 69.92206452000005],
              [-126.81017005099994, 69.91185130400004],
              [-126.80577551999994, 69.89862702000005],
              [-126.77135169199994, 69.86098867400005],
              [-126.72801673099991, 69.80198802300004],
              [-126.7200414699999, 69.78583405200004],
              [-126.71328691299993, 69.77708567900004],
              [-126.70177161399994, 69.76740143400008],
              [-126.67837480399993, 69.75381094000005],
              [-126.6460668609999, 69.72968170800004],
              [-126.27513587099992, 69.54857005400004],
              [-126.25772050699993, 69.53375885600008],
              [-126.24522864499994, 69.52533600500004],
              [-126.2273656889999, 69.51752350500004],
              [-126.2083227199999, 69.51178620000007],
              [-126.17398027299993, 69.50690338700008],
              [-126.15941321499992, 69.50018952000005],
              [-126.13170325399994, 69.48224518400008],
              [-125.93862870999993, 69.41400788000004],
              [-125.80833899599992, 69.38605377800008],
              [-125.77725175699993, 69.38654205900008],
              [-125.71446692599994, 69.39423248900005],
              [-125.68541419199994, 69.39354075700004],
              [-125.67503821499992, 69.39061107000003],
              [-125.67015540299991, 69.38670482000003],
              [-125.66612708199995, 69.38198476800005],
              [-125.65811113199993, 69.37641022300005],
              [-125.64525305899991, 69.37311432500007],
              [-125.61034094999991, 69.37299225500004],
              [-125.60472571499992, 69.36884186400005],
              [-125.59837805899991, 69.36188385600008],
              [-125.59361731699994, 69.35541413000004],
              [-125.59264075399994, 69.35252513200004],
              [-125.44884192599994, 69.31915924700007],
              [-125.42471269399994, 69.31842682500007],
              [-125.41295325399994, 69.32290273600006],
              [-125.3789770169999, 69.34292226800005],
              [-125.37010657499991, 69.35252513200004],
              [-125.3789770169999, 69.35529205900008],
              [-125.39745032499991, 69.36619700700004],
              [-125.39061438699991, 69.37299225500004],
              [-125.41201738199993, 69.38031647300005],
              [-125.45449785099993, 69.38690827000005],
              [-125.47313391799992, 69.40033600500004],
              [-125.46690833199995, 69.40770091400003],
              [-125.45954342399995, 69.41400788000004],
              [-125.43024654899995, 69.39899323100008],
              [-125.16124426999994, 69.38605377800008],
              [-125.14476477799991, 69.38996002800008],
              [-125.13451087099992, 69.39931875200006],
              [-125.12661699099993, 69.41079336100006],
              [-125.11685136599993, 69.42084381700005],
              [-125.1238500639999, 69.42340729400007],
              [-125.13609778599994, 69.43109772300005],
              [-125.14354407499991, 69.43451569200005],
              [-125.1316625639999, 69.44379303600005],
              [-125.08897864499994, 69.45433177300004],
              [-125.15099036399994, 69.45433177300004],
              [-125.15099036399994, 69.46181875200006],
              [-125.14098059799994, 69.46137116100005],
              [-125.13267981699994, 69.46246979400007],
              [-125.12498938699991, 69.46499258000006],
              [-125.11685136599993, 69.46865469000005],
              [-125.22411048099991, 69.46841054900005],
              [-125.25340735599991, 69.46181875200006],
              [-125.24722245999993, 69.44814687700006],
              [-125.26154537699989, 69.44757721600007],
              [-125.27529863199993, 69.44887929900005],
              [-125.30186926999994, 69.45433177300004],
              [-125.29865475199989, 69.45856354400007],
              [-125.29686438699991, 69.46214427300004],
              [-125.29405676999994, 69.46548086100006],
              [-125.28819739499994, 69.46865469000005],
              [-125.30361894399994, 69.47394440300008],
              [-125.46568762899994, 69.45433177300004],
              [-125.54206295499989, 69.43451569200005],
              [-125.57713782499991, 69.43537018400008],
              [-125.58608964799993, 69.43134186400005],
              [-125.59430904899995, 69.42523834800005],
              [-125.60362708199995, 69.42153554900005],
              [-125.61367753799993, 69.42007070500006],
              [-125.62401282499991, 69.42084381700005],
              [-125.61461341099994, 69.43231842700004],
              [-125.58824622299994, 69.45001862200007],
              [-125.57555091099994, 69.46181875200006],
              [-125.57876542899993, 69.46576569200005],
              [-125.58023027299993, 69.46914297100005],
              [-125.58128821499992, 69.47239817900004],
              [-125.58299719999991, 69.47606028900003],
              [-125.54165605399993, 69.48016998900005],
              [-125.50047766799992, 69.47606028900003],
              [-125.50047766799992, 69.48224518400008],
              [-125.5113012359999, 69.48798248900005],
              [-125.51256262899994, 69.49233633000006],
              [-125.50767981699994, 69.49677155200004],
              [-125.4839574859999, 69.51365794500003],
              [-125.46865800699993, 69.51496002800008],
              [-125.43529212099992, 69.50958893400008],
              [-125.30870520699995, 69.50275299700007],
              [-125.30870520699995, 69.50958893400008],
              [-125.3157445949999, 69.51264069200005],
              [-125.32852128799993, 69.52045319200005],
              [-125.3360082669999, 69.52326080900008],
              [-125.31651770699995, 69.52753327000005],
              [-125.29238847599993, 69.52130768400008],
              [-125.24722245999993, 69.50275299700007],
              [-125.18272864499994, 69.49188873900005],
              [-125.11685136599993, 69.48969147300005],
              [-125.15347245999993, 69.50470612200007],
              [-125.24079342399995, 69.51756419500003],
              [-125.27452551999994, 69.53685130400004],
              [-125.26768958199995, 69.54433828300006],
              [-125.28677324099993, 69.55084870000007],
              [-125.29434160099993, 69.55117422100005],
              [-125.29434160099993, 69.55805084800005],
              [-125.28477942599994, 69.55817291900007],
              [-125.2737524079999, 69.56077708500004],
              [-125.26463782499991, 69.56622955900008],
              [-125.26085364499994, 69.57477448100008],
              [-125.21930904899995, 69.58535390800006],
              [-125.24705969999991, 69.59503815300008],
              [-125.41588294199994, 69.60321686400005],
              [-125.43838456899994, 69.61261627800008],
              [-125.40221106699994, 69.61107005400004],
              [-125.38634192599994, 69.61473216400003],
              [-125.37694251199991, 69.62628815300008],
              [-125.39468339799993, 69.62738678600005],
              [-125.39867102799991, 69.62929922100005],
              [-125.39745032499991, 69.63312409100007],
              [-125.40469316299993, 69.63385651200008],
              [-125.4097387359999, 69.63519928600005],
              [-125.41392981699994, 69.63735586100006],
              [-125.41856848899994, 69.64057038000004],
              [-125.38198808499993, 69.68475983300004],
              [-125.37010657499991, 69.69452545800004],
              [-125.33726966099994, 69.70278554900005],
              [-125.26573645699995, 69.69415924700007],
              [-125.23355058499993, 69.69452545800004],
              [-125.14354407499991, 69.72866445500006],
              [-125.12962805899991, 69.72955963700008],
              [-125.10216223899994, 69.72711823100008],
              [-125.08897864499994, 69.72866445500006],
              [-125.0840551419999, 69.73216380400004],
              [-125.08462480399993, 69.73696523600006],
              [-125.08657792899993, 69.74188873900005],
              [-125.08584550699993, 69.74640534100007],
              [-125.0784399079999, 69.75006745000007],
              [-125.06798255099994, 69.75096263200004],
              [-125.03229732999989, 69.74725983300004],
              [-124.97012285099993, 69.73322174700007],
              [-124.96764075399994, 69.72601959800005],
              [-124.96857662699989, 69.71710846600007],
              [-124.96605383999992, 69.70880768400008],
              [-124.9539281889999, 69.69554271000004],
              [-124.94786536399994, 69.68699778900003],
              [-124.94570878799993, 69.67829010600008],
              [-124.94554602799991, 69.66445547100005],
              [-124.93691972599993, 69.64996979400007],
              [-124.91706295499989, 69.65326569200005],
              [-124.89513098899994, 69.66551341400003],
              [-124.88003495999993, 69.67780182500007],
              [-124.86620032499991, 69.69940827000005],
              [-124.86156165299991, 69.71320221600007],
              [-124.8516332669999, 69.71857330900008],
              [-124.82201087099992, 69.71503327000005],
              [-124.87242591099994, 69.74066803600005],
              [-124.9260961579999, 69.75259023600006],
              [-125.0769750639999, 69.75942617400005],
              [-125.14024817599994, 69.77415599200003],
              [-125.17149817599994, 69.77708567900004],
              [-125.22126217399995, 69.76805247600004],
              [-125.23989824099993, 69.77106354400007],
              [-125.26085364499994, 69.79075755400004],
              [-125.25340735599991, 69.79759349200003],
              [-125.26585852799991, 69.80768463700008],
              [-125.27196204299992, 69.81045156500005],
              [-125.28136145699995, 69.81122467700004],
              [-125.21930904899995, 69.84540436400005],
              [-125.20250403599994, 69.85203685100004],
              [-125.18053137899994, 69.85732656500005],
              [-125.16600501199991, 69.85488515800006],
              [-125.17149817599994, 69.83856842700004],
              [-125.16397050699993, 69.82636139500005],
              [-125.16893469999991, 69.80206940300008],
              [-125.15782630099994, 69.79759349200003],
              [-125.07530676999994, 69.79759349200003],
              [-125.06460527299993, 69.79938385600008],
              [-125.06163489499994, 69.80121491100005],
              [-125.06212317599994, 69.80292389500005],
              [-125.06163489499994, 69.80438873900005],
              [-125.03091386599993, 69.82176341400003],
              [-125.02367102799991, 69.83173248900005],
              [-125.01988684799994, 69.84418366100005],
              [-125.02074133999992, 69.85651276200008],
              [-125.02749589799993, 69.86587148600006],
              [-124.97667395699995, 69.88666413000004],
              [-124.9312231109999, 69.92527903900003],
              [-124.91510982999989, 69.93512604400007],
              [-124.89712480399993, 69.94220612200007],
              [-124.70791581899994, 69.97504303600005],
              [-124.69542395699995, 69.97943756700005],
              [-124.68175208199995, 69.97296784100007],
              [-124.6597387359999, 69.97036367400005],
              [-124.63931230399993, 69.97394440300008],
              [-124.63023841099994, 69.98627350500004],
              [-124.63609778599994, 69.99835846600007],
              [-124.65050208199995, 70.01113515800006],
              [-124.66832434799994, 70.02094147300005],
              [-124.6848852199999, 70.02411530200004],
              [-124.70360266799992, 70.01691315300008],
              [-124.72398841099994, 69.98769765800006],
              [-124.74010169199994, 69.97573476800005],
              [-124.7659399079999, 69.97223541900007],
              [-124.8003637359999, 69.97455475500004],
              [-124.83364824099993, 69.98094310100004],
              [-124.85619055899991, 69.98940664300005],
              [-124.82664954299992, 70.00169505400004],
              [-124.79474850199989, 70.01048411700003],
              [-124.81407630099994, 70.01585521000004],
              [-124.90294348899994, 70.01609935100004],
              [-124.9114477199999, 70.01361725500004],
              [-124.91690019399994, 70.00885651200008],
              [-124.91978919199994, 70.00307851800005],
              [-124.92349199099993, 69.99823639500005],
              [-124.93154863199993, 69.99624258000006],
              [-124.94713294199994, 69.99860260600008],
              [-124.97423255099994, 70.00877513200004],
              [-124.99274654899995, 70.01048411700003],
              [-125.00877844999991, 70.00824616100005],
              [-125.02525794199994, 70.00336334800005],
              [-125.05540930899991, 69.98940664300005],
              [-125.05260169199994, 69.98550039300005],
              [-125.04796301999994, 69.97573476800005],
              [-125.06786048099991, 69.97744375200006],
              [-125.09166419199994, 69.97687409100007],
              [-125.11416581899994, 69.97239817900004],
              [-125.12987219999991, 69.96271393400008],
              [-125.12059485599991, 69.96116771000004],
              [-125.11489824099993, 69.95815664300005],
              [-125.10260982999989, 69.94839101800005],
              [-125.11978105399993, 69.94261302300004],
              [-125.13662675699993, 69.94391510600008],
              [-125.1536352199999, 69.94741445500006],
              [-125.17149817599994, 69.94839101800005],
              [-125.1851293609999, 69.94334544500003],
              [-125.19790605399993, 69.93642812700006],
              [-125.20946204299992, 69.93549225500004],
              [-125.21930904899995, 69.94839101800005],
              [-125.19603430899991, 69.96137116100005],
              [-125.1848852199999, 69.97321198100008],
              [-125.18765214799993, 69.98639557500007],
              [-125.20620683499993, 70.00307851800005],
              [-125.19635982999989, 70.00897858300004],
              [-125.16466223899994, 70.01675039300005],
              [-125.12987219999991, 70.03717682500007],
              [-125.05797278599994, 70.05243561400005],
              [-125.03465735599991, 70.06134674700007],
              [-125.02725175699993, 70.06793854400007],
              [-125.0188695949999, 70.08274974200003],
              [-125.01382402299993, 70.08559804900005],
              [-125.00365149599992, 70.08535390800006],
              [-124.9925024079999, 70.08344147300005],
              [-124.98346920499989, 70.07827383000006],
              [-124.97972571499992, 70.06826406500005],
              [-124.98766028599994, 70.04555898600006],
              [-125.00670325399994, 70.04096100500004],
              [-125.02920488199993, 70.04051341400003],
              [-125.04796301999994, 70.03034088700008],
              [-125.00609290299991, 70.01996491100005],
              [-124.95099850199989, 70.01825592700004],
              [-124.89639238199993, 70.02431875200006],
              [-124.85619055899991, 70.03717682500007],
              [-124.95921790299991, 70.03034088700008],
              [-124.95921790299991, 70.03717682500007],
              [-124.94782467399995, 70.04002513200004],
              [-124.92931067599994, 70.04828522300005],
              [-124.9182836579999, 70.05145905200004],
              [-124.86363684799994, 70.05760325700004],
              [-124.85326087099992, 70.06159088700008],
              [-124.84487870999993, 70.06610748900005],
              [-124.8355199859999, 70.06981028900003],
              [-124.82201087099992, 70.07135651200008],
              [-124.81834876199991, 70.06924062700006],
              [-124.81167558499993, 70.05996328300006],
              [-124.80842037699989, 70.05760325700004],
              [-124.79898027299993, 70.05829498900005],
              [-124.78282630099994, 70.06378815300008],
              [-124.67125403599994, 70.07880280200004],
              [-124.6504613919999, 70.07485586100006],
              [-124.63174394399994, 70.06476471600007],
              [-124.59552975199989, 70.03717682500007],
              [-124.5999242829999, 70.02187734600005],
              [-124.57652747299994, 70.01483795800004],
              [-124.54556230399993, 70.01894765800006],
              [-124.52721106699994, 70.03717682500007],
              [-124.56200110599991, 70.03717682500007],
              [-124.52798417899993, 70.06098053600005],
              [-124.49071204299992, 70.05414459800005],
              [-124.45287024599992, 70.04242584800005],
              [-124.41734778599994, 70.05145905200004],
              [-124.44790605399993, 70.07957591400003],
              [-124.46499589799993, 70.08665599200003],
              [-124.48623613199993, 70.08218008000006],
              [-124.51012122299994, 70.07396067900004],
              [-124.5352270169999, 70.07196686400005],
              [-124.55980383999992, 70.07599518400008],
              [-124.58242753799993, 70.08559804900005],
              [-124.56212317599994, 70.09015534100007],
              [-124.53868567599994, 70.09064362200007],
              [-124.51821855399993, 70.09373607000003],
              [-124.50674394399994, 70.10602448100008],
              [-124.5940649079999, 70.11640045800004],
              [-124.62340247299994, 70.11286041900007],
              [-124.71060136599993, 70.09235260600008],
              [-124.74010169199994, 70.09243398600006],
              [-124.74010169199994, 70.09857819200005],
              [-124.72520911399994, 70.09931061400005],
              [-124.71104895699995, 70.10224030200004],
              [-124.6848852199999, 70.11286041900007],
              [-124.69688880099994, 70.11880117400005],
              [-124.71153723899994, 70.12152741100005],
              [-124.72667395699995, 70.12103913000004],
              [-124.74600175699993, 70.11473216400003],
              [-124.75055904899995, 70.11603424700007],
              [-124.7532445949999, 70.12010325700004],
              [-124.75377356699994, 70.12661367400005],
              [-124.75039628799993, 70.13202545800004],
              [-124.74351966099994, 70.13401927300004],
              [-124.73570716099994, 70.13495514500005],
              [-124.72984778599994, 70.13715241100005],
              [-124.70201575399994, 70.15127187700006],
              [-124.66978919199994, 70.15326569200005],
              [-124.60228430899991, 70.14704010600008],
              [-124.59044348899994, 70.14940013200004],
              [-124.56737219999991, 70.15961334800005],
              [-124.55455481699994, 70.16132233300004],
              [-124.5391332669999, 70.15851471600007],
              [-124.5210668609999, 70.14964427300004],
              [-124.50674394399994, 70.14704010600008],
              [-124.44155839799993, 70.15566640800006],
              [-124.40811113199993, 70.15542226800005],
              [-124.38385982999989, 70.14020416900007],
              [-124.42833411399994, 70.12225983300004],
              [-124.44391842399995, 70.11115143400008],
              [-124.4319555329999, 70.10602448100008],
              [-124.41315670499989, 70.10293203300006],
              [-124.39146887899994, 70.09487539300005],
              [-124.37279212099992, 70.08364492400005],
              [-124.36270097599993, 70.07135651200008],
              [-124.36318925699993, 70.05687083500004],
              [-124.37026933499993, 70.04169342700004],
              [-124.38052324099993, 70.02863190300008],
              [-124.39037024599992, 70.02045319200005],
              [-124.41685950399994, 70.01483795800004],
              [-124.47720292899993, 70.02073802300004],
              [-124.50674394399994, 70.01048411700003],
              [-124.48599199099993, 70.00287506700005],
              [-124.4387914699999, 70.00287506700005],
              [-124.41734778599994, 69.99624258000006],
              [-124.4343969389999, 69.99176666900007],
              [-124.4722387359999, 69.99355703300006],
              [-124.47940019399994, 69.98627350500004],
              [-124.48672441299993, 69.97675202000005],
              [-124.50405839799993, 69.97426992400005],
              [-124.52440344999991, 69.97353750200006],
              [-124.54088294199994, 69.96954987200007],
              [-124.48770097599993, 69.95791250200006],
              [-124.43537350199989, 69.95526764500005],
              [-124.43065344999991, 69.95148346600007],
              [-124.4317113919999, 69.94306061400005],
              [-124.43545488199993, 69.93378327000005],
              [-124.43907630099994, 69.92792389500005],
              [-124.44994055899991, 69.91982656500005],
              [-124.46117102799991, 69.91803620000007],
              [-124.48623613199993, 69.92047760600008],
              [-124.50690670499989, 69.91632721600007],
              [-124.49986731699994, 69.90717194200005],
              [-124.47834225199989, 69.89801666900007],
              [-124.45518958199995, 69.89378489800004],
              [-124.44619706899994, 69.89077383000006],
              [-124.44640051999994, 69.88397858300004],
              [-124.45213782499991, 69.87327708500004],
              [-124.44322669199994, 69.86810944200005],
              [-124.43175208199995, 69.86399974200003],
              [-124.41832434799994, 69.86115143400008],
              [-124.40371660099993, 69.85968659100007],
              [-124.42503821499992, 69.85077545800004],
              [-124.45201575399994, 69.83445872600004],
              [-124.47203528599994, 69.81533437700006],
              [-124.47256425699993, 69.79759349200003],
              [-124.49120032499991, 69.79657623900005],
              [-124.49644934799994, 69.78974030200004],
              [-124.49229895699995, 69.77912018400008],
              [-124.48253333199995, 69.76683177300004],
              [-124.48119055899991, 69.75918203300006],
              [-124.4878637359999, 69.75112539300005],
              [-124.50674394399994, 69.73615143400008],
              [-124.48033606699994, 69.72085195500006],
              [-124.4143774079999, 69.72431061400005],
              [-124.39378821499992, 69.71873607000003],
              [-124.36656653599994, 69.70384349200003],
              [-124.32607988199993, 69.69798411700003],
              [-124.28514563699991, 69.70087311400005],
              [-124.25658118399991, 69.71190013200004],
              [-124.22984778599994, 69.72699616100005],
              [-124.20156816299993, 69.73200104400007],
              [-124.07477779899995, 69.72866445500006],
              [-124.06826738199993, 69.72528717700004],
              [-124.0628149079999, 69.71792226800005],
              [-124.0547582669999, 69.71100495000007],
              [-124.0405981109999, 69.70880768400008],
              [-124.04588782499991, 69.70368073100008],
              [-124.0542699859999, 69.68773021000004],
              [-124.0491430329999, 69.68646881700005],
              [-124.03941809799994, 69.68280670800004],
              [-124.03441321499992, 69.68154531500005],
              [-124.0718481109999, 69.66583893400008],
              [-124.18464107999989, 69.63312409100007],
              [-124.20962480399993, 69.61603424700007],
              [-124.21703040299991, 69.59577057500007],
              [-124.22203528599994, 69.57367584800005],
              [-124.23985755099994, 69.55117422100005],
              [-124.26891028599994, 69.53656647300005],
              [-124.3433324859999, 69.51557038000004],
              [-124.39134680899991, 69.49530670800004],
              [-124.42910722599993, 69.47345612200007],
              [-124.43907630099994, 69.46181875200006],
              [-124.43956458199995, 69.44794342700004],
              [-124.43325761599993, 69.43585846600007],
              [-124.41734778599994, 69.41400788000004],
              [-124.4983617829999, 69.41510651200008],
              [-124.5210668609999, 69.40778229400007],
              [-124.50112870999993, 69.39594147300005],
              [-124.43846594999991, 69.36961497600004],
              [-124.42284094999991, 69.36664459800005],
              [-124.38219153599994, 69.36737702000005],
              [-124.34618079299992, 69.35736725500004],
              [-124.32607988199993, 69.35423411700003],
              [-124.15884355399993, 69.34808991100005],
              [-124.09459387899994, 69.35907623900005],
              [-124.0542699859999, 69.39354075700004],
              [-124.06110592399995, 69.37986888200004],
              [-124.03807532499991, 69.35773346600007],
              [-124.02269446499992, 69.34735748900005],
              [-124.00645911399994, 69.34511953300006],
              [-123.9942113919999, 69.35297272300005],
              [-123.99913489499994, 69.36359284100007],
              [-124.02013098899994, 69.37986888200004],
              [-124.01012122299994, 69.39663320500006],
              [-123.99791419199994, 69.40395742400005],
              [-123.98314368399991, 69.40436432500007],
              [-123.96548417899993, 69.40033600500004],
              [-123.9632055329999, 69.39752838700008],
              [-123.96133378799993, 69.39264557500007],
              [-123.9563695949999, 69.38808828300006],
              [-123.88194739499994, 69.37360260600008],
              [-123.86961829299992, 69.37299225500004],
              [-123.86168372299994, 69.37470123900005],
              [-123.85094153599994, 69.38304271000004],
              [-123.84264075399994, 69.38605377800008],
              [-123.82803300699993, 69.38768138200004],
              [-123.80882727799991, 69.38735586100006],
              [-123.79625403599994, 69.38133372600004],
              [-123.80162512899994, 69.36619700700004],
              [-123.75186113199993, 69.37579987200007],
              [-123.72695878799993, 69.37750885600008],
              [-123.69798743399991, 69.37299225500004],
              [-123.69200598899994, 69.36994049700007],
              [-123.6856176419999, 69.36530182500007],
              [-123.67686926999994, 69.36115143400008],
              [-123.66356360599991, 69.35936107000003],
              [-123.64842688699991, 69.36151764500005],
              [-123.61766516799992, 69.37091705900008],
              [-123.54474850199995, 69.37702057500007],
              [-123.38267981699994, 69.41400788000004],
              [-123.42007402299993, 69.42011139500005],
              [-123.43740800699993, 69.42633698100008],
              [-123.44473222599993, 69.43793366100005],
              [-123.44766191299993, 69.46409739800004],
              [-123.44322669199994, 69.47687409100007],
              [-123.42764238199993, 69.48224518400008],
              [-123.41136633999992, 69.48493073100008],
              [-123.35533606699994, 69.50275299700007],
              [-123.26659094999991, 69.50958893400008],
              [-123.27342688699991, 69.50275299700007],
              [-123.17756100199995, 69.49591705900008],
              [-123.16563880099994, 69.50043366100005],
              [-123.1634008449999, 69.51129791900007],
              [-123.16470292899993, 69.52472565300008],
              [-123.16356360599991, 69.53685130400004],
              [-123.15977942599994, 69.54352448100008],
              [-123.1563207669999, 69.54621002800008],
              [-123.1531469389999, 69.54779694200005],
              [-123.1446020169999, 69.55683014500005],
              [-123.13780676999994, 69.56207916900007],
              [-123.13194739499994, 69.56777578300006],
              [-123.12946529899995, 69.57477448100008],
              [-123.13475501199991, 69.58909739800004],
              [-123.1582738919999, 69.60663483300004],
              [-123.16356360599991, 69.61603424700007],
              [-123.15811113199993, 69.63007233300004],
              [-123.14509029899995, 69.63914622600004],
              [-123.12930253799993, 69.64618561400005],
              [-123.11579342399995, 69.65420156500005],
              [-123.10407467399995, 69.66644928600005],
              [-123.10045325399994, 69.67536041900007],
              [-123.10472571499992, 69.72329336100006],
              [-123.11367753799993, 69.74371979400007],
              [-123.13072669199994, 69.75950755400004],
              [-123.15733801999994, 69.77024974200003],
              [-123.07774817599994, 69.78778717700004],
              [-123.05370032499991, 69.79759349200003],
              [-123.0051977199999, 69.82501862200007],
              [-122.97972571499992, 69.83478424700007],
              [-122.95099850199995, 69.83856842700004],
              [-122.83556067599994, 69.80312734600005],
              [-122.77253170499989, 69.79486725500004],
              [-122.74583899599992, 69.82489655200004],
              [-122.74583899599992, 69.83234284100007],
              [-122.73029537699995, 69.82977936400005],
              [-122.70189368399991, 69.82078685100004],
              [-122.6843969389999, 69.81867096600007],
              [-122.64671790299991, 69.82225169500003],
              [-122.62816321499992, 69.82172272300005],
              [-122.58438066299993, 69.80914948100008],
              [-122.53026282499991, 69.81305573100008],
              [-122.48110917899993, 69.80206940300008],
              [-122.35260982999989, 69.81415436400005],
              [-122.17210852799991, 69.80451080900008],
              [-122.03604081899994, 69.81867096600007],
              [-121.6438695949999, 69.78904857000003],
              [-121.55996660099993, 69.76947663000004],
              [-121.42784583199995, 69.76683177300004],
              [-121.11760413299993, 69.69517649950004],
              [-120.80736243399991, 69.62352122600004],
              [-120.68081620999993, 69.55666738500008],
              [-120.63951575399994, 69.53485748900005],
              [-120.2786352199999, 69.40778229400007],
              [-120.15786699099993, 69.38861725500004],
              [-120.08580481699994, 69.36359284100007],
              [-119.9976293609999, 69.34735748900005],
              [-119.78722083199995, 69.34735748900005],
              [-119.72549394399994, 69.32977936400005],
              [-119.47618567599994, 69.30516185100004],
              [-119.25816809799994, 69.29645416900007],
              [-118.86876380099994, 69.25617096600007],
              [-118.66637122299994, 69.22549062700006],
              [-118.65086829299992, 69.21881745000007],
              [-118.62852942599994, 69.20205312700006],
              [-118.47691809799994, 69.12946198100008],
              [-118.22081458199995, 69.07819245000007],
              [-118.04088294199994, 69.02460358300004],
              [-117.83470618399991, 68.99428945500006],
              [-117.68675696499992, 68.98566315300008],
              [-117.37071692599994, 68.95091380400004],
              [-117.30186926999994, 68.92568594000005],
              [-117.16539466099994, 68.89394765800006],
              [-117.12612870999993, 68.89325592700004],
              [-117.0696508449999, 68.90509674700007],
              [-117.05068925699993, 68.90692780200004],
              [-117.00430253799993, 68.90509674700007],
              [-116.98135331899994, 68.90680573100008],
              [-116.96165930899991, 68.91376373900005],
              [-116.97288977799991, 68.92047760600008],
              [-117.00064042899993, 68.93065013200004],
              [-117.0100805329999, 68.94037506700005],
              [-116.97362219999991, 68.94627513200004],
              [-116.94163977799991, 68.93870677300004],
              [-116.86123613199993, 68.89252350500004],
              [-116.84707597599993, 68.88768138200004],
              [-116.83165442599994, 68.88580963700008],
              [-116.82420813699991, 68.88690827000005],
              [-116.79775956899994, 68.89638906500005],
              [-116.78726152299993, 68.89777252800008],
              [-116.77708899599992, 68.89451732000003],
              [-116.76695716099994, 68.88959381700005],
              [-116.75682532499991, 68.88580963700008],
              [-116.46784420499989, 68.86375560100004],
              [-116.42178300699993, 68.86725495000007],
              [-116.41295325399994, 68.88580963700008],
              [-116.38613847599993, 68.88532135600008],
              [-116.32860266799992, 68.87811920800004],
              [-116.24974524599992, 68.85228099200003],
              [-116.21703040299991, 68.83388906500005],
              [-116.20811926999994, 68.83120351800005],
              [-115.97118079299992, 68.80927155200004],
              [-115.94123287699995, 68.81753164300005],
              [-116.09870357999989, 68.85639069200005],
              [-116.12559973899994, 68.87897370000007],
              [-116.0852758449999, 68.87897370000007],
              [-116.0852758449999, 68.88580963700008],
              [-116.31110592399995, 68.94769928600005],
              [-116.32359778599994, 68.95482005400004],
              [-116.31798255099994, 68.96832916900007],
              [-116.29800370999993, 68.97882721600007],
              [-116.26895097599993, 68.98505280200004],
              [-116.21524003799993, 68.98883698100008],
              [-116.1604711579999, 68.98411692900004],
              [-115.90811113199993, 68.92967357000003],
              [-115.8792211579999, 68.92739492400005],
              [-115.86709550699993, 68.92938873900005],
              [-115.84805253799993, 68.93842194200005],
              [-115.83788001199991, 68.94037506700005],
              [-115.76992753799993, 68.94037506700005],
              [-115.79190019399994, 68.95099518400008],
              [-115.8655492829999, 68.96832916900007],
              [-115.88499915299991, 68.97606028900003],
              [-115.92210852799991, 68.99628327000005],
              [-115.94123287699995, 69.00311920800004],
              [-115.91641191299993, 69.01015859600005],
              [-115.80166581899994, 68.99140045800004],
              [-115.7434789699999, 68.97260163000004],
              [-115.71471106699994, 68.96832916900007],
              [-115.58775794199994, 68.97516510600008],
              [-115.56725012899994, 68.97186920800004],
              [-115.49714107999989, 68.94594961100006],
              [-115.48102779899995, 68.94350820500006],
              [-115.44298255099994, 68.94232819200005],
              [-115.43040930899991, 68.93732330900008],
              [-115.42125403599994, 68.93252187700006],
              [-115.37889563699991, 68.92112864800004],
              [-115.2112524079999, 68.89573802300004],
              [-115.11436926999994, 68.85643138200004],
              [-115.06358801999994, 68.85228099200003],
              [-115.06358801999994, 68.85846588700008],
              [-115.06761633999992, 68.86005280200004],
              [-115.07725989499994, 68.86591217700004],
              [-115.03498287699995, 68.87514883000006],
              [-114.98778235599991, 68.86741771000004],
              [-114.82933508999992, 68.81391022300005],
              [-114.80040442599994, 68.79726797100005],
              [-114.77554277299993, 68.77655670800004],
              [-114.74205481699994, 68.75531647300005],
              [-114.52257239499994, 68.71723053600005],
              [-114.43980872299994, 68.68720123900005],
              [-114.44815019399994, 68.68402741100005],
              [-114.45474199099993, 68.67934804900005],
              [-114.46776282499991, 68.66669342700004],
              [-114.43407141799992, 68.65086497600004],
              [-114.41885331899994, 68.64118073100008],
              [-114.41246497299994, 68.62913646000004],
              [-114.4011938139999, 68.61692942900004],
              [-114.3753149079999, 68.60700104400007],
              [-114.20103919199994, 68.57192617400005],
              [-114.18285071499992, 68.56403229400007],
              [-114.18659420499989, 68.55068594000005],
              [-114.17967688699991, 68.53872304900005],
              [-114.16966712099992, 68.53009674700007],
              [-114.15689042899993, 68.52505117400005],
              [-114.14220130099994, 68.52334219000005],
              [-114.12828528599994, 68.52008698100008],
              [-114.1055395169999, 68.50600820500006],
              [-114.09434973899994, 68.50287506700005],
              [-114.07994544199994, 68.49445221600007],
              [-114.07042395699995, 68.47516510600008],
              [-114.06338456899994, 68.45429108300004],
              [-114.05679277299993, 68.44082265800006],
              [-114.11168372299994, 68.43964264500005],
              [-114.12466386599993, 68.43183014500005],
              [-114.11082923099991, 68.41347890800006],
              [-114.08608964799993, 68.40086497600004],
              [-114.05943762899994, 68.39740631700005],
              [-114.00499426999994, 68.39980703300006],
              [-114.00560462099992, 68.40619538000004],
              [-114.00059973899994, 68.42023346600007],
              [-113.98839270699995, 68.43439362200007],
              [-113.96715247299994, 68.44082265800006],
              [-113.95425370999993, 68.43561432500007],
              [-113.90538489499994, 68.39980703300006],
              [-113.9195043609999, 68.39565664300005],
              [-113.93541419199994, 68.39484284100007],
              [-113.94839433499993, 68.39223867400005],
              [-113.95376542899993, 68.38247304900005],
              [-113.95645097599993, 68.37348053600005],
              [-113.96324622299994, 68.36782461100006],
              [-114.04190019399994, 68.32217031500005],
              [-114.05679277299993, 68.30418528900003],
              [-114.0469457669999, 68.28961823100008],
              [-114.02061926999994, 68.26609935100004],
              [-114.01524817599994, 68.25267161700003],
              [-114.0354711579999, 68.24119700700004],
              [-114.08120683499993, 68.24066803600005],
              [-114.20518958199995, 68.25751373900005],
              [-114.22069251199991, 68.25580475500004],
              [-114.23253333199995, 68.25079987200007],
              [-114.25446529899995, 68.23843008000006],
              [-114.26846269399994, 68.23590729400007],
              [-114.33739173099991, 68.23590729400007],
              [-114.35065670499989, 68.23993561400005],
              [-114.37800045499989, 68.25299713700008],
              [-114.38857988199993, 68.25580475500004],
              [-114.40371660099993, 68.25796133000006],
              [-114.4348852199999, 68.26727936400005],
              [-114.45034745999993, 68.26947663000004],
              [-114.62425696499992, 68.25210195500006],
              [-114.83702551999994, 68.26264069200005],
              [-114.90420488199993, 68.28412506700005],
              [-114.94151770699995, 68.29132721600007],
              [-114.96861731699994, 68.28314850500004],
              [-114.94212805899991, 68.27472565300008],
              [-114.88727779899995, 68.24787018400008],
              [-114.8386938139999, 68.23631419500003],
              [-114.75511633999992, 68.19432200700004],
              [-114.77843176999994, 68.19013092700004],
              [-114.80809485599991, 68.19334544500003],
              [-114.83364824099993, 68.19106679900005],
              [-114.84447180899991, 68.17015208500004],
              [-114.8601781889999, 68.15656159100007],
              [-114.8960668609999, 68.15135325700004],
              [-115.24168860599991, 68.18691640800006],
              [-115.22533118399991, 68.16962311400005],
              [-115.19896399599992, 68.15607330900008],
              [-115.17951412699995, 68.14183177300004],
              [-115.18370520699995, 68.12238190300008],
              [-115.19448808499993, 68.11371491100005],
              [-115.21719316299993, 68.10187409100007],
              [-115.2280981109999, 68.09129466400003],
              [-115.23375403599994, 68.08063385600008],
              [-115.24278723899994, 68.05475495000007],
              [-115.24913489499994, 68.04291413000004],
              [-115.2200414699999, 68.02997467700004],
              [-115.20474199099993, 68.02570221600007],
              [-115.18712317599994, 68.02301666900007],
              [-115.12865149599992, 68.02285390800006],
              [-115.11196855399993, 68.01618073100008],
              [-115.12926184799994, 68.00747304900005],
              [-115.1675512359999, 68.00043366100005],
              [-115.20299231699994, 67.98224518400008],
              [-115.22915605399993, 67.97724030200004],
              [-115.30239824099993, 67.97333405200004],
              [-115.46825110599991, 67.94049713700008],
              [-115.51158606699994, 67.93866608300004],
              [-115.53380286399994, 67.93439362200007],
              [-115.54336503799993, 67.92340729400007],
              [-115.53612219999991, 67.90338776200008],
              [-115.51821855399993, 67.89524974200003],
              [-115.47447669199994, 67.89272695500006],
              [-115.39354407499991, 67.87909577000005],
              [-115.25601152299993, 67.88589101800005],
              [-115.2637426419999, 67.88471100500004],
              [-115.2708227199999, 67.88214752800008],
              [-115.27717037699995, 67.87799713700008],
              [-115.28270423099991, 67.87221914300005],
              [-115.26585852799991, 67.86163971600007],
              [-115.22765051999994, 67.84540436400005],
              [-115.21129309799994, 67.83466217700004],
              [-115.18724524599992, 67.82444896000004],
              [-115.12633216099994, 67.81289297100005],
              [-115.11823482999989, 67.80390045800004],
              [-114.99649003799993, 67.79271067900004],
              [-114.78921464799993, 67.81696198100008],
              [-114.71654212099992, 67.81159088700008],
              [-114.68521074099993, 67.80320872600004],
              [-114.63487708199995, 67.78180573100008],
              [-114.61766516799992, 67.77659739800004],
              [-114.59902910099993, 67.77456289300005],
              [-114.5769750639999, 67.77602773600006],
              [-114.54283606699994, 67.78286367400005],
              [-114.54088294199994, 67.78660716400003],
              [-114.53990637899994, 67.79303620000007],
              [-114.53526770699995, 67.79694245000007],
              [-114.39785722599993, 67.74188873900005],
              [-114.32982337099992, 67.72821686400005],
              [-114.26162675699993, 67.72821686400005],
              [-114.20018469999991, 67.74188873900005],
              [-114.17210852799991, 67.74225495000007],
              [-113.98131262899994, 67.72418854400007],
              [-113.94225012899994, 67.71063873900005],
              [-113.85875403599994, 67.69623444200005],
              [-113.68077551999994, 67.69472890800006],
              [-113.31582597599993, 67.71088288000004],
              [-113.19286048099991, 67.70026276200008],
              [-113.08226477799991, 67.67649974200003],
              [-113.04198157499991, 67.67357005400004],
              [-112.83340410099993, 67.68732330900008],
              [-112.74937903599994, 67.67645905200004],
              [-112.42100989499994, 67.68244049700007],
              [-112.35460364499994, 67.69428131700005],
              [-112.3430883449999, 67.70302969000005],
              [-112.34874426999994, 67.71580638200004],
              [-112.37100175699993, 67.73505280200004],
              [-112.32762610599991, 67.74555084800005],
              [-112.18610592399995, 67.72821686400005],
              [-112.02774003799993, 67.74868398600006],
              [-111.99771074099993, 67.74062734600005],
              [-111.98912512899994, 67.72553131700005],
              [-111.9878637359999, 67.70840078300006],
              [-111.9800512359999, 67.69403717700004],
              [-111.96922766799992, 67.69232819200005],
              [-111.92601477799991, 67.69403717700004],
              [-111.89854895699995, 67.68537018400008],
              [-111.88548743399991, 67.68520742400005],
              [-111.87075761599993, 67.69403717700004],
              [-111.88377844999991, 67.70506419500003],
              [-111.8992406889999, 67.71320221600007],
              [-111.91563880099994, 67.71873607000003],
              [-111.93154863199993, 67.72199127800008],
              [-111.92711341099994, 67.73004791900007],
              [-111.9221899079999, 67.73403554900005],
              [-111.91510982999995, 67.73525625200006],
              [-111.90428626199991, 67.73505280200004],
              [-111.90428626199991, 67.74188873900005],
              [-111.91234290299991, 67.74249909100007],
              [-111.93154863199993, 67.74868398600006],
              [-111.87975012899994, 67.76406484600005],
              [-111.54564368399991, 67.72138092700004],
              [-111.54474850199995, 67.72695547100005],
              [-111.57591712099992, 67.74868398600006],
              [-111.56037350199995, 67.75104401200008],
              [-111.55093339799993, 67.75714752800008],
              [-111.54381262899994, 67.76430898600006],
              [-111.53498287699995, 67.76923248900005],
              [-111.51707923099991, 67.77155182500007],
              [-111.45921790299991, 67.76923248900005],
              [-111.46930904899995, 67.74428945500006],
              [-111.45278886599993, 67.73566315300008],
              [-111.42491614499994, 67.73956940300008],
              [-111.40086829299992, 67.75214264500005],
              [-111.3667699859999, 67.78628164300005],
              [-111.35631262899994, 67.79393138200004],
              [-111.32998613199993, 67.80560944200005],
              [-111.3186742829999, 67.81354401200008],
              [-111.29198157499991, 67.82611725500004],
              [-111.21666419199994, 67.83368561400005],
              [-111.16738847599993, 67.84609609600005],
              [-111.15514075399994, 67.84178294500003],
              [-111.15282141799992, 67.83124420800004],
              [-111.16441809799994, 67.81696198100008],
              [-111.17662512899994, 67.81000397300005],
              [-111.2012426419999, 67.79946523600006],
              [-111.2122289699999, 67.78969961100006],
              [-111.20034745999993, 67.79413483300004],
              [-111.18419348899994, 67.79706452000005],
              [-111.17174231699994, 67.79458242400005],
              [-111.17125403599994, 67.78286367400005],
              [-111.17967688699991, 67.77545807500007],
              [-111.20335852799991, 67.77179596600007],
              [-111.2122289699999, 67.76235586100006],
              [-111.1863500639999, 67.76235586100006],
              [-111.1563207669999, 67.76772695500006],
              [-111.08812415299991, 67.79067617400005],
              [-111.0750219389999, 67.78900788000004],
              [-111.06305904899995, 67.78253815300008],
              [-111.05174719999991, 67.77260976800005],
              [-111.03750566299993, 67.76683177300004],
              [-111.01895097599993, 67.76813385600008],
              [-110.90420488199993, 67.80052317900004],
              [-110.84707597599993, 67.80687083500004],
              [-110.8218481109999, 67.81696198100008],
              [-110.78750566299993, 67.84125397300005],
              [-110.7808324859999, 67.84491608300004],
              [-110.77013098899994, 67.84808991100005],
              [-110.75088456899994, 67.86225006700005],
              [-110.7395727199999, 67.86542389500005],
              [-110.72565670499995, 67.86709219000005],
              [-110.6778051419999, 67.87909577000005],
              [-110.57656816299993, 67.88849518400008],
              [-110.53197180899991, 67.91571686400005],
              [-110.42080644399994, 67.94839101800005],
              [-110.32835852799991, 67.94794342700004],
              [-110.3335668609999, 67.95294830900008],
              [-110.34264075399994, 67.96841054900005],
              [-110.31322180899991, 67.96857330900008],
              [-110.27928626199991, 67.96417877800008],
              [-110.21910559799994, 67.94794342700004],
              [-110.18016516799992, 67.92413971600007],
              [-110.15819251199991, 67.91840241100005],
              [-110.12975012899994, 67.92682526200008],
              [-110.18838456899994, 67.95416901200008],
              [-110.20303300699993, 67.97406647300005],
              [-110.17784583199995, 67.99884674700007],
              [-110.15412350199995, 68.00755442900004],
              [-110.13097083199995, 68.01044342700004],
              [-110.08165442599994, 68.00942617400005],
              [-110.05964107999995, 68.00507233300004],
              [-110.01781165299991, 67.98578522300005],
              [-109.99596106699994, 67.98151276200008],
              [-109.97118079299992, 67.96727122600004],
              [-109.97472083199995, 67.93573639500005],
              [-109.99937903599994, 67.88589101800005],
              [-109.99478105399993, 67.85260651200008],
              [-109.96690833199995, 67.83380768400008],
              [-109.93309485599991, 67.83417389500005],
              [-109.91063391799992, 67.85854726800005],
              [-109.92170162699995, 67.86212799700007],
              [-109.95221920499995, 67.87909577000005],
              [-109.95221920499995, 67.88589101800005],
              [-109.8706762359999, 67.88271719000005],
              [-109.83202063699991, 67.87360260600008],
              [-109.78343665299991, 67.83893463700008],
              [-109.75572669199994, 67.82684967700004],
              [-109.69835364499994, 67.81012604400007],
              [-109.7083227199999, 67.79852936400005],
              [-109.7376195949999, 67.79096100500004],
              [-109.7461645169999, 67.77602773600006],
              [-109.65123450399994, 67.75413646000004],
              [-109.6226293609999, 67.74188873900005],
              [-109.65078691299993, 67.73981354400007],
              [-109.7207738919999, 67.75023021000004],
              [-109.74274654899995, 67.74530670800004],
              [-109.74356035099993, 67.72870514500005],
              [-109.71670488199993, 67.71918366100005],
              [-109.53872636599993, 67.68903229400007],
              [-109.51846269399994, 67.69135163000004],
              [-109.49767005099994, 67.70331452000005],
              [-109.49083411399994, 67.71796295800004],
              [-109.51276607999995, 67.72821686400005],
              [-109.49551347599993, 67.74079010600008],
              [-109.45189368399991, 67.74428945500006],
              [-109.43423417899993, 67.75214264500005],
              [-109.42125403599994, 67.76260000200006],
              [-109.40587317599994, 67.76976146000004],
              [-109.39171301999994, 67.76898834800005],
              [-109.38243567599994, 67.75551992400005],
              [-109.39012610599991, 67.75283437700006],
              [-109.40416419199994, 67.74188873900005],
              [-109.35260982999995, 67.72968170800004],
              [-109.33458411399994, 67.72821686400005],
              [-109.32363847599993, 67.72614166900007],
              [-109.31232662699995, 67.72256094000005],
              [-109.3010961579999, 67.72093333500004],
              [-109.28477942599994, 67.72809479400007],
              [-109.2664281889999, 67.73395416900007],
              [-109.2598363919999, 67.73505280200004],
              [-109.07457434799994, 67.72199127800008],
              [-109.06704667899993, 67.72016022300005],
              [-109.06468665299991, 67.71600983300004],
              [-109.06395423099991, 67.71124909100007],
              [-109.06151282499991, 67.70770905200004],
              [-109.01292883999992, 67.67926666900007],
              [-109.00625566299993, 67.67357005400004],
              [-108.99705969999991, 67.65595123900005],
              [-108.97838294199994, 67.59039948100008],
              [-108.9851781889999, 67.59039948100008],
              [-108.97398841099994, 67.57566966400003],
              [-108.9336645169999, 67.54633209800005],
              [-108.92943274599992, 67.53180573100008],
              [-108.94692949099993, 67.52041250200006],
              [-108.99201412699995, 67.50535716400003],
              [-109.01211503799993, 67.49591705900008],
              [-109.02257239499994, 67.48769765800006],
              [-109.02293860599991, 67.47728099200003],
              [-109.01309160099993, 67.46133047100005],
              [-108.99693762899994, 67.44904205900008],
              [-108.95445716099994, 67.44220612200007],
              [-108.92992102799991, 67.43402741100005],
              [-108.93260657499991, 67.41693756700005],
              [-108.86595618399991, 67.41461823100008],
              [-108.84801184799994, 67.39549388200004],
              [-108.84117591099994, 67.36766185100004],
              [-108.82412675699993, 67.35716380400004],
              [-108.80199133999992, 67.36188385600008],
              [-108.77969316299993, 67.37938060100004],
              [-108.75690670499995, 67.41461823100008],
              [-108.7444555329999, 67.45425039300005],
              [-108.73839270699995, 67.59320709800005],
              [-108.73070227799991, 67.61579010600008],
              [-108.71080481699994, 67.62518952000005],
              [-108.63988196499992, 67.62946198100008],
              [-108.59911048099991, 67.62531159100007],
              [-108.58112545499995, 67.60846588700008],
              [-108.58275305899991, 67.59568919500003],
              [-108.5852758449999, 67.58612702000005],
              [-108.5847875639999, 67.57733795800004],
              [-108.52452551999994, 67.50556061400005],
              [-108.51964270699995, 67.49481842700004],
              [-108.51805579299992, 67.48159414300005],
              [-108.52049719999991, 67.47284577000005],
              [-108.52403723899994, 67.46405670800004],
              [-108.52586829299992, 67.45042552300004],
              [-108.5217992829999, 67.42316315300008],
              [-108.51040605399993, 67.39203522300005],
              [-108.49315344999991, 67.36538320500006],
              [-108.47126217399995, 67.35146719000005],
              [-108.44835364499994, 67.35028717700004],
              [-108.43610592399995, 67.35691966400003],
              [-108.4312231109999, 67.36937083500004],
              [-108.43028723899994, 67.38556549700007],
              [-108.43224036399994, 67.38544342700004],
              [-108.43675696499992, 67.39150625200006],
              [-108.44139563699991, 67.39972565300008],
              [-108.44395911399994, 67.40607330900008],
              [-108.44326738199993, 67.41323476800005],
              [-108.44066321499992, 67.41864655200004],
              [-108.43968665299991, 67.42479075700004],
              [-108.44395911399994, 67.43402741100005],
              [-108.43276933499993, 67.43390534100007],
              [-108.42007402299993, 67.43524811400005],
              [-108.40819251199991, 67.43854401200008],
              [-108.3992406889999, 67.44391510600008],
              [-108.3863012359999, 67.44928620000007],
              [-108.37026933499993, 67.44757721600007],
              [-108.3242895169999, 67.43512604400007],
              [-108.31143144399994, 67.42157623900005],
              [-108.29991614499994, 67.40558502800008],
              [-108.28693600199995, 67.39240143400008],
              [-108.26414954299992, 67.38125234600005],
              [-107.99254309799994, 67.28245677300004],
              [-107.9644262359999, 67.24921295800004],
              [-107.94737708199995, 67.24160390800006],
              [-107.94790605399993, 67.23407623900005],
              [-107.93659420499995, 67.21751536700003],
              [-107.89268958199995, 67.16941966400003],
              [-107.88231360599991, 67.15517812700006],
              [-107.87535559799994, 67.13922760600008],
              [-107.91637122299994, 67.13922760600008],
              [-107.88560950399994, 67.09251536700003],
              [-107.88158118399991, 67.07396067900004],
              [-107.8797094389999, 67.05341217700004],
              [-107.88536536399994, 67.04824453300006],
              [-107.90269934799994, 67.05292389500005],
              [-107.91844641799992, 67.05914948100008],
              [-107.95470130099994, 67.06875234600005],
              [-107.9883520169999, 67.07298411700003],
              [-108.02122962099992, 67.08356354400007],
              [-108.0398656889999, 67.08392975500004],
              [-108.05479895699995, 67.07965729400007],
              [-108.06590735599991, 67.07412344000005],
              [-108.07774817599994, 67.07013580900008],
              [-108.09508216099994, 67.07025788000004],
              [-108.13939368399991, 67.08002350500004],
              [-108.1565649079999, 67.07770416900007],
              [-108.15636145699995, 67.07599518400008],
              [-108.15807044199994, 67.07135651200008],
              [-108.16075598899994, 67.06639232000003],
              [-108.1634008449999, 67.06342194200005],
              [-108.17088782499991, 67.06098053600005],
              [-108.19749915299991, 67.05597565300008],
              [-108.1897680329999, 67.03172435100004],
              [-108.21495520699995, 67.02741120000007],
              [-108.30296790299991, 67.04035065300008],
              [-108.36961829299992, 67.06134674700007],
              [-108.42373613199993, 67.08551666900007],
              [-108.48473059799994, 67.10040924700007],
              [-108.51219641799992, 67.11127350500004],
              [-108.56232662699995, 67.14590078300006],
              [-108.58922278599994, 67.15818919500003],
              [-108.62205969999991, 67.15965403900003],
              [-108.62205969999991, 67.15281810100004],
              [-108.58967037699995, 67.13450755400004],
              [-108.5769750639999, 67.12360260600008],
              [-108.56745357999995, 67.11127350500004],
              [-108.54938717399995, 67.06854889500005],
              [-108.54015051999994, 67.05597565300008],
              [-108.5266820949999, 67.04148997600004],
              [-108.51829993399991, 67.03717682500007],
              [-108.50601152299993, 67.03681061400005],
              [-108.48888098899994, 67.04193756700005],
              [-108.4878637359999, 67.04897695500006],
              [-108.49242102799991, 67.05654531500005],
              [-108.49233964799993, 67.06342194200005],
              [-108.48253333199995, 67.07269928600005],
              [-108.47451738199993, 67.07611725500004],
              [-108.46499589799993, 67.07489655200004],
              [-108.45079505099994, 67.07025788000004],
              [-108.43114173099991, 67.06012604400007],
              [-108.42100989499994, 67.05272044500003],
              [-108.41661536399994, 67.04637278900003],
              [-108.4070531889999, 67.03778717700004],
              [-108.36473548099991, 67.01715729400007],
              [-108.35521399599992, 67.00507233300004],
              [-108.33971106699994, 66.99042389500005],
              [-108.30418860599991, 66.98358795800004],
              [-108.2215063139999, 66.97943756700005],
              [-108.1895238919999, 66.97003815300008],
              [-108.17332923099991, 66.96784088700008],
              [-108.16356360599991, 66.96450429900005],
              [-108.13914954299992, 66.94611237200007],
              [-108.1194555329999, 66.93939850500004],
              [-108.11327063699991, 66.92324453300006],
              [-108.11587480399993, 66.90338776200008],
              [-108.12242591099994, 66.88593170800004],
              [-108.11497962099992, 66.87848541900007],
              [-108.1360570949999, 66.86009349200003],
              [-108.16690019399994, 66.85712311400005],
              [-108.20103919199994, 66.85797760600008],
              [-108.23167883999992, 66.85114166900007],
              [-108.18651282499991, 66.83885325700004],
              [-108.0535375639999, 66.85114166900007],
              [-107.99522864499994, 66.83222077000005],
              [-107.98521887899994, 66.82697174700007],
              [-107.97960364499994, 66.81366608300004],
              [-107.96621660099993, 66.80337148600006],
              [-107.95026607999995, 66.79368724200003],
              [-107.9368383449999, 66.78229401200008],
              [-107.94102942599994, 66.77350495000007],
              [-107.94961503799993, 66.74445221600007],
              [-107.9505102199999, 66.73509349200003],
              [-107.94351152299993, 66.72353750200006],
              [-107.92113196499992, 66.70522695500006],
              [-107.91193600199995, 66.68842194200005],
              [-107.90143795499995, 66.67829010600008],
              [-107.88890540299991, 66.66974518400008],
              [-107.87852942599994, 66.66620514500005],
              [-107.86851966099994, 66.67210521000004],
              [-107.86701412699995, 66.68537018400008],
              [-107.8704320949999, 66.69936758000006],
              [-107.87535559799994, 66.70722077000005],
              [-107.85753333199995, 66.72382233300004],
              [-107.86180579299992, 66.73676178600005],
              [-107.8762914699999, 66.74848053600005],
              [-107.88902747299994, 66.76178620000007],
              [-107.8577367829999, 66.76007721600007],
              [-107.83238684799994, 66.74827708500004],
              [-107.76573645699995, 66.69135163000004],
              [-107.68980872299994, 66.64573802300004],
              [-107.70091712099992, 66.64671458500004],
              [-107.71108964799993, 66.64500560100004],
              [-107.71922766799992, 66.64028554900005],
              [-107.72451738199993, 66.63206614800004],
              [-107.70010331899994, 66.62103913000004],
              [-107.63516191299993, 66.57001373900005],
              [-107.59544837099992, 66.54804108300004],
              [-107.58364824099993, 66.53929271000004],
              [-107.56554114499994, 66.53074778900003],
              [-107.54775956899994, 66.53156159100007],
              [-107.5403539699999, 66.54051341400003],
              [-107.55329342399995, 66.55634186400005],
              [-107.52114824099993, 66.55341217700004],
              [-107.49795488199993, 66.53620026200008],
              [-107.44554602799991, 66.46556224200003],
              [-107.43252519399994, 66.45473867400005],
              [-107.41665605399993, 66.44647858300004],
              [-107.36489824099993, 66.43349844000005],
              [-107.27578691299993, 66.36082591400003],
              [-107.2415258449999, 66.34853750200006],
              [-107.20986894399994, 66.35911692900004],
              [-107.20177161399994, 66.37848541900007],
              [-107.23794511599993, 66.39183177300004],
              [-107.24986731699994, 66.41388580900008],
              [-107.29332434799994, 66.44171784100007],
              [-107.41592363199993, 66.49823639500005],
              [-107.43517005099994, 66.51080963700008],
              [-107.4434301419999, 66.52533600500004],
              [-107.45140540299991, 66.54804108300004],
              [-107.47081458199995, 66.55707428600005],
              [-107.49453691299993, 66.56224192900004],
              [-107.52627519399994, 66.57990143400008],
              [-107.55182857999995, 66.58698151200008],
              [-107.56354732999995, 66.59454987200007],
              [-107.56761633999992, 66.60171133000006],
              [-107.57115637899994, 66.61871979400007],
              [-107.57371985599991, 66.62523021000004],
              [-107.62669837099992, 66.66254303600005],
              [-107.65868079299992, 66.70770905200004],
              [-107.76740475199995, 66.73940664300005],
              [-107.79967200399994, 66.76862213700008],
              [-107.74307206899994, 66.75385163000004],
              [-107.71349036399994, 66.75299713700008],
              [-107.68980872299994, 66.76862213700008],
              [-107.69664466099994, 66.77887604400007],
              [-107.70140540299991, 66.78815338700008],
              [-107.70225989499994, 66.79608795800004],
              [-107.69725501199991, 66.80280182500007],
              [-107.70954342399995, 66.83124420800004],
              [-107.71776282499991, 66.87848541900007],
              [-107.75658118399991, 66.92967357000003],
              [-107.76553300699993, 66.94611237200007],
              [-107.76793372299994, 66.95905182500007],
              [-107.76846269399994, 66.97776927300004],
              [-107.76585852799991, 66.99632396000004],
              [-107.75865637899994, 67.00885651200008],
              [-107.73745683499993, 67.01146067900004],
              [-107.6875707669999, 66.98216380400004],
              [-107.6348363919999, 66.96710846600007],
              [-107.61986243399991, 66.96625397300005],
              [-107.60789954299992, 66.97406647300005],
              [-107.60635331899994, 66.98387278900003],
              [-107.61172441299993, 66.99298737200007],
              [-107.6187231109999, 67.00043366100005],
              [-107.62218176999994, 67.00507233300004],
              [-107.62800045499995, 67.01732005400004],
              [-107.65623938699991, 67.05536530200004],
              [-107.66649329299992, 67.06342194200005],
              [-107.66722571499992, 67.06614817900004],
              [-107.65762285099993, 67.07196686400005],
              [-107.64297441299993, 67.07709381700005],
              [-107.62832597599993, 67.07770416900007],
              [-107.61782792899993, 67.07396067900004],
              [-107.56309973899994, 67.04047272300005],
              [-107.54206295499995, 67.03148021000004],
              [-107.52399654899995, 67.02041250200006],
              [-107.51231848899994, 67.00141022300005],
              [-107.5191137359999, 67.00141022300005],
              [-107.48436438699991, 66.91941966400003],
              [-107.51537024599992, 66.92788320500006],
              [-107.53184973899994, 66.92987702000005],
              [-107.53897050699993, 66.92324453300006],
              [-107.5481664699999, 66.91795482000003],
              [-107.56891842399995, 66.91909414300005],
              [-107.59117591099994, 66.92389557500007],
              [-107.6048070949999, 66.92999909100007],
              [-107.62360592399995, 66.94501373900005],
              [-107.64647376199991, 66.95575592700004],
              [-107.67162024599992, 66.95962148600006],
              [-107.69725501199991, 66.95355866100005],
              [-107.68517005099994, 66.93992747600004],
              [-107.6499731109999, 66.91962311400005],
              [-107.63467363199993, 66.89533112200007],
              [-107.61632239499994, 66.88540273600006],
              [-107.59532630099994, 66.88153717700004],
              [-107.57994544199994, 66.88593170800004],
              [-107.58739173099991, 66.89960358300004],
              [-107.57555091099994, 66.89720286700003],
              [-107.54124915299991, 66.88458893400008],
              [-107.5327856109999, 66.87848541900007],
              [-107.53482011599993, 66.86798737200007],
              [-107.54637610599991, 66.85927969000005],
              [-107.57371985599991, 66.84495677300004],
              [-107.56297766799992, 66.83950429900005],
              [-107.52538001199991, 66.82538483300004],
              [-107.51231848899994, 66.82322825700004],
              [-107.49937903599994, 66.82831452000005],
              [-107.4883520169999, 66.84259674700007],
              [-107.47752844999991, 66.84495677300004],
              [-107.46410071499992, 66.83576080900008],
              [-107.44933020699995, 66.81879303600005],
              [-107.43146725199995, 66.80784739800004],
              [-107.40925045499995, 66.81708405200004],
              [-107.45181230399993, 66.84780508000006],
              [-107.47130286399994, 66.86652252800008],
              [-107.48436438699991, 66.88593170800004],
              [-107.46206620999993, 66.88422272300005],
              [-107.43578040299991, 66.87909577000005],
              [-107.41161048099991, 66.87897370000007],
              [-107.39561926999994, 66.89215729400007],
              [-107.39610755099994, 66.90497467700004],
              [-107.40420488199993, 66.91868724200003],
              [-107.44139563699991, 66.96295807500007],
              [-107.43927975199995, 66.96954987200007],
              [-107.42292232999995, 66.97406647300005],
              [-107.40103105399993, 66.97431061400005],
              [-107.37677975199995, 66.96971263200004],
              [-107.35411536399994, 66.96133047100005],
              [-107.33726966099994, 66.94989655200004],
              [-107.30850175699993, 66.93463776200008],
              [-107.22154700399994, 66.90204498900005],
              [-107.2031957669999, 66.88906484600005],
              [-107.1973363919999, 66.87970612200007],
              [-107.15908769399994, 66.85464101800005],
              [-107.14525305899991, 66.84003327000005],
              [-107.13190670499995, 66.83026764500005],
              [-107.11432857999995, 66.82489655200004],
              [-107.08771725199995, 66.82322825700004],
              [-107.08771725199995, 66.83071523600006],
              [-107.16222083199995, 66.87848541900007],
              [-107.13487708199995, 66.89215729400007],
              [-107.26740475199995, 66.98940664300005],
              [-107.31305904899995, 67.01504140800006],
              [-107.36827551999994, 67.03440989800004],
              [-107.40339107999995, 67.04116445500006],
              [-107.39403235599991, 67.05084870000007],
              [-107.36115475199995, 67.06683991100005],
              [-107.24644934799994, 67.08421458500004],
              [-107.25157630099994, 67.09760163000004],
              [-107.24022376199991, 67.10683828300006],
              [-107.2031957669999, 67.12490469000005],
              [-107.22374426999994, 67.13165924700007],
              [-107.24376380099994, 67.13043854400007],
              [-107.26423092399995, 67.12653229400007],
              [-107.28575598899994, 67.12490469000005],
              [-107.30455481699994, 67.12872955900008],
              [-107.33633378799993, 67.14240143400008],
              [-107.39000403599994, 67.14883047100005],
              [-107.42349199099993, 67.15794505400004],
              [-107.52700761599993, 67.21234772300005],
              [-107.54556230399993, 67.23012929900005],
              [-107.55907141799992, 67.26788971600007],
              [-107.58885657499991, 67.31049225500004],
              [-107.65672766799992, 67.37246328300006],
              [-107.69497636599993, 67.38739655200004],
              [-107.71642005099994, 67.40460846600007],
              [-107.72232011599993, 67.42096588700008],
              [-107.69725501199991, 67.42649974200003],
              [-107.68073482999995, 67.41974518400008],
              [-107.66600501199991, 67.40790436400005],
              [-107.65143795499995, 67.40033600500004],
              [-107.63516191299993, 67.40607330900008],
              [-107.62832597599993, 67.45042552300004],
              [-107.58364824099993, 67.47801341400003],
              [-107.5777074859999, 67.49042389500005],
              [-107.58584550699993, 67.50116608300004],
              [-107.60069739499994, 67.50975169500003],
              [-107.61465410099993, 67.51593659100007],
              [-107.6499731109999, 67.52289459800005],
              [-107.66869055899991, 67.52912018400008],
              [-107.67674719999991, 67.53949616100005],
              [-107.68199622299994, 67.54840729400007],
              [-107.70775305899991, 67.57062409100007],
              [-107.74559485599991, 67.59259674700007],
              [-107.81126868399991, 67.62030670800004],
              [-107.86587480399993, 67.63092682500007],
              [-107.93199622299994, 67.66176992400005],
              [-107.9649145169999, 67.68357982000003],
              [-107.98961341099994, 67.69334544500003],
              [-107.99889075399994, 67.70026276200008],
              [-108.00572669199994, 67.70966217700004],
              [-108.01878821499992, 67.73505280200004],
              [-108.01260331899994, 67.75910065300008],
              [-107.99966386599993, 67.77960846600007],
              [-107.96133378799993, 67.82074616100005],
              [-107.95470130099994, 67.83161041900007],
              [-107.94904537699995, 67.84406159100007],
              [-107.94163977799991, 67.85431549700007],
              [-107.92967688699991, 67.85854726800005],
              [-107.86733964799993, 67.86245351800005],
              [-107.7434789699999, 67.89524974200003],
              [-107.71092688699991, 67.89956289300005],
              [-107.69977779899995, 67.90289948100008],
              [-107.68732662699995, 67.91120026200008],
              [-107.66649329299992, 67.93056875200006],
              [-107.65933183499993, 67.94672272300005],
              [-107.67162024599992, 67.95376211100006],
              [-107.7508031889999, 67.96548086100006],
              [-107.76878821499992, 67.96352773600006],
              [-107.78636633999992, 67.95783112200007],
              [-107.80394446499992, 67.95502350500004],
              [-107.8152563139999, 67.96190013200004],
              [-107.82408606699994, 67.97264232000003],
              [-107.83438066299993, 67.98151276200008],
              [-107.85195878799993, 67.98550039300005],
              [-107.89273027299993, 67.98786041900007],
              [-107.90953528599994, 67.99510325700004],
              [-107.91860917899993, 68.00551992400005],
              [-107.91270911399994, 68.00922272300005],
              [-107.90176347599993, 68.01365794500003],
              [-107.89586341099994, 68.02643463700008],
              [-107.89468339799993, 68.05023834800005],
              [-107.88988196499992, 68.07355377800008],
              [-107.87950598899994, 68.09300364800004],
              [-107.86172441299993, 68.10496653900003],
              [-107.84630286399994, 68.10712311400005],
              [-107.83580481699994, 68.10346100500004],
              [-107.8262426419999, 68.09711334800005],
              [-107.81395423099991, 68.09129466400003],
              [-107.79344641799992, 68.08893463700008],
              [-107.75011145699995, 68.09186432500007],
              [-107.73143469999991, 68.08820221600007],
              [-107.69725501199991, 68.07762278900003],
              [-107.71890214799993, 68.06118398600006],
              [-107.7500707669999, 68.05687083500004],
              [-107.81395423099991, 68.05719635600008],
              [-107.80211341099994, 68.04486725500004],
              [-107.78184973899994, 68.04108307500007],
              [-107.73818925699993, 68.04291413000004],
              [-107.76268469999991, 68.03571198100008],
              [-107.79185950399994, 68.03148021000004],
              [-107.81822669199994, 68.02460358300004],
              [-107.83438066299993, 68.00942617400005],
              [-107.79478919199994, 67.99249909100007],
              [-107.77407792899993, 67.98859284100007],
              [-107.75186113199993, 67.99510325700004],
              [-107.74600175699993, 68.00043366100005],
              [-107.74315344999991, 68.00633372600004],
              [-107.74120032499991, 68.01194896000004],
              [-107.73818925699993, 68.01618073100008],
              [-107.69188391799992, 68.04559967700004],
              [-107.68175208199995, 68.04873281500005],
              [-107.64500891799992, 68.05194733300004],
              [-107.61465410099993, 68.06342194200005],
              [-107.58299719999991, 68.06655508000006],
              [-107.50674394399994, 68.06232330900008],
              [-107.42870032499991, 68.04266998900005],
              [-107.37267005099994, 68.04743073100008],
              [-107.27208411399994, 68.07762278900003],
              [-107.19155839799993, 68.11786530200004],
              [-107.14663652299993, 68.13182200700004],
              [-107.10757402299993, 68.12604401200008],
              [-107.12376868399991, 68.10976797100005],
              [-107.13027910099993, 68.10106028900003],
              [-107.13487708199995, 68.09129466400003],
              [-107.02562415299991, 68.10496653900003],
              [-106.9707738919999, 68.09886302300004],
              [-106.95254472599993, 68.10008372600004],
              [-106.97044837099992, 68.11180247600004],
              [-106.9260961579999, 68.12645091400003],
              [-106.86611894399994, 68.12311432500007],
              [-106.75816809799994, 68.10496653900003],
              [-106.75816809799994, 68.11180247600004],
              [-106.74575761599993, 68.13955312700006],
              [-106.76280676999994, 68.16815827000005],
              [-106.79116777299993, 68.19277578300006],
              [-106.81338456899994, 68.20799388200004],
              [-106.78880774599992, 68.22402578300006],
              [-106.75300045499995, 68.22882721600007],
              [-106.6824438139999, 68.22846100500004],
              [-106.69762122299994, 68.20783112200007],
              [-106.69981848899994, 68.19830963700008],
              [-106.67894446499992, 68.19106679900005],
              [-106.65990149599992, 68.17658112200007],
              [-106.64488684799994, 68.17328522300005],
              [-106.62718665299991, 68.18520742400005],
              [-106.6316625639999, 68.21137116100005],
              [-106.63939368399991, 68.23761627800008],
              [-106.63149980399993, 68.24957916900007],
              [-106.59951738199993, 68.24632396000004],
              [-106.49649003799993, 68.20258209800005],
              [-106.47728430899991, 68.19110748900005],
              [-106.46165930899991, 68.17584870000007],
              [-106.44347083199995, 68.15277741100005],
              [-106.43285071499992, 68.15875885600008],
              [-106.41201738199993, 68.17548248900005],
              [-106.40184485599991, 68.18073151200008],
              [-106.38890540299991, 68.18195221600007],
              [-106.36046301999994, 68.18158600500004],
              [-106.34658769399994, 68.18691640800006],
              [-106.48412024599992, 68.22866445500006],
              [-106.49437415299991, 68.24583567900004],
              [-106.48070227799991, 68.25543854400007],
              [-106.44884192599994, 68.27130768400008],
              [-106.43602454299992, 68.28314850500004],
              [-106.42601477799991, 68.30426666900007],
              [-106.43228105399993, 68.31557851800005],
              [-106.4707738919999, 68.33152903900003],
              [-106.44566809799994, 68.35126373900005],
              [-106.41588294199994, 68.35541413000004],
              [-106.35407467399995, 68.35138580900008],
              [-106.32778886599993, 68.35919830900008],
              [-106.27603105399993, 68.38690827000005],
              [-106.25108801999994, 68.39301178600005],
              [-106.18211829299992, 68.39301178600005],
              [-106.17064368399991, 68.38906484600005],
              [-106.16266842399995, 68.38019440300008],
              [-106.15607662699995, 68.37079498900005],
              [-106.14858964799993, 68.36505768400008],
              [-106.12242591099994, 68.36603424700007],
              [-106.07567298099991, 68.39288971600007],
              [-106.05239824099993, 68.39980703300006],
              [-106.03685462099992, 68.39777252800008],
              [-106.0217992829999, 68.39402903900003],
              [-106.0066625639999, 68.39240143400008],
              [-105.9910375639999, 68.39642975500004],
              [-105.98330644399994, 68.40346914300005],
              [-105.97606360599991, 68.41425202000005],
              [-105.97105872299994, 68.42397695500006],
              [-105.97052975199995, 68.42772044500003],
              [-105.94200598899994, 68.42633698100008],
              [-105.90843665299991, 68.41592031500005],
              [-105.87409420499995, 68.41046784100007],
              [-105.84325110599991, 68.42401764500005],
              [-105.8386938139999, 68.43073151200008],
              [-105.83446204299992, 68.44432200700004],
              [-105.82994544199994, 68.45099518400008],
              [-105.8184301419999, 68.45514557500007],
              [-105.80968176999994, 68.44696686400005],
              [-105.79857337099992, 68.42772044500003],
              [-105.77651933499993, 68.42194245000007],
              [-105.7476293609999, 68.42096588700008],
              [-105.72712154899995, 68.42658112200007],
              [-105.73029537699995, 68.44082265800006],
              [-105.71930904899995, 68.45652903900003],
              [-105.70518958199995, 68.47239817900004],
              [-105.6975805329999, 68.48883698100008],
              [-105.70604407499991, 68.50629303600005],
              [-105.71812903599994, 68.51341380400004],
              [-105.74400794199994, 68.51813385600008],
              [-105.75763912699995, 68.52334219000005],
              [-105.7649633449999, 68.52960846600007],
              [-105.77867591099994, 68.55068594000005],
              [-105.76256262899994, 68.56354401200008],
              [-105.72447669199994, 68.58258698100008],
              [-105.70604407499991, 68.59467194200005],
              [-105.70205644399994, 68.60053131700005],
              [-105.69786536399994, 68.61542389500005],
              [-105.69273841099994, 68.62262604400007],
              [-105.68224036399994, 68.62750885600008],
              [-105.6707250639999, 68.62824127800008],
              [-105.65908769399994, 68.63011302300004],
              [-105.64834550699993, 68.63873932500007],
              [-105.70018469999991, 68.64069245000007],
              [-105.72769120999993, 68.63825104400007],
              [-105.7473852199999, 68.62913646000004],
              [-105.76585852799991, 68.61798737200007],
              [-105.79100501199991, 68.61196523600006],
              [-105.81663977799991, 68.61286041900007],
              [-105.87913977799991, 68.63934967700004],
              [-105.94123287699995, 68.64008209800005],
              [-106.00487219999991, 68.63129303600005],
              [-106.05239824099993, 68.61953359600005],
              [-106.05719967399995, 68.60150788000004],
              [-106.08702551999994, 68.59251536700003],
              [-106.52204342399995, 68.52667877800008],
              [-106.55333411399994, 68.51585521000004],
              [-106.42235266799992, 68.51585521000004],
              [-106.45449785099993, 68.50946686400005],
              [-106.53888912699995, 68.50779857000003],
              [-106.55955969999991, 68.48859284100007],
              [-106.53091386599993, 68.48493073100008],
              [-106.51183020699995, 68.47288646000004],
              [-106.50975501199991, 68.45856354400007],
              [-106.53221594999991, 68.44757721600007],
              [-106.5491430329999, 68.44855377800008],
              [-106.55943762899994, 68.45612213700008],
              [-106.56554114499994, 68.46466705900008],
              [-106.56973222599993, 68.46869538000004],
              [-106.61774654899995, 68.47211334800005],
              [-106.63524329299992, 68.46869538000004],
              [-106.62730872299994, 68.45237864800004],
              [-106.61192786399994, 68.43838125200006],
              [-106.59264075399994, 68.42743561400005],
              [-106.57315019399994, 68.42023346600007],
              [-106.51610266799992, 68.41583893400008],
              [-106.48794511599993, 68.40741608300004],
              [-106.48753821499992, 68.38922760600008],
              [-106.50641842399995, 68.37807851800005],
              [-106.53282630099994, 68.36945221600007],
              [-106.5562231109999, 68.35879140800006],
              [-106.56631425699993, 68.34113190300008],
              [-106.55528723899994, 68.32640208500004],
              [-106.53575598899994, 68.31207916900007],
              [-106.52806555899991, 68.30109284100007],
              [-106.55272376199991, 68.29677969000005],
              [-106.58031165299991, 68.29759349200003],
              [-106.59288489499994, 68.30072663000004],
              [-106.60423743399991, 68.30731842700004],
              [-106.62051347599993, 68.32827383000006],
              [-106.62466386599993, 68.33152903900003],
              [-106.63219153599994, 68.33466217700004],
              [-106.64281165299991, 68.34829336100006],
              [-106.65172278599994, 68.35138580900008],
              [-106.7168676419999, 68.35138580900008],
              [-106.72203528599994, 68.35537344000005],
              [-106.72402910099993, 68.36448802300004],
              [-106.72402910099993, 68.38247304900005],
              [-106.78673255099994, 68.41494375200006],
              [-106.8062231109999, 68.41083405200004],
              [-106.81110592399995, 68.39842357000003],
              [-106.7923070949999, 68.38556549700007],
              [-106.80996660099993, 68.37079498900005],
              [-106.83967037699995, 68.37152741100005],
              [-106.89590410099993, 68.38556549700007],
              [-106.91441809799994, 68.38572825700004],
              [-106.95677649599992, 68.37250397300005],
              [-107.00902258999992, 68.37132396000004],
              [-107.02562415299991, 68.36505768400008],
              [-107.0222875639999, 68.34845612200007],
              [-107.04564368399991, 68.33698151200008],
              [-107.09732011599993, 68.32099030200004],
              [-107.1094457669999, 68.31346263200004],
              [-107.12165279899995, 68.30817291900007],
              [-107.13109290299991, 68.30072663000004],
              [-107.13487708199995, 68.28681061400005],
              [-107.14077714799993, 68.27212148600006],
              [-107.15514075399994, 68.27008698100008],
              [-107.1895238919999, 68.27692291900007],
              [-107.24620520699995, 68.26727936400005],
              [-107.27391516799992, 68.26874420800004],
              [-107.30077063699991, 68.30727773600006],
              [-107.33556067599994, 68.31879303600005],
              [-107.37462317599994, 68.32371653900003],
              [-107.47126217399995, 68.31899648600006],
              [-107.50890051999994, 68.32355377800008],
              [-107.52529863199993, 68.34113190300008],
              [-107.54653886599993, 68.35175202000005],
              [-107.69249426999994, 68.34251536700003],
              [-107.7280981109999, 68.33356354400007],
              [-107.74502519399994, 68.33152903900003],
              [-107.76504472599993, 68.33441803600005],
              [-107.80626380099994, 68.34516022300005],
              [-107.8269750639999, 68.34454987200007],
              [-107.84727942599994, 68.33323802300004],
              [-107.86095130099994, 68.31386953300006],
              [-107.87315833199995, 68.29100169500003],
              [-107.88902747299994, 68.26947663000004],
              [-107.87751217399995, 68.26072825700004],
              [-107.86099199099993, 68.25185781500005],
              [-107.84219316299993, 68.24494049700007],
              [-107.82420813699991, 68.24213288000004],
              [-107.79430091099994, 68.24241771000004],
              [-107.77944902299993, 68.24070872600004],
              [-107.76553300699993, 68.23590729400007],
              [-107.7578832669999, 68.23029205900008],
              [-107.7488500639999, 68.21808502800008],
              [-107.74502519399994, 68.21426015800006],
              [-107.72956295499995, 68.20722077000005],
              [-107.6204320949999, 68.18329498900005],
              [-107.6030981109999, 68.17503489800004],
              [-107.61465410099993, 68.16705963700008],
              [-107.64134680899991, 68.16616445500006],
              [-107.73143469999991, 68.18073151200008],
              [-107.84434973899994, 68.18073151200008],
              [-107.86473548099991, 68.17715078300006],
              [-107.87694251199991, 68.16889069200005],
              [-107.88581295499995, 68.15957265800006],
              [-107.89586341099994, 68.15277741100005],
              [-107.92467200399994, 68.14801666900007],
              [-108.00963294199994, 68.15460846600007],
              [-107.98924719999991, 68.17226797100005],
              [-108.14907792899993, 68.17328522300005],
              [-108.18455969999991, 68.16962311400005],
              [-108.24327551999994, 68.14549388200004],
              [-108.38923092399995, 68.11102936400005],
              [-108.42003333199995, 68.12238190300008],
              [-108.43626868399991, 68.13678620000007],
              [-108.44001217399995, 68.14569733300004],
              [-108.43399003799993, 68.15615469000005],
              [-108.41812089799993, 68.16478099200003],
              [-108.39785722599993, 68.16815827000005],
              [-108.37755286399994, 68.16632721600007],
              [-108.3613988919999, 68.15961334800005],
              [-108.37633216099994, 68.14858633000006],
              [-108.38247636599993, 68.14594147300005],
              [-108.38247636599993, 68.13971588700008],
              [-108.35423743399991, 68.14044830900008],
              [-108.33763587099992, 68.15509674700007],
              [-108.32982337099992, 68.17829010600008],
              [-108.32787024599992, 68.20457591400003],
              [-108.33145097599993, 68.21332428600005],
              [-108.34044348899994, 68.22370026200008],
              [-108.35155188699991, 68.23236725500004],
              [-108.36196855399993, 68.23590729400007],
              [-108.38052324099993, 68.23163483300004],
              [-108.38890540299991, 68.22158437700006],
              [-108.39232337099992, 68.21002838700008],
              [-108.39614824099993, 68.20115794500003],
              [-108.39928137899994, 68.19574616100005],
              [-108.3997289699999, 68.19114817900004],
              [-108.40172278599994, 68.18646881700005],
              [-108.40977942599994, 68.18073151200008],
              [-108.45030676999994, 68.18683502800008],
              [-108.45759029899995, 68.18691640800006],
              [-108.45726477799991, 68.19741445500006],
              [-108.45030676999994, 68.21112702000005],
              [-108.44102942599994, 68.22410716400003],
              [-108.41612708199995, 68.25018952000005],
              [-108.40217037699995, 68.26894765800006],
              [-108.39976966099994, 68.28729889500005],
              [-108.41661536399994, 68.30418528900003],
              [-108.4527074859999, 68.31264883000006],
              [-108.4856664699999, 68.30402252800008],
              [-108.51667232999995, 68.29026927300004],
              [-108.56017005099994, 68.27879466400003],
              [-108.58409583199995, 68.26007721600007],
              [-108.59976152299993, 68.25580475500004],
              [-108.69749915299991, 68.25580475500004],
              [-108.7102758449999, 68.25092194200005],
              [-108.71996008999992, 68.24144114800004],
              [-108.73216712099992, 68.23493073100008],
              [-108.75243079299992, 68.23899974200003],
              [-108.79600989499994, 68.25495026200008],
              [-108.80703691299993, 68.26264069200005],
              [-108.81505286399994, 68.27423737200007],
              [-108.81021074099993, 68.27838776200008],
              [-108.77969316299993, 68.28314850500004],
              [-108.75487219999991, 68.29718659100007],
              [-108.74404863199993, 68.30634186400005],
              [-108.74901282499991, 68.31037018400008],
              [-108.75300045499995, 68.31574127800008],
              [-108.75560462099992, 68.32754140800006],
              [-108.75495357999995, 68.33917877800008],
              [-108.74901282499991, 68.34454987200007],
              [-108.73338782499991, 68.34699127800008],
              [-108.59459387899994, 68.39915599200003],
              [-108.40611731699994, 68.56085846600007],
              [-108.34715735599991, 68.60008372600004],
              [-108.2808324859999, 68.62156810100004],
              [-107.80638587099992, 68.65350983300004],
              [-107.75308183499993, 68.64598216400003],
              [-107.62832597599993, 68.67413971600007],
              [-107.4832250639999, 68.68512604400007],
              [-107.42568925699993, 68.70014069200005],
              [-107.29259192599994, 68.70140208500004],
              [-107.17837480399993, 68.73916250200006],
              [-107.16592363199993, 68.74555084800005],
              [-107.15290279899995, 68.74970123900005],
              [-107.07506262899994, 68.75739166900007],
              [-106.91079667899993, 68.80036041900007],
              [-106.85667883999992, 68.80597565300008],
              [-106.81883704299992, 68.81537506700005],
              [-106.79942786399994, 68.81753164300005],
              [-106.70323645699995, 68.81126536700003],
              [-106.66567949099993, 68.81622955900008],
              [-106.56631425699993, 68.85228099200003],
              [-106.45103919199994, 68.86513906500005],
              [-106.38048255099994, 68.88629791900007],
              [-106.30581620999993, 68.89642975500004],
              [-106.27212480399993, 68.90692780200004],
              [-106.2630102199999, 68.91445547100005],
              [-106.2442113919999, 68.94037506700005],
              [-106.22175045499995, 68.94599030200004],
              [-106.19749915299991, 68.94440338700008],
              [-105.99779212099992, 68.89948151200008],
              [-105.81224524599992, 68.88580963700008],
              [-105.79649817599994, 68.88271719000005],
              [-105.7508031889999, 68.86591217700004],
              [-105.71202551999994, 68.84194570500006],
              [-105.67845618399991, 68.83222077000005],
              [-105.60680091099994, 68.79022858300004],
              [-105.52245032499991, 68.75372955900008],
              [-105.49429277299993, 68.73387278900003],
              [-105.46959387899994, 68.72199127800008],
              [-105.47842363199993, 68.70136139500005],
              [-105.48546301999994, 68.69147370000007],
              [-105.4944555329999, 68.68720123900005],
              [-105.50633704299992, 68.68585846600007],
              [-105.52293860599991, 68.68183014500005],
              [-105.53795325399994, 68.67536041900007],
              [-105.54531816299993, 68.66669342700004],
              [-105.53917395699995, 68.65005117400005],
              [-105.5210668609999, 68.63471100500004],
              [-105.48387610599991, 68.61212799700007],
              [-105.46662350199995, 68.59756094000005],
              [-105.40916907499991, 68.53058502800008],
              [-105.38744055899991, 68.52024974200003],
              [-105.36070716099994, 68.51642487200007],
              [-105.3262426419999, 68.51585521000004],
              [-105.3264867829999, 68.50726959800005],
              [-105.32412675699993, 68.48248932500007],
              [-105.3262426419999, 68.47492096600007],
              [-105.34019934799994, 68.46971263200004],
              [-105.35472571499992, 68.47394440300008],
              [-105.38145911399994, 68.48859284100007],
              [-105.40221106699994, 68.49363841400003],
              [-105.42007402299993, 68.49428945500006],
              [-105.43732662699995, 68.49042389500005],
              [-105.45653235599991, 68.48236725500004],
              [-105.47158769399994, 68.47174713700008],
              [-105.47704016799992, 68.46869538000004],
              [-105.4851781889999, 68.46621328300006],
              [-105.5022680329999, 68.46360911700003],
              [-105.5105688139999, 68.46124909100007],
              [-105.5359594389999, 68.44989655200004],
              [-105.5471899079999, 68.44049713700008],
              [-105.55150305899991, 68.42772044500003],
              [-105.54393469999991, 68.41388580900008],
              [-105.52700761599993, 68.41030508000006],
              [-105.36693274599992, 68.42055898600006],
              [-105.33307857999995, 68.41347890800006],
              [-105.3360082669999, 68.40403880400004],
              [-105.34044348899994, 68.39533112200007],
              [-105.34630286399994, 68.38727448100008],
              [-105.35350501199991, 68.37929922100005],
              [-105.3230688139999, 68.35443756700005],
              [-105.09512285099993, 68.26951732000003],
              [-105.03921464799993, 68.25910065300008],
              [-104.99665279899995, 68.27692291900007],
              [-105.06578528599994, 68.29905833500004],
              [-105.0860082669999, 68.31037018400008],
              [-105.03343665299991, 68.30914948100008],
              [-105.02086341099994, 68.31415436400005],
              [-105.00963294199994, 68.32196686400005],
              [-104.99681555899991, 68.32501862200007],
              [-104.98420162699995, 68.32265859600005],
              [-104.97301184799994, 68.31415436400005],
              [-104.9531957669999, 68.30744049700007],
              [-104.92642167899993, 68.31500885600008],
              [-104.90339107999995, 68.33144765800006],
              [-104.89419511599993, 68.35138580900008],
              [-104.88068600199995, 68.34023672100005],
              [-104.8640844389999, 68.33454010600008],
              [-104.84886633999992, 68.32709381700005],
              [-104.83958899599992, 68.31037018400008],
              [-104.84219316299993, 68.29189687700006],
              [-104.85651607999995, 68.28082916900007],
              [-104.94497636599993, 68.26056549700007],
              [-104.95189368399991, 68.25177643400008],
              [-104.93517005099994, 68.23590729400007],
              [-104.90916907499991, 68.22671133000006],
              [-104.88463294199994, 68.22947825700004],
              [-104.83958899599992, 68.24957916900007],
              [-104.8281957669999, 68.26186758000006],
              [-104.82005774599992, 68.26512278900003],
              [-104.79743404899995, 68.25210195500006],
              [-104.78506425699993, 68.24909088700008],
              [-104.63414466099994, 68.24957916900007],
              [-104.60195878799993, 68.23533763200004],
              [-104.6172582669999, 68.20246002800008],
              [-104.67568925699993, 68.13971588700008],
              [-104.6172582669999, 68.13959381700005],
              [-104.60366777299993, 68.12872955900008],
              [-104.59943600199995, 68.09471263200004],
              [-104.59162350199995, 68.08331940300008],
              [-104.57347571499992, 68.07843659100007],
              [-104.52944902299993, 68.07672760600008],
              [-104.5066625639999, 68.07074616100005],
              [-104.5000707669999, 68.06708405200004],
              [-104.49986731699994, 68.06073639500005],
              [-104.51146399599992, 68.04873281500005],
              [-104.51060950399994, 68.04291413000004],
              [-104.48387610599991, 68.03392161700003],
              [-104.36327063699991, 68.03668854400007],
              [-104.34679114499994, 68.04132721600007],
              [-104.3323461579999, 68.05052317900004],
              [-104.31700598899994, 68.05707428600005],
              [-104.29832923099991, 68.05377838700008],
              [-104.22948157499991, 68.02985260600008],
              [-104.14761308499993, 68.02423737200007],
              [-103.9903051419999, 68.04865143400008],
              [-103.87857011599993, 68.02334219000005],
              [-103.83560136599993, 68.02130768400008],
              [-103.79259192599994, 68.02627187700006],
              [-103.75649980399993, 68.03668854400007],
              [-103.74376380099994, 68.04466380400004],
              [-103.72203528599994, 68.06415436400005],
              [-103.70872962099992, 68.07086823100008],
              [-103.6870824859999, 68.07196686400005],
              [-103.61620032499991, 68.05719635600008],
              [-103.58629309799994, 68.05670807500007],
              [-103.57176673099991, 68.05829498900005],
              [-103.5579320949999, 68.06342194200005],
              [-103.5437719389999, 68.07135651200008],
              [-103.54161536399994, 68.07501862200007],
              [-103.54434160099993, 68.07982005400004],
              [-103.54552161399994, 68.10101959800005],
              [-103.5484106109999, 68.10659414300005],
              [-103.5476781889999, 68.11322663000004],
              [-103.5374242829999, 68.12604401200008],
              [-103.52843176999994, 68.13300202000005],
              [-103.44253495999993, 68.16738515800006],
              [-103.4148656889999, 68.16937897300005],
              [-103.38658606699994, 68.15961334800005],
              [-103.37124589799993, 68.14858633000006],
              [-103.35850989499994, 68.13629791900007],
              [-103.33877519399994, 68.11180247600004],
              [-103.35020911399994, 68.10297272300005],
              [-103.36241614499994, 68.09642161700003],
              [-103.37303626199991, 68.08905670800004],
              [-103.37975012899994, 68.07762278900003],
              [-103.37743079299992, 68.07257721600007],
              [-103.36815344999991, 68.04413483300004],
              [-103.36607825399994, 68.03327057500007],
              [-103.36607825399994, 68.01850006700005],
              [-103.36351477799991, 68.01146067900004],
              [-103.35448157499991, 68.00946686400005],
              [-103.31777910099993, 68.00771719000005],
              [-103.30532792899993, 68.00311920800004],
              [-103.2688695949999, 67.97915273600006],
              [-103.2561742829999, 67.97313060100004],
              [-103.24201412699995, 67.96995677300004],
              [-103.22207597599993, 67.96841054900005],
              [-103.1770727199999, 67.97003815300008],
              [-103.15453040299991, 67.96759674700007],
              [-103.13646399599992, 67.95783112200007],
              [-103.11172441299993, 67.93927643400008],
              [-103.08299719999991, 67.92747630400004],
              [-103.05101477799991, 67.92145416900007],
              [-103.01667232999995, 67.91998932500007],
              [-102.96499589799993, 67.92938873900005],
              [-102.94835364499994, 67.92682526200008],
              [-102.92467200399994, 67.90249258000006],
              [-102.92039954299992, 67.89614492400005],
              [-102.90916907499991, 67.88507721600007],
              [-102.83849036399994, 67.84491608300004],
              [-102.76256262899994, 67.81513092700004],
              [-102.57282467399995, 67.79511139500005],
              [-102.45107988199993, 67.78229401200008],
              [-102.34080969999991, 67.75092194200005],
              [-102.30589758999992, 67.72325267100007],
              [-102.25381425699993, 67.73041413000004],
              [-102.24205481699994, 67.72508372600004],
              [-102.23949133999992, 67.70709870000007],
              [-102.23180091099994, 67.69505442900004],
              [-102.21890214799993, 67.69183991100005],
              [-102.20103919199994, 67.70026276200008],
              [-102.21003170499995, 67.70514557500007],
              [-102.22008216099994, 67.71409739800004],
              [-102.22744706899994, 67.72479889500005],
              [-102.22838294199994, 67.73505280200004],
              [-102.21849524599992, 67.74201080900008],
              [-102.1675512359999, 67.75547923400006],
              [-102.14342200399994, 67.77195872600004],
              [-102.13072669199994, 67.77509186400005],
              [-102.10142981699994, 67.75556061400005],
              [-102.08299719999991, 67.75006745000007],
              [-102.06305904899995, 67.74815501500007],
              [-102.0257055329999, 67.75047435100004],
              [-102.01187089799993, 67.75360748900005],
              [-102.00035559799994, 67.75934479400007],
              [-101.98875891799992, 67.76923248900005],
              [-101.99034583199995, 67.77122630400004],
              [-101.99315344999991, 67.77647532800006],
              [-101.9937231109999, 67.78314850500004],
              [-101.98875891799992, 67.78965892100007],
              [-101.98058020699995, 67.79157135600008],
              [-101.94749915299991, 67.78965892100007],
              [-101.93907630099994, 67.78575267100007],
              [-101.93032792899993, 67.77667877800008],
              [-101.91673743399991, 67.75889720300006],
              [-101.89976966099994, 67.74913157800006],
              [-101.85765540299991, 67.74689362200007],
              [-101.8379613919999, 67.74188873900005],
              [-101.83844967399995, 67.73309967700004],
              [-101.83397376199991, 67.72418854400007],
              [-101.82648678299995, 67.71727122600004],
              [-101.81810462099992, 67.71454498900005],
              [-101.81065833199995, 67.71324290600006],
              [-101.79796301999994, 67.70811595300006],
              [-101.78954016799992, 67.70770905200004],
              [-101.78425045499995, 67.71124909100007],
              [-101.7703344389999, 67.72821686400005],
              [-101.74181067599994, 67.72764720300006],
              [-101.71959387899994, 67.71653880400004],
              [-101.69859778599994, 67.70270416900007],
              [-101.67345130099994, 67.69403717700004],
              [-101.65591386599993, 67.69476959800005],
              [-101.62193762899994, 67.70062897300005],
              [-101.60521399599992, 67.69721100500004],
              [-101.58836829299992, 67.69078196800007],
              [-101.54727128799993, 67.68134186400005],
              [-101.52944902299993, 67.68040599200003],
              [-101.48078365799995, 67.69599030200004],
              [-101.47175045499995, 67.69721100500004],
              [-101.4566137359999, 67.68968333500004],
              [-101.43643144399994, 67.68809642100007],
              [-101.41592363199993, 67.69025299700007],
              [-101.39976966099994, 67.69403717700004],
              [-101.41047115799995, 67.70502350500004],
              [-101.44591223899994, 67.71332428600005],
              [-101.4544164699999, 67.72199127800008],
              [-101.44766191299993, 67.73436107000003],
              [-101.42983964799993, 67.73615143400008],
              [-101.40965735599991, 67.73167552300004],
              [-101.38206946499992, 67.71845123900005],
              [-101.36949622299994, 67.72028229400007],
              [-101.35643469999991, 67.72528717700004],
              [-101.34080969999991, 67.72821686400005],
              [-101.28156490799995, 67.72016022300005],
              [-101.26256262899994, 67.72199127800008],
              [-101.24181067599994, 67.73688385600008],
              [-101.24657141799992, 67.75474681200006],
              [-101.25243079299992, 67.76972077000005],
              [-101.23497473899994, 67.77598704600007],
              [-101.21825110599991, 67.77281321800007],
              [-101.19033769399994, 67.75873444200005],
              [-101.17381751199991, 67.75547923400006],
              [-101.15672766799992, 67.75889720300006],
              [-101.12755286399994, 67.77594635600008],
              [-101.11172441299993, 67.78282298400006],
              [-101.09483801999994, 67.78660716400003],
              [-101.09268144399994, 67.78461334800005],
              [-101.09666907499991, 67.77818431200006],
              [-101.09805253799993, 67.76923248900005],
              [-101.09658769399994, 67.75486888200004],
              [-101.09764563699991, 67.74909088700008],
              [-101.09284420499995, 67.74815501500007],
              [-100.95685787699995, 67.74921295800004],
              [-100.91934160099993, 67.75547923400006],
              [-100.89220130099994, 67.77057526200008],
              [-100.90249589799993, 67.78648509300007],
              [-100.92218990799995, 67.80316803600005],
              [-100.92308508999992, 67.82074616100005],
              [-100.90729732999995, 67.82855866100005],
              [-100.89195716099994, 67.82489655200004],
              [-100.87857011599993, 67.81578196800007],
              [-100.8684789699999, 67.80699290600006],
              [-100.84959876199991, 67.79682038000004],
              [-100.83128821499992, 67.79596588700008],
              [-100.81358801999994, 67.80137767100007],
              [-100.7691137359999, 67.82648346600007],
              [-100.75377356699994, 67.82746002800008],
              [-100.73497473899994, 67.81696198100008],
              [-100.72712154899995, 67.82591380400004],
              [-100.71703040299991, 67.84699127800008],
              [-100.70738684799994, 67.85114166900007],
              [-100.68732662699995, 67.84833405200004],
              [-100.66148841099994, 67.83543528900003],
              [-100.64561926999994, 67.83124420800004],
              [-100.61217200399994, 67.84430573100008],
              [-100.59276282499991, 67.84703196800007],
              [-100.58413652299993, 67.83466217700004],
              [-100.58714758999992, 67.82428620000007],
              [-100.59264075399994, 67.81635163000004],
              [-100.59544837099992, 67.80809153900003],
              [-100.59040279899995, 67.79645416900007],
              [-100.5442602199999, 67.80748118700006],
              [-100.45889238199993, 67.84251536700003],
              [-100.41283118399991, 67.85114166900007],
              [-100.16641191299993, 67.84491608300004],
              [-100.14696204299992, 67.84056224200003],
              [-100.10220292899993, 67.82135651200008],
              [-100.08047441299993, 67.81696198100008],
              [-100.02867591099994, 67.82440827000005],
              [-100.01357988199993, 67.82184479400007],
              [-99.98350989499994, 67.81134674700007],
              [-99.96784420499995, 67.81012604400007],
              [-99.95759029899995, 67.81293366100005],
              [-99.93797766799992, 67.82221100500004],
              [-99.92686926999994, 67.82440827000005],
              [-99.91222083199995, 67.82318756700005],
              [-99.87165279899995, 67.81012604400007],
              [-99.81704667899993, 67.80088939000007],
              [-99.79271399599992, 67.80491771000004],
              [-99.79527747299994, 67.82440827000005],
              [-99.76781165299991, 67.82648346600007],
              [-99.68614661399994, 67.81651439000007],
              [-99.66246497299994, 67.80699290600006],
              [-99.64883378799993, 67.79694245000007],
              [-99.63459225199995, 67.79271067900004],
              [-99.61961829299992, 67.79393138200004],
              [-99.58665930899991, 67.80621979400007],
              [-99.56745357999995, 67.80772532800006],
              [-99.51048743399991, 67.80125560100004],
              [-99.49486243399991, 67.79645416900007],
              [-99.49136308499993, 67.79340241100005],
              [-99.48888098899994, 67.78880442900004],
              [-99.4876195949999, 67.78461334800005],
              [-99.48741614499994, 67.78282298400006],
              [-99.47061113199993, 67.78168366100005],
              [-99.46125240799995, 67.78668854400007],
              [-99.45295162699995, 67.79328034100007],
              [-99.43960527299993, 67.79645416900007],
              [-99.42369544199994, 67.79413483300004],
              [-99.41136633999992, 67.78851959800005],
              [-99.39118404899995, 67.77598704600007],
              [-99.37486731699994, 67.76972077000005],
              [-99.35777747299994, 67.76544830900008],
              [-99.31639563699991, 67.76231517100007],
              [-99.29527747299994, 67.75535716400003],
              [-99.25291907499991, 67.72349681200006],
              [-99.22667395699995, 67.71454498900005],
              [-99.21642005099994, 67.71503327000005],
              [-99.20103919199994, 67.72032298400006],
              [-99.19318600199995, 67.72199127800008],
              [-99.18358313699991, 67.72081126500007],
              [-99.1680395169999, 67.71491120000007],
              [-99.15843665299991, 67.71454498900005],
              [-99.12559973899994, 67.72589752800008],
              [-99.10903886599993, 67.72919342700004],
              [-99.05581620999993, 67.71954987200007],
              [-99.01842200399994, 67.72296784100007],
              [-98.98167883999992, 67.72203196800007],
              [-98.93643144399994, 67.69684479400007],
              [-98.92438717399995, 67.70075104400007],
              [-98.91543535099993, 67.71161530200004],
              [-98.90982011599993, 67.73924388200004],
              [-98.90339107999995, 67.74754466400003],
              [-98.89268958199995, 67.75226471600007],
              [-98.87791907499991, 67.75547923400006],
              [-98.77993730399993, 67.74827708500004],
              [-98.73228919199994, 67.75409577000005],
              [-98.69977779899995, 67.78965892100007],
              [-98.70604407499991, 67.80170319200005],
              [-98.69831295499995, 67.80963776200008],
              [-98.68260657499991, 67.81268952000005],
              [-98.66494706899994, 67.81012604400007],
              [-98.64561926999994, 67.80137767100007],
              [-98.63052324099993, 67.79254791900007],
              [-98.61375891799992, 67.78563060100004],
              [-98.58926347599993, 67.78282298400006],
              [-98.40868079299992, 67.78953685100004],
              [-98.39647376199991, 67.78880442900004],
              [-98.37857011599993, 67.79002513200004],
              [-98.3633520169999, 67.79462311400005],
              [-98.35655676999994, 67.80390045800004],
              [-98.36095130099994, 67.81134674700007],
              [-98.39439856699994, 67.83466217700004],
              [-98.43199622299994, 67.85480377800008],
              [-98.43594316299993, 67.85850657800006],
              [-98.44196529899995, 67.86066315300008],
              [-98.45225989499994, 67.87006256700005],
              [-98.45954342399995, 67.87217845300006],
              [-98.47069251199991, 67.87091705900008],
              [-98.49010169199994, 67.86591217700004],
              [-98.50047766799992, 67.86542389500005],
              [-98.53547115799995, 67.87323639500005],
              [-98.56940670499995, 67.88585032800006],
              [-98.6089574859999, 67.91014232000003],
              [-98.64443925699993, 67.91868724200003],
              [-98.71275794199994, 67.94493235900006],
              [-98.72704016799992, 67.95783112200007],
              [-98.73387610599991, 68.03668854400007],
              [-98.74205481699994, 68.05060455900008],
              [-98.74282792899993, 68.06000397300005],
              [-98.73387610599991, 68.07086823100008],
              [-98.71670488199993, 68.07493724200003],
              [-98.64452063699991, 68.07086823100008],
              [-98.62913977799991, 68.07542552300004],
              [-98.5969945949999, 68.09430573100008],
              [-98.58458411399994, 68.09638092700004],
              [-98.56798255099994, 68.08848704600007],
              [-98.56004798099991, 68.07994212400007],
              [-98.55451412699995, 68.07066478100006],
              [-98.54523678299995, 68.06028880400004],
              [-98.52232825399994, 68.04559967700004],
              [-98.34776770699995, 67.96446360900006],
              [-98.3140356109999, 67.95514557500007],
              [-98.25743567599994, 67.92584870000007],
              [-98.24107825399994, 67.91376373900005],
              [-98.23436438699991, 67.90416087400007],
              [-98.22598222599993, 67.88731517100007],
              [-98.21934973899994, 67.87909577000005],
              [-98.20840410099993, 67.87030670800004],
              [-98.1848852199999, 67.85565827000005],
              [-98.17528235599991, 67.84796784100007],
              [-98.09211178299995, 67.76032135600008],
              [-98.0828344389999, 67.75547923400006],
              [-98.07559160099993, 67.75702545800004],
              [-98.05703691299993, 67.76654694200005],
              [-98.04865475199995, 67.76923248900005],
              [-98.03709876199991, 67.76801178600005],
              [-97.98436438699991, 67.75031159100007],
              [-97.97500566299993, 67.74518463700008],
              [-97.93944251199991, 67.70441315300008],
              [-97.92723548099991, 67.69688548400006],
              [-97.90835527299993, 67.69403717700004],
              [-97.83096269399994, 67.69249095300006],
              [-97.79596920499995, 67.68463776200008],
              [-97.76060950399994, 67.66673411700003],
              [-97.74083411399994, 67.65241120000007],
              [-97.73045813699991, 67.64850495000007],
              [-97.7122289699999, 67.64569733300004],
              [-97.67418372299994, 67.64683665600006],
              [-97.65587317599994, 67.64500560100004],
              [-97.64085852799991, 67.63605377800008],
              [-97.61969967399995, 67.61839427300004],
              [-97.59032141799992, 67.60297272300005],
              [-97.5579320949999, 67.59540436400005],
              [-97.49547278599994, 67.60814036700003],
              [-97.41502844999991, 67.61066315300008],
              [-97.38731848899994, 67.62177155200004],
              [-97.36587480399993, 67.63739655200004],
              [-97.33507239499994, 67.65289948100008],
              [-97.30223548099991, 67.66400788000004],
              [-97.27464758999992, 67.66673411700003],
              [-97.25633704299992, 67.65509674700007],
              [-97.23521887899994, 67.63544342700004],
              [-97.21324622299994, 67.62457916900007],
              [-97.19212805899991, 67.63947174700007],
              [-97.19692949099993, 67.66437409100007],
              [-97.15196692599994, 67.67462799700007],
              [-97.06114661399994, 67.68040599200003],
              [-97.07599850199995, 67.69151439000007],
              [-97.09357662699995, 67.70087311400005],
              [-97.13003495999993, 67.71454498900005],
              [-97.15599524599992, 67.71735260600008],
              [-97.20384680899991, 67.71088288000004],
              [-97.22622636599993, 67.71454498900005],
              [-97.21108964799993, 67.73399485900006],
              [-97.12010657499991, 67.77940501500007],
              [-97.12083899599992, 67.79303620000007],
              [-97.13459225199995, 67.81309642100007],
              [-97.16478430899991, 67.84491608300004],
              [-97.17398027299993, 67.85044993700006],
              [-97.19741777299993, 67.85997142100007],
              [-97.20571855399993, 67.86542389500005],
              [-97.21202551999994, 67.87506745000007],
              [-97.21715247299994, 67.89415110900006],
              [-97.22280839799993, 67.90289948100008],
              [-97.2495824859999, 67.92462799700007],
              [-97.26284745999993, 67.92194245000007],
              [-97.27415930899991, 67.90550364800004],
              [-97.29515540299991, 67.88585032800006],
              [-97.32701575399994, 67.87592194200005],
              [-97.36351477799991, 67.87693919500003],
              [-97.39745032499991, 67.88670482000003],
              [-97.44456946499992, 67.92182038000004],
              [-97.47118079299992, 67.93537018400008],
              [-97.5735570949999, 67.97431061400005],
              [-97.64085852799991, 68.00938548400006],
              [-97.65786699099993, 68.01337311400005],
              [-97.67577063699991, 68.02033112200007],
              [-97.69322669199994, 68.02265045800004],
              [-97.70946204299992, 68.01276276200008],
              [-97.71373450399994, 68.00226471600007],
              [-97.71344967399995, 67.98273346600007],
              [-97.71971594999991, 67.97528717700004],
              [-97.72960364499994, 67.97325267100007],
              [-97.74022376199991, 67.97577545800004],
              [-97.7508031889999, 67.97955963700008],
              [-97.76699785099993, 67.98289622600004],
              [-97.77049719999991, 67.98590729400007],
              [-97.77428137899994, 67.98749420800004],
              [-97.78140214799993, 67.98517487200007],
              [-97.79478919199994, 67.97528717700004],
              [-97.83287512899994, 67.97593821800007],
              [-97.84992428299995, 67.97410716400003],
              [-97.87047278599994, 67.96836985900006],
              [-97.95750891799992, 67.92902252800008],
              [-97.97695878799993, 67.93052806200006],
              [-97.99083411399994, 67.95343659100007],
              [-98.0015356109999, 67.95945872600004],
              [-98.0176488919999, 67.95136139500005],
              [-98.05890865799995, 67.91685618700006],
              [-98.06602942599994, 67.89923737200007],
              [-98.06411699099993, 67.87474192900004],
              [-98.05711829299992, 67.85167064000007],
              [-98.04865475199995, 67.83808014500005],
              [-98.07335364499994, 67.83140696800007],
              [-98.0950414699999, 67.83661530200004],
              [-98.13121497299994, 67.85850657800006],
              [-98.17153886599993, 67.87567780200004],
              [-98.17857825399994, 67.88068268400008],
              [-98.1948949859999, 67.89618561400005],
              [-98.19640051999994, 67.89952220300006],
              [-98.20262610599991, 67.90595123900005],
              [-98.2117406889999, 67.91998932500007],
              [-98.22329667899993, 67.93406810100004],
              [-98.23737545499995, 67.94049713700008],
              [-98.25255286399994, 67.94505442900004],
              [-98.30870520699995, 67.97528717700004],
              [-98.38365637899994, 67.99872467700004],
              [-98.40489661399994, 68.00938548400006],
              [-98.41690019399994, 68.02252838700008],
              [-98.44896399599992, 68.07086823100008],
              [-98.46324622299994, 68.07554759300007],
              [-98.5054418609999, 68.09906647300005],
              [-98.53429114499994, 68.12067291900007],
              [-98.57258053299995, 68.13812897300005],
              [-98.5899145169999, 68.15277741100005],
              [-98.57713782499991, 68.15607330900008],
              [-98.56411699099993, 68.15216705900008],
              [-98.53526770699995, 68.13971588700008],
              [-98.52843176999994, 68.16229889500005],
              [-98.50670325399994, 68.18121979400007],
              [-98.47940019399994, 68.19037506700005],
              [-98.45612545499995, 68.18378327000005],
              [-98.44762122299994, 68.17841217700004],
              [-98.43838456899994, 68.17426178600005],
              [-98.4304906889999, 68.16889069200005],
              [-98.42540442599994, 68.15961334800005],
              [-98.42609615799995, 68.14813873900005],
              [-98.43712317599994, 68.12933991100005],
              [-98.43907630099994, 68.11859772300005],
              [-98.4114477199999, 68.08246491100005],
              [-98.36359615799995, 68.09398021000004],
              [-98.32453365799995, 68.12811920800004],
              [-98.32298743399991, 68.15961334800005],
              [-98.31554114499994, 68.16705963700008],
              [-98.34068762899994, 68.18073151200008],
              [-98.36807206899994, 68.18980540600006],
              [-98.48631751199991, 68.21556224200003],
              [-98.54149329299992, 68.23590729400007],
              [-98.52672278599994, 68.23773834800005],
              [-98.51231848899994, 68.23676178600005],
              [-98.49901282499991, 68.23883698100008],
              [-98.48745683499993, 68.24957916900007],
              [-98.5423070949999, 68.26727936400005],
              [-98.59215247299994, 68.29157135600008],
              [-98.68610592399995, 68.35138580900008],
              [-98.71056067599994, 68.36070384300007],
              [-98.7180883449999, 68.36762116100005],
              [-98.71336829299992, 68.37925853100006],
              [-98.69839433499993, 68.38471100500004],
              [-98.67308508999992, 68.38646067900004],
              [-98.64720618399991, 68.38544342700004],
              [-98.63084876199991, 68.38243235900006],
              [-98.54442298099991, 68.33966705900008],
              [-98.51475989499994, 68.33152903900003],
              [-98.51720130099994, 68.34125397300005],
              [-98.52281653599994, 68.34882233300004],
              [-98.53111731699994, 68.35455963700008],
              [-98.54149329299992, 68.35883209800005],
              [-98.54149329299992, 68.36505768400008],
              [-98.49803626199991, 68.35350169500003],
              [-98.47740637899994, 68.35248444200005],
              [-98.45954342399995, 68.36505768400008],
              [-98.52098548099991, 68.39976634300007],
              [-98.54076087099992, 68.41478099200003],
              [-98.54084225199995, 68.42401764500005],
              [-98.52599036399994, 68.42540110900006],
              [-98.50112870999993, 68.41685618700006],
              [-98.45490475199995, 68.38707103100006],
              [-98.43907630099994, 68.37925853100006],
              [-98.43073482999995, 68.37677643400008],
              [-98.31761633999992, 68.35679759300007],
              [-98.2532445949999, 68.31757233300004],
              [-98.21312415299991, 68.30418528900003],
              [-98.19237219999991, 68.30768463700008],
              [-98.17418372299994, 68.31907786700003],
              [-98.15998287699995, 68.33063385600008],
              [-98.15135657499991, 68.33466217700004],
              [-98.13117428299995, 68.32697174700007],
              [-98.10578365799995, 68.32172272300005],
              [-98.08259029899995, 68.32379791900007],
              [-98.06847083199995, 68.33771393400008],
              [-98.11050370999993, 68.34971751500007],
              [-98.11693274599992, 68.35508860900006],
              [-98.1106664699999, 68.36448802300004],
              [-98.09557044199994, 68.36749909100007],
              [-97.90465247299994, 68.34454987200007],
              [-97.90831458199995, 68.39154694200005],
              [-97.85118567599994, 68.38959381700005],
              [-97.78156490799995, 68.37116120000007],
              [-97.7476293609999, 68.36871979400007],
              [-97.75426184799994, 68.38898346600007],
              [-97.77098548099991, 68.40196360900006],
              [-97.79295813699991, 68.40949127800008],
              [-97.8679906889999, 68.41657135600008],
              [-97.88414466099994, 68.42023346600007],
              [-97.89517167899993, 68.42413971600007],
              [-97.90746008999992, 68.43016185100004],
              [-97.9116918609999, 68.43817780200004],
              [-97.89842688699991, 68.44757721600007],
              [-97.98643958199995, 68.48179759300007],
              [-98.01048743399991, 68.49909088700008],
              [-98.01268469999991, 68.50792064000007],
              [-98.00967363199993, 68.52000560100004],
              [-98.00365149599992, 68.53192780200004],
              [-97.99714107999995, 68.54035065300008],
              [-97.97964433499993, 68.54706452000005],
              [-97.96007239499994, 68.54307689000007],
              [-97.92516028599994, 68.53009674700007],
              [-97.90733801999994, 68.53131745000007],
              [-97.87401282499991, 68.54173411700003],
              [-97.8562719389999, 68.54376862200007],
              [-97.79605058499993, 68.53209056200006],
              [-97.70547441299993, 68.52781810100004],
              [-97.68862870999993, 68.51959870000007],
              [-97.68154863199993, 68.51451243700006],
              [-97.66771399599992, 68.51011790600006],
              [-97.66136633999992, 68.50629303600005],
              [-97.6555883449999, 68.49811432500007],
              [-97.65550696499992, 68.49164459800005],
              [-97.6575414699999, 68.48643626500007],
              [-97.65758216099994, 68.48236725500004],
              [-97.63585364499994, 68.45543040600006],
              [-97.61148027299993, 68.44391510600008],
              [-97.58291581899994, 68.43699778900003],
              [-97.54869544199994, 68.42401764500005],
              [-97.5293676419999, 68.42072174700007],
              [-97.51333574099993, 68.42719147300005],
              [-97.50377356699994, 68.43614329600007],
              [-97.50365149599992, 68.44078196800007],
              [-97.50723222599993, 68.44293854400007],
              [-97.51244055899991, 68.44757721600007],
              [-97.51919511599993, 68.45233795800004],
              [-97.52757727799991, 68.45441315300008],
              [-97.57506262899994, 68.44757721600007],
              [-97.60997473899994, 68.45197174700007],
              [-97.61660722599993, 68.45441315300008],
              [-97.62096106699994, 68.46210358300004],
              [-97.61904863199993, 68.46442291900007],
              [-97.61440995999993, 68.46527741100005],
              [-97.61046301999994, 68.46869538000004],
              [-97.6028539699999, 68.48126862200007],
              [-97.59162350199995, 68.49217357000003],
              [-97.57774817599994, 68.49994538000004],
              [-97.56236731699994, 68.50287506700005],
              [-97.43000240799995, 68.50556061400005],
              [-97.26036536399994, 68.46869538000004],
              [-97.24909420499995, 68.44586823100008],
              [-97.10952714799993, 68.39301178600005],
              [-97.12319902299993, 68.39691803600005],
              [-97.14354407499991, 68.39781321800007],
              [-97.16226152299993, 68.39439524900007],
              [-97.17100989499994, 68.38556549700007],
              [-97.16197669199994, 68.37763092700004],
              [-97.14073645699995, 68.37144603100006],
              [-97.00991777299993, 68.35004303600005],
              [-96.9934789699999, 68.33771393400008],
              [-96.99909420499995, 68.32794830900008],
              [-97.00088456899994, 68.31745026200008],
              [-96.99901282499991, 68.30683014500005],
              [-96.9934789699999, 68.29673899900007],
              [-97.01244055899991, 68.29816315300008],
              [-97.05606035099993, 68.30662669500003],
              [-97.07201087099992, 68.30048248900005],
              [-97.08299719999991, 68.28611888200004],
              [-97.08678137899994, 68.27403392100007],
              [-97.08063717399995, 68.26569245000007],
              [-96.97158769399994, 68.25385163000004],
              [-96.94904537699995, 68.24473704600007],
              [-96.93822180899991, 68.24213288000004],
              [-96.92642167899993, 68.24274323100008],
              [-96.69001217399995, 68.28644440300008],
              [-96.67137610599991, 68.28314850500004],
              [-96.66323808499993, 68.26487864800004],
              [-96.65737870999993, 68.25922272300005],
              [-96.64761308499993, 68.25739166900007],
              [-96.64037024599992, 68.25934479400007],
              [-96.6348363919999, 68.25889720300006],
              [-96.63036048099991, 68.24957916900007],
              [-96.67951412699995, 68.23871491100005],
              [-96.69172115799995, 68.22813548400006],
              [-96.68126380099994, 68.21112702000005],
              [-96.66380774599992, 68.19928620000007],
              [-96.64146887899994, 68.18903229400007],
              [-96.62096106699994, 68.18565501500007],
              [-96.60863196499992, 68.19432200700004],
              [-96.63394120999993, 68.21393463700008],
              [-96.62222245999993, 68.23480866100005],
              [-96.59203040299991, 68.25421784100007],
              [-96.48619544199994, 68.30341217700004],
              [-96.44692949099993, 68.31395091400003],
              [-96.40379798099991, 68.31785716400003],
              [-96.46939042899993, 68.28595612200007],
              [-96.47956295499995, 68.27317942900004],
              [-96.48033606699994, 68.24323151200008],
              [-96.48326575399994, 68.22882721600007],
              [-96.48949133999992, 68.21796295800004],
              [-96.52452551999994, 68.19171784100007],
              [-96.64342200399994, 68.13971588700008],
              [-96.62474524599992, 68.12531159100007],
              [-96.63768469999991, 68.11347077000005],
              [-96.6655981109999, 68.10614655200004],
              [-96.69180253799993, 68.10496653900003],
              [-96.68736731699994, 68.09503815300008],
              [-96.68496660099993, 68.09129466400003],
              [-96.71532141799992, 68.08405182500007],
              [-96.75694739499994, 68.08043040600006],
              [-96.79503333199995, 68.07196686400005],
              [-96.81476803299995, 68.05036041900007],
              [-96.80186926999994, 68.02684153900003],
              [-96.76451575399994, 68.01715729400007],
              [-96.69180253799993, 68.01618073100008],
              [-96.6770727199999, 68.02155182500007],
              [-96.66885331899994, 68.03388092700004],
              [-96.66368567599994, 68.04759349200003],
              [-96.65770423099991, 68.05719635600008],
              [-96.64240475199995, 68.06293366100005],
              [-96.6167699859999, 68.06818268400008],
              [-96.59264075399994, 68.06871165600006],
              [-96.58193925699993, 68.06028880400004],
              [-96.56273352799991, 68.04047272300005],
              [-96.51939856699994, 68.03620026200008],
              [-96.47297115799995, 68.04144928600005],
              [-96.44481360599991, 68.05036041900007],
              [-96.46597245999993, 68.05919017100007],
              [-96.48574785099993, 68.07086823100008],
              [-96.47891191299993, 68.09056224200003],
              [-96.49986731699994, 68.09381745000007],
              [-96.54845130099994, 68.08506907800006],
              [-96.52501380099994, 68.11603424700007],
              [-96.49132239499994, 68.13483307500007],
              [-96.39810136599993, 68.17137278900003],
              [-96.34626217399995, 68.18463776200008],
              [-96.3250219389999, 68.18687571800007],
              [-96.3152563139999, 68.18915436400005],
              [-96.29328365799995, 68.19891998900005],
              [-96.21263587099992, 68.21031321800007],
              [-96.15054277299993, 68.22846100500004],
              [-96.00938880099994, 68.25226471600007],
              [-95.9898168609999, 68.25999583500004],
              [-95.97179114499994, 68.26947663000004],
              [-95.94933020699995, 68.28587474200003],
              [-95.93765214799993, 68.29059479400007],
              [-95.90684973899994, 68.29437897300005],
              [-95.89671790299991, 68.29673899900007],
              [-95.91344153599994, 68.27435944200005],
              [-95.9387914699999, 68.25250885600008],
              [-96.04238847599993, 68.18866608300004],
              [-96.06655839799993, 68.16852448100008],
              [-96.08165442599994, 68.14594147300005],
              [-96.02440344999991, 68.11570872600004],
              [-96.04637610599991, 68.07640208500004],
              [-96.08604895699995, 68.03770579600007],
              [-96.08165442599994, 68.00938548400006],
              [-96.09048417899993, 67.99701569200005],
              [-96.12267005099994, 67.96836985900006],
              [-96.13076738199993, 67.95685455900008],
              [-96.14012610599991, 67.93292877800008],
              [-96.14683997299994, 67.92340729400007],
              [-96.15339107999995, 67.91624583500004],
              [-96.1614477199999, 67.90534088700008],
              [-96.16820227799991, 67.89325592700004],
              [-96.17589270699995, 67.86631907800006],
              [-96.18740800699993, 67.85455963700008],
              [-96.20103919199994, 67.84385814000007],
              [-96.21202551999994, 67.83124420800004],
              [-96.21678626199991, 67.81024811400005],
              [-96.2163793609999, 67.78034088700008],
              [-96.20946204299992, 67.75348541900007],
              [-96.19493567599994, 67.74188873900005],
              [-96.19131425699993, 67.73651764500005],
              [-96.2007543609999, 67.72443268400008],
              [-96.22227942599994, 67.70396556200006],
              [-96.22215735599991, 67.69896067900004],
              [-96.21800696499992, 67.69139232000003],
              [-96.21190344999991, 67.68427155200004],
              [-96.20579993399991, 67.68040599200003],
              [-96.17105058499993, 67.70026276200008],
              [-96.18187415299991, 67.64288971600007],
              [-96.19717363199993, 67.62702057500007],
              [-96.23253333199995, 67.62518952000005],
              [-96.25304114499994, 67.62982819200005],
              [-96.26707923099991, 67.63727448100008],
              [-96.27843176999994, 67.64813873900005],
              [-96.29088294199994, 67.66303131700005],
              [-96.29670162699995, 67.67450592700004],
              [-96.30060787699995, 67.68659088700008],
              [-96.30724036399994, 67.69635651200008],
              [-96.32127844999991, 67.70026276200008],
              [-96.34390214799993, 67.68939850500004],
              [-96.34447180899991, 67.66388580900008],
              [-96.33690344999991, 67.63446686400005],
              [-96.33495032499991, 67.61212799700007],
              [-96.35724850199995, 67.58283112200007],
              [-96.3914281889999, 67.56700267100007],
              [-96.46524003799993, 67.54950592700004],
              [-96.44050045499995, 67.54332103100006],
              [-96.43114173099991, 67.54328034100007],
              [-96.43773352799991, 67.53331126500007],
              [-96.44933020699995, 67.52305735900006],
              [-96.46524003799993, 67.51219310100004],
              [-96.46524003799993, 67.47801341400003],
              [-96.45958411399994, 67.47479889500005],
              [-96.44668535099993, 67.48090241100005],
              [-96.42430579299992, 67.49481842700004],
              [-96.40859941299993, 67.49725983300004],
              [-96.39207923099991, 67.49607982000003],
              [-96.37621008999992, 67.49091217700004],
              [-96.36221269399994, 67.48114655200004],
              [-96.37588456899994, 67.46320221600007],
              [-96.3645727199999, 67.45543040600006],
              [-96.34520423099991, 67.45136139500005],
              [-96.33495032499991, 67.44391510600008],
              [-96.32603919199994, 67.44065989800004],
              [-96.28034420499995, 67.44249095300006],
              [-96.26040605399993, 67.44086334800005],
              [-96.2344457669999, 67.42930735900006],
              [-96.22569739499994, 67.42649974200003],
              [-96.21003170499995, 67.42560455900008],
              [-96.18675696499992, 67.43219635600008],
              [-96.17446855399993, 67.43402741100005],
              [-96.15318762899994, 67.44220612200007],
              [-96.13658606699994, 67.45880768400008],
              [-96.11929277299993, 67.47125885600008],
              [-96.09593665299991, 67.46747467700004],
              [-96.10167395699995, 67.45433177300004],
              [-96.09601803299995, 67.44696686400005],
              [-96.0833227199999, 67.44322337400007],
              [-96.06802324099993, 67.44086334800005],
              [-96.08446204299992, 67.42747630400004],
              [-96.09984290299991, 67.42255280200004],
              [-96.1113988919999, 67.41539134300007],
              [-96.11583411399994, 67.39549388200004],
              [-96.12254798099991, 67.38349030200004],
              [-96.13841712099992, 67.36839427300004],
              [-96.17105058499993, 67.34398021000004],
              [-96.2083227199999, 67.33112213700008],
              [-96.22533118399991, 67.32212962400007],
              [-96.23253333199995, 67.30683014500005],
              [-96.23534094999991, 67.28961823100008],
              [-96.24864661399994, 67.26316966400003],
              [-96.25300045499995, 67.24774811400005],
              [-96.17105058499993, 67.25523509300007],
              [-96.16148841099994, 67.25751373900005],
              [-96.15172278599994, 67.26105377800008],
              [-96.1421606109999, 67.26264069200005],
              [-96.13316809799994, 67.25865306200006],
              [-96.12999426999994, 67.25145091400003],
              [-96.13170325399994, 67.24363841400003],
              [-96.13687089799993, 67.23472728100006],
              [-96.11074785099993, 67.22186920800004],
              [-96.07510331899994, 67.22581614800004],
              [-96.03783118399991, 67.23932526200008],
              [-96.00658118399991, 67.25523509300007],
              [-95.96108964799993, 67.29047272300005],
              [-95.94448808499993, 67.29621002800008],
              [-95.9387914699999, 67.29462311400005],
              [-95.93399003799993, 67.28485748900005],
              [-95.92772376199991, 67.28253815300008],
              [-95.91661536399994, 67.28363678600005],
              [-95.90807044199994, 67.28656647300005],
              [-95.79039466099994, 67.34861888200004],
              [-95.78001868399991, 67.36505768400008],
              [-95.76097571499992, 67.37116120000007],
              [-95.73497473899994, 67.37645091400003],
              [-95.71629798099991, 67.37604401200008],
              [-95.71922766799992, 67.36505768400008],
              [-95.69933020699995, 67.35484446800007],
              [-95.68895423099991, 67.34284088700008],
              [-95.67804928299995, 67.33502838700008],
              [-95.65648352799991, 67.33783600500004],
              [-95.63780676999994, 67.34772370000007],
              [-95.63182532499991, 67.35834381700005],
              [-95.62987219999991, 67.36908600500004],
              [-95.62295488199993, 67.37938060100004],
              [-95.60326087099992, 67.38707103100006],
              [-95.5813695949999, 67.38483307500007],
              [-95.56118730399993, 67.37628815300008],
              [-95.53661048099991, 67.35712311400005],
              [-95.53392493399991, 67.35773346600007],
              [-95.53604081899994, 67.35667552300004],
              [-95.54043535099993, 67.34398021000004],
              [-95.55410722599993, 67.32416413000004],
              [-95.58454342399995, 67.30133698100008],
              [-95.81167558499993, 67.19285716400003],
              [-95.8352758449999, 67.16583893400008],
              [-95.80728105399993, 67.16917552300004],
              [-95.75475012899994, 67.18366120000007],
              [-95.72911536399994, 67.18695709800005],
              [-95.7066137359999, 67.19428131700005],
              [-95.66612708199995, 67.22410716400003],
              [-95.64346269399994, 67.22797272300005],
              [-95.65054277299993, 67.22321198100008],
              [-95.66397050699993, 67.20685455900008],
              [-95.62108313699991, 67.20311107000003],
              [-95.52188066299993, 67.21959056200006],
              [-95.48521887899994, 67.20062897300005],
              [-95.49250240799995, 67.19782135600008],
              [-95.49950110599991, 67.19379303600005],
              [-95.4937231109999, 67.19013092700004],
              [-95.48452714799993, 67.18272532800006],
              [-95.47838294199994, 67.18012116100005],
              [-95.48778235599991, 67.16705963700008],
              [-95.49168860599991, 67.15888092700004],
              [-95.49205481699994, 67.15281810100004],
              [-95.48643958199995, 67.14301178600005],
              [-95.48257402299993, 67.14134349200003],
              [-95.47594153599994, 67.14362213700008],
              [-95.46157792899993, 67.14537181200006],
              [-95.44273841099994, 67.15180084800005],
              [-95.43956458199995, 67.16697825700004],
              [-95.44139563699991, 67.18524811400005],
              [-95.43740800699993, 67.20062897300005],
              [-95.42894446499992, 67.18891022300005],
              [-95.42438717399995, 67.18475983300004],
              [-95.38711503799993, 67.16063060100004],
              [-95.38280188699991, 67.15965403900003],
              [-95.38280188699991, 67.15143463700008],
              [-95.38735917899993, 67.14378489800004],
              [-95.39313717399995, 67.13898346600007],
              [-95.39647376199991, 67.13922760600008],
              [-95.37987219999991, 67.11338939000007],
              [-95.37938391799992, 67.10785553600005],
              [-95.41299394399994, 67.08136627800008],
              [-95.41763261599993, 67.06976959800005],
              [-95.40322831899994, 67.05597565300008],
              [-95.38048255099994, 67.04926178600005],
              [-95.35704505099994, 67.04755280200004],
              [-95.33779863199993, 67.04173411700003],
              [-95.32754472599993, 67.02252838700008],
              [-95.33031165299991, 67.01036204600007],
              [-95.3477270169999, 66.97382233300004],
              [-95.35545813699991, 66.96409739800004],
              [-95.36685136599993, 66.96271393400008],
              [-95.39077714799993, 66.97252024900007],
              [-95.40322831899994, 66.97406647300005],
              [-95.41226152299993, 66.96775950700004],
              [-95.4168188139999, 66.95738353100006],
              [-95.4214574859999, 66.94928620000007],
              [-95.47638912699995, 66.95420970300006],
              [-95.60350501199991, 66.94684479400007],
              [-95.63662675699993, 66.96784088700008],
              [-95.62612870999993, 66.96922435100004],
              [-95.61685136599993, 66.97321198100008],
              [-95.60875403599994, 66.97968170800004],
              [-95.60191809799994, 66.98834870000007],
              [-95.65794837099992, 66.98297760600008],
              [-95.76585852799991, 66.95905182500007],
              [-95.88198808499993, 66.94676341400003],
              [-95.91372636599993, 66.94782135600008],
              [-95.93765214799993, 66.96039459800005],
              [-95.94725501199991, 66.98016998900005],
              [-95.95103919199994, 66.99787018400008],
              [-95.96178137899994, 67.00897858300004],
              [-95.99229895699995, 67.00885651200008],
              [-95.98265540299991, 67.02777741100005],
              [-95.96711178299995, 67.04686107000003],
              [-95.94871985599991, 67.06232330900008],
              [-95.93081620999993, 67.07025788000004],
              [-95.95579993399991, 67.07453034100007],
              [-95.9805395169999, 67.06468333500004],
              [-96.04873613199993, 67.01654694200005],
              [-96.04898027299993, 67.00499095300006],
              [-96.03819739499994, 66.99278392100007],
              [-96.02700761599993, 66.97406647300005],
              [-96.05915279899995, 66.96373118700006],
              [-96.09337317599994, 66.95685455900008],
              [-96.12706458199995, 66.95697663000004],
              [-96.15737870999993, 66.96784088700008],
              [-96.14586341099994, 66.97016022300005],
              [-96.13475501199991, 66.97386302300004],
              [-96.12462317599994, 66.97972239800004],
              [-96.11583411399994, 66.98834870000007],
              [-96.15001380099994, 66.99359772300005],
              [-96.22183183499993, 66.98371002800008],
              [-96.2598363919999, 66.99144114800004],
              [-96.28136145699995, 67.01117584800005],
              [-96.26463782499991, 67.04942454600007],
              [-96.28034420499995, 67.07025788000004],
              [-96.29824785099993, 67.07579173400006],
              [-96.3313695949999, 67.06989166900007],
              [-96.34923255099994, 67.07025788000004],
              [-96.36204993399991, 67.07721588700008],
              [-96.37677975199995, 67.08734772300005],
              [-96.39220130099994, 67.09332916900007],
              [-96.45425370999993, 67.06883372600004],
              [-96.45567786399994, 67.05975983300004],
              [-96.41685950399994, 67.02928294500003],
              [-96.40371660099993, 67.00116608300004],
              [-96.39761308499993, 66.99457428600005],
              [-96.30113684799994, 66.97492096600007],
              [-96.28184973899994, 66.95933665600006],
              [-96.2644750639999, 66.94122955900008],
              [-96.24673417899993, 66.92694733300004],
              [-96.21629798099991, 66.91583893400008],
              [-96.15274003799993, 66.90062083500004],
              [-96.12608801999994, 66.88218821800007],
              [-96.12018795499995, 66.87169017100007],
              [-96.11709550699993, 66.85040924700007],
              [-96.11241614499994, 66.84125397300005],
              [-96.09691321499992, 66.83063385600008],
              [-96.07848059799994, 66.82538483300004],
              [-96.05915279899995, 66.82200755400004],
              [-95.86416581899994, 66.76646556200006],
              [-95.85204016799992, 66.75812409100007],
              [-95.84634355399993, 66.75018952000005],
              [-95.83897864499994, 66.73322174700007],
              [-95.83153235599991, 66.72422923400006],
              [-95.79869544199994, 66.69696686400005],
              [-95.78538977799991, 66.68109772300005],
              [-95.78001868399991, 66.66246165600006],
              [-95.78335527299993, 66.63849518400008],
              [-95.79246985599991, 66.62299225500004],
              [-95.82095292899993, 66.59113190300008],
              [-95.79222571499992, 66.60203685100004],
              [-95.74071204299992, 66.64830149900007],
              [-95.71202551999994, 66.65875885600008],
              [-95.67674719999991, 66.66014232000003],
              [-95.66026770699995, 66.66327545800004],
              [-95.64346269399994, 66.66929759300007],
              [-95.6304418609999, 66.67938873900005],
              [-95.63048255099994, 66.68939850500004],
              [-95.64346269399994, 66.70722077000005],
              [-95.65501868399991, 66.73102448100008],
              [-95.66478430899991, 66.74144114800004],
              [-95.67760169199994, 66.74192942900004],
              [-95.68472245999993, 66.73212311400005],
              [-95.67178300699993, 66.70783112200007],
              [-95.6738988919999, 66.69696686400005],
              [-95.68691972599993, 66.68768952000005],
              [-95.7007543609999, 66.68256256700005],
              [-95.71572831899994, 66.68028392100007],
              [-95.73224850199995, 66.67987702000005],
              [-95.75438391799992, 66.68305084800005],
              [-95.76480058499993, 66.69127024900007],
              [-95.77326412699995, 66.71397532800006],
              [-95.79206295499995, 66.73704661700003],
              [-95.81383216099994, 66.74766673400006],
              [-95.83678137899994, 66.75604889500005],
              [-95.85920162699995, 66.77232493700006],
              [-95.89159094999991, 66.80552806200006],
              [-95.90953528599994, 66.81928131700005],
              [-95.93081620999993, 66.83067454600007],
              [-95.98314368399991, 66.84349192900004],
              [-95.99974524599992, 66.85114166900007],
              [-96.02867591099994, 66.88133372600004],
              [-96.03697669199994, 66.88593170800004],
              [-96.04743404899995, 66.88878001500007],
              [-96.07640540299991, 66.90314362200007],
              [-96.08507239499994, 66.90916575700004],
              [-96.09349524599992, 66.92023346600007],
              [-96.09203040299991, 66.92698802300004],
              [-96.06802324099993, 66.93992747600004],
              [-96.02847245999993, 66.95136139500005],
              [-95.9761449859999, 66.95392487200007],
              [-95.92418372299994, 66.94696686400005],
              [-95.88613847599993, 66.92999909100007],
              [-95.87144934799994, 66.92877838700008],
              [-95.82725989499994, 66.94354889500005],
              [-95.80797278599994, 66.94306061400005],
              [-95.79792232999995, 66.94013092700004],
              [-95.77594967399995, 66.93683502800008],
              [-95.76634680899991, 66.93309153900003],
              [-95.7630102199999, 66.92772044500003],
              [-95.75837154899995, 66.91132233300004],
              [-95.7527563139999, 66.90574778900003],
              [-95.73379472599993, 66.90306224200003],
              [-95.67015540299991, 66.91258372600004],
              [-95.57518469999991, 66.91258372600004],
              [-95.50670325399994, 66.90253327000005],
              [-95.48863684799994, 66.90916575700004],
              [-95.47321529899995, 66.92015208500004],
              [-95.4531957669999, 66.92829010600008],
              [-95.43130449099993, 66.93284739800004],
              [-95.41071529899995, 66.93309153900003],
              [-95.40807044199994, 66.92308177300004],
              [-95.38853919199994, 66.91205475500004],
              [-95.36290442599994, 66.90326569200005],
              [-95.3418676419999, 66.89960358300004],
              [-95.31631425699993, 66.90021393400008],
              [-95.29515540299991, 66.90399811400005],
              [-95.27501380099994, 66.91392649900007],
              [-95.25243079299992, 66.93309153900003],
              [-95.25332597599993, 66.94562409100007],
              [-95.24380449099993, 66.95587799700007],
              [-95.2183324859999, 66.97406647300005],
              [-95.2332250639999, 66.98969147300005],
              [-95.25527910099993, 66.99607982000003],
              [-95.27953040299991, 67.00023021000004],
              [-95.30089270699995, 67.00885651200008],
              [-95.29149329299992, 67.03119538000004],
              [-95.30483964799993, 67.04820384300007],
              [-95.34520423099991, 67.07396067900004],
              [-95.34813391799992, 67.08336009300007],
              [-95.34239661399994, 67.09223053600005],
              [-95.32445227799991, 67.10785553600005],
              [-95.3235570949999, 67.11717357000003],
              [-95.33193925699993, 67.12714264500005],
              [-95.34268144399994, 67.13682689000007],
              [-95.34862219999991, 67.14537181200006],
              [-95.34813391799992, 67.15269603100006],
              [-95.34373938699991, 67.15875885600008],
              [-95.28189042899993, 67.20184967700004],
              [-95.2766820949999, 67.20685455900008],
              [-95.26846269399994, 67.21124909100007],
              [-95.26309160099993, 67.22178782800006],
              [-95.26016191299993, 67.23432038000004],
              [-95.25926673099991, 67.24469635600008],
              [-95.25560462099992, 67.26227448100008],
              [-95.24547278599994, 67.26850006700005],
              [-95.21149654899995, 67.26951732000003],
              [-95.17284094999991, 67.27863190300008],
              [-95.1753637359999, 67.28961823100008],
              [-95.30211341099994, 67.32835521000004],
              [-95.33018958199995, 67.34345123900005],
              [-95.3418676419999, 67.36851634300007],
              [-95.34508216099994, 67.37921784100007],
              [-95.35903886599993, 67.39488353100006],
              [-95.36229407499991, 67.40232982000003],
              [-95.36359615799995, 67.41217682500007],
              [-95.37132727799991, 67.43915436400005],
              [-95.37596594999991, 67.44700755400004],
              [-95.39171301999994, 67.45368073100008],
              [-95.40587317599994, 67.45441315300008],
              [-95.41380774599992, 67.45661041900007],
              [-95.41071529899995, 67.46747467700004],
              [-95.39932206899994, 67.47797272300005],
              [-95.38003495999993, 67.48936595300006],
              [-95.35973059799994, 67.49848053600005],
              [-95.34520423099991, 67.50226471600007],
              [-95.32494055899991, 67.51080963700008],
              [-95.32526607999995, 67.53050364800004],
              [-95.33812415299991, 67.55223216400003],
              [-95.35545813699991, 67.56712474200003],
              [-95.43834387899994, 67.60382721600007],
              [-95.45173092399995, 67.61522044500003],
              [-95.46324622299994, 67.63934967700004],
              [-95.49079342399995, 67.64581940300008],
              [-95.52342688699991, 67.64716217700004],
              [-95.55040442599994, 67.65619538000004],
              [-95.57066809799994, 67.67182038000004],
              [-95.59215247299994, 67.68370189000007],
              [-95.61766516799992, 67.69135163000004],
              [-95.66356360599991, 67.69635651200008],
              [-95.68032792899993, 67.70250071800007],
              [-95.69570878799993, 67.71149323100008],
              [-95.70494544199994, 67.72199127800008],
              [-95.70767167899993, 67.73334381700005],
              [-95.70523027299993, 67.74144114800004],
              [-95.68785559799994, 67.75889720300006],
              [-95.67613684799994, 67.76544830900008],
              [-95.62922115799995, 67.77598704600007],
              [-95.62726803299995, 67.77936432500007],
              [-95.62930253799993, 67.78392161700003],
              [-95.62962805899991, 67.78790924700007],
              [-95.6223852199999, 67.78965892100007],
              [-95.58511308499993, 67.78965892100007],
              [-95.54548092399995, 67.80829498900005],
              [-95.52676347599993, 67.84845612200007],
              [-95.53652910099993, 67.88670482000003],
              [-95.58202063699991, 67.89952220300006],
              [-95.54548092399995, 67.93199290600006],
              [-95.52672278599994, 67.94419993700006],
              [-95.46519934799994, 67.97459544500003],
              [-95.45177161399994, 67.98871491100005],
              [-95.4448949859999, 68.00938548400006],
              [-95.43740800699993, 68.00938548400006],
              [-95.42174231699994, 68.01996491100005],
              [-95.42503821499992, 68.03070709800005],
              [-95.43297278599994, 68.04279205900008],
              [-95.4312231109999, 68.05719635600008],
              [-95.45616614499994, 68.05687083500004],
              [-95.4676000639999, 68.05866120000007],
              [-95.47838294199994, 68.06342194200005],
              [-95.45034745999993, 68.07176341400003],
              [-95.27293860599991, 68.07762278900003],
              [-95.24510657499991, 68.08445872600004],
              [-95.2317602199999, 68.08482493700006],
              [-95.2183324859999, 68.07762278900003],
              [-95.23350989499994, 68.06968821800007],
              [-95.24278723899994, 68.05711497600004],
              [-95.25352942599994, 68.04621002800008],
              [-95.27293860599991, 68.04291413000004],
              [-95.27293860599991, 68.03668854400007],
              [-95.22813880099994, 68.04564036700003],
              [-95.14167232999995, 68.08502838700008],
              [-95.09479732999995, 68.09129466400003],
              [-95.07994544199994, 68.08075592700004],
              [-95.03966223899994, 68.05524323100008],
              [-95.01227779899995, 68.05036041900007],
              [-94.95738684799994, 68.06037018400008],
              [-94.93126380099994, 68.06049225500004],
              [-94.90672766799992, 68.04661692900004],
              [-94.86099199099993, 68.03086985900006],
              [-94.79824785099993, 68.03807200700004],
              [-94.7383520169999, 68.05829498900005],
              [-94.70099850199995, 68.08136627800008],
              [-94.69615637899994, 68.08921946800007],
              [-94.69420325399994, 68.09617747600004],
              [-94.69139563699991, 68.10252513200004],
              [-94.68390865799995, 68.10838450700004],
              [-94.64830481699994, 68.12055084800005],
              [-94.56037350199995, 68.16331614800004],
              [-94.47459876199991, 68.18317291900007],
              [-94.46690833199995, 68.18903229400007],
              [-94.4597875639999, 68.19586823100008],
              [-94.45116126199991, 68.20115794500003],
              [-94.4036352199999, 68.21173737200007],
              [-94.38263912699995, 68.21979401200008],
              [-94.36856035099993, 68.23590729400007],
              [-94.36856035099993, 68.22846100500004],
              [-94.34093176999994, 68.24433014500005],
              [-94.24819902299993, 68.25877513200004],
              [-94.21092688699991, 68.26947663000004],
              [-94.19326738199993, 68.28868235900006],
              [-94.20091712099992, 68.30711497600004],
              [-94.21182206899994, 68.32721588700008],
              [-94.20409094999991, 68.35138580900008],
              [-94.21141516799992, 68.36387767100007],
              [-94.20299231699994, 68.37384674700007],
              [-94.17027747299994, 68.38922760600008],
              [-94.15892493399991, 68.39264557500007],
              [-94.14753170499995, 68.39439524900007],
              [-94.1387426419999, 68.39878978100006],
              [-94.13516191299993, 68.40973541900007],
              [-94.13141842399995, 68.41669342700004],
              [-94.1223852199999, 68.42234935100004],
              [-93.94977779899995, 68.47577545800004],
              [-93.7573949859999, 68.50596751500007],
              [-93.72398841099994, 68.52008698100008],
              [-93.68032792899993, 68.52525462400007],
              [-93.66136633999992, 68.53074778900003],
              [-93.62124589799993, 68.55064524900007],
              [-93.60464433499993, 68.55438873900005],
              [-93.56065833199995, 68.55841705900008],
              [-93.5462133449999, 68.56427643400008],
              [-93.5501195949999, 68.56720612200007],
              [-93.55516516799992, 68.57379791900007],
              [-93.55980383999992, 68.57855866100005],
              [-93.5462133449999, 68.57855866100005],
              [-93.54474850199995, 68.59723541900007],
              [-93.52375240799995, 68.60728587400007],
              [-93.44644120999993, 68.61485423400006],
              [-93.37486731699994, 68.63873932500007],
              [-93.39639238199993, 68.63292064000007],
              [-93.58031165299991, 68.61212799700007],
              [-93.6453344389999, 68.62579987200007],
              [-93.66974850199995, 68.62571849200003],
              [-93.73045813699991, 68.61180247600004],
              [-93.75226803299995, 68.61212799700007],
              [-93.75226803299995, 68.61949290600006],
              [-93.73631751199991, 68.63141510600008],
              [-93.72984778599994, 68.63837311400005],
              [-93.72492428299995, 68.64618561400005],
              [-93.72492428299995, 68.63873932500007],
              [-93.71068274599992, 68.65550364800004],
              [-93.70571855399993, 68.66461823100008],
              [-93.70189368399991, 68.68663157800006],
              [-93.69188391799992, 68.71088288000004],
              [-93.6792699859999, 68.73187897300005],
              [-93.68472245999993, 68.73725006700005],
              [-93.69399980399993, 68.74079010600008],
              [-93.69762122299994, 68.74860260600008],
              [-93.68761145699995, 68.76117584800005],
              [-93.65339107999995, 68.76422760600008],
              [-93.64240475199995, 68.77655670800004],
              [-93.65607662699995, 68.77655670800004],
              [-93.64053300699993, 68.78729889500005],
              [-93.63695227799991, 68.80414459800005],
              [-93.6218969389999, 68.81439850500004],
              [-93.58165442599994, 68.83148834800005],
              [-93.57066809799994, 68.84406159100007],
              [-93.57721920499995, 68.86216868700006],
              [-93.59288489499994, 68.87164948100008],
              [-93.63719641799992, 68.88776276200008],
              [-93.6492406889999, 68.89948151200008],
              [-93.64732825399994, 68.91559479400007],
              [-93.63914954299992, 68.92780182500007],
              [-93.63768469999991, 68.93614329600007],
              [-93.65607662699995, 68.94037506700005],
              [-93.64785722599993, 68.95270416900007],
              [-93.64273027299993, 68.95762767100007],
              [-93.63491777299993, 68.96214427300004],
              [-93.66075598899994, 68.97215403900003],
              [-93.68712317599994, 68.97142161700003],
              [-93.71336829299992, 68.96763743700006],
              [-93.73859615799995, 68.96832916900007],
              [-93.72874915299991, 68.97284577000005],
              [-93.72492428299995, 68.97516510600008],
              [-93.73643958199995, 68.97728099200003],
              [-93.77953040299991, 68.97516510600008],
              [-93.77208411399994, 68.97516510600008],
              [-93.79523678299995, 68.96735260600008],
              [-93.82701575399994, 68.96161530200004],
              [-93.85728919199994, 68.96259186400005],
              [-93.8758031889999, 68.97516510600008],
              [-93.86774654899995, 68.98578522300005],
              [-93.85724850199995, 68.99400462400007],
              [-93.84536699099993, 68.99974192900004],
              [-93.8335668609999, 69.00311920800004],
              [-93.8335668609999, 69.00934479400007],
              [-93.85366777299993, 69.00934479400007],
              [-93.8731176419999, 69.00641510600008],
              [-93.90929114499994, 68.99567291900007],
              [-93.89671790299991, 69.01756419500003],
              [-93.86554928299995, 69.03729889500005],
              [-93.80003821499992, 69.06456126500007],
              [-93.82713782499991, 69.06919993700006],
              [-93.86803137899994, 69.06114329600007],
              [-93.90908769399994, 69.04621002800008],
              [-93.93659420499995, 69.02977122600004],
              [-93.92821204299992, 69.03058502800008],
              [-93.90245520699995, 69.02977122600004],
              [-93.90245520699995, 69.02362702000005],
              [-93.9324438139999, 69.00653717700004],
              [-93.9434301419999, 69.00311920800004],
              [-93.93659420499995, 69.00311920800004],
              [-93.94424394399994, 69.00128815300008],
              [-93.94762122299994, 68.99970123900005],
              [-93.95083574099993, 68.99567291900007],
              [-93.94395911399994, 68.99278392100007],
              [-93.92983964799993, 68.98480866100005],
              [-93.92296301999994, 68.98200104400007],
              [-93.93342037699995, 68.97626373900005],
              [-93.95881100199995, 68.96576569200005],
              [-93.96393795499995, 68.95844147300005],
              [-93.9688207669999, 68.94745514500005],
              [-93.98037675699993, 68.94102610900006],
              [-94.00548255099994, 68.93419017100007],
              [-94.04458574099993, 68.91632721600007],
              [-94.06163489499994, 68.90326569200005],
              [-94.0738012359999, 68.88580963700008],
              [-94.06753495999993, 68.88580963700008],
              [-94.0698949859999, 68.87482330900008],
              [-94.06484941299993, 68.86749909100007],
              [-94.05435136599993, 68.86436595300006],
              [-94.04027258999992, 68.86591217700004],
              [-94.04987545499995, 68.86127350500004],
              [-94.08055579299992, 68.85228099200003],
              [-94.07091223899994, 68.84796784100007],
              [-94.0464574859999, 68.84003327000005],
              [-94.03652910099993, 68.83860911700003],
              [-94.02513587099992, 68.84076569200005],
              [-94.00816809799994, 68.85016510600008],
              [-93.97817949099993, 68.85834381700005],
              [-93.94395911399994, 68.88312409100007],
              [-93.92296301999994, 68.88580963700008],
              [-93.92296301999994, 68.87897370000007],
              [-93.92808997299994, 68.87437571800007],
              [-93.93101966099994, 68.87091705900008],
              [-93.9351293609999, 68.86823151200008],
              [-93.9434301419999, 68.86591217700004],
              [-93.9434301419999, 68.85846588700008],
              [-93.81309973899994, 68.89948151200008],
              [-93.8262426419999, 68.87933991100005],
              [-93.8589574859999, 68.86815013200004],
              [-93.89537512899994, 68.85997142100007],
              [-93.91982988199993, 68.84886302300004],
              [-93.94359290299991, 68.82977936400005],
              [-93.97777258999992, 68.81073639500005],
              [-94.01463782499991, 68.79608795800004],
              [-94.05915279899995, 68.78668854400007],
              [-94.08250891799992, 68.76935455900008],
              [-94.09422766799992, 68.76288483300004],
              [-94.10985266799992, 68.75910065300008],
              [-94.28294837099992, 68.75800202000005],
              [-94.41250566299993, 68.72300853100006],
              [-94.44635982999995, 68.73773834800005],
              [-94.46572831899994, 68.74339427300004],
              [-94.48155676999994, 68.73899974200003],
              [-94.49083411399994, 68.73045482000003],
              [-94.49852454299992, 68.72569407800006],
              [-94.5073949859999, 68.72508372600004],
              [-94.52000891799992, 68.72935618700006],
              [-94.53209387899994, 68.73810455900008],
              [-94.5425512359999, 68.74921295800004],
              [-94.55443274599992, 68.75885651200008],
              [-94.57091223899994, 68.76288483300004],
              [-94.63609778599994, 68.75604889500005],
              [-94.62254798099991, 68.77875397300005],
              [-94.60411536399994, 68.82444896000004],
              [-94.59142005099994, 68.84202708500004],
              [-94.55992591099994, 68.86314524900007],
              [-94.55357825399994, 68.87274811400005],
              [-94.55052649599992, 68.89073314000007],
              [-94.55768795499995, 68.89496491100005],
              [-94.57042395699995, 68.89573802300004],
              [-94.58429928299995, 68.90318431200006],
              [-94.58307857999995, 68.91258372600004],
              [-94.56676184799994, 68.93577708500004],
              [-94.57091223899994, 68.94037506700005],
              [-94.58633378799993, 68.94285716400003],
              [-94.59874426999994, 68.94928620000007],
              [-94.60496985599991, 68.95823802300004],
              [-94.60195878799993, 68.96832916900007],
              [-94.57119706899994, 68.98191966400003],
              [-94.53091386599993, 68.97728099200003],
              [-94.46475175699993, 68.95469798400006],
              [-94.46320553299995, 68.94171784100007],
              [-94.44298255099994, 68.94415924700007],
              [-94.41812089799993, 68.95380280200004],
              [-94.40269934799994, 68.96214427300004],
              [-94.39346269399994, 68.97260163000004],
              [-94.36856035099993, 69.00934479400007],
              [-94.34585527299993, 69.02582428600005],
              [-94.3198949859999, 69.03461334800005],
              [-94.29092363199993, 69.03766510600008],
              [-94.23159745999993, 69.03721751500007],
              [-94.20372473899994, 69.04087962400007],
              [-94.17617753799993, 69.04950592700004],
              [-94.14952551999994, 69.06456126500007],
              [-94.17784583199995, 69.07831452000005],
              [-94.18602454299992, 69.08592357000003],
              [-94.1836645169999, 69.09870026200008],
              [-94.17247473899994, 69.10785553600005],
              [-94.10765540299991, 69.12677643400008],
              [-94.07701575399994, 69.12946198100008],
              [-94.0523168609999, 69.14325592700004],
              [-94.00548255099994, 69.16014232000003],
              [-94.03868567599994, 69.15839264500005],
              [-94.13516191299993, 69.13279857000003],
              [-94.25283769399994, 69.12697988500008],
              [-94.30089270699995, 69.14350006700005],
              [-94.32404537699995, 69.15582916900007],
              [-94.32453365799995, 69.17072174700007],
              [-94.3133031889999, 69.18419017100007],
              [-94.29381262899994, 69.21344635600008],
              [-94.27985592399995, 69.22907135600008],
              [-94.28526770699995, 69.23371002800008],
              [-94.29491126199991, 69.24494049700007],
              [-94.30028235599991, 69.24949778900003],
              [-94.27912350199995, 69.26129791900007],
              [-94.25938880099994, 69.27680084800005],
              [-94.30117753799993, 69.29161204600007],
              [-94.31395423099991, 69.29791901200008],
              [-94.28164628799993, 69.32212962400007],
              [-94.23790442599994, 69.33649323100008],
              [-94.1145727199999, 69.34764232000003],
              [-94.02660071499992, 69.36619700700004],
              [-93.93040930899991, 69.36619700700004],
              [-93.91527258999992, 69.36302317900004],
              [-93.8941137359999, 69.34845612200007],
              [-93.88536536399994, 69.34507884300007],
              [-93.84618079299992, 69.34979889500005],
              [-93.81151282499991, 69.35948314000007],
              [-93.7945043609999, 69.36851634300007],
              [-93.7625219389999, 69.39691803600005],
              [-93.73916581899994, 69.40904368700006],
              [-93.61221269399994, 69.43956126500007],
              [-93.52570553299995, 69.44135163000004],
              [-93.54222571499992, 69.42902252800008],
              [-93.59561113199993, 69.39935944200005],
              [-93.63011633999992, 69.39024485900006],
              [-93.64305579299992, 69.38239166900007],
              [-93.66592363199993, 69.36277903900003],
              [-93.6785375639999, 69.35468170800004],
              [-93.6909887359999, 69.35130442900004],
              [-93.70384680899991, 69.34931061400005],
              [-93.71743730399993, 69.34507884300007],
              [-93.78661048099991, 69.31500885600008],
              [-93.80996660099993, 69.31098053600005],
              [-93.88194739499994, 69.24949778900003],
              [-93.86050370999993, 69.25010814000007],
              [-93.83153235599991, 69.26561107000003],
              [-93.81309973899994, 69.27000560100004],
              [-93.84434973899994, 69.24253978100006],
              [-93.86217200399994, 69.23289622600004],
              [-93.88194739499994, 69.22907135600008],
              [-93.86827551999994, 69.21808502800008],
              [-93.85118567599994, 69.21763743700006],
              [-93.83226477799991, 69.22113678600005],
              [-93.81309973899994, 69.22215403900003],
              [-93.81309973899994, 69.21539948100008],
              [-93.83853105399993, 69.19835032800006],
              [-93.85155188699991, 69.18610260600008],
              [-93.85407467399995, 69.17442454600007],
              [-93.84032141799992, 69.16868724200003],
              [-93.81859290299991, 69.17523834800005],
              [-93.79678300699993, 69.18732330900008],
              [-93.78262285099993, 69.19798411700003],
              [-93.76032467399995, 69.21067942900004],
              [-93.70335852799991, 69.22540924700007],
              [-93.66502844999991, 69.24884674700007],
              [-93.60757402299993, 69.27000560100004],
              [-93.61754309799994, 69.27545807500007],
              [-93.62677975199995, 69.27488841400003],
              [-93.63508053299995, 69.27012767100007],
              [-93.64240475199995, 69.26312897300005],
              [-93.64240475199995, 69.27000560100004],
              [-93.62092037699995, 69.27757396000004],
              [-93.57957923099991, 69.29954661700003],
              [-93.48643958199995, 69.31879303600005],
              [-93.45360266799992, 69.33213939000007],
              [-93.45059160099993, 69.34507884300007],
              [-93.4343969389999, 69.35679759300007],
              [-93.36188717399995, 69.37299225500004],
              [-93.38585364499994, 69.37962474200003],
              [-93.47789466099994, 69.35936107000003],
              [-93.50625566299993, 69.36017487200007],
              [-93.55565344999991, 69.36994049700007],
              [-93.58775794199994, 69.36619700700004],
              [-93.58047441299993, 69.37702057500007],
              [-93.52635657499991, 69.42247142100007],
              [-93.49254309799994, 69.44061920800004],
              [-93.47789466099994, 69.45433177300004],
              [-93.48159745999993, 69.45758698100008],
              [-93.48473059799994, 69.46177806200006],
              [-93.46129309799994, 69.46869538000004],
              [-93.45083574099993, 69.47382233300004],
              [-93.44310462099992, 69.48224518400008],
              [-93.45059160099993, 69.48969147300005],
              [-93.45982825399994, 69.48456452000005],
              [-93.4688207669999, 69.48261139500005],
              [-93.47716223899994, 69.48419830900008],
              [-93.48473059799994, 69.48969147300005],
              [-93.48355058499993, 69.50214264500005],
              [-93.50584876199991, 69.51557038000004],
              [-93.53587805899991, 69.52631256700005],
              [-93.55797278599994, 69.53070709800005],
              [-93.69017493399991, 69.52326080900008],
              [-93.68394934799994, 69.52326080900008],
              [-93.7610570949999, 69.49957916900007],
              [-93.78750566299993, 69.48545970300006],
              [-93.80345618399991, 69.48224518400008],
              [-93.80630449099993, 69.48436107000003],
              [-93.81143144399994, 69.49371979400007],
              [-93.81309973899994, 69.49591705900008],
              [-93.82530676999994, 69.49583567900004],
              [-93.87279212099992, 69.48651764500005],
              [-93.8801977199999, 69.47821686400005],
              [-93.87901770699995, 69.46686432500007],
              [-93.86831620999993, 69.45433177300004],
              [-93.89757239499994, 69.43931712400007],
              [-93.93040930899991, 69.43541087400007],
              [-93.99864661399994, 69.44135163000004],
              [-94.14952551999994, 69.43451569200005],
              [-94.32217363199993, 69.45298899900007],
              [-94.3438207669999, 69.46519603100006],
              [-94.38223222599993, 69.49591705900008],
              [-94.39858964799993, 69.50299713700008],
              [-94.43203691299993, 69.51146067900004],
              [-94.44737708199995, 69.52012767100007],
              [-94.52171790299991, 69.57591380400004],
              [-94.52794348899994, 69.59613678600005],
              [-94.53307044199994, 69.60264720300006],
              [-94.54393469999991, 69.61115143400008],
              [-94.55003821499992, 69.62181224200003],
              [-94.55455481699994, 69.63239166900007],
              [-94.56102454299992, 69.64057038000004],
              [-94.57152258999992, 69.64549388200004],
              [-94.58511308499993, 69.64817942900004],
              [-94.59691321499992, 69.64610423400006],
              [-94.60195878799993, 69.63682689000007],
              [-94.60684160099993, 69.63279857000003],
              [-94.6179906889999, 69.63788483300004],
              [-94.62954667899993, 69.64683665600006],
              [-94.63609778599994, 69.65416087400007],
              [-94.63744055899991, 69.66246165600006],
              [-94.63589433499993, 69.67182038000004],
              [-94.62987219999991, 69.68773021000004],
              [-94.74535071499992, 69.66783274900007],
              [-94.76431230399993, 69.66168854400007],
              [-94.76024329299992, 69.64732493700006],
              [-94.7434789699999, 69.63108958500004],
              [-94.72423255099994, 69.61945221600007],
              [-94.74575761599993, 69.59434642100007],
              [-94.78868567599994, 69.57819245000007],
              [-94.83706620999993, 69.57062409100007],
              [-94.87511145699995, 69.57164134300007],
              [-94.95287024599992, 69.58905670800004],
              [-94.96507727799991, 69.59589264500005],
              [-94.97118079299992, 69.60919830900008],
              [-94.98534094999991, 69.61192454600007],
              [-95.00112870999993, 69.60911692900004],
              [-95.01227779899995, 69.60578034100007],
              [-94.99917558499993, 69.61945221600007],
              [-95.02476966099994, 69.62677643400008],
              [-95.11900794199994, 69.61945221600007],
              [-95.13158118399991, 69.62103913000004],
              [-95.16392981699994, 69.63080475500004],
              [-95.18480383999992, 69.64496491100005],
              [-95.19749915299991, 69.64704010600008],
              [-95.22516842399995, 69.64671458500004],
              [-95.41051184799994, 69.68589915600006],
              [-95.43895423099991, 69.69920482000003],
              [-95.47988847599993, 69.70734284100007],
              [-95.53823808499993, 69.73078034100007],
              [-95.56773841099994, 69.73615143400008],
              [-95.58678137899994, 69.74217357000003],
              [-95.65029863199993, 69.78388092700004],
              [-95.66905676999994, 69.78843821800007],
              [-95.73595130099994, 69.79075755400004],
              [-95.75104732999995, 69.78538646000004],
              [-95.76227779899995, 69.77244700700004],
              [-95.77306067599994, 69.75678131700005],
              [-95.78685462099992, 69.74298737200007],
              [-95.80890865799995, 69.75360748900005],
              [-95.81932532499991, 69.76093170800004],
              [-95.82787024599992, 69.77024974200003],
              [-95.81200110599991, 69.78709544500003],
              [-95.80182857999995, 69.79169342700004],
              [-95.78685462099992, 69.79075755400004],
              [-95.80748450399994, 69.80341217700004],
              [-95.83006751199991, 69.80780670800004],
              [-95.84825598899994, 69.80109284100007],
              [-95.85578365799995, 69.78050364800004],
              [-95.86900794199994, 69.77716705900008],
              [-95.93163001199991, 69.79185618700006],
              [-95.9519750639999, 69.79075755400004],
              [-95.94448808499993, 69.78388092700004],
              [-95.9759008449999, 69.78620026200008],
              [-96.00389563699991, 69.79804108300004],
              [-96.05435136599993, 69.83234284100007],
              [-96.08682206899994, 69.84629954600007],
              [-96.20579993399991, 69.86583079600007],
              [-96.18651282499991, 69.86790599200003],
              [-96.15689042899993, 69.88397858300004],
              [-96.14378821499992, 69.88324616100005],
              [-96.11343339799993, 69.86664459800005],
              [-96.09850012899994, 69.86692942900004],
              [-96.08165442599994, 69.87950267100007],
              [-96.1030981109999, 69.88878001500007],
              [-96.12267005099994, 69.90062083500004],
              [-96.08849036399994, 69.91425202000005],
              [-96.08849036399994, 69.92047760600008],
              [-96.10692298099991, 69.92011139500005],
              [-96.10977128799993, 69.92572663000004],
              [-96.10545813699991, 69.93488190300008],
              [-96.10216223899994, 69.94529857000003],
              [-96.11009680899991, 69.95652903900003],
              [-96.12828528599994, 69.96067942900004],
              [-96.14810136599993, 69.96226634300007],
              [-96.16079667899993, 69.96613190300008],
              [-96.17487545499995, 69.97223541900007],
              [-96.1914770169999, 69.97040436400005],
              [-96.22227942599994, 69.96271393400008],
              [-96.24128170499995, 69.96478913000004],
              [-96.25641842399995, 69.97028229400007],
              [-96.48631751199991, 70.09699127800008],
              [-96.51366126199991, 70.12034739800004],
              [-96.52594967399995, 70.12681712400007],
              [-96.53189042899993, 70.13617584800005],
              [-96.5340063139999, 70.14862702000005],
              [-96.53416907499991, 70.16437409100007],
              [-96.53774980399993, 70.17393626500007],
              [-96.56493079299992, 70.21222565300008],
              [-96.57371985599991, 70.23444245000007],
              [-96.56151282499991, 70.31525299700007],
              [-96.54600989499994, 70.34056224200003],
              [-96.51060950399994, 70.36839427300004],
              [-96.44481360599991, 70.40770091400003],
              [-96.42259680899991, 70.41474030200004],
              [-96.40339107999995, 70.41266510600008],
              [-96.38418535099993, 70.40806712400007],
              [-96.36221269399994, 70.40770091400003],
              [-96.34707597599993, 70.41412995000007],
              [-96.33779863199993, 70.42499420800004],
              [-96.32872473899994, 70.44871653900003],
              [-96.33433997299994, 70.48688385600008],
              [-96.30247962099992, 70.51911041900007],
              [-96.25967363199993, 70.54682038000004],
              [-96.23298092399995, 70.57119375200006],
              [-96.22720292899993, 70.57103099200003],
              [-96.21873938699991, 70.56163157800006],
              [-96.21401933499993, 70.54889557500007],
              [-96.20579993399991, 70.53807200700004],
              [-96.18887285099993, 70.53221263200004],
              [-96.17105058499993, 70.53355540600006],
              [-96.13687089799993, 70.54486725500004],
              [-96.14415442599994, 70.56403229400007],
              [-96.12604732999995, 70.57916901200008],
              [-96.09776770699995, 70.58909739800004],
              [-96.07485917899993, 70.59271881700005],
              [-96.04743404899995, 70.58734772300005],
              [-95.99522864499994, 70.56391022300005],
              [-95.85293535099993, 70.53888580900008],
              [-95.81480872299994, 70.53807200700004],
              [-95.80992591099994, 70.53607819200005],
              [-95.80451412699995, 70.53217194200005],
              [-95.79893958199995, 70.53123607000003],
              [-95.79369055899991, 70.53807200700004],
              [-95.79344641799992, 70.54413483300004],
              [-95.79698645699995, 70.54832591400003],
              [-95.80239824099993, 70.55088939000007],
              [-95.91771399599992, 70.56281159100007],
              [-95.95815995999993, 70.57160065300008],
              [-96.00328528599994, 70.58995189000007],
              [-96.04352779899995, 70.59650299700007],
              [-96.05394446499992, 70.60704173400006],
              [-96.05532792899993, 70.62335846600007],
              [-96.05435136599993, 70.64423248900005],
              [-95.95881100199995, 70.68146393400008],
              [-95.94188391799992, 70.68296946800007],
              [-95.89891516799992, 70.69261302300004],
              [-95.86554928299995, 70.70502350500004],
              [-95.83055579299992, 70.70958079600007],
              [-95.81480872299994, 70.71556224200003],
              [-95.90355383999992, 70.70933665600006],
              [-96.12254798099991, 70.65643952000005],
              [-96.14085852799991, 70.64704010600008],
              [-96.15737870999993, 70.63365306200006],
              [-96.15054277299993, 70.63365306200006],
              [-96.19033769399994, 70.62474192900004],
              [-96.26732337099992, 70.63963450700004],
              [-96.34764563699991, 70.66539134300007],
              [-96.39761308499993, 70.68891022300005],
              [-96.41515051999994, 70.70661041900007],
              [-96.42686926999994, 70.72357819200005],
              [-96.4409887359999, 70.73859284100007],
              [-96.46524003799993, 70.75035228100006],
              [-96.57335364499994, 70.77403392100007],
              [-96.60244706899994, 70.79132721600007],
              [-96.61644446499992, 70.82575104400007],
              [-96.59862219999991, 70.85993073100008],
              [-96.53758704299992, 70.91791413000004],
              [-96.52782141799992, 70.93183014500005],
              [-96.50690670499995, 70.98309967700004],
              [-96.50609290299991, 70.98676178600005],
              [-96.50690670499995, 71.00047435100004],
              [-96.50495357999995, 71.00385163000004],
              [-96.49608313699991, 71.00653717700004],
              [-96.49323482999995, 71.01105377800008],
              [-96.48753821499992, 71.02850983300004],
              [-96.4895727199999, 71.03620026200008],
              [-96.49998938699991, 71.04515208500004],
              [-96.46812903599994, 71.04535553600005],
              [-96.43984941299993, 71.05223216400003],
              [-96.41515051999994, 71.06492747600004],
              [-96.38292395699995, 71.09100983300004],
              [-96.37767493399991, 71.09247467700004],
              [-96.37604732999995, 71.09410228100006],
              [-96.37588456899994, 71.10289134300007],
              [-96.40294348899994, 71.11461009300007],
              [-96.41063391799992, 71.11969635600008],
              [-96.4180395169999, 71.11823151200008],
              [-96.42113196499992, 71.11664459800005],
              [-96.42430579299992, 71.11347077000005],
              [-96.41038977799991, 71.09784577000005],
              [-96.41966712099992, 71.08970774900007],
              [-96.43993079299992, 71.08661530200004],
              [-96.45872962099992, 71.08612702000005],
              [-96.48692786399994, 71.09162018400008],
              [-96.53526770699995, 71.11790599200003],
              [-96.56151282499991, 71.12706126500007],
              [-96.55679277299993, 71.13951243700006],
              [-96.54898027299993, 71.14415110900006],
              [-96.52672278599994, 71.14756907800006],
              [-96.45872962099992, 71.17145416900007],
              [-96.43834387899994, 71.16905345300006],
              [-96.41315670499995, 71.15582916900007],
              [-96.39000403599994, 71.14777252800008],
              [-96.37588456899994, 71.16058991100005],
              [-96.44619706899994, 71.18622467700004],
              [-96.45909583199995, 71.19537995000007],
              [-96.45799719999991, 71.20929596600007],
              [-96.45006262899994, 71.22996653900003],
              [-96.43114173099991, 71.26426829600007],
              [-96.44371497299994, 71.26386139500005],
              [-96.47956295499995, 71.25743235900006],
              [-96.47207597599993, 71.26426829600007],
              [-96.48029537699995, 71.26984284100007],
              [-96.48867753799993, 71.27399323100008],
              [-96.49754798099991, 71.27667877800008],
              [-96.50690670499995, 71.27789948100008],
              [-96.48224850199995, 71.29234446800007],
              [-96.44709225199995, 71.29893626500007],
              [-96.32664954299992, 71.29828522300005],
              [-96.30553137899994, 71.30329010600008],
              [-96.28034420499995, 71.31268952000005],
              [-96.28774980399993, 71.31891510600008],
              [-96.2683813139999, 71.34166087400007],
              [-96.24136308499993, 71.36558665600006],
              [-96.2117406889999, 71.38678620000007],
              [-96.18407141799992, 71.40143463700008],
              [-96.13353430899991, 71.41417064000007],
              [-95.9858699209999, 71.41506582200003],
              [-95.92442786399994, 71.40403880400004],
              [-95.89557857999995, 71.39390696800007],
              [-95.87621008999992, 71.37413157800006],
              [-95.88243567599994, 71.37413157800006],
              [-95.83975175699993, 71.35077545800004],
              [-95.65831458199995, 71.29148997600004],
              [-95.63272050699993, 71.28974030200004],
              [-95.60875403599994, 71.29535553600005],
              [-95.58592688699991, 71.29669830900008],
              [-95.55675208199995, 71.29389069200005],
              [-95.5364477199999, 71.29608795800004],
              [-95.54043535099993, 71.31268952000005],
              [-95.5352270169999, 71.31574127800008],
              [-95.52635657499991, 71.32269928600005],
              [-95.51935787699995, 71.32575104400007],
              [-95.53726152299993, 71.33612702000005],
              [-95.57701575399994, 71.34601471600007],
              [-95.58824622299994, 71.36045970300006],
              [-95.47215735599991, 71.36045970300006],
              [-95.4761449859999, 71.37030670800004],
              [-95.47838294199994, 71.37413157800006],
              [-95.43740800699993, 71.37413157800006],
              [-95.43740800699993, 71.38031647300005],
              [-95.4597875639999, 71.38292064000007],
              [-95.4832250639999, 71.38886139500005],
              [-95.50609290299991, 71.39732493700006],
              [-95.52676347599993, 71.40766022300005],
              [-95.54865475199995, 71.42243073100008],
              [-95.5462133449999, 71.42772044500003],
              [-95.53404700399994, 71.43248118700006],
              [-95.52037512899994, 71.45477936400005],
              [-95.50568600199995, 71.45848216400003],
              [-95.48940995999993, 71.45990631700005],
              [-95.47838294199994, 71.46222565300008],
              [-95.46471106699994, 71.46971263200004],
              [-95.4641820949999, 71.47239817900004],
              [-95.46540279899995, 71.48139069200005],
              [-95.46471106699994, 71.48399485900006],
              [-95.44347083199995, 71.49335358300004],
              [-95.37596594999991, 71.51068756700005],
              [-95.44054114499994, 71.50718821800007],
              [-95.47638912699995, 71.50010814000007],
              [-95.49205481699994, 71.48712799700007],
              [-95.62800045499995, 71.49384186400005],
              [-95.66026770699995, 71.50043366100005],
              [-95.68838456899994, 71.50962962400007],
              [-95.80736243399991, 71.51068756700005],
              [-95.82331295499995, 71.51630280200004],
              [-95.8626195949999, 71.53864166900007],
              [-95.88219153599994, 71.54393138200004],
              [-95.92442786399994, 71.54759349200003],
              [-95.94448808499993, 71.55223216400003],
              [-95.93040930899991, 71.57054271000004],
              [-95.88780676999994, 71.58018626500007],
              [-95.87621008999992, 71.59324778900003],
              [-95.88760331899994, 71.59214915600006],
              [-95.89753170499995, 71.59393952000005],
              [-95.90534420499995, 71.59874095300006],
              [-95.91038977799991, 71.60687897300005],
              [-95.88329016799992, 71.61815013200004],
              [-95.84642493399991, 71.62702057500007],
              [-95.77660071499992, 71.63483307500007],
              [-95.74054928299995, 71.63231028900003],
              [-95.72516842399995, 71.63373444200005],
              [-95.67861894399994, 71.65241120000007],
              [-95.67174231699994, 71.65965403900003],
              [-95.67760169199994, 71.66832103100006],
              [-95.66380774599992, 71.67377350500004],
              [-95.64928137899994, 71.67560455900008],
              [-95.61925208199995, 71.67515696800007],
              [-95.60985266799992, 71.67845286700003],
              [-95.59129798099991, 71.69297923400006],
              [-95.58141028599994, 71.69627513200004],
              [-95.55858313699991, 71.70030345300006],
              [-95.51500403599994, 71.71845123900005],
              [-95.49205481699994, 71.72296784100007],
              [-95.30199133999992, 71.72052643400008],
              [-95.27721106699994, 71.72431061400005],
              [-95.25926673099991, 71.73725006700005],
              [-95.27965247299994, 71.74217357000003],
              [-95.28823808499993, 71.75189850500004],
              [-95.28766842399995, 71.76447174700007],
              [-95.28038489499994, 71.77818431200006],
              [-95.27501380099994, 71.78339264500005],
              [-95.26008053299995, 71.79246653900003],
              [-95.25243079299992, 71.79869212400007],
              [-95.23875891799992, 71.81976959800005],
              [-95.21605383999992, 71.82953522300005],
              [-95.13573157499991, 71.83283112200007],
              [-95.08307857999995, 71.84540436400005],
              [-95.06436113199993, 71.84711334800005],
              [-95.02481035099993, 71.84076569200005],
              [-95.01439368399991, 71.84162018400008],
              [-94.98558508999992, 71.84764232000003],
              [-94.83470618399991, 71.84235260600008],
              [-94.78693600199995, 71.83283112200007],
              [-94.74071204299992, 71.82929108300004],
              [-94.69481360599991, 71.83563873900005],
              [-94.65025794199994, 71.84931061400005],
              [-94.60814368399991, 71.86762116100005],
              [-94.64098059799994, 71.87335846600007],
              [-94.75902258999992, 71.83966705900008],
              [-94.77782141799992, 71.84141673400006],
              [-94.81501217399995, 71.85106028900003],
              [-95.10167395699995, 71.86082591400003],
              [-95.15001380099994, 71.85020579600007],
              [-95.17870032499991, 71.84715403900003],
              [-95.21654212099992, 71.85272858300004],
              [-95.24669348899994, 71.86298248900005],
              [-95.25454667899993, 71.87921784100007],
              [-95.25047766799992, 71.88287995000007],
              [-95.24229895699995, 71.88580963700008],
              [-95.2320043609999, 71.88804759300007],
              [-95.2320043609999, 71.89423248900005],
              [-95.23989824099993, 71.89533112200007],
              [-95.25926673099991, 71.90167877800008],
              [-95.24665279899995, 71.90684642100007],
              [-95.21149654899995, 71.92902252800008],
              [-95.21458899599992, 71.93321360900006],
              [-95.21629798099991, 71.93671295800004],
              [-95.21898352799991, 71.93980540600006],
              [-95.22516842399995, 71.94269440300008],
              [-95.22516842399995, 71.94953034100007],
              [-94.88693193299994, 71.97583649300006],
              [-94.54869544199994, 72.00214264500005],
              [-94.49201412699995, 71.99042389500005],
              [-94.48688717399995, 71.98529694200005],
              [-94.48525956899994, 71.97308991100005],
              [-94.48204505099994, 71.96137116100005],
              [-94.47350012899994, 71.95600006700005],
              [-94.4043676419999, 71.94586823100008],
              [-94.39342200399994, 71.93931712400007],
              [-94.40269934799994, 71.92222728100006],
              [-94.42446855399993, 71.90953196800007],
              [-94.45148678299995, 71.90619538000004],
              [-94.4798070949999, 71.90570709800005],
              [-94.50572669199994, 71.90167877800008],
              [-94.48790442599994, 71.89655182500007],
              [-94.4676000639999, 71.89341868700006],
              [-94.4527074859999, 71.88593170800004],
              [-94.45116126199991, 71.86762116100005],
              [-94.46031653599994, 71.85740794500003],
              [-94.47655188699991, 71.85337962400007],
              [-94.55138098899994, 71.85053131700005],
              [-94.58608964799993, 71.84300364800004],
              [-94.64915930899991, 71.81976959800005],
              [-94.61375891799992, 71.79621002800008],
              [-94.60753333199995, 71.78314850500004],
              [-94.62242591099994, 71.76459381700005],
              [-94.61558997299994, 71.76459381700005],
              [-94.61754309799994, 71.75621165600006],
              [-94.61359615799995, 71.75067780200004],
              [-94.6055395169999, 71.74689362200007],
              [-94.59512285099993, 71.74347565300008],
              [-94.55284583199995, 71.76146067900004],
              [-94.53990637899994, 71.77134837400007],
              [-94.50841223899994, 71.81342194200005],
              [-94.50035559799994, 71.82139720300006],
              [-94.49209550699993, 71.82599518400008],
              [-94.47704016799992, 71.82648346600007],
              [-94.46524003799993, 71.82111237200007],
              [-94.46007239499994, 71.81134674700007],
              [-94.46475175699993, 71.79869212400007],
              [-94.44701087099992, 71.79071686400005],
              [-94.43724524599992, 71.79649485900006],
              [-94.43000240799995, 71.80683014500005],
              [-94.41978919199994, 71.81232330900008],
              [-94.38805091099994, 71.81159088700008],
              [-94.3738500639999, 71.80760325700004],
              [-94.35488847599993, 71.79869212400007],
              [-94.36131751199991, 71.79234446800007],
              [-94.36856035099993, 71.78790924700007],
              [-94.37657630099994, 71.78526439000007],
              [-94.38536536399994, 71.78436920800004],
              [-94.38792883999992, 71.78245677300004],
              [-94.38980058499993, 71.77240631700005],
              [-94.3921606109999, 71.76793040600006],
              [-94.39956620999993, 71.75702545800004],
              [-94.3999731109999, 71.74571360900006],
              [-94.39549719999991, 71.73436107000003],
              [-94.38841712099992, 71.72296784100007],
              [-94.41051184799994, 71.68305084800005],
              [-94.41551673099991, 71.66547272300005],
              [-94.40306555899991, 71.66490306200006],
              [-94.28229732999995, 71.73607005400004],
              [-94.2656957669999, 71.74925364800004],
              [-94.2351781889999, 71.78131745000007],
              [-94.21076412699995, 71.79230377800008],
              [-94.18073482999995, 71.79254791900007],
              [-94.15990149599992, 71.78294505400004],
              [-94.16315670499995, 71.76459381700005],
              [-94.12181555899991, 71.76044342700004],
              [-94.05406653599994, 71.78917064000007],
              [-94.01231848899994, 71.77818431200006],
              [-93.98814856699994, 71.75885651200008],
              [-93.97443600199995, 71.75311920800004],
              [-93.95055091099994, 71.75092194200005],
              [-93.89736894399994, 71.75299713700008],
              [-93.87218176999994, 71.75804271000004],
              [-93.84752356699994, 71.76793040600006],
              [-93.80882727799991, 71.77891673400006],
              [-93.76121985599991, 71.77928294500003],
              [-93.72085527299993, 71.76532623900005],
              [-93.70384680899991, 71.73346588700008],
              [-93.70677649599992, 71.71552155200004],
              [-93.71568762899994, 71.70490143400008],
              [-93.82054602799991, 71.65534088700008],
              [-93.80406653599994, 71.64647044500003],
              [-93.73546301999994, 71.62811920800004],
              [-93.63499915299991, 71.57953522300005],
              [-93.54474850199995, 71.55390045800004],
              [-93.41974850199995, 71.53583405200004],
              [-93.39537512899994, 71.52806224200003],
              [-93.37962805899991, 71.51850006700005],
              [-93.36998450399994, 71.50958893400008],
              [-93.35920162699995, 71.50214264500005],
              [-93.25706946499992, 71.48371002800008],
              [-93.21556555899991, 71.46910228100006],
              [-93.2110082669999, 71.44859446800007],
              [-93.19908606699994, 71.44623444200005],
              [-93.19444739499994, 71.44208405200004],
              [-93.19286048099991, 71.43634674700007],
              [-93.18993079299992, 71.42877838700008],
              [-93.18887285099993, 71.42487213700008],
              [-93.18927975199995, 71.42100657800006],
              [-93.18814042899993, 71.41571686400005],
              [-93.18309485599991, 71.40766022300005],
              [-93.16787675699993, 71.39402903900003],
              [-93.14854895699995, 71.38340892100007],
              [-93.12767493399991, 71.37657298400006],
              [-93.04710852799991, 71.37201569200005],
              [-93.01781165299991, 71.36692942900004],
              [-92.99063066299993, 71.35712311400005],
              [-92.98013261599993, 71.34735748900005],
              [-92.98110917899993, 71.33698151200008],
              [-92.98863684799994, 71.32713450700004],
              [-92.99746660099993, 71.31891510600008],
              [-92.95958411399994, 71.30646393400008],
              [-92.94786536399994, 71.29490794500003],
              [-92.94009355399993, 71.25873444200005],
              [-92.93399003799993, 71.24689362200007],
              [-92.93101966099994, 71.23594798400006],
              [-92.93724524599992, 71.22333405200004],
              [-92.88292395699995, 71.18903229400007],
              [-92.86839758999992, 71.17487213700008],
              [-92.8587133449999, 71.15863678600005],
              [-92.8587133449999, 71.14976634300007],
              [-92.86343339799993, 71.14154694200005],
              [-92.86839758999992, 71.12706126500007],
              [-92.86774654899995, 71.11920807500007],
              [-92.86107337099992, 71.11090729400007],
              [-92.86095130099994, 71.10602448100008],
              [-92.86497962099992, 71.10101959800005],
              [-92.87730872299994, 71.09288157800006],
              [-92.88198808499993, 71.08612702000005],
              [-92.88621985599991, 71.07066478100006],
              [-92.88247636599993, 71.06321849200003],
              [-92.85411536399994, 71.04515208500004],
              [-92.87889563699991, 71.02012767100007],
              [-92.88866126199991, 71.00690338700008],
              [-92.89509029899995, 70.99054596600007],
              [-92.90217037699995, 70.94330475500004],
              [-92.90933183499993, 70.92784251500007],
              [-92.9019262359999, 70.92169830900008],
              [-92.90770423099991, 70.90204498900005],
              [-92.89639238199993, 70.88401927300004],
              [-92.87584387899994, 70.86933014500005],
              [-92.85411536399994, 70.85960521000004],
              [-92.86904863199993, 70.85370514500005],
              [-92.91283118399991, 70.84678782800006],
              [-92.93822180899991, 70.84605540600006],
              [-92.94277910099993, 70.84678782800006],
              [-93.00023352799991, 70.87266673400006],
              [-93.02525794199994, 70.87982819200005],
              [-93.05272376199991, 70.88068268400008],
              [-93.04084225199995, 70.86237213700008],
              [-93.02147376199991, 70.84910716400003],
              [-92.94587154899995, 70.81745026200008],
              [-92.82017981699994, 70.80992259300007],
              [-92.76813717399995, 70.79783763200004],
              [-92.74425208199995, 70.78790924700007],
              [-92.6929418609999, 70.77464427300004],
              [-92.67520097599993, 70.76557038000004],
              [-92.69587154899995, 70.75779857000003],
              [-92.69115149599992, 70.74925364800004],
              [-92.68358313699991, 70.74420807500007],
              [-92.67381751199991, 70.74237702000005],
              [-92.66226152299993, 70.74351634300007],
              [-92.66226152299993, 70.73602936400005],
              [-92.71751868399991, 70.72984446800007],
              [-92.71751868399991, 70.72300853100006],
              [-92.67471269399994, 70.72455475500004],
              [-92.65453040299991, 70.72081126500007],
              [-92.64183508999992, 70.70933665600006],
              [-92.6551000639999, 70.70758698100008],
              [-92.66779537699995, 70.70270416900007],
              [-92.6902563139999, 70.68891022300005],
              [-92.65550696499992, 70.68891022300005],
              [-92.6765844389999, 70.68146393400008],
              [-92.6621801419999, 70.67865631700005],
              [-92.61449133999992, 70.68891022300005],
              [-92.41588294199994, 70.66779205900008],
              [-92.41779537699995, 70.66412995000007],
              [-92.41856848899994, 70.66327545800004],
              [-92.41954505099994, 70.66294993700006],
              [-92.42210852799991, 70.66095612200007],
              [-92.40689042899993, 70.65485260600008],
              [-92.35387122299994, 70.64793528900003],
              [-92.31395423099991, 70.63556549700007],
              [-92.30260169199994, 70.63365306200006],
              [-92.29991614499994, 70.62714264500005],
              [-92.30357825399994, 70.61351146000004],
              [-92.31615149599992, 70.60142649900007],
              [-92.34019934799994, 70.59947337400007],
              [-92.32921301999994, 70.58161041900007],
              [-92.30329342399995, 70.57335032800006],
              [-92.27700761599993, 70.58075592700004],
              [-92.26504472599993, 70.60972728100006],
              [-92.24990800699993, 70.62535228100006],
              [-92.21544348899994, 70.61627838700008],
              [-92.17829342399995, 70.59629954600007],
              [-92.15518144399994, 70.57904694200005],
              [-92.17662512899994, 70.57298411700003],
              [-92.20555579299992, 70.57176341400003],
              [-92.23314368399991, 70.57416413000004],
              [-92.2508031889999, 70.57904694200005],
              [-92.24461829299992, 70.57160065300008],
              [-92.25658118399991, 70.56578196800007],
              [-92.26244055899991, 70.55805084800005],
              [-92.26089433499993, 70.54865143400008],
              [-92.2508031889999, 70.53807200700004],
              [-92.23936926999994, 70.53412506700005],
              [-92.2278539699999, 70.53497955900008],
              [-92.21568762899994, 70.53379954600007],
              [-92.20238196499992, 70.52378978100006],
              [-92.19318600199995, 70.51007721600007],
              [-92.19831295499995, 70.50763580900008],
              [-92.2124731109999, 70.51007721600007],
              [-92.23033606699994, 70.51072825700004],
              [-92.24323482999995, 70.50775788000004],
              [-92.28555253799993, 70.48961009300007],
              [-92.24815833199995, 70.48651764500005],
              [-92.17772376199991, 70.47288646000004],
              [-92.14183508999992, 70.46979401200008],
              [-92.12108313699991, 70.47406647300005],
              [-92.11172441299993, 70.47264232000003],
              [-92.10741126199991, 70.46295807500007],
              [-92.1082250639999, 70.45404694200005],
              [-92.11164303299995, 70.44891998900005],
              [-92.11803137899994, 70.44733307500007],
              [-92.12328040299991, 70.44806549700007],
              [-92.13117428299995, 70.44476959800005],
              [-92.13394120999993, 70.44151439000007],
              [-92.13475501199991, 70.43500397300005],
              [-92.04222571499992, 70.42137278900003],
              [-92.0391332669999, 70.41795482000003],
              [-92.04670162699995, 70.40094635600008],
              [-92.04531816299993, 70.39411041900007],
              [-92.03620357999995, 70.39195384300007],
              [-92.0098363919999, 70.39524974200003],
              [-91.99815833199995, 70.39411041900007],
              [-91.99815833199995, 70.38719310100004],
              [-92.00377356699994, 70.38426341400003],
              [-92.01805579299992, 70.37299225500004],
              [-92.00698808499993, 70.37372467700004],
              [-91.99620520699995, 70.37262604400007],
              [-91.98595130099994, 70.37022532800006],
              [-91.97642981699994, 70.36676666900007],
              [-91.99364173099991, 70.35858795800004],
              [-92.00226803299995, 70.34882233300004],
              [-92.00157630099994, 70.33759186400005],
              [-91.99071204299992, 70.32514069200005],
              [-92.01244055899991, 70.31732819200005],
              [-92.03673255099994, 70.31354401200008],
              [-92.08629309799994, 70.31211985900006],
              [-92.08629309799994, 70.30467357000003],
              [-92.02879798099991, 70.30695221600007],
              [-91.99962317599994, 70.30316803600005],
              [-91.98387610599991, 70.29039134300007],
              [-91.99022376199991, 70.28929271000004],
              [-92.00438391799992, 70.28424713700008],
              [-91.96344967399995, 70.26988353100006],
              [-91.96239173099991, 70.26707591400003],
              [-91.96133378799993, 70.26141998900005],
              [-91.95864824099993, 70.25775788000004],
              [-91.95287024599992, 70.26032135600008],
              [-91.94994055899991, 70.26434967700004],
              [-91.9429418609999, 70.27732982000003],
              [-91.93529212099992, 70.28449127800008],
              [-91.92882239499994, 70.29218170800004],
              [-91.92076575399994, 70.29930247600004],
              [-91.90819251199991, 70.30467357000003],
              [-91.89525305899991, 70.30646393400008],
              [-91.8535863919999, 70.30467357000003],
              [-91.8919164699999, 70.32636139500005],
              [-91.90534420499995, 70.33991120000007],
              [-91.89826412699995, 70.35618724200003],
              [-91.87852942599994, 70.36473216400003],
              [-91.85265051999994, 70.36692942900004],
              [-91.82648678299995, 70.36456940300008],
              [-91.80577551999994, 70.35932038000004],
              [-91.79922441299993, 70.35236237200007],
              [-91.79356848899994, 70.34235260600008],
              [-91.78624426999994, 70.33649323100008],
              [-91.77501380099994, 70.34223053600005],
              [-91.76305091099994, 70.35472239800004],
              [-91.75584876199991, 70.35809967700004],
              [-91.74429277299993, 70.35932038000004],
              [-91.72321529899995, 70.35578034100007],
              [-91.70872962099992, 70.34654368700006],
              [-91.69823157499991, 70.33356354400007],
              [-91.68907630099994, 70.31834544500003],
              [-91.69937089799993, 70.31329987200007],
              [-91.71934973899994, 70.30658600500004],
              [-91.73070227799991, 70.30467357000003],
              [-91.69884192599994, 70.25608958500004],
              [-91.68773352799991, 70.22776927300004],
              [-91.69652258999992, 70.20848216400003],
              [-91.69652258999992, 70.20225657800006],
              [-91.68537350199995, 70.20453522300005],
              [-91.67153886599993, 70.21092357000003],
              [-91.65990149599992, 70.21885814000007],
              [-91.65493730399993, 70.22581614800004],
              [-91.65074622299994, 70.23590729400007],
              [-91.64098059799994, 70.23407623900005],
              [-91.62083899599992, 70.22211334800005],
              [-91.55752519399994, 70.19822825700004],
              [-91.53038489499994, 70.18195221600007],
              [-91.51097571499992, 70.16132233300004],
              [-91.51561438699991, 70.15473053600005],
              [-91.52481035099993, 70.14935944200005],
              [-91.54523678299995, 70.14496491100005],
              [-91.69652258999992, 70.13397858300004],
              [-91.81261145699995, 70.14020416900007],
              [-91.83665930899991, 70.13812897300005],
              [-91.8841039699999, 70.12872955900008],
              [-91.99547278599994, 70.12303294500003],
              [-92.02489173099991, 70.12657298400006],
              [-92.04527747299994, 70.13410065300008],
              [-92.0801488919999, 70.15721263200004],
              [-92.09996497299994, 70.16754791900007],
              [-92.12173417899993, 70.17405833500004],
              [-92.21056067599994, 70.18292877800008],
              [-92.22581946499992, 70.18793366100005],
              [-92.23387610599991, 70.19647858300004],
              [-92.23033606699994, 70.20848216400003],
              [-92.26390540299991, 70.23948802300004],
              [-92.2813207669999, 70.25104401200008],
              [-92.29922441299993, 70.25690338700008],
              [-92.29954993399991, 70.24046458500004],
              [-92.32176673099991, 70.23627350500004],
              [-92.36754309799994, 70.23643626500007],
              [-92.29702714799993, 70.21788157800006],
              [-92.27501380099994, 70.21588776200008],
              [-92.26622473899994, 70.21308014500005],
              [-92.26537024599992, 70.20652903900003],
              [-92.26829993399991, 70.19957103100006],
              [-92.27131100199995, 70.19542064000007],
              [-92.27985592399995, 70.19000885600008],
              [-92.29027258999992, 70.18768952000005],
              [-92.31224524599992, 70.18866608300004],
              [-92.30601966099994, 70.19542064000007],
              [-92.32640540299991, 70.19513580900008],
              [-92.36929277299993, 70.18402741100005],
              [-92.39171301999994, 70.18121979400007],
              [-92.48420162699995, 70.18121979400007],
              [-92.48420162699995, 70.17491282800006],
              [-92.45425370999993, 70.17450592700004],
              [-92.43065344999991, 70.17137278900003],
              [-92.40990149599992, 70.16307200700004],
              [-92.38857988199993, 70.14704010600008],
              [-92.40404212099992, 70.14142487200007],
              [-92.43423417899993, 70.13812897300005],
              [-92.44635982999995, 70.13031647300005],
              [-92.4739477199999, 70.09857819200005],
              [-92.53172766799992, 70.09336985900006],
              [-92.5872289699999, 70.07880280200004],
              [-92.56871497299994, 70.07440827000005],
              [-92.53111731699994, 70.07758209800005],
              [-92.51829993399991, 70.07135651200008],
              [-92.49233964799993, 70.05084870000007],
              [-92.47801673099991, 70.04559967700004],
              [-92.46304277299993, 70.05145905200004],
              [-92.45645097599993, 70.06871165600006],
              [-92.31159420499995, 70.09430573100008],
              [-92.11172441299993, 70.08860911700003],
              [-92.05044511599993, 70.07672760600008],
              [-91.99356035099993, 70.05552806200006],
              [-91.9429418609999, 70.02411530200004],
              [-91.95811926999994, 70.01597728100006],
              [-92.02489173099991, 69.99620189000007],
              [-92.03282630099994, 69.99518463700008],
              [-92.06615149599992, 69.99620189000007],
              [-92.07725989499994, 69.99371979400007],
              [-92.0813695949999, 69.98773834800005],
              [-92.08287512899994, 69.98094310100004],
              [-92.08629309799994, 69.97569407800006],
              [-92.2234594389999, 69.91478099200003],
              [-92.24498450399994, 69.90863678600005],
              [-92.27131100199995, 69.90745677300004],
              [-92.27131100199995, 69.90062083500004],
              [-92.26439368399991, 69.89972565300008],
              [-92.24461829299992, 69.89378489800004],
              [-92.26471920499995, 69.87523021000004],
              [-92.3418676419999, 69.86192454600007],
              [-92.37938391799992, 69.84507884300007],
              [-92.38923092399995, 69.84491608300004],
              [-92.39952551999994, 69.84589264500005],
              [-92.40908769399994, 69.84540436400005],
              [-92.41795813699991, 69.84190501500007],
              [-92.43106035099993, 69.83392975500004],
              [-92.43602454299992, 69.83234284100007],
              [-92.45474199099993, 69.83038971600007],
              [-92.49087480399993, 69.82147858300004],
              [-92.51146399599992, 69.81867096600007],
              [-92.53620357999995, 69.81964752800008],
              [-92.54759680899991, 69.81683991100005],
              [-92.55247962099992, 69.80780670800004],
              [-92.55101477799991, 69.80158112200007],
              [-92.54539954299992, 69.78900788000004],
              [-92.54564368399991, 69.78388092700004],
              [-92.55479895699995, 69.77220286700003],
              [-92.56786048099991, 69.76459381700005],
              [-92.58360755099994, 69.76239655200004],
              [-92.60057532499991, 69.76683177300004],
              [-92.6414281889999, 69.79096100500004],
              [-92.64867102799991, 69.79417552300004],
              [-92.67345130099994, 69.78082916900007],
              [-92.67471269399994, 69.77427806200006],
              [-92.65550696499992, 69.77024974200003],
              [-92.68407141799992, 69.75694407800006],
              [-92.8413793609999, 69.71002838700008],
              [-92.86839758999992, 69.70880768400008],
              [-92.86839758999992, 69.70197174700007],
              [-92.53880774599992, 69.71503327000005],
              [-92.53880774599992, 69.70880768400008],
              [-92.62271074099993, 69.70538971600007],
              [-92.64712480399993, 69.70005931200006],
              [-92.71499589799993, 69.67670319200005],
              [-92.73741614499994, 69.67405833500004],
              [-92.81358801999994, 69.67918528900003],
              [-92.85570227799991, 69.68956126500007],
              [-92.92300370999993, 69.68150462400007],
              [-92.92300370999993, 69.67405833500004],
              [-92.86432857999995, 69.66290924700007],
              [-92.83340410099993, 69.66132233300004],
              [-92.7703344389999, 69.66950104400007],
              [-92.70055091099994, 69.65513743700006],
              [-92.66909745999993, 69.65416087400007],
              [-92.64704342399995, 69.66193268400008],
              [-92.6035863919999, 69.68329498900005],
              [-92.47142493399991, 69.69761790600006],
              [-92.44937089799993, 69.68773021000004],
              [-92.40542558499993, 69.68475983300004],
              [-92.38857988199993, 69.68773021000004],
              [-92.3867895169999, 69.69127024900007],
              [-92.38524329299992, 69.69782135600008],
              [-92.38198808499993, 69.70457591400003],
              [-92.37490800699993, 69.70880768400008],
              [-92.36742102799991, 69.70872630400004],
              [-92.34019934799994, 69.70197174700007],
              [-92.34019934799994, 69.69452545800004],
              [-92.35094153599994, 69.68964264500005],
              [-92.36042232999995, 69.68390534100007],
              [-92.36839758999992, 69.67674388200004],
              [-92.37490800699993, 69.66783274900007],
              [-92.35293535099993, 69.66148509300007],
              [-92.34044348899994, 69.66010163000004],
              [-92.33006751199991, 69.66193268400008],
              [-92.33287512899994, 69.66193268400008],
              [-92.33446204299992, 69.66315338700008],
              [-92.33397376199991, 69.66783274900007],
              [-92.26284745999993, 69.66583893400008],
              [-92.22642981699994, 69.65879954600007],
              [-92.1765844389999, 69.63340892100007],
              [-92.1145727199999, 69.63226959800005],
              [-92.09117591099994, 69.62592194200005],
              [-92.08629309799994, 69.61945221600007],
              [-92.24547278599994, 69.63377513200004],
              [-92.26113847599993, 69.63572825700004],
              [-92.26309160099993, 69.63422272300005],
              [-92.27009029899995, 69.64000071800007],
              [-92.28799394399994, 69.64655182500007],
              [-92.29922441299993, 69.64671458500004],
              [-92.29922441299993, 69.64057038000004],
              [-92.23778235599991, 69.60578034100007],
              [-92.18154863199993, 69.59381745000007],
              [-92.16885331899994, 69.58531321800007],
              [-92.16869055899991, 69.59015534100007],
              [-92.16714433499993, 69.59105052300004],
              [-92.16466223899994, 69.58909739800004],
              [-92.1614477199999, 69.58531321800007],
              [-92.16885331899994, 69.57786692900004],
              [-92.14464270699995, 69.57794830900008],
              [-92.13292395699995, 69.57579173400006],
              [-92.12169348899994, 69.57164134300007],
              [-92.12389075399994, 69.56785716400003],
              [-92.12791907499991, 69.55805084800005],
              [-92.10265051999994, 69.55805084800005],
              [-91.96666419199994, 69.53363678600005],
              [-91.93712317599994, 69.51902903900003],
              [-91.87401282499991, 69.50958893400008],
              [-91.81940670499995, 69.49079010600008],
              [-91.79832923099991, 69.48969147300005],
              [-91.80272376199991, 69.51325104400007],
              [-91.77456620999993, 69.52606842700004],
              [-91.73619544199994, 69.53440989800004],
              [-91.71019446499992, 69.54429759300007],
              [-91.73745683499993, 69.55113353100006],
              [-91.71344967399995, 69.55768463700008],
              [-91.64810136599993, 69.55805084800005],
              [-91.63206946499992, 69.56354401200008],
              [-91.59805253799993, 69.58100006700005],
              [-91.57921301999994, 69.58531321800007],
              [-91.58751380099994, 69.59979889500005],
              [-91.59300696499992, 69.60655345300006],
              [-91.60033118399991, 69.61261627800008],
              [-91.58755449099993, 69.61884186400005],
              [-91.55565344999991, 69.62787506700005],
              [-91.5423070949999, 69.63682689000007],
              [-91.53307044199994, 69.64105866100005],
              [-91.51036536399994, 69.63996002800008],
              [-91.50072180899991, 69.64362213700008],
              [-91.49913489499994, 69.64732493700006],
              [-91.49730383999992, 69.66107819200005],
              [-91.46475175699993, 69.66742584800005],
              [-91.42601477799991, 69.66840241100005],
              [-91.35387122299994, 69.66107819200005],
              [-91.33385169199994, 69.65387604400007],
              [-91.32140051999994, 69.65277741100005],
              [-91.3054906889999, 69.65757884300007],
              [-91.2898656889999, 69.66022370000007],
              [-91.27717037699995, 69.65412018400008],
              [-91.2649633449999, 69.64549388200004],
              [-91.25084387899994, 69.64057038000004],
              [-91.19505774599992, 69.65570709800005],
              [-91.16759192599994, 69.65570709800005],
              [-91.16832434799994, 69.63312409100007],
              [-91.1499731109999, 69.63251373900005],
              [-91.09325110599991, 69.64057038000004],
              [-91.10655676999994, 69.62486399900007],
              [-91.13182532499991, 69.61937083500004],
              [-91.1887914699999, 69.61945221600007],
              [-91.21890214799993, 69.61432526200008],
              [-91.3242895169999, 69.56342194200005],
              [-91.35973059799994, 69.55292389500005],
              [-91.5410863919999, 69.53375885600008],
              [-91.57237708199995, 69.52326080900008],
              [-91.55711829299992, 69.51182689000007],
              [-91.54124915299991, 69.51304759300007],
              [-91.52391516799992, 69.51947663000004],
              [-91.50405839799993, 69.52326080900008],
              [-91.34679114499994, 69.52326080900008],
              [-91.33995520699995, 69.52610911700003],
              [-91.31623287699995, 69.53978099200003],
              [-91.30483964799993, 69.54429759300007],
              [-91.18907630099994, 69.56419505400004],
              [-91.17739824099993, 69.56126536700003],
              [-91.16690019399994, 69.55402252800008],
              [-91.14781653599994, 69.53685130400004],
              [-91.10997473899994, 69.51329173400006],
              [-91.08580481699994, 69.51129791900007],
              [-91.0071508449999, 69.52716705900008],
              [-90.97716223899994, 69.51593659100007],
              [-90.89769446499992, 69.53685130400004],
              [-90.88634192599994, 69.53172435100004],
              [-90.88133704299992, 69.51923248900005],
              [-90.88198808499993, 69.50372955900008],
              [-90.88780676999994, 69.48969147300005],
              [-90.75059973899994, 69.48969147300005],
              [-90.75328528599994, 69.51911041900007],
              [-90.72419186099995, 69.53416575700004],
              [-90.68431555899991, 69.53888580900008],
              [-90.65440833199995, 69.53685130400004],
              [-90.50357011599993, 69.50958893400008],
              [-90.4676000639999, 69.49713776200008],
              [-90.43687903599994, 69.49315013200004],
              [-90.4270727199999, 69.48619212400007],
              [-90.41881262899994, 69.47728099200003],
              [-90.40794837099992, 69.46861399900007],
              [-90.40029863199993, 69.46466705900008],
              [-90.39370683499993, 69.46263255400004],
              [-90.37694251199991, 69.46177806200006],
              [-90.36953691299993, 69.45970286700003],
              [-90.36888587099992, 69.45490143400008],
              [-90.37047278599994, 69.44928620000007],
              [-90.36978105399993, 69.44468821800007],
              [-90.3613988919999, 69.44513580900008],
              [-90.32607988199993, 69.45298899900007],
              [-90.31175696499992, 69.45433177300004],
              [-90.31175696499992, 69.44810618700006],
              [-90.35252844999991, 69.43732330900008],
              [-90.47622636599993, 69.44810618700006],
              [-90.4871313139999, 69.44647858300004],
              [-90.51720130099994, 69.43451569200005],
              [-90.53604081899994, 69.43040599200003],
              [-90.56159420499995, 69.42829010600008],
              [-90.57933508999992, 69.42938873900005],
              [-90.59776770699995, 69.43272532800006],
              [-90.61436926999994, 69.43895091400003],
              [-90.61327063699991, 69.44151439000007],
              [-90.60716712099992, 69.44224681200006],
              [-90.59976152299993, 69.44810618700006],
              [-90.62144934799994, 69.45404694200005],
              [-90.70278886599993, 69.45433177300004],
              [-90.70278886599993, 69.44810618700006],
              [-90.68529212099992, 69.44798411700003],
              [-90.66657467399995, 69.44310130400004],
              [-90.63390051999994, 69.42829010600008],
              [-90.62588456899994, 69.42405833500004],
              [-90.59984290299991, 69.42499420800004],
              [-90.58551998599995, 69.42084381700005],
              [-90.59666907499991, 69.41608307500007],
              [-90.61864173099991, 69.41254303600005],
              [-90.62645423099991, 69.40778229400007],
              [-90.64952551999994, 69.41351959800005],
              [-90.67259680899991, 69.40770091400003],
              [-90.69595292899993, 69.39838288000004],
              [-90.73827063699991, 69.39044830900008],
              [-90.79775956899994, 69.36619700700004],
              [-90.79539954299992, 69.36249420800004],
              [-90.79157467399995, 69.35252513200004],
              [-90.81114661399994, 69.34629954600007],
              [-90.81505286399994, 69.33368561400005],
              [-90.81065833199995, 69.32013580900008],
              [-90.80524654899995, 69.31098053600005],
              [-90.81354732999995, 69.30687083500004],
              [-90.81655839799993, 69.30060455900008],
              [-90.81395423099991, 69.29271067900004],
              [-90.80524654899995, 69.28367747600004],
              [-90.81822669199994, 69.27680084800005],
              [-90.81354732999995, 69.27171458500004],
              [-90.80524654899995, 69.25633372600004],
              [-90.93553626199991, 69.24949778900003],
              [-90.93553626199991, 69.25633372600004],
              [-90.90534420499995, 69.26817454600007],
              [-90.8946020169999, 69.27000560100004],
              [-90.90868079299992, 69.27057526200008],
              [-90.94920813699991, 69.26312897300005],
              [-90.94298255099994, 69.26312897300005],
              [-90.95067298099991, 69.26264069200005],
              [-90.95750891799992, 69.26325104400007],
              [-90.96373450399994, 69.26548899900007],
              [-90.96971594999991, 69.27000560100004],
              [-90.95107988199993, 69.27667877800008],
              [-90.94298255099994, 69.27680084800005],
              [-90.94298255099994, 69.28367747600004],
              [-90.95604407499991, 69.28367747600004],
              [-90.95604407499991, 69.29047272300005],
              [-90.94273841099994, 69.28912995000007],
              [-90.93065344999991, 69.28974030200004],
              [-90.92105058499993, 69.29413483300004],
              [-90.91510982999995, 69.30414459800005],
              [-90.93980872299994, 69.30329010600008],
              [-91.07005774599992, 69.26813385600008],
              [-91.08633378799993, 69.27000560100004],
              [-91.09459387899994, 69.28510163000004],
              [-91.06847083199995, 69.29682038000004],
              [-91.01065019399994, 69.31098053600005],
              [-91.00548255099994, 69.31708405200004],
              [-91.00251217399995, 69.33209870000007],
              [-90.9976293609999, 69.33893463700008],
              [-90.98932857999995, 69.34312571800007],
              [-90.95604407499991, 69.35252513200004],
              [-90.95604407499991, 69.35936107000003],
              [-90.98485266799992, 69.35883209800005],
              [-91.01085364499994, 69.35016510600008],
              [-91.08967037699995, 69.31199778900003],
              [-91.15611731699994, 69.29332103100006],
              [-91.18907630099994, 69.29047272300005],
              [-91.25422115799995, 69.29869212400007],
              [-91.44953365799995, 69.35936107000003],
              [-91.44953365799995, 69.35252513200004],
              [-91.39297441299993, 69.32579173400006],
              [-91.25918535099993, 69.28367747600004],
              [-91.18126380099994, 69.27399323100008],
              [-91.16527258999992, 69.26658763200004],
              [-91.15001380099994, 69.25678131700005],
              [-91.13756262899994, 69.24607982000003],
              [-91.12564042899993, 69.23883698100008],
              [-91.03359941299993, 69.21954987200007],
              [-90.85700436099995, 69.14463939000007],
              [-90.82213294199994, 69.13816966400003],
              [-90.80524654899995, 69.13279857000003],
              [-90.77065995999993, 69.10887278900003],
              [-90.76024329299992, 69.10553620000007],
              [-90.73668372299994, 69.10313548400006],
              [-90.67064368399991, 69.08820221600007],
              [-90.65440833199995, 69.07819245000007],
              [-90.66136633999992, 69.06183502800008],
              [-90.70230058499993, 69.03974030200004],
              [-90.6953832669999, 69.02977122600004],
              [-90.70897376199991, 69.00718821800007],
              [-90.68545488199993, 68.99823639500005],
              [-90.62022864499994, 68.99567291900007],
              [-90.62645423099991, 68.99567291900007],
              [-90.6121313139999, 68.98749420800004],
              [-90.57925370999993, 68.94786204600007],
              [-90.59976152299993, 68.94786204600007],
              [-90.59976152299993, 68.94037506700005],
              [-90.59434973899994, 68.93724192900004],
              [-90.58551998599995, 68.92735423400006],
              [-90.60537675699993, 68.92658112200007],
              [-90.61978105399993, 68.92173899900007],
              [-90.62108313699991, 68.91632721600007],
              [-90.53262285099993, 68.91144440300008],
              [-90.44652258999992, 68.88629791900007],
              [-90.43529212099992, 68.87897370000007],
              [-90.44115149599992, 68.87010325700004],
              [-90.47264563699991, 68.86212799700007],
              [-90.48306230399993, 68.85228099200003],
              [-90.43712317599994, 68.85480377800008],
              [-90.42162024599992, 68.85228099200003],
              [-90.42162024599992, 68.84544505400004],
              [-90.44676673099991, 68.84015534100007],
              [-90.49791419199994, 68.84467194200005],
              [-90.52403723899994, 68.83860911700003],
              [-90.53795325399994, 68.83690013200004],
              [-90.56114661399994, 68.82807038000004],
              [-90.59976152299993, 68.80390045800004],
              [-90.56354732999995, 68.79893626500007],
              [-90.48184160099993, 68.82660553600005],
              [-90.44212805899991, 68.83116282800006],
              [-90.44749915299991, 68.82172272300005],
              [-90.45494544199994, 68.81773509300007],
              [-90.46353105399993, 68.81464264500005],
              [-90.47252356699994, 68.80756256700005],
              [-90.47581946499992, 68.79649485900006],
              [-90.46690833199995, 68.79132721600007],
              [-90.45494544199994, 68.79002513200004],
              [-90.44896399599992, 68.79022858300004],
              [-90.4571020169999, 68.77704498900005],
              [-90.47411048099991, 68.77012767100007],
              [-90.49217688699991, 68.77171458500004],
              [-90.50357011599993, 68.78400299700007],
              [-90.51036536399994, 68.78400299700007],
              [-90.51317298099991, 68.77008698100008],
              [-90.52765865799995, 68.75267161700003],
              [-90.53087317599994, 68.74241771000004],
              [-90.52623450399994, 68.73338450700004],
              [-90.51561438699991, 68.72455475500004],
              [-90.50328528599994, 68.71784088700008],
              [-90.48302161399994, 68.71104564000007],
              [-90.48558508999992, 68.70111725500004],
              [-90.49303137899994, 68.68878815300008],
              [-90.5008031889999, 68.66766998900005],
              [-90.50934811099995, 68.66209544500003],
              [-90.53087317599994, 68.65302155200004],
              [-90.52647864499994, 68.64203522300005],
              [-90.53530839799993, 68.63544342700004],
              [-90.56501217399995, 68.62571849200003],
              [-90.54698645699995, 68.62225983300004],
              [-90.52550208199995, 68.61505768400008],
              [-90.50499426999994, 68.60460032800006],
              [-90.48989824099993, 68.59153880400004],
              [-90.50169837099992, 68.58421458500004],
              [-90.53026282499991, 68.58152903900003],
              [-90.53831946499992, 68.57855866100005],
              [-90.53990637899994, 68.57208893400008],
              [-90.53774980399993, 68.56525299700007],
              [-90.53319251199991, 68.55967845300006],
              [-90.52745520699995, 68.55744049700007],
              [-90.50816809799994, 68.55316803600005],
              [-90.48668372299994, 68.54376862200007],
              [-90.47716223899994, 68.53440989800004],
              [-90.49364173099991, 68.53009674700007],
              [-90.49840247299994, 68.52387116100005],
              [-90.51720130099994, 68.49192942900004],
              [-90.52916419199994, 68.48883698100008],
              [-90.60008704299992, 68.46124909100007],
              [-90.60606848899994, 68.45807526200008],
              [-90.60814368399991, 68.45099518400008],
              [-90.60704505099994, 68.44391510600008],
              [-90.60350501199991, 68.44078196800007],
              [-90.56501217399995, 68.43390534100007],
              [-90.4973852199999, 68.41343821800007],
              [-90.31859290299991, 68.37925853100006],
              [-90.31859290299991, 68.37250397300005],
              [-90.35830644399994, 68.37238190300008],
              [-90.47565670499995, 68.33771393400008],
              [-90.38646399599992, 68.35044993700006],
              [-90.33836829299992, 68.35203685100004],
              [-90.31175696499992, 68.33771393400008],
              [-90.31533769399994, 68.33307526200008],
              [-90.3172094389999, 68.33124420800004],
              [-90.31627356699994, 68.32929108300004],
              [-90.31175696499992, 68.32404205900008],
              [-90.32412675699993, 68.30988190300008],
              [-90.31798255099994, 68.29889557500007],
              [-90.28758704299992, 68.28001536700003],
              [-90.27818762899994, 68.26813385600008],
              [-90.27920488199993, 68.25189850500004],
              [-90.2708227199999, 68.24213288000004],
              [-90.23704993399991, 68.23212311400005],
              [-90.19383704299992, 68.23578522300005],
              [-90.15151933499993, 68.24774811400005],
              [-90.11998450399994, 68.26264069200005],
              [-90.12779700399994, 68.26874420800004],
              [-90.13438880099994, 68.27610911700003],
              [-90.13878333199995, 68.28453196800007],
              [-90.14049231699994, 68.29364655200004],
              [-90.16405188699991, 68.30272044500003],
              [-90.17149817599994, 68.30731842700004],
              [-90.1641332669999, 68.31517161700003],
              [-90.11123613199993, 68.33405182500007],
              [-90.09947669199994, 68.33771393400008],
              [-90.06997636599993, 68.34434642100007],
              [-90.02354895699995, 68.37287018400008],
              [-90.00015214799993, 68.37925853100006],
              [-89.99657141799992, 68.38255442900004],
              [-89.9934789699999, 68.39020416900007],
              [-89.98961341099994, 68.40599192900004],
              [-90.00218665299991, 68.41327545800004],
              [-90.00182044199994, 68.41941966400003],
              [-89.98216712099992, 68.42772044500003],
              [-90.00389563699991, 68.43390534100007],
              [-89.97834225199995, 68.44562409100007],
              [-89.92430579299992, 68.45160553600005],
              [-89.90086829299992, 68.46124909100007],
              [-89.91169186099995, 68.46983470300006],
              [-89.91014563699991, 68.47968170800004],
              [-89.90050208199995, 68.48639557500007],
              [-89.88719641799992, 68.48545970300006],
              [-89.87096106699994, 68.48187897300005],
              [-89.8645727199999, 68.48834870000007],
              [-89.86245683499993, 68.49945709800005],
              [-89.85928300699993, 68.50962962400007],
              [-89.84976152299993, 68.52330149900007],
              [-89.83763587099992, 68.53632233300004],
              [-89.82095292899993, 68.54454173400006],
              [-89.86668860599991, 68.54441966400003],
              [-89.89614824099993, 68.55023834800005],
              [-89.92076575399994, 68.56427643400008],
              [-89.9383031889999, 68.58799876500007],
              [-89.94595292899993, 68.60431549700007],
              [-89.94493567599994, 68.61579010600008],
              [-89.92918860599991, 68.62498607000003],
              [-89.90998287699995, 68.63324616100005],
              [-89.89732825399994, 68.64386627800008],
              [-89.90086829299992, 68.66046784100007],
              [-89.84683183499993, 68.67731354400007],
              [-89.83193925699993, 68.68720123900005],
              [-89.8176977199999, 68.70640696800007],
              [-89.80947831899994, 68.71271393400008],
              [-89.79442298099991, 68.71507396000004],
              [-89.76650956899994, 68.70368073100008],
              [-89.75389563699991, 68.67731354400007],
              [-89.75560462099992, 68.64740631700005],
              [-89.77057857999995, 68.62571849200003],
              [-89.75450598899994, 68.62518952000005],
              [-89.74063066299993, 68.62995026200008],
              [-89.71593176999994, 68.64618561400005],
              [-89.71544348899994, 68.65082428600005],
              [-89.71662350199995, 68.65875885600008],
              [-89.72057044199994, 68.66742584800005],
              [-89.72215735599991, 68.67413971600007],
              [-89.72687740799995, 68.68817780200004],
              [-89.72549394399994, 68.70750560100004],
              [-89.71996008999992, 68.72638580900008],
              [-89.7122289699999, 68.73899974200003],
              [-89.70026607999995, 68.75324127800008],
              [-89.69774329299992, 68.76532623900005],
              [-89.70348059799994, 68.77708567900004],
              [-89.71593176999994, 68.79022858300004],
              [-89.70547441299993, 68.79393138200004],
              [-89.69603430899991, 68.79954661700003],
              [-89.68956458199995, 68.80744049700007],
              [-89.68797766799992, 68.81749095300006],
              [-89.69367428299995, 68.82916901200008],
              [-89.70498613199993, 68.83274974200003],
              [-89.7363988919999, 68.83116282800006],
              [-89.72618567599994, 68.84507884300007],
              [-89.72223873599995, 68.85297272300005],
              [-89.7234594389999, 68.86192454600007],
              [-89.7344457669999, 68.89142487200007],
              [-89.74693762899994, 68.91624583500004],
              [-89.75072180899991, 68.94847239800004],
              [-89.74913489499994, 68.95624420800004],
              [-89.74323482999995, 68.96832916900007],
              [-89.72606360599991, 68.99485911700003],
              [-89.70531165299991, 69.02020905200004],
              [-89.67218990799995, 69.04450104400007],
              [-89.54458574099993, 69.09186432500007],
              [-89.44155839799993, 69.15391673400006],
              [-89.44229081899994, 69.16254303600005],
              [-89.40933183499993, 69.17511627800008],
              [-89.40054277299993, 69.18439362200007],
              [-89.39525305899991, 69.21161530200004],
              [-89.39720618399991, 69.21539948100008],
              [-89.38390051999994, 69.21971263200004],
              [-89.33169511599993, 69.24949778900003],
              [-89.30996660099993, 69.25458405200004],
              [-89.26349850199995, 69.26019928600005],
              [-89.19871985599991, 69.27806224200003],
              [-89.03587805899991, 69.26719798400006],
              [-88.94196529899995, 69.23358795800004],
              [-88.93618730399993, 69.22687409100007],
              [-88.94127356699994, 69.21539948100008],
              [-88.93285071499992, 69.20274485900006],
              [-88.92100989499994, 69.19428131700005],
              [-88.90729732999995, 69.18943919500003],
              [-88.90029863199993, 69.18805573100008],
              [-88.88683020699995, 69.17955149900007],
              [-88.86217200399994, 69.15155670800004],
              [-88.84569251199991, 69.13963450700004],
              [-88.7285863919999, 69.08392975500004],
              [-88.55972245999993, 69.03038157800006],
              [-88.52147376199991, 69.01280345300006],
              [-88.44749915299991, 68.99713776200008],
              [-88.24974524599992, 68.93158600500004],
              [-88.02261308499993, 68.80866120000007],
              [-87.98021399599992, 68.77122630400004],
              [-87.94709225199995, 68.72968170800004],
              [-87.92650305899991, 68.68720123900005],
              [-87.91991126199991, 68.66514720300006],
              [-87.91917883999992, 68.65289948100008],
              [-87.92332923099991, 68.64244212400007],
              [-87.94815019399994, 68.60871002800008],
              [-87.94131425699993, 68.58763255400004],
              [-87.92528235599991, 68.56598541900007],
              [-87.90689042899993, 68.54767487200007],
              [-87.89293372299994, 68.53697337400007],
              [-87.88980058499993, 68.51622142100007],
              [-87.87848873599995, 68.49652741100005],
              [-87.85887610599991, 68.47992584800005],
              [-87.8308813139999, 68.46869538000004],
              [-87.84211178299995, 68.45355866100005],
              [-87.84333248599995, 68.44183991100005],
              [-87.8367406889999, 68.43235911700003],
              [-87.80036373599995, 68.40428294500003],
              [-87.79600989499994, 68.38617584800005],
              [-87.80064856699994, 68.36717357000003],
              [-87.80357825399994, 68.34454987200007],
              [-87.79987545499995, 68.33775462400007],
              [-87.79401607999995, 68.33515045800004],
              [-87.79222571499992, 68.33124420800004],
              [-87.80044511599993, 68.32099030200004],
              [-87.80577551999994, 68.31256745000007],
              [-87.80992591099994, 68.30255768400008],
              [-87.81460527299993, 68.29413483300004],
              [-87.82127844999991, 68.29059479400007],
              [-87.82738196499992, 68.28611888200004],
              [-87.83873450399994, 68.26422760600008],
              [-87.8445531889999, 68.25580475500004],
              [-87.85411536399994, 68.24937571800007],
              [-87.89293372299994, 68.23590729400007],
              [-87.91161048099991, 68.22272370000007],
              [-87.92735755099994, 68.20795319200005],
              [-87.94375566299993, 68.20087311400005],
              [-87.99351966099994, 68.22907135600008],
              [-88.02700761599993, 68.23822663000004],
              [-88.09496008999992, 68.24213288000004],
              [-88.10195878799993, 68.24339427300004],
              [-88.11685136599993, 68.24872467700004],
              [-88.12633216099994, 68.24957916900007],
              [-88.13044186099995, 68.24738190300008],
              [-88.14150956899994, 68.23802317900004],
              [-88.14614824099993, 68.23590729400007],
              [-88.15843665299991, 68.23655833500004],
              [-88.16974850199995, 68.23924388200004],
              [-88.17955481699994, 68.24530670800004],
              [-88.18712317599994, 68.25580475500004],
              [-88.18838456899994, 68.27033112200007],
              [-88.18000240799995, 68.35858795800004],
              [-88.18154863199993, 68.37042877800008],
              [-88.18712317599994, 68.37925853100006],
              [-88.19937089799993, 68.38336823100008],
              [-88.21190344999991, 68.38056061400005],
              [-88.21727454299992, 68.37201569200005],
              [-88.2083227199999, 68.35883209800005],
              [-88.21711178299995, 68.35382721600007],
              [-88.25548255099994, 68.34454987200007],
              [-88.26805579299992, 68.33820221600007],
              [-88.29698645699995, 68.31785716400003],
              [-88.3203832669999, 68.30878327000005],
              [-88.39842688699991, 68.29079824400003],
              [-88.39879309799994, 68.28758372600004],
              [-88.40127519399994, 68.28233470300006],
              [-88.40684973899994, 68.27692291900007],
              [-88.38756262899994, 68.25726959800005],
              [-88.34211178299995, 68.22821686400005],
              [-88.32494055899991, 68.20799388200004],
              [-88.32371985599991, 68.20176829600007],
              [-88.32457434799994, 68.19542064000007],
              [-88.32469641799992, 68.18931712400007],
              [-88.32119706899994, 68.18378327000005],
              [-88.30382239499994, 68.16705963700008],
              [-88.28331458199995, 68.12604401200008],
              [-88.28286699099993, 68.11383698100008],
              [-88.28628495999993, 68.10663483300004],
              [-88.32998613199993, 68.07945384300007],
              [-88.33458411399994, 68.07762278900003],
              [-88.34276282499991, 68.07538483300004],
              [-88.34194902299993, 68.06981028900003],
              [-88.33836829299992, 68.06305573100008],
              [-88.3379613919999, 68.05719635600008],
              [-88.33511308499993, 68.05646393400008],
              [-88.33275305899991, 68.05133698100008],
              [-88.33482825399994, 68.04559967700004],
              [-88.35204016799992, 68.04148997600004],
              [-88.3738500639999, 68.03375885600008],
              [-88.37954667899993, 68.02985260600008],
              [-88.37938391799992, 68.02147044500003],
              [-88.37267005099994, 68.01459381700005],
              [-88.35846920499995, 68.00254954600007],
              [-88.37364661399994, 67.97581614800004],
              [-88.36449133999992, 67.95628489800004],
              [-88.34727942599994, 67.93846263200004],
              [-88.33161373599995, 67.89826080900008],
              [-88.30337480399993, 67.86290110900006],
              [-88.29698645699995, 67.84796784100007],
              [-88.29255123599995, 67.83124420800004],
              [-88.28099524599992, 67.81098053600005],
              [-88.26537024599992, 67.79120514500005],
              [-88.24860592399995, 67.77598704600007],
              [-88.18480383999992, 67.75275299700007],
              [-88.16348222599993, 67.73619212400007],
              [-88.17349199099993, 67.70770905200004],
              [-88.15298417899993, 67.68040599200003],
              [-88.14053300699993, 67.67072174700007],
              [-88.11266028599994, 67.65729401200008],
              [-88.10179602799991, 67.64935944200005],
              [-88.06932532499991, 67.63202545800004],
              [-87.97813880099994, 67.61778392100007],
              [-87.9407445949999, 67.60468170800004],
              [-87.91250566299993, 67.58360423400006],
              [-87.86807206899994, 67.56309642100007],
              [-87.8548070949999, 67.55353424700007],
              [-87.84142005099994, 67.53949616100005],
              [-87.81533769399994, 67.51947663000004],
              [-87.71483313699991, 67.48114655200004],
              [-87.65982011599993, 67.43390534100007],
              [-87.64281165299991, 67.42649974200003],
              [-87.63194739499994, 67.42365143400008],
              [-87.57176673099991, 67.39337799700007],
              [-87.48379472599993, 67.36310455900008],
              [-87.46694902299993, 67.35224030200004],
              [-87.45763098899994, 67.33494700700004],
              [-87.45470130099994, 67.27265045800004],
              [-87.44737708199995, 67.26386139500005],
              [-87.43057206899994, 67.26581452000005],
              [-87.39952551999994, 67.27570221600007],
              [-87.37694251199991, 67.27411530200004],
              [-87.36294511599993, 67.26719798400006],
              [-87.3606664699999, 67.25608958500004],
              [-87.37279212099992, 67.24156321800007],
              [-87.38052324099993, 67.23798248900005],
              [-87.41315670499995, 67.22797272300005],
              [-87.45470130099994, 67.20685455900008],
              [-87.4922582669999, 67.19904205900008],
              [-87.50194251199991, 67.19379303600005],
              [-87.51024329299992, 67.18427155200004],
              [-87.51130123599995, 67.17877838700008],
              [-87.50951087099992, 67.17369212400007],
              [-87.50938880099994, 67.16583893400008],
              [-87.51060950399994, 67.15428294500003],
              [-87.51032467399995, 67.14488353100006],
              [-87.51121985599991, 67.13422272300005],
              [-87.51618404899995, 67.11871979400007],
              [-87.49608313699991, 67.12107982000003],
              [-87.47720292899993, 67.12641022300005],
              [-87.4597875639999, 67.13536204600007],
              [-87.42796790299991, 67.16563548400006],
              [-87.41454016799992, 67.17499420800004],
              [-87.39793860599991, 67.17918528900003],
              [-87.37218176999994, 67.18012116100005],
              [-87.32778886599993, 67.17328522300005],
              [-87.32481848899994, 67.17023346600007],
              [-87.32331295499995, 67.15513743700006],
              [-87.31468665299991, 67.13536204600007],
              [-87.31090247299994, 67.11827220300006],
              [-87.30426998599995, 67.10370514500005],
              [-87.28929602799991, 67.09760163000004],
              [-87.27696692599994, 67.10838450700004],
              [-87.25548255099994, 67.18012116100005],
              [-87.2493383449999, 67.18585846600007],
              [-87.23399817599994, 67.19330475500004],
              [-87.22817949099993, 67.20062897300005],
              [-87.22988847599993, 67.20567454600007],
              [-87.23648027299993, 67.20978424700007],
              [-87.24217688699991, 67.21442291900007],
              [-87.24120032499991, 67.22113678600005],
              [-87.22813880099994, 67.22809479400007],
              [-87.19591223899994, 67.22272370000007],
              [-87.18040930899991, 67.22797272300005],
              [-87.18126380099994, 67.23663971600007],
              [-87.16250566299993, 67.23663971600007],
              [-87.13719641799992, 67.22882721600007],
              [-87.11831620999993, 67.21430084800005],
              [-87.12462317599994, 67.20270416900007],
              [-87.12254798099991, 67.18817780200004],
              [-87.11412512899994, 67.17894114800004],
              [-87.10122636599993, 67.18353913000004],
              [-87.08311926999994, 67.20612213700008],
              [-87.07579505099994, 67.21808502800008],
              [-87.07115637899994, 67.22797272300005],
              [-87.0755102199999, 67.25311920800004],
              [-87.07066809799994, 67.26337311400005],
              [-87.05003821499992, 67.25865306200006],
              [-87.02965247299994, 67.25104401200008],
              [-87.00523841099994, 67.24656810100004],
              [-86.98086503799993, 67.24730052300004],
              [-86.96068274599992, 67.25523509300007],
              [-86.99754798099991, 67.27330149900007],
              [-87.00780188699991, 67.28672923400006],
              [-86.99478105399993, 67.30304596600007],
              [-87.01170813699991, 67.31000397300005],
              [-87.04645748599995, 67.31708405200004],
              [-87.06371008999992, 67.32416413000004],
              [-87.07445227799991, 67.33136627800008],
              [-87.08751380099994, 67.34263743700006],
              [-87.09219316299993, 67.35309479400007],
              [-87.07770748599995, 67.35765208500004],
              [-87.03892981699994, 67.35492584800005],
              [-87.01992753799993, 67.34992096600007],
              [-87.00536048099991, 67.34088776200008],
              [-86.99669348899994, 67.33161041900007],
              [-86.98790442599994, 67.32465241100005],
              [-86.97667395699995, 67.32330963700008],
              [-86.96068274599992, 67.33100006700005],
              [-86.96711178299995, 67.34284088700008],
              [-86.96711178299995, 67.35639069200005],
              [-86.96051998599995, 67.36737702000005],
              [-86.92931067599994, 67.37726471600007],
              [-86.8965551419999, 67.40074290600006],
              [-86.88219153599994, 67.40607330900008],
              [-86.81094316299993, 67.41722239800004],
              [-86.77896074099993, 67.41864655200004],
              [-86.74156653599994, 67.40607330900008],
              [-86.68586178299995, 67.37352122600004],
              [-86.65343176999994, 67.36371491100005],
              [-86.62547766799992, 67.37193431200006],
              [-86.62222245999993, 67.40204498900005],
              [-86.61514238199993, 67.41437409100007],
              [-86.59752356699994, 67.40607330900008],
              [-86.59459387899994, 67.39642975500004],
              [-86.59666907499991, 67.38316478100006],
              [-86.60073808499993, 67.37107982000003],
              [-86.60374915299991, 67.36505768400008],
              [-86.58385169199994, 67.34918854400007],
              [-86.55329342399995, 67.35215892100007],
              [-86.52245032499991, 67.36517975500004],
              [-86.50194251199991, 67.37938060100004],
              [-86.51183020699995, 67.39085521000004],
              [-86.52790279899995, 67.41657135600008],
              [-86.53612219999991, 67.42649974200003],
              [-86.53624426999994, 67.43036530200004],
              [-86.53555253799993, 67.44074127800008],
              [-86.53612219999991, 67.44700755400004],
              [-86.49624589799993, 67.45164622600004],
              [-86.48082434799994, 67.45905182500007],
              [-86.4746801419999, 67.47801341400003],
              [-86.47996985599991, 67.48969147300005],
              [-86.48940995999993, 67.49945709800005],
              [-86.49303137899994, 67.51129791900007],
              [-86.48086503799993, 67.52960846600007],
              [-86.48766028599994, 67.54185618700006],
              [-86.48688717399995, 67.55219147300005],
              [-86.48314368399991, 67.56232330900008],
              [-86.48086503799993, 67.57396067900004],
              [-86.47240149599992, 67.57916901200008],
              [-86.45767167899993, 67.59239329600007],
              [-86.45295162699995, 67.60594310100004],
              [-86.48884029899995, 67.61713288000004],
              [-86.49290930899991, 67.62872955900008],
              [-86.49274654899995, 67.64232005400004],
              [-86.49453691299993, 67.65314362200007],
              [-86.50186113199993, 67.66132233300004],
              [-86.5215551419999, 67.67767975500004],
              [-86.52928626199991, 67.68720123900005],
              [-86.47687740799995, 67.71771881700005],
              [-86.39073645699995, 67.80975983300004],
              [-86.34373938699991, 67.84491608300004],
              [-86.28962154899995, 67.86810944200005],
              [-86.27204342399995, 67.88243235900006],
              [-86.25300045499995, 67.89439524900007],
              [-86.18667558499993, 67.91376373900005],
              [-86.17992102799991, 67.91962311400005],
              [-86.17178300699993, 67.93280670800004],
              [-86.16616777299993, 67.93736399900007],
              [-86.13768469999991, 67.95099518400008],
              [-86.12832597599993, 67.95783112200007],
              [-86.12287350199995, 67.96954987200007],
              [-86.12511145699995, 67.98456452000005],
              [-86.13141842399995, 67.99913157800006],
              [-86.13825436099995, 68.00938548400006],
              [-86.13060462099992, 68.01605866100005],
              [-86.12035071499992, 68.02118561400005],
              [-86.10887610599991, 68.02208079600007],
              [-86.09727942599994, 68.01618073100008],
              [-86.10948645699995, 68.00238678600005],
              [-86.10850989499994, 67.99140045800004],
              [-86.09764563699991, 67.98407623900005],
              [-86.08018958199995, 67.98151276200008],
              [-86.0696508449999, 67.98472728100006],
              [-86.05858313699991, 67.99925364800004],
              [-86.04918372299994, 68.00254954600007],
              [-86.02501380099994, 68.00556061400005],
              [-86.01183020699995, 68.00885651200008],
              [-85.90172278599994, 68.05438873900005],
              [-85.89696204299992, 68.06065501500007],
              [-85.90347245999993, 68.06854889500005],
              [-85.91295325399994, 68.08506907800006],
              [-85.91588294199994, 68.09808991100005],
              [-85.91478430899991, 68.11143626500007],
              [-85.9075414699999, 68.12189362200007],
              [-85.89183508999992, 68.12604401200008],
              [-85.86481686099995, 68.12970612200007],
              [-85.86534583199995, 68.13878001500007],
              [-85.87743079299992, 68.15086497600004],
              [-85.88499915299991, 68.16331614800004],
              [-85.8875219389999, 68.17552317900004],
              [-85.89049231699994, 68.18463776200008],
              [-85.88731848899994, 68.19269440300008],
              [-85.87140865799995, 68.20115794500003],
              [-85.85020911399994, 68.20286692900004],
              [-85.82648678299995, 68.20038483300004],
              [-85.8047582669999, 68.20347728100006],
              [-85.78941809799994, 68.22166575700004],
              [-85.81566321499992, 68.22349681200006],
              [-85.8352758449999, 68.23057689000007],
              [-85.84373938699991, 68.24518463700008],
              [-85.83657792899993, 68.26947663000004],
              [-85.82811438699991, 68.27680084800005],
              [-85.81834876199991, 68.27928294500003],
              [-85.81086178299995, 68.28375885600008],
              [-85.80923417899993, 68.29673899900007],
              [-85.81403561099995, 68.30479564000007],
              [-85.83454342399995, 68.31683991100005],
              [-85.84406490799995, 68.32404205900008],
              [-85.82046464799993, 68.32880280200004],
              [-85.80345618399991, 68.33604564000007],
              [-85.71715247299994, 68.39826080900008],
              [-85.70628821499992, 68.41343821800007],
              [-85.71983801999994, 68.41840241100005],
              [-85.73721269399994, 68.42772044500003],
              [-85.74787350199995, 68.43671295800004],
              [-85.7410375639999, 68.44078196800007],
              [-85.70343990799995, 68.44293854400007],
              [-85.68399003799993, 68.44708893400008],
              [-85.66527258999992, 68.45441315300008],
              [-85.71060136599993, 68.45978424700007],
              [-85.73200436099995, 68.46539948100008],
              [-85.7410375639999, 68.47858307500007],
              [-85.73778235599991, 68.48456452000005],
              [-85.73078365799995, 68.48961009300007],
              [-85.72374426999994, 68.49616120000007],
              [-85.72052975199995, 68.50629303600005],
              [-85.72158769399994, 68.52985260600008],
              [-85.72052975199995, 68.53697337400007],
              [-85.72227942599994, 68.53961823100008],
              [-85.72435462099992, 68.54075755400004],
              [-85.72459876199991, 68.54352448100008],
              [-85.72052975199995, 68.55064524900007],
              [-85.73350989499994, 68.55744049700007],
              [-85.73884029899995, 68.56598541900007],
              [-85.73656165299991, 68.57538483300004],
              [-85.72671464799993, 68.58478424700007],
              [-85.74266516799992, 68.61302317900004],
              [-85.74282792899993, 68.62482330900008],
              [-85.73420162699995, 68.63873932500007],
              [-85.72427324099993, 68.64679596600007],
              [-85.70295162699995, 68.65770091400003],
              [-85.69322669199994, 68.66669342700004],
              [-85.68883216099994, 68.67430247600004],
              [-85.68089758999992, 68.69578685100004],
              [-85.67955481699994, 68.70453522300005],
              [-85.66812089799993, 68.72699616100005],
              [-85.64134680899991, 68.74241771000004],
              [-85.61046301999994, 68.74750397300005],
              [-85.56163489499994, 68.73094310100004],
              [-85.52367102799991, 68.73358795800004],
              [-85.48558508999992, 68.74310944200005],
              [-85.45982825399994, 68.75604889500005],
              [-85.48436438699991, 68.76544830900008],
              [-85.56285559799994, 68.78400299700007],
              [-85.41344153599994, 68.77448151200008],
              [-85.36363684799994, 68.76288483300004],
              [-85.37653561099995, 68.75128815300008],
              [-85.38345292899993, 68.74652741100005],
              [-85.39159094999991, 68.74241771000004],
              [-85.36025956899994, 68.73399485900006],
              [-85.22476152299993, 68.72129954600007],
              [-85.21816972599993, 68.73216380400004],
              [-85.2332250639999, 68.74457428600005],
              [-85.26121985599991, 68.74860260600008],
              [-85.23936926999994, 68.76585521000004],
              [-85.19945227799991, 68.76422760600008],
              [-85.12466386599993, 68.74860260600008],
              [-84.95958411399994, 68.76288483300004],
              [-84.93907630099994, 68.75971100500004],
              [-84.89830481699994, 68.74559153900003],
              [-84.80724036399994, 68.73423899900007],
              [-84.78823808499993, 68.73558177300004],
              [-84.78087317599994, 68.74030182500007],
              [-84.75926673099991, 68.75824616100005],
              [-84.75475012899994, 68.76288483300004],
              [-84.76097571499992, 68.77814362200007],
              [-84.77513587099992, 68.78440989800004],
              [-84.78929602799991, 68.78766510600008],
              [-84.7957250639999, 68.79364655200004],
              [-84.80923417899993, 68.81407298400006],
              [-84.84089107999995, 68.82310618700006],
              [-84.90465247299994, 68.82493724200003],
              [-84.92467200399994, 68.82282135600008],
              [-84.96670488199993, 68.81342194200005],
              [-84.98717200399994, 68.81126536700003],
              [-85.14500891799992, 68.83478424700007],
              [-85.17861894399994, 68.84715403900003],
              [-85.19294186099995, 68.86933014500005],
              [-85.17275956899994, 68.87738678600005],
              [-85.04271399599992, 68.86591217700004],
              [-85.05199133999992, 68.86957428600005],
              [-85.05483964799993, 68.87266673400006],
              [-85.05577551999994, 68.87897370000007],
              [-85.02672278599994, 68.87848541900007],
              [-85.01309160099993, 68.88031647300005],
              [-85.00055904899995, 68.88580963700008],
              [-85.01634680899991, 68.89219798400006],
              [-85.05801347599993, 68.89948151200008],
              [-85.06944739499994, 68.90692780200004],
              [-85.06362870999993, 68.91754791900007],
              [-85.01292883999992, 68.91571686400005],
              [-85.00055904899995, 68.92426178600005],
              [-85.14513098899994, 68.94786204600007],
              [-85.11872311099995, 68.96356842700004],
              [-85.08071855399993, 68.96430084800005],
              [-84.95518958199995, 68.95066966400003],
              [-84.93944251199991, 68.94415924700007],
              [-84.92096920499995, 68.93891022300005],
              [-84.87938391799992, 68.94102610900006],
              [-84.80431067599994, 68.93341705900008],
              [-84.7957250639999, 68.93732330900008],
              [-84.79792232999995, 68.94977448100008],
              [-84.80443274599992, 68.95958079600007],
              [-84.81509355399993, 68.96605052300004],
              [-84.90534420499995, 68.97374095300006],
              [-84.94115149599992, 68.98419830900008],
              [-84.94591223899994, 69.00311920800004],
              [-84.95669511599993, 69.00226471600007],
              [-84.96727454299992, 69.00303782800006],
              [-84.97760982999995, 69.00543854400007],
              [-84.98745683499993, 69.00934479400007],
              [-84.95311438699991, 69.01854075700004],
              [-84.83665930899991, 69.00934479400007],
              [-84.8406469389999, 69.01959870000007],
              [-84.84349524599992, 69.02362702000005],
              [-84.80809485599991, 69.03461334800005],
              [-84.72451738199993, 69.00950755400004],
              [-84.66978919199994, 69.01390208500004],
              [-84.61778723899994, 69.00458405200004],
              [-84.59984290299991, 68.99937571800007],
              [-84.58161373599995, 68.99681224200003],
              [-84.56126868399991, 69.00079987200007],
              [-84.54234778599994, 69.01007721600007],
              [-84.52818762899994, 69.02362702000005],
              [-84.55768795499995, 69.02960846600007],
              [-84.65135657499991, 69.02977122600004],
              [-84.66307532499991, 69.03424713700008],
              [-84.67609615799995, 69.04246653900003],
              [-84.68968665299991, 69.04710521000004],
              [-84.71483313699991, 69.03497955900008],
              [-84.72984778599994, 69.03595612200007],
              [-84.74437415299991, 69.04173411700003],
              [-84.75475012899994, 69.05027903900003],
              [-84.75536048099991, 69.05780670800004],
              [-84.75084387899994, 69.06578196800007],
              [-84.74828040299991, 69.07469310100004],
              [-84.75475012899994, 69.08502838700008],
              [-84.76720130099994, 69.08795807500007],
              [-84.88931230399993, 69.07855866100005],
              [-84.92174231699994, 69.08063385600008],
              [-84.95274817599994, 69.09186432500007],
              [-84.94798743399991, 69.10761139500005],
              [-84.97423255099994, 69.11473216400003],
              [-85.02847245999993, 69.11920807500007],
              [-84.98106848899994, 69.13328685100004],
              [-84.96637936099995, 69.13963450700004],
              [-85.01036536399994, 69.14569733300004],
              [-85.0950414699999, 69.11998118700006],
              [-85.13829505099994, 69.12665436400005],
              [-85.11384029899995, 69.15509674700007],
              [-85.07119706899994, 69.16229889500005],
              [-85.02440344999991, 69.16364166900007],
              [-84.98745683499993, 69.17442454600007],
              [-85.01227779899995, 69.18048737200007],
              [-85.16808020699995, 69.17308177300004],
              [-85.19294186099995, 69.16693756700005],
              [-85.18187415299991, 69.15367259300007],
              [-85.18594316299993, 69.14288971600007],
              [-85.20026607999995, 69.13556549700007],
              [-85.21996008999992, 69.13279857000003],
              [-85.27025305899991, 69.13788483300004],
              [-85.29417883999992, 69.14439524900007],
              [-85.3164770169999, 69.15391673400006],
              [-85.29039466099994, 69.16608307500007],
              [-85.22484290299991, 69.17405833500004],
              [-85.20661373599995, 69.18805573100008],
              [-85.25259355399993, 69.19733307500007],
              [-85.34683183499993, 69.20091380400004],
              [-85.39159094999991, 69.21539948100008],
              [-85.37791907499991, 69.22215403900003],
              [-85.43252519399994, 69.26312897300005],
              [-85.44261633999992, 69.26715729400007],
              [-85.46385657499991, 69.27204010600008],
              [-85.47350012899994, 69.27680084800005],
              [-85.47793535099993, 69.28160228100006],
              [-85.48497473899994, 69.29389069200005],
              [-85.49120032499991, 69.30101146000004],
              [-85.5008031889999, 69.31834544500003],
              [-85.48818925699993, 69.32636139500005],
              [-85.46593176999994, 69.32689036700003],
              [-85.42198645699995, 69.31317780200004],
              [-85.39122473899994, 69.30853913000004],
              [-85.3606664699999, 69.30963776200008],
              [-85.33698482999995, 69.31842682500007],
              [-85.35582434799994, 69.32123444200005],
              [-85.41201738199993, 69.33893463700008],
              [-85.4441625639999, 69.34284088700008],
              [-85.45628821499992, 69.34760163000004],
              [-85.46727454299992, 69.35936107000003],
              [-85.45494544199994, 69.36481354400007],
              [-85.44884192599994, 69.36644114800004],
              [-85.44001217399995, 69.36619700700004],
              [-85.45750891799992, 69.37803782800006],
              [-85.47850501199991, 69.38304271000004],
              [-85.49730383999992, 69.39000071800007],
              [-85.50829016799992, 69.40778229400007],
              [-85.48306230399993, 69.41486237200007],
              [-85.41201738199993, 69.41400788000004],
              [-85.38524329299992, 69.41868724200003],
              [-85.38125566299993, 69.42670319200005],
              [-85.39268958199995, 69.43675364800004],
              [-85.41201738199993, 69.44810618700006],
              [-85.34439042899993, 69.44135163000004],
              [-85.35753333199995, 69.45286692900004],
              [-85.37734941299993, 69.46141185100004],
              [-85.39940344999991, 69.46674225500004],
              [-85.41917883999992, 69.46861399900007],
              [-85.43639075399994, 69.46478913000004],
              [-85.46434485599991, 69.44676341400003],
              [-85.48033606699994, 69.44135163000004],
              [-85.51032467399995, 69.44635651200008],
              [-85.53404700399994, 69.46332428600005],
              [-85.53945878799993, 69.48460521000004],
              [-85.5144750639999, 69.50275299700007],
              [-85.53156490799995, 69.52598704600007],
              [-85.50560462099992, 69.53949616100005],
              [-85.47557532499991, 69.54991282800006],
              [-85.48033606699994, 69.56419505400004],
              [-85.4610082669999, 69.57050202000005],
              [-85.38536536399994, 69.56419505400004],
              [-85.49547278599994, 69.61762116100005],
              [-85.54409745999993, 69.65350983300004],
              [-85.5144750639999, 69.68150462400007],
              [-85.47109941299993, 69.68187083500004],
              [-85.44933020699995, 69.68939850500004],
              [-85.44001217399995, 69.71190013200004],
              [-85.44961503799993, 69.74119700700004],
              [-85.47191321499992, 69.74848053600005],
              [-85.4968969389999, 69.75202057500007],
              [-85.5144750639999, 69.77024974200003],
              [-85.4290258449999, 69.78851959800005],
              [-85.39785722599993, 69.78534577000005],
              [-85.41201738199993, 69.75596751500007],
              [-85.39167232999995, 69.75604889500005],
              [-85.36986243399991, 69.76056549700007],
              [-85.34951738199993, 69.76898834800005],
              [-85.33356686099995, 69.78050364800004],
              [-85.33315995999993, 69.79136790600006],
              [-85.34268144399994, 69.80621979400007],
              [-85.35700436099995, 69.81928131700005],
              [-85.37075761599993, 69.82489655200004],
              [-85.59019934799994, 69.83234284100007],
              [-85.57754472599993, 69.85020579600007],
              [-85.56322180899991, 69.85809967700004],
              [-85.35708574099993, 69.85285065300008],
              [-85.32017981699994, 69.84699127800008],
              [-85.17479407499991, 69.79425690300008],
              [-85.09561113199993, 69.77940501500007],
              [-85.05577551999994, 69.77708567900004],
              [-85.05581620999993, 69.79686107000003],
              [-85.02928626199991, 69.80646393400008],
              [-84.90733801999994, 69.81346263200004],
              [-84.87926184799994, 69.81879303600005],
              [-84.85716712099992, 69.83234284100007],
              [-84.86510169199994, 69.83917877800008],
              [-84.89810136599993, 69.85285065300008],
              [-84.86286373599995, 69.86163971600007],
              [-84.77432206899994, 69.83856842700004],
              [-84.73395748599995, 69.84198639500005],
              [-84.6946508449999, 69.85374583500004],
              [-84.33983313699991, 69.85968659100007],
              [-84.33104407499991, 69.85740794500003],
              [-84.31895911399994, 69.84760163000004],
              [-84.30606035099993, 69.84336985900006],
              [-84.2957250639999, 69.83433665600006],
              [-84.28856360599991, 69.83234284100007],
              [-84.24767005099994, 69.83856842700004],
              [-84.16950436099995, 69.82465241100005],
              [-84.03148352799991, 69.76361725500004],
              [-83.81285559799994, 69.73338450700004],
              [-83.75405839799993, 69.71173737200007],
              [-83.73119055899991, 69.70897044500003],
              [-83.6856176419999, 69.70880768400008],
              [-83.49518795499995, 69.68720123900005],
              [-83.44888261599993, 69.69464752800008],
              [-83.35659745999993, 69.68150462400007],
              [-83.32998613199993, 69.68573639500005],
              [-83.28087317599994, 69.70465729400007],
              [-83.25328528599994, 69.70880768400008],
              [-83.02057857999995, 69.68150462400007],
              [-82.90416419199994, 69.69452545800004],
              [-82.6883031889999, 69.68207428600005],
              [-82.66421464799993, 69.68773021000004],
              [-82.67414303299995, 69.68785228100006],
              [-82.68317623599995, 69.69037506700005],
              [-82.69131425699993, 69.69513580900008],
              [-82.69839433499993, 69.70197174700007],
              [-82.63027910099993, 69.70258209800005],
              [-82.59605872299994, 69.69867584800005],
              [-82.56802324099993, 69.68773021000004],
              [-82.57135982999995, 69.68382396000004],
              [-82.5755102199999, 69.67405833500004],
              [-82.41722571499992, 69.64671458500004],
              [-82.25340735599991, 69.64057038000004],
              [-82.40615800699993, 69.61810944200005],
              [-82.43089758999992, 69.62287018400008],
              [-82.45616614499994, 69.63939036700003],
              [-82.61644446499992, 69.64671458500004],
              [-82.61099199099993, 69.64057038000004],
              [-82.60586503799993, 69.63658274900007],
              [-82.59927324099993, 69.63426341400003],
              [-82.5891820949999, 69.63312409100007],
              [-82.60789954299992, 69.62787506700005],
              [-82.64590410099993, 69.62925853100006],
              [-82.65746008999992, 69.61945221600007],
              [-82.55435136599993, 69.59955475500004],
              [-82.58372962099992, 69.58958567900004],
              [-82.75365149599992, 69.57786692900004],
              [-82.6179906889999, 69.57001373900005],
              [-82.59601803299995, 69.56110260600008],
              [-82.57970130099994, 69.54991282800006],
              [-82.4793188139999, 69.50275299700007],
              [-82.51610266799992, 69.49371979400007],
              [-82.88469397699993, 69.52588532100006],
              [-83.25328528599994, 69.55805084800005],
              [-83.27285722599993, 69.55394114800004],
              [-83.28990637899994, 69.54673899900007],
              [-83.29381262899994, 69.53990306200006],
              [-83.27407792899993, 69.53685130400004],
              [-83.19212805899991, 69.53685130400004],
              [-82.73684648349993, 69.47813548400003],
              [-82.28156490799995, 69.41941966400003],
              [-82.24567623599995, 69.40851471600007],
              [-82.22545325399994, 69.39354075700004],
              [-82.26781165299991, 69.38560618700006],
              [-82.3899633449999, 69.40778229400007],
              [-82.3899633449999, 69.40033600500004],
              [-82.35855058499993, 69.39264557500007],
              [-82.30524654899995, 69.35993073100008],
              [-82.24217688699991, 69.34703196800007],
              [-82.20262610599991, 69.33331940300008],
              [-82.16588294199994, 69.31553782800006],
              [-82.14346269399994, 69.29791901200008],
              [-82.16991126199991, 69.29210032800006],
              [-82.22545325399994, 69.29808177300004],
              [-82.25340735599991, 69.29047272300005],
              [-82.23009192599994, 69.27606842700004],
              [-82.23989824099993, 69.26654694200005],
              [-82.29430091099994, 69.25633372600004],
              [-82.2696020169999, 69.23822663000004],
              [-82.23729407499991, 69.23521556200006],
              [-82.02684485599991, 69.24949778900003],
              [-82.03441321499992, 69.25377024900007],
              [-82.03929602799991, 69.25853099200003],
              [-82.04727128799993, 69.27000560100004],
              [-81.99156653599994, 69.27802155200004],
              [-81.75304114499994, 69.26788971600007],
              [-81.63971920499995, 69.24823639500005],
              [-81.49592037699995, 69.20355866100005],
              [-81.46544348899994, 69.20111725500004],
              [-81.41942298099991, 69.20831940300008],
              [-81.40367591099994, 69.20856354400007],
              [-81.35863196499992, 69.19672272300005],
              [-81.34471594999991, 69.19489166900007],
              [-81.3372289699999, 69.18756745000007],
              [-81.32168535099993, 69.13963450700004],
              [-81.30068925699993, 69.11766185100004],
              [-81.28579667899993, 69.10557689000007],
              [-81.27330481699994, 69.09870026200008],
              [-81.27330481699994, 69.09186432500007],
              [-81.36286373599995, 69.10130442900004],
              [-81.38939368399991, 69.09528229400007],
              [-81.41258704299992, 69.08466217700004],
              [-81.48216712099992, 69.06456126500007],
              [-81.48753821499992, 69.05833567900004],
              [-81.55272376199991, 69.00315989800004],
              [-81.58023027299993, 68.99298737200007],
              [-81.60924231699994, 68.98859284100007],
              [-81.63646399599992, 68.98883698100008],
              [-81.66722571499992, 68.99485911700003],
              [-81.68382727799991, 68.99445221600007],
              [-81.69102942599994, 68.98541901200008],
              [-81.69204667899993, 68.97711823100008],
              [-81.69497636599993, 68.96857330900008],
              [-81.69953365799995, 68.96080149900007],
              [-81.70531165299991, 68.95469798400006],
              [-81.72907467399995, 68.94505442900004],
              [-81.88548743399991, 68.92963288000004],
              [-82.00865637899994, 68.89984772300005],
              [-82.06159420499995, 68.87897370000007],
              [-81.87555904899995, 68.90167877800008],
              [-81.83556067599994, 68.91144440300008],
              [-81.81456458199995, 68.91376373900005],
              [-81.80654863199993, 68.91144440300008],
              [-81.79482988199993, 68.90167877800008],
              [-81.78693600199995, 68.89948151200008],
              [-81.77407792899993, 68.90045807500007],
              [-81.73884029899995, 68.90692780200004],
              [-81.70250403599994, 68.90753815300008],
              [-81.67170162699995, 68.90257396000004],
              [-81.64370683499993, 68.89280833500004],
              [-81.61587480399993, 68.87897370000007],
              [-81.60708574099993, 68.87616608300004],
              [-81.59813391799992, 68.87523021000004],
              [-81.58934485599991, 68.87287018400008],
              [-81.58116614499994, 68.86591217700004],
              [-81.58055579299992, 68.86054108300004],
              [-81.58263098899994, 68.85325755400004],
              [-81.58576412699995, 68.84715403900003],
              [-81.58800208199995, 68.84544505400004],
              [-81.57681230399993, 68.83690013200004],
              [-81.56175696499992, 68.83165110900006],
              [-81.54539954299992, 68.83246491100005],
              [-81.53026282499991, 68.84202708500004],
              [-81.51585852799991, 68.85606517100007],
              [-81.50373287699995, 68.86310455900008],
              [-81.4903051419999, 68.86558665600006],
              [-81.45287024599992, 68.86823151200008],
              [-81.43667558499993, 68.87262604400007],
              [-81.41917883999992, 68.87543366100005],
              [-81.39614824099993, 68.87274811400005],
              [-81.37877356699994, 68.86762116100005],
              [-81.36522376199991, 68.86168040600006],
              [-81.29458574099993, 68.81427643400008],
              [-81.28628495999993, 68.81439850500004],
              [-81.28343665299991, 68.80341217700004],
              [-81.27578691299993, 68.79682038000004],
              [-81.25251217399995, 68.78709544500003],
              [-81.23302161399994, 68.77391185100004],
              [-81.23643958199995, 68.76618073100008],
              [-81.24950110599991, 68.76117584800005],
              [-81.25894120999993, 68.75604889500005],
              [-81.26329505099994, 68.73847077000005],
              [-81.26549231699994, 68.71088288000004],
              [-81.26357988199993, 68.68528880400004],
              [-81.2559301419999, 68.67413971600007],
              [-81.25059973899994, 68.66864655200004],
              [-81.25503495999993, 68.65643952000005],
              [-81.26650956899994, 68.63873932500007],
              [-81.28209387899994, 68.63287995000007],
              [-81.34093176999994, 68.62262604400007],
              [-81.35850989499994, 68.60179271000004],
              [-81.39928137899994, 68.59092845300006],
              [-81.44542395699995, 68.58397044500003],
              [-81.47907467399995, 68.57481517100007],
              [-81.62954667899993, 68.51276276200008],
              [-81.64964758999992, 68.50824616100005],
              [-81.67406165299991, 68.50849030200004],
              [-81.76553300699993, 68.52619049700007],
              [-81.81456458199995, 68.53009674700007],
              [-81.79841061099995, 68.51239655200004],
              [-81.79645748599995, 68.50372955900008],
              [-81.80431067599994, 68.49192942900004],
              [-81.82559160099993, 68.47101471600007],
              [-81.83629309799994, 68.46605052300004],
              [-81.8555395169999, 68.46124909100007],
              [-81.91869055899991, 68.45331452000005],
              [-81.95372473899994, 68.43065013200004],
              [-81.97374426999994, 68.42853424700007],
              [-82.01659094999991, 68.43390534100007],
              [-82.03233801999994, 68.44574616100005],
              [-82.06305904899995, 68.49787018400008],
              [-82.08853105399993, 68.50962962400007],
              [-82.1360570949999, 68.51390208500004],
              [-82.22667395699995, 68.53270091400003],
              [-82.27383378799993, 68.53697337400007],
              [-82.27383378799993, 68.53009674700007],
              [-82.24803626199991, 68.51500071800007],
              [-82.21922766799992, 68.50287506700005],
              [-82.18492591099994, 68.49607982000003],
              [-82.17686926999994, 68.48810455900008],
              [-82.18789628799993, 68.47178782800006],
              [-82.22175045499995, 68.45811595300006],
              [-82.26610266799992, 68.45811595300006],
              [-82.42979895699995, 68.47589752800008],
              [-82.4700414699999, 68.48480866100005],
              [-82.57298743399991, 68.52716705900008],
              [-82.61164303299995, 68.53021881700005],
              [-82.63695227799991, 68.50962962400007],
              [-82.6355688139999, 68.49713776200008],
              [-82.62157141799992, 68.49437083500004],
              [-82.5891820949999, 68.49542877800008],
              [-82.5742895169999, 68.48810455900008],
              [-82.56191972599993, 68.47919342700004],
              [-82.54784094999991, 68.47178782800006],
              [-82.49693762899994, 68.46393463700008],
              [-82.51610266799992, 68.45368073100008],
              [-82.55821692599994, 68.44391510600008],
              [-82.59601803299995, 68.44078196800007],
              [-82.62979081899994, 68.44867584800005],
              [-82.64370683499993, 68.44733307500007],
              [-82.65062415299991, 68.43390534100007],
              [-82.64671790299991, 68.41974518400008],
              [-82.63463294199994, 68.41124095300006],
              [-82.61851966099994, 68.40709056200006],
              [-82.60252844999991, 68.40599192900004],
              [-82.52025305899991, 68.41343821800007],
              [-82.50389563699991, 68.41014232000003],
              [-82.49054928299995, 68.40228913000004],
              [-82.47834225199995, 68.39301178600005],
              [-82.4656469389999, 68.38556549700007],
              [-82.36969967399995, 68.35626862200007],
              [-82.3489477199999, 68.33771393400008],
              [-82.37657630099994, 68.31940338700008],
              [-82.46743730399993, 68.32453034100007],
              [-82.50658118399991, 68.31785716400003],
              [-82.4766332669999, 68.29938385600008],
              [-82.44176184799994, 68.28400299700007],
              [-82.4051000639999, 68.27338288000004],
              [-82.36974036399994, 68.26947663000004],
              [-82.30235755099994, 68.29075755400004],
              [-82.27269446499992, 68.29157135600008],
              [-82.26016191299993, 68.26264069200005],
              [-82.26732337099992, 68.24213288000004],
              [-82.28477942599994, 68.22345612200007],
              [-82.34479732999995, 68.17552317900004],
              [-82.34398352799991, 68.16929759300007],
              [-82.33189856699994, 68.15611399900007],
              [-82.31484941299993, 68.14659251500007],
              [-82.20653235599991, 68.12470123900005],
              [-82.17479407499991, 68.12498607000003],
              [-82.14427649599992, 68.13316478100006],
              [-82.10875403599994, 68.14935944200005],
              [-82.10362708199995, 68.15318431200006],
              [-82.10171464799993, 68.15778229400007],
              [-82.10191809799994, 68.17015208500004],
              [-82.09902910099993, 68.17572663000004],
              [-82.09227454299992, 68.17881907800006],
              [-82.08446204299992, 68.18097565300008],
              [-82.07835852799991, 68.18378327000005],
              [-82.05736243399991, 68.20722077000005],
              [-82.04442298099991, 68.21735260600008],
              [-82.02684485599991, 68.22166575700004],
              [-81.99364173099991, 68.21503327000005],
              [-81.98997962099992, 68.19822825700004],
              [-82.0183813139999, 68.13047923400006],
              [-82.0469457669999, 68.12067291900007],
              [-82.10936438699991, 68.11180247600004],
              [-82.12303626199991, 68.11180247600004],
              [-82.09146074099993, 68.09332916900007],
              [-82.08165442599994, 68.08246491100005],
              [-82.10985266799992, 68.07391998900005],
              [-82.12437903599994, 68.06476471600007],
              [-82.13719641799992, 68.05333079600007],
              [-82.14346269399994, 68.04291413000004],
              [-82.12922115799995, 68.04291413000004],
              [-82.14220130099994, 68.03278229400007],
              [-82.15086829299992, 68.02057526200008],
              [-82.1609594389999, 68.01117584800005],
              [-82.17764238199993, 68.00938548400006],
              [-82.16852779899995, 67.99559153900003],
              [-82.13548743399991, 67.97410716400003],
              [-82.12303626199991, 67.96100495000007],
              [-82.12922115799995, 67.96100495000007],
              [-82.1270238919999, 67.95624420800004],
              [-82.12555904899995, 67.95477936400005],
              [-82.12584387899994, 67.95319245000007],
              [-82.12922115799995, 67.94794342700004],
              [-82.11241614499994, 67.92308177300004],
              [-82.10155188699991, 67.91038646000004],
              [-82.08824622299994, 67.89952220300006],
              [-82.06065833199995, 67.88682689000007],
              [-82.00039628799993, 67.87242259300007],
              [-81.97158769399994, 67.86192454600007],
              [-81.96349036399994, 67.85553620000007],
              [-81.96206620999993, 67.84947337400007],
              [-81.96214758999992, 67.84369538000004],
              [-81.95856686099995, 67.83808014500005],
              [-81.94981848899994, 67.83319733300004],
              [-81.88902747299994, 67.81207916900007],
              [-81.82811438699991, 67.80683014500005],
              [-81.81163489499994, 67.79730866100005],
              [-81.82213294199994, 67.79645416900007],
              [-81.83214270699995, 67.79393138200004],
              [-81.8418676419999, 67.78965892100007],
              [-81.81847083199995, 67.77277252800008],
              [-81.78538977799991, 67.75739166900007],
              [-81.75059973899994, 67.74620189000007],
              [-81.72240149599992, 67.74188873900005],
              [-81.70018469999991, 67.73533763200004],
              [-81.6426488919999, 67.68720123900005],
              [-81.58495032499991, 67.66327545800004],
              [-81.45718339799993, 67.62840403900003],
              [-81.40367591099994, 67.59788646000004],
              [-81.3836156889999, 67.57660553600005],
              [-81.34422766799992, 67.54669830900008],
              [-81.33145097599993, 67.53998444200005],
              [-81.31090247299994, 67.51935455900008],
              [-81.30109615799995, 67.51178620000007],
              [-81.26646887899994, 67.49481842700004],
              [-81.23794511599993, 67.46051666900007],
              [-81.25523841099994, 67.43012116100005],
              [-81.29002844999991, 67.40123118700006],
              [-81.31427975199995, 67.37193431200006],
              [-81.30748450399994, 67.37193431200006],
              [-81.31993567599994, 67.34129466400003],
              [-81.35171464799993, 67.28375885600008],
              [-81.36266028599994, 67.25523509300007],
              [-81.37075761599993, 67.20189036700003],
              [-81.37572180899991, 67.18695709800005],
              [-81.4173070949999, 67.13231028900003],
              [-81.41173255099994, 67.12372467700004],
              [-81.41075598899994, 67.11823151200008],
              [-81.4173070949999, 67.10443756700005],
              [-81.40982011599993, 67.09760163000004],
              [-81.41844641799992, 67.09446849200003],
              [-81.42292232999995, 67.08946360900006],
              [-81.42589270699995, 67.08356354400007],
              [-81.43028723899994, 67.07770416900007],
              [-81.43907630099994, 67.07013580900008],
              [-81.4466039699999, 67.06586334800005],
              [-81.45628821499992, 67.06391022300005],
              [-81.47191321499992, 67.06342194200005],
              [-81.49095618399991, 67.06053294500003],
              [-81.49624589799993, 67.05194733300004],
              [-81.49242102799991, 67.01874420800004],
              [-81.50291907499991, 67.00104401200008],
              [-81.5274145169999, 66.99603913000004],
              [-81.63267981699994, 67.00885651200008],
              [-81.64053300699993, 67.00523509300007],
              [-81.65684973899994, 66.98777903900003],
              [-81.66437740799995, 66.98151276200008],
              [-81.71617591099994, 66.97284577000005],
              [-81.82115637899994, 66.99921295800004],
              [-81.87596594999991, 66.99144114800004],
              [-81.90054277299993, 66.98448314000007],
              [-81.95490475199995, 66.97679271000004],
              [-81.97838294199994, 66.96784088700008],
              [-81.98546301999994, 66.96063873900005],
              [-81.9949438139999, 66.94334544500003],
              [-81.99950110599991, 66.93992747600004],
              [-82.01121985599991, 66.93829987200007],
              [-82.02358964799993, 66.93378327000005],
              [-82.03433183499993, 66.92723216400003],
              [-82.0410863919999, 66.91941966400003],
              [-82.03368079299992, 66.91705963700008],
              [-82.01317298099991, 66.90574778900003],
              [-82.09166419199994, 66.85797760600008],
              [-82.09357662699995, 66.85516998900005],
              [-82.08462480399993, 66.84056224200003],
              [-82.0821020169999, 66.83409251500007],
              [-82.08844967399995, 66.82896556200006],
              [-82.12987219999991, 66.81334056200006],
              [-82.16063391799992, 66.79389069200005],
              [-82.17617753799993, 66.78086985900006],
              [-82.18443762899994, 66.76862213700008],
              [-82.1824438139999, 66.74860260600008],
              [-82.17039954299992, 66.73602936400005],
              [-82.15835527299993, 66.72614166900007],
              [-82.15656490799995, 66.71397532800006],
              [-82.37315833199995, 66.72764720300006],
              [-82.38003495999993, 66.72516510600008],
              [-82.38044186099995, 66.71906159100007],
              [-82.3762914699999, 66.70380280200004],
              [-82.3816625639999, 66.69647858300004],
              [-82.4641820949999, 66.68024323100008],
              [-82.48228919199994, 66.67072174700007],
              [-82.4793188139999, 66.65192291900007],
              [-82.53677324099993, 66.63568756700005],
              [-82.55435136599993, 66.62523021000004],
              [-82.56265214799993, 66.61705149900007],
              [-82.58169511599993, 66.59113190300008],
              [-82.59089107999995, 66.57086823100008],
              [-82.63345292899993, 66.56329987200007],
              [-82.85155188699991, 66.57050202000005],
              [-82.90933183499993, 66.55487702000005],
              [-82.99864661399994, 66.55516185100004],
              [-83.00999915299991, 66.55052317900004],
              [-83.01390540299991, 66.54108307500007],
              [-83.01431230399993, 66.52533600500004],
              [-83.0274145169999, 66.49518463700008],
              [-83.05882727799991, 66.47911204600007],
              [-83.13044186099995, 66.46015045800004],
              [-83.12360592399995, 66.46015045800004],
              [-83.13780676999994, 66.45042552300004],
              [-83.26260331899994, 66.39606354400007],
              [-83.29954993399991, 66.38654205900008],
              [-83.31533769399994, 66.38507721600007],
              [-83.32754472599993, 66.38068268400008],
              [-83.36937415299991, 66.35028717700004],
              [-83.38634192599994, 66.35602448100008],
              [-83.44676673099991, 66.35480377800008],
              [-83.49962317599994, 66.36444733300004],
              [-83.56053626199991, 66.34935130400004],
              [-83.58910071499992, 66.35712311400005],
              [-83.58307857999995, 66.35984935100004],
              [-83.56859290299991, 66.37140534100007],
              [-83.63955644399994, 66.40412018400008],
              [-83.65802975199995, 66.41917552300004],
              [-83.65103105399993, 66.41868724200003],
              [-83.63703365799995, 66.41954173400006],
              [-83.63003495999993, 66.41917552300004],
              [-83.6387426419999, 66.43553294500003],
              [-83.62954667899993, 66.44139232000003],
              [-83.6121313139999, 66.43956126500007],
              [-83.59593665299991, 66.43280670800004],
              [-83.59536699099993, 66.41571686400005],
              [-83.57713782499991, 66.39878978100006],
              [-83.55296790299991, 66.38690827000005],
              [-83.5344945949999, 66.38507721600007],
              [-83.52867591099994, 66.39691803600005],
              [-83.54190019399994, 66.41282786700003],
              [-83.5625707669999, 66.42682526200008],
              [-83.59268144399994, 66.43829987200007],
              [-83.64435787699995, 66.47443268400008],
              [-83.65396074099993, 66.48688385600008],
              [-83.66917883999992, 66.51666901200008],
              [-83.67813066299993, 66.52533600500004],
              [-83.73216712099992, 66.53697337400007],
              [-83.84776770699995, 66.54559967700004],
              [-83.89073645699995, 66.57001373900005],
              [-83.90420488199993, 66.59410228100006],
              [-83.91466223899994, 66.59674713700008],
              [-83.93883216099994, 66.58771393400008],
              [-83.96353105399993, 66.58360423400006],
              [-83.98078365799995, 66.59235260600008],
              [-83.98550370999993, 66.60639069200005],
              [-83.97264563699991, 66.61839427300004],
              [-84.01357988199993, 66.63206614800004],
              [-84.00340735599991, 66.64573802300004],
              [-84.00499426999994, 66.65570709800005],
              [-84.01085364499994, 66.66583893400008],
              [-84.01357988199993, 66.67987702000005],
              [-84.00450598899994, 66.69700755400004],
              [-83.98395748599995, 66.70823802300004],
              [-83.95775305899991, 66.71214427300004],
              [-83.93175208199995, 66.70722077000005],
              [-83.91462154899995, 66.69468821800007],
              [-83.91437740799995, 66.68158600500004],
              [-83.91763261599993, 66.66742584800005],
              [-83.91124426999994, 66.65192291900007],
              [-83.89586341099994, 66.64732493700006],
              [-83.87979081899994, 66.65745677300004],
              [-83.86583411399994, 66.67344798400006],
              [-83.85659745999993, 66.68671295800004],
              [-83.88117428299995, 66.70811595300006],
              [-83.89073645699995, 66.71397532800006],
              [-83.90778561099995, 66.71812571800007],
              [-83.92609615799995, 66.71959056200006],
              [-83.9422094389999, 66.72349681200006],
              [-83.95278886599993, 66.73509349200003],
              [-83.94884192599994, 66.74144114800004],
              [-83.95116126199991, 66.74335358300004],
              [-83.95897376199991, 66.74811432500007],
              [-83.94367428299995, 66.77094147300005],
              [-83.90001380099994, 66.79087962400007],
              [-83.88451087099992, 66.81708405200004],
              [-83.88337154899995, 66.83873118700006],
              [-83.89037024599992, 66.85724518400008],
              [-83.90282141799992, 66.87278880400004],
              [-83.91808020699995, 66.88593170800004],
              [-83.92536373599995, 66.87262604400007],
              [-83.9348852199999, 66.84027741100005],
              [-83.94253495999993, 66.82697174700007],
              [-83.96519934799994, 66.81126536700003],
              [-84.01939856699994, 66.79942454600007],
              [-84.04841061099995, 66.78974030200004],
              [-84.02904212099992, 66.78392161700003],
              [-84.0481664699999, 66.77130768400008],
              [-84.10362708199995, 66.74811432500007],
              [-84.09776770699995, 66.71930573100008],
              [-84.13792883999992, 66.71222565300008],
              [-84.26939856699994, 66.72785065300008],
              [-84.30260169199994, 66.74131907800006],
              [-84.30825761599993, 66.76007721600007],
              [-84.26813717399995, 66.78229401200008],
              [-84.3035375639999, 66.80101146000004],
              [-84.41193600199995, 66.80731842700004],
              [-84.43944251199991, 66.83067454600007],
              [-84.38931230399993, 66.83515045800004],
              [-84.24014238199993, 66.83067454600007],
              [-84.24014238199993, 66.83751048400006],
              [-84.37262936099995, 66.86737702000005],
              [-84.41148841099994, 66.88593170800004],
              [-84.41576087099992, 66.90778229400007],
              [-84.41079667899993, 66.91632721600007],
              [-84.39102128799993, 66.91941966400003],
              [-84.40831458199995, 66.93500397300005],
              [-84.43732662699995, 66.94074127800008],
              [-84.49376380099994, 66.93992747600004],
              [-84.5125219389999, 66.94501373900005],
              [-84.56627356699994, 66.97064850500004],
              [-84.5828344389999, 66.98151276200008],
              [-84.53180904899995, 66.97907135600008],
              [-84.41991126199991, 66.96161530200004],
              [-84.37051347599993, 66.97406647300005],
              [-84.8093969389999, 67.02928294500003],
              [-84.84142005099994, 67.03681061400005],
              [-84.91006425699993, 67.06187571800007],
              [-84.93907630099994, 67.05597565300008],
              [-84.9212133449999, 67.05109284100007],
              [-84.90493730399993, 67.04295482000003],
              [-84.9207250639999, 67.03758372600004],
              [-84.92926998599995, 67.03607819200005],
              [-84.93907630099994, 67.03681061400005],
              [-84.91771399599992, 67.02802155200004],
              [-84.84349524599992, 67.01500071800007],
              [-84.8504125639999, 67.00568268400008],
              [-84.85985266799992, 67.00023021000004],
              [-84.88451087099992, 66.99457428600005],
              [-84.85399329299992, 66.98798248900005],
              [-84.82530676999994, 66.99335358300004],
              [-84.79702714799993, 67.00287506700005],
              [-84.76773027299993, 67.00885651200008],
              [-84.73595130099994, 67.00787995000007],
              [-84.70034745999993, 67.00263092700004],
              [-84.66588294199994, 66.99363841400003],
              [-84.63744055899991, 66.98151276200008],
              [-85.00462805899991, 66.96808502800008],
              [-85.21279863199993, 66.91941966400003],
              [-85.19762122299994, 66.91303131700005],
              [-85.16234290299991, 66.91083405200004],
              [-85.14513098899994, 66.90574778900003],
              [-85.16519120999993, 66.89642975500004],
              [-85.18447831899994, 66.88458893400008],
              [-85.20457923099991, 66.87848541900007],
              [-85.22712154899995, 66.88593170800004],
              [-85.21524003799993, 66.86766185100004],
              [-85.18659420499995, 66.85224030200004],
              [-85.15339107999995, 66.84153880400004],
              [-85.12779700399994, 66.83751048400006],
              [-85.09911048099991, 66.84385814000007],
              [-85.08263098899994, 66.84943268400008],
              [-85.07286536399994, 66.85460032800006],
              [-85.06114661399994, 66.85797760600008],
              [-84.97842363199993, 66.85984935100004],
              [-84.95775305899991, 66.86448802300004],
              [-84.94066321499992, 66.87360260600008],
              [-84.92198645699995, 66.88902415600006],
              [-84.91075598899994, 66.90143463700008],
              [-84.91038977799991, 66.90863678600005],
              [-84.92023678299995, 66.91185130400004],
              [-84.98452714799993, 66.91539134300007],
              [-85.00055904899995, 66.91941966400003],
              [-84.97451738199993, 66.92914459800005],
              [-84.9199926419999, 66.91600169500003],
              [-84.89126542899993, 66.91941966400003],
              [-84.88491777299993, 66.92649974200003],
              [-84.88377844999991, 66.93537018400008],
              [-84.88133704299992, 66.94293854400007],
              [-84.8711645169999, 66.94611237200007],
              [-84.76744544199994, 66.95555247600004],
              [-84.75475012899994, 66.95355866100005],
              [-84.74522864499994, 66.94867584800005],
              [-84.72834225199995, 66.93573639500005],
              [-84.71996008999992, 66.93309153900003],
              [-84.60334225199995, 66.93992747600004],
              [-84.61506100199995, 66.92230866100005],
              [-84.60928300699993, 66.91034577000005],
              [-84.59121660099993, 66.90481191600009],
              [-84.74730383999992, 66.89960358300004],
              [-84.69505774599992, 66.89549388200004],
              [-84.61656653599994, 66.87742747600004],
              [-84.54360917899993, 66.85138580900008],
              [-84.50837154899995, 66.82322825700004],
              [-84.55329342399995, 66.82819245000007],
              [-84.65208899599992, 66.85333893400008],
              [-84.6926977199999, 66.84495677300004],
              [-84.65013587099992, 66.82408274900007],
              [-84.54857337099992, 66.81806061400005],
              [-84.50088456899994, 66.80955638200004],
              [-84.44123287699995, 66.78624095300006],
              [-84.41832434799994, 66.78229401200008],
              [-84.34337317599994, 66.78318919500003],
              [-84.32213294199994, 66.77606842700004],
              [-84.34813391799992, 66.75910065300008],
              [-84.4219457669999, 66.72882721600007],
              [-84.4524633449999, 66.72081126500007],
              [-84.43321692599994, 66.71405670800004],
              [-84.37051347599993, 66.70722077000005],
              [-84.3523656889999, 66.70091380400004],
              [-84.32982337099992, 66.68463776200008],
              [-84.31529700399994, 66.67987702000005],
              [-84.30736243399991, 66.68170807500007],
              [-84.27497311099995, 66.69696686400005],
              [-84.2630102199999, 66.70014069200005],
              [-84.25255286399994, 66.69871653900003],
              [-84.2429906889999, 66.69554271000004],
              [-84.23338782499991, 66.69354889500005],
              [-84.16600501199991, 66.69208405200004],
              [-84.1446020169999, 66.68671295800004],
              [-84.14834550699993, 66.67719147300005],
              [-84.14683997299994, 66.67112864800004],
              [-84.14427649599992, 66.66583893400008],
              [-84.1446020169999, 66.65875885600008],
              [-84.15062415299991, 66.64935944200005],
              [-84.16828365799995, 66.62995026200008],
              [-84.17735755099994, 66.61163971600007],
              [-84.19009355399993, 66.60809967700004],
              [-84.20490475199995, 66.60618724200003],
              [-84.21629798099991, 66.60138580900008],
              [-84.2110082669999, 66.59454987200007],
              [-84.07567298099991, 66.52240631700005],
              [-84.03750566299993, 66.51105377800008],
              [-84.00987708199995, 66.49180735900006],
              [-83.99746660099993, 66.48749420800004],
              [-83.98070227799991, 66.48472728100006],
              [-83.96324622299994, 66.47789134300007],
              [-83.93175208199995, 66.46015045800004],
              [-83.89403235599991, 66.43219635600008],
              [-83.87730872299994, 66.41380442900004],
              [-83.87022864499994, 66.39557526200008],
              [-83.87169348899994, 66.35138580900008],
              [-83.86974036399994, 66.32990143400008],
              [-83.86278235599991, 66.31675853100006],
              [-83.83421790299991, 66.30821360900006],
              [-83.80557206899994, 66.30829498900005],
              [-83.78355872299994, 66.30137767100007],
              [-83.77464758999992, 66.27179596600007],
              [-83.76154537699995, 66.25470612200007],
              [-83.70164954299992, 66.22797272300005],
              [-83.68529212099992, 66.21373118700006],
              [-83.69078528599994, 66.19920482000003],
              [-83.71153723899994, 66.19090403900003],
              [-83.7610570949999, 66.17963288000004],
              [-83.80663001199991, 66.16319407800006],
              [-83.8313695949999, 66.15839264500005],
              [-83.85659745999993, 66.15851471600007],
              [-83.84727942599994, 66.17243073100008],
              [-83.83462480399993, 66.17963288000004],
              [-83.82017981699994, 66.18561432500007],
              [-83.80508378799993, 66.19635651200008],
              [-83.80089270699995, 66.19822825700004],
              [-83.79133053299995, 66.20433177300004],
              [-83.7852270169999, 66.21076080900008],
              [-83.79141191299993, 66.21373118700006],
              [-83.82896887899994, 66.21373118700006],
              [-83.92223059799994, 66.20331452000005],
              [-83.97118079299992, 66.20408763200004],
              [-83.98009192599994, 66.22117747600004],
              [-84.00267493399991, 66.23407623900005],
              [-84.08934485599991, 66.24848053600005],
              [-84.11705481699994, 66.25755442900004],
              [-84.13072669199994, 66.26410553600005],
              [-84.14118404899995, 66.27179596600007],
              [-84.1465551419999, 66.28058502800008],
              [-84.15025794199994, 66.29926178600005],
              [-84.15453040299991, 66.30621979400007],
              [-84.17756100199995, 66.31915924700007],
              [-84.20384680899991, 66.32420482000003],
              [-84.23037675699993, 66.32200755400004],
              [-84.25413977799991, 66.31305573100008],
              [-84.3028051419999, 66.30308665600006],
              [-84.32290605399993, 66.29405345300006],
              [-84.30907141799992, 66.28257884300007],
              [-84.32632402299993, 66.27692291900007],
              [-84.34874426999994, 66.27777741100005],
              [-84.37083899599992, 66.28363678600005],
              [-84.38731848899994, 66.29258860900006],
              [-84.39781653599994, 66.30430735900006],
              [-84.40086829299992, 66.31427643400008],
              [-84.40151933499993, 66.32444896000004],
              [-84.40534420499995, 66.33722565300008],
              [-84.42373613199993, 66.36139557500007],
              [-84.44933020699995, 66.37592194200005],
              [-84.48029537699995, 66.38304271000004],
              [-84.51451575399994, 66.38507721600007],
              [-84.50088456899994, 66.39927806200006],
              [-84.53746497299994, 66.40521881700005],
              [-84.56566321499992, 66.38682689000007],
              [-84.59219316299993, 66.36249420800004],
              [-84.63670813699991, 66.34385814000007],
              [-84.62547766799992, 66.32977936400005],
              [-84.60334225199995, 66.31574127800008],
              [-84.58315995999993, 66.30931224200003],
              [-84.56725012899994, 66.30768463700008],
              [-84.55386308499993, 66.30292389500005],
              [-84.5423070949999, 66.29559967700004],
              [-84.50767981699994, 66.26776764500005],
              [-84.42516028599994, 66.22736237200007],
              [-84.40176347599993, 66.21039459800005],
              [-84.38174394399994, 66.19004954600007],
              [-84.37832597599993, 66.17304108300004],
              [-84.40465247299994, 66.16596100500004],
              [-84.48009192599994, 66.16596100500004],
              [-84.49233964799993, 66.16941966400003],
              [-84.53502356699994, 66.19330475500004],
              [-84.60741126199991, 66.21458567900004],
              [-84.75206458199995, 66.22142161700003],
              [-84.78302975199995, 66.22699616100005],
              [-84.81623287699995, 66.24103424700007],
              [-84.85415605399993, 66.26353587400007],
              [-84.87083899599992, 66.26837799700007],
              [-84.89118404899995, 66.26866282800006],
              [-84.92540442599994, 66.25763580900008],
              [-84.94249426999994, 66.25470612200007],
              [-84.9837133449999, 66.25433991100005],
              [-85.00137285099993, 66.25910065300008],
              [-85.01793372299994, 66.27179596600007],
              [-85.03774980399993, 66.27985260600008],
              [-85.06371008999992, 66.28192780200004],
              [-85.08315995999993, 66.28681061400005],
              [-85.08364824099993, 66.30308665600006],
              [-85.08820553299995, 66.30927155200004],
              [-85.09675045499995, 66.31846751500007],
              [-85.10732988199993, 66.32684967700004],
              [-85.11782792899993, 66.33038971600007],
              [-85.13609778599994, 66.32640208500004],
              [-85.13654537699995, 66.31724681200006],
              [-85.13084876199991, 66.30589427300004],
              [-85.13084876199991, 66.29564036700003],
              [-85.13963782499991, 66.28925202000005],
              [-85.17931067599994, 66.26837799700007],
              [-85.19709225199995, 66.26508209800005],
              [-85.21963456899994, 66.26557038000004],
              [-85.24156653599994, 66.27008698100008],
              [-85.25747636599993, 66.27887604400007],
              [-85.26781165299991, 66.28693268400008],
              [-85.28486781399994, 66.33355501100004],
              [-85.27968221999993, 66.36070735400006],
              [-85.31297021899991, 66.37242410800008],
              [-85.31594566399991, 66.38795547000007],
              [-85.30057845999994, 66.40647172800004],
              [-85.31559848199993, 66.44438334900008],
              [-85.3223358809999, 66.47953381600007],
              [-85.3464791529999, 66.50113036900007],
              [-85.37795533299993, 66.51578515100005],
              [-85.3892108309999, 66.53517092200008],
              [-85.41607263899994, 66.56698061400004],
              [-85.46547904499994, 66.57442544000008],
              [-85.5296216129999, 66.56674862600005],
              [-85.68227201899992, 66.53060816500005],
              [-85.7515644749999, 66.51765504300005],
              [-85.78286493699994, 66.50009489100006],
              [-85.84032141799992, 66.50482819200005],
              [-85.85252844999991, 66.50202057500007],
              [-85.90583248599995, 66.51536692900004],
              [-86.13882402299993, 66.50108470300006],
              [-86.15493730399993, 66.50438060100004],
              [-86.1895238919999, 66.51890696800007],
              [-86.20714270699995, 66.52220286700003],
              [-86.26475989499994, 66.51874420800004],
              [-86.28286699099993, 66.52220286700003],
              [-86.29824785099993, 66.53107330900008],
              [-86.32652747299994, 66.55280182500007],
              [-86.34373938699991, 66.55634186400005],
              [-86.36131751199991, 66.55011627800008],
              [-86.37205969999991, 66.53778717700004],
              [-86.3809301419999, 66.52448151200008],
              [-86.39273027299993, 66.51536692900004],
              [-86.41661536399994, 66.51500071800007],
              [-86.52562415299991, 66.54950592700004],
              [-86.57225501199991, 66.55577220300006],
              [-86.59752356699994, 66.55634186400005],
              [-86.58226477799991, 66.53965892100007],
              [-86.57713782499991, 66.53587474200003],
              [-86.62047278599994, 66.50694407800006],
              [-86.68057206899994, 66.51597728100006],
              [-86.74034583199995, 66.53156159100007],
              [-86.7825414699999, 66.52220286700003],
              [-86.74730383999992, 66.49603913000004],
              [-86.63170325399994, 66.44025299700007],
              [-86.66673743399991, 66.43097565300008],
              [-86.78937740799995, 66.45392487200007],
              [-86.80785071499992, 66.44627513200004],
              [-86.79100501199991, 66.42894114800004],
              [-86.69347083199995, 66.36583079600007],
              [-86.64879309799994, 66.32701243700006],
              [-86.62059485599991, 66.31439850500004],
              [-86.54320227799991, 66.31297435100004],
              [-86.47036699099993, 66.29539622600004],
              [-86.34373938699991, 66.28941478100006],
              [-86.32628333199995, 66.28599681200006],
              [-86.2754613919999, 66.26837799700007],
              [-85.95616614499994, 66.19965241100005],
              [-85.89202065299992, 66.19341073100009],
              [-85.85666193299994, 66.16282974700005],
              [-85.89956212699991, 66.14766401200006],
              [-85.93029760399992, 66.12430284200008],
              [-85.97482921999995, 66.09827969500003],
              [-85.97435462099992, 66.07591380400004],
              [-85.98420162699995, 66.06529368700006],
              [-85.98631751199991, 66.05479564000007],
              [-85.9824926419999, 66.04486725500004],
              [-85.97435462099992, 66.03558991100005],
              [-86.06334387899994, 65.99909088700008],
              [-86.09414628799993, 65.99400462400007],
              [-86.16173255099994, 65.99103424700007],
              [-86.19424394399994, 65.98407623900005],
              [-86.20147635099994, 65.96263205300005],
              [-86.19896807499993, 65.94987236000009],
              [-86.2049490409999, 65.93974746300006],
              [-86.22671595399993, 65.93303832100008],
              [-86.25992189599992, 65.92902809400005],
              [-86.29259192599994, 65.92999909100007],
              [-86.30955969999991, 65.92572663000004],
              [-86.31598873599995, 65.92198314000007],
              [-86.31867428299995, 65.91864655200004],
              [-86.32188880099994, 65.91535065300008],
              [-86.33006751199991, 65.91209544500003],
              [-86.3465063139999, 65.90778229400007],
              [-86.36481686099995, 65.90521881700005],
              [-86.39712480399993, 65.90582916900007],
              [-86.41246497299994, 65.90448639500005],
              [-86.42625891799992, 65.89838288000004],
              [-86.42129472599993, 65.88263580900008],
              [-86.43932044199994, 65.86908600500004],
              [-86.46288001199991, 65.85557689000007],
              [-86.4746801419999, 65.84003327000005],
              [-86.4727270169999, 65.83771393400008],
              [-86.4688207669999, 65.83628978100006],
              [-86.46597245999993, 65.83429596600007],
              [-86.46719316299993, 65.83014557500007],
              [-86.47276770699995, 65.82648346600007],
              [-86.49071204299992, 65.81830475500004],
              [-86.49453691299993, 65.81586334800005],
              [-86.48916581899994, 65.80414459800005],
              [-86.47695878799993, 65.79661692900004],
              [-86.46336829299992, 65.79035065300008],
              [-86.45360266799992, 65.78233470300006],
              [-86.46385657499991, 65.77720774900007],
              [-86.46422278599994, 65.77277252800008],
              [-86.4610082669999, 65.76780833500004],
              [-86.46035722599993, 65.76121653900003],
              [-86.46149654899995, 65.75482819200005],
              [-86.46153723899994, 65.74961985900006],
              [-86.46450761599993, 65.74347565300008],
              [-86.4746801419999, 65.73395416900007],
              [-86.52232825399994, 65.70526764500005],
              [-86.53612219999991, 65.69297923400006],
              [-86.53864498599995, 65.68846263200004],
              [-86.5410863919999, 65.68268463700008],
              [-86.54442298099991, 65.67694733300004],
              [-86.54979407499991, 65.67247142100007],
              [-86.55915279899995, 65.66986725500004],
              [-86.59072831899994, 65.67247142100007],
              [-86.61514238199993, 65.67015208500004],
              [-86.66388912699995, 65.65766022300005],
              [-86.68691972599993, 65.64826080900008],
              [-86.7024633449999, 65.63873932500007],
              [-86.72655188699991, 65.61688873900005],
              [-86.74217688699991, 65.60728587400007],
              [-86.7930395169999, 65.58409251500007],
              [-86.80675208199995, 65.57318756700005],
              [-86.82591712099992, 65.56163157800006],
              [-86.84972083199995, 65.55638255400004],
              [-86.89549719999991, 65.55516185100004],
              [-86.97057044199994, 65.54181549700007],
              [-86.98794511599993, 65.53534577000005],
              [-86.9844457669999, 65.53229401200008],
              [-86.97435462099992, 65.52167389500005],
              [-86.98298092399995, 65.51642487200007],
              [-87.00088456899994, 65.51133860900006],
              [-87.00845292899993, 65.50800202000005],
              [-87.01146399599992, 65.50348541900007],
              [-87.0137426419999, 65.49656810100004],
              [-87.01500403599994, 65.49022044500003],
              [-87.01528886599993, 65.48749420800004],
              [-87.03441321499992, 65.48423899900007],
              [-87.06696529899995, 65.48834870000007],
              [-87.08421790299991, 65.48411692900004],
              [-87.0930883449999, 65.47894928600005],
              [-87.10435950399994, 65.47052643400008],
              [-87.11412512899994, 65.46039459800005],
              [-87.11831620999993, 65.45001862200007],
              [-87.10997473899994, 65.43537018400008],
              [-87.07282467399995, 65.42808665600006],
              [-87.06371008999992, 65.41864655200004],
              [-87.07860266799992, 65.40208567900004],
              [-87.15583248599995, 65.39288971600007],
              [-87.18350175699993, 65.38141510600008],
              [-87.19505774599992, 65.37225983300004],
              [-87.20986894399994, 65.36705149900007],
              [-87.25942949099993, 65.36155833500004],
              [-87.31012936099995, 65.34349192900004],
              [-87.38076738199993, 65.32969798400006],
              [-87.65412350149992, 65.33156972850006],
              [-87.92747962099992, 65.33344147300005],
              [-88.06387285099993, 65.35948314000007],
              [-88.17039954299992, 65.39996979400007],
              [-88.20547441299993, 65.40509674700007],
              [-88.22191321499992, 65.41181061400005],
              [-88.23180091099994, 65.41990794500003],
              [-88.24693762899994, 65.43866608300004],
              [-88.25548255099994, 65.44651927300004],
              [-88.29185950399994, 65.46430084800005],
              [-88.30040442599994, 65.46702708500004],
              [-88.30646725199995, 65.47138092700004],
              [-88.32526607999995, 65.49058665600006],
              [-88.33458411399994, 65.49494049700007],
              [-88.35578365799995, 65.49994538000004],
              [-88.41787675699993, 65.52619049700007],
              [-88.46157792899993, 65.55357493700006],
              [-88.55028235599991, 65.58311595300006],
              [-88.58324133999992, 65.58946360900006],
              [-88.66193600199995, 65.59540436400005],
              [-88.69115149599992, 65.60728587400007],
              [-88.72179114499994, 65.62437571800007],
              [-88.7586156889999, 65.63434479400007],
              [-88.83141028599994, 65.64520905200004],
              [-88.58458411399994, 65.64524974200003],
              [-88.48062089799993, 65.62824127800008],
              [-88.42088782499991, 65.62498607000003],
              [-88.41368567599994, 65.63153717700004],
              [-88.44810950399994, 65.64329661700003],
              [-88.7429906889999, 65.67462799700007],
              [-88.78384355399993, 65.68402741100005],
              [-88.80410722599993, 65.68614329600007],
              [-88.81895911399994, 65.68992747600004],
              [-88.84532630099994, 65.70380280200004],
              [-88.85903886599993, 65.70294830900008],
              [-88.87360592399995, 65.69953034100007],
              [-88.97012285099993, 65.69651927300004],
              [-88.9890844389999, 65.69981517100007],
              [-89.05113684799994, 65.72028229400007],
              [-89.10936438699991, 65.72846100500004],
              [-89.12559973899994, 65.73395416900007],
              [-89.13646399599992, 65.74290599200003],
              [-89.14053300699993, 65.75214264500005],
              [-89.1426488919999, 65.76093170800004],
              [-89.14736894399994, 65.76866282800006],
              [-89.16047115799995, 65.77667877800008],
              [-89.22720292899993, 65.79975006700005],
              [-89.27122962099992, 65.80845774900007],
              [-89.29100501199991, 65.80967845300006],
              [-89.31090247299994, 65.81329987200007],
              [-89.32135982999995, 65.82184479400007],
              [-89.32852128799993, 65.83189524900007],
              [-89.33849036399994, 65.84003327000005],
              [-89.40843665299991, 65.86701080900008],
              [-89.4480688139999, 65.87559642100007],
              [-89.47569739499994, 65.87107982000003],
              [-89.46930904899995, 65.86090729400007],
              [-89.47826087099992, 65.85594310100004],
              [-89.49445553299995, 65.85594310100004],
              [-89.5098363919999, 65.86058177300004],
              [-89.51984615799995, 65.86884186400005],
              [-89.52790279899995, 65.88764069200005],
              [-89.5371801419999, 65.89838288000004],
              [-89.55239824099993, 65.90513743700006],
              [-89.63817298099991, 65.92316315300008],
              [-89.67145748599995, 65.94074127800008],
              [-89.68797766799992, 65.94684479400007],
              [-89.7051488919999, 65.94623444200005],
              [-89.75999915299991, 65.93598053600005],
              [-89.77578691299993, 65.94318268400008],
              [-89.96739661399994, 65.95579661700003],
              [-90.00389563699991, 65.94684479400007],
              [-89.76707923099991, 65.89264557500007],
              [-89.74323482999995, 65.87791575700004],
              [-89.73045813699991, 65.85887278900003],
              [-89.73265540299991, 65.84153880400004],
              [-89.74693762899994, 65.82868073100008],
              [-89.77057857999995, 65.82269928600005],
              [-89.80109615799995, 65.82404205900008],
              [-89.83747311099995, 65.83091868700006],
              [-89.87205969999991, 65.84312571800007],
              [-89.89745032499991, 65.86058177300004],
              [-89.91014563699991, 65.86566803600005],
              [-89.96914628799993, 65.87107982000003],
              [-90.02623450399994, 65.88898346600007],
              [-90.0442602199999, 65.89158763200004],
              [-90.10789954299992, 65.89020416900007],
              [-90.13853919199994, 65.88519928600005],
              [-90.16779537699995, 65.87449778900003],
              [-90.22866777299993, 65.85936107000003],
              [-90.30223548099991, 65.86017487200007],
              [-90.43529212099992, 65.88475169500003],
              [-90.40339107999995, 65.89667389500005],
              [-90.3665258449999, 65.90025462400007],
              [-90.29100501199991, 65.89838288000004],
              [-90.22240149599992, 65.90521881700005],
              [-90.21711178299995, 65.90709056200006],
              [-90.21475175699993, 65.91160716400003],
              [-90.21544348899994, 65.91734446800007],
              [-90.21898352799991, 65.92267487200007],
              [-90.22667395699995, 65.92609284100007],
              [-90.23696855399993, 65.92686595300006],
              [-90.40078691299993, 65.90521881700005],
              [-90.72321529849992, 65.92336660350006],
              [-91.04564368399991, 65.94151439000007],
              [-91.08592688699991, 65.95087311400005],
              [-91.1062719389999, 65.95298899900007],
              [-91.18199622299994, 65.94684479400007],
              [-91.31029212099992, 65.97593821800007],
              [-91.34679114499994, 65.97044505400004],
              [-91.38320878799993, 65.96076080900008],
              [-91.46344967399995, 65.95811595300006],
              [-91.49730383999992, 65.94684479400007],
              [-91.12051347599993, 65.84320709800005],
              [-91.06285559799994, 65.81610748900005],
              [-91.03164628799993, 65.80833567900004],
              [-91.00446529899995, 65.81586334800005],
              [-91.06590735599991, 65.85687897300005],
              [-91.09243730399993, 65.88446686400005],
              [-91.10850989499994, 65.89756907800006],
              [-91.12734941299993, 65.90521881700005],
              [-91.10765540299991, 65.92304108300004],
              [-91.07046464799993, 65.92845286700003],
              [-90.95506751199991, 65.92035553600005],
              [-90.89574133999992, 65.90375397300005],
              [-90.70103919199994, 65.89158763200004],
              [-90.52969316299993, 65.88194407800006],
              [-90.30068925699993, 65.84031810100004],
              [-90.09422766799992, 65.82115306200006],
              [-89.95811926999994, 65.79429759300007],
              [-89.85098222599993, 65.75157298400006],
              [-89.77334550699993, 65.73883698100008],
              [-89.7363988919999, 65.72772858300004],
              [-89.64329993399991, 65.67247142100007],
              [-89.63320878799993, 65.66819896000004],
              [-89.61310787699995, 65.64948151200008],
              [-89.60265051999994, 65.64520905200004],
              [-89.58482825399994, 65.64264557500007],
              [-89.49144446499992, 65.61579010600008],
              [-89.46812903599994, 65.60590241100005],
              [-89.45384680899991, 65.58869049700007],
              [-89.44904537699995, 65.55890534100007],
              [-89.44253495999993, 65.54474518400008],
              [-89.42715410099993, 65.52745189000007],
              [-89.40892493399991, 65.51154205900008],
              [-89.39378821499992, 65.50116608300004],
              [-89.25853430899991, 65.45648834800005],
              [-89.21939042899993, 65.45160553600005],
              [-89.2012426419999, 65.44660065300008],
              [-89.18423417899993, 65.43895091400003],
              [-89.1653539699999, 65.42466868700006],
              [-89.15587317599994, 65.41990794500003],
              [-89.15050208199995, 65.41522858300004],
              [-89.14818274599992, 65.40961334800005],
              [-89.14891516799992, 65.39679596600007],
              [-89.14736894399994, 65.39191315300008],
              [-89.12913977799991, 65.37726471600007],
              [-89.08580481699994, 65.35419342700004],
              [-89.06786048099991, 65.34007396000004],
              [-89.0398656889999, 65.32819245000007],
              [-88.96743730399993, 65.34296295800004],
              [-88.93382727799991, 65.34349192900004],
              [-88.89537512899994, 65.32672760600008],
              [-88.87922115799995, 65.32245514500005],
              [-88.61774654899995, 65.31391022300005],
              [-88.54710852799991, 65.29918040600006],
              [-88.12120520699995, 65.28038157800006],
              [-88.07725989499994, 65.26776764500005],
              [-88.04588782499991, 65.26805247600004],
              [-87.97752844999991, 65.28412506700005],
              [-87.94102942599994, 65.28827545800004],
              [-87.83145097599993, 65.28204987200007],
              [-87.77774003799993, 65.26911041900007],
              [-87.75088456899994, 65.26752350500004],
              [-87.73468990799995, 65.28204987200007],
              [-87.74893144399994, 65.28827545800004],
              [-87.71108964799993, 65.30101146000004],
              [-87.65965735599991, 65.30060455900008],
              [-87.60830644399994, 65.29161204600007],
              [-87.52765865799995, 65.26825592700004],
              [-87.37279212099992, 65.27521393400008],
              [-87.0469457669999, 65.23798248900005],
              [-87.03547115799995, 65.22996653900003],
              [-87.03807532499991, 65.21885814000007],
              [-87.05687415299991, 65.20636627800008],
              [-87.03425045499995, 65.19428131700005],
              [-86.97842363199993, 65.17963288000004],
              [-86.95384680899991, 65.16535065300008],
              [-86.93822180899991, 65.14195384300007],
              [-86.95132402299993, 65.13031647300005],
              [-86.97598222599993, 65.12079498900005],
              [-86.99478105399993, 65.10394928600005],
              [-86.99254309799994, 65.08283112200007],
              [-86.97793535099993, 65.06928131700005],
              [-86.97362219999991, 65.05756256700005],
              [-87.00226803299995, 65.04185618700006],
              [-87.08482825399994, 65.01532623900005],
              [-87.11148027299993, 65.00092194200005],
              [-87.10045325399994, 64.99669017100007],
              [-87.0906469389999, 64.99079010600008],
              [-87.08263098899994, 64.98297760600008],
              [-87.07738196499992, 64.97296784100007],
              [-87.10562089799993, 64.95160553600005],
              [-87.11831620999993, 64.94562409100007],
              [-87.13581295499995, 64.94249095300006],
              [-87.15274003799993, 64.94232819200005],
              [-87.16881262899994, 64.93964264500005],
              [-87.18350175699993, 64.92890045800004],
              [-87.20262610599991, 64.91058991100005],
              [-87.24478105399993, 64.88056061400005],
              [-87.27501380099994, 64.84996165600006],
              [-87.30431067599994, 64.81260814000007],
              [-87.31012936099995, 64.79857005400004],
              [-87.30736243399991, 64.78790924700007],
              [-87.29820716099994, 64.77061595300006],
              [-87.30020097599993, 64.76439036700003],
              [-87.31529700399994, 64.75889720300006],
              [-87.35594641799992, 64.75779857000003],
              [-87.37279212099992, 64.75385163000004],
              [-87.41637122299994, 64.71991608300004],
              [-87.44473222599993, 64.70758698100008],
              [-87.47118079299992, 64.71629466400003],
              [-87.47276770699995, 64.72589752800008],
              [-87.46812903599994, 64.73615143400008],
              [-87.46861731699994, 64.74433014500005],
              [-87.4851781889999, 64.74766673400006],
              [-87.49649003799993, 64.74323151200008],
              [-87.51065019399994, 64.73301829600007],
              [-87.52306067599994, 64.72142161700003],
              [-87.52920488199993, 64.71287669500003],
              [-87.52769934799994, 64.69932689000007],
              [-87.5130102199999, 64.66315338700008],
              [-87.50938880099994, 64.64769114800004],
              [-87.51353919199994, 64.63410065300008],
              [-87.52358964799993, 64.62571849200003],
              [-87.54662024599992, 64.61359284100007],
              [-87.55630449099993, 64.60260651200008],
              [-87.56920325399994, 64.57929108300004],
              [-87.57762610599991, 64.56952545800004],
              [-87.59996497299994, 64.55817291900007],
              [-87.76427161399994, 64.52240631700005],
              [-87.80508378799993, 64.51996491100005],
              [-87.8098852199999, 64.51605866100005],
              [-87.81069902299993, 64.50861237200007],
              [-87.81041419199994, 64.49689362200007],
              [-87.81297766799992, 64.48712799700007],
              [-87.8196508449999, 64.48016998900005],
              [-87.83828691299993, 64.46588776200008],
              [-87.85033118399991, 64.45237864800004],
              [-87.85887610599991, 64.43817780200004],
              [-87.86392167899993, 64.42169830900008],
              [-87.86563066299993, 64.40131256700005],
              [-87.87486731699994, 64.36082591400003],
              [-87.89952551999994, 64.33307526200008],
              [-88.02074133999992, 64.27387116100005],
              [-88.04173743399991, 64.25731028900003],
              [-88.05060787699995, 64.23688385600008],
              [-87.99640865799995, 64.20575592700004],
              [-87.98167883999992, 64.19151439000007],
              [-88.04430091099994, 64.18431224200003],
              [-88.06053626199991, 64.17511627800008],
              [-88.07420813699991, 64.16303131700005],
              [-88.09288489499994, 64.15058014500005],
              [-88.11266028599994, 64.14085521000004],
              [-88.12946529899995, 64.13690827000005],
              [-88.22158769399994, 64.14435455900008],
              [-88.23985755099994, 64.13890208500004],
              [-88.27281653599994, 64.11505768400008],
              [-88.29019120999993, 64.10956452000005],
              [-88.3079320949999, 64.10728587400007],
              [-88.48302161399994, 64.05076732000003],
              [-88.50145423099991, 64.04828522300005],
              [-88.55817623599995, 64.04808177300004],
              [-88.56432044199994, 64.04205963700008],
              [-88.55028235599991, 64.02765534100007],
              [-88.5930883449999, 64.01854075700004],
              [-88.6660863919999, 64.01146067900004],
              [-88.67308508999992, 64.00433991100005],
              [-88.67528235599991, 63.993353583000044],
              [-88.68740800699993, 63.97923411700003],
              [-88.70775305899991, 63.972723700000074],
              [-88.73460852799991, 63.972357489000046],
              [-88.78302975199995, 63.97923411700003],
              [-88.8269750639999, 63.99103424700007],
              [-88.83853105399993, 63.99009837400007],
              [-88.84854081899994, 63.98505280200004],
              [-88.85635331899994, 63.98228587400007],
              [-88.86546790299991, 63.982489325000074],
              [-88.87922115799995, 63.98668040600006],
              [-88.87511145699995, 63.99705638200004],
              [-88.87242591099994, 64.00096263200004],
              [-88.9036352199999, 64.00824616100005],
              [-88.96703040299991, 63.98851146000004],
              [-89.0027563139999, 63.993475653000075],
              [-89.00234941299993, 63.99583567900004],
              [-88.99771074099993, 64.00604889500005],
              [-88.99649003799993, 64.01060618700006],
              [-89.00177975199995, 64.01483795800004],
              [-89.01382402299993, 64.01801178600005],
              [-89.05955969999991, 64.02509186400005],
              [-89.10260982999995, 64.04389069200005],
              [-89.14769446499992, 64.05613841400003],
              [-89.17609615799995, 64.07550690300008],
              [-89.19920813699991, 64.09918854400007],
              [-89.20881100199995, 64.12046946800007],
              [-89.21198482999995, 64.13178131700005],
              [-89.2200414699999, 64.13963450700004],
              [-89.2429906889999, 64.15119049700007],
              [-89.24962317599994, 64.15574778900003],
              [-89.25234941299993, 64.15892161700003],
              [-89.25552324099993, 64.15985748900005],
              [-89.26341712099992, 64.15802643400008],
              [-89.29067949099993, 64.13690827000005],
              [-89.27415930899991, 64.13141510600008],
              [-89.23298092399995, 64.10557689000007],
              [-89.21873938699991, 64.09312571800007],
              [-89.17739824099993, 64.03851959800005],
              [-89.16002356699994, 64.02354564000007],
              [-89.10578365799995, 63.98668040600006],
              [-89.09870357999995, 63.97724030200004],
              [-89.09557044199994, 63.96836985900006],
              [-89.08975175699993, 63.96190013200004],
              [-89.07477779899995, 63.959418036000045],
              [-89.04938717399995, 63.96088288000004],
              [-89.03746497299994, 63.959092515000066],
              [-89.02318274599992, 63.95258209800005],
              [-89.04930579299992, 63.94635651200008],
              [-89.14736894399994, 63.95258209800005],
              [-89.14134680899991, 63.955186265000066],
              [-89.12559973899994, 63.96556224200003],
              [-89.14281165299991, 63.97117747600004],
              [-89.17760169199994, 63.970038153000075],
              [-89.19448808499993, 63.97300853100006],
              [-89.20571855399993, 63.97907135600008],
              [-89.23924719999991, 64.00409577000005],
              [-89.25112870999993, 64.00910065300008],
              [-89.27057857999995, 64.01422760600008],
              [-89.28636633999992, 64.01593659100007],
              [-89.28734290299991, 64.01060618700006],
              [-89.27505449099993, 64.00486888200004],
              [-89.25987708199995, 64.00055573100008],
              [-89.25084387899994, 63.993353583000044],
              [-89.25719153599994, 63.97923411700003],
              [-89.25226803299995, 63.97296784100007],
              [-89.25088456899994, 63.97032298400006],
              [-89.24974524599992, 63.96556224200003],
              [-89.2898656889999, 63.98663971600007],
              [-89.3347875639999, 64.01915110900006],
              [-89.37905839799993, 64.04144928600005],
              [-89.43862870999993, 64.02415599200003],
              [-89.46104895699995, 64.03424713700008],
              [-89.49620520699995, 64.06244538000004],
              [-89.52660071499992, 64.07636139500005],
              [-89.54556230399993, 64.07977936400005],
              [-89.56505286399994, 64.07611725500004],
              [-89.55919348899994, 64.05723704600007],
              [-89.56444251199991, 64.02562083500004],
              [-89.55768795499995, 64.00718821800007],
              [-89.54255123599995, 63.99241771000004],
              [-89.48253333199995, 63.95258209800005],
              [-89.50918535099993, 63.95209381700005],
              [-89.5403539699999, 63.97211334800005],
              [-89.59239661399994, 64.02081940300008],
              [-89.65562903599994, 64.06248607000003],
              [-89.69424394399994, 64.07843659100007],
              [-89.72215735599991, 64.07611725500004],
              [-89.71572831899994, 64.07139720300006],
              [-89.70929928299995, 64.06415436400005],
              [-89.70425370999993, 64.05512116100005],
              [-89.70225989499994, 64.04503001500007],
              [-89.70689856699994, 64.03168366100005],
              [-89.71715247299994, 64.03782786700003],
              [-89.73265540299991, 64.05870189000007],
              [-89.75218665299991, 64.07245514500005],
              [-89.82579505099994, 64.10956452000005],
              [-89.8196508449999, 64.12091705900008],
              [-89.81216386599993, 64.12815989800004],
              [-89.80284583199995, 64.13292064000007],
              [-89.79100501199991, 64.13690827000005],
              [-89.75987708199995, 64.13641998900005],
              [-89.7434789699999, 64.13853587400007],
              [-89.7363988919999, 64.14777252800008],
              [-89.73810787699995, 64.15595123900005],
              [-89.74640865799995, 64.17011139500005],
              [-89.74941972599993, 64.17853424700007],
              [-89.75035559799994, 64.18768952000005],
              [-89.74941972599993, 64.21637604400007],
              [-89.75206458199995, 64.22532786700003],
              [-89.75841223899994, 64.23187897300005],
              [-89.77391516799992, 64.24335358300004],
              [-89.78636633999992, 64.25023021000004],
              [-89.79466712099992, 64.24530670800004],
              [-89.80467688699991, 64.22687409100007],
              [-89.80768795499995, 64.21649811400005],
              [-89.80528723899994, 64.20758698100008],
              [-89.80606035099993, 64.20136139500005],
              [-89.81895911399994, 64.19896067900004],
              [-89.86953691299993, 64.20575592700004],
              [-89.88719641799992, 64.20579661700003],
              [-89.8684789699999, 64.19061920800004],
              [-89.84569251199991, 64.18537018400008],
              [-89.82640540299991, 64.17743561400005],
              [-89.81826738199993, 64.15460846600007],
              [-89.83234615799995, 64.14142487200007],
              [-89.86367753799993, 64.14618561400005],
              [-89.91392981699994, 64.16486237200007],
              [-89.93980872299994, 64.16852448100008],
              [-89.97020423099991, 64.16779205900008],
              [-89.99998938699991, 64.16303131700005],
              [-90.04893958199995, 64.14427317900004],
              [-90.12743079299992, 64.13007233300004],
              [-90.07030188699991, 64.11583079600007],
              [-90.05479895699995, 64.10651276200008],
              [-90.04084225199995, 64.10020579600007],
              [-90.0254613919999, 64.09996165600006],
              [-90.01695716099994, 64.10728587400007],
              [-90.02375240799995, 64.12388743700006],
              [-89.96385657499991, 64.12242259300007],
              [-89.93211829299992, 64.11749909100007],
              [-89.91392981699994, 64.10337962400007],
              [-89.93846594999991, 64.09638092700004],
              [-89.94766191299993, 64.08368561400005],
              [-89.94351152299993, 64.06867096600007],
              [-89.92813066299993, 64.05499909100007],
              [-89.92638098899994, 64.05621979400007],
              [-89.90428626199991, 64.05499909100007],
              [-89.89891516799992, 64.05316803600005],
              [-89.89659583199995, 64.04905833500004],
              [-89.89561926999994, 64.04466380400004],
              [-89.89403235599991, 64.04193756700005],
              [-89.87437903599994, 64.03339264500005],
              [-89.85309811099995, 64.02765534100007],
              [-89.85309811099995, 64.02081940300008],
              [-89.88866126199991, 64.02216217700004],
              [-89.90599524599992, 64.02037181200006],
              [-89.92076575399994, 64.01402415600006],
              [-89.91368567599994, 64.00836823100008],
              [-89.91197669199994, 64.00617096600007],
              [-89.91299394399994, 64.00458405200004],
              [-89.91392981699994, 64.00096263200004],
              [-89.88951575399994, 63.99290599200003],
              [-89.83901933499993, 63.98802317900004],
              [-89.81826738199993, 63.97300853100006],
              [-89.81273352799991, 63.960150458000044],
              [-89.81334387899994, 63.94603099200003],
              [-89.81993567599994, 63.93341705900008],
              [-89.83193925699993, 63.92462799700007],
              [-89.85020911399994, 63.92206452000005],
              [-89.89818274599992, 63.925848700000074],
              [-89.92076575399994, 63.92462799700007],
              [-89.9466039699999, 63.91893138200004],
              [-89.95921790299991, 63.918402411000045],
              [-89.9680883449999, 63.92011139500005],
              [-89.99644934799994, 63.932074286000045],
              [-89.97085527299993, 63.93785228100006],
              [-89.95445716099994, 63.94916413000004],
              [-89.95230058499993, 63.963731187000064],
              [-89.96914628799993, 63.97923411700003],
              [-89.99526933499993, 63.989569403000075],
              [-90.0188695949999, 63.992621161000045],
              [-90.02965247299994, 63.985541083000044],
              [-90.01756751199991, 63.96556224200003],
              [-90.03966223899994, 63.964829820000034],
              [-90.06354732999995, 63.97028229400007],
              [-90.08307857999995, 63.97016022300005],
              [-90.09203040299991, 63.95258209800005],
              [-90.11571204299992, 63.96397532800006],
              [-90.1465551419999, 63.994126695000034],
              [-90.16836503799993, 64.00718821800007],
              [-90.19347083199995, 64.01312897300005],
              [-90.22297115799995, 64.01447174700007],
              [-90.25251217399995, 64.01215241100005],
              [-90.27765865799995, 64.00718821800007],
              [-90.27765865799995, 64.00096263200004],
              [-90.22337805899991, 63.99176666900007],
              [-90.13695227799991, 63.944647528000075],
              [-90.08584550699993, 63.92462799700007],
              [-90.09520423099991, 63.92011139500005],
              [-90.10529537699995, 63.91791413000004],
              [-90.11607825399994, 63.91742584800005],
              [-90.12743079299992, 63.918402411000045],
              [-90.09947669199994, 63.90416087400007],
              [-90.09349524599992, 63.885972398000035],
              [-89.99803626199991, 63.84039948100008],
              [-89.96914628799993, 63.82221100500004],
              [-89.96589107999995, 63.813340562000064],
              [-89.96621660099993, 63.80723704600007],
              [-89.9680883449999, 63.800848700000074],
              [-89.96914628799993, 63.79120514500005],
              [-89.97423255099994, 63.778550523000035],
              [-89.98619544199994, 63.77635325700004],
              [-90.01073157499991, 63.781236070000034],
              [-90.11998450399994, 63.781236070000034],
              [-90.10558020699995, 63.774603583000044],
              [-90.06875566299993, 63.763657945000034],
              [-90.05850175699993, 63.753973700000074],
              [-90.06151282499991, 63.743475653000075],
              [-90.07335364499994, 63.73273346600007],
              [-90.08800208199995, 63.72398509300007],
              [-90.09947669199994, 63.71979401200008],
              [-90.09422766799992, 63.70563385600008],
              [-90.10387122299994, 63.69977448100008],
              [-90.13707434799994, 63.699286200000074],
              [-90.13841712099992, 63.69354889500005],
              [-90.16836503799993, 63.65770091400003],
              [-90.15660559799994, 63.64472077000005],
              [-90.1472875639999, 63.63043854400007],
              [-90.17926998599995, 63.62535228100006],
              [-90.22057044199994, 63.61322663000004],
              [-90.25938880099994, 63.607855536000045],
              [-90.28384355399993, 63.62299225500004],
              [-90.26919511599993, 63.628241278000075],
              [-90.23741614499994, 63.63157786700003],
              [-90.22240149599992, 63.63666413000004],
              [-90.24327551999994, 63.64545319200005],
              [-90.2696020169999, 63.65106842700004],
              [-90.29629472599993, 63.65131256700005],
              [-90.31859290299991, 63.64411041900007],
              [-90.31314042899993, 63.642645575000074],
              [-90.29808508999992, 63.63666413000004],
              [-90.34211178299995, 63.621527411000045],
              [-90.3946020169999, 63.61591217700004],
              [-90.44684811099995, 63.62067291900007],
              [-90.48989824099993, 63.63666413000004],
              [-90.45641028599994, 63.65086497600004],
              [-90.52538001199991, 63.65721263200004],
              [-90.54454505099994, 63.66453685100004],
              [-90.51219641799992, 63.66364166900007],
              [-90.49665279899995, 63.66539134300007],
              [-90.48306230399993, 63.67137278900003],
              [-90.52098548099991, 63.685655015000066],
              [-90.60680091099994, 63.703192450000074],
              [-90.64818274599992, 63.705511786000045],
              [-90.64175370999993, 63.68382396000004],
              [-90.65672766799992, 63.674994208000044],
              [-90.68101966099994, 63.67100657800006],
              [-90.70278886599993, 63.66453685100004],
              [-90.68805904899995, 63.659043687000064],
              [-90.66905676999994, 63.65562571800007],
              [-90.64981035099993, 63.65497467700004],
              [-90.63390051999994, 63.65770091400003],
              [-90.61872311099995, 63.66547272300005],
              [-90.61241614499994, 63.67173899900007],
              [-90.60562089799993, 63.67609284100007],
              [-90.58922278599994, 63.67759837400007],
              [-90.57119706899994, 63.67072174700007],
              [-90.55357825399994, 63.653509833000044],
              [-90.54259192599994, 63.63153717700004],
              [-90.54454505099994, 63.60993073100008],
              [-90.55776933499993, 63.59825267100007],
              [-90.57282467399995, 63.599595445000034],
              [-90.59292558499993, 63.60993073100008],
              [-90.66120357999995, 63.60248444200005],
              [-90.71275794199994, 63.58576080900008],
              [-90.72647050699993, 63.577826239000046],
              [-90.74323482999995, 63.575384833000044],
              [-90.91014563699991, 63.569199937000064],
              [-90.97451738199993, 63.57868073100008],
              [-91.03795325399994, 63.60248444200005],
              [-91.05532792899993, 63.61277903900003],
              [-91.0613500639999, 63.61509837400007],
              [-91.10220292899993, 63.621527411000045],
              [-91.13414466099994, 63.63353099200003],
              [-91.15038001199991, 63.63727448100008],
              [-91.19591223899994, 63.63043854400007],
              [-91.23452714799993, 63.63389720300006],
              [-91.27135169199994, 63.64411041900007],
              [-91.31493079299992, 63.661444403000075],
              [-91.3328344389999, 63.66453685100004],
              [-91.37271074099993, 63.664170640000066],
              [-91.39175370999993, 63.66710032800006],
              [-91.40851803299995, 63.67759837400007],
              [-91.39093990799995, 63.691473700000074],
              [-91.37246660099993, 63.688788153000075],
              [-91.35317949099993, 63.680528062000064],
              [-91.3328344389999, 63.67759837400007],
              [-91.34552975199995, 63.69159577000005],
              [-91.37096106699994, 63.70172760600008],
              [-91.50755774599992, 63.730536200000074],
              [-91.53547115799995, 63.732855536000045],
              [-91.54824785099993, 63.73114655200004],
              [-91.57921301999994, 63.71979401200008],
              [-91.59162350199995, 63.718451239000046],
              [-91.6734106109999, 63.72223541900007],
              [-91.68224036399994, 63.72601959800005],
              [-91.68272864499994, 63.73541901200008],
              [-91.6753637359999, 63.74168528900003],
              [-91.66454016799992, 63.74518463700008],
              [-91.65493730399993, 63.746527411000045],
              [-91.66551673099991, 63.76166413000004],
              [-91.68154863199993, 63.77501048400006],
              [-91.70055091099994, 63.78021881700005],
              [-91.71979732999995, 63.77098216400003],
              [-91.73643958199995, 63.75531647300005],
              [-91.74889075399994, 63.74823639500005],
              [-91.89891516799992, 63.74603913000004],
              [-91.94766191299993, 63.75572337400007],
              [-91.99071204299992, 63.781236070000034],
              [-91.96711178299995, 63.79193756700005],
              [-91.88829505099994, 63.80170319200005],
              [-91.88829505099994, 63.80914948100008],
              [-91.98289954299992, 63.82172272300005],
              [-91.99815833199995, 63.818793036000045],
              [-91.99681555899991, 63.80646393400008],
              [-91.9949438139999, 63.801621812000064],
              [-91.99624589799993, 63.79767487200007],
              [-92.00438391799992, 63.78746165600006],
              [-92.01431230399993, 63.77912018400008],
              [-92.02708899599992, 63.77326080900008],
              [-92.04063880099994, 63.769517320000034],
              [-92.0528051419999, 63.767564195000034],
              [-92.0528051419999, 63.76072825700004],
              [-92.04576575399994, 63.750433661000045],
              [-92.0640356109999, 63.748887437000064],
              [-92.10741126199991, 63.753973700000074],
              [-92.14899654899995, 63.753973700000074],
              [-92.16197669199994, 63.75665924700007],
              [-92.18797766799992, 63.765692450000074],
              [-92.29922441299993, 63.781236070000034],
              [-92.37376868399991, 63.77912018400008],
              [-92.39541581899994, 63.784369208000044],
              [-92.46715247299994, 63.81858958500004],
              [-92.50625566299993, 63.83100006700005],
              [-92.75108801999994, 63.86314524900007],
              [-92.75084387899994, 63.887152411000045],
              [-92.78624426999994, 63.90098704600007],
              [-92.82884680899991, 63.90696849200003],
              [-92.8504125639999, 63.907538153000075],
              [-92.86318925699993, 63.90269603100006],
              [-92.91616777299993, 63.90416087400007],
              [-92.93407141799992, 63.90814850500004],
              [-92.94188391799992, 63.91758860900006],
              [-92.94688880099994, 63.928900458000044],
              [-92.95653235599991, 63.93829987200007],
              [-92.98721269399994, 63.941392320000034],
              [-93.0684301419999, 63.93235911700003],
              [-93.09740149599992, 63.94196198100008],
              [-93.12694251199991, 63.96080149900007],
              [-93.16661536399994, 63.973944403000075],
              [-93.31338456899994, 63.993475653000075],
              [-93.36750240799995, 64.01154205900008],
              [-93.41612708199995, 64.01634349200003],
              [-93.44815019399994, 64.02313873900005],
              [-93.47891191299993, 64.03392161700003],
              [-93.50584876199991, 64.04816315300008],
              [-93.54246985599991, 64.07501862200007],
              [-93.55980383999992, 64.08226146000004],
              [-93.60993404899995, 64.09690989800004],
              [-93.62498938699991, 64.10651276200008],
              [-93.63292395699995, 64.12510814000007],
              [-93.61681067599994, 64.15448639500005],
              [-93.63491777299993, 64.16486237200007],
              [-93.65477454299992, 64.16596100500004],
              [-93.69517981699994, 64.16217682500007],
              [-93.71776282499991, 64.16828034100007],
              [-93.74840247299994, 64.18964264500005],
              [-93.76455644399994, 64.19647858300004],
              [-93.77953040299991, 64.19151439000007],
              [-93.69762122299994, 64.15119049700007],
              [-93.68883216099994, 64.14512767100007],
              [-93.68114173099991, 64.13853587400007],
              [-93.67479407499991, 64.13141510600008],
              [-93.66974850199995, 64.12388743700006],
              [-93.66885331899994, 64.11570872600004],
              [-93.67003333199995, 64.09410228100006],
              [-93.66592363199993, 64.08970774900007],
              [-93.64509029899995, 64.08226146000004],
              [-93.60716712099992, 64.04938385600008],
              [-93.58714758999992, 64.04193756700005],
              [-93.57506262899994, 64.04144928600005],
              [-93.56387285099993, 64.03900788000004],
              [-93.55557206899994, 64.03363678600005],
              [-93.55235755099994, 64.02423737200007],
              [-93.60081946499992, 64.01402415600006],
              [-93.58836829299992, 64.00873444200005],
              [-93.57494055899991, 64.00682200700004],
              [-93.5462133449999, 64.00718821800007],
              [-93.5462133449999, 64.00096263200004],
              [-93.59679114499994, 63.993028062000064],
              [-93.76593990799995, 63.993475653000075],
              [-93.76024329299992, 63.984361070000034],
              [-93.75963294199994, 63.97553131700005],
              [-93.76366126199991, 63.96714915600006],
              [-93.77208411399994, 63.959418036000045],
              [-93.7559301419999, 63.95933665600006],
              [-93.72557532499991, 63.96308014500005],
              [-93.71068274599992, 63.959418036000045],
              [-93.69937089799993, 63.95111725500004],
              [-93.68883216099994, 63.931708075000074],
              [-93.68024654899995, 63.92149485900006],
              [-93.66234290299991, 63.907904364000046],
              [-93.65762285099993, 63.90021393400008],
              [-93.65607662699995, 63.88739655200004],
              [-93.6472875639999, 63.88145579600007],
              [-93.53311113199993, 63.84955475500004],
              [-93.51439368399991, 63.846991278000075],
              [-93.46450761599993, 63.84955475500004],
              [-93.43065344999991, 63.843003648000035],
              [-93.36851966099994, 63.81720612200007],
              [-93.33385169199994, 63.81537506700005],
              [-93.3452856109999, 63.82294342700004],
              [-93.37246660099993, 63.82982005400004],
              [-93.38170325399994, 63.83588288000004],
              [-93.38170325399994, 63.84629954600007],
              [-93.36595618399991, 63.84723541900007],
              [-93.3074438139999, 63.83250560100004],
              [-93.2766820949999, 63.83262767100007],
              [-93.21719316299993, 63.84271881700005],
              [-93.21719316299993, 63.84955475500004],
              [-93.28612219999991, 63.84955475500004],
              [-93.30223548099991, 63.85260651200008],
              [-93.33348548099991, 63.86627838700008],
              [-93.35094153599994, 63.86937083500004],
              [-93.36119544199994, 63.87384674700007],
              [-93.39537512899994, 63.90416087400007],
              [-93.45059160099993, 63.932074286000045],
              [-93.43814042899993, 63.93699778900003],
              [-93.43199622299994, 63.93854401200008],
              [-93.42324785099993, 63.93829987200007],
              [-93.44001217399995, 63.94993724200003],
              [-93.45738684799994, 63.959418036000045],
              [-93.40062415299991, 63.97736237200007],
              [-93.33592688699991, 63.96128978100006],
              [-93.21719316299993, 63.91095612200007],
              [-93.14830481699994, 63.90416087400007],
              [-93.13219153599994, 63.898138739000046],
              [-93.10407467399995, 63.880560614000046],
              [-93.08714758999992, 63.87681712400007],
              [-93.01235917899993, 63.86981842700004],
              [-92.90965735599991, 63.84031810100004],
              [-92.76646887899994, 63.83197663000004],
              [-92.63491777299993, 63.78388092700004],
              [-92.61095130099994, 63.780137437000064],
              [-92.58775794199994, 63.786363023000035],
              [-92.56297766799992, 63.80548737200007],
              [-92.53506425699993, 63.819525458000044],
              [-92.49937903599994, 63.82062409100007],
              [-92.46385657499991, 63.81159088700008],
              [-92.43639075399994, 63.794907945000034],
              [-92.41934160099993, 63.75348541900007],
              [-92.41246497299994, 63.746527411000045],
              [-92.30260169199994, 63.740301825000074],
              [-92.26402747299994, 63.746934312000064],
              [-92.2508031889999, 63.746527411000045],
              [-92.24107825399994, 63.74266185100004],
              [-92.22126217399995, 63.730169989000046],
              [-92.20982825399994, 63.72601959800005],
              [-92.12751217399995, 63.71116771000004],
              [-92.09996497299994, 63.699286200000074],
              [-92.12149003799993, 63.693793036000045],
              [-92.16869055899991, 63.69208405200004],
              [-92.18932044199994, 63.68504466400003],
              [-92.20872962099992, 63.66673411700003],
              [-92.19985917899993, 63.657904364000046],
              [-92.18065344999991, 63.652451890000066],
              [-92.16885331899994, 63.64411041900007],
              [-92.20311438699991, 63.640326239000046],
              [-92.27651933499993, 63.62189362200007],
              [-92.30601966099994, 63.63043854400007],
              [-92.2930395169999, 63.63666413000004],
              [-92.30508378799993, 63.65269603100006],
              [-92.32298743399991, 63.65143463700008],
              [-92.34105383999992, 63.64122142100007],
              [-92.35387122299994, 63.63043854400007],
              [-92.37230383999992, 63.60614655200004],
              [-92.38365637899994, 63.596136786000045],
              [-92.40221106699994, 63.58942291900007],
              [-92.52969316299993, 63.56439850500004],
              [-92.54564368399991, 63.554754950000074],
              [-92.46743730399993, 63.52838776200008],
              [-92.45913652299993, 63.52671946800007],
              [-92.44937089799993, 63.527411200000074],
              [-92.44322669199994, 63.548529364000046],
              [-92.42601477799991, 63.55219147300005],
              [-92.3653051419999, 63.54901764500005],
              [-92.35716712099992, 63.54979075700004],
              [-92.34935462099992, 63.55145905200004],
              [-92.34019934799994, 63.554754950000074],
              [-92.33926347599993, 63.557928778000075],
              [-92.33926347599993, 63.56419505400004],
              [-92.33820553299995, 63.57086823100008],
              [-92.33397376199991, 63.57518138200004],
              [-92.30410722599993, 63.574652411000045],
              [-92.25674394399994, 63.542222398000035],
              [-92.23033606699994, 63.541001695000034],
              [-92.2168676419999, 63.55267975500004],
              [-92.20726477799991, 63.57200755400004],
              [-92.20417232999995, 63.593085028000075],
              [-92.20982825399994, 63.60993073100008],
              [-92.18101966099994, 63.62189362200007],
              [-92.12165279899995, 63.62177155200004],
              [-92.09683183499993, 63.63353099200003],
              [-92.08128821499992, 63.64520905200004],
              [-92.06810462099992, 63.647772528000075],
              [-92.03538977799991, 63.64411041900007],
              [-92.0235082669999, 63.64789459800005],
              [-91.98355058499993, 63.67450592700004],
              [-91.9551488919999, 63.68309153900003],
              [-91.89541581899994, 63.69196198100008],
              [-91.83462480399993, 63.71055735900006],
              [-91.80687415299991, 63.71588776200008],
              [-91.77843176999994, 63.71442291900007],
              [-91.66087805899991, 63.67731354400007],
              [-91.62767493399991, 63.65452708500004],
              [-91.61998450399994, 63.65119049700007],
              [-91.61510169199994, 63.64598216400003],
              [-91.6133520169999, 63.63353099200003],
              [-91.6153051419999, 63.62287018400008],
              [-91.61823482999995, 63.61322663000004],
              [-91.61782792899993, 63.603501695000034],
              [-91.60993404899995, 63.59251536700003],
              [-91.59837805899991, 63.58502838700008],
              [-91.5867406889999, 63.58226146000004],
              [-91.53990637899994, 63.580064195000034],
              [-91.52774003799993, 63.576157945000034],
              [-91.50405839799993, 63.562201239000046],
              [-91.40029863199993, 63.53082916900007],
              [-91.38060462099992, 63.513739325000074],
              [-91.38805091099994, 63.511419989000046],
              [-91.40851803299995, 63.500067450000074],
              [-91.39093990799995, 63.48773834800005],
              [-91.37108313699991, 63.48505280200004],
              [-91.35106360599991, 63.48908112200007],
              [-91.3328344389999, 63.49664948100008],
              [-91.31554114499994, 63.50153229400007],
              [-91.16832434799994, 63.49323151200008],
              [-91.14793860599991, 63.48692454600007],
              [-91.09943600199995, 63.459092515000066],
              [-91.07852128799993, 63.45262278900003],
              [-91.06216386599993, 63.45286692900004],
              [-91.04824785099993, 63.45880768400008],
              [-91.03453528599994, 63.46967194200005],
              [-91.01740475199995, 63.471136786000045],
              [-90.98851477799991, 63.465684312000064],
              [-90.96129309799994, 63.45697663000004],
              [-90.92674719999991, 63.43211497600004],
              [-90.78473873599995, 63.397650458000044],
              [-90.80516516799992, 63.39154694200005],
              [-90.83438066299993, 63.39305247600004],
              [-90.9519750639999, 63.42218659100007],
              [-90.97647050699993, 63.42438385600008],
              [-90.96458899599992, 63.408636786000045],
              [-90.9453832669999, 63.39801666900007],
              [-90.92275956899994, 63.39207591400003],
              [-90.87267005099994, 63.385931708000044],
              [-90.81851152299993, 63.367173570000034],
              [-90.79124915299991, 63.36290110900006],
              [-90.70836341099994, 63.36469147300005],
              [-90.68911699099993, 63.356675523000035],
              [-90.6824438139999, 63.33746979400007],
              [-90.70181230399993, 63.329291083000044],
              [-90.73021399599992, 63.32603587400007],
              [-90.75059973899994, 63.32135651200008],
              [-90.73631751199991, 63.308294989000046],
              [-90.74095618399991, 63.29437897300005],
              [-90.72960364499994, 63.28660716400003],
              [-90.71149654899995, 63.281358140000066],
              [-90.6953832669999, 63.27476634300007],
              [-90.71890214799993, 63.260972398000035],
              [-90.7176000639999, 63.25348541900007],
              [-90.70352128799993, 63.246161200000074],
              [-90.68911699099993, 63.23261139500005],
              [-90.68724524599992, 63.22422923400006],
              [-90.68858801999994, 63.21458567900004],
              [-90.69172115799995, 63.20538971600007],
              [-90.6953832669999, 63.198431708000044],
              [-90.69644120999993, 63.19297923400006],
              [-90.69513912699995, 63.188666083000044],
              [-90.69562740799995, 63.18577708500004],
              [-90.70221920499995, 63.184759833000044],
              [-90.71812903599994, 63.18939850500004],
              [-90.72655188699991, 63.19000885600008],
              [-90.73009192599994, 63.184759833000044],
              [-90.72227942599994, 63.17487213700008],
              [-90.68659420499995, 63.16986725500004],
              [-90.67487545499995, 63.164903062000064],
              [-90.67174231699994, 63.15338776200008],
              [-90.67882239499994, 63.147772528000075],
              [-90.68903561099995, 63.14366282800006],
              [-90.6953832669999, 63.13694896000004],
              [-90.69188391799992, 63.12482330900008],
              [-90.65440833199995, 63.08856842700004],
              [-90.66429602799991, 63.088324286000045],
              [-90.68911699099993, 63.081732489000046],
              [-90.67747962099992, 63.070746161000045],
              [-90.64362545499995, 63.06891510600008],
              [-90.62645423099991, 63.06126536700003],
              [-90.64492753799993, 63.05768463700008],
              [-90.65880286399994, 63.03424713700008],
              [-90.69196529899995, 63.04181549700007],
              [-90.70189368399991, 63.035589911000045],
              [-90.71035722599993, 63.024278062000064],
              [-90.72329667899993, 63.014105536000045],
              [-90.68911699099993, 63.014105536000045],
              [-90.7024633449999, 63.00336334800005],
              [-90.71865800699993, 62.99937571800007],
              [-90.75365149599992, 62.99982330900008],
              [-90.75706946499992, 62.99583567900004],
              [-90.74795488199993, 62.98704661700003],
              [-90.73420162699995, 62.97789134300007],
              [-90.72329667899993, 62.973089911000045],
              [-90.73680579299992, 62.96698639500005],
              [-90.75218665299991, 62.96503327000005],
              [-90.78473873599995, 62.96564362200007],
              [-90.77220618399991, 62.953192450000074],
              [-90.78380286399994, 62.94505442900004],
              [-90.82567298099991, 62.938340562000064],
              [-91.03111731699994, 62.95140208500004],
              [-91.05304928299995, 62.94481028900003],
              [-91.09630286399994, 62.92267487200007],
              [-91.11681067599994, 62.91783274900007],
              [-91.13963782499991, 62.916083075000074],
              [-91.16148841099994, 62.91107819200005],
              [-91.19961503799993, 62.89679596600007],
              [-91.20881100199995, 62.876288153000075],
              [-91.2207738919999, 62.862168687000064],
              [-91.31240800699993, 62.830511786000045],
              [-91.32258053299995, 62.82916901200008],
              [-91.39842688699991, 62.828192450000074],
              [-91.42218990799995, 62.822251695000034],
              [-91.40587317599994, 62.815619208000044],
              [-91.37018795499995, 62.80967845300006],
              [-91.35387122299994, 62.801214911000045],
              [-91.39427649599992, 62.786810614000046],
              [-91.44196529899995, 62.78693268400008],
              [-91.65786699099993, 62.81126536700003],
              [-91.7097875639999, 62.82579173400006],
              [-91.73717200399994, 62.82916901200008],
              [-91.83307857999995, 62.82916901200008],
              [-91.97940019399994, 62.84739817900004],
              [-92.08299719999991, 62.87254466400003],
              [-92.13475501199991, 62.87689850500004],
              [-92.13369706899994, 62.87181224200003],
              [-92.13267981699994, 62.87103913000004],
              [-92.1309301419999, 62.87132396000004],
              [-92.12791907499991, 62.86945221600007],
              [-92.13499915299991, 62.84906647300005],
              [-92.1192113919999, 62.83751048400006],
              [-92.09732011599993, 62.82916901200008],
              [-92.08629309799994, 62.81854889500005],
              [-92.09886633999992, 62.803900458000044],
              [-92.12779700399994, 62.80072663000004],
              [-92.15998287699995, 62.804754950000074],
              [-92.22842363199993, 62.82916901200008],
              [-92.28038489499994, 62.84076569200005],
              [-92.33311926999994, 62.84516022300005],
              [-92.42857825399994, 62.83356354400007],
              [-92.45274817599994, 62.82493724200003],
              [-92.46304277299993, 62.81146881700005],
              [-92.4539281889999, 62.79393138200004],
              [-92.43268795499995, 62.78278229400007],
              [-92.40880286399994, 62.773871161000045],
              [-92.39171301999994, 62.76329173400006],
              [-92.35680091099994, 62.73224518400008],
              [-92.31696529899995, 62.71324290600006],
              [-92.22411048099991, 62.69196198100008],
              [-92.22411048099991, 62.68451569200005],
              [-92.24242102799991, 62.68585846600007],
              [-92.25914466099994, 62.69000885600008],
              [-92.27562415299991, 62.69135163000004],
              [-92.2930395169999, 62.68451569200005],
              [-92.27774003799993, 62.67877838700008],
              [-92.20360266799992, 62.66681549700007],
              [-91.96800696499992, 62.65501536700003],
              [-91.89745032499991, 62.63971588700008],
              [-91.88975989499994, 62.63072337400007],
              [-91.88805091099994, 62.620428778000075],
              [-91.88980058499993, 62.60016510600008],
              [-91.89464270699995, 62.58885325700004],
              [-91.90294348899994, 62.57908763200004],
              [-91.91502844999991, 62.571519273000035],
              [-91.94758053299995, 62.55878327000005],
              [-91.95543372299994, 62.550482489000046],
              [-91.9429418609999, 62.541083075000074],
              [-91.96019446499992, 62.53392161700003],
              [-91.98346920499995, 62.53160228100006],
              [-92.02489173099991, 62.53367747600004],
              [-92.09373938699991, 62.547308661000045],
              [-92.15904700399994, 62.54328034100007],
              [-92.17568925699993, 62.547308661000045],
              [-92.18675696499992, 62.56187571800007],
              [-92.17552649599992, 62.57123444200005],
              [-92.14150956899994, 62.582098700000074],
              [-92.15050208199995, 62.59361399900007],
              [-92.16563880099994, 62.60614655200004],
              [-92.18321692599994, 62.612534898000035],
              [-92.21711178299995, 62.596869208000044],
              [-92.25841223899994, 62.60142649900007],
              [-92.27871660099993, 62.595770575000074],
              [-92.24461829299992, 62.574652411000045],
              [-92.26089433499993, 62.562608140000066],
              [-92.28624426999994, 62.56439850500004],
              [-92.31456458199995, 62.569647528000075],
              [-92.34019934799994, 62.568426825000074],
              [-92.33495032499991, 62.56346263200004],
              [-92.32526607999995, 62.551988023000035],
              [-92.31969153599994, 62.547308661000045],
              [-92.39891516799992, 62.53851959800005],
              [-92.42894446499992, 62.541083075000074],
              [-92.45938066299993, 62.54722728100006],
              [-92.4773656889999, 62.55524323100008],
              [-92.47801673099991, 62.56793854400007],
              [-92.45685787699995, 62.588324286000045],
              [-92.47940019399994, 62.59906647300005],
              [-92.49006100199995, 62.59288157800006],
              [-92.49600175699993, 62.58112213700008],
              [-92.50462805899991, 62.574652411000045],
              [-92.5176488919999, 62.575873114000046],
              [-92.52476966099994, 62.57916901200008],
              [-92.53038489499994, 62.58356354400007],
              [-92.57664954299992, 62.60602448100008],
              [-92.58849036399994, 62.61432526200008],
              [-92.6050512359999, 62.62201569200005],
              [-92.61851966099994, 62.62254466400003],
              [-92.62132727799991, 62.609442450000074],
              [-92.60863196499992, 62.59739817900004],
              [-92.58763587099992, 62.58978913000004],
              [-92.57331295499995, 62.579779364000046],
              [-92.58039303299995, 62.560980536000045],
              [-92.56753495999993, 62.557928778000075],
              [-92.5554906889999, 62.553168036000045],
              [-92.54548092399995, 62.54547760600008],
              [-92.53880774599992, 62.53367747600004],
              [-92.55109615799995, 62.52757396000004],
              [-92.55980383999992, 62.52195872600004],
              [-92.56501217399995, 62.51439036700003],
              [-92.56672115799995, 62.50263092700004],
              [-92.55923417899993, 62.49278392100007],
              [-92.54308020699995, 62.497748114000046],
              [-92.52757727799991, 62.50767649900007],
              [-92.52204342399995, 62.51316966400003],
              [-92.50365149599992, 62.51654694200005],
              [-92.50064042899993, 62.51312897300005],
              [-92.50401770699995, 62.49957916900007],
              [-92.50999915299991, 62.48997630400004],
              [-92.51797441299993, 62.487534898000035],
              [-92.52940833199995, 62.48582591400003],
              [-92.54564368399991, 62.47837962400007],
              [-92.53652910099993, 62.47260163000004],
              [-92.53343665299991, 62.46861399900007],
              [-92.53465735599991, 62.46478913000004],
              [-92.53880774599992, 62.45917389500005],
              [-92.53408769399994, 62.452460028000075],
              [-92.53282630099994, 62.44953034100007],
              [-92.53197180899991, 62.44489166900007],
              [-92.54918372299994, 62.44798411700003],
              [-92.59341386599993, 62.46478913000004],
              [-92.6140844389999, 62.46784088700008],
              [-92.67284094999991, 62.46478913000004],
              [-92.70494544199994, 62.468817450000074],
              [-92.7183324859999, 62.46466705900008],
              [-92.72374426999994, 62.44830963700008],
              [-92.72533118399991, 62.43146393400008],
              [-92.72166907499991, 62.42328522300005],
              [-92.71007239499994, 62.41075267100007],
              [-92.71739661399994, 62.39740631700005],
              [-92.71178137899994, 62.387884833000044],
              [-92.69859778599994, 62.382798570000034],
              [-92.68276933499993, 62.382879950000074],
              [-92.68276933499993, 62.376654364000046],
              [-92.70083574099993, 62.37437571800007],
              [-92.73314368399991, 62.36461009300007],
              [-92.75137285099993, 62.36237213700008],
              [-92.79092363199993, 62.36273834800005],
              [-92.80996660099993, 62.36078522300005],
              [-92.82738196499992, 62.355536200000074],
              [-92.80516516799992, 62.34943268400008],
              [-92.73741614499994, 62.349310614000046],
              [-92.66006425699993, 62.33104075700004],
              [-92.63499915299991, 62.328233140000066],
              [-92.61978105399993, 62.32286204600007],
              [-92.60220292899993, 62.31114329600007],
              [-92.58975175699993, 62.29942454600007],
              [-92.59032141799992, 62.29405345300006],
              [-92.59390214799993, 62.29120514500005],
              [-92.59732011599993, 62.284491278000075],
              [-92.59984290299991, 62.27643463700008],
              [-92.6009008449999, 62.26988353100006],
              [-92.63560950399994, 62.25995514500005],
              [-92.6250707669999, 62.25189850500004],
              [-92.60220292899993, 62.244574286000045],
              [-92.59341386599993, 62.239447333000044],
              [-92.58702551999994, 62.22955963700008],
              [-92.58153235599991, 62.20921458500004],
              [-92.57664954299992, 62.201239325000074],
              [-92.5520727199999, 62.186835028000075],
              [-92.49665279899995, 62.169989325000074],
              [-92.4773656889999, 62.157538153000075],
              [-92.47052975199995, 62.150091864000046],
              [-92.49665279899995, 62.153631903000075],
              [-92.5559789699999, 62.17145416900007],
              [-92.59666907499991, 62.16095612200007],
              [-92.61343339799993, 62.17291901200008],
              [-92.62295488199993, 62.19318268400008],
              [-92.62132727799991, 62.21153392100007],
              [-92.6902563139999, 62.23200104400007],
              [-92.68858801999994, 62.23590729400007],
              [-92.68765214799993, 62.23887767100007],
              [-92.68626868399991, 62.24176666900007],
              [-92.68276933499993, 62.24567291900007],
              [-92.6887914699999, 62.255194403000075],
              [-92.69810950399994, 62.26666901200008],
              [-92.70921790299991, 62.27643463700008],
              [-92.72704016799992, 62.28233470300006],
              [-92.73875891799992, 62.291449286000045],
              [-92.74425208199995, 62.29405345300006],
              [-92.75389563699991, 62.29389069200005],
              [-92.76927649599992, 62.28778717700004],
              [-92.77904212099992, 62.28660716400003],
              [-92.79442298099991, 62.28925202000005],
              [-92.81354732999995, 62.29511139500005],
              [-92.83145097599993, 62.302801825000074],
              [-92.84357662699995, 62.31114329600007],
              [-92.8609106109999, 62.317246812000064],
              [-92.90855872299994, 62.31224192900004],
              [-92.94237219999991, 62.32453034100007],
              [-93.13101152299993, 62.34434642100007],
              [-93.2520238919999, 62.36981842700004],
              [-93.18594316299993, 62.346543687000064],
              [-93.14940344999991, 62.338324286000045],
              [-93.07848059799994, 62.33055247600004],
              [-92.98379472599993, 62.29405345300006],
              [-92.9531957669999, 62.28815338700008],
              [-92.91930091099994, 62.28660716400003],
              [-92.91510982999995, 62.28375885600008],
              [-92.91551673099991, 62.277329820000034],
              [-92.91685950399994, 62.27057526200008],
              [-92.9155981109999, 62.266791083000044],
              [-92.90709387899994, 62.26544830900008],
              [-92.87828528599994, 62.266791083000044],
              [-92.84837805899991, 62.263739325000074],
              [-92.81261145699995, 62.25470612200007],
              [-92.7813207669999, 62.239569403000075],
              [-92.76471920499995, 62.21836985900006],
              [-92.78477942599994, 62.21466705900008],
              [-92.7903539699999, 62.202378648000035],
              [-92.79328365799995, 62.187933661000045],
              [-92.80561275899993, 62.17808665600006],
              [-92.83141028599994, 62.17841217700004],
              [-92.84634355399993, 62.18016185100004],
              [-92.86095130099994, 62.18419017100007],
              [-92.86733964799993, 62.188666083000044],
              [-92.87218176999994, 62.194647528000075],
              [-92.87840735599991, 62.20062897300005],
              [-92.88890540299991, 62.20469798400006],
              [-92.90184485599991, 62.20469798400006],
              [-92.94347083199995, 62.19782135600008],
              [-92.97923743399991, 62.20368073100008],
              [-92.99681555899991, 62.20392487200007],
              [-93.0117895169999, 62.19782135600008],
              [-92.97081458199995, 62.18419017100007],
              [-92.99217688699991, 62.17418040600006],
              [-93.01813717399995, 62.173041083000044],
              [-93.0735570949999, 62.17804596600007],
              [-93.0828344389999, 62.17572663000004],
              [-93.09581458199995, 62.16596100500004],
              [-93.10798092399995, 62.163763739000046],
              [-93.11522376199991, 62.15973541900007],
              [-93.12083899599992, 62.150376695000034],
              [-93.1284887359999, 62.12958405200004],
              [-93.08381100199995, 62.11741771000004],
              [-93.06529700399994, 62.11692942900004],
              [-93.01349850199995, 62.127061265000066],
              [-92.98436438699991, 62.12754954600007],
              [-92.95506751199991, 62.12409088700008],
              [-92.92979895699995, 62.11656321800007],
              [-92.94066321499992, 62.101629950000074],
              [-92.96153723899994, 62.08580149900007],
              [-92.98525956899994, 62.07322825700004],
              [-93.00462805899991, 62.06818268400008],
              [-93.04515540299991, 62.07990143400008],
              [-93.06590735599991, 62.081366278000075],
              [-93.08067786399994, 62.06818268400008],
              [-93.07017981699994, 62.066107489000046],
              [-93.06387285099993, 62.06232330900008],
              [-93.06236731699994, 62.05626048400006],
              [-93.06639563699991, 62.04767487200007],
              [-93.0757543609999, 62.041001695000034],
              [-93.08861243399991, 62.03900788000004],
              [-93.1148168609999, 62.040228583000044],
              [-93.10732988199993, 62.040228583000044],
              [-93.1270238919999, 62.04987213700008],
              [-93.13817298099991, 62.05377838700008],
              [-93.14830481699994, 62.053900458000044],
              [-93.16148841099994, 62.04759349200003],
              [-93.1594945949999, 62.04181549700007],
              [-93.15176347599993, 62.035142320000034],
              [-93.14830481699994, 62.026556708000044],
              [-93.1516820949999, 62.01068756700005],
              [-93.15819251199991, 61.99559153900003],
              [-93.17015540299991, 61.985581773000035],
              [-93.18993079299992, 61.98497142100007],
              [-93.20689856699994, 61.99359772300005],
              [-93.24449622299994, 62.03400299700007],
              [-93.26085364499994, 62.04246653900003],
              [-93.2847387359999, 62.049668687000064],
              [-93.31086178299995, 62.054022528000075],
              [-93.33385169199994, 62.053900458000044],
              [-93.32225501199991, 62.044989325000074],
              [-93.3098852199999, 62.038275458000044],
              [-93.29930579299992, 62.03086985900006],
              [-93.29295813699991, 62.01972077000005],
              [-93.41649329299992, 62.03400299700007],
              [-93.41649329299992, 62.026556708000044],
              [-93.21719316299993, 61.958319403000075],
              [-93.21719316299993, 61.95148346600007],
              [-93.36729895699995, 61.95490143400008],
              [-93.38853919199994, 61.95148346600007],
              [-93.33763587099992, 61.93268463700008],
              [-93.3230688139999, 61.93036530200004],
              [-93.3098852199999, 61.92613353100006],
              [-93.29954993399991, 61.916449286000045],
              [-93.29002844999991, 61.90534088700008],
              [-93.27928626199991, 61.89683665600006],
              [-93.3101293609999, 61.89350006700005],
              [-93.3367406889999, 61.896551825000074],
              [-93.49575761599993, 61.93976471600007],
              [-93.59748287699995, 61.95384349200003],
              [-93.61701412699995, 61.952337958000044],
              [-93.59430904899995, 61.93406810100004],
              [-93.51366126199991, 61.902329820000034],
              [-93.49156653599994, 61.88939036700003],
              [-93.5833227199999, 61.886826890000066],
              [-93.60423743399991, 61.879746812000064],
              [-93.61359615799995, 61.861029364000046],
              [-93.59780839799993, 61.85419342700004],
              [-93.50206458199995, 61.85582103100006],
              [-93.4915258449999, 61.84564850500004],
              [-93.48131262899994, 61.83856842700004],
              [-93.46792558499993, 61.83539459800005],
              [-93.34752356699994, 61.82111237200007],
              [-93.36717688699991, 61.814439195000034],
              [-93.39049231699994, 61.812933661000045],
              [-93.43691972599993, 61.81492747600004],
              [-93.43691972599993, 61.80744049700007],
              [-93.42296301999994, 61.80365631700005],
              [-93.39745032499991, 61.78998444200005],
              [-93.38512122299994, 61.78697337400007],
              [-93.33018958199995, 61.78697337400007],
              [-93.2871801419999, 61.794134833000044],
              [-93.27183997299994, 61.79315827000005],
              [-93.2515356109999, 61.78803131700005],
              [-93.24624589799993, 61.78375885600008],
              [-93.25816809799994, 61.76654694200005],
              [-93.26455644399994, 61.74445221600007],
              [-93.27139238199993, 61.736314195000034],
              [-93.28237870999993, 61.742254950000074],
              [-93.29149329299992, 61.74909088700008],
              [-93.30288652299993, 61.75189850500004],
              [-93.36685136599993, 61.75336334800005],
              [-93.40217037699995, 61.75971100500004],
              [-93.43618730399993, 61.771918036000045],
              [-93.45352128799993, 61.773504950000074],
              [-93.47175045499995, 61.76654694200005],
              [-93.45250403599994, 61.757066148000035],
              [-93.43838456899994, 61.743353583000044],
              [-93.42186438699991, 61.73102448100008],
              [-93.39537512899994, 61.72553131700005],
              [-93.3347875639999, 61.73456452000005],
              [-93.31338456899994, 61.73236725500004],
              [-93.44310462099992, 61.69078196800007],
              [-93.46125240799995, 61.68744538000004],
              [-93.49974524599992, 61.68622467700004],
              [-93.5188695949999, 61.683294989000046],
              [-93.69017493399991, 61.615668036000045],
              [-93.71572831899994, 61.601629950000074],
              [-93.75959225199995, 61.568467515000066],
              [-93.78575598899994, 61.55418528900003],
              [-93.79507402299993, 61.55503978100006],
              [-93.80675208199995, 61.560980536000045],
              [-93.81826738199993, 61.56858958500004],
              [-93.8335668609999, 61.57469310100004],
              [-93.83804277299993, 61.561712958000044],
              [-93.87755286399994, 61.52057526200008],
              [-93.89561926999994, 61.50580475500004],
              [-93.90591386599993, 61.50067780200004],
              [-93.9265844389999, 61.49595774900007],
              [-93.93659420499995, 61.491522528000075],
              [-93.98497473899994, 61.45799388200004],
              [-93.97288977799991, 61.454413153000075],
              [-93.96580969999991, 61.44940827000005],
              [-93.96495520699995, 61.44354889500005],
              [-93.97134355399993, 61.43695709800005],
              [-93.96589107999995, 61.42731354400007],
              [-93.95811926999994, 61.419134833000044],
              [-93.94823157499991, 61.41319407800006],
              [-93.93659420499995, 61.410223700000074],
              [-93.96108964799993, 61.40338776200008],
              [-93.97134355399993, 61.402777411000045],
              [-93.92609615799995, 61.390733140000066],
              [-93.90929114499994, 61.389105536000045],
              [-93.89500891799992, 61.39044830900008],
              [-93.88255774599992, 61.39288971600007],
              [-93.87059485599991, 61.39276764500005],
              [-93.85777747299994, 61.386053778000075],
              [-93.82762610599991, 61.36273834800005],
              [-93.8223363919999, 61.34992096600007],
              [-93.84097245999993, 61.34129466400003],
              [-93.83649654899995, 61.33197663000004],
              [-93.8335668609999, 61.32831452000005],
              [-93.85850989499994, 61.31785716400003],
              [-93.92174231699994, 61.30329010600008],
              [-93.95083574099993, 61.30097077000005],
              [-93.99266516799992, 61.30573151200008],
              [-94.07461503799993, 61.32611725500004],
              [-94.11473548099991, 61.32831452000005],
              [-94.09581458199995, 61.31110260600008],
              [-94.05223548099991, 61.29328034100007],
              [-94.03282630099994, 61.27985260600008],
              [-94.0293676419999, 61.27183665600006],
              [-94.02554277299993, 61.25018952000005],
              [-94.02285722599993, 61.24571360900006],
              [-94.01402747299994, 61.243475653000075],
              [-94.00682532499991, 61.23777903900003],
              [-94.0015356109999, 61.230902411000045],
              [-93.99864661399994, 61.224595445000034],
              [-94.00694739499994, 61.224717515000066],
              [-94.02660071499992, 61.218451239000046],
              [-94.01707923099991, 61.20091380400004],
              [-94.0437719389999, 61.18891022300005],
              [-94.08047441299993, 61.17792389500005],
              [-94.10106360599991, 61.16319407800006],
              [-94.04027258999992, 61.16319407800006],
              [-94.05858313699991, 61.14402903900003],
              [-94.06639563699991, 61.13353099200003],
              [-94.06753495999993, 61.12217845300006],
              [-94.05540930899991, 61.10797760600008],
              [-94.03766842399995, 61.11009349200003],
              [-94.0176488919999, 61.116441148000035],
              [-93.99864661399994, 61.11473216400003],
              [-93.98623613199993, 61.10065338700008],
              [-93.99640865799995, 61.09019603100006],
              [-94.01622473899994, 61.083685614000046],
              [-94.03282630099994, 61.081244208000044],
              [-94.0711156889999, 61.08152903900003],
              [-94.08820553299995, 61.07969798400006],
              [-94.10850989499994, 61.07379791900007],
              [-94.11880449099993, 61.07249583500004],
              [-94.12694251199991, 61.06712474200003],
              [-94.12901770699995, 61.06012604400007],
              [-94.1477758449999, 61.048814195000034],
              [-94.16047115799995, 61.03375885600008],
              [-94.16771399599992, 61.015733140000066],
              [-94.1699926419999, 60.99559153900003],
              [-94.17833411399994, 60.983710028000075],
              [-94.21816972599993, 60.94684479400007],
              [-94.23204505099994, 60.93040599200003],
              [-94.2363988919999, 60.91950104400007],
              [-94.23851477799991, 60.91087474200003],
              [-94.24233964799993, 60.90338776200008],
              [-94.25186113199993, 60.895697333000044],
              [-94.26622473899994, 60.89057038000004],
              [-94.29588782499991, 60.886419989000046],
              [-94.32030188699991, 60.87291087400007],
              [-94.34154212099992, 60.86517975500004],
              [-94.35155188699991, 60.85809967700004],
              [-94.3543188139999, 60.85374583500004],
              [-94.35521399599992, 60.848822333000044],
              [-94.35488847599993, 60.837958075000074],
              [-94.35777747299994, 60.83445872600004],
              [-94.37120520699995, 60.82969798400006],
              [-94.37539628799993, 60.827378648000035],
              [-94.40143795499995, 60.78587474200003],
              [-94.40953528599994, 60.764105536000045],
              [-94.40648352799991, 60.74860260600008],
              [-94.39736894399994, 60.72724030200004],
              [-94.40941321499992, 60.70966217700004],
              [-94.47191321499992, 60.66828034100007],
              [-94.48460852799991, 60.657456773000035],
              [-94.49209550699993, 60.64923737200007],
              [-94.49486243399991, 60.63739655200004],
              [-94.49087480399993, 60.63035716400003],
              [-94.4883520169999, 60.62339915600006],
              [-94.49522864499994, 60.61168040600006],
              [-94.51357988199993, 60.59442780200004],
              [-94.52074133999992, 60.58458079600007],
              [-94.51634680899991, 60.58038971600007],
              [-94.5059301419999, 60.57554759300007],
              [-94.50763912699995, 60.56480540600006],
              [-94.51455644399994, 60.55345286700003],
              [-94.52000891799992, 60.54682038000004],
              [-94.57164466099994, 60.52769603100006],
              [-94.68834387899994, 60.552842515000066],
              [-94.73851477799991, 60.53937409100007],
              [-94.71556555899991, 60.530951239000046],
              [-94.6653539699999, 60.52167389500005],
              [-94.64232337099992, 60.51207103100006],
              [-94.66779537699995, 60.49433014500005],
              [-94.76170813699991, 60.505194403000075],
              [-94.80060787699995, 60.49839915600006],
              [-94.70274817599994, 60.48541901200008],
              [-94.68016516799992, 60.47455475500004],
              [-94.62987219999991, 60.419907945000034],
              [-94.62767493399991, 60.41168854400007],
              [-94.61782792899993, 60.39830149900007],
              [-94.61558997299994, 60.392279364000046],
              [-94.61880449099993, 60.380560614000046],
              [-94.6328832669999, 60.36115143400008],
              [-94.63609778599994, 60.35130442900004],
              [-94.64346269399994, 60.33698151200008],
              [-94.67589270699995, 60.308701890000066],
              [-94.68765214799993, 60.28746165600006],
              [-94.71182206899994, 60.265692450000074],
              [-94.71092688699991, 60.25438060100004],
              [-94.70498613199993, 60.24876536700003],
              [-94.69713294199994, 60.24473704600007],
              [-94.6907445949999, 60.238348700000074],
              [-94.68272864499994, 60.216905015000066],
              [-94.68163001199991, 60.19721100500004],
              [-94.68675696499992, 60.17914459800005],
              [-94.69758053299995, 60.16266510600008],
              [-94.7027074859999, 60.15900299700007],
              [-94.71446692599994, 60.15391673400006],
              [-94.71800696499992, 60.149603583000044],
              [-94.7195531889999, 60.14142487200007],
              [-94.71739661399994, 60.13841380400004],
              [-94.71397864499994, 60.13585032800006],
              [-94.70954342399995, 60.122259833000044],
              [-94.70555579299992, 60.11469147300005],
              [-94.70287024599992, 60.10565827000005],
              [-94.70433508999992, 60.09434642100007],
              [-94.71857662699995, 60.07904694200005],
              [-94.75987708199995, 60.068467515000066],
              [-94.77330481699994, 60.052801825000074],
              [-94.76903235599991, 60.051621812000064],
              [-94.75902258999992, 60.046576239000046],
              [-94.76439368399991, 60.04148997600004],
              [-94.76773027299993, 60.03595612200007],
              [-94.77025305899991, 60.03038157800006],
              [-94.77330481699994, 60.025458075000074],
              [-94.75902258999992, 60.01927317900004],
              [-94.78184973899994, 60.016831773000035],
              [-94.8008520169999, 60.01048411700003],
              [-94.80581620999993, 60.00153229400007],
              [-94.80313066299993, 60.000067450000074],
              [-94.78693600199995, 59.99131907800006],
              [-94.80101477799991, 59.97992584800005],
              [-94.81700598899994, 59.962876695000034],
              [-94.82135982999995, 59.948106187000064],
              [-94.80060787699995, 59.94354889500005],
              [-94.80943762899994, 59.92804596600007],
              [-94.81427975199995, 59.923041083000044],
              [-94.80972245999993, 59.91950104400007],
              [-94.80524654899995, 59.91282786700003],
              [-94.80060787699995, 59.909409898000035],
              [-94.80528723899994, 59.88495514500005],
              [-94.77940833199995, 59.83869049700007],
              [-94.79312089799993, 59.820013739000046],
              [-94.77550208199995, 59.798041083000044],
              [-94.77330481699994, 59.78961823100008],
              [-94.77538001199991, 59.77781810100004],
              [-94.78477942599994, 59.75775788000004],
              [-94.78693600199995, 59.74835846600007],
              [-94.78966223899994, 59.74192942900004],
              [-94.80284583199995, 59.725816148000035],
              [-94.8074438139999, 59.71759674700007],
              [-94.7962133449999, 59.66791413000004],
              [-94.79849199099993, 59.659369208000044],
              [-94.81086178299995, 59.655503648000035],
              [-94.82188880099994, 59.65033600500004],
              [-94.81944739499994, 59.638657945000034],
              [-94.8074438139999, 59.61798737200007],
              [-94.80785071499992, 59.610663153000075],
              [-94.8074438139999, 59.60492584800005],
              [-94.80337480399993, 59.598089911000045],
              [-94.79312089799993, 59.58726634300007],
              [-94.78465735599991, 59.582464911000045],
              [-94.77538001199991, 59.580064195000034],
              [-94.7664281889999, 59.57611725500004],
              [-94.75902258999992, 59.56675853100006],
              [-94.78123938699991, 59.562201239000046],
              [-94.78807532499991, 59.55040110900006],
              [-94.78892981699994, 59.53648509300007],
              [-94.79312089799993, 59.525824286000045],
              [-94.7866918609999, 59.51593659100007],
              [-94.77989661399994, 59.51386139500005],
              [-94.77220618399991, 59.513373114000046],
              [-94.76276607999995, 59.50812409100007],
              [-94.7571508449999, 59.50177643400008],
              [-94.7559301419999, 59.497381903000075],
              [-94.75548255099994, 59.49253978100006],
              [-94.75218665299991, 59.484808661000045],
              [-94.75560462099992, 59.483587958000044],
              [-94.75885982999995, 59.475897528000075],
              [-94.75792395699995, 59.467230536000045],
              [-94.74909420499995, 59.46312083500004],
              [-94.74132239499994, 59.46124909100007],
              [-94.73428300699993, 59.45648834800005],
              [-94.72850501199991, 59.45026276200008],
              [-94.72423255099994, 59.44383372600004],
              [-94.73298092399995, 59.435980536000045],
              [-94.73468990799995, 59.42951080900008],
              [-94.72996985599991, 59.40253327000005],
              [-94.7259008449999, 59.39899323100008],
              [-94.72134355399993, 59.396185614000046],
              [-94.71800696499992, 59.38861725500004],
              [-94.71642005099994, 59.37535228100006],
              [-94.71841386599993, 59.36668528900003],
              [-94.7254125639999, 59.35875071800007],
              [-94.73851477799991, 59.347723700000074],
              [-94.72276770699995, 59.34227122600004],
              [-94.70327714799993, 59.34784577000005],
              [-94.68342037699995, 59.356675523000035],
              [-94.66649329299992, 59.361314195000034],
              [-94.66014563699991, 59.35875071800007],
              [-94.67096920499995, 59.35325755400004],
              [-94.68553626199991, 59.34845612200007],
              [-94.6907445949999, 59.347723700000074],
              [-94.70763098899994, 59.332017320000034],
              [-94.71703040299991, 59.32684967700004],
              [-94.73167883999992, 59.32652415600006],
              [-94.72687740799995, 59.31671784100007],
              [-94.72423255099994, 59.312933661000045],
              [-94.76032467399995, 59.304754950000074],
              [-94.77220618399991, 59.298041083000044],
              [-94.76646887899994, 59.285589911000045],
              [-94.77554277299993, 59.27362702000005],
              [-94.78038489499994, 59.26862213700008],
              [-94.78693600199995, 59.26508209800005],
              [-94.77700761599993, 59.25922272300005],
              [-94.77428137899994, 59.25263092700004],
              [-94.77782141799992, 59.245428778000075],
              [-94.78693600199995, 59.23786041900007],
              [-94.77969316299993, 59.230902411000045],
              [-94.77757727799991, 59.22288646000004],
              [-94.77944902299993, 59.20368073100008],
              [-94.78140214799993, 59.20347728100006],
              [-94.78600012899994, 59.20018138200004],
              [-94.79067949099993, 59.19505442900004],
              [-94.79312089799993, 59.18939850500004],
              [-94.79027258999992, 59.18451569200005],
              [-94.77660071499992, 59.17413971600007],
              [-94.77330481699994, 59.16889069200005],
              [-94.77489173099991, 59.16156647300005],
              [-94.78380286399994, 59.14472077000005],
              [-94.78693600199995, 59.134751695000034],
              [-94.79116777299993, 59.100043036000045],
              [-94.79312089799993, 59.093817450000074],
              [-94.84243730399993, 59.08112213700008],
              [-94.9077856109999, 59.08698151200008],
              [-94.96727454299992, 59.085923570000034],
              [-94.99917558499993, 59.052801825000074],
              [-94.96816972599993, 59.06150950700004],
              [-94.8164770169999, 59.068060614000046],
              [-94.8040258449999, 59.06305573100008],
              [-94.80418860599991, 59.05951569200005],
              [-94.80719967399995, 59.044623114000046],
              [-94.8074438139999, 59.03856028900003],
              [-94.80479895699995, 59.03278229400007],
              [-94.80211341099994, 59.02960846600007],
              [-94.8020727199999, 59.02574290600006],
              [-94.8074438139999, 59.01813385600008],
              [-94.76423092399995, 59.01500071800007],
              [-94.72370357999995, 59.00421784100007],
              [-94.69399980399993, 58.98346588700008],
              [-94.68325761599993, 58.950384833000044],
              [-94.68659420499995, 58.93109772300005],
              [-94.69408118399991, 58.91693756700005],
              [-94.71800696499992, 58.888373114000046],
              [-94.73102779899995, 58.880926825000074],
              [-94.73509680899991, 58.877793687000064],
              [-94.73717200399994, 58.87323639500005],
              [-94.7317602199999, 58.86656321800007],
              [-94.73167883999992, 58.861029364000046],
              [-94.73721269399994, 58.84784577000005],
              [-94.74596106699994, 58.83311595300006],
              [-94.68252519399994, 58.87250397300005],
              [-94.65001380099994, 58.88499583500004],
              [-94.60814368399991, 58.88153717700004],
              [-94.54515540299991, 58.85602448100008],
              [-94.51195227799991, 58.838324286000045],
              [-94.48525956899994, 58.82005442900004],
              [-94.46930904899995, 58.79734935100004],
              [-94.45213782499991, 58.74310944200005],
              [-94.43687903599994, 58.723822333000044],
              [-94.39948482999995, 58.71246979400007],
              [-94.36245683499993, 58.71893952000005],
              [-94.29352779899995, 58.74437083500004],
              [-94.29605058499993, 58.75092194200005],
              [-94.29751542899993, 58.75364817900004],
              [-94.30028235599991, 58.75739166900007],
              [-94.28819739499994, 58.76524485900006],
              [-94.27594967399995, 58.78314850500004],
              [-94.26553300699993, 58.792181708000044],
              [-94.25226803299995, 58.798163153000075],
              [-94.21963456899994, 58.80516185100004],
              [-94.20409094999991, 58.80646393400008],
              [-94.20840410099993, 58.79832591400003],
              [-94.21467037699995, 58.792222398000035],
              [-94.22264563699991, 58.78803131700005],
              [-94.23204505099994, 58.78534577000005],
              [-94.22411048099991, 58.774725653000075],
              [-94.22720292899993, 58.76398346600007],
              [-94.23428300699993, 58.75108470300006],
              [-94.23827063699991, 58.73411692900004],
              [-94.23330644399994, 58.71942780200004],
              [-94.2222387359999, 58.71153392100007],
              [-94.21056067599994, 58.70563385600008],
              [-94.20409094999991, 58.696600653000075],
              [-94.20799719999991, 58.68378327000005],
              [-94.22008216099994, 58.67039622600004],
              [-94.23525956899994, 58.659857489000046],
              [-94.26378333199995, 58.64923737200007],
              [-94.27643795499995, 58.63434479400007],
              [-94.2969457669999, 58.60374583500004],
              [-94.30850175699993, 58.57514069200005],
              [-94.28770911399994, 58.520819403000075],
              [-94.30064856699994, 58.48126862200007],
              [-94.28799394399994, 58.449286200000074],
              [-94.28661048099991, 58.43650950700004],
              [-94.29784094999991, 58.42100657800006],
              [-94.32632402299993, 58.39935944200005],
              [-94.33438066299993, 58.38141510600008],
              [-94.33433997299994, 58.37604401200008],
              [-94.32945716099994, 58.35883209800005],
              [-94.32823645699995, 58.35020579600007],
              [-94.33031165299991, 58.33690013200004],
              [-94.33922278599994, 58.31403229400007],
              [-94.34459387899994, 58.286810614000046],
              [-94.36148027299993, 58.243394273000035],
              [-94.36856035099993, 58.23041413000004],
              [-94.36172441299993, 58.22300853100006],
              [-94.33910071499992, 58.26593659100007],
              [-94.32237708199995, 58.288763739000046],
              [-94.30337480399993, 58.29869212400007],
              [-94.30313066299993, 58.30451080900008],
              [-94.28661048099991, 58.33966705900008],
              [-94.27700761599993, 58.34601471600007],
              [-94.26524817599994, 58.350775458000044],
              [-94.25894120999993, 58.35691966400003],
              [-94.26553300699993, 58.367621161000045],
              [-94.23794511599993, 58.39166901200008],
              [-94.23204505099994, 58.40110911700003],
              [-94.23094641799992, 58.41034577000005],
              [-94.23265540299991, 58.43711985900006],
              [-94.2351781889999, 58.442694403000075],
              [-94.24136308499993, 58.451157945000034],
              [-94.23827063699991, 58.51471588700008],
              [-94.23468990799995, 58.53583405200004],
              [-94.2351781889999, 58.54515208500004],
              [-94.24168860599991, 58.55573151200008],
              [-94.24486243399991, 58.56391022300005],
              [-94.24665279899995, 58.57713450700004],
              [-94.24673417899993, 58.59080638200004],
              [-94.24502519399994, 58.60032786700003],
              [-94.22769120999993, 58.62339915600006],
              [-94.18028723899994, 58.66107819200005],
              [-94.16315670499995, 58.682928778000075],
              [-94.16934160099993, 58.69367096600007],
              [-94.17100989499994, 58.70978424700007],
              [-94.16612708199995, 58.724310614000046],
              [-94.15257727799991, 58.73069896000004],
              [-94.14289303299995, 58.73680247600004],
              [-94.15322831899994, 58.75096263200004],
              [-94.16954505099994, 58.76707591400003],
              [-94.17739824099993, 58.77912018400008],
              [-94.14557857999995, 58.76976146000004],
              [-94.1167699859999, 58.76805247600004],
              [-94.0567113919999, 58.77167389500005],
              [-93.88194739499994, 58.75739166900007],
              [-93.86563066299993, 58.75804271000004],
              [-93.85484778599994, 58.76190827000005],
              [-93.83421790299991, 58.775376695000034],
              [-93.81867428299995, 58.77985260600008],
              [-93.80431067599994, 58.77802155200004],
              [-93.79027258999992, 58.77391185100004],
              [-93.77578691299993, 58.77167389500005],
              [-93.75999915299991, 58.774603583000044],
              [-93.73302161399994, 58.78807200700004],
              [-93.71743730399993, 58.792181708000044],
              [-93.69054114499994, 58.790350653000075],
              [-93.57274329299992, 58.76500071800007],
              [-93.55577551999994, 58.76325104400007],
              [-93.53258216099994, 58.77142975500004],
              [-93.49600175699993, 58.773504950000074],
              [-93.48473059799994, 58.77167389500005],
              [-93.4734594389999, 58.75523509300007],
              [-93.47191321499992, 58.73493073100008],
              [-93.46471106699994, 58.71751536700003],
              [-93.4363500639999, 58.710191148000035],
              [-93.42100989499994, 58.708197333000044],
              [-93.40908769399994, 58.705064195000034],
              [-93.3980199859999, 58.70526764500005],
              [-93.38512122299994, 58.713324286000045],
              [-93.35728919199994, 58.743353583000044],
              [-93.34752356699994, 58.751166083000044],
              [-93.32648678299995, 58.75995514500005],
              [-93.2344457669999, 58.76740143400008],
              [-93.21125240799995, 58.76654694200005],
              [-93.1895238919999, 58.75971100500004],
              [-93.17003333199995, 58.74437083500004],
              [-93.15575110599991, 58.74437083500004],
              [-93.15347245999993, 58.72601959800005],
              [-93.1341039699999, 58.68305084800005],
              [-93.13182532499991, 58.67234935100004],
              [-93.13931230399993, 58.65851471600007],
              [-93.14073645699995, 58.63975657800006],
              [-93.13532467399995, 58.60032786700003],
              [-93.13198808499993, 58.59088776200008],
              [-93.12336178299995, 58.573919989000046],
              [-93.12165279899995, 58.562486070000034],
              [-93.12743079299992, 58.53864166900007],
              [-93.1284887359999, 58.52838776200008],
              [-93.12344316299993, 58.512884833000044],
              [-93.09801184799994, 58.476263739000046],
              [-93.05077063699991, 58.42234935100004],
              [-93.04198157499991, 58.385931708000044],
              [-93.03258216099994, 58.36701080900008],
              [-93.02135169199994, 58.35069407800006],
              [-92.98403886599993, 58.31305573100008],
              [-92.97447669199994, 58.296942450000074],
              [-92.97081458199995, 58.27484772300005],
              [-92.9629613919999, 58.259873765000066],
              [-92.93468176999994, 58.233262437000064],
              [-92.93724524599992, 58.22300853100006],
              [-92.92105058499993, 58.20380280200004],
              [-92.91270911399994, 58.19639720300006],
              [-92.9019262359999, 58.189439195000034],
              [-92.87425696499992, 58.17845286700003],
              [-92.86168372299994, 58.17182038000004],
              [-92.85411536399994, 58.162095445000034],
              [-92.86831620999993, 58.153550523000035],
              [-92.86607825399994, 58.14594147300005],
              [-92.85594641799992, 58.13776276200008],
              [-92.84666907499991, 58.127386786000045],
              [-92.84032141799992, 58.10150788000004],
              [-92.83507239499994, 58.09080638200004],
              [-92.82363847599993, 58.08641185100004],
              [-92.80776933499993, 58.07575104400007],
              [-92.80386308499993, 58.05040110900006],
              [-92.80573482999995, 57.99766673400006],
              [-92.76610266799992, 57.910996812000064],
              [-92.75698808499993, 57.86591217700004],
              [-92.78579667899993, 57.83942291900007],
              [-92.77196204299992, 57.83478424700007],
              [-92.74331620999993, 57.832098700000074],
              [-92.73058020699995, 57.82575104400007],
              [-92.72362219999991, 57.81627024900007],
              [-92.71483313699991, 57.79291413000004],
              [-92.69469153599994, 57.76618073100008],
              [-92.66909745999993, 57.716498114000046],
              [-92.64500891799992, 57.69599030200004],
              [-92.61595618399991, 57.67125071800007],
              [-92.60773678299995, 57.65843333500004],
              [-92.60118567599994, 57.64166901200008],
              [-92.55923417899993, 57.58612702000005],
              [-92.55833899599992, 57.57648346600007],
              [-92.5613500639999, 57.55365631700005],
              [-92.55923417899993, 57.54454173400006],
              [-92.55020097599993, 57.538275458000044],
              [-92.5196020169999, 57.52716705900008],
              [-92.50772050699993, 57.52098216400003],
              [-92.5020238919999, 57.51398346600007],
              [-92.49665279899995, 57.504014390000066],
              [-92.49258378799993, 57.49388255400004],
              [-92.48729407499991, 57.47483958500004],
              [-92.47817949099993, 57.466498114000046],
              [-92.46703040299991, 57.45872630400004],
              [-92.45685787699995, 57.44896067900004],
              [-92.45083574099993, 57.43260325700004],
              [-92.44253495999993, 57.38764069200005],
              [-92.42357337099992, 57.35443756700005],
              [-92.42235266799992, 57.33417389500005],
              [-92.42894446499992, 57.29132721600007],
              [-92.4395238919999, 57.25328196800007],
              [-92.45677649599992, 57.22296784100007],
              [-92.54287675699993, 57.10578034100007],
              [-92.59715735599991, 57.04832591400003],
              [-92.66576087099992, 57.00055573100008],
              [-92.68932044199994, 56.970811265000066],
              [-92.70490475199995, 56.95538971600007],
              [-92.72069251199991, 56.94871653900003],
              [-92.76170813699991, 56.94358958500004],
              [-92.84264075399994, 56.92051829600007],
              [-92.88198808499993, 56.91453685100004],
              [-92.85977128799993, 56.907538153000075],
              [-92.72581946499992, 56.927435614000046],
              [-92.6765844389999, 56.94188060100004],
              [-92.5386449859999, 57.01890696800007],
              [-92.49095618399991, 57.03807200700004],
              [-92.27871660099993, 57.06537506700005],
              [-92.24242102799991, 57.07469310100004],
              [-92.23033606699994, 57.07282135600008],
              [-92.21812903599994, 57.06281159100007],
              [-92.22329667899993, 57.053900458000044],
              [-92.23717200399994, 57.04743073100008],
              [-92.25108801999994, 57.044907945000034],
              [-92.27428137899994, 57.037176825000074],
              [-92.34019934799994, 56.982855536000045],
              [-92.3548070949999, 56.97675202000005],
              [-92.37132727799991, 56.97247955900008],
              [-92.40566972599993, 56.969183661000045],
              [-92.42398027299993, 56.96544017100007],
              [-92.45433508999992, 56.947699286000045],
              [-92.47052975199995, 56.94188060100004],
              [-92.47052975199995, 56.93504466400003],
              [-92.41820227799991, 56.94953034100007],
              [-92.33739173099991, 56.95954010600008],
              [-92.31371008999992, 56.969590562000064],
              [-92.22350012899994, 57.021470445000034],
              [-92.11245683499993, 57.044134833000044],
              [-91.96165930899991, 57.060248114000046],
              [-91.76659094999991, 57.11469147300005],
              [-91.48497473899994, 57.16941966400003],
              [-91.21019446499992, 57.22907135600008],
              [-91.03111731699994, 57.26463450700004],
              [-90.85366777299993, 57.26109446800007],
              [-90.68911699099993, 57.22992584800005],
              [-90.60997473899994, 57.23322174700007],
              [-90.58551998599995, 57.22992584800005],
              [-90.51520748599995, 57.20164622600004],
              [-90.48989824099993, 57.195746161000045],
              [-90.43521074099993, 57.192613023000035],
              [-90.40929114499994, 57.187486070000034],
              [-90.3875219389999, 57.17462799700007],
              [-90.38060462099992, 57.15460846600007],
              [-90.31517493399991, 57.14362213700008],
              [-90.26130123599995, 57.11579010600008],
              [-90.16836503799993, 57.09271881700005],
              [-90.15929114499994, 57.082017320000034],
              [-90.15469316299993, 57.07904694200005],
              [-90.07225501199991, 57.06085846600007],
              [-90.0579320949999, 57.05516185100004],
              [-89.98778235599991, 57.013739325000074],
              [-89.9629613919999, 57.003973700000074],
              [-89.87271074099993, 56.99742259300007],
              [-89.82701575399994, 56.97601959800005],
              [-89.57469641799992, 56.94481028900003],
              [-89.51276607999995, 56.927069403000075],
              [-89.48253333199995, 56.921983140000066],
              [-89.39378821499992, 56.928168036000045],
              [-89.36701412699995, 56.922715562000064],
              [-89.3157445949999, 56.90424225500004],
              [-89.26561438699991, 56.896918036000045],
              [-89.18834387899994, 56.87299225500004],
              [-89.10728919199994, 56.86994049700007],
              [-89.08836829299992, 56.863348700000074],
              [-89.07506262899994, 56.85407135600008],
              [-89.05614173099991, 56.84552643400008],
              [-89.03624426999994, 56.84251536700003],
              [-89.02013098899994, 56.849676825000074],
              [-89.00348873599995, 56.853583075000074],
              [-88.94697018099993, 56.853216864000046],
              [-88.92076575399994, 56.85309479400007],
              [-88.9016820949999, 56.85919830900008],
              [-88.89118404899995, 56.86127350500004],
              [-88.87922115799995, 56.85993073100008],
              [-88.87393144399994, 56.855576890000066],
              [-88.86782792899993, 56.842230536000045],
              [-88.86278235599991, 56.83946360900006],
              [-88.8430883449999, 56.83869049700007],
              [-88.82335364499994, 56.835150458000044],
              [-88.81729081899994, 56.82689036700003],
              [-88.83824622299994, 56.812201239000046],
              [-88.80382239499994, 56.791001695000034],
              [-88.72496497299994, 56.755113023000035],
              [-88.68740800699993, 56.72960032800006],
              [-88.6609594389999, 56.70482005400004],
              [-88.64395097599993, 56.693426825000074],
              [-88.60741126199991, 56.68528880400004],
              [-88.54405676999994, 56.661322333000044],
              [-88.52375240799995, 56.66168854400007],
              [-88.49551347599993, 56.64838288000004],
              [-88.46666419199994, 56.62864817900004],
              [-88.43659420499995, 56.60313548400006],
              [-88.41234290299991, 56.58844635600008],
              [-88.4031469389999, 56.585638739000046],
              [-88.38719641799992, 56.58348216400003],
              [-88.37877356699994, 56.57831452000005],
              [-88.37319902299993, 56.571600653000075],
              [-88.36587480399993, 56.56513092700004],
              [-88.3113500639999, 56.53803131700005],
              [-88.10301673099991, 56.47724030200004],
              [-88.04328365799995, 56.46824778900003],
              [-87.98965410099993, 56.44944896000004],
              [-87.97956295499995, 56.44285716400003],
              [-87.97549394399994, 56.43138255400004],
              [-87.97207597599993, 56.42767975500004],
              [-87.95376542899993, 56.393784898000035],
              [-87.93887285099993, 56.37999095300006],
              [-87.85065670499995, 56.32282135600008],
              [-87.71788489499994, 56.194566148000035],
              [-87.71507727799991, 56.18817780200004],
              [-87.71353105399993, 56.17405833500004],
              [-87.7090551419999, 56.16002024900007],
              [-87.69713294199994, 56.153631903000075],
              [-87.67341061099995, 56.14557526200008],
              [-87.65103105399993, 56.12730540600006],
              [-87.62230383999992, 56.09556712400007],
              [-87.60806230399993, 56.08763255400004],
              [-87.59585527299993, 56.08494700700004],
              [-87.58922278599994, 56.07982005400004],
              [-87.59129798099991, 56.06480540600006],
              [-87.59654700399994, 56.058294989000046],
              [-87.62604732999995, 56.03070709800005],
              [-87.62165279899995, 56.017645575000074],
              [-87.61856035099993, 56.00275299700007],
              [-87.60338294199994, 56.01732005400004],
              [-87.59341386599993, 56.03339264500005],
              [-87.57900956899994, 56.046210028000075],
              [-87.55036373599995, 56.051214911000045],
              [-87.52599036399994, 56.04979075700004],
              [-87.5008031889999, 56.04486725500004],
              [-87.48477128799993, 56.03461334800005],
              [-87.48827063699991, 56.01703522300005],
              [-87.46328691299993, 56.01080963700008],
              [-87.38243567599994, 56.010199286000045],
              [-87.35513261599993, 56.003607489000046],
              [-87.35016842399995, 55.98741282800006],
              [-87.36534583199995, 55.94818756700005],
              [-87.31627356699994, 55.96234772300005],
              [-87.05687415299991, 55.92829010600008],
              [-86.98009192599994, 55.933579820000034],
              [-86.95384680899991, 55.92829010600008],
              [-86.95714270699995, 55.923814195000034],
              [-86.95881100199995, 55.92039622600004],
              [-86.96149654899995, 55.91746653900003],
              [-86.96812903599994, 55.91461823100008],
              [-86.95372473899994, 55.90855540600006],
              [-86.89549719999991, 55.91461823100008],
              [-86.87490800699993, 55.911322333000044],
              [-86.81725012899994, 55.886704820000034],
              [-86.77818762899994, 55.87754954600007],
              [-86.73843339799993, 55.87372467700004],
              [-86.71833248599995, 55.86900462400007],
              [-86.68370520699995, 55.851670640000066],
              [-86.58173601099992, 55.81703406400004],
              [-86.37284432399991, 55.76218817100005],
              [-86.28934617199991, 55.72564964800006],
              [-86.04656974099993, 55.68377732000005],
              [-85.9709489469999, 55.67519682000005],
              [-85.9042733629999, 55.66204948700005],
              [-85.87326853699994, 55.64595800300003],
              [-85.8315879459999, 55.638308228000085],
              [-85.79883180699994, 55.62613453700004],
              [-85.7700967799999, 55.61646709200005],
              [-85.73126682999992, 55.60887162000006],
              [-85.69644274599995, 55.60378366000003],
              [-85.68261343799992, 55.586584187000085],
              [-85.64908450699994, 55.56875222000008],
              [-85.61127939999994, 55.55156621500004],
              [-85.58061292199994, 55.53380118600006],
              [-85.55656942299993, 55.506663235000076],
              [-85.5231386719999, 55.48878374200007],
              [-85.50316321499992, 55.473496812000064],
              [-85.43916029099995, 55.42842955300006],
              [-85.32152258999992, 55.38971588700008],
              [-85.26406816299993, 55.37445709800005],
              [-85.15200761599993, 55.36041901200008],
              [-85.12791907499991, 55.34979889500005],
              [-85.11782792899993, 55.32843659100007],
              [-85.12661699099993, 55.30255768400008],
              [-85.14810136599993, 55.29389069200005],
              [-85.17471269399994, 55.29132721600007],
              [-85.19912675699993, 55.28400299700007],
              [-85.20787512899994, 55.275376695000034],
              [-85.2129613919999, 55.257798570000034],
              [-85.22028561099995, 55.24864329600007],
              [-85.23216712099992, 55.24237702000005],
              [-85.25963294199994, 55.23375071800007],
              [-85.27179928299995, 55.22565338700008],
              [-85.28693600199995, 55.20722077000005],
              [-85.30931555899991, 55.170355536000045],
              [-85.32266191299993, 55.15367259300007],
              [-85.38902747299994, 55.11212799700007],
              [-85.39842688699991, 55.09564850500004],
              [-85.39635169199994, 55.089911200000074],
              [-85.38744055899991, 55.07611725500004],
              [-85.38536536399994, 55.067694403000075],
              [-85.38809160099993, 55.06187571800007],
              [-85.40518144399994, 55.036363023000035],
              [-85.41909745999993, 55.00971100500004],
              [-85.4173070949999, 54.999212958000044],
              [-85.40355383999992, 55.003119208000044],
              [-85.3816625639999, 55.01988353100006],
              [-85.36636308499993, 55.03888580900008],
              [-85.33698482999995, 55.10529205900008],
              [-85.32461503799993, 55.12323639500005],
              [-85.19912675699993, 55.24241771000004],
              [-85.15453040299991, 55.26780833500004],
              [-85.10562089799993, 55.28473541900007],
              [-85.05394446499992, 55.294134833000044],
              [-84.94640051999994, 55.29515208500004],
              [-84.61314856699994, 55.24518463700008],
              [-84.55553137899994, 55.24864329600007],
              [-84.48159745999993, 55.267564195000034],
              [-84.44359290299991, 55.27252838700008],
              [-84.42162024599992, 55.28192780200004],
              [-84.22716223899994, 55.29706452000005],
              [-84.19351152299993, 55.29547760600008],
              [-84.13117428299995, 55.28034088700008],
              [-84.09809322799993, 55.27676015800006],
              [-84.07900956899994, 55.277451890000066],
              [-83.95726477799991, 55.32208893400008],
              [-83.92906653599994, 55.32652415600006],
              [-83.90440833199995, 55.32127513200004],
              [-83.86123613199993, 55.305121161000045],
              [-83.76756751199991, 55.281317450000074],
              [-83.72996985599991, 55.25950755400004],
              [-83.72423255099994, 55.24363841400003],
              [-83.73289954299992, 55.23187897300005],
              [-83.73664303299995, 55.22455475500004],
              [-83.71629798099991, 55.221909898000035],
              [-83.71104895699995, 55.225897528000075],
              [-83.70299231699994, 55.243841864000046],
              [-83.69896399599992, 55.24864329600007],
              [-83.68431555899991, 55.24876536700003],
              [-83.67324785099993, 55.24290599200003],
              [-83.66307532499991, 55.23517487200007],
              [-83.6511938139999, 55.229356187000064],
              [-83.6367895169999, 55.22886790600006],
              [-83.62364661399994, 55.23151276200008],
              [-83.61148027299993, 55.23216380400004],
              [-83.5996801419999, 55.22565338700008],
              [-83.59373938699991, 55.216498114000046],
              [-83.58926347599993, 55.206366278000075],
              [-83.58307857999995, 55.19806549700007],
              [-83.57201087099992, 55.194647528000075],
              [-83.56688391799992, 55.190741278000075],
              [-83.5735570949999, 55.18199290600006],
              [-83.58910071499992, 55.16791413000004],
              [-83.58828691299993, 55.15680573100008],
              [-83.58315995999993, 55.14789459800005],
              [-83.57396399599992, 55.14024485900006],
              [-83.56114661399994, 55.13316478100006],
              [-83.55492102799991, 55.14008209800005],
              [-83.57237708199995, 55.15477122600004],
              [-83.56899980399993, 55.16620514500005],
              [-83.55931555899991, 55.17572663000004],
              [-83.55801347599993, 55.18467845300006],
              [-83.57599850199995, 55.20490143400008],
              [-83.58104407499991, 55.21588776200008],
              [-83.58287512899994, 55.232489325000074],
              [-83.59288489499994, 55.241522528000075],
              [-83.61579342399995, 55.24559153900003],
              [-83.65802975199995, 55.24864329600007],
              [-83.67467200399994, 55.25377024900007],
              [-83.68809973899994, 55.260199286000045],
              [-83.71324622299994, 55.276556708000044],
              [-83.6895238919999, 55.284857489000046],
              [-83.57530676999994, 55.26732005400004],
              [-83.50035559799994, 55.24241771000004],
              [-83.48363196499992, 55.239569403000075],
              [-83.4383031889999, 55.24241771000004],
              [-83.42446855399993, 55.240342515000066],
              [-83.39956620999993, 55.23139069200005],
              [-83.28123938699991, 55.221909898000035],
              [-83.23949133999992, 55.22357819200005],
              [-83.22594153599994, 55.221909898000035],
              [-83.21458899599992, 55.21747467700004],
              [-83.19326738199993, 55.204291083000044],
              [-83.18504798099991, 55.20148346600007],
              [-83.1575414699999, 55.204291083000044],
              [-83.08885657499991, 55.229356187000064],
              [-83.03970292899993, 55.23895905200004],
              [-82.97569739499994, 55.23908112200007],
              [-82.92031816299993, 55.22052643400008],
              [-82.89761308499993, 55.17413971600007],
              [-82.90192623599995, 55.16844310100004],
              [-82.91104081899994, 55.16388580900008],
              [-82.92015540299991, 55.156683661000045],
              [-82.92430579299992, 55.143418687000064],
              [-82.92772376199991, 55.13776276200008],
              [-82.95164954299992, 55.11273834800005],
              [-82.92894446499992, 55.11692942900004],
              [-82.89753170499995, 55.14940013200004],
              [-82.87718665299991, 55.16050853100006],
              [-82.86253821499992, 55.15989817900004],
              [-82.8308813139999, 55.14948151200008],
              [-82.81509355399993, 55.14683665600006],
              [-82.76292883999992, 55.14512767100007],
              [-82.74620520699995, 55.14683665600006],
              [-82.67174231699994, 55.17072174700007],
              [-82.64439856699994, 55.17413971600007],
              [-82.61733964799993, 55.168809312000064],
              [-82.56663977799991, 55.14789459800005],
              [-82.54076087099992, 55.14683665600006],
              [-82.54271399599992, 55.151597398000035],
              [-82.54556230399993, 55.163275458000044],
              [-82.54759680899991, 55.16791413000004],
              [-82.5293676419999, 55.16758860900006],
              [-82.51545162699995, 55.15997955900008],
              [-82.50389563699991, 55.15110911700003],
              [-82.49266516799992, 55.14683665600006],
              [-82.47264563699991, 55.14545319200005],
              [-82.45848548099991, 55.14118073100008],
              [-82.44676673099991, 55.13361237200007],
              [-82.43431555899991, 55.12262604400007],
              [-82.42784583199995, 55.11871979400007],
              [-82.41612708199995, 55.11603424700007],
              [-82.41104081899994, 55.11273834800005],
              [-82.40941321499992, 55.107530015000066],
              [-82.4121801419999, 55.10289134300007],
              [-82.41429602799991, 55.098089911000045],
              [-82.41104081899994, 55.092230536000045],
              [-82.39403235599991, 55.08445872600004],
              [-82.35374915299991, 55.08030833500004],
              [-82.33531653599994, 55.07859935100004],
              [-82.32103430899991, 55.07111237200007],
              [-82.32445227799991, 55.08185455900008],
              [-82.34276282499991, 55.10529205900008],
              [-82.31139075399994, 55.11859772300005],
              [-82.31696529899995, 55.13275788000004],
              [-82.33861243399991, 55.14878978100006],
              [-82.35582434799994, 55.16791413000004],
              [-82.33092200399994, 55.162543036000045],
              [-82.29702714799993, 55.13275788000004],
              [-82.25226803299995, 55.11790599200003],
              [-82.24876868399991, 55.099595445000034],
              [-82.25670325399994, 55.07908763200004],
              [-82.2786352199999, 55.04547760600008],
              [-82.28270423099991, 55.02814362200007],
              [-82.27790279899995, 55.010931708000044],
              [-82.25645911399994, 54.98309967700004],
              [-82.25601152299993, 54.976263739000046],
              [-82.25853430899991, 54.968817450000074],
              [-82.26016191299993, 54.95783112200007],
              [-82.26231848899994, 54.95457591400003],
              [-82.26699785099993, 54.95274485900006],
              [-82.27171790299991, 54.95018138200004],
              [-82.27383378799993, 54.944525458000044],
              [-82.27269446499992, 54.93781159100007],
              [-82.27017167899993, 54.93256256700005],
              [-82.2664281889999, 54.927720445000034],
              [-82.25645911399994, 54.89293040600006],
              [-82.25340735599991, 54.88617584800005],
              [-82.2429906889999, 54.88194407800006],
              [-82.21788489499994, 54.88023509300007],
              [-82.20836341099994, 54.87592194200005],
              [-82.1985570949999, 54.85578034100007],
              [-82.20140540299991, 54.83392975500004],
              [-82.26016191299993, 54.71564362200007],
              [-82.31533769399994, 54.577460028000075],
              [-82.37783769399994, 54.47907135600008],
              [-82.39671790299991, 54.42682526200008],
              [-82.41494706899994, 54.39984772300005],
              [-82.41722571499992, 54.38898346600007],
              [-82.42096920499995, 54.38385651200008],
              [-82.43871008999992, 54.37144603100006],
              [-82.44448808499993, 54.36542389500005],
              [-82.43936113199993, 54.33702220300006],
              [-82.44107011599993, 54.33185455900008],
              [-82.42926998599995, 54.32770416900007],
              [-82.42711341099994, 54.317694403000075],
              [-82.43089758999992, 54.29718659100007],
              [-82.43089758999992, 54.228216864000046],
              [-82.42731686099995, 54.21238841400003],
              [-82.42031816299993, 54.19904205900008],
              [-82.41014563699991, 54.18663157800006],
              [-82.37165279899995, 54.15058014500005],
              [-82.36876380099994, 54.137884833000044],
              [-82.38304602799991, 54.12518952000005],
              [-82.37124589799993, 54.12006256700005],
              [-82.36042232999995, 54.12140534100007],
              [-82.3489477199999, 54.12461985900006],
              [-82.33531653599994, 54.12518952000005],
              [-82.32404537699995, 54.122259833000044],
              [-82.31371008999992, 54.11737702000005],
              [-82.25633704299992, 54.07945384300007],
              [-82.24258378799993, 54.06504954600007],
              [-82.17784583199995, 53.91905345300006],
              [-82.16026770699995, 53.899278062000064],
              [-82.15453040299991, 53.887559312000064],
              [-82.14244544199994, 53.83588288000004],
              [-82.13296464799993, 53.82416413000004],
              [-82.12604732999995, 53.812201239000046],
              [-82.13068600199995, 53.785589911000045],
              [-82.14346269399994, 53.745347398000035],
              [-82.15025794199994, 53.731675523000035],
              [-82.18789628799993, 53.68016185100004],
              [-82.20079505099994, 53.67047760600008],
              [-82.20775305899991, 53.64801666900007],
              [-82.21255449099993, 53.62266673400006],
              [-82.21922766799992, 53.60443756700005],
              [-82.20612545499995, 53.59007396000004],
              [-82.20539303299995, 53.57469310100004],
              [-82.20970618399991, 53.559027411000045],
              [-82.21178137899994, 53.54356517100007],
              [-82.20815995999993, 53.526597398000035],
              [-82.20116126199991, 53.50853099200003],
              [-82.19180253799993, 53.49164459800005],
              [-82.16242428299995, 53.45408763200004],
              [-82.14875240799995, 53.42633698100008],
              [-82.11558997299994, 53.30963776200008],
              [-82.11440995999993, 53.28900788000004],
              [-82.11851966099994, 53.27728913000004],
              [-82.14012610599991, 53.25873444200005],
              [-82.18858801999994, 53.23204173400006],
              [-82.20152747299994, 53.22833893400008],
              [-82.21857662699995, 53.226629950000074],
              [-82.23814856699994, 53.22142161700003],
              [-82.25055904899995, 53.212958075000074],
              [-82.24596106699994, 53.20099518400008],
              [-82.27794348899994, 53.14109935100004],
              [-82.28970292899993, 53.11017487200007],
              [-82.30345618399991, 53.03270091400003],
              [-82.29771887899994, 53.018866278000075],
              [-82.28823808499993, 53.006293036000045],
              [-82.2832738919999, 52.99164459800005],
              [-82.28628495999993, 52.977769273000035],
              [-82.30117753799993, 52.96759674700007],
              [-82.2747289699999, 52.95750560100004],
              [-82.23664303299995, 52.92597077000005],
              [-82.19635982999995, 52.916449286000045],
              [-82.18626868399991, 52.910223700000074],
              [-82.1778051419999, 52.903509833000044],
              [-82.17080644399994, 52.89935944200005],
              [-82.12498938699991, 52.891831773000035],
              [-82.10936438699991, 52.88507721600007],
              [-82.04185950399994, 52.84284088700008],
              [-81.98814856699994, 52.79844798400006],
              [-81.97704016799992, 52.78217194200005],
              [-81.98582923099991, 52.76837799700007],
              [-81.9597875639999, 52.747748114000046],
              [-81.91820227799991, 52.68036530200004],
              [-81.88621985599991, 52.66596100500004],
              [-81.85167395699995, 52.65643952000005],
              [-81.81590735599991, 52.633653062000064],
              [-81.71076412699995, 52.533636786000045],
              [-81.67979895699995, 52.510931708000044],
              [-81.64635169199994, 52.50153229400007],
              [-81.56383216099994, 52.456244208000044],
              [-81.55675208199995, 52.44440338700008],
              [-81.56029212099992, 52.43016185100004],
              [-81.57494055899991, 52.412095445000034],
              [-81.5664770169999, 52.395819403000075],
              [-81.55451412699995, 52.35309479400007],
              [-81.54356848899994, 52.34442780200004],
              [-81.53140214799993, 52.339544989000046],
              [-81.49022376199991, 52.314439195000034],
              [-81.47874915299991, 52.30345286700003],
              [-81.58145097599993, 52.316473700000074],
              [-81.60655676999994, 52.313666083000044],
              [-81.72158769399994, 52.27692291900007],
              [-81.73542232999995, 52.27558014500005],
              [-81.74400794199994, 52.25816478100006],
              [-81.75389563699991, 52.251166083000044],
              [-81.77041581899994, 52.25816478100006],
              [-81.79185950399994, 52.26422760600008],
              [-81.82017981699994, 52.25938548400006],
              [-81.84837805899991, 52.248032945000034],
              [-81.86913001199991, 52.23456452000005],
              [-81.84715735599991, 52.23895905200004],
              [-81.8372289699999, 52.24278392100007],
              [-81.82754472599993, 52.24823639500005],
              [-81.82135982999995, 52.24079010600008],
              [-81.8516332669999, 52.22064850500004],
              [-81.88280188699991, 52.19358958500004],
              [-81.85806230399993, 52.19407786700003],
              [-81.83250891799992, 52.199286200000074],
              [-81.80894934799994, 52.20921458500004],
              [-81.77131100199995, 52.236436265000066],
              [-81.74681555899991, 52.241888739000046],
              [-81.51203365799995, 52.23932526200008],
              [-81.46507727799991, 52.22032298400006],
              [-81.43740800699993, 52.19078196800007],
              [-81.39061438699991, 52.127793687000064],
              [-81.35521399599992, 52.10423411700003],
              [-81.27065995999993, 52.091009833000044],
              [-81.23306230399993, 52.07086823100008],
              [-81.15660559799994, 52.04279205900008],
              [-81.12962805899991, 52.04401276200008],
              [-81.11310787699995, 52.05211009300007],
              [-81.09870357999995, 52.05463288000004],
              [-81.07811438699991, 52.039048570000034],
              [-81.05695553299995, 52.026556708000044],
              [-81.00251217399995, 52.014837958000044],
              [-80.97911536399994, 52.00181712400007],
              [-80.97301184799994, 51.99396393400008],
              [-80.95799719999991, 51.96702708500004],
              [-80.93407141799992, 51.93903229400007],
              [-80.93065344999991, 51.92918528900009],
              [-80.92088782499991, 51.909409898000035],
              [-80.89769446499992, 51.896551825000074],
              [-80.84813391799992, 51.88450755400004],
              [-80.84146074099993, 51.88434479400007],
              [-80.82701575399994, 51.88568756700005],
              [-80.82079016799992, 51.88450755400004],
              [-80.81655839799993, 51.880926825000074],
              [-80.81598873599995, 51.877061265000066],
              [-80.81615149599992, 51.87339915600006],
              [-80.81403561099995, 51.87018463700008],
              [-80.77782141799992, 51.852769273000035],
              [-80.76927649599992, 51.84727610900006],
              [-80.74132239499994, 51.823919989000046],
              [-80.70470130099994, 51.80255768400008],
              [-80.69033769399994, 51.790269273000035],
              [-80.6570531889999, 51.754746812000064],
              [-80.64606686099995, 51.747300523000035],
              [-80.63487708199995, 51.74518463700008],
              [-80.62409420499995, 51.739569403000075],
              [-80.60509192599994, 51.72345612200007],
              [-80.59487870999993, 51.711371161000045],
              [-80.59361731699994, 51.70465729400007],
              [-80.59532630099994, 51.69794342700004],
              [-80.59430904899995, 51.68585846600007],
              [-80.5852758449999, 51.66596100500004],
              [-80.55882727799991, 51.62323639500005],
              [-80.54922441299993, 51.591050523000035],
              [-80.51915442599994, 51.53502024900007],
              [-80.50829016799992, 51.52167389500005],
              [-80.49185136599993, 51.505926825000074],
              [-80.47288977799991, 51.49274323100008],
              [-80.45433508999992, 51.48729075700004],
              [-80.44029700399994, 51.47728099200003],
              [-80.43614661399994, 51.45445384300007],
              [-80.43724524599992, 51.412176825000074],
              [-80.42756100199995, 51.37409088700008],
              [-80.42979895699995, 51.35716380400004],
              [-80.44717363199993, 51.35008372600004],
              [-80.46947180899991, 51.34796784100007],
              [-80.58429928299995, 51.31504954600007],
              [-80.62804114499994, 51.29564036700003],
              [-80.66881262899994, 51.27106354400007],
              [-80.70470130099994, 51.24083079600007],
              [-80.70986894399994, 51.23350657800006],
              [-80.72134355399993, 51.212225653000075],
              [-80.72834225199995, 51.20298899900007],
              [-80.73818925699993, 51.19371165600006],
              [-80.74551347599993, 51.18842194200005],
              [-80.76561438699991, 51.17877838700008],
              [-80.83885657499991, 51.15611399900007],
              [-80.86180579299992, 51.144639390000066],
              [-80.87328040299991, 51.13438548400006],
              [-80.89964758999992, 51.10028717700004],
              [-80.90941321499992, 51.092962958000044],
              [-80.96670488199993, 51.074652411000045],
              [-80.98485266799992, 51.06476471600007],
              [-80.99986731699994, 51.051947333000044],
              [-81.01260331899994, 51.03538646000004],
              [-80.97801673099991, 51.039496161000045],
              [-80.96019446499992, 51.044623114000046],
              [-80.94001217399995, 51.05560944200005],
              [-80.93419348899994, 51.05186595300006],
              [-80.93089758999992, 51.04405345300006],
              [-80.93065344999991, 51.03538646000004],
              [-80.93447831899994, 51.031683661000045],
              [-80.95799719999991, 51.014960028000075],
              [-80.95116126199991, 51.00812409100007],
              [-80.91714433499993, 51.03009674700007],
              [-80.8782445949999, 51.09564850500004],
              [-80.84813391799992, 51.12352122600004],
              [-80.82347571499992, 51.13133372600004],
              [-80.77017167899993, 51.13426341400009],
              [-80.74510657499991, 51.14122142100007],
              [-80.71214758999992, 51.15656159100007],
              [-80.70103919199994, 51.158311265000066],
              [-80.68976803299995, 51.16156647300005],
              [-80.6824438139999, 51.16929759300007],
              [-80.67662512899994, 51.178574937000064],
              [-80.6699926419999, 51.18622467700004],
              [-80.60484778599994, 51.218817450000074],
              [-80.59430904899995, 51.23029205900008],
              [-80.58629309799994, 51.248155015000066],
              [-80.56737219999991, 51.26512278900009],
              [-80.52599036399994, 51.28925202000005],
              [-80.45230058499993, 51.31492747600004],
              [-80.41002356699994, 51.339544989000046],
              [-80.38512122299994, 51.34137604400007],
              [-80.25112870999993, 51.31517161700003],
              [-80.2246801419999, 51.30573151200008],
              [-80.19701087099992, 51.29938385600008],
              [-80.13613847599993, 51.30133698100008],
              [-80.10826575399994, 51.296087958000044],
              [-80.09658769399994, 51.28888580900008],
              [-80.08039303299995, 51.27326080900008],
              [-80.06729081899994, 51.267564195000034],
              [-80.00894120999993, 51.26133860900006],
              [-79.98599199099993, 51.255113023000035],
              [-79.92332923099991, 51.206732489000046],
              [-79.87779700399994, 51.18309153900009],
              [-79.78408769399994, 51.14740631700005],
              [-79.74453691299993, 51.12352122600004],
              [-79.70592200399994, 51.064520575000074],
              [-79.69367428299995, 51.05528392100007],
              [-79.67593339799993, 51.04979075700004],
              [-79.56916256399995, 50.985581773000035],
              [-79.5208227199999, 50.94289785400008],
              [-79.42300370999993, 50.856634833000044],
              [-79.41441809799994, 50.843451239000046],
              [-79.40103105399993, 50.81696198100008],
              [-79.39199785099993, 50.805121161000045],
              [-79.35838782499991, 50.780462958000044],
              [-79.35411536399994, 50.77098216400009],
              [-79.35423743399991, 50.75653717700004],
              [-79.3528539699999, 50.743353583000044],
              [-79.34703528599994, 50.73301829600007],
              [-79.33429928299995, 50.72691478100006],
              [-79.33454342399995, 50.768418687000064],
              [-79.33958899599992, 50.79181549700007],
              [-79.35753333199995, 50.802069403000075],
              [-79.3692113919999, 50.811387437000064],
              [-79.40933183499993, 50.870306708000044],
              [-79.4434301419999, 50.90379466400009],
              [-79.46397864499994, 50.919134833000044],
              [-79.48135331899994, 50.92560455900008],
              [-79.49791419199994, 50.934027411000045],
              [-79.5208227199999, 50.96548086100006],
              [-79.52896074099993, 50.97675202000005],
              [-79.54588782499991, 50.99445221600007],
              [-79.66982988199993, 51.05841705900008],
              [-79.70360266799992, 51.09003327000005],
              [-79.72565670499995, 51.12177155200004],
              [-79.74266516799992, 51.15757884300007],
              [-79.74714107999995, 51.19550202000005],
              [-79.73151607999995, 51.23338450700004],
              [-79.69395911399994, 51.28099192900004],
              [-79.67951412699995, 51.31317780200004],
              [-79.6868383449999, 51.339829820000034],
              [-79.69456946499992, 51.351670640000066],
              [-79.69957434799994, 51.368353583000044],
              [-79.70075436099995, 51.38544342700004],
              [-79.69676673099991, 51.398504950000074],
              [-79.69033769399994, 51.39948151200008],
              [-79.64525305899991, 51.41901276200008],
              [-79.62783769399994, 51.42438385600008],
              [-79.60505123599995, 51.44782135600008],
              [-79.59064693899995, 51.453111070000034],
              [-79.53189042899993, 51.46173737200007],
              [-79.5208227199999, 51.46670156500005],
              [-79.51919511599993, 51.46739329600007],
              [-79.51911373599995, 51.48350657800006],
              [-79.52969316299993, 51.50971100500004],
              [-79.54531816299993, 51.53672923400006],
              [-79.56017005099994, 51.555528062000064],
              [-79.51642818899995, 51.56028880400004],
              [-79.46812903599994, 51.580186265000066],
              [-79.34601803299995, 51.661810614000046],
              [-79.32323157499991, 51.66697825700004],
              [-79.27896074099993, 51.64203522300005],
              [-79.25548255099994, 51.638739325000074],
              [-79.24453691299993, 51.630926825000074],
              [-79.25853430899991, 51.603949286000045],
              [-79.28111731699994, 51.57208893400008],
              [-79.28563391799992, 51.551988023000035],
              [-79.27562415299991, 51.53160228100006],
              [-79.26585852799991, 51.527777411000045],
              [-79.18415279899995, 51.52570221600007],
              [-79.16917883999992, 51.52826569200005],
              [-79.15794837099992, 51.53314850500004],
              [-79.14981035099993, 51.53864166900007],
              [-79.14122473899994, 51.54254791900007],
              [-79.12816321499992, 51.54254791900007],
              [-79.10960852799991, 51.53070709800005],
              [-79.09406490799995, 51.51829661700003],
              [-79.08275305899991, 51.50665924700007],
              [-79.02912350199995, 51.47992584800005],
              [-79.01154537699995, 51.46739329600007],
              [-79.00658118399991, 51.45575592700004],
              [-79.00719153599994, 51.43187083500004],
              [-79.00527910099993, 51.41901276200008],
              [-78.99836178299995, 51.40680573100008],
              [-78.97862708199995, 51.38914622600004],
              [-78.97057044199994, 51.37742747600004],
              [-78.9524633449999, 51.31159088700008],
              [-78.93980872299994, 51.292669989000046],
              [-78.93504798099991, 51.28160228100006],
              [-78.94090735599991, 51.27228424700007],
              [-78.96060136599993, 51.257920640000066],
              [-78.96336829299992, 51.247381903000075],
              [-78.95982825399994, 51.232489325000074],
              [-78.9531957669999, 51.21922435100004],
              [-78.91250566299993, 51.182481187000064],
              [-78.90094967399995, 51.177069403000075],
              [-78.84703528599994, 51.164496161000045],
              [-78.8587133449999, 51.17637767100007],
              [-78.87018795499995, 51.19281647300005],
              [-78.88292395699995, 51.20726146000004],
              [-78.91429602799991, 51.219183661000045],
              [-78.91978919199994, 51.23297760600008],
              [-78.91905676999994, 51.25059642100007],
              [-78.91222083199995, 51.289170640000066],
              [-78.90904700399994, 51.296087958000044],
              [-78.90330969999991, 51.304388739000046],
              [-78.88487708199995, 51.31968821800007],
              [-78.86237545499995, 51.344183661000045],
              [-78.84805253799993, 51.350897528000075],
              [-78.82656816299993, 51.35008372600004],
              [-78.84007727799991, 51.36290110900006],
              [-78.87970943899995, 51.37449778900009],
              [-78.8880102199999, 51.38764069200005],
              [-78.8821508449999, 51.40326569200005],
              [-78.86774654899995, 51.41368235900006],
              [-78.84992428299995, 51.42234935100004],
              [-78.83336341099994, 51.43268463700008],
              [-78.80972245999993, 51.46051666900007],
              [-78.79381262899994, 51.47447337400007],
              [-78.75357011599993, 51.48619212400007],
              [-78.74429277299993, 51.48729075700004],
              [-78.69001217399995, 51.48729075700004],
              [-78.71312415299991, 51.50653717700004],
              [-78.78229732999995, 51.503607489000046],
              [-78.81285559799994, 51.51459381700005],
              [-78.82266191299993, 51.53770579600007],
              [-78.81973222599993, 51.56797923400006],
              [-78.80821692599994, 51.59564850500004],
              [-78.79238847599993, 51.61078522300005],
              [-78.8040258449999, 51.61351146000004],
              [-78.82933508999992, 51.61424388200004],
              [-78.84080969999991, 51.61701080900008],
              [-78.84825598899994, 51.62409088700008],
              [-78.86750240799995, 51.64683665600006],
              [-78.87840735599991, 51.65171946800007],
              [-78.90510006399995, 51.653509833000044],
              [-78.92926998599995, 51.66046784100007],
              [-78.94249426999994, 51.675116278000075],
              [-78.93639075399994, 51.70014069200005],
              [-78.96568762899994, 51.71112702000005],
              [-78.98058020699995, 51.71857330900008],
              [-78.99168860599991, 51.72687409100007],
              [-79.0091039699999, 51.75352610900006],
              [-79.01939856699994, 51.76316966400009],
              [-79.03880774599992, 51.76850006700005],
              [-79.02904212099992, 51.78571198100008],
              [-79.0149633449999, 51.796128648000035],
              [-78.99746660099993, 51.80125560100004],
              [-78.97736568899995, 51.80255768400008],
              [-78.96788489499994, 51.80145905200004],
              [-78.94798743399991, 51.796576239000046],
              [-78.93639075399994, 51.79572174700007],
              [-78.92381751199991, 51.79820384300007],
              [-78.90172278599994, 51.807928778000075],
              [-78.87637285099993, 51.814886786000045],
              [-78.85708574099993, 51.82689036700003],
              [-78.84056555899991, 51.84227122600004],
              [-78.83336341099994, 51.85716380400004],
              [-78.83967037699995, 51.86827220300006],
              [-78.86839758999992, 51.890326239000046],
              [-78.87498938699991, 51.90867747600004],
              [-78.89150956899994, 51.932074286000045],
              [-78.89256751199991, 51.94676341400003],
              [-78.87120520699995, 51.95343659100007],
              [-78.82725989499994, 51.957871812000064],
              [-78.74718176999994, 51.97687409100007],
              [-78.73082434799994, 51.98741282800006],
              [-78.71971594999991, 52.01398346600007],
              [-78.71011308499993, 52.01500071800007],
              [-78.70059160099993, 52.01434967700004],
              [-78.69619706899994, 52.01825592700004],
              [-78.69619706899994, 52.029730536000045],
              [-78.69741777299993, 52.039496161000045],
              [-78.70152747299994, 52.04820384300007],
              [-78.70986894399994, 52.05646393400008],
              [-78.6692602199999, 52.055121161000045],
              [-78.6497289699999, 52.058661200000074],
              [-78.63475501199991, 52.06944407800006],
              [-78.64093990799995, 52.07212962400007],
              [-78.6497289699999, 52.07990143400008],
              [-78.65526282499991, 52.08372630400004],
              [-78.63329016799992, 52.09357330900008],
              [-78.61164303299995, 52.09845612200007],
              [-78.59129798099991, 52.10614655200004],
              [-78.57331295499995, 52.124701239000046],
              [-78.56948808499993, 52.13349030200004],
              [-78.56314042899993, 52.15562571800007],
              [-78.55899003799993, 52.165716864000046],
              [-78.55247962099992, 52.17405833500004],
              [-78.53722083199995, 52.18891022300005],
              [-78.53172766799992, 52.19977448100008],
              [-78.55296790299991, 52.236395575000074],
              [-78.54674231699994, 52.24664948100008],
              [-78.51805579299992, 52.255072333000044],
              [-78.48997962099992, 52.256699937000064],
              [-78.40819251199991, 52.24079010600008],
              [-78.40819251199991, 52.24823639500005],
              [-78.42467200399994, 52.255845445000034],
              [-78.43639075399994, 52.264837958000044],
              [-78.44871985599991, 52.27240631700005],
              [-78.46715247299994, 52.27558014500005],
              [-78.51227779899995, 52.27757396000004],
              [-78.53506425699993, 52.27574290600006],
              [-78.55284583199995, 52.26813385600008],
              [-78.55894934799994, 52.28880442900004],
              [-78.54686438699991, 52.30442942900004],
              [-78.51183020699995, 52.330186265000066],
              [-78.49958248599995, 52.35582103100006],
              [-78.50812740799995, 52.36749909100007],
              [-78.5235082669999, 52.37677643400008],
              [-78.53172766799992, 52.39533112200007],
              [-78.52611243399991, 52.39976634300007],
              [-78.5156957669999, 52.41046784100007],
              [-78.50987708199995, 52.42137278900003],
              [-78.51838131399995, 52.42637767100007],
              [-78.53514563699991, 52.43065013200004],
              [-78.54308020699995, 52.44004954600007],
              [-78.5403539699999, 52.44940827000005],
              [-78.51357988199993, 52.45795319200005],
              [-78.51203365799995, 52.46735260600008],
              [-78.51598059799994, 52.47675202000005],
              [-78.52147376199991, 52.48094310100004],
              [-78.5664770169999, 52.48786041900007],
              [-78.55894934799994, 52.497381903000075],
              [-78.55101477799991, 52.50141022300005],
              [-78.54539954299992, 52.50547923400006],
              [-78.54539954299992, 52.51512278900003],
              [-78.55166581899994, 52.52484772300005],
              [-78.56305904899995, 52.533270575000074],
              [-78.57579505099994, 52.53937409100007],
              [-78.58633378799993, 52.54242584800005],
              [-78.63267981699994, 52.531683661000045],
              [-78.65282141799992, 52.53172435100004],
              [-78.64903723899994, 52.549261786000045],
              [-78.66771399599992, 52.555975653000075],
              [-78.68346106699994, 52.55255768400008],
              [-78.69904537699995, 52.54584381700005],
              [-78.71727454299992, 52.54242584800005],
              [-78.71515865799995, 52.546942450000074],
              [-78.71182206899994, 52.55821360900006],
              [-78.70986894399994, 52.562933661000045],
              [-78.72484290299991, 52.56244538000004],
              [-78.75072180899991, 52.56854889500005],
              [-78.76512610599991, 52.570379950000074],
              [-78.76512610599991, 52.57721588700008],
              [-78.74445553299995, 52.57750071800007],
              [-78.71031653599994, 52.59442780200004],
              [-78.69001217399995, 52.597723700000074],
              [-78.69945227799991, 52.60541413000004],
              [-78.70909583199995, 52.61107005400004],
              [-78.71939042899993, 52.61497630400004],
              [-78.73094641799992, 52.61753978100006],
              [-78.73094641799992, 52.624986070000034],
              [-78.70986894399994, 52.624986070000034],
              [-78.71886145699995, 52.63825104400007],
              [-78.72419186099995, 52.65228913000004],
              [-78.74034583199995, 52.64667389500005],
              [-78.75601152299993, 52.646470445000034],
              [-78.77110755099994, 52.650824286000045],
              [-78.78555253799993, 52.65912506700005],
              [-78.76146399599992, 52.68378327000005],
              [-78.76244055899991, 52.69603099200003],
              [-78.78355872299994, 52.70026276200008],
              [-78.81973222599993, 52.70066966400003],
              [-78.81973222599993, 52.70689524900007],
              [-78.79686438699991, 52.70844147300005],
              [-78.77839107999995, 52.71381256700005],
              [-78.77204342399995, 52.72418854400007],
              [-78.78555253799993, 52.74103424700007],
              [-78.80378170499995, 52.74567291900007],
              [-78.83055579299992, 52.749335028000075],
              [-78.85016842399995, 52.75739166900007],
              [-78.84703528599994, 52.77521393400008],
              [-78.83079993399991, 52.782538153000075],
              [-78.75763912699995, 52.78266022300005],
              [-78.73501542899993, 52.789170640000066],
              [-78.72647050699993, 52.798081773000035],
              [-78.72687740799995, 52.81114329600007],
              [-78.73094641799992, 52.83043040600006],
              [-78.75015214799993, 52.82086823100008],
              [-78.76060950399994, 52.81785716400003],
              [-78.77159583199995, 52.81675853100006],
              [-78.78038489499994, 52.819647528000075],
              [-78.77497311099995, 52.826157945000034],
              [-78.69001217399995, 52.88507721600007],
              [-78.70494544199994, 52.88568756700005],
              [-78.78307044199994, 52.871527411000045],
              [-78.79600989499994, 52.87091705900008],
              [-78.82835852799991, 52.874212958000044],
              [-78.84235592399995, 52.87799713700008],
              [-78.85529537699995, 52.88389720300006],
              [-78.86750240799995, 52.89252350500004],
              [-78.88097083199995, 52.91197337400007],
              [-78.8899633449999, 52.92206452000005],
              [-78.9016820949999, 52.926621812000064],
              [-78.87450110599991, 52.93980540600006],
              [-78.86693274599992, 52.94957103100006],
              [-78.86750240799995, 52.96759674700007],
              [-78.85240637899994, 52.96051666900007],
              [-78.82188880099994, 52.96714915600006],
              [-78.80606035099993, 52.960150458000044],
              [-78.79881751199991, 52.964178778000075],
              [-78.7930395169999, 52.968858140000066],
              [-78.78868567599994, 52.974595445000034],
              [-78.78555253799993, 52.98187897300005],
              [-78.81322180899991, 52.98139069200005],
              [-78.82583574099993, 52.98387278900003],
              [-78.83714758999992, 52.99115631700005],
              [-78.84414628799993, 53.002020575000074],
              [-78.84874426999994, 53.01166413000004],
              [-78.85704505099994, 53.01715729400007],
              [-78.87498938699991, 53.01544830900008],
              [-78.87267005099994, 53.01219310100004],
              [-78.8723852199999, 53.01129791900007],
              [-78.87149003799993, 53.01068756700005],
              [-78.86750240799995, 53.00861237200007],
              [-78.89305579299992, 53.001654364000046],
              [-78.92715410099993, 53.00499095300006],
              [-78.96068274599992, 53.01512278900003],
              [-78.98420162699995, 53.02842845300006],
              [-78.96646074099993, 53.031317450000074],
              [-78.9453832669999, 53.03851959800005],
              [-78.92662512899994, 53.04954661700003],
              [-78.91592363199993, 53.06382884300007],
              [-78.92943274599992, 53.07221100500004],
              [-78.94395911399994, 53.072699286000045],
              [-78.95986894399994, 53.07025788000004],
              [-78.97736568899995, 53.070013739000046],
              [-78.91592363199993, 53.16620514500005],
              [-78.93927975199995, 53.18036530200004],
              [-78.93736731699994, 53.186712958000044],
              [-78.9212133449999, 53.191392320000034],
              [-78.9016820949999, 53.20099518400008],
              [-78.90648352799991, 53.20856354400007],
              [-78.91246497299994, 53.21430084800005],
              [-78.91982988199993, 53.21836985900006],
              [-78.92894446499992, 53.22089264500005],
              [-78.91966712099992, 53.22479889500005],
              [-78.89342200399994, 53.22984446800007],
              [-78.8880102199999, 53.231756903000075],
              [-78.89118404899995, 53.242621161000045],
              [-78.89928137899994, 53.24823639500005],
              [-78.91051184799994, 53.249701239000046],
              [-78.92271887899994, 53.248155015000066],
              [-78.90330969999991, 53.25958893400008],
              [-78.89541581899994, 53.261786200000074],
              [-78.89541581899994, 53.26862213700008],
              [-78.90591386599993, 53.269598700000074],
              [-78.92027747299994, 53.27281321800007],
              [-78.93419348899994, 53.27765534100007],
              [-78.94322669199994, 53.28294505400004],
              [-78.95201575399994, 53.29148997600004],
              [-78.95372473899994, 53.29511139500005],
              [-78.93980872299994, 53.30621979400007],
              [-78.93736731699994, 53.31700267100007],
              [-78.94627844999991, 53.327337958000044],
              [-78.95811926999994, 53.33661530200004],
              [-78.96434485599991, 53.34442780200004],
              [-78.96202551999994, 53.357123114000046],
              [-78.94688880099994, 53.370347398000035],
              [-78.94322669199994, 53.38190338700008],
              [-78.94493567599994, 53.392279364000046],
              [-78.94981848899994, 53.40228913000004],
              [-78.95738684799994, 53.40973541900007],
              [-78.96743730399993, 53.41266510600008],
              [-78.97288977799991, 53.41852448100008],
              [-78.9856664699999, 53.445746161000045],
              [-78.99168860599991, 53.45359935100004],
              [-79.00381425699993, 53.45579661700003],
              [-79.01878821499992, 53.45404694200005],
              [-79.03286699099993, 53.44957103100006],
              [-79.04255123599995, 53.44367096600007],
              [-79.05333411399994, 53.43931712400007],
              [-79.06322180899991, 53.44196198100008],
              [-79.06525631399995, 53.44786204600007],
              [-79.05247962099992, 53.45359935100004],
              [-79.05247962099992, 53.461045640000066],
              [-79.07628333199995, 53.46942780200004],
              [-79.08775794199994, 53.48041413000004],
              [-79.09703528599994, 53.49359772300005],
              [-79.1145727199999, 53.50885651200008],
              [-79.09459387899994, 53.52228424700007],
              [-79.07005774599992, 53.53062571800007],
              [-79.04206295499995, 53.53497955900008],
              [-79.03001868399991, 53.53510163000004],
              [-79.03823808499993, 53.53282298400006],
              [-79.04625403599994, 53.529364325000074],
              [-79.03880774599992, 53.52252838700008],
              [-79.04625403599994, 53.51630280200004],
              [-79.02843176999994, 53.49909088700008],
              [-79.00413977799991, 53.49766673400006],
              [-78.97842363199993, 53.50547923400006],
              [-78.95689856699994, 53.51630280200004],
              [-78.96776282499991, 53.52142975500004],
              [-78.99217688699991, 53.52757396000004],
              [-79.00157630099994, 53.53278229400007],
              [-79.01390540299991, 53.54791901200008],
              [-79.02106686099995, 53.55369700700004],
              [-79.03258216099994, 53.556626695000034],
              [-79.01952063699991, 53.57086823100008],
              [-78.99986731699994, 53.566839911000045],
              [-78.9785863919999, 53.555975653000075],
              [-78.96060136599993, 53.54979075700004],
              [-78.93260657499991, 53.555121161000045],
              [-78.92308508999992, 53.56671784100007],
              [-78.93130449099993, 53.57859935100004],
              [-78.95689856699994, 53.58458079600007],
              [-78.95689856699994, 53.59076569200005],
              [-78.95470130099994, 53.60008372600004],
              [-78.96519934799994, 53.60895416900007],
              [-78.9817602199999, 53.61542389500005],
              [-78.99787350199995, 53.61810944200005],
              [-79.02521725199995, 53.60443756700005],
              [-79.03595943899995, 53.602769273000035],
              [-79.05532792899993, 53.60187409100007],
              [-79.06615149599992, 53.59821198100008],
              [-79.06236731699994, 53.60956452000005],
              [-79.05630449099993, 53.620347398000035],
              [-79.04841061099995, 53.63023509300007],
              [-79.03880774599992, 53.63922760600008],
              [-79.02310136599993, 53.632066148000035],
              [-79.01260331899994, 53.63780345300006],
              [-79.00755774599992, 53.647650458000044],
              [-79.00841223899994, 53.65281810100004],
              [-79.02281653599994, 53.65294017100007],
              [-79.03376217399995, 53.654730536000045],
              [-79.04141191299993, 53.66050853100006],
              [-79.04625403599994, 53.672715562000064],
              [-79.03624426999994, 53.671576239000046],
              [-79.0235082669999, 53.67267487200007],
              [-79.01333574099993, 53.67731354400007],
              [-79.01154537699995, 53.68699778900003],
              [-79.01927649599992, 53.69391510600008],
              [-79.03302975199995, 53.69586823100008],
              [-79.05931555899991, 53.69444407800006],
              [-79.0852758449999, 53.696600653000075],
              [-79.13048255099994, 53.70600006700005],
              [-79.15611731699994, 53.70807526200008],
              [-79.14549719999991, 53.71942780200004],
              [-79.12694251199991, 53.72284577000005],
              [-79.05736243399991, 53.720038153000075],
              [-79.04881751199991, 53.72565338700008],
              [-79.03880774599992, 53.74164459800005],
              [-79.06261145699995, 53.74408600500004],
              [-79.06338456899994, 53.757147528000075],
              [-79.04625403599994, 53.79002513200004],
              [-79.05508378799993, 53.79157135600008],
              [-79.06090247299994, 53.794256903000075],
              [-79.07359778599994, 53.80365631700005],
              [-79.01891028599994, 53.82416413000004],
              [-79.03514563699991, 53.83002350500004],
              [-79.04308020699995, 53.83112213700008],
              [-79.05247962099992, 53.83100006700005],
              [-79.05247962099992, 53.83783600500004],
              [-79.01349850199995, 53.84589264500005],
              [-78.97679602799991, 53.836004950000074],
              [-78.94029700399994, 53.821966864000046],
              [-78.9016820949999, 53.81732819200005],
              [-78.92861894399994, 53.843451239000046],
              [-78.97142493399991, 53.85508860900006],
              [-79.06615149599992, 53.85765208500004],
              [-79.05890865799995, 53.880194403000075],
              [-79.06655839799993, 53.89427317900004],
              [-79.08446204299992, 53.90216705900008],
              [-79.10773678299995, 53.90611399900007],
              [-79.0801488919999, 53.91632721600007],
              [-79.05077063699991, 53.91620514500005],
              [-79.02090410099993, 53.91266510600008],
              [-78.99168860599991, 53.91290924700007],
              [-79.02228756399995, 53.935980536000045],
              [-79.09919186099995, 53.94940827000005],
              [-79.13508053299995, 53.961371161000045],
              [-79.07363847599993, 53.948553778000075],
              [-79.04234778599994, 53.94721100500004],
              [-79.02521725199995, 53.961371161000045],
              [-79.04283606699994, 53.96124909100007],
              [-79.07640540299991, 53.96759674700007],
              [-79.03880774599992, 53.96759674700007],
              [-79.04800370999993, 53.979681708000044],
              [-79.06403561099995, 53.98346588700008],
              [-79.1009008449999, 53.98179759300007],
              [-79.09170488199993, 53.98680247600004],
              [-79.08161373599995, 53.98936595300006],
              [-79.07070878799993, 53.98997630400004],
              [-79.05931555899991, 53.98924388200004],
              [-79.06273352799991, 53.99310944200005],
              [-79.06493079299992, 53.99628327000005],
              [-79.06798255099994, 53.999212958000044],
              [-79.07359778599994, 54.00230540600006],
              [-79.04898027299993, 54.01011790600006],
              [-78.96434485599991, 54.00230540600006],
              [-78.97956295499995, 54.019232489000046],
              [-79.0235082669999, 54.03392161700003],
              [-79.03258216099994, 54.046983140000066],
              [-79.04369055899991, 54.04319896000004],
              [-79.10773678299995, 54.063788153000075],
              [-79.1035863919999, 54.065293687000064],
              [-79.10073808499993, 54.06675853100006],
              [-79.09406490799995, 54.07123444200005],
              [-79.13711503799993, 54.08299388200004],
              [-79.26935787699995, 54.08356354400007],
              [-79.29263261599993, 54.091050523000035],
              [-79.26646887899994, 54.09935130400004],
              [-79.16917883999992, 54.091050523000035],
              [-79.17503821499992, 54.11151764500005],
              [-79.15680904899995, 54.11212799700007],
              [-79.12938391799992, 54.107489325000074],
              [-79.10773678299995, 54.11212799700007],
              [-79.12409420499995, 54.11969635600008],
              [-79.12865149599992, 54.12852610900006],
              [-79.12267005099994, 54.132513739000046],
              [-79.10773678299995, 54.12518952000005],
              [-79.10464433499993, 54.129014390000066],
              [-79.10289466099994, 54.13190338700008],
              [-79.10179602799991, 54.13495514500005],
              [-79.1009008449999, 54.13947174700007],
              [-79.11034094999991, 54.14313385600008],
              [-79.12059485599991, 54.14549388200004],
              [-79.13141842399995, 54.14642975500004],
              [-79.14244544199994, 54.145697333000044],
              [-79.12954667899993, 54.154364325000074],
              [-79.11534583199995, 54.158270575000074],
              [-79.08348548099991, 54.15928782800006],
              [-79.07249915299991, 54.162095445000034],
              [-79.05736243399991, 54.17560455900008],
              [-79.04625403599994, 54.18048737200007],
              [-79.06891842399995, 54.187486070000034],
              [-79.10138912699995, 54.187608140000066],
              [-79.16234290299991, 54.18048737200007],
              [-79.21393795499995, 54.163397528000075],
              [-79.23827063699991, 54.16168854400007],
              [-79.23802649599992, 54.18048737200007],
              [-79.2610570949999, 54.17454661700003],
              [-79.27310136599993, 54.17320384300007],
              [-79.28587805899991, 54.17365143400008],
              [-79.29185950399994, 54.18842194200005],
              [-79.32054602799991, 54.19672272300005],
              [-79.35594641799992, 54.198553778000075],
              [-79.38206946499992, 54.19407786700003],
              [-79.37181555899991, 54.206244208000044],
              [-79.35753333199995, 54.21544017100007],
              [-79.32681230399993, 54.228216864000046],
              [-79.32681230399993, 54.23505280200004],
              [-79.34044348899994, 54.24249909100007],
              [-79.33429928299995, 54.24872467700004],
              [-79.32225501199991, 54.24437083500004],
              [-79.30540930899991, 54.24156321800007],
              [-79.29088294199994, 54.24408600500004],
              [-79.28587805899991, 54.255560614000046],
              [-79.29320227799991, 54.26146067900004],
              [-79.40811113199993, 54.27086009300007],
              [-79.44351152299993, 54.28351471600007],
              [-79.43089758999992, 54.29364655200004],
              [-79.42487545499995, 54.29596588700008],
              [-79.41559811099995, 54.29718659100007],
              [-79.42418372299994, 54.30695221600007],
              [-79.43565833199995, 54.31049225500004],
              [-79.46397864499994, 54.31016673400006],
              [-79.45738684799994, 54.33087799700007],
              [-79.46336829299992, 54.35333893400008],
              [-79.47988847599993, 54.36969635600008],
              [-79.50499426999994, 54.372259833000044],
              [-79.50182044199994, 54.37579987200007],
              [-79.49966386599993, 54.379339911000045],
              [-79.49673417899993, 54.38267649900007],
              [-79.49132239499994, 54.38585032800006],
              [-79.49323482999995, 54.39044830900008],
              [-79.4961645169999, 54.40192291900007],
              [-79.49815833199995, 54.406358140000066],
              [-79.48542232999995, 54.40574778900003],
              [-79.47329667899993, 54.40733470300006],
              [-79.45030676999994, 54.41380442900004],
              [-79.45030676999994, 54.420030015000066],
              [-79.49046790299991, 54.42670319200005],
              [-79.50499426999994, 54.42682526200008],
              [-79.49425208199995, 54.44953034100007],
              [-79.49063066299993, 54.462591864000046],
              [-79.49474036399994, 54.468451239000046],
              [-79.50450598899994, 54.47300853100006],
              [-79.51378333199995, 54.48338450700004],
              [-79.51964270699995, 54.49469635600008],
              [-79.51919511599993, 54.501939195000034],
              [-79.52855383999992, 54.501654364000046],
              [-79.53709876199991, 54.50242747600004],
              [-79.54523678299995, 54.50482819200005],
              [-79.55337480399993, 54.50938548400006],
              [-79.52916419199994, 54.51707591400003],
              [-79.53986568899995, 54.53502024900007],
              [-79.56924394399994, 54.552069403000075],
              [-79.60118567599994, 54.55719635600008],
              [-79.60118567599994, 54.56464264500005],
              [-79.55040442599994, 54.56968821800007],
              [-79.52940833199995, 54.57721588700008],
              [-79.5254613919999, 54.59137604400007],
              [-79.53872636599993, 54.604356187000064],
              [-79.55947831899994, 54.60895416900007],
              [-79.58214270699995, 54.60639069200005],
              [-79.60118567599994, 54.59813060100004],
              [-79.59666907499991, 54.593817450000074],
              [-79.59203040299991, 54.591864325000074],
              [-79.58690344999991, 54.59137604400007],
              [-79.58067786399994, 54.59137604400007],
              [-79.60635331899994, 54.58075592700004],
              [-79.61986243399991, 54.577460028000075],
              [-79.63532467399995, 54.57770416900007],
              [-79.62246660099993, 54.59324778900003],
              [-79.6048070949999, 54.60773346600007],
              [-79.59203040299991, 54.62103913000004],
              [-79.59373938699991, 54.632920640000066],
              [-79.69054114499994, 54.632920640000066],
              [-79.65367591099994, 54.64252350500004],
              [-79.64830481699994, 54.649725653000075],
              [-79.65143795499995, 54.660996812000064],
              [-79.6594945949999, 54.66929759300007],
              [-79.67064368399991, 54.673895575000074],
              [-79.68309485599991, 54.673895575000074],
              [-79.67446855399993, 54.65892161700003],
              [-79.69945227799991, 54.65294017100007],
              [-79.76561438699991, 54.652777411000045],
              [-79.76561438699991, 54.65961334800005],
              [-79.74181067599994, 54.66229889500005],
              [-79.67634029899995, 54.693793036000045],
              [-79.66405188699991, 54.696600653000075],
              [-79.65318762899994, 54.69794342700004],
              [-79.64354407499991, 54.70075104400007],
              [-79.64098059799994, 54.716050523000035],
              [-79.64598548099991, 54.72601959800005],
              [-79.64293372299994, 54.73822663000004],
              [-79.62848873599995, 54.742173570000034],
              [-79.63809160099993, 54.73594798400006],
              [-79.6419164699999, 54.72846100500004],
              [-79.6360570949999, 54.71979401200008],
              [-79.62848873599995, 54.714829820000034],
              [-79.61693274599992, 54.71466705900008],
              [-79.59536699099993, 54.72565338700008],
              [-79.57237708199995, 54.73065827000005],
              [-79.54710852799991, 54.73997630400004],
              [-79.51602128799993, 54.74388255400004],
              [-79.5051977199999, 54.74799225500004],
              [-79.49600175699993, 54.75275299700007],
              [-79.48448645699995, 54.75641510600008],
              [-79.41087805899991, 54.76268138200004],
              [-79.39199785099993, 54.77317942900004],
              [-79.38414466099994, 54.77533600500004],
              [-79.33739173099991, 54.77692291900007],
              [-79.32461503799993, 54.779730536000045],
              [-79.29263261599993, 54.79743073100008],
              [-78.96743730399993, 54.851996161000045],
              [-78.95116126199991, 54.85797760600008],
              [-78.89541581899994, 54.89976634300007],
              [-78.87486731699994, 54.90766022300005],
              [-78.77306067599994, 54.92613353100006],
              [-78.72667395699995, 54.94432200700004],
              [-78.67760169199994, 54.951280015000066],
              [-78.62926184799994, 54.964951890000066],
              [-78.60374915299991, 54.968085028000075],
              [-78.57827714799993, 54.97569407800006],
              [-78.52965247299994, 55.00385163000004],
              [-78.50438391799992, 55.00287506700005],
              [-78.44977779899995, 55.02338288000004],
              [-78.39224199099993, 55.02753327000005],
              [-78.37808183499993, 55.033270575000074],
              [-78.36461341099994, 55.04063548400006],
              [-78.31261145699995, 55.05805084800005],
              [-78.27017167899993, 55.08165110900006],
              [-78.26113847599993, 55.08539459800005],
              [-78.23741614499994, 55.092230536000045],
              [-78.1555883449999, 55.14008209800005],
              [-78.04572506399995, 55.180975653000075],
              [-78.05190995999993, 55.180975653000075],
              [-78.00780188699991, 55.188666083000044],
              [-77.87441972599993, 55.24864329600007],
              [-77.80052649599992, 55.264105536000045],
              [-77.78160559799994, 55.273504950000074],
              [-77.67495683499993, 55.36692942900004],
              [-77.65778561099995, 55.37278880400004],
              [-77.63597571499992, 55.37681712400007],
              [-77.23753821499992, 55.59174225500004],
              [-77.16462154899995, 55.64325592700004],
              [-77.1380102199999, 55.65770091400003],
              [-77.11290442599994, 55.67536041900007],
              [-77.09300696499992, 55.70111725500004],
              [-77.08869381399995, 55.71421946800007],
              [-77.0957738919999, 55.71275462400007],
              [-77.10912024599992, 55.705511786000045],
              [-77.13939368399991, 55.69745514500005],
              [-77.1699926419999, 55.68296946800007],
              [-77.18919837099992, 55.68187083500004],
              [-77.16380774599992, 55.70917389500005],
              [-77.04454505099994, 55.78302643400008],
              [-76.90119381399995, 55.90033600500004],
              [-76.84190833199995, 55.933661200000074],
              [-76.82201087099992, 55.95184967700004],
              [-76.81704667899993, 55.960191148000035],
              [-76.81334387899994, 55.97748444200005],
              [-76.80870520699995, 55.986029364000046],
              [-76.79698645699995, 55.994208075000074],
              [-76.78184973899994, 55.998155015000066],
              [-76.75035559799994, 56.00275299700007],
              [-76.71153723899994, 56.01862213700008],
              [-76.68154863199993, 56.04291413000004],
              [-76.65868079299992, 56.07298411700003],
              [-76.62205969999991, 56.13947174700007],
              [-76.61876380099994, 56.166083075000074],
              [-76.61554928299995, 56.17670319200005],
              [-76.58885657499991, 56.23786041900007],
              [-76.57848059799994, 56.25580475500004],
              [-76.54515540299991, 56.295030015000066],
              [-76.53575598899994, 56.318467515000066],
              [-76.53156490799995, 56.34361399900007],
              [-76.53062903599994, 56.36961497600004],
              [-76.52623450399994, 56.39024485900006],
              [-76.51842200399994, 56.41364166900007],
              [-76.51512610599991, 56.43817780200004],
              [-76.52440344999991, 56.462103583000044],
              [-76.51695716099994, 56.46954987200007],
              [-76.52245032499991, 56.481634833000044],
              [-76.52603105399993, 56.49396393400008],
              [-76.52696692599994, 56.504339911000045],
              [-76.52440344999991, 56.51048411700003],
              [-76.52814693899995, 56.53180573100008],
              [-76.52745520699995, 56.59446849200003],
              [-76.50719153599994, 56.71149323100008],
              [-76.51073157499991, 56.72960032800006],
              [-76.50430253799993, 56.764105536000045],
              [-76.50373287699995, 56.78375885600008],
              [-76.51073157499991, 56.79783763200004],
              [-76.50885982999995, 56.814561265000066],
              [-76.52098548099991, 56.855536200000074],
              [-76.52765865799995, 56.89789459800005],
              [-76.54165605399993, 56.938666083000044],
              [-76.54702714799993, 56.979722398000035],
              [-76.55614173099991, 57.016058661000045],
              [-76.5579320949999, 57.031236070000034],
              [-76.55260169199994, 57.05320872600004],
              [-76.53286699099993, 57.087225653000075],
              [-76.53107662699995, 57.102769273000035],
              [-76.53270423099991, 57.115301825000074],
              [-76.53978430899991, 57.12474192900004],
              [-76.54906165299991, 57.132066148000035],
              [-76.5579320949999, 57.14109935100004],
              [-76.56460527299993, 57.153509833000044],
              [-76.56663977799991, 57.16400788000004],
              [-76.56533769399994, 57.19200267100007],
              [-76.58934485599991, 57.27130768400008],
              [-76.65660559799994, 57.404364325000074],
              [-76.66519120999993, 57.41648997600004],
              [-76.67833411399994, 57.42169830900008],
              [-76.68626868399991, 57.42719147300005],
              [-76.70128333199995, 57.453558661000045],
              [-76.70933997299994, 57.46263255400004],
              [-76.70197506399995, 57.46263255400004],
              [-76.69774329299992, 57.46263255400004],
              [-76.69611568899995, 57.46344635600008],
              [-76.69530188699991, 57.46580638200004],
              [-76.69570878799993, 57.46942780200004],
              [-76.71499589799993, 57.47333405200004],
              [-76.73497473899994, 57.49986399900007],
              [-76.76463782499991, 57.55882396000004],
              [-76.79662024599992, 57.59861888200004],
              [-76.80557206899994, 57.61347077000005],
              [-76.80870520699995, 57.67552317900004],
              [-76.86021887899994, 57.719916083000044],
              [-76.89574133999992, 57.762925523000035],
              [-76.90461178299995, 57.77049388200004],
              [-76.91364498599995, 57.77643463700008],
              [-76.92613684799994, 57.78998444200005],
              [-76.93732662699995, 57.805121161000045],
              [-76.94212805899991, 57.81586334800005],
              [-76.94981848899994, 57.827826239000046],
              [-76.98037675699993, 57.84650299700007],
              [-76.98306230399993, 57.85370514500005],
              [-76.99722245999993, 57.85736725500004],
              [-77.00829016799992, 57.86603424700007],
              [-77.05406653599994, 57.92987702000005],
              [-77.06627356699994, 57.943060614000046],
              [-77.07111568899995, 57.94977448100008],
              [-77.07437089799993, 57.95640696800007],
              [-77.07933508999992, 57.96149323100008],
              [-77.08922278599994, 57.96356842700004],
              [-77.09935462099992, 57.964097398000035],
              [-77.10627193899995, 57.96617259300007],
              [-77.11241614499994, 57.97016022300005],
              [-77.12026933499993, 57.976548570000034],
              [-77.12726803299995, 57.98493073100008],
              [-77.13951575399994, 58.007025458000044],
              [-77.14826412699995, 58.01752350500004],
              [-77.20181230399993, 58.05621979400007],
              [-77.26427161399994, 58.08641185100004],
              [-77.28302975199995, 58.09052155200004],
              [-77.32266191299993, 58.09454987200007],
              [-77.33999589799993, 58.10008372600004],
              [-77.3567602199999, 58.111436265000066],
              [-77.38654537699995, 58.13804759300007],
              [-77.40147864499994, 58.14789459800005],
              [-77.3946020169999, 58.14789459800005],
              [-77.41893469999991, 58.14817942900004],
              [-77.49083411399994, 58.168402411000045],
              [-77.47264563699991, 58.17491282800006],
              [-77.45396887899994, 58.177842515000066],
              [-77.44505774599992, 58.18463776200008],
              [-77.45604407499991, 58.203111070000034],
              [-77.47061113199993, 58.21198151200008],
              [-77.53180904899995, 58.23041413000004],
              [-77.60069739499994, 58.27134837400007],
              [-77.62315833199995, 58.27842845300006],
              [-77.69627844999991, 58.28510163000004],
              [-77.71524003799993, 58.29161204600007],
              [-77.77074133999992, 58.31915924700007],
              [-77.95628821499992, 58.36017487200007],
              [-78.01203365799995, 58.384833075000074],
              [-78.03148352799991, 58.38812897300005],
              [-78.01585852799991, 58.412176825000074],
              [-78.01447506399995, 58.42401764500005],
              [-78.02798417899993, 58.429022528000075],
              [-78.04491126199991, 58.432928778000075],
              [-78.06777910099993, 58.450873114000046],
              [-78.07876542899993, 58.45587799700007],
              [-78.11119544199994, 58.453111070000034],
              [-78.12767493399991, 58.454779364000046],
              [-78.13442949099993, 58.46662018400008],
              [-78.14370683499993, 58.47569407800006],
              [-78.20274817599994, 58.50482819200005],
              [-78.26732337099992, 58.51915110900006],
              [-78.27847245999993, 58.52838776200008],
              [-78.28282630099994, 58.53656647300005],
              [-78.31261145699995, 58.57306549700007],
              [-78.37189693899995, 58.61399974200003],
              [-78.40933183499993, 58.62970612200007],
              [-78.42992102799991, 58.62083567900004],
              [-78.41738847599993, 58.60069407800006],
              [-78.38337154899995, 58.57721588700008],
              [-78.32005774599992, 58.54637278900003],
              [-78.34455318899995, 58.538397528000075],
              [-78.3723852199999, 58.54193756700005],
              [-78.39879309799994, 58.55341217700004],
              [-78.41905676999994, 58.56932200700004],
              [-78.42808997299994, 58.574326890000066],
              [-78.43822180899991, 58.576239325000074],
              [-78.44644120999993, 58.57969798400006],
              [-78.45225989499994, 58.59906647300005],
              [-78.45872962099992, 58.606756903000075],
              [-78.46760006399995, 58.61200592700004],
              [-78.47740637899994, 58.61399974200003],
              [-78.52684485599991, 58.60773346600007],
              [-78.54881751199991, 58.60887278900003],
              [-78.5664770169999, 58.62083567900004],
              [-78.57095292899993, 58.638657945000034],
              [-78.56362870999993, 58.65306224200003],
              [-78.55943762899994, 58.66498444200005],
              [-78.57331295499995, 58.675482489000046],
              [-78.55663001199991, 58.68065013200004],
              [-78.53579667899993, 58.68187083500004],
              [-78.52000891799992, 58.685248114000046],
              [-78.51805579299992, 58.696600653000075],
              [-78.49819902299993, 58.70274485900006],
              [-78.48704993399991, 58.697373765000066],
              [-78.47508704299992, 58.698472398000035],
              [-78.46857662699995, 58.70600006700005],
              [-78.47370357999995, 58.72016022300005],
              [-78.48355058499993, 58.73139069200005],
              [-78.49339758999992, 58.73895905200004],
              [-78.53453528599994, 58.759100653000075],
              [-78.54246985599991, 58.76520416900007],
              [-78.54515540299991, 58.77366771000004],
              [-78.54539954299992, 58.788763739000046],
              [-78.53831946499992, 58.79547760600008],
              [-78.52342688699991, 58.79124583500004],
              [-78.51016191299993, 58.78339264500005],
              [-78.50816809799994, 58.77912018400008],
              [-78.49640865799995, 58.78306712400007],
              [-78.49014238199993, 58.79315827000005],
              [-78.48851477799991, 58.80646393400008],
              [-78.49079342399995, 58.82005442900004],
              [-78.4961645169999, 58.83185455900008],
              [-78.50332597599993, 58.84044017100007],
              [-78.52147376199991, 58.85736725500004],
              [-78.53575598899994, 58.880926825000074],
              [-78.54539954299992, 58.902044989000046],
              [-78.54775956899994, 58.91705963700008],
              [-78.54572506399995, 58.923895575000074],
              [-78.54010982999995, 58.92991771000004],
              [-78.53172766799992, 58.94297923400006],
              [-78.55996660099993, 58.944647528000075],
              [-78.5657445949999, 58.95774974200003],
              [-78.55109615799995, 58.96861399900007],
              [-78.51805579299992, 58.96344635600008],
              [-78.49986731699994, 58.95018138200004],
              [-78.48265540299991, 58.93235911700003],
              [-78.46434485599991, 58.91819896000004],
              [-78.44298255099994, 58.915716864000046],
              [-78.45140540299991, 58.93976471600007],
              [-78.43455969999991, 58.95445384300007],
              [-78.40831458199995, 58.96185944200005],
              [-78.38833574099993, 58.96344635600008],
              [-78.35680091099994, 58.959418036000045],
              [-78.35265051999994, 58.95136139500005],
              [-78.36115475199995, 58.93829987200007],
              [-78.3672582669999, 58.91905345300006],
              [-78.36180579299992, 58.914170640000066],
              [-78.3496801419999, 58.91596100500004],
              [-78.31639563699991, 58.92552317900004],
              [-78.31175696499992, 58.93256256700005],
              [-78.31175696499992, 58.940659898000035],
              [-78.31261145699995, 58.94672272300005],
              [-78.30467688699991, 58.95994700700004],
              [-78.28563391799992, 58.97435130400004],
              [-78.24372311099995, 58.99823639500005],
              [-78.27904212099992, 58.99518463700008],
              [-78.29678300699993, 58.99091217700004],
              [-78.31261145699995, 58.98395416900007],
              [-78.31501217399995, 58.98729075700004],
              [-78.31541907499991, 58.988389390000066],
              [-78.32005774599992, 58.991400458000044],
              [-78.30504309799994, 59.00153229400007],
              [-78.29100501199991, 59.00849030200004],
              [-78.2793676419999, 59.01715729400007],
              [-78.27163652299993, 59.03233470300006],
              [-78.27452551999994, 59.033270575000074],
              [-78.27977454299992, 59.03864166900007],
              [-78.28441321499992, 59.046087958000044],
              [-78.28526770699995, 59.052801825000074],
              [-78.27977454299992, 59.05841705900008],
              [-78.2696020169999, 59.06439850500004],
              [-78.25951087099992, 59.06883372600004],
              [-78.25426184799994, 59.06993235900006],
              [-78.24396725199995, 59.06297435100004],
              [-78.22642981699994, 59.05548737200007],
              [-78.21003170499995, 59.05345286700003],
              [-78.20274817599994, 59.06305573100008],
              [-78.20494544199994, 59.07367584800005],
              [-78.22325598899994, 59.10809967700004],
              [-78.20177161399994, 59.11265696800007],
              [-78.17861894399994, 59.092230536000045],
              [-78.1555883449999, 59.093817450000074],
              [-78.13141842399995, 59.10789622600004],
              [-78.12612870999993, 59.12327708500004],
              [-78.13556881399995, 59.13934967700004],
              [-78.1555883449999, 59.15521881700005],
              [-78.13744055899991, 59.161322333000044],
              [-78.10472571499992, 59.15538157800006],
              [-78.08665930899991, 59.161444403000075],
              [-78.09264075399994, 59.17369212400007],
              [-78.09748287699995, 59.19859446800007],
              [-78.10655676999994, 59.20990631700005],
              [-78.07555091099994, 59.22691478100006],
              [-77.99840247299994, 59.24449290600006],
              [-77.96629798099991, 59.261704820000034],
              [-77.94981848899994, 59.26788971600007],
              [-77.90656490799995, 59.26890696800007],
              [-77.87828528599994, 59.280585028000075],
              [-77.81920325399994, 59.293036200000074],
              [-77.83657792899993, 59.30259837400007],
              [-77.87547766799992, 59.307806708000044],
              [-77.89488684799994, 59.312933661000045],
              [-77.86929277299993, 59.32050202000005],
              [-77.81094316299993, 59.32013580900008],
              [-77.78502356699994, 59.32652415600006],
              [-77.76732337099992, 59.34039948100008],
              [-77.77017167899993, 59.35069407800006],
              [-77.80614173099991, 59.36815013200004],
              [-77.77790279899995, 59.38190338700008],
              [-77.67516028599994, 59.40228913000004],
              [-77.68748938699991, 59.406683661000045],
              [-77.71182206899994, 59.410589911000045],
              [-77.72354081899994, 59.41596100500004],
              [-77.72679602799991, 59.408189195000034],
              [-77.73216712099992, 59.40269603100006],
              [-77.73924719999991, 59.401231187000064],
              [-77.75340735599991, 59.40802643400008],
              [-77.7649633449999, 59.407538153000075],
              [-77.77074133999992, 59.40851471600007],
              [-77.7708227199999, 59.41083405200004],
              [-77.77301998599995, 59.422308661000045],
              [-77.77448482999995, 59.425848700000074],
              [-77.79295813699991, 59.43256256700005],
              [-77.81484941299993, 59.42682526200008],
              [-77.85391191299993, 59.40851471600007],
              [-77.87022864499994, 59.404364325000074],
              [-77.89061438699991, 59.40143463700008],
              [-77.90802975199995, 59.404730536000045],
              [-77.91539466099994, 59.41905345300006],
              [-77.90794837099992, 59.43512604400007],
              [-77.88971920499995, 59.445379950000074],
              [-77.86729895699995, 59.45018138200004],
              [-77.84707597599993, 59.450059312000064],
              [-77.84707597599993, 59.45697663000004],
              [-77.88117428299995, 59.48493073100008],
              [-77.84154212099992, 59.50861237200007],
              [-77.73721269399994, 59.539496161000045],
              [-77.73033606699994, 59.54865143400008],
              [-77.73216712099992, 59.565293687000064],
              [-77.72667395699995, 59.57672760600008],
              [-77.71617591099994, 59.62140534100007],
              [-77.72594153599994, 59.63047923400006],
              [-77.75348873599995, 59.63153717700004],
              [-77.76768958199995, 59.638780015000066],
              [-77.78490149599992, 59.659369208000044],
              [-77.79332434799994, 59.67182038000004],
              [-77.79869544199994, 59.682847398000035],
              [-77.78343665299991, 59.68223704600007],
              [-77.76891028599994, 59.68390534100007],
              [-77.75568600199995, 59.688666083000044],
              [-77.74404863199993, 59.69712962400007],
              [-77.76089433499993, 59.704779364000046],
              [-77.77818762899994, 59.710150458000044],
              [-77.70620683499993, 59.70331452000005],
              [-77.69469153599994, 59.699652411000045],
              [-77.68106035099993, 59.68244049700007],
              [-77.66852779899995, 59.67670319200005],
              [-77.63048255099994, 59.67719147300005],
              [-77.60505123599995, 59.680528062000064],
              [-77.58983313699991, 59.68626536700003],
              [-77.57774817599994, 59.69517649900007],
              [-77.57030188699991, 59.693426825000074],
              [-77.56314042899993, 59.68577708500004],
              [-77.55223548099991, 59.676621812000064],
              [-77.48753821499992, 59.647772528000075],
              [-77.46214758999992, 59.62457916900007],
              [-77.46971594999991, 59.59467194200005],
              [-77.44298255099994, 59.57758209800005],
              [-77.39976966099994, 59.56940338700008],
              [-77.31273352799991, 59.56675853100006],
              [-77.31273352799991, 59.57298411700003],
              [-77.38609778599994, 59.58299388200004],
              [-77.4258520169999, 59.595404364000046],
              [-77.44981848899994, 59.614569403000075],
              [-77.44318600199995, 59.62641022300005],
              [-77.44456946499992, 59.64488353100006],
              [-77.45197506399995, 59.66368235900006],
              [-77.46288001199991, 59.676621812000064],
              [-77.48058020699995, 59.68317291900007],
              [-77.54548092399995, 59.68968333500004],
              [-77.54600989499994, 59.694525458000044],
              [-77.54466712099992, 59.69611237200007],
              [-77.53799394399994, 59.69712962400007],
              [-77.54548092399995, 59.69712962400007],
              [-77.53307044199994, 59.701280015000066],
              [-77.51813717399995, 59.70286692900004],
              [-77.50316321499992, 59.70665110900006],
              [-77.49083411399994, 59.71759674700007],
              [-77.50739498599995, 59.718817450000074],
              [-77.52025305899991, 59.72687409100007],
              [-77.53197180899991, 59.73704661700003],
              [-77.54548092399995, 59.74494049700007],
              [-77.53538977799991, 59.75934479400007],
              [-77.52188066299993, 59.75775788000004],
              [-77.50731360599991, 59.749701239000046],
              [-77.49396725199995, 59.74494049700007],
              [-77.46841386599993, 59.747748114000046],
              [-77.45962480399993, 59.75535716400003],
              [-77.45702063699991, 59.76630280200004],
              [-77.44981848899994, 59.77903880400004],
              [-77.43244381399995, 59.78961823100008],
              [-77.41104081899994, 59.793402411000045],
              [-77.32168535099993, 59.79047272300005],
              [-77.30040442599994, 59.79205963700008],
              [-77.29161536399994, 59.79954661700003],
              [-77.35130774599992, 59.86676666900007],
              [-77.36046301999994, 59.88548411700003],
              [-77.37173417899993, 59.90033600500004],
              [-77.3958227199999, 59.90851471600007],
              [-77.41832434799994, 59.91364166900007],
              [-77.42503821499992, 59.91929759300007],
              [-77.41051184799994, 59.92564524900007],
              [-77.36807206899994, 59.925767320000034],
              [-77.35301673099991, 59.92987702000005],
              [-77.35993404899995, 59.93744538000004],
              [-77.36782792899993, 59.942246812000064],
              [-77.3770238919999, 59.94428131700005],
              [-77.38719641799992, 59.94354889500005],
              [-77.36668860599991, 59.95648834800005],
              [-77.34683183499993, 59.964951890000066],
              [-77.32510331899994, 59.96946849200003],
              [-77.29898027299993, 59.97089264500005],
              [-77.31541907499991, 59.97919342700004],
              [-77.33315995999993, 59.984483140000066],
              [-77.31346594999991, 59.99176666900007],
              [-77.25841223899994, 59.99827708500004],
              [-77.23631751199991, 59.99750397300005],
              [-77.23631751199991, 60.00495026200008],
              [-77.25597083199995, 60.00446198100008],
              [-77.28010006399995, 60.00726959800005],
              [-77.30142167899993, 60.01398346600007],
              [-77.31273352799991, 60.025458075000074],
              [-77.28311113199993, 60.026597398000035],
              [-77.24474036399994, 60.03367747600004],
              [-77.20946204299992, 60.045355536000045],
              [-77.18919837099992, 60.060248114000046],
              [-77.21568762899994, 60.058294989000046],
              [-77.30467688699991, 60.036444403000075],
              [-77.33079993399991, 60.03571198100008],
              [-77.34927324099993, 60.042181708000044],
              [-77.34618079299992, 60.060248114000046],
              [-77.35716712099992, 60.06427643400008],
              [-77.36974036399994, 60.06696198100008],
              [-77.38272050699993, 60.06793854400007],
              [-77.3946020169999, 60.066473700000074],
              [-77.40160071499992, 60.06236399900007],
              [-77.41478430899991, 60.04938385600008],
              [-77.41856848899994, 60.046576239000046],
              [-77.47655188699991, 60.052801825000074],
              [-77.55601966099994, 60.052801825000074],
              [-77.56330318899995, 60.05487702000005],
              [-77.57799231699994, 60.06427643400008],
              [-77.58641516799992, 60.066473700000074],
              [-77.63418535099993, 60.066473700000074],
              [-77.6204320949999, 60.07526276200008],
              [-77.59080969999991, 60.08649323100008],
              [-77.57957923099991, 60.09434642100007],
              [-77.58714758999992, 60.09870026200008],
              [-77.59227454299992, 60.103583075000074],
              [-77.60069739499994, 60.11481354400007],
              [-77.55711829299992, 60.130560614000046],
              [-77.53359941299993, 60.13426341400003],
              [-77.51406816299993, 60.125433661000045],
              [-77.50690670499995, 60.124212958000044],
              [-77.49404863199993, 60.12579987200007],
              [-77.48102779899995, 60.12885163000004],
              [-77.47313391799992, 60.13226959800005],
              [-77.46304277299993, 60.13300202000005],
              [-77.4082738919999, 60.12909577000005],
              [-77.4082738919999, 60.13532135600008],
              [-77.4824926419999, 60.153631903000075],
              [-77.50450598899994, 60.16266510600008],
              [-77.53530839799993, 60.183701890000066],
              [-77.55101477799991, 60.19794342700004],
              [-77.55968176999994, 60.211045640000066],
              [-77.51398678299995, 60.20783112200007],
              [-77.49058997299994, 60.20958079600007],
              [-77.46971594999991, 60.217230536000045],
              [-77.53148352799991, 60.255113023000035],
              [-77.5528051419999, 60.26402415600006],
              [-77.56419837099992, 60.26744212400007],
              [-77.56086178299995, 60.27244700700004],
              [-77.53799394399994, 60.28620026200008],
              [-77.56029212099992, 60.28510163000004],
              [-77.59520423099991, 60.269598700000074],
              [-77.61367753799993, 60.265692450000074],
              [-77.62189693899995, 60.27244700700004],
              [-77.61587480399993, 60.288397528000075],
              [-77.59325110599991, 60.32090892100007],
              [-77.60802161399994, 60.333685614000046],
              [-77.61644446499992, 60.339178778000075],
              [-77.63329016799992, 60.34369538000004],
              [-77.63341223899994, 60.34918854400007],
              [-77.63141842399995, 60.35569896000004],
              [-77.63418535099993, 60.36127350500004],
              [-77.65339107999995, 60.368475653000075],
              [-77.69627844999991, 60.375840562000064],
              [-77.71617591099994, 60.38239166900007],
              [-77.74315344999991, 60.40424225500004],
              [-77.7422582669999, 60.425848700000074],
              [-77.72337805899991, 60.44627513200004],
              [-77.69627844999991, 60.464911200000074],
              [-77.59170488199993, 60.50263092700004],
              [-77.56590735599991, 60.51890696800007],
              [-77.56281490799995, 60.524603583000044],
              [-77.56017005099994, 60.536810614000046],
              [-77.55601966099994, 60.54315827000005],
              [-77.5469457669999, 60.54743073100008],
              [-77.41510982999995, 60.54682038000004],
              [-77.43517005099994, 60.558579820000034],
              [-77.46084550699993, 60.56659577000005],
              [-77.54181881399995, 60.57566966400003],
              [-77.57274329299992, 60.57416413000004],
              [-77.58397376199991, 60.57111237200007],
              [-77.60728919199994, 60.561835028000075],
              [-77.61742102799991, 60.559881903000075],
              [-77.66466223899994, 60.55658600500004],
              [-77.68602454299992, 60.558294989000046],
              [-77.77057857999995, 60.59247467700004],
              [-77.78872636599993, 60.60484446800007],
              [-77.82925370999993, 60.64325592700004],
              [-77.82970130099994, 60.64923737200007],
              [-77.81285559799994, 60.653631903000075],
              [-77.75772050699993, 60.684027411000045],
              [-77.71841386599993, 60.69916413000004],
              [-77.70107988199993, 60.70844147300005],
              [-77.6712133449999, 60.732530015000066],
              [-77.62555904899995, 60.75438060100004],
              [-77.60684160099993, 60.759100653000075],
              [-77.62954667899993, 60.77496979400007],
              [-77.66795813699991, 60.77586497600004],
              [-77.74404863199993, 60.76654694200005],
              [-77.71833248599995, 60.781236070000034],
              [-77.51065019399994, 60.834824937000064],
              [-77.51065019399994, 60.841009833000044],
              [-77.56102454299992, 60.83881256700005],
              [-77.89488684799994, 60.75230540600006],
              [-77.88898678299995, 60.763739325000074],
              [-77.88048255099994, 60.77391185100004],
              [-77.86009680899991, 60.792669989000046],
              [-77.88166256399995, 60.80027903900003],
              [-77.96996008999992, 60.792669989000046],
              [-77.88068600199995, 60.827378648000035],
              [-77.91942298099991, 60.835272528000075],
              [-77.96288001199991, 60.829331773000035],
              [-78.04572506399995, 60.80695221600007],
              [-78.07982337099992, 60.80695221600007],
              [-78.19652258999992, 60.792669989000046],
              [-78.17076575399994, 60.85883209800005],
              [-78.16551673099991, 60.868353583000044],
              [-78.14045162699995, 60.87360260600008],
              [-78.12193762899994, 60.88633860900006],
              [-78.09414628799993, 60.91681549700007],
              [-78.02236894399994, 60.95103587400007],
              [-78.01097571499992, 60.96116771000004],
              [-78.00275631399995, 60.972357489000046],
              [-77.88792883999992, 61.037095445000034],
              [-77.87100175699993, 61.05023834800005],
              [-77.86168372299994, 61.054388739000046],
              [-77.84801184799994, 61.05524323100008],
              [-77.82258053299995, 61.053941148000035],
              [-77.80931555899991, 61.057074286000045],
              [-77.80817623599995, 61.06513092700004],
              [-77.81163489499994, 61.07611725500004],
              [-77.81236731699994, 61.08808014500005],
              [-77.79015051999994, 61.145819403000075],
              [-77.78872636599993, 61.15574778900003],
              [-77.78042558499993, 61.16010163000004],
              [-77.76520748599995, 61.17930735900006],
              [-77.75462805899991, 61.183661200000074],
              [-77.70311438699991, 61.191107489000046],
              [-77.69273841099994, 61.20734284100007],
              [-77.70824133999992, 61.21861399900007],
              [-77.75153561099995, 61.23204173400006],
              [-77.74388587099992, 61.242295640000066],
              [-77.73460852799991, 61.24994538000004],
              [-77.72679602799991, 61.258978583000044],
              [-77.72354081899994, 61.27305735900006],
              [-77.72679602799991, 61.27924225500004],
              [-77.74083411399994, 61.29051341400003],
              [-77.74404863199993, 61.29722728100006],
              [-77.74486243399991, 61.349676825000074],
              [-77.74840247299994, 61.37482330900008],
              [-77.75645911399994, 61.39976634300007],
              [-77.78526770699995, 61.45469798400006],
              [-77.77159583199995, 61.46263255400004],
              [-77.74909420499995, 61.45892975500004],
              [-77.73721269399994, 61.45457591400003],
              [-77.72402910099993, 61.43842194200005],
              [-77.69758053299995, 61.43183014500005],
              [-77.67715410099993, 61.43927643400008],
              [-77.68260657499991, 61.464829820000034],
              [-77.60773678299995, 61.46466705900008],
              [-77.5716039699999, 61.470404364000046],
              [-77.54548092399995, 61.48533763200004],
              [-77.63329016799992, 61.50934479400007],
              [-77.66612708199995, 61.52765534100007],
              [-77.65465247299994, 61.55418528900003],
              [-77.64126542899993, 61.560248114000046],
              [-77.62262936099995, 61.56407298400006],
              [-77.60366777299993, 61.563788153000075],
              [-77.5684301419999, 61.54755280200004],
              [-77.47655188699991, 61.53998444200005],
              [-77.50080318899995, 61.56329987200007],
              [-77.54556230399993, 61.57591380400004],
              [-77.63418535099993, 61.582139390000066],
              [-77.62315833199995, 61.593003648000035],
              [-77.60728919199994, 61.59398021000004],
              [-77.58942623599995, 61.59227122600004],
              [-77.57274329299992, 61.59520091400003],
              [-77.57274329299992, 61.60138580900008],
              [-77.59923255099994, 61.60846588700008],
              [-77.68569902299993, 61.60883209800005],
              [-77.70836341099994, 61.61627838700008],
              [-77.74038652299993, 61.64923737200007],
              [-77.75462805899991, 61.656683661000045],
              [-77.76423092399995, 61.66596100500004],
              [-77.79271399599992, 61.70136139500005],
              [-77.79869544199994, 61.70136139500005],
              [-77.81456458199995, 61.691839911000045],
              [-77.93984941299993, 61.69358958500004],
              [-77.96642005099994, 61.70184967700004],
              [-77.98973548099991, 61.714829820000034],
              [-78.00475012899994, 61.73236725500004],
              [-78.00698808499993, 61.74249909100007],
              [-78.00682532499991, 61.75377024900007],
              [-78.00475012899994, 61.76654694200005],
              [-78.00918535099993, 61.77826569200005],
              [-78.01329505099994, 61.78270091400003],
              [-78.01805579299992, 61.78571198100008],
              [-78.02456620999993, 61.79315827000005],
              [-78.02830969999991, 61.80060455900008],
              [-78.03441321499992, 61.81854889500005],
              [-78.03892981699994, 61.82794830900008],
              [-78.04580644399994, 61.83771393400008],
              [-78.06554114499994, 61.85582103100006],
              [-78.07876542899993, 61.873114325000074],
              [-78.08482825399994, 61.88804759300007],
              [-78.08299719999991, 61.903998114000046],
              [-78.07306881399995, 61.92413971600007],
              [-78.0801488919999, 61.93768952000005],
              [-78.08556067599994, 61.95811595300006],
              [-78.09398352799991, 61.97687409100007],
              [-78.12767493399991, 61.99327220300006],
              [-78.13695227799991, 62.01349518400008],
              [-78.1406957669999, 62.03856028900003],
              [-78.14273027299993, 62.10728587400007],
              [-78.14781653599994, 62.128607489000046],
              [-78.15868079299992, 62.14667389500005],
              [-78.16502844999991, 62.16693756700005],
              [-78.15802975199995, 62.18992747600004],
              [-78.14683997299994, 62.21271393400008],
              [-78.14126542899993, 62.23200104400007],
              [-78.15591386599993, 62.27374909100007],
              [-78.15489661399994, 62.297308661000045],
              [-78.13141842399995, 62.30772532800006],
              [-78.11815344999991, 62.309759833000044],
              [-78.1106664699999, 62.31578196800007],
              [-78.10728919199994, 62.325425523000035],
              [-78.10655676999994, 62.33844635600008],
              [-78.10049394399994, 62.34711334800005],
              [-78.02403723899994, 62.391791083000044],
              [-78.01097571499992, 62.396470445000034],
              [-77.97687740799995, 62.396470445000034],
              [-77.9356176419999, 62.40704987200007],
              [-77.91661536399994, 62.42072174700007],
              [-77.90542558499993, 62.423814195000034],
              [-77.88784745999993, 62.42597077000005],
              [-77.78465735599991, 62.467962958000044],
              [-77.76455644399994, 62.47223541900007],
              [-77.71422278599994, 62.47296784100007],
              [-77.68700110599991, 62.47728099200003],
              [-77.67516028599994, 62.48932526200008],
              [-77.65660559799994, 62.51658763200004],
              [-77.61412512899994, 62.531683661000045],
              [-77.53799394399994, 62.547308661000045],
              [-77.52391516799992, 62.55744049700007],
              [-77.50157630099994, 62.58002350500004],
              [-77.49083411399994, 62.588324286000045],
              [-77.47179114499994, 62.593817450000074],
              [-77.40485592399995, 62.588324286000045],
              [-77.40025794199994, 62.58466217700004],
              [-77.39256751199991, 62.56708405200004],
              [-77.38719641799992, 62.560980536000045],
              [-77.37751217399995, 62.55756256700005],
              [-77.37100175699993, 62.557928778000075],
              [-77.36506100199995, 62.559881903000075],
              [-77.3567602199999, 62.560980536000045],
              [-77.2766820949999, 62.55365631700005],
              [-77.25059973899994, 62.55414459800005],
              [-77.24364173099991, 62.54938385600008],
              [-77.16836503799993, 62.547308661000045],
              [-77.16100012899994, 62.54596588700008],
              [-77.15184485599991, 62.542303778000075],
              [-77.14403235599991, 62.53697337400007],
              [-77.14073645699995, 62.530585028000075],
              [-77.13711503799993, 62.52680084800005],
              [-77.12877356699994, 62.52830638200004],
              [-77.11343339799993, 62.53367747600004],
              [-77.07848059799994, 62.535264390000066],
              [-77.06627356699994, 62.53367747600004],
              [-77.05785071499992, 62.52912018400008],
              [-77.05060787699995, 62.522772528000075],
              [-77.04328365799995, 62.519232489000046],
              [-77.01878821499992, 62.53379954600007],
              [-76.99510657499991, 62.540716864000046],
              [-76.96983801999994, 62.54344310100004],
              [-76.94896399599992, 62.541083075000074],
              [-76.93382727799991, 62.534409898000035],
              [-76.92332923099991, 62.52753327000005],
              [-76.91201738199993, 62.52216217700004],
              [-76.75772050699993, 62.51080963700008],
              [-76.73582923099991, 62.50633372600004],
              [-76.71930904899995, 62.496161200000074],
              [-76.70474199099993, 62.48936595300006],
              [-76.66466223899994, 62.48688385600008],
              [-76.64732825399994, 62.47837962400007],
              [-76.65477454299992, 62.47223541900007],
              [-76.62686113199993, 62.46165599200003],
              [-76.59569251199991, 62.45807526200008],
              [-76.53404700399994, 62.45917389500005],
              [-76.46446692599994, 62.43537018400008],
              [-76.40147864499994, 62.43121979400007],
              [-76.30467688699991, 62.40729401200008],
              [-76.21934973899994, 62.399278062000064],
              [-76.19058183499993, 62.38780345300006],
              [-76.14989173099991, 62.38707103100006],
              [-76.13341223899994, 62.382879950000074],
              [-76.12535559799994, 62.374701239000046],
              [-76.11595618399991, 62.35443756700005],
              [-76.11290442599994, 62.349310614000046],
              [-76.09854081899994, 62.34564850500004],
              [-76.08438066299993, 62.34825267100007],
              [-76.06993567599994, 62.35297272300005],
              [-76.05483964799993, 62.355536200000074],
              [-76.04133053299995, 62.35337962400007],
              [-76.02318274599992, 62.34398021000004],
              [-76.01390540299991, 62.341864325000074],
              [-75.99762936099995, 62.34434642100007],
              [-75.96678626199991, 62.354356187000064],
              [-75.94904537699995, 62.355536200000074],
              [-75.93858801999994, 62.35211823100008],
              [-75.91429602799991, 62.33502838700008],
              [-75.85558020699995, 62.32440827000005],
              [-75.82974199099993, 62.313340562000064],
              [-75.65859941299993, 62.29649485900006],
              [-75.59215247299994, 62.27301666900007],
              [-75.59215247299994, 62.266791083000044],
              [-75.71642005099994, 62.23802317900004],
              [-75.75348873599995, 62.214951890000066],
              [-75.77090410099993, 62.206732489000046],
              [-75.81236731699994, 62.20213450700004],
              [-75.82827714799993, 62.19444407800006],
              [-75.84154212099992, 62.18585846600007],
              [-75.89378821499992, 62.163763739000046],
              [-75.83169511599993, 62.163763739000046],
              [-75.81436113199993, 62.16844310100004],
              [-75.77647864499994, 62.18695709800005],
              [-75.73542232999995, 62.195379950000074],
              [-75.67967688699991, 62.21576569200005],
              [-75.66783606699994, 62.22211334800005],
              [-75.57506262899994, 62.24567291900007],
              [-75.4934789699999, 62.29588450700004],
              [-75.47028561099995, 62.301947333000044],
              [-75.32774817599994, 62.31745026200008],
              [-75.17442786399994, 62.29405345300006],
              [-75.15050208199995, 62.28497955900008],
              [-75.14216061099995, 62.27228424700007],
              [-75.1446020169999, 62.25495026200008],
              [-75.15330969999991, 62.23200104400007],
              [-75.13304602799991, 62.23484935100004],
              [-75.10391191299993, 62.26129791900007],
              [-75.08503170499995, 62.266791083000044],
              [-75.09243730399993, 62.266791083000044],
              [-75.05174719999991, 62.27374909100007],
              [-75.00609290299991, 62.26898834800005],
              [-74.89037024599992, 62.23423899900007],
              [-74.84089107999995, 62.20392487200007],
              [-74.78966223899994, 62.182074286000045],
              [-74.78335527299993, 62.17804596600007],
              [-74.77965247299994, 62.17340729400007],
              [-74.77033443899995, 62.157538153000075],
              [-74.75853430899991, 62.15208567900004],
              [-74.67296301999994, 62.12376536700003],
              [-74.59825598899994, 62.110663153000075],
              [-74.55809485599991, 62.10911692900004],
              [-74.55809485599991, 62.11656321800007],
              [-74.58478756399995, 62.12181224200003],
              [-74.63735917899993, 62.14488353100006],
              [-74.68419348899994, 62.15582916900007],
              [-74.74107825399994, 62.18512604400007],
              [-74.75601152299993, 62.19782135600008],
              [-74.75503495999993, 62.21356842700004],
              [-74.74229895699995, 62.23151276200008],
              [-74.72354081899994, 62.24640534100007],
              [-74.70490475199995, 62.25250885600008],
              [-74.41685950399994, 62.25250885600008],
              [-74.39256751199991, 62.25914134300007],
              [-74.3782445949999, 62.264878648000035],
              [-74.37189693899995, 62.26988353100006],
              [-74.36497962099992, 62.27826569200005],
              [-74.3489477199999, 62.28257884300007],
              [-74.31786048099991, 62.28660716400003],
              [-74.29564368399991, 62.29840729400007],
              [-74.27839107999995, 62.323472398000035],
              [-74.24400794199994, 62.33067454600007],
              [-74.23058020699995, 62.335150458000044],
              [-74.21678626199991, 62.33702220300006],
              [-74.19151770699995, 62.32599518400008],
              [-74.17357337099992, 62.32408274900007],
              [-74.15469316299993, 62.32518138200004],
              [-74.13906816299993, 62.328233140000066],
              [-74.08698482999995, 62.35224030200004],
              [-74.01821855399993, 62.36078522300005],
              [-73.99791419199994, 62.36737702000005],
              [-73.98204505099994, 62.376654364000046],
              [-73.95702063699991, 62.40538157800006],
              [-73.94225012899994, 62.418402411000045],
              [-73.90709387899994, 62.429673570000034],
              [-73.88975989499994, 62.44293854400007],
              [-73.87657630099994, 62.45685455900008],
              [-73.87218176999994, 62.46478913000004],
              [-73.74868730399993, 62.47223541900007],
              [-73.69603430899991, 62.48102448100008],
              [-73.67072506399995, 62.482123114000046],
              [-73.64631100199995, 62.47223541900007],
              [-73.63304602799991, 62.45990631700005],
              [-73.59479732999995, 62.414170640000066],
              [-73.57144120999993, 62.39484284100007],
              [-73.55235755099994, 62.390733140000066],
              [-73.5313207669999, 62.39240143400008],
              [-73.50230872299994, 62.390326239000046],
              [-73.48985755099994, 62.38585032800006],
              [-73.48155676999994, 62.37995026200008],
              [-73.47508704299992, 62.37409088700008],
              [-73.46812903599994, 62.36981842700004],
              [-73.45018469999991, 62.36619700700004],
              [-73.4368383449999, 62.36908600500004],
              [-73.42369544199994, 62.37396881700005],
              [-73.40636145699995, 62.376654364000046],
              [-73.37816321499992, 62.37046946800007],
              [-73.35741126199991, 62.35626862200007],
              [-73.33885657499991, 62.34015534100007],
              [-73.31729081899994, 62.328233140000066],
              [-73.24767005099994, 62.321600653000075],
              [-73.20954342399995, 62.31281159100007],
              [-73.20409094999991, 62.29747142100007],
              [-73.21202551999994, 62.27631256700005],
              [-73.19603430899991, 62.26056549700007],
              [-73.08389238199993, 62.214951890000066],
              [-73.07371985599991, 62.20579661700003],
              [-73.06883704299992, 62.19578685100004],
              [-73.06216386599993, 62.187567450000074],
              [-73.04674231699994, 62.18419017100007],
              [-73.00999915299991, 62.18126048400006],
              [-72.96898352799991, 62.17291901200008],
              [-72.92983964799993, 62.15997955900008],
              [-72.89899654899995, 62.14325592700004],
              [-72.90941321499992, 62.13361237200007],
              [-72.92162024599992, 62.12950267100007],
              [-72.93455969999991, 62.12714264500005],
              [-72.94737708199995, 62.122748114000046],
              [-72.82461503799993, 62.11705149900007],
              [-72.78286699099993, 62.10911692900004],
              [-72.78286699099993, 62.11656321800007],
              [-72.82384192599994, 62.13580963700008],
              [-72.80650794199994, 62.142564195000034],
              [-72.75405839799993, 62.150091864000046],
              [-72.73448645699995, 62.150091864000046],
              [-72.71739661399994, 62.144639390000066],
              [-72.68789628799993, 62.126654364000046],
              [-72.62913977799991, 62.116888739000046],
              [-72.62144934799994, 62.10187409100007],
              [-72.63703365799995, 62.082017320000034],
              [-72.66616777299993, 62.06134674700007],
              [-72.62633216099994, 62.062933661000045],
              [-72.60838782499991, 62.05931224200003],
              [-72.59797115799995, 62.04767487200007],
              [-72.61229407499991, 62.04356517100007],
              [-72.61587480399993, 62.03656647300005],
              [-72.61050370999993, 62.02806224200003],
              [-72.59797115799995, 62.01972077000005],
              [-72.60334225199995, 62.00678131700005],
              [-72.60415605399993, 61.98847077000005],
              [-72.60777747299994, 61.97215403900003],
              [-72.62120520699995, 61.96507396000004],
              [-72.67300370999993, 61.958319403000075],
              [-72.68512936099995, 61.951280015000066],
              [-72.68871008999992, 61.945420640000066],
              [-72.68667558499993, 61.92731354400007],
              [-72.68736731699994, 61.91075267100007],
              [-72.69131425699993, 61.902329820000034],
              [-72.79596920499995, 61.83539459800005],
              [-72.75499426999994, 61.83539459800005],
              [-72.73102779899995, 61.84674713700008],
              [-72.69286048099991, 61.87559642100007],
              [-72.66616777299993, 61.88316478100006],
              [-72.66323808499993, 61.85008372600004],
              [-72.63158118399991, 61.82099030200004],
              [-72.60187740799995, 61.812567450000074],
              [-72.6048070949999, 61.84162018400008],
              [-72.61945553299995, 61.866888739000046],
              [-72.63170325399994, 61.89561595300006],
              [-72.63048255099994, 61.92291901200008],
              [-72.60521399599992, 61.94367096600007],
              [-72.59569251199991, 61.94318268400008],
              [-72.56956946499992, 61.932928778000075],
              [-72.48802649599992, 61.92413971600007],
              [-72.35708574099993, 61.88939036700003],
              [-72.23232988199993, 61.881293036000045],
              [-72.2031957669999, 61.86579010600008],
              [-72.19684811099995, 61.855536200000074],
              [-72.19359290299991, 61.84638092700004],
              [-72.18927975199995, 61.83746979400007],
              [-72.17959550699993, 61.82794830900008],
              [-72.14354407499991, 61.809759833000044],
              [-72.13182532499991, 61.80060455900008],
              [-72.15054277299993, 61.80040110900006],
              [-72.20628821499992, 61.79315827000005],
              [-72.19277910099993, 61.78819407800006],
              [-72.18700110599991, 61.78697337400007],
              [-72.18700110599991, 61.780137437000064],
              [-72.21157792899993, 61.77887604400007],
              [-72.2246801419999, 61.76622142100007],
              [-72.22370357999995, 61.75018952000005],
              [-72.20628821499992, 61.73859284100007],
              [-72.19469153599994, 61.73741282800006],
              [-72.18236243399991, 61.739121812000064],
              [-72.17088782499991, 61.74323151200008],
              [-72.15111243399991, 61.756699937000064],
              [-72.14110266799992, 61.75739166900007],
              [-72.07628333199995, 61.74485911700003],
              [-72.05748450399994, 61.73712799700007],
              [-72.04238847599993, 61.72553131700005],
              [-72.03807532499991, 61.716498114000046],
              [-72.0371801419999, 61.70738353100006],
              [-72.03453528599994, 61.700384833000044],
              [-72.01585852799991, 61.69566478100006],
              [-72.00584876199991, 61.69078196800007],
              [-71.9981176419999, 61.68406810100004],
              [-71.99522864499994, 61.67711009300007],
              [-72.00470943899995, 61.65989817900004],
              [-72.02464758999992, 61.64158763200004],
              [-72.06289628799993, 61.615668036000045],
              [-72.08511308499993, 61.60626862200007],
              [-72.10659745999993, 61.60325755400004],
              [-72.12840735599991, 61.604681708000044],
              [-72.20152747299994, 61.61741771000004],
              [-72.2434789699999, 61.617621161000045],
              [-72.27733313699991, 61.60309479400007],
              [-72.30308997299994, 61.56785716400003],
              [-72.24201412699995, 61.59747955900008],
              [-72.22085527299993, 61.60138580900008],
              [-72.11896725199995, 61.589178778000075],
              [-72.08340410099993, 61.58893463700008],
              [-72.06956946499992, 61.59117259300007],
              [-72.03624426999994, 61.60138580900008],
              [-72.02301998599995, 61.60309479400007],
              [-71.9915258449999, 61.60138580900008],
              [-71.97948157499991, 61.60382721600007],
              [-71.97203528599994, 61.61045970300006],
              [-71.96833248599995, 61.620306708000044],
              [-71.96727454299992, 61.63239166900007],
              [-71.96373450399994, 61.64195384300007],
              [-71.95567786399994, 61.64679596600007],
              [-71.94644120999993, 61.650498765000066],
              [-71.94001217399995, 61.656683661000045],
              [-71.93541419199994, 61.67096588700008],
              [-71.93797766799992, 61.677720445000034],
              [-71.94473222599993, 61.682481187000064],
              [-71.95303300699993, 61.69078196800007],
              [-71.96983801999994, 61.701239325000074],
              [-71.97276770699995, 61.708197333000044],
              [-71.95677649599992, 61.71124909100007],
              [-71.86363684799994, 61.69761790600006],
              [-71.80907141799992, 61.683294989000046],
              [-71.76065019399994, 61.677069403000075],
              [-71.75133216099994, 61.67401764500005],
              [-71.73232988199993, 61.66539134300007],
              [-71.67442786399994, 61.656317450000074],
              [-71.65200761599993, 61.64984772300005],
              [-71.58096269399994, 61.61383698100008],
              [-71.56944739499994, 61.60138580900008],
              [-71.59056555899991, 61.60138580900008],
              [-71.57526607999995, 61.596991278000075],
              [-71.55821692599994, 61.58734772300005],
              [-71.54865475199995, 61.574652411000045],
              [-71.55577551999994, 61.56102122600004],
              [-71.56712805899991, 61.55853913000004],
              [-71.60732988199993, 61.56785716400003],
              [-71.62389075399994, 61.56549713700008],
              [-71.62783769399994, 61.55963776200008],
              [-71.62913977799991, 61.55267975500004],
              [-71.63776607999995, 61.54682038000004],
              [-71.69151770699995, 61.53925202000005],
              [-71.80353756399995, 61.542303778000075],
              [-71.85741126199991, 61.53375885600008],
              [-71.84850012899994, 61.523138739000046],
              [-71.83145097599993, 61.52183665600006],
              [-71.79259192599994, 61.52692291900007],
              [-71.78693600199995, 61.52289459800005],
              [-71.78099524599992, 61.51390208500004],
              [-71.78180904899995, 61.50438060100004],
              [-71.79600989499994, 61.49896881700005],
              [-71.79600989499994, 61.491522528000075],
              [-71.77310136599993, 61.48273346600007],
              [-71.76130123599995, 61.479722398000035],
              [-71.74819902299993, 61.47911204600007],
              [-71.76878821499992, 61.460923570000034],
              [-71.81090247299994, 61.44794342700004],
              [-71.89159094999991, 61.43695709800005],
              [-71.89159094999991, 61.43073151200008],
              [-71.85529537699995, 61.42377350500004],
              [-71.79572506399995, 61.42332591400003],
              [-71.73452714799993, 61.410223700000074],
              [-71.61851966099994, 61.418036200000074],
              [-71.58311926999994, 61.410223700000074],
              [-71.62779700399994, 61.39594147300005],
              [-71.64647376199991, 61.393744208000044],
              [-71.65562903599994, 61.388373114000046],
              [-71.66197669199994, 61.38165924700007],
              [-71.67186438699991, 61.37547435100004],
              [-71.70726477799991, 61.368353583000044],
              [-71.82266191299993, 61.37547435100004],
              [-71.80370032499991, 61.37010325700004],
              [-71.79600989499994, 61.369248765000066],
              [-71.79600989499994, 61.36180247600004],
              [-71.81501217399995, 61.35594310100004],
              [-71.82266191299993, 61.35496653900003],
              [-71.80557206899994, 61.34784577000005],
              [-71.78416907499991, 61.34617747600004],
              [-71.74136308499993, 61.34813060100004],
              [-71.72126217399995, 61.34532298400006],
              [-71.68569902299993, 61.33466217700004],
              [-71.66563880099994, 61.33445872600004],
              [-71.67564856699994, 61.31915924700007],
              [-71.6914770169999, 61.30809153900003],
              [-71.72712154899995, 61.29352448100008],
              [-71.72712154899995, 61.28729889500005],
              [-71.69644120999993, 61.277411200000074],
              [-71.59679114499994, 61.25938548400006],
              [-71.61815344999991, 61.23432038000004],
              [-71.62564042899993, 61.221909898000035],
              [-71.6309301419999, 61.20416901200008],
              [-71.61758378799993, 61.20762767100007],
              [-71.59459387899994, 61.22223541900007],
              [-71.58311926999994, 61.224595445000034],
              [-71.57290605399993, 61.22052643400008],
              [-71.56639563699991, 61.21275462400007],
              [-71.56143144399994, 61.20416901200008],
              [-71.55577551999994, 61.197333075000074],
              [-71.57433020699995, 61.173081773000035],
              [-71.58043372299994, 61.16095612200007],
              [-71.57286536399994, 61.15574778900003],
              [-71.55406653599994, 61.15680573100008],
              [-71.53669186099995, 61.15977610900006],
              [-71.52110755099994, 61.16429271000004],
              [-71.50796464799993, 61.169989325000074],
              [-71.52253170499995, 61.18244049700007],
              [-71.53376217399995, 61.19627513200004],
              [-71.53538977799991, 61.21076080900008],
              [-71.52106686099995, 61.224595445000034],
              [-71.49767005099994, 61.230902411000045],
              [-71.47581946499992, 61.22638580900008],
              [-71.45970618399991, 61.21336497600004],
              [-71.45335852799991, 61.194199937000064],
              [-71.44399980399993, 61.18467845300006],
              [-71.39500891799992, 61.14952220300006],
              [-71.38902747299994, 61.141831773000035],
              [-71.37157141799992, 61.129014390000066],
              [-71.35997473899994, 61.12645091400003],
              [-71.37144934799994, 61.14952220300006],
              [-71.27497311099995, 61.15574778900003],
              [-71.23151607999995, 61.16746653900003],
              [-71.21328691299993, 61.167222398000035],
              [-71.22061113199993, 61.14952220300006],
              [-71.21108964799993, 61.13825104400007],
              [-71.19737708199995, 61.125840562000064],
              [-71.18504798099991, 61.122748114000046],
              [-71.17967688699991, 61.13959381700005],
              [-71.16763261599993, 61.141058661000045],
              [-71.11143958199995, 61.12523021000004],
              [-71.09365800699993, 61.12559642100007],
              [-71.07188880099994, 61.132798570000034],
              [-71.03880774599992, 61.13178131700005],
              [-70.95547441299993, 61.11619700700004],
              [-70.93537350199995, 61.106634833000044],
              [-70.92739824099993, 61.09271881700005],
              [-70.93944251199991, 61.07379791900007],
              [-70.84691321499992, 61.075425523000035],
              [-70.82274329299992, 61.067572333000044],
              [-70.81383216099994, 61.06134674700007],
              [-70.80284583199995, 61.05711497600004],
              [-70.78990637899994, 61.054754950000074],
              [-70.77497311099995, 61.053941148000035],
              [-70.76207434799994, 61.056708075000074],
              [-70.7617895169999, 61.06305573100008],
              [-70.76968339799993, 61.06976959800005],
              [-70.78180904899995, 61.07379791900007],
              [-70.7617895169999, 61.08580149900007],
              [-70.72573808499993, 61.07904694200005],
              [-70.6582738919999, 61.053941148000035],
              [-70.6582738919999, 61.04649485900006],
              [-70.66624915299991, 61.04437897300005],
              [-70.6856176419999, 61.03282298400006],
              [-70.66771399599992, 61.02684153900003],
              [-70.60366777299993, 61.03282298400006],
              [-70.55443274599992, 61.01386139500005],
              [-70.53538977799991, 61.01231517100007],
              [-70.53538977799991, 61.01984284100007],
              [-70.54662024599992, 61.02301666900007],
              [-70.55622311099995, 61.02838776200008],
              [-70.5637914699999, 61.03611888200004],
              [-70.56891842399995, 61.04649485900006],
              [-70.56069902299993, 61.04572174700007],
              [-70.54360917899993, 61.04706452000005],
              [-70.53538977799991, 61.04649485900006],
              [-70.53742428299995, 61.04901764500005],
              [-70.53917395699995, 61.05174388200004],
              [-70.54161536399994, 61.053941148000035],
              [-70.54161536399994, 61.06012604400007],
              [-70.5266820949999, 61.06541575700004],
              [-70.50767981699994, 61.06476471600007],
              [-70.48843339799993, 61.06028880400004],
              [-70.4727270169999, 61.053941148000035],
              [-70.47105872299994, 61.05036041900007],
              [-70.46996008999992, 61.037543036000045],
              [-70.46646074099993, 61.03282298400006],
              [-70.45750891799992, 61.02960846600007],
              [-70.42552649599992, 61.026597398000035],
              [-70.43195553299995, 61.040228583000044],
              [-70.44058183499993, 61.049994208000044],
              [-70.44318600199995, 61.058294989000046],
              [-70.43175208199995, 61.067572333000044],
              [-70.42446855399993, 61.063666083000044],
              [-70.41893469999991, 61.06199778900003],
              [-70.40440833199995, 61.06012604400007],
              [-70.41364498599995, 61.07294342700004],
              [-70.41836503799993, 61.07721588700008],
              [-70.42552649599992, 61.081244208000044],
              [-70.42552649599992, 61.08808014500005],
              [-70.40196692599994, 61.085923570000034],
              [-70.36363684799994, 61.068793036000045],
              [-70.34292558499993, 61.067572333000044],
              [-70.34732011599993, 61.08307526200008],
              [-70.33971106699994, 61.09479401200008],
              [-70.32510331899994, 61.10040924700007],
              [-70.30882727799991, 61.097723700000074],
              [-70.29906165299991, 61.09422435100004],
              [-70.26724199099993, 61.08808014500005],
              [-70.25352942599994, 61.07689036700003],
              [-70.24673417899993, 61.07379791900007],
              [-70.22915605399993, 61.07330963700008],
              [-70.21519934799994, 61.07847728100006],
              [-70.20250403599994, 61.08494700700004],
              [-70.1887914699999, 61.08808014500005],
              [-70.15534420499995, 61.08763255400004],
              [-70.14403235599991, 61.08356354400007],
              [-70.15119381399995, 61.07379791900007],
              [-70.13914954299992, 61.07017649900007],
              [-70.12437903599994, 61.070298570000034],
              [-70.11270097599993, 61.068793036000045],
              [-70.11021887899994, 61.06012604400007],
              [-70.11632239499994, 61.05601634300007],
              [-70.14248613199993, 61.04523346600007],
              [-70.15119381399995, 61.040269273000035],
              [-70.16006425699993, 61.02167389500005],
              [-70.14899654899995, 61.01117584800005],
              [-70.12694251199991, 61.01023997600004],
              [-70.10338294199994, 61.01984284100007],
              [-70.09593665299991, 61.01231517100007],
              [-70.10960852799991, 61.005072333000044],
              [-70.11172441299993, 60.996079820000034],
              [-70.10338294199994, 60.978216864000046],
              [-70.09927324099993, 60.972357489000046],
              [-70.09483801999994, 60.970811265000066],
              [-70.09121660099993, 60.968817450000074],
              [-70.08971106699994, 60.96116771000004],
              [-70.09068762899994, 60.95563385600008],
              [-70.09284420499995, 60.94953034100007],
              [-70.09496008999992, 60.94513580900008],
              [-70.09593665299991, 60.94468821800007],
              [-70.10293535099993, 60.93309153900003],
              [-70.10484778599994, 60.92609284100007],
              [-70.0996801419999, 60.92295970300006],
              [-70.09666907499991, 60.92051829600007],
              [-70.09260006399995, 60.91474030200004],
              [-70.08950761599993, 60.907904364000046],
              [-70.08971106699994, 60.90253327000005],
              [-70.1009008449999, 60.89561595300006],
              [-70.15119381399995, 60.88947174700007],
              [-70.15119381399995, 60.882025458000044],
              [-70.07599850199995, 60.88153717700004],
              [-70.05500240799995, 60.87579987200007],
              [-70.06484941299993, 60.85809967700004],
              [-70.05870520699995, 60.85032786700003],
              [-70.04222571499992, 60.84825267100007],
              [-69.99486243399991, 60.84906647300005],
              [-69.98668372299994, 60.84788646000004],
              [-69.97923743399991, 60.84349192900004],
              [-69.96349036399994, 60.830186265000066],
              [-69.95596269399994, 60.827378648000035],
              [-69.93236243399991, 60.814520575000074],
              [-69.91588294199994, 60.81000397300005],
              [-69.90103105399993, 60.816839911000045],
              [-69.88825436099995, 60.826605536000045],
              [-69.85838782499991, 60.842230536000045],
              [-69.84951738199993, 60.854681708000044],
              [-69.86986243399991, 60.85106028900003],
              [-69.90782630099994, 60.83775462400007],
              [-69.92833411399994, 60.834824937000064],
              [-69.93871008999992, 60.84019603100006],
              [-69.92149817599994, 60.851629950000074],
              [-69.89745032499991, 60.862168687000064],
              [-69.88707434799994, 60.864935614000046],
              [-69.8606664699999, 60.883978583000044],
              [-69.82054602799991, 60.904282945000034],
              [-69.77696692599994, 60.91950104400007],
              [-69.7403051419999, 60.92295970300006],
              [-69.73936926999994, 60.88609446800007],
              [-69.70262610599991, 60.874335028000075],
              [-69.66234290299991, 60.88523997600004],
              [-69.65094967399995, 60.91681549700007],
              [-69.66124426999994, 60.927801825000074],
              [-69.67870032499991, 60.94245026200008],
              [-69.69172115799995, 60.95880768400008],
              [-69.68846594999991, 60.97479889500005],
              [-69.68468176999994, 60.98228587400007],
              [-69.68154863199993, 61.00336334800005],
              [-69.67882239499994, 61.01231517100007],
              [-69.67198645699995, 61.02216217700004],
              [-69.65868079299992, 61.03196849200003],
              [-69.65094967399995, 61.040269273000035],
              [-69.65127519399994, 61.04734935100004],
              [-69.65412350199995, 61.05646393400008],
              [-69.65103105399993, 61.06427643400008],
              [-69.63385982999995, 61.067572333000044],
              [-69.62450110599991, 61.07078685100004],
              [-69.60118567599994, 61.08490631700005],
              [-69.58543860599991, 61.08808014500005],
              [-69.55768795499995, 61.086004950000074],
              [-69.53661048099991, 61.07969798400006],
              [-69.52037512899994, 61.06903717700004],
              [-69.50694739499994, 61.053941148000035],
              [-69.47325598899994, 61.000067450000074],
              [-69.46255449099993, 60.991888739000046],
              [-69.44839433499993, 60.983587958000044],
              [-69.43342037699995, 60.96397532800006],
              [-69.42341061099995, 60.941107489000046],
              [-69.42438717399995, 60.92295970300006],
              [-69.41002356699994, 60.92328522300005],
              [-69.36974036399994, 60.91681549700007],
              [-69.37462317599994, 60.904364325000074],
              [-69.38760331899994, 60.88178131700005],
              [-69.39020748599995, 60.868353583000044],
              [-69.38703365799995, 60.85492584800005],
              [-69.37291419199994, 60.83161041900007],
              [-69.36974036399994, 60.82396067900004],
              [-69.38133704299992, 60.79987213700008],
              [-69.40929114499994, 60.78412506700005],
              [-69.44318600199995, 60.775376695000034],
              [-69.50584876199991, 60.769964911000045],
              [-69.57237708199995, 60.75153229400007],
              [-69.60244706899994, 60.73863353100006],
              [-69.64395097599993, 60.70860423400006],
              [-69.6543676419999, 60.70392487200007],
              [-69.67039954299992, 60.702012437000064],
              [-69.70518958199995, 60.690741278000075],
              [-69.71979732999995, 60.684027411000045],
              [-69.70763098899994, 60.67601146000004],
              [-69.69249426999994, 60.66120026200008],
              [-69.68321692599994, 60.64305247600004],
              [-69.68846594999991, 60.625067450000074],
              [-69.69762122299994, 60.60809967700004],
              [-69.68553626199991, 60.60346100500004],
              [-69.66714433499993, 60.59943268400008],
              [-69.65770423099991, 60.584092515000066],
              [-69.66673743399991, 60.56720612200007],
              [-69.68797766799992, 60.55646393400008],
              [-69.80809485599991, 60.535589911000045],
              [-69.82900956899994, 60.52574290600006],
              [-69.81916256399995, 60.51854075700004],
              [-69.79491126199991, 60.492254950000074],
              [-69.76012122299994, 60.47321198100008],
              [-69.74974524599992, 60.462225653000075],
              [-69.75698808499993, 60.44721100500004],
              [-69.77049719999991, 60.43414948100008],
              [-69.77586829299992, 60.42450592700004],
              [-69.76927649599992, 60.41852448100008],
              [-69.74681555899991, 60.41648997600004],
              [-69.73534094999991, 60.411322333000044],
              [-69.72915605399993, 60.385606187000064],
              [-69.71979732999995, 60.37555573100008],
              [-69.72667395699995, 60.36265696800007],
              [-69.73932857999995, 60.34662506700005],
              [-69.75328528599994, 60.33295319200005],
              [-69.76988684799994, 60.32404205900008],
              [-69.76549231699994, 60.31708405200004],
              [-69.75328528599994, 60.306626695000034],
              [-69.74453691299993, 60.303900458000044],
              [-69.72154700399994, 60.302435614000046],
              [-69.71231035099993, 60.29979075700004],
              [-69.67198645699995, 60.26325104400007],
              [-69.66515051999994, 60.255113023000035],
              [-69.65697180899991, 60.241522528000075],
              [-69.61693274599992, 60.23517487200007],
              [-69.60244706899994, 60.224676825000074],
              [-69.61278235599991, 60.214178778000075],
              [-69.64073645699995, 60.19525788000004],
              [-69.65094967399995, 60.183701890000066],
              [-69.59943600199995, 60.183701890000066],
              [-69.59557044199994, 60.178900458000044],
              [-69.59959876199991, 60.168036200000074],
              [-69.60993404899995, 60.149603583000044],
              [-69.60973059799994, 60.130560614000046],
              [-69.60716712099992, 60.113714911000045],
              [-69.61099199099993, 60.10106028900003],
              [-69.63044186099995, 60.09434642100007],
              [-69.62804114499994, 60.07672760600008],
              [-69.64647376199991, 60.06858958500004],
              [-69.69530188699991, 60.066473700000074],
              [-69.70612545499995, 60.06329987200007],
              [-69.71426347599993, 60.049668687000064],
              [-69.72288977799991, 60.046576239000046],
              [-69.73558508999992, 60.04901764500005],
              [-69.77440344999991, 60.066473700000074],
              [-69.80504309799994, 60.073431708000044],
              [-69.82628333199995, 60.071600653000075],
              [-69.83873450399994, 60.057806708000044],
              [-69.84268144399994, 60.02887604400007],
              [-69.8255102199999, 60.02240631700005],
              [-69.79271399599992, 60.014512437000064],
              [-69.77306067599994, 60.004339911000045],
              [-69.79491126199991, 59.99131907800006],
              [-69.82164466099994, 59.98920319200005],
              [-69.90103105399993, 60.00495026200008],
              [-70.29515540299991, 60.025458075000074],
              [-70.33617102799991, 60.03229401200008],
              [-70.33617102799991, 60.025458075000074],
              [-70.32835852799991, 60.02301666900007],
              [-70.30943762899994, 60.011786200000074],
              [-70.32945716099994, 60.00604889500005],
              [-70.57192949099993, 59.994981187000064],
              [-70.59679114499994, 59.99750397300005],
              [-70.61514238199993, 60.003973700000074],
              [-70.65074622299994, 60.02179596600007],
              [-70.99620520699995, 60.076239325000074],
              [-71.03506425699993, 60.066473700000074],
              [-70.92125403599994, 60.055528062000064],
              [-70.88149980399993, 60.03502024900007],
              [-70.86278235599991, 60.02948639500005],
              [-70.80797278599994, 60.02330149900007],
              [-70.77301998599995, 60.01398346600007],
              [-70.72158769399994, 60.00922272300005],
              [-70.57770748599995, 59.97724030200004],
              [-70.48013261599993, 59.97089264500005],
              [-70.40729732999995, 59.98899974200003],
              [-70.38459225199995, 59.99131907800006],
              [-70.3692113919999, 59.98895905200004],
              [-70.33828691299993, 59.979722398000035],
              [-70.32249915299991, 59.97764720300006],
              [-70.2266332669999, 59.98651764500005],
              [-70.21324622299994, 59.984483140000066],
              [-70.16486568899995, 59.964056708000044],
              [-70.10680091099994, 59.95335521000004],
              [-70.04503333199995, 59.95099518400008],
              [-69.94200598899994, 59.964056708000044],
              [-69.85806230399993, 59.960923570000034],
              [-69.76976477799991, 59.97105540600006],
              [-69.73509680899991, 59.97028229400007],
              [-69.71979732999995, 59.960272528000075],
              [-69.72130286399994, 59.93711985900006],
              [-69.72777258999992, 59.921942450000074],
              [-69.7422582669999, 59.91478099200003],
              [-69.76756751199991, 59.91559479400007],
              [-69.72374426999994, 59.897772528000075],
              [-69.58983313699991, 59.87608470300006],
              [-69.56151282499991, 59.86469147300005],
              [-69.56566321499992, 59.85993073100008],
              [-69.59260006399995, 59.84454987200007],
              [-69.60065670499995, 59.83360423400006],
              [-69.60114498599995, 59.82477448100008],
              [-69.59825598899994, 59.81700267100007],
              [-69.59630286399994, 59.809434312000064],
              [-69.60789954299992, 59.79429759300007],
              [-69.61217200399994, 59.78388092700004],
              [-69.60619055899991, 59.77903880400004],
              [-69.59142005099994, 59.77806224200003],
              [-69.57567298099991, 59.77525462400007],
              [-69.56053626199991, 59.770819403000075],
              [-69.54784094999991, 59.76475657800006],
              [-69.56476803299995, 59.758246161000045],
              [-69.58592688699991, 59.73607005400004],
              [-69.6223852199999, 59.727403062000064],
              [-69.64598548099991, 59.70929596600007],
              [-69.65770423099991, 59.70331452000005],
              [-69.64793860599991, 59.699286200000074],
              [-69.63825436099995, 59.69749583500004],
              [-69.61681067599994, 59.69712962400007],
              [-69.60472571499992, 59.69554271000004],
              [-69.60000566299993, 59.691839911000045],
              [-69.59666907499991, 59.68707916900007],
              [-69.58877519399994, 59.682847398000035],
              [-69.53258216099994, 59.67963288000004],
              [-69.52057857999995, 59.676621812000064],
              [-69.51622473899994, 59.649278062000064],
              [-69.53726152299993, 59.622748114000046],
              [-69.56798255099994, 59.60260651200008],
              [-69.59260006399995, 59.59467194200005],
              [-69.62555904899995, 59.59003327000005],
              [-69.65990149599992, 59.577826239000046],
              [-69.6914770169999, 59.56114329600007],
              [-69.74852454299992, 59.51609935100004],
              [-69.75328528599994, 59.50812409100007],
              [-69.75572669199994, 59.49664948100008],
              [-69.75918535099993, 59.492621161000045],
              [-69.75820878799993, 59.49046458500004],
              [-69.74714107999995, 59.484808661000045],
              [-69.73704993399991, 59.48273346600007],
              [-69.69871985599991, 59.484808661000045],
              [-69.70474199099993, 59.47215403900003],
              [-69.69786536399994, 59.46637604400007],
              [-69.68455969999991, 59.462876695000034],
              [-69.67145748599995, 59.45697663000004],
              [-69.66445878799993, 59.45014069200005],
              [-69.65648352799991, 59.44013092700004],
              [-69.64899654899995, 59.42829010600008],
              [-69.64342200399994, 59.41596100500004],
              [-69.6543676419999, 59.41290924700007],
              [-69.66258704299992, 59.407538153000075],
              [-69.66828365799995, 59.39948151200008],
              [-69.67145748599995, 59.38861725500004],
              [-69.64037024599992, 59.38861725500004],
              [-69.63206946499992, 59.38511790600006],
              [-69.63414466099994, 59.37726471600007],
              [-69.64342200399994, 59.36473216400003],
              [-69.74950110599991, 59.34275950700004],
              [-69.75743567599994, 59.331244208000044],
              [-69.75511633999992, 59.317694403000075],
              [-69.7403051419999, 59.306708075000074],
              [-69.7246801419999, 59.30503978100006],
              [-69.62706458199995, 59.306708075000074],
              [-69.61925208199995, 59.308701890000066],
              [-69.6145727199999, 59.31321849200003],
              [-69.61091061099995, 59.317694403000075],
              [-69.60619055899991, 59.31976959800005],
              [-69.59683183499993, 59.32200755400004],
              [-69.57648678299995, 59.33177317900004],
              [-69.56525631399995, 59.334051825000074],
              [-69.52651933499993, 59.33356354400007],
              [-69.44546464799993, 59.361314195000034],
              [-69.42259680899991, 59.36151764500005],
              [-69.39769446499992, 59.35687897300005],
              [-69.37425696499992, 59.34752024900007],
              [-69.35606848899994, 59.334051825000074],
              [-69.36949622299994, 59.320379950000074],
              [-69.3587133449999, 59.31407298400006],
              [-69.33731035099993, 59.31513092700004],
              [-69.29767818899995, 59.33429596600007],
              [-69.27403723899994, 59.33506907800006],
              [-69.25479081899994, 59.32481517100007],
              [-69.24681555899991, 59.30296458500004],
              [-69.25279700399994, 59.29962799700007],
              [-69.2630102199999, 59.28856028900003],
              [-69.26598059799994, 59.27680084800005],
              [-69.25023352799991, 59.27130768400008],
              [-69.24437415299991, 59.26654694200005],
              [-69.23863684799994, 59.25608958500004],
              [-69.23253333199995, 59.24127838700008],
              [-69.24339758999992, 59.228216864000046],
              [-69.26817786399994, 59.21930573100008],
              [-69.29482988199993, 59.216050523000035],
              [-69.31167558499993, 59.220404364000046],
              [-69.3411352199999, 59.24127838700008],
              [-69.34923255099994, 59.24461497600004],
              [-69.36522376199991, 59.24445221600007],
              [-69.36994381399995, 59.23969147300005],
              [-69.36937415299991, 59.23228587400007],
              [-69.37075761599993, 59.21198151200008],
              [-69.36693274599992, 59.20677317900004],
              [-69.36632239499994, 59.20343659100007],
              [-69.37718665299991, 59.19684479400007],
              [-69.38902747299994, 59.194199937000064],
              [-69.40123450399994, 59.19611237200007],
              [-69.41152910099993, 59.20001862200007],
              [-69.41812089799993, 59.20368073100008],
              [-69.42247473899994, 59.21051666900007],
              [-69.42259680899991, 59.21824778900003],
              [-69.42564856699994, 59.22540924700007],
              [-69.43862870999993, 59.23041413000004],
              [-69.44953365799995, 59.228501695000034],
              [-69.52806555899991, 59.185980536000045],
              [-69.54255123599995, 59.16954173400006],
              [-69.53425045499995, 59.15521881700005],
              [-69.53872636599993, 59.15106842700004],
              [-69.54149329299992, 59.14728424700007],
              [-69.54051673099991, 59.14240143400008],
              [-69.53425045499995, 59.134751695000034],
              [-69.54165605399993, 59.12799713700008],
              [-69.53213456899994, 59.117254950000074],
              [-69.5156957669999, 59.10846588700008],
              [-69.50011145699995, 59.106756903000075],
              [-69.49327551999994, 59.11737702000005],
              [-69.49132239499994, 59.12144603100006],
              [-69.48668372299994, 59.124701239000046],
              [-69.48119055899991, 59.127793687000064],
              [-69.47647050699993, 59.13141510600008],
              [-69.46568762899994, 59.13727448100008],
              [-69.45685787699995, 59.13312409100007],
              [-69.44546464799993, 59.12055084800005],
              [-69.4395238919999, 59.11676666900007],
              [-69.43736731699994, 59.11347077000005],
              [-69.43394934799994, 59.110541083000044],
              [-69.42438717399995, 59.10809967700004],
              [-69.4219457669999, 59.11017487200007],
              [-69.40428626199991, 59.11859772300005],
              [-69.39732825399994, 59.12055084800005],
              [-69.37926184799994, 59.11973704600007],
              [-69.36416581899994, 59.11619700700004],
              [-69.35195878799993, 59.10822174700007],
              [-69.34243730399993, 59.093817450000074],
              [-69.39073645699995, 59.07135651200008],
              [-69.41437740799995, 59.05487702000005],
              [-69.43024654899995, 59.025458075000074],
              [-69.44359290299991, 59.029364325000074],
              [-69.45763098899994, 59.03900788000004],
              [-69.46593176999994, 59.04600657800006],
              [-69.47533118399991, 59.057806708000044],
              [-69.48037675699993, 59.066392320000034],
              [-69.4876195949999, 59.071600653000075],
              [-69.50352942599994, 59.07330963700008],
              [-69.46593176999994, 58.93512604400007],
              [-69.45164954299992, 58.902044989000046],
              [-69.45164954299992, 58.89520905200004],
              [-69.46694902299993, 58.87885163000004],
              [-69.47874915299991, 58.87291087400007],
              [-69.49014238199993, 58.877793687000064],
              [-69.49852454299992, 58.884466864000046],
              [-69.51130123599995, 58.890326239000046],
              [-69.52293860599991, 58.889878648000035],
              [-69.52798417899993, 58.877793687000064],
              [-69.53062903599994, 58.85968659100007],
              [-69.53799394399994, 58.83588288000004],
              [-69.54967200399994, 58.81525299700007],
              [-69.56525631399995, 58.80646393400008],
              [-69.64207923099991, 58.79120514500005],
              [-69.66515051999994, 58.792181708000044],
              [-69.68390865799995, 58.80540599200003],
              [-69.71979732999995, 58.867254950000074],
              [-69.69115149599992, 58.884833075000074],
              [-69.67845618399991, 58.89508698100008],
              [-69.67145748599995, 58.908270575000074],
              [-69.67186438699991, 58.927435614000046],
              [-69.67967688699991, 58.93467845300006],
              [-69.68838456899994, 58.93065013200004],
              [-69.69188391799992, 58.915716864000046],
              [-69.70107988199993, 58.918076890000066],
              [-69.70864824099993, 58.92222728100006],
              [-69.71483313699991, 58.92820872600004],
              [-69.71979732999995, 58.93614329600007],
              [-69.70470130099994, 58.96308014500005],
              [-69.72935950399994, 58.98297760600008],
              [-69.76121985599991, 58.98810455900008],
              [-69.76756751199991, 58.97089264500005],
              [-69.79637610599991, 58.981309312000064],
              [-69.83942623599995, 59.04564036700003],
              [-69.86314856699994, 59.05967845300006],
              [-69.87726803299995, 59.05182526200008],
              [-69.87572180899991, 59.03587474200003],
              [-69.86314856699994, 59.005072333000044],
              [-69.86607825399994, 58.98737213700008],
              [-69.87393144399994, 58.97593821800007],
              [-69.88512122299994, 58.96861399900007],
              [-69.89793860599991, 58.96344635600008],
              [-69.85903886599993, 58.96112702000005],
              [-69.82266191299993, 58.94599030200004],
              [-69.80345618399991, 58.91905345300006],
              [-69.81602942599994, 58.88153717700004],
              [-69.80894934799994, 58.87091705900008],
              [-69.80142167899993, 58.85407135600008],
              [-69.79759680899991, 58.837103583000044],
              [-69.80174719999991, 58.826280015000066],
              [-69.81712805899991, 58.82554759300007],
              [-69.83531653599994, 58.83421458500004],
              [-69.85700436099995, 58.853583075000074],
              [-69.86681067599994, 58.863714911000045],
              [-69.87901770699995, 58.87059153900003],
              [-69.89391028599994, 58.87413157800006],
              [-69.91161048099991, 58.87409088700008],
              [-69.89688066299993, 58.84662506700005],
              [-69.89049231699994, 58.839951890000066],
              [-69.89049231699994, 58.83311595300006],
              [-69.95929928299995, 58.814561265000066],
              [-69.97984778599994, 58.812608140000066],
              [-70.02033443899995, 58.81525299700007],
              [-70.0344945949999, 58.812608140000066],
              [-70.04401607999995, 58.80796946800007],
              [-70.06330318899995, 58.79486725500004],
              [-70.07237708199995, 58.792181708000044],
              [-70.13947506399995, 58.78392161700003],
              [-70.21190344999991, 58.78953685100004],
              [-70.23192298099991, 58.784491278000075],
              [-70.25422115799995, 58.77167389500005],
              [-70.19908606699994, 58.778184312000064],
              [-70.17149817599994, 58.77574290600006],
              [-70.1477758449999, 58.76109446800007],
              [-70.13634192599994, 58.75641510600008],
              [-70.05870520699995, 58.75739166900007],
              [-70.05492102799991, 58.75458405200004],
              [-70.04723059799994, 58.741522528000075],
              [-70.04133053299995, 58.737534898000035],
              [-70.02212480399993, 58.739447333000044],
              [-69.99469967399995, 58.74750397300005],
              [-69.97008216099994, 58.758246161000045],
              [-69.95457923099991, 58.77216217700004],
              [-69.94347083199995, 58.77562083500004],
              [-69.9212133449999, 58.77912018400008],
              [-69.91755123599995, 58.77448151200008],
              [-69.92149817599994, 58.76386139500005],
              [-69.93203691299993, 58.74437083500004],
              [-69.93224036399994, 58.72748444200005],
              [-69.92813066299993, 58.70298899900007],
              [-69.91828365799995, 58.686387437000064],
              [-69.90103105399993, 58.69318268400008],
              [-69.88190670499995, 58.708238023000035],
              [-69.86143958199995, 58.71503327000005],
              [-69.84105383999992, 58.71515534100007],
              [-69.8001195949999, 58.70490143400008],
              [-69.79743404899995, 58.70075104400007],
              [-69.80174719999991, 58.68976471600007],
              [-69.80931555899991, 58.68231842700004],
              [-69.82176673099991, 58.67572663000004],
              [-69.83531653599994, 58.67100657800006],
              [-69.84609941299993, 58.669256903000075],
              [-69.8535863919999, 58.66559479400007],
              [-69.87291419199994, 58.64911530200004],
              [-69.87682044199994, 58.64472077000005],
              [-69.87340247299994, 58.63694896000004],
              [-69.86534583199995, 58.62787506700005],
              [-69.84951738199993, 58.61399974200003],
              [-69.83397376199991, 58.60407135600008],
              [-69.81354732999995, 58.59650299700007],
              [-69.79572506399995, 58.59845612200007],
              [-69.78807532499991, 58.61741771000004],
              [-69.77953040299991, 58.62962474200003],
              [-69.74201412699995, 58.652777411000045],
              [-69.72948157499991, 58.67051829600007],
              [-69.70929928299995, 58.68976471600007],
              [-69.70665442599994, 58.69135163000004],
              [-69.70287024599992, 58.69957103100006],
              [-69.69871985599991, 58.70274485900006],
              [-69.69102942599994, 58.703192450000074],
              [-69.67638098899994, 58.69757721600007],
              [-69.67145748599995, 58.696600653000075],
              [-69.65050208199995, 58.701157945000034],
              [-69.64037024599992, 58.713324286000045],
              [-69.63634192599994, 58.722764390000066],
              [-69.63634192599994, 58.73908112200007],
              [-69.63044186099995, 58.737534898000035],
              [-69.60822506399995, 58.76036204600007],
              [-69.56602942599994, 58.77476634300007],
              [-69.48704993399991, 58.792181708000044],
              [-69.41812089799993, 58.82965729400007],
              [-69.41209876199991, 58.84369538000004],
              [-69.39712480399993, 58.85822174700007],
              [-69.37816321499992, 58.86949290600006],
              [-69.35977128799993, 58.87409088700008],
              [-69.34870357999995, 58.87523021000004],
              [-69.32994544199994, 58.88035716400003],
              [-69.30577551999994, 58.88336823100008],
              [-69.28038489499994, 58.89520905200004],
              [-69.25633704299992, 58.89915599200003],
              [-69.18846594999991, 58.89520905200004],
              [-69.12482662699995, 58.90192291900007],
              [-68.97931881399995, 58.902044989000046],
              [-68.9844457669999, 58.89642975500004],
              [-68.98985755099994, 58.886053778000075],
              [-68.99299068899995, 58.88153717700004],
              [-68.89476477799991, 58.87787506700005],
              [-68.78693600199995, 58.92247142100007],
              [-68.77342688699991, 58.92169830900008],
              [-68.76659094999991, 58.917669989000046],
              [-68.76154537699995, 58.912543036000045],
              [-68.75340735599991, 58.908270575000074],
              [-68.72874915299991, 58.903184312000064],
              [-68.64216061099995, 58.89756907800006],
              [-68.61603756399995, 58.89122142100007],
              [-68.54051673099991, 58.861029364000046],
              [-68.50829016799992, 58.83661530200004],
              [-68.49986731699994, 58.83311595300006],
              [-68.41026770699995, 58.823919989000046],
              [-68.40233313699991, 58.81793854400007],
              [-68.39793860599991, 58.80931224200003],
              [-68.39028886599993, 58.79962799700007],
              [-68.37120520699995, 58.79039134300007],
              [-68.36156165299991, 58.78351471600007],
              [-68.35619055899991, 58.77167389500005],
              [-68.35928300699993, 58.76121653900003],
              [-68.37832597599993, 58.74481842700004],
              [-68.38288326699995, 58.73411692900004],
              [-68.38345292899993, 58.71161530200004],
              [-68.38093014199995, 58.70099518400008],
              [-68.37319902299993, 58.696600653000075],
              [-68.33714758999992, 58.68187083500004],
              [-68.32884680899991, 58.675482489000046],
              [-68.32896887899994, 58.657904364000046],
              [-68.35020911399994, 58.621527411000045],
              [-68.34870357999995, 58.60032786700003],
              [-68.33324133999992, 58.58978913000004],
              [-68.29141191299993, 58.59813060100004],
              [-68.27424068899995, 58.58673737200007],
              [-68.27440344999991, 58.567246812000064],
              [-68.28587805899991, 58.549261786000045],
              [-68.29149329299992, 58.534491278000075],
              [-68.27424068899995, 58.524644273000035],
              [-68.25210527299993, 58.52753327000005],
              [-68.21178137899994, 58.54828522300005],
              [-68.19102942599994, 58.54637278900003],
              [-68.21324622299994, 58.50755442900004],
              [-68.22057044199994, 58.48432038000004],
              [-68.21524003799993, 58.46662018400008],
              [-68.20938066299993, 58.45795319200005],
              [-68.20498613199993, 58.445379950000074],
              [-68.20579993399991, 58.434027411000045],
              [-68.22252356699994, 58.425482489000046],
              [-68.22468014199995, 58.41673411700003],
              [-68.22581946499992, 58.394964911000045],
              [-68.24327551999994, 58.35325755400004],
              [-68.31517493399991, 58.25092194200005],
              [-68.33849036399994, 58.18602122600004],
              [-68.34528561099995, 58.175848700000074],
              [-68.35024980399993, 58.17051829600007],
              [-68.34845943899995, 58.159043687000064],
              [-68.34422766799992, 58.14817942900004],
              [-68.34186764199995, 58.14447663000004],
              [-68.34532630099994, 58.13190338700008],
              [-68.35407467399995, 58.12372467700004],
              [-68.37661699099993, 58.11314524900007],
              [-68.47716223899994, 58.04364655200004],
              [-68.52000891799992, 58.03119538000004],
              [-68.71910559799994, 58.013739325000074],
              [-68.84870357999995, 57.97638580900008],
              [-68.97012285099993, 57.96039459800005],
              [-68.98062089799993, 57.95286692900004],
              [-68.98973548099991, 57.94367096600007],
              [-68.99982662699995, 57.935614325000074],
              [-69.04405676999994, 57.91941966400003],
              [-69.04759680899991, 57.91510651200008],
              [-69.14110266799992, 57.89866771000004],
              [-69.22374426999994, 57.86204661700003],
              [-69.36974036399994, 57.77049388200004],
              [-69.14439856699994, 57.86973704600007],
              [-69.12645423099991, 57.884100653000075],
              [-69.10936438699991, 57.89337799700007],
              [-69.04076087099992, 57.908270575000074],
              [-68.94969641799992, 57.94102610900006],
              [-68.75601152299993, 57.97296784100007],
              [-68.68663489499994, 57.99371979400007],
              [-68.60724850199995, 57.99754466400003],
              [-68.46861731699994, 58.020371812000064],
              [-68.41759192599994, 58.03864166900007],
              [-68.40713456899994, 58.04645416900007],
              [-68.40094967399995, 58.05560944200005],
              [-68.39614824099993, 58.06464264500005],
              [-68.39028886599993, 58.07212962400007],
              [-68.37791907499991, 58.07831452000005],
              [-68.34919186099995, 58.08417389500005],
              [-68.33849036399994, 58.089829820000034],
              [-68.31924394399994, 58.10883209800005],
              [-68.3098852199999, 58.12091705900008],
              [-68.30703691299993, 58.13385651200008],
              [-68.30695553299995, 58.17633698100008],
              [-68.30215410099993, 58.20111725500004],
              [-68.29259192599994, 58.22178782800006],
              [-68.27733313699991, 58.23041413000004],
              [-68.25157630099994, 58.23651764500005],
              [-68.24095618399991, 58.251206773000035],
              [-68.23892167899993, 58.269232489000046],
              [-68.23884029899995, 58.28510163000004],
              [-68.23249264199995, 58.30768463700008],
              [-68.21983801999994, 58.32831452000005],
              [-68.18732662699995, 58.36387767100007],
              [-68.18724524599992, 58.370306708000044],
              [-68.19001217399995, 58.38080475500004],
              [-68.19139563699991, 58.39057038000004],
              [-68.18732662699995, 58.394964911000045],
              [-68.18224036399994, 58.39838288000004],
              [-68.17699133999992, 58.40643952000005],
              [-68.17267818899995, 58.41559479400007],
              [-68.17056230399993, 58.42218659100007],
              [-68.17666581899994, 58.48191966400003],
              [-68.17393958199995, 58.491074937000064],
              [-68.16344153599994, 58.49677155200004],
              [-68.13687089799993, 58.52338288000004],
              [-68.12340247299994, 58.53204987200007],
              [-68.11204993399991, 58.52496979400007],
              [-68.09015865799995, 58.52000560100004],
              [-68.06749426999994, 58.51776764500005],
              [-68.04767818899995, 58.518418687000064],
              [-68.02733313699991, 58.52171458500004],
              [-68.02342688699991, 58.52558014500005],
              [-68.02651933499993, 58.53424713700008],
              [-68.02721106699994, 58.551947333000044],
              [-68.00621497299994, 58.57953522300005],
              [-67.97443600199995, 58.56981028900003],
              [-67.95352128799993, 58.54437897300005],
              [-67.96515865799995, 58.524644273000035],
              [-67.96515865799995, 58.518418687000064],
              [-67.95103919199994, 58.51316966400003],
              [-67.93594316299993, 58.511053778000075],
              [-67.90990149599992, 58.510972398000035],
              [-67.88975989499994, 58.49872467700004],
              [-67.89476477799991, 58.484076239000046],
              [-67.90904700399994, 58.46836985900006],
              [-67.91734778599994, 58.45294830900008],
              [-67.92414303299995, 58.41168854400007],
              [-67.92365475199995, 58.40497467700004],
              [-67.92186438699991, 58.40025462400007],
              [-67.91869055899991, 58.39630768400008],
              [-67.91364498599995, 58.39154694200005],
              [-67.90811113199993, 58.38349030200004],
              [-67.90794837099992, 58.376654364000046],
              [-67.90965735599991, 58.37128327000005],
              [-67.90990149599992, 58.367621161000045],
              [-67.90318762899994, 58.36017487200007],
              [-67.86522376199991, 58.330511786000045],
              [-67.86168372299994, 58.32640208500004],
              [-67.86270097599993, 58.30927155200004],
              [-67.86839758999992, 58.28965892100007],
              [-67.88243567599994, 58.27130768400008],
              [-67.90025794199994, 58.255845445000034],
              [-67.98314368399991, 58.208197333000044],
              [-68.00267493399991, 58.203111070000034],
              [-68.08242753799993, 58.15534088700008],
              [-68.12352454299992, 58.09837474200003],
              [-68.12954667899993, 58.08299388200004],
              [-68.12059485599991, 58.07188548400006],
              [-68.10033118399991, 58.083238023000035],
              [-68.06818600199995, 58.11314524900007],
              [-68.05182857999995, 58.12164948100008],
              [-68.01569576699995, 58.13239166900007],
              [-67.99925696499992, 58.141058661000045],
              [-67.99071204299992, 58.150376695000034],
              [-67.97256425699993, 58.189439195000034],
              [-67.95327714799993, 58.21198151200008],
              [-67.92577063699991, 58.22614166900007],
              [-67.89411373599995, 58.23387278900003],
              [-67.86270097599993, 58.23725006700005],
              [-67.86461341099994, 58.259019273000035],
              [-67.84455318899995, 58.27765534100007],
              [-67.80064856699994, 58.29869212400007],
              [-67.81786048099991, 58.31915924700007],
              [-67.8235570949999, 58.335638739000046],
              [-67.82079016799992, 58.39923737200007],
              [-67.81773841099994, 58.40912506700005],
              [-67.81224524599992, 58.41710032800006],
              [-67.78697669199994, 58.442694403000075],
              [-67.78587805899991, 58.448553778000075],
              [-67.78831946499992, 58.464544989000046],
              [-67.78697669199994, 58.470038153000075],
              [-67.77350826699995, 58.475775458000044],
              [-67.75601152299993, 58.47443268400008],
              [-67.73851477799991, 58.469183661000045],
              [-67.71886145699995, 58.45990631700005],
              [-67.71483313699991, 58.45661041900007],
              [-67.71255449099993, 58.452337958000044],
              [-67.71190344999991, 58.44611237200007],
              [-67.70840410099993, 58.443426825000074],
              [-67.68455969999991, 58.43964264500005],
              [-67.67544511599993, 58.42344798400006],
              [-67.69310462099992, 58.40464915600006],
              [-67.70824133999992, 58.38340892100007],
              [-67.69139563699991, 58.36017487200007],
              [-67.72956295499995, 58.333319403000075],
              [-67.73208574099993, 58.321478583000044],
              [-67.7180883449999, 58.29869212400007],
              [-67.72272701699995, 58.295355536000045],
              [-67.73232988199993, 58.28510163000004],
              [-67.71328691299993, 58.28864166900007],
              [-67.69383704299992, 58.28660716400003],
              [-67.67552649599992, 58.27948639500005],
              [-67.66002356699994, 58.26793040600006],
              [-67.64903723899994, 58.25177643400008],
              [-67.64801998599995, 58.23615143400008],
              [-67.65465247299994, 58.22105540600006],
              [-67.69408118399991, 58.17210521000004],
              [-67.70173092399995, 58.141465562000064],
              [-67.69277910099993, 58.109808661000045],
              [-67.67027747299994, 58.07212962400007],
              [-67.69050045499995, 58.02765534100007],
              [-67.70099850199995, 58.01447174700007],
              [-67.71524003799993, 58.00108470300006],
              [-67.73033606699994, 57.983628648000035],
              [-67.74014238199993, 57.963731187000064],
              [-67.73859615799995, 57.943060614000046],
              [-67.73379472599993, 57.93805573100008],
              [-67.72435462099992, 57.93138255400004],
              [-67.71349036399994, 57.927069403000075],
              [-67.7044164699999, 57.92877838700008],
              [-67.70132402299993, 57.93781159100007],
              [-67.7044164699999, 57.94940827000005],
              [-67.71190344999991, 57.96662018400008],
              [-67.70665442599994, 57.99079010600008],
              [-67.69343014199995, 58.005926825000074],
              [-67.65664628799993, 58.03119538000004],
              [-67.64183508999992, 58.04913971600007],
              [-67.63906816299993, 58.06504954600007],
              [-67.64590410099993, 58.080511786000045],
              [-67.66002356699994, 58.09666575700004],
              [-67.66242428299995, 58.11595286700003],
              [-67.64631100199995, 58.138739325000074],
              [-67.60879472599993, 58.175848700000074],
              [-67.59585527299993, 58.20075104400007],
              [-67.57323157499991, 58.22638580900008],
              [-67.56786048099991, 58.23041413000004],
              [-67.56037350199995, 58.23191966400003],
              [-67.54405676999994, 58.23065827000005],
              [-67.53685462099992, 58.23383209800005],
              [-67.50283769399994, 58.26349518400008],
              [-67.48448645699995, 58.27586497600004],
              [-67.46483313699991, 58.28510163000004],
              [-67.43659420499995, 58.286363023000035],
              [-67.3977758449999, 58.28379954600007],
              [-67.36351477799991, 58.28611888200004],
              [-67.33214270699995, 58.32396067900004],
              [-67.29474850199995, 58.33478424700007],
              [-67.23208574099993, 58.33966705900008],
              [-67.21800696499992, 58.34361399900007],
              [-67.20482337099992, 58.35101959800005],
              [-67.18089758999992, 58.37067291900007],
              [-67.16022701699995, 58.38023509300007],
              [-67.1419164699999, 58.37535228100006],
              [-67.12584387899994, 58.36554596600007],
              [-67.11196855399993, 58.36017487200007],
              [-67.09927324099993, 58.36045970300006],
              [-67.08690344999991, 58.36277903900003],
              [-67.07599850199995, 58.36908600500004],
              [-67.06761633999992, 58.381293036000045],
              [-67.06419837099992, 58.39293040600006],
              [-67.06647701699995, 58.39976634300007],
              [-67.07258053299995, 58.40766022300005],
              [-67.08063717399995, 58.42218659100007],
              [-67.04063880099994, 58.42255280200004],
              [-67.02342688699991, 58.42670319200005],
              [-67.00617428299995, 58.43650950700004],
              [-66.97077389199995, 58.476996161000045],
              [-66.96519934799994, 58.48737213700008],
              [-66.94664466099994, 58.49835846600007],
              [-66.90998287699995, 58.500433661000045],
              [-66.88365637899994, 58.48655833500004],
              [-66.89631100199995, 58.44953034100007],
              [-66.87242591099994, 58.44415924700007],
              [-66.86046301999994, 58.43976471600007],
              [-66.85533606699994, 58.432806708000044],
              [-66.85220292899993, 58.425034898000035],
              [-66.84593665299991, 58.43305084800005],
              [-66.84093176999994, 58.445013739000046],
              [-66.84166419199994, 58.44953034100007],
              [-66.81102454299992, 58.464911200000074],
              [-66.80199133999992, 58.477728583000044],
              [-66.80687415299991, 58.49799225500004],
              [-66.71068274599992, 58.49799225500004],
              [-66.66112219999991, 58.491074937000064],
              [-66.63540605399993, 58.49091217700004],
              [-66.61510169199994, 58.49799225500004],
              [-66.65990149599992, 58.525458075000074],
              [-66.6692602199999, 58.53998444200005],
              [-66.63939368399991, 58.54637278900003],
              [-66.62401282499991, 58.55133698100008],
              [-66.62315833199995, 58.56346263200004],
              [-66.62775631399995, 58.57872142100007],
              [-66.62877356699994, 58.59288157800006],
              [-66.61807206899994, 58.60582103100006],
              [-66.60114498599995, 58.61851634300007],
              [-66.58853105399993, 58.631293036000045],
              [-66.59121660099993, 58.64472077000005],
              [-66.59654700399994, 58.65509674700007],
              [-66.59870357999995, 58.66868724200003],
              [-66.59536699099993, 58.67719147300005],
              [-66.58438066299993, 58.67234935100004],
              [-66.57144120999993, 58.66941966400003],
              [-66.56322180899991, 58.68219635600008],
              [-66.55361894399994, 58.710191148000035],
              [-66.52696692599994, 58.71954987200007],
              [-66.49620520699995, 58.71857330900008],
              [-66.46865800699993, 58.721991278000075],
              [-66.45128333199995, 58.74437083500004],
              [-66.47581946499992, 58.750067450000074],
              [-66.48473059799994, 58.75531647300005],
              [-66.49095618399991, 58.764837958000044],
              [-66.47468014199995, 58.771592515000066],
              [-66.46336829299992, 58.78660716400003],
              [-66.46104895699995, 58.802801825000074],
              [-66.47175045499995, 58.812608140000066],
              [-66.46117102799991, 58.824204820000034],
              [-66.44391842399995, 58.83283112200007],
              [-66.42418372299994, 58.83808014500005],
              [-66.40623938699991, 58.839951890000066],
              [-66.40298417899993, 58.84202708500004],
              [-66.39801998599995, 58.84662506700005],
              [-66.39122473899994, 58.85130442900004],
              [-66.38239498599995, 58.853583075000074],
              [-66.37441972599993, 58.852769273000035],
              [-66.36192786399994, 58.84837474200003],
              [-66.34703528599994, 58.845811265000066],
              [-66.34748287699995, 58.84198639500005],
              [-66.34972083199995, 58.837225653000075],
              [-66.34756425699993, 58.83311595300006],
              [-66.29466712099992, 58.80341217700004],
              [-66.25251217399995, 58.79511139500005],
              [-66.23664303299995, 58.78400299700007],
              [-66.21043860599991, 58.75739166900007],
              [-66.19395911399994, 58.74909088700008],
              [-66.14574133999992, 58.73350657800006],
              [-66.12877356699994, 58.73069896000004],
              [-66.11583411399994, 58.72630442900004],
              [-66.11034094999991, 58.71503327000005],
              [-66.10716712099992, 58.699652411000045],
              [-66.10118567599994, 58.682928778000075],
              [-66.09251868399991, 58.671210028000075],
              [-66.07884680899991, 58.65851471600007],
              [-66.06273352799991, 58.65025462400007],
              [-66.04653886599993, 58.65184153900003],
              [-66.02700761599993, 58.65766022300005],
              [-66.00747636599993, 58.65684642100007],
              [-65.99714107999995, 58.64915599200003],
              [-66.00499426999994, 58.63450755400004],
              [-65.99030514199995, 58.62938060100004],
              [-65.95750891799992, 58.626288153000075],
              [-65.94416256399995, 58.62083567900004],
              [-65.93716386599993, 58.609442450000074],
              [-65.94025631399995, 58.59629954600007],
              [-65.94933020699995, 58.58258698100008],
              [-65.96031653599994, 58.56932200700004],
              [-65.96666419199994, 58.56525299700007],
              [-65.97227942599994, 58.56513092700004],
              [-65.97614498599995, 58.563666083000044],
              [-65.97765051999994, 58.55573151200008],
              [-65.97948157499991, 58.54991282800006],
              [-65.98399817599994, 58.54197825700004],
              [-65.98965410099993, 58.53510163000004],
              [-66.00674394399994, 58.52594635600008],
              [-66.01447506399995, 58.51227448100008],
              [-66.01821855399993, 58.49823639500005],
              [-66.01862545499995, 58.491074937000064],
              [-66.01488196499992, 58.479803778000075],
              [-66.00226803299995, 58.45722077000005],
              [-65.99282792899993, 58.430894273000035],
              [-65.99876868399991, 58.40855540600006],
              [-66.02074133999992, 58.39524974200003],
              [-66.07225501199991, 58.37938060100004],
              [-66.09496008999992, 58.36017487200007],
              [-66.07518469999991, 58.33661530200004],
              [-66.06509355399993, 58.32982005400004],
              [-66.05337480399993, 58.33283112200007],
              [-66.0462133449999, 58.34454987200007],
              [-66.04214433499993, 58.36041901200008],
              [-66.03514563699991, 58.376288153000075],
              [-66.01862545499995, 58.38812897300005],
              [-65.99852454299992, 58.392645575000074],
              [-65.98253333199995, 58.39362213700008],
              [-65.96922766799992, 58.39704010600008],
              [-65.95718339799993, 58.40855540600006],
              [-65.95620683499993, 58.415350653000075],
              [-65.95738684799994, 58.424668687000064],
              [-65.95759029899995, 58.432928778000075],
              [-65.95376542899993, 58.43650950700004],
              [-65.92756100199995, 58.44297923400006],
              [-65.92300370999993, 58.442694403000075],
              [-65.92544511599993, 58.45954010600008],
              [-65.94635982999995, 58.46556224200003],
              [-65.97109941299993, 58.468858140000066],
              [-65.98509680899991, 58.47748444200005],
              [-65.97956295499995, 58.49009837400007],
              [-65.96263587099992, 58.50385163000004],
              [-65.92056230399993, 58.52948639500005],
              [-65.91173255099994, 58.532538153000075],
              [-65.90518144399994, 58.53790924700007],
              [-65.90257727799991, 58.54913971600007],
              [-65.90217037699995, 58.558579820000034],
              [-65.90038001199991, 58.566392320000034],
              [-65.89622962099992, 58.57330963700008],
              [-65.88890540299991, 58.57990143400008],
              [-65.87352454299992, 58.58380768400008],
              [-65.84357662699995, 58.57444896000004],
              [-65.82750403599994, 58.57990143400008],
              [-65.85716712099992, 58.591905015000066],
              [-65.86164303299995, 58.59662506700005],
              [-65.86424719999991, 58.59784577000005],
              [-65.87450110599991, 58.623155015000066],
              [-65.87523352799991, 58.62828196800007],
              [-65.89639238199993, 58.63898346600007],
              [-65.91856848899994, 58.64240143400008],
              [-65.93781490799995, 58.64891185100004],
              [-65.94416256399995, 58.669256903000075],
              [-65.94416256399995, 58.675482489000046],
              [-65.96165930899991, 58.68805573100008],
              [-66.01471920499995, 58.69025299700007],
              [-66.03970292899993, 58.696600653000075],
              [-66.03563391799992, 58.70978424700007],
              [-66.03563391799992, 58.73029205900008],
              [-66.03856360599991, 58.74909088700008],
              [-66.04312089799993, 58.75739166900007],
              [-66.09459387899994, 58.77252838700008],
              [-66.10863196499992, 58.77912018400008],
              [-66.09227454299992, 58.78900788000004],
              [-66.03970292899993, 58.84739817900004],
              [-66.02651933499993, 58.85846588700008],
              [-66.01919511599993, 58.86119212400007],
              [-66.01195227799991, 58.85700104400007],
              [-65.97085527299993, 58.826280015000066],
              [-65.94493567599994, 58.841498114000046],
              [-65.85952714799993, 58.83283112200007],
              [-65.82750403599994, 58.839951890000066],
              [-65.80964107999995, 58.84760163000004],
              [-65.79954993399991, 58.853583075000074],
              [-65.79564368399991, 58.86347077000005],
              [-65.80211341099994, 58.867295640000066],
              [-65.88536536399994, 58.87189362200007],
              [-65.93667558499993, 58.88153717700004],
              [-65.96499589799993, 58.891058661000045],
              [-65.98306230399993, 58.90485260600008],
              [-65.98224850199995, 58.917181708000044],
              [-65.94371497299994, 58.92462799700007],
              [-65.92369544199994, 58.934027411000045],
              [-65.87083899599992, 58.940741278000075],
              [-65.86164303299995, 58.94297923400006],
              [-65.85391191299993, 58.96112702000005],
              [-65.86880449099993, 58.97764720300006],
              [-65.88613847599993, 58.99323151200008],
              [-65.88548743399991, 59.00816478100006],
              [-65.86925208199995, 59.00849030200004],
              [-65.75625566299993, 58.975775458000044],
              [-65.70482337099992, 58.94830963700008],
              [-65.68659420499995, 58.93244049700007],
              [-65.67735755099994, 58.928574937000064],
              [-65.67096920499995, 58.93659088700008],
              [-65.66881262899994, 58.949326890000066],
              [-65.67259680899991, 58.96006907800006],
              [-65.68065344999991, 58.967637437000064],
              [-65.6887914699999, 58.973863023000035],
              [-65.69815019399994, 58.97911204600007],
              [-65.79332434799994, 59.005072333000044],
              [-65.78429114499994, 59.015611070000034],
              [-65.77057857999995, 59.01915110900006],
              [-65.73810787699995, 59.01813385600008],
              [-65.74746660099993, 59.023138739000046],
              [-65.77904212099992, 59.03233470300006],
              [-65.75413977799991, 59.032904364000046],
              [-65.72907467399995, 59.03758372600004],
              [-65.68346106699994, 59.052801825000074],
              [-65.68346106699994, 59.04600657800006],
              [-65.65485592399995, 59.04649485900006],
              [-65.60558020699995, 59.013739325000074],
              [-65.50706946499992, 58.98810455900008],
              [-65.49168860599991, 58.991400458000044],
              [-65.50194251199991, 59.005072333000044],
              [-65.51549231699994, 59.01316966400003],
              [-65.53148352799991, 59.01703522300005],
              [-65.54942786399994, 59.01813385600008],
              [-65.56065833199995, 59.02171458500004],
              [-65.59410559799994, 59.04600657800006],
              [-65.58128821499992, 59.052069403000075],
              [-65.54234778599994, 59.06427643400008],
              [-65.52920488199993, 59.066514390000066],
              [-65.51158606699994, 59.065619208000044],
              [-65.50031490799995, 59.062933661000045],
              [-65.47740637899994, 59.052801825000074],
              [-65.44367428299995, 59.04511139500005],
              [-65.34943600199995, 59.03978099200003],
              [-65.31973222599993, 59.04600657800006],
              [-65.31973222599993, 59.052801825000074],
              [-65.34972083199995, 59.064561265000066],
              [-65.42560787699995, 59.06358470300006],
              [-65.46678626199991, 59.083238023000035],
              [-65.5130102199999, 59.09239329600007],
              [-65.52920488199993, 59.093817450000074],
              [-65.53278561099995, 59.09747955900008],
              [-65.53652910099993, 59.10443756700005],
              [-65.54161536399994, 59.10883209800005],
              [-65.54942786399994, 59.104681708000044],
              [-65.55435136599993, 59.09747955900008],
              [-65.55638587099992, 59.09198639500005],
              [-65.55931555899991, 59.086778062000064],
              [-65.56676184799994, 59.08075592700004],
              [-65.58169511599993, 59.075059312000064],
              [-65.60317949099993, 59.07099030200004],
              [-65.62539628799993, 59.06993235900006],
              [-65.64248613199993, 59.07330963700008],
              [-65.65103105399993, 59.083197333000044],
              [-65.66567949099993, 59.11395905200004],
              [-65.71080481699994, 59.15106842700004],
              [-65.71764075399994, 59.158311265000066],
              [-65.71580969999991, 59.17564524900007],
              [-65.70995032499991, 59.185655015000066],
              [-65.69937089799993, 59.19171784100007],
              [-65.68346106699994, 59.19684479400007],
              [-65.70075436099995, 59.20640696800007],
              [-65.71743730399993, 59.21002838700008],
              [-65.73253333199995, 59.21552155200004],
              [-65.74494381399995, 59.23041413000004],
              [-65.73639889199995, 59.241074937000064],
              [-65.74494381399995, 59.252061265000066],
              [-65.74278723899994, 59.262152411000045],
              [-65.74266516799992, 59.26788971600007],
              [-65.73932857999995, 59.27061595300006],
              [-65.72752844999991, 59.27130768400008],
              [-65.68024654899995, 59.26398346600007],
              [-65.65025794199994, 59.24485911700003],
              [-65.59410559799994, 59.18939850500004],
              [-65.59333248599995, 59.207464911000045],
              [-65.61213131399995, 59.24937571800007],
              [-65.60293535099993, 59.257106838000084],
              [-65.5989477199999, 59.25617096600007],
              [-65.58967037699995, 59.25153229400007],
              [-65.58250891799992, 59.24681224200003],
              [-65.58043372299994, 59.24461497600004],
              [-65.56786048099991, 59.24595774900007],
              [-65.56387285099993, 59.24884674700007],
              [-65.56224524599992, 59.25385163000004],
              [-65.55622311099995, 59.261704820000034],
              [-65.54332434799994, 59.26463450700004],
              [-65.51012122299994, 59.253892320000034],
              [-65.49168860599991, 59.25828685100004],
              [-65.49168860599991, 59.26508209800005],
              [-65.50987708199995, 59.27252838700008],
              [-65.53921464799993, 59.294623114000046],
              [-65.55622311099995, 59.299261786000045],
              [-65.56607011599993, 59.30744049700007],
              [-65.57371985599991, 59.32652415600006],
              [-65.57868404899995, 59.34833405200004],
              [-65.58043372299994, 59.36473216400003],
              [-65.55899003799993, 59.376654364000046],
              [-65.51060950399994, 59.35846588700008],
              [-65.37181555899991, 59.28009674700007],
              [-65.35757402299993, 59.28217194200005],
              [-65.40542558499993, 59.34019603100006],
              [-65.42540442599994, 59.343003648000035],
              [-65.44029700399994, 59.35175202000005],
              [-65.44717363199993, 59.36676666900007],
              [-65.44322669199994, 59.38861725500004],
              [-65.4329320949999, 59.40294017100007],
              [-65.4192602199999, 59.406317450000074],
              [-65.38182532499991, 59.40228913000004],
              [-65.40672766799992, 59.41742584800005],
              [-65.49791419199994, 59.436387437000064],
              [-65.49791419199994, 59.44383372600004],
              [-65.47057044199994, 59.44383372600004],
              [-65.47057044199994, 59.450059312000064],
              [-65.49290930899991, 59.45917389500005],
              [-65.52037512899994, 59.46552155200004],
              [-65.54531816299993, 59.47435130400004],
              [-65.55992591099994, 59.49103424700007],
              [-65.52635657499991, 59.48969147300005],
              [-65.45750891799992, 59.472357489000046],
              [-65.42275956899994, 59.47056712400007],
              [-65.38052324099993, 59.48297760600008],
              [-65.36412512899994, 59.484808661000045],
              [-65.24596106699994, 59.472764390000066],
              [-65.20303300699993, 59.46312083500004],
              [-65.19774329299992, 59.462876695000034],
              [-65.19115149599992, 59.46348704600007],
              [-65.18553626199991, 59.46312083500004],
              [-65.18321692599994, 59.46002838700008],
              [-65.18195553299995, 59.45258209800005],
              [-65.17837480399993, 59.44489166900007],
              [-65.17292232999995, 59.43891022300005],
              [-65.06191972599993, 59.388006903000075],
              [-65.05284583199995, 59.38117096600007],
              [-65.04181881399995, 59.38275788000004],
              [-65.00308183499993, 59.37567780200004],
              [-64.98395748599995, 59.38117096600007],
              [-65.03311113199993, 59.39093659100007],
              [-65.08234615799995, 59.41063060100004],
              [-65.12686113199993, 59.43610260600008],
              [-65.18126380099994, 59.475775458000044],
              [-65.20201575399994, 59.48224518400008],
              [-65.25145423099991, 59.49103424700007],
              [-65.31338456899994, 59.50938548400006],
              [-65.39268958199995, 59.51207103100006],
              [-65.41185462099992, 59.51788971600007],
              [-65.42894446499992, 59.53204987200007],
              [-65.48908443899995, 59.626166083000044],
              [-65.51939856699994, 59.70258209800005],
              [-65.52969316299993, 59.71861399900007],
              [-65.54625403599994, 59.73126862200007],
              [-65.52183997299994, 59.75031159100007],
              [-65.48473059799994, 59.76048411700003],
              [-65.46637936099995, 59.77142975500004],
              [-65.49791419199994, 59.792669989000046],
              [-65.49168860599991, 59.79954661700003],
              [-65.48961341099994, 59.79844798400006],
              [-65.48424231699994, 59.79954661700003],
              [-65.45946204299992, 59.79254791900007],
              [-65.45376542899993, 59.78961823100008],
              [-65.44591223899994, 59.78697337400007],
              [-65.44025631399995, 59.793402411000045],
              [-65.43268795499995, 59.809434312000064],
              [-65.41771399599992, 59.81525299700007],
              [-65.40054277299993, 59.81077708500004],
              [-65.38316809799994, 59.80329010600008],
              [-65.36754309799994, 59.79954661700003],
              [-65.37393144399994, 59.80927155200004],
              [-65.37938391799992, 59.82050202000005],
              [-65.37897701699995, 59.829779364000046],
              [-65.36782792899993, 59.833685614000046],
              [-65.35358639199995, 59.835923570000034],
              [-65.33608964799993, 59.845689195000034],
              [-65.32347571499992, 59.84796784100007],
              [-65.31110592399995, 59.84617747600004],
              [-65.21422278599994, 59.82078685100004],
              [-65.19619706899994, 59.81317780200004],
              [-65.16584225199995, 59.792669989000046],
              [-65.11400305899991, 59.78278229400007],
              [-65.08409583199995, 59.77171458500004],
              [-65.05150305899991, 59.766465562000064],
              [-64.98395748599995, 59.76475657800006],
              [-64.98395748599995, 59.77220286700003],
              [-65.05313066299993, 59.77903880400004],
              [-65.06411699099993, 59.78221263200004],
              [-65.09325110599991, 59.79633209800005],
              [-65.14146887899994, 59.80609772300005],
              [-65.19505774599992, 59.83458079600007],
              [-65.22419186099995, 59.841131903000075],
              [-65.22419186099995, 59.84796784100007],
              [-65.21849524599992, 59.848863023000035],
              [-65.20303300699993, 59.85419342700004],
              [-65.20864824099993, 59.863714911000045],
              [-65.22638912699995, 59.87555573100008],
              [-65.23094641799992, 59.882066148000035],
              [-65.22972571499992, 59.89240143400008],
              [-65.22337805899991, 59.89557526200008],
              [-65.21556555899991, 59.893744208000044],
              [-65.20982825399994, 59.88890208500004],
              [-65.19456946499992, 59.88751862200007],
              [-65.16690019399994, 59.87677643400008],
              [-65.14045162699995, 59.87132396000004],
              [-65.12857011599993, 59.88548411700003],
              [-65.13780676999994, 59.90021393400008],
              [-65.16006425699993, 59.90794505400004],
              [-65.20982825399994, 59.91559479400007],
              [-65.20982825399994, 59.923041083000044],
              [-65.17926998599995, 59.921942450000074],
              [-65.16954505099994, 59.923041083000044],
              [-65.15038001199991, 59.929022528000075],
              [-65.14533443899995, 59.92987702000005],
              [-65.14110266799992, 59.931626695000034],
              [-65.14146887899994, 59.93573639500005],
              [-65.14289303299995, 59.94037506700005],
              [-65.14159094999991, 59.94354889500005],
              [-65.13947506399995, 59.947333075000074],
              [-65.14167232999995, 59.951605536000045],
              [-65.14216061099995, 59.955064195000034],
              [-65.13512122299994, 59.95661041900007],
              [-65.12071692599994, 59.95482005400004],
              [-65.10684160099993, 59.95099518400008],
              [-65.09927324099993, 59.946966864000046],
              [-65.08018958199995, 59.92987702000005],
              [-65.07091223899994, 59.94330475500004],
              [-65.08503170499995, 59.956244208000044],
              [-65.12857011599993, 59.97764720300006],
              [-65.11339270699995, 59.982855536000045],
              [-65.09854081899994, 59.981756903000075],
              [-65.0833227199999, 59.978583075000074],
              [-65.06651770699995, 59.97764720300006],
              [-65.07494055899991, 59.98973216400003],
              [-65.08893795499995, 59.99595774900007],
              [-65.10456295499995, 60.00071849200003],
              [-65.11766516799992, 60.00836823100008],
              [-65.12393144399994, 60.018744208000044],
              [-65.12262936099995, 60.033270575000074],
              [-65.12857011599993, 60.03974030200004],
              [-65.12857011599993, 60.046576239000046],
              [-65.06847083199995, 60.04649485900006],
              [-65.04605058499993, 60.054754950000074],
              [-65.02497311099995, 60.08075592700004],
              [-65.05333411399994, 60.08783600500004],
              [-65.06529700399994, 60.094590562000064],
              [-65.06309973899994, 60.10431549700007],
              [-65.05264238199993, 60.109808661000045],
              [-65.03526770699995, 60.11627838700008],
              [-65.01903235599991, 60.12018463700008],
              [-65.01187089799993, 60.11823151200008],
              [-65.00841223899994, 60.11115143400008],
              [-65.00104732999995, 60.11627838700008],
              [-64.99388587099992, 60.124986070000034],
              [-64.99136308499993, 60.12909577000005],
              [-64.99425208199995, 60.130845445000034],
              [-64.99665279899995, 60.13780345300006],
              [-64.99722245999993, 60.14634837400007],
              [-64.99478105399993, 60.15269603100006],
              [-64.98314368399991, 60.156236070000034],
              [-64.97305253799993, 60.15302155200004],
              [-64.9661352199999, 60.154730536000045],
              [-64.96349036399994, 60.173163153000075],
              [-64.95152747299994, 60.193426825000074],
              [-64.92418372299994, 60.196519273000035],
              [-64.89415442599994, 60.195746161000045],
              [-64.87409420499995, 60.20420970300006],
              [-64.88036048099991, 60.21893952000005],
              [-64.95726477799991, 60.25885651200008],
              [-64.90615800699993, 60.272691148000035],
              [-64.88434811099995, 60.28192780200004],
              [-64.86412512899994, 60.29637278900003],
              [-64.84691321499992, 60.31342194200005],
              [-64.83702551999994, 60.32916901200008],
              [-64.83971106699994, 60.34320709800005],
              [-64.86046301999994, 60.35504791900007],
              [-64.86046301999994, 60.36127350500004],
              [-64.84878495999993, 60.36570872600004],
              [-64.83893795499995, 60.365220445000034],
              [-64.82957923099991, 60.36273834800005],
              [-64.81944739499994, 60.36127350500004],
              [-64.77847245999993, 60.36127350500004],
              [-64.75816809799994, 60.357530015000066],
              [-64.72276770699995, 60.344183661000045],
              [-64.7102758449999, 60.34137604400007],
              [-64.68687903599994, 60.33502838700008],
              [-64.67609615799995, 60.33392975500004],
              [-64.68333899599992, 60.34357330900008],
              [-64.68736731699994, 60.34564850500004],
              [-64.6966039699999, 60.34760163000004],
              [-64.6966039699999, 60.35504791900007],
              [-64.67638098899994, 60.350043036000045],
              [-64.62751217399995, 60.34674713700008],
              [-64.61025956899994, 60.33763255400004],
              [-64.59801184799994, 60.329413153000075],
              [-64.54576575399994, 60.306626695000034],
              [-64.53140214799993, 60.303900458000044],
              [-64.46422278599994, 60.291083075000074],
              [-64.44640051999994, 60.282416083000044],
              [-64.43276933499993, 60.26972077000005],
              [-64.41661536399994, 60.25971100500004],
              [-64.38060462099992, 60.24518463700008],
              [-64.39883378799993, 60.24017975500004],
              [-64.42577063699991, 60.242621161000045],
              [-64.45343990799995, 60.25055573100008],
              [-64.49510657499991, 60.27256907800006],
              [-64.58674068899995, 60.292954820000034],
              [-64.63654537699995, 60.293036200000074],
              [-64.68106035099993, 60.27830638200004],
              [-64.75865637899994, 60.238348700000074],
              [-64.72931881399995, 60.234808661000045],
              [-64.65176347599993, 60.26414622600004],
              [-64.61709550699993, 60.27252838700008],
              [-64.55736243399991, 60.26984284100007],
              [-64.53892981699994, 60.265692450000074],
              [-64.48534094999991, 60.24017975500004],
              [-64.46324622299994, 60.238348700000074],
              [-64.48302161399994, 60.21967194200005],
              [-64.54295813699991, 60.19358958500004],
              [-64.56627356699994, 60.17633698100008],
              [-64.51528886599993, 60.17633698100008],
              [-64.50413977799991, 60.17853424700007],
              [-64.48631751199991, 60.18829987200007],
              [-64.45970618399991, 60.19818756700005],
              [-64.43797766799992, 60.212998765000066],
              [-64.41616777299993, 60.22337474200003],
              [-64.39492753799993, 60.217230536000045],
              [-64.40510006399995, 60.21385325700004],
              [-64.41490637899994, 60.20856354400007],
              [-64.42320716099994, 60.202460028000075],
              [-64.42906653599994, 60.19676341400003],
              [-64.40998287699995, 60.197251695000034],
              [-64.39981035099993, 60.18968333500004],
              [-64.39216061099995, 60.179022528000075],
              [-64.38060462099992, 60.17011139500005],
              [-64.39924068899995, 60.15119049700007],
              [-64.49791419199994, 60.11481354400007],
              [-64.49791419199994, 60.10736725500004],
              [-64.48668372299994, 60.10504791900007],
              [-64.47695878799993, 60.101670640000066],
              [-64.46898352799991, 60.09625885600008],
              [-64.46324622299994, 60.08751048400006],
              [-64.49111894399994, 60.08100006700005],
              [-64.57306881399995, 60.08075592700004],
              [-64.63243567599994, 60.071519273000035],
              [-64.66295325399994, 60.06163157800006],
              [-64.67609615799995, 60.049668687000064],
              [-64.68919837099992, 60.043402411000045],
              [-64.81248938699991, 60.008246161000045],
              [-64.82315019399994, 60.001206773000035],
              [-64.82827714799993, 59.99115631700005],
              [-64.82233639199995, 59.98545970300006],
              [-64.81090247299994, 59.98346588700008],
              [-64.80646725199995, 59.984483140000066],
              [-64.58674068899995, 60.060248114000046],
              [-64.55557206899994, 60.05536530200004],
              [-64.50210527299993, 60.05695221600007],
              [-64.45152747299994, 60.06614817900004],
              [-64.42906653599994, 60.08417389500005],
              [-64.41950436099995, 60.10224030200004],
              [-64.39834550699993, 60.12083567900004],
              [-64.37718665299991, 60.129746812000064],
              [-64.36754309799994, 60.11823151200008],
              [-64.36949622299994, 60.09703196800007],
              [-64.37547766799992, 60.08116282800006],
              [-64.38630123599995, 60.076239325000074],
              [-64.40241451699995, 60.08751048400006],
              [-64.41372636599993, 60.07111237200007],
              [-64.37376868399991, 60.04010651200008],
              [-64.38805091099994, 60.025458075000074],
              [-64.39321855399993, 60.01447174700007],
              [-64.42096920499995, 60.00828685100004],
              [-64.53954016799992, 60.010931708000044],
              [-64.48814856699994, 60.003607489000046],
              [-64.41661536399994, 59.98509349200003],
              [-64.40050208199995, 59.97606028900003],
              [-64.39492753799993, 59.95661041900007],
              [-64.40192623599995, 59.941473700000074],
              [-64.41759192599994, 59.93260325700004],
              [-64.43748938699991, 59.92914459800005],
              [-64.45030676999994, 59.92959219000005],
              [-64.50194251199991, 59.912095445000034],
              [-64.51842200399994, 59.90253327000005],
              [-64.49767005099994, 59.89695872600004],
              [-64.47638912699995, 59.900498765000066],
              [-64.43618730399993, 59.91929759300007],
              [-64.42357337099992, 59.92328522300005],
              [-64.40941321499992, 59.92418040600006],
              [-64.38125566299993, 59.923041083000044],
              [-64.36896725199995, 59.927435614000046],
              [-64.36139889199995, 59.93699778900003],
              [-64.35944576699995, 59.946600653000075],
              [-64.36388098899994, 59.95099518400008],
              [-64.36351477799991, 59.95799388200004],
              [-64.34723873599995, 59.97357819200005],
              [-64.32461503799993, 59.989447333000044],
              [-64.30553137899994, 59.99750397300005],
              [-64.2454320949999, 59.994981187000064],
              [-64.22423255099994, 59.99750397300005],
              [-64.22423255099994, 60.00495026200008],
              [-64.26252193899995, 60.003119208000044],
              [-64.30260169199994, 60.00995514500005],
              [-64.32896887899994, 60.02814362200007],
              [-64.32603919199994, 60.060248114000046],
              [-64.30288652299993, 60.05182526200008],
              [-64.27733313699991, 60.04779694200005],
              [-64.22052975199995, 60.046576239000046],
              [-64.21719316299993, 60.04474518400008],
              [-64.21519934799994, 60.035589911000045],
              [-64.21056067599994, 60.03229401200008],
              [-64.18472245999993, 60.03082916900007],
              [-64.18260657499991, 60.03229401200008],
              [-64.17088782499991, 60.02240631700005],
              [-64.15721594999991, 59.99961985900006],
              [-64.14785722599993, 59.99131907800006],
              [-64.14785722599993, 59.984483140000066],
              [-64.18122311099995, 59.97540924700007],
              [-64.27440344999991, 59.963731187000064],
              [-64.29873613199993, 59.94354889500005],
              [-64.22931881399995, 59.94163646000004],
              [-64.20335852799991, 59.933579820000034],
              [-64.18260657499991, 59.91559479400007],
              [-64.19440670499995, 59.90143463700008],
              [-64.21251380099994, 59.889837958000044],
              [-64.23448645699995, 59.882798570000034],
              [-64.25772050699993, 59.882066148000035],
              [-64.25772050699993, 59.87461985900006],
              [-64.21857662699995, 59.87445709800005],
              [-64.19904537699995, 59.87653229400007],
              [-64.18260657499991, 59.882066148000035],
              [-64.16982988199993, 59.892645575000074],
              [-64.16193600199995, 59.903550523000035],
              [-64.15318762899994, 59.912095445000034],
              [-64.13792883999992, 59.91559479400007],
              [-64.12637285099993, 59.907456773000035],
              [-64.13597571499992, 59.88922760600008],
              [-64.16218014199995, 59.861029364000046],
              [-64.17027747299994, 59.84564850500004],
              [-64.17430579299992, 59.83067454600007],
              [-64.17585201699995, 59.796128648000035],
              [-64.19253495999993, 59.778509833000044],
              [-64.25938880099994, 59.788397528000075],
              [-64.26455644399994, 59.76475657800006],
              [-64.24640865799995, 59.742621161000045],
              [-64.21226966099994, 59.716131903000075],
              [-64.17503821499992, 59.69354889500005],
              [-64.14785722599993, 59.682847398000035],
              [-64.03799394399994, 59.682847398000035],
              [-63.96231035099993, 59.694566148000035],
              [-63.943023240999935, 59.68968333500004],
              [-63.95579993399991, 59.67438385600008],
              [-63.96979732999995, 59.66233958500004],
              [-63.94448808499993, 59.66278717700004],
              [-63.93276933499993, 59.66087474200003],
              [-63.921986456999946, 59.655503648000035],
              [-63.955962693999936, 59.645819403000075],
              [-63.99474036399994, 59.647650458000044],
              [-64.03160559799994, 59.644964911000045],
              [-64.05972245999993, 59.62140534100007],
              [-64.06651770699995, 59.59174225500004],
              [-64.07282467399995, 59.57444896000004],
              [-64.09190833199995, 59.560980536000045],
              [-64.10472571499992, 59.54734935100004],
              [-64.11603756399995, 59.531317450000074],
              [-64.12059485599991, 59.51837799700007],
              [-64.06476803299995, 59.54559967700004],
              [-64.03994706899994, 59.562201239000046],
              [-64.03799394399994, 59.58043040600006],
              [-64.03184973899994, 59.58043040600006],
              [-64.03213456899994, 59.61017487200007],
              [-64.00731360599991, 59.62400950700004],
              [-63.97337805899991, 59.62372467700004],
              [-63.94644120999993, 59.61115143400008],
              [-63.889556443999936, 59.617254950000074],
              [-63.86408443899995, 59.611314195000034],
              [-63.87755286399994, 59.58384837400007],
              [-63.89077714799993, 59.57762278900003],
              [-63.927845831999946, 59.57282135600008],
              [-63.943023240999935, 59.56675853100006],
              [-63.98338782499991, 59.525824286000045],
              [-63.98070227799991, 59.50641510600008],
              [-63.96556555899991, 59.51194896000004],
              [-63.935617641999954, 59.539496161000045],
              [-63.92064368399991, 59.54938385600008],
              [-63.87413489499994, 59.57298411700003],
              [-63.7669164699999, 59.54828522300005],
              [-63.73692786399994, 59.53204987200007],
              [-63.72769120999993, 59.519964911000045],
              [-63.72813880099994, 59.50914134300007],
              [-63.736398891999954, 59.49799225500004],
              [-63.75743567599994, 59.477850653000075],
              [-63.78083248599995, 59.450059312000064],
              [-63.78164628799993, 59.44383372600004],
              [-63.78465735599991, 59.44041575700004],
              [-63.78547115799995, 59.43305084800005],
              [-63.787668423999946, 59.42560455900008],
              [-63.795033331999946, 59.42218659100007],
              [-63.99982662699995, 59.41852448100008],
              [-64.03473873599995, 59.41050853100006],
              [-64.06598873599995, 59.39545319200005],
              [-64.06065833199995, 59.38727448100008],
              [-64.05280514199995, 59.38239166900007],
              [-64.04295813699991, 59.38043854400007],
              [-64.03184973899994, 59.38117096600007],
              [-64.03799394399994, 59.38117096600007],
              [-63.99982662699995, 59.390326239000046],
              [-63.96076412699995, 59.39057038000004],
              [-63.805897589999915, 59.37494538000004],
              [-63.79043535099993, 59.378973700000074],
              [-63.77892005099994, 59.38450755400004],
              [-63.76707923099991, 59.388780015000066],
              [-63.75059973899994, 59.38861725500004],
              [-63.75645911399994, 59.37632884300007],
              [-63.75934811099995, 59.37213776200008],
              [-63.764881964999915, 59.36815013200004],
              [-63.75226803299995, 59.36322663000004],
              [-63.739125128999945, 59.36432526200008],
              [-63.72508704299992, 59.367254950000074],
              [-63.70962480399993, 59.36815013200004],
              [-63.72638912699995, 59.35040924700007],
              [-63.74278723899994, 59.30817291900007],
              [-63.75405839799993, 59.28937409100007],
              [-63.77481035099993, 59.26341380400004],
              [-63.778553839999915, 59.261704820000034],
              [-63.78457597599993, 59.257879950000074],
              [-63.82575436099995, 59.252061265000066],
              [-63.82575436099995, 59.24461497600004],
              [-63.77489173099991, 59.248032945000034],
              [-63.75035559799994, 59.25421784100007],
              [-63.730132615999935, 59.26508209800005],
              [-63.71816972599993, 59.28217194200005],
              [-63.69835364499994, 59.32530345300006],
              [-63.68578040299991, 59.334051825000074],
              [-63.67491614499994, 59.33934153900003],
              [-63.662180141999954, 59.36277903900003],
              [-63.6516820949999, 59.36815013200004],
              [-63.64329993399991, 59.36591217700004],
              [-63.62970943899995, 59.35614655200004],
              [-63.62401282499991, 59.35386790600006],
              [-63.55353756399995, 59.353583075000074],
              [-63.53156490799995, 59.347723700000074],
              [-63.533192511999914, 59.33881256700005],
              [-63.53034420499995, 59.335191148000035],
              [-63.52619381399995, 59.331732489000046],
              [-63.52407792899993, 59.323106187000064],
              [-63.52525794199994, 59.316514390000066],
              [-63.52782141799992, 59.31146881700005],
              [-63.53156490799995, 59.306708075000074],
              [-63.533192511999914, 59.280585028000075],
              [-63.536773240999935, 59.27020905200004],
              [-63.54515540299991, 59.25828685100004],
              [-63.55256100199995, 59.25352610900006],
              [-63.60977128799993, 59.22728099200003],
              [-63.62486731699994, 59.223944403000075],
              [-63.64142818899995, 59.22418854400007],
              [-63.63512122299994, 59.21910228100006],
              [-63.628977016999954, 59.21698639500005],
              [-63.614125128999945, 59.21666087400007],
              [-63.62026933499993, 59.21666087400007],
              [-63.60204016799992, 59.21397532800006],
              [-63.57201087099992, 59.21519603100006],
              [-63.54393469999991, 59.21979401200008],
              [-63.53156490799995, 59.22724030200004],
              [-63.47984778599994, 59.27098216400003],
              [-63.46637936099995, 59.27875397300005],
              [-63.41783606699994, 59.29096100500004],
              [-63.392567511999914, 59.29246653900003],
              [-63.38072669199994, 59.27875397300005],
              [-63.38829505099994, 59.26813385600008],
              [-63.40721594999991, 59.256293036000045],
              [-63.42992102799991, 59.24705638200004],
              [-63.44904537699995, 59.24461497600004],
              [-63.43700110599991, 59.22955963700008],
              [-63.44359290299991, 59.218085028000075],
              [-63.4563695949999, 59.207017320000034],
              [-63.46324622299994, 59.19310130400004],
              [-63.456288214999915, 59.19281647300005],
              [-63.421864386999914, 59.206732489000046],
              [-63.40859941299993, 59.20990631700005],
              [-63.40802975199995, 59.21539948100008],
              [-63.39879309799994, 59.218858140000066],
              [-63.38573157499991, 59.219590562000064],
              [-63.37328040299991, 59.21666087400007],
              [-63.36571204299992, 59.20954010600008],
              [-63.36082923099991, 59.19822825700004],
              [-63.36302649599992, 59.18773021000004],
              [-63.377023891999954, 59.18317291900007],
              [-63.39122473899994, 59.17487213700008],
              [-63.425852016999954, 59.13471100500004],
              [-63.44220943899995, 59.12055084800005],
              [-63.46548417899993, 59.11436595300006],
              [-63.521473761999914, 59.10822174700007],
              [-63.54181881399995, 59.09752024900007],
              [-63.56090247299994, 59.08226146000004],
              [-63.58177649599992, 59.075059312000064],
              [-63.66161048099991, 59.07025788000004],
              [-63.71987870999993, 59.05609772300005],
              [-63.74718176999994, 59.052801825000074],
              [-63.77574622299994, 59.055528062000064],
              [-63.824330206999946, 59.06867096600007],
              [-63.962880011999914, 59.08075592700004],
              [-63.973540818999936, 59.078965562000064],
              [-63.98473059799994, 59.07383860900006],
              [-63.9934789699999, 59.066107489000046],
              [-63.99705969999991, 59.05621979400007],
              [-64.00283769399994, 59.048936265000066],
              [-64.02985592399995, 59.03758372600004],
              [-64.03799394399994, 59.03233470300006],
              [-64.03990637899994, 59.01793040600006],
              [-64.02293860599991, 59.019517320000034],
              [-63.96939042899993, 59.03668854400007],
              [-63.955637173999946, 59.05540599200003],
              [-63.94644120999993, 59.05967845300006],
              [-63.894642706999946, 59.05967845300006],
              [-63.894642706999946, 59.052801825000074],
              [-63.91661536399994, 59.02680084800005],
              [-63.90672766799992, 58.98981354400007],
              [-63.88231360599991, 58.96198151200008],
              [-63.86046301999994, 58.96344635600008],
              [-63.85928300699993, 58.978583075000074],
              [-63.86701412699995, 58.99595774900007],
              [-63.880970831999946, 59.01813385600008],
              [-63.870757615999935, 59.033189195000034],
              [-63.85301673099991, 59.037176825000074],
              [-63.832142706999946, 59.03856028900003],
              [-63.81212317599994, 59.04600657800006],
              [-63.78026282499991, 59.027411200000074],
              [-63.763742641999954, 59.02106354400007],
              [-63.743804490999935, 59.01813385600008],
              [-63.72313391799992, 59.02012767100007],
              [-63.66185462099992, 59.03856028900003],
              [-63.617298956999946, 59.04096100500004],
              [-63.53579667899993, 59.036322333000044],
              [-63.52407792899993, 59.03856028900003],
              [-63.51675370999993, 59.04319896000004],
              [-63.512562628999945, 59.04975006700005],
              [-63.507476365999935, 59.055975653000075],
              [-63.49742591099994, 59.05967845300006],
              [-63.460601365999935, 59.07086823100008],
              [-63.4524633449999, 59.06993235900006],
              [-63.43773352799991, 59.06321849200003],
              [-63.420806443999936, 59.06500885600008],
              [-63.40697180899991, 59.072699286000045],
              [-63.40119381399995, 59.08384837400007],
              [-63.38662675699993, 59.101996161000045],
              [-63.352772589999915, 59.10443756700005],
              [-63.285145636999914, 59.093817450000074],
              [-63.28697669199994, 59.089178778000075],
              [-63.28954016799992, 59.07786692900004],
              [-63.29133053299995, 59.07330963700008],
              [-63.25039628799993, 59.07672760600008],
              [-63.23078365799995, 59.07416413000004],
              [-63.21279863199993, 59.06305573100008],
              [-63.19102942599994, 59.05963776200008],
              [-63.15835527299993, 59.06309642100007],
              [-63.13158118399991, 59.06232330900008],
              [-63.12743079299992, 59.04600657800006],
              [-63.16197669199994, 59.03001536700003],
              [-63.33975175699993, 59.03233470300006],
              [-63.33975175699993, 59.02558014500005],
              [-63.250559048999946, 59.013739325000074],
              [-63.22248287699995, 59.005072333000044],
              [-63.26943925699993, 58.97931549700007],
              [-63.28897050699993, 58.964178778000075],
              [-63.305572068999936, 58.94297923400006],
              [-63.28233801999994, 58.951280015000066],
              [-63.24103756399995, 58.97569407800006],
              [-63.21621660099993, 58.98395416900007],
              [-63.20103919199994, 58.98545970300006],
              [-63.18317623599995, 58.984361070000034],
              [-63.169585740999935, 58.97789134300007],
              [-63.16783606699994, 58.96344635600008],
              [-63.176625128999945, 58.957464911000045],
              [-63.19416256399995, 58.953558661000045],
              [-63.22984778599994, 58.950384833000044],
              [-63.22984778599994, 58.94297923400006],
              [-63.211822068999936, 58.943060614000046],
              [-63.19017493399991, 58.94000885600008],
              [-63.17129472599993, 58.93341705900008],
              [-63.16161048099991, 58.92247142100007],
              [-63.18504798099991, 58.91498444200005],
              [-63.23668372299994, 58.88153717700004],
              [-63.25796464799993, 58.87413157800006],
              [-63.32607988199993, 58.861029364000046],
              [-63.31623287699995, 58.85602448100008],
              [-63.31297766799992, 58.85639069200005],
              [-63.29832923099991, 58.851996161000045],
              [-63.27525794199994, 58.85309479400007],
              [-63.22984778599994, 58.861029364000046],
              [-63.19505774599992, 58.85911692900004],
              [-63.18077551999994, 58.86481354400007],
              [-63.16783606699994, 58.88153717700004],
              [-63.15477454299992, 58.87409088700008],
              [-63.17906653599994, 58.841498114000046],
              [-63.17886308499993, 58.82843659100007],
              [-63.15477454299992, 58.826280015000066],
              [-63.13939368399991, 58.833197333000044],
              [-63.12486731699994, 58.84678782800006],
              [-63.11668860599991, 58.86212799700007],
              [-63.12067623599995, 58.87409088700008],
              [-63.091867641999954, 58.894964911000045],
              [-63.05247962099992, 58.90228913000004],
              [-63.014515753999945, 58.89740631700005],
              [-62.98965410099993, 58.88153717700004],
              [-63.02794348899994, 58.87653229400007],
              [-63.047434048999946, 58.870794989000046],
              [-63.052398240999935, 58.861029364000046],
              [-63.04279537699995, 58.85932038000004],
              [-62.92690995999993, 58.82318756700005],
              [-62.914621548999946, 58.812608140000066],
              [-62.91002356699994, 58.796942450000074],
              [-62.913319464999915, 58.78461334800005],
              [-62.917225714999915, 58.77423737200007],
              [-62.914621548999946, 58.764837958000044],
              [-62.91551673099991, 58.76011790600006],
              [-62.917632615999935, 58.75840892100007],
              [-62.91812089799993, 58.75653717700004],
              [-62.914621548999946, 58.751166083000044],
              [-63.033314581999946, 58.719183661000045],
              [-63.044911261999914, 58.710191148000035],
              [-63.03868567599994, 58.709092515000066],
              [-63.02448482999995, 58.70274485900006],
              [-63.02065995999993, 58.70164622600004],
              [-62.94562740799995, 58.70274485900006],
              [-62.920033331999946, 58.707098700000074],
              [-62.89549719999991, 58.714178778000075],
              [-62.87287350199995, 58.71564362200007],
              [-62.85313880099994, 58.70274485900006],
              [-62.844593878999945, 58.68516673400006],
              [-62.84650631399995, 58.669256903000075],
              [-62.856678839999915, 58.65562571800007],
              [-62.87295488199993, 58.64472077000005],
              [-62.88621985599991, 58.64044830900008],
              [-62.90782630099994, 58.63768138200004],
              [-62.917632615999935, 58.63141510600008],
              [-62.921131964999915, 58.623480536000045],
              [-62.92027747299994, 58.615301825000074],
              [-62.92251542899993, 58.60655345300006],
              [-62.93537350199995, 58.59662506700005],
              [-63.07835852799991, 58.55914948100008],
              [-63.124663865999935, 58.53156159100007],
              [-63.15477454299992, 58.524644273000035],
              [-63.1594945949999, 58.52008698100008],
              [-63.16307532499991, 58.50873444200005],
              [-63.16783606699994, 58.50482819200005],
              [-63.17564856699994, 58.50348541900007],
              [-63.278553839999915, 58.50580475500004],
              [-63.305572068999936, 58.510972398000035],
              [-63.32689368399991, 58.49701569200005],
              [-63.36864173099991, 58.497748114000046],
              [-63.412953253999945, 58.50853099200003],
              [-63.44220943899995, 58.524644273000035],
              [-63.44880123599995, 58.50446198100008],
              [-63.47142493399991, 58.490301825000074],
              [-63.49986731699994, 58.48143138200004],
              [-63.52407792899993, 58.47748444200005],
              [-63.39126542899993, 58.491074937000064],
              [-63.37490800699993, 58.49054596600007],
              [-63.35606848899994, 58.487168687000064],
              [-63.34194902299993, 58.47882721600007],
              [-63.33975175699993, 58.46320221600007],
              [-63.34707597599993, 58.45685455900008],
              [-63.387562628999945, 58.429022528000075],
              [-63.41030839799993, 58.407456773000035],
              [-63.420765753999945, 58.399603583000044],
              [-63.43529212099992, 58.39154694200005],
              [-63.48741614499994, 58.37787506700005],
              [-63.53477942599994, 58.352728583000044],
              [-63.582142706999946, 58.31745026200008],
              [-63.593006964999915, 58.305528062000064],
              [-63.56818600199995, 58.30577220300006],
              [-63.546538865999935, 58.31187571800007],
              [-63.48851477799991, 58.34422435100004],
              [-63.42170162699995, 58.367621161000045],
              [-63.26402747299994, 58.470038153000075],
              [-63.26402747299994, 58.46320221600007],
              [-63.24787350199995, 58.470689195000034],
              [-63.14411373599995, 58.47837962400007],
              [-63.12490800699993, 58.475897528000075],
              [-63.106678839999915, 58.468858140000066],
              [-63.08584550699993, 58.456366278000075],
              [-63.09801184799994, 58.44603099200003],
              [-63.12743079299992, 58.41478099200003],
              [-63.157134568999936, 58.39500560100004],
              [-63.165679490999935, 58.38349030200004],
              [-63.16161048099991, 58.367621161000045],
              [-63.15477454299992, 58.381293036000045],
              [-63.14053300699993, 58.38361237200007],
              [-63.07909094999991, 58.442694403000075],
              [-63.06330318899995, 58.451605536000045],
              [-63.051665818999936, 58.45209381700005],
              [-63.03062903599994, 58.442694403000075],
              [-63.02892005099994, 58.44053782800006],
              [-63.027333136999914, 58.436712958000044],
              [-63.02415930899991, 58.43244049700007],
              [-63.017648891999954, 58.429022528000075],
              [-63.00967363199993, 58.42869700700004],
              [-62.98346920499995, 58.43650950700004],
              [-62.97801673099991, 58.447373765000066],
              [-62.96080481699994, 58.45929596600007],
              [-62.93773352799991, 58.46820709800005],
              [-62.914621548999946, 58.470038153000075],
              [-62.85313880099994, 58.47748444200005],
              [-62.84410559799994, 58.47532786700003],
              [-62.83299719999991, 58.47129954600007],
              [-62.8235570949999, 58.471136786000045],
              [-62.817250128999945, 58.48493073100008],
              [-62.81151282499991, 58.49005768400008],
              [-62.80443274599992, 58.49481842700004],
              [-62.79784094999991, 58.49799225500004],
              [-62.78425045499995, 58.49799225500004],
              [-62.79234778599994, 58.48021067900004],
              [-62.792958136999914, 58.46592845300006],
              [-62.78595943899995, 58.45892975500004],
              [-62.77122962099992, 58.46320221600007],
              [-62.767241990999935, 58.46849192900004],
              [-62.762928839999915, 58.484361070000034],
              [-62.75694739499994, 58.491074937000064],
              [-62.74372311099995, 58.49628327000005],
              [-62.732085740999935, 58.49567291900007],
              [-62.72008216099994, 58.49286530200004],
              [-62.70567786399994, 58.491074937000064],
              [-62.62059485599991, 58.50608958500004],
              [-62.57860266799992, 58.50421784100007],
              [-62.558257615999935, 58.47748444200005],
              [-62.6067602199999, 58.456366278000075],
              [-62.60204016799992, 58.446478583000044],
              [-62.59923255099994, 58.442694403000075],
              [-62.61558997299994, 58.43842194200005],
              [-62.630116339999915, 58.431708075000074],
              [-62.65392005099994, 58.41478099200003],
              [-62.62682044199994, 58.38617584800005],
              [-62.61937415299991, 58.37083567900004],
              [-62.63341223899994, 58.36017487200007],
              [-62.626616990999935, 58.35191478100006],
              [-62.62181555899991, 58.33685944200005],
              [-62.620350714999915, 58.32066478100006],
              [-62.62344316299993, 58.30927155200004],
              [-62.63451087099992, 58.30186595300006],
              [-62.70913652299993, 58.28510163000004],
              [-62.71251380099994, 58.28180573100008],
              [-62.71548417899993, 58.27728913000004],
              [-62.72118079299992, 58.27317942900004],
              [-62.73273678299995, 58.27134837400007],
              [-62.855539516999954, 58.26866282800006],
              [-62.87262936099995, 58.26190827000005],
              [-62.88634192599994, 58.237494208000044],
              [-62.89903723899994, 58.22614166900007],
              [-62.90758216099994, 58.21434153900003],
              [-62.90151933499993, 58.203111070000034],
              [-62.88805091099994, 58.202826239000046],
              [-62.87804114499994, 58.21515534100007],
              [-62.87022864499994, 58.23004791900007],
              [-62.86302649599992, 58.23725006700005],
              [-62.85366777299993, 58.240220445000034],
              [-62.83299719999991, 58.25377024900007],
              [-62.82168535099993, 58.257106838000084],
              [-62.7981664699999, 58.253607489000046],
              [-62.69717363199993, 58.253241278000075],
              [-62.67495683499993, 58.26117584800005],
              [-62.66759192599994, 58.271470445000034],
              [-62.65054277299993, 58.26911041900007],
              [-62.61660722599993, 58.25775788000004],
              [-62.60041256399995, 58.25458405200004],
              [-62.589955206999946, 58.24640534100007],
              [-62.5833227199999, 58.235215562000064],
              [-62.57876542899993, 58.22300853100006],
              [-62.61461341099994, 58.21381256700005],
              [-62.620350714999915, 58.20648834800005],
              [-62.624663865999935, 58.195746161000045],
              [-62.63524329299992, 58.186753648000035],
              [-62.64858964799993, 58.17999909100007],
              [-62.661366339999915, 58.175848700000074],
              [-62.754750128999945, 58.171210028000075],
              [-62.81745357999995, 58.17906321800007],
              [-63.07909094999991, 58.15534088700008],
              [-63.064442511999914, 58.14830149900007],
              [-63.02806555899991, 58.14484284100007],
              [-63.01081295499995, 58.141058661000045],
              [-63.03453528599994, 58.11823151200008],
              [-63.20059160099993, 58.06867096600007],
              [-63.20938066299993, 58.06224192900004],
              [-63.19880123599995, 58.05731842700004],
              [-63.149322068999936, 58.06268952000005],
              [-63.13434811099995, 58.06598541900007],
              [-63.14940344999991, 58.042954820000034],
              [-63.16812089799993, 58.02802155200004],
              [-63.19298255099994, 58.019964911000045],
              [-63.25548255099994, 58.014960028000075],
              [-63.28620357999995, 58.007798570000034],
              [-63.31525631399995, 57.997259833000044],
              [-63.33975175699993, 57.98399485900006],
              [-63.32176673099991, 57.98334381700005],
              [-63.13825436099995, 57.99986399900007],
              [-63.11953691299993, 58.00486888200004],
              [-63.10326087099992, 58.01447174700007],
              [-63.09943600199995, 58.02130768400008],
              [-63.10106360599991, 58.03778717700004],
              [-63.09951738199993, 58.04547760600008],
              [-63.09243730399993, 58.05805084800005],
              [-63.066395636999914, 58.07286204600007],
              [-63.03575598899994, 58.08283112200007],
              [-62.98908443899995, 58.09251536700003],
              [-62.979725714999915, 58.09324778900003],
              [-62.97142493399991, 58.09638092700004],
              [-62.96987870999993, 58.103216864000046],
              [-62.96987870999993, 58.11005280200004],
              [-62.96442623599995, 58.11505768400008],
              [-62.94880123599995, 58.124335028000075],
              [-62.93399003799993, 58.130560614000046],
              [-62.92617753799993, 58.132879950000074],
              [-62.88947506399995, 58.13727448100008],
              [-62.85252844999991, 58.14704010600008],
              [-62.83263098899994, 58.14789459800005],
              [-62.83263098899994, 58.141058661000045],
              [-62.838002081999946, 58.14000071800007],
              [-62.85313880099994, 58.134833075000074],
              [-62.84080969999991, 58.123480536000045],
              [-62.81883704299992, 58.12474192900004],
              [-62.77122962099992, 58.134833075000074],
              [-62.76520748599995, 58.13263580900008],
              [-62.75861568899995, 58.12828196800007],
              [-62.74958248599995, 58.12535228100006],
              [-62.736439581999946, 58.127386786000045],
              [-62.735259568999936, 58.12950267100007],
              [-62.734934048999946, 58.13349030200004],
              [-62.73346920499995, 58.13776276200008],
              [-62.72899329299992, 58.141058661000045],
              [-62.718861456999946, 58.144232489000046],
              [-62.7141820949999, 58.144598700000074],
              [-62.68114173099991, 58.13462962400007],
              [-62.66559811099995, 58.12754954600007],
              [-62.651234503999945, 58.12384674700007],
              [-62.63341223899994, 58.127386786000045],
              [-62.615345831999946, 58.13934967700004],
              [-62.59780839799993, 58.15477122600004],
              [-62.58116614499994, 58.165269273000035],
              [-62.5657445949999, 58.162095445000034],
              [-62.560536261999914, 58.14862702000005],
              [-62.55899003799993, 58.133653062000064],
              [-62.55211341099994, 58.129339911000045],
              [-62.53099524599992, 58.14789459800005],
              [-62.52570553299995, 58.156358140000066],
              [-62.5247289699999, 58.16246165600006],
              [-62.52171790299991, 58.16828034100007],
              [-62.51048743399991, 58.175848700000074],
              [-62.47101803299995, 58.18219635600008],
              [-62.46206620999993, 58.18199290600006],
              [-62.45099850199995, 58.16779205900008],
              [-62.46532141799992, 58.15131256700005],
              [-62.52415930899991, 58.11017487200007],
              [-62.529408331999946, 58.103216864000046],
              [-62.53099524599992, 58.09324778900003],
              [-62.525380011999914, 58.08751048400006],
              [-62.51537024599992, 58.081732489000046],
              [-62.509755011999914, 58.07489655200004],
              [-62.51732337099992, 58.06598541900007],
              [-62.51732337099992, 58.05853913000004],
              [-62.49632727799991, 58.05992259300007],
              [-62.49083411399994, 58.06976959800005],
              [-62.49176998599995, 58.08262767100007],
              [-62.49006100199995, 58.09324778900003],
              [-62.479725714999915, 58.10191478100006],
              [-62.4661352199999, 58.10773346600007],
              [-62.45067298099991, 58.11127350500004],
              [-62.39598548099991, 58.11481354400007],
              [-62.37669837099992, 58.11290110900006],
              [-62.3665258449999, 58.10687897300005],
              [-62.37132727799991, 58.09625885600008],
              [-62.39020748599995, 58.090684312000064],
              [-62.428578253999945, 58.08641185100004],
              [-62.38703365799995, 58.07212962400007],
              [-62.3958227199999, 58.05963776200008],
              [-62.391184048999946, 58.051988023000035],
              [-62.37848873599995, 58.051947333000044],
              [-62.36310787699995, 58.06224192900004],
              [-62.344593878999945, 58.071478583000044],
              [-62.32689368399991, 58.06464264500005],
              [-62.31285559799994, 58.04877350500004],
              [-62.30504309799994, 58.03119538000004],
              [-62.32689368399991, 58.02696360900006],
              [-62.366444464999915, 58.00523509300007],
              [-62.38703365799995, 57.99766673400006],
              [-62.41828365799995, 57.99705638200004],
              [-62.47866777299993, 58.009833075000074],
              [-62.51048743399991, 58.01133860900006],
              [-62.5344945949999, 58.00568268400008],
              [-62.65562903599994, 57.94867584800005],
              [-62.67495683499993, 57.935614325000074],
              [-62.64391028599994, 57.937933661000045],
              [-62.59239661399994, 57.96344635600008],
              [-62.56200110599991, 57.96971263200004],
              [-62.48664303299995, 57.976548570000034],
              [-62.46934973899994, 57.97435130400004],
              [-62.43809973899994, 57.96519603100006],
              [-62.421131964999915, 57.96356842700004],
              [-62.42959550699993, 57.94904205900008],
              [-62.427723761999914, 57.93073151200008],
              [-62.42345130099994, 57.91498444200005],
              [-62.42487545499995, 57.908270575000074],
              [-62.42760169199994, 57.89996979400007],
              [-62.42796790299991, 57.88336823100008],
              [-62.420765753999945, 57.87067291900007],
              [-62.40062415299991, 57.87413157800006],
              [-62.39232337099992, 57.88373444200005],
              [-62.38585364499994, 57.89935944200005],
              [-62.37734941299993, 57.94977448100008],
              [-62.369211391999954, 57.96141185100004],
              [-62.3391820949999, 57.98399485900006],
              [-62.32774817599994, 57.96784088700008],
              [-62.32494055899991, 57.945746161000045],
              [-62.330962693999936, 57.92552317900004],
              [-62.34601803299995, 57.91510651200008],
              [-62.32408606699994, 57.909043687000064],
              [-62.304758266999954, 57.92051829600007],
              [-62.27774003799993, 57.956732489000046],
              [-62.266835089999915, 57.95001862200007],
              [-62.24258378799993, 57.944566148000035],
              [-62.23302161399994, 57.93931712400007],
              [-62.22671464799993, 57.93048737200007],
              [-62.22301184799994, 57.92206452000005],
              [-62.21833248599995, 57.914496161000045],
              [-62.20885169199994, 57.908270575000074],
              [-62.2005102199999, 57.934800523000035],
              [-62.19517981699994, 57.943060614000046],
              [-62.15733801999994, 57.97313060100004],
              [-62.14085852799991, 57.97825755400004],
              [-62.121937628999945, 57.96906159100007],
              [-62.103627081999946, 57.955918687000064],
              [-62.08901933499993, 57.949286200000074],
              [-62.08153235599991, 57.946966864000046],
              [-62.076283331999946, 57.941107489000046],
              [-62.07323157499991, 57.933294989000046],
              [-62.07013912699995, 57.911810614000046],
              [-62.066517706999946, 57.90497467700004],
              [-62.0657445949999, 57.89891185100004],
              [-62.072336391999954, 57.88780345300006],
              [-62.08824622299994, 57.87437571800007],
              [-62.12718665299991, 57.85179271000004],
              [-62.14053300699993, 57.833197333000044],
              [-62.1341039699999, 57.83075592700004],
              [-62.12962805899991, 57.82713450700004],
              [-62.12539628799993, 57.82306549700007],
              [-62.11945553299995, 57.81891510600008],
              [-62.11872311099995, 57.79747142100007],
              [-62.08116614499994, 57.78961823100008],
              [-62.03473873599995, 57.78693268400008],
              [-62.0071508449999, 57.781358140000066],
              [-61.962961391999954, 57.73505280200004],
              [-61.950062628999945, 57.70917389500005],
              [-61.96861731699994, 57.69599030200004],
              [-61.96861731699994, 57.68854401200008],
              [-61.905181443999936, 57.67247142100007],
              [-61.89415442599994, 57.67182038000004],
              [-61.89297441299993, 57.661322333000044],
              [-61.88784745999993, 57.64838288000004],
              [-61.886708136999914, 57.63764069200005],
              [-61.889881964999915, 57.624986070000034],
              [-61.898101365999935, 57.62169017100007],
              [-61.90933183499993, 57.62217845300006],
              [-61.92145748599995, 57.62091705900008],
              [-61.97398841099994, 57.606675523000035],
              [-62.03856360599991, 57.597642320000034],
              [-62.05744381399995, 57.58824290600006],
              [-62.06859290299991, 57.58612702000005],
              [-62.07681230399993, 57.58222077000005],
              [-62.07534745999993, 57.57282135600008],
              [-62.07144120999993, 57.56150950700004],
              [-62.072336391999954, 57.552069403000075],
              [-62.08967037699995, 57.54075755400004],
              [-62.115345831999946, 57.53461334800005],
              [-62.164173956999946, 57.53156159100007],
              [-62.24372311099995, 57.544989325000074],
              [-62.27033443899995, 57.538397528000075],
              [-62.28921464799993, 57.52362702000005],
              [-62.328684048999946, 57.466050523000035],
              [-62.3489477199999, 57.45774974200003],
              [-62.37413489499994, 57.46320221600007],
              [-62.421131964999915, 57.48309967700004],
              [-62.51610266799992, 57.508978583000044],
              [-62.54466712099992, 57.511053778000075],
              [-62.53368079299992, 57.49603913000004],
              [-62.51504472599993, 57.48309967700004],
              [-62.46955318899995, 57.46263255400004],
              [-62.414906378999945, 57.44896067900004],
              [-62.40387936099995, 57.44310130400004],
              [-62.38634192599994, 57.430853583000044],
              [-62.377064581999946, 57.42853424700007],
              [-62.315012173999946, 57.42853424700007],
              [-62.30138098899994, 57.431708075000074],
              [-62.27692623599995, 57.44578685100004],
              [-62.263783331999946, 57.44896067900004],
              [-62.21031653599994, 57.449326890000066],
              [-62.202015753999945, 57.45270416900007],
              [-62.19611568899995, 57.45954010600008],
              [-62.18224036399994, 57.46507396000004],
              [-62.16637122299994, 57.46857330900008],
              [-62.159372524999924, 57.46906159100007],
              [-62.13548743399991, 57.461004950000074],
              [-62.031320766999954, 57.45640696800007],
              [-61.900380011999914, 57.41547272300005],
              [-61.81704667899993, 57.377386786000045],
              [-61.804798956999946, 57.36705149900007],
              [-61.823475714999915, 57.35838450700004],
              [-61.92764238199993, 57.36705149900007],
              [-61.92764238199993, 57.360215562000064],
              [-61.88646399599992, 57.350816148000035],
              [-61.87149003799993, 57.34284088700008],
              [-61.87677975199995, 57.32892487200007],
              [-61.879017706999946, 57.31895579600007],
              [-61.873605923999946, 57.30695221600007],
              [-61.870757615999935, 57.293036200000074],
              [-61.88048255099994, 57.27765534100007],
              [-61.89395097599993, 57.27045319200005],
              [-61.93211829299992, 57.259019273000035],
              [-61.94505774599992, 57.257147528000075],
              [-62.02391516799992, 57.257147528000075],
              [-62.01866614499994, 57.24957916900007],
              [-62.01162675699993, 57.24298737200007],
              [-62.003163214999915, 57.238389390000066],
              [-61.99315344999991, 57.23668040600006],
              [-61.96556555899991, 57.23668040600006],
              [-61.962147589999915, 57.23456452000005],
              [-61.96271725199995, 57.22516510600008],
              [-61.959055141999954, 57.223089911000045],
              [-61.90672766799992, 57.219183661000045],
              [-61.88296464799993, 57.21002838700008],
              [-61.873036261999914, 57.19200267100007],
              [-61.86510169199994, 57.17064036700003],
              [-61.84675045499995, 57.17039622600004],
              [-61.81163489499994, 57.18829987200007],
              [-61.785267706999946, 57.19627513200004],
              [-61.77611243399991, 57.191107489000046],
              [-61.77794348899994, 57.17609284100007],
              [-61.78429114499994, 57.15477122600004],
              [-61.64924068899995, 57.23309967700004],
              [-61.61978105399993, 57.22992584800005],
              [-61.63076738199993, 57.22300853100006],
              [-61.67747962099992, 57.18390534100007],
              [-61.691517706999946, 57.17462799700007],
              [-61.69863847599993, 57.171576239000046],
              [-61.70075436099995, 57.16474030200004],
              [-61.69644120999993, 57.157904364000046],
              [-61.68439693899995, 57.15477122600004],
              [-61.52672278599994, 57.16120026200008],
              [-61.47179114499994, 57.15607330900008],
              [-61.4212133449999, 57.14109935100004],
              [-61.38190670499995, 57.121079820000034],
              [-61.36571204299992, 57.10687897300005],
              [-61.35912024599992, 57.08958567900004],
              [-61.36229407499991, 57.08002350500004],
              [-61.37637285099993, 57.06696198100008],
              [-61.37962805899991, 57.05516185100004],
              [-61.3762914699999, 57.04584381700005],
              [-61.35928300699993, 57.03302643400008],
              [-61.35228430899991, 57.02378978100006],
              [-61.35415605399993, 57.02423737200007],
              [-61.35488847599993, 57.01898834800005],
              [-61.354725714999915, 57.017564195000034],
              [-61.35505123599995, 57.016506252000056],
              [-61.36900794199994, 57.01121653900003],
              [-61.37067623599995, 57.00242747600004],
              [-61.361317511999914, 56.994208075000074],
              [-61.34483801999994, 56.98969147300005],
              [-61.349680141999954, 56.98114655200004],
              [-61.34984290299991, 56.97370026200008],
              [-61.34593665299991, 56.96759674700007],
              [-61.33869381399995, 56.962958075000074],
              [-61.34483801999994, 56.955511786000045],
              [-61.35724850199995, 56.96149323100008],
              [-61.37905839799993, 56.98126862200007],
              [-61.39321855399993, 56.98969147300005],
              [-61.41193600199995, 56.981756903000075],
              [-61.4290258449999, 56.980169989000046],
              [-61.46556555899991, 56.982855536000045],
              [-61.48428300699993, 56.98200104400007],
              [-61.50177975199995, 56.978949286000045],
              [-61.51903235599991, 56.97296784100007],
              [-61.53726152299993, 56.962958075000074],
              [-61.567290818999936, 56.92161692900004],
              [-61.575103318999936, 56.91453685100004],
              [-61.59211178299995, 56.91172923400006],
              [-61.61123613199993, 56.904405015000066],
              [-61.629465298999946, 56.89439524900007],
              [-61.643422003999945, 56.88353099200003],
              [-61.65147864499994, 56.86876048400006],
              [-61.64948482999995, 56.85529205900008],
              [-61.645375128999945, 56.84141673400006],
              [-61.64712480399993, 56.82579173400006],
              [-61.664173956999946, 56.80894603100006],
              [-61.68635006399995, 56.80919017100007],
              [-61.70860755099994, 56.81354401200008],
              [-61.726226365999935, 56.80878327000005],
              [-61.760609503999945, 56.79279205900008],
              [-61.80919348899994, 56.78851959800005],
              [-61.858265753999945, 56.79352448100008],
              [-61.89415442599994, 56.80536530200004],
              [-61.90465247299994, 56.79376862200007],
              [-61.90510006399995, 56.777451890000066],
              [-61.89818274599992, 56.76121653900003],
              [-61.886708136999914, 56.750067450000074],
              [-61.89720618399991, 56.738389390000066],
              [-61.90147864499994, 56.723822333000044],
              [-61.89830481699994, 56.71039459800005],
              [-61.886708136999914, 56.702337958000044],
              [-61.876210089999915, 56.723944403000075],
              [-61.86473548099991, 56.74127838700008],
              [-61.84715735599991, 56.75275299700007],
              [-61.818470831999946, 56.75690338700008],
              [-61.75080318899995, 56.751654364000046],
              [-61.720814581999946, 56.74327220300006],
              [-61.69493567599994, 56.72960032800006],
              [-61.71133378799993, 56.711045640000066],
              [-61.73192298099991, 56.70380280200004],
              [-61.75633704299992, 56.70404694200005],
              [-61.81407630099994, 56.71246979400007],
              [-61.81993567599994, 56.708970445000034],
              [-61.79051673099991, 56.68121979400007],
              [-61.77061926999994, 56.68785228100006],
              [-61.74718176999994, 56.67987702000005],
              [-61.72248287699995, 56.667669989000046],
              [-61.67162024599992, 56.655462958000044],
              [-61.65835527299993, 56.64215729400007],
              [-61.662668423999946, 56.628241278000075],
              [-61.68809973899994, 56.620347398000035],
              [-61.70250403599994, 56.62156810100004],
              [-61.74331620999993, 56.633978583000044],
              [-61.86888587099992, 56.63727448100008],
              [-61.90225175699993, 56.64317454600007],
              [-61.92764238199993, 56.65387604400007],
              [-61.89679928299995, 56.66852448100008],
              [-61.905140753999945, 56.67841217700004],
              [-61.92821204299992, 56.68199290600006],
              [-61.94131425699993, 56.67808665600006],
              [-61.95445716099994, 56.665269273000035],
              [-61.984445766999954, 56.66441478100006],
              [-62.03750566299993, 56.674994208000044],
              [-62.124663865999935, 56.70494212400007],
              [-62.237945115999935, 56.71625397300005],
              [-62.26414954299992, 56.72215403900003],
              [-62.34801184799994, 56.75287506700005],
              [-62.48387610599991, 56.77558014500005],
              [-62.50308183499993, 56.784857489000046],
              [-62.47899329299992, 56.79828522300005],
              [-62.30504309799994, 56.818426825000074],
              [-62.27407792899993, 56.827826239000046],
              [-62.26012122299994, 56.82843659100007],
              [-62.228179490999935, 56.81745026200008],
              [-62.04442298099991, 56.82579173400006],
              [-62.08869381399995, 56.84129466400003],
              [-62.33885657499991, 56.84629954600007],
              [-62.354074673999946, 56.84406159100007],
              [-62.38451087099992, 56.83429596600007],
              [-62.40062415299991, 56.832017320000034],
              [-62.42174231699994, 56.83458079600007],
              [-62.47573808499993, 56.85309479400007],
              [-62.49376380099994, 56.85460032800006],
              [-62.51268469999991, 56.852769273000035],
              [-62.53038489499994, 56.847723700000074],
              [-62.54466712099992, 56.83946360900006],
              [-62.554676886999914, 56.82725657800006],
              [-62.56135006399995, 56.814561265000066],
              [-62.56989498599995, 56.803941148000035],
              [-62.585601365999935, 56.79783763200004],
              [-62.56786048099991, 56.79596588700008],
              [-62.414906378999945, 56.75031159100007],
              [-62.35968990799995, 56.72215403900003],
              [-62.338734503999945, 56.71702708500004],
              [-62.28429114499994, 56.71198151200008],
              [-62.26720130099994, 56.70538971600007],
              [-62.24767005099994, 56.69505442900004],
              [-62.16759192599994, 56.67808665600006],
              [-62.09992428299995, 56.650824286000045],
              [-62.0071508449999, 56.633978583000044],
              [-61.95848548099991, 56.63507721600007],
              [-61.93468176999994, 56.63304271000004],
              [-61.914051886999914, 56.62653229400007],
              [-61.94017493399991, 56.61615631700005],
              [-62.24299068899995, 56.62653229400007],
              [-62.238392706999946, 56.62250397300005],
              [-62.23888098899994, 56.62091705900008],
              [-62.24299068899995, 56.620347398000035],
              [-62.02391516799992, 56.593003648000035],
              [-62.00096594999991, 56.58763255400004],
              [-61.91771399599992, 56.585638739000046],
              [-61.869699673999946, 56.593003648000035],
              [-61.85391191299993, 56.59039948100008],
              [-61.781809048999946, 56.56602610900006],
              [-61.769642706999946, 56.564520575000074],
              [-61.756418423999946, 56.56513092700004],
              [-61.74632727799991, 56.569647528000075],
              [-61.73534094999991, 56.57672760600008],
              [-61.72370357999995, 56.58055247600004],
              [-61.71202551999994, 56.575384833000044],
              [-61.699208136999914, 56.56122467700004],
              [-61.69237219999991, 56.55528392100007],
              [-61.68126380099994, 56.54840729400007],
              [-61.65884355399993, 56.53937409100007],
              [-61.65265865799995, 56.531683661000045],
              [-61.653960740999935, 56.51666901200008],
              [-61.66759192599994, 56.50328196800007],
              [-61.71397864499994, 56.50141022300005],
              [-61.75658118399991, 56.48582591400003],
              [-61.977406378999945, 56.51068756700005],
              [-62.036773240999935, 56.50804271000004],
              [-62.085926886999914, 56.49005768400008],
              [-62.085926886999914, 56.48322174700007],
              [-62.06330318899995, 56.48334381700005],
              [-62.020090298999946, 56.48961009300007],
              [-61.98509680899991, 56.489121812000064],
              [-61.969960089999915, 56.48725006700005],
              [-61.95616614499994, 56.48309967700004],
              [-61.94880123599995, 56.47569407800006],
              [-61.94806881399995, 56.46564362200007],
              [-61.95274817599994, 56.46308014500005],
              [-61.96043860599991, 56.46344635600008],
              [-62.01012122299994, 56.45286692900004],
              [-62.10342363199993, 56.45892975500004],
              [-62.147368943999936, 56.45526764500005],
              [-62.12547766799992, 56.44285716400003],
              [-62.10338294199994, 56.43439362200007],
              [-62.08104407499991, 56.42955149900007],
              [-61.97541256399995, 56.421861070000034],
              [-61.96247311099995, 56.42450592700004],
              [-61.953114386999914, 56.44220612200007],
              [-61.93268795499995, 56.43659088700008],
              [-61.91246497299994, 56.422308661000045],
              [-61.90379798099991, 56.41429271000004],
              [-61.84471594999991, 56.40973541900007],
              [-61.81395423099991, 56.40338776200008],
              [-61.79051673099991, 56.393784898000035],
              [-61.81590735599991, 56.38861725500004],
              [-61.845773891999954, 56.38703034100007],
              [-61.83023027299993, 56.37689850500004],
              [-61.77684485599991, 56.35968659100007],
              [-61.77285722599993, 56.35521067900004],
              [-61.77090410099993, 56.34943268400008],
              [-61.76675370999993, 56.34361399900007],
              [-61.756418423999946, 56.339178778000075],
              [-61.74754798099991, 56.33942291900007],
              [-61.72642981699994, 56.344916083000044],
              [-61.71544348899994, 56.345404364000046],
              [-61.71544348899994, 56.339178778000075],
              [-61.73534094999991, 56.33336009300007],
              [-61.74331620999993, 56.33234284100007],
              [-61.719960089999915, 56.32416413000004],
              [-61.66539466099994, 56.32807038000004],
              [-61.63963782499991, 56.32554759300007],
              [-61.622710740999935, 56.31810130400004],
              [-61.60562089799993, 56.30683014500005],
              [-61.59707597599993, 56.29441966400003],
              [-61.605539516999954, 56.28392161700003],
              [-61.62669837099992, 56.28367747600004],
              [-61.768462693999936, 56.31309642100007],
              [-61.79625403599994, 56.31317780200004],
              [-61.81786048099991, 56.30442942900004],
              [-61.79918372299994, 56.29783763200004],
              [-61.66075598899994, 56.277777411000045],
              [-61.66075598899994, 56.27094147300005],
              [-61.74828040299991, 56.25633372600004],
              [-61.796538865999935, 56.25682200700004],
              [-61.83145097599993, 56.27094147300005],
              [-61.78807532499991, 56.26915110900006],
              [-61.767567511999914, 56.272650458000044],
              [-61.756418423999946, 56.28392161700003],
              [-61.77635657499991, 56.290228583000044],
              [-61.8274633449999, 56.297308661000045],
              [-61.907460089999915, 56.29551829600007],
              [-61.94688880099994, 56.28685130400004],
              [-61.96556555899991, 56.28656647300005],
              [-61.98338782499991, 56.291001695000034],
              [-62.00031490799995, 56.30133698100008],
              [-62.01793372299994, 56.30894603100006],
              [-62.0384008449999, 56.30845774900007],
              [-62.07848059799994, 56.29820384300007],
              [-62.06720943899995, 56.28546784100007],
              [-62.04629472599993, 56.27374909100007],
              [-62.004017706999946, 56.25726959800005],
              [-62.016184048999946, 56.248480536000045],
              [-62.00890051999994, 56.24046458500004],
              [-61.93529212099992, 56.21735260600008],
              [-61.91445878799993, 56.21662018400008],
              [-61.88223222599993, 56.234361070000034],
              [-61.86668860599991, 56.23224518400008],
              [-61.850819464999915, 56.22601959800005],
              [-61.835194464999915, 56.22247955900008],
              [-61.798085089999915, 56.223822333000044],
              [-61.76317298099991, 56.22931549700007],
              [-61.77228756399995, 56.21381256700005],
              [-61.77684485599991, 56.20884837400007],
              [-61.72280839799993, 56.20884837400007],
              [-61.71165930899991, 56.21202220300006],
              [-61.691070115999935, 56.220770575000074],
              [-61.67756100199995, 56.22247955900008],
              [-61.59923255099994, 56.22361888200004],
              [-61.59251868399991, 56.22247955900008],
              [-61.58653723899994, 56.21893952000005],
              [-61.58267167899993, 56.21458567900004],
              [-61.58031165299991, 56.21076080900008],
              [-61.57884680899991, 56.20884837400007],
              [-61.55772864499994, 56.201157945000034],
              [-61.54702714799993, 56.200384833000044],
              [-61.43455969999991, 56.21381256700005],
              [-61.40314693899995, 56.22321198100008],
              [-61.37279212099992, 56.22882721600007],
              [-61.34483801999994, 56.22247955900008],
              [-61.34483801999994, 56.21629466400003],
              [-61.35228430899991, 56.20575592700004],
              [-61.34439042899993, 56.19664134300007],
              [-61.33433997299994, 56.187933661000045],
              [-61.335194464999915, 56.17808665600006],
              [-61.34996497299994, 56.17369212400007],
              [-61.37173417899993, 56.17283763200004],
              [-61.391509568999936, 56.16941966400003],
              [-61.400054490999935, 56.15733470300006],
              [-61.403960740999935, 56.14109935100004],
              [-61.409413214999915, 56.13231028900003],
              [-61.40672766799992, 56.12999095300006],
              [-61.38646399599992, 56.13312409100007],
              [-61.37718665299991, 56.13646067900004],
              [-61.36986243399991, 56.14122142100007],
              [-61.361317511999914, 56.14557526200008],
              [-61.348540818999936, 56.14740631700005],
              [-61.33926347599993, 56.144598700000074],
              [-61.33958899599992, 56.13825104400007],
              [-61.345366990999935, 56.13133372600004],
              [-61.35228430899991, 56.12689850500004],
              [-61.35228430899991, 56.11945221600007],
              [-61.33861243399991, 56.111029364000046],
              [-61.34829667899993, 56.10297272300005],
              [-61.42601477799991, 56.082017320000034],
              [-61.443918423999946, 56.07257721600007],
              [-61.45531165299991, 56.05805084800005],
              [-61.425038214999915, 56.050116278000075],
              [-61.400380011999914, 56.050482489000046],
              [-61.34483801999994, 56.06480540600006],
              [-61.319976365999935, 56.06720612200007],
              [-61.291086391999954, 56.06403229400007],
              [-61.26158606699994, 56.055894273000035],
              [-61.23497473899994, 56.04376862200007],
              [-61.28189042899993, 56.04559967700004],
              [-61.30532792899993, 56.04405345300006],
              [-61.32559160099993, 56.037543036000045],
              [-61.31232662699995, 56.032538153000075],
              [-61.29873613199993, 56.03062571800007],
              [-61.270375128999945, 56.03070709800005],
              [-61.270375128999945, 56.02448151200008],
              [-61.39834550699993, 56.03270091400003],
              [-61.46812903599994, 56.029730536000045],
              [-61.50308183499993, 56.010199286000045],
              [-61.47443600199995, 56.01048411700003],
              [-61.451934373999904, 56.007066148000035],
              [-61.43915768099993, 56.005113023000035],
              [-61.38304602799991, 55.99656810100004],
              [-61.37987219999991, 55.993353583000044],
              [-61.37877356699994, 55.986314195000034],
              [-61.37987219999991, 55.97923411700003],
              [-61.38304602799991, 55.97614166900007],
              [-61.39317786399994, 55.976670640000066],
              [-61.40151933499993, 55.97813548400006],
              [-61.413726365999935, 55.98228587400007],
              [-61.41828365799995, 55.988389390000066],
              [-61.4280085929999, 55.99559153900003],
              [-61.43659420499995, 55.998561916000085],
              [-61.44721432199992, 56.00230540600006],
              [-61.45498613199993, 56.00307851800005],
              [-61.462147589999915, 56.00275299700007],
              [-61.46141516799992, 55.99103424700007],
              [-61.44713294199994, 55.980576890000066],
              [-61.41746985599991, 55.96552155200004],
              [-61.40274003799993, 55.95990631700005],
              [-61.34544837099992, 55.96930573100008],
              [-61.262928839999915, 55.96930573100008],
              [-61.242746548999946, 55.966782945000034],
              [-61.229725714999915, 55.96271393400008],
              [-61.20148678299995, 55.94818756700005],
              [-61.17658443899995, 55.97606028900003],
              [-61.13898678299995, 55.97215403900003],
              [-61.10008704299992, 55.95136139500005],
              [-61.071156378999945, 55.92829010600008],
              [-61.07603919199994, 55.92059967700004],
              [-61.07884680899991, 55.91205475500004],
              [-61.07970130099994, 55.902777411000045],
              [-61.07852128799993, 55.89288971600007],
              [-61.10187740799995, 55.90001048400006],
              [-61.13805091099994, 55.90143463700008],
              [-61.17332923099991, 55.89862702000005],
              [-61.19399980399993, 55.89288971600007],
              [-61.19326738199993, 55.87962474200003],
              [-61.16588294199994, 55.86961497600004],
              [-61.11953691299993, 55.859442450000074],
              [-61.098500128999945, 55.84833405200004],
              [-61.06590735599991, 55.84955475500004],
              [-60.94546464799993, 55.870306708000044],
              [-60.93394934799994, 55.86994049700007],
              [-60.91624915299991, 55.86351146000004],
              [-60.89586341099994, 55.86041901200008],
              [-60.78160559799994, 55.85968659100007],
              [-60.74681555899991, 55.85016510600008],
              [-60.728505011999914, 55.82526276200008],
              [-60.735991990999935, 55.800034898000035],
              [-60.7610570949999, 55.78086985900006],
              [-60.81786048099991, 55.75641510600008],
              [-60.87267005099994, 55.75267161700003],
              [-60.89297441299993, 55.74949778900003],
              [-60.949289516999954, 55.755072333000044],
              [-60.96865800699993, 55.74949778900003],
              [-60.95616614499994, 55.74567291900007],
              [-60.95018469999991, 55.742621161000045],
              [-60.94762122299994, 55.73961009300007],
              [-60.943918423999946, 55.729803778000075],
              [-60.93545488199993, 55.72984446800007],
              [-60.92027747299994, 55.73651764500005],
              [-60.90501868399991, 55.73663971600007],
              [-60.86229407499991, 55.74274323100008],
              [-60.77179928299995, 55.735541083000044],
              [-60.74901282499991, 55.73651764500005],
              [-60.72614498599995, 55.74762604400007],
              [-60.69640051999994, 55.76976146000004],
              [-60.67064368399991, 55.79486725500004],
              [-60.653960740999935, 55.82530345300006],
              [-60.64085852799991, 55.82794830900008],
              [-60.61554928299995, 55.82526276200008],
              [-60.60195878799993, 55.819566148000035],
              [-60.60659745999993, 55.806626695000034],
              [-60.62608801999994, 55.78302643400008],
              [-60.61388098899994, 55.77362702000005],
              [-60.60716712099992, 55.75470612200007],
              [-60.60655676999994, 55.73301829600007],
              [-60.61241614499994, 55.71539948100008],
              [-60.605580206999946, 55.71470774900007],
              [-60.596547003999945, 55.71039459800005],
              [-60.59137936099995, 55.70856354400007],
              [-60.60216223899994, 55.69883860900006],
              [-60.614898240999935, 55.690293687000064],
              [-60.62877356699994, 55.68419017100007],
              [-60.642567511999914, 55.68187083500004],
              [-60.656239386999914, 55.67637767100007],
              [-60.65705318899995, 55.664170640000066],
              [-60.64891516799992, 55.65196360900006],
              [-60.6360570949999, 55.646551825000074],
              [-60.63125566299993, 55.64044830900008],
              [-60.63735917899993, 55.627020575000074],
              [-60.65343176999994, 55.605536200000074],
              [-60.67711341099994, 55.58930084800005],
              [-60.68512936099995, 55.578558661000045],
              [-60.681304490999935, 55.564561265000066],
              [-60.63267981699994, 55.61212799700007],
              [-60.61554928299995, 55.619208075000074],
              [-60.60220292899993, 55.62787506700005],
              [-60.58999589799993, 55.648138739000046],
              [-60.57144120999993, 55.68809642100007],
              [-60.54727128799993, 55.72593821800007],
              [-60.53551184799994, 55.738267320000034],
              [-60.53075110599991, 55.746161200000074],
              [-60.53010006399995, 55.75409577000005],
              [-60.530506964999915, 55.766913153000075],
              [-60.52379309799994, 55.78656647300005],
              [-60.507923956999946, 55.804022528000075],
              [-60.48961341099994, 55.81049225500004],
              [-60.47524980399993, 55.79734935100004],
              [-60.463002081999946, 55.80158112200007],
              [-60.4524633449999, 55.79368724200003],
              [-60.44041907499991, 55.782538153000075],
              [-60.42373613199993, 55.77684153900003],
              [-60.41844641799992, 55.77912018400008],
              [-60.40562903599994, 55.78880442900004],
              [-60.39952551999994, 55.79047272300005],
              [-60.390614386999914, 55.78668854400007],
              [-60.38190670499995, 55.779730536000045],
              [-60.37222245999993, 55.77000560100004],
              [-60.35704505099994, 55.77448151200008],
              [-60.34390214799993, 55.78257884300007],
              [-60.33470618399991, 55.78196849200003],
              [-60.331288214999915, 55.76007721600007],
              [-60.38589433499993, 55.72284577000005],
              [-60.37222245999993, 55.71539948100008],
              [-60.376942511999914, 55.71076080900008],
              [-60.38194739499994, 55.70408763200004],
              [-60.38589433499993, 55.70111725500004],
              [-60.37344316299993, 55.69135163000004],
              [-60.375111456999946, 55.68549225500004],
              [-60.38646399599992, 55.68268463700008],
              [-60.41832434799994, 55.67963288000004],
              [-60.454741990999935, 55.66986725500004],
              [-60.471547003999945, 55.66758860900006],
              [-60.49351966099994, 55.66010163000004],
              [-60.51219641799992, 55.64130280200004],
              [-60.525380011999914, 55.61676666900007],
              [-60.530506964999915, 55.591905015000066],
              [-60.50499426999994, 55.61204661700003],
              [-60.47118079299992, 55.630194403000075],
              [-60.43431555899991, 55.634466864000046],
              [-60.39952551999994, 55.612982489000046],
              [-60.39439856699994, 55.58506907800006],
              [-60.411366339999915, 55.55455149900007],
              [-60.454741990999935, 55.503119208000044],
              [-60.428578253999945, 55.51080963700008],
              [-60.40099036399994, 55.53034088700008],
              [-60.35484778599994, 55.57514069200005],
              [-60.34089107999995, 55.58270905200004],
              [-60.326283331999946, 55.583197333000044],
              [-60.319243943999936, 55.57611725500004],
              [-60.3372289699999, 55.54779694200005],
              [-60.33389238199993, 55.539903062000064],
              [-60.3216039699999, 55.53497955900008],
              [-60.3040258449999, 55.530462958000044],
              [-60.30650794199994, 55.51935455900008],
              [-60.308583136999914, 55.51361725500004],
              [-60.31078040299991, 55.50934479400007],
              [-60.332875128999945, 55.51850006700005],
              [-60.34333248599995, 55.51597728100006],
              [-60.35114498599995, 55.50523509300007],
              [-60.36538652299993, 55.489447333000044],
              [-60.38654537699995, 55.47492096600007],
              [-60.454741990999935, 55.44786204600007],
              [-60.454741990999935, 55.44102610900006],
              [-60.44493567599994, 55.43577708500004],
              [-60.44322669199994, 55.429022528000075],
              [-60.44717363199993, 55.42145416900007],
              [-60.454741990999935, 55.413763739000046],
              [-60.44399980399993, 55.40216705900008],
              [-60.451161261999914, 55.384833075000074],
              [-60.482085740999935, 55.35228099200003],
              [-60.46007239499994, 55.356634833000044],
              [-60.441477016999954, 55.368475653000075],
              [-60.41323808499993, 55.400091864000046],
              [-60.42845618399991, 55.415269273000035],
              [-60.41893469999991, 55.42767975500004],
              [-60.37970943899995, 55.44786204600007],
              [-60.34813391799992, 55.48236725500004],
              [-60.32770748599995, 55.49481842700004],
              [-60.3040258449999, 55.489447333000044],
              [-60.311756964999915, 55.48700592700004],
              [-60.331288214999915, 55.475816148000035],
              [-60.33023027299993, 55.46771881700005],
              [-60.35529537699995, 55.44635651200008],
              [-60.36538652299993, 55.434881903000075],
              [-60.35334225199995, 55.43431224200003],
              [-60.343006964999915, 55.437567450000074],
              [-60.33531653599994, 55.444566148000035],
              [-60.331288214999915, 55.45530833500004],
              [-60.315297003999945, 55.44122955900008],
              [-60.30622311099995, 55.43663157800006],
              [-60.29369055899991, 55.434881903000075],
              [-60.283762173999946, 55.440619208000044],
              [-60.28359941299993, 55.45392487200007],
              [-60.290272589999915, 55.47923411700003],
              [-60.27944902299993, 55.501206773000035],
              [-60.254017706999946, 55.50495026200008],
              [-60.22447669199994, 55.49839915600006],
              [-60.20156816299993, 55.489447333000044],
              [-60.20946204299992, 55.47398509300007],
              [-60.21458899599992, 55.46836985900006],
              [-60.207102016999954, 55.46336497600004],
              [-60.2044164699999, 55.45697663000004],
              [-60.206695115999935, 55.44940827000005],
              [-60.21458899599992, 55.44102610900006],
              [-60.199777798999946, 55.435980536000045],
              [-60.19408118399991, 55.434881903000075],
              [-60.19408118399991, 55.427435614000046],
              [-60.19713294199994, 55.42540110900006],
              [-60.20156816299993, 55.421210028000075],
              [-60.22956295499995, 55.427801825000074],
              [-60.26854407499991, 55.42145416900007],
              [-60.36241614499994, 55.39044830900008],
              [-60.374663865999935, 55.38068268400008],
              [-60.382923956999946, 55.345770575000074],
              [-60.39110266799992, 55.33392975500004],
              [-60.41323808499993, 55.31134674700007],
              [-60.391468878999945, 55.305121161000045],
              [-60.403960740999935, 55.292181708000044],
              [-60.42808997299994, 55.28278229400007],
              [-60.44115149599992, 55.287095445000034],
              [-60.44371497299994, 55.29242584800005],
              [-60.45026607999995, 55.295762437000064],
              [-60.45889238199993, 55.29734935100004],
              [-60.46784420499995, 55.29706452000005],
              [-60.466908331999946, 55.29328034100007],
              [-60.49644934799994, 55.27326080900008],
              [-60.50255286399994, 55.270371812000064],
              [-60.505970831999946, 55.263739325000074],
              [-60.50853430899991, 55.24664948100008],
              [-60.51280676999994, 55.23899974200003],
              [-60.528553839999915, 55.22528717700004],
              [-60.534413214999915, 55.216864325000074],
              [-60.53673255099994, 55.20490143400008],
              [-60.54718990799995, 55.19806549700007],
              [-60.61241614499994, 55.16791413000004],
              [-60.56818600199995, 55.182074286000045],
              [-60.49209550699993, 55.226263739000046],
              [-60.45815995999993, 55.235581773000035],
              [-60.44994055899991, 55.23191966400003],
              [-60.44163977799991, 55.22492096600007],
              [-60.43297278599994, 55.220811265000066],
              [-60.42373613199993, 55.22565338700008],
              [-60.4075414699999, 55.24872467700004],
              [-60.39663652299993, 55.25873444200005],
              [-60.382801886999914, 55.262925523000035],
              [-60.35533606699994, 55.259100653000075],
              [-60.35997473899994, 55.24961985900006],
              [-60.41226152299993, 55.214178778000075],
              [-60.452015753999945, 55.198431708000044],
              [-60.46784420499995, 55.18842194200005],
              [-60.481312628999945, 55.17133209800005],
              [-60.50267493399991, 55.13434479400007],
              [-60.51622473899994, 55.11949290600006],
              [-60.536773240999935, 55.10761139500005],
              [-60.605580206999946, 55.08539459800005],
              [-60.65343176999994, 55.05731842700004],
              [-60.673898891999954, 55.05064524900007],
              [-60.673898891999954, 55.043809312000064],
              [-60.6614477199999, 55.03758372600004],
              [-60.66510982999995, 55.025498765000066],
              [-60.687570766999954, 54.995428778000075],
              [-60.67031816299993, 55.009833075000074],
              [-60.61241614499994, 55.036363023000035],
              [-60.574289516999954, 55.073553778000075],
              [-60.557199673999946, 55.08539459800005],
              [-60.537220831999946, 55.09239329600007],
              [-60.49323482999995, 55.10179271000004],
              [-60.47524980399993, 55.11273834800005],
              [-60.46157792899993, 55.15025462400007],
              [-60.457102016999954, 55.15485260600008],
              [-60.43492591099994, 55.16539134300007],
              [-60.42686926999994, 55.16791413000004],
              [-60.4075414699999, 55.168036200000074],
              [-60.39679928299995, 55.163763739000046],
              [-60.38744055899991, 55.16168854400007],
              [-60.37222245999993, 55.16791413000004],
              [-60.287098761999914, 55.23338450700004],
              [-60.26903235599991, 55.24298737200007],
              [-60.24974524599992, 55.25055573100008],
              [-60.22887122299994, 55.25608958500004],
              [-60.22378495999993, 55.254339911000045],
              [-60.21825110599991, 55.24994538000004],
              [-60.21198482999995, 55.24778880400004],
              [-60.20466061099995, 55.252386786000045],
              [-60.19517981699994, 55.263373114000046],
              [-60.189523891999954, 55.26829661700003],
              [-60.17202714799993, 55.27525462400007],
              [-60.16344153599994, 55.28461334800005],
              [-60.15404212099992, 55.290228583000044],
              [-60.139515753999945, 55.28400299700007],
              [-60.17365475199995, 55.24241771000004],
              [-60.16966712099992, 55.231634833000044],
              [-60.17479407499991, 55.219916083000044],
              [-60.19408118399991, 55.194647528000075],
              [-60.17064368399991, 55.20408763200004],
              [-60.13414466099994, 55.235581773000035],
              [-60.08739173099991, 55.24860260600008],
              [-60.04820716099994, 55.273545640000066],
              [-60.02281653599994, 55.276556708000044],
              [-60.02920488199993, 55.261419989000046],
              [-60.04234778599994, 55.25377024900007],
              [-60.057525193999936, 55.247259833000044],
              [-60.07054602799991, 55.235581773000035],
              [-60.076161261999914, 55.22370026200008],
              [-60.08336341099994, 55.20075104400007],
              [-60.091053839999915, 55.18842194200005],
              [-60.17593339799993, 55.12396881700005],
              [-60.18789628799993, 55.09906647300005],
              [-60.19408118399991, 55.09906647300005],
              [-60.216867641999954, 55.105576890000066],
              [-60.25226803299995, 55.08653392100007],
              [-60.28429114499994, 55.054795640000066],
              [-60.29710852799991, 55.02338288000004],
              [-60.286366339999915, 55.02875397300005],
              [-60.20140540299991, 55.08751048400006],
              [-60.10757402299993, 55.13385651200008],
              [-60.098500128999945, 55.14008209800005],
              [-60.08861243399991, 55.15147532800006],
              [-60.0755102199999, 55.17365143400008],
              [-60.04043535099993, 55.21857330900008],
              [-60.03087317599994, 55.22296784100007],
              [-60.02086341099994, 55.22418854400007],
              [-60.01622473899994, 55.22691478100006],
              [-60.02281653599994, 55.235581773000035],
              [-59.99644934799994, 55.243475653000075],
              [-59.93919837099992, 55.23541901200008],
              [-59.912953253999945, 55.24241771000004],
              [-59.920033331999946, 55.25413646000004],
              [-59.91828365799995, 55.262925523000035],
              [-59.90957597599993, 55.268418687000064],
              [-59.896148240999935, 55.270371812000064],
              [-59.88499915299991, 55.273504950000074],
              [-59.87775631399995, 55.28086985900006],
              [-59.87205969999991, 55.28965892100007],
              [-59.86571204299992, 55.29706452000005],
              [-59.84703528599994, 55.309881903000075],
              [-59.82412675699993, 55.32200755400004],
              [-59.799672003999945, 55.33038971600007],
              [-59.77635657499991, 55.33185455900008],
              [-59.77379309799994, 55.316514390000066],
              [-59.75743567599994, 55.29901764500005],
              [-59.76207434799994, 55.290269273000035],
              [-59.755848761999914, 55.28400299700007],
              [-59.76207434799994, 55.28400299700007],
              [-59.75816809799994, 55.28070709800005],
              [-59.75560462099992, 55.27903880400004],
              [-59.74840247299994, 55.276556708000044],
              [-59.73477128799993, 55.292222398000035],
              [-59.72020423099991, 55.27423737200007],
              [-59.71642005099994, 55.25230540600006],
              [-59.73542232999995, 55.25608958500004],
              [-59.73924719999991, 55.246201890000066],
              [-59.755848761999914, 55.221909898000035],
              [-59.744252081999946, 55.220811265000066],
              [-59.73680579299992, 55.21702708500004],
              [-59.73375403599994, 55.210638739000046],
              [-59.73542232999995, 55.20148346600007],
              [-59.741851365999935, 55.19481028900003],
              [-59.750111456999946, 55.195746161000045],
              [-59.76207434799994, 55.20148346600007],
              [-59.77513587099992, 55.19700755400004],
              [-59.78087317599994, 55.19330475500004],
              [-59.78579667899993, 55.18842194200005],
              [-59.80231686099995, 55.17767975500004],
              [-59.81883704299992, 55.169623114000046],
              [-59.848866339999915, 55.164048570000034],
              [-59.86994381399995, 55.15680573100008],
              [-59.89122473899994, 55.152329820000034],
              [-59.93455969999991, 55.161810614000046],
              [-59.959095831999946, 55.16120026200008],
              [-59.97447669199994, 55.155951239000046],
              [-59.96816972599993, 55.14683665600006],
              [-59.97565670499995, 55.14008209800005],
              [-59.96397864499994, 55.11713288000004],
              [-59.951283331999946, 55.12046946800007],
              [-59.93691972599993, 55.13532135600008],
              [-59.92031816299993, 55.14683665600006],
              [-59.9094945949999, 55.14606354400007],
              [-59.8977758449999, 55.14158763200004],
              [-59.88609778599994, 55.13886139500005],
              [-59.866118943999936, 55.147772528000075],
              [-59.86204993399991, 55.14085521000004],
              [-59.862212693999936, 55.129339911000045],
              [-59.86571204299992, 55.11949290600006],
              [-59.79995683499993, 55.11273834800005],
              [-59.787953253999945, 55.11749909100007],
              [-59.76512610599991, 55.14008209800005],
              [-59.755848761999914, 55.14683665600006],
              [-59.7356664699999, 55.15058014500005],
              [-59.6770727199999, 55.14683665600006],
              [-59.67072506399995, 55.14500560100004],
              [-59.66038977799991, 55.136053778000075],
              [-59.65221106699994, 55.13316478100006],
              [-59.643422003999945, 55.13353099200003],
              [-59.629017706999946, 55.138739325000074],
              [-59.60765540299991, 55.14350006700005],
              [-59.56407630099994, 55.16791413000004],
              [-59.5384008449999, 55.17723216400003],
              [-59.53612219999991, 55.183294989000046],
              [-59.53612219999991, 55.19806549700007],
              [-59.5305883449999, 55.214056708000044],
              [-59.51781165299991, 55.21434153900003],
              [-59.504017706999946, 55.20575592700004],
              [-59.49522864499994, 55.194647528000075],
              [-59.49364173099991, 55.17963288000004],
              [-59.49819902299993, 55.16693756700005],
              [-59.50133216099994, 55.154364325000074],
              [-59.49522864499994, 55.14008209800005],
              [-59.467355923999946, 55.15074290600006],
              [-59.44005286399994, 55.15184153900003],
              [-59.43004309799994, 55.14203522300005],
              [-59.45421301999994, 55.11949290600006],
              [-59.486317511999914, 55.100897528000075],
              [-59.49522864499994, 55.092230536000045],
              [-59.51406816299993, 55.067246812000064],
              [-59.524647589999915, 55.05853913000004],
              [-59.543039516999954, 55.05064524900007],
              [-59.54279537699995, 55.05182526200008],
              [-59.54865475199995, 55.052435614000046],
              [-59.55695553299995, 55.052069403000075],
              [-59.56407630099994, 55.05064524900007],
              [-59.62791907499991, 55.00055573100008],
              [-59.639230923999946, 54.995428778000075],
              [-59.64557857999995, 54.99571360900006],
              [-59.654408331999946, 54.99750397300005],
              [-59.66079667899993, 55.00018952000005],
              [-59.65965735599991, 55.00287506700005],
              [-59.68016516799992, 54.98920319200005],
              [-59.72252356699994, 54.974595445000034],
              [-59.73542232999995, 54.968085028000075],
              [-59.71812903599994, 54.955511786000045],
              [-59.73200436099995, 54.937201239000046],
              [-59.758656378999945, 54.92064036700003],
              [-59.80125891799992, 54.90733470300006],
              [-59.827788865999935, 54.89252350500004],
              [-59.85008704299992, 54.87457916900007],
              [-59.858306443999936, 54.85887278900003],
              [-59.852772589999915, 54.84471263200004],
              [-59.8450414699999, 54.84752024900007],
              [-59.83531653599994, 54.854356187000064],
              [-59.82412675699993, 54.851996161000045],
              [-59.82005774599992, 54.84080638200004],
              [-59.82770748599995, 54.83043040600006],
              [-59.83849036399994, 54.81976959800005],
              [-59.84398352799991, 54.80731842700004],
              [-59.85777747299994, 54.78986237200007],
              [-59.94766191299993, 54.75641510600008],
              [-59.921986456999946, 54.74323151200008],
              [-59.89976966099994, 54.746934312000064],
              [-59.87832597599993, 54.75694407800006],
              [-59.84398352799991, 54.76593659100007],
              [-59.81899980399993, 54.780462958000044],
              [-59.79198157499991, 54.786810614000046],
              [-59.7923070949999, 54.79437897300005],
              [-59.798898891999954, 54.804388739000046],
              [-59.80308997299994, 54.814520575000074],
              [-59.80211341099994, 54.85301341400003],
              [-59.79344641799992, 54.87596263200004],
              [-59.76667232999995, 54.88947174700007],
              [-59.74962317599994, 54.903998114000046],
              [-59.738840298999946, 54.90729401200008],
              [-59.69884192599994, 54.91425202000005],
              [-59.6907445949999, 54.91693756700005],
              [-59.67625891799992, 54.926947333000044],
              [-59.625559048999946, 54.94818756700005],
              [-59.44762122299994, 55.06195709800005],
              [-59.42731686099995, 55.06622955900008],
              [-59.41356360599991, 55.05756256700005],
              [-59.41323808499993, 55.03021881700005],
              [-59.39818274599992, 55.03986237200007],
              [-59.36485755099994, 55.09906647300005],
              [-59.30955969999991, 55.14683665600006],
              [-59.30890865799995, 55.15001048400006],
              [-59.30955969999991, 55.16425202000005],
              [-59.29283606699994, 55.17755768400008],
              [-59.28673255099994, 55.185980536000045],
              [-59.28294837099992, 55.19330475500004],
              [-59.27814693899995, 55.200425523000035],
              [-59.26866614499994, 55.208319403000075],
              [-59.25226803299995, 55.21588776200008],
              [-59.23289954299992, 55.219916083000044],
              [-59.216053839999915, 55.21820709800005],
              [-59.20718339799993, 55.208319403000075],
              [-59.218739386999914, 55.20197174700007],
              [-59.223866339999915, 55.192694403000075],
              [-59.22419186099995, 55.18109772300005],
              [-59.22150631399995, 55.16791413000004],
              [-59.20685787699995, 55.17735423400006],
              [-59.18854732999995, 55.19481028900003],
              [-59.17284094999991, 55.213324286000045],
              [-59.15977942599994, 55.238714911000045],
              [-59.14561926999994, 55.231634833000044],
              [-59.13158118399991, 55.21381256700005],
              [-59.12531490799995, 55.194647528000075],
              [-59.142648891999954, 55.154730536000045],
              [-59.18236243399991, 55.13133372600004],
              [-59.22789466099994, 55.11408112200007],
              [-59.26244055899991, 55.092230536000045],
              [-59.26805579299992, 55.08360423400006],
              [-59.27692623599995, 55.06549713700008],
              [-59.282866990999935, 55.05805084800005],
              [-59.293080206999946, 55.052801825000074],
              [-59.31798255099994, 55.045762437000064],
              [-59.38621985599991, 55.00458405200004],
              [-59.39281165299991, 54.98920319200005],
              [-59.38255774599992, 54.97801341400003],
              [-59.36595618399991, 54.989121812000064],
              [-59.34642493399991, 55.007066148000035],
              [-59.32762610599991, 55.01654694200005],
              [-59.30410722599993, 55.017645575000074],
              [-59.28221594999991, 55.02195872600004],
              [-59.26325436099995, 55.03034088700008],
              [-59.245350714999915, 55.04722728100006],
              [-59.24193274599992, 55.048529364000046],
              [-59.23859615799995, 55.049261786000045],
              [-59.23517818899995, 55.05064524900007],
              [-59.24083411399994, 55.07188548400006],
              [-59.22541256399995, 55.084051825000074],
              [-59.180531378999945, 55.09906647300005],
              [-59.16954505099994, 55.08030833500004],
              [-59.154286261999914, 55.074286200000074],
              [-59.14513098899994, 55.08055247600004],
              [-59.15257727799991, 55.09906647300005],
              [-59.14781653599994, 55.10846588700008],
              [-59.13975989499994, 55.11969635600008],
              [-59.12791907499991, 55.12726471600007],
              [-59.11164303299995, 55.12571849200003],
              [-59.0989477199999, 55.11505768400008],
              [-59.10171464799993, 55.103583075000074],
              [-59.10777747299994, 55.091498114000046],
              [-59.1048070949999, 55.07859935100004],
              [-59.080922003999945, 55.09642161700003],
              [-59.073475714999915, 55.10838450700004],
              [-59.07066809799994, 55.12946198100008],
              [-59.06407630099994, 55.14801666900007],
              [-59.04784094999991, 55.159491278000075],
              [-59.027414516999954, 55.16197337400007],
              [-59.00796464799993, 55.15367259300007],
              [-59.00523841099994, 55.14642975500004],
              [-59.00560462099992, 55.13666413000004],
              [-59.003895636999914, 55.12689850500004],
              [-58.99494381399995, 55.11949290600006],
              [-58.98940995999993, 55.12213776200008],
              [-58.97118079299992, 55.13666413000004],
              [-58.96385657499991, 55.14008209800005],
              [-58.95425370999993, 55.13108958500004],
              [-58.958241339999915, 55.11107005400004],
              [-58.97443600199995, 55.07859935100004],
              [-59.025949673999946, 55.01988353100006],
              [-59.04088294199994, 55.00657786700003],
              [-59.04478919199994, 54.99884674700007],
              [-59.03624426999994, 54.995428778000075],
              [-59.02953040299991, 54.99799225500004],
              [-59.016468878999945, 55.01109446800007],
              [-59.00796464799993, 55.01654694200005],
              [-58.99795488199993, 55.02008698100008],
              [-58.992298956999946, 55.020819403000075],
              [-58.98778235599991, 55.019517320000034],
              [-58.98127193899995, 55.01654694200005],
              [-58.980580206999946, 55.01402415600006],
              [-58.97443600199995, 54.99909088700008],
              [-58.97252356699994, 54.99595774900007],
              [-58.9622289699999, 54.99445221600007],
              [-58.95738684799994, 54.992295640000066],
              [-58.9426977199999, 54.98224518400008],
              [-58.90794837099992, 54.965277411000045],
              [-58.89248613199993, 54.954413153000075],
              [-58.90855872299994, 54.94428131700005],
              [-58.948109503999945, 54.935980536000045],
              [-58.96694902299993, 54.927720445000034],
              [-58.96080481699994, 54.927720445000034],
              [-58.97345943899995, 54.91893138200004],
              [-59.01545162699995, 54.89976634300007],
              [-59.01545162699995, 54.893011786000045],
              [-58.973500128999945, 54.89130280200004],
              [-58.96080481699994, 54.893011786000045],
              [-58.940297003999945, 54.89976634300007],
              [-58.93626868399991, 54.904364325000074],
              [-58.93472245999993, 54.91107819200005],
              [-58.93431555899991, 54.917222398000035],
              [-58.93346106699994, 54.92027415600006],
              [-58.90566972599993, 54.92247142100007],
              [-58.886708136999914, 54.911322333000044],
              [-58.8841039699999, 54.89781321800007],
              [-58.9055883449999, 54.893011786000045],
              [-58.900461391999954, 54.878119208000044],
              [-58.90611731699994, 54.87091705900008],
              [-58.91515051999994, 54.865342515000066],
              [-58.91978919199994, 54.855454820000034],
              [-58.91380774599992, 54.84821198100008],
              [-58.89997311099995, 54.84507884300007],
              [-58.83413652299993, 54.84271881700005],
              [-58.82359778599994, 54.84454987200007],
              [-58.81403561099995, 54.85016510600008],
              [-58.80736243399991, 54.855902411000045],
              [-58.79841061099995, 54.85777415600006],
              [-58.77090410099993, 54.846869208000044],
              [-58.76475989499994, 54.842637437000064],
              [-58.76211503799993, 54.83543528900003],
              [-58.76154537699995, 54.82127513200004],
              [-58.75829016799992, 54.809027411000045],
              [-58.7512914699999, 54.80292389500005],
              [-58.74429277299993, 54.804388739000046],
              [-58.73180091099994, 54.84247467700004],
              [-58.713002081999946, 54.84983958500004],
              [-58.69798743399991, 54.843858140000066],
              [-58.700103318999936, 54.83152903900003],
              [-58.68146725199995, 54.81854889500005],
              [-58.65217037699995, 54.809800523000035],
              [-58.597727016999954, 54.80365631700005],
              [-58.515736456999946, 54.80365631700005],
              [-58.54356848899994, 54.79148997600004],
              [-58.55508378799993, 54.783189195000034],
              [-58.56289628799993, 54.76947663000004],
              [-58.547718878999945, 54.771918036000045],
              [-58.52220618399991, 54.78160228100006],
              [-58.50523841099994, 54.78375885600008],
              [-58.43936113199993, 54.77692291900007],
              [-58.444203253999945, 54.76072825700004],
              [-58.43740800699993, 54.749986070000034],
              [-58.42235266799992, 54.74408600500004],
              [-58.40217037699995, 54.742173570000034],
              [-58.38695227799991, 54.747381903000075],
              [-58.39000403599994, 54.75999583500004],
              [-58.39818274599992, 54.77570221600007],
              [-58.398426886999914, 54.78998444200005],
              [-58.38634192599994, 54.79523346600007],
              [-58.20352128799993, 54.79743073100008],
              [-58.19444739499994, 54.79523346600007],
              [-58.18765214799993, 54.79059479400007],
              [-58.18529212099992, 54.78587474200003],
              [-58.189564581999946, 54.78375885600008],
              [-58.19908606699994, 54.77765534100007],
              [-58.19009355399993, 54.76414622600004],
              [-58.17341061099995, 54.749986070000034],
              [-58.1594945949999, 54.742173570000034],
              [-58.13849850199995, 54.73936595300006],
              [-58.023548956999946, 54.74274323100008],
              [-58.005523240999935, 54.73700592700004],
              [-58.008656378999945, 54.72166575700004],
              [-57.992176886999914, 54.716782945000034],
              [-57.97809811099995, 54.724717515000066],
              [-57.96275794199994, 54.73627350500004],
              [-57.94286048099991, 54.742173570000034],
              [-57.86481686099995, 54.74494049700007],
              [-57.8469945949999, 54.738714911000045],
              [-57.78954016799992, 54.693793036000045],
              [-57.787220831999946, 54.69025299700007],
              [-57.78774980399993, 54.686835028000075],
              [-57.78726152299993, 54.68345774900007],
              [-57.782093878999945, 54.68003978100006],
              [-57.77293860599991, 54.679022528000075],
              [-57.76622473899994, 54.68183014500005],
              [-57.760609503999945, 54.685614325000074],
              [-57.754790818999936, 54.687567450000074],
              [-57.74437415299991, 54.68931712400007],
              [-57.73680579299992, 54.69163646000004],
              [-57.729725714999915, 54.69013092700004],
              [-57.720692511999914, 54.68003978100006],
              [-57.7278539699999, 54.663316148000035],
              [-57.711496548999946, 54.64866771000004],
              [-57.68590247299994, 54.637925523000035],
              [-57.66755123599995, 54.63344961100006],
              [-57.61074785099993, 54.63975657800006],
              [-57.58031165299991, 54.63959381700005],
              [-57.57603919199994, 54.64317454600007],
              [-57.573475714999915, 54.64728424700007],
              [-57.56749426999994, 54.652777411000045],
              [-57.56069902299993, 54.657538153000075],
              [-57.55581620999993, 54.65961334800005],
              [-57.486439581999946, 54.65879954600007],
              [-57.44981848899994, 54.64935944200005],
              [-57.44627844999991, 54.62608470300006],
              [-57.43663489499994, 54.626206773000035],
              [-57.428293423999946, 54.62461985900006],
              [-57.412180141999954, 54.619248765000066],
              [-57.412180141999954, 54.61180247600004],
              [-57.41783606699994, 54.597723700000074],
              [-57.39956620999993, 54.59198639500005],
              [-57.353505011999914, 54.59137604400007],
              [-57.35041256399995, 54.58942291900007],
              [-57.34947669199994, 54.584824937000064],
              [-57.35008704299992, 54.574286200000074],
              [-57.353179490999935, 54.56675853100006],
              [-57.360585089999915, 54.56492747600004],
              [-57.36961829299992, 54.56537506700005],
              [-57.37743079299992, 54.56464264500005],
              [-57.39037024599992, 54.56073639500005],
              [-57.41698157499991, 54.55744049700007],
              [-57.43199622299994, 54.55719635600008],
              [-57.43199622299994, 54.55036041900007],
              [-57.405140753999945, 54.548529364000046],
              [-57.38320878799993, 54.54136790600006],
              [-57.37547766799992, 54.526678778000075],
              [-57.39102128799993, 54.501939195000034],
              [-57.41161048099991, 54.49131907800006],
              [-57.439442511999914, 54.487616278000075],
              [-57.65977942599994, 54.48863353100006],
              [-57.707020636999914, 54.47528717700004],
              [-57.68663489499994, 54.46556224200003],
              [-57.48302161399994, 54.46759674700007],
              [-57.45262610599991, 54.46788157800006],
              [-57.41901607999995, 54.461004950000074],
              [-57.43667558499993, 54.449326890000066],
              [-57.44985917899993, 54.45331452000005],
              [-57.462228969999956, 54.462998765000066],
              [-57.48407955599993, 54.46263255400004],
              [-57.50019283799992, 54.46381256700005],
              [-57.53075110599991, 54.453558661000045],
              [-57.541859503999945, 54.447333075000074],
              [-57.519195115999935, 54.43463776200008],
              [-57.53111731699994, 54.42475006700005],
              [-57.57290605399993, 54.41010163000004],
              [-57.587147589999915, 54.400498765000066],
              [-57.63385982999995, 54.38340892100007],
              [-57.65172278599994, 54.37909577000005],
              [-57.67833411399994, 54.37742747600004],
              [-57.76537024599992, 54.387152411000045],
              [-57.78465735599991, 54.391913153000075],
              [-57.795765753999945, 54.39207591400003],
              [-57.80638587099992, 54.38926829600007],
              [-57.824208136999914, 54.380967515000066],
              [-57.83674068899995, 54.37909577000005],
              [-57.84707597599993, 54.379339911000045],
              [-57.85456295499995, 54.38068268400008],
              [-57.86082923099991, 54.38373444200005],
              [-57.86778723899994, 54.38898346600007],
              [-57.87905839799993, 54.39337799700007],
              [-57.89159094999991, 54.391791083000044],
              [-57.90416419199994, 54.388006903000075],
              [-58.18614661399994, 54.358587958000044],
              [-58.187570766999954, 54.34446849200003],
              [-58.242298956999946, 54.32493724200003],
              [-58.26130123599995, 54.31016673400006],
              [-58.22052975199995, 54.31273021000004],
              [-58.13719641799992, 54.33148834800005],
              [-58.09740149599992, 54.33185455900008],
              [-58.11546790299991, 54.31932200700004],
              [-58.15900631399995, 54.30601634300007],
              [-58.179351365999935, 54.29718659100007],
              [-58.1946508449999, 54.30341217700004],
              [-58.21239173099991, 54.30133698100008],
              [-58.24762936099995, 54.290269273000035],
              [-58.242746548999946, 54.283270575000074],
              [-58.22911536399994, 54.267686265000066],
              [-58.22716223899994, 54.263006903000075],
              [-58.236317511999914, 54.25621165600006],
              [-58.25096594999991, 54.254339911000045],
              [-58.32485917899993, 54.25303782800006],
              [-58.4680883449999, 54.233628648000035],
              [-58.56289628799993, 54.20774974200003],
              [-58.68122311099995, 54.15704987200007],
              [-58.727406378999945, 54.145697333000044],
              [-58.87873287699995, 54.14728424700007],
              [-59.00157630099994, 54.12055084800005],
              [-59.130848761999914, 54.107407945000034],
              [-59.15461178299995, 54.10187409100007],
              [-59.18700110599991, 54.08685944200005],
              [-59.23424231699994, 54.08226146000004],
              [-59.26793372299994, 54.06671784100007],
              [-59.39830481699994, 54.04942454600007],
              [-59.41950436099995, 54.050116278000075],
              [-59.515695766999954, 54.063788153000075],
              [-59.55992591099994, 54.056748765000066],
              [-59.57966061099995, 54.05036041900007],
              [-59.58458411399994, 54.04389069200005],
              [-59.59142005099994, 54.04389069200005],
              [-59.58299719999991, 54.038397528000075],
              [-59.53233801999994, 54.02680084800005],
              [-59.52448482999995, 54.02635325700004],
              [-59.522368943999936, 54.02171458500004],
              [-59.52253170499995, 54.00535716400003],
              [-59.51081295499995, 54.001166083000044],
              [-59.44123287699995, 54.01597728100006],
              [-59.302845831999946, 54.01837799700007],
              [-59.12059485599991, 54.05487702000005],
              [-58.96422278599994, 54.074286200000074],
              [-58.818918423999946, 54.115220445000034],
              [-58.76895097599993, 54.12518952000005],
              [-58.74876868399991, 54.12669505400004],
              [-58.698109503999945, 54.12437571800007],
              [-58.68301347599993, 54.128973700000074],
              [-58.65269934799994, 54.14891185100004],
              [-58.57437089799993, 54.17560455900008],
              [-58.543080206999946, 54.19407786700003],
              [-58.53416907499991, 54.19159577000005],
              [-58.52603105399993, 54.19086334800005],
              [-58.51773027299993, 54.19171784100007],
              [-58.509022589999915, 54.19391510600008],
              [-58.496083136999914, 54.19358958500004],
              [-58.475493943999936, 54.19586823100008],
              [-58.45604407499991, 54.20066966400003],
              [-58.43936113199993, 54.20774974200003],
              [-58.41246497299994, 54.23069896000004],
              [-58.39488684799994, 54.23655833500004],
              [-58.371164516999954, 54.228216864000046],
              [-58.39199785099993, 54.21979401200008],
              [-58.41051184799994, 54.209051825000074],
              [-58.426340298999946, 54.19599030200004],
              [-58.45274817599994, 54.16303131700005],
              [-58.464100714999915, 54.15367259300007],
              [-58.50210527299993, 54.13947174700007],
              [-58.523101365999935, 54.12836334800005],
              [-58.53551184799994, 54.115301825000074],
              [-58.54649817599994, 54.10057200700004],
              [-58.56289628799993, 54.084824937000064],
              [-58.603505011999914, 54.055894273000035],
              [-58.62633216099994, 54.04429759300007],
              [-58.65294348899994, 54.036444403000075],
              [-58.70543372299994, 54.03270091400003],
              [-58.85838782499991, 54.050116278000075],
              [-59.04271399599992, 54.03021881700005],
              [-59.04271399599992, 54.022772528000075],
              [-58.91978919199994, 54.01597728100006],
              [-58.96385657499991, 53.97837962400007],
              [-58.97451738199993, 53.97150299700007],
              [-59.00112870999993, 53.963731187000064],
              [-59.011708136999914, 53.95762767100007],
              [-59.03433183499993, 53.952460028000075],
              [-59.10236568899995, 53.953111070000034],
              [-59.11164303299995, 53.94708893400008],
              [-59.13414466099994, 53.94684479400007],
              [-59.21654212099992, 53.93073151200008],
              [-59.26976477799991, 53.91258372600004],
              [-59.30211341099994, 53.89427317900004],
              [-59.34642493399991, 53.88536204600007],
              [-59.36485755099994, 53.87938060100004],
              [-59.42711341099994, 53.84454987200007],
              [-59.44123287699995, 53.84467194200005],
              [-59.47451738199993, 53.828111070000034],
              [-59.53164628799993, 53.82164134300007],
              [-59.639230923999946, 53.82416413000004],
              [-59.79133053299995, 53.84796784100007],
              [-59.84398352799991, 53.84467194200005],
              [-59.86595618399991, 53.83897532800006],
              [-59.87608801999994, 53.83295319200005],
              [-59.87877356699994, 53.82416413000004],
              [-59.86827551999994, 53.817572333000044],
              [-59.82750403599994, 53.81749095300006],
              [-59.81395423099991, 53.81391022300005],
              [-59.807199673999946, 53.79844798400006],
              [-59.82298743399991, 53.79328034100007],
              [-59.90001380099994, 53.79551829600007],
              [-60.00157630099994, 53.78009674700007],
              [-60.04234778599994, 53.76593659100007],
              [-60.063710089999915, 53.76207103100006],
              [-60.08299719999991, 53.76434967700004],
              [-60.13267981699994, 53.78314850500004],
              [-60.13003495999993, 53.77574290600006],
              [-60.12743079299992, 53.77399323100008],
              [-60.12547766799992, 53.77521393400008],
              [-60.12515214799993, 53.77635325700004],
              [-60.108265753999945, 53.75767649900007],
              [-60.07803300699993, 53.73737213700008],
              [-60.044178839999915, 53.72101471600007],
              [-60.01659094999991, 53.71430084800005],
              [-60.01659094999991, 53.70807526200008],
              [-60.069203253999945, 53.70929596600007],
              [-60.09414628799993, 53.700384833000044],
              [-60.104725714999915, 53.67645905200004],
              [-60.107980923999946, 53.65220774900007],
              [-60.112945115999935, 53.63422272300005],
              [-60.112172003999945, 53.61778392100007],
              [-60.098500128999945, 53.59821198100008],
              [-60.08242753799993, 53.582139390000066],
              [-60.07103430899991, 53.566473700000074],
              [-60.07408606699994, 53.55455149900007],
              [-60.101633266999954, 53.54979075700004],
              [-60.11164303299995, 53.54661692900004],
              [-60.13003495999993, 53.532538153000075],
              [-60.13609778599994, 53.529364325000074],
              [-60.14171301999994, 53.53107330900008],
              [-60.144602016999954, 53.53534577000005],
              [-60.14561926999994, 53.54096100500004],
              [-60.146555141999954, 53.55426666900007],
              [-60.14915930899991, 53.55573151200008],
              [-60.153553839999915, 53.55499909100007],
              [-60.15998287699995, 53.556626695000034],
              [-60.18309485599991, 53.56525299700007],
              [-60.22988847599993, 53.57489655200004],
              [-60.27253170499995, 53.59979889500005],
              [-60.338734503999945, 53.62555573100008],
              [-60.35692298099991, 53.640692450000074],
              [-60.371652798999946, 53.65607330900008],
              [-60.38853919199994, 53.66791413000004],
              [-60.438710089999915, 53.67719147300005],
              [-60.50255286399994, 53.70807526200008],
              [-60.69127356699994, 53.73851146000004],
              [-60.736398891999954, 53.757920640000066],
              [-60.801665818999936, 53.77228424700007],
              [-60.82127844999991, 53.779730536000045],
              [-60.84528561099995, 53.82078685100004],
              [-60.859445766999954, 53.835150458000044],
              [-60.87930253799993, 53.83100006700005],
              [-60.86351477799991, 53.81541575700004],
              [-60.861439581999946, 53.795762437000064],
              [-60.869252081999946, 53.77570221600007],
              [-60.88304602799991, 53.758653062000064],
              [-60.92320716099994, 53.739121812000064],
              [-60.93431555899991, 53.72825755400004],
              [-60.92027747299994, 53.71430084800005],
              [-60.89997311099995, 53.710923570000034],
              [-60.8352758449999, 53.72797272300005],
              [-60.80500240799995, 53.725897528000075],
              [-60.72227942599994, 53.70807526200008],
              [-60.636708136999914, 53.70384349200003],
              [-60.44115149599992, 53.64606354400007],
              [-60.41079667899993, 53.62181224200003],
              [-60.40294348899994, 53.61810944200005],
              [-60.37767493399991, 53.61505768400008],
              [-60.356312628999945, 53.60724518400008],
              [-60.27574622299994, 53.56199778900003],
              [-60.25365149599992, 53.55426666900007],
              [-60.18150794199994, 53.541001695000034],
              [-60.101633266999954, 53.502020575000074],
              [-60.070383266999954, 53.50861237200007],
              [-60.063710089999915, 53.50885651200008],
              [-60.04979407499991, 53.49778880400004],
              [-60.04173743399991, 53.480169989000046],
              [-60.037993943999936, 53.45958079600007],
              [-60.037098761999914, 53.43992747600004],
              [-60.05846106699994, 53.451605536000045],
              [-60.08120683499993, 53.45970286700003],
              [-60.10582434799994, 53.46324290600006],
              [-60.13267981699994, 53.461045640000066],
              [-60.20164954299992, 53.44025299700007],
              [-60.233631964999915, 53.42011139500005],
              [-60.28547115799995, 53.39720286700003],
              [-60.3040258449999, 53.39276764500005],
              [-60.328195766999954, 53.39020416900007],
              [-60.34520423099991, 53.38239166900007],
              [-60.35692298099991, 53.369574286000045],
              [-60.36538652299993, 53.35179271000004],
              [-60.389230923999946, 53.36461009300007],
              [-60.392689581999946, 53.36823151200008],
              [-60.39708411399994, 53.37010325700004],
              [-60.40587317599994, 53.36603424700007],
              [-60.41226152299993, 53.35797760600008],
              [-60.409820115999935, 53.348089911000045],
              [-60.397328253999945, 53.339911200000074],
              [-60.381743943999936, 53.33698151200008],
              [-60.25959225199995, 53.34442780200004],
              [-60.204741990999935, 53.35455963700008],
              [-60.18789628799993, 53.35179271000004],
              [-60.18126380099994, 53.336371161000045],
              [-60.20811926999994, 53.31976959800005],
              [-60.27603105399993, 53.296576239000046],
              [-60.34715735599991, 53.281358140000066],
              [-60.42064368399991, 53.275458075000074],
              [-60.42064368399991, 53.26862213700008],
              [-60.30211341099994, 53.27179596600007],
              [-60.24762936099995, 53.27997467700004],
              [-60.19408118399991, 53.296576239000046],
              [-60.175770636999914, 53.30516185100004],
              [-60.169992641999954, 53.30548737200007],
              [-60.15998287699995, 53.302801825000074],
              [-60.14989173099991, 53.296861070000034],
              [-60.13194739499994, 53.27916087400007],
              [-60.128977016999954, 53.275458075000074],
              [-60.11538652299993, 53.277411200000074],
              [-60.10326087099992, 53.28314850500004],
              [-60.09447180899991, 53.29271067900004],
              [-60.091053839999915, 53.30621979400007],
              [-60.13975989499994, 53.315659898000035],
              [-60.15314693899995, 53.323919989000046],
              [-60.142648891999954, 53.333685614000046],
              [-60.13133704299992, 53.336778062000064],
              [-60.104725714999915, 53.337591864000046],
              [-60.05968176999994, 53.34996165600006],
              [-60.046986456999946, 53.35179271000004],
              [-60.02904212099992, 53.35809967700004],
              [-59.985991990999935, 53.38971588700008],
              [-59.971913214999915, 53.40269603100006],
              [-59.940297003999945, 53.42340729400007],
              [-59.93712317599994, 53.426947333000044],
              [-59.92886308499993, 53.431708075000074],
              [-59.910145636999914, 53.45416901200008],
              [-59.899281378999945, 53.461045640000066],
              [-59.89122473899994, 53.45750560100004],
              [-59.88223222599993, 53.44969310100004],
              [-59.87490800699993, 53.446600653000075],
              [-59.871937628999945, 53.45734284100007],
              [-59.87596594999991, 53.46812571800007],
              [-59.88267981699994, 53.475897528000075],
              [-59.884022589999915, 53.48216380400004],
              [-59.873117641999954, 53.48773834800005],
              [-59.85488847599993, 53.48582591400003],
              [-59.83242753799993, 53.478501695000034],
              [-59.809437628999945, 53.47443268400008],
              [-59.78380286399994, 53.48151276200008],
              [-59.78380286399994, 53.488348700000074],
              [-59.80833899599992, 53.49485911700003],
              [-59.86070716099994, 53.499701239000046],
              [-59.88219153599994, 53.512559312000064],
              [-59.89122473899994, 53.530585028000075],
              [-59.879465298999946, 53.53815338700008],
              [-59.85610917899993, 53.538763739000046],
              [-59.754750128999945, 53.52399323100008],
              [-59.60724850199995, 53.53379954600007],
              [-59.558583136999914, 53.546983140000066],
              [-59.53278561099995, 53.54979075700004],
              [-59.51109778599994, 53.55540599200003],
              [-59.48973548099991, 53.568793036000045],
              [-59.45421301999994, 53.59821198100008],
              [-59.38927161399994, 53.62689850500004],
              [-59.37852942599994, 53.63548411700003],
              [-59.37559973899994, 53.64752838700008],
              [-59.36782792899993, 53.652411200000074],
              [-59.34410559799994, 53.65281810100004],
              [-59.32998613199993, 53.65717194200005],
              [-59.32567298099991, 53.667303778000075],
              [-59.32384192599994, 53.67877838700008],
              [-59.31704667899993, 53.68699778900003],
              [-59.29515540299991, 53.68744538000004],
              [-59.26939856699994, 53.665350653000075],
              [-59.25186113199993, 53.67645905200004],
              [-59.24356035099993, 53.68305084800005],
              [-59.23143469999991, 53.68907298400006],
              [-59.21837317599994, 53.69322337400007],
              [-59.20718339799993, 53.69444407800006],
              [-59.20156816299993, 53.69078196800007],
              [-59.19566809799994, 53.68333567900004],
              [-59.18789628799993, 53.67601146000004],
              [-59.17682857999995, 53.672715562000064],
              [-59.15111243399991, 53.67462799700007],
              [-59.13825436099995, 53.67796458500004],
              [-59.12873287699995, 53.683579820000034],
              [-59.11733964799993, 53.68781159100007],
              [-59.088449673999946, 53.68431224200003],
              [-59.07681230399993, 53.68699778900003],
              [-59.07384192599994, 53.69371165600006],
              [-59.06932532499991, 53.71625397300005],
              [-59.066965298999946, 53.721136786000045],
              [-59.055246548999946, 53.720038153000075],
              [-59.03429114499994, 53.71539948100008],
              [-59.02220618399991, 53.71430084800005],
              [-59.02253170499995, 53.726670640000066],
              [-59.01988684799994, 53.73712799700007],
              [-59.01667232999995, 53.74485911700003],
              [-59.01545162699995, 53.74909088700008],
              [-59.00796464799993, 53.74909088700008],
              [-59.02879798099991, 53.75067780200004],
              [-59.05016028599994, 53.75523509300007],
              [-59.04454505099994, 53.76976146000004],
              [-59.048898891999954, 53.78180573100008],
              [-59.05894934799994, 53.79083893400008],
              [-59.07066809799994, 53.79625071800007],
              [-59.050038214999915, 53.81329987200007],
              [-59.003977016999954, 53.829291083000044],
              [-58.98468990799995, 53.84125397300005],
              [-58.96825110599991, 53.85411204600007],
              [-58.886830206999946, 53.89305247600004],
              [-58.88023841099994, 53.89728424700007],
              [-58.87140865799995, 53.90611399900007],
              [-58.86595618399991, 53.916449286000045],
              [-58.86070716099994, 53.930121161000045],
              [-58.85313880099994, 53.94196198100008],
              [-58.840687628999945, 53.94708893400008],
              [-58.74852454299992, 53.95384349200003],
              [-58.65794837099992, 53.97284577000005],
              [-58.52696692599994, 54.01508209800005],
              [-58.32274329299992, 54.05247630400004],
              [-58.30654863199993, 54.06037018400008],
              [-58.289133266999954, 54.06659577000005],
              [-58.24063066299993, 54.06297435100004],
              [-58.22032630099994, 54.063788153000075],
              [-58.15587317599994, 54.093817450000074],
              [-58.12808183499993, 54.09788646000004],
              [-57.818430141999954, 54.066107489000046],
              [-57.795765753999945, 54.07123444200005],
              [-57.79556230399993, 54.08356354400007],
              [-57.8196508449999, 54.09430573100008],
              [-57.85142981699994, 54.10187409100007],
              [-57.87458248599995, 54.104681708000044],
              [-57.95103919199994, 54.101263739000046],
              [-57.973866339999915, 54.104681708000044],
              [-58.03783118399991, 54.12946198100008],
              [-58.15062415299991, 54.14057038000004],
              [-58.179351365999935, 54.13947174700007],
              [-58.225819464999915, 54.12836334800005],
              [-58.24876868399991, 54.119208075000074],
              [-58.26500403599994, 54.10846588700008],
              [-58.27367102799991, 54.10032786700003],
              [-58.28205318899995, 54.095038153000075],
              [-58.2923070949999, 54.09198639500005],
              [-58.30654863199993, 54.091050523000035],
              [-58.32176673099991, 54.09284088700008],
              [-58.328968878999945, 54.097723700000074],
              [-58.33446204299992, 54.10443756700005],
              [-58.34447180899991, 54.11212799700007],
              [-58.39683997299994, 54.12754954600007],
              [-58.41551673099991, 54.14044830900008],
              [-58.40900631399995, 54.16303131700005],
              [-58.39102128799993, 54.18431224200003],
              [-58.37486731699994, 54.199652411000045],
              [-58.35606848899994, 54.20958079600007],
              [-58.330148891999954, 54.214544989000046],
              [-58.25230872299994, 54.20917389500005],
              [-58.241444464999915, 54.21832916900007],
              [-58.228505011999914, 54.23570384300007],
              [-58.198882615999935, 54.24017975500004],
              [-58.1087133449999, 54.23334381700005],
              [-58.09740149599992, 54.228216864000046],
              [-58.07481848899994, 54.236761786000045],
              [-58.04283606699994, 54.24095286700003],
              [-58.01158606699994, 54.23973216400003],
              [-57.99095618399991, 54.231634833000044],
              [-57.968861456999946, 54.22007884300007],
              [-57.93512936099995, 54.21190013200004],
              [-57.900949673999946, 54.20933665600006],
              [-57.87767493399991, 54.214544989000046],
              [-57.86168372299994, 54.20298899900007],
              [-57.83071855399993, 54.204291083000044],
              [-57.76781165299991, 54.214544989000046],
              [-57.782093878999945, 54.20774974200003],
              [-57.77025305899991, 54.197333075000074],
              [-57.748117641999954, 54.19578685100004],
              [-57.69985917899993, 54.20030345300006],
              [-57.60338294199994, 54.18732330900008],
              [-57.608265753999945, 54.18219635600008],
              [-57.61701412699995, 54.16681549700007],
              [-57.59325110599991, 54.169989325000074],
              [-57.570423956999946, 54.18121979400007],
              [-57.548817511999914, 54.18695709800005],
              [-57.52887936099995, 54.17365143400008],
              [-57.46617591099994, 54.20030345300006],
              [-57.457875128999945, 54.19013092700004],
              [-57.429025844999956, 54.17869700700004],
              [-57.39053300699993, 54.15403880400004],
              [-57.38711503799993, 54.14598216400003],
              [-57.398508266999954, 54.13263580900008],
              [-57.37718665299991, 54.13471100500004],
              [-57.35692298099991, 54.13947174700007],
              [-57.35692298099991, 54.13263580900008],
              [-57.36538652299993, 54.10850657800006],
              [-57.342681443999936, 54.06732819200005],
              [-57.28864498599995, 54.00230540600006],
              [-57.26203365799995, 53.97801341400003],
              [-57.246937628999945, 53.96747467700004],
              [-57.23399817599994, 53.961371161000045],
              [-57.182932094999956, 53.957464911000045],
              [-57.15802975199995, 53.95111725500004],
              [-57.144642706999946, 53.934027411000045],
              [-57.16368567599994, 53.93541087400007],
              [-57.18268795499995, 53.93939850500004],
              [-57.20075436099995, 53.93976471600007],
              [-57.21694902299993, 53.93028392100007],
              [-57.222645636999914, 53.915350653000075],
              [-57.221262173999946, 53.89594147300005],
              [-57.213449673999946, 53.87909577000005],
              [-57.19985917899993, 53.871934312000064],
              [-57.18468176999994, 53.86859772300005],
              [-57.144642706999946, 53.84467194200005],
              [-57.12669837099992, 53.841131903000075],
              [-57.10879472599993, 53.83966705900008],
              [-57.09170488199993, 53.83555735900006],
              [-57.07579505099994, 53.82416413000004],
              [-57.104725714999915, 53.823431708000044],
              [-57.11851966099994, 53.82526276200008],
              [-57.13036048099991, 53.83100006700005],
              [-57.12995357999995, 53.82636139500005],
              [-57.13133704299992, 53.82489655200004],
              [-57.13418535099993, 53.82481517100007],
              [-57.13780676999994, 53.82416413000004],
              [-57.12124589799993, 53.81541575700004],
              [-57.107980923999946, 53.80406321800007],
              [-57.10692298099991, 53.794256903000075],
              [-57.15013587099992, 53.78453196800007],
              [-57.15526282499991, 53.77204010600008],
              [-57.14565995999993, 53.75828685100004],
              [-57.12413489499994, 53.74909088700008],
              [-57.12413489499994, 53.74164459800005],
              [-57.15274003799993, 53.739935614000046],
              [-57.20327714799993, 53.71942780200004],
              [-57.255523240999935, 53.70880768400008],
              [-57.33641516799992, 53.672715562000064],
              [-57.457102016999954, 53.64862702000005],
              [-57.517689581999946, 53.62579987200007],
              [-57.549387173999946, 53.59076569200005],
              [-57.497385219999956, 53.603583075000074],
              [-57.44627844999991, 53.62555573100008],
              [-57.44180253799993, 53.61774323100008],
              [-57.441965298999946, 53.610663153000075],
              [-57.44611568899995, 53.60423411700003],
              [-57.45372473899994, 53.59821198100008],
              [-57.41901607999995, 53.59922923400006],
              [-57.399647589999915, 53.60252513200004],
              [-57.388010219999956, 53.607855536000045],
              [-57.377023891999954, 53.60724518400008],
              [-57.33934485599991, 53.59044017100007],
              [-57.32966061099995, 53.58458079600007],
              [-57.31777910099993, 53.585191148000035],
              [-57.32266191299993, 53.57282135600008],
              [-57.343861456999946, 53.54356517100007],
              [-57.31981360599991, 53.54315827000005],
              [-57.30614173099991, 53.534491278000075],
              [-57.30260169199994, 53.51825592700004],
              [-57.309152798999946, 53.49518463700008],
              [-57.32408606699994, 53.47455475500004],
              [-57.362945115999935, 53.448431708000044],
              [-57.37743079299992, 53.433701890000066],
              [-57.36583411399994, 53.43646881700005],
              [-57.34316972599993, 53.44550202000005],
              [-57.33307857999995, 53.447373765000066],
              [-57.31969153599994, 53.44525788000004],
              [-57.29527747299994, 53.43817780200004],
              [-57.28115800699993, 53.43992747600004],
              [-57.28115800699993, 53.447373765000066],
              [-57.291900193999936, 53.46934642100007],
              [-57.26915442599994, 53.489447333000044],
              [-57.16124426999994, 53.540228583000044],
              [-57.14834550699993, 53.54356517100007],
              [-57.13536536399994, 53.55040110900006],
              [-57.13585364499994, 53.56346263200004],
              [-57.14688066299993, 53.57139720300006],
              [-57.16576087099992, 53.56285228100006],
              [-57.13499915299991, 53.58283112200007],
              [-57.13036048099991, 53.58771393400008],
              [-57.13524329299992, 53.61029694200005],
              [-57.13312740799995, 53.62103913000004],
              [-57.12071692599994, 53.62555573100008],
              [-57.098540818999936, 53.62852610900006],
              [-57.07457434799994, 53.63694896000004],
              [-57.060658331999946, 53.64988841400003],
              [-57.06895911399994, 53.66648997600004],
              [-57.038400844999956, 53.685655015000066],
              [-57.01207434799994, 53.70848216400003],
              [-56.98346920499995, 53.72748444200005],
              [-56.94603430899991, 53.73541901200008],
              [-56.92332923099991, 53.73204173400006],
              [-56.88585364499994, 53.72007884300007],
              [-56.864125128999945, 53.721136786000045],
              [-56.83250891799992, 53.73334381700005],
              [-56.81505286399994, 53.73338450700004],
              [-56.79523678299995, 53.721136786000045],
              [-56.79059811099995, 53.73033274900007],
              [-56.78429114499994, 53.733710028000075],
              [-56.776682094999956, 53.732489325000074],
              [-56.76789303299995, 53.72797272300005],
              [-56.75723222599993, 53.72764720300006],
              [-56.74522864499994, 53.73334381700005],
              [-56.74282792899993, 53.741522528000075],
              [-56.75426184799994, 53.74909088700008],
              [-56.715402798999946, 53.75230540600006],
              [-56.64329993399991, 53.71922435100004],
              [-56.59601803299995, 53.71430084800005],
              [-56.59601803299995, 53.721136786000045],
              [-56.60643469999991, 53.72553131700005],
              [-56.62336178299995, 53.737494208000044],
              [-56.63133704299992, 53.74164459800005],
              [-56.63133704299992, 53.74909088700008],
              [-56.610259568999936, 53.74909088700008],
              [-56.61538652299993, 53.76512278900003],
              [-56.61766516799992, 53.769517320000034],
              [-56.610259568999936, 53.769517320000034],
              [-56.59487870999993, 53.75657786700003],
              [-56.57921301999994, 53.76048411700003],
              [-56.56281490799995, 53.77061595300006],
              [-56.54507402299993, 53.77635325700004],
              [-56.525502081999946, 53.77720774900007],
              [-56.51040605399993, 53.779730536000045],
              [-56.47988847599993, 53.79002513200004],
              [-56.43651282499991, 53.76752350500004],
              [-56.42406165299991, 53.75340403900003],
              [-56.439564581999946, 53.74164459800005],
              [-56.43138587099992, 53.73887767100007],
              [-56.41161048099991, 53.72797272300005],
              [-56.427398240999935, 53.72162506700005],
              [-56.49351966099994, 53.721136786000045],
              [-56.54405676999994, 53.712144273000035],
              [-56.57982337099992, 53.69786204600007],
              [-56.59019934799994, 53.68451569200005],
              [-56.59601803299995, 53.68016185100004],
              [-56.60619055899991, 53.67865631700005],
              [-56.72691809799994, 53.68699778900003],
              [-56.709095831999946, 53.67572663000004],
              [-56.63272050699993, 53.66034577000005],
              [-56.597320115999935, 53.64557526200008],
              [-56.43114173099991, 53.61737702000005],
              [-56.39826412699995, 53.61786530200004],
              [-56.37376868399991, 53.62864817900004],
              [-56.34862219999991, 53.636419989000046],
              [-56.31480872299994, 53.62982819200005],
              [-56.282093878999945, 53.616522528000075],
              [-56.26016191299993, 53.60443756700005],
              [-56.28099524599992, 53.59747955900008],
              [-56.327381964999915, 53.60492584800005],
              [-56.350168423999946, 53.59821198100008],
              [-56.33039303299995, 53.59076569200005],
              [-56.25023352799991, 53.58458079600007],
              [-56.222320115999935, 53.58775462400007],
              [-56.18236243399991, 53.59943268400008],
              [-56.15835527299993, 53.59821198100008],
              [-56.15001380099994, 53.594916083000044],
              [-56.14293372299994, 53.59039948100008],
              [-56.13414466099994, 53.586371161000045],
              [-56.12051347599993, 53.58458079600007],
              [-56.05874589799993, 53.58458079600007],
              [-56.03624426999994, 53.58043040600006],
              [-55.97960364499994, 53.54979075700004],
              [-55.97960364499994, 53.54356517100007],
              [-55.98379472599993, 53.53986237200007],
              [-55.98940995999993, 53.53302643400008],
              [-55.99388587099992, 53.529364325000074],
              [-55.99168860599991, 53.52610911700003],
              [-55.99156653599994, 53.525091864000046],
              [-55.99071204299992, 53.52440013200004],
              [-55.986439581999946, 53.52252838700008],
              [-55.99657141799992, 53.51231517100007],
              [-56.00576738199993, 53.50560130400004],
              [-56.01549231699994, 53.504014390000066],
              [-56.027414516999954, 53.50885651200008],
              [-56.02525794199994, 53.51251862200007],
              [-56.02122962099992, 53.52252838700008],
              [-56.032541469999956, 53.52167389500005],
              [-56.043080206999946, 53.52220286700003],
              [-56.05288652299993, 53.524603583000044],
              [-56.062163865999935, 53.529364325000074],
              [-56.05638587099992, 53.53034088700008],
              [-56.041086391999954, 53.53620026200008],
              [-56.06969153599994, 53.545762437000064],
              [-56.19749915299991, 53.56028880400004],
              [-56.23973548099991, 53.56041087400007],
              [-56.26349850199995, 53.55365631700005],
              [-56.240305141999954, 53.53620026200008],
              [-56.052845831999946, 53.478501695000034],
              [-56.03066972599993, 53.46124909100007],
              [-56.03490149599992, 53.433701890000066],
              [-56.01671301999994, 53.43024323100008],
              [-55.96593176999994, 53.41266510600008],
              [-55.96593176999994, 53.40643952000005],
              [-56.00572669199994, 53.39435455900008],
              [-56.02476966099994, 53.38499583500004],
              [-56.041086391999954, 53.37164948100008],
              [-56.01427161399994, 53.36591217700004],
              [-55.99282792899993, 53.37409088700008],
              [-55.97329667899993, 53.387884833000044],
              [-55.95230058499993, 53.39899323100008],
              [-55.924672003999945, 53.401556708000044],
              [-55.90074622299994, 53.39435455900008],
              [-55.856760219999956, 53.37164948100008],
              [-55.856760219999956, 53.36485423400006],
              [-55.87401282499991, 53.35956452000005],
              [-55.89024817599994, 53.35179271000004],
              [-55.843088344999956, 53.35179271000004],
              [-55.83088131399995, 53.347723700000074],
              [-55.816517706999946, 53.34039948100008],
              [-55.80772864499994, 53.333319403000075],
              [-55.81208248599995, 53.330064195000034],
              [-55.89533443899995, 53.315741278000075],
              [-55.911366339999915, 53.30963776200008],
              [-55.889881964999915, 53.30426666900007],
              [-55.83828691299993, 53.30646393400008],
              [-55.819203253999945, 53.299668687000064],
              [-55.80821692599994, 53.279364325000074],
              [-55.82188880099994, 53.26666901200008],
              [-55.84520423099991, 53.25763580900008],
              [-55.86359615799995, 53.248155015000066],
              [-55.81078040299991, 53.23375071800007],
              [-55.79466712099992, 53.23517487200007],
              [-55.78148352799991, 53.244126695000034],
              [-55.77769934799994, 53.25275299700007],
              [-55.77306067599994, 53.25926341400003],
              [-55.75743567599994, 53.261786200000074],
              [-55.74547278599994, 53.25560130400004],
              [-55.752797003999945, 53.24156321800007],
              [-55.77725175699993, 53.21775950700004],
              [-55.79474850199995, 53.20575592700004],
              [-55.808257615999935, 53.20652903900003],
              [-55.82274329299992, 53.212144273000035],
              [-55.843088344999956, 53.21466705900008],
              [-55.83608964799993, 53.20465729400007],
              [-55.82445227799991, 53.19322337400007],
              [-55.81094316299993, 53.18382396000004],
              [-55.79841061099995, 53.17987702000005],
              [-55.76789303299995, 53.17759837400007],
              [-55.76081295499995, 53.173529364000046],
              [-55.77415930899991, 53.16620514500005],
              [-55.74689693899995, 53.145738023000035],
              [-55.80907141799992, 53.10541413000004],
              [-55.82876542899993, 53.097357489000046],
              [-55.85594641799992, 53.098496812000064],
              [-55.915679490999935, 53.11631907800006],
              [-55.94546464799993, 53.118475653000075],
              [-55.94546464799993, 53.111029364000046],
              [-55.92491614499994, 53.10956452000005],
              [-55.90217037699995, 53.102403062000064],
              [-55.884022589999915, 53.091009833000044],
              [-55.87718665299991, 53.07684967700004],
              [-55.88646399599992, 53.05341217700004],
              [-55.90640214799993, 53.036322333000044],
              [-55.93138587099992, 53.025824286000045],
              [-55.95571855399993, 53.02220286700003],
              [-55.98204505099994, 53.025458075000074],
              [-56.03237870999993, 53.03953685100004],
              [-56.05874589799993, 53.042669989000046],
              [-56.16519120999993, 53.03587474200003],
              [-56.16519120999993, 53.02842845300006],
              [-56.14468339799993, 53.02903880400004],
              [-56.082020636999914, 53.02220286700003],
              [-56.09239661399994, 53.009100653000075],
              [-56.10488847599993, 52.99677155200004],
              [-56.11974036399994, 52.98847077000005],
              [-56.137277798999946, 52.987494208000044],
              [-56.12279212099992, 52.973089911000045],
              [-56.10952714799993, 52.970811265000066],
              [-56.09634355399993, 52.97691478100006],
              [-56.06436113199993, 52.99957916900007],
              [-56.05113684799994, 53.004339911000045],
              [-55.94054114499994, 52.99461497600004],
              [-55.90416419199994, 52.98350657800006],
              [-55.884022589999915, 52.960150458000044],
              [-55.89220130099994, 52.960150458000044],
              [-55.89883378799993, 52.958238023000035],
              [-55.90489661399994, 52.95575592700004],
              [-55.911366339999915, 52.953965562000064],
              [-55.88898678299995, 52.94273509300007],
              [-55.856760219999956, 52.93537018400008],
              [-55.83478756399995, 52.92357005400004],
              [-55.843088344999956, 52.89935944200005],
              [-55.81285559799994, 52.877020575000074],
              [-55.80483964799993, 52.86347077000005],
              [-55.80211341099994, 52.840684312000064],
              [-55.81163489499994, 52.83043040600006],
              [-55.833241339999915, 52.82868073100008],
              [-55.87100175699993, 52.83043040600006],
              [-55.87913977799991, 52.82672760600008],
              [-55.891468878999945, 52.81891510600008],
              [-55.897694464999915, 52.81675853100006],
              [-55.908192511999914, 52.815741278000075],
              [-55.96068274599992, 52.81614817900004],
              [-55.97838294199994, 52.81329987200007],
              [-55.99250240799995, 52.80695221600007],
              [-56.000111456999946, 52.79572174700007],
              [-55.925038214999915, 52.79572174700007],
              [-55.94684811099995, 52.78379954600007],
              [-55.975168423999946, 52.77789948100008],
              [-56.004017706999946, 52.77765534100007],
              [-56.027414516999954, 52.78266022300005],
              [-56.061390753999945, 52.79901764500005],
              [-56.137277798999946, 52.81675853100006],
              [-56.16246497299994, 52.81797923400006],
              [-56.15835527299993, 52.80463288000004],
              [-56.136830206999946, 52.78685130400004],
              [-56.10997473899994, 52.77521393400008],
              [-56.05939693899995, 52.765692450000074],
              [-56.03774980399993, 52.75486888200004],
              [-56.02122962099992, 52.73423899900007],
              [-56.027414516999954, 52.73423899900007],
              [-56.02676347599993, 52.72984446800007],
              [-56.025054490999935, 52.72846100500004],
              [-56.02448482999995, 52.726670640000066],
              [-56.027414516999954, 52.72125885600008],
              [-56.005197719999956, 52.72016022300005],
              [-55.99087480399993, 52.71112702000005],
              [-55.97956295499995, 52.69867584800005],
              [-55.96593176999994, 52.68707916900007],
              [-55.946522589999915, 52.68048737200007],
              [-55.92715410099993, 52.68121979400007],
              [-55.88711503799993, 52.68707916900007],
              [-55.79841061099995, 52.68707916900007],
              [-55.77757727799991, 52.68109772300005],
              [-55.759022589999915, 52.65619538000004],
              [-55.73940995999993, 52.65228913000004],
              [-55.74640865799995, 52.64280833500004],
              [-55.75658118399991, 52.63861725500004],
              [-55.768422003999945, 52.63609446800007],
              [-55.78038489499994, 52.63182200700004],
              [-55.772694464999915, 52.630926825000074],
              [-55.760650193999936, 52.62657298400006],
              [-55.75373287699995, 52.624986070000034],
              [-55.765614386999914, 52.61505768400008],
              [-55.791005011999914, 52.60443756700005],
              [-55.80211341099994, 52.597723700000074],
              [-55.817290818999936, 52.61351146000004],
              [-55.83897864499994, 52.61595286700003],
              [-55.884022589999915, 52.611395575000074],
              [-55.89439856699994, 52.613348700000074],
              [-55.90416419199994, 52.61701080900008],
              [-55.91319739499994, 52.62205638200004],
              [-55.933257615999935, 52.637884833000044],
              [-55.940297003999945, 52.63975657800006],
              [-55.947336391999954, 52.638739325000074],
              [-55.95913652299993, 52.63926829600007],
              [-56.04767818899995, 52.65928782800006],
              [-56.09723873599995, 52.662176825000074],
              [-56.124256964999915, 52.64545319200005],
              [-56.052723761999914, 52.64622630400004],
              [-56.01699785099993, 52.64154694200005],
              [-55.99014238199993, 52.62840403900003],
              [-55.97813880099994, 52.61774323100008],
              [-55.97594153599994, 52.61359284100007],
              [-56.027902798999946, 52.593858140000066],
              [-56.039906378999945, 52.58763255400004],
              [-56.048491990999935, 52.57721588700008],
              [-56.01154537699995, 52.57636139500005],
              [-55.99624589799993, 52.570420640000066],
              [-55.986439581999946, 52.556708075000074],
              [-56.00064042899993, 52.55149974200003],
              [-56.01695716099994, 52.55267975500004],
              [-56.06810462099992, 52.56891510600008],
              [-56.08340410099993, 52.57086823100008],
              [-56.11709550699993, 52.570379950000074],
              [-56.21816972599993, 52.540269273000035],
              [-56.24372311099995, 52.54584381700005],
              [-56.26707923099991, 52.56122467700004],
              [-56.298491990999935, 52.57261790600006],
              [-56.36318925699993, 52.584051825000074],
              [-56.42731686099995, 52.58038971600007],
              [-56.442616339999915, 52.58746979400007],
              [-56.45376542899993, 52.595038153000075],
              [-56.46751868399991, 52.59784577000005],
              [-56.50035559799994, 52.597723700000074],
              [-56.48338782499991, 52.59214915600006],
              [-56.450062628999945, 52.574286200000074],
              [-56.42870032499991, 52.570379950000074],
              [-56.35260982999995, 52.568793036000045],
              [-56.32970130099994, 52.562933661000045],
              [-56.28758704299992, 52.54466380400004],
              [-56.26671301999994, 52.53856028900003],
              [-56.16307532499991, 52.536363023000035],
              [-56.150949673999946, 52.53937409100007],
              [-56.140695766999954, 52.54857005400004],
              [-56.117298956999946, 52.548895575000074],
              [-56.07579505099994, 52.54242584800005],
              [-56.053578253999945, 52.54559967700004],
              [-56.04063880099994, 52.545355536000045],
              [-56.03490149599992, 52.53937409100007],
              [-56.03111731699994, 52.53294505400004],
              [-56.02196204299992, 52.52488841400003],
              [-56.010650193999936, 52.518011786000045],
              [-56.00039628799993, 52.51512278900003],
              [-55.911366339999915, 52.50767649900007],
              [-55.82876542899993, 52.52195872600004],
              [-55.83250891799992, 52.51634349200003],
              [-55.843088344999956, 52.49461497600004],
              [-55.76870683499993, 52.499212958000044],
              [-55.74058997299994, 52.49290599200003],
              [-55.75861568899995, 52.44953034100007],
              [-55.72569739499994, 52.44700755400004],
              [-55.679351365999935, 52.44953034100007],
              [-55.64757239499994, 52.44318268400008],
              [-55.64635169199994, 52.43016185100004],
              [-55.662668423999946, 52.40391673400006],
              [-55.64488684799994, 52.39288971600007],
              [-55.64476477799991, 52.37909577000005],
              [-55.65387936099995, 52.36505768400008],
              [-55.67174231699994, 52.35809967700004],
              [-55.68590247299994, 52.36041901200008],
              [-55.70327714799993, 52.36676666900007],
              [-55.71934973899994, 52.374701239000046],
              [-55.72948157499991, 52.38165924700007],
              [-55.744211391999954, 52.38727448100008],
              [-55.808257615999935, 52.38544342700004],
              [-55.80020097599993, 52.374335028000075],
              [-55.774322068999936, 52.361436265000066],
              [-55.76732337099992, 52.35065338700008],
              [-55.77098548099991, 52.33966705900008],
              [-55.78355872299994, 52.33869049700007],
              [-55.84727942599994, 52.349676825000074],
              [-55.917307094999956, 52.372748114000046],
              [-55.97809811099995, 52.382147528000075],
              [-56.16909745999993, 52.44371165600006],
              [-56.19871985599991, 52.44684479400007],
              [-56.18626868399991, 52.43003978100006],
              [-56.16510982999995, 52.41657135600008],
              [-56.11681067599994, 52.39903392100007],
              [-56.025380011999914, 52.391913153000075],
              [-55.99494381399995, 52.376939195000034],
              [-55.97223873599995, 52.37299225500004],
              [-55.96251380099994, 52.36774323100008],
              [-55.95148678299995, 52.35150788000004],
              [-55.94383704299992, 52.34638092700004],
              [-55.82258053299995, 52.330186265000066],
              [-55.82258053299995, 52.322699286000045],
              [-55.84170488199993, 52.31671784100007],
              [-55.856760219999956, 52.30963776200008],
              [-55.856760219999956, 52.30345286700003],
              [-55.84333248599995, 52.30499909100007],
              [-55.83141028599994, 52.30768463700008],
              [-55.82005774599992, 52.30821360900006],
              [-55.808257615999935, 52.30345286700003],
              [-55.81240800699993, 52.30137767100007],
              [-55.81346594999991, 52.30113353100006],
              [-55.81362870999993, 52.30023834800005],
              [-55.81578528599994, 52.29600657800006],
              [-55.78868567599994, 52.297308661000045],
              [-55.78038489499994, 52.29600657800006],
              [-55.77521725199995, 52.29254791900007],
              [-55.77318274599992, 52.28400299700007],
              [-55.76732337099992, 52.28180573100008],
              [-55.75145423099991, 52.28302643400008],
              [-55.72484290299991, 52.29344310100004],
              [-55.70933997299994, 52.29600657800006],
              [-55.70677649599992, 52.29169342700004],
              [-55.71580969999991, 52.28204987200007],
              [-55.73009192599994, 52.27244700700004],
              [-55.74315344999991, 52.26813385600008],
              [-55.75853430899991, 52.26670970300006],
              [-55.77403723899994, 52.262152411000045],
              [-55.78693600199995, 52.25377024900007],
              [-55.79466712099992, 52.24079010600008],
              [-55.77065995999993, 52.24351634300007],
              [-55.728505011999914, 52.25438060100004],
              [-55.705922003999945, 52.255072333000044],
              [-55.686756964999915, 52.250067450000074],
              [-55.616525844999956, 52.22032298400006],
              [-55.63817298099991, 52.21312083500004],
              [-55.66051184799994, 52.21381256700005],
              [-55.705922003999945, 52.22032298400006],
              [-55.72911536399994, 52.214178778000075],
              [-55.741444464999915, 52.21234772300005],
              [-55.74689693899995, 52.21662018400008],
              [-55.751210089999915, 52.22479889500005],
              [-55.76134192599994, 52.22223541900007],
              [-55.77261308499993, 52.21430084800005],
              [-55.78038489499994, 52.20665110900006],
              [-55.759103969999956, 52.20453522300005],
              [-55.71743730399993, 52.18817780200004],
              [-55.692250128999945, 52.18614329600007],
              [-55.70287024599992, 52.16083405200004],
              [-55.70661373599995, 52.14598216400003],
              [-55.70132402299993, 52.13267649900007],
              [-55.684803839999915, 52.11168040600006],
              [-55.71206620999993, 52.09064362200007],
              [-55.74193274599992, 52.08934153900003],
              [-55.77253170499995, 52.092230536000045],
              [-55.80211341099994, 52.08372630400004],
              [-55.79161536399994, 52.07457103100006],
              [-55.76113847599993, 52.05646393400008],
              [-55.785267706999946, 52.03497955900008],
              [-55.81012936099995, 52.02252838700008],
              [-55.86359615799995, 52.00804271000004],
              [-55.88744055899991, 52.00690338700008],
              [-55.93578040299991, 52.02045319200005],
              [-55.96593176999994, 52.02167389500005],
              [-55.94839433499993, 52.00828685100004],
              [-55.90607662699995, 51.98289622600004],
              [-55.897694464999915, 51.97044505400004],
              [-55.90298417899993, 51.94953034100007],
              [-55.91641191299993, 51.93500397300005],
              [-55.93419348899994, 51.92523834800005],
              [-56.017648891999954, 51.90062083500004],
              [-56.037993943999936, 51.898138739000046],
              [-56.04600989499994, 51.894517320000034],
              [-56.08120683499993, 51.87055084800005],
              [-56.11681067599994, 51.86399974200003],
              [-56.12364661399994, 51.86005280200004],
              [-56.14476477799991, 51.84357330900008],
              [-56.16844641799992, 51.83148834800005],
              [-56.17516028599994, 51.82676829600007],
              [-56.192290818999936, 51.81073639500005],
              [-56.210926886999914, 51.79718659100007],
              [-56.23289954299992, 51.78729889500005],
              [-56.26016191299993, 51.782090562000064],
              [-56.337880011999914, 51.782090562000064],
              [-56.350168423999946, 51.77867259300007],
              [-56.35765540299991, 51.76264069200005],
              [-56.37531490799995, 51.74835846600007],
              [-56.395741339999915, 51.73802317900004],
              [-56.41161048099991, 51.733710028000075],
              [-56.437611456999946, 51.74433014500005],
              [-56.45274817599994, 51.74290599200003],
              [-56.45938066299993, 51.72345612200007],
              [-56.46422278599994, 51.71458567900004],
              [-56.47565670499995, 51.70579661700003],
              [-56.578968878999945, 51.657416083000044],
              [-56.60338294199994, 51.65171946800007],
              [-56.66856848899994, 51.65171946800007],
              [-56.682484503999945, 51.648138739000046],
              [-56.68785559799994, 51.638657945000034],
              [-56.69277910099993, 51.61078522300005],
              [-56.700062628999945, 51.58685944200005],
              [-56.707590298999946, 51.579413153000075],
              [-56.73680579299992, 51.57444896000004],
              [-56.74982662699995, 51.56895579600007],
              [-56.760609503999945, 51.56207916900007],
              [-56.76789303299995, 51.555528062000064],
              [-56.76789303299995, 51.54938385600008],
              [-56.777333136999914, 51.537543036000045],
              [-56.796945766999954, 51.53229401200008],
              [-56.810536261999914, 51.52680084800005],
              [-56.802072719999956, 51.51459381700005],
              [-56.82534745999993, 51.48997630400004],
              [-56.85973059799994, 51.47565338700008],
              [-56.89610755099994, 51.47724030200004],
              [-56.92552649599992, 51.50092194200005],
              [-56.95287024599992, 51.47361888200004],
              [-56.941395636999914, 51.46055735900006],
              [-56.94090735599991, 51.446600653000075],
              [-56.94985917899993, 51.43406810100004],
              [-56.96654212099992, 51.42523834800005],
              [-56.987172003999945, 51.42279694200005],
              [-57.029286261999914, 51.424994208000044],
              [-57.04845130099994, 51.41901276200008],
              [-57.056752081999946, 51.427842515000066],
              [-57.06822669199994, 51.42686595300006],
              [-57.08283443899995, 51.421942450000074],
              [-57.10033118399991, 51.41901276200008],
              [-57.139515753999945, 51.425116278000075],
              [-57.16201738199993, 51.42491282800006],
              [-57.171986456999946, 51.41559479400007],
              [-57.18980872299994, 51.418809312000064],
              [-57.22423255099994, 51.43980540600006],
              [-57.24632727799991, 51.46832916900007],
              [-57.22720292899993, 51.49408600500004],
              [-57.249989386999914, 51.50828685100004],
              [-57.28111731699994, 51.50678131700005],
              [-57.35920162699995, 51.492254950000074],
              [-57.398508266999954, 51.48041413000004],
              [-57.41193600199995, 51.48139069200005],
              [-57.42422441299993, 51.48460521000004],
              [-57.437611456999946, 51.48570384300007],
              [-57.45372473899994, 51.48041413000004],
              [-57.44204667899993, 51.46788157800006],
              [-57.44123287699995, 51.456732489000046],
              [-57.44969641799992, 51.44867584800005],
              [-57.46617591099994, 51.44566478100006],
              [-57.471587693999936, 51.44916413000004],
              [-57.47704016799992, 51.464056708000044],
              [-57.48387610599991, 51.46739329600007],
              [-57.48997962099992, 51.46552155200004],
              [-57.49331620999993, 51.461045640000066],
              [-57.49624589799993, 51.456244208000044],
              [-57.500884568999936, 51.453111070000034],
              [-57.60338294199994, 51.43268463700008],
              [-57.59748287699995, 51.443426825000074],
              [-57.582020636999914, 51.45774974200003],
              [-57.57603919199994, 51.46739329600007],
              [-57.59557044199994, 51.46552155200004],
              [-57.62669837099992, 51.444647528000075],
              [-57.67064368399991, 51.434881903000075],
              [-57.67853756399995, 51.43439362200007],
              [-57.68590247299994, 51.439520575000074],
              [-57.69090735599991, 51.44904205900008],
              [-57.692250128999945, 51.46002838700008],
              [-57.69050045499995, 51.47101471600007],
              [-57.68590247299994, 51.48041413000004],
              [-57.71226966099994, 51.47260163000004],
              [-57.73265540299991, 51.47044505400004],
              [-57.74852454299992, 51.46308014500005],
              [-57.76158606699994, 51.439520575000074],
              [-57.76659094999991, 51.417181708000044],
              [-57.770741339999915, 51.408270575000074],
              [-57.77867591099994, 51.404730536000045],
              [-57.79198157499991, 51.40794505400004],
              [-57.79930579299992, 51.41620514500005],
              [-57.80064856699994, 51.427435614000046],
              [-57.795765753999945, 51.439520575000074],
              [-57.81346594999991, 51.432928778000075],
              [-57.841786261999914, 51.40977610900006],
              [-57.87686113199993, 51.40058014500005],
              [-57.92609615799995, 51.37055084800005],
              [-57.96857662699995, 51.335638739000046],
              [-57.97765051999994, 51.32965729400007],
              [-58.04015051999994, 51.313666083000044],
              [-58.04963131399995, 51.31968821800007],
              [-58.05972245999993, 51.31232330900008],
              [-58.12474524599992, 51.296087958000044],
              [-58.133656378999945, 51.29649485900006],
              [-58.14712480399993, 51.30182526200008],
              [-58.152007615999935, 51.30231354400007],
              [-58.16242428299995, 51.29718659100007],
              [-58.18187415299991, 51.284369208000044],
              [-58.234038865999935, 51.27692291900007],
              [-58.25177975199995, 51.28034088700008],
              [-58.26130123599995, 51.296087958000044],
              [-58.25951087099992, 51.31688060100004],
              [-58.254790818999936, 51.32916901200008],
              [-58.260324673999946, 51.33494700700004],
              [-58.289173956999946, 51.33641185100004],
              [-58.27122962099992, 51.32762278900009],
              [-58.29914303299995, 51.29120514500005],
              [-58.289173956999946, 51.27501048400006],
              [-58.3333227199999, 51.27765534100007],
              [-58.41226152299993, 51.30841705900008],
              [-58.453684048999946, 51.31659577000005],
              [-58.57091223899994, 51.25812409100007],
              [-58.59024003799993, 51.25108470300006],
              [-58.59585527299993, 51.26837799700007],
              [-58.6087133449999, 51.27838776200008],
              [-58.62267005099994, 51.277329820000034],
              [-58.63182532499991, 51.26133860900006],
              [-58.62832597599993, 51.25885651200008],
              [-58.62169348899994, 51.25132884300007],
              [-58.61660722599993, 51.241888739000046],
              [-58.61815344999991, 51.23338450700004],
              [-58.62743079299992, 51.230454820000034],
              [-58.64110266799992, 51.231675523000035],
              [-58.65367591099994, 51.23651764500005],
              [-58.659087693999936, 51.244248765000066],
              [-58.66348222599993, 51.257147528000075],
              [-58.671986456999946, 51.25568268400008],
              [-58.67747962099992, 51.244208075000074],
              [-58.67284094999991, 51.22724030200004],
              [-58.65648352799991, 51.210923570000034],
              [-58.63589433499993, 51.200506903000075],
              [-58.59024003799993, 51.18622467700004],
              [-58.60387122299994, 51.183579820000034],
              [-58.61107337099992, 51.17401764500005],
              [-58.61668860599991, 51.161810614000046],
              [-58.62564042899993, 51.15147532800006],
              [-58.639556443999936, 51.14630768400008],
              [-58.67015540299991, 51.141831773000035],
              [-58.68301347599993, 51.13438548400006],
              [-58.70409094999991, 51.11395905200004],
              [-58.71637936099995, 51.10651276200008],
              [-58.779408331999946, 51.09336985900006],
              [-58.78945878799993, 51.096869208000044],
              [-58.79792232999995, 51.08539459800005],
              [-58.80996660099993, 51.07758209800005],
              [-58.82209225199995, 51.07770416900007],
              [-58.83043372299994, 51.09003327000005],
              [-58.84093176999994, 51.08165110900006],
              [-58.84683183499993, 51.071519273000035],
              [-58.85094153599994, 51.05528392100007],
              [-58.84276282499991, 51.05463288000004],
              [-58.83633378799993, 51.05333079600007],
              [-58.83218339799993, 51.04962799700007],
              [-58.83043372299994, 51.04161204600007],
              [-58.84813391799992, 51.032416083000044],
              [-58.86461341099994, 51.02110423400006],
              [-58.885975714999915, 50.99835846600007],
              [-58.89248613199993, 50.99445221600007],
              [-58.91201738199993, 50.99823639500005],
              [-58.90684973899994, 51.01329173400006],
              [-58.88508053299995, 51.04161204600007],
              [-58.89549719999991, 51.05499909100007],
              [-58.913319464999915, 51.055528062000064],
              [-58.93272864499994, 51.04905833500004],
              [-58.94774329299992, 51.04161204600007],
              [-58.954741990999935, 51.03656647300005],
              [-58.96564693899995, 51.02610911700003],
              [-58.97443600199995, 51.02110423400006],
              [-58.98228919199994, 51.02057526200008],
              [-58.99006100199995, 51.022650458000044],
              [-58.99836178299995, 51.022324937000064],
              [-59.00796464799993, 51.014960028000075],
              [-58.996652798999946, 51.00413646000004],
              [-58.98656165299991, 51.00287506700005],
              [-58.97618567599994, 51.005926825000074],
              [-58.96385657499991, 51.00812409100007],
              [-58.95457923099991, 51.003119208000044],
              [-58.956695115999935, 50.99156321800007],
              [-58.96694902299993, 50.969590562000064],
              [-58.96825110599991, 50.965277411000045],
              [-58.973500128999945, 50.95856354400007],
              [-58.97443600199995, 50.95347728100006],
              [-58.97109941299993, 50.94835032800006],
              [-58.95742753799993, 50.94407786700003],
              [-58.953968878999945, 50.93919505400004],
              [-58.954009568999936, 50.92881907800006],
              [-58.95620683499993, 50.918402411000045],
              [-58.96056067599994, 50.90806712400007],
              [-58.96694902299993, 50.89826080900008],
              [-58.95738684799994, 50.89740631700005],
              [-58.95091712099992, 50.894517320000034],
              [-58.940297003999945, 50.88458893400008],
              [-58.96751868399991, 50.877020575000074],
              [-58.96861731699994, 50.860581773000035],
              [-58.958973761999914, 50.84235260600008],
              [-58.953968878999945, 50.829331773000035],
              [-58.96133378799993, 50.82066478100006],
              [-58.97288977799991, 50.81622955900008],
              [-58.98346920499995, 50.810532945000034],
              [-58.98810787699995, 50.79865143400008],
              [-58.99327551999994, 50.79083893400008],
              [-59.00527910099993, 50.785589911000045],
              [-59.02965247299994, 50.780951239000046],
              [-59.025380011999914, 50.77362702000005],
              [-59.021555141999954, 50.76825592700004],
              [-59.01626542899993, 50.76434967700004],
              [-59.00796464799993, 50.761053778000075],
              [-59.03774980399993, 50.75242747600004],
              [-59.066965298999946, 50.76239655200004],
              [-59.089100714999915, 50.784369208000044],
              [-59.09797115799995, 50.81195709800005],
              [-59.09325110599991, 50.82566966400009],
              [-59.07070878799993, 50.85065338700008],
              [-59.06322180899991, 50.86347077000005],
              [-59.06232662699995, 50.87547435100004],
              [-59.065663214999915, 50.88804759300007],
              [-59.07384192599994, 50.89435455900008],
              [-59.08775794199994, 50.88768138200004],
              [-59.09825598899994, 50.87156810100004],
              [-59.112172003999945, 50.82636139500005],
              [-59.12531490799995, 50.802069403000075],
              [-59.18602454299992, 50.75800202000005],
              [-59.18667558499993, 50.747381903000075],
              [-59.202788865999935, 50.73191966400009],
              [-59.22057044199994, 50.74042389500005],
              [-59.23843339799993, 50.75580475500004],
              [-59.25499426999994, 50.761053778000075],
              [-59.26231848899994, 50.75470612200007],
              [-59.26162675699993, 50.746201890000066],
              [-59.25951087099992, 50.73655833500004],
              [-59.26244055899991, 50.72691478100006],
              [-59.27061926999994, 50.71869538000004],
              [-59.2766820949999, 50.71653880400004],
              [-59.28400631399995, 50.716131903000075],
              [-59.29596920499995, 50.713324286000045],
              [-59.31749426999994, 50.701605536000045],
              [-59.34439042899993, 50.675116278000075],
              [-59.36485755099994, 50.66486237200007],
              [-59.37865149599992, 50.663763739000046],
              [-59.40990149599992, 50.66661204600007],
              [-59.41950436099995, 50.66486237200007],
              [-59.42516028599994, 50.65802643400008],
              [-59.42406165299991, 50.65216705900008],
              [-59.41734778599994, 50.64752838700008],
              [-59.40583248599995, 50.64439524900007],
              [-59.41559811099995, 50.63194407800006],
              [-59.42735755099994, 50.630194403000075],
              [-59.439564581999946, 50.63117096600007],
              [-59.45079505099994, 50.627020575000074],
              [-59.45811926999994, 50.61701080900008],
              [-59.468413865999935, 50.59247467700004],
              [-59.45126356599991, 50.58426515500008],
              [-59.4231794449999, 50.58436752500006],
              [-59.410496974999944, 50.57240941800006],
              [-59.41194038499992, 50.55454164100007],
              [-59.4239842099999, 50.54001255800006],
              [-59.45410587999993, 50.533748512000045],
              [-59.49599634099991, 50.53740501500005],
              [-59.510109454999906, 50.546254540000064],
              [-59.520317072999944, 50.54245634600005],
              [-59.525461391999954, 50.53758372600004],
              [-59.533273891999954, 50.531317450000074],
              [-59.544178839999915, 50.527329820000034],
              [-59.556630011999914, 50.52024974200003],
              [-59.56525631399995, 50.50914134300007],
              [-59.57262122299994, 50.49555084800005],
              [-59.58153235599991, 50.484076239000046],
              [-59.59447180899991, 50.47931549700007],
              [-59.65221106699994, 50.47370026200008],
              [-59.69408118399991, 50.46112702000005],
              [-59.72533118399991, 50.457139390000066],
              [-59.73497473899994, 50.451605536000045],
              [-59.74388587099992, 50.444647528000075],
              [-59.755848761999914, 50.43829987200007],
              [-59.76805579299992, 50.445013739000046],
              [-59.791005011999914, 50.44041575700004],
              [-59.80308997299994, 50.445746161000045],
              [-59.82384192599994, 50.430528062000064],
              [-59.86229407499991, 50.391058661000045],
              [-59.885609503999945, 50.37689850500004],
              [-59.885609503999945, 50.37067291900007],
              [-59.87755286399994, 50.36994049700007],
              [-59.858306443999936, 50.36383698100008],
              [-59.86367753799993, 50.35191478100006],
              [-59.86241614499994, 50.34052155200004],
              [-59.854725714999915, 50.33185455900008],
              [-59.84093176999994, 50.32843659100007],
              [-59.840687628999945, 50.33555735900006],
              [-59.832142706999946, 50.348944403000075],
              [-59.82213294199994, 50.356634833000044],
              [-59.817290818999936, 50.34642161700003],
              [-59.82725989499994, 50.32807038000004],
              [-59.85065670499995, 50.31358470300006],
              [-59.899281378999945, 50.294907945000034],
              [-59.922718878999945, 50.28880442900004],
              [-59.93496660099993, 50.28416575700004],
              [-59.94025631399995, 50.27789948100008],
              [-59.94432532499991, 50.26109446800007],
              [-59.9544164699999, 50.26422760600008],
              [-59.96694902299993, 50.27240631700005],
              [-59.97866777299993, 50.27106354400007],
              [-59.99632727799991, 50.255072333000044],
              [-60.01675370999993, 50.24469635600008],
              [-60.03941809799994, 50.24323151200008],
              [-60.063710089999915, 50.253973700000074],
              [-60.072336391999954, 50.24591705900008],
              [-60.080922003999945, 50.24388255400004],
              [-60.08967037699995, 50.24359772300005],
              [-60.098500128999945, 50.240301825000074],
              [-60.10220292899993, 50.23688385600008],
              [-60.10850989499994, 50.22882721600007],
              [-60.11156165299991, 50.22601959800005],
              [-60.12328040299991, 50.21869538000004],
              [-60.134877081999946, 50.212998765000066],
              [-60.14012610599991, 50.21552155200004],
              [-60.13267981699994, 50.232855536000045],
              [-60.17365475199995, 50.232855536000045],
              [-60.16193600199995, 50.240220445000034],
              [-60.155506964999915, 50.25079987200007],
              [-60.15298417899993, 50.26268138200004],
              [-60.15298417899993, 50.284857489000046],
              [-60.15347245999993, 50.288397528000075],
              [-60.176991339999915, 50.28746165600006],
              [-60.19904537699995, 50.27574290600006],
              [-60.22256425699993, 50.252386786000045],
              [-60.24649003799993, 50.23468659100007],
              [-60.26984615799995, 50.240301825000074],
              [-60.25890051999994, 50.24632396000004],
              [-60.24876868399991, 50.253973700000074],
              [-60.240345831999946, 50.26325104400007],
              [-60.23501542899993, 50.27448151200008],
              [-60.25059973899994, 50.26890696800007],
              [-60.26329505099994, 50.27094147300005],
              [-60.27208411399994, 50.27985260600008],
              [-60.27603105399993, 50.294907945000034],
              [-60.28587805899991, 50.28497955900008],
              [-60.285715298999946, 50.25328196800007],
              [-60.29369055899991, 50.246527411000045],
              [-60.33165442599994, 50.25242747600004],
              [-60.34984290299991, 50.253241278000075],
              [-60.36538652299993, 50.246527411000045],
              [-60.35802161399994, 50.239935614000046],
              [-60.35411536399994, 50.233587958000044],
              [-60.35586503799993, 50.228583075000074],
              [-60.36538652299993, 50.22601959800005],
              [-60.37462317599994, 50.228623765000066],
              [-60.382069464999915, 50.24310944200005],
              [-60.38927161399994, 50.246527411000045],
              [-60.39622962099992, 50.24872467700004],
              [-60.402455206999946, 50.25275299700007],
              [-60.409087693999936, 50.25458405200004],
              [-60.416900193999936, 50.25023021000004],
              [-60.423817511999914, 50.24437083500004],
              [-60.43077551999994, 50.241400458000044],
              [-60.438384568999936, 50.24180735900006],
              [-60.447336391999954, 50.246527411000045],
              [-60.44115149599992, 50.26080963700008],
              [-60.46914628799993, 50.25547923400006],
              [-60.49917558499993, 50.253973700000074],
              [-60.50796464799993, 50.24957916900007],
              [-60.53001868399991, 50.23033274900007],
              [-60.54043535099993, 50.22601959800005],
              [-60.59992428299995, 50.21637604400007],
              [-60.62205969999991, 50.22300853100006],
              [-60.61864173099991, 50.253973700000074],
              [-60.64045162699995, 50.23725006700005],
              [-60.65111243399991, 50.23106517100007],
              [-60.66706295499995, 50.22601959800005],
              [-60.72227942599994, 50.22601959800005],
              [-60.71922766799992, 50.23004791900007],
              [-60.717681443999936, 50.23338450700004],
              [-60.71662350199995, 50.23663971600007],
              [-60.714833136999914, 50.240301825000074],
              [-60.73623613199993, 50.240342515000066],
              [-60.75230872299994, 50.23423899900007],
              [-60.76598059799994, 50.22337474200003],
              [-60.78034420499995, 50.208970445000034],
              [-60.79405676999994, 50.20465729400007],
              [-60.82127844999991, 50.22223541900007],
              [-60.83836829299992, 50.21979401200008],
              [-60.83112545499995, 50.23725006700005],
              [-60.81554114499994, 50.24896881700005],
              [-60.79596920499995, 50.25633372600004],
              [-60.77692623599995, 50.26080963700008],
              [-60.80264238199993, 50.26707591400009],
              [-60.83556067599994, 50.25633372600004],
              [-60.93081620999993, 50.20294830900008],
              [-60.93455969999991, 50.199326890000066],
              [-60.94245357999995, 50.201239325000074],
              [-60.94591223899994, 50.20575592700004],
              [-60.94762122299994, 50.21238841400009],
              [-60.94701087099992, 50.21320221600007],
              [-60.94904537699995, 50.21556224200003],
              [-60.95213782499991, 50.21820709800005],
              [-60.955067511999914, 50.21979401200008],
              [-60.962961391999954, 50.219916083000044],
              [-60.97618567599994, 50.21348704600007],
              [-60.98232988199993, 50.21238841400009],
              [-60.996937628999945, 50.21674225500004],
              [-61.010975714999915, 50.22296784100007],
              [-61.02611243399991, 50.22724030200004],
              [-61.043812628999945, 50.22601959800005],
              [-61.04869544199994, 50.22174713700008],
              [-61.04991614499994, 50.21503327000005],
              [-61.04987545499995, 50.20860423400006],
              [-61.05064856699994, 50.20555247600004],
              [-61.0579320949999, 50.205918687000064],
              [-61.07852128799993, 50.21238841400009],
              [-61.10586503799993, 50.20555247600004],
              [-61.10586503799993, 50.20372142100007],
              [-61.10802161399994, 50.19953034100007],
              [-61.112538214999915, 50.195013739000046],
              [-61.11953691299993, 50.19249095300006],
              [-61.14858964799993, 50.20250071800007],
              [-61.16063391799992, 50.20172760600008],
              [-61.15306555899991, 50.18504466400009],
              [-61.16588294199994, 50.18541087400007],
              [-61.20457923099991, 50.20140208500004],
              [-61.22541256399995, 50.20555247600004],
              [-61.31135006399995, 50.199326890000066],
              [-61.427723761999914, 50.16864655200004],
              [-61.50625566299993, 50.15814850500004],
              [-61.58503170499995, 50.12999095300006],
              [-61.64077714799993, 50.121161200000074],
              [-61.69493567599994, 50.10313548400006],
              [-61.71788489499994, 50.100043036000045],
              [-61.78429114499994, 50.10313548400006],
              [-61.78429114499994, 50.10993073100008],
              [-61.76406816299993, 50.11127350500004],
              [-61.735259568999936, 50.126654364000046],
              [-61.71910559799994, 50.13043854400007],
              [-61.705637173999946, 50.132147528000075],
              [-61.61241614499994, 50.156683661000045],
              [-61.59561113199993, 50.15839264500005],
              [-61.58165442599994, 50.163763739000046],
              [-61.57380123599995, 50.17560455900008],
              [-61.57607988199993, 50.18736399900007],
              [-61.59251868399991, 50.19249095300006],
              [-61.61091061099995, 50.17450592700004],
              [-61.63744055899991, 50.16657135600008],
              [-61.69493567599994, 50.15839264500005],
              [-61.747710740999935, 50.13825104400007],
              [-61.77676347599993, 50.13414134300007],
              [-61.804798956999946, 50.14411041900007],
              [-61.79674231699994, 50.17206452000005],
              [-61.81558183499993, 50.190741278000075],
              [-61.83934485599991, 50.20502350500004],
              [-61.845773891999954, 50.21979401200008],
              [-61.86318925699993, 50.230169989000046],
              [-61.884877081999946, 50.233710028000075],
              [-61.92454993399991, 50.232855536000045],
              [-61.93618730399993, 50.23517487200007],
              [-61.94908606699994, 50.239447333000044],
              [-61.96157792899993, 50.24127838700008],
              [-61.972320115999935, 50.23655833500004],
              [-61.98273678299995, 50.230536200000074],
              [-61.99632727799991, 50.22736237200007],
              [-62.02391516799992, 50.22601959800005],
              [-62.13377844999991, 50.240301825000074],
              [-62.21247311099995, 50.24176666900007],
              [-62.23680579299992, 50.246527411000045],
              [-62.280506964999915, 50.263373114000046],
              [-62.29979407499991, 50.27374909100007],
              [-62.315012173999946, 50.284369208000044],
              [-62.32697506399995, 50.289170640000066],
              [-62.33967037699995, 50.287543036000045],
              [-62.35204016799992, 50.28351471600007],
              [-62.369211391999954, 50.28021881700005],
              [-62.38003495999993, 50.27684153900009],
              [-62.38361568899995, 50.27789948100008],
              [-62.387562628999945, 50.28502024900007],
              [-62.38780676999994, 50.29087962400007],
              [-62.390288865999935, 50.29450104400007],
              [-62.40062415299991, 50.294907945000034],
              [-62.41242428299995, 50.29059479400007],
              [-62.42031816299993, 50.28229401200008],
              [-62.426991339999915, 50.273504950000074],
              [-62.434803839999915, 50.267645575000074],
              [-62.45055091099994, 50.26548899900007],
              [-62.459095831999946, 50.27061595300006],
              [-62.46670488199993, 50.27769603100006],
              [-62.47948157499991, 50.281236070000034],
              [-62.595692511999914, 50.27728913000004],
              [-62.75072180899991, 50.28746165600006],
              [-62.75072180899991, 50.294907945000034],
              [-62.70913652299993, 50.30919017100007],
              [-62.70913652299993, 50.31541575700004],
              [-62.75499426999994, 50.30528392100007],
              [-62.77806555899991, 50.30267975500004],
              [-62.79165605399993, 50.30919017100007],
              [-62.79865475199995, 50.29901764500005],
              [-62.80846106699994, 50.294256903000075],
              [-62.83263098899994, 50.28746165600006],
              [-62.852447068999936, 50.294256903000075],
              [-62.931630011999914, 50.28746165600006],
              [-62.95962480399993, 50.28819407800006],
              [-62.96983801999994, 50.29132721600007],
              [-62.979725714999915, 50.29832591400009],
              [-62.993072068999936, 50.31342194200005],
              [-63.002023891999954, 50.31700267100007],
              [-63.017648891999954, 50.31541575700004],
              [-63.028553839999915, 50.309759833000044],
              [-63.04466712099992, 50.29246653900009],
              [-63.052398240999935, 50.28746165600006],
              [-63.06798255099994, 50.28620026200008],
              [-63.11042232999995, 50.294907945000034],
              [-63.158273891999954, 50.294907945000034],
              [-63.176665818999936, 50.29014720300006],
              [-63.17516028599994, 50.279364325000074],
              [-63.166005011999914, 50.26776764500005],
              [-63.16161048099991, 50.26080963700008],
              [-63.17711341099994, 50.25153229400007],
              [-63.20287024599992, 50.24510325700004],
              [-63.25064042899993, 50.240301825000074],
              [-63.33478756399995, 50.25031159100007],
              [-63.360218878999945, 50.246527411000045],
              [-63.37047278599994, 50.24046458500004],
              [-63.38703365799995, 50.224595445000034],
              [-63.39500891799992, 50.21979401200008],
              [-63.42064368399991, 50.21898021000004],
              [-63.435536261999914, 50.22020091400009],
              [-63.44220943899995, 50.22288646000004],
              [-63.44790605399993, 50.24213288000004],
              [-63.46320553299995, 50.25531647300005],
              [-63.48501542899993, 50.26353587400007],
              [-63.51040605399993, 50.267645575000074],
              [-63.53628495999993, 50.266831773000035],
              [-63.603505011999914, 50.253973700000074],
              [-63.61156165299991, 50.257147528000075],
              [-63.62604732999995, 50.27122630400004],
              [-63.63768469999991, 50.27448151200008],
              [-63.65086829299992, 50.273138739000046],
              [-63.66075598899994, 50.270819403000075],
              [-63.67039954299992, 50.27033112200007],
              [-63.68236243399991, 50.27448151200008],
              [-63.68854732999995, 50.27985260600008],
              [-63.70030676999994, 50.29523346600007],
              [-63.70962480399993, 50.30174388200004],
              [-63.72215735599991, 50.30426666900007],
              [-63.76797441299993, 50.30174388200004],
              [-63.78001868399991, 50.303900458000044],
              [-63.79979407499991, 50.31321849200003],
              [-63.80899003799993, 50.31541575700004],
              [-63.989165818999936, 50.30695221600007],
              [-64.03441321499992, 50.29718659100007],
              [-64.09585527299993, 50.29087962400007],
              [-64.10692298099991, 50.28746165600006],
              [-64.13442949099993, 50.27033112200007],
              [-64.14476477799991, 50.267645575000074],
              [-64.24746660099993, 50.270697333000044],
              [-64.34862219999991, 50.28803131700005],
              [-64.37100175699993, 50.29832591400009],
              [-64.3899633449999, 50.31004466400009],
              [-64.41673743399991, 50.31854889500005],
              [-64.44542395699995, 50.32294342700004],
              [-64.4700414699999, 50.322251695000034],
              [-64.49181067599994, 50.315659898000035],
              [-64.53262285099993, 50.29840729400007],
              [-64.62938391799992, 50.284043687000064],
              [-64.86782792899993, 50.27448151200008],
              [-64.87682044199994, 50.272650458000044],
              [-64.88125566299993, 50.27256907800006],
              [-64.88833574099993, 50.27448151200008],
              [-64.90269934799994, 50.282538153000075],
              [-64.90737870999993, 50.28693268400008],
              [-64.90200761599993, 50.28746165600006],
              [-64.91600501199991, 50.288275458000044],
              [-64.93781490799995, 50.28282298400006],
              [-65.03380286399994, 50.28416575700004],
              [-65.11705481699994, 50.29743073100008],
              [-65.15103105399993, 50.298895575000074],
              [-65.17267818899995, 50.29120514500005],
              [-65.19131425699993, 50.28729889500005],
              [-65.21694902299993, 50.298529364000046],
              [-65.25829016799992, 50.322251695000034],
              [-65.26593990799995, 50.32062409100007],
              [-65.28897050699993, 50.31159088700008],
              [-65.29991614499994, 50.30919017100007],
              [-65.45689856699994, 50.30174388200004],
              [-65.53160559799994, 50.28412506700005],
              [-65.6243383449999, 50.27696360900006],
              [-65.73717200399994, 50.25743235900006],
              [-65.83849036399994, 50.26048411700003],
              [-65.86164303299995, 50.267645575000074],
              [-65.89366614499994, 50.282416083000044],
              [-65.92918860599991, 50.29283274900007],
              [-65.96422278599994, 50.29319896000004],
              [-65.99502519399994, 50.27789948100008],
              [-66.03506425699993, 50.23541901200008],
              [-66.04653886599993, 50.22601959800005],
              [-66.06273352799991, 50.22125885600008],
              [-66.07917232999995, 50.22227610900006],
              [-66.08775794199994, 50.23033274900007],
              [-66.08071855399993, 50.246527411000045],
              [-66.10338294199994, 50.24408600500004],
              [-66.10521399599992, 50.22801341400009],
              [-66.09654700399994, 50.20762767100007],
              [-66.08751380099994, 50.19249095300006],
              [-66.10936438699991, 50.197373765000066],
              [-66.16185462099992, 50.19578685100004],
              [-66.18004309799994, 50.202460028000075],
              [-66.19505774599992, 50.212591864000046],
              [-66.21288001199991, 50.21771881700005],
              [-66.25202389199995, 50.21979401200008],
              [-66.28807532499991, 50.21466705900008],
              [-66.32323157499991, 50.20530833500004],
              [-66.35704505099994, 50.20140208500004],
              [-66.40444902299993, 50.21820709800005],
              [-66.40941321499992, 50.22247955900008],
              [-66.40623938699991, 50.22943756700005],
              [-66.40444902299993, 50.23627350500004],
              [-66.40583248599995, 50.24669017100007],
              [-66.40908769399994, 50.25726959800005],
              [-66.41307532499991, 50.26422760600008],
              [-66.42955481699994, 50.273138739000046],
              [-66.44888261599993, 50.273545640000066],
              [-66.46816972599993, 50.26850006700005],
              [-66.49893144399994, 50.25250885600008],
              [-66.52928626199991, 50.23033274900007],
              [-66.54312089799993, 50.216131903000075],
              [-66.54954993399991, 50.19830963700008],
              [-66.54100501199991, 50.18439362200007],
              [-66.51207434799994, 50.16461823100008],
              [-66.49762936099995, 50.16950104400007],
              [-66.47150631399995, 50.17413971600007],
              [-66.44513912699995, 50.175889390000066],
              [-66.43016516799992, 50.17206452000005],
              [-66.42845618399991, 50.163397528000075],
              [-66.4348852199999, 50.157538153000075],
              [-66.45128333199995, 50.15094635600008],
              [-66.46125240799995, 50.14476146000004],
              [-66.4661352199999, 50.142686265000066],
              [-66.4973852199999, 50.14630768400008],
              [-66.53319251199991, 50.15839264500005],
              [-66.54332434799994, 50.15875885600008],
              [-66.56346594999991, 50.15717194200005],
              [-66.57412675699993, 50.15839264500005],
              [-66.59093176999994, 50.16453685100004],
              [-66.61807206899994, 50.17951080900008],
              [-66.63560950399994, 50.18504466400009],
              [-66.63630123599995, 50.174994208000044],
              [-66.63434811099995, 50.16596100500004],
              [-66.62975012899994, 50.15802643400008],
              [-66.62254798099991, 50.15094635600008],
              [-66.64395097599993, 50.14630768400008],
              [-66.66592363199993, 50.134751695000034],
              [-66.70107988199993, 50.10655345300006],
              [-66.74592037699995, 50.05365631700005],
              [-66.76593990799995, 50.041083075000074],
              [-66.81395423099991, 50.02753327000005],
              [-66.91209876199991, 50.01129791900007],
              [-66.95091712099992, 49.986436265000066],
              [-66.96768144399994, 49.966782945000034],
              [-66.97508704299992, 49.955511786000045],
              [-66.97887122299994, 49.94489166900007],
              [-66.97541256399995, 49.93610260600008],
              [-66.96857662699995, 49.92491282800006],
              [-66.96593176999994, 49.91539134300007],
              [-66.99136308499993, 49.90314362200007],
              [-67.00389563699991, 49.88377513200004],
              [-67.01488196499992, 49.86094798400006],
              [-67.02660071499992, 49.84239329600007],
              [-67.04491126199991, 49.82831452000005],
              [-67.05565344999991, 49.83234284100007],
              [-67.06802324099993, 49.84312571800007],
              [-67.09117591099994, 49.849310614000046],
              [-67.11290442599994, 49.84406159100007],
              [-67.13145911399994, 49.831284898000035],
              [-67.14622962099992, 49.815659898000035],
              [-67.16588294199994, 49.78807200700004],
              [-67.17471269399994, 49.77179596600007],
              [-67.18154863199993, 49.75486888200004],
              [-67.18431555899991, 49.73936595300006],
              [-67.18032792899993, 49.722723700000074],
              [-67.17271887899994, 49.709051825000074],
              [-67.16734778599994, 49.69517649900007],
              [-67.17003333199995, 49.67796458500004],
              [-67.17992102799991, 49.66551341400009],
              [-67.21275794199994, 49.63739655200004],
              [-67.22524980399993, 49.62335846600007],
              [-67.23086503799993, 49.61155833500004],
              [-67.24510657499991, 49.56810130400004],
              [-67.23399817599994, 49.546087958000044],
              [-67.23159745999993, 49.51398346600007],
              [-67.23599199099993, 49.481634833000044],
              [-67.24510657499991, 49.45884837400007],
              [-67.26817786399994, 49.43345774900007],
              [-67.37633216099994, 49.33921946800007],
              [-67.40111243399991, 49.32969798400006],
              [-67.54930579299992, 49.331244208000044],
              [-67.5833227199999, 49.32750071800007],
              [-67.61506100199995, 49.314886786000045],
              [-67.62897701699995, 49.32127513200004],
              [-67.64488684799994, 49.32054271000004],
              [-67.67398027299993, 49.314886786000045],
              [-67.73546301999994, 49.314886786000045],
              [-67.74592037699995, 49.31321849200003],
              [-67.77464758999992, 49.303574937000064],
              [-67.78355872299994, 49.298163153000075],
              [-67.79430091099994, 49.287217515000066],
              [-67.80308997299994, 49.28196849200003],
              [-67.81407630099994, 49.28021881700005],
              [-67.86139889199995, 49.282538153000075],
              [-67.91771399599992, 49.292954820000034],
              [-67.9446508449999, 49.29437897300005],
              [-67.99583899599992, 49.287217515000066],
              [-68.02643795499995, 49.28668854400007],
              [-68.05455481699994, 49.29437897300005],
              [-68.05846106699994, 49.282456773000035],
              [-68.06566321499992, 49.273504950000074],
              [-68.08242753799993, 49.26023997600004],
              [-68.1223852199999, 49.27134837400007],
              [-68.13585364499994, 49.25568268400008],
              [-68.14317786399994, 49.228583075000074],
              [-68.16437740799995, 49.20563385600008],
              [-68.17198645699995, 49.20416901200008],
              [-68.18968665299991, 49.20587799700007],
              [-68.19786536399994, 49.20563385600008],
              [-68.20604407499991, 49.20250071800007],
              [-68.21979732999995, 49.19371165600006],
              [-68.22887122299994, 49.19196198100008],
              [-68.28368079299992, 49.19432200700004],
              [-68.30089270699995, 49.19818756700005],
              [-68.30089270699995, 49.19196198100008],
              [-68.25397701699995, 49.16705963700008],
              [-68.23542232999995, 49.16400788000004],
              [-68.20335852799991, 49.170355536000045],
              [-68.19054114499994, 49.16746653900009],
              [-68.18358313699991, 49.15098704600007],
              [-68.18358313699991, 49.14354075700004],
              [-68.18106035099993, 49.12445709800005],
              [-68.21963456899994, 49.11200592700004],
              [-68.32542883999992, 49.09845612200007],
              [-68.34292558499993, 49.09015534100007],
              [-68.37661699099993, 49.06903717700004],
              [-68.39232337099992, 49.06391022300005],
              [-68.40892493399991, 49.061753648000035],
              [-68.44432532499991, 49.06163157800006],
              [-68.38206946499992, 49.09992096600007],
              [-68.36978105399993, 49.11558665600006],
              [-68.37189693899995, 49.140326239000046],
              [-68.40648352799991, 49.16368235900006],
              [-68.40330969999991, 49.18451569200005],
              [-68.43325761599993, 49.196153062000064],
              [-68.44432532499991, 49.19818756700005],
              [-68.43016516799992, 49.18390534100007],
              [-68.41783606699994, 49.15839264500005],
              [-68.4094945949999, 49.133978583000044],
              [-68.40705318899995, 49.123032945000034],
              [-68.41759192599994, 49.11985911700003],
              [-68.45177161399994, 49.095770575000074],
              [-68.48721269399994, 49.083685614000046],
              [-68.49616451699995, 49.07843659100007],
              [-68.51500403599994, 49.06989166900007],
              [-68.57481848899994, 49.06049225500004],
              [-68.59508216099994, 49.054754950000074],
              [-68.61510169199994, 49.039496161000045],
              [-68.63459225199995, 49.01703522300005],
              [-68.64452063699991, 48.99115631700005],
              [-68.63609778599994, 48.96539948100008],
              [-68.69880123599995, 48.94489166900007],
              [-68.68862870999993, 48.93235911700003],
              [-68.65542558499993, 48.92963288000004],
              [-68.64354407499991, 48.917669989000046],
              [-68.78380286399994, 48.91083405200004],
              [-68.79531816299993, 48.907416083000044],
              [-68.80284583199995, 48.89948151200008],
              [-68.8086645169999, 48.89020416900007],
              [-68.81480872299994, 48.882879950000074],
              [-68.88312740799995, 48.84703196800007],
              [-68.90680904899995, 48.83978913000004],
              [-68.92467200399994, 48.83038971600007],
              [-68.94961503799993, 48.82575104400007],
              [-68.95417232999995, 48.81940338700008],
              [-68.9551488919999, 48.810532945000034],
              [-68.95946204299992, 48.80097077000005],
              [-68.97443600199995, 48.78819407800006],
              [-68.99111894399994, 48.78229401200008],
              [-69.03734290299991, 48.780462958000044],
              [-69.05573482999995, 48.773504950000074],
              [-69.06956946499992, 48.75621165600006],
              [-69.11790930899991, 48.630560614000046],
              [-69.14443925699993, 48.60053131700005],
              [-69.19155839799993, 48.58869049700007],
              [-69.20059160099993, 48.59088776200008],
              [-69.21060136599993, 48.59483470300006],
              [-69.22052975199995, 48.59650299700007],
              [-69.22948157499991, 48.59210846600007],
              [-69.26781165299991, 48.54328034100007],
              [-69.28062903599994, 48.511053778000075],
              [-69.28783118399991, 48.499335028000075],
              [-69.28937740799995, 48.46458567900004],
              [-69.3255102199999, 48.42527903900009],
              [-69.40444902299993, 48.36273834800005],
              [-69.43008378799993, 48.317694403000075],
              [-69.44664466099994, 48.296210028000075],
              [-69.46963456899994, 48.28705475500004],
              [-69.49242102799991, 48.28192780200004],
              [-69.51195227799991, 48.27000560100004],
              [-69.52989661399994, 48.25617096600007],
              [-69.54784094999991, 48.245428778000075],
              [-69.55435136599993, 48.24469635600008],
              [-69.56908118399991, 48.24669017100007],
              [-69.57518469999991, 48.245428778000075],
              [-69.57966061099995, 48.24042389500005],
              [-69.58043372299994, 48.234808661000045],
              [-69.58023027299993, 48.22943756700005],
              [-69.58202063699991, 48.22553131700005],
              [-69.65453040299991, 48.16290924700007],
              [-69.67601477799991, 48.14988841400009],
              [-69.69871985599991, 48.14362213700008],
              [-69.71275794199994, 48.14447663000004],
              [-69.74714107999995, 48.156683661000045],
              [-69.76170813699991, 48.15843333500004],
              [-69.79832923099991, 48.156683661000045],
              [-69.81989498599995, 48.16193268400008],
              [-69.83690344999991, 48.17487213700008],
              [-69.86314856699994, 48.205064195000034],
              [-69.88231360599991, 48.221136786000045],
              [-69.90257727799991, 48.23273346600007],
              [-69.94513912699995, 48.259100653000075],
              [-69.98509680899991, 48.27842845300006],
              [-70.03758704299992, 48.278631903000075],
              [-70.09365800699993, 48.27256907800006],
              [-70.14435787699995, 48.27338288000004],
              [-70.1673070949999, 48.28339264500005],
              [-70.2110082669999, 48.31500885600008],
              [-70.23346920499995, 48.32172272300005],
              [-70.25902258999992, 48.325059312000064],
              [-70.28351803299995, 48.333319403000075],
              [-70.3692113919999, 48.37413157800006],
              [-70.39289303299995, 48.376939195000034],
              [-70.41494706899994, 48.36583079600007],
              [-70.43517005099994, 48.362982489000046],
              [-70.63438880099994, 48.39683665600006],
              [-70.67735755099994, 48.39154694200005],
              [-70.69298255099994, 48.39280833500004],
              [-70.71288001199991, 48.40367259300007],
              [-70.74718176999994, 48.42755768400008],
              [-70.76671301999994, 48.43500397300005],
              [-70.79206295499995, 48.43781159100007],
              [-70.80345618399991, 48.43622467700004],
              [-70.81358801999994, 48.43317291900007],
              [-70.82412675699993, 48.431748765000066],
              [-70.83641516799992, 48.43467845300006],
              [-70.87755286399994, 48.44953034100007],
              [-70.98721269399994, 48.46515534100007],
              [-71.01162675699993, 48.46234772300005],
              [-71.04796301999994, 48.44904205900008],
              [-71.06981360599991, 48.444647528000075],
              [-70.99767005099994, 48.45298899900007],
              [-70.97362219999991, 48.45148346600007],
              [-70.88760331899994, 48.42161692900004],
              [-70.83263098899994, 48.41478099200003],
              [-70.80589758999992, 48.407456773000035],
              [-70.78848222599993, 48.395697333000044],
              [-70.79206295499995, 48.379746812000064],
              [-70.81139075399994, 48.36969635600008],
              [-70.83853105399993, 48.36461009300007],
              [-70.89167232999995, 48.36273834800005],
              [-70.87877356699994, 48.34760163000004],
              [-70.87385006399995, 48.33380768400008],
              [-70.86563066299993, 48.32416413000004],
              [-70.84325110599991, 48.32172272300005],
              [-70.82677161399994, 48.32566966400009],
              [-70.78180904899995, 48.34845612200007],
              [-70.74449622299994, 48.35533274900007],
              [-70.60049394399994, 48.35643138200004],
              [-70.54527747299994, 48.36273834800005],
              [-70.47752844999991, 48.35643138200004],
              [-70.46275794199994, 48.35187409100007],
              [-70.44322669199994, 48.34275950700004],
              [-70.39248613199993, 48.33812083500004],
              [-70.35960852799991, 48.32843659100007],
              [-70.34585527299993, 48.32603587400007],
              [-70.33429928299995, 48.32123444200005],
              [-70.32384192599994, 48.30109284100007],
              [-70.31126868399991, 48.29950592700004],
              [-70.29735266799992, 48.30267975500004],
              [-70.28774980399993, 48.307481187000064],
              [-70.23058020699995, 48.272772528000075],
              [-70.16295325399994, 48.24506256700005],
              [-70.09264075399994, 48.23484935100004],
              [-70.02765865799995, 48.25287506700005],
              [-70.00422115799995, 48.24201080900008],
              [-69.95030676999994, 48.23082103100006],
              [-69.92491614499994, 48.221869208000044],
              [-69.90623938699991, 48.20726146000004],
              [-69.87002519399994, 48.156683661000045],
              [-69.84666907499991, 48.14276764500005],
              [-69.81802324099993, 48.13471100500004],
              [-69.76048743399991, 48.12995026200008],
              [-69.73595130099994, 48.12250397300005],
              [-69.74242102799991, 48.105536200000074],
              [-69.77440344999991, 48.07477448100008],
              [-69.78091386599993, 48.05772532800006],
              [-69.79283606699994, 48.006293036000045],
              [-69.79491126199991, 47.988714911000045],
              [-69.80138098899994, 47.98383209800005],
              [-69.81476803299995, 47.97752513200004],
              [-69.82583574099993, 47.969956773000035],
              [-69.82559160099993, 47.96149323100008],
              [-69.82408606699994, 47.95307038000004],
              [-69.82656816299993, 47.93992747600004],
              [-69.8352758449999, 47.91705963700008],
              [-69.84679114499994, 47.900091864000046],
              [-69.89419511599993, 47.851629950000074],
              [-69.9055883449999, 47.83445872600004],
              [-69.91930091099994, 47.792303778000075],
              [-69.93203691299993, 47.77305735900006],
              [-69.94298255099994, 47.76536692900004],
              [-69.96768144399994, 47.75462474200003],
              [-69.97984778599994, 47.74640534100007],
              [-70.01695716099994, 47.708319403000075],
              [-70.0344945949999, 47.697333075000074],
              [-70.07530676999994, 47.681708075000074],
              [-70.08629309799994, 47.67405833500004],
              [-70.09972083199995, 47.668076890000066],
              [-70.11510169199994, 47.66856517100007],
              [-70.13060462099992, 47.667303778000075],
              [-70.14435787699995, 47.656358140000066],
              [-70.13711503799993, 47.642279364000046],
              [-70.15514075399994, 47.62604401200008],
              [-70.18163001199991, 47.609808661000045],
              [-70.19957434799994, 47.59552643400008],
              [-70.20616614499994, 47.579779364000046],
              [-70.20685787699995, 47.565741278000075],
              [-70.20543372299994, 47.552801825000074],
              [-70.20579993399991, 47.540269273000035],
              [-70.21011308499993, 47.52838776200008],
              [-70.21743730399993, 47.51703522300005],
              [-70.23688717399995, 47.49559153900009],
              [-70.24803626199991, 47.489569403000075],
              [-70.27839107999995, 47.482123114000046],
              [-70.30223548099991, 47.46942780200004],
              [-70.31745357999995, 47.46629466400009],
              [-70.37539628799993, 47.46141185100004],
              [-70.40737870999993, 47.45335521000004],
              [-70.43712317599994, 47.44236888200004],
              [-70.45909583199995, 47.43048737200007],
              [-70.46662350199995, 47.43455638200004],
              [-70.48029537699995, 47.44004954600007],
              [-70.48692786399994, 47.44476959800005],
              [-70.49705969999991, 47.42926666900007],
              [-70.50690670499995, 47.37962474200003],
              [-70.51740475199995, 47.36896393400008],
              [-70.53376217399995, 47.35956452000005],
              [-70.54845130099994, 47.337591864000046],
              [-70.56891842399995, 47.29328034100007],
              [-70.5977270169999, 47.24941640800006],
              [-70.61742102799991, 47.22752513200004],
              [-70.63438880099994, 47.21816640800006],
              [-70.6856176419999, 47.14923737200007],
              [-70.71495520699995, 47.11758047100005],
              [-70.75064042899993, 47.091782945000034],
              [-70.79165605399993, 47.07241445500006],
              [-70.92031816299993, 47.037217515000066],
              [-70.95685787699995, 47.02065664300005],
              [-71.19102942599994, 46.85805898600006],
              [-71.20010331899994, 46.84825267100007],
              [-71.22288977799991, 46.814520575000074],
              [-71.22687740799995, 46.81004466400009],
              [-71.23192298099991, 46.79840729400007],
              [-71.24478105399993, 46.78896719000005],
              [-71.30247962099992, 46.75885651200008],
              [-71.31786048099991, 46.75665924700007],
              [-71.34166419199994, 46.74233633000006],
              [-71.35399329299992, 46.73899974200003],
              [-71.46320553299995, 46.734483140000066],
              [-71.51475989499994, 46.724717515000066],
              [-71.59292558499993, 46.700832424000055],
              [-71.64419511599993, 46.69318268400008],
              [-71.69395911399994, 46.67438385600008],
              [-71.72020423099991, 46.67007070500006],
              [-71.77204342399995, 46.67007070500006],
              [-71.78294837099992, 46.67222728100006],
              [-71.80333411399994, 46.681626695000034],
              [-71.81265214799993, 46.68374258000006],
              [-71.84024003799993, 46.68699778900009],
              [-71.86091061099995, 46.69175853100006],
              [-71.88052324099993, 46.690659898000035],
              [-71.97203528599994, 46.62950267100007],
              [-72.0137426419999, 46.60773346600007],
              [-72.05540930899991, 46.59434642100007],
              [-72.1419164699999, 46.58071523600006],
              [-72.21247311099995, 46.56102122600004],
              [-72.22793535099993, 46.55337148600006],
              [-72.2363988919999, 46.53624095300006],
              [-72.25169837099992, 46.48232656500005],
              [-72.25804602799991, 46.47085195500006],
              [-72.29678300699993, 46.45099518400008],
              [-72.33714758999992, 46.44350820500006],
              [-72.35741126199991, 46.43667226800005],
              [-72.3926488919999, 46.419175523000035],
              [-72.44078528599994, 46.41193268400008],
              [-72.46226966099994, 46.402329820000034],
              [-72.60252844999991, 46.30133698100008],
              [-72.64509029899995, 46.28652578300006],
              [-72.66755123599995, 46.28392161700003],
              [-72.73786373599995, 46.28652578300006],
              [-72.77122962099992, 46.280910549000055],
              [-72.84447180899991, 46.26479726800005],
              [-72.91397050699993, 46.24241771000004],
              [-72.99449622299994, 46.21080149900007],
              [-72.98595130099994, 46.195298570000034],
              [-73.00462805899991, 46.140692450000074],
              [-73.02204342399995, 46.10960521000004],
              [-73.07164466099994, 46.08974844000005],
              [-73.10635331899994, 46.08726634300007],
              [-73.15855872299994, 46.07485586100006],
              [-73.17931067599994, 46.05304596600007],
              [-73.18211829299992, 46.03477610900006],
              [-73.18687903599994, 46.01837799700007],
              [-73.20409094999991, 45.98346588700008],
              [-73.26231848899994, 45.90224844000005],
              [-73.28990637899994, 45.875067450000074],
              [-73.33446204299992, 45.85464101800005],
              [-73.35586503799993, 45.84153880400004],
              [-73.37254798099991, 45.81118398600006],
              [-73.42027747299994, 45.76512278900009],
              [-73.4954320949999, 45.72789134300007],
              [-73.67739824099993, 45.70815664300005],
              [-73.75544186099995, 45.67637767100007],
              [-73.86270097599993, 45.592637437000064],
              [-73.8926488919999, 45.55906810100004],
              [-73.9024145169999, 45.54075755400004],
              [-73.90953528599994, 45.53473541900007],
              [-73.93423417899993, 45.52993398600006],
              [-73.94579016799992, 45.52399323100008],
              [-73.95645097599993, 45.51609935100004],
              [-73.96467037699995, 45.50816478100006],
              [-73.97923743399991, 45.49843984600005],
              [-74.00108801999994, 45.49127838700008],
              [-74.04344641799992, 45.48399485900006],
              [-74.10484778599994, 45.48501211100006],
              [-74.12555904899995, 45.48973216400009],
              [-74.13597571499992, 45.49079010600008],
              [-74.14745032499991, 45.49437083500004],
              [-74.17381751199991, 45.51813385600008],
              [-74.19009355399993, 45.52830638200004],
              [-74.19904537699995, 45.530910549000055],
              [-74.21475175699993, 45.53237539300005],
              [-74.30695553299995, 45.52553945500006],
              [-74.3216039699999, 45.52879466400009],
              [-74.33486894399994, 45.53701406500005],
              [-74.35952714799993, 45.559475002000056],
              [-74.37946529899995, 45.56163157800006],
              [-74.36558997299994, 45.552842515000066],
              [-74.35277258999992, 45.53823476800005],
              [-74.34288489499994, 45.522365627000056],
              [-74.32970130099994, 45.50967031500005],
              [-74.30695553299995, 45.50446198100008],
              [-74.27733313699991, 45.502793687000064],
              [-74.12653561099995, 45.46544017100007],
              [-74.10147050699993, 45.46344635600008],
              [-74.07770748599995, 45.456691799000055],
              [-74.05728105399993, 45.44448476800005],
              [-74.03770911399994, 45.43846263200004],
              [-74.01610266799992, 45.450425523000035],
              [-74.00865637899994, 45.43618398600006],
              [-74.01471920499995, 45.42031484600005],
              [-74.00194251199991, 45.39610423400006],
              [-73.98078365799995, 45.37148672100005],
              [-73.96153723899994, 45.35423411700003],
              [-73.96841386599993, 45.35203685100004],
              [-73.97150631399995, 45.350490627000056],
              [-73.97516842399995, 45.34739817900004],
              [-74.01349850199995, 45.32843659100007],
              [-74.10936438699991, 45.327460028000075],
              [-74.15330969999991, 45.32013580900008],
              [-74.16893469999991, 45.30801015800006],
              [-74.19961503799993, 45.272365627000056],
              [-74.21133378799993, 45.264878648000035],
              [-74.23375403599994, 45.26211172100005],
              [-74.30711829299992, 45.232407945000034],
              [-74.31383216099994, 45.22809479400007],
              [-74.32144120999993, 45.22500234600005],
              [-74.33454342399995, 45.223944403000075],
              [-74.34618079299992, 45.22056712400007],
              [-74.36400305899991, 45.20612213700008],
              [-74.37547766799992, 45.202785549000055],
              [-74.37889563699991, 45.19993724200003],
              [-74.40249589799993, 45.18663157800006],
              [-74.4134008449999, 45.18227773600006],
              [-74.44416256399995, 45.17837148600006],
              [-74.45433508999992, 45.175441799000055],
              [-74.47305253799993, 45.16437409100007],
              [-74.49364173099991, 45.14622630400004],
              [-74.51024329299992, 45.12490469000005],
              [-74.51699785099993, 45.104396877000056],
              [-74.52627519399994, 45.091131903000075],
              [-74.54796301999994, 45.08022695500006],
              [-74.65306555899991, 45.04254791900007],
              [-74.7129613919999, 44.999253648000035],
              [-74.74155716999991, 44.99885650700007],
              [-74.8684744869999, 45.010121969000025],
              [-74.88650956299989, 45.00939849900003],
              [-74.90374365199997, 45.005212708],
              [-74.94020137599989, 44.98774607400004],
              [-74.99864742099987, 44.97239817300009],
              [-75.01489965799988, 44.965990296000044],
              [-75.05872127399991, 44.94103057800005],
              [-75.0755936279999, 44.93550120000005],
              [-75.12964717599996, 44.92516591400006],
              [-75.27023290999995, 44.863774313000064],
              [-75.3418306069999, 44.81674875900008],
              [-75.45595800799993, 44.74176625600002],
              [-75.57819860899994, 44.6615127570001],
              [-75.69968990099994, 44.581672668000024],
              [-75.75462194799988, 44.52756744400001],
              [-75.7911830249999, 44.496768291000066],
              [-75.8309480389999, 44.46431549100005],
              [-75.84541743999995, 44.43904571500006],
              [-75.85570104999994, 44.42204417000006],
              [-75.87032548099992, 44.4086082970001],
              [-75.89869584199991, 44.39997833300005],
              [-76.06726436399993, 44.34799184200004],
              [-76.14979162699984, 44.30453196200001],
              [-76.17867875199988, 44.27864207000009],
              [-76.17805863499993, 44.27213084000003],
              [-76.16973872899987, 44.24768788700008],
              [-76.16932531799995, 44.24236521400003],
              [-76.18575842299992, 44.225673727000085],
              [-76.20663570199989, 44.21740549800005],
              [-76.31717159099992, 44.185056051000046],
              [-76.3277652589999, 44.18149037700009],
              [-76.33711869299995, 44.173738912],
              [-76.34135616099991, 44.165780742000024],
              [-76.34440506999991, 44.15818430600005],
              [-76.35008947799986, 44.151724752000106],
              [-76.4300329189999, 44.103303935000056],
              [-76.45463090099989, 44.08423533200006],
              [-76.49736730999987, 44.02935496000005],
              [-76.54020707199993, 43.97447458900005],
              [-76.58299515799985, 43.91959421800003],
              [-76.62588659699989, 43.86476552300003],
              [-76.66867468299992, 43.809885153000025],
              [-76.71151444499986, 43.755004781000096],
              [-76.75435420699992, 43.7000985720001],
              [-76.79719397099984, 43.645269877],
              [-76.80272334899985, 43.64278940900003],
              [-76.80830440299988, 43.640308940000054],
              [-76.81378210499986, 43.63788014800009],
              [-76.81936315899986, 43.63542551700003],
              [-76.82489253699987, 43.63289337200003],
              [-76.83047359199989, 43.63043874100008],
              [-76.83600297099989, 43.62803578800002],
              [-76.84153234899989, 43.62550364200003],
              [-77.0723709719999, 43.62633046500004],
              [-77.30320959499994, 43.62710561200005],
              [-77.53399654199984, 43.627854920000075],
              [-77.76483516399986, 43.62865590400007],
              [-77.99567378799989, 43.629431051],
              [-78.2264607349999, 43.630206197000106],
              [-78.4572735189999, 43.63098134400012],
              [-78.68808630399991, 43.63180816700013],
              [-78.75082149299996, 43.617054546000034],
              [-78.94618424499993, 43.546722921000125],
              [-79.07899267599993, 43.49894806000013],
              [-79.17430985599992, 43.46453155500008],
              [-79.09162756399988, 43.34252349900005],
              [-79.05842545599992, 43.27779876700005],
              [-79.05377457699987, 43.26035797100012],
              [-79.04860693399988, 43.17062184700002],
              [-79.04933040399996, 43.1598473100001],
              [-79.05160416699988, 43.14685068800007],
              [-79.05558325199988, 43.13842743],
              [-79.06142268999986, 43.13028839200008],
              [-79.06573767099994, 43.12023732600004],
              [-79.06527258299991, 43.10589711600004],
              [-79.06294714399988, 43.096543681000085],
              [-79.05553157599985, 43.087887879000064],
              [-79.04186315999993, 43.075459697000085],
              [-79.0307527269999, 43.0668038940001],
              [-79.02325964399998, 43.058070578000056],
              [-79.02201940999996, 43.0494147750001],
              [-79.02824641999985, 43.03450612400006],
              [-79.03196712299984, 43.01342214000003],
              [-79.02201940999996, 43.002234193000064],
              [-79.00835099299994, 42.99104624500005],
              [-78.98352046799988, 42.976137593],
              [-78.95995601399989, 42.96621571900009],
              [-78.93633988499997, 42.96004038500011],
              [-78.91525590099994, 42.94761220300005],
              [-78.90905472799994, 42.93022308400002],
              [-78.91895076599994, 42.88924367300008],
              [-78.96305660099992, 42.84012522400003],
              [-79.01938391099992, 42.802685649000054],
              [-79.17275956299991, 42.74801198400009],
              [-79.32618688999989, 42.693338318000045],
              [-79.47964005599988, 42.63871632900002],
              [-79.63301570699986, 42.58404266400005],
              [-79.76300663499987, 42.53770492800005],
              [-79.78639135799992, 42.529368999],
              [-79.9397670089999, 42.47477284800006],
              [-80.0931684979999, 42.42015085900003],
              [-80.24659582599989, 42.365477194000064],
              [-80.37537349499988, 42.3457884730001],
              [-80.50415116399995, 42.326228943],
              [-80.52023319699992, 42.32378209800005],
              [-80.63287715699994, 42.30664357500008],
              [-80.76165482699992, 42.287032369000045],
              [-80.89038081899989, 42.267447002000026],
              [-81.01915848899998, 42.24780995700009],
              [-81.14788448099995, 42.228250427],
              [-81.27666215099995, 42.20866506000006],
              [-81.42021927899995, 42.142157491],
              [-81.56372473199994, 42.07567576100003],
              [-81.70728186099987, 42.00921986900006],
              [-81.85073563599994, 41.9427123010001],
              [-81.99424108899993, 41.87620473300002],
              [-82.1377465409999, 41.809800517000085],
              [-82.28135534699993, 41.74329294900012],
              [-82.42486079999992, 41.676811219000044],
              [-82.45131913299991, 41.67190195700003],
              [-82.6669132079999, 41.66908559200006],
              [-82.7111223959999, 41.680247701000084],
              [-82.86522151699995, 41.752491353000025],
              [-82.98379309099988, 41.80806935700012],
              [-83.06841324999988, 41.847731019],
              [-83.09737788899994, 41.87576548300011],
              [-83.12344864999994, 41.920336405000015],
              [-83.13250661999984, 41.94195280800004],
              [-83.15701249299985, 42.000434876000085],
              [-83.15949296099993, 42.046323548000046],
              [-83.13964921099992, 42.11585418800006],
              [-83.13592850799992, 42.200267639000074],
              [-83.12851293999992, 42.23995514000005],
              [-83.10983190999994, 42.27227874800003],
              [-83.07996293099993, 42.305067444000045],
              [-83.04035294699986, 42.331861674000024],
              [-82.94351131199994, 42.355477804000046],
              [-82.83282039499997, 42.39800750800002],
              [-82.8001350509999, 42.417980449000126],
              [-82.69440506999987, 42.51913706500001],
              [-82.64433060699986, 42.557816874000125],
              [-82.60846716299991, 42.561098328000114],
              [-82.57583349699985, 42.57179534900003],
              [-82.54924597199991, 42.590941468000025],
              [-82.52622412199986, 42.61990610800008],
              [-82.51126379399989, 42.64667450000006],
              [-82.48341019799992, 42.7192540490001],
              [-82.47695064399997, 42.76147369400006],
              [-82.47134374999985, 42.779844666000045],
              [-82.47098201599994, 42.79056752500007],
              [-82.47361751299988, 42.79816396100004],
              [-82.48527054899992, 42.818524476000064],
              [-82.48232499199995, 42.83511261000008],
              [-82.46803645899985, 42.863973898000026],
              [-82.46478084299989, 42.88363678000006],
              [-82.45317948399992, 42.918983460000064],
              [-82.43044185399992, 42.95130706800005],
              [-82.41460302799993, 42.98324310400001],
              [-82.41641170299994, 43.01714284300003],
              [-82.41108902999989, 43.05127512700001],
              [-82.37892045099994, 43.113571066000034],
              [-82.34672603399989, 43.17584116700006],
              [-82.31450577899994, 43.23818878200008],
              [-82.28238887599991, 43.3004847210001],
              [-82.25019445899997, 43.36278066000004],
              [-82.21800004199991, 43.425024923000066],
              [-82.18585729999998, 43.48729502400006],
              [-82.15361120599991, 43.549590963000085],
              [-82.14565303599994, 43.57641103100009],
              [-82.14544632999991, 43.60064727800007],
              [-82.14756506399988, 43.611344299000066],
              [-82.19562414599994, 43.82169321700003],
              [-82.2436832279999, 44.03193878200007],
              [-82.29184566299998, 44.242210185],
              [-82.33987890599994, 44.45242991200011],
              [-82.38788631299988, 44.662701315000035],
              [-82.43602290899986, 44.87297271800007],
              [-82.48408199099993, 45.08324412000009],
              [-82.53214107299996, 45.29351552300004],
              [-82.54828995799994, 45.334598287000105],
              [-82.58877844299985, 45.3718053190001],
              [-82.75943986099992, 45.447201233],
              [-83.01901057999996, 45.561871236000044],
              [-83.19930965299994, 45.641556295],
              [-83.35925282089791, 45.715804524943366],
              [-83.483974, 45.771937],
              [-83.636867, 45.773944],
              [-83.55621293099992, 45.86965606800008],
              [-83.51024674499993, 45.932391256000116],
              [-83.46585668999987, 45.99311106400002],
              [-83.46280778099992, 46.00778717100009],
              [-83.4740990809999, 46.023135071000084],
              [-83.49203080299989, 46.037087707000055],
              [-83.50882564399984, 46.04737131700007],
              [-83.56543717499991, 46.090779521000044],
              [-83.61388382999988, 46.11563588500012],
              [-83.66483679199993, 46.11914988300008],
              [-83.76653601099986, 46.10648915700004],
              [-83.81805741399995, 46.11656606000007],
              [-83.83929642799984, 46.119201559],
              [-83.85642716599989, 46.115739238000046],
              [-83.87267940299989, 46.107884420000104],
              [-83.93073787499989, 46.06695668600007],
              [-83.94730017199987, 46.06060048400006],
              [-83.96458593799989, 46.06318430700007],
              [-83.97639400199998, 46.07310618100006],
              [-83.99582434099995, 46.101166484],
              [-84.00876928799988, 46.1123285930001],
              [-84.01416947499985, 46.1159976200001],
              [-84.02104243999992, 46.151602681000085],
              [-84.05582067899988, 46.17144643200008],
              [-84.08680070099987, 46.20121205700006],
              [-84.09677425099989, 46.224828187000085],
              [-84.09922888299985, 46.23723053000005],
              [-84.09922888299985, 46.25087310800005],
              [-84.10667028899988, 46.27696970600006],
              [-84.1141375329999, 46.2955732220001],
              [-84.11909847099986, 46.314228414000056],
              [-84.11289729899997, 46.327870992000086],
              [-84.10543005399984, 46.347740580000064],
              [-84.12904618399995, 46.37502573700009],
              [-84.14767553699991, 46.399882101000046],
              [-84.15881180899996, 46.43334259100003],
              [-84.1104426679999, 46.526463521000025],
              [-84.14767553699991, 46.54134633400007],
              [-84.1972849119999, 46.54635894800005],
              [-84.24201086499994, 46.526463521000025],
              [-84.30534033199987, 46.501607158000084],
              [-84.35246923799988, 46.522742818000026],
              [-84.38970210799988, 46.52026235000004],
              [-84.42324011199989, 46.511580709],
              [-84.44809647599993, 46.489721578000044],
              [-84.46540808099985, 46.478171896],
              [-84.47830135099986, 46.466467184000024],
              [-84.49217647399993, 46.456881206000034],
              [-84.51230444299989, 46.45163604700009],
              [-84.54129492199988, 46.45282460600002],
              [-84.56656469699993, 46.4611961880001],
              [-84.58940567999994, 46.47512298600007],
              [-84.69368872099997, 46.564859111000075],
              [-84.77332210299991, 46.6334337360001],
              [-84.78745560699986, 46.65717905700005],
              [-84.81644608599993, 46.74590749100007],
              [-84.8354113369999, 46.80386261000011],
              [-84.85419571999998, 46.861171773000066],
              [-84.86373002199988, 46.88194570000012],
              [-84.87869034799985, 46.897913717000066],
              [-84.89494258699995, 46.90514841700012],
              [-84.91116898599995, 46.91248647000002],
              [-84.9274470629999, 46.919669495000065],
              [-84.94367346199991, 46.92700754800008],
              [-84.95997737699992, 46.934242249000036],
              [-84.97620377699994, 46.941476949],
              [-84.99240433799994, 46.948789164000075],
              [-85.00865657599985, 46.955998027000035],
              [-85.13366186599993, 47.00782948800013],
              [-85.25864131699987, 47.05968678800012],
              [-85.38364660699995, 47.11144073500007],
              [-85.50862605899991, 47.16322052000005],
              [-85.63363134799997, 47.21502614400002],
              [-85.75861079899991, 47.26678009000007],
              [-85.8836160889999, 47.318559876000066],
              [-86.00856970299995, 47.370365499000044],
              [-86.1133695069999, 47.41266265900002],
              [-86.21811763499997, 47.45493398100011],
              [-86.32286576399994, 47.4972053020001],
              [-86.4276138919999, 47.53957997700009],
              [-86.53231034399994, 47.581902975],
              [-86.6370584719999, 47.62412262000008],
              [-86.74180660099995, 47.66644561800008],
              [-86.84655472899993, 47.70874277800006],
              [-87.03416601599992, 47.782485047000094],
              [-87.22169978899987, 47.85625315400004],
              [-87.40925939999991, 47.92999542200009],
              [-87.59689652499989, 48.003737692000115],
              [-87.78448197499995, 48.07742828400005],
              [-87.97209326199993, 48.151170553000085],
              [-88.1596787119999, 48.22488698400009],
              [-88.3472641599999, 48.29865509100004],
              [-88.37646134499991, 48.3051146450001],
              [-88.40790645399994, 48.30405527800012],
              [-88.57887792999992, 48.27038808200008],
              [-88.64272416299985, 48.25659047500004],
              [-88.78214717599994, 48.202071838],
              [-88.90462032099992, 48.154296977000044],
              [-89.09525467899991, 48.079934591000026],
              [-89.24552974499994, 48.02117848800005],
              [-89.34038183599992, 47.984152324],
              [-89.36363623099993, 47.97960479700005],
              [-89.38709733099992, 47.98053497300002],
              [-89.46184728999992, 47.99453928600012],
              [-89.49896244399989, 47.995094552000054],
              [-89.59310542799997, 47.99650299100004],
              [-89.65658992599992, 48.00797515900008],
              [-89.67865576299994, 48.00869862900008],
              [-89.7127880459999, 48.00337595600003],
              [-89.72459610999991, 48.00590810200002],
              [-89.74596431499992, 48.01376291900006],
              [-89.76330175899992, 48.0173027550001],
              [-89.78097509799991, 48.01719940200009],
              [-89.80345434699984, 48.01376291900006],
              [-89.90244055199992, 47.98590932300009],
              [-89.92044978899992, 47.987459615],
              [-89.98031693599998, 48.01009389300005],
              [-89.99532893899996, 48.018594666000055],
              [-90.00822220899997, 48.02973093700008],
              [-90.06103552299993, 48.091019186000025],
              [-90.07325699899994, 48.101199443],
              [-90.12038590599985, 48.115358786000044],
              [-90.17862524499986, 48.116443990000036],
              [-90.47062292599992, 48.08988230400003],
              [-90.47785762599997, 48.09153595000008],
              [-90.48346451899991, 48.09448150700008],
              [-90.4904925139999, 48.09623850600006],
              [-90.5018871669999, 48.094274801000026],
              [-90.53160111499997, 48.08455963200008],
              [-90.5420139169999, 48.08373280900007],
              [-90.56219356299988, 48.088848776000034],
              [-90.57387243699986, 48.09789215100001],
              [-90.5868432209999, 48.10481679300007],
              [-90.61107946799987, 48.10349904400003],
              [-90.7013065189999, 48.08455963200008],
              [-90.7503474529999, 48.08399119100004],
              [-90.78646927899993, 48.1004501340001],
              [-90.79670121299992, 48.11706410700002],
              [-90.80305741399994, 48.1471656290001],
              [-90.81230749599985, 48.160989075000046],
              [-90.8238830169999, 48.16832712800003],
              [-90.8342699799999, 48.17178944900009],
              [-90.84300329599998, 48.1769829310001],
              [-90.84972123299991, 48.189566142],
              [-90.84884273399987, 48.1987128710001],
              [-90.83793900599991, 48.21054677300002],
              [-90.84067785699995, 48.22010691400003],
              [-90.87380244999986, 48.23434377100007],
              [-90.92315344299996, 48.227109070000026],
              [-91.00810949799987, 48.194372051000116],
              [-91.02815995299989, 48.18483774900004],
              [-91.07110306899995, 48.17085927400002],
              [-91.20396317599995, 48.10765899700006],
              [-91.23806962199993, 48.08264760400006],
              [-91.27636185799994, 48.0647675580001],
              [-91.36540034999993, 48.057842916000126],
              [-91.42792883399991, 48.0364488740001],
              [-91.44627396699991, 48.040738017000066],
              [-91.46472245299992, 48.04895457000002],
              [-91.4870983489999, 48.05347625800003],
              [-91.57484492999993, 48.04820526200011],
              [-91.58698889199994, 48.05257192000009],
              [-91.58512853999991, 48.06084014900004],
              [-91.57980586799988, 48.070968730000075],
              [-91.58109777899992, 48.080942281],
              [-91.58967606599987, 48.088332012000095],
              [-91.5974792079999, 48.09039906800005],
              [-91.61861486899991, 48.08957224600003],
              [-91.6925121669999, 48.0978663130001],
              [-91.7164383549999, 48.112051494000056],
              [-91.6955093999999, 48.13757965100008],
              [-91.72757462599992, 48.16832712800003],
              [-91.74413692299993, 48.1795925900001],
              [-91.7649883629999, 48.1873440560001],
              [-91.8522440189999, 48.19597401900005],
              [-91.95730220599987, 48.22832346600005],
              [-91.97549230999991, 48.23656585700009],
              [-91.99215795999993, 48.24790883400006],
              [-92.00799678599992, 48.26248158800003],
              [-92.02135514299994, 48.28744130500009],
              [-92.03011429899993, 48.3131761690001],
              [-92.04342097999995, 48.3345960490001],
              [-92.07049943099992, 48.34671417300011],
              [-92.1547320149999, 48.350124818000026],
              [-92.25911840899994, 48.339634502000095],
              [-92.28159765699988, 48.33177968400004],
              [-92.30309505299991, 48.310928243],
              [-92.30141556899994, 48.29064524400006],
              [-92.2920621349999, 48.270336406000055],
              [-92.29102860599991, 48.24956248000011],
              [-92.30366349299996, 48.23927887000012],
              [-92.32787390199994, 48.22943450900006],
              [-92.35381547099988, 48.22289744100006],
              [-92.37185054599988, 48.22258738200007],
              [-92.38464046299995, 48.23240590400006],
              [-92.4182301429999, 48.28204111800004],
              [-92.45138057499989, 48.31268524200006],
              [-92.46246516999992, 48.32929921500006],
              [-92.46706437199995, 48.35322540300008],
              [-92.46758113699991, 48.394282329000035],
              [-92.4745316159999, 48.41048289000004],
              [-92.49062882499996, 48.433117168000095],
              [-92.52693151899993, 48.44562286400007],
              [-92.57052058899987, 48.446656393000055],
              [-92.65705277599997, 48.43823313400007],
              [-92.67712906899993, 48.44174713200003],
              [-92.70405249099994, 48.445157776000045],
              [-92.71890946499988, 48.45978220700003],
              [-92.71064123599984, 48.48288157200001],
              [-92.69136592599989, 48.489857891],
              [-92.64674332699988, 48.49742848800007],
              [-92.62746801899993, 48.502776998000016],
              [-92.63018103099998, 48.51946848600004],
              [-92.64860367899988, 48.536263326000025],
              [-92.72554988699989, 48.54869150800009],
              [-92.88419653299991, 48.579878235000066],
              [-92.95558752499988, 48.61222768200004],
              [-92.97972041799994, 48.61767954600005],
              [-93.13170080599994, 48.62463002500003],
              [-93.25773962499989, 48.630314433000066],
              [-93.38571630899986, 48.61486318000006],
              [-93.41731644699985, 48.60411448200004],
              [-93.45147456899991, 48.597422384000126],
              [-93.45377417099985, 48.58695790700007],
              [-93.45224971499994, 48.57272105000003],
              [-93.45992366599992, 48.55739898700004],
              [-93.49175634799988, 48.542309469000045],
              [-93.5665838219999, 48.53827870700006],
              [-93.59988928299995, 48.52634145100002],
              [-93.6162965499999, 48.53130238900006],
              [-93.75677893099987, 48.51654876700006],
              [-93.77866390099993, 48.51946848600004],
              [-93.80938553899998, 48.543575541000095],
              [-93.83574051999994, 48.61713694300009],
              [-93.87488541799988, 48.636205546000056],
              [-94.03484981299994, 48.64331105600009],
              [-94.23215043199994, 48.65201853500007],
              [-94.25103816799987, 48.657289530000085],
              [-94.25245926899996, 48.66240549700008],
              [-94.25576656099986, 48.683541158000125],
              [-94.2584537359999, 48.6908275360001],
              [-94.26548172999989, 48.697752177],
              [-94.27449926799994, 48.704108378000015],
              [-94.28403356999993, 48.709069316000054],
              [-94.29258601899997, 48.711911520000044],
              [-94.31157710799991, 48.71392690000009],
              [-94.47949967499994, 48.70069773400009],
              [-94.51916133699993, 48.70447011300011],
              [-94.59285192899995, 48.726432597000084],
              [-94.68889257899994, 48.77883249900002],
              [-94.70178584899995, 48.790097962000075],
              [-94.71090673899991, 48.80751292000009],
              [-94.71328385499987, 48.823842672000055],
              [-94.71214697299988, 48.84244618700011],
              [-94.71173356199995, 48.862755026000016],
              [-94.7112167969999, 48.91458648700011],
              [-94.75377233999987, 49.02615590400002],
              [-94.79203873699987, 49.12645986000008],
              [-94.80374344999984, 49.146406963000075],
              [-94.81118485599987, 49.16656077100008],
              [-94.80612056599989, 49.21089915000003],
              [-94.81035803299994, 49.22960601900009],
              [-94.81989233499993, 49.252033590000096],
              [-94.82725622599995, 49.292857972],
              [-94.83914180499997, 49.308877665000026],
              [-94.8561950289999, 49.31828277600009],
              [-94.92608740299988, 49.345567933],
              [-94.98251806699992, 49.35616160100007],
              [-95.10282080099992, 49.35393951500008],
              [-95.1605692139999, 49.3694941210001],
            ],
          ],
          [
            [
              [-67.17601477799994, 45.17865631700006],
              [-67.20616620799987, 45.18940058600005],
              [-67.21907059799992, 45.19212636300007],
              [-67.24242834499995, 45.20256500300012],
              [-67.25498571899996, 45.205045472000094],
              [-67.26733638499991, 45.2025133260001],
              [-67.27720658399991, 45.195071920000075],
              [-67.27922196499995, 45.18737213100009],
              [-67.27958369999993, 45.179052226000024],
              [-67.28464798999991, 45.16969879200009],
              [-67.31921952299993, 45.1538858040001],
              [-67.35627152599989, 45.165926412000076],
              [-67.39053299999989, 45.193108216000056],
              [-67.42758500199994, 45.23656809500007],
              [-67.47130326399994, 45.26628204400005],
              [-67.47502396699986, 45.2823534140001],
              [-67.46866776599992, 45.30183542900009],
              [-67.45905594899992, 45.3184235640001],
              [-67.43456131999994, 45.350307923000074],
              [-67.4288252369999, 45.387049866000055],
              [-67.48231034399993, 45.455521139000055],
              [-67.4932140709999, 45.493141581000074],
              [-67.46753088399993, 45.50828277600009],
              [-67.44303625499995, 45.52218373600006],
              [-67.42618973799998, 45.53344919900003],
              [-67.42210729999996, 45.568795878000046],
              [-67.43130570499997, 45.597941386000045],
              [-67.44996089699993, 45.610808817000034],
              [-67.47579911299997, 45.61297922800013],
              [-67.50639156199989, 45.609826966000085],
              [-67.55186682099992, 45.61044708300004],
              [-67.60752233899987, 45.620058900000046],
              [-67.66033565299989, 45.63737050400006],
              [-67.69077307099988, 45.65380360900012],
              [-67.70482906099988, 45.66419057200004],
              [-67.71046179199993, 45.675404358],
              [-67.7173864339999, 45.685377910000014],
              [-67.72798010299988, 45.692250875000084],
              [-67.73552486199992, 45.690752258000074],
              [-67.74074418099985, 45.683620911000034],
              [-67.74803055899991, 45.67778147400004],
              [-67.76177648899997, 45.680106913000074],
              [-67.78611608899988, 45.6912173460001],
              [-67.80012040199998, 45.69984731100003],
              [-67.80704504399995, 45.712869772000076],
              [-67.81112748299998, 45.76650990800006],
              [-67.80626989799995, 45.781754456],
              [-67.79412593599994, 45.79916941300003],
              [-67.77986324099987, 45.81570587200012],
              [-67.77283524599997, 45.82805654000008],
              [-67.77609086199996, 45.84082061800005],
              [-67.79262731899985, 45.85890737000007],
              [-67.79924190299994, 45.875650534],
              [-67.78735632399992, 45.89001658100001],
              [-67.76942460199984, 45.903969218],
              [-67.7578490809999, 45.91947214800011],
              [-67.75965775599988, 45.928567200000074],
              [-67.76746089699992, 45.935956930000074],
              [-67.77655594999987, 45.942933248000074],
              [-67.78275712099986, 45.950529684000045],
              [-67.78456579699986, 45.96014150000006],
              [-67.78714961799994, 46.09455190000007],
              [-67.78973343999988, 46.22901397800011],
              [-67.79231726099997, 46.36347605400006],
              [-67.79484940699984, 46.49786061600007],
              [-67.79743322799996, 46.63229685500009],
              [-67.80001704999995, 46.76678477000003],
              [-67.80254919499993, 46.90124684700005],
              [-67.80518469299994, 47.03563140900009],
              [-67.80869868999991, 47.075138042],
              [-67.81355627499994, 47.08190765400006],
              [-67.85474239099992, 47.09784983400009],
              [-67.87060705599993, 47.10735829700006],
              [-67.89913244699989, 47.138777568000094],
              [-67.94341914899991, 47.16453827000002],
              [-67.9499820559999, 47.172935689000084],
              [-67.95370275899992, 47.1866299440001],
              [-67.96243607599988, 47.197688700000114],
              [-67.99318355299994, 47.22321685900006],
              [-68.03938228399988, 47.245231018000126],
              [-68.10144567999996, 47.286184591000065],
              [-68.11539831599995, 47.29228241000003],
              [-68.1450605879999, 47.301454977],
              [-68.1560676679999, 47.306674296000025],
              [-68.18433467599988, 47.33313262900002],
              [-68.19704707899993, 47.341400859000046],
              [-68.24644974799995, 47.36057281600007],
              [-68.29972814899992, 47.36783335400004],
              [-68.34783890799991, 47.35850575800002],
              [-68.38204870599989, 47.32780995700007],
              [-68.38483923399986, 47.31587270100003],
              [-68.38339229299996, 47.30713938400005],
              [-68.38561438099987, 47.30171335900006],
              [-68.41021236199995, 47.29742421500002],
              [-68.4225630299999, 47.29310923300004],
              [-68.43532710799988, 47.29127472000003],
              [-68.46674637899991, 47.30569244400006],
              [-68.49201615399997, 47.30755279600005],
              [-68.51800939899994, 47.304762268],
              [-68.53966182499991, 47.299853008000056],
              [-68.58524043799991, 47.282489726000065],
              [-68.60792639199988, 47.269829000000115],
              [-68.62559973199987, 47.25520457000003],
              [-68.64420324699992, 47.24528269400004],
              [-68.6688012299999, 47.243422343000034],
              [-68.71779048699992, 47.245231018000126],
              [-68.76181880799987, 47.237040304000104],
              [-68.88971797699992, 47.19060902900007],
              [-68.90622859699991, 47.19022145700008],
              [-69.0401997479999, 47.249055074000054],
              [-69.05748551499991, 47.26946726500002],
              [-69.06355977599989, 47.29080926600007],
              [-69.06513362599989, 47.29633901000001],
              [-69.06619299399998, 47.329670309000065],
              [-69.05433325199996, 47.389253235000055],
              [-69.05402319399988, 47.41839874300008],
              [-69.06965531399993, 47.431886292000044],
              [-69.22197159899991, 47.459688213],
              [-69.23726782299988, 47.458809713000065],
              [-69.25091040099997, 47.45291860000005],
              [-69.2676277269999, 47.43984446200001],
              [-69.35790645399993, 47.350134176000026],
              [-69.44815934299996, 47.260346375000026],
              [-69.5384639079999, 47.17061025000005],
              [-69.62879431199994, 47.08079661100005],
              [-69.71909887699988, 46.99108632400008],
              [-69.8094034419999, 46.90129852300008],
              [-69.89970800899994, 46.811562398],
              [-69.98996089699997, 46.72169708300008],
              [-70.00776342799992, 46.70407541900009],
              [-70.02362809299993, 46.66128733400008],
              [-70.03272314499989, 46.60976593000008],
              [-70.05008642599992, 46.51127065100009],
              [-70.06181697699989, 46.445409037],
              [-70.0743226729999, 46.419544983],
              [-70.1530517169999, 46.372829488],
              [-70.1674177649999, 46.36817861000013],
              [-70.1883983969999, 46.35841176400008],
              [-70.19702836099992, 46.336862692000025],
              [-70.1995088299999, 46.31526194300004],
              [-70.20188594599995, 46.305495097000104],
              [-70.22369340099988, 46.300792542000025],
              [-70.23617325899997, 46.288338522000046],
              [-70.25340734899996, 46.25149322600002],
              [-70.28089921099993, 46.211857401000046],
              [-70.28480078199988, 46.19185862200003],
              [-70.26332922399985, 46.18322865900008],
              [-70.24924739599993, 46.1627647910001],
              [-70.24400223899991, 46.1410090130001],
              [-70.2494799399999, 46.12059682300007],
              [-70.26444026699994, 46.106592510000056],
              [-70.3003295499999, 46.08928090500005],
              [-70.31262854099995, 46.079565735000116],
              [-70.31136246799991, 46.071865947000035],
              [-70.30477372299993, 46.0659748340001],
              [-70.30079463699994, 46.06173736600006],
              [-70.29609208199986, 46.05786163400002],
              [-70.29301733399993, 46.05403757800006],
              [-70.29200964399985, 46.04866322900001],
              [-70.29430924499988, 46.0449425260001],
              [-70.3036368409999, 46.03848297100005],
              [-70.30614314799988, 46.03533070900009],
              [-70.31689184599992, 45.99900217700012],
              [-70.31629756699994, 45.98298248300007],
              [-70.30394689999989, 45.96861643500007],
              [-70.2804341239999, 45.95931467700005],
              [-70.2631483559999, 45.956834208000075],
              [-70.25593949399985, 45.948876038],
              [-70.26252823899992, 45.92303782100008],
              [-70.28317297399994, 45.89048166900004],
              [-70.31265437899995, 45.86764068600003],
              [-70.38980729199992, 45.82505930600006],
              [-70.40993526299988, 45.81074493500007],
              [-70.41523209699992, 45.80438873300004],
              [-70.41716996299994, 45.793795065000054],
              [-70.4136818039999, 45.787697246],
              [-70.40828161699994, 45.78165110300007],
              [-70.40394079599986, 45.77116078700003],
              [-70.40244217999995, 45.749663391000084],
              [-70.40735144099997, 45.73152496400006],
              [-70.41931453499984, 45.71690053300007],
              [-70.4391324469999, 45.70589345300009],
              [-70.45042374699989, 45.703723044000085],
              [-70.47279964199987, 45.703568014000055],
              [-70.48476273599991, 45.699640605000084],
              [-70.51473506699995, 45.68170888300001],
              [-70.57240596599993, 45.662278544000046],
              [-70.5896142169999, 45.651788229],
              [-70.68679174899992, 45.5727232870001],
              [-70.73032914299995, 45.5079727170001],
              [-70.73200862699989, 45.491591289000056],
              [-70.7228360599999, 45.47092071600004],
              [-70.7073848069999, 45.45639963800009],
              [-70.66816239499985, 45.43903635700006],
              [-70.65025651099998, 45.42746083600012],
              [-70.64131648799986, 45.40849558500007],
              [-70.65358964099988, 45.39547312400005],
              [-70.67578466799992, 45.388703512000106],
              [-70.69673946199993, 45.38865183600008],
              [-70.7180043139999, 45.39728179900003],
              [-70.75255000799987, 45.42234487000003],
              [-70.77187699399994, 45.43004465800003],
              [-70.7948730069999, 45.43040639200002],
              [-70.81298559599989, 45.423430074000024],
              [-70.82598221799992, 45.410459290000105],
              [-70.83383703699988, 45.393096008],
              [-70.8354648449999, 45.37309722900007],
              [-70.8320800379999, 45.32855214400006],
              [-70.83525813799994, 45.30979359900006],
              [-70.84238948599989, 45.301215312000025],
              [-70.86262080899988, 45.29036326100008],
              [-70.87024308299996, 45.28312856100011],
              [-70.87249100799997, 45.274188538],
              [-70.87060481799995, 45.25527496400004],
              [-70.87435135999996, 45.24566314800005],
              [-70.89241227299988, 45.23460439000003],
              [-70.90690751199992, 45.24623158800007],
              [-70.95160762599997, 45.332014466],
              [-70.96811824599985, 45.344520162],
              [-70.99315547799995, 45.3478274540001],
              [-71.0165390629999, 45.34312489800003],
              [-71.02759781899991, 45.33464996300002],
              [-71.03666703399998, 45.32338450100006],
              [-71.0544178879999, 45.3103620400001],
              [-71.06421057199995, 45.3070547490001],
              [-71.08495196099997, 45.3042925780001],
              [-71.08555293799995, 45.304212545000055],
              [-71.09524226999989, 45.30090525300004],
              [-71.11102941899989, 45.287107646],
              [-71.14172521999993, 45.25232940700003],
              [-71.16032873599997, 45.24576650000007],
              [-71.18513342299991, 45.24855702700002],
              [-71.20936966999989, 45.25475819900002],
              [-71.29339554899994, 45.29232696600012],
              [-71.31153397699995, 45.294135641000096],
              [-71.33432328399994, 45.28870961600002],
              [-71.35209997599989, 45.2783226530001],
              [-71.3812454829999, 45.250779114000025],
              [-71.3948880619999, 45.241529033000106],
              [-71.43881302899985, 45.233467510000125],
              [-71.44904496299992, 45.22690460300005],
              [-71.42268998299994, 45.217189434],
              [-71.40656693499997, 45.20494211900008],
              [-71.41302648899992, 45.18618357400008],
              [-71.4416035569999, 45.150681865000124],
              [-71.44599605399989, 45.140294902],
              [-71.4512153739999, 45.12169138600005],
              [-71.45658972199996, 45.11099436500005],
              [-71.49725907399991, 45.06655263300006],
              [-71.50475215699996, 45.05296173100008],
              [-71.50661250799996, 45.037045390000046],
              [-71.50408036399998, 45.01373931900012],
              [-71.50584813699996, 45.01373107500005],
              [-71.60381587799986, 45.013274231000096],
              [-71.70355139199995, 45.01275746700004],
              [-71.80328690599987, 45.0122407030001],
              [-71.90307409699997, 45.011775615],
              [-72.00280961099989, 45.01125885000003],
              [-72.10254512599988, 45.010793762000034],
              [-72.20222896399986, 45.01032867400009],
              [-72.30196447799995, 45.00976023300005],
              [-72.40175166899988, 45.009295146000014],
              [-72.50148718299997, 45.00883005800007],
              [-72.6012743739999, 45.00831329400005],
              [-72.70095821199988, 45.00779653000011],
              [-72.80069372599988, 45.00733144200008],
              [-72.9004809169999, 45.00686635400005],
              [-73.0002681069999, 45.00634959000011],
              [-73.09995194499987, 45.005884502000086],
              [-73.19968745999998, 45.00541941400006],
              [-73.2994229739999, 45.0049026490001],
              [-73.35134085899992, 45.004633645000055],
              [-73.39915848799987, 45.004385885000076],
              [-73.49891984099989, 45.00392079700005],
              [-73.59865535599988, 45.003404033000024],
              [-73.69841670799988, 45.00293894500008],
              [-73.79815222199989, 45.002473857000055],
              [-73.89788773699988, 45.00195709300003],
              [-73.9976490889999, 45.00144032800007],
              [-74.0973846039999, 45.000975240000045],
              [-74.1971459559999, 45.000458476000105],
              [-74.2968814699999, 44.99999338800008],
              [-74.3966169849999, 44.999476623000035],
              [-74.49635249799991, 44.99901153600011],
              [-74.5961138509999, 44.998494772000086],
              [-74.69587520399992, 44.99802968400006],
              [-74.7129613919999, 44.999253648000035],
              [-74.63491777299993, 45.01402415600006],
              [-74.47354081899994, 45.06712474200003],
              [-74.4368383449999, 45.08633047100005],
              [-74.40713456899994, 45.11465078300006],
              [-74.40428626199991, 45.123887437000064],
              [-74.40314693899995, 45.13515859600005],
              [-74.39956620999993, 45.14476146000004],
              [-74.38914954299992, 45.14878978100006],
              [-74.37922115799995, 45.15029531500005],
              [-74.36733964799993, 45.154364325000074],
              [-74.35627193899995, 45.159816799000055],
              [-74.32949785099993, 45.17808665600006],
              [-74.30817623599995, 45.18398672100005],
              [-74.21947180899991, 45.19757721600007],
              [-74.19945227799991, 45.20384349200003],
              [-74.16441809799994, 45.228623765000066],
              [-74.14561926999994, 45.23395416900007],
              [-74.04845130099994, 45.232530015000066],
              [-74.00438391799992, 45.24518463700008],
              [-73.96434485599991, 45.26780833500004],
              [-73.88923092399995, 45.337144273000035],
              [-73.87995357999995, 45.341131903000075],
              [-73.85753333199995, 45.34007396000004],
              [-73.84825598899994, 45.34398021000004],
              [-73.83189856699994, 45.35561758000006],
              [-73.77594967399995, 45.38149648600006],
              [-73.76720130099994, 45.388332424000055],
              [-73.74494381399995, 45.41225820500006],
              [-73.73468990799995, 45.41860586100006],
              [-73.71288001199991, 45.42137278900009],
              [-73.70457923099991, 45.42625560100004],
              [-73.68736731699994, 45.43121979400007],
              [-73.60460364499994, 45.42251211100006],
              [-73.58177649599992, 45.42829010600008],
              [-73.56916256399995, 45.42804596600007],
              [-73.56362870999993, 45.41909414300005],
              [-73.55728105399993, 45.41429271000004],
              [-73.5430395169999, 45.41632721600007],
              [-73.52790279899995, 45.42145416900007],
              [-73.51895097599993, 45.42625560100004],
              [-73.50255286399994, 45.44790273600006],
              [-73.50259355399993, 45.46344635600008],
              [-73.52269446499992, 45.50446198100008],
              [-73.52375240799995, 45.51382070500006],
              [-73.52354895699995, 45.52757396000004],
              [-73.52204342399995, 45.539943752000056],
              [-73.49038652299993, 45.584092515000066],
              [-73.46886145699995, 45.599717515000066],
              [-73.46060136599993, 45.60805898600006],
              [-73.45628821499992, 45.61823151200008],
              [-73.45189368399991, 45.635606187000064],
              [-73.44692949099993, 45.642238674000055],
              [-73.45685787699995, 45.67243073100008],
              [-73.44884192599994, 45.70449453300006],
              [-73.43130449099993, 45.73273346600007],
              [-73.41283118399991, 45.75153229400007],
              [-73.25934811099995, 45.85411204600007],
              [-73.21727454299992, 45.89883047100005],
              [-73.20653235599991, 45.91559479400007],
              [-73.20596269399994, 45.93272532800006],
              [-73.20860755099994, 45.950832424000055],
              [-73.20738684799994, 45.97056712400007],
              [-73.20034745999993, 45.981756903000075],
              [-73.17804928299995, 46.004014390000066],
              [-73.17320716099994, 46.014960028000075],
              [-73.17186438699991, 46.02684153900009],
              [-73.16808020699995, 46.03579336100006],
              [-73.16266842399995, 46.043076890000066],
              [-73.15611731699994, 46.049709377000056],
              [-73.13980058499993, 46.05833567900004],
              [-73.04059811099995, 46.07359446800007],
              [-73.03189042899993, 46.08234284100007],
              [-73.01573645699995, 46.09349192900004],
              [-72.99840247299994, 46.10342031500005],
              [-72.97850501199991, 46.11583079600007],
              [-72.95494544199994, 46.13072337400007],
              [-72.93260657499991, 46.14439524900007],
              [-72.90941321499992, 46.135646877000056],
              [-72.87604732999995, 46.13662344000005],
              [-72.84365800699993, 46.141913153000075],
              [-72.75829016799992, 46.17251211100006],
              [-72.73102779899995, 46.176621812000064],
              [-72.66942298099991, 46.21515534100007],
              [-72.66942298099991, 46.23004791900007],
              [-72.67064368399991, 46.247381903000075],
              [-72.65208899599992, 46.25861237200007],
              [-72.60985266799992, 46.276597398000035],
              [-72.55626380099994, 46.30573151200008],
              [-72.49596106699994, 46.36050039300005],
              [-72.47777258999992, 46.368475653000075],
              [-72.45494544199994, 46.37173086100006],
              [-72.39806067599994, 46.39638906500005],
              [-72.27432206899994, 46.42055898600006],
              [-72.24156653599994, 46.44350820500006],
              [-72.2161352199999, 46.47955963700008],
              [-72.20474199099993, 46.50063711100006],
              [-72.20002193899995, 46.51585521000004],
              [-72.18993079299992, 46.526231187000064],
              [-72.10244706899994, 46.560207424000055],
              [-72.05760657499991, 46.56602610900006],
              [-72.03237870999993, 46.566473700000074],
              [-72.00739498599995, 46.57139720300006],
              [-71.9915258449999, 46.583644924000055],
              [-71.97813880099994, 46.59943268400008],
              [-71.96043860599991, 46.61485423400006],
              [-71.90501868399991, 46.639960028000075],
              [-71.86709550699993, 46.66665273600006],
              [-71.84569251199991, 46.66828034100007],
              [-71.8242895169999, 46.661363023000035],
              [-71.80272376199991, 46.64956289300005],
              [-71.76060950399994, 46.63418203300006],
              [-71.7141820949999, 46.63218821800007],
              [-71.30247962099992, 46.74518463700008],
              [-71.30260169199994, 46.74518463700008],
              [-71.28205318899995, 46.75328196800007],
              [-71.24372311099995, 46.775458075000074],
              [-71.22374426999994, 46.77993398600006],
              [-71.20506751199991, 46.78701406500005],
              [-71.17625891799992, 46.82396067900004],
              [-71.15794837099992, 46.84080638200004],
              [-71.11534583199995, 46.85337962400007],
              [-71.01911373599995, 46.851548570000034],
              [-70.97362219999991, 46.86188385600008],
              [-70.91966712099992, 46.89756907800006],
              [-70.90192623599995, 46.90289948100008],
              [-70.88963782499991, 46.901678778000075],
              [-70.86705481699994, 46.896592515000066],
              [-70.85692298099991, 46.895412502000056],
              [-70.84422766799992, 46.89826080900008],
              [-70.82579505099994, 46.91168854400007],
              [-70.81533769399994, 46.91648997600004],
              [-70.80549068899995, 46.916896877000056],
              [-70.78359941299993, 46.91469961100006],
              [-70.77432206899994, 46.91648997600004],
              [-70.76528886599993, 46.92283763200004],
              [-70.74396725199995, 46.946926174000055],
              [-70.72716223899994, 46.95644765800006],
              [-70.60024980399993, 46.99705638200004],
              [-70.55504309799994, 47.00234609600005],
              [-70.53490149599992, 47.01056549700007],
              [-70.38817298099991, 47.11587148600006],
              [-70.28661048099991, 47.20913320500006],
              [-70.22630774599992, 47.286444403000075],
              [-70.19489498599995, 47.315293687000064],
              [-70.07607988199993, 47.36896393400008],
              [-70.05036373599995, 47.40001048400006],
              [-70.03107662699995, 47.469590562000064],
              [-70.00035559799994, 47.49937571800007],
              [-69.9903051419999, 47.503607489000046],
              [-69.96955318899995, 47.508653062000064],
              [-69.95938066299993, 47.51239655200004],
              [-69.9492895169999, 47.52033112200007],
              [-69.94229081899994, 47.52948639500005],
              [-69.93423417899993, 47.537176825000074],
              [-69.90074622299994, 47.54559967700004],
              [-69.80223548099991, 47.622381903000075],
              [-69.68968665299991, 47.72833893400008],
              [-69.58877519399994, 47.81403229400007],
              [-69.56187903599994, 47.82807038000004],
              [-69.55528723899994, 47.83445872600004],
              [-69.55016028599994, 47.843858140000066],
              [-69.55068925699993, 47.84955475500004],
              [-69.55357825399994, 47.85716380400004],
              [-69.55528723899994, 47.872381903000075],
              [-69.54800370999993, 47.88959381700005],
              [-69.44546464799993, 47.991888739000046],
              [-69.42808997299994, 47.99896881700005],
              [-69.40835527299993, 48.00104401200008],
              [-69.36131751199991, 48.013006903000075],
              [-69.34243730399993, 48.02008698100008],
              [-69.32396399599992, 48.030585028000075],
              [-69.25365149599992, 48.09235260600008],
              [-69.15233313699991, 48.14667389500005],
              [-69.05443274599992, 48.23236725500004],
              [-68.96471106699994, 48.28778717700004],
              [-68.84455318899995, 48.34271881700005],
              [-68.82477779899995, 48.36583079600007],
              [-68.80606035099993, 48.37242259300007],
              [-68.74836178299995, 48.37291087400007],
              [-68.72606360599991, 48.37641022300005],
              [-68.66173255099994, 48.41229889500005],
              [-68.65038001199991, 48.420762437000064],
              [-68.63853919199994, 48.43195221600007],
              [-68.56159420499995, 48.45148346600007],
              [-68.52334550699993, 48.470770575000074],
              [-68.46328691299993, 48.52891673400006],
              [-68.42503821499992, 48.54706452000005],
              [-68.37682044199994, 48.55052317900004],
              [-68.35358639199995, 48.555975653000075],
              [-68.31387285099993, 48.58698151200008],
              [-68.20563717399995, 48.641913153000075],
              [-68.18431555899991, 48.64789459800005],
              [-68.13272050699993, 48.65253327000005],
              [-68.11571204299992, 48.659491278000075],
              [-68.08242753799993, 48.684881903000075],
              [-68.06029212099992, 48.69383372600004],
              [-68.03359941299993, 48.69782135600008],
              [-67.98216712099992, 48.698553778000075],
              [-67.96202551999994, 48.70164622600004],
              [-67.7180883449999, 48.796128648000035],
              [-67.71190344999991, 48.80097077000005],
              [-67.67125403599994, 48.81785716400009],
              [-67.64688066299993, 48.825425523000035],
              [-67.60334225199995, 48.83238353100006],
              [-67.54678300699993, 48.86237213700008],
              [-67.42516028599994, 48.87360260600008],
              [-67.36180579299992, 48.903998114000046],
              [-67.29238847599993, 48.92450592700004],
              [-67.11754309799994, 48.96308014500005],
              [-66.87962805899991, 49.04649485900006],
              [-66.62205969999991, 49.12262604400007],
              [-66.52651933499993, 49.13336823100008],
              [-66.21930904899995, 49.207871812000064],
              [-66.05492102799991, 49.224676825000074],
              [-65.88280188699991, 49.224676825000074],
              [-65.68415279899995, 49.24253978100006],
              [-65.61514238199993, 49.26023997600004],
              [-65.56578528599994, 49.266465562000064],
              [-65.39622962099992, 49.261053778000075],
              [-65.27700761599993, 49.24445221600007],
              [-65.19107011599993, 49.23704661700003],
              [-64.96349036399994, 49.21930573100008],
              [-64.87779700399994, 49.195420640000066],
              [-64.82262122299994, 49.18903229400007],
              [-64.80142167899993, 49.18121979400007],
              [-64.75865637899994, 49.15717194200005],
              [-64.71344967399995, 49.13886139500005],
              [-64.68862870999993, 49.13239166900007],
              [-64.61339270699995, 49.123032945000034],
              [-64.60269120999993, 49.118841864000046],
              [-64.57945716099994, 49.105454820000034],
              [-64.55256100199995, 49.097357489000046],
              [-64.49791419199994, 49.06163157800006],
              [-64.48631751199991, 49.05744049700007],
              [-64.47826087099992, 49.055975653000075],
              [-64.47061113199993, 49.05296458500004],
              [-64.44880123599995, 49.03461334800005],
              [-64.43883216099994, 49.02912018400008],
              [-64.39647376199991, 49.011826890000066],
              [-64.3801977199999, 49.00157298400006],
              [-64.35049394399994, 48.97565338700008],
              [-64.34007727799991, 48.97020091400009],
              [-64.31090247299994, 48.96442291900007],
              [-64.29873613199993, 48.95921458500004],
              [-64.29515540299991, 48.95482005400004],
              [-64.28661048099991, 48.94049713700008],
              [-64.28164628799993, 48.93439362200007],
              [-64.22118079299992, 48.89435455900008],
              [-64.20645097599993, 48.869574286000045],
              [-64.21678626199991, 48.828233140000066],
              [-64.19196529899995, 48.79962799700007],
              [-64.17487545499995, 48.784491278000075],
              [-64.15534420499995, 48.77423737200007],
              [-64.16881262899994, 48.761826890000066],
              [-64.19009355399993, 48.77281321800007],
              [-64.21202551999994, 48.79120514500005],
              [-64.22736568899995, 48.80097077000005],
              [-64.25308183499993, 48.806341864000046],
              [-64.30333411399994, 48.83026764500005],
              [-64.52965247299994, 48.88239166900007],
              [-64.55939693899995, 48.882879950000074],
              [-64.53758704299992, 48.87632884300007],
              [-64.47744706899994, 48.841905015000066],
              [-64.47744706899994, 48.83567942900004],
              [-64.53921464799993, 48.83002350500004],
              [-64.53892981699994, 48.82139720300006],
              [-64.52159583199995, 48.81700267100007],
              [-64.46007239499994, 48.828233140000066],
              [-64.41844641799992, 48.82640208500004],
              [-64.39720618399991, 48.82135651200008],
              [-64.38805091099994, 48.81114329600007],
              [-64.38390051999994, 48.80805084800005],
              [-64.37657630099994, 48.799994208000044],
              [-64.37409420499995, 48.79169342700004],
              [-64.38438880099994, 48.78790924700007],
              [-64.40786699099993, 48.792669989000046],
              [-64.41832434799994, 48.79120514500005],
              [-64.42906653599994, 48.780462958000044],
              [-64.41738847599993, 48.774603583000044],
              [-64.40794837099992, 48.775824286000045],
              [-64.39883378799993, 48.779364325000074],
              [-64.38805091099994, 48.780462958000044],
              [-64.37633216099994, 48.776231187000064],
              [-64.35366777299993, 48.762884833000044],
              [-64.32795162699995, 48.755845445000034],
              [-64.27818762899994, 48.725816148000035],
              [-64.23542232999995, 48.67808665600006],
              [-64.22052975199995, 48.67059967700004],
              [-64.20518958199995, 48.66697825700004],
              [-64.18968665299991, 48.65757884300007],
              [-64.17503821499992, 48.64447663000004],
              [-64.16218014199995, 48.62962474200003],
              [-64.19310462099992, 48.62299225500004],
              [-64.22716223899994, 48.625067450000074],
              [-64.25767981699994, 48.619208075000074],
              [-64.27818762899994, 48.58869049700007],
              [-64.28213456899994, 48.56903717700004],
              [-64.27887936099995, 48.56126536700003],
              [-64.25088456899994, 48.550767320000034],
              [-64.22154700399994, 48.53367747600004],
              [-64.20645097599993, 48.52802155200004],
              [-64.18883216099994, 48.526597398000035],
              [-64.19953365799995, 48.520697333000044],
              [-64.20645097599993, 48.51325104400007],
              [-64.21251380099994, 48.50482819200005],
              [-64.22052975199995, 48.49583567900004],
              [-64.22887122299994, 48.49213288000004],
              [-64.26455644399994, 48.48627350500004],
              [-64.28600012899994, 48.47923411700003],
              [-64.30553137899994, 48.46942780200004],
              [-64.31993567599994, 48.45587799700007],
              [-64.32603919199994, 48.43781159100007],
              [-64.31236731699994, 48.43158600500004],
              [-64.32909094999991, 48.419623114000046],
              [-64.35960852799991, 48.41303131700005],
              [-64.44448808499993, 48.40684642100007],
              [-64.49624589799993, 48.39366282800006],
              [-64.54515540299991, 48.38751862200007],
              [-64.66258704299992, 48.35016510600008],
              [-64.68321692599994, 48.34031810100004],
              [-64.71104895699995, 48.33930084800005],
              [-64.72325598899994, 48.33539459800005],
              [-64.71202551999994, 48.32920970300006],
              [-64.70470130099994, 48.32371653900009],
              [-64.70181230399993, 48.31708405200004],
              [-64.70400956899994, 48.307481187000064],
              [-64.70783443899995, 48.30174388200004],
              [-64.7141820949999, 48.294907945000034],
              [-64.72118079299992, 48.28937409100007],
              [-64.72695878799993, 48.28705475500004],
              [-64.73131262899994, 48.28400299700007],
              [-64.73778235599991, 48.268784898000035],
              [-64.75694739499994, 48.23973216400009],
              [-64.76573645699995, 48.21898021000004],
              [-64.77936764199995, 48.20404694200005],
              [-64.90884355399993, 48.17719147300005],
              [-64.92446855399993, 48.17625560100004],
              [-64.93846594999991, 48.17731354400007],
              [-64.9505102199999, 48.180853583000044],
              [-64.96035722599993, 48.18768952000005],
              [-64.96369381399995, 48.18585846600007],
              [-64.96353105399993, 48.174994208000044],
              [-64.95913652299993, 48.16095612200007],
              [-64.94981848899994, 48.14984772300005],
              [-64.98786373599995, 48.12596263200004],
              [-65.05162512899994, 48.101629950000074],
              [-65.18101966099994, 48.04283274900007],
              [-65.28555253799993, 48.01264069200005],
              [-65.38491777299993, 48.00926341400009],
              [-65.40444902299993, 48.00145091400009],
              [-65.43219967399995, 48.00328196800007],
              [-65.45938066299993, 48.01080963700008],
              [-65.47740637899994, 48.02008698100008],
              [-65.48151607999995, 48.02606842700004],
              [-65.48717200399994, 48.04132721600007],
              [-65.49168860599991, 48.04682038000004],
              [-65.50340735599991, 48.052069403000075],
              [-65.53600012899994, 48.059881903000075],
              [-65.57721920499995, 48.06403229400007],
              [-65.66763261599993, 48.095811265000066],
              [-65.78384355399993, 48.11558665600006],
              [-65.81997636599993, 48.12995026200008],
              [-65.8587133449999, 48.159369208000044],
              [-65.89045162699995, 48.17059967700004],
              [-65.89297441299993, 48.18768952000005],
              [-65.89098059799994, 48.208197333000044],
              [-65.89574133999992, 48.22553131700005],
              [-65.90440833199995, 48.20880768400008],
              [-65.91295325399994, 48.20079173400006],
              [-65.92406165299991, 48.19835032800006],
              [-65.94041907499991, 48.19822825700004],
              [-65.95303300699993, 48.195379950000074],
              [-65.96401933499993, 48.18829987200007],
              [-66.04600989499994, 48.115220445000034],
              [-66.06704667899993, 48.101996161000045],
              [-66.09557044199994, 48.09715403900009],
              [-66.18309485599991, 48.11570872600004],
              [-66.27061926999994, 48.116522528000075],
              [-66.28685462099992, 48.114488023000035],
              [-66.29979407499991, 48.10822174700007],
              [-66.29206295499995, 48.10541413000004],
              [-66.28429114499994, 48.10337962400007],
              [-66.26504472599993, 48.101996161000045],
              [-66.2747289699999, 48.073106187000064],
              [-66.27936764199995, 48.06732819200005],
              [-66.29002844999991, 48.06517161700003],
              [-66.29613196499992, 48.06940338700008],
              [-66.30064856699994, 48.07611725500004],
              [-66.30663001199991, 48.08152903900009],
              [-66.31257076699995, 48.082017320000034],
              [-66.31956946499992, 48.08100006700005],
              [-66.32530676999994, 48.08116282800006],
              [-66.32774817599994, 48.085272528000075],
              [-66.32909094999991, 48.089911200000074],
              [-66.33263098899994, 48.09483470300006],
              [-66.33706620999993, 48.09918854400007],
              [-66.34142005099994, 48.101996161000045],
              [-66.37612870999993, 48.11420319200005],
              [-66.47329667899993, 48.12010325700004],
              [-66.51537024599992, 48.10809967700004],
              [-66.53319251199991, 48.07099030200004],
              [-66.54279537699995, 48.058661200000074],
              [-66.58507239499994, 48.06126536700003],
              [-66.59996497299994, 48.04474518400008],
              [-66.61204993399991, 48.04669830900008],
              [-66.63219153599994, 48.05426666900007],
              [-66.64391028599994, 48.05186595300006],
              [-66.65038001199991, 48.04625071800007],
              [-66.6555883449999, 48.039496161000045],
              [-66.66348222599993, 48.03375885600008],
              [-66.69880123599995, 48.02403392100007],
              [-66.74852454299992, 48.01780833500004],
              [-66.77301998599995, 48.00804271000004],
              [-66.78579667899993, 48.005845445000034],
              [-66.81773841099994, 48.00633372600004],
              [-66.83315995999993, 48.00450267100007],
              [-66.84788977799991, 47.99896881700005],
              [-66.84300696499992, 47.99681224200003],
              [-66.83409583199995, 47.99290599200003],
              [-66.81753495999993, 47.991522528000075],
              [-66.7864477199999, 47.992173570000034],
              [-66.74990800699993, 47.98578522300005],
              [-66.73151607999995, 47.98651764500005],
              [-66.68578040299991, 48.00763580900008],
              [-66.61351477799991, 48.01085032800006],
              [-66.58438066299993, 48.02317942900004],
              [-66.55760657499991, 48.03819407800006],
              [-66.38589433499993, 48.07514069200005],
              [-66.35529537699995, 48.06928131700005],
              [-66.36192786399994, 48.04059479400007],
              [-66.34512285099993, 48.02142975500004],
              [-66.31899980399993, 48.011053778000075],
              [-66.28937740799995, 48.00665924700007],
              [-66.26195227799991, 48.005845445000034],
              [-66.25422115799995, 48.00108470300006],
              [-66.24673417899993, 47.99176666900007],
              [-66.23835201699995, 47.98517487200007],
              [-66.21593176999994, 47.99323151200008],
              [-66.20225989499994, 47.99017975500004],
              [-66.17690995999993, 47.97911204600007],
              [-65.97085527299993, 47.923895575000074],
              [-65.86611894399994, 47.91693756700005],
              [-65.81786048099991, 47.907416083000044],
              [-65.77220618399991, 47.882920640000066],
              [-65.74120032499991, 47.84857819200005],
              [-65.68968665299991, 47.724676825000074],
              [-65.67784583199995, 47.708685614000046],
              [-65.66364498599995, 47.69550202000005],
              [-65.62881425699993, 47.67064036700003],
              [-65.66364498599995, 47.657456773000035],
              [-65.66917883999992, 47.656358140000066],
              [-65.66710364499994, 47.64533112200007],
              [-65.65811113199993, 47.63764069200005],
              [-65.64631100199995, 47.63080475500004],
              [-65.63573157499991, 47.622259833000044],
              [-65.60606848899994, 47.65643952000005],
              [-65.59105383999992, 47.669175523000035],
              [-65.56676184799994, 47.67747630400004],
              [-65.49901282499991, 47.67926666900007],
              [-65.47740637899994, 47.683701890000066],
              [-65.43736731699994, 47.706244208000044],
              [-65.36363684799994, 47.76203034100007],
              [-65.28498287699995, 47.781683661000045],
              [-65.20933997299994, 47.81968821800007],
              [-65.02574622299994, 47.849595445000034],
              [-64.97777258999992, 47.84198639500005],
              [-65.05455481699994, 47.80304596600007],
              [-65.07335364499994, 47.77989329600007],
              [-65.06065833199995, 47.781317450000074],
              [-65.03966223899994, 47.78624095300006],
              [-64.99022376199991, 47.79063548400006],
              [-64.90611731699994, 47.81073639500005],
              [-64.85627193899995, 47.81586334800005],
              [-64.82628333199995, 47.81549713700008],
              [-64.80003821499992, 47.80927155200004],
              [-64.78595943899995, 47.79356517100007],
              [-64.78970292899993, 47.77130768400008],
              [-64.80943762899994, 47.761419989000046],
              [-64.86046301999994, 47.75938548400006],
              [-64.86046301999994, 47.75254954600007],
              [-64.84203040299991, 47.748114325000074],
              [-64.80264238199993, 47.74595774900007],
              [-64.78595943899995, 47.73895905200004],
              [-64.78335527299993, 47.73322174700007],
              [-64.78233801999994, 47.71662018400008],
              [-64.77847245999993, 47.711004950000074],
              [-64.76390540299991, 47.70807526200008],
              [-64.75767981699994, 47.714911200000074],
              [-64.75690670499995, 47.723089911000045],
              [-64.75865637899994, 47.724676825000074],
              [-64.75743567599994, 47.73224518400008],
              [-64.76081295499995, 47.74546946800007],
              [-64.75865637899994, 47.75254954600007],
              [-64.75300045499995, 47.75726959800005],
              [-64.73570716099994, 47.76447174700007],
              [-64.73078365799995, 47.765611070000034],
              [-64.71825110599991, 47.76158274900007],
              [-64.68016516799992, 47.74131907800006],
              [-64.66860917899993, 47.732123114000046],
              [-64.6848852199999, 47.722723700000074],
              [-64.73936926999994, 47.70140208500004],
              [-64.75121008999992, 47.70075104400007],
              [-64.75763912699995, 47.686387437000064],
              [-64.77334550699993, 47.683294989000046],
              [-64.79336503799993, 47.68305084800005],
              [-64.81261145699995, 47.67747630400004],
              [-64.80915279899995, 47.67454661700003],
              [-64.79963131399995, 47.66380442900004],
              [-64.80870520699995, 47.658636786000045],
              [-64.81175696499992, 47.65326569200005],
              [-64.80870520699995, 47.64793528900009],
              [-64.79963131399995, 47.642686265000066],
              [-64.81403561099995, 47.62156810100004],
              [-64.82884680899991, 47.60594310100004],
              [-64.86782792899993, 47.57444896000004],
              [-64.87584387899994, 47.57050202000005],
              [-64.88483639199995, 47.56720612200007],
              [-64.89216061099995, 47.56150950700004],
              [-64.89517167899993, 47.55023834800005],
              [-64.89549719999991, 47.54258860900006],
              [-64.89712480399993, 47.53705475500004],
              [-64.90884355399993, 47.51984284100007],
              [-64.87409420499995, 47.51984284100007],
              [-64.88955644399994, 47.499701239000046],
              [-64.92446855399993, 47.46747467700004],
              [-64.92931067599994, 47.45091380400004],
              [-64.91515051999994, 47.46478913000004],
              [-64.90200761599993, 47.47150299700007],
              [-64.88711503799993, 47.476548570000034],
              [-64.86782792899993, 47.48570384300007],
              [-64.89321855399993, 47.421861070000034],
              [-64.90884355399993, 47.35533274900007],
              [-64.91226152299993, 47.36579010600008],
              [-64.91169186099995, 47.37592194200005],
              [-64.90794837099992, 47.385972398000035],
              [-64.90587317599994, 47.39447663000004],
              [-64.90884355399993, 47.40253327000005],
              [-64.92788652299993, 47.39337799700007],
              [-64.93911699099993, 47.37877024900007],
              [-64.94815019399994, 47.36163971600007],
              [-64.96035722599993, 47.34479401200008],
              [-64.96174068899995, 47.33193594000005],
              [-64.95840410099993, 47.31232330900008],
              [-64.95962480399993, 47.29429759300007],
              [-64.97398841099994, 47.286444403000075],
              [-65.01992753799993, 47.28237539300005],
              [-65.04295813699991, 47.27521393400008],
              [-65.06126868399991, 47.251939195000034],
              [-65.09845943899995, 47.236436265000066],
              [-65.10684160099993, 47.221584377000056],
              [-65.12254798099991, 47.20274485900006],
              [-65.33145097599993, 47.10057200700004],
              [-65.36754309799994, 47.094631252000056],
              [-65.36754309799994, 47.08779531500005],
              [-65.28433183499993, 47.08087799700007],
              [-65.24478105399993, 47.08189524900007],
              [-65.20303300699993, 47.094631252000056],
              [-65.20457923099991, 47.08047109600005],
              [-65.2102758449999, 47.06476471600007],
              [-65.21320553299995, 47.052069403000075],
              [-65.20645097599993, 47.04677969000005],
              [-65.14903723899994, 47.05369700700004],
              [-65.06309973899994, 47.09056224200003],
              [-65.03233801999994, 47.094631252000056],
              [-65.01500403599994, 47.08852773600006],
              [-64.99828040299991, 47.06504954600007],
              [-64.98452714799993, 47.059881903000075],
              [-64.96524003799993, 47.06309642100007],
              [-64.95466061099995, 47.07078685100004],
              [-64.94709225199995, 47.080064195000034],
              [-64.93675696499992, 47.08779531500005],
              [-64.90855872299994, 47.09275950700004],
              [-64.82542883999992, 47.089097398000035],
              [-64.79963131399995, 47.08161041900007],
              [-64.8255102199999, 47.06354401200008],
              [-64.82111568899995, 47.04136790600006],
              [-64.80760657499991, 47.01524485900006],
              [-64.80646725199995, 46.98541901200008],
              [-64.81688391799992, 46.97711823100008],
              [-64.85265051999994, 46.96271393400008],
              [-64.89517167899993, 46.91648997600004],
              [-64.90583248599995, 46.88686758000006],
              [-64.90436764199995, 46.85875071800007],
              [-64.89488684799994, 46.832098700000074],
              [-64.88149980399993, 46.806626695000034],
              [-64.86489824099993, 46.783189195000034],
              [-64.84430904899995, 46.76316966400009],
              [-64.79214433499993, 46.724717515000066],
              [-64.81891842399995, 46.72475820500006],
              [-64.83942623599995, 46.716864325000074],
              [-64.85191809799994, 46.700832424000055],
              [-64.85423743399991, 46.67633698100008],
              [-64.84740149599992, 46.67633698100008],
              [-64.83267167899993, 46.69936758000006],
              [-64.80190995999993, 46.69562409100007],
              [-64.75121008999992, 46.67007070500006],
              [-64.75792395699995, 46.690293687000064],
              [-64.74917558499993, 46.69981517100007],
              [-64.73216712099992, 46.69879791900007],
              [-64.71361243399991, 46.687160549000055],
              [-64.70677649599992, 46.67226797100005],
              [-64.70539303299995, 46.65176015800006],
              [-64.7102758449999, 46.61485423400006],
              [-64.71983801999994, 46.57632070500006],
              [-64.71739661399994, 46.555975653000075],
              [-64.70030676999994, 46.54722728100006],
              [-64.69025631399995, 46.53864166900007],
              [-64.67975826699995, 46.519598700000074],
              [-64.67772376199991, 46.50055573100008],
              [-64.69318600199995, 46.49201080900008],
              [-64.70213782499991, 46.48981354400007],
              [-64.70872962099992, 46.48509349200003],
              [-64.71108964799993, 46.480454820000034],
              [-64.70714270699995, 46.47833893400008],
              [-64.70189368399991, 46.47646719000005],
              [-64.69420325399994, 46.46743398600006],
              [-64.68976803299995, 46.46401601800005],
              [-64.68219967399995, 46.46336497600004],
              [-64.67686926999994, 46.466457424000055],
              [-64.67275956899994, 46.470038153000075],
              [-64.66860917899993, 46.47085195500006],
              [-64.65465247299994, 46.46369049700007],
              [-64.63621985599991, 46.45079173400006],
              [-64.62022864499994, 46.43512604400007],
              [-64.61339270699995, 46.41929759300007],
              [-64.61461341099994, 46.38222890800006],
              [-64.61880449099993, 46.36798737200007],
              [-64.62767493399991, 46.35415273600006],
              [-64.64549719999991, 46.34039948100008],
              [-64.66356360599991, 46.33673737200007],
              [-64.68285071499992, 46.33510976800005],
              [-64.70400956899994, 46.32750071800007],
              [-64.68342037699995, 46.32851797100005],
              [-64.67259680899991, 46.327378648000035],
              [-64.66519120999993, 46.32379791900007],
              [-64.65721594999991, 46.32103099200003],
              [-64.64720618399991, 46.32436758000006],
              [-64.62767493399991, 46.333644924000055],
              [-64.58893795499995, 46.33535390800006],
              [-64.57494055899991, 46.33869049700007],
              [-64.57990475199995, 46.34796784100007],
              [-64.55850175699993, 46.369126695000034],
              [-64.53652910099993, 46.35146719000005],
              [-64.52342688699991, 46.321600653000075],
              [-64.52839107999995, 46.30573151200008],
              [-64.55532792899993, 46.29857005400004],
              [-64.56358801999994, 46.27968984600005],
              [-64.55939693899995, 46.22378164300005],
              [-64.53502356699994, 46.23497142100007],
              [-64.51402747299994, 46.23940664300005],
              [-64.40542558499993, 46.23810455900008],
              [-64.39915930899991, 46.23607005400004],
              [-64.38752193899995, 46.226670640000066],
              [-64.38060462099992, 46.22378164300005],
              [-64.37035071499992, 46.22374095300006],
              [-64.3626195949999, 46.22614166900007],
              [-64.35553951699995, 46.22915273600006],
              [-64.34715735599991, 46.23126862200007],
              [-64.25328528599994, 46.234442450000074],
              [-64.23729407499991, 46.23126862200007],
              [-64.18504798099991, 46.210191148000035],
              [-64.16274980399993, 46.19513580900008],
              [-64.16905676999994, 46.18345774900007],
              [-64.16128495999993, 46.170030015000066],
              [-64.15127519399994, 46.16632721600007],
              [-64.12743079299992, 46.16982656500005],
              [-64.12669837099992, 46.17413971600007],
              [-64.11929277299993, 46.18227773600006],
              [-64.11091061099995, 46.186835028000075],
              [-64.10411536399994, 46.173936265000066],
              [-64.09732011599993, 46.16852448100008],
              [-64.08267167899993, 46.15928782800006],
              [-64.07803300699993, 46.16347890800006],
              [-64.04967200399994, 46.178941148000035],
              [-64.03799394399994, 46.18345774900007],
              [-64.02257239499994, 46.18528880400004],
              [-63.973215298999946, 46.18345774900007],
              [-63.94627844999991, 46.17877838700008],
              [-63.89427649599992, 46.15664297100005],
              [-63.813059048999946, 46.140285549000055],
              [-63.790272589999915, 46.130967515000066],
              [-63.77110755099994, 46.115220445000034],
              [-63.79181881399995, 46.09951406500005],
              [-63.81297766799992, 46.093858140000066],
              [-63.86046301999994, 46.08726634300007],
              [-63.8665258449999, 46.082912502000056],
              [-63.88536536399994, 46.065741278000075],
              [-63.894642706999946, 46.05996328300006],
              [-63.9055883449999, 46.05801015800006],
              [-64.0637914699999, 46.061753648000035],
              [-64.07274329299992, 46.05996328300006],
              [-64.07648678299995, 46.05353424700007],
              [-64.07648678299995, 46.044582424000055],
              [-64.07970130099994, 46.03652578300006],
              [-64.09325110599991, 46.03261953300006],
              [-64.08385169199994, 46.022365627000056],
              [-64.05231686099995, 46.00136953300006],
              [-64.04271399599992, 45.99197011900009],
              [-64.04185950399994, 45.991115627000056],
              [-64.03355872299994, 45.99526601800005],
              [-64.02424068899995, 46.00181712400007],
              [-64.01756751199991, 46.00535716400009],
              [-64.00772050699993, 46.00503164300005],
              [-63.904855923999946, 45.98033274900007],
              [-63.87026933499993, 45.96246979400007],
              [-63.86668860599991, 45.936428127000056],
              [-63.844593878999945, 45.93423086100006],
              [-63.82485917899993, 45.92519765800006],
              [-63.81090247299994, 45.90977610900006],
              [-63.805897589999915, 45.888657945000034],
              [-63.7864477199999, 45.890733140000066],
              [-63.75894120999993, 45.88540273600006],
              [-63.732492641999954, 45.876613674000055],
              [-63.71589107999995, 45.86815013200004],
              [-63.727121548999946, 45.86172109600005],
              [-63.74649003799993, 45.85366445500006],
              [-63.757476365999935, 45.84703196800007],
              [-63.73615475199995, 45.841864325000074],
              [-63.690297003999945, 45.85309479400007],
              [-63.66869055899991, 45.84703196800007],
              [-63.67418372299994, 45.83641185100004],
              [-63.67418372299994, 45.82762278900009],
              [-63.66974850199995, 45.82339101800005],
              [-63.66185462099992, 45.82656484600005],
              [-63.65225175699993, 45.836818752000056],
              [-63.65339107999995, 45.84275950700004],
              [-63.65868079299992, 45.85008372600004],
              [-63.66185462099992, 45.86440664300005],
              [-63.659087693999936, 45.87384674700007],
              [-63.65257727799991, 45.87457916900007],
              [-63.644602016999954, 45.870347398000035],
              [-63.63768469999991, 45.86440664300005],
              [-63.62877356699994, 45.86229075700004],
              [-63.593006964999915, 45.875067450000074],
              [-63.49193274599992, 45.88263580900008],
              [-63.439116990999935, 45.87559642100007],
              [-63.40859941299993, 45.85447825700004],
              [-63.427845831999946, 45.85366445500006],
              [-63.463775193999936, 45.86041901200008],
              [-63.48314368399991, 45.86070384300007],
              [-63.47028561099995, 45.85236237200007],
              [-63.438059048999946, 45.83844635600008],
              [-63.42853756399995, 45.82656484600005],
              [-63.44758053299995, 45.82135651200008],
              [-63.48399817599994, 45.826157945000034],
              [-63.50426184799994, 45.82656484600005],
              [-63.52281653599994, 45.81944407800006],
              [-63.51593990799995, 45.81089915600006],
              [-63.49632727799991, 45.80695221600007],
              [-63.47691809799994, 45.81354401200008],
              [-63.46898352799991, 45.80841705900008],
              [-63.461048956999946, 45.80601634300007],
              [-63.452381964999915, 45.80548737200007],
              [-63.44220943899995, 45.80605703300006],
              [-63.438059048999946, 45.80528392100007],
              [-63.43126380099994, 45.800767320000034],
              [-63.42853756399995, 45.79987213700008],
              [-63.42495683499993, 45.80223216400009],
              [-63.418527798999946, 45.811428127000056],
              [-63.41543535099993, 45.81354401200008],
              [-63.39915930899991, 45.811753648000035],
              [-63.36953691299993, 45.80255768400008],
              [-63.35399329299992, 45.79987213700008],
              [-63.32396399599992, 45.80369700700004],
              [-63.29137122299994, 45.81207916900007],
              [-63.2591039699999, 45.81590403900009],
              [-63.22984778599994, 45.80605703300006],
              [-63.25796464799993, 45.79136790600006],
              [-63.301665818999936, 45.77553945500006],
              [-63.34723873599995, 45.766506252000056],
              [-63.38072669199994, 45.77195872600004],
              [-63.37279212099992, 45.75718821800007],
              [-63.35594641799992, 45.748114325000074],
              [-63.31240800699993, 45.737168687000064],
              [-63.30378170499995, 45.73224518400008],
              [-63.29478919199994, 45.72565338700008],
              [-63.287953253999945, 45.72418854400007],
              [-63.285145636999914, 45.734442450000074],
              [-63.28164628799993, 45.741115627000056],
              [-63.27358964799993, 45.74787018400008],
              [-63.25719153599994, 45.75889720300006],
              [-63.25743567599994, 45.75352610900006],
              [-63.256703253999945, 45.74249909100007],
              [-63.25719153599994, 45.737168687000064],
              [-63.21165930899991, 45.76007721600007],
              [-63.19570878799993, 45.76512278900009],
              [-63.19562740799995, 45.76748281500005],
              [-63.19448808499993, 45.77252838700008],
              [-63.19237219999991, 45.77724844000005],
              [-63.18887285099993, 45.77879466400009],
              [-63.18394934799994, 45.77586497600004],
              [-63.181711391999954, 45.77130768400008],
              [-63.182199673999946, 45.76626211100006],
              [-63.18517005099994, 45.76203034100007],
              [-63.19969641799992, 45.75299713700008],
              [-63.20523027299993, 45.74591705900008],
              [-63.20254472599993, 45.737168687000064],
              [-63.18980872299994, 45.736395575000074],
              [-63.13434811099995, 45.75889720300006],
              [-63.117298956999946, 45.763006903000075],
              [-63.100453253999945, 45.76463450700004],
              [-63.08336341099994, 45.76349518400008],
              [-63.06541907499991, 45.75889720300006],
              [-63.07046464799993, 45.77842845300006],
              [-63.084055141999954, 45.790269273000035],
              [-63.12067623599995, 45.80605703300006],
              [-63.10065670499995, 45.81134674700007],
              [-62.97996985599991, 45.79596588700008],
              [-62.924672003999945, 45.78261953300006],
              [-62.777414516999954, 45.76512278900009],
              [-62.750843878999945, 45.76552969000005],
              [-62.69957434799994, 45.77244700700004],
              [-62.67495683499993, 45.77195872600004],
              [-62.69595292899993, 45.76080963700008],
              [-62.717681443999936, 45.76040273600006],
              [-62.73859615799995, 45.76251862200007],
              [-62.75694739499994, 45.75889720300006],
              [-62.73900305899991, 45.74835846600007],
              [-62.72883053299995, 45.74437083500004],
              [-62.698882615999935, 45.74461497600004],
              [-62.68236243399991, 45.74209219000005],
              [-62.66454016799992, 45.735581773000035],
              [-62.64753170499995, 45.72671133000006],
              [-62.63341223899994, 45.71735260600008],
              [-62.70299231699994, 45.68691640800006],
              [-62.75096594999991, 45.68121979400007],
              [-62.77057857999995, 45.67442454600007],
              [-62.78429114499994, 45.661769924000055],
              [-62.79165605399993, 45.642238674000055],
              [-62.78066972599993, 45.65294017100007],
              [-62.76500403599994, 45.66172923400006],
              [-62.74876868399991, 45.664048570000034],
              [-62.736439581999946, 45.65525950700004],
              [-62.74754798099991, 45.62710195500006],
              [-62.74974524599992, 45.61286041900007],
              [-62.73985755099994, 45.618028062000064],
              [-62.71987870999993, 45.645412502000056],
              [-62.70661373599995, 45.655585028000075],
              [-62.69176184799994, 45.65216705900008],
              [-62.66909745999993, 45.63068268400008],
              [-62.656809048999946, 45.62775299700007],
              [-62.647043423999946, 45.642238674000055],
              [-62.664051886999914, 45.64704010600008],
              [-62.67235266799992, 45.656236070000034],
              [-62.672434048999946, 45.66783274900007],
              [-62.66470292899993, 45.679795640000066],
              [-62.65526282499991, 45.68195221600007],
              [-62.64037024599992, 45.68113841400009],
              [-62.62474524599992, 45.68227773600006],
              [-62.61290442599994, 45.690659898000035],
              [-62.600493943999936, 45.68618398600006],
              [-62.5774633449999, 45.68585846600007],
              [-62.5657445949999, 45.68317291900007],
              [-62.557525193999936, 45.67788320500006],
              [-62.55028235599991, 45.666856187000064],
              [-62.54466712099992, 45.66270579600007],
              [-62.52635657499991, 45.658270575000074],
              [-62.51056881399995, 45.65916575700004],
              [-62.494699673999946, 45.66185130400004],
              [-62.47573808499993, 45.66270579600007],
              [-62.50259355399993, 45.63100820500006],
              [-62.50914466099994, 45.61497630400004],
              [-62.493397589999915, 45.60805898600006],
              [-62.47044837099992, 45.614488023000035],
              [-62.435210740999935, 45.642686265000066],
              [-62.418039516999954, 45.64907461100006],
              [-62.39981035099993, 45.65289948100008],
              [-62.376942511999914, 45.662176825000074],
              [-62.36168372299994, 45.67332591400009],
              [-62.37096106699994, 45.682521877000056],
              [-62.383371548999946, 45.68008047100005],
              [-62.40469316299993, 45.675116278000075],
              [-62.44163977799991, 45.65525950700004],
              [-62.416127081999946, 45.67910390800006],
              [-62.27033443899995, 45.70372142100007],
              [-62.06004798099991, 45.80796946800007],
              [-61.988840298999946, 45.86302317900004],
              [-61.94880123599995, 45.88182200700004],
              [-61.92430579299992, 45.88914622600004],
              [-61.91148841099994, 45.88898346600007],
              [-61.900380011999914, 45.88182200700004],
              [-61.897368943999936, 45.87164948100008],
              [-61.90534420499995, 45.86554596600007],
              [-61.916086391999954, 45.85984935100004],
              [-61.92145748599995, 45.85073476800005],
              [-61.919992641999954, 45.82994212400007],
              [-61.90900631399995, 45.78693268400008],
              [-61.88784745999993, 45.73769765800006],
              [-61.88634192599994, 45.72105540600006],
              [-61.89415442599994, 45.70372142100007],
              [-61.8762914699999, 45.692694403000075],
              [-61.836496548999946, 45.68121979400007],
              [-61.821522589999915, 45.67267487200007],
              [-61.806630011999914, 45.659491278000075],
              [-61.794911261999914, 45.65289948100008],
              [-61.7259008449999, 45.62754954600007],
              [-61.70783443899995, 45.62327708500004],
              [-61.68439693899995, 45.62173086100006],
              [-61.66820227799991, 45.626613674000055],
              [-61.655140753999945, 45.63589101800005],
              [-61.64216061099995, 45.641506252000056],
              [-61.62604732999995, 45.63540273600006],
              [-61.632923956999946, 45.636053778000075],
              [-61.648508266999954, 45.63418203300006],
              [-61.64806067599994, 45.62681712400007],
              [-61.64037024599992, 45.62132396000004],
              [-61.61978105399993, 45.61432526200008],
              [-61.618804490999935, 45.62246328300006],
              [-61.61546790299991, 45.63165924700007],
              [-61.609934048999946, 45.63914622600004],
              [-61.602121548999946, 45.642238674000055],
              [-61.58901933499993, 45.645412502000056],
              [-61.58348548099991, 45.653225002000056],
              [-61.58055579299992, 45.66319407800006],
              [-61.575103318999936, 45.67267487200007],
              [-61.55801347599993, 45.683661200000074],
              [-61.537098761999914, 45.68886953300006],
              [-61.49254309799994, 45.690659898000035],
              [-61.47052975199995, 45.68309153900009],
              [-61.43724524599992, 45.64980703300006],
              [-61.41746985599991, 45.642238674000055],
              [-61.39997311099995, 45.63263580900008],
              [-61.384429490999935, 45.61147695500006],
              [-61.36974036399994, 45.58079661700003],
              [-61.35887610599991, 45.57770416900007],
              [-61.35138912699995, 45.57005442900004],
              [-61.33869381399995, 45.552842515000066],
              [-61.32371985599991, 45.54205963700008],
              [-61.262928839999915, 45.51186758000006],
              [-61.24689693899995, 45.50731028900009],
              [-61.23981686099995, 45.50836823100008],
              [-61.237212693999936, 45.50576406500005],
              [-61.23497473899994, 45.49079010600008],
              [-61.23680579299992, 45.468003648000035],
              [-61.24852454299992, 45.453111070000034],
              [-61.26732337099992, 45.443426825000074],
              [-61.35289466099994, 45.413397528000075],
              [-61.37279212099992, 45.40884023600006],
              [-61.37409420499995, 45.42125071800007],
              [-61.38809160099993, 45.418036200000074],
              [-61.40566972599993, 45.407538153000075],
              [-61.41746985599991, 45.39858633000006],
              [-61.42983964799993, 45.39199453300006],
              [-61.48265540299991, 45.37474192900004],
              [-61.46153723899994, 45.35484446800007],
              [-61.45075436099995, 45.34935130400004],
              [-61.13687089799993, 45.35423411700003],
              [-61.11961829299992, 45.35211823100008],
              [-61.08177649599992, 45.342678127000056],
              [-60.99864661399994, 45.33315664300005],
              [-60.98232988199993, 45.32632070500006],
              [-60.97118079299992, 45.31386953300006],
              [-60.97061113199993, 45.30174388200004],
              [-60.97256425699993, 45.28823476800005],
              [-60.96865800699993, 45.27163320500006],
              [-60.98306230399993, 45.27130768400008],
              [-60.98713131399995, 45.277004299000055],
              [-60.98875891799992, 45.28530508000006],
              [-60.99600175699993, 45.29214101800005],
              [-61.00694739499994, 45.294256903000075],
              [-61.01707923099991, 45.29368724200003],
              [-61.02696692599994, 45.29433828300006],
              [-61.03697669199994, 45.29962799700007],
              [-61.028553839999915, 45.28530508000006],
              [-61.02334550699993, 45.27846914300005],
              [-61.016468878999945, 45.27163320500006],
              [-61.02407792899993, 45.263006903000075],
              [-61.031320766999954, 45.26085032800006],
              [-61.03880774599992, 45.259833075000074],
              [-61.04723059799994, 45.25462474200003],
              [-61.05345618399991, 45.24453359600005],
              [-61.056630011999914, 45.235988674000055],
              [-61.06297766799992, 45.232530015000066],
              [-61.07852128799993, 45.237534898000035],
              [-61.071156378999945, 45.223944403000075],
              [-61.11974036399994, 45.21344635600008],
              [-61.13939368399991, 45.218003648000035],
              [-61.15306555899991, 45.237534898000035],
              [-61.14220130099994, 45.245021877000056],
              [-61.13345292899993, 45.252834377000056],
              [-61.12612870999993, 45.26162344000005],
              [-61.11953691299993, 45.27163320500006],
              [-61.16470292899993, 45.263657945000034],
              [-61.17479407499991, 45.25804271000004],
              [-61.179798956999946, 45.24249909100007],
              [-61.17072506399995, 45.215725002000056],
              [-61.17479407499991, 45.202785549000055],
              [-61.18423417899993, 45.20848216400009],
              [-61.188059048999946, 45.21544017100007],
              [-61.18993079299992, 45.22304922100005],
              [-61.19668535099993, 45.235256252000056],
              [-61.20425370999993, 45.245754299000055],
              [-61.21206620999993, 45.25299713700008],
              [-61.215728318999936, 45.247707424000055],
              [-61.24600175699993, 45.239488023000035],
              [-61.26305091099994, 45.239162502000056],
              [-61.262928839999915, 45.25112539300005],
              [-61.278553839999915, 45.254014390000066],
              [-61.29873613199993, 45.24791087400007],
              [-61.33177649599992, 45.23069896000004],
              [-61.35057532499991, 45.21735260600008],
              [-61.36506100199995, 45.201239325000074],
              [-61.36461341099994, 45.18960195500006],
              [-61.33869381399995, 45.18976471600007],
              [-61.35464433499993, 45.17763906500005],
              [-61.37100175699993, 45.168850002000056],
              [-61.38914954299992, 45.16356028900009],
              [-61.56786048099991, 45.14712148600006],
              [-61.610585089999915, 45.15062083500004],
              [-61.63963782499991, 45.175441799000055],
              [-61.64728756399995, 45.15684642100007],
              [-61.66588294199994, 45.16396719000005],
              [-61.68712317599994, 45.17536041900007],
              [-61.702381964999915, 45.169256903000075],
              [-61.685658331999946, 45.16193268400008],
              [-61.66616777299993, 45.149318752000056],
              [-61.64915930899991, 45.13462962400007],
              [-61.63963782499991, 45.12083567900004],
              [-61.64952551999994, 45.12156810100004],
              [-61.658192511999914, 45.120347398000035],
              [-61.67442786399994, 45.11465078300006],
              [-61.63963782499991, 45.09357330900008],
              [-61.63963782499991, 45.08730703300006],
              [-61.67723548099991, 45.08848704600007],
              [-61.69493567599994, 45.09141673400006],
              [-61.702381964999915, 45.09727610900006],
              [-61.704335089999915, 45.10704173400006],
              [-61.708648240999935, 45.10724518400008],
              [-61.71544348899994, 45.10097890800006],
              [-61.756418423999946, 45.10097890800006],
              [-61.75454667899993, 45.09414297100005],
              [-61.75503495999993, 45.088771877000056],
              [-61.75617428299995, 45.08429596600007],
              [-61.756418423999946, 45.07990143400008],
              [-61.781361456999946, 45.09235260600008],
              [-61.80972245999993, 45.10093821800007],
              [-61.82526607999995, 45.09902578300006],
              [-61.81163489499994, 45.07990143400008],
              [-61.82209225199995, 45.07794830900008],
              [-61.84601803299995, 45.08022695500006],
              [-61.859364386999914, 45.07990143400008],
              [-61.859364386999914, 45.07306549700007],
              [-61.850819464999915, 45.07046133000006],
              [-61.84162350199995, 45.064520575000074],
              [-61.83617102799991, 45.05613841400009],
              [-61.83893795499995, 45.04637278900009],
              [-61.847645636999914, 45.04478587400007],
              [-61.88048255099994, 45.05320872600004],
              [-61.886708136999914, 45.04637278900009],
              [-61.88239498599995, 45.03416575700004],
              [-61.89688066299993, 45.03066640800006],
              [-61.91844641799992, 45.036769924000055],
              [-61.93517005099994, 45.05320872600004],
              [-61.941517706999946, 45.03310781500005],
              [-61.94131425699993, 45.024644273000035],
              [-61.95946204299992, 45.03648509300007],
              [-61.97573808499993, 45.036037502000056],
              [-61.99054928299995, 45.02651601800005],
              [-62.004017706999946, 45.010972398000035],
              [-62.00572669199994, 45.01634349200003],
              [-62.007923956999946, 45.020738023000035],
              [-62.009755011999914, 45.02553945500006],
              [-62.01024329299992, 45.032131252000056],
              [-62.02025305899991, 45.02610911700003],
              [-62.029408331999946, 45.01935455900008],
              [-62.03897050699993, 45.01357656500005],
              [-62.05060787699995, 45.010972398000035],
              [-62.03465735599991, 45.00405508000006],
              [-61.97606360599991, 44.991115627000056],
              [-61.988840298999946, 44.98493073100008],
              [-62.00348873599995, 44.98281484600005],
              [-62.01821855399993, 44.98484935100004],
              [-62.031320766999954, 44.991115627000056],
              [-62.04214433499993, 44.982407945000034],
              [-62.057525193999936, 44.975490627000056],
              [-62.07339433499993, 44.97296784100007],
              [-62.085926886999914, 44.977443752000056],
              [-62.09780839799993, 44.97345612200007],
              [-62.11872311099995, 44.96971263200004],
              [-62.13853919199994, 44.968817450000074],
              [-62.147368943999936, 44.97378164300005],
              [-62.15151933499993, 44.97516510600008],
              [-62.17398027299993, 44.96043528900009],
              [-62.18492591099994, 44.956366278000075],
              [-62.23375403599994, 44.95929596600007],
              [-62.25454667899993, 44.952012437000064],
              [-62.27033443899995, 44.92906321800007],
              [-62.27774003799993, 44.93650950700004],
              [-62.29002844999991, 44.92723216400009],
              [-62.30614173099991, 44.92007070500006],
              [-62.3216039699999, 44.91754791900007],
              [-62.33177649599992, 44.92226797100005],
              [-62.3391820949999, 44.92226797100005],
              [-62.34024003799993, 44.91779205900008],
              [-62.341867641999954, 44.914943752000056],
              [-62.343861456999946, 44.91242096600007],
              [-62.34601803299995, 44.90859609600005],
              [-62.343006964999915, 44.90525950700004],
              [-62.34203040299991, 44.90330638200004],
              [-62.3391820949999, 44.89492422100005],
              [-62.36115475199995, 44.90216705900008],
              [-62.37734941299993, 44.90997955900008],
              [-62.393422003999945, 44.910264390000066],
              [-62.414906378999945, 44.89492422100005],
              [-62.41038977799991, 44.891913153000075],
              [-62.40566972599993, 44.88580963700008],
              [-62.40062415299991, 44.88125234600005],
              [-62.42039954299992, 44.878241278000075],
              [-62.437163865999935, 44.86851634300007],
              [-62.44766191299993, 44.853176174000055],
              [-62.44839433499993, 44.83348216400009],
              [-62.46715247299994, 44.84137604400007],
              [-62.472767706999946, 44.85899485900006],
              [-62.47313391799992, 44.88076406500005],
              [-62.47573808499993, 44.90110911700003],
              [-62.49046790299991, 44.88141510600008],
              [-62.5071508449999, 44.863389390000066],
              [-62.52708899599992, 44.85586172100005],
              [-62.55150305899991, 44.86758047100005],
              [-62.5657445949999, 44.84023672100005],
              [-62.55528723899994, 44.83274974200003],
              [-62.54662024599992, 44.82501862200007],
              [-62.53099524599992, 44.80621979400007],
              [-62.552723761999914, 44.800116278000075],
              [-62.577788865999935, 44.83340078300006],
              [-62.59923255099994, 44.82664622600004],
              [-62.6067602199999, 44.837144273000035],
              [-62.62319902299993, 44.83030833500004],
              [-62.661366339999915, 44.80621979400007],
              [-62.65392005099994, 44.79254791900007],
              [-62.68724524599992, 44.80211009300007],
              [-62.80532792899993, 44.78506094000005],
              [-62.798817511999914, 44.77183665600006],
              [-62.80260169199994, 44.76109446800007],
              [-62.81289628799993, 44.753973700000074],
              [-62.825835740999935, 44.75157298400006],
              [-62.82135982999995, 44.74363841400009],
              [-62.81517493399991, 44.737616278000075],
              [-62.80736243399991, 44.73301829600007],
              [-62.79792232999995, 44.729803778000075],
              [-62.819243943999936, 44.72060781500005],
              [-62.83043372299994, 44.71775950700004],
              [-62.84260006399995, 44.716782945000034],
              [-62.85147050699993, 44.72296784100007],
              [-62.85757402299993, 44.73375071800007],
              [-62.863840298999946, 44.73786041900007],
              [-62.873605923999946, 44.72361888200004],
              [-62.88744055899991, 44.731309312000064],
              [-62.90855872299994, 44.73802317900004],
              [-62.930246548999946, 44.74005768400008],
              [-62.94562740799995, 44.73350657800006],
              [-62.97256425699993, 44.71743398600006],
              [-62.989491339999915, 44.711004950000074],
              [-62.99714107999995, 44.71369049700007],
              [-62.99787350199995, 44.722316799000055],
              [-62.99962317599994, 44.72719961100006],
              [-63.00186113199993, 44.73126862200007],
              [-63.003977016999954, 44.73729075700004],
              [-63.00291907499991, 44.765285549000055],
              [-63.003977016999954, 44.77138906500005],
              [-63.01854407499991, 44.77798086100006],
              [-63.04702714799993, 44.76622142100007],
              [-63.058583136999914, 44.778225002000056],
              [-63.05931555899991, 44.76325104400007],
              [-63.05028235599991, 44.75047435100004],
              [-63.02098548099991, 44.72671133000006],
              [-63.01402747299994, 44.710598049000055],
              [-63.024322068999936, 44.69684479400007],
              [-63.058583136999914, 44.67519765800006],
              [-63.06285559799994, 44.68862539300005],
              [-63.061431443999936, 44.70465729400007],
              [-63.063059048999946, 44.718003648000035],
              [-63.07591712099992, 44.72361888200004],
              [-63.09561113199993, 44.72915273600006],
              [-63.10195878799993, 44.74266185100004],
              [-63.09951738199993, 44.77480703300006],
              [-63.10265051999994, 44.78400299700007],
              [-63.110218878999945, 44.78986237200007],
              [-63.11937415299991, 44.790676174000055],
              [-63.12743079299992, 44.78506094000005],
              [-63.125070766999954, 44.782131252000056],
              [-63.12067623599995, 44.75157298400006],
              [-63.123890753999945, 44.73484935100004],
              [-63.136789516999954, 44.70677317900004],
              [-63.14049231699994, 44.68886953300006],
              [-63.15392005099994, 44.69554271000004],
              [-63.16047115799995, 44.70567454600007],
              [-63.16055253799993, 44.717678127000056],
              [-63.15477454299992, 44.729803778000075],
              [-63.17324785099993, 44.72105540600006],
              [-63.18317623599995, 44.69163646000004],
              [-63.20254472599993, 44.68268463700008],
              [-63.21393795499995, 44.68121979400007],
              [-63.214100714999915, 44.68301015800006],
              [-63.211822068999936, 44.68980540600006],
              [-63.21621660099993, 44.703192450000074],
              [-63.23232988199993, 44.726670640000066],
              [-63.23668372299994, 44.73729075700004],
              [-63.24982662699995, 44.72593821800007],
              [-63.2532445949999, 44.71149323100008],
              [-63.24840247299994, 44.69765859600005],
              [-63.23668372299994, 44.68886953300006],
              [-63.24974524599992, 44.67267487200007],
              [-63.281320766999954, 44.643459377000056],
              [-63.285145636999914, 44.62742747600004],
              [-63.31712805899991, 44.63613515800006],
              [-63.38906816299993, 44.64313385600008],
              [-63.41543535099993, 44.65534088700008],
              [-63.40257727799991, 44.66461823100008],
              [-63.396555141999954, 44.66705963700008],
              [-63.387562628999945, 44.66836172100005],
              [-63.39903723899994, 44.68203359600005],
              [-63.416900193999936, 44.682928778000075],
              [-63.45579993399991, 44.66836172100005],
              [-63.4348852199999, 44.65928782800006],
              [-63.42064368399991, 44.64826080900008],
              [-63.41543535099993, 44.63361237200007],
              [-63.42170162699995, 44.61375560100004],
              [-63.43895423099991, 44.59634023600006],
              [-63.4563695949999, 44.60073476800005],
              [-63.47606360599991, 44.613389390000066],
              [-63.51016191299993, 44.62409088700008],
              [-63.5384008449999, 44.64785390800006],
              [-63.57363847599993, 44.66559479400007],
              [-63.63263912699995, 44.712958075000074],
              [-63.64411373599995, 44.71727122600004],
              [-63.66185462099992, 44.716782945000034],
              [-63.648996548999946, 44.687567450000074],
              [-63.64012610599991, 44.67617422100005],
              [-63.62775631399995, 44.66836172100005],
              [-63.620350714999915, 44.66705963700008],
              [-63.59642493399991, 44.66836172100005],
              [-63.587554490999935, 44.664170640000066],
              [-63.57396399599992, 44.64590078300006],
              [-63.56875566299993, 44.64170970300006],
              [-63.56354732999995, 44.634833075000074],
              [-63.54857337099992, 44.60293203300006],
              [-63.54515540299991, 44.59332916900007],
              [-63.54572506399995, 44.574204820000034],
              [-63.548085089999915, 44.561428127000056],
              [-63.54649817599994, 44.550116278000075],
              [-63.52326412699995, 44.51813385600008],
              [-63.52379309799994, 44.503241278000075],
              [-63.533314581999946, 44.48887767100007],
              [-63.54857337099992, 44.47321198100008],
              [-63.55406653599994, 44.47028229400007],
              [-63.57339433499993, 44.464178778000075],
              [-63.579335089999915, 44.46352773600006],
              [-63.58690344999991, 44.46906159100007],
              [-63.58462480399993, 44.47496165600006],
              [-63.57970130099994, 44.48033274900007],
              [-63.579335089999915, 44.484035549000055],
              [-63.59618079299992, 44.48737213700008],
              [-63.60464433499993, 44.47691478100006],
              [-63.609934048999946, 44.46303945500006],
              [-63.62071692599994, 44.45270416900007],
              [-63.625884568999936, 44.44586823100008],
              [-63.632801886999914, 44.440741278000075],
              [-63.64142818899995, 44.44245026200008],
              [-63.64370683499993, 44.44961172100005],
              [-63.63898678299995, 44.45840078300006],
              [-63.63198808499993, 44.466131903000075],
              [-63.62775631399995, 44.46979401200008],
              [-63.64159094999991, 44.47593821800007],
              [-63.65811113199993, 44.47520579600007],
              [-63.69286048099991, 44.46979401200008],
              [-63.700835740999935, 44.46759674700007],
              [-63.70274817599994, 44.462958075000074],
              [-63.70555579299992, 44.458238023000035],
              [-63.71589107999995, 44.45612213700008],
              [-63.720773891999954, 44.46067942900004],
              [-63.72411048099991, 44.46946849200003],
              [-63.728627081999946, 44.47500234600005],
              [-63.73692786399994, 44.46979401200008],
              [-63.7493383449999, 44.474269924000055],
              [-63.758371548999946, 44.481350002000056],
              [-63.76357988199993, 44.49135976800005],
              [-63.764881964999915, 44.50450267100007],
              [-63.774281378999945, 44.49355703300006],
              [-63.783314581999946, 44.477850653000075],
              [-63.79336503799993, 44.468410549000055],
              [-63.805897589999915, 44.476629950000074],
              [-63.809437628999945, 44.49013906500005],
              [-63.8040258449999, 44.503241278000075],
              [-63.78477942599994, 44.53184642100007],
              [-63.793080206999946, 44.526271877000056],
              [-63.80528723899994, 44.514553127000056],
              [-63.81212317599994, 44.51133860900006],
              [-63.81989498599995, 44.513780015000066],
              [-63.82603919199994, 44.52049388200004],
              [-63.833973761999914, 44.52448151200008],
              [-63.84683183499993, 44.51870351800005],
              [-63.84447180899991, 44.514878648000035],
              [-63.84007727799991, 44.50450267100007],
              [-63.85366777299993, 44.50429922100005],
              [-63.87401282499991, 44.49860260600008],
              [-63.88780676999994, 44.49705638200004],
              [-63.90054277299993, 44.498114325000074],
              [-63.912220831999946, 44.50096263200004],
              [-63.92202714799993, 44.505519924000055],
              [-63.92943274599992, 44.51133860900006],
              [-63.94249426999994, 44.534043687000064],
              [-63.94172115799995, 44.55430735900006],
              [-63.921986456999946, 44.59332916900007],
              [-63.928578253999945, 44.60000234600005],
              [-63.943023240999935, 44.62051015800006],
              [-63.924712693999936, 44.62881094000005],
              [-63.91860917899993, 44.63414134300007],
              [-63.91510982999995, 44.64170970300006],
              [-63.91954505099994, 44.642564195000034],
              [-63.92943274599992, 44.64785390800006],
              [-63.90217037699995, 44.66648997600004],
              [-63.89085852799991, 44.679795640000066],
              [-63.88841712099992, 44.69635651200008],
              [-63.90672766799992, 44.683661200000074],
              [-63.925852016999954, 44.674709377000056],
              [-63.98961341099994, 44.65582916900007],
              [-64.00080318899995, 44.65534088700008],
              [-64.05695553299995, 44.63882070500006],
              [-64.06598873599995, 44.63426341400009],
              [-64.06021074099993, 44.62124258000006],
              [-64.06191972599993, 44.58665599200003],
              [-64.05260169199994, 44.57965729400007],
              [-64.03669186099995, 44.57090892100007],
              [-64.02497311099995, 44.55068594000005],
              [-64.01134192599994, 44.51133860900006],
              [-64.04124915299991, 44.52260976800005],
              [-64.05557206899994, 44.50885651200008],
              [-64.06387285099993, 44.487616278000075],
              [-64.07583574099993, 44.476629950000074],
              [-64.09707597599993, 44.474717515000066],
              [-64.10619055899991, 44.47760651200008],
              [-64.11750240799995, 44.48745351800005],
              [-64.12364661399994, 44.515611070000034],
              [-64.12401282499991, 44.52187734600005],
              [-64.11876380099994, 44.53750234600005],
              [-64.12804114499994, 44.55491771000004],
              [-64.14484615799995, 44.57021719000005],
              [-64.16218014199995, 44.57965729400007],
              [-64.17808997299994, 44.582139390000066],
              [-64.19762122299994, 44.58030833500004],
              [-64.21149654899995, 44.57135651200008],
              [-64.21056067599994, 44.55231354400007],
              [-64.22736568899995, 44.53701406500005],
              [-64.25275631399995, 44.54376862200007],
              [-64.28083248599995, 44.55817291900007],
              [-64.30553137899994, 44.56598541900007],
              [-64.30068925699993, 44.56089915600006],
              [-64.29255123599995, 44.54547760600008],
              [-64.30386308499993, 44.542629299000055],
              [-64.30483964799993, 44.536037502000056],
              [-64.30125891799992, 44.52651601800005],
              [-64.29873613199993, 44.51504140800006],
              [-64.30134029899995, 44.50259023600006],
              [-64.30801347599993, 44.492295640000066],
              [-64.31688391799992, 44.483710028000075],
              [-64.32603919199994, 44.476629950000074],
              [-64.31773841099994, 44.47642649900007],
              [-64.29873613199993, 44.46979401200008],
              [-64.31041419199994, 44.464911200000074],
              [-64.35391191299993, 44.45612213700008],
              [-64.35366777299993, 44.44513580900008],
              [-64.34390214799993, 44.437608140000066],
              [-64.33560136599993, 44.42910390800006],
              [-64.33971106699994, 44.41514720300006],
              [-64.29686438699991, 44.41705963700008],
              [-64.27529863199993, 44.41543203300006],
              [-64.25772050699993, 44.40892161700003],
              [-64.27501380099994, 44.407131252000056],
              [-64.28823808499993, 44.40094635600008],
              [-64.29987545499995, 44.39329661700003],
              [-64.31236731699994, 44.38719310100004],
              [-64.31236731699994, 44.38100820500006],
              [-64.26065019399994, 44.38027578300006],
              [-64.23558508999992, 44.376613674000055],
              [-64.21056067599994, 44.36733633000006],
              [-64.22793535099993, 44.36050039300005],
              [-64.24620520699995, 44.361314195000034],
              [-64.28164628799993, 44.36733633000006],
              [-64.34715735599991, 44.36733633000006],
              [-64.34715735599991, 44.36050039300005],
              [-64.33971106699994, 44.35606517100007],
              [-64.33576412699995, 44.34983958500004],
              [-64.33568274599992, 44.341864325000074],
              [-64.33971106699994, 44.33258698100008],
              [-64.32583574099993, 44.330145575000074],
              [-64.31517493399991, 44.32379791900007],
              [-64.30504309799994, 44.320379950000074],
              [-64.29255123599995, 44.32632070500006],
              [-64.29771887899994, 44.329331773000035],
              [-64.30728105399993, 44.33702220300006],
              [-64.31236731699994, 44.33999258000006],
              [-64.30166581899994, 44.34312571800007],
              [-64.29112708199995, 44.34129466400009],
              [-64.26455644399994, 44.33258698100008],
              [-64.28970292899993, 44.30377838700008],
              [-64.28880774599992, 44.29913971600007],
              [-64.23729407499991, 44.29913971600007],
              [-64.26903235599991, 44.26707591400009],
              [-64.28661048099991, 44.25861237200007],
              [-64.30553137899994, 44.27179596600007],
              [-64.31236731699994, 44.26430898600006],
              [-64.33055579299992, 44.27635325700004],
              [-64.33922278599994, 44.28375885600008],
              [-64.34715735599991, 44.292222398000035],
              [-64.33751380099994, 44.29767487200007],
              [-64.33348548099991, 44.29913971600007],
              [-64.40892493399991, 44.32851797100005],
              [-64.42906653599994, 44.33999258000006],
              [-64.41852779899995, 44.326239325000074],
              [-64.40160071499992, 44.31297435100004],
              [-64.3821508449999, 44.30304596600007],
              [-64.36388098899994, 44.29913971600007],
              [-64.35903886599993, 44.29564036700003],
              [-64.35728919199994, 44.28766510600008],
              [-64.35789954299992, 44.27846914300005],
              [-64.36017818899995, 44.27179596600007],
              [-64.36750240799995, 44.26414622600004],
              [-64.42564856699994, 44.23387278900009],
              [-64.43122311099995, 44.22557200700004],
              [-64.43439693899995, 44.20774974200003],
              [-64.43960527299993, 44.19912344000005],
              [-64.44888261599993, 44.19310130400004],
              [-64.46922766799992, 44.18736399900007],
              [-64.47744706899994, 44.18235911700003],
              [-64.48302161399994, 44.17413971600007],
              [-64.49791419199994, 44.14077383000006],
              [-64.51390540299991, 44.14940013200004],
              [-64.52261308499993, 44.15249258000006],
              [-64.53148352799991, 44.15444570500006],
              [-64.53571529899995, 44.15599192900004],
              [-64.54352779899995, 44.16079336100006],
              [-64.54918372299994, 44.16193268400008],
              [-64.55215410099993, 44.15965403900009],
              [-64.55508378799993, 44.14996979400007],
              [-64.55939693899995, 44.14826080900008],
              [-64.59434973899994, 44.15794505400004],
              [-64.60619055899991, 44.15859609600005],
              [-64.60041256399995, 44.14826080900008],
              [-64.60582434799994, 44.145412502000056],
              [-64.60952714799993, 44.14288971600007],
              [-64.61384029899995, 44.14109935100004],
              [-64.62083899599992, 44.14077383000006],
              [-64.59951738199993, 44.13507721600007],
              [-64.57481848899994, 44.13377513200004],
              [-64.55426998599995, 44.13003164300005],
              [-64.54576575399994, 44.117254950000074],
              [-64.54991614499994, 44.09983958500004],
              [-64.56094316299993, 44.07998281500005],
              [-64.57648678299995, 44.069240627000056],
              [-64.59414628799993, 44.079413153000075],
              [-64.62144934799994, 44.06476471600007],
              [-64.64915930899991, 44.05894603100006],
              [-64.71703040299991, 44.05882396000004],
              [-64.70539303299995, 44.04572174700007],
              [-64.68663489499994, 44.041856187000064],
              [-64.66942298099991, 44.03546784100007],
              [-64.66177324099993, 44.01447174700007],
              [-64.66698157499991, 43.99787018400008],
              [-64.67992102799991, 43.99298737200007],
              [-64.69668535099993, 43.99013906500005],
              [-64.71361243399991, 43.98004791900007],
              [-64.73119055899991, 43.96348704600007],
              [-64.74453691299993, 43.95783112200007],
              [-64.80650794199994, 43.95677317900004],
              [-64.81566321499992, 43.95408763200004],
              [-64.81944739499994, 43.94586823100008],
              [-64.82192949099993, 43.93667226800005],
              [-64.82843990799995, 43.930975653000075],
              [-64.83747311099995, 43.92853424700007],
              [-64.84740149599992, 43.92910390800006],
              [-64.8333227199999, 43.91388580900008],
              [-64.79710852799991, 43.89488353100006],
              [-64.78595943899995, 43.87449778900009],
              [-64.80182857999995, 43.87632884300007],
              [-64.81395423099991, 43.87409088700008],
              [-64.81883704299992, 43.86656321800007],
              [-64.81261145699995, 43.852850653000075],
              [-64.82957923099991, 43.844956773000035],
              [-64.83458411399994, 43.83429596600007],
              [-64.83897864499994, 43.82965729400007],
              [-64.85423743399991, 43.83974844000005],
              [-64.85920162699995, 43.845689195000034],
              [-64.86803137899994, 43.860663153000075],
              [-64.87409420499995, 43.86705149900007],
              [-64.88341223899994, 43.87287018400008],
              [-64.89329993399991, 43.87681712400007],
              [-64.90392005099994, 43.87929922100005],
              [-64.91502844999991, 43.88072337400007],
              [-64.90998287699995, 43.87091705900008],
              [-64.89509029899995, 43.855536200000074],
              [-64.88833574099993, 43.846584377000056],
              [-64.88573157499991, 43.83885325700004],
              [-64.88459225199995, 43.82212962400007],
              [-64.88149980399993, 43.811835028000075],
              [-64.90660559799994, 43.80499909100007],
              [-64.92430579299992, 43.82282135600008],
              [-64.93765214799993, 43.84902578300006],
              [-64.94981848899994, 43.86705149900007],
              [-64.96678626199991, 43.87364329600007],
              [-64.96393795499995, 43.86050039300005],
              [-64.93512936099995, 43.81264883000006],
              [-64.93248450399994, 43.80626048400006],
              [-64.93512936099995, 43.79918040600006],
              [-64.94896399599992, 43.77525462400007],
              [-64.95824133999992, 43.76577383000006],
              [-64.97008216099994, 43.75893789300005],
              [-64.98395748599995, 43.757879950000074],
              [-64.99714107999995, 43.769598700000074],
              [-65.02041581899994, 43.81696198100008],
              [-65.03917395699995, 43.83234284100007],
              [-65.03774980399993, 43.81598541900007],
              [-65.01870683499993, 43.77086009300007],
              [-65.01598059799994, 43.75840892100007],
              [-65.01447506399995, 43.74253978100006],
              [-65.01659094999991, 43.72715892100007],
              [-65.02497311099995, 43.71621328300006],
              [-65.03441321499992, 43.71230703300006],
              [-65.03677324099993, 43.71539948100008],
              [-65.03766842399995, 43.720811265000066],
              [-65.04287675699993, 43.72370026200008],
              [-65.05284583199995, 43.72052643400008],
              [-65.05858313699991, 43.71348704600007],
              [-65.06065833199995, 43.70640696800007],
              [-65.05968176999994, 43.703192450000074],
              [-65.07697506399995, 43.71076080900008],
              [-65.07306881399995, 43.744981187000064],
              [-65.08698482999995, 43.757879950000074],
              [-65.09630286399994, 43.73619212400007],
              [-65.12315833199995, 43.69676341400009],
              [-65.12857011599993, 43.674668687000064],
              [-65.15123450399994, 43.689113674000055],
              [-65.14683997299994, 43.70652903900009],
              [-65.13658606699994, 43.72711823100008],
              [-65.14159094999991, 43.75104401200008],
              [-65.16124426999994, 43.71564362200007],
              [-65.16954505099994, 43.70937734600005],
              [-65.17845618399991, 43.71006907800006],
              [-65.18708248599995, 43.71588776200008],
              [-65.19367428299995, 43.72447337400007],
              [-65.20075436099995, 43.75104401200008],
              [-65.21174068899995, 43.77204010600008],
              [-65.22524980399993, 43.79181549700007],
              [-65.23786373599995, 43.805568752000056],
              [-65.24030514199995, 43.79824453300006],
              [-65.24233964799993, 43.79523346600007],
              [-65.24209550699993, 43.79214101800005],
              [-65.23786373599995, 43.784491278000075],
              [-65.25470943899995, 43.77570221600007],
              [-65.24913489499994, 43.75470612200007],
              [-65.22459876199991, 43.718817450000074],
              [-65.24010169199994, 43.69468821800007],
              [-65.25035559799994, 43.67340729400007],
              [-65.26353919199994, 43.670803127000056],
              [-65.28929602799991, 43.674668687000064],
              [-65.32721920499995, 43.69639720300006],
              [-65.32778886599993, 43.70954010600008],
              [-65.31602942599994, 43.73281484600005],
              [-65.31354732999995, 43.74355703300006],
              [-65.31725012899994, 43.76048411700003],
              [-65.32298743399991, 43.76544830900008],
              [-65.33088131399995, 43.76304759300007],
              [-65.34080969999991, 43.757879950000074],
              [-65.3450414699999, 43.75079987200007],
              [-65.34630286399994, 43.741522528000075],
              [-65.35147050699993, 43.73680247600004],
              [-65.36754309799994, 43.74355703300006],
              [-65.35496985599991, 43.716050523000035],
              [-65.34146074099993, 43.693467515000066],
              [-65.33429928299995, 43.67031484600005],
              [-65.34080969999991, 43.64118073100008],
              [-65.34142005099994, 43.63434479400007],
              [-65.34048417899993, 43.62514883000006],
              [-65.34064693899995, 43.617254950000074],
              [-65.34422766799992, 43.61383698100008],
              [-65.35448157499991, 43.610663153000075],
              [-65.35806230399993, 43.603583075000074],
              [-65.35655676999994, 43.59650299700007],
              [-65.35106360599991, 43.59332916900007],
              [-65.34605872299994, 43.58738841400009],
              [-65.34080969999991, 43.544907945000034],
              [-65.36253821499992, 43.57493724200003],
              [-65.37124589799993, 43.57908763200004],
              [-65.38149980399993, 43.57656484600005],
              [-65.3919164699999, 43.56655508000006],
              [-65.4016820949999, 43.56541575700004],
              [-65.41588294199994, 43.57135651200008],
              [-65.44220943899995, 43.59292226800005],
              [-65.45689856699994, 43.59951406500005],
              [-65.45689856699994, 43.59332916900007],
              [-65.41295325399994, 43.53880442900004],
              [-65.40973873599995, 43.52916087400007],
              [-65.40778561099995, 43.518784898000035],
              [-65.4016820949999, 43.503973700000074],
              [-65.41616777299993, 43.500067450000074],
              [-65.42243404899995, 43.51129791900007],
              [-65.42894446499992, 43.544907945000034],
              [-65.43952389199995, 43.55723704600007],
              [-65.45010331899994, 43.56045156500005],
              [-65.45563717399995, 43.555975653000075],
              [-65.45067298099991, 43.544907945000034],
              [-65.45543372299994, 43.53473541900007],
              [-65.46263587099992, 43.52757396000004],
              [-65.47232011599993, 43.52399323100008],
              [-65.48424231699994, 43.52448151200008],
              [-65.47411048099991, 43.50377024900007],
              [-65.47142493399991, 43.493801174000055],
              [-65.47057044199994, 43.48004791900007],
              [-65.47484290299991, 43.47093333500004],
              [-65.48424231699994, 43.471909898000035],
              [-65.49364173099991, 43.48033274900007],
              [-65.49791419199994, 43.493394273000035],
              [-65.50401770699995, 43.502834377000056],
              [-65.54255123599995, 43.52789948100008],
              [-65.54678300699993, 43.53229401200008],
              [-65.55036373599995, 43.53750234600005],
              [-65.55166581899994, 43.543036200000074],
              [-65.54564368399991, 43.555975653000075],
              [-65.54987545499995, 43.56134674700007],
              [-65.55650794199994, 43.565334377000056],
              [-65.55992591099994, 43.56915924700007],
              [-65.56598873599995, 43.57404205900008],
              [-65.57949785099993, 43.56541575700004],
              [-65.61294511599993, 43.53620026200008],
              [-65.64867102799991, 43.517645575000074],
              [-65.65269934799994, 43.51280345300006],
              [-65.65420488199993, 43.507147528000075],
              [-65.65794837099992, 43.50157298400006],
              [-65.66917883999992, 43.49713776200008],
              [-65.66771399599992, 43.500108140000066],
              [-65.67446855399993, 43.50454336100006],
              [-65.68968665299991, 43.51080963700008],
              [-65.71930904899995, 43.50889720300006],
              [-65.72956295499995, 43.51349518400008],
              [-65.73810787699995, 43.531317450000074],
              [-65.73053951699995, 43.54677969000005],
              [-65.73159745999993, 43.56273021000004],
              [-65.7395727199999, 43.57672760600008],
              [-65.75234941299993, 43.58653392100007],
              [-65.75251217399995, 43.57632070500006],
              [-65.75177975199995, 43.56915924700007],
              [-65.74941972599993, 43.563706773000035],
              [-65.74494381399995, 43.558579820000034],
              [-65.74771074099993, 43.55483633000006],
              [-65.75084387899994, 43.552801825000074],
              [-65.75438391799992, 43.551662502000056],
              [-65.75853430899991, 43.55113353100006],
              [-65.77814693899995, 43.56818268400008],
              [-65.78184973899994, 43.58738841400009],
              [-65.77220618399991, 43.64118073100008],
              [-65.77155514199995, 43.668809312000064],
              [-65.77375240799995, 43.68081289300005],
              [-65.77904212099992, 43.68895091400009],
              [-65.78880774599992, 43.691066799000055],
              [-65.79491126199991, 43.68260325700004],
              [-65.8001195949999, 43.66868724200003],
              [-65.80699622299994, 43.65477122600004],
              [-65.79637610599991, 43.64634837400007],
              [-65.79234778599994, 43.63393789300005],
              [-65.79381262899994, 43.61994049700007],
              [-65.79954993399991, 43.606350002000056],
              [-65.81480872299994, 43.63157786700003],
              [-65.81700598899994, 43.65696849200003],
              [-65.81566321499992, 43.68272532800006],
              [-65.81997636599993, 43.70937734600005],
              [-65.82510331899994, 43.718410549000055],
              [-65.84064693899995, 43.73867422100005],
              [-65.84797115799995, 43.75104401200008],
              [-65.85289466099994, 43.76422760600008],
              [-65.86164303299995, 43.805568752000056],
              [-65.8684789699999, 43.805568752000056],
              [-65.86823482999995, 43.787095445000034],
              [-65.86620032499991, 43.77903880400004],
              [-65.86164303299995, 43.77086009300007],
              [-65.87718665299991, 43.769598700000074],
              [-65.88890540299991, 43.78375885600008],
              [-65.89899654899995, 43.80345286700003],
              [-65.90941321499992, 43.819240627000056],
              [-65.92438717399995, 43.82680898600006],
              [-65.93716386599993, 43.82599518400008],
              [-65.94127356699994, 43.81989166900007],
              [-65.92992102799991, 43.811835028000075],
              [-65.92992102799991, 43.805568752000056],
              [-65.95669511599993, 43.78538646000004],
              [-65.97134355399993, 43.78009674700007],
              [-65.97765051999994, 43.79478587400007],
              [-65.97883053299995, 43.80211009300007],
              [-65.98395748599995, 43.81944407800006],
              [-65.98721269399994, 43.83921946800007],
              [-65.99193274599992, 43.84902578300006],
              [-65.99665279899995, 43.85407135600008],
              [-65.99876868399991, 43.849676825000074],
              [-66.00401770699995, 43.831691799000055],
              [-66.00499426999994, 43.825506903000075],
              [-66.00475012899994, 43.81631094000005],
              [-66.00365149599992, 43.80971914300005],
              [-66.00169837099992, 43.80418528900009],
              [-65.97435462099992, 43.75063711100006],
              [-65.96336829299992, 43.73729075700004],
              [-65.97321529899995, 43.71426015800006],
              [-65.97960364499994, 43.705959377000056],
              [-65.99132239499994, 43.703192450000074],
              [-65.98314368399991, 43.71946849200003],
              [-65.98379472599993, 43.72931549700007],
              [-65.99160722599993, 43.73110586100006],
              [-66.00499426999994, 43.72370026200008],
              [-66.00690670499995, 43.71694570500006],
              [-66.00548255099994, 43.70783112200007],
              [-66.00641842399995, 43.69985586100006],
              [-66.01524817599994, 43.69639720300006],
              [-66.02379309799994, 43.69806549700007],
              [-66.02814693899995, 43.70229726800005],
              [-66.02871660099993, 43.708644924000055],
              [-66.02611243399991, 43.71621328300006],
              [-66.03229732999995, 43.71621328300006],
              [-66.03087317599994, 43.73668040600006],
              [-66.04214433499993, 43.74640534100007],
              [-66.05553137899994, 43.74087148600006],
              [-66.06021074099993, 43.71621328300006],
              [-66.07420813699991, 43.72931549700007],
              [-66.07730058499993, 43.74058665600006],
              [-66.07323157499991, 43.76772695500006],
              [-66.0794164699999, 43.772365627000056],
              [-66.0930883449999, 43.766465562000064],
              [-66.10728919199994, 43.75503164300005],
              [-66.11485755099994, 43.74355703300006],
              [-66.12169348899994, 43.74355703300006],
              [-66.13365637899994, 43.80971914300005],
              [-66.11978105399993, 43.82453034100007],
              [-66.11339270699995, 43.836004950000074],
              [-66.11115475199995, 43.84752024900007],
              [-66.11827551999994, 43.852850653000075],
              [-66.12848873599995, 43.84951406500005],
              [-66.13585364499994, 43.84194570500006],
              [-66.14232337099992, 43.832871812000064],
              [-66.14956620999993, 43.825506903000075],
              [-66.14781653599994, 43.84007396000004],
              [-66.14924068899995, 43.852443752000056],
              [-66.15591386599993, 43.85997142100007],
              [-66.17007402299993, 43.860256252000056],
              [-66.16616777299993, 43.870428778000075],
              [-66.16714433499993, 43.87946198100008],
              [-66.16966712099992, 43.88735586100006],
              [-66.17007402299993, 43.89439524900007],
              [-66.16559811099995, 43.90379466400009],
              [-66.15233313699991, 43.92413971600007],
              [-66.14956620999993, 43.93223704600007],
              [-66.15367591099994, 43.94717031500005],
              [-66.16071529899995, 43.960923570000034],
              [-66.16291256399995, 43.97565338700008],
              [-66.14875240799995, 44.00254954600007],
              [-66.15025794199994, 44.01040273600006],
              [-66.15583248599995, 44.02163320500006],
              [-66.15782630099994, 44.023545640000066],
              [-66.18342037699995, 44.084051825000074],
              [-66.19432532499991, 44.09259674700007],
              [-66.21043860599991, 44.08555735900006],
              [-66.21031653599994, 44.10569896000004],
              [-66.1946508449999, 44.14272695500006],
              [-66.19058183499993, 44.165350653000075],
              [-66.18765214799993, 44.171210028000075],
              [-66.15868079299992, 44.20054759300007],
              [-66.15257727799991, 44.209051825000074],
              [-66.14216061099995, 44.23078034100007],
              [-66.11367753799993, 44.34336985900006],
              [-66.09496008999992, 44.37417226800005],
              [-66.06289628799993, 44.393459377000056],
              [-66.04674231699994, 44.40664297100005],
              [-66.03970292899993, 44.42540110900006],
              [-66.0325414699999, 44.436753648000035],
              [-65.96597245999993, 44.48924388200004],
              [-65.92772376199991, 44.50617096600007],
              [-65.88878333199995, 44.532456773000035],
              [-65.86676998599995, 44.54336172100005],
              [-65.84788977799991, 44.55650462400007],
              [-65.84048417899993, 44.57339101800005],
              [-65.84911048099991, 44.586818752000056],
              [-65.8684789699999, 44.587551174000055],
              [-65.91315670499995, 44.57965729400007],
              [-65.92369544199994, 44.581284898000035],
              [-65.93297278599994, 44.58380768400008],
              [-65.94253495999993, 44.58340078300006],
              [-66.02843176999994, 44.52061595300006],
              [-66.18724524599992, 44.394598700000074],
              [-66.19676673099991, 44.39093659100007],
              [-66.19229081899994, 44.41746653900009],
              [-66.18032792899993, 44.434434312000064],
              [-65.99876868399991, 44.57965729400007],
              [-65.88890540299991, 44.63076406500005],
              [-65.87466386599993, 44.64313385600008],
              [-65.78587805899991, 44.69635651200008],
              [-65.77269446499992, 44.68577708500004],
              [-65.76305091099994, 44.67234935100004],
              [-65.75633704299992, 44.65729401200008],
              [-65.75234941299993, 44.64170970300006],
              [-65.75373287699995, 44.63198476800005],
              [-65.75698808499993, 44.62051015800006],
              [-65.75706946499992, 44.61090729400007],
              [-65.74864661399994, 44.60691966400009],
              [-65.72960364499994, 44.60919830900008],
              [-65.71019446499992, 44.61375560100004],
              [-65.69229081899994, 44.62071360900006],
              [-65.68004309799994, 44.62864817900004],
              [-65.65611731699994, 44.64785390800006],
              [-65.62498938699991, 44.66648997600004],
              [-65.61241614499994, 44.677801825000074],
              [-65.60155188699991, 44.69635651200008],
              [-65.59410559799994, 44.68886953300006],
              [-65.53673255099994, 44.73663971600007],
              [-65.52236894399994, 44.74404531500005],
              [-65.49413001199991, 44.74868398600006],
              [-65.45091712099992, 44.77061595300006],
              [-65.42894446499992, 44.778225002000056],
              [-65.44725501199991, 44.78107330900008],
              [-65.49254309799994, 44.75812409100007],
              [-65.53514563699991, 44.746975002000056],
              [-65.61534583199995, 44.70913320500006],
              [-65.65396074099993, 44.69806549700007],
              [-65.67634029899995, 44.69635651200008],
              [-65.71727454299992, 44.67442454600007],
              [-65.74176998599995, 44.66783274900007],
              [-65.75853430899991, 44.68268463700008],
              [-65.72345943899995, 44.727443752000056],
              [-65.62124589799993, 44.77887604400007],
              [-65.45689856699994, 44.85460032800006],
              [-65.39761308499993, 44.89488353100006],
              [-65.37840735599991, 44.90110911700003],
              [-65.35826575399994, 44.904364325000074],
              [-65.23167883999992, 44.955186265000066],
              [-65.21328691299993, 44.966905015000066],
              [-65.18053137899994, 44.99323151200008],
              [-65.02212480399993, 45.06016673400006],
              [-64.86318925699993, 45.139553127000056],
              [-64.71401933499993, 45.19236888200004],
              [-64.64411373599995, 45.200832424000055],
              [-64.5755102199999, 45.219631252000056],
              [-64.51065019399994, 45.228583075000074],
              [-64.47496497299994, 45.240301825000074],
              [-64.44115149599992, 45.25576406500005],
              [-64.41539466099994, 45.27163320500006],
              [-64.39533443899995, 45.301621812000064],
              [-64.41755123599995, 45.319647528000075],
              [-64.45933997299994, 45.32916901200008],
              [-64.49791419199994, 45.33380768400008],
              [-64.47777258999992, 45.341131903000075],
              [-64.45616614499994, 45.338731187000064],
              [-64.41539466099994, 45.32632070500006],
              [-64.34870357999995, 45.31944407800006],
              [-64.32974199099993, 45.30955638200004],
              [-64.31843014199995, 45.294907945000034],
              [-64.32046464799993, 45.28294505400004],
              [-64.33055579299992, 45.27228424700007],
              [-64.34337317599994, 45.26146067900004],
              [-64.35155188699991, 45.248114325000074],
              [-64.35912024599992, 45.21336497600004],
              [-64.36754309799994, 45.196600653000075],
              [-64.35244706899994, 45.185207424000055],
              [-64.35700436099995, 45.170762437000064],
              [-64.37193762899994, 45.15729401200008],
              [-64.38805091099994, 45.14878978100006],
              [-64.36733964799993, 45.12612539300005],
              [-64.36241614499994, 45.116115627000056],
              [-64.36754309799994, 45.10781484600005],
              [-64.35659745999993, 45.10398997600004],
              [-64.34552975199995, 45.10586172100005],
              [-64.33690344999991, 45.112941799000055],
              [-64.33348548099991, 45.12457916900007],
              [-64.33161373599995, 45.13589101800005],
              [-64.32603919199994, 45.14199453300006],
              [-64.31725012899994, 45.14557526200008],
              [-64.30553137899994, 45.14878978100006],
              [-64.22345943899995, 45.10838450700004],
              [-64.15160071499992, 45.04979075700004],
              [-64.14907792899993, 45.038723049000055],
              [-64.15534420499995, 44.983710028000075],
              [-64.14728756399995, 44.997707424000055],
              [-64.13585364499994, 45.003241278000075],
              [-64.12205969999991, 45.00254954600007],
              [-64.10692298099991, 44.99795156500005],
              [-64.11632239499994, 45.011379299000055],
              [-64.11904863199993, 45.02989329600007],
              [-64.11416581899994, 45.046210028000075],
              [-64.10069739499994, 45.05320872600004],
              [-64.10069739499994, 45.05939362200007],
              [-64.11949622299994, 45.06207916900007],
              [-64.13654537699995, 45.07290273600006],
              [-64.18382727799991, 45.11432526200008],
              [-64.19741777299993, 45.13255442900004],
              [-64.19933020699995, 45.14866771000004],
              [-64.16588294199994, 45.159409898000035],
              [-64.16397050699993, 45.16828034100007],
              [-64.16633053299995, 45.17837148600006],
              [-64.16559811099995, 45.18602122600004],
              [-64.15770423099991, 45.19188060100004],
              [-64.13927161399994, 45.20001862200007],
              [-64.13076738199993, 45.20652903900009],
              [-64.11506100199995, 45.216050523000035],
              [-64.02432206899994, 45.241441148000035],
              [-63.962880011999914, 45.25112539300005],
              [-63.90583248599995, 45.27578359600005],
              [-63.88467363199993, 45.27912018400008],
              [-63.84650631399995, 45.27716705900008],
              [-63.82530676999994, 45.27960846600007],
              [-63.80899003799993, 45.288723049000055],
              [-63.8040258449999, 45.298814195000034],
              [-63.80410722599993, 45.306301174000055],
              [-63.80142167899993, 45.31102122600004],
              [-63.78819739499994, 45.31264883000006],
              [-63.76040605399993, 45.31126536700003],
              [-63.74828040299991, 45.30744049700007],
              [-63.73692786399994, 45.29962799700007],
              [-63.73033606699994, 45.30548737200007],
              [-63.71979732999995, 45.32212962400007],
              [-63.71589107999995, 45.32632070500006],
              [-63.70811926999994, 45.32640208500004],
              [-63.67491614499994, 45.32013580900008],
              [-63.57872473899994, 45.322333075000074],
              [-63.543080206999946, 45.331691799000055],
              [-63.52407792899993, 45.33380768400008],
              [-63.50450598899994, 45.32868073100008],
              [-63.49258378799993, 45.31696198100008],
              [-63.48277747299994, 45.30329010600008],
              [-63.46947180899991, 45.29214101800005],
              [-63.460926886999914, 45.32501862200007],
              [-63.43309485599991, 45.34487539300005],
              [-63.396148240999935, 45.35561758000006],
              [-63.360218878999945, 45.36107005400004],
              [-63.39167232999995, 45.37164948100008],
              [-63.50731360599991, 45.37474192900004],
              [-63.52867591099994, 45.377834377000056],
              [-63.571156378999945, 45.39166901200008],
              [-63.593006964999915, 45.39516836100006],
              [-63.81578528599994, 45.39516836100006],
              [-63.83385169199994, 45.39207591400009],
              [-63.848866339999915, 45.38458893400008],
              [-63.87413489499994, 45.367295640000066],
              [-63.88048255099994, 45.36188385600008],
              [-63.88491777299993, 45.35626862200007],
              [-63.89085852799991, 45.35289134300007],
              [-63.90147864499994, 45.35423411700003],
              [-63.91047115799995, 45.35887278900009],
              [-63.914621548999946, 45.365220445000034],
              [-63.91392981699994, 45.37287018400008],
              [-63.908314581999946, 45.38149648600006],
              [-63.93663489499994, 45.398504950000074],
              [-64.01378333199995, 45.39044830900008],
              [-64.05231686099995, 45.39516836100006],
              [-64.0423070949999, 45.40053945500006],
              [-64.03799394399994, 45.402004299000055],
              [-64.06598873599995, 45.412990627000056],
              [-64.10533606699994, 45.41514720300006],
              [-64.18260657499991, 45.40884023600006],
              [-64.24388587099992, 45.39468008000006],
              [-64.27586829299992, 45.39207591400009],
              [-64.31236731699994, 45.402004299000055],
              [-64.31452389199995, 45.38194407800006],
              [-64.32217363199993, 45.37999095300006],
              [-64.33364824099993, 45.38580963700008],
              [-64.34715735599991, 45.38898346600007],
              [-64.35895748599995, 45.38633860900006],
              [-64.36974036399994, 45.38149648600006],
              [-64.37946529899995, 45.374986070000034],
              [-64.38805091099994, 45.367295640000066],
              [-64.39981035099993, 45.37287018400008],
              [-64.43590247299994, 45.38149648600006],
              [-64.44570878799993, 45.38804759300007],
              [-64.45140540299991, 45.39468008000006],
              [-64.45881100199995, 45.39996979400007],
              [-64.57616126199991, 45.41563548400006],
              [-64.61998450399994, 45.40851471600007],
              [-64.67251542899993, 45.38902415600006],
              [-64.70702063699991, 45.360581773000035],
              [-64.6966039699999, 45.32632070500006],
              [-64.71743730399993, 45.32461172100005],
              [-64.73253333199995, 45.31614817900004],
              [-64.74510657499991, 45.30613841400009],
              [-64.75865637899994, 45.29962799700007],
              [-64.76817786399994, 45.29726797100005],
              [-64.76842200399994, 45.29791901200008],
              [-64.76707923099991, 45.30259837400007],
              [-64.77163652299993, 45.31264883000006],
              [-64.77285722599993, 45.31777578300006],
              [-64.76659094999991, 45.325100002000056],
              [-64.76821855399993, 45.32998281500005],
              [-64.77399654899995, 45.33315664300005],
              [-64.78636633999992, 45.332098700000074],
              [-64.79214433499993, 45.33380768400008],
              [-64.82274329299992, 45.34796784100007],
              [-64.85985266799992, 45.35301341400009],
              [-64.89745032499991, 45.34650299700007],
              [-64.92931067599994, 45.32632070500006],
              [-64.93569902299993, 45.351223049000055],
              [-64.92870032499991, 45.38304271000004],
              [-64.91519120999993, 45.41242096600007],
              [-64.90200761599993, 45.42999909100007],
              [-64.85391191299993, 45.45726146000004],
              [-64.83897864499994, 45.459051825000074],
              [-64.81493079299992, 45.46759674700007],
              [-64.79963131399995, 45.47085195500006],
              [-64.83311926999994, 45.48399485900006],
              [-64.70641028599994, 45.53685130400004],
              [-64.68089758999992, 45.54254791900007],
              [-64.66331946499992, 45.55650462400007],
              [-64.64879309799994, 45.55906810100004],
              [-64.64537512899994, 45.58633047100005],
              [-64.61359615799995, 45.60268789300005],
              [-64.57282467399995, 45.615342515000066],
              [-64.54234778599994, 45.63165924700007],
              [-64.51333574099993, 45.65684642100007],
              [-64.48428300699993, 45.67637767100007],
              [-64.47671464799993, 45.67910390800006],
              [-64.46251380099994, 45.68105703300006],
              [-64.45702063699991, 45.68317291900007],
              [-64.44859778599994, 45.69057851800005],
              [-64.43765214799993, 45.70425039300005],
              [-64.42906653599994, 45.709865627000056],
              [-64.43675696499992, 45.72520579600007],
              [-64.43907630099994, 45.73851146000004],
              [-64.43211829299992, 45.74787018400008],
              [-64.41197669199994, 45.75153229400007],
              [-64.39810136599993, 45.75625234600005],
              [-64.38589433499993, 45.767645575000074],
              [-64.37889563699991, 45.78115469000005],
              [-64.38060462099992, 45.79238515800006],
              [-64.30553137899994, 45.82656484600005],
              [-64.29303951699995, 45.81578196800007],
              [-64.29442298099991, 45.80503978100006],
              [-64.31236731699994, 45.78563060100004],
              [-64.31908118399991, 45.781317450000074],
              [-64.32603919199994, 45.77993398600006],
              [-64.3313695949999, 45.77716705900008],
              [-64.33348548099991, 45.76854075700004],
              [-64.33153235599991, 45.76325104400007],
              [-64.32827714799993, 45.75958893400008],
              [-64.32770748599995, 45.75446198100008],
              [-64.33348548099991, 45.74461497600004],
              [-64.31672115799995, 45.75568268400008],
              [-64.30308997299994, 45.76186758000006],
              [-64.28746497299994, 45.764512437000064],
              [-64.26455644399994, 45.76512278900009],
              [-64.26952063699991, 45.77415599200003],
              [-64.27892005099994, 45.778631903000075],
              [-64.29141191299993, 45.77960846600007],
              [-64.30553137899994, 45.77879466400009],
              [-64.29385331899994, 45.78400299700007],
              [-64.28282630099994, 45.79352448100008],
              [-64.27452551999994, 45.80451080900008],
              [-64.27074133999992, 45.81354401200008],
              [-64.27110755099994, 45.83063385600008],
              [-64.27623450399994, 45.841782945000034],
              [-64.3216039699999, 45.877834377000056],
              [-64.33470618399991, 45.88511790600006],
              [-64.34715735599991, 45.888657945000034],
              [-64.36148027299993, 45.88507721600007],
              [-64.36595618399991, 45.87596263200004],
              [-64.35912024599992, 45.868068752000056],
              [-64.33971106699994, 45.86815013200004],
              [-64.33971106699994, 45.86070384300007],
              [-64.36900794199994, 45.84674713700008],
              [-64.41954505099994, 45.79116445500006],
              [-64.44640051999994, 45.77879466400009],
              [-64.4641820949999, 45.772772528000075],
              [-64.47150631399995, 45.75844961100006],
              [-64.47484290299991, 45.74160390800006],
              [-64.48086503799993, 45.72789134300007],
              [-64.49498450399994, 45.72101471600007],
              [-64.51390540299991, 45.72060781500005],
              [-64.5325414699999, 45.72483958500004],
              [-64.54576575399994, 45.73159414300005],
              [-64.52627519399994, 45.74253978100006],
              [-64.50853430899991, 45.76618073100008],
              [-64.49551347599993, 45.79368724200003],
              [-64.49054928299995, 45.81671784100007],
              [-64.49620520699995, 45.82477448100008],
              [-64.52301998599995, 45.83974844000005],
              [-64.53148352799991, 45.84703196800007],
              [-64.53620357999995, 45.86147695500006],
              [-64.53575598899994, 45.87384674700007],
              [-64.53148352799991, 45.90224844000005],
              [-64.54841061099995, 45.88361237200007],
              [-64.56090247299994, 45.87872955900008],
              [-64.57241777299993, 45.885606187000064],
              [-64.62979081899994, 45.95449453300006],
              [-64.64879309799994, 45.97056712400007],
              [-64.67003333199995, 45.98314036700003],
              [-64.67878170499995, 45.99095286700003],
              [-64.68228105399993, 46.001613674000055],
              [-64.68301347599993, 46.025458075000074],
              [-64.68521074099993, 46.03620026200008],
              [-64.68976803299995, 46.04629140800006],
              [-64.70396887899994, 46.062160549000055],
              [-64.72606360599991, 46.07908763200004],
              [-64.74868730399993, 46.089911200000074],
              [-64.76488196499992, 46.08726634300007],
              [-64.7102758449999, 46.04962799700007],
              [-64.6966039699999, 46.03261953300006],
              [-64.70567786399994, 46.01788971600007],
              [-64.70799719999991, 46.00804271000004],
              [-64.70372473899994, 45.99937571800007],
              [-64.69318600199995, 45.988267320000034],
              [-64.66860917899993, 45.97056712400007],
              [-64.66405188699991, 45.964911200000074],
              [-64.65656490799995, 45.95294830900008],
              [-64.65221106699994, 45.95075104400007],
              [-64.63540605399993, 45.94521719000005],
              [-64.62608801999994, 45.93199290600006],
              [-64.61339270699995, 45.90224844000005],
              [-64.60163326699995, 45.890611070000034],
              [-64.57868404899995, 45.872707424000055],
              [-64.57241777299993, 45.86070384300007],
              [-64.58543860599991, 45.82591380400004],
              [-64.61318925699993, 45.80036041900007],
              [-64.64647376199991, 45.77765534100007],
              [-64.67609615799995, 45.75153229400007],
              [-64.66649329299992, 45.74591705900008],
              [-64.64989173099991, 45.73037344000005],
              [-64.64134680899991, 45.72418854400007],
              [-64.65343176999994, 45.72056712400007],
              [-64.67617753799993, 45.72618235900006],
              [-64.68976803299995, 45.72418854400007],
              [-64.69676673099991, 45.71580638200004],
              [-64.70775305899991, 45.68895091400009],
              [-64.71361243399991, 45.68317291900007],
              [-64.72915605399993, 45.67332591400009],
              [-64.75625566299993, 45.627793687000064],
              [-64.77163652299993, 45.61432526200008],
              [-64.78477942599994, 45.61318594000005],
              [-64.79027258999992, 45.61871979400007],
              [-64.79515540299991, 45.62730540600006],
              [-64.80646725199995, 45.63540273600006],
              [-64.81761633999992, 45.63743724200003],
              [-64.88280188699991, 45.63361237200007],
              [-64.90477454299992, 45.628241278000075],
              [-64.92442786399994, 45.61969635600008],
              [-64.94298255099994, 45.60805898600006],
              [-64.99449622299994, 45.55906810100004],
              [-65.01528886599993, 45.552842515000066],
              [-65.03522701699995, 45.550441799000055],
              [-65.18431555899991, 45.51040273600006],
              [-65.31505286399994, 45.45921458500004],
              [-65.48916581899994, 45.37164948100008],
              [-65.51939856699994, 45.36461009300007],
              [-65.52916419199994, 45.35773346600007],
              [-65.53620357999995, 45.34800853100006],
              [-65.53880774599992, 45.337144273000035],
              [-65.54499264199995, 45.32957591400009],
              [-65.55915279899995, 45.32481517100007],
              [-65.61856035099993, 45.315659898000035],
              [-65.62881425699993, 45.31264883000006],
              [-65.66071529899995, 45.29454173400006],
              [-65.69749915299991, 45.285223700000074],
              [-65.73298092399995, 45.25328196800007],
              [-65.75234941299993, 45.24437083500004],
              [-65.76134192599994, 45.24717845300006],
              [-65.7825414699999, 45.26186758000006],
              [-65.79332434799994, 45.264878648000035],
              [-65.80406653599994, 45.26011790600006],
              [-65.82656816299993, 45.24168528900009],
              [-65.85289466099994, 45.23301829600007],
              [-65.88829505099994, 45.21385325700004],
              [-65.90941321499992, 45.210272528000075],
              [-65.92931067599994, 45.21303945500006],
              [-65.96056067599994, 45.221991278000075],
              [-65.98143469999991, 45.223944403000075],
              [-65.99559485599991, 45.23029205900008],
              [-66.00593014199995, 45.24494049700007],
              [-66.01862545499995, 45.27163320500006],
              [-66.03962154899995, 45.285142320000034],
              [-66.13597571499992, 45.31264883000006],
              [-66.03355872299994, 45.370428778000075],
              [-66.00186113199993, 45.39858633000006],
              [-65.99836178299995, 45.40680573100008],
              [-65.99762936099995, 45.418036200000074],
              [-65.99876868399991, 45.439561265000066],
              [-66.00084387899994, 45.44981517100007],
              [-66.00527910099993, 45.45937734600005],
              [-66.00975501199991, 45.46434153900009],
              [-66.01183020699995, 45.46035390800006],
              [-66.02041581899994, 45.449286200000074],
              [-66.05842037699995, 45.42267487200007],
              [-66.06973222599993, 45.40029531500005],
              [-66.08751380099994, 45.37474192900004],
              [-66.08942623599995, 45.370021877000056],
              [-66.08897864499994, 45.36465078300006],
              [-66.08967037699995, 45.35923899900007],
              [-66.09496008999992, 45.35423411700003],
              [-66.10057532499991, 45.35411204600007],
              [-66.11432857999995, 45.360256252000056],
              [-66.12169348899994, 45.36107005400004],
              [-66.16413326699995, 45.35187409100007],
              [-66.18541419199994, 45.34414297100005],
              [-66.19676673099991, 45.33380768400008],
              [-66.19318600199995, 45.33055247600004],
              [-66.17690995999993, 45.30646393400008],
              [-66.16637122299994, 45.29726797100005],
              [-66.15440833199995, 45.28961823100008],
              [-66.14159094999991, 45.28343333500004],
              [-66.12848873599995, 45.27912018400008],
              [-66.10651607999995, 45.277329820000034],
              [-66.08678137899994, 45.27830638200004],
              [-66.07091223899994, 45.27448151200008],
              [-66.06021074099993, 45.25804271000004],
              [-66.08360755099994, 45.25230540600006],
              [-66.11595618399991, 45.23672109600005],
              [-66.14098059799994, 45.218085028000075],
              [-66.14216061099995, 45.202785549000055],
              [-66.18936113199993, 45.177801825000074],
              [-66.19676673099991, 45.17234935100004],
              [-66.20213782499991, 45.159491278000075],
              [-66.21410071499992, 45.169582424000055],
              [-66.23155676999994, 45.196600653000075],
              [-66.24937903599994, 45.20465729400007],
              [-66.27977454299992, 45.20860423400006],
              [-66.31004798099991, 45.20482005400004],
              [-66.32774817599994, 45.18976471600007],
              [-66.30382239499994, 45.187160549000055],
              [-66.27049719999991, 45.18976471600007],
              [-66.24860592399995, 45.18528880400004],
              [-66.25890051999994, 45.161769924000055],
              [-66.28380286399994, 45.14996979400007],
              [-66.34284420499995, 45.14439524900007],
              [-66.35440019399994, 45.13141510600008],
              [-66.35802161399994, 45.11660390800006],
              [-66.36717688699991, 45.114894924000055],
              [-66.37954667899993, 45.116522528000075],
              [-66.39293372299994, 45.11123281500005],
              [-66.41490637899994, 45.09284088700008],
              [-66.42882239499994, 45.08372630400004],
              [-66.44066321499992, 45.07990143400008],
              [-66.45421301999994, 45.077053127000056],
              [-66.46129309799994, 45.07774485900006],
              [-66.46426347599993, 45.08360423400006],
              [-66.46491451699995, 45.09800853100006],
              [-66.46401933499993, 45.10488515800006],
              [-66.46084550699993, 45.10781484600005],
              [-66.4602758449999, 45.11473216400009],
              [-66.49095618399991, 45.15562571800007],
              [-66.50548255099994, 45.14801666900007],
              [-66.51992753799993, 45.14394765800006],
              [-66.54312089799993, 45.14199453300006],
              [-66.55003821499992, 45.140285549000055],
              [-66.66006425699993, 45.08462148600006],
              [-66.69253495999993, 45.07461172100005],
              [-66.71812903599994, 45.07990143400008],
              [-66.71068274599992, 45.08730703300006],
              [-66.71788489499994, 45.09092845300006],
              [-66.72496497299994, 45.09357330900008],
              [-66.73106848899994, 45.07477448100008],
              [-66.74583899599992, 45.064520575000074],
              [-66.76634680899991, 45.06028880400004],
              [-66.78954016799992, 45.05939362200007],
              [-66.79702714799993, 45.06582265800006],
              [-66.78693600199995, 45.08063385600008],
              [-66.78075110599991, 45.09682851800005],
              [-66.8001195949999, 45.10781484600005],
              [-66.80337480399993, 45.093410549000055],
              [-66.81330318899995, 45.08942291900007],
              [-66.82701575399994, 45.08942291900007],
              [-66.84166419199994, 45.08730703300006],
              [-66.87214107999995, 45.06557851800005],
              [-66.88890540299991, 45.06069570500006],
              [-66.90868079299992, 45.09870026200008],
              [-66.91104081899994, 45.11391836100006],
              [-66.89940344999991, 45.12083567900004],
              [-66.88524329299992, 45.122300523000035],
              [-66.86229407499991, 45.12799713700008],
              [-66.84788977799991, 45.12832265800006],
              [-66.85570227799991, 45.137600002000056],
              [-66.86974036399994, 45.14394765800006],
              [-66.88565019399994, 45.14760976800005],
              [-66.89940344999991, 45.14878978100006],
              [-66.91600501199991, 45.15468984600005],
              [-66.92739824099993, 45.16819896000004],
              [-66.93586178299995, 45.18203359600005],
              [-66.94347083199995, 45.18976471600007],
              [-66.95702063699991, 45.18907298400006],
              [-66.97077389199995, 45.18199290600006],
              [-66.98143469999991, 45.17100657800006],
              [-66.98570716099994, 45.15875885600008],
              [-66.99144446499992, 45.161769924000055],
              [-67.0051977199999, 45.16665273600006],
              [-67.02114824099993, 45.16836172100005],
              [-67.0400691399999, 45.143825588000084],
              [-67.03880774599992, 45.13426341400009],
              [-67.04552161399994, 45.117173570000034],
              [-67.04950924399992, 45.09642161700003],
              [-67.0400691399999, 45.07562897300005],
              [-67.06566321499992, 45.082546291000085],
              [-67.08637447799993, 45.097642320000034],
              [-67.1247859369999, 45.143784898000035],
              [-67.13109290299991, 45.15383535400008],
              [-67.13414466099994, 45.16506582200009],
              [-67.1362605459999, 45.196519273000035],
              [-67.1406550769999, 45.20461660400008],
              [-67.14915930899991, 45.205511786000045],
              [-67.16295325399994, 45.198513088000084],
              [-67.16303463399993, 45.21275462400007],
              [-67.16795813699991, 45.22260163000004],
              [-67.17719479099992, 45.22898997600004],
              [-67.19029700399994, 45.23318105700008],
              [-67.19062252499992, 45.21739329600007],
              [-67.18773352799991, 45.20144277600008],
              [-67.18256588399993, 45.187933661000045],
              [-67.17601477799994, 45.17865631700006],
            ],
          ],
          [
            [
              [-66.90103105399993, 44.88939036700003],
              [-66.91665605399993, 44.87767161700003],
              [-66.9309789699999, 44.86985911700003],
              [-66.92056230399993, 44.85032786700003],
              [-66.9192602199999, 44.83730703300006],
              [-66.9387914699999, 44.83860911700003],
              [-66.95571855399993, 44.84642161700003],
              [-66.97524980399993, 44.86074453300006],
              [-66.9817602199999, 44.87246328300006],
              [-66.9583227199999, 44.87767161700003],
              [-66.9544164699999, 44.88939036700003],
              [-66.9544164699999, 44.89980703300006],
              [-66.9466039699999, 44.91543203300006],
              [-66.94009355399993, 44.925848700000074],
              [-66.93358313699991, 44.941473700000074],
              [-66.92186438699991, 44.94798411700003],
              [-66.90493730399993, 44.95579661700003],
              [-66.90493730399993, 44.94668203300006],
              [-66.9036352199999, 44.933661200000074],
              [-66.8919164699999, 44.921942450000074],
              [-66.89321855399993, 44.906317450000074],
              [-66.90103105399993, 44.88939036700003],
            ],
          ],
          [
            [
              [-66.96353105399993, 44.961004950000074],
              [-66.9778539699999, 44.93626536700003],
              [-66.9856664699999, 44.925848700000074],
              [-67.0051977199999, 44.94798411700003],
              [-67.01431230399993, 44.96360911700003],
              [-67.0169164699999, 44.97923411700003],
              [-67.0051977199999, 44.98965078300006],
              [-66.9895727199999, 45.00136953300006],
              [-66.9739477199999, 45.01829661700003],
              [-66.9544164699999, 45.027411200000074],
              [-66.9387914699999, 45.02480703300006],
              [-66.94009355399993, 45.011786200000074],
              [-66.94530188699991, 45.000067450000074],
              [-66.94790605399993, 44.98314036700003],
              [-66.96353105399993, 44.961004950000074],
            ],
          ],
          [
            [
              [-55.87718665299991, 47.26601797100005],
              [-55.89037024599992, 47.26089101800005],
              [-55.90176347599993, 47.26414622600004],
              [-55.91368567599994, 47.27016836100006],
              [-55.92808997299994, 47.273423570000034],
              [-55.93895423099991, 47.27187734600005],
              [-55.94994055899991, 47.26813385600008],
              [-55.948475714999915, 47.276597398000035],
              [-55.91942298099991, 47.28900788000004],
              [-55.88805091099994, 47.294907945000034],
              [-55.86359615799995, 47.29328034100007],
              [-55.86180579299992, 47.28388092700004],
              [-55.85924231699994, 47.27708567900004],
              [-55.85374915299991, 47.273423570000034],
              [-55.843088344999956, 47.273423570000034],
              [-55.87100175699993, 47.251654364000046],
              [-55.87718665299991, 47.26601797100005],
            ],
          ],
          [
            [
              [-54.12254798099991, 47.64272695500006],
              [-54.15103105399993, 47.58779531500005],
              [-54.16030839799993, 47.55573151200008],
              [-54.15664628799993, 47.53351471600007],
              [-54.18028723899994, 47.50653717700004],
              [-54.24404863199993, 47.40770091400009],
              [-54.25666256399995, 47.39899323100008],
              [-54.27245032499991, 47.395697333000044],
              [-54.35106360599991, 47.40302155200004],
              [-54.36270097599993, 47.40997955900008],
              [-54.35057532499991, 47.42243073100008],
              [-54.25967363199993, 47.48574453300006],
              [-54.21743730399993, 47.53969961100006],
              [-54.21401933499993, 47.55853913000004],
              [-54.24600175699993, 47.553941148000035],
              [-54.23985755099994, 47.56439850500004],
              [-54.183257615999935, 47.61587148600006],
              [-54.17096920499995, 47.622259833000044],
              [-54.179758266999954, 47.60187409100007],
              [-54.18464107999995, 47.59552643400008],
              [-54.17096920499995, 47.58808014500005],
              [-54.16588294199994, 47.60639069200005],
              [-54.13434811099995, 47.66445547100005],
              [-54.12604732999995, 47.67011139500005],
              [-54.121083136999914, 47.66400788000004],
              [-54.12254798099991, 47.64272695500006],
            ],
          ],
          [
            [
              [-55.925038214999915, 47.67747630400004],
              [-55.93797766799992, 47.65692780200004],
              [-55.92414303299995, 47.638739325000074],
              [-55.89875240799995, 47.62449778900009],
              [-55.87718665299991, 47.61603424700007],
              [-55.903635219999956, 47.607082424000055],
              [-55.93000240799995, 47.60443756700005],
              [-55.95718339799993, 47.605902411000045],
              [-56.04002844999991, 47.61981842700004],
              [-56.06468665299991, 47.63043854400007],
              [-56.097645636999914, 47.629787502000056],
              [-56.10997473899994, 47.63654205900008],
              [-56.108265753999945, 47.65412018400008],
              [-56.08348548099991, 47.66616445500006],
              [-55.969634568999936, 47.68577708500004],
              [-55.94050045499995, 47.685614325000074],
              [-55.925038214999915, 47.67747630400004],
            ],
          ],
          [
            [
              [-54.09512285099993, 47.619126695000034],
              [-54.09325110599991, 47.63043854400007],
              [-54.08885657499991, 47.63886139500005],
              [-54.08421790299991, 47.64520905200004],
              [-54.08153235599991, 47.65013255400004],
              [-54.07949785099993, 47.66901276200008],
              [-54.08153235599991, 47.69114817900004],
              [-54.07241777299993, 47.68398672100005],
              [-54.067616339999915, 47.67519765800006],
              [-54.061105923999946, 47.65639883000006],
              [-54.06187903599994, 47.64158763200004],
              [-54.065012173999946, 47.62799713700008],
              [-54.071156378999945, 47.616848049000055],
              [-54.08153235599991, 47.60919830900008],
              [-54.08153235599991, 47.60175202000005],
              [-54.077015753999945, 47.59194570500006],
              [-54.07860266799992, 47.566066799000055],
              [-54.07135982999995, 47.56077708500004],
              [-54.066070115999935, 47.55536530200004],
              [-54.06297766799992, 47.54344310100004],
              [-54.06663977799991, 47.53172435100004],
              [-54.08153235599991, 47.526678778000075],
              [-54.07103430899991, 47.51825592700004],
              [-54.07380123599995, 47.50828685100004],
              [-54.08043372299994, 47.495428778000075],
              [-54.08153235599991, 47.478216864000046],
              [-54.098500128999945, 47.491848049000055],
              [-54.09923255099994, 47.50690338700008],
              [-54.09284420499995, 47.524725653000075],
              [-54.08836829299992, 47.546535549000055],
              [-54.09170488199993, 47.54437897300005],
              [-54.10204016799992, 47.540269273000035],
              [-54.102853969999956, 47.56146881700005],
              [-54.09512285099993, 47.619126695000034],
            ],
          ],
          [
            [
              [-53.567697719999956, 48.19082265800006],
              [-53.543527798999946, 48.207017320000034],
              [-53.521473761999914, 48.201239325000074],
              [-53.51402747299994, 48.186753648000035],
              [-53.53351803299995, 48.17719147300005],
              [-53.52000891799992, 48.15814850500004],
              [-53.52407792899993, 48.144517320000034],
              [-53.537993943999936, 48.12995026200008],
              [-53.553944464999915, 48.10822174700007],
              [-53.53856360599991, 48.10781484600005],
              [-53.53351803299995, 48.10822174700007],
              [-53.56550045499995, 48.08218008000006],
              [-53.618804490999935, 48.082098700000074],
              [-53.718413865999935, 48.101996161000045],
              [-53.81094316299993, 48.09520091400009],
              [-53.823882615999935, 48.09625885600008],
              [-53.87523352799991, 48.10651276200008],
              [-53.88194739499994, 48.11749909100007],
              [-53.884836391999954, 48.13108958500004],
              [-53.88975989499994, 48.14362213700008],
              [-53.90689042899993, 48.16152578300006],
              [-53.920033331999946, 48.171210028000075],
              [-53.92837480399993, 48.18333567900004],
              [-53.93138587099992, 48.20844147300005],
              [-53.92100989499994, 48.21662018400008],
              [-53.89818274599992, 48.204779364000046],
              [-53.86241614499994, 48.17719147300005],
              [-53.84129798099991, 48.17137278900009],
              [-53.76992753799993, 48.17719147300005],
              [-53.74742591099994, 48.17206452000005],
              [-53.704416469999956, 48.151597398000035],
              [-53.67747962099992, 48.14984772300005],
              [-53.64940344999991, 48.15692780200004],
              [-53.567697719999956, 48.19082265800006],
            ],
          ],
          [
            [
              [-54.65689042899993, 49.465725002000056],
              [-54.66710364499994, 49.46576569200005],
              [-54.67870032499991, 49.46320221600007],
              [-54.68545488199993, 49.45758698100008],
              [-54.68114173099991, 49.44863515800006],
              [-54.677805141999954, 49.438381252000056],
              [-54.684437628999945, 49.42767975500004],
              [-54.69375566299993, 49.417181708000044],
              [-54.698557094999956, 49.40766022300005],
              [-54.70872962099992, 49.40582916900007],
              [-54.73037675699993, 49.41128164300005],
              [-54.74990800699993, 49.424261786000045],
              [-54.75377356699994, 49.44521719000005],
              [-54.74038652299993, 49.45888906500005],
              [-54.69969641799992, 49.47260163000004],
              [-54.691070115999935, 49.48309967700004],
              [-54.67959550699993, 49.49290599200003],
              [-54.65762285099993, 49.48745351800005],
              [-54.64391028599994, 49.47532786700003],
              [-54.65689042899993, 49.465725002000056],
            ],
          ],
          [
            [
              [-55.72573808499993, 49.56191640800006],
              [-55.71251380099994, 49.56476471600007],
              [-55.657460089999915, 49.56191640800006],
              [-55.657093878999945, 49.541449286000045],
              [-55.678578253999945, 49.520697333000044],
              [-55.70848548099991, 49.50849030200004],
              [-55.73322506399995, 49.51349518400008],
              [-55.73615475199995, 49.52228424700007],
              [-55.735991990999935, 49.53685130400004],
              [-55.73257402299993, 49.551947333000044],
              [-55.72573808499993, 49.56191640800006],
            ],
          ],
          [
            [
              [-55.578968878999945, 49.60968659100007],
              [-55.57274329299992, 49.60757070500006],
              [-55.57079016799992, 49.602850653000075],
              [-55.57290605399993, 49.59813060100004],
              [-55.578968878999945, 49.59601471600007],
              [-55.595814581999946, 49.59471263200004],
              [-55.64053300699993, 49.58551666900007],
              [-55.67027747299994, 49.57111237200007],
              [-55.69310462099992, 49.568345445000034],
              [-55.71446692599994, 49.571478583000044],
              [-55.72573808499993, 49.58177317900004],
              [-55.72325598899994, 49.58738841400009],
              [-55.70921790299991, 49.60333893400008],
              [-55.70254472599993, 49.62254466400009],
              [-55.69432532499991, 49.628566799000055],
              [-55.67174231699994, 49.63703034100007],
              [-55.651275193999936, 49.63703034100007],
              [-55.655181443999936, 49.62710195500006],
              [-55.657460089999915, 49.62335846600007],
              [-55.64354407499991, 49.62474192900004],
              [-55.631418423999946, 49.62246328300006],
              [-55.62523352799991, 49.61554596600007],
              [-55.62954667899993, 49.60346100500004],
              [-55.60383053299995, 49.604681708000044],
              [-55.59605872299994, 49.60346100500004],
              [-55.59093176999994, 49.60346100500004],
              [-55.58340410099993, 49.60846588700008],
              [-55.578968878999945, 49.60968659100007],
            ],
          ],
          [
            [
              [-54.88345292899993, 49.55508047100005],
              [-54.88451087099992, 49.560248114000046],
              [-54.888335740999935, 49.57200755400004],
              [-54.89317786399994, 49.58197663000004],
              [-54.89712480399993, 49.58177317900004],
              [-54.88499915299991, 49.59520091400009],
              [-54.851551886999914, 49.591009833000044],
              [-54.83568274599992, 49.60346100500004],
              [-54.819650844999956, 49.601223049000055],
              [-54.795765753999945, 49.60101959800005],
              [-54.78062903599994, 49.59589264500005],
              [-54.790679490999935, 49.57868073100008],
              [-54.79527747299994, 49.56362539300005],
              [-54.776600714999915, 49.55609772300005],
              [-54.75039628799993, 49.553900458000044],
              [-54.73265540299991, 49.55508047100005],
              [-54.69286048099991, 49.567613023000035],
              [-54.67292232999995, 49.57868073100008],
              [-54.66441809799994, 49.59259674700007],
              [-54.660227016999954, 49.61090729400007],
              [-54.64924068899995, 49.62490469000005],
              [-54.633697068999936, 49.63377513200004],
              [-54.61595618399991, 49.63703034100007],
              [-54.62559973899994, 49.626654364000046],
              [-54.63023841099994, 49.62335846600007],
              [-54.61408443899995, 49.616115627000056],
              [-54.58726966099994, 49.63178131700005],
              [-54.557932094999956, 49.653509833000044],
              [-54.53937740799995, 49.661037502000056],
              [-54.54405676999994, 49.65180084800005],
              [-54.538726365999935, 49.64984772300005],
              [-54.53624426999994, 49.64472077000005],
              [-54.529286261999914, 49.625067450000074],
              [-54.53087317599994, 49.61542389500005],
              [-54.53750566299993, 49.606350002000056],
              [-54.547718878999945, 49.59601471600007],
              [-54.54605058499993, 49.58478424700007],
              [-54.57286536399994, 49.57184479400007],
              [-54.60773678299995, 49.56073639500005],
              [-54.699330206999946, 49.541896877000056],
              [-54.71898352799991, 49.53461334800005],
              [-54.73029537699995, 49.528957424000055],
              [-54.736439581999946, 49.52435944200005],
              [-54.73900305899991, 49.51703522300005],
              [-54.739491339999915, 49.503241278000075],
              [-54.74400794199994, 49.493801174000055],
              [-54.75495357999995, 49.493801174000055],
              [-54.78107662699995, 49.49982330900008],
              [-54.82848059799994, 49.48920319200005],
              [-54.85236568899995, 49.48651764500005],
              [-54.876616990999935, 49.49359772300005],
              [-54.859934048999946, 49.50381094000005],
              [-54.84552975199995, 49.509833075000074],
              [-54.83023027299993, 49.51276276200008],
              [-54.81118730399993, 49.51349518400008],
              [-54.80687415299991, 49.515611070000034],
              [-54.81163489499994, 49.52033112200007],
              [-54.82135982999995, 49.525051174000055],
              [-54.840402798999946, 49.52977122600004],
              [-54.847320115999935, 49.53620026200008],
              [-54.85960852799991, 49.551662502000056],
              [-54.86375891799992, 49.552720445000034],
              [-54.87718665299991, 49.55223216400009],
              [-54.88345292899993, 49.55508047100005],
            ],
          ],
          [
            [
              [-54.27676347599993, 49.57558828300006],
              [-54.29198157499991, 49.58738841400009],
              [-54.29869544199994, 49.61513906500005],
              [-54.301991339999915, 49.64712148600006],
              [-54.307484503999945, 49.67177969000005],
              [-54.294992641999954, 49.67674388200004],
              [-54.267241990999935, 49.67328522300005],
              [-54.252837693999936, 49.67796458500004],
              [-54.26211503799993, 49.68024323100008],
              [-54.26992753799993, 49.684475002000056],
              [-54.27603105399993, 49.690619208000044],
              [-54.280140753999945, 49.698431708000044],
              [-54.27476966099994, 49.70189036700003],
              [-54.27188066299993, 49.70530833500004],
              [-54.26976477799991, 49.70888906500005],
              [-54.266509568999936, 49.71271393400008],
              [-54.27171790299991, 49.712225653000075],
              [-54.28237870999993, 49.712958075000074],
              [-54.28758704299992, 49.71271393400008],
              [-54.26984615799995, 49.72724030200004],
              [-54.24404863199993, 49.72606028900009],
              [-54.21760006399995, 49.71637604400007],
              [-54.19762122299994, 49.70526764500005],
              [-54.205067511999914, 49.698431708000044],
              [-54.191395636999914, 49.67796458500004],
              [-54.182932094999956, 49.69135163000004],
              [-54.18350175699993, 49.70482005400004],
              [-54.18635006399995, 49.71698639500005],
              [-54.18464107999995, 49.72638580900008],
              [-54.17296301999994, 49.733587958000044],
              [-54.16148841099994, 49.732123114000046],
              [-54.14952551999994, 49.72931549700007],
              [-54.136789516999954, 49.73261139500005],
              [-54.141468878999945, 49.73773834800005],
              [-54.150461391999954, 49.75372955900008],
              [-54.110218878999945, 49.75446198100008],
              [-54.09203040299991, 49.75047435100004],
              [-54.07599850199995, 49.73411692900004],
              [-54.061756964999915, 49.725043036000045],
              [-54.05426998599995, 49.71893952000005],
              [-54.04898027299993, 49.71718984600005],
              [-54.04198157499991, 49.71674225500004],
              [-54.03579667899993, 49.71499258000006],
              [-54.03311113199993, 49.708970445000034],
              [-54.034820115999935, 49.70453522300005],
              [-54.038319464999915, 49.70062897300005],
              [-54.041005011999914, 49.69668203300006],
              [-54.04059811099995, 49.69163646000004],
              [-54.02977454299992, 49.67597077000005],
              [-54.016509568999936, 49.66779205900008],
              [-53.99982662699995, 49.66474030200004],
              [-53.978505011999914, 49.66429271000004],
              [-53.987172003999945, 49.65106842700004],
              [-54.000070766999954, 49.650091864000046],
              [-54.03001868399991, 49.657456773000035],
              [-54.03888912699995, 49.654282945000034],
              [-54.04596920499995, 49.64728424700007],
              [-54.05540930899991, 49.64020416900007],
              [-54.08665930899991, 49.63499583500004],
              [-54.095041469999956, 49.62995026200008],
              [-54.10260982999995, 49.62335846600007],
              [-54.11571204299992, 49.616522528000075],
              [-54.13027910099993, 49.61273834800005],
              [-54.17096920499995, 49.60968659100007],
              [-54.21035722599993, 49.598089911000045],
              [-54.22215735599991, 49.59601471600007],
              [-54.22760982999995, 49.59369538000004],
              [-54.258697068999936, 49.571478583000044],
              [-54.263335740999935, 49.571193752000056],
              [-54.26789303299995, 49.57379791900007],
              [-54.27676347599993, 49.57558828300006],
            ],
          ],
          [
            [
              [-59.35057532499991, 50.60346100500004],
              [-59.36245683499993, 50.604681708000044],
              [-59.36571204299992, 50.60586172100005],
              [-59.36758378799993, 50.61005280200004],
              [-59.37539628799993, 50.62051015800006],
              [-59.383371548999946, 50.63882070500006],
              [-59.3762914699999, 50.652329820000034],
              [-59.359364386999914, 50.655951239000046],
              [-59.33751380099994, 50.64443594000005],
              [-59.314442511999914, 50.60346100500004],
              [-59.30650794199994, 50.59662506700005],
              [-59.29596920499995, 50.572333075000074],
              [-59.29800370999993, 50.564113674000055],
              [-59.30321204299992, 50.56085846600007],
              [-59.31004798099991, 50.559027411000045],
              [-59.31704667899993, 50.55499909100007],
              [-59.3274633449999, 50.546210028000075],
              [-59.341053839999915, 50.53803131700005],
              [-59.35293535099993, 50.537543036000045],
              [-59.35802161399994, 50.55158112200007],
              [-59.35366777299993, 50.56427643400008],
              [-59.323882615999935, 50.610256252000056],
              [-59.33551998599995, 50.61603424700007],
              [-59.34251868399991, 50.61273834800005],
              [-59.34679114499994, 50.60651276200008],
              [-59.35057532499991, 50.60346100500004],
            ],
          ],
          [
            [
              [-55.51036536399994, 50.805121161000045],
              [-55.49136308499993, 50.808579820000034],
              [-55.46642005099994, 50.80426666900007],
              [-55.45230058499993, 50.796210028000075],
              [-55.465687628999945, 50.788397528000075],
              [-55.46947180899991, 50.785589911000045],
              [-55.471913214999915, 50.782863674000055],
              [-55.47484290299991, 50.780951239000046],
              [-55.47996985599991, 50.780951239000046],
              [-55.47671464799993, 50.77692291900007],
              [-55.474720831999946, 50.77326080900008],
              [-55.47175045499995, 50.77008698100008],
              [-55.465687628999945, 50.767279364000046],
              [-55.497710740999935, 50.751613674000055],
              [-55.50934811099995, 50.74233633000006],
              [-55.50666256399995, 50.73379140800006],
              [-55.52358964799993, 50.72101471600007],
              [-55.58238684799994, 50.69896067900004],
              [-55.59007727799991, 50.70929596600007],
              [-55.59825598899994, 50.716864325000074],
              [-55.607085740999935, 50.71898021000004],
              [-55.616525844999956, 50.713324286000045],
              [-55.64273027299993, 50.72333405200004],
              [-55.64639238199993, 50.73261139500005],
              [-55.62336178299995, 50.761053778000075],
              [-55.62344316299993, 50.76634349200003],
              [-55.626210089999915, 50.77289459800005],
              [-55.62669837099992, 50.78119538000004],
              [-55.61994381399995, 50.79181549700007],
              [-55.61107337099992, 50.79564036700003],
              [-55.603586391999954, 50.79169342700004],
              [-55.598215298999946, 50.78339264500005],
              [-55.59605872299994, 50.774725653000075],
              [-55.575428839999915, 50.778998114000046],
              [-55.52806555899991, 50.79466380400004],
              [-55.51036536399994, 50.805121161000045],
            ],
          ],
          [
            [
              [-55.52782141799992, 50.972723700000074],
              [-55.53477942599994, 50.958197333000044],
              [-55.54312089799993, 50.95091380400004],
              [-55.55333411399994, 50.94521719000005],
              [-55.56558183499993, 50.93549225500004],
              [-55.57306881399995, 50.923041083000044],
              [-55.56737219999991, 50.915269273000035],
              [-55.55638587099992, 50.90643952000005],
              [-55.54759680899991, 50.89081452000005],
              [-55.56916256399995, 50.89093659100007],
              [-55.58775794199994, 50.89598216400009],
              [-55.62336178299995, 50.91193268400008],
              [-55.61237545499995, 50.92267487200007],
              [-55.613392706999946, 50.931341864000046],
              [-55.63329016799992, 50.94977448100008],
              [-55.63914954299992, 50.96149323100008],
              [-55.629465298999946, 50.96539948100008],
              [-55.602853969999956, 50.96653880400004],
              [-55.56265214799993, 50.985988674000055],
              [-55.541900193999936, 50.98777903900009],
              [-55.52782141799992, 50.972723700000074],
            ],
          ],
          [
            [
              [-58.398426886999914, 51.25454336100006],
              [-58.40859941299993, 51.247259833000044],
              [-58.45571855399993, 51.225043036000045],
              [-58.47419186099995, 51.220404364000046],
              [-58.56289628799993, 51.23338450700004],
              [-58.55370032499991, 51.245306708000044],
              [-58.53587805899991, 51.25800202000005],
              [-58.50210527299993, 51.275051174000055],
              [-58.47948157499991, 51.27798086100006],
              [-58.433583136999914, 51.27619049700007],
              [-58.412098761999914, 51.28180573100008],
              [-58.412098761999914, 51.267564195000034],
              [-58.40953528599994, 51.26341380400004],
              [-58.408273891999954, 51.25885651200008],
              [-58.405506964999915, 51.25543854400007],
              [-58.398426886999914, 51.25454336100006],
            ],
          ],
          [
            [
              [-52.62881425699993, 47.526678778000075],
              [-52.61660722599993, 47.522691148000035],
              [-52.61693274599992, 47.51276276200008],
              [-52.62852942599994, 47.48574453300006],
              [-52.64329993399991, 47.487534898000035],
              [-52.65900631399995, 47.481756903000075],
              [-52.69058183499993, 47.46458567900004],
              [-52.66047115799995, 47.44578685100004],
              [-52.65660559799994, 47.43707916900007],
              [-52.663319464999915, 47.42365143400008],
              [-52.674712693999936, 47.412095445000034],
              [-52.701283331999946, 47.39276764500005],
              [-52.711048956999946, 47.383246161000045],
              [-52.718088344999956, 47.368801174000055],
              [-52.73037675699993, 47.33250560100004],
              [-52.738392706999946, 47.32062409100007],
              [-52.75259355399993, 47.31435781500005],
              [-52.78563391799992, 47.31146881700005],
              [-52.800445115999935, 47.30695221600007],
              [-52.79133053299995, 47.301947333000044],
              [-52.781320766999954, 47.29954661700003],
              [-52.77061926999994, 47.29913971600007],
              [-52.75951087099992, 47.300116278000075],
              [-52.76854407499991, 47.28900788000004],
              [-52.78237870999993, 47.28221263200004],
              [-52.81407630099994, 47.273423570000034],
              [-52.80190995999993, 47.25877513200004],
              [-52.805531378999945, 47.25079987200007],
              [-52.81493079299992, 47.24286530200004],
              [-52.82241777299993, 47.22016022300005],
              [-52.83185787699995, 47.20359935100004],
              [-52.83617102799991, 47.18378327000005],
              [-52.841135219999956, 47.17812734600005],
              [-52.84601803299995, 47.173529364000046],
              [-52.84825598899994, 47.16669342700004],
              [-52.85301673099991, 47.13426341400009],
              [-52.859445766999954, 47.115301825000074],
              [-52.86876380099994, 47.10150788000004],
              [-52.882923956999946, 47.09589264500005],
              [-52.92031816299993, 47.09406159100007],
              [-52.937611456999946, 47.08783600500004],
              [-52.88703365799995, 47.075506903000075],
              [-52.868397589999915, 47.07416413000004],
              [-52.84919186099995, 47.06981028900009],
              [-52.84630286399994, 47.06146881700005],
              [-52.85627193899995, 47.055853583000044],
              [-52.87490800699993, 47.059881903000075],
              [-52.87149003799993, 47.05109284100007],
              [-52.86668860599991, 47.04328034100007],
              [-52.86082923099991, 47.037095445000034],
              [-52.85448157499991, 47.033189195000034],
              [-52.85448157499991, 47.02635325700004],
              [-52.88927161399994, 47.00682200700004],
              [-52.895090298999946, 46.99555084800005],
              [-52.88239498599995, 46.97797272300005],
              [-52.89590410099993, 46.973944403000075],
              [-52.898548956999946, 46.96698639500005],
              [-52.89395097599993, 46.96039459800005],
              [-52.88585364499994, 46.957464911000045],
              [-52.88219153599994, 46.95111725500004],
              [-52.90973873599995, 46.91278717700004],
              [-52.915272589999915, 46.890285549000055],
              [-52.92617753799993, 46.86831289300005],
              [-52.93407141799992, 46.84711334800005],
              [-52.93016516799992, 46.82713450700004],
              [-52.936105923999946, 46.81704336100006],
              [-52.937489386999914, 46.80337148600006],
              [-52.94127356699994, 46.79132721600007],
              [-52.96108964799993, 46.78278229400007],
              [-52.971994594999956, 46.765692450000074],
              [-52.978627081999946, 46.75885651200008],
              [-53.00694739499994, 46.753119208000044],
              [-53.00934811099995, 46.752020575000074],
              [-53.031320766999954, 46.736029364000046],
              [-53.06688391799992, 46.66559479400007],
              [-53.09154212099992, 46.649603583000044],
              [-53.14305579299992, 46.62913646000004],
              [-53.176625128999945, 46.62514883000006],
              [-53.19286048099991, 46.62763092700004],
              [-53.21133378799993, 46.63532135600008],
              [-53.23232988199993, 46.65375397300005],
              [-53.25365149599992, 46.68317291900007],
              [-53.26748613199993, 46.714544989000046],
              [-53.26598059799994, 46.73899974200003],
              [-53.282541469999956, 46.73281484600005],
              [-53.29865475199995, 46.72064850500004],
              [-53.324330206999946, 46.69399648600006],
              [-53.33120683499993, 46.69330475500004],
              [-53.33771725199995, 46.70180898600006],
              [-53.34349524599992, 46.712225653000075],
              [-53.348500128999945, 46.71727122600004],
              [-53.35973059799994, 46.71344635600008],
              [-53.37071692599994, 46.704413153000075],
              [-53.38947506399995, 46.68378327000005],
              [-53.382923956999946, 46.69867584800005],
              [-53.35533606699994, 46.73899974200003],
              [-53.37385006399995, 46.73484935100004],
              [-53.38939368399991, 46.72370026200008],
              [-53.41681881399995, 46.69741445500006],
              [-53.432850714999915, 46.687567450000074],
              [-53.440744594999956, 46.680853583000044],
              [-53.44880123599995, 46.66400788000004],
              [-53.459828253999945, 46.659409898000035],
              [-53.47240149599992, 46.65664297100005],
              [-53.48200436099995, 46.65273672100005],
              [-53.51829993399991, 46.628566799000055],
              [-53.554676886999914, 46.618353583000044],
              [-53.58999589799993, 46.626166083000044],
              [-53.62287350199995, 46.65582916900007],
              [-53.62657630099994, 46.662990627000056],
              [-53.63491777299993, 46.68585846600007],
              [-53.63646399599992, 46.69399648600006],
              [-53.63646399599992, 46.711371161000045],
              [-53.61831620999993, 46.74103424700007],
              [-53.605132615999935, 46.75543854400007],
              [-53.601633266999954, 46.76422760600008],
              [-53.60326087099992, 46.775051174000055],
              [-53.606678839999915, 46.786444403000075],
              [-53.60855058499993, 46.79706452000005],
              [-53.60008704299992, 46.812567450000074],
              [-53.562489386999914, 46.84634023600006],
              [-53.553944464999915, 46.86497630400004],
              [-53.54405676999994, 46.87848541900007],
              [-53.498605923999946, 46.886786200000074],
              [-53.48570716099994, 46.90289948100008],
              [-53.49958248599995, 46.89862702000005],
              [-53.53164628799993, 46.89325592700004],
              [-53.54405676999994, 46.88580963700008],
              [-53.61156165299991, 46.81427643400008],
              [-53.63687089799993, 46.798895575000074],
              [-53.643462693999936, 46.79661692900004],
              [-53.64488684799994, 46.80117422100005],
              [-53.64053300699993, 46.82827383000006],
              [-53.63621985599991, 46.83869049700007],
              [-53.62938391799992, 46.847642320000034],
              [-53.619211391999954, 46.85814036700003],
              [-53.612619594999956, 46.86904531500005],
              [-53.60509192599994, 46.89533112200007],
              [-53.59870357999995, 46.905951239000046],
              [-53.54710852799991, 46.92820872600004],
              [-53.521148240999935, 46.944647528000075],
              [-53.519195115999935, 46.96430084800005],
              [-53.53062903599994, 46.95327383000006],
              [-53.54214433499993, 46.944647528000075],
              [-53.55443274599992, 46.94082265800006],
              [-53.567697719999956, 46.94383372600004],
              [-53.56322180899991, 46.952460028000075],
              [-53.561756964999915, 46.96088288000004],
              [-53.56322180899991, 46.96930573100008],
              [-53.567697719999956, 46.97797272300005],
              [-53.57445227799991, 46.97797272300005],
              [-53.577463344999956, 46.97117747600004],
              [-53.587880011999914, 46.95359935100004],
              [-53.591867641999954, 46.95001862200007],
              [-53.59874426999994, 46.95075104400007],
              [-53.608631964999915, 46.95351797100005],
              [-53.615223761999914, 46.958970445000034],
              [-53.61196855399993, 46.968003648000035],
              [-53.60008704299992, 46.98688385600008],
              [-53.60855058499993, 46.991522528000075],
              [-53.64338131399995, 46.98541901200008],
              [-53.62539628799993, 47.01341380400004],
              [-53.605132615999935, 47.03660716400009],
              [-53.578114386999914, 47.05951569200005],
              [-53.57062740799995, 47.072699286000045],
              [-53.58189856699994, 47.08161041900007],
              [-53.56314042899993, 47.097723700000074],
              [-53.511789516999954, 47.12299225500004],
              [-53.49868730399993, 47.135646877000056],
              [-53.51520748599995, 47.13589101800005],
              [-53.524322068999936, 47.14350006700005],
              [-53.52574622299994, 47.15582916900007],
              [-53.519195115999935, 47.16974518400008],
              [-53.53302975199995, 47.16681549700007],
              [-53.55626380099994, 47.15794505400004],
              [-53.57103430899991, 47.15615469000005],
              [-53.57258053299995, 47.16205475500004],
              [-53.56212317599994, 47.19208405200004],
              [-53.56017005099994, 47.20453522300005],
              [-53.59422766799992, 47.145697333000044],
              [-53.617298956999946, 47.11933014500005],
              [-53.65021725199995, 47.10834381700005],
              [-53.63556881399995, 47.14484284100007],
              [-53.62905839799993, 47.15615469000005],
              [-53.64098059799994, 47.153225002000056],
              [-53.64976966099994, 47.14716217700004],
              [-53.656809048999946, 47.13886139500005],
              [-53.66319739499994, 47.12881094000005],
              [-53.67747962099992, 47.09125397300005],
              [-53.683583136999914, 47.09064362200007],
              [-53.69562740799995, 47.08454010600008],
              [-53.70449785099993, 47.07754140800006],
              [-53.695423956999946, 47.07013580900008],
              [-53.704009568999936, 47.06110260600008],
              [-53.72524980399993, 47.04682038000004],
              [-53.73668372299994, 47.04364655200004],
              [-53.75918535099993, 47.041896877000056],
              [-53.766835089999915, 47.04002513200004],
              [-53.77525794199994, 47.03180573100008],
              [-53.818470831999946, 46.962591864000046],
              [-53.82485917899993, 46.957464911000045],
              [-53.86119544199994, 46.94757721600007],
              [-53.869252081999946, 46.94383372600004],
              [-53.87291419199994, 46.93732330900008],
              [-53.87791907499991, 46.91787344000005],
              [-53.882923956999946, 46.909084377000056],
              [-53.88963782499991, 46.90420156500005],
              [-53.91270911399994, 46.89175039300005],
              [-53.934152798999946, 46.886053778000075],
              [-53.93960527299993, 46.878241278000075],
              [-53.94249426999994, 46.86810944200005],
              [-53.947824673999946, 46.85814036700003],
              [-53.95693925699993, 46.852769273000035],
              [-53.992176886999914, 46.84829336100006],
              [-54.00308183499993, 46.84259674700007],
              [-54.02692623599995, 46.82094961100006],
              [-54.04043535099993, 46.812201239000046],
              [-54.05036373599995, 46.80805084800005],
              [-54.060536261999914, 46.80678945500006],
              [-54.07469641799992, 46.806626695000034],
              [-54.08165442599994, 46.80565013200004],
              [-54.09292558499993, 46.80145905200004],
              [-54.09862219999991, 46.800482489000046],
              [-54.10456295499995, 46.802435614000046],
              [-54.11359615799995, 46.81146881700005],
              [-54.11904863199993, 46.81346263200004],
              [-54.17096920499995, 46.82094961100006],
              [-54.18492591099994, 46.82611725500004],
              [-54.18854732999995, 46.82843659100007],
              [-54.18846594999991, 46.83388906500005],
              [-54.19579016799992, 46.86440664300005],
              [-54.19762122299994, 46.88580963700008],
              [-54.19408118399991, 46.90737539300005],
              [-54.18541419199994, 46.927801825000074],
              [-54.164133266999954, 46.96430084800005],
              [-54.16038977799991, 46.97406647300005],
              [-54.155506964999915, 46.99518463700008],
              [-54.150461391999954, 47.00531647300005],
              [-54.112619594999956, 47.043402411000045],
              [-54.10041256399995, 47.059800523000035],
              [-54.04039466099994, 47.17991771000004],
              [-54.023548956999946, 47.20075104400007],
              [-54.01895097599993, 47.210150458000044],
              [-54.01524817599994, 47.222723700000074],
              [-54.01040605399993, 47.23387278900009],
              [-54.00275631399995, 47.23867422100005],
              [-53.951242641999954, 47.23187897300005],
              [-53.931752081999946, 47.234361070000034],
              [-53.94395911399994, 47.24119700700004],
              [-53.96934973899994, 47.25104401200008],
              [-53.98908443899995, 47.262600002000056],
              [-53.99596106699994, 47.27216217700004],
              [-53.99909420499995, 47.281317450000074],
              [-53.99962317599994, 47.30353424700007],
              [-53.996205206999946, 47.31720612200007],
              [-53.98802649599992, 47.31976959800005],
              [-53.97166907499991, 47.31439850500004],
              [-53.96947180899991, 47.31264883000006],
              [-53.972645636999914, 47.30963776200008],
              [-53.97716223899994, 47.30719635600008],
              [-53.978505011999914, 47.30695221600007],
              [-53.96141516799992, 47.30329010600008],
              [-53.938791469999956, 47.30516185100004],
              [-53.92227128799993, 47.31321849200003],
              [-53.923939581999946, 47.32807038000004],
              [-53.89525305899991, 47.34048086100006],
              [-53.88426673099991, 47.34906647300005],
              [-53.87669837099992, 47.36151764500005],
              [-53.90330969999991, 47.361029364000046],
              [-53.91429602799991, 47.36347077000005],
              [-53.91055253799993, 47.372748114000046],
              [-53.89289303299995, 47.39288971600007],
              [-53.87539628799993, 47.40534088700008],
              [-53.85313880099994, 47.41347890800006],
              [-53.807850714999915, 47.42365143400008],
              [-53.807850714999915, 47.43048737200007],
              [-53.82921301999994, 47.42926666900007],
              [-53.83511308499993, 47.43048737200007],
              [-53.84605872299994, 47.43813711100006],
              [-53.850819464999915, 47.44285716400009],
              [-53.84878495999993, 47.44476959800005],
              [-53.902007615999935, 47.43154531500005],
              [-53.910267706999946, 47.43390534100007],
              [-53.913400844999956, 47.44245026200008],
              [-53.91934160099993, 47.448553778000075],
              [-53.92345130099994, 47.45408763200004],
              [-53.920765753999945, 47.46116771000004],
              [-53.90859941299993, 47.47345612200007],
              [-53.904855923999946, 47.47992584800005],
              [-53.90343176999994, 47.48875560100004],
              [-53.89757239499994, 47.50340403900009],
              [-53.88784745999993, 47.516913153000075],
              [-53.88585364499994, 47.52749258000006],
              [-53.90343176999994, 47.53351471600007],
              [-53.891835089999915, 47.577460028000075],
              [-53.892567511999914, 47.598822333000044],
              [-53.90343176999994, 47.61603424700007],
              [-53.90859941299993, 47.61664459800005],
              [-53.918812628999945, 47.608710028000075],
              [-53.923939581999946, 47.60919830900008],
              [-53.92756100199995, 47.61310455900008],
              [-53.930897589999915, 47.620754299000055],
              [-53.93472245999993, 47.62567780200004],
              [-53.93984941299993, 47.63491445500006],
              [-53.94367428299995, 47.64911530200004],
              [-53.94469153599994, 47.663723049000055],
              [-53.94127356699994, 47.67405833500004],
              [-53.94790605399993, 47.681708075000074],
              [-53.97166907499991, 47.74266185100004],
              [-53.96979732999995, 47.74819570500006],
              [-53.96637936099995, 47.75250885600008],
              [-53.96471106699994, 47.75690338700008],
              [-53.96825110599991, 47.76251862200007],
              [-53.975168423999946, 47.764837958000044],
              [-53.98155676999994, 47.76203034100007],
              [-53.98729407499991, 47.75873444200005],
              [-53.992176886999914, 47.759426174000055],
              [-54.000843878999945, 47.771144924000055],
              [-54.00796464799993, 47.79482656500005],
              [-54.01329505099994, 47.80719635600008],
              [-54.005848761999914, 47.82086823100008],
              [-54.04214433499993, 47.801988023000035],
              [-54.06086178299995, 47.80036041900007],
              [-54.07469641799992, 47.81403229400007],
              [-54.074289516999954, 47.82046133000006],
              [-54.069569464999915, 47.82558828300006],
              [-54.06395423099991, 47.82851797100005],
              [-54.061105923999946, 47.82831452000005],
              [-54.062611456999946, 47.83283112200007],
              [-54.06712805899991, 47.841782945000034],
              [-54.06794186099995, 47.84198639500005],
              [-54.071156378999945, 47.850775458000044],
              [-54.076242641999954, 47.85651276200008],
              [-54.08055579299992, 47.863348700000074],
              [-54.08153235599991, 47.87547435100004],
              [-54.09227454299992, 47.86302317900004],
              [-54.09825598899994, 47.837591864000046],
              [-54.109486456999946, 47.82831452000005],
              [-54.125070766999954, 47.828111070000034],
              [-54.14102128799993, 47.83576080900008],
              [-54.164133266999954, 47.85504791900007],
              [-54.16637122299994, 47.85976797100005],
              [-54.16787675699993, 47.87128327000005],
              [-54.17096920499995, 47.87547435100004],
              [-54.179025844999956, 47.878973700000074],
              [-54.205067511999914, 47.88296133000006],
              [-54.266509568999936, 47.90346914300005],
              [-54.25373287699995, 47.88776276200008],
              [-54.23350989499994, 47.88165924700007],
              [-54.21263587099992, 47.87791575700004],
              [-54.19762122299994, 47.86928945500006],
              [-54.19371497299994, 47.852769273000035],
              [-54.19823157499991, 47.833319403000075],
              [-54.224273240999935, 47.772691148000035],
              [-54.24913489499994, 47.730129299000055],
              [-54.280140753999945, 47.69794342700004],
              [-54.31090247299994, 47.70075104400007],
              [-54.32725989499994, 47.710150458000044],
              [-54.32917232999995, 47.69672272300005],
              [-54.321156378999945, 47.667222398000035],
              [-54.32656816299993, 47.647650458000044],
              [-54.350453253999945, 47.618801174000055],
              [-54.35586503799993, 47.605454820000034],
              [-54.363392706999946, 47.59174225500004],
              [-54.39622962099992, 47.55951569200005],
              [-54.411040818999936, 47.53066640800006],
              [-54.427845831999946, 47.516913153000075],
              [-54.45836341099994, 47.49941640800006],
              [-54.456369594999956, 47.49396393400008],
              [-54.454416469999956, 47.49095286700003],
              [-54.45103919199994, 47.488714911000045],
              [-54.444650844999956, 47.48574453300006],
              [-54.43846594999991, 47.49941640800006],
              [-54.42959550699993, 47.486029364000046],
              [-54.42418372299994, 47.471991278000075],
              [-54.417307094999956, 47.45945872600004],
              [-54.40367591099994, 47.45091380400004],
              [-54.43809973899994, 47.43008047100005],
              [-54.452056443999936, 47.42365143400008],
              [-54.44505774599992, 47.438381252000056],
              [-54.44432532499991, 47.44944896000004],
              [-54.450835740999935, 47.45453522300005],
              [-54.465728318999936, 47.45091380400004],
              [-54.47630774599992, 47.44245026200008],
              [-54.495025193999936, 47.41510651200008],
              [-54.50609290299991, 47.40253327000005],
              [-54.49864661399994, 47.39858633000006],
              [-54.49181067599994, 47.39874909100007],
              [-54.48542232999995, 47.402777411000045],
              [-54.479400193999936, 47.40997955900008],
              [-54.47256425699993, 47.40253327000005],
              [-54.50796464799993, 47.38222890800006],
              [-54.523426886999914, 47.37669505400004],
              [-54.526600714999915, 47.383246161000045],
              [-54.57945716099994, 47.359361070000034],
              [-54.60582434799994, 47.35248444200005],
              [-54.61595618399991, 47.36896393400008],
              [-54.610585089999915, 47.37714264500005],
              [-54.57502193899995, 47.39630768400008],
              [-54.437163865999935, 47.55565013200004],
              [-54.41120357999995, 47.60175202000005],
              [-54.41441809799994, 47.60492584800005],
              [-54.41734778599994, 47.60919830900008],
              [-54.43382727799991, 47.59393952000005],
              [-54.47252356699994, 47.54962799700007],
              [-54.50413977799991, 47.530462958000044],
              [-54.54393469999991, 47.468003648000035],
              [-54.60293535099993, 47.40997955900008],
              [-54.65640214799993, 47.38515859600005],
              [-54.66441809799994, 47.37579987200007],
              [-54.67178300699993, 47.380519924000055],
              [-54.67609615799995, 47.38544342700004],
              [-54.677805141999954, 47.392279364000046],
              [-54.677398240999935, 47.40253327000005],
              [-54.68858801999994, 47.39838288000004],
              [-54.697824673999946, 47.39240143400008],
              [-54.70543372299994, 47.384833075000074],
              [-54.712147589999915, 47.37579987200007],
              [-54.70579993399991, 47.37287018400008],
              [-54.703236456999946, 47.36985911700003],
              [-54.70164954299992, 47.36619700700004],
              [-54.698557094999956, 47.36151764500005],
              [-54.710926886999914, 47.35602448100008],
              [-54.72207597599993, 47.35594310100004],
              [-54.73009192599994, 47.36229075700004],
              [-54.73265540299991, 47.37579987200007],
              [-54.74596106699994, 47.36741771000004],
              [-54.75959225199995, 47.36277903900009],
              [-54.77000891799992, 47.366522528000075],
              [-54.77358964799993, 47.383246161000045],
              [-54.79625403599994, 47.37287018400008],
              [-54.808257615999935, 47.36945221600007],
              [-54.82201087099992, 47.36896393400008],
              [-54.79564368399991, 47.39435455900008],
              [-54.78490149599992, 47.41128164300005],
              [-54.78726152299993, 47.42365143400008],
              [-54.80150305899991, 47.42300039300005],
              [-54.81395423099991, 47.40761953300006],
              [-54.828236456999946, 47.37579987200007],
              [-54.840402798999946, 47.384466864000046],
              [-54.84032141799992, 47.39744700700004],
              [-54.83263098899994, 47.41156647300005],
              [-54.82201087099992, 47.42365143400008],
              [-54.837880011999914, 47.419256903000075],
              [-54.84874426999994, 47.40778229400007],
              [-54.866078253999945, 47.37958405200004],
              [-54.87995357999995, 47.36668528900009],
              [-54.91095943899995, 47.34642161700003],
              [-54.92442786399994, 47.33490631700005],
              [-54.92796790299991, 47.32680898600006],
              [-54.92735755099994, 47.31903717700004],
              [-54.928944464999915, 47.31134674700007],
              [-54.938710089999915, 47.30353424700007],
              [-54.96629798099991, 47.288275458000044],
              [-54.97594153599994, 47.286444403000075],
              [-54.98924719999991, 47.28025950700004],
              [-55.00450598899994, 47.26593659100007],
              [-55.027455206999946, 47.23867422100005],
              [-55.04059811099995, 47.21771881700005],
              [-55.03400631399995, 47.21149323100008],
              [-55.02057857999995, 47.20770905200004],
              [-55.01317298099991, 47.19399648600006],
              [-55.01707923099991, 47.184475002000056],
              [-55.02696692599994, 47.17255280200004],
              [-55.04015051999994, 47.16201406500005],
              [-55.05418860599991, 47.15615469000005],
              [-55.07380123599995, 47.15696849200003],
              [-55.07339433499993, 47.16811758000006],
              [-55.06786048099991, 47.18427155200004],
              [-55.07184811099995, 47.20075104400007],
              [-55.088002081999946, 47.206244208000044],
              [-55.106678839999915, 47.19782135600008],
              [-55.123890753999945, 47.18305084800005],
              [-55.13609778599994, 47.16974518400008],
              [-55.097320115999935, 47.17177969000005],
              [-55.08893795499995, 47.16974518400008],
              [-55.08275305899991, 47.159084377000056],
              [-55.08446204299992, 47.148504950000074],
              [-55.088449673999946, 47.13825104400007],
              [-55.08893795499995, 47.12881094000005],
              [-55.07176673099991, 47.094956773000035],
              [-55.07469641799992, 47.08100006700005],
              [-55.10260982999995, 47.08161041900007],
              [-55.10041256399995, 47.07689036700003],
              [-55.09723873599995, 47.06464264500005],
              [-55.09512285099993, 47.059881903000075],
              [-55.134877081999946, 47.04759349200003],
              [-55.14631100199995, 47.03766510600008],
              [-55.150380011999914, 47.01581452000005],
              [-55.15461178299995, 47.012600002000056],
              [-55.16392981699994, 47.016058661000045],
              [-55.17345130099994, 47.02195872600004],
              [-55.17833411399994, 47.02635325700004],
              [-55.17878170499995, 47.037095445000034],
              [-55.17174231699994, 47.06037018400008],
              [-55.17149817599994, 47.06732819200005],
              [-55.18008378799993, 47.07501862200007],
              [-55.18858801999994, 47.07461172100005],
              [-55.196156378999945, 47.069647528000075],
              [-55.20189368399991, 47.063666083000044],
              [-55.20262610599991, 47.055853583000044],
              [-55.19375566299993, 47.032538153000075],
              [-55.19131425699993, 47.022650458000044],
              [-55.193348761999914, 47.00067780200004],
              [-55.20018469999991, 46.980536200000074],
              [-55.213002081999946, 46.96515534100007],
              [-55.23289954299992, 46.957464911000045],
              [-55.22956295499995, 46.93622467700004],
              [-55.250884568999936, 46.918850002000056],
              [-55.28294837099992, 46.90717194200005],
              [-55.311756964999915, 46.90289948100008],
              [-55.36050370999993, 46.909857489000046],
              [-55.37010657499991, 46.909084377000056],
              [-55.36974036399994, 46.89622630400004],
              [-55.36034094999991, 46.884466864000046],
              [-55.359038865999935, 46.874701239000046],
              [-55.38312740799995, 46.86810944200005],
              [-55.41783606699994, 46.86660390800006],
              [-55.45254472599993, 46.876288153000075],
              [-55.47325598899994, 46.89752838700008],
              [-55.465687628999945, 46.93081289300005],
              [-55.509103969999956, 46.91937897300005],
              [-55.52415930899991, 46.92169830900008],
              [-55.52782141799992, 46.94383372600004],
              [-55.53547115799995, 46.934881903000075],
              [-55.53750566299993, 46.925441799000055],
              [-55.53807532499991, 46.916449286000045],
              [-55.54141191299993, 46.909084377000056],
              [-55.55125891799992, 46.90094635600008],
              [-55.55455481699994, 46.90228913000004],
              [-55.55638587099992, 46.90696849200003],
              [-55.56187903599994, 46.909084377000056],
              [-55.57591712099992, 46.90761953300006],
              [-55.58165442599994, 46.90607330900008],
              [-55.58922278599994, 46.90289948100008],
              [-55.59723873599995, 46.89789459800005],
              [-55.616525844999956, 46.88239166900007],
              [-55.64952551999994, 46.86790599200003],
              [-55.66828365799995, 46.862982489000046],
              [-55.684803839999915, 46.86188385600008],
              [-55.71670488199993, 46.87099844000005],
              [-55.72891191299993, 46.86928945500006],
              [-55.73940995999993, 46.85443756700005],
              [-55.752797003999945, 46.86399974200003],
              [-55.77692623599995, 46.86786530200004],
              [-55.82567298099991, 46.86810944200005],
              [-55.85130774599992, 46.87099844000005],
              [-55.90697180899991, 46.88690827000005],
              [-55.95030676999994, 46.904364325000074],
              [-55.96812903599994, 46.917181708000044],
              [-55.981312628999945, 46.93203359600005],
              [-55.986439581999946, 46.946966864000046],
              [-55.97996985599991, 46.970363674000055],
              [-55.96397864499994, 46.98891836100006],
              [-55.925038214999915, 47.01894765800006],
              [-55.88914954299992, 47.05898672100005],
              [-55.86986243399991, 47.07514069200005],
              [-55.84618079299992, 47.08161041900007],
              [-55.82144120999993, 47.08494700700004],
              [-55.78294837099992, 47.101629950000074],
              [-55.76113847599993, 47.10834381700005],
              [-55.73802649599992, 47.10691966400009],
              [-55.684803839999915, 47.09516022300005],
              [-55.668039516999954, 47.098089911000045],
              [-55.65062415299991, 47.10639069200005],
              [-55.58238684799994, 47.11517975500004],
              [-55.523548956999946, 47.13377513200004],
              [-55.49669348899994, 47.135646877000056],
              [-55.487172003999945, 47.140285549000055],
              [-55.47695878799993, 47.15102773600006],
              [-55.46898352799991, 47.16351959800005],
              [-55.465687628999945, 47.173163153000075],
              [-55.46174068899995, 47.180894273000035],
              [-55.45230058499993, 47.18455638200004],
              [-55.44102942599994, 47.18695709800005],
              [-55.43154863199993, 47.19086334800005],
              [-55.39679928299995, 47.21820709800005],
              [-55.36864173099991, 47.228949286000045],
              [-55.34121660099993, 47.24689362200007],
              [-55.32046464799993, 47.25604889500005],
              [-55.30125891799992, 47.267645575000074],
              [-55.28750566299993, 47.286444403000075],
              [-55.28595943899995, 47.296128648000035],
              [-55.28783118399991, 47.31793854400007],
              [-55.28750566299993, 47.32807038000004],
              [-55.283314581999946, 47.33926015800006],
              [-55.270375128999945, 47.361395575000074],
              [-55.267689581999946, 47.372381903000075],
              [-55.264556443999936, 47.396185614000046],
              [-55.25527910099993, 47.411444403000075],
              [-55.18399003799993, 47.46035390800006],
              [-55.16368567599994, 47.46832916900007],
              [-55.12840735599991, 47.47370026200008],
              [-55.10879472599993, 47.48346588700008],
              [-55.095773891999954, 47.48574453300006],
              [-55.05955969999991, 47.48456452000005],
              [-55.04796301999994, 47.48574453300006],
              [-55.032134568999936, 47.49005768400008],
              [-55.00210527299993, 47.50189850500004],
              [-54.98582923099991, 47.50617096600007],
              [-54.955189581999946, 47.50617096600007],
              [-54.94786536399994, 47.51044342700004],
              [-54.95099850199995, 47.52924225500004],
              [-54.94180253799993, 47.53351471600007],
              [-54.907093878999945, 47.53351471600007],
              [-54.89232337099992, 47.53628164300005],
              [-54.853179490999935, 47.56012604400007],
              [-54.84316972599993, 47.57103099200003],
              [-54.841908331999946, 47.58808014500005],
              [-54.861439581999946, 47.573431708000044],
              [-54.86929277299993, 47.57184479400007],
              [-54.876616990999935, 47.581244208000044],
              [-54.86705481699994, 47.587876695000034],
              [-54.85191809799994, 47.606675523000035],
              [-54.841908331999946, 47.61603424700007],
              [-54.83116614499994, 47.62213776200008],
              [-54.78066972599993, 47.64057038000004],
              [-54.75275631399995, 47.64594147300005],
              [-54.739491339999915, 47.65013255400004],
              [-54.72252356699994, 47.66229889500005],
              [-54.711822068999936, 47.66819896000004],
              [-54.698557094999956, 47.67064036700003],
              [-54.71898352799991, 47.675034898000035],
              [-54.75365149599992, 47.67055898600006],
              [-54.77358964799993, 47.67064036700003],
              [-54.76675370999993, 47.68374258000006],
              [-54.826161261999914, 47.644517320000034],
              [-54.89329993399991, 47.619208075000074],
              [-54.96393795499995, 47.60565827000005],
              [-55.07217363199993, 47.597357489000046],
              [-55.08849036399994, 47.60171133000006],
              [-55.07872473899994, 47.619126695000034],
              [-55.04792232999995, 47.64276764500005],
              [-55.03355872299994, 47.65761953300006],
              [-55.027455206999946, 47.67405833500004],
              [-55.02139238199993, 47.68545156500005],
              [-54.95254472599993, 47.75136953300006],
              [-54.942250128999945, 47.76805247600004],
              [-54.93809973899994, 47.78733958500004],
              [-54.98338782499991, 47.75079987200007],
              [-55.05894934799994, 47.65843333500004],
              [-55.10260982999995, 47.622259833000044],
              [-55.09487870999993, 47.60065338700008],
              [-55.10855058499993, 47.58543528900009],
              [-55.13117428299995, 47.58356354400007],
              [-55.150380011999914, 47.60175202000005],
              [-55.15001380099994, 47.61359284100007],
              [-55.144642706999946, 47.63178131700005],
              [-55.12987219999991, 47.66380442900004],
              [-55.14631100199995, 47.65102773600006],
              [-55.16974850199995, 47.639878648000035],
              [-55.19481360599991, 47.636419989000046],
              [-55.23273678299995, 47.655178127000056],
              [-55.25877844999991, 47.66034577000005],
              [-55.308664516999954, 47.66380442900004],
              [-55.31289628799993, 47.665269273000035],
              [-55.317290818999936, 47.66819896000004],
              [-55.32241777299993, 47.67059967700004],
              [-55.32909094999991, 47.67064036700003],
              [-55.33055579299992, 47.66828034100007],
              [-55.33242753799993, 47.66351959800005],
              [-55.335926886999914, 47.65867747600004],
              [-55.34215247299994, 47.65639883000006],
              [-55.36237545499995, 47.65412018400008],
              [-55.36359615799995, 47.65721263200004],
              [-55.363352016999954, 47.667222398000035],
              [-55.36538652299993, 47.673041083000044],
              [-55.37010657499991, 47.675848700000074],
              [-55.37482662699995, 47.67767975500004],
              [-55.376942511999914, 47.68060944200005],
              [-55.375884568999936, 47.68646881700005],
              [-55.37352454299992, 47.68960195500006],
              [-55.371164516999954, 47.69159577000005],
              [-55.37010657499991, 47.69428131700005],
              [-55.364125128999945, 47.70026276200008],
              [-55.353627081999946, 47.70555247600004],
              [-55.349680141999954, 47.71116771000004],
              [-55.363352016999954, 47.718451239000046],
              [-55.360666469999956, 47.722357489000046],
              [-55.35582434799994, 47.732123114000046],
              [-55.36558997299994, 47.73200104400007],
              [-55.37482662699995, 47.72955963700008],
              [-55.38312740799995, 47.725043036000045],
              [-55.390614386999914, 47.718451239000046],
              [-55.38589433499993, 47.71531810100004],
              [-55.38182532499991, 47.709051825000074],
              [-55.376942511999914, 47.70416901200008],
              [-55.381703253999945, 47.70136139500005],
              [-55.39102128799993, 47.697333075000074],
              [-55.40021725199995, 47.69586823100008],
              [-55.40420488199993, 47.70075104400007],
              [-55.40851803299995, 47.71051666900007],
              [-55.41787675699993, 47.71747467700004],
              [-55.42731686099995, 47.71954987200007],
              [-55.43154863199993, 47.71474844000005],
              [-55.428944464999915, 47.68305084800005],
              [-55.43138587099992, 47.67267487200007],
              [-55.441477016999954, 47.66010163000004],
              [-55.464100714999915, 47.64004140800006],
              [-55.47020423099991, 47.62689850500004],
              [-55.45946204299992, 47.61603424700007],
              [-55.44644120999993, 47.619208075000074],
              [-55.43350175699993, 47.62982819200005],
              [-55.41787675699993, 47.63361237200007],
              [-55.39679928299995, 47.61603424700007],
              [-55.426991339999915, 47.59479401200008],
              [-55.43154863199993, 47.58808014500005],
              [-55.42601477799991, 47.58494700700004],
              [-55.390614386999914, 47.59552643400008],
              [-55.390614386999914, 47.58808014500005],
              [-55.40172278599994, 47.58274974200003],
              [-55.401682094999956, 47.578111070000034],
              [-55.39757239499994, 47.573431708000044],
              [-55.39679928299995, 47.567613023000035],
              [-55.418527798999946, 47.53351471600007],
              [-55.402333136999914, 47.520738023000035],
              [-55.40705318899995, 47.50145091400009],
              [-55.42235266799992, 47.48265208500004],
              [-55.43781490799995, 47.47138092700004],
              [-55.46076412699995, 47.46539948100008],
              [-55.52090410099993, 47.46458567900004],
              [-55.52424068899995, 47.46173737200007],
              [-55.55508378799993, 47.44476959800005],
              [-55.562163865999935, 47.434759833000044],
              [-55.575103318999936, 47.40965403900009],
              [-55.58238684799994, 47.40253327000005],
              [-55.598500128999945, 47.399318752000056],
              [-55.60147050699993, 47.40643952000005],
              [-55.59605872299994, 47.42365143400008],
              [-55.600493943999936, 47.43891022300005],
              [-55.59874426999994, 47.44562409100007],
              [-55.58922278599994, 47.45091380400004],
              [-55.58922278599994, 47.45774974200003],
              [-55.61095130099994, 47.45502350500004],
              [-55.64370683499993, 47.438666083000044],
              [-55.66429602799991, 47.43724192900004],
              [-55.65758216099994, 47.44513580900008],
              [-55.64435787699995, 47.45132070500006],
              [-55.63703365799995, 47.45774974200003],
              [-55.61180579299992, 47.49945709800005],
              [-55.60342363199993, 47.50775788000004],
              [-55.58922278599994, 47.51239655200004],
              [-55.59976152299993, 47.527004299000055],
              [-55.61876380099994, 47.54169342700004],
              [-55.63841712099992, 47.54531484600005],
              [-55.651275193999936, 47.526678778000075],
              [-55.64273027299993, 47.52887604400007],
              [-55.63703365799995, 47.528631903000075],
              [-55.63149980399993, 47.527411200000074],
              [-55.62336178299995, 47.526678778000075],
              [-55.62962805899991, 47.518011786000045],
              [-55.64110266799992, 47.50665924700007],
              [-55.65392005099994, 47.49656810100004],
              [-55.66429602799991, 47.491888739000046],
              [-55.675770636999914, 47.49433014500005],
              [-55.68541419199994, 47.50079987200007],
              [-55.69664466099994, 47.506293036000045],
              [-55.71271725199995, 47.50617096600007],
              [-55.70677649599992, 47.49388255400004],
              [-55.703968878999945, 47.48969147300005],
              [-55.698475714999915, 47.48574453300006],
              [-55.715687628999945, 47.47597890800006],
              [-55.73460852799991, 47.46775950700004],
              [-55.75430253799993, 47.46161530200004],
              [-55.77415930899991, 47.45774974200003],
              [-55.76414954299992, 47.47728099200003],
              [-55.76130123599995, 47.48700592700004],
              [-55.76732337099992, 47.491888739000046],
              [-55.771473761999914, 47.50421784100007],
              [-55.76707923099991, 47.51577383000006],
              [-55.759429490999935, 47.52753327000005],
              [-55.75373287699995, 47.540269273000035],
              [-55.770741339999915, 47.53143952000005],
              [-55.78652910099993, 47.51361725500004],
              [-55.79450436099995, 47.49359772300005],
              [-55.78783118399991, 47.478216864000046],
              [-55.805246548999946, 47.462225653000075],
              [-55.821603969999956, 47.464544989000046],
              [-55.83828691299993, 47.47370026200008],
              [-55.856760219999956, 47.478216864000046],
              [-55.87169348899994, 47.472642320000034],
              [-55.890614386999914, 47.460923570000034],
              [-55.90782630099994, 47.44757721600007],
              [-55.91759192599994, 47.43724192900004],
              [-55.91665605399993, 47.45734284100007],
              [-55.89085852799991, 47.47846100500004],
              [-55.835601365999935, 47.51239655200004],
              [-55.77163652299993, 47.572699286000045],
              [-55.74689693899995, 47.58808014500005],
              [-55.759877081999946, 47.58673737200007],
              [-55.780588344999956, 47.57684967700004],
              [-55.79124915299991, 47.57444896000004],
              [-55.79898027299993, 47.56915924700007],
              [-55.809885219999956, 47.559881903000075],
              [-55.81753495999993, 47.55613841400009],
              [-55.81578528599994, 47.567613023000035],
              [-55.83385169199994, 47.566392320000034],
              [-55.85041256399995, 47.557806708000044],
              [-55.87718665299991, 47.53351471600007],
              [-55.89391028599994, 47.54140859600005],
              [-55.91478430899991, 47.532863674000055],
              [-55.934885219999956, 47.51943594000005],
              [-55.948882615999935, 47.51239655200004],
              [-55.97256425699993, 47.51068756700005],
              [-56.02013098899994, 47.49949778900009],
              [-56.10578365799995, 47.46670156500005],
              [-56.12051347599993, 47.468003648000035],
              [-56.16193600199995, 47.49192942900004],
              [-56.16942298099991, 47.50372955900008],
              [-56.150949673999946, 47.51984284100007],
              [-56.13341223899994, 47.525458075000074],
              [-56.04552161399994, 47.53579336100006],
              [-55.93862870999993, 47.567613023000035],
              [-55.92959550699993, 47.56810130400004],
              [-55.918080206999946, 47.56679922100005],
              [-55.911366339999915, 47.567613023000035],
              [-55.90656490799995, 47.57070547100005],
              [-55.90347245999993, 47.57526276200008],
              [-55.90001380099994, 47.57949453300006],
              [-55.88239498599995, 47.58445872600004],
              [-55.86314856699994, 47.59857819200005],
              [-55.85301673099991, 47.60175202000005],
              [-55.82949785099993, 47.60374583500004],
              [-55.808257615999935, 47.60919830900008],
              [-55.78673255099994, 47.61896393400008],
              [-55.74254309799994, 47.64492422100005],
              [-55.722645636999914, 47.65013255400004],
              [-55.69896399599992, 47.65306224200003],
              [-55.62954667899993, 47.67747630400004],
              [-55.650380011999914, 47.68183014500005],
              [-55.68004309799994, 47.67841217700004],
              [-55.73322506399995, 47.66380442900004],
              [-55.81314042899993, 47.62518952000005],
              [-55.843088344999956, 47.622259833000044],
              [-55.867298956999946, 47.62791575700004],
              [-55.89439856699994, 47.64044830900008],
              [-55.91441809799994, 47.65924713700008],
              [-55.91759192599994, 47.68374258000006],
              [-55.903553839999915, 47.699652411000045],
              [-55.82876542899993, 47.73895905200004],
              [-55.83336341099994, 47.74258047100005],
              [-55.83824622299994, 47.74909088700008],
              [-55.843088344999956, 47.75259023600006],
              [-55.83698482999995, 47.759100653000075],
              [-55.81940670499995, 47.772365627000056],
              [-55.81578528599994, 47.77651601800005],
              [-55.81578528599994, 47.79507070500006],
              [-55.81187903599994, 47.79987213700008],
              [-55.80211341099994, 47.80101146000004],
              [-55.80211341099994, 47.80719635600008],
              [-55.82481848899994, 47.820379950000074],
              [-55.81655839799993, 47.83966705900008],
              [-55.794178839999915, 47.85822174700007],
              [-55.77415930899991, 47.86928945500006],
              [-55.79564368399991, 47.87791575700004],
              [-55.78477942599994, 47.89500560100004],
              [-55.75999915299991, 47.91290924700007],
              [-55.73940995999993, 47.923895575000074],
              [-55.75527910099993, 47.94623444200005],
              [-55.766184048999946, 47.955145575000074],
              [-55.78038489499994, 47.95807526200008],
              [-55.77403723899994, 47.932806708000044],
              [-55.784047003999945, 47.92169830900008],
              [-55.80431067599994, 47.913316148000035],
              [-55.82876542899993, 47.89663320500006],
              [-55.81704667899993, 47.888657945000034],
              [-55.81973222599993, 47.88003164300005],
              [-55.835601365999935, 47.86245351800005],
              [-55.84410559799994, 47.83641185100004],
              [-55.849273240999935, 47.810614325000074],
              [-55.86001542899993, 47.79120514500005],
              [-55.88536536399994, 47.77789948100008],
              [-55.96849524599992, 47.759833075000074],
              [-55.990223761999914, 47.75153229400007],
              [-56.00934811099995, 47.73924388200004],
              [-56.049387173999946, 47.705064195000034],
              [-56.05931555899991, 47.69953034100007],
              [-56.07241777299993, 47.697333075000074],
              [-56.10289466099994, 47.69989655200004],
              [-56.11082923099991, 47.70404694200005],
              [-56.09630286399994, 47.711004950000074],
              [-56.09630286399994, 47.718451239000046],
              [-56.10578365799995, 47.72687409100007],
              [-56.092640753999945, 47.74290599200003],
              [-56.07111568899995, 47.76203034100007],
              [-56.05532792899993, 47.77993398600006],
              [-56.089507615999935, 47.757473049000055],
              [-56.10106360599991, 47.75971100500004],
              [-56.11681067599994, 47.77993398600006],
              [-56.13780676999994, 47.825506903000075],
              [-56.150949673999946, 47.84198639500005],
              [-56.15501868399991, 47.826157945000034],
              [-56.14712480399993, 47.81085846600007],
              [-56.13609778599994, 47.79466380400004],
              [-56.13044186099995, 47.77651601800005],
              [-56.13243567599994, 47.75527578300006],
              [-56.13927161399994, 47.74213288000004],
              [-56.17202714799993, 47.718451239000046],
              [-56.16038977799991, 47.71784088700008],
              [-56.15070553299995, 47.713771877000056],
              [-56.14297441299993, 47.706691799000055],
              [-56.137277798999946, 47.697333075000074],
              [-56.149647589999915, 47.68724192900004],
              [-56.16344153599994, 47.68414948100008],
              [-56.177805141999954, 47.68268463700008],
              [-56.19188391799992, 47.67747630400004],
              [-56.17804928299995, 47.67202383000006],
              [-56.17202714799993, 47.67064036700003],
              [-56.17536373599995, 47.666001695000034],
              [-56.176991339999915, 47.662543036000045],
              [-56.17955481699994, 47.659491278000075],
              [-56.185658331999946, 47.65639883000006],
              [-56.15835527299993, 47.64272695500006],
              [-56.16714433499993, 47.63662344000005],
              [-56.18077551999994, 47.63068268400008],
              [-56.19322669199994, 47.630072333000044],
              [-56.19871985599991, 47.63959381700005],
              [-56.20299231699994, 47.649644273000035],
              [-56.21239173099991, 47.65574778900009],
              [-56.22175045499995, 47.655462958000044],
              [-56.22598222599993, 47.64642975500004],
              [-56.23497473899994, 47.63198476800005],
              [-56.25609290299991, 47.62726471600007],
              [-56.30174719999991, 47.62909577000005],
              [-56.298085089999915, 47.644964911000045],
              [-56.300119594999956, 47.665716864000046],
              [-56.29954993399991, 47.68528880400004],
              [-56.28807532499991, 47.697333075000074],
              [-56.30223548099991, 47.70604075700004],
              [-56.30809485599991, 47.719183661000045],
              [-56.308583136999914, 47.75259023600006],
              [-56.31407630099994, 47.73777903900009],
              [-56.31578528599994, 47.72134023600006],
              [-56.32070878799993, 47.70844147300005],
              [-56.33584550699993, 47.70416901200008],
              [-56.33584550699993, 47.697333075000074],
              [-56.315337693999936, 47.68585846600007],
              [-56.31102454299992, 47.66120026200008],
              [-56.31916256399995, 47.634426174000055],
              [-56.33584550699993, 47.61603424700007],
              [-56.36123613199993, 47.60805898600006],
              [-56.38980058499993, 47.60643138200004],
              [-56.46458899599992, 47.61123281500005],
              [-56.49718176999994, 47.62026601800005],
              [-56.51402747299994, 47.622259833000044],
              [-56.56582597599993, 47.61603424700007],
              [-56.67202714799993, 47.62669505400004],
              [-56.69957434799994, 47.622259833000044],
              [-56.68529212099992, 47.61123281500005],
              [-56.65025794199994, 47.60057200700004],
              [-56.637562628999945, 47.58808014500005],
              [-56.66234290299991, 47.58144765800006],
              [-56.66856848899994, 47.57786692900004],
              [-56.67613684799994, 47.577337958000044],
              [-56.70958411399994, 47.58808014500005],
              [-56.720814581999946, 47.59467194200005],
              [-56.744211391999954, 47.625881252000056],
              [-56.75426184799994, 47.63654205900008],
              [-56.76154537699995, 47.62986888200004],
              [-56.76789303299995, 47.622259833000044],
              [-56.75352942599994, 47.61090729400007],
              [-56.74396725199995, 47.59589264500005],
              [-56.73078365799995, 47.582017320000034],
              [-56.70588131399995, 47.57444896000004],
              [-56.70588131399995, 47.567613023000035],
              [-56.72569739499994, 47.561712958000044],
              [-56.777455206999946, 47.53339264500005],
              [-56.79149329299992, 47.53009674700007],
              [-56.80382239499994, 47.53925202000005],
              [-56.81041419199994, 47.539496161000045],
              [-56.81623287699995, 47.53583405200004],
              [-56.82591712099992, 47.53351471600007],
              [-56.851226365999935, 47.53172435100004],
              [-56.857085740999935, 47.53729889500005],
              [-56.850453253999945, 47.553941148000035],
              [-56.869984503999945, 47.54511139500005],
              [-56.89391028599994, 47.54751211100006],
              [-56.91746985599991, 47.55744049700007],
              [-56.93586178299995, 47.57103099200003],
              [-56.95742753799993, 47.58340078300006],
              [-56.98387610599991, 47.58698151200008],
              [-57.12071692599994, 47.567613023000035],
              [-57.132883266999954, 47.56891510600008],
              [-57.146595831999946, 47.572333075000074],
              [-57.159413214999915, 47.577785549000055],
              [-57.168853318999936, 47.58466217700004],
              [-57.167307094999956, 47.58901601800005],
              [-57.14956620999993, 47.60065338700008],
              [-57.144642706999946, 47.60919830900008],
              [-57.16466223899994, 47.632513739000046],
              [-57.171986456999946, 47.63654205900008],
              [-57.196156378999945, 47.59870026200008],
              [-57.20689856699994, 47.59414297100005],
              [-57.21983801999994, 47.595770575000074],
              [-57.24396725199995, 47.60175202000005],
              [-57.25682532499991, 47.600043036000045],
              [-57.28864498599995, 47.58808014500005],
              [-57.314564581999946, 47.583685614000046],
              [-57.32591712099992, 47.58616771000004],
              [-57.33641516799992, 47.59552643400008],
              [-57.34194902299993, 47.608587958000044],
              [-57.33893795499995, 47.61774323100008],
              [-57.332875128999945, 47.624986070000034],
              [-57.32966061099995, 47.632798570000034],
              [-57.332915818999936, 47.64272695500006],
              [-57.341053839999915, 47.643011786000045],
              [-57.35118567599994, 47.63906484600005],
              [-57.366851365999935, 47.63540273600006],
              [-57.37604732999995, 47.630194403000075],
              [-57.38117428299995, 47.62909577000005],
              [-57.39024817599994, 47.630113023000035],
              [-57.40859941299993, 47.63507721600007],
              [-57.41901607999995, 47.63654205900008],
              [-57.50527910099993, 47.63275788000004],
              [-57.535715298999946, 47.63654205900008],
              [-57.533192511999914, 47.64337799700007],
              [-57.53164628799993, 47.64642975500004],
              [-57.52887936099995, 47.65013255400004],
              [-57.543527798999946, 47.64720286700003],
              [-57.55614173099991, 47.64276764500005],
              [-57.56773841099994, 47.63580963700008],
              [-57.57945716099994, 47.62567780200004],
              [-57.627837693999936, 47.60175202000005],
              [-57.64610755099994, 47.60407135600008],
              [-57.65465247299994, 47.61041901200008],
              [-57.668812628999945, 47.632798570000034],
              [-57.68081620999993, 47.639960028000075],
              [-57.72093665299991, 47.65387604400007],
              [-57.73399817599994, 47.65639883000006],
              [-57.75072180899991, 47.65106842700004],
              [-57.75601152299993, 47.638739325000074],
              [-57.75890051999994, 47.62523021000004],
              [-57.76781165299991, 47.61603424700007],
              [-57.78425045499995, 47.63255442900004],
              [-57.78954016799992, 47.63654205900008],
              [-57.79600989499994, 47.635931708000044],
              [-57.80821692599994, 47.62885163000004],
              [-57.81623287699995, 47.62909577000005],
              [-57.82970130099994, 47.63654205900008],
              [-57.838002081999946, 47.64508698100008],
              [-57.847320115999935, 47.652411200000074],
              [-57.86400305899991, 47.65639883000006],
              [-57.87852942599994, 47.65607330900008],
              [-57.91860917899993, 47.65013255400004],
              [-57.90444902299993, 47.678900458000044],
              [-57.895415818999936, 47.69122955900008],
              [-57.88451087099992, 47.697333075000074],
              [-57.91559811099995, 47.697333075000074],
              [-57.92593339799993, 47.69521719000005],
              [-57.93008378799993, 47.689886786000045],
              [-57.93309485599991, 47.68341705900008],
              [-57.93976803299995, 47.67747630400004],
              [-57.95482337099992, 47.67267487200007],
              [-58.00495357999995, 47.67747630400004],
              [-58.01012122299994, 47.683294989000046],
              [-58.02562415299991, 47.69375234600005],
              [-58.04198157499991, 47.698553778000075],
              [-58.05850175699993, 47.675767320000034],
              [-58.075103318999936, 47.67462799700007],
              [-58.08385169199994, 47.68081289300005],
              [-58.06944739499994, 47.69114817900004],
              [-58.06944739499994, 47.697333075000074],
              [-58.097767706999946, 47.69521719000005],
              [-58.18789628799993, 47.673041083000044],
              [-58.21422278599994, 47.66046784100007],
              [-58.22716223899994, 47.65639883000006],
              [-58.2415258449999, 47.659491278000075],
              [-58.280140753999945, 47.675034898000035],
              [-58.29259192599994, 47.67405833500004],
              [-58.30186926999994, 47.666083075000074],
              [-58.33031165299991, 47.64663320500006],
              [-58.340728318999936, 47.64272695500006],
              [-58.354725714999915, 47.64911530200004],
              [-58.35496985599991, 47.66323476800005],
              [-58.34805253799993, 47.67731354400007],
              [-58.340728318999936, 47.68374258000006],
              [-58.338002081999946, 47.68976471600007],
              [-58.313384568999936, 47.72842031500005],
              [-58.30321204299992, 47.73700592700004],
              [-58.28945878799993, 47.744126695000034],
              [-58.274647589999915, 47.74949778900009],
              [-58.26130123599995, 47.75259023600006],
              [-58.32404537699995, 47.74957916900007],
              [-58.349720831999946, 47.73965078300006],
              [-58.371164516999954, 47.718451239000046],
              [-58.38780676999994, 47.67645905200004],
              [-58.400949673999946, 47.65452708500004],
              [-58.425770636999914, 47.63654205900008],
              [-58.43321692599994, 47.63654205900008],
              [-58.452381964999915, 47.646144924000055],
              [-58.470692511999914, 47.652004299000055],
              [-58.48892167899993, 47.651678778000075],
              [-58.508371548999946, 47.64272695500006],
              [-58.51537024599992, 47.65371328300006],
              [-58.52293860599991, 47.661810614000046],
              [-58.53189042899993, 47.665676174000055],
              [-58.543080206999946, 47.66380442900004],
              [-58.52721106699994, 47.65106842700004],
              [-58.53595943899995, 47.645738023000035],
              [-58.570423956999946, 47.64272695500006],
              [-58.57970130099994, 47.63499583500004],
              [-58.60334225199995, 47.620021877000056],
              [-58.62755286399994, 47.61204661700003],
              [-58.638661261999914, 47.62567780200004],
              [-58.64793860599991, 47.62636953300006],
              [-58.703236456999946, 47.60175202000005],
              [-58.76716061099995, 47.59601471600007],
              [-58.92174231699994, 47.60150788000004],
              [-58.950835740999935, 47.591782945000034],
              [-58.96275794199994, 47.58144765800006],
              [-58.97085527299993, 47.58161041900007],
              [-58.97826087099992, 47.586004950000074],
              [-58.98810787699995, 47.58808014500005],
              [-58.99941972599993, 47.58539459800005],
              [-59.02212480399993, 47.57636139500005],
              [-59.03278561099995, 47.57444896000004],
              [-59.11164303299995, 47.56077708500004],
              [-59.14635169199994, 47.560980536000045],
              [-59.1634008449999, 47.56386953300006],
              [-59.19098873599995, 47.57831452000005],
              [-59.203968878999945, 47.57713450700004],
              [-59.2161352199999, 47.57379791900007],
              [-59.22765051999994, 47.57444896000004],
              [-59.238840298999946, 47.58340078300006],
              [-59.24624589799993, 47.594916083000044],
              [-59.25560462099992, 47.60492584800005],
              [-59.272368943999936, 47.60919830900008],
              [-59.287180141999954, 47.610256252000056],
              [-59.30113684799994, 47.61420319200005],
              [-59.30846106699994, 47.62250397300005],
              [-59.30337480399993, 47.63654205900008],
              [-59.312611456999946, 47.66233958500004],
              [-59.30772864499994, 47.699286200000074],
              [-59.29556230399993, 47.735541083000044],
              [-59.282866990999935, 47.759426174000055],
              [-59.310658331999946, 47.76166413000004],
              [-59.325062628999945, 47.77448151200008],
              [-59.33055579299992, 47.794256903000075],
              [-59.3313695949999, 47.81745026200008],
              [-59.33657792899993, 47.82339101800005],
              [-59.35960852799991, 47.83283112200007],
              [-59.36485755099994, 47.83828359600005],
              [-59.36668860599991, 47.84788646000004],
              [-59.371652798999946, 47.85504791900007],
              [-59.39883378799993, 47.88031647300005],
              [-59.40392005099994, 47.886704820000034],
              [-59.40583248599995, 47.89663320500006],
              [-59.40265865799995, 47.90961334800005],
              [-59.39492753799993, 47.916083075000074],
              [-59.38508053299995, 47.92039622600004],
              [-59.37539628799993, 47.92731354400007],
              [-59.36754309799994, 47.93105703300006],
              [-59.35627193899995, 47.93187083500004],
              [-59.33446204299992, 47.93073151200008],
              [-59.320383266999954, 47.934475002000056],
              [-59.313710089999915, 47.943345445000034],
              [-59.30964107999995, 47.95453522300005],
              [-59.30337480399993, 47.964911200000074],
              [-59.24168860599991, 48.01552969000005],
              [-59.16832434799994, 48.05874258000006],
              [-59.00177975199995, 48.12250397300005],
              [-58.97012285099993, 48.141913153000075],
              [-58.91038977799991, 48.19977448100008],
              [-58.85680091099994, 48.216498114000046],
              [-58.841053839999915, 48.22760651200008],
              [-58.81615149599992, 48.25287506700005],
              [-58.79865475199995, 48.26581452000005],
              [-58.741078253999945, 48.293850002000056],
              [-58.72345943899995, 48.30573151200008],
              [-58.68301347599993, 48.345038153000075],
              [-58.678293423999946, 48.35346100500004],
              [-58.673939581999946, 48.37343984600005],
              [-58.666574673999946, 48.38320547100005],
              [-58.65794837099992, 48.38703034100007],
              [-58.636789516999954, 48.389837958000044],
              [-58.62873287699995, 48.393744208000044],
              [-58.60041256399995, 48.419907945000034],
              [-58.570423956999946, 48.440334377000056],
              [-58.53620357999995, 48.453558661000045],
              [-58.49461829299992, 48.458319403000075],
              [-58.49461829299992, 48.45148346600007],
              [-58.52379309799994, 48.44057851800005],
              [-58.55150305899991, 48.43341705900008],
              [-58.578195766999954, 48.42340729400007],
              [-58.60448157499991, 48.40371328300006],
              [-58.58617102799991, 48.40497467700004],
              [-58.53563391799992, 48.42413971600007],
              [-58.48672441299993, 48.43390534100007],
              [-58.47419186099995, 48.43781159100007],
              [-58.45775305899991, 48.44940827000005],
              [-58.43399003799993, 48.47943756700005],
              [-58.41893469999991, 48.49241771000004],
              [-58.40607662699995, 48.497259833000044],
              [-58.341053839999915, 48.50958893400008],
              [-58.30650794199994, 48.510972398000035],
              [-58.289173956999946, 48.51357656500005],
              [-58.27220618399991, 48.52090078300006],
              [-58.275380011999914, 48.52749258000006],
              [-58.290679490999935, 48.53229401200008],
              [-58.31029212099992, 48.53400299700007],
              [-58.37531490799995, 48.525051174000055],
              [-58.411000128999945, 48.51422760600008],
              [-58.43321692599994, 48.499335028000075],
              [-58.447377081999946, 48.51341380400004],
              [-58.47061113199993, 48.514553127000056],
              [-58.51891028599994, 48.506740627000056],
              [-58.54043535099993, 48.51203034100007],
              [-58.57461503799993, 48.53782786700003],
              [-58.597727016999954, 48.54706452000005],
              [-58.703236456999946, 48.55451080900008],
              [-58.726673956999946, 48.551988023000035],
              [-58.838002081999946, 48.52558014500005],
              [-58.938343878999945, 48.516791083000044],
              [-59.03294837099992, 48.52094147300005],
              [-59.078236456999946, 48.514960028000075],
              [-59.23648027299993, 48.47284577000005],
              [-59.26244055899991, 48.47260163000004],
              [-59.25723222599993, 48.480129299000055],
              [-59.24649003799993, 48.49164459800005],
              [-59.24132239499994, 48.499335028000075],
              [-59.23428300699993, 48.512600002000056],
              [-59.23517818899995, 48.52317942900004],
              [-59.22647050699993, 48.53986237200007],
              [-59.20689856699994, 48.55532461100006],
              [-59.11314856699994, 48.60895416900007],
              [-58.970814581999946, 48.675034898000035],
              [-58.80345618399991, 48.77142975500004],
              [-58.76895097599993, 48.780462958000044],
              [-58.78868567599994, 48.759426174000055],
              [-58.814564581999946, 48.73704661700003],
              [-58.84239661399994, 48.71942780200004],
              [-58.868031378999945, 48.712144273000035],
              [-58.8880102199999, 48.70221588700008],
              [-58.91869055899991, 48.67877838700008],
              [-58.94717363199993, 48.65143463700008],
              [-58.96080481699994, 48.62962474200003],
              [-58.95885169199994, 48.61615631700005],
              [-58.950835740999935, 48.607489325000074],
              [-58.92601477799991, 48.59544505400004],
              [-58.899647589999915, 48.58641185100004],
              [-58.89858964799993, 48.57949453300006],
              [-58.89940344999991, 48.55760325700004],
              [-58.892689581999946, 48.553900458000044],
              [-58.87791907499991, 48.563788153000075],
              [-58.85464433499993, 48.585272528000075],
              [-58.8469945949999, 48.59638092700004],
              [-58.84634355399993, 48.607489325000074],
              [-58.85094153599994, 48.63646067900004],
              [-58.84410559799994, 48.63646067900004],
              [-58.84170488199993, 48.60854726800005],
              [-58.84048417899993, 48.597357489000046],
              [-58.838734503999945, 48.58844635600008],
              [-58.82164466099994, 48.57851797100005],
              [-58.81309973899994, 48.571600653000075],
              [-58.79450436099995, 48.564886786000045],
              [-58.76353919199994, 48.562567450000074],
              [-58.732533331999946, 48.56395091400009],
              [-58.713734503999945, 48.56818268400008],
              [-58.68537350199995, 48.60175202000005],
              [-58.67837480399993, 48.64305247600004],
              [-58.67731686099995, 48.68634674700007],
              [-58.666574673999946, 48.725816148000035],
              [-58.62413489499994, 48.775458075000074],
              [-58.61074785099993, 48.81085846600007],
              [-58.59337317599994, 48.827785549000055],
              [-58.556752081999946, 48.85618724200003],
              [-58.54922441299993, 48.86497630400004],
              [-58.54454505099994, 48.87177155200004],
              [-58.53563391799992, 48.890326239000046],
              [-58.52830969999991, 48.914496161000045],
              [-58.52208411399994, 48.92625560100004],
              [-58.51203365799995, 48.931301174000055],
              [-58.50210527299993, 49.00641510600008],
              [-58.45547441299993, 49.04132721600007],
              [-58.443348761999914, 49.05678945500006],
              [-58.41893469999991, 49.11562734600005],
              [-58.398426886999914, 49.136704820000034],
              [-58.36856035099993, 49.149318752000056],
              [-58.36119544199994, 49.15102773600006],
              [-58.34878495999993, 49.14492422100005],
              [-58.34605872299994, 49.13117096600007],
              [-58.35338294199994, 49.11692942900004],
              [-58.371164516999954, 49.109442450000074],
              [-58.34447180899991, 49.109442450000074],
              [-58.34447180899991, 49.10260651200008],
              [-58.35692298099991, 49.094183661000045],
              [-58.36733964799993, 49.083685614000046],
              [-58.36961829299992, 49.07241445500006],
              [-58.357492641999954, 49.06167226800005],
              [-58.34288489499994, 49.06028880400004],
              [-58.30850175699993, 49.071478583000044],
              [-58.29259192599994, 49.074652411000045],
              [-58.21336829299992, 49.074204820000034],
              [-58.175852016999954, 49.066473700000074],
              [-58.14517167899993, 49.047308661000045],
              [-58.097727016999954, 48.99689362200007],
              [-58.06859290299991, 48.97919342700004],
              [-57.92072506399995, 48.96206289300005],
              [-57.88451087099992, 48.97223541900007],
              [-57.90794837099992, 48.98305898600006],
              [-58.00934811099995, 48.98305898600006],
              [-58.0462133449999, 48.99640534100007],
              [-58.06078040299991, 49.00812409100007],
              [-58.09414628799993, 49.02643463700008],
              [-58.107411261999914, 49.03742096600007],
              [-58.12474524599992, 49.074652411000045],
              [-58.13255774599992, 49.08685944200005],
              [-58.13621985599991, 49.09487539300005],
              [-58.13776607999995, 49.10602448100008],
              [-58.13540605399993, 49.126939195000034],
              [-58.127064581999946, 49.13515859600005],
              [-58.11046301999994, 49.13471100500004],
              [-58.06102454299992, 49.12787506700005],
              [-58.001210089999915, 49.136704820000034],
              [-57.93431555899991, 49.12645091400009],
              [-57.91246497299994, 49.12995026200008],
              [-57.899647589999915, 49.13882070500006],
              [-57.85041256399995, 49.18451569200005],
              [-57.85781816299993, 49.19196198100008],
              [-57.89403235599991, 49.16453685100004],
              [-57.91502844999991, 49.15468984600005],
              [-57.93976803299995, 49.15102773600006],
              [-57.96837317599994, 49.15574778900009],
              [-57.968413865999935, 49.16596100500004],
              [-57.95079505099994, 49.177069403000075],
              [-57.92609615799995, 49.18451569200005],
              [-57.92609615799995, 49.19196198100008],
              [-58.02257239499994, 49.15704987200007],
              [-58.07998613199993, 49.14679596600007],
              [-58.11046301999994, 49.17084381700005],
              [-58.10065670499995, 49.182806708000044],
              [-58.014881964999915, 49.17829010600008],
              [-57.989491339999915, 49.187933661000045],
              [-57.96670488199993, 49.204413153000075],
              [-57.92609615799995, 49.24656810100004],
              [-57.94896399599992, 49.24103424700007],
              [-57.986439581999946, 49.22524648600006],
              [-58.008656378999945, 49.21930573100008],
              [-58.03575598899994, 49.217678127000056],
              [-58.13784745999993, 49.227850653000075],
              [-58.193430141999954, 49.243068752000056],
              [-58.214100714999915, 49.25340403900009],
              [-58.22948157499991, 49.268459377000056],
              [-58.23517818899995, 49.28461334800005],
              [-58.23546301999994, 49.30329010600008],
              [-58.22866777299993, 49.37099844000005],
              [-58.21198482999995, 49.409409898000035],
              [-58.18590247299994, 49.442694403000075],
              [-58.13703365799995, 49.48419830900008],
              [-58.09162350199995, 49.51471588700008],
              [-58.05809485599991, 49.52692291900007],
              [-58.02257239499994, 49.554388739000046],
              [-58.001210089999915, 49.56191640800006],
              [-57.966786261999914, 49.55955638200004],
              [-57.940297003999945, 49.54901764500005],
              [-57.92027747299994, 49.53192780200004],
              [-57.91246497299994, 49.51007721600007],
              [-57.91258704299992, 49.48468659100007],
              [-57.909413214999915, 49.45913320500006],
              [-57.89745032499991, 49.43919505400004],
              [-57.87144934799994, 49.430894273000035],
              [-57.89622962099992, 49.47345612200007],
              [-57.89586341099994, 49.49249909100007],
              [-57.87144934799994, 49.50665924700007],
              [-57.84434973899994, 49.50625234600005],
              [-57.81794186099995, 49.49453359600005],
              [-57.79084225199995, 49.47866445500006],
              [-57.76158606699994, 49.465725002000056],
              [-57.73395748599995, 49.460150458000044],
              [-57.70360266799992, 49.45888906500005],
              [-57.70030676999994, 49.46283600500004],
              [-57.712880011999914, 49.47174713700008],
              [-57.79759680899991, 49.509751695000034],
              [-57.81916256399995, 49.530585028000075],
              [-57.82306881399995, 49.56191640800006],
              [-57.83315995999993, 49.552394924000055],
              [-57.842681443999936, 49.53851959800005],
              [-57.85456295499995, 49.52773672100005],
              [-57.87144934799994, 49.52716705900008],
              [-57.87767493399991, 49.53229401200008],
              [-57.88414466099994, 49.54148997600004],
              [-57.88927161399994, 49.55145905200004],
              [-57.89134680899991, 49.55849844000005],
              [-57.89561926999994, 49.56732819200005],
              [-57.90562903599994, 49.57599518400008],
              [-57.92609615799995, 49.58926015800006],
              [-57.92300370999993, 49.59320709800005],
              [-57.92149817599994, 49.59662506700005],
              [-57.92039954299992, 49.59983958500004],
              [-57.91860917899993, 49.60346100500004],
              [-57.94395911399994, 49.614162502000056],
              [-57.95164954299992, 49.64427317900004],
              [-57.948109503999945, 49.67951080900008],
              [-57.93976803299995, 49.70526764500005],
              [-57.91193600199995, 49.75234609600005],
              [-57.89879309799994, 49.76732005400004],
              [-57.89020748599995, 49.77366771000004],
              [-57.87083899599992, 49.782904364000046],
              [-57.86400305899991, 49.78782786700003],
              [-57.8606664699999, 49.79559967700004],
              [-57.86009680899991, 49.804388739000046],
              [-57.85814368399991, 49.81362539300005],
              [-57.85041256399995, 49.82257721600007],
              [-57.85252844999991, 49.833238023000035],
              [-57.82408606699994, 49.861761786000045],
              [-57.80939693899995, 49.896918036000045],
              [-57.77525794199994, 49.92845286700003],
              [-57.76158606699994, 49.94489166900007],
              [-57.73281816299993, 50.00600820500006],
              [-57.698475714999915, 50.04352448100008],
              [-57.65859941299993, 50.10993073100008],
              [-57.61017818899995, 50.165676174000055],
              [-57.60338294199994, 50.18195221600007],
              [-57.60098222599993, 50.20376211100006],
              [-57.59434973899994, 50.224676825000074],
              [-57.56981360599991, 50.267645575000074],
              [-57.53929602799991, 50.308294989000046],
              [-57.526600714999915, 50.330511786000045],
              [-57.52139238199993, 50.35325755400004],
              [-57.52261308499993, 50.355902411000045],
              [-57.52513587099992, 50.35789622600004],
              [-57.52769934799994, 50.361029364000046],
              [-57.52887936099995, 50.367254950000074],
              [-57.52672278599994, 50.370347398000035],
              [-57.522043423999946, 50.371975002000056],
              [-57.51732337099992, 50.37445709800005],
              [-57.51268469999991, 50.389837958000044],
              [-57.49474036399994, 50.42527903900009],
              [-57.46987870999993, 50.44916413000004],
              [-57.463775193999936, 50.45783112200007],
              [-57.460926886999914, 50.47479889500005],
              [-57.45685787699995, 50.48305898600006],
              [-57.44546464799993, 50.49315013200004],
              [-57.40534420499995, 50.52024974200003],
              [-57.38695227799991, 50.549261786000045],
              [-57.37413489499994, 50.58100006700005],
              [-57.35529537699995, 50.60659414300005],
              [-57.31908118399991, 50.61709219000005],
              [-57.23863684799994, 50.60000234600005],
              [-57.19839433499993, 50.596909898000035],
              [-57.16201738199993, 50.61367422100005],
              [-57.15477454299992, 50.62567780200004],
              [-57.16510982999995, 50.62872955900008],
              [-57.238392706999946, 50.617621161000045],
              [-57.25739498599995, 50.61815013200004],
              [-57.27562415299991, 50.623928127000056],
              [-57.27562415299991, 50.630113023000035],
              [-57.26577714799993, 50.630113023000035],
              [-57.256743943999936, 50.63133372600004],
              [-57.24836178299995, 50.63377513200004],
              [-57.240223761999914, 50.63751862200007],
              [-57.25462805899991, 50.65119049700007],
              [-57.29963131399995, 50.64948151200008],
              [-57.309152798999946, 50.66860586100006],
              [-57.32188880099994, 50.687201239000046],
              [-57.35073808499993, 50.69098541900007],
              [-57.38109290299991, 50.691107489000046],
              [-57.398508266999954, 50.69896067900004],
              [-57.39696204299992, 50.708644924000055],
              [-57.38695227799991, 50.71478913000004],
              [-57.359364386999914, 50.72174713700008],
              [-57.35024980399993, 50.72606028900009],
              [-57.343861456999946, 50.72695547100005],
              [-57.337147589999915, 50.724676825000074],
              [-57.335926886999914, 50.71539948100008],
              [-57.329335089999915, 50.713324286000045],
              [-57.28693600199995, 50.72011953300006],
              [-57.240223761999914, 50.73379140800006],
              [-57.213734503999945, 50.75071849200003],
              [-57.206695115999935, 50.75421784100007],
              [-57.194569464999915, 50.75495026200008],
              [-57.16551673099991, 50.753119208000044],
              [-57.155181443999936, 50.75771719000005],
              [-57.136382615999935, 50.77106354400007],
              [-57.09019934799994, 50.78823476800005],
              [-57.06895911399994, 50.802069403000075],
              [-57.062163865999935, 50.81012604400007],
              [-57.050770636999914, 50.82770416900007],
              [-57.042225714999915, 50.83616771000004],
              [-57.01398678299995, 50.85179271000004],
              [-56.99510657499991, 50.867254950000074],
              [-56.98517818899995, 50.87343984600005],
              [-56.97720292899993, 50.88149648600006],
              [-56.97398841099994, 50.894517320000034],
              [-56.971547003999945, 50.912543036000045],
              [-56.964507615999935, 50.91388580900008],
              [-56.95352128799993, 50.90997955900008],
              [-56.93919837099992, 50.91193268400008],
              [-56.92552649599992, 50.91815827000005],
              [-56.93101966099994, 50.92731354400007],
              [-56.939116990999935, 50.93235911700003],
              [-56.96031653599994, 50.93919505400004],
              [-56.97374426999994, 50.931626695000034],
              [-56.981027798999946, 50.93496328300006],
              [-56.98550370999993, 50.94208405200004],
              [-56.99551347599993, 50.94916413000004],
              [-56.98428300699993, 50.95612213700008],
              [-56.96031653599994, 50.96653880400004],
              [-56.97614498599995, 50.97410716400009],
              [-57.01439368399991, 50.97207265800006],
              [-57.03477942599994, 50.980169989000046],
              [-57.03783118399991, 50.98529694200005],
              [-57.04482988199993, 51.00263092700004],
              [-57.04845130099994, 51.00812409100007],
              [-57.05772864499994, 51.01439036700003],
              [-57.067250128999945, 51.01870351800005],
              [-57.07762610599991, 51.02094147300005],
              [-57.08942623599995, 51.021144924000055],
              [-57.07022050699993, 51.02692291900007],
              [-57.01085364499994, 51.021144924000055],
              [-57.003895636999914, 51.013006903000075],
              [-56.99461829299992, 50.997381903000075],
              [-56.97988847599993, 50.98777903900009],
              [-56.95661373599995, 50.99754466400009],
              [-56.916859503999945, 51.00885651200008],
              [-56.90070553299995, 51.01821523600006],
              [-56.90510006399995, 51.03538646000004],
              [-56.920480923999946, 51.04319896000004],
              [-56.96251380099994, 51.046576239000046],
              [-56.980132615999935, 51.05532461100006],
              [-56.94017493399991, 51.05548737200007],
              [-56.90269934799994, 51.06069570500006],
              [-56.874989386999914, 51.077785549000055],
              [-56.864125128999945, 51.11359284100007],
              [-56.85484778599994, 51.119574286000045],
              [-56.810536261999914, 51.13080475500004],
              [-56.79523678299995, 51.13784414300005],
              [-56.78746497299994, 51.14996979400007],
              [-56.78970292899993, 51.16107819200005],
              [-56.809478318999936, 51.19245026200008],
              [-56.78156490799995, 51.206732489000046],
              [-56.773426886999914, 51.20184967700004],
              [-56.76545162699995, 51.19969310100004],
              [-56.74681555899991, 51.199286200000074],
              [-56.755970831999946, 51.21246979400007],
              [-56.766916469999956, 51.22256094000005],
              [-56.79523678299995, 51.24087148600006],
              [-56.786040818999936, 51.248928127000056],
              [-56.76797441299993, 51.261379299000055],
              [-56.76109778599994, 51.267564195000034],
              [-56.74494381399995, 51.296087958000044],
              [-56.736887173999946, 51.30573151200008],
              [-56.72020423099991, 51.31932200700004],
              [-56.66486568899995, 51.35008372600004],
              [-56.49351966099994, 51.412176825000074],
              [-56.44440670499995, 51.42145416900007],
              [-56.394520636999914, 51.42523834800005],
              [-56.377064581999946, 51.430853583000044],
              [-56.33556067599994, 51.45795319200005],
              [-56.31602942599994, 51.46743398600006],
              [-56.23810787699995, 51.48110586100006],
              [-56.22598222599993, 51.49070872600004],
              [-56.215402798999946, 51.50177643400008],
              [-56.19090735599991, 51.51121653900009],
              [-56.10619055899991, 51.528998114000046],
              [-56.08779863199993, 51.53534577000005],
              [-56.06086178299995, 51.55341217700004],
              [-56.01903235599991, 51.57273997600004],
              [-56.00352942599994, 51.57664622600004],
              [-55.89281165299991, 51.62775299700007],
              [-55.884022589999915, 51.61701080900008],
              [-55.868072068999936, 51.612616278000075],
              [-55.85387122299994, 51.61603424700007],
              [-55.83934485599991, 51.621527411000045],
              [-55.82258053299995, 51.62384674700007],
              [-55.87710527299993, 51.57123444200005],
              [-55.880930141999954, 51.552801825000074],
              [-55.843088344999956, 51.555568752000056],
              [-55.86302649599992, 51.527411200000074],
              [-55.89024817599994, 51.50092194200005],
              [-55.87287350199995, 51.49555084800005],
              [-55.85619055899991, 51.495794989000046],
              [-55.82258053299995, 51.50092194200005],
              [-55.75373287699995, 51.50092194200005],
              [-55.71914628799993, 51.493394273000035],
              [-55.680978969999956, 51.48065827000005],
              [-55.64305579299992, 51.47296784100007],
              [-55.60968990799995, 51.48041413000004],
              [-55.62580318899995, 51.48680247600004],
              [-55.66344153599994, 51.49176666900007],
              [-55.678578253999945, 51.50092194200005],
              [-55.68346106699994, 51.513373114000046],
              [-55.68419348899994, 51.527044989000046],
              [-55.688059048999946, 51.53803131700005],
              [-55.73786373599995, 51.55499909100007],
              [-55.728627081999946, 51.57697174700007],
              [-55.712147589999915, 51.58494700700004],
              [-55.72573808499993, 51.555568752000056],
              [-55.702463344999956, 51.565741278000075],
              [-55.65929114499994, 51.59979889500005],
              [-55.632150844999956, 51.61005280200004],
              [-55.64391028599994, 51.59902578300006],
              [-55.64907792899993, 51.593085028000075],
              [-55.64606686099995, 51.58844635600008],
              [-55.64020748599995, 51.585598049000055],
              [-55.63703365799995, 51.579779364000046],
              [-55.628895636999914, 51.571600653000075],
              [-55.61034094999991, 51.56663646000004],
              [-55.58975175699993, 51.565619208000044],
              [-55.57555091099994, 51.569240627000056],
              [-55.57860266799992, 51.57330963700008],
              [-55.58177649599992, 51.57489655200004],
              [-55.58531653599994, 51.575425523000035],
              [-55.58922278599994, 51.57664622600004],
              [-55.53160559799994, 51.60008372600004],
              [-55.51406816299993, 51.603949286000045],
              [-55.47996985599991, 51.593451239000046],
              [-55.477447068999936, 51.57880280200004],
              [-55.47207597599993, 51.57925039300005],
              [-55.46711178299995, 51.586004950000074],
              [-55.465687628999945, 51.590277411000045],
              [-55.426991339999915, 51.58698151200008],
              [-55.40851803299995, 51.579413153000075],
              [-55.40420488199993, 51.56297435100004],
              [-55.41706295499995, 51.55060455900008],
              [-55.437163865999935, 51.55410390800006],
              [-55.457875128999945, 51.56199778900009],
              [-55.47252356699994, 51.56297435100004],
              [-55.463734503999945, 51.554754950000074],
              [-55.437163865999935, 51.539943752000056],
              [-55.43154863199993, 51.538763739000046],
              [-55.43333899599992, 51.52806224200003],
              [-55.43830318899995, 51.515611070000034],
              [-55.44591223899994, 51.50531647300005],
              [-55.45571855399993, 51.50092194200005],
              [-55.48619544199994, 51.50836823100008],
              [-55.53457597599993, 51.50836823100008],
              [-55.52318274599992, 51.49713776200008],
              [-55.49400794199994, 51.48354726800005],
              [-55.48192298099991, 51.47508372600004],
              [-55.454335089999915, 51.47955963700008],
              [-55.45811926999994, 51.46328359600005],
              [-55.47142493399991, 51.44041575700004],
              [-55.47252356699994, 51.42523834800005],
              [-55.482492641999954, 51.412543036000045],
              [-55.491851365999935, 51.388373114000046],
              [-55.50047766799992, 51.37742747600004],
              [-55.515695766999954, 51.36855703300006],
              [-55.524281378999945, 51.371975002000056],
              [-55.53197180899991, 51.37982819200005],
              [-55.559152798999946, 51.39008209800005],
              [-55.56627356699994, 51.389878648000035],
              [-55.56932532499991, 51.380845445000034],
              [-55.571156378999945, 51.366441148000035],
              [-55.56826738199993, 51.36017487200007],
              [-55.55846106699994, 51.35757070500006],
              [-55.554758266999954, 51.35529205900008],
              [-55.557850714999915, 51.35040924700007],
              [-55.56480872299994, 51.34552643400008],
              [-55.57241777299993, 51.34324778900009],
              [-55.59215247299994, 51.34365469000005],
              [-55.600900844999956, 51.34560781500005],
              [-55.60968990799995, 51.35008372600004],
              [-55.609934048999946, 51.34052155200004],
              [-55.608265753999945, 51.327826239000046],
              [-55.60387122299994, 51.31598541900007],
              [-55.59605872299994, 51.30914948100008],
              [-55.61742102799991, 51.304388739000046],
              [-55.64024817599994, 51.31476471600007],
              [-55.66323808499993, 51.32916901200008],
              [-55.68541419199994, 51.33641185100004],
              [-55.80516516799992, 51.35268789300005],
              [-55.867298956999946, 51.34324778900009],
              [-55.887277798999946, 51.34422435100004],
              [-55.89533443899995, 51.34634023600006],
              [-55.90453040299991, 51.35008372600004],
              [-55.92613684799994, 51.36359284100007],
              [-55.93724524599992, 51.36863841400009],
              [-55.95230058499993, 51.37055084800005],
              [-55.94709225199995, 51.36505768400008],
              [-55.93862870999993, 51.35008372600004],
              [-55.966867641999954, 51.346584377000056],
              [-55.98888098899994, 51.35781484600005],
              [-56.009836391999954, 51.37368398600006],
              [-56.03490149599992, 51.38422272300005],
              [-56.03490149599992, 51.376166083000044],
              [-56.03673255099994, 51.36969635600008],
              [-56.03929602799991, 51.36391836100006],
              [-56.041086391999954, 51.35757070500006],
              [-56.05109615799995, 51.36635976800005],
              [-56.06285559799994, 51.37059153900009],
              [-56.075835740999935, 51.37164948100008],
              [-56.089507615999935, 51.37055084800005],
              [-56.089507615999935, 51.36440664300005],
              [-56.087147589999915, 51.35809967700004],
              [-56.09406490799995, 51.33576080900008],
              [-56.09630286399994, 51.32282135600008],
              [-56.08104407499991, 51.32221100500004],
              [-56.03425045499995, 51.31435781500005],
              [-56.02122962099992, 51.30914948100008],
              [-56.01577714799993, 51.27960846600007],
              [-56.01439368399991, 51.275051174000055],
              [-56.01968339799993, 51.26947663000004],
              [-56.02774003799993, 51.26666901200008],
              [-56.037668423999946, 51.266058661000045],
              [-56.048491990999935, 51.267564195000034],
              [-56.04161536399994, 51.26048411700003],
              [-56.01439368399991, 51.247707424000055],
              [-56.029408331999946, 51.24315013200004],
              [-56.06163489499994, 51.23969147300005],
              [-56.07579505099994, 51.23338450700004],
              [-56.04039466099994, 51.221869208000044],
              [-56.018422003999945, 51.21824778900009],
              [-56.01398678299995, 51.21303945500006],
              [-56.01130123599995, 51.20612213700008],
              [-56.00694739499994, 51.199286200000074],
              [-55.98106848899994, 51.169175523000035],
              [-55.965687628999945, 51.15900299700007],
              [-55.94546464799993, 51.15835195500006],
              [-55.954335089999915, 51.17377350500004],
              [-55.95913652299993, 51.17877838700008],
              [-55.95872962099992, 51.18032461100006],
              [-55.95807857999995, 51.18500397300005],
              [-55.95799719999991, 51.19171784100007],
              [-55.95913652299993, 51.199286200000074],
              [-55.91095943899995, 51.202378648000035],
              [-55.88841712099992, 51.20962148600006],
              [-55.867298956999946, 51.223822333000044],
              [-55.84845943899995, 51.23102448100008],
              [-55.77383378799993, 51.220404364000046],
              [-55.76447506399995, 51.21747467700004],
              [-55.751210089999915, 51.210638739000046],
              [-55.72948157499991, 51.19586823100008],
              [-55.71910559799994, 51.18431224200003],
              [-55.72061113199993, 51.180121161000045],
              [-55.72752844999991, 51.177801825000074],
              [-55.73322506399995, 51.171942450000074],
              [-55.73680579299992, 51.16547272300005],
              [-55.74132239499994, 51.15387604400007],
              [-55.739125128999945, 51.14276764500005],
              [-55.722645636999914, 51.13784414300005],
              [-55.718739386999914, 51.132025458000044],
              [-55.72411048099991, 51.11888255400004],
              [-55.73289954299992, 51.10496653900009],
              [-55.73940995999993, 51.096869208000044],
              [-55.73314368399991, 51.08307526200008],
              [-55.74331620999993, 51.07013580900008],
              [-55.761789516999954, 51.060207424000055],
              [-55.78038489499994, 51.05532461100006],
              [-55.78693600199995, 51.05923086100006],
              [-55.79625403599994, 51.066473700000074],
              [-55.804676886999914, 51.06907786700003],
              [-55.808257615999935, 51.059027411000045],
              [-55.804351365999935, 51.04975006700005],
              [-55.795033331999946, 51.042669989000046],
              [-55.78380286399994, 51.03782786700003],
              [-55.77415930899991, 51.03538646000004],
              [-55.808257615999935, 51.00812409100007],
              [-55.81505286399994, 50.99787018400008],
              [-55.82017981699994, 50.98769765800006],
              [-55.826242641999954, 50.97882721600007],
              [-55.835601365999935, 50.972723700000074],
              [-55.835601365999935, 50.96653880400004],
              [-55.82721920499995, 50.960598049000055],
              [-55.82249915299991, 50.952378648000035],
              [-55.81578528599994, 50.93178945500006],
              [-55.83283443899995, 50.92633698100008],
              [-55.839507615999935, 50.934759833000044],
              [-55.842681443999936, 50.94708893400008],
              [-55.849273240999935, 50.95351797100005],
              [-55.86017818899995, 50.94757721600007],
              [-55.86876380099994, 50.93353913000004],
              [-55.873117641999954, 50.917303778000075],
              [-55.87100175699993, 50.90501536700003],
              [-55.86270097599993, 50.909409898000035],
              [-55.85684160099993, 50.911322333000044],
              [-55.85114498599995, 50.91010163000004],
              [-55.843088344999956, 50.90501536700003],
              [-55.856760219999956, 50.89899323100008],
              [-55.86790930899991, 50.890285549000055],
              [-55.87515214799993, 50.878607489000046],
              [-55.87718665299991, 50.86347077000005],
              [-55.89220130099994, 50.89695872600004],
              [-55.90282141799992, 50.89728424700007],
              [-55.925038214999915, 50.88458893400008],
              [-55.93968665299991, 50.870754299000055],
              [-55.961781378999945, 50.83567942900004],
              [-56.00694739499994, 50.788397528000075],
              [-56.02969316299993, 50.770697333000044],
              [-56.03111731699994, 50.767279364000046],
              [-56.05028235599991, 50.75678131700005],
              [-56.06476803299995, 50.73590729400007],
              [-56.080637173999946, 50.72064850500004],
              [-56.10374915299991, 50.72695547100005],
              [-56.09740149599992, 50.73419830900008],
              [-56.09288489499994, 50.74233633000006],
              [-56.09024003799993, 50.751288153000075],
              [-56.089507615999935, 50.761053778000075],
              [-56.10700436099995, 50.75039297100005],
              [-56.11904863199993, 50.75348541900007],
              [-56.137277798999946, 50.774725653000075],
              [-56.12743079299992, 50.79682038000004],
              [-56.124256964999915, 50.802069403000075],
              [-56.13219153599994, 50.82982005400004],
              [-56.12523352799991, 50.85541413000004],
              [-56.112538214999915, 50.880072333000044],
              [-56.10374915299991, 50.90501536700003],
              [-56.12930253799993, 50.90192291900007],
              [-56.14785722599993, 50.89321523600006],
              [-56.161366339999915, 50.878241278000075],
              [-56.17202714799993, 50.856634833000044],
              [-56.151234503999945, 50.855902411000045],
              [-56.14354407499991, 50.84174225500004],
              [-56.14484615799995, 50.82135651200008],
              [-56.150949673999946, 50.802069403000075],
              [-56.15534420499995, 50.795803127000056],
              [-56.17202714799993, 50.77781810100004],
              [-56.16982988199993, 50.77289459800005],
              [-56.16047115799995, 50.76479726800005],
              [-56.15835527299993, 50.761053778000075],
              [-56.159820115999935, 50.75527578300006],
              [-56.16478430899991, 50.74591705900008],
              [-56.16519120999993, 50.739935614000046],
              [-56.162180141999954, 50.72085195500006],
              [-56.15770423099991, 50.706691799000055],
              [-56.14834550699993, 50.69550202000005],
              [-56.13044186099995, 50.68528880400004],
              [-56.10582434799994, 50.68353913000004],
              [-56.09561113199993, 50.67926666900007],
              [-56.10008704299992, 50.66860586100006],
              [-56.127023891999954, 50.643011786000045],
              [-56.137277798999946, 50.63751862200007],
              [-56.14085852799991, 50.63393789300005],
              [-56.18740800699993, 50.59861888200004],
              [-56.21934973899994, 50.583685614000046],
              [-56.23289954299992, 50.56928131700005],
              [-56.24278723899994, 50.53310781500005],
              [-56.25023352799991, 50.52765534100007],
              [-56.322255011999914, 50.52765534100007],
              [-56.322255011999914, 50.52024974200003],
              [-56.29674231699994, 50.514105536000045],
              [-56.27481035099993, 50.51243724200003],
              [-56.26642818899995, 50.506293036000045],
              [-56.281320766999954, 50.486761786000045],
              [-56.314442511999914, 50.459418036000045],
              [-56.350168423999946, 50.43829987200007],
              [-56.36583411399994, 50.42479075700004],
              [-56.397043423999946, 50.38743724200003],
              [-56.41161048099991, 50.37689850500004],
              [-56.427845831999946, 50.37567780200004],
              [-56.43724524599992, 50.382473049000055],
              [-56.44416256399995, 50.391506252000056],
              [-56.45254472599993, 50.397365627000056],
              [-56.50035559799994, 50.39109935100004],
              [-56.481312628999945, 50.37457916900007],
              [-56.45177161399994, 50.371161200000074],
              [-56.42951412699995, 50.36212799700007],
              [-56.43211829299992, 50.32843659100007],
              [-56.44416256399995, 50.304388739000046],
              [-56.46231035099993, 50.27724844000005],
              [-56.484364386999914, 50.253607489000046],
              [-56.507801886999914, 50.240301825000074],
              [-56.50413977799991, 50.218817450000074],
              [-56.523426886999914, 50.19643789300005],
              [-56.60533606699994, 50.135972398000035],
              [-56.61766516799992, 50.13043854400007],
              [-56.63068600199995, 50.13080475500004],
              [-56.643788214999915, 50.13458893400008],
              [-56.657541469999956, 50.13629791900007],
              [-56.67227128799993, 50.13043854400007],
              [-56.649728969999956, 50.11896393400008],
              [-56.64110266799992, 50.10993073100008],
              [-56.64631100199995, 50.09918854400007],
              [-56.66486568899995, 50.08270905200004],
              [-56.71397864499994, 50.05133698100008],
              [-56.72691809799994, 50.041083075000074],
              [-56.73875891799992, 50.02680084800005],
              [-56.77574622299994, 49.95075104400007],
              [-56.78062903599994, 49.934881903000075],
              [-56.78156490799995, 49.91815827000005],
              [-56.768788214999915, 49.931708075000074],
              [-56.747710740999935, 49.94916413000004],
              [-56.72813880099994, 49.95880768400008],
              [-56.71947180899991, 49.948553778000075],
              [-56.72451738199993, 49.932074286000045],
              [-56.74242102799991, 49.894964911000045],
              [-56.74058997299994, 49.88344961100006],
              [-56.74058997299994, 49.87718333500004],
              [-56.75527910099993, 49.872381903000075],
              [-56.763010219999956, 49.868353583000044],
              [-56.76789303299995, 49.86359284100007],
              [-56.770415818999936, 49.853583075000074],
              [-56.76707923099991, 49.84845612200007],
              [-56.76244055899991, 49.845689195000034],
              [-56.76109778599994, 49.84243398600006],
              [-56.768422003999945, 49.83026764500005],
              [-56.77879798099991, 49.818793036000045],
              [-56.79063880099994, 49.80898672100005],
              [-56.802072719999956, 49.80149974200003],
              [-56.88182532499991, 49.770819403000075],
              [-56.90510006399995, 49.75372955900008],
              [-56.88744055899991, 49.74982330900008],
              [-56.82843990799995, 49.74567291900007],
              [-56.815744594999956, 49.74310944200005],
              [-56.81037350199995, 49.734035549000055],
              [-56.79865475199995, 49.732489325000074],
              [-56.78685462099992, 49.73289622600004],
              [-56.78156490799995, 49.72943756700005],
              [-56.781809048999946, 49.696600653000075],
              [-56.78465735599991, 49.69163646000004],
              [-56.78669186099995, 49.68211497600004],
              [-56.815744594999956, 49.62335846600007],
              [-56.823475714999915, 49.59320709800005],
              [-56.829335089999915, 49.58177317900004],
              [-56.856678839999915, 49.54824453300006],
              [-56.83779863199993, 49.556341864000046],
              [-56.82176673099991, 49.57078685100004],
              [-56.79523678299995, 49.60346100500004],
              [-56.74083411399994, 49.65648021000004],
              [-56.72533118399991, 49.69025299700007],
              [-56.599720831999946, 49.811712958000044],
              [-56.57290605399993, 49.82640208500004],
              [-56.569243943999936, 49.83250560100004],
              [-56.56598873599995, 49.840277411000045],
              [-56.55776933499993, 49.84813060100004],
              [-56.54751542899993, 49.85419342700004],
              [-56.518137173999946, 49.86367422100005],
              [-56.485259568999936, 49.89288971600007],
              [-56.466867641999954, 49.897650458000044],
              [-56.42528235599991, 49.845689195000034],
              [-56.41844641799992, 49.85297272300005],
              [-56.42284094999991, 49.87059153900009],
              [-56.42910722599993, 49.88694896000004],
              [-56.426625128999945, 49.90265534100007],
              [-56.40477454299992, 49.91815827000005],
              [-56.395090298999946, 49.911769924000055],
              [-56.36318925699993, 49.897650458000044],
              [-56.37291419199994, 49.920355536000045],
              [-56.38255774599992, 49.93378327000005],
              [-56.38438880099994, 49.94635651200008],
              [-56.33702551999994, 50.01707591400009],
              [-56.31704667899993, 50.03925202000005],
              [-56.291859503999945, 50.048529364000046],
              [-56.270415818999936, 50.05931224200003],
              [-56.24058997299994, 50.106634833000044],
              [-56.17516028599994, 50.140692450000074],
              [-56.16364498599995, 50.14956289300005],
              [-56.14879309799994, 50.15570709800005],
              [-56.13255774599992, 50.15875885600008],
              [-56.11681067599994, 50.15839264500005],
              [-56.11888587099992, 50.15375397300005],
              [-56.12218176999994, 50.14203522300005],
              [-56.124256964999915, 50.13727448100008],
              [-56.10732988199993, 50.137600002000056],
              [-56.09557044199994, 50.13336823100008],
              [-56.09455318899995, 50.127834377000056],
              [-56.10997473899994, 50.12360260600008],
              [-56.098947719999956, 50.11310455900008],
              [-56.08165442599994, 50.105169989000046],
              [-56.06663977799991, 50.09617747600004],
              [-56.062163865999935, 50.08270905200004],
              [-56.06969153599994, 50.07050202000005],
              [-56.098866339999915, 50.04633209800005],
              [-56.10997473899994, 50.03424713700008],
              [-56.12828528599994, 49.98883698100008],
              [-56.137277798999946, 49.97345612200007],
              [-56.14867102799991, 49.96002838700008],
              [-56.19188391799992, 49.924994208000044],
              [-56.15461178299995, 49.93406810100004],
              [-56.12413489499994, 49.95555247600004],
              [-56.07241777299993, 50.010931708000044],
              [-56.05833899599992, 50.01797109600005],
              [-56.01008053299995, 50.03119538000004],
              [-55.996978318999936, 50.03082916900007],
              [-55.993031378999945, 50.01552969000005],
              [-56.003570115999935, 50.001166083000044],
              [-56.03490149599992, 49.97964101800005],
              [-56.00340735599991, 49.971584377000056],
              [-55.98412024599992, 49.994574286000045],
              [-55.97130286399994, 50.02558014500005],
              [-55.95913652299993, 50.041083075000074],
              [-55.92564856699994, 50.03896719000005],
              [-55.892567511999914, 50.03148021000004],
              [-55.863840298999946, 50.016831773000035],
              [-55.843088344999956, 49.99331289300005],
              [-55.849273240999935, 49.99331289300005],
              [-55.842355923999946, 49.98314036700003],
              [-55.80353756399995, 49.956366278000075],
              [-55.79747473899994, 49.95575592700004],
              [-55.79181881399995, 49.95770905200004],
              [-55.784087693999936, 49.95913320500006],
              [-55.777333136999914, 49.95612213700008],
              [-55.77293860599991, 49.94940827000005],
              [-55.77000891799992, 49.94245026200008],
              [-55.76732337099992, 49.938666083000044],
              [-55.74640865799995, 49.93195221600007],
              [-55.722645636999914, 49.93121979400007],
              [-55.71263587099992, 49.934475002000056],
              [-55.701242641999954, 49.94220612200007],
              [-55.691070115999935, 49.95148346600007],
              [-55.684803839999915, 49.95913320500006],
              [-55.692250128999945, 49.96662018400008],
              [-55.66665605399993, 49.97606028900009],
              [-55.61042232999995, 49.972357489000046],
              [-55.58238684799994, 49.97345612200007],
              [-55.570423956999946, 49.97724030200004],
              [-55.49299068899995, 50.01439036700003],
              [-55.49299068899995, 50.007513739000046],
              [-55.47240149599992, 49.97870514500005],
              [-55.46507727799991, 49.962551174000055],
              [-55.465687628999945, 49.94489166900007],
              [-55.47679602799991, 49.92951080900008],
              [-55.49522864499994, 49.919134833000044],
              [-55.51699785099993, 49.91323476800005],
              [-55.537993943999936, 49.911322333000044],
              [-55.575835740999935, 49.901678778000075],
              [-55.648996548999946, 49.85895416900007],
              [-55.692250128999945, 49.849310614000046],
              [-55.714955206999946, 49.82221100500004],
              [-55.807850714999915, 49.80190664300005],
              [-55.96165930899991, 49.74127838700008],
              [-55.97280839799993, 49.73940664300005],
              [-55.983631964999915, 49.74355703300006],
              [-55.99254309799994, 49.75092194200005],
              [-56.001942511999914, 49.75250885600008],
              [-56.01439368399991, 49.73940664300005],
              [-56.00487219999991, 49.72650788000004],
              [-56.021148240999935, 49.71478913000004],
              [-56.06899980399993, 49.698431708000044],
              [-56.06265214799993, 49.682928778000075],
              [-56.08946692599994, 49.662990627000056],
              [-56.150949673999946, 49.63080475500004],
              [-56.15868079299992, 49.62343984600005],
              [-56.16543535099993, 49.61351146000004],
              [-56.17023678299995, 49.60097890800006],
              [-56.17202714799993, 49.58551666900007],
              [-56.16543535099993, 49.574652411000045],
              [-56.150502081999946, 49.585638739000046],
              [-56.124256964999915, 49.616522528000075],
              [-56.097727016999954, 49.63764069200005],
              [-56.03819739499994, 49.67328522300005],
              [-55.96849524599992, 49.702826239000046],
              [-55.95571855399993, 49.70526764500005],
              [-55.939564581999946, 49.706284898000035],
              [-55.92341061099995, 49.70921458500004],
              [-55.90880286399994, 49.71356842700004],
              [-55.897694464999915, 49.71893952000005],
              [-55.89207923099991, 49.712958075000074],
              [-55.89098059799994, 49.71010976800005],
              [-55.89024817599994, 49.70526764500005],
              [-55.90807044199994, 49.70099518400008],
              [-55.94131425699993, 49.68789297100005],
              [-55.95913652299993, 49.68545156500005],
              [-55.95913652299993, 49.67796458500004],
              [-55.94294186099995, 49.67926666900007],
              [-55.92613684799994, 49.68305084800005],
              [-55.91051184799994, 49.68939850500004],
              [-55.897694464999915, 49.698431708000044],
              [-55.89098059799994, 49.689439195000034],
              [-55.87482662699995, 49.68797435100004],
              [-55.835601365999935, 49.69163646000004],
              [-55.839100714999915, 49.68463776200008],
              [-55.844634568999936, 49.67829010600008],
              [-55.85187740799995, 49.673529364000046],
              [-55.86009680899991, 49.67177969000005],
              [-55.86799068899995, 49.66828034100007],
              [-55.87157141799992, 49.66010163000004],
              [-55.87368730399993, 49.65078359600005],
              [-55.87718665299991, 49.643866278000075],
              [-55.89053300699993, 49.63385651200008],
              [-55.93862870999993, 49.60968659100007],
              [-55.92951412699995, 49.59829336100006],
              [-55.913400844999956, 49.594631252000056],
              [-55.87718665299991, 49.59601471600007],
              [-55.90078691299993, 49.56240469000005],
              [-55.93736731699994, 49.536322333000044],
              [-55.98062089799993, 49.51947663000004],
              [-56.024281378999945, 49.51349518400008],
              [-56.03490149599992, 49.51040273600006],
              [-56.05418860599991, 49.49673086100006],
              [-56.062163865999935, 49.49359772300005],
              [-56.07689368399991, 49.491888739000046],
              [-56.07970130099994, 49.48688385600008],
              [-56.07970130099994, 49.47919342700004],
              [-56.08576412699995, 49.46914297100005],
              [-56.12051347599993, 49.44179922100005],
              [-56.13072669199994, 49.42914459800005],
              [-56.12254798099991, 49.429348049000055],
              [-56.10008704299992, 49.438381252000056],
              [-56.05996660099993, 49.446193752000056],
              [-55.99193274599992, 49.484808661000045],
              [-55.95230058499993, 49.49982330900008],
              [-55.86436926999994, 49.51984284100007],
              [-55.82201087099992, 49.52204010600008],
              [-55.77415930899991, 49.51349518400008],
              [-55.782460089999915, 49.49843984600005],
              [-55.78783118399991, 49.49359772300005],
              [-55.76805579299992, 49.49469635600008],
              [-55.75743567599994, 49.493394273000035],
              [-55.75031490799995, 49.489935614000046],
              [-55.74356035099993, 49.48843008000006],
              [-55.728586391999954, 49.48232656500005],
              [-55.71922766799992, 49.47565338700008],
              [-55.72948157499991, 49.47256094000005],
              [-55.74181067599994, 49.47345612200007],
              [-55.749338344999956, 49.475043036000045],
              [-55.75633704299992, 49.47540924700007],
              [-55.76732337099992, 49.47256094000005],
              [-55.76553300699993, 49.47093333500004],
              [-55.770741339999915, 49.46430084800005],
              [-55.779286261999914, 49.456691799000055],
              [-55.78783118399991, 49.452053127000056],
              [-55.766468878999945, 49.44830963700008],
              [-55.73473059799994, 49.45384349200003],
              [-55.678578253999945, 49.47256094000005],
              [-55.68236243399991, 49.45892975500004],
              [-55.69546464799993, 49.440741278000075],
              [-55.698475714999915, 49.42475006700005],
              [-55.678293423999946, 49.42413971600007],
              [-55.67174231699994, 49.42475006700005],
              [-55.67174231699994, 49.417303778000075],
              [-55.678578253999945, 49.40814850500004],
              [-55.67886308499993, 49.39638906500005],
              [-55.671945766999954, 49.38666413000004],
              [-55.657460089999915, 49.38373444200005],
              [-55.64476477799991, 49.390285549000055],
              [-55.637562628999945, 49.40289948100008],
              [-55.632476365999935, 49.41705963700008],
              [-55.62645423099991, 49.427801825000074],
              [-55.58238684799994, 49.472357489000046],
              [-55.55382239499994, 49.48981354400007],
              [-55.52090410099993, 49.49359772300005],
              [-55.55052649599992, 49.451239325000074],
              [-55.563710089999915, 49.42601146000004],
              [-55.56187903599994, 49.41107819200005],
              [-55.56859290299991, 49.39940013200004],
              [-55.572824673999946, 49.38743724200003],
              [-55.57335364499994, 49.37518952000005],
              [-55.56932532499991, 49.36269765800006],
              [-55.54336503799993, 49.38336823100008],
              [-55.53229732999995, 49.39598216400009],
              [-55.52782141799992, 49.40766022300005],
              [-55.52611243399991, 49.42413971600007],
              [-55.52057857999995, 49.435980536000045],
              [-55.509877081999946, 49.443060614000046],
              [-55.49299068899995, 49.44521719000005],
              [-55.494699673999946, 49.44879791900007],
              [-55.495757615999935, 49.45184967700004],
              [-55.497385219999956, 49.45502350500004],
              [-55.50047766799992, 49.45888906500005],
              [-55.494211391999954, 49.46979401200008],
              [-55.48619544199994, 49.47996653900009],
              [-55.47325598899994, 49.460638739000046],
              [-55.46320553299995, 49.46556224200003],
              [-55.454416469999956, 49.48114655200004],
              [-55.44522050699993, 49.49359772300005],
              [-55.42853756399995, 49.500067450000074],
              [-55.37010657499991, 49.50665924700007],
              [-55.376942511999914, 49.49359772300005],
              [-55.36168372299994, 49.49673086100006],
              [-55.35582434799994, 49.49982330900008],
              [-55.349598761999914, 49.49359772300005],
              [-55.41079667899993, 49.442572333000044],
              [-55.43154863199993, 49.430894273000035],
              [-55.43154863199993, 49.42475006700005],
              [-55.40054277299993, 49.43113841400009],
              [-55.34166419199994, 49.458197333000044],
              [-55.31484941299993, 49.452053127000056],
              [-55.332102016999954, 49.44318268400008],
              [-55.39635169199994, 49.38694896000004],
              [-55.43211829299992, 49.368841864000046],
              [-55.44522050699993, 49.35586172100005],
              [-55.42072506399995, 49.36408112200007],
              [-55.391509568999936, 49.369574286000045],
              [-55.37364661399994, 49.36310455900008],
              [-55.38312740799995, 49.33535390800006],
              [-55.366078253999945, 49.35297272300005],
              [-55.34935462099992, 49.38080475500004],
              [-55.33250891799992, 49.40314362200007],
              [-55.31484941299993, 49.40424225500004],
              [-55.32909094999991, 49.389960028000075],
              [-55.31309973899994, 49.388657945000034],
              [-55.28856360599991, 49.40078359600005],
              [-55.28750566299993, 49.389960028000075],
              [-55.29605058499993, 49.371975002000056],
              [-55.30931555899991, 49.36591217700004],
              [-55.32530676999994, 49.363348700000074],
              [-55.34215247299994, 49.35586172100005],
              [-55.33372962099992, 49.349310614000046],
              [-55.32559160099993, 49.33893463700008],
              [-55.31895911399994, 49.32672760600008],
              [-55.31484941299993, 49.314886786000045],
              [-55.30772864499994, 49.31732819200005],
              [-55.30500240799995, 49.31915924700007],
              [-55.30117753799993, 49.322333075000074],
              [-55.308257615999935, 49.33494700700004],
              [-55.30703691299993, 49.34564850500004],
              [-55.29865475199995, 49.35309479400007],
              [-55.26626542899993, 49.36115143400008],
              [-55.253163214999915, 49.37287018400008],
              [-55.24372311099995, 49.38467031500005],
              [-55.236317511999914, 49.389960028000075],
              [-55.23696855399993, 49.39476146000004],
              [-55.267689581999946, 49.42475006700005],
              [-55.27188066299993, 49.436835028000075],
              [-55.27367102799991, 49.45270416900007],
              [-55.27245032499991, 49.46832916900007],
              [-55.267689581999946, 49.47996653900009],
              [-55.31484941299993, 49.53461334800005],
              [-55.287180141999954, 49.53579336100006],
              [-55.273101365999935, 49.539496161000045],
              [-55.26024329299992, 49.54824453300006],
              [-55.228179490999935, 49.53705475500004],
              [-55.21979732999995, 49.53009674700007],
              [-55.23289954299992, 49.52094147300005],
              [-55.22573808499993, 49.51463450700004],
              [-55.217681443999936, 49.51015859600005],
              [-55.20860755099994, 49.507473049000055],
              [-55.19884192599994, 49.50665924700007],
              [-55.20230058499993, 49.51284414300005],
              [-55.208973761999914, 49.528631903000075],
              [-55.21247311099995, 49.53461334800005],
              [-55.193430141999954, 49.539496161000045],
              [-55.17463131399995, 49.54661692900004],
              [-55.15566972599993, 49.54930247600004],
              [-55.13609778599994, 49.54075755400004],
              [-55.150380011999914, 49.54075755400004],
              [-55.150380011999914, 49.53461334800005],
              [-55.13853919199994, 49.52606842700004],
              [-55.12999426999994, 49.513739325000074],
              [-55.12482662699995, 49.49896881700005],
              [-55.123036261999914, 49.48309967700004],
              [-55.128163214999915, 49.46637604400007],
              [-55.140736456999946, 49.455064195000034],
              [-55.15648352799991, 49.44476959800005],
              [-55.17149817599994, 49.430894273000035],
              [-55.162098761999914, 49.41791413000004],
              [-55.17202714799993, 49.40078359600005],
              [-55.18854732999995, 49.39203522300005],
              [-55.19884192599994, 49.40424225500004],
              [-55.21320553299995, 49.39052969000005],
              [-55.22500566299993, 49.368068752000056],
              [-55.22984778599994, 49.34398021000004],
              [-55.219593878999945, 49.31635163000004],
              [-55.219309048999946, 49.277004299000055],
              [-55.22288977799991, 49.264553127000056],
              [-55.23200436099995, 49.25495026200008],
              [-55.244211391999954, 49.24876536700003],
              [-55.26545162699995, 49.24494049700007],
              [-55.29434160099993, 49.23289622600004],
              [-55.30654863199993, 49.22370026200008],
              [-55.31480872299994, 49.212876695000034],
              [-55.32144120999993, 49.20197174700007],
              [-55.32909094999991, 49.19196198100008],
              [-55.36506100199995, 49.17226797100005],
              [-55.37010657499991, 49.16400788000004],
              [-55.36436926999994, 49.159491278000075],
              [-55.33511308499993, 49.159491278000075],
              [-55.322336391999954, 49.15717194200005],
              [-55.34215247299994, 49.123032945000034],
              [-55.32070878799993, 49.12372467700004],
              [-55.31236731699994, 49.11505768400008],
              [-55.31395423099991, 49.10179271000004],
              [-55.322336391999954, 49.088324286000045],
              [-55.337147589999915, 49.07611725500004],
              [-55.368397589999915, 49.06012604400007],
              [-55.38312740799995, 49.047308661000045],
              [-55.36949622299994, 49.04979075700004],
              [-55.33531653599994, 49.06903717700004],
              [-55.31973222599993, 49.07461172100005],
              [-55.30626380099994, 49.07599518400008],
              [-55.27765865799995, 49.074652411000045],
              [-55.25820878799993, 49.08071523600006],
              [-55.184478318999936, 49.123032945000034],
              [-55.184478318999936, 49.12995026200008],
              [-55.20799719999991, 49.12555573100008],
              [-55.25967363199993, 49.10370514500005],
              [-55.27765865799995, 49.10602448100008],
              [-55.28726152299993, 49.12669505400004],
              [-55.28229732999995, 49.15033600500004],
              [-55.26895097599993, 49.17145416900007],
              [-55.25340735599991, 49.18451569200005],
              [-55.25340735599991, 49.19196198100008],
              [-55.28278561099995, 49.184881903000075],
              [-55.28750566299993, 49.18451569200005],
              [-55.28844153599994, 49.194566148000035],
              [-55.282093878999945, 49.203558661000045],
              [-55.27257239499994, 49.20994700700004],
              [-55.26398678299995, 49.21246979400007],
              [-55.24787350199995, 49.21515534100007],
              [-55.231027798999946, 49.221869208000044],
              [-55.19884192599994, 49.239162502000056],
              [-55.05418860599991, 49.29437897300005],
              [-55.06163489499994, 49.30182526200008],
              [-55.05418860599991, 49.30805084800005],
              [-55.073882615999935, 49.33392975500004],
              [-55.08043372299994, 49.34715403900009],
              [-55.082142706999946, 49.36269765800006],
              [-55.06281490799995, 49.350897528000075],
              [-55.04409745999993, 49.33494700700004],
              [-55.02721106699994, 49.329413153000075],
              [-55.01317298099991, 49.34902578300006],
              [-54.99526933499993, 49.29905833500004],
              [-54.992746548999946, 49.28384023600006],
              [-54.99909420499995, 49.268744208000044],
              [-55.01439368399991, 49.253973700000074],
              [-55.04796301999994, 49.23289622600004],
              [-55.03400631399995, 49.23021067900004],
              [-55.01598059799994, 49.23651764500005],
              [-54.99840247299994, 49.24787018400008],
              [-54.98582923099991, 49.26023997600004],
              [-54.961048956999946, 49.294989325000074],
              [-54.947255011999914, 49.30052317900004],
              [-54.92100989499994, 49.30182526200008],
              [-54.91812089799993, 49.29840729400007],
              [-54.91649329299992, 49.29096100500004],
              [-54.91197669199994, 49.28351471600007],
              [-54.90025794199994, 49.28009674700007],
              [-54.890695766999954, 49.28266022300005],
              [-54.88048255099994, 49.28900788000004],
              [-54.87242591099994, 49.29710521000004],
              [-54.869211391999954, 49.30491771000004],
              [-54.86375891799992, 49.337958075000074],
              [-54.866078253999945, 49.34275950700004],
              [-54.88263912699995, 49.34516022300005],
              [-54.88882402299993, 49.35175202000005],
              [-54.88809160099993, 49.36225006700005],
              [-54.88345292899993, 49.376288153000075],
              [-54.87767493399991, 49.385931708000044],
              [-54.86778723899994, 49.39716217700004],
              [-54.85704505099994, 49.40672435100004],
              [-54.84874426999994, 49.41107819200005],
              [-54.83372962099992, 49.40961334800005],
              [-54.83079993399991, 49.40265534100007],
              [-54.83568274599992, 49.38373444200005],
              [-54.83495032499991, 49.32363515800006],
              [-54.83193925699993, 49.314886786000045],
              [-54.834095831999946, 49.30483633000006],
              [-54.830189581999946, 49.28595612200007],
              [-54.816965298999946, 49.27562083500004],
              [-54.790679490999935, 49.29096100500004],
              [-54.782093878999945, 49.300482489000046],
              [-54.77953040299991, 49.30658600500004],
              [-54.78107662699995, 49.32575104400007],
              [-54.77920488199993, 49.337591864000046],
              [-54.77383378799993, 49.34723541900007],
              [-54.765288865999935, 49.353583075000074],
              [-54.75377356699994, 49.35586172100005],
              [-54.75755774599992, 49.34833405200004],
              [-54.75991777299993, 49.33893463700008],
              [-54.75934811099995, 49.32953522300005],
              [-54.75377356699994, 49.322333075000074],
              [-54.74290930899991, 49.31976959800005],
              [-54.737538214999915, 49.32648346600007],
              [-54.73265540299991, 49.34275950700004],
              [-54.72647050699993, 49.35065338700008],
              [-54.719634568999936, 49.36310455900008],
              [-54.712147589999915, 49.37010325700004],
              [-54.70425370999993, 49.37417226800005],
              [-54.68529212099992, 49.37982819200005],
              [-54.677398240999935, 49.38373444200005],
              [-54.67235266799992, 49.388657945000034],
              [-54.66673743399991, 49.39557526200008],
              [-54.65689042899993, 49.41107819200005],
              [-54.65412350199995, 49.41266510600008],
              [-54.649728969999956, 49.413397528000075],
              [-54.64561926999994, 49.415350653000075],
              [-54.64391028599994, 49.42104726800005],
              [-54.64513098899994, 49.42942942900004],
              [-54.64708411399994, 49.432847398000035],
              [-54.65013587099992, 49.430894273000035],
              [-54.63654537699995, 49.446966864000046],
              [-54.585275844999956, 49.489935614000046],
              [-54.56045488199993, 49.51630280200004],
              [-54.54474850199995, 49.52912018400008],
              [-54.53034420499995, 49.53461334800005],
              [-54.509022589999915, 49.53668854400007],
              [-54.469309048999946, 49.546087958000044],
              [-54.45148678299995, 49.54824453300006],
              [-54.44371497299994, 49.54352448100008],
              [-54.496205206999946, 49.51007721600007],
              [-54.498890753999945, 49.503892320000034],
              [-54.50609290299991, 49.476263739000046],
              [-54.50967363199993, 49.47138092700004],
              [-54.534047003999945, 49.44521719000005],
              [-54.51357988199993, 49.45913320500006],
              [-54.482980923999946, 49.47109609600005],
              [-54.45213782499991, 49.476996161000045],
              [-54.43101966099994, 49.47256094000005],
              [-54.444650844999956, 49.46149323100008],
              [-54.45567786399994, 49.448431708000044],
              [-54.45775305899991, 49.43545156500005],
              [-54.444650844999956, 49.42475006700005],
              [-54.47492428299995, 49.40497467700004],
              [-54.479400193999936, 49.40053945500006],
              [-54.48542232999995, 49.38031647300005],
              [-54.48696855399993, 49.36810944200005],
              [-54.482533331999946, 49.36269765800006],
              [-54.46011308499993, 49.355536200000074],
              [-54.45579993399991, 49.33860911700003],
              [-54.46247311099995, 49.31854889500005],
              [-54.48477128799993, 49.278631903000075],
              [-54.48346920499995, 49.267645575000074],
              [-54.476673956999946, 49.269232489000046],
              [-54.47256425699993, 49.28384023600006],
              [-54.463449673999946, 49.30101146000004],
              [-54.44188391799992, 49.31321849200003],
              [-54.41681881399995, 49.32363515800006],
              [-54.39683997299994, 49.33535390800006],
              [-54.41641191299993, 49.35130442900004],
              [-54.40929114499994, 49.37177155200004],
              [-54.392567511999914, 49.39207591400009],
              [-54.37291419199994, 49.422308661000045],
              [-54.348947719999956, 49.42910390800006],
              [-54.30125891799992, 49.430894273000035],
              [-54.30431067599994, 49.41469961100006],
              [-54.29210364499994, 49.41278717700004],
              [-54.25967363199993, 49.42475006700005],
              [-54.258697068999936, 49.40770091400009],
              [-54.24876868399991, 49.406236070000034],
              [-54.21934973899994, 49.417303778000075],
              [-54.22647050699993, 49.40253327000005],
              [-54.23473059799994, 49.39077383000006],
              [-54.23859615799995, 49.378607489000046],
              [-54.23232988199993, 49.36269765800006],
              [-54.22203528599994, 49.37555573100008],
              [-54.217640753999945, 49.389553127000056],
              [-54.21202551999994, 49.40208567900004],
              [-54.19762122299994, 49.41107819200005],
              [-54.18228105399993, 49.39329661700003],
              [-54.17926998599995, 49.382798570000034],
              [-54.17601477799991, 49.38377513200004],
              [-54.16038977799991, 49.40053945500006],
              [-54.15078691299993, 49.41876862200007],
              [-54.14728756399995, 49.43773021000004],
              [-54.139230923999946, 49.452826239000046],
              [-54.08551998599995, 49.46369049700007],
              [-54.08153235599991, 49.46230703300006],
              [-54.07689368399991, 49.45538971600007],
              [-54.06753495999993, 49.460272528000075],
              [-54.06004798099991, 49.46869538000004],
              [-54.061105923999946, 49.47256094000005],
              [-54.048817511999914, 49.47711823100008],
              [-54.04474850199995, 49.481756903000075],
              [-54.041086391999954, 49.48086172100005],
              [-54.03001868399991, 49.46914297100005],
              [-54.02110755099994, 49.46466705900008],
              [-53.99649003799993, 49.46246979400007],
              [-53.98595130099994, 49.45888906500005],
              [-54.00039628799993, 49.45652903900009],
              [-54.04059811099995, 49.438381252000056],
              [-54.016509568999936, 49.43183014500005],
              [-53.95107988199993, 49.449204820000034],
              [-53.923939581999946, 49.452053127000056],
              [-53.908314581999946, 49.445013739000046],
              [-53.873931443999936, 49.42218659100007],
              [-53.85875403599994, 49.417303778000075],
              [-53.845366990999935, 49.41510651200008],
              [-53.805978969999956, 49.40302155200004],
              [-53.79356848899994, 49.39679596600007],
              [-53.77334550699993, 49.39980703300006],
              [-53.75462805899991, 49.39350006700005],
              [-53.72524980399993, 49.376288153000075],
              [-53.67910722599993, 49.366848049000055],
              [-53.663726365999935, 49.359442450000074],
              [-53.67747962099992, 49.34902578300006],
              [-53.65611731699994, 49.33222077000005],
              [-53.62401282499991, 49.32648346600007],
              [-53.59471594999991, 49.32444896000004],
              [-53.58189856699994, 49.31858958500004],
              [-53.58055579299992, 49.31028880400004],
              [-53.57713782499991, 49.307074286000045],
              [-53.57258053299995, 49.30540599200003],
              [-53.567697719999956, 49.30182526200008],
              [-53.56383216099994, 49.300848700000074],
              [-53.55142167899993, 49.30231354400007],
              [-53.54710852799991, 49.30182526200008],
              [-53.54662024599992, 49.299261786000045],
              [-53.54759680899991, 49.289943752000056],
              [-53.54710852799991, 49.287543036000045],
              [-53.536000128999945, 49.28343333500004],
              [-53.522043423999946, 49.28021881700005],
              [-53.50694739499994, 49.28070709800005],
              [-53.49254309799994, 49.287543036000045],
              [-53.47801673099991, 49.26837799700007],
              [-53.46955318899995, 49.26235586100006],
              [-53.45775305899991, 49.26023997600004],
              [-53.45775305899991, 49.25340403900009],
              [-53.453684048999946, 49.242173570000034],
              [-53.491851365999935, 49.218736070000034],
              [-53.49254309799994, 49.19818756700005],
              [-53.50300045499995, 49.19806549700007],
              [-53.52139238199993, 49.19326406500005],
              [-53.53010006399995, 49.19196198100008],
              [-53.54039466099994, 49.18781159100007],
              [-53.54039466099994, 49.178615627000056],
              [-53.53351803299995, 49.16400788000004],
              [-53.53945878799993, 49.156236070000034],
              [-53.556630011999914, 49.14012278900009],
              [-53.56017005099994, 49.13336823100008],
              [-53.56598873599995, 49.12596263200004],
              [-53.579335089999915, 49.12807851800005],
              [-53.605132615999935, 49.136704820000034],
              [-53.60985266799992, 49.13361237200007],
              [-53.61676998599995, 49.126166083000044],
              [-53.622303839999915, 49.117173570000034],
              [-53.62287350199995, 49.109442450000074],
              [-53.61587480399993, 49.105454820000034],
              [-53.60374915299991, 49.10301341400009],
              [-53.59093176999994, 49.09857819200005],
              [-53.58189856699994, 49.088324286000045],
              [-53.57957923099991, 49.06663646000004],
              [-53.589914516999954, 49.052069403000075],
              [-53.60895748599995, 49.04368724200003],
              [-53.79356848899994, 49.02753327000005],
              [-53.83824622299994, 49.03367747600004],
              [-53.84137936099995, 49.030585028000075],
              [-53.83458411399994, 49.02374909100007],
              [-53.82274329299992, 49.01699453300006],
              [-53.81094316299993, 49.01386139500005],
              [-53.742298956999946, 49.01601797100005],
              [-53.72524980399993, 49.01386139500005],
              [-53.74767005099994, 48.99868398600006],
              [-53.777455206999946, 48.98777903900009],
              [-53.809437628999945, 48.98126862200007],
              [-53.83824622299994, 48.97907135600008],
              [-53.85130774599992, 48.981756903000075],
              [-53.874663865999935, 48.99237702000005],
              [-53.882923956999946, 48.99274323100008],
              [-53.89635169199994, 48.980536200000074],
              [-53.887928839999915, 48.97089264500005],
              [-53.85496985599991, 48.95921458500004],
              [-53.81167558499993, 48.935248114000046],
              [-53.81094316299993, 48.931301174000055],
              [-53.82453365799995, 48.92804596600007],
              [-53.84947669199994, 48.91396719000005],
              [-53.86213131399995, 48.91083405200004],
              [-53.923939581999946, 48.917669989000046],
              [-53.93883216099994, 48.911322333000044],
              [-53.94945227799991, 48.90326569200005],
              [-53.961048956999946, 48.89712148600006],
              [-53.978505011999914, 48.896551825000074],
              [-53.96385657499991, 48.885931708000044],
              [-53.93785559799994, 48.88703034100007],
              [-53.882923956999946, 48.896551825000074],
              [-53.882923956999946, 48.890326239000046],
              [-53.95807857999995, 48.86908600500004],
              [-53.978505011999914, 48.85618724200003],
              [-53.964914516999954, 48.84194570500006],
              [-53.978586391999954, 48.83633047100005],
              [-53.994252081999946, 48.83466217700004],
              [-54.026600714999915, 48.83567942900004],
              [-54.04214433499993, 48.83344147300005],
              [-54.078114386999914, 48.82143789300005],
              [-54.136789516999954, 48.82143789300005],
              [-54.146473761999914, 48.81777578300006],
              [-54.17027747299994, 48.80487702000005],
              [-54.18464107999995, 48.80097077000005],
              [-54.17959550699993, 48.79165273600006],
              [-54.18101966099994, 48.78392161700003],
              [-54.187489386999914, 48.77814362200007],
              [-54.19762122299994, 48.77423737200007],
              [-54.19762122299994, 48.76740143400008],
              [-54.16258704299992, 48.77122630400004],
              [-54.02086341099994, 48.81537506700005],
              [-54.005848761999914, 48.81460195500006],
              [-53.99095618399991, 48.80613841400009],
              [-53.99010169199994, 48.795803127000056],
              [-53.99909420499995, 48.78473541900007],
              [-54.01329505099994, 48.77423737200007],
              [-53.99063066299993, 48.76837799700007],
              [-53.96983801999994, 48.77301666900007],
              [-53.96202551999994, 48.781683661000045],
              [-53.978505011999914, 48.78790924700007],
              [-53.943023240999935, 48.824286200000074],
              [-53.89513098899994, 48.84174225500004],
              [-53.84447180899991, 48.839056708000044],
              [-53.80040442599994, 48.81460195500006],
              [-53.829416469999956, 48.80215078300006],
              [-53.85732988199993, 48.79791901200008],
              [-53.91771399599992, 48.80097077000005],
              [-53.90306555899991, 48.791001695000034],
              [-53.90099036399994, 48.778550523000035],
              [-53.90025794199994, 48.76707591400009],
              [-53.88975989499994, 48.75995514500005],
              [-53.87726803299995, 48.76325104400007],
              [-53.86754309799994, 48.77301666900007],
              [-53.85684160099993, 48.77985260600008],
              [-53.84137936099995, 48.77423737200007],
              [-53.87791907499991, 48.74795156500005],
              [-53.89924068899995, 48.73997630400004],
              [-53.923939581999946, 48.739488023000035],
              [-53.97085527299993, 48.751166083000044],
              [-53.99449622299994, 48.75307851800005],
              [-54.02013098899994, 48.74632396000004],
              [-54.02013098899994, 48.739488023000035],
              [-53.96715247299994, 48.73663971600007],
              [-53.94517981699994, 48.72866445500006],
              [-53.94440670499995, 48.712144273000035],
              [-53.933257615999935, 48.70351797100005],
              [-53.938710089999915, 48.69407786700003],
              [-53.94880123599995, 48.683294989000046],
              [-53.951242641999954, 48.67059967700004],
              [-53.941517706999946, 48.66083405200004],
              [-53.92609615799995, 48.65643952000005],
              [-53.909413214999915, 48.653957424000055],
              [-53.89598548099991, 48.650091864000046],
              [-53.89598548099991, 48.64325592700004],
              [-53.914133266999954, 48.637925523000035],
              [-53.93138587099992, 48.62962474200003],
              [-53.89354407499991, 48.632025458000044],
              [-53.79356848899994, 48.67804596600007],
              [-53.79356848899994, 48.684881903000075],
              [-53.873158331999946, 48.673041083000044],
              [-53.91665605399993, 48.672756252000056],
              [-53.920765753999945, 48.68797435100004],
              [-53.90416419199994, 48.70140208500004],
              [-53.86949622299994, 48.72207265800006],
              [-53.835194464999915, 48.75039297100005],
              [-53.83625240799995, 48.74237702000005],
              [-53.85496985599991, 48.704738674000055],
              [-53.75023352799991, 48.712144273000035],
              [-53.74510657499991, 48.698553778000075],
              [-53.72492428299995, 48.697251695000034],
              [-53.71467037699995, 48.69505442900004],
              [-53.70421301999994, 48.691107489000046],
              [-53.71007239499994, 48.683661200000074],
              [-53.71589107999995, 48.680975653000075],
              [-53.721994594999956, 48.67914459800005],
              [-53.72899329299992, 48.67430247600004],
              [-53.73306230399993, 48.66498444200005],
              [-53.72618567599994, 48.65997955900008],
              [-53.71446692599994, 48.65875885600008],
              [-53.70421301999994, 48.66095612200007],
              [-53.65274003799993, 48.68455638200004],
              [-53.639963344999956, 48.69476959800005],
              [-53.63121497299994, 48.69879791900007],
              [-53.618397589999915, 48.69953034100007],
              [-53.60680091099994, 48.69627513200004],
              [-53.60171464799993, 48.68797435100004],
              [-53.60411536399994, 48.67670319200005],
              [-53.60997473899994, 48.673081773000035],
              [-53.61778723899994, 48.671861070000034],
              [-53.62596594999991, 48.66746653900009],
              [-53.64248613199993, 48.65444570500006],
              [-53.65957597599993, 48.64712148600006],
              [-53.678618943999936, 48.64398834800005],
              [-53.71617591099994, 48.641831773000035],
              [-53.78490149599992, 48.62295156500005],
              [-53.82827714799993, 48.59544505400004],
              [-53.84630286399994, 48.591050523000035],
              [-53.88394120999993, 48.59088776200008],
              [-53.90343176999994, 48.58869049700007],
              [-53.92149817599994, 48.58148834800005],
              [-53.933664516999954, 48.571193752000056],
              [-53.94444739499994, 48.55927155200004],
              [-53.958648240999935, 48.54706452000005],
              [-53.943470831999946, 48.54238515800006],
              [-53.93040930899991, 48.54950592700004],
              [-53.917632615999935, 48.56073639500005],
              [-53.90343176999994, 48.56818268400008],
              [-53.711008266999954, 48.56073639500005],
              [-53.73159745999993, 48.55410390800006],
              [-53.77448482999995, 48.550767320000034],
              [-53.79356848899994, 48.540228583000044],
              [-53.78612219999991, 48.53782786700003],
              [-53.77692623599995, 48.53778717700004],
              [-53.76935787699995, 48.53900788000004],
              [-53.766835089999915, 48.540228583000044],
              [-53.75104732999995, 48.52997467700004],
              [-53.74400794199994, 48.52289459800005],
              [-53.748890753999945, 48.51976146000004],
              [-53.75861568899995, 48.51654694200005],
              [-53.787668423999946, 48.50242747600004],
              [-53.80406653599994, 48.499335028000075],
              [-53.83674068899995, 48.49762604400007],
              [-53.86701412699995, 48.49274323100008],
              [-53.895741339999915, 48.484442450000074],
              [-53.923939581999946, 48.47260163000004],
              [-53.980539516999954, 48.44098541900007],
              [-54.009877081999946, 48.428941148000035],
              [-54.04369055899991, 48.42413971600007],
              [-54.07681230399993, 48.42926666900007],
              [-54.09211178299995, 48.42987702000005],
              [-54.109486456999946, 48.42413971600007],
              [-54.14801998599995, 48.39789459800005],
              [-54.164133266999954, 48.390692450000074],
              [-54.15221106699994, 48.384833075000074],
              [-54.14248613199993, 48.37791575700004],
              [-54.13687089799993, 48.36855703300006],
              [-54.136789516999954, 48.35529205900008],
              [-54.08804277299993, 48.40119049700007],
              [-54.06794186099995, 48.40989817900004],
              [-54.046131964999915, 48.41034577000005],
              [-54.001210089999915, 48.40542226800005],
              [-53.978505011999914, 48.40989817900004],
              [-53.89976966099994, 48.45848216400009],
              [-53.85537675699993, 48.47524648600006],
              [-53.81403561099995, 48.46515534100007],
              [-53.828968878999945, 48.44867584800005],
              [-53.87669837099992, 48.40989817900004],
              [-53.88145911399994, 48.388373114000046],
              [-53.873036261999914, 48.373480536000045],
              [-53.856027798999946, 48.368394273000035],
              [-53.83511308499993, 48.37641022300005],
              [-53.85252844999991, 48.38361237200007],
              [-53.84557044199994, 48.394964911000045],
              [-53.81403561099995, 48.41738515800006],
              [-53.81029212099992, 48.42373281500005],
              [-53.80606035099993, 48.432847398000035],
              [-53.800892706999946, 48.441107489000046],
              [-53.793853318999936, 48.444647528000075],
              [-53.77904212099992, 48.44745514500005],
              [-53.77562415299991, 48.45482005400004],
              [-53.77529863199993, 48.464829820000034],
              [-53.76992753799993, 48.47573476800005],
              [-53.741851365999935, 48.500067450000074],
              [-53.70030676999994, 48.52838776200008],
              [-53.65684973899994, 48.546576239000046],
              [-53.62287350199995, 48.540228583000044],
              [-53.63414466099994, 48.532416083000044],
              [-53.65444902299993, 48.522691148000035],
              [-53.66319739499994, 48.51357656500005],
              [-53.64940344999991, 48.51463450700004],
              [-53.63646399599992, 48.51349518400008],
              [-53.624989386999914, 48.50873444200005],
              [-53.61538652299993, 48.499335028000075],
              [-53.70026607999995, 48.45547109600005],
              [-53.714100714999915, 48.445379950000074],
              [-53.72524980399993, 48.43158600500004],
              [-53.718413865999935, 48.42413971600007],
              [-53.69709225199995, 48.43549225500004],
              [-53.67540442599994, 48.44415924700007],
              [-53.65379798099991, 48.44961172100005],
              [-53.632801886999914, 48.45148346600007],
              [-53.62441972599993, 48.462551174000055],
              [-53.58812415299991, 48.526597398000035],
              [-53.58189856699994, 48.526597398000035],
              [-53.577015753999945, 48.51312897300005],
              [-53.578114386999914, 48.50263092700004],
              [-53.58812415299991, 48.47882721600007],
              [-53.56867428299995, 48.48786041900007],
              [-53.558257615999935, 48.49119700700004],
              [-53.54710852799991, 48.49241771000004],
              [-53.61538652299993, 48.40989817900004],
              [-53.59552975199995, 48.42072174700007],
              [-53.55850175699993, 48.44757721600007],
              [-53.54092363199993, 48.46515534100007],
              [-53.530181443999936, 48.45734284100007],
              [-53.521473761999914, 48.462225653000075],
              [-53.505523240999935, 48.48627350500004],
              [-53.50352942599994, 48.49192942900004],
              [-53.50137285099993, 48.50763580900008],
              [-53.49868730399993, 48.51357656500005],
              [-53.49095618399991, 48.514960028000075],
              [-53.482085740999935, 48.51121653900009],
              [-53.47500566299993, 48.510972398000035],
              [-53.46983801999994, 48.531317450000074],
              [-53.464914516999954, 48.53656647300005],
              [-53.45995032499991, 48.540228583000044],
              [-53.45775305899991, 48.54364655200004],
              [-53.45881100199995, 48.55141836100006],
              [-53.46361243399991, 48.56386953300006],
              [-53.46458899599992, 48.571600653000075],
              [-53.46422278599994, 48.586818752000056],
              [-53.46129309799994, 48.592962958000044],
              [-53.444650844999956, 48.59813060100004],
              [-53.44115149599992, 48.60431549700007],
              [-53.440012173999946, 48.61115143400008],
              [-53.43724524599992, 48.61591217700004],
              [-53.42357337099992, 48.62287018400008],
              [-53.414173956999946, 48.62376536700003],
              [-53.38267981699994, 48.61591217700004],
              [-53.35366777299993, 48.614569403000075],
              [-53.34219316299993, 48.61273834800005],
              [-53.30679277299993, 48.58930084800005],
              [-53.301665818999936, 48.579413153000075],
              [-53.317616339999915, 48.55231354400007],
              [-53.30968176999994, 48.54877350500004],
              [-53.29454505099994, 48.55219147300005],
              [-53.28026282499991, 48.56073639500005],
              [-53.27904212099992, 48.549994208000044],
              [-53.27481035099993, 48.53961823100008],
              [-53.268137173999946, 48.531236070000034],
              [-53.25914466099994, 48.526597398000035],
              [-53.24351966099994, 48.52635325700004],
              [-53.238392706999946, 48.53351471600007],
              [-53.236887173999946, 48.54409414300005],
              [-53.23184160099993, 48.55451080900008],
              [-53.215402798999946, 48.56663646000004],
              [-53.17625891799992, 48.58885325700004],
              [-53.162953253999945, 48.60171133000006],
              [-53.17039954299992, 48.60911692900004],
              [-53.15859941299993, 48.62514883000006],
              [-53.152333136999914, 48.63117096600007],
              [-53.14305579299992, 48.63646067900004],
              [-53.12938391799992, 48.63979726800005],
              [-53.10846920499995, 48.64012278900009],
              [-53.09805253799993, 48.64667389500005],
              [-53.098540818999936, 48.65094635600008],
              [-53.084543423999946, 48.69985586100006],
              [-53.07681230399993, 48.703558661000045],
              [-53.07135982999995, 48.700384833000044],
              [-53.074208136999914, 48.691107489000046],
              [-53.06509355399993, 48.680853583000044],
              [-53.05455481699994, 48.67767975500004],
              [-53.04360917899993, 48.67601146000004],
              [-53.033192511999914, 48.67059967700004],
              [-53.02521725199995, 48.660142320000034],
              [-53.018422003999945, 48.640285549000055],
              [-53.01276607999995, 48.62962474200003],
              [-52.98289954299992, 48.60419342700004],
              [-52.98127193899995, 48.591050523000035],
              [-53.005848761999914, 48.57501862200007],
              [-53.00031490799995, 48.570379950000074],
              [-52.99054928299995, 48.55914948100008],
              [-52.98477128799993, 48.55451080900008],
              [-52.998605923999946, 48.546576239000046],
              [-53.014515753999945, 48.54205963700008],
              [-53.02774003799993, 48.53583405200004],
              [-53.033192511999914, 48.52317942900004],
              [-53.03506425699993, 48.516913153000075],
              [-53.04430091099994, 48.50039297100005],
              [-53.04747473899994, 48.49241771000004],
              [-53.04841061099995, 48.48509349200003],
              [-53.04747473899994, 48.46173737200007],
              [-53.05846106699994, 48.43585846600007],
              [-53.08470618399991, 48.417954820000034],
              [-53.14305579299992, 48.39687734600005],
              [-53.15489661399994, 48.388739325000074],
              [-53.18317623599995, 48.36123281500005],
              [-53.18740800699993, 48.35529205900008],
              [-53.22207597599993, 48.35529205900008],
              [-53.23932857999995, 48.36017487200007],
              [-53.26976477799991, 48.38226959800005],
              [-53.28506425699993, 48.38499583500004],
              [-53.31436113199993, 48.38320547100005],
              [-53.32530676999994, 48.37726471600007],
              [-53.33189856699994, 48.37555573100008],
              [-53.334868943999936, 48.379787502000056],
              [-53.33820553299995, 48.38617584800005],
              [-53.34585527299993, 48.388006903000075],
              [-53.35488847599993, 48.38666413000004],
              [-53.362172003999945, 48.38320547100005],
              [-53.355539516999954, 48.36050039300005],
              [-53.38654537699995, 48.30605703300006],
              [-53.36900794199994, 48.293850002000056],
              [-53.38841712099992, 48.28611888200004],
              [-53.44570878799993, 48.28571198100008],
              [-53.45775305899991, 48.277044989000046],
              [-53.468088344999956, 48.25653717700004],
              [-53.492176886999914, 48.247707424000055],
              [-53.54092363199993, 48.23981354400007],
              [-53.54922441299993, 48.23432038000004],
              [-53.57445227799991, 48.21185944200005],
              [-53.60924231699994, 48.18903229400007],
              [-53.619211391999954, 48.180853583000044],
              [-53.63947506399995, 48.16933828300006],
              [-53.664173956999946, 48.16657135600008],
              [-53.68932044199994, 48.17011139500005],
              [-53.75462805899991, 48.19330475500004],
              [-53.77647864499994, 48.19708893400008],
              [-53.80406653599994, 48.19822825700004],
              [-53.84508216099994, 48.19082265800006],
              [-53.85578365799995, 48.19578685100004],
              [-53.86461341099994, 48.207017320000034],
              [-53.871652798999946, 48.218817450000074],
              [-53.87669837099992, 48.22553131700005],
              [-53.90387936099995, 48.236761786000045],
              [-53.92528235599991, 48.23700592700004],
              [-53.93936113199993, 48.22553131700005],
              [-53.94440670499995, 48.20164622600004],
              [-53.94127356699994, 48.17670319200005],
              [-53.93382727799991, 48.15843333500004],
              [-53.925119594999956, 48.14203522300005],
              [-53.91771399599992, 48.12250397300005],
              [-53.91315670499995, 48.09430573100008],
              [-53.905181443999936, 48.08510976800005],
              [-53.80406653599994, 48.07477448100008],
              [-53.72508704299992, 48.083197333000044],
              [-53.68399003799993, 48.08038971600007],
              [-53.66319739499994, 48.06110260600008],
              [-53.72374426999994, 48.03974030200004],
              [-53.78734290299991, 48.02631256700005],
              [-53.85496985599991, 48.02631256700005],
              [-53.90762285099993, 48.038397528000075],
              [-53.923939581999946, 48.03375885600008],
              [-53.90835527299993, 48.02106354400007],
              [-53.886830206999946, 48.014837958000044],
              [-53.84194902299993, 48.01264069200005],
              [-53.820301886999914, 48.008693752000056],
              [-53.79784094999991, 48.00169505400004],
              [-53.775949673999946, 47.99941640800006],
              [-53.741118943999936, 48.016791083000044],
              [-53.68431555899991, 48.02008698100008],
              [-53.665272589999915, 48.02830638200004],
              [-53.62913977799991, 48.04962799700007],
              [-53.60855058499993, 48.05426666900007],
              [-53.61758378799993, 48.03888580900008],
              [-53.62287350199995, 48.03375885600008],
              [-53.62157141799992, 48.00495026200008],
              [-53.64484615799995, 47.96588776200008],
              [-53.697336391999954, 47.89663320500006],
              [-53.72118079299992, 47.902044989000046],
              [-53.78734290299991, 47.90346914300005],
              [-53.78734290299991, 47.89663320500006],
              [-53.75523841099994, 47.89520905200004],
              [-53.72524980399993, 47.88979726800005],
              [-53.72960364499994, 47.87010325700004],
              [-53.732533331999946, 47.84247467700004],
              [-53.74128170499995, 47.81785716400009],
              [-53.76317298099991, 47.80719635600008],
              [-53.770822719999956, 47.80019765800006],
              [-53.78042558499993, 47.78595612200007],
              [-53.79161536399994, 47.774603583000044],
              [-53.80406653599994, 47.77651601800005],
              [-53.82213294199994, 47.79018789300005],
              [-53.83120683499993, 47.79975006700005],
              [-53.83511308499993, 47.810614325000074],
              [-53.84471594999991, 47.824652411000045],
              [-53.86750240799995, 47.843451239000046],
              [-53.89476477799991, 47.85883209800005],
              [-53.91771399599992, 47.86245351800005],
              [-53.928944464999915, 47.852443752000056],
              [-53.87730872299994, 47.828111070000034],
              [-53.87669837099992, 47.80719635600008],
              [-53.858265753999945, 47.80158112200007],
              [-53.85464433499993, 47.78489817900004],
              [-53.85415605399993, 47.76752350500004],
              [-53.84508216099994, 47.759426174000055],
              [-53.83348548099991, 47.75177643400008],
              [-53.82892818899995, 47.73574453300006],
              [-53.834868943999936, 47.72125885600008],
              [-53.85496985599991, 47.718451239000046],
              [-53.84679114499994, 47.70677317900004],
              [-53.807850714999915, 47.67747630400004],
              [-53.793812628999945, 47.664048570000034],
              [-53.76317298099991, 47.62567780200004],
              [-53.73790442599994, 47.61969635600008],
              [-53.72118079299992, 47.64443594000005],
              [-53.70571855399993, 47.67609284100007],
              [-53.68431555899991, 47.69114817900004],
              [-53.66616777299993, 47.684027411000045],
              [-53.66844641799992, 47.669623114000046],
              [-53.68016516799992, 47.65379466400009],
              [-53.69054114499994, 47.64272695500006],
              [-53.70299231699994, 47.619574286000045],
              [-53.707590298999946, 47.61603424700007],
              [-53.71174068899995, 47.60993073100008],
              [-53.71011308499993, 47.59780508000006],
              [-53.70384680899991, 47.58869049700007],
              [-53.69395911399994, 47.591782945000034],
              [-53.68663489499994, 47.597642320000034],
              [-53.68073482999995, 47.59870026200008],
              [-53.670033331999946, 47.59552643400008],
              [-53.671986456999946, 47.589911200000074],
              [-53.66706295499995, 47.57762278900009],
              [-53.66038977799991, 47.569973049000055],
              [-53.65697180899991, 47.57786692900004],
              [-53.65542558499993, 47.57965729400007],
              [-53.652333136999914, 47.57684967700004],
              [-53.64976966099994, 47.57025788000004],
              [-53.65021725199995, 47.56077708500004],
              [-53.653635219999956, 47.55223216400009],
              [-53.670033331999946, 47.526678778000075],
              [-53.65611731699994, 47.53339264500005],
              [-53.63158118399991, 47.55540599200003],
              [-53.62287350199995, 47.56077708500004],
              [-53.61790930899991, 47.55951569200005],
              [-53.613270636999914, 47.55524323100008],
              [-53.609934048999946, 47.54938385600008],
              [-53.60855058499993, 47.543402411000045],
              [-53.605132615999935, 47.53937409100007],
              [-53.59727942599994, 47.54120514500005],
              [-53.58836829299992, 47.54486725500004],
              [-53.58189856699994, 47.546535549000055],
              [-53.55386308499993, 47.53925202000005],
              [-53.550119594999956, 47.54389069200005],
              [-53.54710852799991, 47.56077708500004],
              [-53.54898027299993, 47.57241445500006],
              [-53.55308997299994, 47.58100006700005],
              [-53.550852016999954, 47.58820221600007],
              [-53.53351803299995, 47.59552643400008],
              [-53.55174719999991, 47.61237213700008],
              [-53.560658331999946, 47.62384674700007],
              [-53.55703691299993, 47.62909577000005],
              [-53.54320227799991, 47.62872955900008],
              [-53.53453528599994, 47.627020575000074],
              [-53.513010219999956, 47.61603424700007],
              [-53.51744544199994, 47.63271719000005],
              [-53.51195227799991, 47.64398834800005],
              [-53.50853430899991, 47.65497467700004],
              [-53.519195115999935, 47.67064036700003],
              [-53.50291907499991, 47.673041083000044],
              [-53.48863684799994, 47.68244049700007],
              [-53.48033606699994, 47.692572333000044],
              [-53.48200436099995, 47.697333075000074],
              [-53.49038652299993, 47.70286692900004],
              [-53.49742591099994, 47.71621328300006],
              [-53.50096594999991, 47.73236725500004],
              [-53.49868730399993, 47.74640534100007],
              [-53.487172003999945, 47.75991445500006],
              [-53.47618567599994, 47.764837958000044],
              [-53.46784420499995, 47.771470445000034],
              [-53.46458899599992, 47.79047272300005],
              [-53.459543423999946, 47.80548737200007],
              [-53.44176184799994, 47.82078685100004],
              [-53.44408118399991, 47.82831452000005],
              [-53.42918860599991, 47.85057200700004],
              [-53.42015540299991, 47.86115143400008],
              [-53.40933183499993, 47.86928945500006],
              [-53.39415442599994, 47.87555573100008],
              [-53.382476365999935, 47.87636953300006],
              [-53.35533606699994, 47.86928945500006],
              [-53.35533606699994, 47.87547435100004],
              [-53.36510169199994, 47.88703034100007],
              [-53.362619594999956, 47.89980703300006],
              [-53.352121548999946, 47.913316148000035],
              [-53.33828691299993, 47.92731354400007],
              [-53.32876542899993, 47.94098541900007],
              [-53.31346594999991, 47.974676825000074],
              [-53.30353756399995, 47.988714911000045],
              [-53.27647864499994, 48.01642487200007],
              [-53.26838131399995, 48.02033112200007],
              [-53.24864661399994, 48.01911041900007],
              [-53.23924719999991, 48.02008698100008],
              [-53.22899329299992, 48.02586497600004],
              [-53.22175045499995, 48.03266022300005],
              [-53.21385657499991, 48.038275458000044],
              [-53.18431555899991, 48.04254791900007],
              [-53.18028723899994, 48.04755280200004],
              [-53.17906653599994, 48.05414459800005],
              [-53.17039954299992, 48.06110260600008],
              [-53.14806067599994, 48.06427643400008],
              [-53.13243567599994, 48.05658600500004],
              [-53.117746548999946, 48.04596588700008],
              [-53.09805253799993, 48.04059479400007],
              [-53.081288214999915, 48.043850002000056],
              [-53.06102454299992, 48.05190664300005],
              [-53.04210364499994, 48.061835028000075],
              [-53.02953040299991, 48.07099030200004],
              [-52.991078253999945, 48.10651276200008],
              [-52.95262610599991, 48.15302155200004],
              [-52.93545488199993, 48.16673411700003],
              [-52.92332923099991, 48.17096588700008],
              [-52.900461391999954, 48.16128164300005],
              [-52.86583411399994, 48.12396881700005],
              [-52.83478756399995, 48.112494208000044],
              [-52.83674068899995, 48.105454820000034],
              [-52.84601803299995, 48.09837474200003],
              [-52.85822506399995, 48.09520091400009],
              [-52.902902798999946, 48.09520091400009],
              [-52.91441809799994, 48.08958567900004],
              [-52.920765753999945, 48.082098700000074],
              [-52.925038214999915, 48.07412344000005],
              [-52.93016516799992, 48.06732819200005],
              [-52.946197068999936, 48.054348049000055],
              [-52.95409094999991, 48.045803127000056],
              [-52.95742753799993, 48.037176825000074],
              [-52.95970618399991, 48.01748281500005],
              [-52.966908331999946, 48.001654364000046],
              [-52.97960364499994, 47.98712799700007],
              [-52.99844316299993, 47.97166575700004],
              [-53.03579667899993, 47.94839101800005],
              [-53.053578253999945, 47.93256256700005],
              [-53.06114661399994, 47.91364166900007],
              [-53.06090247299994, 47.88776276200008],
              [-53.06281490799995, 47.869574286000045],
              [-53.07066809799994, 47.85370514500005],
              [-53.08849036399994, 47.83445872600004],
              [-53.12572180899991, 47.80776601800005],
              [-53.14232337099992, 47.79096100500004],
              [-53.149281378999945, 47.76935455900008],
              [-53.15314693899995, 47.76414622600004],
              [-53.16197669199994, 47.75641510600008],
              [-53.17227128799993, 47.74945709800005],
              [-53.18028723899994, 47.74640534100007],
              [-53.18659420499995, 47.74526601800005],
              [-53.19635982999995, 47.74013906500005],
              [-53.20140540299991, 47.73895905200004],
              [-53.20738684799994, 47.73590729400007],
              [-53.20181230399993, 47.72955963700008],
              [-53.193348761999914, 47.72435130400004],
              [-53.19082597599993, 47.724676825000074],
              [-53.162953253999945, 47.718451239000046],
              [-53.17442786399994, 47.70502350500004],
              [-53.18399003799993, 47.69114817900004],
              [-53.17463131399995, 47.696478583000044],
              [-53.16661536399994, 47.69717031500005],
              [-53.16038977799991, 47.69293854400007],
              [-53.15611731699994, 47.68374258000006],
              [-53.17178300699993, 47.67475006700005],
              [-53.19469153599994, 47.64337799700007],
              [-53.21446692599994, 47.63654205900008],
              [-53.232411261999914, 47.63344961100006],
              [-53.25182044199994, 47.62539297100005],
              [-53.26207434799994, 47.61420319200005],
              [-53.25230872299994, 47.60175202000005],
              [-53.241444464999915, 47.60822174700007],
              [-53.23009192599994, 47.612616278000075],
              [-53.21792558499993, 47.61513906500005],
              [-53.20449785099993, 47.61603424700007],
              [-53.21776282499991, 47.605454820000034],
              [-53.24364173099991, 47.59259674700007],
              [-53.25230872299994, 47.581244208000044],
              [-53.23070227799991, 47.58258698100008],
              [-53.21051998599995, 47.58930084800005],
              [-53.17039954299992, 47.60919830900008],
              [-53.18260657499991, 47.593410549000055],
              [-53.20734615799995, 47.57762278900009],
              [-53.23485266799992, 47.565619208000044],
              [-53.25572669199994, 47.56077708500004],
              [-53.259755011999914, 47.55853913000004],
              [-53.25291907499991, 47.55365631700005],
              [-53.24058997299994, 47.54877350500004],
              [-53.22842363199993, 47.546535549000055],
              [-53.21703040299991, 47.54832591400009],
              [-53.18399003799993, 47.56077708500004],
              [-53.18224036399994, 47.523504950000074],
              [-53.18399003799993, 47.51239655200004],
              [-53.189523891999954, 47.50259023600006],
              [-53.19676673099991, 47.49396393400008],
              [-53.20287024599992, 47.48419830900008],
              [-53.20449785099993, 47.47138092700004],
              [-53.18993079299992, 47.48041413000004],
              [-53.17609615799995, 47.492173570000034],
              [-53.162668423999946, 47.50055573100008],
              [-53.149281378999945, 47.49941640800006],
              [-53.15298417899993, 47.490220445000034],
              [-53.15367591099994, 47.48627350500004],
              [-53.149281378999945, 47.478216864000046],
              [-53.181304490999935, 47.45209381700005],
              [-53.19522050699993, 47.43707916900007],
              [-53.18740800699993, 47.43048737200007],
              [-53.16738847599993, 47.434027411000045],
              [-53.15615800699993, 47.44049713700008],
              [-53.144195115999935, 47.44367096600007],
              [-53.121937628999945, 47.43724192900004],
              [-53.12718665299991, 47.421210028000075],
              [-53.12938391799992, 47.41681549700007],
              [-53.11375891799992, 47.430568752000056],
              [-53.078114386999914, 47.470038153000075],
              [-53.037953253999945, 47.484442450000074],
              [-52.97179114499994, 47.526678778000075],
              [-52.91173255099994, 47.556301174000055],
              [-52.89293372299994, 47.57103099200003],
              [-52.87637285099993, 47.58828359600005],
              [-52.86115475199995, 47.60838450700004],
              [-52.848947719999956, 47.62962474200003],
              [-52.84142005099994, 47.65013255400004],
              [-52.818470831999946, 47.74363841400009],
              [-52.79841061099995, 47.78815338700008],
              [-52.77253170499995, 47.80101146000004],
              [-52.76549231699994, 47.79559967700004],
              [-52.75690670499995, 47.77903880400004],
              [-52.752064581999946, 47.773098049000055],
              [-52.71051998599995, 47.76129791900007],
              [-52.70421301999994, 47.75600820500006],
              [-52.69741777299993, 47.71474844000005],
              [-52.70059160099993, 47.70286692900004],
              [-52.71792558499993, 47.67064036700003],
              [-52.70881100199995, 47.661810614000046],
              [-52.693023240999935, 47.66030508000006],
              [-52.66665605399993, 47.66380442900004],
              [-52.657541469999956, 47.660589911000045],
              [-52.65493730399993, 47.65216705900008],
              [-52.65664628799993, 47.603176174000055],
              [-52.66441809799994, 47.587103583000044],
              [-52.69058183499993, 47.553941148000035],
              [-52.67690995999993, 47.56077708500004],
              [-52.67202714799993, 47.54767487200007],
              [-52.65990149599992, 47.536810614000046],
              [-52.644195115999935, 47.529364325000074],
              [-52.62881425699993, 47.526678778000075],
            ],
          ],
          [
            [
              [-127.91869055899991, 51.52204010600008],
              [-127.90367591099994, 51.51430898600006],
              [-127.88829505099994, 51.495794989000046],
              [-127.87633216099994, 51.47418854400007],
              [-127.87149003799993, 51.45652903900009],
              [-127.87930253799993, 51.44220612200007],
              [-127.89753170499989, 51.429754950000074],
              [-127.91808020699995, 51.42129140800006],
              [-127.9329320949999, 51.41901276200008],
              [-127.94322669199994, 51.42243073100008],
              [-127.94945227799991, 51.42763906500005],
              [-127.95433508999992, 51.433579820000034],
              [-127.96084550699993, 51.439520575000074],
              [-127.98379472599993, 51.45111725500004],
              [-128.0076391269999, 51.467678127000056],
              [-128.01618404899995, 51.464829820000034],
              [-128.02700761599993, 51.458685614000046],
              [-128.0502823559999, 51.45994700700004],
              [-128.0685929029999, 51.46954987200007],
              [-128.08604895699995, 51.48688385600008],
              [-128.0991104809999, 51.508693752000056],
              [-128.1042374339999, 51.53164297100005],
              [-128.10912024599992, 51.54515208500004],
              [-128.1452530589999, 51.590277411000045],
              [-128.15660559799994, 51.62787506700005],
              [-128.13902747299994, 51.65802643400008],
              [-128.1043188139999, 51.68183014500005],
              [-128.0261938139999, 51.71979401200008],
              [-128.00987708199995, 51.72370026200008],
              [-127.98936926999994, 51.700384833000044],
              [-127.97655188699991, 51.68211497600004],
              [-127.97126217399995, 51.664048570000034],
              [-127.98135331899994, 51.65176015800006],
              [-127.95055091099994, 51.628892320000034],
              [-127.92031816299993, 51.596136786000045],
              [-127.90489661399994, 51.55874258000006],
              [-127.91869055899991, 51.52204010600008],
            ],
          ],
          [
            [
              [-55.35269120999993, 51.88450755400004],
              [-55.40965735599991, 51.882066148000035],
              [-55.427398240999935, 51.89134349200003],
              [-55.418527798999946, 51.91864655200004],
              [-55.38312740799995, 51.95962148600006],
              [-55.37450110599991, 51.963771877000056],
              [-55.344960089999915, 51.972316799000055],
              [-55.33226477799991, 51.973863023000035],
              [-55.31236731699994, 51.983710028000075],
              [-55.28726152299993, 52.00063711100006],
              [-55.27013098899994, 52.00560130400004],
              [-55.27391516799992, 51.980129299000055],
              [-55.286040818999936, 51.95954010600008],
              [-55.33238684799994, 51.89760976800005],
              [-55.35269120999993, 51.88450755400004],
            ],
          ],
          [
            [
              [-128.13833574099993, 51.86399974200003],
              [-128.1428930329999, 51.86424388200004],
              [-128.15660559799994, 51.858710028000075],
              [-128.16258704299992, 51.85716380400004],
              [-128.20563717399995, 51.85447825700004],
              [-128.23037675699993, 51.85602448100008],
              [-128.24819902299993, 51.86399974200003],
              [-128.2510473299999, 51.87592194200005],
              [-128.24461829299992, 51.891831773000035],
              [-128.23062089799993, 51.905910549000055],
              [-128.1960343089999, 51.916083075000074],
              [-128.19908606699994, 51.92572663000004],
              [-128.21719316299993, 51.94285716400009],
              [-128.2222387359999, 51.95416901200008],
              [-128.2189835279999, 51.96271393400008],
              [-128.2072647779999, 51.973863023000035],
              [-128.1777237619999, 52.01577383000006],
              [-128.1592504549999, 52.034816799000055],
              [-128.14183508999992, 52.04279205900008],
              [-128.1309301419999, 52.044907945000034],
              [-128.1072485019999, 52.054348049000055],
              [-128.09434973899994, 52.05646393400008],
              [-128.0662328769999, 52.055568752000056],
              [-127.9988500639999, 52.065659898000035],
              [-127.97044837099992, 52.06317780200004],
              [-127.9534399079999, 52.04901764500005],
              [-127.9597875639999, 52.01715729400007],
              [-127.96056067599994, 52.00234609600005],
              [-127.9534399079999, 51.987494208000044],
              [-127.96336829299992, 51.96938711100006],
              [-127.97817949099993, 51.93016185100004],
              [-127.98753821499992, 51.911810614000046],
              [-128.03600012899994, 51.84357330900008],
              [-128.02855383999992, 51.83673737200007],
              [-128.03600012899994, 51.82990143400008],
              [-128.02708899599992, 51.81781647300005],
              [-128.01695716099994, 51.80683014500005],
              [-128.0095922519999, 51.79547760600008],
              [-128.0092667309999, 51.782131252000056],
              [-128.0176488919999, 51.77216217700004],
              [-128.03258216099994, 51.76422760600008],
              [-128.06387285099993, 51.754787502000056],
              [-128.07510331899994, 51.76508209800005],
              [-128.09215247299994, 51.76129791900007],
              [-128.11294511599993, 51.75234609600005],
              [-128.13524329299992, 51.747300523000035],
              [-128.1399633449999, 51.75259023600006],
              [-128.13829505099994, 51.76386139500005],
              [-128.13438880099994, 51.774725653000075],
              [-128.13219153599994, 51.77871328300006],
              [-128.1289770169999, 51.78668854400007],
              [-128.12246660099993, 51.793036200000074],
              [-128.1175024079999, 51.80145905200004],
              [-128.11851966099994, 51.81622955900008],
              [-128.12218176999994, 51.823879299000055],
              [-128.13833574099993, 51.84357330900008],
              [-128.13760331899994, 51.846584377000056],
              [-128.13487708199995, 51.85130442900004],
              [-128.13390051999994, 51.85736725500004],
              [-128.13833574099993, 51.86399974200003],
            ],
          ],
          [
            [
              [-130.99665279899995, 52.11172109600005],
              [-130.9602758449999, 52.10431549700007],
              [-130.9507543609999, 52.094916083000044],
              [-130.9550675119999, 52.07689036700003],
              [-130.96690833199995, 52.06793854400007],
              [-130.98375403599994, 52.06663646000004],
              [-131.0171606109999, 52.06948476800005],
              [-131.04482988199993, 52.06159088700008],
              [-131.05455481699994, 52.06537506700005],
              [-131.06493079299992, 52.08372630400004],
              [-131.0713598299999, 52.060980536000045],
              [-131.05528723899994, 52.04669830900008],
              [-131.00967363199993, 52.028509833000044],
              [-130.9922582669999, 52.013373114000046],
              [-131.0015356109999, 52.01190827000005],
              [-131.02354895699995, 52.018784898000035],
              [-131.0444229809999, 52.028509833000044],
              [-131.0400284499999, 52.013739325000074],
              [-131.01748613199993, 51.995021877000056],
              [-131.00967363199993, 51.980129299000055],
              [-131.0444229809999, 51.973863023000035],
              [-131.0373429029999, 51.96784088700008],
              [-131.0319718089999, 51.96108633000006],
              [-131.02399654899995, 51.946600653000075],
              [-131.05068925699993, 51.953558661000045],
              [-131.07437089799993, 51.96942780200004],
              [-131.11270097599993, 52.00185781500005],
              [-131.09996497299994, 52.00991445500006],
              [-131.08975175699993, 52.021144924000055],
              [-131.08775794199994, 52.03107330900008],
              [-131.09972083199995, 52.03534577000005],
              [-131.1131078769999, 52.042181708000044],
              [-131.1175024079999, 52.05776601800005],
              [-131.11888587099992, 52.07501862200007],
              [-131.12816321499992, 52.098089911000045],
              [-131.12682044199994, 52.11155833500004],
              [-131.11392167899993, 52.145819403000075],
              [-131.10875403599994, 52.15403880400004],
              [-131.0987035799999, 52.15607330900008],
              [-131.07860266799992, 52.152044989000046],
              [-131.0673721999999, 52.15106842700004],
              [-131.06094316299993, 52.147365627000056],
              [-131.05996660099993, 52.140611070000034],
              [-131.06493079299992, 52.130926825000074],
              [-131.0408422519999, 52.11953359600005],
              [-131.0295304029999, 52.11676666900007],
              [-131.01683508999992, 52.10797760600008],
              [-131.00987708199995, 52.10602448100008],
              [-131.00633704299992, 52.10809967700004],
              [-131.0030004549999, 52.11107005400004],
              [-130.99665279899995, 52.11172109600005],
            ],
          ],
          [
            [
              [-127.9466039699999, 52.165716864000046],
              [-127.93797766799992, 52.16461823100008],
              [-127.91958574099993, 52.15997955900008],
              [-127.90933183499993, 52.15888092700004],
              [-127.9016820949999, 52.16128164300005],
              [-127.89622962099992, 52.16640859600005],
              [-127.8894750639999, 52.17096588700008],
              [-127.87767493399991, 52.171942450000074],
              [-127.88882402299993, 52.146185614000046],
              [-127.89488684799994, 52.13580963700008],
              [-127.91978919199994, 52.118801174000055],
              [-127.92735755099994, 52.109076239000046],
              [-127.93272864499994, 52.099310614000046],
              [-127.93980872299994, 52.089911200000074],
              [-127.96149654899995, 52.08283112200007],
              [-128.0143936839999, 52.091498114000046],
              [-128.03941809799994, 52.08030833500004],
              [-128.05247962099992, 52.07632070500006],
              [-128.0698949859999, 52.08026764500005],
              [-128.08649654899995, 52.08852773600006],
              [-128.09740149599992, 52.09739817900004],
              [-128.10602779899995, 52.11078522300005],
              [-128.1111547519999, 52.12787506700005],
              [-128.12165279899995, 52.141791083000044],
              [-128.12295488199993, 52.151678778000075],
              [-128.10655676999994, 52.15176015800006],
              [-128.0769750639999, 52.14520905200004],
              [-128.0672094389999, 52.148504950000074],
              [-128.0476781889999, 52.161810614000046],
              [-128.03600012899994, 52.165716864000046],
              [-127.9466039699999, 52.165716864000046],
            ],
          ],
          [
            [
              [-128.24819902299993, 52.02167389500005],
              [-128.25243079299992, 52.02773672100005],
              [-128.25283769399994, 52.03339264500005],
              [-128.2527563139999, 52.04002513200004],
              [-128.25511633999992, 52.04901764500005],
              [-128.27904212099992, 52.09076569200005],
              [-128.2963761059999, 52.10594310100004],
              [-128.29067949099993, 52.124701239000046],
              [-128.27749589799993, 52.14350006700005],
              [-128.2656143869999, 52.152044989000046],
              [-128.2639867829999, 52.15570709800005],
              [-128.25332597599993, 52.17328522300005],
              [-128.24819902299993, 52.179348049000055],
              [-128.24229895699995, 52.18390534100007],
              [-128.2365616529999, 52.18732330900008],
              [-128.22032630099994, 52.19358958500004],
              [-128.20152747299994, 52.19798411700003],
              [-128.18024654899995, 52.19989655200004],
              [-128.1602270169999, 52.198553778000075],
              [-128.1452530589999, 52.19358958500004],
              [-128.1526586579999, 52.18618398600006],
              [-128.15514075399994, 52.09430573100008],
              [-128.16258704299992, 52.07318756700005],
              [-128.16934160099993, 52.06818268400008],
              [-128.1863500639999, 52.061753648000035],
              [-128.1935929029999, 52.05646393400008],
              [-128.19815019399994, 52.048081773000035],
              [-128.20287024599992, 52.02879466400003],
              [-128.2072647779999, 52.02167389500005],
              [-128.21597245999993, 52.01780833500004],
              [-128.22813880099994, 52.01666901200008],
              [-128.24010169199994, 52.01797109600005],
              [-128.24819902299993, 52.02167389500005],
            ],
          ],
          [
            [
              [-128.22777258999992, 52.21283600500004],
              [-128.24840247299994, 52.207017320000034],
              [-128.26602128799993, 52.19757721600007],
              [-128.2783910799999, 52.184759833000044],
              [-128.2830297519999, 52.16876862200007],
              [-128.28624426999994, 52.16429271000004],
              [-128.3035375639999, 52.130926825000074],
              [-128.31362870999993, 52.13141510600008],
              [-128.32982337099992, 52.14785390800006],
              [-128.33667285699994, 52.116226501000085],
              [-128.32151689599993, 52.090447287000075],
              [-128.3397572909999, 52.07933600600006],
              [-128.3662059149999, 52.087849481000035],
              [-128.3842680599999, 52.09801539700004],
              [-128.36811667599994, 52.12156760400006],
              [-128.35784576299994, 52.144525215000044],
              [-128.37322863799994, 52.14953253400006],
              [-128.39457373699992, 52.15551355300005],
              [-128.40514882899993, 52.14240988600005],
              [-128.42242626799992, 52.12766143200008],
              [-128.4417119989999, 52.12275022000006],
              [-128.4546716189999, 52.13089671900008],
              [-128.4389913139999, 52.14251552400003],
              [-128.43006899699992, 52.154049376000046],
              [-128.47736873299993, 52.15138275600003],
              [-128.50535709899992, 52.15310074700005],
              [-128.5224419829999, 52.157551967000074],
              [-128.51797786499992, 52.174756495000054],
              [-128.48367329899992, 52.186625950000064],
              [-128.4715269099999, 52.20288538600005],
              [-128.4565441809999, 52.21086348500006],
              [-128.4553308319999, 52.22491164400009],
              [-128.44729822099993, 52.23800691100007],
              [-128.4090805159999, 52.23639149400009],
              [-128.3662003249999, 52.23476797100005],
              [-128.3444718089999, 52.24079010600008],
              [-128.2788793609999, 52.237209377000056],
              [-128.24657141799992, 52.22890859600005],
              [-128.22777258999992, 52.21283600500004],
            ],
          ],
          [
            [
              [-128.09740149599992, 52.24079010600008],
              [-128.11807206899994, 52.239447333000044],
              [-128.1376846999999, 52.24164459800005],
              [-128.1560766269999, 52.246975002000056],
              [-128.1731664699999, 52.255072333000044],
              [-128.10020911399994, 52.278509833000044],
              [-128.0803116529999, 52.292629299000055],
              [-128.0554906889999, 52.30345286700003],
              [-128.0203344389999, 52.30560944200005],
              [-127.98525956899994, 52.302069403000075],
              [-127.96084550699993, 52.29604726800005],
              [-127.93643144399994, 52.25104401200008],
              [-127.9329320949999, 52.23769765800006],
              [-127.92666581899994, 52.226548570000034],
              [-127.9148656889999, 52.214911200000074],
              [-127.90770423099991, 52.200873114000046],
              [-127.91551673099991, 52.18276601800005],
              [-127.93203691299993, 52.176214911000045],
              [-127.9546606109999, 52.17820872600004],
              [-127.99502519399994, 52.18618398600006],
              [-128.0447485019999, 52.180853583000044],
              [-128.0712784499999, 52.18231842700004],
              [-128.09121660099993, 52.19358958500004],
              [-128.0939835279999, 52.205145575000074],
              [-128.0866593089999, 52.216009833000044],
              [-128.0730688139999, 52.22402578300006],
              [-128.0335180329999, 52.23151276200008],
              [-128.02065995999993, 52.241115627000056],
              [-128.02163652299993, 52.25067780200004],
              [-128.03941809799994, 52.255072333000044],
              [-128.05431067599994, 52.25348541900007],
              [-128.07799231699994, 52.24506256700005],
              [-128.09740149599992, 52.24079010600008],
            ],
          ],
          [
            [
              [-127.24083411399994, 52.42641836100006],
              [-127.23574785099993, 52.40403880400004],
              [-127.24095618399991, 52.38377513200004],
              [-127.2376195949999, 52.36595286700003],
              [-127.20669511599993, 52.35065338700008],
              [-127.23802649599992, 52.312933661000045],
              [-127.27696692599994, 52.28937409100007],
              [-127.36436926999994, 52.26129791900007],
              [-127.36880449099993, 52.25844961100006],
              [-127.37389075399994, 52.25055573100008],
              [-127.37804114499994, 52.24823639500005],
              [-127.38756262899994, 52.24835846600007],
              [-127.4051000639999, 52.25429922100005],
              [-127.41283118399991, 52.255072333000044],
              [-127.45376542899993, 52.23769765800006],
              [-127.46288001199991, 52.222723700000074],
              [-127.48436438699991, 52.210191148000035],
              [-127.5288793609999, 52.19358958500004],
              [-127.54002844999991, 52.191473700000074],
              [-127.56651770699995, 52.18939850500004],
              [-127.57664954299992, 52.18618398600006],
              [-127.58482825399994, 52.17723216400003],
              [-127.5945531889999, 52.15615469000005],
              [-127.6009008449999, 52.152044989000046],
              [-127.62523352799991, 52.14834219000005],
              [-127.64224199099993, 52.13812897300005],
              [-127.69326738199993, 52.067613023000035],
              [-127.70571855399993, 52.043402411000045],
              [-127.70360266799992, 52.025091864000046],
              [-127.69810950399994, 52.00405508000006],
              [-127.7180883449999, 51.98822663000004],
              [-127.74718176999994, 51.97809479400007],
              [-127.7691137359999, 51.973863023000035],
              [-127.81981360599991, 51.97093333500004],
              [-127.83739173099991, 51.96702708500004],
              [-127.87287350199989, 51.954738674000055],
              [-127.8882543609999, 51.95343659100007],
              [-127.90217037699989, 51.96824778900003],
              [-127.8997289699999, 52.001613674000055],
              [-127.8782445949999, 52.08356354400007],
              [-127.87340247299994, 52.09292226800005],
              [-127.86465410099993, 52.10423411700003],
              [-127.85899817599994, 52.108303127000056],
              [-127.85334225199989, 52.10956452000005],
              [-127.84805253799993, 52.11155833500004],
              [-127.84357662699989, 52.11790599200003],
              [-127.84654700399994, 52.11871979400007],
              [-127.85098222599993, 52.14862702000005],
              [-127.84178626199991, 52.16811758000006],
              [-127.82022050699993, 52.19570547100005],
              [-127.79507402299993, 52.217678127000056],
              [-127.77529863199993, 52.220363674000055],
              [-127.75104732999989, 52.25018952000005],
              [-127.71271725199989, 52.25482819200005],
              [-127.67056230399993, 52.255072333000044],
              [-127.61896725199989, 52.280910549000055],
              [-127.57725989499994, 52.289943752000056],
              [-127.55190995999993, 52.30524323100008],
              [-127.54246985599991, 52.308254299000055],
              [-127.52204342399995, 52.30963776200008],
              [-127.51158606699994, 52.31289297100005],
              [-127.4988500639999, 52.32697174700007],
              [-127.47581946499992, 52.33624909100007],
              [-127.46446692599994, 52.35040924700007],
              [-127.4553930329999, 52.366400458000044],
              [-127.44692949099993, 52.37799713700008],
              [-127.43175208199995, 52.387152411000045],
              [-127.41454016799992, 52.392645575000074],
              [-127.31175696499992, 52.413275458000044],
              [-127.29548092399995, 52.419582424000055],
              [-127.27037512899994, 52.43537018400008],
              [-127.25877844999991, 52.43549225500004],
              [-127.24083411399994, 52.42641836100006],
            ],
          ],
          [
            [
              [-128.6182348299999, 52.45368073100008],
              [-128.61827551999994, 52.43512604400007],
              [-128.62047278599994, 52.42731354400007],
              [-128.62564042899993, 52.419582424000055],
              [-128.6127823559999, 52.377386786000045],
              [-128.62315833199995, 52.330145575000074],
              [-128.64830481699994, 52.28969961100006],
              [-128.67959550699993, 52.26813385600008],
              [-128.68639075399994, 52.28607819200005],
              [-128.71666419199994, 52.307806708000044],
              [-128.7280981109999, 52.322699286000045],
              [-128.72940019399994, 52.33270905200004],
              [-128.72695878799993, 52.35423411700003],
              [-128.7280981109999, 52.36432526200008],
              [-128.74852454299992, 52.371161200000074],
              [-128.74917558499993, 52.37592194200005],
              [-128.74767005099994, 52.38694896000004],
              [-128.74852454299992, 52.39166901200008],
              [-128.75641842399995, 52.40810781500005],
              [-128.76280676999994, 52.42853424700007],
              [-128.76382402299993, 52.44953034100007],
              [-128.7553604809999, 52.46735260600008],
              [-128.74111894399994, 52.47455475500004],
              [-128.7175186839999, 52.480902411000045],
              [-128.6728409499999, 52.48786041900007],
              [-128.6728409499999, 52.48094310100004],
              [-128.6772354809999, 52.47768789300005],
              [-128.6870824859999, 52.46735260600008],
              [-128.67784583199995, 52.46930573100008],
              [-128.6690160799999, 52.47223541900007],
              [-128.66071529899995, 52.47614166900007],
              [-128.65294348899994, 52.48094310100004],
              [-128.6323949859999, 52.46979401200008],
              [-128.62368730399993, 52.46308014500005],
              [-128.6182348299999, 52.45368073100008],
            ],
          ],
          [
            [
              [-128.56297766799992, 52.611395575000074],
              [-128.56607011599993, 52.62958405200004],
              [-128.5612686839999, 52.65224844000005],
              [-128.55064856699994, 52.66469961100006],
              [-128.53624426999994, 52.65228913000004],
              [-128.52513587099992, 52.59796784100007],
              [-128.47207597599993, 52.488267320000034],
              [-128.48473059799994, 52.44318268400008],
              [-128.4978735019999, 52.43634674700007],
              [-128.51602128799993, 52.43378327000005],
              [-128.53408769399994, 52.43593984600005],
              [-128.54678300699993, 52.44318268400008],
              [-128.56065833199995, 52.45331452000005],
              [-128.59292558499993, 52.46141185100004],
              [-128.61929277299993, 52.477850653000075],
              [-128.65054277299993, 52.49209219000005],
              [-128.6629125639999, 52.49461497600004],
              [-128.6787003249999, 52.500881252000056],
              [-128.6890356109999, 52.51227448100008],
              [-128.69888261599993, 52.51813385600008],
              [-128.71373450399994, 52.50771719000005],
              [-128.70181230399993, 52.49872467700004],
              [-128.70628821499992, 52.49095286700003],
              [-128.7197159499999, 52.488348700000074],
              [-128.73485266799992, 52.49461497600004],
              [-128.75723222599993, 52.490301825000074],
              [-128.77745520699995, 52.49990469000005],
              [-128.79698645699995, 52.513739325000074],
              [-128.8174535799999, 52.52195872600004],
              [-128.81187903599994, 52.540676174000055],
              [-128.80134029899995, 52.54702383000006],
              [-128.78673255099994, 52.54441966400003],
              [-128.7690323559999, 52.53620026200008],
              [-128.76012122299994, 52.53025950700004],
              [-128.75283769399994, 52.52391185100004],
              [-128.7451065749999, 52.518459377000056],
              [-128.73485266799992, 52.51512278900003],
              [-128.72704016799992, 52.51805247600004],
              [-128.72105872299994, 52.52513255400004],
              [-128.71324622299994, 52.52887604400007],
              [-128.70010331899994, 52.52195872600004],
              [-128.69391842399995, 52.52944570500006],
              [-128.70132402299993, 52.531683661000045],
              [-128.72118079299992, 52.54242584800005],
              [-128.7144262359999, 52.54637278900003],
              [-128.70759029899995, 52.549261786000045],
              [-128.71495520699995, 52.55215078300006],
              [-128.73204505099994, 52.55654531500005],
              [-128.7382706369999, 52.559800523000035],
              [-128.7405492829999, 52.566839911000045],
              [-128.73558508999992, 52.581366278000075],
              [-128.7382706369999, 52.584051825000074],
              [-128.74193274599992, 52.58616771000004],
              [-128.73888098899994, 52.59080638200004],
              [-128.73204505099994, 52.59552643400008],
              [-128.7246801419999, 52.597723700000074],
              [-128.5833227199999, 52.600490627000056],
              [-128.56297766799992, 52.611395575000074],
            ],
          ],
          [
            [
              [-131.56456458199995, 52.727443752000056],
              [-131.59170488199993, 52.72162506700005],
              [-131.65689042899993, 52.72162506700005],
              [-131.67442786399994, 52.70693594000005],
              [-131.6590063139999, 52.712958075000074],
              [-131.64464270699995, 52.71393463700008],
              [-131.63337154899995, 52.70795319200005],
              [-131.62730872299994, 52.69330475500004],
              [-131.6070043609999, 52.698472398000035],
              [-131.5546768869999, 52.700100002000056],
              [-131.54409745999993, 52.70380280200004],
              [-131.5339249339999, 52.71865469000005],
              [-131.5107315749999, 52.73004791900007],
              [-131.4854223299999, 52.735988674000055],
              [-131.4689835279999, 52.73427969000005],
              [-131.45299231699994, 52.71735260600008],
              [-131.44473222599993, 52.70270416900007],
              [-131.44692949099993, 52.68500397300005],
              [-131.46214758999992, 52.65912506700005],
              [-131.45274817599994, 52.64524974200003],
              [-131.46690833199995, 52.63613515800006],
              [-131.49063066299993, 52.63165924700007],
              [-131.5099991529999, 52.63182200700004],
              [-131.53111731699994, 52.63971588700008],
              [-131.57087154899995, 52.66156647300005],
              [-131.5925186839999, 52.66596100500004],
              [-131.5916235019999, 52.66128164300005],
              [-131.59044348899994, 52.66054922100005],
              [-131.58873450399994, 52.66083405200004],
              [-131.58633378799993, 52.65912506700005],
              [-131.59361731699994, 52.63882070500006],
              [-131.55455481699994, 52.61469147300005],
              [-131.5788468089999, 52.597723700000074],
              [-131.60204016799992, 52.59516022300005],
              [-131.6189672519999, 52.60565827000005],
              [-131.65396074099993, 52.64545319200005],
              [-131.64696204299992, 52.66461823100008],
              [-131.6956274079999, 52.70018138200004],
              [-131.70238196499992, 52.72125885600008],
              [-131.6790258449999, 52.73484935100004],
              [-131.63878333199995, 52.73712799700007],
              [-131.56456458199995, 52.727443752000056],
            ],
          ],
          [
            [
              [-128.3103735019999, 52.42942942900004],
              [-128.37857011599993, 52.37799713700008],
              [-128.40225175699993, 52.37396881700005],
              [-128.43862870999993, 52.374335028000075],
              [-128.46642005099994, 52.38271719000005],
              [-128.46422278599994, 52.40249258000006],
              [-128.44737708199995, 52.41453685100004],
              [-128.4272354809999, 52.425482489000046],
              [-128.41100012899994, 52.43939850500004],
              [-128.40587317599994, 52.46051666900007],
              [-128.3985082669999, 52.46735260600008],
              [-128.42495683499993, 52.487616278000075],
              [-128.43594316299993, 52.52643463700008],
              [-128.44005286399994, 52.611395575000074],
              [-128.44395911399994, 52.617621161000045],
              [-128.4499405589999, 52.62335846600007],
              [-128.4518936839999, 52.630926825000074],
              [-128.44347083199995, 52.64240143400008],
              [-128.43797766799992, 52.65253327000005],
              [-128.4416397779999, 52.672756252000056],
              [-128.43691972599993, 52.683661200000074],
              [-128.42613684799994, 52.700100002000056],
              [-128.42442786399994, 52.71515534100007],
              [-128.4314672519999, 52.72890859600005],
              [-128.44688880099994, 52.74103424700007],
              [-128.43521074099993, 52.76129791900007],
              [-128.41462154899995, 52.782416083000044],
              [-128.39126542899993, 52.796535549000055],
              [-128.37173417899993, 52.79572174700007],
              [-128.3601781889999, 52.75873444200005],
              [-128.35191809799994, 52.71747467700004],
              [-128.33315995999993, 52.69708893400008],
              [-128.3185929029999, 52.687567450000074],
              [-128.3183487619999, 52.67519765800006],
              [-128.32164466099994, 52.663275458000044],
              [-128.32396399599992, 52.65912506700005],
              [-128.31456458199995, 52.58820221600007],
              [-128.3068741529999, 52.57721588700008],
              [-128.30313066299993, 52.573472398000035],
              [-128.29991614499994, 52.56464264500005],
              [-128.2975968089999, 52.55426666900007],
              [-128.29531816299993, 52.53424713700008],
              [-128.28750566299993, 52.52130768400008],
              [-128.2830297519999, 52.50771719000005],
              [-128.2815649079999, 52.49823639500005],
              [-128.28172766799992, 52.488714911000045],
              [-128.28408769399994, 52.478501695000034],
              [-128.28921464799993, 52.46735260600008],
              [-128.30776933499993, 52.44017161700003],
              [-128.3103735019999, 52.42942942900004],
            ],
          ],
          [
            [
              [-128.93008378799993, 52.614447333000044],
              [-128.9248754549999, 52.60175202000005],
              [-128.9247940749999, 52.585598049000055],
              [-128.92666581899994, 52.569525458000044],
              [-128.92634029899995, 52.527777411000045],
              [-128.93248450399994, 52.49896881700005],
              [-128.94957434799994, 52.47329336100006],
              [-128.9812719389999, 52.45368073100008],
              [-128.98493404899995, 52.468085028000075],
              [-128.98648027299993, 52.48004791900007],
              [-128.9925024079999, 52.48737213700008],
              [-129.00918535099993, 52.48786041900007],
              [-129.00055904899995, 52.50413646000004],
              [-129.00365149599992, 52.52033112200007],
              [-129.01382402299993, 52.52985260600008],
              [-129.02627519399994, 52.52570221600007],
              [-129.04336503799993, 52.51752350500004],
              [-129.06017005099994, 52.52411530200004],
              [-129.07290605399993, 52.53925202000005],
              [-129.0781143869999, 52.556708075000074],
              [-129.1022843089999, 52.55365631700005],
              [-129.11925208199995, 52.56586334800005],
              [-129.12588456899994, 52.587103583000044],
              [-129.11904863199993, 52.611395575000074],
              [-129.15469316299993, 52.60488515800006],
              [-129.18415279899995, 52.626613674000055],
              [-129.22769120999993, 52.68024323100008],
              [-129.21983801999994, 52.68378327000005],
              [-129.21182206899994, 52.684759833000044],
              [-129.2033585279999, 52.68353913000004],
              [-129.19420325399994, 52.68024323100008],
              [-129.20885169199994, 52.69448476800005],
              [-129.25572669199994, 52.71401601800005],
              [-129.2761124339999, 52.727443752000056],
              [-129.26866614499994, 52.73427969000005],
              [-129.28551184799994, 52.75067780200004],
              [-129.2919815749999, 52.76264069200005],
              [-129.28677324099993, 52.77423737200007],
              [-129.26866614499994, 52.789496161000045],
              [-129.2814835279999, 52.81045156500005],
              [-129.27505449099993, 52.824652411000045],
              [-129.25698808499993, 52.82807038000004],
              [-129.18053137899994, 52.789496161000045],
              [-129.15176347599993, 52.76430898600006],
              [-129.1357315749999, 52.753159898000035],
              [-129.1017960279999, 52.743394273000035],
              [-129.08433997299994, 52.73143138200004],
              [-129.05699622299994, 52.70693594000005],
              [-128.9446508449999, 52.62799713700008],
              [-128.93008378799993, 52.614447333000044],
            ],
          ],
          [
            [
              [-128.3103735019999, 52.727443752000056],
              [-128.3206274079999, 52.743353583000044],
              [-128.3233129549999, 52.75071849200003],
              [-128.3240453769999, 52.775091864000046],
              [-128.3229874339999, 52.77875397300005],
              [-128.31729081899994, 52.77912018400008],
              [-128.2795304029999, 52.78725820500006],
              [-128.2350968089999, 52.78766510600008],
              [-128.21410071499992, 52.79572174700007],
              [-128.2065323559999, 52.80683014500005],
              [-128.19981848899994, 52.82143789300005],
              [-128.19005286399994, 52.830145575000074],
              [-128.1731664699999, 52.82363515800006],
              [-128.1740616529999, 52.813381252000056],
              [-128.17837480399993, 52.79539622600004],
              [-128.17935136599993, 52.78607819200005],
              [-128.1826879549999, 52.77553945500006],
              [-128.19713294199994, 52.75934479400007],
              [-128.2005102199999, 52.751613674000055],
              [-128.20620683499993, 52.727728583000044],
              [-128.2072647779999, 52.71747467700004],
              [-128.2105199859999, 52.706732489000046],
              [-128.22451738199993, 52.689439195000034],
              [-128.22777258999992, 52.683661200000074],
              [-128.22960364499994, 52.67845286700003],
              [-128.2385961579999, 52.66010163000004],
              [-128.25121008999992, 52.624212958000044],
              [-128.25511633999992, 52.61758047100005],
              [-128.2749731109999, 52.60252513200004],
              [-128.28766842399995, 52.60736725500004],
              [-128.2910863919999, 52.622748114000046],
              [-128.2830297519999, 52.63930898600006],
              [-128.2830297519999, 52.64545319200005],
              [-128.28697669199994, 52.64935944200005],
              [-128.2967016269999, 52.66596100500004],
              [-128.28848222599993, 52.68374258000006],
              [-128.2918188139999, 52.699652411000045],
              [-128.3103735019999, 52.727443752000056],
            ],
          ],
          [
            [
              [-128.53282630099994, 52.727443752000056],
              [-128.5312393869999, 52.73395416900007],
              [-128.5359594389999, 52.76642487200007],
              [-128.53282630099994, 52.778957424000055],
              [-128.52318274599992, 52.80182526200008],
              [-128.51036536399994, 52.86277903900003],
              [-128.50210527299993, 52.87201569200005],
              [-128.48493404899995, 52.86546458500004],
              [-128.4733780589999, 52.853583075000074],
              [-128.46593176999994, 52.83869049700007],
              [-128.45767167899993, 52.809475002000056],
              [-128.45555579299992, 52.789048570000034],
              [-128.4611710279999, 52.775824286000045],
              [-128.48102779899995, 52.78266022300005],
              [-128.47765051999994, 52.70661041900007],
              [-128.48473059799994, 52.69017161700003],
              [-128.50169837099992, 52.66941966400003],
              [-128.50987708199995, 52.65387604400007],
              [-128.51671301999994, 52.653957424000055],
              [-128.52940833199995, 52.68024323100008],
              [-128.52196204299992, 52.68707916900007],
              [-128.5305883449999, 52.69481028900003],
              [-128.53954016799992, 52.70848216400003],
              [-128.54238847599993, 52.72162506700005],
              [-128.53282630099994, 52.727443752000056],
            ],
          ],
          [
            [
              [-129.55728105399993, 53.001166083000044],
              [-129.54971269399994, 52.989569403000075],
              [-129.5361221999999, 52.97606028900003],
              [-129.52977454299992, 52.964911200000074],
              [-129.54360917899993, 52.960150458000044],
              [-129.55850175699993, 52.96442291900007],
              [-129.5789281889999, 52.98094310100004],
              [-129.5920304029999, 52.98187897300005],
              [-129.6093643869999, 52.96165599200003],
              [-129.62051347599993, 52.958197333000044],
              [-129.62926184799994, 52.992254950000074],
              [-129.6472875639999, 53.01044342700004],
              [-129.65347245999993, 53.02220286700003],
              [-129.5987035799999, 53.02521393400008],
              [-129.5720922519999, 53.01972077000005],
              [-129.55728105399993, 53.001166083000044],
            ],
          ],
          [
            [
              [-129.56407630099994, 53.056341864000046],
              [-129.54385331899994, 53.03974030200004],
              [-129.53286699099993, 53.035223700000074],
              [-129.51573645699995, 53.03587474200003],
              [-129.51968339799993, 53.026597398000035],
              [-129.5261938139999, 53.019191799000055],
              [-129.53441321499992, 53.01325104400007],
              [-129.54360917899993, 53.00861237200007],
              [-129.54857337099992, 53.016913153000075],
              [-129.5546768869999, 53.02480703300006],
              [-129.56191972599993, 53.03139883000006],
              [-129.5703018869999, 53.03587474200003],
              [-129.5823461579999, 53.03803131700005],
              [-129.5878800119999, 53.03510163000004],
              [-129.5925186839999, 53.03070709800005],
              [-129.60167395699995, 53.02846914300005],
              [-129.60875403599994, 53.03070709800005],
              [-129.62999426999994, 53.04193756700005],
              [-129.63609778599994, 53.04645416900007],
              [-129.6458227199999, 53.05170319200005],
              [-129.6753637359999, 53.05776601800005],
              [-129.68761145699995, 53.06386953300006],
              [-129.67052161399994, 53.06427643400008],
              [-129.6187231109999, 53.056341864000046],
              [-129.57469641799992, 53.05963776200008],
              [-129.56407630099994, 53.056341864000046],
            ],
          ],
          [
            [
              [-129.65347245999993, 53.132066148000035],
              [-129.62759355399993, 53.11766185100004],
              [-129.5989477199999, 53.09357330900008],
              [-129.5888565749999, 53.07176341400003],
              [-129.6187231109999, 53.06386953300006],
              [-129.6612035799999, 53.06989166900007],
              [-129.6935929029999, 53.083197333000044],
              [-129.71959387899994, 53.10390859600005],
              [-129.7429093089999, 53.132066148000035],
              [-129.7219945949999, 53.13694896000004],
              [-129.69395911399994, 53.13886139500005],
              [-129.66808020699995, 53.13735586100006],
              [-129.65347245999993, 53.132066148000035],
            ],
          ],
          [
            [
              [-129.30406653599994, 53.03587474200003],
              [-129.29234778599994, 53.00055573100008],
              [-129.29112708199995, 52.98232656500005],
              [-129.3003637359999, 52.97443268400008],
              [-129.3244522779999, 52.971869208000044],
              [-129.3379613919999, 52.97260163000004],
              [-129.3726293609999, 52.99266185100004],
              [-129.37539628799993, 52.99494049700007],
              [-129.39492753799993, 53.00039297100005],
              [-129.4084366529999, 53.013373114000046],
              [-129.42690995999993, 53.042669989000046],
              [-129.44395911399994, 53.05914948100008],
              [-129.45958411399994, 53.07025788000004],
              [-129.4709366529999, 53.08222077000005],
              [-129.4753311839999, 53.10106028900003],
              [-129.47960364499994, 53.11204661700003],
              [-129.4892471999999, 53.10952383000006],
              [-129.50576738199993, 53.097357489000046],
              [-129.51537024599992, 53.10024648600006],
              [-129.51626542899993, 53.10683828300006],
              [-129.51113847599993, 53.11391836100006],
              [-129.5026749339999, 53.118475653000075],
              [-129.5154516269999, 53.130113023000035],
              [-129.5359594389999, 53.13458893400008],
              [-129.5517471999999, 53.14288971600007],
              [-129.55044511599993, 53.16620514500005],
              [-129.53408769399994, 53.184759833000044],
              [-129.5098363919999, 53.19171784100007],
              [-129.48350989499994, 53.19098541900007],
              [-129.46108964799993, 53.186712958000044],
              [-129.4566137359999, 53.16950104400007],
              [-129.4433487619999, 53.15721263200004],
              [-129.41392981699994, 53.138332424000055],
              [-129.3623754549999, 53.08026764500005],
              [-129.34585527299993, 53.06793854400007],
              [-129.32974199099993, 53.061428127000056],
              [-129.31529700399994, 53.05329010600008],
              [-129.30406653599994, 53.03587474200003],
            ],
          ],
          [
            [
              [-131.11270097599993, 52.171942450000074],
              [-131.1230362619999, 52.18463776200008],
              [-131.12389075399994, 52.198431708000044],
              [-131.12779700399994, 52.20913320500006],
              [-131.1475317049999, 52.21283600500004],
              [-131.14049231699994, 52.17690664300005],
              [-131.15208899599992, 52.14240143400008],
              [-131.17495683499993, 52.12449778900003],
              [-131.20152747299994, 52.138373114000046],
              [-131.20791581899994, 52.15346914300005],
              [-131.21149654899995, 52.186835028000075],
              [-131.21572831899994, 52.19977448100008],
              [-131.22667395699995, 52.21112702000005],
              [-131.2429906889999, 52.22284577000005],
              [-131.27721106699994, 52.24079010600008],
              [-131.24278723899994, 52.17047760600008],
              [-131.23717200399994, 52.136053778000075],
              [-131.26292883999992, 52.124701239000046],
              [-131.27969316299993, 52.13239166900007],
              [-131.29283606699994, 52.14720286700003],
              [-131.30142167899993, 52.163397528000075],
              [-131.3045141269999, 52.17560455900008],
              [-131.31041419199994, 52.19013092700004],
              [-131.33751380099994, 52.216050523000035],
              [-131.3455297519999, 52.23456452000005],
              [-131.3522843089999, 52.23456452000005],
              [-131.35659745999993, 52.200384833000044],
              [-131.38003495999993, 52.20294830900008],
              [-131.40941321499992, 52.223863023000035],
              [-131.43175208199995, 52.24453359600005],
              [-131.44131425699993, 52.25796133000006],
              [-131.4492895169999, 52.272650458000044],
              [-131.45864824099993, 52.284369208000044],
              [-131.4890844389999, 52.29409414300005],
              [-131.4990128249999, 52.30560944200005],
              [-131.50698808499993, 52.319240627000056],
              [-131.51744544199994, 52.33022695500006],
              [-131.5269262359999, 52.32396067900004],
              [-131.53750566299993, 52.322699286000045],
              [-131.5483292309999, 52.32514069200005],
              [-131.5584203769999, 52.33022695500006],
              [-131.5467016269999, 52.343451239000046],
              [-131.5379125639999, 52.35809967700004],
              [-131.55703691299993, 52.35179271000004],
              [-131.56753495999993, 52.35097890800006],
              [-131.57542883999992, 52.354396877000056],
              [-131.57408606699994, 52.35736725500004],
              [-131.58360755099994, 52.38499583500004],
              [-131.58633378799993, 52.38857656500005],
              [-131.5749405589999, 52.40330638200004],
              [-131.5490616529999, 52.403998114000046],
              [-131.5209854809999, 52.397691148000035],
              [-131.50316321499992, 52.39166901200008],
              [-131.51158606699994, 52.40851471600007],
              [-131.52920488199993, 52.42137278900003],
              [-131.55020097599993, 52.42963288000004],
              [-131.5683487619999, 52.43256256700005],
              [-131.58096269399994, 52.429754950000074],
              [-131.59239661399994, 52.42475006700005],
              [-131.6037491529999, 52.42291901200008],
              [-131.61636308499993, 52.42942942900004],
              [-131.64268958199995, 52.45465729400007],
              [-131.64712480399993, 52.457098700000074],
              [-131.6577856109999, 52.477850653000075],
              [-131.68285071499992, 52.48969147300005],
              [-131.7359106109999, 52.50153229400007],
              [-131.76097571499992, 52.51166413000004],
              [-131.8826391269999, 52.576157945000034],
              [-131.8972875639999, 52.58746979400007],
              [-131.9002172519999, 52.59707265800006],
              [-131.9002172519999, 52.60956452000005],
              [-131.90225175699993, 52.620347398000035],
              [-131.91124426999994, 52.624986070000034],
              [-131.9251195949999, 52.62604401200008],
              [-131.9297582669999, 52.62962474200003],
              [-131.92833411399994, 52.648871161000045],
              [-131.9392797519999, 52.65119049700007],
              [-132.01024329299992, 52.68024323100008],
              [-132.0860082669999, 52.73427969000005],
              [-132.0601293609999, 52.75934479400007],
              [-132.0452367829999, 52.764960028000075],
              [-132.02391516799992, 52.762152411000045],
              [-132.01113847599993, 52.756293036000045],
              [-131.96930904899995, 52.727443752000056],
              [-131.96304277299993, 52.73427969000005],
              [-132.00157630099994, 52.766791083000044],
              [-132.0170792309999, 52.77521393400008],
              [-132.00401770699995, 52.78266022300005],
              [-131.96304277299993, 52.75470612200007],
              [-131.94517981699994, 52.739569403000075],
              [-131.9343969389999, 52.73216380400004],
              [-131.9221085279999, 52.727443752000056],
              [-131.9260961579999, 52.73501211100006],
              [-131.93028723899994, 52.74091217700004],
              [-131.93517005099994, 52.745347398000035],
              [-131.94131425699993, 52.748480536000045],
              [-131.94131425699993, 52.75470612200007],
              [-131.9387914699999, 52.773138739000046],
              [-131.96255449099993, 52.78693268400008],
              [-132.0170792309999, 52.803168036000045],
              [-132.03628495999993, 52.81696198100008],
              [-132.06501217399995, 52.85000234600005],
              [-132.0860082669999, 52.85773346600007],
              [-132.0663956369999, 52.82172272300005],
              [-132.0605362619999, 52.80345286700003],
              [-132.06891842399995, 52.79572174700007],
              [-132.0900772779999, 52.78790924700007],
              [-132.11025956899994, 52.757147528000075],
              [-132.1337784499999, 52.75470612200007],
              [-132.1420792309999, 52.75918203300006],
              [-132.1753637359999, 52.78266022300005],
              [-132.17686926999994, 52.78506094000005],
              [-132.18053137899994, 52.793402411000045],
              [-132.18219967399995, 52.79572174700007],
              [-132.18956458199995, 52.798529364000046],
              [-132.20669511599993, 52.80292389500005],
              [-132.2128800119999, 52.80621979400007],
              [-132.22630774599992, 52.818019924000055],
              [-132.24010169199994, 52.834051825000074],
              [-132.2429093089999, 52.850816148000035],
              [-132.22313391799992, 52.864569403000075],
              [-132.2888891269999, 52.88300202000005],
              [-132.30846106699994, 52.89594147300005],
              [-132.32677161399994, 52.913275458000044],
              [-132.33433997299994, 52.92259349200003],
              [-132.34227454299992, 52.94245026200008],
              [-132.33853105399993, 52.94310130400004],
              [-132.32925370999993, 52.95026276200008],
              [-132.3173721999999, 52.954413153000075],
              [-132.2891332669999, 52.94904205900008],
              [-132.28087317599994, 52.95026276200008],
              [-132.27159583199995, 52.956284898000035],
              [-132.2598363919999, 52.95774974200003],
              [-132.2475479809999, 52.95648834800005],
              [-132.23680579299992, 52.954006252000056],
              [-132.1992895169999, 52.93244049700007],
              [-132.1804093089999, 52.92731354400007],
              [-132.16787675699993, 52.940334377000056],
              [-132.17955481699994, 52.94330475500004],
              [-132.1894425119999, 52.94871653900003],
              [-132.19713294199994, 52.956732489000046],
              [-132.20201575399994, 52.96759674700007],
              [-132.1406143869999, 52.93349844000005],
              [-132.14175370999993, 52.94293854400007],
              [-132.1454971999999, 52.950425523000035],
              [-132.15196692599994, 52.95620351800005],
              [-132.16104081899994, 52.960150458000044],
              [-132.16104081899994, 52.96759674700007],
              [-132.1475317049999, 52.97125885600008],
              [-132.13027910099993, 52.97996653900003],
              [-132.1166886059999, 52.99091217700004],
              [-132.11388098899994, 53.001166083000044],
              [-132.1291397779999, 53.00641510600008],
              [-132.18024654899995, 52.99852122600004],
              [-132.19888261599993, 53.00486888200004],
              [-132.23102779899995, 53.02635325700004],
              [-132.26895097599993, 53.03070709800005],
              [-132.3466690749999, 53.02846914300005],
              [-132.34235592399995, 53.03864166900007],
              [-132.33922278599994, 53.042669989000046],
              [-132.3564346999999, 53.03896719000005],
              [-132.39313717399995, 53.03497955900008],
              [-132.40811113199993, 53.02846914300005],
              [-132.42052161399994, 53.04279205900008],
              [-132.43618730399993, 53.04116445500006],
              [-132.45327714799993, 53.033270575000074],
              [-132.4695531889999, 53.02846914300005],
              [-132.48884029899995, 53.031683661000045],
              [-132.50438391799992, 53.04043203300006],
              [-132.50942949099993, 53.05365631700005],
              [-132.49746660099993, 53.070013739000046],
              [-132.5169164699999, 53.07485586100006],
              [-132.53799394399994, 53.08685944200005],
              [-132.55162512899994, 53.09910716400003],
              [-132.5484106109999, 53.104803778000075],
              [-132.53258216099994, 53.109808661000045],
              [-132.5393774079999, 53.121527411000045],
              [-132.56578528599994, 53.145738023000035],
              [-132.54210364499994, 53.152044989000046],
              [-132.5144750639999, 53.146470445000034],
              [-132.48595130099994, 53.13703034100007],
              [-132.45958411399994, 53.132066148000035],
              [-132.3731176419999, 53.13271719000005],
              [-132.3466690749999, 53.138332424000055],
              [-132.33901933499993, 53.14240143400008],
              [-132.3220922519999, 53.15468984600005],
              [-132.31187903599994, 53.159409898000035],
              [-132.29507402299993, 53.16120026200008],
              [-132.24673417899993, 53.15192291900007],
              [-132.0655004549999, 53.16128164300005],
              [-132.05117753799993, 53.169989325000074],
              [-132.0403539699999, 53.18260325700004],
              [-131.97671464799993, 53.21466705900008],
              [-131.9717504549999, 53.215277411000045],
              [-131.96056067599994, 53.21385325700004],
              [-131.95563717399995, 53.21466705900008],
              [-131.9511612619999, 53.21784088700008],
              [-131.94131425699993, 53.22833893400008],
              [-131.90396074099993, 53.24070872600004],
              [-131.83922278599994, 53.24192942900004],
              [-131.82896887899994, 53.245428778000075],
              [-131.81993567599994, 53.25226471600007],
              [-131.81029212099992, 53.25739166900007],
              [-131.79796301999994, 53.25560130400004],
              [-131.79409745999993, 53.25214264500005],
              [-131.7654516269999, 53.19879791900007],
              [-131.76431230399993, 53.181708075000074],
              [-131.78429114499994, 53.17373281500005],
              [-131.78429114499994, 53.16620514500005],
              [-131.71963456899994, 53.15298086100006],
              [-131.70238196499992, 53.145738023000035],
              [-131.69908606699994, 53.14134349200003],
              [-131.68919837099992, 53.12482330900008],
              [-131.6818741529999, 53.118475653000075],
              [-131.67125403599994, 53.115668036000045],
              [-131.6511124339999, 53.11595286700003],
              [-131.6409399079999, 53.111029364000046],
              [-131.63442949099993, 53.10138580900008],
              [-131.61302649599992, 53.056341864000046],
              [-131.6050512359999, 53.04938385600008],
              [-131.5972387359999, 53.04547760600008],
              [-131.59557044199994, 53.04193756700005],
              [-131.6061905589999, 53.03587474200003],
              [-131.6179906889999, 53.03339264500005],
              [-131.6303604809999, 53.03489817900004],
              [-131.64171301999994, 53.03953685100004],
              [-131.65054277299993, 53.04645416900007],
              [-131.66905676999994, 53.05487702000005],
              [-131.72109941299993, 53.05548737200007],
              [-131.74303137899994, 53.06012604400007],
              [-131.7632543609999, 53.06854889500005],
              [-131.7841690749999, 53.07367584800005],
              [-131.82900956899994, 53.07684967700004],
              [-131.8466690749999, 53.07485586100006],
              [-131.88532467399995, 53.06586334800005],
              [-131.9041235019999, 53.06386953300006],
              [-132.00401770699995, 53.06386953300006],
              [-131.99132239499994, 53.054388739000046],
              [-131.9501846999999, 53.04677969000005],
              [-131.94131425699993, 53.03929271000004],
              [-131.94033769399994, 53.02244700700004],
              [-131.9370824859999, 53.009100653000075],
              [-131.93106035099993, 52.99795156500005],
              [-131.9221085279999, 52.987494208000044],
              [-131.90615800699993, 53.01504140800006],
              [-131.9003800119999, 53.02220286700003],
              [-131.89000403599994, 53.029364325000074],
              [-131.8650610019999, 53.04018789300005],
              [-131.85631262899994, 53.04645416900007],
              [-131.8366593089999, 53.05027903900003],
              [-131.75015214799993, 53.02220286700003],
              [-131.6804093089999, 53.01251862200007],
              [-131.6503800119999, 53.003159898000035],
              [-131.63719641799992, 53.001166083000044],
              [-131.62621008999992, 52.998114325000074],
              [-131.6084692049999, 52.98493073100008],
              [-131.60277258999992, 52.98187897300005],
              [-131.59512285099993, 52.976548570000034],
              [-131.6028539699999, 52.96539948100008],
              [-131.61465410099993, 52.95538971600007],
              [-131.61978105399993, 52.954006252000056],
              [-131.62730872299994, 52.940334377000056],
              [-131.62344316299993, 52.94159577000005],
              [-131.6182348299999, 52.93821849200003],
              [-131.61388098899994, 52.932521877000056],
              [-131.61302649599992, 52.926662502000056],
              [-131.61888587099992, 52.92023346600007],
              [-131.64171301999994, 52.90802643400008],
              [-131.67446855399993, 52.883978583000044],
              [-131.69469153599994, 52.87685781500005],
              [-131.80003821499992, 52.87482330900008],
              [-131.82079016799992, 52.878973700000074],
              [-131.84264075399994, 52.89594147300005],
              [-131.85985266799992, 52.91474030200004],
              [-131.87755286399994, 52.93032461100006],
              [-131.89761308499993, 52.93984609600005],
              [-131.9221085279999, 52.940334377000056],
              [-131.93618730399993, 52.93829987200007],
              [-131.94155839799993, 52.936835028000075],
              [-131.9488012359999, 52.93349844000005],
              [-131.93834387899994, 52.92755768400008],
              [-131.92540442599994, 52.92206452000005],
              [-131.9104711579999, 52.91864655200004],
              [-131.89415442599994, 52.919175523000035],
              [-131.89415442599994, 52.91303131700005],
              [-131.98355058499993, 52.88507721600007],
              [-131.98355058499993, 52.878241278000075],
              [-131.95230058499993, 52.88068268400008],
              [-131.92564856699994, 52.88971588700008],
              [-131.90050208199995, 52.89472077000005],
              [-131.87368730399993, 52.88507721600007],
              [-131.86095130099994, 52.87881094000005],
              [-131.85631262899994, 52.87514883000006],
              [-131.85240637899994, 52.867173570000034],
              [-131.85659745999993, 52.86237213700008],
              [-131.86685136599993, 52.85773346600007],
              [-131.86953691299993, 52.85130442900004],
              [-131.87417558499993, 52.846991278000075],
              [-131.87857011599993, 52.84369538000004],
              [-131.88052324099993, 52.840725002000056],
              [-131.8776749339999, 52.83079661700003],
              [-131.87096106699994, 52.831284898000035],
              [-131.86290442599994, 52.83478424700007],
              [-131.85631262899994, 52.83388906500005],
              [-131.83649654899995, 52.80719635600008],
              [-131.82900956899994, 52.803168036000045],
              [-131.70238196499992, 52.803168036000045],
              [-131.67251542899993, 52.80727773600006],
              [-131.6608780589999, 52.80573151200008],
              [-131.65396074099993, 52.79572174700007],
              [-131.68919837099992, 52.79083893400008],
              [-131.7314346999999, 52.78969961100006],
              [-131.7710668609999, 52.783270575000074],
              [-131.79796301999994, 52.762152411000045],
              [-131.81102454299992, 52.77065664300005],
              [-131.82433020699995, 52.77317942900004],
              [-131.83828691299993, 52.77179596600007],
              [-131.85317949099993, 52.76837799700007],
              [-131.8396703769999, 52.76797109600005],
              [-131.82738196499992, 52.76471588700008],
              [-131.80479895699995, 52.75470612200007],
              [-131.8335668609999, 52.72614166900007],
              [-131.83950761599993, 52.713771877000056],
              [-131.7819718089999, 52.71735260600008],
              [-131.75597083199995, 52.714056708000044],
              [-131.72964433499993, 52.70066966400003],
              [-131.7109268869999, 52.68158600500004],
              [-131.6923721999999, 52.65412018400008],
              [-131.6873266269999, 52.63100820500006],
              [-131.7092179029999, 52.624986070000034],
              [-131.6922094389999, 52.613714911000045],
              [-131.6591690749999, 52.58344147300005],
              [-131.64028886599993, 52.57721588700008],
              [-131.62047278599994, 52.57318756700005],
              [-131.6252335279999, 52.56435781500005],
              [-131.6426488919999, 52.55487702000005],
              [-131.66079667899993, 52.549261786000045],
              [-131.66079667899993, 52.54242584800005],
              [-131.65196692599994, 52.53937409100007],
              [-131.64297441299993, 52.53742096600007],
              [-131.62360592399995, 52.53620026200008],
              [-131.6155492829999, 52.53294505400004],
              [-131.6106664699999, 52.52570221600007],
              [-131.6045629549999, 52.518459377000056],
              [-131.5925186839999, 52.51512278900003],
              [-131.57982337099992, 52.52045319200005],
              [-131.5685929029999, 52.530585028000075],
              [-131.5556534499999, 52.53656647300005],
              [-131.5379125639999, 52.52944570500006],
              [-131.5398656889999, 52.51312897300005],
              [-131.51988684799994, 52.507798570000034],
              [-131.4689835279999, 52.50771719000005],
              [-131.48306230399993, 52.48517487200007],
              [-131.46410071499992, 52.47333405200004],
              [-131.43399003799993, 52.46515534100007],
              [-131.4143774079999, 52.45368073100008],
              [-131.44326738199993, 52.40639883000006],
              [-131.4485570949999, 52.39166901200008],
              [-131.42345130099994, 52.39398834800005],
              [-131.3977758449999, 52.38979726800005],
              [-131.38719641799992, 52.378119208000044],
              [-131.40758216099994, 52.35809967700004],
              [-131.3916723299999, 52.35960521000004],
              [-131.37857011599993, 52.36615631700005],
              [-131.36611894399994, 52.37010325700004],
              [-131.3522843089999, 52.36432526200008],
              [-131.35244706899994, 52.38515859600005],
              [-131.35521399599992, 52.39988841400003],
              [-131.35484778599994, 52.41242096600007],
              [-131.3455297519999, 52.42641836100006],
              [-131.3303930329999, 52.43398672100005],
              [-131.28917395699995, 52.43773021000004],
              [-131.24844316299993, 52.446926174000055],
              [-131.2415258449999, 52.435248114000046],
              [-131.24791419199994, 52.41982656500005],
              [-131.28307044199994, 52.40696849200003],
              [-131.29625403599994, 52.39398834800005],
              [-131.30410722599993, 52.37645091400003],
              [-131.3045141269999, 52.35809967700004],
              [-131.29360917899993, 52.366888739000046],
              [-131.2810766269999, 52.37059153900003],
              [-131.24990800699993, 52.371161200000074],
              [-131.25450598899994, 52.35529205900008],
              [-131.2627660799999, 52.35097890800006],
              [-131.2732641269999, 52.35171133000006],
              [-131.2846573559999, 52.35065338700008],
              [-131.30703691299993, 52.343085028000075],
              [-131.3155004549999, 52.33852773600006],
              [-131.32559160099993, 52.33022695500006],
              [-131.33263098899994, 52.34442780200004],
              [-131.3406469389999, 52.35443756700005],
              [-131.34972083199995, 52.355902411000045],
              [-131.35973059799994, 52.34442780200004],
              [-131.34439042899993, 52.33543528900003],
              [-131.33218339799993, 52.29718659100007],
              [-131.3181860019999, 52.28180573100008],
              [-131.30190995999993, 52.29364655200004],
              [-131.2429093089999, 52.262152411000045],
              [-131.21572831899994, 52.26129791900007],
              [-131.2481176419999, 52.27838776200008],
              [-131.26024329299992, 52.28974030200004],
              [-131.25674394399994, 52.30345286700003],
              [-131.2493383449999, 52.30573151200008],
              [-131.24010169199994, 52.302720445000034],
              [-131.22569739499994, 52.29604726800005],
              [-131.19810950399994, 52.31305573100008],
              [-131.18415279899995, 52.318426825000074],
              [-131.16250566299993, 52.31976959800005],
              [-131.1425675119999, 52.31622955900008],
              [-131.1338598299999, 52.30658600500004],
              [-131.12808183499993, 52.296210028000075],
              [-131.0984594389999, 52.287990627000056],
              [-131.0854386059999, 52.27558014500005],
              [-131.09947669199994, 52.25608958500004],
              [-131.12515214799993, 52.24974192900004],
              [-131.15493730399993, 52.247748114000046],
              [-131.18101966099994, 52.24079010600008],
              [-131.18101966099994, 52.23456452000005],
              [-131.12608801999994, 52.23452383000006],
              [-131.1004125639999, 52.230454820000034],
              [-131.07860266799992, 52.220363674000055],
              [-131.0437719389999, 52.23297760600008],
              [-131.02391516799992, 52.23529694200005],
              [-131.00967363199993, 52.22711823100008],
              [-131.0081274079999, 52.212225653000075],
              [-131.0156143869999, 52.19525788000004],
              [-131.02708899599992, 52.18036530200004],
              [-131.03766842399995, 52.171942450000074],
              [-131.0522354809999, 52.169134833000044],
              [-131.0984594389999, 52.16901276200008],
              [-131.11270097599993, 52.171942450000074],
            ],
          ],
          [
            [
              [-128.8037817049999, 52.70066966400003],
              [-128.82579505099994, 52.67161692900004],
              [-128.8564346999999, 52.65900299700007],
              [-128.89146887899994, 52.660223700000074],
              [-128.9273168609999, 52.67279694200005],
              [-129.01724199099993, 52.71576569200005],
              [-129.0445043609999, 52.73452383000006],
              [-129.05699622299994, 52.74103424700007],
              [-129.0515844389999, 52.74510325700004],
              [-129.04735266799992, 52.74896881700005],
              [-129.04283606699994, 52.75234609600005],
              [-129.03648841099994, 52.75470612200007],
              [-129.03648841099994, 52.762152411000045],
              [-129.06297766799992, 52.76829661700003],
              [-129.07725989499994, 52.77830638200004],
              [-129.10167395699995, 52.80621979400007],
              [-129.11074785099993, 52.82013580900008],
              [-129.12120520699995, 52.84454987200007],
              [-129.12539628799993, 52.86786530200004],
              [-129.11534583199995, 52.878241278000075],
              [-129.0927628249999, 52.87567780200004],
              [-129.02969316299993, 52.85773346600007],
              [-129.01683508999992, 52.85932038000004],
              [-129.0275772779999, 52.868841864000046],
              [-129.07066809799994, 52.89252350500004],
              [-129.03648841099994, 52.905585028000075],
              [-129.00548255099994, 52.926662502000056],
              [-128.98867753799993, 52.93378327000005],
              [-128.9651586579999, 52.96588776200008],
              [-128.94713294199994, 52.97443268400008],
              [-128.94774329299992, 52.99896881700005],
              [-128.91397050699993, 53.01675039300005],
              [-128.8379613919999, 53.03587474200003],
              [-128.85167395699995, 53.05158112200007],
              [-128.87734941299993, 53.07200755400004],
              [-128.90542558499993, 53.08974844000005],
              [-128.9338272779999, 53.10016510600008],
              [-128.96080481699994, 53.118475653000075],
              [-129.0154516269999, 53.145738023000035],
              [-129.01427161399994, 53.13349030200004],
              [-129.01227779899995, 53.12449778900003],
              [-129.00837154899995, 53.11741771000004],
              [-129.0017797519999, 53.111029364000046],
              [-128.99893144399994, 53.10602448100008],
              [-128.99620520699995, 53.099676825000074],
              [-128.9920141269999, 53.09638092700004],
              [-128.97891191299993, 53.104396877000056],
              [-128.97109941299993, 53.105536200000074],
              [-128.96336829299992, 53.10443756700005],
              [-128.95767167899993, 53.10106028900003],
              [-128.9467667309999, 53.09202708500004],
              [-128.92125403599994, 53.08079661700003],
              [-128.90990149599992, 53.073431708000044],
              [-128.8916723299999, 53.05337148600006],
              [-128.8816625639999, 53.04682038000004],
              [-128.86461341099994, 53.042669989000046],
              [-128.86461341099994, 53.03587474200003],
              [-128.90489661399994, 53.034084377000056],
              [-128.9229223299999, 53.02997467700004],
              [-128.94029700399994, 53.02220286700003],
              [-128.9495336579999, 53.01675039300005],
              [-128.9666235019999, 53.00348541900007],
              [-128.97447669199994, 52.99494049700007],
              [-128.97744706899994, 52.98969147300005],
              [-128.9839574859999, 52.974595445000034],
              [-128.98814856699994, 52.96759674700007],
              [-129.01280676999994, 52.94672272300005],
              [-129.0573624339999, 52.917954820000034],
              [-129.10000566299993, 52.90298086100006],
              [-129.11904863199993, 52.92291901200008],
              [-129.12559973899994, 52.93187083500004],
              [-129.16051184799994, 52.93032461100006],
              [-129.17711341099994, 52.936835028000075],
              [-129.18374589799993, 52.94953034100007],
              [-129.18911699099993, 52.96922435100004],
              [-129.19420325399994, 53.00486888200004],
              [-129.18980872299994, 53.02334219000005],
              [-129.1706436839999, 53.04718659100007],
              [-129.1662491529999, 53.06012604400007],
              [-129.1589249339999, 53.07416413000004],
              [-129.1428116529999, 53.082098700000074],
              [-129.12657630099994, 53.08148834800005],
              [-129.11904863199993, 53.070013739000046],
              [-129.0905655589999, 53.08856842700004],
              [-129.07896887899994, 53.11107005400004],
              [-129.0771378249999, 53.13621653900003],
              [-129.0781143869999, 53.16278717700004],
              [-129.0828344389999, 53.18805573100008],
              [-129.0823461579999, 53.20140208500004],
              [-129.0651749339999, 53.214504299000055],
              [-129.0639542309999, 53.23114655200004],
              [-129.06700598899994, 53.24949778900003],
              [-129.07066809799994, 53.261786200000074],
              [-129.07860266799992, 53.273423570000034],
              [-129.08653723899994, 53.28221263200004],
              [-129.08836829299992, 53.291001695000034],
              [-129.0781143869999, 53.302801825000074],
              [-129.0642797519999, 53.30756256700005],
              [-129.04210364499994, 53.310614325000074],
              [-129.0197647779999, 53.310532945000034],
              [-128.9760636059999, 53.29486725500004],
              [-128.9050186839999, 53.29336172100005],
              [-128.86876380099994, 53.27252838700008],
              [-128.7951554029999, 53.21865469000005],
              [-128.7045792309999, 53.17462799700007],
              [-128.67959550699993, 53.16620514500005],
              [-128.63467363199993, 53.16315338700008],
              [-128.62193762899994, 53.15570709800005],
              [-128.58702551999994, 53.11359284100007],
              [-128.5842179029999, 53.10761139500005],
              [-128.5822647779999, 53.10106028900003],
              [-128.53872636599993, 53.01972077000005],
              [-128.52749589799993, 52.98102448100008],
              [-128.52196204299992, 52.93349844000005],
              [-128.52403723899994, 52.891791083000044],
              [-128.53233801999994, 52.84662506700005],
              [-128.5645238919999, 52.74323151200008],
              [-128.5712784499999, 52.73737213700008],
              [-128.58462480399993, 52.74103424700007],
              [-128.5774633449999, 52.70099518400008],
              [-128.5840551419999, 52.68622467700004],
              [-128.60513261599993, 52.66596100500004],
              [-128.5972387359999, 52.66657135600008],
              [-128.58999589799993, 52.66596100500004],
              [-128.5834854809999, 52.66364166900007],
              [-128.5772192049999, 52.65912506700005],
              [-128.58189856699994, 52.64858633000006],
              [-128.58910071499992, 52.623032945000034],
              [-128.59459387899994, 52.614447333000044],
              [-128.60562089799993, 52.61123281500005],
              [-128.70360266799992, 52.61123281500005],
              [-128.72516842399995, 52.60736725500004],
              [-128.74852454299992, 52.597723700000074],
              [-128.7553604809999, 52.60390859600005],
              [-128.7461645169999, 52.62164948100008],
              [-128.7397354809999, 52.639105536000045],
              [-128.73595130099994, 52.65619538000004],
              [-128.73485266799992, 52.67279694200005],
              [-128.73717200399994, 52.69163646000004],
              [-128.74644934799994, 52.72638580900008],
              [-128.74852454299992, 52.74481842700004],
              [-128.74307206899994, 52.763739325000074],
              [-128.71914628799993, 52.795355536000045],
              [-128.71373450399994, 52.81305573100008],
              [-128.71080481699994, 52.83665599200003],
              [-128.70230058499993, 52.84739817900004],
              [-128.68936113199993, 52.853949286000045],
              [-128.6728409499999, 52.864569403000075],
              [-128.65103105399993, 52.90884023600006],
              [-128.6484268869999, 52.916083075000074],
              [-128.64517167899993, 52.933661200000074],
              [-128.64468339799993, 52.95368073100008],
              [-128.64610755099994, 52.960150458000044],
              [-128.6531469389999, 52.966050523000035],
              [-128.66445878799993, 52.97089264500005],
              [-128.67495683499993, 52.97134023600006],
              [-128.67959550699993, 52.96393463700008],
              [-128.66958574099993, 52.92747630400004],
              [-128.66934160099993, 52.907904364000046],
              [-128.68333899599992, 52.89935944200005],
              [-128.70352128799993, 52.90387604400007],
              [-128.7189835279999, 52.912543036000045],
              [-128.73298092399995, 52.918036200000074],
              [-128.74852454299992, 52.91303131700005],
              [-128.73692786399994, 52.89948151200008],
              [-128.7276098299999, 52.87612539300005],
              [-128.7278539699999, 52.853949286000045],
              [-128.7451065749999, 52.84414297100005],
              [-128.75723222599993, 52.834865627000056],
              [-128.7636612619999, 52.81305573100008],
              [-128.7690323559999, 52.76837799700007],
              [-128.77871660099993, 52.730129299000055],
              [-128.77725175699993, 52.71515534100007],
              [-128.7593481109999, 52.68691640800006],
              [-128.75670325399994, 52.67682526200008],
              [-128.76040605399993, 52.66909414300005],
              [-128.7727758449999, 52.66596100500004],
              [-128.78189042899993, 52.66982656500005],
              [-128.78897050699993, 52.679022528000075],
              [-128.7956436839999, 52.69049713700008],
              [-128.8037817049999, 52.70066966400003],
            ],
          ],
          [
            [
              [-129.29352779899995, 53.10789622600004],
              [-129.3017471999999, 53.11322663000004],
              [-129.3235570949999, 53.124212958000044],
              [-129.3313695949999, 53.132066148000035],
              [-129.33844967399995, 53.15371328300006],
              [-129.33877519399994, 53.178168036000045],
              [-129.3335668609999, 53.20180898600006],
              [-129.32388261599993, 53.22089264500005],
              [-129.26207434799994, 53.26536692900004],
              [-129.24941972599993, 53.28294505400004],
              [-129.2490942049999, 53.29511139500005],
              [-129.2541397779999, 53.304348049000055],
              [-129.27236894399994, 53.32050202000005],
              [-129.27574622299994, 53.33100006700005],
              [-129.26138261599993, 53.33466217700004],
              [-129.24144446499992, 53.333644924000055],
              [-129.21304277299993, 53.32697174700007],
              [-129.19782467399995, 53.32168203300006],
              [-129.18394934799994, 53.313666083000044],
              [-129.17369544199994, 53.302801825000074],
              [-129.17007402299993, 53.29205963700008],
              [-129.17491614499994, 53.27435944200005],
              [-129.17369544199994, 53.261786200000074],
              [-129.16836503799993, 53.25104401200008],
              [-129.15672766799992, 53.23920319200005],
              [-129.1525772779999, 53.22833893400008],
              [-129.15245520699995, 53.21906159100007],
              [-129.15786699099993, 53.200100002000056],
              [-129.16002356699994, 53.186712958000044],
              [-129.15469316299993, 53.16364166900007],
              [-129.13418535099993, 53.12018463700008],
              [-129.13955644399994, 53.104803778000075],
              [-129.1628311839999, 53.09943268400008],
              [-129.2403051419999, 53.10040924700007],
              [-129.2624405589999, 53.104803778000075],
              [-129.26943925699993, 53.09275950700004],
              [-129.27672278599994, 53.09198639500005],
              [-129.28453528599994, 53.09833405200004],
              [-129.29352779899995, 53.10789622600004],
            ],
          ],
          [
            [
              [-128.9136449859999, 53.40643952000005],
              [-128.90640214799993, 53.39118073100008],
              [-128.90640214799993, 53.380926825000074],
              [-128.9134008449999, 53.37140534100007],
              [-128.9273168609999, 53.35805898600006],
              [-128.92003333199995, 53.34943268400008],
              [-128.9207250639999, 53.33808014500005],
              [-128.9279679029999, 53.328192450000074],
              [-128.94001217399995, 53.323919989000046],
              [-128.95742753799993, 53.325425523000035],
              [-128.99551347599993, 53.337591864000046],
              [-129.01280676999994, 53.340277411000045],
              [-129.06041419199994, 53.337591864000046],
              [-129.0752660799999, 53.33344147300005],
              [-129.1037491529999, 53.31883372600004],
              [-129.1184789699999, 53.32050202000005],
              [-129.14818274599992, 53.363714911000045],
              [-129.11221269399994, 53.40932851800005],
              [-129.06578528599994, 53.452460028000075],
              [-129.06383216099994, 53.488348700000074],
              [-129.04845130099994, 53.50861237200007],
              [-129.0217179029999, 53.532131252000056],
              [-128.99722245999993, 53.54393138200004],
              [-128.98814856699994, 53.529364325000074],
              [-128.9865616529999, 53.50092194200005],
              [-128.9767960279999, 53.480169989000046],
              [-128.9136449859999, 53.40643952000005],
            ],
          ],
          [
            [
              [-129.7429499989999, 53.23529694200005],
              [-129.7429093089999, 53.23517487200007],
              [-129.73672441299993, 53.21564362200007],
              [-129.73794511599993, 53.19135163000004],
              [-129.7483617829999, 53.169907945000034],
              [-129.7696020169999, 53.159409898000035],
              [-129.78526770699995, 53.16242096600007],
              [-129.7964574859999, 53.17145416900007],
              [-129.80606035099993, 53.18121979400007],
              [-129.8173721999999, 53.186712958000044],
              [-129.83067786399994, 53.18374258000006],
              [-129.84146074099993, 53.17475006700005],
              [-129.85045325399994, 53.16486237200007],
              [-129.85830644399994, 53.159409898000035],
              [-129.8874405589999, 53.15778229400007],
              [-129.91295325399994, 53.159409898000035],
              [-129.92808997299994, 53.163763739000046],
              [-129.9394425119999, 53.16889069200005],
              [-129.9939672519999, 53.214178778000075],
              [-130.00772050699993, 53.23126862200007],
              [-130.0097550119999, 53.24819570500006],
              [-130.05382239499994, 53.26007721600007],
              [-130.07559160099993, 53.26898834800005],
              [-130.08486894399994, 53.27920156500005],
              [-130.08454342399995, 53.29824453300006],
              [-130.0861710279999, 53.31232330900008],
              [-130.0940649079999, 53.32257721600007],
              [-130.11217200399994, 53.330064195000034],
              [-130.14439856699994, 53.331732489000046],
              [-130.15562903599994, 53.337225653000075],
              [-130.1599828769999, 53.35492584800005],
              [-130.16466223899994, 53.36277903900003],
              [-130.17568925699993, 53.36554596600007],
              [-130.19815019399994, 53.364894924000055],
              [-130.1995336579999, 53.367621161000045],
              [-130.2058813139999, 53.37409088700008],
              [-130.2143448559999, 53.38100820500006],
              [-130.22203528599994, 53.38540273600006],
              [-130.3145238919999, 53.39276764500005],
              [-130.3255102199999, 53.39996979400007],
              [-130.36538652299993, 53.44741445500006],
              [-130.3933813139999, 53.470038153000075],
              [-130.40762285099993, 53.48484935100004],
              [-130.4138891269999, 53.49860260600008],
              [-130.4042862619999, 53.510199286000045],
              [-130.38206946499992, 53.515285549000055],
              [-130.3381241529999, 53.51630280200004],
              [-130.36489824099993, 53.527329820000034],
              [-130.3849991529999, 53.526556708000044],
              [-130.4057511059999, 53.520697333000044],
              [-130.4343155589999, 53.51630280200004],
              [-130.44981848899994, 53.516791083000044],
              [-130.4609268869999, 53.519598700000074],
              [-130.46983801999994, 53.52488841400003],
              [-130.50259355399993, 53.54979075700004],
              [-130.5095922519999, 53.55117422100005],
              [-130.51891028599994, 53.55097077000005],
              [-130.52708899599992, 53.55267975500004],
              [-130.53050696499992, 53.559759833000044],
              [-130.52977454299992, 53.582912502000056],
              [-130.5256241529999, 53.60895416900007],
              [-130.51528886599993, 53.63035716400003],
              [-130.4960831369999, 53.63922760600008],
              [-130.44448808499993, 53.63540273600006],
              [-130.41454016799992, 53.628892320000034],
              [-130.39273027299993, 53.61810944200005],
              [-130.3659561839999, 53.61286041900007],
              [-130.31558183499993, 53.58978913000004],
              [-130.2613012359999, 53.58063385600008],
              [-130.2365616529999, 53.57078685100004],
              [-130.18789628799993, 53.54360586100006],
              [-130.11514238199993, 53.51943594000005],
              [-130.0750219389999, 53.49286530200004],
              [-129.97398841099994, 53.45799388200004],
              [-129.92857825399994, 53.43256256700005],
              [-129.90050208199995, 53.40900299700007],
              [-129.89053300699993, 53.403957424000055],
              [-129.8826391269999, 53.39817942900004],
              [-129.8759659499999, 53.37832265800006],
              [-129.86782792899993, 53.367621161000045],
              [-129.76610266799992, 53.26459381700005],
              [-129.7429499989999, 53.23529694200005],
            ],
          ],
          [
            [
              [-129.1662491529999, 53.38540273600006],
              [-129.1721085279999, 53.40839264500005],
              [-129.17430579299992, 53.45026276200008],
              [-129.17174231699994, 53.49323151200008],
              [-129.15880286399994, 53.53266022300005],
              [-129.1662491529999, 53.59076569200005],
              [-129.16527258999992, 53.61383698100008],
              [-129.1599828769999, 53.627020575000074],
              [-129.13613847599993, 53.64940013200004],
              [-129.12193762899994, 53.655585028000075],
              [-129.0795792309999, 53.66738515800006],
              [-129.07066809799994, 53.67645905200004],
              [-129.06065833199995, 53.68431224200003],
              [-129.03770911399994, 53.691839911000045],
              [-128.99551347599993, 53.70062897300005],
              [-128.90274003799993, 53.70062897300005],
              [-128.88365637899994, 53.70482005400004],
              [-128.8628637359999, 53.71234772300005],
              [-128.84219316299993, 53.71596914300005],
              [-128.82363847599993, 53.70807526200008],
              [-128.8574926419999, 53.682847398000035],
              [-128.86827551999994, 53.66754791900007],
              [-128.86461341099994, 53.65281810100004],
              [-128.8816625639999, 53.62128327000005],
              [-128.87979081899994, 53.59210846600007],
              [-128.8842667309999, 53.576239325000074],
              [-128.9533585279999, 53.591498114000046],
              [-128.9805395169999, 53.58466217700004],
              [-129.06944739499994, 53.52045319200005],
              [-129.08120683499993, 53.51630280200004],
              [-129.09386145699995, 53.50893789300005],
              [-129.09349524599992, 53.492621161000045],
              [-129.08433997299994, 53.46792226800005],
              [-129.09142005099994, 53.45026276200008],
              [-129.10195878799993, 53.443019924000055],
              [-129.11485755099994, 53.43886953300006],
              [-129.12901770699995, 53.43036530200004],
              [-129.14928137899994, 53.40875885600008],
              [-129.1662491529999, 53.38540273600006],
            ],
          ],
          [
            [
              [-130.40636145699995, 53.68699778900003],
              [-130.36705481699994, 53.71308014500005],
              [-130.30382239499994, 53.745754299000055],
              [-130.29092363199993, 53.75527578300006],
              [-130.2983292309999, 53.77285390800006],
              [-130.3017471999999, 53.78945547100005],
              [-130.2963761059999, 53.80097077000005],
              [-130.27725175699993, 53.80365631700005],
              [-130.26089433499993, 53.79783763200004],
              [-130.2333878249999, 53.784409898000035],
              [-130.22203528599994, 53.77635325700004],
              [-130.2307836579999, 53.764878648000035],
              [-130.2350968089999, 53.75307851800005],
              [-130.2346899079999, 53.74070872600004],
              [-130.22887122299994, 53.72797272300005],
              [-130.2167862619999, 53.718085028000075],
              [-130.20152747299994, 53.71580638200004],
              [-130.18443762899994, 53.71539948100008],
              [-130.1382543609999, 53.702826239000046],
              [-130.12474524599992, 53.69562409100007],
              [-130.11900794199994, 53.683579820000034],
              [-130.1218155589999, 53.67243073100008],
              [-130.12657630099994, 53.66351959800005],
              [-130.12751217399995, 53.653509833000044],
              [-130.11900794199994, 53.63922760600008],
              [-130.1264542309999, 53.63178131700005],
              [-130.1143285799999, 53.61815013200004],
              [-130.1057836579999, 53.603949286000045],
              [-130.09166419199994, 53.570298570000034],
              [-130.1170141269999, 53.570379950000074],
              [-130.1736547519999, 53.59076569200005],
              [-130.25161699099993, 53.59707265800006],
              [-130.29381262899994, 53.619126695000034],
              [-130.3318578769999, 53.62400950700004],
              [-130.3486221999999, 53.63548411700003],
              [-130.36461341099994, 53.658270575000074],
              [-130.3728735019999, 53.66648997600004],
              [-130.3808487619999, 53.67182038000004],
              [-130.3979386059999, 53.68024323100008],
              [-130.40636145699995, 53.68699778900003],
            ],
          ],
          [
            [
              [-130.25279700399994, 53.89248281500005],
              [-130.2331436839999, 53.89793528900003],
              [-130.19619706899994, 53.91657135600008],
              [-130.18106035099993, 53.91290924700007],
              [-130.15746008999992, 53.898138739000046],
              [-130.10635331899994, 53.88035716400003],
              [-130.08145097599993, 53.861395575000074],
              [-130.07046464799993, 53.85643138200004],
              [-130.03726152299993, 53.85016510600008],
              [-130.0302628249999, 53.848089911000045],
              [-130.02672278599994, 53.83852773600006],
              [-130.01805579299992, 53.832464911000045],
              [-129.9961645169999, 53.82416413000004],
              [-129.9326879549999, 53.78192780200004],
              [-129.90029863199993, 53.773423570000034],
              [-129.8908585279999, 53.76642487200007],
              [-129.87564042899993, 53.75214264500005],
              [-129.86510169199994, 53.746161200000074],
              [-129.8413793609999, 53.739894924000055],
              [-129.83096269399994, 53.73541901200008],
              [-129.77749589799993, 53.68903229400007],
              [-129.7696020169999, 53.67645905200004],
              [-129.7599991529999, 53.669623114000046],
              [-129.6747940749999, 53.59271881700005],
              [-129.53457597599993, 53.50812409100007],
              [-129.52383378799993, 53.49945709800005],
              [-129.51573645699995, 53.488348700000074],
              [-129.5339249339999, 53.48338450700004],
              [-129.55089270699995, 53.48224518400008],
              [-129.56749426999994, 53.48411692900004],
              [-129.61632239499994, 53.49909088700008],
              [-129.62979081899994, 53.49681224200003],
              [-129.63923092399995, 53.48151276200008],
              [-129.6189672519999, 53.484808661000045],
              [-129.61192786399994, 53.488348700000074],
              [-129.58804277299993, 53.474676825000074],
              [-129.5598852199999, 53.47125885600008],
              [-129.49893144399994, 53.47475820500006],
              [-129.47813880099994, 53.46832916900007],
              [-129.4512426419999, 53.453192450000074],
              [-129.42699133999992, 53.43500397300005],
              [-129.41392981699994, 53.41950104400007],
              [-129.40279714399992, 53.39836629800004],
              [-129.36877579899993, 53.38387046400004],
              [-129.3365359639999, 53.36061454600008],
              [-129.34575322799992, 53.328067470000065],
              [-129.3257607949999, 53.29591076400004],
              [-129.32871805699995, 53.26344919100006],
              [-129.3613998259999, 53.24554082700007],
              [-129.37936850499995, 53.28023753100007],
              [-129.3965740019999, 53.29244916000005],
              [-129.3909450089999, 53.30874846100005],
              [-129.4064781379999, 53.332219777000034],
              [-129.4295891449999, 53.33563461400007],
              [-129.4413102919999, 53.315512],
              [-129.45913652299993, 53.29482656500005],
              [-129.47524980399993, 53.29743073100008],
              [-129.5026749339999, 53.31708405200004],
              [-129.51292883999992, 53.31069570500006],
              [-129.50942949099993, 53.29718659100007],
              [-129.50255286399994, 53.28164297100005],
              [-129.5026749339999, 53.26862213700008],
              [-129.48228919199994, 53.24494049700007],
              [-129.48302161399994, 53.22410716400003],
              [-129.49864661399994, 53.21556224200003],
              [-129.52310136599993, 53.22833893400008],
              [-129.54507402299993, 53.21771881700005],
              [-129.56753495999993, 53.21531810100004],
              [-129.5850317049999, 53.22370026200008],
              [-129.5920304029999, 53.24506256700005],
              [-129.6017960279999, 53.25608958500004],
              [-129.64663652299993, 53.29547760600008],
              [-129.6597387359999, 53.30963776200008],
              [-129.65318762899994, 53.310614325000074],
              [-129.64443925699993, 53.31509023600006],
              [-129.63923092399995, 53.31708405200004],
              [-129.67393958199995, 53.330064195000034],
              [-129.67393958199995, 53.337591864000046],
              [-129.6597387359999, 53.34442780200004],
              [-129.6725968089999, 53.349269924000055],
              [-129.68496660099993, 53.34516022300005],
              [-129.6985570949999, 53.33893463700008],
              [-129.71495520699995, 53.337591864000046],
              [-129.7256567049999, 53.34174225500004],
              [-129.7627660799999, 53.364894924000055],
              [-129.76406816299993, 53.36969635600008],
              [-129.7626846999999, 53.37653229400007],
              [-129.76211503799993, 53.38271719000005],
              [-129.76610266799992, 53.38540273600006],
              [-129.7968643869999, 53.37848541900007],
              [-129.8068741529999, 53.38532135600008],
              [-129.8222550119999, 53.40534088700008],
              [-129.83096269399994, 53.41266510600008],
              [-129.82213294199994, 53.441066799000055],
              [-129.81851152299993, 53.459418036000045],
              [-129.8210343089999, 53.47134023600006],
              [-129.83389238199993, 53.47260163000004],
              [-129.85326087099992, 53.46771881700005],
              [-129.87547766799992, 53.46637604400007],
              [-129.8967992829999, 53.47809479400007],
              [-129.8953344389999, 53.48725006700005],
              [-129.87633216099994, 53.51992422100005],
              [-129.87193762899994, 53.53620026200008],
              [-129.8770238919999, 53.55410390800006],
              [-129.8887426419999, 53.561712958000044],
              [-129.90591386599993, 53.56321849200003],
              [-129.9272354809999, 53.56289297100005],
              [-129.9186905589999, 53.571519273000035],
              [-129.9081925119999, 53.57684967700004],
              [-129.8863012359999, 53.58462148600006],
              [-129.9134008449999, 53.595363674000055],
              [-129.9268285799999, 53.59662506700005],
              [-129.9409073559999, 53.59076569200005],
              [-129.9409073559999, 53.59821198100008],
              [-129.9330948559999, 53.60032786700003],
              [-129.91295325399994, 53.61127350500004],
              [-129.93858801999994, 53.620428778000075],
              [-129.95421301999994, 53.609808661000045],
              [-129.96739661399994, 53.59320709800005],
              [-129.98550370999993, 53.58462148600006],
              [-130.0303442049999, 53.58161041900007],
              [-130.0496313139999, 53.58779531500005],
              [-130.05752519399994, 53.607855536000045],
              [-130.03331458199995, 53.631293036000045],
              [-129.9780981109999, 53.643011786000045],
              [-129.91808020699995, 53.64313385600008],
              [-129.87938391799992, 53.63178131700005],
              [-129.87193762899994, 53.63922760600008],
              [-129.90249589799993, 53.65875885600008],
              [-129.94619706899994, 53.66429271000004],
              [-129.99233964799993, 53.66071198100008],
              [-130.0302628249999, 53.65281810100004],
              [-130.05833899599992, 53.64020416900007],
              [-130.0757543609999, 53.63764069200005],
              [-130.09166419199994, 53.64606354400007],
              [-130.09756425699993, 53.66128164300005],
              [-130.09239661399994, 53.693060614000046],
              [-130.09850012899994, 53.70807526200008],
              [-130.16738847599993, 53.72797272300005],
              [-130.20238196499992, 53.73029205900008],
              [-130.21153723899994, 53.73663971600007],
              [-130.21458899599992, 53.75527578300006],
              [-130.21104895699995, 53.77106354400007],
              [-130.20523027299993, 53.78595612200007],
              [-130.2040909499999, 53.80117422100005],
              [-130.21458899599992, 53.81732819200005],
              [-130.2311905589999, 53.82566966400003],
              [-130.29092363199993, 53.83783600500004],
              [-130.27672278599994, 53.87103913000004],
              [-130.26732337099992, 53.88613515800006],
              [-130.25279700399994, 53.89248281500005],
            ],
          ],
          [
            [
              [-130.44737708199995, 53.98183828300006],
              [-130.45759029899995, 53.96308014500005],
              [-130.46328691299993, 53.93537018400008],
              [-130.47154700399994, 53.910223700000074],
              [-130.4892471999999, 53.899318752000056],
              [-130.52261308499993, 53.90216705900008],
              [-130.54430091099994, 53.91071198100008],
              [-130.58169511599993, 53.94399648600006],
              [-130.6038305329999, 53.95937734600005],
              [-130.61856035099993, 53.965725002000056],
              [-130.62950598899994, 53.96442291900007],
              [-130.6386612619999, 53.956244208000044],
              [-130.64899654899995, 53.94944896000004],
              [-130.6572973299999, 53.95099518400008],
              [-130.66026770699995, 53.96759674700007],
              [-130.6757706369999, 53.961004950000074],
              [-130.68423417899993, 53.94782135600008],
              [-130.69107011599993, 53.93276601800005],
              [-130.7012426419999, 53.920355536000045],
              [-130.6901749339999, 53.90582916900007],
              [-130.67467200399994, 53.89862702000005],
              [-130.6572159499999, 53.89370351800005],
              [-130.64037024599992, 53.88556549700007],
              [-130.62779700399994, 53.87221914300005],
              [-130.62222245999993, 53.85643138200004],
              [-130.6282445949999, 53.84332916900007],
              [-130.65029863199993, 53.83783600500004],
              [-130.65636145699995, 53.83958567900004],
              [-130.68130449099993, 53.85150788000004],
              [-130.6968481109999, 53.851263739000046],
              [-130.7080785799999, 53.85293203300006],
              [-130.71548417899993, 53.85765208500004],
              [-130.71519934799994, 53.871161200000074],
              [-130.7099503249999, 53.889553127000056],
              [-130.70840410099993, 53.90582916900007],
              [-130.71886145699995, 53.91290924700007],
              [-130.7236221999999, 53.92047760600008],
              [-130.7177628249999, 53.937160549000055],
              [-130.70547441299993, 53.95376211100006],
              [-130.69127356699994, 53.961371161000045],
              [-130.6865128249999, 53.96507396000004],
              [-130.67931067599994, 53.98297760600008],
              [-130.6738988919999, 53.98924388200004],
              [-130.66616777299993, 53.99103424700007],
              [-130.65566972599993, 53.99164459800005],
              [-130.6474503249999, 53.99103424700007],
              [-130.64659583199995, 53.98924388200004],
              [-130.63243567599994, 53.999986070000034],
              [-130.61880449099993, 54.01361725500004],
              [-130.6038305329999, 54.02529531500005],
              [-130.58511308499993, 54.03021881700005],
              [-130.5666397779999, 54.03294505400004],
              [-130.51622473899994, 54.05695221600007],
              [-130.5185440749999, 54.06867096600007],
              [-130.4521378249999, 54.07558828300006],
              [-130.4343155589999, 54.08112213700008],
              [-130.42162024599992, 54.100043036000045],
              [-130.39248613199993, 54.095404364000046],
              [-130.3381241529999, 54.07123444200005],
              [-130.29039466099994, 54.029282945000034],
              [-130.28038489499994, 54.022772528000075],
              [-130.2647192049999, 54.01508209800005],
              [-130.2459203769999, 53.99640534100007],
              [-130.2315160799999, 53.97378164300005],
              [-130.22887122299994, 53.95384349200003],
              [-130.24181067599994, 53.93740469000005],
              [-130.28408769399994, 53.914496161000045],
              [-130.30089270699995, 53.90273672100005],
              [-130.32787024599992, 53.87567780200004],
              [-130.33409583199995, 53.86517975500004],
              [-130.3369848299999, 53.85504791900007],
              [-130.34121660099993, 53.845770575000074],
              [-130.3517960279999, 53.83783600500004],
              [-130.3620499339999, 53.83624909100007],
              [-130.39659583199995, 53.83624909100007],
              [-130.40636145699995, 53.83783600500004],
              [-130.41250566299993, 53.844916083000044],
              [-130.4233292309999, 53.867173570000034],
              [-130.42438717399995, 53.871975002000056],
              [-130.44273841099994, 53.86347077000005],
              [-130.4619034499999, 53.84878164300005],
              [-130.47862708199995, 53.84393952000005],
              [-130.4895727199999, 53.86513906500005],
              [-130.49144446499992, 53.87750885600008],
              [-130.48936926999994, 53.87995026200008],
              [-130.48228919199994, 53.88003164300005],
              [-130.46910559799994, 53.88556549700007],
              [-130.46011308499993, 53.892279364000046],
              [-130.45323645699995, 53.89907461100006],
              [-130.41071529899995, 53.953192450000074],
              [-130.3960668609999, 53.962144273000035],
              [-130.36538652299993, 53.96759674700007],
              [-130.33128821499992, 53.96759674700007],
              [-130.33128821499992, 53.97500234600005],
              [-130.34422766799992, 53.977728583000044],
              [-130.35024980399993, 53.982489325000074],
              [-130.34854081899994, 53.98859284100007],
              [-130.3381241529999, 53.995428778000075],
              [-130.3494360019999, 53.99941640800006],
              [-130.3611547519999, 53.99754466400003],
              [-130.3865453769999, 53.98924388200004],
              [-130.4326879549999, 53.98777903900003],
              [-130.44737708199995, 53.98183828300006],
            ],
          ],
          [
            [
              [-132.5794164699999, 53.20722077000005],
              [-132.56187903599994, 53.220038153000075],
              [-132.55577551999994, 53.22679271000004],
              [-132.55211341099994, 53.23517487200007],
              [-132.5711156889999, 53.23533763200004],
              [-132.6271866529999, 53.25560130400004],
              [-132.6679581369999, 53.26089101800005],
              [-132.7097875639999, 53.261786200000074],
              [-132.69847571499992, 53.27887604400007],
              [-132.6736547519999, 53.28880442900004],
              [-132.62035071499992, 53.302801825000074],
              [-132.61925208199995, 53.30487702000005],
              [-132.61803137899994, 53.30906810100004],
              [-132.61607825399994, 53.313666083000044],
              [-132.61290442599994, 53.31708405200004],
              [-132.57876542899993, 53.323919989000046],
              [-132.5662328769999, 53.319566148000035],
              [-132.5529679029999, 53.31268952000005],
              [-132.54263261599993, 53.31207916900007],
              [-132.53844153599994, 53.32697174700007],
              [-132.56895911399994, 53.33685944200005],
              [-132.75755774599992, 53.31708405200004],
              [-132.74864661399994, 53.331244208000044],
              [-132.7136124339999, 53.36977773600006],
              [-132.7029516269999, 53.37848541900007],
              [-132.69127356699994, 53.378119208000044],
              [-132.66128495999993, 53.36782461100006],
              [-132.64830481699994, 53.364894924000055],
              [-132.53160559799994, 53.364894924000055],
              [-132.5188695949999, 53.36172109600005],
              [-132.5017797519999, 53.34756094000005],
              [-132.48302161399994, 53.34121328300006],
              [-132.46475175699993, 53.32709381700005],
              [-132.4382218089999, 53.321519273000035],
              [-132.42760169199994, 53.31549713700008],
              [-132.4201554029999, 53.30678945500006],
              [-132.41490637899994, 53.296576239000046],
              [-132.40013587099992, 53.33030833500004],
              [-132.42516028599994, 53.350775458000044],
              [-132.49746660099993, 53.37848541900007],
              [-132.5038956369999, 53.38662344000005],
              [-132.5131729809999, 53.40643952000005],
              [-132.51793372299994, 53.41266510600008],
              [-132.52896074099993, 53.417303778000075],
              [-132.55308997299994, 53.41836172100005],
              [-132.64122473899994, 53.43231842700004],
              [-132.66136633999992, 53.43992747600004],
              [-132.6552628249999, 53.46303945500006],
              [-132.66104081899994, 53.48305898600006],
              [-132.67056230399993, 53.49095286700003],
              [-132.68468176999994, 53.45766836100006],
              [-132.7065323559999, 53.45091380400004],
              [-132.7334692049999, 53.453558661000045],
              [-132.75755774599992, 53.46108633000006],
              [-132.75755774599992, 53.46792226800005],
              [-132.74205481699994, 53.476263739000046],
              [-132.7275284499999, 53.49005768400008],
              [-132.7226456369999, 53.50495026200008],
              [-132.73643958199995, 53.51630280200004],
              [-132.74889075399994, 53.51618073100008],
              [-132.7539770169999, 53.50853099200003],
              [-132.75641842399995, 53.49957916900007],
              [-132.76097571499992, 53.49518463700008],
              [-132.7704971999999, 53.49355703300006],
              [-132.84227454299992, 53.46893952000005],
              [-132.86188717399995, 53.466864325000074],
              [-132.87364661399994, 53.47475820500006],
              [-132.87022864499994, 53.487982489000046],
              [-132.83755449099993, 53.510646877000056],
              [-132.8264867829999, 53.52252838700008],
              [-132.92886308499993, 53.52252838700008],
              [-132.91844641799992, 53.530503648000035],
              [-132.9053442049999, 53.55036041900007],
              [-132.8941137359999, 53.556626695000034],
              [-132.9080297519999, 53.567572333000044],
              [-132.92955481699994, 53.56549713700008],
              [-132.95421301999994, 53.55890534100007],
              [-132.9772843089999, 53.556626695000034],
              [-132.97240149599992, 53.57648346600007],
              [-132.99063066299993, 53.589829820000034],
              [-132.96983801999994, 53.59821198100008],
              [-132.94847571499992, 53.59829336100006],
              [-132.9002172519999, 53.58893463700008],
              [-132.88418535099993, 53.59446849200003],
              [-132.89110266799992, 53.61969635600008],
              [-132.9838761059999, 53.667181708000044],
              [-133.0108129549999, 53.68699778900003],
              [-132.9982804029999, 53.680975653000075],
              [-132.98680579299992, 53.67991771000004],
              [-132.97716223899994, 53.68431224200003],
              [-132.96983801999994, 53.69448476800005],
              [-132.9557999339999, 53.68781159100007],
              [-132.9401749339999, 53.68610260600008],
              [-132.93077551999994, 53.69013092700004],
              [-132.93565833199995, 53.70062897300005],
              [-132.95152747299994, 53.706732489000046],
              [-132.97130286399994, 53.710191148000035],
              [-132.9837133449999, 53.71759674700007],
              [-132.9772843089999, 53.73541901200008],
              [-132.9819229809999, 53.74494049700007],
              [-132.9780981109999, 53.763332424000055],
              [-132.98350989499994, 53.769517320000034],
              [-132.9951879549999, 53.770738023000035],
              [-133.00328528599994, 53.76581452000005],
              [-133.01012122299994, 53.75922272300005],
              [-133.01821855399993, 53.75527578300006],
              [-133.02867591099994, 53.755519924000055],
              [-133.04076087099992, 53.76080963700008],
              [-133.0613500639999, 53.76471588700008],
              [-133.09850012899994, 53.77920156500005],
              [-133.1104223299999, 53.78660716400003],
              [-133.11143958199995, 53.79791901200008],
              [-133.09727942599994, 53.80727773600006],
              [-133.0654190749999, 53.81732819200005],
              [-133.07876542899993, 53.833319403000075],
              [-133.1198624339999, 53.86041901200008],
              [-133.1374405589999, 53.87567780200004],
              [-133.14439856699994, 53.896918036000045],
              [-133.1358129549999, 53.91498444200005],
              [-133.1238500639999, 53.929754950000074],
              [-133.1206762359999, 53.94086334800005],
              [-133.10081946499992, 53.95453522300005],
              [-133.10016842399995, 53.97085195500006],
              [-133.10472571499992, 53.987494208000044],
              [-133.10073808499993, 54.00234609600005],
              [-133.09532630099994, 54.00381094000005],
              [-133.0790909499999, 54.00145091400003],
              [-133.07286536399994, 54.00234609600005],
              [-133.06899980399993, 54.005926825000074],
              [-133.06810462099992, 54.009466864000046],
              [-133.06773841099994, 54.012884833000044],
              [-133.0654190749999, 54.01601797100005],
              [-133.0510961579999, 54.026556708000044],
              [-133.04344641799992, 54.034409898000035],
              [-133.0380753249999, 54.04389069200005],
              [-133.04674231699994, 54.049709377000056],
              [-133.05117753799993, 54.057806708000044],
              [-133.0541886059999, 54.06736888200004],
              [-133.0666397779999, 54.094916083000044],
              [-133.07262122299994, 54.100043036000045],
              [-133.08653723899994, 54.104681708000044],
              [-133.0447485019999, 54.14801666900007],
              [-133.0405167309999, 54.16453685100004],
              [-133.07286536399994, 54.16681549700007],
              [-133.05337480399993, 54.18309153900003],
              [-133.02529863199993, 54.17609284100007],
              [-132.9978735019999, 54.16364166900007],
              [-132.98037675699993, 54.16303131700005],
              [-132.9688207669999, 54.16860586100006],
              [-132.95278886599993, 54.16771067900004],
              [-132.9368383449999, 54.16290924700007],
              [-132.92544511599993, 54.15619538000004],
              [-132.9162491529999, 54.148871161000045],
              [-132.90880286399994, 54.14533112200007],
              [-132.83438066299993, 54.128159898000035],
              [-132.7780655589999, 54.12518952000005],
              [-132.7534887359999, 54.12848541900007],
              [-132.70303300699993, 54.142645575000074],
              [-132.67564856699994, 54.145697333000044],
              [-132.64903723899994, 54.14130280200004],
              [-132.60195878799993, 54.12262604400007],
              [-132.5756729809999, 54.118353583000044],
              [-132.56688391799992, 54.10814036700003],
              [-132.56338456899994, 54.08502838700008],
              [-132.56362870999993, 54.059881903000075],
              [-132.56578528599994, 54.04389069200005],
              [-132.5801488919999, 54.022650458000044],
              [-132.60020911399994, 54.014960028000075],
              [-132.62279212099992, 54.01048411700003],
              [-132.6446020169999, 53.998928127000056],
              [-132.67520097599993, 53.96865469000005],
              [-132.68130449099993, 53.950832424000055],
              [-132.66136633999992, 53.94086334800005],
              [-132.65469316299993, 53.94399648600006],
              [-132.6309301419999, 53.96442291900007],
              [-132.62100175699993, 53.97052643400008],
              [-132.61021887899994, 53.97361888200004],
              [-132.5862524079999, 53.97500234600005],
              [-132.56810462099992, 53.98183828300006],
              [-132.55508378799993, 53.99872467700004],
              [-132.54723059799994, 54.02000560100004],
              [-132.54466712099992, 54.04018789300005],
              [-132.53237870999993, 54.04633209800005],
              [-132.4565323559999, 54.063788153000075],
              [-132.43932044199994, 54.075425523000035],
              [-132.42467200399994, 54.08844635600008],
              [-132.40684973899994, 54.09935130400004],
              [-132.29674231699994, 54.11229075700004],
              [-132.2840063139999, 54.10846588700008],
              [-132.27554277299993, 54.09516022300005],
              [-132.23839270699995, 54.071600653000075],
              [-132.2299698559999, 54.05353424700007],
              [-132.23180091099994, 54.04075755400004],
              [-132.23379472599993, 54.03497955900008],
              [-132.23037675699993, 54.03074778900003],
              [-132.2162979809999, 54.022772528000075],
              [-132.2029516269999, 54.01862213700008],
              [-132.17393958199995, 54.014960028000075],
              [-132.16104081899994, 54.00849030200004],
              [-132.14854895699995, 53.99249909100007],
              [-132.1445206369999, 53.974310614000046],
              [-132.14732825399994, 53.95453522300005],
              [-132.15489661399994, 53.934027411000045],
              [-132.14395097599993, 53.923163153000075],
              [-132.12682044199994, 53.902004299000055],
              [-132.1142471999999, 53.881293036000045],
              [-132.1170141269999, 53.871975002000056],
              [-132.14395097599993, 53.84125397300005],
              [-132.1546117829999, 53.83641185100004],
              [-132.18394934799994, 53.83421458500004],
              [-132.19587154899995, 53.83100006700005],
              [-132.21133378799993, 53.81513092700004],
              [-132.22398841099994, 53.79466380400004],
              [-132.24063066299993, 53.777044989000046],
              [-132.2678116529999, 53.769517320000034],
              [-132.3740128249999, 53.76211172100005],
              [-132.3953344389999, 53.75332265800006],
              [-132.43325761599993, 53.72675202000005],
              [-132.45278886599993, 53.721136786000045],
              [-132.4760636059999, 53.717962958000044],
              [-132.52505449099993, 53.70384349200003],
              [-132.55211341099994, 53.70062897300005],
              [-132.60802161399994, 53.70343659100007],
              [-132.63719641799992, 53.70099518400008],
              [-132.65794837099992, 53.690741278000075],
              [-132.66592363199993, 53.676947333000044],
              [-132.6575414699999, 53.674709377000056],
              [-132.6309301419999, 53.68016185100004],
              [-132.61514238199993, 53.67963288000004],
              [-132.6050512359999, 53.67715078300006],
              [-132.5983780589999, 53.67096588700008],
              [-132.5930883449999, 53.65965403900003],
              [-132.59410559799994, 53.65375397300005],
              [-132.6067602199999, 53.63178131700005],
              [-132.58926347599993, 53.63711172100005],
              [-132.5671280589999, 53.65932851800005],
              [-132.55211341099994, 53.66648997600004],
              [-132.5398656889999, 53.66461823100008],
              [-132.5134985019999, 53.649644273000035],
              [-132.49746660099993, 53.64606354400007],
              [-132.46178137899994, 53.65110911700003],
              [-132.39110266799992, 53.671128648000035],
              [-132.35289466099994, 53.672756252000056],
              [-132.38149980399993, 53.64793528900003],
              [-132.42113196499992, 53.63458893400008],
              [-132.4592992829999, 53.616400458000044],
              [-132.48379472599993, 53.57713450700004],
              [-132.46788489499994, 53.577826239000046],
              [-132.45693925699993, 53.58494700700004],
              [-132.44717363199993, 53.595038153000075],
              [-132.43480383999992, 53.60443756700005],
              [-132.4080297519999, 53.61302317900004],
              [-132.3801977199999, 53.61810944200005],
              [-132.31847083199995, 53.61774323100008],
              [-132.2897843089999, 53.622748114000046],
              [-132.27090410099993, 53.63922760600008],
              [-132.28823808499993, 53.638739325000074],
              [-132.31029212099992, 53.64166901200008],
              [-132.32823645699995, 53.648504950000074],
              [-132.3329971999999, 53.65965403900003],
              [-132.31883704299992, 53.672756252000056],
              [-132.29613196499992, 53.67373281500005],
              [-132.25381425699993, 53.66648997600004],
              [-132.2180883449999, 53.655910549000055],
              [-132.20230058499993, 53.655462958000044],
              [-132.19587154899995, 53.669623114000046],
              [-132.18871008999992, 53.68113841400003],
              [-132.1591690749999, 53.69989655200004],
              [-132.15489661399994, 53.71430084800005],
              [-132.16246497299994, 53.72614166900007],
              [-132.18805904899995, 53.741400458000044],
              [-132.19587154899995, 53.75527578300006],
              [-132.19383704299992, 53.77399323100008],
              [-132.18399003799993, 53.78758372600004],
              [-132.17308508999992, 53.798041083000044],
              [-132.16787675699993, 53.807074286000045],
              [-132.16104081899994, 53.813666083000044],
              [-132.1170141269999, 53.84125397300005],
              [-132.0869848299999, 53.87763092700004],
              [-132.07852128799993, 53.89248281500005],
              [-132.08633378799993, 53.90192291900007],
              [-132.10912024599992, 53.923041083000044],
              [-132.11388098899994, 53.93032461100006],
              [-132.1153051419999, 53.94285716400003],
              [-132.1269425119999, 53.97500234600005],
              [-132.12816321499992, 53.99917226800005],
              [-132.1303604809999, 54.010931708000044],
              [-132.13719641799992, 54.01601797100005],
              [-132.1482641269999, 54.01894765800006],
              [-132.1608780589999, 54.026271877000056],
              [-132.18219967399995, 54.04389069200005],
              [-132.1670629549999, 54.04584381700005],
              [-132.1304418609999, 54.03367747600004],
              [-132.04649817599994, 54.022691148000035],
              [-131.9934789699999, 54.02578359600005],
              [-131.91637122299994, 54.04010651200008],
              [-131.86436926999994, 54.06704336100006],
              [-131.79430091099994, 54.08038971600007],
              [-131.75475012899994, 54.10252513200004],
              [-131.7233780589999, 54.11212799700007],
              [-131.7092179029999, 54.118353583000044],
              [-131.6946508449999, 54.12909577000005],
              [-131.68154863199993, 54.141506252000056],
              [-131.66079667899993, 54.16681549700007],
              [-131.66226152299993, 54.15912506700005],
              [-131.66392981699994, 54.15607330900008],
              [-131.6682836579999, 54.15314362200007],
              [-131.6624242829999, 54.14468008000006],
              [-131.66026770699995, 54.13694896000004],
              [-131.6621801419999, 54.13031647300005],
              [-131.6682836579999, 54.12518952000005],
              [-131.6707250639999, 54.07908763200004],
              [-131.6787003249999, 54.03416575700004],
              [-131.69326738199993, 53.991888739000046],
              [-131.71544348899994, 53.95384349200003],
              [-131.74864661399994, 53.91648997600004],
              [-131.8190811839999, 53.85492584800005],
              [-131.85317949099993, 53.81732819200005],
              [-131.86436926999994, 53.799994208000044],
              [-131.87051347599993, 53.782904364000046],
              [-131.87315833199995, 53.763332424000055],
              [-131.87368730399993, 53.73851146000004],
              [-131.8765356109999, 53.71820709800005],
              [-131.88394120999993, 53.69794342700004],
              [-131.89488684799994, 53.67820872600004],
              [-131.92198645699995, 53.64020416900007],
              [-131.93333899599992, 53.61863841400003],
              [-131.93618730399993, 53.59609609600005],
              [-131.92520097599993, 53.57371653900003],
              [-131.9221899079999, 53.563788153000075],
              [-131.92544511599993, 53.551988023000035],
              [-131.93199622299994, 53.54083893400008],
              [-131.9382218089999, 53.53278229400007],
              [-131.94261633999992, 53.52163320500006],
              [-131.9396866529999, 53.50971100500004],
              [-131.92833411399994, 53.488348700000074],
              [-131.91576087099992, 53.45302969000005],
              [-131.91372636599993, 53.43805573100008],
              [-131.9190160799999, 53.38886139500005],
              [-131.9167374339999, 53.375433661000045],
              [-131.90782630099994, 53.35805898600006],
              [-131.9247940749999, 53.34198639500005],
              [-131.96304277299993, 53.28294505400004],
              [-131.9844457669999, 53.260931708000044],
              [-132.0078832669999, 53.253566799000055],
              [-132.09561113199993, 53.25454336100006],
              [-132.16576087099992, 53.24591705900008],
              [-132.1963598299999, 53.23456452000005],
              [-132.21129309799994, 53.234076239000046],
              [-132.22435462099992, 53.23065827000005],
              [-132.2299698559999, 53.21775950700004],
              [-132.23574785099993, 53.20758698100008],
              [-132.24937903599994, 53.20722077000005],
              [-132.27774003799993, 53.21466705900008],
              [-132.2610570949999, 53.200506903000075],
              [-132.2451065749999, 53.196600653000075],
              [-132.20954342399995, 53.20099518400008],
              [-132.1269425119999, 53.20099518400008],
              [-132.13638261599993, 53.188666083000044],
              [-132.15469316299993, 53.17601146000004],
              [-132.17638098899994, 53.16551341400003],
              [-132.19587154899995, 53.159409898000035],
              [-132.2275284499999, 53.15680573100008],
              [-132.2554418609999, 53.161322333000044],
              [-132.27993730399993, 53.17267487200007],
              [-132.30166581899994, 53.19013092700004],
              [-132.31505286399994, 53.19806549700007],
              [-132.31969153599994, 53.19049713700008],
              [-132.3196508449999, 53.177801825000074],
              [-132.31871497299994, 53.169989325000074],
              [-132.3244522779999, 53.165269273000035],
              [-132.3377172519999, 53.16201406500005],
              [-132.3745011059999, 53.15729401200008],
              [-132.40054277299993, 53.14789459800005],
              [-132.41462154899995, 53.145738023000035],
              [-132.4433487619999, 53.14598216400003],
              [-132.45677649599992, 53.147772528000075],
              [-132.4695531889999, 53.15192291900007],
              [-132.46104895699995, 53.16364166900007],
              [-132.4578344389999, 53.17047760600008],
              [-132.4565323559999, 53.17682526200008],
              [-132.45958411399994, 53.184475002000056],
              [-132.46646074099993, 53.187486070000034],
              [-132.47325598899994, 53.186753648000035],
              [-132.4763891269999, 53.183294989000046],
              [-132.48452714799993, 53.16791413000004],
              [-132.5034073559999, 53.16742584800005],
              [-132.53844153599994, 53.17987702000005],
              [-132.53844153599994, 53.186712958000044],
              [-132.51793372299994, 53.19354889500005],
              [-132.5325414699999, 53.19867584800005],
              [-132.5642797519999, 53.20209381700005],
              [-132.5794164699999, 53.20722077000005],
            ],
          ],
          [
            [
              [-130.22915605399993, 54.118353583000044],
              [-130.24339758999992, 54.12262604400007],
              [-130.25352942599994, 54.13255442900004],
              [-130.26162675699993, 54.144191799000055],
              [-130.2698461579999, 54.15314362200007],
              [-130.25918535099993, 54.18211497600004],
              [-130.25279700399994, 54.190659898000035],
              [-130.2420141269999, 54.19578685100004],
              [-130.22777258999992, 54.19717031500005],
              [-130.21646074099993, 54.19440338700008],
              [-130.21458899599992, 54.18732330900008],
              [-130.18590247299994, 54.17987702000005],
              [-130.16250566299993, 54.16095612200007],
              [-130.15587317599994, 54.14158763200004],
              [-130.21353105399993, 54.12059153900003],
              [-130.22915605399993, 54.118353583000044],
            ],
          ],
          [
            [
              [-130.65404212099992, 54.118353583000044],
              [-130.6728409499999, 54.11277903900003],
              [-130.69762122299994, 54.114935614000046],
              [-130.71922766799992, 54.12327708500004],
              [-130.7285050119999, 54.136053778000075],
              [-130.73940995999993, 54.136419989000046],
              [-130.78994706899994, 54.161769924000055],
              [-130.80483964799993, 54.17365143400008],
              [-130.79434160099993, 54.186753648000035],
              [-130.78673255099994, 54.20254140800006],
              [-130.77603105399993, 54.214097398000035],
              [-130.75645911399994, 54.214544989000046],
              [-130.68106035099993, 54.17206452000005],
              [-130.6494034499999, 54.144598700000074],
              [-130.65404212099992, 54.118353583000044],
            ],
          ],
          [
            [
              [-130.35326087099992, 54.267645575000074],
              [-130.35610917899993, 54.26544830900008],
              [-130.3621313139999, 54.25844961100006],
              [-130.36538652299993, 54.255560614000046],
              [-130.37071692599994, 54.25226471600007],
              [-130.3693741529999, 54.24823639500005],
              [-130.36538652299993, 54.24249909100007],
              [-130.3943578769999, 54.25405508000006],
              [-130.4440811839999, 54.29120514500005],
              [-130.46910559799994, 54.303941148000035],
              [-130.46202551999994, 54.317694403000075],
              [-130.45091712099992, 54.32758209800005],
              [-130.43687903599994, 54.33266836100006],
              [-130.4206436839999, 54.33185455900008],
              [-130.3881729809999, 54.31102122600004],
              [-130.3797094389999, 54.303941148000035],
              [-130.3616430329999, 54.27802155200004],
              [-130.35484778599994, 54.27175527600008],
              [-130.3530167309999, 54.26898834800005],
              [-130.35326087099992, 54.267645575000074],
            ],
          ],
          [
            [
              [-130.35212154899995, 54.26772695500006],
              [-130.35204016799992, 54.268418687000064],
              [-130.35195878799993, 54.26902903900003],
              [-130.3523656889999, 54.269598700000074],
              [-130.35399329299992, 54.271999416000085],
              [-130.3542374339999, 54.29677969000005],
              [-130.3342992829999, 54.31976959800005],
              [-130.30504309799994, 54.333685614000046],
              [-130.27725175699993, 54.33185455900008],
              [-130.25304114499994, 54.31134674700007],
              [-130.26504472599993, 54.27879466400003],
              [-130.29845130099994, 54.25364817900004],
              [-130.3381241529999, 54.255560614000046],
              [-130.34679114499994, 54.261786200000074],
              [-130.35000566299993, 54.26504140800006],
              [-130.35212154899995, 54.26772695500006],
            ],
          ],
          [
            [
              [-130.76016191299993, 54.36200592700004],
              [-130.76964270699995, 54.38117096600007],
              [-130.75601152299993, 54.393866278000075],
              [-130.73330644399994, 54.403631903000075],
              [-130.71548417899993, 54.41380442900004],
              [-130.70864824099993, 54.40639883000006],
              [-130.7012426419999, 54.41380442900004],
              [-130.69863847599993, 54.40912506700005],
              [-130.69766191299993, 54.40424225500004],
              [-130.69497636599993, 54.40058014500005],
              [-130.6875707669999, 54.399603583000044],
              [-130.6901749339999, 54.39252350500004],
              [-130.69176184799994, 54.389837958000044],
              [-130.69497636599993, 54.38589101800005],
              [-130.69107011599993, 54.36709219000005],
              [-130.71336829299992, 54.35895416900007],
              [-130.74278723899994, 54.35834381700005],
              [-130.76016191299993, 54.36200592700004],
            ],
          ],
          [
            [
              [-130.74278723899994, 54.60561758000006],
              [-130.75572669199994, 54.57526276200008],
              [-130.7636612619999, 54.56273021000004],
              [-130.7769262359999, 54.55036041900007],
              [-130.8300675119999, 54.52130768400008],
              [-130.83836829299992, 54.51284414300005],
              [-130.9619034499999, 54.454779364000046],
              [-130.96910559799994, 54.46198151200008],
              [-130.9683324859999, 54.46979401200008],
              [-130.96426347599993, 54.477728583000044],
              [-130.9619034499999, 54.48517487200007],
              [-130.9619034499999, 54.53978099200003],
              [-130.9588110019999, 54.550034898000035],
              [-130.9451391269999, 54.56000397300005],
              [-130.9401749339999, 54.57294342700004],
              [-130.93106035099993, 54.58454010600008],
              [-130.9278051419999, 54.59137604400007],
              [-130.92910722599993, 54.597723700000074],
              [-130.9330948559999, 54.60541413000004],
              [-130.93521074099993, 54.61395905200004],
              [-130.9312231109999, 54.622707424000055],
              [-130.91710364499994, 54.630072333000044],
              [-130.89732825399994, 54.63373444200005],
              [-130.8799535799999, 54.630926825000074],
              [-130.87315833199995, 54.61928945500006],
              [-130.85415605399993, 54.630072333000044],
              [-130.83971106699994, 54.626166083000044],
              [-130.8257543609999, 54.61701080900008],
              [-130.80797278599994, 54.61180247600004],
              [-130.7927953769999, 54.61815013200004],
              [-130.7735082669999, 54.62946198100008],
              [-130.75698808499993, 54.63373444200005],
              [-130.7502335279999, 54.61928945500006],
              [-130.74868730399993, 54.61163971600007],
              [-130.7471410799999, 54.608587958000044],
              [-130.74278723899994, 54.60561758000006],
            ],
          ],
          [
            [
              [-130.59194902299993, 54.742173570000034],
              [-130.59805253799993, 54.74603913000004],
              [-130.6096899079999, 54.755519924000055],
              [-130.61510169199994, 54.76508209800005],
              [-130.6025284499999, 54.76947663000004],
              [-130.58873450399994, 54.770697333000044],
              [-130.57860266799992, 54.77391185100004],
              [-130.50987708199995, 54.80487702000005],
              [-130.48355058499993, 54.81037018400008],
              [-130.46157792899993, 54.80365631700005],
              [-130.4521378249999, 54.79389069200005],
              [-130.4343155589999, 54.76947663000004],
              [-130.4407445949999, 54.760646877000056],
              [-130.4526261059999, 54.73505280200004],
              [-130.45482337099992, 54.72508372600004],
              [-130.46178137899994, 54.712103583000044],
              [-130.4780167309999, 54.71234772300005],
              [-130.5100805329999, 54.72166575700004],
              [-130.51227779899995, 54.71775950700004],
              [-130.5217179029999, 54.71035390800006],
              [-130.5346573559999, 54.70604075700004],
              [-130.54727128799993, 54.71141185100004],
              [-130.55699622299994, 54.71930573100008],
              [-130.5816137359999, 54.73383209800005],
              [-130.59194902299993, 54.742173570000034],
            ],
          ],
          [
            [
              [-130.20836341099994, 54.81110260600008],
              [-130.2097875639999, 54.80304596600007],
              [-130.21275794199994, 54.797308661000045],
              [-130.21694902299993, 54.79328034100007],
              [-130.22203528599994, 54.78998444200005],
              [-130.2170304029999, 54.79043203300006],
              [-130.20152747299994, 54.78998444200005],
              [-130.20376542899993, 54.78339264500005],
              [-130.20628821499992, 54.76911041900007],
              [-130.20836341099994, 54.76264069200005],
              [-130.22130286399994, 54.74371979400007],
              [-130.23997962099992, 54.730536200000074],
              [-130.2835180329999, 54.714829820000034],
              [-130.29702714799993, 54.71234772300005],
              [-130.32437089799993, 54.710638739000046],
              [-130.3381241529999, 54.70799388200004],
              [-130.36449133999992, 54.69989655200004],
              [-130.3776749339999, 54.69818756700005],
              [-130.3762914699999, 54.70465729400007],
              [-130.34044348899994, 54.73688385600008],
              [-130.31948808499993, 54.75067780200004],
              [-130.27407792899993, 54.76512278900003],
              [-130.2331436839999, 54.80304596600007],
              [-130.20836341099994, 54.81110260600008],
            ],
          ],
          [
            [
              [-57.87144934799994, 54.81785716400003],
              [-57.877023891999954, 54.82965729400007],
              [-57.87047278599994, 54.834051825000074],
              [-57.857411261999914, 54.832017320000034],
              [-57.84357662699995, 54.82469310100004],
              [-57.85724850199995, 54.80337148600006],
              [-57.88198808499993, 54.79584381700005],
              [-57.9329320949999, 54.79743073100008],
              [-57.95612545499995, 54.79214101800005],
              [-58.00023352799991, 54.76609935100004],
              [-58.02228756399995, 54.75641510600008],
              [-58.053293423999946, 54.75307851800005],
              [-58.157093878999945, 54.76386139500005],
              [-58.16820227799991, 54.76780833500004],
              [-58.17625891799992, 54.77533600500004],
              [-58.179351365999935, 54.786810614000046],
              [-58.17955481699994, 54.80145905200004],
              [-58.181630011999914, 54.806301174000055],
              [-58.18785559799994, 54.80914948100008],
              [-58.200428839999915, 54.81785716400003],
              [-58.21324622299994, 54.832464911000045],
              [-58.22524980399993, 54.85301341400003],
              [-58.22736568899995, 54.87140534100007],
              [-58.21035722599993, 54.879339911000045],
              [-58.199777798999946, 54.876166083000044],
              [-58.18472245999993, 54.86200592700004],
              [-58.175892706999946, 54.85887278900003],
              [-58.16380774599992, 54.86151764500005],
              [-58.142567511999914, 54.87449778900003],
              [-58.13149980399993, 54.879339911000045],
              [-58.11986243399991, 54.88043854400007],
              [-58.09557044199994, 54.87840403900003],
              [-58.08372962099992, 54.879339911000045],
              [-58.073150193999936, 54.884100653000075],
              [-58.055897589999915, 54.89716217700004],
              [-58.0462133449999, 54.89980703300006],
              [-58.02415930899991, 54.90314362200007],
              [-57.982411261999914, 54.91754791900007],
              [-57.95962480399993, 54.92031484600005],
              [-57.95140540299991, 54.922756252000056],
              [-57.945301886999914, 54.92658112200007],
              [-57.94131425699993, 54.92560455900008],
              [-57.938710089999915, 54.89398834800005],
              [-57.946522589999915, 54.88690827000005],
              [-57.959543423999946, 54.884466864000046],
              [-57.973866339999915, 54.879339911000045],
              [-57.98180091099994, 54.870794989000046],
              [-57.987945115999935, 54.84955475500004],
              [-57.99437415299991, 54.838324286000045],
              [-57.99437415299991, 54.83152903900003],
              [-57.98546301999994, 54.82713450700004],
              [-57.98143469999991, 54.82078685100004],
              [-57.98224850199995, 54.81281159100007],
              [-57.987538214999915, 54.80365631700005],
              [-57.96947180899991, 54.806341864000046],
              [-57.93919837099992, 54.82754140800006],
              [-57.92951412699995, 54.828111070000034],
              [-57.91771399599992, 54.81810130400004],
              [-57.90184485599991, 54.80906810100004],
              [-57.88524329299992, 54.807074286000045],
              [-57.87144934799994, 54.81785716400003],
            ],
          ],
          [
            [
              [-130.4312231109999, 54.78998444200005],
              [-130.43814042899993, 54.79486725500004],
              [-130.44786536399994, 54.80658600500004],
              [-130.4568578769999, 54.820298570000034],
              [-130.46157792899993, 54.83152903900003],
              [-130.42113196499992, 54.850897528000075],
              [-130.2547094389999, 54.96967194200005],
              [-130.20400956899994, 55.02130768400008],
              [-130.18179277299993, 55.03156159100007],
              [-130.16738847599993, 55.01654694200005],
              [-130.15347245999993, 54.991441148000035],
              [-130.15005449099993, 54.96942780200004],
              [-130.15782630099994, 54.94773997600004],
              [-130.17735755099994, 54.92401764500005],
              [-130.1889542309999, 54.91461823100008],
              [-130.21349036399994, 54.89940013200004],
              [-130.22545325399994, 54.88959381700005],
              [-130.2585343089999, 54.843085028000075],
              [-130.2698461579999, 54.83152903900003],
              [-130.28209387899994, 54.82493724200003],
              [-130.3244522779999, 54.81110260600008],
              [-130.37075761599993, 54.78156159100007],
              [-130.39964758999992, 54.76943594000005],
              [-130.4094945949999, 54.76740143400008],
              [-130.4138891269999, 54.77317942900004],
              [-130.4312231109999, 54.78998444200005],
            ],
          ],
          [
            [
              [-60.74901282499991, 55.93451569200005],
              [-60.752837693999936, 55.91844310100004],
              [-60.73534094999991, 55.918850002000056],
              [-60.70921790299991, 55.925441799000055],
              [-60.687570766999954, 55.92829010600008],
              [-60.708973761999914, 55.903957424000055],
              [-60.74494381399995, 55.88690827000005],
              [-60.86514238199993, 55.86587148600006],
              [-60.88927161399994, 55.86579010600008],
              [-60.89981035099993, 55.87677643400008],
              [-60.88890540299991, 55.88589101800005],
              [-60.86388098899994, 55.88841380400004],
              [-60.81786048099991, 55.886704820000034],
              [-60.81786048099991, 55.89288971600007],
              [-60.85415605399993, 55.900051174000055],
              [-60.86978105399993, 55.90778229400007],
              [-60.87930253799993, 55.92084381700005],
              [-60.88003495999993, 55.93528880400004],
              [-60.87401282499991, 55.94782135600008],
              [-60.86375891799992, 55.95697663000004],
              [-60.85204016799992, 55.96185944200005],
              [-60.82762610599991, 55.94985586100006],
              [-60.802723761999914, 55.94623444200005],
              [-60.742176886999914, 55.94818756700005],
              [-60.74669348899994, 55.93781159100007],
              [-60.74901282499991, 55.93451569200005],
            ],
          ],
          [
            [
              [-61.00967363199993, 56.04376862200007],
              [-61.00967363199993, 56.037543036000045],
              [-60.95750891799992, 56.02610911700003],
              [-60.940663214999915, 56.01894765800006],
              [-60.955067511999914, 56.010199286000045],
              [-60.966786261999914, 56.00922272300005],
              [-61.00275631399995, 56.00991445500006],
              [-61.17414303299995, 56.032416083000044],
              [-61.20148678299995, 56.04376862200007],
              [-61.21703040299991, 56.057928778000075],
              [-61.231312628999945, 56.080145575000074],
              [-61.23232988199993, 56.09979889500005],
              [-61.2083227199999, 56.10643138200004],
              [-61.2083227199999, 56.09902578300006],
              [-61.215728318999936, 56.09902578300006],
              [-61.215728318999936, 56.09218984600005],
              [-61.20067298099991, 56.08307526200008],
              [-61.184478318999936, 56.08299388200004],
              [-61.14683997299994, 56.09218984600005],
              [-61.15269934799994, 56.102850653000075],
              [-61.1614477199999, 56.10492584800005],
              [-61.17137610599991, 56.10053131700005],
              [-61.18101966099994, 56.09218984600005],
              [-61.188384568999936, 56.107855536000045],
              [-61.171945766999954, 56.114935614000046],
              [-61.13377844999991, 56.11945221600007],
              [-61.13158118399991, 56.12759023600006],
              [-61.133656378999945, 56.13906484600005],
              [-61.13312740799995, 56.14915599200003],
              [-61.12295488199993, 56.153631903000075],
              [-61.11180579299992, 56.15420156500005],
              [-61.10383053299995, 56.15692780200004],
              [-61.09923255099994, 56.163316148000035],
              [-61.09845943899995, 56.174709377000056],
              [-61.082875128999945, 56.17007070500006],
              [-61.07852128799993, 56.16791413000004],
              [-61.043812628999945, 56.16107819200005],
              [-61.043812628999945, 56.153631903000075],
              [-61.06505286399994, 56.144964911000045],
              [-61.06558183499993, 56.13495514500005],
              [-61.053578253999945, 56.12579987200007],
              [-61.03697669199994, 56.11945221600007],
              [-60.96141516799992, 56.104803778000075],
              [-60.94078528599994, 56.09218984600005],
              [-60.95384680899991, 56.089544989000046],
              [-60.95929928299995, 56.08299388200004],
              [-60.96239173099991, 56.07416413000004],
              [-60.96865800699993, 56.06484609600005],
              [-60.97679602799991, 56.05833567900004],
              [-60.98656165299991, 56.05247630400004],
              [-60.99754798099991, 56.04755280200004],
              [-61.00967363199993, 56.04376862200007],
            ],
          ],
          [
            [
              [-61.413726365999935, 56.37335846600007],
              [-61.421945766999954, 56.36310455900008],
              [-61.45299231699994, 56.35736725500004],
              [-61.462147589999915, 56.345404364000046],
              [-61.44904537699995, 56.34365469000005],
              [-61.42682857999995, 56.334418036000045],
              [-61.413726365999935, 56.33234284100007],
              [-61.413726365999935, 56.32558828300006],
              [-61.462147589999915, 56.31875234600005],
              [-61.4759008449999, 56.318793036000045],
              [-61.49787350199995, 56.323553778000075],
              [-61.5969945949999, 56.333238023000035],
              [-61.70872962099992, 56.363267320000034],
              [-61.72964433499993, 56.37335846600007],
              [-61.74718176999994, 56.393866278000075],
              [-61.756418423999946, 56.40062083500004],
              [-61.76744544199994, 56.40477122600004],
              [-61.78868567599994, 56.40973541900007],
              [-61.79735266799992, 56.41429271000004],
              [-61.79735266799992, 56.421128648000035],
              [-61.577015753999945, 56.39297109600005],
              [-61.54409745999993, 56.393784898000035],
              [-61.55150305899991, 56.393784898000035],
              [-61.52871660099993, 56.39720286700003],
              [-61.5051977199999, 56.40460846600007],
              [-61.482492641999954, 56.40839264500005],
              [-61.462147589999915, 56.40062083500004],
              [-61.462147589999915, 56.40810781500005],
              [-61.45225989499994, 56.39935944200005],
              [-61.419992641999954, 56.38178131700005],
              [-61.413726365999935, 56.37335846600007],
            ],
          ],
          [
            [
              [-61.22883053299995, 56.45526764500005],
              [-61.21007239499994, 56.45058828300006],
              [-61.18809973899994, 56.454006252000056],
              [-61.166005011999914, 56.454779364000046],
              [-61.14683997299994, 56.44220612200007],
              [-61.37922115799995, 56.45221588700008],
              [-61.46743730399993, 56.46954987200007],
              [-61.48888098899994, 56.46954987200007],
              [-61.485259568999936, 56.466457424000055],
              [-61.47874915299991, 56.458644924000055],
              [-61.47520911399994, 56.45526764500005],
              [-61.48664303299995, 56.44525788000004],
              [-61.49941972599993, 56.44196198100008],
              [-61.512277798999946, 56.44525788000004],
              [-61.52358964799993, 56.45526764500005],
              [-61.516184048999946, 56.45526764500005],
              [-61.541574673999946, 56.46942780200004],
              [-61.57323157499991, 56.47089264500005],
              [-61.60562089799993, 56.46820709800005],
              [-61.63345292899993, 56.46954987200007],
              [-61.63345292899993, 56.47573476800005],
              [-61.61978105399993, 56.47573476800005],
              [-61.61978105399993, 56.48322174700007],
              [-61.62710527299993, 56.485988674000055],
              [-61.632069464999915, 56.489447333000044],
              [-61.63963782499991, 56.49689362200007],
              [-61.45091712099992, 56.478216864000046],
              [-61.42804928299995, 56.48322174700007],
              [-61.42711341099994, 56.49249909100007],
              [-61.45409094999991, 56.49884674700007],
              [-61.63345292899993, 56.51048411700003],
              [-61.62214107999995, 56.523871161000045],
              [-61.605539516999954, 56.52326080900008],
              [-61.58739173099991, 56.51968008000006],
              [-61.57140051999994, 56.52415599200003],
              [-61.58165442599994, 56.52968984600005],
              [-61.59137936099995, 56.53733958500004],
              [-61.605539516999954, 56.552069403000075],
              [-61.605539516999954, 56.558294989000046],
              [-61.59447180899991, 56.56049225500004],
              [-61.55772864499994, 56.558294989000046],
              [-61.53937740799995, 56.553900458000044],
              [-61.46231035099993, 56.550034898000035],
              [-61.44562740799995, 56.54482656500005],
              [-61.413726365999935, 56.53034088700008],
              [-61.38491777299993, 56.52391185100004],
              [-61.35586503799993, 56.52163320500006],
              [-61.330148891999954, 56.515326239000046],
              [-61.31135006399995, 56.49689362200007],
              [-61.351226365999935, 56.48476797100005],
              [-61.36656653599994, 56.48322174700007],
              [-61.36656653599994, 56.47573476800005],
              [-61.355580206999946, 56.47455475500004],
              [-61.33580481699994, 56.46979401200008],
              [-61.32559160099993, 56.46954987200007],
              [-61.31187903599994, 56.473089911000045],
              [-61.29914303299995, 56.48159414300005],
              [-61.226633266999954, 56.486761786000045],
              [-61.19322669199994, 56.48505280200004],
              [-61.16734778599994, 56.47573476800005],
              [-61.18455969999991, 56.47101471600007],
              [-61.20107988199993, 56.46914297100005],
              [-61.21617591099994, 56.46539948100008],
              [-61.22883053299995, 56.45526764500005],
            ],
          ],
          [
            [
              [-61.215728318999936, 56.585638739000046],
              [-61.2219945949999, 56.59064362200007],
              [-61.22960364499994, 56.60651276200008],
              [-61.23497473899994, 56.612941799000055],
              [-61.23399817599994, 56.618068752000056],
              [-61.23257402299993, 56.61945221600007],
              [-61.232411261999914, 56.62103913000004],
              [-61.23497473899994, 56.62653229400007],
              [-61.200062628999945, 56.64427317900004],
              [-61.19399980399993, 56.650458075000074],
              [-61.186431443999936, 56.66205475500004],
              [-61.168853318999936, 56.664943752000056],
              [-61.13377844999991, 56.661322333000044],
              [-61.13377844999991, 56.66754791900007],
              [-61.1536352199999, 56.67251211100006],
              [-61.16283118399991, 56.67597077000005],
              [-61.16734778599994, 56.68121979400007],
              [-61.164906378999945, 56.691839911000045],
              [-61.155181443999936, 56.69440338700008],
              [-61.14317786399994, 56.692287502000056],
              [-61.13377844999991, 56.688666083000044],
              [-61.115223761999914, 56.68829987200007],
              [-61.094960089999915, 56.684759833000044],
              [-61.082020636999914, 56.67792389500005],
              [-61.08543860599991, 56.66754791900007],
              [-61.08543860599991, 56.661322333000044],
              [-61.071156378999945, 56.661322333000044],
              [-61.080067511999914, 56.65119049700007],
              [-61.09902910099993, 56.63812897300005],
              [-61.10586503799993, 56.62653229400007],
              [-61.07062740799995, 56.63458893400008],
              [-61.057484503999945, 56.633978583000044],
              [-61.057484503999945, 56.62653229400007],
              [-61.071522589999915, 56.62579987200007],
              [-61.10586503799993, 56.612941799000055],
              [-61.152455206999946, 56.610256252000056],
              [-61.16734778599994, 56.60610586100006],
              [-61.188384568999936, 56.59039948100008],
              [-61.20067298099991, 56.58437734600005],
              [-61.215728318999936, 56.585638739000046],
            ],
          ],
          [
            [
              [-61.629750128999945, 56.84634023600006],
              [-61.634429490999935, 56.85248444200005],
              [-61.62572180899991, 56.86635976800005],
              [-61.605539516999954, 56.88727448100008],
              [-61.57111568899995, 56.90053945500006],
              [-61.540679490999935, 56.90770091400003],
              [-61.527007615999935, 56.914129950000074],
              [-61.52375240799995, 56.928168036000045],
              [-61.52375240799995, 56.94232819200005],
              [-61.51988684799994, 56.94871653900003],
              [-61.50438391799992, 56.95075104400007],
              [-61.49176998599995, 56.95490143400008],
              [-61.47883053299995, 56.95766836100006],
              [-61.462147589999915, 56.955511786000045],
              [-61.446156378999945, 56.94749583500004],
              [-61.42943274599992, 56.93659088700008],
              [-61.41185462099992, 56.92914459800005],
              [-61.39321855399993, 56.931626695000034],
              [-61.379017706999946, 56.93695709800005],
              [-61.362945115999935, 56.939886786000045],
              [-61.348500128999945, 56.93960195500006],
              [-61.33869381399995, 56.93504466400003],
              [-61.36851966099994, 56.90542226800005],
              [-61.394642706999946, 56.890611070000034],
              [-61.40689042899993, 56.87982819200005],
              [-61.39134680899991, 56.878159898000035],
              [-61.37767493399991, 56.87494538000004],
              [-61.36497962099992, 56.869208075000074],
              [-61.35228430899991, 56.85993073100008],
              [-61.370757615999935, 56.84707265800006],
              [-61.40111243399991, 56.83193594000005],
              [-61.43272864499994, 56.822251695000034],
              [-61.45531165299991, 56.825832424000055],
              [-61.44517981699994, 56.833319403000075],
              [-61.44570878799993, 56.839544989000046],
              [-61.45457923099991, 56.84406159100007],
              [-61.46898352799991, 56.84634023600006],
              [-61.48232988199993, 56.84349192900004],
              [-61.49547278599994, 56.83641185100004],
              [-61.50300045499995, 56.82916901200008],
              [-61.49567623599995, 56.821478583000044],
              [-61.500884568999936, 56.811835028000075],
              [-61.510609503999945, 56.80219147300005],
              [-61.51988684799994, 56.79783763200004],
              [-61.53099524599992, 56.79682038000004],
              [-61.560658331999946, 56.78978099200003],
              [-61.57140051999994, 56.784857489000046],
              [-61.57921301999994, 56.77871328300006],
              [-61.58470618399991, 56.77167389500005],
              [-61.58551998599995, 56.76430898600006],
              [-61.57884680899991, 56.75690338700008],
              [-61.56468665299991, 56.753973700000074],
              [-61.55093339799993, 56.759466864000046],
              [-61.53819739499994, 56.767238674000055],
              [-61.51699785099993, 56.774318752000056],
              [-61.49762936099995, 56.787990627000056],
              [-61.48574785099993, 56.791083075000074],
              [-61.470692511999914, 56.79047272300005],
              [-61.40135657499991, 56.78021881700005],
              [-61.38438880099994, 56.77216217700004],
              [-61.37547766799992, 56.75755442900004],
              [-61.37279212099992, 56.73305898600006],
              [-61.37279212099992, 56.69208405200004],
              [-61.377512173999946, 56.67796458500004],
              [-61.38825436099995, 56.675034898000035],
              [-61.39976966099994, 56.67450592700004],
              [-61.40689042899993, 56.66754791900007],
              [-61.40379798099991, 56.65766022300005],
              [-61.382476365999935, 56.644964911000045],
              [-61.37962805899991, 56.633978583000044],
              [-61.38841712099992, 56.62323639500005],
              [-61.40379798099991, 56.61945221600007],
              [-61.4348852199999, 56.620347398000035],
              [-61.45352128799993, 56.62604401200008],
              [-61.50991777299993, 56.66754791900007],
              [-61.52944902299993, 56.676662502000056],
              [-61.54039466099994, 56.67987702000005],
              [-61.55093339799993, 56.68121979400007],
              [-61.56114661399994, 56.68549225500004],
              [-61.57530676999994, 56.70425039300005],
              [-61.60171464799993, 56.714097398000035],
              [-61.61237545499995, 56.725816148000035],
              [-61.62572180899991, 56.73590729400007],
              [-61.64712480399993, 56.73647695500006],
              [-61.64712480399993, 56.743841864000046],
              [-61.633656378999945, 56.761786200000074],
              [-61.62413489499994, 56.79682038000004],
              [-61.62169348899994, 56.830959377000056],
              [-61.629750128999945, 56.84634023600006],
            ],
          ],
          [
            [
              [-61.612945115999935, 57.41547272300005],
              [-61.64728756399995, 57.40058014500005],
              [-61.68276933499993, 57.39956289300005],
              [-61.8489477199999, 57.41510651200008],
              [-61.890736456999946, 57.42755768400008],
              [-61.900380011999914, 57.44896067900004],
              [-61.88906816299993, 57.45522695500006],
              [-61.83145097599993, 57.46942780200004],
              [-61.79820716099994, 57.48383209800005],
              [-61.78380286399994, 57.49249909100007],
              [-61.77065995999993, 57.503607489000046],
              [-61.752023891999954, 57.52789948100008],
              [-61.74209550699993, 57.534857489000046],
              [-61.72280839799993, 57.538397528000075],
              [-61.679351365999935, 57.537543036000045],
              [-61.65933183499993, 57.53302643400008],
              [-61.64712480399993, 57.52411530200004],
              [-61.6419164699999, 57.52204010600008],
              [-61.63784745999993, 57.519964911000045],
              [-61.63508053299995, 57.51666901200008],
              [-61.63345292899993, 57.511053778000075],
              [-61.64952551999994, 57.51068756700005],
              [-61.66539466099994, 57.50739166900007],
              [-61.69493567599994, 57.49746328300006],
              [-61.68419348899994, 57.49310944200005],
              [-61.67235266799992, 57.490301825000074],
              [-61.65998287699995, 57.48924388200004],
              [-61.64712480399993, 57.489935614000046],
              [-61.64712480399993, 57.48309967700004],
              [-61.65697180899991, 57.47923411700003],
              [-61.67064368399991, 57.46759674700007],
              [-61.68065344999991, 57.46263255400004],
              [-61.69505774599992, 57.46039459800005],
              [-61.77110755099994, 57.462225653000075],
              [-61.79084225199995, 57.459418036000045],
              [-61.80736243399991, 57.451239325000074],
              [-61.82526607999995, 57.43528880400004],
              [-61.8137914699999, 57.43065013200004],
              [-61.79759680899991, 57.42877838700008],
              [-61.78307044199994, 57.430975653000075],
              [-61.77684485599991, 57.438788153000075],
              [-61.7688695949999, 57.44391510600008],
              [-61.75031490799995, 57.444973049000055],
              [-61.66681881399995, 57.43549225500004],
              [-61.612945115999935, 57.42169830900008],
              [-61.612945115999935, 57.41547272300005],
            ],
          ],
          [
            [
              [-61.85260982999995, 57.58612702000005],
              [-61.79271399599992, 57.556626695000034],
              [-61.77989661399994, 57.53611888200004],
              [-61.79393469999991, 57.50731028900003],
              [-61.81798255099994, 57.49469635600008],
              [-61.914051886999914, 57.45954010600008],
              [-61.92906653599994, 57.45612213700008],
              [-61.96275794199994, 57.473944403000075],
              [-61.99779212099992, 57.49909088700008],
              [-62.01707923099991, 57.51788971600007],
              [-62.01829993399991, 57.547308661000045],
              [-61.99828040299991, 57.572699286000045],
              [-61.96711178299995, 57.58942291900007],
              [-61.93517005099994, 57.592962958000044],
              [-61.95295162699995, 57.57070547100005],
              [-61.955148891999954, 57.559027411000045],
              [-61.94131425699993, 57.552069403000075],
              [-61.92613684799994, 57.55613841400003],
              [-61.908314581999946, 57.58392975500004],
              [-61.89415442599994, 57.592962958000044],
              [-61.88731848899994, 57.587225653000075],
              [-61.87718665299991, 57.58539459800005],
              [-61.85260982999995, 57.58612702000005],
            ],
          ],
          [
            [
              [-61.900380011999914, 57.76430898600006],
              [-61.88451087099992, 57.786322333000044],
              [-61.80040442599994, 57.844916083000044],
              [-61.78453528599994, 57.84625885600008],
              [-61.74950110599991, 57.83942291900007],
              [-61.73546301999994, 57.82807038000004],
              [-61.72671464799993, 57.82404205900008],
              [-61.71939042899993, 57.83478424700007],
              [-61.71133378799993, 57.83624909100007],
              [-61.702056443999936, 57.83535390800006],
              [-61.69493567599994, 57.833197333000044],
              [-61.69981848899994, 57.818793036000045],
              [-61.71703040299991, 57.79791901200008],
              [-61.72280839799993, 57.784816799000055],
              [-61.675892706999946, 57.79120514500005],
              [-61.65412350199995, 57.78998444200005],
              [-61.66075598899994, 57.77798086100006],
              [-61.653960740999935, 57.77798086100006],
              [-61.66030839799993, 57.769598700000074],
              [-61.66812089799993, 57.76325104400007],
              [-61.68809973899994, 57.75063711100006],
              [-61.68309485599991, 57.75112539300005],
              [-61.66759192599994, 57.75063711100006],
              [-61.67796790299991, 57.72793203300006],
              [-61.69367428299995, 57.72357819200005],
              [-61.71108964799993, 57.72524648600006],
              [-61.74518795499995, 57.71303945500006],
              [-61.76634680899991, 57.72028229400007],
              [-61.78624426999994, 57.73419830900008],
              [-61.80109615799995, 57.747259833000044],
              [-61.82217363199993, 57.75763580900008],
              [-61.82526607999995, 57.76117584800005],
              [-61.82526607999995, 57.76992422100005],
              [-61.826283331999946, 57.77757396000004],
              [-61.83031165299991, 57.78302643400008],
              [-61.83893795499995, 57.784816799000055],
              [-61.85411536399994, 57.77716705900008],
              [-61.8645727199999, 57.76382070500006],
              [-61.877512173999946, 57.75576406500005],
              [-61.900380011999914, 57.76430898600006],
            ],
          ],
          [
            [
              [-61.93138587099992, 57.795355536000045],
              [-61.959828253999945, 57.78953685100004],
              [-61.99250240799995, 57.80385976800005],
              [-62.025380011999914, 57.823431708000044],
              [-62.05431067599994, 57.833197333000044],
              [-62.06468665299991, 57.829413153000075],
              [-62.08771725199995, 57.81525299700007],
              [-62.09215247299994, 57.81586334800005],
              [-62.09666907499991, 57.82925039300005],
              [-62.10423743399991, 57.833644924000055],
              [-62.10578365799995, 57.83856842700004],
              [-62.09215247299994, 57.85370514500005],
              [-62.04116777299993, 57.89402903900003],
              [-62.01130123599995, 57.90924713700008],
              [-61.98232988199993, 57.91510651200008],
              [-61.93138587099992, 57.91510651200008],
              [-61.92105058499993, 57.909409898000035],
              [-61.92516028599994, 57.89642975500004],
              [-61.94131425699993, 57.87417226800005],
              [-61.886708136999914, 57.87417226800005],
              [-61.87173417899993, 57.84845612200007],
              [-61.87189693899995, 57.839911200000074],
              [-61.88048255099994, 57.82575104400007],
              [-61.89171301999994, 57.81500885600008],
              [-61.91759192599994, 57.80385976800005],
              [-61.93138587099992, 57.795355536000045],
            ],
          ],
          [
            [
              [-69.10197057699992, 59.131323217000045],
              [-69.08190562699991, 59.11238667400005],
              [-69.06496605799992, 59.09466071500003],
              [-69.06131108499994, 59.07658107300006],
              [-69.10202745099991, 59.06631667600004],
              [-69.0818008519999, 59.06140590600006],
              [-69.1241085819999, 59.04672560100005],
              [-69.14682373699992, 59.03798132700007],
              [-69.15475191999991, 59.02595014500008],
              [-69.17503821499992, 59.017238674000055],
              [-69.17796790299991, 59.01129791900007],
              [-69.21719316299993, 58.99445221600007],
              [-69.23151607999995, 58.98065827000005],
              [-69.21890214799993, 58.96344635600008],
              [-69.23766028599994, 58.95416901200008],
              [-69.25674394399994, 58.96039459800005],
              [-69.29458574099993, 58.98395416900007],
              [-69.30418860599991, 58.96356842700004],
              [-69.32209225199995, 58.95075104400007],
              [-69.34361731699994, 58.94940827000005],
              [-69.36351477799991, 58.96344635600008],
              [-69.35431881399995, 58.973822333000044],
              [-69.33259029899995, 58.99282461100006],
              [-69.32258053299995, 59.005072333000044],
              [-69.32144120999993, 59.009833075000074],
              [-69.32258053299995, 59.028957424000055],
              [-69.31920325399994, 59.03266022300005],
              [-69.31167558499993, 59.03668854400007],
              [-69.30418860599991, 59.04193756700005],
              [-69.29637610599991, 59.06077708500004],
              [-69.28864498599995, 59.064886786000045],
              [-69.28624426999994, 59.06981028900003],
              [-69.29771887899994, 59.08388906500005],
              [-69.33560136599993, 59.11432526200008],
              [-69.35415605399993, 59.14057038000004],
              [-69.33726966099994, 59.146185614000046],
              [-69.30931555899991, 59.14520905200004],
              [-69.29458574099993, 59.15184153900003],
              [-69.23497473899994, 59.15306224200003],
              [-69.19847571499992, 59.14858633000006],
              [-69.16588785099992, 59.145192800000075],
              [-69.15194445999992, 59.13472397000004],
              [-69.11433516399995, 59.14220012800007],
              [-69.10197057699992, 59.131323217000045],
            ],
          ],
          [
            [
              [-64.07896887899994, 59.79954661700003],
              [-64.05882727799991, 59.78538646000004],
              [-63.98570716099994, 59.77094147300005],
              [-63.962880011999914, 59.75177643400008],
              [-63.97398841099994, 59.74603913000004],
              [-63.99132239499994, 59.727769273000035],
              [-64.00080318899995, 59.723822333000044],
              [-64.05211341099994, 59.72345612200007],
              [-64.06826738199993, 59.71942780200004],
              [-64.10692298099991, 59.70331452000005],
              [-64.12409420499995, 59.69989655200004],
              [-64.13902747299994, 59.700873114000046],
              [-64.16905676999994, 59.710150458000044],
              [-64.14928137899994, 59.721136786000045],
              [-64.14167232999995, 59.723822333000044],
              [-64.15758216099994, 59.730129299000055],
              [-64.17528235599991, 59.73102448100008],
              [-64.19163977799991, 59.733587958000044],
              [-64.20311438699991, 59.74494049700007],
              [-64.19615637899994, 59.76080963700008],
              [-64.19115149599992, 59.76703522300005],
              [-64.18260657499991, 59.77220286700003],
              [-64.16893469999991, 59.77358633000006],
              [-64.15453040299991, 59.76902903900003],
              [-64.14024817599994, 59.76268138200004],
              [-64.12743079299992, 59.75861237200007],
              [-64.13158118399991, 59.76813385600008],
              [-64.13784745999993, 59.77631256700005],
              [-64.14590410099993, 59.782538153000075],
              [-64.15534420499995, 59.78652578300006],
              [-64.13036048099991, 59.84202708500004],
              [-64.12059485599991, 59.85419342700004],
              [-64.10191809799994, 59.862982489000046],
              [-64.07970130099994, 59.866441148000035],
              [-64.05919348899994, 59.86375560100004],
              [-64.04548092399995, 59.85419342700004],
              [-64.04922441299993, 59.85130442900004],
              [-64.05972245999993, 59.841131903000075],
              [-64.05345618399991, 59.83079661700003],
              [-64.03184973899994, 59.80573151200008],
              [-64.07896887899994, 59.79954661700003],
            ],
          ],
          [
            [
              [-107.87535559799994, 66.94306061400005],
              [-107.86436926999994, 66.97020091400003],
              [-107.83910071499992, 67.00067780200004],
              [-107.81151282499991, 67.01520416900007],
              [-107.79344641799992, 66.99457428600005],
              [-107.79727128799993, 66.97353750200006],
              [-107.81908118399991, 66.91909414300005],
              [-107.83067786399994, 66.90265534100007],
              [-107.85423743399991, 66.88617584800005],
              [-107.88857988199993, 66.86709219000005],
              [-107.92398027299993, 66.85468170800004],
              [-107.9505102199999, 66.85797760600008],
              [-107.90196692599994, 66.89232005400004],
              [-107.88304602799991, 66.91400788000004],
              [-107.87535559799994, 66.94306061400005],
            ],
          ],
          [
            [
              [-108.04670162699995, 66.98151276200008],
              [-107.99364173099991, 66.95600006700005],
              [-107.9668676419999, 66.94928620000007],
              [-107.9368383449999, 66.95355866100005],
              [-107.96735592399995, 66.93573639500005],
              [-107.97472083199995, 66.92999909100007],
              [-107.97911536399994, 66.92731354400007],
              [-107.98420162699995, 66.92645905200004],
              [-107.99518795499995, 66.92694733300004],
              [-107.99937903599994, 66.92503489800004],
              [-107.99901282499991, 66.92080312700006],
              [-107.9976293609999, 66.91596100500004],
              [-107.99889075399994, 66.91258372600004],
              [-108.01939856699994, 66.90403880400004],
              [-108.03677324099993, 66.90232982000003],
              [-108.04898027299993, 66.91010163000004],
              [-108.0535375639999, 66.92999909100007],
              [-108.09821529899995, 66.97406647300005],
              [-108.09557044199994, 66.98236725500004],
              [-108.09805253799993, 67.00141022300005],
              [-108.10488847599993, 67.02252838700008],
              [-108.11497962099992, 67.03681061400005],
              [-108.09902910099993, 67.02460358300004],
              [-108.07884680899991, 67.01288483300004],
              [-108.06285559799994, 67.00096263200004],
              [-108.05972245999993, 66.98834870000007],
              [-108.04670162699995, 66.98151276200008],
            ],
          ],
          [
            [
              [-107.41665605399993, 67.11871979400007],
              [-107.34251868399991, 67.11074453300006],
              [-107.32046464799993, 67.10443756700005],
              [-107.34552975199995, 67.08881256700005],
              [-107.3836156889999, 67.08372630400004],
              [-107.51748613199993, 67.08197663000004],
              [-107.54356848899994, 67.08844635600008],
              [-107.56688391799992, 67.10443756700005],
              [-107.61465410099993, 67.16583893400008],
              [-107.62612870999993, 67.18838125200006],
              [-107.62417558499993, 67.20453522300005],
              [-107.60875403599994, 67.21002838700008],
              [-107.57994544199994, 67.20062897300005],
              [-107.5601293609999, 67.18528880400004],
              [-107.41665605399993, 67.11871979400007],
            ],
          ],
          [
            [
              [-108.00572669199994, 67.37197500200006],
              [-108.03844153599994, 67.37384674700007],
              [-108.08495032499991, 67.38300202000005],
              [-108.12759355399993, 67.39671458500004],
              [-108.14907792899993, 67.41290924700007],
              [-108.13768469999991, 67.42275625200006],
              [-108.12840735599991, 67.42169830900008],
              [-108.1184789699999, 67.41620514500005],
              [-108.09105383999992, 67.41034577000005],
              [-108.0398656889999, 67.39240143400008],
              [-108.04210364499994, 67.39663320500006],
              [-108.04336503799993, 67.40058014500005],
              [-108.04112708199995, 67.40558502800008],
              [-108.03237870999993, 67.41290924700007],
              [-108.0808813139999, 67.42649974200003],
              [-108.05199133999992, 67.44647858300004],
              [-107.97386633999992, 67.45783112200007],
              [-107.9505102199999, 67.47500234600005],
              [-107.97158769399994, 67.48114655200004],
              [-107.94107011599993, 67.48281484600005],
              [-107.91966712099992, 67.48769765800006],
              [-107.9016820949999, 67.48590729400007],
              [-107.88158118399991, 67.46747467700004],
              [-107.88658606699994, 67.45262278900003],
              [-107.88658606699994, 67.42194245000007],
              [-107.88902747299994, 67.40607330900008],
              [-107.89932206899994, 67.38910553600005],
              [-107.92715410099993, 67.37091705900008],
              [-107.9368383449999, 67.35765208500004],
              [-107.92064368399991, 67.34735748900005],
              [-107.9075414699999, 67.33144765800006],
              [-107.90733801999994, 67.31683991100005],
              [-107.92967688699991, 67.31049225500004],
              [-107.95299231699994, 67.31610748900005],
              [-108.01317298099991, 67.35765208500004],
              [-108.01146399599992, 67.36151764500005],
              [-108.01060950399994, 67.36469147300005],
              [-108.00914466099994, 67.36790599200003],
              [-108.00572669199994, 67.37197500200006],
            ],
          ],
          [
            [
              [-108.28693600199995, 67.53579336100006],
              [-108.30264238199993, 67.52659739800004],
              [-108.30313066299993, 67.51585521000004],
              [-108.29881751199991, 67.50495026200008],
              [-108.29991614499994, 67.49481842700004],
              [-108.31358801999994, 67.48834870000007],
              [-108.38247636599993, 67.46747467700004],
              [-108.41958574099993, 67.47186920800004],
              [-108.4527074859999, 67.48883698100008],
              [-108.47984778599994, 67.51215241100005],
              [-108.49917558499993, 67.53579336100006],
              [-108.48839270699995, 67.53514232000003],
              [-108.48094641799992, 67.53668854400007],
              [-108.47557532499991, 67.54116445500006],
              [-108.47126217399995, 67.54950592700004],
              [-108.47728430899991, 67.55231354400007],
              [-108.49233964799993, 67.56370677300004],
              [-108.45824133999992, 67.57367584800005],
              [-108.42568925699993, 67.56610748900005],
              [-108.39370683499993, 67.55377838700008],
              [-108.3613988919999, 67.54950592700004],
              [-108.34825598899994, 67.55353424700007],
              [-108.33967037699995, 67.55963776200008],
              [-108.3301488919999, 67.56415436400005],
              [-108.31419837099992, 67.56370677300004],
              [-108.3020727199999, 67.56049225500004],
              [-108.29332434799994, 67.55548737200007],
              [-108.28819739499994, 67.54759349200003],
              [-108.28693600199995, 67.53579336100006],
            ],
          ],
          [
            [
              [-108.12865149599992, 67.64569733300004],
              [-108.1214086579999, 67.66665273600006],
              [-108.11196855399993, 67.67597077000005],
              [-108.09707597599993, 67.67719147300005],
              [-108.02550208199995, 67.66762929900005],
              [-108.00381425699993, 67.66054922100005],
              [-107.98521887899994, 67.64569733300004],
              [-107.96271725199995, 67.59780508000006],
              [-107.95421301999994, 67.59039948100008],
              [-107.94554602799991, 67.58466217700004],
              [-107.93468176999994, 67.57160065300008],
              [-107.92568925699993, 67.55780670800004],
              [-107.92251542899993, 67.54950592700004],
              [-107.93455969999991, 67.53701406500005],
              [-107.9531957669999, 67.53510163000004],
              [-107.9702856109999, 67.54132721600007],
              [-107.97777258999992, 67.55316803600005],
              [-107.99071204299992, 67.54873281500005],
              [-108.05117753799993, 67.54588450700004],
              [-108.07030188699991, 67.53949616100005],
              [-108.0711156889999, 67.53156159100007],
              [-108.06216386599993, 67.52610911700003],
              [-108.0432836579999, 67.51935455900008],
              [-108.03465735599991, 67.50910065300008],
              [-108.03490149599992, 67.50438060100004],
              [-108.04019120999993, 67.50104401200008],
              [-108.0618383449999, 67.48102448100008],
              [-108.0847875639999, 67.46954987200007],
              [-108.1057836579999, 67.46820709800005],
              [-108.11497962099992, 67.48493073100008],
              [-108.11876380099994, 67.50189850500004],
              [-108.12743079299992, 67.51129791900007],
              [-108.13662675699993, 67.51870351800005],
              [-108.14224199099993, 67.52960846600007],
              [-108.13756262899994, 67.55052317900004],
              [-108.11856035099993, 67.55707428600005],
              [-108.09430904899995, 67.55841705900008],
              [-108.07339433499993, 67.56370677300004],
              [-108.10704505099994, 67.57453034100007],
              [-108.11864173099991, 67.58295319200005],
              [-108.12865149599992, 67.59788646000004],
              [-108.13320878799993, 67.61220937700006],
              [-108.13345292899993, 67.62494538000004],
              [-108.12865149599992, 67.64569733300004],
            ],
          ],
          [
            [
              [-97.4317113919999, 67.70770905200004],
              [-97.41372636599993, 67.72215403900003],
              [-97.39281165299991, 67.73432038000004],
              [-97.36742102799991, 67.73826732000003],
              [-97.33608964799993, 67.72821686400005],
              [-97.33336341099994, 67.69464752800008],
              [-97.3352758449999, 67.67975495000007],
              [-97.34605872299994, 67.67357005400004],
              [-97.36701412699995, 67.66917552300004],
              [-97.4317113919999, 67.63947174700007],
              [-97.51813717399995, 67.62425364800004],
              [-97.53783118399991, 67.62889232000003],
              [-97.55117753799993, 67.64533112200007],
              [-97.55308997299994, 67.65737539300005],
              [-97.54478919199994, 67.66803620000007],
              [-97.52790279899995, 67.68040599200003],
              [-97.54430091099994, 67.68870677300004],
              [-97.56200110599991, 67.69403717700004],
              [-97.52904212099992, 67.69847239800004],
              [-97.46056067599994, 67.69611237200007],
              [-97.4317113919999, 67.70770905200004],
            ],
          ],
          [
            [
              [-109.2117406889999, 67.78969961100006],
              [-109.1206762359999, 67.80963776200008],
              [-109.07070878799993, 67.81098053600005],
              [-109.03978430899991, 67.78969961100006],
              [-109.04710852799991, 67.79035065300008],
              [-109.05068925699993, 67.78815338700008],
              [-109.05235755099994, 67.78497955900008],
              [-109.05406653599994, 67.78286367400005],
              [-109.1360570949999, 67.76813385600008],
              [-109.17951412699995, 67.76911041900007],
              [-109.2117406889999, 67.78969961100006],
            ],
          ],
          [
            [
              [-114.13727779899995, 67.88764069200005],
              [-114.08629309799994, 67.88239166900007],
              [-113.97451738199993, 67.89179108300004],
              [-113.92650305899991, 67.87909577000005],
              [-113.96930904899995, 67.88068268400008],
              [-113.99058997299994, 67.87897370000007],
              [-114.00841223899994, 67.87221914300005],
              [-114.23778235599991, 67.87909577000005],
              [-114.25234941299993, 67.88141510600008],
              [-114.28062903599994, 67.89142487200007],
              [-114.2964574859999, 67.89272695500006],
              [-114.2964574859999, 67.89956289300005],
              [-114.25723222599993, 67.90729401200008],
              [-114.21629798099991, 67.90619538000004],
              [-114.13727779899995, 67.88764069200005],
            ],
          ],
          [
            [
              [-113.44603430899991, 67.92682526200008],
              [-113.34129798099991, 67.93895091400003],
              [-113.28433183499993, 67.93854401200008],
              [-113.24803626199991, 67.91998932500007],
              [-113.27074133999992, 67.91185130400004],
              [-113.29527747299994, 67.90631745000007],
              [-113.52843176999994, 67.89524974200003],
              [-113.60374915299991, 67.90631745000007],
              [-113.58389238199993, 67.91425202000005],
              [-113.55858313699991, 67.91608307500007],
              [-113.42153886599993, 67.90696849200003],
              [-113.39891516799992, 67.91376373900005],
              [-113.41002356699994, 67.91819896000004],
              [-113.42186438699991, 67.92047760600008],
              [-113.43394934799994, 67.92084381700005],
              [-113.44603430899991, 67.91998932500007],
              [-113.44603430899991, 67.92682526200008],
            ],
          ],
          [
            [
              [-111.08934485599991, 67.86542389500005],
              [-111.06725012899994, 67.87889232000003],
              [-110.94591223899994, 67.91376373900005],
              [-110.84447180899991, 67.95555247600004],
              [-110.8081762359999, 67.96100495000007],
              [-110.80825761599993, 67.95673248900005],
              [-110.80955969999991, 67.95380280200004],
              [-110.81432044199994, 67.94794342700004],
              [-110.83120683499993, 67.93756745000007],
              [-110.85936438699991, 67.90289948100008],
              [-110.87865149599992, 67.89252350500004],
              [-110.95213782499991, 67.88589101800005],
              [-111.03180904899995, 67.86273834800005],
              [-111.07530676999994, 67.85529205900008],
              [-111.08934485599991, 67.86542389500005],
            ],
          ],
          [
            [
              [-108.0535375639999, 67.95477936400005],
              [-108.05557206899994, 67.92430247600004],
              [-108.06932532499991, 67.90037669500003],
              [-108.09219316299993, 67.88471100500004],
              [-108.12181555899991, 67.87909577000005],
              [-108.1907445949999, 67.88589101800005],
              [-108.22923743399991, 67.88174062700006],
              [-108.24787350199995, 67.88296133000006],
              [-108.25894120999993, 67.89272695500006],
              [-108.24022376199991, 67.89760976800005],
              [-108.23741614499994, 67.90668366100005],
              [-108.23940995999993, 67.91819896000004],
              [-108.23509680899991, 67.93056875200006],
              [-108.2222387359999, 67.94188060100004],
              [-108.20840410099993, 67.94965241100005],
              [-108.1770727199999, 67.96100495000007],
              [-108.10440019399994, 67.97850169500003],
              [-108.06761633999992, 67.97650788000004],
              [-108.0535375639999, 67.95477936400005],
            ],
          ],
          [
            [
              [-108.91071529899995, 67.91998932500007],
              [-108.88198808499993, 67.91771067900004],
              [-108.87340247299994, 67.90070221600007],
              [-108.88329016799992, 67.88141510600008],
              [-108.91006425699993, 67.87221914300005],
              [-108.94107011599993, 67.87588125200006],
              [-109.13923092399995, 67.93284739800004],
              [-109.18468176999994, 67.95734284100007],
              [-109.19810950399994, 67.99510325700004],
              [-109.16319739499994, 67.98053620000007],
              [-109.04723059799994, 67.95477936400005],
              [-109.06737219999991, 67.97064850500004],
              [-109.07457434799994, 67.97528717700004],
              [-109.0579320949999, 67.97540924700007],
              [-109.01280676999994, 67.96841054900005],
              [-109.00625566299993, 67.97040436400005],
              [-108.99754798099991, 67.97907135600008],
              [-108.99258378799993, 67.98151276200008],
              [-108.98241126199991, 67.98139069200005],
              [-108.9351293609999, 67.97064850500004],
              [-108.90160071499992, 67.95750560100004],
              [-108.88585364499994, 67.95477936400005],
              [-108.88536536399994, 67.94985586100006],
              [-108.91071529899995, 67.91998932500007],
            ],
          ],
          [
            [
              [-98.96666419199994, 68.07086823100008],
              [-98.96690833199995, 68.04218170800004],
              [-98.96886145699995, 68.02879466400003],
              [-98.97350012899994, 68.01618073100008],
              [-98.96275794199994, 68.01439036700003],
              [-98.93248450399994, 68.00259023600006],
              [-98.95400956899994, 67.98509349200003],
              [-98.98192298099991, 67.98224518400008],
              [-99.00999915299991, 67.99030182500007],
              [-99.03184973899994, 68.00600820500006],
              [-99.0384008449999, 68.01410553600005],
              [-99.04649817599994, 68.02692291900007],
              [-99.0523168609999, 68.03327057500007],
              [-99.07778886599993, 68.04979075700004],
              [-99.08336341099994, 68.05719635600008],
              [-99.05386308499993, 68.05206940300008],
              [-98.99181067599994, 68.07660553600005],
              [-98.96666419199994, 68.07086823100008],
            ],
          ],
          [
            [
              [-109.35570227799991, 68.05719635600008],
              [-109.33535722599993, 68.04710521000004],
              [-109.31680253799993, 68.02993398600006],
              [-109.30821692599994, 68.00836823100008],
              [-109.31753495999993, 67.98517487200007],
              [-109.34239661399994, 67.98118724200003],
              [-109.38345292899993, 67.98940664300005],
              [-109.52448482999995, 68.04376862200007],
              [-109.54751542899993, 68.05719635600008],
              [-109.52904212099992, 68.05426666900007],
              [-109.50621497299994, 68.04730866100005],
              [-109.4851781889999, 68.04364655200004],
              [-109.47179114499994, 68.05036041900007],
              [-109.47252356699994, 68.06183502800008],
              [-109.48241126199991, 68.07282135600008],
              [-109.4956762359999, 68.08124420800004],
              [-109.50658118399991, 68.08510976800005],
              [-109.49771074099993, 68.09577057500007],
              [-109.48387610599991, 68.09931061400005],
              [-109.45132402299993, 68.09813060100004],
              [-109.42503821499992, 68.08991120000007],
              [-109.41462154899995, 68.08417389500005],
              [-109.41030839799993, 68.07420482000003],
              [-109.40355383999992, 68.06317780200004],
              [-109.38768469999991, 68.05923086100006],
              [-109.35570227799991, 68.05719635600008],
            ],
          ],
          [
            [
              [-110.06143144399994, 68.09813060100004],
              [-110.01475989499994, 68.10781484600005],
              [-109.96739661399994, 68.12669505400004],
              [-109.92064368399991, 68.13983795800004],
              [-109.87584387899994, 68.13226959800005],
              [-109.87608801999994, 68.12783437700006],
              [-109.87767493399991, 68.12470123900005],
              [-109.91392981699994, 68.08832428600005],
              [-109.96011308499993, 68.07965729400007],
              [-110.01065019399994, 68.07758209800005],
              [-110.07774817599994, 68.05878327000005],
              [-110.10399329299992, 68.05609772300005],
              [-110.15762285099993, 68.05719635600008],
              [-110.18175208199995, 68.05272044500003],
              [-110.20665442599994, 68.04425690300008],
              [-110.23241126199991, 68.03856028900003],
              [-110.25942949099993, 68.04291413000004],
              [-110.21841386599993, 68.06443919500003],
              [-110.16478430899991, 68.08201732000003],
              [-110.1089574859999, 68.09381745000007],
              [-110.06143144399994, 68.09813060100004],
            ],
          ],
          [
            [
              [-109.85602779899995, 68.15961334800005],
              [-109.78482011599993, 68.18089427300004],
              [-109.64317786399994, 68.24262116100005],
              [-109.56798255099994, 68.24957916900007],
              [-109.57433020699995, 68.24225495000007],
              [-109.58165442599994, 68.23590729400007],
              [-109.59585527299993, 68.21832916900007],
              [-109.61782792899993, 68.21694570500006],
              [-109.6421606109999, 68.21954987200007],
              [-109.66356360599991, 68.21426015800006],
              [-109.67503821499992, 68.20172760600008],
              [-109.67662512899994, 68.19245026200008],
              [-109.68040930899991, 68.18382396000004],
              [-109.69835364499994, 68.17328522300005],
              [-109.78197180899991, 68.14264557500007],
              [-109.82933508999992, 68.13812897300005],
              [-109.85602779899995, 68.15961334800005],
            ],
          ],
          [
            [
              [-111.65786699099993, 68.30418528900003],
              [-111.52867591099994, 68.31403229400007],
              [-111.50023352799991, 68.30418528900003],
              [-111.50633704299992, 68.29913971600007],
              [-111.51276607999995, 68.29694245000007],
              [-111.54784094999991, 68.29669830900008],
              [-111.5991918609999, 68.28994375200006],
              [-111.61693274599992, 68.28314850500004],
              [-111.62954667899993, 68.27024974200003],
              [-111.63589433499993, 68.24705638200004],
              [-111.6448461579999, 68.23590729400007],
              [-111.67699133999992, 68.22532786700003],
              [-111.72606360599991, 68.22150299700007],
              [-111.76870683499993, 68.22992584800005],
              [-111.78136145699995, 68.25580475500004],
              [-111.77061926999994, 68.26740143400008],
              [-111.7515356109999, 68.27472565300008],
              [-111.71934973899994, 68.28314850500004],
              [-111.71715247299994, 68.28864166900007],
              [-111.71939042899993, 68.29559967700004],
              [-111.72008216099994, 68.30170319200005],
              [-111.71275794199994, 68.30418528900003],
              [-111.65786699099993, 68.30418528900003],
            ],
          ],
          [
            [
              [-100.09068762899994, 68.37250397300005],
              [-100.07774817599994, 68.36261627800008],
              [-100.07868404899995, 68.35468170800004],
              [-100.08556067599994, 68.34699127800008],
              [-100.09068762899994, 68.33771393400008],
              [-100.08836829299992, 68.29987213700008],
              [-100.09068762899994, 68.29059479400007],
              [-100.12096106699994, 68.27863190300008],
              [-100.16315670499995, 68.28823476800005],
              [-100.23403886599993, 68.32404205900008],
              [-100.20067298099991, 68.32737864800004],
              [-100.15550696499992, 68.33759186400005],
              [-100.12075761599993, 68.35488515800006],
              [-100.11864173099991, 68.37929922100005],
              [-100.11001542899993, 68.38051992400005],
              [-100.10313880099994, 68.37938060100004],
              [-100.09703528599994, 68.37653229400007],
              [-100.09068762899994, 68.37250397300005],
            ],
          ],
          [
            [
              [-110.83604895699995, 68.55068594000005],
              [-110.79865475199995, 68.54852936400005],
              [-110.75572669199994, 68.53583405200004],
              [-110.71873938699991, 68.51504140800006],
              [-110.69888261599993, 68.48859284100007],
              [-110.72427324099993, 68.48773834800005],
              [-110.73241126199991, 68.48859284100007],
              [-110.9024145169999, 68.46987539300005],
              [-111.08218339799993, 68.47492096600007],
              [-111.09520423099991, 68.48004791900007],
              [-111.07909094999991, 68.49160390800006],
              [-111.03404700399994, 68.50967031500005],
              [-110.83604895699995, 68.55068594000005],
            ],
          ],
          [
            [
              [-110.64427649599992, 68.55068594000005],
              [-110.52074133999992, 68.55068594000005],
              [-110.55247962099992, 68.52871328300006],
              [-110.61432857999995, 68.52260976800005],
              [-110.68077551999994, 68.52708567900004],
              [-110.72618567599994, 68.53701406500005],
              [-110.7376195949999, 68.54364655200004],
              [-110.75259355399993, 68.55532461100006],
              [-110.76048743399991, 68.56622955900008],
              [-110.75039628799993, 68.57111237200007],
              [-110.6875707669999, 68.56757233300004],
              [-110.65729732999995, 68.56915924700007],
              [-110.62999426999994, 68.57855866100005],
              [-110.62254798099991, 68.57111237200007],
              [-110.62999426999994, 68.56427643400008],
              [-110.63369706899994, 68.56167226800005],
              [-110.63634192599994, 68.55914948100008],
              [-110.63931230399993, 68.55744049700007],
              [-110.64427649599992, 68.55744049700007],
              [-110.64427649599992, 68.55068594000005],
            ],
          ],
          [
            [
              [-104.49014238199993, 68.51585521000004],
              [-104.47850501199991, 68.51333242400005],
              [-104.46837317599994, 68.50702545800004],
              [-104.45230058499993, 68.49192942900004],
              [-104.42943274599992, 68.44497304900005],
              [-104.46580969999991, 68.41689687700006],
              [-104.52892005099994, 68.40330638200004],
              [-104.65518144399994, 68.39801666900007],
              [-104.71524003799993, 68.41461823100008],
              [-104.7727758449999, 68.42348867400005],
              [-104.80540930899991, 68.43756745000007],
              [-104.86253821499992, 68.44635651200008],
              [-104.90135657499991, 68.45783112200007],
              [-105.00405839799993, 68.50967031500005],
              [-105.04161536399994, 68.53851959800005],
              [-105.06216386599993, 68.54950592700004],
              [-105.0860082669999, 68.55068594000005],
              [-104.99087480399993, 68.57855866100005],
              [-104.88890540299991, 68.58734772300005],
              [-104.68130449099993, 68.57855866100005],
              [-104.65074622299994, 68.56696198100008],
              [-104.57567298099991, 68.55438873900005],
              [-104.51988684799994, 68.52643463700008],
              [-104.49014238199993, 68.51585521000004],
            ],
          ],
          [
            [
              [-113.96743730399993, 68.61212799700007],
              [-113.9553930329999, 68.61831289300005],
              [-113.94188391799992, 68.62030670800004],
              [-113.8352758449999, 68.61444733300004],
              [-113.7620336579999, 68.59780508000006],
              [-113.79576575399994, 68.58173248900005],
              [-113.96743730399993, 68.59780508000006],
              [-113.96003170499989, 68.60521067900004],
              [-113.96743730399993, 68.61212799700007],
            ],
          ],
          [
            [
              [-114.14622962099992, 68.67413971600007],
              [-114.07176673099991, 68.64459870000007],
              [-114.04775956899994, 68.62718333500004],
              [-114.07046464799993, 68.61953359600005],
              [-114.10684160099993, 68.62836334800005],
              [-114.16417395699995, 68.66913483300004],
              [-114.19273841099994, 68.68097565300008],
              [-114.18032792899993, 68.68602122600004],
              [-114.16657467399995, 68.68618398600006],
              [-114.15420488199993, 68.68195221600007],
              [-114.14622962099992, 68.67413971600007],
            ],
          ],
          [
            [
              [-101.69395911399994, 68.77033112200007],
              [-101.6946508449999, 68.75556061400005],
              [-101.70042883999992, 68.73053620000007],
              [-101.70140540299991, 68.72199127800008],
              [-101.69888261599993, 68.71039459800005],
              [-101.69391842399995, 68.69814687700006],
              [-101.67967688699991, 68.67413971600007],
              [-101.69399980399993, 68.65387604400007],
              [-101.70311438699991, 68.64447663000004],
              [-101.71507727799991, 68.63873932500007],
              [-101.73867753799993, 68.63861725500004],
              [-101.82494055899991, 68.65302155200004],
              [-101.80882727799991, 68.64398834800005],
              [-101.79979407499991, 68.63605377800008],
              [-101.79898027299993, 68.62738678600005],
              [-101.81696529899995, 68.60203685100004],
              [-101.82201087099992, 68.58909739800004],
              [-101.82917232999995, 68.57835521000004],
              [-101.84479732999995, 68.57111237200007],
              [-101.86620032499991, 68.57245514500005],
              [-101.90566972599993, 68.59271881700005],
              [-101.92324785099993, 68.59780508000006],
              [-101.94640051999994, 68.60138580900008],
              [-101.99596106699994, 68.61676666900007],
              [-102.02293860599991, 68.61953359600005],
              [-102.05313066299993, 68.61318594000005],
              [-102.06419837099992, 68.61212799700007],
              [-102.07738196499992, 68.61420319200005],
              [-102.09911048099991, 68.62360260600008],
              [-102.11465410099993, 68.62742747600004],
              [-102.12621008999992, 68.63572825700004],
              [-102.13280188699991, 68.63873932500007],
              [-102.14793860599991, 68.64126211100006],
              [-102.18736731699994, 68.63873932500007],
              [-102.21003170499995, 68.64215729400007],
              [-102.25352942599994, 68.65704987200007],
              [-102.29043535099993, 68.66356028900003],
              [-102.35191809799994, 68.68720123900005],
              [-102.31297766799992, 68.68846263200004],
              [-102.2610570949999, 68.69891998900005],
              [-102.21080481699994, 68.71478913000004],
              [-102.15977942599994, 68.74062734600005],
              [-102.07310950399994, 68.76093170800004],
              [-102.06460527299993, 68.76430898600006],
              [-102.05768795499995, 68.77033112200007],
              [-102.05410722599993, 68.77912018400008],
              [-102.05492102799991, 68.78693268400008],
              [-102.05719967399995, 68.79319896000004],
              [-102.05768795499995, 68.79706452000005],
              [-102.02464758999992, 68.82379791900007],
              [-101.97956295499995, 68.82599518400008],
              [-101.77798417899993, 68.78856028900003],
              [-101.75523841099994, 68.78766510600008],
              [-101.7300512359999, 68.79051341400003],
              [-101.70775305899991, 68.78782786700003],
              [-101.69395911399994, 68.77033112200007],
            ],
          ],
          [
            [
              [-114.4739477199999, 68.89325592700004],
              [-114.46271725199995, 68.89777252800008],
              [-114.4507543609999, 68.89996979400007],
              [-114.43838456899994, 68.90037669500003],
              [-114.35399329299992, 68.89435455900008],
              [-114.33047441299993, 68.88617584800005],
              [-114.35098222599993, 68.87274811400005],
              [-114.38219153599994, 68.86920807500007],
              [-114.41738847599993, 68.87360260600008],
              [-114.45010331899994, 68.88271719000005],
              [-114.4739477199999, 68.89325592700004],
            ],
          ],
          [
            [
              [-100.20677649599992, 68.80390045800004],
              [-100.2195531889999, 68.79393138200004],
              [-100.21886145699995, 68.78656647300005],
              [-100.21568762899994, 68.77948639500005],
              [-100.22105872299994, 68.77033112200007],
              [-100.23916581899994, 68.76585521000004],
              [-100.28897050699993, 68.77338288000004],
              [-100.31041419199994, 68.77033112200007],
              [-100.33145097599993, 68.75421784100007],
              [-100.34618079299992, 68.73663971600007],
              [-100.36351477799991, 68.72207265800006],
              [-100.39240475199995, 68.71507396000004],
              [-100.41828365799995, 68.71898021000004],
              [-100.44542395699995, 68.73053620000007],
              [-100.49478105399993, 68.76288483300004],
              [-100.44701087099992, 68.77655670800004],
              [-100.45718339799993, 68.79266998900005],
              [-100.47118079299992, 68.79975006700005],
              [-100.48843339799993, 68.80044179900005],
              [-100.50841223899994, 68.79706452000005],
              [-100.54503333199995, 68.78607819200005],
              [-100.56017005099994, 68.77781810100004],
              [-100.55626380099994, 68.77033112200007],
              [-100.57945716099994, 68.75291575700004],
              [-100.60334225199995, 68.75556061400005],
              [-100.62242591099994, 68.77236562700006],
              [-100.63133704299992, 68.79706452000005],
              [-100.63036048099991, 68.87470123900005],
              [-100.62205969999991, 68.91962311400005],
              [-100.61412512899994, 68.92251211100006],
              [-100.60293535099993, 68.92177969000005],
              [-100.59040279899995, 68.92739492400005],
              [-100.57974199099993, 68.94798411700003],
              [-100.58910071499992, 68.96527741100005],
              [-100.63133704299992, 68.99567291900007],
              [-100.5789281889999, 69.01186758000006],
              [-100.57046464799993, 69.02020905200004],
              [-100.56065833199995, 69.03778717700004],
              [-100.53766842399995, 69.04197825700004],
              [-100.40412350199995, 69.02973053600005],
              [-100.36143958199995, 69.01923248900005],
              [-100.32347571499992, 69.00311920800004],
              [-100.32852128799993, 68.97964101800005],
              [-100.30915279899995, 68.96588776200008],
              [-100.2805883449999, 68.95600006700005],
              [-100.22862708199995, 68.92890045800004],
              [-100.15420488199993, 68.92340729400007],
              [-100.12486731699994, 68.90692780200004],
              [-100.18008378799993, 68.89325592700004],
              [-100.1655981109999, 68.87726471600007],
              [-100.1712133449999, 68.86481354400007],
              [-100.18789628799993, 68.85635000200006],
              [-100.20677649599992, 68.85228099200003],
              [-100.20132402299993, 68.84105052300004],
              [-100.18517005099994, 68.82550690300008],
              [-100.18008378799993, 68.81753164300005],
              [-100.17756100199995, 68.80337148600006],
              [-100.18248450399994, 68.80255768400008],
              [-100.19286048099991, 68.80585358300004],
              [-100.20677649599992, 68.80390045800004],
            ],
          ],
          [
            [
              [-100.0423070949999, 69.08502838700008],
              [-100.03229732999995, 69.07298411700003],
              [-100.00503495999993, 69.05353424700007],
              [-99.99449622299994, 69.04409414300005],
              [-99.98631751199991, 69.02960846600007],
              [-99.98599199099993, 69.01727936400005],
              [-100.00096594999991, 68.96063873900005],
              [-100.00841223899994, 68.94847239800004],
              [-100.02183997299994, 68.94037506700005],
              [-100.03482011599993, 68.94086334800005],
              [-100.16584225199995, 68.96832916900007],
              [-100.19762122299994, 68.98191966400003],
              [-100.2273656889999, 68.99970123900005],
              [-100.24864661399994, 69.02228424700007],
              [-100.2551977199999, 69.05027903900003],
              [-100.24962317599994, 69.06899648600006],
              [-100.23827063699991, 69.08454010600008],
              [-100.22325598899994, 69.09674713700008],
              [-100.20677649599992, 69.10553620000007],
              [-100.17251542899993, 69.11497630400004],
              [-100.16270911399994, 69.12295156500005],
              [-100.1516820949999, 69.13715241100005],
              [-100.14614824099993, 69.14256419500003],
              [-100.13853919199994, 69.14712148600006],
              [-100.13243567599994, 69.13617584800005],
              [-100.12267005099994, 69.12921784100007],
              [-100.09691321499992, 69.11920807500007],
              [-100.07664954299992, 69.11517975500004],
              [-100.05101477799991, 69.10687897300005],
              [-100.0347387359999, 69.09617747600004],
              [-100.0423070949999, 69.08502838700008],
            ],
          ],
          [
            [
              [-101.52944902299993, 69.18805573100008],
              [-101.50454667899993, 69.17572663000004],
              [-101.50609290299991, 69.15477122600004],
              [-101.52464758999992, 69.13178131700005],
              [-101.55060787699995, 69.11298248900005],
              [-101.56676184799994, 69.10687897300005],
              [-101.5874731109999, 69.10236237200007],
              [-101.62564042899993, 69.09870026200008],
              [-101.64476477799991, 69.09467194200005],
              [-101.66356360599991, 69.08808014500005],
              [-101.68224036399994, 69.08673737200007],
              [-101.70140540299991, 69.09870026200008],
              [-101.68101966099994, 69.11688873900005],
              [-101.6184789699999, 69.13251373900005],
              [-101.60521399599992, 69.15053945500006],
              [-101.61945553299995, 69.16429271000004],
              [-101.69163977799991, 69.16714101800005],
              [-101.72191321499992, 69.18060944200005],
              [-101.68907630099994, 69.21116771000004],
              [-101.6277563139999, 69.22353750200006],
              [-101.5637914699999, 69.21954987200007],
              [-101.52326412699995, 69.20111725500004],
              [-101.52448482999995, 69.19769928600005],
              [-101.52501380099994, 69.19448476800005],
              [-101.5261938139999, 69.19131094000005],
              [-101.52944902299993, 69.18805573100008],
            ],
          ],
          [
            [
              [-135.56676184799994, 69.38605377800008],
              [-135.55166581899994, 69.40713125200006],
              [-135.52159583199995, 69.40741608300004],
              [-135.4609268869999, 69.39354075700004],
              [-135.38914954299992, 69.40005117400005],
              [-135.35338294199994, 69.39704010600008],
              [-135.32095292899993, 69.37986888200004],
              [-135.34068762899994, 69.36347077000005],
              [-135.34829667899993, 69.35936107000003],
              [-135.3262426419999, 69.35496653900003],
              [-135.28099524599992, 69.36176178600005],
              [-135.27257239499994, 69.34882233300004],
              [-135.27818762899994, 69.33152903900003],
              [-135.2915746739999, 69.31590403900003],
              [-135.3076065749999, 69.30914948100008],
              [-135.34496008999992, 69.33283112200007],
              [-135.37279212099992, 69.34369538000004],
              [-135.56676184799994, 69.38605377800008],
            ],
          ],
          [
            [
              [-100.98143469999991, 69.48224518400008],
              [-100.96422278599994, 69.47711823100008],
              [-100.95933997299994, 69.47247955900008],
              [-100.96776282499991, 69.46523672100005],
              [-100.97691809799994, 69.45941803600005],
              [-100.9837133449999, 69.45404694200005],
              [-100.99095618399991, 69.44993724200003],
              [-101.00186113199993, 69.44814687700006],
              [-101.02342688699991, 69.45160553600005],
              [-101.04214433499993, 69.45799388200004],
              [-101.06118730399993, 69.45954010600008],
              [-101.08385169199994, 69.44814687700006],
              [-101.09276282499991, 69.43891022300005],
              [-101.09992428299995, 69.42731354400007],
              [-101.10260982999995, 69.41608307500007],
              [-101.09805253799993, 69.40778229400007],
              [-101.11522376199991, 69.40753815300008],
              [-101.14419511599993, 69.39687734600005],
              [-101.15953528599994, 69.39354075700004],
              [-101.17373613199993, 69.39712148600006],
              [-101.18712317599994, 69.40395742400005],
              [-101.1988012359999, 69.40550364800004],
              [-101.20791581899994, 69.39354075700004],
              [-101.20225989499994, 69.38678620000007],
              [-101.2063695949999, 69.38007233300004],
              [-101.2163793609999, 69.37506745000007],
              [-101.22842363199993, 69.37299225500004],
              [-101.24250240799995, 69.37433502800008],
              [-101.28307044199994, 69.38605377800008],
              [-101.26402747299994, 69.38857656500005],
              [-101.24718176999994, 69.39411041900007],
              [-101.23810787699995, 69.40436432500007],
              [-101.24205481699994, 69.42084381700005],
              [-101.25719153599994, 69.43260325700004],
              [-101.29161536399994, 69.43598053600005],
              [-101.3035375639999, 69.44814687700006],
              [-101.26488196499992, 69.44090403900003],
              [-101.2351781889999, 69.44379303600005],
              [-101.21043860599991, 69.45734284100007],
              [-101.1868383449999, 69.48224518400008],
              [-101.24795488199993, 69.50234609600005],
              [-101.26939856699994, 69.50275299700007],
              [-101.26504472599993, 69.49335358300004],
              [-101.26256262899994, 69.48969147300005],
              [-101.28018144399994, 69.48920319200005],
              [-101.29287675699993, 69.49355703300006],
              [-101.32530676999994, 69.51361725500004],
              [-101.37564042899993, 69.53717682500007],
              [-101.38145911399994, 69.53815338700008],
              [-101.37926184799994, 69.54047272300005],
              [-101.36082923099991, 69.56757233300004],
              [-101.35374915299991, 69.57330963700008],
              [-101.3445531889999, 69.57786692900004],
              [-101.31086178299995, 69.58344147300005],
              [-101.27684485599991, 69.58535390800006],
              [-101.26024329299992, 69.58071523600006],
              [-101.25670325399994, 69.57575104400007],
              [-101.25772050699993, 69.57037995000007],
              [-101.25511633999992, 69.56419505400004],
              [-101.24376380099994, 69.54970937700006],
              [-101.23737545499995, 69.54828522300005],
              [-101.22158769399994, 69.55117422100005],
              [-101.20913652299993, 69.55556875200006],
              [-101.18594316299993, 69.56757233300004],
              [-101.17320716099994, 69.57168203300006],
              [-101.18065344999991, 69.56419505400004],
              [-101.17056230399993, 69.55215078300006],
              [-101.15835527299993, 69.54682038000004],
              [-101.07835852799991, 69.53733958500004],
              [-101.06354732999995, 69.53099192900004],
              [-101.07762610599991, 69.52326080900008],
              [-101.07555091099994, 69.51532623900005],
              [-101.07127844999991, 69.51190827000005],
              [-101.05711829299992, 69.50958893400008],
              [-101.0391332669999, 69.50023021000004],
              [-100.99982662699995, 69.49070872600004],
              [-100.98143469999991, 69.48224518400008],
            ],
          ],
          [
            [
              [-96.55492102799991, 69.47919342700004],
              [-96.61237545499995, 69.50336334800005],
              [-96.65021725199995, 69.53196849200003],
              [-96.74022376199991, 69.57786692900004],
              [-96.74022376199991, 69.58535390800006],
              [-96.70360266799992, 69.58649323100008],
              [-96.69180253799993, 69.58535390800006],
              [-96.68382727799991, 69.58234284100007],
              [-96.66783606699994, 69.57355377800008],
              [-96.65477454299992, 69.56952545800004],
              [-96.64415442599994, 69.56012604400007],
              [-96.63687089799993, 69.55805084800005],
              [-96.54312089799993, 69.56659577000005],
              [-96.3841039699999, 69.56256745000007],
              [-96.3679906889999, 69.55951569200005],
              [-96.35350501199991, 69.55292389500005],
              [-96.3386938139999, 69.54059479400007],
              [-96.32249915299991, 69.53139883000006],
              [-96.30614173099991, 69.53229401200008],
              [-96.2735082669999, 69.54433828300006],
              [-96.2083227199999, 69.55182526200008],
              [-96.18936113199993, 69.57123444200005],
              [-96.1692602199999, 69.57050202000005],
              [-96.14834550699993, 69.56268952000005],
              [-96.13687089799993, 69.55117422100005],
              [-96.1375219389999, 69.53534577000005],
              [-96.1262914699999, 69.52065664300005],
              [-96.11168372299994, 69.50580475500004],
              [-96.10216223899994, 69.48969147300005],
              [-96.10130774599992, 69.46727122600004],
              [-96.11001542899993, 69.44965241100005],
              [-96.12694251199991, 69.43671295800004],
              [-96.15054277299993, 69.42829010600008],
              [-96.13683020699995, 69.41303131700005],
              [-96.13149980399993, 69.40460846600007],
              [-96.12950598899994, 69.39354075700004],
              [-96.13508053299995, 69.38275788000004],
              [-96.14537512899994, 69.37482330900008],
              [-96.1511938139999, 69.36603424700007],
              [-96.14313717399995, 69.35252513200004],
              [-96.23204505099994, 69.36269765800006],
              [-96.27574622299994, 69.37457916900007],
              [-96.31444251199991, 69.39354075700004],
              [-96.36595618399991, 69.43793366100005],
              [-96.38499915299991, 69.44977448100008],
              [-96.47642981699994, 69.46865469000005],
              [-96.52940833199995, 69.47162506700005],
              [-96.55492102799991, 69.47919342700004],
            ],
          ],
          [
            [
              [-133.92943274599992, 69.57786692900004],
              [-133.88833574099993, 69.57196686400005],
              [-133.9287817049999, 69.56488678600005],
              [-133.94985917899993, 69.56419505400004],
              [-134.01817786399994, 69.57786692900004],
              [-134.0182999339999, 69.58250560100004],
              [-134.01695716099994, 69.58588288000004],
              [-134.01134192599994, 69.59210846600007],
              [-133.9982804029999, 69.59357330900008],
              [-133.97842363199993, 69.60346100500004],
              [-133.9014379549999, 69.62689850500004],
              [-133.88735917899993, 69.62636953300006],
              [-133.8611547519999, 69.61945221600007],
              [-133.8601781889999, 69.61717357000003],
              [-133.85875403599994, 69.61249420800004],
              [-133.85582434799994, 69.60789622600004],
              [-133.8505753249999, 69.60578034100007],
              [-133.8127335279999, 69.60578034100007],
              [-133.83043372299994, 69.59349192900004],
              [-133.92943274599992, 69.58535390800006],
              [-133.92943274599992, 69.57786692900004],
            ],
          ],
          [
            [
              [-95.94448808499993, 69.42084381700005],
              [-95.98184160099993, 69.43626536700003],
              [-95.99925696499992, 69.44896067900004],
              [-96.00658118399991, 69.46523672100005],
              [-96.00816809799994, 69.47504303600005],
              [-96.01085364499994, 69.47943756700005],
              [-96.01138261599993, 69.48281484600005],
              [-96.00658118399991, 69.48969147300005],
              [-95.99400794199994, 69.49860260600008],
              [-95.9644262359999, 69.50714752800008],
              [-95.9519750639999, 69.51703522300005],
              [-95.95750891799992, 69.52773672100005],
              [-95.95421301999994, 69.53925202000005],
              [-95.92324785099993, 69.59149811400005],
              [-95.9116918609999, 69.60024648600006],
              [-95.88988196499992, 69.60578034100007],
              [-95.84276282499991, 69.60537344000005],
              [-95.8281957669999, 69.60919830900008],
              [-95.82066809799994, 69.61448802300004],
              [-95.80113684799994, 69.63312409100007],
              [-95.77749589799993, 69.63568756700005],
              [-95.70250403599994, 69.63125234600005],
              [-95.67760169199994, 69.62628815300008],
              [-95.69127356699994, 69.61261627800008],
              [-95.68028723899994, 69.60932038000004],
              [-95.66808020699995, 69.60907623900005],
              [-95.65550696499992, 69.61139557500007],
              [-95.64346269399994, 69.61603424700007],
              [-95.62950598899994, 69.61981842700004],
              [-95.61790930899991, 69.61733633000006],
              [-95.60704505099994, 69.61155833500004],
              [-95.52086341099994, 69.57778554900005],
              [-95.49205481699994, 69.57168203300006],
              [-95.38076738199993, 69.52326080900008],
              [-95.37120520699995, 69.51357656500005],
              [-95.36913001199991, 69.49591705900008],
              [-95.37315833199995, 69.48631419500003],
              [-95.39037024599992, 69.46059804900005],
              [-95.39647376199991, 69.44814687700006],
              [-95.40135657499991, 69.42572663000004],
              [-95.40322831899994, 69.39691803600005],
              [-95.41299394399994, 69.38629791900007],
              [-95.46206620999993, 69.37836334800005],
              [-95.48180091099994, 69.36961497600004],
              [-95.50194251199991, 69.34503815300008],
              [-95.5149633449999, 69.33535390800006],
              [-95.53359941299993, 69.33144765800006],
              [-95.71165930899991, 69.32176341400003],
              [-95.74592037699995, 69.33893463700008],
              [-95.73696855399993, 69.33966705900008],
              [-95.71178137899994, 69.34511953300006],
              [-95.72549394399994, 69.36884186400005],
              [-95.7188207669999, 69.38617584800005],
              [-95.69652258999992, 69.39671458500004],
              [-95.6634008449999, 69.40033600500004],
              [-95.65538489499994, 69.40949127800008],
              [-95.68370520699995, 69.45612213700008],
              [-95.69127356699994, 69.47606028900003],
              [-95.68736731699994, 69.48248932500007],
              [-95.68024654899995, 69.48745351800005],
              [-95.67324785099993, 69.49420807500007],
              [-95.67015540299991, 69.50617096600007],
              [-95.6731664699999, 69.51459381700005],
              [-95.68004309799994, 69.52435944200005],
              [-95.69469153599994, 69.54059479400007],
              [-95.72175045499995, 69.55565013200004],
              [-95.76235917899993, 69.56439850500004],
              [-95.8042699859999, 69.56561920800004],
              [-95.8352758449999, 69.55805084800005],
              [-95.8145238919999, 69.50771719000005],
              [-95.8001195949999, 69.48533763200004],
              [-95.78001868399991, 69.46865469000005],
              [-95.85537675699993, 69.40159739800004],
              [-95.87621008999992, 69.37299225500004],
              [-95.87002519399994, 69.37299225500004],
              [-95.86998450399994, 69.36766185100004],
              [-95.87165279899995, 69.36493561400005],
              [-95.87059485599991, 69.36273834800005],
              [-95.8626195949999, 69.35936107000003],
              [-95.88459225199995, 69.34389883000006],
              [-95.92247473899994, 69.34308502800008],
              [-95.96288001199991, 69.35049062700006],
              [-95.99229895699995, 69.35936107000003],
              [-95.99022376199991, 69.36896393400008],
              [-95.9942113919999, 69.38519928600005],
              [-95.99229895699995, 69.39354075700004],
              [-95.98387610599991, 69.40143463700008],
              [-95.94448808499993, 69.42084381700005],
            ],
          ],
          [
            [
              [-139.1133927069999, 69.65420156500005],
              [-139.0810440749999, 69.64984772300005],
              [-139.0125219389999, 69.63060130400004],
              [-138.9521378249999, 69.62384674700007],
              [-138.92100989499994, 69.61701080900008],
              [-138.89175370999993, 69.60626862200007],
              [-138.8701065749999, 69.59210846600007],
              [-138.90538489499994, 69.57831452000005],
              [-138.9872940749999, 69.58608633000006],
              [-139.02774003799993, 69.58535390800006],
              [-139.05068925699993, 69.57615794500003],
              [-139.08950761599993, 69.54755280200004],
              [-139.11025956899994, 69.53685130400004],
              [-139.13784745999993, 69.53522370000007],
              [-139.17271887899994, 69.54148997600004],
              [-139.20718339799993, 69.55231354400007],
              [-139.23379472599993, 69.56419505400004],
              [-139.2429906889999, 69.57200755400004],
              [-139.25084387899994, 69.58063385600008],
              [-139.26024329299992, 69.58539459800005],
              [-139.27383378799993, 69.58161041900007],
              [-139.2878311839999, 69.57562897300005],
              [-139.30361894399994, 69.57200755400004],
              [-139.31993567599994, 69.57078685100004],
              [-139.33560136599993, 69.57168203300006],
              [-139.31578528599994, 69.58535390800006],
              [-139.21841386599993, 69.63157786700003],
              [-139.16494706899994, 69.64789459800005],
              [-139.1133927069999, 69.65420156500005],
            ],
          ],
          [
            [
              [-135.5742081369999, 69.57786692900004],
              [-135.59288489499994, 69.59365469000005],
              [-135.5810440749999, 69.60927969000005],
              [-135.53636633999992, 69.63686758000006],
              [-135.51097571499992, 69.64838288000004],
              [-135.4732152989999, 69.65338776200008],
              [-135.40294348899994, 69.65420156500005],
              [-135.4116918609999, 69.64232005400004],
              [-135.4644262359999, 69.59210846600007],
              [-135.48888098899994, 69.57925039300005],
              [-135.51797441299993, 69.57225169500003],
              [-135.54771887899994, 69.57168203300006],
              [-135.5742081369999, 69.57786692900004],
            ],
          ],
          [
            [
              [-102.12596594999991, 69.71503327000005],
              [-102.11896725199995, 69.67096588700008],
              [-102.15933183499993, 69.65424225500004],
              [-102.21056067599994, 69.66030508000006],
              [-102.23582923099991, 69.68463776200008],
              [-102.23692786399994, 69.70441315300008],
              [-102.23582923099991, 69.71808502800008],
              [-102.22618567599994, 69.72606028900003],
              [-102.15648352799991, 69.73493073100008],
              [-102.13756262899994, 69.73191966400003],
              [-102.12596594999991, 69.71503327000005],
            ],
          ],
          [
            [
              [-95.2149145169999, 68.86220937700006],
              [-95.20995032499991, 68.85333893400008],
              [-95.21353105399993, 68.84931061400005],
              [-95.22044837099992, 68.84756094000005],
              [-95.22516842399995, 68.84544505400004],
              [-95.23778235599991, 68.82953522300005],
              [-95.25536048099991, 68.81378815300008],
              [-95.27489173099991, 68.80003489800004],
              [-95.37096106699994, 68.75967031500005],
              [-95.39679928299995, 68.75604889500005],
              [-95.43895423099991, 68.73956940300008],
              [-95.53038489499994, 68.67841217700004],
              [-95.56834876199991, 68.68097565300008],
              [-95.5523168609999, 68.70864492400005],
              [-95.54751542899993, 68.72947825700004],
              [-95.55992591099994, 68.74481842700004],
              [-95.59508216099994, 68.75604889500005],
              [-95.73045813699991, 68.73175690300008],
              [-95.7527563139999, 68.73248932500007],
              [-95.76048743399991, 68.74070872600004],
              [-95.77782141799992, 68.74135976800005],
              [-95.79629472599993, 68.73676178600005],
              [-95.80736243399991, 68.72939687700006],
              [-95.79552161399994, 68.71076080900008],
              [-95.79283606699994, 68.69920482000003],
              [-95.8042699859999, 68.69399648600006],
              [-95.83629309799994, 68.68683502800008],
              [-95.85387122299994, 68.66864655200004],
              [-95.85610917899993, 68.64447663000004],
              [-95.84211178299995, 68.61953359600005],
              [-95.88145911399994, 68.61029694200005],
              [-95.95864824099993, 68.62909577000005],
              [-95.99974524599992, 68.62571849200003],
              [-96.01276607999995, 68.61884186400005],
              [-96.04751542899993, 68.59153880400004],
              [-96.06566321499992, 68.58258698100008],
              [-96.08348548099991, 68.57611725500004],
              [-96.10216223899994, 68.57233307500007],
              [-96.12267005099994, 68.57111237200007],
              [-96.15217037699995, 68.56439850500004],
              [-96.29588782499991, 68.48012929900005],
              [-96.32481848899994, 68.47166575700004],
              [-96.52049719999991, 68.44757721600007],
              [-96.55923417899993, 68.45184967700004],
              [-96.63418535099993, 68.47064850500004],
              [-96.71320553299995, 68.47846100500004],
              [-96.88003495999993, 68.51878489800004],
              [-96.94334876199991, 68.52651601800005],
              [-96.98379472599993, 68.54059479400007],
              [-97.02017167899993, 68.54657623900005],
              [-97.03677324099993, 68.55377838700008],
              [-97.05211341099994, 68.56378815300008],
              [-97.06484941299993, 68.57485586100006],
              [-97.0813695949999, 68.58502838700008],
              [-97.10195878799993, 68.58982982000003],
              [-97.14427649599992, 68.59153880400004],
              [-97.11050370999993, 68.55927155200004],
              [-97.09618079299992, 68.53912995000007],
              [-97.10643469999991, 68.53009674700007],
              [-97.1238500639999, 68.52789948100008],
              [-97.15925045499995, 68.51813385600008],
              [-97.17813066299993, 68.51585521000004],
              [-97.19981848899994, 68.51756419500003],
              [-97.26036536399994, 68.53009674700007],
              [-97.32188880099994, 68.53314850500004],
              [-97.38902747299994, 68.54946523600006],
              [-97.40811113199993, 68.55068594000005],
              [-97.42760169199994, 68.54677969000005],
              [-97.44566809799994, 68.53945547100005],
              [-97.46446692599994, 68.53522370000007],
              [-97.56200110599991, 68.56427643400008],
              [-97.65367591099994, 68.60687897300005],
              [-97.68553626199991, 68.61212799700007],
              [-97.71080481699994, 68.61937083500004],
              [-97.7605688139999, 68.65208567900004],
              [-97.78856360599991, 68.66046784100007],
              [-97.83779863199993, 68.65778229400007],
              [-97.99327551999994, 68.69660065300008],
              [-98.0418188139999, 68.70140208500004],
              [-98.0606176419999, 68.69757721600007],
              [-98.08763587099992, 68.67951080900008],
              [-98.10326087099992, 68.67413971600007],
              [-98.11925208199995, 68.67499420800004],
              [-98.13133704299992, 68.68012116100005],
              [-98.15103105399993, 68.69399648600006],
              [-98.16494706899994, 68.69977448100008],
              [-98.21934973899994, 68.71507396000004],
              [-98.2683813139999, 68.74030182500007],
              [-98.29027258999992, 68.75820547100005],
              [-98.29161536399994, 68.77342357000003],
              [-98.26695716099994, 68.79441966400003],
              [-98.25133216099994, 68.81146881700005],
              [-98.25503495999993, 68.82575104400007],
              [-98.28823808499993, 68.83860911700003],
              [-98.36375891799992, 68.85757070500006],
              [-98.40656490799995, 68.86151764500005],
              [-98.42540442599994, 68.84886302300004],
              [-98.41893469999991, 68.82672760600008],
              [-98.40689042899993, 68.80951569200005],
              [-98.40062415299991, 68.79230377800008],
              [-98.41112219999991, 68.77033112200007],
              [-98.43936113199993, 68.75405508000006],
              [-98.48062089799993, 68.74677155200004],
              [-98.52236894399994, 68.75031159100007],
              [-98.55199133999992, 68.76658763200004],
              [-98.57152258999992, 68.78750234600005],
              [-98.58397376199991, 68.79437897300005],
              [-98.64452063699991, 68.80390045800004],
              [-98.65343176999994, 68.80190664300005],
              [-98.67100989499994, 68.79291413000004],
              [-98.6792699859999, 68.79022858300004],
              [-98.71768144399994, 68.79144928600005],
              [-98.8633520169999, 68.83441803600005],
              [-98.87413489499994, 68.84357330900008],
              [-98.87791907499991, 68.85846588700008],
              [-98.8738500639999, 68.87396881700005],
              [-98.86384029899995, 68.88703034100007],
              [-98.8496801419999, 68.89606354400007],
              [-98.82457434799994, 68.90110911700003],
              [-98.81851152299993, 68.90570709800005],
              [-98.81533769399994, 68.91258372600004],
              [-98.81582597599993, 68.92112864800004],
              [-98.81973222599993, 68.92772044500003],
              [-98.8262426419999, 68.93065013200004],
              [-98.87140865799995, 68.93968333500004],
              [-98.93276933499993, 68.94350820500006],
              [-98.96996008999992, 68.95473867400005],
              [-98.98155676999994, 68.95575592700004],
              [-98.99274654899995, 68.95368073100008],
              [-99.00137285099993, 68.94790273600006],
              [-99.00503495999993, 68.93952057500007],
              [-99.00328528599994, 68.93231842700004],
              [-99.00064042899993, 68.92625560100004],
              [-99.00137285099993, 68.92112864800004],
              [-99.01878821499992, 68.90924713700008],
              [-99.03587805899991, 68.91054922100005],
              [-99.05378170499995, 68.91722239800004],
              [-99.07339433499993, 68.92112864800004],
              [-99.11823482999995, 68.92426178600005],
              [-99.12661699099993, 68.92064036700003],
              [-99.1106664699999, 68.90692780200004],
              [-99.05923417899993, 68.87970612200007],
              [-99.04234778599994, 68.86591217700004],
              [-99.06956946499992, 68.85675690300008],
              [-99.13003495999993, 68.85297272300005],
              [-99.15843665299991, 68.84544505400004],
              [-99.18224036399994, 68.83144765800006],
              [-99.19225012899994, 68.82977936400005],
              [-99.20653235599991, 68.83490631700005],
              [-99.24242102799991, 68.85578034100007],
              [-99.2671606109999, 68.86033763200004],
              [-99.29539954299992, 68.86933014500005],
              [-99.41722571499992, 68.89044830900008],
              [-99.44115149599992, 68.89935944200005],
              [-99.45563717399995, 68.91193268400008],
              [-99.44640051999994, 68.92739492400005],
              [-99.46304277299993, 68.95107656500005],
              [-99.48534094999991, 68.96893952000005],
              [-99.54206295499995, 68.99567291900007],
              [-99.57555091099994, 69.00649648600006],
              [-99.59080969999991, 69.01483795800004],
              [-99.59727942599994, 69.02667877800008],
              [-99.59154212099992, 69.04108307500007],
              [-99.57774817599994, 69.05353424700007],
              [-99.54576575399994, 69.07514069200005],
              [-99.49156653599994, 69.12083567900004],
              [-99.46129309799994, 69.13458893400008],
              [-99.41909745999993, 69.13963450700004],
              [-99.35753333199995, 69.13214752800008],
              [-99.34972083199995, 69.13312409100007],
              [-99.33653723899994, 69.13963450700004],
              [-99.30931555899991, 69.15875885600008],
              [-99.29295813699991, 69.16111888200004],
              [-99.27513587099992, 69.14712148600006],
              [-99.25731360599991, 69.15436432500007],
              [-99.24071204299992, 69.15155670800004],
              [-99.22398841099994, 69.14472077000005],
              [-99.20620683499993, 69.13963450700004],
              [-99.18687903599994, 69.13934967700004],
              [-99.13109290299991, 69.14712148600006],
              [-99.00670325399994, 69.13906484600005],
              [-98.96694902299993, 69.15053945500006],
              [-98.93846594999991, 69.17055898600006],
              [-98.92454993399991, 69.17772044500003],
              [-98.90489661399994, 69.18060944200005],
              [-98.81615149599992, 69.17446523600006],
              [-98.78636633999992, 69.17767975500004],
              [-98.74571692599994, 69.18707916900007],
              [-98.71275794199994, 69.20213450700004],
              [-98.70596269399994, 69.22215403900003],
              [-98.69977779899995, 69.22215403900003],
              [-98.71104895699995, 69.23859284100007],
              [-98.71007239499994, 69.25649648600006],
              [-98.69871985599991, 69.27342357000003],
              [-98.67894446499992, 69.28705475500004],
              [-98.65322831899994, 69.30101146000004],
              [-98.63955644399994, 69.30438873900005],
              [-98.6243383449999, 69.30101146000004],
              [-98.5913793609999, 69.28335195500006],
              [-98.57335364499994, 69.27692291900007],
              [-98.55508378799993, 69.27680084800005],
              [-98.54564368399991, 69.28168366100005],
              [-98.5261938139999, 69.29840729400007],
              [-98.51475989499994, 69.30414459800005],
              [-98.49697831899994, 69.30658600500004],
              [-98.43907630099994, 69.30414459800005],
              [-98.40957597599993, 69.30780670800004],
              [-98.39317786399994, 69.31806061400005],
              [-98.39268958199995, 69.33340078300006],
              [-98.41112219999991, 69.35252513200004],
              [-98.45628821499992, 69.37514883000006],
              [-98.5540258449999, 69.40639883000006],
              [-98.60789954299992, 69.44269440300008],
              [-98.61131751199991, 69.44916413000004],
              [-98.60692298099991, 69.45807526200008],
              [-98.59756425699993, 69.46771881700005],
              [-98.58771725199995, 69.47540924700007],
              [-98.57632402299993, 69.48053620000007],
              [-98.56261145699995, 69.48224518400008],
              [-98.49054928299995, 69.46800364800004],
              [-98.45156816299993, 69.46454498900005],
              [-98.41856848899994, 69.47606028900003],
              [-98.53600012899994, 69.49896881700005],
              [-98.59056555899991, 69.52024974200003],
              [-98.59609941299993, 69.55805084800005],
              [-98.57542883999992, 69.57737864800004],
              [-98.54942786399994, 69.58510976800005],
              [-98.4624731109999, 69.58356354400007],
              [-98.36925208199995, 69.56834544500003],
              [-98.3496801419999, 69.55459219000005],
              [-98.34007727799991, 69.54515208500004],
              [-98.29784094999991, 69.52399323100008],
              [-98.27651933499993, 69.49909088700008],
              [-98.18268795499995, 69.46735260600008],
              [-98.12409420499995, 69.46865469000005],
              [-98.10875403599994, 69.46600983300004],
              [-98.10537675699993, 69.45929596600007],
              [-98.11009680899991, 69.43793366100005],
              [-98.0950414699999, 69.42698802300004],
              [-98.06078040299991, 69.42674388200004],
              [-98.02383378799993, 69.43463776200008],
              [-98.00084387899994, 69.44814687700006],
              [-98.15623938699991, 69.50116608300004],
              [-98.19640051999994, 69.52700429900005],
              [-98.24087480399993, 69.56565989800004],
              [-98.25096594999991, 69.57168203300006],
              [-98.26048743399991, 69.57485586100006],
              [-98.29019120999993, 69.58901601800005],
              [-98.30528723899994, 69.59210846600007],
              [-98.33926347599993, 69.59536367400005],
              [-98.35537675699993, 69.59955475500004],
              [-98.37018795499995, 69.60578034100007],
              [-98.34532630099994, 69.62738678600005],
              [-98.33617102799991, 69.63743724200003],
              [-98.32921301999994, 69.65420156500005],
              [-98.3274633449999, 69.66844310100004],
              [-98.33023027299993, 69.69135163000004],
              [-98.32921301999994, 69.70197174700007],
              [-98.31248938699991, 69.73041413000004],
              [-98.28384355399993, 69.75714752800008],
              [-98.21934973899994, 69.79759349200003],
              [-98.19420325399994, 69.80516185100004],
              [-98.14289303299995, 69.80687083500004],
              [-98.11693274599992, 69.81122467700004],
              [-98.09996497299994, 69.82005442900004],
              [-98.06232662699995, 69.85968659100007],
              [-98.02147376199991, 69.88523997600004],
              [-97.97459876199991, 69.89642975500004],
              [-97.92516028599994, 69.89594147300005],
              [-97.87669837099992, 69.88694896000004],
              [-97.86021887899994, 69.87921784100007],
              [-97.82648678299995, 69.86945221600007],
              [-97.72704016799992, 69.85846588700008],
              [-97.70665442599994, 69.85285065300008],
              [-97.69713294199994, 69.84438711100006],
              [-97.69603430899991, 69.83624909100007],
              [-97.69664466099994, 69.82782623900005],
              [-97.69237219999991, 69.81867096600007],
              [-97.67638098899994, 69.80853913000004],
              [-97.63585364499994, 69.80036041900007],
              [-97.61693274599992, 69.79417552300004],
              [-97.47524980399993, 69.77716705900008],
              [-97.45213782499991, 69.76683177300004],
              [-97.4387914699999, 69.74201080900008],
              [-97.40729732999995, 69.72703685100004],
              [-97.34227454299992, 69.70880768400008],
              [-97.37840735599991, 69.69179922100005],
              [-97.4583227199999, 69.68915436400005],
              [-97.49315344999991, 69.67405833500004],
              [-97.43053137899994, 69.62026601800005],
              [-97.39073645699995, 69.60016510600008],
              [-97.37657630099994, 69.59764232000003],
              [-97.37022864499994, 69.60919830900008],
              [-97.36693274599992, 69.62026601800005],
              [-97.32848059799994, 69.67340729400007],
              [-97.31501217399995, 69.68773021000004],
              [-97.29686438699991, 69.69814687700006],
              [-97.2840063139999, 69.69696686400005],
              [-97.27057857999995, 69.69122955900008],
              [-97.22484290299991, 69.68231842700004],
              [-97.12149003799993, 69.62742747600004],
              [-97.10334225199995, 69.61261627800008],
              [-97.09239661399994, 69.59247467700004],
              [-97.08421790299991, 69.58226146000004],
              [-97.07201087099992, 69.57786692900004],
              [-97.04328365799995, 69.57257721600007],
              [-96.89342200399994, 69.49774811400005],
              [-96.85655676999994, 69.48786041900007],
              [-96.79352779899995, 69.49579498900005],
              [-96.76598059799994, 69.48456452000005],
              [-96.71231035099993, 69.45433177300004],
              [-96.68228105399993, 69.44814687700006],
              [-96.61998450399994, 69.44525788000004],
              [-96.53416907499991, 69.42829010600008],
              [-96.50475012899994, 69.41046784100007],
              [-96.49665279899995, 69.40778229400007],
              [-96.4773656889999, 69.40371328300006],
              [-96.40916907499991, 69.37482330900008],
              [-96.32127844999991, 69.35512929900005],
              [-96.21979732999995, 69.31395091400003],
              [-96.18423417899993, 69.29100169500003],
              [-96.17105058499993, 69.26312897300005],
              [-96.17837480399993, 69.25096263200004],
              [-96.20592200399994, 69.22988515800006],
              [-96.21202551999994, 69.21198151200008],
              [-96.2149145169999, 69.19285716400003],
              [-96.22305253799993, 69.17951080900008],
              [-96.23599199099993, 69.16937897300005],
              [-96.25300045499995, 69.16014232000003],
              [-96.22508704299992, 69.14081452000005],
              [-96.21662350199995, 69.11888255400004],
              [-96.22297115799995, 69.09552643400008],
              [-96.23936926999994, 69.07200755400004],
              [-96.22557532499991, 69.05442942900004],
              [-96.20189368399991, 69.04108307500007],
              [-96.17471269399994, 69.03266022300005],
              [-96.15054277299993, 69.02977122600004],
              [-96.12340247299994, 69.03335195500006],
              [-96.12035071499992, 69.04205963700008],
              [-96.14683997299994, 69.06830475500004],
              [-96.15660559799994, 69.08494700700004],
              [-96.15196692599994, 69.09756094000005],
              [-96.14232337099992, 69.11009349200003],
              [-96.13687089799993, 69.12665436400005],
              [-96.14207923099991, 69.14447663000004],
              [-96.15123450399994, 69.15452708500004],
              [-96.15477454299992, 69.16421133000006],
              [-96.14313717399995, 69.18060944200005],
              [-96.10765540299991, 69.19912344000005],
              [-96.10216223899994, 69.20482005400004],
              [-96.09813391799992, 69.21409739800004],
              [-96.0886938139999, 69.22406647300005],
              [-96.07725989499994, 69.23200104400007],
              [-96.06773841099994, 69.23525625200006],
              [-96.04820716099994, 69.22972239800004],
              [-96.03571529899995, 69.21629466400003],
              [-96.0171606109999, 69.18439362200007],
              [-96.00182044199994, 69.17161692900004],
              [-95.96666419199994, 69.15314362200007],
              [-95.9519750639999, 69.13963450700004],
              [-95.94896399599992, 69.13349030200004],
              [-95.9473363919999, 69.12079498900005],
              [-95.94448808499993, 69.11298248900005],
              [-95.92467200399994, 69.08502838700008],
              [-95.93773352799991, 69.08136627800008],
              [-95.95555579299992, 69.07298411700003],
              [-95.97158769399994, 69.06195709800005],
              [-95.9793188139999, 69.05027903900003],
              [-95.97459876199991, 69.04002513200004],
              [-95.95018469999991, 69.02448151200008],
              [-95.94448808499993, 69.01308828300006],
              [-95.93846594999991, 69.00556061400005],
              [-95.92442786399994, 68.99762604400007],
              [-95.90851803299995, 68.99140045800004],
              [-95.87975012899994, 68.98651764500005],
              [-95.86587480399993, 68.97980377800008],
              [-95.85533606699994, 68.96906159100007],
              [-95.84829667899993, 68.95473867400005],
              [-95.84605872299994, 68.93158600500004],
              [-95.84837805899991, 68.90981679900005],
              [-95.84552975199995, 68.89061107000003],
              [-95.8281957669999, 68.87588125200006],
              [-95.81114661399994, 68.87396881700005],
              [-95.79686438699991, 68.88035716400003],
              [-95.78282630099994, 68.88898346600007],
              [-95.76671301999994, 68.89325592700004],
              [-95.7066137359999, 68.88418203300006],
              [-95.69127356699994, 68.87897370000007],
              [-95.67796790299991, 68.86945221600007],
              [-95.67568925699993, 68.86212799700007],
              [-95.67601477799991, 68.85480377800008],
              [-95.67015540299991, 68.84544505400004],
              [-95.65758216099994, 68.83612702000005],
              [-95.6446020169999, 68.83201732000003],
              [-95.62901770699995, 68.83104075700004],
              [-95.57103430899991, 68.83510976800005],
              [-95.39561926999994, 68.89866771000004],
              [-95.35326087099992, 68.90395742400005],
              [-95.3145238919999, 68.89638906500005],
              [-95.28172766799992, 68.88092682500007],
              [-95.26423092399995, 68.87506745000007],
              [-95.23888098899994, 68.87164948100008],
              [-95.22032630099994, 68.86542389500005],
              [-95.2149145169999, 68.86220937700006],
            ],
          ],
          [
            [
              [-97.46580969999991, 69.90062083500004],
              [-97.48696855399993, 69.91400788000004],
              [-97.49331620999993, 69.93170807500007],
              [-97.48595130099994, 69.94940827000005],
              [-97.46580969999991, 69.96271393400008],
              [-97.43423417899993, 69.96596914300005],
              [-97.38841712099992, 69.96238841400003],
              [-97.34715735599991, 69.95197174700007],
              [-97.32925370999993, 69.93475983300004],
              [-97.33739173099991, 69.93012116100005],
              [-97.34463456899994, 69.92251211100006],
              [-97.35594641799992, 69.90745677300004],
              [-97.32640540299991, 69.89183177300004],
              [-97.25479081899994, 69.89472077000005],
              [-97.22622636599993, 69.87954336100006],
              [-97.24909420499995, 69.86017487200007],
              [-97.27538001199991, 69.85887278900003],
              [-97.30093339799993, 69.86786530200004],
              [-97.3218481109999, 69.87954336100006],
              [-97.35777747299994, 69.89288971600007],
              [-97.42882239499994, 69.89435455900008],
              [-97.46580969999991, 69.90062083500004],
            ],
          ],
          [
            [
              [-124.95921790299991, 70.16754791900007],
              [-124.96922766799992, 70.16559479400007],
              [-124.97826087099992, 70.16136302300004],
              [-124.98619544199994, 70.15521881700005],
              [-124.99274654899995, 70.14704010600008],
              [-124.98648027299993, 70.14704010600008],
              [-125.00780188699991, 70.13617584800005],
              [-125.06777910099993, 70.14667389500005],
              [-125.09634355399993, 70.14020416900007],
              [-125.04796301999994, 70.12661367400005],
              [-125.06615149599992, 70.12079498900005],
              [-125.08576412699989, 70.11957428600005],
              [-125.10533606699994, 70.12181224200003],
              [-125.12368730399993, 70.12661367400005],
              [-125.12010657499991, 70.14419179900005],
              [-125.10496985599991, 70.15704987200007],
              [-125.08458411399994, 70.16486237200007],
              [-124.9780981109999, 70.17072174700007],
              [-124.95921790299991, 70.16754791900007],
            ],
          ],
          [
            [
              [-113.16551673099991, 70.31216054900005],
              [-113.05630449099993, 70.31134674700007],
              [-112.9768774079999, 70.30166250200006],
              [-112.94640051999994, 70.29043203300006],
              [-112.96108964799993, 70.28554922100005],
              [-112.97642981699994, 70.28384023600006],
              [-113.1634008449999, 70.28343333500004],
              [-113.2071020169999, 70.29783763200004],
              [-113.19359290299991, 70.29804108300004],
              [-113.1843969389999, 70.30316803600005],
              [-113.17613684799994, 70.30927155200004],
              [-113.16551673099991, 70.31216054900005],
            ],
          ],
          [
            [
              [-100.74120032499991, 70.31216054900005],
              [-100.75088456899994, 70.30719635600008],
              [-100.76187089799993, 70.30003489800004],
              [-100.77114824099993, 70.29197825700004],
              [-100.77599036399994, 70.28424713700008],
              [-100.77375240799995, 70.27399323100008],
              [-100.76671301999994, 70.26752350500004],
              [-100.7625219389999, 70.26264069200005],
              [-100.76915442599994, 70.25690338700008],
              [-100.79434160099993, 70.25604889500005],
              [-100.82286536399994, 70.26837799700007],
              [-100.87218176999994, 70.29783763200004],
              [-100.86042232999995, 70.30109284100007],
              [-100.85094153599994, 70.30634186400005],
              [-100.84683183499993, 70.31415436400005],
              [-100.85106360599991, 70.32514069200005],
              [-100.82689368399991, 70.32900625200006],
              [-100.79279537699995, 70.32843659100007],
              [-100.76024329299992, 70.32298411700003],
              [-100.74120032499991, 70.31216054900005],
            ],
          ],
          [
            [
              [-111.9527074859999, 70.32514069200005],
              [-111.88076738199993, 70.31769440300008],
              [-111.67149817599994, 70.31216054900005],
              [-112.10846920499995, 70.30093008000006],
              [-112.31151282499991, 70.34690989800004],
              [-112.32262122299994, 70.35618724200003],
              [-112.31175696499992, 70.36627838700008],
              [-112.28677324099993, 70.36896393400008],
              [-112.0945531889999, 70.35419342700004],
              [-111.9527074859999, 70.32514069200005],
            ],
          ],
          [
            [
              [-116.66405188699991, 70.49705638200004],
              [-116.6109106109999, 70.49335358300004],
              [-116.58629309799994, 70.48517487200007],
              [-116.57119706899994, 70.46979401200008],
              [-116.60667883999992, 70.47870514500005],
              [-116.75291907499991, 70.47801341400003],
              [-116.78575598899994, 70.48322174700007],
              [-116.81517493399991, 70.49371979400007],
              [-116.83193925699993, 70.51072825700004],
              [-116.79092363199993, 70.51072825700004],
              [-116.66405188699991, 70.49705638200004],
            ],
          ],
          [
            [
              [-116.26341712099992, 70.55170319200005],
              [-116.15664628799993, 70.54852936400005],
              [-116.12559973899994, 70.53807200700004],
              [-116.22862708199995, 70.53807200700004],
              [-116.24767005099994, 70.53339264500005],
              [-116.2825414699999, 70.52033112200007],
              [-116.30064856699994, 70.51764557500007],
              [-116.35423743399991, 70.51976146000004],
              [-116.45311438699991, 70.51194896000004],
              [-116.47565670499989, 70.51434967700004],
              [-116.4961645169999, 70.52383047100005],
              [-116.47183183499993, 70.53733958500004],
              [-116.44347083199995, 70.54315827000005],
              [-116.41315670499989, 70.54189687700006],
              [-116.38316809799994, 70.53465403900003],
              [-116.35265051999994, 70.53339264500005],
              [-116.29747473899994, 70.55463288000004],
              [-116.26341712099992, 70.55170319200005],
            ],
          ],
          [
            [
              [-116.72207597599993, 70.55853913000004],
              [-116.6800024079999, 70.56818268400008],
              [-116.61046301999994, 70.57103099200003],
              [-116.54360917899993, 70.56586334800005],
              [-116.50975501199991, 70.55170319200005],
              [-116.54063880099994, 70.54368724200003],
              [-116.7444555329999, 70.54242584800005],
              [-116.77733313699991, 70.55170319200005],
              [-116.75039628799993, 70.55841705900008],
              [-116.73631751199991, 70.55939362200007],
              [-116.72207597599993, 70.55853913000004],
            ],
          ],
          [
            [
              [-115.88597571499992, 70.58218008000006],
              [-115.86392167899993, 70.58470286700003],
              [-115.8347875639999, 70.58161041900007],
              [-115.81578528599994, 70.57367584800005],
              [-115.8242895169999, 70.56195709800005],
              [-115.8792211579999, 70.54621002800008],
              [-115.94212805899991, 70.54230377800008],
              [-116.06411699099993, 70.55170319200005],
              [-116.00698808499993, 70.55902741100005],
              [-115.9890844389999, 70.56537506700005],
              [-115.90957597599993, 70.57477448100008],
              [-115.88597571499992, 70.58218008000006],
            ],
          ],
          [
            [
              [-117.05724036399994, 70.57160065300008],
              [-116.9175512359999, 70.56647370000007],
              [-116.87975012899994, 70.55170319200005],
              [-116.90831458199995, 70.54315827000005],
              [-117.00259355399993, 70.55170319200005],
              [-117.2219945949999, 70.54311758000006],
              [-117.27578691299993, 70.55027903900003],
              [-117.3042699859999, 70.57160065300008],
              [-117.23973548099991, 70.59271881700005],
              [-117.21548417899993, 70.59271881700005],
              [-117.05724036399994, 70.57160065300008],
            ],
          ],
          [
            [
              [-128.2346085279999, 70.66095612200007],
              [-128.20152747299994, 70.65997955900008],
              [-128.15599524599992, 70.64813873900005],
              [-128.1120499339999, 70.63080475500004],
              [-128.08372962099992, 70.61318594000005],
              [-128.09341386599993, 70.60586172100005],
              [-128.10366777299993, 70.60138580900008],
              [-128.1142471999999, 70.60114166900007],
              [-128.12474524599992, 70.60635000200006],
              [-128.11856035099993, 70.58441803600005],
              [-128.1370336579999, 70.57538483300004],
              [-128.16490637899994, 70.57501862200007],
              [-128.1868383449999, 70.57904694200005],
              [-128.22240149599992, 70.59711334800005],
              [-128.2412817049999, 70.59943268400008],
              [-128.25511633999992, 70.58527252800008],
              [-128.25084387899994, 70.58234284100007],
              [-128.24669348899994, 70.57615794500003],
              [-128.24205481699994, 70.57160065300008],
              [-128.26895097599993, 70.56704336100006],
              [-128.3444718089999, 70.54486725500004],
              [-128.3171280589999, 70.57160065300008],
              [-128.25523841099994, 70.64716217700004],
              [-128.2346085279999, 70.66095612200007],
            ],
          ],
          [
            [
              [-100.35138912699995, 70.48965078300006],
              [-100.46198482999995, 70.49648672100005],
              [-100.65562903599994, 70.55158112200007],
              [-100.68032792899993, 70.57534414300005],
              [-100.67813066299993, 70.59247467700004],
              [-100.66832434799994, 70.61505768400008],
              [-100.66612708199995, 70.62995026200008],
              [-100.67178300699993, 70.64573802300004],
              [-100.68529212099992, 70.65940989800004],
              [-100.71450761599993, 70.68146393400008],
              [-100.68590247299994, 70.68475983300004],
              [-100.58043372299994, 70.66095612200007],
              [-100.55089270699995, 70.66779205900008],
              [-100.51793372299994, 70.67926666900007],
              [-100.4863988919999, 70.68154531500005],
              [-100.46125240799995, 70.66095612200007],
              [-100.41283118399991, 70.64052969000005],
              [-100.35875403599994, 70.63275788000004],
              [-100.34390214799993, 70.62620677300004],
              [-100.35879472599993, 70.62116120000007],
              [-100.36506100199995, 70.62002187700006],
              [-100.34434973899994, 70.60976797100005],
              [-100.27505449099993, 70.60635000200006],
              [-100.2337133449999, 70.59520091400003],
              [-100.19375566299993, 70.57904694200005],
              [-100.2122289699999, 70.56720612200007],
              [-100.23912512899994, 70.56712474200003],
              [-100.26720130099994, 70.57379791900007],
              [-100.31383216099994, 70.59003327000005],
              [-100.3406469389999, 70.59324778900003],
              [-100.36754309799994, 70.59174225500004],
              [-100.39240475199995, 70.58527252800008],
              [-100.36815344999991, 70.56997304900005],
              [-100.31305904899995, 70.55463288000004],
              [-100.28868567599994, 70.53807200700004],
              [-100.28962154899995, 70.51854075700004],
              [-100.25413977799991, 70.48969147300005],
              [-100.22923743399991, 70.46454498900005],
              [-100.26203365799995, 70.45612213700008],
              [-100.28355872299994, 70.46137116100005],
              [-100.32774817599994, 70.48257070500006],
              [-100.35138912699995, 70.48965078300006],
            ],
          ],
          [
            [
              [-125.94888261599993, 71.96320221600007],
              [-125.9680883449999, 71.96523672100005],
              [-125.98843339799993, 71.97040436400005],
              [-125.99693762899994, 71.97703685100004],
              [-125.98029537699989, 71.98362864800004],
              [-125.96361243399991, 71.98281484600005],
              [-125.90908769399994, 71.96434153900003],
              [-125.94888261599993, 71.96320221600007],
            ],
          ],
          [
            [
              [-110.50706946499992, 72.59381745000007],
              [-110.4954320949999, 72.59259674700007],
              [-110.48542232999995, 72.58901601800005],
              [-110.47752844999991, 72.58270905200004],
              [-110.47232011599993, 72.57330963700008],
              [-110.5425512359999, 72.57208893400008],
              [-110.57526607999995, 72.57965729400007],
              [-110.59585527299993, 72.60065338700008],
              [-110.5503637359999, 72.60219961100006],
              [-110.52757727799991, 72.60049062700006],
              [-110.50706946499992, 72.59381745000007],
            ],
          ],
          [
            [
              [-110.39720618399991, 72.62051015800006],
              [-110.3828832669999, 72.62164948100008],
              [-110.36856035099993, 72.62103913000004],
              [-110.35659745999993, 72.61688873900005],
              [-110.34886633999992, 72.60748932500007],
              [-110.4934789699999, 72.62051015800006],
              [-110.46922766799992, 72.62539297100005],
              [-110.39720618399991, 72.62051015800006],
            ],
          ],
          [
            [
              [-110.31468665299991, 72.65521881700005],
              [-110.27989661399994, 72.64842357000003],
              [-110.3030492829999, 72.63320547100005],
              [-110.33975175699993, 72.63202545800004],
              [-110.41087805899991, 72.64223867400005],
              [-110.38817298099991, 72.64874909100007],
              [-110.36424719999991, 72.65277741100005],
              [-110.31468665299991, 72.65521881700005],
            ],
          ],
          [
            [
              [-100.87218176999994, 69.80780670800004],
              [-100.87828528599994, 69.78294505400004],
              [-100.89464270699995, 69.76113515800006],
              [-100.91856848899994, 69.74640534100007],
              [-100.94725501199991, 69.74298737200007],
              [-100.94725501199991, 69.73615143400008],
              [-100.9199926419999, 69.71971263200004],
              [-100.9251195949999, 69.69969310100004],
              [-100.96434485599991, 69.66445547100005],
              [-100.97801673099991, 69.66323476800005],
              [-101.04967200399994, 69.66787344000005],
              [-101.07701575399994, 69.66038646000004],
              [-101.09211178299995, 69.66103750200006],
              [-101.11172441299993, 69.66787344000005],
              [-101.13695227799991, 69.68109772300005],
              [-101.15298417899993, 69.69220612200007],
              [-101.15908769399994, 69.69041575700004],
              [-101.16295325399994, 69.68500397300005],
              [-101.16698157499991, 69.68154531500005],
              [-101.25511633999992, 69.66787344000005],
              [-101.29478919199994, 69.67047760600008],
              [-101.32852128799993, 69.67938873900005],
              [-101.35651607999995, 69.69619375200006],
              [-101.37865149599992, 69.72247955900008],
              [-101.37840735599991, 69.73200104400007],
              [-101.43016516799992, 69.76683177300004],
              [-101.4649145169999, 69.82489655200004],
              [-101.47154700399994, 69.83226146000004],
              [-101.45767167899993, 69.84910716400003],
              [-101.42642167899993, 69.87954336100006],
              [-101.42568925699993, 69.90106842700004],
              [-101.43854732999995, 69.90924713700008],
              [-101.45738684799994, 69.90615469000005],
              [-101.47484290299991, 69.89378489800004],
              [-101.55288652299993, 69.79710521000004],
              [-101.56427975199995, 69.76683177300004],
              [-101.56944739499994, 69.74567291900007],
              [-101.58267167899993, 69.73065827000005],
              [-101.63805091099994, 69.69554271000004],
              [-101.65160071499992, 69.68219635600008],
              [-101.67345130099994, 69.64671458500004],
              [-101.68382727799991, 69.65570709800005],
              [-101.6875707669999, 69.66474030200004],
              [-101.68936113199993, 69.67352936400005],
              [-101.69395911399994, 69.68154531500005],
              [-101.70677649599992, 69.69122955900008],
              [-101.85065670499995, 69.74713776200008],
              [-101.86522376199991, 69.74982330900008],
              [-101.8809301419999, 69.74502187700006],
              [-101.90005449099993, 69.73615143400008],
              [-101.91978919199994, 69.73163483300004],
              [-101.93724524599992, 69.73956940300008],
              [-101.98155676999994, 69.77460358300004],
              [-102.00340735599991, 69.78705475500004],
              [-102.01268469999991, 69.79417552300004],
              [-102.02208411399994, 69.80394114800004],
              [-102.02476966099994, 69.80857982000003],
              [-102.02293860599991, 69.82176341400003],
              [-102.02969316299993, 69.84723541900007],
              [-102.04670162699995, 69.85529205900008],
              [-102.06899980399993, 69.85162995000007],
              [-102.10948645699995, 69.83478424700007],
              [-102.12417558499993, 69.83209870000007],
              [-102.15697180899991, 69.83234284100007],
              [-102.16454016799992, 69.83608633000006],
              [-102.1731664699999, 69.84479401200008],
              [-102.17857825399994, 69.85488515800006],
              [-102.17686926999994, 69.86273834800005],
              [-102.16722571499992, 69.88320547100005],
              [-102.17943274599992, 69.90176015800006],
              [-102.20238196499992, 69.91526927300004],
              [-102.22496497299994, 69.92047760600008],
              [-102.25300045499995, 69.91250234600005],
              [-102.25430253799993, 69.89350006700005],
              [-102.23582923099991, 69.85285065300008],
              [-102.2962133449999, 69.85317617400005],
              [-102.32437089799993, 69.84739817900004],
              [-102.34569251199991, 69.83234284100007],
              [-102.31798255099994, 69.81830475500004],
              [-102.30589758999992, 69.80882396000004],
              [-102.29723059799994, 69.79759349200003],
              [-102.30719967399995, 69.78705475500004],
              [-102.32103430899991, 69.77586497600004],
              [-102.33592688699991, 69.76703522300005],
              [-102.34878495999993, 69.76341380400004],
              [-102.37401282499991, 69.76434967700004],
              [-102.37612870999993, 69.76801178600005],
              [-102.36888587099992, 69.77631256700005],
              [-102.36611894399994, 69.79075755400004],
              [-102.37271074099993, 69.80223216400003],
              [-102.38426673099991, 69.81354401200008],
              [-102.39537512899994, 69.81761302300004],
              [-102.40029863199993, 69.80780670800004],
              [-102.40074622299994, 69.79279205900008],
              [-102.40371660099993, 69.78375885600008],
              [-102.4116918609999, 69.77912018400008],
              [-102.42699133999992, 69.77708567900004],
              [-102.43321692599994, 69.77903880400004],
              [-102.45262610599991, 69.78831614800004],
              [-102.46178137899994, 69.79075755400004],
              [-102.47313391799992, 69.79120514500005],
              [-102.48228919199994, 69.79022858300004],
              [-102.49046790299991, 69.78693268400008],
              [-102.52525794199994, 69.76032135600008],
              [-102.53941809799994, 69.75446198100008],
              [-102.58226477799991, 69.74347565300008],
              [-102.5921117829999, 69.74298737200007],
              [-102.6023656889999, 69.74526601800005],
              [-102.62092037699995, 69.75405508000006],
              [-102.64395097599993, 69.76048411700003],
              [-102.65925045499995, 69.76797109600005],
              [-102.67259680899991, 69.76943594000005],
              [-102.68150794199994, 69.75600820500006],
              [-102.61510169199994, 69.71426015800006],
              [-102.57835852799991, 69.69794342700004],
              [-102.48717200399994, 69.69065989800004],
              [-102.49217688699991, 69.66840241100005],
              [-102.50755774599992, 69.63548411700003],
              [-102.49522864499994, 69.59955475500004],
              [-102.50121008999992, 69.59540436400005],
              [-102.50552324099993, 69.59121328300006],
              [-102.51016191299993, 69.58771393400008],
              [-102.51699785099993, 69.58535390800006],
              [-102.51488196499992, 69.58071523600006],
              [-102.51162675699993, 69.56879303600005],
              [-102.50959225199995, 69.56419505400004],
              [-102.53844153599994, 69.55483633000006],
              [-102.57022050699993, 69.54873281500005],
              [-102.63487708199995, 69.54433828300006],
              [-102.69408118399991, 69.55149974200003],
              [-102.71499589799993, 69.55117422100005],
              [-102.78384355399993, 69.53685130400004],
              [-102.8179418609999, 69.53872304900005],
              [-102.87352454299992, 69.55914948100008],
              [-103.01081295499995, 69.58124420800004],
              [-103.0235082669999, 69.59210846600007],
              [-103.08788001199991, 69.59601471600007],
              [-103.15737870999993, 69.61688873900005],
              [-103.22175045499995, 69.64777252800008],
              [-103.27049719999991, 69.68154531500005],
              [-103.29759680899991, 69.69452545800004],
              [-103.32176673099991, 69.68976471600007],
              [-103.34752356699994, 69.68081289300005],
              [-103.37975012899994, 69.68154531500005],
              [-103.38780676999994, 69.68671295800004],
              [-103.39513098899994, 69.69513580900008],
              [-103.40489661399994, 69.70355866100005],
              [-103.4207250639999, 69.70880768400008],
              [-103.43659420499995, 69.70815664300005],
              [-103.48961341099994, 69.69452545800004],
              [-103.47887122299994, 69.67658112200007],
              [-103.48448645699995, 69.65884023600006],
              [-103.5100805329999, 69.61945221600007],
              [-103.44766191299993, 69.61318594000005],
              [-103.3281957669999, 69.57355377800008],
              [-103.2207738919999, 69.55548737200007],
              [-103.18838456899994, 69.53302643400008],
              [-103.16539466099994, 69.50214264500005],
              [-103.13609778599994, 69.44985586100006],
              [-103.12555904899995, 69.43988678600005],
              [-103.1128637359999, 69.44163646000004],
              [-103.09544837099992, 69.45807526200008],
              [-103.09316972599993, 69.47443268400008],
              [-103.0977270169999, 69.49607982000003],
              [-103.09850012899994, 69.51508209800005],
              [-103.08519446499992, 69.52326080900008],
              [-103.05894934799994, 69.52155182500007],
              [-103.04112708199995, 69.51532623900005],
              [-103.02818762899994, 69.50275299700007],
              [-103.01667232999995, 69.48224518400008],
              [-103.01427161399994, 69.47402578300006],
              [-103.01260331899994, 69.45612213700008],
              [-103.01040605399993, 69.44814687700006],
              [-103.00548255099994, 69.44110748900005],
              [-102.99388587099992, 69.43012116100005],
              [-102.98932857999995, 69.42084381700005],
              [-103.00055904899995, 69.40957265800006],
              [-103.0247289699999, 69.37787506700005],
              [-103.03709876199991, 69.36619700700004],
              [-103.01927649599992, 69.34373607000003],
              [-103.01634680899991, 69.32623932500007],
              [-103.0235082669999, 69.28025950700004],
              [-103.03831946499992, 69.25739166900007],
              [-103.07274329299992, 69.24042389500005],
              [-103.19493567599994, 69.20954010600008],
              [-103.20840410099993, 69.20111725500004],
              [-103.21397864499994, 69.19253164300005],
              [-103.21336829299992, 69.18675364800004],
              [-103.21031653599994, 69.18060944200005],
              [-103.20840410099993, 69.17072174700007],
              [-103.21157792899993, 69.15940989800004],
              [-103.21715247299994, 69.14964427300004],
              [-103.21922766799992, 69.14020416900007],
              [-103.21214758999992, 69.12970612200007],
              [-103.1980688139999, 69.12030670800004],
              [-103.18346106699994, 69.11587148600006],
              [-103.16856848899994, 69.11758047100005],
              [-103.15379798099991, 69.12665436400005],
              [-103.14952551999994, 69.13401927300004],
              [-103.14146887899994, 69.15668366100005],
              [-103.13337154899995, 69.16693756700005],
              [-103.12173417899993, 69.17426178600005],
              [-103.08495032499991, 69.19155508000006],
              [-103.0462133449999, 69.20246002800008],
              [-103.02208411399994, 69.22093333500004],
              [-102.94835364499994, 69.29791901200008],
              [-102.93175208199995, 69.30609772300005],
              [-102.89806067599994, 69.31830475500004],
              [-102.8828832669999, 69.32831452000005],
              [-102.87889563699991, 69.33869049700007],
              [-102.87946529899995, 69.35114166900007],
              [-102.87755286399994, 69.36176178600005],
              [-102.86644446499992, 69.36619700700004],
              [-102.86095130099994, 69.36725495000007],
              [-102.85391191299993, 69.36994049700007],
              [-102.84788977799991, 69.37327708500004],
              [-102.84532630099994, 69.37641022300005],
              [-102.84292558499993, 69.38471100500004],
              [-102.83678137899994, 69.38686758000006],
              [-102.70518958199995, 69.39012278900003],
              [-102.66714433499993, 69.40412018400008],
              [-102.62962805899991, 69.41315338700008],
              [-102.54735266799992, 69.41351959800005],
              [-102.51699785099993, 69.42829010600008],
              [-102.4837133449999, 69.47113678600005],
              [-102.46422278599994, 69.48065827000005],
              [-102.38442949099993, 69.48305898600006],
              [-102.34569251199991, 69.48969147300005],
              [-102.30382239499994, 69.50165436400005],
              [-102.28258216099994, 69.50364817900004],
              [-102.21792558499993, 69.49030182500007],
              [-102.08462480399993, 69.48969147300005],
              [-102.05479895699995, 69.48444245000007],
              [-101.9683324859999, 69.44135163000004],
              [-101.93907630099994, 69.42064036700003],
              [-101.94664466099994, 69.40591054900005],
              [-102.03872636599993, 69.35740794500003],
              [-102.1194555329999, 69.36652252800008],
              [-102.16006425699993, 69.35936107000003],
              [-102.1731664699999, 69.35252513200004],
              [-102.1675512359999, 69.34511953300006],
              [-102.1731664699999, 69.34511953300006],
              [-102.17170162699995, 69.32640208500004],
              [-102.1731664699999, 69.31842682500007],
              [-102.16006425699993, 69.31867096600007],
              [-102.13817298099991, 69.32807038000004],
              [-102.12596594999991, 69.33144765800006],
              [-102.11025956899994, 69.33295319200005],
              [-102.10545813699991, 69.33144765800006],
              [-102.10313880099994, 69.32566966400003],
              [-102.09487870999993, 69.31468333500004],
              [-102.0716039699999, 69.30239492400005],
              [-102.0481664699999, 69.29669830900008],
              [-102.03783118399991, 69.28803131700005],
              [-102.05394446499992, 69.26654694200005],
              [-102.07559160099993, 69.24725983300004],
              [-102.09080969999991, 69.23997630400004],
              [-102.10728919199994, 69.24510325700004],
              [-102.13280188699991, 69.26312897300005],
              [-102.15566972599993, 69.27606842700004],
              [-102.18272864499994, 69.28245677300004],
              [-102.21056067599994, 69.27928294500003],
              [-102.23582923099991, 69.26312897300005],
              [-102.2239477199999, 69.25779857000003],
              [-102.21654212099992, 69.24994538000004],
              [-102.21519934799994, 69.24013906500005],
              [-102.22154700399994, 69.22907135600008],
              [-102.20881100199995, 69.22410716400003],
              [-102.17983964799993, 69.21662018400008],
              [-102.16661536399994, 69.21539948100008],
              [-102.15794837099992, 69.21259186400005],
              [-102.13955644399994, 69.19489166900007],
              [-102.11685136599993, 69.18622467700004],
              [-102.08983313699991, 69.18244049700007],
              [-102.0672094389999, 69.18915436400005],
              [-102.05768795499995, 69.21198151200008],
              [-102.04698645699995, 69.22943756700005],
              [-102.02232825399994, 69.24262116100005],
              [-101.99469967399995, 69.25161367400005],
              [-101.94888261599993, 69.26121653900003],
              [-101.92747962099992, 69.26154205900008],
              [-101.90855872299994, 69.25482819200005],
              [-101.88975989499994, 69.23895905200004],
              [-101.85399329299992, 69.21946849200003],
              [-101.8093969389999, 69.20897044500003],
              [-101.7715551419999, 69.19379303600005],
              [-101.75601152299993, 69.16014232000003],
              [-101.7683813139999, 69.12295156500005],
              [-101.79735266799992, 69.09369538000004],
              [-101.86587480399993, 69.04409414300005],
              [-101.85265051999994, 69.03534577000005],
              [-101.83438066299993, 69.02789948100008],
              [-101.81822669199994, 69.01911041900007],
              [-101.81126868399991, 69.00625234600005],
              [-101.82209225199995, 68.99599844000005],
              [-101.84679114499994, 68.98834870000007],
              [-101.96450761599993, 68.96963125200006],
              [-101.9903051419999, 68.97337474200003],
              [-102.00706946499992, 68.98159414300005],
              [-102.02171790299991, 68.99140045800004],
              [-102.03746497299994, 68.99957916900007],
              [-102.05736243399991, 69.00311920800004],
              [-102.07730058499993, 68.99970123900005],
              [-102.09439042899993, 68.99103424700007],
              [-102.12596594999991, 68.96832916900007],
              [-102.14915930899991, 68.95624420800004],
              [-102.16734778599994, 68.95302969000005],
              [-102.21410071499992, 68.95473867400005],
              [-102.31090247299994, 68.94037506700005],
              [-102.33653723899994, 68.94481028900003],
              [-102.38243567599994, 68.95783112200007],
              [-102.40713456899994, 68.95473867400005],
              [-102.39806067599994, 68.94017161700003],
              [-102.3860570949999, 68.92739492400005],
              [-102.39565995999993, 68.91693756700005],
              [-102.4082738919999, 68.90802643400008],
              [-102.42174231699994, 68.90180084800005],
              [-102.45010331899994, 68.89638906500005],
              [-102.46275794199994, 68.88898346600007],
              [-102.47476152299993, 68.88011302300004],
              [-102.4890844389999, 68.87274811400005],
              [-102.52306067599994, 68.86554596600007],
              [-102.63487708199995, 68.86591217700004],
              [-102.64415442599994, 68.86859772300005],
              [-102.69749915299991, 68.89154694200005],
              [-102.73033606699994, 68.89850495000007],
              [-102.74913489499994, 68.89948151200008],
              [-102.76431230399993, 68.89207591400003],
              [-102.75169837099992, 68.87571849200003],
              [-102.72598222599993, 68.85952383000006],
              [-102.7019750639999, 68.85228099200003],
              [-102.71401933499993, 68.83974844000005],
              [-102.73656165299991, 68.83348216400003],
              [-102.82917232999995, 68.83038971600007],
              [-102.84878495999993, 68.82648346600007],
              [-102.91706295499995, 68.80426666900007],
              [-102.96589107999995, 68.79865143400008],
              [-103.01463782499991, 68.80174388200004],
              [-103.07115637899994, 68.81834544500003],
              [-103.11221269399994, 68.82493724200003],
              [-103.1206762359999, 68.82855866100005],
              [-103.13149980399993, 68.83539459800005],
              [-103.13951575399994, 68.83860911700003],
              [-103.16356360599991, 68.84296295800004],
              [-103.3313695949999, 68.83120351800005],
              [-103.34801184799994, 68.82428620000007],
              [-103.36119544199994, 68.81346263200004],
              [-103.36485755099994, 68.80133698100008],
              [-103.3530981109999, 68.79022858300004],
              [-103.38316809799994, 68.78229401200008],
              [-103.41543535099993, 68.78327057500007],
              [-103.44725501199991, 68.78949616100005],
              [-103.50096594999991, 68.80621979400007],
              [-103.5462133449999, 68.82713450700004],
              [-103.56810462099992, 68.83120351800005],
              [-103.58104407499991, 68.82904694200005],
              [-103.60594641799992, 68.81964752800008],
              [-103.61929277299993, 68.81753164300005],
              [-103.71873938699991, 68.82648346600007],
              [-103.7639867829999, 68.83860911700003],
              [-103.78197180899991, 68.84088776200008],
              [-103.83218339799993, 68.83860911700003],
              [-103.86489824099993, 68.84284088700008],
              [-103.92756100199995, 68.86172109600005],
              [-103.96198482999995, 68.86591217700004],
              [-104.06550045499995, 68.85651276200008],
              [-104.09972083199995, 68.85846588700008],
              [-104.19782467399995, 68.88129303600005],
              [-104.22325598899994, 68.89325592700004],
              [-104.23355058499993, 68.90127187700006],
              [-104.23656165299991, 68.90607330900008],
              [-104.23802649599992, 68.91144440300008],
              [-104.24779212099992, 68.92910390800006],
              [-104.24962317599994, 68.93569570500006],
              [-104.25357011599993, 68.94171784100007],
              [-104.26423092399995, 68.94790273600006],
              [-104.30524654899995, 68.94037506700005],
              [-104.29796301999994, 68.92987702000005],
              [-104.27749589799993, 68.91787344000005],
              [-104.27041581899994, 68.90692780200004],
              [-104.30394446499992, 68.90875885600008],
              [-104.36656653599994, 68.92914459800005],
              [-104.4468481109999, 68.94155508000006],
              [-104.45909583199995, 68.93732330900008],
              [-104.46373450399994, 68.93065013200004],
              [-104.46837317599994, 68.91705963700008],
              [-104.47313391799992, 68.91034577000005],
              [-104.5296117829999, 68.87498607000003],
              [-104.59361731699994, 68.86448802300004],
              [-104.85832678949993, 68.88045888900004],
              [-105.12303626199991, 68.89642975500004],
              [-105.15550696499992, 68.90363190300008],
              [-105.19701087099992, 68.92975495000007],
              [-105.22516842399995, 68.94183991100005],
              [-105.25479081899994, 68.95111725500004],
              [-105.27782141799992, 68.95473867400005],
              [-105.2473852199999, 68.95661041900007],
              [-105.2219945949999, 68.96303945500006],
              [-105.19977779899995, 68.97459544500003],
              [-105.17882239499994, 68.99225495000007],
              [-105.14659583199995, 69.00193919500003],
              [-105.06484941299993, 68.98745351800005],
              [-105.03136145699995, 69.00311920800004],
              [-105.04588782499991, 69.01414622600004],
              [-105.05186926999994, 69.01679108300004],
              [-104.96483313699991, 69.03025950700004],
              [-104.91706295499995, 69.04791901200008],
              [-104.91844641799992, 69.07514069200005],
              [-104.9409887359999, 69.08608633000006],
              [-104.97252356699994, 69.09341054900005],
              [-105.08071855399993, 69.10618724200003],
              [-105.10130774599992, 69.10521067900004],
              [-105.1270238919999, 69.09186432500007],
              [-105.10362708199995, 69.09170156500005],
              [-105.07730058499993, 69.08706289300005],
              [-105.05382239499994, 69.07794830900008],
              [-105.03888912699995, 69.06460195500006],
              [-105.21393795499995, 69.08051178600005],
              [-105.2571508449999, 69.09422435100004],
              [-105.45787512899994, 69.10114166900007],
              [-105.46886145699995, 69.10614655200004],
              [-105.49132239499994, 69.12665436400005],
              [-105.50389563699991, 69.13515859600005],
              [-105.53502356699994, 69.15106842700004],
              [-105.54845130099994, 69.15395742400005],
              [-105.88585364499994, 69.17645905200004],
              [-105.92886308499993, 69.16693756700005],
              [-105.96792558499993, 69.14960358300004],
              [-105.98412024599992, 69.14712148600006],
              [-106.00503495999993, 69.14842357000003],
              [-106.07290605399993, 69.16014232000003],
              [-106.20396887899994, 69.14988841400003],
              [-106.32949785099993, 69.17845286700003],
              [-106.41209876199991, 69.18805573100008],
              [-106.41698157499991, 69.19350820500006],
              [-106.41519120999993, 69.20571523600006],
              [-106.40868079299992, 69.22565338700008],
              [-106.4019262359999, 69.23700592700004],
              [-106.38609778599994, 69.24603913000004],
              [-106.29454505099994, 69.27171458500004],
              [-106.2742406889999, 69.28807200700004],
              [-106.28209387899994, 69.31468333500004],
              [-106.29076087099992, 69.32074616100005],
              [-106.30093339799993, 69.32501862200007],
              [-106.30947831899994, 69.33100006700005],
              [-106.31309973899994, 69.34198639500005],
              [-106.31993567599994, 69.38605377800008],
              [-106.3198949859999, 69.39728424700007],
              [-106.31753495999993, 69.40131256700005],
              [-106.31981360599991, 69.40473053600005],
              [-106.33360755099994, 69.41400788000004],
              [-106.35094153599994, 69.42251211100006],
              [-106.37254798099991, 69.42890045800004],
              [-106.39513098899994, 69.43305084800005],
              [-106.41551673099991, 69.43451569200005],
              [-106.44050045499995, 69.44122955900008],
              [-106.51170813699991, 69.48969147300005],
              [-106.54625403599994, 69.50043366100005],
              [-106.58389238199993, 69.50360748900005],
              [-106.62051347599993, 69.49721914300005],
              [-106.66539466099994, 69.47036367400005],
              [-106.6953832669999, 69.45856354400007],
              [-106.70665442599994, 69.45123932500007],
              [-106.71450761599993, 69.44769928600005],
              [-106.73314368399991, 69.44830963700008],
              [-106.74107825399994, 69.44472890800006],
              [-106.7442113919999, 69.43915436400005],
              [-106.74425208199995, 69.43325429900005],
              [-106.74356035099993, 69.42715078300006],
              [-106.74596106699994, 69.41063060100004],
              [-106.7454320949999, 69.39931875200006],
              [-106.7461645169999, 69.38849518400008],
              [-106.75133216099994, 69.37986888200004],
              [-106.76707923099991, 69.37592194200005],
              [-106.9212133449999, 69.37083567900004],
              [-106.96344967399995, 69.36273834800005],
              [-106.99087480399993, 69.34511953300006],
              [-106.99274654899995, 69.32721588700008],
              [-106.9590551419999, 69.29682038000004],
              [-106.94713294199994, 69.26373932500007],
              [-106.94041907499991, 69.25421784100007],
              [-106.92638098899994, 69.23895905200004],
              [-106.92593339799993, 69.22744375200006],
              [-106.93736731699994, 69.21564362200007],
              [-106.9527074859999, 69.20604075700004],
              [-106.96422278599994, 69.20111725500004],
              [-107.02611243399991, 69.19794342700004],
              [-107.03929602799991, 69.18805573100008],
              [-107.03575598899994, 69.17739492400005],
              [-107.02782141799992, 69.16229889500005],
              [-107.02733313699991, 69.15228913000004],
              [-107.04580644399994, 69.15704987200007],
              [-107.1082250639999, 69.16372304900005],
              [-107.16869055899991, 69.13686758000006],
              [-107.27208411399994, 69.05776601800005],
              [-107.33482825399994, 69.02558014500005],
              [-107.47496497299994, 68.99290599200003],
              [-107.88158118399991, 68.95477936400005],
              [-107.94123287699995, 68.94110748900005],
              [-108.23167883999992, 68.93280670800004],
              [-108.32721920499995, 68.95209381700005],
              [-108.53945878799993, 68.94696686400005],
              [-108.56745357999995, 68.93423086100006],
              [-108.54539954299992, 68.92145416900007],
              [-108.53673255099994, 68.91478099200003],
              [-108.53331458199995, 68.90692780200004],
              [-108.53844153599994, 68.89541250200006],
              [-108.55028235599991, 68.88434479400007],
              [-108.56480872299994, 68.87596263200004],
              [-108.60558020699995, 68.86701080900008],
              [-108.66832434799994, 68.83759186400005],
              [-108.8028051419999, 68.79385000200006],
              [-108.86607825399994, 68.78400299700007],
              [-108.92223059799994, 68.75364817900004],
              [-108.95164954299992, 68.74241771000004],
              [-109.02855383999992, 68.72675202000005],
              [-109.34740149599992, 68.69806549700007],
              [-109.62462317599994, 68.64166901200008],
              [-109.78368079299992, 68.63255442900004],
              [-109.90379798099991, 68.63873932500007],
              [-109.9863988919999, 68.62518952000005],
              [-110.15835527299993, 68.63275788000004],
              [-110.22866777299993, 68.62787506700005],
              [-110.2942602199999, 68.60521067900004],
              [-110.34703528599994, 68.58022695500006],
              [-110.37608801999994, 68.57636139500005],
              [-110.40029863199993, 68.58820221600007],
              [-110.4214574859999, 68.60443756700005],
              [-110.44456946499992, 68.61131419500003],
              [-110.56944739499994, 68.61908600500004],
              [-110.60513261599993, 68.61692942900004],
              [-110.65794837099992, 68.58954498900005],
              [-110.69347083199995, 68.58535390800006],
              [-110.76036536399994, 68.58478424700007],
              [-110.98009192599994, 68.54840729400007],
              [-111.04157467399995, 68.56427643400008],
              [-111.02586829299992, 68.57160065300008],
              [-111.00389563699991, 68.57827383000006],
              [-110.84520423099991, 68.59516022300005],
              [-110.8489477199999, 68.60272858300004],
              [-110.8675024079999, 68.60993073100008],
              [-110.8906957669999, 68.61212799700007],
              [-111.0196020169999, 68.60293203300006],
              [-111.08250891799992, 68.58478424700007],
              [-111.10936438699991, 68.58071523600006],
              [-111.36241614499994, 68.58738841400003],
              [-111.4182836579999, 68.57855866100005],
              [-111.37100175699993, 68.56232330900008],
              [-111.25674394399994, 68.55829498900005],
              [-111.2053930329999, 68.55068594000005],
              [-111.25104732999995, 68.51968008000006],
              [-111.3489477199999, 68.52057526200008],
              [-111.53123938699991, 68.54376862200007],
              [-111.88921057849993, 68.52981191600006],
              [-112.24718176999994, 68.51585521000004],
              [-112.26463782499991, 68.51862213700008],
              [-112.28038489499994, 68.52350495000007],
              [-112.29670162699995, 68.52553945500006],
              [-112.33364824099993, 68.51203034100007],
              [-112.35228430899991, 68.50731028900003],
              [-112.39150956899994, 68.50287506700005],
              [-112.5833227199999, 68.50967031500005],
              [-112.60240637899994, 68.50775788000004],
              [-112.61571204299992, 68.50287506700005],
              [-112.65111243399991, 68.47833893400008],
              [-112.65843665299991, 68.47492096600007],
              [-112.67003333199995, 68.47304922100005],
              [-112.6946508449999, 68.47435130400004],
              [-112.74901282499991, 68.46308014500005],
              [-112.8980199859999, 68.47492096600007],
              [-113.24400794199994, 68.45441315300008],
              [-113.28302975199995, 68.46059804900005],
              [-113.30308997299994, 68.47492096600007],
              [-113.29808508999992, 68.49103424700007],
              [-113.26170813699991, 68.50287506700005],
              [-113.2117406889999, 68.50446198100008],
              [-113.0628149079999, 68.48859284100007],
              [-113.0391332669999, 68.49494049700007],
              [-113.05162512899994, 68.50958893400008],
              [-113.10342363199993, 68.53701406500005],
              [-113.14150956899994, 68.54840729400007],
              [-113.22423255099994, 68.56191640800006],
              [-113.28172766799992, 68.58169179900005],
              [-113.35049394399994, 68.59153880400004],
              [-113.36221269399994, 68.59760163000004],
              [-113.3867895169999, 68.61570872600004],
              [-113.39517167899993, 68.61953359600005],
              [-113.41978919199994, 68.62750885600008],
              [-113.44391842399995, 68.64655182500007],
              [-113.45482337099992, 68.66893138200004],
              [-113.43984941299993, 68.68720123900005],
              [-113.45201575399994, 68.70160553600005],
              [-113.4722387359999, 68.71308014500005],
              [-113.55077063699991, 68.74384186400005],
              [-113.56558183499993, 68.75299713700008],
              [-113.58043372299994, 68.76658763200004],
              [-113.59727942599994, 68.77765534100007],
              [-113.63866126199991, 68.79022858300004],
              [-113.65550696499992, 68.80048248900005],
              [-113.66812089799993, 68.81537506700005],
              [-113.67149817599994, 68.82754140800006],
              [-113.66173255099994, 68.83567942900004],
              [-113.63475501199991, 68.83860911700003],
              [-113.6192113919999, 68.84540436400005],
              [-113.63320878799993, 68.86029694200005],
              [-113.66917883999992, 68.88239166900007],
              [-113.67837480399993, 68.89842357000003],
              [-113.67210852799991, 68.90989817900004],
              [-113.63784745999993, 68.92739492400005],
              [-113.61290442599994, 68.94537995000007],
              [-113.59349524599992, 68.95107656500005],
              [-113.58067786399994, 68.95815664300005],
              [-113.57188880099994, 68.96515534100007],
              [-113.57359778599994, 68.96832916900007],
              [-113.58397376199991, 68.97687409100007],
              [-113.58299719999991, 68.99628327000005],
              [-113.57652747299994, 69.01699453300006],
              [-113.57022050699993, 69.02977122600004],
              [-113.63784745999993, 69.02977122600004],
              [-113.62490800699993, 69.04287344000005],
              [-113.60045325399994, 69.04657623900005],
              [-113.54971269399994, 69.04409414300005],
              [-113.56924394399994, 69.05703359600005],
              [-113.63731848899994, 69.07636139500005],
              [-113.65217037699995, 69.08844635600008],
              [-113.65416419199994, 69.09463125200006],
              [-113.66331946499992, 69.11090729400007],
              [-113.66584225199995, 69.11920807500007],
              [-113.66734778599994, 69.12124258000006],
              [-113.67007402299993, 69.12295156500005],
              [-113.67251542899993, 69.12616608300004],
              [-113.67259680899991, 69.13279857000003],
              [-113.66771399599992, 69.13214752800008],
              [-113.63784745999993, 69.13963450700004],
              [-113.69225012899994, 69.15558502800008],
              [-113.70055091099994, 69.16351959800005],
              [-113.69709225199995, 69.17230866100005],
              [-113.6907445949999, 69.17682526200008],
              [-113.68736731699994, 69.18268463700008],
              [-113.69310462099992, 69.19489166900007],
              [-113.67174231699994, 69.19432200700004],
              [-113.63369706899994, 69.18341705900008],
              [-113.50877844999991, 69.17446523600006],
              [-113.54112708199995, 69.19074127800008],
              [-113.58397376199991, 69.20123932500007],
              [-113.8850805329999, 69.23114655200004],
              [-113.89696204299992, 69.23672109600005],
              [-113.91966712099992, 69.25291575700004],
              [-113.94448808499993, 69.25893789300005],
              [-114.02269446499992, 69.24949778900003],
              [-114.1321508449999, 69.25063711100006],
              [-114.20474199099993, 69.26634349200003],
              [-114.23810787699995, 69.28046295800004],
              [-114.25479081899994, 69.28367747600004],
              [-114.3972875639999, 69.28815338700008],
              [-114.85570227799991, 69.25287506700005],
              [-114.8997289699999, 69.26312897300005],
              [-114.92650305899991, 69.27753327000005],
              [-114.93993079299992, 69.28196849200003],
              [-115.00645911399994, 69.28461334800005],
              [-115.02940833199995, 69.28188711100006],
              [-115.04678300699993, 69.27338288000004],
              [-115.07762610599991, 69.25413646000004],
              [-115.11253821499992, 69.24518463700008],
              [-115.18895423099991, 69.24266185100004],
              [-115.58189856699991, 69.27142975450005],
              [-115.97484290299991, 69.30019765800006],
              [-115.98932857999989, 69.30585358300004],
              [-116.00267493399991, 69.31354401200008],
              [-116.01292883999992, 69.32184479400007],
              [-116.02969316299993, 69.33087799700007],
              [-116.05357825399994, 69.33600495000007],
              [-116.14574133999992, 69.34105052300004],
              [-116.43163001199991, 69.40371328300006],
              [-116.52769934799994, 69.41388580900008],
              [-116.63267981699994, 69.46181875200006],
              [-116.62144934799994, 69.47695547100005],
              [-116.60106360599991, 69.48533763200004],
              [-116.55760657499991, 69.49591705900008],
              [-116.57237708199995, 69.50641510600008],
              [-116.58897864499994, 69.51365794500003],
              [-116.6035863919999, 69.52228424700007],
              [-116.61221269399994, 69.53685130400004],
              [-116.58641516799992, 69.54417552300004],
              [-116.58307857999989, 69.55402252800008],
              [-116.59609941299993, 69.56395091400003],
              [-116.61961829299992, 69.57168203300006],
              [-116.76305091099994, 69.57786692900004],
              [-116.74986731699994, 69.56826406500005],
              [-116.70840410099993, 69.55117422100005],
              [-116.73289954299992, 69.54376862200007],
              [-116.76085364499994, 69.55011627800008],
              [-116.81143144399994, 69.57477448100008],
              [-116.90562903599994, 69.59259674700007],
              [-116.92813066299993, 69.60578034100007],
              [-116.86961829299992, 69.62042877800008],
              [-116.84813391799992, 69.63279857000003],
              [-116.85582434799994, 69.64765045800004],
              [-116.85924231699994, 69.65420156500005],
              [-116.87246660099993, 69.66034577000005],
              [-116.9207250639999, 69.66787344000005],
              [-116.96670488199993, 69.68545156500005],
              [-117.05711829299992, 69.69472890800006],
              [-117.09740149599992, 69.70429108300004],
              [-117.14362545499989, 69.73187897300005],
              [-117.21084550699993, 69.75263092700004],
              [-117.23599199099993, 69.75600820500006],
              [-117.25206458199995, 69.76410553600005],
              [-117.26512610599991, 69.78253815300008],
              [-117.27379309799994, 69.80243561400005],
              [-117.27696692599994, 69.81492747600004],
              [-117.28368079299992, 69.82941315300008],
              [-117.32876542899993, 69.86957428600005],
              [-117.3672582669999, 69.91693756700005],
              [-117.38121497299994, 69.95123932500007],
              [-117.40029863199993, 69.96678294500003],
              [-117.44204667899993, 69.98940664300005],
              [-117.41441809799994, 70.01593659100007],
              [-117.38707434799994, 70.03367747600004],
              [-117.35806230399993, 70.04645416900007],
              [-117.29967200399994, 70.05658600500004],
              [-117.19505774599992, 70.09243398600006],
              [-116.96507727799991, 70.12905508000006],
              [-116.74351966099994, 70.14590078300006],
              [-116.51146399599992, 70.16339752800008],
              [-116.03270423099991, 70.22028229400007],
              [-115.63707434799994, 70.24799225500004],
              [-115.23350989499994, 70.26386139500005],
              [-115.05138098899994, 70.28021881700005],
              [-114.76268469999991, 70.29148997600004],
              [-114.50942949099993, 70.31525299700007],
              [-114.18472245999993, 70.31574127800008],
              [-114.03844153599994, 70.28123607000003],
              [-113.64268958199995, 70.26239655200004],
              [-113.4768774079999, 70.28359609600005],
              [-113.21963456899994, 70.25991445500006],
              [-112.99339758999992, 70.23139069200005],
              [-112.96690833199995, 70.23647695500006],
              [-112.98232988199993, 70.24725983300004],
              [-112.98741614499994, 70.25006745000007],
              [-112.96467037699995, 70.25336334800005],
              [-112.86449133999992, 70.24384186400005],
              [-112.83055579299992, 70.23151276200008],
              [-112.5862524079999, 70.20001862200007],
              [-112.5508520169999, 70.20038483300004],
              [-112.52122962099992, 70.20848216400003],
              [-112.53482011599993, 70.21507396000004],
              [-112.5833227199999, 70.22211334800005],
              [-112.5586645169999, 70.23920319200005],
              [-112.52696692599994, 70.24518463700008],
              [-112.46349036399994, 70.24384186400005],
              [-112.4495336579999, 70.24160390800006],
              [-112.4182836579999, 70.23183828300006],
              [-112.40176347599993, 70.22955963700008],
              [-112.35802161399994, 70.23615143400008],
              [-112.34312903599994, 70.23647695500006],
              [-112.34312903599994, 70.24384186400005],
              [-112.39150956899994, 70.25006745000007],
              [-112.37413489499994, 70.26166413000004],
              [-112.34235592399995, 70.26707591400003],
              [-112.16978919199994, 70.26740143400008],
              [-112.13760331899994, 70.27732982000003],
              [-112.27090410099993, 70.28436920800004],
              [-112.30894934799994, 70.29783763200004],
              [-112.26089433499993, 70.30931224200003],
              [-111.93740800699993, 70.26365794500003],
              [-111.83714758999992, 70.27350495000007],
              [-111.7163793609999, 70.26186758000006],
              [-111.6375219389999, 70.28058502800008],
              [-111.54865475199995, 70.26992422100005],
              [-111.52501380099994, 70.27147044500003],
              [-111.46812903599994, 70.28229401200008],
              [-111.4456274079999, 70.29043203300006],
              [-111.47838294199994, 70.30011627800008],
              [-111.56094316299993, 70.29511139500005],
              [-111.58958899599992, 70.31216054900005],
              [-111.56346594999991, 70.31793854400007],
              [-111.51158606699994, 70.32387929900005],
              [-111.48656165299991, 70.33197663000004],
              [-111.51561438699991, 70.35236237200007],
              [-111.56680253799993, 70.35993073100008],
              [-111.80882727799991, 70.35211823100008],
              [-111.87657630099994, 70.36737702000005],
              [-111.96426347599993, 70.37457916900007],
              [-111.98106848899994, 70.37909577000005],
              [-112.01414954299992, 70.39411041900007],
              [-112.0567113919999, 70.40668366100005],
              [-112.06940670499995, 70.41453685100004],
              [-112.07412675699993, 70.42112864800004],
              [-112.0803930329999, 70.43748607000003],
              [-112.08617102799991, 70.44525788000004],
              [-112.1223852199999, 70.47980377800008],
              [-112.14395097599993, 70.49388255400004],
              [-112.17243404899995, 70.50332265800006],
              [-112.19513912699995, 70.50580475500004],
              [-112.26085364499994, 70.50332265800006],
              [-112.28148352799991, 70.50556061400005],
              [-112.32945716099994, 70.52383047100005],
              [-112.35216223899994, 70.52460358300004],
              [-112.39256751199991, 70.51146067900004],
              [-112.41197669199994, 70.51072825700004],
              [-112.4241430329999, 70.51748281500005],
              [-112.42943274599992, 70.52659739800004],
              [-112.43716386599993, 70.53461334800005],
              [-112.45641028599994, 70.53807200700004],
              [-112.47215735599991, 70.53485748900005],
              [-112.49998938699991, 70.52073802300004],
              [-112.51748613199993, 70.51764557500007],
              [-112.53799394399994, 70.51862213700008],
              [-112.58409583199995, 70.52708567900004],
              [-112.64073645699995, 70.55060455900008],
              [-112.68219967399995, 70.56207916900007],
              [-112.72533118399991, 70.56915924700007],
              [-112.8206274079999, 70.57420482000003],
              [-112.84609941299993, 70.56989166900007],
              [-112.86656653599994, 70.54319896000004],
              [-112.8882543609999, 70.54726797100005],
              [-112.92589270699995, 70.56537506700005],
              [-113.05357825399994, 70.59023672100005],
              [-113.08665930899991, 70.60976797100005],
              [-113.10594641799992, 70.61847565300008],
              [-113.1309301419999, 70.61627838700008],
              [-113.17918860599991, 70.60635000200006],
              [-113.19302324099993, 70.61017487200007],
              [-113.20482337099992, 70.61945221600007],
              [-113.21068274599992, 70.63076406500005],
              [-113.2071020169999, 70.64052969000005],
              [-113.2071020169999, 70.64793528900003],
              [-113.36266028599994, 70.64736562700006],
              [-113.41258704299992, 70.65412018400008],
              [-113.49071204299992, 70.68183014500005],
              [-113.50304114499994, 70.68378327000005],
              [-113.51500403599994, 70.68146393400008],
              [-113.5203344389999, 70.67649974200003],
              [-113.52163652299993, 70.67011139500005],
              [-113.52232825399994, 70.66347890800006],
              [-113.52550208199995, 70.65753815300008],
              [-113.5613500639999, 70.64313385600008],
              [-113.60008704299992, 70.65086497600004],
              [-113.63829505099994, 70.66620514500005],
              [-113.68716386599993, 70.67780182500007],
              [-113.71959387899994, 70.69188060100004],
              [-113.98839270699995, 70.71621328300006],
              [-114.03636633999992, 70.70937734600005],
              [-114.14443925699993, 70.67251211100006],
              [-114.18309485599991, 70.66779205900008],
              [-114.34675045499989, 70.68650950700004],
              [-114.39732825399994, 70.67963288000004],
              [-114.50625566299993, 70.64451732000003],
              [-114.87340247299994, 70.62783437700006],
              [-115.04356848899994, 70.60415273600006],
              [-115.24144446499992, 70.61107005400004],
              [-115.49559485599991, 70.59951406500005],
              [-115.51235917899993, 70.59634023600006],
              [-115.54588782499991, 70.58222077000005],
              [-115.56069902299993, 70.57904694200005],
              [-115.58092200399994, 70.58014557500007],
              [-115.72891191299993, 70.60639069200005],
              [-116.03856360599991, 70.57916901200008],
              [-116.18748938699991, 70.59804922100005],
              [-116.20767167899993, 70.60724518400008],
              [-116.20421301999994, 70.61611562700006],
              [-116.16714433499993, 70.62002187700006],
              [-116.1897680329999, 70.63385651200008],
              [-116.23338782499991, 70.63971588700008],
              [-116.5833227199999, 70.63328685100004],
              [-116.65021725199995, 70.61322663000004],
              [-116.68285071499992, 70.60830312700006],
              [-116.98863684799994, 70.60248444200005],
              [-117.23599199099993, 70.62002187700006],
              [-117.33055579299992, 70.60268789300005],
              [-117.35265051999994, 70.61318594000005],
              [-117.34520423099991, 70.62002187700006],
              [-117.37409420499989, 70.62872955900008],
              [-117.51341712099992, 70.62002187700006],
              [-117.51748613199993, 70.61806875200006],
              [-117.51732337099992, 70.61371491100005],
              [-117.51602128799993, 70.60907623900005],
              [-117.5171606109999, 70.60635000200006],
              [-117.5344945949999, 70.60252513200004],
              [-117.55060787699995, 70.60187409100007],
              [-117.58543860599991, 70.60635000200006],
              [-117.69782467399995, 70.63564687700006],
              [-117.73582923099991, 70.66242096600007],
              [-117.70897376199991, 70.69513580900008],
              [-117.73387610599991, 70.71344635600008],
              [-117.77061926999994, 70.72894928600005],
              [-117.80899003799993, 70.73956940300008],
              [-117.87376868399991, 70.74827708500004],
              [-118.1868383449999, 70.83942291900007],
              [-118.27476966099994, 70.87840403900003],
              [-118.32176673099991, 70.90680573100008],
              [-118.41104081899994, 70.97455475500004],
              [-118.42149817599994, 70.99054596600007],
              [-118.38646399599992, 71.02220286700003],
              [-118.09223385299993, 71.09629954650003],
              [-117.79800370999993, 71.17039622600004],
              [-117.4749242829999, 71.18549225500004],
              [-117.09536699099993, 71.24380117400005],
              [-116.90005449099993, 71.24017975500004],
              [-116.8528539699999, 71.24827708500004],
              [-116.81826738199993, 71.26430898600006],
              [-116.8235570949999, 71.26577383000006],
              [-116.83315995999993, 71.26972077000005],
              [-116.83873450399994, 71.27045319200005],
              [-116.80630449099993, 71.29092031500005],
              [-116.31322180899991, 71.35065338700008],
              [-116.26878821499992, 71.36391836100006],
              [-116.10342363199993, 71.37665436400005],
              [-116.07778886599993, 71.36733633000006],
              [-116.17398027299993, 71.35366445500006],
              [-116.15367591099994, 71.34699127800008],
              [-116.12686113199993, 71.34625885600008],
              [-116.09972083199995, 71.35008372600004],
              [-116.05060787699995, 71.36395905200004],
              [-115.76463782499991, 71.36766185100004],
              [-115.72891191299993, 71.38715241100005],
              [-115.78726152299993, 71.39423248900005],
              [-115.90392005099994, 71.39350006700005],
              [-116.06631425699993, 71.41982656500005],
              [-116.20579993399991, 71.42621491100005],
              [-116.21495520699995, 71.43561432500007],
              [-116.1902563139999, 71.44452545800004],
              [-116.04771887899994, 71.44464752800008],
              [-115.74201412699995, 71.51068756700005],
              [-115.7625219389999, 71.49701569200005],
              [-115.74941972599993, 71.48480866100005],
              [-115.72960364499994, 71.48371002800008],
              [-115.61266028599994, 71.49795156500005],
              [-115.58433997299994, 71.49017975500004],
              [-115.59801184799994, 71.48403554900005],
              [-115.56786048099991, 71.47211334800005],
              [-115.48912512899994, 71.46747467700004],
              [-115.41901607999989, 71.45184967700004],
              [-115.38654537699995, 71.45897044500003],
              [-115.35545813699991, 71.47052643400008],
              [-115.3242895169999, 71.47654857000003],
              [-115.2066137359999, 71.48322174700007],
              [-115.14688066299993, 71.50462474200003],
              [-115.05675208199995, 71.52496979400007],
              [-115.10912024599992, 71.53558991100005],
              [-115.29698645699995, 71.49701569200005],
              [-115.43032792899993, 71.48944733300004],
              [-115.49767005099994, 71.49412669500003],
              [-115.55699622299994, 71.51068756700005],
              [-115.55699622299994, 71.51752350500004],
              [-115.4546606109999, 71.53119538000004],
              [-115.4546606109999, 71.53864166900007],
              [-115.60802161399994, 71.55536530200004],
              [-115.82359778599994, 71.54816315300008],
              [-115.88695227799991, 71.53046295800004],
              [-115.98106848899994, 71.52753327000005],
              [-116.0449926419999, 71.51471588700008],
              [-116.13613847599993, 71.50897858300004],
              [-116.1848852199999, 71.50031159100007],
              [-116.5528051419999, 71.47919342700004],
              [-116.63463294199994, 71.45477936400005],
              [-116.73232988199993, 71.45514557500007],
              [-116.82095292899993, 71.43256256700005],
              [-116.92210852799991, 71.42743561400005],
              [-117.04824785099993, 71.43740469000005],
              [-117.0718481109999, 71.43219635600008],
              [-117.08800208199995, 71.42633698100008],
              [-117.13084876199991, 71.41669342700004],
              [-117.1673070949999, 71.41299062700006],
              [-117.2053930329999, 71.40363190300008],
              [-117.22573808499993, 71.40143463700008],
              [-117.29019120999993, 71.40497467700004],
              [-117.36782792899993, 71.38833242400005],
              [-117.39024817599994, 71.38715241100005],
              [-117.4136449859999, 71.38890208500004],
              [-117.41722571499992, 71.39447663000004],
              [-117.41152910099993, 71.40403880400004],
              [-117.40318762899994, 71.42914459800005],
              [-117.38475501199991, 71.44440338700008],
              [-117.38060462099992, 71.45233795800004],
              [-117.39354407499991, 71.45954010600008],
              [-117.47618567599994, 71.45604075700004],
              [-117.46361243399991, 71.46527741100005],
              [-117.4578344389999, 71.46771881700005],
              [-117.44888261599993, 71.46971263200004],
              [-117.4676000639999, 71.48505280200004],
              [-117.50055904899995, 71.49575429900005],
              [-117.5366918609999, 71.50202057500007],
              [-117.56493079299992, 71.50385163000004],
              [-117.56151282499991, 71.49957916900007],
              [-117.55955969999991, 71.49628327000005],
              [-117.5567113919999, 71.49331289300005],
              [-117.55064856699994, 71.49017975500004],
              [-117.58145097599993, 71.48078034100007],
              [-117.61278235599991, 71.47654857000003],
              [-117.62962805899991, 71.47223541900007],
              [-117.63158118399991, 71.46259186400005],
              [-117.62246660099993, 71.45294830900008],
              [-117.60655676999994, 71.44863515800006],
              [-117.53433183499993, 71.44867584800005],
              [-117.49828040299991, 71.44098541900007],
              [-117.48302161399994, 71.42133209800005],
              [-117.49160722599993, 71.40766022300005],
              [-117.51138261599993, 71.39207591400003],
              [-117.53408769399994, 71.37938060100004],
              [-117.55134029899995, 71.37417226800005],
              [-117.70897376199991, 71.38715241100005],
              [-117.70152747299994, 71.39398834800005],
              [-117.71397864499994, 71.40350983300004],
              [-117.72789466099994, 71.40444570500006],
              [-117.74168860599991, 71.39931875200006],
              [-117.76805579299992, 71.38019440300008],
              [-117.7825414699999, 71.37543366100005],
              [-117.79954993399991, 71.37409088700008],
              [-117.84072831899994, 71.37616608300004],
              [-117.88011633999992, 71.38515859600005],
              [-117.90103105399993, 71.38715241100005],
              [-118.16197669199994, 71.37897370000007],
              [-118.24315344999991, 71.39337799700007],
              [-118.30882727799991, 71.43219635600008],
              [-118.30825761599993, 71.46991608300004],
              [-118.2527563139999, 71.50242747600004],
              [-118.12730872299994, 71.53864166900007],
              [-117.93150794199994, 71.54547760600008],
              [-117.78355872299994, 71.52887604400007],
              [-117.7573949859999, 71.53864166900007],
              [-117.8206274079999, 71.55158112200007],
              [-117.83934485599991, 71.55849844000005],
              [-117.76292883999992, 71.56049225500004],
              [-117.6922094389999, 71.55394114800004],
              [-117.67210852799991, 71.55874258000006],
              [-117.65371660099993, 71.57217031500005],
              [-117.69151770699995, 71.58242422100005],
              [-117.77285722599993, 71.58588288000004],
              [-117.8113500639999, 71.59324778900003],
              [-117.82518469999991, 71.60370514500005],
              [-117.83185787699995, 71.60687897300005],
              [-117.89683997299994, 71.61591217700004],
              [-117.90746008999992, 71.61554596600007],
              [-117.9212133449999, 71.61310455900008],
              [-117.92747962099992, 71.60956452000005],
              [-117.92910722599993, 71.60488515800006],
              [-117.9319555329999, 71.60101959800005],
              [-117.9417211579999, 71.60004303600005],
              [-117.95612545499989, 71.60346100500004],
              [-117.96629798099991, 71.61098867400005],
              [-117.96930904899995, 71.62173086100006],
              [-117.9622289699999, 71.63483307500007],
              [-117.9434301419999, 71.64313385600008],
              [-117.86656653599994, 71.64105866100005],
              [-117.69530188699991, 71.66836172100005],
              [-117.7215063139999, 71.67772044500003],
              [-118.07632402299993, 71.66498444200005],
              [-118.13182532499991, 71.65033600500004],
              [-118.1819555329999, 71.62738678600005],
              [-118.1738988919999, 71.60781484600005],
              [-118.20494544199994, 71.59845612200007],
              [-118.29771887899994, 71.59125397300005],
              [-118.35602779899995, 71.59324778900003],
              [-118.37490800699993, 71.59048086100006],
              [-118.40933183499993, 71.57977936400005],
              [-118.42894446499992, 71.57953522300005],
              [-118.42198645699995, 71.59056224200003],
              [-118.40074622299994, 71.60358307500007],
              [-118.39419511599993, 71.61310455900008],
              [-118.39826412699995, 71.62482330900008],
              [-118.41417395699995, 71.63198476800005],
              [-118.45567786399994, 71.64105866100005],
              [-118.46129309799994, 71.65306224200003],
              [-118.48863684799994, 71.65843333500004],
              [-118.54503333199995, 71.66152578300006],
              [-118.59068762899994, 71.66986725500004],
              [-118.60651607999989, 71.66836172100005],
              [-118.61636308499993, 71.66351959800005],
              [-118.63263912699995, 71.65053945500006],
              [-118.64403235599991, 71.64789459800005],
              [-118.6577856109999, 71.64956289300005],
              [-118.67747962099992, 71.65802643400008],
              [-118.6890356109999, 71.66152578300006],
              [-118.83299719999991, 71.66290924700007],
              [-118.86318925699993, 71.65892161700003],
              [-118.85350501199991, 71.64789459800005],
              [-118.86583411399994, 71.63841380400004],
              [-118.87926184799994, 71.63043854400007],
              [-118.89342200399994, 71.62433502800008],
              [-118.90811113199993, 71.62055084800005],
              [-118.90143795499989, 71.61054108300004],
              [-118.89146887899994, 71.60342031500005],
              [-118.86717688699991, 71.59324778900003],
              [-118.88857988199993, 71.58295319200005],
              [-118.92715410099993, 71.58934153900003],
              [-118.9968969389999, 71.61684804900005],
              [-119.01162675699993, 71.61994049700007],
              [-119.03237870999993, 71.62197500200006],
              [-119.05089270699995, 71.62677643400008],
              [-119.05894934799994, 71.63792552300004],
              [-119.0930883449999, 71.66836172100005],
              [-119.10334225199995, 71.68854401200008],
              [-119.12059485599991, 71.73700592700004],
              [-119.13125566299993, 71.75433991100005],
              [-119.13760331899994, 71.77435944200005],
              [-119.12938391799992, 71.79791901200008],
              [-119.10732988199993, 71.83966705900008],
              [-119.10020911399994, 71.88153717700004],
              [-119.09276282499991, 71.89874909100007],
              [-119.07603919199994, 71.91885000200006],
              [-119.05431067599994, 71.93528880400004],
              [-118.94786536399994, 71.99188873900005],
              [-118.8250219389999, 72.03864166900007],
              [-118.74754798099991, 72.05320872600004],
              [-118.7163793609999, 72.07298411700003],
              [-118.70982825399994, 72.08161041900007],
              [-118.70665442599994, 72.09129466400003],
              [-118.71003170499989, 72.10053131700005],
              [-118.72313391799992, 72.10781484600005],
              [-118.70641028599994, 72.12693919500003],
              [-118.67821204299992, 72.14227936400005],
              [-118.57673092399995, 72.17942942900004],
              [-118.44200598899994, 72.18284739800004],
              [-118.12783769399994, 72.22724030200004],
              [-118.10558020699995, 72.24774811400005],
              [-118.12486731699994, 72.30951569200005],
              [-118.17446855399993, 72.33836497600004],
              [-118.24205481699994, 72.34674713700008],
              [-118.42894446499992, 72.34674713700008],
              [-118.4973852199999, 72.36440664300005],
              [-118.51768958199995, 72.36717357000003],
              [-118.5405981109999, 72.37319570500006],
              [-118.56558183499993, 72.38800690300008],
              [-118.58560136599993, 72.40790436400005],
              [-118.59341386599993, 72.42869700700004],
              [-118.5686742829999, 72.47776927300004],
              [-118.51284745999993, 72.51044342700004],
              [-118.28307044199994, 72.58954498900005],
              [-118.25015214799993, 72.59381745000007],
              [-118.23843339799993, 72.59711334800005],
              [-118.22606360599991, 72.60516998900005],
              [-118.20579993399991, 72.62421295800004],
              [-118.18980872299994, 72.63544342700004],
              [-118.16958574099993, 72.64183177300004],
              [-118.12730872299994, 72.64842357000003],
              [-118.04088294199994, 72.67218659100007],
              [-118.00291907499991, 72.67377350500004],
              [-117.86729895699995, 72.70148346600007],
              [-117.80833899599992, 72.73773834800005],
              [-117.59561113199993, 72.79816315300008],
              [-117.54507402299993, 72.83063385600008],
              [-117.4820043609999, 72.85260651200008],
              [-117.45506751199991, 72.86749909100007],
              [-117.4004613919999, 72.90595123900005],
              [-117.36925208199995, 72.91779205900008],
              [-117.20815995999993, 72.92291901200008],
              [-117.11058508999992, 72.94481028900003],
              [-116.8948461579999, 72.96743398600006],
              [-116.64403235599991, 73.03497955900008],
              [-116.59365800699993, 73.06020742400005],
              [-116.49547278599994, 73.06159088700008],
              [-116.45449785099993, 73.06952545800004],
              [-116.43675696499992, 73.07550690300008],
              [-116.31895911399994, 73.09345123900005],
              [-116.20091712099992, 73.11888255400004],
              [-116.00816809799994, 73.14077383000006],
              [-115.76382402299993, 73.18671295800004],
              [-115.57042395699995, 73.20180898600006],
              [-115.39907792899993, 73.23346588700008],
              [-115.38263912699995, 73.24115631700005],
              [-115.36913001199991, 73.24957916900007],
              [-115.35098222599993, 73.25739166900007],
              [-115.33226477799991, 73.26312897300005],
              [-115.31680253799993, 73.26536692900004],
              [-115.23009192599994, 73.26422760600008],
              [-115.20787512899994, 73.26878489800004],
              [-115.12608801999994, 73.29507070500006],
              [-114.90729732999989, 73.31981028900003],
              [-114.73892167899993, 73.36640045800004],
              [-114.67870032499991, 73.37759023600006],
              [-114.5842992829999, 73.38458893400008],
              [-114.40746008999992, 73.34747955900008],
              [-114.26512610599991, 73.33567942900004],
              [-114.19664466099994, 73.30805084800005],
              [-114.02269446499992, 73.21185944200005],
              [-113.98106848899994, 73.17597077000005],
              [-113.96524003799993, 73.15729401200008],
              [-113.95836341099994, 73.14012278900003],
              [-113.96198482999989, 73.12287018400008],
              [-114.00446529899995, 73.07160065300008],
              [-114.00841223899994, 73.06305573100008],
              [-114.00698808499993, 73.05121491100005],
              [-114.0047094389999, 73.04279205900008],
              [-114.00426184799994, 73.03522370000007],
              [-114.00841223899994, 73.02578359600005],
              [-114.01646887899994, 73.01732005400004],
              [-114.03490149599992, 73.00584544500003],
              [-114.0425512359999, 72.99848053600005],
              [-114.04051673099991, 72.99697500200006],
              [-114.04263261599993, 72.98493073100008],
              [-114.04649817599994, 72.97272370000007],
              [-114.04938717399995, 72.97052643400008],
              [-114.04124915299991, 72.95571523600006],
              [-114.0308324859999, 72.94570547100005],
              [-114.02452551999994, 72.93447500200006],
              [-114.02892005099994, 72.91596100500004],
              [-114.03441321499992, 72.91181061400005],
              [-114.04381262899994, 72.90704987200007],
              [-114.0528051419999, 72.89984772300005],
              [-114.05679277299993, 72.88861725500004],
              [-114.0554906889999, 72.87791575700004],
              [-114.05134029899995, 72.87132396000004],
              [-114.03636633999992, 72.86066315300008],
              [-113.98794511599993, 72.83930084800005],
              [-113.9695531889999, 72.82453034100007],
              [-113.98106848899994, 72.80914948100008],
              [-114.02310136599993, 72.79779694200005],
              [-114.24120032499991, 72.79242584800005],
              [-114.25177975199995, 72.78896719000005],
              [-114.2827856109999, 72.76508209800005],
              [-114.33665930899991, 72.75560130400004],
              [-114.35606848899994, 72.74628327000005],
              [-114.34764563699991, 72.72724030200004],
              [-114.34142005099994, 72.71845123900005],
              [-114.33828691299993, 72.70111725500004],
              [-114.33397376199991, 72.69310130400004],
              [-114.31456458199995, 72.68577708500004],
              [-114.26773027299993, 72.69623444200005],
              [-114.24803626199991, 72.68939850500004],
              [-114.27061926999994, 72.68671295800004],
              [-114.31444251199991, 72.67377350500004],
              [-114.40477454299992, 72.65741608300004],
              [-114.42613684799994, 72.64842357000003],
              [-114.4563695949999, 72.63100820500006],
              [-114.4729711579999, 72.62433502800008],
              [-114.60423743399991, 72.60748932500007],
              [-114.59805253799993, 72.60748932500007],
              [-114.5855199859999, 72.60407135600008],
              [-114.57286536399994, 72.59926992400005],
              [-114.54967200399994, 72.58698151200008],
              [-114.55797278599994, 72.57099030200004],
              [-114.54613196499992, 72.56781647300005],
              [-114.5105688139999, 72.57330963700008],
              [-114.40623938699991, 72.55902741100005],
              [-114.36070716099994, 72.55890534100007],
              [-114.33946692599994, 72.56378815300008],
              [-114.32176673099991, 72.59178294500003],
              [-114.30089270699995, 72.59821198100008],
              [-114.25548255099994, 72.60065338700008],
              [-114.12608801999994, 72.63670482000003],
              [-113.88487708199995, 72.66205475500004],
              [-113.89854895699995, 72.64842357000003],
              [-113.85667883999992, 72.63690827000005],
              [-113.80101477799991, 72.64032623900005],
              [-113.55907141799992, 72.69891998900005],
              [-113.50877844999991, 72.70302969000005],
              [-113.55797278599994, 72.67194245000007],
              [-113.67943274599992, 72.63837311400005],
              [-113.73403886599993, 72.61424388200004],
              [-113.71165930899991, 72.60761139500005],
              [-113.68553626199991, 72.60805898600006],
              [-113.65957597599993, 72.61310455900008],
              [-113.63784745999993, 72.62051015800006],
              [-113.63072669199994, 72.62592194200005],
              [-113.62547766799992, 72.63320547100005],
              [-113.61961829299992, 72.63947174700007],
              [-113.61082923099991, 72.64223867400005],
              [-113.58739173099991, 72.64447663000004],
              [-113.47935950399994, 72.66665273600006],
              [-113.43980872299994, 72.68524811400005],
              [-113.43984941299993, 72.70990631700005],
              [-113.42723548099991, 72.72247955900008],
              [-113.42056230399993, 72.72719961100006],
              [-113.41258704299992, 72.73037344000005],
              [-113.44326738199993, 72.75189850500004],
              [-113.55858313699991, 72.75478750200006],
              [-113.60407467399995, 72.76170482000003],
              [-113.60399329299992, 72.77753327000005],
              [-113.57213294199994, 72.79779694200005],
              [-113.48379472599993, 72.84048086100006],
              [-113.3909399079999, 72.91156647300005],
              [-113.19245357999989, 72.99331289300005],
              [-113.01500403599994, 73.01601797100005],
              [-112.9422094389999, 73.00446198100008],
              [-112.85887610599991, 73.00470612200007],
              [-112.83975175699993, 73.00161367400005],
              [-112.80638587099992, 72.98798248900005],
              [-112.79185950399994, 72.98480866100005],
              [-112.53425045499995, 72.96088288000004],
              [-112.37315833199995, 72.91469961100006],
              [-112.28042558499993, 72.90253327000005],
              [-112.07730058499993, 72.89801666900007],
              [-112.0091039699999, 72.88104889500005],
              [-111.92153886599993, 72.87152741100005],
              [-111.88048255099994, 72.85663483300004],
              [-111.71422278599994, 72.83087799700007],
              [-111.64781653599994, 72.81061432500007],
              [-111.55223548099991, 72.80634186400005],
              [-111.5073949859999, 72.79547760600008],
              [-111.48379472599993, 72.78351471600007],
              [-111.46605383999992, 72.77130768400008],
              [-111.46524003799993, 72.76756419500003],
              [-111.46694902299993, 72.75560130400004],
              [-111.46605383999992, 72.75202057500007],
              [-111.45616614499994, 72.74925364800004],
              [-111.42829342399995, 72.74848053600005],
              [-111.39183508999992, 72.74140045800004],
              [-111.30842037699995, 72.73777903900003],
              [-111.21963456899994, 72.72410716400003],
              [-111.22472083199995, 72.70962148600006],
              [-111.22801673099991, 72.70307038000004],
              [-111.23330644399994, 72.69684479400007],
              [-111.21300208199995, 72.68463776200008],
              [-111.20885169199994, 72.67340729400007],
              [-111.21694902299993, 72.66030508000006],
              [-111.24571692599994, 72.62783437700006],
              [-111.25377356699994, 72.61424388200004],
              [-111.2617895169999, 72.58734772300005],
              [-111.26683508999992, 72.57953522300005],
              [-111.28929602799991, 72.56598541900007],
              [-111.49339758999992, 72.51064687700006],
              [-111.47988847599993, 72.50702545800004],
              [-111.46068274599992, 72.50486888200004],
              [-111.44399980399993, 72.50079987200007],
              [-111.43814042899993, 72.49140045800004],
              [-111.44725501199991, 72.48383209800005],
              [-111.56436113199993, 72.44114817900004],
              [-111.85464433499993, 72.38141510600008],
              [-111.8875219389999, 72.36774323100008],
              [-111.90428626199991, 72.34674713700008],
              [-111.88927161399994, 72.34577057500007],
              [-111.87271074099993, 72.34174225500004],
              [-111.84312903599994, 72.32965729400007],
              [-111.82115637899994, 72.32391998900005],
              [-111.79515540299991, 72.32444896000004],
              [-111.74722245999993, 72.33307526200008],
              [-111.68883216099994, 72.35590241100005],
              [-111.65880286399994, 72.35952383000006],
              [-111.6448461579999, 72.34052155200004],
              [-111.65998287699995, 72.32404205900008],
              [-111.72105872299994, 72.30255768400008],
              [-111.72301184799994, 72.28872304900005],
              [-111.72191321499992, 72.27155182500007],
              [-111.74376380099994, 72.25446198100008],
              [-111.77163652299993, 72.23810455900008],
              [-111.78819739499994, 72.22321198100008],
              [-111.7708227199999, 72.21084219000005],
              [-111.75332597599993, 72.20709870000007],
              [-111.73436438699991, 72.21328359600005],
              [-111.7124731109999, 72.23065827000005],
              [-111.70726477799991, 72.23891836100006],
              [-111.70620683499993, 72.24599844000005],
              [-111.7031957669999, 72.25291575700004],
              [-111.6829320949999, 72.26813385600008],
              [-111.66470292899993, 72.29214101800005],
              [-111.6507055329999, 72.29515208500004],
              [-111.61864173099991, 72.29181549700007],
              [-111.60265051999994, 72.29214101800005],
              [-111.59068762899994, 72.29612864800004],
              [-111.56334387899994, 72.30902741100005],
              [-111.4805395169999, 72.32465241100005],
              [-111.4182836579999, 72.34674713700008],
              [-111.4390356109999, 72.35382721600007],
              [-111.46202551999994, 72.35126373900005],
              [-111.50706946499992, 72.34052155200004],
              [-111.55483964799993, 72.33917877800008],
              [-111.57681230399993, 72.34349192900004],
              [-111.59642493399991, 72.35419342700004],
              [-111.60631262899994, 72.36220937700006],
              [-111.60924231699994, 72.36717357000003],
              [-111.60399329299992, 72.37254466400003],
              [-111.58958899599992, 72.38153717700004],
              [-111.57388261599993, 72.38873932500007],
              [-111.5315649079999, 72.40009186400005],
              [-111.47838294199994, 72.40448639500005],
              [-111.44131425699993, 72.41242096600007],
              [-111.40709387899994, 72.42621491100005],
              [-111.38011633999992, 72.44672272300005],
              [-111.34727942599994, 72.46230703300006],
              [-111.2952367829999, 72.47068919500003],
              [-111.24185136599993, 72.47142161700003],
              [-111.2053930329999, 72.46344635600008],
              [-111.21263587099992, 72.45551178600005],
              [-111.22057044199994, 72.45038483300004],
              [-111.23843339799993, 72.44196198100008],
              [-111.34312903599994, 72.42332591400003],
              [-111.36986243399991, 72.40818919500003],
              [-111.34972083199995, 72.40672435100004],
              [-111.3023168609999, 72.40875885600008],
              [-111.28111731699994, 72.40200429900005],
              [-111.3574926419999, 72.37148672100005],
              [-111.37669837099992, 72.35419342700004],
              [-111.35244706899994, 72.34756094000005],
              [-111.3342992829999, 72.35350169500003],
              [-111.31676184799994, 72.36481354400007],
              [-111.29474850199995, 72.37409088700008],
              [-111.27989661399994, 72.37518952000005],
              [-111.2395727199999, 72.37164948100008],
              [-111.2259008449999, 72.36717357000003],
              [-111.2195531889999, 72.36180247600004],
              [-111.20360266799992, 72.34430573100008],
              [-111.20225989499994, 72.34052155200004],
              [-111.14366614499994, 72.33905670800004],
              [-111.11668860599991, 72.33270905200004],
              [-111.08934485599991, 72.31883372600004],
              [-111.06387285099993, 72.29975006700005],
              [-111.04698645699995, 72.29035065300008],
              [-111.02790279899995, 72.28530508000006],
              [-111.03148352799991, 72.31313711100006],
              [-111.05044511599993, 72.33454010600008],
              [-111.0735570949999, 72.35358307500007],
              [-111.08934485599991, 72.37409088700008],
              [-111.08629309799994, 72.40827057500007],
              [-111.05361894399994, 72.42206452000005],
              [-111.01138261599993, 72.43105703300006],
              [-110.97948157499991, 72.45038483300004],
              [-111.00251217399995, 72.46377187700006],
              [-110.99518795499995, 72.47337474200003],
              [-110.97052975199995, 72.47980377800008],
              [-110.9414770169999, 72.48309967700004],
              [-110.78766842399995, 72.47711823100008],
              [-110.81623287699995, 72.49892812700006],
              [-110.82787024599992, 72.50995514500005],
              [-110.83604895699995, 72.52488841400003],
              [-110.72911536399994, 72.57127513200004],
              [-110.70409094999991, 72.57880280200004],
              [-110.67833411399994, 72.57916901200008],
              [-110.6233617829999, 72.55923086100006],
              [-110.59166419199994, 72.55414459800005],
              [-110.52757727799991, 72.55219147300005],
              [-110.48550370999993, 72.55829498900005],
              [-110.47915605399993, 72.55560944200005],
              [-110.48224850199995, 72.54450104400007],
              [-110.49022376199991, 72.53847890800006],
              [-110.59032141799992, 72.51349518400008],
              [-110.60334225199995, 72.50438060100004],
              [-110.59373938699991, 72.49428945500006],
              [-110.5703832669999, 72.48309967700004],
              [-110.54458574099993, 72.47402578300006],
              [-110.52757727799991, 72.47028229400007],
              [-110.51280676999994, 72.46954987200007],
              [-110.45376542899993, 72.46051666900007],
              [-110.42813066299993, 72.45209381700005],
              [-110.3914281889999, 72.44452545800004],
              [-110.3628637359999, 72.43349844000005],
              [-110.3342992829999, 72.42731354400007],
              [-110.30785071499992, 72.43618398600006],
              [-110.48570716099994, 72.48053620000007],
              [-110.53441321499992, 72.50438060100004],
              [-110.5139867829999, 72.51703522300005],
              [-110.48615475199995, 72.52545807500007],
              [-110.45799719999991, 72.52903880400004],
              [-110.43687903599994, 72.52684153900003],
              [-110.4292699859999, 72.52789948100008],
              [-110.42125403599994, 72.53400299700007],
              [-110.40721594999991, 72.54877350500004],
              [-110.39439856699994, 72.55662669500003],
              [-110.38052324099993, 72.55951569200005],
              [-110.34951738199993, 72.55902741100005],
              [-110.32656816299993, 72.55487702000005],
              [-110.28652910099993, 72.53656647300005],
              [-110.23989824099993, 72.52781810100004],
              [-110.16270911399994, 72.47968170800004],
              [-110.10952714799993, 72.45994700700004],
              [-110.08503170499995, 72.45661041900007],
              [-110.07945716099994, 72.45441315300008],
              [-110.05772864499994, 72.43952057500007],
              [-110.0496313139999, 72.43943919500003],
              [-110.01305091099994, 72.45661041900007],
              [-110.0036921869999, 72.45811595300006],
              [-109.98082434799994, 72.46181875200006],
              [-109.8626195949999, 72.44550202000005],
              [-109.83543860599991, 72.43602122600004],
              [-109.80825761599993, 72.43024323100008],
              [-109.78026282499991, 72.43618398600006],
              [-109.80308997299994, 72.45087311400005],
              [-109.98574785099993, 72.48924388200004],
              [-110.0036921869999, 72.49656810100004],
              [-110.0410863919999, 72.51178620000007],
              [-110.25942949099993, 72.55902741100005],
              [-110.23648027299993, 72.57013580900008],
              [-110.19713294199994, 72.57233307500007],
              [-110.09776770699995, 72.56049225500004],
              [-110.0036921869999, 72.52378978100006],
              [-109.99925696499992, 72.52204010600008],
              [-109.88573157499991, 72.49168528900003],
              [-109.85057532499991, 72.48948802300004],
              [-109.81639563699991, 72.49306875200006],
              [-109.78770911399994, 72.50438060100004],
              [-109.79971269399994, 72.51154205900008],
              [-109.82721920499995, 72.53384023600006],
              [-109.83861243399991, 72.53856028900003],
              [-109.85586503799993, 72.54059479400007],
              [-109.87596594999991, 72.54572174700007],
              [-109.91063391799992, 72.55902741100005],
              [-109.9319555329999, 72.57542552300004],
              [-109.94322669199994, 72.59227122600004],
              [-109.95693925699993, 72.60781484600005],
              [-110.0036921869999, 72.62730540600006],
              [-110.06159420499995, 72.65143463700008],
              [-110.10167395699995, 72.66290924700007],
              [-110.13658606699994, 72.65863678600005],
              [-110.17503821499992, 72.64785390800006],
              [-110.22207597599993, 72.64638906500005],
              [-110.26573645699995, 72.65534088700008],
              [-110.2942602199999, 72.67572663000004],
              [-110.19676673099991, 72.68113841400003],
              [-110.1707250639999, 72.68939850500004],
              [-110.19664466099994, 72.70514557500007],
              [-110.20750891799992, 72.71816640800006],
              [-110.19749915299991, 72.72711823100008],
              [-110.11929277299993, 72.72980377800008],
              [-110.04320227799991, 72.72113678600005],
              [-110.0036921869999, 72.71043528900003],
              [-109.87584387899994, 72.67572663000004],
              [-109.83873450399994, 72.67108795800004],
              [-109.81993567599994, 72.67218659100007],
              [-109.81786048099991, 72.67942942900004],
              [-109.82579505099994, 72.68598053600005],
              [-109.84520423099991, 72.69594961100006],
              [-109.85602779899995, 72.70302969000005],
              [-109.83873450399994, 72.71442291900007],
              [-109.81737219999991, 72.71808502800008],
              [-109.77342688699991, 72.71670156500005],
              [-109.79995683499993, 72.73102448100008],
              [-109.91051184799994, 72.73460521000004],
              [-109.95189368399991, 72.74115631700005],
              [-109.9934789699999, 72.75389232000003],
              [-110.0036921869999, 72.75543854400007],
              [-110.04991614499994, 72.76235586100006],
              [-110.1070043609999, 72.76365794500003],
              [-110.15021725199995, 72.75519440300008],
              [-110.1890356109999, 72.74315013200004],
              [-110.22935950399994, 72.73777903900003],
              [-110.25450598899994, 72.73895905200004],
              [-110.26675370999993, 72.74266185100004],
              [-110.26284745999993, 72.74900950700004],
              [-110.23961341099994, 72.75824616100005],
              [-110.20213782499991, 72.76373932500007],
              [-110.18179277299993, 72.76894765800006],
              [-110.1707250639999, 72.77875397300005],
              [-110.17271887899994, 72.79132721600007],
              [-110.19888261599993, 72.79922109600005],
              [-110.20543372299994, 72.80914948100008],
              [-110.23033606699994, 72.82428620000007],
              [-110.48350989499994, 72.83917877800008],
              [-110.52904212099992, 72.84926992400005],
              [-110.5679418609999, 72.86749909100007],
              [-110.6082250639999, 72.90086497600004],
              [-110.63174394399994, 72.91583893400008],
              [-110.68252519399994, 72.92877838700008],
              [-110.71670488199993, 72.94505442900004],
              [-110.7454320949999, 72.96556224200003],
              [-110.75413977799991, 72.98480866100005],
              [-110.73570716099994, 73.00136953300006],
              [-110.70372473899994, 73.00910065300008],
              [-110.39006507099992, 73.00242747600007],
              [-110.07640540299991, 72.99575429900005],
              [-110.0036921869999, 72.98505280200004],
              [-109.90534420499995, 72.97060781500005],
              [-109.89012610599991, 72.96369049700007],
              [-109.88341223899994, 72.95490143400008],
              [-109.8831274079999, 72.94745514500005],
              [-109.88463294199994, 72.94131094000005],
              [-109.88329016799992, 72.93642812700006],
              [-109.85488847599993, 72.92194245000007],
              [-109.82339433499993, 72.92352936400005],
              [-109.75918535099993, 72.93642812700006],
              [-109.68895423099991, 72.92983633000006],
              [-109.6226293609999, 72.91596100500004],
              [-109.64273027299993, 72.90013255400004],
              [-109.72744706899994, 72.89642975500004],
              [-109.75234941299993, 72.88117096600007],
              [-109.37621008999992, 72.77130768400008],
              [-109.38414466099994, 72.76715729400007],
              [-109.40416419199994, 72.75202057500007],
              [-109.18325761599993, 72.76703522300005],
              [-109.16331946499992, 72.76170482000003],
              [-109.1292211579999, 72.74721914300005],
              [-109.11611894399994, 72.74457428600005],
              [-109.12905839799993, 72.74054596600007],
              [-109.14293372299994, 72.73786041900007],
              [-109.15538489499994, 72.73354726800005],
              [-109.16392981699994, 72.72410716400003],
              [-109.05809485599991, 72.68886953300006],
              [-108.94603430899991, 72.67377350500004],
              [-108.94078528599994, 72.66547272300005],
              [-108.95738684799994, 72.65884023600006],
              [-109.03359941299993, 72.64842357000003],
              [-109.02122962099992, 72.63507721600007],
              [-109.02521725199995, 72.62400950700004],
              [-109.03831946499992, 72.61493561400005],
              [-109.05406653599994, 72.60748932500007],
              [-109.03429114499994, 72.59658437700006],
              [-109.02676347599993, 72.59381745000007],
              [-109.03213456899994, 72.58905670800004],
              [-109.04161536399994, 72.57794830900008],
              [-109.04723059799994, 72.57330963700008],
              [-109.02281653599994, 72.56806061400005],
              [-108.9370824859999, 72.57953522300005],
              [-108.86733964799993, 72.57135651200008],
              [-108.84178626199991, 72.57330963700008],
              [-108.85179602799991, 72.58222077000005],
              [-108.86327063699991, 72.58771393400008],
              [-108.8889867829999, 72.59381745000007],
              [-108.86782792899993, 72.60594310100004],
              [-108.67357337099992, 72.57746002800008],
              [-108.63341223899994, 72.56557851800005],
              [-108.61587480399993, 72.54877350500004],
              [-108.60985266799992, 72.53021881700005],
              [-108.59801184799994, 72.51723867400005],
              [-108.58967037699995, 72.50381094000005],
              [-108.59414628799993, 72.48395416900007],
              [-108.60338294199994, 72.47711823100008],
              [-108.61742102799991, 72.47199127800008],
              [-108.6301977199999, 72.46527741100005],
              [-108.63573157499991, 72.45351797100005],
              [-108.63784745999993, 72.44367096600007],
              [-108.6472875639999, 72.42365143400008],
              [-108.65298417899993, 72.39321523600006],
              [-108.65965735599991, 72.37738678600005],
              [-108.66307532499991, 72.36102936400005],
              [-108.65684973899994, 72.34052155200004],
              [-108.6438695949999, 72.32575104400007],
              [-108.60732988199993, 72.30219147300005],
              [-108.59105383999992, 72.28872304900005],
              [-108.53429114499994, 72.20246002800008],
              [-108.53335527299993, 72.19586823100008],
              [-108.5340063139999, 72.16885000200006],
              [-108.53600012899994, 72.15778229400007],
              [-108.54015051999994, 72.14874909100007],
              [-108.51610266799992, 72.14093659100007],
              [-108.48448645699995, 72.13808828300006],
              [-108.46003170499995, 72.14398834800005],
              [-108.45759029899995, 72.16242096600007],
              [-108.44277910099993, 72.16307200700004],
              [-108.42833411399994, 72.16079336100006],
              [-108.41466223899994, 72.15574778900003],
              [-108.4024145169999, 72.14874909100007],
              [-108.4097387359999, 72.14175039300005],
              [-108.41820227799991, 72.13690827000005],
              [-108.42756100199995, 72.13450755400004],
              [-108.43773352799991, 72.13446686400005],
              [-108.43773352799991, 72.12763092700004],
              [-108.41348222599993, 72.12714264500005],
              [-108.40501868399991, 72.11587148600006],
              [-108.40257727799991, 72.10004303600005],
              [-108.39614824099993, 72.08608633000006],
              [-108.39915930899991, 72.06696198100008],
              [-108.4024145169999, 72.05878327000005],
              [-108.39683997299994, 72.04559967700004],
              [-108.40025794199994, 72.02643463700008],
              [-108.41661536399994, 71.99046458500004],
              [-108.35252844999991, 71.99262116100005],
              [-108.32066809799994, 71.98883698100008],
              [-108.29312089799993, 71.97626373900005],
              [-108.32795162699995, 71.94285716400003],
              [-108.34093176999994, 71.93585846600007],
              [-108.31749426999994, 71.93553294500003],
              [-108.25405839799993, 71.96360911700003],
              [-108.22423255099994, 71.97003815300008],
              [-108.19151770699995, 71.96295807500007],
              [-108.1883031889999, 71.94953034100007],
              [-108.22109941299993, 71.91168854400007],
              [-108.24665279899995, 71.89789459800005],
              [-108.27721106699994, 71.89085521000004],
              [-108.29430091099994, 71.88149648600006],
              [-108.27944902299993, 71.86078522300005],
              [-108.26862545499995, 71.85565827000005],
              [-108.2566625639999, 71.85195547100005],
              [-108.2476293609999, 71.84552643400008],
              [-108.24596106699994, 71.83283112200007],
              [-108.25206458199995, 71.82322825700004],
              [-108.28693600199995, 71.79873281500005],
              [-108.26683508999992, 71.78343333500004],
              [-108.23924719999991, 71.77285390800006],
              [-108.20962480399993, 71.76654694200005],
              [-108.1839086579999, 71.76459381700005],
              [-108.17393958199995, 71.76154205900008],
              [-108.17031816299993, 71.75409577000005],
              [-108.17178300699993, 71.74518463700008],
              [-108.1770727199999, 71.73725006700005],
              [-108.1887914699999, 71.73322174700007],
              [-108.24596106699994, 71.72296784100007],
              [-108.19884192599994, 71.70600006700005],
              [-108.09764563699991, 71.72337474200003],
              [-108.04670162699995, 71.71674225500004],
              [-108.01817786399994, 71.70246002800008],
              [-107.99193274599992, 71.68341705900008],
              [-107.97777258999992, 71.66058991100005],
              [-107.98521887899994, 71.63483307500007],
              [-107.91706295499995, 71.63092682500007],
              [-107.85545813699991, 71.61041901200008],
              [-107.83250891799992, 71.60822174700007],
              [-107.81395423099991, 71.61310455900008],
              [-107.80650794199994, 71.61310455900008],
              [-107.78994706899994, 71.61688873900005],
              [-107.76545162699995, 71.61542389500005],
              [-107.74095618399991, 71.61815013200004],
              [-107.72451738199993, 71.63483307500007],
              [-107.78587805899991, 71.66388580900008],
              [-107.79995683499993, 71.66836172100005],
              [-107.81940670499995, 71.67112864800004],
              [-107.83307857999995, 71.67918528900003],
              [-107.83873450399994, 71.69232819200005],
              [-107.83438066299993, 71.70990631700005],
              [-107.80113684799994, 71.73436107000003],
              [-107.75609290299991, 71.72724030200004],
              [-107.70881100199995, 71.71100495000007],
              [-107.66844641799992, 71.70815664300005],
              [-107.63076738199993, 71.72809479400007],
              [-107.5984594389999, 71.75340403900003],
              [-107.56362870999993, 71.77521393400008],
              [-107.51878821499992, 71.78436920800004],
              [-107.25157630099994, 71.80613841400003],
              [-107.27749589799993, 71.81842682500007],
              [-107.31090247299994, 71.82672760600008],
              [-107.37511145699995, 71.83283112200007],
              [-107.39899654899995, 71.83828359600005],
              [-107.44261633999992, 71.86212799700007],
              [-107.47248287699995, 71.87026601800005],
              [-107.4651586579999, 71.87616608300004],
              [-107.44188391799992, 71.88629791900007],
              [-107.4290258449999, 71.88703034100007],
              [-107.34585527299993, 71.87197500200006],
              [-107.30719967399995, 71.87433502800008],
              [-107.27159583199995, 71.88446686400005],
              [-107.25157630099994, 71.90167877800008],
              [-107.27220618399991, 71.90900299700007],
              [-107.3335668609999, 71.91535065300008],
              [-107.39439856699994, 71.92829010600008],
              [-107.41665605399993, 71.92902252800008],
              [-107.41270911399994, 71.94354889500005],
              [-107.4141332669999, 71.96173737200007],
              [-107.42271887899994, 71.97719961100006],
              [-107.44001217399995, 71.98362864800004],
              [-107.48110917899993, 71.98794179900005],
              [-107.56411699099993, 72.00674062700006],
              [-107.6048070949999, 72.01093170800004],
              [-107.61827551999994, 72.01902903900003],
              [-107.63638261599993, 72.03766510600008],
              [-107.65160071499992, 72.05841705900008],
              [-107.6563207669999, 72.07298411700003],
              [-107.64688066299993, 72.08173248900005],
              [-107.62022864499994, 72.08612702000005],
              [-107.61465410099993, 72.09690989800004],
              [-107.62096106699994, 72.10317617400005],
              [-107.65172278599994, 72.11408112200007],
              [-107.66315670499995, 72.12079498900005],
              [-107.6551000639999, 72.12181224200003],
              [-107.63516191299993, 72.12763092700004],
              [-107.77916419199994, 72.14130280200004],
              [-107.77281653599994, 72.15525950700004],
              [-107.77603105399993, 72.16437409100007],
              [-107.78246008999992, 72.17153554900005],
              [-107.78600012899994, 72.17914459800005],
              [-107.78600012899994, 72.22699616100005],
              [-107.79478919199994, 72.25104401200008],
              [-107.81607011599993, 72.26569245000007],
              [-107.84194902299993, 72.27826569200005],
              [-107.86485755099994, 72.29584381700005],
              [-107.86074785099993, 72.30463288000004],
              [-107.83779863199993, 72.30735911700003],
              [-107.80955969999991, 72.30434804900005],
              [-107.77330481699994, 72.28778717700004],
              [-107.74913489499994, 72.28400299700007],
              [-107.72720292899993, 72.28790924700007],
              [-107.71776282499991, 72.30267975500004],
              [-107.73452714799993, 72.32656484600005],
              [-107.7735082669999, 72.33991120000007],
              [-107.81712805899991, 72.34910716400003],
              [-107.84805253799993, 72.36041901200008],
              [-107.81493079299992, 72.36786530200004],
              [-107.80386308499993, 72.37409088700008],
              [-107.80650794199994, 72.38776276200008],
              [-107.81810462099992, 72.39618561400005],
              [-107.8511449859999, 72.40326569200005],
              [-107.86485755099994, 72.41193268400008],
              [-107.8718969389999, 72.43480052300004],
              [-107.8086645169999, 72.44277578300006],
              [-107.78600012899994, 72.46344635600008],
              [-107.84007727799991, 72.46552155200004],
              [-107.89329993399991, 72.47353750200006],
              [-107.9426977199999, 72.49017975500004],
              [-107.98521887899994, 72.51805247600004],
              [-107.87535559799994, 72.52488841400003],
              [-107.88467363199993, 72.53733958500004],
              [-107.8902074859999, 72.54759349200003],
              [-107.88829505099994, 72.55853913000004],
              [-107.87535559799994, 72.57330963700008],
              [-107.90050208199995, 72.59442780200004],
              [-107.93541419199994, 72.60687897300005],
              [-108.01317298099991, 72.62051015800006],
              [-108.00389563699991, 72.63129303600005],
              [-107.98973548099991, 72.63507721600007],
              [-107.97350012899994, 72.63694896000004],
              [-107.95791581899994, 72.64223867400005],
              [-108.0125219389999, 72.66376373900005],
              [-108.0261938139999, 72.67987702000005],
              [-108.00572669199994, 72.70302969000005],
              [-108.01740475199995, 72.71246979400007],
              [-108.03921464799993, 72.72467682500007],
              [-108.0501195949999, 72.73407623900005],
              [-108.07469641799992, 72.74925364800004],
              [-108.08364824099993, 72.76007721600007],
              [-108.07030188699991, 72.76508209800005],
              [-108.05646725199995, 72.77606842700004],
              [-108.06773841099994, 72.80060455900008],
              [-108.10130774599992, 72.84023672100005],
              [-108.12946529899995, 72.86151764500005],
              [-108.13914954299992, 72.87124258000006],
              [-108.14248613199993, 72.88837311400005],
              [-108.12474524599992, 72.89590078300006],
              [-108.1055395169999, 72.90131256700005],
              [-108.10472571499992, 72.91217682500007],
              [-108.11896725199995, 72.92226797100005],
              [-108.1531469389999, 72.93671295800004],
              [-108.1634008449999, 72.94383372600004],
              [-108.16783606699994, 72.95815664300005],
              [-108.16283118399991, 72.97060781500005],
              [-108.15123450399994, 72.97992584800005],
              [-108.13609778599994, 72.98480866100005],
              [-108.16820227799991, 73.00678131700005],
              [-108.22565670499995, 73.03563060100004],
              [-108.2346899079999, 73.04291413000004],
              [-108.22484290299991, 73.04629140800006],
              [-108.18927975199995, 73.04523346600007],
              [-108.17178300699993, 73.04686107000003],
              [-108.1565649079999, 73.05247630400004],
              [-108.26545162699995, 73.10187409100007],
              [-108.29832923099991, 73.13377513200004],
              [-108.25894120999993, 73.17597077000005],
              [-108.16494706899994, 73.20612213700008],
              [-108.06753495999993, 73.20770905200004],
              [-107.86790930899991, 73.18964264500005],
              [-107.90453040299991, 73.21255117400005],
              [-108.0535375639999, 73.23802317900004],
              [-108.07030188699991, 73.24359772300005],
              [-108.10533606699994, 73.25926341400003],
              [-108.1187231109999, 73.26878489800004],
              [-108.12132727799991, 73.27440013200004],
              [-108.12083899599992, 73.28815338700008],
              [-108.12242591099994, 73.29266998900005],
              [-108.12987219999991, 73.29657623900005],
              [-108.14834550699993, 73.30174388200004],
              [-108.1565649079999, 73.30634186400005],
              [-108.12376868399991, 73.31598541900007],
              [-108.01317298099991, 73.31317780200004],
              [-108.02993730399993, 73.32623932500007],
              [-108.06924394399994, 73.34170156500005],
              [-108.08763587099992, 73.35415273600006],
              [-108.01333574099993, 73.35488515800006],
              [-107.79344641799992, 73.32623932500007],
              [-107.66201738199993, 73.32843659100007],
              [-107.5188695949999, 73.29572174700007],
              [-107.45396887899994, 73.28864166900007],
              [-107.33653723899994, 73.24945709800005],
              [-107.29259192599994, 73.24111562700006],
              [-107.26854407499991, 73.22699616100005],
              [-107.22817949099993, 73.21845123900005],
              [-107.17243404899995, 73.19501373900005],
              [-107.07323157499991, 73.17804596600007],
              [-107.03970292899993, 73.17869700700004],
              [-107.01138261599993, 73.19708893400008],
              [-107.03514563699991, 73.21108633000006],
              [-107.12873287699995, 73.24428945500006],
              [-107.09496008999992, 73.25946686400005],
              [-107.08340410099993, 73.27106354400007],
              [-107.08771725199995, 73.28583405200004],
              [-107.06395423099991, 73.28856028900003],
              [-107.02672278599994, 73.30170319200005],
              [-107.0051977199999, 73.30634186400005],
              [-106.9944555329999, 73.30573151200008],
              [-106.9571020169999, 73.29889557500007],
              [-106.94717363199993, 73.30072663000004],
              [-106.91576087099992, 73.31317780200004],
              [-106.87344316299993, 73.31557851800005],
              [-106.82339433499993, 73.30963776200008],
              [-106.77672278599994, 73.29694245000007],
              [-106.74449622299994, 73.27903880400004],
              [-106.70295162699995, 73.24380117400005],
              [-106.67593339799993, 73.22955963700008],
              [-106.56297766799992, 73.21312083500004],
              [-106.54246985599991, 73.22040436400005],
              [-106.53872636599993, 73.22748444200005],
              [-106.53921464799993, 73.23309967700004],
              [-106.53783118399991, 73.23672109600005],
              [-106.52847245999993, 73.23802317900004],
              [-106.51724199099993, 73.23712799700007],
              [-106.5047094389999, 73.23436107000003],
              [-106.49303137899994, 73.22992584800005],
              [-106.4844457669999, 73.22382233300004],
              [-106.47769120999993, 73.21328359600005],
              [-106.47545325399994, 73.19717031500005],
              [-106.4707738919999, 73.18964264500005],
              [-106.45840410099993, 73.18463776200008],
              [-106.42296301999994, 73.17523834800005],
              [-106.4055883449999, 73.15428294500003],
              [-106.38267981699994, 73.14765045800004],
              [-106.33983313699991, 73.14183177300004],
              [-106.28355872299994, 73.11815013200004],
              [-106.26842200399994, 73.11456940300008],
              [-106.2613012359999, 73.11029694200005],
              [-106.24592037699995, 73.09149811400005],
              [-106.23399817599994, 73.08722565300008],
              [-106.17951412699995, 73.08283112200007],
              [-106.04893958199995, 73.05341217700004],
              [-106.00841223899994, 73.04901764500005],
              [-105.96300208199995, 73.05247630400004],
              [-105.95099850199995, 73.05658600500004],
              [-105.93960527299993, 73.06199778900003],
              [-105.9280492829999, 73.06525299700007],
              [-105.90029863199993, 73.05914948100008],
              [-105.85008704299992, 73.05996328300006],
              [-105.82933508999992, 73.05133698100008],
              [-105.82848059799994, 73.03229401200008],
              [-105.83071855399993, 73.01333242400005],
              [-105.81932532499991, 73.00470612200007],
              [-105.79869544199994, 72.99933502800008],
              [-105.75405839799993, 72.97589752800008],
              [-105.60680091099994, 72.95010000200006],
              [-105.6409399079999, 72.93642812700006],
              [-105.62173417899993, 72.92633698100008],
              [-105.58169511599993, 72.91502513200004],
              [-105.56578528599994, 72.90843333500004],
              [-105.55687415299991, 72.90102773600006],
              [-105.54922441299993, 72.89276764500005],
              [-105.53966223899994, 72.88548411700003],
              [-105.52481035099993, 72.88117096600007],
              [-105.53209387899994, 72.87466054900005],
              [-105.5403539699999, 72.87010325700004],
              [-105.54930579299992, 72.86766185100004],
              [-105.55894934799994, 72.86749909100007],
              [-105.55894934799994, 72.86066315300008],
              [-105.52794348899994, 72.86090729400007],
              [-105.49498450399994, 72.85565827000005],
              [-105.46324622299994, 72.84625885600008],
              [-105.43610592399995, 72.83397044500003],
              [-105.3889867829999, 72.79791901200008],
              [-105.36717688699991, 72.79242584800005],
              [-105.37340247299994, 72.78538646000004],
              [-105.38133704299992, 72.77985260600008],
              [-105.40127519399994, 72.77130768400008],
              [-105.35448157499991, 72.75991445500006],
              [-105.33250891799992, 72.75112539300005],
              [-105.31875566299993, 72.73777903900003],
              [-105.34935462099992, 72.72980377800008],
              [-105.36607825399994, 72.72842031500005],
              [-105.38145911399994, 72.73037344000005],
              [-105.3902074859999, 72.73505280200004],
              [-105.40933183499993, 72.74909088700008],
              [-105.4375707669999, 72.76015859600005],
              [-105.4583227199999, 72.77586497600004],
              [-105.48224850199995, 72.78632233300004],
              [-105.5105688139999, 72.77875397300005],
              [-105.42861894399994, 72.73037344000005],
              [-105.43785559799994, 72.72492096600007],
              [-105.44579016799992, 72.71873607000003],
              [-105.45221920499995, 72.71161530200004],
              [-105.45653235599991, 72.70302969000005],
              [-105.3555395169999, 72.67308177300004],
              [-105.31248938699991, 72.66705963700008],
              [-105.30016028599994, 72.66193268400008],
              [-105.28966223899994, 72.65444570500006],
              [-105.28526770699995, 72.64524974200003],
              [-105.29356848899994, 72.63800690300008],
              [-105.34666907499991, 72.62051015800006],
              [-105.32884680899991, 72.60980866100005],
              [-105.3157445949999, 72.59707265800006],
              [-105.31110592399995, 72.58063385600008],
              [-105.31875566299993, 72.55902741100005],
              [-105.2495824859999, 72.55263906500005],
              [-105.23062089799993, 72.54535553600005],
              [-105.23399817599994, 72.54262929900005],
              [-105.24364173099991, 72.53237539300005],
              [-105.23696855399993, 72.52887604400007],
              [-105.22842363199993, 72.52130768400008],
              [-105.22321529899995, 72.51805247600004],
              [-105.2483617829999, 72.50067780200004],
              [-105.23961341099994, 72.49192942900004],
              [-105.19587154899995, 72.48395416900007],
              [-105.20400956899994, 72.46092357000003],
              [-105.21056067599994, 72.45331452000005],
              [-105.22350012899994, 72.45038483300004],
              [-105.24449622299994, 72.45380280200004],
              [-105.2637426419999, 72.46010976800005],
              [-105.28331458199995, 72.46303945500006],
              [-105.30508378799993, 72.45661041900007],
              [-105.2769262359999, 72.44000885600008],
              [-105.23582923099991, 72.40009186400005],
              [-105.20954342399995, 72.38153717700004],
              [-105.15538489499994, 72.35667552300004],
              [-105.13780676999994, 72.34365469000005],
              [-105.13320878799993, 72.33661530200004],
              [-105.12975012899994, 72.31981028900003],
              [-105.1270238919999, 72.31264883000006],
              [-105.12169348899994, 72.30573151200008],
              [-105.08967037699995, 72.27826569200005],
              [-105.0593969389999, 72.26178620000007],
              [-105.04503333199995, 72.25116608300004],
              [-105.0266820949999, 72.22679271000004],
              [-105.01378333199995, 72.21478913000004],
              [-104.9798070949999, 72.20502350500004],
              [-104.96629798099991, 72.19354889500005],
              [-104.95958411399994, 72.17837148600006],
              [-104.96251380099994, 72.16242096600007],
              [-104.97988847599993, 72.14813873900005],
              [-105.02501380099994, 72.13328685100004],
              [-105.03888912699995, 72.11395905200004],
              [-105.02342688699991, 72.10740794500003],
              [-105.01256262899994, 72.09666575700004],
              [-105.0113012359999, 72.08437734600005],
              [-105.02456620999993, 72.07298411700003],
              [-105.00621497299994, 72.06915924700007],
              [-104.96593176999994, 72.06537506700005],
              [-104.94884192599994, 72.05878327000005],
              [-104.93993079299992, 72.04962799700007],
              [-104.92861894399994, 72.02871328300006],
              [-104.92560787699995, 72.02460358300004],
              [-104.90587317599994, 72.01764557500007],
              [-104.88565019399994, 72.00088125200006],
              [-104.84032141799992, 71.94643789300005],
              [-104.83189856699994, 71.93170807500007],
              [-104.82725989499994, 71.91469961100006],
              [-104.82591712099992, 71.89118073100008],
              [-104.81460527299993, 71.86188385600008],
              [-104.7871801419999, 71.84479401200008],
              [-104.75332597599993, 71.83633047100005],
              [-104.68553626199991, 71.82953522300005],
              [-104.6695043609999, 71.82404205900008],
              [-104.65404212099992, 71.81232330900008],
              [-104.64964758999992, 71.80390045800004],
              [-104.64598548099991, 71.79246653900003],
              [-104.64049231699994, 71.78245677300004],
              [-104.63072669199994, 71.77822500200006],
              [-104.6074926419999, 71.77277252800008],
              [-104.58307857999995, 71.75975169500003],
              [-104.54478919199994, 71.72980377800008],
              [-104.53831946499992, 71.72142161700003],
              [-104.53066972599993, 71.70416901200008],
              [-104.52489173099991, 71.69627513200004],
              [-104.51060950399994, 71.68634674700007],
              [-104.48037675699993, 71.67450592700004],
              [-104.38027910099993, 71.60004303600005],
              [-104.36534583199995, 71.57721588700008],
              [-104.37075761599993, 71.55768463700008],
              [-104.40758216099994, 71.51068756700005],
              [-104.3914281889999, 71.49274323100008],
              [-104.37157141799992, 71.48163483300004],
              [-104.31883704299992, 71.46971263200004],
              [-104.34019934799994, 71.43797435100004],
              [-104.34508216099994, 71.42186107000003],
              [-104.3362524079999, 71.40452708500004],
              [-104.30016028599994, 71.38007233300004],
              [-104.28237870999993, 71.36395905200004],
              [-104.2813207669999, 71.35024648600006],
              [-104.30459550699993, 71.34577057500007],
              [-104.40758216099994, 71.36733633000006],
              [-104.43382727799991, 71.36640045800004],
              [-104.46312415299991, 71.36050039300005],
              [-104.48696855399993, 71.34760163000004],
              [-104.49697831899994, 71.32575104400007],
              [-104.48302161399994, 71.29873281500005],
              [-104.45641028599994, 71.27537669500003],
              [-104.44054114499994, 71.24909088700008],
              [-104.45909583199995, 71.21279531500005],
              [-104.47740637899994, 71.19765859600005],
              [-104.54478919199994, 71.16058991100005],
              [-104.60024980399993, 71.14801666900007],
              [-104.62743079299992, 71.13861725500004],
              [-104.64781653599994, 71.11969635600008],
              [-104.63536536399994, 71.11334870000007],
              [-104.62409420499995, 71.10398997600004],
              [-104.60313880099994, 71.08246491100005],
              [-104.59117591099994, 71.07318756700005],
              [-104.3040258449999, 70.97288646000004],
              [-104.23192298099991, 70.96503327000005],
              [-104.20250403599994, 70.95526764500005],
              [-104.14688066299993, 70.92788320500006],
              [-104.10521399599992, 70.89809804900005],
              [-104.02403723899994, 70.78449127800008],
              [-103.9981176419999, 70.76190827000005],
              [-103.97012285099993, 70.75104401200008],
              [-103.93822180899991, 70.74835846600007],
              [-103.87804114499994, 70.75071849200003],
              [-103.85997473899994, 70.74819570500006],
              [-103.84337317599994, 70.74310944200005],
              [-103.7776586579999, 70.71259186400005],
              [-103.75121008999992, 70.70648834800005],
              [-103.71544348899994, 70.69159577000005],
              [-103.69347083199995, 70.67763906500005],
              [-103.66136633999992, 70.66791413000004],
              [-103.6472875639999, 70.66095612200007],
              [-103.59902910099993, 70.62055084800005],
              [-103.5718481109999, 70.60553620000007],
              [-103.53770911399994, 70.59951406500005],
              [-103.30846106699994, 70.59796784100007],
              [-103.27204342399995, 70.59100983300004],
              [-103.24632727799991, 70.57534414300005],
              [-103.2278539699999, 70.56110260600008],
              [-103.18358313699991, 70.54266998900005],
              [-103.13931230399993, 70.51056549700007],
              [-102.9661352199999, 70.49359772300005],
              [-102.92784583199995, 70.49909088700008],
              [-102.92039954299992, 70.51764557500007],
              [-102.94595292899993, 70.53164297100005],
              [-103.03026282499991, 70.53725820500006],
              [-103.0613500639999, 70.54828522300005],
              [-103.08193925699993, 70.55927155200004],
              [-103.10562089799993, 70.56610748900005],
              [-103.12523352799991, 70.57607656500005],
              [-103.13337154899995, 70.59613678600005],
              [-103.13548743399991, 70.61237213700008],
              [-103.1414281889999, 70.63153717700004],
              [-103.15025794199994, 70.64915599200003],
              [-103.16124426999994, 70.66095612200007],
              [-103.13158118399991, 70.68231842700004],
              [-103.08690344999991, 70.67747630400004],
              [-102.98916581899994, 70.65110911700003],
              [-102.9610082669999, 70.63597239800004],
              [-102.94591223899994, 70.62055084800005],
              [-102.9246313139999, 70.61367422100005],
              [-102.8863012359999, 70.60635000200006],
              [-102.85973059799994, 70.59658437700006],
              [-102.84194902299993, 70.58063385600008],
              [-102.83885657499991, 70.55963776200008],
              [-102.85586503799993, 70.53465403900003],
              [-102.85106360599991, 70.51634349200003],
              [-102.72179114499994, 70.49335358300004],
              [-102.70079505099994, 70.48725006700005],
              [-102.6565649079999, 70.48362864800004],
              [-102.62022864499994, 70.46454498900005],
              [-102.55797278599994, 70.45612213700008],
              [-102.4890844389999, 70.43500397300005],
              [-102.40929114499994, 70.42552317900004],
              [-102.24941972599993, 70.37299225500004],
              [-102.1922094389999, 70.33344147300005],
              [-102.18537350199995, 70.33209870000007],
              [-102.17031816299993, 70.33197663000004],
              [-102.15355383999992, 70.33588288000004],
              [-102.13988196499992, 70.34271881700005],
              [-102.12621008999992, 70.34503815300008],
              [-102.10920162699995, 70.33539459800005],
              [-102.09422766799992, 70.32465241100005],
              [-102.08006751199991, 70.31972890800006],
              [-102.04405676999994, 70.31216054900005],
              [-101.95278886599993, 70.26972077000005],
              [-101.92015540299991, 70.26373932500007],
              [-101.85244706899994, 70.26170482000003],
              [-101.82335364499994, 70.27195872600004],
              [-101.81126868399991, 70.30125560100004],
              [-101.79027258999992, 70.30556875200006],
              [-101.69277910099993, 70.30874258000006],
              [-101.66356360599991, 70.30125560100004],
              [-101.65025794199994, 70.29222239800004],
              [-101.63084876199991, 70.28461334800005],
              [-101.61070716099994, 70.27936432500007],
              [-101.59496008999992, 70.27732982000003],
              [-101.5840551419999, 70.27228424700007],
              [-101.59605872299994, 70.26093170800004],
              [-101.62564042899993, 70.24384186400005],
              [-101.64391028599994, 70.22483958500004],
              [-101.64745032499991, 70.20441315300008],
              [-101.63927161399994, 70.18390534100007],
              [-101.62222245999993, 70.16437409100007],
              [-101.58226477799991, 70.13251373900005],
              [-101.55528723899994, 70.11782461100006],
              [-101.52944902299993, 70.11286041900007],
              [-101.52065995999993, 70.11530182500007],
              [-101.50926673099991, 70.12368398600006],
              [-101.50218665299991, 70.12661367400005],
              [-101.49014238199993, 70.12815989800004],
              [-101.42048092399995, 70.12750885600008],
              [-101.40074622299994, 70.13434479400007],
              [-101.39232337099992, 70.15045807500007],
              [-101.37425696499992, 70.17690664300005],
              [-101.33275305899991, 70.17157623900005],
              [-101.25511633999992, 70.14020416900007],
              [-101.23940995999993, 70.13800690300008],
              [-101.2293188139999, 70.13934967700004],
              [-101.20791581899994, 70.14704010600008],
              [-101.15953528599994, 70.15387604400007],
              [-101.14317786399994, 70.16038646000004],
              [-101.12682044199994, 70.17157623900005],
              [-101.11839758999992, 70.18427155200004],
              [-101.12604732999995, 70.19546133000006],
              [-101.09923255099994, 70.20050690300008],
              [-101.06069902299993, 70.19611237200007],
              [-101.0222875639999, 70.18622467700004],
              [-100.99571692599994, 70.17495351800005],
              [-100.98009192599994, 70.16111888200004],
              [-100.97630774599992, 70.14740631700005],
              [-100.98033606699994, 70.13198476800005],
              [-100.9942113919999, 70.09808991100005],
              [-100.99571692599994, 70.08783600500004],
              [-100.99010169199994, 70.07827383000006],
              [-100.94847571499992, 70.04254791900007],
              [-100.92674719999991, 70.01675039300005],
              [-100.93228105399993, 70.01593659100007],
              [-100.94725501199991, 70.01048411700003],
              [-100.93415279899995, 69.99457428600005],
              [-100.9285375639999, 69.98468659100007],
              [-100.92674719999991, 69.97573476800005],
              [-100.93346106699994, 69.96238841400003],
              [-100.95604407499991, 69.94961172100005],
              [-100.96092688699991, 69.93846263200004],
              [-100.95885169199994, 69.92487213700008],
              [-100.95262610599991, 69.91766998900005],
              [-100.94176184799994, 69.91478099200003],
              [-100.92613684799994, 69.91425202000005],
              [-100.91014563699991, 69.91160716400003],
              [-100.9011938139999, 69.90485260600008],
              [-100.8946020169999, 69.89606354400007],
              [-100.88585364499994, 69.88694896000004],
              [-100.88963782499991, 69.87099844000005],
              [-100.87218176999994, 69.80780670800004],
            ],
          ],
          [
            [
              [-72.94896399599992, 66.73456452000005],
              [-72.97459876199991, 66.75999583500004],
              [-73.00548255099994, 66.77920156500005],
              [-73.00580807199992, 66.81769440300008],
              [-72.96540279899995, 66.86664459800005],
              [-72.91331946499992, 66.90875885600008],
              [-72.87852942599994, 66.92694733300004],
              [-72.88499915299991, 66.92743561400005],
              [-72.88630123599995, 66.92890045800004],
              [-72.88597571499992, 66.93309153900003],
              [-72.86192786399994, 66.95213450700004],
              [-72.82835852799991, 67.01813385600008],
              [-72.80345618399991, 67.04295482000003],
              [-72.73847408799992, 67.06830475500004],
              [-72.67149817599994, 67.08026764500005],
              [-72.47667395699995, 67.08763255400004],
              [-72.41181393099993, 67.09918854400007],
              [-72.3509008449999, 67.11945221600007],
              [-72.28888912699995, 67.16205475500004],
              [-72.28083248599995, 67.16917552300004],
              [-72.27521725199995, 67.18012116100005],
              [-72.27582760299993, 67.18854401200008],
              [-72.28270423099991, 67.20966217700004],
              [-72.28266354099992, 67.22113678600005],
              [-72.26903235599991, 67.24420807500007],
              [-72.24571692599994, 67.25958893400008],
              [-72.19334876199991, 67.27570221600007],
              [-72.31419837099992, 67.30589427300004],
              [-72.36982174399992, 67.33079661700003],
              [-72.35716712099992, 67.36505768400008],
              [-72.37018795499995, 67.37352122600004],
              [-72.39814205599993, 67.41290924700007],
              [-72.4278051419999, 67.44061920800004],
              [-72.43500729099992, 67.45530833500004],
              [-72.43354244699992, 67.47500234600005],
              [-72.50800533799992, 67.50226471600007],
              [-72.48896236899992, 67.51520416900007],
              [-72.43610592399995, 67.53148021000004],
              [-72.42609615799995, 67.54328034100007],
              [-72.43146725199995, 67.55353424700007],
              [-72.44249426999994, 67.55756256700005],
              [-72.45555579299992, 67.55947500200006],
              [-72.46703040299991, 67.56370677300004],
              [-72.47504635299993, 67.57208893400008],
              [-72.48741614499994, 67.59137604400007],
              [-72.49498450399994, 67.59788646000004],
              [-72.48204505099994, 67.61758047100005],
              [-72.49644934799994, 67.63043854400007],
              [-72.52387447799993, 67.63739655200004],
              [-72.59142005099994, 67.63947174700007],
              [-72.59801184799994, 67.64252350500004],
              [-72.59996497299994, 67.65013255400004],
              [-72.60517330599993, 67.65802643400008],
              [-72.6126195949999, 67.66425202000005],
              [-72.64350338399993, 67.67182038000004],
              [-72.66295325399994, 67.68480052300004],
              [-72.67280025899993, 67.70258209800005],
              [-72.66624915299991, 67.72199127800008],
              [-72.64789791599992, 67.73065827000005],
              [-72.59654700399994, 67.74518463700008],
              [-72.59117591099994, 67.75551992400005],
              [-72.59569251199991, 67.76683177300004],
              [-72.60102291599992, 67.77692291900007],
              [-72.60822506399995, 67.78628164300005],
              [-72.61888587099992, 67.79547760600008],
              [-72.63154049399992, 67.80312734600005],
              [-72.64606686099995, 67.80829498900005],
              [-72.66258704299992, 67.81012604400007],
              [-72.67638098899994, 67.81346263200004],
              [-72.69078528599994, 67.82135651200008],
              [-72.71406002499992, 67.83808014500005],
              [-72.73668372299994, 67.85004303600005],
              [-72.74103756399995, 67.85626862200007],
              [-72.73456783799992, 67.86542389500005],
              [-72.7637426419999, 67.88043854400007],
              [-72.78791256399995, 67.87250397300005],
              [-72.81110592399995, 67.85740794500003],
              [-72.83759518099993, 67.85114166900007],
              [-72.85741126199991, 67.86054108300004],
              [-72.88935299399992, 67.89594147300005],
              [-72.91331946499992, 67.90631745000007],
              [-72.90404212099992, 67.91608307500007],
              [-72.87852942599994, 67.93427155200004],
              [-72.89753170499995, 67.93585846600007],
              [-72.92463131399995, 67.93162669500003],
              [-72.94404049399992, 67.93227773600006],
              [-72.94001217399995, 67.94794342700004],
              [-72.91136633999992, 67.95823802300004],
              [-72.90587317599994, 67.96100495000007],
              [-72.9043676419999, 67.97040436400005],
              [-72.90733801999994, 67.97907135600008],
              [-72.9114477199999, 67.98720937700006],
              [-72.91331946499992, 67.99510325700004],
              [-72.91071529899995, 68.00413646000004],
              [-72.90107174399992, 68.01349518400008],
              [-72.89903723899994, 68.02301666900007],
              [-72.90229244699992, 68.02594635600008],
              [-72.90929114499994, 68.02924225500004],
              [-72.91633053299995, 68.03359609600005],
              [-72.91950436099995, 68.03974030200004],
              [-72.9180395169999, 68.04409414300005],
              [-72.91502844999991, 68.04816315300008],
              [-72.91279049399992, 68.05247630400004],
              [-72.91331946499992, 68.05719635600008],
              [-72.92365475199995, 68.07127513200004],
              [-72.9492895169999, 68.09747955900008],
              [-72.96043860599991, 68.11180247600004],
              [-72.97541256399995, 68.13983795800004],
              [-72.98839270699995, 68.17328522300005],
              [-72.99058997299994, 68.18976471600007],
              [-72.99140377499992, 68.22573476800005],
              [-72.99461829299992, 68.23590729400007],
              [-73.00544186099995, 68.24209219000005],
              [-73.01891028599994, 68.24359772300005],
              [-73.0325414699999, 68.24127838700008],
              [-73.04364986899992, 68.23590729400007],
              [-73.04503333199995, 68.22866445500006],
              [-73.03905188699991, 68.22040436400005],
              [-73.03742428299995, 68.21161530200004],
              [-73.05182857999995, 68.20294830900008],
              [-73.07262122299994, 68.20746491100005],
              [-73.09430904899995, 68.22284577000005],
              [-73.11729895699995, 68.23208242400005],
              [-73.14232337099992, 68.21796295800004],
              [-73.14952551999994, 68.21727122600004],
              [-73.16710364499994, 68.23688385600008],
              [-73.17711341099994, 68.24213288000004],
              [-73.19037838399993, 68.24017975500004],
              [-73.20262610599991, 68.23700592700004],
              [-73.21483313699991, 68.23631419500003],
              [-73.22801673099991, 68.24213288000004],
              [-73.21544348899994, 68.24258047100005],
              [-73.20470130099994, 68.24664948100008],
              [-73.19725501199991, 68.25446198100008],
              [-73.19452877499992, 68.26605866100005],
              [-73.20026607999995, 68.27529531500005],
              [-73.21397864499994, 68.27802155200004],
              [-73.22992916599992, 68.27822500200006],
              [-73.24229895699995, 68.28001536700003],
              [-73.25609290299991, 68.28485748900005],
              [-73.28864498599995, 68.29026927300004],
              [-73.30308997299994, 68.29059479400007],
              [-73.31456458199995, 68.28705475500004],
              [-73.32884680899991, 68.27977122600004],
              [-73.33808346299992, 68.27265045800004],
              [-73.33446204299992, 68.26947663000004],
              [-73.32335364499994, 68.26666901200008],
              [-73.32843990799995, 68.26019928600005],
              [-73.34068762899994, 68.25348541900007],
              [-73.35151119699992, 68.24957916900007],
              [-73.36384029899995, 68.24823639500005],
              [-73.37568111899992, 68.24921295800004],
              [-73.38658606699994, 68.25275299700007],
              [-73.41779537699995, 68.27216217700004],
              [-73.44237219999991, 68.27704498900005],
              [-73.49494381399995, 68.27692291900007],
              [-73.48029537699995, 68.28595612200007],
              [-73.46178137899994, 68.29214101800005],
              [-73.44208736899992, 68.29559967700004],
              [-73.42381751199991, 68.29677969000005],
              [-73.42011471299992, 68.29987213700008],
              [-73.41527258999992, 68.31391022300005],
              [-73.41295325399994, 68.31785716400003],
              [-73.40575110599991, 68.32025788000004],
              [-73.37885494699992, 68.32404205900008],
              [-73.34211178299995, 68.32054271000004],
              [-73.32905025899993, 68.32245514500005],
              [-73.30565344999991, 68.33047109600005],
              [-73.29967200399994, 68.33152903900003],
              [-73.29206295499995, 68.33588288000004],
              [-73.29340572799993, 68.34552643400008],
              [-73.30223548099991, 68.35492584800005],
              [-73.31737219999991, 68.35883209800005],
              [-73.2988988919999, 68.37494538000004],
              [-73.27147376199991, 68.38056061400005],
              [-73.21373450399994, 68.37929922100005],
              [-73.2559301419999, 68.39549388200004],
              [-73.27912350199995, 68.39972565300008],
              [-73.31737219999991, 68.39980703300006],
              [-73.30357825399994, 68.38857656500005],
              [-73.29625403599994, 68.38556549700007],
              [-73.3137914699999, 68.38178131700005],
              [-73.33421790299991, 68.38035716400003],
              [-73.35126705599993, 68.37563711100006],
              [-73.35834713399993, 68.36196523600006],
              [-73.35240637899994, 68.34393952000005],
              [-73.3555395169999, 68.33527252800008],
              [-73.37201900899993, 68.33152903900003],
              [-73.43317623599995, 68.33486562700006],
              [-73.46532141799992, 68.33319733300004],
              [-73.48188229099992, 68.32404205900008],
              [-73.47752844999991, 68.32294342700004],
              [-73.46821041599992, 68.31785716400003],
              [-73.53595943899995, 68.28790924700007],
              [-73.57127844999991, 68.27777741100005],
              [-73.61156165299991, 68.27692291900007],
              [-73.61156165299991, 68.26947663000004],
              [-73.60444088399993, 68.26650625200006],
              [-73.59947669199994, 68.26288483300004],
              [-73.59174557199992, 68.25580475500004],
              [-73.61908932199992, 68.24957916900007],
              [-73.62690182199992, 68.25226471600007],
              [-73.63243567599994, 68.25653717700004],
              [-73.63630123599995, 68.26056549700007],
              [-73.63890540299991, 68.26264069200005],
              [-73.68793697799993, 68.27692291900007],
              [-73.65245520699995, 68.29389069200005],
              [-73.63890540299991, 68.29677969000005],
              [-73.62328040299991, 68.29535553600005],
              [-73.60956783799992, 68.29205963700008],
              [-73.59687252499992, 68.29291413000004],
              [-73.58429928299995, 68.30418528900003],
              [-73.64122473899994, 68.31073639500005],
              [-73.70099850199995, 68.31037018400008],
              [-73.72801673099991, 68.31366608300004],
              [-73.83128821499992, 68.34393952000005],
              [-73.84443111899992, 68.34959544500003],
              [-73.86884518099993, 68.37588125200006],
              [-73.88654537699995, 68.38959381700005],
              [-73.90623938699991, 68.39923737200007],
              [-73.94737708199995, 68.41347890800006],
              [-73.93073482999995, 68.42475006700005],
              [-73.91038977799991, 68.43427155200004],
              [-73.89317786399994, 68.44623444200005],
              [-73.87873287699995, 68.48427969000005],
              [-73.86095130099994, 68.49819570500006],
              [-73.83869381399995, 68.50678131700005],
              [-73.81761633999992, 68.50967031500005],
              [-73.76227779899995, 68.51048411700003],
              [-73.73863684799994, 68.51923248900005],
              [-73.72887122299994, 68.54035065300008],
              [-73.74095618399991, 68.54677969000005],
              [-73.81700598899994, 68.57111237200007],
              [-73.75841223899994, 68.58161041900007],
              [-73.74506588399993, 68.58820221600007],
              [-73.72504635299993, 68.61383698100008],
              [-73.72150631399995, 68.61579010600008],
              [-73.7356664699999, 68.62636953300006],
              [-73.76789303299995, 68.62641022300005],
              [-73.82453365799995, 68.61953359600005],
              [-73.82453365799995, 68.62571849200003],
              [-73.73407955599993, 68.64647044500003],
              [-73.70775305899991, 68.66046784100007],
              [-73.77485104099992, 68.66738515800006],
              [-73.79657955599993, 68.66669342700004],
              [-73.78697669199994, 68.67519765800006],
              [-73.77574622299994, 68.68060944200005],
              [-73.75560462099992, 68.68720123900005],
              [-73.84015865799995, 68.69594961100006],
              [-73.88829505099994, 68.71401601800005],
              [-73.95152747299994, 68.70498281500005],
              [-73.98212643099993, 68.70766836100006],
              [-73.99095618399991, 68.71503327000005],
              [-73.99754798099991, 68.72467682500007],
              [-74.00670325399994, 68.73029205900008],
              [-74.03766842399995, 68.72125885600008],
              [-74.0879613919999, 68.72199127800008],
              [-74.09825598899994, 68.72406647300005],
              [-74.12352454299992, 68.73338450700004],
              [-74.13914954299992, 68.73558177300004],
              [-74.17027747299994, 68.72955963700008],
              [-74.1875707669999, 68.72939687700006],
              [-74.16633053299995, 68.70636627800008],
              [-74.15973873599995, 68.70140208500004],
              [-74.14728756399995, 68.69749583500004],
              [-74.09821529899995, 68.69399648600006],
              [-74.08385169199994, 68.68964264500005],
              [-74.04364986899992, 68.66669342700004],
              [-74.04511471299992, 68.66453685100004],
              [-74.0469457669999, 68.65985748900005],
              [-74.04548092399995, 68.65521881700005],
              [-74.03034420499995, 68.65180084800005],
              [-74.02513587099992, 68.64866771000004],
              [-74.01630611899992, 68.63873932500007],
              [-74.02098548099991, 68.63654205900008],
              [-74.02110755099994, 68.63564687700006],
              [-74.02306067599994, 68.63255442900004],
              [-73.99677486899992, 68.62693919500003],
              [-73.97838294199994, 68.61603424700007],
              [-73.94054114499994, 68.58478424700007],
              [-73.89521236899992, 68.57099030200004],
              [-73.88597571499992, 68.56427643400008],
              [-73.88520260299993, 68.55487702000005],
              [-73.89012610599991, 68.54865143400008],
              [-73.8965551419999, 68.54425690300008],
              [-73.9121801419999, 68.52240631700005],
              [-73.94029700399994, 68.50812409100007],
              [-73.98582923099991, 68.49542877800008],
              [-74.01813717399995, 68.49848053600005],
              [-74.02489173099991, 68.50702545800004],
              [-74.01646887899994, 68.52016836100006],
              [-74.00263424399992, 68.53701406500005],
              [-74.1497289699999, 68.53009674700007],
              [-74.19684811099995, 68.51740143400008],
              [-74.2200414699999, 68.51581452000005],
              [-74.22175045499995, 68.53009674700007],
              [-74.25434322799993, 68.53986237200007],
              [-74.37254798099991, 68.54376862200007],
              [-74.38556881399995, 68.54804108300004],
              [-74.39423580599993, 68.55744049700007],
              [-74.39989173099991, 68.56683991100005],
              [-74.40355383999992, 68.57111237200007],
              [-74.41315670499995, 68.57404205900008],
              [-74.43761145699995, 68.58755117400005],
              [-74.44823157499991, 68.59153880400004],
              [-74.50462805899991, 68.59951406500005],
              [-74.52318274599992, 68.61082591400003],
              [-74.53022213399993, 68.63568756700005],
              [-74.53156490799995, 68.65322500200006],
              [-74.53754635299993, 68.66518789300005],
              [-74.55089270699995, 68.67202383000006],
              [-74.57457434799994, 68.67413971600007],
              [-74.59589596299992, 68.67938873900005],
              [-74.66742916599992, 68.71507396000004],
              [-74.7102758449999, 68.72601959800005],
              [-74.7207738919999, 68.73554108300004],
              [-74.7219945949999, 68.75604889500005],
              [-74.72052975199995, 68.76923248900005],
              [-74.71776282499991, 68.77391185100004],
              [-74.61896725199995, 68.78400299700007],
              [-74.59520423099991, 68.79165273600006],
              [-74.57860266799992, 68.80133698100008],
              [-74.55072994699992, 68.82493724200003],
              [-74.57445227799991, 68.84186432500007],
              [-74.61371822799993, 68.85024648600006],
              [-74.65550696499992, 68.85097890800006],
              [-74.68724524599992, 68.84544505400004],
              [-74.68309485599991, 68.83510976800005],
              [-74.68101966099994, 68.83120351800005],
              [-74.69884192599994, 68.83169179900005],
              [-74.71739661399994, 68.82953522300005],
              [-74.73505611899992, 68.82485586100006],
              [-74.74994869699992, 68.81753164300005],
              [-74.71764075399994, 68.81696198100008],
              [-74.68659420499995, 68.82025788000004],
              [-74.65790768099993, 68.81883372600004],
              [-74.63263912699995, 68.80390045800004],
              [-74.65001380099994, 68.79140859600005],
              [-74.82502193899995, 68.77655670800004],
              [-74.83482825399994, 68.77973053600005],
              [-74.83503170499995, 68.78681061400005],
              [-74.83442135299993, 68.79385000200006],
              [-74.84150143099993, 68.79706452000005],
              [-74.89329993399991, 68.79706452000005],
              [-74.95933997299994, 68.81098053600005],
              [-74.98273678299995, 68.81126536700003],
              [-74.95323645699995, 68.82147858300004],
              [-74.87885494699992, 68.82550690300008],
              [-74.84491939999992, 68.83120351800005],
              [-74.85236568899995, 68.83860911700003],
              [-74.78937740799995, 68.85431549700007],
              [-74.7219945949999, 68.85846588700008],
              [-74.70063229099992, 68.86493561400005],
              [-74.68480383999992, 68.87982819200005],
              [-74.68248450399994, 68.89606354400007],
              [-74.70152747299994, 68.90692780200004],
              [-74.68903561099995, 68.91705963700008],
              [-74.6829320949999, 68.91958242400005],
              [-74.67357337099992, 68.92112864800004],
              [-74.7031957669999, 68.93756745000007],
              [-74.75511633999992, 68.94009023600006],
              [-74.89720618399991, 68.91498444200005],
              [-75.04413814999992, 68.90692780200004],
              [-75.02228756399995, 68.91518789300005],
              [-74.86998450399994, 68.93268463700008],
              [-74.84491939999992, 68.94037506700005],
              [-74.89427649599992, 68.94765859600005],
              [-75.00108801999994, 68.92796458500004],
              [-75.04413814999992, 68.93423086100006],
              [-74.85920162699995, 68.96832916900007],
              [-74.93427486899992, 68.96214427300004],
              [-74.97992916599992, 68.94965241100005],
              [-75.00336666599992, 68.94745514500005],
              [-75.02367102799991, 68.95473867400005],
              [-75.01134192599994, 68.96698639500005],
              [-74.94066321499992, 68.99774811400005],
              [-74.92613684799994, 69.00165436400005],
              [-74.72883053299995, 69.02362702000005],
              [-74.78673255099994, 69.00433991100005],
              [-74.80455481699994, 68.99567291900007],
              [-74.78473873599995, 68.99640534100007],
              [-74.74604244699992, 69.00678131700005],
              [-74.72541256399995, 69.00934479400007],
              [-74.6797582669999, 69.00771719000005],
              [-74.65746008999992, 69.01146067900004],
              [-74.64008541599992, 69.02362702000005],
              [-74.65351314999992, 69.04059479400007],
              [-74.6680395169999, 69.04759349200003],
              [-74.70836341099994, 69.05027903900003],
              [-74.72748775899993, 69.05434804900005],
              [-74.78343665299991, 69.07819245000007],
              [-74.80907141799992, 69.08331940300008],
              [-74.83018958199995, 69.08051178600005],
              [-74.85008704299992, 69.07510000200006],
              [-74.89146887899994, 69.06989166900007],
              [-74.93773352799991, 69.05744049700007],
              [-74.94794674399992, 69.05027903900003],
              [-74.96178137899994, 69.04913971600007],
              [-74.97057044199994, 69.04409414300005],
              [-74.98578854099992, 69.02667877800008],
              [-74.99860592399995, 69.02065664300005],
              [-75.03600012899994, 69.01496002800008],
              [-75.05158443899995, 69.00934479400007],
              [-75.03929602799991, 68.99583567900004],
              [-75.04271399599992, 68.98615143400008],
              [-75.05549068899995, 68.97943756700005],
              [-75.07148189999992, 68.97516510600008],
              [-75.0598852199999, 68.95522695500006],
              [-75.07367916599992, 68.93545156500005],
              [-75.10619055899991, 68.91034577000005],
              [-75.11603756399995, 68.89297109600005],
              [-75.13914954299992, 68.88873932500007],
              [-75.18781490799995, 68.89325592700004],
              [-75.20197506399995, 68.89679596600007],
              [-75.24274654899995, 68.92112864800004],
              [-75.29743404899995, 68.93423086100006],
              [-75.36359615799995, 68.97158437700006],
              [-75.37995357999995, 68.97516510600008],
              [-75.39570064999992, 68.98346588700008],
              [-75.42475338399993, 69.00751373900005],
              [-75.4407445949999, 69.01679108300004],
              [-75.46381588399993, 69.02236562700006],
              [-75.4863988919999, 69.02204010600008],
              [-75.50873775899993, 69.01723867400005],
              [-75.53075110599991, 69.00934479400007],
              [-75.57042395699995, 68.98651764500005],
              [-75.56366939999992, 68.97064850500004],
              [-75.49665279899995, 68.93423086100006],
              [-75.54841061099995, 68.90570709800005],
              [-75.60651607999995, 68.88580963700008],
              [-75.73253333199995, 68.86273834800005],
              [-75.80601966099994, 68.83649323100008],
              [-75.93464107999995, 68.82493724200003],
              [-75.95588131399995, 68.81879303600005],
              [-76.00121008999992, 68.78823476800005],
              [-76.02363033799992, 68.77655670800004],
              [-76.32555091099994, 68.69847239800004],
              [-76.53901119699992, 68.67475006700005],
              [-76.62498938699991, 68.68235911700003],
              [-76.68150794199994, 68.72939687700006],
              [-76.6731664699999, 68.76581452000005],
              [-76.57294674399992, 68.82094961100006],
              [-76.53754635299993, 68.85228099200003],
              [-76.53380286399994, 68.88141510600008],
              [-76.55658932199992, 68.88613515800006],
              [-76.59129798099991, 68.88499583500004],
              [-76.62348385299993, 68.89638906500005],
              [-76.64464270699995, 68.91693756700005],
              [-76.65221106699994, 68.93183014500005],
              [-76.64631100199995, 68.94700755400004],
              [-76.62690182199992, 68.96832916900007],
              [-76.63853919199994, 68.97980377800008],
              [-76.64268958199995, 68.99848053600005],
              [-76.63813229099992, 69.01593659100007],
              [-76.62348385299993, 69.02362702000005],
              [-76.60932369699992, 69.02529531500005],
              [-76.56541907499991, 69.03725820500006],
              [-76.42247473899994, 69.05988190300008],
              [-76.16071529899995, 69.04490794500003],
              [-76.13068600199995, 69.03758372600004],
              [-76.08649654899995, 69.01357656500005],
              [-76.05955969999991, 69.00873444200005],
              [-75.98985755099994, 69.01089101800005],
              [-75.9798070949999, 69.01463450700004],
              [-75.96275794199994, 69.02362702000005],
              [-75.89049231699994, 69.04730866100005],
              [-75.82567298099991, 69.05731842700004],
              [-75.81159420499995, 69.08307526200008],
              [-75.78160559799994, 69.08901601800005],
              [-75.71540279899995, 69.09186432500007],
              [-75.65082760299993, 69.08584219000005],
              [-75.62096106699994, 69.08795807500007],
              [-75.59557044199994, 69.10211823100008],
              [-75.59467525899993, 69.10907623900005],
              [-75.60387122299994, 69.12856679900005],
              [-75.60651607999995, 69.13621653900003],
              [-75.60106360599991, 69.14484284100007],
              [-75.57713782499991, 69.15127187700006],
              [-75.57172604099992, 69.15704987200007],
              [-75.59858150899993, 69.21922435100004],
              [-75.59557044199994, 69.22907135600008],
              [-75.60191809799994, 69.23574453300006],
              [-75.68744869699992, 69.28705475500004],
              [-75.75035559799994, 69.30463288000004],
              [-75.80626380099994, 69.32721588700008],
              [-75.87535559799994, 69.34296295800004],
              [-75.9075414699999, 69.34511953300006],
              [-75.91649329299992, 69.34813060100004],
              [-75.94404049399992, 69.36347077000005],
              [-75.95221920499995, 69.36961497600004],
              [-75.96214758999992, 69.37348053600005],
              [-76.05101477799991, 69.38373444200005],
              [-76.16820227799991, 69.41400788000004],
              [-76.21715247299994, 69.41738515800006],
              [-76.35973059799994, 69.40033600500004],
              [-76.39130611899992, 69.40534088700008],
              [-76.4043676419999, 69.41803620000007],
              [-76.4121801419999, 69.43545156500005],
              [-76.42829342399995, 69.45433177300004],
              [-76.45213782499991, 69.46889883000006],
              [-76.60289466099994, 69.52887604400007],
              [-76.62958736899992, 69.54596588700008],
              [-76.63434811099995, 69.57168203300006],
              [-76.61628170499995, 69.59198639500005],
              [-76.58604895699995, 69.60431549700007],
              [-76.55256100199995, 69.61395905200004],
              [-76.46955318899995, 69.65761953300006],
              [-76.4512426419999, 69.66030508000006],
              [-76.38548743399991, 69.64671458500004],
              [-76.3340551419999, 69.64264557500007],
              [-76.22838294199994, 69.61933014500005],
              [-76.20978756399995, 69.61945221600007],
              [-76.20978756399995, 69.62628815300008],
              [-76.22919674399992, 69.63760000200006],
              [-76.21979732999995, 69.64972565300008],
              [-76.18187415299991, 69.66787344000005],
              [-76.36127682199992, 69.67084381700005],
              [-76.38646399599992, 69.67633698100008],
              [-76.40156002499992, 69.68773021000004],
              [-76.39740963399993, 69.69623444200005],
              [-76.40314693899995, 69.70136139500005],
              [-76.41466223899994, 69.70229726800005],
              [-76.44770260299993, 69.69269440300008],
              [-76.58454342399995, 69.69464752800008],
              [-76.62205969999991, 69.68866608300004],
              [-76.64057369699992, 69.67405833500004],
              [-76.54344641799992, 69.67548248900005],
              [-76.53123938699991, 69.67377350500004],
              [-76.51703854099992, 69.66787344000005],
              [-76.53437252499992, 69.64765045800004],
              [-76.55243893099993, 69.63287995000007],
              [-76.57526607999995, 69.62348053600005],
              [-76.60639400899993, 69.61945221600007],
              [-76.61554928299995, 69.62140534100007],
              [-76.62519283799992, 69.62531159100007],
              [-76.6348363919999, 69.62714264500005],
              [-76.64399166599992, 69.62287018400008],
              [-76.64549719999991, 69.61810944200005],
              [-76.64281165299991, 69.61367422100005],
              [-76.64057369699992, 69.60883209800005],
              [-76.64399166599992, 69.60268789300005],
              [-76.68150794199994, 69.57168203300006],
              [-76.70299231699994, 69.56500885600008],
              [-76.83503170499995, 69.57591380400004],
              [-76.8821508449999, 69.59072500200006],
              [-76.88556881399995, 69.59739817900004],
              [-76.87328040299991, 69.61261627800008],
              [-76.86180579299992, 69.61871979400007],
              [-76.83165442599994, 69.62579987200007],
              [-76.81867428299995, 69.63312409100007],
              [-76.84483801999994, 69.62457916900007],
              [-76.90684973899994, 69.62152741100005],
              [-76.95282955599993, 69.60004303600005],
              [-76.98375403599994, 69.59723541900007],
              [-77.01545162699995, 69.59951406500005],
              [-77.0384008449999, 69.60578034100007],
              [-77.04527747299994, 69.61371491100005],
              [-77.04609127499992, 69.62274811400005],
              [-77.04902096299992, 69.63007233300004],
              [-77.06232662699995, 69.63312409100007],
              [-77.11384029899995, 69.62628815300008],
              [-77.13532467399995, 69.62832265800006],
              [-77.20287024599992, 69.64671458500004],
              [-77.18077551999994, 69.67446523600006],
              [-77.13666744699992, 69.68618398600006],
              [-77.04523678299995, 69.68773021000004],
              [-77.03526770699995, 69.69106679900005],
              [-77.01842200399994, 69.70551178600005],
              [-77.00739498599995, 69.70880768400008],
              [-76.99653072799993, 69.70661041900007],
              [-76.98359127499992, 69.69684479400007],
              [-76.97325598899994, 69.69452545800004],
              [-76.95396887899994, 69.69871653900003],
              [-76.92100989499994, 69.71482982000003],
              [-76.90123450399994, 69.71503327000005],
              [-76.90904700399994, 69.70502350500004],
              [-76.91889400899993, 69.69647858300004],
              [-76.94220943899995, 69.68154531500005],
              [-76.87348385299993, 69.68724192900004],
              [-76.83539791599992, 69.69464752800008],
              [-76.79478919199994, 69.72247955900008],
              [-76.79474850199995, 69.72557200700004],
              [-76.79295813699991, 69.73309967700004],
              [-76.78954016799992, 69.74213288000004],
              [-76.78453528599994, 69.74982330900008],
              [-76.81684322799993, 69.75861237200007],
              [-76.85199947799993, 69.75482819200005],
              [-76.88263912699995, 69.75531647300005],
              [-76.90123450399994, 69.77708567900004],
              [-76.88910885299993, 69.80170319200005],
              [-76.84642493399991, 69.80731842700004],
              [-76.79523678299995, 69.80817291900007],
              [-76.75727291599992, 69.81867096600007],
              [-76.77672278599994, 69.83608633000006],
              [-76.80524654899995, 69.83413320500006],
              [-76.83881588399993, 69.82453034100007],
              [-76.87328040299991, 69.81867096600007],
              [-77.07258053299995, 69.81867096600007],
              [-77.07258053299995, 69.82489655200004],
              [-77.03266354099992, 69.83771393400008],
              [-77.0130102199999, 69.84638092700004],
              [-76.99742591099994, 69.85968659100007],
              [-77.0501195949999, 69.85757070500006],
              [-77.07689368399991, 69.85285065300008],
              [-77.09984290299991, 69.84540436400005],
              [-77.13202877499992, 69.82562897300005],
              [-77.1504613919999, 69.81818268400008],
              [-77.19794674399992, 69.83270905200004],
              [-77.29291744699992, 69.83600495000007],
              [-77.31281490799995, 69.84198639500005],
              [-77.29255123599995, 69.86774323100008],
              [-77.11778723899994, 69.90778229400007],
              [-77.01366126199991, 69.91974518400008],
              [-76.97638912699995, 69.94220612200007],
              [-77.0664770169999, 69.93622467700004],
              [-77.21629798099991, 69.90582916900007],
              [-77.23700924399992, 69.89720286700003],
              [-77.25739498599995, 69.89301178600005],
              [-77.30451412699995, 69.89227936400005],
              [-77.32237708199995, 69.88324616100005],
              [-77.35423743399991, 69.87392812700006],
              [-77.49091549399992, 69.86273834800005],
              [-77.50995846299992, 69.84491608300004],
              [-77.63426673099991, 69.82489655200004],
              [-77.60472571499992, 69.81964752800008],
              [-77.58946692599994, 69.81952545800004],
              [-77.53648841099994, 69.83222077000005],
              [-77.51899166599992, 69.83209870000007],
              [-77.50458736899992, 69.82489655200004],
              [-77.51756751199991, 69.81867096600007],
              [-77.49958248599995, 69.81004466400003],
              [-77.4610082669999, 69.80190664300005],
              [-77.44245357999995, 69.79075755400004],
              [-77.46141516799992, 69.79071686400005],
              [-77.51756751199991, 69.79759349200003],
              [-77.51793372299994, 69.77301666900007],
              [-77.54576575399994, 69.75409577000005],
              [-77.58372962099992, 69.74323151200008],
              [-77.61436926999994, 69.74298737200007],
              [-77.63975989499994, 69.75787995000007],
              [-77.65265865799995, 69.77985260600008],
              [-77.66352291599992, 69.80390045800004],
              [-77.68268795499995, 69.82489655200004],
              [-77.66820227799991, 69.85480377800008],
              [-77.67096920499995, 69.89948151200008],
              [-77.68297278599994, 69.94301992400005],
              [-77.68891354099992, 69.96954987200007],
              [-77.69770260299993, 69.99445221600007],
              [-77.68932044199994, 70.01723867400005],
              [-77.67564856699994, 70.03900788000004],
              [-77.66840572799993, 70.06134674700007],
              [-77.66987057199992, 70.08991120000007],
              [-77.67450924399992, 70.11123281500005],
              [-77.69635982999995, 70.15387604400007],
              [-77.68256588399993, 70.18366120000007],
              [-77.70392818899995, 70.20123932500007],
              [-77.74103756399995, 70.21491120000007],
              [-77.77452551999994, 70.23297760600008],
              [-77.7910863919999, 70.24799225500004],
              [-77.79820716099994, 70.25112539300005],
              [-77.80634518099993, 70.24795156500005],
              [-77.82603919199994, 70.24384186400005],
              [-77.84776770699995, 70.24567291900007],
              [-77.87677975199995, 70.26019928600005],
              [-77.89155025899993, 70.26373932500007],
              [-77.93305416599992, 70.25722890800006],
              [-78.01728268099993, 70.22866445500006],
              [-78.05573482999995, 70.22211334800005],
              [-78.07001705599993, 70.22581614800004],
              [-78.12092037699995, 70.25006745000007],
              [-78.1582738919999, 70.25617096600007],
              [-78.1966039699999, 70.25690338700008],
              [-78.1966039699999, 70.25006745000007],
              [-78.18183346299992, 70.24579498900005],
              [-78.15143795499995, 70.23240794500003],
              [-78.13792883999992, 70.22955963700008],
              [-78.13402258999992, 70.22532786700003],
              [-78.13902747299994, 70.21588776200008],
              [-78.14704342399995, 70.20652903900003],
              [-78.15221106699994, 70.20229726800005],
              [-78.21564693899995, 70.20473867400005],
              [-78.2415258449999, 70.21263255400004],
              [-78.23078365799995, 70.22955963700008],
              [-78.29902096299992, 70.22211334800005],
              [-78.30805416599992, 70.21898021000004],
              [-78.32172604099992, 70.20538971600007],
              [-78.32978268099993, 70.20229726800005],
              [-78.35053463399993, 70.20526764500005],
              [-78.38910885299993, 70.21637604400007],
              [-78.4082738919999, 70.21588776200008],
              [-78.40461178299995, 70.21893952000005],
              [-78.3946020169999, 70.22955963700008],
              [-78.42747962099992, 70.25739166900007],
              [-78.46186275899993, 70.27899811400005],
              [-78.53925533799992, 70.31216054900005],
              [-78.5293676419999, 70.31533437700006],
              [-78.50898189999992, 70.31810130400004],
              [-78.49767005099994, 70.31834544500003],
              [-78.48973548099991, 70.32046133000006],
              [-78.47797604099992, 70.32990143400008],
              [-78.4700414699999, 70.33197663000004],
              [-78.42719479099992, 70.33038971600007],
              [-78.40575110599991, 70.33218008000006],
              [-78.38841712099992, 70.33881256700005],
              [-78.48619544199994, 70.35492584800005],
              [-78.53587805899991, 70.35659414300005],
              [-78.58018958199995, 70.34564850500004],
              [-78.58641516799992, 70.33881256700005],
              [-78.57868404899995, 70.33527252800008],
              [-78.55907141799992, 70.31834544500003],
              [-78.58165442599994, 70.31443919500003],
              [-78.66279049399992, 70.35309479400007],
              [-78.65644283799992, 70.36017487200007],
              [-78.64106197799993, 70.37311432500007],
              [-78.6348363919999, 70.37978750200006],
              [-78.68480383999992, 70.37824127800008],
              [-78.69965572799993, 70.38251373900005],
              [-78.74156653599994, 70.42767975500004],
              [-78.74823971299992, 70.44135163000004],
              [-78.74469967399995, 70.45612213700008],
              [-78.77509518099993, 70.45551178600005],
              [-78.8333227199999, 70.44708893400008],
              [-78.86078854099992, 70.45612213700008],
              [-78.87262936099995, 70.47467682500007],
              [-78.88097083199995, 70.48240794500003],
              [-78.89179439999992, 70.47972239800004],
              [-78.89696204299992, 70.47308991100005],
              [-78.9036352199999, 70.45697663000004],
              [-78.90912838399993, 70.44871653900003],
              [-78.89362545499995, 70.44318268400008],
              [-78.88520260299993, 70.43406810100004],
              [-78.87848873599995, 70.42377350500004],
              [-78.86754309799994, 70.41453685100004],
              [-78.89704342399995, 70.41689687700006],
              [-78.9192602199999, 70.42894114800004],
              [-78.93993079299992, 70.44428131700005],
              [-78.96442623599995, 70.45612213700008],
              [-78.98188229099992, 70.45929596600007],
              [-79.02586829299992, 70.45612213700008],
              [-79.03453528599994, 70.45880768400008],
              [-79.07367916599992, 70.47662995000007],
              [-79.04633541599992, 70.48965078300006],
              [-79.06110592399995, 70.48871491100005],
              [-79.07567298099991, 70.48993561400005],
              [-79.08930416599992, 70.49445221600007],
              [-79.10094153599994, 70.50332265800006],
              [-79.08454342399995, 70.50275299700007],
              [-79.06810462099992, 70.50503164300005],
              [-79.05268307199992, 70.50995514500005],
              [-79.03888912699995, 70.51764557500007],
              [-79.04718990799995, 70.52570221600007],
              [-79.05707760299993, 70.53066640800006],
              [-79.06806393099993, 70.53241608300004],
              [-79.07990475199995, 70.53123607000003],
              [-79.07990475199995, 70.53807200700004],
              [-78.92650305899991, 70.53851959800005],
              [-78.88190670499995, 70.55170319200005],
              [-78.90387936099995, 70.55760325700004],
              [-78.95600338399993, 70.55442942900004],
              [-78.97065182199992, 70.55853913000004],
              [-78.97520911399994, 70.55560944200005],
              [-78.98131262899994, 70.55463288000004],
              [-78.98888098899994, 70.55560944200005],
              [-78.99791419199994, 70.55853913000004],
              [-78.99791419199994, 70.56537506700005],
              [-78.95759029899995, 70.56940338700008],
              [-78.88178463399993, 70.60077545800004],
              [-78.84089107999995, 70.59951406500005],
              [-78.82738196499992, 70.59308502800008],
              [-78.81908118399991, 70.58515045800004],
              [-78.81147213399993, 70.57591380400004],
              [-78.79991614499994, 70.56537506700005],
              [-78.78172766799992, 70.55634186400005],
              [-78.76081295499995, 70.55243561400005],
              [-78.71735592399995, 70.55170319200005],
              [-78.76264400899993, 70.56452057500007],
              [-78.78364010299993, 70.57705312700006],
              [-78.80016028599994, 70.60944245000007],
              [-78.81834876199991, 70.62400950700004],
              [-78.8399145169999, 70.63568756700005],
              [-78.85765540299991, 70.64052969000005],
              [-78.86449133999992, 70.63825104400007],
              [-78.86908932199992, 70.63336823100008],
              [-78.87474524599992, 70.62848541900007],
              [-78.88495846299992, 70.62620677300004],
              [-78.93647213399993, 70.62620677300004],
              [-78.9590551419999, 70.63080475500004],
              [-78.97923743399991, 70.63816966400003],
              [-78.99531002499992, 70.64996979400007],
              [-79.00536048099991, 70.66779205900008],
              [-78.99791419199994, 70.67462799700007],
              [-79.01581783799992, 70.68211497600004],
              [-79.03270423099991, 70.68113841400003],
              [-79.12385006399995, 70.64663320500006],
              [-79.13886471299992, 70.63711172100005],
              [-79.14745032499991, 70.63296133000006],
              [-79.15546627499992, 70.63178131700005],
              [-79.1594945949999, 70.62905508000006],
              [-79.15619869699992, 70.62002187700006],
              [-79.12791907499991, 70.61318594000005],
              [-79.0227758449999, 70.63043854400007],
              [-79.01317298099991, 70.63100820500006],
              [-79.00536048099991, 70.62620677300004],
              [-79.0032445949999, 70.61859772300005],
              [-79.00873775899993, 70.61448802300004],
              [-79.01667232999995, 70.61204661700003],
              [-79.02216549399992, 70.60976797100005],
              [-79.03282630099994, 70.59491608300004],
              [-79.04010982999995, 70.58734772300005],
              [-79.05256100199995, 70.57904694200005],
              [-79.09882564999992, 70.55731842700004],
              [-79.11119544199994, 70.54828522300005],
              [-79.11558997299994, 70.54218170800004],
              [-79.12315833199995, 70.52814362200007],
              [-79.1282445949999, 70.52383047100005],
              [-79.14024817599994, 70.52138906500005],
              [-79.16429602799991, 70.52212148600006],
              [-79.17609615799995, 70.51764557500007],
              [-79.14252682199992, 70.51072825700004],
              [-79.1458227199999, 70.50665924700007],
              [-79.14740963399993, 70.50324127800008],
              [-79.14997311099995, 70.50014883000006],
              [-79.15619869699992, 70.49705638200004],
              [-79.14720618399991, 70.47455475500004],
              [-79.14610755099994, 70.46539948100008],
              [-79.14875240799995, 70.45612213700008],
              [-79.15990149599992, 70.44310130400004],
              [-79.17414303299995, 70.43671295800004],
              [-79.18854732999995, 70.43219635600008],
              [-79.20026607999995, 70.42479075700004],
              [-79.21336829299992, 70.42080312700006],
              [-79.23224850199995, 70.42450592700004],
              [-79.26545162699995, 70.43842194200005],
              [-79.2852270169999, 70.44326406500005],
              [-79.32697506399995, 70.44269440300008],
              [-79.34675045499995, 70.44871653900003],
              [-79.33442135299993, 70.45547109600005],
              [-79.32538814999992, 70.45307038000004],
              [-79.31684322799993, 70.44855377800008],
              [-79.30577551999994, 70.44871653900003],
              [-79.29308020699995, 70.45522695500006],
              [-79.29450436099995, 70.45990631700005],
              [-79.30158443899995, 70.46503327000005],
              [-79.30577551999994, 70.47321198100008],
              [-79.29625403599994, 70.49380117400005],
              [-79.27363033799992, 70.50580475500004],
              [-79.24669348899994, 70.51605866100005],
              [-79.22447669199994, 70.53123607000003],
              [-79.22874915299991, 70.53392161700003],
              [-79.23322506399995, 70.54047272300005],
              [-79.23810787699995, 70.54486725500004],
              [-79.23534094999991, 70.54877350500004],
              [-79.23066158799992, 70.55853913000004],
              [-79.25165768099993, 70.55780670800004],
              [-79.31322180899991, 70.54486725500004],
              [-79.30370032499991, 70.54140859600005],
              [-79.29511471299992, 70.53693268400008],
              [-79.28697669199994, 70.53107330900008],
              [-79.27904212099992, 70.52383047100005],
              [-79.29723059799994, 70.51414622600004],
              [-79.30540930899991, 70.49819570500006],
              [-79.31659908799992, 70.48322174700007],
              [-79.34361731699994, 70.47662995000007],
              [-79.35895748599995, 70.47980377800008],
              [-79.39093990799995, 70.49396393400008],
              [-79.40880286399994, 70.49705638200004],
              [-79.42430579299992, 70.49225495000007],
              [-79.41828365799995, 70.48126862200007],
              [-79.40253658799992, 70.46967194200005],
              [-79.38898678299995, 70.46295807500007],
              [-79.40644283799992, 70.43984609600005],
              [-79.41645260299993, 70.43793366100005],
              [-79.43744869699992, 70.44183991100005],
              [-79.47968502499992, 70.45709870000007],
              [-79.50385494699992, 70.46067942900004],
              [-79.53632564999992, 70.44464752800008],
              [-79.57506262899994, 70.43622467700004],
              [-79.58759518099993, 70.42820872600004],
              [-79.59125729099992, 70.41132233300004],
              [-79.58189856699994, 70.39838288000004],
              [-79.56513424399992, 70.39020416900007],
              [-79.46930904899995, 70.37103913000004],
              [-79.45661373599995, 70.36302317900004],
              [-79.45014400899993, 70.35272858300004],
              [-79.43586178299995, 70.35529205900008],
              [-79.42174231699994, 70.36269765800006],
              [-79.41563880099994, 70.36676666900007],
              [-79.37421627499992, 70.37311432500007],
              [-79.33141028599994, 70.36847565300008],
              [-79.28978430899991, 70.35590241100005],
              [-79.25861568899995, 70.33881256700005],
              [-79.22472083199995, 70.32099030200004],
              [-79.17756100199995, 70.31061432500007],
              [-79.12804114499994, 70.30923086100006],
              [-79.08726966099994, 70.31834544500003],
              [-79.08417721299992, 70.34105052300004],
              [-79.04633541599992, 70.34251536700003],
              [-78.97065182199992, 70.32514069200005],
              [-78.94574947799993, 70.31411367400005],
              [-78.92536373599995, 70.30206940300008],
              [-78.86799068899995, 70.25482819200005],
              [-78.7669164699999, 70.19139232000003],
              [-78.75568600199995, 70.18219635600008],
              [-78.75092525899993, 70.17121002800008],
              [-78.75218665299991, 70.14264557500007],
              [-78.75092525899993, 70.13397858300004],
              [-78.74653072799993, 70.12710195500006],
              [-78.73412024599992, 70.11810944200005],
              [-78.73102779899995, 70.11286041900007],
              [-78.7317602199999, 70.10712311400005],
              [-78.73786373599995, 70.09243398600006],
              [-78.73664303299995, 70.08218008000006],
              [-78.73664303299995, 70.07770416900007],
              [-78.73204505099994, 70.07379791900007],
              [-78.70917721299992, 70.06098053600005],
              [-78.69648189999992, 70.05585358300004],
              [-78.69005286399994, 70.05145905200004],
              [-78.68687903599994, 70.04779694200005],
              [-78.68614661399994, 70.04490794500003],
              [-78.68573971299992, 70.04169342700004],
              [-78.68321692599994, 70.03717682500007],
              [-78.67011471299992, 70.02220286700003],
              [-78.66510982999995, 70.01382070500006],
              [-78.66649329299992, 69.99949778900003],
              [-78.66222083199995, 69.97638580900008],
              [-78.66584225199995, 69.96613190300008],
              [-78.70002193899995, 69.93134186400005],
              [-78.71576900899993, 69.92194245000007],
              [-78.7376195949999, 69.91437409100007],
              [-78.76032467399995, 69.90932851800005],
              [-78.77879798099991, 69.90745677300004],
              [-78.78571529899995, 69.90375397300005],
              [-78.79511471299992, 69.88580963700008],
              [-78.79991614499994, 69.87954336100006],
              [-78.82664954299992, 69.87954336100006],
              [-78.84190833199995, 69.88141510600008],
              [-78.87120520699995, 69.89057038000004],
              [-78.88805091099994, 69.89378489800004],
              [-79.16024736249994, 69.88873932500005],
              [-79.43244381399995, 69.88369375200006],
              [-79.68085689999992, 69.84857819200005],
              [-79.7141820949999, 69.86273834800005],
              [-79.72789466099994, 69.87189362200007],
              [-79.75824947799993, 69.88035716400003],
              [-79.77253170499995, 69.88694896000004],
              [-79.78412838399993, 69.89809804900005],
              [-79.79820716099994, 69.92316315300008],
              [-79.8067113919999, 69.93475983300004],
              [-79.81891842399995, 69.94440338700008],
              [-79.83515377499992, 69.95343659100007],
              [-79.85252844999991, 69.96010976800005],
              [-79.8684789699999, 69.96271393400008],
              [-79.88121497299994, 69.96735260600008],
              [-79.89289303299995, 69.97654857000003],
              [-79.90607662699995, 69.98309967700004],
              [-79.92341061099995, 69.97943756700005],
              [-79.9812719389999, 69.95075104400007],
              [-80.01154537699995, 69.94562409100007],
              [-80.04002844999991, 69.95526764500005],
              [-80.04560299399992, 69.96698639500005],
              [-80.05370032499991, 69.96954987200007],
              [-80.04320227799991, 69.98143138200004],
              [-80.0332738919999, 69.99624258000006],
              [-80.06834876199991, 70.00413646000004],
              [-80.20478268099993, 70.01146067900004],
              [-80.24604244699992, 70.00775788000004],
              [-80.26598059799994, 70.00307851800005],
              [-80.28937740799995, 69.99115631700005],
              [-80.29637610599991, 69.98940664300005],
              [-80.3665258449999, 69.99404531500005],
              [-80.54950924399992, 70.04751211100006],
              [-80.82591712099992, 70.05560944200005],
              [-80.89647376199991, 70.07367584800005],
              [-80.9375707669999, 70.07135651200008],
              [-80.96796627499992, 70.06561920800004],
              [-81.00914466099994, 70.06264883000006],
              [-81.04548092399995, 70.07005442900004],
              [-81.06110592399995, 70.09552643400008],
              [-81.07152258999992, 70.09926992400005],
              [-81.13617916599992, 70.08559804900005],
              [-81.1582738919999, 70.08730703300006],
              [-81.20250403599994, 70.09658437700006],
              [-81.56537838399993, 70.10834381700005],
              [-81.60920162699995, 70.12034739800004],
              [-81.7000219389999, 70.13361237200007],
              [-81.73204505099994, 70.13397858300004],
              [-81.75670325399994, 70.12970612200007],
              [-81.76244055899991, 70.12287018400008],
              [-81.75385494699992, 70.11196523600006],
              [-81.73546301999994, 70.09552643400008],
              [-81.68748938699991, 70.07412344000005],
              [-81.57489986899992, 70.06867096600007],
              [-81.53343665299991, 70.05145905200004],
              [-81.45836341099994, 70.02411530200004],
              [-81.45189368399991, 70.01699453300006],
              [-81.4500219389999, 70.00995514500005],
              [-81.44526119699992, 70.00482819200005],
              [-81.43036861899992, 70.00307851800005],
              [-81.3997289699999, 70.01089101800005],
              [-81.33759518099993, 70.03709544500003],
              [-81.30719967399995, 70.03375885600008],
              [-81.19322669199994, 70.00079987200007],
              [-81.16352291599992, 69.98314036700003],
              [-81.15636145699995, 69.97313060100004],
              [-81.14696204299992, 69.94965241100005],
              [-81.13959713399993, 69.93846263200004],
              [-81.12458248599995, 69.92902252800008],
              [-81.08686275899993, 69.91950104400007],
              [-81.05394446499992, 69.90208567900004],
              [-80.98534094999991, 69.88694896000004],
              [-80.82787024599992, 69.80369700700004],
              [-80.77818762899994, 69.79315827000005],
              [-80.7703344389999, 69.78229401200008],
              [-80.7715551419999, 69.76870351800005],
              [-80.77989661399994, 69.75600820500006],
              [-80.79352779899995, 69.74713776200008],
              [-80.83202063699991, 69.73309967700004],
              [-80.92931067599994, 69.71482982000003],
              [-80.9512426419999, 69.71503327000005],
              [-80.96678626199991, 69.71918366100005],
              [-80.97105872299994, 69.72455475500004],
              [-80.96544348899994, 69.73053620000007],
              [-80.9512426419999, 69.73615143400008],
              [-81.08141028599994, 69.76679108300004],
              [-81.12254798099991, 69.79075755400004],
              [-81.15660559799994, 69.81964752800008],
              [-81.17589270699995, 69.82892487200007],
              [-81.22504635299993, 69.83413320500006],
              [-81.27708899599992, 69.84528229400007],
              [-81.30003821499992, 69.85285065300008],
              [-81.34162350199995, 69.87641022300005],
              [-81.35370846299992, 69.88056061400005],
              [-81.3777563139999, 69.88593170800004],
              [-81.44294186099995, 69.91380442900004],
              [-81.48839270699995, 69.92572663000004],
              [-81.55390377499992, 69.92792389500005],
              [-81.57905025899993, 69.93256256700005],
              [-81.59325110599991, 69.94367096600007],
              [-81.59129798099991, 69.95734284100007],
              [-81.56757564999992, 69.96954987200007],
              [-81.60004635299993, 69.97744375200006],
              [-81.72553463399993, 69.96954987200007],
              [-81.75255286399994, 69.97333405200004],
              [-81.9102270169999, 70.03717682500007],
              [-81.93610592399995, 70.04096100500004],
              [-81.94493567599994, 70.04401276200008],
              [-81.95103919199994, 70.04800039300005],
              [-81.95417232999995, 70.05182526200008],
              [-81.95612545499995, 70.05512116100005],
              [-81.95860755099994, 70.05760325700004],
              [-82.11823482999995, 70.11688873900005],
              [-82.16759192599994, 70.12152741100005],
              [-82.19139563699991, 70.12661367400005],
              [-82.23505611899992, 70.14598216400003],
              [-82.25348873599995, 70.14704010600008],
              [-82.28661048099991, 70.14227936400005],
              [-82.30406653599994, 70.14297109600005],
              [-82.33311926999994, 70.15940989800004],
              [-82.35472571499992, 70.16461823100008],
              [-82.44318600199995, 70.17340729400007],
              [-82.46898352799991, 70.17902252800008],
              [-82.48619544199994, 70.18488190300008],
              [-82.50645911399994, 70.18886953300006],
              [-82.55394446499992, 70.18561432500007],
              [-82.57184811099995, 70.19208405200004],
              [-82.60309811099995, 70.21059804900005],
              [-82.8445531889999, 70.25747304900005],
              [-82.92162024599992, 70.29108307500007],
              [-82.96283932199992, 70.30304596600007],
              [-83.00556393099993, 70.30996328300006],
              [-83.04792232999995, 70.31216054900005],
              [-82.86204993399991, 70.23688385600008],
              [-82.8438207669999, 70.23265208500004],
              [-82.83564205599993, 70.22955963700008],
              [-82.82966061099995, 70.22459544500003],
              [-82.82017981699994, 70.21214427300004],
              [-82.81517493399991, 70.20848216400003],
              [-82.79222571499992, 70.20526764500005],
              [-82.74262447799993, 70.20945872600004],
              [-82.71894283799992, 70.20848216400003],
              [-82.66108150899993, 70.19098541900007],
              [-82.24604244699992, 70.11286041900007],
              [-82.1282445949999, 70.07037995000007],
              [-82.05870520699995, 70.05902741100005],
              [-81.97227942599994, 70.01048411700003],
              [-81.96898352799991, 70.00584544500003],
              [-81.96947180899991, 70.00120677300004],
              [-81.96703040299991, 69.99762604400007],
              [-81.95518958199995, 69.99624258000006],
              [-81.9426977199999, 69.99603913000004],
              [-81.93675696499992, 69.99506256700005],
              [-81.89423580599993, 69.97549062700006],
              [-81.87616939999992, 69.97093333500004],
              [-81.77806555899991, 69.96255117400005],
              [-81.73863684799994, 69.95180898600006],
              [-81.71153723899994, 69.93475983300004],
              [-81.76679439999992, 69.90745677300004],
              [-81.76679439999992, 69.90062083500004],
              [-81.7578832669999, 69.89785390800006],
              [-81.73888098899994, 69.88694896000004],
              [-81.73888098899994, 69.87954336100006],
              [-81.75934811099995, 69.87592194200005],
              [-81.80748450399994, 69.89288971600007],
              [-81.82966061099995, 69.88792552300004],
              [-81.85558020699995, 69.88694896000004],
              [-81.85558020699995, 69.87954336100006],
              [-81.85753333199995, 69.86493561400005],
              [-81.96483313699991, 69.84540436400005],
              [-81.97419186099995, 69.86847565300008],
              [-81.99762936099995, 69.87661367400005],
              [-82.02525794199994, 69.87421295800004],
              [-82.04735266799992, 69.86587148600006],
              [-82.07542883999992, 69.84202708500004],
              [-82.08149166599992, 69.83856842700004],
              [-82.11436926999994, 69.83539459800005],
              [-82.13007564999992, 69.83112213700008],
              [-82.14354407499991, 69.82489655200004],
              [-82.12995357999995, 69.82306549700007],
              [-82.12584387899994, 69.81806061400005],
              [-82.13324947799993, 69.78953685100004],
              [-82.13837643099993, 69.78595612200007],
              [-82.25556393099993, 69.80695221600007],
              [-82.30125891799992, 69.80438873900005],
              [-82.30125891799992, 69.81122467700004],
              [-82.29047604099992, 69.81240469000005],
              [-82.27997799399992, 69.81513092700004],
              [-82.26988684799994, 69.81928131700005],
              [-82.26024329299992, 69.82489655200004],
              [-82.27643795499995, 69.83079661700003],
              [-82.29369055899991, 69.83226146000004],
              [-82.31126868399991, 69.83002350500004],
              [-82.32856197799993, 69.82489655200004],
              [-82.32856197799993, 69.83234284100007],
              [-82.29657955599993, 69.83746979400007],
              [-82.23237057199992, 69.82843659100007],
              [-82.20502682199992, 69.83234284100007],
              [-82.32563229099992, 69.85932038000004],
              [-82.39447994699992, 69.86444733300004],
              [-82.42475338399993, 69.84910716400003],
              [-82.4414770169999, 69.84406159100007],
              [-82.64447994699992, 69.89378489800004],
              [-82.66401119699992, 69.90961334800005],
              [-82.69896399599992, 69.92304108300004],
              [-82.73045813699991, 69.92698802300004],
              [-82.73945064999992, 69.91425202000005],
              [-82.77582760299993, 69.92023346600007],
              [-82.84589596299992, 69.94330475500004],
              [-82.9102270169999, 69.95359935100004],
              [-83.00011145699995, 69.98940664300005],
              [-83.00934811099995, 69.98981354400007],
              [-83.01952063699991, 69.98895905200004],
              [-83.02928626199991, 69.98916250200006],
              [-83.03734290299991, 69.99282461100006],
              [-83.04047604099992, 69.99787018400008],
              [-83.04246985599991, 70.00364817900004],
              [-83.04548092399995, 70.00844961100006],
              [-83.05162512899994, 70.01048411700003],
              [-83.13695227799991, 70.00307851800005],
              [-83.14549719999991, 70.00495026200008],
              [-83.15599524599992, 70.01398346600007],
              [-83.16523189999992, 70.01675039300005],
              [-83.17450924399992, 70.01642487200007],
              [-83.23521887899994, 70.00315989800004],
              [-83.24803626199991, 70.00397370000007],
              [-83.25336666599992, 70.01361725500004],
              [-83.26716061099995, 70.01654694200005],
              [-83.35020911399994, 69.98314036700003],
              [-83.48578854099992, 69.97386302300004],
              [-83.57371985599991, 69.95359935100004],
              [-83.67280025899993, 69.94635651200008],
              [-84.02765865799995, 69.97785065300008],
              [-84.05528723899994, 69.98940664300005],
              [-84.07689368399991, 69.98639557500007],
              [-84.36811275899993, 69.98749420800004],
              [-84.53510494699992, 70.01048411700003],
              [-84.69477291599992, 70.00657786700003],
              [-84.74115963399993, 70.02024974200003],
              [-84.8196508449999, 70.03034088700008],
              [-84.83381100199995, 70.03595612200007],
              [-84.84764563699991, 70.04938385600008],
              [-84.87092037699995, 70.07880280200004],
              [-84.81635494699992, 70.08909739800004],
              [-84.7903539699999, 70.09955475500004],
              [-84.78831946499992, 70.11286041900007],
              [-84.81171627499992, 70.11871979400007],
              [-84.84150143099993, 70.10944245000007],
              [-84.89134680899991, 70.08218008000006],
              [-84.9519750639999, 70.06655508000006],
              [-85.14557857999995, 70.08559804900005],
              [-85.15392005099994, 70.08746979400007],
              [-85.17023678299995, 70.09601471600007],
              [-85.17939205599993, 70.09857819200005],
              [-85.19139563699991, 70.09845612200007],
              [-85.22716223899994, 70.09243398600006],
              [-85.27293860599991, 70.09422435100004],
              [-85.34093176999994, 70.10883209800005],
              [-85.36933346299992, 70.10927969000005],
              [-85.44554602799991, 70.09662506700005],
              [-85.51854407499991, 70.10602448100008],
              [-85.80036373599995, 70.09983958500004],
              [-85.85663814999992, 70.08954498900005],
              [-85.87482662699995, 70.07196686400005],
              [-85.8535863919999, 70.04987213700008],
              [-85.82689368399991, 70.04987213700008],
              [-85.79503333199995, 70.05923086100006],
              [-85.6094457669999, 70.07843659100007],
              [-85.53888912699995, 70.06150950700004],
              [-85.48969479099992, 70.05760325700004],
              [-85.40501868399991, 70.03864166900007],
              [-85.34687252499992, 70.03229401200008],
              [-85.23460852799991, 69.99624258000006],
              [-85.25483150899993, 69.98891836100006],
              [-85.59089107999995, 70.01683177300004],
              [-85.7332250639999, 69.99485911700003],
              [-85.78290768099993, 69.99518463700008],
              [-86.02631588449992, 70.05432770350006],
              [-86.26972408799992, 70.11347077000005],
              [-86.52110755099994, 70.23065827000005],
              [-86.54987545499995, 70.23647695500006],
              [-86.55451412699995, 70.24750397300005],
              [-86.55370032499991, 70.27269114800004],
              [-86.5579320949999, 70.30027903900003],
              [-86.57721920499995, 70.31834544500003],
              [-86.5567113919999, 70.32786692900004],
              [-86.55378170499995, 70.34247467700004],
              [-86.56598873599995, 70.35529205900008],
              [-86.59080969999991, 70.35932038000004],
              [-86.59080969999991, 70.36676666900007],
              [-86.57636471299992, 70.37303294500003],
              [-86.51878821499992, 70.41795482000003],
              [-86.49522864499994, 70.42963288000004],
              [-86.3633520169999, 70.45262278900003],
              [-86.32689368399991, 70.46303945500006],
              [-86.29698645699995, 70.47744375200006],
              [-86.29259192599994, 70.49335358300004],
              [-86.31232662699995, 70.50739166900007],
              [-86.34125729099992, 70.51984284100007],
              [-86.37092037699995, 70.52659739800004],
              [-86.39281165299991, 70.52383047100005],
              [-86.35077877499992, 70.50128815300008],
              [-86.33759518099993, 70.48965078300006],
              [-86.37055416599992, 70.47622304900005],
              [-86.38788814999992, 70.47207265800006],
              [-86.40583248599995, 70.46979401200008],
              [-86.4051000639999, 70.46491120000007],
              [-86.41161048099991, 70.46255117400005],
              [-86.46971594999991, 70.44989655200004],
              [-86.50365149599992, 70.43732330900008],
              [-86.55699622299994, 70.42914459800005],
              [-86.5808813139999, 70.42820872600004],
              [-86.63178463399993, 70.39411041900007],
              [-86.63471432199992, 70.39093659100007],
              [-86.63707434799994, 70.38605377800008],
              [-86.64106197799993, 70.38178131700005],
              [-86.66376705599993, 70.38011302300004],
              [-86.67210852799991, 70.37177155200004],
              [-86.66454016799992, 70.35602448100008],
              [-86.65269934799994, 70.33856842700004],
              [-86.63923092399995, 70.32514069200005],
              [-86.8582250639999, 70.32514069200005],
              [-86.88349361899992, 70.33563873900005],
              [-86.89867102799991, 70.35932038000004],
              [-86.8601781889999, 70.36863841400003],
              [-86.77851314999992, 70.37588125200006],
              [-86.74164791599992, 70.38719310100004],
              [-86.79023189999992, 70.39484284100007],
              [-86.90184485599991, 70.38507721600007],
              [-86.9402563139999, 70.40770091400003],
              [-86.87193762899994, 70.40770091400003],
              [-86.89325924399992, 70.42255280200004],
              [-86.96788489499994, 70.42304108300004],
              [-86.99486243399991, 70.43500397300005],
              [-86.97577877499992, 70.44147370000007],
              [-86.93451900899993, 70.44944896000004],
              [-86.91978919199994, 70.45612213700008],
              [-86.91978919199994, 70.46295807500007],
              [-86.97459876199991, 70.47272370000007],
              [-87.03144283799992, 70.46849192900004],
              [-87.13886471299992, 70.44183991100005],
              [-87.13463294199994, 70.41657135600008],
              [-87.16942298099991, 70.40473053600005],
              [-87.24872799399992, 70.39411041900007],
              [-87.24054928299995, 70.38141510600008],
              [-87.22826087099992, 70.37962474200003],
              [-87.20030676999994, 70.38719310100004],
              [-87.04743404899995, 70.38446686400005],
              [-87.00975501199991, 70.37445709800005],
              [-86.97443600199995, 70.35309479400007],
              [-86.98289954299992, 70.34186432500007],
              [-86.98521887899994, 70.33071523600006],
              [-86.98058020699995, 70.32200755400004],
              [-86.96821041599992, 70.31834544500003],
              [-86.97447669199994, 70.31378815300008],
              [-86.98802649599992, 70.29783763200004],
              [-86.98383541599992, 70.29559967700004],
              [-86.97923743399991, 70.29230377800008],
              [-86.97443600199995, 70.29043203300006],
              [-87.00495357999995, 70.28327057500007],
              [-87.42503821499992, 70.31525299700007],
              [-87.48875891799992, 70.32884349200003],
              [-87.77973385299993, 70.33197663000004],
              [-87.78766842399995, 70.32884349200003],
              [-87.7949926419999, 70.32208893400008],
              [-87.7981664699999, 70.31525299700007],
              [-87.79369055899991, 70.31216054900005],
              [-87.64098059799994, 70.29889557500007],
              [-87.61188717399995, 70.29043203300006],
              [-87.61188717399995, 70.28424713700008],
              [-87.76862545499995, 70.24795156500005],
              [-87.85252844999991, 70.23798248900005],
              [-87.93394934799994, 70.25006745000007],
              [-87.93158932199992, 70.25283437700006],
              [-87.92906653599994, 70.25633372600004],
              [-87.92560787699995, 70.26019928600005],
              [-87.92035885299993, 70.26373932500007],
              [-87.94123287699995, 70.26679108300004],
              [-88.03022213399993, 70.29490794500003],
              [-88.15038001199991, 70.30011627800008],
              [-88.19599361899992, 70.31635163000004],
              [-88.24156653599994, 70.32391998900005],
              [-88.26292883999992, 70.33197663000004],
              [-88.2278539699999, 70.35049062700006],
              [-88.21857662699995, 70.35309479400007],
              [-88.19469153599994, 70.35309479400007],
              [-88.19440670499995, 70.35081614800004],
              [-88.19489498599995, 70.34113190300008],
              [-88.19469153599994, 70.33881256700005],
              [-88.16844641799992, 70.33551666900007],
              [-88.08454342399995, 70.33881256700005],
              [-88.06147213399993, 70.33454010600008],
              [-88.00226803299995, 70.30467357000003],
              [-87.97215735599991, 70.30076732000003],
              [-87.93980872299994, 70.30292389500005],
              [-87.87938391799992, 70.31834544500003],
              [-87.90400143099993, 70.32876211100006],
              [-87.95726477799991, 70.33478424700007],
              [-88.14130611899992, 70.39590078300006],
              [-88.33714758999992, 70.42544179900005],
              [-88.40501868399991, 70.45132070500006],
              [-88.41742916599992, 70.44940827000005],
              [-88.42890377499992, 70.44456614800004],
              [-88.44452877499992, 70.44183991100005],
              [-88.69408118399991, 70.46503327000005],
              [-88.76874752499992, 70.48403554900005],
              [-88.90721594999991, 70.54486725500004],
              [-88.93061275899993, 70.56183502800008],
              [-89.00230872299994, 70.63426341400003],
              [-89.00361080599993, 70.64276764500005],
              [-89.0039770169999, 70.65094635600008],
              [-89.01024329299992, 70.66095612200007],
              [-89.02192135299993, 70.66791413000004],
              [-89.06489010299993, 70.68146393400008],
              [-89.06871497299994, 70.68646881700005],
              [-89.07148189999992, 70.69354889500005],
              [-89.07599850199995, 70.69985586100006],
              [-89.08531653599994, 70.70258209800005],
              [-89.09166419199994, 70.70368073100008],
              [-89.13121497299994, 70.71881745000007],
              [-89.16954505099994, 70.72679271000004],
              [-89.29845130099994, 70.77741120000007],
              [-89.33177649599992, 70.79877350500004],
              [-89.36628170499995, 70.81879303600005],
              [-89.41547604099992, 70.87885163000004],
              [-89.44908606699994, 70.90802643400008],
              [-89.42768307199992, 70.92234935100004],
              [-89.40245520699995, 70.92523834800005],
              [-89.37633216099994, 70.92544179900005],
              [-89.32176673099991, 70.93988678600005],
              [-89.20885169199994, 70.94212474200003],
              [-89.20885169199994, 70.94961172100005],
              [-89.21568762899994, 70.94961172100005],
              [-89.21568762899994, 70.95579661700003],
              [-89.19615637899994, 70.96165599200003],
              [-89.18842525899993, 70.96259186400005],
              [-89.20470130099994, 70.97475820500006],
              [-89.22642981699994, 70.98273346600007],
              [-89.33075924399992, 71.00287506700005],
              [-89.46471106699994, 71.05565013200004],
              [-89.48945064999992, 71.05947500200006],
              [-89.50658118399991, 71.06435781500005],
              [-89.53803463399993, 71.08661530200004],
              [-89.55772864499994, 71.09296295800004],
              [-89.22760982999995, 71.07709381700005],
              [-89.20885169199994, 71.06565989800004],
              [-89.21324622299994, 71.06281159100007],
              [-89.21727454299992, 71.05678945500006],
              [-89.22191321499992, 71.05198802300004],
              [-89.17597408799992, 71.03754303600005],
              [-89.15318762899994, 71.03314850500004],
              [-89.12633216099994, 71.03156159100007],
              [-88.92088782499991, 71.05255768400008],
              [-88.90192623599995, 71.05023834800005],
              [-88.87018795499995, 71.04222239800004],
              [-88.83832760299993, 71.03774648600006],
              [-88.80711829299992, 71.03827545800004],
              [-88.74848385299993, 71.04922109600005],
              [-88.64240475199995, 71.05459219000005],
              [-88.6192113919999, 71.05198802300004],
              [-88.57221432199992, 71.03969961100006],
              [-88.45990963399993, 71.03522370000007],
              [-88.41051184799994, 71.02741120000007],
              [-88.37287350199995, 71.01105377800008],
              [-88.36615963399993, 71.00259023600006],
              [-88.35997473899994, 70.98159414300005],
              [-88.35541744699992, 70.97260163000004],
              [-88.34162350199995, 70.96246979400007],
              [-88.32494055899991, 70.95844147300005],
              [-87.89301510299993, 70.93528880400004],
              [-87.81391354099992, 70.95311107000003],
              [-87.78685462099992, 70.95579661700003],
              [-87.72565670499995, 70.95449453300006],
              [-87.70771236899992, 70.95917389500005],
              [-87.68809973899994, 70.96185944200005],
              [-87.62535559799994, 70.95742422100005],
              [-87.5867406889999, 70.94847239800004],
              [-87.52928626199991, 70.95579661700003],
              [-87.35859127499992, 70.94961172100005],
              [-87.37909908799992, 70.94961172100005],
              [-87.35883541599992, 70.94912344000005],
              [-87.34618079299992, 70.95868561400005],
              [-87.32787024599992, 70.98680247600004],
              [-87.30683346299992, 71.00226471600007],
              [-87.28241939999992, 71.00934479400007],
              [-87.22826087099992, 71.01105377800008],
              [-87.05903072799993, 70.99005768400008],
              [-87.02806555899991, 70.99005768400008],
              [-87.00230872299994, 70.99677155200004],
              [-87.04926510299993, 71.00995514500005],
              [-87.33027096299992, 71.03969961100006],
              [-87.3313695949999, 71.04413483300004],
              [-87.33128821499992, 71.04901764500005],
              [-87.33751380099994, 71.05198802300004],
              [-87.34723873599995, 71.05149974200003],
              [-87.36579342399995, 71.04629140800006],
              [-87.37287350199995, 71.04515208500004],
              [-87.39350338399993, 71.04889557500007],
              [-87.40501868399991, 71.05589427300004],
              [-87.41401119699992, 71.06439850500004],
              [-87.42686926999994, 71.07245514500005],
              [-87.50385494699992, 71.07904694200005],
              [-87.51622473899994, 71.08246491100005],
              [-87.54120846299992, 71.09503815300008],
              [-87.65253658799992, 71.11786530200004],
              [-87.68012447799993, 71.11969635600008],
              [-87.69176184799994, 71.12661367400005],
              [-87.74901282499991, 71.14077383000006],
              [-87.83885657499991, 71.18626536700003],
              [-87.85029049399992, 71.19403717700004],
              [-87.85212154899995, 71.20262278900003],
              [-87.82648678299995, 71.22166575700004],
              [-87.82526607999995, 71.23139069200005],
              [-87.83202063699991, 71.23948802300004],
              [-87.84459387899994, 71.24380117400005],
              [-87.82575436099995, 71.25507233300004],
              [-87.81794186099995, 71.25747304900005],
              [-87.86412512899994, 71.27484772300005],
              [-87.92064368399991, 71.27000560100004],
              [-88.02269446499992, 71.23700592700004],
              [-88.06696529899995, 71.21283600500004],
              [-88.08112545499995, 71.20966217700004],
              [-88.10541744699992, 71.21234772300005],
              [-88.18101966099994, 71.22947825700004],
              [-88.5110570949999, 71.24591705900008],
              [-88.61579342399995, 71.23700592700004],
              [-89.0150040356666, 71.26767270200004],
              [-89.41421464733327, 71.29833947700006],
              [-89.81342525899993, 71.32900625200006],
              [-89.85313880099994, 71.33934153900003],
              [-89.88141842399995, 71.35130442900004],
              [-89.89875240799995, 71.36253489800004],
              [-89.91120357999995, 71.37759023600006],
              [-89.92450924399992, 71.40082428600005],
              [-89.93199622299994, 71.40704987200007],
              [-89.95380611899992, 71.41107819200005],
              [-89.96300208199995, 71.41510651200008],
              [-89.96552486899992, 71.41844310100004],
              [-89.96703040299991, 71.42523834800005],
              [-89.98082434799994, 71.44529857000003],
              [-89.98863684799994, 71.45156484600005],
              [-90.0039770169999, 71.45604075700004],
              [-89.99669348899994, 71.46576569200005],
              [-89.9922582669999, 71.46824778900003],
              [-89.98224850199995, 71.46971263200004],
              [-89.98680579299992, 71.49494049700007],
              [-89.99339758999992, 71.50641510600008],
              [-90.01020260299993, 71.51752350500004],
              [-89.97386633999992, 71.51813385600008],
              [-89.9571020169999, 71.52313873900005],
              [-89.95929928299995, 71.53489817900004],
              [-89.98969479099992, 71.56590403900003],
              [-89.99091549399992, 71.57562897300005],
              [-90.03388424399992, 71.58600495000007],
              [-90.04491126199991, 71.59666575700004],
              [-90.03876705599993, 71.60423411700003],
              [-89.99681555899991, 71.61001211100006],
              [-89.98859615799995, 71.61725495000007],
              [-89.99315344999991, 71.62360260600008],
              [-90.00141354099992, 71.62938060100004],
              [-90.0039770169999, 71.63483307500007],
              [-89.9766332669999, 71.65794505400004],
              [-89.90326900899993, 71.68056875200006],
              [-89.87299557199992, 71.70311107000003],
              [-89.88048255099994, 71.70990631700005],
              [-89.83507239499994, 71.72231679900005],
              [-89.82030188699991, 71.73224518400008],
              [-89.83202063699991, 71.74347565300008],
              [-89.83202063699991, 71.75092194200005],
              [-89.82245846299992, 71.75104401200008],
              [-89.79792232999995, 71.75775788000004],
              [-89.79792232999995, 71.76459381700005],
              [-89.82896887899994, 71.76740143400008],
              [-89.85907955599993, 71.77505117400005],
              [-89.91401119699992, 71.79873281500005],
              [-89.90538489499994, 71.80133698100008],
              [-89.88048255099994, 71.81232330900008],
              [-89.8972875639999, 71.81883372600004],
              [-89.9363500639999, 71.81704336100006],
              [-89.95213782499991, 71.82290273600006],
              [-89.95771236899992, 71.83209870000007],
              [-89.95685787699995, 71.84039948100008],
              [-89.9544164699999, 71.84760163000004],
              [-89.95555579299992, 71.85325755400004],
              [-89.96812903599994, 71.85911692900004],
              [-90.00300045499995, 71.86835358300004],
              [-90.01020260299993, 71.87783437700006],
              [-90.01435299399992, 71.89052969000005],
              [-90.02485104099992, 71.89419179900005],
              [-90.0384008449999, 71.89468008000006],
              [-90.10468502499992, 71.91632721600007],
              [-90.11860104099992, 71.92885976800005],
              [-90.09923255099994, 71.94611237200007],
              [-90.08946692599994, 71.94916413000004],
              [-90.07909094999991, 71.95010000200006],
              [-90.05797278599994, 71.94953034100007],
              [-90.0520727199999, 71.95087311400005],
              [-90.05072994699992, 71.95425039300005],
              [-90.04967200399994, 71.95868561400005],
              [-90.04491126199991, 71.96320221600007],
              [-90.01085364499994, 71.98533763200004],
              [-89.99653072799993, 71.99046458500004],
              [-90.00531979099992, 72.00600820500006],
              [-90.01020260299993, 72.01093170800004],
              [-89.99653072799993, 72.01776764500005],
              [-90.0039770169999, 72.02460358300004],
              [-89.96922766799992, 72.03888580900008],
              [-89.99872799399992, 72.06488678600005],
              [-89.99254309799994, 72.07160065300008],
              [-89.76170813699991, 72.12555573100008],
              [-89.73615475199995, 72.12763092700004],
              [-89.7156469389999, 72.12287018400008],
              [-89.69428463399993, 72.11481354400007],
              [-89.67328854099992, 72.11326732000003],
              [-89.65392005099994, 72.12763092700004],
              [-89.65644283799992, 72.13922760600008],
              [-89.59825598899994, 72.15110911700003],
              [-89.5781957669999, 72.16242096600007],
              [-89.58576412699995, 72.17914459800005],
              [-89.61762447799993, 72.18471914300005],
              [-89.68122311099995, 72.18284739800004],
              [-89.67503821499992, 72.18284739800004],
              [-89.77061926999994, 72.16242096600007],
              [-89.79242916599992, 72.16429271000004],
              [-89.83250891799992, 72.17926666900007],
              [-89.90094967399995, 72.18976471600007],
              [-89.90229244699992, 72.19505442900004],
              [-89.89985104099992, 72.21133047100005],
              [-89.90094967399995, 72.21702708500004],
              [-89.91437740799995, 72.23037344000005],
              [-89.92857825399994, 72.24070872600004],
              [-89.96300208199995, 72.25739166900007],
              [-89.93805904899995, 72.26422760600008],
              [-89.93285071499992, 72.27049388200004],
              [-89.95331783799992, 72.30646393400008],
              [-89.95555579299992, 72.31232330900008],
              [-89.95067298099991, 72.33372630400004],
              [-89.93822180899991, 72.34686920800004],
              [-89.9043676419999, 72.37067291900007],
              [-89.89012610599991, 72.37811920800004],
              [-89.85273189999992, 72.38666413000004],
              [-89.83885657499991, 72.39516836100006],
              [-89.83307857999995, 72.40298086100006],
              [-89.83454342399995, 72.40509674700007],
              [-89.84174557199992, 72.40550364800004],
              [-89.89952551999994, 72.41730377800008],
              [-89.91295325399994, 72.42597077000005],
              [-89.90094967399995, 72.44293854400007],
              [-89.89911861899992, 72.43850332200003],
              [-89.88711503799993, 72.42918528900003],
              [-89.87885494699992, 72.42658112200007],
              [-89.84886633999992, 72.42393626500007],
              [-89.78750566299993, 72.42426178600005],
              [-89.78425045499995, 72.42869700700004],
              [-89.87079830599993, 72.43036530200004],
              [-89.8823542959999, 72.43260325700004],
              [-89.8887426419999, 72.44009023600006],
              [-89.88768469999991, 72.44908274900007],
              [-89.8743383449999, 72.45368073100008],
              [-89.81440182199992, 72.45921458500004],
              [-89.80060787699995, 72.46588776200008],
              [-89.79063880099994, 72.47467682500007],
              [-89.78425045499995, 72.48395416900007],
              [-89.77656002499992, 72.50747304900005],
              [-89.77367102799991, 72.52114492400005],
              [-89.77399654899995, 72.52863190300008],
              [-89.78172766799992, 72.53929271000004],
              [-89.78612219999991, 72.55052317900004],
              [-89.78705807199992, 72.56199778900003],
              [-89.78425045499995, 72.57330963700008],
              [-89.7532445949999, 72.61082591400003],
              [-89.73505611899992, 72.62124258000006],
              [-89.70954342399995, 72.62897370000007],
              [-89.68285071499992, 72.63369375200006],
              [-89.66136633999992, 72.63471100500004],
              [-89.61375891799992, 72.62103913000004],
              [-89.58747311099995, 72.61664459800005],
              [-89.56822669199994, 72.62421295800004],
              [-89.54853268099993, 72.64008209800005],
              [-89.54841061099995, 72.64887116100005],
              [-89.56513424399992, 72.66205475500004],
              [-89.54487057199992, 72.66901276200008],
              [-89.49311275899993, 72.66400788000004],
              [-89.46833248599995, 72.66889069200005],
              [-89.49852454299992, 72.68512604400007],
              [-89.56696529899995, 72.70010000200006],
              [-89.58564205599993, 72.72410716400003],
              [-89.57758541599992, 72.73265208500004],
              [-89.57188880099994, 72.74453359600005],
              [-89.5645238919999, 72.75641510600008],
              [-89.55150305899991, 72.76508209800005],
              [-89.5723363919999, 72.78530508000006],
              [-89.5781957669999, 72.79242584800005],
              [-89.55854244699992, 72.78766510600008],
              [-89.50304114499994, 72.78558991100005],
              [-89.48253333199995, 72.78213125200006],
              [-89.42735755099994, 72.76508209800005],
              [-89.40697180899991, 72.76312897300005],
              [-89.36676998599995, 72.76585521000004],
              [-89.34540768099993, 72.76508209800005],
              [-89.31126868399991, 72.75495026200008],
              [-89.29438229099992, 72.75263092700004],
              [-89.27656002499992, 72.75824616100005],
              [-89.28180904899995, 72.76341380400004],
              [-89.29076087099992, 72.77875397300005],
              [-89.27961178299995, 72.78046295800004],
              [-89.26939856699994, 72.78318919500003],
              [-89.25971432199992, 72.78709544500003],
              [-89.24982662699995, 72.79242584800005],
              [-89.2708227199999, 72.79393138200004],
              [-89.33177649599992, 72.80609772300005],
              [-89.37446041599992, 72.80731842700004],
              [-89.39391028599994, 72.81159088700008],
              [-89.41059322799993, 72.82318756700005],
              [-89.41364498599995, 72.83087799700007],
              [-89.4090063139999, 72.83661530200004],
              [-89.40094967399995, 72.84149811400005],
              [-89.3938695949999, 72.84699127800008],
              [-89.39305579299992, 72.84686920800004],
              [-89.37999426999994, 72.85919830900008],
              [-89.3801977199999, 72.86066315300008],
              [-89.33665930899991, 72.87270742400005],
              [-89.32087154899995, 72.88231028900003],
              [-89.33177649599992, 72.89545319200005],
              [-89.30585689999992, 72.91030508000006],
              [-89.29804439999992, 72.92072174700007],
              [-89.29828854099992, 72.93642812700006],
              [-89.30724036399994, 72.94672272300005],
              [-89.3411352199999, 72.95856354400007],
              [-89.35566158799992, 72.96710846600007],
              [-89.3606664699999, 72.98016998900005],
              [-89.35383053299995, 72.99290599200003],
              [-89.34019934799994, 73.00389232000003],
              [-89.32494055899991, 73.01154205900008],
              [-89.30146236899992, 73.01862213700008],
              [-89.27782141799992, 73.02240631700005],
              [-89.25385494699992, 73.02265045800004],
              [-89.22935950399994, 73.01898834800005],
              [-89.23216712099992, 73.01471588700008],
              [-89.2351781889999, 73.01292552300004],
              [-89.24303137899994, 73.01154205900008],
              [-89.22370357999995, 73.00991445500006],
              [-89.2149145169999, 73.01325104400007],
              [-89.2180883449999, 73.01972077000005],
              [-89.23468990799995, 73.02757396000004],
              [-89.31187903599994, 73.04629140800006],
              [-89.30443274599992, 73.04629140800006],
              [-89.31187903599994, 73.05247630400004],
              [-89.3008520169999, 73.06183502800008],
              [-89.27611243399991, 73.07200755400004],
              [-89.26349850199995, 73.07977936400005],
              [-89.25719153599994, 73.08746979400007],
              [-89.24864661399994, 73.10602448100008],
              [-89.24303137899994, 73.11456940300008],
              [-89.21845455599993, 73.13174062700006],
              [-89.18980872299994, 73.13914622600004],
              [-89.12568111899992, 73.14809804900005],
              [-89.1399633449999, 73.14813873900005],
              [-89.18089758999992, 73.15550364800004],
              [-89.17345130099994, 73.16657135600008],
              [-89.16173255099994, 73.17763906500005],
              [-89.14753170499995, 73.18622467700004],
              [-89.11432857999995, 73.19196198100008],
              [-89.10619055899991, 73.19757721600007],
              [-89.10118567599994, 73.20453522300005],
              [-89.09223385299993, 73.21076080900008],
              [-89.04120846299992, 73.21893952000005],
              [-88.9368383449999, 73.20880768400008],
              [-88.88670813699991, 73.21698639500005],
              [-88.90741939999992, 73.22500234600005],
              [-88.95746822799993, 73.22280508000006],
              [-88.98094641799992, 73.22573476800005],
              [-89.03343665299991, 73.24103424700007],
              [-89.05121822799993, 73.25169505400004],
              [-88.96186275899993, 73.28974030200004],
              [-88.91588294199994, 73.30182526200008],
              [-88.86286373599995, 73.30634186400005],
              [-88.85212154899995, 73.30418528900003],
              [-88.83320064999992, 73.29482656500005],
              [-88.82123775899993, 73.29266998900005],
              [-88.74958248599995, 73.29266998900005],
              [-88.64875240799995, 73.28070709800005],
              [-88.6192113919999, 73.28583405200004],
              [-88.64814205599993, 73.29621002800008],
              [-88.83324133999992, 73.32355377800008],
              [-88.8594457669999, 73.33368561400005],
              [-88.84284420499995, 73.34780508000006],
              [-88.78404700399994, 73.36546458500004],
              [-88.76012122299994, 73.37807851800005],
              [-88.72553463399993, 73.40257396000004],
              [-88.68748938699991, 73.42304108300004],
              [-88.58775794199994, 73.45404694200005],
              [-88.51805579299992, 73.46116771000004],
              [-88.49775143099993, 73.46649811400005],
              [-88.48888098899994, 73.47418854400007],
              [-88.48615475199995, 73.48069896000004],
              [-88.47960364499994, 73.48867422100005],
              [-88.47179114499994, 73.49534739800004],
              [-88.45482337099992, 73.50185781500005],
              [-88.41376705599993, 73.52545807500007],
              [-87.9954320949999, 73.65574778900003],
              [-87.85374915299991, 73.68390534100007],
              [-87.7644750639999, 73.71674225500004],
              [-87.58617102799991, 73.73725006700005],
              [-87.43464107999995, 73.76544830900008],
              [-87.29828854099992, 73.77033112200007],
              [-87.1341039699999, 73.80272044500003],
              [-86.87608801999994, 73.81879303600005],
              [-86.7141820949999, 73.84739817900004],
              [-86.55842037699995, 73.85529205900008],
              [-86.3738500639999, 73.84739817900004],
              [-86.01862545499995, 73.85488515800006],
              [-85.74779212099992, 73.83193594000005],
              [-85.27192135299993, 73.81826406500005],
              [-85.24079342399995, 73.82709381700005],
              [-85.21662350199995, 73.81989166900007],
              [-85.10570227799991, 73.81199778900003],
              [-84.88276119699992, 73.74823639500005],
              [-84.8367406889999, 73.74518463700008],
              [-84.84947669199994, 73.73847077000005],
              [-84.87767493399991, 73.71039459800005],
              [-84.88792883999992, 73.70477936400005],
              [-84.91148841099994, 73.69501373900005],
              [-84.9519750639999, 73.66766998900005],
              [-85.21277828649991, 73.59656403200006],
              [-85.47358150899993, 73.52545807500007],
              [-85.55345618399991, 73.51972077000005],
              [-85.57721920499995, 73.51239655200004],
              [-85.66462154899995, 73.45722077000005],
              [-85.7395727199999, 73.44334544500003],
              [-86.03034420499995, 73.30243561400005],
              [-86.12958736899992, 73.23305898600006],
              [-86.2180883449999, 73.14850495000007],
              [-86.24701900899993, 73.12946198100008],
              [-86.29242916599992, 73.11615631700005],
              [-86.29393469999991, 73.10464101800005],
              [-86.28730221299992, 73.09296295800004],
              [-86.28294837099992, 73.08722565300008],
              [-86.29133053299995, 73.07664622600004],
              [-86.30272376199991, 73.07062409100007],
              [-86.3301488919999, 73.05996328300006],
              [-86.33197994699992, 73.04425690300008],
              [-86.38390051999994, 73.02016836100006],
              [-86.40583248599995, 73.00470612200007],
              [-86.46967525899993, 72.95848216400003],
              [-86.61290442599994, 72.89362213700008],
              [-86.67271887899994, 72.84699127800008],
              [-86.69273841099994, 72.82611725500004],
              [-86.6985570949999, 72.81610748900005],
              [-86.70697994699992, 72.76984284100007],
              [-86.71056067599994, 72.76170482000003],
              [-86.7312719389999, 72.74241771000004],
              [-86.73753821499992, 72.73094310100004],
              [-86.73542232999995, 72.71670156500005],
              [-86.68016516799992, 72.68317291900007],
              [-86.70575924399992, 72.66840241100005],
              [-86.68024654899995, 72.64618561400005],
              [-86.32612057199992, 72.50364817900004],
              [-86.26634680899991, 72.46625397300005],
              [-86.24201412699995, 72.42251211100006],
              [-86.25340735599991, 72.39459870000007],
              [-86.27875729099992, 72.37832265800006],
              [-86.3086645169999, 72.36615631700005],
              [-86.33385169199994, 72.35049062700006],
              [-86.35517330599993, 72.33344147300005],
              [-86.40196692599994, 72.30540599200003],
              [-86.42292232999995, 72.28872304900005],
              [-86.43248450399994, 72.27684153900003],
              [-86.43586178299995, 72.26748281500005],
              [-86.44001217399995, 72.24433014500005],
              [-86.46043860599991, 72.20335521000004],
              [-86.45649166599992, 72.19232819200005],
              [-86.43940182199992, 72.17633698100008],
              [-86.43378658799992, 72.16864655200004],
              [-86.44745846299992, 72.12763092700004],
              [-86.43797766799992, 72.11237213700008],
              [-86.43431555899991, 72.09975820500006],
              [-86.43378658799992, 72.07298411700003],
              [-86.43110104099992, 72.05878327000005],
              [-86.42157955599993, 72.03172435100004],
              [-86.41950436099995, 72.02118561400005],
              [-86.40819251199991, 72.00580475500004],
              [-86.3821508449999, 71.99848053600005],
              [-86.35338294199994, 71.99408600500004],
              [-86.33385169199994, 71.98704661700003],
              [-86.32917232999995, 71.97671133000006],
              [-86.32966061099995, 71.96454498900005],
              [-86.32612057199992, 71.95087311400005],
              [-86.30964107999995, 71.93585846600007],
              [-86.25654049399992, 71.90558502800008],
              [-86.24201412699995, 71.89423248900005],
              [-86.1902563139999, 71.84186432500007],
              [-86.12755286399994, 71.79425690300008],
              [-86.11103268099993, 71.78436920800004],
              [-86.08849036399994, 71.77830638200004],
              [-86.04295813699991, 71.77313873900005],
              [-86.02843176999994, 71.76459381700005],
              [-86.00947018099993, 71.75120677300004],
              [-85.96357174399992, 71.73948802300004],
              [-85.9434301419999, 71.72638580900008],
              [-85.92833411399994, 71.71344635600008],
              [-85.84687252499992, 71.67096588700008],
              [-85.82197018099993, 71.66254303600005],
              [-85.79596920499995, 71.65717194200005],
              [-85.7683813139999, 71.65534088700008],
              [-85.75934811099995, 71.65257396000004],
              [-85.72679602799991, 71.63792552300004],
              [-85.72687740799995, 71.62433502800008],
              [-85.72516842399995, 71.61815013200004],
              [-85.72057044199994, 71.61310455900008],
              [-85.67454993399991, 71.59178294500003],
              [-85.5742895169999, 71.56614817900004],
              [-85.52879798099991, 71.54547760600008],
              [-85.51740475199995, 71.53497955900008],
              [-85.50800533799992, 71.52358633000006],
              [-85.49693762899994, 71.51439036700003],
              [-85.48070227799991, 71.51068756700005],
              [-85.42577063699991, 71.51752350500004],
              [-85.41600501199991, 71.51487864800004],
              [-85.41401119699992, 71.50873444200005],
              [-85.41454016799992, 71.50193919500003],
              [-85.41209876199991, 71.49701569200005],
              [-85.3906957669999, 71.48895905200004],
              [-85.37181555899991, 71.48737213700008],
              [-85.32990475199995, 71.49017975500004],
              [-85.31806393099993, 71.48700592700004],
              [-85.30028235599991, 71.47288646000004],
              [-85.28551184799994, 71.46971263200004],
              [-85.24681555899991, 71.46987539300005],
              [-85.22687740799995, 71.46775950700004],
              [-85.20665442599994, 71.46222565300008],
              [-85.20551510299993, 71.46015045800004],
              [-85.20502682199992, 71.45624420800004],
              [-85.20343990799995, 71.45189036700003],
              [-85.19920813699991, 71.44863515800006],
              [-85.18586178299995, 71.44476959800005],
              [-85.02464758999992, 71.44106679900005],
              [-84.95966549399992, 71.42877838700008],
              [-84.94762122299994, 71.42332591400003],
              [-84.93419348899994, 71.41449616100005],
              [-84.92320716099994, 71.40326569200005],
              [-84.91869055899991, 71.39057038000004],
              [-84.92292232999995, 71.37982819200005],
              [-84.94172115799995, 71.36859772300005],
              [-84.94599361899992, 71.35712311400005],
              [-84.94383704299992, 71.34438711100006],
              [-84.93687903599994, 71.34247467700004],
              [-84.92426510299993, 71.34528229400007],
              [-84.90501868399991, 71.34682851800005],
              [-84.88670813699991, 71.34357330900008],
              [-84.8743383449999, 71.33673737200007],
              [-84.85411536399994, 71.31582265800006],
              [-84.83763587099992, 71.28656647300005],
              [-84.85814368399991, 71.27610911700003],
              [-85.19318600199995, 71.29930247600004],
              [-85.27558346299992, 71.28473541900007],
              [-85.25511633999992, 71.27094147300005],
              [-85.22883053299995, 71.27000560100004],
              [-85.1719457669999, 71.27789948100008],
              [-85.1719457669999, 71.27045319200005],
              [-85.20250403599994, 71.26581452000005],
              [-85.26341712099992, 71.24909088700008],
              [-85.29609127499992, 71.24380117400005],
              [-85.41657467399995, 71.25267161700003],
              [-85.45307369699992, 71.24380117400005],
              [-85.47154700399994, 71.22972239800004],
              [-85.45148678299995, 71.22772858300004],
              [-85.41771399599992, 71.22939687700006],
              [-85.39509029899995, 71.22638580900008],
              [-85.38971920499995, 71.20848216400003],
              [-85.40619869699992, 71.19696686400005],
              [-85.42650305899991, 71.19428131700005],
              [-85.43260657499991, 71.20282623900005],
              [-85.45567786399994, 71.21165599200003],
              [-85.4707738919999, 71.21035390800006],
              [-85.48302161399994, 71.20087311400005],
              [-85.49775143099993, 71.18545156500005],
              [-85.51598059799994, 71.17951080900008],
              [-85.54320227799991, 71.18056875200006],
              [-85.70014400899993, 71.20966217700004],
              [-85.72496497299994, 71.20848216400003],
              [-85.7957250639999, 71.18854401200008],
              [-85.83665930899991, 71.18854401200008],
              [-85.88141842399995, 71.17788320500006],
              [-85.91315670499995, 71.18227773600006],
              [-85.94530188699991, 71.18089427300004],
              [-85.9746801419999, 71.17495351800005],
              [-85.98749752499992, 71.16437409100007],
              [-86.01891028599994, 71.14618561400005],
              [-86.16661536399994, 71.10700104400007],
              [-86.21406002499992, 71.09979889500005],
              [-86.21198482999995, 71.09516022300005],
              [-86.20917721299992, 71.08340078300006],
              [-86.20722408799992, 71.07868073100008],
              [-86.30842037699995, 71.05565013200004],
              [-86.3438207669999, 71.05198802300004],
              [-86.3860570949999, 71.05365631700005],
              [-86.39903723899994, 71.05198802300004],
              [-86.40440833199995, 71.04905833500004],
              [-86.41327877499992, 71.04035065300008],
              [-86.41950436099995, 71.03774648600006],
              [-86.49522864499994, 71.03774648600006],
              [-86.80317135299993, 71.00043366100005],
              [-86.81733150899993, 70.99054596600007],
              [-86.8235570949999, 70.99054596600007],
              [-86.66254635299993, 70.97626373900005],
              [-86.28486080599993, 71.00625234600005],
              [-86.25409908799992, 71.01520416900007],
              [-86.22350012899994, 71.02045319200005],
              [-86.19871985599991, 71.03457265800006],
              [-86.16392981699994, 71.04116445500006],
              [-86.12132727799991, 71.05605703300006],
              [-85.88593502499992, 71.10504791900007],
              [-85.81859290299991, 71.14126211100006],
              [-85.76850338399993, 71.14940013200004],
              [-85.54413814999992, 71.15546295800004],
              [-85.52887936099995, 71.15863678600005],
              [-85.50153561099995, 71.17145416900007],
              [-85.48383541599992, 71.17511627800008],
              [-85.19298255099994, 71.15444570500006],
              [-85.19513912699995, 71.14964427300004],
              [-85.19599361899992, 71.14956289300005],
              [-85.19920813699991, 71.14760976800005],
              [-85.18175208199995, 71.14105866100005],
              [-85.16816158799992, 71.14419179900005],
              [-85.15660559799994, 71.15082428600005],
              [-85.14557857999995, 71.15444570500006],
              [-85.08995520699995, 71.15444570500006],
              [-85.1113988919999, 71.16600169500003],
              [-85.11969967399995, 71.17267487200007],
              [-85.12474524599992, 71.18231842700004],
              [-85.01362057199992, 71.16152578300006],
              [-84.98753821499992, 71.16803620000007],
              [-85.01398678299995, 71.17967357000003],
              [-85.02765865799995, 71.18276601800005],
              [-85.04279537699995, 71.18231842700004],
              [-85.04279537699995, 71.18854401200008],
              [-84.97260494699992, 71.19619375200006],
              [-84.95282955599993, 71.19196198100008],
              [-84.92650305899991, 71.17641836100006],
              [-84.91388912699995, 71.17365143400008],
              [-84.89818274599992, 71.17861562700006],
              [-84.88609778599994, 71.17804596600007],
              [-84.8704320949999, 71.17023346600007],
              [-84.85680091099994, 71.15973541900007],
              [-84.85102291599992, 71.15102773600006],
              [-84.85374915299991, 71.14044830900008],
              [-84.86676998599995, 71.12124258000006],
              [-84.87092037699995, 71.11347077000005],
              [-84.87450110599991, 71.07843659100007],
              [-84.87767493399991, 71.07245514500005],
              [-84.89313717399995, 71.07436758000006],
              [-84.95966549399992, 71.10293203300006],
              [-84.98228919199994, 71.10781484600005],
              [-85.14521236899992, 71.09296295800004],
              [-85.14521236899992, 71.08612702000005],
              [-84.95966549399992, 71.07868073100008],
              [-84.96528072799993, 71.06614817900004],
              [-84.97297115799995, 71.05646393400008],
              [-84.98265540299991, 71.05316803600005],
              [-84.99445553299995, 71.05947500200006],
              [-85.00121008999992, 71.05524323100008],
              [-85.00804602799991, 71.05198802300004],
              [-85.0051977199999, 71.04173411700003],
              [-85.00804602799991, 71.03156159100007],
              [-84.97496497299994, 71.02993398600006],
              [-84.94623775899993, 71.01927317900004],
              [-84.93114173099991, 71.00092194200005],
              [-84.93915768099993, 70.97626373900005],
              [-84.95063229099992, 70.96824778900003],
              [-84.96580969999991, 70.96051666900007],
              [-84.97789466099994, 70.95038483300004],
              [-84.98009192599994, 70.93528880400004],
              [-84.96796627499992, 70.92397695500006],
              [-84.94635982999995, 70.92255280200004],
              [-84.90473385299993, 70.92788320500006],
              [-84.79918372299994, 70.92788320500006],
              [-84.79600989499994, 70.93329498900005],
              [-84.7930395169999, 70.94525788000004],
              [-84.78795325399994, 70.95722077000005],
              [-84.77839107999995, 70.96259186400005],
              [-84.75934811099995, 70.96645742400005],
              [-84.75300045499995, 70.97589752800008],
              [-84.75483150899993, 71.00047435100004],
              [-84.76276607999995, 71.01251862200007],
              [-84.77765865799995, 71.01801178600005],
              [-84.78608150899993, 71.02411530200004],
              [-84.77464758999992, 71.03774648600006],
              [-84.81065833199995, 71.05573151200008],
              [-84.8235570949999, 71.06659577000005],
              [-84.82929439999992, 71.08612702000005],
              [-84.82591712099992, 71.10049062700006],
              [-84.80805416599992, 71.12881094000005],
              [-84.80260169199994, 71.14077383000006],
              [-84.80125891799992, 71.17470937700006],
              [-84.79710852799991, 71.18488190300008],
              [-84.78209387899994, 71.19537995000007],
              [-84.75230872299994, 71.20502350500004],
              [-84.69184322799993, 71.21230703300006],
              [-84.66478430899991, 71.22333405200004],
              [-84.75804602799991, 71.25885651200008],
              [-84.79869544199994, 71.28766510600008],
              [-84.78831946499992, 71.31891510600008],
              [-84.75776119699992, 71.36786530200004],
              [-84.74115963399993, 71.38031647300005],
              [-84.76134192599994, 71.40766022300005],
              [-84.73900305899991, 71.42446523600006],
              [-84.7005102199999, 71.43284739800004],
              [-84.59093176999994, 71.43915436400005],
              [-84.54723059799994, 71.44985586100006],
              [-84.52826900899993, 71.47313060100004],
              [-84.53368079299992, 71.49404531500005],
              [-84.55760657499991, 71.53558991100005],
              [-84.56305904899995, 71.55536530200004],
              [-84.57848059799994, 71.56273021000004],
              [-84.6121313139999, 71.56997304900005],
              [-84.64496822799993, 71.58429596600007],
              [-84.65802975199995, 71.61310455900008],
              [-84.64716549399992, 71.62254466400003],
              [-84.60338294199994, 71.64789459800005],
              [-84.6223852199999, 71.66583893400008],
              [-84.63178463399993, 71.67251211100006],
              [-84.64464270699995, 71.67519765800006],
              [-84.71324622299994, 71.68203359600005],
              [-84.87092037699995, 71.67519765800006],
              [-84.86640377499992, 71.66714101800005],
              [-84.86042232999995, 71.66120026200008],
              [-84.85289466099994, 71.65729401200008],
              [-84.84357662699995, 71.65534088700008],
              [-84.8528539699999, 71.63979726800005],
              [-84.87047278599994, 71.63336823100008],
              [-84.89159094999991, 71.63296133000006],
              [-85.2578832669999, 71.66836172100005],
              [-85.32795162699995, 71.68573639500005],
              [-85.45527096299992, 71.75897858300004],
              [-85.52879798099991, 71.77138906500005],
              [-85.52196204299992, 71.77822500200006],
              [-85.53734290299991, 71.78314850500004],
              [-85.56830807199992, 71.78607819200005],
              [-85.58344479099992, 71.79181549700007],
              [-85.45396887899994, 71.80174388200004],
              [-85.4407445949999, 71.80634186400005],
              [-85.43781490799995, 71.81476471600007],
              [-85.44941158799992, 71.82941315300008],
              [-85.46324622299994, 71.83909739800004],
              [-85.49274654899995, 71.85146719000005],
              [-85.54784094999991, 71.88678620000007],
              [-85.56293697799993, 71.89423248900005],
              [-85.55553137899994, 71.90167877800008],
              [-85.57343502499992, 71.90721263200004],
              [-85.65192623599995, 71.92007070500006],
              [-85.74726314999992, 71.94855377800008],
              [-86.02135169199994, 71.98411692900004],
              [-86.04210364499994, 71.99420807500007],
              [-86.04877682199992, 72.00706614800004],
              [-86.05064856699994, 72.01455312700006],
              [-86.04584713399993, 72.01776764500005],
              [-86.03071041599992, 72.01752350500004],
              [-86.0247289699999, 72.01459381700005],
              [-86.0222875639999, 72.00751373900005],
              [-86.01488196499992, 71.99774811400005],
              [-85.9973852199999, 71.98981354400007],
              [-85.97687740799995, 71.98476797100005],
              [-85.96019446499992, 71.98362864800004],
              [-85.96617591099994, 71.99457428600005],
              [-85.98200436099995, 72.00381094000005],
              [-85.98749752499992, 72.00409577000005],
              [-85.98375403599994, 72.01593659100007],
              [-85.98468990799995, 72.02236562700006],
              [-85.98749752499992, 72.03143952000005],
              [-85.96930904899995, 72.03066640800006],
              [-85.9531957669999, 72.02777741100005],
              [-85.93708248599995, 72.02667877800008],
              [-85.9192602199999, 72.03143952000005],
              [-85.92601477799991, 72.03143952000005],
              [-85.87494869699992, 72.03172435100004],
              [-85.72057044199994, 72.01093170800004],
              [-85.73700924399992, 72.02094147300005],
              [-85.77232825399994, 72.02659739800004],
              [-85.7820531889999, 72.03888580900008],
              [-85.74071204299992, 72.05194733300004],
              [-85.61286373599995, 72.05866120000007],
              [-85.57184811099995, 72.05780670800004],
              [-85.55760657499991, 72.06053294500003],
              [-85.51020260299993, 72.07754140800006],
              [-85.49775143099993, 72.07990143400008],
              [-85.49535071499992, 72.08588288000004],
              [-85.5105688139999, 72.09935130400004],
              [-85.54246985599991, 72.12079498900005],
              [-85.54246985599991, 72.12763092700004],
              [-85.46735592399995, 72.12763092700004],
              [-85.43297278599994, 72.13670482000003],
              [-85.41624915299991, 72.13882070500006],
              [-85.3985082669999, 72.13446686400005],
              [-85.41356360599991, 72.15009186400005],
              [-85.44395911399994, 72.16412995000007],
              [-85.47907467399995, 72.17357005400004],
              [-85.50837154899995, 72.17544179900005],
              [-85.49970455599993, 72.19765859600005],
              [-85.50092525899993, 72.21442291900007],
              [-85.51435299399992, 72.22699616100005],
              [-85.54246985599991, 72.23688385600008],
              [-85.51475989499994, 72.23993561400005],
              [-85.45116126199991, 72.22060781500005],
              [-85.41893469999991, 72.21702708500004],
              [-85.43309485599991, 72.23501211100006],
              [-85.45262610599991, 72.24530670800004],
              [-85.47581946499992, 72.25006745000007],
              [-85.50092525899993, 72.25116608300004],
              [-85.47642981699994, 72.26626211100006],
              [-85.43748938699991, 72.26508209800005],
              [-85.36371822799993, 72.25116608300004],
              [-85.34430904899995, 72.25202057500007],
              [-85.29609127499992, 72.26422760600008],
              [-85.27647864499994, 72.26373932500007],
              [-85.23945064999992, 72.25714752800008],
              [-85.22032630099994, 72.25739166900007],
              [-85.24079342399995, 72.25116608300004],
              [-85.23261471299992, 72.23859284100007],
              [-85.21837317599994, 72.23574453300006],
              [-85.20173092399995, 72.23891836100006],
              [-85.18622799399992, 72.24433014500005],
              [-85.18622799399992, 72.25116608300004],
              [-85.19298255099994, 72.25116608300004],
              [-85.1804906889999, 72.25946686400005],
              [-85.15904700399994, 72.26080963700008],
              [-85.11420650899993, 72.25739166900007],
              [-85.09923255099994, 72.25458405200004],
              [-85.09190833199995, 72.24823639500005],
              [-85.09479732999995, 72.24135976800005],
              [-85.11054439999992, 72.23688385600008],
              [-85.11054439999992, 72.23065827000005],
              [-85.0711156889999, 72.23143138200004],
              [-85.05585689999992, 72.23729075700004],
              [-85.05585689999992, 72.25116608300004],
              [-85.03583736899992, 72.25470612200007],
              [-85.01768958199995, 72.25189850500004],
              [-84.99986731699994, 72.24701569200005],
              [-84.95702063699991, 72.24103424700007],
              [-84.91279049399992, 72.22654857000003],
              [-84.89134680899991, 72.22321198100008],
              [-84.87767493399991, 72.22272370000007],
              [-84.86200924399992, 72.21971263200004],
              [-84.8489477199999, 72.21271393400008],
              [-84.84357662699995, 72.19965241100005],
              [-84.83661861899992, 72.19334544500003],
              [-84.68342037699995, 72.14496491100005],
              [-84.60789954299992, 72.13873932500007],
              [-84.57603919199994, 72.12763092700004],
              [-84.55976314999992, 72.12421295800004],
              [-84.52411861899992, 72.12213776200008],
              [-84.50776119699992, 72.11737702000005],
              [-84.46678626199991, 72.09601471600007],
              [-84.45624752499992, 72.09349192900004],
              [-84.44745846299992, 72.08942291900007],
              [-84.42768307199992, 72.06952545800004],
              [-84.41840572799993, 72.06220123900005],
              [-84.40583248599995, 72.05841705900008],
              [-84.36347408799992, 72.05878327000005],
              [-84.35456295499995, 72.05662669500003],
              [-84.33971106699994, 72.04726797100005],
              [-84.31684322799993, 72.04193756700005],
              [-84.28669186099995, 72.02777741100005],
              [-84.27131100199995, 72.02460358300004],
              [-84.25670325399994, 72.01471588700008],
              [-84.24596106699994, 71.99225495000007],
              [-84.2376195949999, 71.96792226800005],
              [-84.23033606699994, 71.95258209800005],
              [-84.20661373599995, 71.93854401200008],
              [-84.18403072799993, 71.93817780200004],
              [-84.17170162699995, 71.95099518400008],
              [-84.17878170499995, 71.97626373900005],
              [-84.17186438699991, 71.97724030200004],
              [-84.16718502499992, 71.97939687700006],
              [-84.16315670499995, 71.98183828300006],
              [-84.15831458199995, 71.98362864800004],
              [-84.16694088399993, 71.99046458500004],
              [-84.18183346299992, 72.00604889500005],
              [-84.19245357999995, 72.01093170800004],
              [-84.16454016799992, 72.02460358300004],
              [-84.18000240799995, 72.02773672100005],
              [-84.24604244699992, 72.05536530200004],
              [-84.31537838399993, 72.06557851800005],
              [-84.3313695949999, 72.07123444200005],
              [-84.34284420499995, 72.07713450700004],
              [-84.38520260299993, 72.11163971600007],
              [-84.39659583199995, 72.11766185100004],
              [-84.41156979099992, 72.12079498900005],
              [-84.39354407499991, 72.12677643400008],
              [-84.37743079299992, 72.13446686400005],
              [-84.48542232999995, 72.14248281500005],
              [-84.59032141799992, 72.16242096600007],
              [-84.6101781889999, 72.16860586100006],
              [-84.7473852199999, 72.23065827000005],
              [-84.70897376199991, 72.22972239800004],
              [-84.69005286399994, 72.23139069200005],
              [-84.67223059799994, 72.23688385600008],
              [-84.68980872299994, 72.24404531500005],
              [-84.71104895699995, 72.24591705900008],
              [-84.75422115799995, 72.24433014500005],
              [-84.77037512899994, 72.24656810100004],
              [-84.81627356699994, 72.26422760600008],
              [-84.91124426999994, 72.28091054900005],
              [-84.93915768099993, 72.29214101800005],
              [-84.92487545499995, 72.29897695500006],
              [-84.88573157499991, 72.31004466400003],
              [-84.87767493399991, 72.31574127800008],
              [-84.87262936099995, 72.32196686400005],
              [-84.81407630099994, 72.35761139500005],
              [-84.78221594999991, 72.36212799700007],
              [-84.56920325399994, 72.35419342700004],
              [-84.53233801999994, 72.35700104400007],
              [-84.43207760299993, 72.38153717700004],
              [-84.45628821499992, 72.38703034100007],
              [-84.53510494699992, 72.36717357000003],
              [-84.82587643099993, 72.37982819200005],
              [-84.86469479099992, 72.36717357000003],
              [-84.8731176419999, 72.37368398600006],
              [-84.87621008999992, 72.38182200700004],
              [-84.87767493399991, 72.40200429900005],
              [-84.85448157499991, 72.40517812700006],
              [-84.82762610599991, 72.40595123900005],
              [-84.8035375639999, 72.40989817900004],
              [-84.78831946499992, 72.42251211100006],
              [-84.80260169199994, 72.42251211100006],
              [-84.77721106699994, 72.44741445500006],
              [-84.76947994699992, 72.46043528900003],
              [-84.78014075399994, 72.46165599200003],
              [-84.8281957669999, 72.44481028900003],
              [-84.89093990799995, 72.43789297100005],
              [-85.02106686099995, 72.40200429900005],
              [-85.0176488919999, 72.39590078300006],
              [-85.01134192599994, 72.38011302300004],
              [-85.00804602799991, 72.37409088700008],
              [-85.07685299399992, 72.37596263200004],
              [-85.09679114499994, 72.37067291900007],
              [-85.12022864499994, 72.35610586100006],
              [-85.13190670499995, 72.35390859600005],
              [-85.14521236899992, 72.36041901200008],
              [-85.14203854099992, 72.37055084800005],
              [-85.1367895169999, 72.37787506700005],
              [-85.12889563699991, 72.38182200700004],
              [-85.11790930899991, 72.38153717700004],
              [-85.11790930899991, 72.38776276200008],
              [-85.34430904899995, 72.41290924700007],
              [-85.45307369699992, 72.45038483300004],
              [-85.51451575399994, 72.46344635600008],
              [-85.54588782499991, 72.48395416900007],
              [-85.55235755099994, 72.49038320500006],
              [-85.55992591099994, 72.50438060100004],
              [-85.57001705599993, 72.51850006700005],
              [-85.58372962099992, 72.52488841400003],
              [-85.5911352199999, 72.52724844000005],
              [-85.60273189999992, 72.53290436400005],
              [-85.61347408799992, 72.53961823100008],
              [-85.61823482999995, 72.54535553600005],
              [-85.61339270699995, 72.55463288000004],
              [-85.60212154899995, 72.55805084800005],
              [-85.49677486899992, 72.56614817900004],
              [-85.47358150899993, 72.57330963700008],
              [-85.47358150899993, 72.57953522300005],
              [-85.57884680899991, 72.58266836100006],
              [-85.63280188699991, 72.59349192900004],
              [-85.7024633449999, 72.63471100500004],
              [-85.7063695949999, 72.63849518400008],
              [-85.70429439999992, 72.64655182500007],
              [-85.6953832669999, 72.65875885600008],
              [-85.69330807199992, 72.66547272300005],
              [-85.68964596299992, 72.69147370000007],
              [-85.69111080599993, 72.70327383000006],
              [-85.70014400899993, 72.71670156500005],
              [-85.69330807199992, 72.71670156500005],
              [-85.70026607999995, 72.72284577000005],
              [-85.71381588399993, 72.73777903900003],
              [-85.70531165299991, 72.74599844000005],
              [-85.69965572799993, 72.75438060100004],
              [-85.69758053299995, 72.76292552300004],
              [-85.70014400899993, 72.77130768400008],
              [-85.69330807199992, 72.77130768400008],
              [-85.69481360599991, 72.78563060100004],
              [-85.68626868399991, 72.79926178600005],
              [-85.67426510299993, 72.81273021000004],
              [-85.6653539699999, 72.82656484600005],
              [-85.67377682199992, 72.84210846600007],
              [-85.66816158799992, 72.85260651200008],
              [-85.65782630099994, 72.86115143400008],
              [-85.65233313699991, 72.87124258000006],
              [-85.65965735599991, 72.88519928600005],
              [-85.67365475199995, 72.88922760600008],
              [-85.68207760299993, 72.89362213700008],
              [-85.67280025899993, 72.90843333500004],
              [-85.65766354099992, 72.91718170800004],
              [-85.61322994699992, 72.93634674700007],
              [-85.60395260299993, 72.94696686400005],
              [-85.59398352799991, 72.96308014500005],
              [-85.57062740799995, 72.97231679900005],
              [-85.54328365799995, 72.97646719000005],
              [-85.31794186099995, 72.96308014500005],
              [-85.1590063139999, 72.94818756700005],
              [-84.92064368399991, 72.89858633000006],
              [-84.45795650899993, 72.84064362200007],
              [-84.37157141799992, 72.81244538000004],
              [-84.30626380099994, 72.80292389500005],
              [-84.25792395699995, 72.78876373900005],
              [-84.13044186099995, 72.77875397300005],
              [-83.99140377499992, 72.74896881700005],
              [-83.95287024599992, 72.75824616100005],
              [-84.07872473899994, 72.78754303600005],
              [-84.23790442599994, 72.80121491100005],
              [-84.6192113919999, 72.90444570500006],
              [-84.71898352799991, 72.91107819200005],
              [-84.91584225199995, 72.96259186400005],
              [-84.94599361899992, 72.96369049700007],
              [-85.08995520699995, 72.98480866100005],
              [-85.08336341099994, 72.98578522300005],
              [-85.06269283799992, 72.99103424700007],
              [-85.08222408799992, 73.01703522300005],
              [-85.11803137899994, 73.03314850500004],
              [-85.1570531889999, 73.03514232000003],
              [-85.18622799399992, 73.01898834800005],
              [-85.1719457669999, 73.01154205900008],
              [-85.53563391799992, 73.02578359600005],
              [-85.52635657499991, 73.04124583500004],
              [-85.46357174399992, 73.11188385600008],
              [-85.44159908799992, 73.12938060100004],
              [-85.41722571499992, 73.14057038000004],
              [-85.39313717399995, 73.13996002800008],
              [-85.37767493399991, 73.13300202000005],
              [-85.36778723899994, 73.12567780200004],
              [-85.34760494699992, 73.10398997600004],
              [-85.3347875639999, 73.09479401200008],
              [-85.20824133999992, 73.05927155200004],
              [-85.12474524599992, 73.05247630400004],
              [-85.14863033799992, 73.07176341400003],
              [-85.21381588399993, 73.11029694200005],
              [-85.22716223899994, 73.13129303600005],
              [-85.17540442599994, 73.14899323100008],
              [-85.03038489499994, 73.13654205900008],
              [-84.8809301419999, 73.10211823100008],
              [-84.73192298099991, 73.08722565300008],
              [-84.45885169199994, 73.06244538000004],
              [-84.19566809799994, 73.04755280200004],
              [-84.0020238919999, 73.03758372600004],
              [-83.86131751199991, 73.03656647300005],
              [-83.70543372299994, 72.99534739800004],
              [-83.65733801999994, 72.99188873900005],
              [-83.63756262899994, 72.98480866100005],
              [-83.66254635299993, 73.00234609600005],
              [-83.78095455599993, 73.03266022300005],
              [-83.7747289699999, 73.03949616100005],
              [-83.79474850199995, 73.04657623900005],
              [-83.91987057199992, 73.06378815300008],
              [-84.16510982999995, 73.07046133000006],
              [-84.24229895699995, 73.08917877800008],
              [-84.49189205599993, 73.11522044500003],
              [-84.56920325399994, 73.11456940300008],
              [-85.02106686099995, 73.20331452000005],
              [-85.11249752499992, 73.20294830900008],
              [-85.15807044199994, 73.20905182500007],
              [-85.19298255099994, 73.23126862200007],
              [-85.17625891799992, 73.24160390800006],
              [-85.16087805899991, 73.25409577000005],
              [-85.14960689999992, 73.26972077000005],
              [-85.14521236899992, 73.28925202000005],
              [-85.13581295499995, 73.30939362200007],
              [-85.1133520169999, 73.32184479400007],
              [-84.83665930899991, 73.38906484600005],
              [-84.79723059799994, 73.39093659100007],
              [-84.75995846299992, 73.38336823100008],
              [-84.73688717399995, 73.37177155200004],
              [-84.68590247299994, 73.32623932500007],
              [-84.65990149599992, 73.31028880400004],
              [-84.63133704299992, 73.29999420800004],
              [-84.60102291599992, 73.29437897300005],
              [-84.56952877499992, 73.29266998900005],
              [-84.51451575399994, 73.27765534100007],
              [-84.45673580599993, 73.24738190300008],
              [-84.39854895699995, 73.22451406500005],
              [-84.34264075399994, 73.23126862200007],
              [-84.38459225199995, 73.25751373900005],
              [-84.57258053299995, 73.32200755400004],
              [-84.59788977799991, 73.33559804900005],
              [-84.59992428299995, 73.35073476800005],
              [-84.59858150899993, 73.36497630400004],
              [-84.6172582669999, 73.37641022300005],
              [-84.64179439999992, 73.38605377800008],
              [-84.65802975199995, 73.39508698100008],
              [-84.60326087099992, 73.41400788000004],
              [-84.24091549399992, 73.47418854400007],
              [-84.18219967399995, 73.47768789300005],
              [-83.78095455599993, 73.43610260600008],
              [-83.75971432199992, 73.42841217700004],
              [-83.73346920499995, 73.41437409100007],
              [-83.7207738919999, 73.40102773600006],
              [-83.73997962099992, 73.39508698100008],
              [-83.71654212099992, 73.36823151200008],
              [-83.6992895169999, 73.34345123900005],
              [-83.67878170499995, 73.32176341400003],
              [-83.64574133999992, 73.30438873900005],
              [-83.62372799399992, 73.29962799700007],
              [-83.60517330599993, 73.30149974200003],
              [-83.59443111899992, 73.31024811400005],
              [-83.59601803299995, 73.32623932500007],
              [-83.61188717399995, 73.34454987200007],
              [-83.62950598899994, 73.35219961100006],
              [-83.64252682199992, 73.36058177300004],
              [-83.64439856699994, 73.38149648600006],
              [-83.6380102199999, 73.39842357000003],
              [-83.63105221299992, 73.41058991100005],
              [-83.62995357999995, 73.42279694200005],
              [-83.64098059799994, 73.43984609600005],
              [-83.66523189999992, 73.45612213700008],
              [-84.00751705599993, 73.50495026200008],
              [-83.98485266799992, 73.52313873900005],
              [-83.64118404899995, 73.59511953300006],
              [-83.54662024599992, 73.59967682500007],
              [-83.35651607999995, 73.64337799700007],
              [-83.16307532499991, 73.66718170800004],
              [-83.1297094389999, 73.66669342700004],
              [-83.05724036399994, 73.64940013200004],
              [-83.0305883449999, 73.65924713700008],
              [-83.00287838399993, 73.67796458500004],
              [-82.89740963399993, 73.70734284100007],
              [-82.86664791599992, 73.72646719000005],
              [-82.85614986899992, 73.73151276200008],
              [-82.83112545499995, 73.73672109600005],
              [-82.44281979099992, 73.73053620000007],
              [-82.05060787699995, 73.73773834800005],
              [-81.87677975199995, 73.72162506700005],
              [-81.52839107999995, 73.71621328300006],
              [-81.47455807199992, 73.70465729400007],
              [-81.45087643099993, 73.68683502800008],
              [-81.45311438699991, 73.66583893400008],
              [-81.44977779899995, 73.66006094000005],
              [-81.43785559799994, 73.64891185100004],
              [-81.42328854099992, 73.63800690300008],
              [-81.40864010299993, 73.63092682500007],
              [-81.34300696499992, 73.61033763200004],
              [-81.25902258999992, 73.56704336100006],
              [-81.24657141799992, 73.55776601800005],
              [-81.22907467399995, 73.53969961100006],
              [-81.21662350199995, 73.51727936400005],
              [-81.21190344999991, 73.49477773600006],
              [-81.20970618399991, 73.48891836100006],
              [-81.20478268099993, 73.48615143400008],
              [-81.19989986899992, 73.48432038000004],
              [-81.19762122299994, 73.48102448100008],
              [-81.19867916599992, 73.47679271000004],
              [-81.2031957669999, 73.46552155200004],
              [-81.20445716099994, 73.46401601800005],
              [-81.19318600199995, 73.43451569200005],
              [-81.18773352799991, 73.42645905200004],
              [-81.18407141799992, 73.41425202000005],
              [-81.18207760299993, 73.36981842700004],
              [-81.18464107999995, 73.35415273600006],
              [-81.20848548099991, 73.33047109600005],
              [-81.21503658799992, 73.32623932500007],
              [-81.21747799399992, 73.32123444200005],
              [-81.21812903599994, 73.29266998900005],
              [-81.1875707669999, 73.26455312700006],
              [-81.13353430899991, 73.24705638200004],
              [-80.64277096299992, 73.16982656500005],
              [-80.61969967399995, 73.16010163000004],
              [-80.57416744699992, 73.12482330900008],
              [-80.54987545499995, 73.09479401200008],
              [-80.57172604099992, 73.06907786700003],
              [-80.59638424399992, 73.04637278900003],
              [-80.58067786399994, 73.02578359600005],
              [-80.59947669199994, 73.01227448100008],
              [-80.64167232999995, 72.99575429900005],
              [-80.6570531889999, 72.97736237200007],
              [-80.64667721299992, 72.97113678600005],
              [-80.63878333199995, 72.96161530200004],
              [-80.63569088399993, 72.95075104400007],
              [-80.63963782499991, 72.94013092700004],
              [-80.64032955599993, 72.92792389500005],
              [-80.6262914699999, 72.91889069200005],
              [-80.59434973899994, 72.90843333500004],
              [-80.56517493399991, 72.89142487200007],
              [-80.53233801999994, 72.85602448100008],
              [-80.50621497299994, 72.84023672100005],
              [-80.46007239499994, 72.82782623900005],
              [-80.36485755099994, 72.81818268400008],
              [-80.32062740799995, 72.80609772300005],
              [-80.30858313699991, 72.79897695500006],
              [-80.27965247299994, 72.77130768400008],
              [-80.27326412699995, 72.76064687700006],
              [-80.26850338399993, 72.74974192900004],
              [-80.26073157499991, 72.74135976800005],
              [-80.24547278599994, 72.73777903900003],
              [-80.26891028599994, 72.72516510600008],
              [-80.30235755099994, 72.71649811400005],
              [-80.3653051419999, 72.70990631700005],
              [-80.37547766799992, 72.70722077000005],
              [-80.40998287699995, 72.68939850500004],
              [-80.45160885299993, 72.67767975500004],
              [-80.46125240799995, 72.67230866100005],
              [-80.47630774599992, 72.65961334800005],
              [-80.49555416599992, 72.64740631700005],
              [-80.5164281889999, 72.63833242400005],
              [-80.53632564999992, 72.63471100500004],
              [-80.55846106699994, 72.62759023600006],
              [-80.55308997299994, 72.61090729400007],
              [-80.52607174399992, 72.57953522300005],
              [-80.75938880099994, 72.52488841400003],
              [-80.90269934799994, 72.46450429900005],
              [-80.9512426419999, 72.45661041900007],
              [-80.98383541599992, 72.44375234600005],
              [-81.04906165299991, 72.38694896000004],
              [-81.08836829299992, 72.37409088700008],
              [-81.09215247299994, 72.37205638200004],
              [-81.10517330599993, 72.35732656500005],
              [-81.11851966099994, 72.34951406500005],
              [-81.13337154899995, 72.34788646000004],
              [-81.14867102799991, 72.34837474200003],
              [-81.16352291599992, 72.34674713700008],
              [-81.17829342399995, 72.34100983300004],
              [-81.1883031889999, 72.33258698100008],
              [-81.19115149599992, 72.32099030200004],
              [-81.18464107999995, 72.30573151200008],
              [-81.20478268099993, 72.29157135600008],
              [-81.23017330599993, 72.28465403900003],
              [-81.28636633999992, 72.27789948100008],
              [-81.38263912699995, 72.24433014500005],
              [-81.31122799399992, 72.24542877800008],
              [-81.24164791599992, 72.26080963700008],
              [-80.88914954299992, 72.43618398600006],
              [-80.86738033799992, 72.44139232000003],
              [-80.81993567599994, 72.44196198100008],
              [-80.79698645699995, 72.44672272300005],
              [-80.7449438139999, 72.46727122600004],
              [-80.55553137899994, 72.51552969000005],
              [-80.53693600199995, 72.51459381700005],
              [-80.51984615799995, 72.50893789300005],
              [-80.50621497299994, 72.49762604400007],
              [-80.50251217399995, 72.48883698100008],
              [-80.49937903599994, 72.46796295800004],
              [-80.49531002499992, 72.46002838700008],
              [-80.49364173099991, 72.45001862200007],
              [-80.50157630099994, 72.43842194200005],
              [-80.52265377499992, 72.41909414300005],
              [-80.5261938139999, 72.40997955900008],
              [-80.52354895699995, 72.39935944200005],
              [-80.51793372299994, 72.38922760600008],
              [-80.51239986899992, 72.38153717700004],
              [-80.5762426419999, 72.37474192900004],
              [-80.63776607999995, 72.35797760600008],
              [-80.75230872299994, 72.30923086100006],
              [-80.83161373599995, 72.26068756700005],
              [-80.85639400899993, 72.23061758000006],
              [-80.83454342399995, 72.20962148600006],
              [-80.86656653599994, 72.19965241100005],
              [-80.97175045499995, 72.20335521000004],
              [-80.75938880099994, 72.14130280200004],
              [-80.73615475199995, 72.14101797100005],
              [-80.71617591099994, 72.13593170800004],
              [-80.67756100199995, 72.12079498900005],
              [-80.61872311099995, 72.11005280200004],
              [-80.57201087099992, 72.09137604400007],
              [-80.56688391799992, 72.08226146000004],
              [-80.58100338399993, 72.06928131700005],
              [-80.60260982999995, 72.06342194200005],
              [-80.68708248599995, 72.07550690300008],
              [-80.75800533799992, 72.10394928600005],
              [-81.02631588399993, 72.09349192900004],
              [-81.01659094999991, 72.09015534100007],
              [-81.00776119699992, 72.08567942900004],
              [-80.99970455599993, 72.08002350500004],
              [-80.99217688699991, 72.07298411700003],
              [-81.01427161399994, 72.06565989800004],
              [-81.08775794199994, 72.05255768400008],
              [-81.05231686099995, 72.04116445500006],
              [-81.00409908799992, 72.03611888200004],
              [-80.95470130099994, 72.03705475500004],
              [-80.84142005099994, 72.05434804900005],
              [-80.80695553299995, 72.04629140800006],
              [-80.80040442599994, 72.01776764500005],
              [-80.80589758999992, 72.01496002800008],
              [-80.81541907499991, 72.01504140800006],
              [-80.82441158799992, 72.01227448100008],
              [-80.82831783799992, 72.00104401200008],
              [-80.82721920499995, 71.99469635600008],
              [-80.82209225199995, 71.98509349200003],
              [-80.82087154899995, 71.97992584800005],
              [-80.82262122299994, 71.96702708500004],
              [-80.82750403599994, 71.95734284100007],
              [-80.84479732999995, 71.93927643400008],
              [-80.87718665299991, 71.92426178600005],
              [-80.96125240799995, 71.90867747600004],
              [-80.98534094999991, 71.88808828300006],
              [-80.83397376199991, 71.90786367400005],
              [-80.76439368399991, 71.93720123900005],
              [-80.75938880099994, 71.98362864800004],
              [-80.66449947799993, 72.00731028900003],
              [-80.56806393099993, 72.01357656500005],
              [-80.54718990799995, 72.01776764500005],
              [-80.5156957669999, 72.02985260600008],
              [-80.45795650899993, 72.03595612200007],
              [-80.39667721299992, 72.05011627800008],
              [-80.35387122299994, 72.07489655200004],
              [-80.3653051419999, 72.11090729400007],
              [-80.38813229099992, 72.12323639500005],
              [-80.4414770169999, 72.13987864800004],
              [-80.46458899599992, 72.15497467700004],
              [-80.48285885299993, 72.18073151200008],
              [-80.47484290299991, 72.19269440300008],
              [-80.4505102199999, 72.19599030200004],
              [-80.41991126199991, 72.19594961100006],
              [-80.40636145699995, 72.19277578300006],
              [-80.38109290299991, 72.17865631700005],
              [-80.36558997299994, 72.17544179900005],
              [-80.35199947799993, 72.17670319200005],
              [-80.33849036399994, 72.17991771000004],
              [-80.31440182199992, 72.18976471600007],
              [-80.30675208199995, 72.19603099200003],
              [-80.30308997299994, 72.20258209800005],
              [-80.29804439999992, 72.20758698100008],
              [-80.28620357999995, 72.20962148600006],
              [-80.27314205599993, 72.20774974200003],
              [-80.26134192599994, 72.20482005400004],
              [-80.24994869699992, 72.20425039300005],
              [-80.23810787699995, 72.20962148600006],
              [-80.27289791599992, 72.23102448100008],
              [-80.30695553299995, 72.25739166900007],
              [-80.28364010299993, 72.28856028900003],
              [-80.24522864499994, 72.29987213700008],
              [-80.20173092399995, 72.29596588700008],
              [-80.16295325399994, 72.28156159100007],
              [-80.0684301419999, 72.21303945500006],
              [-80.02887936099995, 72.20075104400007],
              [-80.01280676999994, 72.18773021000004],
              [-80.00531979099992, 72.18284739800004],
              [-79.99372311099995, 72.17975495000007],
              [-79.9688207669999, 72.17584870000007],
              [-79.93700110599991, 72.16486237200007],
              [-79.67638098899994, 72.12763092700004],
              [-79.69599361899992, 72.14716217700004],
              [-79.73119055899991, 72.15753815300008],
              [-79.83849036399994, 72.16644928600005],
              [-79.93016516799992, 72.19594961100006],
              [-80.03392493399991, 72.24664948100008],
              [-80.04527747299994, 72.25551992400005],
              [-80.06737219999991, 72.27789948100008],
              [-80.15550696499992, 72.31085846600007],
              [-80.16978919199994, 72.32632070500006],
              [-80.16034908799992, 72.33974844000005],
              [-80.04902096299992, 72.39789459800005],
              [-79.9265844389999, 72.40961334800005],
              [-79.87494869699992, 72.42869700700004],
              [-79.86030025899993, 72.44708893400008],
              [-79.86249752499992, 72.46259186400005],
              [-79.86925208199995, 72.47679271000004],
              [-79.86811275899993, 72.49140045800004],
              [-79.8489477199999, 72.50336334800005],
              [-79.81883704299992, 72.50641510600008],
              [-79.78783118399991, 72.50356679900005],
              [-79.7656957669999, 72.49762604400007],
              [-79.78034420499995, 72.48651764500005],
              [-79.78620357999995, 72.48395416900007],
              [-79.77379309799994, 72.47724030200004],
              [-79.7617895169999, 72.47614166900007],
              [-79.75072180899991, 72.47980377800008],
              [-79.7415258449999, 72.48769765800006],
              [-79.73212643099993, 72.48908112200007],
              [-79.71698971299992, 72.48452383000006],
              [-79.70136471299992, 72.47711823100008],
              [-79.69062252499992, 72.47028229400007],
              [-79.71153723899994, 72.45819733300004],
              [-79.74254309799994, 72.44769928600005],
              [-79.76805579299992, 72.43475983300004],
              [-79.77253170499995, 72.41567617400005],
              [-79.75300045499995, 72.40143463700008],
              [-79.65583248599995, 72.37409088700008],
              [-79.66124426999994, 72.37042877800008],
              [-79.66478430899991, 72.36668528900003],
              [-79.66746985599991, 72.36322663000004],
              [-79.67015540299991, 72.36041901200008],
              [-79.64720618399991, 72.35980866100005],
              [-79.62958736899992, 72.35415273600006],
              [-79.61310787699995, 72.34662506700005],
              [-79.5938207669999, 72.34052155200004],
              [-79.60850989499994, 72.33030833500004],
              [-79.62523352799991, 72.30947500200006],
              [-79.63536536399994, 72.29954661700003],
              [-79.65514075399994, 72.28912995000007],
              [-79.73875891799992, 72.26691315300008],
              [-79.75743567599994, 72.25897858300004],
              [-79.77354895699995, 72.24872467700004],
              [-79.78001868399991, 72.23688385600008],
              [-79.76801510299993, 72.22235748900005],
              [-79.74250240799995, 72.21710846600007],
              [-79.7149145169999, 72.21824778900003],
              [-79.69684811099995, 72.22321198100008],
              [-79.71113033799992, 72.23688385600008],
              [-79.6966039699999, 72.24384186400005],
              [-79.64838619699992, 72.25739166900007],
              [-79.62254798099991, 72.27000560100004],
              [-79.60700436099995, 72.27529531500005],
              [-79.58759518099993, 72.27789948100008],
              [-79.54564368399991, 72.27509186400005],
              [-79.52399654899995, 72.26972077000005],
              [-79.50841223899994, 72.26080963700008],
              [-79.50422115799995, 72.25348541900007],
              [-79.4993383449999, 72.23501211100006],
              [-79.49482174399992, 72.22699616100005],
              [-79.47675533799992, 72.20294830900008],
              [-79.4641820949999, 72.19367096600007],
              [-79.45038814999992, 72.19594961100006],
              [-79.44831295499995, 72.20380280200004],
              [-79.4512426419999, 72.21588776200008],
              [-79.45628821499992, 72.22744375200006],
              [-79.46031653599994, 72.23379140800006],
              [-79.46747799399992, 72.24201080900008],
              [-79.48192298099991, 72.26312897300005],
              [-79.49140377499992, 72.27167389500005],
              [-79.50507564999992, 72.27757396000004],
              [-79.53331458199995, 72.28473541900007],
              [-79.54596920499995, 72.29214101800005],
              [-79.51276607999995, 72.29865143400008],
              [-79.49010169199994, 72.30060455900008],
              [-79.49054928299995, 72.30341217700004],
              [-79.49388587099992, 72.30756256700005],
              [-79.49140377499992, 72.31264883000006],
              [-79.48981686099995, 72.31509023600006],
              [-79.48749752499992, 72.32294342700004],
              [-79.48456783799992, 72.32632070500006],
              [-79.47492428299995, 72.32990143400008],
              [-79.45453854099992, 72.33270905200004],
              [-79.42402096299992, 72.34711334800005],
              [-79.38947506399995, 72.35789622600004],
              [-79.36408443899995, 72.37274811400005],
              [-79.3684789699999, 72.39516836100006],
              [-79.33161373599995, 72.40228913000004],
              [-79.28339596299992, 72.39443594000005],
              [-79.12677975199995, 72.34186432500007],
              [-79.09251868399991, 72.32440827000005],
              [-79.04242916599992, 72.28782786700003],
              [-79.02550208199995, 72.28302643400008],
              [-78.97154700399994, 72.28530508000006],
              [-78.95722408799992, 72.28310781500005],
              [-78.9505102199999, 72.27582428600005],
              [-78.96068274599992, 72.26080963700008],
              [-78.97057044199994, 72.25458405200004],
              [-78.97944088399993, 72.25055573100008],
              [-78.98485266799992, 72.24408600500004],
              [-78.98424231699994, 72.23065827000005],
              [-78.97789466099994, 72.22060781500005],
              [-78.94330807199992, 72.19594961100006],
              [-78.98399817599994, 72.17055898600006],
              [-79.00340735599991, 72.15473053600005],
              [-79.01158606699994, 72.13788483300004],
              [-79.01435299399992, 72.12384674700007],
              [-79.03014075399994, 72.08649323100008],
              [-79.03888912699995, 72.07298411700003],
              [-79.0579320949999, 72.06146881700005],
              [-79.11603756399995, 72.03481679900005],
              [-79.14252682199992, 72.00592682500007],
              [-79.20946204299992, 71.98932526200008],
              [-79.23066158799992, 71.97626373900005],
              [-79.17369544199994, 71.95783112200007],
              [-79.15245520699995, 71.95571523600006],
              [-79.1301977199999, 71.95892975500004],
              [-79.08946692599994, 71.97304922100005],
              [-79.06651770699995, 71.97626373900005],
              [-78.71894283799992, 71.92328522300005],
              [-78.5918676419999, 71.87010325700004],
              [-78.54548092399995, 71.86163971600007],
              [-78.50446529899995, 71.87445709800005],
              [-78.52460689999992, 71.88442617400005],
              [-78.56977291599992, 71.89411041900007],
              [-78.59015865799995, 71.90485260600008],
              [-78.59638424399992, 71.91181061400005],
              [-78.5969945949999, 71.91742584800005],
              [-78.59516354099992, 71.92365143400008],
              [-78.59386145699995, 71.93244049700007],
              [-78.60151119699992, 71.94257233300004],
              [-78.61896725199995, 71.94765859600005],
              [-78.76032467399995, 71.95954010600008],
              [-78.8157445949999, 71.97231679900005],
              [-78.86078854099992, 71.99046458500004],
              [-78.89720618399991, 72.00348541900007],
              [-78.91441809799994, 72.01414622600004],
              [-78.91600501199991, 72.03143952000005],
              [-78.90864010299993, 72.04230377800008],
              [-78.89997311099995, 72.04734935100004],
              [-78.89073645699995, 72.05125560100004],
              [-78.88190670499995, 72.05878327000005],
              [-78.87714596299992, 72.06745026200008],
              [-78.87616939999992, 72.07538483300004],
              [-78.87621008999992, 72.08368561400005],
              [-78.8750707669999, 72.09349192900004],
              [-78.87132727799991, 72.09821198100008],
              [-78.86567135299993, 72.10199616100005],
              [-78.86200924399992, 72.10590241100005],
              [-78.87340247299994, 72.13035716400003],
              [-78.87995357999995, 72.15086497600004],
              [-78.8801977199999, 72.15900299700007],
              [-78.8750707669999, 72.16864655200004],
              [-78.85814368399991, 72.17422109600005],
              [-78.83043372299994, 72.17267487200007],
              [-78.50446529899995, 72.10032786700003],
              [-78.46650143099993, 72.07697174700007],
              [-78.43773352799991, 72.04539622600004],
              [-78.38841712099992, 71.97003815300008],
              [-78.38487708199995, 71.94049713700008],
              [-78.20897376199991, 71.82379791900007],
              [-78.12389075399994, 71.81244538000004],
              [-78.04718990799995, 71.78750234600005],
              [-77.95213782499991, 71.77285390800006],
              [-77.90864010299993, 71.77138906500005],
              [-77.90864010299993, 71.77822500200006],
              [-77.94172115799995, 71.78217194200005],
              [-78.00580807199992, 71.80166250200006],
              [-78.06586666599992, 71.80963776200008],
              [-78.17125403599994, 71.85040924700007],
              [-78.22699947799993, 71.89118073100008],
              [-78.24775143099993, 71.90131256700005],
              [-78.29881751199991, 71.91718170800004],
              [-78.31269283799992, 71.92902252800008],
              [-78.30833899599992, 71.94985586100006],
              [-78.28148352799991, 71.95819733300004],
              [-78.17670650899993, 71.97247955900008],
              [-78.15355383999992, 71.97239817900004],
              [-78.13792883999992, 71.96662018400008],
              [-78.13642330599993, 71.96181875200006],
              [-78.13752193899995, 71.95579661700003],
              [-78.1380102199999, 71.94916413000004],
              [-78.13451087099992, 71.94269440300008],
              [-78.09471594999991, 71.92316315300008],
              [-78.03709876199991, 71.90355052300004],
              [-77.98875891799992, 71.87970612200007],
              [-77.97691809799994, 71.84711334800005],
              [-77.93163001199991, 71.82477448100008],
              [-77.8196508449999, 71.80402252800008],
              [-77.7708227199999, 71.77822500200006],
              [-77.75556393099993, 71.75604889500005],
              [-77.74762936099995, 71.75169505400004],
              [-77.74042721299992, 71.78270091400003],
              [-77.73009192599994, 71.79621002800008],
              [-77.7149145169999, 71.80670807500007],
              [-77.69635982999995, 71.81232330900008],
              [-77.71336829299992, 71.81924062700006],
              [-77.73265540299991, 71.82123444200005],
              [-77.77143307199992, 71.81976959800005],
              [-77.78673255099994, 71.82184479400007],
              [-77.81737219999991, 71.83079661700003],
              [-77.85981197799993, 71.83584219000005],
              [-77.88923092399995, 71.84369538000004],
              [-77.91779537699995, 71.85488515800006],
              [-77.94212805899991, 71.86762116100005],
              [-78.01789303299995, 71.91885000200006],
              [-78.09162350199995, 71.94318268400008],
              [-78.10663814999992, 71.95571523600006],
              [-78.09886633999992, 71.96800364800004],
              [-78.12486731699994, 71.97675202000005],
              [-78.18610592399995, 71.98362864800004],
              [-78.25792395699995, 71.97557200700004],
              [-78.29450436099995, 71.97654857000003],
              [-78.32636471299992, 71.99046458500004],
              [-78.33836829299992, 72.00429922100005],
              [-78.35362708199995, 72.05255768400008],
              [-78.36241614499994, 72.06801992400005],
              [-78.37458248599995, 72.08356354400007],
              [-78.38829505099994, 72.09747955900008],
              [-78.40204830599993, 72.10781484600005],
              [-78.4290258449999, 72.11985911700003],
              [-78.4610082669999, 72.12824127800008],
              [-78.55719967399995, 72.13886139500005],
              [-78.62079830599993, 72.15810781500005],
              [-78.68378658799992, 72.16571686400005],
              [-78.84943600199995, 72.21771881700005],
              [-78.8750707669999, 72.23065827000005],
              [-78.80443274599992, 72.24998607000003],
              [-78.76707923099991, 72.26520416900007],
              [-78.75092525899993, 72.28530508000006],
              [-78.7591039699999, 72.29938385600008],
              [-78.77778072799993, 72.30426666900007],
              [-78.79845130099994, 72.30638255400004],
              [-78.81293697799993, 72.31264883000006],
              [-78.81745357999995, 72.32273997600004],
              [-78.81444251199991, 72.33173248900005],
              [-78.8047582669999, 72.33808014500005],
              [-78.78905188699991, 72.34052155200004],
              [-78.73700924399992, 72.33299388200004],
              [-78.71735592399995, 72.33307526200008],
              [-78.6348363919999, 72.35419342700004],
              [-78.60431881399995, 72.35781484600005],
              [-78.56956946499992, 72.35565827000005],
              [-78.53673255099994, 72.34589264500005],
              [-78.51191158799992, 72.32632070500006],
              [-78.52167721299992, 72.32330963700008],
              [-78.52806555899991, 72.31891510600008],
              [-78.53925533799992, 72.30573151200008],
              [-78.52733313699991, 72.29035065300008],
              [-78.52794348899994, 72.27948639500005],
              [-78.53233801999994, 72.26813385600008],
              [-78.53180904899995, 72.25116608300004],
              [-78.52037512899994, 72.23525625200006],
              [-78.5012914699999, 72.22842031500005],
              [-78.47870846299992, 72.22443268400008],
              [-78.45673580599993, 72.21702708500004],
              [-78.45624752499992, 72.19367096600007],
              [-78.42756100199995, 72.17942942900004],
              [-78.39716549399992, 72.17633698100008],
              [-78.39155025899993, 72.18634674700007],
              [-78.39814205599993, 72.19082265800006],
              [-78.41462154899995, 72.19696686400005],
              [-78.42255611899992, 72.20335521000004],
              [-78.42023678299995, 72.20506419500003],
              [-78.41694088399993, 72.21092357000003],
              [-78.41478430899991, 72.21796295800004],
              [-78.41572018099993, 72.22321198100008],
              [-78.42817135299993, 72.23118724200003],
              [-78.47655188699991, 72.24433014500005],
              [-78.45567786399994, 72.28266022300005],
              [-78.45665442599994, 72.29726797100005],
              [-78.47093665299991, 72.31883372600004],
              [-78.40880286399994, 72.32904694200005],
              [-78.02061926999994, 72.27960846600007],
              [-78.00861568899995, 72.26935455900008],
              [-78.02464758999992, 72.25116608300004],
              [-77.94501705599993, 72.26341380400004],
              [-77.91547604099992, 72.26422760600008],
              [-77.78510494699992, 72.24433014500005],
              [-77.69135494699992, 72.21662018400008],
              [-77.65497799399992, 72.19424062700006],
              [-77.66840572799993, 72.16864655200004],
              [-77.65473385299993, 72.16083405200004],
              [-77.63898678299995, 72.15501536700003],
              [-77.62604732999995, 72.14838288000004],
              [-77.62059485599991, 72.13788483300004],
              [-77.62580318899995, 72.12995026200008],
              [-77.65131588399993, 72.11277903900003],
              [-77.66095943899995, 72.10781484600005],
              [-77.66095943899995, 72.10032786700003],
              [-77.63971920499995, 72.10321686400005],
              [-77.61839758999992, 72.11212799700007],
              [-77.59984290299991, 72.12543366100005],
              [-77.58649654899995, 72.14130280200004],
              [-77.60517330599993, 72.15497467700004],
              [-77.61445064999992, 72.16412995000007],
              [-77.62059485599991, 72.17544179900005],
              [-77.58958899599992, 72.18329498900005],
              [-77.29845130099994, 72.18976471600007],
              [-77.25885982999995, 72.18427155200004],
              [-77.18024654899995, 72.16038646000004],
              [-76.99742591099994, 72.13446686400005],
              [-77.13178463399993, 72.17267487200007],
              [-77.27179928299995, 72.19594961100006],
              [-77.54780025899993, 72.19920482000003],
              [-77.62604732999995, 72.22797272300005],
              [-77.6868383449999, 72.23631419500003],
              [-77.82603919199994, 72.27789948100008],
              [-77.94163977799991, 72.29214101800005],
              [-78.00092525899993, 72.31012604400007],
              [-78.22712154899995, 72.33759186400005],
              [-78.53209387899994, 72.42560455900008],
              [-78.5547582669999, 72.44481028900003],
              [-78.55121822799993, 72.46503327000005],
              [-78.54487057199992, 72.48676178600005],
              [-78.55907141799992, 72.51064687700006],
              [-78.53514563699991, 72.51463450700004],
              [-78.45673580599993, 72.55560944200005],
              [-78.45067298099991, 72.56195709800005],
              [-78.44847571499992, 72.57884349200003],
              [-78.44306393099993, 72.58698151200008],
              [-78.42743893099993, 72.59373607000003],
              [-78.40998287699995, 72.59442780200004],
              [-78.3919164699999, 72.59308502800008],
              [-78.37474524599992, 72.59381745000007],
              [-78.18891354099992, 72.65355052300004],
              [-78.02464758999992, 72.67572663000004],
              [-78.01349850199995, 72.67877838700008],
              [-77.98936926999994, 72.69330475500004],
              [-77.97712154899995, 72.69843170800004],
              [-77.79938717399995, 72.70416901200008],
              [-77.72345943899995, 72.72748444200005],
              [-77.65473385299993, 72.73777903900003],
              [-77.60102291599992, 72.75580475500004],
              [-77.24506588449992, 72.74964020400006],
              [-76.88910885299993, 72.74347565300008],
              [-76.78351803299995, 72.72947825700004],
              [-76.68895423099991, 72.69717031500005],
              [-76.67528235599991, 72.68939850500004],
              [-76.66425533799992, 72.67829010600008],
              [-76.65839596299992, 72.66644928600005],
              [-76.66242428299995, 72.65761953300006],
              [-76.68150794199994, 72.65521881700005],
              [-76.65196692599994, 72.63873932500007],
              [-76.19684811099995, 72.59926992400005],
              [-76.16950436099995, 72.59113190300008],
              [-76.15453040299991, 72.57953522300005],
              [-76.15375729099992, 72.56639232000003],
              [-76.15929114499994, 72.55532461100006],
              [-76.16596432199992, 72.54608795800004],
              [-76.16820227799991, 72.53856028900003],
              [-76.16156979099992, 72.52887604400007],
              [-76.12665768099993, 72.49140045800004],
              [-76.10297604099992, 72.47968170800004],
              [-76.08246822799993, 72.47943756700005],
              [-76.03722083199995, 72.49140045800004],
              [-76.04133053299995, 72.50006745000007],
              [-76.07184811099995, 72.54633209800005],
              [-76.06969153599994, 72.55532461100006],
              [-76.03705807199992, 72.56281159100007],
              [-76.0059301419999, 72.58087799700007],
              [-75.99006100199995, 72.58698151200008],
              [-75.93989010299993, 72.59223053600005],
              [-75.73505611899992, 72.58258698100008],
              [-75.64073645699995, 72.56338125200006],
              [-75.56786048099991, 72.55731842700004],
              [-75.54356848899994, 72.55255768400008],
              [-75.47406979099992, 72.52924225500004],
              [-75.19835364499994, 72.49762604400007],
              [-75.19098873599995, 72.49282461100006],
              [-75.19176184799994, 72.48135000200006],
              [-75.19493567599994, 72.46771881700005],
              [-75.19493567599994, 72.45661041900007],
              [-75.19176184799994, 72.45563385600008],
              [-75.16706295499995, 72.43618398600006],
              [-75.15770423099991, 72.42080312700006],
              [-75.15339107999995, 72.41567617400005],
              [-75.07001705599993, 72.35854726800005],
              [-75.05781002499992, 72.33685944200005],
              [-75.04194088399993, 72.32273997600004],
              [-74.96674557199992, 72.27741120000007],
              [-74.94172115799995, 72.25739166900007],
              [-74.99604244699992, 72.23379140800006],
              [-75.01801510299993, 72.21893952000005],
              [-75.02672278599994, 72.21702708500004],
              [-75.03034420499995, 72.21531810100004],
              [-75.02997799399992, 72.21133047100005],
              [-75.02887936099995, 72.20677317900004],
              [-75.02985592399995, 72.20335521000004],
              [-75.06330318899995, 72.18646881700005],
              [-75.24596106699994, 72.12848541900007],
              [-75.28180904899995, 72.12409088700008],
              [-75.47789466099994, 72.14704010600008],
              [-75.63914954299992, 72.14508698100008],
              [-76.02875729099992, 72.08869049700007],
              [-76.0684301419999, 72.07587311400005],
              [-76.08564205599993, 72.05565013200004],
              [-76.09662838399993, 72.03449127800008],
              [-76.12242591099994, 72.01044342700004],
              [-76.15217037699995, 71.98908112200007],
              [-76.17503821499992, 71.97626373900005],
              [-76.28368079299992, 71.94550202000005],
              [-76.31529700399994, 71.92560455900008],
              [-76.35997473899994, 71.88808828300006],
              [-76.40229244699992, 71.87079498900005],
              [-76.41462154899995, 71.86078522300005],
              [-76.38495846299992, 71.85150788000004],
              [-76.35810299399992, 71.85594310100004],
              [-76.33287512899994, 71.87042877800008],
              [-76.28193111899992, 71.91185130400004],
              [-76.25243079299992, 71.92975495000007],
              [-76.18805904899995, 71.95571523600006],
              [-76.11693274599992, 71.97528717700004],
              [-76.08665930899991, 71.98895905200004],
              [-76.05833899599992, 72.01093170800004],
              [-76.03441321499992, 72.04389069200005],
              [-76.02363033799992, 72.05255768400008],
              [-76.00507564999992, 72.05939362200007],
              [-75.65770423099991, 72.12433502800008],
              [-75.51317298099991, 72.12555573100008],
              [-75.24205481699994, 72.08344147300005],
              [-75.22227942599994, 72.06928131700005],
              [-75.24506588399993, 72.05121491100005],
              [-75.29670162699995, 72.03949616100005],
              [-75.5391332669999, 72.01935455900008],
              [-75.58539791599992, 72.00409577000005],
              [-75.60773678299995, 71.99042389500005],
              [-75.62250729099992, 71.97288646000004],
              [-75.63068600199995, 71.95136139500005],
              [-75.63316809799994, 71.92560455900008],
              [-75.63756262899994, 71.91046784100007],
              [-75.6485082669999, 71.90375397300005],
              [-75.66222083199995, 71.90009186400005],
              [-75.67540442599994, 71.89423248900005],
              [-75.68370520699995, 71.88556549700007],
              [-75.69249426999994, 71.86912669500003],
              [-75.70209713399993, 71.86078522300005],
              [-75.69184322799993, 71.84345123900005],
              [-75.70543372299994, 71.82855866100005],
              [-75.74986731699994, 71.80613841400003],
              [-75.76488196499992, 71.79498932500007],
              [-75.80451412699995, 71.75775788000004],
              [-75.87364661399994, 71.72675202000005],
              [-76.02497311099995, 71.71751536700003],
              [-76.09992428299995, 71.70311107000003],
              [-76.09992428299995, 71.69627513200004],
              [-76.05854244699992, 71.69708893400008],
              [-75.99579830599993, 71.70905182500007],
              [-75.9317113919999, 71.70311107000003],
              [-75.86644446499992, 71.70795319200005],
              [-75.83442135299993, 71.71507396000004],
              [-75.80512447799993, 71.72638580900008],
              [-75.78465735599991, 71.73908112200007],
              [-75.71361243399991, 71.79507070500006],
              [-75.67137610599991, 71.81671784100007],
              [-75.6536352199999, 71.83283112200007],
              [-75.64879309799994, 71.84194570500006],
              [-75.64403235599991, 71.86029694200005],
              [-75.64061438699991, 71.86762116100005],
              [-75.63324947799993, 71.87592194200005],
              [-75.59068762899994, 71.90485260600008],
              [-75.57453365799995, 71.91868724200003],
              [-75.56651770699995, 71.93500397300005],
              [-75.57514400899993, 71.95258209800005],
              [-75.57416744699992, 71.96800364800004],
              [-75.55064856699994, 71.98354726800005],
              [-75.50194251199991, 72.00250885600008],
              [-75.46064205599993, 72.00918203300006],
              [-75.32640540299991, 72.00413646000004],
              [-75.29308020699995, 72.00438060100004],
              [-75.2434789699999, 72.01137929900005],
              [-75.19603430899991, 72.02423737200007],
              [-75.16392981699994, 72.04197825700004],
              [-75.15697180899991, 72.05109284100007],
              [-75.14366614499994, 72.07379791900007],
              [-75.13658606699994, 72.08295319200005],
              [-75.12743079299992, 72.09015534100007],
              [-75.10492916599992, 72.10370514500005],
              [-75.09565182199992, 72.11090729400007],
              [-75.06318111899992, 72.12824127800008],
              [-75.02021236899992, 72.13373444200005],
              [-74.97594153599994, 72.13084544500003],
              [-74.89232337099992, 72.11098867400005],
              [-74.60397294799992, 72.09988027550006],
              [-74.31562252499992, 72.08877187700006],
              [-74.27875729099992, 72.08026764500005],
              [-74.25409908799992, 72.08152903900003],
              [-74.2422582669999, 72.07990143400008],
              [-74.23680579299992, 72.07611725500004],
              [-74.22687740799995, 72.06354401200008],
              [-74.22175045499995, 72.05878327000005],
              [-74.17393958199995, 72.03143952000005],
              [-74.13642330599993, 71.99282461100006],
              [-74.11803137899994, 71.96723053600005],
              [-74.12242591099994, 71.95571523600006],
              [-74.19379635299993, 71.92902252800008],
              [-74.20909583199995, 71.91600169500003],
              [-74.20746822799993, 71.91079336100006],
              [-74.19587154899995, 71.90595123900005],
              [-74.18138587099992, 71.89423248900005],
              [-74.17695064999992, 71.88727448100008],
              [-74.17223059799994, 71.87596263200004],
              [-74.17292232999995, 71.86542389500005],
              [-74.19440670499995, 71.85639069200005],
              [-74.21495520699995, 71.83714427300004],
              [-74.25239010299993, 71.82245514500005],
              [-74.26268469999991, 71.81976959800005],
              [-74.31794186099995, 71.81976959800005],
              [-74.41380774599992, 71.80613841400003],
              [-74.4668676419999, 71.80825429900005],
              [-74.49164791599992, 71.81232330900008],
              [-74.51716061099995, 71.81976959800005],
              [-74.52179928299995, 71.82282135600008],
              [-74.52611243399991, 71.82697174700007],
              [-74.53266354099992, 71.83075592700004],
              [-74.54389400899993, 71.83283112200007],
              [-74.55138098899994, 71.83197663000004],
              [-74.56928463399993, 71.82721588700008],
              [-74.57799231699994, 71.82599518400008],
              [-74.57201087099992, 71.81671784100007],
              [-74.55707760299993, 71.80768463700008],
              [-74.55072994699992, 71.79873281500005],
              [-74.57465572799993, 71.79165273600006],
              [-74.62763424399992, 71.78335195500006],
              [-74.65343176999994, 71.77480703300006],
              [-74.66779537699995, 71.76581452000005],
              [-74.69196529899995, 71.74664948100008],
              [-74.70990963399993, 71.73891836100006],
              [-74.74242102799991, 71.73362864800004],
              [-74.81171627499992, 71.73395416900007],
              [-74.84491939999992, 71.72980377800008],
              [-74.90453040299991, 71.71206289300005],
              [-74.92743893099993, 71.70990631700005],
              [-75.05158443899995, 71.72296784100007],
              [-75.35179602799991, 71.70014069200005],
              [-75.37775631399995, 71.69183991100005],
              [-75.39423580599993, 71.67519765800006],
              [-75.08507239499994, 71.70311107000003],
              [-75.00987708199995, 71.69977448100008],
              [-74.97008216099994, 71.69147370000007],
              [-74.94172115799995, 71.67519765800006],
              [-74.93976803299995, 71.66168854400007],
              [-74.95653235599991, 71.65253327000005],
              [-75.16913814999992, 71.60065338700008],
              [-75.26484127499992, 71.56293366100005],
              [-75.41405188699991, 71.52496979400007],
              [-75.39472408799992, 71.51919179900005],
              [-75.31163489499994, 71.54547760600008],
              [-75.20185299399992, 71.55390045800004],
              [-75.04552161399994, 71.60553620000007],
              [-74.92426510299993, 71.61969635600008],
              [-74.89863033799992, 71.62563711100006],
              [-74.88377844999991, 71.63178131700005],
              [-74.87511145699995, 71.63825104400007],
              [-74.85578365799995, 71.65839264500005],
              [-74.84284420499995, 71.66608307500007],
              [-74.79950924399992, 71.68398672100005],
              [-74.71556555899991, 71.70156484600005],
              [-74.69440670499995, 71.70311107000003],
              [-74.68073482999995, 71.69936758000006],
              [-74.66429602799991, 71.69017161700003],
              [-74.64940344999991, 71.67885976800005],
              [-74.64008541599992, 71.66836172100005],
              [-74.63520260299993, 71.65973541900007],
              [-74.63459225199995, 71.65509674700007],
              [-74.66132564999992, 71.62449778900003],
              [-74.67731686099995, 71.61001211100006],
              [-74.69050045499995, 71.60224030200004],
              [-74.72040768099993, 71.59080638200004],
              [-74.73224850199995, 71.58299388200004],
              [-74.74669348899994, 71.57794830900008],
              [-74.7884008449999, 71.57168203300006],
              [-74.79710852799991, 71.56220123900005],
              [-74.80732174399992, 71.55414459800005],
              [-74.83055579299992, 71.54926178600005],
              [-75.0196020169999, 71.54271067900004],
              [-75.05467688699991, 71.52806224200003],
              [-75.07909094999991, 71.51312897300005],
              [-75.13373775899993, 71.49241771000004],
              [-75.15339107999995, 71.46971263200004],
              [-75.12791907499991, 71.47190989800004],
              [-75.10704505099994, 71.48338450700004],
              [-75.08710689999992, 71.49823639500005],
              [-75.06464596299992, 71.51068756700005],
              [-75.02550208199995, 71.52065664300005],
              [-74.84369869699992, 71.52326080900008],
              [-74.82148189999992, 71.51325104400007],
              [-74.82502193899995, 71.49017975500004],
              [-74.8430883449999, 71.47809479400007],
              [-74.90501868399991, 71.45962148600006],
              [-74.92808997299994, 71.45604075700004],
              [-74.81200110599991, 71.45221588700008],
              [-74.74486243399991, 71.44106679900005],
              [-74.71515865799995, 71.41819896000004],
              [-74.7110082669999, 71.40387604400007],
              [-74.70466061099995, 71.39492422100005],
              [-74.70527096299992, 71.38735586100006],
              [-74.7219945949999, 71.37726471600007],
              [-74.73481197799993, 71.37270742400005],
              [-74.76313229099992, 71.36786530200004],
              [-74.77692623599995, 71.36733633000006],
              [-74.78669186099995, 71.36469147300005],
              [-74.79218502499992, 71.35834381700005],
              [-74.79596920499995, 71.35040924700007],
              [-74.8008520169999, 71.34308502800008],
              [-74.83735104099992, 71.32074616100005],
              [-74.86046301999994, 71.30988190300008],
              [-74.87592525899993, 71.30524323100008],
              [-74.88927161399994, 71.29881419500003],
              [-74.9199926419999, 71.27069733300004],
              [-74.93797766799992, 71.26430898600006],
              [-74.94920813699991, 71.26235586100006],
              [-74.97883053299995, 71.25193919500003],
              [-75.00059973899994, 71.24115631700005],
              [-75.00450598899994, 71.23773834800005],
              [-75.00682532499991, 71.23379140800006],
              [-75.01313229099992, 71.22638580900008],
              [-75.03209387899994, 71.21515534100007],
              [-75.07856197799993, 71.20457591400003],
              [-75.09874426999994, 71.19537995000007],
              [-75.07677161399994, 71.18374258000006],
              [-75.04588782499991, 71.18720123900005],
              [-74.89329993399991, 71.24725983300004],
              [-74.85834713399993, 71.26723867400005],
              [-74.82502193899995, 71.29218170800004],
              [-74.75385494699992, 71.32208893400008],
              [-74.71943111899992, 71.34430573100008],
              [-74.67157955599993, 71.36505768400008],
              [-74.63097083199995, 71.39020416900007],
              [-74.62950598899994, 71.41819896000004],
              [-74.66401119699992, 71.44110748900005],
              [-74.70091712099992, 71.45746491100005],
              [-74.73041744699992, 71.47817617400005],
              [-74.74250240799995, 71.51410553600005],
              [-74.72822018099993, 71.54417552300004],
              [-74.69404049399992, 71.55316803600005],
              [-74.65326900899993, 71.55365631700005],
              [-74.61896725199995, 71.55849844000005],
              [-74.60102291599992, 71.57111237200007],
              [-74.53734290299991, 71.64484284100007],
              [-74.53160559799994, 71.65501536700003],
              [-74.52265377499992, 71.66258372600004],
              [-74.50291907499991, 71.66836172100005],
              [-74.41901607999995, 71.67121002800008],
              [-74.31794186099995, 71.70990631700005],
              [-74.2949926419999, 71.72793203300006],
              [-74.28205318899995, 71.73456452000005],
              [-74.1360570949999, 71.74347565300008],
              [-74.12775631399995, 71.74286530200004],
              [-74.11778723899994, 71.74095286700003],
              [-74.10834713399993, 71.73786041900007],
              [-74.1016332669999, 71.73346588700008],
              [-74.09996497299994, 71.72801341400003],
              [-74.10407467399995, 71.72370026200008],
              [-74.10968990799995, 71.71918366100005],
              [-74.11249752499992, 71.71332428600005],
              [-74.12092037699995, 71.68813711100006],
              [-74.14228268099993, 71.66974518400008],
              [-74.17084713399993, 71.65680573100008],
              [-74.23204505099994, 71.63751862200007],
              [-74.24604244699992, 71.62567780200004],
              [-74.24946041599992, 71.60879140800006],
              [-74.24901282499991, 71.58299388200004],
              [-74.23591061099995, 71.56574127800008],
              [-74.20539303299995, 71.55145905200004],
              [-74.17088782499991, 71.54173411700003],
              [-74.14598548099991, 71.53864166900007],
              [-74.19965572799993, 71.58966705900008],
              [-74.21678626199991, 71.62091705900008],
              [-74.1875707669999, 71.63483307500007],
              [-74.14545650899993, 71.63939036700003],
              [-74.11359615799995, 71.65273672100005],
              [-74.08783932199992, 71.67422109600005],
              [-74.06407630099994, 71.70311107000003],
              [-73.99604244699992, 71.75421784100007],
              [-73.90587317599994, 71.77562083500004],
              [-73.72150631399995, 71.77822500200006],
              [-73.70225989499994, 71.77338288000004],
              [-73.68736731699994, 71.75885651200008],
              [-73.68110104099992, 71.74201080900008],
              [-73.68793697799993, 71.72980377800008],
              [-73.68793697799993, 71.72296784100007],
              [-73.68049068899995, 71.72296784100007],
              [-73.65709387899994, 71.75885651200008],
              [-73.62096106699994, 71.77252838700008],
              [-73.59642493399991, 71.76390208500004],
              [-73.60822506399995, 71.73346588700008],
              [-73.62535559799994, 71.71930573100008],
              [-73.64606686099995, 71.70892975500004],
              [-73.77147376199991, 71.66624583500004],
              [-73.79316158799992, 71.66152578300006],
              [-73.80292721299992, 71.65802643400008],
              [-73.80186926999994, 71.64996979400007],
              [-73.79735266799992, 71.64105866100005],
              [-73.79657955599993, 71.63483307500007],
              [-73.80540930899991, 71.62848541900007],
              [-73.81676184799994, 71.62441640800006],
              [-73.87665768099993, 71.61635976800005],
              [-73.88508053299995, 71.60980866100005],
              [-73.88715572799993, 71.59833405200004],
              [-73.89960689999992, 71.57953522300005],
              [-73.91515051999994, 71.57094961100006],
              [-73.95836341099994, 71.55719635600008],
              [-73.97533118399991, 71.54547760600008],
              [-73.98407955599993, 71.53119538000004],
              [-73.99103756399995, 71.51585521000004],
              [-74.00035559799994, 71.50161367400005],
              [-74.01630611899992, 71.49017975500004],
              [-74.00824947799993, 71.48460521000004],
              [-73.99998938699991, 71.48045482000003],
              [-73.99140377499992, 71.47785065300008],
              [-73.98212643099993, 71.47654857000003],
              [-73.9961645169999, 71.46181875200006],
              [-74.02216549399992, 71.46100495000007],
              [-74.07465572799993, 71.46971263200004],
              [-74.10236568899995, 71.46600983300004],
              [-74.15733801999994, 71.45066966400003],
              [-74.1875707669999, 71.44863515800006],
              [-74.19111080599993, 71.44330475500004],
              [-74.26146399599992, 71.43138255400004],
              [-74.31794186099995, 71.41510651200008],
              [-74.29145260299993, 71.40827057500007],
              [-74.2520238919999, 71.41498444200005],
              [-74.18138587099992, 71.43561432500007],
              [-74.02997799399992, 71.44236888200004],
              [-74.02997799399992, 71.43561432500007],
              [-74.04674231699994, 71.42601146000004],
              [-74.06236731699994, 71.41315338700008],
              [-74.0703832669999, 71.39769114800004],
              [-74.06407630099994, 71.38031647300005],
              [-74.06855221299992, 71.36347077000005],
              [-74.06676184799994, 71.34829336100006],
              [-74.07209225199995, 71.33734772300005],
              [-74.12035071499992, 71.33112213700008],
              [-74.18138587099992, 71.31268952000005],
              [-74.18138587099992, 71.30524323100008],
              [-74.12885494699992, 71.30756256700005],
              [-74.10224361899992, 71.30499909100007],
              [-74.09076900899993, 71.29535553600005],
              [-74.09650631399995, 71.28278229400007],
              [-74.10973059799994, 71.27440013200004],
              [-74.12482662699995, 71.26788971600007],
              [-74.15697180899991, 71.24477773600006],
              [-74.21617591099994, 71.21784088700008],
              [-74.2422582669999, 71.20966217700004],
              [-74.2422582669999, 71.20282623900005],
              [-74.18647213399993, 71.21991608300004],
              [-74.00287838399993, 71.32632070500006],
              [-73.99579830599993, 71.33319733300004],
              [-73.99506588399993, 71.34341054900005],
              [-74.00584876199991, 71.35960521000004],
              [-74.00885982999995, 71.37075429900005],
              [-73.95453854099992, 71.43219635600008],
              [-73.93805904899995, 71.43744538000004],
              [-73.92296301999994, 71.44009023600006],
              [-73.90998287699995, 71.44476959800005],
              [-73.89960689999992, 71.45604075700004],
              [-73.89887447799993, 71.46401601800005],
              [-73.90135657499991, 71.47308991100005],
              [-73.90217037699995, 71.48297760600008],
              [-73.89618893099993, 71.49359772300005],
              [-73.87596594999991, 71.50873444200005],
              [-73.86729895699995, 71.51886627800008],
              [-73.86884518099993, 71.52806224200003],
              [-73.86615963399993, 71.53534577000005],
              [-73.84959876199991, 71.54246653900003],
              [-73.81700598899994, 71.55223216400003],
              [-73.75841223899994, 71.58002350500004],
              [-73.72736568899995, 71.58958567900004],
              [-73.68793697799993, 71.59324778900003],
              [-73.65147864499994, 71.59052155200004],
              [-73.62165279899995, 71.58315664300005],
              [-73.5637914699999, 71.55849844000005],
              [-73.57807369699992, 71.54441966400003],
              [-73.60187740799995, 71.53131745000007],
              [-73.61957760299993, 71.51723867400005],
              [-73.61168372299994, 71.48574453300006],
              [-73.62267005099994, 71.46918366100005],
              [-73.65318762899994, 71.44236888200004],
              [-73.63402258999992, 71.43598053600005],
              [-73.60362708199995, 71.40786367400005],
              [-73.58800208199995, 71.40143463700008],
              [-73.58613033799992, 71.39557526200008],
              [-73.63890540299991, 71.36050039300005],
              [-73.60973059799994, 71.36359284100007],
              [-73.55455481699994, 71.37726471600007],
              [-73.52623450399994, 71.38031647300005],
              [-73.51801510299993, 71.38593170800004],
              [-73.50938880099994, 71.41518789300005],
              [-73.50239010299993, 71.42877838700008],
              [-73.48688717399995, 71.43610260600008],
              [-73.46149654899995, 71.44188060100004],
              [-73.43773352799991, 71.44367096600007],
              [-73.42723548099991, 71.43903229400007],
              [-73.42198645699995, 71.42084381700005],
              [-73.40929114499994, 71.40900299700007],
              [-73.39342200399994, 71.39923737200007],
              [-73.37885494699992, 71.38715241100005],
              [-73.42259680899991, 71.37702057500007],
              [-73.44526119699992, 71.37433502800008],
              [-73.46821041599992, 71.37417226800005],
              [-73.48289954299992, 71.37400950700004],
              [-73.49360104099992, 71.37152741100005],
              [-73.50239010299993, 71.36733633000006],
              [-73.50829016799992, 71.36017487200007],
              [-73.5071508449999, 71.35407135600008],
              [-73.50446529899995, 71.34857819200005],
              [-73.50572669199994, 71.34308502800008],
              [-73.52098548099991, 71.33112213700008],
              [-73.57091223899994, 71.31582265800006],
              [-73.63365637899994, 71.28514232000003],
              [-73.66156979099992, 71.26675039300005],
              [-73.68793697799993, 71.24380117400005],
              [-73.68183346299992, 71.23867422100005],
              [-73.68000240799995, 71.23212311400005],
              [-73.68219967399995, 71.22431061400005],
              [-73.68793697799993, 71.21588776200008],
              [-73.68049068899995, 71.20966217700004],
              [-73.68769283799992, 71.20189036700003],
              [-73.70689856699994, 71.18549225500004],
              [-73.71467037699995, 71.17487213700008],
              [-73.71723385299993, 71.16185130400004],
              [-73.71235104099992, 71.13499583500004],
              [-73.71467037699995, 71.11969635600008],
              [-73.74750729099992, 71.08974844000005],
              [-73.85590572799993, 71.07656484600005],
              [-73.89960689999992, 71.05947500200006],
              [-73.88084876199991, 71.05329010600008],
              [-73.86713619699992, 71.05621979400007],
              [-73.85423743399991, 71.06232330900008],
              [-73.83771725199995, 71.06565989800004],
              [-73.76366126199991, 71.06867096600007],
              [-73.72728430899991, 71.07485586100006],
              [-73.69416256399995, 71.08612702000005],
              [-73.66710364499994, 71.10736725500004],
              [-73.6641332669999, 71.12970612200007],
              [-73.66767330599993, 71.15436432500007],
              [-73.66002356699994, 71.18231842700004],
              [-73.65465247299994, 71.18911367400005],
              [-73.63581295499995, 71.20624420800004],
              [-73.63194739499994, 71.21222565300008],
              [-73.62657630099994, 71.22606028900003],
              [-73.62214107999995, 71.23322174700007],
              [-73.60920162699995, 71.24209219000005],
              [-73.55016028599994, 71.27045319200005],
              [-73.54255123599995, 71.27871328300006],
              [-73.53807532499991, 71.28563060100004],
              [-73.53119869699992, 71.29043203300006],
              [-73.50080318899995, 71.29319896000004],
              [-73.46857662699995, 71.30003489800004],
              [-73.45457923099991, 71.30524323100008],
              [-73.43866939999992, 71.31354401200008],
              [-73.42967688699991, 71.32245514500005],
              [-73.4297582669999, 71.33319733300004],
              [-73.44090735599991, 71.34682851800005],
              [-73.31501217399995, 71.34039948100008],
              [-73.25389563699991, 71.33002350500004],
              [-73.1758520169999, 71.30792877800008],
              [-73.16954505099994, 71.30390045800004],
              [-73.16718502499992, 71.29535553600005],
              [-73.16075598899994, 71.29108307500007],
              [-73.12010657499991, 71.29682038000004],
              [-73.08202063699991, 71.28896719000005],
              [-73.06489010299993, 71.28270091400003],
              [-73.04987545499995, 71.27045319200005],
              [-73.22712154899995, 71.24681224200003],
              [-73.27643795499995, 71.22333405200004],
              [-73.26121985599991, 71.21124909100007],
              [-73.2481176419999, 71.19432200700004],
              [-73.24034583199995, 71.17475006700005],
              [-73.24164791599992, 71.15444570500006],
              [-73.26899166599992, 71.12710195500006],
              [-73.29010982999995, 71.09979889500005],
              [-73.32721920499995, 71.08283112200007],
              [-73.42768307199992, 71.05487702000005],
              [-73.45457923099991, 71.03156159100007],
              [-73.43537350199995, 71.02509186400005],
              [-73.38630123599995, 70.99054596600007],
              [-73.37885494699992, 70.98309967700004],
              [-73.37230383999992, 71.00165436400005],
              [-73.40131588399993, 71.02602773600006],
              [-73.39989173099991, 71.04515208500004],
              [-73.37336178299995, 71.05687083500004],
              [-73.28742428299995, 71.07160065300008],
              [-73.26899166599992, 71.08954498900005],
              [-73.26121985599991, 71.10553620000007],
              [-73.24262447799993, 71.11839427300004],
              [-73.20067298099991, 71.14077383000006],
              [-73.18443762899994, 71.15550364800004],
              [-73.17027747299994, 71.17145416900007],
              [-73.17076575399994, 71.17763906500005],
              [-73.18370520699995, 71.19676341400003],
              [-73.18708248599995, 71.20624420800004],
              [-73.16901607999995, 71.22728099200003],
              [-73.12775631399995, 71.23334381700005],
              [-73.05357825399994, 71.22947825700004],
              [-73.03050696499992, 71.23261139500005],
              [-73.01146399599992, 71.24127838700008],
              [-72.99535071499992, 71.25421784100007],
              [-72.98102779899995, 71.27045319200005],
              [-72.9700414699999, 71.28729889500005],
              [-72.96385657499991, 71.30353424700007],
              [-72.96113033799992, 71.31964752800008],
              [-72.96043860599991, 71.33624909100007],
              [-72.96434485599991, 71.35862864800004],
              [-72.97362219999991, 71.37421295800004],
              [-72.98485266799992, 71.38873932500007],
              [-72.99461829299992, 71.40766022300005],
              [-72.93565833199995, 71.41937897300005],
              [-72.8118383449999, 71.41828034100007],
              [-72.75507564999992, 71.43561432500007],
              [-72.76854407499991, 71.46051666900007],
              [-72.77778072799993, 71.47182851800005],
              [-72.78949947799993, 71.47654857000003],
              [-72.80256100199995, 71.47980377800008],
              [-72.81794186099995, 71.48802317900004],
              [-72.83104407499991, 71.49900950700004],
              [-72.83759518099993, 71.51068756700005],
              [-72.82416744699992, 71.51447174700007],
              [-72.76866614499994, 71.51845937700006],
              [-72.63898678299995, 71.54547760600008],
              [-72.61823482999995, 71.57343170800004],
              [-72.61327063699991, 71.58803945500006],
              [-72.61164303299995, 71.61001211100006],
              [-72.60863196499992, 71.62091705900008],
              [-72.60077877499992, 71.63641998900005],
              [-72.58954830599993, 71.65009186400005],
              [-72.58433997299994, 71.65534088700008],
              [-72.54942786399994, 71.66510651200008],
              [-72.51117916599992, 71.65884023600006],
              [-72.47260494699992, 71.64728424700007],
              [-72.19635982999992, 71.61078522350007],
              [-71.92011471299992, 71.57428620000007],
              [-71.78266354099992, 71.53461334800005],
              [-71.58189856699994, 71.51508209800005],
              [-71.54430091099994, 71.50511302300004],
              [-71.52794348899994, 71.49054596600007],
              [-71.51288814999992, 71.48875560100004],
              [-71.41869055899991, 71.45604075700004],
              [-71.42760169199994, 71.44049713700008],
              [-71.43297278599994, 71.43561432500007],
              [-71.38617916599992, 71.41469961100006],
              [-71.28754635299993, 71.38434479400007],
              [-71.14521236899992, 71.29417552300004],
              [-71.11705481699994, 71.27045319200005],
              [-71.1543676419999, 71.24404531500005],
              [-71.24018307199992, 71.21515534100007],
              [-71.29255123599995, 71.18423086100006],
              [-71.32945716099994, 71.17401764500005],
              [-71.34357662699995, 71.16803620000007],
              [-71.38451087099992, 71.13397858300004],
              [-71.42247473899994, 71.09223053600005],
              [-71.44501705599993, 71.07347239800004],
              [-71.47052975199995, 71.06565989800004],
              [-71.61994381399995, 71.07196686400005],
              [-71.71088619699992, 71.09686920800004],
              [-71.86095130099994, 71.11347077000005],
              [-71.89012610599991, 71.11139557500007],
              [-71.99286861899992, 71.08909739800004],
              [-72.04511471299992, 71.08478424700007],
              [-72.06981360599991, 71.07868073100008],
              [-72.09813391799992, 71.06696198100008],
              [-72.11217200399994, 71.05817291900007],
              [-72.11823482999995, 71.04857005400004],
              [-72.11351477799991, 71.04022858300004],
              [-72.10492916599992, 71.02985260600008],
              [-72.10029049399992, 71.02098216400003],
              [-72.10737057199992, 71.01727936400005],
              [-72.11860104099992, 71.01410553600005],
              [-72.13072669199994, 71.00678131700005],
              [-72.17247473899994, 70.97150299700007],
              [-72.18244381399995, 70.96576569200005],
              [-72.26915442599994, 70.95636627800008],
              [-72.29735266799992, 70.94708893400008],
              [-72.32367916599992, 70.92788320500006],
              [-72.31126868399991, 70.91144440300008],
              [-72.32001705599993, 70.89716217700004],
              [-72.33861243399991, 70.88593170800004],
              [-72.35627193899995, 70.87872955900008],
              [-72.74848385299993, 70.82733795800004],
              [-72.77611243399991, 70.81801992400005],
              [-72.47687740799995, 70.83783600500004],
              [-72.30317135299993, 70.87323639500005],
              [-72.27643795499995, 70.87132396000004],
              [-72.23163814999992, 70.85639069200005],
              [-72.18464107999995, 70.84886302300004],
              [-72.17206783799992, 70.84467194200005],
              [-72.1653539699999, 70.83974844000005],
              [-72.16417395699995, 70.83038971600007],
              [-72.16901607999995, 70.82680898600006],
              [-72.17650305899991, 70.82514069200005],
              [-72.18342037699995, 70.82172272300005],
              [-72.19762122299994, 70.81171295800004],
              [-72.2735082669999, 70.77513255400004],
              [-72.31672115799995, 70.76015859600005],
              [-72.33726966099994, 70.75779857000003],
              [-72.32917232999995, 70.74298737200007],
              [-72.32380123599995, 70.73615143400008],
              [-72.31623287699995, 70.72988515800006],
              [-72.36461341099994, 70.68891022300005],
              [-72.38434811099995, 70.68048737200007],
              [-72.4903051419999, 70.65143463700008],
              [-72.58250891799992, 70.64618561400005],
              [-72.62470455599993, 70.63369375200006],
              [-72.60863196499992, 70.62799713700008],
              [-72.59227454299992, 70.62970612200007],
              [-72.57502193899995, 70.63336823100008],
              [-72.55638587099992, 70.63369375200006],
              [-72.56135006399995, 70.62864817900004],
              [-72.57066809799994, 70.61318594000005],
              [-72.55134029899995, 70.61273834800005],
              [-72.53168697799993, 70.61709219000005],
              [-72.51353919199994, 70.62543366100005],
              [-72.49836178299995, 70.63711172100005],
              [-72.47797604099992, 70.64642975500004],
              [-72.3919164699999, 70.65412018400008],
              [-72.35716712099992, 70.66303131700005],
              [-72.32770748599995, 70.67487213700008],
              [-72.30113684799994, 70.69013092700004],
              [-72.27521725199995, 70.70937734600005],
              [-72.23395748599995, 70.74925364800004],
              [-72.21051998599995, 70.76463450700004],
              [-71.95311438699991, 70.79132721600007],
              [-71.82164466099994, 70.82721588700008],
              [-71.72948157499991, 70.83803945500006],
              [-71.59064693899995, 70.87323639500005],
              [-71.32282467399995, 70.88719310100004],
              [-71.29881751199991, 70.88532135600008],
              [-71.21503658799992, 70.85529205900008],
              [-71.19648189999992, 70.85276927300004],
              [-71.17438717399995, 70.85716380400004],
              [-71.18138587099992, 70.86737702000005],
              [-71.25422115799995, 70.90021393400008],
              [-71.27196204299992, 70.90574778900003],
              [-71.28901119699992, 70.90802643400008],
              [-71.28400631399995, 70.92267487200007],
              [-71.27436275899993, 70.93211497600004],
              [-71.2473852199999, 70.94586823100008],
              [-71.23456783799992, 70.95465729400007],
              [-71.22944088399993, 70.96222565300008],
              [-71.2266332669999, 70.97101471600007],
              [-71.22069251199991, 70.98309967700004],
              [-71.20185299399992, 71.00698476800005],
              [-71.17890377499992, 71.02509186400005],
              [-71.15094967399995, 71.03774648600006],
              [-70.98298092399995, 71.07111237200007],
              [-70.86164303299995, 71.10907623900005],
              [-70.78722083199995, 71.11456940300008],
              [-70.71357174399992, 71.10394928600005],
              [-70.63788814999992, 71.07868073100008],
              [-70.62144934799994, 71.06932200700004],
              [-70.58637447799993, 71.03461334800005],
              [-70.58075924399992, 71.02533600500004],
              [-70.57738196499992, 71.00214264500005],
              [-70.57270260299993, 70.99363841400003],
              [-70.53083248599995, 70.95921458500004],
              [-70.51642818899995, 70.93707916900007],
              [-70.52118893099993, 70.91425202000005],
              [-70.54401607999995, 70.89744700700004],
              [-70.7129613919999, 70.83974844000005],
              [-70.72508704299992, 70.83026764500005],
              [-70.73814856699994, 70.81012604400007],
              [-70.74775143099993, 70.79877350500004],
              [-70.74901282499991, 70.75478750200006],
              [-70.80553137899994, 70.72435130400004],
              [-71.06745357999995, 70.67621491100005],
              [-71.10338294199994, 70.66095612200007],
              [-71.12067623599995, 70.64227936400005],
              [-71.13023841099994, 70.62250397300005],
              [-71.14146887899994, 70.60443756700005],
              [-71.16364498599995, 70.59076569200005],
              [-71.2122289699999, 70.58185455900008],
              [-71.26402747299994, 70.58356354400007],
              [-71.52623450399994, 70.62051015800006],
              [-71.57636471299992, 70.61318594000005],
              [-71.58771725199995, 70.60895416900007],
              [-71.59605872299994, 70.60301341400003],
              [-71.59723873599995, 70.59442780200004],
              [-71.58690344999991, 70.58218008000006],
              [-71.57929439999992, 70.56952545800004],
              [-71.5833227199999, 70.55768463700008],
              [-71.59333248599995, 70.54791901200008],
              [-71.60362708199995, 70.54144928600005],
              [-71.72716223899994, 70.49705638200004],
              [-71.73778235599991, 70.48932526200008],
              [-71.74156653599994, 70.48175690300008],
              [-71.74083411399994, 70.45954010600008],
              [-71.74799557199992, 70.44887929900005],
              [-71.76508541599992, 70.44367096600007],
              [-71.88935299399992, 70.44245026200008],
              [-71.93248450399994, 70.43675364800004],
              [-71.96735592399995, 70.42137278900003],
              [-71.93744869699992, 70.41469961100006],
              [-71.81285559799994, 70.43500397300005],
              [-71.74144446499992, 70.42820872600004],
              [-71.72984778599994, 70.42548248900005],
              [-71.7285863919999, 70.41852448100008],
              [-71.74498450399994, 70.35712311400005],
              [-71.76976477799991, 70.32811107000003],
              [-71.8059789699999, 70.30975983300004],
              [-71.85069739499994, 70.29783763200004],
              [-71.82371985599991, 70.29368724200003],
              [-71.78791256399995, 70.30117422100005],
              [-71.75352942599994, 70.31464264500005],
              [-71.6719457669999, 70.37299225500004],
              [-71.67552649599992, 70.39057038000004],
              [-71.66584225199995, 70.41453685100004],
              [-71.63780676999994, 70.45612213700008],
              [-71.64325924399992, 70.45929596600007],
              [-71.65196692599994, 70.46645742400005],
              [-71.65888424399992, 70.46979401200008],
              [-71.55821692599994, 70.51471588700008],
              [-71.50804602799991, 70.54564036700003],
              [-71.51488196499992, 70.57904694200005],
              [-71.48509680899991, 70.58539459800005],
              [-71.45160885299993, 70.58661530200004],
              [-71.41877193899995, 70.58234284100007],
              [-71.39142818899995, 70.57160065300008],
              [-71.43976803299995, 70.55853913000004],
              [-71.4199926419999, 70.55247630400004],
              [-71.34325110599991, 70.56537506700005],
              [-71.3137914699999, 70.56220123900005],
              [-71.25287838399993, 70.54808177300004],
              [-71.22382564999992, 70.54486725500004],
              [-71.2031957669999, 70.54507070500006],
              [-71.18317623599995, 70.54311758000006],
              [-71.16889400899993, 70.53510163000004],
              [-71.16547604099992, 70.51764557500007],
              [-71.24201412699995, 70.41819896000004],
              [-71.26020260299993, 70.38776276200008],
              [-71.27501380099994, 70.34251536700003],
              [-71.29149329299992, 70.33576080900008],
              [-71.31000729099992, 70.33136627800008],
              [-71.32310950399994, 70.31834544500003],
              [-71.32001705599993, 70.30487702000005],
              [-71.30565344999991, 70.29189687700006],
              [-71.27464758999992, 70.26992422100005],
              [-71.3125707669999, 70.22581614800004],
              [-71.32506262899994, 70.21686432500007],
              [-71.37153072799993, 70.19546133000006],
              [-71.3672582669999, 70.18036530200004],
              [-71.37714596299992, 70.16974518400008],
              [-71.39427649599992, 70.16339752800008],
              [-71.41185462099992, 70.16132233300004],
              [-71.41877193899995, 70.15692780200004],
              [-71.4348852199999, 70.13515859600005],
              [-71.43976803299995, 70.12661367400005],
              [-71.43183346299992, 70.13174062700006],
              [-71.42406165299991, 70.13397858300004],
              [-71.40501868399991, 70.13397858300004],
              [-71.42039954299992, 70.11619700700004],
              [-71.50121008999992, 70.08559804900005],
              [-71.51288814999992, 70.07387929900005],
              [-71.53510494699992, 70.03961823100008],
              [-71.54222571499992, 70.02411530200004],
              [-71.52265377499992, 70.02789948100008],
              [-71.5078832669999, 70.03839752800008],
              [-71.48139400899993, 70.06513092700004],
              [-71.45673580599993, 70.08136627800008],
              [-71.35297604099992, 70.12327708500004],
              [-71.34003658799992, 70.13279857000003],
              [-71.33222408799992, 70.14606354400007],
              [-71.32310950399994, 70.16754791900007],
              [-71.30968176999994, 70.18878815300008],
              [-71.29283606699994, 70.20278554900005],
              [-71.24799557199992, 70.22211334800005],
              [-71.24583899599992, 70.23358795800004],
              [-71.21698971299992, 70.26032135600008],
              [-71.21007239499994, 70.27122630400004],
              [-71.2168676419999, 70.27684153900003],
              [-71.22789466099994, 70.28266022300005],
              [-71.2337133449999, 70.29413483300004],
              [-71.22834225199995, 70.30463288000004],
              [-71.19273841099994, 70.33197663000004],
              [-71.19526119699992, 70.33193594000005],
              [-71.19505774599992, 70.33954498900005],
              [-71.19273841099994, 70.35309479400007],
              [-71.1797582669999, 70.36676666900007],
              [-71.16633053299995, 70.38641998900005],
              [-71.15741939999992, 70.39655182500007],
              [-71.14838619699992, 70.40086497600004],
              [-71.14362545499995, 70.40574778900003],
              [-71.13316809799994, 70.42967357000003],
              [-71.12791907499991, 70.43842194200005],
              [-71.07555091099994, 70.49066803600005],
              [-71.06244869699992, 70.51072825700004],
              [-71.06989498599995, 70.51764557500007],
              [-71.05060787699995, 70.52383047100005],
              [-71.00458736899992, 70.52387116100005],
              [-70.98729407499991, 70.53123607000003],
              [-71.00019283799992, 70.53742096600007],
              [-71.05622311099995, 70.55170319200005],
              [-71.04267330599993, 70.56964752800008],
              [-71.02647864499994, 70.57973867400005],
              [-71.01292883999992, 70.59198639500005],
              [-71.00719153599994, 70.61660390800006],
              [-70.98534094999991, 70.63369375200006],
              [-70.84333248599995, 70.64793528900003],
              [-70.69286048099991, 70.70376211100006],
              [-70.64447994699992, 70.71198151200008],
              [-70.62950598899994, 70.71800364800004],
              [-70.61876380099994, 70.72479889500005],
              [-70.61738033799992, 70.72988515800006],
              [-70.55663001199991, 70.74188873900005],
              [-70.51349850199995, 70.74184804900005],
              [-70.49388587099992, 70.74697500200006],
              [-70.44591223899994, 70.76894765800006],
              [-70.39765377499992, 70.78449127800008],
              [-70.23627682199992, 70.80097077000005],
              [-69.91498775899993, 70.87986888200004],
              [-69.87592525899993, 70.88434479400007],
              [-69.81895911399994, 70.87763092700004],
              [-69.79881751199991, 70.87303294500003],
              [-69.78168697799993, 70.86615631700005],
              [-69.77448482999995, 70.85618724200003],
              [-69.77769934799994, 70.84772370000007],
              [-69.79173743399991, 70.83954498900005],
              [-69.7949926419999, 70.82884349200003],
              [-69.80724036399994, 70.81484609600005],
              [-69.86754309799994, 70.77643463700008],
              [-69.95653235599991, 70.73452383000006],
              [-70.20575924399992, 70.65668366100005],
              [-70.28221594999991, 70.64248281500005],
              [-70.40807044199994, 70.64256419500003],
              [-70.44867916599992, 70.63519928600005],
              [-70.48021399599992, 70.61318594000005],
              [-70.46727454299992, 70.60106028900003],
              [-70.46080481699994, 70.59613678600005],
              [-70.45295162699995, 70.59271881700005],
              [-70.45128333199995, 70.57221100500004],
              [-70.40534420499995, 70.54083893400008],
              [-70.40107174399992, 70.52753327000005],
              [-70.42145748599995, 70.51264069200005],
              [-70.49449622299994, 70.48965078300006],
              [-70.49449622299994, 70.48285553600005],
              [-70.47443600199995, 70.47772858300004],
              [-70.45348059799994, 70.47874583500004],
              [-70.36188717399995, 70.50047435100004],
              [-70.30951900899993, 70.50332265800006],
              [-70.32896887899994, 70.53851959800005],
              [-70.35484778599994, 70.56004466400003],
              [-70.38373775899993, 70.57900625200006],
              [-70.41197669199994, 70.60635000200006],
              [-70.39362545499995, 70.61469147300005],
              [-70.37397213399993, 70.61684804900005],
              [-70.3294164699999, 70.61318594000005],
              [-70.19249426999994, 70.62002187700006],
              [-70.10248775899993, 70.61172109600005],
              [-70.07616126199991, 70.61318594000005],
              [-70.06232662699995, 70.63182200700004],
              [-70.05304928299995, 70.63515859600005],
              [-70.04881751199991, 70.61660390800006],
              [-70.04088294199994, 70.59662506700005],
              [-70.02183997299994, 70.60936107000003],
              [-69.97992916599992, 70.65412018400008],
              [-69.95673580599993, 70.66144440300008],
              [-69.90135657499991, 70.66742584800005],
              [-69.85594641799992, 70.68968333500004],
              [-69.80125891799992, 70.68309153900003],
              [-69.77448482999995, 70.68891022300005],
              [-69.78331458199995, 70.69159577000005],
              [-69.8086645169999, 70.70258209800005],
              [-69.78217525899993, 70.71918366100005],
              [-69.75767981699994, 70.71409739800004],
              [-69.71239173099991, 70.68891022300005],
              [-69.68183346299992, 70.68537018400008],
              [-69.66657467399995, 70.69257233300004],
              [-69.65888424399992, 70.70819733300004],
              [-69.65099036399994, 70.72988515800006],
              [-69.63731848899994, 70.74868398600006],
              [-69.61615963399993, 70.76361725500004],
              [-69.59028072799993, 70.77342357000003],
              [-69.47345943899995, 70.79132721600007],
              [-69.40453040299991, 70.79132721600007],
              [-69.40855872299994, 70.78091054900005],
              [-69.41075598899994, 70.77704498900005],
              [-69.27232825399994, 70.78660716400003],
              [-69.20295162699995, 70.77936432500007],
              [-69.12669837099992, 70.73285553600005],
              [-69.09784908799992, 70.72308991100005],
              [-68.73005123599992, 70.65369293850006],
              [-68.36225338399993, 70.58429596600007],
              [-68.33771725199995, 70.57196686400005],
              [-68.29723059799994, 70.55853913000004],
              [-68.29051673099991, 70.55377838700008],
              [-68.2844945949999, 70.54242584800005],
              [-68.28071041599992, 70.52879466400003],
              [-68.28050696499992, 70.51764557500007],
              [-68.28681393099993, 70.50653717700004],
              [-68.29780025899993, 70.49689362200007],
              [-68.34662838399993, 70.47044505400004],
              [-68.36091061099995, 70.46515534100007],
              [-68.37328040299991, 70.46295807500007],
              [-68.38459225199995, 70.45750560100004],
              [-68.39338131399995, 70.43366120000007],
              [-68.40400143099993, 70.42820872600004],
              [-68.43537350199995, 70.42243073100008],
              [-68.44477291599992, 70.40818919500003],
              [-68.44737708199995, 70.39020416900007],
              [-68.45860755099994, 70.37299225500004],
              [-68.48737545499995, 70.36920807500007],
              [-68.52875729099992, 70.37836334800005],
              [-68.56598873599995, 70.39447663000004],
              [-68.58214270699995, 70.41111888200004],
              [-68.57709713399993, 70.42121002800008],
              [-68.55418860599991, 70.43500397300005],
              [-68.54804439999992, 70.44183991100005],
              [-68.55219479099992, 70.46141185100004],
              [-68.56940670499995, 70.46816640800006],
              [-68.59129798099991, 70.46698639500005],
              [-68.60944576699995, 70.46295807500007],
              [-68.6301977199999, 70.45514557500007],
              [-68.65587317599994, 70.44114817900004],
              [-68.67296301999994, 70.42348867400005],
              [-68.66783606699994, 70.40436432500007],
              [-68.65290279899995, 70.38255442900004],
              [-68.65278072799993, 70.36180247600004],
              [-68.66441809799994, 70.34418366100005],
              [-68.68455969999991, 70.33197663000004],
              [-68.7200414699999, 70.32233307500007],
              [-68.83665930899991, 70.31427643400008],
              [-68.90538489499994, 70.29694245000007],
              [-69.01378333199995, 70.30487702000005],
              [-69.09727942599994, 70.28213125200006],
              [-69.13569088399993, 70.27985260600008],
              [-69.21247311099995, 70.28424713700008],
              [-69.23131262899994, 70.28192780200004],
              [-69.27289791599992, 70.27216217700004],
              [-69.31244869699992, 70.26813385600008],
              [-69.36359615799995, 70.25690338700008],
              [-69.47020423099991, 70.24811432500007],
              [-69.48713131399995, 70.24017975500004],
              [-69.50458736899992, 70.22516510600008],
              [-69.54454505099994, 70.21889883000006],
              [-69.61689205599993, 70.21588776200008],
              [-69.72455807199992, 70.18040599200003],
              [-69.80833899599992, 70.16669342700004],
              [-69.82225501199991, 70.16132233300004],
              [-69.83263098899994, 70.15277741100005],
              [-69.83617102799991, 70.14443594000005],
              [-69.83788001199991, 70.13572825700004],
              [-69.84276282499991, 70.12661367400005],
              [-69.86738033799992, 70.10773346600007],
              [-69.90094967399995, 70.09324778900003],
              [-69.93651282499991, 70.08348216400003],
              [-70.08861243399991, 70.06826406500005],
              [-70.11640377499992, 70.05459219000005],
              [-70.15660559799994, 70.04547760600008],
              [-70.17747962099992, 70.03253815300008],
              [-70.17992102799991, 70.02045319200005],
              [-70.15123450399994, 70.01675039300005],
              [-70.11754309799994, 70.02545807500007],
              [-70.06220455599993, 70.05780670800004],
              [-70.02769934799994, 70.06513092700004],
              [-69.95091712099992, 70.05923086100006],
              [-69.87690182199992, 70.04401276200008],
              [-69.85594641799992, 70.03253815300008],
              [-69.82905025899993, 70.01190827000005],
              [-69.81489010299993, 69.99201080900008],
              [-69.83222408799992, 69.98314036700003],
              [-70.00059973899994, 69.99624258000006],
              [-70.03681393099993, 69.99115631700005],
              [-70.11359615799995, 69.97089264500005],
              [-70.14439856699994, 69.96954987200007],
              [-70.19245357999995, 69.95750560100004],
              [-70.20917721299992, 69.94871653900003],
              [-70.21698971299992, 69.94790273600006],
              [-70.22358150899993, 69.94562409100007],
              [-70.22638912699995, 69.93846263200004],
              [-70.22459876199991, 69.93447500200006],
              [-70.22114010299993, 69.92959219000005],
              [-70.21849524599992, 69.92462799700007],
              [-70.21955318899995, 69.92047760600008],
              [-70.2415258449999, 69.90729401200008],
              [-70.26899166599992, 69.90021393400008],
              [-70.32258053299995, 69.89378489800004],
              [-70.34272213399993, 69.88837311400005],
              [-70.36786861899992, 69.87250397300005],
              [-70.38463294199994, 69.86587148600006],
              [-70.39667721299992, 69.86432526200008],
              [-70.43553626199991, 69.86587148600006],
              [-70.44603430899991, 69.86351146000004],
              [-70.47276770699995, 69.84540436400005],
              [-70.37092037699995, 69.84430573100008],
              [-70.33625240799995, 69.85285065300008],
              [-70.08979244699992, 69.95575592700004],
              [-70.05333411399994, 69.96409739800004],
              [-69.93317623599995, 69.96865469000005],
              [-69.90961666599992, 69.96556224200003],
              [-69.87633216099994, 69.95156484600005],
              [-69.85395260299993, 69.95368073100008],
              [-69.81232662699995, 69.96271393400008],
              [-69.78473873599995, 69.96523672100005],
              [-69.75849361899992, 69.97288646000004],
              [-69.74115963399993, 69.98554108300004],
              [-69.74034583199995, 70.00307851800005],
              [-69.7512914699999, 70.01561107000003],
              [-69.76500403599994, 70.02179596600007],
              [-69.77924557199992, 70.02627187700006],
              [-69.79157467399995, 70.03375885600008],
              [-69.80150305899991, 70.04389069200005],
              [-69.80406653599994, 70.04881419500003],
              [-69.80182857999995, 70.06826406500005],
              [-69.79255123599995, 70.08502838700008],
              [-69.77021236899992, 70.10114166900007],
              [-69.71983801999994, 70.12661367400005],
              [-69.68317623599995, 70.13959381700005],
              [-69.20885169199994, 70.19293854400007],
              [-69.1575414699999, 70.18866608300004],
              [-69.07933508999992, 70.16864655200004],
              [-69.03742428299995, 70.16766998900005],
              [-69.01353919199994, 70.18866608300004],
              [-69.11168372299994, 70.20136139500005],
              [-69.1301977199999, 70.21588776200008],
              [-69.10016842399995, 70.22011953300006],
              [-68.99986731699994, 70.20229726800005],
              [-68.95697994699992, 70.19928620000007],
              [-68.70653235599991, 70.20941803600005],
              [-68.67833411399994, 70.20229726800005],
              [-68.67548580599993, 70.19708893400008],
              [-68.67194576699995, 70.18773021000004],
              [-68.66722571499992, 70.17890045800004],
              [-68.65599524599992, 70.17194245000007],
              [-68.65094967399995, 70.16453685100004],
              [-68.64362545499995, 70.14704010600008],
              [-68.76032467399995, 70.10602448100008],
              [-68.74677486899992, 70.09100983300004],
              [-68.73237057199992, 70.07880280200004],
              [-68.79059811099995, 70.04116445500006],
              [-68.86493893099993, 70.01943594000005],
              [-69.08519446499992, 69.98505280200004],
              [-69.12226314999992, 69.97504303600005],
              [-69.15741939999992, 69.95270416900007],
              [-69.1934301419999, 69.93768952000005],
              [-69.2200414699999, 69.93048737200007],
              [-69.24889075399994, 69.91176992400005],
              [-69.28547115799995, 69.90253327000005],
              [-69.30870520699995, 69.89044830900008],
              [-69.37458248599995, 69.84292226800005],
              [-69.40819251199991, 69.82925039300005],
              [-69.44428463399993, 69.82123444200005],
              [-69.48029537699995, 69.81867096600007],
              [-69.71056067599994, 69.84463125200006],
              [-69.75059973899994, 69.84247467700004],
              [-69.78815670499995, 69.83234284100007],
              [-69.84235592399995, 69.80670807500007],
              [-69.86017818899995, 69.79417552300004],
              [-69.86933346299992, 69.78034088700008],
              [-69.88194739499994, 69.74982330900008],
              [-69.89057369699992, 69.73615143400008],
              [-69.9102270169999, 69.72150299700007],
              [-69.95771236899992, 69.70307038000004],
              [-69.97651119699992, 69.69114817900004],
              [-69.99115963399993, 69.67743561400005],
              [-69.99559485599991, 69.67133209800005],
              [-70.00043697799993, 69.66107819200005],
              [-70.00255286399994, 69.65151601800005],
              [-70.0032445949999, 69.63532135600008],
              [-70.0078832669999, 69.62628815300008],
              [-69.98204505099994, 69.61782461100006],
              [-69.96373450399994, 69.63597239800004],
              [-69.94945227799991, 69.66132233300004],
              [-69.93553626199991, 69.67405833500004],
              [-69.90387936099995, 69.68097565300008],
              [-69.86522376199991, 69.69818756700005],
              [-69.83002682199992, 69.72064850500004],
              [-69.8086645169999, 69.74298737200007],
              [-69.80976314999992, 69.75141022300005],
              [-69.81415768099993, 69.76284414300005],
              [-69.81407630099994, 69.77285390800006],
              [-69.79084225199995, 69.78139883000006],
              [-69.76317298099991, 69.80019765800006],
              [-69.74689693899995, 69.80438873900005],
              [-69.60301673099991, 69.81159088700008],
              [-69.55536861899992, 69.80438873900005],
              [-69.50385494699992, 69.78620026200008],
              [-69.48338782499991, 69.78388092700004],
              [-69.39061438699991, 69.78388092700004],
              [-69.36668860599991, 69.79022858300004],
              [-69.21165930899991, 69.88768138200004],
              [-69.16112219999991, 69.89679596600007],
              [-69.10289466099994, 69.92047760600008],
              [-69.01353919199994, 69.93475983300004],
              [-68.94994055899991, 69.95270416900007],
              [-68.92817135299993, 69.95526764500005],
              [-68.77940833199995, 69.95164622600004],
              [-68.70588131399995, 69.93402741100005],
              [-68.69513912699995, 69.93569570500006],
              [-68.69139563699991, 69.94839101800005],
              [-68.67756100199995, 69.94424062700006],
              [-68.66327877499992, 69.94188060100004],
              [-68.64915930899991, 69.94285716400003],
              [-68.63617916599992, 69.94839101800005],
              [-68.64281165299991, 69.95042552300004],
              [-68.64899654899995, 69.95307038000004],
              [-68.65562903599994, 69.95514557500007],
              [-68.66413326699995, 69.95526764500005],
              [-68.65900631399995, 69.96552155200004],
              [-68.6575414699999, 69.97435130400004],
              [-68.66120357999995, 69.98065827000005],
              [-68.67149817599994, 69.98314036700003],
              [-68.65180416599992, 69.99042389500005],
              [-68.63202877499992, 69.99022044500003],
              [-68.61204993399991, 69.99233633000006],
              [-68.57884680899991, 70.01536692900004],
              [-68.54564368399991, 70.02562083500004],
              [-68.53376217399995, 70.03717682500007],
              [-68.55345618399991, 70.03709544500003],
              [-68.56537838399993, 70.04450104400007],
              [-68.56493079299992, 70.05341217700004],
              [-68.54743404899995, 70.05760325700004],
              [-68.53661048099991, 70.05670807500007],
              [-68.51707923099991, 70.05243561400005],
              [-68.46906490799995, 70.04995351800005],
              [-68.45860755099994, 70.05145905200004],
              [-68.45860755099994, 70.05377838700008],
              [-68.45673580599993, 70.06476471600007],
              [-68.45518958199995, 70.06826406500005],
              [-68.44102942599994, 70.07355377800008],
              [-68.4231664699999, 70.07217031500005],
              [-68.39037024599992, 70.06513092700004],
              [-68.33690344999991, 70.06883372600004],
              [-68.28425045499995, 70.08421458500004],
              [-68.19111080599993, 70.12661367400005],
              [-68.21605383999992, 70.13434479400007],
              [-68.32489986899992, 70.14248281500005],
              [-68.33153235599991, 70.14789459800005],
              [-68.32013912699995, 70.15477122600004],
              [-68.29352779899995, 70.16132233300004],
              [-68.29352779899995, 70.16754791900007],
              [-68.33324133999992, 70.16681549700007],
              [-68.34959876199991, 70.17267487200007],
              [-68.34874426999994, 70.18866608300004],
              [-68.33942623599995, 70.19432200700004],
              [-68.3255102199999, 70.19310130400004],
              [-68.30951900899993, 70.18964264500005],
              [-68.29352779899995, 70.18866608300004],
              [-68.31635494699992, 70.20954010600008],
              [-68.32306881399995, 70.22337474200003],
              [-68.30809485599991, 70.22955963700008],
              [-68.28913326699995, 70.23285553600005],
              [-68.23924719999991, 70.26032135600008],
              [-68.17621822799993, 70.28302643400008],
              [-68.14948482999995, 70.30011627800008],
              [-68.15697180899991, 70.31834544500003],
              [-68.07835852799991, 70.32705312700006],
              [-68.05463619699992, 70.32514069200005],
              [-68.04889889199995, 70.32172272300005],
              [-68.03815670499995, 70.30902741100005],
              [-68.03343665299991, 70.30467357000003],
              [-68.02009029899995, 70.29857005400004],
              [-68.00536048099991, 70.29413483300004],
              [-67.86436926999994, 70.27838776200008],
              [-67.80854244699992, 70.26373932500007],
              [-67.76659094999991, 70.24384186400005],
              [-67.74120032499991, 70.22809479400007],
              [-67.58649654899995, 70.15900299700007],
              [-67.54609127499992, 70.14760976800005],
              [-67.49030514199995, 70.11566803600005],
              [-67.47858639199995, 70.10236237200007],
              [-67.44050045499995, 70.07941315300008],
              [-67.43077551999994, 70.07135651200008],
              [-67.42292232999995, 70.07461172100005],
              [-67.41698157499991, 70.07477448100008],
              [-67.41120357999995, 70.07172272300005],
              [-67.40351314999992, 70.06513092700004],
              [-67.41710364499994, 70.06513092700004],
              [-67.38935299399992, 70.05243561400005],
              [-67.37804114499994, 70.04511139500005],
              [-67.36530514199995, 70.03375885600008],
              [-67.36253821499992, 70.02944570500006],
              [-67.36164303299995, 70.02448151200008],
              [-67.36188717399995, 70.01361725500004],
              [-67.35863196499992, 70.01068756700005],
              [-67.35163326699995, 70.00946686400005],
              [-67.34459387899994, 70.00682200700004],
              [-67.34142005099994, 69.99966054900005],
              [-67.24950110599991, 69.96344635600008],
              [-67.22533118399991, 69.94839101800005],
              [-67.21674557199992, 69.92649974200003],
              [-67.21674557199992, 69.87995026200008],
              [-67.20795650899993, 69.86273834800005],
              [-67.16246497299994, 69.82550690300008],
              [-67.15196692599994, 69.80548737200007],
              [-67.17011471299992, 69.79075755400004],
              [-67.13878333199995, 69.76211172100005],
              [-67.12458248599995, 69.74591705900008],
              [-67.11546790299991, 69.72866445500006],
              [-67.34691321499992, 69.71662018400008],
              [-67.55475826699995, 69.74022044500003],
              [-67.61656653599994, 69.75820547100005],
              [-67.66327877499992, 69.76080963700008],
              [-67.70258541599992, 69.77362702000005],
              [-67.74718176999994, 69.78261953300006],
              [-68.01305091099994, 69.77606842700004],
              [-68.0559789699999, 69.76898834800005],
              [-68.07506262899994, 69.76341380400004],
              [-68.08942623599995, 69.75698476800005],
              [-68.11054439999992, 69.74286530200004],
              [-68.12348385299993, 69.73615143400008],
              [-68.19334876199991, 69.72247955900008],
              [-68.22545325399994, 69.71002838700008],
              [-68.23888098899994, 69.68463776200008],
              [-68.25361080599993, 69.66746653900003],
              [-68.28722083199995, 69.65082428600005],
              [-68.32428951699995, 69.63812897300005],
              [-68.34919186099995, 69.63312409100007],
              [-68.54804439999992, 69.63312409100007],
              [-68.66559811099995, 69.64777252800008],
              [-68.70490475199995, 69.64520905200004],
              [-68.72614498599995, 69.64671458500004],
              [-68.72431393099993, 69.64313385600008],
              [-68.72834225199995, 69.64130280200004],
              [-68.75605221299992, 69.63955312700006],
              [-68.80589758999992, 69.62348053600005],
              [-68.96576900899993, 69.59955475500004],
              [-69.01585852799991, 69.58063385600008],
              [-69.0305883449999, 69.57786692900004],
              [-69.10533606699994, 69.57314687700006],
              [-69.14545650899993, 69.56590403900003],
              [-69.21751868399991, 69.54100169500003],
              [-69.26081295499995, 69.53489817900004],
              [-69.70624752499992, 69.57168203300006],
              [-69.79002844999991, 69.56659577000005],
              [-69.94579016799992, 69.53685130400004],
              [-70.00666256399995, 69.54303620000007],
              [-70.0215551419999, 69.53685130400004],
              [-70.01720130099994, 69.52606842700004],
              [-69.98786373599995, 69.52118561400005],
              [-69.95453854099992, 69.52016836100006],
              [-69.88569088399993, 69.50714752800008],
              [-69.84443111899992, 69.51898834800005],
              [-69.80317135299993, 69.53583405200004],
              [-69.76398678299995, 69.54433828300006],
              [-69.65815182199992, 69.55117422100005],
              [-69.29051673099991, 69.50873444200005],
              [-69.23859615799995, 69.51190827000005],
              [-69.17951412699995, 69.52374909100007],
              [-69.1438695949999, 69.52326080900008],
              [-69.13239498599995, 69.52533600500004],
              [-69.11082923099991, 69.53481679900005],
              [-69.09886633999992, 69.53685130400004],
              [-69.04149329299992, 69.53392161700003],
              [-69.01195227799991, 69.53660716400003],
              [-68.95384680899991, 69.56720612200007],
              [-68.76557369699992, 69.59243398600006],
              [-68.58747311099995, 69.59100983300004],
              [-68.45514889199995, 69.56696198100008],
              [-68.39769446499992, 69.54718659100007],
              [-68.00511633999992, 69.46198151200008],
              [-67.91742916599992, 69.45433177300004],
              [-67.87267005099994, 69.45917389500005],
              [-67.79149329299992, 69.48053620000007],
              [-67.59227454299992, 69.48016998900005],
              [-67.54588782499991, 69.47077057500007],
              [-67.22760982999995, 69.46434153900003],
              [-66.78803463399993, 69.34003327000005],
              [-66.77533932199992, 69.33270905200004],
              [-66.73871822799993, 69.30158112200007],
              [-66.72480221299992, 69.29364655200004],
              [-66.71137447799993, 69.29047272300005],
              [-66.69086666599992, 69.28286367400005],
              [-66.67113196499992, 69.26439036700003],
              [-66.65607662699995, 69.24201080900008],
              [-66.64936275899993, 69.22215403900003],
              [-66.65404212099992, 69.19977448100008],
              [-66.66877193899995, 69.18455638200004],
              [-66.74225826699995, 69.13686758000006],
              [-66.78193111899992, 69.13312409100007],
              [-66.97752844999991, 69.17694733300004],
              [-67.15941321499992, 69.18451569200005],
              [-67.20421301999994, 69.17446523600006],
              [-67.20421301999994, 69.16693756700005],
              [-67.19798743399991, 69.16364166900007],
              [-67.18439693899995, 69.15395742400005],
              [-67.21247311099995, 69.14793528900003],
              [-67.25214596299992, 69.15615469000005],
              [-67.32091223899994, 69.18439362200007],
              [-67.35566158799992, 69.19281647300005],
              [-67.39423580599993, 69.18829987200007],
              [-67.46491451699995, 69.16693756700005],
              [-67.50951087099992, 69.16083405200004],
              [-67.67804928299995, 69.17719147300005],
              [-67.90290279899995, 69.23358795800004],
              [-67.93622799399992, 69.24575429900005],
              [-67.9993383449999, 69.25633372600004],
              [-68.04560299399992, 69.27435944200005],
              [-68.09516354099992, 69.28107330900008],
              [-68.19794674399992, 69.31098053600005],
              [-68.23603268099993, 69.31244538000004],
              [-68.34593665299991, 69.29828522300005],
              [-68.67973792249992, 69.32882314650004],
              [-69.01353919199994, 69.35936107000003],
              [-69.20799719999991, 69.30166250200006],
              [-69.26056881399995, 69.27680084800005],
              [-69.23505611899992, 69.26487864800004],
              [-69.20128333199995, 69.27496979400007],
              [-69.13707434799994, 69.30414459800005],
              [-68.99921627499992, 69.33470286700003],
              [-68.9524633449999, 69.33893463700008],
              [-68.76996822799993, 69.32151927300004],
              [-68.70189368399991, 69.30463288000004],
              [-68.41685950399994, 69.27570221600007],
              [-68.21821041599992, 69.28449127800008],
              [-68.17064368399991, 69.27680084800005],
              [-68.15656490799995, 69.26923248900005],
              [-68.12958736899992, 69.24725983300004],
              [-68.10435950399994, 69.23847077000005],
              [-68.09093176999994, 69.22907135600008],
              [-68.08250891799992, 69.21967194200005],
              [-68.08564205599993, 69.21539948100008],
              [-68.10163326699995, 69.21312083500004],
              [-68.13837643099993, 69.20335521000004],
              [-68.15729732999995, 69.20111725500004],
              [-68.17870032499991, 69.20319245000007],
              [-68.22345943899995, 69.21287669500003],
              [-68.62633216099994, 69.23651764500005],
              [-68.69334876199991, 69.22321198100008],
              [-68.78465735599991, 69.21572500200006],
              [-68.96406002499992, 69.22345612200007],
              [-68.96214758999992, 69.22125885600008],
              [-68.88373775899993, 69.20319245000007],
              [-68.7442113919999, 69.20335521000004],
              [-68.67638098899994, 69.21312083500004],
              [-68.53193111899992, 69.21059804900005],
              [-68.50702877499992, 69.20111725500004],
              [-68.54161536399994, 69.18846263200004],
              [-68.65046139199995, 69.16693756700005],
              [-68.6907445949999, 69.14500560100004],
              [-68.70502682199992, 69.13963450700004],
              [-68.72838294199994, 69.13670482000003],
              [-68.80308997299994, 69.13963450700004],
              [-68.9219457669999, 69.12002187700006],
              [-69.03551184799994, 69.12201569200005],
              [-69.06989498599995, 69.11371491100005],
              [-69.09605872299994, 69.09186432500007],
              [-69.05109615799995, 69.09186432500007],
              [-69.04466712099992, 69.09398021000004],
              [-69.03437252499992, 69.10342031500005],
              [-69.02717037699995, 69.10553620000007],
              [-68.92475338399993, 69.10553620000007],
              [-68.92808997299994, 69.09642161700003],
              [-68.92817135299993, 69.09227122600004],
              [-68.92658443899995, 69.08966705900008],
              [-68.92475338399993, 69.08502838700008],
              [-68.93512936099995, 69.07343170800004],
              [-68.95392818899995, 69.03742096600007],
              [-68.96263587099992, 69.02977122600004],
              [-68.95978756399995, 69.02431875200006],
              [-68.96772213399993, 69.01178620000007],
              [-68.98070227799991, 68.99803294500003],
              [-69.01825924399992, 68.96841054900005],
              [-68.9798070949999, 68.97431061400005],
              [-68.93260657499991, 68.99616120000007],
              [-68.93158932199992, 69.02362702000005],
              [-68.92719479099992, 69.02659739800004],
              [-68.91877193899995, 69.03058502800008],
              [-68.89985104099992, 69.04633209800005],
              [-68.89683997299994, 69.05027903900003],
              [-68.89500891799992, 69.05512116100005],
              [-68.89256751199991, 69.06720612200007],
              [-68.89061438699991, 69.07200755400004],
              [-68.87848873599995, 69.08466217700004],
              [-68.86408443899995, 69.09162018400008],
              [-68.76707923099991, 69.11139557500007],
              [-68.67711341099994, 69.11444733300004],
              [-68.63267981699994, 69.13979726800005],
              [-68.46296139199995, 69.17405833500004],
              [-68.37336178299995, 69.17959219000005],
              [-68.20067298099991, 69.14984772300005],
              [-68.15729732999995, 69.14712148600006],
              [-68.14818274599992, 69.14533112200007],
              [-68.11603756399995, 69.13279857000003],
              [-67.73546301999994, 69.04010651200008],
              [-67.70445716099994, 69.02362702000005],
              [-67.74144446499992, 69.01243724200003],
              [-67.95152747299994, 69.00568268400008],
              [-67.97883053299995, 68.99567291900007],
              [-67.96519934799994, 68.98200104400007],
              [-68.00080318899995, 68.97199127800008],
              [-68.04303951699995, 68.97223541900007],
              [-68.24006100199995, 69.00560130400004],
              [-68.39447994699992, 69.00702545800004],
              [-68.43285071499992, 68.99762604400007],
              [-68.46711178299995, 68.99551015800006],
              [-68.47227942599994, 68.99225495000007],
              [-68.47480221299992, 68.99127838700008],
              [-68.48473059799994, 68.98358795800004],
              [-68.48530025899993, 68.98200104400007],
              [-68.49974524599992, 68.98118724200003],
              [-68.53376217399995, 68.98883698100008],
              [-68.55121822799993, 68.98407623900005],
              [-68.55353756399995, 68.97329336100006],
              [-68.54686438699991, 68.96442291900007],
              [-68.53718014199995, 68.96527741100005],
              [-68.51789303299995, 68.97247955900008],
              [-68.30308997299994, 68.98525625200006],
              [-68.29352779899995, 68.97516510600008],
              [-68.26874752499992, 68.96454498900005],
              [-68.20551510299993, 68.95917389500005],
              [-68.16307532499991, 68.94769928600005],
              [-68.04027258999992, 68.94790273600006],
              [-68.04938717399995, 68.93256256700005],
              [-68.05463619699992, 68.92739492400005],
              [-68.04963131399995, 68.91913483300004],
              [-68.05866451699995, 68.91193268400008],
              [-68.07416744699992, 68.90745677300004],
              [-68.08869381399995, 68.90692780200004],
              [-68.07213294199994, 68.89988841400003],
              [-68.03282630099994, 68.89752838700008],
              [-68.01362057199992, 68.89325592700004],
              [-68.00141354099992, 68.88690827000005],
              [-67.97264563699991, 68.86591217700004],
              [-67.99901282499991, 68.85590241100005],
              [-68.12962805899991, 68.86904531500005],
              [-68.18431555899991, 68.88271719000005],
              [-68.49278723899994, 68.89948151200008],
              [-68.45575924399992, 68.88507721600007],
              [-68.27509518099993, 68.87543366100005],
              [-68.25727291599992, 68.87026601800005],
              [-68.23924719999991, 68.86220937700006],
              [-68.22105872299994, 68.85667552300004],
              [-68.18248450399994, 68.85431549700007],
              [-68.13316809799994, 68.83722565300008],
              [-67.92760169199994, 68.81126536700003],
              [-67.88963782499991, 68.81313711100006],
              [-67.87067623599995, 68.81122467700004],
              [-67.85594641799992, 68.80390045800004],
              [-67.86896725199995, 68.79706452000005],
              [-67.84577389199995, 68.78998444200005],
              [-67.79596920499995, 68.79051341400003],
              [-67.77338619699992, 68.78400299700007],
              [-67.81932532499991, 68.77252838700008],
              [-67.87775631399995, 68.77118561400005],
              [-68.22301184799994, 68.82518138200004],
              [-68.2747289699999, 68.82298411700003],
              [-68.40058346299992, 68.84544505400004],
              [-68.47406979099992, 68.84275950700004],
              [-68.52778072799993, 68.84951406500005],
              [-68.58250891799992, 68.84992096600007],
              [-68.60944576699995, 68.84544505400004],
              [-68.60944576699995, 68.83860911700003],
              [-68.54328365799995, 68.82672760600008],
              [-68.50959225199995, 68.81606679900005],
              [-68.49278723899994, 68.79706452000005],
              [-68.60260982999995, 68.80390045800004],
              [-68.60260982999995, 68.79706452000005],
              [-68.60033118399991, 68.78815338700008],
              [-68.61957760299993, 68.78620026200008],
              [-68.64586341099994, 68.78876373900005],
              [-68.66474361899992, 68.79364655200004],
              [-68.6875707669999, 68.80337148600006],
              [-68.71515865799995, 68.81110260600008],
              [-68.74303137899994, 68.81366608300004],
              [-68.79072018099993, 68.80243561400005],
              [-68.83710689999992, 68.81622955900008],
              [-68.86115475199995, 68.81590403900003],
              [-68.8867895169999, 68.81126536700003],
              [-68.96576900899993, 68.81753164300005],
              [-68.98993893099993, 68.82477448100008],
              [-69.03827877499992, 68.84739817900004],
              [-69.06135006399995, 68.85228099200003],
              [-69.16120357999995, 68.85382721600007],
              [-69.3020727199999, 68.88275788000004],
              [-69.36347408799992, 68.88108958500004],
              [-69.3977758449999, 68.85846588700008],
              [-69.26854407499991, 68.86033763200004],
              [-69.20348059799994, 68.85293203300006],
              [-69.15070553299995, 68.83120351800005],
              [-69.35057532499991, 68.83494700700004],
              [-69.38349361899992, 68.81753164300005],
              [-68.98875891799992, 68.80341217700004],
              [-68.95954342399995, 68.79706452000005],
              [-68.94599361899992, 68.78717682500007],
              [-68.95075436099995, 68.77968984600005],
              [-68.95982825399994, 68.77228424700007],
              [-68.95954342399995, 68.76288483300004],
              [-68.96833248599995, 68.75787995000007],
              [-68.97822018099993, 68.75556061400005],
              [-68.98884029899995, 68.75507233300004],
              [-68.99986731699994, 68.75604889500005],
              [-68.99986731699994, 68.74860260600008],
              [-68.97345943899995, 68.74249909100007],
              [-68.94994055899991, 68.74555084800005],
              [-68.90428626199991, 68.76288483300004],
              [-68.87592525899993, 68.76837799700007],
              [-68.75340735599991, 68.76040273600006],
              [-68.66413326699995, 68.74241771000004],
              [-68.54718990799995, 68.75307851800005],
              [-68.51325436099995, 68.74241771000004],
              [-68.49653072799993, 68.73362864800004],
              [-68.40339107999995, 68.73558177300004],
              [-68.21149654899995, 68.71596914300005],
              [-68.14329993399991, 68.70140208500004],
              [-68.13398189999992, 68.69721100500004],
              [-68.12852942599994, 68.69257233300004],
              [-68.12193762899994, 68.68870677300004],
              [-68.10920162699995, 68.68720123900005],
              [-68.04771887899994, 68.68720123900005],
              [-68.04771887899994, 68.68097565300008],
              [-68.09552975199995, 68.66669342700004],
              [-68.09552975199995, 68.67413971600007],
              [-68.11103268099993, 68.67088450700004],
              [-68.17064368399991, 68.67413971600007],
              [-68.14732825399994, 68.66559479400007],
              [-68.09483801999994, 68.65985748900005],
              [-68.07506262899994, 68.64618561400005],
              [-68.10566158799992, 68.63019440300008],
              [-68.14606686099995, 68.63715241100005],
              [-68.18858801999994, 68.65216705900008],
              [-68.22557532499991, 68.66046784100007],
              [-68.28022213399993, 68.65200429900005],
              [-68.36054439999992, 68.62995026200008],
              [-68.3899633449999, 68.63076406500005],
              [-68.64399166599992, 68.66535065300008],
              [-68.72651119699992, 68.65257396000004],
              [-68.74750729099992, 68.65379466400003],
              [-68.76744544199994, 68.65253327000005],
              [-68.78388424399992, 68.64248281500005],
              [-68.78770911399994, 68.63947174700007],
              [-68.80121822799993, 68.63255442900004],
              [-68.80174719999991, 68.63019440300008],
              [-68.80072994699992, 68.62189362200007],
              [-68.80121822799993, 68.61953359600005],
              [-68.8255102199999, 68.61302317900004],
              [-68.88011633999992, 68.61273834800005],
              [-68.90428626199991, 68.60521067900004],
              [-68.88329016799992, 68.60309479400007],
              [-68.84601803299995, 68.59373607000003],
              [-68.82856197799993, 68.59153880400004],
              [-68.79743404899995, 68.59284088700008],
              [-68.76707923099991, 68.59780508000006],
              [-68.73814856699994, 68.61025625200006],
              [-68.71764075399994, 68.61522044500003],
              [-68.69591223899994, 68.62933991100005],
              [-68.6848852199999, 68.63255442900004],
              [-68.62995357999995, 68.63873932500007],
              [-68.48704993399991, 68.62250397300005],
              [-68.47911536399994, 68.61953359600005],
              [-68.47618567599994, 68.61302317900004],
              [-68.47687740799995, 68.60590241100005],
              [-68.48119055899991, 68.60016510600008],
              [-68.48900305899991, 68.59780508000006],
              [-68.50861568899995, 68.59577057500007],
              [-68.54784094999991, 68.58673737200007],
              [-68.71580969999991, 68.58299388200004],
              [-68.76032467399995, 68.57111237200007],
              [-68.45860755099994, 68.56427643400008],
              [-68.44257564999992, 68.56854889500005],
              [-68.43455969999991, 68.57607656500005],
              [-68.42926998599995, 68.58519114800004],
              [-68.42137610599991, 68.59467194200005],
              [-68.40440833199995, 68.60000234600005],
              [-68.37852942599994, 68.60097890800006],
              [-68.35252844999991, 68.59882233300004],
              [-68.33543860599991, 68.59467194200005],
              [-68.21629798099991, 68.58828359600005],
              [-68.19794674399992, 68.57485586100006],
              [-68.19037838399993, 68.57111237200007],
              [-68.14329993399991, 68.57855866100005],
              [-68.12946529899995, 68.57168203300006],
              [-68.12800045499995, 68.56476471600007],
              [-68.13080807199992, 68.55776601800005],
              [-68.12962805899991, 68.55068594000005],
              [-68.11949622299994, 68.54100169500003],
              [-68.11115475199995, 68.53969961100006],
              [-68.10106360599991, 68.54197825700004],
              [-68.08564205599993, 68.54376862200007],
              [-68.02354895699995, 68.54376862200007],
              [-68.02025305899991, 68.54197825700004],
              [-68.01817786399994, 68.53327057500007],
              [-68.01362057199992, 68.53009674700007],
              [-68.00267493399991, 68.52899811400005],
              [-67.99242102799991, 68.53034088700008],
              [-67.97264563699991, 68.53701406500005],
              [-67.94880123599995, 68.55512116100005],
              [-67.93342037699995, 68.56004466400003],
              [-67.91742916599992, 68.55068594000005],
              [-67.91816158799992, 68.54360586100006],
              [-67.92650305899991, 68.53729889500005],
              [-67.93122311099995, 68.52822500200006],
              [-67.91612708199995, 68.50421784100007],
              [-67.91205807199992, 68.48135000200006],
              [-67.90684973899994, 68.47182851800005],
              [-67.90758216099994, 68.45612213700008],
              [-67.94648189999992, 68.41600169500003],
              [-67.95836341099994, 68.39980703300006],
              [-67.94029700399994, 68.40521881700005],
              [-67.92345130099994, 68.41250234600005],
              [-67.90851803299995, 68.42194245000007],
              [-67.89631100199995, 68.43390534100007],
              [-67.89085852799991, 68.44489166900007],
              [-67.88154049399992, 68.47296784100007],
              [-67.86485755099994, 68.49774811400005],
              [-67.86676998599995, 68.50922272300005],
              [-67.87067623599995, 68.52163320500006],
              [-67.86896725199995, 68.53701406500005],
              [-67.85895748599995, 68.55023834800005],
              [-67.84703528599994, 68.54877350500004],
              [-67.83250891799992, 68.54140859600005],
              [-67.81464596299992, 68.53701406500005],
              [-67.70038814999992, 68.55361562700006],
              [-67.66413326699995, 68.56468333500004],
              [-67.64305579299992, 68.56427643400008],
              [-67.62153072799993, 68.55841705900008],
              [-67.61335201699995, 68.55385976800005],
              [-67.60553951699995, 68.54718659100007],
              [-67.59418697799993, 68.54291413000004],
              [-67.55060787699995, 68.55068594000005],
              [-67.53441321499992, 68.55072663000004],
              [-67.51915442599994, 68.54905833500004],
              [-67.50507564999992, 68.54315827000005],
              [-67.49225826699995, 68.53009674700007],
              [-67.53758704299992, 68.51137929900005],
              [-67.59605872299994, 68.50551992400005],
              [-67.62999426999994, 68.49310944200005],
              [-67.60212154899995, 68.45441315300008],
              [-67.60313880099994, 68.43817780200004],
              [-67.60948645699995, 68.42519765800006],
              [-67.61896725199995, 68.41315338700008],
              [-67.62254798099991, 68.39980703300006],
              [-67.6165258449999, 68.38690827000005],
              [-67.60627193899995, 68.38410065300008],
              [-67.59471594999991, 68.38825104400007],
              [-67.56053626199991, 68.41632721600007],
              [-67.55077063699991, 68.42788320500006],
              [-67.54686438699991, 68.44415924700007],
              [-67.55064856699994, 68.45648834800005],
              [-67.56891842399995, 68.47638580900008],
              [-67.57477779899995, 68.48859284100007],
              [-67.54857337099992, 68.49225495000007],
              [-67.45868893099993, 68.48859284100007],
              [-67.43329830599993, 68.49575429900005],
              [-67.41901607999995, 68.49725983300004],
              [-67.40684973899994, 68.49192942900004],
              [-67.39476477799991, 68.47980377800008],
              [-67.38727779899995, 68.47614166900007],
              [-67.37616939999992, 68.47492096600007],
              [-67.37470455599993, 68.49237702000005],
              [-67.35492916599992, 68.50079987200007],
              [-67.32868404899995, 68.50145091400003],
              [-67.30785071499992, 68.49542877800008],
              [-67.30211341099994, 68.48655833500004],
              [-67.29515540299991, 68.47207265800006],
              [-67.28595943899995, 68.45897044500003],
              [-67.27314205599993, 68.45441315300008],
              [-67.26215572799993, 68.46450429900005],
              [-67.25336666599992, 68.48143138200004],
              [-67.24168860599991, 68.49087148600006],
              [-67.22191321499992, 68.47858307500007],
              [-67.21300208199995, 68.46360911700003],
              [-67.21198482999995, 68.45282623900005],
              [-67.20811926999994, 68.44379303600005],
              [-67.19054114499994, 68.43390534100007],
              [-67.19054114499994, 68.42772044500003],
              [-67.27196204299992, 68.43280670800004],
              [-67.31432044199994, 68.42938873900005],
              [-67.34142005099994, 68.41347890800006],
              [-67.12470455599993, 68.41331614800004],
              [-67.10863196499992, 68.42023346600007],
              [-67.10407467399995, 68.42804596600007],
              [-67.09947669199994, 68.44700755400004],
              [-67.09434973899994, 68.45441315300008],
              [-67.1145727199999, 68.46649811400005],
              [-67.12328040299991, 68.47333405200004],
              [-67.12909908799992, 68.48236725500004],
              [-67.06395423099991, 68.47492096600007],
              [-67.00934811099995, 68.45783112200007],
              [-66.98875891799992, 68.44350820500006],
              [-66.96869869699992, 68.44204336100006],
              [-66.93049068899995, 68.45441315300008],
              [-66.86335201699995, 68.46649811400005],
              [-66.79503333199995, 68.46572500200006],
              [-66.66356360599991, 68.44082265800006],
              [-66.66356360599991, 68.43390534100007],
              [-66.72834225199995, 68.42816803600005],
              [-66.76427161399994, 68.43256256700005],
              [-66.78803463399993, 68.43154531500005],
              [-66.80382239499994, 68.42352936400005],
              [-66.80016028599994, 68.40599192900004],
              [-66.83075924399992, 68.40888092700004],
              [-66.86225338399993, 68.41766998900005],
              [-66.89366614499994, 68.42243073100008],
              [-66.92430579299992, 68.41347890800006],
              [-66.91974850199995, 68.39362213700008],
              [-66.93952389199995, 68.37929922100005],
              [-66.96857662699995, 68.36994049700007],
              [-67.02245032499991, 68.36155833500004],
              [-67.05333411399994, 68.36200592700004],
              [-67.11546790299991, 68.37250397300005],
              [-67.18439693899995, 68.39301178600005],
              [-67.33470618399991, 68.40184153900003],
              [-67.37262936099995, 68.39227936400005],
              [-67.40314693899995, 68.39695872600004],
              [-67.41710364499994, 68.39301178600005],
              [-67.41368567599994, 68.39081452000005],
              [-67.41270911399994, 68.39069245000007],
              [-67.41218014199995, 68.38983795800004],
              [-67.41026770699995, 68.38556549700007],
              [-67.44306393099993, 68.37665436400005],
              [-67.79389400899993, 68.33771393400008],
              [-67.83580481699994, 68.32428620000007],
              [-67.85578365799995, 68.31492747600004],
              [-67.86896725199995, 68.30418528900003],
              [-67.87616939999992, 68.28339264500005],
              [-67.86884518099993, 68.26772695500006],
              [-67.85138912699995, 68.26162344000005],
              [-67.82799231699994, 68.26947663000004],
              [-67.82489986899992, 68.27509186400005],
              [-67.82054602799991, 68.29295482000003],
              [-67.81810462099992, 68.29677969000005],
              [-67.80695553299995, 68.29816315300008],
              [-67.7493383449999, 68.31769440300008],
              [-67.72716223899994, 68.32013580900008],
              [-67.64728756399995, 68.31875234600005],
              [-67.56794186099995, 68.33771393400008],
              [-67.54804439999992, 68.34345123900005],
              [-67.53758704299992, 68.34471263200004],
              [-67.52696692599994, 68.34454987200007],
              [-67.53534908799992, 68.33283112200007],
              [-67.54808508999992, 68.32851797100005],
              [-67.56232662699995, 68.32550690300008],
              [-67.57477779899995, 68.31785716400003],
              [-67.58271236899992, 68.30341217700004],
              [-67.57978268099993, 68.29437897300005],
              [-67.57428951699995, 68.28676992400005],
              [-67.57477779899995, 68.27692291900007],
              [-67.59483801999994, 68.26414622600004],
              [-67.69770260299993, 68.24957916900007],
              [-67.69623775899993, 68.24945709800005],
              [-67.69379635299993, 68.24892812700006],
              [-67.69330807199992, 68.24681224200003],
              [-67.69770260299993, 68.24213288000004],
              [-67.68224036399994, 68.24152252800008],
              [-67.63683020699995, 68.24957916900007],
              [-67.57884680899991, 68.25210195500006],
              [-67.56114661399994, 68.25580475500004],
              [-67.54930579299992, 68.26211172100005],
              [-67.54255123599995, 68.26996491100005],
              [-67.53319251199991, 68.29059479400007],
              [-67.53620357999995, 68.28953685100004],
              [-67.54051673099991, 68.29173411700003],
              [-67.54303951699995, 68.29677969000005],
              [-67.54063880099994, 68.30418528900003],
              [-67.53636633999992, 68.30817291900007],
              [-67.41942298099991, 68.34625885600008],
              [-67.40351314999992, 68.35512929900005],
              [-67.35651607999995, 68.35736725500004],
              [-67.33141028599994, 68.34959544500003],
              [-67.33519446499992, 68.32404205900008],
              [-67.31505286399994, 68.32526276200008],
              [-67.30040442599994, 68.33201732000003],
              [-67.27314205599993, 68.35138580900008],
              [-67.25812740799995, 68.35708242400005],
              [-67.24010169199994, 68.36005280200004],
              [-67.21979732999995, 68.36066315300008],
              [-67.19798743399991, 68.35883209800005],
              [-67.0325414699999, 68.32664622600004],
              [-67.01244055899991, 68.31785716400003],
              [-67.06537838399993, 68.30662669500003],
              [-67.23896236899992, 68.29677969000005],
              [-67.23448645699995, 68.29523346600007],
              [-67.22533118399991, 68.29059479400007],
              [-67.22468014199995, 68.28571198100008],
              [-67.22606360599991, 68.28424713700008],
              [-67.22874915299991, 68.28408437700006],
              [-67.23216712099992, 68.28314850500004],
              [-67.23896236899992, 68.28314850500004],
              [-67.27916419199994, 68.27411530200004],
              [-67.31700598899994, 68.25535716400003],
              [-67.33800208199995, 68.22638580900008],
              [-67.32774817599994, 68.18691640800006],
              [-67.35578365799995, 68.16400788000004],
              [-67.38508053299995, 68.15420156500005],
              [-67.45152747299994, 68.15277741100005],
              [-67.48871822799993, 68.15839264500005],
              [-67.52647864499994, 68.16909414300005],
              [-67.56452389199995, 68.17519765800006],
              [-67.60212154899995, 68.16705963700008],
              [-67.56257076699995, 68.15399811400005],
              [-67.3997289699999, 68.12759023600006],
              [-67.37970943899995, 68.12881094000005],
              [-67.36530514199995, 68.13597239800004],
              [-67.35033118399991, 68.14581940300008],
              [-67.31529700399994, 68.15607330900008],
              [-67.30040442599994, 68.16705963700008],
              [-67.30785071499992, 68.17328522300005],
              [-67.29845130099994, 68.18032461100006],
              [-67.28473873599995, 68.18744538000004],
              [-67.27476966099994, 68.19525788000004],
              [-67.27656002499992, 68.20457591400003],
              [-67.28266354099992, 68.21206289300005],
              [-67.28742428299995, 68.22077057500007],
              [-67.29100501199991, 68.23069896000004],
              [-67.29364986899992, 68.24213288000004],
              [-67.13593502499992, 68.28314850500004],
              [-67.11969967399995, 68.28978099200003],
              [-67.06529700399994, 68.29612864800004],
              [-67.02721106699994, 68.29653554900005],
              [-67.00373287699995, 68.29364655200004],
              [-66.99193274599992, 68.29059479400007],
              [-66.98688717399995, 68.28750234600005],
              [-66.98200436099995, 68.28286367400005],
              [-66.97614498599995, 68.27875397300005],
              [-66.94420325399994, 68.27362702000005],
              [-66.89679928299995, 68.25910065300008],
              [-66.78815670499995, 68.24941640800006],
              [-66.76598059799994, 68.24213288000004],
              [-66.77387447799993, 68.23484935100004],
              [-66.77521725199995, 68.22776927300004],
              [-66.77533932199992, 68.22089264500005],
              [-66.77904212099992, 68.21426015800006],
              [-66.78864498599995, 68.20799388200004],
              [-66.81037350199995, 68.20010000200006],
              [-66.82066809799994, 68.19432200700004],
              [-66.83649654899995, 68.17865631700005],
              [-66.84479732999995, 68.16152578300006],
              [-66.84276282499991, 68.14520905200004],
              [-66.8274633449999, 68.13226959800005],
              [-66.84874426999994, 68.11908600500004],
              [-66.95750891799992, 68.07501862200007],
              [-66.97077389199995, 68.06000397300005],
              [-66.97142493399991, 68.03668854400007],
              [-66.96015377499992, 68.02606842700004],
              [-66.95112057199992, 68.01923248900005],
              [-66.94416256399995, 68.01618073100008],
              [-66.93163001199991, 68.01984284100007],
              [-66.92841549399992, 68.02875397300005],
              [-66.92808997299994, 68.03986237200007],
              [-66.92430579299992, 68.05036041900007],
              [-66.90660559799994, 68.06468333500004],
              [-66.82074947799993, 68.10297272300005],
              [-66.79149329299992, 68.11054108300004],
              [-66.77594967399995, 68.11180247600004],
              [-66.76508541599992, 68.11493561400005],
              [-66.74925696499992, 68.13178131700005],
              [-66.73871822799993, 68.13971588700008],
              [-66.71430416599992, 68.14752838700008],
              [-66.69318600199995, 68.14545319200005],
              [-66.67760169199994, 68.13361237200007],
              [-66.66978919199994, 68.11180247600004],
              [-66.67223059799994, 68.11249420800004],
              [-66.67711341099994, 68.11009349200003],
              [-66.68195553299995, 68.10610586100006],
              [-66.68407141799992, 68.10154857000003],
              [-66.68305416599992, 68.09870026200008],
              [-66.68065344999991, 68.09682851800005],
              [-66.67829342399995, 68.09406159100007],
              [-66.67723548099991, 68.08820221600007],
              [-66.67723548099991, 68.05036041900007],
              [-66.68818111899992, 68.03204987200007],
              [-66.70429439999992, 68.01459381700005],
              [-66.72223873599995, 67.99966054900005],
              [-66.73871822799993, 67.98895905200004],
              [-66.70087643099993, 67.99359772300005],
              [-66.66791744699992, 68.00800202000005],
              [-66.64452063699991, 68.03237539300005],
              [-66.62950598899994, 68.10761139500005],
              [-66.61139889199995, 68.13397858300004],
              [-66.58141028599994, 68.14838288000004],
              [-66.54010982999995, 68.15277741100005],
              [-66.34601803299995, 68.13621653900003],
              [-66.31354732999995, 68.12913646000004],
              [-66.33409583199995, 68.09593333500004],
              [-66.38206946499992, 68.08706289300005],
              [-66.47801673099991, 68.08510976800005],
              [-66.47801673099991, 68.07762278900003],
              [-66.38923092399995, 68.07086823100008],
              [-66.29987545499995, 68.09129466400003],
              [-66.28612219999991, 68.09096914300005],
              [-66.24836178299995, 68.08510976800005],
              [-66.24030514199995, 68.08185455900008],
              [-66.23875891799992, 68.07416413000004],
              [-66.2395727199999, 68.06488678600005],
              [-66.23839270699995, 68.05719635600008],
              [-66.22773189999992, 68.04092031500005],
              [-66.21861731699994, 68.03359609600005],
              [-66.18317623599995, 68.02301666900007],
              [-66.18317623599995, 68.01618073100008],
              [-66.21410071499992, 68.00507233300004],
              [-66.29234778599994, 67.99428945500006],
              [-66.32782955599993, 67.97528717700004],
              [-66.35529537699995, 67.93976471600007],
              [-66.36164303299995, 67.93427155200004],
              [-66.37397213399993, 67.93036530200004],
              [-66.38764400899993, 67.92096588700008],
              [-66.40973873599995, 67.89956289300005],
              [-66.39806067599994, 67.88947174700007],
              [-66.40107174399992, 67.87832265800006],
              [-66.41364498599995, 67.86912669500003],
              [-66.43053137899994, 67.86542389500005],
              [-66.50108801999994, 67.86310455900008],
              [-66.63703365799995, 67.88605377800008],
              [-66.69599361899992, 67.88979726800005],
              [-66.74555416599992, 67.87909577000005],
              [-66.72272701699995, 67.87103913000004],
              [-66.67243404899995, 67.86835358300004],
              [-66.62592525899993, 67.85586172100005],
              [-66.57188880099994, 67.85203685100004],
              [-66.54999752499992, 67.84149811400005],
              [-66.51268469999991, 67.82973867400005],
              [-66.42308508999992, 67.83584219000005],
              [-66.39671790299991, 67.81696198100008],
              [-66.4036352199999, 67.79677969000005],
              [-66.38866126199991, 67.78148021000004],
              [-66.36725826699995, 67.78229401200008],
              [-66.35448157499991, 67.81012604400007],
              [-66.35456295499995, 67.81810130400004],
              [-66.35627193899995, 67.82387929900005],
              [-66.35981197799993, 67.82884349200003],
              [-66.36534583199995, 67.83466217700004],
              [-66.36900794199994, 67.84194570500006],
              [-66.36567135299993, 67.84739817900004],
              [-66.35944576699995, 67.85248444200005],
              [-66.35448157499991, 67.85854726800005],
              [-66.34618079299992, 67.87132396000004],
              [-66.33763587099992, 67.88104889500005],
              [-66.33433997299994, 67.89142487200007],
              [-66.34150143099993, 67.90631745000007],
              [-66.32079016799992, 67.91583893400008],
              [-66.29657955599993, 67.94647858300004],
              [-66.27940833199995, 67.96100495000007],
              [-66.26459713399993, 67.96515534100007],
              [-66.23521887899994, 67.96308014500005],
              [-66.22480221299992, 67.96466705900008],
              [-66.20270748599995, 67.97622304900005],
              [-66.19159908799992, 67.98004791900007],
              [-66.1321508449999, 67.98590729400007],
              [-66.11115475199995, 67.99237702000005],
              [-66.06749426999994, 68.01154205900008],
              [-66.01817786399994, 68.02716705900008],
              [-65.96812903599994, 68.03314850500004],
              [-65.95575924399992, 68.04238515800006],
              [-65.95116126199991, 68.05638255400004],
              [-65.94920813699991, 68.08392975500004],
              [-65.94452877499992, 68.10407135600008],
              [-65.94420325399994, 68.11180247600004],
              [-65.94892330599993, 68.12006256700005],
              [-65.95649166599992, 68.12787506700005],
              [-65.96271725199995, 68.13613515800006],
              [-65.96344967399995, 68.14594147300005],
              [-65.94884192599994, 68.16494375200006],
              [-65.92817135299993, 68.16478099200003],
              [-65.90741939999992, 68.15444570500006],
              [-65.89240475199995, 68.14280833500004],
              [-65.87092037699995, 68.12189362200007],
              [-65.86713619699992, 68.11058177300004],
              [-65.87861080599993, 68.10106028900003],
              [-65.90265865799995, 68.08510976800005],
              [-65.89195716099994, 68.08380768400008],
              [-65.88219153599994, 68.08429596600007],
              [-65.87413489499994, 68.08685944200005],
              [-65.86851966099994, 68.09129466400003],
              [-65.8548070949999, 68.08100006700005],
              [-65.86229407499991, 68.07123444200005],
              [-65.89240475199995, 68.05377838700008],
              [-65.91059322799993, 68.03172435100004],
              [-65.92198645699995, 68.02090078300006],
              [-65.93342037699995, 68.01618073100008],
              [-66.03233801999994, 67.96100495000007],
              [-66.03233801999994, 67.95477936400005],
              [-66.02619381399995, 67.95477936400005],
              [-66.01593990799995, 67.94367096600007],
              [-65.96100826699995, 67.91526927300004],
              [-65.94420325399994, 67.89956289300005],
              [-65.94587154899995, 67.87372467700004],
              [-65.96552486899992, 67.85407135600008],
              [-65.98969479099992, 67.83661530200004],
              [-66.00507564999992, 67.81696198100008],
              [-66.00568600199995, 67.80658600500004],
              [-65.99925696499992, 67.78831614800004],
              [-65.99885006399995, 67.77602773600006],
              [-66.00450598899994, 67.76325104400007],
              [-66.02546139199995, 67.74062734600005],
              [-66.03233801999994, 67.72821686400005],
              [-66.02948971299992, 67.70897044500003],
              [-66.01874752499992, 67.69025299700007],
              [-66.01329505099994, 67.67169830900008],
              [-66.02619381399995, 67.65314362200007],
              [-66.01178951699995, 67.63662344000005],
              [-65.99469967399995, 67.63678620000007],
              [-65.98652096299992, 67.64862702000005],
              [-65.99885006399995, 67.66673411700003],
              [-65.97638912699995, 67.68183014500005],
              [-65.96051998599995, 67.70246002800008],
              [-65.95026607999995, 67.72748444200005],
              [-65.94025631399995, 67.77887604400007],
              [-65.94343014199995, 67.78750234600005],
              [-65.95384680899991, 67.80023834800005],
              [-65.95933997299994, 67.81732819200005],
              [-65.94603430899991, 67.82880280200004],
              [-65.89195716099994, 67.84735748900005],
              [-65.80894934799994, 67.86530182500007],
              [-65.80024166599992, 67.86880117400005],
              [-65.79515540299991, 67.87470123900005],
              [-65.79303951699995, 67.88271719000005],
              [-65.79010982999995, 67.88971588700008],
              [-65.77057857999995, 67.89769114800004],
              [-65.76777096299992, 67.90949127800008],
              [-65.77159583199995, 67.92328522300005],
              [-65.77912350199995, 67.93427155200004],
              [-65.79124915299991, 67.94318268400008],
              [-65.81550045499995, 67.95661041900007],
              [-65.82758541599992, 67.96841054900005],
              [-65.80964107999995, 67.97492096600007],
              [-65.79283606699994, 67.97353750200006],
              [-65.77611243399991, 67.96963125200006],
              [-65.75861568899995, 67.96841054900005],
              [-65.74164791599992, 67.97182851800005],
              [-65.69713294199994, 67.98895905200004],
              [-65.65473385299993, 67.99811432500007],
              [-65.51903235599991, 67.99510325700004],
              [-65.50584876199991, 67.99559153900003],
              [-65.48082434799994, 68.00185781500005],
              [-65.47065182199992, 68.00259023600006],
              [-65.45189368399991, 67.99860260600008],
              [-65.44684811099995, 67.99388255400004],
              [-65.45494544199994, 67.94936758000006],
              [-65.46528072799993, 67.92772044500003],
              [-65.51903235599991, 67.85854726800005],
              [-65.52948971299992, 67.83893463700008],
              [-65.53791256399995, 67.82880280200004],
              [-65.54950924399992, 67.82440827000005],
              [-65.56163489499994, 67.82123444200005],
              [-65.58759518099993, 67.80711497600004],
              [-65.61363684799994, 67.79954661700003],
              [-65.61445064999992, 67.78945547100005],
              [-65.6087133449999, 67.77781810100004],
              [-65.60163326699995, 67.76923248900005],
              [-65.58027096299992, 67.75568268400008],
              [-65.51593990799995, 67.73224518400008],
              [-65.46540279899995, 67.72304922100005],
              [-65.44249426999994, 67.70978424700007],
              [-65.42345130099994, 67.69220612200007],
              [-65.40916907499991, 67.67357005400004],
              [-65.37299557199992, 67.60736725500004],
              [-65.36115475199995, 67.59788646000004],
              [-65.33165442599994, 67.60089752800008],
              [-65.32494055899991, 67.60944245000007],
              [-65.36473548099991, 67.69017161700003],
              [-65.36762447799993, 67.70400625200006],
              [-65.38036048099991, 67.71869538000004],
              [-65.51768958199995, 67.76626211100006],
              [-65.54466712099992, 67.77948639500005],
              [-65.54950924399992, 67.79303620000007],
              [-65.53766842399995, 67.80174388200004],
              [-65.51109778599994, 67.81000397300005],
              [-65.49799557199992, 67.81696198100008],
              [-65.49071204299992, 67.82396067900004],
              [-65.47748775899993, 67.84491608300004],
              [-65.42393958199995, 67.90395742400005],
              [-65.41942298099991, 67.91376373900005],
              [-65.38715572799993, 67.93024323100008],
              [-65.37507076699995, 67.93427155200004],
              [-65.29316158799992, 67.94049713700008],
              [-65.18150794199994, 67.96723053600005],
              [-65.15009518099993, 67.98948802300004],
              [-65.18329830599993, 68.01618073100008],
              [-65.16820227799991, 68.03115469000005],
              [-65.14911861899992, 68.03025950700004],
              [-65.12804114499994, 68.02407461100006],
              [-65.10692298099991, 68.02301666900007],
              [-65.09736080599993, 68.02704498900005],
              [-65.09190833199995, 68.03221263200004],
              [-65.08726966099994, 68.03778717700004],
              [-65.08027096299992, 68.04291413000004],
              [-65.05370032499991, 68.05243561400005],
              [-65.02501380099994, 68.05719635600008],
              [-64.96479244699992, 68.05243561400005],
              [-64.85020911399994, 68.01776764500005],
              [-64.77985592399995, 68.00828685100004],
              [-64.74970455599993, 68.00071849200003],
              [-64.71955318899995, 67.98517487200007],
              [-64.75885982999995, 67.96539948100008],
              [-64.88878333199995, 67.94037506700005],
              [-65.01427161399994, 67.94855377800008],
              [-65.06659908799992, 67.93427155200004],
              [-65.03673255099994, 67.92544179900005],
              [-64.97236080599993, 67.92479075700004],
              [-64.94306393099993, 67.91376373900005],
              [-65.00865637899994, 67.86888255400004],
              [-65.04564368399991, 67.85175202000005],
              [-65.08368893099993, 67.84491608300004],
              [-65.08495032499991, 67.84723541900007],
              [-65.09727942599994, 67.86196523600006],
              [-65.10875403599994, 67.86664459800005],
              [-65.11290442599994, 67.85712311400005],
              [-65.11168372299994, 67.84577057500007],
              [-65.10692298099991, 67.84491608300004],
              [-65.14183508999992, 67.80971914300005],
              [-65.14911861899992, 67.79645416900007],
              [-65.13707434799994, 67.79633209800005],
              [-65.12653561099995, 67.79970937700006],
              [-65.07599850199995, 67.82558828300006],
              [-65.06041419199994, 67.82977936400005],
              [-65.03954016799992, 67.83124420800004],
              [-65.02782141799992, 67.82746002800008],
              [-65.01915442599994, 67.81806061400005],
              [-65.01386471299992, 67.80560944200005],
              [-65.01195227799991, 67.79303620000007],
              [-65.01972408799992, 67.78339264500005],
              [-65.03490149599992, 67.78082916900007],
              [-65.04548092399995, 67.77667877800008],
              [-65.03925533799992, 67.76235586100006],
              [-65.07982337099992, 67.75104401200008],
              [-65.12336178299995, 67.74603913000004],
              [-65.16405188699991, 67.73554108300004],
              [-65.19627844999991, 67.70770905200004],
              [-65.20075436099995, 67.69696686400005],
              [-65.20270748599995, 67.68398672100005],
              [-65.20311438699991, 67.65619538000004],
              [-65.19481360599991, 67.64374420800004],
              [-65.17817135299993, 67.63947174700007],
              [-65.16559811099995, 67.64423248900005],
              [-65.16962643099993, 67.65936920800004],
              [-65.15294348899994, 67.67450592700004],
              [-65.14716549399992, 67.69106679900005],
              [-65.13886471299992, 67.70734284100007],
              [-65.11436926999994, 67.72199127800008],
              [-65.09727942599994, 67.72573476800005],
              [-65.06383216099994, 67.72614166900007],
              [-65.04670162699995, 67.72821686400005],
              [-65.03758704299992, 67.73094310100004],
              [-65.02985592399995, 67.73444245000007],
              [-65.02350826699995, 67.73822663000004],
              [-65.01878821499992, 67.74188873900005],
              [-65.01524817599994, 67.74827708500004],
              [-65.01707923099991, 67.75389232000003],
              [-65.01976477799991, 67.75853099200003],
              [-65.01878821499992, 67.76235586100006],
              [-65.00300045499995, 67.76943594000005],
              [-64.94989986899992, 67.77602773600006],
              [-64.93586178299995, 67.78266022300005],
              [-64.92516028599994, 67.78925202000005],
              [-64.91319739499994, 67.79425690300008],
              [-64.89525305899991, 67.79645416900007],
              [-64.87568111899992, 67.79450104400007],
              [-64.83429928299995, 67.78497955900008],
              [-64.81611080599993, 67.78286367400005],
              [-64.81427975199995, 67.77789948100008],
              [-64.80903072799993, 67.75511302300004],
              [-64.80650794199994, 67.74868398600006],
              [-64.81749426999994, 67.72996653900003],
              [-64.82367916599992, 67.71352773600006],
              [-64.83482825399994, 67.70246002800008],
              [-64.86054439999992, 67.70026276200008],
              [-64.86054439999992, 67.69403717700004],
              [-64.82636471299992, 67.69415924700007],
              [-64.79564368399991, 67.69806549700007],
              [-64.77342688699991, 67.71100495000007],
              [-64.7649633449999, 67.73847077000005],
              [-64.76142330599993, 67.76141998900005],
              [-64.75499426999994, 67.78156159100007],
              [-64.75202389199995, 67.80174388200004],
              [-64.75873775899993, 67.82440827000005],
              [-64.74079342399995, 67.82998281500005],
              [-64.72435462099992, 67.82623932500007],
              [-64.70787512899994, 67.81976959800005],
              [-64.68980872299994, 67.81696198100008],
              [-64.68150794199994, 67.81915924700007],
              [-64.66559811099995, 67.82802969000005],
              [-64.65571041599992, 67.83124420800004],
              [-64.62397213399993, 67.83331940300008],
              [-64.60704505099994, 67.83177317900004],
              [-64.50348873599995, 67.80654531500005],
              [-64.45771236899992, 67.78925202000005],
              [-64.45710201699995, 67.76235586100006],
              [-64.40436764199995, 67.77142975500004],
              [-64.37865149599992, 67.77236562700006],
              [-64.36762447799993, 67.75893789300005],
              [-64.37157141799992, 67.75071849200003],
              [-64.39500891799992, 67.72821686400005],
              [-64.39610755099994, 67.72443268400008],
              [-64.39484615799995, 67.71991608300004],
              [-64.39460201699995, 67.71613190300008],
              [-64.39875240799995, 67.71454498900005],
              [-64.4895727199999, 67.71165599200003],
              [-64.54478919199994, 67.70286692900004],
              [-64.59605872299994, 67.68793366100005],
              [-64.64142818899995, 67.66673411700003],
              [-64.62071692599994, 67.66714101800005],
              [-64.44721432199992, 67.69537995000007],
              [-64.39716549399992, 67.69660065300008],
              [-64.37450110599991, 67.70026276200008],
              [-64.35773678299995, 67.70840078300006],
              [-64.3294164699999, 67.72980377800008],
              [-64.31244869699992, 67.73505280200004],
              [-64.28974361899992, 67.72943756700005],
              [-64.26097571499992, 67.71430084800005],
              [-64.23407955599993, 67.69594961100006],
              [-64.21686764199995, 67.68040599200003],
              [-64.20734615799995, 67.65424225500004],
              [-64.22211666599992, 67.63617584800005],
              [-64.2512914699999, 67.62653229400007],
              [-64.28514563699991, 67.62518952000005],
              [-64.25658118399991, 67.61570872600004],
              [-64.22777258999992, 67.61424388200004],
              [-64.10765540299991, 67.62124258000006],
              [-64.07628333199995, 67.61782461100006],
              [-64.07282467399995, 67.60468170800004],
              [-64.07709713399993, 67.58917877800008],
              [-64.09516354099992, 67.56879303600005],
              [-64.10297604099992, 67.55084870000007],
              [-64.07591712099992, 67.54328034100007],
              [-64.05243893099993, 67.54132721600007],
              [-64.04198157499991, 67.53652578300006],
              [-64.04613196499992, 67.52993398600006],
              [-64.06602942599994, 67.52277252800008],
              [-64.07404537699995, 67.52179596600007],
              [-64.10016842399995, 67.52277252800008],
              [-64.10639400899993, 67.51959870000007],
              [-64.10936438699991, 67.50543854400007],
              [-64.11754309799994, 67.50226471600007],
              [-64.24823971299992, 67.46906159100007],
              [-64.26777096299992, 67.46747467700004],
              [-64.44343014199995, 67.48114655200004],
              [-64.38756262899994, 67.46312083500004],
              [-64.32677161399994, 67.45359935100004],
              [-64.20319576699995, 67.45384349200003],
              [-64.09760494699992, 67.46694570500006],
              [-64.04487057199992, 67.46686432500007],
              [-63.99714107999995, 67.45384349200003],
              [-63.96226966099994, 67.42096588700008],
              [-63.94758053299995, 67.40155670800004],
              [-63.94994055899991, 67.38556549700007],
              [-63.94159908799992, 67.36102936400005],
              [-63.954294399999924, 67.34320709800005],
              [-63.978505011999914, 67.33299388200004],
              [-64.00458736899992, 67.33100006700005],
              [-63.92088782499991, 67.31830475500004],
              [-63.90839596299992, 67.30683014500005],
              [-63.92341061099995, 67.29584381700005],
              [-63.957590298999946, 67.29840729400007],
              [-64.01825924399992, 67.31049225500004],
              [-64.39026852149993, 67.33661530150005],
              [-64.76227779899995, 67.36273834800005],
              [-64.79967200399994, 67.35146719000005],
              [-64.36021887899994, 67.30304596600007],
              [-64.25727291599992, 67.30548737200007],
              [-64.23053951699995, 67.29621002800008],
              [-64.28705807199992, 67.27212148600006],
              [-64.34723873599995, 67.25527578300006],
              [-64.39203854099992, 67.25018952000005],
              [-64.52533932199992, 67.26211172100005],
              [-64.78856360599991, 67.22162506700005],
              [-64.81952877499992, 67.20685455900008],
              [-64.77269446499992, 67.19830963700008],
              [-64.72748775899993, 67.20331452000005],
              [-64.63520260299993, 67.22797272300005],
              [-64.57489986899992, 67.23639557500007],
              [-64.29796301999994, 67.23786041900007],
              [-64.01170813699991, 67.28245677300004],
              [-63.98424231699994, 67.28266022300005],
              [-63.962961391999954, 67.27570221600007],
              [-63.99962317599994, 67.22894928600005],
              [-64.02143307199992, 67.21295807500007],
              [-64.05268307199992, 67.20685455900008],
              [-64.09137936099995, 67.20905182500007],
              [-64.14655514199995, 67.22207265800006],
              [-64.16572018099993, 67.21893952000005],
              [-64.20319576699995, 67.20685455900008],
              [-64.60912024599992, 67.14028554900005],
              [-64.66449947799993, 67.11709219000005],
              [-64.69664466099994, 67.08392975500004],
              [-64.69530188699991, 67.01959870000007],
              [-64.70038814999992, 67.00885651200008],
              [-64.67365475199995, 67.00556061400005],
              [-64.65843665299991, 67.00604889500005],
              [-64.64509029899995, 67.01190827000005],
              [-64.63398189999992, 67.02122630400004],
              [-64.62885494699992, 67.02692291900007],
              [-64.61091061099995, 67.07758209800005],
              [-64.60724850199995, 67.08392975500004],
              [-64.59679114499994, 67.09406159100007],
              [-64.57359778599994, 67.10643138200004],
              [-64.56293697799993, 67.11493561400005],
              [-64.53600012899994, 67.12982819200005],
              [-64.49653072799993, 67.13861725500004],
              [-64.34723873599995, 67.14541250200006],
              [-64.29234778599994, 67.15770091400003],
              [-64.24140377499992, 67.16339752800008],
              [-64.14171301999994, 67.18695709800005],
              [-63.96186275899993, 67.18797435100004],
              [-63.945749477999925, 67.19098541900007],
              [-63.930531378999945, 67.19623444200005],
              [-63.91856848899994, 67.20376211100006],
              [-63.89720618399991, 67.23505280200004],
              [-63.88849850199995, 67.24160390800006],
              [-63.88072669199994, 67.24119700700004],
              [-63.846913214999915, 67.23476797100005],
              [-63.785145636999914, 67.24160390800006],
              [-63.77717037699995, 67.23871491100005],
              [-63.76549231699994, 67.22394440300008],
              [-63.757883266999954, 67.21771881700005],
              [-63.7434789699999, 67.21710846600007],
              [-63.68927975199995, 67.23476797100005],
              [-63.56749426999994, 67.24408600500004],
              [-63.50487219999991, 67.24066803600005],
              [-63.44908606699994, 67.22797272300005],
              [-63.453968878999945, 67.21539948100008],
              [-63.455922003999945, 67.20123932500007],
              [-63.45588131399995, 67.17670319200005],
              [-63.46312415299991, 67.16811758000006],
              [-63.539051886999914, 67.11115143400008],
              [-63.668527798999946, 67.06232330900008],
              [-63.737497524999924, 67.04755280200004],
              [-63.76805579299992, 67.02594635600008],
              [-63.80040442599994, 66.99298737200007],
              [-63.79584713399993, 66.98090241100005],
              [-63.77118893099993, 66.96039459800005],
              [-63.7708227199999, 66.98541901200008],
              [-63.76740475199995, 67.00336334800005],
              [-63.75727291599992, 67.01703522300005],
              [-63.73700924399992, 67.02928294500003],
              [-63.67450924399992, 67.05263906500005],
              [-63.55072994699992, 67.07119375200006],
              [-63.49266516799992, 67.09162018400008],
              [-63.439442511999914, 67.12128327000005],
              [-63.39818274599992, 67.15623607000003],
              [-63.398508266999954, 67.16828034100007],
              [-63.41161048099991, 67.18109772300005],
              [-63.42145748599995, 67.19676341400003],
              [-63.412098761999914, 67.21771881700005],
              [-63.33238684799994, 67.28253815300008],
              [-63.29649817599994, 67.30565013200004],
              [-63.285227016999954, 67.31049225500004],
              [-63.26622473899994, 67.31256745000007],
              [-63.212880011999914, 67.30304596600007],
              [-63.20348059799994, 67.29877350500004],
              [-63.20881100199995, 67.28937409100007],
              [-63.22130286399994, 67.27997467700004],
              [-63.23334713399993, 67.27570221600007],
              [-63.24775143099993, 67.27301666900007],
              [-63.29137122299994, 67.25527578300006],
              [-63.29137122299994, 67.24774811400005],
              [-63.25849361899992, 67.24835846600007],
              [-63.22057044199994, 67.25714752800008],
              [-63.18720455599993, 67.27334219000005],
              [-63.16791744699992, 67.29621002800008],
              [-63.18903561099995, 67.30512116100005],
              [-63.20946204299992, 67.31671784100007],
              [-63.16364498599995, 67.33755117400005],
              [-63.11705481699994, 67.33026764500005],
              [-63.07127844999991, 67.31281159100007],
              [-63.02757727799991, 67.30304596600007],
              [-63.002023891999954, 67.28799062700006],
              [-62.98127193899995, 67.25495026200008],
              [-62.97691809799994, 67.22186920800004],
              [-63.010935024999924, 67.20115794500003],
              [-63.04320227799991, 67.17438385600008],
              [-63.058664516999954, 67.16583893400008],
              [-63.250436977999925, 67.13231028900003],
              [-63.26740475199995, 67.12327708500004],
              [-63.28083248599995, 67.11082591400003],
              [-63.28425045499995, 67.09882233300004],
              [-63.277780727999925, 67.09076569200005],
              [-63.2708227199999, 67.08661530200004],
              [-63.22992916599992, 67.03681061400005],
              [-63.22345943899995, 67.01691315300008],
              [-63.22284908799992, 67.00023021000004],
              [-63.22748775899993, 66.98602936400005],
              [-63.236765102999925, 66.97406647300005],
              [-63.28502356699994, 66.94745514500005],
              [-63.346913214999915, 66.93569570500006],
              [-63.46955318899995, 66.92694733300004],
              [-63.52411861899992, 66.91689687700006],
              [-63.55064856699994, 66.90680573100008],
              [-63.56513424399992, 66.89215729400007],
              [-63.56391354099992, 66.88629791900007],
              [-63.55443274599992, 66.87262604400007],
              [-63.55211341099994, 66.86798737200007],
              [-63.55549068899995, 66.85643138200004],
              [-63.56407630099994, 66.84829336100006],
              [-63.58686275899993, 66.83755117400005],
              [-63.6145727199999, 66.82982005400004],
              [-63.70970618399991, 66.82322825700004],
              [-63.77289791599992, 66.83209870000007],
              [-63.8059789699999, 66.83152903900003],
              [-63.8196508449999, 66.81708405200004],
              [-63.572255011999914, 66.80955638200004],
              [-63.52802486899992, 66.81818268400008],
              [-63.50263424399992, 66.82623932500007],
              [-63.48692786399994, 66.83413320500006],
              [-63.480458136999914, 66.84027741100005],
              [-63.47724361899992, 66.84601471600007],
              [-63.47883053299995, 66.85260651200008],
              [-63.49555416599992, 66.87099844000005],
              [-63.49592037699995, 66.87848541900007],
              [-63.492746548999946, 66.88593170800004],
              [-63.490671352999925, 66.89590078300006],
              [-63.48680579299992, 66.90534088700008],
              [-63.47748775899993, 66.91046784100007],
              [-63.466013149999924, 66.91254303600005],
              [-63.45588131399995, 66.91258372600004],
              [-63.44245357999995, 66.91083405200004],
              [-63.43614661399994, 66.90717194200005],
              [-63.423817511999914, 66.88043854400007],
              [-63.41551673099991, 66.83755117400005],
              [-63.41466223899994, 66.80365631700005],
              [-63.42365475199995, 66.77236562700006],
              [-63.45588131399995, 66.70722077000005],
              [-63.42845618399991, 66.70783112200007],
              [-63.41307532499991, 66.71161530200004],
              [-63.40119381399995, 66.72101471600007],
              [-63.38422604099992, 66.73851146000004],
              [-63.37254798099991, 66.75340403900003],
              [-63.349598761999914, 66.79035065300008],
              [-63.33613033799992, 66.80613841400003],
              [-63.32843990799995, 66.83795807500007],
              [-63.34589596299992, 66.86815013200004],
              [-63.34906979099992, 66.89069245000007],
              [-63.29853268099993, 66.89960358300004],
              [-63.23395748599995, 66.90302155200004],
              [-63.20331783799992, 66.90908437700006],
              [-63.129750128999945, 66.93797435100004],
              [-62.99909420499995, 66.94879791900007],
              [-62.99115963399993, 66.95498281500005],
              [-62.98530025899993, 66.96222565300008],
              [-62.97606360599991, 66.96784088700008],
              [-62.94599361899992, 66.97247955900008],
              [-62.90501868399991, 66.97304922100005],
              [-62.865305141999954, 66.96914297100005],
              [-62.83893795499995, 66.96039459800005],
              [-62.844593878999945, 66.94440338700008],
              [-62.842966274999924, 66.91689687700006],
              [-62.836008266999954, 66.88711172100005],
              [-62.82591712099992, 66.86420319200005],
              [-62.82213294199994, 66.82721588700008],
              [-62.82274329299992, 66.80145905200004],
              [-62.829335089999915, 66.78974030200004],
              [-62.83490963399993, 66.78534577000005],
              [-62.86005611899992, 66.75433991100005],
              [-62.86676998599995, 66.73883698100008],
              [-62.867176886999914, 66.72907135600008],
              [-62.86558997299994, 66.72011953300006],
              [-62.86620032499991, 66.70722077000005],
              [-62.86005611899992, 66.70722077000005],
              [-62.87531490799995, 66.69086334800005],
              [-62.89781653599994, 66.67279694200005],
              [-62.91181393099993, 66.65477122600004],
              [-62.901600714999915, 66.63825104400007],
              [-62.88780676999994, 66.65143463700008],
              [-62.842640753999945, 66.66941966400003],
              [-62.822824673999946, 66.68329498900005],
              [-62.82188880099994, 66.69086334800005],
              [-62.831247524999924, 66.71198151200008],
              [-62.83271236899992, 66.72085195500006],
              [-62.82721920499995, 66.72736237200007],
              [-62.8059789699999, 66.73956940300008],
              [-62.79796301999994, 66.74811432500007],
              [-62.80540930899991, 66.74811432500007],
              [-62.787180141999954, 66.76776764500005],
              [-62.76671301999994, 66.77692291900007],
              [-62.75019283799992, 66.78803131700005],
              [-62.743356899999924, 66.81338125200006],
              [-62.74705969999991, 66.81842682500007],
              [-62.77440344999991, 66.84125397300005],
              [-62.775949673999946, 66.85077545800004],
              [-62.75666256399995, 66.86758047100005],
              [-62.75080318899995, 66.87848541900007],
              [-62.75361080599993, 66.88662344000005],
              [-62.767567511999914, 66.90241120000007],
              [-62.77131100199995, 66.91258372600004],
              [-62.76939856699994, 66.92104726800005],
              [-62.763661261999914, 66.92877838700008],
              [-62.74705969999991, 66.94306061400005],
              [-62.73017330599993, 66.95026276200008],
              [-62.69562740799995, 66.94745514500005],
              [-62.68158932199992, 66.94989655200004],
              [-62.66547604099992, 66.95477936400005],
              [-62.60680091099994, 66.95355866100005],
              [-62.58027096299992, 66.94843170800004],
              [-62.555246548999946, 66.93846263200004],
              [-62.53282630099994, 66.92503489800004],
              [-62.51398678299995, 66.90916575700004],
              [-62.50470943899995, 66.89272695500006],
              [-62.50068111899992, 66.85663483300004],
              [-62.496937628999945, 66.84495677300004],
              [-62.469960089999915, 66.83124420800004],
              [-62.43818111899992, 66.82758209800005],
              [-62.41173255099994, 66.81785716400003],
              [-62.40070553299995, 66.78603750200006],
              [-62.32860266799992, 66.73615143400008],
              [-62.31135006399995, 66.72768789300005],
              [-62.3040258449999, 66.73346588700008],
              [-62.29682369699992, 66.74526601800005],
              [-62.29198157499991, 66.75849030200004],
              [-62.29149329299992, 66.76862213700008],
              [-62.298898891999954, 66.77659739800004],
              [-62.33922278599994, 66.79657623900005],
              [-62.350168423999946, 66.80585358300004],
              [-62.368397589999915, 66.82794830900008],
              [-62.38023841099994, 66.83755117400005],
              [-62.41429602799991, 66.84349192900004],
              [-62.42670650899993, 66.84975820500006],
              [-62.4212133449999, 66.86420319200005],
              [-62.44172115799995, 66.89960358300004],
              [-62.43541419199994, 66.90184153900003],
              [-62.42682857999995, 66.90912506700005],
              [-62.4212133449999, 66.91258372600004],
              [-62.425038214999915, 66.92820872600004],
              [-62.40802975199995, 66.93390534100007],
              [-62.36314856699994, 66.93309153900003],
              [-62.32274329299992, 66.93764883000006],
              [-62.28400631399995, 66.94611237200007],
              [-62.272043423999946, 66.96084219000005],
              [-62.27570553299995, 66.98086172100005],
              [-62.29828854099992, 67.02252838700008],
              [-62.291086391999954, 67.03412506700005],
              [-62.28221594999991, 67.04218170800004],
              [-62.27118893099993, 67.04718659100007],
              [-62.25731360599991, 67.04979075700004],
              [-62.24909420499995, 67.04922109600005],
              [-62.231312628999945, 67.04425690300008],
              [-62.22260494699992, 67.04295482000003],
              [-62.21202551999994, 67.04368724200003],
              [-62.201608852999925, 67.04580312700006],
              [-62.181630011999914, 67.05292389500005],
              [-62.140695766999954, 67.06150950700004],
              [-62.09003658799992, 67.05975983300004],
              [-62.04084225199995, 67.05060455900008],
              [-62.00409908799992, 67.03681061400005],
              [-62.03343665299991, 67.01361725500004],
              [-62.04759680899991, 66.99835846600007],
              [-62.05809485599991, 66.98151276200008],
              [-62.06000729099992, 66.97357819200005],
              [-62.06244869699992, 66.95319245000007],
              [-62.064890102999925, 66.94611237200007],
              [-62.07323157499991, 66.93878815300008],
              [-62.096140102999925, 66.92670319200005],
              [-62.105905727999925, 66.91941966400003],
              [-62.08356686099995, 66.91225820500006],
              [-62.05817623599995, 66.90851471600007],
              [-62.034413214999915, 66.90859609600005],
              [-62.01716061099995, 66.91258372600004],
              [-61.95600338399993, 66.96303945500006],
              [-61.94432532499991, 66.96942780200004],
              [-61.927723761999914, 66.97406647300005],
              [-61.906320766999954, 66.97614166900007],
              [-61.83897864499994, 66.97406647300005],
              [-61.844309048999946, 66.96621328300006],
              [-61.86628170499995, 66.94611237200007],
              [-61.845814581999946, 66.93724192900004],
              [-61.82416744699992, 66.94106679900005],
              [-61.801218227999925, 66.94920482000003],
              [-61.77692623599995, 66.95355866100005],
              [-61.75361080599993, 66.95123932500007],
              [-61.73924719999991, 66.94456614800004],
              [-61.73607337099992, 66.93301015800006],
              [-61.746530727999925, 66.91608307500007],
              [-61.79710852799991, 66.89374420800004],
              [-61.93134518099993, 66.90534088700008],
              [-61.989491339999915, 66.89590078300006],
              [-62.00829016799992, 66.88007233300004],
              [-61.99962317599994, 66.87205638200004],
              [-61.97834225199995, 66.87262604400007],
              [-61.935617641999954, 66.89158763200004],
              [-61.803171352999925, 66.88906484600005],
              [-61.77924557199992, 66.88361237200007],
              [-61.755930141999954, 66.88165924700007],
              [-61.70063229099992, 66.89386627800008],
              [-61.605580206999946, 66.87164948100008],
              [-61.62743079299992, 66.84601471600007],
              [-61.658640102999925, 66.83413320500006],
              [-61.729725714999915, 66.83071523600006],
              [-61.66283118399991, 66.81118398600006],
              [-61.505930141999954, 66.80499909100007],
              [-61.44794674399992, 66.76862213700008],
              [-61.46906490799995, 66.76178620000007],
              [-61.45018469999991, 66.75250885600008],
              [-61.407419399999924, 66.74750397300005],
              [-61.389881964999915, 66.73851146000004],
              [-61.35932369699992, 66.71246979400007],
              [-61.30113684799994, 66.67772044500003],
              [-61.27643795499995, 66.65424225500004],
              [-61.26752682199992, 66.63157786700003],
              [-61.290272589999915, 66.61839427300004],
              [-61.28534908799992, 66.61530182500007],
              [-61.27586829299992, 66.60757070500006],
              [-61.27045650899993, 66.60480377800008],
              [-61.28095455599993, 66.59955475500004],
              [-61.31822669199994, 66.59113190300008],
              [-61.34760494699992, 66.57892487200007],
              [-61.35920162699995, 66.57684967700004],
              [-61.37462317599994, 66.57770416900007],
              [-61.38654537699995, 66.58022695500006],
              [-61.39830481699994, 66.58112213700008],
              [-61.41380774599992, 66.57684967700004],
              [-61.41828365799995, 66.57318756700005],
              [-61.42951412699995, 66.56045156500005],
              [-61.43431555899991, 66.55634186400005],
              [-61.43822180899991, 66.54653554900005],
              [-61.576283331999946, 66.55048248900005],
              [-61.598825649999924, 66.55634186400005],
              [-61.61546790299991, 66.56582265800006],
              [-61.622263149999924, 66.57514069200005],
              [-61.62596594999991, 66.58543528900003],
              [-61.63353430899991, 66.59796784100007],
              [-61.6458227199999, 66.60797760600008],
              [-61.734445766999954, 66.64671458500004],
              [-61.776600714999915, 66.65473053600005],
              [-61.86628170499995, 66.65875885600008],
              [-61.90522213399993, 66.66864655200004],
              [-61.95331783799992, 66.68744538000004],
              [-61.999256964999915, 66.69887929900005],
              [-62.031361456999946, 66.68671295800004],
              [-62.01703854099992, 66.67226797100005],
              [-62.027333136999914, 66.65908437700006],
              [-62.04975338399993, 66.64948151200008],
              [-62.18842525899993, 66.63206614800004],
              [-62.18842525899993, 66.62523021000004],
              [-62.12352454299992, 66.61029694200005],
              [-62.089100714999915, 66.60903554900005],
              [-62.06151282499991, 66.62181224200003],
              [-62.03510494699992, 66.63996002800008],
              [-62.00499426999994, 66.64826080900008],
              [-61.97313391799992, 66.64935944200005],
              [-61.821522589999915, 66.62864817900004],
              [-61.79401607999995, 66.61469147300005],
              [-61.775949673999946, 66.59910716400003],
              [-61.66771399599992, 66.52578359600005],
              [-61.64338131399995, 66.51349518400008],
              [-61.60509192599994, 66.50556061400005],
              [-61.591053839999915, 66.49795156500005],
              [-61.58112545499995, 66.48798248900005],
              [-61.582020636999914, 66.47785065300008],
              [-61.59467525899993, 66.47020091400003],
              [-61.61302649599992, 66.46499258000006],
              [-61.64720618399991, 66.46015045800004],
              [-61.70470130099994, 66.46238841400003],
              [-61.72288977799991, 66.46015045800004],
              [-61.736317511999914, 66.45384349200003],
              [-61.76362057199992, 66.43646881700005],
              [-61.77753658799992, 66.43280670800004],
              [-61.79478919199994, 66.43496328300006],
              [-61.824208136999914, 66.44440338700008],
              [-61.83861243399991, 66.44647858300004],
              [-61.87682044199994, 66.44647858300004],
              [-61.883371548999946, 66.44456614800004],
              [-61.89488684799994, 66.43573639500005],
              [-61.900461391999954, 66.43280670800004],
              [-61.98981686099995, 66.41917552300004],
              [-61.98981686099995, 66.41233958500004],
              [-61.95929928299995, 66.40448639500005],
              [-61.92756100199995, 66.40631745000007],
              [-61.86628170499995, 66.41917552300004],
              [-61.56464596299992, 66.41917552300004],
              [-61.54942786399994, 66.41644928600005],
              [-61.54137122299994, 66.40957265800006],
              [-61.53465735599991, 66.40062083500004],
              [-61.52367102799991, 66.39183177300004],
              [-61.47752844999991, 66.37938060100004],
              [-61.4622289699999, 66.37140534100007],
              [-61.492298956999946, 66.36741771000004],
              [-61.54169674399992, 66.34926992400005],
              [-61.56464596299992, 66.34406159100007],
              [-61.57807369699992, 66.34511953300006],
              [-61.60529537699995, 66.35077545800004],
              [-61.61986243399991, 66.35028717700004],
              [-61.63060462099992, 66.34650299700007],
              [-61.64989173099991, 66.33490631700005],
              [-61.66083736899992, 66.33038971600007],
              [-61.69013424399992, 66.32957591400003],
              [-61.753895636999914, 66.34174225500004],
              [-61.784372524999924, 66.33722565300008],
              [-61.80683346299992, 66.32396067900004],
              [-61.82770748599995, 66.30817291900007],
              [-61.850046352999925, 66.29498932500007],
              [-61.87682044199994, 66.28945547100005],
              [-61.93455969999991, 66.28945547100005],
              [-61.950062628999945, 66.29165273600006],
              [-61.978586391999954, 66.30097077000005],
              [-62.016061977999925, 66.30735911700003],
              [-62.05842037699995, 66.32615794500003],
              [-62.08226477799991, 66.33038971600007],
              [-62.096140102999925, 66.32831452000005],
              [-62.11286373599995, 66.31891510600008],
              [-62.12641354099992, 66.31679922100005],
              [-62.19526119699992, 66.31679922100005],
              [-62.21165930899991, 66.32371653900003],
              [-62.22008216099994, 66.33991120000007],
              [-62.22651119699992, 66.35809967700004],
              [-62.236887173999946, 66.37140534100007],
              [-62.21955318899995, 66.39716217700004],
              [-62.25177975199995, 66.40737539300005],
              [-62.32221432199992, 66.40892161700003],
              [-62.33613033799992, 66.41547272300005],
              [-62.37572180899991, 66.41840241100005],
              [-62.41584225199995, 66.42593008000006],
              [-62.49010169199994, 66.42601146000004],
              [-62.60737057199992, 66.44220612200007],
              [-62.62665768099993, 66.44025299700007],
              [-62.6223852199999, 66.42719147300005],
              [-62.61017818899995, 66.41608307500007],
              [-62.606312628999945, 66.40839264500005],
              [-62.626942511999914, 66.40550364800004],
              [-62.64863033799992, 66.40888092700004],
              [-62.67145748599995, 66.41498444200005],
              [-62.69428463399993, 66.41803620000007],
              [-62.716013149999924, 66.41233958500004],
              [-62.691965298999946, 66.40102773600006],
              [-62.6536352199999, 66.39093659100007],
              [-62.61473548099991, 66.38739655200004],
              [-62.589100714999915, 66.39557526200008],
              [-62.56615149599992, 66.40696849200003],
              [-62.53258216099994, 66.41095612200007],
              [-62.49897213399993, 66.40810781500005],
              [-62.475819464999915, 66.39931875200006],
              [-62.47057044199994, 66.37002187700006],
              [-62.41771399599992, 66.34357330900008],
              [-62.35460364499994, 66.32099030200004],
              [-62.318796352999925, 66.30312734600005],
              [-62.34052486899992, 66.29979075700004],
              [-62.40070553299995, 66.27521393400008],
              [-62.47992916599992, 66.26642487200007],
              [-62.57380123599995, 66.23676178600005],
              [-62.61554928299995, 66.23016998900005],
              [-62.63971920499995, 66.22296784100007],
              [-62.66425533799992, 66.21963125200006],
              [-62.68809973899994, 66.22736237200007],
              [-62.69123287699995, 66.23639557500007],
              [-62.74290930899991, 66.24648672100005],
              [-62.76439368399991, 66.25470612200007],
              [-62.76158606699994, 66.25849030200004],
              [-62.757028774999924, 66.26837799700007],
              [-62.76707923099991, 66.27065664300005],
              [-62.77411861899992, 66.27521393400008],
              [-62.779408331999946, 66.28164297100005],
              [-62.78429114499994, 66.28945547100005],
              [-62.784372524999924, 66.29535553600005],
              [-62.779855923999946, 66.29889557500007],
              [-62.779367641999954, 66.30451080900008],
              [-62.79173743399991, 66.31679922100005],
              [-62.813710089999915, 66.32819245000007],
              [-62.840280727999925, 66.33441803600005],
              [-62.89415442599994, 66.33722565300008],
              [-62.89415442599994, 66.33038971600007],
              [-62.869211391999954, 66.31932200700004],
              [-62.8489477199999, 66.30687083500004],
              [-62.81220455599993, 66.27521393400008],
              [-62.8196508449999, 66.26837799700007],
              [-62.801991339999915, 66.24494049700007],
              [-62.7766820949999, 66.23383209800005],
              [-62.74946041599992, 66.22549062700006],
              [-62.72594153599994, 66.21035390800006],
              [-62.69904537699995, 66.19814687700006],
              [-62.662098761999914, 66.19928620000007],
              [-62.53852291599992, 66.22736237200007],
              [-62.52497311099995, 66.22426992400005],
              [-62.50096594999991, 66.21010976800005],
              [-62.4934789699999, 66.20693594000005],
              [-62.45164954299992, 66.19537995000007],
              [-62.37861080599993, 66.18537018400008],
              [-62.35973059799994, 66.18577708500004],
              [-62.35680091099994, 66.16868724200003],
              [-62.32648678299995, 66.16071198100008],
              [-62.13744055899991, 66.15452708500004],
              [-62.105905727999925, 66.14484284100007],
              [-62.15453040299991, 66.13149648600006],
              [-62.170358852999925, 66.12079498900005],
              [-62.154286261999914, 66.10390859600005],
              [-62.12828528599994, 66.09857819200005],
              [-62.06537838399993, 66.10578034100007],
              [-62.03758704299992, 66.10390859600005],
              [-62.03758704299992, 66.09764232000003],
              [-62.048939581999946, 66.09662506700005],
              [-62.05968176999994, 66.09389883000006],
              [-62.0696508449999, 66.08950429900005],
              [-62.078561977999925, 66.08344147300005],
              [-62.04246985599991, 66.08445872600004],
              [-62.02509518099993, 66.08250560100004],
              [-62.010324673999946, 66.07591380400004],
              [-62.03730221299992, 66.07001373900005],
              [-62.091786261999914, 66.06610748900005],
              [-62.113352016999954, 66.05609772300005],
              [-62.099598761999914, 66.05011627800008],
              [-62.08360755099994, 66.04828522300005],
              [-61.992746548999946, 66.05019765800006],
              [-61.97923743399991, 66.04584381700005],
              [-61.960194464999915, 66.03001536700003],
              [-61.95421301999994, 66.01976146000004],
              [-61.96564693899995, 66.01508209800005],
              [-62.023996548999946, 66.02191803600005],
              [-62.05536861899992, 66.01837799700007],
              [-62.111439581999946, 66.00043366100005],
              [-62.14032955599993, 66.00458405200004],
              [-62.170480923999946, 66.01215241100005],
              [-62.19989986899992, 66.01056549700007],
              [-62.30231686099995, 65.98090241100005],
              [-62.318796352999925, 65.98094310100004],
              [-62.33173580599993, 65.98493073100008],
              [-62.35822506399995, 65.99848053600005],
              [-62.370310024999924, 66.00145091400003],
              [-62.38316809799994, 66.00653717700004],
              [-62.39683997299994, 66.01630280200004],
              [-62.41087805899991, 66.02301666900007],
              [-62.44111080599993, 66.01264069200005],
              [-62.460926886999914, 66.01577383000006],
              [-62.496937628999945, 66.02944570500006],
              [-62.528513149999924, 66.03558991100005],
              [-62.62352454299992, 66.02944570500006],
              [-62.63837643099993, 66.03082916900007],
              [-62.673898891999954, 66.03978099200003],
              [-62.688710089999915, 66.04584381700005],
              [-62.70856686099995, 66.05011627800008],
              [-62.72736568899995, 66.04612864800004],
              [-62.74571692599994, 66.03945547100005],
              [-62.76439368399991, 66.03558991100005],
              [-62.785227016999954, 66.03766510600008],
              [-62.80683346299992, 66.04437897300005],
              [-62.82685299399992, 66.05442942900004],
              [-62.842640753999945, 66.06663646000004],
              [-62.853505011999914, 66.08226146000004],
              [-62.86742102799991, 66.11603424700007],
              [-62.87987219999991, 66.13117096600007],
              [-62.92365475199995, 66.15119049700007],
              [-62.97215735599991, 66.15086497600004],
              [-63.06550045499995, 66.12433502800008],
              [-63.04755611899992, 66.11733633000006],
              [-63.024281378999945, 66.11749909100007],
              [-62.95213782499991, 66.12791575700004],
              [-62.9407445949999, 66.12791575700004],
              [-62.928293423999946, 66.12433502800008],
              [-62.92039954299992, 66.11859772300005],
              [-62.89789791599992, 66.09764232000003],
              [-62.886830206999946, 66.07001373900005],
              [-62.87409420499995, 66.05101146000004],
              [-62.848825649999924, 66.03925202000005],
              [-62.83275305899991, 66.02509186400005],
              [-62.822824673999946, 66.02191803600005],
              [-62.531686977999925, 66.00763580900008],
              [-62.51166744699992, 65.99974192900004],
              [-62.49579830599993, 65.98411692900004],
              [-62.47716223899994, 65.97272370000007],
              [-62.44884192599994, 65.97760651200008],
              [-62.428903774999924, 65.97870514500005],
              [-62.409372524999924, 65.96796295800004],
              [-62.39411373599995, 65.95066966400003],
              [-62.38707434799994, 65.93256256700005],
              [-62.45600338399993, 65.92572663000004],
              [-62.443470831999946, 65.91913483300004],
              [-62.43317623599995, 65.91217682500007],
              [-62.42039954299992, 65.90688711100006],
              [-62.40070553299995, 65.90521881700005],
              [-62.38133704299992, 65.91209544500003],
              [-62.36860104099992, 65.91478099200003],
              [-62.35973059799994, 65.91209544500003],
              [-62.358265753999945, 65.90375397300005],
              [-62.36347408799992, 65.89655182500007],
              [-62.3704320949999, 65.89203522300005],
              [-62.37401282499991, 65.89158763200004],
              [-62.371937628999945, 65.87616608300004],
              [-62.369577602999925, 65.86810944200005],
              [-62.36237545499995, 65.86155833500004],
              [-62.30638587099992, 65.82892487200007],
              [-62.29149329299992, 65.82269928600005],
              [-62.30211341099994, 65.81171295800004],
              [-62.31773841099994, 65.81049225500004],
              [-62.35289466099994, 65.81586334800005],
              [-62.369252081999946, 65.81378815300008],
              [-62.39985104099992, 65.80438873900005],
              [-62.510324673999946, 65.79328034100007],
              [-62.53852291599992, 65.80223216400003],
              [-62.52485104099992, 65.81586334800005],
              [-62.53779049399992, 65.81854889500005],
              [-62.54718990799995, 65.81663646000004],
              [-62.55565344999991, 65.81281159100007],
              [-62.56578528599994, 65.80971914300005],
              [-62.582468227999925, 65.80780670800004],
              [-62.644602016999954, 65.81077708500004],
              [-62.71039791599992, 65.82754140800006],
              [-62.71845455599993, 65.83197663000004],
              [-62.73277747299994, 65.84686920800004],
              [-62.742624477999925, 65.85382721600007],
              [-62.75548255099994, 65.85932038000004],
              [-62.76911373599995, 65.86298248900005],
              [-62.78087317599994, 65.86432526200008],
              [-62.79246985599991, 65.86701080900008],
              [-62.79657955599993, 65.87392812700006],
              [-62.798898891999954, 65.88279857000003],
              [-62.80540930899991, 65.89158763200004],
              [-62.8255102199999, 65.90082428600005],
              [-62.85224361899992, 65.90766022300005],
              [-62.87079830599993, 65.90814850500004],
              [-62.86620032499991, 65.89838288000004],
              [-62.87169348899994, 65.89227936400005],
              [-62.87287350199995, 65.88934967700004],
              [-62.87364661399994, 65.88475169500003],
              [-62.82848059799994, 65.86774323100008],
              [-62.81220455599993, 65.86432526200008],
              [-62.815297003999945, 65.86025625200006],
              [-62.81708736899992, 65.85667552300004],
              [-62.81981360599991, 65.85358307500007],
              [-62.82591712099992, 65.85065338700008],
              [-62.82591712099992, 65.84320709800005],
              [-62.80626380099994, 65.83930084800005],
              [-62.74176998599995, 65.81362539300005],
              [-62.728586391999954, 65.81297435100004],
              [-62.69896399599992, 65.81586334800005],
              [-62.67487545499995, 65.80849844000005],
              [-62.61168372299994, 65.77606842700004],
              [-62.58226477799991, 65.76870351800005],
              [-62.57176673099991, 65.76260000200006],
              [-62.57396399599992, 65.74872467700004],
              [-62.582102016999954, 65.73362864800004],
              [-62.589100714999915, 65.72402578300006],
              [-62.60224361899992, 65.72333405200004],
              [-62.65282141799992, 65.73273346600007],
              [-62.689442511999914, 65.74453359600005],
              [-62.82664954299992, 65.76801178600005],
              [-62.84638424399992, 65.76870351800005],
              [-62.81977291599992, 65.73200104400007],
              [-62.78229732999995, 65.71942780200004],
              [-62.68809973899994, 65.71344635600008],
              [-62.66978919199994, 65.70571523600006],
              [-62.640736456999946, 65.68378327000005],
              [-62.59801184799994, 65.67487213700008],
              [-62.594186977999925, 65.66400788000004],
              [-62.60142981699994, 65.65058014500005],
              [-62.61298580599993, 65.63837311400005],
              [-62.61823482999995, 65.62124258000006],
              [-62.635609503999945, 65.59955475500004],
              [-62.65717525899993, 65.58877187700006],
              [-62.675038214999915, 65.60419342700004],
              [-62.65326900899993, 65.63076406500005],
              [-62.67516028599994, 65.63906484600005],
              [-62.71056067599994, 65.63410065300008],
              [-62.729074673999946, 65.62099844000005],
              [-62.72594153599994, 65.60077545800004],
              [-62.73066158799992, 65.59308502800008],
              [-62.74705969999991, 65.58999258000006],
              [-62.76695716099994, 65.59125397300005],
              [-62.78510494699992, 65.59520091400003],
              [-62.80235755099994, 65.60162995000007],
              [-62.8196508449999, 65.61041901200008],
              [-62.82481848899994, 65.61660390800006],
              [-62.82640540299991, 65.62913646000004],
              [-62.83238684799994, 65.63153717700004],
              [-62.84394283799992, 65.63178131700005],
              [-62.85053463399993, 65.63328685100004],
              [-62.85496985599991, 65.63743724200003],
              [-62.86005611899992, 65.64520905200004],
              [-62.862538214999915, 65.65477122600004],
              [-62.86620032499991, 65.69643789300005],
              [-62.87608801999994, 65.72394440300008],
              [-62.90058346299992, 65.74774811400005],
              [-62.93211829299992, 65.76056549700007],
              [-62.96308346299992, 65.75507233300004],
              [-62.934803839999915, 65.74188873900005],
              [-62.92072506399995, 65.73334381700005],
              [-62.91466223899994, 65.72402578300006],
              [-62.91315670499995, 65.69721100500004],
              [-62.90778561099995, 65.67251211100006],
              [-62.89696204299992, 65.64996979400007],
              [-62.896555141999954, 65.64081452000005],
              [-62.904733852999925, 65.62783437700006],
              [-62.95966549399992, 65.58999258000006],
              [-62.992258266999954, 65.58844635600008],
              [-63.00133216099994, 65.59406159100007],
              [-63.01085364499994, 65.61041901200008],
              [-63.01044674399992, 65.61855703300006],
              [-63.00853430899991, 65.62775299700007],
              [-63.013742641999954, 65.63523997600004],
              [-63.16010494699992, 65.64923737200007],
              [-63.16816158799992, 65.64496491100005],
              [-63.16169186099995, 65.63153717700004],
              [-63.196156378999945, 65.63373444200005],
              [-63.21617591099994, 65.64960358300004],
              [-63.23114986899992, 65.67182038000004],
              [-63.250436977999925, 65.69301992400005],
              [-63.30492102799991, 65.72284577000005],
              [-63.32953854099992, 65.74140045800004],
              [-63.339833136999914, 65.76496002800008],
              [-63.35204016799992, 65.78229401200008],
              [-63.43232174399992, 65.84686920800004],
              [-63.44749915299991, 65.87372467700004],
              [-63.45990963399993, 65.90717194200005],
              [-63.47642981699994, 65.93357982000003],
              [-63.50125077999991, 65.93874746300008],
              [-63.50470943899995, 65.93817780200004],
              [-63.51008053299995, 65.93650950700004],
              [-63.51427161399994, 65.93292877800008],
              [-63.51793372299994, 65.92572663000004],
              [-63.51048743399991, 65.92572663000004],
              [-63.51793372299994, 65.91958242400005],
              [-63.51158606699994, 65.90770091400003],
              [-63.51447506399995, 65.89777252800008],
              [-63.53160559799994, 65.87791575700004],
              [-63.483265753999945, 65.84918854400007],
              [-63.41193600199995, 65.76268138200004],
              [-63.36713619699992, 65.73395416900007],
              [-63.3743383449999, 65.72919342700004],
              [-63.38764400899993, 65.71344635600008],
              [-63.37604732999995, 65.70661041900007],
              [-63.36473548099991, 65.69672272300005],
              [-63.354685024999924, 65.68488190300008],
              [-63.34666907499991, 65.67251211100006],
              [-63.37572180899991, 65.67230866100005],
              [-63.463327602999925, 65.68618398600006],
              [-63.5794164699999, 65.67934804900005],
              [-63.59247799399992, 65.66962311400005],
              [-63.60191809799994, 65.66559479400007],
              [-63.62336178299995, 65.67357005400004],
              [-63.71080481699994, 65.68252187700006],
              [-63.72142493399991, 65.67926666900007],
              [-63.71430416599992, 65.66990794500003],
              [-63.689564581999946, 65.65509674700007],
              [-63.66425533799992, 65.64891185100004],
              [-63.58625240799995, 65.65884023600006],
              [-63.56159420499995, 65.65452708500004],
              [-63.519602016999954, 65.63580963700008],
              [-63.49750729099992, 65.63153717700004],
              [-63.38422604099992, 65.63837311400005],
              [-63.36656653599994, 65.63349030200004],
              [-63.34862219999991, 65.62181224200003],
              [-63.31871497299994, 65.59674713700008],
              [-63.32453365799995, 65.59495677300004],
              [-63.32787024599992, 65.59284088700008],
              [-63.33197994699992, 65.59096914300005],
              [-63.339833136999914, 65.58999258000006],
              [-63.33503170499995, 65.58063385600008],
              [-63.33238684799994, 65.57689036700003],
              [-63.35334225199995, 65.54682038000004],
              [-63.36664791599992, 65.53831614800004],
              [-63.48009192599994, 65.52850983300004],
              [-63.496530727999925, 65.53343333500004],
              [-63.51276607999995, 65.54511139500005],
              [-63.554676886999914, 65.58315664300005],
              [-63.56786048099991, 65.59149811400005],
              [-63.58360755099994, 65.59564850500004],
              [-63.60737057199992, 65.59674713700008],
              [-63.60737057199992, 65.58999258000006],
              [-63.60175533799992, 65.58856842700004],
              [-63.58686275899993, 65.58315664300005],
              [-63.58686275899993, 65.57689036700003],
              [-63.589955206999946, 65.57050202000005],
              [-63.58674068899995, 65.56366608300004],
              [-63.57258053299995, 65.54897695500006],
              [-63.59679114499994, 65.55280182500007],
              [-63.60883541599992, 65.55215078300006],
              [-63.620350714999915, 65.54897695500006],
              [-63.60179602799991, 65.53245677300004],
              [-63.542185024999924, 65.52171458500004],
              [-63.52415930899991, 65.50116608300004],
              [-63.530466274999924, 65.48558177300004],
              [-63.518747524999924, 65.48240794500003],
              [-63.48692786399994, 65.48749420800004],
              [-63.45274817599994, 65.48761627800008],
              [-63.43927975199995, 65.48558177300004],
              [-63.29137122299994, 65.43976471600007],
              [-63.29137122299994, 65.43231842700004],
              [-63.313710089999915, 65.43256256700005],
              [-63.35216223899994, 65.43960195500006],
              [-63.37336178299995, 65.43976471600007],
              [-63.398508266999954, 65.43317291900007],
              [-63.40868079299992, 65.43231842700004],
              [-63.42414303299995, 65.43374258000006],
              [-63.5716039699999, 65.47406647300005],
              [-63.627390102999925, 65.48029205900008],
              [-63.65510006399995, 65.46702708500004],
              [-63.463327602999925, 65.40558502800008],
              [-63.406239386999914, 65.40302155200004],
              [-63.38764400899993, 65.39813873900005],
              [-63.52415930899991, 65.39191315300008],
              [-63.52415930899991, 65.38507721600007],
              [-63.463327602999925, 65.38507721600007],
              [-63.463327602999925, 65.37763092700004],
              [-63.47288977799991, 65.37807851800005],
              [-63.48094641799992, 65.37669505400004],
              [-63.49750729099992, 65.37083567900004],
              [-63.470773891999954, 65.36066315300008],
              [-63.46955318899995, 65.35716380400004],
              [-63.445301886999914, 65.35301341400003],
              [-63.37336178299995, 65.32982005400004],
              [-63.38231360599991, 65.31378815300008],
              [-63.38764400899993, 65.30878327000005],
              [-63.36302649599992, 65.30890534100007],
              [-63.35114498599995, 65.30678945500006],
              [-63.339833136999914, 65.30255768400008],
              [-63.36664791599992, 65.29604726800005],
              [-63.41816158799992, 65.30044179900005],
              [-63.442250128999945, 65.29572174700007],
              [-63.45661373599995, 65.28489817900004],
              [-63.44672604099992, 65.27899811400005],
              [-63.42625891799992, 65.27440013200004],
              [-63.40868079299992, 65.26776764500005],
              [-63.39830481699994, 65.27326080900008],
              [-63.38776607999995, 65.27533600500004],
              [-63.363718227999925, 65.27521393400008],
              [-63.352406378999945, 65.27191803600005],
              [-63.3430883449999, 65.26471588700008],
              [-63.34064693899995, 65.25747304900005],
              [-63.35033118399991, 65.25413646000004],
              [-63.405466274999924, 65.25385163000004],
              [-63.43342037699995, 65.25014883000006],
              [-63.45588131399995, 65.24115631700005],
              [-63.43407141799992, 65.23281484600005],
              [-63.346913214999915, 65.22687409100007],
              [-63.32380123599995, 65.22150299700007],
              [-63.31330318899995, 65.20978424700007],
              [-63.31773841099994, 65.19806549700007],
              [-63.33954830599993, 65.19269440300008],
              [-63.34845943899995, 65.19456614800004],
              [-63.36237545499995, 65.20343659100007],
              [-63.37336178299995, 65.20636627800008],
              [-63.380075649999924, 65.20579661700003],
              [-63.40868079299992, 65.20014069200005],
              [-63.494577602999925, 65.20148346600007],
              [-63.51793372299994, 65.19269440300008],
              [-63.43602454299992, 65.17218659100007],
              [-63.4466039699999, 65.16787344000005],
              [-63.458241339999915, 65.16535065300008],
              [-63.47065182199992, 65.16453685100004],
              [-63.48322506399995, 65.16535065300008],
              [-63.448475714999915, 65.15818919500003],
              [-63.373483852999925, 65.15379466400003],
              [-63.339833136999914, 65.14492422100005],
              [-63.35521399599992, 65.12693919500003],
              [-63.379343227999925, 65.11835358300004],
              [-63.40770423099991, 65.11277903900003],
              [-63.43602454299992, 65.10394928600005],
              [-63.42320716099994, 65.10049062700006],
              [-63.41783606699994, 65.09320709800005],
              [-63.41380774599992, 65.08612702000005],
              [-63.40497799399992, 65.08283112200007],
              [-63.39476477799991, 65.08104075700004],
              [-63.37665768099993, 65.07233307500007],
              [-63.36713619699992, 65.06915924700007],
              [-63.388661261999914, 65.06195709800005],
              [-63.41388912699995, 65.06024811400005],
              [-63.463327602999925, 65.06232330900008],
              [-63.463327602999925, 65.05548737200007],
              [-63.38764400899993, 65.04930247600004],
              [-63.38764400899993, 65.04189687700006],
              [-63.40522213399993, 65.03278229400007],
              [-63.422718878999945, 65.03286367400005],
              [-63.44318600199995, 65.03571198100008],
              [-63.46955318899995, 65.03506094000005],
              [-63.460926886999914, 65.01544830900008],
              [-63.45588131399995, 65.00771719000005],
              [-63.47248287699995, 64.99673086100006],
              [-63.53160559799994, 64.97296784100007],
              [-63.5247289699999, 64.97052643400008],
              [-63.510609503999945, 64.96259186400005],
              [-63.504343227999925, 64.95994700700004],
              [-63.52558346299992, 64.94769928600005],
              [-63.533762173999946, 64.94049713700008],
              [-63.53844153599994, 64.93260325700004],
              [-63.53465735599991, 64.92495351800005],
              [-63.52696692599994, 64.91347890800006],
              [-63.52411861899992, 64.90302155200004],
              [-63.53502356699994, 64.89850495000007],
              [-63.59076900899993, 64.90314362200007],
              [-63.65510006399995, 64.91836172100005],
              [-63.638742641999954, 64.92426178600005],
              [-63.63459225199995, 64.93113841400003],
              [-63.64240475199995, 64.93854401200008],
              [-63.66193600199995, 64.94562409100007],
              [-63.62083899599992, 64.95636627800008],
              [-63.60517330599993, 64.96548086100006],
              [-63.60737057199992, 64.98041413000004],
              [-63.602406378999945, 64.99445221600007],
              [-63.61274166599992, 65.00287506700005],
              [-63.629750128999945, 65.00429922100005],
              [-63.64488684799994, 64.99750397300005],
              [-63.65733801999994, 64.98940664300005],
              [-63.702341274999924, 64.98041413000004],
              [-63.73652096299992, 64.96792226800005],
              [-63.756296352999925, 64.96588776200008],
              [-63.7649633449999, 64.97671133000006],
              [-63.773508266999954, 64.97943756700005],
              [-63.82579505099994, 64.98663971600007],
              [-63.82579505099994, 64.99408600500004],
              [-63.82026119699992, 64.99721914300005],
              [-63.81737219999991, 65.00047435100004],
              [-63.815297003999945, 65.00385163000004],
              [-63.81220455599993, 65.00771719000005],
              [-63.81550045499995, 65.00804271000004],
              [-63.82579505099994, 65.00771719000005],
              [-63.82579505099994, 65.01459381700005],
              [-63.7649633449999, 65.01459381700005],
              [-63.767648891999954, 65.01878489800004],
              [-63.76854407499991, 65.01935455900008],
              [-63.77118893099993, 65.02142975500004],
              [-63.7434789699999, 65.03066640800006],
              [-63.65510006399995, 65.04189687700006],
              [-63.68378658799992, 65.05076732000003],
              [-63.71983801999994, 65.05565013200004],
              [-63.7551977199999, 65.05280182500007],
              [-63.78172766799992, 65.03847890800006],
              [-63.80736243399991, 65.02948639500005],
              [-63.84410559799994, 65.03143952000005],
              [-63.87096106699994, 65.04450104400007],
              [-63.86676998599995, 65.06915924700007],
              [-63.88512122299994, 65.08612702000005],
              [-63.88044186099995, 65.10407135600008],
              [-63.86225338399993, 65.12164948100008],
              [-63.8020727199999, 65.16445547100005],
              [-63.791574673999946, 65.17934804900005],
              [-63.80907141799992, 65.18585846600007],
              [-63.83027096299992, 65.18598053600005],
              [-63.85387122299994, 65.18357982000003],
              [-63.873117641999954, 65.17479075700004],
              [-63.884755011999914, 65.14313385600008],
              [-63.892567511999914, 65.14008209800005],
              [-63.89976966099994, 65.14215729400007],
              [-63.901560024999924, 65.14492422100005],
              [-63.94871985599991, 65.10980866100005],
              [-63.968861456999946, 65.10138580900008],
              [-63.99128170499995, 65.09926992400005],
              [-64.01764889199995, 65.10394928600005],
              [-64.05854244699992, 65.12132396000004],
              [-64.07323157499991, 65.12018463700008],
              [-64.07905025899993, 65.10024648600006],
              [-64.08189856699994, 65.07733795800004],
              [-64.09162350199995, 65.06150950700004],
              [-64.10973059799994, 65.05231354400007],
              [-64.1380102199999, 65.04930247600004],
              [-64.15318762899994, 65.05536530200004],
              [-64.21064205599993, 65.09650299700007],
              [-64.20055091099994, 65.10236237200007],
              [-64.19635982999995, 65.10394928600005],
              [-64.19635982999995, 65.11009349200003],
              [-64.21849524599992, 65.10858795800004],
              [-64.2395727199999, 65.10187409100007],
              [-64.25947018099993, 65.09764232000003],
              [-64.27826900899993, 65.10394928600005],
              [-64.25483150899993, 65.11847565300008],
              [-64.20689856699994, 65.16229889500005],
              [-64.17845618399991, 65.17670319200005],
              [-64.10973059799994, 65.18964264500005],
              [-64.07905025899993, 65.20014069200005],
              [-64.07905025899993, 65.20636627800008],
              [-64.11469479099992, 65.20831940300008],
              [-64.22740637899994, 65.20014069200005],
              [-64.23713131399995, 65.19672272300005],
              [-64.25043697799993, 65.18183014500005],
              [-64.26121985599991, 65.17841217700004],
              [-64.27729244699992, 65.17641836100006],
              [-64.29352779899995, 65.17145416900007],
              [-64.31928463399993, 65.15916575700004],
              [-64.32103430899991, 65.15277741100005],
              [-64.32823645699995, 65.15119049700007],
              [-64.33604895699995, 65.15436432500007],
              [-64.34614010299993, 65.17568594000005],
              [-64.3743383449999, 65.17926666900007],
              [-64.38068600199995, 65.18927643400008],
              [-64.38276119699992, 65.19708893400008],
              [-64.39207923099991, 65.21649811400005],
              [-64.39500891799992, 65.22687409100007],
              [-64.39549719999991, 65.23769765800006],
              [-64.39452063699991, 65.24689362200007],
              [-64.39203854099992, 65.25454336100006],
              [-64.38813229099992, 65.26097239800004],
              [-64.37743079299992, 65.26561107000003],
              [-64.35395260299993, 65.28017812700006],
              [-64.33820553299995, 65.29547760600008],
              [-64.35057532499991, 65.30255768400008],
              [-64.36656653599994, 65.29653554900005],
              [-64.38548743399991, 65.28514232000003],
              [-64.39997311099995, 65.27899811400005],
              [-64.40245520699995, 65.28827545800004],
              [-64.40864010299993, 65.28827545800004],
              [-64.39216061099995, 65.30414459800005],
              [-64.33775794199994, 65.33319733300004],
              [-64.32612057199992, 65.34723541900007],
              [-64.25165768099993, 65.39191315300008],
              [-64.25165768099993, 65.39813873900005],
              [-64.26463782499991, 65.40558502800008],
              [-64.25556393099993, 65.41014232000003],
              [-64.24787350199995, 65.41600169500003],
              [-64.24176998599995, 65.42328522300005],
              [-64.23737545499995, 65.43231842700004],
              [-64.28229732999995, 65.43065013200004],
              [-64.29804439999992, 65.42300039300005],
              [-64.29259192599994, 65.40558502800008],
              [-64.30732174399992, 65.40005117400005],
              [-64.33617102799991, 65.39301178600005],
              [-64.34723873599995, 65.38507721600007],
              [-64.35411536399994, 65.37091705900008],
              [-64.35383053299995, 65.36090729400007],
              [-64.35700436099995, 65.35272858300004],
              [-64.37450110599991, 65.34349192900004],
              [-64.42186438699991, 65.33649323100008],
              [-64.43598385299993, 65.32982005400004],
              [-64.44611568899995, 65.31952545800004],
              [-64.46772213399993, 65.29173411700003],
              [-64.47752844999991, 65.28204987200007],
              [-64.47752844999991, 65.27521393400008],
              [-64.45575924399992, 65.24152252800008],
              [-64.4622289699999, 65.20620351800005],
              [-64.50483150899993, 65.14492422100005],
              [-64.53673255099994, 65.10907623900005],
              [-64.55711829299992, 65.09320709800005],
              [-64.56635494699992, 65.10024648600006],
              [-64.57331295499995, 65.12636953300006],
              [-64.59125729099992, 65.13056061400005],
              [-64.61542721299992, 65.12547435100004],
              [-64.64142818899995, 65.12376536700003],
              [-64.64142818899995, 65.13129303600005],
              [-64.63434811099995, 65.13247304900005],
              [-64.62116451699995, 65.13641998900005],
              [-64.61347408799992, 65.13743724200003],
              [-64.62372799399992, 65.14834219000005],
              [-64.63487708199995, 65.15302155200004],
              [-64.63988196499992, 65.15790436400005],
              [-64.6184789699999, 65.18357982000003],
              [-64.61693274599992, 65.19245026200008],
              [-64.62519283799992, 65.19546133000006],
              [-64.64142818899995, 65.19269440300008],
              [-64.64793860599991, 65.18789297100005],
              [-64.65131588399993, 65.18097565300008],
              [-64.65741939999992, 65.17487213700008],
              [-64.68785559799994, 65.17011139500005],
              [-64.7122289699999, 65.16095612200007],
              [-64.73082434799994, 65.15916575700004],
              [-64.71971594999991, 65.17552317900004],
              [-64.71263587099992, 65.18943919500003],
              [-64.7024633449999, 65.20001862200007],
              [-64.68236243399991, 65.20636627800008],
              [-64.71198482999995, 65.21979401200008],
              [-64.71568762899994, 65.22719961100006],
              [-64.70343990799995, 65.23737213700008],
              [-64.69127356699994, 65.24225495000007],
              [-64.66218014199995, 65.24677155200004],
              [-64.64887447799993, 65.24730052300004],
              [-64.64887447799993, 65.25413646000004],
              [-64.68915768099993, 65.25189850500004],
              [-64.70429439999992, 65.25653717700004],
              [-64.71031653599994, 65.27155182500007],
              [-64.71471106699994, 65.27431875200006],
              [-64.72504635299993, 65.27594635600008],
              [-64.73664303299995, 65.27627187700006],
              [-64.74506588399993, 65.27521393400008],
              [-64.75047766799992, 65.27163320500006],
              [-64.7649633449999, 65.25413646000004],
              [-64.79735266799992, 65.23965078300006],
              [-64.83185787699995, 65.24331289300005],
              [-64.86705481699994, 65.25934479400007],
              [-64.90208899599992, 65.28204987200007],
              [-64.85431881399995, 65.28204987200007],
              [-64.86286373599995, 65.29311758000006],
              [-64.87718665299991, 65.29706452000005],
              [-64.89374752499992, 65.29865143400008],
              [-64.90892493399991, 65.30255768400008],
              [-64.90892493399991, 65.30878327000005],
              [-64.89525305899991, 65.30878327000005],
              [-64.87852942599994, 65.31631094000005],
              [-64.83613033799992, 65.32217031500005],
              [-64.81952877499992, 65.32982005400004],
              [-64.81004798099991, 65.32689036700003],
              [-64.77802486899992, 65.31659577000005],
              [-64.75873775899993, 65.31622955900008],
              [-64.7180883449999, 65.32778554900005],
              [-64.68236243399991, 65.34349192900004],
              [-64.79222571499992, 65.35101959800005],
              [-64.89179439999992, 65.33661530200004],
              [-64.91510982999995, 65.34349192900004],
              [-64.88817298099991, 65.35553620000007],
              [-64.81798255099994, 65.36957428600005],
              [-64.75080318899995, 65.39276764500005],
              [-64.67589270699995, 65.40058014500005],
              [-64.64142818899995, 65.41181061400005],
              [-64.61937415299991, 65.42597077000005],
              [-64.60773678299995, 65.43056875200006],
              [-64.50861568899995, 65.43231842700004],
              [-64.48932857999995, 65.42934804900005],
              [-64.47321529899995, 65.42389557500007],
              [-64.45848548099991, 65.42108795800004],
              [-64.44343014199995, 65.42609284100007],
              [-64.43183346299992, 65.43768952000005],
              [-64.40864010299993, 65.48069896000004],
              [-64.42194576699995, 65.48647695500006],
              [-64.43797766799992, 65.48615143400008],
              [-64.45140540299991, 65.47894928600005],
              [-64.45710201699995, 65.46332428600005],
              [-64.46515865799995, 65.44953034100007],
              [-64.48436438699991, 65.44204336100006],
              [-64.50702877499992, 65.44090403900003],
              [-64.52533932199992, 65.44651927300004],
              [-64.51777096299992, 65.44782135600008],
              [-64.49799557199992, 65.45335521000004],
              [-64.49799557199992, 65.45962148600006],
              [-64.61713619699992, 65.45359935100004],
              [-64.63520260299993, 65.46332428600005],
              [-64.64207923099991, 65.47064850500004],
              [-64.65684973899994, 65.46332428600005],
              [-64.67109127499992, 65.45184967700004],
              [-64.67613684799994, 65.44651927300004],
              [-64.69355221299992, 65.43870677300004],
              [-64.70868893099993, 65.43537018400008],
              [-64.74506588399993, 65.43231842700004],
              [-64.79535885299993, 65.42035553600005],
              [-64.81297766799992, 65.41864655200004],
              [-64.87059485599991, 65.42816803600005],
              [-64.88499915299991, 65.42234935100004],
              [-64.95506751199991, 65.40753815300008],
              [-64.99030514199995, 65.39459870000007],
              [-64.98399817599994, 65.37763092700004],
              [-65.01020260299993, 65.36937083500004],
              [-65.04218502499992, 65.37457916900007],
              [-65.07245846299992, 65.38825104400007],
              [-65.08702551999994, 65.39813873900005],
              [-65.13182532499991, 65.42499420800004],
              [-65.14537512899994, 65.43598053600005],
              [-65.14911861899992, 65.44896067900004],
              [-65.14399166599992, 65.46157461100006],
              [-65.14557857999995, 65.47418854400007],
              [-65.16962643099993, 65.48749420800004],
              [-65.14513098899994, 65.49811432500007],
              [-65.11473548099991, 65.50433991100005],
              [-65.02501380099994, 65.51113515800006],
              [-64.92939205599993, 65.52850983300004],
              [-64.93407141799992, 65.53778717700004],
              [-64.9368383449999, 65.54148997600004],
              [-64.93122311099995, 65.54523346600007],
              [-64.90892493399991, 65.55516185100004],
              [-64.90339107999995, 65.55597565300008],
              [-64.89655514199995, 65.55499909100007],
              [-64.89081783799992, 65.55499909100007],
              [-64.88841712099992, 65.55890534100007],
              [-64.88837643099993, 65.56476471600007],
              [-64.88768469999991, 65.56688060100004],
              [-64.88158118399991, 65.56940338700008],
              [-64.86249752499992, 65.58266836100006],
              [-64.85346432199992, 65.58734772300005],
              [-64.84064693899995, 65.58999258000006],
              [-64.82978268099993, 65.58909739800004],
              [-64.80488033799992, 65.58356354400007],
              [-64.79222571499992, 65.58315664300005],
              [-64.80040442599994, 65.59210846600007],
              [-64.83320064999992, 65.60732656500005],
              [-64.83478756399995, 65.61188385600008],
              [-64.8372289699999, 65.62262604400007],
              [-64.83686275899993, 65.63344961100006],
              [-64.83006751199991, 65.63837311400005],
              [-64.73473059799994, 65.64533112200007],
              [-64.71031653599994, 65.65135325700004],
              [-64.71031653599994, 65.65884023600006],
              [-64.83006751199991, 65.66502513200004],
              [-64.85265051999994, 65.66083405200004],
              [-64.86986243399991, 65.65033600500004],
              [-64.96698971299992, 65.55890534100007],
              [-64.99128170499995, 65.54800039300005],
              [-65.02708899599992, 65.54559967700004],
              [-65.09386145699995, 65.54897695500006],
              [-65.15217037699995, 65.54482656500005],
              [-65.18073482999995, 65.54596588700008],
              [-65.20990963399993, 65.55516185100004],
              [-65.22211666599992, 65.56606679900005],
              [-65.21113033799992, 65.57371653900003],
              [-65.19286048099991, 65.58344147300005],
              [-65.18329830599993, 65.60049062700006],
              [-65.19591223899994, 65.60285065300008],
              [-65.29352779899995, 65.56049225500004],
              [-65.31281490799995, 65.55581289300005],
              [-65.32892818899995, 65.56134674700007],
              [-65.34089107999995, 65.58315664300005],
              [-65.32612057199992, 65.58600495000007],
              [-65.31004798099991, 65.59202708500004],
              [-65.30072994699992, 65.60040924700007],
              [-65.30614173099991, 65.61041901200008],
              [-65.30125891799992, 65.62962474200003],
              [-65.26768958199995, 65.63837311400005],
              [-65.22435462099992, 65.63930898600006],
              [-65.17772376199991, 65.63011302300004],
              [-65.11774654899995, 65.63837311400005],
              [-65.10802161399994, 65.64472077000005],
              [-65.10362708199995, 65.67291901200008],
              [-65.09044348899994, 65.67934804900005],
              [-65.05052649599992, 65.68427155200004],
              [-64.97740637899994, 65.70709870000007],
              [-64.9368383449999, 65.71344635600008],
              [-64.85912024599992, 65.71206289300005],
              [-64.82258053299995, 65.71527741100005],
              [-64.79222571499992, 65.72772858300004],
              [-64.82481848899994, 65.73655833500004],
              [-65.00145423099991, 65.72504303600005],
              [-65.06659908799992, 65.71344635600008],
              [-65.09056555899991, 65.70473867400005],
              [-65.13927161399994, 65.67731354400007],
              [-65.15876217399995, 65.66193268400008],
              [-65.18403072799993, 65.65672435100004],
              [-65.45384680899991, 65.67934804900005],
              [-65.44892330599993, 65.68939850500004],
              [-65.40172278599994, 65.74823639500005],
              [-65.38508053299995, 65.76422760600008],
              [-65.37677975199995, 65.77435944200005],
              [-65.37507076699995, 65.78237539300005],
              [-65.38499915299991, 65.78774648600006],
              [-65.40001380099994, 65.78558991100005],
              [-65.41527258999992, 65.77920156500005],
              [-65.44163977799991, 65.75922272300005],
              [-65.46629798099991, 65.74481842700004],
              [-65.49071204299992, 65.73969147300005],
              [-65.50536048099991, 65.75507233300004],
              [-65.50312252499992, 65.76675039300005],
              [-65.49445553299995, 65.77850983300004],
              [-65.47748775899993, 65.79604726800005],
              [-65.45881100199995, 65.83242422100005],
              [-65.45075436099995, 65.84320709800005],
              [-65.37311764199995, 65.89008209800005],
              [-65.36078854099992, 65.90184153900003],
              [-65.35334225199995, 65.91412995000007],
              [-65.33580481699994, 65.92133209800005],
              [-65.28315182199992, 65.92788320500006],
              [-65.25580807199992, 65.93724192900004],
              [-65.21161861899992, 65.94330475500004],
              [-65.15619869699992, 65.96137116100005],
              [-65.12865149599992, 65.96670156500005],
              [-65.13483639199995, 65.96670156500005],
              [-65.10883541599992, 65.96849192900004],
              [-65.06041419199994, 65.98395416900007],
              [-64.96019446499992, 66.00092194200005],
              [-64.93805904899995, 66.00726959800005],
              [-64.90965735599991, 66.00531647300005],
              [-64.80650794199994, 65.97418854400007],
              [-64.81269283799992, 65.97418854400007],
              [-64.79279537699995, 65.97378164300005],
              [-64.7747289699999, 65.97016022300005],
              [-64.75682532499991, 65.96845123900005],
              [-64.7376195949999, 65.97418854400007],
              [-64.74779212099992, 65.98358795800004],
              [-64.76378333199995, 65.99237702000005],
              [-64.78123938699991, 65.99896881700005],
              [-64.81220455599993, 66.00519440300008],
              [-64.83983313699991, 66.02317942900004],
              [-64.85431881399995, 66.02944570500006],
              [-64.85431881399995, 66.03558991100005],
              [-64.82664954299992, 66.05023834800005],
              [-64.80003821499992, 66.07428620000007],
              [-64.77818762899994, 66.10293203300006],
              [-64.7649633449999, 66.13117096600007],
              [-64.75483150899993, 66.16648997600004],
              [-64.74067135299993, 66.19969310100004],
              [-64.71723385299993, 66.22455475500004],
              [-64.63878333199995, 66.24384186400005],
              [-64.56012936099995, 66.28603750200006],
              [-64.51878821499992, 66.29564036700003],
              [-64.4759008449999, 66.29946523600006],
              [-64.42988033799992, 66.31024811400005],
              [-64.38715572799993, 66.32746002800008],
              [-64.35399329299992, 66.35028717700004],
              [-64.36961829299992, 66.35398997600004],
              [-64.37975012899994, 66.35016510600008],
              [-64.38727779899995, 66.34308502800008],
              [-64.39500891799992, 66.33722565300008],
              [-64.4055883449999, 66.33295319200005],
              [-64.41295325399994, 66.33112213700008],
              [-64.42231197799993, 66.33038971600007],
              [-64.42817135299993, 66.33250560100004],
              [-64.43529212099992, 66.34194570500006],
              [-64.43968665299991, 66.34406159100007],
              [-64.45360266799992, 66.34341054900005],
              [-64.46674557199992, 66.34113190300008],
              [-64.52989661399994, 66.31972890800006],
              [-64.54487057199992, 66.31745026200008],
              [-64.56293697799993, 66.31679922100005],
              [-64.58100338399993, 66.31346263200004],
              [-64.61595618399991, 66.29897695500006],
              [-64.71031653599994, 66.28261953300006],
              [-64.76561438699991, 66.25568268400008],
              [-64.79539954299992, 66.23468659100007],
              [-64.81269283799992, 66.21377187700006],
              [-64.80650794199994, 66.21377187700006],
              [-64.81309973899994, 66.20734284100007],
              [-64.82079016799992, 66.20433177300004],
              [-64.82799231699994, 66.20237864800004],
              [-64.83320064999992, 66.19944896000004],
              [-64.83503170499995, 66.19660065300008],
              [-64.83844967399995, 66.18903229400007],
              [-64.85444088399993, 66.16437409100007],
              [-64.85920162699995, 66.15119049700007],
              [-64.85741126199991, 66.14175039300005],
              [-64.85041256399995, 66.12002187700006],
              [-64.87144934799994, 66.10748932500007],
              [-64.92255611899992, 66.09764232000003],
              [-64.95140540299991, 66.08038971600007],
              [-64.96357174399992, 66.07591380400004],
              [-65.02094479099992, 66.07819245000007],
              [-65.03583736899992, 66.07318756700005],
              [-65.05842037699995, 66.06073639500005],
              [-65.20160885299993, 66.02830638200004],
              [-65.23627682199992, 66.02448151200008],
              [-65.25153561099995, 66.03253815300008],
              [-65.25609290299991, 66.03827545800004],
              [-65.2669164699999, 66.04120514500005],
              [-65.28937740799995, 66.04242584800005],
              [-65.29072018099993, 66.03766510600008],
              [-65.30072994699992, 66.01508209800005],
              [-65.30614173099991, 66.00763580900008],
              [-65.31688391799992, 66.00332265800006],
              [-65.36078854099992, 65.99404531500005],
              [-65.38093014199995, 65.98550039300005],
              [-65.39313717399995, 65.98224518400008],
              [-65.75169837099992, 65.97089264500005],
              [-65.82416744699992, 65.95636627800008],
              [-65.86139889199995, 65.95302969000005],
              [-65.89940344999991, 65.95368073100008],
              [-65.9251195949999, 65.95962148600006],
              [-65.93968665299991, 65.97675202000005],
              [-65.94420325399994, 66.01137929900005],
              [-65.94892330599993, 66.02204010600008],
              [-65.95807857999995, 66.03156159100007],
              [-65.96430416599992, 66.04120514500005],
              [-65.96039791599992, 66.05267975500004],
              [-65.94725501199991, 66.05931224200003],
              [-65.93000240799995, 66.06517161700003],
              [-65.91856848899994, 66.07420482000003],
              [-65.92308508999992, 66.09023672100005],
              [-65.90392005099994, 66.09666575700004],
              [-65.86095130099994, 66.09967682500007],
              [-65.84056555899991, 66.10390859600005],
              [-65.67267818899995, 66.16840241100005],
              [-65.63914954299992, 66.17275625200006],
              [-65.62970943899995, 66.18984609600005],
              [-65.61937415299991, 66.20156484600005],
              [-65.59227454299992, 66.21141185100004],
              [-65.55992591099994, 66.23468659100007],
              [-65.54950924399992, 66.24477773600006],
              [-65.54344641799992, 66.25495026200008],
              [-65.53595943899995, 66.27643463700008],
              [-65.52928626199991, 66.28603750200006],
              [-65.51402747299994, 66.29783763200004],
              [-65.47065182199992, 66.31679922100005],
              [-65.48729407499991, 66.32147858300004],
              [-65.52196204299992, 66.31696198100008],
              [-65.53888912699995, 66.32363515800006],
              [-65.48778235599991, 66.33999258000006],
              [-65.46991939999992, 66.35301341400003],
              [-65.47748775899993, 66.37140534100007],
              [-65.47748775899993, 66.37763092700004],
              [-65.47150631399995, 66.38202545800004],
              [-65.47203528599994, 66.38532135600008],
              [-65.47748775899993, 66.39183177300004],
              [-65.49205481699994, 66.38800690300008],
              [-65.50544186099995, 66.37653229400007],
              [-65.51524817599994, 66.36151764500005],
              [-65.51903235599991, 66.34715403900003],
              [-65.52179928299995, 66.34357330900008],
              [-65.52839107999995, 66.34048086100006],
              [-65.53620357999995, 66.33812083500004],
              [-65.55174719999991, 66.33527252800008],
              [-65.55577551999994, 66.33026764500005],
              [-65.57091223899994, 66.28217194200005],
              [-65.57738196499992, 66.27179596600007],
              [-65.59203040299991, 66.25751373900005],
              [-65.68187415299991, 66.19135163000004],
              [-65.69347083199995, 66.18577708500004],
              [-65.73595130099994, 66.18203359600005],
              [-65.77912350199995, 66.17275625200006],
              [-65.8313695949999, 66.14988841400003],
              [-65.84430904899995, 66.14175039300005],
              [-65.85993404899995, 66.13458893400008],
              [-65.9094945949999, 66.12433502800008],
              [-65.93468176999994, 66.11749909100007],
              [-65.95905514199995, 66.11469147300005],
              [-66.01191158799992, 66.11749909100007],
              [-66.1477758449999, 66.14069245000007],
              [-66.15070553299995, 66.14581940300008],
              [-66.15123450399994, 66.15228913000004],
              [-66.15587317599994, 66.15851471600007],
              [-66.19477291599992, 66.17401764500005],
              [-66.20429439999992, 66.17963288000004],
              [-66.20335852799991, 66.18097565300008],
              [-66.20466061099995, 66.18683502800008],
              [-66.20824133999992, 66.19513580900008],
              [-66.21422278599994, 66.20319245000007],
              [-66.25731360599991, 66.22357819200005],
              [-66.25902258999992, 66.22691478100006],
              [-66.2571508449999, 66.22736237200007],
              [-66.25584876199991, 66.22667064000007],
              [-66.25572669199994, 66.22431061400005],
              [-66.25169837099992, 66.22182851800005],
              [-66.24665279899995, 66.23090241100005],
              [-66.23106848899994, 66.24384186400005],
              [-66.2122289699999, 66.25043366100005],
              [-66.19684811099995, 66.24103424700007],
              [-66.19066321499992, 66.24103424700007],
              [-66.17389889199995, 66.26508209800005],
              [-66.14964758999992, 66.28945547100005],
              [-66.23603268099993, 66.25299713700008],
              [-66.2805883449999, 66.24225495000007],
              [-66.31354732999995, 66.26215241100005],
              [-66.31061764199995, 66.27309804900005],
              [-66.32575436099995, 66.26898834800005],
              [-66.36200924399992, 66.25470612200007],
              [-66.38206946499992, 66.26227448100008],
              [-66.40184485599991, 66.27480703300006],
              [-66.42218990799995, 66.28070709800005],
              [-66.44383704299992, 66.26837799700007],
              [-66.41681881399995, 66.25771719000005],
              [-66.38752193899995, 66.24201080900008],
              [-66.37275143099993, 66.22406647300005],
              [-66.38923092399995, 66.20693594000005],
              [-66.42585201699995, 66.20132070500006],
              [-66.47626705599993, 66.20477936400005],
              [-66.5208227199999, 66.21869538000004],
              [-66.54010982999995, 66.24477773600006],
              [-66.54682369699992, 66.26752350500004],
              [-66.54670162699995, 66.28261953300006],
              [-66.53669186099995, 66.28945547100005],
              [-66.48534094999991, 66.27749258000006],
              [-66.47801673099991, 66.27887604400007],
              [-66.47984778599994, 66.28921133000006],
              [-66.48485266799992, 66.30170319200005],
              [-66.49242102799991, 66.31232330900008],
              [-66.50190182199992, 66.31679922100005],
              [-66.51573645699995, 66.32037995000007],
              [-66.50605221299992, 66.32859935100004],
              [-66.47179114499994, 66.34406159100007],
              [-66.47179114499994, 66.35028717700004],
              [-66.54088294199994, 66.34650299700007],
              [-66.57111568899995, 66.35199616100005],
              [-66.57420813699991, 66.37140534100007],
              [-66.55549068899995, 66.38153717700004],
              [-66.44440670499995, 66.40180084800005],
              [-66.43858801999994, 66.40753815300008],
              [-66.44322669199994, 66.41425202000005],
              [-66.45750891799992, 66.41917552300004],
              [-66.4739477199999, 66.41876862200007],
              [-66.50177975199995, 66.40827057500007],
              [-66.51557369699992, 66.40550364800004],
              [-66.53233801999994, 66.40436432500007],
              [-66.56590735599991, 66.39687734600005],
              [-66.59260006399995, 66.38694896000004],
              [-66.62262936099995, 66.37140534100007],
              [-66.61518307199992, 66.37140534100007],
              [-66.69245357999995, 66.36994049700007],
              [-66.73066158799992, 66.37360260600008],
              [-66.76598059799994, 66.38507721600007],
              [-66.73078365799995, 66.38963450700004],
              [-66.70848548099991, 66.40346914300005],
              [-66.69273841099994, 66.42682526200008],
              [-66.67723548099991, 66.46015045800004],
              [-66.7044164699999, 66.45840078300006],
              [-66.71247311099995, 66.44879791900007],
              [-66.71837317599994, 66.43793366100005],
              [-66.73900305899991, 66.43280670800004],
              [-66.75963294199994, 66.43524811400005],
              [-66.78534908799992, 66.44204336100006],
              [-66.80829830599993, 66.45282623900005],
              [-66.82066809799994, 66.46698639500005],
              [-66.79442298099991, 66.47406647300005],
              [-66.79169674399992, 66.49823639500005],
              [-66.80512447799993, 66.52578359600005],
              [-66.8274633449999, 66.54271067900004],
              [-66.8274633449999, 66.53668854400007],
              [-66.83698482999995, 66.53506094000005],
              [-66.85029049399992, 66.53717682500007],
              [-66.86156165299991, 66.54271067900004],
              [-66.7454320949999, 66.57265859600005],
              [-66.72504635299993, 66.59113190300008],
              [-66.76414954299992, 66.59931061400005],
              [-66.84862219999991, 66.59027741100005],
              [-66.88890540299991, 66.59796784100007],
              [-66.96833248599995, 66.63080475500004],
              [-67.01207434799994, 66.64158763200004],
              [-67.06025143099993, 66.64573802300004],
              [-67.06025143099993, 66.63825104400007],
              [-66.88267981699994, 66.57001373900005],
              [-66.91681881399995, 66.55463288000004],
              [-66.96129309799994, 66.54083893400008],
              [-67.00446529899995, 66.53481679900005],
              [-67.03416907499991, 66.54271067900004],
              [-67.03705807199992, 66.53546784100007],
              [-67.0403539699999, 66.53091054900005],
              [-67.04389400899993, 66.52704498900005],
              [-67.04718990799995, 66.52220286700003],
              [-67.07245846299992, 66.53416575700004],
              [-67.10456295499995, 66.53876373900005],
              [-67.13691158799992, 66.53668854400007],
              [-67.16327877499992, 66.52846914300005],
              [-67.16327877499992, 66.52220286700003],
              [-67.09105383999992, 66.51837799700007],
              [-67.08067786399994, 66.51194896000004],
              [-67.09552975199995, 66.49388255400004],
              [-67.12938391799992, 66.48720937700006],
              [-67.16633053299995, 66.48867422100005],
              [-67.19054114499994, 66.49494049700007],
              [-67.19859778599994, 66.50946686400005],
              [-67.19355221299992, 66.52513255400004],
              [-67.19481360599991, 66.53758372600004],
              [-67.28184973899994, 66.55231354400007],
              [-67.31196041599992, 66.56313711100006],
              [-67.33519446499992, 66.57684967700004],
              [-67.32994544199994, 66.59345123900005],
              [-67.35187740799995, 66.59780508000006],
              [-67.41026770699995, 66.59113190300008],
              [-67.43431555899991, 66.57762278900003],
              [-67.4485570949999, 66.57367584800005],
              [-67.46178137899994, 66.58055247600004],
              [-67.5091039699999, 66.61749909100007],
              [-67.51740475199995, 66.62189362200007],
              [-67.52782141799992, 66.62445709800005],
              [-67.54377193899995, 66.62523021000004],
              [-67.55585689999992, 66.62173086100006],
              [-67.54938717399995, 66.61359284100007],
              [-67.52696692599994, 66.59796784100007],
              [-67.52045650899993, 66.57566966400003],
              [-67.53892981699994, 66.57029857000003],
              [-67.56855221299992, 66.57538483300004],
              [-67.58783932199992, 66.58429596600007],
              [-67.59984290299991, 66.59072500200006],
              [-67.61481686099995, 66.59564850500004],
              [-67.63178463399993, 66.59829336100006],
              [-67.64989173099991, 66.59796784100007],
              [-67.64679928299995, 66.59332916900007],
              [-67.64167232999995, 66.58270905200004],
              [-67.63683020699995, 66.57684967700004],
              [-67.69489498599995, 66.58348216400003],
              [-67.72374426999994, 66.58242422100005],
              [-67.74608313699991, 66.57001373900005],
              [-67.70258541599992, 66.55975983300004],
              [-67.37861080599993, 66.54922109600005],
              [-67.36188717399995, 66.54271067900004],
              [-67.30390377499992, 66.53266022300005],
              [-67.28624426999994, 66.52619049700007],
              [-67.27253170499995, 66.51508209800005],
              [-67.26695716099994, 66.49799225500004],
              [-67.25226803299995, 66.47679271000004],
              [-67.17638098899994, 66.45441315300008],
              [-67.14277096299992, 66.44025299700007],
              [-67.15900631399995, 66.43276601800005],
              [-67.16087805899991, 66.42450592700004],
              [-67.14964758999992, 66.40550364800004],
              [-67.14574133999992, 66.39179108300004],
              [-67.14647376199991, 66.37856679900005],
              [-67.15562903599994, 66.36847565300008],
              [-67.17723548099991, 66.36456940300008],
              [-67.19908606699994, 66.37099844000005],
              [-67.23237057199992, 66.39911530200004],
              [-67.25230872299994, 66.40550364800004],
              [-67.36188717399995, 66.41233958500004],
              [-67.36188717399995, 66.41917552300004],
              [-67.35187740799995, 66.41917552300004],
              [-67.34589596299992, 66.42072174700007],
              [-67.33519446499992, 66.42601146000004],
              [-67.35102291599992, 66.43292877800008],
              [-67.37059485599991, 66.43463776200008],
              [-67.41026770699995, 66.43280670800004],
              [-67.3938695949999, 66.41254303600005],
              [-67.36054439999992, 66.39427317900004],
              [-67.32294674399992, 66.38153717700004],
              [-67.30040442599994, 66.37763092700004],
              [-67.28266354099992, 66.36961497600004],
              [-67.2278539699999, 66.35871002800008],
              [-67.20482337099992, 66.35712311400005],
              [-67.18773352799991, 66.35211823100008],
              [-67.14313717399995, 66.32705312700006],
              [-67.12909908799992, 66.31679922100005],
              [-67.14598548099991, 66.30280182500007],
              [-67.17577063699991, 66.30170319200005],
              [-67.23216712099992, 66.30931224200003],
              [-67.25914466099994, 66.30223216400003],
              [-67.28034420499995, 66.28888580900008],
              [-67.30317135299993, 66.28074778900003],
              [-67.33519446499992, 66.28945547100005],
              [-67.36811275899993, 66.31391022300005],
              [-67.38337154899995, 66.31753164300005],
              [-67.38984127499992, 66.29938385600008],
              [-67.39891516799992, 66.29645416900007],
              [-67.4192602199999, 66.30548737200007],
              [-67.44025631399995, 66.31924062700006],
              [-67.45124264199995, 66.33038971600007],
              [-67.44530188699991, 66.33344147300005],
              [-67.44225012899994, 66.33685944200005],
              [-67.44013424399992, 66.34048086100006],
              [-67.43696041599992, 66.34406159100007],
              [-67.4817602199999, 66.35272858300004],
              [-67.49225826699995, 66.35712311400005],
              [-67.49665279899995, 66.36615631700005],
              [-67.4954320949999, 66.37653229400007],
              [-67.49779212099992, 66.38593170800004],
              [-67.51337643099993, 66.39183177300004],
              [-67.52818762899994, 66.38621653900003],
              [-67.54662024599992, 66.39524974200003],
              [-67.57477779899995, 66.41917552300004],
              [-67.58161373599995, 66.41233958500004],
              [-67.59422766799992, 66.41893138200004],
              [-67.62958736899992, 66.42772044500003],
              [-67.64305579299992, 66.43280670800004],
              [-67.63312740799995, 66.44330475500004],
              [-67.62938391799992, 66.44647858300004],
              [-67.65306555899991, 66.44578685100004],
              [-67.70099850199995, 66.43846263200004],
              [-67.80040442599994, 66.45856354400007],
              [-67.82184811099995, 66.46698639500005],
              [-67.83275305899991, 66.48135000200006],
              [-67.84520423099991, 66.51544830900008],
              [-67.85936438699991, 66.52220286700003],
              [-67.86493893099993, 66.51797109600005],
              [-67.86974036399994, 66.50853099200003],
              [-67.87694251199991, 66.49917226800005],
              [-67.88975989499994, 66.49494049700007],
              [-67.9036352199999, 66.49835846600007],
              [-67.92353268099993, 66.51557038000004],
              [-67.93785559799994, 66.52220286700003],
              [-67.98456783799992, 66.51308828300006],
              [-67.99250240799995, 66.50853099200003],
              [-67.98420162699995, 66.50031159100007],
              [-67.96784420499995, 66.50071849200003],
              [-67.95189368399991, 66.49896881700005],
              [-67.94469153599994, 66.48436107000003],
              [-67.93773352799991, 66.47923411700003],
              [-67.90436764199995, 66.46893952000005],
              [-67.87657630099994, 66.46381256700005],
              [-67.87022864499994, 66.45575592700004],
              [-67.86774654899995, 66.44481028900003],
              [-67.86278235599991, 66.43280670800004],
              [-67.85737057199992, 66.42316315300008],
              [-67.85578365799995, 66.41795482000003],
              [-67.85240637899994, 66.41339752800008],
              [-67.84166419199994, 66.40550364800004],
              [-67.80186926999994, 66.38979726800005],
              [-67.78368079299992, 66.37685781500005],
              [-67.76337643099993, 66.36554596600007],
              [-67.7591039699999, 66.36082591400003],
              [-67.75890051999994, 66.34788646000004],
              [-67.75682532499991, 66.33661530200004],
              [-67.75080318899995, 66.32819245000007],
              [-67.73863684799994, 66.32363515800006],
              [-67.73949133999992, 66.31549713700008],
              [-67.71190344999991, 66.30414459800005],
              [-67.70445716099994, 66.29262929900005],
              [-67.70966549399992, 66.27724844000005],
              [-67.72215735599991, 66.26740143400008],
              [-67.75291907499991, 66.25470612200007],
              [-67.73265540299991, 66.24485911700003],
              [-67.68769283799992, 66.24079010600008],
              [-67.67292232999995, 66.23383209800005],
              [-67.67231197799993, 66.23200104400007],
              [-67.67780514199995, 66.22736237200007],
              [-67.64411373599995, 66.22256094000005],
              [-67.56114661399994, 66.18577708500004],
              [-67.47935950399994, 66.17340729400007],
              [-67.48603268099993, 66.16596100500004],
              [-67.48603268099993, 66.15851471600007],
              [-67.48151607999995, 66.15558502800008],
              [-67.47712154899995, 66.15375397300005],
              [-67.47187252499992, 66.15277741100005],
              [-67.47175045499995, 66.15228913000004],
              [-67.43529212099992, 66.13837311400005],
              [-67.31330318899995, 66.11933014500005],
              [-67.29364986899992, 66.11131419500003],
              [-67.28502356699994, 66.09845612200007],
              [-67.27782141799992, 66.07990143400008],
              [-67.26915442599994, 66.06329987200007],
              [-67.25605221299992, 66.05609772300005],
              [-67.24689693899995, 66.05394114800004],
              [-67.22797604099992, 66.04458242400005],
              [-67.21849524599992, 66.04242584800005],
              [-67.16327877499992, 66.04242584800005],
              [-67.16327877499992, 66.03558991100005],
              [-67.23420162699995, 66.01166413000004],
              [-67.27033443899995, 66.00421784100007],
              [-67.31415768099993, 66.00145091400003],
              [-67.30109615799995, 65.99616120000007],
              [-67.27216549399992, 65.99213288000004],
              [-67.25947018099993, 65.98777903900003],
              [-67.25190182199992, 65.98135000200006],
              [-67.24445553299995, 65.96718984600005],
              [-67.23896236899992, 65.96051666900007],
              [-67.22577877499992, 65.95136139500005],
              [-67.20848548099991, 65.94261302300004],
              [-67.18919837099992, 65.93585846600007],
              [-67.17011471299992, 65.93256256700005],
              [-67.18712317599994, 65.91616445500006],
              [-67.20771236899992, 65.91339752800008],
              [-67.26911373599995, 65.92861562700006],
              [-67.31415768099993, 65.92572663000004],
              [-67.33385169199994, 65.92055898600006],
              [-67.34373938699991, 65.91913483300004],
              [-67.35191809799994, 65.92267487200007],
              [-67.36168372299994, 65.92963288000004],
              [-67.37425696499992, 65.93488190300008],
              [-67.38764400899993, 65.93817780200004],
              [-67.3997289699999, 65.93939850500004],
              [-67.40326900899993, 65.94086334800005],
              [-67.40387936099995, 65.94403717700004],
              [-67.40501868399991, 65.94672272300005],
              [-67.41026770699995, 65.94684479400007],
              [-67.41624915299991, 65.94428131700005],
              [-67.41620846299992, 65.94106679900005],
              [-67.41490637899994, 65.93720123900005],
              [-67.41710364499994, 65.93256256700005],
              [-67.45018469999991, 65.90273672100005],
              [-67.47297115799995, 65.89354075700004],
              [-67.51768958199995, 65.91120026200008],
              [-67.54572506399995, 65.91136302300004],
              [-67.60212154899995, 65.90521881700005],
              [-67.61567135299993, 65.90619538000004],
              [-67.62657630099994, 65.90912506700005],
              [-67.63642330599993, 65.91445547100005],
              [-67.64643307199992, 65.92267487200007],
              [-67.65827389199995, 65.92755768400008],
              [-67.69062252499992, 65.92914459800005],
              [-67.70445716099994, 65.93256256700005],
              [-67.73033606699994, 65.95892975500004],
              [-67.74592037699995, 65.96649811400005],
              [-67.75291907499991, 65.94989655200004],
              [-67.74677486899992, 65.93740469000005],
              [-67.73253333199995, 65.92397695500006],
              [-67.70445716099994, 65.90521881700005],
              [-67.70445716099994, 65.89838288000004],
              [-67.75011145699995, 65.89679596600007],
              [-67.77289791599992, 65.89179108300004],
              [-67.79047604099992, 65.88133372600004],
              [-67.81000729099992, 65.87840403900003],
              [-67.92280025899993, 65.90322500200006],
              [-67.93366451699995, 65.91522858300004],
              [-67.93805904899995, 65.93089427300004],
              [-67.94469153599994, 65.94684479400007],
              [-67.95881100199995, 65.95685455900008],
              [-67.97655188699991, 65.96434153900003],
              [-67.98863684799994, 65.97337474200003],
              [-67.9856664699999, 65.98777903900003],
              [-68.02574622299994, 65.99485911700003],
              [-68.03343665299991, 66.00145091400003],
              [-68.03172766799992, 66.01056549700007],
              [-68.01716061099995, 66.03363678600005],
              [-68.01362057199992, 66.04584381700005],
              [-68.01573645699995, 66.04901764500005],
              [-68.02045650899993, 66.05101146000004],
              [-68.02509518099993, 66.05385976800005],
              [-68.02729244699992, 66.05951569200005],
              [-68.02607174399992, 66.06557851800005],
              [-68.02354895699995, 66.06879303600005],
              [-68.02098548099991, 66.07078685100004],
              [-68.01984615799995, 66.07318756700005],
              [-67.97264563699991, 66.08344147300005],
              [-67.99189205599993, 66.09446849200003],
              [-68.07872473899994, 66.11953359600005],
              [-68.13862057199992, 66.12726471600007],
              [-68.21617591099994, 66.14594147300005],
              [-68.23888098899994, 66.15851471600007],
              [-68.24559485599991, 66.17523834800005],
              [-68.25055904899995, 66.19822825700004],
              [-68.25841223899994, 66.21857330900008],
              [-68.27367102799991, 66.22736237200007],
              [-68.30622311099995, 66.22687409100007],
              [-68.33189856699994, 66.22256094000005],
              [-68.34235592399995, 66.21019114800004],
              [-68.32892818899995, 66.18577708500004],
              [-68.34528561099995, 66.18260325700004],
              [-68.37303626199991, 66.18260325700004],
              [-68.39924068899995, 66.18683502800008],
              [-68.41083736899992, 66.19635651200008],
              [-68.41466223899994, 66.21230703300006],
              [-68.43500729099992, 66.25433991100005],
              [-68.44440670499995, 66.26837799700007],
              [-68.45665442599994, 66.27875397300005],
              [-68.47541256399995, 66.29010651200008],
              [-68.49592037699995, 66.29930247600004],
              [-68.51353919199994, 66.30312734600005],
              [-68.52643795499995, 66.29677969000005],
              [-68.51899166599992, 66.28213125200006],
              [-68.49278723899994, 66.25470612200007],
              [-68.47846432199992, 66.24363841400003],
              [-68.47240149599992, 66.23672109600005],
              [-68.47227942599994, 66.22736237200007],
              [-68.48102779899995, 66.21942780200004],
              [-68.49657141799992, 66.21287669500003],
              [-68.51292883999992, 66.20848216400003],
              [-68.52379309799994, 66.20693594000005],
              [-68.82673092399995, 66.20099518400008],
              [-68.8496801419999, 66.19330475500004],
              [-68.7266332669999, 66.18056875200006],
              [-68.71247311099995, 66.17275625200006],
              [-68.68871008999992, 66.17454661700003],
              [-68.6770727199999, 66.17763906500005],
              [-68.66783606699994, 66.18268463700008],
              [-68.65086829299992, 66.18821849200003],
              [-68.63170325399994, 66.18398672100005],
              [-68.61241614499994, 66.17658112200007],
              [-68.59516354099992, 66.17275625200006],
              [-68.5833227199999, 66.17352936400005],
              [-68.57457434799994, 66.17609284100007],
              [-68.56684322799993, 66.18121979400007],
              [-68.5579320949999, 66.18952057500007],
              [-68.54401607999995, 66.19501373900005],
              [-68.48530025899993, 66.19330475500004],
              [-68.49278723899994, 66.19330475500004],
              [-68.45836341099994, 66.18854401200008],
              [-68.44062252499992, 66.18374258000006],
              [-68.42821204299992, 66.17617422100005],
              [-68.40400143099993, 66.14813873900005],
              [-68.38935299399992, 66.13613515800006],
              [-68.33490963399993, 66.12124258000006],
              [-68.26109778599994, 66.08063385600008],
              [-68.21906490799995, 66.07591380400004],
              [-68.22191321499992, 66.07811107000003],
              [-68.21906490799995, 66.08344147300005],
              [-68.23961341099994, 66.09910716400003],
              [-68.25999915299991, 66.11131419500003],
              [-68.25019283799992, 66.11591217700004],
              [-68.23993893099993, 66.11660390800006],
              [-68.22956295499995, 66.11469147300005],
              [-68.21906490799995, 66.11131419500003],
              [-68.21906490799995, 66.11749909100007],
              [-68.22203528599994, 66.12815989800004],
              [-68.19994055899991, 66.12807851800005],
              [-68.15013587099992, 66.11749909100007],
              [-68.13231360599991, 66.10789622600004],
              [-68.10411536399994, 66.08592357000003],
              [-68.09552975199995, 66.08344147300005],
              [-68.08149166599992, 66.07758209800005],
              [-68.04515540299991, 66.08307526200008],
              [-68.02729244699992, 66.07591380400004],
              [-68.03941809799994, 66.07330963700008],
              [-68.05052649599992, 66.06647370000007],
              [-68.06822669199994, 66.04926178600005],
              [-68.05321204299992, 66.02411530200004],
              [-68.05296790299991, 66.00779857000003],
              [-68.06395423099991, 65.99510325700004],
              [-68.08250891799992, 65.98094310100004],
              [-68.09520423099991, 65.98493073100008],
              [-68.10151119699992, 65.99184804900005],
              [-68.10155188699991, 66.00006745000007],
              [-68.09552975199995, 66.00763580900008],
              [-68.12397213399993, 66.02708567900004],
              [-68.15855872299994, 66.03388092700004],
              [-68.19062252499992, 66.02753327000005],
              [-68.21161861899992, 66.00763580900008],
              [-68.15623938699991, 65.99713776200008],
              [-68.1301977199999, 65.98627350500004],
              [-68.11603756399995, 65.96670156500005],
              [-68.14618893099993, 65.96662018400008],
              [-68.17621822799993, 65.97280508000006],
              [-68.28168697799993, 66.01707591400003],
              [-68.30516516799992, 66.03070709800005],
              [-68.32518469999991, 66.04584381700005],
              [-68.33433997299994, 66.04930247600004],
              [-68.3430883449999, 66.04633209800005],
              [-68.34788977799991, 66.03978099200003],
              [-68.34532630099994, 66.03253815300008],
              [-68.30439205599993, 65.99774811400005],
              [-68.28022213399993, 65.98240794500003],
              [-68.21800696499992, 65.96629466400003],
              [-68.19111080599993, 65.95302969000005],
              [-68.21471106699994, 65.94725169500003],
              [-68.23407955599993, 65.95087311400005],
              [-68.27428137899994, 65.96670156500005],
              [-68.29393469999991, 65.96735260600008],
              [-68.31525631399995, 65.96137116100005],
              [-68.33124752499992, 65.94944896000004],
              [-68.33515377499992, 65.93256256700005],
              [-68.31244869699992, 65.91278717700004],
              [-68.27045650899993, 65.91254303600005],
              [-68.19111080599993, 65.92572663000004],
              [-68.19330807199992, 65.92096588700008],
              [-68.19151770699995, 65.91567617400005],
              [-68.18610592399995, 65.91030508000006],
              [-68.17743893099993, 65.90521881700005],
              [-68.17125403599994, 65.91120026200008],
              [-68.15916907499991, 65.92885976800005],
              [-68.14671790299991, 65.93256256700005],
              [-68.13678951699995, 65.92658112200007],
              [-68.13756262899994, 65.91315338700008],
              [-68.14557857999995, 65.89923737200007],
              [-68.15697180899991, 65.89158763200004],
              [-68.15245520699995, 65.87978750200006],
              [-68.16034908799992, 65.87197500200006],
              [-68.1751195949999, 65.86713288000004],
              [-68.19111080599993, 65.86432526200008],
              [-68.12962805899991, 65.83698151200008],
              [-68.09447180899991, 65.83685944200005],
              [-68.08226477799991, 65.83283112200007],
              [-68.09552975199995, 65.82269928600005],
              [-68.10887610599991, 65.81948476800005],
              [-68.15697180899991, 65.81586334800005],
              [-68.20539303299995, 65.80223216400003],
              [-68.20539303299995, 65.79604726800005],
              [-68.12421627499992, 65.79840729400007],
              [-68.09552975199995, 65.79604726800005],
              [-68.03827877499992, 65.78196849200003],
              [-68.00755774599992, 65.78070709800005],
              [-67.98224850199995, 65.79254791900007],
              [-67.96088619699992, 65.79779694200005],
              [-67.9016820949999, 65.79230377800008],
              [-67.88947506399995, 65.79913971600007],
              [-67.88109290299991, 65.81964752800008],
              [-67.86091061099995, 65.82697174700007],
              [-67.83617102799991, 65.82453034100007],
              [-67.81432044199994, 65.81586334800005],
              [-67.82966061099995, 65.80963776200008],
              [-67.83454342399995, 65.79938385600008],
              [-67.82929439999992, 65.78900788000004],
              [-67.81432044199994, 65.78237539300005],
              [-67.84471594999991, 65.76251862200007],
              [-67.92487545499995, 65.75678131700005],
              [-67.95836341099994, 65.74079010600008],
              [-67.95360266799992, 65.72524648600006],
              [-67.97435462099992, 65.70962148600006],
              [-67.96519934799994, 65.69985586100006],
              [-67.94871985599991, 65.69643789300005],
              [-67.92621822799993, 65.69721100500004],
              [-67.90424557199992, 65.70087311400005],
              [-67.88947506399995, 65.70600006700005],
              [-67.88361568899995, 65.70209381700005],
              [-67.87816321499992, 65.69745514500005],
              [-67.87328040299991, 65.69208405200004],
              [-67.86896725199995, 65.68618398600006],
              [-67.88414466099994, 65.67963288000004],
              [-67.88756262899994, 65.66738515800006],
              [-67.88166256399995, 65.65424225500004],
              [-67.86896725199995, 65.64520905200004],
              [-67.87507076699995, 65.63523997600004],
              [-67.88520260299993, 65.62689850500004],
              [-67.89745032499991, 65.62083567900004],
              [-67.90998287699995, 65.61790599200003],
              [-67.92699133999992, 65.62010325700004],
              [-67.96519934799994, 65.63837311400005],
              [-67.99156653599994, 65.63361237200007],
              [-67.97175045499995, 65.62205638200004],
              [-67.91742916599992, 65.60419342700004],
              [-67.94477291599992, 65.59149811400005],
              [-67.95466061099995, 65.58999258000006],
              [-67.96532141799992, 65.59227122600004],
              [-67.97065182199992, 65.59731679900005],
              [-67.97406979099992, 65.60224030200004],
              [-67.97883053299995, 65.60419342700004],
              [-67.99531002499992, 65.59979889500005],
              [-68.06073971299992, 65.56940338700008],
              [-68.04267330599993, 65.56411367400005],
              [-68.02476966099994, 65.56220123900005],
              [-68.00873775899993, 65.56484609600005],
              [-67.99592037699995, 65.57318756700005],
              [-67.98468990799995, 65.57855866100005],
              [-67.96991939999992, 65.57819245000007],
              [-67.95689856699994, 65.57265859600005],
              [-67.95091712099992, 65.56264883000006],
              [-67.96153723899994, 65.54873281500005],
              [-68.01435299399992, 65.50625234600005],
              [-68.03343665299991, 65.49494049700007],
              [-68.03343665299991, 65.48749420800004],
              [-68.01610266799992, 65.48749420800004],
              [-68.00141354099992, 65.49339427300004],
              [-67.98827063699991, 65.50405508000006],
              [-67.97577877499992, 65.51788971600007],
              [-67.90619869699992, 65.55369700700004],
              [-67.88031979099992, 65.57607656500005],
              [-67.86896725199995, 65.58315664300005],
              [-67.84992428299995, 65.58612702000005],
              [-67.80907141799992, 65.58588288000004],
              [-67.79389400899993, 65.58999258000006],
              [-67.79271399599992, 65.60040924700007],
              [-67.77704830599993, 65.61668528900003],
              [-67.7551977199999, 65.63178131700005],
              [-67.73554439999992, 65.63837311400005],
              [-67.54393469999991, 65.66233958500004],
              [-67.51793372299994, 65.65912506700005],
              [-67.49596106699994, 65.64826080900008],
              [-67.48627682199992, 65.64598216400003],
              [-67.48005123599995, 65.65403880400004],
              [-67.47569739499994, 65.66535065300008],
              [-67.47175045499995, 65.67251211100006],
              [-67.45490475199995, 65.67885976800005],
              [-67.43561764199995, 65.68060944200005],
              [-67.39598548099991, 65.67934804900005],
              [-67.40351314999992, 65.67934804900005],
              [-67.36945553299995, 65.67446523600006],
              [-67.27314205599993, 65.64520905200004],
              [-67.27306067599994, 65.63214752800008],
              [-67.25422115799995, 65.60838450700004],
              [-67.26317298099991, 65.60419342700004],
              [-67.28111731699994, 65.60199616100005],
              [-67.34142005099994, 65.58315664300005],
              [-67.34142005099994, 65.57689036700003],
              [-67.32872473899994, 65.57151927300004],
              [-67.29755611899992, 65.56378815300008],
              [-67.28368079299992, 65.56264883000006],
              [-67.27562415299991, 65.55927155200004],
              [-67.27049719999991, 65.55149974200003],
              [-67.26593990799995, 65.54242584800005],
              [-67.25947018099993, 65.53534577000005],
              [-67.34052486899992, 65.54462311400005],
              [-67.3782445949999, 65.54352448100008],
              [-67.41710364499994, 65.52850983300004],
              [-67.40314693899995, 65.52277252800008],
              [-67.39195716099994, 65.52094147300005],
              [-67.34125729099992, 65.52191803600005],
              [-67.33100338399993, 65.51805247600004],
              [-67.32774817599994, 65.50800202000005],
              [-67.34711666599992, 65.50145091400003],
              [-67.43305416599992, 65.50364817900004],
              [-67.45868893099993, 65.50800202000005],
              [-67.45868893099993, 65.50116608300004],
              [-67.38084876199991, 65.47833893400008],
              [-67.35505123599995, 65.46702708500004],
              [-67.34459387899994, 65.45868561400005],
              [-67.34076900899993, 65.45270416900007],
              [-67.33551998599995, 65.45050690300008],
              [-67.32091223899994, 65.45335521000004],
              [-67.30927486899992, 65.45905182500007],
              [-67.30028235599991, 65.46625397300005],
              [-67.28966223899994, 65.47215403900003],
              [-67.27314205599993, 65.47386302300004],
              [-67.26109778599994, 65.47142161700003],
              [-67.23790442599994, 65.46255117400005],
              [-67.22533118399991, 65.45962148600006],
              [-67.20881100199995, 65.45917389500005],
              [-67.13959713399993, 65.46963125200006],
              [-67.11200924399992, 65.47044505400004],
              [-67.08429928299995, 65.46771881700005],
              [-67.06025143099993, 65.45962148600006],
              [-67.06025143099993, 65.45335521000004],
              [-67.1048070949999, 65.44464752800008],
              [-67.11546790299991, 65.43976471600007],
              [-67.10407467399995, 65.43622467700004],
              [-67.07050533799992, 65.43585846600007],
              [-67.06025143099993, 65.43231842700004],
              [-67.0598852199999, 65.42405833500004],
              [-67.07636471299992, 65.40525950700004],
              [-67.08067786399994, 65.39508698100008],
              [-67.09125729099992, 65.38060130400004],
              [-67.11628170499995, 65.37099844000005],
              [-67.14586341099994, 65.36566803600005],
              [-67.31415768099993, 65.36741771000004],
              [-67.32701575399994, 65.35537344000005],
              [-67.41710364499994, 65.35101959800005],
              [-67.40632076699995, 65.33738841400003],
              [-67.38646399599992, 65.32859935100004],
              [-67.36400305899991, 65.32387929900005],
              [-67.34516354099992, 65.32245514500005],
              [-67.33417721299992, 65.32294342700004],
              [-67.32616126199991, 65.32440827000005],
              [-67.31989498599995, 65.32672760600008],
              [-67.31415768099993, 65.32982005400004],
              [-67.30695553299995, 65.33706289300005],
              [-67.30150305899991, 65.34609609600005],
              [-67.29487057199992, 65.35390859600005],
              [-67.28368079299992, 65.35716380400004],
              [-67.24242102799991, 65.34967682500007],
              [-67.16429602799991, 65.31932200700004],
              [-67.12230383999992, 65.31622955900008],
              [-67.15473385299993, 65.28571198100008],
              [-67.16881262899994, 65.26854075700004],
              [-67.16014563699991, 65.26097239800004],
              [-67.14891516799992, 65.26325104400007],
              [-67.12572180899991, 65.27521393400008],
              [-67.11921139199995, 65.27301666900007],
              [-67.11436926999994, 65.26325104400007],
              [-67.10863196499992, 65.26097239800004],
              [-67.10057532499991, 65.26044342700004],
              [-67.08067786399994, 65.25413646000004],
              [-67.08067786399994, 65.24730052300004],
              [-67.13447018099993, 65.24689362200007],
              [-67.15770423099991, 65.24111562700006],
              [-67.17011471299992, 65.22687409100007],
              [-67.15229244699992, 65.23078034100007],
              [-67.13813229099992, 65.23167552300004],
              [-67.1262914699999, 65.22846100500004],
              [-67.11546790299991, 65.21995677300004],
              [-67.11994381399995, 65.20954010600008],
              [-67.11192786399994, 65.20335521000004],
              [-67.09797115799995, 65.20307038000004],
              [-67.06895911399994, 65.21922435100004],
              [-67.04865475199995, 65.22406647300005],
              [-67.02814693899995, 65.22431061400005],
              [-67.01244055899991, 65.21995677300004],
              [-67.01732337099992, 65.21002838700008],
              [-67.01988684799994, 65.20636627800008],
              [-66.99449622299994, 65.20132070500006],
              [-66.97455807199992, 65.21002838700008],
              [-66.93732662699995, 65.24115631700005],
              [-66.93586178299995, 65.21596914300005],
              [-66.95164954299992, 65.12905508000006],
              [-66.96153723899994, 65.11009349200003],
              [-67.03205318899995, 65.11343008000006],
              [-67.05341549399992, 65.11009349200003],
              [-67.06904049399992, 65.10077545800004],
              [-67.09101314999992, 65.07562897300005],
              [-67.10863196499992, 65.06915924700007],
              [-67.10863196499992, 65.06232330900008],
              [-67.08360755099994, 65.06419505400004],
              [-67.01988684799994, 65.08283112200007],
              [-66.99596106699994, 65.08673737200007],
              [-66.96747799399992, 65.08661530200004],
              [-66.95152747299994, 65.07949453300006],
              [-66.96528072799993, 65.06232330900008],
              [-66.95783443899995, 65.06232330900008],
              [-66.90623938699991, 65.07123444200005],
              [-66.88739986899992, 65.08161041900007],
              [-66.89635169199994, 65.10394928600005],
              [-66.83702551999994, 65.14590078300006],
              [-66.82404537699995, 65.15176015800006],
              [-66.79975338399993, 65.15741608300004],
              [-66.75165768099993, 65.18158600500004],
              [-66.72504635299993, 65.18585846600007],
              [-66.72504635299993, 65.17841217700004],
              [-66.73729407499991, 65.16925690300008],
              [-66.74567623599995, 65.15591054900005],
              [-66.75226803299995, 65.14199453300006],
              [-66.75922604099992, 65.13129303600005],
              [-66.75877844999991, 65.11570872600004],
              [-66.80919348899994, 65.10248444200005],
              [-66.8274633449999, 65.09027741100005],
              [-66.79271399599992, 65.09027741100005],
              [-66.81135006399995, 65.06256745000007],
              [-66.89093990799995, 65.06586334800005],
              [-66.91681881399995, 65.04930247600004],
              [-66.86542721299992, 65.04083893400008],
              [-66.85126705599993, 65.03611888200004],
              [-66.83014889199995, 65.04169342700004],
              [-66.75922604099992, 65.06915924700007],
              [-66.77086341099994, 65.05121491100005],
              [-66.77802486899992, 65.04279205900008],
              [-66.78648841099994, 65.03506094000005],
              [-66.77839107999995, 65.03363678600005],
              [-66.77460689999992, 65.03164297100005],
              [-66.77167721299992, 65.02948639500005],
              [-66.76598059799994, 65.02757396000004],
              [-66.77424068899995, 65.02358633000006],
              [-66.7786352199999, 65.01650625200006],
              [-66.77843176999994, 65.00824616100005],
              [-66.77281653599994, 65.00092194200005],
              [-66.76191158799992, 64.99917226800005],
              [-66.75348873599995, 65.00482819200005],
              [-66.74628658799992, 65.00678131700005],
              [-66.73871822799993, 64.99408600500004],
              [-66.74339758999992, 64.96820709800005],
              [-66.77159583199995, 64.95652903900003],
              [-66.83429928299995, 64.94562409100007],
              [-66.75116939999992, 64.93170807500007],
              [-66.72504635299993, 64.91836172100005],
              [-66.73114986899992, 64.90273672100005],
              [-66.73871822799993, 64.89203522300005],
              [-66.74970455599993, 64.88434479400007],
              [-66.76598059799994, 64.87738678600005],
              [-66.76598059799994, 64.87055084800005],
              [-66.7473852199999, 64.86619700700004],
              [-66.73680579299992, 64.85301341400003],
              [-66.73399817599994, 64.83665599200003],
              [-66.73871822799993, 64.82273997600004],
              [-66.72704016799992, 64.81981028900003],
              [-66.7200414699999, 64.81391022300005],
              [-66.71894283799992, 64.80548737200007],
              [-66.72504635299993, 64.79486725500004],
              [-66.70539303299995, 64.78937409100007],
              [-66.69774329299992, 64.78864166900007],
              [-66.70225989499994, 64.78384023600006],
              [-66.70685787699995, 64.77728913000004],
              [-66.71076412699995, 64.77435944200005],
              [-66.70807857999995, 64.77065664300005],
              [-66.70518958199995, 64.76878489800004],
              [-66.69774329299992, 64.76752350500004],
              [-66.68061275899993, 64.76764557500007],
              [-66.63569088399993, 64.78119538000004],
              [-66.64940344999991, 64.79271067900004],
              [-66.66791744699992, 64.80036041900007],
              [-66.68403072799993, 64.80963776200008],
              [-66.69090735599991, 64.82615794500003],
              [-66.68932044199994, 64.84674713700008],
              [-66.68492591099994, 64.86444733300004],
              [-66.65387936099995, 64.93353913000004],
              [-66.65038001199991, 64.94940827000005],
              [-66.64936275899993, 64.96991608300004],
              [-66.65815182199992, 64.98676178600005],
              [-66.69404049399992, 65.01772695500006],
              [-66.69774329299992, 65.03506094000005],
              [-66.68219967399995, 65.04417552300004],
              [-66.59382076699995, 65.02558014500005],
              [-66.57347571499992, 65.01658763200004],
              [-66.56366939999992, 65.01459381700005],
              [-66.54780025899993, 65.01471588700008],
              [-66.53937740799995, 65.01337311400005],
              [-66.53547115799995, 65.00751373900005],
              [-66.53327389199995, 64.99408600500004],
              [-66.54096432199992, 64.96576569200005],
              [-66.53709876199991, 64.95840078300006],
              [-66.50560462099992, 64.98379140800006],
              [-66.49323482999995, 64.98753489800004],
              [-66.48253333199995, 64.98598867400005],
              [-66.47801673099991, 64.97671133000006],
              [-66.48017330599993, 64.96893952000005],
              [-66.49848385299993, 64.94562409100007],
              [-66.47948157499991, 64.93585846600007],
              [-66.45368404899995, 64.92959219000005],
              [-66.37323971299992, 64.91950104400007],
              [-66.36143958199995, 64.92462799700007],
              [-66.36876380099994, 64.94562409100007],
              [-66.34687252499992, 64.94525788000004],
              [-66.33446204299992, 64.93475983300004],
              [-66.32367916599992, 64.92137278900003],
              [-66.30671139199995, 64.91217682500007],
              [-66.31354732999995, 64.90473053600005],
              [-66.30671139199995, 64.90473053600005],
              [-66.31659908799992, 64.89476146000004],
              [-66.32115637899994, 64.88361237200007],
              [-66.31855221299992, 64.87441640800006],
              [-66.30671139199995, 64.87055084800005],
              [-66.29242916599992, 64.87490469000005],
              [-66.28595943899995, 64.88495514500005],
              [-66.28123938699991, 64.89638906500005],
              [-66.27257239499994, 64.90473053600005],
              [-66.24445553299995, 64.90623607000003],
              [-66.20856686099995, 64.89704010600008],
              [-66.14964758999992, 64.87055084800005],
              [-66.16462154899995, 64.86269765800006],
              [-66.17528235599991, 64.85000234600005],
              [-66.18492591099994, 64.83576080900008],
              [-66.19684811099995, 64.82273997600004],
              [-66.18260657499991, 64.81256745000007],
              [-66.18122311099995, 64.79612864800004],
              [-66.19025631399995, 64.78099192900004],
              [-66.20738684799994, 64.77435944200005],
              [-66.34150143099993, 64.77435944200005],
              [-66.32127844999991, 64.76117584800005],
              [-66.28327389199995, 64.75787995000007],
              [-66.21051998599995, 64.76129791900007],
              [-66.22020423099991, 64.74884674700007],
              [-66.21894283799992, 64.74022044500003],
              [-66.21344967399995, 64.73334381700005],
              [-66.21051998599995, 64.72589752800008],
              [-66.21092688699991, 64.71287669500003],
              [-66.21288001199991, 64.70433177300004],
              [-66.21796627499992, 64.69245026200008],
              [-66.17088782499991, 64.68341705900008],
              [-66.15526282499991, 64.70929596600007],
              [-66.14952551999994, 64.74396393400008],
              [-66.12482662699995, 64.76984284100007],
              [-66.10094153599994, 64.80744049700007],
              [-66.09129798099991, 64.81590403900003],
              [-66.07457434799994, 64.82135651200008],
              [-66.01866614499994, 64.85757070500006],
              [-66.0091039699999, 64.83234284100007],
              [-66.01056881399995, 64.80646393400008],
              [-66.02045650899993, 64.78278229400007],
              [-66.03608150899993, 64.76439036700003],
              [-66.04841061099995, 64.74160390800006],
              [-66.04137122299994, 64.71942780200004],
              [-66.02245032499991, 64.70697663000004],
              [-65.99885006399995, 64.71287669500003],
              [-66.00523841099994, 64.72256094000005],
              [-66.01178951699995, 64.73895905200004],
              [-66.01264400899993, 64.75446198100008],
              [-66.00194251199991, 64.76129791900007],
              [-65.99189205599993, 64.76333242400005],
              [-65.98005123599995, 64.76715729400007],
              [-65.96788489499994, 64.76968008000006],
              [-65.95726477799991, 64.76752350500004],
              [-65.95055091099994, 64.75950755400004],
              [-65.95164954299992, 64.75092194200005],
              [-65.95478268099993, 64.74290599200003],
              [-65.95384680899991, 64.73680247600004],
              [-65.90802975199995, 64.67865631700005],
              [-65.86558997299994, 64.66258372600004],
              [-65.85114498599995, 64.65485260600008],
              [-65.83979244699992, 64.64594147300005],
              [-65.82298743399991, 64.63788483300004],
              [-65.80736243399991, 64.63743724200003],
              [-65.79963131399995, 64.65143463700008],
              [-65.80683346299992, 64.65729401200008],
              [-65.85423743399991, 64.68561432500007],
              [-65.87739010299993, 64.70807526200008],
              [-65.89557857999995, 64.73248932500007],
              [-65.89301510299993, 64.75055573100008],
              [-65.85423743399991, 64.75385163000004],
              [-65.85423743399991, 64.76129791900007],
              [-65.87543697799993, 64.76801178600005],
              [-65.90160071499992, 64.77973053600005],
              [-65.92475338399993, 64.79425690300008],
              [-65.93675696499992, 64.80914948100008],
              [-65.92267818899995, 64.80833567900004],
              [-65.90619869699992, 64.81000397300005],
              [-65.89293372299994, 64.81631094000005],
              [-65.88898678299995, 64.82957591400003],
              [-65.93342037699995, 64.86066315300008],
              [-65.95213782499991, 64.88450755400004],
              [-65.94245357999995, 64.89175039300005],
              [-65.91710364499994, 64.88764069200005],
              [-65.88898678299995, 64.87738678600005],
              [-65.87336178299995, 64.86977773600006],
              [-65.86681067599994, 64.86920807500007],
              [-65.85423743399991, 64.87055084800005],
              [-65.85411536399994, 64.87250397300005],
              [-65.85216223899994, 64.87685781500005],
              [-65.84788977799991, 64.88141510600008],
              [-65.84056555899991, 64.88422272300005],
              [-65.83222408799992, 64.88434479400007],
              [-65.82404537699995, 64.88275788000004],
              [-65.81651770699995, 64.87929922100005],
              [-65.81017005099994, 64.87396881700005],
              [-65.79747473899994, 64.86566803600005],
              [-65.78770911399994, 64.86489492400005],
              [-65.78136145699995, 64.86180247600004],
              [-65.77912350199995, 64.84666575700004],
              [-65.79340572799993, 64.80914948100008],
              [-65.77611243399991, 64.80438873900005],
              [-65.76268469999991, 64.81614817900004],
              [-65.75072180899991, 64.83388906500005],
              [-65.73786373599995, 64.84666575700004],
              [-65.71678626199991, 64.84422435100004],
              [-65.68919837099992, 64.83002350500004],
              [-65.66881262899994, 64.81195709800005],
              [-65.6692602199999, 64.79857005400004],
              [-65.70909583199995, 64.77960846600007],
              [-65.72614498599995, 64.76699453300006],
              [-65.73814856699994, 64.74770742400005],
              [-65.73884029899995, 64.73407623900005],
              [-65.73200436099995, 64.72174713700008],
              [-65.7102758449999, 64.69245026200008],
              [-65.70335852799991, 64.69245026200008],
              [-65.70295162699995, 64.75458405200004],
              [-65.64659583199995, 64.77338288000004],
              [-65.58283443899995, 64.75682200700004],
              [-65.56000729099992, 64.71287669500003],
              [-65.56440182199992, 64.71051666900007],
              [-65.58214270699995, 64.70453522300005],
              [-65.58735104099992, 64.69928620000007],
              [-65.58665930899991, 64.69098541900007],
              [-65.58210201699995, 64.68406810100004],
              [-65.57685299399992, 64.67963288000004],
              [-65.57428951699995, 64.67877838700008],
              [-65.57856197799993, 64.65997955900008],
              [-65.58649654899995, 64.64911530200004],
              [-65.61461341099994, 64.63442617400005],
              [-65.65306555899991, 64.60675690300008],
              [-65.6692602199999, 64.60301341400003],
              [-65.71344967399995, 64.60358307500007],
              [-65.73432369699992, 64.59992096600007],
              [-65.75243079299992, 64.59003327000005],
              [-65.73420162699995, 64.58429596600007],
              [-65.72252356699994, 64.57562897300005],
              [-65.71715247299994, 64.56207916900007],
              [-65.71772213399993, 64.54157135600008],
              [-65.72240149599992, 64.52440013200004],
              [-65.72606360599991, 64.51520416900007],
              [-65.72288977799991, 64.50625234600005],
              [-65.70685787699995, 64.49005768400008],
              [-65.69111080599993, 64.48798248900005],
              [-65.61461341099994, 64.50063711100006],
              [-65.50536048099991, 64.50063711100006],
              [-65.50947018099993, 64.49542877800008],
              [-65.51484127499992, 64.48533763200004],
              [-65.51903235599991, 64.48016998900005],
              [-65.49274654899995, 64.47565338700008],
              [-65.45592200399994, 64.48802317900004],
              [-65.42060299399992, 64.50755442900004],
              [-65.39863033799992, 64.52456289300005],
              [-65.38837643099993, 64.52753327000005],
              [-65.35069739499994, 64.52985260600008],
              [-65.34089107999995, 64.52798086100006],
              [-65.33775794199994, 64.51264069200005],
              [-65.34833736899992, 64.50104401200008],
              [-65.40094967399995, 64.47211334800005],
              [-65.41161048099991, 64.46234772300005],
              [-65.41600501199991, 64.44912344000005],
              [-65.40782630099994, 64.44537995000007],
              [-65.38975989499994, 64.45429108300004],
              [-65.36420650899993, 64.47272370000007],
              [-65.35627193899995, 64.47492096600007],
              [-65.34056555899991, 64.48476797100005],
              [-65.33409583199995, 64.48700592700004],
              [-65.32420813699991, 64.48505280200004],
              [-65.30760657499991, 64.47577545800004],
              [-65.29999752499992, 64.47272370000007],
              [-65.28693600199995, 64.47101471600007],
              [-65.27448482999995, 64.47150299700007],
              [-65.26947994699992, 64.47622304900005],
              [-65.27887936099995, 64.48700592700004],
              [-65.27546139199995, 64.50360748900005],
              [-65.27179928299995, 64.51251862200007],
              [-65.26520748599995, 64.52114492400005],
              [-65.25438391799992, 64.52773672100005],
              [-65.23045813699991, 64.53290436400005],
              [-65.22052975199995, 64.53815338700008],
              [-65.21137447799993, 64.54140859600005],
              [-65.20490475199995, 64.53595612200007],
              [-65.20262610599991, 64.52667877800008],
              [-65.20653235599991, 64.51801178600005],
              [-65.23228919199994, 64.49579498900005],
              [-65.23790442599994, 64.48700592700004],
              [-65.20575924399992, 64.49160390800006],
              [-65.14525305899991, 64.51601797100005],
              [-65.11436926999994, 64.51496002800008],
              [-65.12604732999995, 64.50438060100004],
              [-65.16755123599995, 64.48753489800004],
              [-65.17577063699991, 64.48016998900005],
              [-65.16315670499995, 64.47418854400007],
              [-65.10069739499994, 64.48016998900005],
              [-65.08967037699995, 64.48647695500006],
              [-65.08104407499991, 64.47919342700004],
              [-65.07538814999992, 64.46466705900008],
              [-65.07343502499992, 64.44912344000005],
              [-65.07933508999992, 64.42926666900007],
              [-65.09422766799992, 64.41966380400004],
              [-65.15461178299995, 64.40668366100005],
              [-65.23859615799995, 64.40558502800008],
              [-65.24836178299995, 64.39964427300004],
              [-65.26520748599995, 64.38397858300004],
              [-65.19892330599993, 64.36603424700007],
              [-65.17841549399992, 64.34747955900008],
              [-65.19627844999991, 64.31500885600008],
              [-65.22704016799992, 64.30052317900004],
              [-65.26891028599994, 64.29564036700003],
              [-65.52586829299992, 64.32933177300004],
              [-65.54552161399994, 64.32900625200006],
              [-65.56220455599993, 64.32550690300008],
              [-65.59418697799993, 64.31500885600008],
              [-65.65794761699993, 64.30922971600006],
              [-65.65684973899994, 64.30756256700005],
              [-65.65705318899995, 64.30483633000006],
              [-65.65619869699992, 64.30141836100006],
              [-65.47118079299992, 64.30841705900008],
              [-65.43549557199992, 64.30508047100005],
              [-65.41600501199991, 64.28839752800008],
              [-65.43940182199992, 64.29441966400003],
              [-65.45173092399995, 64.29588450700004],
              [-65.46442623599995, 64.29523346600007],
              [-65.45909583199995, 64.28912995000007],
              [-65.4524633449999, 64.28339264500005],
              [-65.44477291599992, 64.27838776200008],
              [-65.43651282499991, 64.27411530200004],
              [-65.46784420499995, 64.26654694200005],
              [-65.53526770699995, 64.26211172100005],
              [-65.56684322799993, 64.25421784100007],
              [-65.54889889199995, 64.24664948100008],
              [-65.52452551999994, 64.24433014500005],
              [-65.35753333199995, 64.25405508000006],
              [-65.34369869699992, 64.25332265800006],
              [-65.33906002499992, 64.24681224200003],
              [-65.34528561099995, 64.23891836100006],
              [-65.36078854099992, 64.23379140800006],
              [-65.36078854099992, 64.22687409100007],
              [-65.29393469999991, 64.22675202000005],
              [-65.26231848899994, 64.21893952000005],
              [-65.24469967399995, 64.19896067900004],
              [-65.28844153599994, 64.19745514500005],
              [-65.30736243399991, 64.19342682500007],
              [-65.37690182199992, 64.16258372600004],
              [-65.39549719999991, 64.15802643400008],
              [-65.39549719999991, 64.15119049700007],
              [-65.34813391799992, 64.15053945500006],
              [-65.33409583199995, 64.15460846600007],
              [-65.30064856699994, 64.17552317900004],
              [-65.29283606699994, 64.17853424700007],
              [-65.26378333199995, 64.18085358300004],
              [-65.25153561099995, 64.17853424700007],
              [-65.19627844999991, 64.15119049700007],
              [-65.19688880099994, 64.14057038000004],
              [-65.18915768099993, 64.13833242400005],
              [-65.16218014199995, 64.14435455900008],
              [-65.16218014199995, 64.13690827000005],
              [-65.16840572799993, 64.13446686400005],
              [-65.18329830599993, 64.12392812700006],
              [-65.16698157499991, 64.11904531500005],
              [-65.13166256399995, 64.11444733300004],
              [-65.11436926999994, 64.10956452000005],
              [-65.19627844999991, 64.07611725500004],
              [-65.11774654899995, 64.08454010600008],
              [-65.07673092399995, 64.08344147300005],
              [-65.05292721299992, 64.06867096600007],
              [-65.07245846299992, 64.06708405200004],
              [-65.12865149599992, 64.04816315300008],
              [-65.17585201699995, 64.04254791900007],
              [-65.22423255099994, 64.04193756700005],
              [-65.21336829299992, 64.02789948100008],
              [-65.19310462099992, 64.02191803600005],
              [-65.08027096299992, 64.01406484600005],
              [-65.07062740799995, 64.01463450700004],
              [-65.03925533799992, 64.02081940300008],
              [-64.92255611899992, 64.01406484600005],
              [-64.92841549399992, 63.99982330900008],
              [-64.93866939999992, 63.98932526200008],
              [-64.96357174399992, 63.97304922100005],
              [-64.92027747299994, 63.97907135600008],
              [-64.89976966099994, 63.98460521000004],
              [-64.88158118399991, 63.993475653000075],
              [-64.85187740799995, 64.01557038000004],
              [-64.83580481699994, 64.02326080900008],
              [-64.79356848899994, 64.03095123900005],
              [-64.78461666599992, 64.03095123900005],
              [-64.77171790299991, 64.02765534100007],
              [-64.76463782499991, 64.02167389500005],
              [-64.76402747299994, 64.01463450700004],
              [-64.76219641799992, 64.00897858300004],
              [-64.7512914699999, 64.00722890800006],
              [-64.73326575399994, 64.01675039300005],
              [-64.71471106699994, 64.03424713700008],
              [-64.69477291599992, 64.04608795800004],
              [-64.67243404899995, 64.03851959800005],
              [-64.66612708199995, 64.03261953300006],
              [-64.66303463399993, 64.02781810100004],
              [-64.66197669199994, 64.02142975500004],
              [-64.66185462099992, 64.01064687700006],
              [-64.65778561099995, 64.00120677300004],
              [-64.63935299399992, 63.99103424700007],
              [-64.63520260299993, 63.98297760600008],
              [-64.64667721299992, 63.975490627000056],
              [-64.79963131399995, 63.93691640800006],
              [-64.81611080599993, 63.92837148600006],
              [-64.83381100199995, 63.91624583500004],
              [-64.89525305899991, 63.897365627000056],
              [-64.88512122299994, 63.880519924000055],
              [-64.89277096299992, 63.868394273000035],
              [-64.91010494699992, 63.860541083000044],
              [-64.92939205599993, 63.85639069200005],
              [-64.96739661399994, 63.852728583000044],
              [-64.97809811099995, 63.84609609600005],
              [-64.99144446499992, 63.82843659100007],
              [-64.97411048099991, 63.80442942900004],
              [-64.95466061099995, 63.78766510600008],
              [-64.92951412699995, 63.77765534100007],
              [-64.76398678299995, 63.749253648000035],
              [-64.70677649599992, 63.76227448100008],
              [-64.69635982999995, 63.75804271000004],
              [-64.68773352799991, 63.749212958000044],
              [-64.67613684799994, 63.740301825000074],
              [-64.54320227799991, 63.686428127000056],
              [-64.52232825399994, 63.66909414300005],
              [-64.50483150899993, 63.64411041900007],
              [-64.51732337099992, 63.62376536700003],
              [-64.52607174399992, 63.61408112200007],
              [-64.53522701699995, 63.60993073100008],
              [-64.56659908799992, 63.61603424700007],
              [-64.57970130099994, 63.61469147300005],
              [-64.58678137899994, 63.60248444200005],
              [-64.56525631399995, 63.59564850500004],
              [-64.54450436099995, 63.582912502000056],
              [-64.53815670499995, 63.56989166900007],
              [-64.55943762899994, 63.562201239000046],
              [-64.54552161399994, 63.55459219000005],
              [-64.53473873599995, 63.54555898600006],
              [-64.52782141799992, 63.53367747600004],
              [-64.52533932199992, 63.51748281500005],
              [-64.52513587099992, 63.500433661000045],
              [-64.52708899599992, 63.49042389500005],
              [-64.53510494699992, 63.482855536000045],
              [-64.55260169199994, 63.47280508000006],
              [-64.52070064999992, 63.46190013200004],
              [-64.50483150899993, 63.44318268400008],
              [-64.50755774599992, 63.42206452000005],
              [-64.53156490799995, 63.40387604400007],
              [-64.56281490799995, 63.40070221600007],
              [-64.60956783799992, 63.42255280200004],
              [-64.63520260299993, 63.41815827000005],
              [-64.60594641799992, 63.38540273600006],
              [-64.52228756399995, 63.376654364000046],
              [-64.50483150899993, 63.34585195500006],
              [-64.50446529899995, 63.335923570000034],
              [-64.50556393099993, 63.32453034100007],
              [-64.51142330599993, 63.314439195000034],
              [-64.52533932199992, 63.308294989000046],
              [-64.55199133999992, 63.31118398600006],
              [-64.57697506399995, 63.32200755400004],
              [-64.60163326699995, 63.329291083000044],
              [-64.62775631399995, 63.32135651200008],
              [-64.59296627499992, 63.30695221600007],
              [-64.51789303299995, 63.29877350500004],
              [-64.48436438699991, 63.28778717700004],
              [-64.49433346299992, 63.28343333500004],
              [-64.51557369699992, 63.27871328300006],
              [-64.52533932199992, 63.27480703300006],
              [-64.53144283799992, 63.267645575000074],
              [-64.5325414699999, 63.26056549700007],
              [-64.53681393099993, 63.255194403000075],
              [-64.55260169199994, 63.25307851800005],
              [-64.56639563699991, 63.25535716400003],
              [-64.57819576699995, 63.25991445500006],
              [-64.59089107999995, 63.262884833000044],
              [-64.60724850199995, 63.26048411700003],
              [-64.61632239499994, 63.255194403000075],
              [-64.62336178299995, 63.24819570500006],
              [-64.63097083199995, 63.24201080900008],
              [-64.64203854099992, 63.23940664300005],
              [-64.65033932199992, 63.24266185100004],
              [-64.65904700399994, 63.25023021000004],
              [-64.66588294199994, 63.25849030200004],
              [-64.66869055899991, 63.26390208500004],
              [-64.6751195949999, 63.271144924000055],
              [-64.70612545499995, 63.277411200000074],
              [-64.71711178299995, 63.28099192900004],
              [-64.72130286399994, 63.28847890800006],
              [-64.72040768099993, 63.296128648000035],
              [-64.72105872299994, 63.303941148000035],
              [-64.73045813699991, 63.311712958000044],
              [-64.77171790299991, 63.32880280200004],
              [-64.76630611899992, 63.34406159100007],
              [-64.77253170499995, 63.35614655200004],
              [-64.77509518099993, 63.36823151200008],
              [-64.75873775899993, 63.38336823100008],
              [-64.79149329299992, 63.39288971600007],
              [-64.79967200399994, 63.397650458000044],
              [-64.80199133999992, 63.402777411000045],
              [-64.80772864499994, 63.42047760600008],
              [-64.84064693899995, 63.48582591400003],
              [-64.83958899599992, 63.489569403000075],
              [-64.83576412699995, 63.49298737200007],
              [-64.83344479099992, 63.497381903000075],
              [-64.83690344999991, 63.50385163000004],
              [-64.84101314999992, 63.50731028900003],
              [-64.84325110599991, 63.508693752000056],
              [-64.84496008999992, 63.51007721600007],
              [-64.85126705599993, 63.51837799700007],
              [-64.87108313699991, 63.53758372600004],
              [-64.89106197799993, 63.552069403000075],
              [-64.93171139199995, 63.57135651200008],
              [-64.94306393099993, 63.58942291900007],
              [-64.94273841099994, 63.598944403000075],
              [-64.93525143099993, 63.612209377000056],
              [-64.9368383449999, 63.62299225500004],
              [-64.9426977199999, 63.63271719000005],
              [-64.95030676999994, 63.63861725500004],
              [-64.9993383449999, 63.65729401200008],
              [-65.05512447799993, 63.67055898600006],
              [-65.08027096299992, 63.68504466400003],
              [-65.09080969999991, 63.696478583000044],
              [-65.11774654899995, 63.73655833500004],
              [-65.13768469999991, 63.74896881700005],
              [-65.18805904899995, 63.76414622600004],
              [-65.20990963399993, 63.781236070000034],
              [-65.19371497299994, 63.78148021000004],
              [-65.14911861899992, 63.77440013200004],
              [-65.17304439999992, 63.79328034100007],
              [-65.20006262899994, 63.80369700700004],
              [-65.22895260299993, 63.80817291900007],
              [-65.25837154899995, 63.80914948100008],
              [-65.28779049399992, 63.81329987200007],
              [-65.30243893099993, 63.81273021000004],
              [-65.30304928299995, 63.80548737200007],
              [-65.29332434799994, 63.797308661000045],
              [-65.20990963399993, 63.753973700000074],
              [-65.18976803299995, 63.73627350500004],
              [-65.17817135299993, 63.728949286000045],
              [-65.16246497299994, 63.72601959800005],
              [-65.13756262899994, 63.71784088700008],
              [-65.12165279899995, 63.698553778000075],
              [-65.10895748599995, 63.67593008000006],
              [-65.09386145699995, 63.65770091400003],
              [-65.04588782499991, 63.63349030200004],
              [-65.00169837099992, 63.61676666900007],
              [-64.99437415299991, 63.612494208000044],
              [-64.98749752499992, 63.60309479400007],
              [-64.98420162699995, 63.593736070000034],
              [-64.98774166599992, 63.58942291900007],
              [-65.05292721299992, 63.57518138200004],
              [-65.09931393099993, 63.54950592700004],
              [-65.08613033799992, 63.516913153000075],
              [-65.05805416599992, 63.48265208500004],
              [-65.05976314999992, 63.452337958000044],
              [-65.08079993399991, 63.44570547100005],
              [-65.13276119699992, 63.444525458000044],
              [-65.14911861899992, 63.43121979400007],
              [-65.10240637899994, 63.431341864000046],
              [-65.04670162699995, 63.438666083000044],
              [-65.0579320949999, 63.42552317900004],
              [-65.07856197799993, 63.41657135600008],
              [-65.12116451699995, 63.40387604400007],
              [-65.08385169199994, 63.39956289300005],
              [-65.04723059799994, 63.403225002000056],
              [-65.01264400899993, 63.40110911700003],
              [-64.97301184799994, 63.37319570500006],
              [-64.95429439999992, 63.36481354400007],
              [-64.94648189999992, 63.359808661000045],
              [-64.94310462099992, 63.35342031500005],
              [-64.94306393099993, 63.33836497600004],
              [-64.93993079299992, 63.33193594000005],
              [-64.93049068899995, 63.320298570000034],
              [-64.91584225199995, 63.29661692900004],
              [-64.90892493399991, 63.28778717700004],
              [-64.91242428299995, 63.28473541900007],
              [-64.91881262899994, 63.27765534100007],
              [-64.92255611899992, 63.27480703300006],
              [-64.90208899599992, 63.23940664300005],
              [-64.93342037699995, 63.243353583000044],
              [-64.95299231699994, 63.253892320000034],
              [-64.99144446499992, 63.28778717700004],
              [-65.01008053299995, 63.29901764500005],
              [-65.03636633999992, 63.31122467700004],
              [-65.06065833199995, 63.316839911000045],
              [-65.07343502499992, 63.308294989000046],
              [-65.05614173099991, 63.302069403000075],
              [-65.00511633999992, 63.27480703300006],
              [-65.02806555899991, 63.249660549000055],
              [-65.07079016799992, 63.26268138200004],
              [-65.11676998599995, 63.28510163000004],
              [-65.14911861899992, 63.28778717700004],
              [-65.10692298099991, 63.245754299000055],
              [-65.09727942599994, 63.23940664300005],
              [-65.00511633999992, 63.23940664300005],
              [-64.97777258999992, 63.22793203300006],
              [-64.97618567599994, 63.21185944200005],
              [-64.99067135299993, 63.20026276200008],
              [-65.01195227799991, 63.20213450700004],
              [-65.02997799399992, 63.21112702000005],
              [-65.05317135299993, 63.21930573100008],
              [-65.07453365799995, 63.21987539300005],
              [-65.08702551999994, 63.20587799700007],
              [-65.07612057199992, 63.20416901200008],
              [-65.04670162699995, 63.19159577000005],
              [-65.05304928299995, 63.187567450000074],
              [-65.05976314999992, 63.184759833000044],
              [-65.05976314999992, 63.17792389500005],
              [-64.93126380099994, 63.18390534100007],
              [-64.88813229099992, 63.17365143400008],
              [-64.86054439999992, 63.171128648000035],
              [-64.86908932199992, 63.16205475500004],
              [-64.88316809799994, 63.15839264500005],
              [-64.89635169199994, 63.15680573100008],
              [-64.90208899599992, 63.15403880400004],
              [-64.89643307199992, 63.14484284100007],
              [-64.88263912699995, 63.141913153000075],
              [-64.81928463399993, 63.141913153000075],
              [-64.80577551999994, 63.13808828300006],
              [-64.79222571499992, 63.130113023000035],
              [-64.78364010299993, 63.11937083500004],
              [-64.77855383999992, 63.108587958000044],
              [-64.77000891799992, 63.10150788000004],
              [-64.7512914699999, 63.10224030200004],
              [-64.77961178299995, 63.09442780200004],
              [-64.84040279899995, 63.10138580900008],
              [-64.86790930899991, 63.09601471600007],
              [-64.84345455599993, 63.082464911000045],
              [-64.77826900899993, 63.07436758000006],
              [-64.7649633449999, 63.05508047100005],
              [-64.76878821499992, 63.04116445500006],
              [-64.77851314999992, 63.042669989000046],
              [-64.79096432199992, 63.050441799000055],
              [-64.80308997299994, 63.05508047100005],
              [-64.81261145699995, 63.05072663000004],
              [-64.80638587099992, 63.04120514500005],
              [-64.79242916599992, 63.031683661000045],
              [-64.77855383999992, 63.02708567900004],
              [-64.77855383999992, 63.02024974200003],
              [-64.7884008449999, 63.01471588700008],
              [-64.78746497299994, 63.00678131700005],
              [-64.78034420499995, 62.998928127000056],
              [-64.77171790299991, 62.99359772300005],
              [-64.77171790299991, 62.98615143400008],
              [-64.78962154899995, 62.98094310100004],
              [-64.82843990799995, 62.97728099200003],
              [-64.84748287699995, 62.973089911000045],
              [-64.82591712099992, 62.965277411000045],
              [-64.77924557199992, 62.95892975500004],
              [-64.75873775899993, 62.95140208500004],
              [-64.73473059799994, 62.92885976800005],
              [-64.71796627499992, 62.92129140800006],
              [-64.71031653599994, 62.93496328300006],
              [-64.71540279899995, 62.950506903000075],
              [-64.71320553299995, 62.95648834800005],
              [-64.70038814999992, 62.95880768400008],
              [-64.69359290299991, 62.95697663000004],
              [-64.62775631399995, 62.91107819200005],
              [-64.64183508999992, 62.89716217700004],
              [-64.66234290299991, 62.89622630400004],
              [-64.70343990799995, 62.90424225500004],
              [-64.72150631399995, 62.90021393400008],
              [-64.73167883999992, 62.89052969000005],
              [-64.73969479099992, 62.87905508000006],
              [-64.7512914699999, 62.86945221600007],
              [-64.78343665299991, 62.86424388200004],
              [-64.88707434799994, 62.86937083500004],
              [-64.91881262899994, 62.88031647300005],
              [-64.94635982999995, 62.89520905200004],
              [-65.01353919199994, 62.91152578300006],
              [-65.05646725199995, 62.93618398600006],
              [-65.08710689999992, 62.94745514500005],
              [-65.10069739499994, 62.95880768400008],
              [-65.10578365799995, 62.969956773000035],
              [-65.10846920499995, 62.981756903000075],
              [-65.11432857999995, 62.99233633000006],
              [-65.12865149599992, 62.99982330900008],
              [-65.14745032499991, 62.98061758000006],
              [-65.14561926999994, 62.96564362200007],
              [-65.13349361899992, 62.948919989000046],
              [-65.12116451699995, 62.92475006700005],
              [-65.14293372299994, 62.93158600500004],
              [-65.18232174399992, 62.95404694200005],
              [-65.23619544199994, 62.96503327000005],
              [-65.24779212099992, 62.97943756700005],
              [-65.2551977199999, 62.99551015800006],
              [-65.27204342399995, 63.00665924700007],
              [-65.28526770699995, 62.984076239000046],
              [-65.25177975199995, 62.95945872600004],
              [-65.20612545499995, 62.93707916900007],
              [-65.18329830599993, 62.92129140800006],
              [-65.18919837099992, 62.90973541900007],
              [-65.19965572799993, 62.90379466400003],
              [-65.20368404899995, 62.89557526200008],
              [-65.19013424399992, 62.87689850500004],
              [-65.17609615799995, 62.86591217700004],
              [-65.12116451699995, 62.83535390800006],
              [-65.0891820949999, 62.79975006700005],
              [-65.07685299399992, 62.79437897300005],
              [-65.06452389199995, 62.786810614000046],
              [-65.02680416599992, 62.75218333500004],
              [-65.01878821499992, 62.74249909100007],
              [-65.01512610599991, 62.73541901200008],
              [-65.00678463399993, 62.731675523000035],
              [-64.99762936099995, 62.72915273600006],
              [-64.99144446499992, 62.725490627000056],
              [-64.98713131399995, 62.715725002000056],
              [-64.98554439999992, 62.70612213700008],
              [-64.98517818899995, 62.69782135600008],
              [-64.98399817599994, 62.69196198100008],
              [-64.97516842399995, 62.677069403000075],
              [-64.96247311099995, 62.66266510600008],
              [-64.94697018099993, 62.65070221600007],
              [-64.92939205599993, 62.64354075700004],
              [-64.93952389199995, 62.63104889500005],
              [-64.95502682199992, 62.63300202000005],
              [-64.97313391799992, 62.64020416900007],
              [-64.99144446499992, 62.64354075700004],
              [-64.99058997299994, 62.627834377000056],
              [-65.00812740799995, 62.614569403000075],
              [-65.08027096299992, 62.584418036000045],
              [-65.10912024599992, 62.57599518400008],
              [-65.13902747299994, 62.57062409100007],
              [-65.16962643099993, 62.568426825000074],
              [-65.21100826699995, 62.57876211100006],
              [-65.24596106699994, 62.60586172100005],
              [-65.29999752499992, 62.67829010600008],
              [-65.26520748599995, 62.69818756700005],
              [-65.30109615799995, 62.69944896000004],
              [-65.31883704299992, 62.69790273600006],
              [-65.33409583199995, 62.69196198100008],
              [-65.32872473899994, 62.67645905200004],
              [-65.33551998599995, 62.671576239000046],
              [-65.34662838399993, 62.675034898000035],
              [-65.35456295499995, 62.68451569200005],
              [-65.35529537699995, 62.696926174000055],
              [-65.35016842399995, 62.707098700000074],
              [-65.31615149599992, 62.745021877000056],
              [-65.29596920499995, 62.759100653000075],
              [-65.24469967399995, 62.78009674700007],
              [-65.27240963399993, 62.78778717700004],
              [-65.34247799399992, 62.77513255400004],
              [-65.37507076699995, 62.78693268400008],
              [-65.36286373599995, 62.80174388200004],
              [-65.36042232999995, 62.81525299700007],
              [-65.35590572799993, 62.82526276200008],
              [-65.33751380099994, 62.82916901200008],
              [-65.29393469999991, 62.82648346600007],
              [-65.27363033799992, 62.827826239000046],
              [-65.25153561099995, 62.83535390800006],
              [-65.27745520699995, 62.83958567900004],
              [-65.30353756399995, 62.840277411000045],
              [-65.32599850199995, 62.84369538000004],
              [-65.34089107999995, 62.85578034100007],
              [-65.34284420499995, 62.868475653000075],
              [-65.34154212099992, 62.888373114000046],
              [-65.33653723899994, 62.907538153000075],
              [-65.32725989499994, 62.91787344000005],
              [-65.3450414699999, 62.925848700000074],
              [-65.36835689999992, 62.89288971600007],
              [-65.39863033799992, 62.82916901200008],
              [-65.40721594999991, 62.827337958000044],
              [-65.41600501199991, 62.82379791900007],
              [-65.42560787699995, 62.82123444200005],
              [-65.43651282499991, 62.822251695000034],
              [-65.4387914699999, 62.82762278900003],
              [-65.43927975199995, 62.837103583000044],
              [-65.44355221299992, 62.84585195500006],
              [-65.45697994699992, 62.848944403000075],
              [-65.46165930899991, 62.84516022300005],
              [-65.47101803299995, 62.82802969000005],
              [-65.47748775899993, 62.822251695000034],
              [-65.52830969999991, 62.82859935100004],
              [-65.56061764199995, 62.82127513200004],
              [-65.60383053299995, 62.82514069200005],
              [-65.64061438699991, 62.84198639500005],
              [-65.65619869699992, 62.87319570500006],
              [-65.6614477199999, 62.891791083000044],
              [-65.66242428299995, 62.90053945500006],
              [-65.66588294199994, 62.91225820500006],
              [-65.67365475199995, 62.90961334800005],
              [-65.68663489499994, 62.89679596600007],
              [-65.70506751199991, 62.89948151200008],
              [-65.72065182199992, 62.906317450000074],
              [-65.75243079299992, 62.92475006700005],
              [-65.7415258449999, 62.942694403000075],
              [-65.72504635299993, 62.95962148600006],
              [-65.68976803299995, 62.98615143400008],
              [-65.69713294199994, 62.99359772300005],
              [-65.69005286399994, 62.99567291900007],
              [-65.68736731699994, 62.99705638200004],
              [-65.68354244699992, 62.99982330900008],
              [-65.69086666599992, 63.00653717700004],
              [-65.70551510299993, 63.01618073100008],
              [-65.7102758449999, 63.02024974200003],
              [-65.71235104099992, 63.030462958000044],
              [-65.71064205599993, 63.04181549700007],
              [-65.7122289699999, 63.051214911000045],
              [-65.72419186099995, 63.05508047100005],
              [-65.73884029899995, 63.04865143400008],
              [-65.75190182199992, 63.033189195000034],
              [-65.75727291599992, 63.014105536000045],
              [-65.74872799399992, 62.99673086100006],
              [-65.74205481699994, 62.97638580900008],
              [-65.76569576699995, 62.96263255400004],
              [-65.81663977799991, 62.94830963700008],
              [-65.82685299399992, 62.92837148600006],
              [-65.81220455599993, 62.91592031500005],
              [-65.7903539699999, 62.90424225500004],
              [-65.77912350199995, 62.88686758000006],
              [-65.78815670499995, 62.87319570500006],
              [-65.80842037699995, 62.88275788000004],
              [-65.84056555899991, 62.91107819200005],
              [-65.87584387899994, 62.928941148000035],
              [-65.88556881399995, 62.93154531500005],
              [-65.92988033799992, 62.92324453300006],
              [-65.94420325399994, 62.92475006700005],
              [-65.96349036399994, 62.937486070000034],
              [-65.95311438699991, 62.95034414300005],
              [-65.9094945949999, 62.973089911000045],
              [-65.88593502499992, 63.002386786000045],
              [-65.87873287699995, 63.00665924700007],
              [-65.86864173099991, 63.00885651200008],
              [-65.84386145699995, 63.021144924000055],
              [-65.83433997299994, 63.02708567900004],
              [-65.83433997299994, 63.03335195500006],
              [-65.86628170499995, 63.032131252000056],
              [-65.89838619699992, 63.023504950000074],
              [-65.95726477799991, 62.99982330900008],
              [-65.95726477799991, 62.99359772300005],
              [-65.95335852799991, 62.99046458500004],
              [-65.94884192599994, 62.98395416900007],
              [-65.94420325399994, 62.97931549700007],
              [-66.00230872299994, 62.98029205900008],
              [-66.02936764199995, 62.98615143400008],
              [-66.05345618399991, 62.99982330900008],
              [-66.06110592399995, 63.00690338700008],
              [-66.06745357999995, 63.01447174700007],
              [-66.07172604099992, 63.02240631700005],
              [-66.07331295499995, 63.03021881700005],
              [-66.06781979099992, 63.03196849200003],
              [-66.05744381399995, 63.040716864000046],
              [-66.05174719999991, 63.050482489000046],
              [-66.06029212099992, 63.05508047100005],
              [-66.08018958199995, 63.04930247600004],
              [-66.09801184799994, 63.039048570000034],
              [-66.11750240799995, 63.03497955900008],
              [-66.14220130099994, 63.04755280200004],
              [-66.14911861899992, 63.06012604400007],
              [-66.1555883449999, 63.07843659100007],
              [-66.16478430899991, 63.095038153000075],
              [-66.18012447799993, 63.10224030200004],
              [-66.20787512899994, 63.10765208500004],
              [-66.25739498599995, 63.13153717700004],
              [-66.28315182199992, 63.13694896000004],
              [-66.29088294199994, 63.128973700000074],
              [-66.26585852799991, 63.11163971600007],
              [-66.21796627499992, 63.08856842700004],
              [-66.21263587099992, 63.080145575000074],
              [-66.21056067599994, 63.07143789300005],
              [-66.21051998599995, 63.05133698100008],
              [-66.20600338399993, 63.04047272300005],
              [-66.19538326699995, 63.03392161700003],
              [-66.18309485599991, 63.02924225500004],
              [-66.15290279899995, 63.01194896000004],
              [-66.10423743399991, 62.99677155200004],
              [-66.08759518099993, 62.97931549700007],
              [-66.09345455599993, 62.978216864000046],
              [-66.1028539699999, 62.97418854400007],
              [-66.1087133449999, 62.973089911000045],
              [-66.10387122299994, 62.951605536000045],
              [-66.12913977799991, 62.943345445000034],
              [-66.16466223899994, 62.944566148000035],
              [-66.19066321499992, 62.95140208500004],
              [-66.2102758449999, 62.967962958000044],
              [-66.22260494699992, 62.97597890800006],
              [-66.23810787699995, 62.97931549700007],
              [-66.24571692599994, 62.97833893400008],
              [-66.26032467399995, 62.97406647300005],
              [-66.2688695949999, 62.973089911000045],
              [-66.27643795499995, 62.97614166900007],
              [-66.27830969999991, 62.982855536000045],
              [-66.27814693899995, 62.98981354400007],
              [-66.27940833199995, 62.99359772300005],
              [-66.30732174399992, 62.99799225500004],
              [-66.36750240799995, 62.99713776200008],
              [-66.39671790299991, 62.99982330900008],
              [-66.41840572799993, 63.007513739000046],
              [-66.4622289699999, 63.03461334800005],
              [-66.47801673099991, 63.04755280200004],
              [-66.47179114499994, 63.06126536700003],
              [-66.50279700399994, 63.064520575000074],
              [-66.51923580599993, 63.077337958000044],
              [-66.51679439999992, 63.08893463700008],
              [-66.49103756399995, 63.08856842700004],
              [-66.50279700399994, 63.09804922100005],
              [-66.52582760299993, 63.12335846600007],
              [-66.56501217399995, 63.150824286000045],
              [-66.57420813699991, 63.164943752000056],
              [-66.55085201699995, 63.186712958000044],
              [-66.55024166599992, 63.19818756700005],
              [-66.56366939999992, 63.21580638200004],
              [-66.58051510299993, 63.22809479400007],
              [-66.61742102799991, 63.24567291900007],
              [-66.63227291599992, 63.25678131700005],
              [-66.64924068899995, 63.26544830900008],
              [-66.67125403599994, 63.271470445000034],
              [-66.68842525899993, 63.28139883000006],
              [-66.69090735599991, 63.30145905200004],
              [-66.68207760299993, 63.312567450000074],
              [-66.64818274599992, 63.34003327000005],
              [-66.63569088399993, 63.356675523000035],
              [-66.64313717399995, 63.356675523000035],
              [-66.63837643099993, 63.36465078300006],
              [-66.63874264199995, 63.37067291900007],
              [-66.64366614499994, 63.37457916900007],
              [-66.65278072799993, 63.37592194200005],
              [-66.6653539699999, 63.373480536000045],
              [-66.66767330599993, 63.36701080900008],
              [-66.66681881399995, 63.35838450700004],
              [-66.66978919199994, 63.349269924000055],
              [-66.68744869699992, 63.33454010600008],
              [-66.72858639199995, 63.308579820000034],
              [-66.73871822799993, 63.29401276200008],
              [-66.73359127499992, 63.27879466400003],
              [-66.71678626199991, 63.26557038000004],
              [-66.65477454299992, 63.23859284100007],
              [-66.63227291599992, 63.23261139500005],
              [-66.62531490799995, 63.22964101800005],
              [-66.61046301999994, 63.21621328300006],
              [-66.6009008449999, 63.21206289300005],
              [-66.61823482999995, 63.18060944200005],
              [-66.62303626199991, 63.164496161000045],
              [-66.60741126199991, 63.154282945000034],
              [-66.59321041599992, 63.14020416900007],
              [-66.58446204299992, 63.13694896000004],
              [-66.58088131399995, 63.13263580900008],
              [-66.58726966099994, 63.11090729400007],
              [-66.58788001199991, 63.10224030200004],
              [-66.58014889199995, 63.097723700000074],
              [-66.56883704299992, 63.09662506700005],
              [-66.56004798099991, 63.09324778900003],
              [-66.55992591099994, 63.081732489000046],
              [-66.56757564999992, 63.07697174700007],
              [-66.60151119699992, 63.068060614000046],
              [-66.62336178299995, 63.073472398000035],
              [-66.66185462099992, 63.09711334800005],
              [-66.68407141799992, 63.10224030200004],
              [-66.67381751199991, 63.087591864000046],
              [-66.66124426999994, 63.074286200000074],
              [-66.64631100199995, 63.062201239000046],
              [-66.62913977799991, 63.05133698100008],
              [-66.56956946499992, 63.03021881700005],
              [-66.55370032499991, 63.02024974200003],
              [-66.54377193899995, 63.00409577000005],
              [-66.55040442599994, 62.99628327000005],
              [-66.56639563699991, 62.99799225500004],
              [-66.59870357999995, 63.019964911000045],
              [-66.65619869699992, 63.04075755400004],
              [-66.65619869699992, 63.03335195500006],
              [-66.64936275899993, 63.03335195500006],
              [-66.64936275899993, 63.02708567900004],
              [-66.6751195949999, 63.02871328300006],
              [-66.69786536399994, 63.03851959800005],
              [-66.75877844999991, 63.08185455900008],
              [-66.76866614499994, 63.09064362200007],
              [-66.77281653599994, 63.09906647300005],
              [-66.76703854099992, 63.12006256700005],
              [-66.76532955599993, 63.13178131700005],
              [-66.76939856699994, 63.13694896000004],
              [-66.78050696499992, 63.141913153000075],
              [-66.77802486899992, 63.15249258000006],
              [-66.77045650899993, 63.16229889500005],
              [-66.76598059799994, 63.164943752000056],
              [-66.76414954299992, 63.18374258000006],
              [-66.76683508999992, 63.19037506700005],
              [-66.80357825399994, 63.23529694200005],
              [-66.81151282499991, 63.25470612200007],
              [-66.80695553299995, 63.27480703300006],
              [-66.83393307199992, 63.27167389500005],
              [-66.84593665299991, 63.252020575000074],
              [-66.84638424399992, 63.22996653900003],
              [-66.83800208199995, 63.21954987200007],
              [-66.81371008999992, 63.21002838700008],
              [-66.80467688699991, 63.18842194200005],
              [-66.81135006399995, 63.16518789300005],
              [-66.83429928299995, 63.15070221600007],
              [-66.8606664699999, 63.15143463700008],
              [-66.88646399599992, 63.16205475500004],
              [-66.90953528599994, 63.17804596600007],
              [-66.92743893099993, 63.195013739000046],
              [-66.94867916599992, 63.20840078300006],
              [-67.00340735599991, 63.226996161000045],
              [-67.01988684799994, 63.23940664300005],
              [-67.01911373599995, 63.26162344000005],
              [-66.99433346299992, 63.27187734600005],
              [-66.96507727799991, 63.27871328300006],
              [-66.95099850199995, 63.29092031500005],
              [-66.96198482999995, 63.30369700700004],
              [-66.98497473899994, 63.31012604400007],
              [-67.00483150899993, 63.31976959800005],
              [-67.00621497299994, 63.34247467700004],
              [-66.97919674399992, 63.377386786000045],
              [-66.97398841099994, 63.39590078300006],
              [-66.99535071499992, 63.40387604400007],
              [-67.01292883999992, 63.40273672100005],
              [-67.0169164699999, 63.39862702000005],
              [-67.01703854099992, 63.39118073100008],
              [-67.02741451699995, 63.37173086100006],
              [-67.03779049399992, 63.34324778900003],
              [-67.03974361899992, 63.33502838700008],
              [-67.03632564999992, 63.32404205900008],
              [-67.01244055899991, 63.28778717700004],
              [-67.03819739499994, 63.28339264500005],
              [-67.11204993399991, 63.28778717700004],
              [-67.13105221299992, 63.292629299000055],
              [-67.16254635299993, 63.31476471600007],
              [-67.18439693899995, 63.32135651200008],
              [-67.18439693899995, 63.31513092700004],
              [-67.16584225199995, 63.30658600500004],
              [-67.15302486899992, 63.29515208500004],
              [-67.15412350199995, 63.285223700000074],
              [-67.17723548099991, 63.28099192900004],
              [-67.20112057199992, 63.28847890800006],
              [-67.23981686099995, 63.32135651200008],
              [-67.34019934799994, 63.37409088700008],
              [-67.35712643099993, 63.38776276200008],
              [-67.37140865799995, 63.404364325000074],
              [-67.38239498599995, 63.42438385600008],
              [-67.38678951699995, 63.45221588700008],
              [-67.38984127499992, 63.45913320500006],
              [-67.40082760299993, 63.46552155200004],
              [-67.41462154899995, 63.467962958000044],
              [-67.42353268099993, 63.46507396000004],
              [-67.42023678299995, 63.45571523600006],
              [-67.41783606699994, 63.43626536700003],
              [-67.41466223899994, 63.424994208000044],
              [-67.41026770699995, 63.42438385600008],
              [-67.41877193899995, 63.414048570000034],
              [-67.42357337099992, 63.415228583000044],
              [-67.42931067599994, 63.42096588700008],
              [-67.45209713399993, 63.426662502000056],
              [-67.47809811099995, 63.436428127000056],
              [-67.48912512899994, 63.438666083000044],
              [-67.50068111899992, 63.44281647300005],
              [-67.50361080599993, 63.45258209800005],
              [-67.50352942599994, 63.46393463700008],
              [-67.50593014199995, 63.47280508000006],
              [-67.53998775899993, 63.49298737200007],
              [-67.54906165299991, 63.505926825000074],
              [-67.53319251199991, 63.521185614000046],
              [-67.56029212099992, 63.53595612200007],
              [-67.59203040299991, 63.54474518400008],
              [-67.61839758999992, 63.55801015800006],
              [-67.62938391799992, 63.58576080900008],
              [-67.64439856699994, 63.60333893400008],
              [-67.67280025899993, 63.61692942900004],
              [-67.68968665299991, 63.632879950000074],
              [-67.67035885299993, 63.65770091400003],
              [-67.69623775899993, 63.65448639500005],
              [-67.74376380099994, 63.639960028000075],
              [-67.76630611899992, 63.63666413000004],
              [-67.78571529899995, 63.64476146000004],
              [-67.79185950399994, 63.66351959800005],
              [-67.79552161399994, 63.68451569200005],
              [-67.80756588399993, 63.699286200000074],
              [-67.81781979099992, 63.69285716400003],
              [-67.82725989499994, 63.69179922100005],
              [-67.83539791599992, 63.69603099200003],
              [-67.84166419199994, 63.705511786000045],
              [-67.8391820949999, 63.72329336100006],
              [-67.86554928299995, 63.741441148000035],
              [-67.92418372299994, 63.767564195000034],
              [-67.91596432199992, 63.74518463700008],
              [-67.86998450399994, 63.71381256700005],
              [-67.86591549399992, 63.702378648000035],
              [-67.86864173099991, 63.686428127000056],
              [-67.85216223899994, 63.67234935100004],
              [-67.81432044199994, 63.65086497600004],
              [-67.80658932199992, 63.629787502000056],
              [-67.81952877499992, 63.59235260600008],
              [-67.81098385299993, 63.571478583000044],
              [-67.80353756399995, 63.56146881700005],
              [-67.79222571499992, 63.54140859600005],
              [-67.78364010299993, 63.53082916900007],
              [-67.71764075399994, 63.472642320000034],
              [-67.68468176999994, 63.43333567900004],
              [-67.67035885299993, 63.39476146000004],
              [-67.69770260299993, 63.36969635600008],
              [-67.73127193899995, 63.36969635600008],
              [-67.78612219999991, 63.39671458500004],
              [-67.81810462099992, 63.40387604400007],
              [-67.82697506399995, 63.407904364000046],
              [-67.83442135299993, 63.417181708000044],
              [-67.84508216099994, 63.434881903000075],
              [-67.86078854099992, 63.45555247600004],
              [-67.86888587099992, 63.46369049700007],
              [-67.94469153599994, 63.507513739000046],
              [-68.00169837099992, 63.527329820000034],
              [-68.01667232999995, 63.53758372600004],
              [-68.03388424399992, 63.54677969000005],
              [-68.07469641799992, 63.54901764500005],
              [-68.09211178299995, 63.55841705900008],
              [-68.10260982999995, 63.573919989000046],
              [-68.11054439999992, 63.58942291900007],
              [-68.1204320949999, 63.60236237200007],
              [-68.13715572799993, 63.60993073100008],
              [-68.13044186099995, 63.58803945500006],
              [-68.14329993399991, 63.58161041900007],
              [-68.1614477199999, 63.58502838700008],
              [-68.17064368399991, 63.59251536700003],
              [-68.18110104099992, 63.60618724200003],
              [-68.23045813699991, 63.59662506700005],
              [-68.24640865799995, 63.60993073100008],
              [-68.22431393099993, 63.61737702000005],
              [-68.22297115799995, 63.63153717700004],
              [-68.23334713399993, 63.648423570000034],
              [-68.25727291599992, 63.67841217700004],
              [-68.27057857999995, 63.69098541900007],
              [-68.28892981699994, 63.69912344000005],
              [-68.31525631399995, 63.699286200000074],
              [-68.31525631399995, 63.691839911000045],
              [-68.29010982999995, 63.66258372600004],
              [-68.28010006399995, 63.64468008000006],
              [-68.28697669199994, 63.63666413000004],
              [-68.31383216099994, 63.639960028000075],
              [-68.36339270699995, 63.65448639500005],
              [-68.38666744699992, 63.65770091400003],
              [-68.40033932199992, 63.664048570000034],
              [-68.41490637899994, 63.678900458000044],
              [-68.42658443899995, 63.69599030200004],
              [-68.43134518099993, 63.70892975500004],
              [-68.4407445949999, 63.71625397300005],
              [-68.48383541599992, 63.73615143400008],
              [-68.49620520699995, 63.740301825000074],
              [-68.50702877499992, 63.741441148000035],
              [-68.52875729099992, 63.746079820000034],
              [-68.54059811099995, 63.746527411000045],
              [-68.54108639199995, 63.74428945500006],
              [-68.54023189999992, 63.739569403000075],
              [-68.54051673099991, 63.73493073100008],
              [-68.5442602199999, 63.732855536000045],
              [-68.57530676999994, 63.732855536000045],
              [-68.73082434799994, 63.77724844000005],
              [-68.74876868399991, 63.77977122600004],
              [-68.74604244699992, 63.767564195000034],
              [-68.73827063699991, 63.76227448100008],
              [-68.71747799399992, 63.75299713700008],
              [-68.71247311099995, 63.746527411000045],
              [-68.71519934799994, 63.735663153000075],
              [-68.72504635299993, 63.73261139500005],
              [-68.73692786399994, 63.73501211100006],
              [-68.74604244699992, 63.740301825000074],
              [-68.77367102799991, 63.73065827000005],
              [-68.88471432199992, 63.74872467700004],
              [-68.91246497299994, 63.75853099200003],
              [-68.92817135299993, 63.76072825700004],
              [-68.99303137899994, 63.76072825700004],
              [-68.99828040299991, 63.74994538000004],
              [-68.99022376199991, 63.74042389500005],
              [-68.91966712099992, 63.70502350500004],
              [-68.88316809799994, 63.67763906500005],
              [-68.82774817599994, 63.65070221600007],
              [-68.81489010299993, 63.63666413000004],
              [-68.81440182199992, 63.62474192900004],
              [-68.84601803299995, 63.62083567900004],
              [-68.8633520169999, 63.60993073100008],
              [-68.84919186099995, 63.60390859600005],
              [-68.83222408799992, 63.59943268400008],
              [-68.79784094999991, 63.59564850500004],
              [-68.78624426999994, 63.59064362200007],
              [-68.77680416599992, 63.57880280200004],
              [-68.76842200399994, 63.56513092700004],
              [-68.76032467399995, 63.554754950000074],
              [-68.71467037699995, 63.52570221600007],
              [-68.6868383449999, 63.512884833000044],
              [-68.64472408799992, 63.50153229400007],
              [-68.58189856699994, 63.472723700000074],
              [-68.55174719999991, 63.44936758000006],
              [-68.51362057199992, 63.44440338700008],
              [-68.44440670499995, 63.44489166900007],
              [-68.45323645699995, 63.43378327000005],
              [-68.46690833199995, 63.430121161000045],
              [-68.49958248599995, 63.43121979400007],
              [-68.49323482999995, 63.422308661000045],
              [-68.44871985599991, 63.39166901200008],
              [-68.40339107999995, 63.37592194200005],
              [-68.37909908799992, 63.36041901200008],
              [-68.3372289699999, 63.32257721600007],
              [-68.30077063699991, 63.31195709800005],
              [-68.28962154899995, 63.30426666900007],
              [-68.28014075399994, 63.29523346600007],
              [-68.27428137899994, 63.28778717700004],
              [-68.27619381399995, 63.28432851800005],
              [-68.28205318899995, 63.27948639500005],
              [-68.28730221299992, 63.27362702000005],
              [-68.28734290299991, 63.267279364000046],
              [-68.28034420499995, 63.26166413000004],
              [-68.26378333199995, 63.26044342700004],
              [-68.24583899599992, 63.25214264500005],
              [-68.21373450399994, 63.24160390800006],
              [-68.20539303299995, 63.23261139500005],
              [-68.20710201699995, 63.21865469000005],
              [-68.21739661399994, 63.212103583000044],
              [-68.23200436099995, 63.21076080900008],
              [-68.24640865799995, 63.21206289300005],
              [-68.2298070949999, 63.199286200000074],
              [-68.19005286399994, 63.189886786000045],
              [-68.17402096299992, 63.181341864000046],
              [-68.15925045499995, 63.16779205900008],
              [-68.14692135299993, 63.16063060100004],
              [-68.13280188699991, 63.157904364000046],
              [-68.1126195949999, 63.157456773000035],
              [-68.05951900899993, 63.16620514500005],
              [-68.01414954299992, 63.15228913000004],
              [-67.94574947799993, 63.143744208000044],
              [-67.91742916599992, 63.14321523600006],
              [-67.92589270699995, 63.13393789300005],
              [-67.93708248599995, 63.12970612200007],
              [-67.94676673099991, 63.124701239000046],
              [-67.95466061099995, 63.103583075000074],
              [-67.9856664699999, 63.075506903000075],
              [-67.96922766799992, 63.068060614000046],
              [-67.94908606699994, 63.06940338700008],
              [-67.92829342399995, 63.07713450700004],
              [-67.90998287699995, 63.08856842700004],
              [-67.91742916599992, 63.10602448100008],
              [-67.89574133999992, 63.118475653000075],
              [-67.86152096299992, 63.120347398000035],
              [-67.79865475199995, 63.08885325700004],
              [-67.75739498599995, 63.08869049700007],
              [-67.67780514199995, 63.10224030200004],
              [-67.63255774599992, 63.103216864000046],
              [-67.61131751199991, 63.09711334800005],
              [-67.60212154899995, 63.081732489000046],
              [-67.61091061099995, 63.06679922100005],
              [-67.63219153599994, 63.060980536000045],
              [-67.71357174399992, 63.06085846600007],
              [-67.73114986899992, 63.055975653000075],
              [-67.73863684799994, 63.044134833000044],
              [-67.74705969999991, 63.03465403900003],
              [-67.78718014199995, 63.02362702000005],
              [-67.80072994699992, 63.014105536000045],
              [-67.76659094999991, 63.014105536000045],
              [-67.77094479099992, 63.00112539300005],
              [-67.76557369699992, 62.991522528000075],
              [-67.75373287699995, 62.98623281500005],
              [-67.73863684799994, 62.98615143400008],
              [-67.73863684799994, 62.97931549700007],
              [-67.75043697799993, 62.97846100500004],
              [-67.76060950399994, 62.97500234600005],
              [-67.76850338399993, 62.96857330900008],
              [-67.77338619699992, 62.95880768400008],
              [-67.74278723899994, 62.95697663000004],
              [-67.72606360599991, 62.95770905200004],
              [-67.71503658799992, 62.962225653000075],
              [-67.71320553299995, 62.97125885600008],
              [-67.71873938699991, 62.982123114000046],
              [-67.72834225199995, 62.99249909100007],
              [-67.73863684799994, 62.99982330900008],
              [-67.67686926999994, 63.02802155200004],
              [-67.66352291599992, 63.04075755400004],
              [-67.63792883999992, 63.039496161000045],
              [-67.61485755099994, 63.03546784100007],
              [-67.5930883449999, 63.036769924000055],
              [-67.57135982999995, 63.05133698100008],
              [-67.55768795499995, 63.05296458500004],
              [-67.53693600199995, 63.044989325000074],
              [-67.51703854099992, 63.03237539300005],
              [-67.50593014199995, 63.02024974200003],
              [-67.51020260299993, 63.00775788000004],
              [-67.52936764199995, 62.99949778900003],
              [-67.55488033799992, 62.995021877000056],
              [-67.57819576699995, 62.99359772300005],
              [-67.59955807199992, 62.98973216400003],
              [-67.62934322799993, 62.98041413000004],
              [-67.64976966099994, 62.96906159100007],
              [-67.64305579299992, 62.95880768400008],
              [-67.66388912699995, 62.95221588700008],
              [-67.67255611899992, 62.94721100500004],
              [-67.67780514199995, 62.938381252000056],
              [-67.67658443899995, 62.92869700700004],
              [-67.66901607999995, 62.92487213700008],
              [-67.66063391799992, 62.92430247600004],
              [-67.65672766799992, 62.92475006700005],
              [-67.65672766799992, 62.91787344000005],
              [-67.64232337099992, 62.934027411000045],
              [-67.58995520699995, 62.95783112200007],
              [-67.56794186099995, 62.973089911000045],
              [-67.55097408799992, 62.96356842700004],
              [-67.52594967399995, 62.968736070000034],
              [-67.47858639199995, 62.98615143400008],
              [-67.46239173099991, 62.98623281500005],
              [-67.4426977199999, 62.98383209800005],
              [-67.42381751199991, 62.97943756700005],
              [-67.39728756399995, 62.968410549000055],
              [-67.39423580599993, 62.96385325700004],
              [-67.3997289699999, 62.955145575000074],
              [-67.41075598899994, 62.94476959800005],
              [-67.41657467399995, 62.941066799000055],
              [-67.42332923099991, 62.938381252000056],
              [-67.42035885299993, 62.93744538000004],
              [-67.41783606699994, 62.93732330900008],
              [-67.41657467399995, 62.935980536000045],
              [-67.41710364499994, 62.93154531500005],
              [-67.39024817599994, 62.93862539300005],
              [-67.37218176999994, 62.94090403900003],
              [-67.35614986899992, 62.936835028000075],
              [-67.29377193899995, 62.900051174000055],
              [-67.27171790299991, 62.892645575000074],
              [-67.24518795499995, 62.889960028000075],
              [-67.24518795499995, 62.88373444200005],
              [-67.36872311099995, 62.86322663000004],
              [-67.36872311099995, 62.85578034100007],
              [-67.32233639199995, 62.85407135600008],
              [-67.29918372299994, 62.855902411000045],
              [-67.27997799399992, 62.86322663000004],
              [-67.28734290299991, 62.85578034100007],
              [-67.24872799399992, 62.87474192900004],
              [-67.22236080599993, 62.88104889500005],
              [-67.19798743399991, 62.87689850500004],
              [-67.17479407499991, 62.85447825700004],
              [-67.19111080599993, 62.83893463700008],
              [-67.22260494699992, 62.82697174700007],
              [-67.24518795499995, 62.81484609600005],
              [-67.23029537699995, 62.816107489000046],
              [-67.19200598899994, 62.82493724200003],
              [-67.18439693899995, 62.82575104400007],
              [-67.17577063699991, 62.81500885600008],
              [-67.15632076699995, 62.81655508000006],
              [-67.12230383999992, 62.82916901200008],
              [-67.10212154899995, 62.81500885600008],
              [-67.09235592399995, 62.80609772300005],
              [-67.08820553299995, 62.79779694200005],
              [-67.0930883449999, 62.78685130400004],
              [-67.11558997299994, 62.768866278000075],
              [-67.12230383999992, 62.75958893400008],
              [-67.10590572799993, 62.760931708000044],
              [-67.07725989499994, 62.77301666900007],
              [-67.03974361899992, 62.773871161000045],
              [-67.03929602799991, 62.76911041900007],
              [-67.04084225199995, 62.76788971600007],
              [-67.04369055899991, 62.768011786000045],
              [-67.04718990799995, 62.76703522300005],
              [-67.0423070949999, 62.76642487200007],
              [-67.04161536399994, 62.764553127000056],
              [-67.04718990799995, 62.75958893400008],
              [-67.02318274599992, 62.745306708000044],
              [-67.01471920499995, 62.73745351800005],
              [-67.01618404899995, 62.72919342700004],
              [-67.02692623599995, 62.71979401200008],
              [-67.06025143099993, 62.69818756700005],
              [-67.05341549399992, 62.69196198100008],
              [-67.01756751199991, 62.70099518400008],
              [-66.98200436099995, 62.70307038000004],
              [-66.91002356699994, 62.69818756700005],
              [-66.91913814999992, 62.69391510600008],
              [-66.95783443899995, 62.68451569200005],
              [-66.97187252499992, 62.67926666900007],
              [-66.98436438699991, 62.67291901200008],
              [-67.00621497299994, 62.65717194200005],
              [-66.98094641799992, 62.65774160400008],
              [-66.75971432199992, 62.68390534100007],
              [-66.72504635299993, 62.67084381700005],
              [-66.73961341099994, 62.666896877000056],
              [-66.75397701699995, 62.660589911000045],
              [-66.76581783799992, 62.650824286000045],
              [-66.77281653599994, 62.63666413000004],
              [-66.69037838399993, 62.64996979400007],
              [-66.66978919199994, 62.64354075700004],
              [-66.68272864499994, 62.638006903000075],
              [-66.71821041599992, 62.62921784100007],
              [-66.70771236899992, 62.62189362200007],
              [-66.69574947799993, 62.61676666900007],
              [-66.68317623599995, 62.61546458500004],
              [-66.65489661399994, 62.62335846600007],
              [-66.63975989499994, 62.62103913000004],
              [-66.62446041599992, 62.61692942900004],
              [-66.60834713399993, 62.61562734600005],
              [-66.61156165299991, 62.61237213700008],
              [-66.61412512899994, 62.609076239000046],
              [-66.61742102799991, 62.60569896000004],
              [-66.62262936099995, 62.60260651200008],
              [-66.60517330599993, 62.58295319200005],
              [-66.55146236899992, 62.56073639500005],
              [-66.54010982999995, 62.53733958500004],
              [-66.52533932199992, 62.51902903900003],
              [-66.49730383999992, 62.51341380400004],
              [-66.48029537699995, 62.505072333000044],
              [-66.49848385299993, 62.47842031500005],
              [-66.49596106699994, 62.46320221600007],
              [-66.51512610599991, 62.43659088700008],
              [-66.51215572799993, 62.423814195000034],
              [-66.49644934799994, 62.42072174700007],
              [-66.47606360599991, 62.42865631700005],
              [-66.45592200399994, 62.439520575000074],
              [-66.4407445949999, 62.44489166900007],
              [-66.35822506399995, 62.45172760600008],
              [-66.35240637899994, 62.44745514500005],
              [-66.36664791599992, 62.43805573100008],
              [-66.39671790299991, 62.423814195000034],
              [-66.32782955599993, 62.390326239000046],
              [-66.33710689999992, 62.380560614000046],
              [-66.34626217399995, 62.378119208000044],
              [-66.35639400899993, 62.37836334800005],
              [-66.39032955599993, 62.37213776200008],
              [-66.39586341099994, 62.36888255400004],
              [-66.40632076699995, 62.35895416900007],
              [-66.41698157499991, 62.354396877000056],
              [-66.44505774599992, 62.35639069200005],
              [-66.46296139199995, 62.35529205900008],
              [-66.46971594999991, 62.35602448100008],
              [-66.47553463399993, 62.35565827000005],
              [-66.47801673099991, 62.352443752000056],
              [-66.47789466099994, 62.34650299700007],
              [-66.47679602799991, 62.34088776200008],
              [-66.47386633999992, 62.33665599200003],
              [-66.42975826699995, 62.32135651200008],
              [-66.34382076699995, 62.270697333000044],
              [-66.30671139199995, 62.27301666900007],
              [-66.34833736899992, 62.309881903000075],
              [-66.36327063699991, 62.33197663000004],
              [-66.34455318899995, 62.341864325000074],
              [-66.30195064999992, 62.35106028900003],
              [-66.28685462099992, 62.349310614000046],
              [-66.27497311099995, 62.34324778900003],
              [-66.25739498599995, 62.32851797100005],
              [-66.24461829299992, 62.32143789300005],
              [-66.23810787699995, 62.34052155200004],
              [-66.23253333199995, 62.34951406500005],
              [-66.22455807199992, 62.34951406500005],
              [-66.21051998599995, 62.341864325000074],
              [-66.20787512899994, 62.337103583000044],
              [-66.20673580599993, 62.33026764500005],
              [-66.20331783799992, 62.32404205900008],
              [-66.18512936099995, 62.31948476800005],
              [-66.16576087099992, 62.31037018400008],
              [-66.15587317599994, 62.30776601800005],
              [-66.16014563699991, 62.30414459800005],
              [-66.16388912699995, 62.29962799700007],
              [-66.16722571499992, 62.29389069200005],
              [-66.17015540299991, 62.28660716400003],
              [-66.15782630099994, 62.27338288000004],
              [-66.15587317599994, 62.26992422100005],
              [-66.15428626199991, 62.26536692900004],
              [-66.15265865799995, 62.25462474200003],
              [-66.15526282499991, 62.248114325000074],
              [-66.16673743399991, 62.25625234600005],
              [-66.18549557199992, 62.26512278900003],
              [-66.21308346299992, 62.26797109600005],
              [-66.26512610599991, 62.266791083000044],
              [-66.18004309799994, 62.24201080900008],
              [-66.05915279899995, 62.22809479400007],
              [-66.03978430899991, 62.239447333000044],
              [-66.04662024599992, 62.239447333000044],
              [-66.01842200399994, 62.25047435100004],
              [-65.98713131399995, 62.24209219000005],
              [-65.93000240799995, 62.204738674000055],
              [-65.93000240799995, 62.19782135600008],
              [-66.01207434799994, 62.17405833500004],
              [-66.03608150899993, 62.16063060100004],
              [-66.04828854099992, 62.15070221600007],
              [-66.05321204299992, 62.14533112200007],
              [-66.05394446499992, 62.13898346600007],
              [-66.05345618399991, 62.126166083000044],
              [-66.04902096299992, 62.11937083500004],
              [-66.03107662699995, 62.09845612200007],
              [-66.02924557199992, 62.09174225500004],
              [-66.03766842399995, 62.08075592700004],
              [-66.04002844999991, 62.07526276200008],
              [-66.04466712099992, 62.07379791900007],
              [-66.06029212099992, 62.07493724200003],
              [-66.08385169199994, 62.08392975500004],
              [-66.08759518099993, 62.08490631700005],
              [-66.09296627499992, 62.089056708000044],
              [-66.11896725199995, 62.087876695000034],
              [-66.12852942599994, 62.08860911700003],
              [-66.15839596299992, 62.12457916900007],
              [-66.17870032499991, 62.13467031500005],
              [-66.20429439999992, 62.11660390800006],
              [-66.19989986899992, 62.112982489000046],
              [-66.19355221299992, 62.109808661000045],
              [-66.18647213399993, 62.109076239000046],
              [-66.17304439999992, 62.11749909100007],
              [-66.16877193899995, 62.11383698100008],
              [-66.16596432199992, 62.10700104400007],
              [-66.16331946499992, 62.10228099200003],
              [-66.10749264199995, 62.05019765800006],
              [-66.1028539699999, 62.04291413000004],
              [-66.10126705599993, 62.03025950700004],
              [-66.10663814999992, 62.02366771000004],
              [-66.13280188699991, 62.016791083000044],
              [-66.14220130099994, 62.012884833000044],
              [-66.11860104099992, 62.00653717700004],
              [-66.08873450399994, 62.00242747600004],
              [-66.06517493399991, 61.99664948100008],
              [-66.06029212099992, 61.98501211100006],
              [-66.04377193899995, 61.96238841400003],
              [-66.03978430899991, 61.958319403000075],
              [-66.02684485599991, 61.958319403000075],
              [-65.99970455599993, 61.966498114000046],
              [-65.98827063699991, 61.96165599200003],
              [-65.98627682199992, 61.95258209800005],
              [-65.98859615799995, 61.94220612200007],
              [-65.98725338399993, 61.93382396000004],
              [-65.96361243399991, 61.92731354400007],
              [-65.95417232999995, 61.91950104400007],
              [-65.94884192599994, 61.90875885600008],
              [-65.95042883999992, 61.89687734600005],
              [-65.97126217399995, 61.886379299000055],
              [-66.03355872299994, 61.88934967700004],
              [-66.04662024599992, 61.879787502000056],
              [-66.06309973899994, 61.87494538000004],
              [-66.17015540299991, 61.87641022300005],
              [-66.27448482999995, 61.85809967700004],
              [-66.33759518099993, 61.87523021000004],
              [-66.40571041599992, 61.87714264500005],
              [-66.43769283799992, 61.88320547100005],
              [-66.48615475199995, 61.89826080900008],
              [-66.51044674399992, 61.90192291900007],
              [-66.53978430899991, 61.90302155200004],
              [-66.55524654899995, 61.90737539300005],
              [-66.5794164699999, 61.92609284100007],
              [-66.59129798099991, 61.93036530200004],
              [-66.60407467399995, 61.92792389500005],
              [-66.61542721299992, 61.923488674000055],
              [-66.62763424399992, 61.92084381700005],
              [-66.64313717399995, 61.92413971600007],
              [-66.66242428299995, 61.937567450000074],
              [-66.65607662699995, 61.94782135600008],
              [-66.61518307199992, 61.96507396000004],
              [-66.63621985599991, 61.971584377000056],
              [-66.67784583199995, 61.96466705900008],
              [-66.69774329299992, 61.96507396000004],
              [-66.70502682199992, 61.96906159100007],
              [-66.71137447799993, 61.97557200700004],
              [-66.72162838399993, 61.988714911000045],
              [-66.72724361899992, 61.99213288000004],
              [-66.75177975199995, 61.999253648000035],
              [-66.74925696499992, 62.00299713700008],
              [-66.74555416599992, 62.012884833000044],
              [-66.77354895699995, 62.017238674000055],
              [-66.85541744699992, 62.01972077000005],
              [-66.92015540299991, 62.044256903000075],
              [-66.94355221299992, 62.04767487200007],
              [-66.92463131399995, 62.03652578300006],
              [-66.91681881399995, 62.03400299700007],
              [-66.93757076699995, 62.01447174700007],
              [-66.96934973899994, 62.02374909100007],
              [-67.02326412699995, 62.053900458000044],
              [-67.03925533799992, 62.050767320000034],
              [-67.07050533799992, 62.037176825000074],
              [-67.08751380099994, 62.03400299700007],
              [-67.10749264199995, 62.03668854400007],
              [-67.1243383449999, 62.04336172100005],
              [-67.22455807199992, 62.09833405200004],
              [-67.23595130099994, 62.10187409100007],
              [-67.24518795499995, 62.10228099200003],
              [-67.24779212099992, 62.09861888200004],
              [-67.25348873599995, 62.08437734600005],
              [-67.25605221299992, 62.081244208000044],
              [-67.31745357999995, 62.07322825700004],
              [-67.32774817599994, 62.07807038000004],
              [-67.32970130099994, 62.08690013200004],
              [-67.33470618399991, 62.10032786700003],
              [-67.34150143099993, 62.113714911000045],
              [-67.34882564999992, 62.122748114000046],
              [-67.3313695949999, 62.12567780200004],
              [-67.32921301999994, 62.13271719000005],
              [-67.33775794199994, 62.139960028000075],
              [-67.40062415299991, 62.14980703300006],
              [-67.48993893099993, 62.14520905200004],
              [-67.52228756399995, 62.15058014500005],
              [-67.55060787699995, 62.167181708000044],
              [-67.58128821499992, 62.18109772300005],
              [-67.61290442599994, 62.17601146000004],
              [-67.64423580599993, 62.16425202000005],
              [-67.67406165299991, 62.157538153000075],
              [-67.75531979099992, 62.163397528000075],
              [-67.83490963399993, 62.17804596600007],
              [-67.83079993399991, 62.18585846600007],
              [-67.82469641799992, 62.191839911000045],
              [-67.81684322799993, 62.19586823100008],
              [-67.80756588399993, 62.19782135600008],
              [-67.80756588399993, 62.204738674000055],
              [-67.82005774599992, 62.20892975500004],
              [-67.83100338399993, 62.209051825000074],
              [-67.84845943899995, 62.204738674000055],
              [-67.84972083199995, 62.202785549000055],
              [-67.85826575399994, 62.19358958500004],
              [-67.86278235599991, 62.191066799000055],
              [-67.87262936099995, 62.19086334800005],
              [-67.88837643099993, 62.19643789300005],
              [-67.98094641799992, 62.21185944200005],
              [-68.00617428299995, 62.21157461100006],
              [-68.03302975199995, 62.20758698100008],
              [-68.04588782499991, 62.20815664300005],
              [-68.06073971299992, 62.21157461100006],
              [-68.06371008999992, 62.21499258000006],
              [-68.06806393099993, 62.22162506700005],
              [-68.07416744699992, 62.22833893400008],
              [-68.08250891799992, 62.23200104400007],
              [-68.08832760299993, 62.23021067900004],
              [-68.10228430899991, 62.22060781500005],
              [-68.10920162699995, 62.218410549000055],
              [-68.55365963399993, 62.24974192900004],
              [-68.61107337099992, 62.26557038000004],
              [-68.62861080599993, 62.275091864000046],
              [-68.65668697799993, 62.284857489000046],
              [-68.67833411399994, 62.28937409100007],
              [-68.71650143099993, 62.302720445000034],
              [-68.72614498599995, 62.30776601800005],
              [-68.72614498599995, 62.31460195500006],
              [-68.71080481699994, 62.32005442900004],
              [-68.70502682199992, 62.32143789300005],
              [-68.70502682199992, 62.32827383000006],
              [-68.81525631399995, 62.341864325000074],
              [-68.8242895169999, 62.34955475500004],
              [-68.82872473899994, 62.36579010600008],
              [-68.83844967399995, 62.38027578300006],
              [-68.8633520169999, 62.382879950000074],
              [-68.88219153599994, 62.36619700700004],
              [-68.89061438699991, 62.36237213700008],
              [-68.90233313699991, 62.36322663000004],
              [-68.91718502499992, 62.36749909100007],
              [-68.93146725199995, 62.37352122600004],
              [-68.94151770699995, 62.379787502000056],
              [-68.96174068899995, 62.38719310100004],
              [-69.00340735599991, 62.37653229400007],
              [-69.02717037699995, 62.379787502000056],
              [-69.19749915299991, 62.444525458000044],
              [-69.28827877499992, 62.49363841400003],
              [-69.30833899599992, 62.541083075000074],
              [-69.31517493399991, 62.541083075000074],
              [-69.27582760299993, 62.61737702000005],
              [-69.28107662699995, 62.62368398600006],
              [-69.29194088399993, 62.62775299700007],
              [-69.30463619699992, 62.62921784100007],
              [-69.31501217399995, 62.59955475500004],
              [-69.31891842399995, 62.59198639500005],
              [-69.32738196499992, 62.58470286700003],
              [-69.34284420499995, 62.574286200000074],
              [-69.34931393099993, 62.568426825000074],
              [-69.35590572799993, 62.55760325700004],
              [-69.35887610599991, 62.54857005400004],
              [-69.36408443899995, 62.54083893400008],
              [-69.37726803299995, 62.53367747600004],
              [-69.38585364499994, 62.54002513200004],
              [-69.38739986899992, 62.54629140800006],
              [-69.38703365799995, 62.55296458500004],
              [-69.39024817599994, 62.560980536000045],
              [-69.39622962099992, 62.56582265800006],
              [-69.40294348899994, 62.569566148000035],
              [-69.40851803299995, 62.57518138200004],
              [-69.41075598899994, 62.585150458000044],
              [-69.40912838399993, 62.595689195000034],
              [-69.40656490799995, 62.60106028900003],
              [-69.40709387899994, 62.60529205900008],
              [-69.41449947799993, 62.612494208000044],
              [-69.42406165299991, 62.61823151200008],
              [-69.45917721299992, 62.62921784100007],
              [-69.45417232999995, 62.617254950000074],
              [-69.44697018099993, 62.610663153000075],
              [-69.43915768099993, 62.60504791900007],
              [-69.43187415299991, 62.595770575000074],
              [-69.43126380099994, 62.58466217700004],
              [-69.43586178299995, 62.575384833000044],
              [-69.43651282499991, 62.56753164300005],
              [-69.42442786399994, 62.560980536000045],
              [-69.44505774599992, 62.55353424700007],
              [-69.46051998599995, 62.56427643400008],
              [-69.47260494699992, 62.580145575000074],
              [-69.48338782499991, 62.588324286000045],
              [-69.50157630099994, 62.59316640800006],
              [-69.52037512899994, 62.60492584800005],
              [-69.55162512899994, 62.63300202000005],
              [-69.58678137899994, 62.65770091400003],
              [-69.58946692599994, 62.66697825700004],
              [-69.56904049399992, 62.67829010600008],
              [-69.54515540299991, 62.682847398000035],
              [-69.47345943899995, 62.67829010600008],
              [-69.47345943899995, 62.68451569200005],
              [-69.47846432199992, 62.68768952000005],
              [-69.48713131399995, 62.69818756700005],
              [-69.45396887899994, 62.69708893400008],
              [-69.44001217399995, 62.70091380400004],
              [-69.43187415299991, 62.71246979400007],
              [-69.49335689999992, 62.71246979400007],
              [-69.53246008999992, 62.706732489000046],
              [-69.55089270699995, 62.708685614000046],
              [-69.56904049399992, 62.71930573100008],
              [-69.53742428299995, 62.73908112200007],
              [-69.49872799399992, 62.746527411000045],
              [-69.41759192599994, 62.74591705900008],
              [-69.40400143099993, 62.74762604400007],
              [-69.39081783799992, 62.75210195500006],
              [-69.38414466099994, 62.75885651200008],
              [-69.39024817599994, 62.76703522300005],
              [-69.40693111899992, 62.770412502000056],
              [-69.46263587099992, 62.75958893400008],
              [-69.47919674399992, 62.76316966400003],
              [-69.49396725199995, 62.77008698100008],
              [-69.50934811099995, 62.77448151200008],
              [-69.54780025899993, 62.76508209800005],
              [-69.56708736899992, 62.76740143400008],
              [-69.61249752499992, 62.78473541900007],
              [-69.61969967399995, 62.78937409100007],
              [-69.62694251199991, 62.791001695000034],
              [-69.63731848899994, 62.78693268400008],
              [-69.6387426419999, 62.78119538000004],
              [-69.63654537699995, 62.763373114000046],
              [-69.64045162699995, 62.75958893400008],
              [-69.65416419199994, 62.757025458000044],
              [-69.68195553299995, 62.74673086100006],
              [-69.69880123599995, 62.74591705900008],
              [-69.67890377499992, 62.78009674700007],
              [-69.72162838399993, 62.78375885600008],
              [-69.76207434799994, 62.793850002000056],
              [-69.80003821499992, 62.80931224200003],
              [-69.83531653599994, 62.82916901200008],
              [-69.84418697799993, 62.824286200000074],
              [-69.84959876199991, 62.822251695000034],
              [-69.84321041599992, 62.81386953300006],
              [-69.81920325399994, 62.790676174000055],
              [-69.80622311099995, 62.78237539300005],
              [-69.7903539699999, 62.77806224200003],
              [-69.77607174399992, 62.772365627000056],
              [-69.7676488919999, 62.75958893400008],
              [-69.77204342399995, 62.75861237200007],
              [-69.7813207669999, 62.75336334800005],
              [-69.77656002499992, 62.74941640800006],
              [-69.76732337099992, 62.738714911000045],
              [-69.76085364499994, 62.73289622600004],
              [-69.78107662699995, 62.73110586100006],
              [-69.79246985599991, 62.73574453300006],
              [-69.81232662699995, 62.75653717700004],
              [-69.82860266799992, 62.764878648000035],
              [-69.84410559799994, 62.76504140800006],
              [-69.87690182199992, 62.75958893400008],
              [-69.89635169199994, 62.76382070500006],
              [-69.91169186099995, 62.77407461100006],
              [-69.93895423099991, 62.801214911000045],
              [-69.97594153599994, 62.774644273000035],
              [-69.99555416599992, 62.76593659100007],
              [-70.06977291599992, 62.74762604400007],
              [-70.08299719999991, 62.74591705900008],
              [-70.10175533799992, 62.748114325000074],
              [-70.14329993399991, 62.757473049000055],
              [-70.16181393099993, 62.75958893400008],
              [-70.2403051419999, 62.75409577000005],
              [-70.26732337099992, 62.75958893400008],
              [-70.33808346299992, 62.79075755400004],
              [-70.3672582669999, 62.79437897300005],
              [-70.38337154899995, 62.800767320000034],
              [-70.42658443899995, 62.82892487200007],
              [-70.45868893099993, 62.837958075000074],
              [-70.47118079299992, 62.84430573100008],
              [-70.48228919199994, 62.85224030200004],
              [-70.48700924399992, 62.85952383000006],
              [-70.49323482999995, 62.86660390800006],
              [-70.50751705599993, 62.86908600500004],
              [-70.53547115799995, 62.86945221600007],
              [-70.68565833199995, 62.889960028000075],
              [-70.80158443899995, 62.893459377000056],
              [-70.82966061099995, 62.90424225500004],
              [-70.82966061099995, 62.89679596600007],
              [-70.88447018099993, 62.911769924000055],
              [-70.89854895699995, 62.91787344000005],
              [-70.86790930899991, 62.92796458500004],
              [-70.80162512899994, 62.92747630400004],
              [-70.76825924399992, 62.93154531500005],
              [-70.80426998599995, 62.933661200000074],
              [-70.87437903599994, 62.94798411700003],
              [-70.91222083199995, 62.95140208500004],
              [-70.95575924399992, 62.944647528000075],
              [-71.02550208199995, 62.95331452000005],
              [-71.04194088399993, 62.95880768400008],
              [-71.04194088399993, 62.96564362200007],
              [-71.01801510299993, 62.96938711100006],
              [-70.95612545499995, 62.96503327000005],
              [-70.9395238919999, 62.973089911000045],
              [-70.94294186099995, 62.98847077000005],
              [-70.9563695949999, 62.99843984600005],
              [-70.95966549399992, 63.007473049000055],
              [-70.93272864499994, 63.02024974200003],
              [-70.94623775899993, 63.03278229400007],
              [-70.96703040299991, 63.03461334800005],
              [-70.98932857999995, 63.02924225500004],
              [-71.00719153599994, 63.02024974200003],
              [-71.01008053299995, 63.01312897300005],
              [-71.00841223899994, 63.004339911000045],
              [-71.0098363919999, 62.99677155200004],
              [-71.02179928299995, 62.99359772300005],
              [-71.03205318899995, 62.99241771000004],
              [-71.05134029899995, 62.98729075700004],
              [-71.11253821499992, 62.98309967700004],
              [-71.14207923099991, 62.984808661000045],
              [-71.15802975199995, 62.99359772300005],
              [-71.15546627499992, 63.005113023000035],
              [-71.14439856699994, 63.01825592700004],
              [-71.13084876199991, 63.028957424000055],
              [-71.12079830599993, 63.03335195500006],
              [-71.03205318899995, 63.02708567900004],
              [-71.02306067599994, 63.03066640800006],
              [-71.00824947799993, 63.04824453300006],
              [-71.00096594999991, 63.05508047100005],
              [-70.99132239499994, 63.058661200000074],
              [-70.96991939999992, 63.06305573100008],
              [-70.96003170499995, 63.068060614000046],
              [-70.95539303299995, 63.073472398000035],
              [-70.95360266799992, 63.08466217700004],
              [-70.94977779899995, 63.09227122600004],
              [-70.94054114499994, 63.098822333000044],
              [-70.91633053299995, 63.10248444200005],
              [-70.89545650899993, 63.10976797100005],
              [-70.86384029899995, 63.116522528000075],
              [-70.83458411399994, 63.12872955900008],
              [-70.82282467399995, 63.130113023000035],
              [-70.82282467399995, 63.13467031500005],
              [-70.82420813699991, 63.137600002000056],
              [-70.82966061099995, 63.14321523600006],
              [-70.86449133999992, 63.14020416900007],
              [-70.89171301999994, 63.130113023000035],
              [-70.91108150899993, 63.120021877000056],
              [-70.92206783799992, 63.116115627000056],
              [-70.93272864499994, 63.116522528000075],
              [-70.93480383999992, 63.12067291900007],
              [-70.93793697799993, 63.12913646000004],
              [-70.94334876199991, 63.138006903000075],
              [-70.95258541599992, 63.14321523600006],
              [-70.93769283799992, 63.14891185100004],
              [-70.90880286399994, 63.155910549000055],
              [-70.89854895699995, 63.164943752000056],
              [-70.92646236899992, 63.17255280200004],
              [-70.96715247299994, 63.162990627000056],
              [-70.99823971299992, 63.14305247600004],
              [-70.99726314999992, 63.11994049700007],
              [-70.99254309799994, 63.10602448100008],
              [-71.00450598899994, 63.09511953300006],
              [-71.02074133999992, 63.08633047100005],
              [-71.02892005099994, 63.07859935100004],
              [-71.11082923099991, 63.075506903000075],
              [-71.12958736899992, 63.080145575000074],
              [-71.13898678299995, 63.08881256700005],
              [-71.14452063699991, 63.09760163000004],
              [-71.15180416599992, 63.10224030200004],
              [-71.15965735599991, 63.09780508000006],
              [-71.19648189999992, 63.06464264500005],
              [-71.19953365799995, 63.05565013200004],
              [-71.20702063699991, 63.01715729400007],
              [-71.21617591099994, 63.00877513200004],
              [-71.23713131399995, 63.00722890800006],
              [-71.2598363919999, 63.009833075000074],
              [-71.27464758999992, 63.014105536000045],
              [-71.27464758999992, 63.02024974200003],
              [-71.25251217399995, 63.02728913000004],
              [-71.26093502499992, 63.03583405200004],
              [-71.28473873599995, 63.04352448100008],
              [-71.30890865799995, 63.04755280200004],
              [-71.37262936099995, 63.048529364000046],
              [-71.40204830599993, 63.055568752000056],
              [-71.42613684799994, 63.075506903000075],
              [-71.40819251199991, 63.084865627000056],
              [-71.39411373599995, 63.10106028900003],
              [-71.39179439999992, 63.116441148000035],
              [-71.40876217399995, 63.12335846600007],
              [-71.41669674399992, 63.12124258000006],
              [-71.44225012899994, 63.11050039300005],
              [-71.44977779899995, 63.10594310100004],
              [-71.46051998599995, 63.104803778000075],
              [-71.49779212099992, 63.12335846600007],
              [-71.5579320949999, 63.12848541900007],
              [-71.61790930899991, 63.14321523600006],
              [-71.68846594999991, 63.17377350500004],
              [-71.71349036399994, 63.17792389500005],
              [-71.70575924399992, 63.18919505400004],
              [-71.69176184799994, 63.19293854400007],
              [-71.65888424399992, 63.19159577000005],
              [-71.65888424399992, 63.198431708000044],
              [-71.70734615799995, 63.21954987200007],
              [-71.7512914699999, 63.22793203300006],
              [-71.76195227799991, 63.23261139500005],
              [-71.75019283799992, 63.243353583000044],
              [-71.73591061099995, 63.247300523000035],
              [-71.66783606699994, 63.24868398600006],
              [-71.64911861899992, 63.25364817900004],
              [-71.64867102799991, 63.26390208500004],
              [-71.67088782499991, 63.27212148600006],
              [-71.76874752499992, 63.26048411700003],
              [-71.76874752499992, 63.267279364000046],
              [-71.76020260299993, 63.267645575000074],
              [-71.74083411399994, 63.27480703300006],
              [-71.76646887899994, 63.28412506700005],
              [-71.76781165299991, 63.29409414300005],
              [-71.76264400899993, 63.305975653000075],
              [-71.76874752499992, 63.32135651200008],
              [-71.79674231699994, 63.33763255400004],
              [-71.82274329299992, 63.349269924000055],
              [-71.77265377499992, 63.34711334800005],
              [-71.7473852199999, 63.348944403000075],
              [-71.72716223899994, 63.356675523000035],
              [-71.73289954299992, 63.35761139500005],
              [-71.74828040299991, 63.362941799000055],
              [-71.74718176999994, 63.38117096600007],
              [-71.76134192599994, 63.40265534100007],
              [-71.78087317599994, 63.414496161000045],
              [-71.79609127499992, 63.40387604400007],
              [-71.80109615799995, 63.39126211100006],
              [-71.82685299399992, 63.38768138200004],
              [-71.93700110599991, 63.39447663000004],
              [-71.96259518099993, 63.40375397300005],
              [-71.97797604099992, 63.429022528000075],
              [-71.98753821499992, 63.43178945500006],
              [-71.99714107999995, 63.429348049000055],
              [-72.00153561099995, 63.421210028000075],
              [-72.00145423099991, 63.40326569200005],
              [-72.00536048099991, 63.39899323100008],
              [-72.01520748599995, 63.397650458000044],
              [-72.08039303299995, 63.40387604400007],
              [-72.08417721299992, 63.40619538000004],
              [-72.08116614499994, 63.411322333000044],
              [-72.07335364499994, 63.41620514500005],
              [-72.06297766799992, 63.41815827000005],
              [-72.06297766799992, 63.42438385600008],
              [-72.09227454299992, 63.42715078300006],
              [-72.12519283799992, 63.437486070000034],
              [-72.14232337099992, 63.44830963700008],
              [-72.1257624989999, 63.452053127000056],
              [-72.10065670499995, 63.450832424000055],
              [-72.08429928299995, 63.447251695000034],
              [-72.07721920499995, 63.44171784100007],
              [-72.07135982999995, 63.43154531500005],
              [-72.05809485599991, 63.43622467700004],
              [-72.03632564999992, 63.452337958000044],
              [-72.02009029899995, 63.45331452000005],
              [-71.96711178299995, 63.44489166900007],
              [-71.8711645169999, 63.44489166900007],
              [-71.68622799399992, 63.42438385600008],
              [-71.61445064999992, 63.42690664300005],
              [-71.57990475199995, 63.43573639500005],
              [-71.56330318899995, 63.452337958000044],
              [-71.57408606699994, 63.46393463700008],
              [-71.55394446499992, 63.471909898000035],
              [-71.41779537699995, 63.48745351800005],
              [-71.39887447799993, 63.500067450000074],
              [-71.40269934799994, 63.50307851800005],
              [-71.40758216099994, 63.50958893400008],
              [-71.41254635299993, 63.513739325000074],
              [-71.38390051999994, 63.528509833000044],
              [-71.31989498599995, 63.54047272300005],
              [-71.27717037699995, 63.56614817900004],
              [-71.27464758999992, 63.571478583000044],
              [-71.27769934799994, 63.577337958000044],
              [-71.2891332669999, 63.58445872600004],
              [-71.28901119699992, 63.58942291900007],
              [-71.27782141799992, 63.59837474200003],
              [-71.26215572799993, 63.60211823100008],
              [-71.22691809799994, 63.60248444200005],
              [-71.25243079299992, 63.61635976800005],
              [-71.2891332669999, 63.61908600500004],
              [-71.32188880099994, 63.60932038000004],
              [-71.33613033799992, 63.58576080900008],
              [-71.33421790299991, 63.57758209800005],
              [-71.33226477799991, 63.57200755400004],
              [-71.33592688699991, 63.568793036000045],
              [-71.38642330599993, 63.56732819200005],
              [-71.40339107999995, 63.56940338700008],
              [-71.41869055899991, 63.57518138200004],
              [-71.37218176999994, 63.59983958500004],
              [-71.36408443899995, 63.60993073100008],
              [-71.36713619699992, 63.62592194200005],
              [-71.38129635299993, 63.63373444200005],
              [-71.40058346299992, 63.636419989000046],
              [-71.41869055899991, 63.63666413000004],
              [-71.40990149599992, 63.62164948100008],
              [-71.40501868399991, 63.61676666900007],
              [-71.41755123599995, 63.61229075700004],
              [-71.4309789699999, 63.61029694200005],
              [-71.45966549399992, 63.60993073100008],
              [-71.45360266799992, 63.59951406500005],
              [-71.44965572799993, 63.59756094000005],
              [-71.43976803299995, 63.59564850500004],
              [-71.43976803299995, 63.58942291900007],
              [-71.46556555899991, 63.583685614000046],
              [-71.51447506399995, 63.579738674000055],
              [-71.56187903599994, 63.58148834800005],
              [-71.58320064999992, 63.59251536700003],
              [-71.57286536399994, 63.62083567900004],
              [-71.54767818899995, 63.62759023600006],
              [-71.51634680899991, 63.626288153000075],
              [-71.4876195949999, 63.63043854400007],
              [-71.50621497299994, 63.64321523600006],
              [-71.56952877499992, 63.643866278000075],
              [-71.58320064999992, 63.654364325000074],
              [-71.58104407499991, 63.66120026200008],
              [-71.57172604099992, 63.67145416900007],
              [-71.56952877499992, 63.681341864000046],
              [-71.56562252499992, 63.69082265800006],
              [-71.55638587099992, 63.698146877000056],
              [-71.54511471299992, 63.70307038000004],
              [-71.53538977799991, 63.705511786000045],
              [-71.53538977799991, 63.71234772300005],
              [-71.54979407499991, 63.71234772300005],
              [-71.57184811099995, 63.702053127000056],
              [-71.58356686099995, 63.699286200000074],
              [-71.59479732999995, 63.70209381700005],
              [-71.59540768099993, 63.70844147300005],
              [-71.58995520699995, 63.715277411000045],
              [-71.58320064999992, 63.71979401200008],
              [-71.6067602199999, 63.72357819200005],
              [-71.62755286399994, 63.724310614000046],
              [-71.64606686099995, 63.72011953300006],
              [-71.66230221299992, 63.70892975500004],
              [-71.66124426999994, 63.698472398000035],
              [-71.62885494699992, 63.674709377000056],
              [-71.61790930899991, 63.66453685100004],
              [-71.61591549399992, 63.650824286000045],
              [-71.62604732999995, 63.64988841400003],
              [-71.65550696499992, 63.65770091400003],
              [-71.65807044199994, 63.66054922100005],
              [-71.67939205599993, 63.67763906500005],
              [-71.72040768099993, 63.691839911000045],
              [-71.72040768099993, 63.699286200000074],
              [-71.70140540299991, 63.700873114000046],
              [-71.69391842399995, 63.71328359600005],
              [-71.68940182199992, 63.728949286000045],
              [-71.67939205599993, 63.740301825000074],
              [-71.69806881399995, 63.75340403900003],
              [-71.72093665299991, 63.73607005400004],
              [-71.75450598899994, 63.691839911000045],
              [-71.76142330599993, 63.69623444200005],
              [-71.76667232999995, 63.70058828300006],
              [-71.77110755099994, 63.70563385600008],
              [-71.77558346299992, 63.71234772300005],
              [-71.76598059799994, 63.72992584800005],
              [-71.77586829299992, 63.745794989000046],
              [-71.82758541599992, 63.77960846600007],
              [-71.83686275899993, 63.783636786000045],
              [-71.85069739499994, 63.78750234600005],
              [-71.89427649599992, 63.78961823100008],
              [-71.90534420499995, 63.794907945000034],
              [-71.90001380099994, 63.798081773000035],
              [-71.89049231699994, 63.80613841400003],
              [-71.88544674399992, 63.80914948100008],
              [-71.92284094999991, 63.819647528000075],
              [-71.95775305899991, 63.80683014500005],
              [-71.98725338399993, 63.78143952000005],
              [-72.00837154899995, 63.753973700000074],
              [-72.00348873599995, 63.75169505400004],
              [-71.99531002499992, 63.746527411000045],
              [-71.97516842399995, 63.75372955900008],
              [-71.94758053299995, 63.772365627000056],
              [-71.92646236899992, 63.77440013200004],
              [-71.92878170499995, 63.76752350500004],
              [-71.93260657499991, 63.76072825700004],
              [-71.9114477199999, 63.758693752000056],
              [-71.86750240799995, 63.766506252000056],
              [-71.84447180899991, 63.76072825700004],
              [-71.85444088399993, 63.75218333500004],
              [-71.86884518099993, 63.725490627000056],
              [-71.87458248599995, 63.71979401200008],
              [-71.88988196499992, 63.71552155200004],
              [-71.89545650899993, 63.70547109600005],
              [-71.89142818899995, 63.69391510600008],
              [-71.87800045499995, 63.68504466400003],
              [-71.90001380099994, 63.67450592700004],
              [-71.91474361899992, 63.662543036000045],
              [-71.92979895699995, 63.65501536700003],
              [-71.95311438699991, 63.65770091400003],
              [-71.96711178299995, 63.65412018400008],
              [-71.97398841099994, 63.65542226800005],
              [-71.97358150899993, 63.66453685100004],
              [-71.96930904899995, 63.67023346600007],
              [-71.96332760299993, 63.673163153000075],
              [-71.95746822799993, 63.675116278000075],
              [-71.94330807199992, 63.68244049700007],
              [-71.93146725199995, 63.68691640800006],
              [-71.92621822799993, 63.694525458000044],
              [-71.93635006399995, 63.70892975500004],
              [-71.95299231699994, 63.72304922100005],
              [-71.96320553299995, 63.72573476800005],
              [-72.02301998599995, 63.67609284100007],
              [-72.04161536399994, 63.67072174700007],
              [-72.05553137899994, 63.68504466400003],
              [-72.05028235599991, 63.696478583000044],
              [-72.05134029899995, 63.71035390800006],
              [-72.05626380099994, 63.72357819200005],
              [-72.06297766799992, 63.732855536000045],
              [-72.07616126199991, 63.740668036000045],
              [-72.08348548099991, 63.73505280200004],
              [-72.09345455599993, 63.72516510600008],
              [-72.11449133999992, 63.71979401200008],
              [-72.1309301419999, 63.723944403000075],
              [-72.14818274599992, 63.73383209800005],
              [-72.17625891799992, 63.75731028900003],
              [-72.19123287699995, 63.77448151200008],
              [-72.20063229099992, 63.78042226800005],
              [-72.21007239499994, 63.77781810100004],
              [-72.21467037699995, 63.76911041900007],
              [-72.21454830599993, 63.75853099200003],
              [-72.21125240799995, 63.748114325000074],
              [-72.2063695949999, 63.740301825000074],
              [-72.21698971299992, 63.72223541900007],
              [-72.22150631399995, 63.71165599200003],
              [-72.22028561099995, 63.69969310100004],
              [-72.21381588399993, 63.67763906500005],
              [-72.23151607999995, 63.675482489000046],
              [-72.31757564999992, 63.67885976800005],
              [-72.32262122299994, 63.685980536000045],
              [-72.32445227799991, 63.744208075000074],
              [-72.33604895699995, 63.75454336100006],
              [-72.36461341099994, 63.753973700000074],
              [-72.36461341099994, 63.76072825700004],
              [-72.34361731699994, 63.773504950000074],
              [-72.33055579299992, 63.77903880400004],
              [-72.3198542959999, 63.78070709800005],
              [-72.30219479099992, 63.77814362200007],
              [-72.26252193899995, 63.764105536000045],
              [-72.24852454299992, 63.767564195000034],
              [-72.26060950399994, 63.77912018400008],
              [-72.27167721299992, 63.79507070500006],
              [-72.27363033799992, 63.80927155200004],
              [-72.25824947799993, 63.81537506700005],
              [-72.24998938699991, 63.82318756700005],
              [-72.22065182199992, 63.86937083500004],
              [-72.20457923099991, 63.87799713700008],
              [-72.18708248599995, 63.88222890800006],
              [-72.14863033799992, 63.883693752000056],
              [-72.13133704299992, 63.886419989000046],
              [-72.09032141799992, 63.91095612200007],
              [-72.16181393099993, 63.89801666900007],
              [-72.18708248599995, 63.897365627000056],
              [-72.20917721299992, 63.900824286000045],
              [-72.22724361899992, 63.90859609600005],
              [-72.23363196499992, 63.91937897300005],
              [-72.22065182199992, 63.932074286000045],
              [-72.24176998599995, 63.959418036000045],
              [-72.26451575399994, 63.939439195000034],
              [-72.26903235599991, 63.932074286000045],
              [-72.27074133999992, 63.93032461100006],
              [-72.27338619699992, 63.92820872600004],
              [-72.27538001199991, 63.92475006700005],
              [-72.27521725199995, 63.918402411000045],
              [-72.27118893099993, 63.91128164300005],
              [-72.25804602799991, 63.90119049700007],
              [-72.25483150899993, 63.897365627000056],
              [-72.25792395699995, 63.884019273000035],
              [-72.27192135299993, 63.884100653000075],
              [-72.2910863919999, 63.89252350500004],
              [-72.31000729099992, 63.90420156500005],
              [-72.32762610599991, 63.87372467700004],
              [-72.35191809799994, 63.85797760600008],
              [-72.37913977799991, 63.84634023600006],
              [-72.4055883449999, 63.82843659100007],
              [-72.37926184799994, 63.818426825000074],
              [-72.36884518099993, 63.81102122600004],
              [-72.36461341099994, 63.79832591400003],
              [-72.3684789699999, 63.785223700000074],
              [-72.3782445949999, 63.782538153000075],
              [-72.4055883449999, 63.78750234600005],
              [-72.47553463399993, 63.78620026200008],
              [-72.51317298099991, 63.78974030200004],
              [-72.53595943899995, 63.80170319200005],
              [-72.51915442599994, 63.80727773600006],
              [-72.47321529899995, 63.809881903000075],
              [-72.46080481699994, 63.82221100500004],
              [-72.48932857999995, 63.82684967700004],
              [-72.57380123599995, 63.85297272300005],
              [-72.59809322799993, 63.86713288000004],
              [-72.62079830599993, 63.862982489000046],
              [-72.64301510299993, 63.854681708000044],
              [-72.66624915299991, 63.85639069200005],
              [-72.64106197799993, 63.880519924000055],
              [-72.64032955599993, 63.89520905200004],
              [-72.65257727799991, 63.909491278000075],
              [-72.66624915299991, 63.932074286000045],
              [-72.62901770699995, 63.940741278000075],
              [-72.61200924399992, 63.94953034100007],
              [-72.60484778599994, 63.96246979400007],
              [-72.60663814999992, 63.97313060100004],
              [-72.61017818899995, 63.98094310100004],
              [-72.61278235599991, 63.989162502000056],
              [-72.61164303299995, 64.00096263200004],
              [-72.59117591099994, 64.02765534100007],
              [-72.61213131399995, 64.03217194200005],
              [-72.65339107999995, 64.01410553600005],
              [-72.66974850199995, 64.01740143400008],
              [-72.67784583199995, 64.03241608300004],
              [-72.67308508999992, 64.04498932500007],
              [-72.66388912699995, 64.05914948100008],
              [-72.65880286399994, 64.07916901200008],
              [-72.66319739499994, 64.08392975500004],
              [-72.67280025899993, 64.08844635600008],
              [-72.68236243399991, 64.08820221600007],
              [-72.68675696499992, 64.07916901200008],
              [-72.68907630099994, 64.06085846600007],
              [-72.69359290299991, 64.04193756700005],
              [-72.69758053299995, 64.03302643400008],
              [-72.70282955599993, 64.02460358300004],
              [-72.70588131399995, 64.01703522300005],
              [-72.70356197799993, 64.01064687700006],
              [-72.69127356699994, 64.00421784100007],
              [-72.67853756399995, 64.00202057500007],
              [-72.66710364499994, 63.998114325000074],
              [-72.65880286399994, 63.98672109600005],
              [-72.67060299399992, 63.97931549700007],
              [-72.68504798099991, 63.97223541900007],
              [-72.70026607999995, 63.96718984600005],
              [-72.71406002499992, 63.96556224200003],
              [-72.73424231699994, 63.96987539300005],
              [-72.74006100199995, 63.97797272300005],
              [-72.74144446499992, 63.988714911000045],
              [-72.74823971299992, 64.00096263200004],
              [-72.77892005099994, 64.01593659100007],
              [-72.85492916599992, 64.02216217700004],
              [-72.88597571499992, 64.03510163000004],
              [-72.8731176419999, 64.04035065300008],
              [-72.86664791599992, 64.04205963700008],
              [-72.85810299399992, 64.04193756700005],
              [-72.85810299399992, 64.04816315300008],
              [-72.87531490799995, 64.05121491100005],
              [-72.91901607999995, 64.05072663000004],
              [-72.93382727799991, 64.05499909100007],
              [-72.94188391799992, 64.06793854400007],
              [-72.93492591099994, 64.07770416900007],
              [-72.92035885299993, 64.08466217700004],
              [-72.90587317599994, 64.08974844000005],
              [-72.89378821499992, 64.09125397300005],
              [-72.88300533799992, 64.09100983300004],
              [-72.87531490799995, 64.09422435100004],
              [-72.8723852199999, 64.10651276200008],
              [-72.87572180899991, 64.11587148600006],
              [-72.88361568899995, 64.11806875200006],
              [-72.89252682199992, 64.11884186400005],
              [-72.89903723899994, 64.12392812700006],
              [-72.90351314999992, 64.14126211100006],
              [-72.90294348899994, 64.15412018400008],
              [-72.9055883449999, 64.16559479400007],
              [-72.91950436099995, 64.17853424700007],
              [-72.93976803299995, 64.18691640800006],
              [-72.96544348899994, 64.19139232000003],
              [-73.0156957669999, 64.19155508000006],
              [-73.05878658799992, 64.18178945500006],
              [-73.07823645699995, 64.18329498900005],
              [-73.08466549399992, 64.19896067900004],
              [-73.07648678299995, 64.20856354400007],
              [-73.06248938699991, 64.21698639500005],
              [-73.05431067599994, 64.22842031500005],
              [-73.06354732999995, 64.24677155200004],
              [-73.11156165299991, 64.25584544500003],
              [-73.12385006399995, 64.26439036700003],
              [-73.13178463399993, 64.26788971600007],
              [-73.12714596299992, 64.27619049700007],
              [-73.12214107999995, 64.28034088700008],
              [-73.11510169199994, 64.28172435100004],
              [-73.10448157499991, 64.28148021000004],
              [-73.13007564999992, 64.29169342700004],
              [-73.21625729099992, 64.29905833500004],
              [-73.22569739499994, 64.32599518400008],
              [-73.23334713399993, 64.33405182500007],
              [-73.24335689999992, 64.33612702000005],
              [-73.25531979099992, 64.32933177300004],
              [-73.24909420499995, 64.32245514500005],
              [-73.25963294199994, 64.31415436400005],
              [-73.27448482999995, 64.31305573100008],
              [-73.31053626199991, 64.31500885600008],
              [-73.31053626199991, 64.30882396000004],
              [-73.29023189999992, 64.30426666900007],
              [-73.27489173099991, 64.29132721600007],
              [-73.27045650899993, 64.27509186400005],
              [-73.28266354099992, 64.26044342700004],
              [-73.30833899599992, 64.25527578300006],
              [-73.34068762899994, 64.25873444200005],
              [-73.36994381399995, 64.26829661700003],
              [-73.38630123599995, 64.28148021000004],
              [-73.38739986899992, 64.28994375200006],
              [-73.38548743399991, 64.30947500200006],
              [-73.39509029899995, 64.32973867400005],
              [-73.39207923099991, 64.33600495000007],
              [-73.37885494699992, 64.34296295800004],
              [-73.3704320949999, 64.34593333500004],
              [-73.35895748599995, 64.34756094000005],
              [-73.34898841099994, 64.35122304900005],
              [-73.34467525899993, 64.36033763200004],
              [-73.34333248599995, 64.36603424700007],
              [-73.33954830599993, 64.37396881700005],
              [-73.33397376199991, 64.38092682500007],
              [-73.32734127499992, 64.38397858300004],
              [-73.32176673099991, 64.38129303600005],
              [-73.30467688699991, 64.36859772300005],
              [-73.29625403599994, 64.36408112200007],
              [-73.28290768099993, 64.36245351800005],
              [-73.27183997299994, 64.36489492400005],
              [-73.26545162699995, 64.36839427300004],
              [-73.26557369699992, 64.37030670800004],
              [-73.27802486899992, 64.37567780200004],
              [-73.31855221299992, 64.39960358300004],
              [-73.34125729099992, 64.40509674700007],
              [-73.35997473899994, 64.39960358300004],
              [-73.37494869699992, 64.37567780200004],
              [-73.39313717399995, 64.37030670800004],
              [-73.41669674399992, 64.37409088700008],
              [-73.48188229099992, 64.40509674700007],
              [-73.44965572799993, 64.44220612200007],
              [-73.42926998599995, 64.45416901200008],
              [-73.40953528599994, 64.44912344000005],
              [-73.38398189999992, 64.43842194200005],
              [-73.35431881399995, 64.44245026200008],
              [-73.32567298099991, 64.45571523600006],
              [-73.30308997299994, 64.47272370000007],
              [-73.32542883999992, 64.47919342700004],
              [-73.34557044199994, 64.47378164300005],
              [-73.36603756399995, 64.46454498900005],
              [-73.38939368399991, 64.45966217700004],
              [-73.41840572799993, 64.46503327000005],
              [-73.41718502499992, 64.47736237200007],
              [-73.39769446499992, 64.49111562700006],
              [-73.29169674399992, 64.52456289300005],
              [-73.27269446499992, 64.52798086100006],
              [-73.26878821499992, 64.53204987200007],
              [-73.25763912699995, 64.55174388200004],
              [-73.25531979099992, 64.55898672100005],
              [-73.2481176419999, 64.56464264500005],
              [-73.20067298099991, 64.56952545800004],
              [-73.18036861899992, 64.57575104400007],
              [-73.17255611899992, 64.58112213700008],
              [-73.16718502499992, 64.59003327000005],
              [-73.16706295499995, 64.59723541900007],
              [-73.16938229099992, 64.60830312700006],
              [-73.17467200399994, 64.61611562700006],
              [-73.18358313699991, 64.61359284100007],
              [-73.20160885299993, 64.60114166900007],
              [-73.22447669199994, 64.59174225500004],
              [-73.24836178299995, 64.58905670800004],
              [-73.26899166599992, 64.59686920800004],
              [-73.27635657499991, 64.60439687700006],
              [-73.27607174399992, 64.60846588700008],
              [-73.27403723899994, 64.61359284100007],
              [-73.27643795499995, 64.62417226800005],
              [-73.28270423099991, 64.64032623900005],
              [-73.28742428299995, 64.64813873900005],
              [-73.29609127499992, 64.65338776200008],
              [-73.29893958199995, 64.66258372600004],
              [-73.30308997299994, 64.66571686400005],
              [-73.30870520699995, 64.66559479400007],
              [-73.31244869699992, 64.66290924700007],
              [-73.31586666599992, 64.65981679900005],
              [-73.32050533799992, 64.65827057500007],
              [-73.33027096299992, 64.65643952000005],
              [-73.33885657499991, 64.65167877800008],
              [-73.34605872299994, 64.64500560100004],
              [-73.35151119699992, 64.63784414300005],
              [-73.32921301999994, 64.61884186400005],
              [-73.30943762899994, 64.59365469000005],
              [-73.30138098899994, 64.56557851800005],
              [-73.31395423099991, 64.53815338700008],
              [-73.33031165299991, 64.53091054900005],
              [-73.42487545499995, 64.51752350500004],
              [-73.44526119699992, 64.51105377800008],
              [-73.46422278599994, 64.50800202000005],
              [-73.48188229099992, 64.51496002800008],
              [-73.46886145699995, 64.52985260600008],
              [-73.46845455599993, 64.54612864800004],
              [-73.47651119699992, 64.56045156500005],
              [-73.48871822799993, 64.56952545800004],
              [-73.48871822799993, 64.57575104400007],
              [-73.47492428299995, 64.57534414300005],
              [-73.4610082669999, 64.57196686400005],
              [-73.44806881399995, 64.56631094000005],
              [-73.42231197799993, 64.55101146000004],
              [-73.4121801419999, 64.55304596600007],
              [-73.40424557199992, 64.55878327000005],
              [-73.39618893099993, 64.56207916900007],
              [-73.39533443899995, 64.56513092700004],
              [-73.44090735599991, 64.58258698100008],
              [-73.45234127499992, 64.59149811400005],
              [-73.45323645699995, 64.59821198100008],
              [-73.44452877499992, 64.60224030200004],
              [-73.42723548099991, 64.60301341400003],
              [-73.45026607999995, 64.61640045800004],
              [-73.47362219999991, 64.61469147300005],
              [-73.51537024599992, 64.59686920800004],
              [-73.53722083199995, 64.59247467700004],
              [-73.56432044199994, 64.59149811400005],
              [-73.58259029899995, 64.59650299700007],
              [-73.57807369699992, 64.61050039300005],
              [-73.58808346299992, 64.62494538000004],
              [-73.60374915299991, 64.64313385600008],
              [-73.62364661399994, 64.65875885600008],
              [-73.64635169199994, 64.66571686400005],
              [-73.66901607999995, 64.66396719000005],
              [-73.67145748599995, 64.65688711100006],
              [-73.66474361899992, 64.64472077000005],
              [-73.66002356699994, 64.62759023600006],
              [-73.66295325399994, 64.61351146000004],
              [-73.67035885299993, 64.60325755400004],
              [-73.67951412699995, 64.59389883000006],
              [-73.68793697799993, 64.58258698100008],
              [-73.66649329299992, 64.58055247600004],
              [-73.64635169199994, 64.57575104400007],
              [-73.66405188699991, 64.56354401200008],
              [-73.74815833199995, 64.55585358300004],
              [-73.74909420499995, 64.55329010600008],
              [-73.74799557199992, 64.54840729400007],
              [-73.74787350199995, 64.54368724200003],
              [-73.75190182199992, 64.54157135600008],
              [-73.75922604099992, 64.54266998900005],
              [-73.77265377499992, 64.54730866100005],
              [-73.77948971299992, 64.54840729400007],
              [-73.79096432199992, 64.55170319200005],
              [-73.81037350199995, 64.56622955900008],
              [-73.83747311099995, 64.57591380400004],
              [-73.87254798099991, 64.60407135600008],
              [-73.89277096299992, 64.61050039300005],
              [-73.92170162699995, 64.60927969000005],
              [-73.93317623599995, 64.60325755400004],
              [-73.93439693899995, 64.59003327000005],
              [-73.92650305899991, 64.58356354400007],
              [-73.88597571499992, 64.57575104400007],
              [-73.89159094999991, 64.55418528900003],
              [-73.87865149599992, 64.54096100500004],
              [-73.86078854099992, 64.53070709800005],
              [-73.85179602799991, 64.51801178600005],
              [-73.84471594999991, 64.50454336100006],
              [-73.82823645699995, 64.49970123900005],
              [-73.80976314999992, 64.49787018400008],
              [-73.79657955599993, 64.49315013200004],
              [-73.80341549399992, 64.50063711100006],
              [-73.79670162699995, 64.49624258000006],
              [-73.79169674399992, 64.49188873900005],
              [-73.78734290299991, 64.48680247600004],
              [-73.78290768099993, 64.48016998900005],
              [-73.79369055899991, 64.47223541900007],
              [-73.80500240799995, 64.46767812700006],
              [-73.81651770699995, 64.46845123900005],
              [-73.84129798099991, 64.48769765800006],
              [-73.85789954299992, 64.49628327000005],
              [-73.87401282499991, 64.49917226800005],
              [-73.88597571499992, 64.49315013200004],
              [-73.88292395699995, 64.48566315300008],
              [-73.87580318899995, 64.47443268400008],
              [-73.8762914699999, 64.46417877800008],
              [-73.89618893099993, 64.45966217700004],
              [-73.91466223899994, 64.46283600500004],
              [-73.94452877499992, 64.47687409100007],
              [-73.96165930899991, 64.48016998900005],
              [-73.95649166599992, 64.45709870000007],
              [-73.9649145169999, 64.44139232000003],
              [-73.96642005099994, 64.42780182500007],
              [-73.94054114499994, 64.41128164300005],
              [-73.95148678299995, 64.40387604400007],
              [-73.96393795499995, 64.39801666900007],
              [-73.98961341099994, 64.39077383000006],
              [-73.98961341099994, 64.38397858300004],
              [-73.98802649599992, 64.37543366100005],
              [-73.98839270699995, 64.35785553600005],
              [-73.99095618399991, 64.33966705900008],
              [-73.99579830599993, 64.32933177300004],
              [-74.01512610599991, 64.32721588700008],
              [-74.03636633999992, 64.33490631700005],
              [-74.05781002499992, 64.33966705900008],
              [-74.07774817599994, 64.32933177300004],
              [-74.07152258999992, 64.33681875200006],
              [-74.08503170499995, 64.33445872600004],
              [-74.10228430899991, 64.33588288000004],
              [-74.11436926999994, 64.34100983300004],
              [-74.11249752499992, 64.34979889500005],
              [-74.12889563699991, 64.35561758000006],
              [-74.14708411399994, 64.35602448100008],
              [-74.1634008449999, 64.35838450700004],
              [-74.17393958199995, 64.37030670800004],
              [-74.13398189999992, 64.36863841400003],
              [-74.11445064999992, 64.37055084800005],
              [-74.09821529899995, 64.37775299700007],
              [-74.10606848899994, 64.38385651200008],
              [-74.11030025899993, 64.39248281500005],
              [-74.11249752499992, 64.40509674700007],
              [-74.07905025899993, 64.42059967700004],
              [-74.10260982999995, 64.43598053600005],
              [-74.14647376199991, 64.45111725500004],
              [-74.17393958199995, 64.46588776200008],
              [-74.09447180899991, 64.45966217700004],
              [-74.07140051999994, 64.44074127800008],
              [-74.05589758999992, 64.43447500200006],
              [-74.04356848899994, 64.44599030200004],
              [-74.05134029899995, 64.46930573100008],
              [-74.12616939999992, 64.54157135600008],
              [-74.08234615799995, 64.53660716400003],
              [-73.99962317599994, 64.51666901200008],
              [-73.95482337099992, 64.51496002800008],
              [-73.95482337099992, 64.52114492400005],
              [-73.97529049399992, 64.53449127800008],
              [-73.99791419199994, 64.54344310100004],
              [-74.08934485599991, 64.56785716400003],
              [-74.1016332669999, 64.56952545800004],
              [-74.15282141799992, 64.56415436400005],
              [-74.16710364499994, 64.56952545800004],
              [-74.16710364499994, 64.57575104400007],
              [-74.13141842399995, 64.59007396000004],
              [-74.00263424399992, 64.58258698100008],
              [-74.01874752499992, 64.60053131700005],
              [-74.0723363919999, 64.62079498900005],
              [-74.08393307199992, 64.64093659100007],
              [-74.08079993399991, 64.64728424700007],
              [-74.06720943899995, 64.66864655200004],
              [-74.06281490799995, 64.69159577000005],
              [-74.05488033799992, 64.71539948100008],
              [-74.04979407499991, 64.72589752800008],
              [-74.06354732999995, 64.73802317900004],
              [-74.08173580599993, 64.74848053600005],
              [-74.10114498599995, 64.75299713700008],
              [-74.11872311099995, 64.74770742400005],
              [-74.1282445949999, 64.73159414300005],
              [-74.10859127499992, 64.70473867400005],
              [-74.11872311099995, 64.68561432500007],
              [-74.12909908799992, 64.68146393400008],
              [-74.15253658799992, 64.68646881700005],
              [-74.16710364499994, 64.68561432500007],
              [-74.18932044199994, 64.66840241100005],
              [-74.20234127499992, 64.66522858300004],
              [-74.21495520699995, 64.67877838700008],
              [-74.22687740799995, 64.66811758000006],
              [-74.2324926419999, 64.65643952000005],
              [-74.2317602199999, 64.64484284100007],
              [-74.2141820949999, 64.61945221600007],
              [-74.21589107999995, 64.60887278900003],
              [-74.2422582669999, 64.58258698100008],
              [-74.27631588399993, 64.60667552300004],
              [-74.29255123599995, 64.62221914300005],
              [-74.29377193899995, 64.63442617400005],
              [-74.27110755099994, 64.64362213700008],
              [-74.26231848899994, 64.65094635600008],
              [-74.26642818899995, 64.66201406500005],
              [-74.27513587099992, 64.66901276200008],
              [-74.28742428299995, 64.67674388200004],
              [-74.30028235599991, 64.68305084800005],
              [-74.31078040299991, 64.68561432500007],
              [-74.3255102199999, 64.67812734600005],
              [-74.32433020699995, 64.64264557500007],
              [-74.33844967399995, 64.63100820500006],
              [-74.35973059799994, 64.63397858300004],
              [-74.39936275899993, 64.66010163000004],
              [-74.42035885299993, 64.66571686400005],
              [-74.40855872299994, 64.64712148600006],
              [-74.38768469999991, 64.62669505400004],
              [-74.36412512899994, 64.60858795800004],
              [-74.34459387899994, 64.59686920800004],
              [-74.36860104099992, 64.57660553600005],
              [-74.39447994699992, 64.57684967700004],
              [-74.41791744699992, 64.59048086100006],
              [-74.43464107999995, 64.61050039300005],
              [-74.4219457669999, 64.61334870000007],
              [-74.41478430899991, 64.62042877800008],
              [-74.41584225199995, 64.62763092700004],
              [-74.42747962099992, 64.63100820500006],
              [-74.44469153599994, 64.62872955900008],
              [-74.47740637899994, 64.61896393400008],
              [-74.49608313699991, 64.61664459800005],
              [-74.52460689999992, 64.62152741100005],
              [-74.54076087099992, 64.62616608300004],
              [-74.55072994699992, 64.63100820500006],
              [-74.55443274599992, 64.63800690300008],
              [-74.55846106699994, 64.65717194200005],
              [-74.56432044199994, 64.66571686400005],
              [-74.58055579299992, 64.67316315300008],
              [-74.62543697799993, 64.68471914300005],
              [-74.64313717399995, 64.69586823100008],
              [-74.65778561099995, 64.70897044500003],
              [-74.70836341099994, 64.74022044500003],
              [-74.69566809799994, 64.74754466400003],
              [-74.68968665299991, 64.75226471600007],
              [-74.68724524599992, 64.75763580900008],
              [-74.68390865799995, 64.76219310100004],
              [-74.67621822799993, 64.76186758000006],
              [-74.6673070949999, 64.76032135600008],
              [-74.66051184799994, 64.76129791900007],
              [-74.6536352199999, 64.77069733300004],
              [-74.64891516799992, 64.78180573100008],
              [-74.64228268099993, 64.79100169500003],
              [-74.60692298099991, 64.80341217700004],
              [-74.57066809799994, 64.84125397300005],
              [-74.55361894399994, 64.84882233300004],
              [-74.51158606699994, 64.83706289300005],
              [-74.48664303299995, 64.83665599200003],
              [-74.48180091099994, 64.85008372600004],
              [-74.50190182199992, 64.86277903900003],
              [-74.56224524599992, 64.86416250200006],
              [-74.57799231699994, 64.87738678600005],
              [-74.56676184799994, 64.88019440300008],
              [-74.55719967399995, 64.88385651200008],
              [-74.54950924399992, 64.88947174700007],
              [-74.54389400899993, 64.89850495000007],
              [-74.56867428299995, 64.89740631700005],
              [-74.64631100199995, 64.90473053600005],
              [-74.66075598899994, 64.89972565300008],
              [-74.65697180899991, 64.88963450700004],
              [-74.64622962099992, 64.87689850500004],
              [-74.64008541599992, 64.86371491100005],
              [-74.66209876199991, 64.86888255400004],
              [-74.72541256399995, 64.86371491100005],
              [-74.74286861899992, 64.85785553600005],
              [-74.74018307199992, 64.84454987200007],
              [-74.7219945949999, 64.82273997600004],
              [-74.70982825399994, 64.80304596600007],
              [-74.70933997299994, 64.79169342700004],
              [-74.71857662699995, 64.77777741100005],
              [-74.73143469999991, 64.77216217700004],
              [-74.74571692599994, 64.77529531500005],
              [-74.79316158799992, 64.80158112200007],
              [-74.80626380099994, 64.80695221600007],
              [-74.8216039699999, 64.80914948100008],
              [-74.82319088399993, 64.80516185100004],
              [-74.82957923099991, 64.79612864800004],
              [-74.83979244699992, 64.78676992400005],
              [-74.85236568899995, 64.78119538000004],
              [-74.86860104099992, 64.78314850500004],
              [-74.90501868399991, 64.79857005400004],
              [-74.92088782499991, 64.80231354400007],
              [-74.97114010299993, 64.80451080900008],
              [-74.98888098899994, 64.80231354400007],
              [-74.9649145169999, 64.77513255400004],
              [-74.92524166599992, 64.76654694200005],
              [-74.88239498599995, 64.76288483300004],
              [-74.84862219999991, 64.75079987200007],
              [-74.8438207669999, 64.74457428600005],
              [-74.84125729099992, 64.73200104400007],
              [-74.83808346299992, 64.72589752800008],
              [-74.83226477799991, 64.72060781500005],
              [-74.82099361899992, 64.71442291900007],
              [-74.81480872299994, 64.70978424700007],
              [-74.79657955599993, 64.70087311400005],
              [-74.74982662699995, 64.69489166900007],
              [-74.72883053299995, 64.68903229400007],
              [-74.59166419199994, 64.63100820500006],
              [-74.46873938699991, 64.56207916900007],
              [-74.50409908799992, 64.54661692900004],
              [-74.52147376199991, 64.54218170800004],
              [-74.54389400899993, 64.54157135600008],
              [-74.59752356699994, 64.55023834800005],
              [-74.62543697799993, 64.54881419500003],
              [-74.64631100199995, 64.53473541900007],
              [-74.58356686099995, 64.53266022300005],
              [-74.55317135299993, 64.52480703300006],
              [-74.5364477199999, 64.50747304900005],
              [-74.55744381399995, 64.50116608300004],
              [-74.57201087099992, 64.50678131700005],
              [-74.5860082669999, 64.51618073100008],
              [-74.60529537699995, 64.52114492400005],
              [-74.6192113919999, 64.51650625200006],
              [-74.6172582669999, 64.50592682500007],
              [-74.60765540299991, 64.49437083500004],
              [-74.59850012899994, 64.48700592700004],
              [-74.57774817599994, 64.47943756700005],
              [-74.53193111899992, 64.47540924700007],
              [-74.50999915299991, 64.46930573100008],
              [-74.50568600199995, 64.46173737200007],
              [-74.52143307199992, 64.45612213700008],
              [-74.53807532499991, 64.44769928600005],
              [-74.5364477199999, 64.43170807500007],
              [-74.5598852199999, 64.42739492400005],
              [-74.59089107999995, 64.42926666900007],
              [-74.61359615799995, 64.42723216400003],
              [-74.61217200399994, 64.41128164300005],
              [-74.66112219999991, 64.40468984600005],
              [-74.68476314999992, 64.39777252800008],
              [-74.68101966099994, 64.38397858300004],
              [-74.68101966099994, 64.37775299700007],
              [-74.71308346299992, 64.38202545800004],
              [-74.75776119699992, 64.40078359600005],
              [-74.79088294199994, 64.40509674700007],
              [-74.78880774599992, 64.40033600500004],
              [-74.78559322799993, 64.38865794500003],
              [-74.78343665299991, 64.38397858300004],
              [-74.81480872299994, 64.38572825700004],
              [-74.85138912699995, 64.39630768400008],
              [-74.88569088399993, 64.41181061400005],
              [-74.91010494699992, 64.42829010600008],
              [-74.92609615799995, 64.43475983300004],
              [-74.94225012899994, 64.43036530200004],
              [-74.95787512899994, 64.42234935100004],
              [-74.97211666599992, 64.41811758000006],
              [-74.98896236899992, 64.42243073100008],
              [-75.01911373599995, 64.44163646000004],
              [-75.11302649599992, 64.46588776200008],
              [-75.14024817599994, 64.48590729400007],
              [-75.15680904899995, 64.49437083500004],
              [-75.17450924399992, 64.49315013200004],
              [-75.18866939999992, 64.48240794500003],
              [-75.18085689999992, 64.47577545800004],
              [-75.16462154899995, 64.47101471600007],
              [-75.15339107999995, 64.46588776200008],
              [-75.14887447799993, 64.45184967700004],
              [-75.16051184799994, 64.44879791900007],
              [-75.1790258449999, 64.44940827000005],
              [-75.19493567599994, 64.44599030200004],
              [-75.18748938699991, 64.43854401200008],
              [-75.19770260299993, 64.43284739800004],
              [-75.20856686099995, 64.43170807500007],
              [-75.21943111899992, 64.43402741100005],
              [-75.22972571499992, 64.43854401200008],
              [-75.23822994699992, 64.45506419500003],
              [-75.24274654899995, 64.45966217700004],
              [-75.2500707669999, 64.46246979400007],
              [-75.26292883999992, 64.46405670800004],
              [-75.3118383449999, 64.47996653900003],
              [-75.32530676999994, 64.48700592700004],
              [-75.35834713399993, 64.51154205900008],
              [-75.36969967399995, 64.51496002800008],
              [-75.39940344999991, 64.51911041900007],
              [-75.45604407499991, 64.53742096600007],
              [-75.48578854099992, 64.54157135600008],
              [-75.5410863919999, 64.54205963700008],
              [-75.56513424399992, 64.55170319200005],
              [-75.57172604099992, 64.57575104400007],
              [-75.61778723899994, 64.56679922100005],
              [-75.66279049399992, 64.56854889500005],
              [-75.70685787699995, 64.57925039300005],
              [-75.7930395169999, 64.61701080900008],
              [-75.82001705599993, 64.62221914300005],
              [-75.84235592399995, 64.61359284100007],
              [-75.84125729099992, 64.60150788000004],
              [-75.82323157499991, 64.58942291900007],
              [-75.80024166599992, 64.57990143400008],
              [-75.78400631399995, 64.57575104400007],
              [-75.78400631399995, 64.56952545800004],
              [-75.81322180899991, 64.57005442900004],
              [-75.82685299399992, 64.56801992400005],
              [-75.83922278599994, 64.56207916900007],
              [-75.8281957669999, 64.55975983300004],
              [-75.82441158799992, 64.55247630400004],
              [-75.82209225199995, 64.54238515800006],
              [-75.81537838399993, 64.53139883000006],
              [-75.8008520169999, 64.52366771000004],
              [-75.77940833199995, 64.51862213700008],
              [-75.73932857999995, 64.51496002800008],
              [-75.6946508449999, 64.48700592700004],
              [-75.66193600199995, 64.47719961100006],
              [-75.64716549399992, 64.47052643400008],
              [-75.63316809799994, 64.45966217700004],
              [-75.63914954299992, 64.45453522300005],
              [-75.64561926999994, 64.45209381700005],
              [-75.65282141799992, 64.45148346600007],
              [-75.66112219999991, 64.45221588700008],
              [-75.6536352199999, 64.45221588700008],
              [-75.67731686099995, 64.45563385600008],
              [-75.72309322799993, 64.47150299700007],
              [-75.74303137899994, 64.46588776200008],
              [-75.72105872299994, 64.45522695500006],
              [-75.6946508449999, 64.44599030200004],
              [-75.71019446499992, 64.44155508000006],
              [-75.72370357999995, 64.44501373900005],
              [-75.74986731699994, 64.45966217700004],
              [-75.86591549399992, 64.48908112200007],
              [-75.89342200399994, 64.49262116100005],
              [-75.92182369699992, 64.48700592700004],
              [-75.91266842399995, 64.48265208500004],
              [-75.89647376199991, 64.48200104400007],
              [-75.88642330599993, 64.48016998900005],
              [-75.85737057199992, 64.46771881700005],
              [-75.84919186099995, 64.46588776200008],
              [-75.84015865799995, 64.46214427300004],
              [-75.81126868399991, 64.44456614800004],
              [-75.79828854099992, 64.43854401200008],
              [-75.8047582669999, 64.43480052300004],
              [-75.81114661399994, 64.43276601800005],
              [-75.81781979099992, 64.43187083500004],
              [-75.82494055899991, 64.43170807500007],
              [-75.81871497299994, 64.43170807500007],
              [-75.80882727799991, 64.42182038000004],
              [-75.71576900899993, 64.38397858300004],
              [-75.73603268099993, 64.37246328300006],
              [-75.77098548099991, 64.37425364800004],
              [-75.83177649599992, 64.38397858300004],
              [-75.83771725199995, 64.37946198100008],
              [-75.8418676419999, 64.37201569200005],
              [-75.84715735599991, 64.36806875200006],
              [-75.86213131399995, 64.37763092700004],
              [-75.90485592399995, 64.38837311400005],
              [-75.9192602199999, 64.38906484600005],
              [-75.93297278599994, 64.38556549700007],
              [-75.94908606699994, 64.37775299700007],
              [-75.95299231699994, 64.40753815300008],
              [-75.97834225199995, 64.40648021000004],
              [-76.02733313699991, 64.38397858300004],
              [-76.04369055899991, 64.37982819200005],
              [-76.05663001199991, 64.37177155200004],
              [-76.07123775899993, 64.36640045800004],
              [-76.09247799399992, 64.37030670800004],
              [-76.09955807199992, 64.37710195500006],
              [-76.10334225199995, 64.38580963700008],
              [-76.11021887899994, 64.39183177300004],
              [-76.12665768099993, 64.39077383000006],
              [-76.1204320949999, 64.39077383000006],
              [-76.17503821499992, 64.37775299700007],
              [-76.16559811099995, 64.37767161700003],
              [-76.15684973899994, 64.37641022300005],
              [-76.14867102799991, 64.37396881700005],
              [-76.14093990799995, 64.37030670800004],
              [-76.16767330599993, 64.35529205900008],
              [-76.23326575399994, 64.36835358300004],
              [-76.28636633999992, 64.35106028900003],
              [-76.35260982999995, 64.36237213700008],
              [-76.37983150899993, 64.35663483300004],
              [-76.35619055899991, 64.34662506700005],
              [-76.32115637899994, 64.32111237200007],
              [-76.29792232999995, 64.31500885600008],
              [-76.23786373599995, 64.32184479400007],
              [-76.20775305899991, 64.31924062700006],
              [-76.18805904899995, 64.30141836100006],
              [-76.31761633999992, 64.28082916900007],
              [-76.34980221299992, 64.29181549700007],
              [-76.37836666599992, 64.30853913000004],
              [-76.42003333199995, 64.32074616100005],
              [-76.46165930899991, 64.32436758000006],
              [-76.48969479099992, 64.31500885600008],
              [-76.47516842399995, 64.31004466400003],
              [-76.44440670499995, 64.31061432500007],
              [-76.42829342399995, 64.30882396000004],
              [-76.4160863919999, 64.30353424700007],
              [-76.39399166599992, 64.29071686400005],
              [-76.37983150899993, 64.28839752800008],
              [-76.40672766799992, 64.27423737200007],
              [-76.45470130099994, 64.26996491100005],
              [-76.49628658799992, 64.27806224200003],
              [-76.5039770169999, 64.30141836100006],
              [-76.55488033799992, 64.30882396000004],
              [-76.56855221299992, 64.30182526200008],
              [-76.57587643099993, 64.29987213700008],
              [-76.58116614499994, 64.30780670800004],
              [-76.5860082669999, 64.31110260600008],
              [-76.59162350199995, 64.31391022300005],
              [-76.59618079299992, 64.31500885600008],
              [-76.60521399599992, 64.31122467700004],
              [-76.62690182199992, 64.28839752800008],
              [-76.64085852799991, 64.28363678600005],
              [-76.68895423099991, 64.28148021000004],
              [-76.68407141799992, 64.29140859600005],
              [-76.68150794199994, 64.29523346600007],
              [-76.71092688699991, 64.30536530200004],
              [-76.72789466099994, 64.29612864800004],
              [-76.73033606699994, 64.27627187700006],
              [-76.71625729099992, 64.25421784100007],
              [-76.71825110599991, 64.24135976800005],
              [-76.70641028599994, 64.23289622600004],
              [-76.68834387899994, 64.22833893400008],
              [-76.67157955599993, 64.22687409100007],
              [-76.65668697799993, 64.22134023600006],
              [-76.65741939999992, 64.20905182500007],
              [-76.66950436099995, 64.19684479400007],
              [-76.68895423099991, 64.19155508000006],
              [-76.70783443899995, 64.19391510600008],
              [-76.74376380099994, 64.20359935100004],
              [-76.76410885299993, 64.20579661700003],
              [-76.84662838399993, 64.20579661700003],
              [-76.82994544199994, 64.21442291900007],
              [-76.8118383449999, 64.21942780200004],
              [-76.82123775899993, 64.22504303600005],
              [-76.8255102199999, 64.22638580900008],
              [-76.83234615799995, 64.22687409100007],
              [-76.8255102199999, 64.23379140800006],
              [-76.86290442599994, 64.23505280200004],
              [-76.89863033799992, 64.24371979400007],
              [-76.96271725199995, 64.27411530200004],
              [-76.98200436099995, 64.25751373900005],
              [-77.01744544199994, 64.25901927300004],
              [-77.08556067599994, 64.28148021000004],
              [-77.11583411399994, 64.29710521000004],
              [-77.13324947799993, 64.30109284100007],
              [-77.14081783799992, 64.29181549700007],
              [-77.15221106699994, 64.28465403900003],
              [-77.22337805899991, 64.27411530200004],
              [-77.35081946499992, 64.24111562700006],
              [-77.38105221299992, 64.24677155200004],
              [-77.38011633999992, 64.25511302300004],
              [-77.36668860599991, 64.27708567900004],
              [-77.37018795499995, 64.28148021000004],
              [-77.37755286399994, 64.28343333500004],
              [-77.39338131399995, 64.29254791900007],
              [-77.40156002499992, 64.29523346600007],
              [-77.41270911399994, 64.29409414300005],
              [-77.42402096299992, 64.29096100500004],
              [-77.43622799399992, 64.28998444200005],
              [-77.44989986899992, 64.29523346600007],
              [-77.43232174399992, 64.30084870000007],
              [-77.39716549399992, 64.30605703300006],
              [-77.38105221299992, 64.31500885600008],
              [-77.40485592399995, 64.32758209800005],
              [-77.41173255099994, 64.32933177300004],
              [-77.42100989499994, 64.32713450700004],
              [-77.42796790299991, 64.32233307500007],
              [-77.43565833199995, 64.31500885600008],
              [-77.54552161399994, 64.31500885600008],
              [-77.54552161399994, 64.32245514500005],
              [-77.51805579299992, 64.33437734600005],
              [-77.49091549399992, 64.34979889500005],
              [-77.5110570949999, 64.35724518400008],
              [-77.55610104099992, 64.35781484600005],
              [-77.64093990799995, 64.38760000200006],
              [-77.65473385299993, 64.39077383000006],
              [-77.66234290299991, 64.37734609600005],
              [-77.65058346299992, 64.35419342700004],
              [-77.64704342399995, 64.33222077000005],
              [-77.67894446499992, 64.32245514500005],
              [-77.6829320949999, 64.32477448100008],
              [-77.68883216099994, 64.33454010600008],
              [-77.69261633999992, 64.33681875200006],
              [-77.72362219999991, 64.34296295800004],
              [-77.73204505099994, 64.34284088700008],
              [-77.73973548099991, 64.34129466400003],
              [-77.74799557199992, 64.34056224200003],
              [-77.75780188699991, 64.34296295800004],
              [-77.76142330599993, 64.34699127800008],
              [-77.77000891799992, 64.36107005400004],
              [-77.77452551999994, 64.36408112200007],
              [-77.85399329299992, 64.37030670800004],
              [-77.87104244699992, 64.37750885600008],
              [-77.90864010299993, 64.40509674700007],
              [-77.89545650899993, 64.40867747600004],
              [-77.87189693899995, 64.40497467700004],
              [-77.86017818899995, 64.40509674700007],
              [-77.85167395699995, 64.40867747600004],
              [-77.83967037699995, 64.41547272300005],
              [-77.83202063699991, 64.42194245000007],
              [-77.83661861899992, 64.42487213700008],
              [-77.8821508449999, 64.42470937700006],
              [-77.92914791599992, 64.41811758000006],
              [-77.95201575399994, 64.41156647300005],
              [-77.96263587099992, 64.41128164300005],
              [-77.9727270169999, 64.41400788000004],
              [-77.99058997299994, 64.42291901200008],
              [-78.00108801999994, 64.42487213700008],
              [-78.01097571499992, 64.42820872600004],
              [-78.01740475199995, 64.43545156500005],
              [-78.01817786399994, 64.44277578300006],
              [-78.01130123599995, 64.44599030200004],
              [-78.00328528599994, 64.44757721600007],
              [-77.9700414699999, 64.45966217700004],
              [-77.9700414699999, 64.46588776200008],
              [-78.04723059799994, 64.49652741100005],
              [-78.0774633449999, 64.51727936400005],
              [-78.06562252499992, 64.53473541900007],
              [-78.06562252499992, 64.54157135600008],
              [-78.08759518099993, 64.54946523600006],
              [-78.14439856699994, 64.55731842700004],
              [-78.16930091099994, 64.56952545800004],
              [-78.1738988919999, 64.57257721600007],
              [-78.18219967399995, 64.57965729400007],
              [-78.18476314999992, 64.58673737200007],
              [-78.17243404899995, 64.59003327000005],
              [-78.12836666599992, 64.59003327000005],
              [-78.12836666599992, 64.59686920800004],
              [-78.14598548099991, 64.60236237200007],
              [-78.16209876199991, 64.60956452000005],
              [-78.16966712099992, 64.62067291900007],
              [-78.16185462099992, 64.63784414300005],
              [-78.16889400899993, 64.64533112200007],
              [-78.17699133999992, 64.65009186400005],
              [-78.18626868399991, 64.65208567900004],
              [-78.1966039699999, 64.65143463700008],
              [-78.18993079299992, 64.67088450700004],
              [-78.18305416599992, 64.68158600500004],
              [-78.15562903599994, 64.69928620000007],
              [-78.18659420499995, 64.70864492400005],
              [-78.29902096299992, 64.70673248900005],
              [-78.27192135299993, 64.71523672100005],
              [-78.18297278599994, 64.72589752800008],
              [-78.18744869699992, 64.72821686400005],
              [-78.18976803299995, 64.72996653900003],
              [-78.18871008999992, 64.73159414300005],
              [-78.18297278599994, 64.73338450700004],
              [-78.18793697799993, 64.75299713700008],
              [-78.17463131399995, 64.76805247600004],
              [-78.15257727799991, 64.77777741100005],
              [-78.13145911399994, 64.78119538000004],
              [-78.12303626199991, 64.78449127800008],
              [-78.11664791599992, 64.79173411700003],
              [-78.11412512899994, 64.79901764500005],
              [-78.11750240799995, 64.80231354400007],
              [-78.12128658799992, 64.80438873900005],
              [-78.11913001199991, 64.80914948100008],
              [-78.11359615799995, 64.81378815300008],
              [-78.10724850199995, 64.81590403900003],
              [-78.07310950399994, 64.81590403900003],
              [-78.07713782499991, 64.82880280200004],
              [-78.07380123599995, 64.83926015800006],
              [-78.06562252499992, 64.85008372600004],
              [-78.07347571499992, 64.85936107000003],
              [-78.08698482999995, 64.86823151200008],
              [-78.10277258999992, 64.87482330900008],
              [-78.11750240799995, 64.87738678600005],
              [-78.12531490799995, 64.88532135600008],
              [-78.1328832669999, 64.90371328300006],
              [-78.14338131399995, 64.94708893400008],
              [-78.14557857999995, 64.95184967700004],
              [-78.14399166599992, 64.95726146000004],
              [-78.13451087099992, 64.96678294500003],
              [-78.12059485599991, 64.97418854400007],
              [-78.08906002499992, 64.98236725500004],
              [-78.06794186099995, 64.99624258000006],
              [-78.04548092399995, 65.00462474200003],
              [-78.02192135299993, 65.01821523600006],
              [-77.99079342399995, 65.02252838700008],
              [-77.97691809799994, 65.02757396000004],
              [-77.97541256399995, 65.03131745000007],
              [-77.97533118399991, 65.03742096600007],
              [-77.97431393099993, 65.04413483300004],
              [-77.9700414699999, 65.04930247600004],
              [-77.96361243399991, 65.05194733300004],
              [-77.89183508999992, 65.06761302300004],
              [-77.87755286399994, 65.06915924700007],
              [-77.81684322799993, 65.09149811400005],
              [-77.75780188699991, 65.09650299700007],
              [-77.70494544199994, 65.11054108300004],
              [-77.67768307199992, 65.12132396000004],
              [-77.65782630099994, 65.13434479400007],
              [-77.62946529899995, 65.14842357000003],
              [-77.59260006399995, 65.15070221600007],
              [-77.51756751199991, 65.14492422100005],
              [-77.48643958199995, 65.14809804900005],
              [-77.43199622299994, 65.16225820500006],
              [-77.37653561099995, 65.16836172100005],
              [-77.35199947799993, 65.17609284100007],
              [-77.33002682199992, 65.18720123900005],
              [-77.31281490799995, 65.20014069200005],
              [-77.38105221299992, 65.24730052300004],
              [-77.4368383449999, 65.27383047100005],
              [-77.46747799399992, 65.29629140800006],
              [-77.50059973899994, 65.31517161700003],
              [-77.51414954299992, 65.32611725500004],
              [-77.50751705599993, 65.33592357000003],
              [-77.46983801999994, 65.37494538000004],
              [-77.45612545499995, 65.38507721600007],
              [-77.31403561099995, 65.36249420800004],
              [-77.29169674399992, 65.38141510600008],
              [-77.31200110599991, 65.39813873900005],
              [-77.40680904899995, 65.43862539300005],
              [-77.43565833199995, 65.45962148600006],
              [-77.39159094999991, 65.47308991100005],
              [-77.2363988919999, 65.47386302300004],
              [-77.24498450399994, 65.47020091400003],
              [-77.25287838399993, 65.46792226800005],
              [-77.26130123599995, 65.46686432500007],
              [-77.27179928299995, 65.46702708500004],
              [-77.27179928299995, 65.45962148600006],
              [-77.19395911399994, 65.45530833500004],
              [-77.12035071499992, 65.43976471600007],
              [-77.11676998599995, 65.42438385600008],
              [-77.08954830599993, 65.41600169500003],
              [-76.96637936099995, 65.41168854400007],
              [-76.95649166599992, 65.41522858300004],
              [-76.94933020699995, 65.42869700700004],
              [-76.93219967399995, 65.43333567900004],
              [-76.83092200399994, 65.43109772300005],
              [-76.8118383449999, 65.42609284100007],
              [-76.77965247299994, 65.40778229400007],
              [-76.76777096299992, 65.40558502800008],
              [-76.67686926999994, 65.41107819200005],
              [-76.39865068249992, 65.34967682500005],
              [-76.1204320949999, 65.28827545800004],
              [-76.09406490799995, 65.28579336100006],
              [-76.04157467399995, 65.28628164300005],
              [-76.01740475199995, 65.28204987200007],
              [-75.99006100199995, 65.26439036700003],
              [-75.98277747299994, 65.26137929900005],
              [-75.93480383999992, 65.26097239800004],
              [-75.91120357999995, 65.25787995000007],
              [-75.86827551999994, 65.24420807500007],
              [-75.82294674399992, 65.23871491100005],
              [-75.79792232999995, 65.23232656500005],
              [-75.77485104099992, 65.22353750200006],
              [-75.75731360599991, 65.21381256700005],
              [-75.76207434799994, 65.20856354400007],
              [-75.77033443899995, 65.19269440300008],
              [-75.75531979099992, 65.18838125200006],
              [-75.74726314999992, 65.17674388200004],
              [-75.74299068899995, 65.16474030200004],
              [-75.73932857999995, 65.15916575700004],
              [-75.6536352199999, 65.14492422100005],
              [-75.59797115799995, 65.12636953300006],
              [-75.56220455599993, 65.12148672100005],
              [-75.52391516799992, 65.11009349200003],
              [-75.45234127499992, 65.07855866100005],
              [-75.4407445949999, 65.06574127800008],
              [-75.43248450399994, 65.04791901200008],
              [-75.41864986899992, 65.03046295800004],
              [-75.41584225199995, 65.01605866100005],
              [-75.4407445949999, 65.00771719000005],
              [-75.43158932199992, 65.00116608300004],
              [-75.41405188699991, 64.98041413000004],
              [-75.42528235599991, 64.97247955900008],
              [-75.44013424399992, 64.96596914300005],
              [-75.45567786399994, 64.96157461100006],
              [-75.48216712099992, 64.95726146000004],
              [-75.50226803299995, 64.94428131700005],
              [-75.51716061099995, 64.93943919500003],
              [-75.55504309799994, 64.94049713700008],
              [-75.63304602799991, 64.95351797100005],
              [-75.66791744699992, 64.94562409100007],
              [-75.65387936099995, 64.93598053600005],
              [-75.63853919199994, 64.92841217700004],
              [-75.60651607999995, 64.91836172100005],
              [-75.61266028599994, 64.91836172100005],
              [-75.60663814999992, 64.90802643400008],
              [-75.60431881399995, 64.88182200700004],
              [-75.59898841099994, 64.87055084800005],
              [-75.58051510299993, 64.85781484600005],
              [-75.56049557199992, 64.85447825700004],
              [-75.49132239499994, 64.85675690300008],
              [-75.47838294199994, 64.85455963700008],
              [-75.46869869699992, 64.85008372600004],
              [-75.4602758449999, 64.84308502800008],
              [-75.45872962099992, 64.84015534100007],
              [-75.46043860599991, 64.83612702000005],
              [-75.46190344999991, 64.82615794500003],
              [-75.46821041599992, 64.81305573100008],
              [-75.48399817599994, 64.80833567900004],
              [-75.52391516799992, 64.80914948100008],
              [-75.52448482999995, 64.80438873900005],
              [-75.52293860599991, 64.80320872600004],
              [-75.52025305899991, 64.80329010600008],
              [-75.51716061099995, 64.80231354400007],
              [-75.52806555899991, 64.79751211100006],
              [-75.53302975199995, 64.79389069200005],
              [-75.53758704299992, 64.78864166900007],
              [-75.53075110599991, 64.78864166900007],
              [-75.53758704299992, 64.78119538000004],
              [-75.50995846299992, 64.77586497600004],
              [-75.47887122299994, 64.77594635600008],
              [-75.44969641799992, 64.77179596600007],
              [-75.42772376199991, 64.75385163000004],
              [-75.43394934799994, 64.75385163000004],
              [-75.43394934799994, 64.74770742400005],
              [-75.4173070949999, 64.74725983300004],
              [-75.40143795499995, 64.74225495000007],
              [-75.39513098899994, 64.73452383000006],
              [-75.40721594999991, 64.72589752800008],
              [-75.37873287699995, 64.72158437700006],
              [-75.33360755099994, 64.72431061400005],
              [-75.29698645699995, 64.73407623900005],
              [-75.29401607999995, 64.75079987200007],
              [-75.30658932199992, 64.75901927300004],
              [-75.33515377499992, 64.77244700700004],
              [-75.34581458199995, 64.78119538000004],
              [-75.35309811099995, 64.79336172100005],
              [-75.35643469999991, 64.80459219000005],
              [-75.3594457669999, 64.82273997600004],
              [-75.35265051999994, 64.82957591400003],
              [-75.36729895699995, 64.83454010600008],
              [-75.3731176419999, 64.83584219000005],
              [-75.36839758999992, 64.85228099200003],
              [-75.36119544199994, 64.86615631700005],
              [-75.35142981699994, 64.87689850500004],
              [-75.33897864499994, 64.88422272300005],
              [-75.35212154899995, 64.89175039300005],
              [-75.35688229099992, 64.90180084800005],
              [-75.35444088399993, 64.91327545800004],
              [-75.34581458199995, 64.92519765800006],
              [-75.37022864499994, 64.92389557500007],
              [-75.38719641799992, 64.91958242400005],
              [-75.44591223899994, 64.88304271000004],
              [-75.45942135299993, 64.87714264500005],
              [-75.46869869699992, 64.87738678600005],
              [-75.49522864499994, 64.88312409100007],
              [-75.50999915299991, 64.88422272300005],
              [-75.54112708199995, 64.87970612200007],
              [-75.55573482999995, 64.87909577000005],
              [-75.57172604099992, 64.88422272300005],
              [-75.54686438699991, 64.89345937700006],
              [-75.48456783799992, 64.90444570500006],
              [-75.48228919199994, 64.91836172100005],
              [-75.46825110599991, 64.93895091400003],
              [-75.44526119699992, 64.95148346600007],
              [-75.41694088399993, 64.95791250200006],
              [-75.3867895169999, 64.95994700700004],
              [-75.39301510299993, 64.98248932500007],
              [-75.3711645169999, 64.98468659100007],
              [-75.3216039699999, 64.97296784100007],
              [-75.28160559799994, 64.95880768400008],
              [-75.26256262899994, 64.95701732000003],
              [-75.27122962099992, 64.97402578300006],
              [-75.28205318899995, 64.98139069200005],
              [-75.29210364499994, 64.98997630400004],
              [-75.29051673099991, 65.00092194200005],
              [-75.27550208199995, 65.00861237200007],
              [-75.25987708199995, 65.00901927300004],
              [-75.24767005099994, 65.01487864800004],
              [-75.24274654899995, 65.03847890800006],
              [-75.23530025899993, 65.05585358300004],
              [-75.21886145699995, 65.06354401200008],
              [-75.2024633449999, 65.06720612200007],
              [-75.19493567599994, 65.07265859600005],
              [-75.19489498599995, 65.09463125200006],
              [-75.19871985599991, 65.10569896000004],
              [-75.21263587099992, 65.10968659100007],
              [-75.25389563699991, 65.10862864800004],
              [-75.2617895169999, 65.09845612200007],
              [-75.26353919199994, 65.08299388200004],
              [-75.26325436099995, 65.06574127800008],
              [-75.27021236899992, 65.04938385600008],
              [-75.28697669199994, 65.03522370000007],
              [-75.30724036399994, 65.02521393400008],
              [-75.33922278599994, 65.01772695500006],
              [-75.35081946499992, 65.01093170800004],
              [-75.36314856699994, 65.00763580900008],
              [-75.37995357999995, 65.01459381700005],
              [-75.38666744699992, 65.02342357000003],
              [-75.4004613919999, 65.05219147300005],
              [-75.40721594999991, 65.06232330900008],
              [-75.43700110599991, 65.08600495000007],
              [-75.49925696499992, 65.12531159100007],
              [-75.52733313699991, 65.14834219000005],
              [-75.56212317599994, 65.16893138200004],
              [-75.64488684799994, 65.18488190300008],
              [-75.68163001199991, 65.20014069200005],
              [-75.69298255099994, 65.19159577000005],
              [-75.70567786399994, 65.18870677300004],
              [-75.71821041599992, 65.19155508000006],
              [-75.72944088399993, 65.20014069200005],
              [-75.72284908799992, 65.20254140800006],
              [-75.71857662699995, 65.20575592700004],
              [-75.71454830599993, 65.20962148600006],
              [-75.70893307199992, 65.21381256700005],
              [-75.75072180899991, 65.23639557500007],
              [-75.80024166599992, 65.25092194200005],
              [-75.90815182199992, 65.26097239800004],
              [-75.89740963399993, 65.27008698100008],
              [-75.89801998599995, 65.27887604400007],
              [-75.90693111899992, 65.28558991100005],
              [-75.93464107999995, 65.29169342700004],
              [-75.9395238919999, 65.30011627800008],
              [-75.94225012899994, 65.31122467700004],
              [-75.94908606699994, 65.32245514500005],
              [-75.71540279899995, 65.30878327000005],
              [-75.70335852799991, 65.31093984600005],
              [-75.67853756399995, 65.32245514500005],
              [-75.66502844999991, 65.32538483300004],
              [-75.65510006399995, 65.33197663000004],
              [-75.64732825399994, 65.33909739800004],
              [-75.64061438699991, 65.34349192900004],
              [-75.62055416599992, 65.34341054900005],
              [-75.60350501199991, 65.33462148600006],
              [-75.59809322799993, 65.32160065300008],
              [-75.61266028599994, 65.30878327000005],
              [-75.58372962099992, 65.28611888200004],
              [-75.54979407499991, 65.27708567900004],
              [-75.30479895699995, 65.26776764500005],
              [-75.21544348899994, 65.25413646000004],
              [-75.19318600199995, 65.25629303600005],
              [-75.1504613919999, 65.26569245000007],
              [-75.12983150899993, 65.26776764500005],
              [-75.10558020699995, 65.27850983300004],
              [-75.08397376199991, 65.30272044500003],
              [-75.07416744699992, 65.32835521000004],
              [-75.08507239499994, 65.34349192900004],
              [-75.09874426999994, 65.37763092700004],
              [-75.1055395169999, 65.38861725500004],
              [-75.10973059799994, 65.39386627800008],
              [-75.10505123599995, 65.39614492400005],
              [-75.08507239499994, 65.39813873900005],
              [-75.06550045499995, 65.39765045800004],
              [-74.97846432199992, 65.37848541900007],
              [-74.96845455599993, 65.37763092700004],
              [-74.9602758449999, 65.37995026200008],
              [-74.94566809799994, 65.38971588700008],
              [-74.93797766799992, 65.39191315300008],
              [-74.87218176999994, 65.39813873900005],
              [-74.85395260299993, 65.39614492400005],
              [-74.82042395699995, 65.38715241100005],
              [-74.8008520169999, 65.38507721600007],
              [-74.78595943899995, 65.38654205900008],
              [-74.76927649599992, 65.39085521000004],
              [-74.75560462099992, 65.39826080900008],
              [-74.74994869699992, 65.40875885600008],
              [-74.74592037699995, 65.42568594000005],
              [-74.73631751199991, 65.43329498900005],
              [-74.71515865799995, 65.43976471600007],
              [-74.70836341099994, 65.43231842700004],
              [-74.68590247299994, 65.43305084800005],
              [-74.67536373599995, 65.43138255400004],
              [-74.67357337099992, 65.42609284100007],
              [-74.67442786399994, 65.42007070500006],
              [-74.68329830599993, 65.41526927300004],
              [-74.70836341099994, 65.40558502800008],
              [-74.68012447799993, 65.40070221600007],
              [-74.66820227799991, 65.39533112200007],
              [-74.66051184799994, 65.38507721600007],
              [-74.67162024599992, 65.38568756700005],
              [-74.68089758999992, 65.38458893400008],
              [-74.68854732999995, 65.38202545800004],
              [-74.69469153599994, 65.37763092700004],
              [-74.66136633999992, 65.35073476800005],
              [-74.60875403599994, 65.33588288000004],
              [-74.55121822799993, 65.33340078300006],
              [-74.50291907499991, 65.34349192900004],
              [-74.43403072799993, 65.38141510600008],
              [-74.41181393099993, 65.39032623900005],
              [-74.36571204299992, 65.40208567900004],
              [-74.34459387899994, 65.41181061400005],
              [-74.32481848899994, 65.45148346600007],
              [-74.30675208199995, 65.47186920800004],
              [-74.28693600199995, 65.48069896000004],
              [-74.17662512899994, 65.48700592700004],
              [-74.15343176999994, 65.49494049700007],
              [-74.17426510299993, 65.50568268400008],
              [-74.18427486899992, 65.51341380400004],
              [-74.1875707669999, 65.52167389500005],
              [-74.17926998599995, 65.52850983300004],
              [-74.14561926999994, 65.52977122600004],
              [-74.13263912699995, 65.53192780200004],
              [-74.11835689999992, 65.53709544500003],
              [-74.10566158799992, 65.53774648600006],
              [-74.07774817599994, 65.53534577000005],
              [-74.05113684799994, 65.53668854400007],
              [-74.04356848899994, 65.53534577000005],
              [-74.03901119699992, 65.53221263200004],
              [-74.02997799399992, 65.52167389500005],
              [-73.98375403599994, 65.50682200700004],
              [-73.95795650899993, 65.50641510600008],
              [-73.91295325399994, 65.53241608300004],
              [-73.88036048099991, 65.53571198100008],
              [-73.77607174399992, 65.52484772300005],
              [-73.73908443899995, 65.51679108300004],
              [-73.74022376199991, 65.51251862200007],
              [-73.74193274599992, 65.49803294500003],
              [-73.73375403599994, 65.48777903900003],
              [-73.71434485599991, 65.47589752800008],
              [-73.69172115799995, 65.46552155200004],
              [-73.67365475199995, 65.45962148600006],
              [-73.64911861899992, 65.46161530200004],
              [-73.59471594999991, 65.47601959800005],
              [-73.57433020699995, 65.47044505400004],
              [-73.55414791599992, 65.45990631700005],
              [-73.52558346299992, 65.45380280200004],
              [-73.49640865799995, 65.45327383000006],
              [-73.47443600199995, 65.45962148600006],
              [-73.50239010299993, 65.48069896000004],
              [-73.49632727799991, 65.48843008000006],
              [-73.49604244699992, 65.49396393400008],
              [-73.50055904899995, 65.49799225500004],
              [-73.50914466099994, 65.50116608300004],
              [-73.50239010299993, 65.50116608300004],
              [-73.53632564999992, 65.52985260600008],
              [-73.5899145169999, 65.58877187700006],
              [-73.63267981699994, 65.61041901200008],
              [-73.63267981699994, 65.61790599200003],
              [-73.62242591099994, 65.62238190300008],
              [-73.61347408799992, 65.62946198100008],
              [-73.60883541599992, 65.63914622600004],
              [-73.61156165299991, 65.65135325700004],
              [-73.62482662699995, 65.66181061400005],
              [-73.64338131399995, 65.66364166900007],
              [-73.66331946499992, 65.66282786700003],
              [-73.68049068899995, 65.66502513200004],
              [-73.68663489499994, 65.66962311400005],
              [-73.69428463399993, 65.67841217700004],
              [-73.70018469999991, 65.68915436400005],
              [-73.70160885299993, 65.69985586100006],
              [-73.69554602799991, 65.71458567900004],
              [-73.68565833199995, 65.72040436400005],
              [-73.65318762899994, 65.72028229400007],
              [-73.66987057199992, 65.73086172100005],
              [-73.68769283799992, 65.73725006700005],
              [-73.70197506399995, 65.74632396000004],
              [-73.70775305899991, 65.76496002800008],
              [-73.71784420499995, 65.77460358300004],
              [-73.78290768099993, 65.79604726800005],
              [-73.82469641799992, 65.81537506700005],
              [-73.84581458199995, 65.82078685100004],
              [-73.89911861899992, 65.82587311400005],
              [-73.95079505099994, 65.84003327000005],
              [-73.97504635299993, 65.84320709800005],
              [-74.01231848899994, 65.85512929900005],
              [-74.08141028599994, 65.90761953300006],
              [-74.13044186099995, 65.92357005400004],
              [-74.18138587099992, 65.95302969000005],
              [-74.20624752499992, 65.98053620000007],
              [-74.2207738919999, 65.99115631700005],
              [-74.2422582669999, 65.99404531500005],
              [-74.23603268099993, 65.99404531500005],
              [-74.42035885299993, 66.08344147300005],
              [-74.45856686099995, 66.11204661700003],
              [-74.47370357999995, 66.13141510600008],
              [-74.47215735599991, 66.14858633000006],
              [-74.45722408799992, 66.16233958500004],
              [-74.42027747299994, 66.18720123900005],
              [-74.34540768099993, 66.22581614800004],
              [-74.08202063699991, 66.30023834800005],
              [-74.05138098899994, 66.31964752800008],
              [-74.03827877499992, 66.32526276200008],
              [-74.02436275899993, 66.32904694200005],
              [-74.01256262899994, 66.33038971600007],
              [-74.00157630099994, 66.33417389500005],
              [-73.9746801419999, 66.35154857000003],
              [-73.96165930899991, 66.35712311400005],
              [-73.94823157499991, 66.35858795800004],
              [-73.90644283799992, 66.35712311400005],
              [-73.91100012899994, 66.36749909100007],
              [-73.91327877499992, 66.37140534100007],
              [-73.90058346299992, 66.37970612200007],
              [-73.88695227799991, 66.38471100500004],
              [-73.85798092399995, 66.39183177300004],
              [-73.81305904899995, 66.40981679900005],
              [-73.78022213399993, 66.41840241100005],
              [-73.71467037699995, 66.46015045800004],
              [-73.45563717399995, 66.55060455900008],
              [-73.43085689999992, 66.56378815300008],
              [-73.41136633999992, 66.60838450700004],
              [-73.3899633449999, 66.62954336100006],
              [-73.36481686099995, 66.64752838700008],
              [-73.34467525899993, 66.65875885600008],
              [-73.33214270699995, 66.66339752800008],
              [-73.27289791599992, 66.67755768400008],
              [-73.23554439999992, 66.69086334800005],
              [-73.1887914699999, 66.69839101800005],
              [-73.1289770169999, 66.72077057500007],
              [-73.09833736899992, 66.72768789300005],
              [-73.01048743399991, 66.72589752800008],
              [-72.94896399599992, 66.73456452000005],
            ],
          ],
          [
            [
              [-115.32363847599993, 73.50869375200006],
              [-115.31908118399991, 73.48826732000003],
              [-115.32054602799991, 73.48065827000005],
              [-115.33079993399991, 73.47768789300005],
              [-115.34959876199991, 73.47654857000003],
              [-115.40127519399994, 73.46796295800004],
              [-115.41673743399991, 73.46059804900005],
              [-115.4500219389999, 73.43431224200003],
              [-115.45775305899991, 73.42987702000005],
              [-115.53726152299993, 73.42479075700004],
              [-115.55736243399991, 73.41925690300008],
              [-115.59093176999994, 73.40424225500004],
              [-115.75377356699994, 73.35748932500007],
              [-115.97984778599994, 73.32485586100006],
              [-116.21849524599992, 73.28465403900003],
              [-116.4590551419999, 73.26117584800005],
              [-116.50300045499989, 73.23802317900004],
              [-116.71271725199995, 73.20132070500006],
              [-116.76862545499989, 73.17877838700008],
              [-116.78880774599992, 73.17365143400008],
              [-116.85179602799991, 73.16657135600008],
              [-116.9070531889999, 73.14183177300004],
              [-116.9832250639999, 73.11969635600008],
              [-117.14720618399991, 73.09345123900005],
              [-117.19994055899991, 73.06952545800004],
              [-117.21548417899993, 73.06610748900005],
              [-117.3902074859999, 73.05548737200007],
              [-117.68529212099992, 72.98114655200004],
              [-117.76109778599994, 72.97174713700008],
              [-117.87287350199995, 72.92963288000004],
              [-117.9885961579999, 72.90493398600006],
              [-118.04214433499993, 72.88589101800005],
              [-118.23802649599992, 72.85757070500006],
              [-118.43106035099993, 72.80849844000005],
              [-118.46129309799994, 72.79531484600005],
              [-118.48696855399993, 72.77505117400005],
              [-118.52196204299992, 72.75771719000005],
              [-118.57298743399991, 72.75128815300008],
              [-118.71764075399994, 72.74876536700003],
              [-118.7678930329999, 72.73948802300004],
              [-118.90538489499994, 72.68870677300004],
              [-119.12319902299993, 72.63703034100007],
              [-119.1446020169999, 72.63471100500004],
              [-119.16388912699995, 72.62982819200005],
              [-119.1726781889999, 72.61790599200003],
              [-119.17760169199994, 72.60333893400008],
              [-119.1856176419999, 72.59031810100004],
              [-119.18980872299994, 72.57904694200005],
              [-119.1800024079999, 72.55239492400005],
              [-119.18187415299991, 72.53856028900003],
              [-119.19359290299991, 72.53025950700004],
              [-119.23460852799991, 72.51479726800005],
              [-119.25072180899991, 72.50438060100004],
              [-119.24624589799993, 72.48566315300008],
              [-119.26280676999994, 72.47260163000004],
              [-119.28697669199994, 72.46198151200008],
              [-119.30532792899993, 72.45038483300004],
              [-119.31550045499989, 72.43398672100005],
              [-119.32652747299994, 72.40818919500003],
              [-119.32957923099991, 72.38446686400005],
              [-119.31590735599991, 72.37409088700008],
              [-119.30479895699995, 72.37006256700005],
              [-119.31309973899994, 72.36107005400004],
              [-119.32876542899993, 72.35179271000004],
              [-119.3401586579999, 72.34674713700008],
              [-119.38638261599993, 72.33584219000005],
              [-119.43659420499989, 72.31818268400008],
              [-119.65099036399994, 72.27387116100005],
              [-119.77281653599994, 72.22955963700008],
              [-119.80565344999991, 72.22321198100008],
              [-119.8303930329999, 72.22284577000005],
              [-119.90184485599991, 72.23065827000005],
              [-119.92682857999989, 72.23045482000003],
              [-119.97598222599993, 72.22467682500007],
              [-120.1760961579999, 72.23566315300008],
              [-120.19668535099993, 72.24433014500005],
              [-120.13951575399994, 72.25421784100007],
              [-120.12779700399994, 72.26422760600008],
              [-120.15396074099993, 72.27098216400003],
              [-120.19196529899995, 72.27399323100008],
              [-120.22956295499989, 72.27122630400004],
              [-120.25475012899994, 72.26080963700008],
              [-120.26121985599991, 72.24184804900005],
              [-120.24331620999993, 72.23065827000005],
              [-120.19668535099993, 72.21702708500004],
              [-120.18346106699994, 72.20429108300004],
              [-120.17788652299993, 72.19122955900008],
              [-120.1738988919999, 72.17820872600004],
              [-120.15465247299994, 72.15143463700008],
              [-120.15274003799993, 72.13996002800008],
              [-120.15807044199994, 72.12836334800005],
              [-120.1687719389999, 72.11395905200004],
              [-120.19774329299992, 72.08502838700008],
              [-120.30654863199993, 72.01776764500005],
              [-120.3491918609999, 71.99900950700004],
              [-120.39476477799991, 71.98444245000007],
              [-120.43399003799993, 71.96430084800005],
              [-120.45738684799994, 71.92902252800008],
              [-120.4104711579999, 71.89996979400007],
              [-120.38809160099993, 71.88231028900003],
              [-120.39159094999991, 71.87445709800005],
              [-120.40343176999994, 71.86383698100008],
              [-120.40672766799992, 71.83930084800005],
              [-120.40680904899995, 71.81167226800005],
              [-120.40892493399991, 71.79181549700007],
              [-120.41991126199991, 71.76434967700004],
              [-120.42162024599992, 71.74921295800004],
              [-120.41266842399995, 71.73574453300006],
              [-120.39159094999991, 71.71332428600005],
              [-120.38337154899995, 71.70148346600007],
              [-120.38243567599994, 71.69171784100007],
              [-120.38780676999994, 71.68235911700003],
              [-120.40607662699995, 71.66327545800004],
              [-120.42259680899991, 71.63483307500007],
              [-120.51553300699993, 71.54319896000004],
              [-120.63524329299992, 71.49144114800004],
              [-120.76414954299992, 71.47329336100006],
              [-120.9925024079999, 71.42885976800005],
              [-121.20555579299992, 71.41107819200005],
              [-121.4231664699999, 71.38031647300005],
              [-121.60814368399991, 71.40143463700008],
              [-121.54527747299994, 71.41998932500007],
              [-121.53795325399994, 71.43065013200004],
              [-121.56680253799993, 71.45233795800004],
              [-121.60350501199991, 71.46442291900007],
              [-121.6519262359999, 71.46971263200004],
              [-121.70055091099994, 71.46808502800008],
              [-121.7378637359999, 71.45917389500005],
              [-121.85456295499989, 71.40766022300005],
              [-121.93106035099993, 71.36050039300005],
              [-121.98037675699993, 71.34686920800004],
              [-122.0606176419999, 71.29840729400007],
              [-122.12295488199993, 71.27081940300008],
              [-122.15607662699995, 71.26117584800005],
              [-122.23302161399994, 71.25311920800004],
              [-122.3198949859999, 71.23383209800005],
              [-122.40172278599994, 71.22601959800005],
              [-122.62954667899993, 71.17495351800005],
              [-122.67198645699995, 71.14948151200008],
              [-122.69692949099993, 71.13910553600005],
              [-122.72752844999991, 71.11408112200007],
              [-122.75328528599994, 71.09979889500005],
              [-122.79775956899994, 71.08779531500005],
              [-123.0999242829999, 71.08462148600006],
              [-123.14989173099991, 71.09296295800004],
              [-123.25527910099993, 71.13043854400007],
              [-123.3523656889999, 71.18284739800004],
              [-123.43569902299993, 71.24860260600008],
              [-123.5567113919999, 71.39813873900005],
              [-123.62352454299992, 71.46222565300008],
              [-123.66917883999992, 71.49481842700004],
              [-123.71849524599992, 71.52122630400004],
              [-123.73452714799993, 71.52716705900008],
              [-123.79792232999989, 71.53864166900007],
              [-123.80821692599994, 71.54254791900007],
              [-123.8184301419999, 71.55182526200008],
              [-123.83511308499993, 71.57217031500005],
              [-123.9395238919999, 71.65326569200005],
              [-124.06456458199995, 71.70038483300004],
              [-124.36312822149992, 71.75250885650004],
              [-124.6616918609999, 71.80463288000004],
              [-124.87319902299993, 71.85561758000006],
              [-124.96861731699994, 71.89057038000004],
              [-125.23228919199994, 71.94131094000005],
              [-125.25340735599991, 71.95571523600006],
              [-125.02749589799993, 71.96320221600007],
              [-125.01183020699995, 71.95905182500007],
              [-124.9820043609999, 71.94550202000005],
              [-124.96788489499994, 71.94269440300008],
              [-124.9480688139999, 71.94456614800004],
              [-124.94029700399994, 71.94989655200004],
              [-124.94420325399994, 71.95750560100004],
              [-124.95889238199993, 71.96662018400008],
              [-125.00670325399994, 71.97898997600004],
              [-125.27196204299992, 71.98078034100007],
              [-125.56663977799991, 71.97378164300005],
              [-125.79043535099993, 71.94916413000004],
              [-125.87755286399994, 71.96401601800005],
              [-125.80833899599992, 71.97626373900005],
              [-125.78498287699989, 71.98725006700005],
              [-125.76060950399994, 72.00385163000004],
              [-125.74156653599994, 72.02484772300005],
              [-125.7307836579999, 72.05878327000005],
              [-125.72443600199989, 72.06854889500005],
              [-125.71934973899994, 72.07965729400007],
              [-125.72020423099991, 72.09349192900004],
              [-125.73224850199989, 72.10993073100008],
              [-125.75064042899993, 72.11554596600007],
              [-125.79527747299994, 72.11395905200004],
              [-125.75206458199995, 72.14769114800004],
              [-125.69017493399991, 72.16840241100005],
              [-125.62441972599993, 72.17723216400003],
              [-125.56940670499989, 72.17544179900005],
              [-125.56940670499989, 72.18284739800004],
              [-125.62995357999989, 72.18549225500004],
              [-125.65664628799993, 72.19375234600005],
              [-125.6575414699999, 72.20962148600006],
              [-125.6660863919999, 72.21271393400008],
              [-125.67149817599994, 72.21723053600005],
              [-125.6792699859999, 72.23065827000005],
              [-125.67088782499991, 72.23745351800005],
              [-125.66026770699995, 72.25409577000005],
              [-125.65099036399994, 72.25739166900007],
              [-125.57282467399995, 72.24872467700004],
              [-125.54857337099992, 72.25421784100007],
              [-125.50234941299993, 72.27488841400003],
              [-125.4905492829999, 72.27789948100008],
              [-125.4827367829999, 72.28558991100005],
              [-125.48094641799992, 72.30036041900007],
              [-125.48737545499989, 72.31024811400005],
              [-125.50389563699991, 72.30267975500004],
              [-125.51720130099994, 72.29376862200007],
              [-125.5276586579999, 72.29222239800004],
              [-125.53237870999993, 72.29840729400007],
              [-125.52843176999994, 72.31264883000006],
              [-125.52037512899994, 72.32290273600006],
              [-125.50845292899993, 72.33291250200006],
              [-125.48741614499994, 72.34674713700008],
              [-125.47256425699993, 72.35260651200008],
              [-125.43944251199991, 72.36090729400007],
              [-125.42471269399994, 72.36717357000003],
              [-125.41641191299993, 72.37417226800005],
              [-125.39061438699991, 72.40200429900005],
              [-125.40282141799992, 72.40656159100007],
              [-125.42711341099994, 72.40989817900004],
              [-125.43838456899994, 72.41567617400005],
              [-125.41567949099993, 72.42161692900004],
              [-125.34284420499989, 72.42251211100006],
              [-125.36314856699994, 72.43886953300006],
              [-125.3538305329999, 72.44887929900005],
              [-125.30870520699995, 72.46344635600008],
              [-125.3113500639999, 72.47894928600005],
              [-125.29918372299994, 72.48908112200007],
              [-125.25914466099994, 72.50043366100005],
              [-125.22032630099994, 72.50507233300004],
              [-125.17540442599994, 72.51813385600008],
              [-125.06065833199995, 72.56561920800004],
              [-125.03270423099991, 72.56826406500005],
              [-124.97288977799991, 72.56586334800005],
              [-124.95238196499992, 72.56964752800008],
              [-124.97533118399991, 72.59271881700005],
              [-124.96605383999992, 72.60748932500007],
              [-125.03880774599992, 72.60980866100005],
              [-125.0718481109999, 72.61774323100008],
              [-125.10260982999989, 72.63471100500004],
              [-125.08267167899993, 72.63959381700005],
              [-125.05923417899993, 72.64008209800005],
              [-125.03868567599994, 72.64301178600005],
              [-125.02749589799993, 72.65521881700005],
              [-125.0347387359999, 72.65656159100007],
              [-125.04820716099994, 72.66107819200005],
              [-125.05540930899991, 72.66205475500004],
              [-125.04454505099994, 72.67304108300004],
              [-125.02643795499989, 72.67267487200007],
              [-125.00560462099992, 72.66868724200003],
              [-124.98648027299993, 72.66889069200005],
              [-124.97374426999994, 72.67450592700004],
              [-124.96304277299993, 72.68260325700004],
              [-124.94554602799991, 72.70302969000005],
              [-124.96035722599993, 72.70892975500004],
              [-125.02065995999993, 72.70302969000005],
              [-125.00942949099993, 72.71735260600008],
              [-124.98932857999989, 72.73086172100005],
              [-124.97386633999992, 72.74518463700008],
              [-124.9766332669999, 72.76170482000003],
              [-124.98623613199993, 72.76947663000004],
              [-125.00706946499992, 72.78021881700005],
              [-125.01756751199991, 72.78900788000004],
              [-125.0215551419999, 72.79759349200003],
              [-125.02269446499992, 72.81728750200006],
              [-125.02749589799993, 72.82656484600005],
              [-125.03844153599994, 72.83246491100005],
              [-125.08275305899991, 72.84023672100005],
              [-125.10789954299992, 72.85443756700005],
              [-125.11827551999994, 72.86347077000005],
              [-125.11343339799993, 72.86749909100007],
              [-125.09951738199993, 72.87173086100006],
              [-125.08433997299994, 72.87970612200007],
              [-125.06822669199994, 72.88418203300006],
              [-125.0347387359999, 72.87201569200005],
              [-124.99120032499991, 72.87002187700006],
              [-124.9766332669999, 72.86408112200007],
              [-124.9514867829999, 72.85708242400005],
              [-124.77700761599993, 72.89545319200005],
              [-124.70726477799991, 72.88792552300004],
              [-124.5757543609999, 72.90827057500007],
              [-124.52476966099994, 72.92267487200007],
              [-124.49038652299993, 72.92511627800008],
              [-124.47598222599993, 72.93305084800005],
              [-124.47923743399991, 72.93976471600007],
              [-124.52721106699994, 72.95685455900008],
              [-124.51935787699989, 72.96271393400008],
              [-124.49746660099993, 72.97353750200006],
              [-124.49307206899994, 72.97736237200007],
              [-124.5000707669999, 72.98411692900004],
              [-124.51561438699991, 72.98607005400004],
              [-124.54430091099994, 72.98480866100005],
              [-124.56676184799994, 72.98761627800008],
              [-124.59434973899994, 72.99506256700005],
              [-124.62018795499989, 73.00600820500006],
              [-124.63707434799994, 73.01898834800005],
              [-124.62340247299994, 73.02578359600005],
              [-124.7190649079999, 73.02578359600005],
              [-124.7044164699999, 73.01447174700007],
              [-124.6985570949999, 73.01154205900008],
              [-124.72630774599992, 73.00877513200004],
              [-124.75475012899994, 73.01752350500004],
              [-124.85069739499994, 73.06354401200008],
              [-124.86538652299993, 73.07550690300008],
              [-124.85993404899995, 73.09031810100004],
              [-124.8496801419999, 73.09552643400008],
              [-124.8211156889999, 73.10635000200006],
              [-124.8152563139999, 73.11082591400003],
              [-124.81240800699993, 73.12103913000004],
              [-124.8054906889999, 73.13007233300004],
              [-124.79637610599991, 73.13715241100005],
              [-124.78726152299993, 73.14183177300004],
              [-124.66641191299993, 73.15448639500005],
              [-124.64391028599994, 73.16982656500005],
              [-124.65013587099992, 73.17112864800004],
              [-124.65929114499994, 73.17422109600005],
              [-124.66783606699994, 73.17829010600008],
              [-124.67186438699991, 73.18280670800004],
              [-124.67096920499989, 73.19367096600007],
              [-124.66584225199989, 73.19757721600007],
              [-124.65831458199995, 73.19928620000007],
              [-124.65013587099992, 73.20331452000005],
              [-124.59837805899991, 73.23851146000004],
              [-124.58584550699993, 73.24428945500006],
              [-124.57412675699993, 73.25120677300004],
              [-124.54088294199994, 73.29889557500007],
              [-124.48936926999994, 73.34389883000006],
              [-124.46922766799992, 73.35317617400005],
              [-124.41779537699989, 73.36383698100008],
              [-124.40371660099993, 73.37466054900005],
              [-124.40562903599994, 73.39004140800006],
              [-124.43724524599992, 73.40668366100005],
              [-124.44530188699991, 73.41925690300008],
              [-124.43431555899991, 73.42853424700007],
              [-124.40916907499991, 73.43768952000005],
              [-124.30650794199994, 73.46019114800004],
              [-124.2918188139999, 73.46800364800004],
              [-124.31493079299992, 73.47768789300005],
              [-124.27847245999993, 73.48436107000003],
              [-124.1812231109999, 73.48395416900007],
              [-124.15729732999989, 73.50495026200008],
              [-124.17096920499989, 73.50495026200008],
              [-124.15257727799991, 73.51935455900008],
              [-124.09007727799991, 73.52667877800008],
              [-124.0679418609999, 73.53969961100006],
              [-124.0684301419999, 73.54441966400003],
              [-124.07477779899995, 73.57046133000006],
              [-124.07022050699993, 73.57807038000004],
              [-124.0484106109999, 73.58698151200008],
              [-124.0405981109999, 73.59438711100006],
              [-124.05190995999993, 73.60081614800004],
              [-124.06558183499993, 73.61115143400008],
              [-124.07701575399994, 73.62323639500005],
              [-124.0816137359999, 73.63532135600008],
              [-124.07384192599994, 73.65277741100005],
              [-124.05614173099991, 73.66185130400004],
              [-124.01329505099994, 73.66885000200006],
              [-123.91710364499994, 73.69672272300005],
              [-123.86579342399995, 73.69717031500005],
              [-123.84142005099994, 73.70111725500004],
              [-123.82835852799991, 73.71723053600005],
              [-123.8484594389999, 73.72968170800004],
              [-123.82909094999991, 73.74404531500005],
              [-123.7737524079999, 73.76561107000003],
              [-123.79234778599994, 73.78095123900005],
              [-123.82249915299991, 73.81419505400004],
              [-123.84264075399994, 73.82709381700005],
              [-123.88280188699991, 73.83877187700006],
              [-124.1453344389999, 73.85106028900003],
              [-124.18521074099993, 73.86465078300006],
              [-124.21324622299994, 73.87921784100007],
              [-124.22508704299992, 73.89044830900008],
              [-124.22008216099994, 73.90346914300005],
              [-124.19762122299994, 73.92328522300005],
              [-124.20889238199993, 73.92597077000005],
              [-124.2395727199999, 73.94009023600006],
              [-124.24754798099991, 73.94599030200004],
              [-124.2610570949999, 73.96116771000004],
              [-124.2671606109999, 73.96430084800005],
              [-124.27940833199995, 73.96613190300008],
              [-124.30703691299993, 73.97504303600005],
              [-124.35496985599991, 73.98395416900007],
              [-124.35993404899995, 73.98826732000003],
              [-124.34227454299992, 73.99217357000003],
              [-124.35582434799994, 74.00787995000007],
              [-124.38927161399994, 74.03070709800005],
              [-124.38385982999989, 74.03937409100007],
              [-124.40355383999992, 74.05296458500004],
              [-124.44579016799992, 74.06484609600005],
              [-124.46580969999991, 74.07416413000004],
              [-124.45213782499991, 74.08030833500004],
              [-124.46288001199991, 74.09308502800008],
              [-124.47256425699993, 74.10830312700006],
              [-124.45230058499993, 74.10712311400005],
              [-124.43932044199994, 74.11058177300004],
              [-124.43464107999989, 74.11961497600004],
              [-124.43907630099994, 74.13556549700007],
              [-124.44945227799991, 74.14813873900005],
              [-124.46275794199994, 74.15444570500006],
              [-124.47679602799991, 74.15900299700007],
              [-124.48936926999994, 74.16632721600007],
              [-124.49681555899991, 74.17739492400005],
              [-124.4995824859999, 74.18842194200005],
              [-124.50328528599994, 74.19863515800006],
              [-124.51390540299991, 74.20722077000005],
              [-124.53140214799993, 74.21767812700006],
              [-124.52989661399994, 74.22264232000003],
              [-124.52212480399993, 74.22776927300004],
              [-124.5210668609999, 74.23859284100007],
              [-124.54564368399991, 74.26512278900003],
              [-124.58177649599992, 74.27081940300008],
              [-124.66441809799994, 74.26593659100007],
              [-124.69391842399995, 74.27570221600007],
              [-124.67247473899994, 74.28961823100008],
              [-124.60293535099993, 74.31370677300004],
              [-124.64810136599993, 74.32493724200003],
              [-124.75137285099993, 74.31631094000005],
              [-124.78726152299993, 74.33421458500004],
              [-124.75568600199989, 74.34857819200005],
              [-124.68321692599994, 74.35171133000006],
              [-124.41002356699994, 74.37327708500004],
              [-124.2312719389999, 74.38324616100005],
              [-124.12132727799991, 74.37636953300006],
              [-124.10265051999994, 74.38263580900008],
              [-124.10464433499993, 74.39862702000005],
              [-124.08682206899994, 74.40403880400004],
              [-123.73062089799993, 74.41201406500005],
              [-123.68350175699993, 74.42597077000005],
              [-123.47740637899994, 74.42645905200004],
              [-123.3035375639999, 74.44940827000005],
              [-122.98623613199993, 74.45237864800004],
              [-122.62319902299993, 74.46308014500005],
              [-122.39745032499991, 74.47833893400008],
              [-122.11681067599994, 74.49664948100008],
              [-121.7859594389999, 74.54319896000004],
              [-121.58079993399991, 74.55585358300004],
              [-121.42951412699995, 74.53025950700004],
              [-121.27733313699991, 74.53278229400007],
              [-121.25723222599993, 74.53025950700004],
              [-121.21084550699993, 74.51235586100006],
              [-121.1323949859999, 74.50995514500005],
              [-121.01158606699994, 74.47040436400005],
              [-120.98436438699991, 74.45087311400005],
              [-120.98151607999989, 74.44472890800006],
              [-120.97752844999991, 74.42357005400004],
              [-120.96886145699995, 74.42153554900005],
              [-120.93472245999993, 74.42357005400004],
              [-120.54564368399991, 74.35128408400004],
              [-120.1565649079999, 74.27899811400005],
              [-119.98086503799993, 74.27033112200007],
              [-119.94107011599993, 74.26316966400003],
              [-119.85952714799993, 74.23651764500005],
              [-119.56558183499993, 74.23895905200004],
              [-119.51829993399991, 74.23114655200004],
              [-119.55378170499989, 74.22418854400007],
              [-119.62889563699991, 74.23151276200008],
              [-119.66222083199995, 74.22500234600005],
              [-119.64745032499991, 74.19521719000005],
              [-119.68504798099991, 74.16571686400005],
              [-119.81798255099994, 74.10431549700007],
              [-119.82945716099994, 74.09137604400007],
              [-119.83360755099994, 74.07074616100005],
              [-119.82201087099992, 74.05540599200003],
              [-119.7952367829999, 74.04319896000004],
              [-119.76524817599994, 74.03534577000005],
              [-119.73672441299993, 74.03314850500004],
              [-119.73013261599993, 74.04645416900007],
              [-119.73827063699991, 74.05707428600005],
              [-119.75072180899991, 74.06671784100007],
              [-119.75723222599993, 74.07721588700008],
              [-119.74693762899994, 74.09731679900005],
              [-119.72248287699995, 74.11001211100006],
              [-119.62120520699995, 74.13434479400007],
              [-119.57921301999994, 74.15534088700008],
              [-119.54165605399993, 74.18256256700005],
              [-119.50743567599994, 74.21409739800004],
              [-119.47988847599993, 74.22614166900007],
              [-119.4434301419999, 74.22606028900003],
              [-119.37425696499992, 74.21747467700004],
              [-119.23721269399994, 74.22728099200003],
              [-119.14435787699995, 74.20905182500007],
              [-119.12462317599994, 74.20184967700004],
              [-119.10732988199993, 74.18402741100005],
              [-119.0979711579999, 74.16429271000004],
              [-119.10065670499989, 74.15204498900005],
              [-119.13467363199993, 74.12872955900008],
              [-119.0950414699999, 74.12506745000007],
              [-119.07677161399994, 74.11994049700007],
              [-119.06639563699991, 74.10830312700006],
              [-119.06924394399994, 74.09052155200004],
              [-119.08519446499992, 74.08104075700004],
              [-119.12100175699993, 74.07416413000004],
              [-119.13963782499991, 74.06769440300008],
              [-119.14915930899991, 74.05963776200008],
              [-119.16197669199994, 74.03314850500004],
              [-119.16917883999992, 74.02334219000005],
              [-119.17756100199995, 74.01447174700007],
              [-119.18496660099993, 74.00470612200007],
              [-119.18932044199994, 73.99217357000003],
              [-119.14781653599994, 73.99526601800005],
              [-119.06895911399994, 74.01862213700008],
              [-119.02481035099993, 74.01886627800008],
              [-118.99644934799994, 74.00910065300008],
              [-118.98257402299993, 74.00726959800005],
              [-118.96336829299992, 74.01211172100005],
              [-118.95189368399991, 74.01756419500003],
              [-118.92739824099993, 74.03400299700007],
              [-118.90855872299994, 74.05316803600005],
              [-118.87767493399991, 74.07721588700008],
              [-118.86107337099992, 74.08441803600005],
              [-118.82209225199995, 74.08991120000007],
              [-118.80508378799993, 74.10138580900008],
              [-118.79552161399994, 74.12759023600006],
              [-118.81590735599991, 74.13959381700005],
              [-118.84813391799992, 74.14793528900003],
              [-118.87393144399994, 74.16290924700007],
              [-118.88174394399994, 74.17304108300004],
              [-118.88316809799994, 74.17869700700004],
              [-118.87633216099994, 74.18329498900005],
              [-118.85973059799994, 74.19017161700003],
              [-118.83849036399994, 74.19554271000004],
              [-118.79238847599993, 74.20050690300008],
              [-118.7254125639999, 74.22077057500007],
              [-118.6253149079999, 74.22711823100008],
              [-118.55577551999994, 74.24192942900004],
              [-118.45677649599992, 74.24701569200005],
              [-118.40274003799993, 74.25682200700004],
              [-118.0659887359999, 74.28070709800005],
              [-117.7412410144999, 74.25659821150006],
              [-117.41649329299992, 74.23248932500007],
              [-117.14175370999993, 74.16002024950006],
              [-116.86701412699995, 74.08755117400005],
              [-116.62669837149994, 73.99443187050005],
              [-116.38638261599993, 73.90131256700005],
              [-116.36266028599994, 73.88544342700004],
              [-116.32896887899994, 73.86884186400005],
              [-116.2456762359999, 73.86107005400004],
              [-116.18219967399995, 73.82648346600007],
              [-115.97642981699994, 73.76569245000007],
              [-115.92300370999993, 73.73004791900007],
              [-115.7351781889999, 73.68309153900003],
              [-115.64635169199994, 73.67649974200003],
              [-115.61904863199993, 73.66885000200006],
              [-115.60985266799992, 73.66351959800005],
              [-115.58433997299994, 73.64150625200006],
              [-115.56895911399994, 73.63446686400005],
              [-115.5327856109999, 73.62543366100005],
              [-115.49437415299991, 73.60272858300004],
              [-115.39940344999991, 73.56704336100006],
              [-115.35631262899994, 73.54181549700007],
              [-115.3335668609999, 73.52411530200004],
              [-115.32363847599993, 73.50869375200006],
            ],
          ],
          [
            [
              [-123.28693600199995, 48.61269765800006],
              [-123.28311113199993, 48.61127350500004],
              [-123.28034420499989, 48.60130442900004],
              [-123.28795325399994, 48.59125397300005],
              [-123.30288652299993, 48.596991278000075],
              [-123.31265214799993, 48.60846588700008],
              [-123.32534745999993, 48.61933014500005],
              [-123.33665930899991, 48.63108958500004],
              [-123.33800208199995, 48.63422272300005],
              [-123.33267167899993, 48.62954336100006],
              [-123.33193925699993, 48.634426174000055],
              [-123.33861243399991, 48.646470445000034],
              [-123.3374731109999, 48.648423570000034],
              [-123.32681230399993, 48.64004140800006],
              [-123.31696529899995, 48.628973700000074],
              [-123.30528723899994, 48.618801174000055],
              [-123.29458574099993, 48.614569403000075],
              [-123.28693600199995, 48.61269765800006],
            ],
          ],
          [
            [
              [-123.36900794199994, 48.77423737200007],
              [-123.38231360599991, 48.75617096600007],
              [-123.40758216099994, 48.75405508000006],
              [-123.45840410099993, 48.76740143400008],
              [-123.4514867829999, 48.759466864000046],
              [-123.4285375639999, 48.738348700000074],
              [-123.42764238199993, 48.72955963700008],
              [-123.44041907499991, 48.72211334800005],
              [-123.4610082669999, 48.71539948100008],
              [-123.48208574099993, 48.712225653000075],
              [-123.49624589799993, 48.71556224200003],
              [-123.50885982999989, 48.72406647300005],
              [-123.52041581899994, 48.72866445500006],
              [-123.53111731699994, 48.734361070000034],
              [-123.54092363199993, 48.74632396000004],
              [-123.54637610599991, 48.75726959800005],
              [-123.54971269399994, 48.770738023000035],
              [-123.54678300699993, 48.78392161700003],
              [-123.5335180329999, 48.794134833000044],
              [-123.5335180329999, 48.80097077000005],
              [-123.55337480399993, 48.81468333500004],
              [-123.56981360599991, 48.83242422100005],
              [-123.57152258999992, 48.84975820500006],
              [-123.5471899079999, 48.86237213700008],
              [-123.57192949099993, 48.88149648600006],
              [-123.58665930899991, 48.89801666900007],
              [-123.59373938699991, 48.91909414300005],
              [-123.59557044199994, 48.95180898600006],
              [-123.59007727799991, 48.94741445500006],
              [-123.58649654899995, 48.942572333000044],
              [-123.58189856699994, 48.931301174000055],
              [-123.50308183499993, 48.89166901200008],
              [-123.43106035099993, 48.84194570500006],
              [-123.44517981699994, 48.84170156500005],
              [-123.45881100199995, 48.844916083000044],
              [-123.47134355399993, 48.85106028900009],
              [-123.48228919199994, 48.85932038000004],
              [-123.48863684799994, 48.86229075700004],
              [-123.49453691299993, 48.860988674000055],
              [-123.49876868399991, 48.85626862200007],
              [-123.49998938699991, 48.84935130400004],
              [-123.49600175699993, 48.84552643400008],
              [-123.47203528599994, 48.82827383000006],
              [-123.36900794199994, 48.77423737200007],
            ],
          ],
          [
            [
              [-123.65392005099994, 49.03367747600004],
              [-123.65884355399993, 49.04120514500005],
              [-123.69798743399991, 49.082098700000074],
              [-123.70274817599994, 49.09992096600007],
              [-123.69725501199991, 49.10932038000004],
              [-123.68700110599991, 49.10854726800005],
              [-123.65855872299994, 49.072699286000045],
              [-123.5703832669999, 48.99176666900007],
              [-123.54674231699994, 48.976223049000055],
              [-123.47191321499992, 48.93813711100006],
              [-123.45714270699995, 48.933254299000055],
              [-123.42878170499989, 48.929673570000034],
              [-123.3909399079999, 48.92015208500004],
              [-123.36595618399991, 48.907131252000056],
              [-123.33446204299992, 48.90298086100006],
              [-123.3218481109999, 48.896551825000074],
              [-123.31444251199991, 48.88231028900009],
              [-123.31712805899991, 48.86981842700004],
              [-123.32738196499992, 48.86395905200004],
              [-123.34235592399995, 48.86981842700004],
              [-123.36929277299993, 48.86188385600008],
              [-123.39452063699991, 48.872381903000075],
              [-123.43732662699995, 48.903998114000046],
              [-123.53075110599991, 48.94196198100008],
              [-123.63292395699995, 49.02435944200005],
              [-123.65392005099994, 49.03367747600004],
            ],
          ],
          [
            [
              [-123.72126217399995, 49.16079336100006],
              [-123.7044164699999, 49.15599192900004],
              [-123.69701087099992, 49.147691148000035],
              [-123.69709225199995, 49.13711172100005],
              [-123.70567786399994, 49.132879950000074],
              [-123.7117406889999, 49.13385651200008],
              [-123.71812903599994, 49.13320547100005],
              [-123.73232988199993, 49.13031647300005],
              [-123.74950110599991, 49.12885163000004],
              [-123.7766820949999, 49.13328685100004],
              [-123.84284420499989, 49.15102773600006],
              [-123.86196855399993, 49.16356028900009],
              [-123.86742102799991, 49.17438385600008],
              [-123.86607825399994, 49.17942942900004],
              [-123.86803137899994, 49.18333567900004],
              [-123.87047278599994, 49.18549225500004],
              [-123.86978105399993, 49.19049713700008],
              [-123.86343339799993, 49.19627513200004],
              [-123.83385169199994, 49.201157945000034],
              [-123.82396399599992, 49.19867584800005],
              [-123.81786048099991, 49.190619208000044],
              [-123.80931555899991, 49.18414948100008],
              [-123.76862545499989, 49.16901276200008],
              [-123.72126217399995, 49.16079336100006],
            ],
          ],
          [
            [
              [-125.94994055899991, 49.20075104400007],
              [-125.94497636599993, 49.19782135600008],
              [-125.93732662699989, 49.190741278000075],
              [-125.93814042899993, 49.184881903000075],
              [-125.94570878799993, 49.183579820000034],
              [-125.95409094999991, 49.181301174000055],
              [-125.9602758449999, 49.17210521000004],
              [-125.96198482999989, 49.15265534100007],
              [-125.96890214799993, 49.14874909100007],
              [-125.97935950399994, 49.149725653000075],
              [-126.01170813699991, 49.15912506700005],
              [-126.01634680899991, 49.169175523000035],
              [-126.01829993399991, 49.18146393400008],
              [-126.03018144399994, 49.190334377000056],
              [-126.03502356699994, 49.20180898600006],
              [-126.02432206899994, 49.21198151200008],
              [-126.00645911399994, 49.214056708000044],
              [-125.98501542899993, 49.211004950000074],
              [-125.96133378799993, 49.20490143400008],
              [-125.94994055899991, 49.20075104400007],
            ],
          ],
          [
            [
              [-126.0833227199999, 49.314886786000045],
              [-126.07632402299993, 49.303615627000056],
              [-126.07140051999994, 49.29047272300005],
              [-126.06371008999992, 49.27757396000004],
              [-126.04849199099993, 49.26703522300005],
              [-126.06940670499989, 49.255519924000055],
              [-126.08958899599992, 49.254339911000045],
              [-126.13573157499991, 49.26471588700008],
              [-126.15831458199995, 49.27358633000006],
              [-126.19253495999993, 49.27228424700007],
              [-126.22354081899994, 49.27708567900004],
              [-126.24034583199995, 49.30182526200008],
              [-126.22740637899994, 49.307806708000044],
              [-126.2298070949999, 49.32021719000005],
              [-126.23403886599993, 49.331732489000046],
              [-126.24034583199995, 49.34275950700004],
              [-126.23131262899994, 49.35732656500005],
              [-126.23289954299992, 49.366400458000044],
              [-126.23143469999991, 49.378607489000046],
              [-126.22671464799993, 49.382513739000046],
              [-126.20616614499994, 49.38373444200005],
              [-126.15021725199989, 49.39622630400004],
              [-126.13170325399994, 49.39679596600007],
              [-126.10802161399994, 49.384100653000075],
              [-126.0862524079999, 49.36310455900008],
              [-126.07510331899994, 49.33852773600006],
              [-126.0833227199999, 49.314886786000045],
            ],
          ],
          [
            [
              [-123.33067786399994, 49.37287018400008],
              [-123.33657792899993, 49.364569403000075],
              [-123.34410559799994, 49.35578034100007],
              [-123.35936438699991, 49.34292226800005],
              [-123.37588456899994, 49.337103583000044],
              [-123.38475501199991, 49.33551666900007],
              [-123.41600501199991, 49.337225653000075],
              [-123.42617753799993, 49.34007396000004],
              [-123.42943274599992, 49.34674713700008],
              [-123.42699133999992, 49.35541413000004],
              [-123.42577063699991, 49.36749909100007],
              [-123.41812089799993, 49.380926825000074],
              [-123.38467363199993, 49.40403880400004],
              [-123.36969967399995, 49.411363023000035],
              [-123.34996497299994, 49.41754791900007],
              [-123.32632402299993, 49.42047760600008],
              [-123.31517493399991, 49.413397528000075],
              [-123.31920325399994, 49.399318752000056],
              [-123.32542883999992, 49.38963450700004],
              [-123.3301488919999, 49.38418203300006],
              [-123.3301488919999, 49.38153717700004],
              [-123.32656816299993, 49.38149648600006],
              [-123.33067786399994, 49.37287018400008],
            ],
          ],
          [
            [
              [-124.23216712099992, 49.499335028000075],
              [-124.17174231699994, 49.46426015800006],
              [-124.17170162699989, 49.454738674000055],
              [-124.18618730399993, 49.44700755400004],
              [-124.23241126199991, 49.45856354400007],
              [-124.24815833199995, 49.45844147300005],
              [-124.2578832669999, 49.45612213700008],
              [-124.26846269399994, 49.455511786000045],
              [-124.29702714799993, 49.457912502000056],
              [-124.3179418609999, 49.462958075000074],
              [-124.35228430899991, 49.47492096600007],
              [-124.36107337099992, 49.48004791900007],
              [-124.3577367829999, 49.48354726800005],
              [-124.35570227799991, 49.49038320500006],
              [-124.36522376199991, 49.497259833000044],
              [-124.3765356109999, 49.49994538000004],
              [-124.37905839799993, 49.50726959800005],
              [-124.37364661399994, 49.515285549000055],
              [-124.36489824099993, 49.52106354400007],
              [-124.35460364499994, 49.52240631700005],
              [-124.32917232999989, 49.51284414300005],
              [-124.32310950399994, 49.51203034100007],
              [-124.29588782499991, 49.51243724200003],
              [-124.28359941299993, 49.51048411700003],
              [-124.26895097599993, 49.506293036000045],
              [-124.25133216099994, 49.50429922100005],
              [-124.23216712099992, 49.499335028000075],
            ],
          ],
          [
            [
              [-123.45156816299993, 49.44521719000005],
              [-123.44912675699993, 49.458685614000046],
              [-123.45445716099994, 49.46930573100008],
              [-123.45665442599994, 49.478216864000046],
              [-123.44473222599993, 49.48615143400008],
              [-123.44473222599993, 49.49359772300005],
              [-123.45262610599991, 49.50812409100007],
              [-123.43968665299991, 49.52130768400008],
              [-123.41812089799993, 49.530910549000055],
              [-123.39167232999989, 49.536322333000044],
              [-123.3823949859999, 49.53974030200004],
              [-123.37254798099991, 49.54205963700008],
              [-123.36217200399994, 49.54075755400004],
              [-123.3567602199999, 49.53489817900004],
              [-123.34235592399995, 49.50665924700007],
              [-123.32249915299991, 49.48607005400004],
              [-123.3238012359999, 49.46185944200005],
              [-123.34268144399994, 49.44293854400007],
              [-123.37584387899994, 49.438381252000056],
              [-123.36742102799991, 49.45384349200003],
              [-123.37462317599994, 49.46352773600006],
              [-123.38939368399991, 49.46743398600006],
              [-123.40379798099991, 49.465725002000056],
              [-123.41519120999993, 49.458685614000046],
              [-123.42320716099994, 49.451239325000074],
              [-123.43342037699995, 49.44599030200004],
              [-123.45156816299993, 49.44521719000005],
            ],
          ],
          [
            [
              [-124.60741126199991, 49.530910549000055],
              [-124.6004125639999, 49.52757396000004],
              [-124.59414628799993, 49.52163320500006],
              [-124.60484778599994, 49.52094147300005],
              [-124.62450110599991, 49.523423570000034],
              [-124.63560950399994, 49.51740143400008],
              [-124.64273027299993, 49.50429922100005],
              [-124.65322831899994, 49.49599844000005],
              [-124.6629125639999, 49.49433014500005],
              [-124.67178300699993, 49.49721914300005],
              [-124.69127356699994, 49.50934479400007],
              [-124.70376542899993, 49.521185614000046],
              [-124.70250403599994, 49.53766510600008],
              [-124.68374589799993, 49.549261786000045],
              [-124.65514075399994, 49.54710521000004],
              [-124.60741126199991, 49.530910549000055],
            ],
          ],
          [
            [
              [-124.70872962099992, 49.49701569200005],
              [-124.6941625639999, 49.49062734600005],
              [-124.69082597599993, 49.482855536000045],
              [-124.70201575399994, 49.47947825700004],
              [-124.70962480399993, 49.47996653900009],
              [-124.7222387359999, 49.48187897300005],
              [-124.7464086579999, 49.48847077000005],
              [-124.82542883999992, 49.54010651200008],
              [-124.83853105399993, 49.55658600500004],
              [-124.8401586579999, 49.57758209800005],
              [-124.83604895699995, 49.597723700000074],
              [-124.82721920499989, 49.60297272300005],
              [-124.80333411399994, 49.58494700700004],
              [-124.79246985599991, 49.579738674000055],
              [-124.71646074099993, 49.49949778900009],
              [-124.70872962099992, 49.49701569200005],
            ],
          ],
          [
            [
              [-124.10948645699995, 49.67796458500004],
              [-124.13638261599993, 49.65656159100007],
              [-124.16368567599994, 49.659816799000055],
              [-124.18773352799991, 49.678941148000035],
              [-124.20506751199991, 49.70526764500005],
              [-124.14561926999994, 49.74754466400009],
              [-124.13316809799994, 49.75385163000004],
              [-124.11913001199991, 49.75482819200005],
              [-124.10265051999994, 49.74689362200007],
              [-124.10122636599993, 49.76044342700004],
              [-124.09813391799992, 49.76699453300006],
              [-124.09024003799993, 49.77033112200007],
              [-124.04747473899994, 49.77924225500004],
              [-124.02013098899994, 49.78099192900004],
              [-124.01964270699995, 49.776271877000056],
              [-124.02122962099992, 49.775091864000046],
              [-124.02399654899995, 49.77529531500005],
              [-124.02696692599994, 49.77415599200003],
              [-124.0745336579999, 49.74135976800005],
              [-124.0816137359999, 49.72943756700005],
              [-124.08576412699995, 49.72406647300005],
              [-124.10948645699995, 49.67796458500004],
            ],
          ],
          [
            [
              [-124.66441809799994, 49.74689362200007],
              [-124.65640214799993, 49.75421784100007],
              [-124.65172278599994, 49.76154205900008],
              [-124.6516820949999, 49.76825592700004],
              [-124.65758216099994, 49.77415599200003],
              [-124.65758216099994, 49.78099192900004],
              [-124.65428626199991, 49.787990627000056],
              [-124.65469316299993, 49.792303778000075],
              [-124.65758216099994, 49.80149974200003],
              [-124.64513098899994, 49.80231354400007],
              [-124.63263912699989, 49.801662502000056],
              [-124.62051347599993, 49.79930247600004],
              [-124.60920162699989, 49.794623114000046],
              [-124.59703528599994, 49.78563060100004],
              [-124.57603919199994, 49.76194896000004],
              [-124.56200110599991, 49.75372955900008],
              [-124.5210668609999, 49.74689362200007],
              [-124.48778235599991, 49.73419830900008],
              [-124.39126542899993, 49.720038153000075],
              [-124.34788977799991, 49.70416901200008],
              [-124.32921301999994, 49.681708075000074],
              [-124.32274329299992, 49.670803127000056],
              [-124.29409745999993, 49.64988841400009],
              [-124.28766842399995, 49.64044830900008],
              [-124.28246008999992, 49.627834377000056],
              [-124.26976477799991, 49.61587148600006],
              [-124.17320716099994, 49.55414459800005],
              [-124.14403235599991, 49.52960846600007],
              [-124.12315833199995, 49.49982330900008],
              [-124.14342200399994, 49.48932526200008],
              [-124.16226152299993, 49.49599844000005],
              [-124.19762122299994, 49.52094147300005],
              [-124.37840735599991, 49.602850653000075],
              [-124.43883216099994, 49.61188385600008],
              [-124.4417211579999, 49.617254950000074],
              [-124.43871008999992, 49.62409088700008],
              [-124.43907630099994, 49.63080475500004],
              [-124.46206620999993, 49.65375397300005],
              [-124.47175045499989, 49.66950104400007],
              [-124.47256425699993, 49.67177969000005],
              [-124.47874915299991, 49.673163153000075],
              [-124.48525956899994, 49.67291901200008],
              [-124.49307206899994, 49.67177969000005],
              [-124.51707923099991, 49.68341705900008],
              [-124.51732337099992, 49.68545156500005],
              [-124.53404700399994, 49.68964264500005],
              [-124.57213294199994, 49.70844147300005],
              [-124.61440995999993, 49.716498114000046],
              [-124.63320878799993, 49.72573476800005],
              [-124.66441809799994, 49.74689362200007],
            ],
          ],
          [
            [
              [-126.65868079299992, 49.78782786700003],
              [-126.64907792899993, 49.77317942900004],
              [-126.64256751199991, 49.75873444200005],
              [-126.63878333199995, 49.74079010600008],
              [-126.63394120999993, 49.69232819200005],
              [-126.6192113919999, 49.652777411000045],
              [-126.61766516799992, 49.63080475500004],
              [-126.63882402299993, 49.595038153000075],
              [-126.67943274599992, 49.591782945000034],
              [-126.80675208199995, 49.627386786000045],
              [-126.82213294199994, 49.63629791900007],
              [-126.84019934799994, 49.65375397300005],
              [-126.85610917899993, 49.665676174000055],
              [-126.91250566299993, 49.69163646000004],
              [-126.97398841099994, 49.735988674000055],
              [-126.97057044199994, 49.75470612200007],
              [-126.96153723899994, 49.75853099200003],
              [-126.94847571499992, 49.752020575000074],
              [-126.93301347599993, 49.73940664300005],
              [-126.92735755099994, 49.749986070000034],
              [-126.91934160099993, 49.75893789300005],
              [-126.90876217399995, 49.76508209800005],
              [-126.88023841099994, 49.76898834800005],
              [-126.8640844389999, 49.77334219000005],
              [-126.85570227799991, 49.77985260600008],
              [-126.86412512899994, 49.78782786700003],
              [-126.8738500639999, 49.78888580900008],
              [-126.88345292899993, 49.78607819200005],
              [-126.89195716099994, 49.782416083000044],
              [-126.89826412699989, 49.78099192900004],
              [-126.90575110599991, 49.78375885600008],
              [-126.91885331899994, 49.79271067900004],
              [-126.92247473899994, 49.794623114000046],
              [-126.9300024079999, 49.79682038000004],
              [-126.94395911399994, 49.80621979400007],
              [-126.95348059799994, 49.808294989000046],
              [-126.96226966099994, 49.80898672100005],
              [-126.98704993399991, 49.81513092700004],
              [-126.9780981109999, 49.828558661000045],
              [-126.96959387899994, 49.83348216400009],
              [-126.94664466099994, 49.83624909100007],
              [-126.86416581899994, 49.855454820000034],
              [-126.80093339799993, 49.88076406500005],
              [-126.76854407499991, 49.88344961100006],
              [-126.75816809799994, 49.87067291900007],
              [-126.74217688699991, 49.85639069200005],
              [-126.72288977799991, 49.84979889500005],
              [-126.70274817599994, 49.86017487200007],
              [-126.69050045499989, 49.857123114000046],
              [-126.67756100199989, 49.833685614000046],
              [-126.65868079299992, 49.78782786700003],
            ],
          ],
          [
            [
              [-127.24063066299993, 50.02171458500004],
              [-127.23228919199994, 50.01325104400007],
              [-127.23184160099993, 50.01015859600005],
              [-127.23420162699989, 50.00535716400009],
              [-127.24193274599992, 50.003119208000044],
              [-127.25104732999989, 49.99957916900007],
              [-127.27232825399994, 49.97797272300005],
              [-127.28502356699994, 49.978583075000074],
              [-127.29596920499989, 49.98737213700008],
              [-127.30801347599993, 49.991848049000055],
              [-127.31859290299991, 49.99957916900007],
              [-127.31920325399994, 50.00812409100007],
              [-127.31456458199995, 50.01325104400007],
              [-127.31346594999991, 50.019964911000045],
              [-127.3113500639999, 50.02619049700007],
              [-127.3015844389999, 50.03229401200008],
              [-127.28600012899994, 50.03705475500004],
              [-127.26349850199989, 50.03432851800005],
              [-127.24063066299993, 50.02171458500004],
            ],
          ],
          [
            [
              [-125.02749589799993, 50.14411041900007],
              [-124.98582923099991, 50.178941148000035],
              [-124.97972571499992, 50.188788153000075],
              [-124.98330644399994, 50.19989655200004],
              [-125.00064042899993, 50.22215403900009],
              [-125.00698808499993, 50.232855536000045],
              [-125.00047766799992, 50.23346588700008],
              [-124.9956762359999, 50.232082424000055],
              [-124.98648027299993, 50.22601959800005],
              [-124.92910722599993, 50.16937897300005],
              [-124.9182836579999, 50.15094635600008],
              [-124.91746985599991, 50.14549388200004],
              [-124.91759192599994, 50.138739325000074],
              [-124.91881262899994, 50.13296133000006],
              [-124.92170162699989, 50.13043854400007],
              [-124.92568925699993, 50.12767161700003],
              [-124.92129472599993, 50.12173086100006],
              [-124.91441809799994, 50.11595286700003],
              [-124.91079667899993, 50.113714911000045],
              [-124.90965735599991, 50.09861888200004],
              [-124.90611731699994, 50.08779531500005],
              [-124.8999731109999, 50.07880280200004],
              [-124.89098059799994, 50.06903717700004],
              [-124.91958574099993, 50.05963776200008],
              [-124.94863847599993, 50.054754950000074],
              [-124.96304277299993, 50.04877350500004],
              [-124.97630774599992, 50.02167389500005],
              [-124.98648027299993, 50.01439036700003],
              [-125.00548255099994, 50.017645575000074],
              [-125.01073157499991, 50.02960846600007],
              [-125.0091039699999, 50.04328034100007],
              [-125.00698808499993, 50.051662502000056],
              [-125.00649980399993, 50.063706773000035],
              [-125.00743567599994, 50.072251695000034],
              [-125.01329505099994, 50.08002350500004],
              [-125.05288652299993, 50.105169989000046],
              [-125.05980383999992, 50.11546458500004],
              [-125.05060787699989, 50.12641022300005],
              [-125.02749589799993, 50.14411041900007],
            ],
          ],
          [
            [
              [-125.19884192599994, 50.041083075000074],
              [-125.21971594999991, 50.059800523000035],
              [-125.22671464799993, 50.06903717700004],
              [-125.22264563699991, 50.070298570000034],
              [-125.2124731109999, 50.07518138200004],
              [-125.23029537699989, 50.08966705900008],
              [-125.2832738919999, 50.11676666900007],
              [-125.29434160099993, 50.127020575000074],
              [-125.29987545499989, 50.13104889500005],
              [-125.31175696499992, 50.13589101800005],
              [-125.32371985599991, 50.14325592700004],
              [-125.32917232999989, 50.15468984600005],
              [-125.32974199099993, 50.16551341400009],
              [-125.33482825399994, 50.19375234600005],
              [-125.3489477199999, 50.220038153000075],
              [-125.34943600199989, 50.24168528900009],
              [-125.3440649079999, 50.26166413000004],
              [-125.3360082669999, 50.27448151200008],
              [-125.31802324099993, 50.28351471600007],
              [-125.29027258999992, 50.29132721600007],
              [-125.26317298099991, 50.29401276200008],
              [-125.24722245999993, 50.28750234600005],
              [-125.23534094999991, 50.26536692900004],
              [-125.23013261599993, 50.26080963700008],
              [-125.21544348899994, 50.25649648600006],
              [-125.1985570949999, 50.23725006700005],
              [-125.1797582669999, 50.228949286000045],
              [-125.1714574859999, 50.21898021000004],
              [-125.16567949099993, 50.205959377000056],
              [-125.16466223899994, 50.19253164300005],
              [-125.17235266799992, 50.17837148600006],
              [-125.18415279899995, 50.16828034100007],
              [-125.19127356699994, 50.158189195000034],
              [-125.18517005099994, 50.14411041900007],
              [-125.20958411399994, 50.13857656500005],
              [-125.22520911399994, 50.13165924700007],
              [-125.22765051999994, 50.120794989000046],
              [-125.2124731109999, 50.103176174000055],
              [-125.20262610599991, 50.09723541900007],
              [-125.19399980399993, 50.094916083000044],
              [-125.18614661399994, 50.09153880400004],
              [-125.17833411399994, 50.08270905200004],
              [-125.1753637359999, 50.07371653900009],
              [-125.17149817599994, 50.041083075000074],
              [-125.16055253799993, 50.00307851800005],
              [-125.16307532499991, 49.99315013200004],
              [-125.17833411399994, 50.000067450000074],
              [-125.18687903599994, 50.009833075000074],
              [-125.19371497299994, 50.030910549000055],
              [-125.19884192599994, 50.041083075000074],
            ],
          ],
          [
            [
              [-124.89098059799994, 50.19253164300005],
              [-124.91274980399993, 50.19432200700004],
              [-124.92593339799993, 50.19985586100006],
              [-124.9578344389999, 50.23432038000004],
              [-124.9651586579999, 50.249212958000044],
              [-124.96426347599993, 50.26211172100005],
              [-124.94863847599993, 50.267645575000074],
              [-124.9368383449999, 50.27619049700007],
              [-124.92833411399994, 50.292669989000046],
              [-124.91706295499989, 50.30345286700003],
              [-124.88267981699994, 50.28961823100008],
              [-124.83568274599992, 50.281236070000034],
              [-124.8157445949999, 50.27383047100005],
              [-124.81191972599993, 50.26947663000004],
              [-124.81655839799993, 50.26239655200004],
              [-124.82201087099992, 50.246527411000045],
              [-124.81566321499992, 50.21157461100006],
              [-124.79173743399991, 50.19798411700003],
              [-124.76585852799991, 50.189154364000046],
              [-124.75377356699994, 50.16828034100007],
              [-124.76353919199994, 50.156236070000034],
              [-124.78624426999994, 50.13922760600008],
              [-124.81236731699994, 50.12400950700004],
              [-124.8323461579999, 50.11737702000005],
              [-124.84251868399991, 50.12221914300005],
              [-124.85228430899991, 50.13328685100004],
              [-124.8667699859999, 50.15468984600005],
              [-124.86937415299991, 50.16632721600007],
              [-124.85826575399994, 50.173488674000055],
              [-124.84190833199995, 50.17877838700008],
              [-124.8289281889999, 50.18504466400009],
              [-124.84044348899994, 50.19830963700008],
              [-124.85610917899993, 50.19953034100007],
              [-124.89098059799994, 50.19253164300005],
            ],
          ],
          [
            [
              [-124.80264238199993, 50.228583075000074],
              [-124.80825761599993, 50.23187897300005],
              [-124.81224524599992, 50.23981354400007],
              [-124.79466712099992, 50.26211172100005],
              [-124.78648841099994, 50.27728913000004],
              [-124.77342688699991, 50.289496161000045],
              [-124.75894120999993, 50.296535549000055],
              [-124.74852454299992, 50.303941148000035],
              [-124.72508704299992, 50.30451080900008],
              [-124.68980872299994, 50.290676174000055],
              [-124.6614477199999, 50.26284414300005],
              [-124.65074622299994, 50.22443268400008],
              [-124.66454016799992, 50.19122955900008],
              [-124.69383704299992, 50.17104726800005],
              [-124.71556555899991, 50.162176825000074],
              [-124.72581946499992, 50.16323476800005],
              [-124.73070227799991, 50.167954820000034],
              [-124.73058020699995, 50.17450592700004],
              [-124.73643958199995, 50.18646881700005],
              [-124.74282792899993, 50.20416901200008],
              [-124.73916581899994, 50.219916083000044],
              [-124.7268774079999, 50.24315013200004],
              [-124.70860755099994, 50.26044342700004],
              [-124.7053930329999, 50.27411530200004],
              [-124.71255449099993, 50.28571198100008],
              [-124.72329667899993, 50.29287344000005],
              [-124.72716223899994, 50.29116445500006],
              [-124.72500566299993, 50.28148021000004],
              [-124.72516842399995, 50.27326080900008],
              [-124.72679602799991, 50.26630280200004],
              [-124.73326575399994, 50.25372955900008],
              [-124.7566625639999, 50.21938711100006],
              [-124.76797441299993, 50.21426015800006],
              [-124.78246008999992, 50.219183661000045],
              [-124.80264238199993, 50.228583075000074],
            ],
          ],
          [
            [
              [-125.3360082669999, 50.30174388200004],
              [-125.36021887899994, 50.294989325000074],
              [-125.38219153599994, 50.29629140800006],
              [-125.39806067599994, 50.307847398000035],
              [-125.40420488199993, 50.33218008000006],
              [-125.39435787699989, 50.34951406500005],
              [-125.37165279899995, 50.35101959800005],
              [-125.32917232999989, 50.34271881700005],
              [-125.31371008999992, 50.349676825000074],
              [-125.31114661399994, 50.363267320000034],
              [-125.31407630099994, 50.38027578300006],
              [-125.31484941299993, 50.397365627000056],
              [-125.3101293609999, 50.41128164300005],
              [-125.30044511599993, 50.42747630400004],
              [-125.28795325399994, 50.43740469000005],
              [-125.23448645699995, 50.41437409100007],
              [-125.22301184799994, 50.41156647300005],
              [-125.21617591099994, 50.409084377000056],
              [-125.20490475199989, 50.39622630400004],
              [-125.19884192599994, 50.39109935100004],
              [-125.19253495999993, 50.390326239000046],
              [-125.17735755099994, 50.39252350500004],
              [-125.17149817599994, 50.39109935100004],
              [-125.1673070949999, 50.38471100500004],
              [-125.15929114499994, 50.36163971600007],
              [-125.15782630099994, 50.35325755400004],
              [-125.15249589799993, 50.34454987200007],
              [-125.12901770699995, 50.321193752000056],
              [-125.11506100199989, 50.29718659100007],
              [-125.07713782499991, 50.26219310100004],
              [-125.06847083199995, 50.25023021000004],
              [-125.06456458199995, 50.24192942900004],
              [-125.05630449099993, 50.23139069200005],
              [-125.04898027299993, 50.21914297100005],
              [-125.04796301999994, 50.20555247600004],
              [-125.05524654899995, 50.194525458000044],
              [-125.06533769399994, 50.19358958500004],
              [-125.07555091099994, 50.19867584800005],
              [-125.08275305899991, 50.20555247600004],
              [-125.09618079299992, 50.164048570000034],
              [-125.10606848899994, 50.14520905200004],
              [-125.12791907499991, 50.13385651200008],
              [-125.13426673099991, 50.12791575700004],
              [-125.14220130099994, 50.12579987200007],
              [-125.15440833199995, 50.13385651200008],
              [-125.15282141799992, 50.14020416900007],
              [-125.13735917899993, 50.17206452000005],
              [-125.13206946499992, 50.19098541900007],
              [-125.13011633999992, 50.21352773600006],
              [-125.13609778599994, 50.23236725500004],
              [-125.16698157499991, 50.247259833000044],
              [-125.1800024079999, 50.26349518400008],
              [-125.21149654899995, 50.31810130400004],
              [-125.2124731109999, 50.322251695000034],
              [-125.22374426999994, 50.322333075000074],
              [-125.23477128799993, 50.317572333000044],
              [-125.24583899599992, 50.31435781500005],
              [-125.2571508449999, 50.31883372600004],
              [-125.2683813139999, 50.326239325000074],
              [-125.27700761599993, 50.32664622600004],
              [-125.28604081899994, 50.32404205900008],
              [-125.31261145699995, 50.31981028900009],
              [-125.32119706899994, 50.314154364000046],
              [-125.32774817599994, 50.30735911700003],
              [-125.3360082669999, 50.30174388200004],
            ],
          ],
          [
            [
              [-125.5022680329999, 50.41380442900004],
              [-125.5032445949999, 50.40493398600006],
              [-125.59203040299991, 50.388006903000075],
              [-125.60899817599994, 50.39093659100007],
              [-125.6206762359999, 50.388739325000074],
              [-125.63581295499989, 50.382513739000046],
              [-125.7434789699999, 50.37734609600005],
              [-125.76622473899994, 50.37970612200007],
              [-125.77025305899991, 50.380926825000074],
              [-125.7808324859999, 50.38572825700004],
              [-125.78184973899994, 50.38934967700004],
              [-125.78213456899994, 50.39325592700004],
              [-125.78335527299993, 50.39740631700005],
              [-125.77916419199994, 50.40143463700008],
              [-125.7717992829999, 50.40403880400004],
              [-125.73493404899995, 50.41071198100008],
              [-125.68765214799993, 50.41034577000005],
              [-125.65640214799993, 50.41787344000005],
              [-125.63597571499992, 50.425482489000046],
              [-125.61558997299994, 50.43040599200003],
              [-125.60806230399993, 50.43431224200003],
              [-125.59300696499992, 50.43789297100005],
              [-125.54686438699991, 50.443426825000074],
              [-125.52342688699991, 50.44171784100007],
              [-125.5066625639999, 50.43081289300005],
              [-125.5022680329999, 50.41380442900004],
            ],
          ],
          [
            [
              [-125.3679906889999, 50.46112702000005],
              [-125.33958899599992, 50.45254140800006],
              [-125.32787024599992, 50.43374258000006],
              [-125.33800208199995, 50.41205475500004],
              [-125.34634355399993, 50.40228913000004],
              [-125.35496985599991, 50.398098049000055],
              [-125.38206946499992, 50.39350006700005],
              [-125.37852942599994, 50.38914622600004],
              [-125.3765356109999, 50.38255442900004],
              [-125.37857011599993, 50.37555573100008],
              [-125.39240475199989, 50.36741771000004],
              [-125.41567949099993, 50.35960521000004],
              [-125.44774329299992, 50.35370514500005],
              [-125.48656165299991, 50.35765208500004],
              [-125.51406816299993, 50.36823151200008],
              [-125.5320531889999, 50.37287018400008],
              [-125.54478919199994, 50.377834377000056],
              [-125.53978430899991, 50.384426174000055],
              [-125.51939856699994, 50.39081452000005],
              [-125.49950110599991, 50.40106842700004],
              [-125.49010169199994, 50.413275458000044],
              [-125.4910375639999, 50.421942450000074],
              [-125.47801673099991, 50.42951080900008],
              [-125.40859941299993, 50.44773997600004],
              [-125.39769446499992, 50.45197174700007],
              [-125.38853919199994, 50.459051825000074],
              [-125.3679906889999, 50.46112702000005],
            ],
          ],
          [
            [
              [-125.74913489499994, 50.42182038000004],
              [-125.75674394399994, 50.41982656500005],
              [-125.78506425699993, 50.41193268400008],
              [-125.8042699859999, 50.40859609600005],
              [-125.82363847599993, 50.40884023600006],
              [-125.87173417899993, 50.41620514500005],
              [-125.90664628799993, 50.41705963700008],
              [-125.94863847599993, 50.424994208000044],
              [-125.96544348899994, 50.43821849200003],
              [-125.9539281889999, 50.44326406500005],
              [-125.93907630099994, 50.444566148000035],
              [-125.88857988199993, 50.46124909100007],
              [-125.8509008449999, 50.46942780200004],
              [-125.80581620999993, 50.475043036000045],
              [-125.79369055899991, 50.472357489000046],
              [-125.77000891799992, 50.45917389500005],
              [-125.76610266799992, 50.45392487200007],
              [-125.76390540299991, 50.44867584800005],
              [-125.75601152299993, 50.44318268400008],
              [-125.74323482999989, 50.43667226800005],
              [-125.73916581899994, 50.428615627000056],
              [-125.74913489499994, 50.42182038000004],
            ],
          ],
          [
            [
              [-126.53770911399994, 50.58380768400008],
              [-126.52440344999991, 50.579413153000075],
              [-126.51844242499993, 50.57569410600007],
              [-126.51895751799992, 50.57001569100004],
              [-126.53017841199994, 50.56520673700004],
              [-126.54300229099994, 50.56268776100006],
              [-126.58101593099991, 50.556504819000054],
              [-126.61489824099993, 50.55267975500004],
              [-126.65029863199993, 50.55874258000006],
              [-126.65794837099992, 50.56391022300005],
              [-126.64834550699993, 50.56989166900007],
              [-126.65367591099994, 50.57859935100004],
              [-126.6680395169999, 50.58478424700007],
              [-126.67088782499991, 50.58958567900004],
              [-126.66124426999994, 50.59096914300005],
              [-126.6270238919999, 50.589829820000034],
              [-126.61042232999989, 50.59129466400009],
              [-126.5969945949999, 50.59430573100008],
              [-126.58690344999991, 50.59487539300005],
              [-126.58177649599992, 50.591131903000075],
              [-126.57591712099992, 50.58860911700003],
              [-126.53770911399994, 50.58380768400008],
            ],
          ],
          [
            [
              [-126.33653723899994, 50.60346100500004],
              [-126.32485917899993, 50.604803778000075],
              [-126.28807532499991, 50.60346100500004],
              [-126.26146399599992, 50.58087799700007],
              [-126.24486243399991, 50.571519273000035],
              [-126.22667395699995, 50.56928131700005],
              [-126.23485266799992, 50.557074286000045],
              [-126.24461829299992, 50.55414459800005],
              [-126.25584876199991, 50.55524323100008],
              [-126.26821855399993, 50.55499909100007],
              [-126.27989661399994, 50.550482489000046],
              [-126.30003821499992, 50.53729889500005],
              [-126.3054906889999, 50.53457265800006],
              [-126.41270911399994, 50.527411200000074],
              [-126.41905676999994, 50.52399323100008],
              [-126.44815019399994, 50.519232489000046],
              [-126.62450110599991, 50.53457265800006],
              [-126.58413652299993, 50.548081773000035],
              [-126.36758378799993, 50.58295319200005],
              [-126.36221269399994, 50.585638739000046],
              [-126.34675045499989, 50.598822333000044],
              [-126.33653723899994, 50.60346100500004],
            ],
          ],
          [
            [
              [-126.40379798099991, 50.62982819200005],
              [-126.38459225199989, 50.628607489000046],
              [-126.36351477799991, 50.618841864000046],
              [-126.37441972599993, 50.60496653900009],
              [-126.42564856699994, 50.58856842700004],
              [-126.4375707669999, 50.58771393400008],
              [-126.45262610599991, 50.58812083500004],
              [-126.48542232999989, 50.578558661000045],
              [-126.50011145699995, 50.57892487200007],
              [-126.51085364499994, 50.58185455900008],
              [-126.51317298099991, 50.58445872600004],
              [-126.50658118399991, 50.58576080900008],
              [-126.51146399599992, 50.587958075000074],
              [-126.52953040299991, 50.592230536000045],
              [-126.53795325399994, 50.59593333500004],
              [-126.53624426999994, 50.59845612200007],
              [-126.5457250639999, 50.59829336100006],
              [-126.55850175699993, 50.603176174000055],
              [-126.54759680899991, 50.613714911000045],
              [-126.47126217399995, 50.628241278000075],
              [-126.40379798099991, 50.62982819200005],
            ],
          ],
          [
            [
              [-126.85928300699993, 50.645738023000035],
              [-126.83971106699994, 50.63373444200005],
              [-126.83307857999989, 50.62523021000004],
              [-126.83804277299993, 50.62189362200007],
              [-126.84675045499989, 50.624986070000034],
              [-126.85374915299991, 50.62885163000004],
              [-126.86245683499993, 50.628607489000046],
              [-126.8723852199999, 50.62482330900008],
              [-126.89712480399993, 50.62099844000005],
              [-127.0032445949999, 50.62645091400009],
              [-127.03746497299994, 50.64008209800005],
              [-127.0696508449999, 50.63373444200005],
              [-127.12214107999989, 50.62995026200008],
              [-127.15038001199991, 50.639960028000075],
              [-127.14146887899994, 50.65477122600004],
              [-127.12352454299992, 50.66632721600007],
              [-127.1074926419999, 50.671087958000044],
              [-127.07331295499989, 50.66889069200005],
              [-127.03709876199991, 50.66250234600005],
              [-126.93464107999989, 50.66030508000006],
              [-126.89476477799991, 50.66592031500005],
              [-126.88133704299992, 50.65973541900007],
              [-126.85928300699993, 50.645738023000035],
            ],
          ],
          [
            [
              [-126.61766516799992, 50.672308661000045],
              [-126.60179602799991, 50.67450592700004],
              [-126.59019934799994, 50.679348049000055],
              [-126.58482825399994, 50.68781159100007],
              [-126.58771725199989, 50.70107656500005],
              [-126.54995683499993, 50.73289622600004],
              [-126.52700761599993, 50.74371979400007],
              [-126.50780188699991, 50.739935614000046],
              [-126.47887122299994, 50.75690338700008],
              [-126.42829342399995, 50.79450104400007],
              [-126.39793860599991, 50.808254299000055],
              [-126.37954667899993, 50.81150950700004],
              [-126.3411352199999, 50.81281159100007],
              [-126.32347571499992, 50.815741278000075],
              [-126.28945878799993, 50.828558661000045],
              [-126.2722875639999, 50.83002350500004],
              [-126.2442113919999, 50.81631094000005],
              [-126.23277747299994, 50.80646393400008],
              [-126.22362219999991, 50.79507070500006],
              [-126.21983801999994, 50.78465403900009],
              [-126.21344967399995, 50.771551825000074],
              [-126.18529212099992, 50.75971100500004],
              [-126.17886308499993, 50.75079987200007],
              [-126.18590247299994, 50.74160390800006],
              [-126.23289954299992, 50.72695547100005],
              [-126.24469967399995, 50.71743398600006],
              [-126.26821855399993, 50.68528880400004],
              [-126.26439368399991, 50.66461823100008],
              [-126.28807532499991, 50.65460846600007],
              [-126.35020911399994, 50.65184153900009],
              [-126.43464107999989, 50.669134833000044],
              [-126.46007239499994, 50.66486237200007],
              [-126.44933020699995, 50.65696849200003],
              [-126.44896399599992, 50.650458075000074],
              [-126.45677649599992, 50.64598216400009],
              [-126.4702856109999, 50.64443594000005],
              [-126.48485266799992, 50.646185614000046],
              [-126.5086156889999, 50.65497467700004],
              [-126.52147376199991, 50.65802643400008],
              [-126.57599850199989, 50.65228913000004],
              [-126.60342363199993, 50.65485260600008],
              [-126.61766516799992, 50.672308661000045],
            ],
          ],
          [
            [
              [-126.78213456899994, 50.774725653000075],
              [-126.79613196499992, 50.77496979400007],
              [-126.85484778599994, 50.786037502000056],
              [-126.88609778599994, 50.81159088700008],
              [-126.9051000639999, 50.821926174000055],
              [-126.9051000639999, 50.829331773000035],
              [-126.89199785099993, 50.829331773000035],
              [-126.87946529899995, 50.83429596600007],
              [-126.86266028599994, 50.83612702000005],
              [-126.82628333199995, 50.83616771000004],
              [-126.81554114499994, 50.82831452000005],
              [-126.80459550699993, 50.81403229400007],
              [-126.79344641799992, 50.80731842700004],
              [-126.78213456899994, 50.821926174000055],
              [-126.78433183499993, 50.83234284100007],
              [-126.77065995999993, 50.83633047100005],
              [-126.6824438139999, 50.83437734600005],
              [-126.66612708199995, 50.83616771000004],
              [-126.65729732999989, 50.84324778900009],
              [-126.6499731109999, 50.84780508000006],
              [-126.64098059799994, 50.84979889500005],
              [-126.63377844999991, 50.848089911000045],
              [-126.6277563139999, 50.84406159100007],
              [-126.62254798099991, 50.83942291900007],
              [-126.61766516799992, 50.83616771000004],
              [-126.58812415299991, 50.822251695000034],
              [-126.57542883999992, 50.813706773000035],
              [-126.56240800699993, 50.802069403000075],
              [-126.57371985599991, 50.80215078300006],
              [-126.59373938699991, 50.80711497600004],
              [-126.60342363199993, 50.808254299000055],
              [-126.61534583199995, 50.805975653000075],
              [-126.63756262899994, 50.79718659100007],
              [-126.67284094999991, 50.79254791900007],
              [-126.74120032499991, 50.774725653000075],
              [-126.74583899599992, 50.776678778000075],
              [-126.76081295499989, 50.78611888200004],
              [-126.76854407499991, 50.788397528000075],
              [-126.76842200399994, 50.78628164300005],
              [-126.77253170499989, 50.78164297100005],
              [-126.77798417899993, 50.777004299000055],
              [-126.78213456899994, 50.774725653000075],
            ],
          ],
          [
            [
              [-123.32119706899994, 48.49583567900004],
              [-123.30223548099991, 48.48419830900008],
              [-123.2871801419999, 48.46832916900007],
              [-123.28062903599994, 48.44839101800005],
              [-123.28709876199991, 48.42413971600007],
              [-123.30247962099992, 48.41429271000004],
              [-123.3303930329999, 48.40477122600004],
              [-123.35704505099994, 48.40058014500005],
              [-123.43732662699995, 48.444647528000075],
              [-123.45335852799991, 48.433579820000034],
              [-123.48021399599992, 48.39232005400004],
              [-123.49624589799993, 48.38320547100005],
              [-123.51109778599994, 48.380519924000055],
              [-123.51512610599991, 48.37376536700003],
              [-123.5156957669999, 48.36473216400009],
              [-123.5198461579999, 48.35529205900008],
              [-123.52790279899995, 48.34833405200004],
              [-123.54548092399995, 48.33657461100006],
              [-123.55459550699993, 48.32794830900008],
              [-123.55060787699995, 48.31305573100008],
              [-123.57217363199993, 48.30609772300005],
              [-123.5952856109999, 48.31004466400009],
              [-123.59557044199994, 48.32794830900008],
              [-123.61245683499993, 48.32684967700004],
              [-123.6399633449999, 48.31679922100005],
              [-123.65392005099994, 48.31427643400008],
              [-123.66779537699995, 48.317613023000035],
              [-123.68504798099991, 48.33218008000006],
              [-123.7053930329999, 48.33803945500006],
              [-123.73375403599994, 48.350775458000044],
              [-123.78062903599994, 48.36286041900007],
              [-123.84117591099994, 48.36188385600008],
              [-123.89077714799993, 48.366888739000046],
              [-124.13149980399993, 48.43349844000005],
              [-124.38914954299992, 48.51797109600005],
              [-124.41421464799993, 48.51976146000004],
              [-124.43789628799993, 48.52553945500006],
              [-124.42967688699991, 48.53851959800005],
              [-124.4077856109999, 48.552394924000055],
              [-124.3906957669999, 48.56073639500005],
              [-124.40143795499989, 48.56525299700007],
              [-124.43468176999994, 48.56915924700007],
              [-124.44530188699991, 48.56818268400008],
              [-124.45726477799991, 48.56273021000004],
              [-124.46751868399991, 48.555975653000075],
              [-124.4856664699999, 48.540228583000044],
              [-124.49356035099993, 48.54214101800005],
              [-124.51357988199993, 48.54706452000005],
              [-124.66539466099994, 48.57322825700004],
              [-124.73119055899991, 48.59638092700004],
              [-124.76935787699989, 48.61505768400008],
              [-124.79991614499994, 48.63922760600008],
              [-124.81623287699989, 48.64712148600006],
              [-125.09398352799991, 48.73004791900007],
              [-125.10875403599994, 48.73875560100004],
              [-125.14391028599994, 48.77435944200005],
              [-125.15982011599993, 48.786810614000046],
              [-125.18517005099994, 48.80097077000005],
              [-125.17113196499992, 48.81590403900009],
              [-125.11001542899993, 48.84194570500006],
              [-125.10513261599993, 48.84784577000005],
              [-125.09557044199994, 48.86347077000005],
              [-125.08897864499994, 48.86981842700004],
              [-125.0784399079999, 48.876166083000044],
              [-125.06875566299993, 48.880194403000075],
              [-125.0581762359999, 48.88226959800005],
              [-125.0344945949999, 48.88373444200005],
              [-125.02196204299992, 48.88654205900008],
              [-125.01146399599992, 48.89199453300006],
              [-125.00698808499993, 48.90021393400008],
              [-125.00963294199994, 48.91429271000004],
              [-125.01378333199995, 48.92137278900009],
              [-125.01366126199991, 48.92812734600005],
              [-125.00357011599993, 48.94122955900008],
              [-124.98412024599992, 48.95600006700005],
              [-124.96324622299994, 48.962958075000074],
              [-124.9182836579999, 48.97223541900007],
              [-124.88267981699994, 48.99054596600007],
              [-124.8469945949999, 49.02045319200005],
              [-124.81944739499994, 49.05801015800006],
              [-124.80842037699989, 49.09918854400007],
              [-124.80089270699995, 49.11676666900007],
              [-124.78697669199994, 49.13349030200004],
              [-124.77940833199995, 49.152044989000046],
              [-124.79881751199991, 49.188788153000075],
              [-124.80842037699989, 49.24656810100004],
              [-124.81460527299993, 49.24286530200004],
              [-124.8206274079999, 49.237982489000046],
              [-124.82555091099994, 49.23216380400004],
              [-124.8289281889999, 49.225490627000056],
              [-124.82852128799993, 49.21771881700005],
              [-124.82201087099992, 49.18138255400004],
              [-124.82201087099992, 49.14012278900009],
              [-124.82803300699993, 49.11985911700003],
              [-124.84203040299991, 49.10390859600005],
              [-124.85802161399994, 49.08958567900004],
              [-124.86986243399991, 49.074652411000045],
              [-124.8792211579999, 49.03229401200008],
              [-124.8880102199999, 49.01398346600007],
              [-124.90770423099991, 49.00641510600008],
              [-124.92467200399994, 49.002834377000056],
              [-124.96764075399994, 48.987941799000055],
              [-124.99274654899995, 48.98590729400007],
              [-125.04482988199993, 48.99274323100008],
              [-125.05646725199989, 48.99062734600005],
              [-125.07603919199994, 48.98118724200003],
              [-125.08584550699993, 48.97907135600008],
              [-125.11123613199993, 48.98387278900009],
              [-125.1292211579999, 48.99298737200007],
              [-125.14688066299993, 48.99852122600004],
              [-125.17149817599994, 48.99274323100008],
              [-125.20189368399991, 48.96674225500004],
              [-125.22126217399995, 48.954779364000046],
              [-125.24038652299993, 48.95547109600005],
              [-125.26504472599993, 48.96303945500006],
              [-125.31517493399991, 48.96531810100004],
              [-125.3360082669999, 48.97223541900007],
              [-125.30247962099992, 49.003119208000044],
              [-125.28282630099994, 49.01536692900004],
              [-125.26085364499994, 49.020697333000044],
              [-125.26085364499994, 49.02753327000005],
              [-125.2971899079999, 49.02631256700005],
              [-125.30870520699995, 49.02753327000005],
              [-125.31696529899995, 49.03139883000006],
              [-125.3250219389999, 49.03733958500004],
              [-125.33340410099993, 49.04181549700007],
              [-125.34284420499989, 49.04116445500006],
              [-125.35387122299994, 49.02724844000005],
              [-125.35899817599994, 49.00641510600008],
              [-125.36628170499989, 48.98737213700008],
              [-125.40050208199995, 48.97260163000004],
              [-125.42979895699995, 48.94399648600006],
              [-125.44896399599992, 48.93744538000004],
              [-125.45221920499989, 48.93439362200007],
              [-125.45543372299994, 48.92755768400008],
              [-125.46056067599994, 48.92072174700007],
              [-125.46947180899991, 48.917669989000046],
              [-125.48936926999994, 48.91864655200004],
              [-125.4983617829999, 48.92047760600008],
              [-125.50047766799992, 48.923814195000034],
              [-125.51439368399991, 48.92649974200003],
              [-125.53111731699994, 48.932521877000056],
              [-125.54710852799991, 48.94025299700007],
              [-125.55882727799991, 48.94830963700008],
              [-125.5730688139999, 48.95579661700003],
              [-125.60655676999994, 48.96185944200005],
              [-125.62022864499994, 48.968817450000074],
              [-125.62612870999993, 48.97553131700005],
              [-125.63341223899994, 48.98786041900007],
              [-125.6370336579999, 48.99274323100008],
              [-125.67235266799992, 49.01780833500004],
              [-125.69823157499991, 49.02912018400008],
              [-125.70933997299994, 49.03742096600007],
              [-125.73582923099991, 49.05304596600007],
              [-125.8362524079999, 49.06903717700004],
              [-125.84927324099993, 49.073919989000046],
              [-125.86278235599991, 49.08075592700004],
              [-125.87169348899994, 49.09015534100007],
              [-125.87100175699993, 49.10260651200008],
              [-125.86156165299991, 49.11001211100006],
              [-125.83092200399994, 49.11440664300005],
              [-125.81578528599994, 49.123032945000034],
              [-125.80028235599991, 49.11212799700007],
              [-125.78477942599994, 49.10492584800005],
              [-125.76756751199991, 49.10346100500004],
              [-125.7468969389999, 49.109442450000074],
              [-125.73973548099991, 49.11432526200008],
              [-125.70128333199995, 49.13471100500004],
              [-125.69225012899994, 49.13336823100008],
              [-125.68358313699991, 49.148423570000034],
              [-125.64565995999993, 49.16400788000004],
              [-125.6370336579999, 49.17462799700007],
              [-125.63231360599991, 49.187933661000045],
              [-125.62230383999992, 49.196193752000056],
              [-125.61294511599993, 49.206366278000075],
              [-125.61034094999991, 49.225490627000056],
              [-125.69859778599994, 49.18109772300005],
              [-125.72325598899994, 49.160589911000045],
              [-125.74669348899994, 49.148138739000046],
              [-125.75511633999992, 49.16889069200005],
              [-125.75373287699989, 49.222357489000046],
              [-125.74282792899993, 49.25177643400008],
              [-125.7405492829999, 49.26740143400008],
              [-125.7503149079999, 49.263657945000034],
              [-125.76305091099994, 49.25372955900008],
              [-125.77733313699991, 49.247707424000055],
              [-125.79112708199995, 49.24701569200005],
              [-125.80211341099994, 49.25340403900009],
              [-125.80313066299993, 49.26251862200007],
              [-125.80199133999992, 49.30019765800006],
              [-125.79869544199994, 49.31146881700005],
              [-125.79010982999989, 49.322699286000045],
              [-125.78160559799994, 49.33844635600008],
              [-125.77562415299991, 49.35541413000004],
              [-125.77476966099994, 49.37010325700004],
              [-125.78160559799994, 49.37010325700004],
              [-125.79279537699989, 49.35993073100008],
              [-125.80630449099993, 49.343451239000046],
              [-125.81777910099993, 49.32404205900008],
              [-125.82469641799992, 49.29559967700004],
              [-125.82998613199993, 49.28384023600006],
              [-125.83690344999991, 49.273138739000046],
              [-125.84373938699991, 49.26703522300005],
              [-125.85171464799993, 49.26642487200007],
              [-125.86489824099993, 49.27619049700007],
              [-125.8772680329999, 49.28009674700007],
              [-125.9011938139999, 49.27448151200008],
              [-125.93980872299994, 49.24091217700004],
              [-125.95604407499991, 49.23289622600004],
              [-125.9773656889999, 49.23517487200007],
              [-125.99437415299991, 49.24233633000006],
              [-126.01016191299993, 49.255072333000044],
              [-126.02806555899991, 49.273871161000045],
              [-126.00890051999994, 49.292303778000075],
              [-125.97874915299991, 49.304022528000075],
              [-125.95091712099992, 49.32025788000004],
              [-125.92878170499989, 49.373032945000034],
              [-125.91002356699994, 49.39838288000004],
              [-125.89899654899995, 49.42218659100007],
              [-125.91197669199994, 49.438381252000056],
              [-125.92178300699993, 49.41982656500005],
              [-125.95848548099991, 49.39329661700003],
              [-125.96662350199989, 49.380072333000044],
              [-125.96983801999994, 49.357855536000045],
              [-125.97923743399991, 49.341782945000034],
              [-125.99425208199995, 49.33038971600007],
              [-126.01439368399991, 49.322333075000074],
              [-126.02367102799991, 49.32868073100008],
              [-126.0464574859999, 49.33783600500004],
              [-126.05907141799992, 49.34589264500005],
              [-126.0764867829999, 49.38373444200005],
              [-126.07164466099994, 49.39630768400008],
              [-126.0581762359999, 49.41193268400008],
              [-126.05532792899993, 49.42104726800005],
              [-126.05435136599993, 49.438381252000056],
              [-126.05508378799993, 49.445298570000034],
              [-126.06289628799993, 49.44440338700008],
              [-126.12193762899994, 49.426214911000045],
              [-126.14126542899993, 49.42357005400004],
              [-126.1565649079999, 49.418402411000045],
              [-126.17398027299993, 49.415350653000075],
              [-126.17764238199993, 49.41111888200004],
              [-126.18016516799992, 49.40672435100004],
              [-126.18569902299993, 49.40424225500004],
              [-126.19786536399994, 49.40460846600007],
              [-126.21353105399993, 49.40737539300005],
              [-126.22712154899995, 49.41278717700004],
              [-126.23289954299992, 49.42104726800005],
              [-126.23574785099993, 49.43549225500004],
              [-126.24351966099994, 49.44627513200004],
              [-126.25479081899994, 49.450506903000075],
              [-126.26821855399993, 49.44521719000005],
              [-126.25877844999991, 49.43146393400008],
              [-126.25670325399994, 49.41592031500005],
              [-126.2613012359999, 49.40033600500004],
              [-126.27513587099992, 49.38190338700008],
              [-126.28429114499994, 49.366522528000075],
              [-126.28807532499991, 49.36269765800006],
              [-126.29735266799992, 49.362534898000035],
              [-126.30256100199989, 49.36709219000005],
              [-126.30577551999994, 49.372748114000046],
              [-126.30923417899993, 49.376288153000075],
              [-126.33771725199989, 49.386053778000075],
              [-126.34996497299994, 49.39215729400007],
              [-126.36070716099994, 49.40053945500006],
              [-126.37555904899995, 49.407456773000035],
              [-126.39509029899995, 49.41400788000004],
              [-126.40501868399991, 49.42137278900009],
              [-126.39118404899995, 49.430894273000035],
              [-126.40575110599991, 49.44208405200004],
              [-126.42137610599991, 49.46556224200003],
              [-126.43211829299992, 49.47256094000005],
              [-126.44835364499994, 49.47052643400008],
              [-126.46532141799992, 49.460150458000044],
              [-126.47948157499991, 49.44745514500005],
              [-126.48737545499989, 49.438381252000056],
              [-126.47524980399993, 49.418402411000045],
              [-126.46393795499989, 49.405585028000075],
              [-126.46434485599991, 49.39565664300005],
              [-126.48737545499989, 49.38373444200005],
              [-126.51040605399993, 49.37775299700007],
              [-126.52782141799992, 49.37885163000004],
              [-126.5423070949999, 49.38568756700005],
              [-126.55626380099994, 49.39679596600007],
              [-126.57266191299993, 49.41429271000004],
              [-126.5742895169999, 49.42568594000005],
              [-126.56834876199991, 49.43813711100006],
              [-126.56240800699993, 49.45888906500005],
              [-126.56273352799991, 49.46088288000004],
              [-126.56240800699993, 49.48615143400008],
              [-126.56041419199994, 49.49628327000005],
              [-126.55785071499992, 49.503241278000075],
              [-126.55760657499991, 49.51040273600006],
              [-126.56240800699993, 49.52094147300005],
              [-126.55626380099994, 49.52094147300005],
              [-126.55626380099994, 49.52716705900008],
              [-126.56297766799992, 49.531317450000074],
              [-126.5676977199999, 49.53579336100006],
              [-126.57677161399994, 49.54824453300006],
              [-126.57095292899993, 49.55414459800005],
              [-126.57087154899995, 49.559759833000044],
              [-126.5718481109999, 49.566473700000074],
              [-126.56932532499991, 49.57558828300006],
              [-126.56509355399993, 49.58356354400007],
              [-126.5625707669999, 49.58738841400009],
              [-126.54881751199991, 49.59601471600007],
              [-126.53302975199989, 49.60248444200005],
              [-126.49909420499989, 49.610581773000035],
              [-126.45254472599993, 49.63629791900007],
              [-126.41706295499989, 49.63849518400008],
              [-126.33653723899994, 49.63080475500004],
              [-126.21816972599993, 49.645697333000044],
              [-126.19668535099993, 49.65448639500005],
              [-126.18569902299993, 49.657456773000035],
              [-126.17198645699995, 49.657416083000044],
              [-126.14891516799992, 49.651556708000044],
              [-126.13792883999992, 49.650051174000055],
              [-126.08950761599993, 49.66087474200003],
              [-126.09203040299991, 49.669989325000074],
              [-126.09854081899994, 49.677801825000074],
              [-126.1074926419999, 49.683294989000046],
              [-126.11709550699993, 49.68545156500005],
              [-126.19497636599993, 49.68138255400004],
              [-126.29678300699993, 49.66083405200004],
              [-126.32437089799993, 49.64826080900008],
              [-126.33877519399994, 49.649644273000035],
              [-126.45323645699995, 49.67430247600004],
              [-126.47716223899994, 49.68398672100005],
              [-126.48737545499989, 49.69505442900004],
              [-126.47940019399994, 49.711818752000056],
              [-126.41201738199993, 49.77171458500004],
              [-126.41120357999989, 49.778225002000056],
              [-126.42560787699989, 49.78099192900004],
              [-126.45274817599994, 49.790228583000044],
              [-126.46735592399995, 49.792303778000075],
              [-126.47370357999989, 49.784369208000044],
              [-126.47227942599994, 49.749701239000046],
              [-126.47777258999992, 49.73493073100008],
              [-126.49356035099993, 49.71893952000005],
              [-126.51671301999994, 49.70840078300006],
              [-126.54531816299993, 49.704413153000075],
              [-126.57310950399994, 49.70693594000005],
              [-126.59349524599992, 49.71580638200004],
              [-126.60521399599992, 49.732123114000046],
              [-126.63727779899995, 49.81712474200003],
              [-126.64134680899991, 49.833319403000075],
              [-126.64439856699994, 49.873480536000045],
              [-126.6497289699999, 49.89801666900007],
              [-126.66372636599993, 49.89687734600005],
              [-126.68346106699994, 49.88491445500006],
              [-126.7058813139999, 49.87718333500004],
              [-126.72638912699989, 49.88239166900007],
              [-126.74893144399994, 49.89557526200008],
              [-126.76720130099994, 49.91242096600007],
              [-126.78294837099992, 49.94245026200008],
              [-126.80223548099991, 49.95457591400009],
              [-126.84361731699994, 49.97345612200007],
              [-126.8426000639999, 49.960638739000046],
              [-126.8108617829999, 49.943345445000034],
              [-126.80264238199993, 49.92812734600005],
              [-126.80850175699993, 49.91437409100007],
              [-126.8225805329999, 49.899725653000075],
              [-126.83946692599994, 49.88816966400009],
              [-126.85387122299994, 49.88344961100006],
              [-126.87165279899995, 49.882473049000055],
              [-126.88341223899994, 49.88312409100007],
              [-126.89159094999991, 49.89101797100005],
              [-126.9102270169999, 49.95742422100005],
              [-126.91934160099993, 49.97345612200007],
              [-126.92198645699995, 49.968451239000046],
              [-126.92349199099993, 49.95880768400008],
              [-126.92552649599992, 49.952337958000044],
              [-126.92857825399994, 49.933254299000055],
              [-126.92983964799993, 49.88312409100007],
              [-126.93614661399994, 49.86664459800005],
              [-126.94493567599994, 49.86359284100007],
              [-127.07298743399991, 49.86225006700005],
              [-127.09825598899994, 49.858303127000056],
              [-127.12193762899994, 49.85773346600007],
              [-127.1419164699999, 49.86664459800005],
              [-127.22907467399995, 49.946478583000044],
              [-127.23753821499992, 49.961818752000056],
              [-127.23094641799992, 49.97650788000004],
              [-127.19985917899993, 50.007513739000046],
              [-127.19383704299992, 50.01113515800006],
              [-127.18838456899994, 50.011419989000046],
              [-127.18358313699991, 50.01325104400007],
              [-127.17943274599992, 50.021185614000046],
              [-127.17959550699993, 50.02619049700007],
              [-127.18626868399991, 50.028998114000046],
              [-127.18626868399991, 50.03424713700008],
              [-127.17756100199989, 50.05341217700004],
              [-127.16429602799991, 50.07123444200005],
              [-127.14753170499989, 50.084418036000045],
              [-127.10610917899993, 50.09552643400008],
              [-127.08873450399994, 50.11074453300006],
              [-127.08311926999994, 50.13076406500005],
              [-127.09691321499992, 50.15094635600008],
              [-127.10643469999991, 50.14325592700004],
              [-127.1089574859999, 50.13495514500005],
              [-127.11058508999992, 50.12636953300006],
              [-127.11733964799993, 50.11737702000005],
              [-127.12498938699991, 50.114935614000046],
              [-127.14745032499991, 50.110541083000044],
              [-127.16388912699989, 50.097357489000046],
              [-127.18968665299991, 50.09564850500004],
              [-127.21544348899994, 50.09943268400008],
              [-127.22720292899993, 50.10659414300005],
              [-127.2344457669999, 50.11713288000004],
              [-127.25121008999992, 50.13190338700008],
              [-127.27049719999991, 50.14520905200004],
              [-127.28526770699995, 50.15094635600008],
              [-127.29206295499989, 50.14427317900004],
              [-127.28783118399991, 50.12840403900009],
              [-127.27989661399994, 50.10932038000004],
              [-127.27562415299991, 50.09292226800005],
              [-127.27725175699993, 50.07632070500006],
              [-127.28331458199995, 50.06244538000004],
              [-127.29580644399994, 50.05093008000006],
              [-127.31655839799993, 50.041083075000074],
              [-127.33946692599994, 50.034857489000046],
              [-127.36253821499992, 50.032538153000075],
              [-127.3848363919999, 50.034491278000075],
              [-127.40534420499989, 50.041083075000074],
              [-127.44054114499994, 50.060614325000074],
              [-127.45689856699994, 50.07412344000005],
              [-127.46743730399993, 50.089504299000055],
              [-127.46947180899991, 50.107855536000045],
              [-127.45885169199994, 50.116441148000035],
              [-127.41901607999989, 50.13043854400007],
              [-127.48790442599994, 50.13043854400007],
              [-127.47874915299991, 50.14354075700004],
              [-127.46288001199991, 50.15615469000005],
              [-127.42642167899993, 50.17885976800005],
              [-127.46344967399995, 50.18695709800005],
              [-127.49547278599994, 50.16860586100006],
              [-127.52456620999993, 50.14325592700004],
              [-127.5528051419999, 50.13043854400007],
              [-127.59361731699994, 50.12006256700005],
              [-127.61416581899994, 50.118801174000055],
              [-127.63125566299993, 50.13043854400007],
              [-127.63560950399994, 50.145412502000056],
              [-127.63084876199991, 50.160142320000034],
              [-127.6211645169999, 50.17365143400008],
              [-127.61082923099991, 50.18504466400009],
              [-127.64989173099991, 50.17804596600007],
              [-127.68871008999992, 50.160142320000034],
              [-127.72472083199995, 50.135972398000035],
              [-127.77415930899991, 50.09194570500006],
              [-127.7847387359999, 50.08502838700008],
              [-127.79637610599991, 50.08270905200004],
              [-127.80451412699989, 50.086004950000074],
              [-127.82135982999989, 50.10000234600005],
              [-127.82652747299994, 50.103176174000055],
              [-127.87564042899993, 50.10602448100008],
              [-127.89810136599993, 50.11408112200007],
              [-127.90623938699991, 50.13043854400007],
              [-127.89683997299994, 50.14297109600005],
              [-127.84044348899994, 50.175441799000055],
              [-127.77529863199993, 50.232855536000045],
              [-127.75523841099994, 50.23810455900008],
              [-127.74697831899994, 50.24323151200008],
              [-127.74795488199993, 50.253973700000074],
              [-127.75511633999992, 50.259466864000046],
              [-127.76500403599994, 50.25885651200008],
              [-127.78612219999991, 50.253973700000074],
              [-127.80431067599994, 50.25287506700005],
              [-127.81094316299993, 50.25560130400004],
              [-127.82628333199995, 50.269964911000045],
              [-127.83348548099991, 50.27448151200008],
              [-127.85098222599993, 50.281236070000034],
              [-127.84093176999994, 50.29173411700003],
              [-127.81346594999991, 50.29474518400008],
              [-127.80260169199994, 50.30174388200004],
              [-127.80028235599991, 50.31439850500004],
              [-127.8089086579999, 50.32176341400009],
              [-127.82209225199989, 50.323431708000044],
              [-127.83360755099994, 50.31883372600004],
              [-127.84268144399994, 50.31875234600005],
              [-127.86620032499991, 50.33771393400008],
              [-127.87800045499989, 50.34271881700005],
              [-127.88634192599994, 50.33974844000005],
              [-127.90684973899994, 50.32591380400004],
              [-127.91869055899991, 50.322251695000034],
              [-127.94399980399993, 50.32786692900004],
              [-127.9680883449999, 50.342230536000045],
              [-127.9788305329999, 50.35700104400007],
              [-127.96426347599993, 50.36383698100008],
              [-127.95425370999993, 50.39337799700007],
              [-127.94212805899991, 50.41437409100007],
              [-127.92613684799994, 50.42527903900009],
              [-127.92613684799994, 50.43211497600004],
              [-127.93130449099993, 50.44098541900007],
              [-127.93114173099991, 50.452337958000044],
              [-127.92577063699991, 50.462103583000044],
              [-127.91551673099991, 50.46625397300005],
              [-127.88048255099994, 50.45844147300005],
              [-127.86412512899994, 50.45954010600008],
              [-127.85781816299993, 50.47370026200008],
              [-127.82437089799993, 50.46637604400007],
              [-127.79849199099993, 50.471869208000044],
              [-127.77399654899995, 50.48159414300005],
              [-127.74453691299993, 50.486761786000045],
              [-127.59117591099994, 50.48574453300006],
              [-127.56956946499992, 50.47842031500005],
              [-127.55239824099993, 50.464097398000035],
              [-127.49779212099992, 50.40078359600005],
              [-127.47549394399994, 50.38373444200005],
              [-127.44692949099993, 50.37689850500004],
              [-127.48224850199989, 50.435248114000046],
              [-127.5078832669999, 50.46596914300005],
              [-127.55785071499992, 50.49298737200007],
              [-127.56248938699991, 50.52106354400007],
              [-127.5496313139999, 50.54389069200005],
              [-127.52261308499993, 50.54197825700004],
              [-127.50047766799992, 50.56720612200007],
              [-127.42369544199994, 50.581244208000044],
              [-127.41901607999989, 50.60346100500004],
              [-127.5117895169999, 50.589056708000044],
              [-127.53229732999989, 50.57925039300005],
              [-127.54580644399994, 50.57021719000005],
              [-127.55614173099991, 50.57249583500004],
              [-127.5647680329999, 50.57916901200008],
              [-127.57323157499991, 50.58295319200005],
              [-127.5874731109999, 50.59320709800005],
              [-127.60024980399993, 50.60024648600006],
              [-127.6145727199999, 50.60346100500004],
              [-127.8198949859999, 50.61115143400008],
              [-127.87767493399991, 50.630113023000035],
              [-127.86595618399991, 50.617254950000074],
              [-127.8433324859999, 50.60390859600005],
              [-127.8184301419999, 50.593410549000055],
              [-127.79946855399993, 50.589178778000075],
              [-127.68651282499991, 50.589178778000075],
              [-127.6348363919999, 50.57965729400007],
              [-127.61082923099991, 50.57062409100007],
              [-127.59373938699991, 50.55874258000006],
              [-127.5926000639999, 50.54360586100006],
              [-127.61485755099994, 50.53660716400009],
              [-127.66266842399995, 50.53457265800006],
              [-127.83739173099991, 50.49017975500004],
              [-127.84593665299991, 50.50625234600005],
              [-127.86587480399993, 50.50438060100004],
              [-127.90623938699991, 50.486761786000045],
              [-127.9505102199999, 50.47728099200003],
              [-127.99697831899994, 50.47402578300006],
              [-128.0139867829999, 50.48086172100005],
              [-128.0325414699999, 50.492173570000034],
              [-128.05003821499992, 50.495794989000046],
              [-128.06387285099993, 50.47931549700007],
              [-128.05589758999992, 50.478501695000034],
              [-128.05199133999992, 50.476996161000045],
              [-128.04674231699994, 50.466864325000074],
              [-128.0417374339999, 50.45994700700004],
              [-128.04352779899995, 50.454738674000055],
              [-128.06017005099994, 50.45258209800005],
              [-128.06749426999994, 50.454291083000044],
              [-128.07750403599994, 50.45856354400007],
              [-128.0873917309999, 50.46426015800006],
              [-128.1043188139999, 50.476629950000074],
              [-128.1315811839999, 50.482123114000046],
              [-128.1452530589999, 50.486761786000045],
              [-128.1531469389999, 50.492621161000045],
              [-128.1647843089999, 50.50690338700008],
              [-128.1731664699999, 50.51406484600005],
              [-128.18932044199994, 50.52240631700005],
              [-128.2001846999999, 50.52610911700003],
              [-128.21068274599992, 50.52765534100007],
              [-128.21800696499992, 50.53021881700005],
              [-128.22252356699994, 50.53656647300005],
              [-128.22622636599993, 50.54437897300005],
              [-128.23818925699993, 50.562933661000045],
              [-128.24209550699993, 50.586004950000074],
              [-128.24819902299993, 50.59662506700005],
              [-128.28921464799993, 50.610256252000056],
              [-128.3100479809999, 50.60773346600007],
              [-128.3198136059999, 50.609808661000045],
              [-128.32396399599992, 50.62051015800006],
              [-128.33629309799994, 50.636786200000074],
              [-128.3386938139999, 50.64716217700004],
              [-128.32705644399994, 50.65184153900009],
              [-128.30479895699995, 50.65497467700004],
              [-128.28433183499993, 50.662095445000034],
              [-128.27774003799993, 50.669134833000044],
              [-128.2967016269999, 50.672308661000045],
              [-128.30801347599993, 50.671128648000035],
              [-128.32872473899994, 50.666001695000034],
              [-128.34105383999992, 50.66486237200007],
              [-128.3491104809999, 50.667669989000046],
              [-128.36172441299993, 50.67438385600008],
              [-128.37344316299993, 50.68231842700004],
              [-128.37857011599993, 50.689113674000055],
              [-128.3843481109999, 50.708970445000034],
              [-128.40587317599994, 50.74408600500004],
              [-128.40587317599994, 50.761053778000075],
              [-128.41722571499992, 50.77187734600005],
              [-128.40680904899995, 50.780503648000035],
              [-128.3865453769999, 50.786322333000044],
              [-128.36831620999993, 50.788397528000075],
              [-128.36803137899994, 50.79083893400008],
              [-128.34821529899995, 50.805121161000045],
              [-128.33999589799993, 50.80695221600007],
              [-128.3034561839999, 50.802069403000075],
              [-128.2671606109999, 50.81207916900007],
              [-128.2265518869999, 50.831732489000046],
              [-128.18675696499992, 50.845038153000075],
              [-128.1526586579999, 50.83616771000004],
              [-128.0978897779999, 50.86579010600008],
              [-128.0769750639999, 50.870306708000044],
              [-128.0562231109999, 50.86896393400008],
              [-128.01768958199995, 50.862209377000056],
              [-127.91836503799993, 50.870794989000046],
              [-127.88247636599993, 50.866888739000046],
              [-127.57013912699989, 50.79511139500005],
              [-127.53587805899991, 50.780951239000046],
              [-127.51805579299992, 50.77977122600004],
              [-127.5051977199999, 50.77334219000005],
              [-127.49559485599991, 50.76235586100006],
              [-127.48790442599994, 50.747381903000075],
              [-127.4903051419999, 50.74648672100005],
              [-127.49331620999993, 50.739935614000046],
              [-127.49449622299994, 50.73126862200007],
              [-127.49132239499994, 50.723537502000056],
              [-127.48131262899994, 50.71336497600004],
              [-127.47728430899991, 50.70742422100005],
              [-127.47362219999991, 50.69896067900004],
              [-127.45824133999992, 50.71653880400004],
              [-127.44505774599992, 50.73786041900007],
              [-127.4290258449999, 50.75189850500004],
              [-127.40534420499989, 50.747381903000075],
              [-127.42129472599993, 50.728949286000045],
              [-127.4036352199999, 50.70774974200003],
              [-127.37295488199993, 50.689154364000046],
              [-127.35008704299992, 50.67853424700007],
              [-127.2632543609999, 50.655910549000055],
              [-127.2346899079999, 50.64443594000005],
              [-127.21922766799992, 50.63471100500004],
              [-127.20954342399995, 50.62710195500006],
              [-127.1985570949999, 50.62128327000005],
              [-127.17943274599992, 50.61709219000005],
              [-127.12645423099991, 50.620021877000056],
              [-127.11115475199989, 50.61709219000005],
              [-127.10558020699995, 50.61237213700008],
              [-127.10094153599994, 50.60541413000004],
              [-127.09780839799993, 50.599269924000055],
              [-127.09691321499992, 50.59662506700005],
              [-127.08739173099991, 50.59442780200004],
              [-127.08067786399994, 50.594916083000044],
              [-127.0735570949999, 50.59617747600004],
              [-127.06273352799991, 50.59662506700005],
              [-127.0113012359999, 50.58930084800005],
              [-126.99449622299994, 50.589178778000075],
              [-127.0012914699999, 50.589178778000075],
              [-126.99380449099993, 50.58893463700008],
              [-126.98688717399995, 50.58779531500005],
              [-126.98033606699994, 50.58567942900004],
              [-126.97398841099994, 50.58295319200005],
              [-126.97899329299992, 50.57990143400008],
              [-126.98884029899995, 50.57208893400008],
              [-126.99449622299994, 50.56928131700005],
              [-126.97716223899994, 50.56297435100004],
              [-126.87328040299991, 50.562201239000046],
              [-126.85728919199994, 50.55914948100008],
              [-126.85045325399994, 50.55158112200007],
              [-126.8550512359999, 50.54389069200005],
              [-126.86266028599994, 50.53611888200004],
              [-126.86424719999991, 50.53009674700007],
              [-126.85045325399994, 50.52765534100007],
              [-126.84447180899991, 50.53034088700008],
              [-126.83657792899993, 50.54336172100005],
              [-126.82933508999992, 50.548163153000075],
              [-126.8230688139999, 50.54901764500005],
              [-126.78941809799994, 50.54857005400004],
              [-126.76553300699993, 50.54441966400009],
              [-126.67931067599994, 50.51752350500004],
              [-126.65526282499991, 50.51406484600005],
              [-126.63149980399993, 50.507147528000075],
              [-126.59532630099994, 50.48021067900004],
              [-126.56932532499991, 50.47931549700007],
              [-126.56297766799992, 50.48427969000005],
              [-126.56224524599992, 50.498114325000074],
              [-126.55565344999991, 50.50096263200004],
              [-126.54845130099994, 50.49982330900008],
              [-126.53701738199993, 50.49469635600008],
              [-126.53140214799993, 50.49355703300006],
              [-126.52110755099994, 50.49286530200004],
              [-126.49258378799993, 50.48737213700008],
              [-126.48363196499992, 50.48305898600006],
              [-126.45982825399994, 50.47483958500004],
              [-126.36440995999993, 50.486761786000045],
              [-126.33971106699994, 50.48354726800005],
              [-126.29385331899994, 50.46942780200004],
              [-126.27163652299993, 50.46625397300005],
              [-126.19310462099992, 50.46971263200004],
              [-126.1172582669999, 50.45538971600007],
              [-126.02354895699995, 50.42560455900008],
              [-125.95750891799992, 50.39500560100004],
              [-125.93578040299991, 50.39109935100004],
              [-125.83751380099994, 50.38727448100008],
              [-125.7891332669999, 50.37689850500004],
              [-125.75267493399991, 50.359035549000055],
              [-125.74034583199995, 50.35639069200005],
              [-125.58922278599994, 50.37067291900007],
              [-125.56432044199994, 50.36615631700005],
              [-125.52440344999991, 50.34707265800006],
              [-125.47671464799993, 50.33901601800005],
              [-125.45445716099994, 50.32880280200004],
              [-125.43618730399993, 50.31362539300005],
              [-125.42471269399994, 50.294907945000034],
              [-125.43219967399995, 50.28750234600005],
              [-125.41966712099992, 50.27252838700008],
              [-125.41051184799994, 50.25690338700008],
              [-125.38805091099994, 50.198553778000075],
              [-125.34959876199991, 50.14411041900007],
              [-125.36953691299993, 50.13857656500005],
              [-125.35008704299992, 50.12490469000005],
              [-125.3184301419999, 50.11147695500006],
              [-125.30186926999994, 50.10659414300005],
              [-125.29271399599992, 50.09039948100008],
              [-125.25914466099994, 50.06464264500005],
              [-125.26085364499994, 50.048529364000046],
              [-125.22301184799994, 50.01776764500005],
              [-125.21910559799994, 50.00995514500005],
              [-125.21947180899991, 49.99103424700007],
              [-125.21589107999989, 49.98305898600006],
              [-125.20531165299991, 49.96922435100004],
              [-125.18789628799993, 49.93781159100007],
              [-125.17833411399994, 49.924994208000044],
              [-124.88206946499992, 49.72492096600007],
              [-124.87291419199994, 49.712591864000046],
              [-124.86986243399991, 49.69505442900004],
              [-124.87584387899994, 49.677435614000046],
              [-124.89098059799994, 49.67206452000005],
              [-124.97325598899994, 49.68496328300006],
              [-124.97972571499992, 49.681708075000074],
              [-124.97622636599993, 49.668036200000074],
              [-124.96792558499993, 49.66250234600005],
              [-124.9578344389999, 49.65961334800005],
              [-124.94863847599993, 49.65375397300005],
              [-124.94131425699993, 49.646918036000045],
              [-124.9182836579999, 49.63080475500004],
              [-124.9094945949999, 49.62132396000004],
              [-124.83804277299993, 49.517279364000046],
              [-124.81786048099991, 49.511786200000074],
              [-124.80842037699989, 49.50665924700007],
              [-124.80459550699993, 49.499701239000046],
              [-124.7996313139999, 49.48078034100007],
              [-124.79474850199989, 49.47256094000005],
              [-124.77257239499994, 49.46149323100008],
              [-124.72362219999991, 49.46507396000004],
              [-124.7019750639999, 49.45547109600005],
              [-124.69196529899995, 49.449204820000034],
              [-124.66812089799993, 49.443060614000046],
              [-124.65758216099994, 49.438381252000056],
              [-124.64244544199994, 49.41681549700007],
              [-124.63707434799994, 49.41107819200005],
              [-124.5960180329999, 49.39118073100008],
              [-124.54507402299993, 49.37718333500004],
              [-124.44530188699991, 49.36269765800006],
              [-124.38727779899995, 49.360663153000075],
              [-124.35997473899994, 49.356634833000044],
              [-124.33885657499991, 49.34589264500005],
              [-124.32900956899994, 49.338771877000056],
              [-124.31956946499992, 49.33490631700005],
              [-124.20848548099991, 49.30805084800005],
              [-124.19835364499994, 49.30914948100008],
              [-124.18541419199994, 49.313788153000075],
              [-124.17467200399994, 49.314886786000045],
              [-124.15916907499991, 49.31045156500005],
              [-124.10948645699995, 49.28009674700007],
              [-124.12677975199995, 49.274318752000056],
              [-124.16307532499991, 49.27167389500005],
              [-124.17837480399993, 49.26023997600004],
              [-124.1648656889999, 49.25486888200004],
              [-124.1516820949999, 49.25543854400007],
              [-124.12287350199995, 49.26023997600004],
              [-124.10855058499993, 49.25812409100007],
              [-124.08458411399994, 49.24872467700004],
              [-124.07135982999989, 49.24656810100004],
              [-124.00938880099994, 49.24591705900008],
              [-123.97769120999993, 49.24095286700003],
              [-123.95494544199994, 49.22919342700004],
              [-123.94981848899994, 49.22304922100005],
              [-123.94579016799992, 49.21523672100005],
              [-123.94627844999991, 49.20844147300005],
              [-123.9641820949999, 49.20307038000004],
              [-123.96214758999992, 49.19700755400004],
              [-123.9512426419999, 49.18451569200005],
              [-123.93077551999994, 49.14354075700004],
              [-123.91710364499994, 49.13491445500006],
              [-123.90453040299991, 49.13361237200007],
              [-123.8836156889999, 49.136704820000034],
              [-123.84166419199994, 49.12763092700004],
              [-123.82835852799991, 49.12995026200008],
              [-123.81338456899994, 49.11859772300005],
              [-123.80492102799991, 49.10398997600004],
              [-123.79784094999991, 49.087144273000035],
              [-123.78734290299991, 49.06903717700004],
              [-123.75690670499989, 49.04214101800005],
              [-123.75137285099993, 49.02798086100006],
              [-123.7737524079999, 49.020697333000044],
              [-123.76488196499992, 49.007879950000074],
              [-123.76089433499993, 48.99583567900004],
              [-123.76488196499992, 48.987534898000035],
              [-123.77989661399994, 48.98590729400007],
              [-123.79385331899994, 48.993475653000075],
              [-123.80410722599993, 49.00535716400009],
              [-123.81602942599994, 49.01268138200004],
              [-123.83511308499993, 49.00641510600008],
              [-123.83511308499993, 49.00018952000005],
              [-123.78734290299991, 48.96539948100008],
              [-123.73973548099991, 48.94285716400009],
              [-123.73277747299994, 48.93439362200007],
              [-123.71792558499993, 48.921535549000055],
              [-123.5938207669999, 48.83698151200008],
              [-123.57994544199994, 48.821600653000075],
              [-123.5918676419999, 48.81460195500006],
              [-123.59609941299993, 48.811428127000056],
              [-123.60049394399994, 48.804388739000046],
              [-123.60228430899991, 48.797308661000045],
              [-123.59870357999989, 48.794134833000044],
              [-123.59044348899994, 48.79547760600008],
              [-123.58250891799992, 48.797756252000056],
              [-123.57506262899994, 48.79824453300006],
              [-123.56826738199993, 48.794134833000044],
              [-123.56529700399994, 48.780910549000055],
              [-123.56655839799993, 48.76072825700004],
              [-123.57298743399991, 48.74624258000006],
              [-123.58503170499989, 48.749701239000046],
              [-123.59878495999993, 48.75844961100006],
              [-123.61758378799993, 48.76325104400007],
              [-123.63658606699994, 48.76386139500005],
              [-123.65078691299993, 48.75995514500005],
              [-123.65078691299993, 48.753119208000044],
              [-123.63158118399991, 48.74213288000004],
              [-123.5608617829999, 48.712144273000035],
              [-123.55199133999992, 48.70538971600007],
              [-123.53087317599994, 48.68496328300006],
              [-123.5266820949999, 48.67804596600007],
              [-123.52993730399993, 48.66474030200004],
              [-123.53697669199994, 48.65761953300006],
              [-123.54234778599994, 48.65029531500005],
              [-123.54092363199993, 48.63646067900004],
              [-123.53465735599991, 48.628119208000044],
              [-123.52529863199993, 48.62067291900007],
              [-123.51695716099994, 48.61082591400009],
              [-123.51366126199991, 48.59544505400004],
              [-123.51756751199991, 48.58038971600007],
              [-123.52586829299992, 48.57208893400008],
              [-123.53482011599993, 48.56537506700005],
              [-123.54092363199993, 48.55451080900008],
              [-123.5354711579999, 48.54010651200008],
              [-123.51357988199993, 48.54755280200004],
              [-123.47203528599994, 48.57501862200007],
              [-123.47850501199991, 48.59080638200004],
              [-123.47500566299993, 48.62124258000006],
              [-123.47887122299994, 48.63646067900004],
              [-123.43732662699995, 48.650091864000046],
              [-123.46178137899994, 48.66323476800005],
              [-123.47179114499994, 48.67243073100008],
              [-123.47203528599994, 48.684881903000075],
              [-123.46300208199995, 48.68964264500005],
              [-123.44603430899991, 48.69208405200004],
              [-123.42829342399995, 48.69245026200008],
              [-123.4168188139999, 48.691107489000046],
              [-123.40538489499994, 48.68634674700007],
              [-123.3992406889999, 48.68154531500005],
              [-123.3967992829999, 48.673895575000074],
              [-123.39635169199994, 48.66095612200007],
              [-123.39415442599994, 48.65704987200007],
              [-123.39028886599993, 48.646185614000046],
              [-123.38866126199991, 48.634833075000074],
              [-123.39321855399993, 48.62962474200003],
              [-123.39004472599993, 48.620428778000075],
              [-123.35533606699994, 48.56073639500005],
              [-123.3457738919999, 48.52338288000004],
              [-123.33706620999993, 48.50804271000004],
              [-123.32119706899994, 48.49583567900004],
            ],
          ],
          [
            [
              [-127.84557044199994, 50.92291901200008],
              [-127.84365800699993, 50.91909414300005],
              [-127.83897864499994, 50.91156647300005],
              [-127.84019934799994, 50.90326569200005],
              [-127.85155188699991, 50.89663320500006],
              [-127.86416581899994, 50.89252350500004],
              [-127.87498938699991, 50.89036692900004],
              [-127.88532467399995, 50.89276764500005],
              [-127.89500891799992, 50.896918036000045],
              [-127.92332923099991, 50.89667389500005],
              [-127.93716386599993, 50.90485260600008],
              [-127.95445716099994, 50.90228913000004],
              [-127.98102779899995, 50.90704987200007],
              [-127.98302161399994, 50.91673411700003],
              [-127.94001217399995, 50.92487213700008],
              [-127.93004309799994, 50.92991771000004],
              [-127.92308508999992, 50.936712958000044],
              [-127.91539466099994, 50.93964264500005],
              [-127.86058508999992, 50.93573639500005],
              [-127.84776770699995, 50.92926666900007],
              [-127.84557044199994, 50.92291901200008],
            ],
          ],
          [
            [
              [-127.54531816299993, 51.08978913000004],
              [-127.5269262359999, 51.08372630400004],
              [-127.52651933499993, 51.06622955900008],
              [-127.54198157499991, 51.05215078300006],
              [-127.5562231109999, 51.05036041900007],
              [-127.56383216099994, 51.05158112200007],
              [-127.57567298099991, 51.049994208000044],
              [-127.59117591099994, 51.05190664300005],
              [-127.59984290299991, 51.059027411000045],
              [-127.6101781889999, 51.07062409100007],
              [-127.61168372299994, 51.075100002000056],
              [-127.59959876199991, 51.07998281500005],
              [-127.55785071499992, 51.08930084800005],
              [-127.54531816299993, 51.08978913000004],
            ],
          ],
          [
            [
              [-131.68126380099994, 52.84210846600007],
              [-131.66515051999994, 52.84125397300005],
              [-131.6536352199999, 52.83771393400008],
              [-131.65518144399994, 52.830511786000045],
              [-131.67076575399994, 52.82489655200004],
              [-131.67983964799993, 52.82330963700008],
              [-131.70083574099993, 52.817694403000075],
              [-131.74351966099994, 52.81134674700007],
              [-131.77944902299993, 52.81159088700008],
              [-131.80797278599994, 52.814886786000045],
              [-131.83193925699993, 52.826157945000034],
              [-131.83763587099992, 52.84096914300005],
              [-131.81777910099993, 52.84674713700008],
              [-131.75942949099993, 52.857123114000046],
              [-131.7358292309999, 52.85366445500006],
              [-131.7305395169999, 52.844631252000056],
              [-131.74535071499992, 52.84125397300005],
              [-131.7434789699999, 52.84015534100007],
              [-131.7206925119999, 52.839178778000075],
              [-131.68126380099994, 52.84210846600007],
            ],
          ],
          [
            [
              [-132.22964433499993, 52.99518463700008],
              [-132.21983801999994, 52.99201080900008],
              [-132.2018936839999, 52.984442450000074],
              [-132.21568762899994, 52.975043036000045],
              [-132.30308997299994, 52.96670156500005],
              [-132.32408606699994, 52.96869538000004],
              [-132.38255774599992, 53.00409577000005],
              [-132.3753149079999, 53.00617096600007],
              [-132.3647354809999, 53.00731028900003],
              [-132.22964433499993, 52.99518463700008],
            ],
          ],
          [
            [
              [-132.9785050119999, 54.24599844000005],
              [-132.9685766269999, 54.24005768400008],
              [-132.96605383999992, 54.23419830900008],
              [-132.9772843089999, 54.218085028000075],
              [-132.97940019399994, 54.20465729400007],
              [-132.9780981109999, 54.196926174000055],
              [-132.98493404899995, 54.19330475500004],
              [-133.00047766799992, 54.19009023600006],
              [-133.0126846999999, 54.19448476800005],
              [-133.01524817599994, 54.20604075700004],
              [-133.0208227199999, 54.214911200000074],
              [-133.0340063139999, 54.21674225500004],
              [-133.0444229809999, 54.21930573100008],
              [-133.05211341099994, 54.22256094000005],
              [-133.0772192049999, 54.223863023000035],
              [-133.08177649599992, 54.231756903000075],
              [-133.0757543609999, 54.24567291900007],
              [-133.06139075399994, 54.25625234600005],
              [-133.03962154899995, 54.25877513200004],
              [-133.0056860019999, 54.255113023000035],
              [-132.99429277299993, 54.25263092700004],
              [-132.9785050119999, 54.24599844000005],
            ],
          ],
          [
            [
              [-64.47744706899994, 60.33392975500004],
              [-64.44786536399994, 60.314154364000046],
              [-64.43415279899995, 60.30170319200005],
              [-64.42666581899994, 60.28620026200008],
              [-64.47183183499993, 60.30145905200004],
              [-64.51923580599993, 60.31932200700004],
              [-64.59414628799993, 60.34760163000004],
              [-64.62002519399994, 60.35504791900007],
              [-64.64622962099992, 60.35911692900004],
              [-64.70335852799991, 60.36127350500004],
              [-64.72647050699993, 60.364894924000055],
              [-64.75031490799995, 60.37384674700007],
              [-64.82437089799993, 60.41547272300005],
              [-64.85411536399994, 60.44041575700004],
              [-64.86156165299991, 60.46552155200004],
              [-64.82689368399991, 60.48541901200008],
              [-64.80671139199995, 60.486395575000074],
              [-64.72695878799993, 60.47797272300005],
              [-64.68260657499991, 60.480169989000046],
              [-64.65977942599994, 60.48452383000006],
              [-64.64134680899991, 60.492254950000074],
              [-64.62767493399991, 60.48419830900008],
              [-64.61131751199991, 60.476996161000045],
              [-64.60142981699994, 60.468817450000074],
              [-64.60716712099992, 60.457464911000045],
              [-64.58747311099995, 60.45962148600006],
              [-64.5696508449999, 60.45795319200005],
              [-64.56041419199994, 60.44940827000005],
              [-64.56627356699994, 60.43081289300005],
              [-64.53941809799994, 60.42601146000004],
              [-64.52936764199995, 60.41421133000006],
              [-64.52896074099993, 60.39679596600007],
              [-64.53148352799991, 60.37555573100008],
              [-64.52525794199994, 60.37555573100008],
              [-64.49502519399994, 60.398423570000034],
              [-64.48741614499994, 60.40216705900008],
              [-64.43248450399994, 60.40216705900008],
              [-64.42247473899994, 60.39760976800005],
              [-64.42381751199991, 60.38690827000005],
              [-64.43032792899993, 60.37539297100005],
              [-64.43236243399991, 60.372748114000046],
              [-64.43590247299994, 60.36810944200005],
              [-64.44220943899995, 60.36347077000005],
              [-64.46324622299994, 60.35504791900007],
              [-64.46690833199995, 60.35130442900004],
              [-64.46930904899995, 60.34796784100007],
              [-64.47215735599991, 60.34479401200008],
              [-64.47744706899994, 60.34137604400007],
              [-64.47744706899994, 60.33392975500004],
            ],
          ],
          [
            [
              [-67.88079833499995, 60.496804559000054],
              [-67.84032560599991, 60.489519114000075],
              [-67.82649431599992, 60.46566278600005],
              [-67.84704416299991, 60.416407553000056],
              [-67.88761897799992, 60.379092452000066],
              [-67.90852529999995, 60.37686017700008],
              [-67.93506997399993, 60.347120964000055],
              [-67.9601258749999, 60.332559856000046],
              [-67.95584596899994, 60.302117122000084],
              [-67.97284732199995, 60.290296099000045],
              [-67.9878783389999, 60.28941290400007],
              [-68.00469278499992, 60.295974529000034],
              [-68.06123732399993, 60.29412336300004],
              [-68.07362287399991, 60.28860488400005],
              [-68.08835388099993, 60.27816638300004],
              [-68.1108701679999, 60.26852107500008],
              [-68.13879023299995, 60.26634109200006],
              [-68.17264524699993, 60.25751300500008],
              [-68.18125932599992, 60.23887654200007],
              [-68.2045537429999, 60.226394767000045],
              [-68.24184015299994, 60.21934711600005],
              [-68.28390272399992, 60.21728477100004],
              [-68.32096725199995, 60.197129027000074],
              [-68.37502843099992, 60.19656790500005],
              [-68.41938190299993, 60.20967631800005],
              [-68.43903429499994, 60.25933281600004],
              [-68.41658549999994, 60.307530186000065],
              [-68.37996159799991, 60.37582991700003],
              [-68.33495294799991, 60.43201184800006],
              [-68.30769936799993, 60.46995728500008],
              [-68.29122722699992, 60.50629776400007],
              [-68.24130644199994, 60.585605927000074],
              [-68.13055740399994, 60.596545407000065],
              [-68.10112336499992, 60.593752539000036],
              [-68.07848059799994, 60.589911200000074],
              [-68.02811690699991, 60.582671488000074],
              [-67.9991310769999, 60.585889412000085],
              [-67.98154974699992, 60.56363794400005],
              [-67.9465539549999, 60.53058418300003],
              [-67.90595803399992, 60.50851664900006],
              [-67.88079833499995, 60.496804559000054],
            ],
          ],
          [
            [
              [-64.61025956899994, 60.69017161700003],
              [-64.59898841099994, 60.68842194200005],
              [-64.59398352799991, 60.683661200000074],
              [-64.59471594999991, 60.67715078300006],
              [-64.59414628799993, 60.66974518400008],
              [-64.59732011599993, 60.65021393400008],
              [-64.60875403599994, 60.630113023000035],
              [-64.62555904899995, 60.614569403000075],
              [-64.65859941299993, 60.605169989000046],
              [-64.68976803299995, 60.58783600500004],
              [-64.70311438699991, 60.59064362200007],
              [-64.71353105399993, 60.597642320000034],
              [-64.71646074099993, 60.60492584800005],
              [-64.69212805899991, 60.61546458500004],
              [-64.63512122299994, 60.66290924700007],
              [-64.61742102799991, 60.68659088700008],
              [-64.61025956899994, 60.69017161700003],
            ],
          ],
          [
            [
              [-78.24372311099995, 60.834865627000056],
              [-78.23664303299995, 60.83307526200008],
              [-78.2344457669999, 60.831244208000044],
              [-78.2317602199999, 60.831244208000044],
              [-78.22325598899994, 60.834865627000056],
              [-78.22427324099993, 60.82689036700003],
              [-78.22374426999994, 60.81342194200005],
              [-78.22325598899994, 60.81313711100006],
              [-78.23070227799991, 60.81313711100006],
              [-78.34056555899991, 60.772772528000075],
              [-78.29515540299991, 60.77985260600008],
              [-78.27847245999993, 60.77960846600007],
              [-78.27847245999993, 60.772772528000075],
              [-78.33629309799994, 60.758693752000056],
              [-78.50438391799992, 60.73867422100005],
              [-78.58853105399993, 60.71430084800005],
              [-78.67943274599992, 60.711371161000045],
              [-78.69611568899995, 60.714097398000035],
              [-78.69139563699991, 60.720404364000046],
              [-78.63695227799991, 60.74624258000006],
              [-78.62791907499991, 60.75234609600005],
              [-78.62368730399993, 60.759833075000074],
              [-78.62120520699995, 60.768866278000075],
              [-78.61607825399994, 60.77643463700008],
              [-78.60374915299991, 60.77960846600007],
              [-78.25112870999993, 60.827378648000035],
              [-78.24372311099995, 60.834865627000056],
            ],
          ],
          [
            [
              [-64.84056555899991, 61.351548570000034],
              [-64.85118567599994, 61.33372630400004],
              [-64.87511145699995, 61.33071523600006],
              [-64.90038001199991, 61.34064362200007],
              [-64.91502844999991, 61.36180247600004],
              [-64.93248450399994, 61.35390859600005],
              [-64.95543372299994, 61.34760163000004],
              [-64.97541256399995, 61.34935130400004],
              [-64.98395748599995, 61.36554596600007],
              [-64.97716223899994, 61.37909577000005],
              [-64.96080481699994, 61.38629791900007],
              [-64.94066321499992, 61.39248281500005],
              [-64.92247473899994, 61.402777411000045],
              [-64.97203528599994, 61.416449286000045],
              [-65.07579505099994, 61.41860586100006],
              [-65.12108313699991, 61.43695709800005],
              [-65.12108313699991, 61.44432200700004],
              [-65.10948645699995, 61.442572333000044],
              [-65.09935462099992, 61.44391510600008],
              [-65.09154212099992, 61.448879299000055],
              [-65.08698482999995, 61.45799388200004],
              [-65.13609778599994, 61.456244208000044],
              [-65.16079667899993, 61.458970445000034],
              [-65.17951412699995, 61.46857330900008],
              [-65.18468176999994, 61.47679271000004],
              [-65.18830318899995, 61.49396393400008],
              [-65.19310462099992, 61.502386786000045],
              [-65.20348059799994, 61.507025458000044],
              [-65.21873938699991, 61.50775788000004],
              [-65.24811764199995, 61.50580475500004],
              [-65.2630102199999, 61.50934479400007],
              [-65.27293860599991, 61.517564195000034],
              [-65.28172766799992, 61.52692291900007],
              [-65.29308020699995, 61.53375885600008],
              [-65.30801347599993, 61.53660716400003],
              [-65.35448157499991, 61.53998444200005],
              [-65.3762914699999, 61.54824453300006],
              [-65.41930091099994, 61.571519273000035],
              [-65.42894446499992, 61.57469310100004],
              [-65.44806881399995, 61.58584219000005],
              [-65.47036699099993, 61.59052155200004],
              [-65.48582923099991, 61.599310614000046],
              [-65.48424231699994, 61.62250397300005],
              [-65.47061113199993, 61.64435455900008],
              [-65.45213782499991, 61.656683661000045],
              [-65.42918860599991, 61.66225820500006],
              [-65.04662024599992, 61.69765859600005],
              [-65.02061926999994, 61.69513580900008],
              [-64.97569739499994, 61.68048737200007],
              [-64.71703040299991, 61.66347890800006],
              [-64.73509680899991, 61.64996979400007],
              [-64.77383378799993, 61.634833075000074],
              [-64.79214433499993, 61.62250397300005],
              [-64.77798417899993, 61.618475653000075],
              [-64.76121985599991, 61.623114325000074],
              [-64.74266516799992, 61.63080475500004],
              [-64.72325598899994, 61.63613515800006],
              [-64.72325598899994, 61.62872955900008],
              [-64.73753821499992, 61.62250397300005],
              [-64.73753821499992, 61.615668036000045],
              [-64.68415279899995, 61.618475653000075],
              [-64.66860917899993, 61.615668036000045],
              [-64.65758216099994, 61.610581773000035],
              [-64.64997311099995, 61.604722398000035],
              [-64.64997311099995, 61.599269924000055],
              [-64.66177324099993, 61.59520091400003],
              [-64.67027747299994, 61.587591864000046],
              [-64.70152747299994, 61.565619208000044],
              [-64.71361243399991, 61.56102122600004],
              [-64.71996008999992, 61.55776601800005],
              [-64.72337805899991, 61.550482489000046],
              [-64.72354081899994, 61.54328034100007],
              [-64.72012285099993, 61.53998444200005],
              [-64.70018469999991, 61.53978099200003],
              [-64.69127356699994, 61.53803131700005],
              [-64.68228105399993, 61.53375885600008],
              [-64.71703040299991, 61.51325104400007],
              [-64.68594316299993, 61.513006903000075],
              [-64.67503821499992, 61.50800202000005],
              [-64.67926998599995, 61.49526601800005],
              [-64.68468176999994, 61.486761786000045],
              [-64.69102942599994, 61.46889883000006],
              [-64.6966039699999, 61.45799388200004],
              [-64.72118079299992, 61.43862539300005],
              [-64.78262285099993, 61.42413971600007],
              [-64.79963131399995, 61.410223700000074],
              [-64.78661048099991, 61.39533112200007],
              [-64.80280514199995, 61.37689850500004],
              [-64.84056555899991, 61.351548570000034],
            ],
          ],
          [
            [
              [-65.70327714799993, 61.79315827000005],
              [-65.67857825399994, 61.768744208000044],
              [-65.67601477799991, 61.75971100500004],
              [-65.69151770699995, 61.75039297100005],
              [-65.72118079299992, 61.75755442900004],
              [-65.75230872299994, 61.772650458000044],
              [-65.77220618399991, 61.78701406500005],
              [-65.78648841099994, 61.76463450700004],
              [-65.81354732999995, 61.75971100500004],
              [-65.87523352799991, 61.76654694200005],
              [-65.89997311099995, 61.77289459800005],
              [-65.92943274599992, 61.78701406500005],
              [-65.94640051999994, 61.80109284100007],
              [-65.89142818899995, 61.82306549700007],
              [-65.84097245999993, 61.853176174000055],
              [-65.79149329299992, 61.87250397300005],
              [-65.75234941299993, 61.85586172100005],
              [-65.76178951699995, 61.851996161000045],
              [-65.79332434799994, 61.845038153000075],
              [-65.79084225199995, 61.837591864000046],
              [-65.78453528599994, 61.83112213700008],
              [-65.77651933499993, 61.828192450000074],
              [-65.76878821499992, 61.831691799000055],
              [-65.75503495999993, 61.841782945000034],
              [-65.73778235599991, 61.84747955900008],
              [-65.72329667899993, 61.84430573100008],
              [-65.71764075399994, 61.82794830900008],
              [-65.71182206899994, 61.818019924000055],
              [-65.70360266799992, 61.79584381700005],
              [-65.70327714799993, 61.79315827000005],
            ],
          ],
          [
            [
              [-93.0254613919999, 61.91669342700004],
              [-93.02830969999991, 61.91290924700007],
              [-93.03221594999991, 61.90302155200004],
              [-92.98192298099991, 61.88947174700007],
              [-92.96397864499994, 61.88939036700003],
              [-92.98412024599992, 61.86823151200008],
              [-93.02013098899994, 61.84467194200005],
              [-93.05890865799995, 61.82990143400008],
              [-93.08751380099994, 61.83539459800005],
              [-93.10187740799995, 61.846584377000056],
              [-93.12938391799992, 61.874701239000046],
              [-93.14830481699994, 61.88320547100005],
              [-93.1953832669999, 61.87718333500004],
              [-93.21605383999992, 61.88165924700007],
              [-93.2246801419999, 61.90643952000005],
              [-93.21548417899993, 61.91986725500004],
              [-93.19420325399994, 61.92479075700004],
              [-93.10407467399995, 61.92226797100005],
              [-93.0847875639999, 61.92597077000005],
              [-93.06639563699991, 61.93781159100007],
              [-93.04596920499995, 61.925848700000074],
              [-93.0254613919999, 61.91669342700004],
            ],
          ],
          [
            [
              [-65.24120032499991, 61.92039622600004],
              [-65.23167883999992, 61.92401764500005],
              [-65.21886145699995, 61.923895575000074],
              [-65.20783443899995, 61.92552317900004],
              [-65.20303300699993, 61.93406810100004],
              [-65.1985570949999, 61.94521719000005],
              [-65.18757076699995, 61.95026276200008],
              [-65.16242428299995, 61.95148346600007],
              [-65.11318925699993, 61.94403717700004],
              [-65.06651770699995, 61.93036530200004],
              [-65.02993730399993, 61.887925523000035],
              [-65.0188695949999, 61.85614655200004],
              [-65.00487219999991, 61.86676666900007],
              [-64.98908443899995, 61.886419989000046],
              [-64.97777258999992, 61.89687734600005],
              [-64.96035722599993, 61.88418203300006],
              [-64.95738684799994, 61.85822174700007],
              [-64.95759029899995, 61.83270905200004],
              [-64.95010331899994, 61.82111237200007],
              [-64.93895423099991, 61.82339101800005],
              [-64.91808020699995, 61.83315664300005],
              [-64.90542558499993, 61.83539459800005],
              [-64.89195716099994, 61.83283112200007],
              [-64.88487708199995, 61.826157945000034],
              [-64.87409420499995, 61.80744049700007],
              [-64.84044348899994, 61.78139883000006],
              [-64.83311926999994, 61.77334219000005],
              [-64.82787024599992, 61.76117584800005],
              [-64.83055579299992, 61.75755442900004],
              [-64.83901933499993, 61.755845445000034],
              [-64.8743383449999, 61.734361070000034],
              [-64.90147864499994, 61.72736237200007],
              [-64.92992102799991, 61.72711823100008],
              [-64.95726477799991, 61.73236725500004],
              [-65.03783118399991, 61.76825592700004],
              [-65.14732825399994, 61.78392161700003],
              [-65.15514075399994, 61.79315827000005],
              [-65.15982011599993, 61.80451080900008],
              [-65.16954505099994, 61.81492747600004],
              [-65.18126380099994, 61.81883372600004],
              [-65.20433508999992, 61.82099030200004],
              [-65.21670488199993, 61.82794830900008],
              [-65.22203528599994, 61.83454010600008],
              [-65.24925696499992, 61.878119208000044],
              [-65.2551977199999, 61.89085521000004],
              [-65.2532445949999, 61.90387604400007],
              [-65.24120032499991, 61.92039622600004],
            ],
          ],
          [
            [
              [-92.27188066299993, 62.40737539300005],
              [-92.24144446499992, 62.39862702000005],
              [-92.14150956899994, 62.403957424000055],
              [-92.14150956899994, 62.396470445000034],
              [-92.1614477199999, 62.396470445000034],
              [-92.22883053299995, 62.36237213700008],
              [-92.24120032499991, 62.35895416900007],
              [-92.26284745999993, 62.36546458500004],
              [-92.32591712099992, 62.35724518400008],
              [-92.35387122299994, 62.36237213700008],
              [-92.31932532499991, 62.38275788000004],
              [-92.30028235599991, 62.389837958000044],
              [-92.27871660099993, 62.390326239000046],
              [-92.29971269399994, 62.40424225500004],
              [-92.32408606699994, 62.40184153900003],
              [-92.34984290299991, 62.393784898000035],
              [-92.37490800699993, 62.390326239000046],
              [-92.37490800699993, 62.396470445000034],
              [-92.36241614499994, 62.400376695000034],
              [-92.35562089799993, 62.406236070000034],
              [-92.34984290299991, 62.412543036000045],
              [-92.34019934799994, 62.417629299000055],
              [-92.32347571499992, 62.41966380400004],
              [-92.30500240799995, 62.41791413000004],
              [-92.28701738199993, 62.41347890800006],
              [-92.27188066299993, 62.40737539300005],
            ],
          ],
          [
            [
              [-79.28246008999992, 62.26992422100005],
              [-79.26573645699995, 62.24982330900008],
              [-79.26382402299993, 62.235541083000044],
              [-79.26866614499994, 62.221991278000075],
              [-79.27220618399991, 62.204738674000055],
              [-79.26732337099992, 62.163275458000044],
              [-79.26952063699991, 62.14520905200004],
              [-79.28246008999992, 62.126166083000044],
              [-79.31517493399991, 62.09080638200004],
              [-79.32774817599994, 62.07046133000006],
              [-79.33429928299995, 62.04767487200007],
              [-79.33372962099992, 62.03607819200005],
              [-79.32795162699995, 62.01593659100007],
              [-79.32599850199995, 61.98843008000006],
              [-79.3301488919999, 61.99046458500004],
              [-79.34357662699995, 61.99241771000004],
              [-79.35179602799991, 61.99469635600008],
              [-79.36750240799995, 62.00446198100008],
              [-79.37832597599993, 62.006740627000056],
              [-79.38638261599993, 62.00218333500004],
              [-79.39073645699995, 61.991848049000055],
              [-79.39509029899995, 61.97134023600006],
              [-79.40274003799993, 61.95807526200008],
              [-79.41038977799991, 61.95075104400007],
              [-79.42983964799993, 61.93781159100007],
              [-79.44078528599994, 61.92719147300005],
              [-79.44635982999995, 61.91815827000005],
              [-79.45653235599991, 61.89687734600005],
              [-79.47398841099994, 61.88060130400004],
              [-79.51829993399991, 61.848089911000045],
              [-79.51919511599993, 61.83539459800005],
              [-79.52281653599994, 61.82453034100007],
              [-79.52798417899993, 61.81403229400007],
              [-79.53547115799995, 61.80540599200003],
              [-79.53745531299995, 61.78741402600008],
              [-79.53970292899993, 61.80060455900008],
              [-79.5408110649999, 61.77722810400007],
              [-79.54847553299993, 61.75953848000006],
              [-79.5633073759999, 61.74239703500007],
              [-79.58489035399992, 61.721415351000076],
              [-79.61644446499992, 61.704413153000075],
              [-79.63898678299995, 61.66054922100005],
              [-79.65123450399994, 61.653631903000075],
              [-79.6887914699999, 61.625881252000056],
              [-79.72443600199995, 61.61225006700005],
              [-79.73379472599993, 61.604803778000075],
              [-79.75023352799991, 61.585923570000034],
              [-79.75885982999995, 61.58218008000006],
              [-79.81029212099992, 61.57404205900008],
              [-79.83381100199995, 61.57306549700007],
              [-79.85440019399994, 61.58218008000006],
              [-79.85606848899994, 61.585598049000055],
              [-79.85855058499993, 61.59642161700003],
              [-79.86188717399995, 61.60138580900008],
              [-79.8692113919999, 61.606634833000044],
              [-79.88292395699995, 61.612209377000056],
              [-79.88914954299992, 61.615668036000045],
              [-79.92332923099991, 61.64984772300005],
              [-79.9500219389999, 61.683294989000046],
              [-79.96031653599994, 61.69013092700004],
              [-79.97057044199994, 61.69330475500004],
              [-80.0061798669999, 61.71127429100005],
              [-80.04087207599991, 61.71728191400007],
              [-80.05904832199991, 61.735118141000044],
              [-80.0598852199999, 61.74603913000004],
              [-80.11501589699992, 61.76088092400005],
              [-80.13795484699995, 61.76947965800008],
              [-80.18039832699992, 61.77425658900006],
              [-80.20445716099994, 61.79010651200008],
              [-80.21621660099993, 61.800848700000074],
              [-80.22255943599993, 61.809363992000044],
              [-80.21886084399995, 61.821247364000044],
              [-80.24131133199995, 61.83149720200004],
              [-80.26109121799993, 61.856298441000035],
              [-80.2591039699999, 61.88939036700003],
              [-80.27367102799991, 61.90521881700005],
              [-80.28197180899991, 61.91754791900007],
              [-80.28555253799993, 61.93036530200004],
              [-80.26252524699993, 61.981057313000065],
              [-80.25910691699994, 62.015410141000075],
              [-80.25154122499993, 62.051195636000045],
              [-80.21859196199995, 62.09124565500008],
              [-80.21497305199995, 62.137658473000045],
              [-80.1582746329999, 62.19935992900008],
              [-80.12377796299995, 62.22027478500007],
              [-80.07458554199991, 62.24619587500007],
              [-80.03454153299992, 62.27793776100003],
              [-79.98922957999991, 62.30844035000007],
              [-79.97655691099993, 62.34125445800004],
              [-79.95207790799992, 62.36459236600007],
              [-79.9345649139999, 62.378049640000086],
              [-79.9150670379999, 62.38617844000004],
              [-79.8672756759999, 62.400923411000065],
              [-79.83079993399991, 62.41079336100006],
              [-79.81737219999991, 62.40717194200005],
              [-79.80467688699991, 62.40021393400008],
              [-79.79051673099991, 62.39594147300005],
              [-79.75792395699995, 62.40485260600008],
              [-79.74063066299993, 62.40574778900003],
              [-79.72398841099994, 62.40289948100008],
              [-79.71104895699995, 62.396470445000034],
              [-79.72036699099993, 62.39130280200004],
              [-79.72264563699991, 62.384751695000034],
              [-79.71727454299992, 62.37921784100007],
              [-79.70360266799992, 62.376654364000046],
              [-79.68907630099994, 62.37958405200004],
              [-79.66559811099995, 62.39337799700007],
              [-79.64541581899994, 62.39980703300006],
              [-79.62132727799991, 62.41429271000004],
              [-79.61107337099992, 62.417629299000055],
              [-79.55858313699991, 62.42039622600004],
              [-79.53970292899993, 62.417629299000055],
              [-79.54588782499991, 62.417629299000055],
              [-79.53490149599992, 62.41364166900007],
              [-79.51545162699995, 62.401556708000044],
              [-79.50499426999994, 62.396470445000034],
              [-79.4883520169999, 62.39313385600008],
              [-79.47105872299994, 62.39166901200008],
              [-79.45466061099995, 62.388373114000046],
              [-79.44041907499991, 62.379787502000056],
              [-79.43545488199993, 62.371161200000074],
              [-79.42491614499994, 62.346869208000044],
              [-79.41930091099994, 62.341864325000074],
              [-79.40892493399991, 62.33930084800005],
              [-79.36839758999992, 62.32143789300005],
              [-79.36278235599991, 62.31460195500006],
              [-79.35016842399995, 62.294623114000046],
              [-79.34044348899994, 62.28660716400003],
              [-79.32664954299992, 62.28237539300005],
              [-79.29556230399993, 62.277044989000046],
              [-79.28246008999992, 62.26992422100005],
            ],
          ],
          [
            [
              [-92.57664954299992, 62.403957424000055],
              [-92.55785071499992, 62.41071198100008],
              [-92.54259192599994, 62.423814195000034],
              [-92.52892005099994, 62.43301015800006],
              [-92.49282792899993, 62.41714101800005],
              [-92.42906653599994, 62.41469961100006],
              [-92.40221106699994, 62.41079336100006],
              [-92.4102270169999, 62.402044989000046],
              [-92.42003333199995, 62.396918036000045],
              [-92.43114173099991, 62.39508698100008],
              [-92.44322669199994, 62.396470445000034],
              [-92.53880774599992, 62.382879950000074],
              [-92.56615149599992, 62.384426174000055],
              [-92.59105383999992, 62.391831773000035],
              [-92.59923255099994, 62.400091864000046],
              [-92.57664954299992, 62.403957424000055],
            ],
          ],
          [
            [
              [-64.38060462099992, 62.52749258000006],
              [-64.38556881399995, 62.52045319200005],
              [-64.38125566299993, 62.51382070500006],
              [-64.37157141799992, 62.50861237200007],
              [-64.36017818899995, 62.50576406500005],
              [-64.36017818899995, 62.49957916900007],
              [-64.48428300699993, 62.48582591400003],
              [-64.48428300699993, 62.47842031500005],
              [-64.46300208199995, 62.47280508000006],
              [-64.41706295499995, 62.46979401200008],
              [-64.39492753799993, 62.46478913000004],
              [-64.42552649599992, 62.444525458000044],
              [-64.44517981699994, 62.43699778900003],
              [-64.46007239499994, 62.44122955900008],
              [-64.46898352799991, 62.44550202000005],
              [-64.48363196499992, 62.44830963700008],
              [-64.49762936099995, 62.448553778000075],
              [-64.50475012899994, 62.44489166900007],
              [-64.50039628799993, 62.43919505400004],
              [-64.4700414699999, 62.417629299000055],
              [-64.51573645699995, 62.39524974200003],
              [-64.54344641799992, 62.386419989000046],
              [-64.56932532499991, 62.382879950000074],
              [-64.57579505099994, 62.380926825000074],
              [-64.58828691299993, 62.37213776200008],
              [-64.59414628799993, 62.36981842700004],
              [-64.60488847599993, 62.370306708000044],
              [-64.62437903599994, 62.375433661000045],
              [-64.65591386599993, 62.37881094000005],
              [-64.69587154899995, 62.38812897300005],
              [-64.78091386599993, 62.393011786000045],
              [-64.92296301999994, 62.41950104400007],
              [-64.95213782499991, 62.43537018400008],
              [-64.94298255099994, 62.45917389500005],
              [-64.95714270699995, 62.464178778000075],
              [-64.96349036399994, 62.46478913000004],
              [-64.93224036399994, 62.48932526200008],
              [-64.88634192599994, 62.49664948100008],
              [-64.79214433499993, 62.49274323100008],
              [-64.80614173099991, 62.503159898000035],
              [-64.85171464799993, 62.51463450700004],
              [-64.86782792899993, 62.52749258000006],
              [-64.84166419199994, 62.55605703300006],
              [-64.80134029899995, 62.56850820500006],
              [-64.75649980399993, 62.56708405200004],
              [-64.71703040299991, 62.55414459800005],
              [-64.69444739499994, 62.53607819200005],
              [-64.68602454299992, 62.53367747600004],
              [-64.67735755099994, 62.53583405200004],
              [-64.65807044199994, 62.54523346600007],
              [-64.64842688699991, 62.547308661000045],
              [-64.55256100199995, 62.541083075000074],
              [-64.55223548099991, 62.55971914300005],
              [-64.52623450399994, 62.56122467700004],
              [-64.46324622299994, 62.547308661000045],
              [-64.46666419199994, 62.526678778000075],
              [-64.40440833199995, 62.53595612200007],
              [-64.38060462099992, 62.52749258000006],
            ],
          ],
          [
            [
              [-77.85391191299993, 62.588324286000045],
              [-77.83633378799993, 62.56232330900008],
              [-77.86058508999992, 62.550482489000046],
              [-77.93244381399995, 62.547308661000045],
              [-78.08702551999994, 62.560980536000045],
              [-78.10562089799993, 62.56525299700007],
              [-78.1133520169999, 62.574652411000045],
              [-78.1087133449999, 62.584051825000074],
              [-78.09044348899994, 62.588324286000045],
              [-77.88695227799991, 62.59918854400007],
              [-77.85391191299993, 62.588324286000045],
            ],
          ],
          [
            [
              [-77.72297115799995, 62.588324286000045],
              [-77.63951575399994, 62.59218984600005],
              [-77.62051347599993, 62.588324286000045],
              [-77.64915930899991, 62.56830475500004],
              [-77.66563880099994, 62.56134674700007],
              [-77.69294186099995, 62.567694403000075],
              [-77.71080481699994, 62.559759833000044],
              [-77.72899329299992, 62.54840729400007],
              [-77.74404863199993, 62.541083075000074],
              [-77.76207434799994, 62.54002513200004],
              [-77.78473873599995, 62.542303778000075],
              [-77.80410722599993, 62.548163153000075],
              [-77.81236731699994, 62.55756256700005],
              [-77.81468665299991, 62.57070547100005],
              [-77.82042395699995, 62.58104075700004],
              [-77.82730058499993, 62.59096914300005],
              [-77.83348548099991, 62.60260651200008],
              [-77.82591712099992, 62.601996161000045],
              [-77.81899980399993, 62.60065338700008],
              [-77.81248938699991, 62.59857819200005],
              [-77.80614173099991, 62.595770575000074],
              [-77.79503333199995, 62.59625885600008],
              [-77.77232825399994, 62.601629950000074],
              [-77.76455644399994, 62.60260651200008],
              [-77.75348873599995, 62.599676825000074],
              [-77.73314368399991, 62.590277411000045],
              [-77.72297115799995, 62.588324286000045],
            ],
          ],
          [
            [
              [-64.96690833199995, 62.53367747600004],
              [-65.06159420499995, 62.53278229400007],
              [-65.11440995999993, 62.53847890800006],
              [-65.14159094999991, 62.55414459800005],
              [-65.08307857999995, 62.55939362200007],
              [-65.06993567599994, 62.56468333500004],
              [-65.06012936099995, 62.574286200000074],
              [-65.04942786399994, 62.58266836100006],
              [-65.03783118399991, 62.58974844000005],
              [-65.02497311099995, 62.595770575000074],
              [-64.99478105399993, 62.60370514500005],
              [-64.95400956899994, 62.60854726800005],
              [-64.91454016799992, 62.60691966400003],
              [-64.88833574099993, 62.595770575000074],
              [-64.84056555899991, 62.582098700000074],
              [-64.86851966099994, 62.56313711100006],
              [-64.88414466099994, 62.556626695000034],
              [-64.90200761599993, 62.55414459800005],
              [-64.92223059799994, 62.55536530200004],
              [-64.93248450399994, 62.55451080900008],
              [-64.93984941299993, 62.55072663000004],
              [-64.95287024599992, 62.54002513200004],
              [-64.96060136599993, 62.53554922100005],
              [-64.96690833199995, 62.53367747600004],
            ],
          ],
          [
            [
              [-91.59288489499994, 62.65094635600008],
              [-91.58413652299993, 62.64313385600008],
              [-91.57632402299993, 62.63222890800006],
              [-91.57510331899994, 62.62441640800006],
              [-91.58604895699995, 62.626166083000044],
              [-91.66966712099992, 62.65424225500004],
              [-91.68907630099994, 62.67084381700005],
              [-91.67943274599992, 62.671942450000074],
              [-91.6707250639999, 62.67104726800005],
              [-91.66266842399995, 62.66819896000004],
              [-91.65493730399993, 62.66400788000004],
              [-91.60619055899991, 62.65607330900008],
              [-91.59288489499994, 62.65094635600008],
            ],
          ],
          [
            [
              [-91.13414466099994, 62.68451569200005],
              [-91.04482988199993, 62.68256256700005],
              [-90.98399817599994, 62.66400788000004],
              [-90.98884029899995, 62.65912506700005],
              [-90.99315344999991, 62.65884023600006],
              [-91.00446529899995, 62.66400788000004],
              [-91.14781653599994, 62.66400788000004],
              [-91.20156816299993, 62.67641836100006],
              [-91.21983801999994, 62.67829010600008],
              [-91.25422115799995, 62.67645905200004],
              [-91.27098548099991, 62.68008047100005],
              [-91.27135169199994, 62.69196198100008],
              [-91.24657141799992, 62.69989655200004],
              [-91.13414466099994, 62.68451569200005],
            ],
          ],
          [
            [
              [-74.01622473899994, 62.67084381700005],
              [-74.00153561099995, 62.65875885600008],
              [-73.96751868399991, 62.61810944200005],
              [-73.96471106699994, 62.609442450000074],
              [-74.11864173099991, 62.60260651200008],
              [-74.37559973899994, 62.634466864000046],
              [-74.40721594999991, 62.64354075700004],
              [-74.43199622299994, 62.65704987200007],
              [-74.44416256399995, 62.66205475500004],
              [-74.53209387899994, 62.66889069200005],
              [-74.54723059799994, 62.67454661700003],
              [-74.56704667899993, 62.686835028000075],
              [-74.65306555899991, 62.71930573100008],
              [-74.63243567599994, 62.72943756700005],
              [-74.56427975199995, 62.73908112200007],
              [-74.54190019399994, 62.75096263200004],
              [-74.53014075399994, 62.75336334800005],
              [-74.51773027299993, 62.752386786000045],
              [-74.49461829299992, 62.74648672100005],
              [-74.4817602199999, 62.74591705900008],
              [-74.47614498599995, 62.739894924000055],
              [-74.46751868399991, 62.73383209800005],
              [-74.45759029899995, 62.72870514500005],
              [-74.44815019399994, 62.725490627000056],
              [-74.43980872299994, 62.725043036000045],
              [-74.42137610599991, 62.726996161000045],
              [-74.41344153599994, 62.725490627000056],
              [-74.39830481699994, 62.71507396000004],
              [-74.39220130099994, 62.70848216400003],
              [-74.40054277299993, 62.702337958000044],
              [-74.39452063699991, 62.695013739000046],
              [-74.38434811099995, 62.68781159100007],
              [-74.37559973899994, 62.68451569200005],
              [-74.15274003799993, 62.69196198100008],
              [-74.13687089799993, 62.68984609600005],
              [-74.10602779899995, 62.68040599200003],
              [-74.03246008999992, 62.67536041900007],
              [-74.01622473899994, 62.67084381700005],
            ],
          ],
          [
            [
              [-70.24058997299994, 62.61562734600005],
              [-70.19947183999994, 62.61013707400008],
              [-70.17705041499994, 62.58998812200008],
              [-70.19404764699993, 62.56753608000008],
              [-70.2308333229999, 62.550923143000034],
              [-70.27606591699993, 62.541947522000044],
              [-70.36198192499995, 62.52686493200008],
              [-70.43887285099993, 62.53367747600004],
              [-70.56236731699994, 62.541083075000074],
              [-70.58556067599994, 62.545355536000045],
              [-70.62486731699994, 62.564154364000046],
              [-70.64464270699995, 62.568426825000074],
              [-70.65428626199991, 62.56513092700004],
              [-70.66942298099991, 62.55060455900008],
              [-70.68224036399994, 62.547308661000045],
              [-70.72789466099994, 62.55341217700004],
              [-70.74054928299995, 62.55756256700005],
              [-70.72541609199993, 62.569025939000085],
              [-70.72800817799993, 62.58078472400007],
              [-70.73338782499991, 62.595770575000074],
              [-70.79067833699992, 62.602832403000036],
              [-70.82044954399993, 62.62661280600008],
              [-70.81708156699995, 62.67324603800006],
              [-70.84532630099994, 62.69912344000005],
              [-70.8665258449999, 62.720038153000075],
              [-70.92516028599994, 62.74591705900008],
              [-70.90892493399991, 62.75242747600004],
              [-70.89024817599994, 62.75462474200003],
              [-70.87205969999991, 62.75259023600006],
              [-70.85692298099991, 62.74591705900008],
              [-70.85008704299992, 62.75336334800005],
              [-70.83617102799991, 62.74762604400007],
              [-70.81456458199995, 62.74408600500004],
              [-70.79271399599992, 62.744208075000074],
              [-70.77806555899991, 62.749660549000055],
              [-70.77098548099991, 62.76162344000005],
              [-70.77399654899995, 62.77130768400008],
              [-70.78502356699994, 62.777777411000045],
              [-70.80231686099995, 62.78009674700007],
              [-70.87140865799995, 62.772772528000075],
              [-70.90733801999994, 62.77484772300005],
              [-70.95962480399993, 62.803168036000045],
              [-70.99697831899994, 62.811712958000044],
              [-71.03465735599991, 62.81329987200007],
              [-71.07249915299991, 62.80019765800006],
              [-71.09459387899994, 62.799261786000045],
              [-71.15729732999995, 62.80345286700003],
              [-71.16856848899994, 62.80719635600008],
              [-71.17967688699991, 62.81484609600005],
              [-71.14736894399994, 62.82562897300005],
              [-71.06867428299995, 62.82025788000004],
              [-71.03506425699993, 62.82916901200008],
              [-71.14281165299991, 62.83893463700008],
              [-71.19741777299993, 62.85024648600006],
              [-71.23704993399991, 62.87319570500006],
              [-71.23595130099994, 62.886419989000046],
              [-71.20815995999993, 62.888739325000074],
              [-70.78864498599995, 62.84153880400004],
              [-70.61108622099994, 62.797949163000055],
              [-70.55577573099993, 62.77776275200006],
              [-70.49249324199991, 62.76695743400006],
              [-70.47362219999991, 62.75039297100005],
              [-70.44196529899995, 62.74249909100007],
              [-70.41307532499991, 62.73151276200008],
              [-70.39757239499994, 62.71930573100008],
              [-70.41869055899991, 62.71865469000005],
              [-70.42552649599992, 62.71930573100008],
              [-70.42552649599992, 62.71246979400007],
              [-70.38487708199995, 62.69550202000005],
              [-70.32666003299994, 62.68651160400003],
              [-70.35150379599992, 62.67616949600006],
              [-70.37330199699994, 62.66655719100004],
              [-70.35301673099991, 62.66388580900008],
              [-70.32258053299995, 62.66205475500004],
              [-70.29945907399991, 62.66388506700008],
              [-70.27496364099994, 62.65736525300008],
              [-70.25625593799992, 62.637143119000086],
              [-70.24058997299994, 62.61562734600005],
            ],
          ],
          [
            [
              [-82.19131425699993, 62.98615143400008],
              [-82.10960852799991, 62.96849192900004],
              [-81.93455969999991, 62.95498281500005],
              [-81.8972875639999, 62.94489166900007],
              [-81.86237545499995, 62.92475006700005],
              [-81.88011633999992, 62.91242096600007],
              [-81.89826412699995, 62.896551825000074],
              [-81.90859941299993, 62.87750885600008],
              [-81.90330969999991, 62.85578034100007],
              [-81.92931067599994, 62.84992096600007],
              [-81.94155839799993, 62.84467194200005],
              [-81.95173092399995, 62.83535390800006],
              [-81.93529212099992, 62.82697174700007],
              [-81.93927975199995, 62.817287502000056],
              [-81.96475175699993, 62.801214911000045],
              [-81.94200598899994, 62.77773672100005],
              [-81.93004309799994, 62.762152411000045],
              [-81.92373613199993, 62.74591705900008],
              [-81.92756100199995, 62.72931549700007],
              [-81.93980872299994, 62.71161530200004],
              [-81.95693925699993, 62.69765859600005],
              [-81.99583899599992, 62.68650950700004],
              [-82.03807532499991, 62.66266510600008],
              [-82.07713782499991, 62.65180084800005],
              [-82.13670813699991, 62.61562734600005],
              [-82.1634008449999, 62.60789622600004],
              [-82.29596920499995, 62.585150458000044],
              [-82.31395423099991, 62.571519273000035],
              [-82.3445531889999, 62.564439195000034],
              [-82.3633520169999, 62.554673570000034],
              [-82.3933813139999, 62.530585028000075],
              [-82.40298417899993, 62.517238674000055],
              [-82.42467200399994, 62.47223541900007],
              [-82.62267005099994, 62.396470445000034],
              [-82.74669348899994, 62.310532945000034],
              [-82.89793860599991, 62.24750397300005],
              [-83.06615149599992, 62.187160549000055],
              [-83.13459225199995, 62.17658112200007],
              [-83.14712480399993, 62.18109772300005],
              [-83.15615800699993, 62.190659898000035],
              [-83.16779537699995, 62.20872630400004],
              [-83.17821204299992, 62.218410549000055],
              [-83.19896399599992, 62.22955963700008],
              [-83.25739498599995, 62.24909088700008],
              [-83.28062903599994, 62.25250885600008],
              [-83.41779537699995, 62.239447333000044],
              [-83.67300370999993, 62.14508698100008],
              [-83.70518958199995, 62.14350006700005],
              [-83.71939042899993, 62.16063060100004],
              [-83.71324622299994, 62.239447333000044],
              [-83.72484290299991, 62.28563060100004],
              [-83.75145423099991, 62.31004466400003],
              [-83.91002356699994, 62.39524974200003],
              [-83.93980872299994, 62.423814195000034],
              [-83.93911699099993, 62.45917389500005],
              [-83.90697180899991, 62.491400458000044],
              [-83.71324622299994, 62.568426825000074],
              [-83.66909745999993, 62.60789622600004],
              [-83.66002356699994, 62.63133372600004],
              [-83.65461178299995, 62.63666413000004],
              [-83.64199785099993, 62.63898346600007],
              [-83.58315995999993, 62.66864655200004],
              [-83.56550045499995, 62.68227773600006],
              [-83.55284583199995, 62.69969310100004],
              [-83.5481664699999, 62.722357489000046],
              [-83.55134029899995, 62.733303127000056],
              [-83.55687415299991, 62.74176666900007],
              [-83.55894934799994, 62.75071849200003],
              [-83.54450436099995, 62.77391185100004],
              [-83.5344945949999, 62.80801015800006],
              [-83.51984615799995, 62.82636139500005],
              [-83.48086503799993, 62.84552643400008],
              [-83.44273841099994, 62.878119208000044],
              [-83.41869055899991, 62.892279364000046],
              [-83.29645748599995, 62.930894273000035],
              [-83.28742428299995, 62.93154531500005],
              [-83.28018144399994, 62.92475006700005],
              [-83.27261308499993, 62.919989325000074],
              [-83.26353919199994, 62.91787344000005],
              [-83.23058020699995, 62.915676174000055],
              [-83.20881100199995, 62.90851471600007],
              [-83.19139563699991, 62.895819403000075],
              [-83.17137610599991, 62.87689850500004],
              [-83.11888587099992, 62.84723541900007],
              [-83.06041419199994, 62.84198639500005],
              [-83.00096594999991, 62.85236237200007],
              [-82.73936926999994, 62.938381252000056],
              [-82.69546464799993, 62.94521719000005],
              [-82.60594641799992, 62.94603099200003],
              [-82.42048092399995, 62.92796458500004],
              [-82.3762914699999, 62.938381252000056],
              [-82.38101152299993, 62.94708893400008],
              [-82.3821508449999, 62.954779364000046],
              [-82.37877356699994, 62.96112702000005],
              [-82.37002519399994, 62.96564362200007],
              [-82.3762914699999, 62.96564362200007],
              [-82.35309811099995, 62.966009833000044],
              [-82.32713782499991, 62.97138092700004],
              [-82.30186926999994, 62.98004791900007],
              [-82.28066972599993, 62.98981354400007],
              [-82.25719153599994, 62.99555084800005],
              [-82.20815995999993, 62.98688385600008],
              [-82.18443762899994, 62.98615143400008],
              [-82.19131425699993, 62.98615143400008],
            ],
          ],
          [
            [
              [-90.62022864499994, 63.47955963700008],
              [-90.61465410099993, 63.47553131700005],
              [-90.61082923099991, 63.47150299700007],
              [-90.60655676999994, 63.46816640800006],
              [-90.59976152299993, 63.46653880400004],
              [-90.61554928299995, 63.44912344000005],
              [-90.64293372299994, 63.44318268400008],
              [-90.70221920499995, 63.44489166900007],
              [-90.71987870999993, 63.45075104400007],
              [-90.73452714799993, 63.46523672100005],
              [-90.75682532499991, 63.500067450000074],
              [-90.72264563699991, 63.49941640800006],
              [-90.65111243399991, 63.490301825000074],
              [-90.62022864499994, 63.47955963700008],
            ],
          ],
          [
            [
              [-77.53799394399994, 63.28778717700004],
              [-77.52358964799993, 63.284491278000075],
              [-77.50597083199995, 63.28237539300005],
              [-77.49596106699994, 63.27606842700004],
              [-77.50450598899994, 63.26048411700003],
              [-77.54954993399991, 63.22752513200004],
              [-77.56749426999994, 63.20722077000005],
              [-77.55968176999994, 63.19159577000005],
              [-77.55968176999994, 63.184759833000044],
              [-77.64483944599993, 63.14316963600004],
              [-77.70831176099995, 63.12700401800004],
              [-77.75878620899994, 63.11035782600004],
              [-77.82453609099991, 63.10221106000006],
              [-77.8895075179999, 63.08873679200008],
              [-77.94076413499994, 63.08714883300007],
              [-77.95889238199993, 63.09943268400008],
              [-78.04572506399995, 63.130113023000035],
              [-78.04434160099993, 63.144232489000046],
              [-78.06432044199994, 63.15033600500004],
              [-78.09105383999992, 63.15403880400004],
              [-78.11025956899994, 63.16120026200008],
              [-78.12669837099992, 63.17446523600006],
              [-78.14976966099994, 63.189113674000055],
              [-78.17381751199991, 63.20099518400008],
              [-78.20856686099995, 63.210150458000044],
              [-78.24791419199994, 63.23261139500005],
              [-78.31550045499995, 63.28192780200004],
              [-78.34203040299991, 63.29238515800006],
              [-78.45665442599994, 63.356675523000035],
              [-78.49819902299993, 63.36969635600008],
              [-78.50918535099993, 63.374986070000034],
              [-78.53172766799992, 63.39020416900007],
              [-78.51123740899993, 63.41069388800008],
              [-78.53304988199994, 63.418288102000076],
              [-78.52474875799993, 63.43198569200007],
              [-78.54427181499995, 63.44918435000005],
              [-78.5185034459999, 63.48501906800004],
              [-78.48481315299995, 63.511106092000034],
              [-78.44054470599991, 63.51938713000004],
              [-78.41438011799994, 63.493150040000046],
              [-78.37981091199993, 63.455132752000054],
              [-78.27829573199995, 63.48229066000005],
              [-78.18635006399995, 63.49323151200008],
              [-78.16026770699995, 63.48965078300006],
              [-78.10680091099994, 63.474676825000074],
              [-78.07982337099992, 63.47280508000006],
              [-78.05890865799995, 63.48379140800006],
              [-78.04881751199991, 63.48582591400003],
              [-77.99083411399994, 63.47955963700008],
              [-77.89561926999994, 63.48004791900007],
              [-77.84430904899995, 63.47247955900008],
              [-77.81920325399994, 63.452337958000044],
              [-77.82848059799994, 63.45058828300006],
              [-77.83438066299993, 63.448146877000056],
              [-77.84707597599993, 63.438666083000044],
              [-77.82640540299991, 63.432074286000045],
              [-77.80345618399991, 63.42763906500005],
              [-77.75804602799991, 63.42438385600008],
              [-77.73965410099993, 63.42715078300006],
              [-77.70327714799993, 63.43817780200004],
              [-77.68260657499991, 63.438666083000044],
              [-77.68443762899994, 63.434027411000045],
              [-77.68691972599993, 63.42279694200005],
              [-77.68883216099994, 63.41815827000005],
              [-77.67373613199993, 63.41852448100008],
              [-77.65957597599993, 63.41592031500005],
              [-77.64639238199993, 63.41083405200004],
              [-77.63418535099993, 63.40387604400007],
              [-77.64073645699995, 63.40338776200008],
              [-77.65465247299994, 63.397650458000044],
              [-77.64757239499994, 63.39594147300005],
              [-77.63540605399993, 63.39130280200004],
              [-77.62734941299993, 63.39020416900007],
              [-77.63072669199994, 63.386379299000055],
              [-77.63292395699995, 63.38275788000004],
              [-77.63585364499994, 63.37929922100005],
              [-77.64171301999994, 63.37592194200005],
              [-77.62832597599993, 63.35521067900004],
              [-77.6055395169999, 63.34218984600005],
              [-77.57933508999992, 63.33161041900007],
              [-77.55601966099994, 63.31826406500005],
              [-77.54991614499994, 63.31037018400008],
              [-77.54385331899994, 63.294175523000035],
              [-77.53799394399994, 63.28778717700004],
            ],
          ],
          [
            [
              [-90.67487545499995, 63.521185614000046],
              [-90.68858801999994, 63.51040273600006],
              [-90.7058813139999, 63.50893789300005],
              [-90.7434789699999, 63.513739325000074],
              [-90.76203365799995, 63.51162344000005],
              [-90.79308020699995, 63.50218333500004],
              [-90.81175696499992, 63.500067450000074],
              [-90.85057532499991, 63.50690338700008],
              [-90.93004309799994, 63.538723049000055],
              [-90.96971594999991, 63.548529364000046],
              [-90.96971594999991, 63.554754950000074],
              [-90.76366126199991, 63.527411200000074],
              [-90.78189042899993, 63.53534577000005],
              [-90.78990637899994, 63.54096100500004],
              [-90.79775956899994, 63.548529364000046],
              [-90.77965247299994, 63.55353424700007],
              [-90.76130123599995, 63.553941148000035],
              [-90.72329667899993, 63.548529364000046],
              [-90.68618730399993, 63.53034088700008],
              [-90.67487545499995, 63.521185614000046],
            ],
          ],
          [
            [
              [-91.46312415299991, 63.61676666900007],
              [-91.44664466099994, 63.609442450000074],
              [-91.39928137899994, 63.59760163000004],
              [-91.35948645699995, 63.59271881700005],
              [-91.29865475199995, 63.56777578300006],
              [-91.41470292899993, 63.56777578300006],
              [-91.40111243399991, 63.554754950000074],
              [-91.4168188139999, 63.55385976800005],
              [-91.43553626199991, 63.55499909100007],
              [-91.45335852799991, 63.558579820000034],
              [-91.46654212099992, 63.56492747600004],
              [-91.47288977799991, 63.57436758000006],
              [-91.47598222599993, 63.584418036000045],
              [-91.48208574099993, 63.59243398600006],
              [-91.49730383999992, 63.59564850500004],
              [-91.50865637899994, 63.59682851800005],
              [-91.52578691299993, 63.600490627000056],
              [-91.5391332669999, 63.60700104400007],
              [-91.53888912699995, 63.61676666900007],
              [-91.52586829299992, 63.61961497600004],
              [-91.46312415299991, 63.61676666900007],
            ],
          ],
          [
            [
              [-64.08641516799992, 63.33502838700008],
              [-64.09919186099995, 63.32184479400007],
              [-64.08975175699993, 63.30805084800005],
              [-64.07209225199995, 63.292669989000046],
              [-64.05972245999993, 63.27480703300006],
              [-64.09316972599993, 63.28025950700004],
              [-64.15957597599993, 63.32021719000005],
              [-64.18260657499991, 63.32135651200008],
              [-64.17275956899994, 63.31492747600004],
              [-64.16885331899994, 63.30853913000004],
              [-64.17267818899995, 63.30345286700003],
              [-64.18578040299991, 63.30145905200004],
              [-64.19994055899991, 63.30459219000005],
              [-64.22350012899994, 63.31826406500005],
              [-64.25885982999995, 63.32721588700008],
              [-64.27920488199993, 63.341131903000075],
              [-64.31236731699994, 63.36969635600008],
              [-64.31745357999995, 63.37514883000006],
              [-64.32217363199993, 63.382025458000044],
              [-64.32909094999991, 63.38776276200008],
              [-64.34032141799992, 63.39020416900007],
              [-64.35155188699991, 63.39472077000005],
              [-64.35619055899991, 63.40534088700008],
              [-64.35875403599994, 63.41779205900008],
              [-64.36388098899994, 63.427720445000034],
              [-64.36839758999992, 63.43073151200008],
              [-64.37254798099991, 63.43227773600006],
              [-64.37657630099994, 63.43427155200004],
              [-64.38060462099992, 63.438666083000044],
              [-64.38727779899995, 63.45026276200008],
              [-64.38805091099994, 63.452337958000044],
              [-64.40094967399995, 63.46507396000004],
              [-64.40973873599995, 63.470363674000055],
              [-64.42223059799994, 63.47280508000006],
              [-64.40615800699993, 63.480536200000074],
              [-64.38805091099994, 63.48582591400003],
              [-64.39321855399993, 63.48725006700005],
              [-64.40330969999991, 63.49168528900003],
              [-64.40855872299994, 63.49323151200008],
              [-64.40697180899991, 63.511379299000055],
              [-64.41779537699995, 63.53156159100007],
              [-64.43517005099994, 63.54791901200008],
              [-64.45323645699995, 63.554754950000074],
              [-64.46377519399994, 63.56268952000005],
              [-64.48521887899994, 63.60195547100005],
              [-64.49791419199994, 63.61676666900007],
              [-64.48688717399995, 63.62645091400003],
              [-64.47716223899994, 63.63768138200004],
              [-64.46495520699995, 63.64704010600008],
              [-64.44640051999994, 63.65086497600004],
              [-64.42788652299993, 63.65176015800006],
              [-64.40802975199995, 63.65525950700004],
              [-64.39439856699994, 63.663275458000044],
              [-64.39492753799993, 63.67763906500005],
              [-64.37466386599993, 63.67670319200005],
              [-64.35488847599993, 63.668850002000056],
              [-64.33800208199995, 63.65692780200004],
              [-64.32603919199994, 63.64411041900007],
              [-64.32225501199991, 63.59406159100007],
              [-64.31602942599994, 63.57367584800005],
              [-64.30553137899994, 63.554754950000074],
              [-64.29185950399994, 63.535589911000045],
              [-64.28189042899993, 63.51630280200004],
              [-64.28376217399995, 63.49900950700004],
              [-64.30553137899994, 63.48582591400003],
              [-64.28571529899995, 63.47919342700004],
              [-64.27354895699995, 63.47089264500005],
              [-64.25157630099994, 63.44489166900007],
              [-64.27301998599995, 63.44489166900007],
              [-64.28307044199994, 63.44281647300005],
              [-64.29255123599995, 63.438666083000044],
              [-64.28209387899994, 63.43073151200008],
              [-64.27171790299991, 63.42845286700003],
              [-64.26138261599993, 63.427720445000034],
              [-64.25157630099994, 63.42438385600008],
              [-64.24502519399994, 63.419175523000035],
              [-64.23045813699991, 63.40387604400007],
              [-64.23053951699995, 63.40298086100006],
              [-64.22862708199995, 63.39940013200004],
              [-64.22419186099995, 63.39476146000004],
              [-64.21678626199991, 63.39020416900007],
              [-64.20864824099993, 63.38959381700005],
              [-64.19579016799992, 63.39720286700003],
              [-64.18883216099994, 63.397650458000044],
              [-64.18252519399994, 63.39337799700007],
              [-64.16905676999994, 63.37592194200005],
              [-64.16836503799993, 63.373480536000045],
              [-64.16954505099994, 63.36546458500004],
              [-64.16905676999994, 63.362941799000055],
              [-64.16515051999994, 63.361314195000034],
              [-64.15314693899995, 63.35895416900007],
              [-64.11888587099992, 63.341457424000055],
              [-64.10228430899991, 63.336371161000045],
              [-64.08641516799992, 63.33502838700008],
            ],
          ],
          [
            [
              [-76.68887285099993, 63.48582591400003],
              [-76.65835527299993, 63.47724030200004],
              [-76.58018958199995, 63.47553131700005],
              [-76.54491126199991, 63.46653880400004],
              [-76.54930579299992, 63.46173737200007],
              [-76.55382239499994, 63.45966217700004],
              [-76.5716039699999, 63.45913320500006],
              [-76.60924231699994, 63.434800523000035],
              [-76.62946529899995, 63.42963288000004],
              [-76.65477454299992, 63.438666083000044],
              [-76.65477454299992, 63.43121979400007],
              [-76.63878333199995, 63.41950104400007],
              [-76.65245520699995, 63.399725653000075],
              [-76.67910722599993, 63.38027578300006],
              [-76.70197506399995, 63.36969635600008],
              [-76.72549394399994, 63.36908600500004],
              [-76.77049719999991, 63.38031647300005],
              [-76.83104407499991, 63.385931708000044],
              [-76.85016842399995, 63.39020416900007],
              [-76.86644446499992, 63.397650458000044],
              [-76.86607825399994, 63.40814850500004],
              [-76.89000403599994, 63.41193268400008],
              [-76.94554602799991, 63.411322333000044],
              [-76.97061113199993, 63.40688711100006],
              [-76.98208574099993, 63.40729401200008],
              [-77.00389563699991, 63.42059967700004],
              [-77.03831946499992, 63.43121979400007],
              [-77.06627356699994, 63.452337958000044],
              [-77.09471594999991, 63.46430084800005],
              [-77.15611731699994, 63.500433661000045],
              [-77.16185462099992, 63.507513739000046],
              [-77.17845618399991, 63.50726959800005],
              [-77.19469153599994, 63.509466864000046],
              [-77.20995032499991, 63.514105536000045],
              [-77.22329667899993, 63.521185614000046],
              [-77.2278539699999, 63.52293528900003],
              [-77.23839270699995, 63.524725653000075],
              [-77.24376380099994, 63.527411200000074],
              [-77.24437415299991, 63.52997467700004],
              [-77.24323482999995, 63.53851959800005],
              [-77.24376380099994, 63.541001695000034],
              [-77.25283769399994, 63.549261786000045],
              [-77.25763912699995, 63.55109284100007],
              [-77.26427161399994, 63.548529364000046],
              [-77.2884008449999, 63.56049225500004],
              [-77.37352454299992, 63.58197663000004],
              [-77.37071692599994, 63.58588288000004],
              [-77.36778723899994, 63.58771393400008],
              [-77.36046301999994, 63.58942291900007],
              [-77.41828365799995, 63.59064362200007],
              [-77.4356176419999, 63.59564850500004],
              [-77.42772376199991, 63.59910716400003],
              [-77.41966712099992, 63.60138580900008],
              [-77.41100012899994, 63.60248444200005],
              [-77.40147864499994, 63.60248444200005],
              [-77.42052161399994, 63.604681708000044],
              [-77.43687903599994, 63.61188385600008],
              [-77.44139563699991, 63.61945221600007],
              [-77.42503821499992, 63.62299225500004],
              [-77.33315995999993, 63.62299225500004],
              [-77.33315995999993, 63.63043854400007],
              [-77.41344153599994, 63.63271719000005],
              [-77.44810950399994, 63.64166901200008],
              [-77.44611568899995, 63.66111888200004],
              [-77.42381751199991, 63.678900458000044],
              [-77.39696204299992, 63.693426825000074],
              [-77.36644446499992, 63.70140208500004],
              [-77.33315995999993, 63.699286200000074],
              [-77.28770911399994, 63.68569570500006],
              [-77.19603430899991, 63.68504466400003],
              [-77.1790258449999, 63.68187083500004],
              [-77.15070553299995, 63.66771067900004],
              [-77.13735917899993, 63.66453685100004],
              [-77.11156165299991, 63.66583893400008],
              [-77.10619055899991, 63.669623114000046],
              [-77.12026933499993, 63.67763906500005],
              [-77.12026933499993, 63.68504466400003],
              [-76.70933997299994, 63.56777578300006],
              [-76.7188207669999, 63.56329987200007],
              [-76.72240149599992, 63.562201239000046],
              [-76.70726477799991, 63.54588450700004],
              [-76.67894446499992, 63.535142320000034],
              [-76.64761308499993, 63.52920156500005],
              [-76.62340247299994, 63.527411200000074],
              [-76.61782792899993, 63.52167389500005],
              [-76.68887285099993, 63.48582591400003],
            ],
          ],
          [
            [
              [-72.47443600199995, 63.705511786000045],
              [-72.45982825399994, 63.687933661000045],
              [-72.47130286399994, 63.67560455900008],
              [-72.49120032499991, 63.67218659100007],
              [-72.50169837099992, 63.681341864000046],
              [-72.51341712099992, 63.694525458000044],
              [-72.54039466099994, 63.694525458000044],
              [-72.5703832669999, 63.68699778900003],
              [-72.5911352199999, 63.67763906500005],
              [-72.57917232999995, 63.67340729400007],
              [-72.55451412699995, 63.66864655200004],
              [-72.54271399599992, 63.66453685100004],
              [-72.59972083199995, 63.64667389500005],
              [-72.62987219999991, 63.64642975500004],
              [-72.67959550699993, 63.67206452000005],
              [-72.71349036399994, 63.67206452000005],
              [-72.78286699099993, 63.66453685100004],
              [-72.78286699099993, 63.67137278900003],
              [-72.50059973899994, 63.71279531500005],
              [-72.47443600199995, 63.705511786000045],
            ],
          ],
          [
            [
              [-92.97765051999994, 63.90420156500005],
              [-92.96446692599994, 63.88963450700004],
              [-92.96153723899994, 63.87938060100004],
              [-92.97166907499991, 63.874660549000055],
              [-93.05223548099991, 63.88654205900008],
              [-93.07957923099991, 63.89622630400004],
              [-93.09365800699993, 63.91095612200007],
              [-92.9968969389999, 63.91323476800005],
              [-92.97765051999994, 63.90420156500005],
            ],
          ],
          [
            [
              [-64.88833574099993, 63.794907945000034],
              [-64.91649329299992, 63.82367584800005],
              [-64.89329993399991, 63.84662506700005],
              [-64.81261145699995, 63.883693752000056],
              [-64.78697669199994, 63.85333893400008],
              [-64.77245032499991, 63.84125397300005],
              [-64.75121008999992, 63.82843659100007],
              [-64.74998938699991, 63.83930084800005],
              [-64.75625566299993, 63.84935130400004],
              [-64.76683508999992, 63.85765208500004],
              [-64.77847245999993, 63.86318594000005],
              [-64.77061926999994, 63.87441640800006],
              [-64.75780188699991, 63.878241278000075],
              [-64.74339758999992, 63.87612539300005],
              [-64.73078365799995, 63.86937083500004],
              [-64.72899329299992, 63.90265534100007],
              [-64.68748938699991, 63.917629299000055],
              [-64.64370683499993, 63.91543203300006],
              [-64.63512122299994, 63.897365627000056],
              [-64.61384029899995, 63.886053778000075],
              [-64.56257076699995, 63.90859609600005],
              [-64.55256100199995, 63.897365627000056],
              [-64.56427975199995, 63.88434479400007],
              [-64.59581458199995, 63.85797760600008],
              [-64.60716712099992, 63.84271881700005],
              [-64.55540930899991, 63.85179271000004],
              [-64.52721106699994, 63.85106028900003],
              [-64.50475012899994, 63.84271881700005],
              [-64.56371008999992, 63.803900458000044],
              [-64.59788977799991, 63.794989325000074],
              [-64.61339270699995, 63.78750234600005],
              [-64.59528561099995, 63.78766510600008],
              [-64.55504309799994, 63.78021881700005],
              [-64.53892981699994, 63.77440013200004],
              [-64.51406816299993, 63.75665924700007],
              [-64.50108801999994, 63.751166083000044],
              [-64.48428300699993, 63.753973700000074],
              [-64.47166907499991, 63.76398346600007],
              [-64.45933997299994, 63.77692291900007],
              [-64.44399980399993, 63.785223700000074],
              [-64.42223059799994, 63.781236070000034],
              [-64.41437740799995, 63.773504950000074],
              [-64.38805091099994, 63.732855536000045],
              [-64.40855872299994, 63.732855536000045],
              [-64.39854895699995, 63.71556224200003],
              [-64.39354407499991, 63.700832424000055],
              [-64.40111243399991, 63.68821849200003],
              [-64.42906653599994, 63.67763906500005],
              [-64.44273841099994, 63.67617422100005],
              [-64.45767167899993, 63.677394924000055],
              [-64.47215735599991, 63.680568752000056],
              [-64.48428300699993, 63.68504466400003],
              [-64.49364173099991, 63.692572333000044],
              [-64.51463782499991, 63.71507396000004],
              [-64.52183997299994, 63.71979401200008],
              [-64.57616126199991, 63.72601959800005],
              [-64.58429928299995, 63.72919342700004],
              [-64.58995520699995, 63.73627350500004],
              [-64.59813391799992, 63.743353583000044],
              [-64.64232337099992, 63.75250885600008],
              [-64.68224036399994, 63.77993398600006],
              [-64.70274817599994, 63.78705475500004],
              [-64.72622636599993, 63.784084377000056],
              [-64.76895097599993, 63.77008698100008],
              [-64.79214433499993, 63.767564195000034],
              [-64.84142005099994, 63.77753327000005],
              [-64.88833574099993, 63.794907945000034],
            ],
          ],
          [
            [
              [-77.97337805899991, 63.96556224200003],
              [-77.98330644399994, 63.97247955900008],
              [-77.97630774599992, 63.98810455900008],
              [-77.96178137899994, 64.00458405200004],
              [-77.94945227799991, 64.01406484600005],
              [-77.92918860599991, 64.02033112200007],
              [-77.90538489499994, 64.02448151200008],
              [-77.86074785099993, 64.02765534100007],
              [-77.79137122299994, 64.02081940300008],
              [-77.77074133999992, 64.02765534100007],
              [-77.77818762899994, 64.03510163000004],
              [-77.59569251199991, 64.04116445500006],
              [-77.54548092399995, 64.02765534100007],
              [-77.54548092399995, 64.02081940300008],
              [-77.59019934799994, 64.01996491100005],
              [-77.60936438699991, 64.01422760600008],
              [-77.62734941299993, 64.00096263200004],
              [-77.64464270699995, 63.982489325000074],
              [-77.71031653599994, 63.94232819200005],
              [-77.73721269399994, 63.932074286000045],
              [-77.75658118399991, 63.931626695000034],
              [-77.78945878799993, 63.94277578300006],
              [-77.92080644399994, 63.95538971600007],
              [-77.95787512899994, 63.96381256700005],
              [-77.97337805899991, 63.96556224200003],
            ],
          ],
          [
            [
              [-81.4688207669999, 64.19155508000006],
              [-81.51699785099993, 64.19672272300005],
              [-81.53880774599992, 64.20636627800008],
              [-81.53677324099993, 64.22321198100008],
              [-81.49913489499994, 64.23676178600005],
              [-81.44204667899993, 64.23822663000004],
              [-81.39378821499992, 64.22972239800004],
              [-81.38255774599992, 64.21320221600007],
              [-81.39940344999991, 64.20319245000007],
              [-81.42308508999992, 64.19647858300004],
              [-81.4688207669999, 64.19155508000006],
            ],
          ],
          [
            [
              [-73.27635657499991, 64.21942780200004],
              [-73.25059973899994, 64.21198151200008],
              [-73.19798743399991, 64.21369049700007],
              [-73.17332923099991, 64.20579661700003],
              [-73.19489498599995, 64.19696686400005],
              [-73.21914628799993, 64.19049713700008],
              [-73.26891028599994, 64.18537018400008],
              [-73.26577714799993, 64.18195221600007],
              [-73.26329505099994, 64.17845286700003],
              [-73.26024329299992, 64.17499420800004],
              [-73.25523841099994, 64.17169830900008],
              [-73.27635657499991, 64.15102773600006],
              [-73.28726152299993, 64.14769114800004],
              [-73.29963131399995, 64.15460846600007],
              [-73.31334387899994, 64.15985748900005],
              [-73.33096269399994, 64.15766022300005],
              [-73.34927324099993, 64.15302155200004],
              [-73.36510169199994, 64.15119049700007],
              [-73.36510169199994, 64.15802643400008],
              [-73.35533606699994, 64.15843333500004],
              [-73.34829667899993, 64.16079336100006],
              [-73.34288489499994, 64.16510651200008],
              [-73.33775794199994, 64.17169830900008],
              [-73.35435950399994, 64.17206452000005],
              [-73.39981035099993, 64.16486237200007],
              [-73.39110266799992, 64.18032461100006],
              [-73.38621985599991, 64.18537018400008],
              [-73.39118404899995, 64.19623444200005],
              [-73.37376868399991, 64.19647858300004],
              [-73.33096269399994, 64.19155508000006],
              [-73.31484941299993, 64.20091380400004],
              [-73.31212317599994, 64.21393463700008],
              [-73.32042395699995, 64.22630442900004],
              [-73.33775794199994, 64.23379140800006],
              [-73.33775794199994, 64.23993561400005],
              [-73.26207434799994, 64.23993561400005],
              [-73.26207434799994, 64.23379140800006],
              [-73.2669164699999, 64.23419830900008],
              [-73.26797441299993, 64.23257070500006],
              [-73.26781165299991, 64.22988515800006],
              [-73.26891028599994, 64.22687409100007],
              [-73.27635657499991, 64.21942780200004],
            ],
          ],
          [
            [
              [-73.52961178299995, 64.50405508000006],
              [-73.52415930899991, 64.49262116100005],
              [-73.51219641799992, 64.48725006700005],
              [-73.50023352799991, 64.48334381700005],
              [-73.49486243399991, 64.47646719000005],
              [-73.49689693899995, 64.44790273600006],
              [-73.50487219999991, 64.43252187700006],
              [-73.52163652299993, 64.42279694200005],
              [-73.5501195949999, 64.41128164300005],
              [-73.5449926419999, 64.39301178600005],
              [-73.54564368399991, 64.37889232000003],
              [-73.53986568899995, 64.37075429900005],
              [-73.51528886599993, 64.37030670800004],
              [-73.53359941299993, 64.36107005400004],
              [-73.55549068899995, 64.35443756700005],
              [-73.57453365799995, 64.34540436400005],
              [-73.58421790299991, 64.32933177300004],
              [-73.57306881399995, 64.32998281500005],
              [-73.56566321499992, 64.32831452000005],
              [-73.56045488199993, 64.32363515800006],
              [-73.55626380099994, 64.31500885600008],
              [-73.60826575399994, 64.31370677300004],
              [-73.64647376199991, 64.31879303600005],
              [-73.65420488199993, 64.32322825700004],
              [-73.65477454299992, 64.39248281500005],
              [-73.66075598899994, 64.41278717700004],
              [-73.67357337099992, 64.43170807500007],
              [-73.65330969999991, 64.44428131700005],
              [-73.6406957669999, 64.44989655200004],
              [-73.62580318899995, 64.45221588700008],
              [-73.61363684799994, 64.45087311400005],
              [-73.59097245999993, 64.44594961100006],
              [-73.57799231699994, 64.44599030200004],
              [-73.57799231699994, 64.45221588700008],
              [-73.59093176999994, 64.46295807500007],
              [-73.60484778599994, 64.47825755400004],
              [-73.60545813699991, 64.48924388200004],
              [-73.57799231699994, 64.48700592700004],
              [-73.57799231699994, 64.49315013200004],
              [-73.65713456899994, 64.50275299700007],
              [-73.67357337099992, 64.50747304900005],
              [-73.68419348899994, 64.52480703300006],
              [-73.67100989499994, 64.53449127800008],
              [-73.63573157499991, 64.54498932500007],
              [-73.60879472599993, 64.56045156500005],
              [-73.57103430899991, 64.56757233300004],
              [-73.53400631399995, 64.56614817900004],
              [-73.5091039699999, 64.55585358300004],
              [-73.50865637899994, 64.54425690300008],
              [-73.50670325399994, 64.53949616100005],
              [-73.50230872299994, 64.53473541900007],
              [-73.5091039699999, 64.53473541900007],
              [-73.50230872299994, 64.52798086100006],
              [-73.51748613199993, 64.51862213700008],
              [-73.52586829299992, 64.51154205900008],
              [-73.52961178299995, 64.50405508000006],
            ],
          ],
          [
            [
              [-65.54625403599994, 64.54840729400007],
              [-65.52603105399993, 64.53709544500003],
              [-65.50169837099992, 64.53339264500005],
              [-65.45067298099991, 64.53473541900007],
              [-65.47313391799992, 64.52277252800008],
              [-65.50145423099991, 64.51919179900005],
              [-65.55964107999995, 64.52114492400005],
              [-65.65957597599993, 64.50885651200008],
              [-65.68346106699994, 64.51496002800008],
              [-65.68814042899993, 64.54759349200003],
              [-65.65404212099992, 64.58075592700004],
              [-65.60635331899994, 64.60639069200005],
              [-65.54987545499995, 64.62274811400005],
              [-65.49791419199994, 64.66571686400005],
              [-65.45836341099994, 64.67951080900008],
              [-65.44273841099994, 64.69000885600008],
              [-65.42894446499992, 64.72915273600006],
              [-65.41193600199995, 64.73981354400007],
              [-65.39346269399994, 64.73948802300004],
              [-65.38182532499991, 64.72589752800008],
              [-65.38345292899993, 64.71165599200003],
              [-65.40908769399994, 64.65827057500007],
              [-65.39293372299994, 64.65314362200007],
              [-65.38097083199995, 64.66461823100008],
              [-65.36070716099994, 64.69928620000007],
              [-65.34679114499994, 64.71116771000004],
              [-65.30980383999992, 64.73403554900005],
              [-65.29308020699995, 64.74022044500003],
              [-65.29881751199991, 64.72260163000004],
              [-65.28892981699994, 64.71474844000005],
              [-65.27065995999993, 64.71271393400008],
              [-65.25145423099991, 64.71287669500003],
              [-65.26512610599991, 64.69928620000007],
              [-65.31354732999995, 64.66571686400005],
              [-65.27892005099994, 64.66779205900008],
              [-65.26598059799994, 64.66547272300005],
              [-65.25145423099991, 64.65827057500007],
              [-65.25365149599992, 64.65448639500005],
              [-65.25373287699995, 64.64500560100004],
              [-65.25007076699995, 64.63784414300005],
              [-65.23497473899994, 64.64386627800008],
              [-65.22642981699994, 64.64496491100005],
              [-65.20982825399994, 64.64398834800005],
              [-65.21670488199993, 64.63068268400008],
              [-65.22834225199995, 64.62494538000004],
              [-65.27489173099991, 64.62299225500004],
              [-65.28612219999991, 64.61981842700004],
              [-65.30606035099993, 64.61050039300005],
              [-65.33706620999993, 64.60407135600008],
              [-65.4075414699999, 64.59975820500006],
              [-65.43643144399994, 64.59003327000005],
              [-65.41930091099994, 64.58323802300004],
              [-65.39976966099994, 64.58136627800008],
              [-65.36070716099994, 64.58258698100008],
              [-65.39093990799995, 64.56207916900007],
              [-65.44448808499993, 64.55198802300004],
              [-65.54625403599994, 64.54840729400007],
            ],
          ],
          [
            [
              [-62.25723222599993, 65.74823639500005],
              [-62.24982662699995, 65.74823639500005],
              [-62.24982662699995, 65.74079010600008],
              [-62.25694739499994, 65.73822663000004],
              [-62.25967363199993, 65.73501211100006],
              [-62.259429490999935, 65.73289622600004],
              [-62.29820716099994, 65.71344635600008],
              [-62.264515753999945, 65.70734284100007],
              [-62.19884192599994, 65.71369049700007],
              [-62.16787675699993, 65.70600006700005],
              [-62.18455969999991, 65.69822825700004],
              [-62.202015753999945, 65.69301992400005],
              [-62.202015753999945, 65.68618398600006],
              [-62.18260657499991, 65.69277578300006],
              [-62.16283118399991, 65.69269440300008],
              [-62.1438695949999, 65.68768952000005],
              [-62.126942511999914, 65.67934804900005],
              [-62.14053300699993, 65.67251211100006],
              [-62.13438880099994, 65.65452708500004],
              [-62.154286261999914, 65.64887116100005],
              [-62.18272864499994, 65.64817942900004],
              [-62.202015753999945, 65.64520905200004],
              [-62.19277910099993, 65.63751862200007],
              [-62.18968665299991, 65.63031647300005],
              [-62.191965298999946, 65.62274811400005],
              [-62.19859778599994, 65.61416250200006],
              [-62.20885169199994, 65.60952383000006],
              [-62.219309048999946, 65.61359284100007],
              [-62.229725714999915, 65.62042877800008],
              [-62.23985755099994, 65.62409088700008],
              [-62.25169837099992, 65.63349030200004],
              [-62.25845292899993, 65.65167877800008],
              [-62.26622473899994, 65.66380442900004],
              [-62.28087317599994, 65.65509674700007],
              [-62.30223548099991, 65.62547435100004],
              [-62.31810462099992, 65.61517975500004],
              [-62.3391820949999, 65.61790599200003],
              [-62.34862219999991, 65.63011302300004],
              [-62.33836829299992, 65.64325592700004],
              [-62.321522589999915, 65.65542226800005],
              [-62.31126868399991, 65.66502513200004],
              [-62.32262122299994, 65.66278717700004],
              [-62.34129798099991, 65.65473053600005],
              [-62.35220292899993, 65.65135325700004],
              [-62.36310787699995, 65.65086497600004],
              [-62.38231360599991, 65.65338776200008],
              [-62.393788214999915, 65.65135325700004],
              [-62.3919164699999, 65.65631745000007],
              [-62.38890540299991, 65.66754791900007],
              [-62.38703365799995, 65.67251211100006],
              [-62.40664628799993, 65.66811758000006],
              [-62.46955318899995, 65.66502513200004],
              [-62.465687628999945, 65.67340729400007],
              [-62.45946204299992, 65.67975495000007],
              [-62.45132402299993, 65.68402741100005],
              [-62.44163977799991, 65.68618398600006],
              [-62.44163977799991, 65.69301992400005],
              [-62.45685787699995, 65.69940827000005],
              [-62.47423255099994, 65.70970286700003],
              [-62.48570716099994, 65.72370026200008],
              [-62.48322506399995, 65.74079010600008],
              [-62.469634568999936, 65.74884674700007],
              [-62.45034745999993, 65.74884674700007],
              [-62.414906378999945, 65.74079010600008],
              [-62.408314581999946, 65.74201080900008],
              [-62.40269934799994, 65.74591705900008],
              [-62.39708411399994, 65.74819570500006],
              [-62.39037024599992, 65.74453359600005],
              [-62.38914954299992, 65.74144114800004],
              [-62.38634192599994, 65.73016998900005],
              [-62.38703365799995, 65.72772858300004],
              [-62.37124589799993, 65.72772858300004],
              [-62.360585089999915, 65.73069896000004],
              [-62.3391820949999, 65.74079010600008],
              [-62.31908118399991, 65.74656810100004],
              [-62.30211341099994, 65.74868398600006],
              [-62.25723222599993, 65.74823639500005],
            ],
          ],
          [
            [
              [-83.50340735599991, 65.80971914300005],
              [-83.53819739499994, 65.81928131700005],
              [-83.57241777299993, 65.84039948100008],
              [-83.58250891799992, 65.86151764500005],
              [-83.54474850199995, 65.87107982000003],
              [-83.36937415299991, 65.87107982000003],
              [-83.32787024599992, 65.86343008000006],
              [-83.30654863199993, 65.85643138200004],
              [-83.29116777299993, 65.84686920800004],
              [-83.28954016799992, 65.83519114800004],
              [-83.30923417899993, 65.83234284100007],
              [-83.35016842399995, 65.83698151200008],
              [-83.41315670499995, 65.83527252800008],
              [-83.43211829299992, 65.83014557500007],
              [-83.43919837099992, 65.82538483300004],
              [-83.45474199099993, 65.81232330900008],
              [-83.46312415299991, 65.80971914300005],
              [-83.50340735599991, 65.80971914300005],
            ],
          ],
          [
            [
              [-80.18333899599992, 63.767564195000034],
              [-80.18297278599994, 63.75625234600005],
              [-80.19635982999995, 63.75291575700004],
              [-80.23180091099994, 63.753973700000074],
              [-80.28209387899994, 63.742173570000034],
              [-80.46642005099994, 63.72728099200003],
              [-80.47891191299993, 63.721909898000035],
              [-80.49185136599993, 63.71234772300005],
              [-80.50381425699993, 63.69350820500006],
              [-80.51268469999991, 63.682521877000056],
              [-80.52257239499994, 63.67763906500005],
              [-80.53237870999993, 63.67475006700005],
              [-80.56216386599993, 63.660223700000074],
              [-80.5847875639999, 63.64297109600005],
              [-80.5977270169999, 63.63686758000006],
              [-80.62901770699995, 63.63043854400007],
              [-80.72842363199993, 63.58844635600008],
              [-80.77403723899994, 63.577785549000055],
              [-80.80040442599994, 63.55898672100005],
              [-80.81362870999993, 63.554754950000074],
              [-80.82144120999993, 63.553168036000045],
              [-80.82730058499993, 63.54913971600007],
              [-80.83788001199991, 63.53758372600004],
              [-80.84459387899994, 63.53412506700005],
              [-80.85265051999994, 63.53375885600008],
              [-80.86119544199994, 63.534491278000075],
              [-80.90208899599992, 63.53302643400008],
              [-80.91808020699995, 63.53009674700007],
              [-80.93065344999991, 63.521185614000046],
              [-80.93455969999991, 63.51056549700007],
              [-80.93578040299991, 63.49677155200004],
              [-80.93521074099993, 63.48468659100007],
              [-80.93407141799992, 63.47955963700008],
              [-80.98558508999992, 63.45571523600006],
              [-81.00055904899995, 63.45136139500005],
              [-81.0188695949999, 63.45026276200008],
              [-81.12490800699993, 63.46381256700005],
              [-81.22154700399994, 63.50153229400007],
              [-81.45445716099994, 63.54979075700004],
              [-81.49767005099994, 63.57575104400007],
              [-81.53180904899995, 63.58075592700004],
              [-81.63597571499992, 63.57518138200004],
              [-81.66063391799992, 63.58197663000004],
              [-81.68077551999994, 63.594916083000044],
              [-81.70156816299993, 63.613348700000074],
              [-81.72960364499994, 63.630926825000074],
              [-81.76366126199991, 63.641058661000045],
              [-81.79991614499994, 63.64508698100008],
              [-81.83438066299993, 63.64411041900007],
              [-81.88194739499994, 63.63613515800006],
              [-81.89708411399994, 63.63666413000004],
              [-81.91323808499993, 63.64158763200004],
              [-81.94090735599991, 63.65501536700003],
              [-81.98965410099993, 63.66242096600007],
              [-82.04417883999992, 63.68463776200008],
              [-82.07461503799993, 63.691839911000045],
              [-82.24266516799992, 63.68695709800005],
              [-82.26256262899994, 63.67869700700004],
              [-82.26016191299993, 63.66453685100004],
              [-82.28750566299993, 63.68504466400003],
              [-82.31891842399995, 63.659409898000035],
              [-82.35753333199995, 63.65961334800005],
              [-82.4817602199999, 63.685207424000055],
              [-82.4895727199999, 63.68846263200004],
              [-82.49217688699991, 63.69554271000004],
              [-82.49107825399994, 63.714056708000044],
              [-82.4929906889999, 63.71979401200008],
              [-82.53164628799993, 63.73191966400003],
              [-82.5515844389999, 63.74298737200007],
              [-82.55093339799993, 63.75731028900003],
              [-82.53111731699994, 63.78424713700008],
              [-82.51773027299993, 63.796576239000046],
              [-82.49974524599992, 63.80170319200005],
              [-82.47923743399991, 63.804754950000074],
              [-82.43419348899994, 63.818426825000074],
              [-82.41104081899994, 63.82221100500004],
              [-82.39122473899994, 63.822333075000074],
              [-82.38540605399993, 63.823879299000055],
              [-82.3762914699999, 63.82843659100007],
              [-82.37954667899993, 63.83002350500004],
              [-82.37181555899991, 63.841131903000075],
              [-82.36119544199994, 63.851996161000045],
              [-82.35582434799994, 63.85297272300005],
              [-82.35798092399995, 63.86713288000004],
              [-82.36156165299991, 63.87909577000005],
              [-82.36221269399994, 63.889105536000045],
              [-82.35582434799994, 63.897365627000056],
              [-82.37092037699995, 63.91303131700005],
              [-82.39110266799992, 63.92377350500004],
              [-82.47883053299995, 63.95099518400008],
              [-82.49266516799992, 63.95258209800005],
              [-82.50625566299993, 63.95575592700004],
              [-82.52647864499994, 63.96987539300005],
              [-82.53392493399991, 63.97304922100005],
              [-82.73936926999994, 63.97304922100005],
              [-82.84239661399994, 63.98672109600005],
              [-82.86864173099991, 63.98680247600004],
              [-82.95372473899994, 63.977443752000056],
              [-82.99258378799993, 63.96556224200003],
              [-83.02794348899994, 63.96621328300006],
              [-83.05923417899993, 63.954331773000035],
              [-83.08454342399995, 63.958197333000044],
              [-83.13044186099995, 63.97923411700003],
              [-83.12873287699995, 63.98265208500004],
              [-83.12645423099991, 63.989569403000075],
              [-83.12360592399995, 63.993475653000075],
              [-83.14167232999995, 63.999701239000046],
              [-83.13829505099994, 64.00665924700007],
              [-83.10993404899995, 64.02081940300008],
              [-83.07579505099994, 64.05060455900008],
              [-83.04735266799992, 64.06293366100005],
              [-82.97960364499994, 64.11709219000005],
              [-82.97032630099994, 64.12783437700006],
              [-82.96580969999991, 64.13703034100007],
              [-82.96637936099995, 64.14655182500007],
              [-82.97207597599993, 64.15802643400008],
              [-83.01024329299992, 64.18642812700006],
              [-83.0137426419999, 64.19155508000006],
              [-83.08429928299995, 64.18984609600005],
              [-83.11856035099993, 64.18402741100005],
              [-83.15086829299992, 64.17169830900008],
              [-83.17096920499995, 64.15399811400005],
              [-83.18565833199995, 64.13422272300005],
              [-83.20352128799993, 64.12205638200004],
              [-83.23314368399991, 64.12702057500007],
              [-83.26891028599994, 64.13837311400005],
              [-83.30211341099994, 64.14057038000004],
              [-83.33482825399994, 64.13523997600004],
              [-83.36937415299991, 64.12392812700006],
              [-83.3894750639999, 64.11322663000004],
              [-83.40143795499995, 64.10952383000006],
              [-83.41779537699995, 64.10956452000005],
              [-83.42369544199994, 64.11196523600006],
              [-83.43814042899993, 64.12091705900008],
              [-83.44566809799994, 64.12392812700006],
              [-83.45653235599991, 64.12531159100007],
              [-83.51280676999994, 64.12042877800008],
              [-83.53941809799994, 64.11074453300006],
              [-83.56265214799993, 64.09564850500004],
              [-83.58287512899994, 64.07611725500004],
              [-83.59337317599994, 64.05487702000005],
              [-83.6016332669999, 64.04572174700007],
              [-83.61701412699995, 64.04193756700005],
              [-83.63687089799993, 64.03937409100007],
              [-83.65347245999993, 64.03290436400005],
              [-83.68529212099992, 64.01406484600005],
              [-83.67861894399994, 63.99876536700003],
              [-83.66685950399994, 63.98712799700007],
              [-83.61937415299991, 63.952826239000046],
              [-83.61636308499993, 63.94916413000004],
              [-83.61554928299995, 63.945013739000046],
              [-83.61318925699993, 63.941392320000034],
              [-83.60680091099994, 63.935207424000055],
              [-83.60456295499995, 63.93036530200004],
              [-83.60781816299993, 63.926662502000056],
              [-83.61302649599992, 63.923041083000044],
              [-83.61750240799995, 63.91693756700005],
              [-83.62694251199991, 63.894232489000046],
              [-83.64110266799992, 63.88361237200007],
              [-83.64858964799993, 63.87636953300006],
              [-83.6511938139999, 63.86937083500004],
              [-83.64224199099993, 63.85651276200008],
              [-83.60753333199995, 63.83315664300005],
              [-83.59593665299991, 63.82221100500004],
              [-83.60855058499993, 63.82257721600007],
              [-83.61750240799995, 63.82054271000004],
              [-83.62071692599994, 63.816107489000046],
              [-83.61636308499993, 63.80914948100008],
              [-83.62800045499995, 63.77912018400008],
              [-83.63377844999991, 63.77098216400003],
              [-83.6492406889999, 63.76512278900003],
              [-83.66661536399994, 63.768744208000044],
              [-83.69896399599992, 63.781236070000034],
              [-83.72801673099991, 63.78229401200008],
              [-83.7566625639999, 63.77749258000006],
              [-83.78392493399991, 63.76850006700005],
              [-83.89683997299994, 63.71670156500005],
              [-83.90782630099994, 63.70892975500004],
              [-83.92398027299993, 63.69330475500004],
              [-83.93187415299991, 63.689439195000034],
              [-83.94595292899993, 63.68504466400003],
              [-83.99339758999992, 63.67755768400008],
              [-84.00743567599994, 63.67137278900003],
              [-84.06387285099993, 63.62067291900007],
              [-84.08934485599991, 63.60993073100008],
              [-84.12181555899991, 63.610988674000055],
              [-84.1848852199999, 63.630194403000075],
              [-84.22891191299993, 63.623114325000074],
              [-84.26085364499994, 63.63003164300005],
              [-84.27432206899994, 63.63043854400007],
              [-84.28425045499995, 63.62677643400008],
              [-84.28831946499992, 63.62250397300005],
              [-84.29149329299992, 63.61603424700007],
              [-84.2988988919999, 63.60618724200003],
              [-84.3098852199999, 63.597723700000074],
              [-84.35000566299993, 63.58197663000004],
              [-84.39110266799992, 63.56000397300005],
              [-84.40534420499995, 63.554754950000074],
              [-84.40493730399993, 63.527329820000034],
              [-84.45254472599993, 63.479722398000035],
              [-84.44566809799994, 63.45913320500006],
              [-84.48033606699994, 63.39337799700007],
              [-84.49376380099994, 63.38336823100008],
              [-84.52041581899994, 63.37457916900007],
              [-84.59024003799993, 63.31513092700004],
              [-84.61945553299995, 63.30683014500005],
              [-84.68260657499991, 63.299994208000044],
              [-84.72313391799992, 63.277411200000074],
              [-84.75767981699994, 63.27106354400007],
              [-84.78502356699994, 63.25503164300005],
              [-84.9544164699999, 63.19383372600004],
              [-85.0957738919999, 63.157131252000056],
              [-85.27391516799992, 63.12335846600007],
              [-85.45518958199995, 63.122259833000044],
              [-85.50975501199991, 63.12921784100007],
              [-85.58531653599994, 63.17332591400003],
              [-85.59203040299991, 63.18463776200008],
              [-85.60387122299994, 63.21206289300005],
              [-85.63516191299993, 63.24310944200005],
              [-85.63951575399994, 63.25104401200008],
              [-85.64207923099991, 63.268011786000045],
              [-85.64541581899994, 63.27480703300006],
              [-85.64362545499995, 63.29433828300006],
              [-85.64830481699994, 63.34442780200004],
              [-85.65225175699993, 63.356675523000035],
              [-85.65127519399994, 63.37335846600007],
              [-85.65501868399991, 63.41771067900004],
              [-85.65225175699993, 63.438666083000044],
              [-85.63955644399994, 63.45795319200005],
              [-85.62096106699994, 63.47919342700004],
              [-85.60753333199995, 63.50079987200007],
              [-85.6106664699999, 63.521185614000046],
              [-85.60387122299994, 63.521185614000046],
              [-85.61388098899994, 63.53412506700005],
              [-85.62515214799993, 63.554673570000034],
              [-85.63011633999992, 63.57367584800005],
              [-85.62120520699995, 63.58197663000004],
              [-85.61522376199991, 63.58649323100008],
              [-85.59463456899994, 63.60724518400008],
              [-85.59019934799994, 63.613348700000074],
              [-85.59235592399995, 63.623928127000056],
              [-85.60167395699995, 63.644191799000055],
              [-85.60387122299994, 63.654364325000074],
              [-85.61701412699995, 63.67487213700008],
              [-85.64736894399994, 63.68431224200003],
              [-85.68163001199991, 63.69009023600006],
              [-85.70628821499992, 63.699286200000074],
              [-85.71532141799992, 63.716009833000044],
              [-85.71467037699995, 63.73505280200004],
              [-85.71157792899993, 63.75336334800005],
              [-85.71373450399994, 63.767564195000034],
              [-85.71373450399994, 63.77440013200004],
              [-85.76471920499995, 63.73224518400008],
              [-85.79356848899994, 63.71336497600004],
              [-85.81981360599991, 63.705511786000045],
              [-85.9539281889999, 63.699286200000074],
              [-86.21397864499994, 63.65086497600004],
              [-86.28538977799991, 63.64606354400007],
              [-86.49453691299993, 63.67137278900003],
              [-86.63231360599991, 63.66453685100004],
              [-86.66120357999995, 63.65770091400003],
              [-86.68956458199995, 63.64118073100008],
              [-86.74156653599994, 63.60248444200005],
              [-86.80211341099994, 63.57489655200004],
              [-86.86815344999991, 63.561753648000035],
              [-87.06436113199993, 63.55483633000006],
              [-87.12376868399991, 63.56362539300005],
              [-87.17540442599994, 63.58502838700008],
              [-87.21450761599993, 63.62299225500004],
              [-87.22378495999993, 63.660142320000034],
              [-87.20856686099995, 63.696478583000044],
              [-87.17735755099994, 63.73041413000004],
              [-86.95384680899991, 63.897365627000056],
              [-86.89590410099993, 63.93024323100008],
              [-86.59788977799991, 63.99689362200007],
              [-86.56143144399994, 64.01634349200003],
              [-86.49193274599992, 64.02309804900005],
              [-86.41624915299991, 64.05394114800004],
              [-86.3496801419999, 64.07298411700003],
              [-86.25059973899994, 64.07908763200004],
              [-86.21739661399994, 64.08722565300008],
              [-86.19286048099991, 64.10342031500005],
              [-86.18321692599994, 64.12396881700005],
              [-86.1856176419999, 64.14492422100005],
              [-86.19595292899993, 64.16474030200004],
              [-86.21056067599994, 64.18195221600007],
              [-86.23265540299991, 64.19354889500005],
              [-86.29881751199991, 64.21865469000005],
              [-86.31639563699991, 64.23379140800006],
              [-86.31566321499992, 64.24249909100007],
              [-86.30968176999994, 64.25112539300005],
              [-86.30199133999992, 64.25958893400008],
              [-86.29588782499991, 64.26788971600007],
              [-86.32054602799991, 64.27342357000003],
              [-86.33824622299994, 64.28192780200004],
              [-86.35204016799992, 64.29352448100008],
              [-86.36481686099995, 64.30882396000004],
              [-86.3613988919999, 64.32196686400005],
              [-86.3665258449999, 64.33417389500005],
              [-86.37417558499993, 64.34564850500004],
              [-86.37848873599995, 64.35663483300004],
              [-86.37535559799994, 64.37457916900007],
              [-86.36595618399991, 64.38491445500006],
              [-86.35411536399994, 64.39468008000006],
              [-86.34373938699991, 64.41128164300005],
              [-86.37633216099994, 64.42279694200005],
              [-86.40575110599991, 64.43854401200008],
              [-86.39293372299994, 64.45600006700005],
              [-86.38878333199995, 64.47467682500007],
              [-86.38296464799993, 64.54580312700006],
              [-86.38829505099994, 64.56073639500005],
              [-86.41942298099991, 64.59686920800004],
              [-86.38316809799994, 64.62055084800005],
              [-86.35289466099994, 64.65078359600005],
              [-86.24583899599992, 64.80451080900008],
              [-86.23818925699993, 64.81256745000007],
              [-86.22765051999994, 64.81590403900003],
              [-86.19749915299991, 64.81561920800004],
              [-86.18407141799992, 64.81948476800005],
              [-86.17300370999993, 64.82957591400003],
              [-86.19273841099994, 64.83710358300004],
              [-86.20099850199995, 64.84198639500005],
              [-86.20714270699995, 64.85008372600004],
              [-86.18203691299993, 64.85590241100005],
              [-86.18675696499992, 64.86758047100005],
              [-86.21397864499994, 64.89105866100005],
              [-86.1902563139999, 64.89862702000005],
              [-86.17039954299992, 64.90753815300008],
              [-86.15876217399995, 64.92031484600005],
              [-86.15933183499993, 64.93943919500003],
              [-86.1726781889999, 64.95433177300004],
              [-86.21450761599993, 64.97260163000004],
              [-86.22765051999994, 64.98663971600007],
              [-86.2278539699999, 65.00385163000004],
              [-86.22069251199991, 65.02362702000005],
              [-86.21019446499992, 65.04214101800005],
              [-86.20030676999994, 65.05548737200007],
              [-86.18321692599994, 65.06932200700004],
              [-86.16266842399995, 65.08148834800005],
              [-86.14549719999991, 65.09516022300005],
              [-86.13825436099995, 65.11351146000004],
              [-86.13825436099995, 65.18219635600008],
              [-86.14037024599992, 65.20001862200007],
              [-86.14976966099994, 65.22431061400005],
              [-86.15192623599995, 65.23737213700008],
              [-86.15786699099993, 65.25360748900005],
              [-86.1687719389999, 65.26959870000007],
              [-86.17393958199995, 65.28652578300006],
              [-86.16274980399993, 65.30565013200004],
              [-86.11583411399994, 65.34686920800004],
              [-86.09727942599994, 65.35716380400004],
              [-86.10863196499992, 65.36810944200005],
              [-86.14122473899994, 65.37567780200004],
              [-86.15192623599995, 65.38507721600007],
              [-86.15151933499993, 65.39614492400005],
              [-86.14509029899995, 65.40908437700006],
              [-86.13613847599993, 65.42108795800004],
              [-86.12832597599993, 65.42918528900003],
              [-86.11998450399994, 65.44464752800008],
              [-86.10472571499992, 65.51422760600008],
              [-86.08336341099994, 65.56207916900007],
              [-86.06602942599994, 65.58637116100005],
              [-86.02830969999991, 65.60610586100006],
              [-86.02407792899993, 65.62734609600005],
              [-86.02839107999995, 65.66502513200004],
              [-85.99029165799993, 65.71237932900004],
              [-85.93893536399992, 65.76319806100008],
              [-85.7269381779999, 65.86347870800006],
              [-85.60981566299995, 65.91054608700006],
              [-85.54088143899992, 65.92158908400006],
              [-85.48651056599994, 65.92413607900005],
              [-85.46228784099992, 65.88067228900007],
              [-85.49236764299991, 65.85901555200007],
              [-85.50617579499993, 65.83865454000005],
              [-85.4890814119999, 65.82033065800005],
              [-85.48827063699991, 65.79661692900004],
              [-85.45718339799993, 65.79364655200004],
              [-85.42634029899995, 65.80223216400003],
              [-85.4153539699999, 65.81020742400005],
              [-85.3972875639999, 65.82973867400005],
              [-85.38536536399994, 65.83698151200008],
              [-85.36953691299993, 65.83958567900004],
              [-85.32506262899994, 65.83759186400005],
              [-85.20103919199994, 65.80927155200004],
              [-85.17186438699991, 65.78912995000007],
              [-85.1641332669999, 65.77676015800006],
              [-85.16612708199995, 65.77147044500003],
              [-85.17100989499994, 65.76813385600008],
              [-85.17186438699991, 65.76121653900003],
              [-85.16494706899994, 65.75263092700004],
              [-85.15562903599994, 65.74371979400007],
              [-85.15269934799994, 65.73672109600005],
              [-85.1653539699999, 65.73395416900007],
              [-85.18394934799994, 65.72630442900004],
              [-85.16759192599994, 65.70905182500007],
              [-85.07371985599991, 65.64972565300008],
              [-85.0540258449999, 65.63011302300004],
              [-85.05235755099994, 65.61416250200006],
              [-85.07994544199994, 65.59308502800008],
              [-85.11172441299993, 65.58120351800005],
              [-85.25064042899993, 65.55516185100004],
              [-85.28636633999992, 65.56004466400003],
              [-85.30142167899993, 65.55683014500005],
              [-85.3164770169999, 65.54148997600004],
              [-85.26097571499992, 65.50763580900008],
              [-85.23005123599995, 65.49339427300004],
              [-85.16222083199995, 65.48309967700004],
              [-85.07673092399995, 65.45636627800008],
              [-85.01943925699993, 65.42544179900005],
              [-85.00763912699995, 65.41571686400005],
              [-85.00055904899995, 65.40558502800008],
              [-85.00121008999992, 65.39647044500003],
              [-85.01138261599993, 65.36399974200003],
              [-85.01895097599993, 65.35224030200004],
              [-84.99962317599994, 65.32632070500006],
              [-84.93126380099994, 65.26430898600006],
              [-84.92540442599994, 65.25413646000004],
              [-84.92662512899994, 65.24225495000007],
              [-84.9317113919999, 65.22898997600004],
              [-84.93179277299993, 65.21820709800005],
              [-84.91832434799994, 65.21381256700005],
              [-84.84797115799995, 65.21352773600006],
              [-84.8152563139999, 65.22113678600005],
              [-84.78823808499993, 65.24115631700005],
              [-84.78213456899994, 65.25063711100006],
              [-84.76773027299993, 65.28204987200007],
              [-84.76284745999993, 65.28611888200004],
              [-84.75088456899994, 65.29075755400004],
              [-84.74730383999992, 65.29572174700007],
              [-84.7468969389999, 65.30304596600007],
              [-84.74962317599994, 65.30678945500006],
              [-84.75304114499994, 65.30923086100006],
              [-84.75475012899994, 65.31248607000003],
              [-84.75259355399993, 65.33515045800004],
              [-84.74498450399994, 65.35150788000004],
              [-84.73013261599993, 65.36652252800008],
              [-84.7063695949999, 65.38507721600007],
              [-84.6524145169999, 65.43846263200004],
              [-84.62389075399994, 65.45115794500003],
              [-84.61229407499991, 65.46198151200008],
              [-84.59337317599994, 65.48411692900004],
              [-84.57738196499992, 65.48940664300005],
              [-84.55467688699991, 65.48590729400007],
              [-84.51451575399994, 65.47386302300004],
              [-84.45026607999995, 65.46230703300006],
              [-84.42723548099991, 65.44977448100008],
              [-84.43569902299993, 65.42918528900003],
              [-84.4434301419999, 65.41933828300006],
              [-84.43907630099994, 65.41421133000006],
              [-84.4270727199999, 65.41217682500007],
              [-84.41177324099993, 65.41181061400005],
              [-84.40282141799992, 65.40802643400008],
              [-84.3762914699999, 65.39036692900004],
              [-84.36367753799993, 65.38507721600007],
              [-84.29539954299992, 65.37763092700004],
              [-84.2200414699999, 65.35407135600008],
              [-84.16002356699994, 65.34699127800008],
              [-84.15078691299993, 65.34007396000004],
              [-84.15225175699993, 65.33222077000005],
              [-84.15648352799991, 65.32973867400005],
              [-84.16299394399994, 65.32892487200007],
              [-84.17162024599992, 65.32611725500004],
              [-84.17910722599993, 65.32094961100006],
              [-84.18130449099993, 65.31683991100005],
              [-84.18211829299992, 65.31305573100008],
              [-84.18553626199991, 65.30878327000005],
              [-84.22573808499993, 65.28754303600005],
              [-84.23338782499991, 65.28204987200007],
              [-84.23033606699994, 65.26764557500007],
              [-84.21483313699991, 65.25983307500007],
              [-84.17870032499991, 65.25071849200003],
              [-84.0984594389999, 65.20954010600008],
              [-84.06883704299992, 65.20014069200005],
              [-84.04605058499993, 65.19769928600005],
              [-83.97264563699991, 65.20014069200005],
              [-83.87706458199995, 65.19269440300008],
              [-83.91808020699995, 65.17841217700004],
              [-83.90135657499991, 65.16982656500005],
              [-83.88247636599993, 65.16551341400003],
              [-83.84292558499993, 65.16535065300008],
              [-83.77521725199995, 65.18024323100008],
              [-83.72484290299991, 65.16303131700005],
              [-83.54645748599995, 65.16225820500006],
              [-83.46979732999995, 65.14809804900005],
              [-83.42833411399994, 65.14492422100005],
              [-83.39769446499992, 65.13662344000005],
              [-83.37759355399993, 65.11701080900008],
              [-83.35977128799993, 65.09406159100007],
              [-83.33580481699994, 65.07599518400008],
              [-83.33983313699991, 65.03579336100006],
              [-83.30675208199995, 65.00885651200008],
              [-83.22227942599994, 64.96991608300004],
              [-83.21540279899995, 64.96088288000004],
              [-83.21288001199991, 64.95311107000003],
              [-83.20836341099994, 64.94769928600005],
              [-83.10936438699991, 64.93537018400008],
              [-83.05093339799993, 64.91917552300004],
              [-83.01431230399993, 64.91836172100005],
              [-83.00112870999993, 64.91616445500006],
              [-82.99144446499992, 64.91120026200008],
              [-82.97207597599993, 64.89850495000007],
              [-82.95612545499995, 64.89154694200005],
              [-82.94261633999992, 64.88776276200008],
              [-82.88377844999991, 64.87970612200007],
              [-82.86375891799992, 64.87201569200005],
              [-82.84756425699993, 64.86102936400005],
              [-82.79458574099993, 64.81293366100005],
              [-82.77318274599992, 64.79987213700008],
              [-82.74620520699995, 64.78864166900007],
              [-82.71450761599993, 64.78099192900004],
              [-82.62328040299991, 64.78119538000004],
              [-82.60204016799992, 64.77480703300006],
              [-82.5496313139999, 64.74803294500003],
              [-82.53766842399995, 64.74396393400008],
              [-82.5286352199999, 64.74795156500005],
              [-82.47223873599995, 64.75556061400005],
              [-82.42467200399994, 64.76752350500004],
              [-82.39537512899994, 64.76996491100005],
              [-82.36595618399991, 64.76801178600005],
              [-82.3367406889999, 64.76154205900008],
              [-82.30797278599994, 64.75079987200007],
              [-82.27696692599994, 64.72907135600008],
              [-82.26699785099993, 64.72589752800008],
              [-82.22012285099993, 64.72345612200007],
              [-82.20494544199994, 64.71971263200004],
              [-82.2168676419999, 64.69879791900007],
              [-82.21768144399994, 64.69122955900008],
              [-82.12254798099991, 64.69204336100006],
              [-82.0984594389999, 64.68716054900005],
              [-82.07835852799991, 64.67536041900007],
              [-82.07339433499993, 64.66950104400007],
              [-82.06550045499995, 64.65639883000006],
              [-82.06159420499995, 64.65143463700008],
              [-81.84870357999995, 64.53473541900007],
              [-81.82725989499994, 64.53192780200004],
              [-81.79759680899991, 64.52407461100006],
              [-81.77131100199995, 64.51203034100007],
              [-81.75991777299993, 64.49689362200007],
              [-81.75841223899994, 64.49310944200005],
              [-81.75523841099994, 64.48834870000007],
              [-81.75255286399994, 64.48183828300006],
              [-81.75251217399995, 64.47272370000007],
              [-81.75645911399994, 64.46478913000004],
              [-81.76976477799991, 64.45380280200004],
              [-81.7742406889999, 64.44599030200004],
              [-81.77448482999995, 64.43231842700004],
              [-81.76992753799993, 64.41657135600008],
              [-81.75251217399995, 64.38397858300004],
              [-81.75991777299993, 64.37775299700007],
              [-81.75308183499993, 64.36151764500005],
              [-81.76130123599995, 64.35097890800006],
              [-81.77383378799993, 64.34096914300005],
              [-81.78038489499994, 64.32587311400005],
              [-81.77464758999992, 64.30923086100006],
              [-81.76089433499993, 64.29279205900008],
              [-81.71353105399993, 64.25421784100007],
              [-81.69029700399994, 64.24091217700004],
              [-81.66576087099992, 64.23086172100005],
              [-81.62291419199994, 64.22174713700008],
              [-81.60846920499995, 64.20962148600006],
              [-81.58800208199995, 64.18537018400008],
              [-81.60204016799992, 64.15753815300008],
              [-81.60912024599992, 64.15119049700007],
              [-81.60659745999993, 64.13410065300008],
              [-81.62718665299991, 64.12360260600008],
              [-81.70897376199991, 64.11277903900003],
              [-81.76732337099992, 64.09398021000004],
              [-81.85578365799995, 64.08515045800004],
              [-81.88263912699995, 64.07859935100004],
              [-81.91014563699991, 64.06867096600007],
              [-81.92788652299993, 64.05658600500004],
              [-81.93956458199995, 64.05243561400005],
              [-81.94489498599995, 64.05874258000006],
              [-81.9500219389999, 64.06806061400005],
              [-81.96125240799995, 64.06354401200008],
              [-81.97264563699991, 64.05402252800008],
              [-81.97838294199994, 64.04816315300008],
              [-81.97423255099994, 64.03497955900008],
              [-81.98253333199995, 64.02651601800005],
              [-81.9942113919999, 64.01947663000004],
              [-82.00011145699995, 64.01064687700006],
              [-81.99160722599993, 63.99872467700004],
              [-81.97134355399993, 63.993841864000046],
              [-81.87832597599993, 64.00389232000003],
              [-81.77904212099992, 64.00202057500007],
              [-81.64997311099995, 64.02850983300004],
              [-81.58828691299993, 64.03510163000004],
              [-81.50133216099994, 64.03261953300006],
              [-81.45653235599991, 64.03778717700004],
              [-81.43028723899994, 64.05499909100007],
              [-81.43618730399993, 64.06053294500003],
              [-81.45079505099994, 64.08226146000004],
              [-81.43822180899991, 64.09162018400008],
              [-81.41917883999992, 64.09894440300008],
              [-81.39883378799993, 64.10150788000004],
              [-81.38255774599992, 64.09658437700006],
              [-81.40274003799993, 64.08486562700006],
              [-81.40982011599993, 64.08226146000004],
              [-81.37328040299991, 64.07440827000005],
              [-81.29832923099991, 64.08063385600008],
              [-81.24510657499991, 64.05735911700003],
              [-81.05850175699993, 64.02651601800005],
              [-80.97370357999995, 63.99359772300005],
              [-80.93065344999991, 63.993475653000075],
              [-80.90371660099993, 64.01080963700008],
              [-80.92186438699991, 64.03021881700005],
              [-80.95653235599991, 64.04999420800004],
              [-80.97911536399994, 64.06867096600007],
              [-80.95034745999993, 64.08490631700005],
              [-80.93838456899994, 64.09438711100006],
              [-80.93065344999991, 64.10342031500005],
              [-80.94481360599991, 64.12335846600007],
              [-80.95116126199991, 64.13007233300004],
              [-80.88878333199995, 64.12262604400007],
              [-80.82371985599991, 64.10268789300005],
              [-80.76317298099991, 64.07347239800004],
              [-80.71471106699994, 64.03851959800005],
              [-80.7083227199999, 64.03021881700005],
              [-80.70376542899993, 64.02228424700007],
              [-80.69709225199995, 64.01634349200003],
              [-80.61473548099991, 64.00722890800006],
              [-80.54381262899994, 63.98493073100008],
              [-80.52188066299993, 63.96971263200004],
              [-80.53966223899994, 63.959418036000045],
              [-80.54881751199991, 63.93317291900007],
              [-80.4968969389999, 63.917669989000046],
              [-80.53282630099994, 63.90420156500005],
              [-80.57705644399994, 63.89793528900003],
              [-80.61880449099993, 63.90110911700003],
              [-80.70470130099994, 63.918402411000045],
              [-80.6746313139999, 63.89398834800005],
              [-80.6438695949999, 63.88165924700007],
              [-80.37938391799992, 63.85057200700004],
              [-80.27961178299995, 63.80914948100008],
              [-80.26012122299994, 63.80853913000004],
              [-80.22240149599992, 63.81708405200004],
              [-80.20445716099994, 63.81537506700005],
              [-80.19298255099994, 63.807806708000044],
              [-80.18382727799991, 63.796576239000046],
              [-80.16974850199995, 63.77440013200004],
              [-80.18333899599992, 63.767564195000034],
            ],
          ],
          [
            [
              [-85.00112870999993, 66.00763580900008],
              [-84.95376542899993, 66.01581452000005],
              [-84.93028723899994, 66.01508209800005],
              [-84.89891516799992, 65.99079010600008],
              [-84.85716712099992, 65.96670156500005],
              [-84.86660722599993, 65.96344635600008],
              [-84.87523352799991, 65.95917389500005],
              [-84.88329016799992, 65.95376211100006],
              [-84.89126542899993, 65.94684479400007],
              [-84.82868404899995, 65.91388580900008],
              [-84.81281490799995, 65.90184153900003],
              [-84.79417883999992, 65.89215729400007],
              [-84.77122962099992, 65.88519928600005],
              [-84.75609290299991, 65.87718333500004],
              [-84.76097571499992, 65.86432526200008],
              [-84.72704016799992, 65.84552643400008],
              [-84.71495520699995, 65.83527252800008],
              [-84.71934973899994, 65.82269928600005],
              [-84.71304277299993, 65.80849844000005],
              [-84.70457923099991, 65.79564036700003],
              [-84.65933183499993, 65.74843984600005],
              [-84.65294348899994, 65.73639557500007],
              [-84.64220130099994, 65.72382233300004],
              [-84.63369706899994, 65.70966217700004],
              [-84.62751217399995, 65.70294830900008],
              [-84.61733964799993, 65.69733307500007],
              [-84.59923255099994, 65.69330475500004],
              [-84.59024003799993, 65.68618398600006],
              [-84.59194902299993, 65.68366120000007],
              [-84.60138912699995, 65.67487213700008],
              [-84.60334225199995, 65.67251211100006],
              [-84.60045325399994, 65.66925690300008],
              [-84.59227454299992, 65.66217682500007],
              [-84.59024003799993, 65.65884023600006],
              [-84.57852128799993, 65.64472077000005],
              [-84.57408606699994, 65.63564687700006],
              [-84.58665930899991, 65.62563711100006],
              [-84.64830481699994, 65.59332916900007],
              [-84.67552649599992, 65.56753164300005],
              [-84.69066321499992, 65.56004466400003],
              [-84.71320553299995, 65.55516185100004],
              [-84.75121008999992, 65.55638255400004],
              [-84.80089270699995, 65.56708405200004],
              [-84.84121660099993, 65.58755117400005],
              [-84.85094153599994, 65.61790599200003],
              [-84.85521399599992, 65.62335846600007],
              [-84.85700436099995, 65.63007233300004],
              [-84.85716712099992, 65.64826080900008],
              [-84.86286373599995, 65.66095612200007],
              [-84.87633216099994, 65.67039622600004],
              [-84.92422441299993, 65.68976471600007],
              [-85.04539954299992, 65.71625397300005],
              [-85.05919348899994, 65.72402578300006],
              [-85.07852128799993, 65.73997630400004],
              [-85.09679114499994, 65.75039297100005],
              [-85.11266028599994, 65.76211172100005],
              [-85.12466386599993, 65.78237539300005],
              [-85.14073645699995, 65.84027741100005],
              [-85.15257727799991, 65.85687897300005],
              [-85.13670813699991, 65.87958405200004],
              [-85.14586341099994, 65.90631745000007],
              [-85.16673743399991, 65.93081289300005],
              [-85.18614661399994, 65.94684479400007],
              [-85.17808997299994, 65.95636627800008],
              [-85.17345130099994, 65.96653880400004],
              [-85.17341061099995, 65.97711823100008],
              [-85.17931067599994, 65.98777903900003],
              [-85.15566972599993, 66.01121653900003],
              [-85.13174394399994, 66.02362702000005],
              [-85.10244706899994, 66.02850983300004],
              [-85.06261145699995, 66.02944570500006],
              [-85.05223548099991, 66.02781810100004],
              [-85.04442298099991, 66.02407461100006],
              [-85.0371801419999, 66.01935455900008],
              [-85.02269446499992, 66.01239655200004],
              [-85.0188695949999, 66.00995514500005],
              [-85.01292883999992, 66.00824616100005],
              [-85.00112870999993, 66.00763580900008],
            ],
          ],
          [
            [
              [-84.47354081899994, 66.09023672100005],
              [-84.46825110599991, 66.10382721600007],
              [-84.47036699099993, 66.11762116100005],
              [-84.47411048099991, 66.12978750200006],
              [-84.47354081899994, 66.13861725500004],
              [-84.4578344389999, 66.14614492400005],
              [-84.43325761599993, 66.14581940300008],
              [-84.40819251199991, 66.14105866100005],
              [-84.34609941299993, 66.11790599200003],
              [-84.18614661399994, 66.08734772300005],
              [-84.14354407499991, 66.08673737200007],
              [-84.12344316299993, 66.08344147300005],
              [-84.11021887899994, 66.07729726800005],
              [-84.10024980399993, 66.07054271000004],
              [-84.08828691299993, 66.06513092700004],
              [-84.06883704299992, 66.06289297100005],
              [-84.05418860599991, 66.06907786700003],
              [-84.03819739499994, 66.08075592700004],
              [-84.02135169199994, 66.08771393400008],
              [-84.00401770699995, 66.07965729400007],
              [-83.99893144399994, 66.06928131700005],
              [-83.99742591099994, 66.05609772300005],
              [-83.99840247299994, 66.04368724200003],
              [-84.00059973899994, 66.03558991100005],
              [-83.9824926419999, 66.02960846600007],
              [-83.94367428299995, 66.02204010600008],
              [-83.83340410099993, 65.97821686400005],
              [-83.7754613919999, 65.96971263200004],
              [-83.74290930899991, 65.95831940300008],
              [-83.71251380099994, 65.94277578300006],
              [-83.69273841099994, 65.92572663000004],
              [-83.68248450399994, 65.88153717700004],
              [-83.71198482999995, 65.85346100500004],
              [-83.80199133999992, 65.82269928600005],
              [-83.78636633999992, 65.81281159100007],
              [-83.72622636599993, 65.80223216400003],
              [-83.72248287699995, 65.79954661700003],
              [-83.71837317599994, 65.79515208500004],
              [-83.71214758999992, 65.79100169500003],
              [-83.70238196499992, 65.78912995000007],
              [-83.67686926999994, 65.78912995000007],
              [-83.66502844999991, 65.78607819200005],
              [-83.63548743399991, 65.76691315300008],
              [-83.56114661399994, 65.75507233300004],
              [-83.54222571499992, 65.74823639500005],
              [-83.5320531889999, 65.74286530200004],
              [-83.52765865799995, 65.73737213700008],
              [-83.53380286399994, 65.72431061400005],
              [-83.53555253799993, 65.71678294500003],
              [-83.53107662699995, 65.71344635600008],
              [-83.5149633449999, 65.71576569200005],
              [-83.48981686099995, 65.72553131700005],
              [-83.4727270169999, 65.72772858300004],
              [-83.29084225199995, 65.72797272300005],
              [-83.23932857999995, 65.72158437700006],
              [-83.21231035099993, 65.70600006700005],
              [-83.2356664699999, 65.69985586100006],
              [-83.25845292899993, 65.69013092700004],
              [-83.26675370999993, 65.67820872600004],
              [-83.24644934799994, 65.66502513200004],
              [-83.25523841099994, 65.65672435100004],
              [-83.26561438699991, 65.65180084800005],
              [-83.28742428299995, 65.64520905200004],
              [-83.28123938699991, 65.64520905200004],
              [-83.30064856699994, 65.63450755400004],
              [-83.33372962099992, 65.62441640800006],
              [-83.36705481699994, 65.61859772300005],
              [-83.38735917899993, 65.62099844000005],
              [-83.40770423099991, 65.63540273600006],
              [-83.42983964799993, 65.64630768400008],
              [-83.45372473899994, 65.65399811400005],
              [-83.47923743399991, 65.65884023600006],
              [-83.59626217399995, 65.65884023600006],
              [-83.62267005099994, 65.66453685100004],
              [-83.61611894399994, 65.67796458500004],
              [-83.58287512899994, 65.70600006700005],
              [-83.61803137899994, 65.70282623900005],
              [-83.64928137899994, 65.68976471600007],
              [-83.65758216099994, 65.67291901200008],
              [-83.6238500639999, 65.65884023600006],
              [-83.6238500639999, 65.65135325700004],
              [-83.65892493399991, 65.65534088700008],
              [-83.72752844999991, 65.67121002800008],
              [-83.7610570949999, 65.67251211100006],
              [-83.81444251199991, 65.65302155200004],
              [-83.83885657499991, 65.65224844000005],
              [-83.84911048099991, 65.67593008000006],
              [-83.84284420499995, 65.68357982000003],
              [-83.82835852799991, 65.68480052300004],
              [-83.81248938699991, 65.68414948100008],
              [-83.80199133999992, 65.68618398600006],
              [-83.79531816299993, 65.69489166900007],
              [-83.79605058499993, 65.70189036700003],
              [-83.79979407499991, 65.70868561400005],
              [-83.80199133999992, 65.71686432500007],
              [-83.7859594389999, 65.72842031500005],
              [-83.74958248599995, 65.73859284100007],
              [-83.68529212099992, 65.74823639500005],
              [-83.68529212099992, 65.75507233300004],
              [-83.72297115799995, 65.76410553600005],
              [-83.82925370999993, 65.75507233300004],
              [-83.78795325399994, 65.77643463700008],
              [-83.78087317599994, 65.78237539300005],
              [-83.78563391799992, 65.79266998900005],
              [-83.80186926999994, 65.79393138200004],
              [-83.86974036399994, 65.78290436400005],
              [-83.95897376199991, 65.74079010600008],
              [-83.97817949099993, 65.73997630400004],
              [-83.99303137899994, 65.74591705900008],
              [-84.00633704299992, 65.75438060100004],
              [-84.02110755099994, 65.76121653900003],
              [-84.0391332669999, 65.76235586100006],
              [-84.07282467399995, 65.75535716400003],
              [-84.12596594999991, 65.76162344000005],
              [-84.14273027299993, 65.76675039300005],
              [-84.14118404899995, 65.77863190300008],
              [-84.12922115799995, 65.78851959800005],
              [-84.1179906889999, 65.79498932500007],
              [-84.10903886599993, 65.80263906500005],
              [-84.10362708199995, 65.81586334800005],
              [-84.10863196499992, 65.83612702000005],
              [-84.12242591099994, 65.85643138200004],
              [-84.13267981699994, 65.87628815300008],
              [-84.12458248599995, 65.90668366100005],
              [-84.13613847599993, 65.91648997600004],
              [-84.15269934799994, 65.92328522300005],
              [-84.18691972599993, 65.92861562700006],
              [-84.1895238919999, 65.93622467700004],
              [-84.18496660099993, 65.94733307500007],
              [-84.18553626199991, 65.96051666900007],
              [-84.19456946499992, 65.97186920800004],
              [-84.20531165299991, 65.97638580900008],
              [-84.23338782499991, 65.98094310100004],
              [-84.28962154899995, 66.00438060100004],
              [-84.30874589799993, 66.00763580900008],
              [-84.37071692599994, 66.00690338700008],
              [-84.39708411399994, 66.01288483300004],
              [-84.42516028599994, 66.02944570500006],
              [-84.45189368399991, 66.05267975500004],
              [-84.47354081899994, 66.07591380400004],
              [-84.4661352199999, 66.07591380400004],
              [-84.47354081899994, 66.08344147300005],
              [-84.4661352199999, 66.09023672100005],
              [-84.47354081899994, 66.09023672100005],
            ],
          ],
          [
            [
              [-83.27379309799994, 66.30931224200003],
              [-83.2898656889999, 66.30853913000004],
              [-83.29605058499993, 66.31195709800005],
              [-83.29454505099994, 66.31932200700004],
              [-83.28742428299995, 66.33038971600007],
              [-83.2747289699999, 66.34349192900004],
              [-83.26284745999993, 66.34699127800008],
              [-83.23314368399991, 66.34406159100007],
              [-83.22496497299994, 66.34113190300008],
              [-83.19871985599991, 66.32021719000005],
              [-83.18423417899993, 66.31586334800005],
              [-83.15233313699991, 66.31293366100005],
              [-83.13719641799992, 66.30931224200003],
              [-83.15977942599994, 66.30312734600005],
              [-83.16958574099993, 66.29767487200007],
              [-83.17821204299992, 66.28945547100005],
              [-83.15794837099992, 66.28497955900008],
              [-83.10277258999992, 66.28945547100005],
              [-83.09068762899994, 66.28522370000007],
              [-83.06704667899993, 66.26642487200007],
              [-83.0481664699999, 66.26215241100005],
              [-82.92784583199995, 66.28099192900004],
              [-82.90444902299993, 66.26837799700007],
              [-82.93797766799992, 66.25470612200007],
              [-82.95763098899994, 66.24359772300005],
              [-82.99022376199991, 66.21015045800004],
              [-83.00690670499995, 66.19944896000004],
              [-83.03954016799992, 66.19476959800005],
              [-83.07762610599991, 66.19782135600008],
              [-83.11375891799992, 66.20791250200006],
              [-83.14028886599993, 66.22431061400005],
              [-83.18805904899995, 66.24184804900005],
              [-83.25145423099991, 66.25092194200005],
              [-83.29263261599993, 66.26788971600007],
              [-83.27379309799994, 66.30931224200003],
            ],
          ],
          [
            [
              [-62.407460089999915, 67.18695709800005],
              [-62.373931443999936, 67.16583893400008],
              [-62.40721594999991, 67.15888092700004],
              [-62.590728318999936, 67.09540436400005],
              [-62.61986243399991, 67.07802969000005],
              [-62.650461391999954, 67.05292389500005],
              [-62.67100989499994, 67.04612864800004],
              [-62.72032630099994, 67.05329010600008],
              [-62.73985755099994, 67.04637278900003],
              [-62.74331620999993, 67.03583405200004],
              [-62.74168860599991, 67.02570221600007],
              [-62.74689693899995, 67.01805247600004],
              [-62.77086341099994, 67.01504140800006],
              [-62.80776933499993, 67.02024974200003],
              [-62.90151933499993, 67.06342194200005],
              [-62.821929490999935, 67.05841705900008],
              [-62.80532792899993, 67.06342194200005],
              [-62.8040258449999, 67.06891510600008],
              [-62.80532792899993, 67.09418366100005],
              [-62.79987545499995, 67.10248444200005],
              [-62.78697669199994, 67.10529205900008],
              [-62.73961341099994, 67.10553620000007],
              [-62.71837317599994, 67.11001211100006],
              [-62.702015753999945, 67.11945221600007],
              [-62.69546464799993, 67.13572825700004],
              [-62.68468176999994, 67.14227936400005],
              [-62.63198808499993, 67.14252350500004],
              [-62.61290442599994, 67.14541250200006],
              [-62.62336178299995, 67.15570709800005],
              [-62.64468339799993, 67.16372304900005],
              [-62.65392005099994, 67.17328522300005],
              [-62.63898678299995, 67.17841217700004],
              [-62.62291419199994, 67.18032461100006],
              [-62.58901933499993, 67.18012116100005],
              [-62.57323157499991, 67.18227773600006],
              [-62.54092363199993, 67.19159577000005],
              [-62.52476966099994, 67.19379303600005],
              [-62.42845618399991, 67.19293854400007],
              [-62.407460089999915, 67.18695709800005],
            ],
          ],
          [
            [
              [-63.51789303299995, 67.32416413000004],
              [-63.498036261999914, 67.33685944200005],
              [-63.48713131399995, 67.34174225500004],
              [-63.47630774599992, 67.34088776200008],
              [-63.38613847599993, 67.31171295800004],
              [-63.360218878999945, 67.29621002800008],
              [-63.40916907499991, 67.27533600500004],
              [-63.46084550699993, 67.27024974200003],
              [-63.770090298999946, 67.27586497600004],
              [-63.83315995999993, 67.28998444200005],
              [-63.82249915299991, 67.29303620000007],
              [-63.78307044199994, 67.30955638200004],
              [-63.75169837099992, 67.31903717700004],
              [-63.68687903599994, 67.34690989800004],
              [-63.66869055899991, 67.35146719000005],
              [-63.63158118399991, 67.35610586100006],
              [-63.60098222599993, 67.35504791900007],
              [-63.58531653599994, 67.34186432500007],
              [-63.593006964999915, 67.31049225500004],
              [-63.554351365999935, 67.31289297100005],
              [-63.53673255099994, 67.31708405200004],
              [-63.51789303299995, 67.32416413000004],
            ],
          ],
          [
            [
              [-63.757476365999935, 67.52277252800008],
              [-63.78929602799991, 67.51121653900003],
              [-63.982411261999914, 67.50674062700006],
              [-64.01667232999995, 67.51243724200003],
              [-64.03799394399994, 67.52960846600007],
              [-64.03213456899994, 67.55621979400007],
              [-64.0266820949999, 67.56622955900008],
              [-63.99156653599994, 67.60488515800006],
              [-63.98265540299991, 67.61749909100007],
              [-63.976551886999914, 67.63263580900008],
              [-63.982492641999954, 67.64313385600008],
              [-63.972727016999954, 67.65241120000007],
              [-63.95470130099994, 67.65497467700004],
              [-63.943023240999935, 67.64569733300004],
              [-63.92943274599992, 67.63947174700007],
              [-63.894520636999914, 67.60346100500004],
              [-63.7942602199999, 67.55560944200005],
              [-63.757476365999935, 67.52277252800008],
            ],
          ],
          [
            [
              [-73.35826575399994, 67.83808014500005],
              [-73.35968990799995, 67.82404205900008],
              [-73.3711645169999, 67.80316803600005],
              [-73.38902747299994, 67.78432851800005],
              [-73.4094945949999, 67.77602773600006],
              [-73.9059138659999, 67.77745189000007],
              [-74.40233313699991, 67.77887604400007],
              [-74.55064856699994, 67.81012604400007],
              [-74.59797115799995, 67.83022695500006],
              [-74.64024817599994, 67.85667552300004],
              [-74.7532445949999, 67.94741445500006],
              [-74.77013098899994, 67.96417877800008],
              [-74.77721106699994, 67.98517487200007],
              [-74.77521725199995, 68.02936432500007],
              [-74.76895097599993, 68.04832591400003],
              [-74.75601152299993, 68.06342194200005],
              [-74.73070227799991, 68.07412344000005],
              [-74.65729732999995, 68.08417389500005],
              [-74.47716223899994, 68.06981028900003],
              [-74.46206620999993, 68.07103099200003],
              [-74.44847571499992, 68.07562897300005],
              [-74.43455969999991, 68.08510976800005],
              [-74.43691972599993, 68.08608633000006],
              [-74.43797766799992, 68.09186432500007],
              [-74.43732662699995, 68.09926992400005],
              [-74.43455969999991, 68.10496653900003],
              [-74.42894446499992, 68.10834381700005],
              [-74.4094945949999, 68.11692942900004],
              [-74.40347245999993, 68.11859772300005],
              [-74.38581295499995, 68.12791575700004],
              [-74.36192786399994, 68.16986725500004],
              [-74.33836829299992, 68.18073151200008],
              [-74.30943762899994, 68.17523834800005],
              [-74.25084387899994, 68.14647044500003],
              [-74.22166907499991, 68.13971588700008],
              [-74.21442623599995, 68.13540273600006],
              [-74.21507727799991, 68.12579987200007],
              [-74.22179114499994, 68.11615631700005],
              [-74.24400794199994, 68.10822174700007],
              [-74.25926673099991, 68.09955475500004],
              [-74.27212480399993, 68.08844635600008],
              [-74.27696692599994, 68.07762278900003],
              [-74.25544186099995, 68.06346263200004],
              [-74.16087805899991, 68.07021719000005],
              [-74.12580318899995, 68.06708405200004],
              [-74.09190833199995, 68.05585358300004],
              [-73.92308508999992, 68.03384023600006],
              [-73.85619055899991, 68.01186758000006],
              [-73.82949785099993, 68.00714752800008],
              [-73.80431067599994, 67.99738190300008],
              [-73.78966223899994, 67.99510325700004],
              [-73.77554277299993, 67.99795156500005],
              [-73.74941972599993, 68.01129791900007],
              [-73.73501542899993, 68.01618073100008],
              [-73.71548417899993, 68.01715729400007],
              [-73.65973873599995, 68.00946686400005],
              [-73.6048070949999, 68.01581452000005],
              [-73.52183997299994, 68.00958893400008],
              [-73.44615637899994, 67.99298737200007],
              [-73.41291256399995, 67.96841054900005],
              [-73.43032792899993, 67.94232819200005],
              [-73.43342037699995, 67.93427155200004],
              [-73.43032792899993, 67.92279694200005],
              [-73.42247473899994, 67.91156647300005],
              [-73.41246497299994, 67.90289948100008],
              [-73.40298417899993, 67.89956289300005],
              [-73.39924068899995, 67.89443594000005],
              [-73.40074622299994, 67.88275788000004],
              [-73.40607662699995, 67.86196523600006],
              [-73.39932206899994, 67.85541413000004],
              [-73.36803137899994, 67.84414297100005],
              [-73.35826575399994, 67.83808014500005],
            ],
          ],
          [
            [
              [-66.29637610599991, 68.26947663000004],
              [-66.23338782499991, 68.27667877800008],
              [-66.19831295499995, 68.27570221600007],
              [-66.18309485599991, 68.26264069200005],
              [-66.19025631399995, 68.25511302300004],
              [-66.21715247299994, 68.24990469000005],
              [-66.21788489499994, 68.24213288000004],
              [-66.24404863199993, 68.23794179900005],
              [-66.26325436099995, 68.22215403900003],
              [-66.27065995999993, 68.20026276200008],
              [-66.26195227799991, 68.17694733300004],
              [-66.27057857999995, 68.16144440300008],
              [-66.31663977799991, 68.15949127800008],
              [-66.58096269399994, 68.18691640800006],
              [-66.61953691299993, 68.18573639500005],
              [-66.63756262899994, 68.18870677300004],
              [-66.65269934799994, 68.19773997600004],
              [-66.66112219999991, 68.20945872600004],
              [-66.65859941299993, 68.21637604400007],
              [-66.64712480399993, 68.21995677300004],
              [-66.62877356699994, 68.22166575700004],
              [-66.59601803299995, 68.21869538000004],
              [-66.57066809799994, 68.21246979400007],
              [-66.54775956899994, 68.21352773600006],
              [-66.52232825399994, 68.23224518400008],
              [-66.49689693899995, 68.24396393400008],
              [-66.45933997299994, 68.24677155200004],
              [-66.34357662699995, 68.23419830900008],
              [-66.32774817599994, 68.23590729400007],
              [-66.31737219999991, 68.24258047100005],
              [-66.30589758999992, 68.25389232000003],
              [-66.29751542899993, 68.26463450700004],
              [-66.29637610599991, 68.26947663000004],
            ],
          ],
          [
            [
              [-86.57713782499991, 68.29059479400007],
              [-86.50234941299993, 68.26316966400003],
              [-86.42967688699991, 68.21906159100007],
              [-86.41600501199991, 68.21426015800006],
              [-86.40782630099994, 68.20774974200003],
              [-86.41502844999991, 68.19318268400008],
              [-86.43370520699995, 68.16705963700008],
              [-86.43541419199994, 68.15159739800004],
              [-86.43541419199994, 68.09813060100004],
              [-86.43000240799995, 68.08136627800008],
              [-86.41490637899994, 68.06378815300008],
              [-86.40217037699995, 68.04389069200005],
              [-86.39216061099995, 68.02313873900005],
              [-86.37376868399991, 67.95917389500005],
              [-86.37246660099993, 67.93659088700008],
              [-86.38190670499995, 67.92682526200008],
              [-86.41266842399995, 67.84491608300004],
              [-86.46450761599993, 67.79189687700006],
              [-86.47777258999992, 67.78286367400005],
              [-86.51060950399994, 67.77464427300004],
              [-86.56655839799993, 67.73777903900003],
              [-86.59752356699994, 67.72821686400005],
              [-86.63878333199995, 67.72915273600006],
              [-86.68008378799993, 67.73505280200004],
              [-86.69448808499993, 67.74188873900005],
              [-86.70986894399994, 67.75820547100005],
              [-86.7207738919999, 67.76581452000005],
              [-86.75853430899991, 67.77753327000005],
              [-86.83657792899993, 67.79181549700007],
              [-86.8718969389999, 67.81012604400007],
              [-86.88609778599994, 67.82294342700004],
              [-86.92039954299992, 67.86139557500007],
              [-86.92711341099994, 67.87567780200004],
              [-86.93024654899995, 67.88735586100006],
              [-86.94391842399995, 67.90704987200007],
              [-86.94701087099992, 67.91689687700006],
              [-86.94904537699995, 67.91998932500007],
              [-86.95254472599993, 67.92182038000004],
              [-86.95421301999994, 67.92454661700003],
              [-86.95042883999992, 67.93056875200006],
              [-86.94090735599991, 67.93707916900007],
              [-86.9329320949999, 67.93618398600006],
              [-86.92438717399995, 67.93333567900004],
              [-86.9129125639999, 67.93427155200004],
              [-86.90709387899994, 67.93829987200007],
              [-86.8977758449999, 67.95075104400007],
              [-86.89240475199995, 67.95477936400005],
              [-86.88316809799994, 67.95648834800005],
              [-86.86685136599993, 67.95697663000004],
              [-86.85826575399994, 67.96100495000007],
              [-86.85069739499994, 67.96572500200006],
              [-86.84862219999991, 67.96649811400005],
              [-86.84398352799991, 67.97528717700004],
              [-86.83804277299993, 67.99091217700004],
              [-86.83714758999992, 67.99201080900008],
              [-86.84788977799991, 68.02216217700004],
              [-86.87441972599993, 68.03375885600008],
              [-86.94017493399991, 68.04291413000004],
              [-86.96898352799991, 68.05467357000003],
              [-86.98570716099994, 68.06745026200008],
              [-86.98737545499995, 68.08429596600007],
              [-86.97126217399995, 68.10838450700004],
              [-86.96019446499992, 68.11473216400003],
              [-86.90916907499991, 68.13226959800005],
              [-86.89785722599993, 68.13788483300004],
              [-86.90078691299993, 68.15070221600007],
              [-86.9129125639999, 68.17328522300005],
              [-86.89513098899994, 68.19513580900008],
              [-86.82664954299992, 68.22776927300004],
              [-86.7996313139999, 68.24583567900004],
              [-86.77635657499991, 68.26727936400005],
              [-86.74771074099993, 68.28701406500005],
              [-86.71690833199995, 68.30231354400007],
              [-86.68691972599993, 68.31037018400008],
              [-86.66002356699994, 68.31037018400008],
              [-86.57713782499991, 68.29059479400007],
            ],
          ],
          [
            [
              [-75.03351803299995, 68.17328522300005],
              [-75.02879798099991, 68.16925690300008],
              [-75.00991777299993, 68.14594147300005],
              [-75.00560462099992, 68.13711172100005],
              [-75.00352942599994, 68.12327708500004],
              [-75.00719153599994, 68.11054108300004],
              [-75.03465735599991, 68.09926992400005],
              [-75.04271399599992, 68.08563873900005],
              [-75.05150305899991, 68.05719635600008],
              [-75.07005774599992, 68.03318919500003],
              [-75.14305579299992, 67.97833893400008],
              [-75.16136633999992, 67.95311107000003],
              [-75.15318762899994, 67.93821849200003],
              [-75.13565019399994, 67.92279694200005],
              [-75.11668860599991, 67.86627838700008],
              [-75.09434973899994, 67.84731679900005],
              [-75.06729081899994, 67.83299388200004],
              [-75.04405676999994, 67.81696198100008],
              [-75.06094316299993, 67.77692291900007],
              [-75.06554114499994, 67.73167552300004],
              [-75.05931555899991, 67.68622467700004],
              [-75.04405676999994, 67.64569733300004],
              [-75.03685462099992, 67.63690827000005],
              [-75.03136145699995, 67.63442617400005],
              [-75.0286352199999, 67.63068268400008],
              [-75.02977454299992, 67.61835358300004],
              [-75.0352270169999, 67.60748932500007],
              [-75.05370032499991, 67.58421458500004],
              [-75.06505286399994, 67.55243561400005],
              [-75.08242753799993, 67.53318919500003],
              [-75.13939368399991, 67.48676178600005],
              [-75.18447831899994, 67.46010976800005],
              [-75.20482337099992, 67.44391510600008],
              [-75.22956295499995, 67.43203359600005],
              [-75.29796301999994, 67.42267487200007],
              [-75.32526607999995, 67.41290924700007],
              [-75.32664954299992, 67.40940989800004],
              [-75.32697506399995, 67.40375397300005],
              [-75.32795162699995, 67.39744700700004],
              [-75.33141028599994, 67.39240143400008],
              [-75.33804277299993, 67.38939036700003],
              [-75.35216223899994, 67.38788483300004],
              [-75.35936438699991, 67.38556549700007],
              [-75.36799068899995, 67.37958405200004],
              [-75.38792883999992, 67.36147695500006],
              [-75.39045162699995, 67.35765208500004],
              [-75.51056881399995, 67.36107005400004],
              [-75.54377193899995, 67.35146719000005],
              [-75.55370032499991, 67.34320709800005],
              [-75.56826738199993, 67.32436758000006],
              [-75.57848059799994, 67.31671784100007],
              [-75.59585527299993, 67.31110260600008],
              [-75.68968665299991, 67.30780670800004],
              [-75.88927161399994, 67.25800202000005],
              [-75.92105058499993, 67.25527578300006],
              [-76.08897864499994, 67.26211172100005],
              [-76.14761308499993, 67.25527578300006],
              [-76.24327551999994, 67.26951732000003],
              [-76.27464758999992, 67.26520416900007],
              [-76.33775794199994, 67.24591705900008],
              [-76.36681067599994, 67.24160390800006],
              [-76.53766842399995, 67.24754466400003],
              [-76.60098222599993, 67.23200104400007],
              [-76.63365637899994, 67.22797272300005],
              [-76.98155676999994, 67.24331289300005],
              [-77.02098548099991, 67.25869375200006],
              [-77.03319251199991, 67.26585521000004],
              [-77.06200110599991, 67.27582428600005],
              [-77.07591712099992, 67.28628164300005],
              [-77.11343339799993, 67.32416413000004],
              [-77.16808020699995, 67.40607330900008],
              [-77.16185462099992, 67.40607330900008],
              [-77.17804928299995, 67.42552317900004],
              [-77.20099850199995, 67.43598053600005],
              [-77.22655188699991, 67.44342682500007],
              [-77.25059973899994, 67.45384349200003],
              [-77.24185136599993, 67.47357819200005],
              [-77.23802649599992, 67.48944733300004],
              [-77.24233964799993, 67.50462474200003],
              [-77.25804602799991, 67.52277252800008],
              [-77.23546301999994, 67.52924225500004],
              [-77.22695878799993, 67.53497955900008],
              [-77.22329667899993, 67.54328034100007],
              [-77.22765051999994, 67.55243561400005],
              [-77.24844316299993, 67.57868073100008],
              [-77.2637426419999, 67.59393952000005],
              [-77.31822669199994, 67.68793366100005],
              [-77.32266191299993, 67.70799388200004],
              [-77.31578528599994, 67.72508372600004],
              [-77.30150305899991, 67.74192942900004],
              [-77.24494381399995, 67.83600495000007],
              [-77.2122289699999, 67.87042877800008],
              [-76.98306230399993, 68.06342194200005],
              [-76.90802975199995, 68.11180247600004],
              [-76.88068600199995, 68.14280833500004],
              [-76.87718665299991, 68.15281810100004],
              [-76.86839758999992, 68.15900299700007],
              [-76.84654700399994, 68.16705963700008],
              [-76.73078365799995, 68.24310944200005],
              [-76.68887285099993, 68.26264069200005],
              [-76.29914303299995, 68.33478424700007],
              [-76.27163652299993, 68.33612702000005],
              [-76.25218665299991, 68.33173248900005],
              [-76.25625566299993, 68.31785716400003],
              [-76.22813880099994, 68.30385976800005],
              [-76.18268795499995, 68.29779694200005],
              [-76.08185787699995, 68.29767487200007],
              [-76.04792232999995, 68.30475495000007],
              [-75.99120032499991, 68.32884349200003],
              [-75.91120357999995, 68.34454987200007],
              [-75.59748287699995, 68.31378815300008],
              [-75.49657141799992, 68.28314850500004],
              [-75.13760331899994, 68.23627350500004],
              [-75.11705481699994, 68.22182851800005],
              [-75.09959876199991, 68.20376211100006],
              [-75.07876542899993, 68.18691640800006],
              [-75.07079016799992, 68.18305084800005],
              [-75.04515540299991, 68.17479075700004],
              [-75.03351803299995, 68.17328522300005],
            ],
          ],
          [
            [
              [-78.90904700399994, 68.32404205900008],
              [-78.83120683499993, 68.30076732000003],
              [-78.81041419199994, 68.28449127800008],
              [-78.82998613199993, 68.25267161700003],
              [-78.87124589799993, 68.23037344000005],
              [-78.96914628799993, 68.20429108300004],
              [-79.00841223899994, 68.17694733300004],
              [-79.0442602199999, 68.16620514500005],
              [-79.09752356699994, 68.17706940300008],
              [-79.15001380099994, 68.19912344000005],
              [-79.18346106699994, 68.22166575700004],
              [-79.17601477799991, 68.22846100500004],
              [-79.1868383449999, 68.24632396000004],
              [-79.19054114499994, 68.26788971600007],
              [-79.18883216099994, 68.29022858300004],
              [-79.18224036399994, 68.31663646000004],
              [-79.18321692599994, 68.31907786700003],
              [-79.18236243399991, 68.32245514500005],
              [-79.17601477799991, 68.33152903900003],
              [-79.15611731699994, 68.34454987200007],
              [-79.14557857999995, 68.34756094000005],
              [-78.94131425699993, 68.35358307500007],
              [-78.92894446499992, 68.35138580900008],
              [-78.92772376199991, 68.34804922100005],
              [-78.91494706899994, 68.32990143400008],
              [-78.90904700399994, 68.32404205900008],
            ],
          ],
          [
            [
              [-82.08141028599994, 68.30731842700004],
              [-82.14932206899994, 68.33441803600005],
              [-82.26040605399993, 68.34442780200004],
              [-82.3489477199999, 68.36505768400008],
              [-82.32803300699993, 68.37860748900005],
              [-82.25572669199994, 68.36188385600008],
              [-82.22545325399994, 68.36505768400008],
              [-82.23192298099991, 68.36871979400007],
              [-82.24083411399994, 68.37612539300005],
              [-82.24596106699994, 68.37929922100005],
              [-82.24596106699994, 68.38556549700007],
              [-82.17666581899994, 68.38544342700004],
              [-82.14073645699995, 68.37970612200007],
              [-82.11558997299994, 68.36505768400008],
              [-82.12022864499994, 68.35643138200004],
              [-82.11180579299992, 68.35236237200007],
              [-82.09683183499993, 68.35114166900007],
              [-82.02196204299992, 68.35419342700004],
              [-82.00011145699995, 68.35138580900008],
              [-82.00084387899994, 68.34589264500005],
              [-82.00348873599995, 68.34251536700003],
              [-82.04710852799991, 68.31679922100005],
              [-82.06639563699991, 68.30805084800005],
              [-82.08141028599994, 68.30731842700004],
            ],
          ],
          [
            [
              [-74.36876380099994, 68.38922760600008],
              [-74.39220130099994, 68.40912506700005],
              [-74.40094967399995, 68.42259349200003],
              [-74.39976966099994, 68.44082265800006],
              [-74.39049231699994, 68.45368073100008],
              [-74.37608801999994, 68.46259186400005],
              [-74.35973059799994, 68.46751536700003],
              [-74.32022050699993, 68.46881745000007],
              [-74.29775956899994, 68.46442291900007],
              [-74.24791419199994, 68.44318268400008],
              [-74.17039954299992, 68.39972565300008],
              [-74.11864173099991, 68.35883209800005],
              [-74.08409583199995, 68.34324778900003],
              [-74.08071855399993, 68.33270905200004],
              [-74.09439042899993, 68.31415436400005],
              [-74.10863196499992, 68.30540599200003],
              [-74.12564042899993, 68.29852936400005],
              [-74.1399633449999, 68.28912995000007],
              [-74.15387936099995, 68.25556061400005],
              [-74.17332923099991, 68.24713776200008],
              [-74.19810950399994, 68.24579498900005],
              [-74.22166907499991, 68.24957916900007],
              [-74.25731360599991, 68.26894765800006],
              [-74.27131100199995, 68.29482656500005],
              [-74.25877844999991, 68.31513092700004],
              [-74.2149145169999, 68.31785716400003],
              [-74.2149145169999, 68.32404205900008],
              [-74.29674231699994, 68.34560781500005],
              [-74.33454342399995, 68.36050039300005],
              [-74.36876380099994, 68.38922760600008],
            ],
          ],
          [
            [
              [-78.61424719999991, 68.50629303600005],
              [-78.62401282499991, 68.49310944200005],
              [-78.6465551419999, 68.48265208500004],
              [-78.73741614499994, 68.45233795800004],
              [-78.78408769399994, 68.44586823100008],
              [-78.83165442599994, 68.44733307500007],
              [-78.88182532499991, 68.45441315300008],
              [-78.86656653599994, 68.46572500200006],
              [-78.86070716099994, 68.46869538000004],
              [-78.88434811099995, 68.47650788000004],
              [-78.97057044199994, 68.47492096600007],
              [-78.95897376199991, 68.48187897300005],
              [-78.94823157499991, 68.49103424700007],
              [-78.94367428299995, 68.50088125200006],
              [-78.95067298099991, 68.50967031500005],
              [-78.93553626199991, 68.52187734600005],
              [-78.92039954299992, 68.52204010600008],
              [-78.90469316299993, 68.51764557500007],
              [-78.8880102199999, 68.51585521000004],
              [-78.87096106699994, 68.52265045800004],
              [-78.84422766799992, 68.54559967700004],
              [-78.82998613199993, 68.55068594000005],
              [-78.74278723899994, 68.55194733300004],
              [-78.70335852799991, 68.56171295800004],
              [-78.66885331899994, 68.58478424700007],
              [-78.69245357999995, 68.59983958500004],
              [-78.72057044199994, 68.60492584800005],
              [-78.75015214799993, 68.60667552300004],
              [-78.77814693899995, 68.61212799700007],
              [-78.77188066299993, 68.61953359600005],
              [-78.9016820949999, 68.65302155200004],
              [-78.89354407499991, 68.65668366100005],
              [-78.88630123599995, 68.65888092700004],
              [-78.86750240799995, 68.66046784100007],
              [-78.84251868399991, 68.66730377800008],
              [-78.6751195949999, 68.65835195500006],
              [-78.64903723899994, 68.65302155200004],
              [-78.58584550699993, 68.62982819200005],
              [-78.5664770169999, 68.62571849200003],
              [-78.48985755099994, 68.62738678600005],
              [-78.46344967399995, 68.61953359600005],
              [-78.46568762899994, 68.61123281500005],
              [-78.46593176999994, 68.60834381700005],
              [-78.46499589799993, 68.60565827000005],
              [-78.46344967399995, 68.59780508000006],
              [-78.47276770699995, 68.59194570500006],
              [-78.47520911399994, 68.58222077000005],
              [-78.47695878799993, 68.57021719000005],
              [-78.48395748599995, 68.55744049700007],
              [-78.50527910099993, 68.54547760600008],
              [-78.53099524599992, 68.54437897300005],
              [-78.65664628799993, 68.56313711100006],
              [-78.66885331899994, 68.55402252800008],
              [-78.67552649599992, 68.54043203300006],
              [-78.69115149599992, 68.53119538000004],
              [-78.70946204299992, 68.52562083500004],
              [-78.72419186099995, 68.52334219000005],
              [-78.70010331899994, 68.51821523600006],
              [-78.62922115799995, 68.51520416900007],
              [-78.61424719999991, 68.50629303600005],
            ],
          ],
          [
            [
              [-74.84483801999994, 68.57855866100005],
              [-74.85846920499995, 68.58954498900005],
              [-74.89321855399993, 68.62571849200003],
              [-74.82982337099992, 68.66160716400003],
              [-74.79259192599994, 68.67568594000005],
              [-74.68301347599993, 68.66327545800004],
              [-74.64606686099995, 68.64744700700004],
              [-74.64964758999992, 68.62262604400007],
              [-74.64745032499991, 68.61163971600007],
              [-74.62364661399994, 68.60382721600007],
              [-74.57453365799995, 68.59780508000006],
              [-74.56354732999995, 68.59365469000005],
              [-74.51707923099991, 68.56427643400008],
              [-74.53819739499994, 68.55499909100007],
              [-74.78819739499994, 68.56134674700007],
              [-74.81908118399991, 68.56769440300008],
              [-74.84483801999994, 68.57855866100005],
            ],
          ],
          [
            [
              [-74.83800208199995, 68.42023346600007],
              [-74.79600989499994, 68.42169830900008],
              [-74.78425045499995, 68.41791413000004],
              [-74.79084225199995, 68.40599192900004],
              [-74.80524654899995, 68.39801666900007],
              [-74.82648678299995, 68.39118073100008],
              [-74.84850012899994, 68.38654205900008],
              [-74.86534583199995, 68.38556549700007],
              [-74.86534583199995, 68.37929922100005],
              [-74.85008704299992, 68.37840403900003],
              [-74.82681230399993, 68.37457916900007],
              [-74.80752519399994, 68.36615631700005],
              [-74.80451412699995, 68.35138580900008],
              [-74.81480872299994, 68.34398021000004],
              [-74.84508216099994, 68.34926992400005],
              [-74.85912024599992, 68.34454987200007],
              [-74.83299719999991, 68.33852773600006],
              [-74.82144120999993, 68.33307526200008],
              [-74.81126868399991, 68.32404205900008],
              [-74.84264075399994, 68.32269928600005],
              [-74.85228430899991, 68.32404205900008],
              [-74.86481686099995, 68.33047109600005],
              [-74.87413489499994, 68.33852773600006],
              [-74.88414466099994, 68.34398021000004],
              [-74.97630774599992, 68.33515045800004],
              [-74.99624589799993, 68.33771393400008],
              [-75.00645911399994, 68.34617747600004],
              [-75.00731360599991, 68.36912669500003],
              [-75.01618404899995, 68.38556549700007],
              [-75.03465735599991, 68.39720286700003],
              [-75.25633704299992, 68.44936758000006],
              [-75.3789770169999, 68.49884674700007],
              [-75.41148841099994, 68.52277252800008],
              [-75.39415442599994, 68.55068594000005],
              [-75.40038001199991, 68.55068594000005],
              [-75.39452063699991, 68.56500885600008],
              [-75.39513098899994, 68.57908763200004],
              [-75.40038001199991, 68.60871002800008],
              [-75.39207923099991, 68.62596263200004],
              [-75.33141028599994, 68.66046784100007],
              [-75.32396399599992, 68.67108795800004],
              [-75.31004798099991, 68.69643789300005],
              [-75.30101477799991, 68.70140208500004],
              [-75.28246008999992, 68.70844147300005],
              [-75.26036536399994, 68.72064850500004],
              [-75.23892167899993, 68.72479889500005],
              [-75.22223873599995, 68.70766836100006],
              [-75.20181230399993, 68.70270416900007],
              [-75.17048092399995, 68.68984609600005],
              [-75.01988684799994, 68.68097565300008],
              [-74.98936926999994, 68.66876862200007],
              [-74.97435462099992, 68.64105866100005],
              [-74.96251380099994, 68.61102936400005],
              [-74.94163977799991, 68.59153880400004],
              [-74.93390865799995, 68.57135651200008],
              [-74.90330969999991, 68.55288320500006],
              [-74.86701412699995, 68.53571198100008],
              [-74.82640540299991, 68.50885651200008],
              [-74.79067949099993, 68.49607982000003],
              [-74.77375240799995, 68.48550039300005],
              [-74.77098548099991, 68.47329336100006],
              [-74.78148352799991, 68.46100495000007],
              [-74.79759680899991, 68.45140208500004],
              [-74.81126868399991, 68.44757721600007],
              [-74.86217200399994, 68.45014069200005],
              [-74.88687089799993, 68.44660065300008],
              [-74.90005449099993, 68.43390534100007],
              [-74.89610755099994, 68.42182038000004],
              [-74.87987219999991, 68.41819896000004],
              [-74.83800208199995, 68.42023346600007],
            ],
          ],
          [
            [
              [-68.00609290299991, 68.77033112200007],
              [-67.69627844999991, 68.71946849200003],
              [-67.66344153599994, 68.70766836100006],
              [-67.66344153599994, 68.70140208500004],
              [-67.91466223899994, 68.71051666900007],
              [-68.18732662699995, 68.76691315300008],
              [-68.44200598899994, 68.78457265800006],
              [-68.45856686099995, 68.79364655200004],
              [-68.45311438699991, 68.80927155200004],
              [-68.44054114499994, 68.81622955900008],
              [-68.42682857999995, 68.81781647300005],
              [-68.41759192599994, 68.81753164300005],
              [-68.39586341099994, 68.80939362200007],
              [-68.32140051999994, 68.79706452000005],
              [-68.20470130099994, 68.79706452000005],
              [-68.00609290299991, 68.77033112200007],
            ],
          ],
          [
            [
              [-90.18203691299993, 69.11920807500007],
              [-90.17105058499993, 69.11733633000006],
              [-90.16161048099991, 69.11395905200004],
              [-90.15367591099994, 69.10980866100005],
              [-90.1472875639999, 69.10553620000007],
              [-90.14464270699995, 69.09113190300008],
              [-90.12999426999994, 69.06500885600008],
              [-90.12743079299992, 69.05776601800005],
              [-90.1380102199999, 69.04995351800005],
              [-90.15465247299994, 69.05101146000004],
              [-90.1660863919999, 69.06053294500003],
              [-90.1609594389999, 69.07819245000007],
              [-90.21165930899991, 69.06952545800004],
              [-90.23420162699995, 69.07050202000005],
              [-90.25373287699995, 69.08161041900007],
              [-90.2688695949999, 69.09857819200005],
              [-90.27676347599993, 69.11399974200003],
              [-90.27574622299994, 69.12962474200003],
              [-90.26398678299995, 69.14712148600006],
              [-90.25422115799995, 69.13987864800004],
              [-90.25438391799992, 69.13060130400004],
              [-90.25157630099994, 69.12262604400007],
              [-90.23298092399995, 69.11920807500007],
              [-90.21226966099994, 69.12466054900005],
              [-90.19591223899994, 69.13540273600006],
              [-90.17845618399991, 69.14313385600008],
              [-90.15469316299993, 69.13963450700004],
              [-90.16006425699993, 69.13336823100008],
              [-90.16543535099993, 69.12946198100008],
              [-90.17235266799992, 69.12738678600005],
              [-90.18203691299993, 69.12665436400005],
              [-90.18203691299993, 69.11920807500007],
            ],
          ],
          [
            [
              [-90.4973852199999, 69.24266185100004],
              [-90.4883520169999, 69.24787018400008],
              [-90.47935950399994, 69.24966054900005],
              [-90.47069251199991, 69.24799225500004],
              [-90.46255449099993, 69.24266185100004],
              [-90.45628821499992, 69.23419830900008],
              [-90.45938066299993, 69.22968170800004],
              [-90.46735592399995, 69.22654857000003],
              [-90.48916581899994, 69.21491120000007],
              [-90.50503495999993, 69.21149323100008],
              [-90.53831946499992, 69.20856354400007],
              [-90.57225501199991, 69.20156484600005],
              [-90.59056555899991, 69.20014069200005],
              [-90.60350501199991, 69.20482005400004],
              [-90.61021887899994, 69.21507396000004],
              [-90.61432857999995, 69.22577545800004],
              [-90.62067623599995, 69.23541901200008],
              [-90.63390051999994, 69.24266185100004],
              [-90.6243383449999, 69.24819570500006],
              [-90.62022864499994, 69.24949778900003],
              [-90.62022864499994, 69.25633372600004],
              [-90.64110266799992, 69.25446198100008],
              [-90.65656490799995, 69.24477773600006],
              [-90.67015540299991, 69.23407623900005],
              [-90.68541419199994, 69.22907135600008],
              [-90.69127356699994, 69.23432038000004],
              [-90.68077551999994, 69.24603913000004],
              [-90.66331946499992, 69.25775788000004],
              [-90.64818274599992, 69.26312897300005],
              [-90.64818274599992, 69.27000560100004],
              [-90.67951412699995, 69.26805247600004],
              [-90.6914770169999, 69.27167389500005],
              [-90.6953832669999, 69.28367747600004],
              [-90.69009355399993, 69.28974030200004],
              [-90.65440833199995, 69.31098053600005],
              [-90.6817113919999, 69.31098053600005],
              [-90.6817113919999, 69.31842682500007],
              [-90.66030839799993, 69.33234284100007],
              [-90.65599524599992, 69.34979889500005],
              [-90.66714433499993, 69.35748932500007],
              [-90.69225012899994, 69.34198639500005],
              [-90.73021399599992, 69.30402252800008],
              [-90.75055904899995, 69.28925202000005],
              [-90.77725175699993, 69.27680084800005],
              [-90.77700761599993, 69.32868073100008],
              [-90.77106686099995, 69.34511953300006],
              [-90.75690670499995, 69.35708242400005],
              [-90.73668372299994, 69.36522044500003],
              [-90.65953528599994, 69.38129303600005],
              [-90.61896725199995, 69.37636953300006],
              [-90.57982337099992, 69.36196523600006],
              [-90.54820716099994, 69.34198639500005],
              [-90.53795325399994, 69.33169179900005],
              [-90.52330481699994, 69.31134674700007],
              [-90.51378333199995, 69.30101146000004],
              [-90.49901282499991, 69.29218170800004],
              [-90.48379472599993, 69.28660716400003],
              [-90.47081458199995, 69.27887604400007],
              [-90.46255449099993, 69.26312897300005],
              [-90.47374426999994, 69.26141998900005],
              [-90.4837133449999, 69.25751373900005],
              [-90.49176998599995, 69.25128815300008],
              [-90.4973852199999, 69.24266185100004],
            ],
          ],
          [
            [
              [-79.07982337099992, 68.87897370000007],
              [-79.14464270699995, 68.86933014500005],
              [-79.16266842399995, 68.86220937700006],
              [-79.21275794199994, 68.83490631700005],
              [-79.2278539699999, 68.83120351800005],
              [-79.26817786399994, 68.83226146000004],
              [-79.28799394399994, 68.83551666900007],
              [-79.34552975199995, 68.85268789300005],
              [-79.38548743399991, 68.85846588700008],
              [-79.39671790299991, 68.86322663000004],
              [-79.40001380099994, 68.87421295800004],
              [-79.39761308499993, 68.88678620000007],
              [-79.39199785099993, 68.89638906500005],
              [-79.38817298099991, 68.90696849200003],
              [-79.39858964799993, 68.91307200700004],
              [-79.41344153599994, 68.91864655200004],
              [-79.42300370999993, 68.92739492400005],
              [-79.36864173099991, 68.94159577000005],
              [-79.32583574099993, 68.96991608300004],
              [-79.24176998599995, 69.06207916900007],
              [-79.22484290299991, 69.07534414300005],
              [-79.20417232999995, 69.08490631700005],
              [-79.17601477799991, 69.09186432500007],
              [-79.15998287699995, 69.09373607000003],
              [-79.12071692599994, 69.09186432500007],
              [-79.09972083199995, 69.09393952000005],
              [-79.06248938699991, 69.10342031500005],
              [-79.04255123599995, 69.10553620000007],
              [-78.97642981699994, 69.10370514500005],
              [-78.95750891799992, 69.10919830900008],
              [-78.92308508999992, 69.12946198100008],
              [-78.91063391799992, 69.13458893400008],
              [-78.87612870999993, 69.14264557500007],
              [-78.86327063699991, 69.14842357000003],
              [-78.85448157499991, 69.16014232000003],
              [-78.8528539699999, 69.17182038000004],
              [-78.85757402299993, 69.19041575700004],
              [-78.85448157499991, 69.20111725500004],
              [-78.83877519399994, 69.21527741100005],
              [-78.76512610599991, 69.25633372600004],
              [-78.72728430899991, 69.26984284100007],
              [-78.6582738919999, 69.25787995000007],
              [-78.62169348899994, 69.26312897300005],
              [-78.64704342399995, 69.28070709800005],
              [-78.71092688699991, 69.30341217700004],
              [-78.73094641799992, 69.32526276200008],
              [-78.72232011599993, 69.33714427300004],
              [-78.71011308499993, 69.34162018400008],
              [-78.67568925699993, 69.34511953300006],
              [-78.65721594999991, 69.35077545800004],
              [-78.60741126199991, 69.37299225500004],
              [-78.58543860599991, 69.37702057500007],
              [-78.52489173099991, 69.37986888200004],
              [-78.47740637899994, 69.39183177300004],
              [-78.45665442599994, 69.39354075700004],
              [-78.41222083199995, 69.38690827000005],
              [-78.31273352799991, 69.38711172100005],
              [-78.27505449099993, 69.36961497600004],
              [-78.24058997299994, 69.32831452000005],
              [-78.21401933499993, 69.30288320500006],
              [-78.21467037699995, 69.29393138200004],
              [-78.23717200399994, 69.29047272300005],
              [-78.26349850199995, 69.28221263200004],
              [-78.29507402299993, 69.26251862200007],
              [-78.32188880099994, 69.23883698100008],
              [-78.33311926999994, 69.21881745000007],
              [-78.34170488199993, 69.20677317900004],
              [-78.36070716099994, 69.19920482000003],
              [-78.37970943899995, 69.19794342700004],
              [-78.38833574099993, 69.20482005400004],
              [-78.39696204299992, 69.21771881700005],
              [-78.41710364499994, 69.22264232000003],
              [-78.43993079299992, 69.22475820500006],
              [-78.45665442599994, 69.22907135600008],
              [-78.47158769399994, 69.21946849200003],
              [-78.47508704299992, 69.20555247600004],
              [-78.47085527299993, 69.17072174700007],
              [-78.4837133449999, 69.16201406500005],
              [-78.54515540299991, 69.14301178600005],
              [-78.5664770169999, 69.13279857000003],
              [-78.55158443899995, 69.10244375200006],
              [-78.60383053299995, 69.06903717700004],
              [-78.71727454299992, 69.01679108300004],
              [-78.72028561099995, 69.00763580900008],
              [-78.71987870999993, 68.98554108300004],
              [-78.72419186099995, 68.97516510600008],
              [-78.73989824099993, 68.96426015800006],
              [-78.79922441299993, 68.95132070500006],
              [-78.81078040299991, 68.94391510600008],
              [-78.81688391799992, 68.93659088700008],
              [-78.82176673099991, 68.92816803600005],
              [-78.82998613199993, 68.91742584800005],
              [-78.84658769399994, 68.90790436400005],
              [-78.87059485599991, 68.90249258000006],
              [-78.93272864499994, 68.89728424700007],
              [-78.96532141799992, 68.88792552300004],
              [-79.07982337099992, 68.87897370000007],
            ],
          ],
          [
            [
              [-90.25035559799994, 69.29791901200008],
              [-90.25072180899991, 69.27838776200008],
              [-90.27171790299991, 69.26141998900005],
              [-90.29727128799993, 69.25397370000007],
              [-90.31175696499992, 69.26312897300005],
              [-90.31859290299991, 69.26312897300005],
              [-90.32762610599991, 69.23895905200004],
              [-90.35509192599994, 69.24648672100005],
              [-90.40794837099992, 69.27680084800005],
              [-90.40794837099992, 69.28367747600004],
              [-90.3946020169999, 69.29393138200004],
              [-90.40339107999995, 69.30019765800006],
              [-90.42308508999992, 69.30329010600008],
              [-90.44212805899991, 69.30414459800005],
              [-90.45864824099993, 69.30906810100004],
              [-90.48859615799995, 69.32929108300004],
              [-90.51036536399994, 69.33144765800006],
              [-90.50621497299994, 69.34467194200005],
              [-90.50865637899994, 69.35565827000005],
              [-90.50674394399994, 69.36664459800005],
              [-90.48989824099993, 69.37986888200004],
              [-90.38971920499995, 69.40338776200008],
              [-90.37319902299993, 69.41087474200003],
              [-90.36876380099994, 69.42206452000005],
              [-90.35741126199991, 69.42715078300006],
              [-90.32542883999992, 69.42829010600008],
              [-90.31501217399995, 69.42987702000005],
              [-90.30874589799993, 69.43305084800005],
              [-90.30235755099994, 69.43537018400008],
              [-90.29124915299991, 69.43451569200005],
              [-90.28111731699994, 69.43085358300004],
              [-90.25035559799994, 69.41400788000004],
              [-90.25035559799994, 69.40778229400007],
              [-90.25536048099991, 69.40436432500007],
              [-90.25841223899994, 69.40082428600005],
              [-90.26073157499991, 69.39728424700007],
              [-90.26398678299995, 69.39354075700004],
              [-90.23932857999995, 69.39459870000007],
              [-90.22638912699995, 69.40281810100004],
              [-90.22883053299995, 69.41510651200008],
              [-90.25035559799994, 69.42829010600008],
              [-90.23936926999994, 69.43231842700004],
              [-90.21593176999994, 69.44452545800004],
              [-90.20189368399991, 69.44814687700006],
              [-90.20933997299994, 69.43451569200005],
              [-90.20612545499995, 69.42942942900004],
              [-90.20299231699994, 69.42572663000004],
              [-90.19957434799994, 69.42300039300005],
              [-90.18321692599994, 69.41498444200005],
              [-90.17784583199995, 69.40566640800006],
              [-90.18138587099992, 69.39508698100008],
              [-90.19570878799993, 69.38605377800008],
              [-90.18199622299994, 69.38715241100005],
              [-90.16893469999991, 69.38621653900003],
              [-90.15721594999991, 69.38206614800004],
              [-90.1472875639999, 69.37299225500004],
              [-90.1536352199999, 69.36001211100006],
              [-90.16283118399991, 69.34906647300005],
              [-90.17536373599995, 69.34170156500005],
              [-90.21263587099992, 69.33490631700005],
              [-90.22549394399994, 69.32493724200003],
              [-90.23623613199993, 69.31171295800004],
              [-90.25035559799994, 69.29791901200008],
            ],
          ],
          [
            [
              [-76.69229081899994, 69.41087474200003],
              [-76.65306555899991, 69.39191315300008],
              [-76.64732825399994, 69.38296133000006],
              [-76.64964758999992, 69.37091705900008],
              [-76.65355383999992, 69.36054108300004],
              [-76.6543676419999, 69.35028717700004],
              [-76.64732825399994, 69.33893463700008],
              [-76.67345130099994, 69.33071523600006],
              [-76.67967688699991, 69.32343170800004],
              [-76.67520097599993, 69.31098053600005],
              [-76.70693925699993, 69.30597565300008],
              [-76.7656957669999, 69.28237539300005],
              [-76.79474850199995, 69.27680084800005],
              [-76.81578528599994, 69.27033112200007],
              [-76.85928300699993, 69.24176666900007],
              [-76.88414466099994, 69.23525625200006],
              [-76.9082738919999, 69.23208242400005],
              [-76.93028723899994, 69.22284577000005],
              [-76.94359290299991, 69.20799388200004],
              [-76.94212805899991, 69.18805573100008],
              [-76.92589270699995, 69.17133209800005],
              [-76.90396074099993, 69.16502513200004],
              [-76.88068600199995, 69.16168854400007],
              [-76.86021887899994, 69.15395742400005],
              [-76.87437903599994, 69.14472077000005],
              [-76.88939368399991, 69.13715241100005],
              [-76.92170162699995, 69.12665436400005],
              [-76.90758216099994, 69.11546458500004],
              [-76.90119381399995, 69.11298248900005],
              [-76.90119381399995, 69.10553620000007],
              [-76.93106035099993, 69.11115143400008],
              [-76.94456946499992, 69.11688873900005],
              [-76.95641028599994, 69.12665436400005],
              [-76.95506751199991, 69.14101797100005],
              [-76.9915258449999, 69.14508698100008],
              [-77.07249915299991, 69.13963450700004],
              [-77.13548743399991, 69.12107982000003],
              [-77.15819251199991, 69.11815013200004],
              [-77.2649633449999, 69.14671458500004],
              [-77.31944739499994, 69.18097565300008],
              [-77.36693274599992, 69.22459544500003],
              [-77.38719641799992, 69.26654694200005],
              [-77.38084876199991, 69.28400299700007],
              [-77.35045325399994, 69.31061432500007],
              [-77.33999589799993, 69.32526276200008],
              [-77.33885657499991, 69.34560781500005],
              [-77.34634355399993, 69.36172109600005],
              [-77.35582434799994, 69.37567780200004],
              [-77.36046301999994, 69.38979726800005],
              [-77.32677161399994, 69.41705963700008],
              [-77.25011145699995, 69.43512604400007],
              [-77.11343339799993, 69.44814687700006],
              [-77.08381100199995, 69.43089427300004],
              [-77.04775956899994, 69.41966380400004],
              [-76.97630774599992, 69.40778229400007],
              [-76.7844945949999, 69.40778229400007],
              [-76.75755774599992, 69.41315338700008],
              [-76.73672441299993, 69.42230866100005],
              [-76.71678626199991, 69.42499420800004],
              [-76.69229081899994, 69.41087474200003],
            ],
          ],
          [
            [
              [-67.44432532499991, 69.59210846600007],
              [-67.39842688699991, 69.59105052300004],
              [-67.37706458199995, 69.58600495000007],
              [-67.34752356699994, 69.56810130400004],
              [-67.32262122299994, 69.56281159100007],
              [-67.30776933499993, 69.55805084800005],
              [-67.35309811099995, 69.53188711100006],
              [-67.49669348899994, 69.53497955900008],
              [-67.55418860599991, 69.52326080900008],
              [-67.5364477199999, 69.52220286700003],
              [-67.50373287699995, 69.51211172100005],
              [-67.48908443899995, 69.50958893400008],
              [-67.48501542899993, 69.50755442900004],
              [-67.49063066299993, 69.50307851800005],
              [-67.50584876199991, 69.49591705900008],
              [-67.57803300699993, 69.51048411700003],
              [-67.62800045499995, 69.50267161700003],
              [-67.67516028599994, 69.51288483300004],
              [-67.72956295499995, 69.51536692900004],
              [-67.75283769399994, 69.52326080900008],
              [-67.74547278599994, 69.52838776200008],
              [-67.74282792899993, 69.53416575700004],
              [-67.74160722599993, 69.53978099200003],
              [-67.73859615799995, 69.54433828300006],
              [-67.72594153599994, 69.54987213700008],
              [-67.71458899599992, 69.54926178600005],
              [-67.70327714799993, 69.54621002800008],
              [-67.69078528599994, 69.54433828300006],
              [-67.66478430899991, 69.54743073100008],
              [-67.61436926999994, 69.56110260600008],
              [-67.56118730399993, 69.56631094000005],
              [-67.54727128799993, 69.56952545800004],
              [-67.53685462099992, 69.57477448100008],
              [-67.53148352799991, 69.58250560100004],
              [-67.52570553299995, 69.60032786700003],
              [-67.52009029899995, 69.60578034100007],
              [-67.51109778599994, 69.60740794500003],
              [-67.49974524599992, 69.60667552300004],
              [-67.49006100199995, 69.60301341400003],
              [-67.48595130099994, 69.59589264500005],
              [-67.48021399599992, 69.59243398600006],
              [-67.43687903599994, 69.59210846600007],
              [-67.44432532499991, 69.59210846600007],
            ],
          ],
          [
            [
              [-67.90990149599992, 69.53375885600008],
              [-67.96743730399993, 69.52985260600008],
              [-68.30772864499994, 69.59210846600007],
              [-68.28823808499993, 69.59943268400008],
              [-68.21898352799991, 69.60578034100007],
              [-68.22581946499992, 69.60578034100007],
              [-68.20710201699995, 69.61025625200006],
              [-68.17638098899994, 69.62885163000004],
              [-68.1380102199999, 69.63768138200004],
              [-68.07530676999994, 69.67096588700008],
              [-68.01398678299995, 69.67792389500005],
              [-67.88841712099992, 69.64911530200004],
              [-67.82795162699995, 69.66107819200005],
              [-67.94810950399994, 69.67983633000006],
              [-67.97256425699993, 69.69452545800004],
              [-67.97175045499995, 69.70661041900007],
              [-67.95579993399991, 69.71043528900003],
              [-67.91698157499991, 69.70880768400008],
              [-67.89146887899994, 69.71210358300004],
              [-67.88060462099992, 69.71051666900007],
              [-67.86888587099992, 69.70197174700007],
              [-67.84312903599994, 69.68915436400005],
              [-67.81676184799994, 69.68048737200007],
              [-67.78892981699994, 69.67568594000005],
              [-67.75902258999992, 69.67405833500004],
              [-67.76329505099994, 69.66669342700004],
              [-67.74864661399994, 69.66254303600005],
              [-67.73106848899994, 69.65875885600008],
              [-67.72492428299995, 69.64671458500004],
              [-67.73704993399991, 69.63519928600005],
              [-67.80748450399994, 69.61603424700007],
              [-67.86705481699994, 69.58270905200004],
              [-67.89708411399994, 69.55853913000004],
              [-67.90990149599992, 69.53375885600008],
            ],
          ],
          [
            [
              [-78.39452063699991, 69.64671458500004],
              [-78.38463294199994, 69.65932851800005],
              [-78.38792883999992, 69.67064036700003],
              [-78.3946020169999, 69.68207428600005],
              [-78.39452063699991, 69.69452545800004],
              [-78.37804114499994, 69.70457591400003],
              [-78.35220292899993, 69.70233795800004],
              [-78.30577551999994, 69.68773021000004],
              [-78.32363847599993, 69.67495351800005],
              [-78.29849199099993, 69.66209544500003],
              [-78.25816809799994, 69.65867747600004],
              [-78.23070227799991, 69.67405833500004],
              [-78.23326575399994, 69.68842194200005],
              [-78.26317298099991, 69.71845123900005],
              [-78.27163652299993, 69.73615143400008],
              [-78.2122289699999, 69.73712799700007],
              [-78.1946508449999, 69.75482819200005],
              [-78.17609615799995, 69.75641510600008],
              [-78.15542558499993, 69.75385163000004],
              [-78.14126542899993, 69.74982330900008],
              [-78.12751217399995, 69.73944733300004],
              [-78.11266028599994, 69.73676178600005],
              [-78.07982337099992, 69.73615143400008],
              [-78.02647864499994, 69.71857330900008],
              [-77.98786373599995, 69.69871653900003],
              [-77.97061113199993, 69.68451569200005],
              [-77.94204667899993, 69.64671458500004],
              [-77.95840410099993, 69.63324616100005],
              [-77.97728430899991, 69.62689850500004],
              [-78.01781165299991, 69.61945221600007],
              [-78.05109615799995, 69.60765208500004],
              [-78.0637914699999, 69.59992096600007],
              [-78.07648678299995, 69.58869049700007],
              [-78.09227454299992, 69.57831452000005],
              [-78.10879472599993, 69.57558828300006],
              [-78.14509029899995, 69.57786692900004],
              [-78.28697669199994, 69.55780670800004],
              [-78.36803137899994, 69.52968984600005],
              [-78.44273841099994, 69.51508209800005],
              [-78.51724199099993, 69.48476797100005],
              [-78.54600989499994, 69.48602936400005],
              [-78.58413652299993, 69.50311920800004],
              [-78.61945553299995, 69.51056549700007],
              [-78.65404212099992, 69.50824616100005],
              [-78.77529863199993, 69.46308014500005],
              [-78.82599850199995, 69.45160553600005],
              [-78.85757402299993, 69.45807526200008],
              [-78.87730872299994, 69.47260163000004],
              [-78.88072669199994, 69.48065827000005],
              [-78.87120520699995, 69.49286530200004],
              [-78.85464433499993, 69.50421784100007],
              [-78.68968665299991, 69.56110260600008],
              [-78.67365475199995, 69.57062409100007],
              [-78.61546790299991, 69.62091705900008],
              [-78.57982337099992, 69.63800690300008],
              [-78.5664770169999, 69.64671458500004],
              [-78.55223548099991, 69.64468008000006],
              [-78.48395748599995, 69.65420156500005],
              [-78.41392981699994, 69.64203522300005],
              [-78.39452063699991, 69.64671458500004],
            ],
          ],
          [
            [
              [-79.97105872299994, 69.63312409100007],
              [-80.02456620999993, 69.64630768400008],
              [-80.05321204299992, 69.64899323100008],
              [-80.07750403599994, 69.63686758000006],
              [-80.0618383449999, 69.61904531500005],
              [-79.97012285099993, 69.55385976800005],
              [-79.9363500639999, 69.53685130400004],
              [-79.96251380099994, 69.50665924700007],
              [-79.99864661399994, 69.50014883000006],
              [-80.09898841099994, 69.51264069200005],
              [-80.15038001199991, 69.52659739800004],
              [-80.21524003799993, 69.53327057500007],
              [-80.23062089799993, 69.54083893400008],
              [-80.23802649599992, 69.55805084800005],
              [-80.22948157499991, 69.57855866100005],
              [-80.21393795499995, 69.60081614800004],
              [-80.21035722599993, 69.61871979400007],
              [-80.23802649599992, 69.62628815300008],
              [-80.26097571499992, 69.61530182500007],
              [-80.30736243399991, 69.56757233300004],
              [-80.33421790299991, 69.55805084800005],
              [-80.33556067599994, 69.57379791900007],
              [-80.33877519399994, 69.59039948100008],
              [-80.34422766799992, 69.60537344000005],
              [-80.35155188699991, 69.61603424700007],
              [-80.36286373599995, 69.62201569200005],
              [-80.40249589799993, 69.62628815300008],
              [-80.41462154899995, 69.63129303600005],
              [-80.43724524599992, 69.64671458500004],
              [-80.49681555899991, 69.66754791900007],
              [-80.56216386599993, 69.67283763200004],
              [-80.76065019399994, 69.66795482000003],
              [-80.79792232999995, 69.67552317900004],
              [-80.81403561099995, 69.69452545800004],
              [-80.8035375639999, 69.70465729400007],
              [-80.75304114499994, 69.72190989800004],
              [-80.7351781889999, 69.73240794500003],
              [-80.73094641799992, 69.73989492400005],
              [-80.72956295499995, 69.74591705900008],
              [-80.72671464799993, 69.75112539300005],
              [-80.71837317599994, 69.75600820500006],
              [-80.64952551999994, 69.74982330900008],
              [-80.58747311099995, 69.72866445500006],
              [-80.53587805899991, 69.72752513200004],
              [-80.51915442599994, 69.72247955900008],
              [-80.50926673099991, 69.72772858300004],
              [-80.49380449099993, 69.72760651200008],
              [-80.47740637899994, 69.72304922100005],
              [-80.46450761599993, 69.71503327000005],
              [-80.46051998599995, 69.70799388200004],
              [-80.45653235599991, 69.69033437700006],
              [-80.45091712099992, 69.68154531500005],
              [-80.42536373599995, 69.66828034100007],
              [-80.40274003799993, 69.67015208500004],
              [-80.39757239499994, 69.68280670800004],
              [-80.42418372299994, 69.70197174700007],
              [-80.41222083199995, 69.70697663000004],
              [-80.38776607999995, 69.71027252800008],
              [-80.3758031889999, 69.71503327000005],
              [-80.40729732999995, 69.71718984600005],
              [-80.43565833199995, 69.72361888200004],
              [-80.46117102799991, 69.73444245000007],
              [-80.4844457669999, 69.74982330900008],
              [-80.49600175699993, 69.76141998900005],
              [-80.50401770699995, 69.77582428600005],
              [-80.50064042899993, 69.78742096600007],
              [-80.47817949099993, 69.79075755400004],
              [-80.44688880099994, 69.80036041900007],
              [-80.41030839799993, 69.80231354400007],
              [-80.34105383999992, 69.79759349200003],
              [-80.33641516799992, 69.78241608300004],
              [-80.30296790299991, 69.78652578300006],
              [-80.23180091099994, 69.80438873900005],
              [-80.20604407499991, 69.80068594000005],
              [-80.16942298099991, 69.79067617400005],
              [-80.13670813699991, 69.77631256700005],
              [-80.12254798099991, 69.75971100500004],
              [-80.12779700399994, 69.75311920800004],
              [-80.15078691299993, 69.74079010600008],
              [-80.15607662699995, 69.73240794500003],
              [-80.15029863199993, 69.72337474200003],
              [-80.13768469999991, 69.72577545800004],
              [-80.08092200399994, 69.75287506700005],
              [-80.06541907499991, 69.75429922100005],
              [-79.97411048099991, 69.73061758000006],
              [-79.86558997299994, 69.74616120000007],
              [-79.83218339799993, 69.76032135600008],
              [-79.8137914699999, 69.76341380400004],
              [-79.78457597599993, 69.75584544500003],
              [-79.76793372299994, 69.75385163000004],
              [-79.75511633999992, 69.75971100500004],
              [-79.75401770699995, 69.76373932500007],
              [-79.75719153599994, 69.77456289300005],
              [-79.75816809799994, 69.78050364800004],
              [-79.75633704299992, 69.78676992400005],
              [-79.75182044199994, 69.78953685100004],
              [-79.74632727799991, 69.79120514500005],
              [-79.74144446499992, 69.79417552300004],
              [-79.73534094999991, 69.79596588700008],
              [-79.71324622299994, 69.79608795800004],
              [-79.70360266799992, 69.79759349200003],
              [-79.69871985599991, 69.80198802300004],
              [-79.69517981699994, 69.81464264500005],
              [-79.69054114499994, 69.81867096600007],
              [-79.67243404899995, 69.82037995000007],
              [-79.53286699099993, 69.79759349200003],
              [-79.5110570949999, 69.80768463700008],
              [-79.45470130099994, 69.80097077000005],
              [-79.40807044199994, 69.77887604400007],
              [-79.41559811099995, 69.74298737200007],
              [-79.38744055899991, 69.74164459800005],
              [-79.36607825399994, 69.73655833500004],
              [-79.34727942599994, 69.72622304900005],
              [-79.32681230399993, 69.70880768400008],
              [-79.34805253799993, 69.69452545800004],
              [-79.53286699099993, 69.63312409100007],
              [-79.61286373599995, 69.61981842700004],
              [-79.85440019399994, 69.61261627800008],
              [-79.89610755099994, 69.60565827000005],
              [-79.91808020699995, 69.60468170800004],
              [-79.93691972599993, 69.60919830900008],
              [-79.96300208199995, 69.63019440300008],
              [-79.97105872299994, 69.63312409100007],
            ],
          ],
          [
            [
              [-83.83608964799993, 69.74982330900008],
              [-83.86961829299992, 69.75922272300005],
              [-83.90217037699995, 69.77383047100005],
              [-83.91710364499994, 69.79360586100006],
              [-83.89757239499994, 69.81867096600007],
              [-83.85558020699995, 69.83173248900005],
              [-83.56932532499991, 69.80426666900007],
              [-83.52765865799995, 69.79075755400004],
              [-83.53872636599993, 69.78595612200007],
              [-83.55068925699993, 69.78343333500004],
              [-83.59276282499991, 69.78400299700007],
              [-83.6375219389999, 69.77024974200003],
              [-83.68065344999991, 69.77118561400005],
              [-83.70067298099991, 69.76854075700004],
              [-83.71324622299994, 69.75600820500006],
              [-83.68008378799993, 69.74750397300005],
              [-83.66551673099991, 69.74017975500004],
              [-83.65802975199995, 69.72866445500006],
              [-83.70103919199994, 69.72280508000006],
              [-83.74754798099991, 69.72785065300008],
              [-83.83608964799993, 69.74982330900008],
            ],
          ],
          [
            [
              [-91.8535863919999, 69.85968659100007],
              [-91.80190995999993, 69.87836334800005],
              [-91.74754798099991, 69.88300202000005],
              [-91.69318600199995, 69.87604401200008],
              [-91.64126542899993, 69.85968659100007],
              [-91.67003333199995, 69.85008372600004],
              [-91.77159583199995, 69.83856842700004],
              [-91.82258053299995, 69.82632070500006],
              [-91.84019934799994, 69.82489655200004],
              [-91.84536699099993, 69.82754140800006],
              [-91.86717688699991, 69.84540436400005],
              [-91.86310787699995, 69.85089752800008],
              [-91.85838782499991, 69.85488515800006],
              [-91.8535863919999, 69.85968659100007],
            ],
          ],
          [
            [
              [-91.46312415299991, 69.77708567900004],
              [-91.47354081899994, 69.76211172100005],
              [-91.49136308499993, 69.74933502800008],
              [-91.53355872299994, 69.73065827000005],
              [-91.55679277299993, 69.72919342700004],
              [-91.6087133449999, 69.74534739800004],
              [-91.63442949099993, 69.74982330900008],
              [-91.6426488919999, 69.75283437700006],
              [-91.67540442599994, 69.77366771000004],
              [-91.69033769399994, 69.77997467700004],
              [-91.73745683499993, 69.79075755400004],
              [-91.73745683499993, 69.79759349200003],
              [-91.61095130099994, 69.82160065300008],
              [-91.57237708199995, 69.83539459800005],
              [-91.55540930899991, 69.83795807500007],
              [-91.52049719999991, 69.83270905200004],
              [-91.50405839799993, 69.83856842700004],
              [-91.49669348899994, 69.84910716400003],
              [-91.49429277299993, 69.86078522300005],
              [-91.49014238199993, 69.87152741100005],
              [-91.47740637899994, 69.87954336100006],
              [-91.45909583199995, 69.88007233300004],
              [-91.44196529899995, 69.88426341400003],
              [-91.42528235599991, 69.88605377800008],
              [-91.40851803299995, 69.87954336100006],
              [-91.41930091099994, 69.87189362200007],
              [-91.43077551999994, 69.86676666900007],
              [-91.45567786399994, 69.85968659100007],
              [-91.44273841099994, 69.85244375200006],
              [-91.45352128799993, 69.83730703300006],
              [-91.47752844999991, 69.82306549700007],
              [-91.50405839799993, 69.81867096600007],
              [-91.47175045499995, 69.79901764500005],
              [-91.46324622299994, 69.78953685100004],
              [-91.46312415299991, 69.77708567900004],
            ],
          ],
          [
            [
              [-87.08421790299991, 69.98940664300005],
              [-87.12010657499991, 69.99384186400005],
              [-87.18643144399994, 70.01837799700007],
              [-87.25023352799991, 70.02704498900005],
              [-87.26537024599992, 70.03107330900008],
              [-87.27599036399994, 70.03717682500007],
              [-87.27794348899994, 70.04352448100008],
              [-87.27627519399994, 70.06110260600008],
              [-87.27912350199995, 70.06826406500005],
              [-87.30313066299993, 70.08038971600007],
              [-87.3626195949999, 70.09275950700004],
              [-87.37901770699995, 70.10602448100008],
              [-87.35191809799994, 70.11302317900004],
              [-87.31578528599994, 70.11806875200006],
              [-87.28042558499993, 70.11863841400003],
              [-87.25548255099994, 70.11286041900007],
              [-87.19334876199991, 70.11098867400005],
              [-87.09780839799993, 70.12661367400005],
              [-87.13243567599994, 70.13898346600007],
              [-87.14561926999994, 70.14020416900007],
              [-87.1165258449999, 70.16107819200005],
              [-87.0735570949999, 70.15155670800004],
              [-87.00161699099993, 70.12034739800004],
              [-86.80304928299995, 70.09243398600006],
              [-86.65074622299994, 70.12091705900008],
              [-86.59752356699994, 70.11286041900007],
              [-86.58307857999995, 70.10586172100005],
              [-86.54979407499991, 70.07880280200004],
              [-86.52375240799995, 70.06240469000005],
              [-86.51113847599993, 70.05182526200008],
              [-86.50194251199991, 70.03717682500007],
              [-86.50682532499991, 70.02741120000007],
              [-86.49567623599995, 70.02179596600007],
              [-86.46035722599993, 70.01675039300005],
              [-86.47752844999991, 69.99477773600006],
              [-86.50352942599994, 69.98590729400007],
              [-86.77692623599995, 69.97125885600008],
              [-86.91714433499993, 69.99127838700008],
              [-86.98110917899993, 70.01361725500004],
              [-87.00633704299992, 70.01634349200003],
              [-87.05842037699995, 69.99591705900008],
              [-87.08421790299991, 69.98940664300005],
            ],
          ],
          [
            [
              [-71.50796464799993, 71.01727936400005],
              [-71.36632239499994, 71.01605866100005],
              [-71.34349524599992, 71.00763580900008],
              [-71.34874426999994, 70.98468659100007],
              [-71.36204993399991, 70.97077057500007],
              [-71.39879309799994, 70.94961172100005],
              [-71.38597571499992, 70.92934804900005],
              [-71.40607662699995, 70.91657135600008],
              [-71.43871008999992, 70.90989817900004],
              [-71.62466386599993, 70.90119049700007],
              [-71.89842688699991, 70.85276927300004],
              [-71.91982988199993, 70.84495677300004],
              [-71.94749915299991, 70.82607656500005],
              [-71.96727454299992, 70.81801992400005],
              [-72.00206458199995, 70.81191640800006],
              [-72.04759680899991, 70.80890534100007],
              [-72.09068762899994, 70.81232330900008],
              [-72.11815344999991, 70.82542552300004],
              [-72.11717688699991, 70.82855866100005],
              [-72.11587480399993, 70.83661530200004],
              [-72.1165258449999, 70.84666575700004],
              [-72.12124589799993, 70.85618724200003],
              [-72.13125566299993, 70.86408112200007],
              [-72.14207923099991, 70.86806875200006],
              [-72.16527258999992, 70.87323639500005],
              [-72.18675696499992, 70.88251373900005],
              [-72.20002193899995, 70.89280833500004],
              [-72.22801673099991, 70.92169830900008],
              [-72.22642981699994, 70.92755768400008],
              [-72.22752844999991, 70.93048737200007],
              [-72.22801673099991, 70.93528880400004],
              [-72.17979895699995, 70.94208405200004],
              [-72.15566972599993, 70.94114817900004],
              [-72.13182532499991, 70.93528880400004],
              [-72.1516820949999, 70.92788320500006],
              [-72.12531490799995, 70.92096588700008],
              [-72.09557044199994, 70.92279694200005],
              [-72.06749426999994, 70.93162669500003],
              [-72.04613196499992, 70.94586823100008],
              [-72.03709876199991, 70.96149323100008],
              [-72.02794348899994, 70.99909088700008],
              [-72.01854407499991, 71.01410553600005],
              [-72.01455644399994, 71.02269114800004],
              [-72.01773027299993, 71.03091054900005],
              [-72.02212480399993, 71.03847890800006],
              [-72.02196204299992, 71.04515208500004],
              [-72.01158606699994, 71.05215078300006],
              [-71.85973059799994, 71.07855866100005],
              [-71.8301488919999, 71.07245514500005],
              [-71.83698482999995, 71.06565989800004],
              [-71.82762610599991, 71.06126536700003],
              [-71.81753495999993, 71.05923086100006],
              [-71.79600989499994, 71.05947500200006],
              [-71.50796464799993, 71.01727936400005],
            ],
          ],
          [
            [
              [-72.95360266799992, 71.51752350500004],
              [-72.93529212099992, 71.50991445500006],
              [-72.92341061099995, 71.49982330900008],
              [-72.91295325399994, 71.48834870000007],
              [-72.89899654899995, 71.47654857000003],
              [-72.87954667899993, 71.46869538000004],
              [-72.83556067599994, 71.45966217700004],
              [-72.81704667899993, 71.44863515800006],
              [-72.85440019399994, 71.43520742400005],
              [-72.93980872299994, 71.43378327000005],
              [-73.01154537699995, 71.41950104400007],
              [-73.02415930899991, 71.41229889500005],
              [-73.02928626199991, 71.39769114800004],
              [-73.02603105399993, 71.39101797100005],
              [-73.01207434799994, 71.37079498900005],
              [-73.00885982999995, 71.36050039300005],
              [-73.01048743399991, 71.35663483300004],
              [-73.01378333199995, 71.35325755400004],
              [-73.01626542899993, 71.35008372600004],
              [-73.01561438699991, 71.34682851800005],
              [-73.01065019399994, 71.34381745000007],
              [-72.99453691299993, 71.33934153900003],
              [-72.98468990799995, 71.32855866100005],
              [-72.97887122299994, 71.32575104400007],
              [-72.98013261599993, 71.32208893400008],
              [-72.9915258449999, 71.30898672100005],
              [-73.00495357999995, 71.30292389500005],
              [-73.02879798099991, 71.29832591400003],
              [-73.05357825399994, 71.29637278900003],
              [-73.07022050699993, 71.29840729400007],
              [-73.08470618399991, 71.30841705900008],
              [-73.08788001199991, 71.31793854400007],
              [-73.08055579299992, 71.32453034100007],
              [-73.06346594999991, 71.32575104400007],
              [-73.12340247299994, 71.33893463700008],
              [-73.20702063699991, 71.34438711100006],
              [-73.26683508999992, 71.36440664300005],
              [-73.25523841099994, 71.42133209800005],
              [-73.2871801419999, 71.42767975500004],
              [-73.29552161399994, 71.43463776200008],
              [-73.29002844999991, 71.44863515800006],
              [-73.30736243399991, 71.46238841400003],
              [-73.37193762899994, 71.49017975500004],
              [-73.36632239499994, 71.50165436400005],
              [-73.36998450399994, 71.50918203300006],
              [-73.37633216099994, 71.51410553600005],
              [-73.37877356699994, 71.51752350500004],
              [-73.36799068899995, 71.52826569200005],
              [-73.35244706899994, 71.53363678600005],
              [-73.17186438699991, 71.57322825700004],
              [-73.13658606699994, 71.56696198100008],
              [-73.1009008449999, 71.55329010600008],
              [-73.07713782499991, 71.53864166900007],
              [-73.08568274599992, 71.52704498900005],
              [-73.1074926419999, 71.50482819200005],
              [-73.11188717399995, 71.49359772300005],
              [-73.12254798099991, 71.47996653900003],
              [-73.16950436099995, 71.46499258000006],
              [-73.18008378799993, 71.45233795800004],
              [-73.17259680899991, 71.43504466400003],
              [-73.15599524599992, 71.42316315300008],
              [-73.13931230399993, 71.42084381700005],
              [-73.13170325399994, 71.43219635600008],
              [-73.12922115799995, 71.45001862200007],
              [-73.12157141799992, 71.45661041900007],
              [-73.10899817599994, 71.45945872600004],
              [-73.03868567599994, 71.48725006700005],
              [-73.02183997299994, 71.49701569200005],
              [-72.99217688699991, 71.51898834800005],
              [-72.97720292899993, 71.52167389500005],
              [-72.95360266799992, 71.51752350500004],
            ],
          ],
          [
            [
              [-72.73790442599994, 71.66152578300006],
              [-72.70848548099991, 71.65688711100006],
              [-72.68932044199994, 71.64398834800005],
              [-72.65876217399995, 71.60004303600005],
              [-72.72679602799991, 71.54743073100008],
              [-72.76528886599993, 71.52899811400005],
              [-72.99547278599994, 71.55670807500007],
              [-73.04356848899994, 71.58641185100004],
              [-73.01903235599991, 71.60932038000004],
              [-72.98851477799991, 71.62738678600005],
              [-72.92625891799992, 71.65534088700008],
              [-72.73790442599994, 71.66152578300006],
            ],
          ],
          [
            [
              [-95.32754472599993, 71.84711334800005],
              [-95.29100501199991, 71.84747955900008],
              [-95.27391516799992, 71.84349192900004],
              [-95.25926673099991, 71.83283112200007],
              [-95.3086645169999, 71.77802155200004],
              [-95.32135982999995, 71.75775788000004],
              [-95.31847083199995, 71.74249909100007],
              [-95.34019934799994, 71.73725006700005],
              [-95.36953691299993, 71.73615143400008],
              [-95.40957597599993, 71.73041413000004],
              [-95.43944251199991, 71.73265208500004],
              [-95.49205481699994, 71.74347565300008],
              [-95.47276770699995, 71.76117584800005],
              [-95.3926488919999, 71.77411530200004],
              [-95.36229407499991, 71.79181549700007],
              [-95.38243567599994, 71.79547760600008],
              [-95.42491614499994, 71.79144928600005],
              [-95.4448949859999, 71.79873281500005],
              [-95.44204667899993, 71.80247630400004],
              [-95.43740800699993, 71.81232330900008],
              [-95.4434301419999, 71.81533437700006],
              [-95.44640051999994, 71.81875234600005],
              [-95.44839433499993, 71.82233307500007],
              [-95.45173092399995, 71.82599518400008],
              [-95.42373613199993, 71.83494700700004],
              [-95.3570043609999, 71.84699127800008],
              [-95.32754472599993, 71.84711334800005],
            ],
          ],
          [
            [
              [-95.76634680899991, 72.87498607000003],
              [-95.73350989499994, 72.85846588700008],
              [-95.72105872299994, 72.84902578300006],
              [-95.71178137899994, 72.83397044500003],
              [-95.7202856109999, 72.81834544500003],
              [-95.73228919199994, 72.80768463700008],
              [-95.74950110599991, 72.80316803600005],
              [-95.77326412699995, 72.80609772300005],
              [-95.79820716099994, 72.81586334800005],
              [-95.85578365799995, 72.86066315300008],
              [-95.79320227799991, 72.88056061400005],
              [-95.77977454299992, 72.88043854400007],
              [-95.76634680899991, 72.87498607000003],
            ],
          ],
          [
            [
              [-96.91771399599992, 72.73777903900003],
              [-96.95059160099993, 72.74127838700008],
              [-96.9719945949999, 72.75055573100008],
              [-97.01398678299995, 72.77875397300005],
              [-96.9480688139999, 72.79071686400005],
              [-96.92296301999994, 72.80402252800008],
              [-96.93822180899991, 72.82656484600005],
              [-96.91454016799992, 72.84227122600004],
              [-96.85138912699995, 72.85980866100005],
              [-96.79039466099994, 72.88654205900008],
              [-96.75938880099994, 72.89618561400005],
              [-96.72695878799993, 72.89765045800004],
              [-96.69180253799993, 72.88861725500004],
              [-96.6887914699999, 72.87441640800006],
              [-96.69831295499995, 72.86005280200004],
              [-96.72598222599993, 72.83397044500003],
              [-96.67023678299995, 72.81419505400004],
              [-96.64830481699994, 72.80093008000006],
              [-96.65086829299992, 72.77875397300005],
              [-96.70547441299993, 72.75202057500007],
              [-96.73997962099992, 72.72842031500005],
              [-96.75328528599994, 72.72410716400003],
              [-96.77245032499991, 72.72394440300008],
              [-96.82217363199993, 72.73777903900003],
              [-96.8452856109999, 72.74013906500005],
              [-96.91771399599992, 72.73777903900003],
            ],
          ],
          [
            [
              [-97.07201087099992, 73.13812897300005],
              [-97.04381262899994, 73.15558502800008],
              [-96.97130286399994, 73.16913483300004],
              [-96.90379798099991, 73.18964264500005],
              [-96.85655676999994, 73.19415924700007],
              [-96.80919348899994, 73.19208405200004],
              [-96.77375240799995, 73.18280670800004],
              [-96.76073157499991, 73.18268463700008],
              [-96.74828040299991, 73.17804596600007],
              [-96.72598222599993, 73.16233958500004],
              [-96.7390844389999, 73.14402903900003],
              [-96.77057857999995, 73.12335846600007],
              [-96.75942949099993, 73.11456940300008],
              [-96.73106848899994, 73.11261627800008],
              [-96.70343990799995, 73.12205638200004],
              [-96.6765844389999, 73.13458893400008],
              [-96.65086829299992, 73.14183177300004],
              [-96.6426488919999, 73.12547435100004],
              [-96.57896887899994, 73.08344147300005],
              [-96.56826738199993, 73.05247630400004],
              [-96.57725989499994, 73.03681061400005],
              [-96.59264075399994, 73.02562083500004],
              [-96.60952714799993, 73.01593659100007],
              [-96.62291419199994, 73.00470612200007],
              [-96.62682044199994, 72.99799225500004],
              [-96.63365637899994, 72.98232656500005],
              [-96.63658606699994, 72.97736237200007],
              [-96.6460668609999, 72.96869538000004],
              [-96.6551000639999, 72.96356842700004],
              [-96.71011308499993, 72.94171784100007],
              [-96.78384355399993, 72.93065013200004],
              [-96.93415279899995, 72.92446523600006],
              [-96.97301184799994, 72.92963288000004],
              [-97.0586645169999, 72.96417877800008],
              [-97.10033118399991, 72.99201080900008],
              [-97.10952714799993, 73.01898834800005],
              [-97.13170325399994, 73.04389069200005],
              [-97.1406957669999, 73.05890534100007],
              [-97.14427649599992, 73.07636139500005],
              [-97.1355688139999, 73.09520091400003],
              [-97.11506100199995, 73.11041901200008],
              [-97.09097245999993, 73.12409088700008],
              [-97.07201087099992, 73.13812897300005],
            ],
          ],
          [
            [
              [-108.08763587099992, 73.59064362200007],
              [-108.01402747299994, 73.62238190300008],
              [-107.84886633999992, 73.63336823100008],
              [-107.67617753799993, 73.62543366100005],
              [-107.57994544199994, 73.60053131700005],
              [-107.5918676419999, 73.58722565300008],
              [-107.60850989499994, 73.57831452000005],
              [-107.62808183499993, 73.57379791900007],
              [-107.67613684799994, 73.57416413000004],
              [-107.73151607999995, 73.56264883000006],
              [-107.99396725199995, 73.54657623900005],
              [-108.02623450399994, 73.55341217700004],
              [-108.03184973899994, 73.55678945500006],
              [-108.0535375639999, 73.57387929900005],
              [-108.08324133999992, 73.58462148600006],
              [-108.08763587099992, 73.59064362200007],
            ],
          ],
          [
            [
              [-104.68089758999992, 73.62982819200005],
              [-104.55980383999992, 73.59516022300005],
              [-104.50084387899994, 73.56720612200007],
              [-104.4895727199999, 73.53229401200008],
              [-104.49730383999992, 73.52879466400003],
              [-104.5047094389999, 73.52407461100006],
              [-104.51744544199994, 73.51239655200004],
              [-104.5183813139999, 73.49290599200003],
              [-104.53795325399994, 73.47846100500004],
              [-104.5628149079999, 73.46531810100004],
              [-104.57949785099993, 73.44969310100004],
              [-104.5554906889999, 73.43280670800004],
              [-104.55162512899994, 73.42645905200004],
              [-104.55699622299994, 73.41290924700007],
              [-104.58092200399994, 73.39374420800004],
              [-104.58633378799993, 73.38519928600005],
              [-104.58096269399994, 73.36294179900005],
              [-104.57249915299991, 73.34699127800008],
              [-104.57266191299993, 73.33218008000006],
              [-104.59316972599993, 73.31317780200004],
              [-104.67369544199994, 73.27301666900007],
              [-104.74982662699995, 73.21747467700004],
              [-104.7600805329999, 73.20042552300004],
              [-104.73656165299991, 73.18964264500005],
              [-104.76183020699995, 73.17300039300005],
              [-104.83775794199994, 73.15493398600006],
              [-104.86754309799994, 73.14183177300004],
              [-104.92491614499994, 73.10578034100007],
              [-104.99038652299993, 73.07977936400005],
              [-104.98131262899994, 73.03571198100008],
              [-105.01577714799993, 73.01386139500005],
              [-105.12047278599994, 72.98798248900005],
              [-105.2024633449999, 72.94452545800004],
              [-105.23062089799993, 72.93642812700006],
              [-105.26231848899994, 72.94049713700008],
              [-105.29613196499992, 72.95258209800005],
              [-105.32945716099994, 72.95990631700005],
              [-105.35973059799994, 72.95010000200006],
              [-105.32982337099992, 72.94281647300005],
              [-105.30451412699995, 72.93235911700003],
              [-105.3001195949999, 72.92218659100007],
              [-105.33307857999995, 72.91596100500004],
              [-105.27782141799992, 72.88861725500004],
              [-105.22057044199994, 72.87579987200007],
              [-105.20335852799991, 72.86749909100007],
              [-105.25731360599991, 72.86066315300008],
              [-105.26805579299992, 72.85712311400005],
              [-105.27603105399993, 72.85342031500005],
              [-105.28498287699995, 72.85138580900008],
              [-105.29832923099991, 72.85321686400005],
              [-105.30357825399994, 72.86294179900005],
              [-105.30996660099993, 72.87030670800004],
              [-105.31875566299993, 72.87498607000003],
              [-105.3342992829999, 72.87563711100006],
              [-105.38768469999991, 72.86749909100007],
              [-105.38573157499991, 72.87225983300004],
              [-105.38337154899995, 72.88385651200008],
              [-105.38145911399994, 72.88861725500004],
              [-105.42467200399994, 72.89569733300004],
              [-105.44692949099993, 72.90444570500006],
              [-105.45653235599991, 72.91901276200008],
              [-105.46031653599994, 72.93406810100004],
              [-105.47061113199993, 72.94611237200007],
              [-105.48574785099993, 72.95575592700004],
              [-105.7288305329999, 73.04584381700005],
              [-105.78551184799994, 73.07977936400005],
              [-105.81191972599993, 73.10297272300005],
              [-105.82652747299994, 73.11127350500004],
              [-105.86339270699995, 73.11733633000006],
              [-105.88243567599994, 73.12417226800005],
              [-105.91588294199994, 73.14183177300004],
              [-105.90807044199994, 73.15375397300005],
              [-105.90269934799994, 73.15814850500004],
              [-105.89415442599994, 73.16233958500004],
              [-105.9090063139999, 73.16644928600005],
              [-105.92149817599994, 73.16559479400007],
              [-105.93407141799992, 73.16315338700008],
              [-105.94937089799993, 73.16233958500004],
              [-106.10765540299991, 73.19708893400008],
              [-106.09194902299993, 73.20172760600008],
              [-106.0606176419999, 73.20473867400005],
              [-106.04564368399991, 73.21076080900008],
              [-106.05923417899993, 73.21698639500005],
              [-106.04564368399991, 73.22382233300004],
              [-106.09398352799991, 73.24530670800004],
              [-106.15859941299993, 73.26141998900005],
              [-106.17613684799994, 73.26959870000007],
              [-106.19579016799992, 73.28583405200004],
              [-106.17662512899994, 73.29181549700007],
              [-106.13902747299994, 73.28790924700007],
              [-106.12071692599994, 73.29266998900005],
              [-106.34658769399994, 73.34731679900005],
              [-106.34972083199995, 73.36066315300008],
              [-106.36815344999991, 73.36904531500005],
              [-106.39220130099994, 73.37335846600007],
              [-106.41209876199991, 73.37466054900005],
              [-106.42516028599994, 73.37824127800008],
              [-106.44603430899991, 73.39581940300008],
              [-106.45645097599993, 73.40253327000005],
              [-106.50877844999991, 73.41412995000007],
              [-106.61904863199993, 73.41986725500004],
              [-106.66942298099991, 73.43292877800008],
              [-106.70750891799992, 73.44822825700004],
              [-106.79043535099993, 73.46800364800004],
              [-106.98875891799992, 73.47036367400005],
              [-107.03929602799991, 73.48444245000007],
              [-107.02261308499993, 73.50556061400005],
              [-106.9937231109999, 73.52814362200007],
              [-106.96182206899994, 73.54608795800004],
              [-106.93626868399991, 73.55341217700004],
              [-106.90172278599994, 73.55805084800005],
              [-106.86339270699995, 73.57025788000004],
              [-106.82721920499995, 73.58759186400005],
              [-106.73696855399993, 73.65623607000003],
              [-106.67153886599993, 73.69049713700008],
              [-106.59959876199991, 73.71063873900005],
              [-106.15986080649992, 73.72308991100005],
              [-105.72012285099993, 73.73554108300004],
              [-105.57664954299992, 73.76178620000007],
              [-105.38141842399995, 73.77065664300005],
              [-105.16714433499993, 73.75665924700007],
              [-105.1243383449999, 73.74725983300004],
              [-105.1030981109999, 73.74518463700008],
              [-105.07701575399994, 73.73883698100008],
              [-104.98363196499992, 73.69672272300005],
              [-104.86485755099994, 73.67072174700007],
              [-104.84581458199995, 73.65924713700008],
              [-104.82457434799994, 73.63816966400003],
              [-104.68089758999992, 73.62982819200005],
            ],
          ],
          [
            [
              [-80.90339107999995, 73.60736725500004],
              [-80.83934485599991, 73.62384674700007],
              [-80.80260169199994, 73.67072174700007],
              [-80.80581620999993, 73.72040436400005],
              [-80.86180579299992, 73.74518463700008],
              [-80.86180579299992, 73.75136953300006],
              [-80.78408769399994, 73.75263092700004],
              [-80.75934811099995, 73.75885651200008],
              [-80.74767005099994, 73.75755442900004],
              [-80.6699926419999, 73.75885651200008],
              [-80.56017005099994, 73.77252838700008],
              [-80.44619706899994, 73.77350495000007],
              [-80.33421790299991, 73.75885651200008],
              [-80.12559973899994, 73.69794342700004],
              [-80.10252844999991, 73.69733307500007],
              [-80.07945716099994, 73.70229726800005],
              [-80.06956946499992, 73.70844147300005],
              [-80.0586645169999, 73.72406647300005],
              [-80.0462133449999, 73.73151276200008],
              [-80.02245032499991, 73.73407623900005],
              [-79.99718176999994, 73.72776927300004],
              [-79.9500219389999, 73.71039459800005],
              [-79.64606686099995, 73.68012116100005],
              [-79.60338294199994, 73.66608307500007],
              [-79.45030676999994, 73.63532135600008],
              [-78.97427324099993, 73.63532135600008],
              [-78.95498613199993, 73.63792552300004],
              [-78.90868079299992, 73.65753815300008],
              [-78.84630286399994, 73.66632721600007],
              [-78.81240800699993, 73.66575755400004],
              [-78.76537024599992, 73.65534088700008],
              [-78.45195471899993, 73.66209544450007],
              [-78.13853919199994, 73.66885000200006],
              [-78.11375891799992, 73.66571686400005],
              [-78.06602942599994, 73.65204498900005],
              [-77.99966386599993, 73.64370351800005],
              [-77.86351477799991, 73.60956452000005],
              [-77.42813066299993, 73.55955638200004],
              [-77.40583248599995, 73.55263906500005],
              [-77.34654700399994, 73.52204010600008],
              [-77.32079016799992, 73.51471588700008],
              [-77.21349036399994, 73.51080963700008],
              [-77.20645097599993, 73.50698476800005],
              [-77.20152747299994, 73.50234609600005],
              [-77.19542395699995, 73.49811432500007],
              [-77.16026770699995, 73.48436107000003],
              [-77.14826412699995, 73.47768789300005],
              [-77.15245520699995, 73.47492096600007],
              [-77.15709387899994, 73.46857330900008],
              [-77.16185462099992, 73.46401601800005],
              [-77.09813391799992, 73.42926666900007],
              [-77.03156490799995, 73.40253327000005],
              [-77.04967200399994, 73.39435455900008],
              [-77.05825761599993, 73.38890208500004],
              [-77.06627356699994, 73.38149648600006],
              [-77.03986568899995, 73.35883209800005],
              [-76.90428626199991, 73.32501862200007],
              [-76.8496801419999, 73.33368561400005],
              [-76.80231686099995, 73.33022695500006],
              [-76.75719153599994, 73.32062409100007],
              [-76.75885982999995, 73.32465241100005],
              [-76.75523841099994, 73.32672760600008],
              [-76.74754798099991, 73.32713450700004],
              [-76.72476152299993, 73.32489655200004],
              [-76.71442623599995, 73.32249583500004],
              [-76.70645097599993, 73.31704336100006],
              [-76.70197506399995, 73.30634186400005],
              [-76.75035559799994, 73.29889557500007],
              [-76.72740637899994, 73.27777741100005],
              [-76.69180253799993, 73.26129791900007],
              [-76.61998450399994, 73.23802317900004],
              [-76.58356686099995, 73.21922435100004],
              [-76.58649654899995, 73.20453522300005],
              [-76.63426673099991, 73.16982656500005],
              [-76.6133520169999, 73.16718170800004],
              [-76.52147376199991, 73.12921784100007],
              [-76.49083411399994, 73.12238190300008],
              [-76.44359290299991, 73.11912669500003],
              [-76.38809160099993, 73.10932038000004],
              [-76.27163652299993, 73.10211823100008],
              [-76.24327551999994, 73.09345123900005],
              [-76.26207434799994, 73.08209870000007],
              [-76.30492102799991, 73.07273997600004],
              [-76.31895911399994, 73.05996328300006],
              [-76.30968176999994, 73.05597565300008],
              [-76.29954993399991, 73.05312734600005],
              [-76.28872636599993, 73.05182526200008],
              [-76.2774145169999, 73.05247630400004],
              [-76.28636633999992, 73.04262929900005],
              [-76.29771887899994, 73.03774648600006],
              [-76.32518469999991, 73.03266022300005],
              [-76.31305904899995, 73.02142975500004],
              [-76.27769934799994, 73.00901927300004],
              [-76.2637426419999, 72.99848053600005],
              [-76.31607011599993, 72.98159414300005],
              [-76.33263098899994, 72.97052643400008],
              [-76.26622473899994, 72.94428131700005],
              [-76.11733964799993, 72.94171784100007],
              [-76.05825761599993, 72.90167877800008],
              [-76.07770748599995, 72.89720286700003],
              [-76.09850012899994, 72.88922760600008],
              [-76.10602779899995, 72.87885163000004],
              [-76.08556067599994, 72.86749909100007],
              [-76.1250707669999, 72.84699127800008],
              [-76.22044837099992, 72.83734772300005],
              [-76.31895911399994, 72.81671784100007],
              [-76.66388912699995, 72.82680898600006],
              [-76.7337133449999, 72.84170156500005],
              [-76.77342688699991, 72.84162018400008],
              [-76.81891842399995, 72.83323802300004],
              [-77.06916256449995, 72.84457021700004],
              [-77.31940670499995, 72.85590241100005],
              [-77.42332923099991, 72.88275788000004],
              [-77.73182125549991, 72.88904450100006],
              [-78.0403132799999, 72.89533112200007],
              [-78.11693274599992, 72.88922760600008],
              [-78.17088782499991, 72.89862702000005],
              [-78.64167232999995, 72.85248444200005],
              [-78.70958411399994, 72.83051178600005],
              [-78.86851966099994, 72.81085846600007],
              [-78.94286048099991, 72.79181549700007],
              [-79.17544511599993, 72.75458405200004],
              [-79.39093990799995, 72.74176666900007],
              [-79.5684301419999, 72.75983307500007],
              [-79.82778886599993, 72.83323802300004],
              [-79.94863847599993, 72.84747955900008],
              [-79.9798070949999, 72.85712311400005],
              [-80.00182044199994, 72.87124258000006],
              [-80.02599036399994, 72.91510651200008],
              [-80.03661048099991, 72.92210521000004],
              [-80.04405676999994, 72.92544179900005],
              [-80.05947831899994, 72.94131094000005],
              [-80.06700598899994, 72.94696686400005],
              [-80.10826575399994, 72.97052643400008],
              [-80.12181555899991, 72.98240794500003],
              [-80.15607662699995, 73.02578359600005],
              [-80.16966712099992, 73.03782786700003],
              [-80.17613684799994, 73.04559967700004],
              [-80.17259680899991, 73.05524323100008],
              [-80.13780676999994, 73.09414297100005],
              [-80.12254798099991, 73.12140534100007],
              [-80.13613847599993, 73.12677643400008],
              [-80.16616777299993, 73.13446686400005],
              [-80.1765844389999, 73.14183177300004],
              [-80.17992102799991, 73.14988841400003],
              [-80.18016516799992, 73.15912506700005],
              [-80.17686926999994, 73.16665273600006],
              [-80.16974850199995, 73.16982656500005],
              [-80.13760331899994, 73.17357005400004],
              [-80.11815344999991, 73.18447500200006],
              [-80.11758378799993, 73.20148346600007],
              [-80.14240475199995, 73.22382233300004],
              [-80.16380774599992, 73.23338450700004],
              [-80.23265540299991, 73.24982330900008],
              [-80.27253170499995, 73.25283437700006],
              [-80.36750240799995, 73.23973216400003],
              [-80.44163977799991, 73.25751373900005],
              [-80.55329342399995, 73.25787995000007],
              [-80.71092688699991, 73.27903880400004],
              [-80.77131100199995, 73.27912018400008],
              [-80.79503333199995, 73.28534577000005],
              [-80.81737219999991, 73.30263906500005],
              [-80.8289281889999, 73.30914948100008],
              [-80.86009680899991, 73.31899648600006],
              [-80.86925208199995, 73.32623932500007],
              [-80.87173417899993, 73.33836497600004],
              [-80.86656653599994, 73.34552643400008],
              [-80.85741126199991, 73.35175202000005],
              [-80.84813391799992, 73.36098867400005],
              [-80.89598548099991, 73.38149648600006],
              [-80.87214107999995, 73.39394765800006],
              [-80.8692113919999, 73.39866771000004],
              [-80.86925208199995, 73.40875885600008],
              [-80.87344316299993, 73.42674388200004],
              [-80.87877356699994, 73.43695709800005],
              [-80.87832597599993, 73.44599030200004],
              [-80.84976152299993, 73.47532786700003],
              [-80.83625240799995, 73.48541901200008],
              [-80.81932532499991, 73.49070872600004],
              [-80.79352779899995, 73.49135976800005],
              [-80.71670488199993, 73.47890859600005],
              [-80.6973363919999, 73.48444245000007],
              [-80.71629798099991, 73.49363841400003],
              [-80.77985592399995, 73.50495026200008],
              [-80.79210364499994, 73.50995514500005],
              [-80.85610917899993, 73.54490794500003],
              [-80.86310787699995, 73.55170319200005],
              [-80.87547766799992, 73.57387929900005],
              [-80.87474524599992, 73.57444896000004],
              [-80.88109290299991, 73.58978913000004],
              [-80.8828832669999, 73.59064362200007],
              [-80.88540605399993, 73.59381745000007],
              [-80.90339107999995, 73.60736725500004],
            ],
          ],
          [
            [
              [-96.32126970399992, 72.46686432500007],
              [-96.31541032899992, 72.44879791900007],
              [-96.30556332299994, 72.43667226800005],
              [-96.30361019799994, 72.42674388200004],
              [-96.32126970399992, 72.41567617400005],
              [-96.33925472999994, 72.41217682500007],
              [-96.37929379199994, 72.41347890800006],
              [-96.3984995209999, 72.41014232000003],
              [-96.40761410499994, 72.40521881700005],
              [-96.41371761999994, 72.39911530200004],
              [-96.41860043299994, 72.39301178600005],
              [-96.42429704699992, 72.38776276200008],
              [-96.44114274999993, 72.37726471600007],
              [-96.45994157899992, 72.36904531500005],
              [-96.46873064099992, 72.36713288000004],
              [-96.49631853199992, 72.36717357000003],
              [-96.50522966499994, 72.36566803600005],
              [-96.5098683359999, 72.36200592700004],
              [-96.5137745859999, 72.35773346600007],
              [-96.52048845399992, 72.35419342700004],
              [-96.66440935199995, 72.31826406500005],
              [-96.68809099299995, 72.31745026200008],
              [-96.74021501599992, 72.32632070500006],
              [-96.87681169599995, 72.32632070500006],
              [-96.84165544599995, 72.31293366100005],
              [-96.71848649999993, 72.29954661700003],
              [-96.64585466499994, 72.27773672100005],
              [-96.60658871399994, 72.27240631700005],
              [-96.58193051099994, 72.28530508000006],
              [-96.57224626599992, 72.28213125200006],
              [-96.5650034279999, 72.27806224200003],
              [-96.5594288829999, 72.27236562700006],
              [-96.55466814099992, 72.26422760600008],
              [-96.5703745209999, 72.25861237200007],
              [-96.61611019799994, 72.25116608300004],
              [-96.59128923499992, 72.24188873900005],
              [-96.57411801099994, 72.23834870000007],
              [-96.5574757579999, 72.23956940300008],
              [-96.53416032899992, 72.24433014500005],
              [-96.5337534279999, 72.22459544500003],
              [-96.52659196899992, 72.19700755400004],
              [-96.5147104589999, 72.17072174700007],
              [-96.49998064099992, 72.15497467700004],
              [-96.5068979589999, 72.15497467700004],
              [-96.4898081149999, 72.14557526200008],
              [-96.48484392199992, 72.12848541900007],
              [-96.4891163829999, 72.10927969000005],
              [-96.49998064099992, 72.09349192900004],
              [-96.52842302399995, 72.08161041900007],
              [-96.86928402699994, 72.04511139500005],
              [-96.84434099299995, 72.03831614800004],
              [-96.8231007579999, 72.03693268400008],
              [-96.7771616309999, 72.03888580900008],
              [-96.74912614899995, 72.03558991100005],
              [-96.6939096779999, 72.02106354400007],
              [-96.66453142199992, 72.01776764500005],
              [-96.51576840199994, 72.04218170800004],
              [-96.4932260839999, 72.02802155200004],
              [-96.4988413179999, 71.99640534100007],
              [-96.51499528999994, 71.97101471600007],
              [-96.54075212499993, 71.95453522300005],
              [-96.57509457299994, 71.94953034100007],
              [-96.5877085059999, 71.95197174700007],
              [-96.6123667089999, 71.96116771000004],
              [-96.62632341499994, 71.96320221600007],
              [-96.6394663179999, 71.96100495000007],
              [-96.66465349299995, 71.95160553600005],
              [-96.69993181299992, 71.94647858300004],
              [-96.76694841499994, 71.92226797100005],
              [-96.76694841499994, 71.91535065300008],
              [-96.71738786799995, 71.90436432500007],
              [-96.6665659279999, 71.91303131700005],
              [-96.6145639739999, 71.92792389500005],
              [-96.56150407899992, 71.93585846600007],
              [-96.51890153999994, 71.93707916900007],
              [-96.50132341499994, 71.93146393400008],
              [-96.4932260839999, 71.91535065300008],
              [-96.55967302399995, 71.83982982000003],
              [-96.58876644799994, 71.82074616100005],
              [-96.62392269799994, 71.80975983300004],
              [-96.7164113049999, 71.79743073100008],
              [-96.73765153999994, 71.79905833500004],
              [-96.74644060199995, 71.81610748900005],
              [-96.7383839609999, 71.82855866100005],
              [-96.71921892199992, 71.83454010600008],
              [-96.6775522559999, 71.83966705900008],
              [-96.7085581149999, 71.85464101800005],
              [-96.73964535499994, 71.85236237200007],
              [-96.7691049899999, 71.84039948100008],
              [-96.79482113599994, 71.82599518400008],
              [-96.8294077239999, 71.81313711100006],
              [-96.8643198339999, 71.80963776200008],
              [-96.9351613049999, 71.81232330900008],
              [-96.96156918299994, 71.80683014500005],
              [-96.9805714609999, 71.79303620000007],
              [-97.0139780369999, 71.75775788000004],
              [-97.05808610999992, 71.73379140800006],
              [-97.07981462499993, 71.71796295800004],
              [-97.0828663829999, 71.70311107000003],
              [-97.21189470399992, 71.66648997600004],
              [-97.3016163829999, 71.65696849200003],
              [-97.4385385839999, 71.62055084800005],
              [-97.4612436619999, 71.61737702000005],
              [-97.68528337499993, 71.61839427300004],
              [-97.70566911799995, 71.62396881700005],
              [-97.72402035499994, 71.63279857000003],
              [-97.76381527699994, 71.64590078300006],
              [-97.90574235999992, 71.64996979400007],
              [-97.9485483489999, 71.65936920800004],
              [-97.96982927399995, 71.66152578300006],
              [-98.1004038179999, 71.64777252800008],
              [-98.14487810199995, 71.64789459800005],
              [-98.21982927399995, 71.65863678600005],
              [-98.2527882579999, 71.66998932500007],
              [-98.33608090199994, 71.71308014500005],
              [-98.3496713959999, 71.72296784100007],
              [-98.35927426099994, 71.73436107000003],
              [-98.3560190529999, 71.73920319200005],
              [-98.3479624119999, 71.74551015800006],
              [-98.33652849299995, 71.78986237200007],
              [-98.31858415699992, 71.81175364800004],
              [-98.2212534279999, 71.87278880400004],
              [-98.21311540699992, 71.88125234600005],
              [-98.21523129199994, 71.89378489800004],
              [-98.22865902699994, 71.89545319200005],
              [-98.2461557709999, 71.89516836100006],
              [-98.2603159279999, 71.90167877800008],
              [-98.2583628029999, 71.90350983300004],
              [-98.25722347999994, 71.90375397300005],
              [-98.25632829699992, 71.90452708500004],
              [-98.2547413829999, 71.90790436400005],
              [-98.2950245859999, 71.90167877800008],
              [-98.26674496399994, 71.87799713700008],
              [-98.2603159279999, 71.86762116100005],
              [-98.28147478199992, 71.86566803600005],
              [-98.3231007579999, 71.86627838700008],
              [-98.34348649999993, 71.86078522300005],
              [-98.33665056299992, 71.86078522300005],
              [-98.43837582299994, 71.80361562700006],
              [-98.47996110999992, 71.76723867400005],
              [-98.50046892199992, 71.72296784100007],
              [-98.49648129199994, 71.71967194200005],
              [-98.4922902109999, 71.71775950700004],
              [-98.4871225679999, 71.71771881700005],
              [-98.4656381929999, 71.72402578300006],
              [-98.45619808899994, 71.72235748900005],
              [-98.44773454699992, 71.71873607000003],
              [-98.4156300549999, 71.71417877800008],
              [-98.39792985999992, 71.70815664300005],
              [-98.39296566699994, 71.70132070500006],
              [-98.41111345399992, 71.69627513200004],
              [-98.39426774999993, 71.67975495000007],
              [-98.3862924899999, 71.66412995000007],
              [-98.37538754199994, 71.65241120000007],
              [-98.34995622699995, 71.64789459800005],
              [-98.32126970399992, 71.64606354400007],
              [-98.30723161799995, 71.64109935100004],
              [-98.30125017199992, 71.63104889500005],
              [-98.29758806299992, 71.61741771000004],
              [-98.2881479589999, 71.61351146000004],
              [-98.27524919599995, 71.61310455900008],
              [-98.26121110999992, 71.61001211100006],
              [-98.23362321899992, 71.59324778900003],
              [-98.2200327239999, 71.59064362200007],
              [-98.19077653999994, 71.58954498900005],
              [-98.17836605799994, 71.58641185100004],
              [-98.15964860999992, 71.56020742400005],
              [-98.15102230799994, 71.55223216400003],
              [-98.14223324499994, 71.54702383000006],
              [-98.1343800549999, 71.54368724200003],
              [-98.1246144299999, 71.54295482000003],
              [-98.11008806299992, 71.54547760600008],
              [-98.10422868799992, 71.54071686400005],
              [-98.06040544599995, 71.53644440300008],
              [-98.0418100679999, 71.53119538000004],
              [-98.0601206149999, 71.52147044500003],
              [-98.0982065529999, 71.49469635600008],
              [-98.13059587499993, 71.46588776200008],
              [-98.1716928809999, 71.43992747600004],
              [-98.1892710059999, 71.42503489800004],
              [-98.21519060199995, 71.40940989800004],
              [-98.31553239899995, 71.38715241100005],
              [-98.4004933359999, 71.34625885600008],
              [-98.41111345399992, 71.33934153900003],
              [-98.4415089609999, 71.33502838700008],
              [-98.50942074499994, 71.30280182500007],
              [-98.54148454699992, 71.29218170800004],
              [-98.66355485999992, 71.29889557500007],
              [-98.6997690529999, 71.29218170800004],
              [-98.69675798499992, 71.28831614800004],
              [-98.69407243799992, 71.28119538000004],
              [-98.69228207299994, 71.27789948100008],
              [-98.71787614899995, 71.27167389500005],
              [-98.72996110999992, 71.27171458500004],
              [-98.74070329699992, 71.27789948100008],
              [-98.78501482099995, 71.28363678600005],
              [-98.82761735999992, 71.30048248900005],
              [-98.94626970399992, 71.37392812700006],
              [-98.9676320079999, 71.38324616100005],
              [-98.9939585059999, 71.38715241100005],
              [-99.02085466499994, 71.38410065300008],
              [-99.09165544599995, 71.35541413000004],
              [-99.11903988599994, 71.34975820500006],
              [-99.21335954699992, 71.34682851800005],
              [-99.23508806299992, 71.34959544500003],
              [-99.2410288179999, 71.35732656500005],
              [-99.24257504199994, 71.36904531500005],
              [-99.25120134399992, 71.38373444200005],
              [-99.25820004199994, 71.38886139500005],
              [-99.28196306299992, 71.40143463700008],
              [-99.28700863599994, 71.40766022300005],
              [-99.29189144799994, 71.42133209800005],
              [-99.29563493799992, 71.42877838700008],
              [-99.3176889739999, 71.44871653900003],
              [-99.32358903999994, 71.46063873900005],
              [-99.31606136999994, 71.47654857000003],
              [-99.36631364899995, 71.50861237200007],
              [-99.41225277699994, 71.54547760600008],
              [-99.39613949499994, 71.54498932500007],
              [-99.38315935199995, 71.55060455900008],
              [-99.37449235999992, 71.56126536700003],
              [-99.37131853199992, 71.57587311400005],
              [-99.38523454699992, 71.58584219000005],
              [-99.5127573339999, 71.60541413000004],
              [-99.56166683899994, 71.62006256700005],
              [-99.59950863599994, 71.64179108300004],
              [-99.60471696899992, 71.66836172100005],
              [-99.6106577239999, 71.67829010600008],
              [-99.61436052399995, 71.68829987200007],
              [-99.62001644799994, 71.69879791900007],
              [-99.63197933899994, 71.70990631700005],
              [-99.6431284279999, 71.71478913000004],
              [-99.6660776459999, 71.71963125200006],
              [-99.6760874119999, 71.72638580900008],
              [-99.67836605799994, 71.73236725500004],
              [-99.6778370859999, 71.73920319200005],
              [-99.67563982099995, 71.74396393400008],
              [-99.67295427399995, 71.74347565300008],
              [-99.68296403999994, 71.75775788000004],
              [-99.6934620859999, 71.76715729400007],
              [-99.7073374119999, 71.77334219000005],
              [-99.7476206149999, 71.78237539300005],
              [-99.76829118799992, 71.78436920800004],
              [-99.78171892199992, 71.78778717700004],
              [-99.8069467869999, 71.80267975500004],
              [-99.8201303809999, 71.80613841400003],
              [-99.82871599299995, 71.81207916900007],
              [-99.84706722999994, 71.85024648600006],
              [-99.86436052399995, 71.85944245000007],
              [-100.0354624119999, 71.86762116100005],
              [-100.05776058899994, 71.87274811400005],
              [-100.0982065529999, 71.88873932500007],
              [-100.11863298499992, 71.89423248900005],
              [-100.1438608489999, 71.92487213700008],
              [-100.1875620209999, 71.94245026200008],
              [-100.2756967869999, 71.96662018400008],
              [-100.3067026459999, 71.98623281500005],
              [-100.35349626599992, 72.02435944200005],
              [-100.38490902699994, 72.03888580900008],
              [-100.3787241309999, 72.03888580900008],
              [-100.39561052399995, 72.04193756700005],
              [-100.44700212499993, 72.05878327000005],
              [-100.43088884399992, 72.06460195500006],
              [-100.4255991309999, 72.07318756700005],
              [-100.42421566699994, 72.08323802300004],
              [-100.42026872699995, 72.09349192900004],
              [-100.44407243799992, 72.10008372600004],
              [-100.47239274999993, 72.09552643400008],
              [-100.49839372699995, 72.09666575700004],
              [-100.5152394299999, 72.12079498900005],
              [-100.50706071899992, 72.12152741100005],
              [-100.48793636999994, 72.12763092700004],
              [-100.54612321899992, 72.13646067900004],
              [-100.56361996399994, 72.14130280200004],
              [-100.57826840199994, 72.15033600500004],
              [-100.59092302399995, 72.16063060100004],
              [-100.60520524999993, 72.16815827000005],
              [-100.6251027109999, 72.16864655200004],
              [-100.6365366309999, 72.18646881700005],
              [-100.7991342869999, 72.21133047100005],
              [-100.8211069429999, 72.20697663000004],
              [-100.84169613599994, 72.19969310100004],
              [-100.86130876599992, 72.19594961100006],
              [-100.8674936619999, 72.19794342700004],
              [-100.8797006929999, 72.20722077000005],
              [-100.88584489899995, 72.20962148600006],
              [-100.8963022559999, 72.20929596600007],
              [-100.92673845399992, 72.20335521000004],
              [-100.92185564099992, 72.19985586100006],
              [-100.9131479589999, 72.18976471600007],
              [-100.9297902109999, 72.19086334800005],
              [-100.94077653999994, 72.18549225500004],
              [-100.95164079699992, 72.17865631700005],
              [-100.96775407899992, 72.17544179900005],
              [-100.9805714609999, 72.17902252800008],
              [-101.02919613599994, 72.20335521000004],
              [-101.02854509399992, 72.21133047100005],
              [-101.03456722999994, 72.21991608300004],
              [-101.04482113599994, 72.22858307500007],
              [-101.05710954699992, 72.23688385600008],
              [-101.03196306299992, 72.24892812700006],
              [-101.0230112399999, 72.25116608300004],
              [-101.0230112399999, 72.25739166900007],
              [-101.0386769299999, 72.25958893400008],
              [-101.06968278999994, 72.25739166900007],
              [-101.08384294599995, 72.26422760600008],
              [-101.06069027699994, 72.27383047100005],
              [-101.04856462499993, 72.27655670800004],
              [-101.0359913829999, 72.27789948100008],
              [-101.06577653999994, 72.28880442900004],
              [-101.13450212499993, 72.29555898600006],
              [-101.16697282899992, 72.30573151200008],
              [-101.2007863049999, 72.32965729400007],
              [-101.21616716499994, 72.33470286700003],
              [-101.22898454699992, 72.33539459800005],
              [-101.2932749119999, 72.32542552300004],
              [-101.35618181299992, 72.30573151200008],
              [-101.40321957299994, 72.27928294500003],
              [-101.39976091499994, 72.25116608300004],
              [-101.42201840199994, 72.24518463700008],
              [-101.44862972999994, 72.24213288000004],
              [-101.4746713959999, 72.24359772300005],
              [-101.49534196899992, 72.25116608300004],
              [-101.4849253029999, 72.25063711100006],
              [-101.47642107099995, 72.25307851800005],
              [-101.47068376599992, 72.25873444200005],
              [-101.46860857099995, 72.26797109600005],
              [-101.47397966499994, 72.27289459800005],
              [-101.50962419599995, 72.28530508000006],
              [-101.50217790699992, 72.28530508000006],
              [-101.5291147559999, 72.29612864800004],
              [-101.60227556299992, 72.31102122600004],
              [-101.63246761999994, 72.31264883000006],
              [-101.65321957299994, 72.30687083500004],
              [-101.67470394799994, 72.29718659100007],
              [-101.69578142199992, 72.29193756700005],
              [-101.71506853199992, 72.29954661700003],
              [-101.70762224299995, 72.30573151200008],
              [-101.7176320079999, 72.31142812700006],
              [-101.7247120859999, 72.31077708500004],
              [-101.73179216499994, 72.30760325700004],
              [-101.7417612399999, 72.30573151200008],
              [-101.77040707299994, 72.30670807500007],
              [-101.7820444429999, 72.30878327000005],
              [-101.8401499119999, 72.32648346600007],
              [-101.85219418299994, 72.33307526200008],
              [-101.86252946899992, 72.34210846600007],
              [-101.87046403999994, 72.35089752800008],
              [-101.87949724299995, 72.35761139500005],
              [-101.89316911799995, 72.36041901200008],
              [-101.89365739899995, 72.36481354400007],
              [-101.89243669599995, 72.36635976800005],
              [-101.8863331799999, 72.36717357000003],
              [-101.89316911799995, 72.36717357000003],
              [-101.87876482099995, 72.37270742400005],
              [-101.87278337499993, 72.38108958500004],
              [-101.8770558359999, 72.38963450700004],
              [-101.89316911799995, 72.39516836100006],
              [-101.8662729589999, 72.39964427300004],
              [-101.7922983489999, 72.39354075700004],
              [-101.77646989899995, 72.39516836100006],
              [-101.7942514739999, 72.41205475500004],
              [-101.8396616309999, 72.41437409100007],
              [-101.91982113599994, 72.40818919500003],
              [-101.9163217869999, 72.41132233300004],
              [-101.9097706799999, 72.41909414300005],
              [-101.90623064099992, 72.42251211100006],
              [-101.92006527699994, 72.43561432500007],
              [-101.9522104589999, 72.45807526200008],
              [-101.9614878029999, 72.47028229400007],
              [-101.90623064099992, 72.47028229400007],
              [-101.93398129199994, 72.48651764500005],
              [-101.96653337499993, 72.49705638200004],
              [-102.00071306299992, 72.50267161700003],
              [-102.03342790699992, 72.50438060100004],
              [-102.06532894799994, 72.51235586100006],
              [-102.13930355799994, 72.54108307500007],
              [-102.1675424899999, 72.53856028900003],
              [-102.15574235999992, 72.53099192900004],
              [-102.16420590199994, 72.52903880400004],
              [-102.19480485999992, 72.53237539300005],
              [-102.19765316699994, 72.53473541900007],
              [-102.20103044599995, 72.53921133000006],
              [-102.20619808899994, 72.54344310100004],
              [-102.21470232099995, 72.54535553600005],
              [-102.2420053809999, 72.54482656500005],
              [-102.2566945079999, 72.54767487200007],
              [-102.26308285499994, 72.55560944200005],
              [-102.34194027699994, 72.57953522300005],
              [-102.3811655369999, 72.57758209800005],
              [-102.39280290699992, 72.57953522300005],
              [-102.40175472999994, 72.58470286700003],
              [-102.40745134399992, 72.59145742400005],
              [-102.41086931299992, 72.59756094000005],
              [-102.41331071899992, 72.60065338700008],
              [-102.61423845399992, 72.66132233300004],
              [-102.65517269799994, 72.68109772300005],
              [-102.6880503029999, 72.70498281500005],
              [-102.72719418299994, 72.71808502800008],
              [-102.7422902109999, 72.73037344000005],
              [-102.7344370209999, 72.73419830900008],
              [-102.72792660499994, 72.73924388200004],
              [-102.71498715199994, 72.75202057500007],
              [-102.7329721779999, 72.75824616100005],
              [-102.7437143649999, 72.75967031500005],
              [-102.75034685199995, 72.76390208500004],
              [-102.7559620859999, 72.77875397300005],
              [-102.7559620859999, 72.78929271000004],
              [-102.7527882579999, 72.79824453300006],
              [-102.7512827239999, 72.80585358300004],
              [-102.7559620859999, 72.81232330900008],
              [-102.7320363049999, 72.83201732000003],
              [-102.66929216499994, 72.86066315300008],
              [-102.60203142199992, 72.91217682500007],
              [-102.59690446899992, 72.92357005400004],
              [-102.59584652699994, 72.93650950700004],
              [-102.5962534279999, 72.94765859600005],
              [-102.5955210059999, 72.95351797100005],
              [-102.5874643649999, 72.96369049700007],
              [-102.57582699499994, 72.98460521000004],
              [-102.56785173499992, 72.99477773600006],
              [-102.55702816699994, 73.00226471600007],
              [-102.53037614899995, 73.01479726800005],
              [-102.5200815529999, 73.02236562700006],
              [-102.48476254199994, 73.04124583500004],
              [-102.3926401459999, 73.04751211100006],
              [-102.35190935199995, 73.05996328300006],
              [-102.38230485999992, 73.06220123900005],
              [-102.39280290699992, 73.06610748900005],
              [-102.36167497699995, 73.07046133000006],
              [-102.29758806299992, 73.06533437700006],
              [-102.2693491309999, 73.07294342700004],
              [-102.28293962499993, 73.08722565300008],
              [-102.20603532899992, 73.07868073100008],
              [-102.1143198339999, 73.08881256700005],
              [-102.07997738599994, 73.08820221600007],
              [-102.0462045989999, 73.08030833500004],
              [-101.9478159279999, 73.09345123900005],
              [-101.9478159279999, 73.08722565300008],
              [-101.95774431299992, 73.08348216400003],
              [-101.9813038829999, 73.06610748900005],
              [-101.96287126599992, 73.05365631700005],
              [-101.94008480799994, 73.05329010600008],
              [-101.90623064099992, 73.05996328300006],
              [-101.8992726329999, 73.04083893400008],
              [-101.88547868799992, 73.02924225500004],
              [-101.8667612399999, 73.02277252800008],
              [-101.8447885839999, 73.01898834800005],
              [-101.82314144799994, 73.01772695500006],
              [-101.80381364899995, 73.01898834800005],
              [-101.78367204699992, 73.02423737200007],
              [-101.7737436619999, 73.02472565300008],
              [-101.76283871399994, 73.01898834800005],
              [-101.7684132579999, 73.01097239800004],
              [-101.7735402109999, 73.00136953300006],
              [-101.77992855799994, 72.99201080900008],
              [-101.78953142199992, 72.98480866100005],
              [-101.7593393649999, 72.98484935100004],
              [-101.74607439099992, 72.98078034100007],
              [-101.7349253029999, 72.97052643400008],
              [-101.80125017199992, 72.97687409100007],
              [-101.81748552399995, 72.97052643400008],
              [-101.73923845399992, 72.92767975500004],
              [-101.68967790699992, 72.91474030200004],
              [-101.6578175549999, 72.90078359600005],
              [-101.6287241309999, 72.89232005400004],
              [-101.61204118799992, 72.90167877800008],
              [-101.61781918299994, 72.91205475500004],
              [-101.59788103199992, 72.92226797100005],
              [-101.56785173499992, 72.92731354400007],
              [-101.5437631929999, 72.92210521000004],
              [-101.55808610999992, 72.92218659100007],
              [-101.57216488599994, 72.91998932500007],
              [-101.5857553809999, 72.91543203300006],
              [-101.59836931299992, 72.90843333500004],
              [-101.58347673499992, 72.90119049700007],
              [-101.53627621399994, 72.88861725500004],
              [-101.5222788179999, 72.88080475500004],
              [-101.49534196899992, 72.85321686400005],
              [-101.46348161799995, 72.83079661700003],
              [-101.45546566699994, 72.81769440300008],
              [-101.46860857099995, 72.80609772300005],
              [-101.43886410499994, 72.79462311400005],
              [-101.3972788179999, 72.78343333500004],
              [-101.3550831799999, 72.77850983300004],
              [-101.3240366309999, 72.78558991100005],
              [-101.33396501599992, 72.79169342700004],
              [-101.35544939099992, 72.79975006700005],
              [-101.36497087499993, 72.80609772300005],
              [-101.34055681299992, 72.80613841400003],
              [-101.31703793299994, 72.80093008000006],
              [-101.29551286799995, 72.79144928600005],
              [-101.27683610999992, 72.77875397300005],
              [-101.2913217869999, 72.76699453300006],
              [-101.3003549899999, 72.75592682500007],
              [-101.3110971779999, 72.74770742400005],
              [-101.3308725679999, 72.74457428600005],
              [-101.34006853199992, 72.74677155200004],
              [-101.35610043299994, 72.75608958500004],
              [-101.3687143649999, 72.75824616100005],
              [-101.4133920989999, 72.75202057500007],
              [-101.39890642199992, 72.75018952000005],
              [-101.3335581149999, 72.72479889500005],
              [-101.29624528999994, 72.71857330900008],
              [-101.13442074499994, 72.71161530200004],
              [-101.07224626599992, 72.69310130400004],
              [-101.05601091499994, 72.69086334800005],
              [-101.04018246399994, 72.69310130400004],
              [-101.02268571899992, 72.69993724200003],
              [-101.0034799899999, 72.70368073100008],
              [-100.98427426099994, 72.69985586100006],
              [-100.96547543299994, 72.69342682500007],
              [-100.94724626599992, 72.68939850500004],
              [-100.9121713959999, 72.69000885600008],
              [-100.8746144299999, 72.69619375200006],
              [-100.83901058899994, 72.70770905200004],
              [-100.8101206149999, 72.72410716400003],
              [-100.82517595399992, 72.72947825700004],
              [-100.87217302399995, 72.73777903900003],
              [-100.87217302399995, 72.74457428600005],
              [-100.8616342869999, 72.74526601800005],
              [-100.8562631929999, 72.74689362200007],
              [-100.85520524999993, 72.75071849200003],
              [-100.85789079699992, 72.75824616100005],
              [-100.84641618799992, 72.76312897300005],
              [-100.83608090199994, 72.76414622600004],
              [-100.8264780369999, 72.76219310100004],
              [-100.81687517199992, 72.75824616100005],
              [-100.83054704699992, 72.75824616100005],
              [-100.75575863599994, 72.75039297100005],
              [-100.59096371399994, 72.75873444200005],
              [-100.51023454699992, 72.75234609600005],
              [-100.50266618799992, 72.75263092700004],
              [-100.49644060199995, 72.75214264500005],
              [-100.4915170989999, 72.74974192900004],
              [-100.48793636999994, 72.74457428600005],
              [-100.4817514739999, 72.75202057500007],
              [-100.47459001599992, 72.74677155200004],
              [-100.4664113049999, 72.74262116100005],
              [-100.45762224299995, 72.73973216400003],
              [-100.44834489899995, 72.73810455900008],
              [-100.4312143649999, 72.74042389500005],
              [-100.41733903999994, 72.74632396000004],
              [-100.39174496399994, 72.76170482000003],
              [-100.34800310199995, 72.77655670800004],
              [-100.32924496399994, 72.78693268400008],
              [-100.31663103199992, 72.80609772300005],
              [-100.3291635839999, 72.84194570500006],
              [-100.33339535499994, 72.85016510600008],
              [-100.3547983489999, 72.86054108300004],
              [-100.40077816699994, 72.86615631700005],
              [-100.42026872699995, 72.87498607000003],
              [-100.39304704699992, 72.89179108300004],
              [-100.39662777699994, 72.90281810100004],
              [-100.44700212499993, 72.92210521000004],
              [-100.43394060199995, 72.93207428600005],
              [-100.3923960059999, 72.95010000200006],
              [-100.41831560199995, 72.95600006700005],
              [-100.4852101329999, 72.95380280200004],
              [-100.5022592869999, 72.96369049700007],
              [-100.44700212499993, 73.00470612200007],
              [-100.45237321899992, 73.00775788000004],
              [-100.46230160499994, 73.01593659100007],
              [-100.46742855799994, 73.01898834800005],
              [-100.43691097999994, 73.03367747600004],
              [-100.4219777109999, 73.03632233300004],
              [-100.40598649999993, 73.03266022300005],
              [-100.42026872699995, 73.03949616100005],
              [-100.41282243799992, 73.03949616100005],
              [-100.39296566699994, 73.02777741100005],
              [-100.3923960059999, 73.02578359600005],
              [-100.38344418299994, 73.02765534100007],
              [-100.37864274999993, 73.03180573100008],
              [-100.37559099299995, 73.03636302300004],
              [-100.36928402699994, 73.04193756700005],
              [-100.3667612399999, 73.04596588700008],
              [-100.3616342869999, 73.04987213700008],
              [-100.3513803809999, 73.05247630400004],
              [-100.34202165699992, 73.05097077000005],
              [-100.32997738599994, 73.04612864800004],
              [-100.3184213959999, 73.03949616100005],
              [-100.31040544599995, 73.03266022300005],
              [-100.3225717869999, 73.02277252800008],
              [-100.33970232099995, 73.01581452000005],
              [-100.35935564099992, 73.01178620000007],
              [-100.37827653999994, 73.01125722900008],
              [-100.37904965199994, 73.01121653900003],
              [-100.38088070599991, 73.01166413000004],
              [-100.38279314099992, 73.01186758000006],
              [-100.38466488599994, 73.01203034100007],
              [-100.38853044599995, 73.01255931200006],
              [-100.39255876599992, 73.01365794500003],
              [-100.39561052399995, 73.01496002800008],
              [-100.40500993799992, 73.01923248900005],
              [-100.40598649999993, 73.01898834800005],
              [-100.39748226899991, 73.01443105700008],
              [-100.3926401459999, 73.01255931200006],
              [-100.38914079699992, 73.01133860900006],
              [-100.38307797199991, 73.01060618700006],
              [-100.3814096779999, 73.00967031500005],
              [-100.38210140899992, 73.00922272300005],
              [-100.41469418299994, 72.98749420800004],
              [-100.4165659279999, 72.97833893400008],
              [-100.3985402109999, 72.96369049700007],
              [-100.37302751599992, 72.95136139500005],
              [-100.3433237399999, 72.94285716400003],
              [-100.31223649999993, 72.93797435100004],
              [-100.2825327239999, 72.93642812700006],
              [-100.30629574499994, 72.95062897300005],
              [-100.2938038829999, 72.96230703300006],
              [-100.26877946899992, 72.96002838700008],
              [-100.2551889739999, 72.93305084800005],
              [-100.26499528999994, 72.92283763200004],
              [-100.31264340199994, 72.91876862200007],
              [-100.3296925549999, 72.90843333500004],
              [-100.33250017199992, 72.89496491100005],
              [-100.3269663179999, 72.88434479400007],
              [-100.31663103199992, 72.87742747600004],
              [-100.3047902109999, 72.87498607000003],
              [-100.20054216499994, 72.88117096600007],
              [-100.1353159279999, 72.89618561400005],
              [-100.08652849299995, 72.88792552300004],
              [-100.07175798499992, 72.88857656500005],
              [-100.06337582299994, 72.89545319200005],
              [-100.06435238599994, 72.90102773600006],
              [-100.06874691699994, 72.90631745000007],
              [-100.0738331799999, 72.90940989800004],
              [-100.07704769799994, 72.90843333500004],
              [-100.07883806299992, 72.91437409100007],
              [-100.08583676099994, 72.91596100500004],
              [-100.0884409279999, 72.91901276200008],
              [-100.07704769799994, 72.92963288000004],
              [-100.06907243799992, 72.93244049700007],
              [-100.0354624119999, 72.93642812700006],
              [-100.0354624119999, 72.94383372600004],
              [-100.0559702239999, 72.95010000200006],
              [-100.05320329699992, 72.95384349200003],
              [-100.05186052399995, 72.95677317900004],
              [-100.04970394799994, 72.96369049700007],
              [-100.18007504199994, 72.99103424700007],
              [-100.16929216499994, 73.00381094000005],
              [-100.1512257579999, 73.00495026200008],
              [-100.11118669599995, 72.99848053600005],
              [-100.12400407899992, 73.00726959800005],
              [-100.12803239899995, 73.01536692900004],
              [-100.12363786799995, 73.02362702000005],
              [-100.11118669599995, 73.03266022300005],
              [-100.1521616309999, 73.03266022300005],
              [-100.1465463959999, 73.03571198100008],
              [-100.1316945079999, 73.04629140800006],
              [-100.15330095399992, 73.05255768400008],
              [-100.2039194429999, 73.04633209800005],
              [-100.22788591499994, 73.05247630400004],
              [-100.20286149999993, 73.06858958500004],
              [-100.17323910499994, 73.07977936400005],
              [-100.2078256929999, 73.09808991100005],
              [-100.28920590199994, 73.09223053600005],
              [-100.32346696899992, 73.10089752800008],
              [-100.30918474299995, 73.10614655200004],
              [-100.27781267199992, 73.10976797100005],
              [-100.2620249119999, 73.11456940300008],
              [-100.29612321899992, 73.12140534100007],
              [-100.27976579699992, 73.12738678600005],
              [-100.24436540699992, 73.12889232000003],
              [-100.22788591499994, 73.13442617400005],
              [-100.26454769799994, 73.14179108300004],
              [-100.31492204699992, 73.14175039300005],
              [-100.36362810199995, 73.13393789300005],
              [-100.40806169599995, 73.11180247600004],
              [-100.42527360999992, 73.10805898600006],
              [-100.44041032899992, 73.10236237200007],
              [-100.44700212499993, 73.09031810100004],
              [-100.45835466499994, 73.08616771000004],
              [-100.48423357099995, 73.08661530200004],
              [-100.52952165699992, 73.09345123900005],
              [-100.5193491309999, 73.11603424700007],
              [-100.5457570079999, 73.13080475500004],
              [-100.61147152699994, 73.14809804900005],
              [-100.6004038179999, 73.15550364800004],
              [-100.58689470399992, 73.17230866100005],
              [-100.57729183899994, 73.17938873900005],
              [-100.5647592869999, 73.18309153900003],
              [-100.52207536799995, 73.18280670800004],
              [-100.52268571899992, 73.19147370000007],
              [-100.50681657899992, 73.19623444200005],
              [-100.46742855799994, 73.20331452000005],
              [-100.48622738599994, 73.21246979400007],
              [-100.5098276459999, 73.21979401200008],
              [-100.53440446899992, 73.22406647300005],
              [-100.5562550549999, 73.22382233300004],
              [-100.5562550549999, 73.23126862200007],
              [-100.4734913829999, 73.23834870000007],
              [-100.44700212499993, 73.24428945500006],
              [-100.44862972999994, 73.24762604400007],
              [-100.45090837499993, 73.25409577000005],
              [-100.45375668299994, 73.25787995000007],
              [-100.42747087499993, 73.26703522300005],
              [-100.38132829699992, 73.29035065300008],
              [-100.3513803809999, 73.29266998900005],
              [-100.3650522559999, 73.28583405200004],
              [-100.35654802399995, 73.27399323100008],
              [-100.34145199499994, 73.27317942900004],
              [-100.30824886999994, 73.28412506700005],
              [-100.2922983489999, 73.28497955900008],
              [-100.27366228199992, 73.28034088700008],
              [-100.24155778999994, 73.26536692900004],
              [-100.21311540699992, 73.24591705900008],
              [-100.1995249119999, 73.24017975500004],
              [-100.18031918299994, 73.23802317900004],
              [-100.1043507579999, 73.24428945500006],
              [-100.1218881929999, 73.23533763200004],
              [-100.13853044599995, 73.22382233300004],
              [-100.0386769299999, 73.19367096600007],
              [-99.9939585059999, 73.19009023600006],
              [-99.81113786799995, 73.19513580900008],
              [-99.7686167089999, 73.21076080900008],
              [-99.8189096779999, 73.21796295800004],
              [-99.92600603199992, 73.21377187700006],
              [-99.9981495859999, 73.23558177300004],
              [-100.0535695079999, 73.24518463700008],
              [-100.09120785499994, 73.26557038000004],
              [-100.15956722999994, 73.29266998900005],
              [-100.17222185199995, 73.30231354400007],
              [-100.19700212499993, 73.32640208500004],
              [-100.20676774999993, 73.33368561400005],
              [-100.2620249119999, 73.35285065300008],
              [-100.2910776459999, 73.37197500200006],
              [-100.34389340199994, 73.39508698100008],
              [-100.3628956799999, 73.39960358300004],
              [-100.38352556299992, 73.40005117400005],
              [-100.3931284279999, 73.39451732000003],
              [-100.3787241309999, 73.38149648600006],
              [-100.39792985999992, 73.37018463700008],
              [-100.40598649999993, 73.36782461100006],
              [-100.39036149999993, 73.34418366100005],
              [-100.38865251599992, 73.34052155200004],
              [-100.3757944429999, 73.33926015800006],
              [-100.34788103199992, 73.33136627800008],
              [-100.33713884399992, 73.32623932500007],
              [-100.47764177399995, 73.32330963700008],
              [-100.65806169599995, 73.28107330900008],
              [-100.85789079699992, 73.26284414300005],
              [-100.97402035499994, 73.28196849200003],
              [-101.03159685199995, 73.30243561400005],
              [-101.04237972999994, 73.31126536700003],
              [-101.02919613599994, 73.32062409100007],
              [-101.02919613599994, 73.32623932500007],
              [-101.06679379199994, 73.32501862200007],
              [-101.28896176099994, 73.36005280200004],
              [-101.31777035499994, 73.37466054900005],
              [-101.31484066699994, 73.40045807500007],
              [-101.34983415699992, 73.41242096600007],
              [-101.4304819429999, 73.41559479400007],
              [-101.44651384399992, 73.41990794500003],
              [-101.47092790699992, 73.43915436400005],
              [-101.48508806299992, 73.44354889500005],
              [-101.56321306299992, 73.44953034100007],
              [-101.58469743799992, 73.45718008000006],
              [-101.57456560199995, 73.46051666900007],
              [-101.5672006929999, 73.46165599200003],
              [-101.56003923499992, 73.46059804900005],
              [-101.5505991309999, 73.45718008000006],
              [-101.5615854589999, 73.46857330900008],
              [-101.5828256929999, 73.47870514500005],
              [-101.62563168299994, 73.49135976800005],
              [-101.60569353199992, 73.49628327000005],
              [-101.5699269299999, 73.49160390800006],
              [-101.5505991309999, 73.49135976800005],
              [-101.53159685199995, 73.49555084800005],
              [-101.52537126599992, 73.50079987200007],
              [-101.52146501599992, 73.50726959800005],
              [-101.47035824499994, 73.54083893400008],
              [-101.4558725679999, 73.54783763200004],
              [-101.43715511999994, 73.55341217700004],
              [-101.41786801099994, 73.55703359600005],
              [-101.37864274999993, 73.55955638200004],
              [-101.3035288179999, 73.55223216400003],
              [-101.26938982099995, 73.56004466400003],
              [-101.25510759399992, 73.59064362200007],
              [-101.22983903999994, 73.60614655200004],
              [-100.97800798499992, 73.59438711100006],
              [-100.91855974299995, 73.60297272300005],
              [-100.8994760839999, 73.60053131700005],
              [-100.88523454699992, 73.59393952000005],
              [-100.84482927399995, 73.56704336100006],
              [-100.82615251599992, 73.56012604400007],
              [-100.7691456799999, 73.54588450700004],
              [-100.72133480799994, 73.51239655200004],
              [-100.71360368799992, 73.50405508000006],
              [-100.70115251599992, 73.48550039300005],
              [-100.69399105799994, 73.47768789300005],
              [-100.65427751599992, 73.46149323100008],
              [-100.5576792089999, 73.45355866100005],
              [-100.52207536799995, 73.43610260600008],
              [-100.5176808359999, 73.42316315300008],
              [-100.48142595399992, 73.41156647300005],
              [-100.44004411799995, 73.40810781500005],
              [-100.42026872699995, 73.41925690300008],
              [-100.43931169599995, 73.43952057500007],
              [-100.48264665699992, 73.45831940300008],
              [-100.58921403999994, 73.48379140800006],
              [-100.6043100679999, 73.49876536700003],
              [-100.6031300549999, 73.51780833500004],
              [-100.5835581149999, 73.53603750200006],
              [-100.5723683359999, 73.54238515800006],
              [-100.54921566699994, 73.55906810100004],
              [-100.54319353199992, 73.56704336100006],
              [-100.54311215199994, 73.57770416900007],
              [-100.54917497699995, 73.58307526200008],
              [-100.5537729589999, 73.58881256700005],
              [-100.54941911799995, 73.60053131700005],
              [-100.61619157899992, 73.59739817900004],
              [-100.64780778999994, 73.60073476800005],
              [-100.67690121399994, 73.61823151200008],
              [-100.6914682709999, 73.62441640800006],
              [-100.71140642199992, 73.62417226800005],
              [-100.73110043299994, 73.61920807500007],
              [-100.7449350679999, 73.61115143400008],
              [-100.76072282899992, 73.60504791900007],
              [-100.78123064099992, 73.60740794500003],
              [-100.80263363599994, 73.61253489800004],
              [-100.82139177399995, 73.61469147300005],
              [-100.87473649999993, 73.61863841400003],
              [-100.90012712499993, 73.62531159100007],
              [-100.9131479589999, 73.63532135600008],
              [-100.89426774999993, 73.63715241100005],
              [-100.8772592869999, 73.64272695500006],
              [-100.86440121399994, 73.65289948100008],
              [-100.85789079699992, 73.66885000200006],
              [-100.87815446899992, 73.66901276200008],
              [-100.9370737399999, 73.67625560100004],
              [-101.0161753029999, 73.67625560100004],
              [-101.0479135839999, 73.68256256700005],
              [-101.05723161799995, 73.69599030200004],
              [-101.04600114899995, 73.70799388200004],
              [-101.0161753029999, 73.71039459800005],
              [-101.0161753029999, 73.71723053600005],
              [-101.02952165699992, 73.71881745000007],
              [-101.05247087499993, 73.72907135600008],
              [-101.06361996399994, 73.73151276200008],
              [-101.10410661799995, 73.72418854400007],
              [-101.11855160499994, 73.72406647300005],
              [-101.0950327239999, 73.74249909100007],
              [-101.01186215199994, 73.75413646000004],
              [-100.98142595399992, 73.77252838700008],
              [-101.0066538179999, 73.77216217700004],
              [-101.01829118799992, 73.77387116100005],
              [-101.02919613599994, 73.77871328300006],
              [-101.0049448339999, 73.80239492400005],
              [-100.96816097999994, 73.81248607000003],
              [-100.88584489899995, 73.81403229400007],
              [-100.88584489899995, 73.83209870000007],
              [-100.86375017199992, 73.83161041900007],
              [-100.81687517199992, 73.82025788000004],
              [-100.8237924899999, 73.82025788000004],
              [-100.75828142199992, 73.81439850500004],
              [-100.72279965199994, 73.81736888200004],
              [-100.69712419599995, 73.83051178600005],
              [-100.6721811619999, 73.84735748900005],
              [-100.6414194429999, 73.85431549700007],
              [-100.41493832299994, 73.84365469000005],
              [-100.30271501599992, 73.80951569200005],
              [-100.1727101329999, 73.79999420800004],
              [-100.0699269299999, 73.77301666900007],
              [-100.06337582299994, 73.76902903900003],
              [-100.06117855799994, 73.76044342700004],
              [-100.0557260839999, 73.75405508000006],
              [-100.0422983489999, 73.74518463700008],
              [-100.02329607099995, 73.73777903900003],
              [-100.01401872699995, 73.74331289300005],
              [-100.0157277109999, 73.75486888200004],
              [-100.02927751599992, 73.76561107000003],
              [-100.01987810199995, 73.77293528900003],
              [-100.0005503029999, 73.78266022300005],
              [-99.98691911799995, 73.79157135600008],
              [-99.97874040699992, 73.79413483300004],
              [-99.97434587499993, 73.79608795800004],
              [-99.96982927399995, 73.80084870000007],
              [-99.96921892199992, 73.80589427300004],
              [-99.9695444429999, 73.81061432500007],
              [-99.9678354589999, 73.81403229400007],
              [-99.9431772559999, 73.82314687700006],
              [-99.88173519799994, 73.83445872600004],
              [-99.86106462499993, 73.84446849200003],
              [-99.8536183359999, 73.85516998900005],
              [-99.84609066699994, 73.87230052300004],
              [-99.84609066699994, 73.88833242400005],
              [-99.86106462499993, 73.89541250200006],
              [-99.88279314099992, 73.89618561400005],
              [-99.8887745859999, 73.89541250200006],
              [-99.8784799899999, 73.86806875200006],
              [-99.9143686619999, 73.88825104400007],
              [-99.95408220399992, 73.87946198100008],
              [-100.02927751599992, 73.84137604400007],
              [-100.0860402109999, 73.83177317900004],
              [-100.2620249119999, 73.84137604400007],
              [-100.2586476329999, 73.84560781500005],
              [-100.25649105799994, 73.84894440300008],
              [-100.25356136999994, 73.85199616100005],
              [-100.24770199499994, 73.85504791900007],
              [-100.26112972999994, 73.85960521000004],
              [-100.27476091499994, 73.86131419500003],
              [-100.30295915699992, 73.86123281500005],
              [-100.27866716499994, 73.88955312700006],
              [-100.24924821899992, 73.90875885600008],
              [-100.2141733489999, 73.91986725500004],
              [-100.15419613599994, 73.92641836100006],
              [-100.1155405369999, 73.94009023600006],
              [-100.09413754199994, 73.94318268400008],
              [-100.02415056299992, 73.94546133000006],
              [-100.00132341499994, 73.95001862200007],
              [-99.80271501599992, 73.93695709800005],
              [-99.81089372699995, 73.93024323100008],
              [-99.82297868799992, 73.92255280200004],
              [-99.83363949499994, 73.91331614800004],
              [-99.8374643649999, 73.90224844000005],
              [-99.83095394799994, 73.89691803600005],
              [-99.80027360999992, 73.87832265800006],
              [-99.78904314099992, 73.86806875200006],
              [-99.7730519299999, 73.87677643400008],
              [-99.75803728199992, 73.87205638200004],
              [-99.72898454699992, 73.85309479400007],
              [-99.7012745859999, 73.84764232000003],
              [-99.5147104589999, 73.83392975500004],
              [-99.49509782899992, 73.82697174700007],
              [-99.4641733489999, 73.80776601800005],
              [-99.44639177399995, 73.79975006700005],
              [-99.4277963959999, 73.79791901200008],
              [-99.41038103199992, 73.80019765800006],
              [-99.3931284279999, 73.79954661700003],
              [-99.3550424899999, 73.77692291900007],
              [-99.21840511999994, 73.73944733300004],
              [-99.20619808899994, 73.73151276200008],
              [-99.20961605799994, 73.71930573100008],
              [-99.22288103199992, 73.71112702000005],
              [-99.23826189099992, 73.70441315300008],
              [-99.24778337499993, 73.69672272300005],
              [-99.22837419599995, 73.69635651200008],
              [-99.1912241309999, 73.69025299700007],
              [-99.17954607099995, 73.69057851800005],
              [-99.1633920989999, 73.69537995000007],
              [-99.15859066699994, 73.70848216400003],
              [-99.1565561619999, 73.72553131700005],
              [-99.1485402109999, 73.74144114800004],
              [-99.12864274999993, 73.75177643400008],
              [-99.10325212499993, 73.75429922100005],
              [-99.05417985999992, 73.75136953300006],
              [-98.91469418299994, 73.76398346600007],
              [-98.83860368799992, 73.76166413000004],
              [-98.7959604589999, 73.73773834800005],
              [-98.7891245209999, 73.73773834800005],
              [-98.77455746399994, 73.75360748900005],
              [-98.74741716499994, 73.76487864800004],
              [-98.71628923499992, 73.77130768400008],
              [-98.68984066699994, 73.77265045800004],
              [-98.6860971779999, 73.77252838700008],
              [-98.67917985999992, 73.77741120000007],
              [-98.6031300549999, 73.78058502800008],
              [-98.53489274999993, 73.79413483300004],
              [-98.0965382579999, 73.81830475500004],
              [-98.04612321899992, 73.83710358300004],
              [-97.97690935199995, 73.84857819200005],
              [-97.95204769799994, 73.86554596600007],
              [-97.93015642199992, 73.88568756700005],
              [-97.89841814099992, 73.90224844000005],
              [-97.90464372699995, 73.90224844000005],
              [-97.77390642199992, 73.91889069200005],
              [-97.73329769799994, 73.90900299700007],
              [-97.7579152109999, 73.89744700700004],
              [-97.8118295989999, 73.88104889500005],
              [-97.8357553809999, 73.86806875200006],
              [-97.80381364899995, 73.85936107000003],
              [-97.76829118799992, 73.86326732000003],
              [-97.69919939099992, 73.88231028900003],
              [-97.6133839609999, 73.89545319200005],
              [-97.57045590199994, 73.89370351800005],
              [-97.4612436619999, 73.86517975500004],
              [-97.26035661799995, 73.86123281500005],
              [-97.19370622699995, 73.84747955900008],
              [-97.16135759399992, 73.83470286700003],
              [-97.06882829699992, 73.77045319200005],
              [-97.04124040699992, 73.75885651200008],
              [-96.9834604589999, 73.74884674700007],
              [-96.95640153999994, 73.73729075700004],
              [-96.945049, 73.71381256700005],
              [-96.93931169599995, 73.69481028900003],
              [-96.93821306299992, 73.68683502800008],
              [-96.97300310199995, 73.66266510600008],
              [-96.9695851329999, 73.64081452000005],
              [-96.99473161799995, 73.62592194200005],
              [-97.1719777109999, 73.58926015800006],
              [-97.1778370859999, 73.57387929900005],
              [-97.2200327239999, 73.55597565300008],
              [-97.27769060199995, 73.55475495000007],
              [-97.42478532899992, 73.58466217700004],
              [-97.44858903999994, 73.58515045800004],
              [-97.45896501599992, 73.57729726800005],
              [-97.45546566699994, 73.56452057500007],
              [-97.4383351329999, 73.54360586100006],
              [-97.4317026459999, 73.53229401200008],
              [-97.48459978199992, 73.52106354400007],
              [-97.59194027699994, 73.54266998900005],
              [-97.64394222999994, 73.53969961100006],
              [-97.63108415699992, 73.52602773600006],
              [-97.63539730799994, 73.51630280200004],
              [-97.64744157899992, 73.50787995000007],
              [-97.65757341499994, 73.49811432500007],
              [-97.66355485999992, 73.49046458500004],
              [-97.6682749119999, 73.48631419500003],
              [-97.6685190529999, 73.48212311400005],
              [-97.66135759399992, 73.47418854400007],
              [-97.6480519299999, 73.46564362200007],
              [-97.63222347999994, 73.46039459800005],
              [-97.61570329699992, 73.45783112200007],
              [-97.59983415699992, 73.45718008000006],
              [-97.55173845399992, 73.46800364800004],
              [-97.49827165699992, 73.48908112200007],
              [-97.445049, 73.50263092700004],
              [-97.3975229589999, 73.49135976800005],
              [-97.40500993799992, 73.48444245000007],
              [-97.3784799899999, 73.47329336100006],
              [-97.34804379199994, 73.46954987200007],
              [-97.22019548499992, 73.47748444200005],
              [-97.1832081799999, 73.47235748900005],
              [-97.16477556299992, 73.44969310100004],
              [-97.18642269799994, 73.44432200700004],
              [-97.25413103199992, 73.43610260600008],
              [-97.2313038829999, 73.42792389500005],
              [-97.18381853199992, 73.42137278900003],
              [-97.16477556299992, 73.40875885600008],
              [-97.17100114899995, 73.40875885600008],
              [-97.1648569429999, 73.40595123900005],
              [-97.1504933359999, 73.39508698100008],
              [-97.15883480799994, 73.39093659100007],
              [-97.16526384399992, 73.38617584800005],
              [-97.1778370859999, 73.37466054900005],
              [-97.1727101329999, 73.35895416900007],
              [-97.1936655369999, 73.35126373900005],
              [-97.22304379199994, 73.35097890800006],
              [-97.26560564099992, 73.36737702000005],
              [-97.29514665699992, 73.36644114800004],
              [-97.58909196899992, 73.32005442900004],
              [-97.6651010839999, 73.32062409100007],
              [-97.65785824499994, 73.31240469000005],
              [-97.6785695079999, 73.30906810100004],
              [-97.73329769799994, 73.30634186400005],
              [-97.82826840199994, 73.27826569200005],
              [-97.84999691699994, 73.26536692900004],
              [-97.8538217869999, 73.25861237200007],
              [-97.85532732099995, 73.25043366100005],
              [-97.85903011999994, 73.24249909100007],
              [-97.86899919599995, 73.23627350500004],
              [-98.18931169599995, 73.11676666900007],
              [-98.23158871399994, 73.08832428600005],
              [-98.34861345399992, 73.04364655200004],
              [-98.41054379199994, 73.03656647300005],
              [-98.49403988599994, 73.01788971600007],
              [-98.51475114899995, 73.00470612200007],
              [-98.4749155369999, 73.00161367400005],
              [-98.4553842869999, 72.99575429900005],
              [-98.44529314099992, 72.98480866100005],
              [-98.44785661799995, 72.97968170800004],
              [-98.4732065529999, 72.96369049700007],
              [-98.4422413829999, 72.95221588700008],
              [-98.43162126599992, 72.94342682500007],
              [-98.4390675549999, 72.93305084800005],
              [-98.44919939099992, 72.92381419500003],
              [-98.45298357099995, 72.91225820500006],
              [-98.4527394299999, 72.88491445500006],
              [-98.44618832299994, 72.87250397300005],
              [-98.4319467869999, 72.86302317900004],
              [-98.4175831799999, 72.86102936400005],
              [-98.41111345399992, 72.87124258000006],
              [-98.4092417089999, 72.88540273600006],
              [-98.40378923499992, 72.89618561400005],
              [-98.3953256929999, 72.90485260600008],
              [-98.38413591499994, 72.91217682500007],
              [-98.31553239899995, 72.94383372600004],
              [-98.26772152699994, 72.97736237200007],
              [-98.22304379199994, 72.99237702000005],
              [-98.12668962499993, 73.01284414300005],
              [-98.09023129199994, 73.03266022300005],
              [-98.0747690529999, 73.02448151200008],
              [-98.0547902109999, 73.02627187700006],
              [-98.01389665699992, 73.03949616100005],
              [-97.9851694429999, 73.04413483300004],
              [-97.87437028999994, 73.04775625200006],
              [-97.83681332299994, 73.04140859600005],
              [-97.66074724299995, 73.03668854400007],
              [-97.2559620859999, 72.96206289300005],
              [-97.22621761999994, 72.93642812700006],
              [-97.24070329699992, 72.93813711100006],
              [-97.25071306299992, 72.93500397300005],
              [-97.25364274999993, 72.92747630400004],
              [-97.24668474299995, 72.91596100500004],
              [-97.26267595399992, 72.88849518400008],
              [-97.27382504199994, 72.87872955900008],
              [-97.2911183359999, 72.87498607000003],
              [-97.41860043299994, 72.86749909100007],
              [-97.41860043299994, 72.86066315300008],
              [-97.26625668299994, 72.85443756700005],
              [-97.21938168299994, 72.84023672100005],
              [-97.2080698339999, 72.83372630400004],
              [-97.17722673499992, 72.81122467700004],
              [-97.17100114899995, 72.80231354400007],
              [-97.1648976329999, 72.78514232000003],
              [-97.14963884399992, 72.78156159100007],
              [-97.10951840199994, 72.78558991100005],
              [-97.09080095399992, 72.78266022300005],
              [-97.0776987399999, 72.77728913000004],
              [-97.03489274999993, 72.74127838700008],
              [-97.02561540699992, 72.72947825700004],
              [-97.03098649999993, 72.72410716400003],
              [-97.11293636999994, 72.69993724200003],
              [-97.12803239899995, 72.69057851800005],
              [-97.18528337499993, 72.66889069200005],
              [-97.17612810199995, 72.65326569200005],
              [-97.17100114899995, 72.64842357000003],
              [-97.1766163829999, 72.64744700700004],
              [-97.18666683899994, 72.64362213700008],
              [-97.19211931299992, 72.64223867400005],
              [-97.18788754199994, 72.64061107000003],
              [-97.1778370859999, 72.63471100500004],
              [-97.1939096779999, 72.61505768400008],
              [-97.15940446899992, 72.60736725500004],
              [-97.10683285499994, 72.60822174700007],
              [-97.06858415699992, 72.61424388200004],
              [-96.93202816699994, 72.67572663000004],
              [-96.7105112399999, 72.71482982000003],
              [-96.65907894799994, 72.71401601800005],
              [-96.63686215199994, 72.72040436400005],
              [-96.60276384399992, 72.73749420800004],
              [-96.59657894799994, 72.74628327000005],
              [-96.61611019799994, 72.75202057500007],
              [-96.53757829699992, 72.75202057500007],
              [-96.52968441699994, 72.73932526200008],
              [-96.52195329699992, 72.72988515800006],
              [-96.51365251599992, 72.72410716400003],
              [-96.5308644299999, 72.71588776200008],
              [-96.57053728199992, 72.70465729400007],
              [-96.58876644799994, 72.69684479400007],
              [-96.57265316699994, 72.68854401200008],
              [-96.45225114899995, 72.64223867400005],
              [-96.45872087499993, 72.61985911700003],
              [-96.44871110999992, 72.59638092700004],
              [-96.42832536799995, 72.57672760600008],
              [-96.40378923499992, 72.56586334800005],
              [-96.4136362399999, 72.55731842700004],
              [-96.43186540699992, 72.54779694200005],
              [-96.43857927399995, 72.53856028900003],
              [-96.42690121399994, 72.53937409100007],
              [-96.39902849299995, 72.54511139500005],
              [-96.3901987399999, 72.54535553600005],
              [-96.37929379199994, 72.54010651200008],
              [-96.37343441699994, 72.53339264500005],
              [-96.3689585059999, 72.52594635600008],
              [-96.36220394799994, 72.51805247600004],
              [-96.33469743799992, 72.49823639500005],
              [-96.3250131929999, 72.48598867400005],
              [-96.32126970399992, 72.46686432500007],
            ],
          ],
          [
            [
              [-99.24742591099994, 73.85504791900007],
              [-99.35513261599993, 73.86615631700005],
              [-99.41136633999992, 73.88271719000005],
              [-99.4402563139999, 73.90900299700007],
              [-99.38971920499995, 73.92373281500005],
              [-99.0969945949999, 73.95746491100005],
              [-98.9993383449999, 73.95050690300008],
              [-98.97350012899994, 73.95746491100005],
              [-98.9871313139999, 73.96088288000004],
              [-98.99998938699991, 73.96670156500005],
              [-99.01170813699991, 73.97479889500005],
              [-99.02188066299993, 73.98476797100005],
              [-98.98277747299994, 73.99591705900008],
              [-98.8426000639999, 74.00739166900007],
              [-98.76992753799993, 74.03107330900008],
              [-98.75251217399995, 74.03363678600005],
              [-98.52920488199993, 74.03339264500005],
              [-98.17300370999993, 74.09772370000007],
              [-97.72524980399993, 74.12164948100008],
              [-97.68871008999992, 74.11615631700005],
              [-97.65758216099994, 74.10138580900008],
              [-97.64321855399993, 74.07221100500004],
              [-97.6929418609999, 74.03294505400004],
              [-97.80846106699994, 73.97793203300006],
              [-97.90021725199995, 73.95563385600008],
              [-97.99339758999992, 73.94318268400008],
              [-98.0071508449999, 73.93915436400005],
              [-98.03331458199995, 73.92609284100007],
              [-98.0418188139999, 73.92328522300005],
              [-98.05166581899994, 73.92177969000005],
              [-98.05711829299992, 73.91771067900004],
              [-98.06541907499991, 73.90558502800008],
              [-98.07437089799993, 73.89887116100005],
              [-98.0833227199999, 73.89655182500007],
              [-98.09276282499991, 73.89541250200006],
              [-98.12368730399993, 73.88344961100006],
              [-98.14342200399994, 73.87840403900003],
              [-98.39742997949995, 73.85647207250005],
              [-98.65143795499995, 73.83454010600008],
              [-98.71837317599994, 73.86522044500003],
              [-98.74303137899994, 73.85468170800004],
              [-98.74852454299992, 73.83641185100004],
              [-98.72020423099991, 73.82709381700005],
              [-98.74083411399994, 73.81891510600008],
              [-98.76317298099991, 73.81659577000005],
              [-98.8360082669999, 73.82184479400007],
              [-98.89704342399995, 73.81867096600007],
              [-98.95128333199995, 73.80711497600004],
              [-99.1433813139999, 73.82160065300008],
              [-99.17210852799991, 73.83392975500004],
              [-99.14537512899994, 73.84100983300004],
              [-98.8262426419999, 73.83209870000007],
              [-98.81920325399994, 73.83763255400004],
              [-98.84398352799991, 73.85224030200004],
              [-98.87604732999995, 73.85687897300005],
              [-99.24742591099994, 73.85504791900007],
            ],
          ],
          [
            [
              [-90.29100501199991, 73.92328522300005],
              [-90.26744544199994, 73.92153554900005],
              [-90.24209550699993, 73.91681549700007],
              [-90.19570878799993, 73.90224844000005],
              [-90.23900305899991, 73.85846588700008],
              [-90.26414954299992, 73.84479401200008],
              [-90.29124915299991, 73.84760163000004],
              [-90.30166581899994, 73.85545482000003],
              [-90.30699622299994, 73.86383698100008],
              [-90.31297766799992, 73.87103913000004],
              [-90.32542883999992, 73.87547435100004],
              [-90.3418676419999, 73.87425364800004],
              [-90.36168372299994, 73.86786530200004],
              [-90.37889563699991, 73.85838450700004],
              [-90.3875219389999, 73.84760163000004],
              [-90.36929277299993, 73.84064362200007],
              [-90.36164303299995, 73.82689036700003],
              [-90.36327063699991, 73.80971914300005],
              [-90.37319902299993, 73.79238515800006],
              [-90.4434301419999, 73.74534739800004],
              [-90.47594153599994, 73.73037344000005],
              [-90.51073157499991, 73.69794342700004],
              [-90.58836829299992, 73.65778229400007],
              [-90.63390051999994, 73.64150625200006],
              [-90.78636633999992, 73.55683014500005],
              [-90.84593665299991, 73.54588450700004],
              [-90.93895423099991, 73.54588450700004],
              [-90.95034745999993, 73.54804108300004],
              [-90.97101803299995, 73.55744049700007],
              [-90.98338782499991, 73.55955638200004],
              [-90.99596106699994, 73.55121491100005],
              [-90.97398841099994, 73.53204987200007],
              [-90.92125403599994, 73.49811432500007],
              [-90.9351293609999, 73.48395416900007],
              [-91.03262285099993, 73.44415924700007],
              [-91.03795325399994, 73.43984609600005],
              [-91.03831946499992, 73.42991771000004],
              [-91.03994706899994, 73.42381419500003],
              [-91.04417883999992, 73.41966380400004],
              [-91.05223548099991, 73.41559479400007],
              [-91.04478919199994, 73.41559479400007],
              [-91.0598852199999, 73.41396719000005],
              [-91.07559160099993, 73.40766022300005],
              [-91.08812415299991, 73.39765045800004],
              [-91.09325110599991, 73.38519928600005],
              [-91.10407467399995, 73.37734609600005],
              [-91.17577063699991, 73.35415273600006],
              [-91.20006262899994, 73.33478424700007],
              [-91.23619544199994, 73.28998444200005],
              [-91.25767981699994, 73.27220286700003],
              [-91.2788793609999, 73.26268138200004],
              [-91.30431067599994, 73.25592682500007],
              [-91.33079993399991, 73.25324127800008],
              [-91.37905839799993, 73.25812409100007],
              [-91.46129309799994, 73.24428945500006],
              [-91.59557044199994, 73.24359772300005],
              [-91.63385982999995, 73.23126862200007],
              [-91.37730872299994, 73.21344635600008],
              [-91.37633216099994, 73.20319245000007],
              [-91.47370357999995, 73.13442617400005],
              [-91.47427324099993, 73.12954336100006],
              [-91.49730383999992, 73.10089752800008],
              [-91.52749589799993, 73.08193594000005],
              [-91.5894262359999, 73.05499909100007],
              [-91.62905839799993, 73.02920156500005],
              [-91.63890540299991, 73.02704498900005],
              [-91.64561926999994, 73.02236562700006],
              [-91.64810136599993, 73.00812409100007],
              [-91.64854895699995, 72.99241771000004],
              [-91.65147864499994, 72.98468659100007],
              [-91.65953528599994, 72.97923411700003],
              [-91.7715551419999, 72.92291901200008],
              [-91.79523678299995, 72.90509674700007],
              [-91.83470618399991, 72.86399974200003],
              [-91.85765540299991, 72.84796784100007],
              [-92.01183020699995, 72.79857005400004],
              [-92.03302975199995, 72.78742096600007],
              [-92.07298743399991, 72.75519440300008],
              [-92.09581458199995, 72.74624258000006],
              [-92.16885331899994, 72.73037344000005],
              [-92.38487708199995, 72.70990631700005],
              [-92.46719316299993, 72.72190989800004],
              [-92.58315995999993, 72.72630442900004],
              [-92.62865149599992, 72.74038320500006],
              [-93.04820716099994, 72.76919179900005],
              [-93.09316972599993, 72.78266022300005],
              [-93.11449133999992, 72.78558991100005],
              [-93.2110082669999, 72.78558991100005],
              [-93.23184160099993, 72.78815338700008],
              [-93.27928626199991, 72.81232330900008],
              [-93.30101477799991, 72.81834544500003],
              [-93.31802324099993, 72.81732819200005],
              [-93.35289466099994, 72.80414459800005],
              [-93.40322831899994, 72.79433828300006],
              [-93.50316321499992, 72.79779694200005],
              [-93.59870357999995, 72.78465403900003],
              [-93.87718665299994, 72.77798086150005],
              [-94.15566972599993, 72.77130768400008],
              [-94.24181067599994, 72.78119538000004],
              [-94.28661048099991, 72.78034088700008],
              [-94.32079016799992, 72.76508209800005],
              [-94.32843990799995, 72.75592682500007],
              [-94.33311926999994, 72.74551015800006],
              [-94.3335668609999, 72.73468659100007],
              [-94.32823645699995, 72.72410716400003],
              [-94.31432044199994, 72.71662018400008],
              [-94.29751542899993, 72.71845123900005],
              [-94.26553300699993, 72.73037344000005],
              [-94.22716223899994, 72.73696523600006],
              [-94.18594316299993, 72.73680247600004],
              [-94.01952063699991, 72.71246979400007],
              [-93.8758031889999, 72.70990631700005],
              [-93.87360592399995, 72.71161530200004],
              [-93.84780839799993, 72.72410716400003],
              [-93.8394262359999, 72.72675202000005],
              [-93.83421790299991, 72.72728099200003],
              [-93.82990475199995, 72.72870514500005],
              [-93.82396399599992, 72.73407623900005],
              [-93.81281490799995, 72.74168528900003],
              [-93.79954993399991, 72.74420807500007],
              [-93.78742428299995, 72.74070872600004],
              [-93.77953040299991, 72.73037344000005],
              [-93.79649817599994, 72.72785065300008],
              [-93.79954993399991, 72.71824778900003],
              [-93.79320227799991, 72.69310130400004],
              [-93.80040442599994, 72.67934804900005],
              [-93.81432044199994, 72.66876862200007],
              [-93.82359778599994, 72.65851471600007],
              [-93.81680253799993, 72.64524974200003],
              [-93.78359941299993, 72.63007233300004],
              [-93.66222083199995, 72.61424388200004],
              [-93.62832597599993, 72.60122304900005],
              [-93.56029212099992, 72.56598541900007],
              [-93.50059973899994, 72.51601797100005],
              [-93.46422278599994, 72.46344635600008],
              [-93.47175045499995, 72.46344635600008],
              [-93.46422278599994, 72.45661041900007],
              [-93.47508704299992, 72.44196198100008],
              [-93.49205481699994, 72.43353913000004],
              [-93.51219641799992, 72.42963288000004],
              [-93.53229732999995, 72.42869700700004],
              [-93.54922441299993, 72.42548248900005],
              [-93.55923417899993, 72.41742584800005],
              [-93.57408606699994, 72.39516836100006],
              [-93.59813391799992, 72.37246328300006],
              [-93.62279212099992, 72.35785553600005],
              [-93.6848852199999, 72.33502838700008],
              [-93.72752844999991, 72.32648346600007],
              [-93.7703344389999, 72.32404205900008],
              [-93.81102454299992, 72.31631094000005],
              [-93.84780839799993, 72.29214101800005],
              [-93.8665258449999, 72.27204010600008],
              [-93.87466386599993, 72.26569245000007],
              [-93.88878333199995, 72.25739166900007],
              [-93.91673743399991, 72.24530670800004],
              [-93.9265844389999, 72.23822663000004],
              [-93.93040930899991, 72.22699616100005],
              [-93.94318600199995, 72.20962148600006],
              [-94.02660071499992, 72.15497467700004],
              [-94.03429114499994, 72.14630768400008],
              [-94.03844153599994, 72.13959381700005],
              [-94.0464574859999, 72.12079498900005],
              [-94.04723059799994, 72.11603424700007],
              [-94.04576575399994, 72.10516998900005],
              [-94.0464574859999, 72.10032786700003],
              [-94.05101477799991, 72.09418366100005],
              [-94.0581762359999, 72.08808014500005],
              [-94.06468665299991, 72.08372630400004],
              [-94.06753495999993, 72.08295319200005],
              [-94.08775794199994, 72.06354401200008],
              [-94.21837317599994, 72.05255768400008],
              [-94.23387610599991, 72.03241608300004],
              [-94.20653235599991, 72.02326080900008],
              [-94.16274980399993, 72.02179596600007],
              [-94.12901770699995, 72.02460358300004],
              [-94.10342363199993, 72.03485748900005],
              [-94.08092200399994, 72.04999420800004],
              [-94.05679277299993, 72.06264883000006],
              [-94.02660071499992, 72.06557851800005],
              [-94.0738012359999, 72.02460358300004],
              [-94.03282630099994, 72.00409577000005],
              [-94.04849199099993, 72.00023021000004],
              [-94.06753495999993, 71.99795156500005],
              [-94.06578528599994, 71.99457428600005],
              [-94.06322180899991, 71.98761627800008],
              [-94.0601293609999, 71.98362864800004],
              [-94.08828691299993, 71.97939687700006],
              [-94.12389075399994, 71.98525625200006],
              [-94.19041907499991, 72.00409577000005],
              [-94.29133053299995, 72.00291575700004],
              [-94.34496008999992, 72.02562083500004],
              [-94.57827714799993, 72.01947663000004],
              [-94.60195878799993, 72.01093170800004],
              [-94.60195878799993, 72.01776764500005],
              [-94.61900794199994, 72.01508209800005],
              [-94.74950110599991, 72.01532623900005],
              [-95.14525305899991, 71.96588776200008],
              [-95.17275956899994, 71.97329336100006],
              [-95.16002356699994, 71.98069896000004],
              [-95.10903886599993, 71.99046458500004],
              [-95.10903886599993, 71.99795156500005],
              [-95.19737708199995, 71.99237702000005],
              [-95.21149654899995, 71.99420807500007],
              [-95.20824133999992, 72.00820547100005],
              [-95.19420325399994, 72.02920156500005],
              [-95.19102942599994, 72.04197825700004],
              [-95.19225012899994, 72.04926178600005],
              [-95.1926977199999, 72.05971914300005],
              [-95.1870824859999, 72.06899648600006],
              [-95.15021725199995, 72.07587311400005],
              [-95.08861243399991, 72.10032786700003],
              [-95.19391842399995, 72.09992096600007],
              [-95.2012426419999, 72.11090729400007],
              [-95.18765214799993, 72.11595286700003],
              [-95.12950598899994, 72.11395905200004],
              [-95.10993404899995, 72.11847565300008],
              [-95.07921301999994, 72.13019440300008],
              [-94.79043535099993, 72.15993886900003],
              [-94.84068762899994, 72.16644928600005],
              [-95.11302649599992, 72.13898346600007],
              [-95.17674719999991, 72.15497467700004],
              [-95.16136633999992, 72.16071198100008],
              [-95.16852779899995, 72.16771067900004],
              [-95.19473222599993, 72.17914459800005],
              [-95.21182206899994, 72.19672272300005],
              [-95.21385657499991, 72.20477936400005],
              [-95.21149654899995, 72.21702708500004],
              [-95.20555579299992, 72.23021067900004],
              [-95.19888261599993, 72.24013906500005],
              [-95.19326738199993, 72.25116608300004],
              [-95.19102942599994, 72.26797109600005],
              [-95.18781490799995, 72.27496979400007],
              [-95.17369544199994, 72.28107330900008],
              [-95.17052161399994, 72.28872304900005],
              [-95.17149817599994, 72.29596588700008],
              [-95.17674719999991, 72.30923086100006],
              [-95.17430579299992, 72.32318756700005],
              [-95.16462154899995, 72.34393952000005],
              [-95.16368567599994, 72.35419342700004],
              [-95.17080644399994, 72.36920807500007],
              [-95.18309485599991, 72.37783437700006],
              [-95.19758053299995, 72.38475169500003],
              [-95.21149654899995, 72.39516836100006],
              [-95.22911536399994, 72.41811758000006],
              [-95.23570716099994, 72.43089427300004],
              [-95.23534094999991, 72.43952057500007],
              [-95.21857662699995, 72.44415924700007],
              [-95.14317786399994, 72.43618398600006],
              [-95.15689042899993, 72.44281647300005],
              [-95.19847571499992, 72.45661041900007],
              [-95.16624915299991, 72.45612213700008],
              [-95.15062415299991, 72.45799388200004],
              [-95.13573157499991, 72.46344635600008],
              [-95.1695043609999, 72.48167552300004],
              [-95.18468176999994, 72.49249909100007],
              [-95.1980688139999, 72.52293528900003],
              [-95.21524003799993, 72.53241608300004],
              [-95.23664303299995, 72.53725820500006],
              [-95.28587805899991, 72.53807200700004],
              [-95.30020097599993, 72.53998444200005],
              [-95.31387285099993, 72.54535553600005],
              [-95.31969153599994, 72.55194733300004],
              [-95.32754472599993, 72.56972890800006],
              [-95.33128821499992, 72.57330963700008],
              [-95.3352758449999, 72.57562897300005],
              [-95.34154212099992, 72.58112213700008],
              [-95.3469945949999, 72.58787669500003],
              [-95.34862219999991, 72.59381745000007],
              [-95.34398352799991, 72.59931061400005],
              [-95.33503170499995, 72.60276927300004],
              [-95.31387285099993, 72.60748932500007],
              [-95.33385169199994, 72.61733633000006],
              [-95.36318925699993, 72.63971588700008],
              [-95.38280188699991, 72.64842357000003],
              [-95.43651282499991, 72.65704987200007],
              [-95.44737708199995, 72.66364166900007],
              [-95.44908606699994, 72.67088450700004],
              [-95.44831295499995, 72.67780182500007],
              [-95.45173092399995, 72.68317291900007],
              [-95.54674231699994, 72.68964264500005],
              [-95.59268144399994, 72.69944896000004],
              [-95.58824622299994, 72.72410716400003],
              [-95.59487870999993, 72.72467682500007],
              [-95.60936438699991, 72.73037344000005],
              [-95.59040279899995, 72.74339427300004],
              [-95.56493079299992, 72.74457428600005],
              [-95.51309160099993, 72.73777903900003],
              [-95.53014075399994, 72.74384186400005],
              [-95.57457434799994, 72.77130768400008],
              [-95.55724036399994, 72.78229401200008],
              [-95.56358801999994, 72.78628164300005],
              [-95.6218969389999, 72.78644440300008],
              [-95.64785722599993, 72.79096100500004],
              [-95.66893469999991, 72.80215078300006],
              [-95.67760169199994, 72.82318756700005],
              [-95.67381751199991, 72.85211823100008],
              [-95.66299394399994, 72.88491445500006],
              [-95.64586341099994, 72.91339752800008],
              [-95.62295488199993, 72.92963288000004],
              [-95.63829505099994, 72.93675364800004],
              [-95.65135657499991, 72.94635651200008],
              [-95.66051184799994, 72.95856354400007],
              [-95.66397050699993, 72.97394440300008],
              [-95.67487545499995, 72.98281484600005],
              [-95.69766191299993, 72.98908112200007],
              [-95.71739661399994, 72.99713776200008],
              [-95.71922766799992, 73.01154205900008],
              [-95.70592200399994, 73.01752350500004],
              [-95.68545488199993, 73.01825592700004],
              [-95.66470292899993, 73.02260976800005],
              [-95.65029863199993, 73.03949616100005],
              [-95.64875240799995, 73.05744049700007],
              [-95.65782630099994, 73.06712474200003],
              [-95.6734106109999, 73.07489655200004],
              [-95.69127356699994, 73.08722565300008],
              [-95.65160071499992, 73.11859772300005],
              [-95.63467363199993, 73.12641022300005],
              [-95.60094153599994, 73.13068268400008],
              [-95.53189042899993, 73.12636953300006],
              [-95.5132543609999, 73.13373444200005],
              [-95.52261308499993, 73.13715241100005],
              [-95.52977454299992, 73.14354075700004],
              [-95.53701738199993, 73.15180084800005],
              [-95.54605058499993, 73.15639883000006],
              [-95.57091223899994, 73.15839264500005],
              [-95.58202063699991, 73.16233958500004],
              [-95.58047441299993, 73.18378327000005],
              [-95.58885657499991, 73.21039459800005],
              [-95.58853105399993, 73.23021067900004],
              [-95.56090247299994, 73.23126862200007],
              [-95.56090247299994, 73.23802317900004],
              [-95.57730058499993, 73.23940664300005],
              [-95.58975175699993, 73.24673086100006],
              [-95.59459387899994, 73.25820547100005],
              [-95.58824622299994, 73.27220286700003],
              [-95.5972387359999, 73.27993398600006],
              [-95.59569251199991, 73.28807200700004],
              [-95.59121660099993, 73.29588450700004],
              [-95.59166419199994, 73.30263906500005],
              [-95.60741126199991, 73.31244538000004],
              [-95.6414281889999, 73.32265859600005],
              [-95.65029863199993, 73.33368561400005],
              [-95.64049231699994, 73.33380768400008],
              [-95.63133704299992, 73.33616771000004],
              [-95.62291419199994, 73.34072500200006],
              [-95.61554928299995, 73.34731679900005],
              [-95.62197831899994, 73.35907623900005],
              [-95.61851966099994, 73.36855703300006],
              [-95.60191809799994, 73.38890208500004],
              [-95.6265356109999, 73.39301178600005],
              [-95.64427649599992, 73.40546295800004],
              [-95.6738988919999, 73.43984609600005],
              [-95.68517005099994, 73.46320221600007],
              [-95.67479407499991, 73.48208242400005],
              [-95.65274003799993, 73.49616120000007],
              [-95.62922115799995, 73.50495026200008],
              [-95.64146887899994, 73.50991445500006],
              [-95.6477758449999, 73.51166413000004],
              [-95.65648352799991, 73.51239655200004],
              [-95.63585364499994, 73.52814362200007],
              [-95.65143795499995, 73.54071686400005],
              [-95.70494544199994, 73.55955638200004],
              [-95.67349199099993, 73.55951569200005],
              [-95.65831458199995, 73.56159088700008],
              [-95.64346269399994, 73.56704336100006],
              [-95.65217037699995, 73.57123444200005],
              [-95.65916907499991, 73.57636139500005],
              [-95.67015540299991, 73.58685944200005],
              [-95.63292395699995, 73.59454987200007],
              [-95.61294511599993, 73.59638092700004],
              [-95.59850012899994, 73.59064362200007],
              [-95.58584550699993, 73.58124420800004],
              [-95.5698949859999, 73.57542552300004],
              [-95.55370032499991, 73.57477448100008],
              [-95.54043535099993, 73.58071523600006],
              [-95.55553137899994, 73.59369538000004],
              [-95.59943600199995, 73.61497630400004],
              [-95.64232337099992, 73.63031647300005],
              [-95.7254125639999, 73.64150625200006],
              [-95.68455969999991, 73.66791413000004],
              [-95.68968665299991, 73.67617422100005],
              [-95.71922766799992, 73.69057851800005],
              [-95.70295162699995, 73.69432200700004],
              [-95.67031816299993, 73.69773997600004],
              [-95.65648352799991, 73.70416901200008],
              [-95.66429602799991, 73.70661041900007],
              [-95.68443762899994, 73.71723053600005],
              [-95.66234290299991, 73.73094310100004],
              [-95.63849850199995, 73.73517487200007],
              [-95.58202063699991, 73.73773834800005],
              [-95.44640051999994, 73.77411530200004],
              [-95.43199622299994, 73.77619049700007],
              [-95.41173255099994, 73.77643463700008],
              [-95.39199785099993, 73.77423737200007],
              [-95.37938391799992, 73.76902903900003],
              [-95.37214107999995, 73.76162344000005],
              [-95.36384029899995, 73.75495026200008],
              [-95.35391191299993, 73.75185781500005],
              [-95.30821692599994, 73.76764557500007],
              [-95.27721106699994, 73.76813385600008],
              [-95.24592037699995, 73.75971100500004],
              [-95.08812415299991, 73.69082265800006],
              [-95.02135169199994, 73.67059967700004],
              [-94.80370032499991, 73.64891185100004],
              [-94.62242591099994, 73.65574778900003],
              [-94.68480383999992, 73.68500397300005],
              [-94.84019934799994, 73.69159577000005],
              [-94.91047115799995, 73.71039459800005],
              [-94.92625891799992, 73.71869538000004],
              [-94.98680579299992, 73.74176666900007],
              [-95.00690670499995, 73.75535716400003],
              [-95.01768958199995, 73.76064687700006],
              [-95.0742895169999, 73.77826569200005],
              [-95.1004125639999, 73.79279205900008],
              [-95.11587480399993, 73.81403229400007],
              [-94.95763098899994, 73.83392975500004],
              [-94.95763098899994, 73.84137604400007],
              [-94.9800512359999, 73.84503815300008],
              [-95.02342688699991, 73.85838450700004],
              [-95.04759680899991, 73.86123281500005],
              [-95.07896887899994, 73.85708242400005],
              [-95.10903886599993, 73.84760163000004],
              [-95.11554928299995, 73.84275950700004],
              [-95.12393144399994, 73.83071523600006],
              [-95.12950598899994, 73.82709381700005],
              [-95.15538489499994, 73.82729726800005],
              [-95.20091712099992, 73.84931061400005],
              [-95.24705969999991, 73.85858795800004],
              [-95.27375240799995, 73.86762116100005],
              [-95.29918372299994, 73.87954336100006],
              [-95.31761633999992, 73.89199453300006],
              [-95.33092200399994, 73.91746653900003],
              [-95.32750403599994, 73.94672272300005],
              [-95.31309973899994, 73.97370026200008],
              [-95.29336503799993, 73.99217357000003],
              [-95.24864661399994, 74.00991445500006],
              [-95.04161536399994, 74.02676015800006],
              [-94.94668535099993, 74.04767487200007],
              [-94.85936438699991, 74.05683014500005],
              [-94.81655839799993, 74.06683991100005],
              [-94.73884029899995, 74.09772370000007],
              [-94.72057044199994, 74.10138580900008],
              [-94.65290279899995, 74.09398021000004],
              [-94.46231035099993, 74.09756094000005],
              [-94.43687903599994, 74.10138580900008],
              [-94.42544511599993, 74.10712311400005],
              [-94.40819251199991, 74.12254466400003],
              [-94.39586341099994, 74.12872955900008],
              [-94.37393144399994, 74.13226959800005],
              [-93.91901607999995, 74.14008209800005],
              [-93.88304602799991, 74.12913646000004],
              [-93.82652747299994, 74.08795807500007],
              [-93.79320227799991, 74.07802969000005],
              [-93.75723222599993, 74.07713450700004],
              [-93.72492428299995, 74.08779531500005],
              [-93.75011145699995, 74.09454987200007],
              [-93.75357011599993, 74.10700104400007],
              [-93.75300045499995, 74.12189362200007],
              [-93.76593990799995, 74.13556549700007],
              [-93.72984778599994, 74.16083405200004],
              [-93.6675512359999, 74.17283763200004],
              [-93.46129309799994, 74.17796458500004],
              [-93.27257239499994, 74.17796458500004],
              [-93.0176488919999, 74.14154694200005],
              [-92.79995683499993, 74.13182200700004],
              [-92.76976477799991, 74.12372467700004],
              [-92.75108801999994, 74.10830312700006],
              [-92.76500403599994, 74.09320709800005],
              [-92.74705969999991, 74.08510976800005],
              [-92.7227270169999, 74.08340078300006],
              [-92.71751868399991, 74.08779531500005],
              [-92.66661536399994, 74.10150788000004],
              [-92.64281165299991, 74.10297272300005],
              [-92.51707923099991, 74.07005442900004],
              [-92.43016516799992, 74.06240469000005],
              [-92.37295488199993, 74.04791901200008],
              [-92.31895911399994, 74.02440013200004],
              [-92.27131100199995, 73.99217357000003],
              [-92.28457597599993, 73.97809479400007],
              [-92.33397376199991, 73.95001862200007],
              [-92.32652747299994, 73.95001862200007],
              [-92.33397376199991, 73.94318268400008],
              [-92.1309301419999, 73.95083242400005],
              [-92.11424719999991, 73.95746491100005],
              [-92.12169348899994, 73.95746491100005],
              [-92.11742102799991, 73.96482982000003],
              [-92.11375891799992, 73.98432038000004],
              [-92.10741126199991, 73.99217357000003],
              [-92.09764563699991, 73.99445221600007],
              [-92.05899003799993, 73.99217357000003],
              [-92.04454505099994, 73.99445221600007],
              [-92.01805579299992, 74.00202057500007],
              [-91.8145238919999, 74.02875397300005],
              [-91.77578691299993, 74.01654694200005],
              [-91.57237708199995, 74.03314850500004],
              [-91.37047278599994, 74.01528554900005],
              [-90.99388587099992, 74.00592682500007],
              [-90.63585364499994, 73.95246002800008],
              [-90.3496801419999, 73.91583893400008],
              [-90.33910071499992, 73.92641836100006],
              [-90.33263098899994, 73.93024323100008],
              [-90.29100501199991, 73.92328522300005],
            ],
          ],
          [
            [
              [-97.73680579299992, 74.47138092700004],
              [-97.76927649599992, 74.47573476800005],
              [-97.78648841099994, 74.48200104400007],
              [-97.79478919199994, 74.49188873900005],
              [-97.75723222599993, 74.51976146000004],
              [-97.63467363199993, 74.54661692900004],
              [-97.62002519399994, 74.55707428600005],
              [-97.61807206899994, 74.57404205900008],
              [-97.54198157499991, 74.58958567900004],
              [-97.51366126199991, 74.60175202000005],
              [-97.53408769399994, 74.60175202000005],
              [-97.50304114499994, 74.62303294500003],
              [-97.45836341099994, 74.63056061400005],
              [-97.37022864499994, 74.62905508000006],
              [-97.27562415299991, 74.60488515800006],
              [-97.26036536399994, 74.59796784100007],
              [-97.26943925699993, 74.58144765800006],
              [-97.29100501199991, 74.56403229400007],
              [-97.37706458199995, 74.51235586100006],
              [-97.3960668609999, 74.50836823100008],
              [-97.45213782499991, 74.51235586100006],
              [-97.48631751199991, 74.50617096600007],
              [-97.63621985599991, 74.45994700700004],
              [-97.67870032499991, 74.45709870000007],
              [-97.69375566299993, 74.45962148600006],
              [-97.7234594389999, 74.46922435100004],
              [-97.73680579299992, 74.47138092700004],
            ],
          ],
          [
            [
              [-95.36229407499991, 74.59080638200004],
              [-95.26675370999993, 74.54360586100006],
              [-95.25560462099992, 74.51878489800004],
              [-95.31387285099993, 74.49803294500003],
              [-95.34959876199991, 74.49591705900008],
              [-95.7176000639999, 74.53253815300008],
              [-95.7766820949999, 74.55316803600005],
              [-95.8418676419999, 74.56488678600005],
              [-95.87002519399994, 74.58124420800004],
              [-95.81582597599993, 74.59625885600008],
              [-95.79556230399993, 74.59870026200008],
              [-95.75462805899991, 74.58881256700005],
              [-95.73281816299993, 74.58746979400007],
              [-95.75210527299993, 74.61448802300004],
              [-95.7122289699999, 74.63202545800004],
              [-95.65664628799993, 74.64109935100004],
              [-95.56322180899991, 74.64288971600007],
              [-95.49258378799993, 74.63336823100008],
              [-95.42357337099992, 74.61554596600007],
              [-95.36229407499991, 74.59080638200004],
            ],
          ],
          [
            [
              [-103.63841712099992, 75.19953034100007],
              [-103.59947669199994, 75.18121979400007],
              [-103.58580481699994, 75.17715078300006],
              [-103.60411536399994, 75.15546295800004],
              [-103.64224199099993, 75.13572825700004],
              [-103.76268469999991, 75.09064362200007],
              [-103.8672582669999, 75.06443919500003],
              [-104.1636449859999, 75.03725820500006],
              [-104.22948157499991, 75.01886627800008],
              [-104.25719153599994, 75.01850006700005],
              [-104.33934485599991, 75.03245677300004],
              [-104.46934973899994, 75.03510163000004],
              [-104.52122962099992, 75.04466380400004],
              [-104.59585527299993, 75.04946523600006],
              [-104.70555579299992, 75.06903717700004],
              [-104.78856360599991, 75.09808991100005],
              [-104.90648352799991, 75.12409088700008],
              [-104.92955481699994, 75.14109935100004],
              [-104.90929114499994, 75.15839264500005],
              [-104.87002519399994, 75.17177969000005],
              [-104.81436113199993, 75.18231842700004],
              [-104.79991614499994, 75.19501373900005],
              [-104.7781469389999, 75.22553131700005],
              [-104.77139238199993, 75.22894928600005],
              [-104.75377356699994, 75.23285553600005],
              [-104.75023352799991, 75.23550039300005],
              [-104.74982662699995, 75.24494049700007],
              [-104.74803626199991, 75.24909088700008],
              [-104.74400794199994, 75.25218333500004],
              [-104.73062089799993, 75.25633372600004],
              [-104.70213782499991, 75.26154205900008],
              [-104.6887914699999, 75.26650625200006],
              [-104.7085668609999, 75.26581452000005],
              [-104.73106848899994, 75.26845937700006],
              [-104.75291907499991, 75.27338288000004],
              [-104.77065995999993, 75.27952708500004],
              [-104.77065995999993, 75.28701406500005],
              [-104.75108801999994, 75.28937409100007],
              [-104.72838294199994, 75.29580312700006],
              [-104.7149145169999, 75.30459219000005],
              [-104.72288977799991, 75.31427643400008],
              [-104.70225989499994, 75.33315664300005],
              [-104.67686926999994, 75.34601471600007],
              [-104.48180091099994, 75.41494375200006],
              [-104.40322831899994, 75.43260325700004],
              [-104.1309301419999, 75.43561432500007],
              [-104.07241777299993, 75.41669342700004],
              [-103.9688207669999, 75.40985748900005],
              [-103.94896399599992, 75.40314362200007],
              [-103.89366614499994, 75.37567780200004],
              [-103.82054602799991, 75.36668528900003],
              [-103.80492102799991, 75.35521067900004],
              [-103.81143144399994, 75.33698151200008],
              [-103.74522864499994, 75.28790924700007],
              [-103.74693762899994, 75.23924388200004],
              [-103.72158769399994, 75.22882721600007],
              [-103.66710364499994, 75.21800364800004],
              [-103.66665605399993, 75.21580638200004],
              [-103.66759192599994, 75.20726146000004],
              [-103.66710364499994, 75.20502350500004],
              [-103.66104081899994, 75.20327383000006],
              [-103.63841712099992, 75.19953034100007],
            ],
          ],
          [
            [
              [-93.43691972599993, 74.94432200700004],
              [-93.4187719389999, 74.91836172100005],
              [-93.4121801419999, 74.90436432500007],
              [-93.4090063139999, 74.88910553600005],
              [-93.41136633999992, 74.87445709800005],
              [-93.42015540299991, 74.85004303600005],
              [-93.41649329299992, 74.84072500200006],
              [-93.44041907499991, 74.78864166900007],
              [-93.44310462099992, 74.76927317900004],
              [-93.45889238199993, 74.74998607000003],
              [-93.4954320949999, 74.74339427300004],
              [-93.56663977799991, 74.74510325700004],
              [-93.50413977799991, 74.74095286700003],
              [-93.4722387359999, 74.73444245000007],
              [-93.45738684799994, 74.71775950700004],
              [-93.46666419199994, 74.70376211100006],
              [-93.48932857999995, 74.68939850500004],
              [-93.53311113199993, 74.67059967700004],
              [-93.60765540299991, 74.65420156500005],
              [-93.90143795499992, 74.64520905200004],
              [-94.19522050699993, 74.63621653900003],
              [-94.23204505099994, 74.64264557500007],
              [-94.26805579299992, 74.65460846600007],
              [-94.28624426999994, 74.65766022300005],
              [-94.4246313139999, 74.64020416900007],
              [-94.45116126199991, 74.62905508000006],
              [-94.7241918609999, 74.63178131700005],
              [-94.77330481699994, 74.65257396000004],
              [-94.79010982999995, 74.67454661700003],
              [-94.82860266799992, 74.68512604400007],
              [-94.87120520699995, 74.68455638200004],
              [-94.92100989499994, 74.66376373900005],
              [-94.94562740799995, 74.66596100500004],
              [-94.99547278599994, 74.67682526200008],
              [-95.04385331899994, 74.67804596600007],
              [-95.06696529899995, 74.68207428600005],
              [-95.08861243399991, 74.69049713700008],
              [-95.07994544199994, 74.70197174700007],
              [-95.06094316299993, 74.71845123900005],
              [-95.05382239499994, 74.73143138200004],
              [-95.30540930899991, 74.80548737200007],
              [-95.32070878799993, 74.80719635600008],
              [-95.33560136599993, 74.80438873900005],
              [-95.34642493399991, 74.79804108300004],
              [-95.35472571499992, 74.79096100500004],
              [-95.36229407499991, 74.78607819200005],
              [-95.38499915299991, 74.77924225500004],
              [-95.41372636599993, 74.77383047100005],
              [-95.44245357999995, 74.77293528900003],
              [-95.46471106699994, 74.77985260600008],
              [-95.38280188699991, 74.79975006700005],
              [-95.38280188699991, 74.80719635600008],
              [-95.43333899599992, 74.80801015800006],
              [-95.46043860599991, 74.80426666900007],
              [-95.47838294199994, 74.79352448100008],
              [-95.48021399599992, 74.78131745000007],
              [-95.47321529899995, 74.76813385600008],
              [-95.45173092399995, 74.74510325700004],
              [-95.51134192599994, 74.74359772300005],
              [-95.54015051999994, 74.75120677300004],
              [-95.54662024599992, 74.77301666900007],
              [-95.49205481699994, 74.79975006700005],
              [-95.50243079299992, 74.80988190300008],
              [-95.51488196499992, 74.81411367400005],
              [-95.6323949859999, 74.81268952000005],
              [-95.67642167899993, 74.81891510600008],
              [-95.71178137899994, 74.84072500200006],
              [-95.70494544199994, 74.84072500200006],
              [-95.71890214799993, 74.84658437700006],
              [-95.73412024599992, 74.84373607000003],
              [-95.74327551999994, 74.83612702000005],
              [-95.7390844389999, 74.82762278900003],
              [-95.7390844389999, 74.82078685100004],
              [-95.89757239499994, 74.82587311400005],
              [-95.92467200399994, 74.83441803600005],
              [-95.90819251199991, 74.83392975500004],
              [-95.89146887899994, 74.83588288000004],
              [-95.87759355399993, 74.84223053600005],
              [-95.87002519399994, 74.85496653900003],
              [-95.91633053299995, 74.85516998900005],
              [-95.96231035099993, 74.86322663000004],
              [-96.00479081899994, 74.87742747600004],
              [-96.04067949099993, 74.89594147300005],
              [-96.0332738919999, 74.89594147300005],
              [-96.09430904899995, 74.90591054900005],
              [-96.12059485599991, 74.91771067900004],
              [-96.13687089799993, 74.93691640800006],
              [-96.11314856699994, 74.94525788000004],
              [-96.0332738919999, 74.95058828300006],
              [-96.03897050699993, 74.96417877800008],
              [-96.04552161399994, 74.97077057500007],
              [-96.05455481699994, 74.97272370000007],
              [-96.06802324099993, 74.97223541900007],
              [-96.07774817599994, 74.96995677300004],
              [-96.09801184799994, 74.96084219000005],
              [-96.10899817599994, 74.95799388200004],
              [-96.14313717399995, 74.95799388200004],
              [-96.12816321499992, 74.97528717700004],
              [-96.10496985599991, 74.99176666900007],
              [-96.07860266799992, 75.00495026200008],
              [-96.05435136599993, 75.01264069200005],
              [-96.06460527299993, 75.02358633000006],
              [-96.09117591099994, 75.02460358300004],
              [-96.15054277299993, 75.01886627800008],
              [-96.14525305899991, 75.00812409100007],
              [-96.15518144399994, 74.99648672100005],
              [-96.15054277299993, 74.98529694200005],
              [-96.19615637899994, 74.96377187700006],
              [-96.19835364499994, 74.95799388200004],
              [-96.20449785099993, 74.95209381700005],
              [-96.20421301999994, 74.94599030200004],
              [-96.20278886599993, 74.93903229400007],
              [-96.20579993399991, 74.93065013200004],
              [-96.21727454299992, 74.92007070500006],
              [-96.2312719389999, 74.91425202000005],
              [-96.26667232999995, 74.90961334800005],
              [-96.34850012899994, 74.90997955900008],
              [-96.38756262899994, 74.91860586100006],
              [-96.40379798099991, 74.93691640800006],
              [-96.38988196499992, 74.94611237200007],
              [-96.38414466099994, 74.95917389500005],
              [-96.38670813699991, 74.97321198100008],
              [-96.39761308499993, 74.98529694200005],
              [-96.35545813699991, 74.97744375200006],
              [-96.33169511599993, 74.97825755400004],
              [-96.32127844999991, 74.98843008000006],
              [-96.32945716099994, 75.00413646000004],
              [-96.34943600199995, 75.00869375200006],
              [-96.51984615799995, 75.00580475500004],
              [-96.54295813699991, 75.00055573100008],
              [-96.56590735599991, 74.99066803600005],
              [-96.58983313699991, 74.98480866100005],
              [-96.61611894399994, 74.99152252800008],
              [-96.60582434799994, 75.00128815300008],
              [-96.59854081899994, 75.01276276200008],
              [-96.58877519399994, 75.03245677300004],
              [-96.5996801419999, 75.05027903900003],
              [-96.60456295499995, 75.06484609600005],
              [-96.59805253799993, 75.07550690300008],
              [-96.57510331899994, 75.08148834800005],
              [-96.57921301999994, 75.09149811400005],
              [-96.58193925699993, 75.09516022300005],
              [-96.52977454299992, 75.12327708500004],
              [-96.50885982999995, 75.13947174700007],
              [-96.47695878799993, 75.17011139500005],
              [-96.47581946499992, 75.17715078300006],
              [-96.4722387359999, 75.18024323100008],
              [-96.47142493399991, 75.18732330900008],
              [-96.46934973899994, 75.19440338700008],
              [-96.46214758999992, 75.19757721600007],
              [-96.43797766799992, 75.19586823100008],
              [-96.41685950399994, 75.19074127800008],
              [-96.3880102199999, 75.17999909100007],
              [-96.37730872299994, 75.18244049700007],
              [-96.36969967399995, 75.19757721600007],
              [-96.37889563699991, 75.19940827000005],
              [-96.38780676999994, 75.20237864800004],
              [-96.39622962099992, 75.20636627800008],
              [-96.40379798099991, 75.21124909100007],
              [-96.35411536399994, 75.22467682500007],
              [-96.13219153599994, 75.24534739800004],
              [-96.07843990799995, 75.23676178600005],
              [-95.98607337099992, 75.25218333500004],
              [-96.00767981699994, 75.25946686400005],
              [-96.02855383999992, 75.25869375200006],
              [-96.07144120999993, 75.25218333500004],
              [-96.08828691299993, 75.25478750200006],
              [-96.09398352799991, 75.26097239800004],
              [-96.08958899599992, 75.26850006700005],
              [-96.07640540299991, 75.27496979400007],
              [-96.03335527299993, 75.28188711100006],
              [-95.94493567599994, 75.28367747600004],
              [-95.90355383999992, 75.29315827000005],
              [-95.93370520699995, 75.30288320500006],
              [-96.17105058499993, 75.28701406500005],
              [-96.15737870999993, 75.29999420800004],
              [-96.16148841099994, 75.30158112200007],
              [-96.17105058499993, 75.30744049700007],
              [-96.13280188699991, 75.30866120000007],
              [-96.02700761599993, 75.32786692900004],
              [-95.96178137899994, 75.37616608300004],
              [-95.92052161399994, 75.38963450700004],
              [-95.88988196499992, 75.36888255400004],
              [-95.90221106699994, 75.36664459800005],
              [-95.93765214799993, 75.35521067900004],
              [-95.93765214799993, 75.34845612200007],
              [-95.80296790299991, 75.37010325700004],
              [-95.78001868399991, 75.38251373900005],
              [-96.03888912699995, 75.40477122600004],
              [-96.06110592399995, 75.40257396000004],
              [-96.07506262899994, 75.40379466400003],
              [-96.08165442599994, 75.40302155200004],
              [-96.08202063699991, 75.40078359600005],
              [-96.0813695949999, 75.39158763200004],
              [-96.08165442599994, 75.38934967700004],
              [-96.12995357999995, 75.37860748900005],
              [-96.1551000639999, 75.37775299700007],
              [-96.17788652299993, 75.38251373900005],
              [-96.15550696499992, 75.40802643400008],
              [-96.11424719999991, 75.41950104400007],
              [-96.0332738919999, 75.42413971600007],
              [-96.0176488919999, 75.41787344000005],
              [-96.00987708199995, 75.41779205900008],
              [-96.00658118399991, 75.42723216400003],
              [-96.00039628799993, 75.43524811400005],
              [-95.98607337099992, 75.43821849200003],
              [-95.90542558499993, 75.43431224200003],
              [-95.88060462099992, 75.42829010600008],
              [-95.8626195949999, 75.41669342700004],
              [-95.86461341099994, 75.40473053600005],
              [-95.84203040299991, 75.40037669500003],
              [-95.77920488199993, 75.39642975500004],
              [-95.76768958199995, 75.39765045800004],
              [-95.74592037699995, 75.40302155200004],
              [-95.70494544199994, 75.40302155200004],
              [-95.67951412699995, 75.41351959800005],
              [-95.68789628799993, 75.42218659100007],
              [-95.71361243399991, 75.42816803600005],
              [-95.77090410099993, 75.43146393400008],
              [-95.80016028599994, 75.43622467700004],
              [-95.82469641799992, 75.44676341400003],
              [-95.84211178299995, 75.46507396000004],
              [-95.79149329299992, 75.50104401200008],
              [-95.59056555899991, 75.54889557500007],
              [-95.52114824099993, 75.55459219000005],
              [-95.4492895169999, 75.57257721600007],
              [-95.43138587099992, 75.57221100500004],
              [-95.41071529899995, 75.56818268400008],
              [-95.38670813699991, 75.55634186400005],
              [-95.37344316299993, 75.55499909100007],
              [-95.35887610599991, 75.56439850500004],
              [-95.34601803299995, 75.58144765800006],
              [-95.33995520699995, 75.58734772300005],
              [-95.32754472599993, 75.59479401200008],
              [-95.31175696499992, 75.60130442900004],
              [-95.29759680899991, 75.60394928600005],
              [-95.2847387359999, 75.60374583500004],
              [-95.2324926419999, 75.59389883000006],
              [-95.19212805899991, 75.59088776200008],
              [-95.1511938139999, 75.59316640800006],
              [-95.10903886599993, 75.60162995000007],
              [-95.09593665299991, 75.60732656500005],
              [-95.07445227799991, 75.62026601800005],
              [-95.06065833199995, 75.62274811400005],
              [-94.98180091099994, 75.62274811400005],
              [-94.96788489499994, 75.62482330900008],
              [-94.92259680899991, 75.64130280200004],
              [-94.89952551999994, 75.64472077000005],
              [-94.64671790299994, 75.62447744350004],
              [-94.39391028599994, 75.60423411700003],
              [-94.05150305899991, 75.47418854400007],
              [-94.01915442599994, 75.45148346600007],
              [-93.98741614499994, 75.43927643400008],
              [-93.88878333199995, 75.41669342700004],
              [-93.78612219999991, 75.37441640800006],
              [-93.69017493399991, 75.36497630400004],
              [-93.67650305899991, 75.36204661700003],
              [-93.66869055899991, 75.35480377800008],
              [-93.65660559799994, 75.33466217700004],
              [-93.6492406889999, 75.32786692900004],
              [-93.6797582669999, 75.31781647300005],
              [-93.72215735599991, 75.31342194200005],
              [-93.80003821499992, 75.31427643400008],
              [-93.80003821499992, 75.30744049700007],
              [-93.66783606699994, 75.30267975500004],
              [-93.49937903599994, 75.26801178600005],
              [-93.49722245999993, 75.25934479400007],
              [-93.50894120999993, 75.24225495000007],
              [-93.5227758449999, 75.23086172100005],
              [-93.58031165299991, 75.20502350500004],
              [-93.55850175699993, 75.18903229400007],
              [-93.48473059799994, 75.15322500200006],
              [-93.46226966099994, 75.13507721600007],
              [-93.46703040299991, 75.11985911700003],
              [-93.48741614499994, 75.10683828300006],
              [-93.51203365799995, 75.09516022300005],
              [-93.50584876199991, 75.09031810100004],
              [-93.49156653599994, 75.07404205900008],
              [-93.5113012359999, 75.07225169500003],
              [-93.54991614499994, 75.06268952000005],
              [-93.60777747299994, 75.05532461100006],
              [-93.62637285099993, 75.04889557500007],
              [-93.64240475199995, 75.03994375200006],
              [-93.62214107999995, 75.03436920800004],
              [-93.55288652299993, 75.04677969000005],
              [-93.53453528599994, 75.04466380400004],
              [-93.52204342399995, 75.03880442900004],
              [-93.49840247299994, 75.01886627800008],
              [-93.44884192599994, 74.98786041900007],
              [-93.4309789699999, 74.96747467700004],
              [-93.43691972599993, 74.94432200700004],
            ],
          ],
          [
            [
              [-96.57510331899994, 75.43773021000004],
              [-96.67568925699993, 75.43650950700004],
              [-96.70547441299993, 75.42413971600007],
              [-96.68773352799991, 75.41282786700003],
              [-96.66624915299991, 75.40863678600005],
              [-96.64370683499993, 75.40692780200004],
              [-96.62291419199994, 75.40302155200004],
              [-96.65672766799992, 75.38857656500005],
              [-96.78115800699993, 75.37567780200004],
              [-96.8438207669999, 75.35858795800004],
              [-96.87271074099993, 75.35736725500004],
              [-96.86929277299993, 75.37567780200004],
              [-96.8977758449999, 75.38174062700006],
              [-96.95958411399994, 75.38471100500004],
              [-96.98668372299994, 75.39679596600007],
              [-96.97687740799995, 75.39667389500005],
              [-96.9663793609999, 75.39801666900007],
              [-96.95641028599994, 75.40110911700003],
              [-96.94847571499992, 75.40643952000005],
              [-96.94737708199995, 75.41437409100007],
              [-96.95767167899993, 75.41925690300008],
              [-96.97923743399991, 75.42413971600007],
              [-97.00511633999992, 75.44635651200008],
              [-97.01842200399994, 75.45530833500004],
              [-97.03441321499992, 75.45831940300008],
              [-97.03441321499992, 75.46507396000004],
              [-97.01402747299994, 75.47174713700008],
              [-97.02017167899993, 75.48126862200007],
              [-97.05492102799991, 75.49921295800004],
              [-96.70547441299993, 75.56818268400008],
              [-96.66991126199991, 75.55451080900008],
              [-96.53075110599991, 75.58120351800005],
              [-96.43618730399993, 75.58779531500005],
              [-96.41685950399994, 75.59479401200008],
              [-96.41543535099993, 75.60358307500007],
              [-96.42430579299992, 75.62482330900008],
              [-96.42430579299992, 75.63580963700008],
              [-96.37511145699995, 75.65997955900008],
              [-96.28693600199995, 75.65033600500004],
              [-96.13121497299994, 75.60952383000006],
              [-96.07213294199994, 75.61420319200005],
              [-96.04503333199995, 75.61220937700006],
              [-96.02700761599993, 75.60162995000007],
              [-96.02700761599993, 75.60907623900005],
              [-95.99791419199994, 75.59658437700006],
              [-95.93614661399994, 75.58038971600007],
              [-95.91038977799991, 75.56069570500006],
              [-95.93651282499991, 75.54677969000005],
              [-95.94904537699995, 75.54197825700004],
              [-96.03014075399994, 75.53314850500004],
              [-96.04751542899993, 75.52716705900008],
              [-96.0332738919999, 75.51972077000005],
              [-96.04857337099992, 75.50934479400007],
              [-96.06859290299991, 75.50263092700004],
              [-96.10875403599994, 75.49420807500007],
              [-96.12413489499994, 75.48822663000004],
              [-96.14976966099994, 75.47199127800008],
              [-96.16421464799993, 75.46507396000004],
              [-96.20571855399993, 75.45799388200004],
              [-96.23574785099993, 75.46605052300004],
              [-96.26260331899994, 75.48102448100008],
              [-96.29466712099992, 75.49420807500007],
              [-96.3687231109999, 75.50897858300004],
              [-96.40855872299994, 75.52228424700007],
              [-96.42430579299992, 75.54022858300004],
              [-96.4153539699999, 75.55145905200004],
              [-96.39785722599993, 75.55634186400005],
              [-96.37901770699995, 75.55927155200004],
              [-96.36595618399991, 75.56439850500004],
              [-96.36461341099994, 75.57599518400008],
              [-96.38316809799994, 75.58075592700004],
              [-96.42430579299992, 75.58120351800005],
              [-96.41954505099994, 75.57176341400003],
              [-96.41685950399994, 75.56818268400008],
              [-96.48253333199995, 75.55906810100004],
              [-96.51500403599994, 75.55023834800005],
              [-96.54100501199991, 75.53339264500005],
              [-96.5520727199999, 75.51666901200008],
              [-96.54893958199995, 75.50495026200008],
              [-96.52049719999991, 75.47874583500004],
              [-96.51512610599991, 75.47573476800005],
              [-96.50560462099992, 75.46869538000004],
              [-96.50267493399991, 75.46157461100006],
              [-96.53115800699993, 75.45551178600005],
              [-96.56078040299991, 75.44220612200007],
              [-96.57510331899994, 75.43773021000004],
            ],
          ],
          [
            [
              [-120.99795488199993, 75.93060944200005],
              [-120.96483313699991, 75.93720123900005],
              [-120.92088782499991, 75.94114817900004],
              [-120.88292395699995, 75.93642812700006],
              [-120.86827551999994, 75.91693756700005],
              [-120.87340247299994, 75.91046784100007],
              [-120.87498938699991, 75.90184153900003],
              [-120.87315833199995, 75.89240143400008],
              [-120.86827551999994, 75.88279857000003],
              [-120.87555904899995, 75.87392812700006],
              [-120.89769446499992, 75.83759186400005],
              [-120.9024145169999, 75.82510000200006],
              [-120.9141332669999, 75.81045156500005],
              [-120.99111894399994, 75.76300690300008],
              [-121.05870520699995, 75.73944733300004],
              [-121.0921117829999, 75.73411692900004],
              [-121.16820227799991, 75.73371002800008],
              [-121.25682532499991, 75.74583567900004],
              [-121.29344641799992, 75.75995514500005],
              [-121.25243079299992, 75.77728913000004],
              [-121.11681067599994, 75.80247630400004],
              [-121.08531653599994, 75.81220123900005],
              [-121.0725805329999, 75.81403229400007],
              [-121.05345618399991, 75.81452057500007],
              [-121.03612219999991, 75.81704336100006],
              [-121.02261308499993, 75.82347239800004],
              [-121.01939856699994, 75.83226146000004],
              [-121.0327856109999, 75.84186432500007],
              [-121.02232825399994, 75.84788646000004],
              [-120.99795488199993, 75.86981842700004],
              [-121.00869706899994, 75.87832265800006],
              [-121.04637610599991, 75.89647044500003],
              [-121.04369055899991, 75.90827057500007],
              [-121.03001868399991, 75.91828034100007],
              [-120.99795488199993, 75.93060944200005],
            ],
          ],
          [
            [
              [-102.87328040299991, 75.76609935100004],
              [-102.86583411399994, 75.75995514500005],
              [-102.89464270699995, 75.75088125200006],
              [-103.3274633449999, 75.75088125200006],
              [-103.38658606699994, 75.76609935100004],
              [-103.27110755099994, 75.79238515800006],
              [-103.24937903599994, 75.80707428600005],
              [-103.3108617829999, 75.80707428600005],
              [-103.25405839799993, 75.82965729400007],
              [-103.18517005099994, 75.83706289300005],
              [-103.05138098899994, 75.83441803600005],
              [-103.07750403599994, 75.84137604400007],
              [-103.11241614499994, 75.84422435100004],
              [-103.13727779899995, 75.85106028900003],
              [-103.13337154899995, 75.86981842700004],
              [-103.10993404899995, 75.88629791900007],
              [-103.07823645699995, 75.89817942900004],
              [-103.04491126199991, 75.90615469000005],
              [-102.76750647699993, 75.93773021050006],
              [-102.49010169199994, 75.96930573100008],
              [-102.40611731699994, 75.96898021000004],
              [-102.21467037699995, 75.99266185100004],
              [-102.07070878799993, 75.97223541900007],
              [-102.08926347599993, 75.96271393400008],
              [-102.0862524079999, 75.95880768400008],
              [-102.00015214799993, 75.95575592700004],
              [-101.98131262899994, 75.95172760600008],
              [-101.98521887899994, 75.94822825700004],
              [-101.9866430329999, 75.94464752800008],
              [-101.98721269399994, 75.94098541900007],
              [-101.98875891799992, 75.93744538000004],
              [-102.09337317599994, 75.91535065300008],
              [-102.38866126199991, 75.89036692900004],
              [-102.44127356699994, 75.86981842700004],
              [-102.45335852799991, 75.85895416900007],
              [-102.4754125639999, 75.82135651200008],
              [-102.4895727199999, 75.80780670800004],
              [-102.50450598899994, 75.79905833500004],
              [-102.6048070949999, 75.77260976800005],
              [-102.66714433499993, 75.76609935100004],
              [-102.70946204299992, 75.77830638200004],
              [-102.73151607999995, 75.77806224200003],
              [-102.72862708199995, 75.75995514500005],
              [-102.76805579299992, 75.75828685100004],
              [-102.78774980399993, 75.75983307500007],
              [-102.80435136599993, 75.76609935100004],
              [-102.7969457669999, 75.77358633000006],
              [-102.87328040299991, 75.76609935100004],
            ],
          ],
          [
            [
              [-94.48525956899994, 75.97842031500005],
              [-94.45750891799992, 75.96588776200008],
              [-94.45116126199991, 75.95270416900007],
              [-94.45327714799993, 75.93707916900007],
              [-94.45116126199991, 75.91693756700005],
              [-94.42320716099994, 75.88898346600007],
              [-94.42247473899994, 75.88605377800008],
              [-94.42320716099994, 75.87287018400008],
              [-94.41974850199995, 75.87079498900005],
              [-94.39586341099994, 75.86237213700008],
              [-94.31924394399994, 75.81928131700005],
              [-94.30028235599991, 75.80093008000006],
              [-94.29458574099993, 75.77570221600007],
              [-94.31651770699995, 75.76434967700004],
              [-94.6577856109999, 75.74648672100005],
              [-94.74380449099993, 75.76154205900008],
              [-94.79336503799993, 75.78270091400003],
              [-94.82335364499994, 75.81049225500004],
              [-94.83454342399995, 75.84564850500004],
              [-94.82787024599992, 75.88898346600007],
              [-94.85252844999991, 75.89378489800004],
              [-94.87873287699995, 75.90350983300004],
              [-94.90013587099992, 75.91803620000007],
              [-94.91047115799995, 75.93744538000004],
              [-94.8523656889999, 75.95319245000007],
              [-94.66344153599994, 75.96539948100008],
              [-94.53990637899994, 75.98924388200004],
              [-94.53233801999994, 75.99803294500003],
              [-94.5152074859999, 75.99445221600007],
              [-94.48525956899994, 75.97842031500005],
            ],
          ],
          [
            [
              [-102.57164466099994, 75.99266185100004],
              [-102.9449763666666, 75.95810238933338],
              [-103.31830807233325, 75.92354292766673],
              [-103.69163977799991, 75.88898346600007],
              [-103.80150305899991, 75.90326569200005],
              [-103.8889867829999, 75.89862702000005],
              [-103.91417395699995, 75.90326569200005],
              [-103.93150794199994, 75.92719147300005],
              [-103.94115149599992, 75.93227773600006],
              [-103.96519934799994, 75.93781159100007],
              [-103.97622636599993, 75.94428131700005],
              [-103.82103430899991, 75.94798411700003],
              [-103.72545325399994, 75.97833893400008],
              [-103.49791419199994, 75.98236725500004],
              [-103.31891842399995, 76.02285390800006],
              [-103.23265540299991, 76.02065664300005],
              [-103.20677649599992, 76.02366771000004],
              [-103.13951575399994, 76.04730866100005],
              [-103.11302649599992, 76.05036041900007],
              [-103.02965247299994, 76.04730866100005],
              [-102.73674475799993, 76.06860993050006],
              [-102.44383704299992, 76.08991120000007],
              [-102.35191809799994, 76.07526276200008],
              [-102.32799231699994, 76.06541575700004],
              [-102.31851152299993, 76.04413483300004],
              [-102.32681230399993, 76.02277252800008],
              [-102.35594641799992, 76.01312897300005],
              [-102.57164466099994, 75.99266185100004],
            ],
          ],
          [
            [
              [-117.7847387359999, 75.89647044500003],
              [-117.8316137359999, 75.86660390800006],
              [-117.83934485599991, 75.85553620000007],
              [-117.83006751199991, 75.85415273600006],
              [-117.82677161399994, 75.85154857000003],
              [-117.82445227799991, 75.84760163000004],
              [-117.81822669199994, 75.84186432500007],
              [-117.83641516799992, 75.83519114800004],
              [-117.87633216099994, 75.82807038000004],
              [-117.8946020169999, 75.82135651200008],
              [-117.88707434799994, 75.81452057500007],
              [-117.89976966099994, 75.80451080900008],
              [-117.92955481699994, 75.79498932500007],
              [-117.9417211579999, 75.78725820500006],
              [-117.9514867829999, 75.77448151200008],
              [-117.95055091099994, 75.76874420800004],
              [-117.94522050699993, 75.76349518400008],
              [-117.9417211579999, 75.75250885600008],
              [-117.93773352799991, 75.74628327000005],
              [-117.93248450399994, 75.73981354400007],
              [-117.93545488199993, 75.73468659100007],
              [-117.97329667899993, 75.73016998900005],
              [-117.98778235599991, 75.72431061400005],
              [-118.01060950399994, 75.71149323100008],
              [-118.27065995999993, 75.61591217700004],
              [-118.21800696499992, 75.60838450700004],
              [-118.20238196499992, 75.60162995000007],
              [-118.25251217399995, 75.59564850500004],
              [-118.61392167899993, 75.50372955900008],
              [-118.66079667899993, 75.50259023600006],
              [-118.70787512899994, 75.50824616100005],
              [-118.79503333199995, 75.53082916900007],
              [-118.94163977799991, 75.53339264500005],
              [-118.9304906889999, 75.54547760600008],
              [-118.91234290299991, 75.54865143400008],
              [-118.8919164699999, 75.54930247600004],
              [-118.87393144399994, 75.55390045800004],
              [-118.93651282499991, 75.56268952000005],
              [-118.96467037699995, 75.56171295800004],
              [-118.99665279899995, 75.55560944200005],
              [-119.01073157499991, 75.55556875200006],
              [-119.05894934799994, 75.56818268400008],
              [-119.09325110599991, 75.57294342700004],
              [-119.19835364499994, 75.56439850500004],
              [-119.40904700399994, 75.60162995000007],
              [-119.40880286399994, 75.60651276200008],
              [-119.4075414699999, 75.60976797100005],
              [-119.40160071499992, 75.61591217700004],
              [-119.40904700399994, 75.61591217700004],
              [-119.3321020169999, 75.66079336100006],
              [-119.05256100199995, 75.75165436400005],
              [-118.99205481699994, 75.76154205900008],
              [-118.97215735599991, 75.77033112200007],
              [-118.92178300699993, 75.80402252800008],
              [-118.84203040299991, 75.83539459800005],
              [-118.79930579299992, 75.84552643400008],
              [-118.75731360599991, 75.84808991100005],
              [-118.74128170499989, 75.87396881700005],
              [-118.68610592399995, 75.90086497600004],
              [-118.62120520699995, 75.92206452000005],
              [-118.31908118399991, 75.97223541900007],
              [-118.20938066299993, 75.96857330900008],
              [-118.17446855399993, 75.97223541900007],
              [-118.15412350199995, 75.97866445500006],
              [-118.14077714799993, 75.98822663000004],
              [-118.11644446499992, 76.01691315300008],
              [-118.08706620999993, 76.03546784100007],
              [-118.05418860599991, 76.03945547100005],
              [-118.01992753799993, 76.03888580900008],
              [-117.88707434799994, 76.06777578300006],
              [-117.8899633449999, 76.07147858300004],
              [-117.8946020169999, 76.08148834800005],
              [-117.79869544199994, 76.11163971600007],
              [-117.6597387359999, 76.12588125200006],
              [-117.62637285099993, 76.11562734600005],
              [-117.58568274599992, 76.11570872600004],
              [-117.54234778599994, 76.10932038000004],
              [-117.46251380099994, 76.08828359600005],
              [-117.48208574099993, 76.08185455900008],
              [-117.49132239499994, 76.07241445500006],
              [-117.50352942599994, 76.04730866100005],
              [-117.51927649599992, 76.03148021000004],
              [-117.53722083199995, 76.02142975500004],
              [-117.57860266799992, 76.00633372600004],
              [-117.57404537699995, 75.99030182500007],
              [-117.58409583199995, 75.97833893400008],
              [-117.60147050699993, 75.96967194200005],
              [-117.6187231109999, 75.96344635600008],
              [-117.63560950399994, 75.95465729400007],
              [-117.66567949099993, 75.93219635600008],
              [-117.68101966099994, 75.92377350500004],
              [-117.7586156889999, 75.90827057500007],
              [-117.7847387359999, 75.89647044500003],
            ],
          ],
          [
            [
              [-78.89541581899994, 76.12299225500004],
              [-78.87385006399995, 76.11115143400008],
              [-78.8125707669999, 76.10004303600005],
              [-78.79987545499995, 76.08486562700006],
              [-78.80760657499991, 76.07367584800005],
              [-78.82555091099994, 76.06224192900004],
              [-78.86070716099994, 76.04730866100005],
              [-79.14411373599995, 75.98029205900008],
              [-79.16539466099994, 75.97040436400005],
              [-79.17601477799991, 75.95795319200005],
              [-79.16966712099992, 75.93748607000003],
              [-79.14806067599994, 75.92495351800005],
              [-79.01121985599991, 75.88580963700008],
              [-78.95059160099993, 75.87958405200004],
              [-78.87498938699991, 75.85553620000007],
              [-78.89647376199991, 75.84259674700007],
              [-78.9212133449999, 75.84137604400007],
              [-78.97142493399991, 75.84808991100005],
              [-79.05052649599992, 75.84113190300008],
              [-79.07359778599994, 75.84808991100005],
              [-79.05060787699995, 75.86098867400005],
              [-79.02521725199995, 75.86981842700004],
              [-79.04662024599992, 75.87616608300004],
              [-79.11314856699994, 75.86981842700004],
              [-79.27916419199994, 75.87653229400007],
              [-79.32957923099991, 75.87091705900008],
              [-79.42983964799993, 75.84808991100005],
              [-79.41030839799993, 75.83624909100007],
              [-79.38752193899995, 75.83331940300008],
              [-79.36359615799995, 75.83295319200005],
              [-79.34044348899994, 75.82880280200004],
              [-79.42520097599993, 75.79629140800006],
              [-79.43814042899993, 75.79535553600005],
              [-79.45653235599991, 75.80093008000006],
              [-79.45702063699991, 75.80320872600004],
              [-79.45604407499991, 75.81220123900005],
              [-79.45653235599991, 75.81452057500007],
              [-79.46711178299995, 75.81834544500003],
              [-79.47695878799993, 75.82046133000006],
              [-79.59373938699991, 75.82135651200008],
              [-79.58617102799991, 75.82880280200004],
              [-79.57713782499991, 75.83246491100005],
              [-79.56956946499992, 75.83649323100008],
              [-79.56639563699991, 75.84495677300004],
              [-79.57249915299991, 75.85553620000007],
              [-79.58690344999991, 75.86155833500004],
              [-79.61632239499994, 75.86786530200004],
              [-79.65119381399995, 75.87002187700006],
              [-79.68814042899993, 75.86318594000005],
              [-79.72313391799992, 75.86237213700008],
              [-79.7520238919999, 75.88279857000003],
              [-79.71764075399994, 75.88251373900005],
              [-79.63296464799993, 75.89305247600004],
              [-79.60118567599994, 75.90326569200005],
              [-79.58311926999994, 75.91608307500007],
              [-79.58348548099991, 75.92479075700004],
              [-79.59093176999994, 75.93134186400005],
              [-79.59373938699991, 75.93744538000004],
              [-79.58348548099991, 75.94814687700006],
              [-79.56786048099991, 75.95441315300008],
              [-79.50218665299991, 75.96198151200008],
              [-79.42983964799993, 75.99884674700007],
              [-79.40977942599994, 76.00470612200007],
              [-79.32022050699993, 76.01605866100005],
              [-79.28416907499991, 76.02948639500005],
              [-79.26475989499994, 76.03363678600005],
              [-79.26915442599994, 76.04352448100008],
              [-79.27220618399991, 76.04730866100005],
              [-79.25300045499995, 76.05874258000006],
              [-79.18431555899991, 76.06972890800006],
              [-79.14565995999993, 76.08307526200008],
              [-79.12905839799993, 76.09162018400008],
              [-79.11115475199995, 76.10565827000005],
              [-79.06818600199995, 76.12470123900005],
              [-79.01109778599994, 76.12889232000003],
              [-78.9016820949999, 76.12299225500004],
              [-78.89541581899994, 76.12299225500004],
            ],
          ],
          [
            [
              [-81.32795162699995, 76.14972565300008],
              [-81.35993404899995, 76.14883047100005],
              [-81.43614661399994, 76.15473053600005],
              [-81.46507727799991, 76.16400788000004],
              [-81.4539281889999, 76.16913483300004],
              [-81.36839758999992, 76.18964264500005],
              [-81.31086178299995, 76.19635651200008],
              [-81.25332597599993, 76.19537995000007],
              [-81.2044164699999, 76.18447500200006],
              [-81.22777258999992, 76.17153554900005],
              [-81.2630102199999, 76.16083405200004],
              [-81.32795162699995, 76.14972565300008],
            ],
          ],
          [
            [
              [-103.81143144399994, 76.03363678600005],
              [-103.94432532499991, 76.04075755400004],
              [-103.88621985599991, 76.04897695500006],
              [-103.87315833199995, 76.05414459800005],
              [-104.06541907499991, 76.06732819200005],
              [-104.08608964799993, 76.06159088700008],
              [-104.07860266799992, 76.05414459800005],
              [-104.36774654899995, 76.07636139500005],
              [-104.39452063699991, 76.08148834800005],
              [-104.41087805899991, 76.08966705900008],
              [-104.45230058499993, 76.12616608300004],
              [-104.4768774079999, 76.14028554900005],
              [-104.47813880099994, 76.14704010600008],
              [-104.46593176999994, 76.16058991100005],
              [-104.44432532499991, 76.17182038000004],
              [-104.41600501199991, 76.17670319200005],
              [-104.35960852799991, 76.17767975500004],
              [-104.34227454299992, 76.18305084800005],
              [-104.3274633449999, 76.20697663000004],
              [-104.31200110599991, 76.21238841400003],
              [-104.20254472599993, 76.22540924700007],
              [-104.12954667899993, 76.21954987200007],
              [-104.1096899079999, 76.22199127800008],
              [-104.08214270699995, 76.22955963700008],
              [-103.91177324099993, 76.24412669500003],
              [-103.85708574099993, 76.25690338700008],
              [-103.79385331899994, 76.25531647300005],
              [-103.70889238199993, 76.26239655200004],
              [-103.58958899599992, 76.25901927300004],
              [-103.52538001199991, 76.27252838700008],
              [-103.49722245999993, 76.27057526200008],
              [-103.4832250639999, 76.27163320500006],
              [-103.44692949099993, 76.27814362200007],
              [-103.08678137899992, 76.29688141500006],
              [-102.7266332669999, 76.31561920800004],
              [-102.65355383999992, 76.29433828300006],
              [-102.64183508999992, 76.27106354400007],
              [-102.6258031889999, 76.25800202000005],
              [-102.54157467399995, 76.23135000200006],
              [-102.5403539699999, 76.21971263200004],
              [-102.5852758449999, 76.18447500200006],
              [-102.54308020699995, 76.16535065300008],
              [-102.53062903599994, 76.15717194200005],
              [-102.62621008999992, 76.15717194200005],
              [-102.62254798099991, 76.15412018400008],
              [-102.61253821499992, 76.14350006700005],
              [-102.68301347599993, 76.11701080900008],
              [-102.83763587099992, 76.08063385600008],
              [-103.24323482999995, 76.04730866100005],
              [-103.2363988919999, 76.04730866100005],
              [-103.52391516799992, 76.04047272350005],
              [-103.81143144399994, 76.03363678600005],
            ],
          ],
          [
            [
              [-89.38011633999992, 76.44513580900008],
              [-89.40737870999993, 76.43793366100005],
              [-89.59642493399991, 76.44367096600007],
              [-89.62653561099995, 76.45136139500005],
              [-89.56191972599993, 76.47345612200007],
              [-89.52497311099995, 76.48041413000004],
              [-89.50300045499995, 76.47186920800004],
              [-89.49620520699995, 76.47870514500005],
              [-89.46930904899995, 76.46576569200005],
              [-89.38011633999992, 76.44513580900008],
            ],
          ],
          [
            [
              [-83.9922582669999, 76.42536041900007],
              [-84.05679277299993, 76.44220612200007],
              [-84.12344316299993, 76.45136139500005],
              [-84.10631262899994, 76.47516510600008],
              [-84.10362708199995, 76.48240794500003],
              [-84.10850989499994, 76.48932526200008],
              [-84.13101152299993, 76.50389232000003],
              [-84.13780676999994, 76.51406484600005],
              [-84.09618079299992, 76.51406484600005],
              [-84.07054602799991, 76.50600820500006],
              [-84.01341712099992, 76.50336334800005],
              [-83.98729407499991, 76.49603913000004],
              [-83.96841386599993, 76.48777903900003],
              [-83.91124426999994, 76.47186920800004],
              [-83.95026607999995, 76.44204336100006],
              [-83.9739477199999, 76.42837148600006],
              [-83.9922582669999, 76.42536041900007],
            ],
          ],
          [
            [
              [-104.3980199859999, 76.46873607000003],
              [-104.4141332669999, 76.47923411700003],
              [-104.4390356109999, 76.49111562700006],
              [-104.46393795499995, 76.49860260600008],
              [-104.47988847599993, 76.49603913000004],
              [-104.49864661399994, 76.48631419500003],
              [-104.5254613919999, 76.48322174700007],
              [-104.55247962099992, 76.48558177300004],
              [-104.57209225199995, 76.49233633000006],
              [-104.56590735599991, 76.49974192900004],
              [-104.57445227799991, 76.50364817900004],
              [-104.58145097599993, 76.50873444200005],
              [-104.59316972599993, 76.52020905200004],
              [-104.58438066299993, 76.52020905200004],
              [-104.57774817599994, 76.52236562700006],
              [-104.57192949099993, 76.52509186400005],
              [-104.56590735599991, 76.52708567900004],
              [-104.58836829299992, 76.53953685100004],
              [-104.64378821499992, 76.54759349200003],
              [-104.6682836579999, 76.55499909100007],
              [-104.64098059799994, 76.58173248900005],
              [-104.66417395699995, 76.58926015800006],
              [-104.67393958199995, 76.59479401200008],
              [-104.68130449099993, 76.60219961100006],
              [-104.65200761599993, 76.60203685100004],
              [-104.35240637899994, 76.66331614800004],
              [-104.02464758999992, 76.67047760600008],
              [-103.9668676419999, 76.66168854400007],
              [-103.92471269399994, 76.64008209800005],
              [-103.9356176419999, 76.62201569200005],
              [-104.0581762359999, 76.56806061400005],
              [-104.02448482999995, 76.56207916900007],
              [-103.94546464799993, 76.57733795800004],
              [-103.88296464799993, 76.57786692900004],
              [-103.85342363199993, 76.61029694200005],
              [-103.82534745999993, 76.62270742400005],
              [-103.79613196499992, 76.62311432500007],
              [-103.76732337099992, 76.61627838700008],
              [-103.67796790299991, 76.57713450700004],
              [-103.63923092399995, 76.57005442900004],
              [-103.5579320949999, 76.56806061400005],
              [-103.58214270699995, 76.55483633000006],
              [-103.59080969999991, 76.54669830900008],
              [-103.59203040299991, 76.53335195500006],
              [-103.57974199099993, 76.52684153900003],
              [-103.38735917899993, 76.49664948100008],
              [-103.30483964799993, 76.49974192900004],
              [-103.26207434799994, 76.50885651200008],
              [-103.24937903599994, 76.50657786700003],
              [-103.24535071499992, 76.50202057500007],
              [-103.24376380099994, 76.49591705900008],
              [-103.24498450399994, 76.49152252800008],
              [-103.24937903599994, 76.49233633000006],
              [-103.24608313699991, 76.48761627800008],
              [-103.24632727799991, 76.48322174700007],
              [-103.24425208199995, 76.47858307500007],
              [-103.23424231699994, 76.47361888200004],
              [-103.21934973899994, 76.47085195500006],
              [-103.07005774599992, 76.46458567900004],
              [-103.02074133999992, 76.45010000200006],
              [-103.01040605399993, 76.42348867400005],
              [-103.02261308499993, 76.41559479400007],
              [-103.3362524079999, 76.33173248900005],
              [-103.6083064444999, 76.32434723500006],
              [-103.88036048099991, 76.31696198100008],
              [-103.94985917899993, 76.32636139500005],
              [-104.37767493399991, 76.32485586100006],
              [-104.40758216099994, 76.33527252800008],
              [-104.3899633449999, 76.34438711100006],
              [-104.34569251199991, 76.35748932500007],
              [-104.33311926999994, 76.36945221600007],
              [-104.34813391799992, 76.38165924700007],
              [-104.35594641799992, 76.38605377800008],
              [-104.36660722599993, 76.38987864800004],
              [-104.39024817599994, 76.39276764500005],
              [-104.43854732999995, 76.39081452000005],
              [-104.4622289699999, 76.39671458500004],
              [-104.43419348899994, 76.40517812700006],
              [-104.40367591099994, 76.42072174700007],
              [-104.38638261599993, 76.44232819200005],
              [-104.3980199859999, 76.46873607000003],
            ],
          ],
          [
            [
              [-97.42487545499995, 75.51972077000005],
              [-97.40892493399991, 75.47158437700006],
              [-97.37340247299994, 75.44163646000004],
              [-97.28087317599994, 75.40302155200004],
              [-97.30500240799995, 75.39516836100006],
              [-97.3316137359999, 75.39655182500007],
              [-97.47227942599994, 75.42450592700004],
              [-97.49315344999991, 75.43773021000004],
              [-97.49754798099991, 75.44562409100007],
              [-97.49876868399991, 75.45453522300005],
              [-97.49315344999991, 75.46507396000004],
              [-97.49950110599991, 75.47528717700004],
              [-97.49828040299991, 75.48322174700007],
              [-97.49107825399994, 75.48883698100008],
              [-97.47948157499991, 75.49237702000005],
              [-97.72423255099994, 75.57221100500004],
              [-97.76060950399994, 75.57436758000006],
              [-97.74982662699995, 75.54775625200006],
              [-97.78302975199995, 75.54730866100005],
              [-97.82884680899991, 75.55385976800005],
              [-97.8562719389999, 75.54767487200007],
              [-97.85130774599992, 75.53778717700004],
              [-97.79548092399995, 75.52342357000003],
              [-97.77179928299995, 75.50885651200008],
              [-97.76121985599991, 75.50006745000007],
              [-97.75072180899991, 75.48867422100005],
              [-97.74742591099994, 75.47540924700007],
              [-97.75772050699993, 75.46588776200008],
              [-97.77383378799993, 75.46015045800004],
              [-97.78819739499994, 75.45831940300008],
              [-97.80964107999995, 75.46002838700008],
              [-97.82315019399994, 75.46503327000005],
              [-97.83299719999991, 75.47337474200003],
              [-97.84316972599993, 75.48493073100008],
              [-97.84593665299991, 75.49030182500007],
              [-97.84850012899994, 75.50299713700008],
              [-97.85000566299993, 75.50674062700006],
              [-97.86143958199995, 75.51243724200003],
              [-97.92369544199994, 75.51959870000007],
              [-97.94456946499992, 75.51634349200003],
              [-97.95563717399995, 75.50763580900008],
              [-97.94562740799995, 75.49237702000005],
              [-98.0210668609999, 75.49192942900004],
              [-98.0418188139999, 75.48493073100008],
              [-98.01805579299992, 75.47907135600008],
              [-97.96861731699994, 75.47882721600007],
              [-97.94562740799995, 75.47134023600006],
              [-97.97280839799993, 75.46295807500007],
              [-98.02749589799993, 75.46222565300008],
              [-98.0554906889999, 75.45831940300008],
              [-98.02037512899994, 75.44912344000005],
              [-97.94249426999994, 75.45441315300008],
              [-97.80443274599992, 75.43382396000004],
              [-97.77428137899994, 75.42413971600007],
              [-97.78140214799993, 75.42316315300008],
              [-97.78587805899991, 75.42129140800006],
              [-97.78966223899994, 75.41901276200008],
              [-97.79478919199994, 75.41669342700004],
              [-97.80508378799993, 75.41437409100007],
              [-97.81224524599992, 75.41486237200007],
              [-97.81944739499994, 75.41620514500005],
              [-98.03530839799993, 75.41551341400003],
              [-98.06232662699995, 75.40302155200004],
              [-98.02696692599994, 75.39411041900007],
              [-97.88711503799993, 75.38011302300004],
              [-97.87999426999994, 75.37433502800008],
              [-97.88857988199993, 75.36758047100005],
              [-97.91148841099994, 75.36204661700003],
              [-97.99339758999992, 75.35521067900004],
              [-97.99128170499995, 75.35797760600008],
              [-97.99079342399995, 75.35903554900005],
              [-97.98985755099994, 75.35993073100008],
              [-97.98656165299991, 75.36204661700003],
              [-97.98656165299991, 75.36888255400004],
              [-98.01203365799995, 75.36627838700008],
              [-98.05825761599993, 75.35590241100005],
              [-98.0828344389999, 75.35521067900004],
              [-98.06232662699995, 75.37567780200004],
              [-98.09683183499993, 75.37433502800008],
              [-98.12295488199993, 75.36863841400003],
              [-98.14435787699995, 75.35610586100006],
              [-98.16470292899993, 75.33417389500005],
              [-98.1536352199999, 75.32957591400003],
              [-98.14195716099994, 75.32782623900005],
              [-98.11693274599992, 75.32786692900004],
              [-98.13744055899991, 75.33417389500005],
              [-98.12303626199991, 75.34100983300004],
              [-98.10631262899994, 75.34235260600008],
              [-98.08983313699991, 75.33803945500006],
              [-98.07599850199995, 75.32786692900004],
              [-98.08853105399993, 75.32050202000005],
              [-98.10228430899991, 75.31557851800005],
              [-98.11660722599993, 75.31342194200005],
              [-98.13121497299994, 75.31427643400008],
              [-98.11668860599991, 75.29800039300005],
              [-98.08824622299994, 75.28856028900003],
              [-98.05724036399994, 75.28681061400005],
              [-98.03502356699994, 75.29315827000005],
              [-98.0418188139999, 75.29315827000005],
              [-98.01317298099991, 75.31452057500007],
              [-97.97362219999991, 75.33258698100008],
              [-97.93053137899994, 75.33954498900005],
              [-97.89098059799994, 75.32786692900004],
              [-97.95303300699993, 75.31427643400008],
              [-97.94562740799995, 75.30744049700007],
              [-97.9617406889999, 75.30255768400008],
              [-98.00084387899994, 75.27952708500004],
              [-97.93407141799992, 75.26654694200005],
              [-97.91148841099994, 75.26650625200006],
              [-97.91148841099994, 75.27334219000005],
              [-97.92491614499994, 75.28717682500007],
              [-97.91710364499994, 75.30072663000004],
              [-97.8977758449999, 75.30548737200007],
              [-97.87669837099992, 75.29315827000005],
              [-97.88414466099994, 75.28701406500005],
              [-97.85142981699994, 75.26471588700008],
              [-97.75999915299991, 75.23794179900005],
              [-97.73330644399994, 75.21124909100007],
              [-97.77367102799991, 75.21320221600007],
              [-97.79165605399993, 75.20962148600006],
              [-97.80223548099991, 75.19757721600007],
              [-97.76626542899993, 75.19086334800005],
              [-97.69505774599992, 75.19236888200004],
              [-97.65758216099994, 75.18329498900005],
              [-97.6699926419999, 75.18398672100005],
              [-97.67634029899995, 75.18195221600007],
              [-97.68492591099994, 75.17023346600007],
              [-97.61449133999992, 75.15412018400008],
              [-97.59679114499994, 75.15664297100005],
              [-97.61660722599993, 75.16339752800008],
              [-97.61660722599993, 75.17023346600007],
              [-97.60204016799992, 75.17011139500005],
              [-97.58820553299995, 75.16665273600006],
              [-97.57673092399995, 75.15985748900005],
              [-97.56883704299992, 75.14980703300006],
              [-97.64362545499995, 75.12641022300005],
              [-97.72765051999994, 75.11334870000007],
              [-97.81285559799994, 75.11310455900008],
              [-98.01329505099994, 75.15957265800006],
              [-98.03502356699994, 75.17715078300006],
              [-98.03359941299993, 75.18671295800004],
              [-98.02061926999994, 75.20184967700004],
              [-98.02135169199994, 75.21124909100007],
              [-98.03587805899991, 75.22044505400004],
              [-98.0598852199999, 75.22459544500003],
              [-98.10326087099992, 75.22553131700005],
              [-98.07994544199994, 75.20758698100008],
              [-98.09243730399993, 75.19806549700007],
              [-98.15103105399993, 75.18329498900005],
              [-98.14403235599991, 75.18256256700005],
              [-98.12376868399991, 75.17715078300006],
              [-98.1426488919999, 75.17104726800005],
              [-98.15103105399993, 75.17023346600007],
              [-98.13141842399995, 75.15363190300008],
              [-98.10338294199994, 75.14105866100005],
              [-98.0288793609999, 75.12079498900005],
              [-97.98989824099993, 75.11717357000003],
              [-97.97325598899994, 75.11196523600006],
              [-97.96597245999993, 75.10541413000004],
              [-97.95897376199991, 75.09027741100005],
              [-97.9524633449999, 75.08462148600006],
              [-97.94432532499991, 75.07245514500005],
              [-97.94432532499991, 75.05255768400008],
              [-97.95010331899994, 75.03229401200008],
              [-97.95929928299995, 75.01886627800008],
              [-97.97581946499992, 75.01447174700007],
              [-98.03502356699994, 75.02627187700006],
              [-98.39262854749992, 75.00735097850006],
              [-98.75023352799991, 74.98843008000006],
              [-98.7891332669999, 74.99896881700005],
              [-98.74693762899994, 75.01264069200005],
              [-98.77310136599993, 75.01850006700005],
              [-98.83055579299992, 75.01089101800005],
              [-98.85680091099994, 75.01886627800008],
              [-98.84312903599994, 75.02627187700006],
              [-98.84825598899994, 75.02920156500005],
              [-98.85814368399991, 75.03705475500004],
              [-98.86363684799994, 75.03994375200006],
              [-98.85195878799993, 75.05048248900005],
              [-98.84618079299992, 75.05304596600007],
              [-98.83690344999991, 75.05418528900003],
              [-98.86042232999995, 75.06525299700007],
              [-98.90021725199995, 75.06708405200004],
              [-98.94078528599994, 75.06061432500007],
              [-98.96666419199994, 75.04677969000005],
              [-98.94155839799993, 75.03046295800004],
              [-98.93871008999992, 75.01748281500005],
              [-98.95417232999995, 75.00893789300005],
              [-99.37425696499992, 74.98920319200005],
              [-99.40550696499992, 74.99896881700005],
              [-99.39879309799994, 75.00128815300008],
              [-99.37816321499992, 75.01264069200005],
              [-99.39098059799994, 75.02920156500005],
              [-99.37832597599993, 75.04686107000003],
              [-99.29576575399994, 75.09731679900005],
              [-99.28075110599991, 75.11001211100006],
              [-99.28197180899991, 75.12250397300005],
              [-99.30577551999994, 75.13129303600005],
              [-99.3313695949999, 75.12140534100007],
              [-99.37474524599992, 75.08462148600006],
              [-99.38963782499991, 75.07615794500003],
              [-99.44640051999994, 75.06037018400008],
              [-99.48766028599994, 75.03558991100005],
              [-99.50104732999995, 75.03245677300004],
              [-99.4871313139999, 75.01557038000004],
              [-99.44090735599991, 75.00600820500006],
              [-99.42593339799993, 74.99152252800008],
              [-99.47911536399994, 74.99640534100007],
              [-99.49592037699995, 74.99347565300008],
              [-99.52871660099993, 74.98281484600005],
              [-99.64541581899994, 74.97601959800005],
              [-99.98780270049994, 74.99504222200005],
              [-100.33018958199995, 75.01406484600005],
              [-100.36876380099994, 75.02309804900005],
              [-100.39240475199995, 75.03994375200006],
              [-100.39793860599991, 75.05882396000004],
              [-100.39464270699995, 75.07416413000004],
              [-100.38833574099993, 75.08856842700004],
              [-100.38491777299993, 75.10480377800008],
              [-100.38756262899994, 75.12059153900003],
              [-100.39598548099991, 75.12962474200003],
              [-100.43333899599992, 75.14980703300006],
              [-100.41673743399991, 75.15595123900005],
              [-100.40835527299993, 75.15721263200004],
              [-100.39854895699995, 75.15664297100005],
              [-100.39854895699995, 75.16339752800008],
              [-100.45409094999991, 75.18146393400008],
              [-100.51504472599993, 75.18707916900007],
              [-100.53498287699995, 75.19367096600007],
              [-100.54942786399994, 75.20502350500004],
              [-100.48814856699994, 75.22711823100008],
              [-100.41649329299992, 75.23456452000005],
              [-100.01748613199993, 75.22931549700007],
              [-99.98704993399991, 75.23859284100007],
              [-100.00914466099994, 75.24697500200006],
              [-100.06187903599994, 75.24607982000003],
              [-100.11461341099994, 75.25372955900008],
              [-100.17174231699994, 75.25360748900005],
              [-100.25226803299995, 75.26300690300008],
              [-100.35374915299991, 75.25682200700004],
              [-100.40599524599992, 75.27334219000005],
              [-100.36522376199991, 75.27936432500007],
              [-100.32087154899995, 75.28095123900005],
              [-100.27944902299993, 75.28900788000004],
              [-100.24771074099993, 75.31427643400008],
              [-100.50291907499991, 75.29262929900005],
              [-100.53770911399994, 75.29816315300008],
              [-100.67577063699991, 75.33649323100008],
              [-100.74852454299992, 75.34471263200004],
              [-100.78213456899994, 75.35521067900004],
              [-100.76309160099993, 75.36261627800008],
              [-100.6492406889999, 75.38344961100006],
              [-100.6262914699999, 75.38263580900008],
              [-100.60464433499993, 75.37567780200004],
              [-100.62726803299995, 75.37531159100007],
              [-100.67918860599991, 75.36880117400005],
              [-100.70026607999995, 75.36204661700003],
              [-100.67003333199995, 75.35407135600008],
              [-100.62417558499993, 75.34935130400004],
              [-100.58556067599994, 75.35268789300005],
              [-100.57673092399995, 75.36888255400004],
              [-100.49901282499991, 75.36676666900007],
              [-100.46011308499993, 75.37034739800004],
              [-100.42650305899991, 75.38251373900005],
              [-100.4531957669999, 75.38922760600008],
              [-100.51659094999991, 75.39459870000007],
              [-100.53575598899994, 75.40985748900005],
              [-100.52208411399994, 75.40985748900005],
              [-100.56847083199995, 75.42706940300008],
              [-100.61929277299993, 75.43260325700004],
              [-100.72134355399993, 75.43036530200004],
              [-100.72134355399993, 75.43773021000004],
              [-100.38125566349993, 75.44747549000004],
              [-100.04116777299993, 75.45722077000005],
              [-100.00877844999991, 75.47134023600006],
              [-100.31041419199994, 75.47874583500004],
              [-100.22288977799991, 75.48973216400003],
              [-100.03917395699995, 75.48021067900004],
              [-99.95352128799993, 75.49921295800004],
              [-100.2825414699999, 75.51972077000005],
              [-100.2825414699999, 75.52716705900008],
              [-99.82998613199993, 75.54767487200007],
              [-99.85570227799991, 75.55491771000004],
              [-99.93643144399994, 75.54767487200007],
              [-100.01634680899991, 75.55438873900005],
              [-100.0423070949999, 75.55390045800004],
              [-100.0423070949999, 75.56069570500006],
              [-99.9915258449999, 75.56175364800004],
              [-99.79893958199995, 75.58852773600006],
              [-99.75023352799991, 75.58930084800005],
              [-99.70368404899995, 75.59520091400003],
              [-99.66551673099991, 75.61591217700004],
              [-99.86412512899994, 75.61591217700004],
              [-99.86412512899994, 75.62274811400005],
              [-99.84947669199994, 75.62449778900003],
              [-99.80955969999991, 75.63580963700008],
              [-99.81826738199993, 75.65119049700007],
              [-99.82323157499991, 75.65623607000003],
              [-99.39183509049991, 75.67023346550005],
              [-98.96043860599991, 75.68423086100006],
              [-98.91136633999992, 75.69179922100005],
              [-98.89419511599993, 75.69965241100005],
              [-98.90672766799992, 75.70970286700003],
              [-98.9312231109999, 75.71417877800008],
              [-99.2983699209999, 75.69607168150006],
              [-99.66551673099991, 75.67796458500004],
              [-99.64118404899995, 75.68691640800006],
              [-99.55626380099994, 75.69847239800004],
              [-99.88975989499994, 75.68258291250004],
              [-100.22325598899994, 75.66669342700004],
              [-100.2742406889999, 75.65159739800004],
              [-100.30068925699993, 75.65119049700007],
              [-100.35448157499991, 75.65623607000003],
              [-100.47923743399991, 75.64191315300008],
              [-100.55345618399991, 75.65009186400005],
              [-100.80781002499992, 75.63269684450006],
              [-101.06216386599993, 75.61530182500007],
              [-101.10191809799994, 75.60333893400008],
              [-101.11729895699995, 75.60114166900007],
              [-101.15269934799994, 75.60162995000007],
              [-101.22948157499991, 75.58803945500006],
              [-101.28954016799992, 75.59162018400008],
              [-101.36115475199995, 75.57831452000005],
              [-101.39232337099992, 75.58860911700003],
              [-101.37181555899991, 75.59479401200008],
              [-101.40615800699993, 75.60683828300006],
              [-101.44937089799993, 75.60765208500004],
              [-101.75658118399991, 75.57766347850006],
              [-102.0637914699999, 75.54767487200007],
              [-102.20787512899994, 75.55390045800004],
              [-102.40029863199993, 75.54022858300004],
              [-102.63341223899994, 75.49811432500007],
              [-102.66787675699993, 75.50413646000004],
              [-102.66714433499993, 75.52716705900008],
              [-102.6858617829999, 75.53668854400007],
              [-102.70909583199995, 75.54035065300008],
              [-102.75963294199994, 75.54022858300004],
              [-102.77611243399991, 75.54498932500007],
              [-102.76504472599993, 75.55589427300004],
              [-102.72862708199995, 75.57436758000006],
              [-102.75649980399993, 75.58576080900008],
              [-102.84683183499993, 75.59983958500004],
              [-102.8743383449999, 75.61029694200005],
              [-102.8816625639999, 75.61782461100006],
              [-102.87092037699995, 75.62482330900008],
              [-102.84398352799991, 75.63397858300004],
              [-102.82140051999994, 75.63739655200004],
              [-102.80199133999992, 75.63422272300005],
              [-102.76964270699995, 75.62274811400005],
              [-102.73595130099994, 75.61701080900008],
              [-102.63304602799991, 75.61591217700004],
              [-102.64509029899995, 75.62702057500007],
              [-102.68468176999994, 75.63003164300005],
              [-102.7019750639999, 75.63580963700008],
              [-102.69383704299992, 75.64081452000005],
              [-102.68517005099994, 75.64492422100005],
              [-102.67625891799992, 75.64801666900007],
              [-102.66714433499993, 75.65009186400005],
              [-102.68765214799993, 75.67796458500004],
              [-102.67015540299991, 75.67951080900008],
              [-102.63727779899995, 75.68878815300008],
              [-102.61986243399991, 75.69106679900005],
              [-102.5738012359999, 75.68911367400005],
              [-102.55052649599992, 75.69090403900003],
              [-102.53062903599994, 75.69847239800004],
              [-102.54279537699995, 75.70571523600006],
              [-102.55630449099993, 75.71002838700008],
              [-102.57070878799993, 75.71173737200007],
              [-102.5852758449999, 75.71149323100008],
              [-102.56187903599994, 75.72553131700005],
              [-102.52261308499993, 75.72919342700004],
              [-102.24673417899993, 75.72443268400008],
              [-102.10606848899994, 75.69798411700003],
              [-102.07526607999995, 75.69745514500005],
              [-102.00926673099991, 75.70465729400007],
              [-102.00926673099991, 75.71149323100008],
              [-102.03673255099994, 75.71015045800004],
              [-102.06468665299991, 75.70526764500005],
              [-102.09239661399994, 75.70351797100005],
              [-102.11913001199991, 75.71149323100008],
              [-102.09911048099991, 75.71796295800004],
              [-102.09117591099994, 75.71893952000005],
              [-102.11729895699995, 75.73749420800004],
              [-102.20543372299994, 75.73712799700007],
              [-102.23582923099991, 75.74567291900007],
              [-102.2227270169999, 75.75820547100005],
              [-102.09117591099994, 75.78725820500006],
              [-102.11896725199995, 75.79950592700004],
              [-102.32583574099993, 75.78375885600008],
              [-102.34569251199991, 75.78725820500006],
              [-102.36607825399994, 75.80141836100006],
              [-102.37413489499994, 75.81049225500004],
              [-102.36310787699995, 75.81879303600005],
              [-102.34414628799993, 75.83759186400005],
              [-102.33482825399994, 75.84186432500007],
              [-102.31676184799994, 75.84625885600008],
              [-102.28140214799993, 75.86542389500005],
              [-102.26227779899995, 75.86981842700004],
              [-101.83299719999991, 75.90582916900007],
              [-101.81749426999994, 75.90326569200005],
              [-101.80479895699995, 75.89549388200004],
              [-101.78160559799994, 75.87421295800004],
              [-101.76626542899993, 75.86981842700004],
              [-101.75283769399994, 75.86798737200007],
              [-101.70763098899994, 75.85553620000007],
              [-101.63609778599994, 75.84601471600007],
              [-101.57664954299992, 75.82859935100004],
              [-101.49278723899994, 75.81443919500003],
              [-101.4544164699999, 75.81452057500007],
              [-101.45860755099994, 75.81244538000004],
              [-101.46214758999992, 75.80980052300004],
              [-101.46532141799992, 75.80609772300005],
              [-101.46861731699994, 75.80093008000006],
              [-101.46397864499994, 75.79266998900005],
              [-101.46320553299995, 75.78660716400003],
              [-101.46666419199994, 75.78091054900005],
              [-101.47484290299991, 75.77358633000006],
              [-101.44591223899994, 75.76410553600005],
              [-101.41519120999993, 75.75763580900008],
              [-101.27578691299993, 75.74567291900007],
              [-101.25869706899994, 75.74774811400005],
              [-101.24795488199993, 75.75287506700005],
              [-101.23912512899994, 75.75950755400004],
              [-101.2278539699999, 75.76609935100004],
              [-101.15111243399991, 75.78359609600005],
              [-100.98814856699994, 75.79067617400005],
              [-100.91315670499995, 75.81452057500007],
              [-101.04967200399994, 75.80707428600005],
              [-101.02920488199993, 75.80093008000006],
              [-101.06444251199991, 75.79035065300008],
              [-101.14883378799993, 75.78986237200007],
              [-101.22899329299992, 75.77838776200008],
              [-101.35875403599994, 75.77973053600005],
              [-101.35195878799993, 75.79018789300005],
              [-101.32974199099993, 75.81146881700005],
              [-101.3274633449999, 75.81793854400007],
              [-101.34870357999995, 75.83690013200004],
              [-101.37181555899991, 75.85179271000004],
              [-101.41494706899994, 75.86237213700008],
              [-101.50743567599994, 75.85708242400005],
              [-101.55060787699995, 75.86981842700004],
              [-101.54454505099994, 75.88507721600007],
              [-101.55321204299992, 75.89736562700006],
              [-101.56908118399991, 75.90680573100008],
              [-101.58470618399991, 75.91388580900008],
              [-101.58946692599994, 75.92450592700004],
              [-101.56895911399994, 75.93512604400007],
              [-101.4871313139999, 75.95917389500005],
              [-101.42686926999994, 75.96698639500005],
              [-101.39915930899991, 75.97528717700004],
              [-101.36709550699993, 75.99624258000006],
              [-101.35472571499992, 75.99884674700007],
              [-101.34068762899994, 76.00043366100005],
              [-101.32701575399994, 76.00478750200006],
              [-101.31436113199993, 76.01166413000004],
              [-101.3035375639999, 76.02065664300005],
              [-101.34386145699995, 76.02122630400004],
              [-101.41356360599991, 76.00360748900005],
              [-101.70995032499991, 75.98969147300005],
              [-101.77993730399993, 76.00267161700003],
              [-101.8438207669999, 76.02700429900005],
              [-101.89631100199995, 76.06468333500004],
              [-101.90884355399993, 76.08722565300008],
              [-101.90290279899995, 76.10590241100005],
              [-101.88585364499994, 76.12103913000004],
              [-101.86522376199991, 76.13263580900008],
              [-101.84715735599991, 76.13934967700004],
              [-101.80821692599994, 76.14935944200005],
              [-101.78954016799992, 76.15717194200005],
              [-101.7566625639999, 76.17853424700007],
              [-101.74233964799993, 76.18447500200006],
              [-101.54356848899994, 76.21043528900003],
              [-101.38548743399991, 76.25336334800005],
              [-101.78673255099994, 76.21857330900008],
              [-101.80797278599994, 76.22064850500004],
              [-101.84992428299995, 76.22964101800005],
              [-102.10277258999992, 76.22077057500007],
              [-102.1675512359999, 76.23908112200007],
              [-102.13853919199994, 76.24848053600005],
              [-102.09951738199993, 76.25145091400003],
              [-102.06700598899994, 76.25861237200007],
              [-102.05768795499995, 76.28001536700003],
              [-102.07787024599992, 76.29376862200007],
              [-102.11807206899994, 76.29743073100008],
              [-102.19481360599991, 76.29433828300006],
              [-102.16966712099992, 76.30133698100008],
              [-102.08519446499992, 76.31297435100004],
              [-102.05211341099994, 76.32306549700007],
              [-102.04995683499993, 76.32977936400005],
              [-102.09862219999991, 76.34902578300006],
              [-102.06200110599991, 76.35614655200004],
              [-101.98550370999993, 76.35578034100007],
              [-101.9546606109999, 76.36945221600007],
              [-101.97984778599994, 76.37738678600005],
              [-102.03457597599993, 76.38426341400003],
              [-102.05768795499995, 76.39671458500004],
              [-102.03514563699991, 76.41278717700004],
              [-102.00401770699995, 76.41852448100008],
              [-101.97085527299993, 76.42047760600008],
              [-101.94237219999991, 76.42536041900007],
              [-101.84654700399994, 76.45477936400005],
              [-101.81126868399991, 76.45880768400008],
              [-101.4134008449999, 76.43768952000005],
              [-101.39867102799991, 76.43256256700005],
              [-101.37181555899991, 76.41974518400008],
              [-101.32164466099994, 76.41453685100004],
              [-101.30679277299993, 76.41058991100005],
              [-101.21572831899994, 76.37055084800005],
              [-101.08617102799991, 76.34198639500005],
              [-101.05711829299992, 76.32843659100007],
              [-101.07046464799993, 76.32566966400003],
              [-101.08189856699994, 76.31976959800005],
              [-101.09117591099994, 76.31122467700004],
              [-101.09805253799993, 76.30052317900004],
              [-101.0906469389999, 76.30052317900004],
              [-101.12767493399991, 76.26032135600008],
              [-101.13206946499992, 76.24518463700008],
              [-101.10533606699994, 76.23908112200007],
              [-100.96076412699995, 76.23183828300006],
              [-100.84626217399995, 76.21059804900005],
              [-100.75308183499993, 76.18089427300004],
              [-100.71715247299994, 76.17401764500005],
              [-100.70555579299992, 76.16567617400005],
              [-100.69566809799994, 76.15631745000007],
              [-100.68659420499995, 76.14972565300008],
              [-100.65038001199991, 76.14264557500007],
              [-100.63414466099994, 76.13666413000004],
              [-100.62511145699995, 76.12299225500004],
              [-100.71507727799991, 76.10635000200006],
              [-100.74120032499991, 76.09568919500003],
              [-100.42027747299994, 76.12299225500004],
              [-100.45563717399995, 76.10154857000003],
              [-100.62511145699995, 76.08828359600005],
              [-100.62511145699995, 76.08148834800005],
              [-100.35391191299993, 76.06557851800005],
              [-100.31041419199994, 76.04389069200005],
              [-100.29674231699994, 76.03481679900005],
              [-100.20592200399994, 75.99433014500005],
              [-100.1961156889999, 75.98847077000005],
              [-100.18004309799994, 75.97052643400008],
              [-100.16779537699995, 75.96344635600008],
              [-100.14427649599992, 75.95709870000007],
              [-100.07022050699993, 75.95172760600008],
              [-100.08259029899995, 75.93553294500003],
              [-100.10537675699993, 75.92963288000004],
              [-100.13109290299991, 75.92601146000004],
              [-100.15217037699995, 75.91693756700005],
              [-100.12852942599994, 75.91046784100007],
              [-100.09927324099993, 75.90940989800004],
              [-100.06956946499992, 75.91266510600008],
              [-100.01561438699991, 75.92560455900008],
              [-99.9995824859999, 75.92666250200006],
              [-99.98704993399991, 75.92377350500004],
              [-99.98228919199994, 75.91990794500003],
              [-99.97565670499995, 75.91290924700007],
              [-99.97227942599994, 75.90631745000007],
              [-99.98167883999992, 75.90058014500005],
              [-99.98082434799994, 75.89435455900008],
              [-99.97740637899994, 75.88743724200003],
              [-99.97398841099994, 75.88279857000003],
              [-99.96141516799992, 75.87579987200007],
              [-99.94709225199995, 75.87518952000005],
              [-99.91942298099991, 75.88279857000003],
              [-99.86558997299994, 75.90790436400005],
              [-99.72386633999992, 75.91693756700005],
              [-99.71349036399994, 75.91917552300004],
              [-99.68447831899994, 75.93569570500006],
              [-99.67003333199995, 75.93817780200004],
              [-99.63975989499994, 75.93756745000007],
              [-99.60228430899991, 75.94245026200008],
              [-99.59422766799992, 75.94619375200006],
              [-99.5911352199999, 75.95477936400005],
              [-99.58470618399991, 75.96320221600007],
              [-99.57005774599992, 75.96588776200008],
              [-99.55382239499994, 75.96478913000004],
              [-99.52041581899994, 75.95701732000003],
              [-99.49136308499993, 75.95917389500005],
              [-99.4402563139999, 75.97223541900007],
              [-99.49144446499992, 75.98330312700006],
              [-99.8184301419999, 75.95123932500007],
              [-99.86412512899994, 75.93744538000004],
              [-99.86668860599991, 75.95018138200004],
              [-99.87661699099993, 75.95160553600005],
              [-99.88980058499993, 75.95026276200008],
              [-99.90200761599993, 75.95477936400005],
              [-99.90440833199995, 75.96417877800008],
              [-99.89561926999994, 75.97142161700003],
              [-99.88243567599994, 75.97630442900004],
              [-99.87165279899995, 75.97842031500005],
              [-99.89073645699995, 75.98948802300004],
              [-99.91388912699995, 75.99042389500005],
              [-99.93846594999991, 75.98847077000005],
              [-99.9622289699999, 75.99091217700004],
              [-99.96764075399994, 75.99469635600008],
              [-99.96849524599992, 75.99966054900005],
              [-99.9700414699999, 76.00495026200008],
              [-99.97740637899994, 76.00975169500003],
              [-99.99144446499992, 76.01300690300008],
              [-100.03547115799995, 76.01312897300005],
              [-100.02220618399991, 76.01707591400003],
              [-100.01032467399995, 76.02236562700006],
              [-100.0008031889999, 76.02977122600004],
              [-99.99449622299994, 76.04047272300005],
              [-100.06017005099994, 76.04254791900007],
              [-100.08372962099992, 76.05263906500005],
              [-100.10435950399994, 76.07526276200008],
              [-100.10936438699991, 76.08661530200004],
              [-100.11156165299991, 76.09589264500005],
              [-100.11660722599993, 76.10370514500005],
              [-100.1301977199999, 76.11054108300004],
              [-100.19961503799993, 76.12677643400008],
              [-100.22105872299994, 76.13605377800008],
              [-100.11864173099991, 76.13605377800008],
              [-100.12218176999994, 76.14581940300008],
              [-100.12486731699994, 76.14972565300008],
              [-100.08385169199994, 76.16054922100005],
              [-100.0391332669999, 76.15912506700005],
              [-99.95352128799993, 76.14350006700005],
              [-99.8101293609999, 76.13812897300005],
              [-99.72248287699995, 76.12433502800008],
              [-99.68374589799993, 76.12376536700003],
              [-99.55842037699995, 76.14451732000003],
              [-99.46080481699994, 76.15013255400004],
              [-99.41852779899995, 76.16400788000004],
              [-99.69961503799993, 76.14105866100005],
              [-99.72565670499995, 76.14516836100006],
              [-99.76170813699991, 76.15839264500005],
              [-99.77818762899994, 76.16250234600005],
              [-99.88068600199995, 76.17300039300005],
              [-99.97183183499993, 76.20221588700008],
              [-99.9942113919999, 76.20498281500005],
              [-100.16869055899991, 76.19041575700004],
              [-100.47874915299991, 76.23383209800005],
              [-100.51097571499992, 76.24994538000004],
              [-100.49510657499991, 76.27016836100006],
              [-100.44456946499992, 76.28375885600008],
              [-100.07705644399994, 76.27326080900008],
              [-100.07705644399994, 76.28001536700003],
              [-100.09093176999994, 76.28021881700005],
              [-100.13170325399994, 76.28685130400004],
              [-100.12486731699994, 76.29433828300006],
              [-100.19546464799993, 76.30076732000003],
              [-100.21422278599994, 76.30801015800006],
              [-100.17808997299994, 76.31757233300004],
              [-100.1394750639999, 76.30882396000004],
              [-100.10045325399994, 76.29450104400007],
              [-100.06309973899994, 76.28685130400004],
              [-99.89696204299992, 76.27692291900007],
              [-99.84365800699993, 76.28685130400004],
              [-99.99657141799992, 76.29881419500003],
              [-100.02183997299994, 76.30801015800006],
              [-99.99889075399994, 76.30866120000007],
              [-99.9488012359999, 76.31561920800004],
              [-99.92686926999994, 76.32225169500003],
              [-99.95799719999991, 76.33002350500004],
              [-100.02916419199994, 76.32575104400007],
              [-100.06338456899994, 76.32843659100007],
              [-100.18008378799993, 76.36322663000004],
              [-100.17048092399995, 76.36937083500004],
              [-100.13853919199994, 76.38312409100007],
              [-100.16600501199991, 76.38141510600008],
              [-100.22191321499992, 76.37042877800008],
              [-100.24771074099993, 76.36945221600007],
              [-100.32135982999995, 76.38898346600007],
              [-100.67528235599991, 76.38104889500005],
              [-100.96304277299993, 76.48029205900008],
              [-100.98818925699993, 76.50657786700003],
              [-100.73159745999993, 76.53196849200003],
              [-100.70026607999995, 76.54071686400005],
              [-100.71007239499994, 76.54311758000006],
              [-100.71816972599993, 76.54718659100007],
              [-100.72427324099993, 76.55329010600008],
              [-100.72813880099994, 76.56122467700004],
              [-100.70881100199995, 76.56342194200005],
              [-100.65306555899991, 76.58173248900005],
              [-100.5789281889999, 76.58844635600008],
              [-100.42516028599994, 76.62921784100007],
              [-100.38491777299993, 76.63007233300004],
              [-100.33259029899995, 76.64472077000005],
              [-100.26964270699995, 76.64956289300005],
              [-99.85130774599992, 76.60993073100008],
              [-99.83023027299993, 76.61147695500006],
              [-99.76598059799994, 76.63287995000007],
              [-99.74128170499995, 76.63694896000004],
              [-99.64093990799995, 76.63743724200003],
              [-99.58995520699995, 76.62856679900005],
              [-99.54946855399993, 76.60960521000004],
              [-99.58006751199991, 76.60114166900007],
              [-99.65217037699995, 76.60683828300006],
              [-99.68663489499994, 76.60219961100006],
              [-99.5230199859999, 76.59088776200008],
              [-99.2910863919999, 76.50336334800005],
              [-99.25462805899991, 76.49974192900004],
              [-99.25462805899991, 76.50657786700003],
              [-99.26146399599992, 76.50657786700003],
              [-99.26146399599992, 76.51406484600005],
              [-99.19668535099993, 76.51707591400003],
              [-99.16368567599994, 76.51349518400008],
              [-99.13853919199994, 76.49974192900004],
              [-99.22179114499994, 76.48322174700007],
              [-99.25731360599991, 76.46893952000005],
              [-99.2410375639999, 76.44822825700004],
              [-99.15876217399995, 76.41571686400005],
              [-99.11778723899994, 76.40717194200005],
              [-99.07030188699991, 76.40420156500005],
              [-99.07030188699991, 76.41038646000004],
              [-99.10920162699995, 76.42829010600008],
              [-99.1297094389999, 76.44171784100007],
              [-99.13853919199994, 76.45506419500003],
              [-99.12267005099994, 76.46491120000007],
              [-99.04710852799991, 76.45538971600007],
              [-99.02188066299993, 76.45880768400008],
              [-99.03490149599992, 76.45880768400008],
              [-99.03490149599992, 76.46564362200007],
              [-99.01235917899993, 76.47064850500004],
              [-98.97923743399991, 76.47280508000006],
              [-98.95348059799994, 76.46771881700005],
              [-98.95299231699994, 76.45136139500005],
              [-98.93089758999992, 76.43952057500007],
              [-98.90420488199993, 76.43585846600007],
              [-98.85057532499991, 76.43768952000005],
              [-98.85057532499991, 76.44513580900008],
              [-98.86164303299995, 76.44440338700008],
              [-98.87218176999994, 76.44546133000006],
              [-98.89150956899994, 76.45136139500005],
              [-98.85680091099994, 76.46564362200007],
              [-98.87808183499993, 76.47939687700006],
              [-98.90591386599993, 76.49262116100005],
              [-98.93492591099994, 76.50267161700003],
              [-98.95982825399994, 76.50657786700003],
              [-98.97288977799991, 76.51019928600005],
              [-98.9812719389999, 76.51850006700005],
              [-98.98741614499994, 76.52749258000006],
              [-98.99396725199995, 76.53335195500006],
              [-99.00938880099994, 76.53644440300008],
              [-99.04133053299995, 76.53660716400003],
              [-99.05601966099994, 76.54071686400005],
              [-99.04283606699994, 76.55158112200007],
              [-99.03758704299992, 76.56244538000004],
              [-99.04157467399995, 76.57290273600006],
              [-99.05601966099994, 76.58173248900005],
              [-99.04527747299994, 76.58087799700007],
              [-99.03482011599993, 76.58173248900005],
              [-99.02476966099994, 76.58429596600007],
              [-99.01504472599993, 76.58856842700004],
              [-99.01862545499995, 76.59162018400008],
              [-99.02513587099992, 76.59894440300008],
              [-99.02871660099993, 76.60219961100006],
              [-98.97549394399994, 76.61688873900005],
              [-98.90469316299993, 76.62441640800006],
              [-98.83409583199995, 76.62262604400007],
              [-98.78164628799993, 76.60960521000004],
              [-98.77989661399994, 76.58974844000005],
              [-98.75182044199994, 76.58222077000005],
              [-98.72667395699995, 76.59015534100007],
              [-98.73387610599991, 76.61644114800004],
              [-98.61359615799995, 76.61054108300004],
              [-98.54820716099994, 76.61546458500004],
              [-98.50796464799993, 76.63694896000004],
              [-98.53262285099993, 76.64288971600007],
              [-98.54149329299992, 76.64321523600006],
              [-98.52969316299993, 76.64923737200007],
              [-98.5164281889999, 76.65131256700005],
              [-98.48745683499993, 76.65062083500004],
              [-98.48745683499993, 76.65741608300004],
              [-98.56460527299993, 76.66571686400005],
              [-98.6792699859999, 76.65062083500004],
              [-98.7774145169999, 76.65078359600005],
              [-98.82884680899991, 76.65843333500004],
              [-98.85680091099994, 76.67792389500005],
              [-98.45531165299991, 76.68207428600005],
              [-98.42715410099993, 76.67755768400008],
              [-98.40802975199995, 76.66766998900005],
              [-98.40713456899994, 76.65814850500004],
              [-98.4304906889999, 76.64223867400005],
              [-98.43285071499992, 76.63007233300004],
              [-98.42162024599992, 76.62547435100004],
              [-98.33185787699995, 76.60651276200008],
              [-98.22752844999991, 76.60004303600005],
              [-98.17764238199993, 76.59064362200007],
              [-98.15103105399993, 76.58856842700004],
              [-98.27830969999991, 76.58173248900005],
              [-98.29409745999993, 76.58368561400005],
              [-98.34349524599992, 76.59601471600007],
              [-98.40489661399994, 76.59601471600007],
              [-98.36790930899991, 76.57050202000005],
              [-98.32164466099994, 76.56427643400008],
              [-98.27285722599993, 76.56484609600005],
              [-98.22834225199995, 76.55963776200008],
              [-98.19815019399994, 76.54840729400007],
              [-98.18586178299995, 76.54755280200004],
              [-98.17979895699995, 76.54987213700008],
              [-98.17568925699993, 76.55459219000005],
              [-98.16966712099992, 76.55914948100008],
              [-98.15811113199993, 76.56122467700004],
              [-98.1367895169999, 76.55687083500004],
              [-98.09764563699991, 76.53766510600008],
              [-98.0757543609999, 76.53335195500006],
              [-97.80630449099993, 76.51642487200007],
              [-97.66510982999995, 76.48615143400008],
              [-97.6817113919999, 76.47455475500004],
              [-97.69920813699991, 76.46564362200007],
              [-97.68968665299991, 76.45612213700008],
              [-97.67495683499993, 76.44501373900005],
              [-97.66478430899991, 76.43292877800008],
              [-97.66844641799992, 76.42035553600005],
              [-97.68643144399994, 76.41266510600008],
              [-97.71275794199994, 76.40493398600006],
              [-97.73306230399993, 76.39557526200008],
              [-97.73330644399994, 76.38312409100007],
              [-97.73680579299992, 76.37824127800008],
              [-97.74575761599993, 76.36066315300008],
              [-97.7476293609999, 76.35236237200007],
              [-97.75267493399991, 76.34381745000007],
              [-97.77822831899994, 76.32982005400004],
              [-97.78856360599991, 76.32225169500003],
              [-97.77159583199995, 76.31806061400005],
              [-97.73668372299994, 76.31342194200005],
              [-97.71971594999991, 76.30801015800006],
              [-97.72378495999993, 76.30267975500004],
              [-97.72899329299992, 76.29218170800004],
              [-97.73330644399994, 76.28685130400004],
              [-97.70885169199994, 76.27081940300008],
              [-97.55406653599994, 76.22553131700005],
              [-97.52769934799994, 76.21039459800005],
              [-97.50674394399994, 76.19065989800004],
              [-97.51366126199991, 76.19065989800004],
              [-97.50039628799993, 76.15729401200008],
              [-97.50145423099991, 76.14378489800004],
              [-97.51732337099992, 76.12616608300004],
              [-97.52985592399995, 76.11733633000006],
              [-97.56859290299991, 76.09910716400003],
              [-97.58242753799993, 76.08917877800008],
              [-97.58739173099991, 76.07982005400004],
              [-97.58995520699995, 76.05239492400005],
              [-97.59194902299993, 76.04393138200004],
              [-97.59679114499994, 76.03363678600005],
              [-97.60407467399995, 76.02635325700004],
              [-97.61290442599994, 76.02081940300008],
              [-97.62035071499992, 76.01386139500005],
              [-97.62694251199991, 75.99323151200008],
              [-97.63532467399995, 75.98981354400007],
              [-97.64557857999995, 75.98769765800006],
              [-97.65453040299991, 75.98212311400005],
              [-97.65477454299992, 75.97435130400004],
              [-97.64818274599992, 75.96698639500005],
              [-97.64395097599993, 75.95954010600008],
              [-97.65143795499995, 75.95172760600008],
              [-97.64513098899994, 75.94147370000007],
              [-97.63780676999994, 75.93187083500004],
              [-97.62002519399994, 75.91388580900008],
              [-97.57506262899994, 75.88279857000003],
              [-97.57022050699993, 75.86522044500003],
              [-97.58877519399994, 75.85016510600008],
              [-97.6446020169999, 75.82510000200006],
              [-97.65453040299991, 75.81720612200007],
              [-97.65982011599993, 75.80955638200004],
              [-97.66763261599993, 75.80243561400005],
              [-97.73753821499992, 75.78168366100005],
              [-97.80211341099994, 75.77741120000007],
              [-97.89810136599993, 75.75995514500005],
              [-97.93936113199993, 75.74567291900007],
              [-97.89732825399994, 75.73712799700007],
              [-97.67186438699991, 75.72577545800004],
              [-97.65493730399993, 75.72117747600004],
              [-97.62010657499991, 75.70750560100004],
              [-97.60317949099993, 75.70465729400007],
              [-97.42487545499995, 75.69847239800004],
              [-97.37751217399995, 75.67983633000006],
              [-97.37022864499994, 75.67426178600005],
              [-97.37254798099991, 75.65936920800004],
              [-97.37865149599992, 75.65436432500007],
              [-97.38735917899993, 75.65167877800008],
              [-97.39753170499995, 75.64325592700004],
              [-97.40640214799993, 75.62636953300006],
              [-97.40933183499993, 75.60956452000005],
              [-97.41120357999995, 75.57436758000006],
              [-97.40982011599993, 75.57562897300005],
              [-97.4077856109999, 75.57265859600005],
              [-97.4058324859999, 75.56806061400005],
              [-97.40501868399991, 75.56439850500004],
              [-97.40709387899994, 75.55890534100007],
              [-97.4116918609999, 75.55605703300006],
              [-97.41860917899993, 75.55390045800004],
              [-97.4246313139999, 75.52952708500004],
              [-97.42487545499995, 75.51972077000005],
            ],
          ],
          [
            [
              [-101.1597387359999, 76.58173248900005],
              [-101.33812415299991, 76.56122467700004],
              [-101.68712317599994, 76.58856842700004],
              [-101.66685950399994, 76.59609609600005],
              [-101.59837805899991, 76.60219961100006],
              [-101.53034420499995, 76.62815989800004],
              [-101.43346106699994, 76.64166901200008],
              [-101.24274654899995, 76.64655182500007],
              [-101.19212805899991, 76.65582916900007],
              [-101.13756262899994, 76.68402741100005],
              [-101.09019934799994, 76.68622467700004],
              [-101.05870520699995, 76.69131094000005],
              [-101.05052649599992, 76.69110748900005],
              [-101.04491126199991, 76.69330475500004],
              [-101.04283606699994, 76.70184967700004],
              [-101.0398656889999, 76.70892975500004],
              [-101.0325414699999, 76.71454498900005],
              [-101.02375240799995, 76.71881745000007],
              [-100.97248287699995, 76.73554108300004],
              [-100.62852942599994, 76.75983307500007],
              [-100.24771074099993, 76.73940664300005],
              [-100.33348548099991, 76.71454498900005],
              [-100.7466121084999, 76.64813873900005],
              [-101.1597387359999, 76.58173248900005],
            ],
          ],
          [
            [
              [-89.67495683499993, 76.73261139500005],
              [-89.68838456899994, 76.72724030200004],
              [-89.69326738199993, 76.72109609600005],
              [-89.68903561099995, 76.71552155200004],
              [-89.67495683499993, 76.71206289300005],
              [-89.69420325399994, 76.69261302300004],
              [-89.72594153599994, 76.67999909100007],
              [-89.81615149599992, 76.66766998900005],
              [-89.83580481699994, 76.65745677300004],
              [-89.85008704299992, 76.64036692900004],
              [-89.85928300699993, 76.61644114800004],
              [-89.8582250639999, 76.60028717700004],
              [-89.84947669199994, 76.58315664300005],
              [-89.82209225199995, 76.55125560100004],
              [-89.79157467399995, 76.53436920800004],
              [-89.71251380099994, 76.52094147300005],
              [-89.67495683499993, 76.50657786700003],
              [-89.71239173099991, 76.50454336100006],
              [-89.78701738199993, 76.48590729400007],
              [-89.82579505099994, 76.48615143400008],
              [-89.88744055899991, 76.50918203300006],
              [-89.91958574099993, 76.51581452000005],
              [-89.94863847599993, 76.50657786700003],
              [-89.93862870999993, 76.48334381700005],
              [-89.9773656889999, 76.47772858300004],
              [-90.06476803299995, 76.48615143400008],
              [-90.15782630099994, 76.50608958500004],
              [-90.20433508999992, 76.52423737200007],
              [-90.26618404899995, 76.57461172100005],
              [-90.56802324099993, 76.71564362200007],
              [-90.58999589799993, 76.73236725500004],
              [-90.59447180899991, 76.75088125200006],
              [-90.57184811099995, 76.77350495000007],
              [-90.52953040299991, 76.79218170800004],
              [-90.33047441299993, 76.82379791900007],
              [-90.19888261599993, 76.83616771000004],
              [-89.98216712099992, 76.84235260600008],
              [-89.93927975199995, 76.82908763200004],
              [-89.84874426999994, 76.81366608300004],
              [-89.69635982999995, 76.75348541900007],
              [-89.67495683499993, 76.73261139500005],
            ],
          ],
          [
            [
              [-105.39513098899994, 75.67426178600005],
              [-105.3933813139999, 75.66559479400007],
              [-105.39049231699994, 75.65965403900003],
              [-105.3899633449999, 75.65338776200008],
              [-105.39513098899994, 75.64325592700004],
              [-105.41006425699993, 75.63117096600007],
              [-105.44640051999994, 75.62421295800004],
              [-105.46336829299992, 75.61591217700004],
              [-105.47622636599993, 75.59861888200004],
              [-105.48302161399994, 75.58104075700004],
              [-105.49364173099991, 75.56549713700008],
              [-105.51805579299992, 75.55390045800004],
              [-105.54112708199995, 75.55084870000007],
              [-105.58971106699994, 75.55011627800008],
              [-105.68932044199994, 75.52716705900008],
              [-105.68932044199994, 75.51972077000005],
              [-105.68016516799992, 75.51825592700004],
              [-105.67418372299994, 75.51569245000007],
              [-105.66136633999992, 75.50674062700006],
              [-105.68537350199995, 75.50608958500004],
              [-105.72956295499995, 75.49966054900005],
              [-105.7508031889999, 75.49237702000005],
              [-105.71507727799991, 75.48411692900004],
              [-105.61986243399991, 75.48126862200007],
              [-105.59312903599994, 75.46507396000004],
              [-105.60977128799993, 75.46206289300005],
              [-105.64321855399993, 75.44065989800004],
              [-105.66161048099991, 75.43231842700004],
              [-105.7090551419999, 75.41974518400008],
              [-105.70872962099992, 75.41038646000004],
              [-105.68248450399994, 75.39305247600004],
              [-105.66649329299992, 75.38495514500005],
              [-105.65534420499995, 75.37759023600006],
              [-105.65245520699995, 75.36847565300008],
              [-105.66136633999992, 75.35521067900004],
              [-105.68024654899995, 75.34723541900007],
              [-105.70506751199991, 75.34292226800005],
              [-105.72183183499993, 75.33783600500004],
              [-105.71666419199994, 75.32786692900004],
              [-105.73558508999992, 75.31403229400007],
              [-105.81224524599992, 75.29999420800004],
              [-105.86766516799992, 75.27094147300005],
              [-105.88451087099992, 75.26650625200006],
              [-105.8958227199999, 75.25910065300008],
              [-105.93944251199991, 75.21466705900008],
              [-105.92861894399994, 75.20669179900005],
              [-105.83950761599993, 75.18329498900005],
              [-105.87450110599991, 75.17523834800005],
              [-105.88849850199995, 75.16689687700006],
              [-105.88451087099992, 75.15322500200006],
              [-105.89159094999991, 75.14569733300004],
              [-106.01040605399993, 75.13418203300006],
              [-106.04710852799991, 75.12409088700008],
              [-106.05980383999992, 75.11688873900005],
              [-106.0738012359999, 75.10455963700008],
              [-106.07917232999995, 75.09296295800004],
              [-106.06607011599993, 75.08771393400008],
              [-106.02440344999991, 75.08209870000007],
              [-106.00332597599993, 75.07367584800005],
              [-105.99779212099992, 75.06037018400008],
              [-106.00890051999994, 75.05662669500003],
              [-106.38457190649993, 75.02981191600006],
              [-106.76024329299992, 75.00299713700008],
              [-106.77245032499991, 74.99896881700005],
              [-106.77843176999994, 74.99518463700008],
              [-106.78189042899993, 74.99103424700007],
              [-106.78404700399994, 74.98745351800005],
              [-106.78604081899994, 74.98529694200005],
              [-107.0051977199999, 74.92381419500003],
              [-107.23102779899995, 74.92011139500005],
              [-107.31419837099992, 74.93378327000005],
              [-107.51260331899994, 74.94342682500007],
              [-107.68626868399991, 74.98224518400008],
              [-107.68980872299994, 74.99896881700005],
              [-107.72032630099994, 75.01605866100005],
              [-107.72451738199993, 75.02252838700008],
              [-107.71816972599993, 75.03196849200003],
              [-107.69001217399995, 75.03969961100006],
              [-107.68358313699991, 75.05048248900005],
              [-107.69253495999993, 75.07587311400005],
              [-107.71483313699991, 75.09198639500005],
              [-107.74351966099994, 75.10000234600005],
              [-107.77171790299991, 75.10138580900008],
              [-107.78600012899994, 75.09516022300005],
              [-107.78038489499994, 75.09393952000005],
              [-107.76553300699993, 75.08771393400008],
              [-107.77318274599992, 75.07538483300004],
              [-107.75462805899991, 75.06509023600006],
              [-107.74356035099993, 75.05272044500003],
              [-107.77391516799992, 75.03440989800004],
              [-107.85391191299993, 75.01373932500007],
              [-107.9368383449999, 75.00580475500004],
              [-107.92638098899994, 75.00800202000005],
              [-107.92137610599991, 75.00967031500005],
              [-107.91637122299994, 75.01264069200005],
              [-107.93248450399994, 75.01780833500004],
              [-107.95457923099991, 75.02106354400007],
              [-107.97638912699995, 75.02008698100008],
              [-107.99144446499992, 75.01264069200005],
              [-107.99722245999993, 75.00067780200004],
              [-107.99079342399995, 74.99494049700007],
              [-107.96475175699993, 74.98843008000006],
              [-107.94713294199994, 74.97211334800005],
              [-107.96670488199993, 74.96190013200004],
              [-108.01878821499992, 74.95058828300006],
              [-107.99986731699994, 74.94586823100008],
              [-107.96214758999992, 74.94326406500005],
              [-107.94424394399994, 74.93691640800006],
              [-107.97158769399994, 74.92942942900004],
              [-108.0569555329999, 74.93691640800006],
              [-108.41661536399994, 74.91705963700008],
              [-108.49547278599994, 74.93427155200004],
              [-108.5227758449999, 74.93691640800006],
              [-108.53990637899994, 74.94122955900008],
              [-108.56847083199995, 74.96051666900007],
              [-108.80703691299993, 74.98529694200005],
              [-108.80703691299993, 74.99152252800008],
              [-108.51219641799992, 74.97846100500004],
              [-108.54686438699991, 75.01268138200004],
              [-108.59654700399994, 75.03847890800006],
              [-108.65208899599992, 75.05475495000007],
              [-108.82420813699991, 75.07151927300004],
              [-108.92418372299994, 75.05414459800005],
              [-108.94420325399994, 75.04677969000005],
              [-108.9512426419999, 75.04144928600005],
              [-108.97154700399994, 75.01886627800008],
              [-108.96182206899994, 75.01886627800008],
              [-108.95274817599994, 75.01666901200008],
              [-108.94456946499992, 75.01235586100006],
              [-108.93736731699994, 75.00580475500004],
              [-109.03359941299993, 75.00580475500004],
              [-108.99258378799993, 74.99152252800008],
              [-109.07530676999994, 74.98867422100005],
              [-109.35716712099992, 74.94672272300005],
              [-109.38048255099994, 74.93671295800004],
              [-109.40074622299994, 74.92348867400005],
              [-109.41030839799993, 74.90961334800005],
              [-109.40444902299993, 74.90851471600007],
              [-109.38988196499992, 74.90338776200008],
              [-109.42760169199994, 74.89964427300004],
              [-109.53233801999994, 74.86701080900008],
              [-109.58193925699993, 74.85814036700003],
              [-109.88385982999995, 74.87055084800005],
              [-109.99795488199993, 74.85419342700004],
              [-110.0036921869999, 74.85260651200008],
              [-110.01988684799994, 74.84813060100004],
              [-110.05337480399993, 74.82908763200004],
              [-110.06981360599991, 74.82363515800006],
              [-110.0882055329999, 74.82762278900003],
              [-110.08189856699994, 74.83441803600005],
              [-110.0882055329999, 74.84072500200006],
              [-110.15493730399993, 74.82786692900004],
              [-110.30785071499992, 74.85219961100006],
              [-110.37677975199995, 74.84072500200006],
              [-110.36632239499994, 74.83885325700004],
              [-110.3613988919999, 74.83734772300005],
              [-110.35631262899994, 74.83441803600005],
              [-110.37022864499994, 74.83490631700005],
              [-110.38402258999992, 74.83348216400003],
              [-110.41087805899991, 74.82762278900003],
              [-110.41087805899991, 74.82078685100004],
              [-110.33901933499993, 74.80784739800004],
              [-110.31468665299991, 74.80719635600008],
              [-110.34398352799991, 74.79657623900005],
              [-110.60334225199995, 74.78607819200005],
              [-110.64614824099993, 74.79437897300005],
              [-110.66612708199995, 74.79132721600007],
              [-110.67096920499995, 74.77301666900007],
              [-110.65855872299994, 74.75918203300006],
              [-110.63402258999992, 74.74481842700004],
              [-110.58901933499993, 74.72528717700004],
              [-110.6167699859999, 74.70530833500004],
              [-110.77403723899994, 74.68366120000007],
              [-110.83604895699995, 74.65631745000007],
              [-110.8589574859999, 74.65135325700004],
              [-110.9500219389999, 74.64638906500005],
              [-110.95982825399994, 74.63987864800004],
              [-110.96715247299994, 74.63129303600005],
              [-110.97948157499991, 74.62221914300005],
              [-111.00096594999991, 74.61635976800005],
              [-111.0750219389999, 74.61542389500005],
              [-111.15697180899991, 74.59422435100004],
              [-111.22842363199993, 74.59406159100007],
              [-111.25377356699994, 74.58746979400007],
              [-111.3040258449999, 74.56378815300008],
              [-111.32249915299991, 74.56073639500005],
              [-111.41104081899994, 74.56989166900007],
              [-111.57420813699991, 74.53196849200003],
              [-111.6575414699999, 74.50120677300004],
              [-111.9482722644999, 74.47479889550004],
              [-112.23900305899991, 74.44839101800005],
              [-112.30894934799994, 74.43036530200004],
              [-112.38829505099994, 74.42401764500005],
              [-112.43740800699993, 74.41351959800005],
              [-112.63487708199995, 74.41315338700008],
              [-113.02379309799994, 74.39594147300005],
              [-113.22105872299994, 74.40460846600007],
              [-113.4527074859999, 74.41889069200005],
              [-113.69302324099993, 74.44448476800005],
              [-113.76561438699991, 74.47113678600005],
              [-114.17349199099993, 74.56696198100008],
              [-114.1741430329999, 74.57184479400007],
              [-114.1726781889999, 74.57343170800004],
              [-114.16978919199994, 74.57367584800005],
              [-114.1660863919999, 74.57440827000005],
              [-114.1929418609999, 74.57583242400005],
              [-114.39232337099992, 74.63930898600006],
              [-114.43077551999994, 74.65790436400005],
              [-114.44066321499992, 74.66876862200007],
              [-114.43980872299994, 74.68366120000007],
              [-114.42235266799992, 74.70311107000003],
              [-114.39500891799992, 74.71466705900008],
              [-114.30992591099994, 74.73212311400005],
              [-114.23436438699991, 74.75873444200005],
              [-113.97191321499992, 74.80760325700004],
              [-113.82949785099993, 74.81403229400007],
              [-113.75186113199993, 74.83429596600007],
              [-113.62682044199994, 74.84275950700004],
              [-113.49559485599991, 74.83917877800008],
              [-113.42137610599991, 74.85675690300008],
              [-113.33617102799991, 74.86237213700008],
              [-113.25796464799993, 74.84788646000004],
              [-113.2176000639999, 74.84589264500005],
              [-113.19286048099991, 74.86237213700008],
              [-113.26016191299993, 74.87665436400005],
              [-113.32998613199993, 74.88287995000007],
              [-113.30663001199991, 74.88861725500004],
              [-113.29442298099991, 74.88979726800005],
              [-113.28408769399994, 74.88922760600008],
              [-113.20775305899991, 74.89081452000005],
              [-113.18602454299992, 74.89594147300005],
              [-113.17955481699994, 74.90086497600004],
              [-113.16612708199995, 74.91705963700008],
              [-113.11095130099994, 74.94171784100007],
              [-113.01292883999992, 74.95319245000007],
              [-112.95889238199993, 74.96670156500005],
              [-112.79784094999991, 74.98505280200004],
              [-112.69782467399995, 74.97931549700007],
              [-112.5491430329999, 74.99933502800008],
              [-112.2717992829999, 74.99933502800008],
              [-112.06305904899995, 75.00796133000006],
              [-111.90868079299992, 74.99713776200008],
              [-111.77708899599992, 74.98505280200004],
              [-111.67125403599994, 75.00397370000007],
              [-111.58580481699994, 75.00641510600008],
              [-111.5554906889999, 75.01264069200005],
              [-111.50186113199993, 75.03961823100008],
              [-111.47972571499992, 75.04677969000005],
              [-111.50487219999991, 75.05874258000006],
              [-111.55483964799993, 75.04767487200007],
              [-111.57591712099992, 75.06037018400008],
              [-111.54295813699991, 75.07290273600006],
              [-111.50918535099993, 75.07147858300004],
              [-111.44188391799992, 75.06037018400008],
              [-111.40294348899994, 75.06329987200007],
              [-111.28795325399994, 75.08771393400008],
              [-111.30260169199994, 75.09853750200006],
              [-111.32298743399991, 75.10512929900005],
              [-111.34471594999991, 75.10822174700007],
              [-111.36363684799994, 75.10822174700007],
              [-111.33950761599993, 75.11566803600005],
              [-111.29165605399993, 75.10757070500006],
              [-111.26683508999992, 75.10822174700007],
              [-111.2620336579999, 75.11127350500004],
              [-111.26097571499992, 75.11591217700004],
              [-111.26113847599993, 75.12018463700008],
              [-111.25999915299991, 75.12250397300005],
              [-111.1909887359999, 75.13544342700004],
              [-111.16258704299992, 75.13613515800006],
              [-111.15160071499992, 75.13825104400007],
              [-111.13272050699993, 75.14765045800004],
              [-111.10057532499991, 75.15273672100005],
              [-111.02790279899995, 75.17715078300006],
              [-111.06883704299992, 75.19074127800008],
              [-111.05378170499995, 75.19623444200005],
              [-111.02159583199995, 75.20233795800004],
              [-111.00674394399994, 75.21124909100007],
              [-111.01357988199993, 75.21800364800004],
              [-110.99038652299993, 75.22426992400005],
              [-110.93675696499992, 75.22284577000005],
              [-110.9180395169999, 75.23236725500004],
              [-110.92430579299992, 75.24286530200004],
              [-110.9507543609999, 75.25161367400005],
              [-111.10269120999993, 75.27334219000005],
              [-111.24351966099994, 75.26650625200006],
              [-111.25059973899994, 75.26080963700008],
              [-111.27476966099994, 75.23265208500004],
              [-111.28795325399994, 75.22182851800005],
              [-111.31216386599993, 75.20966217700004],
              [-111.37218176999994, 75.18724192900004],
              [-111.42861894399994, 75.17967357000003],
              [-111.48875891799992, 75.16502513200004],
              [-111.52065995999993, 75.16339752800008],
              [-111.57262122299994, 75.17084381700005],
              [-111.59923255099994, 75.17096588700008],
              [-111.6243383449999, 75.16339752800008],
              [-111.5757543609999, 75.15615469000005],
              [-111.56163489499994, 75.14980703300006],
              [-111.67833411399994, 75.14980703300006],
              [-111.6988012359999, 75.15863678600005],
              [-111.73289954299992, 75.18488190300008],
              [-111.7534887359999, 75.19074127800008],
              [-111.76333574099993, 75.18943919500003],
              [-111.77188066299993, 75.18585846600007],
              [-111.77989661399994, 75.18130117400005],
              [-111.89736894399994, 75.13983795800004],
              [-111.92345130099994, 75.13641998900005],
              [-112.05915279899995, 75.14980703300006],
              [-112.21458899599992, 75.12799713700008],
              [-112.34605872299994, 75.12152741100005],
              [-112.41820227799991, 75.12824127800008],
              [-112.4734594389999, 75.14980703300006],
              [-112.45360266799992, 75.15859609600005],
              [-112.4292699859999, 75.16498444200005],
              [-112.3616430329999, 75.17389557500007],
              [-112.31078040299991, 75.19415924700007],
              [-112.29527747299994, 75.20502350500004],
              [-112.31798255099994, 75.21124909100007],
              [-112.39150956899994, 75.21124909100007],
              [-112.39150956899994, 75.21800364800004],
              [-112.3635961579999, 75.21800364800004],
              [-112.34996497299994, 75.22052643400008],
              [-112.33690344999991, 75.22553131700005],
              [-112.39037024599992, 75.24355703300006],
              [-112.40489661399994, 75.24603913000004],
              [-112.42174231699994, 75.24262116100005],
              [-112.44351152299993, 75.23407623900005],
              [-112.46141516799992, 75.22280508000006],
              [-112.46662350199995, 75.21124909100007],
              [-112.46117102799991, 75.20962148600006],
              [-112.45018469999991, 75.20840078300006],
              [-112.43887285099993, 75.20514557500007],
              [-112.43248450399994, 75.19757721600007],
              [-112.4363500639999, 75.18732330900008],
              [-112.4495336579999, 75.18329498900005],
              [-112.58950761599993, 75.18329498900005],
              [-112.61949622299994, 75.19188060100004],
              [-112.63255774599992, 75.19916413000004],
              [-112.63792883999992, 75.20815664300005],
              [-112.63243567599994, 75.21946849200003],
              [-112.61953691299993, 75.22581614800004],
              [-112.60472571499992, 75.23016998900005],
              [-112.59325110599991, 75.23550039300005],
              [-112.59520423099991, 75.24990469000005],
              [-112.62132727799991, 75.26459381700005],
              [-112.65485592399995, 75.27570221600007],
              [-112.67886308499993, 75.27952708500004],
              [-112.6721899079999, 75.27594635600008],
              [-112.66519120999993, 75.27334219000005],
              [-112.66519120999993, 75.26650625200006],
              [-112.69977779899995, 75.26194896000004],
              [-112.71519934799994, 75.24941640800006],
              [-112.72472083199995, 75.22996653900003],
              [-112.74095618399991, 75.20502350500004],
              [-112.70641028599994, 75.18740469000005],
              [-112.69595292899993, 75.18024323100008],
              [-112.69351152299993, 75.17267487200007],
              [-112.70079505099994, 75.15330638200004],
              [-112.69937089799993, 75.14232005400004],
              [-112.73009192599994, 75.14154694200005],
              [-112.85708574099993, 75.10984935100004],
              [-113.02293860599991, 75.09479401200008],
              [-113.05459550699993, 75.09739817900004],
              [-113.08360755099994, 75.10822174700007],
              [-113.12075761599993, 75.14142487200007],
              [-113.13817298099991, 75.14980703300006],
              [-113.16177324099993, 75.11115143400008],
              [-113.17983964799993, 75.09463125200006],
              [-113.20645097599993, 75.08771393400008],
              [-113.34972083199995, 75.08063385600008],
              [-113.44692949099993, 75.08515045800004],
              [-113.62165279899995, 75.06728750200006],
              [-113.64598548099991, 75.07099030200004],
              [-113.65196692599994, 75.06854889500005],
              [-113.6563207669999, 75.06415436400005],
              [-113.66584225199995, 75.06037018400008],
              [-113.88662675699993, 75.05817291900007],
              [-113.95763098899994, 75.07444896000004],
              [-113.95376542899993, 75.12250397300005],
              [-113.93932044199994, 75.13816966400003],
              [-113.9290258449999, 75.14427317900004],
              [-113.91283118399991, 75.14980703300006],
              [-113.6453344389999, 75.19074127800008],
              [-113.67979895699995, 75.19879791900007],
              [-113.71719316299993, 75.19700755400004],
              [-113.86611894399994, 75.16860586100006],
              [-113.90684973899994, 75.16864655200004],
              [-113.9395238919999, 75.18329498900005],
              [-113.87608801999994, 75.24974192900004],
              [-113.83641516799992, 75.30166250200006],
              [-113.81297766799992, 75.32391998900005],
              [-113.78429114499994, 75.33966705900008],
              [-113.67857825399994, 75.35952383000006],
              [-113.60138912699995, 75.36538320500006],
              [-113.53066972599993, 75.38727448100008],
              [-113.37564042899993, 75.41644928600005],
              [-113.32315019399994, 75.41669342700004],
              [-113.32315019399994, 75.42413971600007],
              [-113.34544837099992, 75.41669342700004],
              [-113.41958574099993, 75.42413971600007],
              [-113.46153723899994, 75.41868724200003],
              [-113.47630774599992, 75.42186107000003],
              [-113.47398841099994, 75.43773021000004],
              [-113.51821855399993, 75.41925690300008],
              [-113.87393144399994, 75.37376536700003],
              [-113.89854895699995, 75.37567780200004],
              [-113.92064368399991, 75.38800690300008],
              [-113.96670488199993, 75.42890045800004],
              [-114.03551184799994, 75.46576569200005],
              [-114.07066809799994, 75.47492096600007],
              [-114.09093176999994, 75.45831940300008],
              [-114.07607988199993, 75.45433177300004],
              [-114.07762610599991, 75.44525788000004],
              [-114.08592688699991, 75.43414948100008],
              [-114.09093176999994, 75.42413971600007],
              [-114.08853105399993, 75.40884023600006],
              [-114.08104407499991, 75.40216705900008],
              [-114.06908118399991, 75.39691803600005],
              [-114.05308997299994, 75.38593170800004],
              [-114.0464574859999, 75.36644114800004],
              [-114.05821692599994, 75.34601471600007],
              [-114.09093176999994, 75.31427643400008],
              [-114.11827551999994, 75.27334219000005],
              [-114.12677975199995, 75.26471588700008],
              [-114.1558324859999, 75.24225495000007],
              [-114.19579016799992, 75.22516510600008],
              [-114.25267493399991, 75.22675202000005],
              [-114.3098852199999, 75.24042389500005],
              [-114.35098222599993, 75.25967031500005],
              [-114.35191809799994, 75.26337311400005],
              [-114.35016842399995, 75.27582428600005],
              [-114.35098222599993, 75.27952708500004],
              [-114.36192786399994, 75.28485748900005],
              [-114.49437415299991, 75.30369700700004],
              [-114.51121985599991, 75.31696198100008],
              [-114.54930579299992, 75.31199778900003],
              [-114.5901586579999, 75.29779694200005],
              [-114.61514238199993, 75.28327057500007],
              [-114.61620032499991, 75.27309804900005],
              [-114.60167395699995, 75.26829661700003],
              [-114.58193925699993, 75.26772695500006],
              [-114.54698645699995, 75.27342357000003],
              [-114.44839433499993, 75.26361725500004],
              [-114.42589270699995, 75.25836823100008],
              [-114.40941321499992, 75.24909088700008],
              [-114.38516191299993, 75.21800364800004],
              [-114.35570227799991, 75.20282623900005],
              [-114.32347571499992, 75.19391510600008],
              [-114.30329342399995, 75.18178945500006],
              [-114.31004798099991, 75.15664297100005],
              [-114.32998613199993, 75.13792552300004],
              [-114.38158118399991, 75.10814036700003],
              [-114.40290279899995, 75.09145742400005],
              [-114.44082597599993, 75.06793854400007],
              [-114.69965572849992, 75.01923248900007],
              [-114.95848548099991, 74.97052643400008],
              [-115.05768795499989, 74.96674225500004],
              [-115.15477454299992, 74.98354726800005],
              [-115.18004309799994, 74.99249909100007],
              [-115.19595292899993, 75.00242747600004],
              [-115.2063695949999, 75.01699453300006],
              [-115.21499589799993, 75.03994375200006],
              [-115.22581946499992, 75.06049225500004],
              [-115.22516842399995, 75.06854889500005],
              [-115.21499589799993, 75.08148834800005],
              [-115.20083574099993, 75.08901601800005],
              [-115.1836645169999, 75.09406159100007],
              [-115.1734106109999, 75.09951406500005],
              [-115.18028723899994, 75.10822174700007],
              [-115.18321692599994, 75.12579987200007],
              [-115.20384680899991, 75.15102773600006],
              [-115.23326575399994, 75.17357005400004],
              [-115.26280676999994, 75.18329498900005],
              [-115.25487219999991, 75.16583893400008],
              [-115.27403723899994, 75.14940013200004],
              [-115.40575110599991, 75.10293203300006],
              [-115.4480688139999, 75.10024648600006],
              [-115.52415930899991, 75.12506745000007],
              [-115.65343176999994, 75.15143463700008],
              [-115.66657467399995, 75.14850495000007],
              [-115.66820227799991, 75.14044830900008],
              [-115.6526586579999, 75.12872955900008],
              [-115.63719641799992, 75.12421295800004],
              [-115.60533606699994, 75.12148672100005],
              [-115.59117591099994, 75.11562734600005],
              [-115.60594641799992, 75.10504791900007],
              [-115.58763587099992, 75.08515045800004],
              [-115.55752519399994, 75.06150950700004],
              [-115.5371801419999, 75.03994375200006],
              [-115.54336503799993, 75.03994375200006],
              [-115.55028235599991, 75.01605866100005],
              [-115.58433997299994, 74.99542877800008],
              [-115.62706458199995, 74.98016998900005],
              [-115.66006425699993, 74.97223541900007],
              [-115.71544348899994, 74.97036367400005],
              [-115.92723548099991, 74.99787018400008],
              [-116.02550208199995, 75.02606842700004],
              [-116.16641191299993, 75.04018789300005],
              [-116.2559301419999, 75.06037018400008],
              [-116.2559301419999, 75.06728750200006],
              [-116.1421606109999, 75.08380768400008],
              [-116.08446204299992, 75.09870026200008],
              [-116.04369055899991, 75.12872955900008],
              [-116.08193925699993, 75.12738678600005],
              [-116.26968339799993, 75.10049062700006],
              [-116.30850175699993, 75.10260651200008],
              [-116.33849036399994, 75.11562734600005],
              [-116.28160559799994, 75.14252350500004],
              [-116.24966386599993, 75.16242096600007],
              [-116.24600175699993, 75.18024323100008],
              [-116.24937903599994, 75.19009023600006],
              [-116.24522864499994, 75.20018138200004],
              [-116.24404863199993, 75.20807526200008],
              [-116.25649980399993, 75.21124909100007],
              [-116.46703040299991, 75.18439362200007],
              [-116.52061926999994, 75.18878815300008],
              [-116.54548092399995, 75.18524811400005],
              [-116.59593665299991, 75.17059967700004],
              [-116.61221269399994, 75.16339752800008],
              [-116.6680395169999, 75.12718333500004],
              [-116.68789628799993, 75.12250397300005],
              [-116.76724199099993, 75.12221914300005],
              [-116.89395097599993, 75.14232005400004],
              [-116.9514867829999, 75.16185130400004],
              [-116.96540279899995, 75.15997955900008],
              [-116.98867753799993, 75.14960358300004],
              [-117.0171606109999, 75.14948151200008],
              [-117.5100805329999, 75.20111725500004],
              [-117.59268144399994, 75.22728099200003],
              [-117.64631100199995, 75.23647695500006],
              [-117.67080644399994, 75.24453359600005],
              [-117.68846594999991, 75.25967031500005],
              [-117.66909745999993, 75.26801178600005],
              [-117.66051184799994, 75.27326080900008],
              [-117.65371660099993, 75.27952708500004],
              [-117.65990149599992, 75.28204987200007],
              [-117.67487545499989, 75.29315827000005],
              [-117.65143795499989, 75.30573151200008],
              [-117.62022864499994, 75.31244538000004],
              [-117.5581762359999, 75.31427643400008],
              [-117.57673092399995, 75.33661530200004],
              [-117.55431067599994, 75.35805898600006],
              [-117.3042699859999, 75.45831940300008],
              [-117.20221920499989, 75.48078034100007],
              [-116.8248591789999, 75.47913239150006],
              [-116.44749915299991, 75.47748444200005],
              [-116.3692113919999, 75.48916250200006],
              [-116.14952551999994, 75.47719961100006],
              [-116.04190019399994, 75.48480866100005],
              [-115.58971106699994, 75.58795807500007],
              [-115.26280676999994, 75.60162995000007],
              [-115.28441321499992, 75.61969635600008],
              [-115.2835180329999, 75.62714264500005],
              [-115.2727758449999, 75.63955312700006],
              [-115.25487219999991, 75.64923737200007],
              [-115.1121313139999, 75.68829987200007],
              [-115.02391516799992, 75.69358958500004],
              [-115.00210527299993, 75.69847239800004],
              [-115.05223548099991, 75.71027252800008],
              [-115.37222245999993, 75.66058991100005],
              [-115.69749915299991, 75.64581940300008],
              [-115.77476966099994, 75.62702057500007],
              [-115.9827367829999, 75.61139557500007],
              [-116.10142981699994, 75.58576080900008],
              [-116.11563066299993, 75.57778554900005],
              [-116.47652476033325, 75.57702600033339],
              [-116.83741885766658, 75.57626645166674],
              [-117.19831295499989, 75.57550690300008],
              [-117.23900305899991, 75.58270905200004],
              [-117.24901282499991, 75.60907623900005],
              [-117.22801673099991, 75.63349030200004],
              [-116.9656469389999, 75.76137929900005],
              [-116.88536536399994, 75.78900788000004],
              [-116.52379309833327, 75.80414459866671],
              [-116.1622208326666, 75.81928131733338],
              [-115.80064856699994, 75.83441803600005],
              [-115.78750566299993, 75.84048086100006],
              [-115.77611243399991, 75.85252513200004],
              [-115.76231848899994, 75.86176178600005],
              [-115.74229895699995, 75.85895416900007],
              [-115.72691809799994, 75.85419342700004],
              [-115.57811438699991, 75.83441803600005],
              [-115.22655188699991, 75.85089752800005],
              [-114.87498938699991, 75.86737702000005],
              [-114.82738196499992, 75.87938060100004],
              [-114.8059789699999, 75.89227936400005],
              [-114.81248938699991, 75.90216705900008],
              [-114.83409583199995, 75.90851471600007],
              [-114.8577367829999, 75.91079336100006],
              [-115.27769934799991, 75.89872874550005],
              [-115.69766191299993, 75.88666413000004],
              [-115.76162675699993, 75.89606354400007],
              [-116.20254472599993, 75.86806875200006],
              [-116.21857662699995, 75.86957428600005],
              [-116.22179114499994, 75.87596263200004],
              [-116.24437415299991, 75.86953359600005],
              [-116.70811926999994, 75.89956289300005],
              [-116.7234594389999, 75.90802643400008],
              [-116.73399817599994, 75.92108795800004],
              [-116.73631751199991, 75.93744538000004],
              [-116.72850501199991, 75.95416901200008],
              [-116.71385657499991, 75.96124909100007],
              [-116.61611894399994, 75.97626373900005],
              [-116.55736243399991, 75.97842031500005],
              [-116.48497473899994, 75.97211334800005],
              [-116.46133378799993, 75.97842031500005],
              [-116.47569739499994, 75.99241771000004],
              [-116.5164281889999, 76.00145091400003],
              [-116.53026282499991, 76.01312897300005],
              [-116.52131100199995, 76.01532623900005],
              [-116.4961645169999, 76.02680084800005],
              [-116.54198157499991, 76.03534577000005],
              [-116.65831458199995, 76.01992422100005],
              [-116.70156816299993, 76.04047272300005],
              [-116.7071020169999, 76.05036041900007],
              [-116.7058813139999, 76.05780670800004],
              [-116.68789628799993, 76.07526276200008],
              [-116.64614824099993, 76.10106028900003],
              [-116.64696204299992, 76.10871002800008],
              [-116.63027910099993, 76.12042877800008],
              [-116.61082923099991, 76.12384674700007],
              [-116.59048417899993, 76.12490469000005],
              [-116.57119706899994, 76.12921784100007],
              [-116.5547582669999, 76.13947174700007],
              [-116.5410863919999, 76.15082428600005],
              [-116.52623450399994, 76.16014232000003],
              [-116.16270911399994, 76.20384349200003],
              [-115.94644120999993, 76.20209381700005],
              [-115.8411352199999, 76.18496328300006],
              [-115.67198645699995, 76.18048737200007],
              [-115.45225989499994, 76.18821849200003],
              [-115.16051184799994, 76.16705963700008],
              [-115.04308020699995, 76.16400788000004],
              [-115.04010982999989, 76.15884023600006],
              [-114.94981848899994, 76.16396719000005],
              [-114.82713782499991, 76.14931875200006],
              [-114.71104895699995, 76.15420156500005],
              [-114.66698157499991, 76.16400788000004],
              [-114.70628821499992, 76.17438385600008],
              [-114.7949926419999, 76.16795482000003],
              [-114.87832597599993, 76.17743561400005],
              [-114.97533118399991, 76.17731354400007],
              [-115.04027258999992, 76.20844147300005],
              [-115.27928626199991, 76.23704661700003],
              [-115.52936764249992, 76.23716868700004],
              [-115.77944902299993, 76.23729075700004],
              [-115.87730872299994, 76.25324127800008],
              [-115.89281165299991, 76.25958893400008],
              [-115.91738847599993, 76.28148021000004],
              [-115.92699133999992, 76.28685130400004],
              [-115.90990149599992, 76.29926178600005],
              [-115.8518774079999, 76.32225169500003],
              [-115.86339270699995, 76.33258698100008],
              [-115.89769446499992, 76.34235260600008],
              [-115.91331946499992, 76.34902578300006],
              [-115.87486731699994, 76.36359284100007],
              [-115.51231848899994, 76.45620351800005],
              [-115.02147376199991, 76.47907135600008],
              [-114.98167883999992, 76.48615143400008],
              [-114.90489661399994, 76.51675039300005],
              [-114.87242591099994, 76.52020905200004],
              [-114.7005102199999, 76.52020905200004],
              [-114.71300208199995, 76.51044342700004],
              [-114.74693762899994, 76.50018952000005],
              [-114.76256262899994, 76.49233633000006],
              [-114.45079505099994, 76.50092194200005],
              [-114.20592200399994, 76.47101471600007],
              [-114.15925045499989, 76.45880768400008],
              [-114.13263912699995, 76.44570547100005],
              [-114.11579342399995, 76.43060944200005],
              [-114.09093176999994, 76.38987864800004],
              [-114.11827551999994, 76.36945221600007],
              [-114.10460364499994, 76.36322663000004],
              [-114.12205969999991, 76.35675690300008],
              [-114.14102128799993, 76.35480377800008],
              [-114.1797582669999, 76.35578034100007],
              [-114.1687719389999, 76.34406159100007],
              [-114.15050208199995, 76.34023672100005],
              [-114.11082923099991, 76.34149811400005],
              [-114.1179906889999, 76.33738841400003],
              [-114.13878333199995, 76.32225169500003],
              [-114.13581295499989, 76.31818268400008],
              [-114.13272050699993, 76.31647370000007],
              [-114.12511145699995, 76.31484609600005],
              [-114.13194739499994, 76.31484609600005],
              [-114.0835668609999, 76.29433828300006],
              [-114.00841223899994, 76.27326080900008],
              [-113.98485266799992, 76.25592682500007],
              [-114.00096594999991, 76.24380117400005],
              [-114.03465735599991, 76.23273346600007],
              [-114.06362870999993, 76.21857330900008],
              [-114.02578691299993, 76.21206289300005],
              [-113.99461829299992, 76.19928620000007],
              [-113.96304277299993, 76.19061920800004],
              [-113.87376868399991, 76.20648834800005],
              [-113.71353105399993, 76.20498281500005],
              [-113.56822669199994, 76.23468659100007],
              [-113.51903235599991, 76.23908112200007],
              [-113.46784420499989, 76.23822663000004],
              [-113.44286048099991, 76.24115631700005],
              [-113.39989173099991, 76.25763580900008],
              [-113.35435950399994, 76.26605866100005],
              [-113.21983801999994, 76.26430898600006],
              [-113.18004309799994, 76.25531647300005],
              [-113.1590063139999, 76.25336334800005],
              [-112.9942113919999, 76.27326080900008],
              [-112.91104081899994, 76.26410553600005],
              [-112.86856035099993, 76.25031159100007],
              [-112.85020911399994, 76.22858307500007],
              [-112.83079993399991, 76.21922435100004],
              [-112.7561742829999, 76.22190989800004],
              [-112.75462805899991, 76.21238841400003],
              [-112.75462805899991, 76.20498281500005],
              [-112.61953691299993, 76.20530833500004],
              [-112.54076087099992, 76.18797435100004],
              [-112.46467037699995, 76.18065013200004],
              [-112.43248450399994, 76.17084381700005],
              [-112.42564856699994, 76.17084381700005],
              [-112.44937089799993, 76.16193268400008],
              [-112.4805395169999, 76.15546295800004],
              [-112.50279700399994, 76.14468008000006],
              [-112.50015214799993, 76.12299225500004],
              [-112.52574622299994, 76.12099844000005],
              [-112.51545162699995, 76.11001211100006],
              [-112.44717363199993, 76.07977936400005],
              [-112.43797766799992, 76.07001373900005],
              [-112.43114173099991, 76.06012604400007],
              [-112.41881262899994, 76.05072663000004],
              [-112.36461341099994, 76.03363678600005],
              [-112.11803137899994, 76.01239655200004],
              [-111.8555395169999, 75.95351797100005],
              [-111.76927649599992, 75.94741445500006],
              [-111.74620520699995, 75.93707916900007],
              [-111.72679602799991, 75.91693756700005],
              [-111.78140214799993, 75.90053945500006],
              [-112.07274329299992, 75.87563711100006],
              [-112.18610592399995, 75.84808991100005],
              [-112.16266842399995, 75.83982982000003],
              [-112.13760331899994, 75.83441803600005],
              [-112.20775305899991, 75.82241445500006],
              [-112.22704016799992, 75.81452057500007],
              [-112.19692949099993, 75.80760325700004],
              [-112.15953528599994, 75.80829498900005],
              [-112.0899145169999, 75.82135651200008],
              [-112.07677161399994, 75.82697174700007],
              [-112.06480872299994, 75.83372630400004],
              [-112.0515844389999, 75.83942291900007],
              [-112.03465735599991, 75.84186432500007],
              [-112.02074133999992, 75.84039948100008],
              [-111.9942113919999, 75.83466217700004],
              [-111.9800512359999, 75.83441803600005],
              [-111.99453691299993, 75.83063385600008],
              [-112.02236894399994, 75.82672760600008],
              [-112.03526770699995, 75.82135651200008],
              [-111.94896399599992, 75.80707428600005],
              [-111.92833411399994, 75.81049225500004],
              [-111.88809160099993, 75.82538483300004],
              [-111.86733964799993, 75.82880280200004],
              [-111.4590551419999, 75.84186432500007],
              [-111.44668535099993, 75.83759186400005],
              [-111.45628821499992, 75.82819245000007],
              [-111.4759008449999, 75.81879303600005],
              [-111.49327551999994, 75.81452057500007],
              [-111.57388261599993, 75.81907786700003],
              [-111.59642493399991, 75.81452057500007],
              [-111.45889238199993, 75.78880442900004],
              [-111.4319555329999, 75.76609935100004],
              [-111.44005286399994, 75.76312897300005],
              [-111.44786536399994, 75.75775788000004],
              [-111.45189368399991, 75.75063711100006],
              [-111.44871985599991, 75.74225495000007],
              [-111.43248450399994, 75.73602936400005],
              [-111.3882543609999, 75.73932526200008],
              [-111.36986243399991, 75.73261139500005],
              [-111.36143958199995, 75.71523672100005],
              [-111.37588456899994, 75.70502350500004],
              [-111.39753170499995, 75.69501373900005],
              [-111.41079667899993, 75.67796458500004],
              [-111.4024145169999, 75.67499420800004],
              [-111.39098059799994, 75.66917552300004],
              [-111.38097083199995, 75.66160716400003],
              [-111.37669837099992, 75.65314362200007],
              [-111.3809301419999, 75.64325592700004],
              [-111.41079667899993, 75.61591217700004],
              [-111.39659583199995, 75.61456940300008],
              [-111.38475501199991, 75.60838450700004],
              [-111.35130774599992, 75.57977936400005],
              [-111.33580481699994, 75.57485586100006],
              [-111.29474850199995, 75.57436758000006],
              [-111.29474850199995, 75.56818268400008],
              [-111.30223548099991, 75.56439850500004],
              [-111.3089086579999, 75.55988190300008],
              [-111.32209225199995, 75.54767487200007],
              [-111.29784094999991, 75.54531484600005],
              [-111.28111731699994, 75.54022858300004],
              [-111.27965247299994, 75.53790924700007],
              [-111.27953040299991, 75.53424713700008],
              [-111.27843176999994, 75.53034088700008],
              [-111.27428137899994, 75.52716705900008],
              [-111.25084387899994, 75.52187734600005],
              [-111.22935950399994, 75.52240631700005],
              [-111.20897376199991, 75.52533600500004],
              [-111.0137426419999, 75.53143952000005],
              [-110.85606848899994, 75.55744049700007],
              [-110.51357988199993, 75.57330963700008],
              [-110.43101966099994, 75.55951569200005],
              [-110.42686926999994, 75.55613841400003],
              [-110.42495683499993, 75.55084870000007],
              [-110.42454993399991, 75.54389069200005],
              [-110.41869055899991, 75.53986237200007],
              [-110.21861731699994, 75.53583405200004],
              [-110.15786699099993, 75.54694245000007],
              [-110.11607825399994, 75.54022858300004],
              [-110.06826738199993, 75.54767487200007],
              [-110.0036921869999, 75.54466380400004],
              [-109.5145360994999, 75.52169424050004],
              [-109.02538001199991, 75.49872467700004],
              [-108.93748938699991, 75.47744375200006],
              [-108.90998287699995, 75.47874583500004],
              [-108.89639238199993, 75.49237702000005],
              [-108.90147864499994, 75.49567291900007],
              [-108.92682857999995, 75.53025950700004],
              [-108.95103919199994, 75.54266998900005],
              [-109.01097571499992, 75.54767487200007],
              [-109.03359941299993, 75.55390045800004],
              [-108.99413001199991, 75.56810130400004],
              [-108.94741777299993, 75.56899648600006],
              [-108.85545813699991, 75.56069570500006],
              [-108.85545813699991, 75.56818268400008],
              [-108.86758378799993, 75.56879303600005],
              [-108.87865149599992, 75.57269928600005],
              [-108.88829505099994, 75.57949453300006],
              [-108.89639238199993, 75.58860911700003],
              [-108.88084876199991, 75.60053131700005],
              [-108.8452856109999, 75.61237213700008],
              [-108.83495032499991, 75.62274811400005],
              [-108.9082738919999, 75.66608307500007],
              [-108.93736731699994, 75.67796458500004],
              [-108.93443762899994, 75.68109772300005],
              [-108.93150794199994, 75.68268463700008],
              [-108.92491614499994, 75.68398672100005],
              [-108.87474524599992, 75.68154531500005],
              [-108.8499242829999, 75.68341705900008],
              [-108.82811438699991, 75.69106679900005],
              [-108.85765540299991, 75.70026276200008],
              [-108.95787512899994, 75.70465729400007],
              [-108.98058020699995, 75.71552155200004],
              [-108.99258378799993, 75.71893952000005],
              [-109.01081295499995, 75.72089264500005],
              [-109.06773841099994, 75.71893952000005],
              [-109.06590735599991, 75.72333405200004],
              [-109.0633031889999, 75.73432038000004],
              [-109.06151282499991, 75.73883698100008],
              [-109.10204016799992, 75.75006745000007],
              [-109.4082738919999, 75.77879466400003],
              [-109.46434485599991, 75.79409414300005],
              [-109.44904537699995, 75.79389069200005],
              [-109.40416419199994, 75.80093008000006],
              [-109.69151770699995, 75.80707428600005],
              [-109.68146725199995, 75.81801992400005],
              [-109.64586341099994, 75.82599518400008],
              [-109.62946529899995, 75.83441803600005],
              [-109.64696204299992, 75.84186432500007],
              [-109.68691972599993, 75.84194570500006],
              [-109.70518958199995, 75.84808991100005],
              [-109.68248450399994, 75.85993073100008],
              [-109.65737870999993, 75.86981842700004],
              [-109.67454993399991, 75.87571849200003],
              [-109.70107988199993, 75.88035716400003],
              [-109.72789466099994, 75.88214752800008],
              [-109.74583899599992, 75.87938060100004],
              [-109.7886449859999, 75.86424388200004],
              [-109.80467688699991, 75.86371491100005],
              [-109.83958899599992, 75.87091705900008],
              [-109.8933813139999, 75.85224030200004],
              [-109.95173092399995, 75.86054108300004],
              [-110.0036921869999, 75.87868886900003],
              [-110.05459550699993, 75.89647044500003],
              [-110.0036921869999, 75.91144440300008],
              [-109.97618567599994, 75.91950104400007],
              [-109.68569902299993, 75.94782135600008],
              [-109.65330969999991, 75.95697663000004],
              [-109.58698482999995, 75.98387278900003],
              [-109.5384008449999, 75.99388255400004],
              [-109.43333899599992, 76.00360748900005],
              [-109.38988196499992, 76.02065664300005],
              [-109.42540442599994, 76.03143952000005],
              [-109.43765214799993, 76.03363678600005],
              [-109.39948482999995, 76.04132721600007],
              [-109.29735266799992, 76.03912995000007],
              [-109.27257239499994, 76.05414459800005],
              [-109.30182857999995, 76.05630117400005],
              [-109.36058508999992, 76.06704336100006],
              [-109.38988196499992, 76.06777578300006],
              [-109.38365637899994, 76.07908763200004],
              [-109.38296464799993, 76.08209870000007],
              [-109.38243567599994, 76.08828359600005],
              [-109.32607988199993, 76.09735748900005],
              [-109.30797278599994, 76.10252513200004],
              [-109.3230688139999, 76.11538320500006],
              [-109.34439042899993, 76.12177155200004],
              [-109.3679906889999, 76.12604401200008],
              [-109.42174231699994, 76.14240143400008],
              [-109.48936926999994, 76.15180084800005],
              [-109.5196020169999, 76.16400788000004],
              [-109.52049719999991, 76.16718170800004],
              [-109.51935787699995, 76.17218659100007],
              [-109.52017167899993, 76.17816803600005],
              [-109.52708899599992, 76.18447500200006],
              [-109.54222571499992, 76.18943919500003],
              [-109.69957434799994, 76.19501373900005],
              [-109.72500566299993, 76.20498281500005],
              [-109.7141820949999, 76.20473867400005],
              [-109.69957434799994, 76.20612213700008],
              [-109.68748938699991, 76.21039459800005],
              [-109.68407141799992, 76.21857330900008],
              [-109.69546464799993, 76.22467682500007],
              [-109.83189856699994, 76.24079010600008],
              [-109.86961829299992, 76.23981354400007],
              [-109.90379798099991, 76.23163483300004],
              [-109.90029863199993, 76.22475820500006],
              [-109.88695227799991, 76.20701732000003],
              [-109.88329016799992, 76.20498281500005],
              [-109.8933813139999, 76.19749583500004],
              [-109.9097387359999, 76.19672272300005],
              [-109.92686926999994, 76.19965241100005],
              [-110.0036921869999, 76.22642649900007],
              [-110.14696204299992, 76.27631256700005],
              [-110.3836156889999, 76.30052317900004],
              [-110.37539628799993, 76.31476471600007],
              [-110.34284420499995, 76.32973867400005],
              [-110.32835852799991, 76.34149811400005],
              [-110.34142005099994, 76.34585195500006],
              [-110.35606848899994, 76.34886302300004],
              [-110.36888587099992, 76.35370514500005],
              [-110.37677975199995, 76.36322663000004],
              [-110.36351477799991, 76.37164948100008],
              [-110.36949622299994, 76.37938060100004],
              [-110.38426673099991, 76.38739655200004],
              [-110.39720618399991, 76.39671458500004],
              [-110.38707434799994, 76.40232982000003],
              [-110.38133704299992, 76.41038646000004],
              [-110.3801977199999, 76.42011139500005],
              [-110.3836156889999, 76.43085358300004],
              [-110.36290442599994, 76.43158600500004],
              [-110.35631262899994, 76.43085358300004],
              [-110.36245683499993, 76.43085358300004],
              [-110.32127844999991, 76.42877838700008],
              [-110.11278235599991, 76.45380280200004],
              [-110.04893958199995, 76.47671133000006],
              [-110.00682532499991, 76.48615143400008],
              [-110.0036921869999, 76.48615143400008],
              [-109.91685950399994, 76.48615143400008],
              [-109.87987219999991, 76.49575429900005],
              [-109.86156165299991, 76.49819570500006],
              [-109.80825761599993, 76.49164459800005],
              [-109.77196204299992, 76.50018952000005],
              [-109.70518958199995, 76.52708567900004],
              [-109.73346920499995, 76.53546784100007],
              [-109.8491918609999, 76.53335195500006],
              [-109.8491918609999, 76.54071686400005],
              [-109.82656816299993, 76.54437897300005],
              [-109.80174719999991, 76.55170319200005],
              [-109.77830969999991, 76.56195709800005],
              [-109.7598363919999, 76.57489655200004],
              [-109.76854407499991, 76.57949453300006],
              [-109.77318274599992, 76.58421458500004],
              [-109.78026282499991, 76.59601471600007],
              [-109.65054277299993, 76.58856842700004],
              [-109.65392005099994, 76.59463125200006],
              [-109.6602270169999, 76.61025625200006],
              [-109.66356360599991, 76.61644114800004],
              [-109.58116614499994, 76.63031647300005],
              [-109.55431067599994, 76.63007233300004],
              [-109.56029212099992, 76.65497467700004],
              [-109.5520727199999, 76.67487213700008],
              [-109.53302975199995, 76.68952057500007],
              [-109.50658118399991, 76.69843170800004],
              [-109.4944555329999, 76.72284577000005],
              [-109.44066321499992, 76.73989492400005],
              [-109.3352758449999, 76.75983307500007],
              [-109.33873450399994, 76.76300690300008],
              [-109.34520423099991, 76.77033112200007],
              [-109.3489477199999, 76.77350495000007],
              [-109.32510331899994, 76.78888580900008],
              [-109.30394446499992, 76.79490794500003],
              [-109.25332597599993, 76.80145905200004],
              [-109.19994055899991, 76.82005442900004],
              [-109.17699133999992, 76.82192617400005],
              [-109.18443762899994, 76.82192617400005],
              [-109.00625566299993, 76.82876211100006],
              [-108.93578040299991, 76.81769440300008],
              [-108.90123450399994, 76.81614817900004],
              [-108.82079016799992, 76.83441803600005],
              [-108.8145238919999, 76.83901601800005],
              [-108.80846106699994, 76.85244375200006],
              [-108.79381262899994, 76.86074453300006],
              [-108.77562415299991, 76.86416250200006],
              [-108.75926673099991, 76.86294179900005],
              [-108.7481176419999, 76.85871002800008],
              [-108.72508704299992, 76.84235260600008],
              [-108.66738847599993, 76.82485586100006],
              [-108.64940344999991, 76.81452057500007],
              [-108.66974850199995, 76.79962799700007],
              [-108.68724524599992, 76.78375885600008],
              [-108.69001217399995, 76.77114492400005],
              [-108.67003333199995, 76.76654694200005],
              [-108.53233801999994, 76.76699453300006],
              [-108.48550370999993, 76.75714752800008],
              [-108.45079505099994, 76.73261139500005],
              [-108.44408118399991, 76.70331452000005],
              [-108.46861731699994, 76.68626536700003],
              [-108.54015051999994, 76.66425202000005],
              [-108.57652747299994, 76.64598216400003],
              [-108.59727942599994, 76.64305247600004],
              [-108.64907792899993, 76.65346914300005],
              [-108.67788652299993, 76.65277741100005],
              [-108.73192298099991, 76.64321523600006],
              [-108.69127356699994, 76.60822174700007],
              [-108.68724524599992, 76.60219961100006],
              [-108.66274980399993, 76.59796784100007],
              [-108.62865149599992, 76.57916901200008],
              [-108.60863196499992, 76.57489655200004],
              [-108.56159420499995, 76.57005442900004],
              [-108.53868567599994, 76.56175364800004],
              [-108.53331458199995, 76.54755280200004],
              [-108.54832923099991, 76.53945547100005],
              [-108.60651607999995, 76.53070709800005],
              [-108.62889563699991, 76.52020905200004],
              [-108.60334225199995, 76.51512278900003],
              [-108.54824785099993, 76.52045319200005],
              [-108.52586829299992, 76.51406484600005],
              [-108.56631425699993, 76.50250885600008],
              [-108.58682206899994, 76.49258047100005],
              [-108.59105383999992, 76.48240794500003],
              [-108.56940670499995, 76.47174713700008],
              [-108.50959225199995, 76.46938711100006],
              [-108.48493404899995, 76.45880768400008],
              [-108.51732337099992, 76.44936758000006],
              [-108.5872289699999, 76.44318268400008],
              [-108.61587480399993, 76.42348867400005],
              [-108.58971106699994, 76.41022370000007],
              [-108.5601293609999, 76.41111888200004],
              [-108.53001868399991, 76.41583893400008],
              [-108.50230872299994, 76.41380442900004],
              [-108.47130286399994, 76.40692780200004],
              [-108.34227454299992, 76.40208567900004],
              [-108.31883704299992, 76.39638906500005],
              [-108.26333574099993, 76.37152741100005],
              [-108.24559485599991, 76.35919830900008],
              [-108.23851477799991, 76.35578034100007],
              [-108.22240149599992, 76.35443756700005],
              [-108.19107011599993, 76.35521067900004],
              [-108.1770727199999, 76.34902578300006],
              [-108.18980872299994, 76.34845612200007],
              [-108.20213782499991, 76.34638092700004],
              [-108.21373450399994, 76.34210846600007],
              [-108.22423255099994, 76.33527252800008],
              [-108.0808813139999, 76.28685130400004],
              [-108.0808813139999, 76.28001536700003],
              [-108.12865149599992, 76.28001536700003],
              [-108.12865149599992, 76.27326080900008],
              [-108.11497962099992, 76.27326080900008],
              [-108.13849850199995, 76.25910065300008],
              [-108.21153723899994, 76.26691315300008],
              [-108.23167883999992, 76.25336334800005],
              [-108.21422278599994, 76.23908112200007],
              [-108.08763587099992, 76.22540924700007],
              [-108.1199438139999, 76.21010976800005],
              [-108.33641516799992, 76.18642812700006],
              [-108.37755286399994, 76.17377350500004],
              [-108.40977942599994, 76.14972565300008],
              [-108.39688066299993, 76.13202545800004],
              [-108.41226152299993, 76.12034739800004],
              [-108.43838456899994, 76.11155833500004],
              [-108.45759029899995, 76.10252513200004],
              [-108.44009355399993, 76.09739817900004],
              [-108.40172278599994, 76.09609609600005],
              [-108.38247636599993, 76.08828359600005],
              [-108.4109594389999, 76.08344147300005],
              [-108.44839433499993, 76.07119375200006],
              [-108.48216712099992, 76.05548737200007],
              [-108.49917558499993, 76.04047272300005],
              [-108.35521399599992, 76.05414459800005],
              [-108.16197669199994, 76.04791901200008],
              [-108.0398656889999, 76.06777578300006],
              [-107.88902747299994, 76.06777578300006],
              [-107.85757402299993, 76.06586334800005],
              [-107.73070227799991, 76.03900788000004],
              [-107.71776282499991, 76.03363678600005],
              [-107.70067298099991, 76.02122630400004],
              [-107.69009355399993, 76.01557038000004],
              [-107.65025794199994, 76.00576406500005],
              [-107.64012610599991, 75.98924388200004],
              [-107.64830481699994, 75.97284577000005],
              [-107.67674719999991, 75.96539948100008],
              [-107.70494544199994, 75.96149323100008],
              [-107.79344641799992, 75.93060944200005],
              [-107.78034420499995, 75.92511627800008],
              [-107.75234941299993, 75.92194245000007],
              [-107.73818925699993, 75.91693756700005],
              [-107.78815670499995, 75.90257396000004],
              [-107.89736894399994, 75.90110911700003],
              [-107.94424394399994, 75.87596263200004],
              [-107.94102942599994, 75.87213776200008],
              [-107.93956458199995, 75.86904531500005],
              [-107.93858801999994, 75.86603424700007],
              [-107.9368383449999, 75.86237213700008],
              [-107.9690649079999, 75.85956452000005],
              [-107.99937903599994, 75.84442780200004],
              [-108.04670162699995, 75.80707428600005],
              [-108.03880774599992, 75.80499909100007],
              [-108.01878821499992, 75.79409414300005],
              [-108.02623450399994, 75.78725820500006],
              [-107.97862708199995, 75.78070709800005],
              [-107.9214574859999, 75.79067617400005],
              [-107.8653051419999, 75.81069570500006],
              [-107.82079016799992, 75.83441803600005],
              [-107.77098548099991, 75.86937083500004],
              [-107.75340735599991, 75.87783437700006],
              [-107.72057044199994, 75.88580963700008],
              [-107.36717688699991, 75.91864655200004],
              [-107.29747473899994, 75.91299062700006],
              [-107.21605383999992, 75.91583893400008],
              [-107.15025794199994, 75.89862702000005],
              [-107.07599850199995, 75.89940013200004],
              [-107.04613196499992, 75.88898346600007],
              [-107.08226477799991, 75.87750885600008],
              [-107.09390214799993, 75.86981842700004],
              [-107.0977270169999, 75.86334870000007],
              [-107.10171464799993, 75.84788646000004],
              [-107.10757402299993, 75.84186432500007],
              [-107.07701575399994, 75.81525299700007],
              [-107.03770911399994, 75.80756256700005],
              [-106.99575761599993, 75.80508047100005],
              [-106.95677649599992, 75.79409414300005],
              [-106.97476152299993, 75.79413483300004],
              [-107.00059973899994, 75.79120514500005],
              [-107.0235082669999, 75.78465403900003],
              [-107.03307044199994, 75.77358633000006],
              [-107.02208411399994, 75.76740143400008],
              [-106.94994055899991, 75.75250885600008],
              [-106.96703040299991, 75.73509349200003],
              [-106.96165930899991, 75.71039459800005],
              [-106.94517981699994, 75.68626536700003],
              [-106.92943274599992, 75.67055898600006],
              [-106.91519120999993, 75.66046784100007],
              [-106.89663652299993, 75.65078359600005],
              [-106.8809301419999, 75.64923737200007],
              [-106.87486731699994, 75.66372304900005],
              [-106.88145911399994, 75.67186107000003],
              [-106.89427649599992, 75.67670319200005],
              [-106.90420488199993, 75.68374258000006],
              [-106.90217037699995, 75.69847239800004],
              [-106.9090063139999, 75.69847239800004],
              [-106.89671790299991, 75.71539948100008],
              [-106.88927161399994, 75.73159414300005],
              [-106.8797094389999, 75.74656810100004],
              [-106.86119544199994, 75.75995514500005],
              [-106.88231360599991, 75.76609935100004],
              [-106.81851152299993, 75.78534577000005],
              [-106.75401770699995, 75.79584381700005],
              [-106.6148168609999, 75.80093008000006],
              [-106.66417395699995, 75.81439850500004],
              [-106.86229407499991, 75.82562897300005],
              [-106.88589433499993, 75.83820221600007],
              [-106.89102128799993, 75.85846588700008],
              [-106.87144934799994, 75.88593170800004],
              [-106.86856035099993, 75.90265534100007],
              [-106.88231360599991, 75.92059967700004],
              [-106.8914281889999, 75.94110748900005],
              [-106.87486731699994, 75.96539948100008],
              [-106.84129798099991, 75.98212311400005],
              [-106.71865800699993, 76.01508209800005],
              [-106.70099850199995, 76.02313873900005],
              [-106.65542558499993, 76.05072663000004],
              [-106.63174394399994, 76.05853913000004],
              [-106.60684160099993, 76.06159088700008],
              [-106.33983313699991, 76.06159088700008],
              [-106.04987545499992, 76.02588532100006],
              [-105.75991777299993, 75.99017975500004],
              [-105.60680091099994, 75.93744538000004],
              [-105.51183020699995, 75.89057038000004],
              [-105.46654212099992, 75.85773346600007],
              [-105.4429418609999, 75.82135651200008],
              [-105.46344967399995, 75.80121491100005],
              [-105.4571020169999, 75.78237539300005],
              [-105.42243404899995, 75.74567291900007],
              [-105.46336829299992, 75.73261139500005],
              [-105.44196529899995, 75.72573476800005],
              [-105.41974850199995, 75.71173737200007],
              [-105.40221106699994, 75.69358958500004],
              [-105.39513098899994, 75.67426178600005],
            ],
          ],
          [
            [
              [-114.83702551999994, 76.75983307500007],
              [-114.84463456899994, 76.76512278900003],
              [-114.8667699859999, 76.76268138200004],
              [-114.87857011599993, 76.76727936400005],
              [-114.85875403599994, 76.80145905200004],
              [-114.84048417899993, 76.80939362200007],
              [-114.63158118399991, 76.86163971600007],
              [-114.43455969999991, 76.88239166900007],
              [-114.2371313139999, 76.87909577000005],
              [-114.19273841099994, 76.89081452000005],
              [-113.84605872299994, 76.89887116100005],
              [-113.73403886599993, 76.88336823100008],
              [-113.58633378799993, 76.84662506700005],
              [-113.53612219999991, 76.84235260600008],
              [-113.51036536399994, 76.83633047100005],
              [-113.48428300699993, 76.82037995000007],
              [-113.46349036399994, 76.79824453300006],
              [-113.45348059799994, 76.77350495000007],
              [-113.48851477799991, 76.76776764500005],
              [-113.55654863199993, 76.73916250200006],
              [-113.60464433499993, 76.72870514500005],
              [-113.63609778599994, 76.71084219000005],
              [-113.65217037699995, 76.70526764500005],
              [-113.6731664699999, 76.70425039300005],
              [-113.83055579299992, 76.72553131700005],
              [-114.1262507799999, 76.72760651250005],
              [-114.4219457669999, 76.72968170800004],
              [-114.51065019399994, 76.74481842700004],
              [-114.81777910099993, 76.75983307500007],
              [-114.83702551999994, 76.75983307500007],
            ],
          ],
          [
            [
              [-79.56017005099994, 74.99152252800008],
              [-79.53917395699995, 74.97662995000007],
              [-79.48875891799992, 74.95612213700008],
              [-79.43932044199994, 74.92304108300004],
              [-79.33429928299995, 74.90338776200008],
              [-79.35631262899994, 74.88556549700007],
              [-79.39517167899993, 74.87628815300008],
              [-79.81578528599994, 74.83535390800006],
              [-79.87515214799993, 74.81732819200005],
              [-79.90904700399994, 74.81395091400003],
              [-79.94758053299995, 74.81753164300005],
              [-80.15770423099991, 74.85944245000007],
              [-80.16673743399991, 74.86334870000007],
              [-80.17048092399995, 74.86823151200008],
              [-80.16974850199995, 74.87543366100005],
              [-80.15941321499992, 74.89061107000003],
              [-80.14696204299992, 74.90517812700006],
              [-80.14586341099994, 74.92023346600007],
              [-80.16974850199995, 74.93691640800006],
              [-80.1966039699999, 74.94342682500007],
              [-80.20547441299993, 74.93451569200005],
              [-80.20164954299992, 74.91657135600008],
              [-80.19017493399991, 74.89594147300005],
              [-80.23839270699995, 74.87787506700005],
              [-80.26203365799995, 74.87938060100004],
              [-80.2864477199999, 74.89594147300005],
              [-80.27961178299995, 74.89594147300005],
              [-80.29234778599994, 74.91644928600005],
              [-80.30020097599993, 74.93374258000006],
              [-80.31314042899993, 74.94155508000006],
              [-80.39940344999991, 74.91425202000005],
              [-80.41055253799993, 74.90180084800005],
              [-80.38878333199995, 74.88287995000007],
              [-80.3555395169999, 74.87026601800005],
              [-80.10081946499992, 74.82762278900003],
              [-80.10081946499992, 74.82078685100004],
              [-80.10802161399994, 74.82037995000007],
              [-80.11278235599991, 74.81875234600005],
              [-80.12254798099991, 74.81395091400003],
              [-80.11676998599995, 74.80931224200003],
              [-80.10667883999992, 74.79808177300004],
              [-80.10081946499992, 74.79352448100008],
              [-80.13536536399994, 74.78290436400005],
              [-80.21548417899993, 74.77505117400005],
              [-80.2454320949999, 74.75873444200005],
              [-80.1531469389999, 74.73285553600005],
              [-80.12877356699994, 74.71775950700004],
              [-80.1531469389999, 74.70628489800004],
              [-80.18203691299993, 74.70331452000005],
              [-80.20474199099993, 74.69733307500007],
              [-80.21068274599992, 74.67682526200008],
              [-80.18545488199993, 74.66543203300006],
              [-80.1765844389999, 74.66315338700008],
              [-80.18285071499992, 74.65851471600007],
              [-80.19701087099992, 74.64264557500007],
              [-80.15623938699991, 74.63686758000006],
              [-80.16173255099994, 74.62376536700003],
              [-80.19359290299991, 74.60984935100004],
              [-80.23180091099994, 74.60175202000005],
              [-80.21751868399991, 74.58746979400007],
              [-80.26504472599993, 74.57786692900004],
              [-80.42275956899994, 74.58746979400007],
              [-80.44749915299991, 74.58612702000005],
              [-80.46979732999995, 74.58242422100005],
              [-80.51382402299993, 74.56891510600008],
              [-80.54185950399994, 74.56354401200008],
              [-80.82860266799995, 74.57123444200008],
              [-81.11534583199995, 74.57892487200007],
              [-81.32022050699993, 74.56183502800008],
              [-81.43781490799995, 74.52602773600006],
              [-81.50999915299991, 74.51780833500004],
              [-81.56139075399994, 74.50136953300006],
              [-81.62214107999995, 74.50088125200006],
              [-81.73839270699995, 74.46621328300006],
              [-81.78868567599994, 74.45840078300006],
              [-81.8469945949999, 74.46572500200006],
              [-81.88451087099992, 74.46369049700007],
              [-81.97052975199995, 74.47679271000004],
              [-82.06798255099994, 74.47711823100008],
              [-82.19570878799993, 74.50031159100007],
              [-82.22618567599994, 74.51007721600007],
              [-82.42170162699995, 74.51833730700008],
              [-82.42162024599992, 74.52073802300004],
              [-82.40265865799995, 74.52529531500005],
              [-82.38841712099992, 74.53359609600005],
              [-82.38304602799991, 74.54645416900007],
              [-82.39509029899995, 74.56452057500007],
              [-82.42149817599994, 74.57269928600005],
              [-82.45091712099992, 74.57135651200008],
              [-82.47183183499993, 74.56073639500005],
              [-82.46812903599994, 74.55914948100008],
              [-82.45815995999993, 74.55329010600008],
              [-82.4641820949999, 74.54759349200003],
              [-82.47085527299993, 74.54336172100005],
              [-82.4793188139999, 74.53900788000004],
              [-82.57412675699993, 74.51532623900005],
              [-82.60619055899991, 74.51235586100006],
              [-82.64268958199995, 74.51593659100007],
              [-82.67943274599992, 74.52435944200005],
              [-82.69981848899994, 74.52667877800008],
              [-82.74058997299994, 74.52195872600004],
              [-82.9199926419999, 74.55149974200003],
              [-82.95067298099991, 74.56391022300005],
              [-83.08495032499991, 74.63849518400008],
              [-83.1172582669999, 74.66937897300005],
              [-83.13044186099995, 74.70783112200007],
              [-83.12669837099992, 74.72052643400008],
              [-83.11774654899995, 74.73749420800004],
              [-83.10631262899994, 74.75238678600005],
              [-83.09561113199993, 74.75873444200005],
              [-83.05968176999994, 74.76414622600004],
              [-83.03750566299993, 74.77610911700003],
              [-83.0410863919999, 74.78807200700004],
              [-83.08193925699993, 74.79352448100008],
              [-83.07848059799994, 74.81582265800006],
              [-83.09878495999993, 74.82807038000004],
              [-83.12828528599994, 74.83209870000007],
              [-83.18927975199995, 74.82428620000007],
              [-83.35879472599993, 74.85635000200006],
              [-83.42479407499991, 74.88711172100005],
              [-83.49168860599991, 74.90949127800008],
              [-83.55459550699993, 74.89964427300004],
              [-83.56248938699991, 74.89232005400004],
              [-83.56017005099994, 74.88662344000005],
              [-83.55345618399991, 74.88133372600004],
              [-83.52391516799992, 74.84442780200004],
              [-83.5020238919999, 74.83002350500004],
              [-83.47085527299993, 74.81712474200003],
              [-83.41152910099993, 74.79975006700005],
              [-83.35570227799991, 74.79157135600008],
              [-83.33193925699993, 74.78192780200004],
              [-83.32217363199993, 74.76215241100005],
              [-83.33116614499994, 74.74721914300005],
              [-83.39110266799992, 74.70408763200004],
              [-83.38365637899994, 74.69733307500007],
              [-83.39598548099991, 74.68414948100008],
              [-83.42931067599994, 74.67377350500004],
              [-83.44566809799994, 74.66315338700008],
              [-83.4383031889999, 74.65631745000007],
              [-83.45702063699991, 74.63190338700008],
              [-83.46324622299994, 74.61200592700004],
              [-83.47085527299993, 74.59467194200005],
              [-83.49351966099994, 74.57782623900005],
              [-83.51463782499991, 74.57111237200007],
              [-83.5606176419999, 74.56468333500004],
              [-83.6004125639999, 74.54950592700004],
              [-83.62035071499992, 74.54555898600006],
              [-83.64098059799994, 74.54555898600006],
              [-83.68565833199995, 74.55442942900004],
              [-84.04393469999991, 74.54315827000005],
              [-84.14622962099992, 74.51801178600005],
              [-84.25829016799992, 74.50649648600006],
              [-84.50047766799992, 74.51284414300005],
              [-84.61286373599995, 74.50291575700004],
              [-84.63805091099994, 74.50897858300004],
              [-84.65729732999995, 74.51764557500007],
              [-84.67642167899993, 74.52374909100007],
              [-84.69676673099991, 74.52667877800008],
              [-84.74327551999994, 74.52334219000005],
              [-84.84365800699993, 74.50478750200006],
              [-84.9148656889999, 74.51235586100006],
              [-84.92096920499995, 74.51630280200004],
              [-84.92894446499992, 74.52545807500007],
              [-84.93602454299992, 74.53558991100005],
              [-84.94570878799993, 74.55560944200005],
              [-84.96084550699993, 74.56146881700005],
              [-84.97716223899994, 74.56582265800006],
              [-84.98745683499993, 74.57440827000005],
              [-84.98778235599991, 74.58429596600007],
              [-84.97679602799991, 74.60162995000007],
              [-84.97386633999992, 74.61163971600007],
              [-84.97614498599995, 74.62221914300005],
              [-84.99437415299991, 74.64887116100005],
              [-84.96165930899991, 74.66290924700007],
              [-84.95718339799993, 74.68109772300005],
              [-84.97476152299993, 74.69696686400005],
              [-85.00796464799993, 74.70408763200004],
              [-85.00157630099994, 74.68256256700005],
              [-85.02090410099993, 74.66958242400005],
              [-85.0508520169999, 74.65839264500005],
              [-85.0762426419999, 74.64264557500007],
              [-85.05565344999991, 74.63051992400005],
              [-85.04906165299991, 74.62018463700008],
              [-85.05272376199991, 74.60724518400008],
              [-85.06261145699995, 74.58746979400007],
              [-85.05516516799992, 74.58372630400004],
              [-85.05068925699993, 74.57982005400004],
              [-85.04271399599992, 74.56696198100008],
              [-85.04645748599995, 74.56561920800004],
              [-85.05577551999994, 74.56073639500005],
              [-85.05040442599994, 74.55573151200008],
              [-85.04088294199994, 74.54389069200005],
              [-85.03526770699995, 74.53900788000004],
              [-85.07140051999994, 74.51312897300005],
              [-85.12596594999991, 74.49900950700004],
              [-85.18492591099994, 74.49310944200005],
              [-85.3328344389999, 74.49599844000005],
              [-85.35741126199991, 74.50556061400005],
              [-85.36758378799993, 74.51723867400005],
              [-85.3660375639999, 74.52505117400005],
              [-85.36168372299994, 74.53327057500007],
              [-85.36363684799994, 74.54645416900007],
              [-85.37621008999992, 74.56037018400008],
              [-85.41258704299992, 74.57786692900004],
              [-85.42634029899995, 74.58746979400007],
              [-85.46979732999995, 74.66282786700003],
              [-85.48029537699995, 74.67426178600005],
              [-85.49461829299992, 74.68366120000007],
              [-85.5125219389999, 74.68870677300004],
              [-85.53368079299992, 74.69009023600006],
              [-85.54564368399991, 74.68500397300005],
              [-85.53555253799993, 74.67059967700004],
              [-85.54084225199995, 74.66913483300004],
              [-85.55040442599994, 74.66478099200003],
              [-85.5554906889999, 74.66315338700008],
              [-85.53624426999994, 74.65761953300006],
              [-85.53038489499994, 74.64647044500003],
              [-85.53042558499993, 74.63178131700005],
              [-85.52871660099993, 74.61542389500005],
              [-85.52257239499994, 74.60122304900005],
              [-85.48493404899995, 74.55390045800004],
              [-85.48228919199994, 74.54535553600005],
              [-85.48916581899994, 74.53729889500005],
              [-85.53026282499991, 74.51569245000007],
              [-85.55426998599995, 74.50747304900005],
              [-85.60387122299994, 74.49803294500003],
              [-85.86424719949994, 74.49119700750003],
              [-86.12462317599994, 74.48436107000003],
              [-86.08259029899995, 74.53742096600007],
              [-86.08018958199995, 74.54987213700008],
              [-86.1035863919999, 74.56525299700007],
              [-86.15599524599992, 74.58112213700008],
              [-86.17926998599995, 74.59422435100004],
              [-86.16038977799991, 74.59955475500004],
              [-86.15379798099991, 74.60789622600004],
              [-86.15998287699995, 74.61644114800004],
              [-86.17926998599995, 74.62221914300005],
              [-86.20059160099993, 74.62107982000003],
              [-86.22398841099994, 74.61391836100006],
              [-86.23790442599994, 74.60138580900008],
              [-86.23106848899994, 74.58437734600005],
              [-86.22398841099994, 74.55512116100005],
              [-86.25133216099994, 74.52838776200008],
              [-86.28990637899994, 74.50804271000004],
              [-86.31639563699991, 74.49803294500003],
              [-86.38003495999993, 74.48749420800004],
              [-86.44082597599993, 74.48981354400007],
              [-86.6614477199999, 74.53754303600005],
              [-86.71076412699995, 74.55857982000003],
              [-86.72105872299994, 74.58124420800004],
              [-86.74176998599995, 74.58128489800004],
              [-86.75694739499994, 74.58746979400007],
              [-86.76121985599991, 74.59906647300005],
              [-86.74901282499991, 74.61542389500005],
              [-86.76183020699995, 74.61933014500005],
              [-86.77529863199993, 74.62181224200003],
              [-86.7891332669999, 74.62287018400008],
              [-86.80304928299995, 74.62221914300005],
              [-86.80304928299995, 74.61542389500005],
              [-86.79185950399994, 74.59870026200008],
              [-86.7981664699999, 74.57298411700003],
              [-86.80101477799991, 74.54938385600008],
              [-86.77940833199995, 74.53900788000004],
              [-86.73631751199991, 74.52871328300006],
              [-86.65013587099992, 74.48529694200005],
              [-86.60374915299991, 74.47821686400005],
              [-86.60374915299991, 74.47138092700004],
              [-86.91104081899994, 74.46454498900005],
              [-86.93659420499995, 74.46767812700006],
              [-87.00226803299995, 74.49803294500003],
              [-87.00597083199995, 74.50336334800005],
              [-87.00804602799991, 74.51032135600008],
              [-87.01406816299993, 74.51398346600007],
              [-87.02961178299995, 74.50897858300004],
              [-87.03921464799993, 74.50234609600005],
              [-87.04206295499995, 74.49599844000005],
              [-87.03856360599991, 74.48993561400005],
              [-87.02961178299995, 74.48436107000003],
              [-87.04991614499994, 74.47736237200007],
              [-87.07225501199991, 74.47345612200007],
              [-87.11831620999993, 74.47138092700004],
              [-87.11148027299993, 74.47138092700004],
              [-87.25926673099991, 74.46816640800006],
              [-87.33470618399991, 74.48309967700004],
              [-87.37279212099992, 74.52602773600006],
              [-87.33193925699993, 74.52997467700004],
              [-87.31208248599995, 74.53579336100006],
              [-87.29649817599994, 74.54645416900007],
              [-87.36864173099991, 74.54486725500004],
              [-87.40265865799995, 74.53709544500003],
              [-87.43301347599993, 74.51976146000004],
              [-87.43956458199995, 74.51105377800008],
              [-87.44627844999991, 74.49921295800004],
              [-87.45425370999993, 74.48891836100006],
              [-87.46434485599991, 74.48436107000003],
              [-87.55036373599995, 74.47138092700004],
              [-87.54283606699994, 74.47138092700004],
              [-87.64362545499995, 74.45831940300008],
              [-87.69920813699991, 74.45978424700007],
              [-87.73839270699995, 74.47479889500005],
              [-87.74844316299993, 74.48407623900005],
              [-87.75112870999993, 74.48871491100005],
              [-87.74893144399994, 74.50897858300004],
              [-87.75576738199993, 74.51992422100005],
              [-87.77163652299993, 74.51898834800005],
              [-87.84105383999992, 74.49013906500005],
              [-87.87734941299993, 74.48187897300005],
              [-88.06041419199994, 74.47736237200007],
              [-88.11290442599994, 74.48493073100008],
              [-88.15298417899993, 74.50556061400005],
              [-88.14671790299991, 74.50926341400003],
              [-88.14915930899991, 74.51190827000005],
              [-88.16978919199994, 74.50507233300004],
              [-88.2097875639999, 74.48639557500007],
              [-88.24205481699994, 74.48139069200005],
              [-88.51781165299991, 74.50120677300004],
              [-88.53457597599993, 74.50918203300006],
              [-88.54751542899993, 74.52167389500005],
              [-88.55768795499995, 74.53900788000004],
              [-88.56480872299994, 74.55487702000005],
              [-88.56688391799992, 74.56443919500003],
              [-88.56436113199993, 74.57343170800004],
              [-88.54417883999992, 74.61603424700007],
              [-88.53246008999992, 74.62995026200008],
              [-88.5164281889999, 74.63589101800005],
              [-88.50523841099994, 74.64166901200008],
              [-88.47500566299993, 74.67007070500006],
              [-88.44701087099992, 74.68927643400008],
              [-88.43443762899994, 74.70111725500004],
              [-88.42857825399994, 74.71381256700005],
              [-88.43419348899994, 74.72528717700004],
              [-88.42369544199994, 74.72760651200008],
              [-88.41559811099995, 74.73118724200003],
              [-88.41169186099995, 74.73676178600005],
              [-88.41368567599994, 74.74510325700004],
              [-88.40762285099993, 74.75275299700007],
              [-88.41177324099993, 74.75897858300004],
              [-88.43419348899994, 74.76557038000004],
              [-88.29698645699995, 74.77301666900007],
              [-88.29698645699995, 74.77985260600008],
              [-88.32087154899995, 74.78571198100008],
              [-88.43761145699995, 74.78607819200005],
              [-88.45030676999994, 74.78754303600005],
              [-88.47524980399993, 74.79328034100007],
              [-88.48884029899995, 74.79352448100008],
              [-88.48350989499994, 74.80735911700003],
              [-88.47496497299994, 74.81972890800006],
              [-88.46304277299993, 74.82925039300005],
              [-88.44782467399995, 74.83441803600005],
              [-88.45995032499991, 74.84735748900005],
              [-88.52830969999991, 74.89891185100004],
              [-88.53945878799993, 74.90375397300005],
              [-88.57477779899995, 74.90338776200008],
              [-88.57876542899993, 74.89606354400007],
              [-88.56725012899994, 74.87995026200008],
              [-88.54405676999994, 74.85496653900003],
              [-88.55492102799991, 74.84088776200008],
              [-88.57827714799993, 74.83063385600008],
              [-88.61913001199991, 74.82078685100004],
              [-88.61481686099995, 74.83014557500007],
              [-88.61432857999995, 74.83966705900008],
              [-88.6179906889999, 74.84833405200004],
              [-88.62596594999991, 74.85496653900003],
              [-88.64671790299991, 74.85911692900004],
              [-88.66128495999993, 74.85154857000003],
              [-88.68374589799993, 74.82318756700005],
              [-88.68565833199995, 74.81842682500007],
              [-88.68854732999995, 74.81317780200004],
              [-88.69489498599995, 74.80719635600008],
              [-88.70531165299991, 74.80206940300008],
              [-88.7259008449999, 74.79816315300008],
              [-88.73582923099991, 74.79352448100008],
              [-88.74449622299994, 74.78595612200007],
              [-88.75255286399994, 74.77562083500004],
              [-88.75649980399993, 74.76487864800004],
              [-88.75291907499991, 74.75560130400004],
              [-88.74730383999992, 74.73505280200004],
              [-88.76455644399994, 74.71552155200004],
              [-88.8047582669999, 74.69049713700008],
              [-88.81883704299992, 74.67885976800005],
              [-88.83202063699991, 74.67031484600005],
              [-88.84764563699991, 74.66498444200005],
              [-88.86929277299993, 74.66315338700008],
              [-88.88463294199994, 74.66673411700003],
              [-88.89061438699991, 74.67499420800004],
              [-88.88841712099992, 74.68423086100006],
              [-88.87922115799995, 74.69049713700008],
              [-88.88634192599994, 74.69867584800005],
              [-88.90607662699995, 74.71027252800008],
              [-88.91397050699993, 74.71775950700004],
              [-88.91820227799991, 74.72671133000006],
              [-88.91763261599993, 74.73191966400003],
              [-88.91527258999992, 74.73525625200006],
              [-88.91397050699993, 74.73826732000003],
              [-88.91270911399994, 74.75486888200004],
              [-88.90982011599993, 74.76601797100005],
              [-88.91079667899993, 74.77521393400008],
              [-88.92076575399994, 74.78607819200005],
              [-88.94041907499991, 74.79523346600007],
              [-89.01699785099993, 74.81395091400003],
              [-89.07738196499992, 74.83657461100006],
              [-89.0989477199999, 74.84072500200006],
              [-89.08470618399991, 74.81989166900007],
              [-89.06248938699991, 74.80243561400005],
              [-89.03628495999993, 74.79043203300006],
              [-89.01016191299993, 74.78607819200005],
              [-89.0391332669999, 74.74066803600005],
              [-89.06029212099992, 74.72223541900007],
              [-89.08372962099992, 74.71971263200004],
              [-89.10802161399994, 74.72606028900003],
              [-89.15770423099991, 74.73289622600004],
              [-89.2442113919999, 74.75665924700007],
              [-89.27025305899991, 74.75873444200005],
              [-89.25194251199991, 74.75096263200004],
              [-89.20881100199995, 74.72150299700007],
              [-89.11363684799994, 74.69725169500003],
              [-89.0989477199999, 74.68707916900007],
              [-89.10448157499991, 74.66705963700008],
              [-89.11778723899994, 74.64297109600005],
              [-89.13369706899994, 74.62103913000004],
              [-89.14736894399994, 74.60789622600004],
              [-89.19591223899994, 74.58881256700005],
              [-89.2481176419999, 74.58348216400003],
              [-89.38182532499991, 74.58771393400008],
              [-89.3933813139999, 74.58510976800005],
              [-89.40396074099993, 74.57782623900005],
              [-89.41470292899993, 74.56171295800004],
              [-89.42174231699994, 74.55573151200008],
              [-89.43443762899994, 74.55329010600008],
              [-89.57811438699991, 74.54645416900007],
              [-89.57127844999991, 74.55329010600008],
              [-89.59569251199991, 74.55801015800006],
              [-89.61913001199991, 74.55532461100006],
              [-89.66771399599992, 74.54096100500004],
              [-89.70116126199991, 74.53595612200007],
              [-89.80809485599991, 74.53900788000004],
              [-89.91852779899995, 74.52728913000004],
              [-89.94863847599993, 74.53278229400007],
              [-89.9602758449999, 74.54409414300005],
              [-89.97402910099993, 74.57489655200004],
              [-89.98277747299994, 74.58437734600005],
              [-90.00865637899994, 74.59064362200007],
              [-90.03001868399991, 74.58661530200004],
              [-90.06476803299995, 74.56696198100008],
              [-90.08820553299995, 74.55744049700007],
              [-90.11074785099993, 74.55467357000003],
              [-90.37319902299993, 74.60175202000005],
              [-90.32437089799993, 74.61835358300004],
              [-90.31175696499992, 74.62905508000006],
              [-90.47297115799995, 74.60492584800005],
              [-90.5637914699999, 74.60858795800004],
              [-90.70132402299993, 74.64614492400005],
              [-90.73009192599994, 74.66315338700008],
              [-90.73875891799992, 74.67621491100005],
              [-90.74356035099993, 74.69114817900004],
              [-90.7500707669999, 74.70575592700004],
              [-90.76366126199991, 74.71775950700004],
              [-90.73741614499994, 74.72284577000005],
              [-90.72740637899994, 74.72776927300004],
              [-90.72329667899993, 74.73826732000003],
              [-90.7332250639999, 74.73639557500007],
              [-90.74144446499992, 74.73602936400005],
              [-90.75682532499991, 74.73826732000003],
              [-90.77318274599992, 74.73114655200004],
              [-90.82310950399994, 74.72955963700008],
              [-90.84618079299992, 74.72528717700004],
              [-90.85643469999991, 74.71893952000005],
              [-90.86318925699993, 74.71116771000004],
              [-90.8684789699999, 74.70343659100007],
              [-90.87413489499994, 74.69733307500007],
              [-90.90550696499992, 74.68695709800005],
              [-90.94627844999991, 74.68842194200005],
              [-91.0249731109999, 74.70408763200004],
              [-90.99229895699995, 74.73834870000007],
              [-90.8941137359999, 74.76089101800005],
              [-90.84959876199991, 74.78294505400004],
              [-90.81480872299994, 74.81736888200004],
              [-90.80296790299991, 74.82306549700007],
              [-90.76968339799993, 74.82859935100004],
              [-90.75682532499991, 74.83441803600005],
              [-90.74714107999995, 74.85065338700008],
              [-90.75169837099992, 74.86343008000006],
              [-90.75885982999995, 74.87384674700007],
              [-90.75682532499991, 74.88287995000007],
              [-90.77131100199995, 74.88792552300004],
              [-90.78677324099993, 74.88963450700004],
              [-90.81822669199994, 74.88910553600005],
              [-90.81143144399994, 74.88910553600005],
              [-90.84129798099991, 74.88214752800008],
              [-90.86180579299992, 74.87051015800006],
              [-90.90143795499995, 74.84072500200006],
              [-91.09943600199995, 74.75250885600008],
              [-91.12047278599994, 74.74868398600006],
              [-91.13646399599992, 74.75136953300006],
              [-91.15151933499993, 74.75625234600005],
              [-91.17015540299991, 74.75873444200005],
              [-91.18285071499992, 74.75665924700007],
              [-91.22109941299993, 74.74469635600008],
              [-91.23037675699993, 74.73826732000003],
              [-91.22777258999992, 74.72479889500005],
              [-91.21349036399994, 74.71751536700003],
              [-91.19562740799995, 74.71210358300004],
              [-91.18199622299994, 74.70408763200004],
              [-91.18150794199994, 74.68720123900005],
              [-91.11904863199993, 74.64874909100007],
              [-91.09943600199995, 74.62905508000006],
              [-91.28563391799992, 74.63589101800005],
              [-91.27818762899994, 74.64264557500007],
              [-91.30483964799993, 74.66315338700008],
              [-91.28209387899994, 74.67869700700004],
              [-91.29527747299994, 74.70522695500006],
              [-91.33043372299994, 74.72093333500004],
              [-91.37376868399991, 74.70408763200004],
              [-91.35057532499991, 74.69830963700008],
              [-91.33946692599994, 74.68878815300008],
              [-91.3386938139999, 74.67670319200005],
              [-91.3465063139999, 74.66315338700008],
              [-91.3684789699999, 74.64858633000006],
              [-91.39712480399993, 74.64280833500004],
              [-91.51349850199995, 74.64472077000005],
              [-91.63499915299991, 74.66498444200005],
              [-91.68907630099994, 74.68366120000007],
              [-91.67345130099994, 74.69009023600006],
              [-91.63292395699995, 74.70014069200005],
              [-91.62083899599992, 74.71161530200004],
              [-91.66600501199991, 74.72675202000005],
              [-91.71458899599992, 74.73139069200005],
              [-91.81261145699995, 74.72528717700004],
              [-91.80060787699995, 74.70701732000003],
              [-91.82103430899991, 74.70172760600008],
              [-91.85435950399994, 74.70482005400004],
              [-91.88084876199991, 74.71161530200004],
              [-91.86449133999992, 74.72378164300005],
              [-91.80577551999994, 74.73826732000003],
              [-91.86042232999995, 74.75250885600008],
              [-91.86042232999995, 74.74510325700004],
              [-91.90941321499992, 74.75897858300004],
              [-92.01846269399994, 74.77749258000006],
              [-92.06273352799991, 74.80341217700004],
              [-92.06602942599994, 74.81610748900005],
              [-92.05650794199994, 74.82855866100005],
              [-92.03164628799993, 74.84813060100004],
              [-92.02489173099991, 74.85195547100005],
              [-92.01846269399994, 74.85236237200007],
              [-92.0137426419999, 74.85504791900007],
              [-92.01183020699995, 74.86554596600007],
              [-92.01146399599992, 74.87323639500005],
              [-92.01032467399995, 74.87836334800005],
              [-92.00438391799992, 74.88910553600005],
              [-92.01162675699993, 74.89720286700003],
              [-92.01402747299994, 74.90176015800006],
              [-92.01341712099992, 74.90501536700003],
              [-92.01183020699995, 74.90961334800005],
              [-92.02570553299995, 74.92182038000004],
              [-92.04279537699995, 74.92829010600008],
              [-92.07945716099994, 74.93691640800006],
              [-92.04865475199995, 74.94818756700005],
              [-92.06114661399994, 74.96283600500004],
              [-92.1953832669999, 75.02448151200008],
              [-92.22411048099991, 75.03245677300004],
              [-92.22411048099991, 75.03994375200006],
              [-92.2102758449999, 75.04108307500007],
              [-92.20299231699994, 75.04669830900008],
              [-92.20079505099994, 75.05573151200008],
              [-92.20238196499992, 75.06728750200006],
              [-92.21743730399993, 75.06712474200003],
              [-92.22712154899995, 75.06854889500005],
              [-92.23033606699994, 75.07404205900008],
              [-92.22411048099991, 75.08104075700004],
              [-92.21336829299992, 75.08222077000005],
              [-92.20164954299992, 75.08185455900008],
              [-92.15477454299992, 75.09662506700005],
              [-92.05386308499993, 75.08783600500004],
              [-92.01183020699995, 75.10138580900008],
              [-92.09203040299991, 75.12156810100004],
              [-92.11424719999991, 75.13613515800006],
              [-92.05947831899994, 75.14647044500003],
              [-92.05589758999992, 75.15322500200006],
              [-92.07396399599992, 75.15973541900007],
              [-92.23839270699995, 75.14057038000004],
              [-92.28229732999995, 75.14081452000005],
              [-92.32652747299994, 75.14980703300006],
              [-92.32591712099992, 75.16620514500005],
              [-92.34264075399994, 75.17177969000005],
              [-92.36685136599993, 75.17304108300004],
              [-92.38857988199993, 75.17715078300006],
              [-92.38565019399994, 75.18097565300008],
              [-92.38109290299991, 75.19074127800008],
              [-92.41246497299994, 75.19399648600006],
              [-92.47207597599993, 75.21531810100004],
              [-92.50401770699995, 75.21800364800004],
              [-92.49518795499995, 75.22947825700004],
              [-92.46617591099994, 75.24184804900005],
              [-92.45685787699995, 75.25218333500004],
              [-92.45693925699993, 75.26447174700007],
              [-92.46202551999994, 75.27728913000004],
              [-92.47052975199995, 75.29315827000005],
              [-92.44078528599994, 75.33038971600007],
              [-92.42894446499992, 75.34153880400004],
              [-92.40599524599992, 75.35309479400007],
              [-92.35240637899994, 75.36542389500005],
              [-92.32652747299994, 75.37567780200004],
              [-92.3594457669999, 75.37954336100006],
              [-92.43252519399994, 75.37177155200004],
              [-92.46304277299993, 75.37567780200004],
              [-92.38076738199993, 75.45612213700008],
              [-92.30003821499992, 75.51251862200007],
              [-92.25682532499991, 75.52521393400008],
              [-92.23778235599991, 75.53339264500005],
              [-92.21104895699995, 75.55036041900007],
              [-92.19579016799992, 75.55670807500007],
              [-92.08625240799995, 75.57070547100005],
              [-92.04369055899991, 75.58161041900007],
              [-92.00438391799992, 75.60162995000007],
              [-92.02456620999993, 75.60944245000007],
              [-92.07144120999993, 75.61871979400007],
              [-92.07945716099994, 75.62897370000007],
              [-92.06969153599994, 75.63959381700005],
              [-92.01183020699995, 75.66372304900005],
              [-92.02977454299992, 75.66966380400004],
              [-92.04531816299993, 75.67796458500004],
              [-92.05768795499995, 75.69334544500003],
              [-92.15306555899991, 75.72939687700006],
              [-92.17568925699993, 75.75250885600008],
              [-92.17015540299991, 75.75926341400003],
              [-92.12100175699993, 75.79254791900007],
              [-92.1113988919999, 75.80267975500004],
              [-92.10472571499992, 75.81452057500007],
              [-92.09996497299994, 75.82880280200004],
              [-92.11644446499992, 75.86237213700008],
              [-92.12682044199994, 75.87384674700007],
              [-92.14834550699993, 75.88593170800004],
              [-92.18455969999991, 75.89492422100005],
              [-92.26667232999995, 75.89789459800005],
              [-92.41283118399991, 75.92645905200004],
              [-92.43980872299994, 75.94086334800005],
              [-92.45250403599994, 75.95770905200004],
              [-92.46117102799991, 75.96320221600007],
              [-92.4773656889999, 75.96539948100008],
              [-92.51329505099994, 75.96556224200003],
              [-92.53026282499991, 75.96930573100008],
              [-92.54564368399991, 75.97842031500005],
              [-92.54161536399994, 75.99030182500007],
              [-92.5542699859999, 76.00153229400007],
              [-92.57469641799992, 76.00991445500006],
              [-92.59406490799995, 76.01312897300005],
              [-92.61974036399994, 76.01459381700005],
              [-92.62979081899994, 76.02033112200007],
              [-92.63560950399994, 76.05414459800005],
              [-92.63833574099993, 76.06073639500005],
              [-92.64683997299994, 76.07591380400004],
              [-92.64867102799991, 76.08148834800005],
              [-92.64635169199994, 76.08624909100007],
              [-92.6367895169999, 76.09723541900007],
              [-92.63560950399994, 76.10252513200004],
              [-92.64671790299991, 76.11994049700007],
              [-92.66612708199995, 76.13507721600007],
              [-92.68976803299995, 76.14569733300004],
              [-92.73631751199991, 76.15379466400003],
              [-92.75991777299993, 76.16486237200007],
              [-92.77839107999995, 76.18138255400004],
              [-92.78579667899993, 76.20156484600005],
              [-92.80093339799993, 76.21434153900003],
              [-92.83556067599994, 76.22382233300004],
              [-92.92747962099992, 76.23700592700004],
              [-93.00495357999995, 76.28001536700003],
              [-93.04845130099994, 76.29539622600004],
              [-93.06847083199995, 76.30634186400005],
              [-93.08067786399994, 76.32225169500003],
              [-93.07282467399995, 76.32461172100005],
              [-93.05272376199991, 76.33527252800008],
              [-93.05606035099993, 76.34031810100004],
              [-93.05923417899993, 76.34393952000005],
              [-93.06261145699995, 76.34662506700005],
              [-93.06639563699991, 76.34902578300006],
              [-93.06017005099994, 76.34902578300006],
              [-93.12832597599993, 76.37018463700008],
              [-93.20848548099991, 76.37547435100004],
              [-93.28990637899994, 76.36920807500007],
              [-93.59105383999992, 76.29970937700006],
              [-93.66974850199995, 76.30052317900004],
              [-93.65758216099994, 76.30589427300004],
              [-93.63316809799994, 76.31069570500006],
              [-93.62124589799993, 76.31484609600005],
              [-93.63491777299993, 76.32843659100007],
              [-93.6773168609999, 76.32705312700006],
              [-93.69737708199995, 76.32306549700007],
              [-93.71743730399993, 76.31484609600005],
              [-93.75328528599994, 76.29108307500007],
              [-93.76593990799995, 76.28685130400004],
              [-93.73460852799991, 76.27338288000004],
              [-93.66441809799994, 76.27020905200004],
              [-93.63491777299993, 76.25958893400008],
              [-93.70372473899994, 76.25153229400007],
              [-93.84268144399994, 76.26996491100005],
              [-93.94286048099991, 76.26113515800006],
              [-94.00841223899994, 76.26508209800005],
              [-94.06761633999992, 76.25942617400005],
              [-94.18639075399994, 76.28408437700006],
              [-94.60366777299993, 76.27374909100007],
              [-94.66344153599994, 76.28685130400004],
              [-94.64793860599991, 76.29291413000004],
              [-94.64232337099992, 76.29433828300006],
              [-94.66201738199993, 76.30524323100008],
              [-94.66958574099993, 76.30801015800006],
              [-94.66344153599994, 76.31484609600005],
              [-94.74909420499995, 76.31484609600005],
              [-94.75987708199995, 76.31069570500006],
              [-94.80028235599991, 76.28351471600007],
              [-94.84813391799992, 76.26923248900005],
              [-94.99917558499993, 76.25336334800005],
              [-95.0191137359999, 76.24502187700006],
              [-95.04206295499995, 76.23004791900007],
              [-95.06065833199995, 76.22540924700007],
              [-95.0867406889999, 76.22573476800005],
              [-95.16392981699994, 76.23908112200007],
              [-95.39024817599994, 76.23908112200007],
              [-95.38597571499992, 76.24819570500006],
              [-95.38442949099993, 76.25299713700008],
              [-95.38585364499994, 76.25779857000003],
              [-95.39024817599994, 76.26703522300005],
              [-95.3836156889999, 76.28351471600007],
              [-95.37450110599991, 76.29832591400003],
              [-95.35777747299994, 76.30512116100005],
              [-95.29019120999993, 76.28803131700005],
              [-95.0989477199999, 76.30719635600008],
              [-95.07494055899991, 76.31484609600005],
              [-95.07274329299992, 76.31850820500006],
              [-95.07506262899994, 76.32298411700003],
              [-95.0755102199999, 76.32684967700004],
              [-95.0313207669999, 76.33417389500005],
              [-94.88084876199991, 76.33397044500003],
              [-94.84154212099992, 76.32225169500003],
              [-94.8489477199999, 76.31932200700004],
              [-94.85399329299992, 76.31561920800004],
              [-94.86204993399991, 76.30801015800006],
              [-94.84341386599993, 76.30731842700004],
              [-94.82583574099993, 76.30914948100008],
              [-94.81094316299993, 76.31541575700004],
              [-94.80060787699995, 76.32843659100007],
              [-94.84117591099994, 76.34027741100005],
              [-95.12584387899994, 76.36749909100007],
              [-95.15684973899994, 76.35578034100007],
              [-95.17638098899994, 76.34955475500004],
              [-95.19737708199995, 76.35382721600007],
              [-95.23729407499991, 76.37140534100007],
              [-95.25251217399995, 76.37555573100008],
              [-95.26862545499995, 76.37775299700007],
              [-95.30089270699995, 76.37689850500004],
              [-95.31358801999994, 76.37425364800004],
              [-95.3418676419999, 76.36322663000004],
              [-95.39899654899995, 76.35785553600005],
              [-95.43236243399991, 76.36005280200004],
              [-95.45173092399995, 76.36945221600007],
              [-95.4466039699999, 76.38202545800004],
              [-95.42223059799994, 76.38861725500004],
              [-95.39370683499993, 76.39240143400008],
              [-95.37596594999991, 76.39671458500004],
              [-95.42052161399994, 76.40094635600008],
              [-95.55410722599993, 76.38312409100007],
              [-95.82331295499995, 76.39911530200004],
              [-95.8457738919999, 76.40420156500005],
              [-95.8946020169999, 76.42255280200004],
              [-95.97378495999993, 76.43593984600005],
              [-96.04116777299993, 76.46259186400005],
              [-96.10899817599994, 76.49974192900004],
              [-96.08193925699993, 76.51764557500007],
              [-96.05728105399993, 76.52399323100008],
              [-95.7945043609999, 76.52106354400007],
              [-95.75767981699994, 76.52732982000003],
              [-95.72179114499994, 76.53790924700007],
              [-95.60391191299993, 76.59479401200008],
              [-95.58824622299994, 76.60960521000004],
              [-95.62092037699995, 76.60765208500004],
              [-95.64830481699994, 76.60203685100004],
              [-95.75210527299993, 76.55947500200006],
              [-95.7840063139999, 76.55467357000003],
              [-95.80113684799994, 76.56122467700004],
              [-95.80113684799994, 76.56806061400005],
              [-95.82872473899994, 76.56854889500005],
              [-95.91714433499993, 76.55499909100007],
              [-96.02700761599993, 76.55499909100007],
              [-96.02220618399991, 76.56541575700004],
              [-96.01427161399994, 76.57298411700003],
              [-96.0039770169999, 76.57827383000006],
              [-95.99229895699995, 76.58173248900005],
              [-96.0286352199999, 76.58917877800008],
              [-96.1048070949999, 76.57953522300005],
              [-96.14224199099993, 76.58348216400003],
              [-96.16515051999994, 76.59271881700005],
              [-96.17349199099993, 76.59837474200003],
              [-96.18101966099994, 76.60590241100005],
              [-96.19448808499993, 76.61489492400005],
              [-96.24673417899993, 76.62270742400005],
              [-96.23924719999991, 76.62604401200008],
              [-96.22569739499994, 76.63694896000004],
              [-96.37242591099994, 76.63764069200005],
              [-96.41901607999995, 76.64866771000004],
              [-96.44847571499992, 76.66038646000004],
              [-96.46043860599991, 76.66925690300008],
              [-96.46524003799993, 76.68105703300006],
              [-96.47569739499994, 76.69049713700008],
              [-96.49962317599994, 76.69574616100005],
              [-96.68187415299991, 76.71173737200007],
              [-96.76695716099994, 76.69843170800004],
              [-96.87149003799993, 76.70319245000007],
              [-96.92516028599994, 76.71613190300008],
              [-96.96556555899991, 76.73940664300005],
              [-96.9356176419999, 76.74030182500007],
              [-96.90099036399994, 76.74677155200004],
              [-96.86790930899991, 76.75804271000004],
              [-96.84264075399994, 76.77350495000007],
              [-96.85985266799992, 76.77423737200007],
              [-96.8823949859999, 76.77798086100006],
              [-96.90038001199991, 76.78636302300004],
              [-96.90412350199995, 76.80145905200004],
              [-96.89049231699994, 76.81244538000004],
              [-96.86750240799995, 76.81366608300004],
              [-96.81602942599994, 76.80634186400005],
              [-96.79678300699993, 76.79718659100007],
              [-96.78742428299995, 76.79393138200004],
              [-96.77574622299994, 76.79319896000004],
              [-96.75182044199994, 76.79486725500004],
              [-96.74022376199991, 76.79393138200004],
              [-96.67756100199995, 76.77350495000007],
              [-96.69005286399994, 76.76337311400005],
              [-96.68195553299995, 76.75722890800006],
              [-96.66295325399994, 76.75413646000004],
              [-96.64342200399994, 76.75307851800005],
              [-96.57249915299991, 76.76723867400005],
              [-96.53563391799992, 76.77000560100004],
              [-96.50690670499995, 76.75983307500007],
              [-96.50690670499995, 76.76727936400005],
              [-96.40623938699991, 76.74673086100006],
              [-96.35049394399994, 76.74607982000003],
              [-96.30821692599994, 76.75983307500007],
              [-96.32469641799992, 76.76349518400008],
              [-96.37588456899994, 76.75983307500007],
              [-96.3926488919999, 76.76243724200003],
              [-96.42491614499994, 76.77155182500007],
              [-96.4949438139999, 76.78009674700007],
              [-96.51366126199991, 76.78034088700008],
              [-96.56493079299992, 76.77301666900007],
              [-96.58193925699993, 76.77350495000007],
              [-96.58193925699993, 76.78034088700008],
              [-96.56334387899994, 76.78436920800004],
              [-96.50690670499995, 76.78717682500007],
              [-96.50690670499995, 76.79393138200004],
              [-96.52672278599994, 76.80145905200004],
              [-96.5188695949999, 76.80597565300008],
              [-96.51146399599992, 76.80805084800005],
              [-96.49323482999995, 76.80829498900005],
              [-96.47891191299993, 76.80589427300004],
              [-96.45641028599994, 76.79612864800004],
              [-96.44542395699995, 76.79393138200004],
              [-96.34300696499992, 76.79865143400008],
              [-96.31444251199991, 76.80829498900005],
              [-96.59911048099991, 76.84080638200004],
              [-96.61611894399994, 76.84918854400007],
              [-96.68472245999993, 76.86676666900007],
              [-96.71202551999994, 76.86908600500004],
              [-96.7852270169999, 76.86627838700008],
              [-96.81956946499992, 76.87201569200005],
              [-96.85008704299992, 76.89081452000005],
              [-96.86611894399994, 76.91730377800008],
              [-96.8511449859999, 76.92963288000004],
              [-96.76976477799991, 76.94306061400005],
              [-96.71231035099993, 76.93862539300005],
              [-96.65770423099991, 76.95229726800005],
              [-96.69786536399994, 76.96474844000005],
              [-96.74136308499993, 76.97077057500007],
              [-96.82835852799991, 76.97280508000006],
              [-96.8184301419999, 76.98338450700004],
              [-96.80235755099994, 76.98696523600006],
              [-96.76695716099994, 76.98578522300005],
              [-96.77375240799995, 76.98578522300005],
              [-96.47956295499995, 76.97280508000006],
              [-96.48574785099993, 76.95913320500006],
              [-96.47297115799995, 76.95921458500004],
              [-96.46568762899994, 76.96312083500004],
              [-96.46007239499994, 76.96845123900005],
              [-96.45225989499994, 76.97280508000006],
              [-96.39810136599993, 76.98094310100004],
              [-96.37913977799991, 76.98944733300004],
              [-96.34976152299993, 76.99241771000004],
              [-96.30614173099991, 76.98655833500004],
              [-96.26695716099994, 76.98712799700007],
              [-96.24673417899993, 77.00629303600005],
              [-96.30821692599994, 77.00629303600005],
              [-96.30821692599994, 77.01365794500003],
              [-96.30138098899994, 77.01365794500003],
              [-96.32188880099994, 77.02431875200006],
              [-96.36782792899993, 77.02830638200004],
              [-96.3902074859999, 77.03424713700008],
              [-96.0012914699999, 77.05036041900007],
              [-95.8919164699999, 77.06976959800005],
              [-95.77074133999992, 77.07672760600008],
              [-95.66734778599994, 77.06256745000007],
              [-95.42373613199993, 77.06146881700005],
              [-95.40151933499993, 77.05744049700007],
              [-95.35631262899994, 77.04389069200005],
              [-95.31094316299993, 77.03774648600006],
              [-95.23875891799992, 77.01365794500003],
              [-95.19155839799993, 77.00405508000006],
              [-95.0027563139999, 76.99697500200006],
              [-94.95470130099994, 76.98273346600007],
              [-94.93032792899993, 76.97894928600005],
              [-94.50796464799993, 76.97117747600004],
              [-94.49828040299991, 76.96588776200008],
              [-94.49474036399994, 76.95962148600006],
              [-94.49681555899991, 76.95404694200005],
              [-94.49962317599994, 76.94928620000007],
              [-94.49828040299991, 76.94481028900003],
              [-94.48745683499993, 76.93695709800005],
              [-94.4722387359999, 76.92820872600004],
              [-94.45547441299993, 76.92108795800004],
              [-94.44029700399994, 76.91815827000005],
              [-94.30728105399993, 76.92169830900008],
              [-94.26553300699993, 76.91128164300005],
              [-94.25938880099994, 76.90688711100006],
              [-94.25674394399994, 76.90192291900007],
              [-94.25308183499993, 76.89691803600005],
              [-94.2437231109999, 76.89248281500005],
              [-94.23399817599994, 76.89061107000003],
              [-94.11359615799995, 76.88776276200008],
              [-94.03807532499991, 76.90509674700007],
              [-94.00576738199993, 76.92572663000004],
              [-93.98550370999993, 76.93260325700004],
              [-93.96401933499993, 76.93650950700004],
              [-93.91881262899994, 76.93903229400007],
              [-93.82152258999992, 76.92234935100004],
              [-93.70091712099992, 76.92096588700008],
              [-93.67015540299991, 76.91461823100008],
              [-93.64346269399994, 76.90208567900004],
              [-93.61815344999991, 76.87995026200008],
              [-93.58531653599994, 76.86102936400005],
              [-93.50645911399994, 76.84979889500005],
              [-93.46336829299992, 76.82660553600005],
              [-93.43000240799995, 76.82436758000006],
              [-93.41649329299992, 76.82192617400005],
              [-93.40819251199991, 76.81679922100005],
              [-93.39419511599993, 76.80402252800008],
              [-93.38853919199994, 76.80145905200004],
              [-93.33576412699995, 76.79535553600005],
              [-93.28551184799994, 76.78034088700008],
              [-93.29914303299995, 76.77350495000007],
              [-93.29914303299995, 76.76727936400005],
              [-93.2727758449999, 76.75287506700005],
              [-93.25885982999995, 76.74843984600005],
              [-93.24168860599991, 76.74681224200003],
              [-93.20494544199994, 76.75356679900005],
              [-93.19676673099991, 76.75307851800005],
              [-93.1851293609999, 76.73997630400004],
              [-93.1790258449999, 76.71991608300004],
              [-93.17625891799992, 76.68105703300006],
              [-93.18761145699995, 76.66697825700004],
              [-93.26158606699994, 76.62641022300005],
              [-93.2625219389999, 76.62128327000005],
              [-93.26227779899995, 76.60342031500005],
              [-93.26500403599994, 76.59601471600007],
              [-93.2813207669999, 76.58685944200005],
              [-93.30186926999994, 76.57929108300004],
              [-93.31261145699995, 76.56981028900003],
              [-93.29914303299995, 76.55499909100007],
              [-93.33726966099994, 76.53750234600005],
              [-93.42418372299994, 76.51544830900008],
              [-93.46422278599994, 76.49974192900004],
              [-93.47801673099991, 76.48965078300006],
              [-93.48473059799994, 76.48615143400008],
              [-93.50145423099991, 76.48114655200004],
              [-93.63182532499991, 76.45669179900005],
              [-93.65607662699995, 76.44513580900008],
              [-93.61229407499991, 76.41583893400008],
              [-93.56069902299993, 76.39516836100006],
              [-93.50723222599993, 76.39077383000006],
              [-93.45738684799994, 76.41038646000004],
              [-93.52599036399994, 76.41063060100004],
              [-93.56090247299994, 76.41453685100004],
              [-93.58031165299991, 76.43085358300004],
              [-93.5051977199999, 76.45441315300008],
              [-93.38125566299993, 76.46698639500005],
              [-93.36188717399995, 76.47186920800004],
              [-93.35118567599994, 76.47785065300008],
              [-93.33128821499992, 76.49359772300005],
              [-93.3196508449999, 76.49974192900004],
              [-93.26390540299991, 76.51593659100007],
              [-93.24510657499991, 76.52366771000004],
              [-93.23668372299994, 76.53143952000005],
              [-93.22472083199995, 76.55109284100007],
              [-93.21784420499995, 76.55499909100007],
              [-93.18480383999992, 76.55853913000004],
              [-93.15294348899994, 76.56781647300005],
              [-93.09365800699993, 76.59601471600007],
              [-93.09935462099992, 76.59955475500004],
              [-93.1148168609999, 76.61644114800004],
              [-93.07925370999993, 76.62763092700004],
              [-92.95030676999994, 76.63007233300004],
              [-92.91759192599994, 76.62205638200004],
              [-92.81314042899993, 76.61644114800004],
              [-92.72350012899994, 76.59845612200007],
              [-92.69302324099993, 76.59601471600007],
              [-92.52383378799993, 76.62221914300005],
              [-92.46304277299993, 76.61644114800004],
              [-92.39932206899994, 76.60162995000007],
              [-92.36896725199995, 76.59910716400003],
              [-92.33397376199991, 76.60219961100006],
              [-92.23534094999991, 76.62311432500007],
              [-92.15465247299994, 76.61920807500007],
              [-92.01183020699995, 76.65741608300004],
              [-92.00438391799992, 76.66425202000005],
              [-91.72272701699993, 76.67896149300006],
              [-91.44107011599993, 76.69367096600007],
              [-91.13963782499991, 76.67129140800006],
              [-91.0918676419999, 76.66022370000007],
              [-91.01065019399994, 76.65741608300004],
              [-90.92113196499992, 76.64329661700003],
              [-90.87596594999991, 76.62815989800004],
              [-90.84276282499991, 76.60590241100005],
              [-90.80638587099992, 76.58746979400007],
              [-90.57168535099993, 76.56403229400007],
              [-90.53270423099991, 76.55052317900004],
              [-90.4973852199999, 76.52708567900004],
              [-90.50495357999995, 76.52041250200006],
              [-90.51329505099994, 76.51459381700005],
              [-90.52208411399994, 76.50995514500005],
              [-90.53087317599994, 76.50657786700003],
              [-90.51846269399994, 76.49555084800005],
              [-90.50300045499995, 76.49115631700005],
              [-90.46939042899993, 76.48615143400008],
              [-90.49274654899995, 76.46832916900007],
              [-90.65343176999994, 76.45677317900004],
              [-90.92503821499992, 76.48615143400008],
              [-90.9480688139999, 76.49575429900005],
              [-90.97671464799993, 76.51288483300004],
              [-91.00450598899994, 76.52008698100008],
              [-91.0249731109999, 76.49974192900004],
              [-91.02041581899994, 76.49835846600007],
              [-91.01065019399994, 76.49233633000006],
              [-91.0735570949999, 76.48061758000006],
              [-91.14513098899994, 76.48061758000006],
              [-91.34943600199995, 76.51691315300008],
              [-91.56554114499994, 76.50657786700003],
              [-91.56554114499994, 76.49974192900004],
              [-91.51732337099992, 76.49575429900005],
              [-91.46996008999992, 76.48615143400008],
              [-91.45181230399993, 76.48012929900005],
              [-91.41856848899994, 76.46405670800004],
              [-91.40111243399991, 76.45880768400008],
              [-90.99014238199993, 76.45136139500005],
              [-90.96019446499992, 76.43952057500007],
              [-90.95262610599991, 76.43768952000005],
              [-90.80524654899995, 76.43439362200007],
              [-90.72887122299994, 76.42080312700006],
              [-90.64073645699995, 76.41722239800004],
              [-90.57738196499992, 76.39158763200004],
              [-90.55850175699993, 76.39329661700003],
              [-90.51032467399995, 76.40692780200004],
              [-90.44782467399995, 76.41132233300004],
              [-90.0644153856666, 76.37438928166671],
              [-89.68100609733325, 76.33745623033337],
              [-89.29759680899991, 76.30052317900004],
              [-89.29190019399994, 76.29889557500007],
              [-89.28892981699994, 76.29051341400003],
              [-89.28392493399991, 76.28685130400004],
              [-89.21784420499995, 76.26605866100005],
              [-89.19444739499994, 76.24819570500006],
              [-89.20881100199995, 76.22540924700007],
              [-89.22057044199994, 76.22284577000005],
              [-89.25064042899993, 76.22622304900005],
              [-89.26341712099992, 76.22540924700007],
              [-89.27135169199994, 76.22125885600008],
              [-89.28392493399991, 76.20954010600008],
              [-89.29067949099993, 76.20498281500005],
              [-89.31265214799993, 76.19676341400003],
              [-89.38011633999992, 76.18447500200006],
              [-89.7388809886666, 76.18220991966672],
              [-90.09764563733326, 76.17994483733338],
              [-90.45641028599994, 76.17767975500004],
              [-90.42674719999991, 76.16282786700003],
              [-90.09788977799991, 76.15009186400005],
              [-90.05109615799995, 76.13605377800008],
              [-90.09373938699991, 76.12498607000003],
              [-90.14297441299993, 76.12783437700006],
              [-90.23668372299994, 76.14350006700005],
              [-90.69908606699994, 76.17082347200005],
              [-91.16148841099994, 76.19814687700006],
              [-91.23721269399994, 76.22540924700007],
              [-91.6133520169999, 76.26703522300005],
              [-91.58535722599993, 76.25617096600007],
              [-91.52843176999994, 76.25275299700007],
              [-91.49876868399991, 76.25141022300005],
              [-91.46784420499995, 76.24192942900004],
              [-91.27367102799991, 76.21173737200007],
              [-91.25767981699994, 76.20156484600005],
              [-91.27000891799992, 76.18919505400004],
              [-91.35387122299994, 76.17767975500004],
              [-91.35460364499994, 76.17064036700003],
              [-91.40851803299995, 76.15717194200005],
              [-91.40851803299995, 76.14972565300008],
              [-91.36705481699994, 76.14484284100007],
              [-91.24364173099991, 76.16400788000004],
              [-90.78868567599994, 76.13251373900005],
              [-90.74128170499995, 76.12409088700008],
              [-90.6907445949999, 76.12335846600007],
              [-90.66808020699995, 76.11562734600005],
              [-90.68358313699991, 76.11078522300005],
              [-90.71519934799994, 76.11176178600005],
              [-90.73009192599994, 76.10871002800008],
              [-90.73745683499993, 76.10325755400004],
              [-90.73997962099992, 76.09735748900005],
              [-90.74087480399993, 76.09198639500005],
              [-90.74376380099994, 76.08828359600005],
              [-90.77232825399994, 76.07843659100007],
              [-90.80321204299992, 76.07477448100008],
              [-90.86668860599991, 76.07526276200008],
              [-90.86668860599991, 76.06777578300006],
              [-90.71930904899995, 76.05638255400004],
              [-90.68541419199994, 76.06468333500004],
              [-90.65811113199993, 76.07835521000004],
              [-90.62035071499992, 76.08803945500006],
              [-90.55199133999992, 76.09568919500003],
              [-90.18822180899991, 76.06777578300006],
              [-90.2298070949999, 76.04246653900003],
              [-90.29124915299991, 76.03180573100008],
              [-90.69794674399992, 76.03320953950006],
              [-91.10464433499993, 76.03461334800005],
              [-91.16148841099994, 76.02065664300005],
              [-91.11074785099993, 76.01251862200007],
              [-90.98924719999991, 76.02094147300005],
              [-90.94298255099994, 76.00633372600004],
              [-90.97329667899993, 75.99713776200008],
              [-91.04076087099992, 75.99994538000004],
              [-91.07213294199994, 75.99266185100004],
              [-91.05052649599992, 75.98505280200004],
              [-91.00161699099993, 75.97394440300008],
              [-90.97834225199995, 75.97223541900007],
              [-90.9583227199999, 75.96678294500003],
              [-90.94627844999991, 75.95477936400005],
              [-90.94717363199993, 75.94285716400003],
              [-90.96597245999993, 75.93744538000004],
              [-91.0117895169999, 75.93569570500006],
              [-91.10578365799995, 75.91925690300008],
              [-91.14781653599994, 75.90326569200005],
              [-91.14024817599994, 75.89325592700004],
              [-91.12657630099994, 75.88125234600005],
              [-91.12051347599993, 75.86981842700004],
              [-91.13125566299993, 75.84511953300006],
              [-91.12881425699993, 75.83612702000005],
              [-91.10684160099993, 75.84808991100005],
              [-91.10684160099993, 75.84186432500007],
              [-91.08678137899994, 75.84943268400008],
              [-91.06847083199995, 75.87518952000005],
              [-91.05223548099991, 75.88279857000003],
              [-91.06224524599992, 75.89345937700006],
              [-91.06590735599991, 75.89647044500003],
              [-91.04161536399994, 75.90424225500004],
              [-90.93175208199995, 75.92340729400007],
              [-90.85301673099991, 75.95477936400005],
              [-90.83592688699991, 75.96552155200004],
              [-90.80923417899993, 75.99079010600008],
              [-90.79775956899994, 75.99884674700007],
              [-90.77135169199994, 76.00242747600004],
              [-90.73395748599995, 75.99900950700004],
              [-90.69774329299992, 75.99042389500005],
              [-90.67487545499995, 75.97842031500005],
              [-90.70787512899994, 75.97858307500007],
              [-90.72301184799994, 75.97500234600005],
              [-90.73631751199991, 75.96539948100008],
              [-90.70034745999993, 75.95673248900005],
              [-90.66128495999993, 75.96002838700008],
              [-90.55186926999994, 75.98602936400005],
              [-90.50975501199991, 75.98729075700004],
              [-90.46812903599994, 75.98257070500006],
              [-90.42845618399991, 75.97223541900007],
              [-90.45523027299993, 75.96173737200007],
              [-90.48973548099991, 75.95319245000007],
              [-90.51915442599994, 75.94037506700005],
              [-90.53087317599994, 75.91693756700005],
              [-90.51854407499991, 75.89883047100005],
              [-90.49168860599991, 75.90615469000005],
              [-90.43569902299993, 75.93569570500006],
              [-90.35887610599991, 75.94863515800006],
              [-90.34654700399994, 75.95477936400005],
              [-90.33706620999993, 75.96979401200008],
              [-90.31484941299993, 75.97435130400004],
              [-90.24522864499994, 75.96954987200007],
              [-90.22911536399994, 75.96279531500005],
              [-90.19570878799993, 75.94428131700005],
              [-90.17662512899994, 75.93911367400005],
              [-90.11375891799992, 75.93744538000004],
              [-90.11021887899994, 75.95498281500005],
              [-90.08063717399995, 75.97955963700008],
              [-90.07896887899994, 75.99266185100004],
              [-90.04857337099992, 76.01068756700005],
              [-90.00706946499992, 76.01797109600005],
              [-89.96377519399994, 76.01601797100005],
              [-89.92813066299993, 76.00633372600004],
              [-89.94566809799994, 75.99957916900007],
              [-89.9583227199999, 75.98802317900004],
              [-89.95929928299995, 75.97703685100004],
              [-89.94180253799993, 75.97223541900007],
              [-89.84780839799993, 75.96784088700008],
              [-89.82884680899991, 75.96165599200003],
              [-89.81798255099994, 75.94879791900007],
              [-89.8086645169999, 75.94000885600008],
              [-89.79613196499992, 75.93305084800005],
              [-89.77578691299993, 75.92560455900008],
              [-89.68797766799992, 75.90326569200005],
              [-89.71019446499992, 75.88117096600007],
              [-89.77025305899991, 75.84365469000005],
              [-89.78416907499991, 75.82135651200008],
              [-89.77700761599993, 75.81858958500004],
              [-89.75690670499995, 75.80707428600005],
              [-89.76268469999991, 75.80438873900005],
              [-89.77733313699991, 75.79409414300005],
              [-89.76463782499991, 75.79067617400005],
              [-89.74754798099991, 75.78949616100005],
              [-89.72996985599991, 75.79067617400005],
              [-89.71593176999994, 75.79409414300005],
              [-89.70592200399994, 75.80027903900003],
              [-89.68146725199995, 75.82135651200008],
              [-89.66820227799991, 75.82347239800004],
              [-89.61823482999995, 75.83991120000007],
              [-89.59951738199993, 75.84174225500004],
              [-89.57884680899991, 75.84039948100008],
              [-89.56110592399995, 75.84271881700005],
              [-89.55142167899993, 75.85553620000007],
              [-89.61969967399995, 75.85553620000007],
              [-89.61266028599994, 75.85993073100008],
              [-89.60545813699991, 75.86204661700003],
              [-89.5977270169999, 75.86269765800006],
              [-89.58942623599995, 75.86237213700008],
              [-89.51480058499993, 75.85932038000004],
              [-89.44155839799993, 75.84808991100005],
              [-89.31867428299995, 75.80707428600005],
              [-89.19766191299993, 75.79629140800006],
              [-89.17096920499995, 75.78351471600007],
              [-89.16250566299993, 75.76520416900007],
              [-89.16771399599992, 75.75055573100008],
              [-89.19448808499993, 75.72577545800004],
              [-89.20738684799994, 75.71084219000005],
              [-89.23546301999994, 75.66372304900005],
              [-89.25609290299991, 75.63914622600004],
              [-89.25719153599994, 75.63580963700008],
              [-89.27354895699995, 75.63222890800006],
              [-89.30614173099991, 75.63629791900007],
              [-89.40339107999995, 75.61733633000006],
              [-89.64720618399991, 75.62238190300008],
              [-89.66454016799992, 75.60578034100007],
              [-89.69619706899994, 75.59247467700004],
              [-89.73241126199991, 75.58392975500004],
              [-89.76305091099994, 75.58120351800005],
              [-89.71157792899993, 75.57298411700003],
              [-89.5984594389999, 75.59381745000007],
              [-89.54458574099993, 75.57436758000006],
              [-89.58145097599993, 75.56366608300004],
              [-89.66942298099991, 75.56997304900005],
              [-89.70840410099993, 75.56069570500006],
              [-89.67552649599992, 75.54962799700007],
              [-89.54116777299993, 75.55390045800004],
              [-89.50926673099991, 75.55927155200004],
              [-89.44871985599991, 75.58319733300004],
              [-89.41445878799993, 75.58860911700003],
              [-89.20848548099991, 75.58600495000007],
              [-89.18740800699993, 75.57758209800005],
              [-89.17174231699994, 75.56264883000006],
              [-89.14476477799991, 75.52708567900004],
              [-89.13776607999995, 75.52179596600007],
              [-89.11143958199995, 75.51675039300005],
              [-89.1074926419999, 75.50910065300008],
              [-89.10700436099995, 75.49909088700008],
              [-89.1023656889999, 75.48867422100005],
              [-89.0769750639999, 75.48090241100005],
              [-88.99331620999993, 75.47239817900004],
              [-88.97883053299995, 75.46820709800005],
              [-88.9863988919999, 75.44916413000004],
              [-88.96812903599994, 75.43764883000006],
              [-88.94001217399995, 75.43187083500004],
              [-88.91738847599993, 75.43036530200004],
              [-88.76378333199995, 75.43773021000004],
              [-88.76593990799995, 75.44806549700007],
              [-88.74990800699993, 75.47068919500003],
              [-88.75291907499991, 75.48187897300005],
              [-88.79043535099993, 75.52716705900008],
              [-88.81554114499994, 75.55076732000003],
              [-88.90029863199993, 75.60907623900005],
              [-88.80264238199993, 75.62815989800004],
              [-88.75649980399993, 75.64581940300008],
              [-88.75633704299992, 75.67796458500004],
              [-88.72240149599992, 75.68610260600008],
              [-88.68455969999991, 75.68280670800004],
              [-88.6133520169999, 75.66380442900004],
              [-88.57994544199994, 75.65851471600007],
              [-88.48200436099995, 75.60907623900005],
              [-88.33116614499994, 75.56069570500006],
              [-88.22264563699991, 75.54498932500007],
              [-88.20140540299991, 75.53339264500005],
              [-88.20010331899994, 75.51837799700007],
              [-88.21129309799994, 75.51325104400007],
              [-88.24233964799993, 75.51288483300004],
              [-88.28742428299995, 75.50067780200004],
              [-88.30382239499994, 75.49921295800004],
              [-88.30382239499994, 75.49237702000005],
              [-88.24535071499992, 75.47842031500005],
              [-88.22813880099994, 75.47134023600006],
              [-88.22813880099994, 75.47874583500004],
              [-88.21251380099994, 75.47382233300004],
              [-88.20213782499991, 75.47772858300004],
              [-88.19294186099995, 75.48554108300004],
              [-88.1809789699999, 75.49237702000005],
              [-87.99535071499992, 75.53339264500005],
              [-88.00218665299991, 75.53339264500005],
              [-87.99327551999994, 75.53900788000004],
              [-87.9817602199999, 75.54409414300005],
              [-87.96837317599994, 75.54730866100005],
              [-87.95376542899993, 75.54767487200007],
              [-87.96125240799995, 75.54767487200007],
              [-87.75084387899994, 75.58087799700007],
              [-87.66942298099991, 75.56867096600007],
              [-87.63341223899994, 75.55512116100005],
              [-87.62913977799991, 75.53681061400005],
              [-87.61587480399993, 75.52448151200008],
              [-87.52708899599992, 75.49681224200003],
              [-87.49571692599994, 75.49237702000005],
              [-87.51211503799993, 75.47508372600004],
              [-87.54283606699994, 75.46454498900005],
              [-87.5774633449999, 75.45937734600005],
              [-87.60558020699995, 75.45831940300008],
              [-87.60558020699995, 75.45148346600007],
              [-87.51671301999994, 75.45038483300004],
              [-87.46690833199995, 75.45600006700005],
              [-87.43301347599993, 75.47134023600006],
              [-87.42365475199995, 75.50079987200007],
              [-87.45225989499994, 75.51699453300006],
              [-87.49034583199995, 75.52855052300004],
              [-87.50938880099994, 75.54389069200005],
              [-87.50747636599993, 75.56126536700003],
              [-87.50039628799993, 75.56663646000004],
              [-87.46092688699991, 75.56818268400008],
              [-87.44652258999992, 75.57241445500006],
              [-87.41592363199993, 75.58576080900008],
              [-87.40290279899995, 75.58860911700003],
              [-87.39867102799991, 75.59292226800005],
              [-87.39126542899993, 75.60224030200004],
              [-87.38044186099995, 75.61163971600007],
              [-87.36563066299993, 75.61591217700004],
              [-87.26573645699995, 75.62303294500003],
              [-87.11148027299993, 75.59479401200008],
              [-87.09805253799993, 75.58808014500005],
              [-87.09154212099992, 75.58014557500007],
              [-87.08641516799992, 75.57103099200003],
              [-87.07738196499992, 75.56069570500006],
              [-87.06017005099994, 75.55117422100005],
              [-86.77782141799992, 75.47601959800005],
              [-86.57990475199995, 75.47760651200008],
              [-86.51671301999994, 75.46832916900007],
              [-86.39509029899995, 75.43134186400005],
              [-86.36481686099995, 75.43036530200004],
              [-86.39313717399995, 75.41429271000004],
              [-86.41934160099993, 75.40521881700005],
              [-86.61803137899994, 75.36888255400004],
              [-86.40160071499992, 75.37628815300008],
              [-86.19635982999995, 75.41535065300008],
              [-85.99282792899993, 75.42218659100007],
              [-85.81623287699995, 75.40839264500005],
              [-85.52188066299993, 75.40302155200004],
              [-85.52188066299993, 75.40985748900005],
              [-85.54214433499993, 75.41474030200004],
              [-85.54971269399994, 75.41412995000007],
              [-85.5554906889999, 75.40985748900005],
              [-85.5808813139999, 75.41966380400004],
              [-85.79190019399994, 75.43036530200004],
              [-85.83291581899994, 75.43976471600007],
              [-85.90794837099992, 75.46727122600004],
              [-86.11095130099994, 75.48493073100008],
              [-86.12523352799991, 75.49013906500005],
              [-86.14293372299994, 75.49966054900005],
              [-86.1516820949999, 75.50877513200004],
              [-86.13882402299993, 75.51288483300004],
              [-86.09630286399994, 75.51715729400007],
              [-86.01036536399994, 75.53587474200003],
              [-85.71646074099993, 75.55731842700004],
              [-85.59194902299993, 75.59711334800005],
              [-85.52871660099993, 75.60162995000007],
              [-85.56322180899991, 75.58218008000006],
              [-85.56810462099992, 75.57233307500007],
              [-85.54580644399994, 75.56818268400008],
              [-85.45885169199994, 75.56118398600006],
              [-85.38695227799991, 75.57355377800008],
              [-85.22712154899995, 75.56069570500006],
              [-85.22712154899995, 75.56818268400008],
              [-85.29906165299991, 75.57493724200003],
              [-85.32266191299993, 75.57436758000006],
              [-85.31818600199995, 75.57876211100006],
              [-85.31867428299995, 75.58051178600005],
              [-85.30284583199995, 75.58730703300006],
              [-85.29234778599994, 75.58869049700007],
              [-85.28172766799992, 75.58860911700003],
              [-85.29173743399991, 75.59365469000005],
              [-85.29600989499994, 75.59479401200008],
              [-85.29600989499994, 75.60162995000007],
              [-85.21344967399995, 75.60162995000007],
              [-85.20018469999991, 75.60468170800004],
              [-85.19432532499991, 75.61196523600006],
              [-85.1895238919999, 75.62091705900008],
              [-85.17931067599994, 75.62897370000007],
              [-85.16148841099994, 75.63251373900005],
              [-85.09723873599995, 75.62897370000007],
              [-85.07559160099993, 75.63117096600007],
              [-85.0352270169999, 75.64081452000005],
              [-85.01480058499993, 75.64325592700004],
              [-85.01480058499993, 75.65009186400005],
              [-85.02985592399995, 75.65403880400004],
              [-85.04491126199991, 75.65582916900007],
              [-84.80247962099992, 75.65623607000003],
              [-84.57607988199993, 75.62425364800004],
              [-84.50088456899994, 75.63580963700008],
              [-84.53872636599993, 75.64354075700004],
              [-84.61888587099992, 75.64419179900005],
              [-84.65794837099992, 75.65009186400005],
              [-84.64037024599992, 75.65997955900008],
              [-84.64175370999993, 75.67047760600008],
              [-84.66470292899993, 75.69106679900005],
              [-84.28962154899995, 75.71328359600005],
              [-84.21149654899995, 75.75299713700008],
              [-84.17804928299995, 75.76284414300005],
              [-84.01915442599994, 75.77220286700003],
              [-83.93325761599993, 75.80312734600005],
              [-83.91808020699995, 75.81452057500007],
              [-83.98436438699991, 75.82119375200006],
              [-84.00059973899994, 75.82880280200004],
              [-83.83922278599994, 75.81452057500007],
              [-83.73623613199993, 75.82660553600005],
              [-83.69896399599992, 75.82135651200008],
              [-83.71178137899994, 75.81663646000004],
              [-83.75422115799995, 75.80707428600005],
              [-83.68228105399993, 75.79181549700007],
              [-83.52049719999991, 75.79865143400008],
              [-83.43081620999993, 75.75580475500004],
              [-83.39586341099994, 75.74860260600008],
              [-83.26671301999994, 75.74412669500003],
              [-83.19786536399994, 75.75495026200008],
              [-83.17210852799991, 75.75458405200004],
              [-83.11953691299993, 75.74005768400008],
              [-83.08897864499994, 75.74030182500007],
              [-82.62450110599991, 75.82070547100005],
              [-82.54076087099992, 75.82135651200008],
              [-82.50523841099994, 75.82900625200006],
              [-82.41808020699995, 75.83014557500007],
              [-82.33104407499991, 75.84357330900008],
              [-81.92507890566658, 75.82208893400008],
              [-81.51911373633327, 75.80060455900008],
              [-81.11314856699994, 75.77912018400008],
              [-81.10155188699991, 75.77338288000004],
              [-81.09512285099993, 75.75995514500005],
              [-81.10631262899994, 75.75556061400005],
              [-81.12621008999992, 75.74176666900007],
              [-81.13646399599992, 75.73883698100008],
              [-81.15208899599992, 75.73672109600005],
              [-81.16860917899993, 75.73163483300004],
              [-81.24181067599994, 75.69476959800005],
              [-81.28628495999993, 75.66372304900005],
              [-81.25210527299993, 75.65399811400005],
              [-81.17577063699991, 75.65761953300006],
              [-81.13951575399994, 75.65314362200007],
              [-81.10069739499994, 75.64394765800006],
              [-81.01524817599994, 75.63629791900007],
              [-80.75932776599993, 75.64893219600006],
              [-80.50340735599991, 75.66156647300005],
              [-80.46450761599993, 75.65623607000003],
              [-80.46007239499994, 75.65387604400007],
              [-80.4500219389999, 75.64622630400004],
              [-80.4434301419999, 75.64325592700004],
              [-80.41755123599995, 75.63641998900005],
              [-80.33653723899994, 75.63788483300004],
              [-80.22142493399991, 75.61863841400003],
              [-80.1765844389999, 75.60162995000007],
              [-80.11143958199995, 75.59438711100006],
              [-80.07860266799992, 75.58608633000006],
              [-80.0598852199999, 75.56818268400008],
              [-80.06973222599993, 75.56663646000004],
              [-80.07803300699993, 75.56264883000006],
              [-80.08413652299993, 75.55630117400005],
              [-80.08775794199994, 75.54767487200007],
              [-80.05370032499991, 75.54352448100008],
              [-79.97866777299993, 75.54987213700008],
              [-79.9500219389999, 75.54022858300004],
              [-79.99547278599994, 75.52423737200007],
              [-80.34178626199991, 75.48285553600005],
              [-80.3758031889999, 75.46507396000004],
              [-80.01280676999991, 75.46743398600006],
              [-79.64981035099993, 75.46979401200008],
              [-79.59459387899994, 75.45921458500004],
              [-79.57384192599994, 75.45148346600007],
              [-79.63109290299991, 75.45359935100004],
              [-79.65973873599995, 75.45001862200007],
              [-79.68309485599991, 75.43773021000004],
              [-79.62559973899994, 75.41107819200005],
              [-79.59650631399995, 75.40192291900007],
              [-79.56017005099994, 75.39679596600007],
              [-79.52061926999994, 75.39569733300004],
              [-79.50104732999995, 75.39191315300008],
              [-79.49132239499994, 75.38251373900005],
              [-79.4934789699999, 75.36810944200005],
              [-79.50430253799993, 75.36200592700004],
              [-79.51903235599991, 75.35932038000004],
              [-79.53286699099993, 75.35521067900004],
              [-79.52765865799995, 75.35382721600007],
              [-79.51720130099994, 75.34983958500004],
              [-79.51183020699995, 75.34845612200007],
              [-79.53258216099994, 75.32733795800004],
              [-79.60024980399993, 75.31875234600005],
              [-79.61485755099994, 75.30369700700004],
              [-79.59105383999992, 75.28994375200006],
              [-79.44351152299993, 75.28701406500005],
              [-79.45201575399994, 75.27533600500004],
              [-79.45335852799991, 75.27244700700004],
              [-79.49754798099991, 75.25958893400008],
              [-79.51183020699995, 75.25218333500004],
              [-79.5169164699999, 75.22923411700003],
              [-79.60586503799993, 75.19782135600008],
              [-79.62848873599995, 75.18024323100008],
              [-79.75133216099994, 75.17023346600007],
              [-79.79987545499995, 75.17682526200008],
              [-79.81346594999991, 75.17715078300006],
              [-79.82534745999993, 75.17548248900005],
              [-79.83364824099993, 75.17316315300008],
              [-79.83706620999993, 75.16941966400003],
              [-79.83458411399994, 75.16339752800008],
              [-79.84825598899994, 75.15501536700003],
              [-79.8645727199999, 75.15159739800004],
              [-79.90282141799992, 75.14980703300006],
              [-79.92202714799993, 75.14663320500006],
              [-79.93553626199991, 75.14126211100006],
              [-79.94615637899994, 75.13324616100005],
              [-79.95742753799993, 75.12250397300005],
              [-79.96271725199995, 75.11237213700008],
              [-79.96328691299993, 75.10366445500006],
              [-79.96865800699993, 75.09747955900008],
              [-80.28783118399991, 75.06293366100005],
              [-80.3235570949999, 75.04417552300004],
              [-80.34479732999995, 75.03994375200006],
              [-80.4434301419999, 75.03994375200006],
              [-80.34984290299991, 75.01422760600008],
              [-80.32087154899995, 75.00238678600005],
              [-80.28726152299993, 74.99384186400005],
              [-80.21153723899994, 74.99420807500007],
              [-80.1765844389999, 74.98529694200005],
              [-80.25792395699995, 74.97711823100008],
              [-80.2761938139999, 74.96857330900008],
              [-80.27464758999992, 74.95648834800005],
              [-80.24913489499994, 74.95351797100005],
              [-80.19701087099992, 74.95799388200004],
              [-80.13817298099991, 74.97060781500005],
              [-80.10631262899994, 74.97370026200008],
              [-80.08092200399994, 74.96857330900008],
              [-80.05931555899991, 74.96092357000003],
              [-80.04385331899994, 74.96377187700006],
              [-80.03140214799993, 74.97313060100004],
              [-80.01891028599994, 74.98529694200005],
              [-80.02570553299995, 74.98529694200005],
              [-79.77993730399993, 75.03245677300004],
              [-79.74413001199991, 75.03261953300006],
              [-79.64216061099995, 75.01886627800008],
              [-79.59203040299991, 75.02057526200008],
              [-79.50499426999994, 74.99896881700005],
              [-79.5332738919999, 74.99917226800005],
              [-79.54702714799993, 74.99664948100008],
              [-79.56017005099994, 74.99152252800008],
            ],
          ],
          [
            [
              [-119.31749426999994, 76.19989655200004],
              [-119.3340551419999, 76.20734284100007],
              [-119.3635961579999, 76.22589752800008],
              [-119.37954667899993, 76.23358795800004],
              [-119.44249426999994, 76.25079987200007],
              [-119.45958411399994, 76.26333242400005],
              [-119.46849524599992, 76.27875397300005],
              [-119.48082434799994, 76.35516998900005],
              [-119.48631751199991, 76.36107005400004],
              [-119.50059973899994, 76.36322663000004],
              [-119.52261308499993, 76.36163971600007],
              [-119.52855383999992, 76.35691966400003],
              [-119.52912350199995, 76.34910716400003],
              [-119.53502356699994, 76.33836497600004],
              [-119.57591712099992, 76.32074616100005],
              [-119.6714574859999, 76.33885325700004],
              [-119.7168676419999, 76.33527252800008],
              [-119.7168676419999, 76.32843659100007],
              [-119.69762122299994, 76.32843659100007],
              [-119.67756100199995, 76.32440827000005],
              [-119.66177324099993, 76.31460195500006],
              [-119.65542558499993, 76.29743073100008],
              [-119.66038977799991, 76.27773672100005],
              [-119.67324785099993, 76.27090078300006],
              [-119.71068274599992, 76.26703522300005],
              [-119.69635982999989, 76.25702545800004],
              [-119.59715735599991, 76.20246002800008],
              [-119.57730058499993, 76.19619375200006],
              [-119.57433020699995, 76.19147370000007],
              [-119.57217363199993, 76.18585846600007],
              [-119.5691625639999, 76.18109772300005],
              [-119.56460527299993, 76.17182038000004],
              [-119.5723363919999, 76.16705963700008],
              [-119.62002519399994, 76.16176992400005],
              [-119.67528235599991, 76.16596100500004],
              [-119.70323645699995, 76.16400788000004],
              [-119.67577063699991, 76.14134349200003],
              [-119.63418535099993, 76.13426341400003],
              [-119.58946692599994, 76.13190338700008],
              [-119.55239824099993, 76.12299225500004],
              [-119.5777074859999, 76.11196523600006],
              [-119.80565344999991, 76.11562734600005],
              [-119.78685462099992, 76.10578034100007],
              [-119.76183020699995, 76.09967682500007],
              [-119.68415279899995, 76.09357330900008],
              [-119.52334550699993, 76.05255768400008],
              [-119.49168860599991, 76.03685130400004],
              [-119.47728430899991, 76.00633372600004],
              [-119.48595130099994, 75.97492096600007],
              [-119.51113847599993, 75.96723053600005],
              [-119.54332434799994, 75.97402578300006],
              [-119.59532630099994, 75.99437083500004],
              [-119.61571204299992, 75.99799225500004],
              [-119.63532467399995, 75.99555084800005],
              [-119.65542558499993, 75.98582591400003],
              [-119.70323645699995, 75.94428131700005],
              [-119.64867102799991, 75.93773021000004],
              [-119.62100175699993, 75.92963288000004],
              [-119.6070043609999, 75.91693756700005],
              [-119.62633216099994, 75.91714101800005],
              [-119.68203691299993, 75.92377350500004],
              [-119.70201575399994, 75.92177969000005],
              [-119.71361243399991, 75.91640859600005],
              [-119.73737545499989, 75.89988841400003],
              [-119.77574622299994, 75.88312409100007],
              [-119.86294511599993, 75.85911692900004],
              [-120.04434160099993, 75.84267812700006],
              [-120.08063717399995, 75.85553620000007],
              [-120.08543860599991, 75.86347077000005],
              [-120.08971106699994, 75.87470123900005],
              [-120.0969945949999, 75.88467031500005],
              [-120.11070716099994, 75.88898346600007],
              [-120.13003495999993, 75.89252350500004],
              [-120.14561926999994, 75.89813873900005],
              [-120.16087805899991, 75.89834219000005],
              [-120.17931067599994, 75.88593170800004],
              [-120.20274817599994, 75.86546458500004],
              [-120.22972571499992, 75.84760163000004],
              [-120.25967363199993, 75.83274974200003],
              [-120.2923070949999, 75.82135651200008],
              [-120.33486894399994, 75.81199778900003],
              [-120.38744055899991, 75.80670807500007],
              [-120.4387914699999, 75.81053294500003],
              [-120.4778539699999, 75.82880280200004],
              [-120.48900305899991, 75.84707265800006],
              [-120.48542232999989, 75.86367422100005],
              [-120.46353105399993, 75.89647044500003],
              [-120.46104895699995, 75.90672435100004],
              [-120.46157792899993, 75.91559479400007],
              [-120.46060136599993, 75.92430247600004],
              [-120.45368404899995, 75.93402741100005],
              [-120.43724524599992, 75.94456614800004],
              [-120.40078691299993, 75.96108633000006],
              [-120.38849850199995, 75.97223541900007],
              [-120.44163977799991, 75.97866445500006],
              [-120.44985917899993, 75.98212311400005],
              [-120.44692949099993, 75.98908112200007],
              [-120.43569902299993, 76.00018952000005],
              [-120.43565833199995, 76.00633372600004],
              [-120.46031653599994, 76.01544830900008],
              [-120.58023027299993, 76.00633372600004],
              [-120.57530676999994, 76.00356679900005],
              [-120.56517493399991, 75.99579498900005],
              [-120.55972245999993, 75.99266185100004],
              [-120.59618079299992, 75.98688385600008],
              [-120.64045162699995, 75.99213288000004],
              [-120.68374589799993, 76.00617096600007],
              [-120.71743730399993, 76.02680084800005],
              [-120.7324926419999, 76.05508047100005],
              [-120.71377519399994, 76.07440827000005],
              [-120.64915930899991, 76.10252513200004],
              [-120.67223059799994, 76.10565827000005],
              [-120.73448645699995, 76.09373607000003],
              [-120.75157630099994, 76.10252513200004],
              [-120.74510657499991, 76.12368398600006],
              [-120.71662350199995, 76.13349030200004],
              [-120.68325761599993, 76.13812897300005],
              [-120.66222083199995, 76.14350006700005],
              [-120.69163977799991, 76.15981679900005],
              [-120.79454505099994, 76.17584870000007],
              [-120.84715735599991, 76.19814687700006],
              [-120.86497962099992, 76.20099518400008],
              [-120.87995357999989, 76.19863515800006],
              [-120.94701087099992, 76.18040599200003],
              [-120.98875891799992, 76.16400788000004],
              [-121.01121985599991, 76.13886139500005],
              [-120.99795488199993, 76.10252513200004],
              [-121.01353919199994, 76.09760163000004],
              [-121.02131100199995, 76.08710358300004],
              [-121.0242406889999, 76.07412344000005],
              [-121.02529863199993, 76.06159088700008],
              [-120.98656165299991, 76.03237539300005],
              [-120.97069251199991, 76.02374909100007],
              [-120.9636938139999, 76.01325104400007],
              [-120.95881100199995, 75.99579498900005],
              [-120.95225989499994, 75.97943756700005],
              [-120.93993079299992, 75.97223541900007],
              [-120.93907630099994, 75.96784088700008],
              [-120.95348059799994, 75.95819733300004],
              [-120.97398841099994, 75.94863515800006],
              [-120.99111894399994, 75.94428131700005],
              [-121.01414954299992, 75.95038483300004],
              [-121.01732337099992, 75.96405670800004],
              [-121.00572669199994, 75.97825755400004],
              [-120.98436438699991, 75.98582591400003],
              [-121.03429114499994, 76.00356679900005],
              [-121.11778723899994, 76.00014883000006],
              [-121.2031957669999, 75.98452383000006],
              [-121.25869706899994, 75.96539948100008],
              [-121.2698461579999, 75.95262278900003],
              [-121.28384355399993, 75.92088450700004],
              [-121.29967200399994, 75.91079336100006],
              [-121.31069902299993, 75.91266510600008],
              [-121.35509192599994, 75.93244049700007],
              [-121.41771399599992, 75.93781159100007],
              [-121.4368383449999, 75.94428131700005],
              [-121.42959550699993, 75.94700755400004],
              [-121.4163305329999, 75.95795319200005],
              [-121.4512426419999, 75.96588776200008],
              [-121.46841386599993, 75.97304922100005],
              [-121.48151607999989, 75.98212311400005],
              [-121.49486243399991, 75.98761627800008],
              [-121.55288652299993, 75.99266185100004],
              [-121.68504798099991, 76.01862213700008],
              [-121.8198949859999, 76.02968984600005],
              [-121.84707597599993, 76.04523346600007],
              [-122.04637610599991, 76.03363678600005],
              [-122.09870357999989, 76.04096100500004],
              [-122.12547766799992, 76.04120514500005],
              [-122.1499731109999, 76.03363678600005],
              [-122.14468339799993, 76.03229401200008],
              [-122.13442949099993, 76.02806224200003],
              [-122.12889563699991, 76.02680084800005],
              [-122.14517167899993, 76.00726959800005],
              [-122.14903723899994, 75.99713776200008],
              [-122.13914954299992, 75.99266185100004],
              [-122.13272050699993, 75.99127838700008],
              [-122.13084876199991, 75.98777903900003],
              [-122.13223222599993, 75.98309967700004],
              [-122.13573157499991, 75.97842031500005],
              [-122.1453344389999, 75.97626373900005],
              [-122.1909887359999, 75.97842031500005],
              [-122.3753149079999, 75.93744538000004],
              [-122.42589270699995, 75.93280670800004],
              [-122.61888587099992, 75.94196198100008],
              [-122.73155676999994, 75.97842031500005],
              [-122.68748938699991, 75.98065827000005],
              [-122.64167232999989, 75.98847077000005],
              [-122.5979711579999, 76.00336334800005],
              [-122.56029212099992, 76.02680084800005],
              [-122.57778886599993, 76.02558014500005],
              [-122.60948645699995, 76.01561107000003],
              [-122.62572180899991, 76.01312897300005],
              [-122.6980688139999, 76.02065664300005],
              [-122.67467200399994, 76.02655670800004],
              [-122.6018774079999, 76.03363678600005],
              [-122.52611243399991, 76.06159088700008],
              [-122.53355872299994, 76.06777578300006],
              [-122.5039770169999, 76.08417389500005],
              [-122.48298092399995, 76.10236237200007],
              [-122.4837133449999, 76.11701080900008],
              [-122.51903235599991, 76.12299225500004],
              [-122.70490475199995, 76.11562734600005],
              [-122.68602454299992, 76.12372467700004],
              [-122.49258378799993, 76.14350006700005],
              [-122.51170813699991, 76.14948151200008],
              [-122.53262285099993, 76.15106842700004],
              [-122.5745336579999, 76.14972565300008],
              [-122.57530676999994, 76.16766998900005],
              [-122.60582434799994, 76.17426178600005],
              [-122.67015540299991, 76.17767975500004],
              [-122.77009029899995, 76.15363190300008],
              [-122.80386308499993, 76.14972565300008],
              [-122.82835852799991, 76.15428294500003],
              [-122.83775794199994, 76.15208567900004],
              [-122.84142005099994, 76.13979726800005],
              [-122.84780839799993, 76.13300202000005],
              [-122.88988196499992, 76.10871002800008],
              [-122.92540442599994, 76.09707265800006],
              [-122.96373450399994, 76.09100983300004],
              [-123.04067949099993, 76.08828359600005],
              [-123.02501380099994, 76.09369538000004],
              [-122.99339758999992, 76.10016510600008],
              [-122.97923743399991, 76.10871002800008],
              [-122.99917558499993, 76.12051015800006],
              [-123.00649980399993, 76.12299225500004],
              [-122.95860755099994, 76.13202545800004],
              [-122.95128333199995, 76.13979726800005],
              [-122.94717363199993, 76.15127187700006],
              [-122.93700110599991, 76.15696849200003],
              [-122.92369544199994, 76.15843333500004],
              [-122.91030839799993, 76.15717194200005],
              [-122.91722571499992, 76.16502513200004],
              [-122.9253637359999, 76.17121002800008],
              [-122.93447831899994, 76.17548248900005],
              [-122.94448808499993, 76.17767975500004],
              [-122.92467200399994, 76.18895091400003],
              [-122.8921606109999, 76.18317291900007],
              [-122.86172441299993, 76.18235911700003],
              [-122.83165442599994, 76.23729075700004],
              [-122.79246985599991, 76.23826732000003],
              [-122.74697831899994, 76.23016998900005],
              [-122.71108964799993, 76.23163483300004],
              [-122.7254125639999, 76.23163483300004],
              [-122.71157792899993, 76.24689362200007],
              [-122.6887914699999, 76.25507233300004],
              [-122.64126542899993, 76.26508209800005],
              [-122.63438880099994, 76.27260976800005],
              [-122.63524329299992, 76.28375885600008],
              [-122.64122473899994, 76.29450104400007],
              [-122.64964758999992, 76.30052317900004],
              [-122.6343481109999, 76.32689036700003],
              [-122.6172582669999, 76.34320709800005],
              [-122.59398352799991, 76.35382721600007],
              [-122.45140540299991, 76.38182200700004],
              [-122.40322831899994, 76.40420156500005],
              [-122.38060462099992, 76.40851471600007],
              [-121.96324622299994, 76.43732330900008],
              [-121.78140214799993, 76.42519765800006],
              [-121.55357825399994, 76.43699778900003],
              [-121.51187089799993, 76.44822825700004],
              [-121.50523841099994, 76.45359935100004],
              [-121.50300045499989, 76.45970286700003],
              [-121.5034887359999, 76.46442291900007],
              [-121.50511633999992, 76.46564362200007],
              [-121.49889075399994, 76.46963125200006],
              [-121.42369544199994, 76.50043366100005],
              [-121.40884355399993, 76.51406484600005],
              [-121.41356360599991, 76.55426666900007],
              [-121.37002519399994, 76.56972890800006],
              [-121.32217363199993, 76.57782623900005],
              [-121.31395423099991, 76.59601471600007],
              [-121.2542211579999, 76.60952383000006],
              [-121.22801673099991, 76.62116120000007],
              [-121.2171117829999, 76.64008209800005],
              [-121.21397864499994, 76.66205475500004],
              [-121.20425370999993, 76.67820872600004],
              [-121.18732662699995, 76.68817780200004],
              [-121.16270911399994, 76.69159577000005],
              [-121.14663652299993, 76.68968333500004],
              [-121.1070043609999, 76.67291901200008],
              [-121.08934485599991, 76.67072174700007],
              [-121.03897050699993, 76.68414948100008],
              [-120.91954505099994, 76.69546133000006],
              [-120.81411699099993, 76.73371002800008],
              [-120.55190995999993, 76.75942617400005],
              [-120.52399654899995, 76.76837799700007],
              [-120.5120336579999, 76.78375885600008],
              [-120.3679906889999, 76.81452057500007],
              [-120.37303626199991, 76.81777578300006],
              [-120.38255774599992, 76.82566966400003],
              [-120.38849850199995, 76.82876211100006],
              [-120.38341223899994, 76.83197663000004],
              [-120.37368730399993, 76.83954498900005],
              [-120.3679906889999, 76.84235260600008],
              [-120.3843481109999, 76.84560781500005],
              [-120.4004613919999, 76.85154857000003],
              [-120.41563880099994, 76.85968659100007],
              [-120.42943274599992, 76.86908600500004],
              [-120.36974036399994, 76.89276764500005],
              [-120.2280981109999, 76.90265534100007],
              [-120.1687719389999, 76.93178945500006],
              [-120.18150794199994, 76.93431224200003],
              [-120.18854732999989, 76.94049713700008],
              [-120.18736731699994, 76.94794342700004],
              [-120.1753637359999, 76.95404694200005],
              [-120.11351477799991, 76.96588776200008],
              [-120.09361731699994, 76.96588776200008],
              [-120.10423743399991, 76.98944733300004],
              [-120.0911352199999, 77.00560130400004],
              [-120.06541907499991, 77.01577383000006],
              [-120.0384008449999, 77.02057526200008],
              [-119.96629798099991, 77.01593659100007],
              [-119.93081620999993, 77.02008698100008],
              [-119.90868079299992, 77.04100169500003],
              [-119.92235266799992, 77.04726797100005],
              [-119.90086829299992, 77.05219147300005],
              [-119.85435950399994, 77.05483633000006],
              [-119.83665930899991, 77.06525299700007],
              [-119.83311926999994, 77.07672760600008],
              [-119.83299719999991, 77.08885325700004],
              [-119.8269750639999, 77.09857819200005],
              [-119.72374426999994, 77.11615631700005],
              [-119.6507055329999, 77.11644114800004],
              [-119.62808183499993, 77.12360260600008],
              [-119.62706458199995, 77.14252350500004],
              [-119.59927324099993, 77.15184153900003],
              [-119.42520097599993, 77.18056875200006],
              [-119.38731848899994, 77.19253164300005],
              [-119.37267005099994, 77.20416901200008],
              [-119.34142005099994, 77.23908112200007],
              [-119.32957923099991, 77.24648672100005],
              [-119.32396399599992, 77.25128815300008],
              [-119.28970292899993, 77.28880442900004],
              [-119.26817786399994, 77.29633209800005],
              [-119.22964433499993, 77.30487702000005],
              [-119.1956274079999, 77.31757233300004],
              [-119.16270911399994, 77.32489655200004],
              [-119.12905839799993, 77.32827383000006],
              [-118.96629798099991, 77.31964752800008],
              [-118.87677975199995, 77.33685944200005],
              [-118.85973059799994, 77.34267812700006],
              [-118.83315995999993, 77.35781484600005],
              [-118.82054602799991, 77.36102936400005],
              [-118.78294837099992, 77.35431549700007],
              [-118.7598363919999, 77.35431549700007],
              [-118.70026607999989, 77.36432526200008],
              [-118.43952389249989, 77.36229075700007],
              [-118.17878170499989, 77.36025625200006],
              [-118.10228430899991, 77.38035716400003],
              [-117.8523656889999, 77.39044830900008],
              [-117.8523656889999, 77.38361237200007],
              [-117.87979081899994, 77.38336823100008],
              [-117.93455969999991, 77.37140534100007],
              [-117.9622289699999, 77.37002187700006],
              [-117.93492591099994, 77.36139557500007],
              [-117.79918372299994, 77.37205638200004],
              [-117.7847387359999, 77.37002187700006],
              [-117.77330481699994, 77.36444733300004],
              [-117.75357011599993, 77.34808991100005],
              [-117.7437231109999, 77.34267812700006],
              [-117.72935950399994, 77.34039948100008],
              [-117.68175208199995, 77.34267812700006],
              [-117.6636449859999, 77.34088776200008],
              [-117.61339270699995, 77.32904694200005],
              [-117.47435462099992, 77.33588288000004],
              [-117.46930904899995, 77.33319733300004],
              [-117.46190344999991, 77.32001373900005],
              [-117.45506751199991, 77.31537506700005],
              [-117.4375707669999, 77.31293366100005],
              [-117.38060462099992, 77.31537506700005],
              [-117.32005774599992, 77.30630117400005],
              [-117.2617895169999, 77.28925202000005],
              [-117.23110917899993, 77.28571198100008],
              [-117.1336156889999, 77.30170319200005],
              [-117.03921464799993, 77.29279205900008],
              [-117.0100805329999, 77.30170319200005],
              [-117.06566321499992, 77.33364492400005],
              [-117.09727942599994, 77.34345123900005],
              [-117.13988196499992, 77.33641185100004],
              [-117.15819251199991, 77.33665599200003],
              [-117.17438717399995, 77.34056224200003],
              [-117.18138587099992, 77.34886302300004],
              [-117.17373613199993, 77.35968659100007],
              [-117.15587317599994, 77.36383698100008],
              [-117.03331458199995, 77.35293203300006],
              [-116.86021887899994, 77.31826406500005],
              [-116.81309973899994, 77.31659577000005],
              [-116.77733313699991, 77.32904694200005],
              [-116.78693600199995, 77.33120351800005],
              [-116.8108617829999, 77.34267812700006],
              [-116.7698461579999, 77.35521067900004],
              [-116.68252519399994, 77.37059153900003],
              [-116.64696204299992, 77.39044830900008],
              [-116.67650305899991, 77.39740631700005],
              [-116.74632727799991, 77.40082428600005],
              [-116.77733313699991, 77.39728424700007],
              [-116.82652747299994, 77.38349030200004],
              [-116.85191809799994, 77.38401927300004],
              [-116.85240637899994, 77.40412018400008],
              [-116.94322669199994, 77.39744700700004],
              [-116.99400794199994, 77.39956289300005],
              [-117.01626542899993, 77.41469961100006],
              [-117.03457597599993, 77.43138255400004],
              [-117.15404212099992, 77.45872630400004],
              [-117.13341223899994, 77.46816640800006],
              [-117.11009680899991, 77.47459544500003],
              [-117.06468665299991, 77.47988515800006],
              [-117.07152258999992, 77.46621328300006],
              [-117.05532792899993, 77.46234772300005],
              [-117.03844153599994, 77.46308014500005],
              [-117.0034887359999, 77.47077057500007],
              [-116.98119055899991, 77.47304922100005],
              [-116.93569902299993, 77.47138092700004],
              [-116.9136449859999, 77.47431061400005],
              [-116.75682532499991, 77.51337311400005],
              [-116.77403723899994, 77.51968008000006],
              [-116.92813066299993, 77.52765534100007],
              [-116.90074622299994, 77.53636302300004],
              [-116.40672766799992, 77.56240469000005],
              [-116.41234290299991, 77.55923086100006],
              [-116.42723548099991, 77.54816315300008],
              [-116.33849036399994, 77.54071686400005],
              [-116.35387122299994, 77.53058502800008],
              [-116.35960852799991, 77.52765534100007],
              [-116.24693762899994, 77.52704498900005],
              [-116.21568762899994, 77.52216217700004],
              [-116.10024980399993, 77.49066803600005],
              [-116.06411699099993, 77.48672109600005],
              [-116.1109106109999, 77.47809479400007],
              [-116.12559973899994, 77.47239817900004],
              [-116.08665930899991, 77.46027252800008],
              [-115.89199785099993, 77.44135163000004],
              [-115.85020911399994, 77.42934804900005],
              [-115.80003821499992, 77.43158600500004],
              [-115.77651933499993, 77.42983633000006],
              [-115.65835527299993, 77.38922760600008],
              [-115.57526607999989, 77.37807851800005],
              [-115.48961341099994, 77.35394928600005],
              [-115.44782467399995, 77.34886302300004],
              [-115.45079505099994, 77.34528229400007],
              [-115.45287024599992, 77.34198639500005],
              [-115.45567786399994, 77.33881256700005],
              [-115.46080481699994, 77.33588288000004],
              [-115.44359290299991, 77.32811107000003],
              [-115.40416419199994, 77.31842682500007],
              [-115.39256751199991, 77.30792877800008],
              [-115.45807857999989, 77.30792877800008],
              [-115.47061113199993, 77.30585358300004],
              [-115.49429277299993, 77.29645416900007],
              [-115.50576738199993, 77.29425690300008],
              [-115.50885982999989, 77.29169342700004],
              [-115.51748613199993, 77.27899811400005],
              [-115.52285722599993, 77.27440013200004],
              [-115.53709876199991, 77.26947663000004],
              [-115.6829320949999, 77.26154205900008],
              [-115.72972571499992, 77.25307851800005],
              [-115.77611243399991, 77.25332265800006],
              [-115.8145238919999, 77.24091217700004],
              [-115.8518774079999, 77.23480866100005],
              [-115.90245520699995, 77.21649811400005],
              [-115.9278051419999, 77.21234772300005],
              [-116.24722245999993, 77.19594961100006],
              [-116.27452551999994, 77.18984609600005],
              [-116.27643795499989, 77.17816803600005],
              [-116.28384355399993, 77.17072174700007],
              [-116.27643795499989, 77.16453685100004],
              [-116.30182857999989, 77.14826080900008],
              [-116.37149003799993, 77.14549388200004],
              [-116.40054277299993, 77.13727448100008],
              [-116.37873287699995, 77.12824127800008],
              [-116.30418860599991, 77.11810944200005],
              [-116.28990637899994, 77.11188385600008],
              [-116.28685462099992, 77.10443756700005],
              [-116.28734290299991, 77.09503815300008],
              [-116.28384355399993, 77.08266836100006],
              [-116.25767981699994, 77.05589427300004],
              [-116.22166907499991, 77.04165273600006],
              [-115.8313695949999, 76.97280508000006],
              [-115.77843176999994, 76.97040436400005],
              [-115.75365149599992, 76.96478913000004],
              [-115.73204505099994, 76.94855377800008],
              [-115.75104732999989, 76.93309153900003],
              [-115.90709387899994, 76.89704010600008],
              [-116.02403723899994, 76.89874909100007],
              [-116.25658118399991, 76.94049713700008],
              [-116.32579505099994, 76.94554271000004],
              [-116.36579342399995, 76.93178945500006],
              [-116.3570043609999, 76.90761953300006],
              [-116.3137914699999, 76.89032623900005],
              [-116.26309160099993, 76.87726471600007],
              [-116.17491614499994, 76.84174225500004],
              [-116.04015051999994, 76.82831452000005],
              [-115.99522864499994, 76.79393138200004],
              [-115.99746660099993, 76.78384023600006],
              [-115.99779212099992, 76.77521393400008],
              [-115.99522864499994, 76.76727936400005],
              [-115.96349036399994, 76.75177643400008],
              [-115.9055883449999, 76.71279531500005],
              [-115.89281165299991, 76.69843170800004],
              [-115.91161048099991, 76.69489166900007],
              [-115.97813880099994, 76.68968333500004],
              [-116.00023352799991, 76.68284739800004],
              [-116.00951087099992, 76.67792389500005],
              [-116.0125219389999, 76.67450592700004],
              [-116.0144750639999, 76.66705963700008],
              [-116.01634680899991, 76.66425202000005],
              [-116.04971269399994, 76.64329661700003],
              [-116.08315995999993, 76.62946198100008],
              [-116.32481848899994, 76.58173248900005],
              [-116.45132402299993, 76.57957591400003],
              [-116.49714107999989, 76.57021719000005],
              [-116.52000891799992, 76.56806061400005],
              [-116.76207434799994, 76.57314687700006],
              [-116.78408769399994, 76.56903717700004],
              [-116.80459550699993, 76.56122467700004],
              [-116.8301488919999, 76.54458242400005],
              [-116.84483801999994, 76.54026927300004],
              [-116.9597875639999, 76.55573151200008],
              [-117.00792395699995, 76.55215078300006],
              [-117.07477779899995, 76.52606842700004],
              [-117.07762610599991, 76.51959870000007],
              [-117.07152258999992, 76.50657786700003],
              [-117.05785071499992, 76.49469635600008],
              [-117.03990637899994, 76.48916250200006],
              [-117.02057857999989, 76.48533763200004],
              [-117.00259355399993, 76.47870514500005],
              [-117.0100805329999, 76.47186920800004],
              [-116.98643958199995, 76.46238841400003],
              [-116.98949133999992, 76.45075104400007],
              [-116.99852454299992, 76.43683502800008],
              [-116.99303137899994, 76.42035553600005],
              [-116.95620683499993, 76.40180084800005],
              [-116.94188391799992, 76.38987864800004],
              [-116.94798743399991, 76.37689850500004],
              [-116.94391842399995, 76.37164948100008],
              [-116.93846594999991, 76.36115143400008],
              [-116.93431555899991, 76.35578034100007],
              [-116.94920813699991, 76.34609609600005],
              [-116.96825110599991, 76.33978913000004],
              [-116.98839270699995, 76.33633047100005],
              [-117.00633704299992, 76.33527252800008],
              [-117.02627519399994, 76.33185455900008],
              [-117.13634192599994, 76.29022858300004],
              [-117.27696692599994, 76.28001536700003],
              [-117.33055579299992, 76.26178620000007],
              [-117.35244706899994, 76.25958893400008],
              [-117.57140051999994, 76.27163320500006],
              [-117.63963782499991, 76.29092031500005],
              [-117.66051184799994, 76.29433828300006],
              [-117.65127519399994, 76.31679922100005],
              [-117.67625891799992, 76.32660553600005],
              [-117.81859290299991, 76.32514069200005],
              [-117.85802161399994, 76.33047109600005],
              [-117.88023841099994, 76.34902578300006],
              [-117.86656653599994, 76.34902578300006],
              [-118.00698808499993, 76.40249258000006],
              [-118.05842037699995, 76.41038646000004],
              [-118.05337480399993, 76.41571686400005],
              [-118.04678300699993, 76.42108795800004],
              [-118.03107662699995, 76.43085358300004],
              [-118.03677324099993, 76.43414948100008],
              [-118.0515844389999, 76.44513580900008],
              [-117.99010169199994, 76.46564362200007],
              [-118.00951087099992, 76.47846100500004],
              [-118.02000891799992, 76.48305898600006],
              [-118.03107662699995, 76.48615143400008],
              [-118.01012122299994, 76.50503164300005],
              [-117.90758216099994, 76.53335195500006],
              [-117.91795813699991, 76.54531484600005],
              [-117.9553930329999, 76.56806061400005],
              [-117.94273841099994, 76.57221100500004],
              [-117.91881262899994, 76.57689036700003],
              [-117.90758216099994, 76.58173248900005],
              [-117.96129309799994, 76.59210846600007],
              [-117.97647050699993, 76.60219961100006],
              [-117.93736731699994, 76.61969635600008],
              [-117.90074622299994, 76.64321523600006],
              [-117.90859941299993, 76.64789459800005],
              [-117.91808020699995, 76.65615469000005],
              [-117.92564856699994, 76.66657135600008],
              [-117.92808997299994, 76.67792389500005],
              [-117.91856848899994, 76.69334544500003],
              [-117.89940344999991, 76.70050690300008],
              [-117.85948645699995, 76.70868561400005],
              [-117.76423092399995, 76.75706614800004],
              [-117.73623613199993, 76.78034088700008],
              [-117.7730199859999, 76.81098053600005],
              [-117.81851152299993, 76.82469310100004],
              [-117.86579342399995, 76.82330963700008],
              [-117.90758216099994, 76.80829498900005],
              [-117.95665442599994, 76.78188711100006],
              [-117.98102779899995, 76.77326080900008],
              [-118.01060950399994, 76.76727936400005],
              [-118.04702714799993, 76.76430898600006],
              [-118.33983313699991, 76.77130768400008],
              [-118.33788001199991, 76.76512278900003],
              [-118.31777910099993, 76.75556061400005],
              [-118.30540930899991, 76.74310944200005],
              [-118.30724036399994, 76.72113678600005],
              [-118.31427975199995, 76.71149323100008],
              [-118.32868404899995, 76.70994700700004],
              [-118.49665279899995, 76.71889883000006],
              [-118.48892167899993, 76.71198151200008],
              [-118.4805395169999, 76.70612213700008],
              [-118.47154700399994, 76.70148346600007],
              [-118.4624731109999, 76.69843170800004],
              [-118.46617591099994, 76.69513580900008],
              [-118.47256425699993, 76.68732330900008],
              [-118.4761449859999, 76.68414948100008],
              [-118.43297278599994, 76.66913483300004],
              [-118.38597571499992, 76.66083405200004],
              [-118.34821529899995, 76.64459870000007],
              [-118.32599850199995, 76.58978913000004],
              [-118.30211341099994, 76.56769440300008],
              [-118.30540930899991, 76.55499909100007],
              [-118.32778886599993, 76.54975006700005],
              [-118.43517005099994, 76.55499909100007],
              [-118.47984778599994, 76.54523346600007],
              [-118.49038652299993, 76.54071686400005],
              [-118.49522864499994, 76.53440989800004],
              [-118.49449622299994, 76.52887604400007],
              [-118.49518795499989, 76.52265045800004],
              [-118.50405839799993, 76.51406484600005],
              [-118.53490149599992, 76.50381094000005],
              [-118.67300370999993, 76.51068756700005],
              [-118.69351152299993, 76.52049388200004],
              [-118.72996985599991, 76.54413483300004],
              [-118.75597083199995, 76.55198802300004],
              [-118.79287675699993, 76.55768463700008],
              [-118.82921301999994, 76.55939362200007],
              [-118.85350501199991, 76.55499909100007],
              [-118.83755449099993, 76.54686107000003],
              [-118.8176977199999, 76.54035065300008],
              [-118.77774003799993, 76.53335195500006],
              [-118.82526607999989, 76.52826569200005],
              [-118.88866126199991, 76.52977122600004],
              [-118.94627844999991, 76.52285390800006],
              [-118.97642981699994, 76.49233633000006],
              [-118.94277910099993, 76.48578522300005],
              [-118.84044348899994, 76.47870514500005],
              [-118.83185787699995, 76.47435130400004],
              [-118.82481848899994, 76.46759674700007],
              [-118.82022050699993, 76.46149323100008],
              [-118.81871497299994, 76.45880768400008],
              [-118.79865475199995, 76.45612213700008],
              [-118.73338782499991, 76.45880768400008],
              [-118.70445716099994, 76.45563385600008],
              [-118.67430579299992, 76.44660065300008],
              [-118.64639238199993, 76.43244049700007],
              [-118.59707597599993, 76.38784414300005],
              [-118.59483801999994, 76.37636953300006],
              [-118.61392167899993, 76.36945221600007],
              [-118.57135982999989, 76.35162995000007],
              [-118.56895911399994, 76.34520091400003],
              [-118.57994544199994, 76.33600495000007],
              [-118.60509192599994, 76.32119375200006],
              [-118.61729895699995, 76.31142812700006],
              [-118.65160071499992, 76.29108307500007],
              [-118.69277910099993, 76.28449127800008],
              [-118.86046301999994, 76.28481679900005],
              [-118.8997289699999, 76.27509186400005],
              [-118.92857825399994, 76.25336334800005],
              [-118.93691972599993, 76.22968170800004],
              [-118.93163001199991, 76.20612213700008],
              [-118.91445878799993, 76.18895091400003],
              [-118.88760331899994, 76.18447500200006],
              [-118.90103105399993, 76.17226797100005],
              [-118.94444739499994, 76.17129140800006],
              [-118.96336829299992, 76.16400788000004],
              [-118.96743730399993, 76.15200429900005],
              [-118.96178137899994, 76.14301178600005],
              [-118.96353105399993, 76.13572825700004],
              [-118.99006100199995, 76.12921784100007],
              [-119.03693600199995, 76.12897370000007],
              [-119.0586645169999, 76.12641022300005],
              [-119.07945716099994, 76.11562734600005],
              [-119.0803930329999, 76.11078522300005],
              [-119.07852128799993, 76.10358307500007],
              [-119.07542883999992, 76.09739817900004],
              [-119.07262122299994, 76.09568919500003],
              [-119.08385169199994, 76.08958567900004],
              [-119.09532630099994, 76.08832428600005],
              [-119.12059485599991, 76.09373607000003],
              [-119.16071529899995, 76.10765208500004],
              [-119.1809789699999, 76.11204661700003],
              [-119.2219945949999, 76.10944245000007],
              [-119.24486243399991, 76.11318594000005],
              [-119.26724199099993, 76.12030670800004],
              [-119.28551184799994, 76.12921784100007],
              [-119.30256100199995, 76.14931875200006],
              [-119.30333411399994, 76.18744538000004],
              [-119.31749426999994, 76.19989655200004],
            ],
          ],
          [
            [
              [-85.16222083199995, 77.45872630400004],
              [-85.17894446499992, 77.46417877800008],
              [-85.17027747299994, 77.47675202000005],
              [-85.13829505099994, 77.49970123900005],
              [-85.15485592399995, 77.51251862200007],
              [-85.17642167899993, 77.51675039300005],
              [-85.19945227799991, 77.51845937700006],
              [-85.24437415299991, 77.53245677300004],
              [-85.54238847599993, 77.54071686400005],
              [-85.52529863199993, 77.54832591400003],
              [-85.46727454299992, 77.55491771000004],
              [-85.44981848899994, 77.55951569200005],
              [-85.41478430899991, 77.57269928600005],
              [-85.3797094389999, 77.57758209800005],
              [-85.34268144399994, 77.58698151200008],
              [-85.32331295499995, 77.58909739800004],
              [-85.0183813139999, 77.58348216400003],
              [-84.99087480399993, 77.57200755400004],
              [-84.94627844999991, 77.53522370000007],
              [-84.93285071499992, 77.52765534100007],
              [-84.90318762899994, 77.52147044500003],
              [-84.8731176419999, 77.52024974200003],
              [-84.84365800699993, 77.51581452000005],
              [-84.81623287699995, 77.49970123900005],
              [-84.87047278599994, 77.48273346600007],
              [-85.04893958199995, 77.45872630400004],
              [-85.16222083199995, 77.45872630400004],
            ],
          ],
          [
            [
              [-89.66128495999993, 77.35635000200006],
              [-89.64452063699991, 77.34341054900005],
              [-89.64500891799992, 77.33307526200008],
              [-89.65713456899994, 77.32416413000004],
              [-89.79088294199994, 77.27069733300004],
              [-90.09390214799993, 77.20408763200004],
              [-90.16519120999993, 77.21303945500006],
              [-90.20091712099992, 77.21124909100007],
              [-90.23607337099992, 77.20547109600005],
              [-90.36253821499992, 77.19891998900005],
              [-90.40501868399991, 77.20319245000007],
              [-90.41820227799991, 77.20892975500004],
              [-90.41710364499994, 77.21381256700005],
              [-90.39476477799991, 77.22410716400003],
              [-90.3875219389999, 77.23338450700004],
              [-90.65599524649991, 77.27020905150005],
              [-90.92446855399993, 77.30703359600005],
              [-91.05508378799993, 77.35293203300006],
              [-91.10220292899993, 77.36249420800004],
              [-91.11701412699995, 77.37250397300005],
              [-91.13219153599994, 77.38544342700004],
              [-91.17951412699995, 77.39419179900005],
              [-91.19961503799993, 77.40786367400005],
              [-91.20205644399994, 77.41966380400004],
              [-91.19367428299995, 77.43235911700003],
              [-91.18040930899991, 77.44403717700004],
              [-91.16832434799994, 77.45254140800006],
              [-91.19517981699994, 77.50897858300004],
              [-91.20929928299995, 77.52020905200004],
              [-91.19701087099992, 77.53310781500005],
              [-91.1902563139999, 77.53750234600005],
              [-91.18199622299994, 77.54071686400005],
              [-91.18659420499995, 77.55125560100004],
              [-91.20929928299995, 77.57538483300004],
              [-91.20067298099991, 77.58022695500006],
              [-91.19286048099991, 77.58852773600006],
              [-91.18639075399994, 77.59882233300004],
              [-91.18199622299994, 77.60956452000005],
              [-91.16869055899991, 77.61749909100007],
              [-91.12051347599993, 77.62323639500005],
              [-91.09162350199995, 77.61684804900005],
              [-91.05532792899993, 77.62156810100004],
              [-90.95547441299993, 77.65131256700005],
              [-90.88170325399994, 77.65770091400003],
              [-90.59290523999994, 77.64354075750003],
              [-90.30410722599993, 77.62938060100004],
              [-90.22769120999993, 77.61151764500005],
              [-90.21719316299993, 77.60639069200005],
              [-90.2129613919999, 77.60199616100005],
              [-90.2097875639999, 77.59747955900008],
              [-90.20250403599994, 77.59251536700003],
              [-90.18472245999993, 77.58685944200005],
              [-90.1453344389999, 77.58331940300008],
              [-89.77574622299994, 77.48639557500007],
              [-89.71593176999994, 77.45872630400004],
              [-89.7239477199999, 77.44379303600005],
              [-89.71947180899991, 77.42470937700006],
              [-89.70807857999995, 77.40550364800004],
              [-89.69481360599991, 77.39044830900008],
              [-89.70352128799993, 77.38947174700007],
              [-89.71239173099991, 77.38597239800004],
              [-89.71768144399994, 77.37958405200004],
              [-89.71593176999994, 77.37002187700006],
              [-89.70421301999994, 77.35956452000005],
              [-89.68984941299993, 77.35797760600008],
              [-89.67491614499994, 77.35895416900007],
              [-89.66128495999993, 77.35635000200006],
            ],
          ],
          [
            [
              [-104.39452063699991, 77.19253164300005],
              [-104.4500219389999, 77.15176015800006],
              [-104.51357988199993, 77.14069245000007],
              [-104.64781653599994, 77.13727448100008],
              [-104.75401770699995, 77.11123281500005],
              [-104.79116777299993, 77.10993073100008],
              [-104.82579505099994, 77.11566803600005],
              [-104.85619055899991, 77.12616608300004],
              [-104.9153539699999, 77.15399811400005],
              [-104.95807857999995, 77.16771067900004],
              [-105.00576738199993, 77.17495351800005],
              [-105.0996801419999, 77.17816803600005],
              [-105.1831762359999, 77.16600169500003],
              [-105.22459876199991, 77.16449616100005],
              [-105.26414954299992, 77.17816803600005],
              [-105.2503149079999, 77.19891998900005],
              [-105.24364173099991, 77.20551178600005],
              [-105.27806555899991, 77.21503327000005],
              [-105.35777747299994, 77.21185944200005],
              [-105.39513098899994, 77.21918366100005],
              [-105.39513098899994, 77.22601959800005],
              [-105.37743079299992, 77.21954987200007],
              [-105.3562719389999, 77.21723053600005],
              [-105.3355199859999, 77.21922435100004],
              [-105.31875566299993, 77.22601959800005],
              [-105.35212154899995, 77.24567291900007],
              [-105.39077714799993, 77.25893789300005],
              [-105.46959387899994, 77.27440013200004],
              [-105.45604407499991, 77.28021881700005],
              [-105.44050045499995, 77.28180573100008],
              [-105.40819251199991, 77.28058502800008],
              [-105.40819251199991, 77.28742096600007],
              [-105.49046790299991, 77.29482656500005],
              [-105.53628495999993, 77.30442942900004],
              [-105.56578528599994, 77.32160065300008],
              [-105.5718481109999, 77.33193594000005],
              [-105.57225501199991, 77.33926015800006],
              [-105.56578528599994, 77.35635000200006],
              [-105.55003821499992, 77.36595286700003],
              [-105.54405676999994, 77.37083567900004],
              [-105.55150305899991, 77.37002187700006],
              [-105.57135982999995, 77.38080475500004],
              [-105.60138912699995, 77.38446686400005],
              [-105.66136633999992, 77.38361237200007],
              [-105.65615800699993, 77.39252350500004],
              [-105.64883378799993, 77.39769114800004],
              [-105.62783769399994, 77.40412018400008],
              [-105.64134680899991, 77.41103750200006],
              [-105.68932044199994, 77.42523834800005],
              [-105.6597387359999, 77.44098541900007],
              [-105.68106035099993, 77.45307038000004],
              [-105.76504472599993, 77.46621328300006],
              [-105.75548255099994, 77.47955963700008],
              [-105.74132239499994, 77.48541901200008],
              [-105.72520911399994, 77.48847077000005],
              [-105.70982825399994, 77.49347565300008],
              [-105.68862870999993, 77.50714752800008],
              [-105.68163001199991, 77.51618073100008],
              [-105.69273841099994, 77.52020905200004],
              [-105.71324622299994, 77.52244700700004],
              [-105.75641842399995, 77.53221263200004],
              [-105.84203040299991, 77.54157135600008],
              [-105.8606664699999, 77.54816315300008],
              [-105.82656816299993, 77.56024811400005],
              [-105.82103430899991, 77.56793854400007],
              [-105.83950761599993, 77.57538483300004],
              [-105.8262426419999, 77.59568919500003],
              [-105.84422766799992, 77.62026601800005],
              [-105.87572180899991, 77.64252350500004],
              [-105.9031469389999, 77.65607330900008],
              [-106.05016028599994, 77.69497304900005],
              [-106.08967037699995, 77.71637604400007],
              [-106.09365800699993, 77.72964101800005],
              [-106.07721920499995, 77.73859284100007],
              [-105.90876217399995, 77.76788971600007],
              [-105.64834550699993, 77.75421784100007],
              [-105.60265051999994, 77.73965078300006],
              [-105.50304114499994, 77.72109609600005],
              [-105.24956214099993, 77.62909577050004],
              [-104.99608313699991, 77.53709544500003],
              [-104.96621660099993, 77.51679108300004],
              [-104.95201575399994, 77.48700592700004],
              [-104.97655188699991, 77.47207265800006],
              [-105.00621497299994, 77.46084219000005],
              [-105.00747636599993, 77.44196198100008],
              [-105.00690670499995, 77.43203359600005],
              [-105.01378333199995, 77.42210521000004],
              [-105.01585852799991, 77.41461823100008],
              [-105.00064042899993, 77.41160716400003],
              [-104.79234778599994, 77.42202383000006],
              [-104.74852454299992, 77.41766998900005],
              [-104.72972571499992, 77.39386627800008],
              [-104.7039281889999, 77.38275788000004],
              [-104.5432836579999, 77.34430573100008],
              [-104.50495357999995, 77.32632070500006],
              [-104.4895727199999, 77.32160065300008],
              [-104.43716386599993, 77.31488678600005],
              [-104.42125403599994, 77.30792877800008],
              [-104.43651282499991, 77.30410390800006],
              [-104.4514867829999, 77.30198802300004],
              [-104.46507727799991, 77.29783763200004],
              [-104.47647050699993, 77.28742096600007],
              [-104.44566809799994, 77.27802155200004],
              [-104.41909745999993, 77.27741120000007],
              [-104.39720618399991, 77.27326080900008],
              [-104.38027910099993, 77.25332265800006],
              [-104.37108313699991, 77.23476797100005],
              [-104.3738500639999, 77.23151276200008],
              [-104.39452063699991, 77.19253164300005],
            ],
          ],
          [
            [
              [-93.2520238919999, 77.64435455900008],
              [-93.33617102799991, 77.64472077000005],
              [-93.37466386599993, 77.63397858300004],
              [-93.4090063139999, 77.60956452000005],
              [-93.39989173099991, 77.60651276200008],
              [-93.39093990799995, 77.60187409100007],
              [-93.38243567599994, 77.59601471600007],
              [-93.37486731699994, 77.58909739800004],
              [-93.47789466099994, 77.55866120000007],
              [-93.48131262899994, 77.55198802300004],
              [-93.48790442599994, 77.54804108300004],
              [-93.49201412699995, 77.54413483300004],
              [-93.48184160099993, 77.52777741100005],
              [-93.48477128799993, 77.51976146000004],
              [-93.4937231109999, 77.51300690300008],
              [-93.50584876199991, 77.50714752800008],
              [-93.47842363199993, 77.48810455900008],
              [-93.5015356109999, 77.46405670800004],
              [-93.54552161399994, 77.44481028900003],
              [-93.58096269399994, 77.44017161700003],
              [-93.64557857999995, 77.45282623900005],
              [-93.67747962099992, 77.45282623900005],
              [-93.71043860599991, 77.44749583500004],
              [-93.74156653599994, 77.44578685100004],
              [-93.80882727799991, 77.45758698100008],
              [-93.84097245999993, 77.45872630400004],
              [-93.82518469999991, 77.45254140800006],
              [-93.7840063139999, 77.44562409100007],
              [-93.76593990799995, 77.44574616100005],
              [-93.78453528599994, 77.43773021000004],
              [-93.80768795499995, 77.43870677300004],
              [-93.85407467399995, 77.44574616100005],
              [-93.95767167899993, 77.43829987200007],
              [-93.95612545499995, 77.44208405200004],
              [-93.95518958199995, 77.44525788000004],
              [-93.95376542899993, 77.44855377800008],
              [-93.95083574099993, 77.45254140800006],
              [-93.97557532499991, 77.45986562700006],
              [-94.00479081899994, 77.46137116100005],
              [-94.08849036399994, 77.45050690300008],
              [-94.22769120999993, 77.45746491100005],
              [-94.33079993399991, 77.47748444200005],
              [-94.74500484924991, 77.47788117050005],
              [-95.1592097644999, 77.47827789900006],
              [-95.5734146797499, 77.47867462750007],
              [-95.9876195949999, 77.47907135600008],
              [-96.07640540299991, 77.49811432500007],
              [-96.09040279899995, 77.50421784100007],
              [-96.12267005099994, 77.52765534100007],
              [-96.30247962099992, 77.59332916900007],
              [-96.32872473899994, 77.60956452000005],
              [-96.30772864499994, 77.61078522300005],
              [-96.28477942599994, 77.61554596600007],
              [-96.27505449099993, 77.62238190300008],
              [-96.29393469999991, 77.63007233300004],
              [-96.28604081899994, 77.63776276200008],
              [-96.28246008999992, 77.64350006700005],
              [-96.28302975199995, 77.64956289300005],
              [-96.28774980399993, 77.65802643400008],
              [-96.2573949859999, 77.65745677300004],
              [-96.25328528599994, 77.66644928600005],
              [-96.25959225199995, 77.67963288000004],
              [-96.26040605399993, 77.69147370000007],
              [-96.23546301999994, 77.70551178600005],
              [-96.12950598899994, 77.71328359600005],
              [-96.04015051999994, 77.73688385600008],
              [-95.97834225199995, 77.74274323100008],
              [-95.89671790299991, 77.76044342700004],
              [-95.72354081899994, 77.77163320500006],
              [-95.69151770699995, 77.77952708500004],
              [-95.67516028599994, 77.78025950700004],
              [-95.6414281889999, 77.77366771000004],
              [-95.62409420499995, 77.77594635600008],
              [-95.50649980399993, 77.81073639500005],
              [-95.4441625639999, 77.81126536700003],
              [-95.40322831899994, 77.78148021000004],
              [-95.41258704299992, 77.75942617400005],
              [-95.40151933499993, 77.74681224200003],
              [-95.37946529899995, 77.74127838700008],
              [-95.35545813699991, 77.73993561400005],
              [-95.33413652299993, 77.74750397300005],
              [-95.31427975199995, 77.76162344000005],
              [-95.29356848899994, 77.76923248900005],
              [-95.24095618399991, 77.74591705900008],
              [-95.19961503799993, 77.74591705900008],
              [-95.08535722599993, 77.75861237200007],
              [-94.98493404899995, 77.78774648600006],
              [-94.94835364499994, 77.79144928600005],
              [-94.65162106049993, 77.78276194850005],
              [-94.35488847599993, 77.77407461100006],
              [-94.36856035099993, 77.76044342700004],
              [-94.30028235599991, 77.76044342700004],
              [-94.31021074099993, 77.77090078300006],
              [-94.31395423099991, 77.77407461100006],
              [-94.17739824099993, 77.76044342700004],
              [-94.13923092399995, 77.76072825700004],
              [-94.06297766799992, 77.77338288000004],
              [-94.02599036399994, 77.76410553600005],
              [-94.00885982999995, 77.75731028900003],
              [-93.97337805899991, 77.74933502800008],
              [-93.94001217399995, 77.73725006700005],
              [-93.92955481699994, 77.73916250200006],
              [-93.92113196499992, 77.74396393400008],
              [-93.90957597599993, 77.74677155200004],
              [-93.84797115799995, 77.73749420800004],
              [-93.82730058499993, 77.73993561400005],
              [-93.81700598899994, 77.74628327000005],
              [-93.80752519399994, 77.75568268400008],
              [-93.79580644399994, 77.76410553600005],
              [-93.7788793609999, 77.76788971600007],
              [-93.60802161399994, 77.78148021000004],
              [-93.56908118399991, 77.77757396000004],
              [-93.45738684799994, 77.75421784100007],
              [-93.42292232999995, 77.75739166900007],
              [-93.40697180899991, 77.75714752800008],
              [-93.36880449099993, 77.74286530200004],
              [-93.34854081899994, 77.73993561400005],
              [-93.27017167899993, 77.73851146000004],
              [-93.23827063699991, 77.73334381700005],
              [-93.20791581899994, 77.72296784100007],
              [-93.17625891799992, 77.70579661700003],
              [-93.16038977799991, 77.69281647300005],
              [-93.1011449859999, 77.66421133000006],
              [-93.2117406889999, 77.64411041900007],
              [-93.2520238919999, 77.64435455900008],
            ],
          ],
          [
            [
              [-77.57274329299992, 77.85663483300004],
              [-77.58706620999993, 77.84495677300004],
              [-77.59325110599991, 77.84235260600008],
              [-77.59325110599991, 77.83612702000005],
              [-77.58128821499992, 77.82611725500004],
              [-77.59658769399994, 77.81659577000005],
              [-77.67178300699993, 77.79661692900004],
              [-77.76382402299993, 77.79515208500004],
              [-77.85260982999995, 77.77924225500004],
              [-77.88121497299994, 77.78461334800005],
              [-77.92031816299993, 77.80829498900005],
              [-77.95628821499992, 77.83612702000005],
              [-77.88927161399994, 77.85285065300008],
              [-77.65050208199995, 77.87091705900008],
              [-77.59520423099991, 77.86367422100005],
              [-77.57274329299992, 77.85663483300004],
            ],
          ],
          [
            [
              [-102.44871985599991, 77.73993561400005],
              [-102.43614661399994, 77.73916250200006],
              [-102.42564856699994, 77.74241771000004],
              [-102.41783606699994, 77.74949778900003],
              [-102.41331946499992, 77.76044342700004],
              [-102.4370824859999, 77.76243724200003],
              [-102.46890214799993, 77.77057526200008],
              [-102.49889075399994, 77.78237539300005],
              [-102.51699785099993, 77.79515208500004],
              [-102.49913489499994, 77.80927155200004],
              [-102.5008031889999, 77.81932200700004],
              [-102.53062903599994, 77.83612702000005],
              [-102.49518795499995, 77.86473216400003],
              [-102.44847571499992, 77.88129303600005],
              [-102.39818274599992, 77.88886139500005],
              [-102.10179602749992, 77.89213694850005],
              [-101.80540930899991, 77.89541250200006],
              [-101.72520911399994, 77.90648021000004],
              [-101.69810950399994, 77.90521881700005],
              [-101.64517167899993, 77.89032623900005],
              [-101.21434485599991, 77.84072500200006],
              [-100.95815995999993, 77.76032135600008],
              [-100.93199622299994, 77.74453359600005],
              [-100.96068274599992, 77.72850169500003],
              [-100.98672441299993, 77.72638580900008],
              [-101.04259192599994, 77.73086172100005],
              [-101.14757239499994, 77.71979401200008],
              [-101.34166419199994, 77.73012929900005],
              [-101.39891516799992, 77.72138092700004],
              [-101.44635982999995, 77.72052643400008],
              [-101.50279700399994, 77.72898997600004],
              [-101.55797278599994, 77.73069896000004],
              [-101.62096106699994, 77.70087311400005],
              [-101.7905981109999, 77.67938873900005],
              [-102.17634029899995, 77.69513580900008],
              [-102.29043535099993, 77.71942780200004],
              [-102.44871985599991, 77.73309967700004],
              [-102.44871985599991, 77.73993561400005],
            ],
          ],
          [
            [
              [-113.68626868399991, 77.86660390800006],
              [-113.67149817599994, 77.84593333500004],
              [-113.60094153599994, 77.83242422100005],
              [-113.57701575399994, 77.81500885600008],
              [-113.60423743399991, 77.81085846600007],
              [-113.72248287699995, 77.76923248900005],
              [-114.16258704299992, 77.70673248900005],
              [-114.30068925699993, 77.71328359600005],
              [-114.47960364499994, 77.75141022300005],
              [-114.62132727799991, 77.75682200700004],
              [-114.65269934799994, 77.76788971600007],
              [-114.62287350199995, 77.77411530200004],
              [-114.51610266799992, 77.76044342700004],
              [-114.53799394399994, 77.78302643400008],
              [-114.58193925699993, 77.79645416900007],
              [-114.66698157499991, 77.80817291900007],
              [-114.79824785099993, 77.85032786700003],
              [-114.85781816299993, 77.85980866100005],
              [-115.11823482999989, 77.95966217700004],
              [-115.09707597599993, 77.96613190300008],
              [-115.06932532499991, 77.96893952000005],
              [-115.04067949099993, 77.96824778900003],
              [-114.99071204299992, 77.95799388200004],
              [-114.9683324859999, 77.95677317900004],
              [-114.94762122299994, 77.95966217700004],
              [-114.89891516799992, 77.97357819200005],
              [-114.79507402299993, 77.98285553600005],
              [-114.76732337099992, 77.99005768400008],
              [-114.74111894399994, 77.99994538000004],
              [-114.67967688699991, 78.03449127800008],
              [-114.50186113199993, 78.04840729400007],
              [-114.38882402299993, 78.07660553600005],
              [-114.32725989499994, 78.08079661700003],
              [-114.2827856109999, 78.06207916900007],
              [-114.29385331899994, 78.05231354400007],
              [-114.35098222599993, 78.03473541900007],
              [-114.33193925699993, 78.02741120000007],
              [-114.2691137359999, 78.01422760600008],
              [-114.31688391799992, 78.01422760600008],
              [-114.25780188699991, 77.98944733300004],
              [-114.11461341099994, 78.00043366100005],
              [-114.06362870999993, 77.97264232000003],
              [-114.0698949859999, 77.97264232000003],
              [-113.98741614499994, 77.93744538000004],
              [-113.97427324099993, 77.92829010600008],
              [-113.95132402299993, 77.91885000200006],
              [-113.73729407499991, 77.90167877800008],
              [-113.70152747299994, 77.89036692900004],
              [-113.68626868399991, 77.86660390800006],
            ],
          ],
          [
            [
              [-109.60366777299993, 78.07391998900005],
              [-109.58153235599991, 78.05410390800006],
              [-109.60155188699991, 78.03204987200007],
              [-109.66051184799994, 77.99689362200007],
              [-109.67625891799992, 77.97699616100005],
              [-109.68614661399994, 77.97138092700004],
              [-109.78685462099992, 77.94977448100008],
              [-110.0036921869999, 77.93138255400004],
              [-110.12393144399994, 77.92121002800008],
              [-110.22476152299993, 77.89801666900007],
              [-110.53311113199993, 77.88391754800006],
              [-110.84146074099993, 77.86981842700004],
              [-110.90371660099993, 77.85321686400005],
              [-110.88036048099991, 77.82123444200005],
              [-110.77749589799993, 77.80365631700005],
              [-110.75413977799991, 77.78461334800005],
              [-110.71996008999992, 77.76618073100008],
              [-110.4082738919999, 77.77338288000004],
              [-110.34463456899994, 77.78485748900005],
              [-110.12950598899994, 77.78148021000004],
              [-110.10789954299992, 77.77619049700007],
              [-110.08824622299994, 77.76447174700007],
              [-110.08079993399991, 77.75250885600008],
              [-110.09557044199994, 77.74677155200004],
              [-110.09089107999995, 77.73696523600006],
              [-110.0882055329999, 77.73309967700004],
              [-110.11192786399994, 77.70766836100006],
              [-110.11607825399994, 77.70579661700003],
              [-110.11070716099994, 77.69245026200008],
              [-110.09801184799994, 77.68333567900004],
              [-110.06826738199993, 77.67161692900004],
              [-110.0718481109999, 77.66844310100004],
              [-110.07823645699995, 77.66111888200004],
              [-110.08189856699994, 77.65802643400008],
              [-110.07249915299991, 77.65200429900005],
              [-110.06240800699993, 77.64765045800004],
              [-110.05190995999993, 77.64516836100006],
              [-110.04100501199991, 77.64435455900008],
              [-110.05589758999992, 77.63202545800004],
              [-110.07823645699995, 77.62482330900008],
              [-110.12352454299992, 77.61701080900008],
              [-110.14818274599992, 77.60936107000003],
              [-110.16368567599994, 77.60016510600008],
              [-110.16079667899993, 77.59235260600008],
              [-110.10777747299994, 77.58746979400007],
              [-110.09215247299994, 77.58197663000004],
              [-110.08682206899994, 77.57147858300004],
              [-110.09557044199994, 77.55491771000004],
              [-110.11388098899994, 77.54271067900004],
              [-110.16234290299991, 77.53180573100008],
              [-110.23542232999995, 77.50421784100007],
              [-110.57262122299994, 77.45530833500004],
              [-110.70938066299993, 77.45282623900005],
              [-110.74718176999994, 77.44501373900005],
              [-110.78807532499991, 77.44574616100005],
              [-110.79898027299993, 77.44330475500004],
              [-110.82860266799992, 77.42523834800005],
              [-110.88072669199994, 77.41242096600007],
              [-111.19322669199994, 77.42108795800004],
              [-111.25096594999991, 77.43268463700008],
              [-111.28111731699994, 77.43146393400008],
              [-111.40123450399994, 77.40350983300004],
              [-111.88385982999995, 77.35317617400005],
              [-111.99083411399994, 77.32929108300004],
              [-112.10924231699994, 77.32575104400007],
              [-112.46930904899995, 77.37059153900003],
              [-112.49396725199995, 77.38027578300006],
              [-112.50633704299992, 77.38800690300008],
              [-112.53490149599992, 77.41160716400003],
              [-112.60057532499991, 77.45368073100008],
              [-112.63744055899991, 77.46405670800004],
              [-112.67906653599994, 77.46067942900004],
              [-112.7285863919999, 77.45111725500004],
              [-112.77782141799992, 77.44843170800004],
              [-112.92760169199994, 77.46478913000004],
              [-112.95498613199993, 77.47101471600007],
              [-112.96690833199995, 77.48330312700006],
              [-112.97427324099993, 77.50189850500004],
              [-112.99233964799993, 77.51105377800008],
              [-113.03506425699993, 77.51845937700006],
              [-113.16588294199994, 77.51508209800005],
              [-113.19961503799993, 77.52765534100007],
              [-113.20840410099993, 77.54368724200003],
              [-113.21178137899994, 77.56159088700008],
              [-113.21947180899991, 77.57607656500005],
              [-113.24128170499989, 77.58226146000004],
              [-113.2161352199999, 77.60040924700007],
              [-113.12352454299992, 77.61440664300005],
              [-113.08975175699993, 77.62323639500005],
              [-113.10997473899994, 77.63206614800004],
              [-113.17918860599991, 77.65058014500005],
              [-113.17235266799992, 77.65058014500005],
              [-113.19029700399994, 77.65843333500004],
              [-113.2337133449999, 77.66400788000004],
              [-113.25426184799994, 77.67161692900004],
              [-113.23814856699994, 77.67450592700004],
              [-113.21922766799992, 77.68203359600005],
              [-113.20677649599992, 77.69379303600005],
              [-113.21019446499992, 77.70954010600008],
              [-113.23086503799993, 77.72304922100005],
              [-113.23379472599993, 77.72687409100007],
              [-113.22667395699995, 77.73444245000007],
              [-113.21275794199994, 77.73834870000007],
              [-113.18602454299992, 77.73993561400005],
              [-113.26781165299991, 77.75983307500007],
              [-113.30557206899994, 77.77684153900003],
              [-113.32315019399994, 77.80817291900007],
              [-113.31212317599994, 77.83877187700006],
              [-113.28213456899994, 77.86237213700008],
              [-113.21328691299993, 77.89077383000006],
              [-113.24128170499989, 77.90497467700004],
              [-113.14110266799992, 77.92251211100006],
              [-113.08511308499993, 77.92267487200007],
              [-113.04539954299992, 77.90814850500004],
              [-113.02855383999992, 77.89935944200005],
              [-113.00609290299991, 77.89614492400005],
              [-112.98151607999995, 77.89760976800005],
              [-112.95824133999992, 77.90306224200003],
              [-112.94570878799993, 77.91107819200005],
              [-112.93651282499991, 77.92129140800006],
              [-112.92491614499994, 77.92959219000005],
              [-112.90542558499993, 77.93170807500007],
              [-112.9116918609999, 77.93170807500007],
              [-112.59129798099991, 77.97351715700006],
              [-112.27090410099993, 78.01532623900005],
              [-112.22459876199991, 78.00922272300005],
              [-112.16905676999994, 78.00787995000007],
              [-112.05630449099993, 78.02407461100006],
              [-111.95055091099994, 78.02130768400008],
              [-111.82412675699993, 78.05263906500005],
              [-111.7991430329999, 78.05174388200004],
              [-111.78819739499994, 78.03815338700008],
              [-111.77489173099991, 78.02952708500004],
              [-111.74453691299993, 78.02741120000007],
              [-111.71165930899991, 78.02924225500004],
              [-111.69066321499992, 78.03278229400007],
              [-111.6394750639999, 78.04816315300008],
              [-111.52717037699995, 78.06708405200004],
              [-111.39195716099994, 78.07196686400005],
              [-111.27806555899991, 78.09003327000005],
              [-111.20653235599991, 78.08246491100005],
              [-111.00763912699995, 78.09686920800004],
              [-111.00137285099993, 78.09516022300005],
              [-111.0003149079999, 78.09080638200004],
              [-111.00011145699995, 78.08515045800004],
              [-110.99681555899991, 78.07916901200008],
              [-110.97988847599993, 78.07322825700004],
              [-110.86050370999993, 78.06875234600005],
              [-110.82290605399993, 78.07416413000004],
              [-110.7117406889999, 78.10382721600007],
              [-110.3577164379999, 78.10156891500006],
              [-110.0036921869999, 78.09931061400005],
              [-109.69717363199993, 78.09735748900005],
              [-109.60366777299993, 78.07391998900005],
            ],
          ],
          [
            [
              [-102.90054277299993, 78.27435944200005],
              [-102.83446204299992, 78.26609935100004],
              [-102.79918372299994, 78.25665924700007],
              [-102.78384355399993, 78.23704661700003],
              [-102.78209387899994, 78.22728099200003],
              [-102.77912350199995, 78.22077057500007],
              [-102.77847245999993, 78.21478913000004],
              [-102.78384355399993, 78.20673248900005],
              [-102.79918372299994, 78.20014069200005],
              [-102.86949622299994, 78.18903229400007],
              [-103.04723059799994, 78.12702057500007],
              [-103.08653723899994, 78.12238190300008],
              [-103.23424231699994, 78.12807851800005],
              [-103.2691137359999, 78.13922760600008],
              [-103.28416907499991, 78.16136302300004],
              [-103.27285722599993, 78.17942942900004],
              [-103.24681555899991, 78.19529857000003],
              [-103.06505286399994, 78.26129791900007],
              [-103.0242406889999, 78.26984284100007],
              [-102.90054277299993, 78.27435944200005],
            ],
          ],
          [
            [
              [-88.0574438139999, 78.45246002800008],
              [-88.04674231699994, 78.42324453300006],
              [-88.08039303299995, 78.39956289300005],
              [-88.16047115799995, 78.36371491100005],
              [-88.15221106699994, 78.34003327000005],
              [-88.1648656889999, 78.31683991100005],
              [-88.18724524599992, 78.29657623900005],
              [-88.2083227199999, 78.28180573100008],
              [-88.24620520699995, 78.26093170800004],
              [-88.28880774599992, 78.24677155200004],
              [-88.33385169199994, 78.24103424700007],
              [-88.37913977799991, 78.24542877800008],
              [-88.4055883449999, 78.25897858300004],
              [-88.4114477199999, 78.27936432500007],
              [-88.40127519399994, 78.30109284100007],
              [-88.37954667899993, 78.31903717700004],
              [-88.33812415299991, 78.33722565300008],
              [-88.29434160099993, 78.34894440300008],
              [-88.20140540299991, 78.35687897300005],
              [-88.20612545499995, 78.36391836100006],
              [-88.21304277299993, 78.36782461100006],
              [-88.22191321499992, 78.36953359600005],
              [-88.23216712099992, 78.36994049700007],
              [-88.24742591099994, 78.37262604400007],
              [-88.24669348899994, 78.37885163000004],
              [-88.23497473899994, 78.39105866100005],
              [-88.23542232999995, 78.40497467700004],
              [-88.2344457669999, 78.41592031500005],
              [-88.23045813699991, 78.42475006700005],
              [-88.22191321499992, 78.43260325700004],
              [-88.20791581899994, 78.43838125200006],
              [-88.19200598899994, 78.43992747600004],
              [-88.16026770699995, 78.43886953300006],
              [-88.14976966099994, 78.44098541900007],
              [-88.13097083199995, 78.45038483300004],
              [-88.08812415299991, 78.45799388200004],
              [-88.07140051999994, 78.45872630400004],
              [-88.0574438139999, 78.45246002800008],
            ],
          ],
          [
            [
              [-109.25951087099992, 78.45929596600007],
              [-109.31745357999995, 78.44196198100008],
              [-109.33433997299994, 78.42837148600006],
              [-109.31411699099993, 78.41087474200003],
              [-109.34618079299992, 78.39695872600004],
              [-109.35570227799991, 78.39105866100005],
              [-109.32510331899994, 78.37384674700007],
              [-109.33893795499995, 78.35468170800004],
              [-109.40416419199994, 78.32273997600004],
              [-109.40782630099994, 78.31785716400003],
              [-109.4063207669999, 78.31321849200003],
              [-109.40868079299992, 78.30988190300008],
              [-109.42393958199995, 78.30849844000005],
              [-109.50792395699995, 78.31647370000007],
              [-109.82323157499991, 78.29539622600004],
              [-109.87193762899994, 78.30243561400005],
              [-109.96043860599991, 78.32908763200004],
              [-110.0036921869999, 78.32900625200006],
              [-110.01305091099994, 78.32900625200006],
              [-110.33242753799993, 78.28595612200007],
              [-110.58637447799993, 78.30056386950005],
              [-110.84032141799992, 78.31517161700003],
              [-110.86278235599991, 78.32273997600004],
              [-110.86290442599994, 78.33905670800004],
              [-110.88829505099994, 78.34552643400008],
              [-110.94591223899994, 78.35004303600005],
              [-111.02611243399991, 78.37490469000005],
              [-111.1546117829999, 78.39052969000005],
              [-111.21841386599993, 78.38153717700004],
              [-111.28892981699994, 78.37982819200005],
              [-111.3152563139999, 78.36994049700007],
              [-111.29938717399995, 78.35887278900003],
              [-111.27904212099992, 78.34829336100006],
              [-111.25804602799991, 78.34007396000004],
              [-111.24010169199994, 78.33637116100005],
              [-111.27867591099994, 78.32184479400007],
              [-111.41148841099994, 78.32982005400004],
              [-111.4319555329999, 78.30849844000005],
              [-111.4258520169999, 78.30280182500007],
              [-111.40831458199995, 78.30011627800008],
              [-111.4046117829999, 78.29197825700004],
              [-111.40929114499994, 78.28180573100008],
              [-111.42056230399993, 78.27651601800005],
              [-111.43399003799993, 78.27460358300004],
              [-111.77847245999993, 78.27020905200004],
              [-111.83629309799994, 78.28522370000007],
              [-111.87075761599993, 78.30223216400003],
              [-111.87755286399994, 78.30882396000004],
              [-111.89061438699991, 78.32900625200006],
              [-111.91246497299994, 78.33584219000005],
              [-111.97044837099992, 78.34593333500004],
              [-111.9800512359999, 78.35004303600005],
              [-112.02867591099994, 78.35187409100007],
              [-112.17552649599992, 78.37738678600005],
              [-112.46560624899993, 78.35187409050005],
              [-112.75568600199995, 78.32636139500005],
              [-112.77745520699995, 78.31928131700005],
              [-112.78604081899994, 78.30866120000007],
              [-112.76829993399991, 78.29539622600004],
              [-112.80443274599992, 78.30780670800004],
              [-112.83967037699995, 78.30646393400008],
              [-113.06151282499991, 78.27435944200005],
              [-113.18517005099994, 78.27358633000006],
              [-113.24828040299991, 78.28497955900008],
              [-113.29527747299994, 78.31533437700006],
              [-113.28221594999991, 78.32273997600004],
              [-113.33617102799991, 78.33637116100005],
              [-113.2207738919999, 78.36371491100005],
              [-113.22301184799994, 78.37466054900005],
              [-113.22248287699995, 78.38434479400007],
              [-113.22435462099992, 78.39240143400008],
              [-113.23379472599993, 78.39850495000007],
              [-113.21422278599994, 78.40656159100007],
              [-113.14981035099993, 78.40989817900004],
              [-113.13353430899991, 78.41453685100004],
              [-113.10179602799991, 78.42767975500004],
              [-112.78087317599994, 78.47313060100004],
              [-112.68203691299993, 78.49827708500004],
              [-112.49274654899995, 78.51203034100007],
              [-112.35460364499994, 78.54002513200004],
              [-112.15005449099993, 78.55703359600005],
              [-112.03551184799994, 78.55174388200004],
              [-111.92674719999991, 78.56069570500006],
              [-111.81602942599994, 78.54889557500007],
              [-111.42015540299991, 78.60663483300004],
              [-111.37669837099992, 78.62376536700003],
              [-111.43814042899993, 78.64423248900005],
              [-111.31436113199993, 78.64842357000003],
              [-111.29474850199995, 78.66168854400007],
              [-111.27562415299991, 78.67023346600007],
              [-111.16441809799994, 78.69891998900005],
              [-111.13170325399994, 78.69159577000005],
              [-110.97964433499993, 78.72003815300008],
              [-110.8440649079999, 78.73061758000006],
              [-110.79442298099991, 78.74428945500006],
              [-110.76012122299994, 78.74957916900007],
              [-110.74095618399991, 78.75796133000006],
              [-110.73302161399994, 78.75726959800005],
              [-110.72411048099991, 78.75405508000006],
              [-110.71467037699995, 78.75307851800005],
              [-110.42690995999993, 78.76634349200003],
              [-110.39720618399991, 78.75348541900007],
              [-110.36632239499994, 78.74412669500003],
              [-110.23766028599994, 78.72785065300008],
              [-110.13658606699994, 78.69891998900005],
              [-110.03026282499991, 78.69253164300005],
              [-110.0036921869999, 78.68691640800006],
              [-109.96043860599991, 78.67780182500007],
              [-109.88727779899995, 78.67593008000006],
              [-109.85602779899995, 78.66535065300008],
              [-109.85802161399994, 78.64679596600007],
              [-109.8401586579999, 78.63629791900007],
              [-109.8137914699999, 78.63165924700007],
              [-109.75938880099994, 78.62824127800008],
              [-109.66356360599991, 78.60394928600005],
              [-109.67100989499994, 78.59711334800005],
              [-109.63345292899993, 78.58681875200006],
              [-109.50450598899994, 78.58958567900004],
              [-109.49315344999991, 78.58649323100008],
              [-109.47935950399994, 78.57233307500007],
              [-109.46540279899995, 78.56915924700007],
              [-109.4461156889999, 78.56793854400007],
              [-109.40689042899993, 78.55902741100005],
              [-109.34666907499991, 78.53534577000005],
              [-109.3352758449999, 78.52822500200006],
              [-109.32917232999995, 78.51699453300006],
              [-109.3321020169999, 78.50910065300008],
              [-109.33275305899991, 78.50267161700003],
              [-109.3196508449999, 78.49579498900005],
              [-109.30288652299993, 78.49457428600005],
              [-109.28307044199994, 78.49555084800005],
              [-109.26646887899994, 78.49359772300005],
              [-109.25951087099992, 78.48354726800005],
              [-109.2659399079999, 78.47699616100005],
              [-109.27651933499993, 78.47134023600006],
              [-109.27871660099993, 78.46572500200006],
              [-109.25951087099992, 78.45929596600007],
            ],
          ],
          [
            [
              [-74.55809485599991, 78.78143952000005],
              [-74.51203365799995, 78.77098216400003],
              [-74.31558183499993, 78.75629303600005],
              [-74.16706295499995, 78.72679271000004],
              [-74.1926977199999, 78.70502350500004],
              [-74.24022376199991, 78.69000885600008],
              [-74.33112545499995, 78.67841217700004],
              [-74.69229081899994, 78.72166575700004],
              [-74.70360266799992, 78.72687409100007],
              [-74.70518958199995, 78.73541901200008],
              [-74.6946508449999, 78.74725983300004],
              [-74.68781490799995, 78.74957916900007],
              [-74.66820227799991, 78.75128815300008],
              [-74.66047115799995, 78.75348541900007],
              [-74.65404212099992, 78.75922272300005],
              [-74.64712480399993, 78.77244700700004],
              [-74.64305579299992, 78.77830638200004],
              [-74.62718665299991, 78.78400299700007],
              [-74.55809485599991, 78.78143952000005],
            ],
          ],
          [
            [
              [-96.91030839799993, 77.79515208500004],
              [-97.04124915299991, 77.80817291900007],
              [-97.09288489499994, 77.80581289300005],
              [-97.10334225199995, 77.80817291900007],
              [-97.10488847599993, 77.81517161700003],
              [-97.10220292899993, 77.82294342700004],
              [-97.09825598899994, 77.82843659100007],
              [-97.09585527299993, 77.82868073100008],
              [-97.09447180899991, 77.83437734600005],
              [-97.09040279899995, 77.83779531500005],
              [-97.08731035099993, 77.84198639500005],
              [-97.08901933499993, 77.84979889500005],
              [-97.09658769399994, 77.85663483300004],
              [-97.10716712099992, 77.86050039300005],
              [-97.11729895699995, 77.86579010600008],
              [-97.1238500639999, 77.87714264500005],
              [-97.09398352799991, 77.88141510600008],
              [-97.05288652299993, 77.89325592700004],
              [-97.01475989499994, 77.90900299700007],
              [-96.9934789699999, 77.92487213700008],
              [-97.34325110599991, 77.95941803600005],
              [-97.43480383999992, 77.99363841400003],
              [-97.67186438699991, 78.02728913000004],
              [-97.7261449859999, 78.02553945500006],
              [-97.75279700399994, 78.02863190300008],
              [-97.77428137899994, 78.04157135600008],
              [-97.74233964799993, 78.04230377800008],
              [-97.68016516799992, 78.05451080900008],
              [-97.65143795499995, 78.05585358300004],
              [-97.65876217399995, 78.05980052300004],
              [-97.67520097599993, 78.07119375200006],
              [-97.68492591099994, 78.07566966400003],
              [-97.65689042899993, 78.09707265800006],
              [-97.29725094299994, 78.08905670750005],
              [-96.93761145699995, 78.08104075700004],
              [-96.89513098899994, 78.09129466400003],
              [-96.85631262899994, 78.10927969000005],
              [-96.8706762359999, 78.10809967700004],
              [-96.88467363199993, 78.10907623900005],
              [-96.89647376199991, 78.11367422100005],
              [-96.90412350199995, 78.12348053600005],
              [-96.89439856699994, 78.12384674700007],
              [-96.88516191299993, 78.12620677300004],
              [-96.87686113199993, 78.13076406500005],
              [-96.86929277299993, 78.13715241100005],
              [-96.89704342399995, 78.14679596600007],
              [-96.97740637899994, 78.15558502800008],
              [-97.03774980399993, 78.15241120000007],
              [-97.17564856699994, 78.17621491100005],
              [-97.22838294199994, 78.19497304900005],
              [-97.39415442599994, 78.21287669500003],
              [-97.53514563699991, 78.20673248900005],
              [-97.82957923099991, 78.22650788000004],
              [-97.88975989499994, 78.21893952000005],
              [-97.91954505099994, 78.22028229400007],
              [-97.92516028599994, 78.23334381700005],
              [-97.92210852799991, 78.24404531500005],
              [-97.88902747299994, 78.24388255400004],
              [-97.82209225199995, 78.23334381700005],
              [-97.82209225199995, 78.24079010600008],
              [-97.81529700399994, 78.23334381700005],
              [-97.80736243399991, 78.24022044500003],
              [-97.78018144399994, 78.24249909100007],
              [-97.76683508999992, 78.24701569200005],
              [-97.83877519399994, 78.27533600500004],
              [-97.91372636599993, 78.29214101800005],
              [-98.06847083199995, 78.30849844000005],
              [-98.0598852199999, 78.32176341400003],
              [-98.04576575399994, 78.32794830900008],
              [-98.0293676419999, 78.33136627800008],
              [-98.01390540299991, 78.33637116100005],
              [-98.03042558499993, 78.34723541900007],
              [-98.07103430899991, 78.36513906500005],
              [-98.09024003799993, 78.36994049700007],
              [-98.08202063699991, 78.38397858300004],
              [-98.06729081899994, 78.39008209800005],
              [-98.05016028599994, 78.39321523600006],
              [-98.03502356699994, 78.39850495000007],
              [-98.06932532499991, 78.40509674700007],
              [-98.21666419199994, 78.41518789300005],
              [-98.35973059799994, 78.45172760600008],
              [-98.37157141799992, 78.45697663000004],
              [-98.38442949099993, 78.46613190300008],
              [-98.40729732999995, 78.48818594000005],
              [-98.41112219999991, 78.49408600500004],
              [-98.40282141799992, 78.51300690300008],
              [-98.37905839799993, 78.52057526200008],
              [-98.32298743399991, 78.52073802300004],
              [-98.35655676999994, 78.53506094000005],
              [-98.3399145169999, 78.54364655200004],
              [-98.32164466099994, 78.54315827000005],
              [-98.28823808499993, 78.53506094000005],
              [-98.0757543609999, 78.53506094000005],
              [-98.05190995999993, 78.53827545800004],
              [-98.03050696499992, 78.54547760600008],
              [-98.0249731109999, 78.55255768400008],
              [-98.04865475199995, 78.55548737200007],
              [-98.04865475199995, 78.56171295800004],
              [-98.04149329299992, 78.56256745000007],
              [-98.02757727799991, 78.56915924700007],
              [-98.05431067599994, 78.58051178600005],
              [-98.13756262899994, 78.60211823100008],
              [-98.16515051999994, 78.60443756700005],
              [-98.22313391799992, 78.60244375200006],
              [-98.24730383999992, 78.61017487200007],
              [-98.23363196499992, 78.62376536700003],
              [-98.25413977799991, 78.63279857000003],
              [-98.31607011599993, 78.64622630400004],
              [-98.32921301999994, 78.65485260600008],
              [-98.32921301999994, 78.68329498900005],
              [-98.32534745999993, 78.69562409100007],
              [-98.31554114499994, 78.70636627800008],
              [-98.35802161399994, 78.71800364800004],
              [-98.37018795499995, 78.72679271000004],
              [-98.3562719389999, 78.73126862200007],
              [-98.32945716099994, 78.74310944200005],
              [-98.31554114499994, 78.74725983300004],
              [-98.34654700399994, 78.75747304900005],
              [-98.36188717399995, 78.76618073100008],
              [-98.35586503799993, 78.77391185100004],
              [-98.14907792899993, 78.81867096600007],
              [-97.80005856049993, 78.80788808800006],
              [-97.45103919199994, 78.79710521000004],
              [-97.34508216099994, 78.77326080900008],
              [-96.95933997299994, 78.73362864800004],
              [-96.89419511599993, 78.70294830900008],
              [-96.70494544199994, 78.68626536700003],
              [-96.59776770699995, 78.69403717700004],
              [-96.54308020699995, 78.68561432500007],
              [-96.34040279899995, 78.62555573100008],
              [-96.31387285099993, 78.62075429900005],
              [-96.28937740799995, 78.62205638200004],
              [-96.23936926999994, 78.63060130400004],
              [-96.21963456899994, 78.63076406500005],
              [-96.16421464799993, 78.62376536700003],
              [-96.15729732999995, 78.61957428600005],
              [-96.16673743399991, 78.61041901200008],
              [-96.18399003799993, 78.60126373900005],
              [-96.21214758999992, 78.59308502800008],
              [-96.21446692599994, 78.58348216400003],
              [-96.21434485599991, 78.57192617400005],
              [-96.21886145699995, 78.56171295800004],
              [-96.23277747299994, 78.55508047100005],
              [-96.24917558499993, 78.55182526200008],
              [-96.26402747299994, 78.54682038000004],
              [-96.2735082669999, 78.53506094000005],
              [-95.90697180899991, 78.48725006700005],
              [-95.86827551999994, 78.49103424700007],
              [-95.74592037699995, 78.52073802300004],
              [-95.69981848899994, 78.52610911700003],
              [-95.46108964799993, 78.51113515800006],
              [-95.26341712099992, 78.46893952000005],
              [-95.1187231109999, 78.45465729400007],
              [-94.93468176999994, 78.40306224200003],
              [-94.87291419199994, 78.39508698100008],
              [-94.85741126199991, 78.38641998900005],
              [-94.82787024599992, 78.36371491100005],
              [-94.85000566299993, 78.34613678600005],
              [-94.88133704299992, 78.33490631700005],
              [-95.3699438139999, 78.24677155200004],
              [-95.40322831899994, 78.23334381700005],
              [-95.33307857999995, 78.21645742400005],
              [-95.18163001199991, 78.20783112200007],
              [-95.10903886599993, 78.19236888200004],
              [-95.09170488199993, 78.16461823100008],
              [-94.88931230399993, 78.10927969000005],
              [-94.92418372299994, 78.08673737200007],
              [-94.91836503799993, 78.07933177300004],
              [-94.88931230399993, 78.06891510600008],
              [-94.88931230399993, 78.06207916900007],
              [-94.90623938699991, 78.06199778900003],
              [-94.92247473899994, 78.05857982000003],
              [-94.93748938699991, 78.05182526200008],
              [-94.95079505099994, 78.04157135600008],
              [-94.93773352799991, 78.04157135600008],
              [-94.98997962099992, 78.01976146000004],
              [-95.02774003799993, 77.98908112200007],
              [-95.04238847599993, 77.98045482000003],
              [-95.06065833199995, 77.97264232000003],
              [-95.11310787699995, 77.96067942900004],
              [-95.16258704299992, 77.96067942900004],
              [-95.26671301999994, 77.97264232000003],
              [-95.37743079299992, 77.97264232000003],
              [-95.39932206899994, 77.96942780200004],
              [-95.45173092399995, 77.94599030200004],
              [-95.47516842399995, 77.94456614800004],
              [-95.52521725199995, 77.94806549700007],
              [-95.56944739499994, 77.93451569200005],
              [-95.70457923099991, 77.92633698100008],
              [-95.80850175699993, 77.90298086100006],
              [-96.08702551999994, 77.88298167500005],
              [-96.36554928299995, 77.86298248900005],
              [-96.38829505099994, 77.86701080900008],
              [-96.41063391799992, 77.87714264500005],
              [-96.41136633999992, 77.88060130400004],
              [-96.4082738919999, 77.88556549700007],
              [-96.40640214799993, 77.89142487200007],
              [-96.41063391799992, 77.89760976800005],
              [-96.42113196499992, 77.90184153900003],
              [-96.4961645169999, 77.90607330900008],
              [-96.53062903599994, 77.90224844000005],
              [-96.59561113199993, 77.88328685100004],
              [-96.63219153599994, 77.87738678600005],
              [-96.70860755099994, 77.88031647300005],
              [-96.74022376199991, 77.87030670800004],
              [-96.68748938699991, 77.85252513200004],
              [-96.61827551999994, 77.85195547100005],
              [-96.5484106109999, 77.86225006700005],
              [-96.49323482999995, 77.87714264500005],
              [-96.49323482999995, 77.87030670800004],
              [-96.57510331899994, 77.85663483300004],
              [-96.51366126199991, 77.85663483300004],
              [-96.5249731109999, 77.84638092700004],
              [-96.54352779899995, 77.84174225500004],
              [-96.56436113199993, 77.84145742400005],
              [-96.60635331899994, 77.84747955900008],
              [-96.72667395699995, 77.83681875200006],
              [-96.79987545499995, 77.81289297100005],
              [-96.84264075399994, 77.80817291900007],
              [-96.83507239499994, 77.80829498900005],
              [-96.82803300699993, 77.80735911700003],
              [-96.82135982999995, 77.80516185100004],
              [-96.81476803299995, 77.80141836100006],
              [-96.8379613919999, 77.79148997600004],
              [-96.8613988919999, 77.78896719000005],
              [-96.91030839799993, 77.79515208500004],
            ],
          ],
          [
            [
              [-105.60680091099994, 79.10358307500007],
              [-105.59996497299994, 79.11041901200008],
              [-105.60586503799993, 79.11859772300005],
              [-105.62466386599993, 79.15314362200007],
              [-105.62783769399994, 79.16502513200004],
              [-105.61758378799993, 79.17926666900007],
              [-105.58116614499994, 79.20502350500004],
              [-105.56078040299991, 79.23550039300005],
              [-105.53197180899991, 79.24896881700005],
              [-105.44904537699995, 79.26947663000004],
              [-105.43700110599991, 79.27529531500005],
              [-105.42552649599992, 79.28510163000004],
              [-105.42564856699994, 79.29637278900003],
              [-105.44456946499992, 79.30133698100008],
              [-105.48387610599991, 79.30219147300005],
              [-105.45689856699994, 79.32929108300004],
              [-105.40811113199993, 79.33429596600007],
              [-105.15684973899994, 79.29987213700008],
              [-104.67842905733328, 79.32103099133342],
              [-104.2000083756666, 79.34218984566674],
              [-103.72158769399994, 79.36334870000007],
              [-103.65697180899991, 79.34129466400003],
              [-103.37242591099994, 79.30093008000006],
              [-103.2903539699999, 79.30963776200008],
              [-103.12092037699995, 79.29067617400005],
              [-103.07127844999991, 79.27488841400003],
              [-103.01610266799992, 79.24713776200008],
              [-102.9961645169999, 79.24070872600004],
              [-102.96703040299991, 79.23834870000007],
              [-102.90843665299991, 79.23969147300005],
              [-102.87946529899995, 79.23330312700006],
              [-102.89268958199995, 79.23139069200005],
              [-102.90538489499994, 79.22748444200005],
              [-102.91722571499992, 79.22158437700006],
              [-102.92784583199995, 79.21344635600008],
              [-102.91661536399994, 79.20282623900005],
              [-102.90343176999994, 79.18048737200007],
              [-102.89370683499993, 79.17186107000003],
              [-102.87852942599994, 79.16771067900004],
              [-102.84105383999992, 79.16738515800006],
              [-102.82485917899993, 79.16502513200004],
              [-102.79320227799991, 79.14740631700005],
              [-102.76964270699995, 79.14280833500004],
              [-102.7639867829999, 79.13719310100004],
              [-102.75877844999991, 79.13027578300006],
              [-102.74974524599992, 79.12409088700008],
              [-102.73778235599991, 79.12051015800006],
              [-102.71825110599991, 79.11798737200007],
              [-102.70848548099991, 79.11416250200006],
              [-102.6863500639999, 79.10895416900007],
              [-102.62694251199991, 79.10272858300004],
              [-102.61876380099994, 79.09674713700008],
              [-102.60716712099992, 79.07648346600007],
              [-102.61851966099994, 79.05980052300004],
              [-102.6370336579999, 79.04181549700007],
              [-102.64671790299991, 79.01788971600007],
              [-102.66490637899994, 78.98598867400005],
              [-102.74998938699991, 78.96824778900003],
              [-102.77643795499995, 78.94594961100006],
              [-102.7288305329999, 78.94013092700004],
              [-102.7156469389999, 78.94253164300005],
              [-102.70205644399994, 78.94676341400003],
              [-102.66429602799991, 78.95254140800006],
              [-102.58844967399995, 78.95050690300008],
              [-102.57164466099994, 78.94594961100006],
              [-102.57213294199994, 78.94131094000005],
              [-102.57298743399991, 78.94037506700005],
              [-102.57469641799992, 78.94049713700008],
              [-102.57778886599993, 78.93911367400005],
              [-102.57164466099994, 78.93162669500003],
              [-102.62621008999992, 78.90497467700004],
              [-102.61937415299991, 78.89704010600008],
              [-102.61131751199991, 78.89105866100005],
              [-102.60216223899994, 78.88694896000004],
              [-102.5921117829999, 78.88507721600007],
              [-102.5989477199999, 78.87763092700004],
              [-102.5371801419999, 78.87763092700004],
              [-102.52562415299991, 78.88027578300006],
              [-102.49522864499994, 78.89813873900005],
              [-102.40274003799993, 78.93480052300004],
              [-102.37979081899994, 78.95335521000004],
              [-102.38072669199994, 78.95815664300005],
              [-102.38149980399993, 78.95954010600008],
              [-102.38141842399995, 78.96133047100005],
              [-102.37979081899994, 78.96698639500005],
              [-102.39134680899991, 78.97614166900007],
              [-102.41197669199994, 78.99966054900005],
              [-102.42699133999992, 79.00800202000005],
              [-102.40713456899994, 79.01422760600008],
              [-102.42076575399994, 79.01422760600008],
              [-102.29531816299993, 79.02069733300004],
              [-102.2808324859999, 79.02440013200004],
              [-102.28294837099992, 79.03530508000006],
              [-102.12051347599993, 79.04266998900005],
              [-101.95775305899991, 79.08649323100008],
              [-101.91030839799993, 79.09121328300006],
              [-101.64842688699991, 79.08100006700005],
              [-101.63780676999994, 79.07855866100005],
              [-101.63267981699994, 79.07469310100004],
              [-101.63036048099991, 79.06932200700004],
              [-101.62694251199991, 79.06464264500005],
              [-101.61864173099991, 79.06264883000006],
              [-101.57664954299992, 79.05780670800004],
              [-101.3899633449999, 79.00299713700008],
              [-101.3472387359999, 78.99628327000005],
              [-101.30540930899991, 78.97748444200005],
              [-101.16710364499994, 78.95831940300008],
              [-101.15689042899993, 78.95929596600007],
              [-101.14899654899995, 78.96332428600005],
              [-101.1458227199999, 78.96869538000004],
              [-101.14366614499994, 78.97451406500005],
              [-101.14045162699995, 78.97846100500004],
              [-101.13369706899994, 78.97825755400004],
              [-101.01423092399995, 78.95050690300008],
              [-100.98818925699993, 78.93162669500003],
              [-101.01829993399991, 78.92080312700006],
              [-101.11266028599994, 78.87254466400003],
              [-101.16258704299992, 78.83779531500005],
              [-101.20791581899994, 78.82245514500005],
              [-101.18517005099994, 78.80744049700007],
              [-101.15831458199995, 78.80190664300005],
              [-101.03538977799991, 78.80385976800005],
              [-101.00499426999994, 78.79804108300004],
              [-101.00186113199993, 78.78143952000005],
              [-100.90636145699995, 78.77374909100007],
              [-100.83804277299993, 78.79148997600004],
              [-100.76463782499991, 78.80158112200007],
              [-100.59544837099992, 78.80084870000007],
              [-100.52122962099992, 78.82391998900005],
              [-100.39854895699995, 78.82990143400008],
              [-100.34976152299993, 78.82371653900003],
              [-100.32681230399993, 78.81427643400008],
              [-100.32656816299993, 78.79913971600007],
              [-100.31639563699991, 78.78416575700004],
              [-100.27391516799992, 78.77212148600006],
              [-99.99038652299993, 78.73607005400004],
              [-99.89207923099991, 78.69891998900005],
              [-99.92772376199991, 78.67845286700003],
              [-100.03433183499993, 78.65696849200003],
              [-100.06338456899994, 78.63808828300006],
              [-100.00177975199995, 78.62661367400005],
              [-99.93643144399994, 78.62376536700003],
              [-99.82982337099992, 78.63934967700004],
              [-99.79527747299994, 78.63060130400004],
              [-99.78502356699994, 78.62274811400005],
              [-99.77721106699994, 78.61399974200003],
              [-99.76919511599993, 78.60687897300005],
              [-99.75837154899995, 78.60394928600005],
              [-99.69871985599991, 78.60297272300005],
              [-99.64541581899994, 78.60879140800006],
              [-99.60094153599994, 78.60675690300008],
              [-99.5579320949999, 78.59870026200008],
              [-99.52839107999995, 78.58344147300005],
              [-99.55581620999993, 78.56598541900007],
              [-99.62608801999994, 78.55902741100005],
              [-99.6519262359999, 78.54246653900003],
              [-99.62295488199993, 78.54295482000003],
              [-99.60968990799995, 78.54096100500004],
              [-99.59727942599994, 78.53506094000005],
              [-99.61241614499994, 78.52643463700008],
              [-99.64403235599991, 78.51479726800005],
              [-99.65933183499993, 78.50706614800004],
              [-99.66771399599992, 78.49892812700006],
              [-99.67153886599993, 78.49115631700005],
              [-99.67784583199995, 78.48411692900004],
              [-99.69351152299993, 78.47817617400005],
              [-99.83364824099993, 78.45758698100008],
              [-99.87165279899995, 78.43886953300006],
              [-99.79796301999994, 78.42194245000007],
              [-99.76292883999992, 78.40521881700005],
              [-99.7481176419999, 78.38080475500004],
              [-99.75499426999994, 78.36465078300006],
              [-99.78921464799993, 78.32021719000005],
              [-99.80272376199991, 78.30849844000005],
              [-99.77025305899991, 78.29441966400003],
              [-99.57062740799995, 78.29531484600005],
              [-99.53392493399991, 78.28839752800008],
              [-99.50446529899995, 78.27094147300005],
              [-99.47061113199993, 78.24038320500006],
              [-99.43276933499993, 78.21287669500003],
              [-99.40298417899993, 78.20319245000007],
              [-99.29564368399991, 78.18553294500003],
              [-99.0445043609999, 78.08185455900008],
              [-98.99254309799994, 78.06952545800004],
              [-98.94615637899994, 78.06891510600008],
              [-98.96397864499994, 78.04535553600005],
              [-98.96666419199994, 78.03815338700008],
              [-98.96580969999991, 78.02008698100008],
              [-98.96666419199994, 78.01093170800004],
              [-98.97008216099994, 78.00405508000006],
              [-98.99840247299994, 77.98883698100008],
              [-99.07237708199995, 77.97699616100005],
              [-99.10383053299995, 77.96588776200008],
              [-99.07030188699991, 77.93854401200008],
              [-99.08039303299995, 77.92963288000004],
              [-99.0723363919999, 77.92084381700005],
              [-99.04234778599994, 77.90497467700004],
              [-99.0247289699999, 77.89850495000007],
              [-99.01724199099993, 77.89378489800004],
              [-99.01846269399994, 77.88703034100007],
              [-99.02904212099992, 77.88271719000005],
              [-99.07787024599992, 77.87807851800005],
              [-99.11945553299995, 77.86611562700006],
              [-99.15843665299991, 77.84979889500005],
              [-99.18224036399994, 77.84369538000004],
              [-99.48949134049994, 77.83154938350006],
              [-99.79674231699994, 77.81940338700008],
              [-99.82323157499991, 77.81500885600008],
              [-99.84068762899994, 77.80780670800004],
              [-99.86774654899995, 77.79218170800004],
              [-99.88536536399994, 77.78607819200005],
              [-99.93858801999994, 77.78290436400005],
              [-100.11119544199994, 77.81500885600008],
              [-100.27953040299991, 77.81903717700004],
              [-100.38902747299994, 77.84398021000004],
              [-100.61001542899993, 77.86395905200004],
              [-100.62511145699995, 77.87030670800004],
              [-100.60484778599994, 77.88385651200008],
              [-100.61628170499995, 77.90062083500004],
              [-100.64248613199993, 77.91669342700004],
              [-100.78184973899994, 77.97260163000004],
              [-100.81354732999995, 77.99689362200007],
              [-100.83067786399994, 78.01532623900005],
              [-100.83560136599993, 78.02496979400007],
              [-100.83739173099991, 78.03815338700008],
              [-100.82848059799994, 78.05499909100007],
              [-100.80736243399991, 78.05805084800005],
              [-100.78270423099991, 78.05707428600005],
              [-100.76292883999992, 78.06207916900007],
              [-100.76207434799994, 78.08299388200004],
              [-100.80528723899994, 78.09613678600005],
              [-100.96890214799993, 78.12482330900008],
              [-101.00230872299994, 78.13800690300008],
              [-101.0230199859999, 78.15827057500007],
              [-101.02383378799993, 78.16917552300004],
              [-101.0203344389999, 78.17780182500007],
              [-101.02139238199993, 78.18695709800005],
              [-101.03600012899994, 78.19920482000003],
              [-101.05972245999993, 78.20551178600005],
              [-101.09203040299991, 78.20563385600008],
              [-101.26256262899994, 78.18553294500003],
              [-101.29027258999992, 78.18793366100005],
              [-101.49836178299995, 78.23777903900003],
              [-101.82955888599994, 78.26304759350003],
              [-102.16075598899994, 78.28831614800004],
              [-102.54287675699993, 78.24258047100005],
              [-102.59251868399991, 78.24445221600007],
              [-102.76500403599994, 78.27407461100006],
              [-102.80223548099991, 78.28778717700004],
              [-102.81798255099994, 78.31191640800006],
              [-102.7971899079999, 78.32876211100006],
              [-102.66714433499993, 78.36371491100005],
              [-102.74413001199991, 78.38056061400005],
              [-103.03933671799993, 78.36438629750006],
              [-103.33454342399995, 78.34821198100008],
              [-103.37975012899994, 78.33637116100005],
              [-103.44123287699995, 78.33441803600005],
              [-103.49803626199991, 78.32477448100008],
              [-103.65880286399994, 78.32111237200007],
              [-103.74339758999992, 78.31012604400007],
              [-103.8801977199999, 78.27631256700005],
              [-103.91417395699995, 78.27435944200005],
              [-103.90453040299991, 78.25299713700008],
              [-103.94652258999992, 78.24282461100006],
              [-104.20610510949993, 78.25873444200005],
              [-104.46568762899994, 78.27464427300004],
              [-104.67568925699993, 78.32273997600004],
              [-104.7312719389999, 78.34674713700008],
              [-104.75088456899994, 78.35004303600005],
              [-104.7747289699999, 78.35097890800006],
              [-104.79832923099991, 78.35447825700004],
              [-104.81956946499992, 78.36163971600007],
              [-104.86876380099994, 78.39679596600007],
              [-104.99038652299993, 78.43886953300006],
              [-105.00096594999991, 78.44623444200005],
              [-105.04332434799994, 78.49534739800004],
              [-105.04637610599991, 78.50478750200006],
              [-105.03848222599993, 78.51276276200008],
              [-105.01773027299993, 78.52448151200008],
              [-104.97533118399991, 78.54002513200004],
              [-104.8821508449999, 78.55735911700003],
              [-104.8191625639999, 78.57802969000005],
              [-104.64098059799994, 78.58344147300005],
              [-104.33934485599994, 78.55208974800004],
              [-104.03770911399994, 78.52073802300004],
              [-103.72183183499993, 78.52431875200006],
              [-103.5835668609999, 78.50238678600005],
              [-103.53954016799992, 78.50039297100005],
              [-103.49718176999994, 78.50653717700004],
              [-103.46568762899994, 78.52448151200008],
              [-103.45360266799992, 78.53961823100008],
              [-103.45303300699993, 78.54743073100008],
              [-103.46275794199994, 78.55194733300004],
              [-103.4812719389999, 78.55711497600004],
              [-103.49429277299993, 78.56614817900004],
              [-103.47647050699993, 78.57282135600008],
              [-103.42813066299993, 78.58344147300005],
              [-103.42007402299993, 78.57802969000005],
              [-103.40737870999993, 78.57904694200005],
              [-103.37975012899994, 78.58958567900004],
              [-103.39150956899994, 78.59711334800005],
              [-103.40534420499995, 78.60195547100005],
              [-103.42015540299991, 78.60415273600006],
              [-103.43496660099993, 78.60394928600005],
              [-103.41673743399991, 78.60932038000004],
              [-103.40021725199995, 78.61692942900004],
              [-103.43936113199993, 78.62518952000005],
              [-103.72500566299993, 78.62268707850006],
              [-104.01065019399994, 78.62018463700008],
              [-104.0445043609999, 78.63060130400004],
              [-103.98135331899994, 78.65517812700006],
              [-103.91030839799993, 78.66876862200007],
              [-103.48277747299994, 78.67157623900005],
              [-103.51964270699995, 78.69594961100006],
              [-103.5305883449999, 78.70636627800008],
              [-103.49474036399994, 78.71662018400008],
              [-103.45958411399994, 78.72064850500004],
              [-103.3479711579999, 78.72174713700008],
              [-103.32725989499994, 78.72679271000004],
              [-103.31826738199993, 78.73704661700003],
              [-103.32579505099994, 78.74754466400003],
              [-103.35855058499993, 78.74860260600008],
              [-103.38402258999992, 78.77460358300004],
              [-103.42495683499993, 78.78388092700004],
              [-103.49844316299993, 78.78827545800004],
              [-103.52599036399994, 78.77871328300006],
              [-103.55357825399994, 78.75983307500007],
              [-103.5821020169999, 78.74652741100005],
              [-103.61253821499992, 78.75348541900007],
              [-103.60684160099993, 78.75665924700007],
              [-103.59203040299991, 78.76776764500005],
              [-103.61607825399994, 78.77289459800005],
              [-103.64305579299992, 78.77179596600007],
              [-103.7551977199999, 78.74673086100006],
              [-103.8179418609999, 78.74046458500004],
              [-103.79600989499994, 78.75787995000007],
              [-103.76134192599994, 78.77440013200004],
              [-103.69505774599992, 78.79572174700007],
              [-103.72093665299991, 78.80646393400008],
              [-103.75104732999995, 78.80361562700006],
              [-103.78229732999995, 78.79682038000004],
              [-103.81175696499992, 78.79572174700007],
              [-103.86237545499995, 78.80923086100006],
              [-103.88914954299992, 78.80975983300004],
              [-103.90733801999994, 78.79572174700007],
              [-103.90282141799992, 78.79287344000005],
              [-103.8985082669999, 78.78632233300004],
              [-103.89366614499994, 78.78143952000005],
              [-103.93700110599991, 78.76601797100005],
              [-103.99229895699995, 78.75739166900007],
              [-104.0481664699999, 78.75739166900007],
              [-104.09288489499994, 78.76776764500005],
              [-104.07860266799992, 78.76776764500005],
              [-104.09996497299994, 78.77716705900008],
              [-104.18805904899995, 78.77667877800008],
              [-104.22325598899994, 78.78827545800004],
              [-104.14903723899994, 78.82436758000006],
              [-103.8562719389999, 78.88255442900004],
              [-103.8316137359999, 78.89142487200007],
              [-103.83218339799993, 78.90497467700004],
              [-103.85582434799994, 78.91461823100008],
              [-104.02586829299992, 78.94415924700007],
              [-104.04458574099993, 78.95311107000003],
              [-104.04938717399995, 78.96185944200005],
              [-104.05044511599993, 78.97064850500004],
              [-104.0581762359999, 78.98004791900007],
              [-104.07762610599991, 78.98627350500004],
              [-104.24722245999993, 78.99705638200004],
              [-104.2710668609999, 78.99066803600005],
              [-104.28180904899995, 78.97919342700004],
              [-104.28799394399994, 78.96653880400004],
              [-104.29942786399994, 78.95868561400005],
              [-104.37018795499995, 78.96898021000004],
              [-104.4155981109999, 78.96792226800005],
              [-104.45628821499992, 78.95697663000004],
              [-104.48643958199995, 78.93537018400008],
              [-104.52928626199991, 78.89301178600005],
              [-104.55431067599994, 78.87523021000004],
              [-104.57949785099993, 78.86334870000007],
              [-104.6887914699999, 78.84349192900004],
              [-104.78498287699995, 78.80878327000005],
              [-104.83535722599993, 78.79979075700004],
              [-104.95543372299994, 78.79816315300008],
              [-105.00560462099992, 78.80711497600004],
              [-105.03184973899994, 78.82615794500003],
              [-105.00999915299991, 78.84511953300006],
              [-104.87376868399991, 78.89069245000007],
              [-104.86388098899994, 78.89691803600005],
              [-104.8555395169999, 78.90399811400005],
              [-104.8460180329999, 78.90957265800006],
              [-104.83275305899991, 78.91181061400005],
              [-104.81704667899993, 78.94017161700003],
              [-104.76329505099994, 78.97308991100005],
              [-104.6785375639999, 79.01113515800006],
              [-104.70840410099993, 79.03107330900008],
              [-104.74559485599991, 79.03896719000005],
              [-104.95335852799991, 79.05385976800005],
              [-105.40249589799993, 79.01288483300004],
              [-105.56346594999991, 79.02594635600008],
              [-105.59178626199991, 79.03782786700003],
              [-105.60704505099994, 79.05540599200003],
              [-105.59312903599994, 79.07684967700004],
              [-105.59666907499991, 79.08478424700007],
              [-105.59675045499995, 79.09259674700007],
              [-105.59837805899991, 79.09918854400007],
              [-105.60680091099994, 79.10358307500007],
            ],
          ],
          [
            [
              [-100.15217037699995, 79.99799225500004],
              [-100.16258704299992, 80.01044342700004],
              [-100.18219967399995, 80.02118561400005],
              [-100.19371497299994, 80.03229401200008],
              [-100.17979895699995, 80.04580312700006],
              [-100.16685950399994, 80.04999420800004],
              [-100.13902747299994, 80.05483633000006],
              [-100.12515214799993, 80.05947500200006],
              [-100.1184789699999, 80.06427643400008],
              [-100.10619055899991, 80.07770416900007],
              [-100.09691321499992, 80.08364492400005],
              [-100.10435950399994, 80.07684967700004],
              [-100.06029212099992, 80.09617747600004],
              [-99.7793676419999, 80.15078359600005],
              [-99.57030188699991, 80.14215729400007],
              [-99.44888261599993, 80.11249420800004],
              [-99.42284094999991, 80.11098867400005],
              [-99.11969967399995, 80.13373444200005],
              [-99.06285559799994, 80.12523021000004],
              [-98.95958411399994, 80.09552643400008],
              [-98.87376868399991, 80.08380768400008],
              [-98.85057532499991, 80.07001373900005],
              [-98.85781816299993, 80.06732819200005],
              [-98.87132727799991, 80.05931224200003],
              [-98.87791907499991, 80.05634186400005],
              [-98.8550512359999, 80.04559967700004],
              [-98.78693600199995, 80.02216217700004],
              [-98.77822831899994, 80.01194896000004],
              [-98.77798417899993, 79.99701569200005],
              [-98.75548255099994, 79.98432038000004],
              [-98.70596269399994, 79.96698639500005],
              [-98.72549394399994, 79.96112702000005],
              [-98.74364173099991, 79.95189036700003],
              [-98.7586156889999, 79.93992747600004],
              [-98.76866614499994, 79.92597077000005],
              [-98.77505449099993, 79.90468984600005],
              [-98.76805579299992, 79.89545319200005],
              [-98.72704016799992, 79.88499583500004],
              [-98.69570878799993, 79.86774323100008],
              [-98.6719457669999, 79.84406159100007],
              [-98.65664628799993, 79.81769440300008],
              [-98.65135657499991, 79.79222239800004],
              [-98.66002356699994, 79.78082916900007],
              [-98.67992102799991, 79.76854075700004],
              [-98.7019750639999, 79.75873444200005],
              [-98.71678626199991, 79.75462474200003],
              [-98.72630774599992, 79.74827708500004],
              [-98.7376195949999, 79.73419830900008],
              [-98.75230872299994, 79.72016022300005],
              [-98.77171790299991, 79.71369049700007],
              [-98.78050696499992, 79.70844147300005],
              [-98.79539954299992, 79.68374258000006],
              [-98.8028051419999, 79.67584870000007],
              [-98.8238012359999, 79.66925690300008],
              [-98.84019934799994, 79.66986725500004],
              [-98.87791907499991, 79.67894114800004],
              [-98.87336178299995, 79.69830963700008],
              [-98.88475501199991, 79.70962148600006],
              [-98.95885169199994, 79.72817617400005],
              [-99.3001195949999, 79.75942617400005],
              [-99.33039303299995, 79.76829661700003],
              [-99.31090247299994, 79.78497955900008],
              [-99.30304928299995, 79.78880442900004],
              [-99.31232662699995, 79.79266998900005],
              [-99.32917232999995, 79.80292389500005],
              [-99.33653723899994, 79.80927155200004],
              [-99.31578528599994, 79.81098053600005],
              [-99.29564368399991, 79.81610748900005],
              [-99.3015844389999, 79.83340078300006],
              [-99.3035375639999, 79.84259674700007],
              [-99.3118383449999, 79.84837474200003],
              [-99.58360755099994, 79.89866771000004],
              [-99.61510169199994, 79.89858633000006],
              [-99.7051488919999, 79.88499583500004],
              [-100.07022050699993, 79.87815989800004],
              [-100.09825598899994, 79.88523997600004],
              [-100.15379798099991, 79.90680573100008],
              [-100.18008378799993, 79.91168854400007],
              [-100.17149817599994, 79.92304108300004],
              [-100.14427649599992, 79.94074127800008],
              [-100.13853919199994, 79.94989655200004],
              [-100.13805091099994, 79.95746491100005],
              [-100.13727779899995, 79.96185944200005],
              [-100.13711503799993, 79.96629466400003],
              [-100.13853919199994, 79.97443268400008],
              [-100.14159094999991, 79.98041413000004],
              [-100.14614824099993, 79.98493073100008],
              [-100.15029863199993, 79.99017975500004],
              [-100.15217037699995, 79.99799225500004],
            ],
          ],
          [
            [
              [-95.8523656889999, 80.65277741100005],
              [-96.15054277299993, 80.66583893400008],
              [-96.11046301999994, 80.68573639500005],
              [-96.05589758999992, 80.69367096600007],
              [-95.71922766799992, 80.69379303600005],
              [-95.7254125639999, 80.70001862200007],
              [-95.53335527299993, 80.70001862200007],
              [-95.47769120999993, 80.70844147300005],
              [-95.4231664699999, 80.69757721600007],
              [-95.16368567599994, 80.70001862200007],
              [-95.06749426999994, 80.68695709800005],
              [-95.05589758999992, 80.68329498900005],
              [-95.04214433499993, 80.67690664300005],
              [-95.03066972599993, 80.66937897300005],
              [-95.02586829299992, 80.66274648600006],
              [-94.98228919199994, 80.64801666900007],
              [-94.97130286399994, 80.63914622600004],
              [-95.18687903599994, 80.61294179900005],
              [-95.4837133449999, 80.62986888200004],
              [-95.62857011599993, 80.65729401200008],
              [-95.8523656889999, 80.65277741100005],
            ],
          ],
          [
            [
              [-96.6231176419999, 80.04433828300006],
              [-96.66515051999994, 80.04389069200005],
              [-96.72130286399994, 80.05414459800005],
              [-96.7730199859999, 80.07269928600005],
              [-96.80166581899994, 80.09731679900005],
              [-96.78270423099991, 80.10049062700006],
              [-96.77110755099994, 80.11367422100005],
              [-96.76134192599994, 80.12933991100005],
              [-96.74795488199993, 80.14008209800005],
              [-96.71056067599994, 80.14813873900005],
              [-96.36392167899993, 80.14150625200006],
              [-96.01854407499991, 80.07200755400004],
              [-95.70396887899994, 80.05687083500004],
              [-95.67015540299991, 80.04889557500007],
              [-95.67760169199994, 80.04889557500007],
              [-95.46735592399995, 80.04804108300004],
              [-95.16934160099993, 80.03400299700007],
              [-94.95836341099994, 80.04588450700004],
              [-94.84569251199991, 80.04539622600004],
              [-94.42284094999991, 79.98224518400008],
              [-94.38223222599993, 79.98802317900004],
              [-94.42446855399993, 80.00653717700004],
              [-94.44859778599994, 80.01288483300004],
              [-94.50133216099994, 80.01968008000006],
              [-94.56151282499991, 80.03839752800008],
              [-94.64541581899994, 80.05101146000004],
              [-94.75226803299995, 80.08576080900008],
              [-94.8074438139999, 80.09048086100006],
              [-94.8074438139999, 80.09731679900005],
              [-94.54576575399994, 80.15766022300005],
              [-94.0874731109999, 80.17987702000005],
              [-94.1067602199999, 80.18707916900007],
              [-94.49209550699993, 80.20718008000006],
              [-94.50279700399994, 80.21930573100008],
              [-94.54076087099992, 80.22553131700005],
              [-94.58568274599992, 80.22638580900008],
              [-94.61709550699993, 80.22260163000004],
              [-94.6934301419999, 80.18821849200003],
              [-94.95982825399994, 80.14227936400005],
              [-95.40151933499993, 80.12665436400005],
              [-95.65587317599994, 80.17694733300004],
              [-95.69810950399994, 80.17987702000005],
              [-95.67625891799992, 80.19257233300004],
              [-95.55919348899994, 80.21002838700008],
              [-95.33714758999992, 80.20941803600005],
              [-95.28172766799992, 80.21930573100008],
              [-95.2320043609999, 80.24127838700008],
              [-95.26357988199993, 80.25096263200004],
              [-95.30260169199994, 80.24583567900004],
              [-95.37596594999991, 80.22768789300005],
              [-95.56273352799991, 80.22768789300005],
              [-95.57559160099993, 80.23078034100007],
              [-95.59691321499992, 80.24494049700007],
              [-95.61245683499993, 80.24811432500007],
              [-95.88243567599994, 80.20034414300005],
              [-95.96914628799993, 80.20136139500005],
              [-96.3216039699999, 80.26162344000005],
              [-96.56826738199993, 80.27606842700004],
              [-96.56151282499991, 80.28229401200008],
              [-96.48151607999995, 80.31037018400008],
              [-96.46524003799993, 80.32318756700005],
              [-96.49132239499994, 80.32933177300004],
              [-96.57485917899993, 80.33002350500004],
              [-96.68496660099993, 80.34369538000004],
              [-96.63219153599994, 80.36444733300004],
              [-96.57453365799995, 80.36074453300006],
              [-96.51561438699991, 80.34845612200007],
              [-96.45909583199995, 80.34369538000004],
              [-96.45352128799993, 80.35736725500004],
              [-96.42296301999994, 80.35635000200006],
              [-96.32970130099994, 80.33982982000003],
              [-96.24815833199995, 80.33657461100006],
              [-96.21886145699995, 80.34369538000004],
              [-96.26414954299992, 80.36074453300006],
              [-96.28034420499995, 80.36420319200005],
              [-96.25479081899994, 80.37392812700006],
              [-96.16462154899995, 80.38491445500006],
              [-96.14073645699995, 80.38178131700005],
              [-96.10244706899994, 80.38959381700005],
              [-95.94896399599992, 80.39154694200005],
              [-95.80992591099994, 80.36945221600007],
              [-95.66844641799992, 80.37164948100008],
              [-95.56427975199995, 80.35248444200005],
              [-95.43740800699993, 80.34369538000004],
              [-95.44640051999994, 80.35244375200006],
              [-95.46515865799995, 80.36469147300005],
              [-95.47215735599991, 80.37164948100008],
              [-95.46670488199993, 80.37299225500004],
              [-95.45173092399995, 80.37848541900007],
              [-95.48387610599991, 80.38996002800008],
              [-95.56407630099994, 80.39004140800006],
              [-95.68614661399994, 80.40428294500003],
              [-95.72996985599991, 80.41535065300008],
              [-95.79222571499992, 80.45136139500005],
              [-96.05870520699995, 80.48191966400003],
              [-96.10216223899994, 80.49457428600005],
              [-95.96458899599992, 80.50946686400005],
              [-95.9544164699999, 80.51284414300005],
              [-95.93765214799993, 80.52244700700004],
              [-95.93175208199995, 80.53538646000004],
              [-95.9219457669999, 80.54242584800005],
              [-95.90355383999992, 80.54291413000004],
              [-95.97321529899995, 80.55304596600007],
              [-96.0073949859999, 80.56411367400005],
              [-96.02700761599993, 80.58392975500004],
              [-95.62633216099994, 80.59149811400005],
              [-95.29600989499994, 80.58763255400004],
              [-95.05516516799992, 80.60236237200007],
              [-94.98151607999995, 80.60374583500004],
              [-94.76170813699991, 80.56924062700006],
              [-94.57599850199995, 80.55536530200004],
              [-94.28677324099993, 80.56655508000006],
              [-94.0320531889999, 80.54873281500005],
              [-94.01573645699995, 80.55292389500005],
              [-94.00332597599993, 80.55792877800008],
              [-93.98656165299991, 80.55817291900007],
              [-93.96983801999994, 80.55499909100007],
              [-93.95767167899993, 80.54975006700005],
              [-93.97134355399993, 80.54291413000004],
              [-93.9348852199999, 80.52191803600005],
              [-93.88365637899994, 80.52049388200004],
              [-93.78575598899994, 80.52928294500003],
              [-93.78575598899994, 80.53676992400005],
              [-94.00548255099994, 80.59137604400007],
              [-94.37539628799993, 80.61741771000004],
              [-94.5210668609999, 80.60492584800005],
              [-94.54279537699995, 80.60789622600004],
              [-94.56143144399994, 80.61505768400008],
              [-94.57774817599994, 80.62832265800006],
              [-94.60081946499992, 80.64183177300004],
              [-94.65599524599992, 80.65204498900005],
              [-94.6770727199999, 80.66583893400008],
              [-94.65343176999994, 80.68378327000005],
              [-94.62018795499995, 80.69342682500007],
              [-94.34699459549992, 80.70042552300006],
              [-94.0738012359999, 80.70742422100005],
              [-94.12877356699994, 80.72821686400005],
              [-94.25503495999993, 80.72321198100008],
              [-94.31395423099991, 80.72728099200003],
              [-94.31395423099991, 80.73476797100005],
              [-94.3106176419999, 80.74583567900004],
              [-94.33429928299995, 80.74957916900007],
              [-94.38906816299993, 80.74843984600005],
              [-94.47508704299992, 80.73151276200008],
              [-94.49209550699993, 80.73476797100005],
              [-94.51398678299995, 80.72589752800008],
              [-94.69517981699994, 80.73411692900004],
              [-95.02476966099994, 80.77142975500004],
              [-95.04015051999994, 80.78253815300008],
              [-94.8972875639999, 80.79588450700004],
              [-94.85582434799994, 80.80988190300008],
              [-94.88744055899991, 80.81976959800005],
              [-94.92837480399993, 80.82005442900004],
              [-95.13914954299992, 80.79726797100005],
              [-95.49974524599992, 80.80801015800006],
              [-95.53359941299993, 80.82412344000005],
              [-95.51935787699995, 80.83095937700006],
              [-95.52676347599993, 80.83714427300004],
              [-95.48070227799991, 80.84931061400005],
              [-95.19225012899994, 80.87238190300008],
              [-95.15001380099994, 80.88556549700007],
              [-95.43521074099993, 80.88841380400004],
              [-95.48521887899994, 80.90607330900008],
              [-95.29914303299995, 80.94839101800005],
              [-95.27114824099993, 80.96181875200006],
              [-95.23184160099993, 81.01532623900005],
              [-95.16783606699994, 81.02912018400008],
              [-95.03868567599994, 81.03522370000007],
              [-94.90298417899993, 81.06370677300004],
              [-94.86314856699994, 81.06460195500006],
              [-94.54556230399993, 81.03327057500007],
              [-94.52651933499993, 81.02582428600005],
              [-94.5091039699999, 81.02179596600007],
              [-94.47350012899994, 81.02195872600004],
              [-94.45734615799995, 81.01532623900005],
              [-94.50523841099994, 80.99730052300004],
              [-94.51256262899994, 80.98798248900005],
              [-94.50422115799995, 80.97874583500004],
              [-94.48452714799993, 80.97235748900005],
              [-94.44709225199995, 80.96751536700003],
              [-94.40831458199995, 80.96918366100005],
              [-94.3706762359999, 80.97492096600007],
              [-94.33446204299992, 80.98550039300005],
              [-94.30028235599991, 81.00165436400005],
              [-94.30003821499992, 81.01300690300008],
              [-94.2786352199999, 81.01776764500005],
              [-94.25182044199994, 81.01703522300005],
              [-94.21540279899995, 81.00576406500005],
              [-94.18248450399994, 81.00556061400005],
              [-94.14932206899994, 81.00942617400005],
              [-94.12901770699995, 81.01532623900005],
              [-94.10496985599991, 81.03058502800008],
              [-93.93659420499995, 81.02277252800008],
              [-93.93659420499995, 81.02895742400005],
              [-94.0738012359999, 81.04262929900005],
              [-94.03880774599992, 81.05239492400005],
              [-93.90929114499994, 81.04262929900005],
              [-93.97020423099991, 81.05809153900003],
              [-94.17015540299991, 81.06370677300004],
              [-94.18150794199994, 81.06586334800005],
              [-94.2039281889999, 81.07526276200008],
              [-94.2356664699999, 81.07949453300006],
              [-94.27163652299993, 81.08893463700008],
              [-94.34422766799992, 81.09813060100004],
              [-94.35993404899995, 81.10472239800004],
              [-94.34129798099991, 81.11151764500005],
              [-94.30239824099993, 81.12270742400005],
              [-94.15566972599993, 81.09784577000005],
              [-93.8235570949999, 81.10472239800004],
              [-93.49156653599994, 81.06997304900005],
              [-93.49156653599994, 81.07737864800004],
              [-93.50104732999995, 81.07884349200003],
              [-93.50670325399994, 81.08124420800004],
              [-93.5188695949999, 81.09100983300004],
              [-93.31354732999995, 81.08665599200003],
              [-93.15575110599991, 81.09784577000005],
              [-93.16974850199995, 81.10008372600004],
              [-93.17650305899991, 81.10236237200007],
              [-93.18309485599991, 81.10529205900008],
              [-93.1680395169999, 81.10984935100004],
              [-93.13727779899995, 81.11424388200004],
              [-93.12165279899995, 81.11831289300005],
              [-93.13508053299995, 81.12759023600006],
              [-93.15025794199994, 81.13214752800008],
              [-93.16641191299993, 81.13344961100006],
              [-93.18309485599991, 81.13263580900008],
              [-93.16006425699993, 81.14524974200003],
              [-93.12437903599994, 81.14960358300004],
              [-93.10000566299993, 81.15643952000005],
              [-93.11107337099992, 81.17670319200005],
              [-93.14419511599993, 81.19114817900004],
              [-93.21735592399995, 81.19065989800004],
              [-93.2520238919999, 81.20026276200008],
              [-93.22622636599993, 81.21198151200008],
              [-93.21719316299993, 81.21454498900005],
              [-93.57896887899994, 81.22406647300005],
              [-93.77660071499992, 81.20709870000007],
              [-93.92056230399993, 81.20954010600008],
              [-94.16637122299994, 81.22321198100008],
              [-94.33372962099992, 81.24384186400005],
              [-94.39586341099994, 81.26170482000003],
              [-94.37987219999991, 81.28095123900005],
              [-94.36025956899994, 81.29291413000004],
              [-94.25039628799993, 81.32245514500005],
              [-94.24478105399993, 81.32925039300005],
              [-94.25446529899995, 81.33637116100005],
              [-94.26943925699993, 81.34198639500005],
              [-94.27985592399995, 81.34422435100004],
              [-94.24278723899994, 81.36078522300005],
              [-94.18846594999991, 81.36664459800005],
              [-93.92804928299995, 81.35854726800005],
              [-93.66429602799991, 81.33942291900007],
              [-93.59552975199995, 81.31696198100008],
              [-93.55980383999992, 81.31012604400007],
              [-93.56663977799991, 81.30329010600008],
              [-93.55304928299995, 81.30829498900005],
              [-93.52293860599991, 81.31574127800008],
              [-93.50865637899994, 81.31696198100008],
              [-93.49673417899993, 81.32025788000004],
              [-93.48753821499992, 81.32746002800008],
              [-93.48546301999994, 81.33478424700007],
              [-93.49498450399994, 81.33808014500005],
              [-93.51402747299994, 81.34170156500005],
              [-93.53380286399994, 81.35122304900005],
              [-93.5520727199999, 81.36432526200008],
              [-93.56663977799991, 81.37905508000006],
              [-93.54775956899994, 81.38499583500004],
              [-93.5266820949999, 81.38711172100005],
              [-93.25767981699994, 81.37343984600005],
              [-93.09630286399994, 81.34747955900008],
              [-92.77293860599991, 81.31769440300008],
              [-92.70641028599994, 81.30182526200008],
              [-92.48843339799993, 81.28587474200003],
              [-92.37083899599992, 81.26357656500005],
              [-92.23692786399994, 81.25633372600004],
              [-91.82909094999991, 81.16193268400008],
              [-91.79832923099991, 81.15924713700008],
              [-91.81045488199993, 81.15021393400008],
              [-91.83604895699995, 81.13593170800004],
              [-91.84732011599993, 81.12518952000005],
              [-91.8137914699999, 81.11245351800005],
              [-91.79832923099991, 81.10350169500003],
              [-91.78526770699995, 81.09100983300004],
              [-91.81407630099994, 81.08222077000005],
              [-91.91502844999991, 81.08417389500005],
              [-91.91502844999991, 81.07737864800004],
              [-91.70807857999995, 81.03803131700005],
              [-91.52456620999993, 80.97801341400003],
              [-91.52708899599992, 80.96332428600005],
              [-91.5301000639999, 80.95400625200006],
              [-91.52700761599993, 80.94635651200008],
              [-91.5113012359999, 80.93675364800004],
              [-91.48692786399994, 80.92617422100005],
              [-91.43077551999994, 80.90888092700004],
              [-91.36107337099992, 80.89960358300004],
              [-91.32437089799993, 80.88349030200004],
              [-91.2573949859999, 80.84088776200008],
              [-91.23648027299993, 80.83372630400004],
              [-91.19029700399994, 80.82965729400007],
              [-91.16832434799994, 80.82412344000005],
              [-91.14708411399994, 80.81305573100008],
              [-91.14610755099994, 80.80719635600008],
              [-91.15265865799995, 80.80121491100005],
              [-91.15404212099992, 80.78998444200005],
              [-91.13027910099993, 80.76471588700008],
              [-91.08885657499991, 80.74860260600008],
              [-90.7097875639999, 80.70331452000005],
              [-90.61363684799994, 80.65582916900007],
              [-90.60716712099992, 80.65379466400003],
              [-90.59292558499993, 80.65277741100005],
              [-90.61876380099994, 80.63190338700008],
              [-90.75031490799995, 80.59418366100005],
              [-90.76618404899995, 80.57623932500007],
              [-90.73106848899994, 80.56671784100007],
              [-90.67772376199991, 80.56452057500007],
              [-90.63923092399995, 80.56850820500006],
              [-90.57542883999992, 80.56460195500006],
              [-90.56501217399995, 80.57367584800005],
              [-90.55483964799993, 80.57876211100006],
              [-90.49176998599995, 80.56342194200005],
              [-90.0066625639999, 80.54193756700005],
              [-89.94481360599991, 80.51581452000005],
              [-89.92446855399993, 80.51023997600004],
              [-89.90396074099993, 80.50824616100005],
              [-89.77432206899994, 80.46409739800004],
              [-89.73981686099995, 80.47093333500004],
              [-89.74746660099993, 80.48248932500007],
              [-89.81102454299992, 80.51504140800006],
              [-89.83193925699993, 80.52928294500003],
              [-89.71593176999994, 80.53676992400005],
              [-89.65855872299994, 80.53058502800008],
              [-89.63133704299992, 80.53172435100004],
              [-89.62653561099995, 80.54291413000004],
              [-89.32485917899993, 80.53676992400005],
              [-89.05797278599994, 80.46784088700008],
              [-89.09601803299995, 80.44794342700004],
              [-89.10863196499992, 80.44326406500005],
              [-89.22935950399994, 80.41518789300005],
              [-89.25719153599994, 80.39899323100008],
              [-89.21385657499991, 80.39288971600007],
              [-89.12083899599992, 80.40961334800005],
              [-89.07848059799994, 80.39899323100008],
              [-89.12169348899994, 80.36937083500004],
              [-89.1301977199999, 80.35561758000006],
              [-89.10578365799995, 80.34369538000004],
              [-89.12946529899995, 80.32957591400003],
              [-89.16567949099993, 80.31883372600004],
              [-89.26048743399991, 80.30365631700005],
              [-89.25584876199991, 80.28974030200004],
              [-89.23534094999991, 80.27383047100005],
              [-89.15884355399993, 80.23248932500007],
              [-89.04002844999991, 80.19375234600005],
              [-88.6023656889999, 80.11847565300008],
              [-88.57135982999995, 80.10724518400008],
              [-88.53844153599994, 80.09910716400003],
              [-88.49307206899994, 80.09829336100006],
              [-88.44741777299993, 80.10276927300004],
              [-88.41368567599994, 80.11098867400005],
              [-88.47118079299992, 80.13519928600005],
              [-88.48200436099995, 80.14508698100008],
              [-88.39281165299991, 80.14199453300006],
              [-88.27489173099991, 80.12181224200003],
              [-88.2449438139999, 80.10691966400003],
              [-88.14614824099993, 80.09731679900005],
              [-88.14614824099993, 80.10346100500004],
              [-88.17918860599991, 80.10927969000005],
              [-88.31867428299995, 80.15965403900003],
              [-88.39932206899994, 80.17523834800005],
              [-88.42735755099994, 80.19285716400003],
              [-88.37865149599992, 80.19245026200008],
              [-88.33116614499994, 80.18671295800004],
              [-88.29308020699995, 80.17397695500006],
              [-88.27440344999991, 80.17405833500004],
              [-88.25548255099994, 80.18671295800004],
              [-88.31021074099993, 80.21198151200008],
              [-88.50926673099991, 80.22077057500007],
              [-88.59337317599994, 80.23826732000003],
              [-88.61913001199991, 80.24811432500007],
              [-88.62857011599993, 80.25372955900008],
              [-88.63857988199993, 80.26337311400005],
              [-88.64647376199991, 80.26862213700008],
              [-88.67674719999991, 80.28107330900008],
              [-88.70856686099995, 80.28974030200004],
              [-88.65770423099991, 80.32172272300005],
              [-88.65005449099993, 80.33893463700008],
              [-88.68057206899994, 80.36107005400004],
              [-88.68114173099991, 80.37750885600008],
              [-88.64415442599994, 80.39667389500005],
              [-88.59634355399993, 80.41274648600006],
              [-88.54039466099994, 80.42259349200003],
              [-88.49331620999993, 80.43671295800004],
              [-88.46898352799991, 80.43988678600005],
              [-88.08476721949992, 80.42623525600004],
              [-87.70055091099994, 80.41258372600004],
              [-87.67430579299992, 80.40375397300005],
              [-87.65697180899991, 80.38837311400005],
              [-87.62230383999992, 80.34711334800005],
              [-87.61188717399995, 80.32851797100005],
              [-87.61782792899993, 80.29010651200008],
              [-87.61180579299992, 80.26862213700008],
              [-87.59386145699995, 80.24982330900008],
              [-87.57909094999991, 80.24054596600007],
              [-87.57217363199993, 80.22817617400005],
              [-87.57762610599991, 80.20034414300005],
              [-87.57518469999991, 80.19733307500007],
              [-87.56908118399991, 80.19452545800004],
              [-87.56476803299995, 80.19041575700004],
              [-87.5676977199999, 80.18329498900005],
              [-87.57555091099994, 80.17959219000005],
              [-87.58690344999991, 80.17865631700005],
              [-87.60830644399994, 80.17987702000005],
              [-87.62889563699991, 80.17658112200007],
              [-87.66942298099991, 80.16205475500004],
              [-88.02464758999992, 80.13849518400008],
              [-88.06362870999993, 80.12523021000004],
              [-88.04491126199991, 80.11969635600008],
              [-88.00706946499992, 80.11717357000003],
              [-87.98912512899994, 80.11098867400005],
              [-87.99400794199994, 80.09833405200004],
              [-87.98668372299994, 80.09414297100005],
              [-87.97362219999991, 80.09320709800005],
              [-87.96125240799995, 80.09048086100006],
              [-87.95726477799991, 80.08657461100006],
              [-87.95270748599995, 80.08051178600005],
              [-87.94595292899993, 80.07379791900007],
              [-87.93541419199994, 80.06806061400005],
              [-87.89867102799991, 80.05939362200007],
              [-87.8633520169999, 80.05902741100005],
              [-87.71410071499992, 80.07957591400003],
              [-87.23936926999994, 80.07037995000007],
              [-87.20026607999995, 80.03925202000005],
              [-87.19082597599993, 80.02374909100007],
              [-87.16881262899994, 80.00844961100006],
              [-87.12511145699995, 79.98802317900004],
              [-87.03579667899993, 79.96662018400008],
              [-87.00845292899993, 79.95331452000005],
              [-87.0352270169999, 79.93903229400007],
              [-87.10024980399993, 79.93622467700004],
              [-87.16344153599994, 79.92511627800008],
              [-87.19688880099994, 79.92377350500004],
              [-87.2293188139999, 79.91893138200004],
              [-87.28502356699994, 79.88393789300005],
              [-87.31212317599994, 79.87372467700004],
              [-87.43785559799994, 79.86107005400004],
              [-87.47118079299992, 79.85382721600007],
              [-87.48827063699991, 79.83722565300008],
              [-87.44041907499991, 79.83722565300008],
              [-87.34679114499994, 79.84251536700003],
              [-87.03237870999993, 79.91250234600005],
              [-86.99046790299991, 79.91632721600007],
              [-86.96202551999994, 79.90875885600008],
              [-86.97126217399995, 79.88157786700003],
              [-87.04942786399994, 79.81610748900005],
              [-87.06456458199995, 79.79462311400005],
              [-87.06554114499994, 79.77830638200004],
              [-87.06037350199995, 79.76146067900004],
              [-87.05687415299991, 79.73794179900005],
              [-87.06700598899994, 79.72492096600007],
              [-87.13133704299992, 79.67279694200005],
              [-87.13219153599994, 79.66937897300005],
              [-87.13133704299992, 79.65509674700007],
              [-87.13581295499995, 79.64948151200008],
              [-87.15794837099992, 79.63873932500007],
              [-87.18871008999992, 79.62783437700006],
              [-87.41071529899995, 79.59039948100008],
              [-87.4473363919999, 79.56907786700003],
              [-87.44188391799992, 79.56077708500004],
              [-87.4446508449999, 79.55206940300008],
              [-87.45205644399994, 79.54360586100006],
              [-87.46092688699991, 79.53558991100005],
              [-87.40172278599994, 79.51707591400003],
              [-87.34117591099994, 79.50824616100005],
              [-87.2805883449999, 79.51219310100004],
              [-87.22134355399993, 79.53217194200005],
              [-87.2044164699999, 79.54303620000007],
              [-87.17446855399993, 79.56757233300004],
              [-87.15929114499994, 79.57656484600005],
              [-87.12718665299991, 79.58543528900003],
              [-86.9910375639999, 79.60346100500004],
              [-86.84483801999994, 79.59316640800006],
              [-86.82087154899995, 79.58413320500006],
              [-86.82725989499994, 79.56598541900007],
              [-86.83788001199991, 79.54975006700005],
              [-86.82135982999995, 79.54669830900008],
              [-86.79507402299993, 79.55084870000007],
              [-86.77635657499991, 79.55609772300005],
              [-86.77586829299992, 79.55829498900005],
              [-86.77676347599993, 79.56683991100005],
              [-86.77635657499991, 79.56907786700003],
              [-86.76895097599993, 79.57037995000007],
              [-86.69375566299993, 79.56907786700003],
              [-86.71202551999994, 79.59202708500004],
              [-86.74697831899994, 79.60350169500003],
              [-86.81725012899994, 79.61749909100007],
              [-86.71934973899994, 79.64248281500005],
              [-86.62035071499992, 79.65204498900005],
              [-86.30907141799992, 79.64809804900005],
              [-86.25649980399993, 79.63898346600007],
              [-86.16685950399994, 79.60561758000006],
              [-86.08096269399994, 79.58368561400005],
              [-86.04206295499995, 79.56907786700003],
              [-86.05646725199995, 79.56354401200008],
              [-86.06314042899993, 79.56293366100005],
              [-86.05528723899994, 79.55585358300004],
              [-86.04987545499995, 79.55194733300004],
              [-86.04206295499995, 79.54857005400004],
              [-86.06021074099993, 79.54116445500006],
              [-86.08812415299991, 79.53465403900003],
              [-86.13825436099995, 79.52875397300005],
              [-86.13825436099995, 79.52191803600005],
              [-86.12242591099994, 79.52073802300004],
              [-86.08389238199993, 79.51288483300004],
              [-86.06940670499995, 79.50763580900008],
              [-86.06822669199994, 79.50495026200008],
              [-86.06798255099994, 79.50014883000006],
              [-86.06688391799992, 79.49481842700004],
              [-86.06285559799994, 79.49054596600007],
              [-86.05455481699994, 79.48676178600005],
              [-86.04605058499993, 79.48387278900003],
              [-86.03742428299995, 79.48191966400003],
              [-86.02839107999995, 79.48094310100004],
              [-86.06240800699993, 79.47475820500006],
              [-86.1360570949999, 79.47174713700008],
              [-86.16616777299993, 79.45986562700006],
              [-86.12498938699991, 79.44415924700007],
              [-86.06753495999993, 79.43618398600006],
              [-86.01060950399994, 79.43915436400005],
              [-85.97101803299995, 79.45644765800006],
              [-85.94481360599991, 79.48118724200003],
              [-85.92955481699994, 79.49038320500006],
              [-85.89443925699993, 79.49896881700005],
              [-85.89175370999993, 79.51080963700008],
              [-85.89867102799991, 79.53558991100005],
              [-85.86180579299992, 79.59300364800004],
              [-85.78648841099994, 79.61737702000005],
              [-85.69871985599991, 79.61798737200007],
              [-85.6243383449999, 79.60382721600007],
              [-85.5637914699999, 79.57977936400005],
              [-85.54918372299994, 79.56907786700003],
              [-85.54161536399994, 79.55727773600006],
              [-85.53937740799995, 79.54852936400005],
              [-85.53506425699993, 79.54083893400008],
              [-85.52159583199995, 79.53217194200005],
              [-85.45213782499991, 79.50633372600004],
              [-85.41917883999992, 79.48786041900007],
              [-85.40518144399994, 79.46356842700004],
              [-85.39443925699993, 79.45331452000005],
              [-85.32461503799993, 79.43805573100008],
              [-85.30443274599992, 79.42853424700007],
              [-85.26646887899994, 79.40534088700008],
              [-85.2468969389999, 79.39704010600008],
              [-85.10362708199995, 79.37189362200007],
              [-85.05577551999994, 79.35683828300006],
              [-85.00055904899995, 79.33014557500007],
              [-84.93602454299992, 79.30707428600005],
              [-84.91860917899993, 79.29596588700008],
              [-84.91258704299992, 79.27069733300004],
              [-84.94815019399994, 79.26007721600007],
              [-85.19595292899993, 79.23395416900007],
              [-85.24754798099991, 79.22028229400007],
              [-85.29556230399993, 79.19635651200008],
              [-85.3164770169999, 79.19232819200005],
              [-85.40477454299992, 79.19061920800004],
              [-85.45523027299993, 79.17511627800008],
              [-85.51048743399991, 79.16620514500005],
              [-85.63304602799991, 79.16258372600004],
              [-85.67650305899991, 79.14964427300004],
              [-86.09019934799991, 79.10915761950005],
              [-86.50389563699991, 79.06867096600007],
              [-86.56281490799995, 79.04897695500006],
              [-86.55199133999992, 79.03986237200007],
              [-86.5593969389999, 79.02781810100004],
              [-86.58454342399995, 79.00800202000005],
              [-86.58775794199994, 79.00165436400005],
              [-86.59215247299994, 78.98615143400008],
              [-86.59752356699994, 78.98004791900007],
              [-86.61461341099994, 78.97418854400007],
              [-86.74665279899995, 78.95905182500007],
              [-86.77721106699994, 78.96222565300008],
              [-86.81045488199993, 78.97321198100008],
              [-86.91201738199993, 79.01959870000007],
              [-86.92357337099992, 79.03156159100007],
              [-86.94359290299991, 79.05890534100007],
              [-86.95335852799991, 79.06317780200004],
              [-86.96825110599991, 79.06419505400004],
              [-86.98200436099995, 79.06098053600005],
              [-86.98794511599993, 79.05206940300008],
              [-86.9895727199999, 79.02749258000006],
              [-86.98794511599993, 79.02846914300005],
              [-87.00084387899994, 79.00063711100006],
              [-87.00112870999993, 78.99005768400008],
              [-86.98591061099995, 78.96808502800008],
              [-86.98546301999994, 78.96088288000004],
              [-86.9863988919999, 78.95482005400004],
              [-86.98485266799992, 78.94965241100005],
              [-86.97492428299995, 78.94110748900005],
              [-86.95091712099992, 78.92743561400005],
              [-86.94017493399991, 78.91860586100006],
              [-87.03612219999991, 78.87449778900003],
              [-87.22179114499994, 78.82172272300005],
              [-87.30980383999992, 78.80931224200003],
              [-87.33983313699991, 78.79279205900008],
              [-87.39207923099991, 78.75348541900007],
              [-87.49567623599995, 78.71088288000004],
              [-87.52920488199993, 78.69269440300008],
              [-87.53083248599995, 78.68903229400007],
              [-87.53111731699994, 78.68317291900007],
              [-87.53233801999994, 78.67682526200008],
              [-87.53669186099995, 78.67157623900005],
              [-87.55308997299994, 78.66404857000003],
              [-87.62157141799992, 78.64573802300004],
              [-87.6492406889999, 78.64301178600005],
              [-87.67227128799993, 78.64618561400005],
              [-87.85879472599993, 78.69269440300008],
              [-87.88792883999992, 78.70648834800005],
              [-87.91641191299993, 78.72626373900005],
              [-87.98452714799993, 78.79287344000005],
              [-87.99754798099991, 78.81122467700004],
              [-88.00023352799991, 78.83112213700008],
              [-87.98912512899994, 78.85712311400005],
              [-87.95579993399991, 78.90648021000004],
              [-87.95946204299992, 78.92890045800004],
              [-87.98912512899994, 78.95954010600008],
              [-87.98473059799994, 78.96430084800005],
              [-87.97996985599991, 78.96649811400005],
              [-87.97545325399994, 78.96702708500004],
              [-87.95685787699995, 78.97260163000004],
              [-87.88744055899991, 78.98187897300005],
              [-87.79735266799992, 79.00800202000005],
              [-87.80638587099992, 79.01520416900007],
              [-87.81639563699991, 79.02094147300005],
              [-87.82713782499991, 79.02533600500004],
              [-87.83828691299993, 79.02846914300005],
              [-87.81029212099992, 79.03998444200005],
              [-87.77586829299992, 79.04889557500007],
              [-87.74522864499994, 79.06134674700007],
              [-87.72842363199993, 79.08307526200008],
              [-87.76390540299991, 79.08860911700003],
              [-87.8054906889999, 79.07904694200005],
              [-87.87865149599992, 79.04523346600007],
              [-87.89224199099993, 79.03436920800004],
              [-87.89858964799993, 79.02423737200007],
              [-87.90746008999992, 79.01561107000003],
              [-87.92857825399994, 79.00897858300004],
              [-88.12559973899994, 79.00560130400004],
              [-88.17373613199993, 78.99559153900003],
              [-88.2083227199999, 78.97321198100008],
              [-88.21654212099992, 78.95286692900004],
              [-88.20885169199994, 78.93781159100007],
              [-88.19566809799994, 78.92332591400003],
              [-88.18712317599994, 78.90497467700004],
              [-88.19090735599991, 78.88385651200008],
              [-88.21825110599991, 78.84870026200008],
              [-88.22813880099994, 78.82990143400008],
              [-88.22891191299993, 78.80451080900008],
              [-88.21996008999992, 78.78294505400004],
              [-88.20474199099993, 78.76422760600008],
              [-88.14427649599992, 78.70677317900004],
              [-88.13621985599991, 78.68691640800006],
              [-88.1602270169999, 78.67841217700004],
              [-88.32258053299995, 78.67324453300006],
              [-88.35846920499995, 78.65790436400005],
              [-88.34162350199995, 78.65452708500004],
              [-88.3340551419999, 78.65517812700006],
              [-88.32494055899991, 78.65790436400005],
              [-88.32494055899991, 78.65176015800006],
              [-88.27717037699995, 78.66494375200006],
              [-88.0672094389999, 78.66290924700007],
              [-88.02204342399995, 78.65460846600007],
              [-87.97907467399995, 78.63971588700008],
              [-87.93390865799995, 78.61692942900004],
              [-87.9070531889999, 78.59601471600007],
              [-87.89867102799991, 78.57416413000004],
              [-87.90973873599995, 78.55243561400005],
              [-88.00743567599994, 78.49371979400007],
              [-88.04214433499993, 78.47931549700007],
              [-88.22850501199991, 78.46356842700004],
              [-88.27651933499993, 78.47662995000007],
              [-88.54405676999994, 78.58958567900004],
              [-88.54873613199993, 78.59393952000005],
              [-88.55260169199994, 78.60561758000006],
              [-88.55768795499995, 78.61017487200007],
              [-88.56956946499992, 78.61253489800004],
              [-88.61253821499992, 78.61017487200007],
              [-88.76740475199995, 78.61798737200007],
              [-88.78693600199995, 78.61619700700004],
              [-88.8047582669999, 78.61017487200007],
              [-88.76431230399993, 78.59837474200003],
              [-88.75739498599995, 78.58905670800004],
              [-88.7774145169999, 78.57599518400008],
              [-88.76333574099993, 78.57343170800004],
              [-88.75348873599995, 78.56850820500006],
              [-88.75035559799994, 78.56045156500005],
              [-88.75633704299992, 78.54873281500005],
              [-88.59870357999995, 78.45929596600007],
              [-88.57579505099994, 78.44668203300006],
              [-88.55117753799993, 78.43280670800004],
              [-88.54002844999991, 78.41689687700006],
              [-88.55768795499995, 78.39105866100005],
              [-88.57095292899993, 78.38060130400004],
              [-88.67373613199993, 78.32273997600004],
              [-88.67764238199993, 78.31614817900004],
              [-88.68260657499991, 78.29759349200003],
              [-88.68740800699993, 78.28864166900007],
              [-88.69579016799992, 78.28123607000003],
              [-88.70494544199994, 78.27513255400004],
              [-88.71231035099993, 78.26801178600005],
              [-88.72166907499991, 78.23700592700004],
              [-88.73672441299993, 78.21625397300005],
              [-88.77000891799992, 78.18553294500003],
              [-88.81126868399991, 78.16543203300006],
              [-88.85435950399994, 78.16006094000005],
              [-88.9988500639999, 78.16917552300004],
              [-89.04995683499993, 78.18170807500007],
              [-89.24592037699995, 78.26211172100005],
              [-89.2859594389999, 78.29490794500003],
              [-89.31505286399994, 78.30874258000006],
              [-89.32827714799993, 78.31903717700004],
              [-89.34080969999991, 78.33128489800004],
              [-89.35204016799992, 78.33905670800004],
              [-89.38011633999992, 78.35004303600005],
              [-89.49083411399994, 78.37543366100005],
              [-89.50601152299993, 78.38300202000005],
              [-89.53355872299994, 78.40204498900005],
              [-89.55142167899993, 78.41087474200003],
              [-89.62197831899994, 78.43073151200008],
              [-89.64517167899993, 78.43260325700004],
              [-89.65746008999992, 78.43573639500005],
              [-89.80426998599995, 78.50389232000003],
              [-89.81541907499991, 78.51337311400005],
              [-89.83535722599993, 78.53876373900005],
              [-89.84923255099994, 78.54718659100007],
              [-89.90086829299992, 78.56171295800004],
              [-89.95547441299993, 78.59711334800005],
              [-89.94863847599993, 78.60394928600005],
              [-89.9734594389999, 78.61200592700004],
              [-90.00617428299995, 78.61375560100004],
              [-90.03966223899994, 78.61107005400004],
              [-90.06672115799995, 78.60553620000007],
              [-90.08580481699994, 78.59324778900003],
              [-90.08315995999993, 78.56785716400003],
              [-90.09947669199994, 78.56171295800004],
              [-90.09203040299991, 78.55003489800004],
              [-90.07957923099991, 78.54140859600005],
              [-90.05109615799995, 78.52822500200006],
              [-90.0625707669999, 78.51805247600004],
              [-90.0586645169999, 78.50922272300005],
              [-90.02769934799994, 78.48680247600004],
              [-90.01134192599994, 78.48273346600007],
              [-90.00389563699991, 78.47980377800008],
              [-90.00072180899991, 78.47451406500005],
              [-90.00023352799991, 78.46845123900005],
              [-89.99608313699991, 78.46466705900008],
              [-89.98216712099992, 78.46613190300008],
              [-89.98884029899995, 78.44867584800005],
              [-89.97630774599992, 78.43943919500003],
              [-89.7871801419999, 78.39838288000004],
              [-89.59923255099994, 78.28522370000007],
              [-89.5891820949999, 78.27619049700007],
              [-89.56818600199995, 78.23704661700003],
              [-89.54255123599995, 78.21987539300005],
              [-89.47203528599994, 78.18618398600006],
              [-89.45518958199995, 78.16449616100005],
              [-89.49567623599995, 78.15607330900008],
              [-89.53538977799991, 78.15249258000006],
              [-89.57481848899994, 78.15444570500006],
              [-89.61436926999994, 78.16282786700003],
              [-89.62612870999993, 78.16766998900005],
              [-89.63658606699994, 78.17479075700004],
              [-89.64415442599994, 78.18414948100008],
              [-89.64704342399995, 78.19578685100004],
              [-89.65192623599995, 78.20888906500005],
              [-89.66405188699991, 78.21649811400005],
              [-89.69522050699993, 78.22455475500004],
              [-89.71349036399994, 78.22614166900007],
              [-89.90135657499991, 78.22117747600004],
              [-89.93643144399994, 78.22874583500004],
              [-89.96035722599993, 78.24355703300006],
              [-89.95547441299993, 78.26752350500004],
              [-90.04649817599994, 78.30463288000004],
              [-90.13878333199995, 78.32526276200008],
              [-90.33202063699991, 78.33637116100005],
              [-90.53831946499992, 78.32273997600004],
              [-90.70543372299994, 78.33543528900003],
              [-90.75059973899994, 78.32273997600004],
              [-90.70425370999993, 78.30573151200008],
              [-90.59459387899994, 78.29120514500005],
              [-90.37254798099991, 78.28750234600005],
              [-90.32542883999992, 78.27435944200005],
              [-90.35716712099992, 78.26459381700005],
              [-90.37035071499992, 78.25629303600005],
              [-90.37319902299993, 78.24079010600008],
              [-90.36217200399994, 78.22744375200006],
              [-90.34105383999992, 78.21735260600008],
              [-90.29991614499994, 78.20473867400005],
              [-90.27594967399995, 78.18646881700005],
              [-90.28795325399994, 78.16738515800006],
              [-90.31920325399994, 78.15192291900007],
              [-90.35269120999993, 78.14459870000007],
              [-90.60362708199995, 78.15387604400007],
              [-90.88414466099994, 78.14459870000007],
              [-91.18464107999995, 78.17544179900005],
              [-91.60440019399994, 78.19086334800005],
              [-91.76585852799991, 78.23065827000005],
              [-91.82005774599992, 78.23574453300006],
              [-91.85952714799993, 78.24388255400004],
              [-91.96987870999993, 78.23086172100005],
              [-91.99201412699995, 78.21792226800005],
              [-92.00438391799992, 78.21287669500003],
              [-92.02452551999994, 78.21067942900004],
              [-92.06651770699995, 78.21552155200004],
              [-92.11632239499994, 78.22695547100005],
              [-92.19615637899994, 78.26129791900007],
              [-92.18740800699993, 78.27692291900007],
              [-92.20128333199995, 78.28253815300008],
              [-92.3079320949999, 78.28294505400004],
              [-92.32652747299994, 78.28864166900007],
              [-92.29491126199991, 78.30414459800005],
              [-92.21198482999995, 78.30768463700008],
              [-92.17568925699993, 78.31533437700006],
              [-92.21983801999994, 78.33226146000004],
              [-92.27867591099994, 78.32843659100007],
              [-92.38857988199993, 78.30849844000005],
              [-92.50340735599991, 78.31317780200004],
              [-92.61388098899994, 78.33637116100005],
              [-92.60578365799995, 78.35187409100007],
              [-92.6009008449999, 78.35687897300005],
              [-92.62425696499992, 78.36493561400005],
              [-92.67804928299995, 78.36835358300004],
              [-92.82192949099993, 78.40155670800004],
              [-92.87035071499992, 78.40525950700004],
              [-92.95274817599994, 78.43671295800004],
              [-92.99128170499995, 78.46613190300008],
              [-92.96906490799995, 78.48956940300008],
              [-92.93517005099994, 78.49705638200004],
              [-92.87539628799993, 78.49599844000005],
              [-92.87979081899994, 78.49925364800004],
              [-92.88198808499993, 78.50706614800004],
              [-92.62816321499992, 78.49408600500004],
              [-92.63560950399994, 78.49408600500004],
              [-92.5593969389999, 78.49359772300005],
              [-92.51943925699993, 78.49933502800008],
              [-92.49095618399991, 78.51455312700006],
              [-92.56672115799995, 78.52073802300004],
              [-92.54271399599992, 78.52741120000007],
              [-92.5188695949999, 78.52728913000004],
              [-92.47052975199995, 78.52073802300004],
              [-92.15725663999993, 78.53534577050004],
              [-91.84398352799991, 78.54995351800005],
              [-91.72618567599994, 78.53925202000005],
              [-91.69741777299993, 78.53327057500007],
              [-91.65396074099993, 78.52985260600008],
              [-91.63878333199995, 78.54645416900007],
              [-91.64915930899991, 78.56500885600008],
              [-91.68248450399994, 78.56728750200006],
              [-91.73729407499991, 78.55947500200006],
              [-92.19660397049992, 78.58567942900007],
              [-92.65591386599993, 78.61188385600008],
              [-92.73302161399994, 78.62954336100006],
              [-92.8113500639999, 78.63808828300006],
              [-92.85045325399994, 78.63548411700003],
              [-92.90941321499992, 78.62494538000004],
              [-92.93004309799994, 78.62376536700003],
              [-92.93659420499995, 78.62213776200008],
              [-92.93761145699995, 78.61823151200008],
              [-92.93814042899993, 78.61359284100007],
              [-92.94347083199995, 78.61017487200007],
              [-92.97679602799991, 78.60431549700007],
              [-93.21621660099993, 78.58958567900004],
              [-93.28172766799992, 78.59471263200004],
              [-93.34683183499993, 78.60834381700005],
              [-93.47175045499995, 78.65176015800006],
              [-93.47175045499995, 78.65790436400005],
              [-93.44391842399995, 78.65802643400008],
              [-93.37291419199994, 78.66913483300004],
              [-93.34752356699994, 78.67841217700004],
              [-93.37368730399993, 78.68829987200007],
              [-93.52281653599994, 78.67674388200004],
              [-93.53937740799995, 78.67841217700004],
              [-93.55386308499993, 78.68317291900007],
              [-93.58238684799994, 78.69623444200005],
              [-93.65184485599991, 78.70880768400008],
              [-93.75938880099994, 78.75438060100004],
              [-93.81309973899994, 78.76776764500005],
              [-93.77745520699995, 78.78266022300005],
              [-93.56615149599992, 78.78628164300005],
              [-93.16258704299992, 78.73989492400005],
              [-93.06480872299994, 78.74184804900005],
              [-93.05044511599993, 78.74579498900005],
              [-93.04246985599991, 78.75226471600007],
              [-93.04588782499991, 78.76097239800004],
              [-93.03844153599994, 78.76776764500005],
              [-93.08116614499994, 78.77838776200008],
              [-93.3062231109999, 78.80414459800005],
              [-93.36709550699993, 78.82046133000006],
              [-93.5469457669999, 78.83856842700004],
              [-93.77281653599994, 78.83124420800004],
              [-93.8745824859999, 78.83397044500003],
              [-93.90587317599994, 78.84690989800004],
              [-93.93057206899994, 78.86701080900008],
              [-93.9602758449999, 78.88328685100004],
              [-93.99278723899994, 78.89419179900005],
              [-94.06265214799993, 78.90224844000005],
              [-94.2715551419999, 78.96820709800005],
              [-94.29352779899995, 78.98688385600008],
              [-94.21031653599994, 79.00763580900008],
              [-94.02098548099991, 79.02643463700008],
              [-93.93175208199995, 79.04340241100005],
              [-93.80646725199995, 79.04779694200005],
              [-93.68639075399994, 79.05975983300004],
              [-93.64561926999994, 79.05414459800005],
              [-93.62706458199995, 79.05410390800006],
              [-93.60924231699994, 79.05687083500004],
              [-93.59398352799991, 79.06264883000006],
              [-93.57583574099993, 79.08397044500003],
              [-93.4700414699999, 79.12006256700005],
              [-93.46422278599994, 79.13833242400005],
              [-93.43297278599994, 79.15648021000004],
              [-93.38341223899994, 79.16657135600008],
              [-93.33047441299993, 79.17096588700008],
              [-93.22911536399994, 79.17121002800008],
              [-93.08433997299994, 79.15281810100004],
              [-93.00112870999993, 79.15949127800008],
              [-92.84044348899994, 79.14516836100006],
              [-92.81725012899994, 79.14899323100008],
              [-92.77440344999991, 79.16132233300004],
              [-92.75108801999994, 79.16502513200004],
              [-92.52733313699991, 79.16771067900004],
              [-92.29027258999992, 79.15306224200003],
              [-91.88121497299994, 79.16351959800005],
              [-91.57494055899991, 79.18036530200004],
              [-91.37559973899994, 79.19501373900005],
              [-91.23932857999995, 79.19285716400003],
              [-90.96971594949994, 79.20547109600005],
              [-90.70010331899994, 79.21808502800008],
              [-90.5281469389999, 79.22016022300005],
              [-90.38776607999995, 79.23956940300008],
              [-90.36636308499993, 79.24754466400003],
              [-90.37319902299993, 79.24754466400003],
              [-90.41657467399995, 79.26080963700008],
              [-90.76305091099994, 79.24945709800005],
              [-91.04417883999992, 79.25165436400005],
              [-91.35464433499993, 79.23004791900007],
              [-91.74498450399994, 79.21723053600005],
              [-91.88536536399994, 79.22016022300005],
              [-92.08629309799994, 79.20600006700005],
              [-92.35682125549994, 79.22571442250006],
              [-92.62734941299993, 79.24542877800008],
              [-92.67080644399994, 79.25348541900007],
              [-92.69587154899995, 79.26740143400008],
              [-92.66856848899994, 79.27460358300004],
              [-92.60065670499995, 79.30414459800005],
              [-92.56444251199991, 79.31037018400008],
              [-92.13475501199991, 79.30219147300005],
              [-92.13475501199991, 79.30963776200008],
              [-92.15835527299993, 79.31549713700008],
              [-92.17080644399994, 79.31655508000006],
              [-92.1831762359999, 79.31586334800005],
              [-92.16649329299992, 79.32001373900005],
              [-92.14273027299993, 79.32111237200007],
              [-92.11945553299995, 79.31875234600005],
              [-92.08486894399994, 79.30361562700006],
              [-92.06248938699991, 79.30076732000003],
              [-91.91502844999991, 79.30219147300005],
              [-91.8484594389999, 79.31513092700004],
              [-91.82628333199995, 79.31586334800005],
              [-91.83307857999995, 79.31586334800005],
              [-91.65884355399993, 79.33559804900005],
              [-91.49551347599993, 79.33543528900003],
              [-91.17027747299994, 79.35439687700006],
              [-91.14781653599994, 79.36424388200004],
              [-91.14781653599994, 79.35683828300006],
              [-91.14610755099994, 79.35927969000005],
              [-91.14488684799994, 79.36273834800005],
              [-91.14171301999994, 79.36505768400008],
              [-91.13414466099994, 79.36424388200004],
              [-91.13776607999995, 79.36725495000007],
              [-91.14419511599993, 79.37433502800008],
              [-91.14781653599994, 79.37726471600007],
              [-91.12755286399994, 79.38865794500003],
              [-91.12051347599993, 79.39158763200004],
              [-91.16283118399991, 79.39594147300005],
              [-91.32949785099993, 79.37962474200003],
              [-91.46165930899991, 79.37962474200003],
              [-91.7437231109999, 79.36424388200004],
              [-91.8074438139999, 79.34577057500007],
              [-91.83031165299991, 79.34316640800006],
              [-92.05117753799993, 79.35398997600004],
              [-92.16860917899993, 79.35236237200007],
              [-92.39854895699995, 79.37103913000004],
              [-92.49535071499992, 79.36542389500005],
              [-92.54775956899994, 79.36859772300005],
              [-92.58039303299995, 79.38475169500003],
              [-92.56163489499994, 79.39150625200006],
              [-92.49787350199995, 79.39899323100008],
              [-92.42296301999994, 79.41771067900004],
              [-92.39956620999993, 79.42023346600007],
              [-92.35147050699993, 79.41803620000007],
              [-92.27977454299992, 79.42999909100007],
              [-92.23033606699994, 79.43256256700005],
              [-92.24982662699995, 79.44953034100007],
              [-92.28746497299994, 79.45750560100004],
              [-92.60631262899994, 79.45062897300005],
              [-92.8472387359999, 79.41266510600008],
              [-92.92381751199991, 79.41600169500003],
              [-92.95815995999993, 79.42503489800004],
              [-93.0535375639999, 79.48016998900005],
              [-93.06761633999992, 79.48529694200005],
              [-93.08665930899991, 79.48712799700007],
              [-93.11790930899991, 79.48590729400007],
              [-93.13451087099992, 79.48297760600008],
              [-93.14517167899993, 79.47724030200004],
              [-93.14696204299992, 79.46625397300005],
              [-93.13609778599994, 79.45892975500004],
              [-93.11107337099992, 79.44989655200004],
              [-93.08531653599994, 79.43463776200008],
              [-93.0254613919999, 79.40843333500004],
              [-93.00495357999995, 79.39158763200004],
              [-93.09235592399995, 79.37083567900004],
              [-93.38853919199994, 79.34316640800006],
              [-93.37132727799991, 79.35492584800005],
              [-93.31338456899994, 79.37726471600007],
              [-93.2632543609999, 79.40814850500004],
              [-93.23436438699991, 79.41815827000005],
              [-93.23997962099992, 79.43048737200007],
              [-93.25572669199994, 79.44358958500004],
              [-93.27220618399991, 79.45136139500005],
              [-93.29800370999993, 79.45441315300008],
              [-93.32103430899991, 79.45205312700006],
              [-93.34190833199995, 79.44550202000005],
              [-93.37706458199995, 79.43032461100006],
              [-93.41246497299994, 79.41933828300006],
              [-93.42638098899994, 79.40892161700003],
              [-93.43789628799993, 79.39655182500007],
              [-93.44961503799993, 79.38686758000006],
              [-93.49510657499991, 79.36017487200007],
              [-93.50584876199991, 79.35683828300006],
              [-93.52188066299993, 79.35492584800005],
              [-93.5730688139999, 79.35683828300006],
              [-93.62677975199995, 79.36542389500005],
              [-93.65440833199995, 79.36652252800008],
              [-93.67650305899991, 79.35683828300006],
              [-93.66222083199995, 79.35000234600005],
              [-93.66901607999995, 79.34882233300004],
              [-93.68394934799994, 79.34316640800006],
              [-93.66958574099993, 79.33905670800004],
              [-93.65493730399993, 79.33661530200004],
              [-93.64098059799994, 79.33234284100007],
              [-93.62873287699995, 79.32269928600005],
              [-93.65892493399991, 79.31195709800005],
              [-93.72227942599994, 79.30231354400007],
              [-93.78600012899994, 79.28058502800008],
              [-93.92979895699995, 79.25918203300006],
              [-94.0464574859999, 79.26121653900003],
              [-94.13499915299991, 79.27993398600006],
              [-94.15269934799994, 79.28123607000003],
              [-94.21092688699991, 79.27488841400003],
              [-94.19737708199995, 79.28221263200004],
              [-94.17609615799995, 79.28896719000005],
              [-94.16112219999991, 79.29808177300004],
              [-94.16657467399995, 79.31273021000004],
              [-94.16543535099993, 79.32550690300008],
              [-94.1441137359999, 79.33685944200005],
              [-94.00975501199991, 79.37254466400003],
              [-93.87401282499991, 79.39175039300005],
              [-93.84097245999993, 79.39158763200004],
              [-93.84097245999993, 79.39899323100008],
              [-94.09190833199995, 79.39179108300004],
              [-94.48009192599994, 79.42666250200006],
              [-94.51256262899994, 79.41950104400007],
              [-94.49950110599991, 79.41327545800004],
              [-94.49071204299992, 79.40497467700004],
              [-94.48924719999991, 79.39520905200004],
              [-94.49828040299991, 79.38475169500003],
              [-94.48436438699991, 79.37958405200004],
              [-94.47240149599992, 79.38255442900004],
              [-94.46060136599993, 79.38837311400005],
              [-94.44709225199995, 79.39158763200004],
              [-94.43228105399993, 79.38971588700008],
              [-94.41665605399993, 79.38495514500005],
              [-94.38841712099992, 79.37103913000004],
              [-94.43443762899994, 79.36619700700004],
              [-94.52977454299992, 79.34247467700004],
              [-94.96068274599992, 79.29157135600008],
              [-94.98273678299995, 79.27191803600005],
              [-95.00230872299994, 79.26740143400008],
              [-95.11929277299993, 79.28172435100004],
              [-95.2110082669999, 79.28095123900005],
              [-95.23875891799992, 79.28851959800005],
              [-95.22838294199994, 79.29694245000007],
              [-95.21670488199993, 79.30304596600007],
              [-95.20409094999991, 79.30727773600006],
              [-95.19102942599994, 79.30963776200008],
              [-95.19102942599994, 79.31586334800005],
              [-95.22227942599994, 79.31500885600008],
              [-95.2578832669999, 79.31781647300005],
              [-95.2925512359999, 79.32501862200007],
              [-95.32135982999995, 79.33698151200008],
              [-95.29800370999993, 79.34186432500007],
              [-95.27550208199995, 79.34210846600007],
              [-95.2532445949999, 79.33844635600008],
              [-95.23045813699991, 79.33193594000005],
              [-95.21353105399993, 79.33063385600008],
              [-95.19664466099994, 79.33563873900005],
              [-95.16368567599994, 79.35000234600005],
              [-95.18126380099994, 79.35687897300005],
              [-95.28062903599994, 79.35781484600005],
              [-95.29015051999994, 79.36196523600006],
              [-95.28038489499994, 79.37103913000004],
              [-95.28465735599991, 79.37982819200005],
              [-95.29063880099994, 79.38629791900007],
              [-95.2984106109999, 79.39020416900007],
              [-95.30768795499995, 79.39158763200004],
              [-95.29991614499994, 79.39423248900005],
              [-95.28038489499994, 79.40521881700005],
              [-95.35220292899993, 79.40668366100005],
              [-95.38597571499992, 79.39984772300005],
              [-95.39024817599994, 79.37726471600007],
              [-95.56639563699991, 79.39150625200006],
              [-95.64598548099991, 79.39427317900004],
              [-95.67076575399994, 79.40216705900008],
              [-95.69790605399993, 79.40713125200006],
              [-95.75536048099991, 79.40623607000003],
              [-95.78001868399991, 79.41950104400007],
              [-95.77257239499994, 79.42035553600005],
              [-95.7527563139999, 79.42572663000004],
              [-95.7730199859999, 79.43146393400008],
              [-95.78001868399991, 79.43256256700005],
              [-95.75267493399991, 79.43854401200008],
              [-95.69692949099993, 79.44009023600006],
              [-95.67015540299991, 79.44684479400007],
              [-95.70750891799992, 79.46478913000004],
              [-95.71861731699994, 79.46727122600004],
              [-95.73277747299994, 79.46820709800005],
              [-95.76646887899994, 79.47500234600005],
              [-95.78001868399991, 79.48094310100004],
              [-95.75926673099991, 79.48126862200007],
              [-95.73900305899991, 79.48550039300005],
              [-95.72044837099992, 79.49408600500004],
              [-95.70494544199994, 79.50763580900008],
              [-95.72325598899994, 79.52220286700003],
              [-95.73273678299995, 79.53156159100007],
              [-95.7390844389999, 79.54242584800005],
              [-95.69709225199995, 79.54364655200004],
              [-95.61148027299993, 79.55902741100005],
              [-95.16958574149993, 79.58476390200005],
              [-94.72769120999993, 79.61050039300005],
              [-94.63638261599993, 79.63617584800005],
              [-94.3406469389999, 79.68622467700004],
              [-94.32823645699995, 79.69696686400005],
              [-94.33267167899993, 79.70563385600008],
              [-94.35411536399994, 79.72455475500004],
              [-94.36172441299993, 79.73419830900008],
              [-94.3098852199999, 79.74778880400004],
              [-94.29344641799992, 79.75873444200005],
              [-94.30028235599991, 79.77521393400008],
              [-94.31908118399991, 79.78388092700004],
              [-94.34512285099993, 79.78742096600007],
              [-94.37083899599992, 79.78485748900005],
              [-94.38841712099992, 79.77521393400008],
              [-94.38320878799993, 79.77387116100005],
              [-94.36856035099993, 79.76829661700003],
              [-94.41649329299992, 79.75287506700005],
              [-94.57384192599994, 79.74310944200005],
              [-94.58828691299993, 79.73672109600005],
              [-94.60362708199995, 79.71820709800005],
              [-94.61546790299991, 79.71190013200004],
              [-94.69399980399993, 79.70636627800008],
              [-94.71800696499992, 79.70062897300005],
              [-94.77017167899993, 79.68211497600004],
              [-95.14415442599994, 79.65643952000005],
              [-95.19326738199993, 79.64740631700005],
              [-95.52350826749992, 79.64990875850006],
              [-95.85374915299991, 79.65241120000007],
              [-96.13385982999995, 79.73725006700005],
              [-96.17886308499993, 79.74164459800005],
              [-96.21910559799994, 79.73993561400005],
              [-96.23814856699994, 79.74339427300004],
              [-96.25300045499995, 79.75462474200003],
              [-96.25059973899994, 79.76837799700007],
              [-96.25023352799991, 79.77960846600007],
              [-96.25300045499995, 79.78880442900004],
              [-96.26593990799995, 79.79865143400008],
              [-96.2852270169999, 79.80646393400008],
              [-96.40664628799993, 79.83222077000005],
              [-96.49323482999995, 79.83722565300008],
              [-96.46983801999994, 79.84853750200006],
              [-96.41588294199994, 79.85553620000007],
              [-96.3902074859999, 79.86448802300004],
              [-96.4375707669999, 79.86945221600007],
              [-96.54271399599992, 79.84837474200003],
              [-96.58877519399994, 79.85712311400005],
              [-96.58193925699993, 79.86448802300004],
              [-96.58983313699991, 79.87128327000005],
              [-96.59829667899993, 79.87714264500005],
              [-96.60724850199995, 79.88174062700006],
              [-96.61611894399994, 79.88499583500004],
              [-96.5991918609999, 79.89598216400003],
              [-96.58079993399991, 79.90232982000003],
              [-96.56126868399991, 79.90509674700007],
              [-96.50706946499992, 79.90692780200004],
              [-96.47956295499995, 79.91168854400007],
              [-96.40640214799993, 79.91331614800004],
              [-96.37726803299995, 79.90497467700004],
              [-96.3902074859999, 79.88499583500004],
              [-96.36270097599993, 79.88666413000004],
              [-96.30858313699991, 79.90180084800005],
              [-96.28066972599993, 79.90550364800004],
              [-96.17039954299992, 79.90371328300006],
              [-96.13687089799993, 79.91168854400007],
              [-96.20738684799994, 79.93374258000006],
              [-96.5579320949999, 79.94855377800008],
              [-96.59561113199993, 79.96015045800004],
              [-96.61693274599992, 79.97329336100006],
              [-96.65343176999994, 80.00210195500006],
              [-96.67756100199995, 80.01536692900004],
              [-96.64403235599991, 80.02765534100007],
              [-96.3902074859999, 80.04889557500007],
              [-96.56456458199995, 80.05219147300005],
              [-96.6231176419999, 80.04433828300006],
            ],
          ],
          [
            [
              [-61.0854792959999, 82.33116282800006],
              [-61.08617102799991, 82.30711497600004],
              [-61.09890702999991, 82.28021881700005],
              [-61.1186824209999, 82.25836823100008],
              [-61.1404109369999, 82.24925364800004],
              [-61.16047115799995, 82.24595774900007],
              [-61.31240800699993, 82.19721100500004],
              [-61.67186438699994, 82.16830068600004],
              [-62.031320766999954, 82.13939036700003],
              [-61.992949998999904, 82.12938060100004],
              [-61.91079667899993, 82.12425364800004],
              [-61.873076951999906, 82.11273834800005],
              [-61.91356360599991, 82.09784577000005],
              [-62.00234941299993, 82.08665599200003],
              [-62.085926886999914, 82.05963776200008],
              [-62.25763912699995, 82.02354564000007],
              [-62.3904109369999, 82.01585521000004],
              [-62.475819464999915, 82.02277252800008],
              [-62.49787350199995, 82.01963939000007],
              [-62.51223710799991, 82.01268138200004],
              [-62.51195227799991, 82.00584544500003],
              [-62.49006100199995, 82.00287506700005],
              [-62.51480058499993, 81.98704661700003],
              [-62.77987626849992, 81.95028310750004],
              [-63.044951951999906, 81.91351959800005],
              [-63.0381160149999, 81.91351959800005],
              [-63.11693274599992, 81.91132233300004],
              [-63.51856441949991, 81.85500722850006],
              [-63.9201960929999, 81.79869212400007],
              [-64.12295488199993, 81.80316803600005],
              [-64.28604081899994, 81.83116282800006],
              [-64.32607988199993, 81.83091868700006],
              [-64.30825761599993, 81.81952545800004],
              [-64.1206355459999, 81.76947663000004],
              [-64.14614824099993, 81.75324127800008],
              [-64.1865535149999, 81.74498118700006],
              [-64.30174719999991, 81.73847077000005],
              [-64.3725886709999, 81.72496165600006],
              [-64.7805883449999, 81.73102448100008],
              [-64.8811335929999, 81.75360748900005],
              [-64.9221492179999, 81.75792064000007],
              [-65.04629472599993, 81.74900950700004],
              [-65.3750300769999, 81.76268138200004],
              [-65.36497962099992, 81.75975169500003],
              [-65.35594641799992, 81.75531647300005],
              [-65.3479304679999, 81.74913157800006],
              [-65.3408503899999, 81.74156321800007],
              [-65.36123613199993, 81.73436107000003],
              [-65.70392818899992, 81.71438222850006],
              [-66.04662024599992, 81.69440338700008],
              [-66.00576738199993, 81.68296946800007],
              [-65.8686824209999, 81.69440338700008],
              [-65.70742753799993, 81.68012116100005],
              [-65.3408503899999, 81.69440338700008],
              [-65.3740535149999, 81.68052806200006],
              [-65.85814368399991, 81.62726471600007],
              [-65.9299617179999, 81.63975657800006],
              [-65.94603430899991, 81.65391673400006],
              [-65.99974524599992, 81.65436432500007],
              [-66.1506648429999, 81.62787506700005],
              [-66.38980058499993, 81.62034739800004],
              [-66.62490800699993, 81.62287018400008],
              [-67.07249915299991, 81.61102936400005],
              [-67.37281246649991, 81.60219961150005],
              [-67.6731257799999, 81.59336985900006],
              [-67.94316565649993, 81.57829417550005],
              [-68.21320553299995, 81.56321849200003],
              [-68.5782500206666, 81.61603424700003],
              [-68.94329450833327, 81.66885000200004],
              [-69.30833899599992, 81.72166575700004],
              [-69.2512914699999, 81.70030345300006],
              [-68.8203425769999, 81.63346995650005],
              [-68.38939368399991, 81.56663646000004],
              [-68.3562312489999, 81.54295482000003],
              [-68.85586503799993, 81.55036041900007],
              [-68.85586503799993, 81.54295482000003],
              [-68.58055579299992, 81.51609935100004],
              [-68.14331349699991, 81.53453196833338],
              [-67.70607120099992, 81.55296458566671],
              [-67.2688289049999, 81.57139720300006],
              [-66.9638972644999, 81.55131663650005],
              [-66.6589656239999, 81.53123607000003],
              [-66.60830644399994, 81.51622142100007],
              [-66.6540828119999, 81.49986399900007],
              [-66.94880123599995, 81.47565338700008],
              [-67.11367753799993, 81.46385325700004],
              [-67.28433183499993, 81.44249095300006],
              [-67.66458085849993, 81.40792470950007],
              [-68.04482988199993, 81.37335846600007],
              [-68.14504960799991, 81.35069407800006],
              [-68.25503495999993, 81.34459056200006],
              [-68.44066321499992, 81.31134674700007],
              [-68.57526607999995, 81.30333079600007],
              [-68.56843014199995, 81.30333079600007],
              [-68.62173417899993, 81.29401276200008],
              [-68.73363196499992, 81.29197825700004],
              [-68.8164770169999, 81.27619049700007],
              [-68.87946529899995, 81.27879466400003],
              [-68.9356176419999, 81.26780833500004],
              [-69.0202937489999, 81.26178620000007],
              [-69.4250789049999, 81.27671946800007],
              [-69.4734187489999, 81.26178620000007],
              [-69.43626868399991, 81.25169505400004],
              [-69.35171464799993, 81.25181712400007],
              [-69.31517493399991, 81.24192942900004],
              [-69.36676998599995, 81.24046458500004],
              [-69.58006751199991, 81.21190013200004],
              [-69.70002193899995, 81.21202220300006],
              [-69.92373613199993, 81.18817780200004],
              [-70.1648249989999, 81.19371165600006],
              [-70.21328691299993, 81.17987702000005],
              [-70.07103430899991, 81.16205475500004],
              [-69.63727779899995, 81.17987702000005],
              [-69.66112219999991, 81.17173899900007],
              [-69.74006100199995, 81.16111888200004],
              [-69.81753495999993, 81.14122142100007],
              [-69.9997859369999, 81.11615631700005],
              [-70.02025305899991, 81.10594310100004],
              [-69.63231360599991, 81.13865794500003],
              [-69.5342097649999, 81.17454661700003],
              [-69.4822078119999, 81.18480052300004],
              [-69.0584102044999, 81.21785106000004],
              [-68.63461259699992, 81.25090159700005],
              [-68.21081498949992, 81.28395213400006],
              [-67.78701738199993, 81.31700267100007],
              [-67.77928626199991, 81.32135651200008],
              [-67.49067135299993, 81.34841543150006],
              [-67.20205644399994, 81.37547435100004],
              [-66.8372289699999, 81.39667389500005],
              [-66.52794348849991, 81.42141347850006],
              [-66.21865800699993, 81.44615306200006],
              [-65.95950273299991, 81.46385325700004],
              [-65.73574785099993, 81.49327220300006],
              [-65.24697831899994, 81.51093170800004],
              [-64.9348852199999, 81.53453196800007],
              [-64.54605058499993, 81.55036041900007],
              [-64.53075110599991, 81.54686107000003],
              [-64.5205378899999, 81.53843821800007],
              [-64.51097571499992, 81.52830638200004],
              [-64.49762936099995, 81.51935455900008],
              [-64.46174068899995, 81.50592682500007],
              [-64.44701087099992, 81.49669017100007],
              [-64.43594316299993, 81.48151276200008],
              [-64.4490046869999, 81.47052643400008],
              [-64.46816972599993, 81.46141185100004],
              [-64.69212805899991, 81.39081452000005],
              [-65.11636308499993, 81.33283112200007],
              [-65.40005449099993, 81.26951732000003],
              [-65.57673092399995, 81.25181712400007],
              [-65.6709285149999, 81.25706614800004],
              [-65.8713679679999, 81.22960032800006],
              [-65.98892167899993, 81.22825755400004],
              [-66.10635331899994, 81.19749583500004],
              [-66.2478328119999, 81.17816803600005],
              [-66.27253170499995, 81.16270579600007],
              [-66.29670162699995, 81.15269603100006],
              [-66.46393795499995, 81.12156810100004],
              [-66.48053951699995, 81.11273834800005],
              [-66.51211503799993, 81.09105052300004],
              [-66.53001868399991, 81.08246491100005],
              [-66.67210852799991, 81.03986237200007],
              [-66.87165279899995, 81.01365794500003],
              [-67.23493404899995, 80.94049713700008],
              [-67.56301835799991, 80.94599030200004],
              [-67.60887610599991, 80.93341705900008],
              [-67.5915828119999, 80.92291901200008],
              [-67.53319251199991, 80.89866771000004],
              [-67.56672115799995, 80.88361237200007],
              [-67.60578365799995, 80.87120189000007],
              [-67.68399003799993, 80.85765208500004],
              [-67.78091386599993, 80.85887278900003],
              [-67.83275305899991, 80.85394928600005],
              [-67.86278235599991, 80.83722565300008],
              [-67.84333248599995, 80.82933177300004],
              [-67.85374915299991, 80.82282135600008],
              [-67.92845618399991, 80.81329987200007],
              [-67.98501542899993, 80.79645416900007],
              [-68.27936764199995, 80.75987376500007],
              [-68.4033503899999, 80.72117747600004],
              [-68.47606360599991, 80.71067942900004],
              [-68.58454342399995, 80.68284739800004],
              [-68.65330969999991, 80.67613353100006],
              [-68.77326412699995, 80.63922760600008],
              [-68.97256425699993, 80.61749909100007],
              [-68.9538874989999, 80.60761139500005],
              [-68.9336238269999, 80.60398997600004],
              [-68.89061438699991, 80.60447825700004],
              [-68.92601477799991, 80.58336009300007],
              [-69.13296464799993, 80.53624095300006],
              [-69.16812089799993, 80.52208079600007],
              [-69.21621660099993, 80.48908112200007],
              [-69.26707923099991, 80.47101471600007],
              [-69.27920488199993, 80.46190013200004],
              [-69.28604081899994, 80.45103587400007],
              [-69.2910457019999, 80.43992747600004],
              [-69.29775956899994, 80.43003978100006],
              [-69.33177649599992, 80.40892161700003],
              [-69.37417558499993, 80.39740631700005],
              [-69.66600501199991, 80.35521067900004],
              [-69.98774166549993, 80.35661448750005],
              [-70.30947831899994, 80.35801829600007],
              [-70.2949519519999, 80.37457916900007],
              [-70.23810787699995, 80.40326569200005],
              [-70.2195124989999, 80.41950104400007],
              [-70.26952063699991, 80.45347728100006],
              [-70.33397376199991, 80.47654857000003],
              [-70.78823808499993, 80.57050202000005],
              [-70.80768795499995, 80.57086823100008],
              [-70.82445227799991, 80.56696198100008],
              [-70.8296199209999, 80.55601634300007],
              [-70.81908118399991, 80.54901764500005],
              [-70.77481035099993, 80.53843821800007],
              [-70.72191321499992, 80.53379954600007],
              [-70.68301347599993, 80.52574290600006],
              [-70.57900956899994, 80.48725006700005],
              [-70.5110164049999, 80.47349681200006],
              [-70.48021399599992, 80.46043528900003],
              [-70.45482337099992, 80.43638743700006],
              [-70.4460749989999, 80.43309153900003],
              [-70.4284968739999, 80.43101634300007],
              [-70.37035071499992, 80.41266510600008],
              [-70.43997148299991, 80.39752838700008],
              [-70.45913652299993, 80.38532135600008],
              [-70.4685359369999, 80.37193431200006],
              [-70.47126217399995, 80.35887278900003],
              [-70.4646296869999, 80.34874095300006],
              [-70.4460749989999, 80.34373607000003],
              [-70.4529109369999, 80.34373607000003],
              [-70.0158992179999, 80.28453196800007],
              [-69.95946204299992, 80.26182689000007],
              [-69.9973852199999, 80.24388255400004],
              [-70.0820613269999, 80.23057689000007],
              [-70.15908769399994, 80.19249095300006],
              [-70.21076412699995, 80.18817780200004],
              [-70.47923743399994, 80.19769928600005],
              [-70.74771074099993, 80.20722077000005],
              [-71.1003718739999, 80.18602122600004],
              [-71.3537898429999, 80.15228913000004],
              [-71.5007624989999, 80.12128327000005],
              [-71.73460852799991, 80.11786530200004],
              [-71.84072831899994, 80.13829173400006],
              [-71.8535457019999, 80.14293040600006],
              [-71.9053035149999, 80.17247142100007],
              [-71.93521074099993, 80.18146393400008],
              [-71.99787350199995, 80.19163646000004],
              [-72.16458085799991, 80.19452545800004],
              [-72.33283443899995, 80.22984446800007],
              [-72.37946529899995, 80.22776927300004],
              [-72.41982988199993, 80.21344635600008],
              [-72.02358964799993, 80.15086497600004],
              [-71.92943274599992, 80.12169017100007],
              [-71.8984675769999, 80.11786530200004],
              [-71.8984675769999, 80.11102936400005],
              [-72.10732988199993, 80.08592357000003],
              [-72.3918757799999, 80.09052155200004],
              [-72.3918757799999, 80.08368561400005],
              [-72.32363847599993, 80.08368561400005],
              [-72.3391414049999, 80.07404205900008],
              [-72.3469539049999, 80.07139720300006],
              [-72.35716712099992, 80.07005442900004],
              [-72.34203040299991, 80.06256745000007],
              [-72.16787675699993, 80.05646393400008],
              [-71.84231523299991, 80.06236399900007],
              [-71.71279863199993, 80.07408274900007],
              [-71.52432206899994, 80.06822337400007],
              [-71.32412675699993, 80.09178294500003],
              [-71.00666256399995, 80.12250397300005],
              [-70.6482234369999, 80.14288971600007],
              [-70.60716712099992, 80.12840403900003],
              [-70.5891820949999, 80.11827220300006],
              [-70.56362870999993, 80.11041901200008],
              [-70.53669186099995, 80.10533274900007],
              [-70.51431230399993, 80.10350169500003],
              [-70.5034480459999, 80.09837474200003],
              [-70.49697831899994, 80.07273997600004],
              [-70.48696855399993, 80.06260814000007],
              [-70.52928626199991, 80.04389069200005],
              [-70.63565019399994, 80.04026927300004],
              [-70.67878170499995, 80.01544830900008],
              [-70.6719457669999, 80.00861237200007],
              [-70.7053523429999, 79.99156321800007],
              [-71.0406794914999, 79.96694570500006],
              [-71.3760066399999, 79.94232819200005],
              [-71.4148249989999, 79.93138255400004],
              [-71.4487605459999, 79.91608307500007],
              [-71.45962480399993, 79.89874909100007],
              [-71.4287410149999, 79.88776276200008],
              [-71.17853756399995, 79.91636790600006],
              [-70.91161048099991, 79.89256419500003],
              [-70.93325761599993, 79.87999095300006],
              [-70.9895727199999, 79.85565827000005],
              [-71.00096594999991, 79.84068431200006],
              [-71.0188289049999, 79.82294342700004],
              [-71.08820553299995, 79.81561920800004],
              [-71.09032141799992, 79.80186595300006],
              [-71.14240475199995, 79.78949616100005],
              [-71.3825984369999, 79.76300690300008],
              [-71.48257402299993, 79.73777903900003],
              [-71.94050045499995, 79.70201243700006],
              [-72.01878821499992, 79.68467845300006],
              [-72.1270238919999, 79.68065013200004],
              [-72.23167883999992, 79.66258372600004],
              [-72.3918757799999, 79.68646881700005],
              [-72.62840735599991, 79.67902252800008],
              [-72.9201960929999, 79.70958079600007],
              [-72.95034745999993, 79.72162506700005],
              [-72.94741777299993, 79.74168528900003],
              [-72.9616999989999, 79.75254954600007],
              [-72.99868730399993, 79.76178620000007],
              [-73.0156550769999, 79.76837799700007],
              [-73.02782141799992, 79.77891673400006],
              [-73.0364070299999, 79.78990306200006],
              [-73.0466609369999, 79.79840729400007],
              [-73.0635066399999, 79.80186595300006],
              [-73.0635066399999, 79.80931224200003],
              [-72.94302324099993, 79.80845774900007],
              [-72.90583248599995, 79.81614817900004],
              [-72.9309789699999, 79.82359446800007],
              [-73.19090735599991, 79.82322825700004],
              [-73.38516191299993, 79.83860911700003],
              [-73.8132624989999, 79.82233307500007],
              [-73.86546790299991, 79.83726634300007],
              [-73.83682206899994, 79.84662506700005],
              [-73.80508378799993, 79.85028717700004],
              [-73.74193274599992, 79.85032786700003],
              [-73.7685847649999, 79.86497630400004],
              [-74.22777258999992, 79.89569733300004],
              [-74.3259578119999, 79.87445709800005],
              [-74.58541826099992, 79.86239248250004],
              [-74.84487870999993, 79.85032786700003],
              [-74.7920222649999, 79.84418366100005],
              [-74.76854407499991, 79.83763255400004],
              [-74.77033443899995, 79.82359446800007],
              [-74.6965632799999, 79.79844798400006],
              [-74.67015540299991, 79.79572174700007],
              [-74.35204016799992, 79.80931224200003],
              [-73.96814938049991, 79.78514232000003],
              [-73.5842585929999, 79.76097239800004],
              [-73.48184160099993, 79.76097239800004],
              [-73.38333085799991, 79.77562083500004],
              [-73.35147050699993, 79.76837799700007],
              [-73.3769832019999, 79.75682200700004],
              [-73.3862605459999, 79.75470612200007],
              [-73.38084876199991, 79.74693431200006],
              [-73.3650203119999, 79.73472728100006],
              [-73.35830644399994, 79.72740306200006],
              [-73.36001542899993, 79.71714915600006],
              [-73.33934485599991, 79.71031321800007],
              [-73.2900691399999, 79.70066966400003],
              [-73.2962133449999, 79.69330475500004],
              [-73.26675370999993, 79.68260325700004],
              [-73.20042883999992, 79.67064036700003],
              [-73.1733699209999, 79.65855540600006],
              [-73.16380774599992, 79.64463939000007],
              [-73.16193600199995, 79.62620677300004],
              [-73.1692602199999, 79.60862864800004],
              [-73.1870417959999, 79.59703196800007],
              [-73.14606686099995, 79.58567942900004],
              [-73.13239498599995, 79.58002350500004],
              [-73.12710527299993, 79.57432689000007],
              [-73.12531490799995, 79.56635163000004],
              [-73.12783769399994, 79.55919017100007],
              [-73.13548743399991, 79.55613841400003],
              [-73.1485082669999, 79.55292389500005],
              [-73.1738582019999, 79.53880442900004],
              [-73.18724524599992, 79.53563060100004],
              [-73.20360266799992, 79.53424713700008],
              [-73.31688391799992, 79.50914134300007],
              [-73.4629613919999, 79.49986399900007],
              [-73.5954890619999, 79.50792064000007],
              [-73.7337133449999, 79.49616120000007],
              [-73.79653886599993, 79.51109446800007],
              [-73.90469316299993, 79.55442942900004],
              [-73.96580969999991, 79.56358470300006],
              [-74.00259355399993, 79.54246653900003],
              [-73.9844050769999, 79.53143952000005],
              [-73.97150631399995, 79.51923248900005],
              [-73.95107988199993, 79.48749420800004],
              [-73.95954342399995, 79.47154368700006],
              [-73.9922175769999, 79.45868561400005],
              [-74.03026282499991, 79.45005931200006],
              [-74.2820124989999, 79.43992747600004],
              [-74.39240475199995, 79.45172760600008],
              [-74.69611568899995, 79.45001862200007],
              [-74.79067949099993, 79.47553131700005],
              [-74.91323808499993, 79.48875560100004],
              [-74.94790605399993, 79.50153229400007],
              [-74.9416804679999, 79.50254954600007],
              [-74.92804928299995, 79.50767649900007],
              [-74.95824133999992, 79.51532623900005],
              [-74.9963679679999, 79.51341380400004],
              [-75.03457597599993, 79.50523509300007],
              [-75.06460527299993, 79.49408600500004],
              [-75.0537410149999, 79.48570384300007],
              [-75.0151667959999, 79.47553131700005],
              [-75.01016191299993, 79.47105540600006],
              [-75.01016191299993, 79.46592845300006],
              [-75.00967363199993, 79.46165599200003],
              [-74.99404863199993, 79.45836009300007],
              [-74.9690242179999, 79.44688548400006],
              [-74.9226374989999, 79.43565501500007],
              [-74.90697180899991, 79.42918528900003],
              [-74.89093990799995, 79.42027415600006],
              [-74.88857988199993, 79.41563548400006],
              [-74.9063207669999, 79.40525950700004],
              [-74.96157792899993, 79.38060130400004],
              [-75.02798417899993, 79.37327708500004],
              [-75.51244055899991, 79.39618561400005],
              [-75.62246660099993, 79.41893138200004],
              [-75.64858964799993, 79.42991771000004],
              [-75.67495683499993, 79.43394603100006],
              [-75.70205644399994, 79.41954173400006],
              [-75.6946101549999, 79.41270579600007],
              [-75.7556453119999, 79.41404857000003],
              [-75.7871394519999, 79.41978587400007],
              [-75.8044734369999, 79.43260325700004],
              [-75.79873613199993, 79.43976471600007],
              [-75.80060787699995, 79.44529857000003],
              [-75.8079320949999, 79.44957103100006],
              [-75.81867428299995, 79.45307038000004],
              [-75.84243730399993, 79.45384349200003],
              [-75.91502844999991, 79.43077220300006],
              [-75.96125240799995, 79.42731354400007],
              [-76.00942949099993, 79.43577708500004],
              [-76.19522050699993, 79.49351634300007],
              [-76.62008622949992, 79.50773753450005],
              [-77.0449519519999, 79.52195872600004],
              [-77.06737219999991, 79.52610911700003],
              [-77.10968990799995, 79.54450104400007],
              [-77.13377844999991, 79.54865143400008],
              [-77.1496882799999, 79.54661692900004],
              [-77.16502844999991, 79.54075755400004],
              [-77.17935136599993, 79.53123607000003],
              [-77.19237219999991, 79.51825592700004],
              [-77.1885066399999, 79.50840892100007],
              [-77.16771399599992, 79.50079987200007],
              [-77.12710527299993, 79.49408600500004],
              [-76.94481360599991, 79.49408600500004],
              [-76.85407467399995, 79.48265208500004],
              [-76.75739498599995, 79.49408600500004],
              [-76.5769343739999, 79.47565338700008],
              [-76.4485570949999, 79.48285553600005],
              [-76.19359290299991, 79.47028229400007],
              [-76.1408992179999, 79.44688548400006],
              [-76.19017493399991, 79.43638743700006],
              [-76.20754960799991, 79.42991771000004],
              [-76.19367428299995, 79.42121002800008],
              [-76.17609615799995, 79.41282786700003],
              [-76.16486568899995, 79.40314362200007],
              [-76.15233313699991, 79.39500560100004],
              [-76.01056881399995, 79.37107982000003],
              [-75.90998287699995, 79.36595286700003],
              [-75.8801570299999, 79.35687897300005],
              [-75.91405188699991, 79.34703196800007],
              [-76.15453040299991, 79.33702220300006],
              [-76.23574785099993, 79.34845612200007],
              [-76.53524736249992, 79.35201650600007],
              [-76.8347468739999, 79.35557689000007],
              [-76.8616023429999, 79.35057200700004],
              [-76.87328040299991, 79.35004303600005],
              [-76.88646399599992, 79.35289134300007],
              [-76.9118953119999, 79.36229075700004],
              [-76.94863847599993, 79.36656321800007],
              [-77.08706620999993, 79.40607330900008],
              [-77.1035457019999, 79.41612376500007],
              [-77.10846920499995, 79.42462799700007],
              [-77.11156165299991, 79.43659088700008],
              [-77.11351477799991, 79.45648834800005],
              [-77.12450110599991, 79.46893952000005],
              [-77.14915930899991, 79.46759674700007],
              [-77.19009355399993, 79.45482005400004],
              [-77.24299068899995, 79.44981517100007],
              [-77.35293535099993, 79.46421946800007],
              [-77.40151933499993, 79.45307038000004],
              [-77.38076738199993, 79.43650950700004],
              [-77.31509355399993, 79.39891185100004],
              [-77.27912350199995, 79.38829173400006],
              [-77.26455644399994, 79.38023509300007],
              [-77.24006100199995, 79.36058177300004],
              [-77.2209773429999, 79.34996165600006],
              [-77.1780085929999, 79.34214915600006],
              [-77.1618953119999, 79.33018626500007],
              [-77.1836238269999, 79.33030833500004],
              [-77.22508704299992, 79.32477448100008],
              [-77.50580807199992, 79.33948395400006],
              [-77.78652910099993, 79.35419342700004],
              [-77.88239498599995, 79.37034739800004],
              [-77.92349199099993, 79.37099844000005],
              [-77.99075273299991, 79.36778392100007],
              [-78.05939693899995, 79.35687897300005],
              [-78.05939693899995, 79.35004303600005],
              [-77.8335261709999, 79.31769440300008],
              [-77.63320878799993, 79.32103099200003],
              [-77.36506100199995, 79.28135814000007],
              [-77.32575436099995, 79.26744212400007],
              [-77.3664851549999, 79.26019928600005],
              [-77.45661373599995, 79.25987376500007],
              [-77.49705969999991, 79.24762604400007],
              [-77.0891414049999, 79.26740143400008],
              [-76.7829890619999, 79.27916087400007],
              [-76.51211503799993, 79.26072825700004],
              [-76.3040258449999, 79.26349518400008],
              [-76.20559648299991, 79.27716705900008],
              [-76.15339107999995, 79.27513255400004],
              [-75.94815019399994, 79.23716868700006],
              [-75.64419511599993, 79.23509349150007],
              [-75.34024003799993, 79.23301829600007],
              [-75.05174719999991, 79.23106517100007],
              [-74.79849199099993, 79.24384186400005],
              [-74.46873938699991, 79.22715892100007],
              [-74.49250240799995, 79.21202220300006],
              [-74.5935359369999, 79.19456614800004],
              [-74.78335527299993, 79.19318268400008],
              [-74.8249812489999, 79.17930735900006],
              [-74.77981523299991, 79.15997955900008],
              [-74.65982011599993, 79.16547272300005],
              [-74.61213131399995, 79.15135325700004],
              [-74.62547766799992, 79.14716217700004],
              [-74.63923092399995, 79.14500560100004],
              [-74.66738847599993, 79.14520905200004],
              [-74.6545710929999, 79.13434479400007],
              [-74.63137773299991, 79.12791575700004],
              [-74.56436113199993, 79.12103913000004],
              [-74.5527644519999, 79.11347077000005],
              [-74.54214433499993, 79.10386790600006],
              [-74.52489173099991, 79.09503815300008],
              [-74.4785457019999, 79.08543528900003],
              [-74.45392818899995, 79.07684967700004],
              [-74.44082597599993, 79.06268952000005],
              [-74.44725501199991, 79.04987213700008],
              [-74.46760006399995, 79.04136790600006],
              [-74.49233964799993, 79.03672923400006],
              [-74.79263261599993, 79.04795970300006],
              [-75.08698482999995, 79.03184642100007],
              [-75.5051570299999, 79.07481517100007],
              [-75.7571508449999, 79.08421458500004],
              [-75.7634578119999, 79.08653392100007],
              [-75.76724199099993, 79.09629954600007],
              [-75.77635657499991, 79.10142649900007],
              [-75.78742428299995, 79.10333893400008],
              [-75.8938289049999, 79.10362376500007],
              [-75.85968990799995, 79.11790599200003],
              [-75.86660722599993, 79.12042877800008],
              [-75.8796687489999, 79.12803782800006],
              [-75.88638261599993, 79.13092682500007],
              [-75.87938391799992, 79.13658274900007],
              [-75.87124589799993, 79.14085521000004],
              [-75.86229407499991, 79.14378489800004],
              [-75.8528539699999, 79.14520905200004],
              [-75.8550105459999, 79.15294017100007],
              [-75.85667883999992, 79.15452708500004],
              [-75.85968990799995, 79.15135325700004],
              [-75.89362545499995, 79.16966380400004],
              [-76.08877519399994, 79.20469798400006],
              [-76.34459387899994, 79.20359935100007],
              [-76.60041256399995, 79.20250071800007],
              [-76.9831843739999, 79.19078196800007],
              [-77.20702063699991, 79.19977448100008],
              [-77.69471188049991, 79.19759756050007],
              [-78.1824031239999, 79.19542064000007],
              [-78.2248835929999, 79.18805573100008],
              [-78.25739498599995, 79.17194245000007],
              [-78.2126765619999, 79.15989817900004],
              [-78.1602270169999, 79.16282786700003],
              [-78.05939693899995, 79.17930735900006],
              [-77.70677649633329, 79.16924334000005],
              [-77.35415605366661, 79.15917932100005],
              [-77.00153561099995, 79.14911530200004],
              [-76.7417292959999, 79.14964427300004],
              [-76.49465898299991, 79.13450755400004],
              [-76.13345292899993, 79.12413157800006],
              [-76.13662675699993, 79.12022532800006],
              [-76.13817298099991, 79.11705149900007],
              [-76.13914954299992, 79.11399974200003],
              [-76.1408992179999, 79.11045970300006],
              [-76.09951738199993, 79.10301341400003],
              [-76.08560136599993, 79.10362376500007],
              [-76.1147761709999, 79.08490631700005],
              [-76.16869055899991, 79.07733795800004],
              [-76.3884578119999, 79.07599518400008],
              [-76.70645097599993, 79.09068431200006],
              [-76.96548417899993, 79.07245514500005],
              [-77.15908769399994, 79.07123444200005],
              [-77.53392493399991, 79.02387116100005],
              [-77.6140437489999, 79.03424713700008],
              [-77.6963191399999, 79.03534577000005],
              [-77.72052975199995, 79.04246653900003],
              [-77.7688289049999, 79.06476471600007],
              [-77.79190019399994, 79.06944407800006],
              [-78.09618079299992, 79.08482493700006],
              [-78.33169511599993, 79.08482493700006],
              [-78.61359615799992, 79.07713450750006],
              [-78.89549719999991, 79.06944407800006],
              [-78.86636308499993, 79.06175364800004],
              [-78.4258520169999, 79.05906810100004],
              [-78.1704605784999, 79.05748118700004],
              [-77.9150691399999, 79.05589427300004],
              [-77.76593990799995, 79.03648509300007],
              [-77.73224850199995, 79.02472565300008],
              [-77.7031550769999, 79.00804271000004],
              [-77.73672441299993, 79.00519440300008],
              [-77.9563289049999, 78.95958079600007],
              [-77.97712154899995, 78.94135163000004],
              [-78.14134680899991, 78.87767161700003],
              [-78.21646074099993, 78.82994212400007],
              [-78.28123938699991, 78.80662669500003],
              [-78.29898027299993, 78.79576243700006],
              [-78.27114824099993, 78.77423737200007],
              [-78.2268367179999, 78.77220286700003],
              [-78.1819148429999, 78.78290436400005],
              [-78.15217037699995, 78.79918040600006],
              [-78.12596594999991, 78.82123444200005],
              [-78.06265214799993, 78.85777415600006],
              [-77.82144120999993, 78.94586823100008],
              [-77.71800696499992, 78.96971263200004],
              [-77.22541256399992, 79.00322093300005],
              [-76.73281816299993, 79.03672923400006],
              [-76.25678463449992, 79.00936513900007],
              [-75.78075110599991, 78.98200104400007],
              [-75.72191321499992, 78.96702708500004],
              [-75.74299068899995, 78.96238841400003],
              [-75.79824785099993, 78.93170807500007],
              [-75.82762610599991, 78.92609284100007],
              [-76.26838131399995, 78.90464915600006],
              [-76.4411921869999, 78.87128327000005],
              [-76.45962480399993, 78.86029694200005],
              [-76.45921790299991, 78.84935130400004],
              [-76.43447831899994, 78.84723541900007],
              [-76.3940730459999, 78.85040924700007],
              [-76.25625566299993, 78.87970612200007],
              [-75.8459773429999, 78.88047923400006],
              [-75.74429277299993, 78.89716217700004],
              [-75.55215410099993, 78.88719310100004],
              [-75.30492102799991, 78.88462962400007],
              [-75.07502193899995, 78.86265696800007],
              [-74.9150691399999, 78.85435618700006],
              [-74.8789770169999, 78.83673737200007],
              [-74.88174394399994, 78.83274974200003],
              [-74.88646399599992, 78.82249583500004],
              [-74.81411699099993, 78.83421458500004],
              [-74.77375240799995, 78.83482493700006],
              [-74.75609290299991, 78.81932200700004],
              [-74.7776179679999, 78.80548737200007],
              [-74.87710527299993, 78.79478587400007],
              [-74.9063207669999, 78.78831614800004],
              [-74.87189693899995, 78.78327057500007],
              [-74.78620357999995, 78.78270091400003],
              [-74.7629695299999, 78.76780833500004],
              [-74.81330318899995, 78.75006745000007],
              [-74.83185787699995, 78.74730052300004],
              [-74.81078040299991, 78.73484935100004],
              [-74.7471003899999, 78.71539948100008],
              [-74.7219539049999, 78.71263255400004],
              [-74.75121008999992, 78.70026276200008],
              [-74.81419837099992, 78.70286692900004],
              [-74.84487870999993, 78.69896067900004],
              [-74.86587480399993, 78.68756745000007],
              [-74.86628170499995, 78.67711009300007],
              [-74.85277258999992, 78.66734446800007],
              [-74.83185787699995, 78.65794505400004],
              [-74.84137936099995, 78.65228913000004],
              [-74.85147050699993, 78.64805735900006],
              [-74.86196855399993, 78.64537181200006],
              [-74.8728328119999, 78.64427317900004],
              [-74.84231523299991, 78.63267649900007],
              [-74.80858313699991, 78.62665436400005],
              [-74.77395585799991, 78.62571849200003],
              [-74.74103756399995, 78.62958405200004],
              [-74.71605383999992, 78.62767161700003],
              [-74.68545488199993, 78.61705149900007],
              [-74.6325984369999, 78.58966705900008],
              [-74.80231686099995, 78.58860911700003],
              [-75.00877844999991, 78.53782786700003],
              [-75.03091386599993, 78.53510163000004],
              [-75.18464107999995, 78.54157135600008],
              [-75.39810136599993, 78.51561107000003],
              [-75.76557369666659, 78.52623118700005],
              [-76.13304602733325, 78.53685130400005],
              [-76.50051835799991, 78.54747142100007],
              [-76.5835261709999, 78.53306712400007],
              [-76.6357722649999, 78.53184642100007],
              [-76.66161048099991, 78.52826569200005],
              [-76.6875707669999, 78.51972077000005],
              [-76.69082597599993, 78.51304759300007],
              [-76.6758520169999, 78.50865306200006],
              [-76.28176835799991, 78.51951732000003],
              [-76.15021725199995, 78.50694407800006],
              [-76.12661699099993, 78.50096263200004],
              [-76.11465410099993, 78.49119700700004],
              [-76.1072078119999, 78.47972239800004],
              [-76.0974421869999, 78.47020091400003],
              [-76.07860266799992, 78.46617259300007],
              [-75.59314938049991, 78.42082347200005],
              [-75.1076960929999, 78.37547435100004],
              [-75.0871882799999, 78.36387767100007],
              [-75.07249915299991, 78.35089752800008],
              [-75.0559382799999, 78.34031810100004],
              [-75.02981523299991, 78.33641185100004],
              [-75.07079016799992, 78.31492747600004],
              [-75.11978105399993, 78.30491771000004],
              [-75.2168269519999, 78.30231354400007],
              [-75.3145238919999, 78.31098053600005],
              [-75.36986243399991, 78.30731842700004],
              [-75.41067460799991, 78.26788971600007],
              [-75.44839433499993, 78.24738190300008],
              [-75.5171199209999, 78.21918366100005],
              [-75.57095292899993, 78.20636627800008],
              [-75.62621008999992, 78.19981517100007],
              [-75.90994218649993, 78.22343577650005],
              [-76.19367428299995, 78.24705638200004],
              [-76.3594457669999, 78.23179759300007],
              [-76.6047664049999, 78.25519440300008],
              [-76.6343074209999, 78.25389232000003],
              [-76.6892390619999, 78.24237702000005],
              [-76.88833574099993, 78.22333405200004],
              [-76.91543535099993, 78.20677317900004],
              [-76.8757624989999, 78.19175853100006],
              [-76.82347571499992, 78.18577708500004],
              [-76.72345943899995, 78.18561432500007],
              [-76.71401933499993, 78.18378327000005],
              [-76.69774329299992, 78.17487213700008],
              [-76.68895423099991, 78.17198314000007],
              [-76.6482234369999, 78.17255280200004],
              [-76.61184648299991, 78.16453685100004],
              [-76.29458574099993, 78.15277741100005],
              [-76.19098873599995, 78.13300202000005],
              [-75.92973792199993, 78.13515859550006],
              [-75.66848710799991, 78.13731517100007],
              [-75.61758378799993, 78.13096751500007],
              [-75.58193925699993, 78.11302317900004],
              [-75.58836829299992, 78.09528229400007],
              [-75.68838456899994, 78.05589427300004],
              [-75.68163001199991, 78.04844798400006],
              [-75.8391820949999, 78.00067780200004],
              [-75.90135657499991, 77.96788157800006],
              [-75.93399003799993, 77.95860423400006],
              [-75.9682917959999, 77.96592845300006],
              [-75.9721980459999, 77.97894928600005],
              [-75.98916581899994, 77.98456452000005],
              [-76.09817460799991, 77.99628327000005],
              [-76.12661699099993, 78.00751373900005],
              [-76.17853756399995, 78.01829661700003],
              [-76.23241126199991, 78.02110423400006],
              [-76.4638972649999, 77.99095286700003],
              [-76.4773249989999, 77.98468659100007],
              [-76.50055904899995, 77.96275462400007],
              [-76.53897050699993, 77.94566478100006],
              [-76.74624589799993, 77.93414948100008],
              [-76.88068600199995, 77.90501536700003],
              [-77.0632624989999, 77.91486237200007],
              [-77.15379798099991, 77.94867584800005],
              [-77.51716061099992, 77.94570547050006],
              [-77.88052324099993, 77.94273509300007],
              [-78.2165828119999, 78.00254954600007],
              [-78.27171790299991, 77.98704661700003],
              [-78.27171790299991, 77.98021067900004],
              [-78.22476152299993, 77.98130931200006],
              [-78.2019343739999, 77.97752513200004],
              [-78.1829320949999, 77.96592845300006],
              [-78.37881425699993, 77.93650950700004],
              [-78.40802975199995, 77.92670319200005],
              [-78.4299617179999, 77.91132233300004],
              [-78.4128718739999, 77.90131256700005],
              [-78.36107337099992, 77.89081452000005],
              [-78.34593665299991, 77.88340892100007],
              [-78.33389238199993, 77.87571849200003],
              [-78.31989498599995, 77.87046946800007],
              [-78.29898027299993, 77.87034739800004],
              [-78.30581620999993, 77.87034739800004],
              [-78.2813207669999, 77.86412181200006],
              [-78.15676835799991, 77.86424388200004],
              [-78.13857988199993, 77.85862864800004],
              [-78.14134680899991, 77.84239329600007],
              [-77.98070227799991, 77.81671784100007],
              [-77.9494929679999, 77.79523346600007],
              [-77.96263587099992, 77.79523346600007],
              [-77.95824133999992, 77.78611888200004],
              [-77.94212805899991, 77.76048411700003],
              [-77.9629207019999, 77.75495026200008],
              [-77.9700007799999, 77.75425853100006],
              [-77.96263587099992, 77.75425853100006],
              [-78.0078832669999, 77.74632396000004],
              [-78.05199133999992, 77.73314036700003],
              [-78.03408769399994, 77.73045482000003],
              [-78.00942949099993, 77.72325267100007],
              [-77.98997962099992, 77.71336497600004],
              [-77.98745683499993, 77.70246002800008],
              [-78.0080867179999, 77.69139232000003],
              [-78.05809485599991, 77.68907298400006],
              [-78.0798640619999, 77.67853424700007],
              [-78.02635657499991, 77.66840241100005],
              [-77.91274980399993, 77.67503489800004],
              [-77.8601374989999, 77.65806712400007],
              [-77.85610917899993, 77.65501536700003],
              [-77.8542781239999, 77.65196360900006],
              [-77.85399329299992, 77.64069245000007],
              [-77.84740149599992, 77.63239166900007],
              [-77.8320613269999, 77.62950267100007],
              [-77.75641842399995, 77.62730540600006],
              [-77.73664303299995, 77.62116120000007],
              [-77.71621660099993, 77.60960521000004],
              [-77.73680579299992, 77.60081614800004],
              [-77.90859941299993, 77.56867096600007],
              [-77.9553523429999, 77.56549713700008],
              [-77.97647050699993, 77.56024811400005],
              [-77.98436438699991, 77.54820384300007],
              [-77.9783015619999, 77.54197825700004],
              [-77.94212805899991, 77.51341380400004],
              [-78.01846269399994, 77.47199127800008],
              [-78.1973363919999, 77.45246002800008],
              [-78.27855383999992, 77.43150462400007],
              [-78.2307429679999, 77.40416087400007],
              [-78.25210527299993, 77.38707103100006],
              [-78.2891332669999, 77.37754954600007],
              [-78.50096594999991, 77.36517975500004],
              [-78.68968665299991, 77.31907786700003],
              [-78.76577714799993, 77.31089915600006],
              [-78.8408503899999, 77.31541575700004],
              [-78.75210527299993, 77.35919830900008],
              [-78.72419186099995, 77.37689850500004],
              [-78.74665279899995, 77.38243235900006],
              [-78.7710261709999, 77.38495514500005],
              [-78.81981360599991, 77.38365306200006],
              [-78.8440242179999, 77.37828196800007],
              [-78.8935847649999, 77.36029694200005],
              [-78.92926998599995, 77.35264720300006],
              [-78.97736568899995, 77.32538483300004],
              [-79.00247148299991, 77.31688060100004],
              [-79.05467688699991, 77.31207916900007],
              [-79.13320878799993, 77.29132721600007],
              [-79.38939368399994, 77.30648427950007],
              [-79.64557857999995, 77.32164134300007],
              [-79.84414628799993, 77.31126536700003],
              [-79.94627844999991, 77.28306712400007],
              [-79.97122148299991, 77.28062571800007],
              [-80.19725501199991, 77.28746165600006],
              [-80.29987545499995, 77.30174388200004],
              [-80.3913874989999, 77.29515208500004],
              [-80.46434485599991, 77.30646393400008],
              [-80.55142167899993, 77.30980052300004],
              [-80.63833574099993, 77.32591380400004],
              [-80.77985592399995, 77.33592357000003],
              [-80.97451738199993, 77.38043854400007],
              [-81.0129695299999, 77.38365306200006],
              [-81.01821855399993, 77.38646067900004],
              [-81.02969316299993, 77.39964427300004],
              [-81.03994706899994, 77.40416087400007],
              [-81.03311113199993, 77.40416087400007],
              [-81.2156469389999, 77.41917552300004],
              [-81.29686438699991, 77.43650950700004],
              [-81.30752519399994, 77.44261302300004],
              [-81.32795162699995, 77.45880768400008],
              [-81.36115475199995, 77.47654857000003],
              [-81.39899654899995, 77.48936595300006],
              [-81.43814042899993, 77.49713776200008],
              [-81.4973445299999, 77.50189850500004],
              [-81.54165605399993, 77.51129791900007],
              [-81.5647273429999, 77.51341380400004],
              [-81.58226477799991, 77.51695384300007],
              [-81.58568274599992, 77.52525462400007],
              [-81.57933508999992, 77.53440989800004],
              [-81.56753495999993, 77.54075755400004],
              [-81.58877519399994, 77.55442942900004],
              [-81.67056230399993, 77.56867096600007],
              [-81.67056230399993, 77.57542552300004],
              [-81.6389460929999, 77.57489655200004],
              [-81.62360592399995, 77.57664622600004],
              [-81.6091609369999, 77.58234284100007],
              [-81.64045162699995, 77.59837474200003],
              [-81.82477779899995, 77.62494538000004],
              [-81.84740149599992, 77.63633860900006],
              [-81.83446204299992, 77.65806712400007],
              [-81.8555395169999, 77.67377350500004],
              [-81.8860164049999, 77.68561432500007],
              [-81.91641191299993, 77.69049713700008],
              [-81.93748938699991, 77.68537018400008],
              [-81.9346003899999, 77.67706940300008],
              [-81.93740800699993, 77.67401764500005],
              [-81.9421687489999, 77.67137278900003],
              [-81.94489498599995, 77.66425202000005],
              [-81.94603430899991, 77.65428294500003],
              [-81.94375566299993, 77.65338776200008],
              [-81.92617753799993, 77.62986888200004],
              [-81.9109594389999, 77.61790599200003],
              [-81.8938695949999, 77.60895416900007],
              [-81.87661699099993, 77.60346100500004],
              [-81.8040258449999, 77.59727610900006],
              [-81.78384355399993, 77.58576080900008],
              [-81.7732234369999, 77.57709381700005],
              [-81.74270585799991, 77.55967845300006],
              [-81.6929011709999, 77.53953685100004],
              [-81.67300370999993, 77.52366771000004],
              [-81.67438717399995, 77.50511302300004],
              [-81.70474199099993, 77.48334381700005],
              [-81.73098710799991, 77.46934642100007],
              [-81.74185136599993, 77.46002838700008],
              [-81.74632727799991, 77.44916413000004],
              [-81.73721269399994, 77.43480052300004],
              [-81.71589107999995, 77.42792389500005],
              [-81.67398027299993, 77.42157623900005],
              [-81.5796199209999, 77.39293040600006],
              [-81.4800105459999, 77.37592194200005],
              [-81.2070613269999, 77.37413157800006],
              [-81.18106035099993, 77.36347077000005],
              [-81.1709285149999, 77.33250560100004],
              [-81.19973710799991, 77.32335032800006],
              [-81.52430172399991, 77.30668773000005],
              [-81.84886633999992, 77.29002513200004],
              [-82.15192623599995, 77.31590403900003],
              [-82.19815019399994, 77.30174388200004],
              [-82.02004960799991, 77.26703522300005],
              [-81.9411921869999, 77.26129791900007],
              [-81.91763261599993, 77.25336334800005],
              [-81.9063207669999, 77.24388255400004],
              [-81.89574133999992, 77.22569407800006],
              [-81.8828425769999, 77.21922435100004],
              [-81.89509029899995, 77.20941803600005],
              [-81.90094967399995, 77.20677317900004],
              [-81.9101863269999, 77.20555247600004],
              [-81.89183508999992, 77.18272532800006],
              [-81.8576960929999, 77.17047760600008],
              [-81.81908118399991, 77.16551341400003],
              [-81.7527156239999, 77.16657135600008],
              [-81.6204320949999, 77.20176829600007],
              [-81.52586829299992, 77.20872630400004],
              [-81.47817949099993, 77.22288646000004],
              [-81.10301673099991, 77.28746165600006],
              [-80.73932857999992, 77.25899892800007],
              [-80.37564042899993, 77.23053620000007],
              [-80.3274226549999, 77.21922435100004],
              [-80.31875566299993, 77.21812571800007],
              [-80.14541581899994, 77.21112702000005],
              [-80.11514238199993, 77.20555247600004],
              [-80.1457820299999, 77.18878815300008],
              [-80.23932857999995, 77.16771067900004],
              [-80.2790828119999, 77.12437571800007],
              [-80.37547766799992, 77.10069407800006],
              [-80.4099421869999, 77.08270905200004],
              [-80.37246660099993, 77.07469310100004],
              [-80.3213191399999, 77.08124420800004],
              [-80.0263972649999, 77.18903229400007],
              [-79.7178035149999, 77.24339427300004],
              [-79.4324031239999, 77.23859284100007],
              [-79.3435359369999, 77.21885814000007],
              [-79.24852454299992, 77.21592845300006],
              [-79.2024226549999, 77.20734284100007],
              [-79.1045222649999, 77.17479075700004],
              [-79.05540930899991, 77.16791413000004],
              [-79.03262285099993, 77.15717194200005],
              [-79.03958085799991, 77.14960358300004],
              [-79.04759680899991, 77.14366282800006],
              [-79.05646725199995, 77.13951243700006],
              [-79.0661921869999, 77.13731517100007],
              [-79.0178523429999, 77.11815013200004],
              [-79.00649980399993, 77.10472239800004],
              [-79.02717037699995, 77.09064362200007],
              [-79.09406490799995, 77.07518138200004],
              [-79.3467097649999, 76.97923411700003],
              [-79.3796687489999, 76.95758698100008],
              [-79.38727779899995, 76.95628489800004],
              [-79.39289303299995, 76.95286692900004],
              [-79.39509029899995, 76.94175853100006],
              [-79.38931230399993, 76.93036530200004],
              [-79.37564042899993, 76.92564524900007],
              [-79.12051347599993, 76.93024323100008],
              [-79.10098222599993, 76.92633698100008],
              [-79.0818171869999, 76.92523834800005],
              [-79.01895097599993, 76.93866608300004],
              [-78.98098710799991, 76.94049713700008],
              [-78.90306555899991, 76.93419017100007],
              [-78.86750240799995, 76.92442454600007],
              [-78.87376868399991, 76.91791413000004],
              [-78.88166256399995, 76.91124095300006],
              [-78.89037024599992, 76.90599192900004],
              [-78.90648352799991, 76.90131256700005],
              [-78.90794837099992, 76.89524974200003],
              [-78.90737870999993, 76.88837311400005],
              [-78.90908769399994, 76.88340892100007],
              [-78.94163977799991, 76.86701080900008],
              [-78.95596269399994, 76.85712311400005],
              [-78.9643855459999, 76.84239329600007],
              [-78.72036699099993, 76.82758209800005],
              [-78.69627844999991, 76.84239329600007],
              [-78.7119441399999, 76.86229075700004],
              [-78.72419186099995, 76.88340892100007],
              [-78.62551835799991, 76.88340892100007],
              [-78.59365800699993, 76.88890208500004],
              [-78.56712805899991, 76.89732493700006],
              [-78.56484941299993, 76.90326569200005],
              [-78.57022050699993, 76.91266510600008],
              [-78.5664770169999, 76.93183014500005],
              [-78.5342097649999, 76.95396556200006],
              [-78.43020585799991, 76.96177806200006],
              [-78.38841712099992, 76.97284577000005],
              [-78.39484615799995, 76.97532786700003],
              [-78.40916907499991, 76.98338450700004],
              [-78.41567949099993, 76.98582591400003],
              [-78.40029863199993, 76.99803294500003],
              [-78.38442949099993, 77.00409577000005],
              [-78.36709550699993, 77.00608958500004],
              [-78.34740149599992, 77.00633372600004],
              [-78.33307857999995, 77.01264069200005],
              [-78.13174394399994, 77.02525462400007],
              [-78.0908503899999, 77.02281321800007],
              [-77.91543535099993, 76.96592845300006],
              [-77.88923092399995, 76.94977448100008],
              [-77.88919023299991, 76.93736399900007],
              [-77.89895585799991, 76.92735423400006],
              [-77.9023738269999, 76.91819896000004],
              [-77.89647376199991, 76.91209544500003],
              [-77.85228430899991, 76.89948151200008],
              [-77.8335261709999, 76.89085521000004],
              [-77.89492753799993, 76.86912669500003],
              [-77.8723445299999, 76.85980866100005],
              [-77.79873613199993, 76.84922923400006],
              [-77.71621660099993, 76.82196686400005],
              [-77.75381425699993, 76.80931224200003],
              [-77.77200273299991, 76.79987213700008],
              [-77.78506425699993, 76.78721751500007],
              [-77.78978430899991, 76.77631256700005],
              [-77.78799394399994, 76.76862213700008],
              [-77.78302975199995, 76.76011790600006],
              [-77.77822831899994, 76.74689362200007],
              [-77.76650956899994, 76.73423899900007],
              [-77.7663874989999, 76.72789134300007],
              [-77.78164628799993, 76.72516510600008],
              [-77.78888912699995, 76.72300853100006],
              [-77.79857337099992, 76.71775950700004],
              [-77.80744381399995, 76.71124909100007],
              [-77.81240800699993, 76.70530833500004],
              [-77.8127742179999, 76.68809642100007],
              [-77.8020320299999, 76.67796458500004],
              [-77.7707820299999, 76.66429271000004],
              [-77.82778886599993, 76.64097728100006],
              [-77.88792883999992, 76.63373444200005],
              [-78.01260331899994, 76.63703034100007],
              [-78.03229732999995, 76.63340892100007],
              [-78.08836829299992, 76.61456940300008],
              [-78.10350501199991, 76.60594310100004],
              [-78.12271074099993, 76.59125397300005],
              [-78.1682429679999, 76.57526276200008],
              [-78.1897273429999, 76.56126536700003],
              [-78.15925045499995, 76.55003489800004],
              [-78.14712480399993, 76.54124583500004],
              [-78.14134680899991, 76.52716705900008],
              [-78.35562089799993, 76.49839915600006],
              [-78.38052324099993, 76.48619212400007],
              [-78.3672582669999, 76.46568431200006],
              [-78.4997859369999, 76.45933665600006],
              [-78.56460527299993, 76.47044505400004],
              [-78.62173417899993, 76.49982330900008],
              [-78.6030574209999, 76.50767649900007],
              [-78.59439042899993, 76.51312897300005],
              [-78.58641516799992, 76.52024974200003],
              [-78.59414628799993, 76.52623118700006],
              [-78.60187740799995, 76.53461334800005],
              [-78.60887610599991, 76.54441966400003],
              [-78.6142878899999, 76.55503978100006],
              [-78.5664770169999, 76.56126536700003],
              [-78.5664770169999, 76.56810130400004],
              [-78.68317623599995, 76.56810130400004],
              [-78.7431941399999, 76.57689036700003],
              [-78.77424068899995, 76.57733795800004],
              [-78.79987545499995, 76.56810130400004],
              [-78.79246985599991, 76.56810130400004],
              [-78.81314042899993, 76.55243561400005],
              [-78.85602779899995, 76.52948639500005],
              [-78.8750300769999, 76.51410553600005],
              [-78.91869055899991, 76.46556224200003],
              [-78.93643144399994, 76.45140208500004],
              [-78.97012285099993, 76.43492259300007],
              [-79.0090632799999, 76.42442454600007],
              [-79.1494441399999, 76.41547272300005],
              [-79.1692195299999, 76.41046784100007],
              [-79.18276933499993, 76.40399811400005],
              [-79.19489498599995, 76.39549388200004],
              [-79.19583085799991, 76.38926829600007],
              [-79.1760554679999, 76.38996002800008],
              [-79.1760554679999, 76.38316478100006],
              [-79.2073054679999, 76.37779368700006],
              [-79.24494381399995, 76.36192454600007],
              [-79.2671199209999, 76.34149811400005],
              [-79.2517390619999, 76.32233307500007],
              [-79.2932429679999, 76.30235423400006],
              [-79.3477270169999, 76.29686107000003],
              [-79.5012914699999, 76.31769440300008],
              [-79.55028235599991, 76.31696198100008],
              [-79.82327226499993, 76.27242666200007],
              [-80.09626217399995, 76.22789134300007],
              [-80.18997148299991, 76.24669017100007],
              [-80.23884029899995, 76.24420807500007],
              [-80.3791804679999, 76.21869538000004],
              [-80.42332923099991, 76.20160553600005],
              [-80.44318600199995, 76.19773997600004],
              [-80.58747311099995, 76.20087311400005],
              [-80.60855058499993, 76.19818756700005],
              [-80.62401282499991, 76.18988678600005],
              [-80.64907792899993, 76.16840241100005],
              [-80.66722571499992, 76.16404857000003],
              [-80.79019120999993, 76.16404857000003],
              [-80.8542781239999, 76.17283763200004],
              [-80.88784745999993, 76.17304108300004],
              [-80.93936113199993, 76.14622630400004],
              [-81.07249915299991, 76.12913646000004],
              [-81.0828344389999, 76.13739655200004],
              [-81.08023027299993, 76.15062083500004],
              [-81.06729081899994, 76.16404857000003],
              [-81.04246985599991, 76.17597077000005],
              [-80.9580378899999, 76.19074127800008],
              [-80.9580378899999, 76.19818756700005],
              [-80.99136308499993, 76.20416901200008],
              [-81.06497148299991, 76.20795319200005],
              [-81.09520423099991, 76.21861399900007],
              [-81.0520727199999, 76.23008860900006],
              [-81.04312089799993, 76.23582591400003],
              [-81.04385331899994, 76.24286530200004],
              [-81.0456843739999, 76.25079987200007],
              [-81.03994706899994, 76.25962962400007],
              [-81.02692623599995, 76.26483795800004],
              [-80.9597468739999, 76.27574290600006],
              [-80.95059160099993, 76.28160228100006],
              [-80.89321855399993, 76.33551666900007],
              [-80.8791804679999, 76.34153880400004],
              [-80.8552546869999, 76.34605540600006],
              [-80.82526607999995, 76.35736725500004],
              [-80.79662024599992, 76.37193431200006],
              [-80.77643795499995, 76.38654205900008],
              [-80.7724910149999, 76.41998932500007],
              [-80.82510331899994, 76.43638743700006],
              [-80.8945613269999, 76.44676341400003],
              [-80.9409480459999, 76.46226634300007],
              [-80.9685359369999, 76.48021067900004],
              [-80.99779212099992, 76.48607005400004],
              [-81.0281062489999, 76.48814524900007],
              [-81.0964656239999, 76.50206126500007],
              [-81.2180883449999, 76.49982330900008],
              [-81.2087703119999, 76.50999583500004],
              [-81.17715410099993, 76.53339264500005],
              [-81.20685787699995, 76.56358470300006],
              [-81.24771074099993, 76.55064524900007],
              [-81.28921464799993, 76.52232493700006],
              [-81.3211156889999, 76.50665924700007],
              [-81.3476863269999, 76.50230540600006],
              [-81.40233313699991, 76.48309967700004],
              [-81.5381160149999, 76.47300853100006],
              [-81.93529212099992, 76.49498118700006],
              [-82.0556941399999, 76.51646556200006],
              [-82.0821020169999, 76.52716705900008],
              [-82.0444636709999, 76.54783763200004],
              [-82.0132136709999, 76.57493724200003],
              [-82.00348873599995, 76.57880280200004],
              [-81.9922582669999, 76.58026764500005],
              [-81.9863988919999, 76.58429596600007],
              [-81.99270585799991, 76.59605540600006],
              [-82.06159420499995, 76.61652252800008],
              [-82.02041581899994, 76.61933014500005],
              [-81.9033503899999, 76.65070221600007],
              [-81.85521399599992, 76.65167877800008],
              [-81.83112545499995, 76.65586985900006],
              [-81.81118730399993, 76.66771067900004],
              [-81.80378170499995, 76.67064036700003],
              [-81.79348710799991, 76.67186107000003],
              [-81.78441321499992, 76.67442454600007],
              [-81.78042558499993, 76.68109772300005],
              [-81.7832332019999, 76.68846263200004],
              [-81.79010982999995, 76.69151439000007],
              [-81.79857337099992, 76.69151439000007],
              [-81.89053300699993, 76.66889069200005],
              [-82.17788652299993, 76.63011302300004],
              [-82.27627519399994, 76.63487376500007],
              [-82.32534745999993, 76.64402903900003],
              [-82.44456946499992, 76.69163646000004],
              [-82.45929928299995, 76.70152415600006],
              [-82.4929906889999, 76.73265208500004],
              [-82.50723222599993, 76.74009837400007],
              [-82.5547175769999, 76.75645579600007],
              [-82.56582597599993, 76.76451243700006],
              [-82.57656816299993, 76.77476634300007],
              [-82.58934485599991, 76.78343333500004],
              [-82.6482234369999, 76.79503001500007],
              [-82.68871008999992, 76.81041087400007],
              [-82.7297664049999, 76.82099030200004],
              [-82.7735082669999, 76.81456126500007],
              [-82.7403051419999, 76.80882396000004],
              [-82.69863847599993, 76.79657623900005],
              [-82.66030839799993, 76.77960846600007],
              [-82.6369929679999, 76.75987376500007],
              [-82.6506648429999, 76.75311920800004],
              [-82.62677975199995, 76.74388255400004],
              [-82.57795162699995, 76.73517487200007],
              [-82.55443274599992, 76.72516510600008],
              [-82.56126868399991, 76.69261302300004],
              [-82.51187089799993, 76.66229889500005],
              [-82.38182532499991, 76.61961497600004],
              [-82.2956843739999, 76.61461009300007],
              [-82.0821020169999, 76.56810130400004],
              [-82.20946204299992, 76.54218170800004],
              [-82.22549394399994, 76.52024974200003],
              [-82.21145585799991, 76.50128815300008],
              [-82.13304602799991, 76.45514557500007],
              [-82.13817298099991, 76.43870677300004],
              [-82.17284094999991, 76.42462799700007],
              [-82.2820124989999, 76.40049876500007],
              [-82.5414322579999, 76.39522939650007],
              [-82.8008520169999, 76.38996002800008],
              [-82.8181453119999, 76.39618561400005],
              [-82.85277258999992, 76.41364166900007],
              [-83.00104732999995, 76.43626536700003],
              [-83.10252844999991, 76.46568431200006],
              [-83.09622148299991, 76.47776927300004],
              [-83.0859675769999, 76.48668040600006],
              [-83.0615535149999, 76.49982330900008],
              [-83.07453365799995, 76.50706614800004],
              [-83.08470618399991, 76.51585521000004],
              [-83.0866999989999, 76.52501048400006],
              [-83.0752253899999, 76.53339264500005],
              [-83.10505123599995, 76.57733795800004],
              [-83.11611894399994, 76.58860911700003],
              [-83.12734941299993, 76.59459056200006],
              [-83.19041907499991, 76.60655345300006],
              [-83.19937089799993, 76.60968659100007],
              [-83.19985917899993, 76.61192454600007],
              [-83.19880123599995, 76.62034739800004],
              [-83.19937089799993, 76.62274811400005],
              [-83.22248287699995, 76.63251373900005],
              [-83.3723445299999, 76.66954173400006],
              [-83.39114335799991, 76.67796458500004],
              [-83.3875219389999, 76.68516673400006],
              [-83.40217037699995, 76.70726146000004],
              [-83.40481523299991, 76.71893952000005],
              [-83.3972468739999, 76.72882721600007],
              [-83.38312740799995, 76.73887767100007],
              [-83.35635331899994, 76.75311920800004],
              [-83.38101152299993, 76.76133860900006],
              [-83.40143795499995, 76.76154205900008],
              [-83.4216609369999, 76.75499095300006],
              [-83.44546464799993, 76.74315013200004],
              [-83.51667232999995, 76.72227610900006],
              [-83.52765865799995, 76.70872630400004],
              [-83.5195613269999, 76.69212474200003],
              [-83.50055904899995, 76.68113841400003],
              [-83.40444902299993, 76.65403880400004],
              [-83.39769446499992, 76.64866771000004],
              [-83.38528398299991, 76.63312409100007],
              [-83.37653561099995, 76.62645091400003],
              [-83.34919186099995, 76.61546458500004],
              [-83.29279537699995, 76.59983958500004],
              [-83.26699785099993, 76.58860911700003],
              [-83.25161699099993, 76.57725657800006],
              [-83.2458796869999, 76.56688060100004],
              [-83.24649003799993, 76.53709544500003],
              [-83.23688717399995, 76.51866282800006],
              [-83.21580969999991, 76.51166413000004],
              [-83.1946508449999, 76.50706614800004],
              [-83.1850886709999, 76.49607982000003],
              [-83.19334876199991, 76.49030182500007],
              [-83.23306230399993, 76.46910228100006],
              [-83.24649003799993, 76.45884837400007],
              [-83.2400203119999, 76.45477936400005],
              [-83.23330644399994, 76.45233795800004],
              [-83.22549394399994, 76.45123932500007],
              [-83.21442623599995, 76.44749583500004],
              [-83.1850886709999, 76.43089427300004],
              [-83.2236628899999, 76.41136302300004],
              [-83.2793269519999, 76.40619538000004],
              [-83.6946101549999, 76.43146393400008],
              [-83.71279863199993, 76.43504466400003],
              [-83.71947180899991, 76.43773021000004],
              [-83.7254125639999, 76.44334544500003],
              [-83.72903398299991, 76.44981517100007],
              [-83.7314753899999, 76.45555247600004],
              [-83.7337133449999, 76.45884837400007],
              [-83.77782141799992, 76.47581614800004],
              [-83.8731176419999, 76.48619212400007],
              [-83.89761308499993, 76.50665924700007],
              [-84.0019832019999, 76.53180573100008],
              [-84.0505671869999, 76.55333079600007],
              [-84.04841061099995, 76.57493724200003],
              [-84.07925370999993, 76.62034739800004],
              [-84.1013484369999, 76.63483307500007],
              [-84.2385554679999, 76.66087474200003],
              [-84.29295813699991, 76.66380442900004],
              [-84.3296199209999, 76.65070221600007],
              [-84.30443274599992, 76.64024485900006],
              [-84.27261308499993, 76.63129303600005],
              [-84.2126765619999, 76.62274811400005],
              [-84.19725501199991, 76.61810944200005],
              [-84.1963191399999, 76.60700104400007],
              [-84.20364335799991, 76.59345123900005],
              [-84.2478328119999, 76.54515208500004],
              [-84.25104732999995, 76.53709544500003],
              [-84.23355058499993, 76.52460358300004],
              [-84.1897273429999, 76.50071849200003],
              [-84.1787410149999, 76.48619212400007],
              [-84.18911699099993, 76.48118724200003],
              [-84.19326738199993, 76.47333405200004],
              [-84.1953425769999, 76.46507396000004],
              [-84.1992488269999, 76.45884837400007],
              [-84.21589107999995, 76.45079173400006],
              [-84.23501542899993, 76.44676341400003],
              [-84.5488582019999, 76.43345774900007],
              [-84.63337154899995, 76.43903229400007],
              [-84.71670488199993, 76.45416901200008],
              [-84.7957250639999, 76.47874583500004],
              [-84.79946855399993, 76.50340403900003],
              [-84.8445124989999, 76.53538646000004],
              [-84.90103105399993, 76.56309642100007],
              [-84.98745683499993, 76.58604564000007],
              [-85.01292883999992, 76.58738841400003],
              [-85.03530839799993, 76.57493724200003],
              [-85.04076087099992, 76.56366608300004],
              [-85.0469050769999, 76.53416575700004],
              [-85.05581620999993, 76.52024974200003],
              [-85.03636633999992, 76.51129791900007],
              [-85.02171790299991, 76.49974192900004],
              [-85.01732337099992, 76.48631419500003],
              [-85.02855383999992, 76.47190989800004],
              [-85.0176082019999, 76.45860423400006],
              [-85.0034480459999, 76.45298899900007],
              [-84.98900305899991, 76.44920482000003],
              [-84.97695878799993, 76.44147370000007],
              [-84.96060136599993, 76.42820872600004],
              [-84.94204667899993, 76.42234935100004],
              [-84.67098954999992, 76.38084544500003],
              [-84.3999324209999, 76.33934153900003],
              [-84.3836156889999, 76.32847728100006],
              [-84.38809160099993, 76.31513092700004],
              [-84.4101863269999, 76.30927155200004],
              [-84.8067927724999, 76.29677969000005],
              [-85.2033992179999, 76.28428782800006],
              [-85.22744706899994, 76.29063548400006],
              [-85.2331843739999, 76.29539622600004],
              [-85.23420162699995, 76.30015696800007],
              [-85.2344457669999, 76.30540599200003],
              [-85.23770097599993, 76.31146881700005],
              [-85.24909420499995, 76.31610748900005],
              [-85.43260657499991, 76.30805084800005],
              [-85.46198482999995, 76.31378815300008],
              [-85.51984615799995, 76.33152903900003],
              [-85.54946855399993, 76.33531321800007],
              [-85.58413652299993, 76.33612702000005],
              [-85.72329667899993, 76.35472239800004],
              [-85.8621313139999, 76.35679759300007],
              [-85.9990535149999, 76.37669505400004],
              [-86.07339433499993, 76.37059153900003],
              [-86.21735592399995, 76.37498607000003],
              [-86.2822566399999, 76.38654205900008],
              [-86.34740149599992, 76.38853587400007],
              [-86.37848873599995, 76.39679596600007],
              [-86.37108313699991, 76.39679596600007],
              [-86.40542558499993, 76.40668366100005],
              [-86.41266842399995, 76.41046784100007],
              [-86.4160863919999, 76.41734446800007],
              [-86.4148656889999, 76.42267487200007],
              [-86.41250566299993, 76.42869700700004],
              [-86.41266842399995, 76.43773021000004],
              [-86.4194636709999, 76.45994700700004],
              [-86.41755123599995, 76.47166575700004],
              [-86.4057917959999, 76.48248932500007],
              [-86.23721269399994, 76.50787995000007],
              [-86.20718339799993, 76.52716705900008],
              [-86.2322078119999, 76.54869212400007],
              [-86.4043269519999, 76.58356354400007],
              [-86.51699785099993, 76.62689850500004],
              [-86.57795162699995, 76.64166901200008],
              [-86.63174394399994, 76.63703034100007],
              [-86.30825761599993, 76.53526439000007],
              [-86.30288652299993, 76.52769603100006],
              [-86.31997636599993, 76.52094147300005],
              [-86.5918676419999, 76.48082103100006],
              [-86.6184789699999, 76.48033274900007],
              [-86.64273027299993, 76.47715892100007],
              [-86.65908769399994, 76.46568431200006],
              [-86.63426673099991, 76.46104564000007],
              [-86.63540605399993, 76.44920482000003],
              [-86.6836645169999, 76.40867747600004],
              [-86.7136531239999, 76.36326732000003],
              [-86.71694902299993, 76.35639069200005],
              [-86.7180476549999, 76.35081614800004],
              [-86.7219539049999, 76.34837474200003],
              [-86.75300045499995, 76.35472239800004],
              [-86.79238847599993, 76.35704173400006],
              [-86.84854081899994, 76.36949290600006],
              [-87.09243730399993, 76.38145579600007],
              [-87.13137773299991, 76.38996002800008],
              [-87.15583248599995, 76.40403880400004],
              [-87.14309648299991, 76.41185130400004],
              [-87.12205969999991, 76.41990794500003],
              [-87.12181555899991, 76.43431224200003],
              [-87.1513972649999, 76.44867584800005],
              [-87.40103105399993, 76.45567454600007],
              [-87.43309485599991, 76.46568431200006],
              [-87.40322831899994, 76.48460521000004],
              [-87.39207923099991, 76.49669017100007],
              [-87.3957820299999, 76.51036204600007],
              [-87.42113196499992, 76.52232493700006],
              [-87.48460852799991, 76.53306712400007],
              [-87.5019832019999, 76.54759349200003],
              [-87.48346920499995, 76.55040110900006],
              [-87.47443600199995, 76.56236399900007],
              [-87.46890214799993, 76.57721588700008],
              [-87.4609675769999, 76.58860911700003],
              [-87.4866023429999, 76.60142649900007],
              [-87.52562415299991, 76.61469147300005],
              [-87.56301835799991, 76.62018463700008],
              [-87.58389238199993, 76.60968659100007],
              [-87.58324133999992, 76.60289134300007],
              [-87.5781550769999, 76.59752024900007],
              [-87.57274329299992, 76.59300364800004],
              [-87.57083085799991, 76.58860911700003],
              [-87.5776667959999, 76.56810130400004],
              [-87.58511308499993, 76.55503978100006],
              [-87.59463456899994, 76.54551829600007],
              [-87.59528561099995, 76.53754303600005],
              [-87.57616126199991, 76.52875397300005],
              [-87.50633704299992, 76.51365794500003],
              [-87.49575761599993, 76.50324127800008],
              [-87.50259355399993, 76.49481842700004],
              [-87.5466609369999, 76.46881745000007],
              [-87.54739335799991, 76.44904205900008],
              [-87.51048743399991, 76.43638743700006],
              [-87.43309485599991, 76.42352936400005],
              [-87.4333796869999, 76.41917552300004],
              [-87.43472245999993, 76.41612376500007],
              [-87.4404597649999, 76.41046784100007],
              [-87.43309485599991, 76.40424225500004],
              [-87.4485570949999, 76.39720286700003],
              [-87.5019832019999, 76.38316478100006],
              [-87.4778132799999, 76.37974681200006],
              [-87.45181230399993, 76.37327708500004],
              [-87.4063207669999, 76.35582103100006],
              [-87.4270727199999, 76.34935130400004],
              [-87.4505102199999, 76.35130442900004],
              [-87.53970292899993, 76.37079498900005],
              [-87.5605769519999, 76.37144603100006],
              [-87.58389238199993, 76.36949290600006],
              [-87.5798640619999, 76.36436595300006],
              [-87.57477779899995, 76.35435618700006],
              [-87.57083085799991, 76.34906647300005],
              [-87.6299128899999, 76.33555735900006],
              [-87.70669511599993, 76.33958567900004],
              [-87.77733313699991, 76.36216868700006],
              [-87.8179011709999, 76.40424225500004],
              [-87.80361894399994, 76.40424225500004],
              [-87.81688391799992, 76.41620514500005],
              [-87.83706620999993, 76.41795482000003],
              [-87.87938391799992, 76.41046784100007],
              [-87.8706355459999, 76.40001048400006],
              [-87.86571204299992, 76.39679596600007],
              [-87.87726803299995, 76.39118073100008],
              [-87.8918757799999, 76.37543366100005],
              [-87.89981035099993, 76.36949290600006],
              [-87.91787675699993, 76.36408112200007],
              [-88.40355383999992, 76.39366282800006],
              [-88.43423417899993, 76.40424225500004],
              [-88.41844641799992, 76.41828034100007],
              [-88.39932206899994, 76.42491282800006],
              [-88.3786921869999, 76.42955149900007],
              [-88.35846920499995, 76.43773021000004],
              [-88.3704320949999, 76.43797435100004],
              [-88.37808183499993, 76.44163646000004],
              [-88.38980058499993, 76.45514557500007],
              [-88.39940344999991, 76.46027252800008],
              [-88.41380774599992, 76.46324290600006],
              [-88.44107011599993, 76.46568431200006],
              [-88.38345292899993, 76.48033274900007],
              [-88.35895748599995, 76.48997630400004],
              [-88.36595618399991, 76.49982330900008],
              [-88.3543188139999, 76.51911041900007],
              [-88.37124589799993, 76.52940501500007],
              [-88.3992406889999, 76.53685130400004],
              [-88.4211726549999, 76.54759349200003],
              [-88.42341061099995, 76.55426666900007],
              [-88.42471269399994, 76.57416413000004],
              [-88.42739824099993, 76.58177317900004],
              [-88.44001217399995, 76.59275950700004],
              [-88.45364335799991, 76.59752024900007],
              [-88.46784420499995, 76.60044993700006],
              [-88.5093074209999, 76.61522044500003],
              [-88.5195613269999, 76.62144603100006],
              [-88.52358964799993, 76.63361237200007],
              [-88.5171199209999, 76.63898346600007],
              [-88.48851477799991, 76.65045807500007],
              [-88.48200436099995, 76.66087474200003],
              [-88.49266516799992, 76.68296946800007],
              [-88.53962154899995, 76.70787181200006],
              [-88.5503230459999, 76.72203196800007],
              [-88.55166581899994, 76.74046458500004],
              [-88.48818925699993, 76.76886627800008],
              [-88.48200436099995, 76.77696360900006],
              [-88.4832250639999, 76.80133698100008],
              [-88.4900203119999, 76.81781647300005],
              [-88.50698808499993, 76.82371653900003],
              [-88.53880774599992, 76.81647370000007],
              [-88.55516516799992, 76.80866120000007],
              [-88.57070878799993, 76.79783763200004],
              [-88.60212154899995, 76.77045319200005],
              [-88.62946529899995, 76.75486888200004],
              [-88.6892390619999, 76.73350657800006],
              [-88.70856686099995, 76.71210358300004],
              [-88.67349199099993, 76.70054759300007],
              [-88.58503170499995, 76.63703034100007],
              [-88.59129798099991, 76.63703034100007],
              [-88.59536699099993, 76.62547435100004],
              [-88.6601863269999, 76.60224030200004],
              [-88.6218562489999, 76.58832428600005],
              [-88.57591712099992, 76.58812083500004],
              [-88.53107662699995, 76.58136627800008],
              [-88.49632727799991, 76.54759349200003],
              [-88.5119929679999, 76.53925202000005],
              [-88.5129695299999, 76.52802155200004],
              [-88.50373287699995, 76.51634349200003],
              [-88.48884029899995, 76.50665924700007],
              [-88.58291581899994, 76.46775950700004],
              [-88.62157141799992, 76.43817780200004],
              [-88.59870357999995, 76.41046784100007],
              [-88.61839758999992, 76.40440501500007],
              [-88.64297441299993, 76.40159739800004],
              [-88.66779537699995, 76.40245189000007],
              [-88.6877742179999, 76.40733470300006],
              [-88.69583085799991, 76.41526927300004],
              [-88.69294186099995, 76.42418040600006],
              [-88.68065344999991, 76.43773021000004],
              [-88.66901607999995, 76.46006907800006],
              [-88.6577449209999, 76.47508372600004],
              [-88.6408992179999, 76.48350657800006],
              [-88.61294511599993, 76.48619212400007],
              [-88.6260066399999, 76.49498118700006],
              [-88.68065344999991, 76.52374909100007],
              [-88.6765437489999, 76.53803131700005],
              [-88.66633053299995, 76.54893626500007],
              [-88.65298417899993, 76.55658600500004],
              [-88.6396785149999, 76.56126536700003],
              [-88.65851803299995, 76.57884349200003],
              [-88.6833796869999, 76.59357330900008],
              [-88.7104792959999, 76.60081614800004],
              [-88.7358699209999, 76.59605540600006],
              [-88.7405085929999, 76.59141673400006],
              [-88.7422175769999, 76.58502838700008],
              [-88.74209550699993, 76.57151927300004],
              [-88.74925696499992, 76.56403229400007],
              [-88.79735266799992, 76.55503978100006],
              [-88.7785945299999, 76.53563060100004],
              [-88.78831946499992, 76.52252838700008],
              [-88.83145097599993, 76.49982330900008],
              [-88.79743404899995, 76.48456452000005],
              [-88.78726152299993, 76.47410716400003],
              [-88.79051673099991, 76.45884837400007],
              [-88.8078914049999, 76.44737376500007],
              [-88.88670813699991, 76.43089427300004],
              [-88.8933406239999, 76.42552317900004],
              [-88.8953344389999, 76.41868724200003],
              [-88.89895585799991, 76.41294993700006],
              [-88.91063391799992, 76.41046784100007],
              [-88.99518795499995, 76.41217682500007],
              [-89.01943925699993, 76.41730377800008],
              [-89.03563391799992, 76.42584870000007],
              [-89.03066972599993, 76.43773021000004],
              [-89.04678300699993, 76.45030345300006],
              [-89.0661921869999, 76.44769928600005],
              [-89.1042781239999, 76.42894114800004],
              [-89.1338191399999, 76.42369212400007],
              [-89.1701960929999, 76.42418040600006],
              [-89.2063695949999, 76.42930735900006],
              [-89.23550370999993, 76.43773021000004],
              [-89.25259355399993, 76.45579661700003],
              [-89.26040605399993, 76.45884837400007],
              [-89.41653398299991, 76.49217357000003],
              [-89.43480383999992, 76.49982330900008],
              [-89.42983964799993, 76.51072825700004],
              [-89.41584225199995, 76.51915110900006],
              [-89.40526282499991, 76.52899811400005],
              [-89.41055253799993, 76.54417552300004],
              [-89.42434648299991, 76.55768463700008],
              [-89.44180253799993, 76.56944407800006],
              [-89.46157792899993, 76.57550690300008],
              [-89.48289954299992, 76.57151927300004],
              [-89.5210261709999, 76.54816315300008],
              [-89.54385331899994, 76.54291413000004],
              [-89.59854081899994, 76.56012604400007],
              [-89.65672766799992, 76.56541575700004],
              [-89.6811824209999, 76.57493724200003],
              [-89.6660457019999, 76.57957591400003],
              [-89.6336156889999, 76.58209870000007],
              [-89.61969967399995, 76.58860911700003],
              [-89.6145320299999, 76.59715403900003],
              [-89.61685136599993, 76.60460032800006],
              [-89.62059485599991, 76.61102936400005],
              [-89.61969967399995, 76.61652252800008],
              [-89.59959876199991, 76.62901439000007],
              [-89.44758053299995, 76.65912506700005],
              [-89.42731686099995, 76.67112864800004],
              [-89.4189753899999, 76.68748607000003],
              [-89.4280085929999, 76.69721100500004],
              [-89.44367428299995, 76.70726146000004],
              [-89.45523027299993, 76.72516510600008],
              [-89.43773352799991, 76.72577545800004],
              [-89.40412350199995, 76.73253001500007],
              [-89.38638261599993, 76.73265208500004],
              [-89.39150956899994, 76.73554108300004],
              [-89.39671790299991, 76.73729075700004],
              [-89.4075007799999, 76.73944733300004],
              [-89.40062415299991, 76.73944733300004],
              [-89.42251542899993, 76.74217357000003],
              [-89.4504695299999, 76.75031159100007],
              [-89.4704890619999, 76.76312897300005],
              [-89.4682917959999, 76.78038157800006],
              [-89.4839167959999, 76.79938385600008],
              [-89.49266516799992, 76.80744049700007],
              [-89.50300045499995, 76.81456126500007],
              [-89.50234941299993, 76.82664622600004],
              [-89.5112605459999, 76.83836497600004],
              [-89.5371801419999, 76.85675690300008],
              [-89.47305253799993, 76.88117096600007],
              [-88.99787350199995, 76.95502350500004],
              [-88.9754125639999, 76.97284577000005],
              [-88.9949438139999, 76.97764720300006],
              [-88.99046790299991, 76.98179759300007],
              [-88.7195124989999, 77.01410553600005],
              [-88.64150956899994, 77.04462311400005],
              [-88.53514563699991, 77.07359446800007],
              [-88.50051835799991, 77.07591380400004],
              [-88.45864824099993, 77.07383860900006],
              [-88.41950436099995, 77.07880280200004],
              [-88.39321855399993, 77.10252513200004],
              [-88.4311824209999, 77.09886302300004],
              [-88.54409745999993, 77.10252513200004],
              [-88.49461829299992, 77.11412181200006],
              [-88.39309648299991, 77.11933014500005],
              [-88.29360917899993, 77.13633860900006],
              [-88.13255774599992, 77.12982819200005],
              [-88.13255774599992, 77.12364329600007],
              [-88.14240475199995, 77.12372467700004],
              [-88.1506648429999, 77.12242259300007],
              [-88.1673070949999, 77.11619700700004],
              [-88.12930253799993, 77.10899485900006],
              [-87.86481686099995, 77.13731517100007],
              [-87.7735082669999, 77.12791575700004],
              [-87.6775203119999, 77.13731517100007],
              [-87.64541581899994, 77.13255442900004],
              [-87.61864173099991, 77.11619700700004],
              [-87.61563066299993, 77.10077545800004],
              [-87.5857234369999, 77.09772370000007],
              [-87.47459876199991, 77.11139557500007],
              [-87.38011633999992, 77.10569896000004],
              [-87.33747311099995, 77.11619700700004],
              [-87.4609675769999, 77.12982819200005],
              [-87.4609675769999, 77.13731517100007],
              [-87.39118404899995, 77.16917552300004],
              [-87.36156165299991, 77.17649974200003],
              [-87.08348548099991, 77.18903229400007],
              [-87.0227758449999, 77.17820872600004],
              [-87.02961178299995, 77.17076243700006],
              [-87.0086156889999, 77.16795482000003],
              [-86.98029537699995, 77.16832103100006],
              [-86.95767167899993, 77.16502513200004],
              [-86.9538874989999, 77.15094635600008],
              [-86.91934160099993, 77.13914622600004],
              [-86.87108313699991, 77.13096751500007],
              [-86.82323157499991, 77.12933991100005],
              [-86.79002844999991, 77.13731517100007],
              [-86.8659968739999, 77.16233958500004],
              [-86.89240475199995, 77.16461823100008],
              [-86.89240475199995, 77.17076243700006],
              [-86.6037898429999, 77.17820872600004],
              [-86.6767878899999, 77.19346751500007],
              [-86.8283992179999, 77.18016185100004],
              [-86.90029863199993, 77.19053782800006],
              [-86.9289851549999, 77.19806549700007],
              [-87.13263912699995, 77.21360911700003],
              [-87.15933183499993, 77.20555247600004],
              [-87.14565995999993, 77.19871653900003],
              [-87.18130449099993, 77.20018138200004],
              [-87.19782467399995, 77.20420970300006],
              [-87.21458899599992, 77.21238841400003],
              [-87.20173092399995, 77.21385325700004],
              [-87.1438695949999, 77.23887767100007],
              [-87.1250707669999, 77.24424876500007],
              [-87.00853430899991, 77.26080963700008],
              [-86.93553626199991, 77.26048411700003],
              [-86.9129125639999, 77.26703522300005],
              [-86.9519343739999, 77.27671946800007],
              [-86.99364173099991, 77.28156159100007],
              [-87.17080644399994, 77.27452220300006],
              [-87.21731523299991, 77.28233470300006],
              [-87.24868730399993, 77.30796946800007],
              [-87.19644120999993, 77.31378815300008],
              [-87.09496008999992, 77.34235260600008],
              [-87.0418188139999, 77.34894440300008],
              [-86.9333796869999, 77.34271881700005],
              [-86.83096269399994, 77.35639069200005],
              [-86.8503718739999, 77.36387767100007],
              [-87.1233210929999, 77.36871979400007],
              [-87.3486628899999, 77.33397044500003],
              [-87.68122311099995, 77.35337962400007],
              [-87.72101803299995, 77.37006256700005],
              [-87.70059160099993, 77.39732493700006],
              [-87.72248287699995, 77.40062083500004],
              [-87.75169837099992, 77.40843333500004],
              [-87.77594967399995, 77.42100657800006],
              [-87.78311113199993, 77.43834056200006],
              [-87.75796464799993, 77.45811595300006],
              [-87.66958574099993, 77.46800364800004],
              [-87.6465551419999, 77.48676178600005],
              [-87.6513972649999, 77.49567291900007],
              [-87.66462154899995, 77.50348541900007],
              [-87.6875300769999, 77.51341380400004],
              [-87.69302324099993, 77.52086009300007],
              [-87.69627844999991, 77.53489817900004],
              [-87.70059160099993, 77.54075755400004],
              [-87.71833248599995, 77.54759349200003],
              [-87.78311113199993, 77.54820384300007],
              [-87.8196101549999, 77.55267975500004],
              [-87.8372289699999, 77.55829498900005],
              [-87.85204016799992, 77.56867096600007],
              [-87.84129798099991, 77.56830475500004],
              [-87.83071855399993, 77.56928131700005],
              [-87.82046464799993, 77.57172272300005],
              [-87.81045488199993, 77.57542552300004],
              [-87.8262019519999, 77.58189524900007],
              [-87.8447566399999, 77.58372630400004],
              [-87.88239498599995, 77.58234284100007],
              [-87.90518144399994, 77.58421458500004],
              [-88.01065019399994, 77.61456940300008],
              [-88.1883031889999, 77.64036692900004],
              [-88.21149654899995, 77.65033600500004],
              [-88.2219539049999, 77.66425202000005],
              [-88.2146296869999, 77.68048737200007],
              [-88.19554602799991, 77.69574616100005],
              [-88.15306555899991, 77.71946849200003],
              [-88.16047115799995, 77.72691478100006],
              [-88.15387936099995, 77.73383209800005],
              [-88.15330969999991, 77.74237702000005],
              [-88.1579890619999, 77.75157298400006],
              [-88.1673070949999, 77.76048411700003],
              [-88.18529212099992, 77.76439036700003],
              [-88.20604407499991, 77.76158274900007],
              [-88.2243953119999, 77.76158274900007],
              [-88.23501542899993, 77.77411530200004],
              [-88.1836238269999, 77.77558014500005],
              [-88.16852779899995, 77.78343333500004],
              [-88.1809789699999, 77.80145905200004],
              [-88.12356523299991, 77.80943431200006],
              [-88.1052546869999, 77.81504954600007],
              [-88.1152644519999, 77.82017649900007],
              [-88.2219539049999, 77.85667552300004],
              [-88.2219539049999, 77.86286041900007],
              [-88.20059160099993, 77.85700104400007],
              [-88.13255774599992, 77.85667552300004],
              [-88.1357722649999, 77.85309479400007],
              [-88.1389460929999, 77.85154857000003],
              [-88.14622962099992, 77.84983958500004],
              [-88.1165258449999, 77.83482493700006],
              [-88.0810847649999, 77.82640208500004],
              [-88.04222571499992, 77.82273997600004],
              [-87.61713619699992, 77.86363353050004],
              [-87.19204667899993, 77.90452708500004],
              [-86.8467097649999, 77.88947174700007],
              [-86.6641332669999, 77.85419342700004],
              [-86.4521785149999, 77.83641185100004],
              [-86.21556555899991, 77.79328034100007],
              [-86.07266191299993, 77.73387278900003],
              [-85.9743953119999, 77.71332428600005],
              [-85.95693925699993, 77.69114817900004],
              [-85.91567949099993, 77.65660228100006],
              [-85.8918757799999, 77.64069245000007],
              [-85.88137773299991, 77.63153717700004],
              [-85.87694251199991, 77.62095774900007],
              [-85.87393144399994, 77.61005280200004],
              [-85.8679499989999, 77.59971751500007],
              [-85.8576960929999, 77.59345123900005],
              [-85.84536699099993, 77.58844635600008],
              [-85.83836829299992, 77.58295319200005],
              [-85.84406490799995, 77.57542552300004],
              [-85.80931555899991, 77.52769603100006],
              [-85.79588782499991, 77.51292552300004],
              [-85.78180904899995, 77.50438060100004],
              [-85.74242102799991, 77.49176666900007],
              [-85.7185359369999, 77.47447337400007],
              [-85.73558508999992, 77.45701732000003],
              [-85.7956843739999, 77.42527903900003],
              [-85.7520238919999, 77.42597077000005],
              [-85.59471594999991, 77.46088288000004],
              [-85.55068925699993, 77.46226634300007],
              [-85.52879798099991, 77.46625397300005],
              [-85.52660071499992, 77.46959056200006],
              [-85.52944902299993, 77.47422923400006],
              [-85.52944902299993, 77.47821686400005],
              [-85.51854407499991, 77.47992584800005],
              [-85.5080867179999, 77.47911204600007],
              [-85.49819902299993, 77.47662995000007],
              [-85.48884029899995, 77.47239817900004],
              [-85.48037675699993, 77.46625397300005],
              [-85.49307206899994, 77.45897044500003],
              [-85.5066625639999, 77.45404694200005],
              [-85.52098548099991, 77.45176829600007],
              [-85.53563391799992, 77.45258209800005],
              [-85.5273738269999, 77.44346751500007],
              [-85.51406816299993, 77.43687571800007],
              [-85.49860592399995, 77.43284739800004],
              [-85.48412024599992, 77.43150462400007],
              [-85.4715063139999, 77.42890045800004],
              [-85.43455969999991, 77.40965403900003],
              [-85.40225175699993, 77.40074290600006],
              [-85.00055904899995, 77.38365306200006],
              [-84.93854732999995, 77.37400950700004],
              [-84.7610164049999, 77.32164134300007],
              [-84.4661352199999, 77.30174388200004],
              [-84.48452714799993, 77.32050202000005],
              [-84.54808508999992, 77.33726634300007],
              [-84.57599850199995, 77.34894440300008],
              [-84.5654597649999, 77.36314524900007],
              [-84.5764460929999, 77.37364329600007],
              [-84.59756425699993, 77.38060130400004],
              [-84.61701412699995, 77.38365306200006],
              [-84.57331295499995, 77.40668366100005],
              [-84.4971003899999, 77.40684642100007],
              [-84.3562719389999, 77.39048899900007],
              [-84.06208248599995, 77.40416087400007],
              [-83.76414954349994, 77.37655263850007],
              [-83.46621660099993, 77.34894440300008],
              [-83.47223873599995, 77.36200592700004],
              [-83.48753821499992, 77.38495514500005],
              [-83.4841609369999, 77.39142487200007],
              [-83.7998347649999, 77.42902252800008],
              [-83.83617102799991, 77.45880768400008],
              [-83.80370032499991, 77.47276439000007],
              [-83.6238500639999, 77.47247955900008],
              [-83.57473710799991, 77.48143138200004],
              [-83.50422115799995, 77.50250885600008],
              [-83.4246313139999, 77.50718821800007],
              [-83.3889460929999, 77.51410553600005],
              [-83.37336178299995, 77.51927317900004],
              [-83.35635331899994, 77.52769603100006],
              [-83.31692460799991, 77.55833567900004],
              [-83.30174719999991, 77.56244538000004],
              [-83.2590632799999, 77.56781647300005],
              [-83.02432206899994, 77.67186107000003],
              [-82.9861140619999, 77.67853424700007],
              [-82.97297115799995, 77.68394603100006],
              [-82.96483313699991, 77.69590892100007],
              [-82.9587703119999, 77.70787181200006],
              [-82.95230058499993, 77.71332428600005],
              [-82.93411210799991, 77.71527741100005],
              [-82.8808894519999, 77.72797272300005],
              [-82.78034420499995, 77.79523346600007],
              [-82.7881160149999, 77.79596588700008],
              [-82.80833899599992, 77.80145905200004],
              [-82.76968339799993, 77.81529368700006],
              [-82.68431555899991, 77.83331940300008],
              [-82.6506648429999, 77.85667552300004],
              [-82.64395097599993, 77.86924876500007],
              [-82.6453344389999, 77.88617584800005],
              [-82.6406957669999, 77.89423248900005],
              [-82.6192113919999, 77.90611399900007],
              [-82.5408015619999, 77.92491282800006],
              [-82.58177649599992, 77.94603099200003],
              [-82.56436113199993, 77.95066966400003],
              [-82.52985592399995, 77.95347728100006],
              [-82.5134578119999, 77.95970286700003],
              [-82.52786210799991, 77.96556224200003],
              [-82.5527644519999, 77.97960032800006],
              [-82.56191972599993, 77.98704661700003],
              [-82.5540258449999, 77.98814524900007],
              [-82.5508520169999, 77.98961009300007],
              [-82.5476374989999, 77.99323151200008],
              [-82.5852758449999, 78.01194896000004],
              [-82.59601803299995, 78.02118561400005],
              [-82.5447078119999, 78.03876373900005],
              [-82.4858699209999, 78.04417552300004],
              [-82.37010657499991, 78.04161204600007],
              [-82.3718562489999, 78.05540599200003],
              [-82.35570227799991, 78.06285228100006],
              [-82.33450273299991, 78.07001373900005],
              [-82.3210749989999, 78.08258698100008],
              [-82.5090632799999, 78.08026764500005],
              [-82.65746008999992, 78.06175364800004],
              [-82.76488196499992, 78.02769603100006],
              [-82.78408769399994, 78.01768626500007],
              [-82.7929988269999, 77.98899974200003],
              [-82.7678523429999, 77.96674225500004],
              [-82.73879960799991, 77.94761790600006],
              [-82.73599199099993, 77.92833079600007],
              [-82.75894120999993, 77.91620514500005],
              [-82.93602454299992, 77.88190338700008],
              [-82.95913652299993, 77.87034739800004],
              [-82.95563717399995, 77.86286041900007],
              [-82.9651179679999, 77.85521067900004],
              [-82.97988847599993, 77.84654368700006],
              [-82.99266516799992, 77.83616771000004],
              [-82.9863988919999, 77.83616771000004],
              [-83.00072180899991, 77.82615794500003],
              [-83.0710749989999, 77.81065501500007],
              [-83.1084285149999, 77.79645416900007],
              [-83.12360592399995, 77.78778717700004],
              [-83.1850886709999, 77.72321198100008],
              [-83.20189368399991, 77.70954010600008],
              [-83.23981686099995, 77.69489166900007],
              [-83.32656816299993, 77.67161692900004],
              [-83.39114335799991, 77.62327708500004],
              [-83.42251542899993, 77.60728587400007],
              [-83.6784968739999, 77.53453196800007],
              [-83.9182429679999, 77.49351634300007],
              [-83.92617753799993, 77.49656810100004],
              [-83.9221492179999, 77.50336334800005],
              [-83.91283118399991, 77.51011790600006],
              [-83.90444902299993, 77.51341380400004],
              [-84.08413652299993, 77.50950755400004],
              [-84.33421790299991, 77.53257884300007],
              [-84.7610164049999, 77.52024974200003],
              [-84.78482011599993, 77.52464427300004],
              [-84.84544837099992, 77.54319896000004],
              [-84.86465410099993, 77.55499909100007],
              [-84.8572078119999, 77.56244538000004],
              [-84.8681941399999, 77.57347239800004],
              [-84.8564753899999, 77.58307526200008],
              [-84.83486894399994, 77.59088776200008],
              [-84.6536352199999, 77.62327708500004],
              [-84.63125566299993, 77.63011302300004],
              [-84.59292558499993, 77.65387604400007],
              [-84.50641842399995, 77.67723216400003],
              [-84.47256425699993, 77.69183991100005],
              [-84.43358313699991, 77.72516510600008],
              [-84.4350886709999, 77.72858307500007],
              [-84.44261633999992, 77.73655833500004],
              [-84.45205644399994, 77.74363841400003],
              [-84.4648738269999, 77.74876536700003],
              [-84.47923743399991, 77.75214264500005],
              [-84.49364173099991, 77.75397370000007],
              [-84.49429277299993, 77.75397370000007],
              [-84.49600175699993, 77.75429922100005],
              [-84.4988093739999, 77.75474681200006],
              [-84.50177975199995, 77.75507233300004],
              [-84.50503495999993, 77.75486888200004],
              [-84.50837154899995, 77.75425853100006],
              [-84.49583899599992, 77.75328196800007],
              [-84.49339758999992, 77.75279368700006],
              [-84.49233964799993, 77.75254954600007],
              [-84.47923743399991, 77.74302806200006],
              [-84.47362219999991, 77.73997630400004],
              [-84.4866023429999, 77.71946849200003],
              [-84.49258378799993, 77.71360911700003],
              [-84.50967363199993, 77.70250071800007],
              [-84.51797441299993, 77.69529857000003],
              [-84.54450436099995, 77.68089427300004],
              [-84.62010657499991, 77.66937897300005],
              [-84.71572831899994, 77.63963450700004],
              [-84.94302324099993, 77.60272858300004],
              [-84.96312415299991, 77.60789622600004],
              [-85.00055904899995, 77.62327708500004],
              [-85.28246008999992, 77.65965403900003],
              [-85.30715898299991, 77.67108795800004],
              [-85.30060787699995, 77.68382396000004],
              [-85.28148352799991, 77.69786204600007],
              [-85.26809648299991, 77.71332428600005],
              [-85.3381648429999, 77.73033274900007],
              [-85.3506160149999, 77.73997630400004],
              [-85.21060136599993, 77.75877513200004],
              [-85.20173092399995, 77.77000560100004],
              [-85.19798743399991, 77.78436920800004],
              [-85.1895238919999, 77.79832591400003],
              [-85.1641332669999, 77.80621979400007],
              [-85.05581620999993, 77.80145905200004],
              [-84.96963456899994, 77.81879303600005],
              [-84.94595292899993, 77.82872142100007],
              [-84.97142493399991, 77.84373607000003],
              [-85.0088191399999, 77.84418366100005],
              [-85.04743404899995, 77.83604564000007],
              [-85.09243730399993, 77.82103099200003],
              [-85.14517167899993, 77.82188548400006],
              [-85.2600398429999, 77.80390045800004],
              [-85.32494055899991, 77.80390045800004],
              [-85.3799128899999, 77.81329987200007],
              [-85.39736894399994, 77.82090892100007],
              [-85.4016820949999, 77.83165110900006],
              [-85.3847957019999, 77.84605540600006],
              [-85.32022050699993, 77.87205638200004],
              [-85.25051835799991, 77.88544342700004],
              [-85.17926998599995, 77.88841380400004],
              [-85.03579667899993, 77.87852610900006],
              [-84.95962480399993, 77.88336823100008],
              [-84.8982234369999, 77.89655182500007],
              [-84.86750240799995, 77.89842357000003],
              [-84.8366999989999, 77.89081452000005],
              [-84.8435359369999, 77.89081452000005],
              [-84.8879695299999, 77.85968659100007],
              [-84.90689042899993, 77.84080638200004],
              [-84.89110266799992, 77.83783600500004],
              [-84.67682857999995, 77.90770091400003],
              [-84.3567602199999, 77.88829173400006],
              [-84.31533769399994, 77.89765045800004],
              [-84.5498347649999, 77.92808665600006],
              [-84.89299475849992, 77.91903310750007],
              [-85.23615475199995, 77.90997955900008],
              [-85.3523249989999, 77.88458893400008],
              [-85.47264563699991, 77.87205638200004],
              [-85.4934789699999, 77.87323639500005],
              [-85.50833085799991, 77.88336823100008],
              [-85.51223710799991, 77.89459870000007],
              [-85.50959225199995, 77.90350983300004],
              [-85.50121008999992, 77.90936920800004],
              [-85.4878230459999, 77.91132233300004],
              [-85.65233313699991, 77.91905345300006],
              [-85.67959550699993, 77.93516673400006],
              [-85.66055253799993, 77.95014069200005],
              [-85.36166337799992, 78.00641510600005],
              [-85.0627742179999, 78.06268952000005],
              [-85.01667232999995, 78.05980052300004],
              [-84.92544511599993, 78.04161204600007],
              [-84.70669511599993, 78.03477610900006],
              [-84.68911699099993, 78.03758372600004],
              [-84.5964656239999, 78.06517161700003],
              [-84.5386042959999, 78.07453034100007],
              [-84.3381648429999, 78.07054271000004],
              [-84.2886042959999, 78.08258698100008],
              [-84.58926347599993, 78.08055247600004],
              [-84.73810787699995, 78.05853913000004],
              [-84.85195878799993, 78.05772532800006],
              [-85.09740149599992, 78.10309479400007],
              [-85.04133053299995, 78.12693919500003],
              [-84.9944148429999, 78.15831126500007],
              [-84.99714107999995, 78.16551341400003],
              [-85.0058894519999, 78.17059967700004],
              [-85.01911373599995, 78.17295970300006],
              [-85.03530839799993, 78.17198314000007],
              [-85.03530839799993, 78.17881907800006],
              [-84.84211178299995, 78.16893138200004],
              [-84.62356523299991, 78.20319245000007],
              [-84.39329993399991, 78.19090403900003],
              [-84.20881100199995, 78.15953196800007],
              [-84.02798417899993, 78.17881907800006],
              [-84.02798417899993, 78.18561432500007],
              [-84.22317460799991, 78.18561432500007],
              [-84.42520097599993, 78.21295807500007],
              [-84.7527563139999, 78.21812571800007],
              [-84.87075761599993, 78.19928620000007],
              [-84.9485164049999, 78.20123932500007],
              [-84.96833248599995, 78.21405670800004],
              [-84.94937089799993, 78.24396393400008],
              [-84.9343969389999, 78.25482819200005],
              [-84.8845515619999, 78.27814362200007],
              [-84.87352454299992, 78.28563060100004],
              [-84.85098222599993, 78.30853913000004],
              [-84.80882727799991, 78.32652415600006],
              [-84.5881648429999, 78.34373607000003],
              [-84.57599850199995, 78.35350169500003],
              [-84.5833227199999, 78.36688873900005],
              [-84.60073808499993, 78.37213776200008],
              [-84.6213679679999, 78.37140534100007],
              [-84.63809160099993, 78.36688873900005],
              [-84.66795813699991, 78.35496653900003],
              [-84.69766191299993, 78.34690989800004],
              [-84.72826087099992, 78.34296295800004],
              [-84.7610164049999, 78.34324778900003],
              [-84.78848222599993, 78.34833405200004],
              [-84.84268144399994, 78.36534251500007],
              [-84.8708796869999, 78.36998118700006],
              [-84.86473548099991, 78.37523021000004],
              [-84.8581843739999, 78.37921784100007],
              [-84.85114498599995, 78.38206614800004],
              [-84.85098222599993, 78.38426341400003],
              [-84.83877519399994, 78.39451732000003],
              [-84.82754472599993, 78.41160716400003],
              [-84.8193660149999, 78.43113841400003],
              [-84.81623287699995, 78.44908274900007],
              [-84.8037410149999, 78.46710846600007],
              [-84.78066972599993, 78.47711823100008],
              [-84.7683406239999, 78.48761627800008],
              [-84.78831946499992, 78.50714752800008],
              [-84.71784420499995, 78.53282298400006],
              [-84.65892493399991, 78.57261790600006],
              [-84.63760331899994, 78.58360423400006],
              [-84.61701412699995, 78.58966705900008],
              [-84.64696204299992, 78.59935130400004],
              [-84.67959550699993, 78.59100983300004],
              [-84.7405085929999, 78.55866120000007],
              [-84.83291581899994, 78.52191803600005],
              [-84.8572078119999, 78.50714752800008],
              [-84.85855058499993, 78.49677155200004],
              [-84.86351477799991, 78.48065827000005],
              [-84.87287350199995, 78.46588776200008],
              [-84.88792883999992, 78.45933665600006],
              [-84.89940344999991, 78.45616282800006],
              [-84.91812089799993, 78.44029368700006],
              [-84.93187415299991, 78.43427155200004],
              [-84.96060136599993, 78.42833079600007],
              [-84.97232011599993, 78.42222728100006],
              [-84.98005123599995, 78.41095612200007],
              [-84.97101803299995, 78.40949127800008],
              [-84.96524003799993, 78.40709056200006],
              [-84.95278886599993, 78.39854564000007],
              [-84.96401933499993, 78.38902415600006],
              [-84.97248287699995, 78.37482330900008],
              [-84.97280839799993, 78.36033763200004],
              [-84.95962480399993, 78.35008372600004],
              [-84.9763484369999, 78.33881256700005],
              [-85.0286352199999, 78.31928131700005],
              [-85.04898027299993, 78.31537506700005],
              [-85.04670162699995, 78.30573151200008],
              [-85.0432429679999, 78.30023834800005],
              [-85.03750566299993, 78.29730866100005],
              [-85.02855383999992, 78.29547760600008],
              [-85.02855383999992, 78.28868235900006],
              [-85.05874589799993, 78.28510163000004],
              [-85.08495032499991, 78.27850983300004],
              [-85.19839433499993, 78.22764720300006],
              [-85.23778235599991, 78.20123932500007],
              [-85.36131751199991, 78.15977610900006],
              [-85.3847957019999, 78.14744700700004],
              [-85.3916316399999, 78.13719310100004],
              [-85.4914851549999, 78.10606517100007],
              [-85.52879798099991, 78.10309479400007],
              [-85.52879798099991, 78.10932038000004],
              [-85.51829993399991, 78.10948314000007],
              [-85.50796464799993, 78.11090729400007],
              [-85.4878230459999, 78.11668528900003],
              [-85.85775712799992, 78.08940257400005],
              [-86.22769120999993, 78.06211985900006],
              [-86.24559485599991, 78.06480540600006],
              [-86.2710261709999, 78.07184479400007],
              [-86.28937740799995, 78.08336009300007],
              [-86.28604081899994, 78.09996165600006],
              [-86.26610266799992, 78.12413157800006],
              [-86.25283769399994, 78.13389720300006],
              [-86.23452714799993, 78.13719310100004],
              [-86.23452714799993, 78.14463939000007],
              [-86.2412410149999, 78.14813873900005],
              [-86.25031490799995, 78.15513743700006],
              [-86.25560462099992, 78.15831126500007],
              [-86.2241511709999, 78.16636790600006],
              [-86.1179906889999, 78.17198314000007],
              [-86.0967097649999, 78.17735423400006],
              [-86.0222468739999, 78.21295807500007],
              [-85.93919837099992, 78.23737213700008],
              [-85.92601477799991, 78.25047435100004],
              [-85.9201960929999, 78.26776764500005],
              [-85.9065242179999, 78.27610911700003],
              [-85.89061438699991, 78.28282298400006],
              [-85.8782039049999, 78.29547760600008],
              [-85.8869929679999, 78.29539622600004],
              [-85.89346269399994, 78.29722728100006],
              [-85.9055476549999, 78.30231354400007],
              [-85.87734941299993, 78.31932200700004],
              [-85.85000566299993, 78.32872142100007],
              [-85.83657792899993, 78.34178294500003],
              [-85.85033118399991, 78.36998118700006],
              [-85.84426835799991, 78.37156810100004],
              [-85.83039303299995, 78.37742747600004],
              [-85.8440242179999, 78.38397858300004],
              [-85.86025956899994, 78.38556549700007],
              [-85.87694251199991, 78.38304271000004],
              [-85.8918757799999, 78.37742747600004],
              [-85.8850398429999, 78.37742747600004],
              [-85.89297441299993, 78.36998118700006],
              [-85.8965144519999, 78.36444733300004],
              [-85.89598548099991, 78.35850657800006],
              [-85.8918757799999, 78.35008372600004],
              [-85.90859941299993, 78.34227122600004],
              [-85.94798743399991, 78.33079661700003],
              [-85.97964433499993, 78.32721588700008],
              [-85.98843339799993, 78.32310618700006],
              [-85.9951472649999, 78.31854889500005],
              [-86.00112870999993, 78.31537506700005],
              [-86.0456843739999, 78.30707428600005],
              [-86.05638587099992, 78.30231354400007],
              [-86.0622859369999, 78.29307689000007],
              [-86.06484941299993, 78.27159251500007],
              [-86.06940670499995, 78.26133860900006],
              [-86.0833227199999, 78.25189850500004],
              [-86.14378821499992, 78.23895905200004],
              [-86.23648027299993, 78.20506419500003],
              [-86.28766842399995, 78.19525788000004],
              [-86.3552546869999, 78.20945872600004],
              [-86.43997148299991, 78.20677317900004],
              [-86.4853816399999, 78.21556224200003],
              [-86.50625566299993, 78.21519603100006],
              [-86.5293269519999, 78.20677317900004],
              [-86.5691625639999, 78.18077220300006],
              [-86.72500566299993, 78.12872955900008],
              [-86.76976477799991, 78.12042877800008],
              [-87.12881425699993, 78.12380605650006],
              [-87.48786373599995, 78.12718333500004],
              [-87.51667232999995, 78.13353099200003],
              [-87.53669186099995, 78.14463939000007],
              [-87.49258378799993, 78.17027415600006],
              [-87.43553626199991, 78.18711985900006],
              [-87.09105383999992, 78.20677317900004],
              [-87.09105383999992, 78.21295807500007],
              [-87.20026607999995, 78.21918366100005],
              [-87.2783503899999, 78.23541901200008],
              [-87.34707597599993, 78.22117747600004],
              [-87.4192602199999, 78.21617259300007],
              [-87.48843339799993, 78.21898021000004],
              [-87.52301998599995, 78.23338450700004],
              [-87.5207820299999, 78.24449290600006],
              [-87.50064042899993, 78.26670970300006],
              [-87.49575761599993, 78.27814362200007],
              [-87.49893144399994, 78.29258860900006],
              [-87.5130102199999, 78.31517161700003],
              [-87.51618404899995, 78.32591380400004],
              [-87.50926673099991, 78.35240306200006],
              [-87.49868730399993, 78.37449778900003],
              [-87.50015214799993, 78.39350006700005],
              [-87.52928626199991, 78.41095612200007],
              [-87.51130123599995, 78.43537018400008],
              [-87.4824519519999, 78.45197174700007],
              [-87.1572566399999, 78.54930247600004],
              [-86.85830644399994, 78.54877350500004],
              [-86.8591609369999, 78.55577220300006],
              [-86.8586726549999, 78.56793854400007],
              [-86.85830644399994, 78.56919993700006],
              [-86.90355383999992, 78.58295319200005],
              [-87.05508378799993, 78.56919993700006],
              [-87.10155188699991, 78.57526276200008],
              [-87.1223445299999, 78.58287181200006],
              [-87.11839758999992, 78.59345123900005],
              [-86.98875891799992, 78.64817942900004],
              [-86.96865800699993, 78.66771067900004],
              [-86.9607234369999, 78.69586823100008],
              [-86.9404597649999, 78.71417877800008],
              [-86.60985266799992, 78.80927155200004],
              [-86.58096269399994, 78.81199778900003],
              [-86.55231686099995, 78.81114329600007],
              [-86.5059301419999, 78.80223216400003],
              [-86.0158992179999, 78.83787669500003],
              [-85.75731360599991, 78.83165110900006],
              [-85.49242102799991, 78.87596263200004],
              [-85.3838191399999, 78.88385651200008],
              [-85.2461238269999, 78.91685618700006],
              [-85.2204890619999, 78.91974518400008],
              [-85.16543535099993, 78.91193268400008],
              [-85.03107662699995, 78.92186107000003],
              [-84.70612545499995, 78.87083567900004],
              [-84.22588050049993, 78.85484446800004],
              [-83.7456355459999, 78.83885325700004],
              [-83.54946855399993, 78.79234446800007],
              [-83.32217363199993, 78.77195872600004],
              [-83.26016191299993, 78.74730052300004],
              [-83.16169186099995, 78.72443268400008],
              [-82.78783118399991, 78.69273509300007],
              [-82.7571101549999, 78.68170807500007],
              [-82.70409094999991, 78.67039622600004],
              [-82.69098873599995, 78.66539134300007],
              [-82.70531165299991, 78.65794505400004],
              [-82.6907039049999, 78.64988841400003],
              [-82.6433813139999, 78.64268626500007],
              [-82.6291804679999, 78.63731517100007],
              [-82.62417558499993, 78.63096751500007],
              [-82.62018795499995, 78.62409088700008],
              [-82.60903886599993, 78.61701080900008],
              [-82.5791316399999, 78.60704173400006],
              [-82.50723222599993, 78.59210846600007],
              [-82.4424128899999, 78.58612702000005],
              [-82.37677975199995, 78.57135651200008],
              [-82.3428035149999, 78.56919993700006],
              [-82.26431230399993, 78.58714427300004],
              [-82.2390844389999, 78.58966705900008],
              [-82.2390437489999, 78.59434642100007],
              [-82.24038652299993, 78.59772370000007],
              [-82.24600175699993, 78.60398997600004],
              [-82.5146785149999, 78.66880931200006],
              [-82.59601803299995, 78.70640696800007],
              [-82.49771074099993, 78.71739329600007],
              [-82.47191321499992, 78.72687409100007],
              [-82.4793188139999, 78.73371002800008],
              [-82.24730383999992, 78.71991608300004],
              [-82.21926835799991, 78.72687409100007],
              [-82.2624812489999, 78.75132884300007],
              [-82.33942623599995, 78.75922272300005],
              [-82.7734675769999, 78.73371002800008],
              [-82.80500240799995, 78.73749420800004],
              [-82.89020748599995, 78.76780833500004],
              [-82.92617753799993, 78.77317942900004],
              [-83.00015214799993, 78.77391185100004],
              [-83.03571529899995, 78.77989329600007],
              [-83.0788874989999, 78.79918040600006],
              [-83.09813391799992, 78.80316803600005],
              [-83.21084550699993, 78.80365631700005],
              [-83.2275691399999, 78.80719635600008],
              [-83.2344050769999, 78.81211985900006],
              [-83.25015214799993, 78.83006419500003],
              [-83.26016191299993, 78.83673737200007],
              [-83.2092585929999, 78.85118235900006],
              [-82.9837133449999, 78.85521067900004],
              [-82.64810136599993, 78.83551666900007],
              [-82.40143795499995, 78.82868073100008],
              [-82.35586503799993, 78.83673737200007],
              [-82.32453365799995, 78.84747955900008],
              [-82.01797441299993, 78.86701080900008],
              [-81.77171790299991, 78.86591217700004],
              [-81.73884029899995, 78.85716380400004],
              [-81.80728105399993, 78.84752024900007],
              [-81.7536921869999, 78.84300364800004],
              [-81.71003170499995, 78.84910716400003],
              [-81.7053523429999, 78.87083567900004],
              [-81.69163977799991, 78.87071360900006],
              [-81.67926998599995, 78.87494538000004],
              [-81.65689042899993, 78.89073314000007],
              [-81.67967688699991, 78.90245189000007],
              [-81.75999915299991, 78.91864655200004],
              [-81.74640865799995, 78.92975495000007],
              [-81.7122289699999, 78.94944896000004],
              [-81.6985570949999, 78.97850169500003],
              [-81.68333899599992, 78.98944733300004],
              [-81.6670222649999, 78.99506256700005],
              [-81.65689042899993, 78.99437083500004],
              [-81.6401667959999, 79.00397370000007],
              [-81.4787898429999, 79.04901764500005],
              [-81.49624589799993, 79.05748118700006],
              [-81.53547115799995, 79.06285228100006],
              [-81.54702714799993, 79.06944407800006],
              [-81.56216386599993, 79.06102122600004],
              [-81.88137773299991, 79.01886627800008],
              [-81.9407039049999, 79.00397370000007],
              [-81.97223873599995, 78.98008860900006],
              [-81.95856686099995, 78.98008860900006],
              [-81.9734594389999, 78.96979401200008],
              [-82.03368079299992, 78.95343659100007],
              [-82.10228430899991, 78.92210521000004],
              [-82.12246660099993, 78.91648997600004],
              [-82.53457597599993, 78.88511790600006],
              [-82.5605769519999, 78.88841380400004],
              [-82.6116023429999, 78.90196360900006],
              [-82.9678035149999, 78.94078196800007],
              [-83.33120683499993, 78.93174876500007],
              [-83.66909745999993, 78.93366120000007],
              [-83.96125240799995, 78.96202220300006],
              [-84.27928626199991, 78.95530833500004],
              [-84.50951087099992, 79.01536692900004],
              [-84.75210527299993, 79.03892649900007],
              [-84.78278561099995, 79.05280182500007],
              [-84.7820531889999, 79.07689036700003],
              [-84.76593990799995, 79.08710358300004],
              [-84.70018469999991, 79.09678782800006],
              [-84.6555883449999, 79.11265696800007],
              [-84.50576738199993, 79.14679596600007],
              [-84.4529109369999, 79.14830149900007],
              [-84.3406469389999, 79.13226959800005],
              [-84.16454016799992, 79.13092682500007],
              [-84.0508520169999, 79.10468170800004],
              [-84.04832923099991, 79.10289134300007],
              [-84.05776933499993, 79.09813060100004],
              [-84.06887773299991, 79.08311595300006],
              [-84.04979407499991, 79.08307526200008],
              [-84.0305476549999, 79.07990143400008],
              [-84.0134578119999, 79.07489655200004],
              [-84.00064042899993, 79.06944407800006],
              [-83.9992976549999, 79.06708405200004],
              [-83.9988093739999, 79.06309642100007],
              [-83.99771074099993, 79.05870189000007],
              [-83.9944148429999, 79.05524323100008],
              [-83.9824926419999, 79.05109284100007],
              [-83.71495520749991, 79.04004547750006],
              [-83.44741777299993, 79.02899811400005],
              [-83.3994441399999, 79.03660716400003],
              [-83.36318925699993, 79.05524323100008],
              [-83.40697180899991, 79.06574127800008],
              [-83.4971003899999, 79.04661692900004],
              [-83.54092363199993, 79.04706452000005],
              [-83.6924128899999, 79.07001373900005],
              [-83.71328691299993, 79.07689036700003],
              [-83.69912675699993, 79.08226146000004],
              [-83.69277910099993, 79.08311595300006],
              [-83.72744706899994, 79.09662506700005],
              [-83.87995357999995, 79.12303294500003],
              [-83.9612117179999, 79.12763092700004],
              [-83.9944148429999, 79.13837311400005],
              [-83.98875891799992, 79.14142487200007],
              [-83.9856664699999, 79.14439524900007],
              [-83.98355058499993, 79.14752838700008],
              [-83.98013261599993, 79.15135325700004],
              [-83.99242102799991, 79.15062083500004],
              [-84.0046687489999, 79.15159739800004],
              [-84.01659094999991, 79.15428294500003],
              [-84.02798417899993, 79.15888092700004],
              [-84.00894120999993, 79.17100657800006],
              [-83.9826960929999, 79.18036530200004],
              [-83.93179277299993, 79.19236888200004],
              [-83.96247311099995, 79.22040436400005],
              [-84.0002742179999, 79.22300853100006],
              [-84.0840551419999, 79.19432200700004],
              [-84.14281165299991, 79.18268463700008],
              [-84.3296199209999, 79.19236888200004],
              [-84.3176570299999, 79.20355866100005],
              [-84.32217363199993, 79.21836985900006],
              [-84.3354792959999, 79.23395416900007],
              [-84.35008704299992, 79.24762604400007],
              [-84.33584550699993, 79.24762604400007],
              [-84.3469539049999, 79.26292552300004],
              [-84.36758378799993, 79.27000560100004],
              [-84.39053300699993, 79.27525462400007],
              [-84.41633053299995, 79.29071686400005],
              [-84.42398027299993, 79.29332103100006],
              [-84.4297175769999, 79.29710521000004],
              [-84.43350175699993, 79.31553782800006],
              [-84.43708248599995, 79.31883372600004],
              [-84.44155839799993, 79.32164134300007],
              [-84.44570878799993, 79.33018626500007],
              [-84.4490046869999, 79.36192454600007],
              [-84.4524633449999, 79.37107982000003],
              [-84.46149654899995, 79.37632884300007],
              [-84.47280839799993, 79.37718333500004],
              [-84.4824926419999, 79.37925853100006],
              [-84.4866023429999, 79.38825104400007],
              [-84.48582923099991, 79.40875885600008],
              [-84.4866023429999, 79.41270579600007],
              [-84.50637773299991, 79.42125071800007],
              [-84.58975175699993, 79.44004954600007],
              [-84.68895423099991, 79.44769928600005],
              [-84.87930253799993, 79.48741282800006],
              [-84.89598548099991, 79.49791087400007],
              [-84.8845515619999, 79.51451243700006],
              [-84.8997289699999, 79.51963939000007],
              [-84.93065344999991, 79.52403392100007],
              [-84.96833248599995, 79.53839752800008],
              [-84.9739070299999, 79.54246653900003],
              [-84.9743953119999, 79.54649485900006],
              [-84.97166907499991, 79.55088939000007],
              [-84.96637936099995, 79.55613841400003],
              [-84.98298092399995, 79.56871165600006],
              [-85.0034480459999, 79.57782623900005],
              [-85.04898027299993, 79.59080638200004],
              [-85.03661048099991, 79.60407135600008],
              [-85.0210261709999, 79.61753978100006],
              [-85.17434648299991, 79.65025462400007],
              [-85.3215632799999, 79.67967357000003],
              [-85.62783769399994, 79.70909251500007],
              [-85.86278235599991, 79.69810618700006],
              [-86.15778561099995, 79.73273346600007],
              [-86.44985917899993, 79.75421784100007],
              [-86.4746801419999, 79.76097239800004],
              [-86.48989824099993, 79.76976146000004],
              [-86.4961238269999, 79.77757396000004],
              [-86.49661210799991, 79.78583405200004],
              [-86.4895320299999, 79.81346263200004],
              [-86.48192298099991, 79.82164134300007],
              [-86.46873938699991, 79.82371653900003],
              [-86.37848873599995, 79.82359446800007],
              [-86.39679928299995, 79.82994212400007],
              [-86.43618730399993, 79.83824290600006],
              [-86.45364335799991, 79.85032786700003],
              [-86.45986894399994, 79.86029694200005],
              [-86.46776282499991, 79.88226959800005],
              [-86.4746801419999, 79.89256419500003],
              [-86.46328691299993, 79.90745677300004],
              [-86.4571020169999, 79.92279694200005],
              [-86.4492895169999, 79.93724192900004],
              [-86.4331355459999, 79.94993724200003],
              [-86.3962703119999, 79.96299876500007],
              [-86.3117976549999, 79.97374095300006],
              [-85.96548417899993, 79.95575592700004],
              [-85.87889563699991, 79.94147370000007],
              [-85.53457597599993, 79.93549225500004],
              [-85.41893469999991, 79.90558502800008],
              [-85.33259029899995, 79.90013255400004],
              [-85.28709876199991, 79.90696849200003],
              [-85.25381425699993, 79.92601146000004],
              [-85.4248347649999, 79.93394603100006],
              [-85.52139238199993, 79.96544017100007],
              [-85.87262936099995, 79.97772858300004],
              [-85.95238196499992, 79.99168528900003],
              [-86.44107011599993, 80.00763580900008],
              [-86.53465735599991, 80.03086985900006],
              [-86.5789281889999, 80.04730866100005],
              [-86.5837703119999, 80.05048248900005],
              [-86.5847875639999, 80.05516185100004],
              [-86.58511308499993, 80.06065501500007],
              [-86.5876765619999, 80.06635163000004],
              [-86.60208085799991, 80.07904694200005],
              [-86.63320878799993, 80.09800853100006],
              [-86.64541581899994, 80.11102936400005],
              [-86.65379798099991, 80.13694896000004],
              [-86.64309648299991, 80.15318431200006],
              [-86.58975175699993, 80.19013092700004],
              [-86.55679277299993, 80.20494212400007],
              [-86.5498347649999, 80.21031321800007],
              [-86.54718990799995, 80.22044505400004],
              [-86.54051673099991, 80.23004791900007],
              [-86.5315242179999, 80.23749420800004],
              [-86.52188066299993, 80.24131907800006],
              [-86.5293269519999, 80.24815501500007],
              [-86.52041581899994, 80.25836823100008],
              [-86.51602128799993, 80.26817454600007],
              [-86.5088191399999, 80.28978099200003],
              [-86.5117488269999, 80.28856028900003],
              [-86.5149226549999, 80.29222239800004],
              [-86.51675370999993, 80.29795970300006],
              [-86.5156550769999, 80.30280182500007],
              [-86.5039363269999, 80.30906810100004],
              [-86.4734187489999, 80.31037018400008],
              [-86.43773352799991, 80.32001373900005],
              [-86.16553707599991, 80.32918935750004],
              [-85.8933406239999, 80.33836497600004],
              [-85.72708085799991, 80.31517161700003],
              [-85.3157039049999, 80.26854075700004],
              [-84.9712214834999, 80.27360667500005],
              [-84.6267390619999, 80.27867259300007],
              [-84.3323054679999, 80.27360667500005],
              [-84.0378718739999, 80.26854075700004],
              [-83.7878718739999, 80.25092194200005],
              [-83.3438207669999, 80.14598216400003],
              [-83.1133113269999, 80.07420482000003],
              [-82.67756100199995, 79.99180735900006],
              [-82.42422441349993, 79.93034495650005],
              [-82.17088782499991, 79.86888255400004],
              [-82.10472571499992, 79.84227122600004],
              [-82.07469641799992, 79.82359446800007],
              [-82.01488196499992, 79.77488841400003],
              [-81.98037675699993, 79.75779857000003],
              [-81.96483313699991, 79.74730052300004],
              [-81.97256425699993, 79.74420807500007],
              [-81.97728430899991, 79.74009837400007],
              [-81.9858699209999, 79.72740306200006],
              [-81.9114477199999, 79.70298899900007],
              [-81.83112545499995, 79.69342682500007],
              [-81.67056230399993, 79.69330475500004],
              [-81.6865535149999, 79.66551341400003],
              [-81.67747962099992, 79.64838288000004],
              [-81.61595618399991, 79.62437571800007],
              [-81.63508053299995, 79.61778392100007],
              [-81.6590063139999, 79.61225006700005],
              [-81.6836645169999, 79.61029694200005],
              [-81.70474199099993, 79.61448802300004],
              [-81.72533118399991, 79.62169017100007],
              [-81.75072180899991, 79.62632884300007],
              [-81.7737117179999, 79.62425364800004],
              [-81.78726152299993, 79.61139557500007],
              [-81.6516414049999, 79.59422435100004],
              [-81.58698482999995, 79.60130442900004],
              [-81.4531550769999, 79.64170970300006],
              [-81.37800045499995, 79.64293040600006],
              [-80.98273678299995, 79.60604482650007],
              [-80.58747311099995, 79.56915924700007],
              [-80.5996801419999, 79.57859935100004],
              [-80.61351477799991, 79.58311595300006],
              [-80.62808183499993, 79.58616771000004],
              [-80.64273027299993, 79.59080638200004],
              [-80.62010657499991, 79.60407135600008],
              [-80.35230465399991, 79.62765127150007],
              [-80.08450273299991, 79.65123118700006],
              [-79.95303300699993, 79.64561595300006],
              [-79.91958574099993, 79.64854564000007],
              [-79.7520238919999, 79.70697663000004],
              [-80.07603919149992, 79.69832998250004],
              [-80.40005449099993, 79.68968333500004],
              [-80.4446101549999, 79.67503489800004],
              [-80.88101152299993, 79.65391673400006],
              [-81.32217363199993, 79.72064850500004],
              [-81.5032445949999, 79.71482982000003],
              [-81.52342688699991, 79.71800364800004],
              [-81.53343665299991, 79.72125885600008],
              [-81.51089433499993, 79.74481842700004],
              [-81.50609290299991, 79.75470612200007],
              [-81.56692460799991, 79.76524485900006],
              [-81.6289770169999, 79.76837799700007],
              [-81.58645585799991, 79.78953685100004],
              [-81.56558183499993, 79.80662669500003],
              [-81.57127844999991, 79.82672760600008],
              [-81.60423743399991, 79.86139557500007],
              [-81.6245417959999, 79.87803782800006],
              [-81.6589656239999, 79.88926829600007],
              [-81.66437740799995, 79.89842357000003],
              [-81.66169186099995, 79.90757884300007],
              [-81.64981035099993, 79.91172923400006],
              [-81.56753495999993, 79.92601146000004],
              [-81.44229081899994, 79.92674388200004],
              [-81.40371660099993, 79.93968333500004],
              [-81.45726477799991, 79.95416901200008],
              [-81.72822018149992, 79.97260162950008],
              [-81.99917558499993, 79.99103424700007],
              [-82.0703425769999, 80.01007721600007],
              [-82.1687312489999, 80.01829661700003],
              [-82.5185847649999, 80.11546458500004],
              [-82.94237219999991, 80.24437083500004],
              [-83.00169837099992, 80.27964915600006],
              [-83.20555579299992, 80.31708405200004],
              [-83.20555579299992, 80.32322825700004],
              [-83.1592097649999, 80.33543528900003],
              [-82.84770667249992, 80.35500722900005],
              [-82.53620357999995, 80.37457916900007],
              [-82.26239986899995, 80.38928864150006],
              [-81.98859615799995, 80.40399811400005],
              [-81.6121313139999, 80.41099681200006],
              [-81.19219587566657, 80.43154531466672],
              [-80.77226043733323, 80.45209381733338],
              [-80.3523249989999, 80.47264232000003],
              [-80.29263261599993, 80.48838939000007],
              [-80.30996660099993, 80.49388255400004],
              [-80.3457332019999, 80.49774811400005],
              [-80.36156165299991, 80.50828685100004],
              [-80.05117753799993, 80.52757396000004],
              [-79.78042558499993, 80.53280263850004],
              [-79.50967363199993, 80.53803131700005],
              [-79.4297175769999, 80.55280182500007],
              [-79.0403132799999, 80.54979075700004],
              [-78.9275203119999, 80.56443919500003],
              [-78.81322180899991, 80.55552806200006],
              [-78.69961503799993, 80.57029857000003],
              [-78.40451005749992, 80.56698232650004],
              [-78.1094050769999, 80.56366608300004],
              [-78.05231686099995, 80.56907786700003],
              [-78.0315242179999, 80.57713450700004],
              [-78.03604081899994, 80.57884349200003],
              [-78.03897050699993, 80.58397044500003],
              [-78.0315242179999, 80.58397044500003],
              [-78.02798417899993, 80.58677806200006],
              [-78.0254613919999, 80.58946360900006],
              [-78.02269446499992, 80.59125397300005],
              [-78.0178523429999, 80.59141673400006],
              [-78.0178523429999, 80.59699127800008],
              [-78.40149898999991, 80.60645172750006],
              [-78.78514563699991, 80.61591217700004],
              [-79.27383378799993, 80.60997142100007],
              [-79.61908932199992, 80.61062246300006],
              [-79.96434485599991, 80.61127350500004],
              [-79.96434485599991, 80.61749909100007],
              [-79.9114477199999, 80.63121165600006],
              [-79.5683894519999, 80.66429271000004],
              [-79.3916316399999, 80.69835032800006],
              [-79.07884680899991, 80.71153392100007],
              [-78.84992428299995, 80.74546946800007],
              [-78.63825436099995, 80.75397370000007],
              [-78.53189042899993, 80.78074778900003],
              [-78.33844967399995, 80.78294505400004],
              [-78.2331843739999, 80.79307689000007],
              [-78.18927975199995, 80.80601634300007],
              [-77.73102779899995, 80.81745026200008],
              [-77.50731360599991, 80.83380768400008],
              [-77.13589433499993, 80.83226146000004],
              [-76.85250810449992, 80.83928050300005],
              [-76.5691218739999, 80.84629954600007],
              [-76.51528886599993, 80.85606517100007],
              [-76.48346920499995, 80.87877024900007],
              [-76.5891820949999, 80.90241120000007],
              [-76.77627519399994, 80.90281810100004],
              [-77.0244441399999, 80.88678620000007],
              [-77.38947506399995, 80.90448639500005],
              [-77.69353186749993, 80.90527985200006],
              [-77.9975886709999, 80.90607330900008],
              [-78.11595618399991, 80.88829173400006],
              [-78.48188229099992, 80.87297190950005],
              [-78.84780839799993, 80.85765208500004],
              [-78.87336178299995, 80.85948314000007],
              [-78.8943171869999, 80.86412181200006],
              [-78.93643144399994, 80.87877024900007],
              [-78.9123835929999, 80.89854564000007],
              [-78.88044186099995, 80.90989817900004],
              [-78.86196855399993, 80.92540110900006],
              [-78.8784480459999, 80.95762767100007],
              [-78.89907792899993, 80.97081126500007],
              [-78.9192195299999, 80.97801341400003],
              [-78.92666581899994, 80.98607005400004],
              [-78.90908769399994, 81.00169505400004],
              [-78.8857722649999, 81.01182689000007],
              [-78.46971594999991, 81.10435618700006],
              [-78.42430579299992, 81.12201569200005],
              [-78.3945613269999, 81.14630768400008],
              [-78.47655188699991, 81.15192291900007],
              [-78.44416256399995, 81.17051829600007],
              [-78.38003495999993, 81.17857493700006],
              [-78.26455644399994, 81.17987702000005],
              [-78.15973873599995, 81.19293854400007],
              [-78.05744381399995, 81.21918366100005],
              [-77.9905085929999, 81.24872467700004],
              [-77.8420710929999, 81.28440989800004],
              [-77.66600501199991, 81.30662669500003],
              [-77.62417558499993, 81.32115306200006],
              [-77.36595618399991, 81.34019603100006],
              [-77.19579016799992, 81.37653229400007],
              [-77.07152258999992, 81.37555573100008],
              [-76.96670488199993, 81.40619538000004],
              [-76.7591039699999, 81.43309153900003],
              [-76.7441707019999, 81.44049713700008],
              [-76.79173743399991, 81.45201243700006],
              [-76.85391191299993, 81.45530833500004],
              [-77.31700598849994, 81.40654124550005],
              [-77.78010006399995, 81.35777415600006],
              [-77.87474524599992, 81.33576080900008],
              [-78.19172115799995, 81.30516185100004],
              [-78.48294023299991, 81.22557200700004],
              [-78.5937800769999, 81.21234772300005],
              [-78.6828914049999, 81.19175853100006],
              [-78.70962480399993, 81.17930735900006],
              [-78.73298092399995, 81.16246165600006],
              [-78.75763912699995, 81.13886139500005],
              [-78.72476152299993, 81.12775299700007],
              [-78.70759029899995, 81.12474192900004],
              [-78.69001217399995, 81.12523021000004],
              [-78.73684648299991, 81.11363353100006],
              [-78.9441218739999, 81.10736725500004],
              [-79.22457841699992, 81.15383535400005],
              [-79.50503495999993, 81.20030345300006],
              [-79.4631648429999, 81.17536041900007],
              [-79.15322831899994, 81.10297272300005],
              [-79.0945124989999, 81.09910716400003],
              [-79.0661921869999, 81.09105052300004],
              [-79.1069636709999, 81.07099030200004],
              [-79.21198482999995, 81.07147858300004],
              [-79.2585749989999, 81.06378815300008],
              [-79.32396399599992, 81.02586497600004],
              [-79.3320613269999, 81.01866282800006],
              [-79.3467097649999, 81.00169505400004],
              [-79.3152156239999, 80.99217357000003],
              [-79.28010006399995, 80.98741282800006],
              [-79.24429277299993, 80.98773834800005],
              [-79.18276933499993, 80.99571360900006],
              [-79.16836503799993, 80.98753489800004],
              [-79.1711726549999, 80.97374095300006],
              [-79.19497636599993, 80.95941803600005],
              [-79.2793676419999, 80.92955149900007],
              [-79.30980383999992, 80.92658112200007],
              [-79.37759355399993, 80.92857493700006],
              [-79.41120357999995, 80.92304108300004],
              [-79.43740800699993, 80.90611399900007],
              [-79.4426977199999, 80.88471100500004],
              [-79.48289954299992, 80.86619700700004],
              [-79.61449133999992, 80.82762278900003],
              [-79.92747962099992, 80.79767487200007],
              [-80.05703691299993, 80.76312897300005],
              [-80.19245357999995, 80.75128815300008],
              [-80.35741126199991, 80.73956940300008],
              [-80.6341039699999, 80.70420970300006],
              [-80.87555904899995, 80.66294993700006],
              [-81.21711178299995, 80.62767161700003],
              [-81.5528051419999, 80.62181224200003],
              [-81.81191972599993, 80.59825267100007],
              [-82.07538815049992, 80.58260732600007],
              [-82.33885657499991, 80.56696198100008],
              [-82.3762914699999, 80.55601634300007],
              [-82.38963782499991, 80.55809153900003],
              [-82.72476152299993, 80.55345286700003],
              [-82.9131160149999, 80.53941478100006],
              [-83.1203914049999, 80.54783763200004],
              [-83.16567949099993, 80.56102122600004],
              [-83.16828365799995, 80.58771393400008],
              [-83.14606686099995, 80.61131419500003],
              [-83.11904863199993, 80.63218821800007],
              [-83.08698482999995, 80.64716217700004],
              [-83.04971269399994, 80.65281810100004],
              [-82.9463191399999, 80.65208567900004],
              [-82.89028886599993, 80.65863678600005],
              [-82.83486894399994, 80.68455638200004],
              [-82.49213619699992, 80.70571523650005],
              [-82.14940344999991, 80.72687409100007],
              [-82.02725175699993, 80.75450267100007],
              [-81.9422094389999, 80.76141998900005],
              [-81.75999915299991, 80.81671784100007],
              [-81.78091386599993, 80.82530345300006],
              [-81.86237545499995, 80.82416413000004],
              [-81.97028561099995, 80.83722565300008],
              [-82.02375240799995, 80.83197663000004],
              [-82.12865149599992, 80.80890534100007],
              [-82.3738500639999, 80.78558991100005],
              [-82.42243404899995, 80.77281321800007],
              [-82.4807429679999, 80.77460358300004],
              [-82.50812740799995, 80.77118561400005],
              [-82.5256648429999, 80.76312897300005],
              [-82.54051673099991, 80.75336334800005],
              [-82.5567113919999, 80.74510325700004],
              [-82.57864335799991, 80.74164459800005],
              [-83.00153561099995, 80.72300853100006],
              [-83.3017878899999, 80.69843170800004],
              [-83.49901282499991, 80.70123932500007],
              [-83.52594967399995, 80.70538971600007],
              [-83.5481664699999, 80.71430084800005],
              [-83.52765865799995, 80.72117747600004],
              [-83.5371801419999, 80.72728099200003],
              [-83.5686335929999, 80.74164459800005],
              [-83.52643795499995, 80.75804271000004],
              [-83.35635331899994, 80.76951732000003],
              [-83.14989173099991, 80.81773509300007],
              [-83.12360592399995, 80.83100006700005],
              [-83.2737117179999, 80.84650299700007],
              [-83.32225501199991, 80.83722565300008],
              [-83.3669734369999, 80.81549713700008],
              [-83.38369706899994, 80.80992259300007],
              [-83.5320124989999, 80.78449127800008],
              [-83.5788874989999, 80.78257884300007],
              [-83.60098222599993, 80.77936432500007],
              [-83.65802975199995, 80.75523509300007],
              [-83.70612545499995, 80.74864329600007],
              [-83.8628230459999, 80.76207103100006],
              [-83.8428035149999, 80.75450267100007],
              [-83.7746882799999, 80.74164459800005],
              [-83.8098852199999, 80.73883698100008],
              [-83.82917232999995, 80.72618235900006],
              [-83.82669023299991, 80.70884837400007],
              [-83.79653886599993, 80.69200267100007],
              [-83.77334550699993, 80.68231842700004],
              [-83.7500300769999, 80.66803620000007],
              [-83.73070227799991, 80.65074290600006],
              [-83.71947180899991, 80.63178131700005],
              [-83.74242102799991, 80.61790599200003],
              [-83.77993730399993, 80.57721588700008],
              [-83.80174719999991, 80.55975983300004],
              [-83.84601803299995, 80.54405345300006],
              [-83.8987117179999, 80.53754303600005],
              [-84.07949785099993, 80.53611888200004],
              [-84.39704342399995, 80.50999583500004],
              [-84.69115149599992, 80.53168366100005],
              [-84.9270727199999, 80.53001536700003],
              [-85.1213679679999, 80.50409577000005],
              [-85.55060787699995, 80.52549876500007],
              [-85.65090898299991, 80.54124583500004],
              [-85.79702714799993, 80.53038157800006],
              [-85.8645320299999, 80.54295482000003],
              [-85.7957250639999, 80.57457103100006],
              [-85.63451087099992, 80.60089752800008],
              [-85.56289628799993, 80.62494538000004],
              [-85.78530839799993, 80.60175202000005],
              [-86.05020097599993, 80.53782786700003],
              [-86.11782792899993, 80.53681061400005],
              [-86.43344072199992, 80.57064443550004],
              [-86.7490535149999, 80.60447825700004],
              [-86.6882624989999, 80.65098704600007],
              [-86.55174719999991, 80.71617259300007],
              [-86.17511959549992, 80.83122386250005],
              [-85.79849199099993, 80.94627513200004],
              [-85.62246660099993, 80.98029205900008],
              [-85.50763912699995, 80.98505280200004],
              [-85.45164954299992, 80.99473704600007],
              [-85.36367753799993, 80.99546946800007],
              [-85.23363196499992, 81.01072825700004],
              [-85.20954342399995, 81.02049388200004],
              [-85.1960749989999, 81.02281321800007],
              [-85.00055904899995, 81.02899811400005],
              [-85.01488196499992, 81.03644440300008],
              [-84.99771074099993, 81.04230377800008],
              [-84.9773249989999, 81.04511139500005],
              [-84.95677649599992, 81.04437897300005],
              [-84.9123835929999, 81.03095123900005],
              [-84.8840632799999, 81.02806224200003],
              [-84.5517878894999, 81.04305654500004],
              [-84.2195124989999, 81.05805084800005],
              [-84.14207923099991, 81.07249583500004],
              [-83.67897159199991, 81.09357330900004],
              [-83.2158639529999, 81.11465078300004],
              [-82.7527563139999, 81.13572825700004],
              [-82.69920813699991, 81.14887116100005],
              [-82.4590144519999, 81.16063060100004],
              [-82.36327063699991, 81.17987702000005],
              [-82.3848363919999, 81.18541087400007],
              [-82.83954830624991, 81.16298045425006],
              [-83.29426022049992, 81.14055003450005],
              [-83.74897213474993, 81.11811961475004],
              [-84.20368404899995, 81.09568919500003],
              [-84.25755774599992, 81.10008372600004],
              [-84.71747799349993, 81.08451976100005],
              [-85.17739824099993, 81.06895579600007],
              [-85.27981523299991, 81.05125560100004],
              [-85.39309648299991, 81.06024811400005],
              [-85.4910375639999, 81.05101146000004],
              [-85.78099524599992, 81.03404368700006],
              [-86.11156165299991, 80.99290599200003],
              [-86.36693274599992, 80.92723216400003],
              [-86.44058183499993, 80.89524974200003],
              [-86.46190344999991, 80.88861725500004],
              [-86.56305904899995, 80.87461985900006],
              [-86.62551835799991, 80.84467194200005],
              [-86.61807206899994, 80.83722565300008],
              [-87.06387285099993, 80.73358795800004],
              [-87.0842585929999, 80.72117747600004],
              [-87.09911048099991, 80.69147370000007],
              [-87.16470292899993, 80.66429271000004],
              [-87.27603105399993, 80.63178131700005],
              [-87.4651179679999, 80.63365306200006],
              [-87.70653235599991, 80.64545319200005],
              [-87.89492753799993, 80.67491282800006],
              [-88.10106360599991, 80.68077220300006],
              [-88.37783769399994, 80.72199127800008],
              [-88.62515214799993, 80.76902903900003],
              [-88.93138587099992, 80.79852936400005],
              [-89.18455969999991, 80.85154857000003],
              [-89.38638261599993, 80.87889232000003],
              [-89.4512019519999, 80.90692780200004],
              [-89.46214758999992, 80.91478099200003],
              [-89.45754960799991, 80.92125071800007],
              [-89.4343562489999, 80.92841217700004],
              [-89.3465063139999, 80.93646881700005],
              [-89.27188066299993, 80.95319245000007],
              [-89.02554277299993, 80.95738353100006],
              [-88.8606664699999, 80.98106517100007],
              [-88.41315670499995, 80.99876536700003],
              [-88.12466386599993, 80.99876536700003],
              [-87.8301488919999, 80.99876536700003],
              [-87.61864173099991, 80.98143138200004],
              [-87.13809160099993, 80.98969147300005],
              [-87.02912350199995, 81.00584544500003],
              [-86.69920813699991, 81.00543854400007],
              [-86.45807857999995, 81.02818431200006],
              [-86.28140214799993, 81.06944407800006],
              [-86.0156957669999, 81.08380768400008],
              [-85.85830644399994, 81.07603587400007],
              [-85.83039303299995, 81.08421458500004],
              [-85.87783769399994, 81.09296295800004],
              [-85.9016414049999, 81.10016510600008],
              [-85.9192195299999, 81.11155833500004],
              [-85.89305579299992, 81.12474192900004],
              [-85.85757402299993, 81.13316478100006],
              [-85.75104732999995, 81.14313385600008],
              [-85.67560787699995, 81.16193268400008],
              [-85.6028132799999, 81.17047760600008],
              [-85.53302975199995, 81.18919505400004],
              [-85.18618730399993, 81.23432038000004],
              [-84.8413386709999, 81.26129791900007],
              [-84.7683406239999, 81.27916087400007],
              [-84.7336726549999, 81.28351471600007],
              [-84.74868730399993, 81.29600657800006],
              [-84.7741999989999, 81.29962799700007],
              [-84.8020320299999, 81.29722728100006],
              [-84.82412675699993, 81.29161204600007],
              [-84.84854081899994, 81.29051341400003],
              [-84.93911699099993, 81.31016673400006],
              [-85.00918535099993, 81.30345286700003],
              [-85.24502519399994, 81.29905833500004],
              [-85.56008867099993, 81.26963939000004],
              [-85.87515214799993, 81.24022044500003],
              [-86.20018469999991, 81.18903229400007],
              [-86.29360917899993, 81.15216705900008],
              [-86.52188066299993, 81.12523021000004],
              [-86.5156550769999, 81.12523021000004],
              [-86.93512936099995, 81.11102936400005],
              [-87.38849850199995, 81.06944407800006],
              [-87.8596492179999, 81.07969798400006],
              [-88.3512772289999, 81.06303538625006],
              [-88.84290523999991, 81.04637278850007],
              [-89.33453325099991, 81.02971019075007],
              [-89.82616126199991, 81.01304759300007],
              [-89.94432532499991, 81.02598704600007],
              [-89.99836178299995, 81.03904857000003],
              [-90.08218339799993, 81.04637278900003],
              [-90.18211829299992, 81.07001373900005],
              [-90.2048640619999, 81.08177317900004],
              [-90.24868730399993, 81.11212799700007],
              [-90.31891842399995, 81.14166901200008],
              [-90.34007727799991, 81.15562571800007],
              [-90.35277258999992, 81.17365143400008],
              [-90.3391820949999, 81.17711009300007],
              [-90.2981257799999, 81.19346751500007],
              [-89.98363196499992, 81.24986399900007],
              [-89.96141516799992, 81.24852122600004],
              [-89.91673743399991, 81.24022044500003],
              [-89.8425593739999, 81.24872467700004],
              [-89.79328365799995, 81.24677155200004],
              [-89.60440019399994, 81.21051666900007],
              [-89.55858313699991, 81.20856354400007],
              [-89.24622555249991, 81.22864411050006],
              [-88.9338679679999, 81.24872467700004],
              [-88.99469967399995, 81.26605866100005],
              [-89.38735917899993, 81.25177643400008],
              [-89.57404537699995, 81.28575267100007],
              [-89.8313289049999, 81.30369700700004],
              [-89.95555579299992, 81.33063385600008],
              [-89.92446855399993, 81.34223053600005],
              [-89.60855058499993, 81.36387767100007],
              [-89.45364335799991, 81.40635814000007],
              [-89.2434382799999, 81.41095612200007],
              [-88.99087480399993, 81.46934642100007],
              [-88.88613847599993, 81.45518626500007],
              [-88.84976152299993, 81.45445384300007],
              [-88.81786048099991, 81.46104564000007],
              [-88.84780839799993, 81.46299876500007],
              [-88.90485592399995, 81.47813548400006],
              [-88.9338679679999, 81.48151276200008],
              [-88.91323808499993, 81.49530670800004],
              [-88.8889460929999, 81.50047435100004],
              [-88.49559485599991, 81.52281321800007],
              [-88.30736243399991, 81.52232493700006],
              [-87.9407445949999, 81.53611888200004],
              [-87.9407445949999, 81.52989329600007],
              [-87.95140540299991, 81.53062571800007],
              [-87.9597875639999, 81.52964915600006],
              [-87.96735592399995, 81.52696360900006],
              [-87.97557532499991, 81.52244700700004],
              [-87.9389949209999, 81.51329173400006],
              [-87.8928523429999, 81.51080963700008],
              [-87.78734290299991, 81.52366771000004],
              [-87.72191321499992, 81.51622142100007],
              [-87.52635657499991, 81.51691315300008],
              [-87.2839656239999, 81.48607005400004],
              [-87.24868730399993, 81.49510325700004],
              [-87.25999915299991, 81.49591705900008],
              [-87.27057857999995, 81.49839915600006],
              [-87.2805883449999, 81.50275299700007],
              [-87.28962154899995, 81.50877513200004],
              [-87.3135066399999, 81.51793040600006],
              [-87.6805517244999, 81.54411448800005],
              [-88.04759680899991, 81.57029857000003],
              [-88.13597571499992, 81.55723704600007],
              [-88.24860592399995, 81.56346263200004],
              [-88.23501542899993, 81.57090892100007],
              [-88.2825414699999, 81.58600495000007],
              [-88.34268144399994, 81.59052155200004],
              [-88.4036352199999, 81.58653392100007],
              [-88.50527910099993, 81.56391022300005],
              [-88.61286373599995, 81.55369700700004],
              [-88.97850501199991, 81.54051341400003],
              [-89.30825761599993, 81.50519440300008],
              [-89.51431230399993, 81.48753489800004],
              [-89.7852270169999, 81.44627513200004],
              [-90.25820878799993, 81.39781321800007],
              [-90.35024980399993, 81.37596263200004],
              [-90.4214167959999, 81.36851634300007],
              [-90.49233964799993, 81.37083567900004],
              [-90.5520320299999, 81.38523997600004],
              [-90.48314368399991, 81.39891185100004],
              [-90.85989335799991, 81.44733307500007],
              [-90.83356686099995, 81.46434153900003],
              [-90.46174068899992, 81.51713694900005],
              [-90.0899145169999, 81.56993235900006],
              [-89.97598222599993, 81.56761302300004],
              [-89.95555579299992, 81.57090892100007],
              [-89.94635982999995, 81.57603587400007],
              [-89.9290258449999, 81.59056224200003],
              [-89.9148249989999, 81.59638092700004],
              [-89.64150956899994, 81.60167064000007],
              [-89.58560136599993, 81.63231028900003],
              [-89.83885657499991, 81.63231028900003],
              [-90.0920710929999, 81.62608470300006],
              [-90.07949785099993, 81.63658274900007],
              [-90.06200110599991, 81.64024485900006],
              [-90.04246985599991, 81.64183177300004],
              [-90.02375240799995, 81.64598216400003],
              [-90.04914303299995, 81.65391673400006],
              [-90.10643469999991, 81.65525950700004],
              [-90.1336156889999, 81.66022370000007],
              [-90.23656165299991, 81.69599030200004],
              [-90.29865475199995, 81.70408763200004],
              [-90.33226477799991, 81.70184967700004],
              [-90.3564753899999, 81.69065989800004],
              [-90.35448157499991, 81.67808665600006],
              [-90.3340551419999, 81.66498444200005],
              [-90.2912898429999, 81.64598216400003],
              [-90.31761633999992, 81.64683665600006],
              [-90.39378821499992, 81.66022370000007],
              [-90.48745683499993, 81.65818919500003],
              [-90.68276933499993, 81.67711009300007],
              [-90.71589107999995, 81.67430247600004],
              [-90.7805883449999, 81.64179108300004],
              [-90.82974199099993, 81.63389720300006],
              [-90.9287410149999, 81.63231028900003],
              [-90.97085527299993, 81.62584056200006],
              [-90.99209550699993, 81.61884186400005],
              [-91.0075984369999, 81.60838450700004],
              [-91.0046687489999, 81.59821198100008],
              [-90.96231035099993, 81.56346263200004],
              [-90.98664303299995, 81.56366608300004],
              [-91.0152074859999, 81.56085846600007],
              [-91.0429988269999, 81.55512116100005],
              [-91.08259029899995, 81.54132721600007],
              [-91.10122636599993, 81.53978099200003],
              [-91.1103816399999, 81.54258860900006],
              [-91.09943600199995, 81.55036041900007],
              [-91.1438695949999, 81.56000397300005],
              [-91.4700007799999, 81.52989329600007],
              [-91.41706295499995, 81.54393138200004],
              [-91.40851803299995, 81.55036041900007],
              [-91.41437740799995, 81.55369700700004],
              [-91.44204667899993, 81.58515045800004],
              [-91.4817195299999, 81.59617747600004],
              [-91.7515356109999, 81.60480377800008],
              [-91.8120417959999, 81.62067291900007],
              [-91.8808894519999, 81.61863841400003],
              [-91.94920813699991, 81.63231028900003],
              [-91.9365535149999, 81.64398834800005],
              [-91.91380774599992, 81.64756907800006],
              [-91.8672175769999, 81.64598216400003],
              [-91.88540605399993, 81.65350983300004],
              [-91.9096980459999, 81.65790436400005],
              [-91.9566137359999, 81.66022370000007],
              [-91.91258704299992, 81.67015208500004],
              [-91.81924394399994, 81.66270579600007],
              [-91.77163652299993, 81.66705963700008],
              [-91.81265214799993, 81.68012116100005],
              [-91.79491126199991, 81.68650950700004],
              [-91.75649980399993, 81.68992747600004],
              [-91.73753821499992, 81.69440338700008],
              [-91.75121008999992, 81.70054759300007],
              [-91.72305253799993, 81.71360911700003],
              [-91.71727454299992, 81.72089264500005],
              [-91.7307429679999, 81.72850169500003],
              [-91.7085261709999, 81.73436107000003],
              [-91.6179906889999, 81.73663971600007],
              [-91.5710749989999, 81.75360748900005],
              [-91.4844457669999, 81.77179596600007],
              [-91.3980199859999, 81.77692291900007],
              [-91.20653235599991, 81.76268138200004],
              [-91.11717688699991, 81.76947663000004],
              [-91.0508113269999, 81.76500071800007],
              [-91.03115800699993, 81.76947663000004],
              [-91.1250707669999, 81.79071686400005],
              [-91.1540828119999, 81.80365631700005],
              [-91.0913386709999, 81.83043040600006],
              [-91.01390540299991, 81.84227122600004],
              [-90.73232988199993, 81.83930084800005],
              [-90.69603430899991, 81.84800853100006],
              [-90.69090735599991, 81.85154857000003],
              [-90.6895238919999, 81.85460032800006],
              [-90.68887285099993, 81.85777415600006],
              [-90.68545488199993, 81.86200592700004],
              [-90.67747962099992, 81.86546458500004],
              [-90.65835527299993, 81.86554596600007],
              [-90.61286373599995, 81.87669505400004],
              [-90.24290930899991, 81.89984772300005],
              [-89.9350886709999, 81.88556549700007],
              [-89.9551082019999, 81.89708079600007],
              [-89.98306230399993, 81.90277741100005],
              [-89.89240475199995, 81.90110911700003],
              [-89.76463782499991, 81.92198314000007],
              [-89.72175045499995, 81.92332591400003],
              [-89.6811824209999, 81.91351959800005],
              [-89.69579016799992, 81.90729401200008],
              [-89.72777258999992, 81.90448639500005],
              [-89.74323482999995, 81.89984772300005],
              [-89.70815995999993, 81.88983795800004],
              [-89.64476477799991, 81.86399974200003],
              [-89.53408769399994, 81.84459056200006],
              [-89.4961645169999, 81.84605540600006],
              [-89.47760982999995, 81.84430573100008],
              [-89.46206620999993, 81.83775462400007],
              [-89.46768144399994, 81.83466217700004],
              [-89.48257402299993, 81.82408274900007],
              [-89.4521785149999, 81.82550690300008],
              [-89.3699031239999, 81.81964752800008],
              [-89.33535722599993, 81.80902741100005],
              [-89.35081946499992, 81.81858958500004],
              [-89.35220292899993, 81.82099030200004],
              [-89.34097245999993, 81.83051178600005],
              [-89.26878821499992, 81.84275950700004],
              [-89.1790258449999, 81.87828196800007],
              [-89.14745032499991, 81.88556549700007],
              [-89.17634029899995, 81.90045807500007],
              [-89.37913977799991, 81.90684642100007],
              [-89.40591386599993, 81.91087474200003],
              [-89.42113196499992, 81.92027415600006],
              [-89.41323808499993, 81.92955149900007],
              [-89.38906816299993, 81.93736399900007],
              [-89.34447180899991, 81.94647858300004],
              [-89.25210527299993, 81.94871653900003],
              [-89.07925370999993, 81.91412995000007],
              [-88.9890844389999, 81.92772044500003],
              [-89.0027563139999, 81.94017161700003],
              [-88.9958796869999, 81.94310130400004],
              [-88.9890844389999, 81.94761790600006],
              [-89.05801347599993, 81.98859284100007],
              [-89.00739498599995, 82.00682200700004],
              [-88.68073482999995, 82.05841705900008],
              [-88.23656165299991, 82.08079661700003],
              [-88.16820227799991, 82.09186432500007],
              [-88.1291804679999, 82.09162018400008],
              [-88.11770585799991, 82.09336985900006],
              [-88.10065670499995, 82.10211823100008],
              [-88.0915828119999, 82.10529205900008],
              [-88.07046464799993, 82.10728587400007],
              [-87.99909420499995, 82.10529205900008],
              [-87.79336503799993, 82.07737864800004],
              [-87.5879207019999, 82.09162018400008],
              [-87.3728328119999, 82.07737864800004],
              [-87.19359290299991, 82.03062571800007],
              [-87.1736140619999, 82.01585521000004],
              [-87.31761633999992, 81.97557200700004],
              [-87.28958085799991, 81.96446360900006],
              [-87.00875810449992, 81.92873769750005],
              [-86.72793535099993, 81.89301178600005],
              [-86.75658118399991, 81.91522858300004],
              [-86.81403561099995, 81.93174876500007],
              [-87.08975175699993, 81.95604075700004],
              [-87.13137773299991, 81.97557200700004],
              [-86.8440242179999, 81.98859284100007],
              [-86.8440242179999, 81.99542877800008],
              [-86.87026933499993, 81.99705638200004],
              [-86.99266516799992, 82.02448151200008],
              [-87.00137285099993, 82.03204987200007],
              [-86.98802649599992, 82.04380931200006],
              [-86.96475175699993, 82.05149974200003],
              [-86.6289363269999, 82.05870189000007],
              [-86.25772050699993, 82.04657623900005],
              [-86.1621394519999, 82.04584381700005],
              [-86.11184648299991, 82.03241608300004],
              [-85.97883053299995, 82.01646556200006],
              [-85.70409094949994, 81.93827952700005],
              [-85.42935136599993, 81.86009349200003],
              [-85.39932206899994, 81.85691966400003],
              [-85.3711238269999, 81.86509837400007],
              [-85.4060359369999, 81.88739655200004],
              [-85.64020748599995, 81.94859446800007],
              [-85.73420162699995, 81.98859284100007],
              [-85.68374589799993, 82.00779857000003],
              [-85.26789303299995, 82.00800202000005],
              [-85.2000219389999, 81.99738190300008],
              [-85.0210261709999, 81.92027415600006],
              [-84.91047115799995, 81.89512767100007],
              [-84.7957250639999, 81.88556549700007],
              [-84.9394832019999, 81.93085358300004],
              [-85.06948808499993, 81.98859284100007],
              [-85.0320124989999, 81.99909088700008],
              [-84.86587480399993, 81.99351634300007],
              [-84.8376765619999, 81.98570384300007],
              [-84.8232722649999, 81.96893952000005],
              [-84.82925370999993, 81.94017161700003],
              [-84.77448482999995, 81.91864655200004],
              [-84.7200414699999, 81.90391673400006],
              [-84.60334225199995, 81.89301178600005],
              [-84.6218562489999, 81.90355052300004],
              [-84.6855769519999, 81.92405833500004],
              [-84.6922094389999, 81.93138255400004],
              [-84.70498613199993, 81.95689524900007],
              [-84.71320553299995, 81.96812571800007],
              [-84.75243079299992, 81.99119700700004],
              [-85.24636796749992, 82.02775706575004],
              [-85.74030514199993, 82.06431712450004],
              [-86.23424231649993, 82.10087718325003],
              [-86.72817949099993, 82.13743724200003],
              [-86.8594050769999, 82.19025299700007],
              [-86.87873287699995, 82.20831940300008],
              [-86.84797115799995, 82.22056712400007],
              [-86.55825761599993, 82.24127838700008],
              [-86.35781816299993, 82.23082103100006],
              [-86.01516679599993, 82.23790110900006],
              [-85.67251542899993, 82.24498118700006],
              [-85.56273352799991, 82.27464427300004],
              [-85.51073157499991, 82.28009674700007],
              [-85.40103105399993, 82.27704498900005],
              [-85.3506160149999, 82.29026927300004],
              [-85.45913652299993, 82.31175364800004],
              [-85.49465898299991, 82.32371653900003],
              [-85.47744706899994, 82.33177317900004],
              [-85.43801835799991, 82.34324778900003],
              [-85.41893469999991, 82.35167064000007],
              [-85.5156550769999, 82.35203685100004],
              [-85.5352270169999, 82.36570872600004],
              [-85.50088456899994, 82.40013255400004],
              [-85.5483699209999, 82.41575755400004],
              [-85.7063289049999, 82.41380442900004],
              [-85.78726152299993, 82.42621491100005],
              [-85.89565995999993, 82.42670319200005],
              [-85.9192195299999, 82.43357982000003],
              [-85.9011938139999, 82.44468821800007],
              [-85.8796687489999, 82.44810618700006],
              [-85.8569636709999, 82.44920482000003],
              [-85.76187089799993, 82.46747467700004],
              [-85.41071529899993, 82.47265588333339],
              [-85.05955969999992, 82.47783708966672],
              [-84.70840410099993, 82.48301829600007],
              [-84.65965735599991, 82.47386302300004],
              [-84.62352454299992, 82.45250071800007],
              [-84.64696204299992, 82.44310130400004],
              [-84.90029863199993, 82.43834056200006],
              [-84.94595292899993, 82.42743561400005],
              [-84.52057857999995, 82.39976634300007],
              [-84.3836156889999, 82.37278880400004],
              [-84.39110266799992, 82.36595286700003],
              [-84.34740149599992, 82.35325755400004],
              [-84.1985570949999, 82.37278880400004],
              [-83.93671627499992, 82.36088694850005],
              [-83.67487545499995, 82.34898509300007],
              [-83.42682857999995, 82.30296458500004],
              [-83.38369706899994, 82.28278229400007],
              [-83.37002519399994, 82.27195872600004],
              [-83.36965898299991, 82.26703522300005],
              [-83.37279212099992, 82.26158274900007],
              [-83.3694148429999, 82.24925364800004],
              [-83.35594641799992, 82.23619212400007],
              [-83.33617102799991, 82.22825755400004],
              [-83.0339656239999, 82.17161692900004],
              [-83.01528886599993, 82.16380442900004],
              [-82.9690242179999, 82.13255442900004],
              [-82.95169023299991, 82.12579987200007],
              [-82.97923743399991, 82.09935130400004],
              [-83.02887936099995, 82.08482493700006],
              [-83.13044186099995, 82.07737864800004],
              [-83.13044186099995, 82.07115306200006],
              [-82.78757347999993, 82.06728750200006],
              [-82.44470509899992, 82.06342194200005],
              [-82.1018367179999, 82.05955638200004],
              [-81.9470515619999, 82.03522370000007],
              [-81.9077449209999, 82.03461334800005],
              [-81.87661699099993, 82.04380931200006],
              [-81.89509029899995, 82.04783763200004],
              [-81.94489498599995, 82.07115306200006],
              [-82.11196855399993, 82.09935130400004],
              [-82.5842585929999, 82.09483470300006],
              [-82.6270238919999, 82.10374583500004],
              [-82.83714758999992, 82.18707916900007],
              [-83.00869706899994, 82.23053620000007],
              [-83.01846269399994, 82.23619212400007],
              [-83.02074133999992, 82.24522532800006],
              [-83.02057857999995, 82.26292552300004],
              [-83.02497311099995, 82.28522370000007],
              [-83.01968339799993, 82.28986237200007],
              [-82.99990800699993, 82.29527415600006],
              [-82.96987870999993, 82.29844798400006],
              [-82.5716039699999, 82.24717845300006],
              [-82.40078691299993, 82.24717845300006],
              [-82.1296687489999, 82.19017161700003],
              [-81.85543779199992, 82.15487295150004],
              [-81.58120683499993, 82.11957428600005],
              [-81.58804277299993, 82.11957428600005],
              [-81.10140947199992, 82.06771474800004],
              [-80.6147761709999, 82.01585521000004],
              [-80.60879472599993, 82.00218333500004],
              [-80.56818600199995, 81.99607982000003],
              [-80.51809648299991, 81.99616120000007],
              [-80.4402563139999, 82.00800202000005],
              [-80.0212703119999, 81.96759674700007],
              [-79.61522376199991, 81.85911692900004],
              [-79.56875566299993, 81.83177317900004],
              [-79.52912350199995, 81.82404205900008],
              [-79.23062089799993, 81.81785716400003],
              [-79.68089758999992, 81.93577708500004],
              [-79.71108964799993, 81.95445384300007],
              [-79.70364335799991, 81.96128978100006],
              [-79.7566218739999, 81.97345612200007],
              [-79.86978105399993, 81.97544993700006],
              [-79.9233699209999, 81.98859284100007],
              [-79.90249589799993, 81.99803294500003],
              [-79.85562089799993, 82.00824616100005],
              [-79.83462480399993, 82.01585521000004],
              [-79.86367753799993, 82.02692291900007],
              [-80.22033986433325, 82.05259837466673],
              [-80.57700219066658, 82.07827383033339],
              [-80.9336645169999, 82.10394928600005],
              [-80.9648738269999, 82.11957428600005],
              [-80.97378495999993, 82.12946198100008],
              [-80.97419186099995, 82.13458893400008],
              [-80.96646074099993, 82.13755931200006],
              [-80.8869929679999, 82.15314362200007],
              [-80.86929277299993, 82.15989817900004],
              [-81.29190019399994, 82.16282786700003],
              [-81.7651261056666, 82.23570384333338],
              [-82.23835201733327, 82.30857981966672],
              [-82.71157792899993, 82.38145579600007],
              [-82.72573808499993, 82.39264557500007],
              [-82.7314753899999, 82.40489329600007],
              [-82.73013261599993, 82.41050853100006],
              [-82.6809382799999, 82.43931712400007],
              [-82.49730383999992, 82.50938548400006],
              [-81.99864661349991, 82.50356679900005],
              [-81.49998938699991, 82.49774811400005],
              [-81.4787898429999, 82.50250885600008],
              [-81.50413977799991, 82.50975169500003],
              [-81.57778886599993, 82.50250885600008],
              [-81.91364498599995, 82.52464427300004],
              [-81.92381751199991, 82.52985260600008],
              [-82.29434160099993, 82.58445872600004],
              [-82.3967585929999, 82.61920807500007],
              [-82.37100175699993, 82.64606354400007],
              [-82.32803300699993, 82.65916575700004],
              [-82.06997636599993, 82.67430247600004],
              [-81.74319413949993, 82.65279775600004],
              [-81.41641191299993, 82.63129303600005],
              [-81.15168209549992, 82.58313629750006],
              [-80.88695227799991, 82.53497955900008],
              [-80.58063717399995, 82.54344310100004],
              [-80.6006160149999, 82.55882396000004],
              [-80.8488866854999, 82.61576976100005],
              [-81.09715735599991, 82.67271556200006],
              [-81.12995357999995, 82.68809642100007],
              [-81.12254798099991, 82.69432200700004],
              [-81.16006425699993, 82.71714915600006],
              [-81.26870683499993, 82.72772858300004],
              [-81.36636308499993, 82.75580475500004],
              [-81.47826087099992, 82.76585521000004],
              [-81.57616126199991, 82.79124583500004],
              [-81.58454342399995, 82.80052317900004],
              [-81.56786048099991, 82.81476471600007],
              [-81.54076087099992, 82.82371653900003],
              [-81.4739477199999, 82.83030833500004],
              [-81.0877715049999, 82.81568702433339],
              [-80.7015952899999, 82.80106571366673],
              [-80.31541907499991, 82.78644440300008],
              [-80.27961178299995, 82.77000560100004],
              [-80.28311113199993, 82.76691315300008],
              [-80.28921464799993, 82.75950755400004],
              [-80.29263261599993, 82.75641510600008],
              [-80.17731686099995, 82.73607005400004],
              [-80.14240475199995, 82.72162506700005],
              [-80.16185462099992, 82.70880768400008],
              [-80.17227128799993, 82.70416901200008],
              [-80.1833796869999, 82.70115794500003],
              [-80.15200761599993, 82.68077220300006],
              [-80.1016332669999, 82.67011139500005],
              [-79.9226781889999, 82.65635814000007],
              [-79.8742976549999, 82.64622630400004],
              [-79.8469539049999, 82.64378489800004],
              [-79.82030188699991, 82.64561595300006],
              [-79.79922441299993, 82.65330638200004],
              [-79.9421687489999, 82.67918528900003],
              [-79.98477128799993, 82.69432200700004],
              [-79.9514460929999, 82.71128978100006],
              [-79.90078691299993, 82.71788157800006],
              [-79.51362057199992, 82.69350820550005],
              [-79.12645423099991, 82.66913483300004],
              [-79.03815670499995, 82.68134186400005],
              [-78.9409480459999, 82.67059967700004],
              [-78.54792232999995, 82.67601146000004],
              [-78.50442460799991, 82.68809642100007],
              [-78.96795271133324, 82.71381256700006],
              [-79.43148081466659, 82.73952871300007],
              [-79.89500891799992, 82.76524485900006],
              [-79.9309382799999, 82.77936432500007],
              [-79.9233699209999, 82.79795970300006],
              [-79.99844316299993, 82.80357493700006],
              [-79.92349199099993, 82.82225169500003],
              [-79.67634029899995, 82.82465241100005],
              [-79.67634029899995, 82.83148834800005],
              [-80.01427161399994, 82.84796784050005],
              [-80.35220292899993, 82.86444733300004],
              [-80.4011938139999, 82.87958405200004],
              [-80.42983964799993, 82.90037669500003],
              [-80.39126542899993, 82.90586985900006],
              [-80.31143144399994, 82.90766022300005],
              [-80.25706946499992, 82.91901276200008],
              [-80.22248287699995, 82.91966380400004],
              [-80.20539303299995, 82.92247142100007],
              [-80.15811113199993, 82.93927643400008],
              [-79.74929765549993, 82.95740387550006],
              [-79.34048417899993, 82.97553131700005],
              [-79.32363847599993, 82.97113678600005],
              [-79.2893367179999, 82.95811595300006],
              [-79.2722468739999, 82.95433177300004],
              [-79.1907039049999, 82.95404694200005],
              [-79.19994055899991, 82.95213450700004],
              [-79.20799719999991, 82.94843170800004],
              [-79.2141414049999, 82.94261302300004],
              [-79.21768144399994, 82.93451569200005],
              [-79.17870032499991, 82.93223704600007],
              [-79.12352454299992, 82.92222728100006],
              [-79.0793757799999, 82.90473053600005],
              [-79.07363847599993, 82.87986888200004],
              [-79.00902258999992, 82.87474192900004],
              [-78.98973548099991, 82.87791575700004],
              [-78.79279537699995, 82.94367096600007],
              [-78.7009578119999, 82.94859446800007],
              [-78.60598710799991, 82.94358958500004],
              [-78.5244441399999, 82.92743561400005],
              [-78.50894120999993, 82.92137278900003],
              [-78.50442460799991, 82.90721263200004],
              [-78.51244055899991, 82.89769114800004],
              [-78.55907141799992, 82.86627838700008],
              [-78.51870683499993, 82.84605540600006],
              [-78.47052975199995, 82.85578034100007],
              [-78.42056230399993, 82.87230052300004],
              [-78.37474524599992, 82.87242259300007],
              [-78.36563066299993, 82.85691966400003],
              [-78.3298640619999, 82.85203685100004],
              [-78.25780188699991, 82.85020579600007],
              [-78.17544511599993, 82.83148834800005],
              [-78.10659745999993, 82.83148834800005],
              [-78.10659745999993, 82.83832428600005],
              [-78.1382136709999, 82.83832428600005],
              [-78.17910722599993, 82.84300364800004],
              [-78.21800696499992, 82.85236237200007],
              [-78.24372311099995, 82.86627838700008],
              [-78.20197506399995, 82.87836334800005],
              [-78.05874589799993, 82.85875071800007],
              [-78.02399654899995, 82.86094798400006],
              [-78.01878821499992, 82.86615631700005],
              [-78.03180904899995, 82.87620677300004],
              [-78.0500789049999, 82.88239166900007],
              [-78.1140437489999, 82.89293040600006],
              [-78.0818171869999, 82.90460846600007],
              [-77.85220292899993, 82.92601146000004],
              [-77.49543209549992, 82.89645009950004],
              [-77.13866126199991, 82.86688873900005],
              [-76.9502253899999, 82.80621979400007],
              [-76.92853756399995, 82.79051341400003],
              [-76.95384680899991, 82.77891673400006],
              [-76.9626765619999, 82.77623118700006],
              [-76.92894446499992, 82.76793040600006],
              [-76.7888484369999, 82.75840892100007],
              [-76.73110917899993, 82.74359772300005],
              [-76.5569148429999, 82.67548248900005],
              [-76.4324031239999, 82.66478099200003],
              [-76.39614824099993, 82.65623607000003],
              [-76.38044186099995, 82.64996979400007],
              [-76.36392167899993, 82.64586009300007],
              [-76.32852128799993, 82.64695872600004],
              [-76.28099524599992, 82.63511790600006],
              [-76.16673743399991, 82.63287995000007],
              [-75.96133378799993, 82.60040924700007],
              [-75.8938289049999, 82.59874095300006],
              [-75.9170222649999, 82.58690013200004],
              [-75.9429011709999, 82.57957591400003],
              [-75.99624589799993, 82.57078685100004],
              [-76.08031165299991, 82.54169342700004],
              [-76.1511531239999, 82.53143952000005],
              [-76.1929011709999, 82.51593659100007],
              [-76.23078365799995, 82.49388255400004],
              [-76.2637426419999, 82.46836985900006],
              [-76.2500707669999, 82.46836985900006],
              [-76.21833248599995, 82.45209381700005],
              [-76.17357337099992, 82.45600006700005],
              [-75.92080644399991, 82.52484772350005],
              [-75.6680395169999, 82.59369538000004],
              [-75.46149654899995, 82.60081614800004],
              [-75.4004207019999, 82.61920807500007],
              [-75.43997148299991, 82.63047923400006],
              [-75.77304033099992, 82.65928782750007],
              [-76.10610917899993, 82.68809642100007],
              [-76.10049394399994, 82.69159577000005],
              [-76.09732011599993, 82.69481028900003],
              [-76.09243730399993, 82.70115794500003],
              [-76.14639238199993, 82.70042552300004],
              [-76.21182206899994, 82.70836009300007],
              [-76.27236894399994, 82.72642649900007],
              [-76.3115535149999, 82.75641510600008],
              [-76.2307429679999, 82.77415599200003],
              [-76.05638587099992, 82.77024974200003],
              [-75.97573808499993, 82.79051341400003],
              [-76.37360592399995, 82.79051341400003],
              [-76.53962154899995, 82.82298411700003],
              [-76.66779537699995, 82.87986888200004],
              [-77.02751624249993, 82.93480052300004],
              [-77.38723710799991, 82.98973216400003],
              [-77.3635554679999, 83.00438060100004],
              [-77.33503170499995, 83.01325104400007],
              [-77.13402258999992, 83.03697337400007],
              [-77.14273027299993, 83.02952708500004],
              [-77.1526179679999, 83.02476634300007],
              [-77.1634008449999, 83.02265045800004],
              [-77.17495683499993, 83.02330149900007],
              [-77.13036048099991, 83.01060618700006],
              [-76.68346106699991, 83.02279287300007],
              [-76.23656165299991, 83.03497955900008],
              [-76.13548743399991, 83.05369700700004],
              [-75.78339596249992, 83.04690175950006],
              [-75.43130449099993, 83.04010651200008],
              [-75.38475501199991, 83.03172435100004],
              [-75.3020320299999, 83.03148021000004],
              [-75.29116777299993, 83.02948639500005],
              [-75.29051673099991, 83.02330149900007],
              [-75.1870417959999, 83.02313873900005],
              [-75.1533503899999, 83.03074778900003],
              [-75.16079667899993, 83.03074778900003],
              [-75.05687415299991, 83.04210032800006],
              [-74.62844804599993, 83.02212148650005],
              [-74.20002193899995, 83.00214264500005],
              [-74.05288652299993, 82.96369049700007],
              [-74.01626542899993, 82.96185944200005],
              [-74.02114824099993, 82.94965241100005],
              [-74.01561438699991, 82.94249095300006],
              [-74.00373287699995, 82.93980540600006],
              [-73.99575761599993, 82.93451569200005],
              [-73.97655188699991, 82.93492259300007],
              [-73.95759029899995, 82.93199290600006],
              [-73.90249589799993, 82.91343821800007],
              [-73.89004472599993, 82.90562571800007],
              [-73.86546790299991, 82.88609446800007],
              [-73.8283992179999, 82.86570872600004],
              [-73.41597788533323, 82.8108584656667],
              [-73.00355655266657, 82.75600820533337],
              [-72.5911352199999, 82.70115794500003],
              [-72.60521399599992, 82.70701732000003],
              [-72.6116023429999, 82.70860423400006],
              [-72.6116023429999, 82.71544017100007],
              [-72.5017390619999, 82.72162506700005],
              [-72.5017390619999, 82.72907135600008],
              [-72.80803382099992, 82.76028066600006],
              [-73.11432857999995, 82.79148997600004],
              [-73.32583574099993, 82.84385814000007],
              [-73.37295488199993, 82.84796784100007],
              [-73.35830644399994, 82.85875071800007],
              [-73.41934160099993, 82.89130280200004],
              [-73.45303300699993, 82.90269603100006],
              [-73.5716039699999, 82.91136302300004],
              [-73.65314693899995, 82.92711009300007],
              [-73.61978105399993, 82.94627513200004],
              [-73.5735164049999, 82.95917389500005],
              [-73.43606523299991, 82.97190989800004],
              [-73.2478328119999, 83.02073802300004],
              [-72.93268795499995, 83.04454173400006],
              [-72.88597571499992, 83.05805084800005],
              [-73.00885982999995, 83.05805084800005],
              [-72.97223873599995, 83.07298411700003],
              [-72.78799394399994, 83.08234284100007],
              [-72.70205644399994, 83.09654368700006],
              [-72.59162350199995, 83.10236237200007],
              [-72.57062740799995, 83.09959544500003],
              [-72.52253170499995, 83.08051178600005],
              [-72.5017390619999, 83.07786692900004],
              [-72.27383378799993, 83.10875071800007],
              [-71.95071367099993, 83.10604482600007],
              [-71.62759355399993, 83.10333893400008],
              [-71.58315995999993, 83.09214915600006],
              [-71.6282445949999, 83.08441803600005],
              [-71.76667232999995, 83.04246653900003],
              [-71.79605058499993, 83.02012767100007],
              [-71.76520748599995, 83.00165436400005],
              [-71.56948808499993, 82.96185944200005],
              [-71.57209225199995, 82.95868561400005],
              [-71.57420813699991, 82.95530833500004],
              [-71.57730058499993, 82.95176829600007],
              [-71.58315995999993, 82.94818756700005],
              [-71.21011308499993, 82.91714101750006],
              [-70.83706620999993, 82.88609446800007],
              [-70.86717688699991, 82.90509674700007],
              [-71.3088679679999, 82.98973216400003],
              [-71.45474199099993, 82.99961985900006],
              [-71.50121008999992, 83.00962962400007],
              [-71.48062089799993, 83.02240631700005],
              [-71.2690730459999, 83.06053294500003],
              [-71.1116023429999, 83.07029857000003],
              [-71.09032141799992, 83.07786692900004],
              [-71.10155188699991, 83.08055247600004],
              [-71.1116023429999, 83.08482493700006],
              [-71.11965898299991, 83.09113190300008],
              [-71.12441972599993, 83.09959544500003],
              [-71.01292883999992, 83.10154857000003],
              [-70.94570878799993, 83.08543528900003],
              [-70.90811113199993, 83.08177317900004],
              [-70.8704320949999, 83.08372630400004],
              [-70.83706620999993, 83.09214915600006],
              [-70.85033118399991, 83.09581126500007],
              [-70.8779597649999, 83.09983958500004],
              [-70.89167232999995, 83.09959544500003],
              [-70.8174128899999, 83.11107005400004],
              [-70.44078528566656, 83.11288754533338],
              [-70.06415768133324, 83.11470503666673],
              [-69.6875300769999, 83.11652252800008],
              [-69.6577449209999, 83.10521067900004],
              [-69.67756100199995, 83.10529205900008],
              [-69.69635982999995, 83.10297272300005],
              [-69.73346920499995, 83.09214915600006],
              [-69.71719316299993, 83.08576080900008],
              [-69.68260657499991, 83.08270905200004],
              [-69.66519120999993, 83.07786692900004],
              [-69.6926570299999, 83.07037995000007],
              [-69.7573542959999, 83.06346263200004],
              [-69.7744441399999, 83.05121491100005],
              [-69.6987605459999, 83.05121491100005],
              [-69.70189368399991, 83.04889557500007],
              [-69.67617753799993, 83.04503001500007],
              [-69.48338782499991, 83.04564036700003],
              [-69.45169023299991, 83.03697337400007],
              [-69.50300045499995, 83.03290436400005],
              [-69.6057429679999, 83.00596751500007],
              [-69.6577449209999, 83.00279368700006],
              [-69.61701412699995, 82.98993561400005],
              [-69.2143855459999, 83.01349518400008],
              [-69.03929602799991, 83.04576243700006],
              [-68.99990800699993, 83.04234446800007],
              [-68.9763484369999, 83.02647532800006],
              [-68.98615475199995, 82.99595774900007],
              [-68.95368404899995, 82.98314036700003],
              [-68.67943274599992, 82.98314036700003],
              [-68.6299128899999, 82.98973216400003],
              [-68.63613847599993, 82.98973216400003],
              [-68.53372148299991, 83.00962962400007],
              [-68.17178300699993, 82.99913157800006],
              [-68.14329993399991, 82.98973216400003],
              [-68.1675105459999, 82.97081126500007],
              [-68.19107011599993, 82.94818756700005],
              [-68.1318660149999, 82.93317291900007],
              [-68.0661921869999, 82.93980540600006],
              [-67.99958248599995, 82.95396556200006],
              [-67.59683183499993, 82.97117747600004],
              [-67.18024654899995, 82.93329498900005],
              [-67.11546790299991, 82.94818756700005],
              [-67.1179499989999, 82.95990631700005],
              [-67.09772701699995, 82.96356842700004],
              [-66.9372859369999, 82.95433177300004],
              [-66.96930904899995, 82.94078196800007],
              [-66.97891191299993, 82.93451569200005],
              [-66.89533443899995, 82.92540110900006],
              [-66.85244706899994, 82.92601146000004],
              [-66.78506425699993, 82.95836009300007],
              [-66.7400203119999, 82.95600006700005],
              [-66.65615800699993, 82.94135163000004],
              [-66.40286210799991, 82.94322337400007],
              [-66.36270097599993, 82.93370189000007],
              [-66.32119706899994, 82.93736399900007],
              [-66.2998347649999, 82.93451569200005],
              [-66.31810462099992, 82.92686595300006],
              [-66.38919023299991, 82.92088450700004],
              [-66.3779597649999, 82.91539134300007],
              [-66.36611894399994, 82.91148509300007],
              [-66.34146074099993, 82.90721263200004],
              [-66.36278235599991, 82.89411041900007],
              [-66.8069148429999, 82.83148834800005],
              [-66.8001195949999, 82.82465241100005],
              [-66.84626217399995, 82.81211985900006],
              [-67.15046139199995, 82.79266998900005],
              [-67.24665279899995, 82.77020905200004],
              [-67.48818925699993, 82.75926341400003],
              [-67.54010982999995, 82.75018952000005],
              [-67.59959876199991, 82.75226471600007],
              [-67.6797175769999, 82.73859284100007],
              [-67.78783118399991, 82.73729075700004],
              [-67.8684382799999, 82.72101471600007],
              [-68.14834550649991, 82.70290761950005],
              [-68.42825273299991, 82.68480052300004],
              [-68.48525956899994, 82.67027415600006],
              [-68.63727779899995, 82.65330638200004],
              [-68.67145748599995, 82.63971588700008],
              [-68.61770585799991, 82.63043854400007],
              [-68.22581946499992, 82.63977014100006],
              [-67.83393307199992, 82.64910173800006],
              [-67.44204667899993, 82.65843333500004],
              [-67.26235917899993, 82.69310130400004],
              [-67.14631100199995, 82.69786204600007],
              [-67.1023249989999, 82.71080149900007],
              [-66.8601374989999, 82.72418854400007],
              [-66.66763261599993, 82.71185944200005],
              [-66.63565019399994, 82.72162506700005],
              [-66.6452937489999, 82.72654857000003],
              [-66.6555476549999, 82.72935618700006],
              [-66.66616777299993, 82.73021067900004],
              [-66.67723548099991, 82.72907135600008],
              [-66.66022701699995, 82.74803294500003],
              [-66.62946529899995, 82.75828685100004],
              [-66.24052893799993, 82.80031972850006],
              [-65.8515925769999, 82.84235260600008],
              [-65.49250240799995, 82.84308502800008],
              [-65.45693925699993, 82.83148834800005],
              [-65.4734187489999, 82.82261790600006],
              [-65.52586829299992, 82.80357493700006],
              [-65.49282792899993, 82.78534577000005],
              [-65.4448542959999, 82.77745189000007],
              [-65.1553035149999, 82.77000560100004],
              [-65.2031550769999, 82.78306712400007],
              [-65.30728105399993, 82.78819407800006],
              [-65.3545222649999, 82.80357493700006],
              [-65.32111568899995, 82.80857982000003],
              [-65.1946101549999, 82.84699127800008],
              [-65.16445878799993, 82.85101959800005],
              [-65.10065670499995, 82.85199616100005],
              [-65.1448054679999, 82.86676666900007],
              [-65.25763912699995, 82.86326732000003],
              [-65.30614173099991, 82.87242259300007],
              [-65.27611243399991, 82.87872955900008],
              [-65.20169023299991, 82.88104889500005],
              [-65.13239498599995, 82.89940013200004],
              [-64.69668535099993, 82.90977610900006],
              [-64.65566972599993, 82.90037669500003],
              [-64.68081620999993, 82.88523997600004],
              [-64.71524003799993, 82.87950267100007],
              [-64.90314693899995, 82.88287995000007],
              [-64.9367976549999, 82.87242259300007],
              [-64.8865046869999, 82.86009349200003],
              [-64.7102758449999, 82.85875071800007],
              [-64.71914628799993, 82.84979889500005],
              [-64.7512507799999, 82.83148834800005],
              [-64.71019446499992, 82.81480540600006],
              [-64.57681230399993, 82.79425690300008],
              [-64.4890437489999, 82.76756419500003],
              [-64.4429011709999, 82.76048411700003],
              [-64.40241451699995, 82.77000560100004],
              [-64.40729732999995, 82.77313873900005],
              [-64.41673743399991, 82.78082916900007],
              [-64.42227128799993, 82.78367747600004],
              [-64.39305579299992, 82.79222239800004],
              [-64.32843990799995, 82.79083893400008],
              [-64.1362605459999, 82.83738841400003],
              [-63.791676398999925, 82.83205801000005],
              [-63.44709225199995, 82.82672760600008],
              [-63.40802975199995, 82.81822337400007],
              [-63.38076738199993, 82.80357493700006],
              [-63.389881964999915, 82.79588450700004],
              [-63.392608201999906, 82.78742096600007],
              [-63.38939368399991, 82.77855052300004],
              [-63.38076738199993, 82.77000560100004],
              [-63.43399003799993, 82.75145091400003],
              [-63.4900203119999, 82.74103424700007],
              [-63.8530574209999, 82.72162506700005],
              [-63.65151933499993, 82.71775950700004],
              [-63.57681230399993, 82.70246002800008],
              [-63.5384008449999, 82.70115794500003],
              [-63.543853318999936, 82.69651927300004],
              [-63.553618943999936, 82.68541087400007],
              [-63.5588679679999, 82.68065013200004],
              [-63.5393367179999, 82.67576732000003],
              [-63.483184373999904, 82.68065013200004],
              [-63.46442623599995, 82.67877838700008],
              [-63.43215898299991, 82.66917552300004],
              [-63.32168535099993, 82.66229889500005],
              [-63.22988847599993, 82.64655182500007],
              [-63.262481248999904, 82.62938060100004],
              [-63.30203202999991, 82.62364329600007],
              [-63.38076738199993, 82.62535228100006],
              [-63.3706355459999, 82.61176178600005],
              [-62.9626765619999, 82.59349192900004],
              [-62.92825273299991, 82.57078685100004],
              [-62.959868943999936, 82.56981028900003],
              [-63.00072180899991, 82.56358470300006],
              [-63.03958085799991, 82.55255768400008],
              [-63.0654597649999, 82.53729889500005],
              [-63.0666804679999, 82.53013743700006],
              [-63.06265214799993, 82.52326080900008],
              [-63.06159420499995, 82.51557038000004],
              [-63.08242753799993, 82.49766673400006],
              [-63.08967037699995, 82.48899974200003],
              [-63.10024980399993, 82.48289622600004],
              [-63.12067623599995, 82.48204173400006],
              [-63.12067623599995, 82.47581614800004],
              [-63.09333248599995, 82.47581614800004],
              [-63.09333248599995, 82.46836985900006],
              [-63.309478318999936, 82.46092357000003],
              [-63.34695390499991, 82.45514557500007],
              [-63.3733210929999, 82.44102610900006],
              [-63.03498287699995, 82.45673248900005],
              [-62.98973548099991, 82.46836985900006],
              [-62.9013972649999, 82.51146067900004],
              [-62.869903123999904, 82.51679108300004],
              [-62.841053839999915, 82.51817454600007],
              [-62.83267167899993, 82.51679108300004],
              [-62.82770748599995, 82.51264069200005],
              [-62.82437089799993, 82.50071849200003],
              [-62.81961015499991, 82.49632396000004],
              [-62.797759568999936, 82.49009837400007],
              [-62.72903398299991, 82.48887767100007],
              [-62.73574785099993, 82.49705638200004],
              [-62.743804490999935, 82.50299713700008],
              [-62.7532445949999, 82.50726959800005],
              [-62.76439368399991, 82.50995514500005],
              [-62.7392878899999, 82.52342357000003],
              [-62.45700029199992, 82.52663808800006],
              [-62.174712693999936, 82.52985260600008],
              [-62.174712693999936, 82.52362702000005],
              [-62.30117753799993, 82.52122630400004],
              [-62.3318171869999, 82.50995514500005],
              [-62.32559160099993, 82.50250885600008],
              [-62.33478756399995, 82.49827708500004],
              [-62.34170488199993, 82.49351634300007],
              [-62.35228430899991, 82.48204173400006],
              [-62.25739498599995, 82.48969147300005],
              [-62.23684648299991, 82.50250885600008],
              [-62.24315344999991, 82.50401439000007],
              [-62.25731360599991, 82.50995514500005],
              [-62.09902910099993, 82.50995514500005],
              [-62.101592576999906, 82.50617096600007],
              [-62.10586503799993, 82.49632396000004],
              [-61.84237626849992, 82.49260081550005],
              [-61.578887498999904, 82.48887767100007],
              [-61.57022050699993, 82.48509349200003],
              [-61.34121660099993, 82.45018138200004],
              [-61.1369929679999, 82.38231028900003],
              [-61.10570227799991, 82.36143626500007],
              [-61.0854792959999, 82.33116282800006],
            ],
          ],
          [
            [
              [-79.84137936099995, 53.145738023000035],
              [-79.80532792899993, 53.12612539300005],
              [-79.79918372299994, 53.12189362200007],
              [-79.79686438699991, 53.111314195000034],
              [-79.79369055899991, 53.10797760600008],
              [-79.79507402299993, 53.10541413000004],
              [-79.80663001199991, 53.097357489000046],
              [-79.81810462099992, 53.09170156500005],
              [-79.83364824099993, 53.087103583000044],
              [-79.84935462099992, 53.085150458000044],
              [-79.88776607999995, 53.09210846600007],
              [-79.91209876199991, 53.08893463700008],
              [-79.92983964799993, 53.09438711100006],
              [-79.9363500639999, 53.12531159100007],
              [-79.93089758999992, 53.14948151200008],
              [-79.91657467399995, 53.17031484600005],
              [-79.89492753799993, 53.18065013200004],
              [-79.85529537699995, 53.16937897300005],
              [-79.84972083199995, 53.162095445000034],
              [-79.84666907499991, 53.153631903000075],
              [-79.84137936099995, 53.145738023000035],
            ],
          ],
          [
            [
              [-79.9500219389999, 53.35179271000004],
              [-79.95669511599993, 53.32306549700007],
              [-79.91734778599994, 53.29743073100008],
              [-79.92332923099991, 53.275458075000074],
              [-79.94713294199994, 53.26593659100007],
              [-79.98420162699995, 53.26512278900003],
              [-80.01821855399993, 53.27374909100007],
              [-80.04605058499993, 53.30927155200004],
              [-80.07079016799992, 53.31850820500006],
              [-80.08604895699995, 53.33038971600007],
              [-80.07070878799993, 53.35492584800005],
              [-80.04279537699995, 53.36619700700004],
              [-79.97183183499993, 53.36542389500005],
              [-79.94375566299993, 53.37164948100008],
              [-79.94790605399993, 53.36664459800005],
              [-79.94888261599993, 53.36212799700007],
              [-79.94884192599994, 53.357489325000074],
              [-79.9500219389999, 53.35179271000004],
            ],
          ],
          [
            [
              [-79.86188717399995, 53.91290924700007],
              [-79.86632239499994, 53.91266510600008],
              [-79.86900794199994, 53.91095612200007],
              [-79.87140865799995, 53.90843333500004],
              [-79.87486731699994, 53.90615469000005],
              [-79.90689042899993, 53.91771067900004],
              [-79.92023678299995, 53.92625560100004],
              [-79.93008378799993, 53.94086334800005],
              [-79.91331946499992, 53.938381252000056],
              [-79.86188717399995, 53.920355536000045],
              [-79.86188717399995, 53.91290924700007],
            ],
          ],
          [
            [
              [-79.97793535099993, 56.202053127000056],
              [-80.03286699099993, 56.189886786000045],
              [-80.06383216099994, 56.18744538000004],
              [-80.08775794199994, 56.191473700000074],
              [-80.10187740799995, 56.19757721600007],
              [-80.10496985599991, 56.200506903000075],
              [-80.10277258999992, 56.20579661700003],
              [-80.10016842399995, 56.23338450700004],
              [-80.09797115799995, 56.239935614000046],
              [-80.06004798099991, 56.27179596600007],
              [-80.05239824099993, 56.28367747600004],
              [-80.0598852199999, 56.29824453300006],
              [-80.0598852199999, 56.30442942900004],
              [-80.03099524599992, 56.31972890800006],
              [-80.00031490799995, 56.325873114000046],
              [-79.89134680899991, 56.329413153000075],
              [-79.87173417899993, 56.33551666900007],
              [-79.86188717399995, 56.345404364000046],
              [-79.86363684799994, 56.354803778000075],
              [-79.87816321499992, 56.368353583000044],
              [-79.88170325399994, 56.37677643400008],
              [-79.8770238919999, 56.381293036000045],
              [-79.86742102799991, 56.38548411700003],
              [-79.86001542899993, 56.38617584800005],
              [-79.83189856699994, 56.37921784100007],
              [-79.77481035099993, 56.36733633000006],
              [-79.74453691299993, 56.36591217700004],
              [-79.72891191299993, 56.368841864000046],
              [-79.69994055899991, 56.378159898000035],
              [-79.6868383449999, 56.380194403000075],
              [-79.67442786399994, 56.38450755400004],
              [-79.65412350199995, 56.40375397300005],
              [-79.63243567599994, 56.415716864000046],
              [-79.61522376199991, 56.43378327000005],
              [-79.60020911399994, 56.45522695500006],
              [-79.59373938699991, 56.472642320000034],
              [-79.58897864499994, 56.494208075000074],
              [-79.57705644399994, 56.51015859600005],
              [-79.56159420499995, 56.52167389500005],
              [-79.54588782499991, 56.53034088700008],
              [-79.54605058499993, 56.52187734600005],
              [-79.54869544199994, 56.51508209800005],
              [-79.55345618399991, 56.50922272300005],
              [-79.56017005099994, 56.50364817900004],
              [-79.56997636599993, 56.46938711100006],
              [-79.59260006399995, 56.430121161000045],
              [-79.64216061099995, 56.36591217700004],
              [-79.67878170499995, 56.331284898000035],
              [-79.71572831899994, 56.30914948100008],
              [-79.97793535099993, 56.202053127000056],
            ],
          ],
          [
            [
              [-79.59373938699991, 56.771185614000046],
              [-79.58018958199995, 56.776678778000075],
              [-79.57384192599994, 56.777411200000074],
              [-79.57384192599994, 56.784857489000046],
              [-79.5833227199999, 56.789129950000074],
              [-79.58739173099991, 56.79531484600005],
              [-79.58641516799992, 56.80304596600007],
              [-79.58067786399994, 56.812201239000046],
              [-79.57335364499994, 56.81818268400008],
              [-79.56916256399995, 56.816107489000046],
              [-79.56554114499994, 56.81028880400004],
              [-79.56017005099994, 56.80536530200004],
              [-79.55980383999992, 56.80292389500005],
              [-79.55337480399993, 56.78790924700007],
              [-79.55089270699995, 56.78473541900007],
              [-79.54503333199995, 56.78457265800006],
              [-79.53819739499994, 56.78534577000005],
              [-79.52550208199995, 56.784409898000035],
              [-79.51781165299991, 56.78607819200005],
              [-79.51065019399994, 56.78367747600004],
              [-79.50499426999994, 56.771185614000046],
              [-79.50487219999991, 56.77558014500005],
              [-79.50340735599991, 56.77643463700008],
              [-79.50108801999994, 56.774644273000035],
              [-79.49815833199995, 56.771185614000046],
              [-79.48326575399994, 56.739447333000044],
              [-79.48033606699994, 56.72321198100008],
              [-79.49132239499994, 56.71596914300005],
              [-79.48131262899994, 56.704779364000046],
              [-79.47996985599991, 56.69513580900008],
              [-79.48770097599993, 56.66364166900007],
              [-79.49559485599991, 56.661444403000075],
              [-79.51549231699994, 56.66754791900007],
              [-79.53197180899991, 56.65607330900008],
              [-79.54857337099992, 56.634100653000075],
              [-79.56493079299992, 56.62055084800005],
              [-79.58067786399994, 56.633978583000044],
              [-79.5833227199999, 56.648871161000045],
              [-79.57787024599992, 56.65778229400007],
              [-79.57030188699991, 56.664129950000074],
              [-79.56411699099993, 56.67527903900003],
              [-79.55589758999992, 56.70156484600005],
              [-79.55679277299993, 56.70538971600007],
              [-79.54759680899991, 56.72752513200004],
              [-79.56041419199994, 56.747259833000044],
              [-79.59373938699991, 56.771185614000046],
            ],
          ],
          [
            [
              [-79.90282141799992, 56.89411041900007],
              [-79.8958227199999, 56.90371328300006],
              [-79.87535559799994, 56.92279694200005],
              [-79.85879472599993, 56.93496328300006],
              [-79.85147050699993, 56.938788153000075],
              [-79.84227454299992, 56.93732330900008],
              [-79.82705644399994, 56.928168036000045],
              [-79.8191625639999, 56.94188060100004],
              [-79.80728105399993, 56.95062897300005],
              [-79.79503333199995, 56.951605536000045],
              [-79.78612219999991, 56.94188060100004],
              [-79.76598059799994, 56.92601146000004],
              [-79.75621497299994, 56.916449286000045],
              [-79.7520238919999, 56.903998114000046],
              [-79.74962317599994, 56.89158763200004],
              [-79.73151607999995, 56.85309479400007],
              [-79.72370357999995, 56.820746161000045],
              [-79.73086503799993, 56.80190664300005],
              [-79.75121008999992, 56.79319896000004],
              [-79.78307044199994, 56.791083075000074],
              [-79.79076087099992, 56.796087958000044],
              [-79.7910863919999, 56.80744049700007],
              [-79.78612219999991, 56.825832424000055],
              [-79.78815670499995, 56.83685944200005],
              [-79.79710852799991, 56.86473216400003],
              [-79.79918372299994, 56.87641022300005],
              [-79.81248938699991, 56.89667389500005],
              [-79.87816321499992, 56.88495514500005],
              [-79.90282141799992, 56.89411041900007],
            ],
          ],
          [
            [
              [-79.79295813699991, 57.42853424700007],
              [-79.80776933499993, 57.43353913000004],
              [-79.82884680899991, 57.45221588700008],
              [-79.84654700399994, 57.47345612200007],
              [-79.85098222599993, 57.48651764500005],
              [-79.83849036399994, 57.48932526200008],
              [-79.82388261599993, 57.48517487200007],
              [-79.81167558499993, 57.485256252000056],
              [-79.80247962099992, 57.51162344000005],
              [-79.79328365799995, 57.51776764500005],
              [-79.78404700399994, 57.52212148600006],
              [-79.77993730399993, 57.527777411000045],
              [-79.78473873599995, 57.53778717700004],
              [-79.79580644399994, 57.53534577000005],
              [-79.8172094389999, 57.52411530200004],
              [-79.82823645699995, 57.52875397300005],
              [-79.82567298099991, 57.539048570000034],
              [-79.81346594999991, 57.55548737200007],
              [-79.80687415299991, 57.56928131700005],
              [-79.7910863919999, 57.586371161000045],
              [-79.77183997299994, 57.60101959800005],
              [-79.75511633999992, 57.60732656500005],
              [-79.74990800699993, 57.610988674000055],
              [-79.7442113919999, 57.61786530200004],
              [-79.73717200399994, 57.62201569200005],
              [-79.72809811099995, 57.617173570000034],
              [-79.72134355399993, 57.60761139500005],
              [-79.71275794199994, 57.589056708000044],
              [-79.70132402299993, 57.57330963700008],
              [-79.69611568899995, 57.55231354400007],
              [-79.69640051999994, 57.52948639500005],
              [-79.70360266799992, 57.511053778000075],
              [-79.72276770699995, 57.50189850500004],
              [-79.76109778599994, 57.52045319200005],
              [-79.77993730399993, 57.511053778000075],
              [-79.78416907499991, 57.493353583000044],
              [-79.7844945949999, 57.44432200700004],
              [-79.79295813699991, 57.42853424700007],
            ],
          ],
          [
            [
              [-80.4707738919999, 59.49103424700007],
              [-80.47594153599994, 59.48261139500005],
              [-80.47630774599992, 59.47842031500005],
              [-80.47240149599992, 59.47540924700007],
              [-80.46450761599993, 59.47060781500005],
              [-80.46715247299994, 59.46466705900008],
              [-80.47008216099994, 59.461004950000074],
              [-80.47370357999995, 59.45880768400008],
              [-80.47817949099993, 59.45697663000004],
              [-80.4876195949999, 59.44208405200004],
              [-80.51378333199995, 59.41034577000005],
              [-80.51915442599994, 59.39203522300005],
              [-80.52721106699994, 59.37539297100005],
              [-80.54222571499992, 59.37132396000004],
              [-80.55089270699995, 59.38178131700005],
              [-80.53966223899994, 59.40851471600007],
              [-80.54710852799991, 59.40851471600007],
              [-80.52358964799993, 59.434881903000075],
              [-80.51915442599994, 59.44383372600004],
              [-80.52916419199994, 59.443345445000034],
              [-80.53750566299993, 59.444525458000044],
              [-80.55329342399995, 59.450100002000056],
              [-80.49120032499991, 59.48476797100005],
              [-80.4707738919999, 59.49103424700007],
            ],
          ],
          [
            [
              [-80.22496497299994, 59.73126862200007],
              [-80.21076412699995, 59.721909898000035],
              [-80.16832434799994, 59.716009833000044],
              [-80.1492406889999, 59.710150458000044],
              [-80.15623938699991, 59.70270416900007],
              [-80.15925045499995, 59.69757721600007],
              [-80.15892493399991, 59.69188060100004],
              [-80.15607662699995, 59.682847398000035],
              [-80.16055253799993, 59.682806708000044],
              [-80.16356360599991, 59.68138255400004],
              [-80.16974850199995, 59.676662502000056],
              [-80.20555579299992, 59.668036200000074],
              [-80.22093665299991, 59.662543036000045],
              [-80.23493404899995, 59.652411200000074],
              [-80.23888098899994, 59.64752838700008],
              [-80.24852454299992, 59.63198476800005],
              [-80.25617428299995, 59.62669505400004],
              [-80.26610266799992, 59.62409088700008],
              [-80.2864477199999, 59.62140534100007],
              [-80.30650794199994, 59.61546458500004],
              [-80.31725012899994, 59.61359284100007],
              [-80.32738196499992, 59.614569403000075],
              [-80.34219316299993, 59.619574286000045],
              [-80.34300696499992, 59.62213776200008],
              [-80.33775794199994, 59.627020575000074],
              [-80.33421790299991, 59.63882070500006],
              [-80.32575436099995, 59.64838288000004],
              [-80.30874589799993, 59.65485260600008],
              [-80.29600989499994, 59.66266510600008],
              [-80.30003821499992, 59.676662502000056],
              [-80.28701738199993, 59.68183014500005],
              [-80.27399654899995, 59.68081289300005],
              [-80.26024329299992, 59.67767975500004],
              [-80.2454320949999, 59.676662502000056],
              [-80.2454320949999, 59.682847398000035],
              [-80.24941972599993, 59.68573639500005],
              [-80.25438391799992, 59.69232819200005],
              [-80.2591039699999, 59.69717031500005],
              [-80.24860592399995, 59.70221588700008],
              [-80.24071204299992, 59.710272528000075],
              [-80.23509680899991, 59.720363674000055],
              [-80.23180091099994, 59.73126862200007],
              [-80.22712154899995, 59.725775458000044],
              [-80.22533118399991, 59.72638580900008],
              [-80.22496497299994, 59.73126862200007],
            ],
          ],
          [
            [
              [-80.10826575399994, 59.76479726800005],
              [-80.0996801419999, 59.77606842700004],
              [-80.08145097599993, 59.789129950000074],
              [-80.07315019399994, 59.802069403000075],
              [-80.09459387899994, 59.81317780200004],
              [-80.09898841099994, 59.80174388200004],
              [-80.10643469999991, 59.79604726800005],
              [-80.11571204299992, 59.79120514500005],
              [-80.12564042899993, 59.78278229400007],
              [-80.13198808499993, 59.77948639500005],
              [-80.13980058499993, 59.77846914300005],
              [-80.14647376199991, 59.77606842700004],
              [-80.1492406889999, 59.76850006700005],
              [-80.14915930899991, 59.759833075000074],
              [-80.15025794199994, 59.75226471600007],
              [-80.15416419199994, 59.746975002000056],
              [-80.1629125639999, 59.74494049700007],
              [-80.17983964799993, 59.74876536700003],
              [-80.17992102799991, 59.75812409100007],
              [-80.12877356699994, 59.827460028000075],
              [-80.10997473899994, 59.844183661000045],
              [-80.09748287699995, 59.851263739000046],
              [-80.06696529899995, 59.85854726800005],
              [-80.04295813699991, 59.87775299700007],
              [-80.02940833199995, 59.882066148000035],
              [-80.02367102799991, 59.88320547100005],
              [-80.01231848899994, 59.887884833000044],
              [-80.00523841099994, 59.88890208500004],
              [-80.00047766799992, 59.885931708000044],
              [-79.99233964799993, 59.872259833000044],
              [-79.98473059799994, 59.868475653000075],
              [-79.9746801419999, 59.87164948100008],
              [-79.96263587099992, 59.87848541900007],
              [-79.94790605399993, 59.88190338700008],
              [-79.93008378799993, 59.874660549000055],
              [-79.92064368399991, 59.86692942900004],
              [-79.90977942599994, 59.86204661700003],
              [-79.89688066299993, 59.86005280200004],
              [-79.88170325399994, 59.861029364000046],
              [-79.8926488919999, 59.846136786000045],
              [-79.90550696499992, 59.833644924000055],
              [-79.9363500639999, 59.81317780200004],
              [-79.95787512899994, 59.803941148000035],
              [-79.96996008999992, 59.800767320000034],
              [-79.98131262899994, 59.79954661700003],
              [-79.98985755099994, 59.79588450700004],
              [-80.01891028599994, 59.77220286700003],
              [-80.06663977799991, 59.76007721600007],
              [-80.09410559799994, 59.75812409100007],
              [-80.10826575399994, 59.76479726800005],
            ],
          ],
          [
            [
              [-65.60777747299994, 43.48346588700008],
              [-65.61705481699994, 43.507879950000074],
              [-65.60521399599992, 43.514105536000045],
              [-65.55992591099994, 43.51080963700008],
              [-65.56867428299995, 43.494574286000045],
              [-65.57420813699991, 43.47671133000006],
              [-65.58714758999992, 43.46352773600006],
              [-65.59797115799995, 43.44472890800006],
              [-65.61058508999992, 43.428168036000045],
              [-65.62881425699993, 43.42206452000005],
              [-65.62140865799995, 43.43504466400009],
              [-65.62694251199991, 43.44513580900008],
              [-65.63536536399994, 43.453192450000074],
              [-65.64541581899994, 43.45917389500005],
              [-65.65611731699994, 43.46303945500006],
              [-65.64631100199995, 43.47174713700008],
              [-65.63451087099992, 43.47675202000005],
              [-65.60777747299994, 43.48346588700008],
            ],
          ],
          [
            [
              [-59.793511003999924, 43.96457099300005],
              [-59.74082906199993, 43.996438294000086],
              [-59.707183922999945, 44.014416262000054],
              [-59.75711863399994, 43.96606364000007],
              [-59.808161700999904, 43.940226333000055],
              [-59.85837099799994, 43.92359832900007],
              [-59.90777975099991, 43.91617457400008],
              [-59.963220056999944, 43.914068721000035],
              [-60.01875791999993, 43.913771298000086],
              [-60.07511849499991, 43.92722222900005],
              [-60.116953500999955, 43.94293903700009],
              [-60.13016059599994, 43.96047286800007],
              [-60.11795309699994, 43.95947495300004],
              [-60.10486024399995, 43.95436180200005],
              [-60.091159975999915, 43.94972750100004],
              [-60.073882615999935, 43.94245026200008],
              [-59.99781365699994, 43.937867735000054],
              [-59.87154968099992, 43.94207755800005],
              [-59.840664456999946, 43.94987449800004],
              [-59.81980052199992, 43.954155950000086],
              [-59.793511003999924, 43.96457099300005],
            ],
          ],
          [
            [
              [-66.23155676999994, 44.38719310100004],
              [-66.21300208199995, 44.395819403000075],
              [-66.20343990799995, 44.392238674000055],
              [-66.20445716099994, 44.38117096600007],
              [-66.21788489499994, 44.36737702000005],
              [-66.23867753799993, 44.33836497600004],
              [-66.2981664699999, 44.283270575000074],
              [-66.31346594999991, 44.25067780200004],
              [-66.32774817599994, 44.25812409100007],
              [-66.28579667899993, 44.32477448100008],
              [-66.25788326699995, 44.35464101800005],
              [-66.24176998599995, 44.377386786000045],
              [-66.23155676999994, 44.38719310100004],
            ],
          ],
          [
            [
              [-66.86148027299993, 44.72675202000005],
              [-66.85114498599995, 44.75470612200007],
              [-66.82575436099995, 44.78758372600004],
              [-66.79128873799993, 44.799104088000036],
              [-66.76945305999993, 44.79565700400008],
              [-66.75680085999994, 44.77756250900006],
              [-66.74315992899994, 44.78204731400007],
              [-66.73246554299993, 44.76882355500004],
              [-66.73549067599993, 44.75908336400005],
              [-66.75289549299993, 44.76385456500009],
              [-66.76148639199994, 44.754529636000086],
              [-66.75332843099994, 44.74176134000004],
              [-66.73863684799994, 44.710638739000046],
              [-66.72810612499995, 44.68353545800005],
              [-66.72113448199991, 44.66277926100008],
              [-66.70799804199993, 44.65133403700008],
              [-66.6917839699999, 44.64299154100007],
              [-66.6873421059999, 44.62885725000007],
              [-66.69039124999995, 44.62000171900007],
              [-66.7089870129999, 44.61374149800008],
              [-66.7283134029999, 44.622952231000056],
              [-66.73279134599994, 44.64106765400004],
              [-66.74282881699992, 44.653408443000046],
              [-66.75405138699995, 44.65734203300008],
              [-66.76770142499993, 44.65330482400009],
              [-66.7832824859999, 44.66120486500006],
              [-66.79817285999991, 44.659375028000056],
              [-66.8099365299999, 44.651801747000036],
              [-66.83909087599994, 44.65035119400005],
              [-66.85838782499991, 44.638006903000075],
              [-66.86701412699995, 44.629787502000056],
              [-66.876141, 44.606331030000035],
              [-66.89029089699994, 44.60275711200006],
              [-66.90598585599992, 44.60616917900006],
              [-66.90143795499995, 44.630113023000035],
              [-66.89134680899991, 44.655585028000075],
              [-66.88459225199995, 44.68891022300005],
              [-66.86579342399995, 44.71124909100007],
              [-66.86148027299993, 44.72675202000005],
            ],
          ],
          [
            [
              [-73.99518795499995, 45.32013580900008],
              [-73.98729407499991, 45.32469310100004],
              [-73.98330644399994, 45.326239325000074],
              [-73.92064368399991, 45.33380768400008],
              [-73.92186438699991, 45.327337958000044],
              [-73.92467200399994, 45.321966864000046],
              [-73.92886308499993, 45.31720612200007],
              [-73.93431555899991, 45.31268952000005],
              [-73.93805904899995, 45.310248114000046],
              [-73.94831295499995, 45.302069403000075],
              [-73.96865800699993, 45.28986237200007],
              [-73.9837133449999, 45.277044989000046],
              [-73.99327551999994, 45.27212148600006],
              [-74.00300045499995, 45.26870351800005],
              [-74.02871660099993, 45.264105536000045],
              [-74.04784094999991, 45.25763580900008],
              [-74.08104407499991, 45.25275299700007],
              [-74.13939368399991, 45.251166083000044],
              [-74.1465551419999, 45.25259023600006],
              [-74.15318762899994, 45.25560130400004],
              [-74.15868079299992, 45.26007721600007],
              [-74.16502844999991, 45.26972077000005],
              [-74.16624915299991, 45.27912018400008],
              [-74.16258704299992, 45.28778717700004],
              [-74.15420488199993, 45.29511139500005],
              [-74.14171301999994, 45.30219147300005],
              [-74.12840735599991, 45.30756256700005],
              [-74.12108313699991, 45.30906810100004],
              [-74.04356848899994, 45.30565013200004],
              [-74.03233801999994, 45.30719635600008],
              [-74.00121008999992, 45.31671784100007],
              [-73.99518795499995, 45.32013580900008],
            ],
          ],
          [
            [
              [-73.88902747299994, 45.39671458500004],
              [-73.87584387899994, 45.39398834800005],
              [-73.86241614499994, 45.38959381700005],
              [-73.85806230399993, 45.38890208500004],
              [-73.85789954299992, 45.38532135600008],
              [-73.85806230399993, 45.38178131700005],
              [-73.87189693899995, 45.38076406500005],
              [-73.87840735599991, 45.37921784100007],
              [-73.90070553299995, 45.36888255400004],
              [-73.90636145699995, 45.36733633000006],
              [-73.91478430899991, 45.36619700700004],
              [-73.93163001199991, 45.366888739000046],
              [-73.94847571499992, 45.36969635600008],
              [-73.95107988199993, 45.370794989000046],
              [-73.95335852799991, 45.37262604400007],
              [-73.95933997299994, 45.37909577000005],
              [-73.97520911399994, 45.39126211100006],
              [-73.98135331899994, 45.398504950000074],
              [-73.98452714799993, 45.40639883000006],
              [-73.98135331899994, 45.413397528000075],
              [-73.97911536399994, 45.41469961100006],
              [-73.97667395699995, 45.415350653000075],
              [-73.97398841099994, 45.41547272300005],
              [-73.9173070949999, 45.40997955900008],
              [-73.90729732999995, 45.40692780200004],
              [-73.90282141799992, 45.40477122600004],
              [-73.89289303299995, 45.39834219000005],
              [-73.88902747299994, 45.39671458500004],
            ],
          ],
          [
            [
              [-73.93179277299993, 45.48883698100008],
              [-73.93651282499991, 45.48965078300006],
              [-73.94098873599995, 45.491400458000044],
              [-73.94473222599993, 45.494208075000074],
              [-73.9473363919999, 45.49823639500005],
              [-73.94692949099993, 45.503241278000075],
              [-73.94318600199995, 45.50755442900004],
              [-73.93809973899994, 45.510931708000044],
              [-73.93382727799991, 45.513006903000075],
              [-73.89631100199995, 45.52448151200008],
              [-73.89102128799993, 45.52496979400007],
              [-73.88646399599992, 45.52338288000004],
              [-73.88512122299994, 45.51239655200004],
              [-73.89928137899994, 45.50092194200005],
              [-73.91832434799994, 45.49209219000005],
              [-73.93179277299993, 45.48883698100008],
            ],
          ],
          [
            [
              [-60.914133266999954, 45.56655508000006],
              [-60.90807044199994, 45.577378648000035],
              [-60.899281378999945, 45.57868073100008],
              [-60.889230923999946, 45.573919989000046],
              [-60.87930253799993, 45.56655508000006],
              [-60.88426673099991, 45.55760325700004],
              [-60.89220130099994, 45.552801825000074],
              [-60.902414516999954, 45.55145905200004],
              [-60.914133266999954, 45.55288320500006],
              [-60.95262610599991, 45.53164297100005],
              [-60.961822068999936, 45.517279364000046],
              [-60.94762122299994, 45.49823639500005],
              [-60.96784420499995, 45.48680247600004],
              [-60.98570716099994, 45.47016022300005],
              [-61.00352942599994, 45.46076080900008],
              [-61.02391516799992, 45.47089264500005],
              [-61.01305091099994, 45.476629950000074],
              [-61.003895636999914, 45.48582591400009],
              [-61.00210527299993, 45.49445221600007],
              [-61.01309160099993, 45.49823639500005],
              [-61.04002844999991, 45.49872467700004],
              [-61.052805141999954, 45.50055573100008],
              [-61.06493079299992, 45.50446198100008],
              [-61.07518469999991, 45.510931708000044],
              [-61.08934485599991, 45.52334219000005],
              [-61.10509192599994, 45.52708567900004],
              [-61.10610917899993, 45.53099192900004],
              [-61.10606848899994, 45.536444403000075],
              [-61.11172441299993, 45.54877350500004],
              [-61.10582434799994, 45.55133698100008],
              [-61.09162350199995, 45.55288320500006],
              [-61.07502193899995, 45.56273021000004],
              [-61.05386308499993, 45.57111237200007],
              [-61.03111731699994, 45.577337958000044],
              [-61.00967363199993, 45.58079661700003],
              [-60.95856686099995, 45.58144765800006],
              [-60.93195553299995, 45.57684967700004],
              [-60.914133266999954, 45.56655508000006],
            ],
          ],
          [
            [
              [-73.85728919199994, 45.54938385600008],
              [-73.86489824099993, 45.554388739000046],
              [-73.86644446499992, 45.56077708500004],
              [-73.86351477799991, 45.56785716400009],
              [-73.84862219999991, 45.58413320500006],
              [-73.82770748599995, 45.601223049000055],
              [-73.8059789699999, 45.61310455900008],
              [-73.75894120999993, 45.65253327000005],
              [-73.74087480399993, 45.66425202000005],
              [-73.71776282499991, 45.675848700000074],
              [-73.67613684799994, 45.69049713700008],
              [-73.66616777299993, 45.69220612200007],
              [-73.65925045499995, 45.69171784100007],
              [-73.64557857999995, 45.68891022300005],
              [-73.63829505099994, 45.689113674000055],
              [-73.58535722599993, 45.70062897300005],
              [-73.57433020699995, 45.70164622600004],
              [-73.56484941299993, 45.69867584800005],
              [-73.5637914699999, 45.69232819200005],
              [-73.57286536399994, 45.68610260600008],
              [-73.5938207669999, 45.67792389500005],
              [-73.61294511599993, 45.66791413000004],
              [-73.63646399599992, 45.649318752000056],
              [-73.64207923099991, 45.64321523600006],
              [-73.64395097599993, 45.64008209800005],
              [-73.64830481699994, 45.63068268400008],
              [-73.68455969999991, 45.58746979400007],
              [-73.70620683499993, 45.56948476800005],
              [-73.71833248599995, 45.56244538000004],
              [-73.73135331899994, 45.55695221600007],
              [-73.74722245999993, 45.552435614000046],
              [-73.77993730399993, 45.54710521000004],
              [-73.84268144399994, 45.54584381700005],
              [-73.85728919199994, 45.54938385600008],
            ],
          ],
          [
            [
              [-73.49925696499992, 45.70994700700004],
              [-73.47956295499995, 45.71442291900007],
              [-73.47061113199993, 45.71328359600005],
              [-73.46898352799991, 45.70555247600004],
              [-73.47647050699993, 45.68927643400008],
              [-73.47940019399994, 45.67829010600008],
              [-73.49958248599995, 45.62677643400008],
              [-73.50157630099994, 45.60895416900007],
              [-73.50405839799993, 45.60040924700007],
              [-73.50694739499994, 45.595689195000034],
              [-73.52672278599994, 45.57640208500004],
              [-73.5325414699999, 45.567694403000075],
              [-73.53701738199993, 45.55817291900007],
              [-73.54063880099994, 45.54779694200005],
              [-73.54308020699995, 45.536444403000075],
              [-73.54369055899991, 45.52553945500006],
              [-73.5391332669999, 45.49266185100004],
              [-73.53941809799994, 45.48737213700008],
              [-73.54137122299994, 45.48261139500005],
              [-73.54474850199995, 45.47907135600008],
              [-73.54898027299993, 45.476629950000074],
              [-73.56786048099991, 45.46938711100006],
              [-73.57201087099992, 45.46662018400008],
              [-73.57579505099994, 45.46312083500004],
              [-73.58511308499993, 45.45140208500004],
              [-73.58873450399994, 45.44794342700004],
              [-73.59821529899995, 45.443060614000046],
              [-73.60855058499993, 45.44163646000004],
              [-73.6192113919999, 45.442572333000044],
              [-73.71690833199995, 45.464544989000046],
              [-73.79482988199993, 45.467230536000045],
              [-73.80064856699994, 45.46670156500005],
              [-73.81200110599991, 45.46385325700004],
              [-73.85041256399995, 45.448879299000055],
              [-73.92491614499994, 45.42999909100007],
              [-73.94322669199994, 45.43113841400009],
              [-73.95543372299994, 45.43024323100008],
              [-73.95856686099995, 45.430975653000075],
              [-73.96833248599995, 45.43707916900007],
              [-73.97008216099994, 45.43886953300006],
              [-73.97101803299995, 45.44025299700007],
              [-73.97248287699995, 45.44326406500005],
              [-73.97362219999991, 45.444647528000075],
              [-73.96226966099994, 45.448879299000055],
              [-73.89757239499994, 45.484035549000055],
              [-73.87498938699991, 45.49310944200005],
              [-73.87067623599995, 45.49632396000004],
              [-73.85484778599994, 45.51630280200004],
              [-73.84984290299991, 45.520738023000035],
              [-73.84373938699991, 45.522650458000044],
              [-73.82347571499992, 45.52252838700008],
              [-73.80284583199995, 45.52570221600007],
              [-73.79702714799993, 45.52558014500005],
              [-73.78600012899994, 45.52415599200003],
              [-73.78018144399994, 45.524318752000056],
              [-73.76683508999992, 45.52724844000005],
              [-73.71670488199993, 45.54441966400009],
              [-73.69399980399993, 45.55532461100006],
              [-73.66795813699991, 45.57558828300006],
              [-73.64867102799991, 45.598863023000035],
              [-73.64273027299993, 45.60932038000004],
              [-73.62531490799995, 45.63031647300005],
              [-73.62071692599994, 45.638332424000055],
              [-73.60952714799993, 45.64667389500005],
              [-73.54112708199995, 45.68577708500004],
              [-73.52403723899994, 45.69953034100007],
              [-73.51667232999995, 45.70404694200005],
              [-73.50865637899994, 45.707464911000045],
              [-73.49925696499992, 45.70994700700004],
            ],
          ],
          [
            [
              [-70.84325110599991, 47.033189195000034],
              [-70.82848059799994, 47.03009674700007],
              [-70.8157445949999, 47.02362702000005],
              [-70.80968176999994, 47.01341380400004],
              [-70.81533769399994, 46.99909088700008],
              [-70.82795162699995, 46.98700592700004],
              [-70.86192786399994, 46.94594961100006],
              [-70.87425696499992, 46.93699778900009],
              [-70.89126542899993, 46.931708075000074],
              [-70.95250403599994, 46.89545319200005],
              [-71.03123938699991, 46.862941799000055],
              [-71.07176673099991, 46.85814036700003],
              [-71.11400305899991, 46.859442450000074],
              [-71.12474524599992, 46.877020575000074],
              [-71.08511308499993, 46.90570709800005],
              [-70.9934789699999, 46.95001862200007],
              [-70.92406165299991, 47.003241278000075],
              [-70.88540605399993, 47.026556708000044],
              [-70.84325110599991, 47.033189195000034],
            ],
          ],
          [
            [
              [-60.08088131399995, 45.79242584800005],
              [-60.09325110599991, 45.79083893400008],
              [-60.177723761999914, 45.76654694200005],
              [-60.19884192599994, 45.75568268400008],
              [-60.20775305899991, 45.74091217700004],
              [-60.21564693899995, 45.71942780200004],
              [-60.23497473899994, 45.70685455900008],
              [-60.25967363199993, 45.70018138200004],
              [-60.28351803299995, 45.69684479400007],
              [-60.32286536399994, 45.683661200000074],
              [-60.395375128999945, 45.64252350500004],
              [-60.44115149599992, 45.63544342700004],
              [-60.46263587099992, 45.63572825700004],
              [-60.47008216099994, 45.63947174700007],
              [-60.47524980399993, 45.64911530200004],
              [-60.49986731699994, 45.63239166900007],
              [-60.511830206999946, 45.62641022300005],
              [-60.629790818999936, 45.594956773000035],
              [-60.66234290299991, 45.57758209800005],
              [-60.67178300699993, 45.57367584800005],
              [-60.70425370999993, 45.57330963700008],
              [-60.71153723899994, 45.571600653000075],
              [-60.718861456999946, 45.56818268400008],
              [-60.72687740799995, 45.565619208000044],
              [-60.73595130099994, 45.56655508000006],
              [-60.74156653599994, 45.57273997600004],
              [-60.74250240799995, 45.58193594000005],
              [-60.744252081999946, 45.590277411000045],
              [-60.75243079299992, 45.59389883000006],
              [-60.82843990799995, 45.60065338700008],
              [-60.84434973899994, 45.60455963700008],
              [-60.84874426999994, 45.61432526200008],
              [-60.849720831999946, 45.62677643400008],
              [-60.855458136999914, 45.63882070500006],
              [-60.871083136999914, 45.64565664300005],
              [-60.88394120999993, 45.63739655200004],
              [-60.89557857999995, 45.62372467700004],
              [-60.90729732999995, 45.61432526200008],
              [-60.91576087099992, 45.62128327000005],
              [-60.92540442599994, 45.62579987200007],
              [-60.93602454299992, 45.62799713700008],
              [-60.94762122299994, 45.62799713700008],
              [-60.946156378999945, 45.61225006700005],
              [-60.969960089999915, 45.60809967700004],
              [-61.02391516799992, 45.61432526200008],
              [-61.00967363199993, 45.60809967700004],
              [-61.01622473899994, 45.59528229400007],
              [-61.02501380099994, 45.59153880400004],
              [-61.04723059799994, 45.59389883000006],
              [-61.05760657499991, 45.591498114000046],
              [-61.08543860599991, 45.57330963700008],
              [-61.131418423999946, 45.559881903000075],
              [-61.15672766799992, 45.55658600500004],
              [-61.17479407499991, 45.55906810100004],
              [-61.15721594999991, 45.56513092700004],
              [-61.15111243399991, 45.571478583000044],
              [-61.15501868399991, 45.578558661000045],
              [-61.16734778599994, 45.58698151200008],
              [-61.18203691299993, 45.59031810100004],
              [-61.195871548999946, 45.589544989000046],
              [-61.205637173999946, 45.59271881700005],
              [-61.2083227199999, 45.60809967700004],
              [-61.21548417899993, 45.60028717700004],
              [-61.22032630099994, 45.589504299000055],
              [-61.22496497299994, 45.58193594000005],
              [-61.23192298099991, 45.58392975500004],
              [-61.24120032499991, 45.58539459800005],
              [-61.25365149599992, 45.57949453300006],
              [-61.266468878999945, 45.571478583000044],
              [-61.27721106699994, 45.56655508000006],
              [-61.27017167899993, 45.54832591400009],
              [-61.28457597599993, 45.54767487200007],
              [-61.32188880099994, 45.55906810100004],
              [-61.334868943999936, 45.56622955900008],
              [-61.36286373599995, 45.61123281500005],
              [-61.4192602199999, 45.65688711100006],
              [-61.44204667899993, 45.68178945500006],
              [-61.45531165299991, 45.70990631700005],
              [-61.46507727799991, 45.776271877000056],
              [-61.47541256399995, 45.81134674700007],
              [-61.49254309799994, 45.826605536000045],
              [-61.497303839999915, 45.835150458000044],
              [-61.48888098899994, 45.888657945000034],
              [-61.500111456999946, 45.90607330900008],
              [-61.51439368399991, 45.91937897300005],
              [-61.52261308499993, 45.932806708000044],
              [-61.516184048999946, 45.95075104400007],
              [-61.52122962099992, 45.961004950000074],
              [-61.52122962099992, 45.98078034100007],
              [-61.52358964799993, 45.99168528900009],
              [-61.52892005099994, 45.996527411000045],
              [-61.53844153599994, 46.003119208000044],
              [-61.54751542899993, 46.01162344000005],
              [-61.55150305899991, 46.02179596600007],
              [-61.541127081999946, 46.04047272300005],
              [-61.51732337099992, 46.05312734600005],
              [-61.49160722599993, 46.06305573100008],
              [-61.47520911399994, 46.07363515800006],
              [-61.47008216099994, 46.09259674700007],
              [-61.466053839999915, 46.120306708000044],
              [-61.458973761999914, 46.14533112200007],
              [-61.44473222599993, 46.15619538000004],
              [-61.43126380099994, 46.16278717700004],
              [-61.38438880099994, 46.19428131700005],
              [-61.28880774599992, 46.242621161000045],
              [-61.28062903599994, 46.24555084800005],
              [-61.27794348899994, 46.255194403000075],
              [-61.21251380099994, 46.33100006700005],
              [-61.19155839799993, 46.36701080900008],
              [-61.17788652299993, 46.38556549700007],
              [-61.09483801999994, 46.45392487200007],
              [-61.08617102799991, 46.466498114000046],
              [-61.08055579299992, 46.480536200000074],
              [-61.07526607999995, 46.51325104400007],
              [-61.066517706999946, 46.52684153900009],
              [-61.04039466099994, 46.55036041900007],
              [-61.03038489499994, 46.568019924000055],
              [-61.037220831999946, 46.58161041900007],
              [-61.04991614499994, 46.59227122600004],
              [-61.057484503999945, 46.601263739000046],
              [-61.05382239499994, 46.61225006700005],
              [-61.043080206999946, 46.62531159100007],
              [-61.029286261999914, 46.63654205900008],
              [-61.016468878999945, 46.64215729400007],
              [-61.030181443999936, 46.61155833500004],
              [-61.030181443999936, 46.601263739000046],
              [-61.02379309799994, 46.59320709800005],
              [-61.01707923099991, 46.60040924700007],
              [-61.011830206999946, 46.61408112200007],
              [-61.00967363199993, 46.625433661000045],
              [-61.004790818999936, 46.63328685100004],
              [-60.97207597599993, 46.65273672100005],
              [-60.96499589799993, 46.66201406500005],
              [-60.94762122299994, 46.69741445500006],
              [-60.89924068899995, 46.768784898000035],
              [-60.869211391999954, 46.800034898000035],
              [-60.832142706999946, 46.82094961100006],
              [-60.7884008449999, 46.83466217700004],
              [-60.769602016999954, 46.843736070000034],
              [-60.70132402299993, 46.90468984600005],
              [-60.65147864499994, 46.981634833000044],
              [-60.64207923099991, 47.00372955900008],
              [-60.63316809799994, 47.01068756700005],
              [-60.623036261999914, 47.016831773000035],
              [-60.60326087099992, 47.033636786000045],
              [-60.59361731699994, 47.034816799000055],
              [-60.57144120999993, 47.02635325700004],
              [-60.53416907499991, 47.02195872600004],
              [-60.52306067599994, 47.01894765800006],
              [-60.514230923999946, 47.013006903000075],
              [-60.50877844999991, 47.00641510600008],
              [-60.50112870999993, 47.001206773000035],
              [-60.48582923099991, 46.99909088700008],
              [-60.46157792899993, 47.00336334800005],
              [-60.42031816299993, 47.02216217700004],
              [-60.39610755099994, 47.02635325700004],
              [-60.383371548999946, 47.016791083000044],
              [-60.398426886999914, 46.99555084800005],
              [-60.43431555899991, 46.96430084800005],
              [-60.46471106699994, 46.927069403000075],
              [-60.49038652299993, 46.90521881700005],
              [-60.495757615999935, 46.89545319200005],
              [-60.473866339999915, 46.89716217700004],
              [-60.45221920499995, 46.89252350500004],
              [-60.44204667899993, 46.884426174000055],
              [-60.454741990999935, 46.87555573100008],
              [-60.454741990999935, 46.86810944200005],
              [-60.43040930899991, 46.86420319200005],
              [-60.39354407499991, 46.862982489000046],
              [-60.358306443999936, 46.86615631700005],
              [-60.338734503999945, 46.87555573100008],
              [-60.33071855399993, 46.87164948100008],
              [-60.32335364499994, 46.866888739000046],
              [-60.31672115799995, 46.86115143400008],
              [-60.31078040299991, 46.85443756700005],
              [-60.305531378999945, 46.83388906500005],
              [-60.30899003799993, 46.80337148600006],
              [-60.32445227799991, 46.74518463700008],
              [-60.342355923999946, 46.70848216400009],
              [-60.34487870999993, 46.69399648600006],
              [-60.352121548999946, 46.68646881700005],
              [-60.39952551999994, 46.67011139500005],
              [-60.391468878999945, 46.66120026200008],
              [-60.38149980399993, 46.65599192900004],
              [-60.37010657499991, 46.654282945000034],
              [-60.357980923999946, 46.65582916900007],
              [-60.357980923999946, 46.649603583000044],
              [-60.365223761999914, 46.648098049000055],
              [-60.37791907499991, 46.643459377000056],
              [-60.38589433499993, 46.64215729400007],
              [-60.37401282499991, 46.62962474200003],
              [-60.36009680899991, 46.623114325000074],
              [-60.350493943999936, 46.61587148600006],
              [-60.35179602799991, 46.601263739000046],
              [-60.35704505099994, 46.594631252000056],
              [-60.37970943899995, 46.58075592700004],
              [-60.42105058499993, 46.52480703300006],
              [-60.46157792899993, 46.423081773000035],
              [-60.472645636999914, 46.40692780200004],
              [-60.50938880099994, 46.368475653000075],
              [-60.51634680899991, 46.35614655200004],
              [-60.53038489499994, 46.32363515800006],
              [-60.57787024599992, 46.26414622600004],
              [-60.60578365799995, 46.21133047100005],
              [-60.60033118399991, 46.201157945000034],
              [-60.59874426999994, 46.19717031500005],
              [-60.55235755099994, 46.26227448100008],
              [-60.54043535099993, 46.27228424700007],
              [-60.52440344999991, 46.27838776200008],
              [-60.47524980399993, 46.320013739000046],
              [-60.442616339999915, 46.332464911000045],
              [-60.43431555899991, 46.333685614000046],
              [-60.418853318999936, 46.329779364000046],
              [-60.415679490999935, 46.323919989000046],
              [-60.41832434799994, 46.31517161700003],
              [-60.42064368399991, 46.30267975500004],
              [-60.42690995999993, 46.28400299700007],
              [-60.441965298999946, 46.27057526200008],
              [-60.47524980399993, 46.25177643400008],
              [-60.61241614499994, 46.128241278000075],
              [-60.63223222599993, 46.11798737200007],
              [-60.67540442599994, 46.101629950000074],
              [-60.69098873599995, 46.091009833000044],
              [-60.700835740999935, 46.08803945500006],
              [-60.714914516999954, 46.10736725500004],
              [-60.72541256399995, 46.104681708000044],
              [-60.74779212099992, 46.085272528000075],
              [-60.755848761999914, 46.08047109600005],
              [-60.77301998599995, 46.07339101800005],
              [-60.816395636999914, 46.06191640800006],
              [-60.873158331999946, 46.053168036000045],
              [-60.87950598899994, 46.061753648000035],
              [-60.87413489499994, 46.068345445000034],
              [-60.86290442599994, 46.07245514500005],
              [-60.85204016799992, 46.07363515800006],
              [-60.87413489499994, 46.07916901200008],
              [-60.91250566299993, 46.05182526200008],
              [-60.97557532499991, 45.99168528900009],
              [-60.99323482999995, 45.982123114000046],
              [-61.01480058499993, 45.974676825000074],
              [-61.10187740799995, 45.95815664300005],
              [-61.11864173099991, 45.94940827000005],
              [-61.12637285099993, 45.92963288000004],
              [-61.03355872299994, 45.93646881700005],
              [-61.00991777299993, 45.941392320000034],
              [-60.99526933499993, 45.95392487200007],
              [-60.98355058499993, 45.96967194200005],
              [-60.96865800699993, 45.98493073100008],
              [-60.90274003799993, 46.010199286000045],
              [-60.88394120999993, 46.03465403900009],
              [-60.86266028599994, 46.03823476800005],
              [-60.81786048099991, 46.03880442900004],
              [-60.773508266999954, 46.05927155200004],
              [-60.74746660099993, 46.06622955900008],
              [-60.73595130099994, 46.05658600500004],
              [-60.74315344999991, 46.03729889500005],
              [-60.76024329299992, 46.02228424700007],
              [-60.78062903599994, 46.00812409100007],
              [-60.797434048999946, 45.99168528900009],
              [-60.80296790299991, 45.97479889500005],
              [-60.80654863199993, 45.95416901200008],
              [-60.81505286399994, 45.93695709800005],
              [-60.8352758449999, 45.92963288000004],
              [-60.84666907499991, 45.92841217700004],
              [-60.85777747299994, 45.92487213700008],
              [-60.86782792899993, 45.919623114000046],
              [-60.8762914699999, 45.91282786700003],
              [-60.88654537699995, 45.90835195500006],
              [-60.898426886999914, 45.90989817900004],
              [-60.92027747299994, 45.91596100500004],
              [-60.96165930899991, 45.91518789300005],
              [-60.981027798999946, 45.910223700000074],
              [-60.98924719999991, 45.898871161000045],
              [-61.00108801999994, 45.89695872600004],
              [-61.05573482999995, 45.897650458000044],
              [-61.071156378999945, 45.89549388200004],
              [-61.05223548099991, 45.88886139500005],
              [-61.043812628999945, 45.888657945000034],
              [-61.05728105399993, 45.87958405200004],
              [-61.073475714999915, 45.874701239000046],
              [-61.08861243399991, 45.86823151200008],
              [-61.09845943899995, 45.85447825700004],
              [-61.08389238199993, 45.85382721600007],
              [-61.06086178299995, 45.857123114000046],
              [-61.03954016799992, 45.86347077000005],
              [-61.030181443999936, 45.87164948100008],
              [-61.01943925699993, 45.87571849200003],
              [-60.998158331999946, 45.875067450000074],
              [-60.98265540299991, 45.87689850500004],
              [-60.98924719999991, 45.888657945000034],
              [-60.96857662699995, 45.88621653900009],
              [-60.914133266999954, 45.85447825700004],
              [-60.926340298999946, 45.847723700000074],
              [-60.93732662699995, 45.850775458000044],
              [-60.94945227799991, 45.857123114000046],
              [-60.964955206999946, 45.86074453300006],
              [-60.96666419199994, 45.85651276200008],
              [-60.94212805899991, 45.835272528000075],
              [-60.93455969999991, 45.826605536000045],
              [-60.95295162699995, 45.82684967700004],
              [-60.96076412699995, 45.82908763200004],
              [-60.96865800699993, 45.834051825000074],
              [-60.98192298099991, 45.820746161000045],
              [-60.99486243399991, 45.819973049000055],
              [-61.00572669199994, 45.823472398000035],
              [-61.01309160099993, 45.82318756700005],
              [-61.02440344999991, 45.813666083000044],
              [-61.1028539699999, 45.77887604400007],
              [-61.123158331999946, 45.76357656500005],
              [-61.13377844999991, 45.74461497600004],
              [-61.129017706999946, 45.74681224200003],
              [-61.11204993399991, 45.75153229400007],
              [-61.11123613199993, 45.74461497600004],
              [-61.111439581999946, 45.735541083000044],
              [-61.11278235599991, 45.72760651200008],
              [-61.11583411399994, 45.72418854400007],
              [-61.125843878999945, 45.721909898000035],
              [-61.13385982999995, 45.71702708500004],
              [-61.13971920499995, 45.712144273000035],
              [-61.14761308499993, 45.707912502000056],
              [-61.14293372299994, 45.70343659100007],
              [-61.133371548999946, 45.698879299000055],
              [-61.082020636999914, 45.690659898000035],
              [-61.04942786399994, 45.698472398000035],
              [-60.94762122299994, 45.75153229400007],
              [-60.91283118399991, 45.75617096600007],
              [-60.87319902299993, 45.752386786000045],
              [-60.83568274599992, 45.74046458500004],
              [-60.80736243399991, 45.720770575000074],
              [-60.79922441299993, 45.70331452000005],
              [-60.80768795499995, 45.690659898000035],
              [-60.82363847599993, 45.67853424700007],
              [-60.84487870999993, 45.65534088700008],
              [-60.850168423999946, 45.65119049700007],
              [-60.84947669199994, 45.647650458000044],
              [-60.83836829299992, 45.642279364000046],
              [-60.82892818899995, 45.64057038000004],
              [-60.82603919199994, 45.644232489000046],
              [-60.827788865999935, 45.65021393400008],
              [-60.832142706999946, 45.65525950700004],
              [-60.81041419199994, 45.66274648600006],
              [-60.81786048099991, 45.66893138200004],
              [-60.784047003999945, 45.66893138200004],
              [-60.777333136999914, 45.67377350500004],
              [-60.765736456999946, 45.69293854400007],
              [-60.75951087099992, 45.693793036000045],
              [-60.74388587099992, 45.684881903000075],
              [-60.732492641999954, 45.68439362200007],
              [-60.730132615999935, 45.69098541900007],
              [-60.742176886999914, 45.70376211100006],
              [-60.73005123599995, 45.71393463700008],
              [-60.73350989499994, 45.72455475500004],
              [-60.74299068899995, 45.73501211100006],
              [-60.74901282499991, 45.74461497600004],
              [-60.74640865799995, 45.76015859600005],
              [-60.737212693999936, 45.77374909100007],
              [-60.725453253999945, 45.78473541900007],
              [-60.714833136999914, 45.79242584800005],
              [-60.700062628999945, 45.79987213700008],
              [-60.66954505099994, 45.81028880400004],
              [-60.65343176999994, 45.81976959800005],
              [-60.64370683499993, 45.83055247600004],
              [-60.63438880099994, 45.844183661000045],
              [-60.62340247299994, 45.85578034100007],
              [-60.609038865999935, 45.86074453300006],
              [-60.599273240999935, 45.86615631700005],
              [-60.56895911399994, 45.89008209800005],
              [-60.541086391999954, 45.90086497600004],
              [-60.52098548099991, 45.924261786000045],
              [-60.477772589999915, 45.93659088700008],
              [-60.44517981699994, 45.95392487200007],
              [-60.41637122299994, 45.976223049000055],
              [-60.39952551999994, 45.99795156500005],
              [-60.42027747299994, 45.99315013200004],
              [-60.46349036399994, 45.97736237200007],
              [-60.49722245999993, 45.95661041900007],
              [-60.56403561099995, 45.94391510600008],
              [-60.62140865799995, 45.91986725500004],
              [-60.64598548099991, 45.91278717700004],
              [-60.664906378999945, 45.89866771000004],
              [-60.69912675699993, 45.89093659100007],
              [-60.70970618399991, 45.890326239000046],
              [-60.72227942599994, 45.89549388200004],
              [-60.73151607999995, 45.90460846600007],
              [-60.73997962099992, 45.92267487200007],
              [-60.74901282499991, 45.92963288000004],
              [-60.76203365799995, 45.930975653000075],
              [-60.77578691299993, 45.929022528000075],
              [-60.78673255099994, 45.93008047100005],
              [-60.79116777299993, 45.94017161700003],
              [-60.78164628799993, 45.954291083000044],
              [-60.714833136999914, 45.98493073100008],
              [-60.68439693899995, 46.00682200700004],
              [-60.66576087099992, 46.01512278900009],
              [-60.642567511999914, 46.01837799700007],
              [-60.62254798099991, 46.02435944200005],
              [-60.56403561099995, 46.06679922100005],
              [-60.507883266999954, 46.090725002000056],
              [-60.4895727199999, 46.101548570000034],
              [-60.431630011999914, 46.14935944200005],
              [-60.416900193999936, 46.15619538000004],
              [-60.40538489499994, 46.163763739000046],
              [-60.37490800699993, 46.19700755400004],
              [-60.35484778599994, 46.20457591400009],
              [-60.33385169199994, 46.205145575000074],
              [-60.31460527299993, 46.20880768400008],
              [-60.30101477799991, 46.21869538000004],
              [-60.29710852799991, 46.23810455900008],
              [-60.31794186099995, 46.23021067900004],
              [-60.338449673999946, 46.22601959800005],
              [-60.382801886999914, 46.223822333000044],
              [-60.40070553299995, 46.21816640800006],
              [-60.447336391999954, 46.176662502000056],
              [-60.60704505099994, 46.07648346600007],
              [-60.63027910099993, 46.068060614000046],
              [-60.63906816299993, 46.06679922100005],
              [-60.65269934799994, 46.07221100500004],
              [-60.65510006399995, 46.081691799000055],
              [-60.650461391999954, 46.090725002000056],
              [-60.642567511999914, 46.09471263200004],
              [-60.62132727799991, 46.10101959800005],
              [-60.60142981699994, 46.11591217700004],
              [-60.57144120999993, 46.14935944200005],
              [-60.50255286399994, 46.200873114000046],
              [-60.49449622299994, 46.217962958000044],
              [-60.47541256399995, 46.23346588700008],
              [-60.35098222599993, 46.31207916900007],
              [-60.28351803299995, 46.32754140800006],
              [-60.27961178299995, 46.317287502000056],
              [-60.25959225199995, 46.27912018400008],
              [-60.20466061099995, 46.241848049000055],
              [-60.21198482999995, 46.223944403000075],
              [-60.290272589999915, 46.15619538000004],
              [-60.278228318999936, 46.159084377000056],
              [-60.26854407499991, 46.16596100500004],
              [-60.26121985599991, 46.173081773000035],
              [-60.25617428299995, 46.176662502000056],
              [-60.24372311099995, 46.17633698100008],
              [-60.23534094999991, 46.17279694200005],
              [-60.22142493399991, 46.16242096600007],
              [-60.212147589999915, 46.14520905200004],
              [-60.20498613199993, 46.142279364000046],
              [-60.19408118399991, 46.15619538000004],
              [-60.19204667899993, 46.16616445500006],
              [-60.194976365999935, 46.17487213700008],
              [-60.199330206999946, 46.18374258000006],
              [-60.20156816299993, 46.19375234600005],
              [-60.19322669199994, 46.21173737200007],
              [-60.173939581999946, 46.23069896000004],
              [-60.15208899599992, 46.24567291900007],
              [-60.13609778599994, 46.25177643400008],
              [-60.109445766999954, 46.25055573100008],
              [-60.08315995999993, 46.24624258000006],
              [-60.058664516999954, 46.237616278000075],
              [-60.037098761999914, 46.223822333000044],
              [-60.091053839999915, 46.21084219000005],
              [-59.99136308499993, 46.20693594000005],
              [-59.94416256399995, 46.19623444200005],
              [-59.94766191299993, 46.16242096600007],
              [-59.93382727799991, 46.15851471600007],
              [-59.90135657499991, 46.17243073100008],
              [-59.88219153599994, 46.176662502000056],
              [-59.810536261999914, 46.16986725500004],
              [-59.83653723899994, 46.155910549000055],
              [-59.863352016999954, 46.136419989000046],
              [-59.88243567599994, 46.11127350500004],
              [-59.885609503999945, 46.08047109600005],
              [-59.87144934799994, 46.09414297100005],
              [-59.85106360599991, 46.10443756700005],
              [-59.82917232999995, 46.11147695500006],
              [-59.810536261999914, 46.115220445000034],
              [-59.810536261999914, 46.10781484600005],
              [-59.871937628999945, 46.07363515800006],
              [-59.89590410099993, 46.05019765800006],
              [-59.90925045499995, 46.04197825700004],
              [-59.95421301999994, 46.03579336100006],
              [-59.957915818999936, 46.02749258000006],
              [-59.94969641799992, 46.01557038000004],
              [-59.93712317599994, 46.001654364000046],
              [-59.92072506399995, 45.994574286000045],
              [-59.89826412699995, 45.99689362200007],
              [-59.858306443999936, 46.00535716400009],
              [-59.83975175699993, 46.005072333000044],
              [-59.832102016999954, 46.003119208000044],
              [-59.82412675699993, 45.99795156500005],
              [-59.83031165299991, 45.999335028000075],
              [-59.83189856699994, 45.99201080900008],
              [-59.83039303299995, 45.97801341400009],
              [-59.82380123599995, 45.97101471600007],
              [-59.80695553299995, 45.96043528900009],
              [-59.80308997299994, 45.95693594000005],
              [-59.80223548099991, 45.94521719000005],
              [-59.80528723899994, 45.935532945000034],
              [-59.812489386999914, 45.93060944200005],
              [-59.82384192599994, 45.93305084800005],
              [-59.86204993399991, 45.93569570500006],
              [-59.93927975199995, 45.904364325000074],
              [-59.96816972599993, 45.90973541900007],
              [-59.97492428299995, 45.90542226800005],
              [-59.98029537699995, 45.90086497600004],
              [-59.98473059799994, 45.89557526200008],
              [-59.98863684799994, 45.888657945000034],
              [-59.98428300699993, 45.88580963700008],
              [-59.98021399599992, 45.87970612200007],
              [-59.97565670499995, 45.875067450000074],
              [-60.12734941299993, 45.86945221600007],
              [-60.15314693899995, 45.84707265800006],
              [-60.1555883449999, 45.837958075000074],
              [-60.154408331999946, 45.837144273000035],
              [-60.14753170499995, 45.83808014500005],
              [-60.13267981699994, 45.834051825000074],
              [-60.11168372299994, 45.82404205900008],
              [-60.10118567599994, 45.82094961100006],
              [-60.08763587099992, 45.81976959800005],
              [-60.075428839999915, 45.81549713700008],
              [-60.07188880099994, 45.80609772300005],
              [-60.07457434799994, 45.79677969000005],
              [-60.08088131399995, 45.79242584800005],
            ],
          ],
          [
            [
              [-62.004017706999946, 46.464056708000044],
              [-61.97695878799993, 46.45465729400007],
              [-61.977406378999945, 46.44818756700005],
              [-61.99351966099994, 46.440334377000056],
              [-62.031320766999954, 46.414943752000056],
              [-62.16563880099994, 46.35838450700004],
              [-62.212554490999935, 46.34756094000005],
              [-62.22760982999995, 46.34589264500005],
              [-62.23985755099994, 46.35106028900009],
              [-62.25047766799992, 46.36005280200004],
              [-62.28392493399991, 46.382147528000075],
              [-62.27090410099993, 46.35415273600006],
              [-62.27375240799995, 46.344916083000044],
              [-62.29141191299993, 46.341131903000075],
              [-62.30687415299991, 46.344631252000056],
              [-62.33942623599995, 46.359442450000074],
              [-62.35968990799995, 46.361029364000046],
              [-62.35968990799995, 46.35419342700004],
              [-62.34801184799994, 46.34560781500005],
              [-62.34605872299994, 46.324286200000074],
              [-62.33177649599992, 46.31321849200003],
              [-62.367298956999946, 46.30621979400007],
              [-62.38451087099992, 46.30573151200008],
              [-62.40062415299991, 46.31321849200003],
              [-62.36778723899994, 46.284409898000035],
              [-62.36571204299992, 46.27142975500004],
              [-62.39037024599992, 46.266058661000045],
              [-62.471262173999946, 46.280462958000044],
              [-62.49689693899995, 46.27228424700007],
              [-62.446929490999935, 46.259100653000075],
              [-62.42373613199993, 46.24506256700005],
              [-62.421131964999915, 46.223822333000044],
              [-62.43732662699995, 46.21625397300005],
              [-62.46617591099994, 46.214911200000074],
              [-62.51390540299991, 46.217678127000056],
              [-62.55500240799995, 46.23419830900008],
              [-62.57640540299991, 46.23899974200003],
              [-62.585601365999935, 46.22752513200004],
              [-62.54328365799995, 46.214911200000074],
              [-62.5130102199999, 46.201605536000045],
              [-62.49689693899995, 46.18349844000005],
              [-62.52440344999991, 46.186753648000035],
              [-62.57306881399995, 46.20742422100005],
              [-62.59923255099994, 46.21084219000005],
              [-62.59483801999994, 46.202826239000046],
              [-62.58975175699993, 46.19839101800005],
              [-62.58263098899994, 46.19668203300006],
              [-62.571929490999935, 46.19717031500005],
              [-62.571929490999935, 46.190334377000056],
              [-62.582020636999914, 46.190741278000075],
              [-62.59044348899994, 46.18964264500005],
              [-62.6067602199999, 46.18349844000005],
              [-62.58702551999994, 46.177394924000055],
              [-62.54674231699994, 46.17523834800005],
              [-62.53099524599992, 46.16986725500004],
              [-62.53819739499994, 46.15965403900009],
              [-62.542225714999915, 46.145819403000075],
              [-62.54328365799995, 46.13349030200004],
              [-62.541574673999946, 46.128241278000075],
              [-62.49205481699994, 46.12563711100006],
              [-62.47573808499993, 46.12140534100007],
              [-62.48070227799991, 46.135199286000045],
              [-62.49058997299994, 46.14154694200005],
              [-62.51732337099992, 46.14935944200005],
              [-62.486439581999946, 46.15265534100007],
              [-62.46422278599994, 46.135199286000045],
              [-62.453236456999946, 46.10761139500005],
              [-62.455922003999945, 46.08047109600005],
              [-62.457590298999946, 46.07982005400004],
              [-62.472645636999914, 46.06342194200005],
              [-62.47931881399995, 46.06000397300005],
              [-62.48859615799995, 46.05906810100004],
              [-62.506743943999936, 46.06000397300005],
              [-62.52749589799993, 46.05731842700004],
              [-62.55455481699994, 46.04393138200004],
              [-62.571929490999935, 46.03880442900004],
              [-62.571929490999935, 46.03266022300005],
              [-62.55426998599995, 46.03070709800005],
              [-62.51048743399991, 46.01837799700007],
              [-62.49632727799991, 46.01898834800005],
              [-62.47057044199994, 46.02513255400004],
              [-62.455922003999945, 46.02521393400008],
              [-62.485585089999915, 45.989894924000055],
              [-62.54523678299995, 45.97182851800005],
              [-62.68394934799994, 45.96564362200007],
              [-62.71467037699995, 45.970404364000046],
              [-62.72899329299992, 45.97060781500005],
              [-62.73668372299994, 45.96702708500004],
              [-62.74510657499991, 45.95404694200005],
              [-62.75072180899991, 45.95075104400007],
              [-62.756703253999945, 45.952460028000075],
              [-62.77183997299994, 45.96173737200007],
              [-62.777414516999954, 45.96434153900009],
              [-62.82945716099994, 45.972723700000074],
              [-62.84630286399994, 45.97801341400009],
              [-62.89411373599995, 46.00535716400009],
              [-62.87999426999994, 46.010972398000035],
              [-62.873605923999946, 46.01154205900008],
              [-62.873605923999946, 46.01837799700007],
              [-62.88914954299992, 46.020697333000044],
              [-62.90477454299992, 46.02529531500005],
              [-62.91930091099994, 46.032416083000044],
              [-62.931630011999914, 46.042629299000055],
              [-62.93464107999995, 46.05296458500004],
              [-62.9212133449999, 46.05524323100008],
              [-62.887277798999946, 46.053168036000045],
              [-62.909047003999945, 46.071926174000055],
              [-62.996652798999946, 46.06195709800005],
              [-63.03062903599994, 46.06679922100005],
              [-63.00926673099991, 46.07176341400009],
              [-62.98656165299991, 46.07363515800006],
              [-62.97362219999991, 46.07689036700003],
              [-62.95030676999994, 46.091457424000055],
              [-62.91755123599995, 46.101263739000046],
              [-62.88695227799991, 46.12962474200003],
              [-62.866118943999936, 46.13568756700005],
              [-62.8782445949999, 46.155585028000075],
              [-62.89549719999991, 46.157456773000035],
              [-62.91445878799993, 46.147650458000044],
              [-62.931630011999914, 46.13198476800005],
              [-62.94786536399994, 46.12799713700008],
              [-62.95653235599991, 46.14484284100007],
              [-62.95197506399995, 46.16640859600005],
              [-62.92821204299992, 46.176662502000056],
              [-62.93545488199993, 46.187201239000046],
              [-62.94717363199993, 46.193426825000074],
              [-62.97598222599993, 46.20457591400009],
              [-62.98965410099993, 46.19717031500005],
              [-62.98501542899993, 46.19208405200004],
              [-62.98314368399991, 46.188706773000035],
              [-62.98110917899993, 46.18610260600008],
              [-62.97598222599993, 46.18349844000005],
              [-62.9973852199999, 46.17926666900007],
              [-63.02525794199994, 46.18610260600008],
              [-63.05431067599994, 46.196926174000055],
              [-63.10627193899995, 46.210150458000044],
              [-63.11681067599994, 46.21576569200005],
              [-63.11213131399995, 46.22418854400007],
              [-63.09333248599995, 46.23810455900008],
              [-63.08775794199994, 46.24103424700007],
              [-63.07770748599995, 46.24355703300006],
              [-63.07286536399994, 46.24555084800005],
              [-63.06798255099994, 46.25079987200007],
              [-63.06712805899991, 46.25641510600008],
              [-63.067290818999936, 46.261786200000074],
              [-63.06541907499991, 46.266058661000045],
              [-63.06114661399994, 46.266913153000075],
              [-63.04906165299991, 46.26504140800006],
              [-63.044911261999914, 46.266058661000045],
              [-63.04332434799994, 46.27057526200008],
              [-63.043812628999945, 46.27631256700005],
              [-63.04320227799991, 46.28192780200004],
              [-63.03807532499991, 46.28656647300005],
              [-62.98033606699994, 46.30548737200007],
              [-62.963002081999946, 46.320013739000046],
              [-62.981027798999946, 46.31940338700008],
              [-63.011708136999914, 46.30853913000004],
              [-63.04360917899993, 46.30158112200007],
              [-63.0696508449999, 46.283270575000074],
              [-63.08250891799992, 46.27912018400008],
              [-63.09679114499994, 46.272650458000044],
              [-63.1204320949999, 46.24433014500005],
              [-63.13434811099995, 46.23810455900008],
              [-63.14045162699995, 46.24103424700007],
              [-63.16161048099991, 46.25922272300005],
              [-63.19570878799993, 46.27228424700007],
              [-63.17369544199994, 46.23822663000004],
              [-63.174712693999936, 46.227728583000044],
              [-63.19912675699993, 46.223822333000044],
              [-63.20763098899994, 46.220770575000074],
              [-63.22402910099993, 46.20758698100008],
              [-63.233265753999945, 46.20457591400009],
              [-63.27086341099994, 46.20457591400009],
              [-63.27086341099994, 46.19717031500005],
              [-63.214914516999954, 46.191107489000046],
              [-63.189116990999935, 46.195298570000034],
              [-63.17528235599991, 46.217678127000056],
              [-63.147694464999915, 46.206284898000035],
              [-63.1419164699999, 46.198431708000044],
              [-63.147328253999945, 46.18349844000005],
              [-63.17764238199993, 46.171942450000074],
              [-63.20815995999993, 46.165228583000044],
              [-63.23338782499991, 46.14545319200005],
              [-63.25719153599994, 46.141913153000075],
              [-63.28429114499994, 46.14704010600008],
              [-63.33556067599994, 46.165716864000046],
              [-63.37262936099995, 46.171942450000074],
              [-63.39989173099991, 46.181341864000046],
              [-63.41201738199993, 46.18349844000005],
              [-63.41836503799993, 46.185614325000074],
              [-63.42284094999991, 46.195013739000046],
              [-63.42882239499994, 46.19717031500005],
              [-63.45026607999995, 46.19599030200004],
              [-63.45579993399991, 46.19717031500005],
              [-63.465687628999945, 46.20457591400009],
              [-63.480580206999946, 46.219916083000044],
              [-63.49058997299994, 46.223822333000044],
              [-63.49917558499993, 46.22247955900008],
              [-63.521148240999935, 46.21308014500005],
              [-63.53498287699995, 46.21084219000005],
              [-63.54531816299993, 46.21369049700007],
              [-63.55638587099992, 46.21930573100008],
              [-63.566965298999946, 46.223089911000045],
              [-63.57591712099992, 46.220770575000074],
              [-63.58731035099993, 46.21625397300005],
              [-63.602121548999946, 46.216864325000074],
              [-63.62775631399995, 46.223822333000044],
              [-63.67564856699994, 46.24258047100005],
              [-63.694569464999915, 46.25653717700004],
              [-63.70225989499994, 46.27570221600007],
              [-63.71304277299993, 46.28978099200003],
              [-63.73790442599994, 46.302394924000055],
              [-63.78477942599994, 46.320013739000046],
              [-63.800038214999915, 46.33185455900008],
              [-63.805897589999915, 46.34357330900008],
              [-63.80117753799993, 46.34878164300005],
              [-63.78477942599994, 46.341131903000075],
              [-63.805897589999915, 46.374701239000046],
              [-63.73932857999995, 46.356675523000035],
              [-63.71589107999995, 46.35419342700004],
              [-63.764881964999915, 46.382147528000075],
              [-63.752064581999946, 46.38727448100008],
              [-63.74551347599993, 46.38906484600005],
              [-63.73692786399994, 46.38898346600007],
              [-63.73692786399994, 46.39642975500004],
              [-63.766835089999915, 46.39935944200005],
              [-63.839914516999954, 46.39695872600004],
              [-63.87144934799994, 46.409369208000044],
              [-63.88048255099994, 46.40814850500004],
              [-63.88731848899994, 46.40493398600006],
              [-63.88841712099992, 46.40257396000004],
              [-63.89533443899995, 46.405951239000046],
              [-63.90465247299994, 46.413397528000075],
              [-63.908314581999946, 46.41559479400007],
              [-63.926625128999945, 46.421942450000074],
              [-63.934478318999936, 46.423041083000044],
              [-63.95612545499995, 46.409409898000035],
              [-63.987172003999945, 46.399603583000044],
              [-64.08267167899993, 46.409409898000035],
              [-64.11025956899994, 46.40810781500005],
              [-64.12450110599991, 46.40965403900009],
              [-64.13426673099991, 46.41559479400007],
              [-64.13752193899995, 46.429022528000075],
              [-64.13345292899993, 46.442613023000035],
              [-64.12486731699994, 46.44969310100004],
              [-64.11436926999994, 46.44354889500005],
              [-64.11070716099994, 46.473822333000044],
              [-64.11461341099994, 46.51264069200005],
              [-64.10802161399994, 46.54437897300005],
              [-64.07274329299992, 46.55341217700004],
              [-64.07689368399991, 46.562933661000045],
              [-64.07896887899994, 46.566473700000074],
              [-64.06191972599993, 46.569973049000055],
              [-64.06383216099994, 46.57876211100006],
              [-64.07331295499995, 46.58926015800006],
              [-64.07896887899994, 46.59780508000006],
              [-64.07892818899995, 46.61888255400004],
              [-64.07713782499991, 46.628241278000075],
              [-64.07274329299992, 46.64215729400007],
              [-64.13101152299993, 46.59910716400009],
              [-64.14476477799991, 46.59780508000006],
              [-64.15330969999991, 46.60407135600008],
              [-64.16551673099991, 46.60956452000005],
              [-64.17845618399991, 46.61347077000005],
              [-64.18944251199991, 46.614894924000055],
              [-64.19688880099994, 46.61782461100006],
              [-64.21841386599993, 46.63141510600008],
              [-64.23045813699991, 46.63532135600008],
              [-64.32262122299994, 46.63532135600008],
              [-64.36432857999995, 46.626939195000034],
              [-64.38304602799991, 46.627834377000056],
              [-64.40241451699995, 46.64215729400007],
              [-64.41681881399995, 46.68276601800005],
              [-64.40151933499993, 46.72296784100007],
              [-64.36945553299995, 46.75877513200004],
              [-64.33348548099991, 46.78620026200008],
              [-64.29092363199993, 46.80955638200004],
              [-64.27232825399994, 46.82501862200007],
              [-64.26455644399994, 46.84454987200007],
              [-64.25942949099993, 46.866400458000044],
              [-64.24693762899994, 46.88629791900007],
              [-64.23131262899994, 46.90330638200004],
              [-64.16266842399995, 46.95620351800005],
              [-64.05272376199991, 47.021470445000034],
              [-63.99705969999991, 47.06732819200005],
              [-63.98851477799991, 47.05426666900007],
              [-63.98534094999991, 47.04718659100007],
              [-63.98338782499991, 47.04002513200004],
              [-63.99592037699995, 47.00971100500004],
              [-63.99779212099992, 46.97101471600007],
              [-63.99006100199995, 46.93333567900004],
              [-63.973215298999946, 46.905951239000046],
              [-63.97484290299991, 46.89398834800005],
              [-64.02497311099995, 46.84829336100006],
              [-64.02843176999994, 46.84227122600004],
              [-64.03490149599992, 46.82648346600007],
              [-64.03799394399994, 46.82094961100006],
              [-64.0423070949999, 46.82086823100008],
              [-64.04893958199995, 46.822251695000034],
              [-64.05553137899994, 46.81932200700004],
              [-64.05972245999993, 46.806626695000034],
              [-64.06395423099991, 46.80853913000004],
              [-64.07481848899994, 46.81150950700004],
              [-64.07896887899994, 46.81346263200004],
              [-64.07900956899994, 46.802720445000034],
              [-64.0813695949999, 46.79401276200008],
              [-64.08592688699991, 46.78668854400007],
              [-64.09325110599991, 46.77997467700004],
              [-64.07192949099993, 46.75775788000004],
              [-64.05606035099993, 46.74884674700007],
              [-64.03490149599992, 46.74518463700008],
              [-64.01451575399994, 46.74819570500006],
              [-63.9993383449999, 46.753119208000044],
              [-63.985585089999915, 46.75413646000004],
              [-63.96979732999995, 46.74518463700008],
              [-63.974720831999946, 46.73859284100007],
              [-63.98338782499991, 46.71727122600004],
              [-63.960194464999915, 46.70766836100006],
              [-63.93903561099995, 46.69525788000004],
              [-63.91954505099994, 46.68024323100008],
              [-63.90147864499994, 46.66266510600008],
              [-63.88658606699994, 46.65119049700007],
              [-63.881418423999946, 46.64288971600007],
              [-63.880970831999946, 46.62913646000004],
              [-63.88581295499995, 46.61782461100006],
              [-63.89403235599991, 46.61538320500006],
              [-63.904286261999914, 46.61977773600006],
              [-63.91510982999995, 46.62913646000004],
              [-63.91246497299994, 46.61664459800005],
              [-63.90664628799993, 46.60797760600008],
              [-63.89745032499991, 46.60293203300006],
              [-63.88467363199993, 46.601263739000046],
              [-63.871205206999946, 46.603176174000055],
              [-63.86705481699994, 46.60814036700003],
              [-63.86558997299994, 46.61469147300005],
              [-63.86046301999994, 46.62173086100006],
              [-63.86286373599995, 46.62343984600005],
              [-63.86115475199995, 46.62970612200007],
              [-63.85484778599994, 46.632879950000074],
              [-63.843413865999935, 46.625433661000045],
              [-63.83690344999991, 46.61823151200008],
              [-63.833648240999935, 46.61237213700008],
              [-63.83617102799991, 46.60700104400007],
              [-63.84683183499993, 46.601263739000046],
              [-63.84365800699993, 46.59723541900007],
              [-63.84194902299993, 46.59365469000005],
              [-63.83926347599993, 46.59048086100006],
              [-63.83315995999993, 46.587591864000046],
              [-63.83315995999993, 46.58075592700004],
              [-63.84528561099995, 46.578192450000074],
              [-63.85171464799993, 46.57367584800005],
              [-63.880970831999946, 46.52240631700005],
              [-63.894520636999914, 46.51666901200008],
              [-63.92162024599992, 46.51117584800005],
              [-63.94204667899993, 46.50031159100007],
              [-63.935617641999954, 46.47833893400008],
              [-63.91978919199994, 46.49266185100004],
              [-63.902007615999935, 46.49876536700003],
              [-63.86046301999994, 46.506293036000045],
              [-63.84406490799995, 46.515692450000074],
              [-63.83503170499995, 46.51972077000005],
              [-63.82575436099995, 46.51927317900004],
              [-63.81851152299993, 46.51243724200003],
              [-63.81297766799992, 46.50067780200004],
              [-63.81297766799992, 46.489488023000035],
              [-63.82262122299994, 46.48456452000005],
              [-63.83299719999991, 46.48191966400009],
              [-63.833648240999935, 46.47565338700008],
              [-63.82884680899991, 46.46784088700008],
              [-63.82262122299994, 46.460638739000046],
              [-63.813384568999936, 46.45587799700007],
              [-63.72956295499995, 46.443345445000034],
              [-63.70889238199993, 46.44415924700007],
              [-63.69664466099994, 46.45722077000005],
              [-63.71320553299995, 46.47760651200008],
              [-63.73180091099994, 46.49603913000004],
              [-63.73424231699994, 46.51068756700005],
              [-63.70225989499994, 46.51927317900004],
              [-63.70225989499994, 46.525458075000074],
              [-63.7219945949999, 46.53180573100008],
              [-63.730132615999935, 46.53294505400004],
              [-63.71080481699994, 46.55841705900008],
              [-63.67686926999994, 46.568060614000046],
              [-63.63890540299991, 46.56704336100006],
              [-63.53673255099994, 46.54466380400004],
              [-63.52098548099991, 46.536322333000044],
              [-63.51732337099992, 46.533636786000045],
              [-63.51325436099995, 46.53270091400009],
              [-63.503977016999954, 46.53294505400004],
              [-63.49474036399994, 46.53115469000005],
              [-63.49376380099994, 46.52692291900007],
              [-63.496205206999946, 46.522365627000056],
              [-63.49742591099994, 46.51927317900004],
              [-63.49632727799991, 46.51284414300005],
              [-63.498931443999936, 46.50649648600006],
              [-63.50080318899995, 46.499660549000055],
              [-63.49742591099994, 46.49201080900008],
              [-63.48192298099991, 46.492621161000045],
              [-63.45661373599995, 46.46743398600006],
              [-63.44554602799991, 46.46747467700004],
              [-63.43260657499991, 46.483710028000075],
              [-63.428944464999915, 46.49746328300006],
              [-63.43809973899994, 46.505845445000034],
              [-63.46324622299994, 46.506293036000045],
              [-63.43651282499991, 46.51251862200007],
              [-63.39903723899994, 46.51211172100005],
              [-63.36091061099995, 46.50690338700008],
              [-63.33234615799995, 46.49884674700007],
              [-63.31777910099993, 46.48899974200003],
              [-63.31358801999994, 46.47833893400008],
              [-63.31208248599995, 46.46596914300005],
              [-63.305572068999936, 46.45099518400008],
              [-63.30215410099993, 46.45099518400008],
              [-63.28034420499995, 46.43927643400008],
              [-63.26353919199994, 46.42597077000005],
              [-63.25719153599994, 46.423081773000035],
              [-63.25035559799994, 46.42987702000005],
              [-63.245025193999936, 46.412543036000045],
              [-63.23810787699995, 46.407416083000044],
              [-63.22874915299991, 46.40997955900008],
              [-63.21621660099993, 46.41559479400007],
              [-63.21422278599994, 46.41791413000004],
              [-63.212554490999935, 46.42182038000004],
              [-63.20933997299994, 46.426214911000045],
              [-63.20254472599993, 46.42987702000005],
              [-63.19473222599993, 46.43113841400009],
              [-63.08112545499995, 46.42088450700004],
              [-62.953195766999954, 46.42405833500004],
              [-62.849720831999946, 46.43740469000005],
              [-62.841867641999954, 46.430853583000044],
              [-62.83340410099993, 46.41950104400007],
              [-62.82380123599995, 46.41510651200008],
              [-62.81212317599994, 46.42987702000005],
              [-62.819569464999915, 46.43740469000005],
              [-62.764515753999945, 46.44904205900008],
              [-62.585601365999935, 46.42987702000005],
              [-62.585601365999935, 46.43740469000005],
              [-62.67723548099991, 46.44765859600005],
              [-62.70225989499994, 46.45722077000005],
              [-62.67414303299995, 46.46442291900007],
              [-62.61168372299994, 46.46759674700007],
              [-62.585601365999935, 46.47833893400008],
              [-62.56578528599994, 46.47089264500005],
              [-62.54206295499995, 46.47166575700004],
              [-62.5169164699999, 46.475816148000035],
              [-62.35728919199994, 46.47931549700007],
              [-62.264556443999936, 46.47378164300005],
              [-62.18517005099994, 46.48700592700004],
              [-62.09911048099991, 46.483710028000075],
              [-62.004017706999946, 46.464056708000044],
            ],
          ],
          [
            [
              [-61.67100989499994, 47.546535549000055],
              [-61.69070390499991, 47.534043687000064],
              [-61.69912675699993, 47.52749258000006],
              [-61.74351966099994, 47.48314036700003],
              [-61.7669164699999, 47.47138092700004],
              [-61.79076087099992, 47.464544989000046],
              [-61.83568274599992, 47.432806708000044],
              [-61.859364386999914, 47.42365143400008],
              [-61.82217363199993, 47.415350653000075],
              [-61.78538977799991, 47.43382396000004],
              [-61.671538865999935, 47.537990627000056],
              [-61.63621985599991, 47.557074286000045],
              [-61.59251868399991, 47.56077708500004],
              [-61.62531490799995, 47.549261786000045],
              [-61.656361456999946, 47.53066640800006],
              [-61.70860755099994, 47.48574453300006],
              [-61.76504472599993, 47.41107819200005],
              [-61.778228318999936, 47.40582916900007],
              [-61.821522589999915, 47.40997955900008],
              [-61.836496548999946, 47.40143463700008],
              [-61.84797115799995, 47.38263580900008],
              [-61.85651607999995, 47.36391836100006],
              [-61.86278235599991, 47.35537344000005],
              [-61.90192623599995, 47.35370514500005],
              [-61.916900193999936, 47.34870026200008],
              [-61.93138587099992, 47.338324286000045],
              [-61.94050045499995, 47.326605536000045],
              [-61.956288214999915, 47.29629140800006],
              [-61.96556555899991, 47.28302643400008],
              [-61.95933997299994, 47.27407461100006],
              [-61.94098873599995, 47.26227448100008],
              [-61.92027747299994, 47.26007721600007],
              [-61.90721594999991, 47.27968984600005],
              [-61.896595831999946, 47.26520416900007],
              [-61.88341223899994, 47.255926825000074],
              [-61.86681067599994, 47.24994538000004],
              [-61.825062628999945, 47.242621161000045],
              [-61.810658331999946, 47.24433014500005],
              [-61.79845130099994, 47.251654364000046],
              [-61.78429114499994, 47.26601797100005],
              [-61.793039516999954, 47.240301825000074],
              [-61.81602942599994, 47.22833893400008],
              [-61.845366990999935, 47.22500234600005],
              [-61.873036261999914, 47.225043036000045],
              [-61.87486731699994, 47.237616278000075],
              [-61.895090298999946, 47.233710028000075],
              [-61.93822180899991, 47.21820709800005],
              [-61.988840298999946, 47.217230536000045],
              [-62.01056881399995, 47.22479889500005],
              [-62.01707923099991, 47.24551015800006],
              [-61.98973548099991, 47.273423570000034],
              [-61.96776282499991, 47.30756256700005],
              [-61.959055141999954, 47.31753164300005],
              [-61.94945227799991, 47.33616771000004],
              [-61.9485570949999, 47.38275788000004],
              [-61.94131425699993, 47.40253327000005],
              [-61.92552649599992, 47.41315338700008],
              [-61.901234503999945, 47.42206452000005],
              [-61.87559973899994, 47.428168036000045],
              [-61.856027798999946, 47.43048737200007],
              [-61.83926347599993, 47.43667226800005],
              [-61.7007136709999, 47.53188711100006],
              [-61.69351152299993, 47.536810614000046],
              [-61.56212317599994, 47.62714264500005],
              [-61.53726152299993, 47.63654205900008],
              [-61.505930141999954, 47.64142487200007],
              [-61.38634192599994, 47.64398834800005],
              [-61.38219153599994, 47.63666413000004],
              [-61.388661261999914, 47.62571849200003],
              [-61.400054490999935, 47.61603424700007],
              [-61.432525193999936, 47.60809967700004],
              [-61.448475714999915, 47.60053131700005],
              [-61.45531165299991, 47.58466217700004],
              [-61.46947180899991, 47.56948476800005],
              [-61.50108801999994, 47.55678945500006],
              [-61.53384355399993, 47.552069403000075],
              [-61.55150305899991, 47.56077708500004],
              [-61.527414516999954, 47.568793036000045],
              [-61.50230872299994, 47.58266836100006],
              [-61.481312628999945, 47.60097890800006],
              [-61.46898352799991, 47.622259833000044],
              [-61.49722245999993, 47.624335028000075],
              [-61.526600714999915, 47.62213776200008],
              [-61.55459550699993, 47.61497630400004],
              [-61.57884680899991, 47.60175202000005],
              [-61.62071692599994, 47.56818268400008],
              [-61.64598548099991, 47.55292389500005],
              [-61.67100989499994, 47.546535549000055],
            ],
          ],
          [
            [
              [-64.50475012899994, 47.88979726800005],
              [-64.51195227799991, 47.90253327000005],
              [-64.50405839799993, 47.91669342700004],
              [-64.47744706899994, 47.94440338700008],
              [-64.47704016799992, 47.93781159100007],
              [-64.47866777299993, 47.93317291900007],
              [-64.49233964799993, 47.91063060100004],
              [-64.49889075399994, 47.89276764500005],
              [-64.5032445949999, 47.87417226800005],
              [-64.50475012899994, 47.858710028000075],
              [-64.50902258999992, 47.84454987200007],
              [-64.51891028599994, 47.829291083000044],
              [-64.53892981699994, 47.80719635600008],
              [-64.59349524599992, 47.76536692900004],
              [-64.64879309799994, 47.732123114000046],
              [-64.65420488199993, 47.74705638200004],
              [-64.66600501199991, 47.752834377000056],
              [-64.68106035099993, 47.75503164300005],
              [-64.6966039699999, 47.759426174000055],
              [-64.65501868399991, 47.782904364000046],
              [-64.64879309799994, 47.79047272300005],
              [-64.65420488199993, 47.80190664300005],
              [-64.66665605399993, 47.80263906500005],
              [-64.68040930899991, 47.79800039300005],
              [-64.68976803299995, 47.79360586100006],
              [-64.68716386599993, 47.80263906500005],
              [-64.68285071499992, 47.81004466400009],
              [-64.67674719999991, 47.816066799000055],
              [-64.66860917899993, 47.82086823100008],
              [-64.68626868399991, 47.81928131700005],
              [-64.69664466099994, 47.82103099200003],
              [-64.70006262899994, 47.82794830900008],
              [-64.6966039699999, 47.84198639500005],
              [-64.69098873599995, 47.85028717700004],
              [-64.68053137899994, 47.861395575000074],
              [-64.66869055899991, 47.87128327000005],
              [-64.65868079299992, 47.87547435100004],
              [-64.59552975199995, 47.88548411700003],
              [-64.56798255099994, 47.88304271000004],
              [-64.57990475199995, 47.86245351800005],
              [-64.55894934799994, 47.869574286000045],
              [-64.53864498599995, 47.87010325700004],
              [-64.52013098899994, 47.87360260600008],
              [-64.50475012899994, 47.88979726800005],
            ],
          ],
          [
            [
              [-64.54576575399994, 47.97166575700004],
              [-64.52578691299993, 48.020697333000044],
              [-64.51081295499995, 48.03359609600005],
              [-64.48428300699993, 48.02008698100008],
              [-64.48005123599995, 47.99835846600007],
              [-64.47301184799994, 47.98094310100004],
              [-64.47240149599992, 47.96336497600004],
              [-64.48741614499994, 47.94122955900008],
              [-64.50780188699991, 47.92829010600008],
              [-64.56826738199993, 47.90696849200003],
              [-64.59044348899994, 47.90346914300005],
              [-64.59410559799994, 47.91437409100007],
              [-64.57713782499991, 47.93842194200005],
              [-64.54576575399994, 47.97166575700004],
            ],
          ],
          [
            [
              [-64.31920325399994, 49.79124583500004],
              [-64.33543860599991, 49.81549713700008],
              [-64.36717688699991, 49.82562897300005],
              [-64.38874264199995, 49.81940338700008],
              [-64.37441972599993, 49.794623114000046],
              [-64.39753170499995, 49.79783763200004],
              [-64.42471269399994, 49.80849844000005],
              [-64.44749915299991, 49.82339101800005],
              [-64.45702063699991, 49.83930084800005],
              [-64.47061113199993, 49.852443752000056],
              [-64.49620520699995, 49.858628648000035],
              [-64.51056881399995, 49.868068752000056],
              [-64.49054928299995, 49.89085521000004],
              [-64.45128333199995, 49.909491278000075],
              [-64.3509008449999, 49.927435614000046],
              [-64.29385331899994, 49.93109772300005],
              [-64.26911373599995, 49.92959219000005],
              [-64.25772050699993, 49.93121979400007],
              [-64.24518795499995, 49.937486070000034],
              [-64.23778235599991, 49.94448476800005],
              [-64.22935950399994, 49.95001862200007],
              [-64.21369381399995, 49.952337958000044],
              [-64.13280188699991, 49.95014069200005],
              [-64.02700761599993, 49.92096588700008],
              [-64.00080318899995, 49.91815827000005],
              [-63.99193274599992, 49.91620514500005],
              [-63.9446508449999, 49.89606354400007],
              [-63.698150193999936, 49.867254950000074],
              [-63.60533606699994, 49.85024648600006],
              [-63.51284745999993, 49.84552643400008],
              [-63.374663865999935, 49.829413153000075],
              [-63.20860755099994, 49.79075755400004],
              [-63.12409420499995, 49.78388092700004],
              [-63.044911261999914, 49.75372955900008],
              [-62.962147589999915, 49.74054596600007],
              [-62.93883216099994, 49.72943756700005],
              [-62.90465247299994, 49.70184967700004],
              [-62.89297441299993, 49.69745514500005],
              [-62.84630286399994, 49.698431708000044],
              [-62.77574622299994, 49.669175523000035],
              [-62.75755774599992, 49.66429271000004],
              [-62.73070227799991, 49.66315338700008],
              [-62.707915818999936, 49.659369208000044],
              [-62.687611456999946, 49.65302155200004],
              [-62.617258266999954, 49.62051015800006],
              [-62.58971106699994, 49.61269765800006],
              [-62.53425045499995, 49.604681708000044],
              [-62.51280676999994, 49.59227122600004],
              [-62.47573808499993, 49.56191640800006],
              [-62.46983801999994, 49.56000397300005],
              [-62.45409094999991, 49.557928778000075],
              [-62.44839433499993, 49.55508047100005],
              [-62.445423956999946, 49.54979075700004],
              [-62.443430141999954, 49.53847890800006],
              [-62.44163977799991, 49.53461334800005],
              [-62.39728756399995, 49.49673086100006],
              [-62.38589433499993, 49.49042389500005],
              [-62.37474524599992, 49.48997630400004],
              [-62.3528539699999, 49.49359772300005],
              [-62.33922278599994, 49.49091217700004],
              [-62.31126868399991, 49.47256094000005],
              [-62.29987545499995, 49.469631252000056],
              [-62.27574622299994, 49.46824778900009],
              [-62.26414954299992, 49.465725002000056],
              [-62.25381425699993, 49.45856354400007],
              [-62.226226365999935, 49.430894273000035],
              [-62.22008216099994, 49.427801825000074],
              [-62.21328691299993, 49.42104726800005],
              [-62.204335089999915, 49.41421133000006],
              [-62.19176184799994, 49.41107819200005],
              [-62.17808997299994, 49.40924713700008],
              [-62.13312740799995, 49.39679596600007],
              [-62.01805579299992, 49.388373114000046],
              [-62.00609290299991, 49.38422272300005],
              [-61.97179114499994, 49.36692942900004],
              [-61.95103919199994, 49.35297272300005],
              [-61.94131425699993, 49.34902578300006],
              [-61.90416419199994, 49.35419342700004],
              [-61.88263912699995, 49.35447825700004],
              [-61.86563066299993, 49.33763255400004],
              [-61.81786048099991, 49.30805084800005],
              [-61.82652747299994, 49.294989325000074],
              [-61.818918423999946, 49.286769924000055],
              [-61.79051673099991, 49.273871161000045],
              [-61.787220831999946, 49.26894765800006],
              [-61.78062903599994, 49.25299713700008],
              [-61.77684485599991, 49.24656810100004],
              [-61.77171790299991, 49.243353583000044],
              [-61.74950110599991, 49.23289622600004],
              [-61.73737545499995, 49.22134023600006],
              [-61.70860755099994, 49.18451569200005],
              [-61.68468176999994, 49.16583893400008],
              [-61.66075598899994, 49.15102773600006],
              [-61.67100989499994, 49.141058661000045],
              [-61.69298255099994, 49.12962474200003],
              [-61.702381964999915, 49.123032945000034],
              [-61.70750891799992, 49.11151764500005],
              [-61.70490475199995, 49.10297272300005],
              [-61.707020636999914, 49.09760163000004],
              [-61.726226365999935, 49.095770575000074],
              [-61.74547278599994, 49.097723700000074],
              [-61.75731360599991, 49.096869208000044],
              [-61.81163489499994, 49.06903717700004],
              [-61.824208136999914, 49.070013739000046],
              [-61.86620032499991, 49.082098700000074],
              [-61.882069464999915, 49.083685614000046],
              [-62.05064856699994, 49.07453034100007],
              [-62.12999426999994, 49.082098700000074],
              [-62.24819902299993, 49.06793854400007],
              [-62.27684485599991, 49.071600653000075],
              [-62.30333411399994, 49.079779364000046],
              [-62.32213294199994, 49.09202708500004],
              [-62.34260006399995, 49.10219961100006],
              [-62.416900193999936, 49.11200592700004],
              [-62.50625566299993, 49.13857656500005],
              [-62.681752081999946, 49.148504950000074],
              [-62.88451087099992, 49.196519273000035],
              [-63.09333248599995, 49.23289622600004],
              [-63.16466223899994, 49.262925523000035],
              [-63.21239173099991, 49.27289459800005],
              [-63.27769934799994, 49.314886786000045],
              [-63.33421790299991, 49.32440827000005],
              [-63.36363684799994, 49.34015534100007],
              [-63.382923956999946, 49.34780508000006],
              [-63.40379798099991, 49.353583075000074],
              [-63.46206620999993, 49.359361070000034],
              [-63.586781378999945, 49.389960028000075],
              [-63.573150193999936, 49.40485260600008],
              [-63.58458411399994, 49.419134833000044],
              [-63.60387122299994, 49.43349844000005],
              [-63.614125128999945, 49.44863515800006],
              [-63.614898240999935, 49.46771881700005],
              [-63.61851966099994, 49.48379140800006],
              [-63.62677975199995, 49.49843984600005],
              [-63.64142818899995, 49.51349518400008],
              [-63.67723548099991, 49.54169342700004],
              [-63.764230923999946, 49.601996161000045],
              [-63.92516028599994, 49.67487213700008],
              [-64.05882727799991, 49.714544989000046],
              [-64.17796790299991, 49.74095286700003],
              [-64.30239824099993, 49.778998114000046],
              [-64.31920325399994, 49.79124583500004],
            ],
          ],
          [
            [
              [-63.88467363199993, 50.19936758000006],
              [-63.91226152299993, 50.205959377000056],
              [-63.926991339999915, 50.22142161700003],
              [-63.92479407499991, 50.23965078300006],
              [-63.90147864499994, 50.253973700000074],
              [-63.89858964799993, 50.249986070000034],
              [-63.89561926999994, 50.24835846600007],
              [-63.88841712099992, 50.246527411000045],
              [-63.857533331999946, 50.21743398600006],
              [-63.85606848899994, 50.20465729400007],
              [-63.88467363199993, 50.19936758000006],
            ],
          ],
          [
            [
              [-79.39509029899995, 52.08372630400004],
              [-79.36758378799993, 52.09784577000005],
              [-79.34870357999995, 52.10504791900007],
              [-79.32900956899994, 52.10496653900003],
              [-79.29946855399993, 52.09739817900004],
              [-79.28368079299992, 52.09650299700007],
              [-79.27232825399994, 52.09137604400007],
              [-79.25169837099992, 52.07689036700003],
              [-79.29523678299995, 52.05540599200003],
              [-79.30943762899994, 52.04588450700004],
              [-79.32054602799991, 52.03351471600007],
              [-79.32559160099993, 52.02130768400008],
              [-79.32689368399991, 52.009466864000046],
              [-79.32664954299992, 51.981756903000075],
              [-79.32860266799992, 51.97138092700004],
              [-79.33649654899995, 51.963324286000045],
              [-79.35411536399994, 51.95343659100007],
              [-79.37340247299994, 51.94525788000004],
              [-79.39305579299992, 51.94025299700007],
              [-79.41397050699993, 51.93829987200007],
              [-79.51549231699994, 51.946600653000075],
              [-79.58409583199995, 51.932928778000075],
              [-79.59072831899994, 51.93065013200004],
              [-79.60411536399994, 51.92088450700004],
              [-79.61107337099992, 51.91864655200004],
              [-79.6204320949999, 51.92047760600008],
              [-79.62100175699993, 51.925034898000035],
              [-79.61929277299993, 51.93158600500004],
              [-79.62165279899995, 51.939154364000046],
              [-79.65575110599991, 51.987494208000044],
              [-79.63980058499993, 52.01618073100008],
              [-79.63532467399995, 52.02167389500005],
              [-79.62108313699991, 52.02578359600005],
              [-79.61046301999994, 52.02289459800005],
              [-79.59947669199994, 52.017645575000074],
              [-79.58409583199995, 52.014837958000044],
              [-79.55744381399995, 52.01902903900003],
              [-79.53359941299993, 52.029730536000045],
              [-79.51276607999995, 52.044134833000044],
              [-79.49474036399994, 52.05955638200004],
              [-79.48399817599994, 52.06391022300005],
              [-79.45620683499993, 52.063381252000056],
              [-79.44383704299992, 52.066107489000046],
              [-79.39509029899995, 52.08372630400004],
            ],
          ],
          [
            [
              [-80.75934811099995, 52.919175523000035],
              [-80.72370357999995, 52.86277903900003],
              [-80.71837317599994, 52.84756094000005],
              [-80.67837480399993, 52.78042226800005],
              [-80.66958574099993, 52.74201080900008],
              [-80.70470130099994, 52.72125885600008],
              [-80.69953365799995, 52.70014069200005],
              [-80.71768144399994, 52.694973049000055],
              [-80.74380449099993, 52.70018138200004],
              [-80.78453528599994, 52.72304922100005],
              [-81.02684485599991, 52.75263092700004],
              [-81.15176347599993, 52.803168036000045],
              [-81.28628495999993, 52.84414297100005],
              [-81.4688207669999, 52.86127350500004],
              [-81.64940344999991, 52.903509833000044],
              [-81.79234778599994, 52.94220612200007],
              [-81.95173092399995, 52.97443268400008],
              [-82.01598059799994, 53.01044342700004],
              [-82.06265214799993, 53.022772528000075],
              [-82.05361894399994, 53.03974030200004],
              [-82.01317298099991, 53.070013739000046],
              [-82.00767981699994, 53.07575104400007],
              [-81.98501542899993, 53.10700104400007],
              [-81.94408118399991, 53.14370351800005],
              [-81.88280188699991, 53.17987702000005],
              [-81.85777747299994, 53.185248114000046],
              [-81.78038489499994, 53.17987702000005],
              [-81.75706946499992, 53.18260325700004],
              [-81.66624915299991, 53.20697663000004],
              [-81.61485755099994, 53.21381256700005],
              [-81.49486243399991, 53.21312083500004],
              [-81.42438717399995, 53.22882721600007],
              [-81.17422441299993, 53.21234772300005],
              [-81.12279212099992, 53.20221588700008],
              [-81.00576738199993, 53.12531159100007],
              [-80.98509680899991, 53.11554596600007],
              [-80.97760982999995, 53.11029694200005],
              [-80.96825110599991, 53.10106028900003],
              [-80.94790605399993, 53.069525458000044],
              [-80.9348852199999, 53.060614325000074],
              [-80.87913977799991, 53.03217194200005],
              [-80.77953040299991, 52.94871653900003],
              [-80.76842200399994, 52.934800523000035],
              [-80.75934811099995, 52.919175523000035],
            ],
          ],
          [
            [
              [-79.75816809799994, 53.52252838700008],
              [-79.7676488919999, 53.53143952000005],
              [-79.76919511599993, 53.53546784100007],
              [-79.76720130099994, 53.53900788000004],
              [-79.76561438699991, 53.54669830900008],
              [-79.70360266799992, 53.51630280200004],
              [-79.70815995999993, 53.51154205900008],
              [-79.71288001199991, 53.50958893400008],
              [-79.72472083199995, 53.50885651200008],
              [-79.73277747299994, 53.51276276200008],
              [-79.75096594999991, 53.51837799700007],
              [-79.75816809799994, 53.52252838700008],
            ],
          ],
          [
            [
              [-79.28587805899991, 54.91351959800005],
              [-79.01891028599994, 54.94082265800006],
              [-79.02603105399993, 54.931708075000074],
              [-79.03595943899995, 54.926947333000044],
              [-79.15135657499991, 54.90228913000004],
              [-79.24168860599991, 54.89793528900003],
              [-79.26805579299992, 54.89203522300005],
              [-79.29263261599993, 54.879339911000045],
              [-79.31265214799993, 54.88198476800005],
              [-79.40192623599995, 54.851996161000045],
              [-79.60350501199991, 54.82880280200004],
              [-79.75792395699995, 54.780178127000056],
              [-79.77993730399993, 54.78375885600008],
              [-79.76244055899991, 54.79572174700007],
              [-79.73501542899993, 54.804754950000074],
              [-79.70588131399995, 54.81012604400007],
              [-79.68309485599991, 54.81110260600008],
              [-79.68309485599991, 54.81785716400003],
              [-79.73151607999995, 54.81785716400003],
              [-79.69725501199991, 54.84076569200005],
              [-79.65392005099994, 54.85443756700005],
              [-79.46963456899994, 54.88959381700005],
              [-79.36778723899994, 54.893011786000045],
              [-79.34805253799993, 54.89590078300006],
              [-79.30719967399995, 54.90932851800005],
              [-79.28587805899991, 54.91351959800005],
            ],
          ],
          [
            [
              [-77.31208248599995, 55.619208075000074],
              [-77.24498450399994, 55.64484284100007],
              [-77.21125240799995, 55.65375397300005],
              [-77.20962480399993, 55.63971588700008],
              [-77.22386633999992, 55.63735586100006],
              [-77.23717200399994, 55.63190338700008],
              [-77.31920325399994, 55.582017320000034],
              [-77.35240637899994, 55.56736888200004],
              [-77.37751217399995, 55.56028880400004],
              [-77.52611243399991, 55.46539948100008],
              [-77.58629309799994, 55.43622467700004],
              [-77.64785722599993, 55.427435614000046],
              [-77.61900794199994, 55.437486070000034],
              [-77.44839433499993, 55.534084377000056],
              [-77.41307532499991, 55.56232330900008],
              [-77.3801977199999, 55.57245514500005],
              [-77.36668860599991, 55.57827383000006],
              [-77.34337317599994, 55.60236237200007],
              [-77.32917232999995, 55.61420319200005],
              [-77.31208248599995, 55.619208075000074],
            ],
          ],
          [
            [
              [-79.00527910099993, 56.01703522300005],
              [-78.97044837099992, 56.02802155200004],
              [-78.95270748599995, 56.03070709800005],
              [-78.93639075399994, 56.02448151200008],
              [-78.97032630099994, 56.00503164300005],
              [-78.99860592399995, 55.98261139500005],
              [-79.02139238199993, 55.95368073100008],
              [-79.03258216099994, 55.91461823100008],
              [-79.04898027299993, 55.87929922100005],
              [-79.07827714799993, 55.83429596600007],
              [-79.11217200399994, 55.80023834800005],
              [-79.14244544199994, 55.79734935100004],
              [-79.12389075399994, 55.809027411000045],
              [-79.10537675699993, 55.83120351800005],
              [-79.08975175699993, 55.857082424000055],
              [-79.05752519399994, 55.92999909100007],
              [-79.03258216099994, 55.98232656500005],
              [-79.02806555899991, 55.99258047100005],
              [-79.02521725199995, 56.02448151200008],
              [-79.01862545499995, 56.049261786000045],
              [-79.01329505099994, 56.05906810100004],
              [-79.00255286399994, 56.06386953300006],
              [-78.98729407499991, 56.06439850500004],
              [-78.96568762899994, 56.083644924000055],
              [-78.95067298099991, 56.07851797100005],
              [-78.95376542899993, 56.068019924000055],
              [-78.95555579299992, 56.05841705900008],
              [-78.95482337099992, 56.05019765800006],
              [-78.95067298099991, 56.04376862200007],
              [-78.95067298099991, 56.037543036000045],
              [-78.9661352199999, 56.036322333000044],
              [-78.97984778599994, 56.03180573100008],
              [-79.00527910099993, 56.01703522300005],
            ],
          ],
          [
            [
              [-78.75763912699995, 56.16791413000004],
              [-78.77745520699995, 56.17267487200007],
              [-78.79649817599994, 56.161769924000055],
              [-78.81505286399994, 56.14520905200004],
              [-78.83336341099994, 56.13312409100007],
              [-78.88451087099992, 56.12189362200007],
              [-78.93639075399994, 56.11945221600007],
              [-78.93138587099992, 56.13178131700005],
              [-78.92491614499994, 56.16095612200007],
              [-78.91934160099993, 56.17133209800005],
              [-78.84048417899993, 56.248480536000045],
              [-78.82896887899994, 56.26902903900003],
              [-78.84703528599994, 56.277777411000045],
              [-78.83580481699994, 56.28961823100008],
              [-78.82135982999995, 56.300482489000046],
              [-78.81456458199995, 56.310248114000046],
              [-78.82656816299993, 56.31875234600005],
              [-78.82176673099991, 56.325100002000056],
              [-78.81285559799994, 56.345404364000046],
              [-78.83336341099994, 56.345404364000046],
              [-78.82502193899995, 56.35834381700005],
              [-78.7981664699999, 56.37921784100007],
              [-78.78799394399994, 56.40143463700008],
              [-78.77774003799993, 56.41486237200007],
              [-78.75763912699995, 56.434800523000035],
              [-78.73355058499993, 56.44448476800005],
              [-78.69957434799994, 56.44904205900008],
              [-78.67076575399994, 56.443060614000046],
              [-78.66270911399994, 56.421128648000035],
              [-78.66344153599994, 56.35297272300005],
              [-78.65965735599991, 56.31940338700008],
              [-78.64903723899994, 56.29075755400004],
              [-78.66026770699995, 56.280462958000044],
              [-78.66014563699991, 56.267564195000034],
              [-78.65599524599992, 56.25263092700004],
              [-78.65526282499991, 56.23615143400008],
              [-78.66299394399994, 56.22182851800005],
              [-78.67438717399995, 56.20978424700007],
              [-78.68130449099993, 56.19721100500004],
              [-78.67568925699993, 56.18154531500005],
              [-78.68748938699991, 56.17690664300005],
              [-78.69994055899991, 56.17450592700004],
              [-78.71239173099991, 56.17572663000004],
              [-78.72419186099995, 56.18154531500005],
              [-78.74132239499994, 56.16583893400008],
              [-78.75157630099994, 56.161363023000035],
              [-78.76512610599991, 56.16107819200005],
              [-78.75763912699995, 56.16791413000004],
            ],
          ],
          [
            [
              [-79.54588782499991, 56.04376862200007],
              [-79.52879798099991, 56.06122467700004],
              [-79.47451738199993, 56.102728583000044],
              [-79.47081458199995, 56.12103913000004],
              [-79.49315344999991, 56.13157786700003],
              [-79.52391516799992, 56.13532135600008],
              [-79.54588782499991, 56.13312409100007],
              [-79.5840551419999, 56.110663153000075],
              [-79.72276770699995, 55.978583075000074],
              [-79.8301488919999, 55.89862702000005],
              [-79.85635331899994, 55.87140534100007],
              [-79.86188717399995, 55.86277903900003],
              [-79.86705481699994, 55.84349192900004],
              [-79.87975012899994, 55.837144273000035],
              [-79.89525305899991, 55.83421458500004],
              [-79.90904700399994, 55.82526276200008],
              [-79.91266842399995, 55.84324778900003],
              [-79.92357337099992, 55.857082424000055],
              [-79.93407141799992, 55.86709219000005],
              [-79.9363500639999, 55.87372467700004],
              [-79.94912675699993, 55.88906484600005],
              [-79.97085527299993, 55.896918036000045],
              [-80.02570553299995, 55.90033600500004],
              [-80.00251217399995, 55.93927643400008],
              [-79.9876195949999, 55.95526764500005],
              [-79.94904537699995, 55.96820709800005],
              [-79.73717200399994, 56.161444403000075],
              [-79.55101477799991, 56.26630280200004],
              [-79.52538001199991, 56.29364655200004],
              [-79.50499426999994, 56.33234284100007],
              [-79.46751868399991, 56.42869700700004],
              [-79.46129309799994, 56.479681708000044],
              [-79.47826087099992, 56.52415599200003],
              [-79.47435462099992, 56.52606842700004],
              [-79.47154700399994, 56.52802155200004],
              [-79.46849524599992, 56.52960846600007],
              [-79.46397864499994, 56.53034088700008],
              [-79.46597245999993, 56.53510163000004],
              [-79.46886145699995, 56.54734935100004],
              [-79.47081458199995, 56.552069403000075],
              [-79.45372473899994, 56.55951569200005],
              [-79.44579016799992, 56.55499909100007],
              [-79.42992102799991, 56.50995514500005],
              [-79.42601477799991, 56.50348541900007],
              [-79.41559811099995, 56.49689362200007],
              [-79.42369544199994, 56.480536200000074],
              [-79.42796790299991, 56.46356842700004],
              [-79.42983964799993, 56.43138255400004],
              [-79.43517005099994, 56.41421133000006],
              [-79.45864824099993, 56.381293036000045],
              [-79.46397864499994, 56.36961497600004],
              [-79.46719316299993, 56.36432526200008],
              [-79.47423255099994, 56.356675523000035],
              [-79.48127193899995, 56.34707265800006],
              [-79.48448645699995, 56.33576080900008],
              [-79.47923743399991, 56.31150950700004],
              [-79.47826087099992, 56.30133698100008],
              [-79.48241126199991, 56.28628164300005],
              [-79.50470943899995, 56.246079820000034],
              [-79.51549231699994, 56.23273346600007],
              [-79.57384192599994, 56.18154531500005],
              [-79.59618079299992, 56.169175523000035],
              [-79.60387122299994, 56.161444403000075],
              [-79.60741126199991, 56.14740631700005],
              [-79.60732988199993, 56.134466864000046],
              [-79.60464433499993, 56.12905508000006],
              [-79.59829667899993, 56.12921784100007],
              [-79.58751380099994, 56.13312409100007],
              [-79.58006751199991, 56.13906484600005],
              [-79.56802324099993, 56.15888092700004],
              [-79.56017005099994, 56.16791413000004],
              [-79.54637610599991, 56.17719147300005],
              [-79.53083248599995, 56.18471914300005],
              [-79.49815833199995, 56.194566148000035],
              [-79.4492895169999, 56.20351797100005],
              [-79.42870032499991, 56.210150458000044],
              [-79.40933183499993, 56.22247955900008],
              [-79.40933183499993, 56.232855536000045],
              [-79.36099199099993, 56.34845612200007],
              [-79.32477779899995, 56.39484284100007],
              [-79.30874589799993, 56.43528880400004],
              [-79.29914303299995, 56.47992584800005],
              [-79.29063880099994, 56.58567942900004],
              [-79.28587805899991, 56.60610586100006],
              [-79.2849311409999, 56.66104104600004],
              [-79.25831871399993, 56.68184306100005],
              [-79.20395865099994, 56.68498411600007],
              [-79.16567541199993, 56.659408915000085],
              [-79.13426328799994, 56.63440421200005],
              [-79.13265137199994, 56.615098387000046],
              [-79.1539102559999, 56.605384412000035],
              [-79.17602977599995, 56.62193332000004],
              [-79.18998345599994, 56.642910156000084],
              [-79.2230200429999, 56.64950453400007],
              [-79.2476376329999, 56.63174746100003],
              [-79.25528421599995, 56.59533160400008],
              [-79.24699147399991, 56.56206626100004],
              [-79.23497473899994, 56.55145905200004],
              [-79.19029700399994, 56.552069403000075],
              [-79.15925045499995, 56.54466380400004],
              [-79.13805091099994, 56.54779694200005],
              [-79.13097083199995, 56.544175523000035],
              [-79.11754309799994, 56.49103424700007],
              [-79.09349524599992, 56.458970445000034],
              [-79.05760657499991, 56.43695709800005],
              [-79.01154537699995, 56.42796458500004],
              [-78.95775305899991, 56.43471914300005],
              [-78.93614661399994, 56.43024323100008],
              [-78.92271887899994, 56.40810781500005],
              [-78.92271887899994, 56.397365627000056],
              [-78.92918860599991, 56.377386786000045],
              [-78.92894446499992, 56.36591217700004],
              [-78.92577063699991, 56.360581773000035],
              [-78.91397050699993, 56.351223049000055],
              [-78.90904700399994, 56.345404364000046],
              [-78.93407141799992, 56.344183661000045],
              [-78.93639075399994, 56.345404364000046],
              [-78.94859778599994, 56.33087799700007],
              [-78.95221920499995, 56.32245514500005],
              [-78.94692949099993, 56.31875234600005],
              [-78.88182532499991, 56.32558828300006],
              [-78.89195716099994, 56.31085846600007],
              [-78.90819251199991, 56.30296458500004],
              [-78.92662512899994, 56.29767487200007],
              [-78.94322669199994, 56.29075755400004],
              [-78.95750891799992, 56.277411200000074],
              [-78.97057044199994, 56.24750397300005],
              [-78.98078365799995, 56.23273346600007],
              [-79.06216386599993, 56.13934967700004],
              [-79.09801184799994, 56.050848700000074],
              [-79.19546464799993, 55.90477122600004],
              [-79.20327714799993, 55.859442450000074],
              [-79.21548417899993, 55.86310455900008],
              [-79.21837317599994, 55.87221914300005],
              [-79.21373450399994, 55.883246161000045],
              [-79.20327714799993, 55.89288971600007],
              [-79.21011308499993, 55.89288971600007],
              [-79.20156816299993, 55.905951239000046],
              [-79.18346106699994, 55.94818756700005],
              [-79.15347245999993, 55.99506256700005],
              [-79.14338131399995, 56.023138739000046],
              [-79.11986243399991, 56.05536530200004],
              [-79.11107337099992, 56.08698151200008],
              [-78.99010169199994, 56.262600002000056],
              [-78.97362219999991, 56.30426666900007],
              [-78.97020423099991, 56.34284088700008],
              [-78.99787350199995, 56.352850653000075],
              [-78.98273678299995, 56.36994049700007],
              [-78.97472083199995, 56.38458893400008],
              [-78.98021399599992, 56.39203522300005],
              [-79.00527910099993, 56.38703034100007],
              [-79.00609290299991, 56.38495514500005],
              [-79.00666256399995, 56.380926825000074],
              [-79.00812740799995, 56.37653229400007],
              [-79.01154537699995, 56.37335846600007],
              [-79.02603105399993, 56.36790599200003],
              [-79.03359941299993, 56.366400458000044],
              [-79.04255123599995, 56.36591217700004],
              [-79.04938717399995, 56.360663153000075],
              [-79.05622311099995, 56.34857819200005],
              [-79.10049394399994, 56.23305898600006],
              [-79.10228430899991, 56.22150299700007],
              [-79.09748287699995, 56.21629466400003],
              [-79.08556067599994, 56.21710846600007],
              [-79.07469641799992, 56.21942780200004],
              [-79.06566321499992, 56.223537502000056],
              [-79.05931555899991, 56.22931549700007],
              [-79.05247962099992, 56.22931549700007],
              [-79.06167558499993, 56.216498114000046],
              [-79.06663977799991, 56.21206289300005],
              [-79.07359778599994, 56.20888906500005],
              [-79.06334387899994, 56.20351797100005],
              [-79.05931555899991, 56.202053127000056],
              [-79.07331295499995, 56.18040599200003],
              [-79.1126195949999, 56.14012278900003],
              [-79.12071692599994, 56.11603424700007],
              [-79.12511145699995, 56.10956452000005],
              [-79.14435787699995, 56.08706289300005],
              [-79.14867102799991, 56.07514069200005],
              [-79.21910559799994, 55.95221588700008],
              [-79.28587805899991, 55.86627838700008],
              [-79.28062903599994, 55.88808828300006],
              [-79.19709225199995, 56.010199286000045],
              [-79.12816321499992, 56.16107819200005],
              [-79.12873287699995, 56.17991771000004],
              [-79.13141842399995, 56.20502350500004],
              [-79.14098059799994, 56.22679271000004],
              [-79.1555883449999, 56.23615143400008],
              [-79.17218990799995, 56.22931549700007],
              [-79.18984941299993, 56.21320221600007],
              [-79.24840247299994, 56.14516836100006],
              [-79.35484778599994, 55.977850653000075],
              [-79.36465410099993, 55.96930573100008],
              [-79.38101152299993, 55.96198151200008],
              [-79.46934973899994, 55.87938060100004],
              [-79.50926673099991, 55.86497630400004],
              [-79.55382239499994, 55.868475653000075],
              [-79.60741126199991, 55.886704820000034],
              [-79.62291419199994, 55.899318752000056],
              [-79.63385982999995, 55.90298086100006],
              [-79.64525305899991, 55.89667389500005],
              [-79.73908443899995, 55.811835028000075],
              [-79.75816809799994, 55.804754950000074],
              [-79.75853430899991, 55.79975006700005],
              [-79.76447506399995, 55.79511139500005],
              [-79.77424068899995, 55.79169342700004],
              [-79.78612219999991, 55.79047272300005],
              [-79.76716061099995, 55.818060614000046],
              [-79.63182532499991, 55.94122955900008],
              [-79.54588782499991, 56.04376862200007],
            ],
          ],
          [
            [
              [-79.90591386599993, 56.866848049000055],
              [-79.87295488199993, 56.86737702000005],
              [-79.85798092399995, 56.86554596600007],
              [-79.82420813699991, 56.84796784100007],
              [-79.81737219999991, 56.83161041900007],
              [-79.82335364499994, 56.81305573100008],
              [-79.8379613919999, 56.79450104400007],
              [-79.84361731699994, 56.79132721600007],
              [-79.85602779899995, 56.78925202000005],
              [-79.86188717399995, 56.784857489000046],
              [-79.86327063699991, 56.780910549000055],
              [-79.86607825399994, 56.768011786000045],
              [-79.86803137899994, 56.763739325000074],
              [-79.87975012899994, 56.75275299700007],
              [-79.88805091099994, 56.74909088700008],
              [-79.91270911399994, 56.750067450000074],
              [-79.93936113199993, 56.76048411700003],
              [-79.95173092399995, 56.785223700000074],
              [-79.95238196499992, 56.81468333500004],
              [-79.94375566299993, 56.839504299000055],
              [-79.93822180899991, 56.844916083000044],
              [-79.91494706899994, 56.86286041900007],
              [-79.90591386599993, 56.866848049000055],
            ],
          ],
          [
            [
              [-77.92162024599992, 58.33283112200007],
              [-77.81794186099995, 58.30878327000005],
              [-77.69725501199991, 58.25560130400004],
              [-77.66832434799994, 58.25092194200005],
              [-77.66832434799994, 58.24469635600008],
              [-77.69835364499994, 58.240668036000045],
              [-77.73827063699991, 58.250433661000045],
              [-77.94945227799991, 58.326605536000045],
              [-77.94945227799991, 58.33283112200007],
              [-77.92365475199995, 58.33380768400008],
              [-77.91539466099994, 58.33283112200007],
              [-77.92162024599992, 58.33283112200007],
            ],
          ],
          [
            [
              [-78.64159094999991, 58.62832265800006],
              [-78.62385006399995, 58.61570872600004],
              [-78.48306230399993, 58.552801825000074],
              [-78.45665442599994, 58.54637278900003],
              [-78.45665442599994, 58.53888580900008],
              [-78.63044186099995, 58.59589264500005],
              [-78.68317623599995, 58.62083567900004],
              [-78.67804928299995, 58.62750885600008],
              [-78.67251542899993, 58.63190338700008],
              [-78.6653539699999, 58.634100653000075],
              [-78.65526282499991, 58.63450755400004],
              [-78.65526282499991, 58.64130280200004],
              [-78.67430579299992, 58.64826080900008],
              [-78.68765214799993, 58.66030508000006],
              [-78.69505774599992, 58.676662502000056],
              [-78.69619706899994, 58.696600653000075],
              [-78.68858801999994, 58.689154364000046],
              [-78.68065344999991, 58.68305084800005],
              [-78.67202714799993, 58.67853424700007],
              [-78.66270911399994, 58.675482489000046],
              [-78.65147864499994, 58.66282786700003],
              [-78.61998450399994, 58.64492422100005],
              [-78.60741126199991, 58.63450755400004],
              [-78.61587480399993, 58.630072333000044],
              [-78.62450110599991, 58.62881094000005],
              [-78.63304602799991, 58.63031647300005],
              [-78.64159094999991, 58.63450755400004],
              [-78.64159094999991, 58.62832265800006],
            ],
          ],
          [
            [
              [-123.28722083199995, 48.81281159100007],
              [-123.26598059799994, 48.800034898000035],
              [-123.25182044199994, 48.79018789300005],
              [-123.24901282499991, 48.777411200000074],
              [-123.25039628799993, 48.76609935100004],
              [-123.24046790299991, 48.76186758000006],
              [-123.21922766799992, 48.76186758000006],
              [-123.20225989499994, 48.758978583000044],
              [-123.18809973899994, 48.75617096600007],
              [-123.1824438139999, 48.743475653000075],
              [-123.18667558499993, 48.736395575000074],
              [-123.19945227799991, 48.732123114000046],
              [-123.2249242829999, 48.73493073100008],
              [-123.24046790299991, 48.736395575000074],
              [-123.25747636599993, 48.73920319200005],
              [-123.28294837099992, 48.75189850500004],
              [-123.29149329299992, 48.75617096600007],
              [-123.30699622299994, 48.76463450700004],
              [-123.31126868399991, 48.77171458500004],
              [-123.31126868399991, 48.788763739000046],
              [-123.31126868399991, 48.79726797100005],
              [-123.32262122299994, 48.80573151200008],
              [-123.32262122299994, 48.81281159100007],
              [-123.31265214799993, 48.81708405200004],
              [-123.29857337099992, 48.815619208000044],
              [-123.28722083199995, 48.81281159100007],
            ],
          ],
          [
            [
              [-123.08901933499993, 48.76752350500004],
              [-123.10171464799993, 48.76186758000006],
              [-123.12018795499989, 48.76463450700004],
              [-123.13711503799993, 48.76463450700004],
              [-123.15835527299993, 48.76325104400007],
              [-123.17113196499992, 48.76894765800006],
              [-123.18529212099992, 48.774603583000044],
              [-123.20368404899995, 48.784491278000075],
              [-123.20368404899995, 48.79437897300005],
              [-123.20368404899995, 48.80145905200004],
              [-123.20368404899995, 48.80853913000004],
              [-123.20791581899994, 48.815619208000044],
              [-123.21642005099994, 48.81989166900007],
              [-123.22207597599993, 48.822699286000045],
              [-123.22350012899994, 48.83266836100006],
              [-123.20368404899995, 48.829779364000046],
              [-123.17959550699993, 48.815619208000044],
              [-123.1414281889999, 48.80145905200004],
              [-123.09044348899994, 48.79865143400008],
              [-123.05361894399994, 48.79584381700005],
              [-123.0437719389999, 48.788763739000046],
              [-123.0423070949999, 48.784491278000075],
              [-123.05361894399994, 48.78310781500005],
              [-123.0706274079999, 48.77879466400009],
              [-123.0777074859999, 48.77602773600006],
              [-123.08901933499993, 48.76752350500004],
            ],
          ],
          [
            [
              [-62.54496156899995, 45.826665939000065],
              [-62.53269860699993, 45.82927132900005],
              [-62.517955256999926, 45.82760494300004],
              [-62.50690812999994, 45.82806499600008],
              [-62.51117906299993, 45.823347192000085],
              [-62.51235687499991, 45.81436011100004],
              [-62.52644601199995, 45.809611620000055],
              [-62.54973263499994, 45.80354685000009],
              [-62.55584404199993, 45.79924724300008],
              [-62.56691058699994, 45.80220430800006],
              [-62.57798151599991, 45.805588312000054],
              [-62.5945458889999, 45.80381534800006],
              [-62.60314445799992, 45.804210545000046],
              [-62.6031879759999, 45.81062938700006],
              [-62.594009393999954, 45.81537107500009],
              [-62.57441638899991, 45.82399981800006],
              [-62.5645922299999, 45.82403390700006],
              [-62.554154388999905, 45.82406905400006],
              [-62.54496156899995, 45.826665939000065],
            ],
          ],
          [
            [
              [-59.70807857999995, 45.99469635600008],
              [-59.714100714999915, 45.99750397300005],
              [-59.7259008449999, 46.000433661000045],
              [-59.76040605399993, 46.000067450000074],
              [-59.78099524599992, 46.00438060100004],
              [-59.77814693899995, 46.01243724200003],
              [-59.72374426999994, 46.02887604400007],
              [-59.69517981699994, 46.03400299700007],
              [-59.68862870999993, 46.03025950700004],
              [-59.70287024599992, 46.02289459800005],
              [-59.70604407499991, 46.010972398000035],
              [-59.70567786399994, 45.99909088700008],
              [-59.70807857999995, 45.99469635600008],
            ],
          ],
          [
            [
              [-54.794226514999934, 47.27938768000007],
              [-54.77813639899995, 47.27356367200008],
              [-54.79230003999993, 47.259077147000085],
              [-54.798379490999935, 47.24259926600007],
              [-54.8123992969999, 47.23178117400005],
              [-54.82825334899991, 47.24314073600004],
              [-54.83005120999991, 47.26713317200006],
              [-54.794226514999934, 47.27938768000007],
            ],
          ],
          [
            [
              [-54.19560374799994, 47.39320836700006],
              [-54.17804201799993, 47.41819329700007],
              [-54.1586782519999, 47.41467042800008],
              [-54.14458937699993, 47.400444606000065],
              [-54.15335358899995, 47.368356110000036],
              [-54.17796229699991, 47.35998372200004],
              [-54.20962565399992, 47.35990252000005],
              [-54.22019711699994, 47.36819295200007],
              [-54.216702030999954, 47.38127351800006],
              [-54.204389239999955, 47.384869941000034],
              [-54.19560374799994, 47.39320836700006],
            ],
          ],
          [
            [
              [-70.36978105399993, 47.42682526200008],
              [-70.33971106699994, 47.42755768400008],
              [-70.32388261599993, 47.427435614000046],
              [-70.32994544199994, 47.41836172100005],
              [-70.37389075399994, 47.38385651200008],
              [-70.39317786399994, 47.372748114000046],
              [-70.41169186099995, 47.37018463700008],
              [-70.42760169199994, 47.37201569200005],
              [-70.43565833199995, 47.377020575000074],
              [-70.43659420499995, 47.38654205900008],
              [-70.43358313699991, 47.39594147300005],
              [-70.42536373599995, 47.40497467700004],
              [-70.41100012899994, 47.41437409100007],
              [-70.39073645699995, 47.42251211100006],
              [-70.36978105399993, 47.42682526200008],
            ],
          ],
          [
            [
              [-52.95647529599995, 47.654806363000034],
              [-52.91876012999995, 47.65264346400005],
              [-52.91644342299992, 47.63445557500006],
              [-52.94642945499993, 47.618389543000035],
              [-52.976501743999904, 47.59686610500006],
              [-53.00619265499995, 47.59349774000003],
              [-53.0303363939999, 47.59915557800008],
              [-53.01918390399993, 47.61903994700003],
              [-52.95647529599995, 47.654806363000034],
            ],
          ],
          [
            [
              [-68.86433288599994, 48.407597675000034],
              [-68.85560324499994, 48.41446358400003],
              [-68.84271464599993, 48.415855830000055],
              [-68.83806365099991, 48.413808946000074],
              [-68.84320580999992, 48.409692137000036],
              [-68.84267527799994, 48.40558619600006],
              [-68.84469231699995, 48.39599367400007],
              [-68.86320698199995, 48.38911173900004],
              [-68.87867713299994, 48.38771459600008],
              [-68.89106522499992, 48.388033360000065],
              [-68.89263237299991, 48.39179625200006],
              [-68.8885278269999, 48.39693939600005],
              [-68.87978489999995, 48.40345998100008],
              [-68.86433288599994, 48.407597675000034],
            ],
          ],
          [
            [
              [-125.8616252679999, 49.237385439000036],
              [-125.83072269299993, 49.237095758000066],
              [-125.7970020649999, 49.22703472900008],
              [-125.78601912599993, 49.209254498000064],
              [-125.79255137699994, 49.18099581300004],
              [-125.80135190899989, 49.14388754200007],
              [-125.84172702399991, 49.13378005200008],
              [-125.87989753599993, 49.14604615700006],
              [-125.88022976299993, 49.16105411800004],
              [-125.88755813599994, 49.173100686000055],
              [-125.91498553799994, 49.176295122000056],
              [-125.92340618599991, 49.19698146300004],
              [-125.9148946219999, 49.213290319000066],
              [-125.9010695159999, 49.22552008200006],
              [-125.8616252679999, 49.237385439000036],
            ],
          ],
          [
            [
              [-55.85427053899991, 50.20503322800005],
              [-55.85027584499994, 50.21432950500008],
              [-55.84234445499993, 50.21516462000005],
              [-55.831785246999914, 50.21176667600008],
              [-55.823887156999945, 50.20414395900008],
              [-55.835808208999936, 50.19570594800007],
              [-55.84507243199994, 50.190645257000085],
              [-55.86751936199994, 50.19321134200004],
              [-55.88600177699993, 50.19746059100004],
              [-55.88334035699995, 50.20422362000005],
              [-55.85427053899991, 50.20503322800005],
            ],
          ],
          [
            [
              [-55.76297109399991, 50.231935374000045],
              [-55.7510740429999, 50.231909202000054],
              [-55.729933058999904, 50.23016960700005],
              [-55.712811512999906, 50.21997991200004],
              [-55.701020366999956, 50.20388245300006],
              [-55.69580176499994, 50.19372111100006],
              [-55.709036864999916, 50.18952834500004],
              [-55.72880005099995, 50.19803326500005],
              [-55.75653189999991, 50.19978858400003],
              [-55.789522191999936, 50.207466460000035],
              [-55.802679301999945, 50.22017413400005],
              [-55.79999157299994, 50.23031649100005],
              [-55.76297109399991, 50.231935374000045],
            ],
          ],
          [
            [
              [-128.6390761259999, 50.80467027600008],
              [-128.6268875539999, 50.81188525400006],
              [-128.6065303439999, 50.81231765400008],
              [-128.60372836999994, 50.819826773000045],
              [-128.59084241499994, 50.81264668100005],
              [-128.5740732989999, 50.80853307000007],
              [-128.5722465469999, 50.80261710800005],
              [-128.57257831499993, 50.795158187000084],
              [-128.5890692389999, 50.79432017500005],
              [-128.60151411899994, 50.79305622600003],
              [-128.6034377279999, 50.78506785400003],
              [-128.61588798299994, 50.78281726100005],
              [-128.6351242529999, 50.78985552100005],
              [-128.6379887939999, 50.799230435000084],
              [-128.6390761259999, 50.80467027600008],
            ],
          ],
          [
            [
              [-58.861186371999906, 50.83305051900004],
              [-58.85163626099995, 50.81265407200004],
              [-58.84632306099991, 50.78944289000003],
              [-58.86110798599992, 50.77959453300008],
              [-58.88086334399992, 50.78473669400006],
              [-58.88560832999991, 50.794251331000055],
              [-58.861186371999906, 50.83305051900004],
            ],
          ],
          [
            [
              [-128.7021400449999, 50.83655887300006],
              [-128.69793798799992, 50.831687930000044],
              [-128.6828628379999, 50.82903882700003],
              [-128.67336327599992, 50.828260071000045],
              [-128.6621774489999, 50.82503186300005],
              [-128.6704891889999, 50.81888895000009],
              [-128.66626614299992, 50.81351792500004],
              [-128.6550070219999, 50.808794782000064],
              [-128.6634264469999, 50.804639644000076],
              [-128.6822418129999, 50.803733504000036],
              [-128.69155134499994, 50.80154297900003],
              [-128.70444397699993, 50.80722252500004],
              [-128.71584237199994, 50.814413467000065],
              [-128.71479854199993, 50.82386778300008],
              [-128.7089332039999, 50.831442766000066],
              [-128.7021400449999, 50.83655887300006],
            ],
          ],
          [
            [
              [-57.25026545599991, 50.84064133600003],
              [-57.23215696099993, 50.841032012000085],
              [-57.22864018999991, 50.83660953200007],
              [-57.22163843299995, 50.83956793800007],
              [-57.2093751349999, 50.84105557500004],
              [-57.20293549099995, 50.83442186800005],
              [-57.191826703999936, 50.82816059700008],
              [-57.18656187199991, 50.82300050500004],
              [-57.194730627999945, 50.82004317500008],
              [-57.20814971099992, 50.815604971000084],
              [-57.22331538599991, 50.810056443000065],
              [-57.225633530999914, 50.80341369000007],
              [-57.240205346999915, 50.795648666000034],
              [-57.25246608999993, 50.79673915400008],
              [-57.26181505299991, 50.799677400000064],
              [-57.25190034099995, 50.80264287700004],
              [-57.23965077899993, 50.805979180000065],
              [-57.24608243499995, 50.809291064000035],
              [-57.258926027999905, 50.80890465400006],
              [-57.27002343099991, 50.809995152000056],
              [-57.277055978999954, 50.81736296300005],
              [-57.27533876399991, 50.827326311000036],
              [-57.26310556099992, 50.836935260000075],
              [-57.25026545599991, 50.84064133600003],
            ],
          ],
          [
            [
              [-127.77911951599992, 50.901523771000086],
              [-127.74485205999991, 50.91250372300004],
              [-127.7134575149999, 50.91300310400004],
              [-127.68818450399993, 50.90089945100004],
              [-127.66920431699992, 50.88035405800008],
              [-127.66347880199993, 50.86065129600007],
              [-127.65598930399995, 50.83784632800007],
              [-127.67413096999991, 50.83756558500005],
              [-127.72891655699993, 50.846075849000044],
              [-127.7525863599999, 50.85923682500004],
              [-127.78246992399994, 50.86291479000005],
              [-127.81738525999992, 50.86858556800007],
              [-127.8343600369999, 50.87872275700005],
              [-127.8348063819999, 50.88913711500004],
              [-127.77911951599992, 50.901523771000086],
            ],
          ],
          [
            [
              [-58.46263371999993, 51.176264202000084],
              [-58.427356878999944, 51.16712320100004],
              [-58.45703478899992, 51.14067138000007],
              [-58.495659221999915, 51.12095497100006],
              [-58.56915589199991, 51.10074466100008],
              [-58.58147877099992, 51.080003471000055],
              [-58.62120867199991, 51.09177551400006],
              [-58.587326841999925, 51.11968490400005],
              [-58.54695159999994, 51.15041888300004],
              [-58.46263371999993, 51.176264202000084],
            ],
          ],
          [
            [
              [-58.307577060999904, 51.25226989500004],
              [-58.307070918999955, 51.235822262000056],
              [-58.32629371199994, 51.220491189000086],
              [-58.36290490099992, 51.20221944900004],
              [-58.411009737999905, 51.20163209700007],
              [-58.413882233999914, 51.22217663300006],
              [-58.388163024999926, 51.23893430500004],
              [-58.307577060999904, 51.25226989500004],
            ],
          ],
          [
            [
              [-128.43821624499992, 51.98079706800007],
              [-128.43205340899993, 51.99514813800005],
              [-128.4174164769999, 52.00348858800004],
              [-128.41345137199994, 51.983162664000076],
              [-128.4207600449999, 51.95247584100008],
              [-128.42322682199995, 51.92593196100006],
              [-128.4323985329999, 51.90235500600005],
              [-128.4454860649999, 51.89810453700005],
              [-128.4543697719999, 51.91736777500006],
              [-128.47882812599994, 51.90684439200004],
              [-128.4926865469999, 51.926039922000086],
              [-128.48696520599992, 51.95365823700007],
              [-128.43821624499992, 51.98079706800007],
            ],
          ],
          [
            [
              [-79.02745520699995, 52.11359284100007],
              [-79.01789303299995, 52.11237213700008],
              [-79.00186113199993, 52.10757070500006],
              [-79.00666256399995, 52.09788646000004],
              [-79.03160559799994, 52.093410549000055],
              [-79.08665930899991, 52.09747955900008],
              [-79.0801488919999, 52.10651276200008],
              [-79.04539954299992, 52.11273834800005],
              [-79.02745520699995, 52.11359284100007],
            ],
          ],
          [
            [
              [-79.40566972599993, 52.260972398000035],
              [-79.38532467399995, 52.25576406500005],
              [-79.37930253799993, 52.25189850500004],
              [-79.38125566299993, 52.24477773600006],
              [-79.40086829299992, 52.24091217700004],
              [-79.47496497299994, 52.237494208000044],
              [-79.5012914699999, 52.23309967700004],
              [-79.50161699099993, 52.23663971600007],
              [-79.49478105399993, 52.245754299000055],
              [-79.48493404899995, 52.25332265800006],
              [-79.44562740799995, 52.26239655200004],
              [-79.40566972599993, 52.260972398000035],
            ],
          ],
          [
            [
              [-78.73424231699994, 52.44513580900008],
              [-78.71947180899991, 52.44554271000004],
              [-78.70738684799994, 52.44757721600007],
              [-78.70840410099993, 52.44399648600006],
              [-78.72350012899994, 52.434759833000044],
              [-78.73989824099993, 52.42731354400007],
              [-78.75523841099994, 52.42206452000005],
              [-78.75104732999995, 52.41893138200004],
              [-78.72801673099991, 52.41738515800006],
              [-78.72695878799993, 52.41233958500004],
              [-78.74982662699995, 52.40619538000004],
              [-78.76089433499993, 52.40643952000005],
              [-78.76109778599994, 52.411322333000044],
              [-78.76256262899994, 52.413763739000046],
              [-78.76659094999991, 52.41250234600005],
              [-78.77440344999991, 52.411810614000046],
              [-78.78209387899994, 52.414129950000074],
              [-78.78355872299994, 52.41380442900004],
              [-78.78677324099993, 52.41274648600006],
              [-78.79263261599993, 52.411444403000075],
              [-78.79450436099995, 52.41193268400008],
              [-78.79332434799994, 52.41347890800006],
              [-78.79491126199991, 52.41388580900008],
              [-78.79698645699995, 52.41351959800005],
              [-78.80003821499992, 52.41278717700004],
              [-78.80150305899991, 52.417669989000046],
              [-78.79922441299993, 52.429348049000055],
              [-78.80166581899994, 52.43390534100007],
              [-78.80776933499993, 52.42914459800005],
              [-78.82079016799992, 52.423814195000034],
              [-78.82725989499994, 52.42763906500005],
              [-78.8145238919999, 52.435248114000046],
              [-78.79637610599991, 52.43886953300006],
              [-78.76854407499991, 52.447699286000045],
              [-78.75243079299992, 52.44794342700004],
              [-78.73424231699994, 52.44513580900008],
            ],
          ],
          [
            [
              [-79.58462480399993, 52.55516185100004],
              [-79.57217363199993, 52.54767487200007],
              [-79.56529700399994, 52.545355536000045],
              [-79.57217363199993, 52.54246653900003],
              [-79.5813695949999, 52.53986237200007],
              [-79.6094457669999, 52.53510163000004],
              [-79.63939368399991, 52.53261953300006],
              [-79.63817298099991, 52.53782786700003],
              [-79.62144934799994, 52.555853583000044],
              [-79.61628170499995, 52.57241445500006],
              [-79.61241614499994, 52.577337958000044],
              [-79.60155188699991, 52.577826239000046],
              [-79.59142005099994, 52.57672760600008],
              [-79.58828691299993, 52.57135651200008],
              [-79.58873450399994, 52.56395091400003],
              [-79.58462480399993, 52.55516185100004],
            ],
          ],
          [
            [
              [-129.43278804599993, 52.683119555000076],
              [-129.41331133499995, 52.687649011000076],
              [-129.4001032619999, 52.67952748000005],
              [-129.40325590499992, 52.663349432000075],
              [-129.40244544299992, 52.64664334000008],
              [-129.41812533099994, 52.64516731400005],
              [-129.4354763629999, 52.63768597600006],
              [-129.44957194699992, 52.64399713000006],
              [-129.43653144899992, 52.659165976000054],
              [-129.42742922399992, 52.67425943500007],
              [-129.43278804599993, 52.683119555000076],
            ],
          ],
          [
            [
              [-55.8523295249999, 52.772469509000075],
              [-55.832094258999916, 52.770918908000056],
              [-55.81185526999991, 52.770132655000054],
              [-55.808092469999906, 52.761708042000066],
              [-55.81069226499994, 52.74333814400006],
              [-55.809474682999905, 52.73108644900009],
              [-55.829715035999925, 52.72651306200004],
              [-55.86130337399993, 52.73036769600009],
              [-55.866325515999904, 52.743387716000086],
              [-55.884009044999914, 52.75105567700007],
              [-55.89535986399994, 52.763313975000074],
              [-55.88774236499995, 52.77479393100003],
              [-55.8523295249999, 52.772469509000075],
            ],
          ],
          [
            [
              [-129.3546622049999, 52.86251028400005],
              [-129.33028384699992, 52.84918029900007],
              [-129.3120175179999, 52.839333115000045],
              [-129.3239886039999, 52.82060492900007],
              [-129.32892439099993, 52.79961096200009],
              [-129.34770493799994, 52.79988525400006],
              [-129.36619171299992, 52.81449987600007],
              [-129.36766411399992, 52.84495090300004],
              [-129.3546622049999, 52.86251028400005],
            ],
          ],
          [
            [
              [-55.80846552399993, 53.006563752000034],
              [-55.80081030999992, 53.01497728500004],
              [-55.7868213349999, 53.01649974500003],
              [-55.77540701399994, 53.00960201000004],
              [-55.78560934799992, 53.00118981600008],
              [-55.786903680999956, 52.99506752600007],
              [-55.77037396999992, 52.99734994100004],
              [-55.767871785999944, 52.98816198700007],
              [-55.78189633499994, 52.976697449000085],
              [-55.787036100999956, 52.96216449900004],
              [-55.789629342999945, 52.94839368600009],
              [-55.80233718599993, 52.94458264100007],
              [-55.8213259609999, 52.95990392900006],
              [-55.83397061499994, 52.976744808000035],
              [-55.84917044799994, 52.991289177000056],
              [-55.850409242999945, 53.003529649000086],
              [-55.80846552399993, 53.006563752000034],
            ],
          ],
          [
            [
              [-55.82731908699992, 53.07928408200007],
              [-55.79034679299991, 53.093834247000075],
              [-55.77125576399993, 53.08923174600005],
              [-55.75475676199994, 53.07543576200004],
              [-55.75101167999992, 53.05935094100005],
              [-55.768882300999906, 53.048642629000085],
              [-55.7587670019999, 53.034087585000066],
              [-55.77533097499992, 53.027974862000065],
              [-55.8007489659999, 53.032582484000045],
              [-55.81603375299994, 53.02416904200004],
              [-55.84527387399993, 53.023417520000066],
              [-55.87068771299994, 53.02648520000008],
              [-55.8757473739999, 53.03872493600005],
              [-55.87443939299993, 53.05708321000009],
              [-55.862966360999906, 53.07085822300007],
              [-55.8476781839999, 53.08081241800005],
              [-55.82731908699992, 53.07928408200007],
            ],
          ],
          [
            [
              [-55.92758746699991, 53.49223635900006],
              [-55.91366299899994, 53.49220954700007],
              [-55.902165262999915, 53.49705860800003],
              [-55.88986976699994, 53.49849027400006],
              [-55.88013802099994, 53.484332531000064],
              [-55.84578801999993, 53.48034399800008],
              [-55.824516496999934, 53.47785181200004],
              [-55.81461772799992, 53.48756619000005],
              [-55.803165992999936, 53.48461320800004],
              [-55.7851825219999, 53.47725641400007],
              [-55.7671632549999, 53.475739316000045],
              [-55.75171627399993, 53.463989481000056],
              [-55.749360072999934, 53.45374564800005],
              [-55.742891493999934, 53.445437078000054],
              [-55.745394768999915, 53.44057164800006],
              [-55.76167888799995, 53.44988805200006],
              [-55.78209133599995, 53.45580311000003],
              [-55.80257079099994, 53.455378222000036],
              [-55.8067609119999, 53.44320716200008],
              [-55.81339063099995, 53.432992252000076],
              [-55.79792251099991, 53.42368555500008],
              [-55.77996310599991, 53.419242147000034],
              [-55.768580726999915, 53.41140581800005],
              [-55.76947751799992, 53.40263494000004],
              [-55.78904049499994, 53.410010286000045],
              [-55.811070197999925, 53.41641464800006],
              [-55.81684152699995, 53.41058292900004],
              [-55.79402621699995, 53.40076549400004],
              [-55.785908373999916, 53.39391537600005],
              [-55.79898897599992, 53.39395708700005],
              [-55.829954364999935, 53.40672149800008],
              [-55.864244768999924, 53.41412498600005],
              [-55.90673875999994, 53.41861568000007],
              [-55.92630207499991, 53.42888708000004],
              [-55.965539780999904, 53.43236669300006],
              [-55.98349960399992, 53.44165202100004],
              [-55.98506570799992, 53.45871038800004],
              [-55.98992995099991, 53.47041339200007],
              [-55.97594992499995, 53.48452479100007],
              [-55.92758746699991, 53.49223635900006],
            ],
          ],
          [
            [
              [-130.5921147929999, 53.49618318600005],
              [-130.58726424999992, 53.47794319500008],
              [-130.5869657579999, 53.466191596000044],
              [-130.6024500019999, 53.47127565000005],
              [-130.6246525159999, 53.481520156000045],
              [-130.63606760599993, 53.49840648700007],
              [-130.6165227159999, 53.506408116000046],
              [-130.5921147929999, 53.49618318600005],
            ],
          ],
          [
            [
              [-57.152729294999915, 53.69312088700008],
              [-57.12978111599995, 53.704631772000084],
              [-57.10326684899991, 53.704637063000064],
              [-57.08029000099992, 53.70359138100008],
              [-57.0643843659999, 53.70881644600007],
              [-57.0449382729999, 53.71508387700004],
              [-57.03080053499991, 53.71298546600008],
              [-57.05024997499993, 53.701493725000034],
              [-57.06615410199993, 53.684773833000065],
              [-57.08204699699991, 53.680595132000064],
              [-57.085571039999934, 53.667011424000066],
              [-57.08379753799994, 53.65656781600006],
              [-57.09261012299993, 53.649259458000074],
              [-57.11376316299993, 53.64299394600005],
              [-57.15438710799992, 53.64712687300005],
              [-57.17213876599993, 53.659624748000056],
              [-57.166848098999935, 53.67846760500004],
              [-57.152729294999915, 53.69312088700008],
            ],
          ],
          [
            [
              [-56.922484390999955, 53.797558578000064],
              [-56.88852688999992, 53.80659727600005],
              [-56.83610480899995, 53.80648020800004],
              [-56.817714520999914, 53.79004085300005],
              [-56.85170902199991, 53.77737785000005],
              [-56.88260816299993, 53.762878828000055],
              [-56.91957138999993, 53.76295442500003],
              [-56.9473349619999, 53.752077608000036],
              [-56.98428477999994, 53.75938370000006],
              [-57.00885508499994, 53.78854820000004],
              [-56.99954826699991, 53.81039107700008],
              [-56.96559876899994, 53.812180383000054],
              [-56.922484390999955, 53.797558578000064],
            ],
          ],
          [
            [
              [-130.6091173819999, 53.79701070500005],
              [-130.61721551599993, 53.82319100400008],
              [-130.5693789579999, 53.83674208300005],
              [-130.50982115099993, 53.82630738900008],
              [-130.4498636919999, 53.796168916000056],
              [-130.4199641149999, 53.78327440400005],
              [-130.4378845739999, 53.756888651000054],
              [-130.49727188999992, 53.76516651900005],
              [-130.5127460309999, 53.79347448400006],
              [-130.5532566259999, 53.78438237000006],
              [-130.6091173819999, 53.79701070500005],
            ],
          ],
          [
            [
              [-57.32795223699992, 54.28756437700008],
              [-57.292497744999935, 54.28374193800005],
              [-57.30574709199993, 54.27596203100006],
              [-57.32121225599991, 54.269470510000076],
              [-57.31231109999993, 54.26043054400009],
              [-57.298974321999935, 54.24881127800006],
              [-57.314418763999925, 54.239730756000085],
              [-57.34101155099995, 54.247447445000034],
              [-57.3676392509999, 54.25903493800007],
              [-57.36770294299993, 54.269380864000084],
              [-57.35003830399995, 54.27717749300007],
              [-57.32795223699992, 54.28756437700008],
            ],
          ],
          [
            [
              [-81.10521399599992, 54.332912502000056],
              [-81.10846920499995, 54.342962958000044],
              [-81.10899817599994, 54.35398997600004],
              [-81.10802161399994, 54.36603424700007],
              [-81.10179602799991, 54.37409088700008],
              [-81.09361731699994, 54.37018463700008],
              [-81.0886938139999, 54.359076239000046],
              [-81.08604895699995, 54.34821198100008],
              [-81.09007727799991, 54.337551174000055],
              [-81.09471594999991, 54.332098700000074],
              [-81.09854081899994, 54.33026764500005],
              [-81.10521399599992, 54.332912502000056],
            ],
          ],
          [
            [
              [-57.2444759519999, 54.484173276000035],
              [-57.228932433999944, 54.49194139700006],
              [-57.22000584099993, 54.48031798000005],
              [-57.21108261199993, 54.46998807500006],
              [-57.19764395099992, 54.449324757000056],
              [-57.224333248999926, 54.451887585000065],
              [-57.24442155699995, 54.46737257800004],
              [-57.27107277999994, 54.460879928000054],
              [-57.29333721499995, 54.468604921000065],
              [-57.2867276369999, 54.48283194600003],
              [-57.2444759519999, 54.484173276000035],
            ],
          ],
          [
            [
              [-130.81756221299992, 54.48632416600003],
              [-130.79000577999994, 54.49373426800008],
              [-130.7662242059999, 54.468864593000035],
              [-130.72845533899994, 54.43783470400007],
              [-130.7295674739999, 54.42080082000007],
              [-130.7847434379999, 54.41225315300005],
              [-130.8234491359999, 54.42085756800009],
              [-130.82856595999993, 54.438727707000055],
              [-130.8700270619999, 54.434750928000085],
              [-130.86138562399992, 54.45544308600006],
              [-130.81756221299992, 54.48632416600003],
            ],
          ],
          [
            [
              [-57.30367682799994, 54.57472319500005],
              [-57.27507799299991, 54.57964989100009],
              [-57.271659893999924, 54.566965519000064],
              [-57.283392232999915, 54.55620827700005],
              [-57.26989055699994, 54.54549308300005],
              [-57.254726554999934, 54.53770818800007],
              [-57.25468354199995, 54.52599464500008],
              [-57.26804138099993, 54.503519933000064],
              [-57.29156018499992, 54.50249937600006],
              [-57.34031001999995, 54.50144345800004],
              [-57.362203294999915, 54.50726324700008],
              [-57.365670381999905, 54.52385194100003],
              [-57.34895194699993, 54.54145359000006],
              [-57.3473487629999, 54.55512260900008],
              [-57.30367682799994, 54.57472319500005],
            ],
          ],
          [
            [
              [-131.09876009899995, 54.62796194200007],
              [-131.0568402149999, 54.625716674000046],
              [-131.04995313799992, 54.606029385000056],
              [-131.06944001699992, 54.58785953700004],
              [-131.0909046569999, 54.58223994100007],
              [-131.10222385399993, 54.59558468100005],
              [-131.09876009899995, 54.62796194200007],
            ],
          ],
          [
            [
              [-76.73045813699991, 56.16083405200004],
              [-76.72402910099993, 56.153631903000075],
              [-76.71593176999994, 56.138006903000075],
              [-76.7207738919999, 56.12539297100005],
              [-76.73452714799993, 56.11831289300005],
              [-76.77481035099993, 56.10366445500006],
              [-76.78034420499995, 56.10805898600006],
              [-76.77204342399995, 56.12372467700004],
              [-76.77009029899995, 56.138332424000055],
              [-76.77293860599991, 56.15184153900003],
              [-76.77285722599993, 56.165350653000075],
              [-76.76549231699994, 56.17597077000005],
              [-76.75645911399994, 56.17885976800005],
              [-76.74526933499993, 56.16648997600004],
              [-76.7356664699999, 56.16229889500005],
              [-76.73045813699991, 56.16083405200004],
            ],
          ],
          [
            [
              [-77.84984290299991, 56.31525299700007],
              [-77.88463294199994, 56.30353424700007],
              [-77.91234290299991, 56.29828522300005],
              [-77.92760169199994, 56.29877350500004],
              [-77.97232011599993, 56.28660716400003],
              [-77.98009192599994, 56.28660716400003],
              [-77.97044837099992, 56.295803127000056],
              [-77.96393795499995, 56.30560944200005],
              [-77.96031653599994, 56.30878327000005],
              [-77.95677649599992, 56.311428127000056],
              [-77.94896399599992, 56.313381252000056],
              [-77.94054114499994, 56.311428127000056],
              [-77.84764563699991, 56.323553778000075],
              [-77.84142005099994, 56.32330963700008],
              [-77.84117591099994, 56.320379950000074],
              [-77.84984290299991, 56.31525299700007],
            ],
          ],
          [
            [
              [-77.48704993399991, 56.44212474200003],
              [-77.48306230399993, 56.44122955900008],
              [-77.47760982999995, 56.43646881700005],
              [-77.47838294199994, 56.43073151200008],
              [-77.48363196499992, 56.42719147300005],
              [-77.49014238199993, 56.41828034100007],
              [-77.50255286399994, 56.38646067900004],
              [-77.5215551419999, 56.37604401200008],
              [-77.53538977799991, 56.37954336100006],
              [-77.53726152299993, 56.38812897300005],
              [-77.53701738199993, 56.39704010600008],
              [-77.52940833199995, 56.40403880400004],
              [-77.51577714799993, 56.41095612200007],
              [-77.50670325399994, 56.41738515800006],
              [-77.50503495999993, 56.423041083000044],
              [-77.5039770169999, 56.430121161000045],
              [-77.49937903599994, 56.43699778900003],
              [-77.49156653599994, 56.44114817900004],
              [-77.48704993399991, 56.44212474200003],
            ],
          ],
          [
            [
              [-78.81114661399994, 56.65766022300005],
              [-78.81993567599994, 56.66087474200003],
              [-78.83218339799993, 56.66933828300006],
              [-78.83861243399991, 56.66986725500004],
              [-78.85094153599994, 56.67267487200007],
              [-78.84068762899994, 56.675767320000034],
              [-78.77822831899994, 56.675767320000034],
              [-78.76504472599993, 56.67719147300005],
              [-78.7500707669999, 56.67560455900008],
              [-78.73989824099993, 56.66697825700004],
              [-78.75300045499995, 56.65729401200008],
              [-78.78294837099992, 56.65509674700007],
              [-78.81114661399994, 56.65766022300005],
            ],
          ],
          [
            [
              [-76.62344316299993, 56.68146393400008],
              [-76.62564042899993, 56.67942942900004],
              [-76.62694251199991, 56.67560455900008],
              [-76.62523352799991, 56.67177969000005],
              [-76.62083899599992, 56.655585028000075],
              [-76.62083899599992, 56.64817942900004],
              [-76.62490800699993, 56.64362213700008],
              [-76.62584387899994, 56.63361237200007],
              [-76.6223852199999, 56.617254950000074],
              [-76.61904863199993, 56.58690013200004],
              [-76.62669837099992, 56.568793036000045],
              [-76.64635169199994, 56.550482489000046],
              [-76.65469316299993, 56.548895575000074],
              [-76.64907792899993, 56.561428127000056],
              [-76.64948482999995, 56.57440827000005],
              [-76.65538489499994, 56.58746979400007],
              [-76.65428626199991, 56.60488515800006],
              [-76.64785722599993, 56.62653229400007],
              [-76.63426673099991, 56.65656159100007],
              [-76.63418535099993, 56.715277411000045],
              [-76.62425696499992, 56.710272528000075],
              [-76.61611894399994, 56.69550202000005],
              [-76.62071692599994, 56.683579820000034],
              [-76.62344316299993, 56.68146393400008],
            ],
          ],
          [
            [
              [-76.65196692599994, 57.07135651200008],
              [-76.65469316299993, 57.06712474200003],
              [-76.66095943899995, 57.06537506700005],
              [-76.6751195949999, 57.06537506700005],
              [-76.69326738199993, 57.071966864000046],
              [-76.70091712099992, 57.08266836100006],
              [-76.70661373599995, 57.10065338700008],
              [-76.70848548099991, 57.110663153000075],
              [-76.71861731699994, 57.13271719000005],
              [-76.72061113199993, 57.14142487200007],
              [-76.72008216099994, 57.14630768400008],
              [-76.72769120999993, 57.157538153000075],
              [-76.73346920499995, 57.17641836100006],
              [-76.73143469999991, 57.18646881700005],
              [-76.72508704299992, 57.19082265800006],
              [-76.71141516799992, 57.19635651200008],
              [-76.69847571499992, 57.19220612200007],
              [-76.68154863199993, 57.17023346600007],
              [-76.67857825399994, 57.15184153900003],
              [-76.66844641799992, 57.14545319200005],
              [-76.65599524599992, 57.13979726800005],
              [-76.65355383999992, 57.12885163000004],
              [-76.66234290299991, 57.12083567900004],
              [-76.67247473899994, 57.117254950000074],
              [-76.67593339799993, 57.10887278900003],
              [-76.67145748599995, 57.098537502000056],
              [-76.65538489499994, 57.08783600500004],
              [-76.65428626199991, 57.08266836100006],
              [-76.65782630099994, 57.07807038000004],
              [-76.65566972599993, 57.07477448100008],
              [-76.65196692599994, 57.07135651200008],
            ],
          ],
          [
            [
              [-78.26838131399995, 57.19863515800006],
              [-78.26284745999993, 57.19773997600004],
              [-78.25694739499994, 57.19448476800005],
              [-78.26162675699993, 57.19159577000005],
              [-78.27188066299993, 57.19163646000004],
              [-78.27892005099994, 57.190741278000075],
              [-78.28286699099993, 57.189439195000034],
              [-78.28697669199994, 57.190741278000075],
              [-78.29137122299994, 57.19253164300005],
              [-78.29670162699995, 57.19122955900008],
              [-78.30044511599993, 57.185614325000074],
              [-78.30846106699994, 57.17747630400004],
              [-78.32433020699995, 57.171861070000034],
              [-78.33299719999991, 57.17047760600008],
              [-78.34129798099991, 57.169907945000034],
              [-78.35781816299993, 57.17039622600004],
              [-78.38194739499994, 57.17446523600006],
              [-78.38243567599994, 57.17812734600005],
              [-78.37364661399994, 57.185248114000046],
              [-78.36628170499995, 57.18891022300005],
              [-78.36025956899994, 57.18817780200004],
              [-78.35879472599993, 57.190741278000075],
              [-78.35757402299993, 57.19546133000006],
              [-78.35265051999994, 57.19818756700005],
              [-78.32555091099994, 57.20766836100006],
              [-78.31163489499994, 57.20872630400004],
              [-78.29784094999991, 57.20648834800005],
              [-78.26838131399995, 57.19863515800006],
            ],
          ],
          [
            [
              [-78.33649654899995, 57.30516185100004],
              [-78.37975012899994, 57.28815338700008],
              [-78.41539466099994, 57.279282945000034],
              [-78.42747962099992, 57.27960846600007],
              [-78.46841386599993, 57.28701406500005],
              [-78.47801673099991, 57.287543036000045],
              [-78.48078365799995, 57.291449286000045],
              [-78.47447669199994, 57.296861070000034],
              [-78.45811926999994, 57.304754950000074],
              [-78.38101152299993, 57.32880280200004],
              [-78.34715735599991, 57.328558661000045],
              [-78.32640540299991, 57.31777578300006],
              [-78.33649654899995, 57.30516185100004],
            ],
          ],
          [
            [
              [-76.79112708199995, 57.33608633000006],
              [-76.79234778599994, 57.344183661000045],
              [-76.80772864499994, 57.36517975500004],
              [-76.81419837099992, 57.37958405200004],
              [-76.81773841099994, 57.39101797100005],
              [-76.82388261599993, 57.40053945500006],
              [-76.83287512899994, 57.408270575000074],
              [-76.83926347599993, 57.418850002000056],
              [-76.83543860599991, 57.425767320000034],
              [-76.82689368399991, 57.421576239000046],
              [-76.81810462099992, 57.415350653000075],
              [-76.80825761599993, 57.41160716400003],
              [-76.80101477799991, 57.40607330900008],
              [-76.77131100199995, 57.390611070000034],
              [-76.7598363919999, 57.38035716400003],
              [-76.75617428299995, 57.37531159100007],
              [-76.75182044199994, 57.370306708000044],
              [-76.74535071499992, 57.36017487200007],
              [-76.74388587099992, 57.34943268400008],
              [-76.74705969999991, 57.34125397300005],
              [-76.75084387899994, 57.33490631700005],
              [-76.74990800699993, 57.32640208500004],
              [-76.74522864499994, 57.31659577000005],
              [-76.73839270699995, 57.30573151200008],
              [-76.73298092399995, 57.29352448100008],
              [-76.73940995999993, 57.28388092700004],
              [-76.75454667899993, 57.280503648000035],
              [-76.76378333199995, 57.28506094000005],
              [-76.76976477799991, 57.30377838700008],
              [-76.77448482999995, 57.311428127000056],
              [-76.78392493399991, 57.32103099200003],
              [-76.79112708199995, 57.33608633000006],
            ],
          ],
          [
            [
              [-67.55828973799993, 58.41100254200006],
              [-67.52616662499992, 58.34705647100009],
              [-67.53084201999991, 58.29689722300009],
              [-67.58197791399994, 58.27845345800006],
              [-67.63593720999995, 58.29103717700008],
              [-67.6618649799999, 58.327191387000084],
              [-67.65782377199992, 58.36407937800004],
              [-67.6365571959999, 58.40222478900006],
              [-67.59281628199994, 58.422209096000074],
              [-67.55828973799993, 58.41100254200006],
            ],
          ],
          [
            [
              [-78.62881425699993, 58.77952708500004],
              [-78.62539628799993, 58.77789948100008],
              [-78.62523352799991, 58.77334219000005],
              [-78.6289770169999, 58.770697333000044],
              [-78.63792883999992, 58.77289459800005],
              [-78.64826412699995, 58.77216217700004],
              [-78.65314693899995, 58.773504950000074],
              [-78.65387936099995, 58.77798086100006],
              [-78.65697180899991, 58.78021881700005],
              [-78.68480383999992, 58.780462958000044],
              [-78.69664466099994, 58.778631903000075],
              [-78.70494544199994, 58.77952708500004],
              [-78.70763098899994, 58.786037502000056],
              [-78.70287024599992, 58.79132721600007],
              [-78.69692949099993, 58.792669989000046],
              [-78.69102942599994, 58.79193756700005],
              [-78.68521074099993, 58.78929271000004],
              [-78.67935136599993, 58.789048570000034],
              [-78.67471269399994, 58.79157135600008],
              [-78.67882239499994, 58.794623114000046],
              [-78.69188391799992, 58.797756252000056],
              [-78.68309485599991, 58.80223216400003],
              [-78.65086829299992, 58.802069403000075],
              [-78.63805091099994, 58.79706452000005],
              [-78.64509029899995, 58.794623114000046],
              [-78.63198808499993, 58.79132721600007],
              [-78.62999426999994, 58.78497955900008],
              [-78.62881425699993, 58.77952708500004],
            ],
          ],
          [
            [
              [-78.90111243399991, 58.832464911000045],
              [-78.89679928299995, 58.82294342700004],
              [-78.88434811099995, 58.80996328300006],
              [-78.8860570949999, 58.80805084800005],
              [-78.89883378799993, 58.814439195000034],
              [-78.90233313699991, 58.81732819200005],
              [-78.90514075399994, 58.82123444200005],
              [-78.90807044199994, 58.82339101800005],
              [-78.91519120999993, 58.82469310100004],
              [-78.92894446499992, 58.829291083000044],
              [-78.93809973899994, 58.833970445000034],
              [-78.94212805899991, 58.83783600500004],
              [-78.94155839799993, 58.84320709800005],
              [-78.93663489499994, 58.84682851800005],
              [-78.93761145699995, 58.86481354400007],
              [-78.9270727199999, 58.86554596600007],
              [-78.91592363199993, 58.85382721600007],
              [-78.90111243399991, 58.832464911000045],
            ],
          ],
          [
            [
              [-68.9954867859999, 59.01634455000004],
              [-68.98498982099994, 59.005283175000045],
              [-68.9745609119999, 58.989632795000034],
              [-69.01556438099993, 58.97241520600005],
              [-69.07238934999992, 58.96259606600006],
              [-69.12027897899992, 58.95730195800007],
              [-69.11128128999991, 58.97103306100007],
              [-69.08264479099995, 58.996596218000036],
              [-69.06119749499993, 59.01117469500008],
              [-68.9954867859999, 59.01634455000004],
            ],
          ],
          [
            [
              [-80.55239824099993, 59.11005280200004],
              [-80.5398656889999, 59.10569896000004],
              [-80.53547115799995, 59.09992096600007],
              [-80.53856360599991, 59.09467194200005],
              [-80.54832923099991, 59.091131903000075],
              [-80.57860266799992, 59.092962958000044],
              [-80.58287512899994, 59.09833405200004],
              [-80.56993567599994, 59.10561758000006],
              [-80.55239824099993, 59.11005280200004],
            ],
          ],
          [
            [
              [-80.51854407499991, 59.69472890800006],
              [-80.51398678299995, 59.69749583500004],
              [-80.51040605399993, 59.69245026200008],
              [-80.51073157499991, 59.683294989000046],
              [-80.52334550699993, 59.67454661700003],
              [-80.55150305899991, 59.64940013200004],
              [-80.56704667899993, 59.64642975500004],
              [-80.57433020699995, 59.65208567900004],
              [-80.57701575399994, 59.65766022300005],
              [-80.58824622299994, 59.66156647300005],
              [-80.58055579299992, 59.669256903000075],
              [-80.54271399599992, 59.68309153900003],
              [-80.53758704299992, 59.68854401200008],
              [-80.51854407499991, 59.69472890800006],
            ],
          ],
          [
            [
              [-80.38727779899995, 59.71173737200007],
              [-80.38060462099992, 59.71133047100005],
              [-80.37026933499993, 59.70872630400004],
              [-80.37254798099991, 59.705145575000074],
              [-80.38304602799991, 59.700832424000055],
              [-80.38792883999992, 59.69354889500005],
              [-80.39049231699994, 59.68577708500004],
              [-80.39793860599991, 59.683661200000074],
              [-80.40758216099994, 59.68500397300005],
              [-80.40982011599993, 59.68146393400008],
              [-80.4102270169999, 59.67475006700005],
              [-80.41637122299994, 59.66868724200003],
              [-80.42178300699993, 59.661444403000075],
              [-80.42967688699991, 59.65265534100007],
              [-80.44367428299995, 59.64817942900004],
              [-80.44839433499993, 59.658270575000074],
              [-80.43871008999992, 59.677435614000046],
              [-80.42186438699991, 59.69476959800005],
              [-80.39952551999994, 59.70734284100007],
              [-80.38727779899995, 59.71173737200007],
            ],
          ],
          [
            [
              [-69.92194070399995, 61.01312434400006],
              [-69.91106216599991, 60.99987031100005],
              [-69.9500410469999, 60.98593910200003],
              [-69.94973398799993, 60.96572931500003],
              [-69.97207877999995, 60.95297872000003],
              [-69.97764268199995, 60.92986044700007],
              [-70.00385575299993, 60.935066418000076],
              [-70.0008089769999, 60.96908397400006],
              [-70.01194644199995, 60.99676388100005],
              [-69.98499866299994, 61.019336198000076],
              [-69.95672484599993, 61.034980026000085],
              [-69.92339611699992, 61.03158912200007],
              [-69.92194070399995, 61.01312434400006],
            ],
          ],
          [
            [
              [-71.56097542899994, 61.33343559700006],
              [-71.48781845899993, 61.337112320000074],
              [-71.4839960079999, 61.31955458600004],
              [-71.48649490999992, 61.301894480000044],
              [-71.51288273599994, 61.299627169000075],
              [-71.5568559589999, 61.295836476000034],
              [-71.58639617999995, 61.30199068400003],
              [-71.58556105999992, 61.323891263000064],
              [-71.56097542899994, 61.33343559700006],
            ],
          ],
          [
            [
              [-72.0914252529999, 61.89474062600004],
              [-72.02154657199992, 61.87736161600009],
              [-71.9938568259999, 61.87065746400003],
              [-71.97343957399994, 61.85894228300003],
              [-72.01538848199993, 61.85261197400007],
              [-72.05894519199995, 61.85050341300007],
              [-72.10593696099994, 61.87072091300007],
              [-72.13083347799994, 61.88903851500004],
              [-72.11296772599991, 61.90463204100007],
              [-72.0914252529999, 61.89474062600004],
            ],
          ],
          [
            [
              [-92.79841330999994, 61.948019281000086],
              [-92.77187474599992, 61.93505477800005],
              [-92.78745574999994, 61.92878261800007],
              [-92.81707758499994, 61.936594143000036],
              [-92.83760989199993, 61.92596966800005],
              [-92.86329906899994, 61.93047224500003],
              [-92.87496630999993, 61.93867827000008],
              [-92.85066130099995, 61.947699207000085],
              [-92.79841330999994, 61.948019281000086],
            ],
          ],
          [
            [
              [-72.41213996999994, 62.039061202000084],
              [-72.38422098299992, 62.03239929400007],
              [-72.3281161079999, 62.01603765900006],
              [-72.35238455299992, 62.00029249600004],
              [-72.39381521199994, 62.01272416900008],
              [-72.4406474999999, 62.026846602000035],
              [-72.46240092199992, 62.03665243000006],
              [-72.41213996999994, 62.039061202000084],
            ],
          ],
          [
            [
              [-92.64169957099995, 62.06065567700006],
              [-92.63612815099992, 62.04044195400007],
              [-92.65284610399993, 62.02653924800006],
              [-92.68867279799991, 62.04187732500009],
              [-92.69378093899991, 62.05701773000004],
              [-92.70089782499991, 62.07463482400004],
              [-92.64169957099995, 62.06065567700006],
            ],
          ],
          [
            [
              [-66.43846030599991, 62.895262089000084],
              [-66.36325300299995, 62.87060780200005],
              [-66.34254113299994, 62.84955253000004],
              [-66.41058775399995, 62.848266049000074],
              [-66.49482125799994, 62.87736287000007],
              [-66.56904397499994, 62.91483245300003],
              [-66.56199630499992, 62.931058343000075],
              [-66.43846030599991, 62.895262089000084],
            ],
          ],
          [
            [
              [-66.9246942449999, 63.065198025000086],
              [-66.80735917299995, 62.98593630500005],
              [-66.77079867599991, 62.94491295700004],
              [-66.79311113299991, 62.92548263200007],
              [-66.83450626399991, 62.95281116700005],
              [-66.89489819099992, 62.98041840900004],
              [-66.97250261999994, 63.03407009000006],
              [-67.03824608899993, 63.07116647300006],
              [-67.07445693099993, 63.09750051000003],
              [-66.99490944799993, 63.092921742000044],
              [-66.9246942449999, 63.065198025000086],
            ],
          ],
          [
            [
              [-68.14525118299991, 63.27246623600007],
              [-68.05848307499991, 63.22267614200007],
              [-68.04981915399992, 63.19243036100005],
              [-68.12737704299991, 63.220558881000045],
              [-68.1878906359999, 63.250286825000046],
              [-68.21611053899994, 63.276375474000076],
              [-68.14525118299991, 63.27246623600007],
            ],
          ],
          [
            [
              [-68.02338663699993, 63.30086902900007],
              [-67.93172847299991, 63.232875258000036],
              [-67.8949939869999, 63.18944830400005],
              [-67.95893093699993, 63.21841570400005],
              [-68.03008983099994, 63.27159918600006],
              [-68.0919993039999, 63.320381069000064],
              [-68.02338663699993, 63.30086902900007],
            ],
          ],
          [
            [
              [-67.85266682999992, 63.34599330100008],
              [-67.8457402059999, 63.32608679900005],
              [-67.81829291299994, 63.29133348700003],
              [-67.86624350799991, 63.29177552800007],
              [-67.91453730499995, 63.337056680000046],
              [-67.95150186399991, 63.380523854000046],
              [-67.96400659999995, 63.40998460000009],
              [-67.91252879299992, 63.393132963000085],
              [-67.85266682999992, 63.34599330100008],
            ],
          ],
          [
            [
              [-64.0434301379999, 63.56314675500005],
              [-64.06482305999992, 63.53401329900004],
              [-64.0911717429999, 63.48646979600005],
              [-64.14888612099992, 63.540132070000084],
              [-64.1686679579999, 63.60457708000007],
              [-64.13730843299993, 63.61804039800006],
              [-64.0434301379999, 63.56314675500005],
            ],
          ],
          [
            [
              [-64.21724374399992, 63.842612957000085],
              [-64.17420067599994, 63.80567614600005],
              [-64.20420481499991, 63.79054429200005],
              [-64.25656607299993, 63.76163359800006],
              [-64.26110485799995, 63.723886975000084],
              [-64.31497329299992, 63.73936957900008],
              [-64.34285968699993, 63.76929604900005],
              [-64.34176953699995, 63.82007446300008],
              [-64.33399378999991, 63.84482888000008],
              [-64.21724374399992, 63.842612957000085],
            ],
          ],
          [
            [
              [-76.48420162699995, 64.18134186400005],
              [-76.52550208199995, 64.19708893400008],
              [-76.56851152299993, 64.20612213700008],
              [-76.57266191299993, 64.23427969000005],
              [-76.52965247299994, 64.24583567900004],
              [-76.49742591099994, 64.24258047100005],
              [-76.49413001199991, 64.22353750200006],
              [-76.47179114499994, 64.20612213700008],
              [-76.48420162699995, 64.18134186400005],
            ],
          ],
          [
            [
              [-76.66441809799994, 64.24168528900003],
              [-76.69090735599991, 64.25242747600004],
              [-76.69005286399994, 64.26406484600005],
              [-76.65200761599993, 64.26316966400003],
              [-76.61314856699994, 64.27147044500003],
              [-76.56525631399995, 64.25409577000005],
              [-76.59581458199995, 64.23920319200005],
              [-76.60741126199991, 64.22101471600007],
              [-76.62804114499994, 64.22186920800004],
              [-76.66441809799994, 64.24168528900003],
            ],
          ],
          [
            [
              [-64.9653635059999, 64.30970681700006],
              [-64.9868067619999, 64.29008803000005],
              [-64.9459877779999, 64.27599707200005],
              [-64.88446014699991, 64.26371383800006],
              [-64.93754360699995, 64.24421977900005],
              [-64.87830309299994, 64.22957797200007],
              [-64.94114737799993, 64.20632590600007],
              [-64.9912955769999, 64.19319186700005],
              [-65.04161779199995, 64.24471083300006],
              [-65.06650782899993, 64.27933365100006],
              [-65.07548654899995, 64.30696785600009],
              [-65.04617802399991, 64.32785207700005],
              [-64.9653635059999, 64.30970681700006],
            ],
          ],
          [
            [
              [-66.93427391599994, 65.31701358700008],
              [-66.96784715399991, 65.28303024200005],
              [-66.9970764869999, 65.29772982400004],
              [-67.01671657799994, 65.31978103800003],
              [-66.9711760799999, 65.34684771100007],
              [-66.92456464799994, 65.36489784500003],
              [-66.9029544359999, 65.34502933500005],
              [-66.93427391599994, 65.31701358700008],
            ],
          ],
          [
            [
              [-89.04675330399994, 65.40635762800008],
              [-89.02304480599992, 65.41470440000006],
              [-89.01310029299992, 65.40733958900006],
              [-89.01044240599992, 65.40063449300004],
              [-88.98885106799992, 65.39257914500007],
              [-88.96934335999993, 65.38787841900006],
              [-88.98055309699993, 65.38218494600005],
              [-89.0030529419999, 65.38508221200004],
              [-89.03125267299993, 65.39105621100003],
              [-89.05572643599993, 65.40094835500008],
              [-89.0727226169999, 65.39650306900006],
              [-89.08679440999992, 65.39203592100006],
              [-89.10270367999993, 65.39700273500006],
              [-89.10445393499992, 65.40887001700008],
              [-89.10056096499994, 65.41522880900004],
              [-89.0897511959999, 65.41059805000003],
              [-89.0789009209999, 65.40718259000005],
              [-89.0612825469999, 65.40888873900008],
              [-89.04675330399994, 65.40635762800008],
            ],
          ],
          [
            [
              [-88.43080041399992, 65.48699020800007],
              [-88.38306322099993, 65.47248055200004],
              [-88.3712768979999, 65.46199003100008],
              [-88.38892624499994, 65.45908026100005],
              [-88.42145939799991, 65.45736751200008],
              [-88.4589809499999, 65.45570147600006],
              [-88.48461774099991, 65.46477726200004],
              [-88.48910074799994, 65.47311121400008],
              [-88.48859468299992, 65.48139274400006],
              [-88.4523071129999, 65.48256141900004],
              [-88.43080041399992, 65.48699020800007],
            ],
          ],
          [
            [
              [-67.43251604399995, 65.74271277700007],
              [-67.38915832099991, 65.73617606600004],
              [-67.4227535409999, 65.72608368300007],
              [-67.4787824519999, 65.70800035800005],
              [-67.52947214799991, 65.71308646600005],
              [-67.61970029199995, 65.70136073200007],
              [-67.68248058199993, 65.68928222900007],
              [-67.70002082699995, 65.70072386300006],
              [-67.70454111099991, 65.71653140300003],
              [-67.67647256299995, 65.72749428800006],
              [-67.6249355839999, 65.73368893400004],
              [-67.55881705399992, 65.73895024200004],
              [-67.43251604399995, 65.74271277700007],
            ],
          ],
          [
            [
              [-65.7864184629999, 65.70198775400007],
              [-65.79811229899991, 65.68344979300008],
              [-65.83725049999993, 65.67831550000005],
              [-65.86111316299991, 65.70516739600004],
              [-65.85881910499995, 65.74948862000008],
              [-65.86555236099991, 65.78122830700005],
              [-65.80734117199995, 65.77692910500008],
              [-65.77063519399991, 65.76331209400007],
              [-65.7864184629999, 65.70198775400007],
            ],
          ],
          [
            [
              [-66.92946670399994, 65.94983440500005],
              [-66.96251694199992, 65.95108636900005],
              [-66.9880888209999, 65.97402130700004],
              [-67.05736008899993, 65.98330854800008],
              [-67.08768062099995, 65.97397001500008],
              [-67.10566440999992, 65.95769003700008],
              [-67.12966717099994, 65.97908612500004],
              [-67.14855654399992, 65.99589014200006],
              [-67.11994780299995, 66.00676874400006],
              [-67.05335170699993, 66.00806695300008],
              [-66.9638708889999, 65.99697261600005],
              [-66.92157402999993, 65.97527494600007],
              [-66.92946670399994, 65.94983440500005],
            ],
          ],
          [
            [
              [-85.02172456799991, 66.08306982500005],
              [-85.00275316999995, 66.07532309400005],
              [-85.00903827299993, 66.06542598000004],
              [-84.99747363099993, 66.05732373700005],
              [-85.02955027799993, 66.05066535800006],
              [-85.0620117549999, 66.04935368100007],
              [-85.0924242289999, 66.05093464400005],
              [-85.10400453099993, 66.05902387300006],
              [-85.09815643499991, 66.07427811000008],
              [-85.0806476539999, 66.08142776200003],
              [-85.02172456799991, 66.08306982500005],
            ],
          ],
          [
            [
              [-83.59520423099991, 66.04010651200008],
              [-83.60423743399991, 66.03815338700008],
              [-83.61986243399991, 66.04092031500005],
              [-83.62230383999992, 66.04901764500005],
              [-83.61314856699994, 66.05463288000004],
              [-83.60635331899994, 66.06122467700004],
              [-83.60464433499993, 66.06557851800005],
              [-83.60301673099991, 66.06891510600008],
              [-83.59312903599994, 66.07660553600005],
              [-83.57725989499994, 66.08380768400008],
              [-83.5703832669999, 66.08368561400005],
              [-83.57184811099995, 66.07733795800004],
              [-83.5711156889999, 66.07172272300005],
              [-83.56480872299994, 66.06020742400005],
              [-83.55776933499993, 66.05141836100006],
              [-83.55874589799993, 66.04596588700008],
              [-83.56773841099994, 66.04389069200005],
              [-83.57282467399995, 66.04539622600004],
              [-83.57713782499991, 66.04730866100005],
              [-83.58458411399994, 66.04608795800004],
              [-83.5918676419999, 66.04254791900007],
              [-83.59520423099991, 66.04010651200008],
            ],
          ],
          [
            [
              [-83.61143958199995, 66.08462148600006],
              [-83.61839758999992, 66.08397044500003],
              [-83.62262936099995, 66.08087799700007],
              [-83.63174394399994, 66.07611725500004],
              [-83.64842688699991, 66.07111237200007],
              [-83.64541581899994, 66.07591380400004],
              [-83.64244544199994, 66.08535390800006],
              [-83.65245520699995, 66.09072500200006],
              [-83.65782630099994, 66.09931061400005],
              [-83.65591386599993, 66.11334870000007],
              [-83.64879309799994, 66.12295156500005],
              [-83.63194739499994, 66.12128327000005],
              [-83.61253821499992, 66.11420319200005],
              [-83.60309811099995, 66.11444733300004],
              [-83.59902910099993, 66.11855703300006],
              [-83.59093176999994, 66.11798737200007],
              [-83.57408606699994, 66.11025625200006],
              [-83.57241777299993, 66.10643138200004],
              [-83.57738196499992, 66.10211823100008],
              [-83.58946692599994, 66.09853750200006],
              [-83.58971106699994, 66.09398021000004],
              [-83.5969945949999, 66.08844635600008],
              [-83.61143958199995, 66.08462148600006],
            ],
          ],
          [
            [
              [-85.95564212599993, 66.46317791300004],
              [-85.91123173699992, 66.46199107900009],
              [-85.89621613399993, 66.45386154300007],
              [-85.89954393099993, 66.44266151200009],
              [-85.92655105499995, 66.44101007900008],
              [-85.96242957999993, 66.43958958400003],
              [-85.97531466299995, 66.45181445300005],
              [-85.98229229599991, 66.46388431400004],
              [-85.95564212599993, 66.46317791300004],
            ],
          ],
          [
            [
              [-113.0083082619999, 67.94729431200005],
              [-112.9449924939999, 67.95015853800004],
              [-112.88533855299994, 67.96109620400006],
              [-112.81650743699993, 67.96915656400006],
              [-112.76134112599993, 67.96408139800008],
              [-112.81542630599989, 67.95085291100008],
              [-112.8682743089999, 67.94650814200008],
              [-112.89431966099994, 67.92916086800005],
              [-112.93934158699994, 67.92062475300008],
              [-113.0520593149999, 67.92042944300005],
              [-113.12147624099993, 67.91540026500007],
              [-113.1550986989999, 67.92177371400004],
              [-113.1389415619999, 67.93754878400006],
              [-113.0083082619999, 67.94729431200005],
            ],
          ],
          [
            [
              [-112.83692525499993, 68.17025048000005],
              [-112.7461299659999, 68.16762650300006],
              [-112.71780054099992, 68.15592047600006],
              [-112.76119713499992, 68.14560833100006],
              [-112.78970056399993, 68.13009472700008],
              [-112.8264591549999, 68.14150032600008],
              [-112.87915258899994, 68.14159612200007],
              [-112.91225559799994, 68.14488428200008],
              [-112.90420990299992, 68.16034959100006],
              [-112.89046701599995, 68.17347977300005],
              [-112.85534452199994, 68.17595131100006],
              [-112.83692525499993, 68.17025048000005],
            ],
          ],
          [
            [
              [-136.2119415179999, 69.17930901300008],
              [-136.1454724369999, 69.16138041800008],
              [-136.0668381819999, 69.12853045500003],
              [-136.0215302449999, 69.10837031500006],
              [-136.00626708499993, 69.09028059900004],
              [-136.03906945199992, 69.08700896700003],
              [-136.08698404599994, 69.09009321100007],
              [-136.11961679099994, 69.07934224500008],
              [-136.16759123799994, 69.08666511200005],
              [-136.22191015599992, 69.10568475800005],
              [-136.22531420799993, 69.12060374100008],
              [-136.17731438999994, 69.11649350700003],
              [-136.18074372899991, 69.13354597700004],
              [-136.2233231099999, 69.15687255000006],
              [-136.24774165299993, 69.17172226500008],
              [-136.2119415179999, 69.17930901300008],
            ],
          ],
          [
            [
              [-80.14657770399992, 69.40050573200006],
              [-80.12426368799993, 69.39333197700006],
              [-80.07100557699994, 69.38358312400004],
              [-80.08780669999993, 69.36562326100005],
              [-80.13129082599994, 69.36250101400003],
              [-80.18201203299992, 69.37959513200008],
              [-80.20770979399992, 69.40806662800009],
              [-80.20103765899995, 69.42770454600003],
              [-80.14657770399992, 69.40050573200006],
            ],
          ],
          [
            [
              [-81.64327938799994, 69.41437846600007],
              [-81.54852694199991, 69.41548622400006],
              [-81.50578946199994, 69.40682846600004],
              [-81.49912241899995, 69.37209129300004],
              [-81.48563125999993, 69.34718034400004],
              [-81.5682994309999, 69.34425843200006],
              [-81.6721840219999, 69.35351158000003],
              [-81.7007959579999, 69.36884492600007],
              [-81.69191101099995, 69.38438648300007],
              [-81.78196996399993, 69.38733910300004],
              [-81.76734820799993, 69.36529275000004],
              [-81.83030918499992, 69.34433230800005],
              [-81.88270248499992, 69.36328218600005],
              [-81.9027227439999, 69.39414630100003],
              [-81.8967567169999, 69.41696085100006],
              [-81.83886931599994, 69.43378785700008],
              [-81.71348368999992, 69.42822833600007],
              [-81.64327938799994, 69.41437846600007],
            ],
          ],
          [
            [
              [-135.7059526779999, 69.50875084800003],
              [-135.5911823209999, 69.46710471900008],
              [-135.5952433309999, 69.44842380400007],
              [-135.63616325599992, 69.45132723900008],
              [-135.70987365999991, 69.47429111300005],
              [-135.76723741299992, 69.48144560800006],
              [-135.84092817999993, 69.48137953600008],
              [-135.8410917889999, 69.49573626300008],
              [-135.78793664599993, 69.50584089000006],
              [-135.7059526779999, 69.50875084800003],
            ],
          ],
          [
            [
              [-82.50623510399993, 69.79062566200008],
              [-82.4920467359999, 69.76298116400005],
              [-82.5588683819999, 69.74334865100008],
              [-82.69554125299993, 69.76144684100007],
              [-82.81570834899992, 69.78186063700008],
              [-82.85468069899991, 69.79435394300003],
              [-82.84331088099992, 69.80839531000004],
              [-82.74901751699991, 69.82023467400006],
              [-82.64772189899992, 69.82609623700006],
              [-82.50623510399993, 69.79062566200008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Mexico',
        iso3: 'MEX',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-97.13927161399994, 25.96580638200004],
              [-97.16746985599991, 25.828599351000037],
              [-97.15733801999994, 25.789536851000037],
              [-97.16445878799993, 25.76951732000009],
              [-97.16515051999994, 25.72333405200004],
              [-97.17442786399994, 25.70416901200008],
              [-97.18626868399991, 25.68695709800005],
              [-97.19815019399994, 25.64667389500005],
              [-97.22496497299994, 25.584418036000045],
              [-97.26154537699995, 25.49945709800005],
              [-97.31944739499994, 25.389960028000075],
              [-97.45897376199991, 25.179388739000046],
              [-97.55520585849993, 24.847621974500044],
              [-97.65143795499995, 24.51585521000004],
              [-97.70799719999991, 24.08388906500005],
              [-97.7117406889999, 24.04913971600007],
              [-97.71666419199994, 24.00812409100007],
              [-97.72520911399994, 23.80565013200004],
              [-97.73330644399994, 23.788397528000075],
              [-97.75096594999991, 23.78192780200004],
              [-97.82209225199995, 23.788397528000075],
              [-97.82209225199995, 23.78221263200004],
              [-97.79442298099991, 23.78261953300006],
              [-97.77285722599993, 23.780096747000073],
              [-97.75885982999995, 23.76902903900009],
              [-97.75381425699993, 23.74371979400007],
              [-97.76060950399994, 23.65192291900007],
              [-97.75381425699993, 23.65192291900007],
              [-97.74693762899994, 23.67914459800005],
              [-97.74209550699993, 23.74518463700008],
              [-97.73330644399994, 23.77480703300006],
              [-97.7222387359999, 23.73932526200008],
              [-97.74181067599994, 23.536363023000035],
              [-97.75812740799995, 23.440375067000048],
              [-97.76854407499991, 23.26007721600007],
              [-97.74233964799993, 22.97207265800006],
              [-97.75381425699993, 22.849310614000046],
              [-97.75267493399991, 22.907049872000073],
              [-97.75389563699991, 22.92324453300006],
              [-97.7644750639999, 22.91201406500005],
              [-97.79478919199994, 22.808335679000038],
              [-97.80239824099993, 22.793768622000073],
              [-97.83576412699995, 22.76117584800005],
              [-97.83901933499993, 22.753729559000078],
              [-97.83824622299994, 22.73969147300005],
              [-97.84316972599993, 22.733303127000056],
              [-97.84996497299994, 22.732367255000042],
              [-97.87669837099992, 22.739447333000044],
              [-97.85741126199991, 22.718573309000078],
              [-97.8550512359999, 22.698553778000075],
              [-97.88939368399991, 22.625433661000045],
              [-97.89321855399993, 22.610256252000056],
              [-97.89098059799994, 22.596096096000053],
              [-97.88198808499993, 22.58787669500009],
              [-97.87010657499991, 22.587713934000078],
              [-97.85838782499991, 22.593451239000046],
              [-97.85000566299993, 22.60293203300006],
              [-97.84927324099993, 22.613226630000042],
              [-97.85334225199995, 22.64394765800006],
              [-97.85000566299993, 22.657538153000075],
              [-97.83995520699995, 22.670314846000053],
              [-97.83429928299995, 22.669745184000078],
              [-97.8313695949999, 22.65973541900007],
              [-97.82957923099991, 22.643866278000075],
              [-97.83006751199991, 22.616400458000044],
              [-97.85000566299993, 22.53461334800005],
              [-97.82005774599992, 22.433294989000046],
              [-97.82209225199995, 22.40428294500009],
              [-97.81777910099993, 22.390692450000074],
              [-97.80907141799992, 22.340318101000037],
              [-97.80532792899993, 22.32916901200008],
              [-97.79922441299993, 22.318833726000037],
              [-97.77428137899994, 22.25348541900007],
              [-97.77135169199994, 22.131659247000073],
              [-97.76060950399994, 22.095851955000057],
              [-97.61046301999994, 21.835760809000078],
              [-97.50812740799995, 21.722805080000057],
              [-97.48997962099992, 21.712836005000042],
              [-97.43529212099992, 21.665350653000075],
              [-97.42487545499995, 21.661037502000056],
              [-97.41380774599992, 21.64671458500004],
              [-97.34227454299992, 21.60297272300005],
              [-97.31623287699995, 21.560939846000053],
              [-97.3191625639999, 21.51984284100007],
              [-97.33360755099994, 21.478338934000078],
              [-97.34227454299992, 21.43512604400007],
              [-97.34788977799991, 21.417914130000042],
              [-97.37584387899994, 21.37327708500004],
              [-97.38731848899994, 21.35936107000009],
              [-97.39818274599992, 21.341620184000078],
              [-97.40420488199993, 21.318915106000077],
              [-97.41120357999995, 21.273382880000042],
              [-97.41860917899993, 21.273382880000042],
              [-97.4317113919999, 21.342271226000037],
              [-97.45612545499995, 21.392279364000046],
              [-97.46377519399994, 21.42401764500005],
              [-97.47154700399994, 21.43073151200008],
              [-97.4722387359999, 21.43781159100007],
              [-97.45563717399995, 21.45526764500005],
              [-97.43980872299994, 21.466620184000078],
              [-97.41942298099991, 21.47675202000005],
              [-97.40086829299992, 21.480536200000074],
              [-97.39073645699995, 21.47264232000009],
              [-97.38048255099994, 21.489203192000048],
              [-97.37425696499992, 21.504299221000053],
              [-97.37108313699991, 21.51984284100007],
              [-97.37022864499994, 21.537502346000053],
              [-97.3789770169999, 21.554348049000055],
              [-97.3992406889999, 21.57062409100007],
              [-97.43854732999995, 21.595526434000078],
              [-97.48688717399995, 21.636419989000046],
              [-97.50161699099993, 21.660549221000053],
              [-97.55581620999993, 21.712836005000042],
              [-97.60204016799992, 21.777044989000046],
              [-97.6250707669999, 21.79441966400009],
              [-97.63027910099993, 21.804388739000046],
              [-97.63097083199995, 21.816839911000045],
              [-97.64761308499993, 21.88434479400007],
              [-97.65884355399993, 21.907456773000035],
              [-97.68590247299994, 21.92450592700004],
              [-97.76756751199991, 22.063788153000075],
              [-97.78111731699994, 22.095851955000057],
              [-97.77700761599993, 22.073065497000073],
              [-97.76012122299994, 22.036851304000038],
              [-97.75145423099991, 22.02570221600007],
              [-97.74429277299993, 22.006415106000077],
              [-97.71971594999991, 21.95180898600006],
              [-97.71263587099992, 21.910956122000073],
              [-97.70836341099994, 21.827460028000075],
              [-97.68814042899993, 21.76080963700008],
              [-97.67259680899991, 21.67527903900009],
              [-97.65758216099994, 21.636542059000078],
              [-97.57762610599991, 21.50104401200008],
              [-97.56200110599991, 21.485663153000075],
              [-97.54564368399991, 21.477362372000073],
              [-97.53066972599993, 21.476263739000046],
              [-97.51610266799992, 21.48183828300006],
              [-97.50059973899994, 21.493109442000048],
              [-97.48940995999993, 21.48078034100007],
              [-97.49071204299992, 21.462144273000035],
              [-97.50059973899994, 21.421087958000044],
              [-97.49681555899991, 21.40062083500004],
              [-97.42951412699995, 21.27167389500005],
              [-97.42829342399995, 21.26040273600006],
              [-97.41250566299993, 21.255194403000075],
              [-97.40489661399994, 21.241888739000046],
              [-97.39753170499995, 21.205145575000074],
              [-97.33804277299993, 21.05499909100007],
              [-97.26813717399995, 20.927883205000057],
              [-97.19717363199993, 20.810207424000055],
              [-97.18700110599991, 20.77680084800005],
              [-97.17784583199995, 20.759466864000046],
              [-97.18321692599994, 20.75604889500005],
              [-97.18814042899993, 20.751776434000078],
              [-97.19831295499995, 20.73895905200004],
              [-97.15054277299993, 20.647040106000077],
              [-97.03441321499992, 20.514553127000056],
              [-97.00031490799995, 20.48574453300006],
              [-96.95986894399994, 20.46482982000009],
              [-96.94033769399994, 20.449164130000042],
              [-96.92564856699994, 20.41034577000005],
              [-96.91087805899991, 20.39280833500004],
              [-96.8836156889999, 20.368475653000075],
              [-96.81480872299994, 20.29043203300006],
              [-96.75328528599994, 20.240790106000077],
              [-96.73428300699993, 20.22101471600007],
              [-96.72154700399994, 20.192694403000075],
              [-96.71157792899993, 20.182440497000073],
              [-96.70116126199991, 20.173976955000057],
              [-96.69522050699993, 20.170477606000077],
              [-96.68443762899994, 20.16673411700009],
              [-96.67601477799991, 20.157863674000055],
              [-96.64110266799992, 20.10024648600006],
              [-96.57510331899994, 20.02643463700008],
              [-96.50987708199995, 19.929754950000074],
              [-96.45612545499995, 19.868801174000055],
              [-96.44009355399993, 19.837713934000078],
              [-96.40514075399994, 19.741848049000055],
              [-96.39366614499994, 19.654120184000078],
              [-96.36001542899993, 19.536851304000038],
              [-96.34923255099994, 19.519354559000078],
              [-96.31550045499995, 19.482245184000078],
              [-96.31029212099992, 19.462958075000074],
              [-96.32070878799993, 19.438828843000067],
              [-96.3191625639999, 19.424709377000056],
              [-96.30479895699995, 19.39199453300006],
              [-96.29845130099994, 19.35415273600006],
              [-96.2903539699999, 19.332586981000077],
              [-96.27830969999991, 19.314601955000057],
              [-96.25450598899994, 19.30145905200004],
              [-96.17162024599992, 19.234116929000038],
              [-96.15737870999993, 19.225165106000077],
              [-96.13194739499994, 19.23590729400007],
              [-96.12214107999995, 19.22207265800006],
              [-96.1187231109999, 19.198472398000035],
              [-96.11241614499994, 19.180121161000045],
              [-96.10289466099994, 19.165838934000078],
              [-96.08849036399994, 19.115301825000074],
              [-96.07738196499992, 19.096096096000053],
              [-96.06143144399994, 19.078517971000053],
              [-96.04124915299991, 19.065659898000035],
              [-96.0171606109999, 19.060614325000074],
              [-95.99120032499991, 19.061021226000037],
              [-95.97716223899994, 19.058254299000055],
              [-95.97032630099994, 19.046087958000044],
              [-95.95628821499992, 18.975816148000035],
              [-95.94176184799994, 18.93895091400009],
              [-95.92369544199994, 18.90766022300005],
              [-95.90355383999992, 18.88190338700008],
              [-95.86774654899995, 18.84910716400009],
              [-95.84434973899994, 18.83340078300006],
              [-95.82437089799993, 18.826646226000037],
              [-95.80825761599993, 18.82453034100007],
              [-95.78604081899994, 18.818833726000037],
              [-95.7652074859999, 18.81045156500005],
              [-95.7527563139999, 18.799994208000044],
              [-95.75121008999992, 18.792792059000078],
              [-95.7527563139999, 18.76581452000005],
              [-95.77790279899995, 18.778509833000044],
              [-95.82457434799994, 18.813299872000073],
              [-95.87950598899994, 18.828517971000053],
              [-95.91478430899991, 18.862494208000044],
              [-95.93765214799993, 18.86823151200008],
              [-95.95885169199994, 18.856390692000048],
              [-95.93651282499991, 18.838364976000037],
              [-95.90099036399994, 18.822333075000074],
              [-95.88243567599994, 18.81704336100006],
              [-95.87291419199994, 18.798773505000042],
              [-95.85069739499994, 18.779852606000077],
              [-95.80736243399991, 18.75214264500005],
              [-95.80736243399991, 18.744696356000077],
              [-95.82420813699991, 18.745266018000052],
              [-95.85130774599992, 18.75617096600007],
              [-95.86632239499994, 18.758978583000044],
              [-95.87730872299994, 18.752386786000045],
              [-95.87303626199991, 18.73786041900007],
              [-95.86188717399995, 18.72337474200009],
              [-95.85204016799992, 18.71678294500009],
              [-95.83584550699993, 18.717596747000073],
              [-95.82433020699995, 18.72011953300006],
              [-95.80113684799994, 18.731024481000077],
              [-95.79775956899994, 18.73505280200004],
              [-95.79718990799995, 18.739488023000035],
              [-95.79417883999992, 18.74323151200008],
              [-95.78343665299991, 18.744696356000077],
              [-95.7747289699999, 18.74404531500005],
              [-95.66930091099994, 18.71434153900009],
              [-95.64688066299993, 18.710598049000055],
              [-95.62840735599991, 18.700344143000052],
              [-95.60643469999991, 18.68105703300006],
              [-95.58503170499995, 18.669663804000038],
              [-95.56834876199991, 18.683294989000046],
              [-95.60826575399994, 18.70766836100006],
              [-95.67430579299992, 18.729396877000056],
              [-95.72838294199994, 18.75722890800006],
              [-95.73281816299993, 18.799994208000044],
              [-95.66417395699995, 18.75104401200008],
              [-95.58360755099994, 18.72166575700004],
              [-95.49518795499995, 18.70734284100007],
              [-95.36473548099991, 18.703273830000057],
              [-95.27525794199994, 18.709906317000048],
              [-95.20836341099994, 18.708644924000055],
              [-95.19005286399994, 18.705145575000074],
              [-95.17300370999993, 18.69672272300005],
              [-95.13809160099993, 18.66705963700008],
              [-95.05142167899993, 18.612250067000048],
              [-95.0384008449999, 18.59796784100007],
              [-95.03331458199995, 18.57713450700004],
              [-95.0242406889999, 18.56403229400007],
              [-95.00255286399994, 18.55540599200009],
              [-94.87193762899994, 18.53583405200004],
              [-94.8550512359999, 18.527899481000077],
              [-94.80785071499992, 18.52362702000005],
              [-94.78693600199995, 18.51194896000004],
              [-94.76919511599993, 18.483343817000048],
              [-94.73859615799995, 18.406805731000077],
              [-94.71800696499992, 18.374823309000078],
              [-94.65274003799993, 18.313788153000075],
              [-94.62828528599994, 18.28534577000005],
              [-94.5808813139999, 18.189846096000053],
              [-94.5750219389999, 18.188299872000073],
              [-94.54332434799994, 18.16620514500005],
              [-94.53087317599994, 18.160630601000037],
              [-94.50023352799991, 18.15761953300006],
              [-94.46694902299993, 18.144232489000046],
              [-94.43846594999991, 18.14720286700009],
              [-94.41006425699993, 18.153550523000092],
              [-94.38841712099992, 18.15570709800005],
              [-94.35415605399993, 18.168524481000077],
              [-94.20714270699995, 18.18964264500005],
              [-94.13487708199995, 18.20799388200004],
              [-94.11164303299995, 18.220851955000057],
              [-94.08458411399994, 18.232245184000078],
              [-94.00780188699991, 18.248439846000053],
              [-93.99181067599994, 18.262152411000045],
              [-93.97256425699993, 18.27212148600006],
              [-93.86148027299993, 18.30654531500005],
              [-93.86831620999993, 18.295803127000056],
              [-93.87751217399995, 18.28652578300006],
              [-93.88540605399993, 18.27606842700004],
              [-93.88878333199995, 18.262152411000045],
              [-93.87828528599994, 18.25690338700008],
              [-93.79820716099994, 18.26748281500005],
              [-93.78111731699994, 18.272772528000075],
              [-93.76744544199994, 18.281195380000042],
              [-93.7591039699999, 18.292222398000092],
              [-93.75885982999995, 18.30149974200009],
              [-93.76349850199995, 18.308254299000055],
              [-93.76675370999993, 18.314846096000053],
              [-93.7625219389999, 18.323919989000046],
              [-93.75617428299995, 18.329291083000044],
              [-93.74400794199994, 18.336004950000074],
              [-93.73859615799995, 18.340643622000073],
              [-93.72520911399994, 18.337103583000044],
              [-93.71060136599993, 18.339585679000038],
              [-93.69640051999994, 18.346177476000037],
              [-93.68394934799994, 18.35492584800005],
              [-93.67756100199995, 18.336411851000037],
              [-93.65721594999991, 18.333319403000075],
              [-93.59284420499995, 18.344956773000092],
              [-93.58120683499993, 18.356268622000073],
              [-93.56663977799991, 18.389064846000053],
              [-93.57640540299991, 18.411851304000038],
              [-93.58031165299991, 18.41632721600007],
              [-93.58873450399994, 18.415350653000075],
              [-93.60260982999995, 18.411037502000056],
              [-93.61554928299995, 18.40497467700004],
              [-93.62124589799993, 18.398993231000077],
              [-93.63267981699994, 18.390448309000078],
              [-93.70384680899991, 18.36859772300005],
              [-93.71007239499994, 18.363348700000074],
              [-93.71873938699991, 18.35187409100007],
              [-93.72492428299995, 18.347479559000078],
              [-93.76903235599991, 18.340643622000073],
              [-93.80345618399991, 18.31708405200004],
              [-93.81411699099993, 18.31207916900007],
              [-93.82542883999992, 18.311468817000048],
              [-93.83682206899994, 18.30931224200009],
              [-93.84780839799993, 18.299709377000056],
              [-93.83958899599992, 18.31854889500005],
              [-93.82079016799992, 18.32754140800006],
              [-93.80186926999994, 18.333685614000046],
              [-93.79320227799991, 18.34406159100007],
              [-93.78197180899991, 18.35297272300005],
              [-93.59666907499991, 18.41990794500009],
              [-93.55235755099994, 18.429388739000046],
              [-93.44469153599994, 18.441799221000053],
              [-93.30553137899994, 18.437933661000045],
              [-93.15575110599991, 18.443060614000046],
              [-93.15575110599991, 18.436835028000075],
              [-93.16567949099993, 18.421535549000055],
              [-93.17308508999992, 18.41364166900007],
              [-93.18309485599991, 18.40892161700009],
              [-93.17837480399993, 18.40037669500009],
              [-93.17642167899993, 18.37767161700009],
              [-93.17003333199995, 18.36859772300005],
              [-93.16047115799995, 18.368963934000078],
              [-93.14525305899991, 18.37445709800005],
              [-93.13036048099991, 18.38222890800006],
              [-93.12165279899995, 18.389064846000053],
              [-93.12254798099991, 18.373968817000048],
              [-93.13385982999995, 18.35488515800006],
              [-93.13532467399995, 18.340643622000073],
              [-93.1284887359999, 18.340643622000073],
              [-93.11412512899994, 18.36163971600007],
              [-93.10732988199993, 18.36859772300005],
              [-93.1148168609999, 18.374823309000078],
              [-93.09479732999995, 18.378119208000044],
              [-93.08836829299992, 18.39276764500005],
              [-93.09593665299991, 18.40888092700004],
              [-93.11823482999995, 18.41632721600007],
              [-93.13939368399991, 18.42023346600007],
              [-93.13760331899994, 18.428859768000052],
              [-93.12193762899994, 18.437933661000045],
              [-93.1011449859999, 18.443060614000046],
              [-92.9397696499999, 18.445740928000077],
              [-92.85573099599992, 18.466046608000056],
              [-92.8067894269999, 18.494094085000086],
              [-92.7593073939999, 18.53667241700009],
              [-92.73839270699995, 18.564195054000038],
              [-92.73058020699995, 18.57713450700004],
              [-92.72630774599992, 18.587632554000038],
              [-92.71690833199995, 18.592189846000053],
              [-92.70750891799992, 18.59088776200008],
              [-92.70327714799993, 18.58429596600007],
              [-92.6902563139999, 18.55292389500005],
              [-92.68219967399995, 18.455959377000056],
              [-92.66909745999993, 18.429388739000046],
              [-92.66226152299993, 18.45734284100007],
              [-92.67027747299994, 18.47284577000005],
              [-92.66942298099991, 18.494208075000074],
              [-92.66226152299993, 18.53583405200004],
              [-92.66836503799993, 18.55654531500005],
              [-92.69298255099994, 18.60252513200004],
              [-92.69587154899995, 18.615627346000053],
              [-92.68101966099994, 18.622870184000078],
              [-92.6563207669999, 18.624253648000092],
              [-92.61082923099991, 18.62181224200009],
              [-92.58897864499994, 18.62490469000005],
              [-92.48614402599992, 18.648482672000057],
              [-92.4051404139999, 18.671062566000046],
              [-92.29271399599992, 18.67682526200008],
              [-92.18675696499992, 18.68622467700004],
              [-92.0601326439999, 18.70161721700009],
              [-91.9793087669999, 18.698430251000048],
              [-91.94806007299991, 18.69122495000005],
              [-91.92080644399994, 18.661932684000078],
              [-91.86693274599992, 18.62836334800005],
              [-91.86042232999995, 18.62181224200009],
              [-91.86042232999995, 18.609808661000045],
              [-91.86656653599994, 18.59837474200009],
              [-91.87661699099993, 18.59015534100007],
              [-91.88829505099994, 18.587632554000038],
              [-91.88365637899994, 18.594305731000077],
              [-91.88084876199991, 18.601304429000038],
              [-91.8926488919999, 18.596625067000048],
              [-91.9051000639999, 18.59442780200004],
              [-91.93236243399991, 18.593898830000057],
              [-91.94253495999993, 18.59837474200009],
              [-91.94066321499992, 18.60887278900009],
              [-91.93724524599992, 18.62055084800005],
              [-91.9429418609999, 18.628648179000038],
              [-91.95018469999991, 18.62954336100006],
              [-91.95628821499992, 18.627386786000045],
              [-91.97606360599991, 18.61155833500004],
              [-91.98070227799991, 18.611273505000042],
              [-91.98534094999991, 18.613836981000077],
              [-91.99445553299995, 18.615627346000053],
              [-92.00820878799993, 18.612982489000046],
              [-92.01138261599993, 18.607367255000042],
              [-92.00503495999993, 18.602362372000073],
              [-91.99071204299992, 18.601304429000038],
              [-91.99071204299992, 18.593898830000057],
              [-92.00357011599993, 18.590236721000053],
              [-92.01646887899994, 18.589667059000078],
              [-92.02847245999993, 18.593085028000075],
              [-92.0391332669999, 18.601304429000038],
              [-92.03726152299993, 18.595445054000038],
              [-92.0366918609999, 18.591050523000092],
              [-92.03538977799991, 18.586737372000073],
              [-92.03164628799993, 18.58079661700009],
              [-92.03990637899994, 18.57420482000009],
              [-92.04600989499994, 18.56663646000004],
              [-92.05016028599994, 18.55760325700004],
              [-92.0528051419999, 18.546698309000078],
              [-92.04775956899994, 18.550726630000042],
              [-92.03164628799993, 18.560370184000078],
              [-92.0137426419999, 18.54633209800005],
              [-92.00389563699991, 18.54173411700009],
              [-91.99071204299992, 18.53925202000005],
              [-91.96861731699994, 18.545721747000073],
              [-91.95518958199995, 18.547674872000073],
              [-91.94912675699993, 18.543036200000074],
              [-91.94261633999992, 18.52997467700004],
              [-91.92662512899994, 18.51829661700009],
              [-91.90672766799992, 18.509711005000042],
              [-91.88829505099994, 18.50576406500005],
              [-91.91502844999991, 18.52558014500005],
              [-91.94298255099994, 18.54197825700004],
              [-91.9641820949999, 18.562323309000078],
              [-91.9702856109999, 18.593898830000057],
              [-91.95006262899994, 18.58429596600007],
              [-91.93883216099994, 18.57526276200008],
              [-91.92625891799992, 18.572333075000074],
              [-91.90196692599994, 18.58079661700009],
              [-91.91502844999991, 18.560370184000078],
              [-91.90135657499991, 18.55573151200008],
              [-91.88817298099991, 18.548163153000075],
              [-91.87816321499992, 18.537990627000056],
              [-91.87401282499991, 18.52558014500005],
              [-91.88829505099994, 18.532416083000044],
              [-91.88931230399993, 18.529242255000042],
              [-91.88906816299993, 18.52680084800005],
              [-91.89004472599993, 18.525458075000074],
              [-91.89452063699991, 18.52558014500005],
              [-91.87694251199991, 18.51439036700009],
              [-91.8372289699999, 18.503241278000075],
              [-91.82628333199995, 18.491441148000092],
              [-91.82909094999991, 18.47728099200009],
              [-91.85423743399991, 18.44830963700008],
              [-91.86042232999995, 18.43317291900007],
              [-91.85228430899991, 18.42015208500004],
              [-91.83397376199991, 18.402777411000045],
              [-91.81427975199995, 18.38865794500009],
              [-91.8020727199999, 18.385646877000056],
              [-91.79234778599994, 18.401556708000044],
              [-91.79649817599994, 18.41592031500005],
              [-91.80601966099994, 18.43121979400007],
              [-91.81261145699995, 18.450506903000075],
              [-91.80443274599992, 18.442206122000073],
              [-91.79454505099994, 18.437323309000078],
              [-91.78343665299991, 18.435614325000074],
              [-91.77159583199995, 18.436835028000075],
              [-91.78209387899994, 18.450140692000048],
              [-91.79649817599994, 18.462632554000038],
              [-91.80516516799992, 18.475897528000075],
              [-91.79832923099991, 18.491441148000092],
              [-91.77281653599994, 18.47850169500009],
              [-91.7117406889999, 18.46279531500005],
              [-91.68224036399994, 18.450506903000075],
              [-91.66356360599991, 18.456203518000052],
              [-91.61815344999991, 18.445257880000042],
              [-91.59288489499994, 18.443060614000046],
              [-91.54442298099991, 18.449164130000042],
              [-91.52131100199995, 18.45506419500009],
              [-91.50405839799993, 18.464178778000075],
              [-91.50259355399993, 18.449693101000037],
              [-91.49583899599992, 18.439601955000057],
              [-91.48648027299993, 18.436428127000056],
              [-91.47740637899994, 18.443060614000046],
              [-91.4754125639999, 18.45465729400007],
              [-91.4824926419999, 18.48468659100007],
              [-91.48363196499992, 18.49827708500004],
              [-91.49046790299991, 18.49827708500004],
              [-91.49201412699995, 18.49286530200004],
              [-91.49583899599992, 18.485174872000073],
              [-91.49730383999992, 18.477769273000092],
              [-91.50804602799991, 18.47719961100006],
              [-91.53404700399994, 18.46580638200004],
              [-91.53888912699995, 18.47101471600007],
              [-91.53404700399994, 18.480861721000053],
              [-91.51162675699993, 18.50527578300006],
              [-91.50405839799993, 18.51194896000004],
              [-91.48045813699991, 18.524318752000056],
              [-91.42381751199991, 18.54433828300006],
              [-91.39488684799994, 18.560370184000078],
              [-91.37930253799993, 18.554836330000057],
              [-91.36164303299995, 18.55801015800006],
              [-91.3450414699999, 18.565619208000044],
              [-91.3328344389999, 18.573431708000044],
              [-91.32408606699994, 18.58429596600007],
              [-91.30724036399994, 18.615383205000057],
              [-91.30174719999991, 18.62181224200009],
              [-91.26821855399993, 18.61912669500009],
              [-91.25133216099994, 18.619696356000077],
              [-91.24400794199994, 18.62518952000005],
              [-91.23615475199995, 18.63540273600006],
              [-91.19701087099992, 18.64638906500005],
              [-91.18199622299994, 18.65656159100007],
              [-91.19912675699993, 18.663234768000052],
              [-91.21231035099993, 18.661322333000044],
              [-91.23721269399994, 18.64911530200004],
              [-91.28482011599993, 18.63670482000009],
              [-91.29865475199995, 18.628648179000038],
              [-91.2664281889999, 18.704291083000044],
              [-91.26553300699993, 18.735663153000075],
              [-91.28563391799992, 18.76581452000005],
              [-91.30235755099994, 18.780951239000046],
              [-91.3106176419999, 18.784491278000075],
              [-91.32258053299995, 18.785630601000037],
              [-91.33259029899995, 18.782904364000046],
              [-91.33665930899991, 18.776597398000035],
              [-91.33967037699995, 18.769924221000053],
              [-91.3465063139999, 18.76581452000005],
              [-91.36701412699995, 18.771226304000038],
              [-91.39537512899994, 18.806586005000042],
              [-91.41470292899993, 18.813625393000052],
              [-91.40111243399991, 18.83738841400009],
              [-91.38072669199994, 18.859442450000074],
              [-91.35773678299995, 18.87563711100006],
              [-91.31110592399995, 18.89081452000005],
              [-91.28050696499992, 18.91201406500005],
              [-91.25304114499994, 18.93707916900007],
              [-91.23721269399994, 18.957586981000077],
              [-91.26085364499994, 18.95262278900009],
              [-91.32599850199995, 18.90298086100006],
              [-91.39126542899993, 18.87128327000005],
              [-91.4168188139999, 18.850165106000077],
              [-91.41470292899993, 18.826646226000037],
              [-91.42418372299994, 18.82184479400007],
              [-91.4290258449999, 18.826646226000037],
              [-91.45213782499991, 18.81159088700008],
              [-91.46426347599993, 18.808294989000046],
              [-91.48363196499992, 18.80735911700009],
              [-91.50340735599991, 18.80955638200004],
              [-91.50527910099993, 18.816555080000057],
              [-91.48241126199991, 18.842637437000064],
              [-91.43118799199993, 18.880117173000087],
              [-91.36691320999995, 18.91406913700007],
              [-91.2817476749999, 18.96556096900008],
              [-91.16161048099991, 19.01626211100006],
              [-91.07957923099991, 19.08734772300005],
              [-91.05899003799993, 19.09715403900009],
              [-91.01366126199991, 19.113348700000074],
              [-90.93553626199991, 19.16307200700004],
              [-90.85655676999994, 19.258286851000037],
              [-90.83592688699991, 19.272284247000073],
              [-90.80308997299994, 19.282904364000046],
              [-90.76935787699995, 19.30923086100006],
              [-90.74242102799991, 19.342962958000044],
              [-90.73009192599994, 19.375921942000048],
              [-90.71434485599991, 19.56989166900007],
              [-90.70494544199994, 19.611883856000077],
              [-90.70278886599993, 19.632554429000038],
              [-90.70498613199993, 19.654771226000037],
              [-90.70872962099992, 19.67096588700008],
              [-90.70946204299992, 19.68748607000009],
              [-90.70278886599993, 19.71112702000005],
              [-90.68370520699995, 19.75291575700004],
              [-90.66454016799992, 19.78192780200004],
              [-90.60673300499991, 19.82121954300004],
              [-90.5168563819999, 19.88165214600008],
              [-90.47782273799993, 19.92210102300004],
              [-90.46825110599991, 19.96430084800005],
              [-90.46385657499991, 19.977850653000075],
              [-90.46255449099993, 19.99567291900007],
              [-90.46719316299993, 20.013332424000055],
              [-90.4973852199999, 20.06736888200004],
              [-90.50023352799991, 20.079250393000052],
              [-90.50015214799993, 20.08812083500004],
              [-90.4973852199999, 20.108343817000048],
              [-90.49665279899995, 20.18463776200008],
              [-90.48729407499991, 20.23460521000004],
              [-90.48989824099993, 20.290228583000044],
              [-90.48827063699991, 20.31207916900007],
              [-90.47565670499995, 20.368475653000075],
              [-90.47447669199994, 20.40851471600007],
              [-90.4895727199999, 20.49054596600007],
              [-90.48989824099993, 20.534125067000048],
              [-90.46690833199995, 20.618882554000038],
              [-90.45938066299993, 20.71552155200004],
              [-90.44912675699993, 20.742132880000042],
              [-90.39321855399993, 20.80414459800005],
              [-90.37905839799993, 20.827460028000075],
              [-90.36705481699994, 20.88149648600006],
              [-90.34190833199995, 20.939154364000046],
              [-90.33910071499992, 20.972357489000046],
              [-90.34654700399994, 20.972357489000046],
              [-90.3601781889999, 20.917710679000038],
              [-90.37808183499993, 20.880682684000078],
              [-90.38068600199995, 20.87303294500009],
              [-90.38532467399995, 20.84910716400009],
              [-90.39806067599994, 20.820746161000045],
              [-90.41755123599995, 20.79710521000004],
              [-90.44212805899991, 20.78742096600007],
              [-90.44212805899991, 20.794256903000075],
              [-90.42223059799994, 20.819566148000035],
              [-90.36009680899991, 21.000392971000053],
              [-90.3496801419999, 21.016750393000052],
              [-90.33238684799994, 21.032456773000035],
              [-90.22008216099994, 21.09837474200009],
              [-90.19945227799991, 21.114162502000056],
              [-90.1336156889999, 21.136867580000057],
              [-90.09947669199994, 21.164129950000074],
              [-90.07774817599994, 21.17373281500005],
              [-90.0657445949999, 21.17715078300006],
              [-90.03490149599992, 21.180568752000056],
              [-89.98216712099992, 21.198919989000046],
              [-89.92153886599993, 21.240668036000045],
              [-89.90428626199991, 21.24673086100006],
              [-89.88638261599993, 21.249823309000078],
              [-89.7859594389999, 21.28457265800006],
              [-89.67756100199995, 21.301906643000052],
              [-89.59805253799993, 21.301906643000052],
              [-89.4590551419999, 21.325100002000056],
              [-89.26915442599994, 21.343003648000035],
              [-89.18708248599995, 21.36554596600007],
              [-89.14736894399994, 21.370266018000052],
              [-89.12315833199995, 21.36347077000005],
              [-89.1126195949999, 21.36277903900009],
              [-89.10269120999993, 21.365383205000057],
              [-89.08153235599991, 21.37441640800006],
              [-89.07477779899995, 21.37641022300005],
              [-88.9890844389999, 21.39008209800005],
              [-88.92296301999994, 21.408596096000053],
              [-88.87877356699994, 21.41307200700004],
              [-88.85952714799993, 21.417914130000042],
              [-88.82396399599992, 21.43162669500009],
              [-88.70270748599995, 21.45856354400007],
              [-88.66755123599995, 21.480129299000055],
              [-88.60545813699991, 21.534084377000056],
              [-88.58592688699991, 21.541815497000073],
              [-88.52354895699995, 21.54840729400007],
              [-88.50413977799991, 21.55418528900009],
              [-88.46764075399994, 21.570135809000078],
              [-88.44782467399995, 21.575100002000056],
              [-88.36929277299993, 21.575100002000056],
              [-88.35240637899994, 21.57184479400007],
              [-88.31818600199995, 21.557766018000052],
              [-88.30040442599994, 21.55459219000005],
              [-88.28270423099991, 21.556708075000074],
              [-88.25035559799994, 21.566107489000046],
              [-88.19517981699994, 21.571437893000052],
              [-88.17723548099991, 21.576727606000077],
              [-88.16388912699995, 21.585638739000046],
              [-88.14928137899994, 21.591131903000075],
              [-88.0847875639999, 21.58930084800005],
              [-88.10456295499995, 21.596584377000056],
              [-88.12865149599992, 21.601507880000042],
              [-88.15221106699994, 21.60114166900007],
              [-88.18675696499992, 21.583156643000052],
              [-88.22695878799993, 21.574774481000077],
              [-88.23509680899991, 21.57379791900007],
              [-88.23058020699995, 21.58226146000004],
              [-88.21019446499992, 21.59324778900009],
              [-88.18797766799992, 21.600409247000073],
              [-88.16075598899994, 21.60496653900009],
              [-88.13890540299991, 21.61399974200009],
              [-88.12946529899995, 21.616034247000073],
              [-88.11497962099992, 21.614203192000048],
              [-88.0711156889999, 21.60297272300005],
              [-87.98542232999995, 21.60297272300005],
              [-87.96206620999993, 21.600083726000037],
              [-87.89976966099994, 21.575100002000056],
              [-87.85789954299992, 21.564398505000042],
              [-87.76984615799995, 21.55263906500005],
              [-87.7097875639999, 21.536851304000038],
              [-87.70628821499992, 21.53343333500004],
              [-87.71483313699991, 21.526678778000075],
              [-87.72500566299993, 21.523260809000078],
              [-87.7376195949999, 21.522406317000048],
              [-87.74982662699995, 21.524603583000044],
              [-87.75918535099993, 21.53034088700008],
              [-87.77432206899994, 21.536769924000055],
              [-87.8445531889999, 21.54840729400007],
              [-87.86563066299993, 21.55459219000005],
              [-87.84170488199993, 21.536322333000044],
              [-87.8113500639999, 21.52106354400007],
              [-87.77806555899991, 21.510646877000056],
              [-87.74551347599993, 21.506781317000048],
              [-87.67690995999993, 21.506781317000048],
              [-87.64484615799995, 21.50031159100007],
              [-87.62840735599991, 21.49949778900009],
              [-87.61180579299992, 21.506781317000048],
              [-87.65428626199991, 21.508612372000073],
              [-87.67454993399991, 21.51357656500005],
              [-87.69058183499993, 21.523586330000057],
              [-87.68565833199995, 21.52875397300005],
              [-87.61856035099993, 21.520453192000048],
              [-87.56273352799991, 21.50141022300005],
              [-87.53978430899991, 21.499335028000075],
              [-87.51065019399994, 21.50067780200004],
              [-87.50194251199991, 21.499335028000075],
              [-87.49844316299993, 21.495266018000052],
              [-87.49453691299993, 21.488104559000078],
              [-87.48753821499992, 21.481756903000075],
              [-87.47459876199991, 21.480129299000055],
              [-87.48151607999995, 21.47597890800006],
              [-87.48753821499992, 21.473578192000048],
              [-87.49242102799991, 21.474432684000078],
              [-87.49571692599994, 21.480129299000055],
              [-87.50194251199991, 21.480129299000055],
              [-87.49274654899995, 21.468491929000038],
              [-87.47411048099991, 21.46710846600007],
              [-87.42992102799991, 21.47264232000009],
              [-87.40835527299993, 21.47028229400007],
              [-87.35106360599991, 21.45213450700004],
              [-87.28929602799991, 21.45457591400009],
              [-87.27257239499994, 21.448431708000044],
              [-87.25694739499994, 21.440619208000044],
              [-87.23818925699993, 21.443019924000055],
              [-87.16612708199995, 21.47264232000009],
              [-87.1555883449999, 21.481756903000075],
              [-87.14244544199994, 21.50136953300006],
              [-87.13512122299994, 21.510199286000045],
              [-87.12999426999994, 21.51943594000005],
              [-87.13190670499995, 21.528469143000052],
              [-87.13634192599994, 21.536851304000038],
              [-87.13878333199995, 21.544623114000046],
              [-87.13687089799993, 21.552679755000042],
              [-87.1348363919999, 21.558335679000038],
              [-87.13833574099993, 21.563055731000077],
              [-87.15306555899991, 21.56826406500005],
              [-87.17577063699991, 21.56903717700004],
              [-87.19985917899993, 21.562323309000078],
              [-87.22183183499993, 21.550848700000074],
              [-87.23810787699995, 21.537502346000053],
              [-87.25658118399991, 21.52802155200004],
              [-87.28050696499992, 21.527899481000077],
              [-87.30479895699995, 21.53339264500005],
              [-87.32437089799993, 21.54092031500005],
              [-87.33120683499993, 21.534084377000056],
              [-87.33678137899994, 21.54824453300006],
              [-87.33747311099995, 21.55459219000005],
              [-87.35338294199994, 21.546820380000042],
              [-87.37950598899994, 21.527085679000038],
              [-87.39952551999994, 21.520453192000048],
              [-87.39785722599993, 21.516058661000045],
              [-87.39732825399994, 21.515326239000046],
              [-87.39606686099995, 21.515448309000078],
              [-87.39207923099991, 21.513617255000042],
              [-87.40233313699991, 21.509466864000046],
              [-87.41038977799991, 21.51239655200004],
              [-87.41445878799993, 21.52106354400007],
              [-87.41315670499995, 21.534084377000056],
              [-87.38243567599994, 21.558294989000046],
              [-87.37218176999994, 21.569159247000073],
              [-87.3653051419999, 21.573960679000038],
              [-87.35773678299995, 21.575140692000048],
              [-87.33397376199991, 21.574367580000057],
              [-87.30264238199993, 21.569240627000056],
              [-87.2930395169999, 21.56513092700004],
              [-87.27212480399993, 21.56077708500004],
              [-87.24388587099992, 21.56854889500005],
              [-87.13418535099993, 21.61945221600007],
              [-87.11148027299993, 21.623439846000053],
              [-87.04332434799994, 21.602118231000077],
              [-87.0261938139999, 21.59243398600006],
              [-86.99791419199994, 21.56590403900009],
              [-86.94469153599994, 21.493068752000056],
              [-86.94017493399991, 21.482855536000045],
              [-86.9336645169999, 21.47483958500004],
              [-86.92918860599991, 21.46621328300006],
              [-86.92479407499991, 21.446112372000073],
              [-86.91852779899995, 21.439601955000057],
              [-86.90941321499992, 21.43500397300005],
              [-86.89858964799993, 21.43162669500009],
              [-86.89476477799991, 21.443833726000037],
              [-86.88536536399994, 21.44521719000005],
              [-86.86449133999992, 21.43854401200008],
              [-86.83877519399994, 21.437933661000045],
              [-86.82795162699995, 21.433294989000046],
              [-86.8125707669999, 21.38279857000009],
              [-86.81045488199993, 21.370266018000052],
              [-86.81248938699991, 21.354803778000075],
              [-86.82144120999993, 21.32998281500005],
              [-86.82347571499992, 21.31834544500009],
              [-86.82286536399994, 21.26951732000009],
              [-86.81505286399994, 21.204779364000046],
              [-86.79092363199993, 21.158351955000057],
              [-86.74156653599994, 21.164129950000074],
              [-86.74425208199995, 21.154689846000053],
              [-86.74746660099993, 21.148993231000077],
              [-86.75108801999994, 21.14402903900009],
              [-86.77257239499994, 21.09902578300006],
              [-86.77717037699995, 21.09198639500005],
              [-86.78994706899994, 21.064886786000045],
              [-86.78880774599992, 21.058539130000042],
              [-86.78368079299992, 21.04905833500004],
              [-86.7825414699999, 21.04401276200008],
              [-86.78368079299992, 21.035956122000073],
              [-86.78673255099994, 21.035101630000042],
              [-86.79112708199995, 21.03620026200008],
              [-86.7962133449999, 21.03384023600006],
              [-86.80223548099991, 21.029852606000077],
              [-86.81753495999993, 21.024725653000075],
              [-86.82347571499992, 21.02016836100006],
              [-86.82774817599994, 21.012640692000048],
              [-86.82994544199994, 21.004461981000077],
              [-86.83092200399994, 20.98261139500005],
              [-86.83315995999993, 20.97101471600007],
              [-86.85081946499992, 20.917710679000038],
              [-86.87515214799993, 20.865301825000074],
              [-86.87531490799995, 20.85504791900007],
              [-86.94322669199994, 20.762274481000077],
              [-87.03636633999992, 20.663275458000044],
              [-87.05679277299993, 20.63043854400007],
              [-87.06745357999995, 20.619208075000074],
              [-87.12262936099995, 20.58665599200009],
              [-87.13809160099993, 20.57184479400007],
              [-87.18040930899991, 20.54718659100007],
              [-87.23497473899994, 20.492580471000053],
              [-87.35391191299993, 20.326971747000073],
              [-87.36534583199995, 20.29393138200004],
              [-87.37840735599991, 20.29100169500009],
              [-87.38467363199993, 20.28416575700004],
              [-87.38467363199993, 20.27537669500009],
              [-87.37901770699995, 20.26666901200008],
              [-87.41006425699993, 20.24628327000005],
              [-87.4304906889999, 20.22101471600007],
              [-87.44399980399993, 20.191148179000038],
              [-87.46589107999995, 20.111761786000045],
              [-87.47130286399994, 20.06903717700004],
              [-87.46776282499991, 19.984849351000037],
              [-87.46043860599991, 19.96238841400009],
              [-87.43781490799995, 19.921535549000055],
              [-87.43301347599993, 19.89984772300005],
              [-87.43419348899994, 19.889227606000077],
              [-87.44253495999993, 19.85309479400007],
              [-87.44774329299992, 19.848944403000075],
              [-87.45445716099994, 19.84711334800005],
              [-87.46092688699991, 19.841498114000046],
              [-87.47427324099993, 19.79706452000005],
              [-87.4798070949999, 19.784328518000052],
              [-87.48273678299995, 19.825506903000075],
              [-87.4817602199999, 19.83665599200009],
              [-87.47834225199995, 19.841498114000046],
              [-87.46703040299991, 19.84243398600006],
              [-87.46043860599991, 19.849554755000042],
              [-87.45238196499992, 19.851996161000045],
              [-87.4473363919999, 19.86196523600006],
              [-87.44522050699993, 19.874335028000075],
              [-87.44391842399995, 19.91347890800006],
              [-87.46165930899991, 19.92877838700008],
              [-87.46621660099993, 19.938299872000073],
              [-87.46776282499991, 19.954413153000075],
              [-87.47101803299995, 19.962144273000035],
              [-87.47801673099991, 19.96482982000009],
              [-87.48501542899993, 19.96230703300006],
              [-87.48827063699991, 19.954413153000075],
              [-87.48648027299993, 19.946478583000044],
              [-87.47789466099994, 19.93817780200004],
              [-87.47459876199991, 19.930853583000044],
              [-87.47093665299991, 19.898911851000037],
              [-87.47154700399994, 19.884711005000042],
              [-87.47459876199991, 19.87563711100006],
              [-87.46959387899994, 19.88043854400007],
              [-87.46495520699995, 19.88385651200008],
              [-87.45470130099994, 19.88930898600006],
              [-87.49693762899994, 19.82965729400007],
              [-87.50560462099992, 19.82099030200004],
              [-87.51048743399991, 19.81708405200004],
              [-87.51744544199994, 19.809149481000077],
              [-87.52525794199994, 19.802883205000057],
              [-87.53294837099992, 19.803900458000044],
              [-87.54206295499995, 19.81268952000005],
              [-87.54967200399994, 19.817613023000035],
              [-87.55687415299991, 19.814886786000045],
              [-87.56456458199995, 19.800482489000046],
              [-87.57994544199994, 19.79901764500005],
              [-87.6004125639999, 19.77138906500005],
              [-87.61831620999993, 19.736883856000077],
              [-87.62873287699995, 19.70856354400007],
              [-87.6465551419999, 19.67763906500005],
              [-87.65831458199995, 19.64484284100007],
              [-87.66734778599994, 19.63377513200004],
              [-87.68004309799994, 19.635972398000035],
              [-87.66909745999993, 19.642279364000046],
              [-87.65884355399993, 19.655462958000044],
              [-87.65420488199993, 19.670843817000048],
              [-87.66014563699991, 19.68378327000005],
              [-87.67048092399995, 19.68187083500004],
              [-87.72419186099995, 19.682033596000053],
              [-87.73468990799995, 19.68378327000005],
              [-87.74120032499991, 19.671698309000078],
              [-87.74425208199995, 19.65180084800005],
              [-87.74437415299991, 19.630601304000038],
              [-87.74209550699993, 19.614935614000046],
              [-87.73151607999995, 19.600531317000048],
              [-87.70274817599994, 19.583319403000075],
              [-87.70055091099994, 19.573919989000046],
              [-87.69310462099992, 19.570135809000078],
              [-87.68325761599993, 19.567572333000044],
              [-87.67198645699995, 19.56671784100007],
              [-87.66014563699991, 19.56777578300006],
              [-87.66637122299994, 19.552476304000038],
              [-87.6692602199999, 19.52334219000005],
              [-87.67381751199991, 19.505682684000078],
              [-87.65440833199995, 19.507473049000055],
              [-87.64159094999991, 19.518052476000037],
              [-87.63097083199995, 19.53278229400007],
              [-87.61856035099993, 19.546616929000038],
              [-87.60728919199994, 19.552679755000042],
              [-87.57852128799993, 19.561468817000048],
              [-87.56456458199995, 19.56777578300006],
              [-87.53669186099995, 19.560288804000038],
              [-87.51553300699993, 19.548000393000052],
              [-87.50938880099994, 19.546616929000038],
              [-87.50291907499991, 19.550034898000035],
              [-87.5008031889999, 19.556341864000046],
              [-87.49941972599993, 19.562974351000037],
              [-87.49571692599994, 19.56777578300006],
              [-87.48672441299993, 19.56781647300005],
              [-87.48013261599993, 19.56281159100007],
              [-87.47435462099992, 19.560288804000038],
              [-87.46776282499991, 19.56777578300006],
              [-87.46401933499993, 19.56517161700009],
              [-87.4617406889999, 19.562974351000037],
              [-87.45909583199995, 19.561428127000056],
              [-87.45470130099994, 19.560288804000038],
              [-87.46776282499991, 19.55410390800006],
              [-87.46776282499991, 19.546616929000038],
              [-87.44139563699991, 19.553656317000048],
              [-87.42674719999991, 19.573553778000075],
              [-87.42577063699991, 19.59210846600007],
              [-87.44041907499991, 19.595038153000075],
              [-87.43443762899994, 19.58417389500005],
              [-87.43407141799992, 19.57713450700004],
              [-87.44391842399995, 19.573919989000046],
              [-87.47459876199991, 19.573919989000046],
              [-87.50226803299995, 19.577948309000078],
              [-87.51524817599994, 19.581732489000046],
              [-87.52920488199993, 19.587591864000046],
              [-87.50877844999991, 19.588446356000077],
              [-87.4473363919999, 19.58079661700009],
              [-87.4473363919999, 19.587591864000046],
              [-87.44908606699994, 19.593898830000057],
              [-87.44139563699991, 19.618882554000038],
              [-87.44041907499991, 19.635972398000035],
              [-87.4212133449999, 19.59983958500004],
              [-87.41274980399993, 19.57762278900009],
              [-87.41633053299995, 19.56777578300006],
              [-87.42320716099994, 19.55801015800006],
              [-87.43301347599993, 19.492010809000078],
              [-87.44391842399995, 19.47256094000005],
              [-87.45840410099993, 19.455023505000042],
              [-87.47496497299994, 19.442328192000048],
              [-87.49193274599992, 19.437445380000042],
              [-87.49852454299992, 19.43378327000005],
              [-87.52611243399991, 19.406398830000057],
              [-87.53477942599994, 19.402044989000046],
              [-87.57079016799992, 19.396429755000042],
              [-87.55256100199995, 19.401597398000035],
              [-87.54539954299992, 19.411444403000075],
              [-87.54246985599991, 19.423895575000074],
              [-87.53669186099995, 19.437445380000042],
              [-87.57168535099993, 19.42796458500004],
              [-87.61766516799992, 19.405462958000044],
              [-87.65566972599993, 19.37323639500005],
              [-87.66706295499995, 19.334377346000053],
              [-87.66014563699991, 19.334377346000053],
              [-87.65269934799994, 19.35488515800006],
              [-87.6465551419999, 19.35488515800006],
              [-87.65493730399993, 19.339056708000044],
              [-87.66942298099991, 19.323187567000048],
              [-87.6758520169999, 19.31118398600006],
              [-87.66014563699991, 19.307033596000053],
              [-87.68114173099991, 19.265285549000055],
              [-87.68785559799994, 19.242132880000042],
              [-87.67690995999993, 19.23191966400009],
              [-87.65868079299992, 19.22752513200004],
              [-87.64907792899993, 19.220648505000042],
              [-87.63898678299995, 19.22093333500004],
              [-87.61856035099993, 19.23818594000005],
              [-87.59251868399991, 19.26825592700004],
              [-87.58193925699993, 19.28611888200004],
              [-87.57762610599991, 19.30337148600006],
              [-87.56712805899991, 19.317206122000073],
              [-87.54279537699995, 19.32379791900007],
              [-87.49571692599994, 19.32758209800005],
              [-87.51618404899995, 19.28656647300005],
              [-87.50422115799995, 19.29629140800006],
              [-87.49396725199995, 19.309515692000048],
              [-87.48094641799992, 19.31976959800005],
              [-87.46092688699991, 19.320705471000053],
              [-87.46092688699991, 19.31391022300005],
              [-87.48086503799993, 19.304348049000055],
              [-87.49697831899994, 19.28904857000009],
              [-87.52301998599995, 19.252427476000037],
              [-87.53343665299991, 19.22809479400007],
              [-87.5449926419999, 19.17454661700009],
              [-87.55719967399995, 19.15623607000009],
              [-87.5488988919999, 19.13304271000004],
              [-87.56240800699993, 19.102118231000077],
              [-87.58385169199994, 19.053208726000037],
              [-87.60619055899991, 19.020412502000056],
              [-87.62604732999995, 18.88934967700004],
              [-87.66201738199993, 18.766831773000035],
              [-87.68004309799994, 18.73851146000004],
              [-87.70352128799993, 18.711737372000073],
              [-87.72337805899991, 18.68121979400007],
              [-87.73704993399991, 18.644964911000045],
              [-87.74209550699993, 18.601304429000038],
              [-87.73696855399993, 18.557033596000053],
              [-87.73924719999991, 18.535956122000073],
              [-87.75234941299993, 18.515366929000038],
              [-87.75804602799991, 18.49945709800005],
              [-87.76256262899994, 18.429388739000046],
              [-87.77122962099992, 18.406398830000057],
              [-87.81944739499994, 18.33860911700009],
              [-87.82461503799993, 18.323919989000046],
              [-87.82774817599994, 18.308986721000053],
              [-87.84142005099994, 18.27765534100007],
              [-87.8445531889999, 18.262152411000045],
              [-87.8445531889999, 18.19668203300006],
              [-87.85195878799993, 18.19668203300006],
              [-87.85383053299995, 18.22337474200009],
              [-87.85879472599993, 18.245062567000048],
              [-87.87498938699991, 18.22565338700008],
              [-87.88719641799992, 18.23004791900007],
              [-87.89098059799994, 18.24355703300006],
              [-87.88239498599995, 18.251288153000075],
              [-87.87425696499992, 18.26268138200004],
              [-87.86839758999992, 18.288031317000048],
              [-87.86534583199995, 18.314154364000046],
              [-87.86563066299993, 18.32758209800005],
              [-87.86900794199994, 18.31736888200004],
              [-87.87417558499993, 18.307440497000073],
              [-87.88003495999993, 18.298651434000078],
              [-87.88548743399991, 18.292222398000092],
              [-87.8914281889999, 18.30410390800006],
              [-87.88825436099995, 18.313625393000052],
              [-87.8821508449999, 18.32453034100007],
              [-87.87930253799993, 18.340643622000073],
              [-87.88170325399994, 18.34198639500005],
              [-87.89635169199994, 18.35805898600006],
              [-87.89683997299994, 18.36273834800005],
              [-87.8958227199999, 18.37132396000004],
              [-87.89590410099993, 18.381008205000057],
              [-87.89976966099994, 18.389064846000053],
              [-87.92760169199994, 18.394924221000053],
              [-87.93016516799992, 18.39590078300006],
              [-87.93529212099992, 18.400051174000055],
              [-87.93382727799991, 18.40851471600007],
              [-87.92959550699993, 18.41592031500005],
              [-87.92650305899991, 18.41632721600007],
              [-87.9304906889999, 18.432562567000048],
              [-87.93517005099994, 18.443101304000038],
              [-87.94505774599992, 18.44879791900007],
              [-87.96467037699995, 18.450506903000075],
              [-87.99132239499994, 18.45693594000005],
              [-88.04356848899994, 18.48505280200004],
              [-88.06737219999991, 18.491441148000092],
              [-88.07778886599993, 18.498602606000077],
              [-88.08023027299993, 18.514227606000077],
              [-88.07872473899994, 18.52952708500004],
              [-88.07725989499994, 18.53583405200004],
              [-88.04381262899994, 18.573431708000044],
              [-88.05052649599992, 18.595770575000074],
              [-88.03990637899994, 18.617010809000078],
              [-88.02440344999991, 18.63629791900007],
              [-88.01646887899994, 18.652899481000077],
              [-88.01427161399994, 18.661851304000038],
              [-88.00438391799992, 18.677883205000057],
              [-88.00218665299991, 18.69013092700004],
              [-88.00438391799992, 18.691229559000078],
              [-88.00934811099995, 18.69599030200004],
              [-88.01427161399994, 18.702053127000056],
              [-88.01646887899994, 18.707180080000057],
              [-88.01524817599994, 18.71356842700004],
              [-88.01268469999991, 18.719549872000073],
              [-88.01012122299994, 18.723578192000048],
              [-88.00902258999992, 18.724269924000055],
              [-88.00377356699994, 18.765448309000078],
              [-88.00454667899993, 18.786851304000038],
              [-88.01276607999995, 18.803656317000048],
              [-88.02342688699991, 18.818101304000038],
              [-88.03026282499991, 18.835150458000044],
              [-88.03628495999993, 18.87498607000009],
              [-88.0593969389999, 18.85687897300005],
              [-88.08413652299993, 18.831284898000035],
              [-88.10391191299993, 18.80272044500009],
              [-88.11204993399991, 18.775783596000053],
              [-88.11412512899994, 18.761542059000078],
              [-88.11953691299993, 18.744533596000053],
              [-88.12730872299994, 18.730210679000038],
              [-88.13621985599991, 18.724269924000055],
              [-88.14293372299994, 18.731634833000044],
              [-88.14028886599993, 18.749212958000044],
              [-88.13467363199993, 18.76951732000009],
              [-88.13776607999995, 18.762193101000037],
              [-88.14915930899991, 18.74998607000009],
              [-88.16685950399994, 18.745428778000075],
              [-88.19082597599993, 18.744696356000077],
              [-88.19880123599995, 18.739935614000046],
              [-88.24181067599994, 18.70384349200009],
              [-88.24779212099992, 18.69627513200004],
              [-88.25251217399995, 18.687323309000078],
              [-88.25548255099994, 18.67645905200004],
              [-88.23570716099994, 18.68431224200009],
              [-88.21593176999994, 18.69953034100007],
              [-88.19880123599995, 18.718695380000042],
              [-88.18712317599994, 18.73851146000004],
              [-88.18089758999992, 18.721177476000037],
              [-88.1856176419999, 18.70856354400007],
              [-88.19294186099995, 18.695379950000074],
              [-88.1946508449999, 18.67645905200004],
              [-88.18932044199994, 18.684393622000073],
              [-88.18089758999992, 18.693833726000037],
              [-88.17076575399994, 18.70140208500004],
              [-88.16047115799995, 18.70376211100006],
              [-88.15074622299994, 18.698553778000075],
              [-88.15697180899991, 18.691107489000046],
              [-88.16820227799991, 18.684881903000075],
              [-88.17349199099993, 18.683294989000046],
              [-88.19762122299994, 18.635199286000045],
              [-88.22105872299994, 18.60578034100007],
              [-88.24860592399995, 18.55662669500009],
              [-88.25300045499995, 18.540757554000038],
              [-88.27476966099994, 18.509833075000074],
              [-88.28331458199995, 18.491441148000092],
              [-88.29552161399994, 18.489406643000052],
              [-88.29971269399994, 18.487453518000052],
              [-88.30382239499994, 18.484035549000055],
              [-88.30382239499994, 18.481350002000056],
              [-88.30951452699992, 18.482283834000057],
              [-88.37144873099996, 18.481792908],
              [-88.37907100499993, 18.479700013000055],
              [-88.3849104409999, 18.47662526500001],
              [-88.3907757159999, 18.47569508900004],
              [-88.39837215199987, 18.480113424000066],
              [-88.40798396799997, 18.48895009400006],
              [-88.41322912699991, 18.49075876900004],
              [-88.41997290099994, 18.48900177000006],
              [-88.43085078999988, 18.48378245100004],
              [-88.45082373099993, 18.476883647000065],
              [-88.4596345619999, 18.47572092700007],
              [-88.46994401099991, 18.478511454000014],
              [-88.47919409199991, 18.483420716000055],
              [-88.48924515799987, 18.484505920000046],
              [-88.52019934199987, 18.461561584000023],
              [-88.52782161499994, 18.4541460170001],
              [-88.53304093499986, 18.44331980400007],
              [-88.53838944599991, 18.41308909100003],
              [-88.54740698299986, 18.389059551000017],
              [-88.55133439199992, 18.363686422000015],
              [-88.55479671199987, 18.352214254],
              [-88.56717321799994, 18.333507385000118],
              [-88.59807572499992, 18.299478455000084],
              [-88.60771337899985, 18.283381246000104],
              [-88.61148575899998, 18.266379700000087],
              [-88.61316524299991, 18.250566712000094],
              [-88.61405893099987, 18.247028189000034],
              [-88.61698929899987, 18.23542551700008],
              [-88.62704036499989, 18.220310160000068],
              [-88.63895178299992, 18.211602681],
              [-88.66814896699987, 18.198244324000072],
              [-88.6966226809999, 18.17806467700008],
              [-88.6929536539999, 18.175170797000092],
              [-88.68951717199988, 18.16124399900012],
              [-88.69285030099988, 18.150004374000062],
              [-88.71770666499992, 18.110032654000108],
              [-88.72044551599987, 18.100084941000105],
              [-88.72349442599992, 18.077502340000066],
              [-88.72664668799987, 18.066727804000024],
              [-88.7363876959999, 18.051922506000025],
              [-88.74835078999988, 18.04329254100007],
              [-88.76201920599996, 18.03564443000009],
              [-88.77687618099992, 18.02375885000005],
              [-88.78163041199991, 18.014715475000102],
              [-88.79594478399989, 17.975596415000084],
              [-88.80534989499995, 17.9650027470001],
              [-88.85640620899991, 17.92831247900004],
              [-88.86085038299993, 17.92112945600006],
              [-88.86537207099985, 17.899011943000076],
              [-88.87136653699989, 17.890950419000077],
              [-88.88033239799992, 17.888469951],
              [-88.9204591479999, 17.910949199000115],
              [-88.9333007409999, 17.920354309000075],
              [-88.94702083399994, 17.94846628800009],
              [-88.95650345899992, 17.950533346000057],
              [-88.96784643599989, 17.948259583000052],
              [-88.97975785399993, 17.949448141000076],
              [-88.99657853199992, 17.961850485000028],
              [-89.01153885999986, 17.977818502000062],
              [-89.02802364099995, 17.992081197000047],
              [-89.04944352299987, 17.999212545000077],
              [-89.13256506399995, 17.97027374300002],
              [-89.15393326799995, 17.94107655900008],
              [-89.16137467499988, 17.901440735000037],
              [-89.16049617499993, 17.814314270000054],
              [-89.38030188099987, 17.814520976000026],
              [-89.60015926199989, 17.814727681000065],
              [-89.82001664299995, 17.814986064000024],
              [-90.03977067099993, 17.815141093000065],
              [-90.25965389099989, 17.815347799000037],
              [-90.47945959499992, 17.815606181000092],
              [-90.69923946199992, 17.815812887000064],
              [-90.91912268099986, 17.81601959300012],
              [-90.96222082599988, 17.81601959300012],
              [-90.98283972199988, 17.810541890000124],
              [-90.99090124599988, 17.801963603],
              [-90.99144384799993, 17.52694163050002],
              [-90.99198644999987, 17.251919658000034],
              [-91.43077103699989, 17.254968567000063],
              [-91.43826411999993, 17.253676657000128],
              [-91.44250158699987, 17.237967020000056],
              [-91.41924719299996, 17.227735087000084],
              [-91.38834468599995, 17.22158559200001],
              [-91.37294510899997, 17.21357574500003],
              [-91.36488358599988, 17.189752910000053],
              [-91.34452307199987, 17.18634226500002],
              [-91.31775467999998, 17.19047638000005],
              [-91.29041784699987, 17.189081116000082],
              [-91.2795141199999, 17.18008941600003],
              [-91.27083247999994, 17.164276428000036],
              [-91.2651480719999, 17.146241354000026],
              [-91.26313269099984, 17.130738424000114],
              [-91.25920528199987, 17.12433054700007],
              [-91.23879309099993, 17.119214579000086],
              [-91.22959468599993, 17.113995260000067],
              [-91.22535721899987, 17.107018942000067],
              [-91.22024125199988, 17.089293925000064],
              [-91.21595210799993, 17.079217021000105],
              [-91.20675370399991, 17.065367737000045],
              [-91.17120031799996, 17.02800567700011],
              [-91.16122676599986, 17.02397491500001],
              [-91.13714554899991, 17.0265070600001],
              [-91.12655187999994, 17.02459503200008],
              [-91.12122920799987, 17.018393860000103],
              [-91.11611324099991, 16.999273580000093],
              [-91.11223750899984, 16.990488587000115],
              [-91.07694250499995, 16.949509176000063],
              [-91.07130977499992, 16.938915507],
              [-91.0668656009999, 16.918193258000073],
              [-91.05492834599997, 16.908013],
              [-91.01668778499987, 16.89483551100004],
              [-91.0109000249999, 16.890287984000096],
              [-90.9983426519999, 16.87716217000012],
              [-90.99307165599996, 16.87437164300006],
              [-90.98325313399991, 16.878609110000113],
              [-90.98428666299989, 16.887755840000082],
              [-90.98795568899988, 16.896902568000073],
              [-90.98625036699991, 16.901088359000127],
              [-90.96883540899998, 16.901036682000026],
              [-90.95519283099986, 16.898762919000077],
              [-90.95276403799991, 16.89090810200007],
              [-90.96888708599988, 16.87437164300006],
              [-90.94816483599996, 16.864708150000027],
              [-90.91907100399996, 16.836337789000126],
              [-90.90062251899994, 16.826002503000026],
              [-90.83173783399994, 16.805435283000023],
              [-90.81995560699991, 16.805331930000094],
              [-90.81060217299998, 16.812928365000076],
              [-90.79695959599988, 16.805435283000023],
              [-90.79695959599988, 16.79866567000009],
              [-90.80037023999989, 16.786831767000066],
              [-90.78559077999998, 16.77499786400007],
              [-90.74977901199986, 16.757686259000067],
              [-90.73530961099993, 16.74657582600004],
              [-90.66771683799996, 16.6525763960001],
              [-90.65402258299994, 16.61660959900003],
              [-90.66720007399991, 16.593200175000064],
              [-90.66720007399991, 16.586999003000088],
              [-90.65882849199994, 16.58844594300008],
              [-90.65360917199993, 16.590099590000122],
              [-90.65025020399992, 16.59340688100012],
              [-90.64735632399993, 16.60007314000005],
              [-90.63376542199984, 16.59216664600008],
              [-90.63702103799992, 16.577903952000028],
              [-90.64353226799989, 16.56100575800012],
              [-90.63996659299991, 16.544831034000126],
              [-90.64818314699994, 16.52958648700009],
              [-90.6395015059999, 16.52586578400006],
              [-90.62415360499992, 16.52493560800012],
              [-90.61262976099991, 16.518114319000077],
              [-90.61206131999984, 16.507624003000032],
              [-90.61898596199993, 16.500079244000077],
              [-90.62787430799995, 16.492896220000105],
              [-90.63309362799995, 16.483336080000115],
              [-90.6207429619999, 16.48674672500003],
              [-90.60467159099994, 16.486178284000076],
              [-90.59061560099991, 16.483387757000045],
              [-90.58472448799992, 16.48023549500006],
              [-90.57935013899996, 16.482767639000073],
              [-90.5534085699999, 16.490260722000087],
              [-90.54371923899987, 16.49020904500007],
              [-90.5390683599999, 16.468866679000072],
              [-90.53289302599993, 16.459926656000064],
              [-90.50891516199991, 16.47108876500009],
              [-90.49775305299988, 16.46803985600006],
              [-90.48821875099989, 16.461580302000087],
              [-90.48230179899988, 16.45605092400011],
              [-90.47708247899996, 16.44499216700008],
              [-90.47842606699993, 16.436413879000057],
              [-90.47584224499994, 16.43072947200004],
              [-90.44437129799988, 16.426802063000068],
              [-90.43411352599989, 16.42240956600007],
              [-90.42669795799989, 16.417707011000076],
              [-90.42080684399988, 16.415123190000074],
              [-90.4094638679999, 16.41667348300011],
              [-90.40060135999988, 16.420549215000065],
              [-90.39491695199985, 16.419205627000096],
              [-90.3929015709999, 16.404839580000086],
              [-90.39269486499984, 16.391713766000024],
              [-90.39137711699988, 16.385977681000057],
              [-90.37985327199993, 16.367270813000076],
              [-90.39512365699989, 16.371404927000086],
              [-90.4087403979999, 16.372335103000054],
              [-90.41822302299997, 16.36716746100005],
              [-90.42080684399988, 16.353008118],
              [-90.41401139299992, 16.353008118],
              [-90.41401139299992, 16.360449524000032],
              [-90.40719010499987, 16.360449524000032],
              [-90.39879268399989, 16.347582092000025],
              [-90.4046837979999, 16.33151072200006],
              [-90.4194632569999, 16.317816467000043],
              [-90.43788590499992, 16.312080383000094],
              [-90.4448880619999, 16.308359680000066],
              [-90.43473364299987, 16.301228333000026],
              [-90.42018672799992, 16.296009013000017],
              [-90.41401139299992, 16.298386129000065],
              [-90.41406306999994, 16.287844137],
              [-90.42023840399992, 16.285363668000016],
              [-90.42855830999989, 16.28763743100005],
              [-90.4344752609999, 16.291564840000106],
              [-90.43550878899987, 16.288774312000058],
              [-90.43550878899987, 16.286242168000072],
              [-90.43674902399991, 16.284846904000077],
              [-90.44129654999995, 16.285363668000016],
              [-90.4375241699999, 16.280040996000068],
              [-90.43142635099986, 16.26893056300007],
              [-90.42767980999994, 16.263607890000017],
              [-90.44062475599986, 16.265313212000066],
              [-90.4437253429999, 16.266863505000103],
              [-90.4481436769999, 16.27110097300006],
              [-90.45943497799996, 16.259060364000064],
              [-90.45783300899984, 16.24913848900009],
              [-90.44798864799986, 16.241490377],
              [-90.4344752609999, 16.236322734000098],
              [-90.44623164899988, 16.230845032],
              [-90.45850480199991, 16.22174998000004],
              [-90.46558447299995, 16.20810740200004],
              [-90.46181209399992, 16.18914215100007],
              [-90.43271826199992, 16.173225810000062],
              [-90.42612951699991, 16.163148906000018],
              [-90.4481436769999, 16.15441558900004],
              [-90.4481436769999, 16.148214417000062],
              [-90.43530208399991, 16.136277161000024],
              [-90.45948665399987, 16.11679514600003],
              [-90.45558508399992, 16.0997419240001],
              [-90.4481436769999, 16.0997419240001],
              [-90.44452632699992, 16.103255920000052],
              [-90.44274348999994, 16.104186096000106],
              [-90.44021134499985, 16.104857890000076],
              [-90.4344752609999, 16.107183330000012],
              [-90.43742081699989, 16.098863424000044],
              [-90.44416459199991, 16.084652405],
              [-90.44784120199992, 16.07968659300009],
              [-90.44819509699988, 16.079259908000054],
              [-90.4661529139999, 16.072921855000104],
              [-90.48573828199991, 16.070699768000097],
              [-90.5754744059999, 16.070596415000082],
              [-90.71329545199984, 16.070338034000102],
              [-90.85111649699991, 16.070131327000055],
              [-90.98898921799986, 16.069872946000075],
              [-90.99479783199988, 16.069868593000066],
              [-91.12691361599994, 16.06976959300006],
              [-91.26478633699989, 16.069511210000073],
              [-91.40260738199993, 16.069304505000034],
              [-91.54048010299991, 16.06914947500009],
              [-91.67840450099987, 16.068891093],
              [-91.7237764089999, 16.068787740000076],
              [-91.73984777899997, 16.060984599000065],
              [-91.75188838699992, 16.04630849200008],
              [-91.77447098799988, 16.008429667000073],
              [-91.7929711509999, 15.977578837000081],
              [-91.84167618899994, 15.896085103000061],
              [-91.91056087199985, 15.780950013000066],
              [-91.98959997599994, 15.648968404000115],
              [-92.06853572599996, 15.516935120000042],
              [-92.10593123099994, 15.454469062000058],
              [-92.13744624899991, 15.401825866000067],
              [-92.18617712399993, 15.320383810000038],
              [-92.20465144899995, 15.289507141000044],
              [-92.21129187099987, 15.272066345000013],
              [-92.21093013499987, 15.253359477000117],
              [-92.20335953799992, 15.237158915000109],
              [-92.07380672199992, 15.073706360000102],
              [-92.0935987959999, 15.02941965800008],
              [-92.10383072999986, 15.017869975000039],
              [-92.11698238099984, 15.012392274000135],
              [-92.12987565099994, 15.010945333000052],
              [-92.14235550999993, 15.007483012000108],
              [-92.15421525099995, 14.995933329000081],
              [-92.15757421899988, 14.963041280000127],
              [-92.1546803389999, 14.900797018000034],
              [-92.16602331599995, 14.87082468700008],
              [-92.1867972419999, 14.847260233000085],
              [-92.19165482699992, 14.835297140000122],
              [-92.1908280029999, 14.814238993000103],
              [-92.1886575929999, 14.80589324900005],
              [-92.17938167299988, 14.781243591000049],
              [-92.17881323299994, 14.77338877400011],
              [-92.1801051439999, 14.758790182000041],
              [-92.17938167299988, 14.751581320000085],
              [-92.16173417199991, 14.702333679000105],
              [-92.16080399699985, 14.683497620000082],
              [-92.16473140499991, 14.668149720000116],
              [-92.18607377099991, 14.62957326300004],
              [-92.2080620939999, 14.57050710100009],
              [-92.22609716799988, 14.54934560200013],
              [-92.24625650399989, 14.546279476000095],
              [-92.2507624989999, 14.550726630000042],
              [-92.3059382799999, 14.615057684000078],
              [-92.38206946499992, 14.68463776200008],
              [-92.5078425769999, 14.807074286000045],
              [-92.69985917899993, 14.99909088700008],
              [-92.82485917899993, 15.135646877000056],
              [-92.8406062489999, 15.161159572000088],
              [-92.84044348899994, 15.18195221600007],
              [-92.8240046869999, 15.172796942000048],
              [-92.78087317599994, 15.15884023600006],
              [-92.77212480399993, 15.150336005000042],
              [-92.77017167899993, 15.131740627000056],
              [-92.76402747299994, 15.112941799000055],
              [-92.75316321499992, 15.098415432000081],
              [-92.73741614499994, 15.092596747000073],
              [-92.74815833199995, 15.112982489000046],
              [-92.75633704299992, 15.154120184000078],
              [-92.76842200399994, 15.171454169000071],
              [-92.7822566399999, 15.179877020000049],
              [-92.80296790299991, 15.188299872000073],
              [-92.82433020699995, 15.192694403000075],
              [-92.84044348899994, 15.188788153000075],
              [-92.84316972599993, 15.205877997000073],
              [-92.85403398299991, 15.20852285400008],
              [-92.85973059799994, 15.201320705000057],
              [-92.84666907499991, 15.188788153000075],
              [-92.86351477799991, 15.191107489000046],
              [-92.92300370999993, 15.237209377000056],
              [-92.96377519399994, 15.25381094000005],
              [-92.98314368399991, 15.265570380000042],
              [-92.99819902299993, 15.293972072000088],
              [-93.07811438699991, 15.348659572000088],
              [-93.17003333199995, 15.448879299000055],
              [-93.18809973899994, 15.477565822000088],
              [-93.19961503799993, 15.490993557000081],
              [-93.22862708199995, 15.50185781500005],
              [-93.47081458199995, 15.70071035400008],
              [-93.48814856699994, 15.708929755000042],
              [-93.6560359369999, 15.839260158000059],
              [-93.75918535099993, 15.90615469000005],
              [-93.9433894519999, 16.010565497000073],
              [-93.9311824209999, 16.016058661000045],
              [-93.90709387899994, 16.01443105700008],
              [-93.89561926999994, 16.017401434000078],
              [-93.88906816299993, 16.006415106000077],
              [-93.87804114499994, 16.00539785400008],
              [-93.86538652299993, 16.012152411000045],
              [-93.85403398299991, 16.02484772300005],
              [-93.87393144399994, 16.048529364000046],
              [-93.88524329299992, 16.070827541000085],
              [-93.89810136599993, 16.08893463700008],
              [-93.92296301999994, 16.09992096600007],
              [-94.04263261599993, 16.12531159100007],
              [-94.0737605459999, 16.14093659100007],
              [-94.08360755099994, 16.148871161000045],
              [-94.10265051999994, 16.164129950000074],
              [-94.11636308499993, 16.17914459800005],
              [-94.12218176999994, 16.19245026200008],
              [-94.12783769399994, 16.220851955000057],
              [-94.14244544199994, 16.22675202000005],
              [-94.16226152299993, 16.219671942000048],
              [-94.1836238269999, 16.20917389500005],
              [-94.22423255099994, 16.203558661000045],
              [-94.26671301999994, 16.215277411000045],
              [-94.30711829299992, 16.237616278000075],
              [-94.34129798099991, 16.263820705000057],
              [-94.3635554679999, 16.28701406500005],
              [-94.37767493399991, 16.295355536000045],
              [-94.39928137899994, 16.298610744000086],
              [-94.4172664049999, 16.29250722900008],
              [-94.41905676999994, 16.277736721000053],
              [-94.41527258999992, 16.259792385000083],
              [-94.41637122299994, 16.243963934000078],
              [-94.42320716099994, 16.243963934000078],
              [-94.43228105399993, 16.24880605700008],
              [-94.43651282499991, 16.24555084800005],
              [-94.43492591099994, 16.23969147300005],
              [-94.42662512899994, 16.23651764500005],
              [-94.41421464799993, 16.234035549000055],
              [-94.41454016799992, 16.228583075000074],
              [-94.42332923099991, 16.223822333000044],
              [-94.43687903599994, 16.22284577000005],
              [-94.3454890619999, 16.16315338700008],
              [-94.29263261599993, 16.141140041000085],
              [-94.26553300699993, 16.148382880000042],
              [-94.34129798099991, 16.17568594000005],
              [-94.34129798099991, 16.18191152600008],
              [-94.31529700399994, 16.180487372000073],
              [-94.27476966099994, 16.165716864000046],
              [-94.25560462099992, 16.16201406500005],
              [-94.2300105459999, 16.163275458000044],
              [-94.21947180899991, 16.161322333000044],
              [-94.20409094999991, 16.15456777600008],
              [-94.1699519519999, 16.134711005000042],
              [-94.1699519519999, 16.12726471600007],
              [-94.1836238269999, 16.12726471600007],
              [-94.1836238269999, 16.120428778000075],
              [-94.1128230459999, 16.10565827000005],
              [-94.08218339799993, 16.094753322000088],
              [-94.0566707019999, 16.07575104400007],
              [-94.03038489499994, 16.03974030200004],
              [-94.01915442599994, 16.031073309000078],
              [-93.98534094999991, 16.017971096000053],
              [-93.97061113199993, 16.009792385000083],
              [-93.9638972649999, 15.99750397300005],
              [-94.3437800769999, 16.147731838000084],
              [-94.35830644399994, 16.158351955000057],
              [-94.39220130099994, 16.177679755000042],
              [-94.43956458199995, 16.186794338000084],
              [-94.53307044199994, 16.18935781500005],
              [-94.52623450399994, 16.18935781500005],
              [-94.5796199209999, 16.189846096000053],
              [-94.6057429679999, 16.19354889500005],
              [-94.62242591099994, 16.202337958000044],
              [-94.6394343739999, 16.195705471000053],
              [-94.65990149599992, 16.19399648600006],
              [-94.7009578119999, 16.19558340100008],
              [-94.72240149599992, 16.199652411000045],
              [-94.72899329299992, 16.209377346000053],
              [-94.72427324099993, 16.220851955000057],
              [-94.71182206899994, 16.230292059000078],
              [-94.62535559799994, 16.25649648600006],
              [-94.58714758999992, 16.282416083000044],
              [-94.5808406239999, 16.32648346600007],
              [-94.59142005099994, 16.337225653000075],
              [-94.63023841099994, 16.348211981000077],
              [-94.64574133999992, 16.35696035400008],
              [-94.65440833199995, 16.36359284100007],
              [-94.66246497299994, 16.365383205000057],
              [-94.67003333199995, 16.363836981000077],
              [-94.6770320299999, 16.360663153000075],
              [-94.68028723899994, 16.344916083000044],
              [-94.68325761599993, 16.34015534100007],
              [-94.68858801999994, 16.337591864000046],
              [-94.70034745999993, 16.334540106000077],
              [-94.70433508999992, 16.33270905200004],
              [-94.71572831899994, 16.322821356000077],
              [-94.72215735599991, 16.315578518000052],
              [-94.72109941299993, 16.312201239000046],
              [-94.7490535149999, 16.298610744000086],
              [-94.76329505099994, 16.293524481000077],
              [-94.77989661399994, 16.268133856000077],
              [-94.79312089799993, 16.257635809000078],
              [-94.80431067599994, 16.275213934000078],
              [-94.80850175699993, 16.286444403000075],
              [-94.8074031239999, 16.298610744000086],
              [-94.79662024599992, 16.30817291900007],
              [-94.78111731699994, 16.31659577000005],
              [-94.77269446499992, 16.327175197000088],
              [-94.78319251199991, 16.34320709800005],
              [-94.7976374989999, 16.358343817000048],
              [-94.80190995999993, 16.36941152600008],
              [-94.80284583199995, 16.38031647300005],
              [-94.8074031239999, 16.39480215100008],
              [-94.81436113199993, 16.40310293200008],
              [-94.82705644399994, 16.414455471000053],
              [-94.8410945299999, 16.42458730700008],
              [-94.85208085799991, 16.428900458000044],
              [-94.87865149599992, 16.424627997000073],
              [-94.90172278599994, 16.41286855700008],
              [-94.92137610599991, 16.395331122000073],
              [-94.96507727799991, 16.333156643000052],
              [-94.97496497299994, 16.32648346600007],
              [-95.03331458199995, 16.32648346600007],
              [-95.02745520699995, 16.308539130000042],
              [-95.03555253799993, 16.302557684000078],
              [-95.04759680899991, 16.300726630000042],
              [-95.05382239499994, 16.29519277600008],
              [-95.06517493399991, 16.278265692000048],
              [-95.06383216099994, 16.26825592700004],
              [-95.04380145399995, 16.26104238000005],
              [-94.99935431299991, 16.251044370000045],
              [-94.96462082399995, 16.247719630000063],
              [-94.93056917199993, 16.24972963600004],
              [-94.90206175599991, 16.251743943000065],
              [-94.88954087799993, 16.253085292000037],
              [-94.86888587099992, 16.257635809000078],
              [-94.85924231699994, 16.264471747000073],
              [-94.8418269519999, 16.283718166000085],
              [-94.83409583199995, 16.285549221000053],
              [-94.82803300699993, 16.270331122000073],
              [-94.85875403599994, 16.256293036000045],
              [-94.9011531239999, 16.246527411000045],
              [-94.93032792899993, 16.243963934000078],
              [-94.89635169199994, 16.234401760000083],
              [-94.80553137899994, 16.237127997000073],
              [-94.77635657499991, 16.226589260000083],
              [-94.7615046869999, 16.203924872000073],
              [-94.76695716099994, 16.19867584800005],
              [-94.8191218739999, 16.21364980700008],
              [-94.8958785399999, 16.211687975000075],
              [-94.94869982099993, 16.201670728000067],
              [-94.99278723899994, 16.196437893000052],
              [-95.0181409089999, 16.19032119700006],
              [-95.0653357299999, 16.18364396800007],
              [-95.10280762799994, 16.184303123000063],
              [-95.12293348499992, 16.188299959000062],
              [-95.13611806599994, 16.188293215000044],
              [-95.14930138599993, 16.18695203100009],
              [-95.15554251499992, 16.181614325000055],
              [-95.1541504949999, 16.175614735000067],
              [-95.14928870999995, 16.16828399400009],
              [-95.16104081899994, 16.163234768000052],
              [-95.1881421299999, 16.167596119000052],
              [-95.19854779499991, 16.15826667200008],
              [-95.2158968519999, 16.15825772000005],
              [-95.23324719399994, 16.158247691000042],
              [-95.24711408799993, 16.147572352000054],
              [-95.2484877419999, 16.13424154900008],
              [-95.26860558699991, 16.128226753000092],
              [-95.28109314099993, 16.118888206000065],
              [-95.2803875489999, 16.10822509400009],
              [-95.28454994999993, 16.104223394000087],
              [-95.29768952099994, 16.101529043000085],
              [-95.30536620099991, 16.093540603000065],
              [-95.3372892299999, 16.088838327000076],
              [-95.35326250299994, 16.079489701000057],
              [-95.37823499599995, 16.04745414100006],
              [-95.3726480929999, 16.027458212000056],
              [-95.3844392279999, 16.021438772000067],
              [-95.39918225899993, 16.008758581000052],
              [-95.42552380299992, 15.99938792100005],
              [-95.42826260399994, 15.98538790300006],
              [-95.4344782519999, 15.975379910000072],
              [-95.4927793629999, 15.974653980000085],
              [-95.49689336199992, 15.965308182000058],
              [-95.57236940599995, 15.957122053000091],
              [-95.5813452189999, 15.945101371000078],
              [-95.60905023299995, 15.941702055000064],
              [-95.61456154099994, 15.92901896300009],
              [-95.66231329099992, 15.911570435000044],
              [-95.70588651199995, 15.908834483000078],
              [-95.73295357599994, 15.903396902000054],
              [-95.7551277789999, 15.89932060600006],
              [-95.77102762699991, 15.89060704600007],
              [-95.7786310589999, 15.884582315000046],
              [-95.7785826789999, 15.87325596800008],
              [-95.80076071999991, 15.870507959000065],
              [-95.82291598799992, 15.86509581100006],
              [-95.84805253799993, 15.858303127000056],
              [-95.87896861899992, 15.850892682000051],
              [-95.88794068699991, 15.843529704000048],
              [-95.95988243199992, 15.827913833000082],
              [-95.96815059099993, 15.817221044000064],
              [-96.0034001219999, 15.80841233600006],
              [-96.0310421239999, 15.792294053000091],
              [-96.05248489099995, 15.787530963000052],
              [-96.0785901989999, 15.770127250000087],
              [-96.0911871319999, 15.768733495000049],
              [-96.0959713279999, 15.762044132000085],
              [-96.10631255399994, 15.757327305000047],
              [-96.11674278999993, 15.761949731000072],
              [-96.1277410859999, 15.752563212000041],
              [-96.12553446599992, 15.737889486000086],
              [-96.20423237099993, 15.703500897000083],
              [-96.23663683099994, 15.683330152000053],
              [-96.2871528519999, 15.685769673000038],
              [-96.3618675049999, 15.683973606000052],
              [-96.4013731849999, 15.691707698000073],
              [-96.43114173099991, 15.695868231000077],
              [-96.44652258999992, 15.68195221600007],
              [-96.4703074979999, 15.672246618000088],
              [-96.48612871599994, 15.660809074000042],
              [-96.5048574139999, 15.658053971000072],
              [-96.52631438299994, 15.659907124000085],
              [-96.5491854679999, 15.664420499000073],
              [-96.55603842599993, 15.659025170000064],
              [-96.6136213399999, 15.679932849000068],
              [-96.6809749229999, 15.709412911000072],
              [-96.8036948589999, 15.731771397000045],
              [-96.84512285099993, 15.732570705000057],
              [-96.93067121399991, 15.78266532300006],
              [-96.99175752899993, 15.800107763000085],
              [-97.02228194399993, 15.80716693900007],
              [-97.04949866599992, 15.828923939000049],
              [-97.04537675699993, 15.83228345000009],
              [-97.06226405099994, 15.859413507000056],
              [-97.07609023099991, 15.856644955000093],
              [-97.10254115399994, 15.869073149000087],
              [-97.16067460799991, 15.90375397300005],
              [-97.20584919499993, 15.919664577000049],
              [-97.26602459299994, 15.935911607000037],
              [-97.28519143599993, 15.935556649000091],
              [-97.34548194299992, 15.945860377000088],
              [-97.36856495199993, 15.934601375000057],
              [-97.45924408999991, 15.945001337000065],
              [-97.52970282799993, 15.968188437000038],
              [-97.55742035399993, 15.962242746000072],
              [-97.61609394999994, 15.975603551000063],
              [-97.65998858699993, 15.97650324500006],
              [-97.67306027199993, 15.96931770000009],
              [-97.68174348499991, 15.962182608000091],
              [-97.7184109019999, 15.968802364000055],
              [-97.77271899599992, 15.979454108000084],
              [-97.79187160999993, 15.98768638000007],
              [-97.81113521999993, 16.002967181000088],
              [-97.8357234369999, 16.010565497000073],
              [-97.84603806399991, 16.018850285000042],
              [-97.8545793699999, 16.025167667000062],
              [-97.86121543799993, 16.028768941000067],
              [-97.87734971299994, 16.04004563700005],
              [-97.94440024999994, 16.087377194000055],
              [-97.98129962699994, 16.109375319000037],
              [-98.0852351549999, 16.165065822000088],
              [-98.12161210799991, 16.176214911000045],
              [-98.15416419199994, 16.190252997000073],
              [-98.1721492179999, 16.20917389500005],
              [-98.11318925699993, 16.192694403000075],
              [-98.08214270699995, 16.189276434000078],
              [-98.06847083199995, 16.202337958000044],
              [-98.08336341099994, 16.20075104400007],
              [-98.09732011599993, 16.210882880000042],
              [-98.11074785099993, 16.218573309000078],
              [-98.12376868399991, 16.20917389500005],
              [-98.14378821499992, 16.217596747000073],
              [-98.16470292899993, 16.22284577000005],
              [-98.16543535099993, 16.22479889500005],
              [-98.16832434799994, 16.229315497000073],
              [-98.17271887899994, 16.23395416900007],
              [-98.17837480399993, 16.23651764500005],
              [-98.17821204299992, 16.234157619000086],
              [-98.18297278599994, 16.229518947000088],
              [-98.18993079299992, 16.22492096600007],
              [-98.19640051999994, 16.22284577000005],
              [-98.21593176999994, 16.224676825000074],
              [-98.31578528599994, 16.255682684000078],
              [-98.44530188699991, 16.27810293200008],
              [-98.5085950049999, 16.300446737000073],
              [-98.53177398999992, 16.309559652000075],
              [-98.54539954299992, 16.31240469000005],
              [-98.5528473139999, 16.31474962900006],
              [-98.5545475429999, 16.318275247000088],
              [-98.56824441499992, 16.323979112000075],
              [-98.5711797859999, 16.327090746000067],
              [-98.5674605559999, 16.327148308000062],
              [-98.5646244539999, 16.33113674100008],
              [-98.5664018889999, 16.34057036900009],
              [-98.58242753799993, 16.360663153000075],
              [-98.61921319399994, 16.39184719600007],
              [-98.6980724679999, 16.46199885900006],
              [-98.73529821499994, 16.51393164400008],
              [-98.76428711499995, 16.543084413000088],
              [-98.76815131399991, 16.550928893000048],
              [-98.7768980589999, 16.555134748000057],
              [-98.79134711599994, 16.554121449000036],
              [-98.80626903099994, 16.557821620000084],
              [-98.81403970999992, 16.553349463000075],
              [-98.82164466099994, 16.55304596600007],
              [-98.83128155799994, 16.54980840500008],
              [-98.84619425299991, 16.546531306000077],
              [-98.8518542089999, 16.539705171000037],
              [-98.85538923699994, 16.531353657000068],
              [-98.85655020699994, 16.528179282000053],
              [-98.88929341999994, 16.53548444800009],
              [-98.90698576199992, 16.534790358000066],
              [-98.94645264799993, 16.550273600000082],
              [-99.1438269329999, 16.61088711900004],
              [-99.30714517899992, 16.652481739000052],
              [-99.37426040499992, 16.667911476000086],
              [-99.49452157099995, 16.68575399000008],
              [-99.55697487999993, 16.687780124000085],
              [-99.6053953089999, 16.682775244000084],
              [-99.6360628139999, 16.69010141700005],
              [-99.66328903099992, 16.698163701000055],
              [-99.68915009099993, 16.706915963000085],
              [-99.7180476549999, 16.719997463000084],
              [-99.7412410149999, 16.730617580000057],
              [-99.79527747299994, 16.771551825000074],
              [-99.82141301799993, 16.789770186000055],
              [-99.82761173099993, 16.788888455000063],
              [-99.8328912899999, 16.782454270000073],
              [-99.84382500099991, 16.78595806900006],
              [-99.84789275899993, 16.791790722000087],
              [-99.85810433499995, 16.79602871500009],
              [-99.8496426609999, 16.79993941200007],
              [-99.8389820349999, 16.794618364000087],
              [-99.83569982299991, 16.80210926500007],
              [-99.84052041699994, 16.808701072000076],
              [-99.84713024199993, 16.810049294000066],
              [-99.85291029199993, 16.806565530000057],
              [-99.86151591499993, 16.80860635600004],
              [-99.86929116599993, 16.80843283300004],
              [-99.87683473599992, 16.815336284000068],
              [-99.87028129399994, 16.817714814000055],
              [-99.8685120049999, 16.82593727200009],
              [-99.86248947099995, 16.83462161600005],
              [-99.85782166599995, 16.83398408000005],
              [-99.8516634209999, 16.836352505000036],
              [-99.85103398899992, 16.843053937000036],
              [-99.85819155799993, 16.851424915000052],
              [-99.86680073499991, 16.855672410000068],
              [-99.88126512399992, 16.85870982000006],
              [-99.89750498199993, 16.85280355900005],
              [-99.90790934499995, 16.846269453000048],
              [-99.9062029719999, 16.838501547000078],
              [-99.89690022199994, 16.84130621500009],
              [-99.8913678159999, 16.83733849300006],
              [-99.89973507799994, 16.828595782000036],
              [-99.9137063689999, 16.827166601000044],
              [-99.92010222099992, 16.834095778000062],
              [-99.92503744599992, 16.855864266000083],
              [-99.93235311299992, 16.86023018800006],
              [-99.95623371599993, 16.883125817000064],
              [-99.9594456829999, 16.892660810000052],
              [-99.9916863169999, 16.909736688000066],
              [-100.06545177899994, 16.93483595300006],
              [-100.11522432099991, 16.948197401000073],
              [-100.16691276699993, 16.967076057000043],
              [-100.23524448199993, 16.991130335000037],
              [-100.31981299499995, 17.022618451000085],
              [-100.56460403099993, 17.105274782000038],
              [-100.65306555899991, 17.134059963000084],
              [-100.71318224099991, 17.152105807000055],
              [-100.78001868399991, 17.18044668200008],
              [-100.83389238199993, 17.19875722900008],
              [-100.90003065999991, 17.217139055000075],
              [-100.95561370299993, 17.236859073000062],
              [-101.00823983399994, 17.252975908000053],
              [-101.04281446699991, 17.27020220500009],
              [-101.05902865899992, 17.264237103000085],
              [-101.06510498699993, 17.276008235000063],
              [-101.05369896999991, 17.28274348000008],
              [-101.05508378799993, 17.30263906500005],
              [-101.07332806799991, 17.320846334000066],
              [-101.1050819759999, 17.35030973700009],
              [-101.1718201299999, 17.38979140200007],
              [-101.1822451779999, 17.412536007000085],
              [-101.26309160099993, 17.456203518000052],
              [-101.34642852499991, 17.485192260000076],
              [-101.39376435399993, 17.50627711800007],
              [-101.45577348299992, 17.526338059000068],
              [-101.45683823699994, 17.53735030200005],
              [-101.44318928399991, 17.53934857900009],
              [-101.4407039049999, 17.557155666000085],
              [-101.44866989299993, 17.57032723900005],
              [-101.45814020199992, 17.58334294900004],
              [-101.49649083899993, 17.61440636100008],
              [-101.5258664669999, 17.61839286700007],
              [-101.55314003399991, 17.611375722000048],
              [-101.55731955499994, 17.62539019600007],
              [-101.56989757499991, 17.62538393300008],
              [-101.5793477709999, 17.636367233000044],
              [-101.5951275239999, 17.635342863000062],
              [-101.59933725499991, 17.65333853800007],
              [-101.61508673799995, 17.660323159000086],
              [-101.64448715599991, 17.668293558000073],
              [-101.6476665429999, 17.70528382100008],
              [-101.67188951599991, 17.74027008900009],
              [-101.69819797699995, 17.757255543000042],
              [-101.7455397729999, 17.792204006000077],
              [-101.75633704299992, 17.816839911000045],
              [-101.77091054099992, 17.829232578000074],
              [-101.77302728799992, 17.84822496700008],
              [-101.81106103499991, 17.890259920000062],
              [-101.85618362899993, 17.909494918000064],
              [-101.87091174699992, 17.915455892000068],
              [-101.9319627779999, 17.95034151400006],
              [-101.9898774799999, 17.974750847000053],
              [-102.03673255099994, 17.990668036000045],
              [-102.10047719799991, 17.98232702300004],
              [-102.10987181999991, 17.965296239000054],
              [-102.12979944299991, 17.951220542000044],
              [-102.1454925839999, 17.934168580000062],
              [-102.1622803969999, 17.92510161900009],
              [-102.1759152169999, 17.917046981000055],
              [-102.19062878299991, 17.915988111000047],
              [-102.2295927799999, 17.93283249600006],
              [-102.2885907729999, 17.961586612000076],
              [-102.42076575399994, 17.997992255000042],
              [-102.47508177799995, 18.01777694000009],
              [-102.5140332869999, 18.02057439300006],
              [-102.59724663599991, 18.049051098000064],
              [-102.69127356699994, 18.056708075000074],
              [-102.74229895699995, 18.066961981000077],
              [-102.87942460799991, 18.12213776200008],
              [-102.97315675099992, 18.16621926600004],
              [-103.0244441399999, 18.18581777600008],
              [-103.05973117899993, 18.187544996000042],
              [-103.11346855999994, 18.192098239000074],
              [-103.12522300799992, 18.206007525000075],
              [-103.14093968599991, 18.201865421000036],
              [-103.2212453699999, 18.234141987000044],
              [-103.23911690299991, 18.231980999000086],
              [-103.2919001709999, 18.24947638100008],
              [-103.30873547399995, 18.259273287000042],
              [-103.34366699499992, 18.270956281000053],
              [-103.36164018799991, 18.26682016400008],
              [-103.37968148399995, 18.27864559300008],
              [-103.42416177199993, 18.303190434000044],
              [-103.49839965599995, 18.333482650000064],
              [-103.5231405809999, 18.37623900400007],
              [-103.57510331899994, 18.492254950000074],
              [-103.61095130099994, 18.53115469000005],
              [-103.61925208199995, 18.536932684000078],
              [-103.62902516299994, 18.547985243000085],
              [-103.64401622899993, 18.55888869800009],
              [-103.66217147499992, 18.570743295000057],
              [-103.69304148999993, 18.588434127000085],
              [-103.70673684299993, 18.59122079000008],
              [-103.71001987099993, 18.601175565000062],
              [-103.68622843799994, 18.628552100000036],
              [-103.7001745789999, 18.65432741400008],
              [-103.73435068499992, 18.682946300000083],
              [-103.79427692099995, 18.74124833700006],
              [-103.95317750399994, 18.84927311000007],
              [-103.9799770269999, 18.874937644000056],
              [-104.09072831899994, 18.928290106000077],
              [-104.1806057629999, 18.971381044000054],
              [-104.24124432799994, 18.991548012000067],
              [-104.27209535599991, 19.00211132000004],
              [-104.29443733799991, 19.00978783700009],
              [-104.31570712699994, 19.01649580700007],
              [-104.33166806799994, 19.022256479000077],
              [-104.3290120399999, 19.05329889400008],
              [-104.30685922899994, 19.05664880200004],
              [-104.2996075079999, 19.06575494100008],
              [-104.30410206699992, 19.081682405000038],
              [-104.32872109699991, 19.099297143000058],
              [-104.34039256499995, 19.101121934000048],
              [-104.35080557899994, 19.09096450900006],
              [-104.35616281199992, 19.09488422900006],
              [-104.3543323269999, 19.111912810000092],
              [-104.36818729499993, 19.117704483000068],
              [-104.38613870599994, 19.115432845000043],
              [-104.3934260609999, 19.108322420000036],
              [-104.39000242899994, 19.093372238000086],
              [-104.39843298999995, 19.09124332400006],
              [-104.40598813799994, 19.100129920000086],
              [-104.4158015619999, 19.10565827000005],
              [-104.42701659199992, 19.091804806000084],
              [-104.43954794399991, 19.081607217000055],
              [-104.4515770509999, 19.10442611900004],
              [-104.48643958199995, 19.11867910400008],
              [-104.50381425699993, 19.12966543200008],
              [-104.5925593739999, 19.149603583000044],
              [-104.6360164049999, 19.159369208000044],
              [-104.67296301999994, 19.176581122000073],
              [-104.68399003799993, 19.18349844000005],
              [-104.6887507799999, 19.19411855700008],
              [-104.69192460799991, 19.207586981000077],
              [-104.70010331899994, 19.21035390800006],
              [-104.71117102799991, 19.209377346000053],
              [-104.72288977799991, 19.211493231000077],
              [-104.73033606699994, 19.218085028000075],
              [-104.73143469999991, 19.223781643000052],
              [-104.73355058499993, 19.228461005000042],
              [-104.74400794199994, 19.23196035400008],
              [-104.75084387899994, 19.23151276200008],
              [-104.7781062489999, 19.225165106000077],
              [-104.79967200399994, 19.224554755000042],
              [-104.8069148429999, 19.229071356000077],
              [-104.80483964799993, 19.255886135000083],
              [-104.7991023429999, 19.28310781500005],
              [-104.80142167899993, 19.294745184000078],
              [-104.8157039049999, 19.299627997000073],
              [-104.82583574099993, 19.29755280200004],
              [-104.84190833199995, 19.28860097900008],
              [-104.84951738199993, 19.28656647300005],
              [-104.85912024599992, 19.288112697000088],
              [-104.86620032499991, 19.289984442000048],
              [-104.8725886709999, 19.288356838000084],
              [-104.88052324099993, 19.279120184000078],
              [-104.95787512899994, 19.318060614000046],
              [-104.99364173099991, 19.342189846000053],
              [-105.0171199209999, 19.368475653000075],
              [-105.02871660099993, 19.414862372000073],
              [-105.0393367179999, 19.435614325000074],
              [-105.0700984369999, 19.447780666000085],
              [-105.07046464799993, 19.456244208000044],
              [-105.06554114499994, 19.475002346000053],
              [-105.06810462099992, 19.48541901200008],
              [-105.07412675699993, 19.493109442000048],
              [-105.08092200399994, 19.49941640800006],
              [-105.0859675769999, 19.505682684000078],
              [-105.08771005999995, 19.56107250100007],
              [-105.1169198309999, 19.58556352000005],
              [-105.1301570299999, 19.586452541000085],
              [-105.1428523429999, 19.583034572000088],
              [-105.15184485599991, 19.58417389500005],
              [-105.1706843739999, 19.60224030200004],
              [-105.18968665299991, 19.614935614000046],
              [-105.2507624989999, 19.666083075000074],
              [-105.29832923099991, 19.718573309000078],
              [-105.35167395699995, 19.804470119000086],
              [-105.38145911399994, 19.834051825000074],
              [-105.38841712099992, 19.852362372000073],
              [-105.3994441399999, 19.865057684000078],
              [-105.42861894399994, 19.88930898600006],
              [-105.44155839799993, 19.90643952000005],
              [-105.46666419199994, 19.950344143000052],
              [-105.52562415299991, 20.03192780200004],
              [-105.53164628799993, 20.050604559000078],
              [-105.53380286399994, 20.061794338000084],
              [-105.54320227799991, 20.080511786000045],
              [-105.54531816299993, 20.091620184000078],
              [-105.54531816299993, 20.135687567000048],
              [-105.55321204299992, 20.20148346600007],
              [-105.55894934799994, 20.21820709800005],
              [-105.5666804679999, 20.227362372000073],
              [-105.58397376199991, 20.23773834800005],
              [-105.59312903599994, 20.24555084800005],
              [-105.60879472599993, 20.27289459800005],
              [-105.62857011599993, 20.299994208000044],
              [-105.65565177199994, 20.31318116500006],
              [-105.6753734589999, 20.352666101000068],
              [-105.6902370489999, 20.384866143000067],
              [-105.6986814249999, 20.406910593000077],
              [-105.68309485599991, 20.423651434000078],
              [-105.57559160099993, 20.48773834800005],
              [-105.53080463499992, 20.49319459600008],
              [-105.46043860599991, 20.492621161000045],
              [-105.44603430899991, 20.49628327000005],
              [-105.42918860599991, 20.505926825000074],
              [-105.35973059799994, 20.51247793200008],
              [-105.3287343689999, 20.513738192000062],
              [-105.30095238099995, 20.531843742000092],
              [-105.2870394329999, 20.549929315000043],
              [-105.26671903699992, 20.557583699000077],
              [-105.25536048099991, 20.57062409100007],
              [-105.24364173099991, 20.58356354400007],
              [-105.23680579299992, 20.602443752000056],
              [-105.23429574499994, 20.636126945000058],
              [-105.25366980299992, 20.656139256000074],
              [-105.2838011319999, 20.670049756000083],
              [-105.3102233699999, 20.727212975000043],
              [-105.34152583699995, 20.75463932200006],
              [-105.36156124299993, 20.762750917000062],
              [-105.36958602399994, 20.755008383000074],
              [-105.38836035499992, 20.739463262000072],
              [-105.41090741699992, 20.733998547000056],
              [-105.44197156199994, 20.748710403000075],
              [-105.47832942299993, 20.751480598000057],
              [-105.51412233799994, 20.770333116000074],
              [-105.53287534399993, 20.756447104000074],
              [-105.54489559599995, 20.76809624000009],
              [-105.53513939099992, 20.778437288000077],
              [-105.5235832329999, 20.789655700000083],
              [-105.51448532299992, 20.78811999900006],
              [-105.50444810999994, 20.784905964000075],
              [-105.48653477199991, 20.79622291700008],
              [-105.47549394399994, 20.820379950000074],
              [-105.46644273099992, 20.834674219000078],
              [-105.4596038279999, 20.85595004600009],
              [-105.45528530699994, 20.867022744000053],
              [-105.44908606699994, 20.873073635000083],
              [-105.43992618099992, 20.871435320000046],
              [-105.4249189819999, 20.889572686000065],
              [-105.40394096499995, 20.928942248000055],
              [-105.37086974099992, 20.954080460000057],
              [-105.35823785199995, 20.957733546000043],
              [-105.3512222519999, 20.970605032000037],
              [-105.33425486499993, 20.985321139000064],
              [-105.32559160099993, 21.002956447000088],
              [-105.31871497299994, 21.017401434000078],
              [-105.30968176999994, 21.03066640800006],
              [-105.29884992399991, 21.03428020000007],
              [-105.29145705699995, 21.02671399600007],
              [-105.27964465699995, 21.02604421700005],
              [-105.2705586749999, 21.025322774000074],
              [-105.24997230499991, 21.04356363700009],
              [-105.2343269399999, 21.06096569500005],
              [-105.2303333509999, 21.09067123400007],
              [-105.2326318289999, 21.116901262000056],
              [-105.23924827999991, 21.131198091000044],
              [-105.2297008679999, 21.155067233000068],
              [-105.2329364819999, 21.18295221900007],
              [-105.2160808729999, 21.204378830000053],
              [-105.22570031399994, 21.283876130000067],
              [-105.24313839699994, 21.342063624000048],
              [-105.2304988269999, 21.388617255000042],
              [-105.2197566399999, 21.407497463000084],
              [-105.20289842999995, 21.434747136000055],
              [-105.18496660099993, 21.443019924000055],
              [-105.18663489499994, 21.45339590100008],
              [-105.19583085799991, 21.472683010000083],
              [-105.20006262899994, 21.49286530200004],
              [-105.20786442699995, 21.505802134000078],
              [-105.2175593739999, 21.517238674000055],
              [-105.23008214099991, 21.52491463800004],
              [-105.24376579499994, 21.527245425000046],
              [-105.24988618599991, 21.514455050000038],
              [-105.26350383699992, 21.51340146600006],
              [-105.2810359369999, 21.52838776200008],
              [-105.31963843699992, 21.54554550200004],
              [-105.3913874989999, 21.58930084800005],
              [-105.41407821699994, 21.60111301200004],
              [-105.44841745499991, 21.631031866000058],
              [-105.46290637099992, 21.671449576000043],
              [-105.54938677599995, 21.830182474000082],
              [-105.6322635979999, 21.95573695900009],
              [-105.64877493599994, 21.99232197000009],
              [-105.65726088299994, 22.04725290500005],
              [-105.64766385699994, 22.190607774000057],
              [-105.65503163999995, 22.256298129000072],
              [-105.68209154199991, 22.34677726600006],
              [-105.70622128299993, 22.421368276000067],
              [-105.72008216099994, 22.47292715100008],
              [-105.7326960929999, 22.504055080000057],
              [-105.71666419199994, 22.514186916000085],
              [-105.72354081899994, 22.52838776200008],
              [-105.7324519519999, 22.541449286000045],
              [-105.74193274599992, 22.546087958000044],
              [-105.7507624989999, 22.53461334800005],
              [-105.7575984369999, 22.53461334800005],
              [-105.76695716099994, 22.59048086100006],
              [-105.80016028599994, 22.638454494000086],
              [-105.8811335929999, 22.71279531500005],
              [-105.92544511599993, 22.766140041000085],
              [-105.94253495999993, 22.781683661000045],
              [-105.98448645699995, 22.805975653000075],
              [-105.9909968739999, 22.81207916900007],
              [-105.99290930899991, 22.815375067000048],
              [-105.99718176999994, 22.81867096600007],
              [-106.00161699099993, 22.823187567000048],
              [-106.00401770699995, 22.830104885000083],
              [-105.98412024599992, 22.856756903000075],
              [-105.99779212099992, 22.854518947000088],
              [-106.01016191299993, 22.848944403000075],
              [-106.0215144519999, 22.840643622000073],
              [-106.03197180899991, 22.830104885000083],
              [-106.22032630099994, 23.051947333000044],
              [-106.22874915299991, 23.05805084800005],
              [-106.2471003899999, 23.06403229400007],
              [-106.2578425769999, 23.06903717700004],
              [-106.27733313699991, 23.083685614000046],
              [-106.37083899599992, 23.183986721000053],
              [-106.3882136709999, 23.192572333000044],
              [-106.4001765619999, 23.19009023600006],
              [-106.41006425699993, 23.183661200000074],
              [-106.41934160099993, 23.17987702000005],
              [-106.42979895699995, 23.18512604400007],
              [-106.43175208199995, 23.193182684000078],
              [-106.42979895699995, 23.230414130000042],
              [-106.43517005099994, 23.244289455000057],
              [-106.4707332019999, 23.294989325000074],
              [-106.48692786399994, 23.30768463700008],
              [-106.48936926999994, 23.314520575000074],
              [-106.47695878799993, 23.322292385000083],
              [-106.47850501199991, 23.32839590100008],
              [-106.48131262899994, 23.333929755000042],
              [-106.4853816399999, 23.33893463700008],
              [-106.48656165299991, 23.339911200000074],
              [-106.52281653599994, 23.407538153000075],
              [-106.53563391799992, 23.418524481000077],
              [-106.55272376199991, 23.423529364000046],
              [-106.57140051999994, 23.435329494000086],
              [-106.61184648299991, 23.46906159100007],
              [-106.6164851549999, 23.473944403000075],
              [-106.62157141799992, 23.480617580000057],
              [-106.63247636599993, 23.504787502000056],
              [-106.6404109369999, 23.516546942000048],
              [-106.66653398299991, 23.52875397300005],
              [-106.6814265619999, 23.545436916000085],
              [-106.70352128799993, 23.57680898600006],
              [-106.73257402299993, 23.60651276200008],
              [-106.75059973899994, 23.618923244000086],
              [-106.7932429679999, 23.63235097900008],
              [-106.80406653599994, 23.65265534100007],
              [-106.81338456899994, 23.699652411000045],
              [-106.82652747299994, 23.717718817000048],
              [-106.8447566399999, 23.735541083000044],
              [-106.86099199099993, 23.755153713000084],
              [-106.8733210929999, 23.79828522300005],
              [-106.90200761599993, 23.846625067000048],
              [-107.03587805899991, 23.98078034100007],
              [-107.08486894399994, 24.01508209800005],
              [-107.10415605399993, 24.02179596600007],
              [-107.11693274599992, 24.02920156500005],
              [-107.16966712099992, 24.07644277600008],
              [-107.31297766799992, 24.16632721600007],
              [-107.3777563139999, 24.206854559000078],
              [-107.38878333199995, 24.217352606000077],
              [-107.3928930329999, 24.241156317000048],
              [-107.40428626199991, 24.252508856000077],
              [-107.4434301419999, 24.26825592700004],
              [-107.48086503799993, 24.293402411000045],
              [-107.54320227799991, 24.346584377000056],
              [-107.77501380099994, 24.477443752000056],
              [-107.79234778599994, 24.49404531500005],
              [-107.79967200399994, 24.512152411000045],
              [-107.79674231699994, 24.522650458000044],
              [-107.78990637899994, 24.52301666900007],
              [-107.78189042899993, 24.518011786000045],
              [-107.7754613919999, 24.512152411000045],
              [-107.77253170499995, 24.507554429000038],
              [-107.77147376199991, 24.502386786000045],
              [-107.77171790299991, 24.491034247000073],
              [-107.76915442599994, 24.48932526200008],
              [-107.69054114499994, 24.44953034100007],
              [-107.68016516799992, 24.446966864000046],
              [-107.54149329299992, 24.365057684000078],
              [-107.52603105399993, 24.358221747000073],
              [-107.51488196499992, 24.351996161000045],
              [-107.49803626199991, 24.34393952000005],
              [-107.50890051999994, 24.35260651200008],
              [-107.53844153599994, 24.36937083500004],
              [-107.55329342399995, 24.378078518000052],
              [-107.54967200399994, 24.387884833000044],
              [-107.53075110599991, 24.380113023000035],
              [-107.49803626199991, 24.35761139500005],
              [-107.49673417899993, 24.36082591400009],
              [-107.49303137899994, 24.36676666900007],
              [-107.49181067599994, 24.37059153900009],
              [-107.49510657499991, 24.370794989000046],
              [-107.50218665299991, 24.37018463700008],
              [-107.50548255099994, 24.37059153900009],
              [-107.49510657499991, 24.38222890800006],
              [-107.48509680899991, 24.389878648000035],
              [-107.47826087099992, 24.400091864000046],
              [-107.47752844999991, 24.419094143000052],
              [-107.48180091099994, 24.432847398000035],
              [-107.51919511599993, 24.511379299000055],
              [-107.52969316299993, 24.521918036000045],
              [-107.5464574859999, 24.528957424000055],
              [-107.56338456899994, 24.53066640800006],
              [-107.5794164699999, 24.52757396000004],
              [-107.59264075399994, 24.520086981000077],
              [-107.60167395699995, 24.50844961100006],
              [-107.58755449099993, 24.50543854400007],
              [-107.56090247299994, 24.514960028000075],
              [-107.55329342399995, 24.50844961100006],
              [-107.55752519399994, 24.49949778900009],
              [-107.58409583199995, 24.47492096600007],
              [-107.59422766799992, 24.46747467700004],
              [-107.62413489499994, 24.45848216400009],
              [-107.64220130099994, 24.47020091400009],
              [-107.65684973899994, 24.489081122000073],
              [-107.67674719999991, 24.501613674000055],
              [-107.69644120999993, 24.49013906500005],
              [-107.70409094999991, 24.487941799000055],
              [-107.7117406889999, 24.489203192000048],
              [-107.7188207669999, 24.49237702000005],
              [-107.73912512899994, 24.50726959800005],
              [-107.74502519399994, 24.51585521000004],
              [-107.74722245999993, 24.52212148600006],
              [-107.74828040299991, 24.53546784100007],
              [-107.75186113199993, 24.54254791900007],
              [-107.75816809799994, 24.547796942000048],
              [-107.77269446499992, 24.55292389500005],
              [-107.77916419199994, 24.55621979400007],
              [-107.82054602799991, 24.59516022300005],
              [-107.83287512899994, 24.59870026200008],
              [-107.84805253799993, 24.590318101000037],
              [-107.86709550699993, 24.608221747000073],
              [-107.88902747299994, 24.62376536700009],
              [-107.91270911399994, 24.63467031500005],
              [-107.9368383449999, 24.638820705000057],
              [-107.93248450399994, 24.628241278000075],
              [-107.92479407499991, 24.62099844000005],
              [-107.90953528599994, 24.61082591400009],
              [-107.87852942599994, 24.579820054000038],
              [-107.86168372299994, 24.56712474200009],
              [-107.81908118399991, 24.54441966400009],
              [-107.80650794199994, 24.528957424000055],
              [-107.83389238199993, 24.535223700000074],
              [-107.90855872299994, 24.577866929000038],
              [-107.99518795499995, 24.648382880000042],
              [-108.0047094389999, 24.661810614000046],
              [-108.0086156889999, 24.67723216400009],
              [-108.01317298099991, 24.71385325700004],
              [-108.0188695949999, 24.730861721000053],
              [-108.02794348899994, 24.748928127000056],
              [-108.03892981699994, 24.76325104400007],
              [-108.0501195949999, 24.76911041900007],
              [-108.05451412699995, 24.772284247000073],
              [-108.05870520699995, 24.779364325000074],
              [-108.06029212099992, 24.786444403000075],
              [-108.05663001199991, 24.789618231000077],
              [-108.0457250639999, 24.78847890800006],
              [-108.03620357999995, 24.785223700000074],
              [-108.01878821499992, 24.775336005000042],
              [-108.0110570949999, 24.76854075700004],
              [-107.99486243399991, 24.75804271000004],
              [-107.97887122299994, 24.756984768000052],
              [-107.97158769399994, 24.77875397300005],
              [-107.97630774599992, 24.79677969000005],
              [-107.98753821499992, 24.814601955000057],
              [-108.00121008999992, 24.828924872000073],
              [-108.01317298099991, 24.836818752000056],
              [-108.00084387899994, 24.84764232000009],
              [-107.99950110599991, 24.86359284100007],
              [-108.00572669199994, 24.898871161000045],
              [-108.00426184799994, 24.914618231000077],
              [-107.99986731699994, 24.92763906500005],
              [-107.98521887899994, 24.95343659100007],
              [-107.99657141799992, 24.96784088700008],
              [-108.03612219999991, 24.998480536000045],
              [-108.04869544199994, 25.00145091400009],
              [-108.04918372299994, 24.98261139500005],
              [-108.03648841099994, 24.92910390800006],
              [-108.03380286399994, 24.923773505000042],
              [-108.03233801999994, 24.91795482000009],
              [-108.03237870999993, 24.90501536700009],
              [-108.03880774599992, 24.872992255000042],
              [-108.04112708199995, 24.838364976000037],
              [-108.04417883999992, 24.82762278900009],
              [-108.0501195949999, 24.823146877000056],
              [-108.05663001199991, 24.82367584800005],
              [-108.0613500639999, 24.82558828300006],
              [-108.06541907499991, 24.82884349200009],
              [-108.07030188699991, 24.833685614000046],
              [-108.07774817599994, 24.83779531500005],
              [-108.08079993399991, 24.832953192000048],
              [-108.08291581899994, 24.825873114000046],
              [-108.08763587099992, 24.823146877000056],
              [-108.12437903599994, 24.844549872000073],
              [-108.1555883449999, 24.88300202000005],
              [-108.23412024599992, 25.02838776200008],
              [-108.25780188699991, 25.056341864000046],
              [-108.29312089799993, 25.083807684000078],
              [-108.31261145699995, 25.09243398600006],
              [-108.32225501199991, 25.09951406500005],
              [-108.32787024599992, 25.111151434000078],
              [-108.30626380099994, 25.11131419500009],
              [-108.28380286399994, 25.10683828300006],
              [-108.26618404899995, 25.096869208000044],
              [-108.25894120999993, 25.08038971600007],
              [-108.19749915299991, 25.014878648000035],
              [-108.18639075399994, 24.98655833500004],
              [-108.18325761599993, 24.981390692000048],
              [-108.17747962099992, 24.98069896000004],
              [-108.17137610599991, 24.98314036700009],
              [-108.1663305329999, 24.98631419500009],
              [-108.1634008449999, 24.987616278000075],
              [-108.14435787699995, 24.975775458000044],
              [-108.13914954299992, 24.973944403000075],
              [-108.13060462099992, 24.97679271000004],
              [-108.1277563139999, 24.984198309000078],
              [-108.12865149599992, 25.00531647300005],
              [-108.13247636599993, 25.019354559000078],
              [-108.1419164699999, 25.019191799000055],
              [-108.15330969999991, 25.01630280200004],
              [-108.1634008449999, 25.022365627000056],
              [-108.16258704299992, 25.028509833000044],
              [-108.15257727799991, 25.04588450700004],
              [-108.14907792899993, 25.05023834800005],
              [-108.1406957669999, 25.05768463700008],
              [-108.1367895169999, 25.05996328300006],
              [-108.13316809799994, 25.056382554000038],
              [-108.12555904899995, 25.046576239000046],
              [-108.1055395169999, 25.02692291900007],
              [-108.08901933499993, 25.01951732000009],
              [-108.04670162699995, 25.014878648000035],
              [-108.01317298099991, 25.001898505000042],
              [-108.00475012899994, 25.009507554000038],
              [-108.00169837099992, 25.02098216400009],
              [-108.00352942599994, 25.03143952000005],
              [-108.10692298099991, 25.116929429000038],
              [-108.11953691299993, 25.123480536000045],
              [-108.13609778599994, 25.124741929000038],
              [-108.1282445949999, 25.116848049000055],
              [-108.12913977799991, 25.11074453300006],
              [-108.1367895169999, 25.106594143000052],
              [-108.14907792899993, 25.104315497000073],
              [-108.16173255099994, 25.10643138200004],
              [-108.17292232999995, 25.11359284100007],
              [-108.1907445949999, 25.13157786700009],
              [-108.21226966099994, 25.166937567000048],
              [-108.21800696499992, 25.173163153000075],
              [-108.23159745999993, 25.17186107000009],
              [-108.24201412699995, 25.164943752000056],
              [-108.25243079299992, 25.160305080000057],
              [-108.2664281889999, 25.165716864000046],
              [-108.27977454299992, 25.158351955000057],
              [-108.30577551999994, 25.15696849200009],
              [-108.33360755099994, 25.160956122000073],
              [-108.35179602799991, 25.16950104400007],
              [-108.35606848899994, 25.20018138200004],
              [-108.35521399599992, 25.206732489000046],
              [-108.34805253799993, 25.204779364000046],
              [-108.32506262899994, 25.190659898000035],
              [-108.31419837099992, 25.18622467700004],
              [-108.3172094389999, 25.19944896000004],
              [-108.31745357999995, 25.22850169500009],
              [-108.32042395699995, 25.241441148000035],
              [-108.3294164699999, 25.251654364000046],
              [-108.35289466099994, 25.261664130000042],
              [-108.3613988919999, 25.269354559000078],
              [-108.3860570949999, 25.161932684000078],
              [-108.3992406889999, 25.14524974200009],
              [-108.40074622299994, 25.154364325000074],
              [-108.39610755099994, 25.198431708000044],
              [-108.39614824099993, 25.214178778000075],
              [-108.40518144399994, 25.23383209800005],
              [-108.41901607999995, 25.249172268000052],
              [-108.43504798099991, 25.26080963700008],
              [-108.45079505099994, 25.269354559000078],
              [-108.55418860599991, 25.307766018000052],
              [-108.61400305899991, 25.34332916900007],
              [-108.65428626199991, 25.35370514500005],
              [-108.69652258999992, 25.358547268000052],
              [-108.73192298099991, 25.35814036700009],
              [-108.70860755099994, 25.373846747000073],
              [-108.66734778599994, 25.370794989000046],
              [-108.59414628799993, 25.351304429000038],
              [-108.61831620999993, 25.36196523600006],
              [-108.65721594999991, 25.392238674000055],
              [-108.68724524599992, 25.398504950000074],
              [-108.7405492829999, 25.382879950000074],
              [-108.76573645699995, 25.380926825000074],
              [-108.77969316299993, 25.398504950000074],
              [-108.73867753799993, 25.39907461100006],
              [-108.72988847599993, 25.405991929000038],
              [-108.74185136599993, 25.423000393000052],
              [-108.74596106699994, 25.43105703300006],
              [-108.7456762359999, 25.438788153000075],
              [-108.74693762899994, 25.444647528000075],
              [-108.75584876199991, 25.446926174000055],
              [-108.75991777299993, 25.445054429000038],
              [-108.77159583199995, 25.43622467700004],
              [-108.77969316299993, 25.433254299000055],
              [-108.76976477799991, 25.464667059000078],
              [-108.76744544199994, 25.47870514500005],
              [-108.76671301999994, 25.52570221600007],
              [-108.76895097599993, 25.540187893000052],
              [-108.77501380099994, 25.541408596000053],
              [-108.78355872299994, 25.537543036000045],
              [-108.79336503799993, 25.536322333000044],
              [-108.82811438699991, 25.549302476000037],
              [-108.82933508999992, 25.551906643000052],
              [-108.8303930329999, 25.556789455000057],
              [-108.8328344389999, 25.561468817000048],
              [-108.83836829299992, 25.563625393000052],
              [-108.84434973899994, 25.56248607000009],
              [-108.8538305329999, 25.557847398000035],
              [-108.85887610599991, 25.556789455000057],
              [-108.87682044199994, 25.55963776200008],
              [-108.88951575399994, 25.563299872000073],
              [-108.89631100199995, 25.560248114000046],
              [-108.89639238199993, 25.543117580000057],
              [-108.89293372299994, 25.532456773000035],
              [-108.88780676999994, 25.526312567000048],
              [-108.8836156889999, 25.51984284100007],
              [-108.88272050699993, 25.508368231000077],
              [-108.88475501199991, 25.49677155200004],
              [-108.88784745999993, 25.48969147300005],
              [-108.8926488919999, 25.484320380000042],
              [-108.89981035099993, 25.47797272300005],
              [-108.91584225199995, 25.46747467700004],
              [-108.92967688699991, 25.46637604400007],
              [-108.94155839799993, 25.473537502000056],
              [-108.95164954299992, 25.48786041900007],
              [-108.94701087099992, 25.486802476000037],
              [-108.94029700399994, 25.489406643000052],
              [-108.93736731699994, 25.49477773600006],
              [-108.94420325399994, 25.50214264500005],
              [-108.95181230399993, 25.50389232000009],
              [-109.00186113199993, 25.499945380000042],
              [-109.01577714799993, 25.493353583000044],
              [-109.01878821499992, 25.482489325000074],
              [-109.00625566299993, 25.467352606000077],
              [-109.03465735599991, 25.465236721000053],
              [-109.06631425699993, 25.48505280200004],
              [-109.11611894399994, 25.536322333000044],
              [-109.09439042899993, 25.545314846000053],
              [-109.08824622299994, 25.549302476000037],
              [-109.08202063699991, 25.558742580000057],
              [-109.07738196499992, 25.570461330000057],
              [-109.07046464799993, 25.580471096000053],
              [-109.05776933499993, 25.58466217700004],
              [-109.02391516799992, 25.573065497000073],
              [-109.01622473899994, 25.573879299000055],
              [-109.00536048099991, 25.577948309000078],
              [-108.99815833199995, 25.56867096600007],
              [-108.99258378799993, 25.549302476000037],
              [-108.98314368399991, 25.54437897300005],
              [-108.98045813699991, 25.544623114000046],
              [-108.97862708199995, 25.550848700000074],
              [-108.97154700399994, 25.563625393000052],
              [-108.97057044199994, 25.568182684000078],
              [-108.97232011599993, 25.57998281500005],
              [-108.97154700399994, 25.58466217700004],
              [-108.96768144399994, 25.588771877000056],
              [-108.9597875639999, 25.59052155200004],
              [-108.9065649079999, 25.639064846000053],
              [-108.89639238199993, 25.65298086100006],
              [-108.89537512899994, 25.65851471600007],
              [-108.89736894399994, 25.662176825000074],
              [-108.89891516799992, 25.66620514500005],
              [-108.89639238199993, 25.67283763200004],
              [-108.89329993399991, 25.67536041900007],
              [-108.88784745999993, 25.678168036000045],
              [-108.88329016799992, 25.67837148600006],
              [-108.88052324099993, 25.684881903000075],
              [-108.88272050699993, 25.717230536000045],
              [-108.8731176419999, 25.736721096000053],
              [-108.8333227199999, 25.768866278000075],
              [-108.82811438699991, 25.789536851000037],
              [-108.83804277299993, 25.804632880000042],
              [-108.84984290299991, 25.792710679000038],
              [-108.8718969389999, 25.75226471600007],
              [-108.8860570949999, 25.732163804000038],
              [-108.90086829299992, 25.70066966400009],
              [-108.91690019399994, 25.687160549000055],
              [-108.9409887359999, 25.676988023000035],
              [-108.98936926999994, 25.663031317000048],
              [-109.00967363199993, 25.649562893000052],
              [-109.04173743399991, 25.604681708000044],
              [-109.06212317599994, 25.590277411000045],
              [-109.08824622299994, 25.597723700000074],
              [-109.11367753799993, 25.584377346000053],
              [-109.13125566299993, 25.58340078300006],
              [-109.14439856699994, 25.59471263200004],
              [-109.15648352799991, 25.61823151200008],
              [-109.16441809799994, 25.638820705000057],
              [-109.1712133449999, 25.64874909100007],
              [-109.18073482999995, 25.65298086100006],
              [-109.19318600199995, 25.655422268000052],
              [-109.22447669199994, 25.668890692000048],
              [-109.25015214799993, 25.68618398600006],
              [-109.25438391799992, 25.681708075000074],
              [-109.25169837099992, 25.67023346600007],
              [-109.24592037699995, 25.65916575700004],
              [-109.23770097599993, 25.650783596000053],
              [-109.1692602199999, 25.59796784100007],
              [-109.15274003799993, 25.57648346600007],
              [-109.15648352799991, 25.556789455000057],
              [-109.17992102799991, 25.57636139500005],
              [-109.20164954299992, 25.603989976000037],
              [-109.22752844999991, 25.628648179000038],
              [-109.26292883999992, 25.63930898600006],
              [-109.37389075399994, 25.637152411000045],
              [-109.41030839799993, 25.646144924000055],
              [-109.38719641799992, 25.66083405200004],
              [-109.35928300699993, 25.668402411000045],
              [-109.32945716099994, 25.66815827000005],
              [-109.30052649599992, 25.65916575700004],
              [-109.3015844389999, 25.676336981000077],
              [-109.30052649599992, 25.693304755000042],
              [-109.29784094999991, 25.698065497000073],
              [-109.28880774599992, 25.70571523600006],
              [-109.28685462099992, 25.710679429000038],
              [-109.28799394399994, 25.716742255000042],
              [-109.2905981109999, 25.71946849200009],
              [-109.29312089799993, 25.721136786000045],
              [-109.29430091099994, 25.724351304000038],
              [-109.30256100199995, 25.735541083000044],
              [-109.32176673099991, 25.748195705000057],
              [-109.34357662699995, 25.75853099200009],
              [-109.35948645699995, 25.762884833000044],
              [-109.37804114499994, 25.761786200000074],
              [-109.3894750639999, 25.756415106000077],
              [-109.39517167899993, 25.74371979400007],
              [-109.39586341099994, 25.68585846600007],
              [-109.39964758999992, 25.678534247000073],
              [-109.41030839799993, 25.693304755000042],
              [-109.40526282499991, 25.71116771000004],
              [-109.40355383999992, 25.73655833500004],
              [-109.40623938699991, 25.75922272300005],
              [-109.4141332669999, 25.76902903900009],
              [-109.43517005099994, 25.776312567000048],
              [-109.44054114499994, 25.793402411000045],
              [-109.43691972599993, 25.813788153000075],
              [-109.42540442599994, 25.85228099200009],
              [-109.42052161399994, 25.861029364000046],
              [-109.41840572799993, 25.86204661700009],
              [-109.41783606699994, 25.882025458000044],
              [-109.41909745999993, 25.89594147300005],
              [-109.42243404899995, 25.905178127000056],
              [-109.43081620999993, 25.920477606000077],
              [-109.4378149079999, 25.942694403000075],
              [-109.4395238919999, 25.961330471000053],
              [-109.43765214799993, 26.005519924000055],
              [-109.43325761599993, 26.02167389500005],
              [-109.39671790299991, 26.07689036700009],
              [-109.35928300699993, 26.11395905200004],
              [-109.34239661399994, 26.13475169500009],
              [-109.32970130099994, 26.175116278000075],
              [-109.28880774599992, 26.243882554000038],
              [-109.26964270699995, 26.277411200000074],
              [-109.26634680899991, 26.293524481000077],
              [-109.26219641799992, 26.30410390800006],
              [-109.2547094389999, 26.301988023000035],
              [-109.25133216099994, 26.289455471000053],
              [-109.26207434799994, 26.268011786000045],
              [-109.26895097599993, 26.262518622000073],
              [-109.27513587099992, 26.255072333000044],
              [-109.28014075399994, 26.24762604400007],
              [-109.28364010299993, 26.240627346000053],
              [-109.28384355399993, 26.240179755000042],
              [-109.28795325399994, 26.22614166900007],
              [-109.28685462099992, 26.20449453300006],
              [-109.28921464799993, 26.194566148000035],
              [-109.29356848899994, 26.183539130000042],
              [-109.29552161399994, 26.17255280200004],
              [-109.2905981109999, 26.16315338700008],
              [-109.28042558499993, 26.160630601000037],
              [-109.27281653599994, 26.168036200000074],
              [-109.26805579299992, 26.17987702000005],
              [-109.26170813699991, 26.21039459800005],
              [-109.23159745999993, 26.262518622000073],
              [-109.22695878799993, 26.280991929000038],
              [-109.2254125639999, 26.334458726000037],
              [-109.21666419199994, 26.34398021000004],
              [-109.19688880099994, 26.343817450000074],
              [-109.1760961579999, 26.33820221600007],
              [-109.16392981699994, 26.331366278000075],
              [-109.15611731699994, 26.312323309000078],
              [-109.15713456899994, 26.292792059000078],
              [-109.1648656889999, 26.27692291900007],
              [-109.17699133999992, 26.268703518000052],
              [-109.17699133999992, 26.262518622000073],
              [-109.15607662699995, 26.254828192000048],
              [-109.10936438699991, 26.216457424000055],
              [-109.0950414699999, 26.21474844000005],
              [-109.09373938699991, 26.225409247000073],
              [-109.10777747299994, 26.249335028000075],
              [-109.1087133449999, 26.262518622000073],
              [-109.10098222599993, 26.268784898000035],
              [-109.08983313699991, 26.27171458500004],
              [-109.08299719999991, 26.277004299000055],
              [-109.08824622299994, 26.29043203300006],
              [-109.11611894399994, 26.288885809000078],
              [-109.13923092399995, 26.331773179000038],
              [-109.15672766799992, 26.364203192000048],
              [-109.18443762899994, 26.378566799000055],
              [-109.18024654899995, 26.37518952000005],
              [-109.17650305899991, 26.370917059000078],
              [-109.1731664699999, 26.365627346000053],
              [-109.17015540299991, 26.358710028000075],
              [-109.19054114499994, 26.36424388200004],
              [-109.20132402299993, 26.36595286700009],
              [-109.2117406889999, 26.364935614000046],
              [-109.24010169199994, 26.33551666900007],
              [-109.24962317599994, 26.334458726000037],
              [-109.25300045499995, 26.34906647300005],
              [-109.23900305899991, 26.41950104400007],
              [-109.24478105399993, 26.458726304000038],
              [-109.25572669199994, 26.497992255000042],
              [-109.27735262199991, 26.521766079000088],
              [-109.31415377199994, 26.568716230000064],
              [-109.3579047159999, 26.597391015000085],
              [-109.38708865699994, 26.63802112700006],
              [-109.41743323799994, 26.661963897000078],
              [-109.44659322099994, 26.671834553000053],
              [-109.47516307099994, 26.674927979000074],
              [-109.48275263599993, 26.682211429000063],
              [-109.47167895599995, 26.684829622000052],
              [-109.4512676199999, 26.679643130000045],
              [-109.42852177499992, 26.671851485000047],
              [-109.43378949599992, 26.690078576000076],
              [-109.4413742019999, 26.694238642000073],
              [-109.4355542369999, 26.703620647000037],
              [-109.44139775299993, 26.714554887000077],
              [-109.45947745799992, 26.71609963600008],
              [-109.47347552399992, 26.717646973000058],
              [-109.48049046599994, 26.72857822700007],
              [-109.48342848399994, 26.742640547000065],
              [-109.49508627599994, 26.73741614000005],
              [-109.50615412799993, 26.72906592600009],
              [-109.51201941599993, 26.747297161000063],
              [-109.5289457699999, 26.751437709000072],
              [-109.5411691999999, 26.73839018600006],
              [-109.54989611499991, 26.727955911000038],
              [-109.55278809599992, 26.71701042500007],
              [-109.54519536399994, 26.71181349300008],
              [-109.53294590999991, 26.71027047800004],
              [-109.52186215099994, 26.708203730000037],
              [-109.51835160799993, 26.701957448000087],
              [-109.52183818399993, 26.695700825000074],
              [-109.5235732889999, 26.688405051000075],
              [-109.5037339569999, 26.678536600000086],
              [-109.49323725599993, 26.676467500000058],
              [-109.49439100299992, 26.669173329000046],
              [-109.53056107599991, 26.684226796000075],
              [-109.60464171299992, 26.69659686400007],
              [-109.6477981519999, 26.693379237000045],
              [-109.66177008999995, 26.683968056000083],
              [-109.6640706309999, 26.67406241200007],
              [-109.69442842699993, 26.678155055000047],
              [-109.72542263399993, 26.691102545000035],
              [-109.7683721819999, 26.706511899000077],
              [-109.78457597599993, 26.71942780200004],
              [-109.83145097599993, 26.765692450000074],
              [-109.85631262899994, 26.80097077000005],
              [-109.8640423729999, 26.835453692000044],
              [-109.87157279299993, 26.87079303900009],
              [-109.88654537699995, 26.89203522300005],
              [-109.90054277299993, 26.92291901200008],
              [-109.90379798099991, 26.93781159100007],
              [-109.91124426999994, 26.951971747000073],
              [-109.94556500999994, 26.99708981000009],
              [-109.94177346999993, 27.00739376300004],
              [-109.9324438139999, 26.994086005000042],
              [-109.90416419199994, 26.954413153000075],
              [-109.88329016799992, 26.94090403900009],
              [-109.9083591729999, 26.99668292000007],
              [-109.90911034699991, 27.017251504000058],
              [-109.91703660899992, 27.060074427000075],
              [-109.95221920499995, 27.098578192000048],
              [-109.96617591099994, 27.10887278900009],
              [-109.98216712099992, 27.11513906500005],
              [-109.99917558499993, 27.11815013200004],
              [-110.01646887899994, 27.11904531500005],
              [-110.02383378799993, 27.11741771000004],
              [-110.03148352799991, 27.113430080000057],
              [-110.03848222599993, 27.107977606000077],
              [-110.04405676999994, 27.10228099200009],
              [-110.05210445699993, 27.090320845000065],
              [-110.06232888199992, 27.081692415000077],
              [-110.09078298599991, 27.10270860500009],
              [-110.14930901799994, 27.118419558000085],
              [-110.19239509699992, 27.127871069000037],
              [-110.21684741999991, 27.134573515000056],
              [-110.24128180999992, 27.138415901000087],
              [-110.2650923359999, 27.14340237500005],
              [-110.2876215799999, 27.148393774000056],
              [-110.32087154899995, 27.165228583000044],
              [-110.33668842299994, 27.172061820000067],
              [-110.37178884399992, 27.20898266200004],
              [-110.40371775599993, 27.245371116000058],
              [-110.4478827879999, 27.27426201700007],
              [-110.46476651099994, 27.28330948900009],
              [-110.5003709739999, 27.291081661000078],
              [-110.52232942199993, 27.290354190000073],
              [-110.52439359599992, 27.30008336900005],
              [-110.4933549299999, 27.298008329000083],
              [-110.46621245199992, 27.295904755000038],
              [-110.43842313599993, 27.292655264000075],
              [-110.42562796699991, 27.30190561900008],
              [-110.44505774599992, 27.317694403000075],
              [-110.47105872299994, 27.345851955000057],
              [-110.47915605399993, 27.358628648000035],
              [-110.47740637899994, 27.363104559000078],
              [-110.47354081899994, 27.370266018000052],
              [-110.47350012899994, 27.37685781500005],
              [-110.48737545499995, 27.381293036000045],
              [-110.49209550699993, 27.38499583500004],
              [-110.49966386599993, 27.393377997000073],
              [-110.51846269399994, 27.379055080000057],
              [-110.53038489499994, 27.37323639500005],
              [-110.54063880099994, 27.372259833000044],
              [-110.55093339799993, 27.377386786000045],
              [-110.5547582669999, 27.38475169500009],
              [-110.55431067599994, 27.41014232000009],
              [-110.55850175699993, 27.434393622000073],
              [-110.58740492099992, 27.44936494600006],
              [-110.58884897799993, 27.511864521000064],
              [-110.5980262409999, 27.54368436100009],
              [-110.62670827099993, 27.60853697400006],
              [-110.62710096099994, 27.641099162000046],
              [-110.6170046069999, 27.657476743000075],
              [-110.5991918609999, 27.664618231000077],
              [-110.57896887899994, 27.668361721000053],
              [-110.5679418609999, 27.681382554000038],
              [-110.57013912699995, 27.697414455000057],
              [-110.58193925699993, 27.700140692000048],
              [-110.59561113199993, 27.69354889500005],
              [-110.60334225199995, 27.681382554000038],
              [-110.59471594999991, 27.714504299000055],
              [-110.58901933499993, 27.722357489000046],
              [-110.57583574099993, 27.72797272300005],
              [-110.56338456899994, 27.72947825700004],
              [-110.55345618399991, 27.732489325000074],
              [-110.54808508999992, 27.74282461100006],
              [-110.58189856699994, 27.74481842700004],
              [-110.59951738199993, 27.752346096000053],
              [-110.60171464799993, 27.76707591400009],
              [-110.58901933499993, 27.79124583500004],
              [-110.60326087099992, 27.79315827000005],
              [-110.6128637359999, 27.800930080000057],
              [-110.61558997299994, 27.812201239000046],
              [-110.60952714799993, 27.824774481000077],
              [-110.60399329299992, 27.81509023600006],
              [-110.5972387359999, 27.812892971000053],
              [-110.59146074099993, 27.817572333000044],
              [-110.58657792899993, 27.837062893000052],
              [-110.5801488919999, 27.83885325700004],
              [-110.57115637899994, 27.837958075000074],
              [-110.5210668609999, 27.844549872000073],
              [-110.50837154899995, 27.853664455000057],
              [-110.51329505099994, 27.873195705000057],
              [-110.5332738919999, 27.86595286700009],
              [-110.59166419199994, 27.887518622000073],
              [-110.61632239499994, 27.88617584800005],
              [-110.60411536399994, 27.87563711100006],
              [-110.60912024599992, 27.870835679000038],
              [-110.62376868399991, 27.872992255000042],
              [-110.65465247299994, 27.892238674000055],
              [-110.67096920499995, 27.898382880000042],
              [-110.74185136599993, 27.914129950000074],
              [-110.77696692599994, 27.916896877000056],
              [-110.81212317599994, 27.914536851000037],
              [-110.84911048099991, 27.906683661000045],
              [-110.84911048099991, 27.914129950000074],
              [-110.83849036399994, 27.916571356000077],
              [-110.8081762359999, 27.927801825000074],
              [-110.8159887359999, 27.941066799000055],
              [-110.81997636599993, 27.95026276200008],
              [-110.82152258999992, 27.959377346000053],
              [-110.8218481109999, 27.97215403900009],
              [-110.82713782499991, 27.982855536000045],
              [-110.83885657499991, 27.989406643000052],
              [-110.85065670499995, 27.989081122000073],
              [-110.85594641799992, 27.979315497000073],
              [-110.85655676999994, 27.951605536000045],
              [-110.86058508999992, 27.934881903000075],
              [-110.87092037699995, 27.92059967700004],
              [-110.8906957669999, 27.89984772300005],
              [-110.87584387899994, 27.90192291900007],
              [-110.86742102799991, 27.89842357000009],
              [-110.86363684799994, 27.889797268000052],
              [-110.86278235599991, 27.876288153000075],
              [-110.86717688699991, 27.863104559000078],
              [-110.87677975199995, 27.84711334800005],
              [-110.8863012359999, 27.83885325700004],
              [-110.8906957669999, 27.848944403000075],
              [-110.89513098899994, 27.850816148000035],
              [-110.9180395169999, 27.879380601000037],
              [-110.92320716099994, 27.88149648600006],
              [-110.93907630099994, 27.883368231000077],
              [-110.94591223899994, 27.88617584800005],
              [-110.95030676999994, 27.891099351000037],
              [-110.95372473899994, 27.89671458500004],
              [-110.95824133999992, 27.902289130000042],
              [-110.96580969999991, 27.906683661000045],
              [-110.95323645699995, 27.916571356000077],
              [-110.94762122299994, 27.919094143000052],
              [-110.93846594999991, 27.920355536000045],
              [-110.9553930329999, 27.936468817000048],
              [-110.97594153599994, 27.95213450700004],
              [-110.99925696499992, 27.964056708000044],
              [-111.02102183699992, 27.96188626500009],
              [-111.04056132099993, 27.955910476000042],
              [-111.05914568999992, 27.937017087000072],
              [-111.0874484229999, 27.936204641000074],
              [-111.10502524999993, 27.935372175000055],
              [-111.10208792499992, 27.94483826700008],
              [-111.09523647299994, 27.951711511000042],
              [-111.1039952779999, 27.962050585000043],
              [-111.11864431099991, 27.969824937000055],
              [-111.12844325599991, 27.968989087000068],
              [-111.14259284399992, 27.984057328000063],
              [-111.17179953099992, 27.99008703800007],
              [-111.1834739499999, 28.00641842500005],
              [-111.19807016599992, 28.02186669300005],
              [-111.22046374399991, 28.044274],
              [-111.2506620239999, 28.052012803000082],
              [-111.26333758899995, 28.07351772800007],
              [-111.28183590499992, 28.09152931200009],
              [-111.30037177799994, 28.12934926400004],
              [-111.33264827199991, 28.160407105000047],
              [-111.34044348899994, 28.20526764500005],
              [-111.34935462099992, 28.215765692000048],
              [-111.35244706899994, 28.216538804000038],
              [-111.3667699859999, 28.215765692000048],
              [-111.37279212099992, 28.217718817000048],
              [-111.37559973899994, 28.222316799000055],
              [-111.37730872299994, 28.22793203300006],
              [-111.3848363919999, 28.24164459800005],
              [-111.38833574099993, 28.263373114000046],
              [-111.3941137359999, 28.273830471000053],
              [-111.43883216099994, 28.30849844000005],
              [-111.45177161399994, 28.32562897300005],
              [-111.4583227199999, 28.34723541900007],
              [-111.45205644399994, 28.35883209800005],
              [-111.44229081899994, 28.369289455000057],
              [-111.43814042899993, 28.387111721000053],
              [-111.47350012899994, 28.38104889500005],
              [-111.51622473899994, 28.393784898000035],
              [-111.5862040259999, 28.41541466800004],
              [-111.64954103399992, 28.444398917000058],
              [-111.67367216399992, 28.452284864000035],
              [-111.69779694699992, 28.457520444000068],
              [-111.70835409699993, 28.460141185000055],
              [-111.72363810999991, 28.50120129700008],
              [-111.7419431969999, 28.539617281000062],
              [-111.76060950399994, 28.58397044500009],
              [-111.92039954299992, 28.720038153000075],
              [-111.94007215599993, 28.74644744400007],
              [-111.94937979899993, 28.756513934000054],
              [-111.94508248499994, 28.76342251600005],
              [-111.93290793299991, 28.763408887000082],
              [-111.92144725999992, 28.76779257800007],
              [-111.90353532599994, 28.77970405600007],
              [-111.89435787699995, 28.78066640800006],
              [-111.88735917899993, 28.77090078300006],
              [-111.88231360599991, 28.76080963700008],
              [-111.87637285099993, 28.752834377000056],
              [-111.86705481699994, 28.74957916900007],
              [-111.86119544199994, 28.753241278000075],
              [-111.8574926419999, 28.762274481000077],
              [-111.85602779899995, 28.77362702000005],
              [-111.85708574099993, 28.784369208000044],
              [-111.86823482999995, 28.803127346000053],
              [-111.8836156889999, 28.803290106000077],
              [-111.90200761599993, 28.799994208000044],
              [-111.92501710499994, 28.80171885900006],
              [-111.95294523299992, 28.82498053100005],
              [-111.96727145799991, 28.841320533000044],
              [-112.00451443799994, 28.855152588000067],
              [-112.03029557999992, 28.86143095300008],
              [-112.03526770699995, 28.880560614000046],
              [-112.0489199559999, 28.885892416000047],
              [-112.04677355799993, 28.895933908000075],
              [-112.06109715499991, 28.908517462000077],
              [-112.08401944399992, 28.92354005100009],
              [-112.09118593499994, 28.938583944000072],
              [-112.09886633999992, 28.950873114000046],
              [-112.10552631799993, 28.95737767600008],
              [-112.115576, 28.961755502000074],
              [-112.12921614999993, 28.964250974000038],
              [-112.1507251949999, 28.96297809200007],
              [-112.16650771699994, 28.966725705000044],
              [-112.17081866399991, 28.972993070000086],
              [-112.1607871139999, 28.980529845000035],
              [-112.15217895799992, 28.987435522000055],
              [-112.15501868399991, 28.996649481000077],
              [-112.15733801999994, 29.00604889500005],
              [-112.17091819599995, 29.047161802000062],
              [-112.1730875849999, 29.07037257500008],
              [-112.18601746199994, 29.07474544200005],
              [-112.18387199699993, 29.08415728600005],
              [-112.17383930099993, 29.098593563000065],
              [-112.16494706899994, 29.109930731000077],
              [-112.16612708199995, 29.120428778000075],
              [-112.1774689099999, 29.140602336000086],
              [-112.19475279499994, 29.157518750000065],
              [-112.19114764199992, 29.166919730000075],
              [-112.20913652299993, 29.180975653000075],
              [-112.22704016799992, 29.188421942000048],
              [-112.21358415299994, 29.227754780000055],
              [-112.21142480399993, 29.252807880000034],
              [-112.22446506599994, 29.28042766300007],
              [-112.23945332799991, 29.31533664600005],
              [-112.26347388199991, 29.329980488000047],
              [-112.31400174899994, 29.330542532000038],
              [-112.3233476829999, 29.326753219000068],
              [-112.33052754999994, 29.32108672800007],
              [-112.33214270699995, 29.316351630000042],
              [-112.32945716099994, 29.308254299000055],
              [-112.33307857999995, 29.296535549000055],
              [-112.34129798099991, 29.300930080000057],
              [-112.3567602199999, 29.318793036000045],
              [-112.39388944099994, 29.33282606100005],
              [-112.41122409299993, 29.344728143000054],
              [-112.41982229999991, 29.37590965000004],
              [-112.40737870999993, 29.404364325000074],
              [-112.38536536399994, 29.443182684000078],
              [-112.37783769399994, 29.46279531500005],
              [-112.37775381199992, 29.485729055000036],
              [-112.38714996699991, 29.49827496900008],
              [-112.40803708999994, 29.502706999000054],
              [-112.4195985909999, 29.510208876000036],
              [-112.43045237699994, 29.520222293000074],
              [-112.42909280899994, 29.54156411400004],
              [-112.43199622299994, 29.56118398600006],
              [-112.46662350199995, 29.585638739000046],
              [-112.50597170999993, 29.616918785000053],
              [-112.53087317599994, 29.67601146000004],
              [-112.53587805899991, 29.68821849200009],
              [-112.5437719389999, 29.69822825700004],
              [-112.56047596799993, 29.696341251000035],
              [-112.58018958199995, 29.718003648000035],
              [-112.58702551999994, 29.73265208500004],
              [-112.59581458199995, 29.771307684000078],
              [-112.61025956899994, 29.791896877000056],
              [-112.6265356109999, 29.809881903000075],
              [-112.63792883999992, 29.825873114000046],
              [-112.65831458199995, 29.88344961100006],
              [-112.66945523099992, 29.89762272300004],
              [-112.6863500639999, 29.90778229400007],
              [-112.69338240899992, 29.90317899200005],
              [-112.70934523499994, 29.909995156000036],
              [-112.72957736899991, 29.903012034000085],
              [-112.74628702099994, 29.91046545200004],
              [-112.7514717169999, 29.92426352600006],
              [-112.7392658089999, 29.941248914000084],
              [-112.74448754899993, 29.958832783000048],
              [-112.73600160299992, 29.98775407000005],
              [-112.73045813699991, 30.013373114000046],
              [-112.73794511599993, 30.02802155200004],
              [-112.74693762899994, 30.04169342700004],
              [-112.75881512299992, 30.05918058000009],
              [-112.7596118909999, 30.076086279000037],
              [-112.75276508699994, 30.129403427000057],
              [-112.75323596999993, 30.18588295300009],
              [-112.76429326199991, 30.211519729000088],
              [-112.77961668199993, 30.229884284000036],
              [-112.79575359299992, 30.246732371000064],
              [-112.8089489699999, 30.258582947000036],
              [-112.82878431299991, 30.269181114000048],
              [-112.83679020799991, 30.26976390300007],
              [-112.84626318499994, 30.271593642000084],
              [-112.85491512899995, 30.262755919000085],
              [-112.8607896609999, 30.268998923000083],
              [-112.84859448399993, 30.28852973800008],
              [-112.84664665199995, 30.31928542500009],
              [-112.84774316099993, 30.36134532400007],
              [-112.85602779899995, 30.40058014500005],
              [-112.8706762359999, 30.428534247000073],
              [-112.91539562299994, 30.475129516000038],
              [-112.98654348699989, 30.532351902000073],
              [-113.04125758899994, 30.608531018000065],
              [-113.0798948549999, 30.670441074000053],
              [-113.11385972799991, 30.78117956400007],
              [-113.12884060399995, 30.812439603000087],
              [-113.11090794899991, 30.84333253400007],
              [-113.09994055899995, 30.906834639000067],
              [-113.09735918199993, 30.946007914000063],
              [-113.0999214119999, 30.979240707000088],
              [-113.13078295499992, 31.05054715700004],
              [-113.13096083199991, 31.06498964700006],
              [-113.12291450999993, 31.066933307000056],
              [-113.11619285799992, 31.056936244000042],
              [-113.1123903759999, 31.04566256700008],
              [-113.10408048799991, 31.025008694000064],
              [-113.0898196259999, 30.993121915000074],
              [-113.08318710399993, 30.98940785800005],
              [-113.07677161399994, 30.99705638200004],
              [-113.05589758999992, 31.03070709800005],
              [-113.05379930499993, 31.078891088000034],
              [-113.05352467799992, 31.123423225000067],
              [-113.04872293699992, 31.156691667000075],
              [-113.06942216999994, 31.172218187000055],
              [-113.09174437099995, 31.20215244700006],
              [-113.11686949799991, 31.217645212000036],
              [-113.14549627999992, 31.219293245000074],
              [-113.1439423349999, 31.209906639000053],
              [-113.12847332299992, 31.203138636000062],
              [-113.11667699399993, 31.197588884000083],
              [-113.12099381799993, 31.190025639000055],
              [-113.13867242299995, 31.19553327500006],
              [-113.15563542099994, 31.204797162000034],
              [-113.19704639399993, 31.225187791000053],
              [-113.20864824099993, 31.248439846000053],
              [-113.2219945949999, 31.26040273600006],
              [-113.23289954299992, 31.288031317000048],
              [-113.24583899599992, 31.286932684000078],
              [-113.26170813699991, 31.280585028000075],
              [-113.27599036399994, 31.278265692000048],
              [-113.26431230399993, 31.262844143000052],
              [-113.2520238919999, 31.25604889500005],
              [-113.2378637359999, 31.251776434000078],
              [-113.22934889999993, 31.245095622000065],
              [-113.24144437899992, 31.24123975400005],
              [-113.27839107999989, 31.25063711100006],
              [-113.43402415499992, 31.276236063000056],
              [-113.48185810299992, 31.286450397000067],
              [-113.5489479009999, 31.295700208000085],
              [-113.55846418199991, 31.315613273000054],
              [-113.58537856599992, 31.323163873000055],
              [-113.62226888899994, 31.325583966000067],
              [-113.6434923999999, 31.341774799000063],
              [-113.6368837689999, 31.347576984000057],
              [-113.61839489499994, 31.344939871000065],
              [-113.60930600799992, 31.35291513100009],
              [-113.61961829299992, 31.381781317000048],
              [-113.63583192699991, 31.434851190000074],
              [-113.63467582499993, 31.46562658600004],
              [-113.65957666299994, 31.497539584000037],
              [-113.7135878329999, 31.53190230100006],
              [-113.75754479999995, 31.549214858000084],
              [-113.77458153099991, 31.563314466000065],
              [-113.80398738199995, 31.56435300700008],
              [-113.84886683399992, 31.584509310000044],
              [-113.87572180899991, 31.59674713700008],
              [-113.88487708199995, 31.61469147300005],
              [-113.91299394399994, 31.604641018000052],
              [-113.92617753799993, 31.60146719000005],
              [-113.9395238919999, 31.600409247000073],
              [-113.9578344389999, 31.61595286700009],
              [-113.96251380099994, 31.655218817000048],
              [-113.97769120999993, 31.66307200700004],
              [-113.98037675699993, 31.65029531500005],
              [-113.97988847599993, 31.59593333500004],
              [-113.98106848899994, 31.586737372000073],
              [-113.97402910099993, 31.57908763200004],
              [-113.96678626199991, 31.577053127000056],
              [-113.96141516799992, 31.578111070000034],
              [-113.96003170499989, 31.579901434000078],
              [-113.95099850199995, 31.568019924000055],
              [-113.95470130099994, 31.565659898000035],
              [-113.96288001199991, 31.562892971000053],
              [-113.9796687569999, 31.545206483000072],
              [-113.98276729899993, 31.53228497200007],
              [-113.99273998399991, 31.527129052000078],
              [-114.00530278799994, 31.52550970100009],
              [-114.01040605399993, 31.51626211100006],
              [-114.01500403599994, 31.51072825700004],
              [-114.01878821499992, 31.504055080000057],
              [-114.02894224699992, 31.491539208000063],
              [-114.07140051999994, 31.492010809000078],
              [-114.11787302699992, 31.492307933000063],
              [-114.15901272199994, 31.494508617000065],
              [-114.20888787799993, 31.512283403000083],
              [-114.23195014399994, 31.53048824800004],
              [-114.2598166869999, 31.53859757400005],
              [-114.2878448059999, 31.552430480000055],
              [-114.29813273499991, 31.56155198400006],
              [-114.3120824859999, 31.575873114000046],
              [-114.32466449299994, 31.58255204900007],
              [-114.3274803949999, 31.594665150000083],
              [-114.36054094899993, 31.608374101000038],
              [-114.41254249399992, 31.63525916800006],
              [-114.43212594399989, 31.646343159000082],
              [-114.44813648399992, 31.648910226000055],
              [-114.4612286919999, 31.66725917900004],
              [-114.49426315499994, 31.677366307000057],
              [-114.5406792949999, 31.717235522000067],
              [-114.58471181099992, 31.76075482400006],
              [-114.60391191299993, 31.765326239000046],
              [-114.67723548099991, 31.764064846000053],
              [-114.6868383449999, 31.76552969000005],
              [-114.69591223899994, 31.77106354400007],
              [-114.7144262359999, 31.78851959800005],
              [-114.71751868399991, 31.792222398000035],
              [-114.72704016799992, 31.795477606000077],
              [-114.74697831899994, 31.81000397300005],
              [-114.75885982999989, 31.813299872000073],
              [-114.79360917899993, 31.816555080000057],
              [-114.8035375639999, 31.819525458000044],
              [-114.81696529899995, 31.830471096000053],
              [-114.8426000639999, 31.86151764500005],
              [-114.8550512359999, 31.86790599200009],
              [-114.87572180899991, 31.87295156500005],
              [-114.9336238269999, 31.908758856000077],
              [-114.93382727799991, 31.90888092700004],
              [-114.95612545499989, 31.918117580000057],
              [-114.96841386599993, 31.92133209800005],
              [-114.98135331899994, 31.92255280200004],
              [-114.99132239499994, 31.92479075700004],
              [-115.00584876199991, 31.93455638200004],
              [-115.01207434799994, 31.936835028000075],
              [-115.0156957669999, 31.942206122000073],
              [-115.01748613199993, 31.95384349200009],
              [-115.0210668609999, 31.96556224200009],
              [-115.02944902299993, 31.97093333500004],
              [-115.0352270169999, 31.966050523000035],
              [-115.0347387359999, 31.954738674000055],
              [-115.03062903599994, 31.94208405200004],
              [-115.01622473899994, 31.919094143000052],
              [-115.01195227799991, 31.91474030200004],
              [-115.00210527299993, 31.90888092700004],
              [-114.99453691299993, 31.90656159100007],
              [-114.96861731699994, 31.902085679000038],
              [-114.95132402299993, 31.894476630000042],
              [-114.93618730399993, 31.884751695000034],
              [-114.92345130099994, 31.873521226000037],
              [-114.9134008449999, 31.861070054000038],
              [-114.88895799699992, 31.856349653000052],
              [-114.87001782199991, 31.839946936000047],
              [-114.85617742699992, 31.82223032400009],
              [-114.84943600199995, 31.80609772300005],
              [-114.83503170499989, 31.801906643000052],
              [-114.82799231699994, 31.78978099200009],
              [-114.8159887359999, 31.719142971000053],
              [-114.8074438139999, 31.69830963700008],
              [-114.79295813699991, 31.67926666900007],
              [-114.78062903599994, 31.65582916900007],
              [-114.7886449859999, 31.63617584800005],
              [-114.82396399599992, 31.600409247000073],
              [-114.8411352199999, 31.566839911000045],
              [-114.85291027199992, 31.52660633700009],
              [-114.8523104819999, 31.38942978700004],
              [-114.87519857299992, 31.32870151600008],
              [-114.87262745599992, 31.27266680100007],
              [-114.88378307499994, 31.182244539000067],
              [-114.88867790299992, 31.162892087000046],
              [-114.88404305299991, 31.120715433000044],
              [-114.86390442999993, 31.08967322600006],
              [-114.83816541399995, 31.066614429000083],
              [-114.81347095899991, 31.049985552000066],
              [-114.81493081199994, 31.042799895000087],
              [-114.83291581899994, 31.027411200000074],
              [-114.83238684799994, 31.006659247000073],
              [-114.82176673099991, 30.98895905200004],
              [-114.8035375639999, 30.976629950000074],
              [-114.73633589299993, 30.949346628000058],
              [-114.72025889999992, 30.94109777600005],
              [-114.71676455499994, 30.935448835000045],
              [-114.71489978199992, 30.928336923000074],
              [-114.71045177299993, 30.918416053000044],
              [-114.70909583199995, 30.88495514500005],
              [-114.70791581899994, 30.874212958000044],
              [-114.70460154599994, 30.858455784000057],
              [-114.70919746399994, 30.844058200000063],
              [-114.70393717199994, 30.83485963600009],
              [-114.6968593599999, 30.81998463700006],
              [-114.7005817999999, 30.774816066000085],
              [-114.69519630199994, 30.761302603000047],
              [-114.68724167599993, 30.74499434200004],
              [-114.69365411399991, 30.736264899000048],
              [-114.70546817299993, 30.711718878000056],
              [-114.6964451899999, 30.687496928000087],
              [-114.6918914019999, 30.670999803000086],
              [-114.69847440399991, 30.63721156300005],
              [-114.68432607299991, 30.60676519100008],
              [-114.66182491199993, 30.574336929000083],
              [-114.6496461299999, 30.55456087300007],
              [-114.6485476609999, 30.54385678300008],
              [-114.6460668609999, 30.534491278000075],
              [-114.64525305899991, 30.52411530200004],
              [-114.64028886599993, 30.513006903000075],
              [-114.63059863899991, 30.494874103000086],
              [-114.63020674299992, 30.48057745600005],
              [-114.6380553269999, 30.463267685000062],
              [-114.63663632599992, 30.441838472000086],
              [-114.62952016399993, 30.42480280500007],
              [-114.63454925499991, 30.396789634000072],
              [-114.6406021119999, 30.37521455800004],
              [-114.6353137029999, 30.36456150400005],
              [-114.64396295699993, 30.313731103000066],
              [-114.65151933499993, 30.29645416900007],
              [-114.65269934799994, 30.288275458000044],
              [-114.65094967399995, 30.277004299000055],
              [-114.6401163249999, 30.263756544000046],
              [-114.64476814599993, 30.25002687400007],
              [-114.6515823009999, 30.22848386700008],
              [-114.6553015319999, 30.21339781800009],
              [-114.66573313099991, 30.19956817600007],
              [-114.6603023049999, 30.183252241000048],
              [-114.65264408799993, 30.174826159000077],
              [-114.64217386799993, 30.155028462000075],
              [-114.63068600199995, 30.144517320000034],
              [-114.63078309199994, 30.132384926000043],
              [-114.6246008249999, 30.11749534100005],
              [-114.6045333269999, 30.11074138300006],
              [-114.59655075799992, 30.089450043000056],
              [-114.5803775149999, 30.072604697000088],
              [-114.58143418399993, 30.05111713000008],
              [-114.55814530999993, 30.01763005400005],
              [-114.54429788099992, 29.991680126000063],
              [-114.5331320869999, 29.967950990000077],
              [-114.48130631299995, 29.94729923700004],
              [-114.4726984219999, 29.91897398100008],
              [-114.4593406219999, 29.91011513400008],
              [-114.42771934599995, 29.90729511400008],
              [-114.4168355079999, 29.89119658900006],
              [-114.40879484399994, 29.88094200100005],
              [-114.41509688899993, 29.85476649700007],
              [-114.4030280149999, 29.832824062000043],
              [-114.39629715199993, 29.827228182000056],
              [-114.4031923949999, 29.82684166200005],
              [-114.40863389799995, 29.82137416000006],
              [-114.4094385219999, 29.815433021000047],
              [-114.39825717899993, 29.809706831000085],
              [-114.39608070899993, 29.805173136000064],
              [-114.3958175539999, 29.796110630000044],
              [-114.3922400109999, 29.78301160700005],
              [-114.38125128399992, 29.774451764000048],
              [-114.3710969579999, 29.770169518000046],
              [-114.36314417999989, 29.77206443400007],
              [-114.3532632269999, 29.76801799900005],
              [-114.34585134899993, 29.758730986000046],
              [-114.34584939799993, 29.75158638700009],
              [-114.33954217999991, 29.74472279400004],
              [-114.32252564099991, 29.741100531000086],
              [-114.3041387909999, 29.741566686000056],
              [-114.29704342399992, 29.742350247000047],
              [-114.2888110959999, 29.74829283200006],
              [-114.28796125699989, 29.753019733000087],
              [-114.28606085799993, 29.756618538000055],
              [-114.2923423439999, 29.757059515000037],
              [-114.2939852259999, 29.761344352000037],
              [-114.2928866289999, 29.766585621000047],
              [-114.28552387499991, 29.76568218400007],
              [-114.28302061999995, 29.76993340300004],
              [-114.28053984499991, 29.772066592000044],
              [-114.27865029399993, 29.77042683800005],
              [-114.2737163779999, 29.770190263000075],
              [-114.27121498399993, 29.77206841800006],
              [-114.26577682499993, 29.769246516000067],
              [-114.26330383999994, 29.764716623000083],
              [-114.2602468909999, 29.76539764000006],
              [-114.25755018899991, 29.760431100000062],
              [-114.25394764299995, 29.762067783000077],
              [-114.24347797099995, 29.762985342000036],
              [-114.2359051659999, 29.75859979900008],
              [-114.22768398699992, 29.750007879000066],
              [-114.2211022599999, 29.749059239000076],
              [-114.2202910179999, 29.746404531000053],
              [-114.20848461399993, 29.744775323000056],
              [-114.20330972099993, 29.73973405600009],
              [-114.2003223609999, 29.727354191000074],
              [-114.19623476999993, 29.721877324000047],
              [-114.1904749549999, 29.71997331400007],
              [-114.1872057039999, 29.714262681000037],
              [-114.18331533999992, 29.712833956000054],
              [-114.18170877499995, 29.70950057600004],
              [-114.17893178899993, 29.707592270000077],
              [-114.17537240999991, 29.704731150000043],
              [-114.1701489319999, 29.70234167700005],
              [-114.16494813799994, 29.700193872000057],
              [-114.1605674299999, 29.692328264000082],
              [-114.15783263299994, 29.690420938000045],
              [-114.15233361299994, 29.69255421400004],
              [-114.1504069209999, 29.69397975800007],
              [-114.14260456499994, 29.690668948000052],
              [-114.14125198999994, 29.682821113000045],
              [-114.13261563799995, 29.67656753400007],
              [-114.13201136899994, 29.670936835000077],
              [-114.12658097799994, 29.67035985600006],
              [-114.11870860199991, 29.662991220000038],
              [-114.11237498999992, 29.656055207000065],
              [-114.11122268299994, 29.653061758000035],
              [-114.09738607299994, 29.64796569200007],
              [-114.09020257799995, 29.64244161000005],
              [-114.08222569599991, 29.640981993000082],
              [-114.06265575299994, 29.62931622800005],
              [-114.05938861099992, 29.616669048000063],
              [-114.05638653699992, 29.612137577000055],
              [-114.0503782969999, 29.605218922000063],
              [-114.04627592999992, 29.59637626600005],
              [-114.03259000799994, 29.594428926000035],
              [-114.03039580399991, 29.593208578000088],
              [-114.02768056999992, 29.587264548000064],
              [-114.02304844199995, 29.584202874000084],
              [-114.02250896599992, 29.58134116800005],
              [-114.01486293499994, 29.57795358900006],
              [-114.00557394999993, 29.576748600000087],
              [-113.9943335189999, 29.576981853000063],
              [-113.98128726399995, 29.56789557600007],
              [-113.97419358499991, 29.556943620000084],
              [-113.9655240589999, 29.546708029000058],
              [-113.95806459999994, 29.54023562000009],
              [-113.95200340399992, 29.53877545000006],
              [-113.94313459799992, 29.524751897000044],
              [-113.93050161499991, 29.520161322000035],
              [-113.92247687999992, 29.512402578000035],
              [-113.9108775229999, 29.500628559000063],
              [-113.8974643819999, 29.485649941000077],
              [-113.88031680799992, 29.477049733000058],
              [-113.86504741599992, 29.463655595000034],
              [-113.85032356099993, 29.45878683500007],
              [-113.83866529499994, 29.456602332000045],
              [-113.8319489289999, 29.450170392000075],
              [-113.83267400199992, 29.435245228000042],
              [-113.8247526589999, 29.429886443000044],
              [-113.81310704299995, 29.428236665000043],
              [-113.80388811199992, 29.42444512900005],
              [-113.7966315239999, 29.41643690400008],
              [-113.78738641299992, 29.41476858300007],
              [-113.7708664939999, 29.407756444000086],
              [-113.68083996199994, 29.31599844400006],
              [-113.64851685399992, 29.293960740000045],
              [-113.63633087599993, 29.28217876100007],
              [-113.63157910099994, 29.263960920000045],
              [-113.62486924199993, 29.25860173400008],
              [-113.62307566099992, 29.252714105000052],
              [-113.63848133399995, 29.24048414500004],
              [-113.64732052099993, 29.22800495100006],
              [-113.6565573389999, 29.218440144000056],
              [-113.65533690299992, 29.20732339500006],
              [-113.64611809699994, 29.202034654000045],
              [-113.63834952499991, 29.198636264000072],
              [-113.6413775549999, 29.183833347000075],
              [-113.63223100199991, 29.173680200000035],
              [-113.6285476189999, 29.175265809000052],
              [-113.6249179209999, 29.169906257000036],
              [-113.62436439899994, 29.162424688000044],
              [-113.61396471099994, 29.162374683000053],
              [-113.60844984499994, 29.163416270000084],
              [-113.60851743599994, 29.154337611000074],
              [-113.60205169199992, 29.140883879000057],
              [-113.59105402199992, 29.129121034000036],
              [-113.5793736139999, 29.126417711000045],
              [-113.5708806859999, 29.115163004000067],
              [-113.56432916599994, 29.09163434800007],
              [-113.54740057299995, 29.065372281000066],
              [-113.5358838379999, 29.051420258000064],
              [-113.5396418329999, 29.039615325000057],
              [-113.5500342549999, 29.03860904600009],
              [-113.55621723199994, 29.027955902000087],
              [-113.5617177389999, 29.02367245700009],
              [-113.56359855099993, 29.01404163600006],
              [-113.56186517599991, 29.00014632300008],
              [-113.54974340399991, 28.993182009000066],
              [-113.54498766699993, 28.97552676300006],
              [-113.5469384989999, 28.958981665000067],
              [-113.55547336299992, 28.955259039000055],
              [-113.55787555699993, 28.948253316000034],
              [-113.54648633099993, 28.93332237700008],
              [-113.54049564899992, 28.92048705800005],
              [-113.5338860039999, 28.906565173000047],
              [-113.52600651299991, 28.90118472200004],
              [-113.5248536869999, 28.891565685000046],
              [-113.50477064899991, 28.889319670000077],
              [-113.48153775999992, 28.893398388000037],
              [-113.47722925499994, 28.898159433000046],
              [-113.47902902499993, 28.90190909800009],
              [-113.47221267599991, 28.915174921000073],
              [-113.4831470179999, 28.921696566000037],
              [-113.48797278899991, 28.930302828000038],
              [-113.48061931699993, 28.933431489000043],
              [-113.48301991599993, 28.939342175000036],
              [-113.4786930279999, 28.946247890000052],
              [-113.47318724799993, 28.947796431000086],
              [-113.46222113599993, 28.946654498000044],
              [-113.4500639709999, 28.942290453000055],
              [-113.4402310619999, 28.95133313000008],
              [-113.4346645949999, 28.95987356200004],
              [-113.42621755999994, 28.94913925800006],
              [-113.4287896219999, 28.934712853000065],
              [-113.4130520999999, 28.922322388000055],
              [-113.4062853669999, 28.927115752000077],
              [-113.40562230599994, 28.932984210000086],
              [-113.3878709899999, 28.93980408200008],
              [-113.38303097999994, 28.935499448000087],
              [-113.3867350939999, 28.930719804000034],
              [-113.39102408499991, 28.928613701000074],
              [-113.3942271549999, 28.913138573000083],
              [-113.36743928499993, 28.907096091000085],
              [-113.36809913999991, 28.901762658000052],
              [-113.37912064799991, 28.90021308000007],
              [-113.38041793299993, 28.89327594100007],
              [-113.37251178899993, 28.886313569000038],
              [-113.36832431099992, 28.877743557000088],
              [-113.3592152459999, 28.873942552000074],
              [-113.36597138899992, 28.868652111000074],
              [-113.36728899199994, 28.85851929100005],
              [-113.36746177599991, 28.845178073000056],
              [-113.3706328159999, 28.837205767000057],
              [-113.3652901889999, 28.82384416600007],
              [-113.35184894899993, 28.818386459000067],
              [-113.3544759259999, 28.80027413600004],
              [-113.33249379299991, 28.800621422000063],
              [-113.30997057699994, 28.80206361100005],
              [-113.3020358849999, 28.80895356800005],
              [-113.29100553399991, 28.819009772000072],
              [-113.28543402499992, 28.825897953000037],
              [-113.26849109299991, 28.832179781000036],
              [-113.26038606499992, 28.840106827000056],
              [-113.23409901899993, 28.83562315000006],
              [-113.22026346799993, 28.82484253800004],
              [-113.21415887299992, 28.81731173500009],
              [-113.21184305999992, 28.802874366000083],
              [-113.2026626569999, 28.798512799000036],
              [-113.19604389299991, 28.792052096000077],
              [-113.19987939299995, 28.77981460500007],
              [-113.1914012389999, 28.772794082000075],
              [-113.19037758199994, 28.759452771000042],
              [-113.19424051499993, 28.744019945000048],
              [-113.18198898399993, 28.715733758000056],
              [-113.17585970099992, 28.71351321900005],
              [-113.16989219899995, 28.69151906400009],
              [-113.15604596899993, 28.657625721000045],
              [-113.13235426799992, 28.64130317200005],
              [-113.1269917159999, 28.62786949200006],
              [-113.1316091999999, 28.604583012000035],
              [-113.12098288599992, 28.578888678000055],
              [-113.11629357999993, 28.565513819000046],
              [-113.1116573789999, 28.545722047000083],
              [-113.1142866919999, 28.52813541000006],
              [-113.10297024099992, 28.504583284000034],
              [-113.08249857499993, 28.493182379000075],
              [-113.08072342399993, 28.486809703000063],
              [-113.06323616599991, 28.479690770000047],
              [-113.03961725199991, 28.476230324000085],
              [-113.03609809199992, 28.46660714400008],
              [-113.00163877299991, 28.455578548000062],
              [-112.97126836899992, 28.456328013000075],
              [-112.9304540689999, 28.466580271000055],
              [-112.90236180099993, 28.475341649000086],
              [-112.88555896799994, 28.463433553000073],
              [-112.88689549799994, 28.455982926000047],
              [-112.8760036029999, 28.450512122000077],
              [-112.87548447899991, 28.445175240000083],
              [-112.8817096979999, 28.437256879000074],
              [-112.87993848199994, 28.434580870000048],
              [-112.8677780139999, 28.432283916000074],
              [-112.86224681599992, 28.434876226000085],
              [-112.85788426599993, 28.441223928000056],
              [-112.84630402399995, 28.441077049000057],
              [-112.84705705199991, 28.430400821000035],
              [-112.84474164699992, 28.422386547000087],
              [-112.85149206699992, 28.41709671800004],
              [-112.85839338099993, 28.40384421400006],
              [-112.8541980839999, 28.397904676000053],
              [-112.84953198599993, 28.382344540000076],
              [-112.85398156799994, 28.368510023000056],
              [-112.87030194699992, 28.330779120000045],
              [-112.87426049399994, 28.30785618400006],
              [-112.8688666729999, 28.299726410000062],
              [-112.87212638099993, 28.28373952800007],
              [-112.86495773699994, 28.27183249500007],
              [-112.8530636459999, 28.260047718000067],
              [-112.8392245149999, 28.252418250000062],
              [-112.83784748199992, 28.243550708000043],
              [-112.80501663699994, 28.210680251000042],
              [-112.8002737199999, 28.203683743000056],
              [-112.7918269079999, 28.201475361000064],
              [-112.78645579599993, 28.19607740400005],
              [-112.79380891099993, 28.19026568000004],
              [-112.79571921999991, 28.183888823000075],
              [-112.79897243999994, 28.16843829600009],
              [-112.80389951899991, 28.162607920000085],
              [-112.80770636299991, 28.150914709000062],
              [-112.81177057199994, 28.120539654000083],
              [-112.80138952199991, 28.085751805000086],
              [-112.79842760199995, 28.081451504000086],
              [-112.79121588699991, 28.078168021000067],
              [-112.78955812299989, 28.067474823000055],
              [-112.79695627399991, 28.05795123000007],
              [-112.80370032499991, 28.045721747000073],
              [-112.80540930899991, 28.032049872000073],
              [-112.79936277699994, 28.01742390800007],
              [-112.78567680299994, 28.00286594000005],
              [-112.76876099899994, 28.002127270000074],
              [-112.76036220299994, 27.997756250000066],
              [-112.76116906599992, 27.98443003600005],
              [-112.75658468799992, 27.968385500000068],
              [-112.75725526799994, 27.963031241000067],
              [-112.76610996799991, 27.938125142000047],
              [-112.76216415099992, 27.91997664300004],
              [-112.76172583699991, 27.907640291000064],
              [-112.76302542399992, 27.901244906000045],
              [-112.76192114999992, 27.89372737000008],
              [-112.7667994279999, 27.890589222000074],
              [-112.76875037299993, 27.880418553000084],
              [-112.77321756299995, 27.86390215700004],
              [-112.7583870279999, 27.846107019000044],
              [-112.7428243899999, 27.837394733000053],
              [-112.73860307399991, 27.82957627400009],
              [-112.72544041499992, 27.822488923000037],
              [-112.72418081399991, 27.827303216000075],
              [-112.7193706349999, 27.826180209000086],
              [-112.71945059399991, 27.819208769000056],
              [-112.71299324699993, 27.806302205000065],
              [-112.71608556599995, 27.80045468600008],
              [-112.71512915999995, 27.783898672000078],
              [-112.70560823799991, 27.77740757400005],
              [-112.70875066499991, 27.767281714000035],
              [-112.7035312829999, 27.754959928000062],
              [-112.69286807899994, 27.742555740000057],
              [-112.67886308499993, 27.728583075000074],
              [-112.6703421069999, 27.717730224000036],
              [-112.66315435299992, 27.71497417900008],
              [-112.65782874299992, 27.708503498000084],
              [-112.6487627869999, 27.710528211000053],
              [-112.64334127099994, 27.71046183100009],
              [-112.63681321699994, 27.703974955000035],
              [-112.63274634099992, 27.694317683000065],
              [-112.62322043899991, 27.68726156400004],
              [-112.62112370799991, 27.678078158000062],
              [-112.5996262509999, 27.666613031000054],
              [-112.59800775899993, 27.654297399000086],
              [-112.56673706599992, 27.64144069000008],
              [-112.5439658329999, 27.640752276000057],
              [-112.52832251599995, 27.636730044000046],
              [-112.51575342799993, 27.62898394800004],
              [-112.49775516199992, 27.624407509000036],
              [-112.4852151959999, 27.620019726000066],
              [-112.47869482099992, 27.61403808500006],
              [-112.46682204599995, 27.605989652000062],
              [-112.4561297539999, 27.597824209000066],
              [-112.41833100199995, 27.589890091000086],
              [-112.40344192599991, 27.580606076000038],
              [-112.37310644999991, 27.56409536600006],
              [-112.35471357299991, 27.547323351000045],
              [-112.35320719399994, 27.533942855000078],
              [-112.33299561199993, 27.516593396000076],
              [-112.32376760999995, 27.494574088000036],
              [-112.31905047899994, 27.45928183500007],
              [-112.3205721299999, 27.443835574000047],
              [-112.3095306589999, 27.422317218000046],
              [-112.29901202799994, 27.405066796000085],
              [-112.30186336299994, 27.392880697000066],
              [-112.2973247239999, 27.38106210600006],
              [-112.28701288199994, 27.36582028500004],
              [-112.2707585199999, 27.35759566900009],
              [-112.26523524899994, 27.34197966800008],
              [-112.25804392499992, 27.330599016000065],
              [-112.24170787799994, 27.326584052000044],
              [-112.23612160099992, 27.31472329500008],
              [-112.23024259399995, 27.291104420000067],
              [-112.21768516499992, 27.283397535000063],
              [-112.20700211899992, 27.261130164000065],
              [-112.19557922199994, 27.250129257000083],
              [-112.20276064599994, 27.23058867000009],
              [-112.2076565509999, 27.22586418700007],
              [-112.21140513199992, 27.218450645000075],
              [-112.2127636969999, 27.210462858000085],
              [-112.19438566799994, 27.19895536000007],
              [-112.18142696199993, 27.187016804000052],
              [-112.16966093999991, 27.17562982600009],
              [-112.16494706899994, 27.166815497000073],
              [-112.1549368929999, 27.162046299000053],
              [-112.1339552359999, 27.16007058200006],
              [-112.11453437699993, 27.142147339000076],
              [-112.08893937699992, 27.131560293000064],
              [-112.06786218999991, 27.13385171100009],
              [-112.06437318499991, 27.12845043100009],
              [-112.05425980099994, 27.124002316000087],
              [-112.01116812399994, 27.11683140200006],
              [-111.99358450799991, 27.096208304000072],
              [-111.95994125599992, 27.095590478000076],
              [-111.95037230399993, 27.09327554400005],
              [-111.95173822999993, 27.085276192000038],
              [-111.94645295399994, 27.079294951000065],
              [-111.9442539399999, 27.069626075000087],
              [-111.95758810599995, 27.06452700200009],
              [-111.97015198799994, 27.067982150000034],
              [-111.9866059769999, 27.055968315000086],
              [-112.00312811499992, 27.035743279000087],
              [-112.01198769399991, 27.014497603000052],
              [-112.01473510599993, 26.99849793900006],
              [-112.0171606109999, 26.97850169500009],
              [-112.00145423099991, 26.95221588700008],
              [-111.98338782499991, 26.94090403900009],
              [-111.9739477199999, 26.93691640800006],
              [-111.97142493399991, 26.92804596600007],
              [-111.95735630699994, 26.91097559600007],
              [-111.95179504499993, 26.89218398400004],
              [-111.94174717699991, 26.886665623000056],
              [-111.91559806299995, 26.87819769500004],
              [-111.9100428939999, 26.85888229200009],
              [-111.87071692599994, 26.828070380000042],
              [-111.86335955599992, 26.805189837000057],
              [-111.86070113999995, 26.790189540000085],
              [-111.8614463379999, 26.783795461000068],
              [-111.87239815599992, 26.776523094000083],
              [-111.87681012199994, 26.76645783400005],
              [-111.87762944399992, 26.756325443000037],
              [-111.8902074859999, 26.762925523000035],
              [-111.90518144399994, 26.73427969000005],
              [-111.90011415599992, 26.714559432000044],
              [-111.88597571499992, 26.71116771000004],
              [-111.86350943899993, 26.69305164800005],
              [-111.8530503429999, 26.67733572600008],
              [-111.84858091299992, 26.663902722000046],
              [-111.84710676799995, 26.655421526000055],
              [-111.84310283799994, 26.645158610000067],
              [-111.82461311499992, 26.639946536000082],
              [-111.81168619999994, 26.62899863800004],
              [-111.79822702599989, 26.61264708500005],
              [-111.78427506899993, 26.57179580600007],
              [-111.76179947499992, 26.553561570000056],
              [-111.73581048199992, 26.53968359600009],
              [-111.71455205399991, 26.551538640000047],
              [-111.67679283899992, 26.581858923000084],
              [-111.68007024499991, 26.593675962000077],
              [-111.69241301699992, 26.603013730000043],
              [-111.71460861299994, 26.629706987000077],
              [-111.74287770399991, 26.65275882900005],
              [-111.7570640859999, 26.659438916000056],
              [-111.76689067299992, 26.67621918100008],
              [-111.79412145999993, 26.690113248000046],
              [-111.80742126699994, 26.71552499900008],
              [-111.8145847749999, 26.714577386000087],
              [-111.81618941099993, 26.72261546900006],
              [-111.81361097799993, 26.731114451000053],
              [-111.81700334899995, 26.73918651200006],
              [-111.8167023869999, 26.766478085000074],
              [-111.8222361569999, 26.77882453600006],
              [-111.8232918569999, 26.792198666000047],
              [-111.8286838009999, 26.808293115000083],
              [-111.82364059799994, 26.820474768000054],
              [-111.83164448299993, 26.828640878000044],
              [-111.83690401899992, 26.834612744000083],
              [-111.83670356999994, 26.843154749000064],
              [-111.8401488689999, 26.849626261000083],
              [-111.84597625299995, 26.856675718000076],
              [-111.84511588399994, 26.867876480000064],
              [-111.8521677089999, 26.873878785000045],
              [-111.8514193179999, 26.880274807000035],
              [-111.83396966299995, 26.88316541900008],
              [-111.82660319299993, 26.89051092300008],
              [-111.81807339699992, 26.89623316400008],
              [-111.79509108899992, 26.884027951000064],
              [-111.79235385699991, 26.875419651000072],
              [-111.7681305619999, 26.86268218400005],
              [-111.74522936499994, 26.844098924000036],
              [-111.72907626499995, 26.822432899000034],
              [-111.72108205899991, 26.80626710900009],
              [-111.68012422099991, 26.778759020000052],
              [-111.66733722999993, 26.78055093100005],
              [-111.6628385489999, 26.768699070000082],
              [-111.65649062499995, 26.75892936100007],
              [-111.64887586799995, 26.752936608000084],
              [-111.64783119299994, 26.74647998000006],
              [-111.62589462099993, 26.739700568000046],
              [-111.62306345899992, 26.733213602000035],
              [-111.6082867099999, 26.726508451000086],
              [-111.6084201409999, 26.721133913000074],
              [-111.58474130799993, 26.71214750200005],
              [-111.57230284399992, 26.70763775100005],
              [-111.57009011799994, 26.700650711000037],
              [-111.56005494199991, 26.695653004000064],
              [-111.56427141799992, 26.67115759400008],
              [-111.56602752799989, 26.649299624000037],
              [-111.56304031699995, 26.62575408200007],
              [-111.56908004499991, 26.576233743000046],
              [-111.56477159499991, 26.558000735000064],
              [-111.54889526599993, 26.548600160000035],
              [-111.52461941999991, 26.540620121000075],
              [-111.50365149599992, 26.53310781500005],
              [-111.48241126199991, 26.528509833000044],
              [-111.47472670999991, 26.531034909000084],
              [-111.47280805199995, 26.535799007000037],
              [-111.46022113399994, 26.53766896500008],
              [-111.4610302879999, 26.529677131000085],
              [-111.45579128999992, 26.52476184300008],
              [-111.44223803999989, 26.517526],
              [-111.44891293599994, 26.51393641900006],
              [-111.45453024799991, 26.505522992000067],
              [-111.45567567099994, 26.486354034000044],
              [-111.4682474039999, 26.46643627800006],
              [-111.46643164199992, 26.440147032000084],
              [-111.4688668149999, 26.41950369300008],
              [-111.46155960399994, 26.400057229000083],
              [-111.43814042899993, 26.385972398000035],
              [-111.42848546199991, 26.382623873000057],
              [-111.42383490999993, 26.37715435800004],
              [-111.42277415599995, 26.371778583000037],
              [-111.4330745659999, 26.367970202000038],
              [-111.4323846229999, 26.36087458800006],
              [-111.4229681729999, 26.350371924000058],
              [-111.40642235999991, 26.34443760700009],
              [-111.39365646599992, 26.33001124900005],
              [-111.38794694599994, 26.31416570500005],
              [-111.38479089599991, 26.29988113400009],
              [-111.38192468599993, 26.277072565000083],
              [-111.39322345099993, 26.27799734100006],
              [-111.3974490679999, 26.25221458200008],
              [-111.38815054499992, 26.24269012600007],
              [-111.3874859519999, 26.234812349000038],
              [-111.37582308299994, 26.212549508000052],
              [-111.3796631859999, 26.200054110000053],
              [-111.37572080799993, 26.18345217500007],
              [-111.36452064199995, 26.176120365000088],
              [-111.35872567699994, 26.162611475000062],
              [-111.35919773299992, 26.14376037900007],
              [-111.35094657899992, 26.12631910400006],
              [-111.34177324399991, 26.110419525000054],
              [-111.32203732499994, 26.098183177000067],
              [-111.32321960199994, 26.086442515000044],
              [-111.31833767199993, 26.07373688100006],
              [-111.31948278399994, 26.06356014000005],
              [-111.32574412399993, 26.058970419000048],
              [-111.32779495599993, 26.048014418000037],
              [-111.34029172699991, 26.03886311100007],
              [-111.34494102999992, 26.02875127300007],
              [-111.33751007699993, 26.012859448000086],
              [-111.3373283929999, 25.987698037000087],
              [-111.34730720999994, 25.974555364000082],
              [-111.36025956899994, 25.964097398000035],
              [-111.3551195689999, 25.94484096800005],
              [-111.34935462099992, 25.92609284100007],
              [-111.33901933499993, 25.90843333500004],
              [-111.33576412699995, 25.89940013200004],
              [-111.3325467969999, 25.884906769000054],
              [-111.33889005799995, 25.873077970000054],
              [-111.33387169299994, 25.86593736900005],
              [-111.3310281649999, 25.837357703000066],
              [-111.32336933699992, 25.832578891000082],
              [-111.31783904899993, 25.833631856000068],
              [-111.31574059399992, 25.836201611000035],
              [-111.30871909799993, 25.831294614000058],
              [-111.30015613699993, 25.821149225000056],
              [-111.29745410399994, 25.81645897100009],
              [-111.29192322699993, 25.812265834000073],
              [-111.29676097399994, 25.807459515000062],
              [-111.30107736199994, 25.80789537600009],
              [-111.3057375599999, 25.81220876900005],
              [-111.30688057999993, 25.817424033000066],
              [-111.31539405299992, 25.820033626000054],
              [-111.3144254149999, 25.815138064000053],
              [-111.3106702749999, 25.80098475400007],
              [-111.3092957589999, 25.78926005200009],
              [-111.3071159779999, 25.779207115000077],
              [-111.30234029299993, 25.771518295000078],
              [-111.2894180969999, 25.764196377000076],
              [-111.27832250599994, 25.75065943900006],
              [-111.26289430599991, 25.74589037700008],
              [-111.25563802199991, 25.741656787000068],
              [-111.24733494499992, 25.731119748000083],
              [-111.24428167499991, 25.723302812000043],
              [-111.23660637699993, 25.719808552000075],
              [-111.23198651699994, 25.723769159000085],
              [-111.22500524899993, 25.724353272000087],
              [-111.21253283499993, 25.701567166000075],
              [-111.21518385299993, 25.694985539000072],
              [-111.2122588439999, 25.682742801000074],
              [-111.2069457529999, 25.668234098000084],
              [-111.20037312099993, 25.65404717000007],
              [-111.19999452199994, 25.639297878000036],
              [-111.19657165299992, 25.630370620000065],
              [-111.19174434199994, 25.61482905400004],
              [-111.1832250029999, 25.60261455600005],
              [-111.1723843829999, 25.594971869000062],
              [-111.1639584589999, 25.573333115000082],
              [-111.15092708399993, 25.57042483400005],
              [-111.14570204199993, 25.566220635000036],
              [-111.1450724629999, 25.558811150000054],
              [-111.1377696099999, 25.54428359600007],
              [-111.1289679119999, 25.53930911300006],
              [-111.12389617899993, 25.53032225600009],
              [-111.11380167899995, 25.525650048000045],
              [-111.10359122699992, 25.525409575000083],
              [-111.0998040369999, 25.529385405000085],
              [-111.0962175439999, 25.52597378900009],
              [-111.07662627699995, 25.52476807000005],
              [-111.06945330299993, 25.532353302000047],
              [-111.0674866739999, 25.529721777000077],
              [-111.0738514219999, 25.52174724100007],
              [-111.07193716599994, 25.517271013000084],
              [-111.06341274999994, 25.515221955000072],
              [-111.0591972339999, 25.51955262000007],
              [-111.05424799399992, 25.520904451000035],
              [-111.04865202399992, 25.516276281000046],
              [-111.0417227129999, 25.516087634000087],
              [-111.03912636199993, 25.520859563000045],
              [-111.03545226299991, 25.520775411000045],
              [-111.03186890099994, 25.51773533800008],
              [-111.01925629199991, 25.51524993700008],
              [-111.01462699199993, 25.50591594000008],
              [-111.02222263899995, 25.49870933400007],
              [-111.0148771389999, 25.483782587000064],
              [-111.01465475599991, 25.47750239800007],
              [-111.02054602599992, 25.47286160300007],
              [-111.01922067099991, 25.461747136000042],
              [-111.02627297499993, 25.458611932000053],
              [-111.02538886399992, 25.44715339700008],
              [-111.0202596019999, 25.440738810000084],
              [-111.0134413959999, 25.424029543000074],
              [-111.00381700999992, 25.416713064000078],
              [-111.00087452299994, 25.392673350000052],
              [-110.9966992329999, 25.38263792400005],
              [-110.98229971199993, 25.35941790800007],
              [-110.97954463199994, 25.342369421000058],
              [-110.9720132029999, 25.335186286000067],
              [-110.95580788099994, 25.32837536900007],
              [-110.9565628009999, 25.322690210000076],
              [-110.9473894329999, 25.315447737000056],
              [-110.94353495699994, 25.30758148700005],
              [-110.94685013399993, 25.30542192100006],
              [-110.94745394199992, 25.298009961000048],
              [-110.94067347899994, 25.29382645600009],
              [-110.9342615029999, 25.29114098200006],
              [-110.93677314299993, 25.28897993700008],
              [-110.9385392019999, 25.284203510000054],
              [-110.93466092099993, 25.27784373600008],
              [-110.9384734439999, 25.273128494000048],
              [-110.9425078189999, 25.273553124000045],
              [-110.94731552699994, 25.26181430400004],
              [-110.94591223899994, 25.255113023000035],
              [-110.9384755079999, 25.24578252000009],
              [-110.94001830699995, 25.23434559100008],
              [-110.93202366499992, 25.215313087000084],
              [-110.9228155379999, 25.21030192900008],
              [-110.91517487699991, 25.191988308000077],
              [-110.9084168089999, 25.186659156000076],
              [-110.90609344199993, 25.182161566000048],
              [-110.91271133899994, 25.17787876300008],
              [-110.91087343899994, 25.16015513800005],
              [-110.9044506599999, 25.143012755000086],
              [-110.89336097199993, 25.131662635000055],
              [-110.88010739899994, 25.12652946500009],
              [-110.8809937229999, 25.123970090000057],
              [-110.87423002499992, 25.118998902000044],
              [-110.8751604599999, 25.114967077000074],
              [-110.87367336699992, 25.110499902000072],
              [-110.86814316599992, 25.105186235000076],
              [-110.8679306549999, 25.098906733000035],
              [-110.86404203299992, 25.09290266100004],
              [-110.8616154209999, 25.07918850200008],
              [-110.84752552799995, 25.07366840600008],
              [-110.84644729199994, 25.06887901200008],
              [-110.82947336799992, 25.064698630000066],
              [-110.82357217299995, 25.058328327000083],
              [-110.82673856299994, 25.048018056000046],
              [-110.82169181099994, 25.041048241000055],
              [-110.8142316229999, 25.033190174000083],
              [-110.80208312799994, 25.031351138000048],
              [-110.7944642729999, 25.03059930900008],
              [-110.79382895999993, 25.034389542000042],
              [-110.7904544129999, 25.03679520500009],
              [-110.7833661969999, 25.032748908000087],
              [-110.77954396699994, 25.026462549000087],
              [-110.75779051099994, 25.012238703000037],
              [-110.75971041799994, 25.006549],
              [-110.75732610699993, 25.003472592000037],
              [-110.75833680499994, 24.997222811000086],
              [-110.75111824899994, 24.993705256000055],
              [-110.74921469399993, 24.98726582900008],
              [-110.7487723569999, 24.97392480600007],
              [-110.74724089299991, 24.96379028100006],
              [-110.7344792479999, 24.95226277100005],
              [-110.72790315399993, 24.94085809900008],
              [-110.7182080849999, 24.930105998000045],
              [-110.71918661599994, 24.924158737000084],
              [-110.71080933699994, 24.920442592000086],
              [-110.70536822999992, 24.921015192000084],
              [-110.70162925999995, 24.917408268000088],
              [-110.69863228399993, 24.914527744000054],
              [-110.7002429389999, 24.912812595000048],
              [-110.7057104989999, 24.911541904000046],
              [-110.70851481699992, 24.90880644300006],
              [-110.70432131599995, 24.906952197000066],
              [-110.70450408699992, 24.901702002000036],
              [-110.6905329739999, 24.891886380000074],
              [-110.69071026799992, 24.88698924600004],
              [-110.68386845399993, 24.882959352000057],
              [-110.68746287599993, 24.87990502000008],
              [-110.6879773959999, 24.87501916700006],
              [-110.6843065729999, 24.86826453900005],
              [-110.68285511099992, 24.86542333300008],
              [-110.68434109799995, 24.857073424000077],
              [-110.6787565429999, 24.84991078900009],
              [-110.6747193619999, 24.843142748000048],
              [-110.6741720849999, 24.836833253000066],
              [-110.67365076899995, 24.829828839000072],
              [-110.66729954499993, 24.82299417900009],
              [-110.66516868899993, 24.81625803500009],
              [-110.6641824159999, 24.810975559000042],
              [-110.66154374099995, 24.808795350000082],
              [-110.65883229799994, 24.809071516000074],
              [-110.6569723799999, 24.80691821700009],
              [-110.66068410999992, 24.799661726000068],
              [-110.66168409999995, 24.793042481000043],
              [-110.66029804199991, 24.789180078000072],
              [-110.66389220199994, 24.775693905000082],
              [-110.66452420399992, 24.76472117600008],
              [-110.67913514299994, 24.74776696500004],
              [-110.68720848099991, 24.730660767000074],
              [-110.6910372989999, 24.719232213000055],
              [-110.68843762299991, 24.710239002000037],
              [-110.69398336599994, 24.699878561000048],
              [-110.70912027899993, 24.697604311000077],
              [-110.72352753199993, 24.68117784800006],
              [-110.72931377399993, 24.662464433000082],
              [-110.73297911399993, 24.638413615000047],
              [-110.73931361899992, 24.621252694000077],
              [-110.73880290699992, 24.601292125000043],
              [-110.73980203899993, 24.58819611100006],
              [-110.7351730449999, 24.570233039000072],
              [-110.73261105699993, 24.56070943700007],
              [-110.7385851979999, 24.55457229600006],
              [-110.7348722299999, 24.544500973000083],
              [-110.7286479949999, 24.522280589000047],
              [-110.7288553549999, 24.515989407000063],
              [-110.72172014599994, 24.504776451000055],
              [-110.6872001889999, 24.46603883100005],
              [-110.68569902299993, 24.45416901200008],
              [-110.68436073599992, 24.44425082500004],
              [-110.69211348999994, 24.43549964300007],
              [-110.6924865439999, 24.42395640300009],
              [-110.68874080899991, 24.41546953900007],
              [-110.69359578199993, 24.40771584400005],
              [-110.68643741999995, 24.39809297700009],
              [-110.68149919299992, 24.390615316000037],
              [-110.68350771399992, 24.38173292600004],
              [-110.67860185099994, 24.373202029000083],
              [-110.68184913499994, 24.360659657000042],
              [-110.6552310589999, 24.328967275000082],
              [-110.6536781929999, 24.323143650000077],
              [-110.63842648899993, 24.314865990000044],
              [-110.64147482499993, 24.309167794000075],
              [-110.62844393799992, 24.284665595000035],
              [-110.61511532899993, 24.269087751000086],
              [-110.6098897579999, 24.25372496400007],
              [-110.59803011399993, 24.24709788800004],
              [-110.5810012419999, 24.24031091200004],
              [-110.57688516499991, 24.22551413000008],
              [-110.56498777299993, 24.21992245200005],
              [-110.56235863899991, 24.21250286500009],
              [-110.53962269499993, 24.20398902000005],
              [-110.51158606699994, 24.195746161000045],
              [-110.48570716099994, 24.19013092700004],
              [-110.45285591899994, 24.18261551200004],
              [-110.40208899599992, 24.175523179000038],
              [-110.34935462099992, 24.17674388200004],
              [-110.33018958199995, 24.17719147300005],
              [-110.32519519399995, 24.175709083000072],
              [-110.32714821699994, 24.16946414100005],
              [-110.33781465399994, 24.160845986000083],
              [-110.3524209819999, 24.15497317800009],
              [-110.36930986899995, 24.14969295600008],
              [-110.37893509899993, 24.154709877000073],
              [-110.40383853999992, 24.16752658100006],
              [-110.4324285859999, 24.17361708100009],
              [-110.43377937799994, 24.167880681000042],
              [-110.4253968669999, 24.160277785000062],
              [-110.42937795699993, 24.14516814700005],
              [-110.42103818599992, 24.136519105000048],
              [-110.41730290699991, 24.128009113000076],
              [-110.42276394599992, 24.120304374000057],
              [-110.4168366209999, 24.108575691000055],
              [-110.39269389099991, 24.106242929000075],
              [-110.37055817299989, 24.113467250000042],
              [-110.36085696899994, 24.111082928000087],
              [-110.35038095699991, 24.11445597800008],
              [-110.34952413699995, 24.12230747800004],
              [-110.3485964699999, 24.13226072100008],
              [-110.34718656599995, 24.139573845000086],
              [-110.3430305259999, 24.143129078000072],
              [-110.32410454699993, 24.157282286000054],
              [-110.3061342499999, 24.176715521000062],
              [-110.3008107089999, 24.217041665000067],
              [-110.31218650599993, 24.218409801000064],
              [-110.3107321359999, 24.228354515000035],
              [-110.30988549599994, 24.237264481000068],
              [-110.31832545599991, 24.241185814000062],
              [-110.32456775499992, 24.24504780400008],
              [-110.32159915099993, 24.248640057000046],
              [-110.3207529099999, 24.25649033400009],
              [-110.32213925999991, 24.265455974000076],
              [-110.32778975299993, 24.267722026000058],
              [-110.3299002629999, 24.25728212900009],
              [-110.33625864599992, 24.25589169400007],
              [-110.33900172799991, 24.274881183000048],
              [-110.33474854899993, 24.28105749200006],
              [-110.33857606099991, 24.28694784000004],
              [-110.33420524699994, 24.296275783000056],
              [-110.3380538539999, 24.301641027000073],
              [-110.33600703499991, 24.31051144500009],
              [-110.33927957599991, 24.315859706000083],
              [-110.32484683299992, 24.315964730000076],
              [-110.32121864999993, 24.32058708200009],
              [-110.32919738699991, 24.323446282000077],
              [-110.33247026099991, 24.32879474400005],
              [-110.32357701599994, 24.335366192000038],
              [-110.30906495199991, 24.33757043500009],
              [-110.30134633299991, 24.343648649000045],
              [-110.29699734799993, 24.35193158000004],
              [-110.27623718699994, 24.350801266000076],
              [-110.24985108499993, 24.345818524000038],
              [-110.24619986599993, 24.350445393000086],
              [-110.2326133929999, 24.343205646000058],
              [-110.22884539899991, 24.335734064000064],
              [-110.23535030699992, 24.332243562000087],
              [-110.23638444499994, 24.32018418100006],
              [-110.2308422349999, 24.31318989400006],
              [-110.21971967199994, 24.310163291000038],
              [-110.21139906699995, 24.300419437000073],
              [-110.20000023599994, 24.296919312000057],
              [-110.19215585599994, 24.29035390000007],
              [-110.18391404499994, 24.279612874000065],
              [-110.1836995619999, 24.269626624000068],
              [-110.17652018799993, 24.260442942000054],
              [-110.17276033399992, 24.252975845000037],
              [-110.14599109799991, 24.245907456000054],
              [-110.1359249919999, 24.237716017000082],
              [-110.12591865099989, 24.22794804600005],
              [-110.11735334999992, 24.22611362500004],
              [-110.10041240699991, 24.21716146600005],
              [-110.08723055199994, 24.215752725000073],
              [-110.0838979689999, 24.212493301000052],
              [-110.07714014399994, 24.208578556000077],
              [-110.07340997199992, 24.20103516900008],
              [-110.06258136299994, 24.198124319000044],
              [-110.0588517999999, 24.190630484000053],
              [-110.04634709499993, 24.185588287000087],
              [-110.03167222999991, 24.177080524000075],
              [-110.0181381189999, 24.169279489000076],
              [-110.00698532699994, 24.158826143000056],
              [-110.0026109449999, 24.137087741000073],
              [-109.99663254799992, 24.128611152000076],
              [-109.99825237099992, 24.115413683000043],
              [-109.9938595019999, 24.110659351000038],
              [-109.9886293749999, 24.065737051000042],
              [-109.98765183599994, 24.04631887700009],
              [-109.9741602769999, 24.03857598600007],
              [-109.95291610099991, 24.037894511000047],
              [-109.93140921799994, 24.029305440000087],
              [-109.89027950199994, 24.037453886000037],
              [-109.85292570999991, 24.050979706000078],
              [-109.83531098799995, 24.05987216300008],
              [-109.82828804299993, 24.062799557000062],
              [-109.82736815099992, 24.056989437000084],
              [-109.82546455599993, 24.04694522200009],
              [-109.82179551999991, 24.037895010000057],
              [-109.81109289099993, 24.032289537000054],
              [-109.80344397499994, 24.022060036000084],
              [-109.80493128599994, 24.01370095200008],
              [-109.80968068999994, 24.010175745000083],
              [-109.81118569099993, 24.00129558100008],
              [-109.82491019499992, 23.989131978000046],
              [-109.83066522399992, 23.989313980000077],
              [-109.83310366699993, 23.985721631000047],
              [-109.83222881299992, 23.977827905000083],
              [-109.83634087199994, 23.961677483000074],
              [-109.8390577099999, 23.951788613000076],
              [-109.83732193999992, 23.93808667600007],
              [-109.83005, 23.91896104400007],
              [-109.82396399599992, 23.91038646000004],
              [-109.81537735699993, 23.905835740000043],
              [-109.80861435499992, 23.90246108000008],
              [-109.80476007199991, 23.897572783000044],
              [-109.79735266799992, 23.891506252000056],
              [-109.79356848899994, 23.888739325000074],
              [-109.7858175849999, 23.882216090000043],
              [-109.77277799899991, 23.87755896300007],
              [-109.74087480399993, 23.84251536700009],
              [-109.72191321499992, 23.826320705000057],
              [-109.7118357949999, 23.807786234000048],
              [-109.69844281799993, 23.798428157000046],
              [-109.71027249899993, 23.77518289200009],
              [-109.71132210199994, 23.748969669000076],
              [-109.70449785099993, 23.724269924000055],
              [-109.69420325399994, 23.68895091400009],
              [-109.69632063199992, 23.66552013800009],
              [-109.67982513099992, 23.648164954000038],
              [-109.66008191299994, 23.640126025000086],
              [-109.6425926519999, 23.63323224600009],
              [-109.63600076499995, 23.62618186900005],
              [-109.62183711099993, 23.62201596300008],
              [-109.60873244399994, 23.61998633400009],
              [-109.5850865249999, 23.609192748000055],
              [-109.57740127499994, 23.601044866000052],
              [-109.56666809899991, 23.596988404000058],
              [-109.5410902569999, 23.59136143900008],
              [-109.52401872399992, 23.588134580000087],
              [-109.51735373199995, 23.58263700400005],
              [-109.51442142199994, 23.570454],
              [-109.49871660699995, 23.564193532000047],
              [-109.47645889899991, 23.560204887000054],
              [-109.46801587899989, 23.555138226000054],
              [-109.46795204499995, 23.54812267300008],
              [-109.47677436099991, 23.538987847000044],
              [-109.47794897599994, 23.52543487400004],
              [-109.46835893399992, 23.503872469000044],
              [-109.4437343589999, 23.474550606000037],
              [-109.42631560199993, 23.458513309000068],
              [-109.42324150299993, 23.439432773000078],
              [-109.42780822899994, 23.42299093400004],
              [-109.42706540599994, 23.409930794000047],
              [-109.41431707999993, 23.405944876000035],
              [-109.41362465499992, 23.391696740000043],
              [-109.41665324699994, 23.38113237500005],
              [-109.4285563979999, 23.37443305700009],
              [-109.42642571699992, 23.36369565600006],
              [-109.42717118399992, 23.345946645000083],
              [-109.42375150399994, 23.335158168000078],
              [-109.42598483099994, 23.312715084000047],
              [-109.42564856699994, 23.29718659100007],
              [-109.43374589799993, 23.284979559000078],
              [-109.43765214799993, 23.281317450000074],
              [-109.43838456899994, 23.271307684000078],
              [-109.43667558499993, 23.250392971000053],
              [-109.43765214799993, 23.240383205000057],
              [-109.44225012899994, 23.230617580000057],
              [-109.45162794399994, 23.213409279000075],
              [-109.45383763699994, 23.202270627000075],
              [-109.4629613919999, 23.19476959800005],
              [-109.47484290299991, 23.17796458500004],
              [-109.49420327299993, 23.151730649000058],
              [-109.50491589199993, 23.144919023000057],
              [-109.51617724399995, 23.125282931000072],
              [-109.52588303199991, 23.121642359000077],
              [-109.53167226799991, 23.108207006000043],
              [-109.56614670199991, 23.09496782900004],
              [-109.57714396799992, 23.08171356300005],
              [-109.60759939399992, 23.081166444000075],
              [-109.6271427989999, 23.071412215000066],
              [-109.6721432039999, 23.056103844000063],
              [-109.6945447729999, 23.040804457000036],
              [-109.71317632099993, 23.031050315000073],
              [-109.71719108299993, 23.016811990000065],
              [-109.71238319199995, 23.007791566000037],
              [-109.7315190079999, 22.987542751000035],
              [-109.75857884999994, 22.98446544300009],
              [-109.80337698499994, 22.956122423000068],
              [-109.80600981999993, 22.936069701000065],
              [-109.8241584939999, 22.919920368000078],
              [-109.83670523299992, 22.90993994100006],
              [-109.85106360599991, 22.89996979400007],
              [-109.85912024599992, 22.897772528000075],
              [-109.88496870499995, 22.897214056000053],
              [-109.90173896199991, 22.889677279000068],
              [-109.90290927199993, 22.881673934000048],
              [-109.8953783629999, 22.87420295900006],
              [-109.93452322299993, 22.87230237400007],
              [-109.9544964509999, 22.87215511800008],
              [-109.96555140999993, 22.878142711000066],
              [-109.97843141399994, 22.881775402000073],
              [-109.99965906299991, 22.894442213000048],
              [-110.02747925699992, 22.916159029000085],
              [-110.04337454599994, 22.93187903800009],
              [-110.06001758199994, 22.950816487000054],
              [-110.07835852799991, 22.98065827000005],
              [-110.08189856699994, 22.99022044500009],
              [-110.08994766099994, 23.01091497500005],
              [-110.09837991099994, 23.01756239900004],
              [-110.10679680699991, 23.04819412100005],
              [-110.10759344099995, 23.075454753000088],
              [-110.15157522399994, 23.226266827000074],
              [-110.1604805309999, 23.292108040000073],
              [-110.1672598529999, 23.321086283000056],
              [-110.1782451169999, 23.330218908000063],
              [-110.18572330699993, 23.34005362700009],
              [-110.20959839299991, 23.378440434000083],
              [-110.21601538499993, 23.393849697000064],
              [-110.22948653799995, 23.40707536700006],
              [-110.2346369899999, 23.426069079000058],
              [-110.26683960399993, 23.47826065000004],
              [-110.27779911399995, 23.488175823000063],
              [-110.3073623439999, 23.54103237000004],
              [-110.35390745299992, 23.58078591800006],
              [-110.40439634699993, 23.608645611000043],
              [-110.52398645099993, 23.658460456000057],
              [-110.5773431479999, 23.681560456000057],
              [-110.6475176649999, 23.733900839000057],
              [-110.75331122599994, 23.83910734200009],
              [-110.81578794799992, 23.90874566800005],
              [-110.8516332669999, 23.940375067000048],
              [-110.8695542459999, 23.951764128000036],
              [-110.88087238999992, 23.953662259000055],
              [-110.88333528599992, 23.96650298900005],
              [-110.89445368199995, 23.97640464500006],
              [-110.9317113919999, 24.014960028000075],
              [-110.95383780999992, 24.030837235000035],
              [-110.9872352349999, 24.057347751000066],
              [-111.01001122399992, 24.071446481000066],
              [-111.01662203899991, 24.085213902000078],
              [-111.03971426899994, 24.10418492000008],
              [-111.0827498509999, 24.130840387000035],
              [-111.10767483799992, 24.147442066000053],
              [-111.13875169199991, 24.163386826000078],
              [-111.17415248599991, 24.18103153600009],
              [-111.22744093499995, 24.217471852000074],
              [-111.28075110599991, 24.242987372000073],
              [-111.44444475799992, 24.324391423000066],
              [-111.4495903159999, 24.330119099000058],
              [-111.43732404299993, 24.327432971000064],
              [-111.35974875599993, 24.290321719000076],
              [-111.3743758359999, 24.305914751000046],
              [-111.41234290299991, 24.32526276200008],
              [-111.44494507399992, 24.339625712000043],
              [-111.4607048499999, 24.34319604800004],
              [-111.4780551739999, 24.354804107000064],
              [-111.48638138099994, 24.37421388900009],
              [-111.5225919799999, 24.404638722000072],
              [-111.5416878449999, 24.415463338000052],
              [-111.5653659809999, 24.41918117000006],
              [-111.59557761799994, 24.44223530100004],
              [-111.6194248079999, 24.47313665000007],
              [-111.62908477499991, 24.50852920500006],
              [-111.64936246899993, 24.541738674000044],
              [-111.65349964699993, 24.552218829000083],
              [-111.6456852959999, 24.548059494000086],
              [-111.63425113699992, 24.547823389000087],
              [-111.6470813599999, 24.562484596000047],
              [-111.6678407359999, 24.576507460000073],
              [-111.67903001899992, 24.586333593000063],
              [-111.6956274079999, 24.587144273000035],
              [-111.69523764099995, 24.571470255000065],
              [-111.68592778899995, 24.556889028000057],
              [-111.6987808799999, 24.535561715000085],
              [-111.72595222799993, 24.539306414000066],
              [-111.73719903699993, 24.54673419900007],
              [-111.7487437879999, 24.542169326000078],
              [-111.76553998999992, 24.53850844400006],
              [-111.78830781799991, 24.542159594000054],
              [-111.80314545399995, 24.546450916000083],
              [-111.78250856699992, 24.52765518500007],
              [-111.76171451099992, 24.51524893900006],
              [-111.78111938199993, 24.51244026800009],
              [-111.79154538199992, 24.517443727000057],
              [-111.80132126899991, 24.51284271500009],
              [-111.81290810099995, 24.505879613000047],
              [-111.8196862659999, 24.516404126000054],
              [-111.82101975299992, 24.534014953000053],
              [-111.81899456799994, 24.545166021000057],
              [-111.81488356999989, 24.56986663100008],
              [-111.83474326899994, 24.621425576000036],
              [-111.84892417299994, 24.653685574000065],
              [-111.8661469949999, 24.66921685500006],
              [-111.8859002929999, 24.689602256000057],
              [-111.90629670499993, 24.713611438000044],
              [-111.9292014429999, 24.73046975400007],
              [-111.94159657199992, 24.74422498100006],
              [-111.93817958099993, 24.748322727000073],
              [-111.91600195099994, 24.73351318400006],
              [-111.9122195519999, 24.73658333700007],
              [-111.91292862699993, 24.743776108000077],
              [-111.93285071499992, 24.75617096600007],
              [-111.95278886599993, 24.77484772300005],
              [-111.96812903599994, 24.79441966400009],
              [-111.9741918609999, 24.809393622000073],
              [-111.97704016799992, 24.825995184000078],
              [-111.98473059799994, 24.84715403900009],
              [-111.9956762359999, 24.865790106000077],
              [-112.00837154899995, 24.87457916900007],
              [-111.99982662699995, 24.845648505000042],
              [-111.99583899599992, 24.81940338700008],
              [-111.98766028599994, 24.796698309000078],
              [-111.96670488199993, 24.77830638200004],
              [-111.97252356699994, 24.77570221600007],
              [-111.98843339799993, 24.76471588700008],
              [-111.9827367829999, 24.760199286000045],
              [-111.97240149599992, 24.74876536700009],
              [-111.96670488199993, 24.744208075000074],
              [-111.97565670499995, 24.741156317000048],
              [-111.98355058499993, 24.74282461100006],
              [-111.99006100199995, 24.748521226000037],
              [-111.99469967399995, 24.757879950000074],
              [-112.01162675699993, 24.739447333000044],
              [-112.02525794199994, 24.755560614000046],
              [-112.04308020699995, 24.80565013200004],
              [-112.03376217399995, 24.81195709800005],
              [-112.02928626199991, 24.82021719000005],
              [-112.02989661399994, 24.829820054000038],
              [-112.03563391799992, 24.840399481000077],
              [-112.05125891799992, 24.83006419500009],
              [-112.05451412699995, 24.81712474200009],
              [-112.04930579299992, 24.78579336100006],
              [-112.04754221799993, 24.76512962000004],
              [-112.04305371299989, 24.75346589800006],
              [-112.06358801999994, 24.751654364000046],
              [-112.07811438699991, 24.762152411000045],
              [-112.08804277299993, 24.773382880000042],
              [-112.09430904899995, 24.787176825000074],
              [-112.0977270169999, 24.80565013200004],
              [-112.0957738919999, 24.836004950000074],
              [-112.0977270169999, 24.846625067000048],
              [-112.10350501199991, 24.85301341400009],
              [-112.11095130099994, 24.854315497000073],
              [-112.11685136599993, 24.857082424000055],
              [-112.12421473299992, 24.87404577400008],
              [-112.11339270699995, 24.87889232000009],
              [-112.0957738919999, 24.893784898000035],
              [-112.09024003799993, 24.901190497000073],
              [-112.09683183499993, 24.923488674000055],
              [-112.10065670499995, 24.92731354400007],
              [-112.10391191299993, 24.932196356000077],
              [-112.10350501199991, 24.94041575700004],
              [-112.09947669199994, 24.94481028900009],
              [-112.08617102799991, 24.953273830000057],
              [-112.08238684799994, 24.960272528000075],
              [-112.08385169199994, 24.966945705000057],
              [-112.09373938699991, 24.980210679000038],
              [-112.09605872299994, 24.991359768000052],
              [-112.09692095299994, 24.99960875800008],
              [-112.10417080699995, 25.00787267900006],
              [-112.1103737769999, 25.002610667000056],
              [-112.12024216399993, 24.98812397900008],
              [-112.11956800199994, 24.97064531600006],
              [-112.1297863079999, 24.959129086000075],
              [-112.13727779899995, 24.946112372000073],
              [-112.13133404899992, 24.927151651000088],
              [-112.12302316299991, 24.909326969000062],
              [-112.13361967599991, 24.889896771000053],
              [-112.1449312719999, 24.87409437900004],
              [-112.15583112999991, 24.87543776700005],
              [-112.16087223699992, 24.89325718400005],
              [-112.15756297999991, 24.90743027500008],
              [-112.15386234499994, 24.931819231000077],
              [-112.16220545599992, 24.93909044500009],
              [-112.1632868349999, 24.942719486000044],
              [-112.16580313599991, 24.95393479200004],
              [-112.1603335559999, 24.95952789000006],
              [-112.14723714099995, 24.961147297000082],
              [-112.1417559649999, 24.970367296000063],
              [-112.14900471399994, 24.979616087000068],
              [-112.1424266979999, 24.99048338500006],
              [-112.13072995999994, 25.00925480500007],
              [-112.1233632929999, 25.038267207000047],
              [-112.12807866299994, 25.04638097900005],
              [-112.1207529749999, 25.062188891000062],
              [-112.12217589099993, 25.073402313000088],
              [-112.13236833699995, 25.073426677000043],
              [-112.13271325499994, 25.080021508000073],
              [-112.14252531299991, 25.085978837000084],
              [-112.1381153449999, 25.100476214000082],
              [-112.13553710899993, 25.110692130000075],
              [-112.1402277549999, 25.125871403000076],
              [-112.1383537399999, 25.144335639000076],
              [-112.13062134599994, 25.172027650000075],
              [-112.11774654899995, 25.19944896000004],
              [-112.09976152299993, 25.22406647300005],
              [-112.08411772999995, 25.243583568000076],
              [-112.07787059499992, 25.258735367000043],
              [-112.07668247499993, 25.290387096000075],
              [-112.07468845599993, 25.344067736000056],
              [-112.07422794099995, 25.372746603000053],
              [-112.08624760999993, 25.377724715000056],
              [-112.08693243599993, 25.39058503700005],
              [-112.08103491899993, 25.407714161000058],
              [-112.0726111329999, 25.41659221000009],
              [-112.07072499299994, 25.433733344000075],
              [-112.07069732499991, 25.441318252000087],
              [-112.08309751199994, 25.44399540200004],
              [-112.07429171699994, 25.456501440000068],
              [-112.04835256699994, 25.46641487800008],
              [-112.03077844599994, 25.473614549000047],
              [-112.04246447199989, 25.47760594600004],
              [-112.06731337899993, 25.475699486000053],
              [-112.07937260199992, 25.471117378000088],
              [-112.08445012599992, 25.481021014000078],
              [-112.07494177199993, 25.48659893300004],
              [-112.0625707669999, 25.494696356000077],
              [-112.06362870999993, 25.51325104400007],
              [-112.06704414599994, 25.550208094000084],
              [-112.07207869299992, 25.571333464000077],
              [-112.06471728899993, 25.591713450000043],
              [-112.06313337699993, 25.62533420500006],
              [-112.07097819199993, 25.68403754400009],
              [-112.07599409699992, 25.71340029000004],
              [-112.08144967899995, 25.72068166100007],
              [-112.08951663099992, 25.71543073400005],
              [-112.08847726499994, 25.69893420300008],
              [-112.08702551999994, 25.59320709800005],
              [-112.09225174199992, 25.54929861000005],
              [-112.09640002499992, 25.510726956000042],
              [-112.1040903309999, 25.504153664000057],
              [-112.10514924099994, 25.515697431000035],
              [-112.10397835099991, 25.538779142000067],
              [-112.0997694219999, 25.595179037000037],
              [-112.10191129599991, 25.728014313000074],
              [-112.10871238399994, 25.784145291000073],
              [-112.1309531689999, 25.816505326000083],
              [-112.13962818399995, 25.85752510800006],
              [-112.15968635799993, 25.890531301000067],
              [-112.17894196299994, 25.95517483200007],
              [-112.1982823539999, 25.99510553300007],
              [-112.22024480999994, 26.01530058900005],
              [-112.23851477799991, 26.040838934000078],
              [-112.26414954299992, 26.05410390800006],
              [-112.29287281899991, 26.049711527000056],
              [-112.30874589799993, 26.06976959800005],
              [-112.31289628799993, 26.101996161000045],
              [-112.32115637899994, 26.131008205000057],
              [-112.34349524599992, 26.178127346000053],
              [-112.37905839799993, 26.22028229400007],
              [-112.40269934799994, 26.24022044500009],
              [-112.44273841099994, 26.26072825700004],
              [-112.45295162699995, 26.262925523000035],
              [-112.46532141799992, 26.25812409100007],
              [-112.47256425699993, 26.247870184000078],
              [-112.48131262899994, 26.238104559000078],
              [-112.49828040299991, 26.23501211100006],
              [-112.55679277299993, 26.272365627000056],
              [-112.55581620999993, 26.27635325700004],
              [-112.55455481699994, 26.29092031500005],
              [-112.55996660099993, 26.30109284100007],
              [-112.57335364499994, 26.293036200000074],
              [-112.59016829899991, 26.287845357000037],
              [-112.6048930469999, 26.297977382000056],
              [-112.61278235599991, 26.31631094000005],
              [-112.61709550699993, 26.31972890800006],
              [-112.6336156889999, 26.321112372000073],
              [-112.67625891799992, 26.319281317000048],
              [-112.68911699099993, 26.322739976000037],
              [-112.72836343699993, 26.370227227000044],
              [-112.75509697199993, 26.387062145000073],
              [-112.78606552899993, 26.404706531000045],
              [-112.8052928599999, 26.417705090000084],
              [-112.8303582939999, 26.435268437000047],
              [-112.86290410299995, 26.463448394000068],
              [-112.90303741399993, 26.493197105000036],
              [-112.95335798299993, 26.51849354500007],
              [-112.95596269399994, 26.529120184000078],
              [-112.95653235599991, 26.531195380000042],
              [-112.9571020169999, 26.535549221000053],
              [-112.95864824099993, 26.540228583000044],
              [-112.9622289699999, 26.543402411000045],
              [-112.96776282499991, 26.54437897300005],
              [-112.98704993399991, 26.543402411000045],
              [-113.00365149599992, 26.549750067000048],
              [-113.01813717399995, 26.564276434000078],
              [-113.04400305399992, 26.585463600000082],
              [-113.06071644299993, 26.599117770000078],
              [-113.05892668899992, 26.61188154200005],
              [-113.06037350199995, 26.628729559000078],
              [-113.0562231109999, 26.639471747000073],
              [-113.05703691299993, 26.650213934000078],
              [-113.06362870999993, 26.656805731000077],
              [-113.07689368399991, 26.674994208000044],
              [-113.08763587099992, 26.689886786000045],
              [-113.10338294199994, 26.708929755000042],
              [-113.11579342399995, 26.717189846000053],
              [-113.1265356109999, 26.730414130000042],
              [-113.13727779899995, 26.746975002000056],
              [-113.14305579299992, 26.75771719000005],
              [-113.14305579299992, 26.770086981000077],
              [-113.14053300699993, 26.781683661000045],
              [-113.12564042899993, 26.789129950000074],
              [-113.11904863199993, 26.794094143000052],
              [-113.12816321499992, 26.79824453300006],
              [-113.13638261599993, 26.79901764500005],
              [-113.14964758999992, 26.79490794500009],
              [-113.16368567599994, 26.789129950000074],
              [-113.16698157499991, 26.77753327000005],
              [-113.17031816299993, 26.76512278900009],
              [-113.18521074099993, 26.762640692000048],
              [-113.19595292899993, 26.760199286000045],
              [-113.19180253799993, 26.751125393000052],
              [-113.19261633999992, 26.74363841400009],
              [-113.2058813139999, 26.738674221000053],
              [-113.21580969999991, 26.74445221600007],
              [-113.22402910099993, 26.755194403000075],
              [-113.22984778599994, 26.766791083000044],
              [-113.23151607999989, 26.78082916900007],
              [-113.23814856699994, 26.78660716400009],
              [-113.23151607999989, 26.791571356000077],
              [-113.21251380099994, 26.79242584800005],
              [-113.20421301999994, 26.79987213700008],
              [-113.18932044199994, 26.808986721000053],
              [-113.18106035099993, 26.81476471600007],
              [-113.1695043609999, 26.82713450700004],
              [-113.16038977799991, 26.839544989000046],
              [-113.14635169199994, 26.846991278000075],
              [-113.13727779899995, 26.85773346600007],
              [-113.13145911399994, 26.875921942000048],
              [-113.1245824859999, 26.88629791900007],
              [-113.12621008999992, 26.937892971000053],
              [-113.13141842399995, 26.955145575000074],
              [-113.14574133999992, 26.97011953300006],
              [-113.16380774599992, 26.97479889500005],
              [-113.17935136599993, 26.966945705000057],
              [-113.19254413699991, 26.94506014800004],
              [-113.19640675999995, 26.883465684000043],
              [-113.2042211019999, 26.853463499000043],
              [-113.23241126199991, 26.829331773000035],
              [-113.24474036399994, 26.837103583000044],
              [-113.25796464799993, 26.824652411000045],
              [-113.26378333199995, 26.811468817000048],
              [-113.26378333199995, 26.80231354400007],
              [-113.26455644399994, 26.794094143000052],
              [-113.26292883999992, 26.78583405200004],
              [-113.26378333199995, 26.774237372000073],
              [-113.26541744299993, 26.75996867200007],
              [-113.27054400299994, 26.75247404000004],
              [-113.28577230799993, 26.749550769000052],
              [-113.32527043199991, 26.776833426000053],
              [-113.36397058499995, 26.79506774300006],
              [-113.40099036399994, 26.802679755000042],
              [-113.4195635769999, 26.805843165000056],
              [-113.44823226499994, 26.80446201700005],
              [-113.47098648399992, 26.804554152000037],
              [-113.5038871779999, 26.793415760000073],
              [-113.51834512999994, 26.769428706000042],
              [-113.52647864499994, 26.753607489000046],
              [-113.5423070949999, 26.74209219000005],
              [-113.54296596799992, 26.71919600700005],
              [-113.55483964799993, 26.71820709800005],
              [-113.57414856299994, 26.70503897900005],
              [-113.59767530499994, 26.709627805000082],
              [-113.6371376759999, 26.725530915000036],
              [-113.66584225199995, 26.76943594000005],
              [-113.72520911399994, 26.799994208000044],
              [-113.73403886599993, 26.813788153000075],
              [-113.73729407499991, 26.828680731000077],
              [-113.75413977799991, 26.860581773000035],
              [-113.79148967799995, 26.92004632600009],
              [-113.81638813799992, 26.94896938800008],
              [-113.8512478159999, 26.967914275000055],
              [-113.87866020799993, 26.983500183000046],
              [-113.90990149599992, 26.992336330000057],
              [-113.95976707599993, 26.997984165000048],
              [-113.9747392299999, 26.99354818800009],
              [-113.9735187199999, 26.98021615500005],
              [-113.98412024599992, 26.976263739000046],
              [-113.99388587099992, 26.971828518000052],
              [-114.0051977199999, 26.977443752000056],
              [-114.04954031299991, 27.01798509100007],
              [-114.06362870999993, 27.05076732000009],
              [-114.08441305399992, 27.07574801000004],
              [-114.11436926999994, 27.10545482000009],
              [-114.14704342399995, 27.123480536000045],
              [-114.1819555329999, 27.13963450700004],
              [-114.20918328599993, 27.14233824900009],
              [-114.23656165299991, 27.15330638200004],
              [-114.27408324599992, 27.148897894000072],
              [-114.29029561499993, 27.14654032800007],
              [-114.29399928499993, 27.12546160900007],
              [-114.32024517999992, 27.145496995000087],
              [-114.35081946499992, 27.165757554000038],
              [-114.39514923299993, 27.182913648000067],
              [-114.42140513999993, 27.166457302000083],
              [-114.43514318399991, 27.176367458000072],
              [-114.42833411399994, 27.188055731000077],
              [-114.4304906889999, 27.19790273600006],
              [-114.42979895699995, 27.208929755000042],
              [-114.44453586999992, 27.21435629100006],
              [-114.46336829299992, 27.222479559000078],
              [-114.47589382699994, 27.217653590000054],
              [-114.48754187299994, 27.23809778100008],
              [-114.48689046699991, 27.28164412400008],
              [-114.4844457669999, 27.324286200000074],
              [-114.49156653599994, 27.36269765800006],
              [-114.50646073799993, 27.406184127000074],
              [-114.52916419199994, 27.426906643000052],
              [-114.53783118399991, 27.43390534100007],
              [-114.56334387899994, 27.44863515800006],
              [-114.58107769899993, 27.450845063000088],
              [-114.59658643499989, 27.477189362000047],
              [-114.63188817499992, 27.48877256700007],
              [-114.68109422599991, 27.507628890000035],
              [-114.71575247699991, 27.521904491000043],
              [-114.73422912699994, 27.521251508000034],
              [-114.74889075399994, 27.547308661000045],
              [-114.75210527299993, 27.55304596600007],
              [-114.76618404899995, 27.56940338700008],
              [-114.76939856699994, 27.574652411000045],
              [-114.78173011299992, 27.60275745100006],
              [-114.80571925699991, 27.621042742000043],
              [-114.83038589899991, 27.631132388000083],
              [-114.83879971999994, 27.628357350000044],
              [-114.8448657109999, 27.616063557000075],
              [-114.85567270699994, 27.622137059000067],
              [-114.8618857319999, 27.630958901000042],
              [-114.87581933099995, 27.64382426900005],
              [-114.8720118789999, 27.649294652000037],
              [-114.85809763999993, 27.63915318700009],
              [-114.84887846099991, 27.64056480800008],
              [-114.84447180899991, 27.65965403900009],
              [-114.84764563699991, 27.67133209800005],
              [-114.85334225199995, 27.68162669500009],
              [-114.86156165299991, 27.689886786000045],
              [-114.87242591099994, 27.695054429000038],
              [-114.88658606699994, 27.69489166900007],
              [-114.89240475199995, 27.687323309000078],
              [-114.89753170499989, 27.678290106000077],
              [-114.89980539899994, 27.664122211000063],
              [-114.91214848999994, 27.66950057400004],
              [-114.9321951959999, 27.67619330900004],
              [-114.93930491399993, 27.700669451000067],
              [-114.95096436299991, 27.716258811000046],
              [-114.97411048099991, 27.72410716400009],
              [-114.9887088239999, 27.726853978000065],
              [-115.00172633099993, 27.71593090500005],
              [-115.01104128599991, 27.728108086000077],
              [-115.02268426599994, 27.740290592000065],
              [-115.03362639799991, 27.75929308900004],
              [-115.03458306199991, 27.77905848000006],
              [-115.0463103969999, 27.795381771000052],
              [-115.0495085419999, 27.80831244500007],
              [-115.05288652299993, 27.822088934000078],
              [-115.05675208199995, 27.824774481000077],
              [-115.08382347999992, 27.851054038000086],
              [-115.05589758999992, 27.860256252000056],
              [-115.0414702299999, 27.85678170700004],
              [-115.0228603679999, 27.844617793000054],
              [-115.01425743599992, 27.830346771000052],
              [-114.96645117999992, 27.82646669400009],
              [-114.9234045039999, 27.83627549600004],
              [-114.88405430599994, 27.83045654500006],
              [-114.86864063699994, 27.83055373400009],
              [-114.84780084599993, 27.825215872000058],
              [-114.8400156209999, 27.81230250100009],
              [-114.81919398699995, 27.809006011000065],
              [-114.78608959799993, 27.815328708000038],
              [-114.76447046999994, 27.810672990000057],
              [-114.73977108199995, 27.806713604000038],
              [-114.7235683859999, 27.806800852000038],
              [-114.71894744399992, 27.796561740000072],
              [-114.7089852549999, 27.791792963000034],
              [-114.69200211999993, 27.78778843400005],
              [-114.66959404099993, 27.787915749000035],
              [-114.63834607599995, 27.779745623000053],
              [-114.60445727799993, 27.77440888600006],
              [-114.57142083199994, 27.78207759500009],
              [-114.53064561399992, 27.787640384000042],
              [-114.49905714399995, 27.774071481000078],
              [-114.46349036399994, 27.788763739000046],
              [-114.43285071499992, 27.80027903900009],
              [-114.40477454299992, 27.817694403000075],
              [-114.39403235599991, 27.82843659100007],
              [-114.38131257999993, 27.836503220000054],
              [-114.36510169199994, 27.850775458000044],
              [-114.34520423099991, 27.86318594000005],
              [-114.33446204299992, 27.86977773600006],
              [-114.32534745999993, 27.874701239000046],
              [-114.31627356699994, 27.874701239000046],
              [-114.30386308499993, 27.872259833000044],
              [-114.29808508999992, 27.868109442000048],
              [-114.29727128799993, 27.860663153000075],
              [-114.29478919199994, 27.852443752000056],
              [-114.29063880099994, 27.83340078300006],
              [-114.29564368399991, 27.817694403000075],
              [-114.30142167899993, 27.801947333000044],
              [-114.30801347599993, 27.789536851000037],
              [-114.31216386599993, 27.779689846000053],
              [-114.3047582669999, 27.764797268000052],
              [-114.28237870999993, 27.73582591400009],
              [-114.26170813699991, 27.72675202000005],
              [-114.24022376199991, 27.70604075700004],
              [-114.22370357999989, 27.696966864000046],
              [-114.1956274079999, 27.69204336100006],
              [-114.1765844389999, 27.679632880000042],
              [-114.15094967399995, 27.669663804000038],
              [-114.1360570949999, 27.65729401200008],
              [-114.12612870999993, 27.64325592700004],
              [-114.11949622299994, 27.63580963700008],
              [-114.12035071499992, 27.625881252000056],
              [-114.11204993399991, 27.620917059000078],
              [-114.10293535099993, 27.620917059000078],
              [-114.10545813699991, 27.610174872000073],
              [-114.10293535099993, 27.60187409100007],
              [-114.09386145699995, 27.60765208500004],
              [-114.0823461579999, 27.61424388200004],
              [-114.07485917899993, 27.62254466400009],
              [-114.07404537699995, 27.62913646000004],
              [-114.0567113919999, 27.641546942000048],
              [-114.04759680899991, 27.653143622000073],
              [-114.04344641799992, 27.668036200000074],
              [-114.05003821499992, 27.67381419500009],
              [-114.05748450399994, 27.669663804000038],
              [-114.05996660099993, 27.676255601000037],
              [-114.0633031889999, 27.679632880000042],
              [-114.06493079299992, 27.682928778000075],
              [-114.0716039699999, 27.679632880000042],
              [-114.0781957669999, 27.68040599200009],
              [-114.07982337099992, 27.68622467700004],
              [-114.07485917899993, 27.690375067000048],
              [-114.06655839799993, 27.69204336100006],
              [-114.05504309799994, 27.694484768000052],
              [-114.0484106109999, 27.691148179000038],
              [-114.04674231699994, 27.68455638200004],
              [-114.04259192599994, 27.679632880000042],
              [-114.03018144399994, 27.682928778000075],
              [-114.02110755099994, 27.679632880000042],
              [-114.0203344389999, 27.67133209800005],
              [-114.0120336579999, 27.66551341400009],
              [-113.99469967399995, 27.65892161700009],
              [-113.96816972599993, 27.654771226000037],
              [-113.95327714799993, 27.65566640800006],
              [-113.9500219389999, 27.65973541900007],
              [-113.94253495999993, 27.669663804000038],
              [-113.93594316299993, 27.67877838700008],
              [-113.93101966099994, 27.687892971000053],
              [-113.91779537699995, 27.696966864000046],
              [-113.91445878799993, 27.710191148000035],
              [-113.91856848899994, 27.719305731000077],
              [-113.92935136599993, 27.72675202000005],
              [-113.94009355399993, 27.72842031500005],
              [-113.94420325399994, 27.734198309000078],
              [-113.95909583199995, 27.740790106000077],
              [-113.9690649079999, 27.74241771000004],
              [-113.97398841099994, 27.744940497000073],
              [-113.97565670499989, 27.752386786000045],
              [-113.98306230399993, 27.75731028900009],
              [-113.98721269399994, 27.75649648600006],
              [-113.99380449099993, 27.74990469000005],
              [-114.00291907499991, 27.75067780200004],
              [-114.01528886599993, 27.74900950700004],
              [-114.02110755099994, 27.74823639500005],
              [-114.02525794199994, 27.74990469000005],
              [-114.03685462099992, 27.768052476000037],
              [-114.04507402299993, 27.783758856000077],
              [-114.05003821499992, 27.79205963700008],
              [-114.05915279899995, 27.801174221000053],
              [-114.06655839799993, 27.803656317000048],
              [-114.06908118399991, 27.79950592700004],
              [-114.06493079299992, 27.79043203300006],
              [-114.0567113919999, 27.775539455000057],
              [-114.05748450399994, 27.764797268000052],
              [-114.04922441299993, 27.759833075000074],
              [-114.04259192599994, 27.75067780200004],
              [-114.03848222599993, 27.739162502000056],
              [-114.0418188139999, 27.732489325000074],
              [-114.04922441299993, 27.732489325000074],
              [-114.05089270699995, 27.72675202000005],
              [-114.05174719999991, 27.72011953300006],
              [-114.05581620999993, 27.72093333500004],
              [-114.06248938699991, 27.725083726000037],
              [-114.07237708199995, 27.725083726000037],
              [-114.07982337099992, 27.719305731000077],
              [-114.09142005099994, 27.711859442000048],
              [-114.10460364499994, 27.70770905200004],
              [-114.11705481699994, 27.709377346000053],
              [-114.1253149079999, 27.71430084800005],
              [-114.13194739499994, 27.723456122000073],
              [-114.14098059799994, 27.730861721000053],
              [-114.14268958199995, 27.74241771000004],
              [-114.14598548099991, 27.755682684000078],
              [-114.15343176999994, 27.765570380000042],
              [-114.1616918609999, 27.774644273000035],
              [-114.17243404899995, 27.788763739000046],
              [-114.17324785099993, 27.803656317000048],
              [-114.17491614499994, 27.816066799000055],
              [-114.17324785099993, 27.82680898600006],
              [-114.16661536399994, 27.83421458500004],
              [-114.1616918609999, 27.844956773000035],
              [-114.14598548099991, 27.86395905200004],
              [-114.13438880099994, 27.87718333500004],
              [-114.13109290299991, 27.888820705000057],
              [-114.13524329299992, 27.89288971600007],
              [-114.14435787699995, 27.894598700000074],
              [-114.14928137899994, 27.895412502000056],
              [-114.15094967399995, 27.89866771000004],
              [-114.14346269399994, 27.902818101000037],
              [-114.13687089799993, 27.90615469000005],
              [-114.13524329299992, 27.911932684000078],
              [-114.13931230399993, 27.915228583000044],
              [-114.14842688699991, 27.918524481000077],
              [-114.15420488199993, 27.923529364000046],
              [-114.15835527299993, 27.930121161000045],
              [-114.15420488199993, 27.936712958000044],
              [-114.15343176999994, 27.945013739000046],
              [-114.1616918609999, 27.949164130000042],
              [-114.16832434799994, 27.950832424000055],
              [-114.17739824099993, 27.945868231000077],
              [-114.17821204299992, 27.938421942000048],
              [-114.18236243399991, 27.930975653000075],
              [-114.19058183499993, 27.92845286700009],
              [-114.1980688139999, 27.922674872000073],
              [-114.20881100199995, 27.917710679000038],
              [-114.22036699099993, 27.91937897300005],
              [-114.23940995999993, 27.911932684000078],
              [-114.24767005099994, 27.901190497000073],
              [-114.25674394399994, 27.89207591400009],
              [-114.26769374499992, 27.886901287000057],
              [-114.27645156699992, 27.901147773000048],
              [-114.27378964299993, 27.916593688000034],
              [-114.27045141899993, 27.92966307800009],
              [-114.26170813699991, 27.944159247000073],
              [-114.2534887359999, 27.952460028000075],
              [-114.23363196499992, 27.96816640800006],
              [-114.22695878799993, 27.980536200000074],
              [-114.21129309799994, 27.995428778000075],
              [-114.20702063699991, 27.99998607000009],
              [-114.18565833199995, 28.022691148000035],
              [-114.1551000639999, 28.062445380000042],
              [-114.13438880099994, 28.083929755000042],
              [-114.11986848999993, 28.085949775000074],
              [-114.11381156099992, 28.06040695300004],
              [-114.1171839079999, 28.04317994200005],
              [-114.13536580699991, 28.031295451000062],
              [-114.14613333799991, 28.02178966000008],
              [-114.14949488899993, 28.013474461000044],
              [-114.15083636799994, 28.004566200000056],
              [-114.1387141429999, 27.98853488700007],
              [-114.13063581499995, 27.971907196000075],
              [-114.12996061699994, 27.96121693200007],
              [-114.10640219099992, 27.927951567000036],
              [-114.0942989959999, 27.957650688000058],
              [-114.09160276699993, 27.976062463000062],
              [-114.09563881199995, 27.996258391000083],
              [-114.10708142399994, 28.01348400200004],
              [-114.11785402699991, 28.01110710100005],
              [-114.12324162999994, 28.016451491000055],
              [-114.1212235779999, 28.022984960000088],
              [-114.10843089499991, 28.03070841600004],
              [-114.09428743599995, 28.024176268000076],
              [-114.07745713199989, 28.009324405000086],
              [-114.06803612599992, 27.99565965100004],
              [-114.05523800499992, 28.007536667000068],
              [-114.03973636199993, 28.027729815000043],
              [-114.03770919199991, 28.037234640000065],
              [-114.04646538299994, 28.038425827000083],
              [-114.05791420399993, 28.04199331600006],
              [-114.07003059199991, 28.055065106000086],
              [-114.08551944699991, 28.05684845400009],
              [-114.09966733699991, 28.055064041000037],
              [-114.1010073679999, 28.071104546000072],
              [-114.1016701769999, 28.099027745000058],
              [-114.10570930199992, 28.111503506000076],
              [-114.11312056499992, 28.120412927000075],
              [-114.11042232999989, 28.12523021000004],
              [-114.10569461299991, 28.13468159200005],
              [-114.09016264499991, 28.156094875000065],
              [-114.07866728699992, 28.176320572000066],
              [-114.06987530299995, 28.193571201000054],
              [-114.05748450399994, 28.206284898000035],
              [-114.06163489499994, 28.212103583000044],
              [-114.06493079299992, 28.22361888200004],
              [-114.06993567599994, 28.239406643000052],
              [-114.0781957669999, 28.24677155200004],
              [-114.08893795499989, 28.24677155200004],
              [-114.0987833229999, 28.23865316800004],
              [-114.10985408099992, 28.241791231000036],
              [-114.1173696319999, 28.25084844400004],
              [-114.12488288899993, 28.25572503500007],
              [-114.11856117399992, 28.269303182000044],
              [-114.11059731899991, 28.28621991600005],
              [-114.09929054199995, 28.307129428000053],
              [-114.0811743829999, 28.342968946000042],
              [-114.06076247599992, 28.404697378000037],
              [-114.04941813699992, 28.432574824000085],
              [-114.04259192599994, 28.45844147300005],
              [-114.05089270699995, 28.47418854400007],
              [-114.06432162499993, 28.47944790100007],
              [-114.07149597099993, 28.486944187000063],
              [-114.0690059179999, 28.504102774000046],
              [-114.06822669199994, 28.518011786000045],
              [-114.07730058499993, 28.523830471000053],
              [-114.08311926999994, 28.532049872000073],
              [-114.08641516799992, 28.541164455000057],
              [-114.09634355399993, 28.551906643000052],
              [-114.11042232999989, 28.561835028000075],
              [-114.12779700399994, 28.562648830000057],
              [-114.1479907669999, 28.560773251000057],
              [-114.16012582199994, 28.566186918000085],
              [-114.15758356899994, 28.58222188900004],
              [-114.15496727099992, 28.60104127900007],
              [-114.15726999799995, 28.625672197000085],
              [-114.16584225199995, 28.646958726000037],
              [-114.17491614499994, 28.65770091400009],
              [-114.18399003799993, 28.661851304000038],
              [-114.20775305899991, 28.661444403000075],
              [-114.23534094999991, 28.66006094000005],
              [-114.24615797699994, 28.65331728800004],
              [-114.27175119999993, 28.65880135100008],
              [-114.27306067599994, 28.673081773000035],
              [-114.26915442599994, 28.675116278000075],
              [-114.27170623399991, 28.684466972000052],
              [-114.27534198799992, 28.696240946000046],
              [-114.29830772399993, 28.70382033800007],
              [-114.31405987599993, 28.726333475000047],
              [-114.3469225259999, 28.73075473600005],
              [-114.3468700819999, 28.748911288000045],
              [-114.34802032999994, 28.76386736900008],
              [-114.36137133699992, 28.77780281400004],
              [-114.36204993399991, 28.79511139500005],
              [-114.37092037699995, 28.81317780200004],
              [-114.3916458249999, 28.806778586000064],
              [-114.40728230399992, 28.839983903000075],
              [-114.40231678299995, 28.86024867100008],
              [-114.4192985059999, 28.878479626000058],
              [-114.4375822849999, 28.877507454000067],
              [-114.43994166999994, 28.894610312000054],
              [-114.45939582299991, 28.910713],
              [-114.4766332669999, 28.92914459800005],
              [-114.50194251199991, 28.932562567000048],
              [-114.5159399079999, 28.92967357000009],
              [-114.52306067599994, 28.92536041900007],
              [-114.52993730399993, 28.925523179000038],
              [-114.54283195699992, 28.934394031000068],
              [-114.54892017899994, 28.951515414000085],
              [-114.55630449099993, 28.97028229400007],
              [-114.56121472799992, 28.980400083000063],
              [-114.5750219389999, 28.97923411700009],
              [-114.5916331279999, 28.96540417300008],
              [-114.6037645379999, 28.99760937600007],
              [-114.60252844999991, 29.03034088700008],
              [-114.60830644399994, 29.046210028000075],
              [-114.61815344999991, 29.063055731000077],
              [-114.6233617829999, 29.080511786000045],
              [-114.63141842399995, 29.09446849200009],
              [-114.65953528599994, 29.10301341400009],
              [-114.68903605499992, 29.11313508900008],
              [-114.70492679799992, 29.09611321300008],
              [-114.72201032999993, 29.117504618000055],
              [-114.72789466099994, 29.141180731000077],
              [-114.73493404899995, 29.15180084800005],
              [-114.7398168609999, 29.175523179000038],
              [-114.74380449099993, 29.187567450000074],
              [-114.75230872299994, 29.19281647300005],
              [-114.7853130449999, 29.194160130000057],
              [-114.82935268199992, 29.231593020000048],
              [-114.85139606199994, 29.258299975000057],
              [-114.87946529899995, 29.287665106000077],
              [-114.9248390059999, 29.33096911800004],
              [-114.97203528599994, 29.377752997000073],
              [-115.10423743399991, 29.418890692000048],
              [-115.18712317599994, 29.428615627000056],
              [-115.23228919199994, 29.490057684000078],
              [-115.28572166999993, 29.529885232000083],
              [-115.37144934799994, 29.55695221600007],
              [-115.42356524099989, 29.59568895400008],
              [-115.4519642759999, 29.62010617900006],
              [-115.47744706899994, 29.62645091400009],
              [-115.4985831869999, 29.611401236000063],
              [-115.51915442599994, 29.62726471600007],
              [-115.53612219999991, 29.635158596000053],
              [-115.54808508999992, 29.65338776200008],
              [-115.5726252419999, 29.668723250000085],
              [-115.59370482999992, 29.69217307100007],
              [-115.62205339299993, 29.695295584000064],
              [-115.69756432999992, 29.755825783000034],
              [-115.69525202699992, 29.77720028600004],
              [-115.68801295399993, 29.801772610000057],
              [-115.68576718499992, 29.83064062400007],
              [-115.6907445949999, 29.85175202000005],
              [-115.69477696799993, 29.869225027000084],
              [-115.69989884299991, 29.89801384900005],
              [-115.72081458199995, 29.920803127000056],
              [-115.72891191299993, 29.93512604400007],
              [-115.74429277299993, 29.94749583500004],
              [-115.7625219389999, 29.95380280200004],
              [-115.80748450399994, 29.956203518000052],
              [-115.81118730399993, 29.968003648000035],
              [-115.79039466099994, 30.03807200700004],
              [-115.78327216899993, 30.092637823000075],
              [-115.79039466099994, 30.12376536700009],
              [-115.7925512359999, 30.12954336100006],
              [-115.80190995999993, 30.143133856000077],
              [-115.80406653599994, 30.15143463700008],
              [-115.80321204299992, 30.163031317000048],
              [-115.79723059799994, 30.195786851000037],
              [-115.79832923099991, 30.240301825000074],
              [-115.80728105399993, 30.284125067000048],
              [-115.82590809499993, 30.317710644000044],
              [-115.83730300899992, 30.346467032000078],
              [-115.86596663799992, 30.368713728000046],
              [-115.89832686199992, 30.386661940000067],
              [-115.9329320949999, 30.400213934000078],
              [-115.9754125639999, 30.401271877000056],
              [-115.9473363919999, 30.42340729400007],
              [-115.93700110599991, 30.43512604400007],
              [-115.93382727799991, 30.449652411000045],
              [-115.9402563139999, 30.463364976000037],
              [-115.95470130099994, 30.47955963700008],
              [-115.97248287699995, 30.49282461100006],
              [-115.9890844389999, 30.49746328300006],
              [-115.98013261599993, 30.482570705000057],
              [-115.97057044199994, 30.470851955000057],
              [-115.96328691299993, 30.458685614000046],
              [-115.9617406889999, 30.442206122000073],
              [-115.97186687199991, 30.434206691000043],
              [-115.9829978219999, 30.431989539000085],
              [-115.9892820039999, 30.44048646400006],
              [-116.00267493399991, 30.449652411000045],
              [-116.01024329299992, 30.44367096600007],
              [-116.01512610599991, 30.434475002000056],
              [-116.01463782499991, 30.42601146000004],
              [-116.00609290299991, 30.422308661000045],
              [-115.99644934799994, 30.410549221000053],
              [-115.99136308499993, 30.388617255000042],
              [-115.97978479199992, 30.35935582700006],
              [-116.00454898599992, 30.359164572000054],
              [-116.0123305279999, 30.39224956000004],
              [-116.02898127999993, 30.441271407000045],
              [-116.04925400199994, 30.47959301600008],
              [-116.03111731699994, 30.62714264500005],
              [-116.03685462099992, 30.730210679000038],
              [-116.05483964799993, 30.783677476000037],
              [-116.0579320949999, 30.802476304000038],
              [-116.06802324099993, 30.81317780200004],
              [-116.1056443139999, 30.818813746000046],
              [-116.15207621399992, 30.857815507000055],
              [-116.17577403399991, 30.860147233000077],
              [-116.20128333199995, 30.89158763200004],
              [-116.21857662699995, 30.91315338700008],
              [-116.22618567599994, 30.92645905200004],
              [-116.24974524599992, 30.956773179000038],
              [-116.26817786399994, 30.963812567000048],
              [-116.30731263299992, 30.95409131000008],
              [-116.3354458209999, 30.956339556000046],
              [-116.3403625329999, 30.989260414000057],
              [-116.32612001899992, 31.027449096000055],
              [-116.31810909699993, 31.089660714000047],
              [-116.30943762899994, 31.148504950000074],
              [-116.34154212099992, 31.219549872000073],
              [-116.4541395139999, 31.338544165000087],
              [-116.4976293609999, 31.406805731000077],
              [-116.50820878799993, 31.41933828300006],
              [-116.51414954299992, 31.422796942000048],
              [-116.5301000639999, 31.440334377000056],
              [-116.53892981699994, 31.447251695000034],
              [-116.55235755099994, 31.452093817000048],
              [-116.57213294199994, 31.466864325000074],
              [-116.5855199859999, 31.47134023600006],
              [-116.59593665299991, 31.477850653000075],
              [-116.59951738199993, 31.48387278900009],
              [-116.60195878799993, 31.491156317000048],
              [-116.60912024599992, 31.50141022300005],
              [-116.64696204299992, 31.52838776200008],
              [-116.65221106699994, 31.537909247000073],
              [-116.67560787699995, 31.55263906500005],
              [-116.68106035099993, 31.56631094000005],
              [-116.67723548099991, 31.577785549000055],
              [-116.68106035099993, 31.577297268000052],
              [-116.66763261599993, 31.580023505000042],
              [-116.64452063699991, 31.57953522300005],
              [-116.66417395699995, 31.60114166900007],
              [-116.66193600199995, 31.616441148000035],
              [-116.65575110599991, 31.632473049000055],
              [-116.64806067599994, 31.65916575700004],
              [-116.6551000639999, 31.67796458500004],
              [-116.66852779899995, 31.697007554000038],
              [-116.6753637359999, 31.70258209800005],
              [-116.69017493399991, 31.708156643000052],
              [-116.7153232689999, 31.71098380400008],
              [-116.74117687599994, 31.738533860000075],
              [-116.7503808049999, 31.752360311000075],
              [-116.70881100199995, 31.744208075000074],
              [-116.67882239499994, 31.726996161000045],
              [-116.66128495999993, 31.72337474200009],
              [-116.64362545499989, 31.73427969000005],
              [-116.6304418609999, 31.752834377000056],
              [-116.61962677299994, 31.771738378000066],
              [-116.61259833399993, 31.80102687200008],
              [-116.61000172799993, 31.822600523000062],
              [-116.61181856499991, 31.842879924000044],
              [-116.61969967399995, 31.857570705000057],
              [-116.65692572599994, 31.86390121800008],
              [-116.67638283999992, 31.868764541000075],
              [-116.69472531999992, 31.890039683000055],
              [-116.7187888179999, 31.901189162000037],
              [-116.73527801199992, 31.903483287000086],
              [-116.75476835699993, 31.909641021000084],
              [-116.75601152299993, 31.93455638200004],
              [-116.75792395699995, 31.96503327000005],
              [-116.76988684799994, 31.977769273000035],
              [-116.80386308499993, 31.97870514500005],
              [-116.84227454299992, 31.98651764500005],
              [-116.86538652299993, 32.013006903000075],
              [-116.8753149079999, 32.034491278000075],
              [-116.87865149599992, 32.069240627000056],
              [-116.88687089799993, 32.132025458000044],
              [-116.9051000639999, 32.17837148600006],
              [-116.9226781889999, 32.21938711100006],
              [-116.93342037699995, 32.23379140800006],
              [-116.94831295499989, 32.24701569200005],
              [-116.96666419199994, 32.25657786700009],
              [-117.00987708199995, 32.26508209800005],
              [-117.0249731109999, 32.27692291900007],
              [-117.07347571499992, 32.36945221600007],
              [-117.08861243399991, 32.40493398600006],
              [-117.10728919199994, 32.43764883000006],
              [-117.11839758999992, 32.45453522300005],
              [-117.12124589799993, 32.471909898000035],
              [-117.12338461999991, 32.490564937000045],
              [-117.12452675999992, 32.51292381900004],
              [-117.12414985399994, 32.52411934300005],
              [-117.12512148894416, 32.53166949000402],
              [-117.04422054099993, 32.53742075600012],
              [-116.97073665399988, 32.542975973000026],
              [-116.89720109099989, 32.54853118900003],
              [-116.8236396889999, 32.55408640600005],
              [-116.75010412699991, 32.55966746000006],
              [-116.67654272499993, 32.56522267700008],
              [-116.60300716199995, 32.57080373200007],
              [-116.52947159899988, 32.57633311000008],
              [-116.4559618739999, 32.58188832600008],
              [-116.38242631099992, 32.58746938100002],
              [-116.30889074799985, 32.593024597000024],
              [-116.23532934599986, 32.59855397500003],
              [-116.16174210699987, 32.60416086900004],
              [-116.08823238199989, 32.60966440800006],
              [-116.01474849499992, 32.61527130200007],
              [-115.94121293199994, 32.62082651800007],
              [-115.86759985399993, 32.626407573000094],
              [-115.79406429099996, 32.63196278900001],
              [-115.72052872799988, 32.637518006],
              [-115.64701900299991, 32.64307322200004],
              [-115.57353511599985, 32.648654277000034],
              [-115.49992203799994, 32.65420949300004],
              [-115.42638647499986, 32.65976471000006],
              [-115.35285091199988, 32.66534576500008],
              [-115.27928951099989, 32.67082346600007],
              [-115.20580562399992, 32.67645619700009],
              [-115.13227006099994, 32.6819855750001],
              [-115.05873449699996, 32.68756663],
              [-114.98519893499989, 32.69312184700003],
              [-114.91161169499989, 32.69870290200005],
              [-114.83807613199991, 32.70420644200003],
              [-114.76454056899993, 32.70983917300008],
              [-114.7242846279999, 32.71283640500009],
              [-114.72387121699988, 32.71151865700001],
              [-114.73120926999988, 32.686636454000066],
              [-114.73947749899992, 32.669066468],
              [-114.7511563719999, 32.652219951000106],
              [-114.75880448499987, 32.644830221000106],
              [-114.78154211399995, 32.62806121800004],
              [-114.78681311099989, 32.62103322400013],
              [-114.80267777499989, 32.59449737500002],
              [-114.7942028399999, 32.57411102400009],
              [-114.79554642799987, 32.55222605400003],
              [-114.80944738899993, 32.51132415800002],
              [-114.82210811499996, 32.50023956300002],
              [-114.81937311799989, 32.49936330200008],
              [-114.81678544199993, 32.49853424100006],
              [-114.78014685099987, 32.48724294000009],
              [-114.37092118399988, 32.360687358000106],
              [-113.9616955169999, 32.23413177500002],
              [-113.55244401099989, 32.10760203100004],
              [-113.1432183429999, 31.981046448000043],
              [-112.73396683799992, 31.85454254200006],
              [-112.32471533199991, 31.72798695900009],
              [-111.91546382699991, 31.601431376],
              [-111.50623815999992, 31.47497914700004],
              [-111.45476843299994, 31.45833933500002],
              [-111.40329870599996, 31.441854554000045],
              [-111.35180314199997, 31.425318095000065],
              [-111.30033341499988, 31.40872996000006],
              [-111.2488636879999, 31.392141826000042],
              [-111.19744563799992, 31.375553690000046],
              [-111.14592423599993, 31.359068909000044],
              [-111.09445450899995, 31.342532451000054],
              [-111.06711767599991, 31.333644104000044],
              [-111.00626867799988, 31.327184550000098],
              [-110.94875280799995, 31.327184550000098],
              [-110.90606807499987, 31.327236227000085],
              [-110.86335750399986, 31.327236227000085],
              [-110.82059525599993, 31.327236227000085],
              [-110.77788468499993, 31.327236227000085],
              [-110.73519995099993, 31.327236227000085],
              [-110.69243770399991, 31.327236227000085],
              [-110.64972713299991, 31.327236227000085],
              [-110.6069648849999, 31.327236227000085],
              [-110.5642801519999, 31.327236227000085],
              [-110.5215954189999, 31.327236227000085],
              [-110.47885900899989, 31.327236227000085],
              [-110.43617427699989, 31.327236227000085],
              [-110.39348954299989, 31.327236227000085],
              [-110.35075313299988, 31.327236227000085],
              [-110.30801672399987, 31.327236227000085],
              [-110.26522863799994, 31.327236227000085],
              [-110.22254390599994, 31.327236227000085],
              [-110.17980749599992, 31.327236227000085],
              [-110.13707108599992, 31.327236227000085],
              [-110.09438635299992, 31.327236227000085],
              [-110.05170161999992, 31.327236227000085],
              [-110.0089652109999, 31.327236227000085],
              [-109.96628047799992, 31.327236227000085],
              [-109.92359574399991, 31.327287903000112],
              [-109.88080765899988, 31.327339580000043],
              [-109.8381229249999, 31.327339580000043],
              [-109.79533483999987, 31.327339580000043],
              [-109.75265010599988, 31.327339580000043],
              [-109.70996537299996, 31.327339580000043],
              [-109.66717728799993, 31.327339580000043],
              [-109.62449255399994, 31.327339580000043],
              [-109.58180782099994, 31.327339580000043],
              [-109.53907141199993, 31.327339580000043],
              [-109.49638667799994, 31.327339580000043],
              [-109.45365026899992, 31.327339580000043],
              [-109.41091385899992, 31.327339580000043],
              [-109.36822912599992, 31.327339580000043],
              [-109.32551855499992, 31.327339580000043],
              [-109.2827821459999, 31.327339580000043],
              [-109.2400715749999, 31.327339580000043],
              [-109.19736100399989, 31.32739125600004],
              [-109.15459875599987, 31.32739125600004],
              [-109.11191402299997, 31.32739125600004],
              [-109.06920345099988, 31.32739125600004],
              [-109.04743046299986, 31.32739125600004],
              [-109.02649287999986, 31.32739125600004],
              [-108.98373063199995, 31.32739125600004],
              [-108.9682819669999, 31.32739125600004],
              [-108.94104589899986, 31.32739125600004],
              [-108.89833532799994, 31.32739125600004],
              [-108.85562475699993, 31.32739125600004],
              [-108.81291418599993, 31.32739125600004],
              [-108.77017777599993, 31.32739125600004],
              [-108.72746720399992, 31.32739125600004],
              [-108.6847566329999, 31.32739125600004],
              [-108.6420202229999, 31.32739125600004],
              [-108.5993096519999, 31.32739125600004],
              [-108.55654740399989, 31.32739125600004],
              [-108.51383683299987, 31.32739125600004],
              [-108.47115209999988, 31.32739125600004],
              [-108.42844152899997, 31.32739125600004],
              [-108.38573095799987, 31.32739125600004],
              [-108.34302038599986, 31.32739125600004],
              [-108.30033565299996, 31.32739125600004],
              [-108.25757340499985, 31.32739125600004],
              [-108.21481115799992, 31.327442932000068],
              [-108.21486283399993, 31.334470927000055],
              [-108.21486283399993, 31.341550598000097],
              [-108.21486283399993, 31.348526917000086],
              [-108.21486283399993, 31.355554911000084],
              [-108.21486283399993, 31.36263458300003],
              [-108.21486283399993, 31.36966257800013],
              [-108.21486283399993, 31.37663889600013],
              [-108.21486283399993, 31.38371856700006],
              [-108.21486283399993, 31.390798239000063],
              [-108.21486283399993, 31.39782623300009],
              [-108.21486283399993, 31.404802552000078],
              [-108.21486283399993, 31.41188222300009],
              [-108.21486283399993, 31.418910218000107],
              [-108.21486283399993, 31.425938213000038],
              [-108.21486283399993, 31.432966208000025],
              [-108.21491451099986, 31.44004587800005],
              [-108.21496618699987, 31.447073873000065],
              [-108.21496618699987, 31.45410186800008],
              [-108.21496618699987, 31.461129862000078],
              [-108.21496618699987, 31.468157857000094],
              [-108.21496618699987, 31.475237529000097],
              [-108.21496618699987, 31.482213847000097],
              [-108.21496618699987, 31.489241842000027],
              [-108.21496618699987, 31.49632151300004],
              [-108.21496618699987, 31.503401184000055],
              [-108.21496618699987, 31.510377503000072],
              [-108.21496618699987, 31.51740549800006],
              [-108.21496618699987, 31.5244851690001],
              [-108.21496618699987, 31.5314614870001],
              [-108.21496618699987, 31.538489482],
              [-108.21496618699987, 31.54556915300013],
              [-108.21496618699987, 31.552597148000032],
              [-108.21501786399998, 31.559625143000048],
              [-108.21501786399998, 31.566653138000063],
              [-108.21501786399998, 31.573732808000088],
              [-108.21501786399998, 31.580760803000075],
              [-108.21501786399998, 31.58778879800009],
              [-108.21501786399998, 31.594816793000106],
              [-108.21501786399998, 31.601844788],
              [-108.21501786399998, 31.608872782000034],
              [-108.21501786399998, 31.615952454000038],
              [-108.21501786399998, 31.622980449000053],
              [-108.21501786399998, 31.63000844300008],
              [-108.21501786399998, 31.637036438000067],
              [-108.21501786399998, 31.644064433],
              [-108.21501786399998, 31.651092428000098],
              [-108.21501786399998, 31.658172099000026],
              [-108.2150695399999, 31.665148418000015],
              [-108.2151212169999, 31.67217641200004],
              [-108.2151212169999, 31.679256084000045],
              [-108.2151212169999, 31.68628407900006],
              [-108.2151212169999, 31.693312073000058],
              [-108.2151212169999, 31.7003917440001],
              [-108.2151212169999, 31.707419739],
              [-108.2151212169999, 31.714396057],
              [-108.2151212169999, 31.7214757280001],
              [-108.2151212169999, 31.728555400000047],
              [-108.2151212169999, 31.735583395000063],
              [-108.2151212169999, 31.742559713000063],
              [-108.2151212169999, 31.749639384000076],
              [-108.2151212169999, 31.756667379000092],
              [-108.2151212169999, 31.76369537400008],
              [-108.2151212169999, 31.770723369],
              [-108.2151212169999, 31.777751364000025],
              [-108.18928299999989, 31.777699687000094],
              [-108.16334143099994, 31.777648010000078],
              [-108.13750321499992, 31.777544657000064],
              [-108.11161332199988, 31.777544657000064],
              [-108.08572342899994, 31.777389629000098],
              [-108.05988521399993, 31.777389629000098],
              [-108.03399532099989, 31.777337952],
              [-108.00810542899987, 31.777234599000067],
              [-107.98221553599993, 31.77718292300007],
              [-107.9563773199999, 31.777131246000053],
              [-107.93048742799996, 31.777079569000122],
              [-107.90459753499994, 31.777027893000096],
              [-107.87875931799992, 31.77692454100007],
              [-107.85286942599988, 31.77692454100007],
              [-107.82697953299994, 31.776872864000083],
              [-107.80114131699993, 31.77676951100004],
              [-107.7752514249999, 31.776717835000042],
              [-107.74936153199987, 31.77666615800011],
              [-107.72347163999993, 31.776614482000085],
              [-107.6976334239999, 31.776562805000097],
              [-107.67174353099996, 31.776459453000072],
              [-107.64585363899994, 31.776459453000072],
              [-107.6199637459999, 31.776407776000056],
              [-107.59407385299995, 31.776304423000013],
              [-107.56818396099993, 31.7762527470001],
              [-107.5422940679999, 31.776201070000084],
              [-107.51640417599987, 31.776149394000086],
              [-107.49056595899994, 31.77609771700007],
              [-107.46467606599991, 31.77599436500013],
              [-107.43878617399987, 31.775942689000104],
              [-107.41289628199993, 31.7758393350001],
              [-107.3870322269999, 31.775787659000073],
              [-107.36114233399988, 31.775787659000073],
              [-107.33525244199986, 31.77568430600006],
              [-107.30941422599992, 31.77563262900013],
              [-107.28352433299989, 31.775529277000103],
              [-107.25763444099995, 31.775477601],
              [-107.23179622499993, 31.77542592400009],
              [-107.2059063319999, 31.775374248000062],
              [-107.18001643999987, 31.775374248000062],
              [-107.15412654699993, 31.775219218000117],
              [-107.1282883299999, 31.7751675410001],
              [-107.10239843799988, 31.7751675410001],
              [-107.07650854499994, 31.775064189],
              [-107.05067032899991, 31.77501251300008],
              [-107.02478043699998, 31.774960836000062],
              [-106.99889054399995, 31.774909160000036],
              [-106.97300065199991, 31.77485748300002],
              [-106.94711075899988, 31.77475413000009],
              [-106.92122086599994, 31.774702453000074],
              [-106.89533097399992, 31.774702453000074],
              [-106.86944108099988, 31.77459910100005],
              [-106.84360286499995, 31.77454742500005],
              [-106.81771297299993, 31.774495748000035],
              [-106.79182307999989, 31.774444072],
              [-106.76593318799986, 31.774392395000106],
              [-106.74009497099993, 31.774289042000063],
              [-106.7142050779999, 31.774237366000065],
              [-106.68831518599987, 31.774237366000065],
              [-106.66247696999994, 31.774134014000126],
              [-106.63658707699992, 31.774082337000024],
              [-106.61069718499988, 31.773978984000095],
              [-106.58485896899995, 31.77392730700008],
              [-106.55896907599993, 31.773875631000053],
              [-106.51718867999996, 31.773823954000036],
              [-106.50605240999994, 31.770258281000068],
              [-106.50142524799989, 31.766343684],
              [-106.49279740499993, 31.759044495000026],
              [-106.4731345219999, 31.75506540900004],
              [-106.4289511729999, 31.75847605400007],
              [-106.39176997999989, 31.74591868100005],
              [-106.35849035699995, 31.717548320000063],
              [-106.33130855399988, 31.68214996300013],
              [-106.3122916269999, 31.648611959000036],
              [-106.28629838099994, 31.580140687000025],
              [-106.2747486989999, 31.56262237600005],
              [-106.23265824399995, 31.519937643000063],
              [-106.2228913989999, 31.50458974200008],
              [-106.21873144499997, 31.494616191],
              [-106.21743953499993, 31.48872507700007],
              [-106.21542415499988, 31.48391917000008],
              [-106.2092488199999, 31.477304586000074],
              [-106.17447058199986, 31.46025136300004],
              [-106.1643161629999, 31.44779734300006],
              [-106.14111344499989, 31.439167379000097],
              [-106.09938472499995, 31.428883769000024],
              [-106.06530411899989, 31.410952047000038],
              [-106.04626135299992, 31.404647522000047],
              [-106.02114660699989, 31.40216705300007],
              [-106.00473933899993, 31.39694773400005],
              [-105.9612019459999, 31.371006165],
              [-105.94851538199995, 31.361239319000035],
              [-105.94177160699992, 31.352350973000043],
              [-105.93456274399996, 31.335504456000038],
              [-105.9280515139999, 31.3264610800001],
              [-105.90880204299987, 31.317004293000124],
              [-105.8971490079999, 31.30951121100007],
              [-105.89699397899996, 31.305997213000026],
              [-105.88014746199988, 31.30088124600003],
              [-105.86198319499994, 31.288375550000055],
              [-105.78483028199989, 31.21101593000013],
              [-105.77785396399989, 31.192722474000064],
              [-105.76819047099987, 31.180010071000098],
              [-105.69227779199993, 31.13763539600008],
              [-105.67522456899991, 31.131950989000032],
              [-105.66804154499995, 31.12786855100005],
              [-105.64380529799988, 31.10368398000007],
              [-105.62349645999986, 31.090351461000054],
              [-105.60587479699987, 31.08192820300006],
              [-105.5909403079999, 31.0714378870001],
              [-105.57864131699995, 31.05216257700006],
              [-105.56572220899994, 31.016660868000102],
              [-105.5559553639999, 31.002604879],
              [-105.53078894099987, 30.991701152000033],
              [-105.49668249599989, 30.95650950100007],
              [-105.41555049699994, 30.902455954000075],
              [-105.37617305599994, 30.85956451400004],
              [-105.36377071199988, 30.850366109000035],
              [-105.33431514499996, 30.843803202000046],
              [-105.2770059819999, 30.81941192600003],
              [-105.2707531339999, 30.81434763600005],
              [-105.26584387299997, 30.808404847000034],
              [-105.25948767099995, 30.802978821000053],
              [-105.2490490329999, 30.798844706000025],
              [-105.24398474199984, 30.7991030890001],
              [-105.23985062699991, 30.80153188100006],
              [-105.23287430899991, 30.80912831600004],
              [-105.22925695899993, 30.810213522000126],
              [-105.21824987899994, 30.806802877000095],
              [-105.21210038299996, 30.805717672000085],
              [-105.20491735899992, 30.802410381000087],
              [-105.1953055429999, 30.787940980000073],
              [-105.18512528499994, 30.784633688000085],
              [-105.17478999899993, 30.783961894000086],
              [-105.1672969169999, 30.781171367000027],
              [-105.16269771299994, 30.774918518000035],
              [-105.16088903799995, 30.764118144000108],
              [-105.15778845299991, 30.76572011300003],
              [-105.15324092699989, 30.763187969000043],
              [-105.14042517099989, 30.750475566],
              [-105.13360388299994, 30.757916972000103],
              [-105.08704341699989, 30.70980621400004],
              [-105.06812984299985, 30.70267486600001],
              [-105.04947465099988, 30.699264221000064],
              [-105.02797725499994, 30.690117493000102],
              [-105.00849523999995, 30.676991679000125],
              [-104.9957828379999, 30.661747132000087],
              [-104.99294063399992, 30.6514635220001],
              [-104.99164872299987, 30.640301412000056],
              [-104.98911657799988, 30.62955271400004],
              [-104.98276037599994, 30.620716044000048],
              [-104.97273514899993, 30.61802887],
              [-104.94105749599993, 30.61404978500012],
              [-104.9343395599999, 30.610535787000074],
              [-104.92824173999993, 30.59952870700009],
              [-104.89816605699987, 30.569401347000095],
              [-104.88659053599993, 30.551883037000025],
              [-104.88400671499993, 30.541857809000092],
              [-104.88214636299992, 30.520928854000104],
              [-104.87971757099986, 30.51085194900007],
              [-104.86302608299992, 30.502377015],
              [-104.8592537039999, 30.497261048],
              [-104.8596154389999, 30.49111155200002],
              [-104.86524816999993, 30.479897767000082],
              [-104.86669510999992, 30.47302480000009],
              [-104.86447302299992, 30.462017721],
              [-104.85465450099994, 30.448736877],
              [-104.85243241399985, 30.438866679000043],
              [-104.85362097299988, 30.423983866000086],
              [-104.85501623599994, 30.417472636000113],
              [-104.85325923699988, 30.41214996400008],
              [-104.8449393309999, 30.401039530000062],
              [-104.8375496019999, 30.394063212000063],
              [-104.82426875799989, 30.387190247],
              [-104.81827429199987, 30.380523987000075],
              [-104.81600052899985, 30.371997376000067],
              [-104.81496700099987, 30.360576884000054],
              [-104.81289994399991, 30.350706686000066],
              [-104.8077323009999, 30.346417541],
              [-104.78876704899994, 30.335927226000067],
              [-104.77414261999988, 30.311587627000037],
              [-104.7616885989999, 30.284199117000085],
              [-104.74938960899995, 30.264458721000054],
              [-104.74215490799989, 30.259859518],
              [-104.7245849209999, 30.252211406000114],
              [-104.71523148699987, 30.243994853000075],
              [-104.6958528239999, 30.208441467000014],
              [-104.68156429099992, 30.192938538000092],
              [-104.67867041099993, 30.170355937000082],
              [-104.68047908599992, 30.134130758000126],
              [-104.68463903799994, 30.111134746000076],
              [-104.69859167499995, 30.07527130100003],
              [-104.70158890799986, 30.055324199000026],
              [-104.69910843899989, 30.031449687000034],
              [-104.68047908599992, 29.97646596300008],
              [-104.68011734999992, 29.967784322000043],
              [-104.68246862899987, 29.952126363000062],
              [-104.68047908599992, 29.942307841000016],
              [-104.67652583899985, 29.936830140000026],
              [-104.6634775399999, 29.923084208],
              [-104.66063533599993, 29.918433330000127],
              [-104.65634619199996, 29.908201396000052],
              [-104.63758764699988, 29.88799591100006],
              [-104.62376420099991, 29.841487122000032],
              [-104.6196817629999, 29.83306386400004],
              [-104.60120743799989, 29.81477040700007],
              [-104.5835857749999, 29.802574768000042],
              [-104.57027909399997, 29.787511089000063],
              [-104.56139074799987, 29.745420634000098],
              [-104.54366573199985, 29.716430156000044],
              [-104.53710282499988, 29.702115784000043],
              [-104.53519079599994, 29.687853088000068],
              [-104.53503576699991, 29.67780202200005],
              [-104.53082413799987, 29.667905986000065],
              [-104.5166389579999, 29.65431508400006],
              [-104.46938085999996, 29.62540212],
              [-104.45522151799992, 29.613387350000053],
              [-104.45206925499987, 29.607108664000023],
              [-104.44855525799991, 29.597677714000056],
              [-104.44400773199987, 29.589202779000075],
              [-104.4378323979999, 29.585430399000032],
              [-104.43044266799988, 29.582794902000032],
              [-104.34902644899987, 29.53757802400004],
              [-104.33848445699991, 29.524012960000064],
              [-104.32060441199994, 29.532255351000103],
              [-104.29275081399987, 29.53282379200006],
              [-104.26717097999992, 29.52657094300004],
              [-104.25102209499994, 29.508587545000054],
              [-104.22714758399985, 29.49303293900003],
              [-104.21869848699995, 29.489829],
              [-104.21229060899991, 29.484661357000064],
              [-104.19451391599998, 29.44892710400005],
              [-104.16164770599995, 29.41675852500002],
              [-104.13978857399991, 29.4005838020001],
              [-104.10542374699988, 29.38567515000007],
              [-104.05731298899991, 29.3390371710001],
              [-104.01914994399993, 29.320330303],
              [-103.92812190799991, 29.293019308000098],
              [-103.86412064699991, 29.281366272000028],
              [-103.79417659599991, 29.277593893000088],
              [-103.78366044199994, 29.27480336500004],
              [-103.7742294929999, 29.26751698900007],
              [-103.76942358499988, 29.257543437000052],
              [-103.77771765199994, 29.235296733000027],
              [-103.77076717199995, 29.229844869000132],
              [-103.75906245999997, 29.226847637],
              [-103.74947648199986, 29.22297190400006],
              [-103.7024767669999, 29.187857768000114],
              [-103.67312455299992, 29.173569235000045],
              [-103.58499039699987, 29.154655660000103],
              [-103.55801529999994, 29.156205953000025],
              [-103.55023799699993, 29.154655660000103],
              [-103.54171138599992, 29.1488162240001],
              [-103.53822322699996, 29.142408345000078],
              [-103.53558772799994, 29.135121969000082],
              [-103.52974829199987, 29.12677622500003],
              [-103.47853694699985, 29.082050273000064],
              [-103.43569718499991, 29.061121318000076],
              [-103.42360489999992, 29.057865702000086],
              [-103.41463903799989, 29.05241383900001],
              [-103.38663041199987, 29.02879771],
              [-103.37208349699992, 29.02373341900004],
              [-103.3605338139999, 29.029831238000085],
              [-103.35167130599989, 29.039417217000093],
              [-103.34260209199991, 29.04122589200007],
              [-103.33048396899991, 29.02373341900004],
              [-103.32479956099988, 29.026808167000056],
              [-103.30999426299987, 29.031174825000036],
              [-103.31151447599987, 29.026042538000027],
              [-103.31624711199994, 29.010065002000104],
              [-103.30154516699986, 29.002365214000022],
              [-103.24175553499991, 29.003502096000133],
              [-103.18710770699995, 28.990221253000115],
              [-103.14798864799994, 28.985105286000035],
              [-103.12277054899988, 28.996474101000032],
              [-103.1092054849999, 29.023371684000026],
              [-103.10468379799997, 29.057865702000086],
              [-103.09535620199993, 29.060294495000065],
              [-103.0915321449999, 29.057865702000086],
              [-103.08558935599989, 29.075719910000046],
              [-103.08075760999988, 29.08520253600004],
              [-103.07254105599993, 29.091403707000026],
              [-103.0326210129999, 29.11021392800002],
              [-103.02427526899992, 29.116156718000028],
              [-103.01582617199992, 29.12677622500003],
              [-102.98838598699987, 29.1771349080001],
              [-102.9697566329999, 29.192844543000078],
              [-102.94753576699988, 29.182018331000037],
              [-102.94226477099994, 29.19020904600005],
              [-102.8968928629999, 29.220284730000046],
              [-102.86986608899987, 29.22478057900004],
              [-102.85878149399986, 29.22914723700005],
              [-102.86795406099995, 29.240386862],
              [-102.89213863099992, 29.254391175000094],
              [-102.89970922899997, 29.26389963800007],
              [-102.8993991699999, 29.276095276],
              [-102.88549820999991, 29.31480092400001],
              [-102.88518815199993, 29.333378601000064],
              [-102.88306941799995, 29.343765564000066],
              [-102.8769715989999, 29.350871073000107],
              [-102.86495682799993, 29.35952687600006],
              [-102.85986669999994, 29.361154683],
              [-102.85387223399992, 29.36099965500007],
              [-102.84656001899994, 29.361748963000068],
              [-102.83767167199991, 29.36632232700002],
              [-102.83803340699991, 29.370533956000045],
              [-102.84557816599997, 29.384719137],
              [-102.84454463699988, 29.390532736000083],
              [-102.83519120299985, 29.4038394170001],
              [-102.8349844979999, 29.415699158000038],
              [-102.8387052009999, 29.42693878200008],
              [-102.84113399299987, 29.438307597000076],
              [-102.8390669359999, 29.45195017500008],
              [-102.83395096899991, 29.46135528600003],
              [-102.8273105479999, 29.470502014000104],
              [-102.79547786499987, 29.54427012200007],
              [-102.78651200399992, 29.550497131000057],
              [-102.78075008199995, 29.55824859700006],
              [-102.78589188699995, 29.571813660000046],
              [-102.77646093799989, 29.575947774000056],
              [-102.77408382199994, 29.579616801000057],
              [-102.77966487699986, 29.59230336600011],
              [-102.76759842999988, 29.597290141000073],
              [-102.76134558099997, 29.603413798000034],
              [-102.75175960299988, 29.62015696200008],
              [-102.75165624999994, 29.622456564000103],
              [-102.73550736499996, 29.649509176000052],
              [-102.73126989799991, 29.65059438100006],
              [-102.72674820999988, 29.66449534100012],
              [-102.6977577319999, 29.70955719000007],
              [-102.69470882199997, 29.72061594700007],
              [-102.69362361799998, 29.729400940000048],
              [-102.69103979499988, 29.736816508000075],
              [-102.68346919799993, 29.74371531200005],
              [-102.67605362999991, 29.744490458000072],
              [-102.63874324599996, 29.74371531200005],
              [-102.62122493499992, 29.74728098600012],
              [-102.58530981499986, 29.764695944000053],
              [-102.5667579759999, 29.77105214400008],
              [-102.56288224299995, 29.76934682200003],
              [-102.55830887999991, 29.759089050000043],
              [-102.55314123599992, 29.756737773000097],
              [-102.54657832899993, 29.757874654000105],
              [-102.54334855199994, 29.760122579000026],
              [-102.54153987699995, 29.762473857000046],
              [-102.53112707599993, 29.769915263000073],
              [-102.52306555199993, 29.782317607000053],
              [-102.51528824899992, 29.7847205610001],
              [-102.40609594799986, 29.777279155000073],
              [-102.40413224299992, 29.780793152000015],
              [-102.38005102599989, 29.811385600000037],
              [-102.37658870499985, 29.82148834200008],
              [-102.37454748599988, 29.848101705000104],
              [-102.37072342999994, 29.857765198000052],
              [-102.36323034699991, 29.8642764290001],
              [-102.35106054799991, 29.86660186800013],
              [-102.33976924699994, 29.870632629000042],
              [-102.33023494499994, 29.888926087000087],
              [-102.32101070199994, 29.893938700000078],
              [-102.30217464199993, 29.889391174000124],
              [-102.28902299099985, 29.878125712000056],
              [-102.27618139699986, 29.86954742500005],
              [-102.25827551399989, 29.873474833],
              [-102.25344376599989, 29.855284729000076],
              [-102.23977534999996, 29.849135234000087],
              [-102.20367936299995, 29.846138001000085],
              [-102.15724808799985, 29.8245372520001],
              [-102.14564672899989, 29.815700582000105],
              [-102.10934403499992, 29.802109681000033],
              [-102.01459529599988, 29.810998027000025],
              [-101.98793025699985, 29.80518442800006],
              [-101.97224646099997, 29.81818105100008],
              [-101.95705358899994, 29.814046936000054],
              [-101.94266170299994, 29.803608297000025],
              [-101.9296134039999, 29.797717183000103],
              [-101.92015661699992, 29.798182271000044],
              [-101.91088069699991, 29.799887594000026],
              [-101.9023799239999, 29.803246562000126],
              [-101.89545528199992, 29.80862091100009],
              [-101.88741959699993, 29.81228993800009],
              [-101.87752355999994, 29.81084299700008],
              [-101.85760229499992, 29.80518442800006],
              [-101.82409012899993, 29.80518442800006],
              [-101.81269547499993, 29.812031556000093],
              [-101.8059775399999, 29.811928203],
              [-101.8029803059999, 29.801437887000034],
              [-101.79453120999989, 29.795856832000098],
              [-101.63221553599989, 29.77565134700002],
              [-101.58028072099988, 29.78156829800004],
              [-101.5649069829999, 29.78647756000008],
              [-101.55397741699993, 29.796683655000052],
              [-101.54976578799989, 29.815700582000105],
              [-101.54645849699989, 29.820144755000015],
              [-101.5391721199999, 29.817974345000025],
              [-101.53191158099993, 29.811101380000068],
              [-101.52860428999993, 29.801437887000034],
              [-101.53051631799987, 29.79647694900008],
              [-101.53968888399994, 29.779191182000076],
              [-101.54289282299992, 29.77105214400008],
              [-101.52180883899989, 29.765936178000075],
              [-101.50576330699992, 29.77389434800004],
              [-101.49028621499993, 29.785547384000026],
              [-101.47090755299986, 29.79151601200003],
              [-101.46243261799995, 29.78893219000004],
              [-101.45568884399992, 29.775909729],
              [-101.44610286499992, 29.77105214400008],
              [-101.43509578499993, 29.770121969000016],
              [-101.42421789599987, 29.771413880000082],
              [-101.4140117999999, 29.774411113],
              [-101.40509761599988, 29.77844187400008],
              [-101.40930924499992, 29.765781149000034],
              [-101.40654455599987, 29.752887879000056],
              [-101.39961991499989, 29.740718079000132],
              [-101.38336767599988, 29.718497213],
              [-101.37662390199993, 29.70064300500006],
              [-101.36435074999991, 29.676665141000043],
              [-101.3576844899999, 29.667440898000038],
              [-101.34902868699994, 29.660102845000026],
              [-101.33623876999988, 29.65431508400006],
              [-101.30978043599988, 29.65454762800003],
              [-101.30107295799992, 29.649509176000052],
              [-101.30272660399996, 29.6338512170001],
              [-101.31086564199988, 29.61276723300007],
              [-101.31215755199993, 29.597858581000125],
              [-101.30096960499989, 29.594137878000097],
              [-101.28358048499987, 29.60780629500003],
              [-101.25877579799992, 29.62015696200008],
              [-101.23391943399987, 29.622663269000057],
              [-101.21901078299992, 29.610286764000094],
              [-101.21777054899988, 29.58419016500001],
              [-101.22647802799995, 29.554450378000027],
              [-101.22278316299995, 29.540781962000025],
              [-101.21286128799994, 29.531583558000094],
              [-101.20177669299993, 29.530653382000068],
              [-101.19141556799993, 29.528147075000064],
              [-101.18270808899986, 29.5223593140001],
              [-101.16356197199985, 29.50130116800007],
              [-101.13477819799994, 29.487658590000066],
              [-101.06796057199998, 29.469494324000053],
              [-101.03778153599988, 29.460063375000075],
              [-101.02961665899996, 29.442984315000032],
              [-101.02594763199995, 29.41435557100006],
              [-101.02217525299993, 29.400480449],
              [-101.01623246299992, 29.390067648000056],
              [-101.00806758599991, 29.380585023],
              [-100.99830074099995, 29.372471822000065],
              [-100.9873970139999, 29.36632232700002],
              [-100.91473994999986, 29.337047628000064],
              [-100.89122717299995, 29.318547465000037],
              [-100.87179683499997, 29.296455791000128],
              [-100.86389034099993, 29.290616353000033],
              [-100.81608964099985, 29.270772604000044],
              [-100.79614253799993, 29.257672628000094],
              [-100.7831717539999, 29.24307403600004],
              [-100.76208776899996, 29.20865753200006],
              [-100.77009761699995, 29.187289327000073],
              [-100.76250118099998, 29.17377594],
              [-100.70973954299986, 29.135561218000092],
              [-100.70684566299987, 29.13018687000006],
              [-100.70203975499994, 29.12364980000008],
              [-100.6908259689999, 29.121014303000052],
              [-100.67816524299987, 29.119412334000017],
              [-100.66896683799987, 29.116208394000054],
              [-100.66085363799996, 29.102669169000066],
              [-100.65222367399991, 29.044817404000057],
              [-100.63279333499993, 29.00515574200007],
              [-100.62891760299989, 28.98433014000001],
              [-100.63790930199993, 28.962884420000094],
              [-100.6307779549999, 28.956683248],
              [-100.62669551599988, 28.948337504000037],
              [-100.62478348799996, 28.93776967400008],
              [-100.62431839999994, 28.924721375000033],
              [-100.61884069899995, 28.917925924000073],
              [-100.60695511999992, 28.910122782000045],
              [-100.59496618699987, 28.89932240800003],
              [-100.58954016199989, 28.883457743000108],
              [-100.58654292799987, 28.87978871700001],
              [-100.57176346899986, 28.873199972000023],
              [-100.56623409099986, 28.869789327],
              [-100.56334021099987, 28.86208953900011],
              [-100.5696964109999, 28.849609681000018],
              [-100.56623409099986, 28.842504171000073],
              [-100.55967118399988, 28.83937774700003],
              [-100.54515010599992, 28.838990174000045],
              [-100.53863887599995, 28.835631205000098],
              [-100.53445308499992, 28.83023101800005],
              [-100.52928544199992, 28.81994740800006],
              [-100.52499629799986, 28.814831441000067],
              [-100.51905350799984, 28.804961243],
              [-100.49393876199991, 28.708377991000035],
              [-100.4813813889999, 28.68605377300007],
              [-100.44489782699989, 28.643782450000074],
              [-100.44618973899993, 28.626496684000088],
              [-100.43482092299986, 28.619132793000077],
              [-100.4114631759999, 28.609314270000127],
              [-100.40143794799988, 28.602260437000027],
              [-100.3970971279999, 28.59272613500012],
              [-100.39875077399995, 28.56864491800006],
              [-100.39776892099988, 28.557586162000078],
              [-100.3842296959999, 28.53717397100003],
              [-100.36402421099991, 28.52479746500005],
              [-100.32263138899987, 28.51040557900005],
              [-100.35162186799994, 28.49671132500002],
              [-100.35678951099995, 28.48932159500002],
              [-100.3555492759999, 28.478185323],
              [-100.34831457599994, 28.470252991000038],
              [-100.34020137599994, 28.464258525],
              [-100.33632564399988, 28.458574117000055],
              [-100.33167476499992, 28.422013041000028],
              [-100.32263138899987, 28.3868989060001],
              [-100.29389929199995, 28.3534125770001],
              [-100.2785513919999, 28.33108835900002],
              [-100.27793127499991, 28.314887797000026],
              [-100.28433915299986, 28.29651682500004],
              [-100.27508907199986, 28.277241516000103],
              [-100.25793249499989, 28.260524191000044],
              [-100.2407242439999, 28.2496979780001],
              [-100.21281896999993, 28.245072938000064],
              [-100.20594600499996, 28.242876689000056],
              [-100.20294877199986, 28.234427592000074],
              [-100.20119177299996, 28.220345764000044],
              [-100.1976260989999, 28.207168274000068],
              [-100.18920283999991, 28.201328838000066],
              [-100.17287308799987, 28.198538310000018],
              [-100.07489457299995, 28.154406637000122],
              [-100.05649776199995, 28.137921855000045],
              [-100.0489013269999, 28.115959371000073],
              [-100.04802282699985, 28.102523499000128],
              [-100.04507727099985, 28.095288799000073],
              [-100.03153804599988, 28.081801250000083],
              [-100.01758540899989, 28.070949199000054],
              [-100.01019567899988, 28.06888214100009],
              [-100.01050573799995, 28.063611145000053],
              [-100.01350297099988, 28.05697072400004],
              [-100.01412308799985, 28.050459493000076],
              [-100.00745682799993, 28.033561300000073],
              [-100.00058386299987, 28.02040964800001],
              [-99.9911270759999, 28.007800599000078],
              [-99.97660599799985, 27.992452698000122],
              [-99.96185237699984, 27.987491760000083],
              [-99.9407167159999, 27.983254293000115],
              [-99.92828853399992, 27.975761210000073],
              [-99.93968318799992, 27.961085104000105],
              [-99.92991634199987, 27.946331482000076],
              [-99.91433589699993, 27.928244731000078],
              [-99.89676590999996, 27.91292266900011],
              [-99.88134049599996, 27.90646311500005],
              [-99.87880834999989, 27.901838074000082],
              [-99.88268408299993, 27.891580302000094],
              [-99.89128820899987, 27.87602569600007],
              [-99.88800675499988, 27.86481191000003],
              [-99.88020361399995, 27.859230856000025],
              [-99.87092769399993, 27.854476624000128],
              [-99.86335709699998, 27.845665792000133],
              [-99.86185847999988, 27.83607981400003],
              [-99.86472652299994, 27.814324036000116],
              [-99.86335709699998, 27.804660543000082],
              [-99.8582411299999, 27.803523662000075],
              [-99.84477941899993, 27.793575949000072],
              [-99.83297135499993, 27.782181295000086],
              [-99.83291967799991, 27.77675526900002],
              [-99.80816666699988, 27.77241444900004],
              [-99.80696277699992, 27.771423010000078],
              [-99.79542842699992, 27.76192413400007],
              [-99.7868501389999, 27.748488261000134],
              [-99.77457698599996, 27.735827535000098],
              [-99.76519771399991, 27.731176657000034],
              [-99.74734350599995, 27.726009013000024],
              [-99.74044470299988, 27.722159119000068],
              [-99.73631058799995, 27.713606669000043],
              [-99.73403682499993, 27.702031148000017],
              [-99.73065201899992, 27.691825053000045],
              [-99.72305558299986, 27.68738088000002],
              [-99.7106736549999, 27.670116197000098],
              [-99.70569230199993, 27.663170471000043],
              [-99.7003696299999, 27.659191386000074],
              [-99.66473872999991, 27.659398092000018],
              [-99.65869258599987, 27.654023743000053],
              [-99.64864151999984, 27.636918843000032],
              [-99.64486914099992, 27.63273305200009],
              [-99.63352616399993, 27.633068950000066],
              [-99.6124421789999, 27.64363678000005],
              [-99.60016902699996, 27.64642730700011],
              [-99.59024715199988, 27.6420606490001],
              [-99.57823238199991, 27.622811178000077],
              [-99.57226375399998, 27.618470358000096],
              [-99.5550296629999, 27.613509420000057],
              [-99.53503088399988, 27.604827779000104],
              [-99.51500626599993, 27.5886013800001],
              [-99.5072031249999, 27.573770244000073],
              [-99.50707393499997, 27.53343678800009],
              [-99.5100711669999, 27.510518291000082],
              [-99.50950272699993, 27.500027974000105],
              [-99.50368912899987, 27.495583802000013],
              [-99.48828955199987, 27.494653626000073],
              [-99.48040889499993, 27.4907778930001],
              [-99.47642980999986, 27.482509664000062],
              [-99.4729158129999, 27.468298645000104],
              [-99.4736392819999, 27.46380279600008],
              [-99.4729158129999, 27.42664744100007],
              [-99.47570633999995, 27.41476186200005],
              [-99.48462052399988, 27.391765849000095],
              [-99.48772111099991, 27.3718704220001],
              [-99.49288875399992, 27.358847961000052],
              [-99.49402563499993, 27.34820261700007],
              [-99.4975913089999, 27.338797506000034],
              [-99.51479956099988, 27.321795960000102],
              [-99.52136246799995, 27.311253967000127],
              [-99.4931988119999, 27.30128041600004],
              [-99.4865842289999, 27.29761138900004],
              [-99.48487890699994, 27.294820862000066],
              [-99.48294103999991, 27.28670766300006],
              [-99.48040889499993, 27.283297018000027],
              [-99.46896256599992, 27.27823272700006],
              [-99.46612036199994, 27.276527405000095],
              [-99.45183182799987, 27.261179504000026],
              [-99.4409022629999, 27.244798075000077],
              [-99.43402929799993, 27.226969706000133],
              [-99.43198807799988, 27.20759104400007],
              [-99.4357862959999, 27.18841908800006],
              [-99.45033321199986, 27.14516591400009],
              [-99.45245194599993, 27.125012106000028],
              [-99.45017818299992, 27.120464579],
              [-99.4457340089999, 27.11472849600004],
              [-99.44141902699994, 27.10749379500008],
              [-99.43940364599989, 27.09834706700009],
              [-99.4420391439999, 27.089613749000094],
              [-99.46172786499994, 27.05695424400004],
              [-99.44374446699996, 27.034578349000057],
              [-99.43986873399992, 27.028945618000122],
              [-99.42465002499998, 27.017886862000026],
              [-99.41604589899994, 27.014889628],
              [-99.40731258199988, 27.01452789300002],
              [-99.3993285729999, 27.012667542000102],
              [-99.39279150499992, 27.00476104800005],
              [-99.39015600599991, 26.993598938000034],
              [-99.39036271199987, 26.973135071000073],
              [-99.38617692099993, 26.962231344000102],
              [-99.3768493249999, 26.953756409],
              [-99.33698095699995, 26.92476593000002],
              [-99.32597387799987, 26.91153676300003],
              [-99.29396032799987, 26.876293437000058],
              [-99.2796717939999, 26.859653625000036],
              [-99.2627994389999, 26.8440473430001],
              [-99.24827836199987, 26.827097473],
              [-99.2340931799999, 26.78363759400007],
              [-99.22135493999994, 26.735733541000073],
              [-99.18112483799992, 26.629900208000024],
              [-99.17838598699987, 26.613673808],
              [-99.17128047699994, 26.563961080000084],
              [-99.1648725999999, 26.540448303000105],
              [-99.1409464109999, 26.531404928000043],
              [-99.11510819499996, 26.525617167000078],
              [-99.10299007199988, 26.51207794200009],
              [-99.09149206599996, 26.484017639000072],
              [-99.08937333299988, 26.471150208000083],
              [-99.09373999099996, 26.459781393000085],
              [-99.10252498399986, 26.446965637000105],
              [-99.10890702399989, 26.434253235000043],
              [-99.10642655499991, 26.423039450000104],
              [-99.08549759999993, 26.40763987200002],
              [-99.06635148099993, 26.40474599300002],
              [-99.04764461299995, 26.406968079000038],
              [-99.02787837799988, 26.40624460900004],
              [-99.02299495499994, 26.403350729000053],
              [-99.01643204799987, 26.394462383000032],
              [-99.01051509599995, 26.392602031000123],
              [-99.0040555419999, 26.39384226500006],
              [-98.98695064399995, 26.400095114000052],
              [-98.9628435879999, 26.399526673000096],
              [-98.95413610899993, 26.393945618000103],
              [-98.94537695399995, 26.378287659000037],
              [-98.92989986199986, 26.392240295000036],
              [-98.89302872799993, 26.36784902],
              [-98.87021358199993, 26.37213816300006],
              [-98.8605242519999, 26.366298727000085],
              [-98.85083492099996, 26.36407664000008],
              [-98.84233414799986, 26.36583363900006],
              [-98.83608129899996, 26.37213816300006],
              [-98.82502254299995, 26.36645375600004],
              [-98.81732275399987, 26.368520813000075],
              [-98.81029475999995, 26.372448222000045],
              [-98.80132889899991, 26.37213816300006],
              [-98.79585119699993, 26.368314108000035],
              [-98.78083919299985, 26.351674296000013],
              [-98.7463968509999, 26.332140605000106],
              [-98.73593237299986, 26.32004832000011],
              [-98.73991145899993, 26.30325347900005],
              [-98.72621720399991, 26.304390360000056],
              [-98.71316890499986, 26.30335683300008],
              [-98.70141251699997, 26.299119365000124],
              [-98.69146480399988, 26.290231019000103],
              [-98.70425472099993, 26.276640117000014],
              [-98.7022393389999, 26.27162750300006],
              [-98.69332515499988, 26.270542298000052],
              [-98.6852894699999, 26.26847524],
              [-98.6646964119999, 26.250646871000058],
              [-98.6536634929999, 26.24429067000004],
              [-98.64056351799994, 26.241810201000064],
              [-98.58162654599991, 26.262274068000025],
              [-98.5527910969999, 26.24832143100012],
              [-98.5215268559999, 26.240931702000026],
              [-98.49294978899994, 26.230596415000022],
              [-98.47238256899993, 26.207652079000084],
              [-98.45654374199984, 26.225945536000054],
              [-98.4288451749999, 26.217728984000118],
              [-98.3971933599999, 26.20114084900011],
              [-98.36933976299994, 26.19400950200007],
              [-98.37727209499991, 26.17364898700005],
              [-98.37727209499991, 26.16357208300009],
              [-98.36577408899987, 26.16016143800006],
              [-98.33926407899989, 26.15985138000009],
              [-98.33303706899997, 26.15303009000003],
              [-98.30980851299995, 26.121094056000047],
              [-98.30042924099993, 26.111430562000024],
              [-98.22265620999988, 26.07541208900004],
              [-98.18506160499987, 26.065231832000066],
              [-98.15023168999991, 26.063681539000058],
              [-98.1031027839999, 26.074947001000012],
              [-98.08331071099994, 26.07091624000013],
              [-98.0751458339999, 26.046628317000042],
              [-98.06545650299998, 26.04218414300003],
              [-98.04416581299989, 26.0487987260001],
              [-98.01305659999994, 26.063681539000058],
              [-97.99923315399988, 26.06430165600004],
              [-97.94166560999994, 26.0568085740001],
              [-97.87818111199991, 26.063733215000084],
              [-97.80201005099991, 26.063733215000084],
              [-97.78232132999995, 26.05861724900008],
              [-97.78030594899991, 26.043217672000097],
              [-97.76694759099988, 26.039651998000025],
              [-97.67961442099994, 26.034639385000062],
              [-97.65987402399989, 26.030660299000075],
              [-97.64145137499989, 26.02249542300008],
              [-97.62264115499997, 26.009059550000117],
              [-97.61305517699995, 25.99598541300007],
              [-97.60478694699992, 25.97996571900002],
              [-97.59432246899988, 25.96637481800012],
              [-97.56517696199987, 25.95474762000005],
              [-97.52027014199984, 25.91278635700006],
              [-97.50220922899985, 25.90188263],
              [-97.48631872599992, 25.895733134000025],
              [-97.46942053299992, 25.89294260700008],
              [-97.44825903299997, 25.892322490000097],
              [-97.4413085539999, 25.884932760000098],
              [-97.43572749899997, 25.86927480100003],
              [-97.42541805099987, 25.8548570760001],
              [-97.40417903699989, 25.85139475600009],
              [-97.39988989299994, 25.85511545900009],
              [-97.39947648199993, 25.861161601000035],
              [-97.39782283599988, 25.86581248],
              [-97.38989050399991, 25.865657451000047],
              [-97.38312089099989, 25.860541484000052],
              [-97.38012365799997, 25.85320343100007],
              [-97.37601538199993, 25.846743877],
              [-97.36599015299993, 25.843901673000047],
              [-97.34573299199991, 25.852221578000112],
              [-97.34516455099987, 25.871703593000106],
              [-97.3522700609999, 25.8944928990001],
              [-97.35511226399987, 25.91278635700006],
              [-97.35110734099987, 25.91841908800008],
              [-97.32844722499993, 25.933301900000046],
              [-97.31098059099989, 25.92208811400009],
              [-97.28764868199994, 25.92865102100008],
              [-97.26920019499994, 25.944360657000047],
              [-97.26635799199994, 25.960638733000067],
              [-97.25305130999993, 25.96348093700003],
              [-97.20494055199987, 25.960638733000067],
              [-97.13927161399994, 25.96580638200004],
            ],
          ],
          [
            [
              [-114.77554277299993, 18.35492584800005],
              [-114.72402910099993, 18.35492584800005],
              [-114.72020423099991, 18.352118231000077],
              [-114.72085527299993, 18.34568919500009],
              [-114.7239477199999, 18.33856842700004],
              [-114.72716223899994, 18.333807684000078],
              [-114.73403886599993, 18.329250393000052],
              [-114.74058997299994, 18.32831452000005],
              [-114.7473852199999, 18.328680731000077],
              [-114.78189042899993, 18.32453034100007],
              [-114.79857337099992, 18.330877997000073],
              [-114.79857337099992, 18.34247467700004],
              [-114.77554277299993, 18.35492584800005],
            ],
          ],
          [
            [
              [-110.94591223899994, 18.799994208000044],
              [-110.93224036399994, 18.794663804000038],
              [-110.91942298099991, 18.78070709800005],
              [-110.91120357999995, 18.762518622000073],
              [-110.91120357999995, 18.744696356000077],
              [-110.92430579299992, 18.727362372000073],
              [-110.94188391799992, 18.72597890800006],
              [-110.96117102799991, 18.726955471000053],
              [-110.97948157499991, 18.71678294500009],
              [-110.99461829299992, 18.731594143000052],
              [-111.00837154899995, 18.74237702000005],
              [-111.02318274599992, 18.750921942000048],
              [-111.06725012899994, 18.768744208000044],
              [-111.06655839799993, 18.77570221600007],
              [-111.06200110599991, 18.793117580000057],
              [-111.05308997299994, 18.81598541900007],
              [-111.03856360599991, 18.83539459800005],
              [-111.00055904899995, 18.86823151200008],
              [-110.9800512359999, 18.86082591400009],
              [-110.95616614499994, 18.843695380000042],
              [-110.94078528599994, 18.82172272300005],
              [-110.94591223899994, 18.799994208000044],
            ],
          ],
          [
            [
              [-110.81432044199994, 19.348049221000053],
              [-110.80565344999991, 19.34210846600007],
              [-110.79865475199995, 19.333807684000078],
              [-110.78766842399995, 19.31391022300005],
              [-110.81309973899994, 19.29633209800005],
              [-110.82408606699994, 19.286281643000052],
              [-110.82860266799992, 19.27570221600007],
              [-110.83023027299993, 19.27334219000005],
              [-110.83348548099991, 19.27635325700004],
              [-110.83617102799991, 19.283596096000053],
              [-110.83604895699995, 19.293402411000045],
              [-110.83238684799994, 19.30219147300005],
              [-110.81920325399994, 19.324042059000078],
              [-110.81432044199994, 19.334377346000053],
              [-110.81432044199994, 19.348049221000053],
            ],
          ],
          [
            [
              [-106.2240376009999, 21.328735901000073],
              [-106.22573969099994, 21.308668959000045],
              [-106.2275059619999, 21.29116570900004],
              [-106.23697185899994, 21.29506652000009],
              [-106.24730951999993, 21.289698507000082],
              [-106.2701965419999, 21.300997418000065],
              [-106.2793633789999, 21.314658975000043],
              [-106.26000511599995, 21.334096877000036],
              [-106.24178269399994, 21.33296387100006],
              [-106.23191740099992, 21.335237076000055],
              [-106.22744588799992, 21.33276854400009],
              [-106.2240376009999, 21.328735901000073],
            ],
          ],
          [
            [
              [-106.40421775099992, 21.483885817000044],
              [-106.38599027899994, 21.48276668400007],
              [-106.37272832899993, 21.482046343000036],
              [-106.37192408599992, 21.471799066000074],
              [-106.36288746199995, 21.464307183000074],
              [-106.36264428099992, 21.45507439100004],
              [-106.38065409599994, 21.446987422000063],
              [-106.38462786999992, 21.43147294000005],
              [-106.3870980609999, 21.42063577600004],
              [-106.4026073519999, 21.422952328000065],
              [-106.42882562099993, 21.435094921000086],
              [-106.4437093489999, 21.436839228000053],
              [-106.4592758469999, 21.448321668000062],
              [-106.4787473799999, 21.451401902000043],
              [-106.49261366699994, 21.46900464500004],
              [-106.47198508199995, 21.48384143000004],
              [-106.4595874499999, 21.49488474900005],
              [-106.4485300259999, 21.493095749000076],
              [-106.43706217599993, 21.49594584400006],
              [-106.42472209199991, 21.48802382000008],
              [-106.40421775099992, 21.483885817000044],
            ],
          ],
          [
            [
              [-106.51235262799992, 21.59703438200006],
              [-106.5160081809999, 21.588751779000063],
              [-106.51407658599993, 21.57903635200006],
              [-106.5116644389999, 21.57189577400004],
              [-106.51986177299995, 21.568143128000088],
              [-106.5208069279999, 21.562471823000067],
              [-106.52615644999992, 21.556679212000063],
              [-106.53205055899991, 21.550369398000043],
              [-106.5323609699999, 21.541629253000053],
              [-106.53685815499995, 21.544603513000084],
              [-106.54179406799994, 21.54345926700006],
              [-106.54084847899992, 21.54914135200005],
              [-106.53771141399994, 21.555386187000067],
              [-106.54506495499993, 21.561892414000056],
              [-106.5522885929999, 21.563762095000072],
              [-106.59126768399994, 21.57722481500008],
              [-106.63115564399993, 21.600860513000043],
              [-106.63009297899993, 21.604493492000074],
              [-106.62853903599995, 21.609152522000045],
              [-106.62875933899994, 21.61683733700005],
              [-106.6355638899999, 21.62589748700009],
              [-106.64163068499994, 21.63910615000009],
              [-106.65139358399995, 21.652216620000047],
              [-106.65598550599992, 21.658265680000056],
              [-106.6494767019999, 21.662531711000042],
              [-106.6492159799999, 21.672806739000066],
              [-106.65064252699995, 21.68406887000009],
              [-106.6608476159999, 21.69306395500007],
              [-106.64215669399994, 21.696598633000065],
              [-106.62098152399994, 21.690434647000075],
              [-106.60001273099994, 21.69145196800008],
              [-106.58766558799994, 21.68456126800004],
              [-106.54800391099991, 21.668545934000065],
              [-106.53445774699992, 21.657571309000048],
              [-106.53642576499993, 21.64827092300004],
              [-106.53942568899993, 21.636397627000065],
              [-106.52690855399993, 21.623896266000088],
              [-106.51896979799994, 21.616897592000043],
              [-106.51378643899994, 21.60881008000007],
              [-106.50926665799994, 21.605320530000085],
              [-106.50478224299991, 21.602859498000043],
              [-106.51235262799992, 21.59703438200006],
            ],
          ],
          [
            [
              [-106.66382290899992, 21.777245607000054],
              [-106.6630470959999, 21.76955433900008],
              [-106.65799745999993, 21.767105653000044],
              [-106.65596502599993, 21.754301570000052],
              [-106.66349972799992, 21.746932291000064],
              [-106.65776606599991, 21.739877617000047],
              [-106.67896341999995, 21.727035999000066],
              [-106.68894070399995, 21.746831544000088],
              [-106.6839086579999, 21.760972398000035],
              [-106.6781389759999, 21.77484558900005],
              [-106.67141441799993, 21.771923195000056],
              [-106.66382290899992, 21.777245607000054],
            ],
          ],
          [
            [
              [-109.83574974399994, 24.22465432900009],
              [-109.82284859099991, 24.209405591000063],
              [-109.80856253399992, 24.182221868000056],
              [-109.8071475349999, 24.171565618000045],
              [-109.79842518999993, 24.155164565000064],
              [-109.80286510999991, 24.137062296000067],
              [-109.8148435299999, 24.140431111000055],
              [-109.83101246299992, 24.143511042000057],
              [-109.8624826699999, 24.147087282000086],
              [-109.8739270779999, 24.151702835000037],
              [-109.87176125199994, 24.159690718000036],
              [-109.88504423799992, 24.17665820900004],
              [-109.90043209999993, 24.19924080800007],
              [-109.91297210499994, 24.235720661000073],
              [-109.92387530899992, 24.266637803000037],
              [-109.9211799279999, 24.275815512000065],
              [-109.91662099599995, 24.284812325000075],
              [-109.93742544899993, 24.325148634000072],
              [-109.9342336329999, 24.359386],
              [-109.9332203749999, 24.374414236000064],
              [-109.92675140499995, 24.37292955500004],
              [-109.9192461589999, 24.362028983000073],
              [-109.91741307099994, 24.348511088000066],
              [-109.90584407499995, 24.334834182000066],
              [-109.89969417399993, 24.325687604000052],
              [-109.89215525599991, 24.316288133000057],
              [-109.88233080599991, 24.29428587800004],
              [-109.87063098199991, 24.27235586200004],
              [-109.85808965299992, 24.258939500000054],
              [-109.84257144299994, 24.230300382000053],
              [-109.83574974399994, 24.22465432900009],
            ],
          ],
          [
            [
              [-111.56163489499994, 24.378078518000052],
              [-111.5394508839999, 24.372666735000053],
              [-111.50963294199994, 24.36395905200004],
              [-111.46709409399995, 24.33673168900009],
              [-111.4629578979999, 24.329770950000068],
              [-111.53281673899994, 24.35831156900008],
              [-111.56125257199994, 24.36236705300007],
              [-111.59724512799994, 24.365109379000046],
              [-111.63836643299993, 24.35570348400006],
              [-111.66481439899991, 24.351855932000035],
              [-111.67325405399993, 24.358400544000062],
              [-111.66546126499992, 24.36901188300004],
              [-111.6577775699999, 24.37521720600006],
              [-111.6460495369999, 24.371051097000077],
              [-111.6287980169999, 24.372644277000063],
              [-111.60018725499992, 24.376440140000057],
              [-111.58299852699992, 24.375088554000058],
              [-111.56163489499994, 24.378078518000052],
            ],
          ],
          [
            [
              [-111.7534887359999, 24.446966864000046],
              [-111.72420777799994, 24.396167005000052],
              [-111.70620517899994, 24.37981757600005],
              [-111.69474867999992, 24.381188915000052],
              [-111.6923174989999, 24.373939418000077],
              [-111.69975163899994, 24.358923824000044],
              [-111.69386709299994, 24.347602274000053],
              [-111.7012644539999, 24.330945383000085],
              [-111.7103545459999, 24.318345521000083],
              [-111.70811069699994, 24.29985435800006],
              [-111.73883500699992, 24.338117159000035],
              [-111.75856116599994, 24.356101453000065],
              [-111.80780339199993, 24.38907488400008],
              [-111.84575211999993, 24.41781456600006],
              [-111.87158328599992, 24.439098904000048],
              [-111.90802733499993, 24.45738591500009],
              [-111.9148817279999, 24.464710549000074],
              [-111.92621743699993, 24.468124111000066],
              [-111.94078989499991, 24.483586751000075],
              [-111.9755938749999, 24.49783229800005],
              [-112.00175417299994, 24.50631284700006],
              [-112.0068437249999, 24.51440004200009],
              [-111.98897432699994, 24.52765388100005],
              [-111.97161083099991, 24.51853605100007],
              [-111.96019613599992, 24.51832095700007],
              [-111.90484224099993, 24.518864115000042],
              [-111.88115444499994, 24.51760676500004],
              [-111.8643953539999, 24.52047869100005],
              [-111.85059021099994, 24.509819021000055],
              [-111.83734329099991, 24.512756229000047],
              [-111.83852555099992, 24.499991039000065],
              [-111.83095280399993, 24.486254022000082],
              [-111.82143053099992, 24.48047117400006],
              [-111.81823229199995, 24.467621027000064],
              [-111.7982023479999, 24.46403541500007],
              [-111.77547727599995, 24.461988059000078],
              [-111.7534887359999, 24.446966864000046],
            ],
          ],
          [
            [
              [-110.32494055899991, 24.51585521000004],
              [-110.31522154699991, 24.50455830100009],
              [-110.3050024079999, 24.503159898000035],
              [-110.3023501809999, 24.488769550000086],
              [-110.2958527539999, 24.47688661600006],
              [-110.28786260899994, 24.469741671000065],
              [-110.29234573699995, 24.45818525900006],
              [-110.30651301699993, 24.456491962000086],
              [-110.31273352799991, 24.44668203300006],
              [-110.30785071499992, 24.43268463700008],
              [-110.3172094389999, 24.426214911000045],
              [-110.3225805329999, 24.417303778000075],
              [-110.3265047619999, 24.400748607000082],
              [-110.34804007899993, 24.402450981000072],
              [-110.34886633999992, 24.411444403000075],
              [-110.35274593799994, 24.418000290000066],
              [-110.34883727499994, 24.429574826000078],
              [-110.3550626469999, 24.435071164000078],
              [-110.36318734499991, 24.436372359000075],
              [-110.3704264779999, 24.42967789800008],
              [-110.37244100599992, 24.43876883300004],
              [-110.37565919399992, 24.44683193900005],
              [-110.35863514599993, 24.45219963900007],
              [-110.3601619509999, 24.457545576000086],
              [-110.36706995999992, 24.458800171000064],
              [-110.36863507399994, 24.464158732000044],
              [-110.37724721699993, 24.46812852900007],
              [-110.38463989399992, 24.473656319000042],
              [-110.38902736499995, 24.48228272600005],
              [-110.39199039099992, 24.497767921000047],
              [-110.38764858399992, 24.505600723000043],
              [-110.39676958199993, 24.511183282000047],
              [-110.39591375299995, 24.519119929000055],
              [-110.38290852099993, 24.524046609000038],
              [-110.3762316399999, 24.530767280000077],
              [-110.38509918199992, 24.529389449000064],
              [-110.3959660559999, 24.53502673400004],
              [-110.39444292699994, 24.546094078000067],
              [-110.40557110799995, 24.54380431700008],
              [-110.4076532919999, 24.55128184000006],
              [-110.40332378499994, 24.55907602800005],
              [-110.41250187599991, 24.56257994000009],
              [-110.4157449729999, 24.56960144800007],
              [-110.40021137499991, 24.581266476000053],
              [-110.39750663199993, 24.59080501400007],
              [-110.38649662099994, 24.586863813000036],
              [-110.38052283399992, 24.57495772100009],
              [-110.37436556599994, 24.56683545900006],
              [-110.36363635499993, 24.556947663000074],
              [-110.3605270789999, 24.546743507000087],
              [-110.36398941999994, 24.532488947000047],
              [-110.3459234959999, 24.53039492100004],
              [-110.32494055899991, 24.51585521000004],
            ],
          ],
          [
            [
              [-110.71079188599992, 25.095047107000084],
              [-110.70870678799992, 25.102208052000037],
              [-110.70689963799992, 25.105136333000075],
              [-110.70202038799994, 25.103374973000086],
              [-110.6949982349999, 25.093982836000066],
              [-110.68475232799995, 25.06618603700008],
              [-110.66862540999995, 25.05277324800005],
              [-110.64231949299995, 25.049226687000044],
              [-110.61412512899994, 25.041937567000048],
              [-110.59309239099991, 25.03444734900006],
              [-110.59022830599991, 25.02612204400009],
              [-110.5836467659999, 25.022437961000037],
              [-110.5749164689999, 25.015727364000043],
              [-110.57569567099995, 25.005967387000055],
              [-110.5683624379999, 24.997681793000083],
              [-110.56580686399991, 24.980569350000053],
              [-110.57069197499993, 24.95549260100006],
              [-110.55928946099993, 24.935704142000077],
              [-110.55335291499995, 24.92582326200005],
              [-110.54847203899993, 24.911490180000044],
              [-110.53397131199995, 24.890802534000045],
              [-110.52492856899994, 24.880000918000064],
              [-110.53309552299993, 24.876578652000035],
              [-110.55335630899992, 24.872682024000085],
              [-110.56271729299993, 24.87375736900009],
              [-110.57170343799993, 24.872381827000083],
              [-110.5791528869999, 24.86366181200009],
              [-110.58353889199992, 24.866218003000085],
              [-110.57931286699994, 24.872187285000052],
              [-110.57370606199993, 24.879335815000047],
              [-110.5738800119999, 24.887454611000067],
              [-110.58399245899994, 24.892602441000065],
              [-110.59536165399993, 24.90021637700005],
              [-110.61035802099991, 24.90630599800005],
              [-110.61019330599993, 24.911166024000067],
              [-110.62030189699993, 24.91672414800007],
              [-110.6319909419999, 24.915431955000088],
              [-110.64231341499993, 24.914497534000077],
              [-110.64165134199993, 24.920972040000038],
              [-110.63649964099994, 24.927725502000044],
              [-110.6440234509999, 24.94250263100008],
              [-110.65468291699995, 24.94607318000004],
              [-110.66040546199991, 24.96245745200008],
              [-110.66013538699991, 24.970982727000035],
              [-110.66565583499994, 24.98006119900009],
              [-110.67301917799995, 24.987986253000088],
              [-110.67403704999992, 24.997328081000035],
              [-110.67583788799993, 25.01119781200009],
              [-110.68224833499994, 25.020289296000044],
              [-110.69693856499993, 25.01975555900009],
              [-110.70494139999994, 25.029921422000086],
              [-110.71328177499993, 25.029215408000084],
              [-110.71655063599991, 25.039890378000052],
              [-110.71651205799992, 25.05406544300007],
              [-110.71306259599993, 25.062019201000055],
              [-110.71349036399994, 25.075018622000073],
              [-110.71079188599992, 25.095047107000084],
            ],
          ],
          [
            [
              [-112.10348531499994, 24.617166414000053],
              [-112.09634306999993, 24.607004017000065],
              [-112.07808494099993, 24.58483726700007],
              [-112.07091075599993, 24.58517794900007],
              [-112.0709482769999, 24.57395338200007],
              [-112.0645940149999, 24.568160634000037],
              [-112.0574777469999, 24.553690517000064],
              [-112.05990735599994, 24.540602578000062],
              [-112.0682659549999, 24.542448684000078],
              [-112.09134153899993, 24.551534022000055],
              [-112.10247783699992, 24.559152037000047],
              [-112.1000679089999, 24.564234767000073],
              [-112.10558606299992, 24.583818767000082],
              [-112.11386196299992, 24.59916626000006],
              [-112.1270149639999, 24.611790559000042],
              [-112.13733249099994, 24.61908889500006],
              [-112.14653348799993, 24.618710786000065],
              [-112.1592155859999, 24.643023274000086],
              [-112.17197412299993, 24.646668426000076],
              [-112.17634372899994, 24.653562288000046],
              [-112.16834392099992, 24.66115747400005],
              [-112.16632563799993, 24.67093667000006],
              [-112.15993740399995, 24.672373487000073],
              [-112.15196333099993, 24.670545450000077],
              [-112.14478550299992, 24.67089158600004],
              [-112.13838146199993, 24.680296655000063],
              [-112.13593802899993, 24.69804552800008],
              [-112.1394817229999, 24.714721162000046],
              [-112.14621608099992, 24.732128918000058],
              [-112.15576430199991, 24.743385225000054],
              [-112.16771031799993, 24.755373340000062],
              [-112.17567392399991, 24.763364067000055],
              [-112.18953347099995, 24.773923376000084],
              [-112.20677649599992, 24.782131252000056],
              [-112.21385065599992, 24.784838708000052],
              [-112.2246186299999, 24.78811879600005],
              [-112.23778533699993, 24.789227892000042],
              [-112.24596106699994, 24.788763739000046],
              [-112.2505451319999, 24.787795561000053],
              [-112.25693038799994, 24.783819839000046],
              [-112.26093235699994, 24.77658198900008],
              [-112.26095585799993, 24.769700153000088],
              [-112.25781435599993, 24.751578125000037],
              [-112.2594127729999, 24.74940725600004],
              [-112.26857633999992, 24.75811605000007],
              [-112.2725319239999, 24.772977454000056],
              [-112.30459550699993, 24.792181708000044],
              [-112.30163741799993, 24.803093277000073],
              [-112.30202996299994, 24.80744214100008],
              [-112.30002897599991, 24.809975869000084],
              [-112.29003319299994, 24.812495007000052],
              [-112.27518191199994, 24.83951262000005],
              [-112.25733971099993, 24.884474586000067],
              [-112.2063022829999, 25.01766045800008],
              [-112.1907445949999, 25.062974351000037],
              [-112.16322417099991, 25.156268241000078],
              [-112.14452063699991, 25.227769273000035],
              [-112.14249481099989, 25.25513247200007],
              [-112.13784646199991, 25.265260829000056],
              [-112.12532590599994, 25.265833482000062],
              [-112.1202239939999, 25.22052060100009],
              [-112.1268761039999, 25.201467647000072],
              [-112.1434630519999, 25.162781904000042],
              [-112.15603391299993, 25.14077327600006],
              [-112.16937150899992, 25.073534125000037],
              [-112.17930364599994, 25.044985661000055],
              [-112.17083786099994, 25.029572655000038],
              [-112.1673192689999, 25.019389709000052],
              [-112.16971930999995, 25.006005860000073],
              [-112.1641298859999, 24.996891562000087],
              [-112.16149471499995, 24.988050817000044],
              [-112.1618270589999, 24.974397215000067],
              [-112.1701095709999, 24.96959576900008],
              [-112.17895712699993, 24.974700467000048],
              [-112.18696375799993, 24.96133111900008],
              [-112.18875719699992, 24.95223261600006],
              [-112.1873535769999, 24.92170919600005],
              [-112.19592968799992, 24.915300649000073],
              [-112.19096971599993, 24.889849179000066],
              [-112.18331850699991, 24.879654277000043],
              [-112.17686468599993, 24.872387684000046],
              [-112.18255662099995, 24.865960379000057],
              [-112.19532299499991, 24.867272565000064],
              [-112.20430994599991, 24.86686072300006],
              [-112.20716100899995, 24.860857139000075],
              [-112.20930587599992, 24.85512948300004],
              [-112.21371500299995, 24.84752651000008],
              [-112.21093858199993, 24.83882314600004],
              [-112.20897563599993, 24.823599279000064],
              [-112.20619494699991, 24.817434121000076],
              [-112.19582969599992, 24.81161667400005],
              [-112.18785962099992, 24.806166062000045],
              [-112.18228772899994, 24.79963311700004],
              [-112.1787056199999, 24.795640332000062],
              [-112.17112540699992, 24.794537781000088],
              [-112.1731264789999, 24.792367994000074],
              [-112.17752014099995, 24.790927773000078],
              [-112.17593001599994, 24.78838837300009],
              [-112.16558736899992, 24.77568580600007],
              [-112.16211193499993, 24.759709437000083],
              [-112.1390187579999, 24.737909984000055],
              [-112.1314646589999, 24.72847092300009],
              [-112.13070253799992, 24.715787315000057],
              [-112.13111923899993, 24.709628569000074],
              [-112.1271395689999, 24.70635827600006],
              [-112.12314905999995, 24.707073139000045],
              [-112.11562348799993, 24.689301038000053],
              [-112.12643687199994, 24.673747081000045],
              [-112.1316392949999, 24.666875547000075],
              [-112.14002912399991, 24.65928849800008],
              [-112.1432344079999, 24.64988240300005],
              [-112.14043902599991, 24.64373442400006],
              [-112.13646363599992, 24.63288190700007],
              [-112.10348531499994, 24.617166414000053],
            ],
          ],
          [
            [
              [-108.8316137359999, 25.42641836100006],
              [-108.81883704299992, 25.420803127000056],
              [-108.79930579299992, 25.39411041900007],
              [-108.78652910099993, 25.38544342700004],
              [-108.80394446499992, 25.37457916900007],
              [-108.83657792899993, 25.38812897300005],
              [-108.87246660099993, 25.40884023600006],
              [-108.89981035099993, 25.419623114000046],
              [-108.9070531889999, 25.420355536000045],
              [-108.9160863919999, 25.42446523600006],
              [-108.92373613199993, 25.42641836100006],
              [-108.93248450399994, 25.42731354400007],
              [-108.99400794199994, 25.42674388200004],
              [-109.00796464799993, 25.432562567000048],
              [-109.01309160099993, 25.446926174000055],
              [-108.90099036399994, 25.446519273000035],
              [-108.88272050699993, 25.443182684000078],
              [-108.8316137359999, 25.42641836100006],
            ],
          ],
          [
            [
              [-110.7652924809999, 25.59393941700006],
              [-110.7858862409999, 25.60436900500008],
              [-110.80553198399991, 25.644418101000042],
              [-110.80356054299995, 25.67493264400008],
              [-110.7919430259999, 25.695302068000046],
              [-110.7824740399999, 25.710334678000038],
              [-110.7734142509999, 25.712794990000077],
              [-110.77000389099993, 25.69562729800009],
              [-110.76206207599989, 25.693617526000082],
              [-110.76668353999992, 25.67578554100004],
              [-110.75961292199992, 25.64775568300007],
              [-110.75318694899994, 25.598095819000036],
              [-110.7652924809999, 25.59393941700006],
            ],
          ],
          [
            [
              [-111.0811938309999, 25.998658402000046],
              [-111.07000793899994, 25.99703904800009],
              [-111.07084954899995, 25.98606181200006],
              [-111.06534376799993, 25.982723084000042],
              [-111.06566210499994, 25.97219318200007],
              [-111.06738623799993, 25.965818013000046],
              [-111.07231128799992, 25.971434832000057],
              [-111.07941373699992, 25.97251975100005],
              [-111.08677798199994, 25.98185686700009],
              [-111.09381556299991, 25.98522699700004],
              [-111.10111427099991, 25.99685113700008],
              [-111.11233049999993, 25.99665954900007],
              [-111.1196184879999, 25.99221775700005],
              [-111.11926233999992, 25.986286845000052],
              [-111.12057780899994, 25.97624182800007],
              [-111.1306831199999, 25.961821332000056],
              [-111.14115858899993, 25.952874674000043],
              [-111.15394647599993, 25.933045148000076],
              [-111.1728556519999, 25.91332837100009],
              [-111.18080348799992, 25.902525408000088],
              [-111.17787572599991, 25.897446674000037],
              [-111.18341436399993, 25.882008298000073],
              [-111.18130347199991, 25.866851135000047],
              [-111.18871430099995, 25.85695510000005],
              [-111.1978926829999, 25.85627327600008],
              [-111.20430271399994, 25.84543830100006],
              [-111.20284973499992, 25.82523079200007],
              [-111.20074113699991, 25.81006880600006],
              [-111.2049908329999, 25.80375425200009],
              [-111.2132906519999, 25.815855302000045],
              [-111.21985968999991, 25.817379909000067],
              [-111.2303447949999, 25.82361198600006],
              [-111.22972571499992, 25.830877997000073],
              [-111.23335513699993, 25.84289916000006],
              [-111.23181414099992, 25.851619962000086],
              [-111.21834429599994, 25.871688495000058],
              [-111.21931062099992, 25.884235896000064],
              [-111.20988847299992, 25.91695274500006],
              [-111.21107189399993, 25.92886868700009],
              [-111.201016, 25.942358080000076],
              [-111.19659220499994, 25.95463297400005],
              [-111.18809973899994, 25.969916083000044],
              [-111.1746798179999, 25.978365239000084],
              [-111.1692554149999, 25.98759417900004],
              [-111.17204118599994, 26.002715416000058],
              [-111.16821293099991, 26.02348040000004],
              [-111.1756174279999, 26.035206350000067],
              [-111.17602678499992, 26.04334152800004],
              [-111.1617701699999, 26.04536283300007],
              [-111.13381297299992, 26.052844358000073],
              [-111.1360700159999, 26.063303259000065],
              [-111.12752035999995, 26.06831320200007],
              [-111.11999754399994, 26.061188066000057],
              [-111.1034137399999, 26.053816848000054],
              [-111.0793200839999, 26.060190875000046],
              [-111.07454573299992, 26.06877613900008],
              [-111.05636947499994, 26.071817312000064],
              [-111.07111848099993, 26.05360946500008],
              [-111.0819856249999, 26.028694466000047],
              [-111.0811938309999, 25.998658402000046],
            ],
          ],
          [
            [
              [-110.04444200599994, 27.086999694000042],
              [-110.0367519969999, 27.089324977000047],
              [-110.0174508849999, 27.08370561600009],
              [-109.98524464699994, 27.069567861000053],
              [-109.9575096189999, 27.05196660900009],
              [-109.93803407999991, 27.02116467700006],
              [-109.94574682699994, 27.021134875000087],
              [-109.96841416799992, 27.049062125000034],
              [-109.99144446499992, 27.064195054000038],
              [-110.01869023899991, 27.076841114000047],
              [-110.03540467499994, 27.07961621000004],
              [-110.04444200599994, 27.086999694000042],
            ],
          ],
          [
            [
              [-110.60417602399991, 27.318023509000056],
              [-110.60655676999994, 27.358587958000044],
              [-110.60456295499995, 27.382513739000046],
              [-110.59748287699995, 27.40574778900009],
              [-110.59308971299993, 27.416985674000045],
              [-110.59843330799993, 27.37807892400008],
              [-110.59404179899991, 27.331831771000054],
              [-110.5751819649999, 27.313715466000076],
              [-110.53065936899992, 27.300391905000083],
              [-110.53434219499991, 27.284356682000066],
              [-110.58856431499993, 27.302735408000046],
              [-110.60417602399991, 27.318023509000056],
            ],
          ],
          [
            [
              [-115.19497965599993, 28.341358253000067],
              [-115.18413588599992, 28.31474069500007],
              [-115.17392961099995, 28.308830826000076],
              [-115.17576563799992, 28.298818501000085],
              [-115.16858538299994, 28.28512137900009],
              [-115.16271472199992, 28.261342294000087],
              [-115.17275956899994, 28.23456452000005],
              [-115.17226837499993, 28.21264516900004],
              [-115.15884794699991, 28.192840181000065],
              [-115.15548988699993, 28.17070354000009],
              [-115.15971033499994, 28.15071465500006],
              [-115.1558288139999, 28.140779932000044],
              [-115.16268872299992, 28.129624921000072],
              [-115.17533643199994, 28.124479492000034],
              [-115.17645830599992, 28.116755135000062],
              [-115.18577654899991, 28.106172687000083],
              [-115.18304013799991, 28.095147119000046],
              [-115.1879708319999, 28.086801431000083],
              [-115.18214886699991, 28.07023639600004],
              [-115.18828828499994, 28.056346964000056],
              [-115.17932147099992, 28.04034477400006],
              [-115.1830311839999, 28.034777741000084],
              [-115.18169735599992, 28.027581981000083],
              [-115.18926456799994, 28.030301958000052],
              [-115.19456946499992, 28.03392161700009],
              [-115.2062993809999, 28.037940216000038],
              [-115.21814763299994, 28.03174530800004],
              [-115.22814296399991, 28.028322673000048],
              [-115.23387870099992, 28.036059358000045],
              [-115.2470238489999, 28.033716118000086],
              [-115.2539951409999, 28.040303985000037],
              [-115.26184529499994, 28.070143449000057],
              [-115.28026282499991, 28.08746979400007],
              [-115.30354490199994, 28.09469858700004],
              [-115.3216695669999, 28.086785194000072],
              [-115.33670020999995, 28.084436037000046],
              [-115.34660976099991, 28.071051225000076],
              [-115.35805203099994, 28.082578651000063],
              [-115.3521567059999, 28.116420125000047],
              [-115.33400439999991, 28.124877560000073],
              [-115.27367102799991, 28.189520575000074],
              [-115.23975583999993, 28.233606330000043],
              [-115.25515489299994, 28.263917329000037],
              [-115.26245342499993, 28.298756383000068],
              [-115.25708823299993, 28.32743559900007],
              [-115.24864245299995, 28.359315181000056],
              [-115.23499631899995, 28.370230333000052],
              [-115.21486747199992, 28.37827913400008],
              [-115.19199501499992, 28.360835960000088],
              [-115.19497965599993, 28.341358253000067],
            ],
          ],
          [
            [
              [-112.89376932999994, 28.677695720000088],
              [-112.86075651099992, 28.671860307000088],
              [-112.8049556879999, 28.63653661300009],
              [-112.79124613499994, 28.622883142000035],
              [-112.7829987579999, 28.61760626000006],
              [-112.7784152449999, 28.610303542000054],
              [-112.76354392899992, 28.602824208000072],
              [-112.76010855899995, 28.59485311600008],
              [-112.75240050199994, 28.591080524000063],
              [-112.7620451279999, 28.58196352400006],
              [-112.77391863399993, 28.575782119000053],
              [-112.78099396999994, 28.581026645000065],
              [-112.78365377299991, 28.585982793000085],
              [-112.7891311219999, 28.58687043100008],
              [-112.79792632699991, 28.609920211000087],
              [-112.8105687829999, 28.618432575000043],
              [-112.82931983899994, 28.625782954000044],
              [-112.84264237299993, 28.640067870000053],
              [-112.86779761499992, 28.643278413000075],
              [-112.86522737099995, 28.650153054000043],
              [-112.87186763499994, 28.655575326000076],
              [-112.8774364809999, 28.663389815000073],
              [-112.8844889849999, 28.67021533400009],
              [-112.89376932999994, 28.677695720000088],
            ],
          ],
          [
            [
              [-112.61315004699992, 28.725762994000036],
              [-112.60065889899994, 28.727974773000085],
              [-112.5934937529999, 28.73223196200007],
              [-112.5698923569999, 28.72889942200004],
              [-112.55745077799992, 28.733809269000062],
              [-112.5479570249999, 28.72854947500008],
              [-112.54672268699994, 28.71745715900005],
              [-112.54140183899995, 28.712268452000046],
              [-112.54597977399993, 28.701872250000065],
              [-112.54573873699991, 28.686589775000073],
              [-112.55393926599993, 28.672288046000062],
              [-112.57205677999991, 28.668401137000046],
              [-112.5946734879999, 28.673082513000054],
              [-112.60434930199995, 28.66943382800008],
              [-112.6009349659999, 28.676981198000078],
              [-112.61224299199989, 28.705233499000087],
              [-112.61315004699992, 28.725762994000036],
            ],
          ],
          [
            [
              [-112.27465689899992, 28.768387890000042],
              [-112.28905188699991, 28.763006903000075],
              [-112.30966018399994, 28.746360236000044],
              [-112.3261752009999, 28.762722486000087],
              [-112.34548878599992, 28.765191770000058],
              [-112.3590553539999, 28.75823598000005],
              [-112.36696525199994, 28.772016148000034],
              [-112.38200435099992, 28.77382158800009],
              [-112.39921720299992, 28.792626505000044],
              [-112.41281887699989, 28.800127908000036],
              [-112.42572624499991, 28.796911519000048],
              [-112.43575147099995, 28.801907462000088],
              [-112.4550493139999, 28.80060380100008],
              [-112.46653628899992, 28.805570414000044],
              [-112.46721560799995, 28.81940573600008],
              [-112.49384857899992, 28.82301866000006],
              [-112.49604336899989, 28.833045195000068],
              [-112.52182024899992, 28.844879157000037],
              [-112.54849392999989, 28.857934456000066],
              [-112.5621659929999, 28.869173542000055],
              [-112.57293149799995, 28.868502359000047],
              [-112.5830330099999, 28.87536288800004],
              [-112.5558371279999, 28.89178426300009],
              [-112.52610426699994, 28.90884183500009],
              [-112.51073157499991, 28.92837148600006],
              [-112.50430253799993, 28.93187083500004],
              [-112.49982662699995, 28.94041575700004],
              [-112.49575761599993, 28.95062897300005],
              [-112.49083411399994, 28.959418036000045],
              [-112.4859106109999, 28.971625067000048],
              [-112.48973548099991, 28.981024481000077],
              [-112.50015214799993, 28.99042389500005],
              [-112.50357011599993, 29.032171942000048],
              [-112.50035559799994, 29.07562897300005],
              [-112.49205481699994, 29.117621161000045],
              [-112.48029537699995, 29.15493398600006],
              [-112.47386633999992, 29.168524481000077],
              [-112.46471106699994, 29.18183014500005],
              [-112.45299231699994, 29.19354889500005],
              [-112.43871008999992, 29.202093817000048],
              [-112.42229018299992, 29.189389988000073],
              [-112.4014518919999, 29.189440997000077],
              [-112.3799504399999, 29.205163290000087],
              [-112.36274813499995, 29.21773604100008],
              [-112.34336176799991, 29.22087556200006],
              [-112.31606889199992, 29.220302162000053],
              [-112.29956453599993, 29.222822831000087],
              [-112.28733285399994, 29.232996247000074],
              [-112.27799196199993, 29.24246728500009],
              [-112.26433722299993, 29.24689047800007],
              [-112.26719660599991, 29.238094579000062],
              [-112.28156888199993, 29.225470832000042],
              [-112.2772395739999, 29.20913371800009],
              [-112.26573539099991, 29.19784728600007],
              [-112.26356650999992, 29.192840508000074],
              [-112.26715248699992, 29.18466571500005],
              [-112.26855837099993, 29.175270872000056],
              [-112.2742860599999, 29.165222437000068],
              [-112.2684819239999, 29.15272630600009],
              [-112.27274704799993, 29.137675178000052],
              [-112.23531295499993, 29.09572531400005],
              [-112.19560606599993, 29.02132978700007],
              [-112.21354301899993, 28.986747267000055],
              [-112.21489869499993, 28.95414763800005],
              [-112.22842412099993, 28.903951465000034],
              [-112.24347362799995, 28.88949925500009],
              [-112.23768415399991, 28.876342013000055],
              [-112.25413705699992, 28.856878838000057],
              [-112.25910981999994, 28.837435669000058],
              [-112.27125978399994, 28.823632539000073],
              [-112.27622926099991, 28.805450989000065],
              [-112.27256357699991, 28.784095663000073],
              [-112.2610892639999, 28.780332430000044],
              [-112.2531873509999, 28.76905021400006],
              [-112.26319325899993, 28.76338798800009],
              [-112.27465689899992, 28.768387890000042],
            ],
          ],
          [
            [
              [-113.13817298099991, 29.064886786000045],
              [-113.1248466539999, 29.060636971000065],
              [-113.11776626199992, 29.056293871000037],
              [-113.10208382299993, 29.053105584000036],
              [-113.1166362479999, 29.02619801800006],
              [-113.11436064599991, 29.013734428000078],
              [-113.1147917589999, 28.984477801000082],
              [-113.12328652499991, 28.98635721700009],
              [-113.13575669699992, 29.000333272000034],
              [-113.1470742109999, 29.004075740000076],
              [-113.15916291899993, 29.017744151000045],
              [-113.19074517199994, 29.02875324200005],
              [-113.19940468899995, 29.04680925000008],
              [-113.21627733799994, 29.055408113000055],
              [-113.22948830299993, 29.059573915000044],
              [-113.2436275469999, 29.06947006900009],
              [-113.25089085299993, 29.08197656300007],
              [-113.25817766499995, 29.087713471000086],
              [-113.26292013699992, 29.102877481000064],
              [-113.2757368899999, 29.11722645100008],
              [-113.29269581599993, 29.133263241000066],
              [-113.3006540909999, 29.14509482200009],
              [-113.31254612599992, 29.14626531600004],
              [-113.3210910919999, 29.15555039800006],
              [-113.33501052499992, 29.160959159000072],
              [-113.35397443599993, 29.170739069000035],
              [-113.36207166999992, 29.18757928100007],
              [-113.38720949999993, 29.19723799700006],
              [-113.40553277599992, 29.211974587000043],
              [-113.43103151399993, 29.242771749000042],
              [-113.42753338699993, 29.25201482500006],
              [-113.43461267999993, 29.26677888100005],
              [-113.4501282409999, 29.27971522200005],
              [-113.4649701269999, 29.279067957000052],
              [-113.48192959499994, 29.27844388300008],
              [-113.49608030899992, 29.28520104000006],
              [-113.50316754699992, 29.298122615000068],
              [-113.50460668599993, 29.31658129300007],
              [-113.51168528599993, 29.32640949100005],
              [-113.52444228999991, 29.334423246000085],
              [-113.53155204099994, 29.349202346000084],
              [-113.53936526099994, 29.354764180000075],
              [-113.54367972599994, 29.366527261000044],
              [-113.5585735389999, 29.37821449000006],
              [-113.5606781859999, 29.386168642000086],
              [-113.57198453299992, 29.397790602000043],
              [-113.58910418499994, 29.409598965000043],
              [-113.5934194269999, 29.433628912000074],
              [-113.58840051699991, 29.456846298000073],
              [-113.57364640499992, 29.478520097000057],
              [-113.56459483599991, 29.507679189000044],
              [-113.56895153199991, 29.524473106000073],
              [-113.57114440599992, 29.539949646000082],
              [-113.55980170599992, 29.54427536500009],
              [-113.55835734699991, 29.53808097800004],
              [-113.5491174959999, 29.53313937200005],
              [-113.5356637139999, 29.538128666000034],
              [-113.52362438299991, 29.543113419000065],
              [-113.52364634999992, 29.549928796000074],
              [-113.5108757459999, 29.549337562000062],
              [-113.51084384199993, 29.537581515000056],
              [-113.49949083099995, 29.535137933000044],
              [-113.47678904899993, 29.532103626000037],
              [-113.4632968439999, 29.518877573000054],
              [-113.4327737079999, 29.49253698800004],
              [-113.41933647899992, 29.46639228300006],
              [-113.3951604749999, 29.45931768400004],
              [-113.39449403899994, 29.451168177000056],
              [-113.3852738089999, 29.442559862000053],
              [-113.38599339199993, 29.435119452000038],
              [-113.37319534199992, 29.421643346000053],
              [-113.36113295299992, 29.401929736000056],
              [-113.36325746499995, 29.39328396400009],
              [-113.34977863199992, 29.384066381000082],
              [-113.36110104599993, 29.374184550000052],
              [-113.37313816499994, 29.361205388000087],
              [-113.37595921199994, 29.343928322000068],
              [-113.37240629699994, 29.334687142000064],
              [-113.37028713599994, 29.310008921000076],
              [-113.34559675499992, 29.295826504000047],
              [-113.30659006299993, 29.290325292000034],
              [-113.29741479899991, 29.280457269000067],
              [-113.2853836679999, 29.280460522000055],
              [-113.27686238699994, 29.289100765000057],
              [-113.2641364989999, 29.28848324900008],
              [-113.25568157899994, 29.285394654000072],
              [-113.2380267339999, 29.28847206900008],
              [-113.22109392699991, 29.28907899300009],
              [-113.2062676519999, 29.285371068000075],
              [-113.18276014899993, 29.289693397000065],
              [-113.1685245029999, 29.276117742000054],
              [-113.17881075299994, 29.25945868100007],
              [-113.17792591599994, 29.237876320000055],
              [-113.17141283399991, 29.226131886000076],
              [-113.17214234699992, 29.20639058800009],
              [-113.17218326599993, 29.19467073800007],
              [-113.16577177699992, 29.189100008000082],
              [-113.17073493099991, 29.17861427100007],
              [-113.17359275699994, 29.157020570000043],
              [-113.17431544099992, 29.129247556000053],
              [-113.17008626699993, 29.11998566400007],
              [-113.15806358599991, 29.10021134400006],
              [-113.15450146699993, 29.093400958000075],
              [-113.1573818789999, 29.08355183200007],
              [-113.14822958399992, 29.066266563000056],
              [-113.13817298099991, 29.064886786000045],
            ],
          ],
          [
            [
              [-114.78612219999991, 31.80304596600007],
              [-114.75523841099994, 31.797796942000048],
              [-114.71007239499994, 31.763739325000074],
              [-114.66954505099994, 31.72093333500004],
              [-114.65269934799994, 31.68976471600007],
              [-114.6660863919999, 31.68976471600007],
              [-114.67796790299991, 31.69440338700008],
              [-114.68740800699993, 31.70180898600006],
              [-114.6936742829999, 31.710272528000075],
              [-114.71556555899991, 31.69521719000005],
              [-114.76256262899994, 31.715643622000073],
              [-114.79820716099994, 31.756659247000073],
              [-114.78612219999991, 31.80304596600007],
            ],
          ],
          [
            [
              [-87.33120683499993, 18.532416083000044],
              [-87.3281550769999, 18.54124583500004],
              [-87.32433020699995, 18.54979075700004],
              [-87.31847083199995, 18.558417059000078],
              [-87.31012936099995, 18.567206122000073],
              [-87.3281550769999, 18.53270091400009],
              [-87.32209225199995, 18.48924388200004],
              [-87.33450273299991, 18.454372463000084],
              [-87.37319902299993, 18.402492580000057],
              [-87.37942460799991, 18.402492580000057],
              [-87.37564042899993, 18.410264390000066],
              [-87.35850989499994, 18.429388739000046],
              [-87.34874426999994, 18.442572333000044],
              [-87.34361731699994, 18.452337958000044],
              [-87.33747311099995, 18.477769273000092],
              [-87.33120683499993, 18.532416083000044],
            ],
          ],
          [
            [
              [-87.26915442599994, 18.73851146000004],
              [-87.25548255099994, 18.724269924000055],
              [-87.24815833199995, 18.676214911000045],
              [-87.24986731699994, 18.650864976000037],
              [-87.26292883999992, 18.628648179000038],
              [-87.2586156889999, 18.65696849200009],
              [-87.26915442599994, 18.73851146000004],
            ],
          ],
          [
            [
              [-91.60033118399991, 18.772040106000077],
              [-91.55573482999995, 18.79169342700004],
              [-91.53888912699995, 18.793117580000057],
              [-91.53246008999992, 18.78534577000005],
              [-91.52733313699991, 18.777085679000038],
              [-91.52440344999991, 18.76658763200004],
              [-91.52456620999993, 18.75214264500005],
              [-91.52879798099991, 18.75527578300006],
              [-91.5320531889999, 18.758978583000044],
              [-91.55394446499992, 18.744940497000073],
              [-91.56590735599991, 18.740179755000042],
              [-91.57921301999994, 18.73851146000004],
              [-91.57461503799993, 18.745917059000078],
              [-91.56851152299993, 18.751654364000046],
              [-91.56090247299994, 18.755926825000074],
              [-91.55186926999994, 18.758978583000044],
              [-91.57164466099994, 18.75722890800006],
              [-91.60602779899995, 18.74371979400007],
              [-91.62083899599992, 18.744696356000077],
              [-91.66006425699993, 18.692328192000048],
              [-91.68887285099993, 18.66941966400009],
              [-91.72321529899995, 18.66278717700004],
              [-91.70274817599994, 18.69749583500004],
              [-91.75511633999992, 18.667141018000052],
              [-91.7859594389999, 18.654364325000074],
              [-91.81627356699994, 18.64911530200004],
              [-91.83568274599992, 18.64911530200004],
              [-91.84268144399994, 18.651190497000073],
              [-91.83824622299994, 18.65818919500009],
              [-91.82315019399994, 18.67332591400009],
              [-91.81216386599993, 18.679754950000074],
              [-91.76821855399993, 18.69749583500004],
              [-91.74022376199991, 18.70380280200004],
              [-91.6858870289999, 18.73153338600008],
              [-91.64655434699995, 18.755841064000037],
              [-91.60033118399991, 18.772040106000077],
            ],
          ],
          [
            [
              [-86.74901282499991, 20.592230536000045],
              [-86.7468969389999, 20.59589264500005],
              [-86.74217688699991, 20.59589264500005],
              [-86.73745683499993, 20.592271226000037],
              [-86.73534094999991, 20.58535390800006],
              [-86.73721269399994, 20.582180080000057],
              [-86.74901282499991, 20.567694403000075],
              [-86.78433183499993, 20.509833075000074],
              [-86.79710852799991, 20.477484442000048],
              [-86.81354732999995, 20.46112702000005],
              [-86.84398352799991, 20.437323309000078],
              [-86.85570227799991, 20.420843817000048],
              [-86.88076738199993, 20.375921942000048],
              [-86.8855688139999, 20.35883209800005],
              [-86.88980058499993, 20.353664455000057],
              [-86.8992406889999, 20.348456122000073],
              [-86.90855872299994, 20.341538804000038],
              [-86.9129125639999, 20.33148834800005],
              [-86.91690019399994, 20.324611721000053],
              [-86.92650305899991, 20.313706773000035],
              [-86.97915605399993, 20.26780833500004],
              [-86.99526933499993, 20.26080963700008],
              [-87.00226803299995, 20.270086981000077],
              [-87.00523841099994, 20.290187893000052],
              [-87.0188695949999, 20.332464911000045],
              [-87.0227758449999, 20.355414130000042],
              [-87.01968339799993, 20.39744700700004],
              [-87.0078832669999, 20.43622467700004],
              [-86.96812903599994, 20.506252346000053],
              [-86.93675696499992, 20.54718659100007],
              [-86.92951412699995, 20.550034898000035],
              [-86.91368567599994, 20.563421942000048],
              [-86.90542558499993, 20.567694403000075],
              [-86.89688066299993, 20.56781647300005],
              [-86.89053300699993, 20.565334377000056],
              [-86.88573157499991, 20.562323309000078],
              [-86.88219153599994, 20.56085846600007],
              [-86.87124589799993, 20.55857982000009],
              [-86.84634355399993, 20.548976955000057],
              [-86.83714758999992, 20.54718659100007],
              [-86.82371985599991, 20.549994208000044],
              [-86.80174719999991, 20.562567450000074],
              [-86.78921464799993, 20.559881903000075],
              [-86.77131100199995, 20.566107489000046],
              [-86.75568600199995, 20.57754140800006],
              [-86.74901282499991, 20.592230536000045],
            ],
          ],
          [
            [
              [-86.70059160099993, 21.198919989000046],
              [-86.7200414699999, 21.212713934000078],
              [-86.7395727199999, 21.24282461100006],
              [-86.74986731699994, 21.273138739000046],
              [-86.74156653599994, 21.287665106000077],
              [-86.73851477799991, 21.266750393000052],
              [-86.72752844999991, 21.24290599200009],
              [-86.70059160099993, 21.198919989000046],
            ],
          ],
          [
            [
              [-97.65143795499995, 21.787909247000073],
              [-97.61473548099991, 21.76439036700009],
              [-97.60171464799993, 21.75193919500009],
              [-97.61046301999994, 21.740179755000042],
              [-97.6399633449999, 21.74510325700004],
              [-97.66348222599993, 21.778469143000052],
              [-97.6792699859999, 21.823187567000048],
              [-97.68492591099994, 21.862453518000052],
              [-97.67031816299993, 21.84861888200004],
              [-97.66454016799992, 21.82908763200004],
              [-97.66055253799993, 21.807562567000048],
              [-97.65143795499995, 21.787909247000073],
            ],
          ],
          [
            [
              [-97.81529700399994, 22.72020091400009],
              [-97.7984106109999, 22.762518622000073],
              [-97.78856360599991, 22.77484772300005],
              [-97.78453528599994, 22.75584544500009],
              [-97.79613196499992, 22.723781643000052],
              [-97.81761633999992, 22.69476959800005],
              [-97.84316972599993, 22.684881903000075],
              [-97.83714758999992, 22.696112372000073],
              [-97.82188880099994, 22.71157461100006],
              [-97.81529700399994, 22.72020091400009],
            ],
          ],
          [
            [
              [-118.25147802899994, 29.089444080000078],
              [-118.22958889199992, 29.061719537000045],
              [-118.22052873299992, 29.015180125000086],
              [-118.22907773499992, 28.99597345600006],
              [-118.22136451799992, 28.95934258300008],
              [-118.22580357499993, 28.91505206100004],
              [-118.2513620439999, 28.884541890000037],
              [-118.27037512899994, 28.88617584800005],
              [-118.28201988599994, 28.879102129000046],
              [-118.2892143709999, 28.878881774000035],
              [-118.28878202099992, 28.868082591000075],
              [-118.29839224199992, 28.876797863000036],
              [-118.2947497589999, 28.888623817000052],
              [-118.28358639699991, 28.892569644000048],
              [-118.2927464199999, 28.915717156000085],
              [-118.2974722479999, 28.93089063800005],
              [-118.29404346699994, 28.948116962000086],
              [-118.29998013599993, 28.96775888600007],
              [-118.31599010799994, 28.98168671400009],
              [-118.30434304499994, 28.998019411000087],
              [-118.31367863899993, 29.025563069000043],
              [-118.32349524599994, 29.039965813000038],
              [-118.33527606599989, 29.05115814900006],
              [-118.35551846999994, 29.067003973000055],
              [-118.35820540899994, 29.083665909000047],
              [-118.3640187879999, 29.098314793000043],
              [-118.36880422899992, 29.114401178000037],
              [-118.36538298799991, 29.131653493000044],
              [-118.3567780329999, 29.14948061000007],
              [-118.33672881399991, 29.163293131000046],
              [-118.30924962199992, 29.171555914000066],
              [-118.29634558599992, 29.186158661000036],
              [-118.27375518699989, 29.189562864000038],
              [-118.25589454999994, 29.180932220000045],
              [-118.2717817649999, 29.165123835000088],
              [-118.28369324199991, 29.15185512000005],
              [-118.28617607099994, 29.136439960000075],
              [-118.27911252799993, 29.116244771000083],
              [-118.26720977299993, 29.098056713000062],
              [-118.25147802899994, 29.089444080000078],
            ],
          ],
          [
            [
              [-113.24474036399994, 26.72459544500009],
              [-113.22899329299992, 26.732896226000037],
              [-113.21996008999992, 26.731268622000073],
              [-113.21080481699994, 26.72793203300006],
              [-113.20254472599993, 26.72296784100007],
              [-113.2034399079999, 26.717189846000053],
              [-113.19513912699995, 26.71385325700004],
              [-113.19180253799993, 26.717189846000053],
              [-113.18687903599994, 26.72134023600006],
              [-113.18024654899995, 26.72296784100007],
              [-113.17442786399994, 26.720445054000038],
              [-113.1629125639999, 26.704779364000046],
              [-113.14712480399993, 26.684068101000037],
              [-113.13890540299991, 26.67255280200004],
              [-113.13805091099994, 26.66510651200008],
              [-113.14635169199994, 26.66510651200008],
              [-113.1546117829999, 26.67088450700004],
              [-113.16539466099994, 26.677476304000038],
              [-113.19180253799993, 26.687445380000042],
              [-113.22158769399994, 26.695705471000053],
              [-113.2464086579999, 26.70148346600007],
              [-113.25796464799993, 26.704779364000046],
              [-113.26455644399994, 26.708929755000042],
              [-113.25796464799993, 26.718003648000035],
              [-113.24474036399994, 26.72459544500009],
            ],
          ],
          [
            [
              [-89.66418798799992, 22.371069109000075],
              [-89.68458230099992, 22.380737837000083],
              [-89.69172582699991, 22.387598838000088],
              [-89.6892464629999, 22.399856861000046],
              [-89.69797173799992, 22.417544062000047],
              [-89.6943877779999, 22.424873421000086],
              [-89.67755395499995, 22.42966756900006],
              [-89.65710439999992, 22.446689219000064],
              [-89.65516467999993, 22.472001270000078],
              [-89.67271790399991, 22.49254389500004],
              [-89.68766341299994, 22.507352138000044],
              [-89.69107183699992, 22.52862850400004],
              [-89.71401664199993, 22.541046090000066],
              [-89.73876902099994, 22.54938823000009],
              [-89.75652256599994, 22.543782055000065],
              [-89.76191796299992, 22.529095854000047],
              [-89.77075566699995, 22.533241273000044],
              [-89.76713830299991, 22.547123043000056],
              [-89.75643459899993, 22.560140758000045],
              [-89.74570742299994, 22.57724911300005],
              [-89.72972515299995, 22.582868579000035],
              [-89.69261012599992, 22.567073036000068],
              [-89.65824757199994, 22.54066988900007],
              [-89.62491973699991, 22.497943699000075],
              [-89.6101519099999, 22.461080928000058],
              [-89.62188280099991, 22.409829168000044],
              [-89.63427615599994, 22.37889104900006],
              [-89.65057469399994, 22.367576495000037],
              [-89.66418798799992, 22.371069109000075],
            ],
          ],
          [
            [
              [-110.58616260399992, 24.832117105000066],
              [-110.57451863599994, 24.840236985000047],
              [-110.56922842499995, 24.843842237000047],
              [-110.56519201899994, 24.840915688000052],
              [-110.56762016499994, 24.830196709000063],
              [-110.56464878999992, 24.82636156700005],
              [-110.56123963999994, 24.820171102000074],
              [-110.56141360099991, 24.815017092000062],
              [-110.5681252419999, 24.815203173000043],
              [-110.5684050779999, 24.82224559100007],
              [-110.57408386799995, 24.822403544000053],
              [-110.58032832299995, 24.821168422000085],
              [-110.58679008799993, 24.82885119900004],
              [-110.58616260399992, 24.832117105000066],
            ],
          ],
          [
            [
              [-115.75279700399994, 24.954779364000046],
              [-115.75230872299994, 24.954291083000044],
              [-115.75230872299994, 24.953273830000057],
              [-115.75328528599994, 24.95302969000005],
              [-115.75377356699994, 24.953517971000053],
              [-115.75377356699994, 24.954413153000075],
              [-115.75279700399994, 24.954779364000046],
            ],
          ],
          [
            [
              [-110.7147906489999, 25.30592566000007],
              [-110.7047994799999, 25.306051100000047],
              [-110.69651821199994, 25.307006880000074],
              [-110.69068524799991, 25.31273794000009],
              [-110.6895253369999, 25.308388679000075],
              [-110.69404315999992, 25.303015619000064],
              [-110.70398902499994, 25.289108078000083],
              [-110.70719465899992, 25.271563092000065],
              [-110.71343768499992, 25.264268410000057],
              [-110.71977787499992, 25.259347713000068],
              [-110.7288728499999, 25.259981991000075],
              [-110.72975618099991, 25.266260189000036],
              [-110.7339393979999, 25.27778009000008],
              [-110.7327421089999, 25.287954409000065],
              [-110.7147906489999, 25.30592566000007],
            ],
          ],
          [
            [
              [-112.10630618699992, 25.484113397000044],
              [-112.10292936199994, 25.48887492700004],
              [-112.0981361669999, 25.48582181900008],
              [-112.0991407489999, 25.47194615300009],
              [-112.09775422199993, 25.45502857000008],
              [-112.0997500819999, 25.431189394000057],
              [-112.10077020799991, 25.41211862600005],
              [-112.10659164299994, 25.391761856000073],
              [-112.10955788099994, 25.36316402300008],
              [-112.10434741199992, 25.34234799500007],
              [-112.10583783999994, 25.32588092700007],
              [-112.11306636299992, 25.314194651000037],
              [-112.11886047099995, 25.301203586000042],
              [-112.11747555099993, 25.28385816100007],
              [-112.12275429399995, 25.282136463000086],
              [-112.1308846209999, 25.288659129000052],
              [-112.1380505809999, 25.29734661400005],
              [-112.13416846099994, 25.312944434000087],
              [-112.12549294999991, 25.327662273000044],
              [-112.1177191679999, 25.360583888000065],
              [-112.11327091099992, 25.403915398000038],
              [-112.10547262599994, 25.44291230200008],
              [-112.10301479599991, 25.46155052100005],
              [-112.10630618699992, 25.484113397000044],
            ],
          ],
          [
            [
              [-111.0591482449999, 25.700977588000057],
              [-111.05955021199992, 25.708223700000076],
              [-111.04354031199995, 25.70672490000004],
              [-111.04337521699995, 25.71228737000007],
              [-111.03715375399992, 25.71381075800008],
              [-111.03128278499992, 25.703644765000035],
              [-111.02344521399993, 25.697335088000045],
              [-111.01922563099993, 25.69388712700004],
              [-111.0128891089999, 25.678704954000068],
              [-111.01625677499993, 25.66932151800006],
              [-111.02210814299991, 25.65944128500007],
              [-111.02850966999995, 25.651792606000072],
              [-111.03526141899994, 25.653070770000056],
              [-111.04416712699992, 25.664981510000075],
              [-111.0477029459999, 25.67063575700007],
              [-111.0462037499999, 25.67950910600007],
              [-111.05379375399991, 25.694168687000058],
              [-111.0591482449999, 25.700977588000057],
            ],
          ],
          [
            [
              [-111.2582353069999, 25.812789104000046],
              [-111.25478977799992, 25.811284971000077],
              [-111.25316385699995, 25.801545692000047],
              [-111.24752485499994, 25.799136094000062],
              [-111.2498730929999, 25.794622036000078],
              [-111.24590078299991, 25.789395178000063],
              [-111.24470679799992, 25.786799451000036],
              [-111.24795653599995, 25.78401779300009],
              [-111.24690914799993, 25.77628688200008],
              [-111.24322964399994, 25.771922456000084],
              [-111.24305953099991, 25.76677994700009],
              [-111.2459432949999, 25.765702386000044],
              [-111.25301022499991, 25.773568347000037],
              [-111.25849374199993, 25.781398624000076],
              [-111.25790034199991, 25.791091002000087],
              [-111.2569741669999, 25.801345626000057],
              [-111.2602256369999, 25.809694639000043],
              [-111.2582353069999, 25.812789104000046],
            ],
          ],
          [
            [
              [-111.28662406799992, 26.125845586000082],
              [-111.27523822699993, 26.136377506000088],
              [-111.2685576959999, 26.13626232100006],
              [-111.26372496499994, 26.13504210700006],
              [-111.26248744399993, 26.125414309000064],
              [-111.26442964099994, 26.118247110000084],
              [-111.26716165199991, 26.115103197000053],
              [-111.26255747399995, 26.11130564700005],
              [-111.26424326599994, 26.10500571600005],
              [-111.27402031299994, 26.10497750600007],
              [-111.28142231999993, 26.104882898000085],
              [-111.2862044719999, 26.103131543000075],
              [-111.2834498009999, 26.10652465600009],
              [-111.28038014399993, 26.11043764200008],
              [-111.2799317759999, 26.114641237000058],
              [-111.2865819349999, 26.119009039000048],
              [-111.28662406799992, 26.125845586000082],
            ],
          ],
          [
            [
              [-112.09700313999991, 27.224523119000082],
              [-112.10881185499994, 27.23691513600005],
              [-112.09009010599993, 27.259978197000066],
              [-112.06414072699994, 27.241471524000076],
              [-112.04525282299994, 27.216644319000068],
              [-112.05222677799992, 27.193672018000086],
              [-112.06627896399993, 27.17896489700007],
              [-112.08744774799993, 27.18294220200005],
              [-112.09222093499994, 27.203736787000082],
              [-112.09700313999991, 27.224523119000082],
            ],
          ],
          [
            [
              [-111.89226813399995, 27.429018960000064],
              [-111.90428751999991, 27.43763937400007],
              [-111.90108254599994, 27.44922802800005],
              [-111.87933159799991, 27.45318926400006],
              [-111.8629721609999, 27.44651625000006],
              [-111.85639427099994, 27.437869636000073],
              [-111.85962089399993, 27.43014061100007],
              [-111.87920334599994, 27.42811819700006],
              [-111.89226813399995, 27.429018960000064],
            ],
          ],
          [
            [
              [-115.20415565499991, 27.89249616400008],
              [-115.19692239099993, 27.89148923500005],
              [-115.18478292799995, 27.88200766300008],
              [-115.17145298299994, 27.873595298000055],
              [-115.1623654469999, 27.868343484000036],
              [-115.1592674289999, 27.859851379000077],
              [-115.16459619099993, 27.85129607400006],
              [-115.17299472899992, 27.848570985000038],
              [-115.1784340509999, 27.850657260000048],
              [-115.18223512899993, 27.86872369000008],
              [-115.1938067189999, 27.881404487000054],
              [-115.2094880979999, 27.88447246800007],
              [-115.22036738599991, 27.888640469000052],
              [-115.21803928799994, 27.89610767100004],
              [-115.20415565499991, 27.89249616400008],
            ],
          ],
          [
            [
              [-111.38850838199994, 27.968801946000042],
              [-111.3950649819999, 27.979388662000076],
              [-111.38743959899995, 27.988079089000053],
              [-111.37323579499991, 27.968813943000043],
              [-111.3655865419999, 27.953400352000074],
              [-111.38195072799994, 27.95724250300009],
              [-111.38850838199994, 27.968801946000042],
            ],
          ],
          [
            [
              [-115.5938065069999, 28.317167183000038],
              [-115.58826485799995, 28.309779406000075],
              [-115.57926277699994, 28.314132820000054],
              [-115.5677766039999, 28.313724],
              [-115.56466734899993, 28.307373446000042],
              [-115.57554124399991, 28.30725824800004],
              [-115.57907717099994, 28.30083495000008],
              [-115.59232139699992, 28.29750052600008],
              [-115.60268783299995, 28.304302844000063],
              [-115.6039786639999, 28.31013982400009],
              [-115.6010417139999, 28.31602319700005],
              [-115.5938065069999, 28.317167183000038],
            ],
          ],
          [
            [
              [-113.51883989599992, 29.095563248000076],
              [-113.5119003559999, 29.095005531000083],
              [-113.50470694699993, 29.09217759200004],
              [-113.50404679999991, 29.08795414900004],
              [-113.50786021199991, 29.08291492400008],
              [-113.5089183629999, 29.07872564200005],
              [-113.50413298399991, 29.075319585000045],
              [-113.5055555049999, 29.070761490000052],
              [-113.50596487399991, 29.06259534500009],
              [-113.50014401699991, 29.05622247200006],
              [-113.5012220139999, 29.050493187000086],
              [-113.49675063299992, 29.048354430000074],
              [-113.49645031299991, 29.04231539400007],
              [-113.49163841099994, 29.039570896000043],
              [-113.49201098799995, 29.03594982900006],
              [-113.50132706599993, 29.03630505800004],
              [-113.50682475299993, 29.039656543000035],
              [-113.50472040299991, 29.044173343000068],
              [-113.50883103399991, 29.048422577000053],
              [-113.5143178909999, 29.053284405000056],
              [-113.51221106199989, 29.058103620000054],
              [-113.50942981999992, 29.06080436900004],
              [-113.51355364799991, 29.063243666000062],
              [-113.51522798399992, 29.070196360000068],
              [-113.51483820399994, 29.07623088400004],
              [-113.52103066199993, 29.078982847000077],
              [-113.52270512699994, 29.08593363400007],
              [-113.5271456509999, 29.09229514900005],
              [-113.51883989599992, 29.095563248000076],
            ],
          ],
          [
            [
              [-114.41854183299989, 29.98677644600008],
              [-114.4018487599999, 29.98603429700006],
              [-114.4000647339999, 29.969303853000042],
              [-114.39478096099992, 29.96018407300005],
              [-114.40707344099991, 29.95864837000005],
              [-114.4220174859999, 29.96623616000005],
              [-114.41588681499991, 29.976131271000042],
              [-114.41854183299989, 29.98677644600008],
            ],
          ],
          [
            [
              [-116.1144106829999, 30.496223352000072],
              [-116.10961194599992, 30.49534673900007],
              [-116.1042395039999, 30.488080085000036],
              [-116.10417503199994, 30.48258947900007],
              [-116.11476364399994, 30.482034513000087],
              [-116.1227673649999, 30.48516743500005],
              [-116.12284389899992, 30.491572071000064],
              [-116.1144106829999, 30.496223352000072],
            ],
          ],
          [
            [
              [-117.25369333799995, 32.420802080000044],
              [-117.2476392349999, 32.41863049500006],
              [-117.2450316479999, 32.414626732000045],
              [-117.24196962899993, 32.404425521000064],
              [-117.2393509989999, 32.39713975800004],
              [-117.23932074099991, 32.389117730000066],
              [-117.24320544999995, 32.388742780000086],
              [-117.2467032589999, 32.40003748700008],
              [-117.24802681699992, 32.40732653800006],
              [-117.25106411699994, 32.410963019000064],
              [-117.25369333799995, 32.420802080000044],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Belize',
        iso3: 'BLZ',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-89.19313967135847, 16.392625602808764],
              [-89.1843527061227, 16.49587244432975],
              [-89.16606739756634, 16.777009063383176],
              [-89.1492048451793, 17.036270806333576],
              [-89.15072787410207, 17.32103207973212],
              [-89.15621739539208, 17.59824334848561],
              [-89.16049617499993, 17.814314270000054],
              [-89.16137467499988, 17.901440735000037],
              [-89.15393326799995, 17.94107655900008],
              [-89.13256506399995, 17.97027374300002],
              [-89.04944352299987, 17.999212545000077],
              [-89.02802364099995, 17.992081197000047],
              [-89.01153885999986, 17.977818502000062],
              [-88.99657853199992, 17.961850485000028],
              [-88.97975785399993, 17.949448141000076],
              [-88.96784643599989, 17.948259583000052],
              [-88.95650345899992, 17.950533346000057],
              [-88.94702083399994, 17.94846628800009],
              [-88.9333007409999, 17.920354309000075],
              [-88.9204591479999, 17.910949199000115],
              [-88.88033239799992, 17.888469951],
              [-88.87136653699989, 17.890950419000077],
              [-88.86537207099985, 17.899011943000076],
              [-88.86085038299993, 17.92112945600006],
              [-88.85640620899991, 17.92831247900004],
              [-88.80534989499995, 17.9650027470001],
              [-88.79594478399989, 17.975596415000084],
              [-88.78163041199991, 18.014715475000102],
              [-88.77687618099992, 18.02375885000005],
              [-88.76201920599996, 18.03564443000009],
              [-88.74835078999988, 18.04329254100007],
              [-88.7363876959999, 18.051922506000025],
              [-88.72664668799987, 18.066727804000024],
              [-88.72349442599992, 18.077502340000066],
              [-88.72044551599987, 18.100084941000105],
              [-88.71770666499992, 18.110032654000108],
              [-88.69285030099988, 18.150004374000062],
              [-88.68951717199988, 18.16124399900012],
              [-88.6929536539999, 18.175170797000092],
              [-88.6966226809999, 18.17806467700008],
              [-88.66814896699987, 18.198244324000072],
              [-88.63895178299992, 18.211602681],
              [-88.62704036499989, 18.220310160000068],
              [-88.61698929899987, 18.23542551700008],
              [-88.61405893099987, 18.247028189000034],
              [-88.61316524299991, 18.250566712000094],
              [-88.61148575899998, 18.266379700000087],
              [-88.60771337899985, 18.283381246000104],
              [-88.59807572499992, 18.299478455000084],
              [-88.56717321799994, 18.333507385000118],
              [-88.55479671199987, 18.352214254],
              [-88.55133439199992, 18.363686422000015],
              [-88.54740698299986, 18.389059551000017],
              [-88.53838944599991, 18.41308909100003],
              [-88.53304093499986, 18.44331980400007],
              [-88.52782161499994, 18.4541460170001],
              [-88.52019934199987, 18.461561584000023],
              [-88.48924515799987, 18.484505920000046],
              [-88.47919409199991, 18.483420716000055],
              [-88.46994401099991, 18.478511454000014],
              [-88.4596345619999, 18.47572092700007],
              [-88.45082373099993, 18.476883647000065],
              [-88.43085078999988, 18.48378245100004],
              [-88.41997290099994, 18.48900177000006],
              [-88.41322912699991, 18.49075876900004],
              [-88.40798396799997, 18.48895009400006],
              [-88.39837215199987, 18.480113424000066],
              [-88.3907757159999, 18.47569508900004],
              [-88.3849104409999, 18.47662526500001],
              [-88.37907100499993, 18.479700013000055],
              [-88.37144873099996, 18.481792908],
              [-88.30951452699992, 18.482283834000057],
              [-88.30382239499994, 18.481350002000056],
              [-88.30382239499994, 18.477769273000092],
              [-88.28661048099991, 18.46279531500005],
              [-88.30626380099994, 18.438299872000073],
              [-88.38369706899994, 18.38495514500005],
              [-88.39098059799994, 18.37059153900009],
              [-88.37954667899993, 18.35492584800005],
              [-88.36538652299993, 18.354071356000077],
              [-88.31749426999994, 18.374823309000078],
              [-88.32310950399994, 18.360256252000056],
              [-88.33242753799993, 18.34479401200008],
              [-88.35533606699994, 18.31708405200004],
              [-88.36082923099991, 18.308254299000055],
              [-88.35798092399995, 18.30369700700004],
              [-88.35024980399993, 18.30418528900009],
              [-88.34142005099994, 18.310248114000046],
              [-88.32457434799994, 18.32831452000005],
              [-88.29141191299993, 18.35114166900007],
              [-88.27574622299994, 18.358221747000073],
              [-88.25914466099994, 18.361151434000078],
              [-88.23680579299992, 18.35814036700009],
              [-88.20775305899991, 18.344631252000056],
              [-88.1946508449999, 18.340643622000073],
              [-88.17341061099995, 18.34373607000009],
              [-88.14313717399995, 18.363755601000037],
              [-88.10850989499994, 18.373928127000056],
              [-88.09675045499995, 18.375433661000045],
              [-88.09154212099992, 18.37173086100006],
              [-88.09349524599992, 18.35761139500005],
              [-88.09902910099993, 18.34837474200009],
              [-88.11888587099992, 18.333807684000078],
              [-88.14171301999994, 18.32444896000004],
              [-88.14614824099993, 18.32021719000005],
              [-88.14647376199991, 18.30927155200004],
              [-88.13927161399994, 18.30695221600007],
              [-88.13052324099993, 18.31045156500005],
              [-88.12303626199991, 18.322333075000074],
              [-88.11485755099994, 18.327826239000046],
              [-88.10464433499993, 18.332098700000074],
              [-88.09496008999992, 18.333807684000078],
              [-88.09166419199994, 18.32835521000004],
              [-88.08356686099995, 18.210109768000052],
              [-88.09154212099992, 18.118394273000092],
              [-88.09479732999995, 18.102769273000092],
              [-88.10879472599993, 18.07884349200009],
              [-88.11204993399991, 18.06317780200004],
              [-88.14964758999992, 17.97134023600006],
              [-88.16673743399991, 17.960150458000044],
              [-88.16685950399994, 17.95994700700004],
              [-88.2083227199999, 17.881984768000052],
              [-88.20225989499994, 17.85614655200004],
              [-88.21434485599991, 17.773098049000055],
              [-88.23875891799992, 17.690375067000048],
              [-88.24669348899994, 17.673651434000078],
              [-88.27269446499992, 17.64398834800005],
              [-88.28319251199991, 17.62563711100006],
              [-88.28770911399994, 17.60423411700009],
              [-88.28331458199995, 17.58026764500005],
              [-88.27122962099992, 17.568101304000038],
              [-88.23558508999992, 17.550726630000042],
              [-88.22813880099994, 17.535589911000045],
              [-88.21857662699995, 17.527289130000042],
              [-88.17666581899994, 17.52024974200009],
              [-88.1673070949999, 17.51203034100007],
              [-88.17935136599993, 17.492621161000045],
              [-88.2051488919999, 17.49286530200004],
              [-88.23078365799995, 17.496527411000045],
              [-88.24233964799993, 17.487494208000044],
              [-88.2449438139999, 17.471991278000075],
              [-88.26022969117484, 17.423064435021338],
              [-88.28628495999993, 17.339667059000078],
              [-88.29596920499995, 17.238104559000078],
              [-88.29698645699995, 17.217189846000053],
              [-88.30052649599992, 17.17792389500005],
              [-88.29344641799992, 17.156805731000077],
              [-88.28954016799992, 17.13776276200008],
              [-88.28937740799995, 17.135768947000088],
              [-88.28856360599991, 17.12693919500009],
              [-88.28331458199995, 17.103949286000045],
              [-88.27940833199995, 17.091457424000055],
              [-88.26992753799993, 17.086330471000053],
              [-88.24860592399995, 17.079413153000075],
              [-88.23648027299993, 17.064195054000038],
              [-88.22817949099993, 17.044867255000042],
              [-88.2234594389999, 17.023138739000046],
              [-88.22085527299993, 16.991441148000092],
              [-88.21507727799991, 16.96710846600007],
              [-88.21743730399993, 16.955471096000053],
              [-88.22370357999995, 16.952948309000078],
              [-88.2324926419999, 16.953070380000042],
              [-88.24233964799993, 16.949652411000045],
              [-88.25328528599994, 16.939927476000037],
              [-88.26695716099994, 16.924750067000048],
              [-88.27847245999993, 16.907416083000044],
              [-88.28331458199995, 16.89134349200009],
              [-88.27887936099995, 16.87295156500005],
              [-88.25934811099995, 16.843410549000055],
              [-88.25548255099994, 16.82615794500009],
              [-88.25373287699995, 16.82607656500005],
              [-88.25023352799991, 16.823431708000044],
              [-88.24767005099994, 16.818915106000077],
              [-88.24860592399995, 16.81313711100006],
              [-88.25230872299994, 16.812160549000055],
              [-88.26549231699994, 16.81386953300006],
              [-88.26968339799993, 16.81313711100006],
              [-88.28237870999993, 16.80341217700004],
              [-88.28750566299993, 16.797349351000037],
              [-88.28954016799992, 16.788275458000044],
              [-88.29173743399991, 16.78339264500005],
              [-88.29670162699995, 16.778509833000044],
              [-88.30162512899994, 16.77171458500004],
              [-88.30382239499994, 16.76129791900007],
              [-88.3028051419999, 16.749335028000075],
              [-88.29808508999992, 16.733547268000052],
              [-88.29698645699995, 16.723781643000052],
              [-88.30622311099995, 16.652899481000077],
              [-88.31240800699993, 16.64203522300005],
              [-88.32115637899994, 16.63344961100006],
              [-88.33116614499994, 16.62067291900007],
              [-88.3426000639999, 16.579820054000038],
              [-88.34805253799993, 16.567328192000048],
              [-88.35147050699993, 16.549709377000056],
              [-88.34483801999994, 16.524562893000052],
              [-88.34898841099994, 16.515326239000046],
              [-88.35610917899993, 16.50649648600006],
              [-88.36286373599995, 16.50584544500009],
              [-88.36587480399993, 16.521429755000042],
              [-88.33454342399995, 16.63507721600007],
              [-88.3176977199999, 16.65224844000005],
              [-88.31126868399991, 16.66229889500005],
              [-88.33763587099992, 16.649237372000073],
              [-88.36465410099993, 16.583685614000046],
              [-88.38638261599993, 16.55927155200004],
              [-88.37979081899994, 16.558254299000055],
              [-88.36587480399993, 16.55182526200008],
              [-88.37262936099995, 16.548529364000046],
              [-88.37783769399994, 16.54710521000004],
              [-88.38402258999992, 16.548000393000052],
              [-88.39317786399994, 16.55182526200008],
              [-88.39110266799992, 16.543036200000074],
              [-88.38853919199994, 16.538885809000078],
              [-88.38329016799992, 16.53778717700004],
              [-88.37279212099992, 16.53815338700008],
              [-88.37279212099992, 16.53196849200009],
              [-88.38341223899994, 16.525091864000046],
              [-88.39093990799995, 16.51504140800006],
              [-88.39268958199995, 16.50299713700008],
              [-88.39004472599993, 16.49762604400007],
              [-88.38638261599993, 16.490383205000057],
              [-88.40518144399994, 16.47679271000004],
              [-88.42564856699994, 16.437241929000038],
              [-88.44444739499994, 16.428900458000044],
              [-88.44640051999994, 16.42340729400007],
              [-88.44823157499991, 16.399644273000092],
              [-88.44782467399995, 16.39476146000004],
              [-88.45352128799993, 16.391424872000073],
              [-88.45881100199995, 16.39134349200009],
              [-88.46214758999992, 16.393011786000045],
              [-88.46214758999992, 16.39476146000004],
              [-88.46849524599992, 16.390692450000074],
              [-88.47057044199994, 16.388617255000042],
              [-88.47179114499994, 16.386053778000075],
              [-88.47573808499993, 16.38117096600007],
              [-88.48859615799995, 16.351263739000046],
              [-88.49254309799994, 16.34638092700004],
              [-88.50035559799994, 16.34210846600007],
              [-88.5266820949999, 16.30882396000004],
              [-88.52965247299994, 16.303534247000073],
              [-88.53380286399994, 16.290350653000075],
              [-88.53661048099991, 16.285549221000053],
              [-88.53726152299993, 16.28266022300005],
              [-88.5359594389999, 16.27411530200004],
              [-88.53661048099991, 16.271307684000078],
              [-88.53937740799995, 16.270656643000052],
              [-88.54751542899993, 16.271918036000045],
              [-88.55028235599991, 16.271307684000078],
              [-88.55467688699991, 16.268866278000075],
              [-88.56676184799994, 16.26626211100006],
              [-88.57135982999995, 16.263820705000057],
              [-88.57347571499992, 16.259914455000057],
              [-88.5781957669999, 16.243963934000078],
              [-88.5781957669999, 16.285549221000053],
              [-88.58503170499995, 16.285549221000053],
              [-88.59190833199995, 16.263820705000057],
              [-88.60594641799992, 16.260646877000056],
              [-88.61974036399994, 16.26898834800005],
              [-88.62596594999991, 16.281805731000077],
              [-88.62987219999991, 16.287502346000053],
              [-88.63829505099994, 16.28815338700008],
              [-88.64663652299993, 16.28660716400009],
              [-88.65021725199995, 16.285549221000053],
              [-88.65147864499994, 16.28196849200009],
              [-88.65103105399993, 16.26439036700009],
              [-88.65392005099994, 16.257635809000078],
              [-88.66112219999991, 16.25535716400009],
              [-88.69489498599995, 16.250799872000073],
              [-88.70067298099991, 16.24705638200004],
              [-88.70539303299995, 16.242336330000057],
              [-88.71255449099993, 16.238226630000042],
              [-88.7259008449999, 16.23651764500005],
              [-88.74006100199995, 16.230169989000046],
              [-88.7442113919999, 16.214504299000055],
              [-88.74205481699994, 16.17568594000005],
              [-88.74571692599994, 16.154852606000077],
              [-88.7551977199999, 16.13971588700008],
              [-88.76927649599992, 16.13035716400009],
              [-88.78673255099994, 16.12726471600007],
              [-88.7918188139999, 16.124660549000055],
              [-88.79771887899994, 16.118353583000044],
              [-88.80264238199993, 16.110581773000092],
              [-88.80703691299993, 16.09320709800005],
              [-88.81314042899993, 16.08812083500004],
              [-88.82176673099991, 16.084865627000056],
              [-88.83141028599994, 16.07949453300006],
              [-88.84251868399991, 16.07029857000009],
              [-88.84748287699995, 16.06517161700009],
              [-88.85191809799994, 16.058986721000053],
              [-88.8543188139999, 16.04791901200008],
              [-88.85350501199991, 16.036851304000038],
              [-88.8562719389999, 16.028265692000048],
              [-88.88239498599995, 16.02090078300006],
              [-88.89964758999992, 16.01080963700008],
              [-88.91637122299994, 15.99750397300005],
              [-88.92764238199993, 15.983872789000088],
              [-88.93114173099991, 15.959051825000074],
              [-88.91026770699995, 15.917385158000059],
              [-88.91397050699996, 15.893947658000044],
              [-88.95187841899985, 15.879651999000075],
              [-89.04032263199989, 15.901717834000081],
              [-89.07238785899989, 15.901511129000127],
              [-89.10091324899994, 15.896808574000048],
              [-89.17744604499984, 15.900270894000087],
              [-89.19576533999992, 15.892932841000103],
              [-89.20483455399989, 15.89241607700005],
              [-89.21653926699986, 15.888643697000035],
              [-89.22599605399992, 15.884044495000083],
              [-89.22824397799985, 15.88084055600011],
              [-89.23651220799991, 15.89391469300007],
              [-89.23602227599986, 15.90649316800004],
              [-89.23413509199995, 15.954944560000044],
              [-89.2085168605212, 16.186131919766652],
              [-89.19313967135847, 16.392625602808764],
            ],
          ],
          [
            [
              [-87.83828691299993, 17.388495184000078],
              [-87.82579505099994, 17.39915599200009],
              [-87.81419837099992, 17.381293036000045],
              [-87.79735266799992, 17.333238023000092],
              [-87.80199133999992, 17.325873114000046],
              [-87.80370032499991, 17.31598541900007],
              [-87.80357825399994, 17.292303778000075],
              [-87.81041419199994, 17.292303778000075],
              [-87.81004798099991, 17.30263906500005],
              [-87.81041419199994, 17.305975653000075],
              [-87.81607011599993, 17.30426666900007],
              [-87.81989498599995, 17.30145905200004],
              [-87.82241777299993, 17.29751211100006],
              [-87.82461503799993, 17.292303778000075],
              [-87.82380123599995, 17.35293203300006],
              [-87.82721920499995, 17.378119208000044],
              [-87.83828691299993, 17.388495184000078],
            ],
          ],
          [
            [
              [-87.82774817599994, 17.54555898600006],
              [-87.8157445949999, 17.54515208500004],
              [-87.80150305899991, 17.541815497000073],
              [-87.78921464799993, 17.53196849200009],
              [-87.78307044199994, 17.51203034100007],
              [-87.7871801419999, 17.496893622000073],
              [-87.80785071499992, 17.457831122000073],
              [-87.8211156889999, 17.440741278000075],
              [-87.83128821499992, 17.42373281500005],
              [-87.8457738919999, 17.414618231000077],
              [-87.86563066299993, 17.429510809000078],
              [-87.87588456899994, 17.413234768000052],
              [-87.88853919199994, 17.40387604400007],
              [-87.90005449099993, 17.391791083000044],
              [-87.90721594999991, 17.36741771000004],
              [-87.91344153599994, 17.322699286000045],
              [-87.91588294199994, 17.31541575700004],
              [-87.92100989499994, 17.305243231000077],
              [-87.92552649599992, 17.292792059000078],
              [-87.92650305899991, 17.278631903000075],
              [-87.9407445949999, 17.292303778000075],
              [-87.93700110599991, 17.29564036700009],
              [-87.93569902299993, 17.298976955000057],
              [-87.93529212099992, 17.302394924000055],
              [-87.93390865799995, 17.305975653000075],
              [-87.93150794199994, 17.32721588700008],
              [-87.92227128799993, 17.362494208000044],
              [-87.91746985599991, 17.41046784100007],
              [-87.90953528599994, 17.426255601000037],
              [-87.89671790299991, 17.43768952000005],
              [-87.87930253799993, 17.44993724200009],
              [-87.85879472599993, 17.470404364000046],
              [-87.84870357999995, 17.471258856000077],
              [-87.83381100199995, 17.465318101000037],
              [-87.82127844999991, 17.46360911700009],
              [-87.81163489499994, 17.472316799000055],
              [-87.80394446499992, 17.491929429000038],
              [-87.8020727199999, 17.512925523000092],
              [-87.81041419199994, 17.52562083500004],
              [-87.82144120999993, 17.516180731000077],
              [-87.83067786399994, 17.51113515800006],
              [-87.83828691299993, 17.51203034100007],
              [-87.83779863199993, 17.518377997000073],
              [-87.82774817599994, 17.54555898600006],
            ],
          ],
          [
            [
              [-88.07725989499994, 17.641791083000044],
              [-88.06354732999995, 17.630560614000046],
              [-88.05361894399994, 17.606268622000073],
              [-88.04381262899994, 17.55296458500004],
              [-88.05060787699995, 17.55296458500004],
              [-88.05565344999991, 17.562648830000057],
              [-88.06444251199991, 17.586371161000045],
              [-88.07725989499994, 17.641791083000044],
            ],
          ],
          [
            [
              [-88.16047115799995, 17.682766018000052],
              [-88.13951575399994, 17.69204336100006],
              [-88.08275305899991, 17.72923411700009],
              [-88.0711156889999, 17.73427969000005],
              [-88.08031165299991, 17.70180898600006],
              [-88.10366777299993, 17.68183014500005],
              [-88.13487708199995, 17.671820380000042],
              [-88.1673070949999, 17.669094143000052],
              [-88.16738847599993, 17.673773505000042],
              [-88.16600501199991, 17.67682526200008],
              [-88.16047115799995, 17.682766018000052],
            ],
          ],
          [
            [
              [-87.91344153599994, 18.025946356000077],
              [-87.90721594999991, 18.025946356000077],
              [-87.91510982999995, 17.98273346600007],
              [-87.93455969999991, 17.94293854400007],
              [-87.96580969999991, 17.913763739000046],
              [-88.00902258999992, 17.902492580000057],
              [-88.00902258999992, 17.90924713700008],
              [-87.99864661399994, 17.90892161700009],
              [-87.99535071499992, 17.90924713700008],
              [-87.95889238199993, 17.93427155200004],
              [-87.94591223899994, 17.95180898600006],
              [-87.9407445949999, 17.97752513200004],
              [-87.95653235599991, 17.97675202000005],
              [-87.95230058499993, 18.007757880000042],
              [-87.93390865799995, 18.07029857000009],
              [-87.93175208199995, 18.074693101000037],
              [-87.92711341099994, 18.078273830000057],
              [-87.92235266799992, 18.082953192000048],
              [-87.92027747299994, 18.09080638200004],
              [-87.91966712099992, 18.10057200700004],
              [-87.90485592399995, 18.153225002000056],
              [-87.89500891799992, 18.16209544500009],
              [-87.87930253799993, 18.15570709800005],
              [-87.85728919199994, 18.169663804000038],
              [-87.84732011599993, 18.155991929000038],
              [-87.84898841099994, 18.13377513200004],
              [-87.86221269399994, 18.12213776200008],
              [-87.86961829299992, 18.11082591400009],
              [-87.89004472599993, 18.057033596000053],
              [-87.89976966099994, 18.039007880000042],
              [-87.90664628799993, 18.043524481000077],
              [-87.91344153599994, 18.04645416900007],
              [-87.91588294199994, 18.035956122000073],
              [-87.91966712099992, 18.028509833000044],
              [-87.92544511599993, 18.023138739000046],
              [-87.93390865799995, 18.01911041900007],
              [-87.93390865799995, 18.01235586100006],
              [-87.92650305899991, 17.997992255000042],
              [-87.91710364499994, 18.01117584800005],
              [-87.9148656889999, 18.01715729400007],
              [-87.91344153599994, 18.025946356000077],
            ],
          ],
          [
            [
              [-88.09561113199993, 17.517401434000078],
              [-88.07701575399994, 17.503729559000078],
              [-88.0676977199999, 17.49054596600007],
              [-88.06981360599991, 17.48065827000005],
              [-88.07262122299994, 17.47614166900007],
              [-88.07286536399994, 17.47011953300006],
              [-88.07705644399994, 17.461086330000057],
              [-88.08397376199991, 17.461818752000056],
              [-88.08580481699994, 17.47011953300006],
              [-88.08714758999992, 17.49091217700004],
              [-88.08849036399994, 17.495306708000044],
              [-88.0965063139999, 17.494289455000057],
              [-88.10513261599993, 17.498114325000074],
              [-88.11091061099995, 17.505072333000044],
              [-88.11424719999991, 17.51007721600007],
              [-88.11729895699995, 17.512884833000044],
              [-88.11717688699991, 17.518784898000092],
              [-88.11046301999994, 17.52301666900007],
              [-88.09561113199993, 17.517401434000078],
            ],
          ],
          [
            [
              [-87.96906490799995, 18.09088776200008],
              [-87.96328691299993, 18.09320709800005],
              [-87.96031653599994, 18.090399481000077],
              [-87.96251380099994, 18.07998281500005],
              [-87.97061113199993, 18.073146877000056],
              [-87.98143469999991, 18.07127513200004],
              [-87.98436438699991, 18.07758209800005],
              [-87.97716223899994, 18.08746979400007],
              [-87.97207597599993, 18.090725002000056],
              [-87.96906490799995, 18.09088776200008],
            ],
          ],
          [
            [
              [-87.9395238919999, 18.11863841400009],
              [-87.93712317599994, 18.11465078300006],
              [-87.93639075399994, 18.103908596000053],
              [-87.94225012899994, 18.093491929000038],
              [-87.9505102199999, 18.087591864000046],
              [-87.95400956899994, 18.088283596000053],
              [-87.95531165299991, 18.093410549000055],
              [-87.95689856699994, 18.097357489000046],
              [-87.95523027299993, 18.100816148000092],
              [-87.95010331899994, 18.103583075000074],
              [-87.94481360599991, 18.107896226000037],
              [-87.94302324099993, 18.11347077000005],
              [-87.94115149599992, 18.11717357000009],
              [-87.9395238919999, 18.11863841400009],
            ],
          ],
          [
            [
              [-87.87840735599991, 18.208238023000092],
              [-87.87474524599992, 18.20648834800005],
              [-87.87413489499994, 18.202460028000075],
              [-87.87474524599992, 18.197333075000074],
              [-87.87828528599994, 18.187323309000078],
              [-87.88780676999994, 18.175604559000078],
              [-87.89354407499991, 18.18036530200004],
              [-87.89077714799993, 18.19745514500005],
              [-87.88683020699995, 18.20343659100007],
              [-87.88369706899994, 18.20107656500005],
              [-87.88316809799994, 18.20311107000009],
              [-87.8848363919999, 18.207464911000045],
              [-87.88442949099993, 18.20917389500005],
              [-87.88097083199995, 18.20848216400009],
              [-87.87840735599991, 18.208238023000092],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Panama',
        iso3: 'PAN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-82.57359778599994, 9.576198635000083],
              [-82.56187903599994, 9.56907786700009],
              [-82.4656469389999, 9.493963934000078],
              [-82.40660559799994, 9.435248114000046],
              [-82.36896725199995, 9.414943752000056],
              [-82.34276282499991, 9.432521877000056],
              [-82.34508216099994, 9.415432033000059],
              [-82.34959876199991, 9.402044989000046],
              [-82.37677975199995, 9.355169989000046],
              [-82.37946529899995, 9.343817450000074],
              [-82.3762914699999, 9.33006419500009],
              [-82.36778723899994, 9.320746161000045],
              [-82.35643469999991, 9.313421942000048],
              [-82.34813391799992, 9.305568752000056],
              [-82.3489477199999, 9.294745184000078],
              [-82.36245683499993, 9.284125067000048],
              [-82.38760331899994, 9.286078192000048],
              [-82.3899633449999, 9.27484772300005],
              [-82.39492753799993, 9.267075914000088],
              [-82.39366614499994, 9.262111721000053],
              [-82.38878333199995, 9.26007721600007],
              [-82.38304602799991, 9.261216539000088],
              [-82.37319902299993, 9.25454336100006],
              [-82.36449133999992, 9.242865302000041],
              [-82.35814368399991, 9.229437567000048],
              [-82.35582434799994, 9.21678294500009],
              [-82.35057532499991, 9.20726146000004],
              [-82.31480872299994, 9.185492255000042],
              [-82.30797278599994, 9.185492255000042],
              [-82.30044511599993, 9.197088934000078],
              [-82.28823808499993, 9.198553778000075],
              [-82.28246008999992, 9.202093817000048],
              [-82.29430091099994, 9.220282294000071],
              [-82.28099524599992, 9.216620184000078],
              [-82.27594967399995, 9.206447658000059],
              [-82.27306067599994, 9.194484768000052],
              [-82.2664281889999, 9.185492255000042],
              [-82.25548255099994, 9.18260325700004],
              [-82.24791419199994, 9.186997789000088],
              [-82.24445553299995, 9.19757721600007],
              [-82.24596106699994, 9.213446356000077],
              [-82.2390844389999, 9.213446356000077],
              [-82.23814856699994, 9.20026276200008],
              [-82.23106848899994, 9.193752346000053],
              [-82.22305253799993, 9.192775783000059],
              [-82.21922766799992, 9.19635651200008],
              [-82.21873938699991, 9.208644924000055],
              [-82.2168676419999, 9.217474677000041],
              [-82.21251380099994, 9.220038153000075],
              [-82.20494544199994, 9.213446356000077],
              [-82.20396887899994, 9.216538804000038],
              [-82.20400956899994, 9.219224351000037],
              [-82.20278886599993, 9.22068919500009],
              [-82.19810950399994, 9.220282294000071],
              [-82.19619706899994, 9.21116771000004],
              [-82.1934301419999, 9.20408763200004],
              [-82.18960527299993, 9.19830963700008],
              [-82.18443762899994, 9.192938544000071],
              [-82.17764238199993, 9.192938544000071],
              [-82.17764238199993, 9.199774481000077],
              [-82.17080644399994, 9.199774481000077],
              [-82.17345130099994, 9.184759833000044],
              [-82.17170162699995, 9.157416083000044],
              [-82.17764238199993, 9.14516836100006],
              [-82.20811926999994, 9.163763739000046],
              [-82.22411048099991, 9.169663804000038],
              [-82.24962317599994, 9.171820380000042],
              [-82.26073157499991, 9.16404857000009],
              [-82.26378333199995, 9.146551825000074],
              [-82.26073157499991, 9.127875067000048],
              [-82.25340735599991, 9.116603908000059],
              [-82.25340735599991, 9.11041901200008],
              [-82.25894120999993, 9.11273834800005],
              [-82.27383378799993, 9.116603908000059],
              [-82.26846269399994, 9.102362372000073],
              [-82.24453691299993, 9.089911200000074],
              [-82.2390844389999, 9.079331773000092],
              [-82.24596106699994, 9.014146226000037],
              [-82.25047766799992, 9.015204169000071],
              [-82.25348873599995, 9.016302802000041],
              [-82.25621497299994, 9.017971096000053],
              [-82.26016191299993, 9.020982164000088],
              [-82.24303137899994, 9.004461981000077],
              [-82.2188207669999, 8.993353583000044],
              [-82.19469153599994, 8.99095286700009],
              [-82.17764238199993, 9.000555731000077],
              [-82.14175370999993, 8.988959052000041],
              [-82.12901770699995, 8.981390692000048],
              [-82.12922115799995, 8.973211981000077],
              [-82.11440995999993, 8.950751044000071],
              [-82.10936438699991, 8.94529857000009],
              [-82.10700436099995, 8.941880601000037],
              [-82.10537675699993, 8.935207424000055],
              [-82.10191809799994, 8.93162669500009],
              [-82.09780839799993, 8.930609442000048],
              [-82.08665930899991, 8.931708075000074],
              [-82.06761633999992, 8.93073151200008],
              [-82.02000891799992, 8.94529857000009],
              [-81.99771074099993, 8.947455145000049],
              [-81.98521887899994, 8.942328192000048],
              [-81.97472083199995, 8.935207424000055],
              [-81.95856686099995, 8.93162669500009],
              [-81.94395911399994, 8.935126044000071],
              [-81.92943274599992, 8.943833726000037],
              [-81.92076575399994, 8.955145575000074],
              [-81.92373613199993, 8.966376044000071],
              [-81.91246497299994, 8.971096096000053],
              [-81.90371660099993, 8.971136786000045],
              [-81.88963782499991, 8.966376044000071],
              [-81.88768469999991, 8.962591864000046],
              [-81.87804114499994, 8.954250393000052],
              [-81.86733964799993, 8.949286200000074],
              [-81.86237545499995, 8.95579661700009],
              [-81.85228430899991, 8.958319403000075],
              [-81.79344641799992, 8.93162669500009],
              [-81.77554277299993, 8.940252997000073],
              [-81.77057857999995, 8.957464911000045],
              [-81.7742406889999, 8.997463283000059],
              [-81.8418676419999, 9.035305080000057],
              [-81.87706458199995, 9.087307033000059],
              [-81.88621985599991, 9.096136786000045],
              [-81.89928137899994, 9.10187409100007],
              [-81.91783606699994, 9.114976304000038],
              [-81.93342037699995, 9.12921784100007],
              [-81.93740800699993, 9.138332424000055],
              [-81.92202714799993, 9.13812897300005],
              [-81.89663652299993, 9.131781317000048],
              [-81.87287350199995, 9.12954336100006],
              [-81.86237545499995, 9.141750393000052],
              [-81.89476477799991, 9.156927802000041],
              [-81.91030839799993, 9.168117580000057],
              [-81.90330969999991, 9.179266669000071],
              [-81.88280188699991, 9.179510809000078],
              [-81.86546790299991, 9.16665273600006],
              [-81.8418676419999, 9.138332424000055],
              [-81.81875566299993, 9.12107982000009],
              [-81.81456458199995, 9.116603908000059],
              [-81.81602942599994, 9.10805898600006],
              [-81.82420813699991, 9.10545482000009],
              [-81.83438066299993, 9.107001044000071],
              [-81.8418676419999, 9.11041901200008],
              [-81.8418676419999, 9.103583075000074],
              [-81.83372962099992, 9.093817450000074],
              [-81.8258313899999, 9.08528605400005],
              [-81.82088085399994, 9.070647428000086],
              [-81.81346556799991, 9.06780531000004],
              [-81.80028557799994, 9.067811131000042],
              [-81.77680703499993, 9.06497242000006],
              [-81.76197132199991, 9.063750226000082],
              [-81.73688717399995, 9.036932684000078],
              [-81.72117186999992, 9.03202187100004],
              [-81.70645097599993, 8.999172268000052],
              [-81.70156816299993, 8.994330145000049],
              [-81.68748938699991, 8.984198309000078],
              [-81.62755286399994, 8.899115302000041],
              [-81.58731035099993, 8.856350002000056],
              [-81.56749426999994, 8.843491929000038],
              [-81.56159420499995, 8.834377346000053],
              [-81.55077063699991, 8.822821356000077],
              [-81.53905188699991, 8.812933661000045],
              [-81.53026282499991, 8.808742580000057],
              [-81.52147376199991, 8.806789455000057],
              [-81.50329208599993, 8.800959842000054],
              [-81.4911969389999, 8.80098472700007],
              [-81.47347433899995, 8.806593814000053],
              [-81.42150634699993, 8.796426828000051],
              [-81.40943074899991, 8.800099720000048],
              [-81.3815466449999, 8.800120439000068],
              [-81.35798092399995, 8.785101630000042],
              [-81.3044631599999, 8.781882361000044],
              [-81.26622414899992, 8.789234831000044],
              [-81.21307278599994, 8.79180860100007],
              [-81.17478467299992, 8.796765778000065],
              [-81.13034023599994, 8.801736471000083],
              [-81.08771725199995, 8.808742580000057],
              [-81.07990475199995, 8.804836330000057],
              [-81.07070878799993, 8.806830145000049],
              [-81.06151282499991, 8.813177802000041],
              [-81.05357825399994, 8.822414455000057],
              [-80.97513893799993, 8.848088992000044],
              [-80.89892320999991, 8.87963516900004],
              [-80.88171707399994, 8.885697916000083],
              [-80.84485694599994, 8.884479757000065],
              [-80.82241777299993, 8.890692450000074],
              [-80.8128994569999, 8.902669580000065],
              [-80.80429236399993, 8.912369333000072],
              [-80.78355872299994, 8.939195054000038],
              [-80.77257239499994, 8.95343659100007],
              [-80.7625219389999, 8.959540106000077],
              [-80.75914466099994, 8.962713934000078],
              [-80.75584876199991, 8.96979401200008],
              [-80.75064042899993, 8.97687409100007],
              [-80.74168860599991, 8.980047919000071],
              [-80.7268262899999, 8.997221549000074],
              [-80.70348462299995, 9.00810791200007],
              [-80.66710364499994, 9.029730536000045],
              [-80.65322831899994, 9.035305080000057],
              [-80.63711786899995, 9.051671743000043],
              [-80.57933726999994, 9.08068731700007],
              [-80.5067727149999, 9.110891244000072],
              [-80.40831586199994, 9.14226211600004],
              [-80.29259192599994, 9.15135325700004],
              [-80.27745520699995, 9.156398830000057],
              [-80.24478105399993, 9.175116278000075],
              [-80.23493404899995, 9.179266669000071],
              [-80.19994055899991, 9.183172919000071],
              [-80.1629125639999, 9.192938544000071],
              [-80.1297094389999, 9.206203518000052],
              [-80.10081946499992, 9.222316799000055],
              [-80.06520070199991, 9.262480813000082],
              [-80.0261938139999, 9.296616929000038],
              [-80.00082338199991, 9.320515588000092],
              [-79.99850467899995, 9.331796456000063],
              [-79.97894374399993, 9.36335312600005],
              [-79.9537310579999, 9.373433893000083],
              [-79.94743641199994, 9.372848822000037],
              [-79.94375566299993, 9.36359284100007],
              [-79.94591223899994, 9.325873114000046],
              [-79.94375566299993, 9.31586334800005],
              [-79.93822180899991, 9.309149481000077],
              [-79.92943274599992, 9.30414459800005],
              [-79.91917883999992, 9.303168036000045],
              [-79.90904700399994, 9.308417059000078],
              [-79.90160071499992, 9.326646226000037],
              [-79.90025794199994, 9.346828518000052],
              [-79.89468339799993, 9.35643138200004],
              [-79.87486731699994, 9.343166408000059],
              [-79.87706458199995, 9.351629950000074],
              [-79.87950598899994, 9.368801174000055],
              [-79.88170325399994, 9.37726471600007],
              [-79.87930253799993, 9.375433661000045],
              [-79.87486731699994, 9.37107982000009],
              [-79.86803137899994, 9.37726471600007],
              [-79.88040158399991, 9.39464028000009],
              [-79.8712115319999, 9.404204787000083],
              [-79.85978611999991, 9.399083630000064],
              [-79.84089812699995, 9.400709095000082],
              [-79.8186231439999, 9.39103205400005],
              [-79.80036373599995, 9.36078522300005],
              [-79.79295813699991, 9.349351304000038],
              [-79.79698645699995, 9.371283270000049],
              [-79.80215410099993, 9.386664130000042],
              [-79.80272376199991, 9.400580145000049],
              [-79.79295813699991, 9.41819896000004],
              [-79.7781469389999, 9.431586005000042],
              [-79.74828040299991, 9.442531643000052],
              [-79.73151607999995, 9.45302969000005],
              [-79.72935950399994, 9.455959377000056],
              [-79.7266332669999, 9.463364976000037],
              [-79.72472083199995, 9.46670156500005],
              [-79.72130286399994, 9.469224351000037],
              [-79.71465453699994, 9.47984492200004],
              [-79.70546269099992, 9.485459786000092],
              [-79.69062971999995, 9.495799408000039],
              [-79.6842831539999, 9.521478175000084],
              [-79.67737458599993, 9.545607528000062],
              [-79.6596830229999, 9.552373618000047],
              [-79.6516624539999, 9.55969390000007],
              [-79.65648481599993, 9.564962828000091],
              [-79.66772035799994, 9.560802323000075],
              [-79.67650305899991, 9.558417059000078],
              [-79.68215766899993, 9.564526740000076],
              [-79.67573197299993, 9.568706321000093],
              [-79.66984326599993, 9.572886580000045],
              [-79.66448485699993, 9.583370031000072],
              [-79.65003105499994, 9.589606428000081],
              [-79.63885293599992, 9.598508694000088],
              [-79.63033519699991, 9.608473537000066],
              [-79.61221022799992, 9.613666727000066],
              [-79.59624273399993, 9.611521288000063],
              [-79.57654892999994, 9.617789961000085],
              [-79.55096854999994, 9.62929248000006],
              [-79.53286699099993, 9.624335028000075],
              [-79.52798417899993, 9.612453518000052],
              [-79.52261308499993, 9.602850653000075],
              [-79.52245032499991, 9.595282294000071],
              [-79.53286699099993, 9.589544989000046],
              [-79.53286699099993, 9.583319403000075],
              [-79.52306067599994, 9.579046942000048],
              [-79.52281653599994, 9.576727606000077],
              [-79.51919511599993, 9.56907786700009],
              [-79.51431230399993, 9.57249583500004],
              [-79.51073157499991, 9.57453034100007],
              [-79.5078832669999, 9.577378648000092],
              [-79.50499426999994, 9.583319403000075],
              [-79.49815833199995, 9.583319403000075],
              [-79.49201412699995, 9.578680731000077],
              [-79.48387610599991, 9.575018622000073],
              [-79.46397864499994, 9.56907786700009],
              [-79.46349036399994, 9.577704169000071],
              [-79.45653235599991, 9.596380927000041],
              [-79.4512426419999, 9.587388414000088],
              [-79.44456946499992, 9.583807684000078],
              [-79.43724524599992, 9.58470286700009],
              [-79.42983964799993, 9.589544989000046],
              [-79.39189221999993, 9.580501864000041],
              [-79.33604602399993, 9.57435921800004],
              [-79.27274965599992, 9.557021313000064],
              [-79.2397089829999, 9.545515083000055],
              [-79.19375722899991, 9.53960210200006],
              [-79.17500364499995, 9.549403746000053],
              [-79.1562743639999, 9.554955061000044],
              [-79.1332760869999, 9.553404717000092],
              [-79.11603674199995, 9.551889715000073],
              [-79.09877164199992, 9.556032194000068],
              [-79.08006653099994, 9.56157950000005],
              [-79.04845565199992, 9.564218877000087],
              [-79.01290200799991, 9.570225582000091],
              [-78.97058297199993, 9.573313287000076],
              [-78.95731140799995, 9.565283566000062],
              [-78.95736250999994, 9.554032607000067],
              [-78.97451246299994, 9.544735453000044],
              [-78.98685837099993, 9.547135568000044],
              [-78.99687111199995, 9.539680668000074],
              [-79.00780600299993, 9.538792274000059],
              [-79.03823063099992, 9.535170273000062],
              [-79.05487343899995, 9.531958770000074],
              [-79.06585882999991, 9.513720207000063],
              [-79.06315206999994, 9.49029209400004],
              [-79.05806002299994, 9.457931447000078],
              [-79.04049811499993, 9.452233634000038],
              [-79.0243235989999, 9.455913990000056],
              [-79.01389037699994, 9.451183411000045],
              [-79.00104969499995, 9.453471043000093],
              [-78.98821213399992, 9.455289557000071],
              [-78.9772772689999, 9.457115774000044],
              [-78.9663622189999, 9.45472499400006],
              [-78.95259004199994, 9.454663080000046],
              [-78.93505017399991, 9.447556342000041],
              [-78.92461863999995, 9.44423117000008],
              [-78.91567949099993, 9.436835028000075],
              [-78.90807044199994, 9.430812893000052],
              [-78.90330969999991, 9.42291901200008],
              [-78.89574330399995, 9.42442106100009],
              [-78.88291297299992, 9.425295124000058],
              [-78.8748411329999, 9.424788310000054],
              [-78.86487824799991, 9.422397982000064],
              [-78.85254420299992, 9.423753852000061],
              [-78.8472357409999, 9.433084454000038],
              [-78.8363359199999, 9.435384427000088],
              [-78.81784476899992, 9.431080468000062],
              [-78.78938426499991, 9.436570632000041],
              [-78.78113641499993, 9.445882047000055],
              [-78.76410528799994, 9.442521953000039],
              [-78.75264904499994, 9.444333833000087],
              [-78.74159506699993, 9.44848875100007],
              [-78.72822288499992, 9.454983637000055],
              [-78.71788489499994, 9.441839911000045],
              [-78.70165696899994, 9.434259603000044],
              [-78.68886908499991, 9.43555350400004],
              [-78.65560028599992, 9.426498389000074],
              [-78.63326473099994, 9.428733218000048],
              [-78.62002758199992, 9.418825435000088],
              [-78.60389964699993, 9.416394068000045],
              [-78.58962149599995, 9.42240219000007],
              [-78.57808738799991, 9.43189831300009],
              [-78.56131832599993, 9.438040165000075],
              [-78.54640744199992, 9.434370216000048],
              [-78.52712264599995, 9.421502986000064],
              [-78.51282012399992, 9.415992034000055],
              [-78.4798896659999, 9.416002824000088],
              [-78.46344967399995, 9.40460846600007],
              [-78.45260668899994, 9.40883344000008],
              [-78.43771249799994, 9.404351060000067],
              [-78.42726134199995, 9.393895709000049],
              [-78.41595138199995, 9.38430978100007],
              [-78.38873073299993, 9.371848899000042],
              [-78.37832171399992, 9.365750006000042],
              [-78.36422450399994, 9.36119855700008],
              [-78.33833926199992, 9.35600665600009],
              [-78.3175122419999, 9.344662242000084],
              [-78.30272703399993, 9.333313626000063],
              [-78.28707217399995, 9.326287320000063],
              [-78.27748631499992, 9.321878839000078],
              [-78.26791099399992, 9.320943162000049],
              [-78.25486162099992, 9.31738961600007],
              [-78.24185741299993, 9.309545141000058],
              [-78.22623634099995, 9.300807706000057],
              [-78.20802479399993, 9.290335613000082],
              [-78.19235394299994, 9.287610808000068],
              [-78.17665408399995, 9.290058988000055],
              [-78.16708629099992, 9.286516887000062],
              [-78.15492256599993, 9.279491061000044],
              [-78.14190549599994, 9.277709576000063],
              [-78.1237068929999, 9.266364628000076],
              [-78.11400305899991, 9.25381094000005],
              [-78.08815929999992, 9.247983673000078],
              [-78.05599234899995, 9.243438130000072],
              [-78.03690117899993, 9.23639165700007],
              [-78.02456620999993, 9.22646719000005],
              [-78.0208227199999, 9.21360911700009],
              [-77.99925696499992, 9.190822658000059],
              [-77.9862546459999, 9.188899939000066],
              [-77.96865800699993, 9.180609442000048],
              [-77.93540895199993, 9.142888937000066],
              [-77.91852779899995, 9.116603908000059],
              [-77.90502841799992, 9.099310445000071],
              [-77.89015234899995, 9.077213285000084],
              [-77.8557435969999, 9.054290580000043],
              [-77.86083844199993, 9.068091029000072],
              [-77.86522376199991, 9.080267645000049],
              [-77.8764420999999, 9.103554690000067],
              [-77.87766101999995, 9.11888756500008],
              [-77.86009680899991, 9.11041901200008],
              [-77.84725879699994, 9.087558109000042],
              [-77.83919444299994, 9.076501573000087],
              [-77.81186510799995, 9.058039561000044],
              [-77.80817235199993, 9.035333090000051],
              [-77.7982385389999, 9.024263803000053],
              [-77.78581384099994, 9.016871380000055],
              [-77.77074133999992, 9.003973700000074],
              [-77.76724199099993, 8.992336330000057],
              [-77.75853430899991, 8.98151276200008],
              [-77.74754798099991, 8.97256094000005],
              [-77.7444159659999, 8.96357630500006],
              [-77.75420571599994, 8.945658706000074],
              [-77.73473059799994, 8.923488674000055],
              [-77.72077232999993, 8.892290262000074],
              [-77.71032086299994, 8.881281909000052],
              [-77.70105606899995, 8.889259806000041],
              [-77.69673684399993, 8.88742638900004],
              [-77.6955196479999, 8.87331922900006],
              [-77.6762925239999, 8.861628296000049],
              [-77.65585186299995, 8.843200133000039],
              [-77.63345292899993, 8.81745026200008],
              [-77.61432857999995, 8.808742580000057],
              [-77.61945553299995, 8.816961981000077],
              [-77.62604732999995, 8.823146877000056],
              [-77.63174394399994, 8.829901434000078],
              [-77.63418535099993, 8.839789130000042],
              [-77.62905839799993, 8.84446849200009],
              [-77.61799068899995, 8.835191148000092],
              [-77.60741126199991, 8.82217031500005],
              [-77.60383053299995, 8.815578518000052],
              [-77.57407264999995, 8.792754063000075],
              [-77.57787370799991, 8.775030270000059],
              [-77.55934215299993, 8.75970760000007],
              [-77.55362263399991, 8.776756090000049],
              [-77.54368848899992, 8.774885415000085],
              [-77.53509940299995, 8.757744993000074],
              [-77.53834277699991, 8.741314829000089],
              [-77.5402902859999, 8.72607897100005],
              [-77.54474951799995, 8.714603511000064],
              [-77.53213732899991, 8.703201771000067],
              [-77.50072180899991, 8.681830145000049],
              [-77.47695878799993, 8.66990794500009],
              [-77.44420325399994, 8.66437409100007],
              [-77.41319739499994, 8.666693427000041],
              [-77.3946020169999, 8.678412177000041],
              [-77.3906957669999, 8.673529364000046],
              [-77.38581295499995, 8.669582424000055],
              [-77.38003495999993, 8.66665273600006],
              [-77.37352454299992, 8.664740302000041],
              [-77.37493648399993, 8.6509459440001],
              [-77.38537512199986, 8.643633728000111],
              [-77.40154984599985, 8.642031759000076],
              [-77.41767289299995, 8.638466085000104],
              [-77.43400264499988, 8.628259989000043],
              [-77.43503617399995, 8.620637716000061],
              [-77.43023026499995, 8.610457459000102],
              [-77.42909338499993, 8.59262909000006],
              [-77.44113399299991, 8.567669372000069],
              [-77.4693733009999, 8.537811606000105],
              [-77.48035640499995, 8.526199036],
              [-77.48867630999993, 8.496536764000055],
              [-77.48872798699995, 8.473644104000115],
              [-77.4796846109999, 8.46785634300005],
              [-77.44960892799992, 8.470646871000014],
              [-77.43271073499992, 8.465065816000092],
              [-77.4223237709999, 8.456410014000141],
              [-77.4057873139999, 8.428453064000053],
              [-77.39126623599986, 8.393545634000063],
              [-77.38299800599992, 8.324945171000124],
              [-77.37436804299998, 8.289314270000133],
              [-77.36320593299993, 8.27208018000006],
              [-77.3504935309999, 8.267403463000093],
              [-77.33716101099986, 8.26662831600008],
              [-77.32434525599987, 8.261202291000103],
              [-77.31690384999987, 8.250841166000086],
              [-77.29519974799987, 8.205495097000068],
              [-77.26943425099992, 8.167700643000046],
              [-77.26011144999993, 8.154025371000088],
              [-77.23106929499994, 8.098731588000064],
              [-77.2096235759999, 8.020700175000059],
              [-77.2077632239999, 7.996567281000097],
              [-77.2012003179999, 7.98199452700004],
              [-77.1915368249999, 7.972847799000064],
              [-77.1808398039999, 7.965148010000064],
              [-77.17107295799994, 7.954916077000078],
              [-77.16326981599991, 7.939258117000037],
              [-77.16900589999997, 7.935072326000096],
              [-77.20605790299993, 7.935485738000096],
              [-77.23613358599991, 7.92923289],
              [-77.26972326699993, 7.918122457000081],
              [-77.30041906799997, 7.90210276300013],
              [-77.32160640499984, 7.881018779000016],
              [-77.34718623899988, 7.82381296800007],
              [-77.37664180599998, 7.786605937000061],
              [-77.37989742099995, 7.774410299000039],
              [-77.36651322499992, 7.745109762000084],
              [-77.34599768099986, 7.725731099000114],
              [-77.33974483299997, 7.707230937000091],
              [-77.36909704599992, 7.680772603],
              [-77.50934688399994, 7.594111227000056],
              [-77.55492549699991, 7.548480937000051],
              [-77.57998856699993, 7.528378805000088],
              [-77.60267451999991, 7.526053365000067],
              [-77.6133198659999, 7.537473857000066],
              [-77.62546382699989, 7.587444967000039],
              [-77.63306026199987, 7.60067413400013],
              [-77.66075882999988, 7.63803619400008],
              [-77.6633943279999, 7.639948222000015],
              [-77.6718692629999, 7.64196360300005],
              [-77.67481481999991, 7.644650778000084],
              [-77.67476314299998, 7.64842315700011],
              [-77.67062902899997, 7.65731150400012],
              [-77.67021561799996, 7.659947001000134],
              [-77.6799307869999, 7.670954081000033],
              [-77.72990189699996, 7.713328756000053],
              [-77.74023718299989, 7.718858134000044],
              [-77.7642150479999, 7.705732320000081],
              [-77.7705195719999, 7.6689903770001],
              [-77.76581701699993, 7.626460674000043],
              [-77.7568253179999, 7.595558167000135],
              [-77.73424271699994, 7.551788228000049],
              [-77.73124548399994, 7.530342509000121],
              [-77.74023718299989, 7.504607645000121],
              [-77.75511999499992, 7.486107483000097],
              [-77.77424027499993, 7.474738668000029],
              [-77.79630611199991, 7.471276347000071],
              [-77.8201806239999, 7.476547343000107],
              [-77.85501053899986, 7.365391337000105],
              [-77.89583915073322, 7.235098056585514],
              [-77.8965551419999, 7.235296942000048],
              [-77.91881262899994, 7.24164459800005],
              [-77.94762122299994, 7.267645575000074],
              [-77.99046790299991, 7.32094961100006],
              [-78.00645911399994, 7.332464911000045],
              [-78.01439368399991, 7.341009833000044],
              [-78.01781165299991, 7.35228099200009],
              [-78.01553300699993, 7.36273834800005],
              [-78.01154537699995, 7.373195705000057],
              [-78.00975501199991, 7.383490302000041],
              [-78.01439368399991, 7.393540757000039],
              [-78.02009029899995, 7.397853908000059],
              [-78.02285722599993, 7.395982164000088],
              [-78.02489173099991, 7.39203522300005],
              [-78.02798417899993, 7.389837958000044],
              [-78.03587805899991, 7.393011786000045],
              [-78.03815670499995, 7.399400132000039],
              [-78.03612219999991, 7.40460846600007],
              [-78.03148352799991, 7.404120184000078],
              [-78.04344641799992, 7.422308661000045],
              [-78.04995683499993, 7.425930080000057],
              [-78.05939693899995, 7.417792059000078],
              [-78.06554114499994, 7.417792059000078],
              [-78.08971106699994, 7.445217190000051],
              [-78.10562089799993, 7.459418036000045],
              [-78.11742102799991, 7.46556224200009],
              [-78.12067623599995, 7.469916083000044],
              [-78.12315833199995, 7.479478257000039],
              [-78.12791907499991, 7.489162502000056],
              [-78.13784745999993, 7.493475653000075],
              [-78.14415442599994, 7.497870184000078],
              [-78.14907792899993, 7.507879950000074],
              [-78.1555883449999, 7.52765534100007],
              [-78.16177324099993, 7.52765534100007],
              [-78.1660863919999, 7.512640692000048],
              [-78.16832434799994, 7.522406317000048],
              [-78.1692602199999, 7.557440497000073],
              [-78.17422441299993, 7.575425523000092],
              [-78.18480383999992, 7.579413153000075],
              [-78.19444739499994, 7.571437893000052],
              [-78.19652258999992, 7.553697007000039],
              [-78.20201575399994, 7.566839911000045],
              [-78.20030676999994, 7.576157945000091],
              [-78.19664466099994, 7.584906317000048],
              [-78.19652258999992, 7.595892645000049],
              [-78.20030676999994, 7.606431382000039],
              [-78.20445716099994, 7.612127997000073],
              [-78.21642005099994, 7.622544664000088],
              [-78.23770097599993, 7.649888414000088],
              [-78.25234941299993, 7.660956122000073],
              [-78.27163652299993, 7.663560289000088],
              [-78.26927649599992, 7.67454661700009],
              [-78.27358964799993, 7.682806708000044],
              [-78.28213456899994, 7.688462632000039],
              [-78.29214433499993, 7.691473700000074],
              [-78.28258216099994, 7.710638739000046],
              [-78.27749589799993, 7.724351304000038],
              [-78.27814693899995, 7.737372137000079],
              [-78.28526770699995, 7.754136460000041],
              [-78.31533769399994, 7.799872137000079],
              [-78.32005774599992, 7.81126536700009],
              [-78.3294164699999, 7.843247789000088],
              [-78.35114498599995, 7.870184637000079],
              [-78.37596594999991, 7.894191799000055],
              [-78.39452063699991, 7.91742584800005],
              [-78.40758216099994, 7.948228257000039],
              [-78.41563880099994, 7.980129299000055],
              [-78.41600501199991, 7.992173570000091],
              [-78.41364498599995, 8.003648179000038],
              [-78.41563880099994, 8.013617255000042],
              [-78.43358313699991, 8.045803127000056],
              [-78.43614661399994, 8.058294989000046],
              [-78.43081620999993, 8.07713450700004],
              [-78.41905676999994, 8.095404364000046],
              [-78.40729732999995, 8.10219961100006],
              [-78.39574133999992, 8.069891669000071],
              [-78.38133704299992, 8.063625393000052],
              [-78.36522376199991, 8.065985419000071],
              [-78.3535863919999, 8.075669664000088],
              [-78.32518469999991, 8.060939846000053],
              [-78.2864477199999, 8.08071523600006],
              [-78.25218665299991, 8.11749909100007],
              [-78.23745683499993, 8.153957424000055],
              [-78.23936926999994, 8.174383856000077],
              [-78.24474036399994, 8.186916408000059],
              [-78.25328528599994, 8.195786851000037],
              [-78.26480058499993, 8.20538971600007],
              [-78.29405676999994, 8.239203192000048],
              [-78.30577551999994, 8.24640534100007],
              [-78.30577551999994, 8.253851630000042],
              [-78.2786352199999, 8.25096263200004],
              [-78.27009029899995, 8.252386786000045],
              [-78.25739498599995, 8.25999583500004],
              [-78.25739498599995, 8.267523505000042],
              [-78.26317298099991, 8.270331122000073],
              [-78.26610266799992, 8.273260809000078],
              [-78.26817786399994, 8.276678778000075],
              [-78.27163652299993, 8.28115469000005],
              [-78.26366126199991, 8.284328518000052],
              [-78.26130123599995, 8.284735419000071],
              [-78.25739498599995, 8.29482656500005],
              [-78.24893144399994, 8.289211330000057],
              [-78.23745683499993, 8.278509833000044],
              [-78.23070227799991, 8.274359442000048],
              [-78.22191321499992, 8.271918036000045],
              [-78.21422278599994, 8.272162177000041],
              [-78.19969641799992, 8.274359442000048],
              [-78.19810950399994, 8.27830638200004],
              [-78.18586178299995, 8.295111395000049],
              [-78.1829320949999, 8.29791901200008],
              [-78.18439693899995, 8.325344143000052],
              [-78.1829320949999, 8.335760809000078],
              [-78.18004309799994, 8.337591864000046],
              [-78.16177324099993, 8.356268622000073],
              [-78.1575414699999, 8.36554596600007],
              [-78.15575110599991, 8.374335028000075],
              [-78.1555883449999, 8.394110419000071],
              [-78.15135657499991, 8.39948151200008],
              [-78.1419164699999, 8.404038804000038],
              [-78.13247636599993, 8.40534088700008],
              [-78.12828528599994, 8.400946356000077],
              [-78.12328040299991, 8.364488023000092],
              [-78.12083899599992, 8.356268622000073],
              [-78.11095130099994, 8.34796784100007],
              [-78.09455318899995, 8.339056708000044],
              [-78.07664954299992, 8.331854559000078],
              [-78.06248938699991, 8.328924872000073],
              [-78.05101477799991, 8.32249583500004],
              [-78.04246985599991, 8.30735911700009],
              [-78.02489173099991, 8.259711005000042],
              [-78.01512610599991, 8.246527411000045],
              [-78.00255286399994, 8.237005927000041],
              [-77.98741614499994, 8.233343817000048],
              [-77.98265540299991, 8.23533763200004],
              [-77.97203528599994, 8.238470770000049],
              [-77.96129309799994, 8.238023179000038],
              [-77.95352128799993, 8.223781643000052],
              [-77.9466039699999, 8.218410549000055],
              [-77.93773352799991, 8.214422919000071],
              [-77.92906653599994, 8.21287669500009],
              [-77.91539466099994, 8.21287669500009],
              [-77.91539466099994, 8.21906159100007],
              [-77.93073482999995, 8.222398179000038],
              [-77.94473222599993, 8.230536200000074],
              [-77.95588131399995, 8.24164459800005],
              [-77.96255449099993, 8.253851630000042],
              [-77.91258704299992, 8.244330145000049],
              [-77.88597571499992, 8.23468659100007],
              [-77.86900794199994, 8.21548086100006],
              [-77.84508216099994, 8.20258209800005],
              [-77.83967037699995, 8.195502020000049],
              [-77.83873450399994, 8.18065013200004],
              [-77.83556067599994, 8.170111395000049],
              [-77.82925370999993, 8.162787177000041],
              [-77.81920325399994, 8.15766022300005],
              [-77.80842037699995, 8.163763739000046],
              [-77.79727128799993, 8.157700914000088],
              [-77.78856360599991, 8.14398834800005],
              [-77.78502356699994, 8.126898505000042],
              [-77.77814693899995, 8.115790106000077],
              [-77.76260331899994, 8.111883856000077],
              [-77.74640865799995, 8.116359768000052],
              [-77.73721269399994, 8.13031647300005],
              [-77.76512610599991, 8.130072333000044],
              [-77.80186926999994, 8.174383856000077],
              [-77.81920325399994, 8.171291408000059],
              [-77.87059485599991, 8.23578522300005],
              [-77.88068600199995, 8.243312893000052],
              [-77.89541581899994, 8.251532294000071],
              [-77.98428300699993, 8.267523505000042],
              [-78.0059301419999, 8.27602773600006],
              [-78.02318274599992, 8.29047272300005],
              [-78.03473873599995, 8.30963776200008],
              [-78.03892981699994, 8.33234284100007],
              [-78.06069902299993, 8.375921942000048],
              [-78.06704667899993, 8.402736721000053],
              [-78.05190995999993, 8.417669989000046],
              [-78.06273352799991, 8.424709377000056],
              [-78.07477779899995, 8.434515692000048],
              [-78.08592688699991, 8.44635651200008],
              [-78.09414628799993, 8.45929596600007],
              [-78.09854081899994, 8.475775458000044],
              [-78.09557044199994, 8.485174872000073],
              [-78.08999589799993, 8.491888739000046],
              [-78.08665930899991, 8.50023021000004],
              [-78.08812415299991, 8.51276276200008],
              [-78.09386145699995, 8.51593659100007],
              [-78.10289466099994, 8.518052476000037],
              [-78.11400305899991, 8.52757396000004],
              [-78.11888587099992, 8.538763739000046],
              [-78.11994381399995, 8.54828522300005],
              [-78.1231176419999, 8.556057033000059],
              [-78.13442949099993, 8.561712958000044],
              [-78.13036048099991, 8.552476304000038],
              [-78.12954667899993, 8.527289130000042],
              [-78.12450110599991, 8.517645575000074],
              [-78.11119544199994, 8.509019273000092],
              [-78.10619055899991, 8.50804271000004],
              [-78.10582434799994, 8.505031643000052],
              [-78.10651607999995, 8.47211334800005],
              [-78.1048070949999, 8.463364976000037],
              [-78.09093176999994, 8.430853583000044],
              [-78.08958899599992, 8.420396226000037],
              [-78.09414628799993, 8.41087474200009],
              [-78.10033118399991, 8.41087474200009],
              [-78.11925208199995, 8.442531643000052],
              [-78.13141842399995, 8.45807526200008],
              [-78.14126542899993, 8.466131903000075],
              [-78.15684973899994, 8.466213283000059],
              [-78.17015540299991, 8.45766836100006],
              [-78.17943274599992, 8.442084052000041],
              [-78.1829320949999, 8.421087958000044],
              [-78.18887285099993, 8.405747789000088],
              [-78.20376542899993, 8.393947658000059],
              [-78.22256425699993, 8.386297919000071],
              [-78.24058997299994, 8.38353099200009],
              [-78.24913489499994, 8.386908270000049],
              [-78.25283769399994, 8.394720770000049],
              [-78.25304114499994, 8.403794664000088],
              [-78.25112870999993, 8.41087474200009],
              [-78.24535071499992, 8.417669989000046],
              [-78.21642005099994, 8.43195221600007],
              [-78.21251380099994, 8.428656317000048],
              [-78.20982825399994, 8.426988023000092],
              [-78.20274817599994, 8.424505927000041],
              [-78.20152747299994, 8.45734284100007],
              [-78.20669511599993, 8.48773834800005],
              [-78.22325598899994, 8.541815497000073],
              [-78.23070227799991, 8.541815497000073],
              [-78.23770097599993, 8.527533270000049],
              [-78.23281816299993, 8.518377997000073],
              [-78.22329667899993, 8.510565497000073],
              [-78.21642005099994, 8.50023021000004],
              [-78.21784420499995, 8.482489325000074],
              [-78.22557532499991, 8.468247789000088],
              [-78.23045813699991, 8.456447658000059],
              [-78.22325598899994, 8.44562409100007],
              [-78.22325598899994, 8.438177802000041],
              [-78.22638912699995, 8.435980536000045],
              [-78.22984778599994, 8.434393622000073],
              [-78.23745683499993, 8.43195221600007],
              [-78.24185136599993, 8.440008856000077],
              [-78.24787350199995, 8.444525458000044],
              [-78.25357011599993, 8.447821356000077],
              [-78.25739498599995, 8.451849677000041],
              [-78.26065019399994, 8.460638739000046],
              [-78.25894120999993, 8.46165599200009],
              [-78.25495357999995, 8.461371161000045],
              [-78.25112870999993, 8.466131903000075],
              [-78.24038652299993, 8.485296942000048],
              [-78.24156653599994, 8.49477773600006],
              [-78.25739498599995, 8.50023021000004],
              [-78.25259355399993, 8.48773834800005],
              [-78.25475012899994, 8.48187897300005],
              [-78.26008053299995, 8.47842031500005],
              [-78.26480058499993, 8.47296784100007],
              [-78.27847245999993, 8.44562409100007],
              [-78.29454505099994, 8.44326406500005],
              [-78.30333411399994, 8.454291083000044],
              [-78.31261145699995, 8.48655833500004],
              [-78.32005774599992, 8.47915273600006],
              [-78.32103430899991, 8.46625397300005],
              [-78.33482825399994, 8.446193752000056],
              [-78.35301673099991, 8.428900458000044],
              [-78.3672582669999, 8.424505927000041],
              [-78.37645423099991, 8.44131094000005],
              [-78.38687089799993, 8.500474351000037],
              [-78.39452063699991, 8.520697333000044],
              [-78.39073645699995, 8.527492580000057],
              [-78.38833574099993, 8.534369208000044],
              [-78.39452063699991, 8.534369208000044],
              [-78.39452063699991, 8.52757396000004],
              [-78.40196692599994, 8.52757396000004],
              [-78.40196692599994, 8.548041083000044],
              [-78.40819251199991, 8.548041083000044],
              [-78.41201738199993, 8.523504950000074],
              [-78.39378821499992, 8.473863023000092],
              [-78.3841039699999, 8.425970770000049],
              [-78.36534583199995, 8.410630601000037],
              [-78.36099199099993, 8.394110419000071],
              [-78.38833574099993, 8.335760809000078],
              [-78.39232337099992, 8.34438711100006],
              [-78.39948482999995, 8.348822333000044],
              [-78.40782630099994, 8.351996161000045],
              [-78.4096980459999, 8.353013414000088],
              [-78.41563880099994, 8.356268622000073],
              [-78.43871008999992, 8.384426174000055],
              [-78.44977779899995, 8.391017971000053],
              [-78.44440670499995, 8.403225002000056],
              [-78.44517981699994, 8.421087958000044],
              [-78.44994055899991, 8.439154364000046],
              [-78.45665442599994, 8.451849677000041],
              [-78.46401933499993, 8.446234442000048],
              [-78.4680883449999, 8.440130927000041],
              [-78.46996008999992, 8.433010158000059],
              [-78.47085527299993, 8.424505927000041],
              [-78.47549394399994, 8.434027411000045],
              [-78.4863988919999, 8.447821356000077],
              [-78.49079342399995, 8.45929596600007],
              [-78.49136308499993, 8.47337474200009],
              [-78.48395748599995, 8.507066148000092],
              [-78.49079342399995, 8.52448151200008],
              [-78.52000891799992, 8.56346263200004],
              [-78.53172766799992, 8.575995184000078],
              [-78.51671301999994, 8.57526276200008],
              [-78.50576738199993, 8.571966864000046],
              [-78.49592037699995, 8.570746161000045],
              [-78.48395748599995, 8.575995184000078],
              [-78.50031490799995, 8.588690497000073],
              [-78.50584876199991, 8.59906647300005],
              [-78.50438391799992, 8.634019273000092],
              [-78.5664770169999, 8.651068427000041],
              [-78.56126868399991, 8.666449286000045],
              [-78.55899003799993, 8.67096588700008],
              [-78.56558183499993, 8.67177969000005],
              [-78.56899980399993, 8.67023346600007],
              [-78.57331295499995, 8.664740302000041],
              [-78.58153235599991, 8.670111395000049],
              [-78.58922278599994, 8.669582424000055],
              [-78.59654700399994, 8.666489976000037],
              [-78.60374915299991, 8.664740302000041],
              [-78.61253821499992, 8.669745184000078],
              [-78.61888587099992, 8.681463934000078],
              [-78.62791907499991, 8.70571523600006],
              [-78.61367753799993, 8.717230536000045],
              [-78.60838782499991, 8.73533763200004],
              [-78.60948645699995, 8.755926825000074],
              [-78.61424719999991, 8.774603583000044],
              [-78.62169348899994, 8.774603583000044],
              [-78.6231176419999, 8.758490302000041],
              [-78.61913001199991, 8.737860419000071],
              [-78.61974036399994, 8.723537502000056],
              [-78.63475501199991, 8.726223049000055],
              [-78.65151933499993, 8.707953192000048],
              [-78.68219967399995, 8.747748114000046],
              [-78.70986894399994, 8.747300523000092],
              [-78.72940019399994, 8.759344794000071],
              [-78.74937903599994, 8.80182526200008],
              [-78.76512610599991, 8.815578518000052],
              [-78.76512610599991, 8.822414455000057],
              [-78.75763912699995, 8.822414455000057],
              [-78.75763912699995, 8.829250393000052],
              [-78.77245032499991, 8.833563544000071],
              [-78.78180904899995, 8.84284088700008],
              [-78.78962154899995, 8.853908596000053],
              [-78.79987545499995, 8.863348700000074],
              [-78.79190019399994, 8.84666575700004],
              [-78.79015051999994, 8.833563544000071],
              [-78.79645748599995, 8.823472398000092],
              [-78.81285559799994, 8.815578518000052],
              [-78.82787024599992, 8.81313711100006],
              [-78.83800208199995, 8.816961981000077],
              [-78.85757402299993, 8.839789130000042],
              [-78.8645727199999, 8.855617580000057],
              [-78.86856035099993, 8.87490469000005],
              [-78.87389075399994, 8.891180731000077],
              [-79.00527910099993, 8.959540106000077],
              [-79.05760657499991, 8.97101471600007],
              [-79.08299719999991, 8.988836981000077],
              [-79.0872289699999, 8.994330145000049],
              [-79.08849036399994, 9.004095770000049],
              [-79.08568274599992, 9.00975169500009],
              [-79.08177649599992, 9.015326239000046],
              [-79.07982337099992, 9.024725653000075],
              [-79.07933508999992, 9.045396226000037],
              [-79.08088131399995, 9.06281159100007],
              [-79.08885657499991, 9.073797919000071],
              [-79.10773678299995, 9.07562897300005],
              [-79.10773678299995, 9.08307526200008],
              [-79.08629309799994, 9.08462148600006],
              [-79.06989498599995, 9.093329169000071],
              [-79.05858313699991, 9.107163804000038],
              [-79.05247962099992, 9.12400950700004],
              [-79.04625403599994, 9.12400950700004],
              [-79.03742428299995, 9.110500393000052],
              [-79.02769934799994, 9.111029364000046],
              [-79.01154537699995, 9.12400950700004],
              [-78.99120032499991, 9.13117096600007],
              [-78.98216712099992, 9.136419989000046],
              [-78.97736568899995, 9.14516836100006],
              [-78.98375403599994, 9.141994533000059],
              [-78.99718176999994, 9.14093659100007],
              [-79.00527910099993, 9.138332424000055],
              [-79.01195227799991, 9.13312409100007],
              [-79.0247289699999, 9.11937083500004],
              [-79.02892005099994, 9.116603908000059],
              [-79.03693600199995, 9.119614976000037],
              [-79.03954016799992, 9.125921942000048],
              [-79.04263261599993, 9.13108958500004],
              [-79.05247962099992, 9.13084544500009],
              [-79.0586645169999, 9.12563711100006],
              [-79.07087154899995, 9.107489325000074],
              [-79.07664954299992, 9.103583075000074],
              [-79.07900956899994, 9.10146719000005],
              [-79.08218339799993, 9.09674713700008],
              [-79.08779863199993, 9.09202708500004],
              [-79.09748287699995, 9.089911200000074],
              [-79.1067602199999, 9.089422919000071],
              [-79.11416581899994, 9.087551174000055],
              [-79.11904863199993, 9.083197333000044],
              [-79.12071692599994, 9.07562897300005],
              [-79.1145727199999, 9.068793036000045],
              [-79.10167395699995, 9.065008856000077],
              [-79.08999589799993, 9.056382554000038],
              [-79.0872289699999, 9.035305080000057],
              [-79.09178626199991, 9.023016669000071],
              [-79.10212154899995, 9.006008205000057],
              [-79.11607825399994, 8.99412669500009],
              [-79.13158118399991, 8.997463283000059],
              [-79.13809160099993, 9.000799872000073],
              [-79.16234290299991, 9.007391669000071],
              [-79.1634008449999, 9.011786200000074],
              [-79.16828365799995, 9.01984284100007],
              [-79.17349199099993, 9.02252838700008],
              [-79.17601477799991, 9.01072825700004],
              [-79.19298255099994, 9.005194403000075],
              [-79.27334550699993, 9.019273179000038],
              [-79.29946855399993, 9.014146226000037],
              [-79.30573482999995, 9.014146226000037],
              [-79.30573482999995, 9.020982164000088],
              [-79.33031165299991, 9.013413804000038],
              [-79.38683020699995, 9.018866278000075],
              [-79.40933183499993, 9.007391669000071],
              [-79.41820227799991, 9.014146226000037],
              [-79.42747962099992, 9.013373114000046],
              [-79.43712317599994, 9.009588934000078],
              [-79.45445716099994, 9.006293036000045],
              [-79.46690833199995, 9.001654364000046],
              [-79.47451738199993, 9.000555731000077],
              [-79.48200436099995, 8.99835846600007],
              [-79.48403886599993, 8.993719794000071],
              [-79.48468990799995, 8.98899974200009],
              [-79.48790442599994, 8.986883856000077],
              [-79.49107825399994, 8.98346588700008],
              [-79.51919511599993, 8.966376044000071],
              [-79.52122962099992, 8.957424221000053],
              [-79.52025305899991, 8.948879299000055],
              [-79.52220618399991, 8.942287502000056],
              [-79.53286699099993, 8.939113674000055],
              [-79.51553300699993, 8.909979559000078],
              [-79.51183020699995, 8.898138739000046],
              [-79.52497311099995, 8.90729401200008],
              [-79.54112708199995, 8.92328522300005],
              [-79.55467688699991, 8.942084052000041],
              [-79.56017005099994, 8.959540106000077],
              [-79.56639563699991, 8.959540106000077],
              [-79.56501217399995, 8.95376211100006],
              [-79.56322180899991, 8.950018622000073],
              [-79.56017005099994, 8.94529857000009],
              [-79.56017005099994, 8.939113674000055],
              [-79.56639563699991, 8.939113674000055],
              [-79.55919348899994, 8.91429271000004],
              [-79.56387285099993, 8.892767645000049],
              [-79.57848059799994, 8.88226959800005],
              [-79.60118567599994, 8.890692450000074],
              [-79.64683997299994, 8.882635809000078],
              [-79.66120357999995, 8.87523021000004],
              [-79.65575110599991, 8.863348700000074],
              [-79.65575110599991, 8.857123114000046],
              [-79.66685950399994, 8.860825914000088],
              [-79.67398027299993, 8.86554596600007],
              [-79.68065344999991, 8.867621161000045],
              [-79.69054114499994, 8.863348700000074],
              [-79.69347083199995, 8.86664459800005],
              [-79.6946508449999, 8.868312893000052],
              [-79.69701087099992, 8.869208075000074],
              [-79.70360266799992, 8.87018463700008],
              [-79.70360266799992, 8.863348700000074],
              [-79.70079505099994, 8.859930731000077],
              [-79.69920813699991, 8.854803778000075],
              [-79.69676673099991, 8.849676825000074],
              [-79.71393795499995, 8.85260651200008],
              [-79.73021399599992, 8.844305731000077],
              [-79.74356035099993, 8.83006419500009],
              [-79.7520238919999, 8.815578518000052],
              [-79.75625566299993, 8.796291408000059],
              [-79.7520238919999, 8.736761786000045],
              [-79.74986731699994, 8.731024481000077],
              [-79.74518795499995, 8.728013414000088],
              [-79.74046790299991, 8.725978908000059],
              [-79.7383520169999, 8.722805080000057],
              [-79.73932857999995, 8.716498114000046],
              [-79.74136308499993, 8.711127020000049],
              [-79.74453691299993, 8.70571523600006],
              [-79.74681555899991, 8.697943427000041],
              [-79.75080318899995, 8.689601955000057],
              [-79.75601152299993, 8.681586005000042],
              [-79.76195227799991, 8.674709377000056],
              [-79.76593990799995, 8.671820380000042],
              [-79.77839107999995, 8.665838934000078],
              [-79.79100501199991, 8.663234768000052],
              [-79.79173743399991, 8.659491278000075],
              [-79.79051673099991, 8.65501536700009],
              [-79.79295813699991, 8.651068427000041],
              [-79.81001863299991, 8.646601108000084],
              [-79.82631067499995, 8.63852006600007],
              [-79.81369061599992, 8.626059908000059],
              [-79.77960804599991, 8.61840994000005],
              [-79.74735102599993, 8.631258633000073],
              [-79.71730499299991, 8.64631035800005],
              [-79.70580393799992, 8.652550776000055],
              [-79.70209358999995, 8.657320823000077],
              [-79.69726913999995, 8.657323396000038],
              [-79.69689726799993, 8.648887585000068],
              [-79.70060713899994, 8.641550643000073],
              [-79.7343651249999, 8.615498574000071],
              [-79.77439595699991, 8.579550130000086],
              [-79.7936731719999, 8.572207498000068],
              [-79.82629835499995, 8.561552820000088],
              [-79.86411799399991, 8.55235759900006],
              [-79.87152542599995, 8.542819456000075],
              [-79.86978105399993, 8.531805731000077],
              [-79.87173417899993, 8.52415599200009],
              [-79.87486731699994, 8.520697333000044],
              [-79.87999426999994, 8.51862213700008],
              [-79.89122473899994, 8.516302802000041],
              [-79.89537512899994, 8.514553127000056],
              [-79.91055253799993, 8.500474351000037],
              [-79.91763261599993, 8.495428778000075],
              [-79.92674719999991, 8.493394273000092],
              [-79.93211829299992, 8.489162502000056],
              [-79.94180253799993, 8.470404364000046],
              [-79.94688880099994, 8.466131903000075],
              [-79.94896399599992, 8.462307033000059],
              [-79.97020423099991, 8.44407786700009],
              [-80.0408015619999, 8.39797597900008],
              [-80.0808813139999, 8.371771552000041],
              [-80.12584387899994, 8.34861888200004],
              [-80.19554602799991, 8.312933661000045],
              [-80.22496497299994, 8.301052151000079],
              [-80.2727351549999, 8.29482656500005],
              [-80.28160559799994, 8.295925197000088],
              [-80.2944636709999, 8.300441799000055],
              [-80.30003821499992, 8.301052151000079],
              [-80.30882727799991, 8.298651434000078],
              [-80.32628333199995, 8.290309963000084],
              [-80.33421790299991, 8.287990627000056],
              [-80.36148027299993, 8.29482656500005],
              [-80.37466386599993, 8.30337148600006],
              [-80.38072669199994, 8.310370184000078],
              [-80.3757624989999, 8.315252997000073],
              [-80.3857722649999, 8.311346747000073],
              [-80.3862605459999, 8.30695221600007],
              [-80.38475501199991, 8.301581122000073],
              [-80.38878333199995, 8.29482656500005],
              [-80.4070124989999, 8.283026434000078],
              [-80.4702449209999, 8.220648505000042],
              [-80.47817949099993, 8.202337958000044],
              [-80.47484290299991, 8.106472072000088],
              [-80.4761042959999, 8.094875393000052],
              [-80.47846432199992, 8.091376044000071],
              [-80.4844050769999, 8.082546291000085],
              [-80.46816972599993, 8.07485586100006],
              [-80.46092688699991, 8.05573151200008],
              [-80.4560847649999, 8.03620026200008],
              [-80.44717363199993, 8.027289130000042],
              [-80.4324031239999, 8.024237372000073],
              [-80.39427649599992, 8.007635809000078],
              [-80.3825984369999, 7.999335028000075],
              [-80.34886633999992, 7.989284572000088],
              [-80.32774817599994, 7.953314520000049],
              [-80.31334387899994, 7.911444403000075],
              [-80.30003821499992, 7.883327541000085],
              [-80.20445716099994, 7.807562567000048],
              [-80.14378821499992, 7.752752997000073],
              [-80.05239824099993, 7.637111721000053],
              [-80.00576738199993, 7.55227285400008],
              [-79.99351966099994, 7.522772528000075],
              [-79.99465898299991, 7.50344472900008],
              [-80.0100398429999, 7.465236721000053],
              [-80.0178523429999, 7.456813869000086],
              [-80.0300593739999, 7.453924872000073],
              [-80.05679277299993, 7.452541408000059],
              [-80.06497148299991, 7.450995184000078],
              [-80.1355281239999, 7.424627997000073],
              [-80.1985164049999, 7.424709377000056],
              [-80.21068274599992, 7.417792059000078],
              [-80.22280839799993, 7.42336660400008],
              [-80.24966386599993, 7.429632880000042],
              [-80.2590632799999, 7.438259182000081],
              [-80.2658992179999, 7.438259182000081],
              [-80.27481035099993, 7.433864651000079],
              [-80.30687415299991, 7.424627997000073],
              [-80.30687415299991, 7.417792059000078],
              [-80.2939753899999, 7.419256903000075],
              [-80.28355872299994, 7.421820380000042],
              [-80.27452551999994, 7.425685940000051],
              [-80.2658992179999, 7.430812893000052],
              [-80.2590632799999, 7.424627997000073],
              [-80.33096269399994, 7.401190497000073],
              [-80.35757402299993, 7.382025458000044],
              [-80.36148027299993, 7.355739651000079],
              [-80.34439042899993, 7.327419338000084],
              [-80.34756425699993, 7.318264065000051],
              [-80.3723445299999, 7.31476471600007],
              [-80.37926184799994, 7.312770901000079],
              [-80.38711503799993, 7.30805084800005],
              [-80.3935847649999, 7.302394924000055],
              [-80.3962703119999, 7.297674872000073],
              [-80.39883378799993, 7.28664785400008],
              [-80.40538489499994, 7.282782294000071],
              [-80.41441809799994, 7.280340887000079],
              [-80.42418372299994, 7.27374909100007],
              [-80.4284968739999, 7.265448309000078],
              [-80.42813066299993, 7.258490302000041],
              [-80.42910722599993, 7.252346096000053],
              [-80.43724524599992, 7.246486721000053],
              [-80.44481360599991, 7.245876369000086],
              [-80.46373450399994, 7.251654364000046],
              [-80.47447669199994, 7.253322658000059],
              [-80.59683183499993, 7.238063869000086],
              [-80.60407467399995, 7.236721096000053],
              [-80.71312415299991, 7.216457424000055],
              [-80.79336503799993, 7.213568427000041],
              [-80.8139949209999, 7.219142971000053],
              [-80.82079016799992, 7.219142971000053],
              [-80.8259578119999, 7.213324286000045],
              [-80.8310847649999, 7.211371161000045],
              [-80.8362117179999, 7.213324286000045],
              [-80.84129798099991, 7.219142971000053],
              [-80.84813391799992, 7.219142971000053],
              [-80.86180579299992, 7.20571523600006],
              [-80.8730769519999, 7.212551174000055],
              [-80.88906816299993, 7.239040432000081],
              [-80.89443925699993, 7.243434963000084],
              [-80.90176347599993, 7.248114325000074],
              [-80.91055253799993, 7.251776434000078],
              [-80.92007402299993, 7.253322658000059],
              [-80.9297175769999, 7.25649648600006],
              [-80.93016516799992, 7.263576565000051],
              [-80.9255671869999, 7.270575262000079],
              [-80.92007402299993, 7.27374909100007],
              [-80.91600501199991, 7.278143622000073],
              [-80.91714433499993, 7.299627997000073],
              [-80.91637122299994, 7.307928778000075],
              [-80.9111628899999, 7.315008856000077],
              [-80.8999324209999, 7.323513088000084],
              [-80.89598548099991, 7.328395901000079],
              [-80.8923640619999, 7.341742255000042],
              [-80.89159094999991, 7.360174872000073],
              [-80.89565995999993, 7.376613674000055],
              [-80.9211726549999, 7.39203522300005],
              [-80.92080644399994, 7.41079336100006],
              [-80.9101863269999, 7.441677151000079],
              [-80.9150691399999, 7.454657294000071],
              [-80.95116126199991, 7.493475653000075],
              [-80.9546199209999, 7.495510158000059],
              [-80.9621882799999, 7.502468166000085],
              [-80.96690833199995, 7.509914455000057],
              [-80.95470130099994, 7.516913153000075],
              [-80.95274817599994, 7.525458075000074],
              [-80.95164954299992, 7.535589911000045],
              [-80.94774329299992, 7.544094143000052],
              [-80.9463191399999, 7.555690822000088],
              [-80.95571855399993, 7.569647528000075],
              [-80.96898352799991, 7.582058010000083],
              [-80.97911536399994, 7.589056708000044],
              [-80.97911536399994, 7.595892645000049],
              [-80.97166907499991, 7.595892645000049],
              [-80.97166907499991, 7.602728583000044],
              [-81.02004960799991, 7.650539455000057],
              [-81.02993730399993, 7.656073309000078],
              [-81.03750566299993, 7.658270575000074],
              [-81.0412898429999, 7.661688544000071],
              [-81.03990637899994, 7.671047268000052],
              [-81.0351863269999, 7.679958401000079],
              [-81.02782141799992, 7.68618398600006],
              [-81.0178523429999, 7.688421942000048],
              [-81.00576738199993, 7.685329494000086],
              [-81.01060950399994, 7.693915106000077],
              [-81.02183997299994, 7.70266347900008],
              [-81.0344539049999, 7.70929596600007],
              [-81.04332434799994, 7.711981512000079],
              [-81.04482988199993, 7.716701565000051],
              [-81.02623450399994, 7.74673086100006],
              [-81.0371394519999, 7.745998440000051],
              [-81.04686438699991, 7.747219143000052],
              [-81.05483964799993, 7.750026760000083],
              [-81.06102454299992, 7.754177151000079],
              [-81.05760657499991, 7.754950262000079],
              [-81.05479895699995, 7.754828192000048],
              [-81.05325273299991, 7.755926825000074],
              [-81.05357825399994, 7.76040273600006],
              [-81.07669023299991, 7.764797268000052],
              [-81.08608964799993, 7.779120184000078],
              [-81.08543860599991, 7.794338283000059],
              [-81.07811438699991, 7.801336981000077],
              [-81.07249915299991, 7.803534247000073],
              [-81.06749426999994, 7.808172919000071],
              [-81.0608210929999, 7.812892971000053],
              [-81.05016028599994, 7.815008856000077],
              [-81.03762773299991, 7.815008856000077],
              [-81.02757727799991, 7.816799221000053],
              [-81.0212703119999, 7.822699286000045],
              [-81.02004960799991, 7.835516669000071],
              [-81.02623450399994, 7.835516669000071],
              [-81.0488582019999, 7.822699286000045],
              [-81.05589758999992, 7.849391994000086],
              [-81.05357825399994, 7.911200262000079],
              [-81.0752253899999, 7.871283270000049],
              [-81.09044348899994, 7.857855536000045],
              [-81.10195878799993, 7.877101955000057],
              [-81.1081843739999, 7.877101955000057],
              [-81.10594641799992, 7.866400458000044],
              [-81.10216223899994, 7.858587958000044],
              [-81.09630286399994, 7.85305410400008],
              [-81.0876765619999, 7.849188544000071],
              [-81.0876765619999, 7.842311916000085],
              [-81.13304602799991, 7.842311916000085],
              [-81.1423640619999, 7.844427802000041],
              [-81.15481523299991, 7.85382721600007],
              [-81.16714433499993, 7.855983791000085],
              [-81.1924128899999, 7.863348700000074],
              [-81.19737708199995, 7.879055080000057],
              [-81.19994055899991, 7.893622137000079],
              [-81.2180476549999, 7.897528387000079],
              [-81.20815995999993, 7.893459377000056],
              [-81.20523027299993, 7.889919338000084],
              [-81.2043757799999, 7.883327541000085],
              [-81.21764075399994, 7.878973700000074],
              [-81.21519934799994, 7.870998440000051],
              [-81.1975398429999, 7.855983791000085],
              [-81.18020585799991, 7.846869208000044],
              [-81.17711341099994, 7.845729885000083],
              [-81.17870032499991, 7.836859442000048],
              [-81.18163001199991, 7.829657294000071],
              [-81.18325761599993, 7.82367584800005],
              [-81.16470292899993, 7.789007880000042],
              [-81.17442786399994, 7.763006903000075],
              [-81.19668535099993, 7.74172597900008],
              [-81.2180476549999, 7.726263739000046],
              [-81.22240149599992, 7.734401760000083],
              [-81.22317460799991, 7.739203192000048],
              [-81.2214656239999, 7.742702541000085],
              [-81.2180476549999, 7.74673086100006],
              [-81.2180476549999, 7.754177151000079],
              [-81.23204505099994, 7.755031643000052],
              [-81.24596106699994, 7.754177151000079],
              [-81.24596106699994, 7.74673086100006],
              [-81.2353816399999, 7.743841864000046],
              [-81.22948157499991, 7.73781972900008],
              [-81.2180476549999, 7.719427802000041],
              [-81.23155676999994, 7.71438222900008],
              [-81.23741614499994, 7.715114651000079],
              [-81.24596106699994, 7.719427802000041],
              [-81.23867753799993, 7.707464911000045],
              [-81.23167883999992, 7.698919989000046],
              [-81.22549394399994, 7.698919989000046],
              [-81.21214758999992, 7.706122137000079],
              [-81.1975398429999, 7.711981512000079],
              [-81.19326738199993, 7.700751044000071],
              [-81.1975398429999, 7.657375393000052],
              [-81.19546464799993, 7.645697333000044],
              [-81.19517981699994, 7.638861395000049],
              [-81.1975398429999, 7.630072333000044],
              [-81.20132402299993, 7.625189520000049],
              [-81.21340898299991, 7.615423895000049],
              [-81.2180476549999, 7.608954169000071],
              [-81.22549394399994, 7.608954169000071],
              [-81.23403886599993, 7.615261135000083],
              [-81.26622473899994, 7.632391669000071],
              [-81.27330481699994, 7.633490302000041],
              [-81.27871660099993, 7.646063544000071],
              [-81.29116777299993, 7.650661526000079],
              [-81.3142390619999, 7.650539455000057],
              [-81.39696204299992, 7.673529364000046],
              [-81.4241023429999, 7.671047268000052],
              [-81.42821204299992, 7.682562567000048],
              [-81.43492591099994, 7.692653713000084],
              [-81.4429011709999, 7.700466213000084],
              [-81.45079505099994, 7.705145575000074],
              [-81.4739070299999, 7.699408270000049],
              [-81.5034480459999, 7.701971747000073],
              [-81.52578691299993, 7.711452541000085],
              [-81.5271296869999, 7.726263739000046],
              [-81.51866614499994, 7.728908596000053],
              [-81.49998938699991, 7.738674221000053],
              [-81.48875891799992, 7.749212958000044],
              [-81.52806555899991, 7.760565497000073],
              [-81.53905188699991, 7.75735097900008],
              [-81.54019120999993, 7.739935614000046],
              [-81.56322180899991, 7.756293036000045],
              [-81.57494055899991, 7.76040273600006],
              [-81.57494055899991, 7.767238674000055],
              [-81.5683894519999, 7.77602773600006],
              [-81.57388261599993, 7.784328518000052],
              [-81.58311926999994, 7.793402411000045],
              [-81.58800208199995, 7.804470119000086],
              [-81.58629309799994, 7.820868231000077],
              [-81.58177649599992, 7.83156972900008],
              [-81.56749426999994, 7.849188544000071],
              [-81.56749426999994, 7.855983791000085],
              [-81.57461503799993, 7.860663153000075],
              [-81.58189856699994, 7.862494208000044],
              [-81.58897864499994, 7.861110744000086],
              [-81.59544837099992, 7.855983791000085],
              [-81.6015925769999, 7.855983791000085],
              [-81.60912024599992, 7.86281972900008],
              [-81.60912024599992, 7.870266018000052],
              [-81.59976152299993, 7.877834377000056],
              [-81.5998835929999, 7.885036526000079],
              [-81.60802161399994, 7.889837958000044],
              [-81.62271074099993, 7.89008209800005],
              [-81.61961829299992, 7.905340887000079],
              [-81.6186824209999, 7.922023830000057],
              [-81.61294511599993, 7.931423244000086],
              [-81.59544837099992, 7.924872137000079],
              [-81.59801184799994, 7.933783270000049],
              [-81.60208085799991, 7.940008856000077],
              [-81.61587480399993, 7.952175197000088],
              [-81.61123613199993, 7.95962148600006],
              [-81.61294511599993, 7.974188544000071],
              [-81.60912024599992, 7.986354885000083],
              [-81.62132727799991, 7.981350002000056],
              [-81.62710527299993, 7.982814846000053],
              [-81.62889563699991, 7.981838283000059],
              [-81.6289363269999, 7.969265041000085],
              [-81.62413489499994, 7.95538971600007],
              [-81.6225886709999, 7.947943427000041],
              [-81.62588456899994, 7.944728908000059],
              [-81.63329016799992, 7.945868231000077],
              [-81.6384578119999, 7.949245510000083],
              [-81.64159094999991, 7.954657294000071],
              [-81.6426082019999, 7.962103583000044],
              [-81.64590410099993, 7.973089911000045],
              [-81.66356360599991, 7.997300523000092],
              [-81.67052161399994, 8.006781317000048],
              [-81.68480383999992, 8.044623114000046],
              [-81.69102942599994, 8.054632880000042],
              [-81.69713294199994, 8.039129950000074],
              [-81.69835364499994, 8.031032619000086],
              [-81.69786536399994, 8.021063544000071],
              [-81.70836341099994, 8.031317450000074],
              [-81.7085261709999, 8.045843817000048],
              [-81.71035722599993, 8.059841213000084],
              [-81.72573808499993, 8.06826406500005],
              [-81.72573808499993, 8.07571035400008],
              [-81.71727454299992, 8.070827541000085],
              [-81.70946204299992, 8.068630276000079],
              [-81.70287024599992, 8.069973049000055],
              [-81.69786536399994, 8.07571035400008],
              [-81.69102942599994, 8.07571035400008],
              [-81.68761145699995, 8.072780666000085],
              [-81.68541419199994, 8.071600653000075],
              [-81.67735755099994, 8.06826406500005],
              [-81.71145585799991, 8.13031647300005],
              [-81.73355058499993, 8.15766022300005],
              [-81.7434382799999, 8.173163153000075],
              [-81.74624589799993, 8.191799221000053],
              [-81.75247148299991, 8.191799221000053],
              [-81.75820878799993, 8.180609442000048],
              [-81.76065019399994, 8.169582424000055],
              [-81.75747636599993, 8.161159572000088],
              [-81.74624589799993, 8.15766022300005],
              [-81.75243079299992, 8.148993231000077],
              [-81.76748613199993, 8.132757880000042],
              [-81.7741999989999, 8.123480536000045],
              [-81.78038489499994, 8.123480536000045],
              [-81.79832923099991, 8.137111721000053],
              [-81.87657630099994, 8.16787344000005],
              [-81.88536536399994, 8.17328522300005],
              [-81.9270320299999, 8.183172919000071],
              [-81.94115149599992, 8.184963283000059],
              [-81.95181230399993, 8.191433010000083],
              [-81.94786536399994, 8.206244208000044],
              [-81.9311824209999, 8.233343817000048],
              [-81.94326738199993, 8.229641018000052],
              [-81.95669511599993, 8.22101471600007],
              [-81.96764075399994, 8.209051825000074],
              [-81.9721980459999, 8.195502020000049],
              [-81.97838294199994, 8.192531643000052],
              [-81.99217688699991, 8.201117255000042],
              [-82.01317298099991, 8.21906159100007],
              [-82.02786210799991, 8.208278713000084],
              [-82.06029212099992, 8.210272528000075],
              [-82.09312903599994, 8.220363674000055],
              [-82.10936438699991, 8.233343817000048],
              [-82.11558997299994, 8.233343817000048],
              [-82.11729895699995, 8.21515534100007],
              [-82.14240475199995, 8.16006094000005],
              [-82.1445613269999, 8.161891994000086],
              [-82.14891516799992, 8.164089260000083],
              [-82.15029863199993, 8.164496161000045],
              [-82.15029863199993, 8.15766022300005],
              [-82.1565242179999, 8.15766022300005],
              [-82.14720618399991, 8.180934963000084],
              [-82.14757239499994, 8.188299872000073],
              [-82.1565242179999, 8.184963283000059],
              [-82.15538489499994, 8.193182684000078],
              [-82.15379798099991, 8.199286200000074],
              [-82.15038001199991, 8.203314520000049],
              [-82.14346269399994, 8.20538971600007],
              [-82.14346269399994, 8.212917385000083],
              [-82.15689042899993, 8.211737372000073],
              [-82.1741023429999, 8.201727606000077],
              [-82.18789628799993, 8.199245510000083],
              [-82.19652258999992, 8.202175197000088],
              [-82.2092585929999, 8.215521552000041],
              [-82.21922766799992, 8.21906159100007],
              [-82.21922766799992, 8.225897528000075],
              [-82.21410071499992, 8.227443752000056],
              [-82.20958411399994, 8.231146552000041],
              [-82.20494544199994, 8.233343817000048],
              [-82.21654212099992, 8.264227606000077],
              [-82.2175593739999, 8.278225002000056],
              [-82.21178137899994, 8.287990627000056],
              [-82.21178137899994, 8.29482656500005],
              [-82.21764075399994, 8.299343166000085],
              [-82.2187800769999, 8.304348049000055],
              [-82.21642005099994, 8.309759833000044],
              [-82.21178137899994, 8.315252997000073],
              [-82.21060136599993, 8.312648830000057],
              [-82.21084550699993, 8.309881903000075],
              [-82.20982825399994, 8.30805084800005],
              [-82.20494544199994, 8.30849844000005],
              [-82.20982825399994, 8.321844794000071],
              [-82.20864824099993, 8.332098700000074],
              [-82.20055091099994, 8.33930084800005],
              [-82.18443762899994, 8.34320709800005],
              [-82.20787512899994, 8.343939520000049],
              [-82.22012285099993, 8.342962958000044],
              [-82.22545325399994, 8.339504299000055],
              [-82.24144446499992, 8.306708075000074],
              [-82.2424617179999, 8.301052151000079],
              [-82.26195227799991, 8.302801825000074],
              [-82.27708899599992, 8.309271552000041],
              [-82.28441321499992, 8.322211005000042],
              [-82.2800593739999, 8.34320709800005],
              [-82.29649817599994, 8.336208401000079],
              [-82.31395423099991, 8.330837307000081],
              [-82.33165442599994, 8.329779364000046],
              [-82.3489070299999, 8.335760809000078],
              [-82.34707597599993, 8.32916901200008],
              [-82.34496008999992, 8.315008856000077],
              [-82.34276282499991, 8.30849844000005],
              [-82.3586726549999, 8.30609772300005],
              [-82.38719641799992, 8.291449286000045],
              [-82.40013587099992, 8.287990627000056],
              [-82.41893469999991, 8.293036200000074],
              [-82.43325761599993, 8.304348049000055],
              [-82.4353328119999, 8.316107489000046],
              [-82.41722571499992, 8.322780666000085],
              [-82.41722571499992, 8.328924872000073],
              [-82.42568925699993, 8.332302151000079],
              [-82.43028723899994, 8.338161526000079],
              [-82.43175208199995, 8.346218166000085],
              [-82.43089758999992, 8.356268622000073],
              [-82.44102942599994, 8.34870026200008],
              [-82.44261633999992, 8.336330471000053],
              [-82.44701087099992, 8.323553778000075],
              [-82.4656062489999, 8.315252997000073],
              [-82.4656062489999, 8.30849844000005],
              [-82.46141516799992, 8.302923895000049],
              [-82.45742753799993, 8.296047268000052],
              [-82.4541316399999, 8.28851959800005],
              [-82.45201575399994, 8.28115469000005],
              [-82.47085527299993, 8.277126369000086],
              [-82.47777258999992, 8.277411200000074],
              [-82.4861140619999, 8.28115469000005],
              [-82.51170813699991, 8.27643463700008],
              [-82.55264238199993, 8.287380276000079],
              [-82.62267005099994, 8.315252997000073],
              [-82.65892493399991, 8.322780666000085],
              [-82.69859778599994, 8.322821356000077],
              [-82.73802649599992, 8.31745026200008],
              [-82.80870520699995, 8.295681057000081],
              [-82.83901933499993, 8.278509833000044],
              [-82.86245683499993, 8.254055080000057],
              [-82.87718665299991, 8.21906159100007],
              [-82.87987219999991, 8.177883205000057],
              [-82.8728328119999, 8.135891018000052],
              [-82.84923255099994, 8.06826406500005],
              [-82.84923255099994, 8.06203847900008],
              [-82.8620906239999, 8.048895575000074],
              [-82.8681941399999, 8.032375393000052],
              [-82.87694251199991, 8.023871161000045],
              [-82.8976292589999, 8.034748020000023],
              [-82.89136979199989, 8.057545471000068],
              [-82.88640885499993, 8.102193909000093],
              [-82.93909297799985, 8.216838074000052],
              [-82.94366634199989, 8.248567403000067],
              [-82.95051346899993, 8.258825175000055],
              [-82.96800594099989, 8.267971904000134],
              [-82.97712683099988, 8.269237976000085],
              [-82.98919327799987, 8.264457907000093],
              [-82.99552364099989, 8.264819641000088],
              [-83.00110469599989, 8.269237976000085],
              [-83.01076818899992, 8.283371480000127],
              [-83.01606502399994, 8.289004211000062],
              [-83.04407364999986, 8.305359803000101],
              [-83.05324621699995, 8.315100810000047],
              [-83.05210933499987, 8.327632345000055],
              [-83.04329850299987, 8.334737854000082],
              [-82.9977715659999, 8.360162659000096],
              [-82.95351070199987, 8.402098084000087],
              [-82.92477860499986, 8.41674835200007],
              [-82.89651159699989, 8.425352478000107],
              [-82.87041499899988, 8.438116557000072],
              [-82.84829748599986, 8.46516916900012],
              [-82.83891821399993, 8.494624736000034],
              [-82.83597265699993, 8.52976471000008],
              [-82.84186376999992, 8.599476217000117],
              [-82.84979610299987, 8.629861959000067],
              [-82.86222428499985, 8.655700176000096],
              [-82.87894160999991, 8.679057923000045],
              [-82.91033504299992, 8.713913676000104],
              [-82.91922338899994, 8.72706532800008],
              [-82.9241584889999, 8.741198832000123],
              [-82.92296992999988, 8.756159160000081],
              [-82.91488256899996, 8.764789124000032],
              [-82.88511694399998, 8.78318593400013],
              [-82.87578934799984, 8.793908793000043],
              [-82.87563431899991, 8.807525533000046],
              [-82.88356665099985, 8.81238311800007],
              [-82.88832088299995, 8.816930644000095],
              [-82.8785798749999, 8.82977223800009],
              [-82.86692683999993, 8.838066304000051],
              [-82.76378067999991, 8.879950053000115],
              [-82.73386002599997, 8.897985128000116],
              [-82.72015670999991, 8.920237750000112],
              [-82.71936478699985, 8.921523743000108],
              [-82.72334387199993, 8.930928854000072],
              [-82.74913041199991, 8.974078674000097],
              [-82.76269547599992, 8.98299285900012],
              [-82.80817073599988, 8.9983665970001],
              [-82.85408524699994, 9.031982117000041],
              [-82.87656449499985, 9.041929830000129],
              [-82.88242976999993, 9.04534047500006],
              [-82.88687394299987, 9.05148997000012],
              [-82.88969030799993, 9.059370626000074],
              [-82.89328181999988, 9.066941224000033],
              [-82.90023229999989, 9.072057190000109],
              [-82.90945654399988, 9.072005514000097],
              [-82.93937719799993, 9.059577332000032],
              [-82.93952108499991, 9.070641889000072],
              [-82.94165096099994, 9.234424540000134],
              [-82.94320125399986, 9.354313863000101],
              [-82.94428645899987, 9.437151185000118],
              [-82.94170263699993, 9.45634897900004],
              [-82.93330521699997, 9.470327454000127],
              [-82.9146241869999, 9.476864522000099],
              [-82.86129410899991, 9.484099223000072],
              [-82.84638545799996, 9.492548320000068],
              [-82.84478348899992, 9.500687358000079],
              [-82.84938269099987, 9.503477885000038],
              [-82.85591975899985, 9.505441590000075],
              [-82.86020890299991, 9.511203512000037],
              [-82.86713354499989, 9.538643697000097],
              [-82.8792516689999, 9.55990854900007],
              [-82.87739131699988, 9.569184469000092],
              [-82.8660483409999, 9.5850749720001],
              [-82.84747066299985, 9.600655416000052],
              [-82.82902217599994, 9.6027224730001],
              [-82.77109289599989, 9.579855652000091],
              [-82.72936417699995, 9.54489654600009],
              [-82.71972652199995, 9.541330872000032],
              [-82.71169083699996, 9.544999899000118],
              [-82.70145890399988, 9.53355356900002],
              [-82.68866898699991, 9.509446513000057],
              [-82.67804947999991, 9.497767639000088],
              [-82.66820511899994, 9.493168437000037],
              [-82.65071264699989, 9.487845764000085],
              [-82.63213496999992, 9.484667663000039],
              [-82.61885412599992, 9.486708883000077],
              [-82.61239457299988, 9.499498800000055],
              [-82.60820878199993, 9.537868551000088],
              [-82.6011032719999, 9.548668925000115],
              [-82.58588456299987, 9.546240133000055],
              [-82.57061417699992, 9.538230285000083],
              [-82.56283687399991, 9.53869537300011],
              [-82.57359778599994, 9.576198635000083],
            ],
          ],
          [
            [
              [-81.80772864499994, 7.28742096600007],
              [-81.79800370999993, 7.291083075000074],
              [-81.78990637899994, 7.290106512000079],
              [-81.78050696499992, 7.28782786700009],
              [-81.76671301999994, 7.28742096600007],
              [-81.77904212099992, 7.277492580000057],
              [-81.79238847599993, 7.251654364000046],
              [-81.80089270699995, 7.23899974200009],
              [-81.79698645699995, 7.233954169000071],
              [-81.79344641799992, 7.225978908000059],
              [-81.80089270699995, 7.225978908000059],
              [-81.81623287699995, 7.271307684000078],
              [-81.81456458199995, 7.279974677000041],
              [-81.81875566299993, 7.285630601000094],
              [-81.8191625639999, 7.288723049000055],
              [-81.81456458199995, 7.294256903000075],
              [-81.81078040299991, 7.294134833000044],
              [-81.80825761599993, 7.293443101000094],
              [-81.80719967399995, 7.291571356000077],
              [-81.80772864499994, 7.28742096600007],
            ],
          ],
          [
            [
              [-81.14915930899991, 7.56118398600006],
              [-81.1355688139999, 7.568182684000078],
              [-81.11807206899994, 7.57453034100007],
              [-81.08771725199995, 7.581610419000071],
              [-81.0750219389999, 7.577337958000044],
              [-81.06159420499995, 7.575588283000059],
              [-81.03307044199994, 7.575425523000092],
              [-81.0449926419999, 7.55414459800005],
              [-81.05284583199995, 7.544623114000046],
              [-81.06411699099993, 7.540676174000055],
              [-81.0750219389999, 7.535345770000049],
              [-81.08275305899991, 7.53384023600006],
              [-81.09142005099994, 7.537543036000045],
              [-81.09776770699995, 7.542547919000071],
              [-81.10334225199995, 7.54555898600006],
              [-81.10985266799992, 7.547064520000049],
              [-81.11904863199993, 7.54751211100006],
              [-81.12926184799994, 7.545314846000053],
              [-81.13438880099994, 7.539943752000056],
              [-81.13784745999993, 7.533392645000049],
              [-81.14297441299993, 7.52765534100007],
              [-81.17088782499991, 7.513373114000046],
              [-81.18492591099994, 7.496975002000056],
              [-81.1907445949999, 7.493475653000075],
              [-81.19912675699993, 7.493475653000075],
              [-81.20856686099995, 7.495591539000088],
              [-81.21580969999991, 7.498277085000041],
              [-81.2180883449999, 7.499701239000046],
              [-81.24567623599995, 7.490057684000078],
              [-81.25194251199991, 7.490423895000049],
              [-81.24258378799993, 7.503404039000088],
              [-81.23289954299992, 7.513373114000046],
              [-81.2227270169999, 7.521063544000071],
              [-81.21043860599991, 7.525946356000077],
              [-81.17438717399995, 7.531439520000049],
              [-81.16405188699991, 7.540513414000088],
              [-81.15762285099993, 7.551581122000073],
              [-81.14915930899991, 7.56118398600006],
            ],
          ],
          [
            [
              [-81.66437740799995, 7.397284247000073],
              [-81.65249589799993, 7.391017971000053],
              [-81.62205969999991, 7.393866278000075],
              [-81.61587480399993, 7.386704820000091],
              [-81.58800208199995, 7.335191148000092],
              [-81.60667883999992, 7.32758209800005],
              [-81.62816321499992, 7.321600653000075],
              [-81.64940344999991, 7.321519273000092],
              [-81.68423417899993, 7.341376044000071],
              [-81.72712154899995, 7.344427802000041],
              [-81.74624589799993, 7.348863023000092],
              [-81.75670325399994, 7.35773346600007],
              [-81.78075110599991, 7.38422272300005],
              [-81.80003821499992, 7.395575262000079],
              [-81.8418676419999, 7.430812893000052],
              [-81.86465410099993, 7.478461005000042],
              [-81.87287350199995, 7.486029364000046],
              [-81.87511145699995, 7.490423895000049],
              [-81.88280188699991, 7.516791083000044],
              [-81.87889563699991, 7.517482815000051],
              [-81.85806230399993, 7.517523505000042],
              [-81.84870357999995, 7.520209052000041],
              [-81.8489477199999, 7.524115302000041],
              [-81.83625240799995, 7.546698309000078],
              [-81.83438066299993, 7.54751211100006],
              [-81.83177649599992, 7.559271552000041],
              [-81.83141028599994, 7.568182684000078],
              [-81.82998613199993, 7.576157945000091],
              [-81.82445227799991, 7.585353908000059],
              [-81.81680253799993, 7.590399481000077],
              [-81.79832923099991, 7.594224351000037],
              [-81.77013098899994, 7.614813544000071],
              [-81.76036536399994, 7.620184637000079],
              [-81.75991777299993, 7.616400458000044],
              [-81.75251217399995, 7.616400458000044],
              [-81.75523841099994, 7.624009507000039],
              [-81.75731360599991, 7.636419989000046],
              [-81.75991777299993, 7.644273179000038],
              [-81.75251217399995, 7.644273179000038],
              [-81.75251217399995, 7.636867580000057],
              [-81.74624589799993, 7.636867580000057],
              [-81.74681555899991, 7.641831773000092],
              [-81.74535071499992, 7.64329661700009],
              [-81.74242102799991, 7.643459377000056],
              [-81.73884029899995, 7.644273179000038],
              [-81.71617591099994, 7.579657294000071],
              [-81.71519934799994, 7.568019924000055],
              [-81.71328691299993, 7.565904039000088],
              [-81.70531165299991, 7.553697007000039],
              [-81.70482337099992, 7.55109284100007],
              [-81.70592200399994, 7.543117580000057],
              [-81.70531165299991, 7.540676174000055],
              [-81.70213782499991, 7.540187893000052],
              [-81.69383704299992, 7.541408596000053],
              [-81.69102942599994, 7.540676174000055],
              [-81.68203691299993, 7.534572658000059],
              [-81.67564856699994, 7.532131252000056],
              [-81.67178300699993, 7.526353257000039],
              [-81.67052161399994, 7.510239976000094],
              [-81.67638098899994, 7.505519924000055],
              [-81.70836341099994, 7.493475653000075],
              [-81.70933997299994, 7.48663971600007],
              [-81.71678626199991, 7.457505601000094],
              [-81.71898352799991, 7.452541408000059],
              [-81.71271725199995, 7.44009023600006],
              [-81.69473222599993, 7.423976955000057],
              [-81.69102942599994, 7.414048570000091],
              [-81.68919837099992, 7.403794664000088],
              [-81.68443762899994, 7.395005601000094],
              [-81.67788652299993, 7.391587632000039],
              [-81.67052161399994, 7.397284247000073],
              [-81.66437740799995, 7.397284247000073],
            ],
          ],
          [
            [
              [-82.21178137899994, 8.19920482000009],
              [-82.23302161399994, 8.20530833500004],
              [-82.24705969999991, 8.206732489000046],
              [-82.25340735599991, 8.202337958000044],
              [-82.25332597599993, 8.19326406500005],
              [-82.25259355399993, 8.188381252000056],
              [-82.24596106699994, 8.171291408000059],
              [-82.27383378799993, 8.191799221000053],
              [-82.28136145699995, 8.193548895000049],
              [-82.30138098899994, 8.196112372000073],
              [-82.30797278599994, 8.19920482000009],
              [-82.31566321499992, 8.214911200000074],
              [-82.30646725199995, 8.22406647300005],
              [-82.27383378799993, 8.233343817000048],
              [-82.25959225199995, 8.227036851000037],
              [-82.23888098899994, 8.220648505000042],
              [-82.22012285099993, 8.212062893000052],
              [-82.21178137899994, 8.19920482000009],
            ],
          ],
          [
            [
              [-82.34276282499991, 8.25999583500004],
              [-82.31480872299994, 8.240179755000042],
              [-82.33486894399994, 8.23509349200009],
              [-82.36969967399995, 8.216864325000074],
              [-82.38646399599992, 8.21287669500009],
              [-82.39834550699993, 8.21820709800005],
              [-82.41250566299993, 8.231024481000077],
              [-82.42471269399994, 8.246568101000037],
              [-82.43089758999992, 8.25999583500004],
              [-82.42467200399994, 8.25999583500004],
              [-82.40192623599995, 8.257147528000075],
              [-82.35000566299993, 8.293646552000041],
              [-82.32848059799994, 8.287990627000056],
              [-82.31651770699995, 8.27732982000009],
              [-82.3172094389999, 8.26756419500009],
              [-82.32705644399994, 8.262884833000044],
              [-82.34276282499991, 8.267523505000042],
              [-82.34276282499991, 8.25999583500004],
            ],
          ],
          [
            [
              [-79.09406490799995, 8.30849844000005],
              [-79.08750501899993, 8.295776164000074],
              [-79.08300128899992, 8.274186322000048],
              [-79.07586376099994, 8.265991063000058],
              [-79.07099204899993, 8.264492413000085],
              [-79.06574100899991, 8.260760089000087],
              [-79.0698599509999, 8.257050825000078],
              [-79.08039084199993, 8.254828134000093],
              [-79.09127787299991, 8.259680790000061],
              [-79.10378803899994, 8.252959415000078],
              [-79.10452795799995, 8.244402237000088],
              [-79.09844714099995, 8.238471424000068],
              [-79.09850992699995, 8.229879634000042],
              [-79.10488716099991, 8.228778713000054],
              [-79.1086818949999, 8.22392517600008],
              [-79.1095195659999, 8.210469238000087],
              [-79.12270896399991, 8.208981766000079],
              [-79.14000259699992, 8.244395848000067],
              [-79.1369727149999, 8.25743809800008],
              [-79.13056404999992, 8.256690183000046],
              [-79.1298047219999, 8.264141881000057],
              [-79.12564983499993, 8.277552791000062],
              [-79.12941093899991, 8.287243020000062],
              [-79.1244996719999, 8.303261001000067],
              [-79.11243080899993, 8.317408727000043],
              [-79.10488692399991, 8.318517622000059],
              [-79.10037274099994, 8.317396915000074],
              [-79.09487870999993, 8.311753648000092],
              [-79.09406490799995, 8.30849844000005],
            ],
          ],
          [
            [
              [-82.36204993399991, 8.086859442000048],
              [-82.35924231699994, 8.099025783000059],
              [-82.35244706899994, 8.11204661700009],
              [-82.34312903599994, 8.12335846600007],
              [-82.33234615799995, 8.129706122000073],
              [-82.32070878799993, 8.13031647300005],
              [-82.31834876199991, 8.123968817000048],
              [-82.31944739499994, 8.113104559000078],
              [-82.31822669199994, 8.09992096600007],
              [-82.33653723899994, 8.091864325000074],
              [-82.34748287699995, 8.088283596000053],
              [-82.36204993399991, 8.086859442000048],
            ],
          ],
          [
            [
              [-79.08439313199995, 8.38249055700004],
              [-79.09284420499995, 8.37718333500004],
              [-79.11217536399994, 8.391497737000066],
              [-79.13009816699991, 8.404869682000083],
              [-79.11823790299991, 8.429110441000091],
              [-79.1050181839999, 8.418740701000047],
              [-79.09483801999994, 8.40648021000004],
              [-79.09014876899994, 8.410278495000057],
              [-79.0879429709999, 8.419543644000044],
              [-79.08243764799994, 8.415996564000068],
              [-79.0862839099999, 8.403453466000087],
              [-79.07886767399992, 8.398554347000072],
              [-79.08025186799995, 8.39092974500005],
              [-79.08439313199995, 8.38249055700004],
            ],
          ],
          [
            [
              [-82.12303626199991, 9.322658596000053],
              [-82.0977270169999, 9.31118398600006],
              [-82.0852758449999, 9.302679755000042],
              [-82.07461503799993, 9.28851959800005],
              [-82.09398352799991, 9.29124583500004],
              [-82.11416581899994, 9.283270575000074],
              [-82.1301977199999, 9.268255927000041],
              [-82.13882402299993, 9.245306708000044],
              [-82.14362545499995, 9.24713776200008],
              [-82.15440833199995, 9.258368231000077],
              [-82.15396074099993, 9.259182033000059],
              [-82.15172278599994, 9.259914455000057],
              [-82.15029863199993, 9.264349677000041],
              [-82.15025794199994, 9.287258205000057],
              [-82.15404212099992, 9.296291408000059],
              [-82.16397050699993, 9.30219147300005],
              [-82.16397050699993, 9.308417059000078],
              [-82.15029863199993, 9.30219147300005],
              [-82.15933183499993, 9.323146877000056],
              [-82.17430579299992, 9.33038971600007],
              [-82.19261633999992, 9.33388906500005],
              [-82.21178137899994, 9.343166408000059],
              [-82.21178137899994, 9.349351304000038],
              [-82.20616614499994, 9.354193427000041],
              [-82.20099850199995, 9.35618724200009],
              [-82.19603430899991, 9.354803778000075],
              [-82.19131425699993, 9.349351304000038],
              [-82.18248450399994, 9.345851955000057],
              [-82.17438717399995, 9.34406159100007],
              [-82.16600501199991, 9.344956773000092],
              [-82.15656490799995, 9.349351304000038],
              [-82.14671790299991, 9.344631252000056],
              [-82.12303626199991, 9.322658596000053],
            ],
          ],
          [
            [
              [-82.32848059799994, 9.412054755000042],
              [-82.30166581899994, 9.432318427000041],
              [-82.28551184799994, 9.438869533000059],
              [-82.2664281889999, 9.43935781500005],
              [-82.23875891799992, 9.39874909100007],
              [-82.23180091099994, 9.37335846600007],
              [-82.24596106699994, 9.356838283000059],
              [-82.24596106699994, 9.349351304000038],
              [-82.24156653599994, 9.344549872000073],
              [-82.24014238199993, 9.341945705000057],
              [-82.24168860599991, 9.338080145000049],
              [-82.24596106699994, 9.33006419500009],
              [-82.25967363199993, 9.353176174000055],
              [-82.28075110599991, 9.374701239000046],
              [-82.32848059799994, 9.412054755000042],
            ],
          ],
          [
            [
              [-78.89224447499993, 8.458046989000081],
              [-78.89371335499993, 8.469273655000052],
              [-78.88992961499991, 8.474136485000088],
              [-78.88018061799994, 8.468460590000063],
              [-78.86913001199991, 8.46165599200009],
              [-78.86278235599991, 8.453680731000077],
              [-78.85822506399995, 8.442938544000071],
              [-78.85537675699993, 8.431341864000046],
              [-78.85448157499991, 8.421087958000044],
              [-78.85468334699993, 8.413287151000077],
              [-78.84222896199992, 8.411064086000067],
              [-78.8355102729999, 8.39799539900008],
              [-78.83733826699995, 8.386865516000057],
              [-78.84567049399993, 8.381269455000051],
              [-78.84795918899994, 8.368606294000074],
              [-78.83447648499993, 8.342810923000059],
              [-78.84320713099993, 8.320457840000074],
              [-78.85229804499994, 8.312268477000089],
              [-78.85228125599991, 8.303331914000069],
              [-78.85802161399994, 8.295843817000048],
              [-78.87041456299994, 8.296650181000075],
              [-78.87534335399994, 8.301494433000073],
              [-78.88250315999994, 8.300386780000053],
              [-78.88923092399995, 8.29913971600007],
              [-78.89639936999993, 8.297429279000085],
              [-78.89905189699994, 8.302641950000066],
              [-78.9013251369999, 8.308967386000063],
              [-78.90469062599993, 8.302649751000047],
              [-78.91219731699994, 8.293727235000063],
              [-78.92047597299995, 8.282565959000067],
              [-78.92011717699995, 8.274001963000046],
              [-78.92277514599994, 8.265446118000057],
              [-78.9129872389999, 8.253881356000079],
              [-78.91113984499992, 8.234147619000055],
              [-78.90511446499994, 8.22929004100007],
              [-78.89757411699992, 8.228897258000075],
              [-78.89757889899994, 8.224426574000063],
              [-78.90398547099994, 8.219221605000087],
              [-78.9179244419999, 8.227084176000062],
              [-78.92845417699994, 8.23566760400007],
              [-78.9269376119999, 8.249817786000051],
              [-78.93365607099992, 8.273271306000083],
              [-78.94004292499994, 8.282589941000083],
              [-78.95799719999991, 8.290432033000059],
              [-78.96434485599991, 8.29482656500005],
              [-78.96989797299995, 8.305098917000066],
              [-78.9654121449999, 8.320765975000086],
              [-78.95823733999993, 8.329105164000055],
              [-78.9547769369999, 8.346514341000045],
              [-78.95848548099991, 8.352850653000075],
              [-78.96727762699993, 8.362430036000092],
              [-78.96990783399991, 8.369891318000043],
              [-78.96575300599994, 8.377316386000075],
              [-78.96160231099992, 8.383618156000068],
              [-78.9612179209999, 8.390315085000054],
              [-78.96571735799995, 8.408223900000053],
              [-78.96434485599991, 8.417669989000046],
              [-78.97471184999995, 8.444368241000063],
              [-78.97092155699994, 8.458449965000057],
              [-78.95812685599992, 8.45880618600006],
              [-78.94910443999993, 8.452789919000054],
              [-78.90877739699994, 8.470040703000052],
              [-78.89976966099994, 8.461615302000041],
              [-78.89696204299992, 8.456691799000055],
              [-78.89541581899994, 8.451849677000041],
              [-78.89224447499993, 8.458046989000081],
            ],
          ],
          [
            [
              [-79.57039255199993, 8.798575963000076],
              [-79.5633396039999, 8.80463886800004],
              [-79.5568946539999, 8.802516973000081],
              [-79.55382717799995, 8.803426325000089],
              [-79.55321149999992, 8.800395163000076],
              [-79.55535746599992, 8.797970274000079],
              [-79.55259222199993, 8.791908401000057],
              [-79.54798869699994, 8.788877806000073],
              [-79.54185266899992, 8.786756789000037],
              [-79.54123675099993, 8.781302357000072],
              [-79.54338095799994, 8.775544614000069],
              [-79.5479808469999, 8.77402866600005],
              [-79.55135755399994, 8.779179747000057],
              [-79.55534757299995, 8.782815983000091],
              [-79.56270948699995, 8.781299764000039],
              [-79.56915370799993, 8.78311735300008],
              [-79.57161263799992, 8.789178986000081],
              [-79.57039255199993, 8.798575963000076],
            ],
          ],
          [
            [
              [-81.5682686479999, 9.10824946200006],
              [-81.56549282599991, 9.105496117000087],
              [-81.55992511999995, 9.10396596600009],
              [-81.55774703499992, 9.106106241000077],
              [-81.55310224199991, 9.10579937600005],
              [-81.54722092599991, 9.102740545000074],
              [-81.5419475949999, 9.09907047200005],
              [-81.5379113379999, 9.095094040000049],
              [-81.53666944899993, 9.091423836000047],
              [-81.53387190099994, 9.088669683000091],
              [-81.53449179699993, 9.085917258000052],
              [-81.53884096899992, 9.085920190000081],
              [-81.54381126299995, 9.088369729000078],
              [-81.55218935499994, 9.089596845000074],
              [-81.56241366799992, 9.09082288400009],
              [-81.56704406299991, 9.090822599000091],
              [-81.5716713079999, 9.089598507000062],
              [-81.57292766099994, 9.096020901000088],
              [-81.57509865899993, 9.10060658100008],
              [-81.57725858899994, 9.10458133800006],
              [-81.57539613699993, 9.107638619000056],
              [-81.5682686479999, 9.10824946200006],
            ],
          ],
          [
            [
              [-82.04723834999993, 9.172568781000052],
              [-82.05240965799993, 9.177661002000093],
              [-82.05184027299993, 9.182192803000078],
              [-82.04552275399993, 9.17936813600005],
              [-82.04149825099995, 9.173142195000082],
              [-82.0357556319999, 9.16975029100007],
              [-82.02886688599995, 9.169192132000092],
              [-82.0254148169999, 9.160700151000071],
              [-82.02311321999991, 9.153905700000053],
              [-82.01622389199991, 9.15108183600006],
              [-82.00876062099991, 9.147692229000086],
              [-82.0104771099999, 9.141459268000062],
              [-82.0196558419999, 9.13748270700006],
              [-82.02711256799995, 9.13294146700008],
              [-82.03285361399992, 9.134633315000087],
              [-82.04204321499992, 9.140852517000042],
              [-82.0500839149999, 9.145940624000048],
              [-82.05525757899994, 9.153864964000093],
              [-82.0546908579999, 9.16179681400007],
              [-82.04723834999993, 9.172568781000052],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Greenland',
        iso3: 'GRL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-40.87580318899995, 65.09650299700007],
              [-40.85366777299993, 65.06586334800005],
              [-40.86937415299991, 65.06317780200004],
              [-40.93846594999991, 65.08283112200007],
              [-41.01598059799994, 65.08926015800006],
              [-41.05711829299992, 65.09975820500006],
              [-41.075062628999945, 65.12042877800008],
              [-41.08226477799991, 65.13174062700006],
              [-41.09825598899994, 65.12995026200008],
              [-41.11461341099994, 65.12250397300005],
              [-41.12279212099992, 65.11701080900008],
              [-41.12755286399994, 65.10419342700004],
              [-41.127064581999946, 65.09088776200008],
              [-41.12100175699993, 65.08026764500005],
              [-41.07762610599991, 65.06769440300008],
              [-41.03359941299993, 65.02802155200004],
              [-41.006743943999936, 65.01459381700005],
              [-41.01089433499993, 65.00470612200007],
              [-41.01353919199994, 65.00092194200005],
              [-40.99242102799991, 64.99030182500007],
              [-40.98314368399991, 64.97675202000005],
              [-40.989125128999945, 64.96507396000004],
              [-41.01353919199994, 64.95994700700004],
              [-41.130116339999915, 64.98139069200005],
              [-41.15013587099992, 64.97671133000006],
              [-41.14956620999993, 64.96063873900005],
              [-41.14639238199993, 64.95351797100005],
              [-41.12279212099992, 64.93943919500003],
              [-41.112212693999936, 64.93056875200006],
              [-41.073475714999915, 64.88719310100004],
              [-41.06680253799993, 64.88198476800005],
              [-41.05455481699994, 64.87738678600005],
              [-41.01402747299994, 64.87579987200007],
              [-40.99327551999994, 64.87213776200008],
              [-40.993072068999936, 64.86371491100005],
              [-40.96670488199993, 64.86465078300006],
              [-40.88320878799993, 64.85757070500006],
              [-40.89635169199994, 64.85224030200004],
              [-40.920033331999946, 64.83856842700004],
              [-40.93472245999993, 64.83584219000005],
              [-40.96515865799995, 64.83624909100007],
              [-40.97960364499994, 64.83454010600008],
              [-40.993072068999936, 64.82957591400003],
              [-40.88463294199994, 64.80914948100008],
              [-40.87580318899995, 64.78864166900007],
              [-40.78978430899991, 64.74628327000005],
              [-40.76349850199995, 64.74022044500003],
              [-40.73412024599992, 64.73932526200008],
              [-40.70482337099992, 64.73383209800005],
              [-40.68687903599994, 64.71963125200006],
              [-40.691477016999954, 64.69245026200008],
              [-40.62905839799993, 64.69208405200004],
              [-40.60448157499991, 64.68349844000005],
              [-40.594634568999936, 64.66201406500005],
              [-40.59471594999991, 64.65582916900007],
              [-40.59593665299991, 64.65265534100007],
              [-40.59911048099991, 64.65155670800004],
              [-40.605458136999914, 64.65143463700008],
              [-40.61034094999991, 64.64858633000006],
              [-40.60855058499993, 64.64203522300005],
              [-40.60204016799992, 64.63100820500006],
              [-40.599720831999946, 64.62018463700008],
              [-40.59337317599994, 64.60366445500006],
              [-40.594634568999936, 64.59686920800004],
              [-40.58576412699995, 64.57949453300006],
              [-40.57054602799991, 64.53237539300005],
              [-40.561105923999946, 64.51496002800008],
              [-40.61799068899995, 64.48403554900005],
              [-40.63512122299994, 64.46710846600007],
              [-40.605458136999914, 64.45966217700004],
              [-40.569569464999915, 64.45697663000004],
              [-40.401275193999936, 64.41718170800004],
              [-40.386708136999914, 64.40814850500004],
              [-40.37291419199994, 64.39598216400003],
              [-40.36815344999991, 64.39276764500005],
              [-40.36929277299993, 64.37396881700005],
              [-40.36558997299994, 64.36644114800004],
              [-40.359486456999946, 64.36298248900005],
              [-40.358306443999936, 64.35903554900005],
              [-40.36929277299993, 64.34979889500005],
              [-40.383371548999946, 64.34471263200004],
              [-40.41397050699993, 64.34223053600005],
              [-40.42454993399991, 64.33681875200006],
              [-40.43785559799994, 64.35179271000004],
              [-40.457142706999946, 64.35846588700008],
              [-40.47891191299993, 64.35748932500007],
              [-40.49962317599994, 64.34979889500005],
              [-40.50890051999994, 64.34178294500003],
              [-40.51203365799995, 64.33527252800008],
              [-40.51744544199994, 64.33087799700007],
              [-40.53380286399994, 64.32933177300004],
              [-40.54865475199995, 64.33226146000004],
              [-40.553578253999945, 64.33954498900005],
              [-40.55028235599991, 64.34845612200007],
              [-40.54063880099994, 64.35663483300004],
              [-40.54063880099994, 64.36408112200007],
              [-40.60619055899991, 64.37433502800008],
              [-40.61632239499994, 64.38080475500004],
              [-40.623036261999914, 64.39215729400007],
              [-40.63849850199995, 64.38979726800005],
              [-40.667225714999915, 64.37775299700007],
              [-40.681630011999914, 64.37970612200007],
              [-40.70767167899993, 64.38865794500003],
              [-40.718739386999914, 64.39077383000006],
              [-40.73192298099991, 64.38833242400005],
              [-40.757476365999935, 64.37848541900007],
              [-40.77334550699993, 64.37775299700007],
              [-40.76720130099994, 64.38397858300004],
              [-40.80020097599993, 64.38873932500007],
              [-40.83617102799991, 64.38031647300005],
              [-40.93049068899995, 64.33364492400005],
              [-40.96556555899991, 64.32514069200005],
              [-41.07774817599994, 64.31110260600008],
              [-41.33568274599992, 64.32933177300004],
              [-41.332142706999946, 64.33234284100007],
              [-41.32201087099992, 64.34296295800004],
              [-41.353179490999935, 64.34967682500007],
              [-41.45860755099994, 64.32933177300004],
              [-41.50275631399995, 64.33051178600005],
              [-41.52489173099991, 64.32611725500004],
              [-41.539133266999954, 64.30560944200005],
              [-41.568470831999946, 64.28148021000004],
              [-41.56749426999994, 64.26618073100008],
              [-41.55333411399994, 64.25775788000004],
              [-41.531361456999946, 64.25433991100005],
              [-41.46336829299992, 64.25446198100008],
              [-41.44416256399995, 64.24762604400007],
              [-41.44871985599991, 64.23037344000005],
              [-41.45543372299994, 64.21946849200003],
              [-41.45230058499993, 64.21352773600006],
              [-41.39696204299992, 64.18187083500004],
              [-41.387277798999946, 64.17853424700007],
              [-41.087147589999915, 64.14923737200007],
              [-41.061390753999945, 64.14061107000003],
              [-41.046864386999914, 64.12872955900008],
              [-41.02448482999995, 64.09943268400008],
              [-41.00645911399994, 64.08600495000007],
              [-40.984038865999935, 64.08030833500004],
              [-40.95933997299994, 64.08274974200003],
              [-40.937489386999914, 64.09275950700004],
              [-40.92418372299994, 64.10956452000005],
              [-40.94546464799993, 64.11863841400003],
              [-40.96519934799994, 64.13007233300004],
              [-40.95567786399994, 64.14118073100008],
              [-40.92870032499991, 64.15680573100008],
              [-40.917958136999914, 64.16486237200007],
              [-40.91051184799994, 64.15802643400008],
              [-40.88634192599994, 64.16669342700004],
              [-40.76720130099994, 64.16486237200007],
              [-40.76134192599994, 64.16242096600007],
              [-40.74909420499995, 64.15322500200006],
              [-40.74299068899995, 64.15119049700007],
              [-40.735585089999915, 64.15281810100004],
              [-40.72899329299992, 64.15623607000003],
              [-40.721547003999945, 64.15884023600006],
              [-40.71198482999995, 64.15802643400008],
              [-40.69591223899994, 64.15005117400005],
              [-40.68663489499994, 64.14081452000005],
              [-40.67613684799994, 64.13324616100005],
              [-40.59162350199995, 64.12051015800006],
              [-40.56094316299993, 64.10687897300005],
              [-40.548085089999915, 64.08600495000007],
              [-40.54238847599993, 64.06769440300008],
              [-40.54527747299994, 64.05878327000005],
              [-40.57730058499993, 64.05158112200007],
              [-40.59752356699994, 64.04303620000007],
              [-40.61660722599993, 64.03192780200004],
              [-40.62999426999994, 64.02081940300008],
              [-40.64830481699994, 64.01190827000005],
              [-40.64122473899994, 64.00031159100007],
              [-40.60204016799992, 63.97923411700003],
              [-40.623931443999936, 63.96727122600004],
              [-40.645375128999945, 63.96596914300005],
              [-40.66584225199995, 63.97125885600008],
              [-40.71617591099994, 63.99388255400004],
              [-40.733265753999945, 63.99408600500004],
              [-40.746083136999914, 63.97923411700003],
              [-40.726551886999914, 63.97370026200008],
              [-40.718739386999914, 63.97304922100005],
              [-40.74461829299992, 63.96271393400008],
              [-40.84166419199994, 63.95258209800005],
              [-40.80894934799994, 63.93903229400007],
              [-40.76073157499991, 63.933254299000055],
              [-40.71202551999994, 63.93528880400004],
              [-40.677805141999954, 63.945746161000045],
              [-40.637928839999915, 63.932928778000075],
              [-40.62169348899994, 63.92462799700007],
              [-40.62254798099991, 63.91095612200007],
              [-40.62254798099991, 63.90420156500005],
              [-40.60952714799993, 63.89158763200004],
              [-40.60260982999995, 63.88703034100007],
              [-40.594634568999936, 63.883693752000056],
              [-40.594634568999936, 63.87685781500005],
              [-40.608306443999936, 63.86713288000004],
              [-40.59715735599991, 63.85504791900007],
              [-40.561105923999946, 63.83588288000004],
              [-40.561105923999946, 63.82843659100007],
              [-40.59048417899993, 63.82208893400008],
              [-40.614125128999945, 63.80756256700005],
              [-40.618072068999936, 63.79319896000004],
              [-40.58836829299992, 63.78750234600005],
              [-40.58836829299992, 63.781236070000034],
              [-40.59227454299992, 63.77985260600008],
              [-40.60204016799992, 63.77440013200004],
              [-40.58747311099995, 63.76935455900008],
              [-40.578236456999946, 63.75067780200004],
              [-40.564523891999954, 63.746527411000045],
              [-40.53282630099994, 63.74632396000004],
              [-40.519642706999946, 63.74054596600007],
              [-40.51329505099994, 63.72601959800005],
              [-40.52643795499995, 63.69635651200008],
              [-40.562489386999914, 63.684881903000075],
              [-40.64366614499994, 63.68504466400003],
              [-40.63540605399993, 63.696600653000075],
              [-40.63048255099994, 63.70136139500005],
              [-40.62254798099991, 63.705511786000045],
              [-40.64745032499991, 63.71141185100004],
              [-40.678618943999936, 63.711371161000045],
              [-40.70067298099991, 63.70136139500005],
              [-40.69823157499991, 63.67763906500005],
              [-40.99791419199994, 63.70294830900008],
              [-41.08531653599994, 63.721869208000044],
              [-41.13931230399993, 63.74945709800005],
              [-41.32066809799994, 63.772650458000044],
              [-41.354359503999945, 63.782538153000075],
              [-41.380116339999915, 63.79832591400003],
              [-41.407093878999945, 63.82221100500004],
              [-41.41274980399993, 63.825832424000055],
              [-41.42052161399994, 63.843085028000075],
              [-41.42446855399993, 63.84955475500004],
              [-41.43350175699993, 63.85594310100004],
              [-41.44469153599994, 63.861029364000046],
              [-41.45783443899995, 63.86375560100004],
              [-41.47288977799991, 63.86318594000005],
              [-41.48810787699995, 63.860256252000056],
              [-41.49132239499994, 63.85700104400007],
              [-41.48875891799992, 63.850897528000075],
              [-41.48656165299991, 63.83930084800005],
              [-41.50112870999993, 63.82221100500004],
              [-41.53465735599991, 63.81244538000004],
              [-41.59642493399991, 63.80170319200005],
              [-41.62022864499994, 63.79437897300005],
              [-41.62926184799994, 63.78766510600008],
              [-41.62682044199994, 63.77781810100004],
              [-41.618031378999945, 63.77008698100008],
              [-41.606678839999915, 63.76268138200004],
              [-41.59434973899994, 63.75698476800005],
              [-41.58275305899991, 63.753973700000074],
              [-41.56773841099994, 63.75503164300005],
              [-41.54279537699995, 63.76508209800005],
              [-41.530913865999935, 63.767564195000034],
              [-41.46914628799993, 63.767564195000034],
              [-41.441395636999914, 63.763373114000046],
              [-41.39606686099995, 63.744574286000045],
              [-41.33763587099992, 63.735663153000075],
              [-41.24632727799991, 63.699286200000074],
              [-41.21837317599994, 63.693345445000034],
              [-40.96666419199994, 63.67450592700004],
              [-40.90851803299995, 63.66083405200004],
              [-40.87950598899994, 63.65770091400003],
              [-40.84166419199994, 63.59564850500004],
              [-40.89004472599993, 63.59564850500004],
              [-40.872385219999956, 63.58026764500005],
              [-40.848866339999915, 63.57273997600004],
              [-40.823882615999935, 63.571519273000035],
              [-40.801340298999946, 63.57518138200004],
              [-40.79564368399991, 63.57802969000005],
              [-40.78945878799993, 63.58226146000004],
              [-40.78062903599994, 63.58641185100004],
              [-40.76720130099994, 63.58942291900007],
              [-40.759755011999914, 63.58901601800005],
              [-40.75169837099992, 63.58734772300005],
              [-40.74258378799993, 63.586818752000056],
              [-40.732411261999914, 63.58942291900007],
              [-40.737212693999936, 63.58234284100007],
              [-40.74372311099995, 63.57518138200004],
              [-40.75967363199993, 63.562201239000046],
              [-40.74278723899994, 63.538397528000075],
              [-40.750070766999954, 63.516913153000075],
              [-40.77257239499994, 63.50259023600006],
              [-40.801340298999946, 63.500067450000074],
              [-40.82201087099992, 63.51015859600005],
              [-40.83625240799995, 63.52399323100008],
              [-40.851633266999954, 63.53119538000004],
              [-40.87580318899995, 63.521185614000046],
              [-40.87580318899995, 63.513739325000074],
              [-40.86278235599991, 63.507513739000046],
              [-40.875111456999946, 63.507066148000035],
              [-40.887562628999945, 63.507879950000074],
              [-40.89956620999993, 63.51007721600007],
              [-40.91051184799994, 63.513739325000074],
              [-40.91820227799991, 63.51894765800006],
              [-40.93472245999993, 63.53465403900003],
              [-40.94469153599994, 63.541001695000034],
              [-40.944569464999915, 63.53139883000006],
              [-40.946197068999936, 63.52496979400007],
              [-40.95213782499991, 63.513739325000074],
              [-40.96422278599994, 63.518011786000045],
              [-40.968739386999914, 63.52334219000005],
              [-40.97085527299993, 63.52985260600008],
              [-40.97598222599993, 63.53758372600004],
              [-41.01414954299992, 63.56541575700004],
              [-41.019602016999954, 63.56159088700008],
              [-41.02122962099992, 63.55365631700005],
              [-41.02106686099995, 63.548529364000046],
              [-41.01622473899994, 63.54083893400008],
              [-40.993072068999936, 63.521185614000046],
              [-41.032093878999945, 63.51308828300006],
              [-41.10627193899995, 63.52533600500004],
              [-41.14391028599994, 63.527411200000074],
              [-41.12954667899993, 63.51264069200005],
              [-41.10875403599994, 63.507147528000075],
              [-41.06505286399994, 63.507513739000046],
              [-41.049387173999946, 63.50214264500005],
              [-41.01805579299992, 63.475816148000035],
              [-40.999338344999956, 63.46653880400004],
              [-41.01675370999993, 63.450506903000075],
              [-41.04450436099995, 63.44550202000005],
              [-41.07363847599993, 63.44749583500004],
              [-41.09552975199995, 63.452337958000044],
              [-41.11546790299991, 63.46133047100005],
              [-41.194203253999945, 63.53143952000005],
              [-41.21544348899994, 63.54389069200005],
              [-41.26585852799991, 63.56468333500004],
              [-41.28066972599993, 63.56826406500005],
              [-41.28726152299993, 63.56492747600004],
              [-41.28563391799992, 63.55463288000004],
              [-41.282866990999935, 63.54710521000004],
              [-41.28237870999993, 63.54083893400008],
              [-41.28726152299993, 63.53424713700008],
              [-41.267567511999914, 63.52692291900007],
              [-41.22520911399994, 63.516831773000035],
              [-41.20539303299995, 63.507513739000046],
              [-41.192616339999915, 63.49469635600008],
              [-41.18016516799992, 63.47614166900007],
              [-41.17247473899994, 63.45954010600008],
              [-41.17430579299992, 63.452337958000044],
              [-41.15306555899991, 63.44794342700004],
              [-41.10777747299994, 63.42869700700004],
              [-41.082142706999946, 63.42438385600008],
              [-41.03628495999993, 63.42523834800005],
              [-41.01585852799991, 63.42161692900004],
              [-40.999338344999956, 63.411322333000044],
              [-41.01329505099994, 63.404730536000045],
              [-41.03034420499995, 63.402777411000045],
              [-41.06505286399994, 63.40387604400007],
              [-41.08023027299993, 63.402411200000074],
              [-41.11595618399991, 63.39020416900007],
              [-41.12950598899994, 63.38914622600004],
              [-41.16909745999993, 63.39057038000004],
              [-41.177398240999935, 63.39398834800005],
              [-41.180978969999956, 63.404364325000074],
              [-41.197255011999914, 63.432806708000044],
              [-41.20197506399995, 63.438666083000044],
              [-41.22337805899991, 63.44684479400007],
              [-41.29124915299991, 63.48773834800005],
              [-41.32591712099992, 63.51536692900004],
              [-41.37669837099992, 63.541001695000034],
              [-41.400949673999946, 63.55951569200005],
              [-41.41392981699994, 63.56590403900003],
              [-41.43187415299991, 63.56777578300006],
              [-41.325510219999956, 63.48265208500004],
              [-41.28726152299993, 63.44489166900007],
              [-41.257801886999914, 63.42942942900004],
              [-41.24571692599994, 63.419582424000055],
              [-41.24010169199994, 63.40387604400007],
              [-41.39305579299992, 63.458238023000035],
              [-41.43814042899993, 63.48582591400003],
              [-41.48961341099994, 63.53082916900007],
              [-41.49290930899991, 63.525091864000046],
              [-41.493397589999915, 63.503892320000034],
              [-41.49795488199993, 63.48501211100006],
              [-41.51382402299993, 63.48582591400003],
              [-41.51382402299993, 63.47955963700008],
              [-41.52586829299992, 63.485581773000035],
              [-41.54434160099993, 63.49062734600005],
              [-41.56484941299993, 63.493475653000075],
              [-41.58275305899991, 63.49323151200008],
              [-41.57530676999994, 63.49323151200008],
              [-41.57994544199994, 63.48997630400004],
              [-41.57664954299992, 63.48875560100004],
              [-41.56932532499991, 63.487941799000055],
              [-41.56163489499994, 63.48582591400003],
              [-41.54792232999995, 63.47675202000005],
              [-41.54141191299993, 63.473822333000044],
              [-41.512928839999915, 63.47020091400003],
              [-41.359364386999914, 63.425441799000055],
              [-41.24901282499991, 63.37103913000004],
              [-41.16006425699993, 63.345770575000074],
              [-41.136830206999946, 63.33270905200004],
              [-41.11595618399991, 63.31513092700004],
              [-41.11595618399991, 63.308294989000046],
              [-41.13263912699995, 63.31134674700007],
              [-41.177398240999935, 63.33502838700008],
              [-41.197255011999914, 63.34218984600005],
              [-41.36204993399991, 63.372300523000035],
              [-41.37401282499991, 63.37677643400008],
              [-41.382150844999956, 63.38471100500004],
              [-41.39098059799994, 63.397650458000044],
              [-41.38353430899991, 63.40387604400007],
              [-41.40387936099995, 63.421576239000046],
              [-41.434885219999956, 63.42593008000006],
              [-41.50023352799991, 63.42438385600008],
              [-41.53099524599992, 63.43195221600007],
              [-41.66714433499993, 63.51007721600007],
              [-41.70140540299991, 63.54450104400007],
              [-41.71593176999994, 63.55296458500004],
              [-41.73387610599991, 63.553941148000035],
              [-41.76024329299992, 63.548529364000046],
              [-41.75894120999993, 63.54214101800005],
              [-41.75621497299994, 63.53660716400003],
              [-41.752064581999946, 63.53172435100004],
              [-41.746652798999946, 63.527411200000074],
              [-41.77057857999995, 63.50958893400008],
              [-41.884429490999935, 63.47955963700008],
              [-41.90086829299992, 63.469916083000044],
              [-41.90705318899995, 63.46352773600006],
              [-41.90526282499991, 63.456366278000075],
              [-41.89806067599994, 63.44489166900007],
              [-41.86204993399991, 63.40957265800006],
              [-41.85643469999991, 63.40078359600005],
              [-41.83263098899994, 63.39695872600004],
              [-41.68390865799995, 63.35333893400008],
              [-41.68065344999991, 63.345404364000046],
              [-41.683664516999954, 63.33612702000005],
              [-41.691395636999914, 63.32880280200004],
              [-41.69969641799992, 63.32762278900003],
              [-41.79059811099995, 63.348822333000044],
              [-41.808705206999946, 63.34247467700004],
              [-41.808705206999946, 63.33502838700008],
              [-41.779855923999946, 63.32925039300005],
              [-41.76549231699994, 63.32412344000005],
              [-41.75340735599991, 63.31513092700004],
              [-41.75621497299994, 63.311712958000044],
              [-41.757923956999946, 63.30654531500005],
              [-41.76024329299992, 63.30145905200004],
              [-41.73672441299993, 63.30914948100008],
              [-41.670033331999946, 63.31720612200007],
              [-41.64354407499991, 63.31513092700004],
              [-41.620757615999935, 63.30658600500004],
              [-41.59097245999993, 63.29124583500004],
              [-41.56871497299994, 63.27423737200007],
              [-41.568470831999946, 63.26048411700003],
              [-41.48851477799991, 63.23777903900003],
              [-41.47288977799991, 63.225775458000044],
              [-41.474598761999914, 63.20677317900004],
              [-41.48546301999994, 63.18903229400007],
              [-41.49156653599994, 63.17096588700008],
              [-41.47911536399994, 63.15070221600007],
              [-41.43968665299991, 63.14252350500004],
              [-41.43187415299991, 63.13694896000004],
              [-41.43272864499994, 63.12531159100007],
              [-41.441477016999954, 63.120428778000075],
              [-41.46544348899994, 63.116522528000075],
              [-41.525054490999935, 63.09723541900007],
              [-41.55443274599992, 63.096869208000044],
              [-41.58275305899991, 63.10968659100007],
              [-41.61009680899991, 63.13694896000004],
              [-41.62267005099994, 63.14402903900003],
              [-41.818023240999935, 63.214829820000034],
              [-41.911040818999936, 63.225775458000044],
              [-42.02090410099993, 63.25307851800005],
              [-42.00230872299994, 63.23452383000006],
              [-41.96910559799994, 63.221584377000056],
              [-41.86070716099994, 63.195379950000074],
              [-41.73550370999993, 63.13886139500005],
              [-41.67833411399994, 63.12335846600007],
              [-41.620350714999915, 63.09601471600007],
              [-41.54946855399993, 63.05292389500005],
              [-41.53945878799993, 63.04360586100006],
              [-41.53433183499993, 63.03335195500006],
              [-41.66466223899994, 63.04075755400004],
              [-41.71617591099994, 63.06077708500004],
              [-41.74315344999991, 63.068019924000055],
              [-41.76707923099991, 63.06126536700003],
              [-41.720692511999914, 63.04629140800006],
              [-41.71133378799993, 63.03953685100004],
              [-41.73355058499993, 63.03335195500006],
              [-41.759022589999915, 63.03375885600008],
              [-41.839100714999915, 63.04755280200004],
              [-41.85704505099994, 63.05516185100004],
              [-41.86888587099992, 63.07184479400007],
              [-41.87800045499995, 63.08844635600008],
              [-41.88752193899995, 63.09601471600007],
              [-41.932484503999945, 63.102850653000075],
              [-41.95815995999993, 63.101629950000074],
              [-41.97252356699994, 63.08856842700004],
              [-41.96324622299994, 63.08665599200003],
              [-41.95482337099992, 63.08356354400007],
              [-41.93903561099995, 63.075506903000075],
              [-41.956695115999935, 63.06915924700007],
              [-41.97484290299991, 63.074286200000074],
              [-42.02257239499994, 63.108628648000035],
              [-42.04824785099993, 63.15070221600007],
              [-42.07384192599994, 63.17560455900008],
              [-42.107411261999914, 63.19481028900003],
              [-42.14395097599993, 63.20587799700007],
              [-42.178618943999936, 63.20587799700007],
              [-42.16478430899991, 63.19635651200008],
              [-42.14989173099991, 63.17877838700008],
              [-42.13744055899991, 63.15912506700005],
              [-42.13076738199993, 63.14321523600006],
              [-42.13536536399994, 63.12775299700007],
              [-42.15392005099994, 63.12091705900008],
              [-42.179676886999914, 63.11676666900007],
              [-42.205922003999945, 63.10968659100007],
              [-42.17878170499995, 63.096869208000044],
              [-42.11213131399995, 63.09369538000004],
              [-42.08238684799994, 63.08856842700004],
              [-42.02879798099991, 63.06281159100007],
              [-42.006418423999946, 63.046128648000035],
              [-42.00731360599991, 63.02708567900004],
              [-41.751942511999914, 63.02057526200008],
              [-41.74010169199994, 63.01715729400007],
              [-41.70189368399991, 62.997381903000075],
              [-41.691395636999914, 62.99359772300005],
              [-41.66812089799993, 62.993841864000046],
              [-41.644520636999914, 62.99705638200004],
              [-41.62409420499995, 62.99506256700005],
              [-41.61009680899991, 62.97931549700007],
              [-41.621205206999946, 62.975775458000044],
              [-41.623158331999946, 62.96893952000005],
              [-41.61856035099993, 62.96035390800006],
              [-41.61009680899991, 62.95140208500004],
              [-41.63646399599992, 62.92804596600007],
              [-41.67454993399991, 62.91356028900003],
              [-41.718006964999915, 62.911322333000044],
              [-41.76024329299992, 62.92475006700005],
              [-41.76817786399994, 62.93768952000005],
              [-41.77717037699995, 62.93427155200004],
              [-41.78819739499994, 62.91107819200005],
              [-41.76024329299992, 62.88373444200005],
              [-41.764963344999956, 62.88300202000005],
              [-41.76789303299995, 62.88149648600006],
              [-41.77452551999994, 62.87689850500004],
              [-41.783192511999914, 62.880845445000034],
              [-41.79466712099992, 62.88165924700007],
              [-41.807932094999956, 62.880072333000044],
              [-41.82168535099993, 62.87689850500004],
              [-41.78595943899995, 62.867254950000074],
              [-41.76073157499991, 62.85687897300005],
              [-41.749663865999935, 62.84975820500006],
              [-41.750111456999946, 62.84393952000005],
              [-41.80036373599995, 62.83844635600008],
              [-41.82209225199995, 62.83274974200003],
              [-41.843088344999956, 62.82990143400008],
              [-41.92479407499991, 62.846869208000044],
              [-41.98306230399993, 62.848944403000075],
              [-41.98619544199994, 62.85333893400008],
              [-41.99103756399995, 62.862941799000055],
              [-41.99868730399993, 62.87254466400003],
              [-42.01036536399994, 62.87689850500004],
              [-42.020822719999956, 62.873032945000034],
              [-42.01903235599991, 62.863714911000045],
              [-42.00731360599991, 62.84153880400004],
              [-42.017689581999946, 62.79682038000004],
              [-42.06126868399991, 62.790228583000044],
              [-42.17178300699993, 62.81484609600005],
              [-42.31944739499994, 62.81696198100008],
              [-42.34080969999991, 62.82396067900004],
              [-42.353627081999946, 62.83661530200004],
              [-42.34935462099992, 62.85578034100007],
              [-42.33336341099994, 62.86774323100008],
              [-42.309437628999945, 62.87474192900004],
              [-42.28343665299991, 62.87763092700004],
              [-42.26113847599993, 62.87689850500004],
              [-42.26113847599993, 62.88373444200005],
              [-42.349720831999946, 62.881293036000045],
              [-42.36359615799995, 62.889960028000075],
              [-42.35309811099995, 62.90375397300005],
              [-42.328195766999954, 62.91909414300005],
              [-42.30016028599994, 62.93195221600007],
              [-42.28038489499994, 62.938381252000056],
              [-42.30540930899991, 62.94550202000005],
              [-42.33812415299991, 62.94114817900004],
              [-42.370432094999956, 62.929388739000046],
              [-42.39395097599993, 62.91445547100005],
              [-42.40269934799994, 62.91445547100005],
              [-42.41783606699994, 62.91657135600008],
              [-42.43228105399993, 62.91596100500004],
              [-42.43862870999993, 62.90766022300005],
              [-42.43517005099994, 62.89248281500005],
              [-42.42931067599994, 62.88458893400008],
              [-42.42813066299993, 62.87872955900008],
              [-42.43862870999993, 62.86945221600007],
              [-42.46080481699994, 62.86245351800005],
              [-42.49038652299993, 62.86172109600005],
              [-42.51988684799994, 62.86587148600006],
              [-42.54173743399991, 62.87319570500006],
              [-42.572824673999946, 62.87970612200007],
              [-42.59715735599991, 62.871527411000045],
              [-42.60236568899995, 62.85626862200007],
              [-42.575835740999935, 62.84153880400004],
              [-42.54759680899991, 62.83783600500004],
              [-42.45612545499995, 62.84153880400004],
              [-42.42601477799991, 62.83803945500006],
              [-42.41576087099992, 62.82880280200004],
              [-42.423085089999915, 62.81582265800006],
              [-42.47101803299995, 62.784409898000035],
              [-42.484364386999914, 62.778998114000046],
              [-42.500111456999946, 62.78009674700007],
              [-42.50938880099994, 62.78583405200004],
              [-42.51817786399994, 62.79511139500005],
              [-42.52481035099993, 62.80483633000006],
              [-42.527455206999946, 62.81146881700005],
              [-42.53172766799992, 62.81708405200004],
              [-42.54206295499995, 62.82290273600006],
              [-42.55455481699994, 62.827337958000044],
              [-42.56558183499993, 62.82916901200008],
              [-42.57966061099995, 62.825873114000046],
              [-42.57795162699995, 62.81818268400008],
              [-42.49937903599994, 62.72695547100005],
              [-42.48713131399995, 62.69818756700005],
              [-42.50560462099992, 62.70327383000006],
              [-42.51602128799993, 62.71185944200005],
              [-42.523996548999946, 62.72223541900007],
              [-42.53490149599992, 62.73289622600004],
              [-42.548898891999954, 62.73875560100004],
              [-42.56590735599991, 62.74363841400003],
              [-42.57762610599991, 62.74990469000005],
              [-42.575835740999935, 62.75958893400008],
              [-42.58934485599991, 62.76552969000005],
              [-42.60265051999994, 62.76654694200005],
              [-42.61278235599991, 62.76162344000005],
              [-42.616851365999935, 62.749660549000055],
              [-42.61082923099991, 62.73517487200007],
              [-42.596262173999946, 62.72483958500004],
              [-42.562163865999935, 62.71246979400007],
              [-42.58043372299994, 62.69936758000006],
              [-42.60366777299993, 62.68964264500005],
              [-42.62840735599991, 62.684475002000056],
              [-42.65099036399994, 62.68451569200005],
              [-42.64411373599995, 62.694647528000075],
              [-42.63975989499994, 62.708238023000035],
              [-42.64024817599994, 62.72028229400007],
              [-42.64785722599993, 62.725490627000056],
              [-42.65900631399995, 62.73126862200007],
              [-42.68228105399993, 62.77045319200005],
              [-42.69579016799992, 62.77887604400007],
              [-42.70995032499991, 62.78001536700003],
              [-42.72130286399994, 62.77362702000005],
              [-42.726673956999946, 62.75958893400008],
              [-42.72256425699993, 62.751288153000075],
              [-42.69188391799992, 62.71246979400007],
              [-42.708241339999915, 62.69285716400003],
              [-42.73818925699993, 62.692572333000044],
              [-42.80211341099994, 62.70563385600008],
              [-42.90025794199994, 62.70774974200003],
              [-43.035267706999946, 62.72528717700004],
              [-43.05939693899995, 62.736029364000046],
              [-43.07860266799992, 62.74917226800005],
              [-43.10570227799991, 62.76048411700003],
              [-43.13267981699994, 62.76552969000005],
              [-43.151234503999945, 62.75958893400008],
              [-43.14273027299993, 62.749335028000075],
              [-43.110259568999936, 62.725490627000056],
              [-43.13125566299993, 62.71112702000005],
              [-43.11799068899995, 62.70062897300005],
              [-43.08812415299991, 62.69415924700007],
              [-42.869984503999945, 62.67487213700008],
              [-42.76085364499994, 62.64354075700004],
              [-42.74054928299995, 62.64280833500004],
              [-42.73082434799994, 62.640611070000034],
              [-42.726673956999946, 62.63300202000005],
              [-42.72809811099995, 62.62555573100008],
              [-42.73037675699993, 62.62250397300005],
              [-42.73082434799994, 62.620306708000044],
              [-42.726673956999946, 62.61562734600005],
              [-42.71556555899991, 62.60761139500005],
              [-42.69058183499993, 62.595770575000074],
              [-42.67886308499993, 62.588324286000045],
              [-42.67886308499993, 62.595770575000074],
              [-42.676625128999945, 62.60895416900007],
              [-42.67886308499993, 62.61562734600005],
              [-42.65611731699994, 62.616441148000035],
              [-42.61351477799991, 62.62995026200008],
              [-42.58922278599994, 62.626166083000044],
              [-42.452015753999945, 62.58307526200008],
              [-42.405140753999945, 62.57802969000005],
              [-42.383697068999936, 62.571519273000035],
              [-42.36668860599991, 62.55605703300006],
              [-42.344309048999946, 62.516913153000075],
              [-42.32262122299994, 62.50576406500005],
              [-42.326161261999914, 62.502834377000056],
              [-42.33568274599992, 62.49274323100008],
              [-42.333973761999914, 62.48261139500005],
              [-42.346994594999956, 62.47406647300005],
              [-42.366444464999915, 62.46784088700008],
              [-42.384022589999915, 62.46478913000004],
              [-42.432484503999945, 62.47842031500005],
              [-42.46475175699993, 62.49249909100007],
              [-42.521595831999946, 62.534409898000035],
              [-42.55532792899993, 62.541083075000074],
              [-42.55532792899993, 62.53367747600004],
              [-42.51268469999991, 62.51080963700008],
              [-42.49282792899993, 62.49518463700008],
              [-42.48029537699995, 62.47842031500005],
              [-42.49828040299991, 62.473944403000075],
              [-42.51622473899994, 62.47711823100008],
              [-42.53416907499991, 62.482855536000045],
              [-42.55190995999993, 62.48582591400003],
              [-42.55768795499995, 62.48334381700005],
              [-42.55382239499994, 62.47760651200008],
              [-42.54173743399991, 62.468451239000046],
              [-42.530140753999945, 62.46503327000005],
              [-42.505970831999946, 62.46596914300005],
              [-42.49388587099992, 62.46478913000004],
              [-42.433705206999946, 62.440741278000075],
              [-42.411366339999915, 62.43744538000004],
              [-42.396595831999946, 62.43231842700004],
              [-42.386382615999935, 62.42255280200004],
              [-42.375070766999954, 62.41681549700007],
              [-42.356760219999956, 62.423814195000034],
              [-42.359486456999946, 62.42755768400008],
              [-42.36359615799995, 62.43744538000004],
              [-42.34064693899995, 62.44163646000004],
              [-42.25373287699995, 62.43744538000004],
              [-42.25658118399991, 62.433579820000034],
              [-42.26113847599993, 62.423814195000034],
              [-42.24323482999995, 62.41498444200005],
              [-42.24461829299992, 62.40485260600008],
              [-42.25763912699995, 62.39394765800006],
              [-42.27415930899991, 62.382879950000074],
              [-42.248117641999954, 62.388006903000075],
              [-42.16437740799995, 62.390326239000046],
              [-42.16437740799995, 62.382879950000074],
              [-42.22411048099991, 62.36749909100007],
              [-42.25438391799992, 62.363714911000045],
              [-42.277333136999914, 62.37323639500005],
              [-42.33934485599991, 62.37669505400004],
              [-42.41624915299991, 62.39398834800005],
              [-42.43602454299992, 62.40387604400007],
              [-42.46666419199994, 62.41079336100006],
              [-42.47215735599991, 62.415228583000044],
              [-42.482411261999914, 62.42792389500005],
              [-42.48713131399995, 62.43121979400007],
              [-42.50210527299993, 62.43183014500005],
              [-42.53184973899994, 62.424261786000045],
              [-42.548491990999935, 62.423814195000034],
              [-42.56460527299993, 62.42959219000005],
              [-42.60997473899994, 62.45917389500005],
              [-42.632801886999914, 62.46344635600008],
              [-42.65684973899994, 62.46381256700005],
              [-42.67983964799993, 62.46674225500004],
              [-42.69937089799993, 62.47842031500005],
              [-42.696603969999956, 62.48236725500004],
              [-42.69188391799992, 62.49274323100008],
              [-42.73306230399993, 62.503973700000074],
              [-42.75182044199994, 62.50263092700004],
              [-42.77163652299993, 62.48932526200008],
              [-42.78856360599991, 62.486761786000045],
              [-42.85700436099995, 62.51316966400003],
              [-42.934437628999945, 62.51581452000005],
              [-42.95978756399995, 62.52374909100007],
              [-42.97402910099993, 62.52484772300005],
              [-42.975453253999945, 62.51040273600006],
              [-42.97402910099993, 62.49135976800005],
              [-42.97988847599993, 62.47842031500005],
              [-42.96458899599992, 62.47304922100005],
              [-42.94806881399995, 62.47443268400008],
              [-42.93049068899995, 62.477769273000035],
              [-42.91161048099991, 62.47842031500005],
              [-42.76154537699995, 62.432806708000044],
              [-42.67686926999994, 62.393011786000045],
              [-42.659047003999945, 62.38825104400007],
              [-42.65099036399994, 62.382879950000074],
              [-42.64561926999994, 62.37563711100006],
              [-42.64045162699995, 62.36123281500005],
              [-42.63731848899994, 62.355536200000074],
              [-42.623036261999914, 62.34284088700008],
              [-42.607980923999946, 62.33649323100008],
              [-42.59048417899993, 62.33445872600004],
              [-42.41197669199994, 62.349310614000046],
              [-42.40111243399991, 62.34174225500004],
              [-42.34935462099992, 62.32143789300005],
              [-42.32872473899994, 62.31659577000005],
              [-42.26113847599993, 62.31460195500006],
              [-42.270090298999946, 62.29962799700007],
              [-42.28473873599995, 62.292954820000034],
              [-42.30125891799992, 62.28856028900003],
              [-42.31578528599994, 62.280462958000044],
              [-42.327056443999936, 62.267645575000074],
              [-42.32494055899991, 62.26341380400004],
              [-42.29466712099992, 62.25995514500005],
              [-42.26748613199993, 62.24656810100004],
              [-42.25804602799991, 62.22748444200005],
              [-42.26317298099991, 62.20571523600006],
              [-42.28038489499994, 62.18423086100006],
              [-42.32046464799993, 62.15884023600006],
              [-42.32945716099994, 62.150091864000046],
              [-42.33141028599994, 62.13825104400007],
              [-42.32262122299994, 62.13471100500004],
              [-42.31045488199993, 62.132025458000044],
              [-42.30211341099994, 62.122748114000046],
              [-42.312163865999935, 62.103216864000046],
              [-42.34561113199993, 62.09638092700004],
              [-42.384836391999954, 62.09414297100005],
              [-42.41197669199994, 62.08860911700003],
              [-42.39098059799994, 62.07770416900007],
              [-42.384022589999915, 62.07493724200003],
              [-42.40021725199995, 62.06537506700005],
              [-42.411000128999945, 62.05658600500004],
              [-42.42373613199993, 62.05019765800006],
              [-42.50328528599994, 62.044623114000046],
              [-42.52122962099992, 62.040228583000044],
              [-42.49689693899995, 62.03188711100006],
              [-42.43399003799993, 62.025458075000074],
              [-42.41812089799993, 62.012884833000044],
              [-42.48668372299994, 61.985541083000044],
              [-42.548491990999935, 61.95148346600007],
              [-42.49592037699995, 61.942572333000044],
              [-42.43858801999994, 61.96710846600007],
              [-42.38145911399994, 62.00079987200007],
              [-42.32945716099994, 62.01972077000005],
              [-42.148101365999935, 62.02374909100007],
              [-42.117176886999914, 62.006740627000056],
              [-42.125070766999954, 61.99017975500004],
              [-42.16844641799992, 61.96401601800005],
              [-42.18724524599992, 61.93024323100008],
              [-42.20860755099994, 61.92023346600007],
              [-42.23550370999993, 61.91624583500004],
              [-42.38711503799993, 61.92413971600007],
              [-42.41576087099992, 61.92059967700004],
              [-42.403553839999915, 61.91225820500006],
              [-42.34312903599994, 61.89687734600005],
              [-42.22638912699995, 61.88939036700003],
              [-42.22638912699995, 61.88320547100005],
              [-42.237172003999945, 61.88336823100008],
              [-42.24449622299994, 61.882147528000075],
              [-42.24962317599994, 61.878119208000044],
              [-42.25373287699995, 61.869574286000045],
              [-42.192250128999945, 61.869574286000045],
              [-42.19684811099995, 61.86151764500005],
              [-42.204335089999915, 61.85150788000004],
              [-42.219593878999945, 61.83539459800005],
              [-42.25499426999994, 61.81818268400008],
              [-42.26427161399994, 61.81118398600006],
              [-42.281320766999954, 61.79238515800006],
              [-42.29784094999991, 61.77871328300006],
              [-42.317290818999936, 61.768459377000056],
              [-42.34312903599994, 61.75971100500004],
              [-42.37144934799994, 61.75340403900003],
              [-42.55801347599993, 61.73655833500004],
              [-42.589507615999935, 61.73859284100007],
              [-42.602772589999915, 61.742173570000034],
              [-42.63731848899994, 61.75971100500004],
              [-42.68382727799991, 61.77643463700008],
              [-42.69566809799994, 61.78359609600005],
              [-42.70815995999993, 61.789129950000074],
              [-42.72541256399995, 61.79328034100007],
              [-42.74058997299994, 61.79950592700004],
              [-42.75348873599995, 61.82062409100007],
              [-42.768137173999946, 61.82172272300005],
              [-42.78433183499993, 61.818426825000074],
              [-42.840687628999945, 61.79677969000005],
              [-42.861317511999914, 61.78392161700003],
              [-42.870025193999936, 61.76992422100005],
              [-42.855580206999946, 61.77024974200003],
              [-42.76829993399991, 61.78701406500005],
              [-42.62010657499991, 61.71088288000004],
              [-42.59361731699994, 61.70380280200004],
              [-42.41930091099994, 61.69989655200004],
              [-42.384022589999915, 61.705064195000034],
              [-42.31895911399994, 61.726629950000074],
              [-42.28355872299994, 61.72833893400008],
              [-42.25373287699995, 61.71124909100007],
              [-42.380848761999914, 61.68744538000004],
              [-42.392689581999946, 61.682847398000035],
              [-42.397694464999915, 61.67401764500005],
              [-42.393869594999956, 61.66087474200003],
              [-42.38390051999994, 61.65688711100006],
              [-42.356760219999956, 61.656683661000045],
              [-42.33307857999995, 61.648423570000034],
              [-42.32103430899991, 61.63662344000005],
              [-42.325062628999945, 61.62449778900003],
              [-42.34935462099992, 61.615668036000045],
              [-42.37474524599992, 61.61709219000005],
              [-42.425770636999914, 61.633978583000044],
              [-42.45299231699994, 61.63613515800006],
              [-42.41323808499993, 61.626939195000034],
              [-42.392567511999914, 61.61961497600004],
              [-42.37726803299995, 61.60883209800005],
              [-42.46666419199994, 61.615668036000045],
              [-42.44041907499991, 61.58706289300005],
              [-42.42943274599992, 61.56903717700004],
              [-42.435536261999914, 61.56102122600004],
              [-42.527455206999946, 61.56102122600004],
              [-42.61343339799993, 61.54682038000004],
              [-42.63719641799992, 61.54901764500005],
              [-42.683664516999954, 61.55878327000005],
              [-42.86758378799993, 61.563788153000075],
              [-42.94762122299994, 61.59088776200008],
              [-42.99885006399995, 61.60008372600004],
              [-43.04942786399994, 61.602728583000044],
              [-43.082915818999936, 61.59520091400003],
              [-42.96564693899995, 61.56240469000005],
              [-42.94640051999994, 61.550482489000046],
              [-42.93122311099995, 61.530585028000075],
              [-42.85309811099995, 61.543402411000045],
              [-42.79063880099994, 61.52826569200005],
              [-42.527455206999946, 61.53375885600008],
              [-42.54161536399994, 61.496161200000074],
              [-42.548491990999935, 61.48533763200004],
              [-42.53062903599994, 61.47211334800005],
              [-42.52301998599995, 61.45302969000005],
              [-42.511057094999956, 61.436428127000056],
              [-42.48029537699995, 61.43073151200008],
              [-42.46654212099992, 61.43398672100005],
              [-42.43883216099994, 61.444525458000044],
              [-42.42564856699994, 61.44432200700004],
              [-42.418853318999936, 61.43935781500005],
              [-42.40453040299991, 61.41640859600005],
              [-42.41812089799993, 61.402777411000045],
              [-42.43663489499994, 61.41225820500006],
              [-42.45225989499994, 61.41425202000005],
              [-42.46642005099994, 61.410589911000045],
              [-42.48029537699995, 61.402777411000045],
              [-42.48106848899994, 61.40053945500006],
              [-42.49388587099992, 61.38296133000006],
              [-42.499256964999915, 61.37832265800006],
              [-42.50495357999995, 61.376288153000075],
              [-42.506703253999945, 61.37409088700008],
              [-42.500111456999946, 61.36928945500006],
              [-42.500111456999946, 61.36180247600004],
              [-42.52904212099992, 61.35639069200005],
              [-42.58088131399995, 61.35431549700007],
              [-42.59239661399994, 61.35236237200007],
              [-42.60374915299991, 61.34813060100004],
              [-42.60374915299991, 61.34129466400003],
              [-42.58348548099991, 61.341009833000044],
              [-42.58023027299993, 61.33478424700007],
              [-42.59032141799992, 61.32664622600004],
              [-42.60997473899994, 61.32086823100008],
              [-42.67284094999991, 61.31989166900007],
              [-42.69188391799992, 61.31403229400007],
              [-42.67821204299992, 61.30805084800005],
              [-42.66291256399995, 61.30377838700008],
              [-42.64679928299995, 61.30133698100008],
              [-42.63048255099994, 61.30097077000005],
              [-42.63048255099994, 61.29352448100008],
              [-42.70750891799992, 61.29181549700007],
              [-42.85586503799993, 61.33730703300006],
              [-42.93211829299992, 61.34129466400003],
              [-42.967640753999945, 61.33820221600007],
              [-43.20946204299992, 61.351629950000074],
              [-43.248117641999954, 61.34129466400003],
              [-43.22052975199995, 61.331691799000055],
              [-42.886057094999956, 61.310248114000046],
              [-42.775054490999935, 61.27985260600008],
              [-42.775054490999935, 61.273098049000055],
              [-42.80626380099994, 61.26715729400007],
              [-42.84715735599991, 61.26752350500004],
              [-42.88451087099992, 61.26390208500004],
              [-42.90538489499994, 61.245754299000055],
              [-42.79564368399991, 61.24754466400003],
              [-42.77163652299993, 61.25600820500006],
              [-42.74819902299993, 61.26829661700003],
              [-42.719960089999915, 61.26947663000004],
              [-42.66519120999993, 61.259426174000055],
              [-42.65835527299993, 61.259426174000055],
              [-42.66075598899994, 61.25568268400008],
              [-42.66519120999993, 61.245754299000055],
              [-42.64879309799994, 61.24526601800005],
              [-42.64037024599992, 61.23773834800005],
              [-42.63329016799992, 61.228949286000045],
              [-42.62059485599991, 61.224595445000034],
              [-42.60326087099992, 61.22304922100005],
              [-42.59227454299992, 61.218003648000035],
              [-42.58421790299991, 61.20945872600004],
              [-42.575835740999935, 61.197333075000074],
              [-42.73289954299992, 61.197333075000074],
              [-42.73965410099993, 61.194973049000055],
              [-42.75487219999991, 61.185980536000045],
              [-42.76085364499994, 61.183661200000074],
              [-42.77000891799992, 61.18439362200007],
              [-42.79088294199994, 61.18984609600005],
              [-42.819569464999915, 61.19358958500004],
              [-42.847767706999946, 61.20600006700005],
              [-42.86388098899994, 61.211004950000074],
              [-42.910145636999914, 61.216131903000075],
              [-42.93537350199995, 61.21507396000004],
              [-42.94640051999994, 61.20758698100008],
              [-42.95767167899993, 61.204331773000035],
              [-43.17918860599991, 61.218451239000046],
              [-43.17918860599991, 61.211004950000074],
              [-43.14273027299993, 61.212103583000044],
              [-42.86953691299993, 61.17479075700004],
              [-42.83340410099993, 61.161363023000035],
              [-42.76203365799995, 61.14398834800005],
              [-42.74376380099994, 61.14272695500006],
              [-42.734364386999914, 61.14427317900004],
              [-42.71662350199995, 61.150051174000055],
              [-42.70616614499994, 61.14956289300005],
              [-42.698150193999936, 61.14508698100008],
              [-42.695301886999914, 61.13890208500004],
              [-42.69440670499995, 61.13296133000006],
              [-42.69188391799992, 61.12909577000005],
              [-42.63048255099994, 61.108587958000044],
              [-42.63048255099994, 61.10114166900007],
              [-42.781320766999954, 61.108587958000044],
              [-42.85289466099994, 61.12250397300005],
              [-42.889556443999936, 61.124253648000035],
              [-42.90538489499994, 61.11163971600007],
              [-42.92568925699993, 61.10415273600006],
              [-43.17100989499994, 61.13178131700005],
              [-43.20645097599993, 61.12221914300005],
              [-43.22447669199994, 61.128241278000075],
              [-43.30235755099994, 61.12221914300005],
              [-43.51626542899993, 61.147365627000056],
              [-43.57201087099992, 61.14524974200003],
              [-43.61115475199995, 61.12909577000005],
              [-43.580067511999914, 61.119208075000074],
              [-43.507923956999946, 61.12571849200003],
              [-43.45653235599991, 61.115301825000074],
              [-43.41588294199994, 61.11713288000004],
              [-43.40135657499991, 61.11163971600007],
              [-43.385650193999936, 61.10346100500004],
              [-43.36465410099993, 61.10053131700005],
              [-43.164133266999954, 61.109442450000074],
              [-43.15868079299992, 61.108587958000044],
              [-43.15404212099992, 61.10521067900004],
              [-43.150380011999914, 61.096136786000045],
              [-43.14781653599994, 61.09430573100008],
              [-43.096587693999936, 61.09430573100008],
              [-43.10342363199993, 61.10114166900007],
              [-43.07713782499991, 61.091864325000074],
              [-43.01524817599994, 61.08860911700003],
              [-42.98737545499995, 61.081244208000044],
              [-42.999663865999935, 61.06395091400003],
              [-43.00633704299992, 61.058294989000046],
              [-43.01471920499995, 61.053941148000035],
              [-42.99132239499994, 61.054348049000055],
              [-42.94131425699993, 61.06976959800005],
              [-42.91502844999991, 61.07379791900007],
              [-42.86351477799991, 61.071519273000035],
              [-42.84276282499991, 61.065659898000035],
              [-42.82286536399994, 61.053941148000035],
              [-42.803578253999945, 61.06464264500005],
              [-42.76992753799993, 61.070379950000074],
              [-42.733631964999915, 61.06948476800005],
              [-42.70616614499994, 61.06012604400007],
              [-42.72325598899994, 61.05540599200003],
              [-42.74156653599994, 61.05487702000005],
              [-42.75772050699993, 61.051988023000035],
              [-42.76829993399991, 61.040269273000035],
              [-42.74795488199993, 61.036037502000056],
              [-42.70539303299995, 61.03660716400003],
              [-42.68569902299993, 61.032863674000055],
              [-42.67251542899993, 61.02513255400004],
              [-42.668812628999945, 61.01703522300005],
              [-42.675038214999915, 61.00995514500005],
              [-42.69188391799992, 61.005560614000046],
              [-42.69188391799992, 60.999335028000075],
              [-42.66665605399993, 60.99868398600006],
              [-42.65835527299993, 60.999335028000075],
              [-42.69774329299992, 60.98261139500005],
              [-42.73737545499995, 60.99994538000004],
              [-42.77334550699993, 61.02204010600008],
              [-42.80182857999995, 61.01984284100007],
              [-42.807199673999946, 61.010931708000044],
              [-42.805897589999915, 61.003119208000044],
              [-42.80016028599994, 60.99599844000005],
              [-42.791859503999945, 60.98875560100004],
              [-42.78673255099994, 60.97947825700004],
              [-42.79092363199993, 60.97089264500005],
              [-42.79800370999993, 60.96271393400008],
              [-42.80182857999995, 60.954291083000044],
              [-42.79198157499991, 60.94757721600007],
              [-42.726673956999946, 60.93040599200003],
              [-42.97988847599993, 60.895697333000044],
              [-42.97988847599993, 60.88947174700007],
              [-43.027455206999946, 60.88157786700003],
              [-43.209868943999936, 60.91681549700007],
              [-43.29991614499994, 60.91986725500004],
              [-43.42943274599992, 60.94741445500006],
              [-43.46312415299991, 60.950873114000046],
              [-43.47695878799993, 60.94839101800005],
              [-43.48184160099993, 60.94155508000006],
              [-43.48082434799994, 60.91986725500004],
              [-43.47728430899991, 60.91079336100006],
              [-43.46861731699994, 60.91063060100004],
              [-43.45738684799994, 60.91437409100007],
              [-43.44635982999995, 60.91681549700007],
              [-43.13385982999995, 60.880845445000034],
              [-43.10342363199993, 60.86155833500004],
              [-43.11213131399995, 60.85993073100008],
              [-43.11754309799994, 60.85805898600006],
              [-43.121164516999954, 60.85447825700004],
              [-43.12458248599995, 60.84788646000004],
              [-43.09312903599994, 60.85716380400004],
              [-43.06094316299993, 60.858587958000044],
              [-42.88508053299995, 60.845404364000046],
              [-42.85700436099995, 60.834865627000056],
              [-42.86388098899994, 60.827378648000035],
              [-42.848866339999915, 60.82176341400003],
              [-42.834095831999946, 60.82318756700005],
              [-42.81871497299994, 60.82680898600006],
              [-42.807077602999925, 60.82721588700008],
              [-42.78612219999991, 60.82453034100007],
              [-42.78575598899994, 60.81500885600008],
              [-42.80113684799994, 60.80483633000006],
              [-42.82599850199995, 60.800116278000075],
              [-42.92162024599992, 60.792669989000046],
              [-43.12458248599995, 60.827378648000035],
              [-43.50377356699994, 60.84821198100008],
              [-43.52798417899993, 60.841009833000044],
              [-43.51720130099994, 60.83344147300005],
              [-43.506418423999946, 60.82982005400004],
              [-43.41161048099991, 60.827378648000035],
              [-43.397043423999946, 60.82514069200005],
              [-43.36620032499991, 60.81537506700005],
              [-43.35020911399994, 60.81313711100006],
              [-43.296538865999935, 60.81195709800005],
              [-43.28156490799995, 60.80695221600007],
              [-43.273996548999946, 60.799994208000044],
              [-43.272328253999945, 60.79319896000004],
              [-43.27379309799994, 60.78823476800005],
              [-43.275380011999914, 60.786444403000075],
              [-43.26309160099993, 60.78143952000005],
              [-43.24901282499991, 60.77977122600004],
              [-43.23501542899993, 60.78221263200004],
              [-43.22325598899994, 60.78953685100004],
              [-43.20026607999995, 60.79743073100008],
              [-43.08975175699993, 60.800116278000075],
              [-42.97337805899991, 60.786444403000075],
              [-42.960926886999914, 60.78335195500006],
              [-42.92837480399993, 60.76654694200005],
              [-42.856312628999945, 60.75641510600008],
              [-42.82286536399994, 60.74481842700004],
              [-42.80650794199994, 60.74506256700005],
              [-42.795480923999946, 60.74762604400007],
              [-42.78538977799991, 60.74628327000005],
              [-42.77163652299993, 60.73493073100008],
              [-42.778960740999935, 60.72630442900004],
              [-42.83653723899994, 60.684027411000045],
              [-42.87962805899991, 60.66351959800005],
              [-42.93272864499994, 60.65078359600005],
              [-42.98729407499991, 60.64858633000006],
              [-43.06102454299992, 60.66640859600005],
              [-43.275380011999914, 60.67658112200007],
              [-43.26109778599994, 60.66111888200004],
              [-43.24132239499994, 60.656236070000034],
              [-43.19961503799993, 60.656683661000045],
              [-42.90538489499994, 60.62132396000004],
              [-42.90538489499994, 60.62872955900008],
              [-42.924672003999945, 60.635646877000056],
              [-42.924672003999945, 60.64305247600004],
              [-42.90013587099992, 60.64988841400003],
              [-42.852121548999946, 60.67182038000004],
              [-42.823475714999915, 60.67869700700004],
              [-42.803578253999945, 60.68805573100008],
              [-42.791859503999945, 60.69017161700003],
              [-42.74718176999994, 60.69017161700003],
              [-42.76707923099991, 60.676214911000045],
              [-42.81867428299995, 60.65110911700003],
              [-42.82909094999991, 60.63934967700004],
              [-42.82396399599992, 60.618801174000055],
              [-42.826283331999946, 60.61127350500004],
              [-42.88817298099991, 60.60175202000005],
              [-43.14439856699994, 60.608303127000056],
              [-43.14439856699994, 60.60146719000005],
              [-43.10704505099994, 60.59202708500004],
              [-42.980580206999946, 60.59406159100007],
              [-42.86583411399994, 60.57949453300006],
              [-42.82909094999991, 60.58038971600007],
              [-42.84715735599991, 60.56785716400003],
              [-42.86790930899991, 60.567694403000075],
              [-42.889881964999915, 60.572333075000074],
              [-42.91161048099991, 60.57416413000004],
              [-42.92833411399994, 60.56899648600006],
              [-42.96007239499994, 60.550767320000034],
              [-42.97679602799991, 60.54682038000004],
              [-43.14439856699994, 60.54682038000004],
              [-43.126942511999914, 60.529364325000074],
              [-43.09434973899994, 60.52374909100007],
              [-43.02839107999995, 60.52578359600005],
              [-43.04454505099994, 60.507879950000074],
              [-43.075062628999945, 60.50263092700004],
              [-43.109486456999946, 60.506293036000045],
              [-43.16978919199994, 60.52814362200007],
              [-43.18590247299994, 60.53766510600008],
              [-43.19286048099991, 60.54995351800005],
              [-43.20034745999993, 60.55329010600008],
              [-43.23477128799993, 60.54433828300006],
              [-43.24437415299991, 60.54315827000005],
              [-43.27306067599994, 60.55744049700007],
              [-43.30109615799995, 60.557521877000056],
              [-43.30850175699993, 60.54596588700008],
              [-43.275380011999914, 60.52578359600005],
              [-43.16441809799994, 60.49567291900007],
              [-43.14439856699994, 60.47797272300005],
              [-43.227447068999936, 60.47089264500005],
              [-43.51431230399993, 60.53432851800005],
              [-43.54430091099994, 60.54474518400008],
              [-43.56883704299992, 60.56037018400008],
              [-43.64273027299993, 60.626654364000046],
              [-43.66641191299993, 60.65497467700004],
              [-43.66576087099992, 60.67658112200007],
              [-43.66860917899993, 60.689520575000074],
              [-43.675892706999946, 60.71035390800006],
              [-43.68919837099992, 60.72370026200008],
              [-43.710194464999915, 60.71474844000005],
              [-43.71251380099994, 60.69708893400008],
              [-43.702381964999915, 60.67234935100004],
              [-43.688343878999945, 60.64911530200004],
              [-43.626616990999935, 60.570013739000046],
              [-43.620757615999935, 60.559881903000075],
              [-43.65892493399991, 60.55304596600007],
              [-43.67650305899991, 60.55499909100007],
              [-43.70970618399991, 60.56419505400004],
              [-44.08429928299995, 60.59357330900008],
              [-44.10773678299995, 60.60488515800006],
              [-44.14411373599995, 60.63922760600008],
              [-44.17015540299991, 60.651597398000035],
              [-44.19273841099994, 60.64305247600004],
              [-44.186390753999945, 60.62872955900008],
              [-44.165272589999915, 60.615301825000074],
              [-44.15977942599994, 60.60537344000005],
              [-44.20018469999991, 60.60146719000005],
              [-44.16388912699995, 60.57591380400004],
              [-44.02574622299994, 60.572251695000034],
              [-43.97362219999991, 60.56362539300005],
              [-43.94481360599991, 60.55385976800005],
              [-43.87987219999991, 60.54645416900007],
              [-43.850168423999946, 60.53937409100007],
              [-43.82949785099993, 60.526556708000044],
              [-43.81700598899994, 60.51040273600006],
              [-43.80736243399991, 60.49331289300005],
              [-43.79552161399994, 60.47797272300005],
              [-43.79552161399994, 60.471136786000045],
              [-43.82579505099994, 60.45453522300005],
              [-43.83706620999993, 60.45062897300005],
              [-43.804758266999954, 60.44281647300005],
              [-43.78555253799993, 60.45209381700005],
              [-43.78172766799992, 60.47260163000004],
              [-43.79552161399994, 60.49843984600005],
              [-43.769602016999954, 60.52334219000005],
              [-43.72533118399991, 60.525458075000074],
              [-43.42756100199995, 60.48314036700003],
              [-43.33731035099993, 60.45892975500004],
              [-43.327788865999935, 60.45416901200008],
              [-43.31944739499994, 60.44721100500004],
              [-43.31541907499991, 60.437486070000034],
              [-43.32290605399993, 60.43333567900004],
              [-43.343006964999915, 60.43081289300005],
              [-43.46629798099991, 60.39476146000004],
              [-43.48704993399991, 60.38239166900007],
              [-43.47765051999994, 60.380845445000034],
              [-43.47175045499995, 60.37840403900003],
              [-43.45978756399995, 60.36810944200005],
              [-43.54002844999991, 60.349269924000055],
              [-43.568918423999946, 60.33197663000004],
              [-43.58177649599992, 60.327337958000044],
              [-43.592681443999936, 60.32176341400003],
              [-43.59683183499993, 60.31346263200004],
              [-43.591135219999956, 60.30646393400008],
              [-43.579416469999956, 60.309881903000075],
              [-43.56602942599994, 60.31704336100006],
              [-43.555572068999936, 60.32094961100006],
              [-43.53001868399991, 60.325384833000044],
              [-43.45287024599992, 60.35504791900007],
              [-43.42564856699994, 60.35447825700004],
              [-43.38304602799991, 60.337144273000035],
              [-43.35728919199994, 60.33392975500004],
              [-43.36587480399993, 60.34259674700007],
              [-43.38508053299995, 60.35492584800005],
              [-43.39142818899995, 60.36127350500004],
              [-43.39891516799992, 60.37343984600005],
              [-43.39952551999994, 60.376654364000046],
              [-43.39435787699995, 60.37750885600008],
              [-43.36628170499995, 60.39118073100008],
              [-43.314116990999935, 60.40102773600006],
              [-43.17528235599991, 60.400091864000046],
              [-43.173817511999914, 60.395412502000056],
              [-43.18858801999994, 60.390692450000074],
              [-43.21328691299993, 60.38857656500005],
              [-43.15493730399993, 60.36810944200005],
              [-43.150949673999946, 60.366115627000056],
              [-43.15416419199994, 60.36155833500004],
              [-43.16124426999994, 60.357123114000046],
              [-43.16856848899994, 60.35504791900007],
              [-43.20645097599993, 60.35504791900007],
              [-43.32453365799995, 60.38043854400007],
              [-43.35728919199994, 60.37555573100008],
              [-43.32827714799993, 60.35101959800005],
              [-43.31944739499994, 60.34760163000004],
              [-43.306752081999946, 60.349676825000074],
              [-43.294911261999914, 60.353501695000034],
              [-43.282460089999915, 60.35537344000005],
              [-43.16551673099991, 60.31346263200004],
              [-43.15111243399991, 60.32697174700007],
              [-43.13703365799995, 60.32709381700005],
              [-43.10342363199993, 60.31346263200004],
              [-43.11546790299991, 60.29718659100007],
              [-43.13219153599994, 60.28656647300005],
              [-43.15343176999994, 60.28070709800005],
              [-43.17918860599991, 60.27871328300006],
              [-43.110991990999935, 60.26593659100007],
              [-43.08975175699993, 60.25885651200008],
              [-43.09919186099995, 60.24371979400007],
              [-43.112212693999936, 60.239447333000044],
              [-43.20889238199993, 60.250881252000056],
              [-43.22630774599992, 60.25885651200008],
              [-43.25064042899993, 60.24494049700007],
              [-43.30410722599993, 60.229396877000056],
              [-43.32998613199993, 60.217230536000045],
              [-43.28620357999995, 60.21198151200008],
              [-43.15684973899994, 60.21503327000005],
              [-43.12458248599995, 60.19676341400003],
              [-43.135609503999945, 60.19765859600005],
              [-43.14622962099992, 60.197251695000034],
              [-43.156320766999954, 60.19505442900004],
              [-43.16551673099991, 60.190619208000044],
              [-43.12450110599991, 60.18305084800005],
              [-43.110259568999936, 60.18374258000006],
              [-43.11864173099991, 60.17255280200004],
              [-43.123605923999946, 60.167222398000035],
              [-43.13076738199993, 60.16266510600008],
              [-43.110259568999936, 60.15582916900007],
              [-43.13703365799995, 60.148504950000074],
              [-43.16112219999991, 60.15521881700005],
              [-43.18394934799994, 60.16575755400004],
              [-43.20645097599993, 60.17011139500005],
              [-43.20645097599993, 60.16266510600008],
              [-43.19579016799992, 60.154730536000045],
              [-43.193918423999946, 60.14671458500004],
              [-43.20002193899995, 60.139878648000035],
              [-43.21328691299993, 60.13532135600008],
              [-43.19701087099992, 60.134100653000075],
              [-43.168853318999936, 60.12417226800005],
              [-43.15493730399993, 60.12164948100008],
              [-43.14712480399993, 60.123928127000056],
              [-43.14000403599994, 60.12836334800005],
              [-43.130848761999914, 60.13125234600005],
              [-43.11705481699994, 60.12909577000005],
              [-43.10619055899991, 60.122381903000075],
              [-43.09337317599994, 60.110581773000035],
              [-43.08812415299991, 60.09935130400004],
              [-43.10000566299993, 60.09438711100006],
              [-43.11302649599992, 60.09247467700004],
              [-43.12865149599992, 60.08348216400003],
              [-43.13817298099991, 60.08075592700004],
              [-43.163400844999956, 60.08152903900003],
              [-43.248117641999954, 60.09438711100006],
              [-43.30931555899991, 60.09560781500005],
              [-43.33967037699995, 60.101548570000034],
              [-43.36351477799991, 60.11481354400007],
              [-43.388742641999954, 60.10781484600005],
              [-43.48704993399991, 60.13532135600008],
              [-43.55451412699995, 60.13418203300006],
              [-43.58885657499991, 60.138373114000046],
              [-43.60374915299991, 60.15273672100005],
              [-43.60610917899993, 60.16278717700004],
              [-43.611887173999946, 60.175034898000035],
              [-43.61864173099991, 60.185614325000074],
              [-43.624256964999915, 60.190619208000044],
              [-43.642648891999954, 60.19135163000004],
              [-43.64801998599995, 60.18431224200003],
              [-43.644642706999946, 60.16632721600007],
              [-43.66063391799992, 60.154282945000034],
              [-43.69701087099992, 60.15607330900008],
              [-43.76195227799991, 60.17011139500005],
              [-43.78107662699995, 60.16225820500006],
              [-43.80687415299991, 60.16038646000004],
              [-43.94041907499991, 60.17446523600006],
              [-43.99058997299994, 60.19086334800005],
              [-44.141835089999915, 60.18374258000006],
              [-44.15575110599991, 60.179388739000046],
              [-44.16588294199994, 60.173163153000075],
              [-44.17170162699995, 60.17552317900004],
              [-44.17292232999995, 60.19676341400003],
              [-44.168039516999954, 60.21141185100004],
              [-44.157134568999936, 60.223089911000045],
              [-44.14370683499993, 60.23200104400007],
              [-43.99474036399994, 60.306626695000034],
              [-43.99474036399994, 60.31346263200004],
              [-44.04198157499991, 60.312567450000074],
              [-44.05451412699995, 60.320298570000034],
              [-44.06362870999993, 60.34137604400007],
              [-44.063791469999956, 60.34935130400004],
              [-44.061431443999936, 60.35541413000004],
              [-44.06102454299992, 60.36196523600006],
              [-44.06676184799994, 60.37181224200003],
              [-44.07762610599991, 60.38165924700007],
              [-44.08942623599995, 60.38703034100007],
              [-44.100819464999915, 60.38739655200004],
              [-44.11082923099991, 60.38239166900007],
              [-44.08706620999993, 60.35008372600004],
              [-44.082875128999945, 60.34137604400007],
              [-44.086008266999954, 60.33315664300005],
              [-44.09276282499991, 60.321478583000044],
              [-44.09727942599994, 60.31118398600006],
              [-44.093739386999914, 60.306626695000034],
              [-44.083648240999935, 60.30231354400007],
              [-44.087147589999915, 60.292669989000046],
              [-44.09825598899994, 60.28302643400008],
              [-44.111439581999946, 60.27871328300006],
              [-44.123890753999945, 60.27610911700003],
              [-44.13711503799993, 60.26947663000004],
              [-44.14948482999995, 60.26068756700005],
              [-44.15925045499995, 60.25141022300005],
              [-44.17804928299995, 60.278998114000046],
              [-44.21239173099991, 60.31207916900007],
              [-44.248931443999936, 60.33543528900003],
              [-44.274647589999915, 60.33392975500004],
              [-44.266468878999945, 60.317287502000056],
              [-44.230580206999946, 60.282416083000044],
              [-44.22411048099991, 60.26870351800005],
              [-44.22085527299993, 60.249335028000075],
              [-44.22419186099995, 60.23216380400004],
              [-44.23741614499994, 60.224676825000074],
              [-44.30549068899995, 60.237494208000044],
              [-44.31688391799992, 60.238348700000074],
              [-44.31541907499991, 60.224676825000074],
              [-44.29751542899993, 60.212591864000046],
              [-44.26162675699993, 60.19676341400003],
              [-44.26162675699993, 60.190619208000044],
              [-44.29076087099992, 60.16620514500005],
              [-44.308583136999914, 60.155585028000075],
              [-44.32994544199994, 60.149603583000044],
              [-44.352772589999915, 60.14940013200004],
              [-44.40135657499991, 60.155503648000035],
              [-44.42613684799994, 60.15582916900007],
              [-44.45775305899991, 60.14557526200008],
              [-44.481312628999945, 60.12372467700004],
              [-44.496083136999914, 60.09479401200008],
              [-44.501210089999915, 60.06329987200007],
              [-44.51549231699994, 60.03880442900004],
              [-44.54946855399993, 60.00999583500004],
              [-44.59019934799994, 59.98908112200007],
              [-44.62441972599993, 59.987941799000055],
              [-44.65721594999991, 60.003241278000075],
              [-44.66832434799994, 60.015611070000034],
              [-44.67251542899993, 60.036037502000056],
              [-44.66551673099991, 60.08885325700004],
              [-44.665679490999935, 60.10736725500004],
              [-44.687611456999946, 60.10032786700003],
              [-44.70274817599994, 60.08978913000004],
              [-44.71133378799993, 60.07436758000006],
              [-44.714100714999915, 60.052801825000074],
              [-44.71271725199995, 60.02399323100008],
              [-44.71422278599994, 60.00726959800005],
              [-44.726633266999954, 59.99945709800005],
              [-44.75820878799993, 59.99750397300005],
              [-44.77814693899995, 60.00307851800005],
              [-44.80190995999993, 60.01658763200004],
              [-44.82188880099994, 60.033636786000045],
              [-44.83751380099994, 60.06492747600004],
              [-44.85423743399991, 60.08698151200008],
              [-44.87279212099992, 60.106756903000075],
              [-44.88536536399994, 60.11481354400007],
              [-44.878895636999914, 60.12441640800006],
              [-44.84447180899991, 60.149603583000044],
              [-44.871652798999946, 60.15387604400007],
              [-44.89818274599992, 60.14520905200004],
              [-44.91836503799993, 60.127386786000045],
              [-44.92638098899994, 60.10431549700007],
              [-44.90965735599991, 60.083970445000034],
              [-44.84544837099992, 60.04116445500006],
              [-44.84447180899991, 60.01927317900004],
              [-44.86766516799992, 60.03579336100006],
              [-44.94249426999994, 60.03156159100007],
              [-44.97484290299991, 60.03974030200004],
              [-44.962961391999954, 60.052435614000046],
              [-44.95372473899994, 60.066473700000074],
              [-44.96898352799991, 60.07257721600007],
              [-44.97484290299991, 60.073919989000046],
              [-44.97484290299991, 60.08075592700004],
              [-44.96812903599994, 60.078192450000074],
              [-44.94688880099994, 60.073919989000046],
              [-44.95494544199994, 60.08307526200008],
              [-44.97028561099995, 60.09088776200008],
              [-45.020415818999936, 60.10565827000005],
              [-45.03937740799995, 60.10736725500004],
              [-45.04918372299994, 60.10537344000005],
              [-45.05443274599992, 60.100897528000075],
              [-45.05724036399994, 60.09638092700004],
              [-45.059885219999956, 60.09438711100006],
              [-45.06749426999994, 60.09638092700004],
              [-45.09007727799991, 60.10537344000005],
              [-45.10114498599995, 60.10736725500004],
              [-45.11583411399994, 60.10342031500005],
              [-45.11481686099995, 60.09454987200007],
              [-45.10423743399991, 60.08539459800005],
              [-45.09024003799993, 60.08075592700004],
              [-45.10977128799993, 60.07050202000005],
              [-45.12922115799995, 60.07070547100005],
              [-45.17284094999991, 60.087551174000055],
              [-45.159047003999945, 60.103949286000045],
              [-45.070423956999946, 60.13532135600008],
              [-45.09007727799991, 60.14704010600008],
              [-45.08104407499991, 60.155585028000075],
              [-45.05801347599993, 60.16087474200003],
              [-44.93382727799991, 60.173163153000075],
              [-44.90855872299994, 60.181341864000046],
              [-44.755116339999915, 60.20425039300005],
              [-44.76146399599992, 60.218410549000055],
              [-44.772043423999946, 60.221584377000056],
              [-44.79942786399994, 60.217230536000045],
              [-44.80894934799994, 60.21401601800005],
              [-44.818348761999914, 60.208197333000044],
              [-44.82774817599994, 60.20526764500005],
              [-44.83702551999994, 60.21108633000006],
              [-44.83706620999993, 60.21743398600006],
              [-44.83242753799993, 60.22508372600004],
              [-44.81627356699994, 60.24481842700004],
              [-44.74209550699993, 60.27411530200004],
              [-44.73615475199995, 60.27997467700004],
              [-44.73460852799991, 60.29979075700004],
              [-44.729725714999915, 60.31513092700004],
              [-44.72240149599992, 60.32843659100007],
              [-44.71084550699993, 60.33783600500004],
              [-44.693348761999914, 60.34137604400007],
              [-44.62873287699995, 60.37457916900007],
              [-44.617298956999946, 60.38544342700004],
              [-44.610218878999945, 60.41079336100006],
              [-44.59093176999994, 60.43317291900007],
              [-44.56289628799993, 60.44806549700007],
              [-44.52916419199994, 60.45062897300005],
              [-44.532541469999956, 60.455145575000074],
              [-44.53453528599994, 60.45848216400003],
              [-44.537180141999954, 60.46149323100008],
              [-44.54283606699994, 60.464911200000074],
              [-44.51244055899991, 60.47516510600008],
              [-44.50133216099994, 60.48187897300005],
              [-44.501210089999915, 60.492254950000074],
              [-44.49233964799993, 60.498928127000056],
              [-44.46642005099994, 60.52578359600005],
              [-44.472645636999914, 60.537176825000074],
              [-44.47411048099991, 60.54857005400004],
              [-44.47175045499995, 60.559027411000045],
              [-44.46642005099994, 60.56732819200005],
              [-44.525502081999946, 60.49843984600005],
              [-44.553578253999945, 60.49359772300005],
              [-44.57750403599994, 60.48094310100004],
              [-44.617298956999946, 60.443793036000045],
              [-44.64159094999991, 60.409491278000075],
              [-44.65859941299993, 60.39057038000004],
              [-44.67625891799992, 60.38239166900007],
              [-44.70103919199994, 60.37726471600007],
              [-44.729359503999945, 60.36424388200004],
              [-44.755970831999946, 60.34642161700003],
              [-44.77554277299993, 60.32709381700005],
              [-44.79735266799992, 60.29791901200008],
              [-44.81346594999991, 60.28929271000004],
              [-44.840728318999936, 60.28620026200008],
              [-44.85924231699994, 60.27838776200008],
              [-44.86766516799992, 60.26032135600008],
              [-44.87205969999991, 60.23973216400003],
              [-44.878570115999935, 60.224676825000074],
              [-44.89631100199995, 60.21426015800006],
              [-44.950062628999945, 60.19912344000005],
              [-44.97109941299993, 60.19676341400003],
              [-45.05724036399994, 60.202337958000044],
              [-45.084095831999946, 60.19676341400003],
              [-45.11375891799992, 60.17674388200004],
              [-45.143137173999946, 60.150458075000074],
              [-45.173817511999914, 60.13361237200007],
              [-45.207590298999946, 60.14215729400007],
              [-45.198150193999936, 60.15542226800005],
              [-45.171945766999954, 60.171942450000074],
              [-45.15916907499991, 60.18374258000006],
              [-45.179351365999935, 60.18036530200004],
              [-45.19762122299994, 60.173895575000074],
              [-45.20685787699995, 60.17560455900008],
              [-45.20018469999991, 60.19676341400003],
              [-45.18732662699995, 60.21263255400004],
              [-45.14305579299992, 60.251206773000035],
              [-45.12877356699994, 60.25885651200008],
              [-45.11558997299994, 60.26312897300005],
              [-45.09239661399994, 60.28192780200004],
              [-45.080637173999946, 60.28620026200008],
              [-45.06871497299994, 60.28782786700003],
              [-45.00377356699994, 60.311835028000075],
              [-44.95152747299994, 60.31989166900007],
              [-44.92638098899994, 60.32709381700005],
              [-44.94200598899994, 60.34650299700007],
              [-44.93980872299994, 60.364569403000075],
              [-44.92650305899991, 60.38190338700008],
              [-44.909047003999945, 60.39911530200004],
              [-44.90343176999994, 60.40766022300005],
              [-44.89785722599993, 60.427069403000075],
              [-44.892241990999935, 60.43695709800005],
              [-44.883697068999936, 60.44525788000004],
              [-44.871083136999914, 60.45498281500005],
              [-44.84447180899991, 60.471136786000045],
              [-44.84447180899991, 60.47797272300005],
              [-44.89093990799995, 60.46820709800005],
              [-44.940337693999936, 60.464911200000074],
              [-44.953195766999954, 60.47064850500004],
              [-44.93887285099993, 60.483587958000044],
              [-44.816517706999946, 60.55646393400008],
              [-44.81236731699994, 60.56500885600008],
              [-44.80247962099992, 60.570298570000034],
              [-44.791127081999946, 60.57469310100004],
              [-44.78237870999993, 60.58038971600007],
              [-44.776275193999936, 60.59048086100006],
              [-44.76838131399995, 60.61163971600007],
              [-44.76130123599995, 60.62132396000004],
              [-44.772368943999936, 60.656236070000034],
              [-44.72679602799991, 60.687160549000055],
              [-44.62474524599992, 60.73114655200004],
              [-44.62413489499994, 60.735988674000055],
              [-44.62539628799993, 60.737534898000035],
              [-44.628163214999915, 60.73773834800005],
              [-44.63158118399991, 60.73867422100005],
              [-44.63902747299994, 60.73867422100005],
              [-44.71532141799992, 60.723822333000044],
              [-44.72716223899994, 60.71474844000005],
              [-44.741078253999945, 60.69476959800005],
              [-44.80260169199994, 60.68451569200005],
              [-44.816517706999946, 60.673163153000075],
              [-44.827463344999956, 60.63934967700004],
              [-44.84447180899991, 60.60146719000005],
              [-44.85814368399991, 60.58661530200004],
              [-44.87804114499994, 60.56915924700007],
              [-45.00035559799994, 60.49070872600004],
              [-45.04393469999991, 60.472316799000055],
              [-45.143137173999946, 60.458685614000046],
              [-45.18708248599995, 60.443793036000045],
              [-45.21422278599994, 60.43895091400003],
              [-45.239491339999915, 60.44196198100008],
              [-45.26244055899991, 60.45111725500004],
              [-45.28270423099991, 60.464911200000074],
              [-45.26744544199994, 60.47174713700008],
              [-45.24852454299992, 60.47797272300005],
              [-45.24852454299992, 60.48541901200008],
              [-45.26716061099995, 60.49437083500004],
              [-45.26012122299994, 60.50486888200004],
              [-45.24396725199995, 60.514837958000044],
              [-45.23485266799992, 60.522365627000056],
              [-45.23037675699993, 60.53929271000004],
              [-45.218861456999946, 60.55613841400003],
              [-45.20335852799991, 60.56903717700004],
              [-45.186756964999915, 60.57416413000004],
              [-45.16356360599991, 60.58633047100005],
              [-45.08299719999991, 60.64398834800005],
              [-45.06297766799992, 60.66290924700007],
              [-45.091867641999954, 60.65607330900008],
              [-45.17284094999991, 60.62132396000004],
              [-45.20177161399994, 60.63393789300005],
              [-45.21068274599992, 60.635646877000056],
              [-45.22248287699995, 60.63336823100008],
              [-45.23460852799991, 60.62848541900007],
              [-45.23997962099992, 60.62360260600008],
              [-45.21385657499991, 60.61505768400008],
              [-45.21117102799991, 60.60065338700008],
              [-45.21776282499991, 60.58478424700007],
              [-45.22809811099995, 60.57416413000004],
              [-45.24351966099994, 60.585191148000035],
              [-45.25503495999993, 60.59162018400008],
              [-45.26520748599995, 60.59096914300005],
              [-45.27647864499994, 60.58038971600007],
              [-45.27643795499995, 60.57648346600007],
              [-45.27513587099992, 60.570013739000046],
              [-45.27603105399993, 60.56191640800006],
              [-45.28270423099991, 60.55304596600007],
              [-45.29010982999995, 60.549709377000056],
              [-45.31753495999993, 60.541083075000074],
              [-45.35033118399991, 60.53510163000004],
              [-45.39366614499994, 60.51634349200003],
              [-45.43663489499994, 60.509833075000074],
              [-45.49559485599991, 60.492254950000074],
              [-45.483631964999915, 60.50560130400004],
              [-45.46056067599994, 60.521185614000046],
              [-45.43529212099992, 60.53400299700007],
              [-45.41641191299993, 60.53937409100007],
              [-45.398101365999935, 60.548488674000055],
              [-45.38731848899994, 60.56932200700004],
              [-45.379790818999936, 60.59247467700004],
              [-45.37144934799994, 60.608303127000056],
              [-45.32567298099991, 60.63471100500004],
              [-45.16661536399994, 60.67658112200007],
              [-45.129017706999946, 60.70209381700005],
              [-45.11388098899994, 60.71792226800005],
              [-45.121937628999945, 60.72500234600005],
              [-45.14586341099994, 60.720038153000075],
              [-45.213734503999945, 60.684027411000045],
              [-45.23843339799993, 60.67829010600008],
              [-45.30695553299995, 60.67658112200007],
              [-45.31427975199995, 60.686835028000075],
              [-45.31419837099992, 60.70783112200007],
              [-45.32144120999993, 60.72540924700007],
              [-45.35094153599994, 60.72500234600005],
              [-45.37437903599994, 60.70856354400007],
              [-45.37287350199995, 60.68817780200004],
              [-45.36546790299991, 60.667222398000035],
              [-45.37144934799994, 60.64923737200007],
              [-45.39635169199994, 60.64020416900007],
              [-45.427723761999914, 60.636379299000055],
              [-45.455189581999946, 60.62872955900008],
              [-45.46788489499994, 60.60883209800005],
              [-45.46637936099995, 60.582098700000074],
              [-45.46825110599991, 60.57416413000004],
              [-45.47752844999991, 60.56663646000004],
              [-45.48265540299991, 60.572333075000074],
              [-45.48550370999993, 60.58226146000004],
              [-45.48814856699994, 60.58783600500004],
              [-45.50267493399991, 60.58771393400008],
              [-45.50877844999991, 60.583970445000034],
              [-45.51545162699995, 60.56732819200005],
              [-45.51626542899993, 60.56268952000005],
              [-45.51463782499991, 60.55158112200007],
              [-45.51545162699995, 60.54682038000004],
              [-45.518869594999956, 60.542181708000044],
              [-45.52676347599993, 60.536037502000056],
              [-45.53823808499993, 60.52423737200007],
              [-45.556630011999914, 60.51251862200007],
              [-45.56383216099994, 60.505845445000034],
              [-45.56688391799992, 60.49591705900008],
              [-45.567250128999945, 60.484808661000045],
              [-45.570871548999946, 60.47553131700005],
              [-45.58372962099992, 60.471136786000045],
              [-45.593088344999956, 60.474676825000074],
              [-45.59605872299994, 60.48427969000005],
              [-45.59642493399991, 60.49591705900008],
              [-45.59801184799994, 60.505845445000034],
              [-45.60423743399991, 60.51117584800005],
              [-45.61367753799993, 60.52138906500005],
              [-45.61363684799994, 60.53070709800005],
              [-45.59117591099994, 60.533189195000034],
              [-45.59117591099994, 60.53937409100007],
              [-45.60912024599992, 60.53729889500005],
              [-45.64216061099995, 60.52789948100008],
              [-45.65607662699995, 60.52578359600005],
              [-45.67442786399994, 60.530462958000044],
              [-45.66515051999994, 60.54092031500005],
              [-45.622303839999915, 60.56232330900008],
              [-45.60789954299992, 60.56264883000006],
              [-45.59618079299992, 60.56586334800005],
              [-45.59117591099994, 60.58038971600007],
              [-45.59593665299991, 60.58836497600004],
              [-45.607411261999914, 60.59552643400008],
              [-45.621083136999914, 60.60028717700004],
              [-45.632150844999956, 60.60146719000005],
              [-45.62246660099993, 60.58783600500004],
              [-45.62547766799992, 60.57697174700007],
              [-45.63768469999991, 60.56989166900007],
              [-45.690744594999956, 60.56582265800006],
              [-45.70103919199994, 60.56732819200005],
              [-45.70848548099991, 60.57184479400007],
              [-45.723215298999946, 60.58502838700008],
              [-45.73143469999991, 60.58783600500004],
              [-45.72984778599994, 60.592678127000056],
              [-45.67992102799991, 60.62132396000004],
              [-45.64806067599994, 60.62995026200008],
              [-45.63377844999991, 60.63711172100005],
              [-45.624663865999935, 60.64923737200007],
              [-45.67796790299991, 60.64142487200007],
              [-45.68736731699994, 60.64305247600004],
              [-45.68736731699994, 60.635646877000056],
              [-45.75450598899994, 60.634466864000046],
              [-45.770822719999956, 60.63178131700005],
              [-45.78538977799991, 60.62494538000004],
              [-45.80036373599995, 60.61172109600005],
              [-45.81017005099994, 60.59609609600005],
              [-45.807932094999956, 60.58612702000005],
              [-45.80113684799994, 60.57697174700007],
              [-45.79723059799994, 60.56362539300005],
              [-45.802845831999946, 60.55097077000005],
              [-45.81505286399994, 60.55377838700008],
              [-45.82689368399991, 60.56232330900008],
              [-45.831369594999956, 60.56732819200005],
              [-45.84752356699994, 60.56586334800005],
              [-45.85228430899991, 60.56045156500005],
              [-45.85326087099992, 60.55145905200004],
              [-45.85802161399994, 60.53937409100007],
              [-45.86705481699994, 60.52252838700008],
              [-45.87169348899994, 60.51894765800006],
              [-45.88109290299991, 60.51837799700007],
              [-45.88902747299994, 60.52362702000005],
              [-45.892648891999954, 60.53001536700003],
              [-45.88304602799991, 60.538763739000046],
              [-45.89053300699993, 60.551214911000045],
              [-45.90953528599994, 60.570746161000045],
              [-45.92446855399993, 60.57648346600007],
              [-45.96471106699994, 60.57640208500004],
              [-45.98159745999993, 60.58038971600007],
              [-45.90880286399994, 60.605129299000055],
              [-45.89281165299991, 60.61513906500005],
              [-45.88158118399991, 60.614488023000035],
              [-45.843413865999935, 60.626613674000055],
              [-45.80724036399994, 60.63312409100007],
              [-45.765614386999914, 60.652329820000034],
              [-45.745432094999956, 60.656683661000045],
              [-45.70274817599994, 60.66079336100006],
              [-45.65566972599993, 60.67145416900007],
              [-45.611439581999946, 60.68667226800005],
              [-45.57750403599994, 60.70392487200007],
              [-45.60802161399994, 60.71149323100008],
              [-45.642689581999946, 60.700832424000055],
              [-45.67804928299995, 60.684759833000044],
              [-45.710601365999935, 60.67658112200007],
              [-45.78551184799994, 60.67731354400007],
              [-45.823150193999936, 60.683294989000046],
              [-45.85802161399994, 60.697699286000045],
              [-45.84024003799993, 60.70404694200005],
              [-45.80186926999994, 60.701239325000074],
              [-45.78294837099992, 60.70392487200007],
              [-45.76732337099992, 60.71173737200007],
              [-45.737538214999915, 60.73126862200007],
              [-45.72150631399995, 60.73867422100005],
              [-45.57750403599994, 60.76654694200005],
              [-45.57750403599994, 60.772772528000075],
              [-45.61095130099994, 60.771918036000045],
              [-45.62328040299991, 60.77374909100007],
              [-45.624663865999935, 60.77960846600007],
              [-45.62800045499995, 60.78359609600005],
              [-45.62368730399993, 60.78656647300005],
              [-45.58153235599991, 60.79938385600008],
              [-45.57408606699994, 60.800116278000075],
              [-45.55406653599994, 60.80463288000004],
              [-45.53888912699995, 60.815741278000075],
              [-45.525054490999935, 60.82925039300005],
              [-45.50926673099991, 60.841009833000044],
              [-45.49331620999993, 60.845689195000034],
              [-45.45815995999993, 60.85000234600005],
              [-45.44371497299994, 60.85809967700004],
              [-45.41982988199993, 60.882025458000044],
              [-45.413400844999956, 60.88434479400007],
              [-45.39561926999994, 60.888657945000034],
              [-45.388783331999946, 60.892564195000034],
              [-45.37657630099994, 60.89793528900003],
              [-45.305978969999956, 60.90452708500004],
              [-45.25877844999991, 60.90253327000005],
              [-45.25503495999993, 60.907904364000046],
              [-45.264230923999946, 60.91986725500004],
              [-45.28001868399991, 60.93183014500005],
              [-45.29629472599993, 60.93724192900004],
              [-45.31436113199993, 60.933254299000055],
              [-45.330962693999936, 60.92597077000005],
              [-45.347320115999935, 60.92255280200004],
              [-45.36461341099994, 60.93040599200003],
              [-45.34154212099992, 60.94232819200005],
              [-45.33385169199994, 60.94782135600008],
              [-45.33088131399995, 60.95571523600006],
              [-45.32970130099994, 60.96849192900004],
              [-45.330637173999946, 60.98041413000004],
              [-45.33385169199994, 60.985663153000075],
              [-45.35537675699993, 60.99233633000006],
              [-45.37490800699993, 61.00446198100008],
              [-45.395415818999936, 61.010646877000056],
              [-45.41982988199993, 60.999335028000075],
              [-45.414906378999945, 60.990668036000045],
              [-45.40916907499991, 60.98493073100008],
              [-45.39561926999994, 60.97479889500005],
              [-45.387928839999915, 60.96308014500005],
              [-45.393788214999915, 60.95693594000005],
              [-45.40575110599991, 60.95294830900008],
              [-45.41641191299993, 60.94782135600008],
              [-45.431630011999914, 60.93602122600004],
              [-45.470041469999956, 60.91543203300006],
              [-45.48814856699994, 60.90997955900008],
              [-45.48672441299993, 60.88959381700005],
              [-45.50890051999994, 60.87262604400007],
              [-45.67992102799991, 60.792669989000046],
              [-45.70103919199994, 60.777044989000046],
              [-45.71336829299992, 60.769964911000045],
              [-45.72834225199995, 60.76654694200005],
              [-45.77415930899991, 60.763373114000046],
              [-45.81867428299995, 60.75177643400008],
              [-45.84740149599992, 60.74990469000005],
              [-45.87486731699994, 60.75604889500005],
              [-45.899647589999915, 60.772772528000075],
              [-45.88585364499994, 60.78070709800005],
              [-45.831369594999956, 60.800116278000075],
              [-45.795806443999936, 60.818060614000046],
              [-45.777902798999946, 60.82396067900004],
              [-45.75625566299993, 60.827378648000035],
              [-45.77301998599995, 60.84332916900007],
              [-45.80235755099994, 60.848944403000075],
              [-45.87018795499995, 60.84739817900004],
              [-45.87791907499991, 60.846136786000045],
              [-45.89281165299991, 60.841009833000044],
              [-45.916859503999945, 60.82953522300005],
              [-45.92853756399995, 60.827826239000046],
              [-45.940663214999915, 60.834865627000056],
              [-45.93374589799993, 60.834865627000056],
              [-45.93374589799993, 60.841009833000044],
              [-45.95579993399991, 60.83649323100008],
              [-45.980458136999914, 60.82221100500004],
              [-46.00059973899994, 60.80288320500006],
              [-46.00890051999994, 60.78302643400008],
              [-46.00890051999994, 60.74168528900003],
              [-46.01598059799994, 60.73261139500005],
              [-46.032134568999936, 60.72809479400007],
              [-46.04963131399995, 60.72540924700007],
              [-46.060658331999946, 60.721584377000056],
              [-46.15973873599995, 60.73114655200004],
              [-46.18106035099993, 60.73663971600007],
              [-46.205067511999914, 60.74664948100008],
              [-46.22008216099994, 60.761053778000075],
              [-46.214955206999946, 60.77960846600007],
              [-46.175770636999914, 60.79157135600008],
              [-46.06037350199995, 60.79702383000006],
              [-46.01048743399991, 60.839056708000044],
              [-45.88980058499993, 60.87368398600006],
              [-45.851226365999935, 60.895697333000044],
              [-45.866525844999956, 60.900091864000046],
              [-45.88512122299994, 60.896551825000074],
              [-45.95767167899993, 60.868353583000044],
              [-45.96727454299992, 60.87051015800006],
              [-45.97248287699995, 60.87518952000005],
              [-45.97533118399991, 60.87986888200004],
              [-45.97813880099994, 60.882025458000044],
              [-45.98867753799993, 60.882879950000074],
              [-45.993072068999936, 60.88373444200005],
              [-45.99779212099992, 60.88222890800006],
              [-46.00890051999994, 60.87579987200007],
              [-46.01427161399994, 60.870306708000044],
              [-46.021148240999935, 60.85724518400008],
              [-46.09142005099994, 60.82054271000004],
              [-46.10789954299992, 60.827460028000075],
              [-46.116118943999936, 60.82461172100005],
              [-46.12059485599991, 60.81785716400003],
              [-46.12559973899994, 60.81313711100006],
              [-46.15538489499994, 60.80817291900007],
              [-46.18736731699994, 60.80695221600007],
              [-46.19493567599994, 60.81126536700003],
              [-46.18785559799994, 60.82086823100008],
              [-46.17442786399994, 60.830511786000045],
              [-46.16315670499995, 60.834865627000056],
              [-46.15062415299991, 60.837103583000044],
              [-45.88536536399994, 60.93040599200003],
              [-45.51024329299992, 60.98224518400008],
              [-45.46825110599991, 61.005560614000046],
              [-45.46458899599992, 61.010931708000044],
              [-45.45811926999994, 61.02692291900007],
              [-45.45457923099991, 61.032863674000055],
              [-45.443023240999935, 61.04319896000004],
              [-45.43126380099994, 61.049709377000056],
              [-45.41828365799995, 61.05304596600007],
              [-45.40274003799993, 61.053941148000035],
              [-45.37755286399994, 61.060248114000046],
              [-45.327056443999936, 61.08803945500006],
              [-45.300038214999915, 61.09430573100008],
              [-45.29133053299995, 61.09520091400003],
              [-45.266184048999946, 61.10101959800005],
              [-45.25877844999991, 61.10488515800006],
              [-45.25426184799994, 61.116115627000056],
              [-45.25743567599994, 61.12726471600007],
              [-45.26211503799993, 61.138373114000046],
              [-45.26219641799992, 61.14956289300005],
              [-45.24559485599991, 61.16421133000006],
              [-45.21983801999994, 61.17820872600004],
              [-45.203236456999946, 61.19330475500004],
              [-45.213734503999945, 61.211004950000074],
              [-45.24852454299992, 61.191107489000046],
              [-45.28172766799992, 61.160142320000034],
              [-45.29287675699993, 61.15574778900003],
              [-45.30797278599994, 61.14630768400008],
              [-45.342681443999936, 61.10464101800005],
              [-45.36461341099994, 61.09430573100008],
              [-45.38109290299991, 61.101223049000055],
              [-45.403960740999935, 61.11810944200005],
              [-45.42418372299994, 61.13764069200005],
              [-45.432932094999956, 61.15265534100007],
              [-45.43512936099995, 61.15851471600007],
              [-45.44005286399994, 61.161444403000075],
              [-45.44493567599994, 61.163397528000075],
              [-45.44713294199994, 61.16657135600008],
              [-45.44493567599994, 61.17267487200007],
              [-45.43512936099995, 61.181626695000034],
              [-45.432932094999956, 61.18740469000005],
              [-45.43736731699994, 61.19818756700005],
              [-45.44835364499994, 61.20575592700004],
              [-45.47447669199994, 61.218451239000046],
              [-45.50503495999993, 61.246527411000045],
              [-45.51284745999993, 61.24762604400007],
              [-45.51545162699995, 61.22833893400008],
              [-45.511708136999914, 61.220404364000046],
              [-45.50536048099991, 61.21466705900008],
              [-45.503244594999956, 61.20726146000004],
              [-45.52057857999995, 61.18235911700003],
              [-45.52106686099995, 61.171942450000074],
              [-45.51634680899991, 61.16156647300005],
              [-45.49083411399994, 61.12482330900008],
              [-45.48814856699994, 61.11473216400003],
              [-45.486887173999946, 61.112982489000046],
              [-45.48452714799993, 61.11188385600008],
              [-45.48399817599994, 61.10879140800006],
              [-45.48814856699994, 61.10114166900007],
              [-45.49205481699994, 61.10040924700007],
              [-45.542958136999914, 61.079291083000044],
              [-45.618478969999956, 61.01984284100007],
              [-45.644602016999954, 61.00678131700005],
              [-45.77692623599995, 60.96051666900007],
              [-45.78978430899991, 60.95770905200004],
              [-45.805572068999936, 60.959418036000045],
              [-45.82652747299994, 60.96906159100007],
              [-45.84129798099991, 60.97138092700004],
              [-45.964100714999915, 60.928900458000044],
              [-46.03282630099994, 60.91388580900008],
              [-46.070301886999914, 60.93724192900004],
              [-46.044585740999935, 60.93797435100004],
              [-46.03620357999995, 60.93724192900004],
              [-46.04898027299993, 60.94773997600004],
              [-46.06436113199993, 60.951605536000045],
              [-46.07945716099994, 60.95343659100007],
              [-46.09142005099994, 60.95770905200004],
              [-46.09911048099991, 60.966457424000055],
              [-46.10024980399993, 60.97553131700005],
              [-46.092640753999945, 60.98273346600007],
              [-46.04287675699993, 60.99160390800006],
              [-45.94806881399995, 61.032863674000055],
              [-45.77725175699993, 61.06354401200008],
              [-45.73961341099994, 61.06403229400007],
              [-45.704741990999935, 61.068793036000045],
              [-45.67992102799991, 61.08808014500005],
              [-45.73395748599995, 61.08624909100007],
              [-45.76329505099994, 61.08869049700007],
              [-45.77611243399991, 61.097723700000074],
              [-45.76427161399994, 61.10565827000005],
              [-45.70274817599994, 61.12140534100007],
              [-45.71499589799993, 61.12579987200007],
              [-45.72520911399994, 61.13353099200003],
              [-45.73452714799993, 61.14272695500006],
              [-45.71703040299991, 61.14704010600008],
              [-45.69078528599994, 61.14866771000004],
              [-45.66588294199994, 61.14740631700005],
              [-45.65265865799995, 61.14272695500006],
              [-45.643869594999956, 61.14443594000005],
              [-45.62987219999991, 61.14207591400003],
              [-45.61876380099994, 61.144964911000045],
              [-45.618478969999956, 61.15574778900003],
              [-45.630197719999956, 61.16034577000005],
              [-45.694203253999945, 61.169989325000074],
              [-45.72598222599993, 61.169175523000035],
              [-45.73729407499991, 61.16421133000006],
              [-45.75255286399994, 61.15265534100007],
              [-45.76329505099994, 61.146470445000034],
              [-45.772328253999945, 61.14712148600006],
              [-45.78075110599991, 61.15314362200007],
              [-45.78978430899991, 61.16323476800005],
              [-45.77574622299994, 61.17991771000004],
              [-45.78587805899991, 61.19159577000005],
              [-45.82872473899994, 61.21039459800005],
              [-45.86827551999994, 61.218451239000046],
              [-45.872303839999915, 61.222723700000074],
              [-45.86961829299992, 61.232082424000055],
              [-45.86286373599995, 61.241441148000035],
              [-45.84508216099994, 61.25145091400003],
              [-45.79723059799994, 61.28729889500005],
              [-45.77830969999991, 61.298163153000075],
              [-45.735666469999956, 61.31655508000006],
              [-45.71401933499993, 61.32086823100008],
              [-45.71401933499993, 61.32831452000005],
              [-45.767241990999935, 61.33490631700005],
              [-45.79076087099992, 61.335150458000044],
              [-45.81712805899991, 61.32831452000005],
              [-45.86485755099994, 61.30719635600008],
              [-45.88654537699995, 61.28388092700004],
              [-45.88906816299993, 61.27985260600008],
              [-45.92320716099994, 61.24233633000006],
              [-45.938384568999936, 61.23322174700007],
              [-45.955189581999946, 61.23297760600008],
              [-46.00487219999991, 61.24310944200005],
              [-46.034413214999915, 61.261419989000046],
              [-46.050445115999935, 61.265611070000034],
              [-46.066395636999914, 61.26430898600006],
              [-46.11192786399994, 61.25259023600006],
              [-46.11192786399994, 61.245754299000055],
              [-46.08267167899993, 61.24249909100007],
              [-46.029286261999914, 61.22797272300005],
              [-45.98790442599994, 61.22174713700008],
              [-45.97166907499991, 61.21474844000005],
              [-45.96031653599994, 61.20575592700004],
              [-45.96108964799993, 61.197333075000074],
              [-45.931630011999914, 61.18891022300005],
              [-45.895415818999936, 61.18854401200008],
              [-45.861398891999954, 61.184027411000045],
              [-45.83820553299995, 61.16323476800005],
              [-45.83641516799992, 61.152044989000046],
              [-45.84032141799992, 61.141058661000045],
              [-45.84976152299993, 61.132473049000055],
              [-45.86485755099994, 61.12909577000005],
              [-45.95421301999994, 61.13646067900004],
              [-45.94871985599991, 61.12376536700003],
              [-45.93854732999995, 61.113714911000045],
              [-45.92601477799991, 61.10614655200004],
              [-45.913319464999915, 61.10114166900007],
              [-45.913319464999915, 61.09430573100008],
              [-46.00304114499994, 61.05931224200003],
              [-46.03278561099995, 61.053941148000035],
              [-46.10582434799994, 61.04922109600005],
              [-46.14366614499994, 61.052435614000046],
              [-46.173939581999946, 61.067572333000044],
              [-46.16759192599994, 61.08295319200005],
              [-46.18049068899995, 61.08869049700007],
              [-46.261830206999946, 61.089056708000044],
              [-46.281239386999914, 61.085150458000044],
              [-46.296864386999914, 61.07379791900007],
              [-46.28062903599994, 61.06932200700004],
              [-46.228627081999946, 61.067572333000044],
              [-46.210275844999956, 61.06167226800005],
              [-46.172718878999945, 61.04401276200008],
              [-46.14940344999991, 61.03815338700008],
              [-46.13613847599993, 61.02875397300005],
              [-46.11681067599994, 61.02326080900008],
              [-46.12218176999994, 61.01581452000005],
              [-46.139230923999946, 61.005560614000046],
              [-46.15758216099994, 60.998480536000045],
              [-46.20221920499995, 60.99115631700005],
              [-46.226673956999946, 60.97703685100004],
              [-46.23570716099994, 60.978949286000045],
              [-46.24449622299994, 60.98322174700007],
              [-46.25218665299991, 60.985663153000075],
              [-46.25698808499993, 60.98891836100006],
              [-46.255116339999915, 60.99624258000006],
              [-46.24844316299993, 61.00893789300005],
              [-46.251291469999956, 61.02167389500005],
              [-46.25890051999994, 61.035223700000074],
              [-46.27013098899994, 61.04682038000004],
              [-46.28380286399994, 61.053941148000035],
              [-46.30809485599991, 61.04645416900007],
              [-46.31737219999991, 61.046535549000055],
              [-46.325103318999936, 61.05060455900008],
              [-46.341867641999954, 61.07070547100005],
              [-46.35704505099994, 61.07965729400007],
              [-46.37572180899991, 61.08466217700004],
              [-46.412953253999945, 61.08808014500005],
              [-46.406361456999946, 61.080959377000056],
              [-46.379465298999946, 61.06012604400007],
              [-46.382150844999956, 61.04743073100008],
              [-46.39240475199995, 61.04083893400008],
              [-46.406361456999946, 61.03896719000005],
              [-46.42039954299992, 61.040269273000035],
              [-46.44432532499991, 61.056301174000055],
              [-46.45653235599991, 61.05955638200004],
              [-46.46133378799993, 61.046535549000055],
              [-46.45470130099994, 61.036769924000055],
              [-46.412953253999945, 61.01235586100006],
              [-46.44684811099995, 61.00079987200007],
              [-46.45763098899994, 60.999335028000075],
              [-46.46812903599994, 61.00250885600008],
              [-46.48790442599994, 61.01666901200008],
              [-46.498890753999945, 61.01984284100007],
              [-46.54149329299992, 61.025458075000074],
              [-46.55776933499993, 61.02212148600006],
              [-46.57803300699993, 61.005560614000046],
              [-46.55158443899995, 60.99042389500005],
              [-46.544178839999915, 60.980129299000055],
              [-46.55016028599994, 60.964544989000046],
              [-46.54409745999993, 60.95221588700008],
              [-46.558583136999914, 60.95600006700005],
              [-46.59935462099992, 60.97671133000006],
              [-46.613840298999946, 60.98672109600005],
              [-46.631743943999936, 60.992621161000045],
              [-46.65314693899995, 60.985663153000075],
              [-46.638661261999914, 60.97475820500006],
              [-46.59007727799991, 60.93036530200004],
              [-46.57803300699993, 60.90997955900008],
              [-46.59276282499991, 60.91445547100005],
              [-46.60484778599994, 60.92300039300005],
              [-46.62645423099991, 60.94472890800006],
              [-46.62999426999994, 60.93081289300005],
              [-46.63829505099994, 60.912990627000056],
              [-46.651600714999915, 60.903225002000056],
              [-46.67052161399994, 60.913316148000035],
              [-46.68724524599992, 60.92519765800006],
              [-46.73021399599992, 60.941107489000046],
              [-46.74937903599994, 60.950873114000046],
              [-46.744130011999914, 60.937201239000046],
              [-46.732411261999914, 60.92715078300006],
              [-46.71711178299995, 60.92047760600008],
              [-46.70091712099992, 60.91681549700007],
              [-46.70091712099992, 60.90997955900008],
              [-46.72569739499994, 60.91425202000005],
              [-46.772694464999915, 60.93301015800006],
              [-46.79710852799991, 60.93724192900004],
              [-46.88654537699995, 60.93724192900004],
              [-46.87083899599992, 60.92377350500004],
              [-46.80549068899995, 60.91860586100006],
              [-46.77977454299992, 60.90619538000004],
              [-46.76089433499993, 60.89996979400007],
              [-46.730580206999946, 60.89411041900007],
              [-46.71031653599994, 60.886704820000034],
              [-46.72142493399991, 60.87579987200007],
              [-46.720041469999956, 60.856350002000056],
              [-46.74657141799992, 60.84275950700004],
              [-46.81078040299991, 60.827378648000035],
              [-46.82469641799992, 60.820746161000045],
              [-46.85106360599991, 60.803615627000056],
              [-46.86229407499991, 60.800116278000075],
              [-46.94115149599992, 60.800116278000075],
              [-46.94115149599992, 60.80695221600007],
              [-46.90880286399994, 60.81500885600008],
              [-46.894520636999914, 60.82257721600007],
              [-46.88654537699995, 60.834865627000056],
              [-46.94994055899991, 60.82200755400004],
              [-46.97813880099994, 60.82013580900008],
              [-46.96910559799994, 60.834865627000056],
              [-46.88849850199995, 60.85781484600005],
              [-46.84557044199994, 60.882025458000044],
              [-46.896473761999914, 60.87579987200007],
              [-46.93272864499994, 60.86188385600008],
              [-46.95152747299994, 60.86774323100008],
              [-46.96165930899991, 60.868353583000044],
              [-46.982411261999914, 60.85789622600004],
              [-47.00137285099993, 60.84320709800005],
              [-47.02106686099995, 60.83429596600007],
              [-47.04356848899994, 60.841009833000044],
              [-47.03986568899995, 60.84275950700004],
              [-47.039173956999946, 60.84320709800005],
              [-47.039173956999946, 60.84422435100004],
              [-47.03734290299991, 60.84788646000004],
              [-47.05650794199994, 60.86078522300005],
              [-47.044178839999915, 60.87909577000005],
              [-47.01720130099994, 60.89545319200005],
              [-46.967640753999945, 60.907416083000044],
              [-46.93272864499994, 60.92767975500004],
              [-46.91388912699995, 60.93040599200003],
              [-46.943470831999946, 60.95840078300006],
              [-46.99160722599993, 60.952785549000055],
              [-47.04198157499991, 60.93960195500006],
              [-47.07835852799991, 60.94472890800006],
              [-47.063343878999945, 60.95107656500005],
              [-47.02196204299992, 60.962591864000046],
              [-47.00259355399993, 60.964544989000046],
              [-47.029855923999946, 60.97475820500006],
              [-47.08267167899993, 60.96710846600007],
              [-47.173939581999946, 60.93724192900004],
              [-47.20738684799994, 60.912095445000034],
              [-47.22728430899991, 60.90033600500004],
              [-47.24901282499991, 60.895697333000044],
              [-47.26252193899995, 60.896918036000045],
              [-47.26781165299991, 60.900376695000034],
              [-47.27057857999995, 60.90680573100008],
              [-47.285145636999914, 60.930853583000044],
              [-47.28897050699993, 60.93964264500005],
              [-47.29059811099995, 60.94782135600008],
              [-47.30040442599994, 60.96108633000006],
              [-47.32217363199993, 60.955145575000074],
              [-47.34434973899994, 60.94208405200004],
              [-47.355458136999914, 60.93382396000004],
              [-47.37157141799992, 60.92963288000004],
              [-47.45327714799993, 60.93886953300006],
              [-47.458241339999915, 60.941392320000034],
              [-47.46336829299992, 60.94090403900003],
              [-47.47215735599991, 60.93382396000004],
              [-47.48070227799991, 60.92910390800006],
              [-47.49315344999991, 60.92568594000005],
              [-47.525502081999946, 60.921576239000046],
              [-47.53746497299994, 60.91771067900004],
              [-47.54670162699995, 60.91233958500004],
              [-47.54723059799994, 60.90619538000004],
              [-47.53774980399993, 60.90216705900008],
              [-47.52330481699994, 60.901271877000056],
              [-47.49669348899994, 60.90253327000005],
              [-47.52721106699994, 60.89175039300005],
              [-47.55736243399991, 60.89288971600007],
              [-47.659087693999936, 60.91071198100008],
              [-47.68541419199994, 60.89935944200005],
              [-47.70645097599993, 60.89642975500004],
              [-47.72801673099991, 60.89752838700008],
              [-47.74372311099995, 60.90253327000005],
              [-47.736317511999914, 60.91681549700007],
              [-47.752797003999945, 60.91547272300005],
              [-47.77989661399994, 60.899644273000035],
              [-47.80736243399991, 60.892238674000055],
              [-47.85912024599992, 60.868353583000044],
              [-47.826161261999914, 60.86603424700007],
              [-47.75304114499994, 60.88296133000006],
              [-47.72203528599994, 60.87579987200007],
              [-47.75450598899994, 60.85594310100004],
              [-47.762928839999915, 60.84788646000004],
              [-47.734445766999954, 60.85370514500005],
              [-47.67690995999993, 60.871975002000056],
              [-47.65001380099994, 60.87579987200007],
              [-47.530181443999936, 60.87579987200007],
              [-47.518422003999945, 60.87962474200003],
              [-47.49396725199995, 60.892238674000055],
              [-47.48302161399994, 60.895697333000044],
              [-47.360218878999945, 60.88556549700007],
              [-47.33116614499994, 60.87726471600007],
              [-47.32469641799992, 60.86155833500004],
              [-47.34284420499995, 60.85260651200008],
              [-47.438343878999945, 60.827378648000035],
              [-47.52562415299991, 60.83079661700003],
              [-47.61709550699993, 60.82086823100008],
              [-47.80532792899993, 60.82965729400007],
              [-47.84333248599995, 60.83901601800005],
              [-47.93211829299992, 60.84174225500004],
              [-47.948557094999956, 60.84788646000004],
              [-47.913726365999935, 60.87579987200007],
              [-47.94131425699993, 60.88255442900004],
              [-47.968739386999914, 60.87567780200004],
              [-47.99372311099995, 60.86090729400007],
              [-48.013742641999954, 60.84442780200004],
              [-48.037993943999936, 60.82998281500005],
              [-48.06432044199994, 60.825425523000035],
              [-48.11986243399991, 60.827378648000035],
              [-48.13499915299991, 60.82514069200005],
              [-48.16624915299991, 60.81537506700005],
              [-48.18126380099994, 60.81313711100006],
              [-48.195423956999946, 60.81419505400004],
              [-48.21971594999991, 60.81940338700008],
              [-48.23277747299994, 60.82054271000004],
              [-48.24266516799992, 60.82485586100006],
              [-48.24120032499991, 60.83421458500004],
              [-48.232085740999935, 60.84365469000005],
              [-48.20836341099994, 60.85040924700007],
              [-48.16828365799995, 60.868353583000044],
              [-48.08116614499994, 60.888657945000034],
              [-48.02847245999993, 60.914496161000045],
              [-48.02057857999995, 60.91681549700007],
              [-48.008697068999936, 60.913763739000046],
              [-47.999989386999914, 60.89996979400007],
              [-47.989491339999915, 60.895697333000044],
              [-47.971262173999946, 60.90058014500005],
              [-47.94371497299994, 60.91364166900007],
              [-47.91856848899994, 60.929022528000075],
              [-47.90758216099994, 60.94098541900007],
              [-47.892567511999914, 60.948431708000044],
              [-47.75365149599992, 60.970770575000074],
              [-47.73517818899995, 60.97846100500004],
              [-47.736317511999914, 60.991888739000046],
              [-47.70152747299994, 61.00429922100005],
              [-47.68846594999991, 61.005560614000046],
              [-47.68846594999991, 61.01235586100006],
              [-47.71642005099994, 61.01703522300005],
              [-47.81818600199995, 61.005560614000046],
              [-47.876210089999915, 61.005560614000046],
              [-47.88263912699995, 61.00771719000005],
              [-47.88459225199995, 61.00930410400008],
              [-47.894642706999946, 61.01740143400008],
              [-47.90013587099992, 61.01984284100007],
              [-47.90953528599994, 61.01902903900003],
              [-47.92442786399994, 61.013657945000034],
              [-47.93146725199995, 61.01235586100006],
              [-47.937611456999946, 61.01040273600006],
              [-47.94554602799991, 61.00568268400008],
              [-47.95848548099991, 60.99559153900003],
              [-47.96629798099991, 60.99164459800005],
              [-47.97630774599992, 60.99087148600006],
              [-48.00352942599994, 60.99298737200007],
              [-48.016468878999945, 60.99852122600004],
              [-48.02358964799993, 60.999335028000075],
              [-48.03164628799993, 60.99677155200004],
              [-48.047434048999946, 60.987616278000075],
              [-48.05500240799995, 60.985663153000075],
              [-48.05817623599995, 60.98338450700004],
              [-48.059803839999915, 60.978583075000074],
              [-48.06236731699994, 60.97361888200004],
              [-48.068348761999914, 60.97138092700004],
              [-48.07787024599992, 60.97361888200004],
              [-48.09325110599991, 60.98354726800005],
              [-48.09935462099992, 60.985663153000075],
              [-48.11436926999994, 60.982123114000046],
              [-48.143869594999956, 60.967678127000056],
              [-48.16079667899993, 60.964544989000046],
              [-48.15737870999993, 60.96857330900008],
              [-48.155140753999945, 60.971909898000035],
              [-48.15217037699995, 60.97500234600005],
              [-48.146555141999954, 60.978216864000046],
              [-48.171864386999914, 60.98786041900007],
              [-48.20726477799991, 60.99445221600007],
              [-48.27098548099991, 60.999335028000075],
              [-48.295765753999945, 60.99555084800005],
              [-48.34675045499995, 60.97996653900003],
              [-48.373117641999954, 60.978216864000046],
              [-48.40221106699994, 60.98651764500005],
              [-48.39610755099994, 60.99795156500005],
              [-48.37083899599992, 61.00800202000005],
              [-48.229725714999915, 61.026597398000035],
              [-48.215728318999936, 61.024603583000044],
              [-48.18126380099994, 61.01235586100006],
              [-48.16673743399991, 61.010646877000056],
              [-48.11986243399991, 61.01235586100006],
              [-48.10716712099992, 61.01557038000004],
              [-48.09390214799993, 61.02968984600005],
              [-48.08226477799991, 61.032863674000055],
              [-48.066070115999935, 61.03497955900008],
              [-48.03425045499995, 61.04437897300005],
              [-48.01744544199994, 61.046535549000055],
              [-47.883371548999946, 61.032863674000055],
              [-47.85374915299991, 61.03693268400008],
              [-47.838449673999946, 61.042303778000075],
              [-47.83185787699995, 61.05023834800005],
              [-47.835194464999915, 61.05711497600004],
              [-47.843006964999915, 61.06732819200005],
              [-47.852121548999946, 61.07672760600008],
              [-47.85912024599992, 61.081244208000044],
              [-47.87437903599994, 61.07876211100006],
              [-47.89952551999994, 61.06244538000004],
              [-47.913726365999935, 61.06012604400007],
              [-47.92039954299992, 61.06427643400008],
              [-47.934885219999956, 61.08808014500005],
              [-47.88194739499994, 61.10736725500004],
              [-47.85594641799992, 61.12213776200008],
              [-47.83470618399991, 61.15420156500005],
              [-47.786366339999915, 61.176947333000044],
              [-47.770375128999945, 61.191107489000046],
              [-47.79784094999991, 61.187933661000045],
              [-47.83511308499993, 61.16201406500005],
              [-47.86693274599992, 61.15273672100005],
              [-47.870757615999935, 61.145412502000056],
              [-47.873158331999946, 61.13654205900008],
              [-47.87962805899991, 61.12909577000005],
              [-47.892241990999935, 61.12400950700004],
              [-47.98497473899994, 61.10325755400004],
              [-48.03453528599994, 61.10114166900007],
              [-48.04662024599992, 61.09857819200005],
              [-48.07335364499994, 61.08844635600008],
              [-48.08568274599992, 61.08808014500005],
              [-48.095366990999935, 61.09320709800005],
              [-48.109364386999914, 61.108587958000044],
              [-48.11986243399991, 61.11473216400003],
              [-48.07453365799995, 61.14663320500006],
              [-48.049712693999936, 61.169623114000046],
              [-48.05158443899995, 61.183661200000074],
              [-48.066070115999935, 61.17169830900008],
              [-48.10147050699993, 61.14874909100007],
              [-48.13752193899995, 61.13231028900003],
              [-48.153960740999935, 61.13959381700005],
              [-48.15957597599993, 61.15424225500004],
              [-48.17296301999994, 61.161322333000044],
              [-48.18883216099994, 61.165228583000044],
              [-48.20177161399994, 61.169989325000074],
              [-48.21263587099992, 61.17914459800005],
              [-48.21637936099995, 61.18622467700004],
              [-48.21544348899994, 61.20075104400007],
              [-48.20030676999994, 61.210272528000075],
              [-48.105580206999946, 61.23895905200004],
              [-48.10997473899994, 61.24872467700004],
              [-48.11302649599992, 61.25259023600006],
              [-48.09935462099992, 61.259426174000055],
              [-48.10415605399993, 61.26609935100004],
              [-48.10960852799991, 61.27049388200004],
              [-48.11681067599994, 61.272650458000044],
              [-48.12669837099992, 61.273098049000055],
              [-48.12669837099992, 61.27985260600008],
              [-48.11107337099992, 61.282904364000046],
              [-48.087880011999914, 61.29759349200003],
              [-48.07884680899991, 61.30097077000005],
              [-48.064116990999935, 61.302435614000046],
              [-48.02358964799993, 61.31403229400007],
              [-47.93419348899994, 61.32013580900008],
              [-47.913726365999935, 61.32831452000005],
              [-47.96076412699995, 61.34064362200007],
              [-48.01671301999994, 61.334418036000045],
              [-48.11986243399991, 61.30719635600008],
              [-48.128163214999915, 61.32094961100006],
              [-48.14696204299992, 61.321478583000044],
              [-48.16584225199995, 61.31240469000005],
              [-48.17446855399993, 61.29726797100005],
              [-48.17638098899994, 61.27553945500006],
              [-48.18211829299992, 61.262884833000044],
              [-48.20547441299993, 61.24233633000006],
              [-48.21760006399995, 61.23680247600004],
              [-48.243804490999935, 61.237494208000044],
              [-48.256418423999946, 61.232082424000055],
              [-48.26626542899993, 61.21946849200003],
              [-48.28156490799995, 61.188788153000075],
              [-48.291127081999946, 61.177435614000046],
              [-48.27183997299994, 61.17055898600006],
              [-48.21544348899994, 61.14272695500006],
              [-48.23668372299994, 61.134426174000055],
              [-48.29124915299991, 61.12913646000004],
              [-48.40721594999991, 61.133978583000044],
              [-48.43455969999991, 61.14272695500006],
              [-48.430978969999956, 61.14891185100004],
              [-48.432525193999936, 61.152329820000034],
              [-48.44200598899994, 61.15574778900003],
              [-48.44200598899994, 61.16323476800005],
              [-48.37083899599992, 61.169907945000034],
              [-48.304798956999946, 61.183661200000074],
              [-48.32404537699995, 61.19041575700004],
              [-48.33275305899991, 61.191107489000046],
              [-48.304798956999946, 61.20416901200008],
              [-48.30093339799993, 61.212225653000075],
              [-48.297759568999936, 61.221991278000075],
              [-48.29898027299993, 61.22724030200004],
              [-48.320423956999946, 61.21401601800005],
              [-48.35802161399994, 61.19989655200004],
              [-48.373117641999954, 61.197333075000074],
              [-48.36628170499995, 61.211004950000074],
              [-48.39492753799993, 61.20465729400007],
              [-48.450103318999936, 61.179754950000074],
              [-48.48289954299992, 61.177435614000046],
              [-48.480580206999946, 61.181301174000055],
              [-48.47614498599995, 61.191107489000046],
              [-48.51162675699993, 61.190334377000056],
              [-48.52892005099994, 61.19204336100006],
              [-48.54442298099991, 61.197333075000074],
              [-48.52375240799995, 61.21507396000004],
              [-48.51549231699994, 61.22516510600008],
              [-48.51085364499994, 61.23895905200004],
              [-48.52721106699994, 61.235988674000055],
              [-48.572336391999954, 61.211004950000074],
              [-48.56786048099991, 61.22150299700007],
              [-48.557199673999946, 61.23899974200003],
              [-48.55801347599993, 61.245754299000055],
              [-48.523548956999946, 61.25153229400007],
              [-48.50690670499995, 61.258978583000044],
              [-48.49657141799992, 61.273098049000055],
              [-48.52391516799992, 61.272772528000075],
              [-48.54735266799992, 61.26459381700005],
              [-48.586008266999954, 61.23895905200004],
              [-48.60704505099994, 61.21967194200005],
              [-48.619130011999914, 61.212144273000035],
              [-48.63316809799994, 61.211004950000074],
              [-48.63963782499991, 61.214911200000074],
              [-48.63731848899994, 61.22943756700005],
              [-48.640614386999914, 61.23895905200004],
              [-48.60968990799995, 61.265692450000074],
              [-48.58112545499995, 61.280178127000056],
              [-48.548939581999946, 61.28620026200008],
              [-48.43659420499995, 61.29287344000005],
              [-48.39915930899991, 61.30109284100007],
              [-48.37987219999991, 61.31403229400007],
              [-48.448150193999936, 61.31403229400007],
              [-48.49400794199994, 61.30170319200005],
              [-48.51085364499994, 61.30097077000005],
              [-48.48770097599993, 61.34129466400003],
              [-48.48607337099992, 61.34813060100004],
              [-48.448557094999956, 61.35610586100006],
              [-48.42711341099994, 61.35809967700004],
              [-48.398101365999935, 61.347723700000074],
              [-48.35289466099994, 61.345363674000055],
              [-48.33897864499994, 61.34813060100004],
              [-48.33283443899995, 61.35809967700004],
              [-48.33336341099994, 61.36969635600008],
              [-48.34007727799991, 61.37579987200007],
              [-48.35260982999995, 61.36928945500006],
              [-48.36978105399993, 61.37250397300005],
              [-48.545765753999945, 61.381293036000045],
              [-48.572336391999954, 61.389105536000045],
              [-48.56554114499994, 61.402777411000045],
              [-48.57843990799995, 61.40094635600008],
              [-48.60342363199993, 61.39199453300006],
              [-48.613270636999914, 61.39252350500004],
              [-48.62726803299995, 61.396470445000034],
              [-48.674712693999936, 61.39594147300005],
              [-48.66397050699993, 61.40875885600008],
              [-48.648548956999946, 61.423163153000075],
              [-48.64110266799992, 61.43610260600008],
              [-48.654286261999914, 61.44432200700004],
              [-48.670765753999945, 61.43927643400008],
              [-48.76329505099994, 61.39402903900003],
              [-48.817250128999945, 61.37995026200008],
              [-48.859934048999946, 61.378159898000035],
              [-48.85289466099994, 61.402777411000045],
              [-48.87840735599991, 61.40485260600008],
              [-48.89232337099992, 61.40424225500004],
              [-48.903553839999915, 61.39789459800005],
              [-48.921131964999915, 61.38296133000006],
              [-48.93529212099992, 61.37327708500004],
              [-48.95250403599994, 61.36587148600006],
              [-48.97130286399994, 61.36163971600007],
              [-48.99006100199995, 61.36180247600004],
              [-48.99006100199995, 61.36928945500006],
              [-48.96056067599994, 61.380519924000055],
              [-48.95213782499991, 61.386053778000075],
              [-48.93846594999991, 61.39911530200004],
              [-48.939523891999954, 61.40326569200005],
              [-49.044911261999914, 61.39642975500004],
              [-49.06578528599994, 61.402777411000045],
              [-49.05321204299992, 61.40802643400008],
              [-49.04063880099994, 61.410142320000034],
              [-49.01398678299995, 61.410223700000074],
              [-49.00304114499994, 61.413397528000075],
              [-48.97960364499994, 61.42747630400004],
              [-48.939523891999954, 61.43406810100004],
              [-48.85973059799994, 61.45799388200004],
              [-48.83067786399994, 61.46141185100004],
              [-48.74644934799994, 61.45799388200004],
              [-48.72398841099994, 61.461371161000045],
              [-48.67735755099994, 61.47833893400008],
              [-48.48704993399991, 61.513657945000034],
              [-48.257923956999946, 61.531317450000074],
              [-48.229725714999915, 61.54682038000004],
              [-48.47614498599995, 61.53375885600008],
              [-48.44981848899994, 61.542303778000075],
              [-48.36628170499995, 61.55418528900003],
              [-48.34434973899994, 61.56537506700005],
              [-48.33055579299992, 61.58087799700007],
              [-48.329335089999915, 61.59674713700008],
              [-48.345814581999946, 61.60883209800005],
              [-48.36790930899991, 61.60809967700004],
              [-48.53115800699993, 61.54368724200003],
              [-48.69371497299994, 61.52317942900004],
              [-48.76268469999991, 61.503973700000074],
              [-48.80345618399991, 61.48578522300005],
              [-48.87344316299993, 61.48615143400008],
              [-48.90099036399994, 61.48224518400008],
              [-48.92682857999995, 61.47247955900008],
              [-48.98965410099993, 61.45795319200005],
              [-49.01732337099992, 61.45799388200004],
              [-49.01244055899991, 61.46771881700005],
              [-49.004750128999945, 61.47418854400007],
              [-48.99486243399991, 61.47793203300006],
              [-48.983265753999945, 61.47915273600006],
              [-49.00609290299991, 61.49168528900003],
              [-49.03929602799991, 61.49477773600006],
              [-49.10334225199995, 61.491522528000075],
              [-49.11351477799991, 61.49603913000004],
              [-49.11310787699995, 61.50617096600007],
              [-49.10777747299994, 61.516913153000075],
              [-49.10334225199995, 61.523138739000046],
              [-49.091786261999914, 61.52887604400007],
              [-49.05882727799991, 61.53351471600007],
              [-49.04466712099992, 61.53998444200005],
              [-49.06159420499995, 61.53925202000005],
              [-49.11290442599994, 61.54682038000004],
              [-49.12970943899995, 61.54645416900007],
              [-49.17564856699994, 61.53998444200005],
              [-49.29857337099992, 61.56102122600004],
              [-49.283192511999914, 61.568426825000074],
              [-49.23892167899993, 61.58120351800005],
              [-49.222767706999946, 61.58218008000006],
              [-49.24742591099994, 61.587958075000074],
              [-49.25698808499993, 61.592230536000045],
              [-49.263783331999946, 61.60138580900008],
              [-49.241078253999945, 61.60757070500006],
              [-48.95018469999991, 61.58706289300005],
              [-48.690297003999945, 61.61505768400008],
              [-48.623158331999946, 61.63768138200004],
              [-48.59219316299993, 61.63613515800006],
              [-48.618478969999956, 61.64622630400004],
              [-48.64175370999993, 61.650824286000045],
              [-48.66437740799995, 61.649603583000044],
              [-48.73668372299994, 61.628119208000044],
              [-48.983265753999945, 61.60883209800005],
              [-48.983265753999945, 61.615668036000045],
              [-48.959543423999946, 61.61782461100006],
              [-48.947377081999946, 61.62059153900003],
              [-48.93822180899991, 61.62555573100008],
              [-48.93321692599994, 61.636053778000075],
              [-48.94115149599992, 61.64203522300005],
              [-48.95449785099993, 61.64313385600008],
              [-48.97679602799991, 61.63507721600007],
              [-49.01732337099992, 61.63613515800006],
              [-49.027414516999954, 61.63255442900004],
              [-49.03620357999995, 61.62763092700004],
              [-49.04588782499991, 61.62352122600004],
              [-49.05833899599992, 61.62250397300005],
              [-49.05264238199993, 61.62836334800005],
              [-49.05333411399994, 61.63239166900007],
              [-49.05646725199995, 61.63739655200004],
              [-49.05833899599992, 61.646144924000055],
              [-49.05833899599992, 61.67401764500005],
              [-49.06151282499991, 61.68195221600007],
              [-49.06749426999994, 61.68406810100004],
              [-49.07079016799992, 61.687160549000055],
              [-49.06578528599994, 61.69765859600005],
              [-49.056304490999935, 61.704779364000046],
              [-49.04287675699993, 61.708319403000075],
              [-49.01732337099992, 61.71124909100007],
              [-48.94912675699993, 61.733710028000075],
              [-48.912098761999914, 61.73847077000005],
              [-48.880197719999956, 61.72553131700005],
              [-48.90387936099995, 61.752020575000074],
              [-48.904367641999954, 61.764960028000075],
              [-48.89122473899994, 61.77521393400008],
              [-48.87401282499991, 61.79315827000005],
              [-48.906239386999914, 61.78270091400003],
              [-48.96751868399991, 61.74648672100005],
              [-49.01797441299993, 61.73493073100008],
              [-49.03465735599991, 61.72809479400007],
              [-49.05211341099994, 61.72406647300005],
              [-49.091053839999915, 61.73322174700007],
              [-49.12877356699994, 61.72671133000006],
              [-49.14830481699994, 61.72553131700005],
              [-49.13581295499995, 61.73883698100008],
              [-49.11595618399991, 61.752386786000045],
              [-49.10191809799994, 61.76618073100008],
              [-49.106760219999956, 61.780178127000056],
              [-49.11949622299994, 61.794582424000055],
              [-49.12157141799992, 61.811753648000035],
              [-49.10924231699994, 61.828558661000045],
              [-49.08568274599992, 61.84162018400008],
              [-49.054798956999946, 61.84511953300006],
              [-49.021148240999935, 61.84479401200008],
              [-49.00267493399991, 61.84992096600007],
              [-49.01732337099992, 61.869574286000045],
              [-49.00210527299993, 61.874701239000046],
              [-48.96279863199993, 61.87742747600004],
              [-48.94505774599992, 61.88629791900007],
              [-48.93919837099992, 61.897650458000044],
              [-48.93309485599991, 61.91498444200005],
              [-48.92463131399995, 61.930853583000044],
              [-48.91148841099994, 61.93781159100007],
              [-48.903960740999935, 61.93992747600004],
              [-48.89004472599993, 61.94936758000006],
              [-48.88076738199993, 61.95148346600007],
              [-48.86961829299992, 61.952378648000035],
              [-48.83922278599994, 61.958319403000075],
              [-48.74986731699994, 61.958319403000075],
              [-48.75039628799993, 61.962958075000074],
              [-48.75177975199995, 61.96556224200003],
              [-48.75731360599991, 61.97134023600006],
              [-48.74986731699994, 61.97874583500004],
              [-48.78416907499991, 61.992254950000074],
              [-48.82127844999991, 61.99298737200007],
              [-48.91270911399994, 61.98395416900007],
              [-48.94591223899994, 61.97650788000004],
              [-48.98070227799991, 61.96320221600007],
              [-49.166900193999936, 61.856634833000044],
              [-49.18919837099992, 61.83808014500005],
              [-49.19749915299991, 61.814520575000074],
              [-49.18187415299991, 61.78701406500005],
              [-49.18187415299991, 61.780178127000056],
              [-49.18773352799991, 61.76992422100005],
              [-49.18187415299991, 61.75971100500004],
              [-49.18187415299991, 61.75218333500004],
              [-49.200428839999915, 61.73541901200008],
              [-49.22008216099994, 61.72406647300005],
              [-49.241118943999936, 61.72016022300005],
              [-49.263783331999946, 61.72553131700005],
              [-49.272694464999915, 61.73065827000005],
              [-49.29173743399991, 61.74603913000004],
              [-49.307484503999945, 61.75299713700008],
              [-49.353179490999935, 61.76654694200005],
              [-49.22960364499994, 61.87641022300005],
              [-49.21580969999991, 61.88344961100006],
              [-49.18927975199995, 61.89118073100008],
              [-49.17564856699994, 61.89687734600005],
              [-49.17564856699994, 61.90302155200004],
              [-49.197336391999954, 61.905951239000046],
              [-49.21446692599994, 61.906317450000074],
              [-49.23082434799994, 61.90346914300005],
              [-49.27847245999993, 61.884751695000034],
              [-49.287953253999945, 61.88320547100005],
              [-49.29210364499994, 61.878892320000034],
              [-49.29124915299991, 61.86017487200007],
              [-49.29507402299993, 61.85586172100005],
              [-49.30500240799995, 61.84943268400008],
              [-49.315663214999915, 61.83539459800005],
              [-49.32884680899991, 61.82127513200004],
              [-49.34630286399994, 61.81492747600004],
              [-49.386789516999954, 61.81289297100005],
              [-49.40656490799995, 61.81439850500004],
              [-49.42821204299992, 61.82111237200007],
              [-49.41466223899994, 61.82794830900008],
              [-49.43492591099994, 61.847357489000046],
              [-49.42833411399994, 61.859442450000074],
              [-49.38109290299991, 61.87641022300005],
              [-49.392241990999935, 61.88104889500005],
              [-49.39875240799995, 61.88296133000006],
              [-49.40843665299991, 61.88320547100005],
              [-49.40843665299991, 61.88939036700003],
              [-49.39281165299991, 61.894598700000074],
              [-49.39037024599992, 61.904364325000074],
              [-49.39171301999994, 61.91543203300006],
              [-49.38731848899994, 61.92413971600007],
              [-49.374256964999915, 61.927720445000034],
              [-49.34064693899995, 61.927720445000034],
              [-49.32648678299995, 61.93036530200004],
              [-49.346547003999945, 61.93805573100008],
              [-49.38613847599993, 61.93227773600006],
              [-49.40843665299991, 61.93781159100007],
              [-49.38752193899995, 61.94672272300005],
              [-49.34097245999993, 61.95294830900008],
              [-49.30760657499991, 61.97052643400008],
              [-49.28856360599991, 61.97553131700005],
              [-49.250111456999946, 61.97874583500004],
              [-49.161366339999915, 61.97134023600006],
              [-49.14354407499991, 61.97565338700008],
              [-49.11359615799995, 61.99494049700007],
              [-49.06590735599991, 62.00991445500006],
              [-48.992258266999954, 62.05304596600007],
              [-48.97301184799994, 62.05760325700004],
              [-48.959828253999945, 62.051214911000045],
              [-48.93919837099992, 62.04779694200005],
              [-48.901275193999936, 62.04767487200007],
              [-48.88418535099993, 62.05292389500005],
              [-48.85383053299995, 62.06976959800005],
              [-48.83922278599994, 62.07493724200003],
              [-48.83922278599994, 62.081244208000044],
              [-48.92487545499995, 62.07493724200003],
              [-48.948475714999915, 62.07770416900007],
              [-48.993397589999915, 62.08828359600005],
              [-49.01732337099992, 62.08860911700003],
              [-48.97956295499995, 62.11432526200008],
              [-48.96861731699994, 62.128892320000034],
              [-48.983265753999945, 62.13580963700008],
              [-49.00767981699994, 62.12710195500006],
              [-49.05382239499994, 62.08812083500004],
              [-49.07945716099994, 62.081244208000044],
              [-49.095773891999954, 62.10150788000004],
              [-49.07339433499993, 62.14093659100007],
              [-49.03502356699994, 62.181341864000046],
              [-49.00304114499994, 62.204738674000055],
              [-49.03111731699994, 62.212103583000044],
              [-49.067697719999956, 62.20254140800006],
              [-49.09943600199995, 62.18138255400004],
              [-49.11799068899995, 62.145697333000044],
              [-49.15143795499995, 62.10569896000004],
              [-49.15660559799994, 62.09218984600005],
              [-49.15404212099992, 62.07672760600008],
              [-49.14948482999995, 62.06122467700004],
              [-49.14830481699994, 62.04767487200007],
              [-49.16909745999993, 62.02130768400008],
              [-49.205637173999946, 62.018784898000035],
              [-49.24657141799992, 62.02130768400008],
              [-49.28087317599994, 62.009833075000074],
              [-49.31041419199994, 61.996161200000074],
              [-49.35586503799993, 61.987209377000056],
              [-49.40249589799993, 61.98517487200007],
              [-49.43569902299993, 61.99241771000004],
              [-49.418527798999946, 61.99990469000005],
              [-49.39586341099994, 62.00405508000006],
              [-49.353179490999935, 62.006740627000056],
              [-49.36392167899993, 62.01821523600006],
              [-49.40444902299993, 62.02533600500004],
              [-49.42202714799993, 62.03400299700007],
              [-49.40070553299995, 62.04832591400003],
              [-49.39240475199995, 62.05719635600008],
              [-49.38731848899994, 62.06818268400008],
              [-49.41515051999994, 62.06590403900003],
              [-49.440337693999936, 62.053900458000044],
              [-49.462147589999915, 62.036037502000056],
              [-49.48009192599994, 62.01630280200004],
              [-49.54116777299993, 61.999253648000035],
              [-49.55809485599991, 61.99701569200005],
              [-49.589914516999954, 61.98725006700005],
              [-49.60704505099994, 61.98501211100006],
              [-49.63849850199995, 61.98920319200005],
              [-49.67528235599991, 62.000433661000045],
              [-49.69351152299993, 62.01609935100004],
              [-49.66905676999994, 62.03400299700007],
              [-49.63540605399993, 62.03530508000006],
              [-49.56663977799991, 62.018866278000075],
              [-49.53746497299994, 62.026556708000044],
              [-49.60456295499995, 62.048488674000055],
              [-49.618478969999956, 62.05760325700004],
              [-49.564523891999954, 62.06342194200005],
              [-49.534413214999915, 62.07282135600008],
              [-49.517689581999946, 62.07493724200003],
              [-49.48546301999994, 62.072699286000045],
              [-49.472645636999914, 62.076239325000074],
              [-49.463002081999946, 62.08860911700003],
              [-49.51207434799994, 62.08978913000004],
              [-49.53628495999993, 62.08698151200008],
              [-49.555531378999945, 62.07807038000004],
              [-49.575835740999935, 62.07290273600006],
              [-49.60326087099992, 62.076157945000034],
              [-49.62490800699993, 62.08454010600008],
              [-49.62808183499993, 62.09487539300005],
              [-49.64468339799993, 62.096136786000045],
              [-49.67210852799991, 62.09479401200008],
              [-49.69440670499995, 62.098944403000075],
              [-49.69579016799992, 62.11660390800006],
              [-49.67650305899991, 62.12372467700004],
              [-49.60033118399991, 62.12445709800005],
              [-49.33263098899994, 62.081244208000044],
              [-49.34683183499993, 62.09096914300005],
              [-49.42821204299992, 62.11660390800006],
              [-49.32648678299995, 62.13580963700008],
              [-49.314442511999914, 62.136053778000075],
              [-49.303293423999946, 62.13491445500006],
              [-49.295033331999946, 62.13690827000005],
              [-49.29173743399991, 62.14667389500005],
              [-49.293527798999946, 62.15314362200007],
              [-49.296538865999935, 62.159409898000035],
              [-49.29710852799991, 62.16714101800005],
              [-49.29173743399991, 62.17804596600007],
              [-49.313343878999945, 62.17572663000004],
              [-49.334543423999946, 62.16779205900008],
              [-49.353179490999935, 62.16307200700004],
              [-49.36742102799991, 62.17059967700004],
              [-49.36241614499994, 62.178900458000044],
              [-49.36017818899995, 62.18895091400003],
              [-49.35627193899995, 62.198431708000044],
              [-49.34630286399994, 62.204738674000055],
              [-49.34630286399994, 62.21157461100006],
              [-49.39085852799991, 62.20921458500004],
              [-49.41274980399993, 62.20221588700008],
              [-49.42202714799993, 62.18764883000006],
              [-49.43032792899993, 62.16742584800005],
              [-49.45026607999995, 62.15582916900007],
              [-49.474720831999946, 62.15070221600007],
              [-49.49657141799992, 62.150091864000046],
              [-49.56151282499991, 62.15656159100007],
              [-49.61046301999994, 62.155951239000046],
              [-49.65957597599993, 62.14988841400003],
              [-49.68272864499994, 62.150091864000046],
              [-49.68272864499994, 62.157538153000075],
              [-49.65265865799995, 62.162176825000074],
              [-49.62926184799994, 62.16836172100005],
              [-49.61009680899991, 62.17918528900003],
              [-49.59276282499991, 62.19782135600008],
              [-49.59398352799991, 62.198919989000046],
              [-49.59048417899993, 62.20892975500004],
              [-49.58385169199994, 62.220363674000055],
              [-49.57599850199995, 62.225816148000035],
              [-49.51081295499995, 62.23200104400007],
              [-49.46914628799993, 62.25018952000005],
              [-49.45616614499994, 62.24909088700008],
              [-49.42992102799991, 62.238348700000074],
              [-49.40151933499993, 62.23200104400007],
              [-49.36904863199993, 62.22988515800006],
              [-49.34056555899991, 62.23411692900004],
              [-49.31509355399993, 62.24603913000004],
              [-49.29173743399991, 62.266791083000044],
              [-49.30296790299991, 62.27057526200008],
              [-49.31232662699995, 62.26850006700005],
              [-49.321522589999915, 62.26390208500004],
              [-49.33263098899994, 62.25995514500005],
              [-49.342640753999945, 62.25861237200007],
              [-49.46983801999994, 62.266791083000044],
              [-49.55455481699994, 62.249660549000055],
              [-49.57290605399993, 62.25250885600008],
              [-49.57164466099994, 62.264960028000075],
              [-49.541086391999954, 62.29193756700005],
              [-49.54116777299993, 62.304348049000055],
              [-49.55797278599994, 62.30646393400008],
              [-49.57555091099994, 62.292669989000046],
              [-49.591460740999935, 62.27533600500004],
              [-49.60326087099992, 62.266791083000044],
              [-49.60887610599991, 62.26463450700004],
              [-49.61148027299993, 62.25995514500005],
              [-49.612619594999956, 62.255113023000035],
              [-49.613840298999946, 62.25250885600008],
              [-49.62010657499991, 62.252386786000045],
              [-49.631703253999945, 62.25836823100008],
              [-49.63776607999995, 62.25995514500005],
              [-49.69579016799992, 62.266791083000044],
              [-49.795033331999946, 62.25995514500005],
              [-49.802805141999954, 62.25849030200004],
              [-49.80907141799992, 62.25462474200003],
              [-49.822377081999946, 62.24258047100005],
              [-49.834828253999945, 62.239569403000075],
              [-49.887562628999945, 62.24567291900007],
              [-49.85342363199993, 62.25995514500005],
              [-49.859486456999946, 62.26129791900007],
              [-49.87328040299991, 62.266791083000044],
              [-49.85968990799995, 62.26854075700004],
              [-49.833241339999915, 62.26557038000004],
              [-49.81867428299995, 62.266791083000044],
              [-49.81017005099994, 62.27033112200007],
              [-49.78453528599994, 62.28660716400003],
              [-49.788400844999956, 62.29791901200008],
              [-49.79527747299994, 62.30573151200008],
              [-49.80532792899993, 62.30923086100006],
              [-49.81867428299995, 62.30776601800005],
              [-49.821929490999935, 62.29291413000004],
              [-49.845773891999954, 62.28607819200005],
              [-49.87401282499991, 62.28579336100006],
              [-49.89098059799994, 62.290350653000075],
              [-49.90135657499991, 62.30646393400008],
              [-49.90392005099994, 62.32127513200004],
              [-49.901234503999945, 62.352443752000056],
              [-49.90855872299994, 62.36432526200008],
              [-49.92601477799991, 62.350897528000075],
              [-49.94676673099991, 62.32876211100006],
              [-49.96393795499995, 62.31460195500006],
              [-49.98786373599995, 62.31354401200008],
              [-50.01382402299993, 62.320379950000074],
              [-50.02672278599994, 62.33120351800005],
              [-50.01109778599994, 62.341864325000074],
              [-50.03844153599994, 62.36237213700008],
              [-50.05158443899995, 62.36579010600008],
              [-50.07998613199993, 62.36888255400004],
              [-50.09333248599995, 62.37323639500005],
              [-50.12279212099992, 62.38727448100008],
              [-50.130848761999914, 62.39337799700007],
              [-50.14500891799992, 62.40184153900003],
              [-50.15933183499993, 62.40281810100004],
              [-50.17406165299991, 62.40176015800006],
              [-50.18919837099992, 62.403957424000055],
              [-50.20152747299994, 62.40961334800005],
              [-50.20689856699994, 62.41478099200003],
              [-50.21035722599993, 62.42137278900003],
              [-50.231760219999956, 62.44839101800005],
              [-50.24762936099995, 62.46198151200008],
              [-50.30772864499994, 62.49127838700008],
              [-50.319569464999915, 62.50576406500005],
              [-50.30455481699994, 62.51463450700004],
              [-50.29369055899991, 62.53143952000005],
              [-50.278553839999915, 62.568426825000074],
              [-50.26829993399991, 62.58315664300005],
              [-50.24046790299991, 62.60932038000004],
              [-50.23021399599992, 62.623032945000034],
              [-50.22301184799994, 62.64533112200007],
              [-50.22101803299995, 62.66168854400007],
              [-50.21336829299992, 62.67597077000005],
              [-50.18919837099992, 62.69196198100008],
              [-50.16559811099995, 62.69765859600005],
              [-50.13630123599995, 62.70111725500004],
              [-50.11465410099993, 62.70685455900008],
              [-50.114125128999945, 62.71930573100008],
              [-50.08580481699994, 62.736314195000034],
              [-50.07575436099995, 62.74469635600008],
              [-50.065663214999915, 62.75958893400008],
              [-50.053578253999945, 62.78266022300005],
              [-50.04674231699994, 62.79205963700008],
              [-50.03502356699994, 62.80459219000005],
              [-50.01854407499991, 62.81281159100007],
              [-49.976633266999954, 62.81826406500005],
              [-49.945301886999914, 62.83380768400008],
              [-49.897043423999946, 62.848822333000044],
              [-49.90587317599994, 62.850043036000045],
              [-49.91429602799991, 62.85248444200005],
              [-49.92235266799992, 62.85578034100007],
              [-49.914906378999945, 62.86709219000005],
              [-49.90208899599992, 62.876613674000055],
              [-49.87328040299991, 62.889960028000075],
              [-49.87328040299991, 62.89679596600007],
              [-49.916900193999936, 62.888332424000055],
              [-49.95889238199993, 62.86977773600006],
              [-50.03844153599994, 62.822251695000034],
              [-50.10326087099992, 62.79897695500006],
              [-50.13491777299993, 62.77846914300005],
              [-50.15192623599995, 62.77773672100005],
              [-50.15933183499993, 62.78778717700004],
              [-50.14826412699995, 62.80801015800006],
              [-50.19664466099994, 62.80801015800006],
              [-50.19664466099994, 62.801214911000045],
              [-50.17174231699994, 62.78148021000004],
              [-50.17845618399991, 62.76642487200007],
              [-50.22679602799991, 62.736029364000046],
              [-50.24559485599991, 62.71507396000004],
              [-50.255848761999914, 62.708197333000044],
              [-50.27179928299995, 62.70563385600008],
              [-50.28307044199994, 62.71185944200005],
              [-50.288726365999935, 62.725043036000045],
              [-50.29792232999995, 62.73696523600006],
              [-50.319569464999915, 62.73908112200007],
              [-50.31126868399991, 62.75462474200003],
              [-50.26838131399995, 62.790676174000055],
              [-50.26593990799995, 62.798081773000035],
              [-50.264556443999936, 62.81818268400008],
              [-50.26158606699994, 62.822251695000034],
              [-50.25210527299993, 62.825384833000044],
              [-50.24681555899991, 62.83307526200008],
              [-50.24445553299995, 62.84292226800005],
              [-50.243804490999935, 62.85236237200007],
              [-50.23534094999991, 62.85565827000005],
              [-50.18236243399991, 62.89679596600007],
              [-50.16152910099993, 62.90574778900003],
              [-50.161773240999935, 62.909491278000075],
              [-50.162953253999945, 62.91400788000004],
              [-50.16193600199995, 62.91787344000005],
              [-50.142648891999954, 62.93821849200003],
              [-49.79873613199993, 63.00934479400007],
              [-49.74201412699995, 63.03188711100006],
              [-49.70262610599991, 63.06126536700003],
              [-49.77017167899993, 63.066473700000074],
              [-49.804758266999954, 63.06427643400008],
              [-49.82921301999994, 63.05133698100008],
              [-49.84947669199994, 63.03733958500004],
              [-50.025380011999914, 62.97675202000005],
              [-50.154855923999946, 62.96792226800005],
              [-50.18236243399991, 62.95880768400008],
              [-50.23766028599994, 62.89337799700007],
              [-50.24299068899995, 62.889105536000045],
              [-50.25470943899995, 62.88532135600008],
              [-50.266468878999945, 62.87872955900008],
              [-50.27179928299995, 62.86635976800005],
              [-50.27440344999991, 62.85114166900007],
              [-50.28160559799994, 62.846584377000056],
              [-50.29259192599994, 62.84564850500004],
              [-50.30650794199994, 62.84153880400004],
              [-50.324330206999946, 62.82575104400007],
              [-50.33551998599995, 62.807806708000044],
              [-50.34898841099994, 62.793036200000074],
              [-50.373890753999945, 62.78693268400008],
              [-50.38971920499995, 62.792222398000035],
              [-50.38044186099995, 62.80320872600004],
              [-50.36266028599994, 62.812201239000046],
              [-50.35309811099995, 62.81146881700005],
              [-50.35610917899993, 62.83026764500005],
              [-50.364165818999936, 62.83490631700005],
              [-50.37547766799992, 62.835272528000075],
              [-50.38841712099992, 62.84153880400004],
              [-50.39220130099994, 62.84467194200005],
              [-50.40147864499994, 62.848944403000075],
              [-50.40147864499994, 62.85578034100007],
              [-50.367176886999914, 62.88312409100007],
              [-50.36668860599991, 62.889960028000075],
              [-50.32648678299995, 62.93231842700004],
              [-50.31895911399994, 62.938381252000056],
              [-50.30313066299993, 62.94122955900008],
              [-50.28579667899993, 62.94839101800005],
              [-50.26988684799994, 62.95726146000004],
              [-50.25816809799994, 62.96564362200007],
              [-50.23900305899991, 62.98725006700005],
              [-50.22809811099995, 62.996161200000074],
              [-50.213449673999946, 62.99982330900008],
              [-50.17495683499993, 63.00079987200007],
              [-50.15843665299991, 63.00665924700007],
              [-50.14826412699995, 63.02024974200003],
              [-50.235991990999935, 63.04555898600006],
              [-50.25470943899995, 63.044134833000044],
              [-50.26158606699994, 63.033270575000074],
              [-50.27806555899991, 62.99315013200004],
              [-50.278553839999915, 62.97931549700007],
              [-50.38145911399994, 62.94961172100005],
              [-50.41576087099992, 62.94521719000005],
              [-50.46898352799991, 62.951157945000034],
              [-50.48033606699994, 62.955145575000074],
              [-50.49364173099991, 62.97524648600006],
              [-50.50275631399995, 62.979803778000075],
              [-50.517567511999914, 62.973089911000045],
              [-50.51475989499994, 62.962591864000046],
              [-50.52330481699994, 62.96198151200008],
              [-50.536773240999935, 62.96784088700008],
              [-50.548898891999954, 62.976223049000055],
              [-50.56297766799992, 62.980902411000045],
              [-50.59703528599994, 62.97455475500004],
              [-50.61375891799992, 62.97931549700007],
              [-50.49087480399993, 63.014105536000045],
              [-50.49486243399991, 63.02244700700004],
              [-50.49909420499995, 63.02903880400004],
              [-50.50430253799993, 63.034857489000046],
              [-50.51134192599994, 63.04075755400004],
              [-50.51280676999994, 63.05174388200004],
              [-50.524647589999915, 63.05573151200008],
              [-50.538319464999915, 63.053941148000035],
              [-50.55235755099994, 63.04755280200004],
              [-50.547718878999945, 63.042629299000055],
              [-50.53929602799991, 63.02708567900004],
              [-50.55776933499993, 63.02643463700008],
              [-50.57754472599993, 63.028957424000055],
              [-50.59679114499994, 63.03392161700003],
              [-50.61375891799992, 63.04075755400004],
              [-50.60130774599992, 63.05353424700007],
              [-50.59455318899995, 63.05805084800005],
              [-50.586496548999946, 63.06126536700003],
              [-50.590687628999945, 63.07200755400004],
              [-50.59512285099993, 63.08002350500004],
              [-50.607533331999946, 63.09601471600007],
              [-50.591135219999956, 63.09845612200007],
              [-50.545765753999945, 63.09601471600007],
              [-50.53555253799993, 63.09760163000004],
              [-50.53392493399991, 63.10138580900008],
              [-50.53473873599995, 63.10586172100005],
              [-50.53184973899994, 63.10968659100007],
              [-50.50450598899994, 63.12335846600007],
              [-50.471994594999956, 63.132513739000046],
              [-50.43936113199993, 63.13694896000004],
              [-50.42674719999991, 63.14240143400008],
              [-50.42332923099991, 63.15379466400003],
              [-50.430572068999936, 63.163763739000046],
              [-50.44994055899991, 63.164943752000056],
              [-50.44994055899991, 63.171128648000035],
              [-50.40021725199995, 63.18939850500004],
              [-50.059437628999945, 63.22964101800005],
              [-50.105458136999914, 63.240301825000074],
              [-50.29906165299991, 63.23261139500005],
              [-50.35220292899993, 63.23969147300005],
              [-50.36050370999993, 63.235988674000055],
              [-50.364898240999935, 63.22492096600007],
              [-50.37547766799992, 63.21702708500004],
              [-50.428578253999945, 63.194240627000056],
              [-50.458322719999956, 63.18585846600007],
              [-50.48863684799994, 63.18390534100007],
              [-50.517567511999914, 63.19159577000005],
              [-50.517567511999914, 63.198431708000044],
              [-50.51357988199993, 63.19993724200003],
              [-50.50450598899994, 63.20587799700007],
              [-50.56004798099991, 63.22601959800005],
              [-50.593006964999915, 63.23029205900008],
              [-50.607533331999946, 63.21580638200004],
              [-50.620025193999936, 63.20579661700003],
              [-50.67833411399994, 63.21771881700005],
              [-50.69635982999995, 63.21206289300005],
              [-50.78189042899993, 63.202337958000044],
              [-50.80247962099992, 63.195013739000046],
              [-50.82384192599994, 63.17820872600004],
              [-50.85448157499991, 63.161363023000035],
              [-50.88662675699993, 63.14838288000004],
              [-50.91234290299991, 63.14321523600006],
              [-50.92442786399994, 63.14671458500004],
              [-50.930978969999956, 63.155585028000075],
              [-50.93228105399993, 63.16693756700005],
              [-50.92906653599994, 63.17792389500005],
              [-50.919585740999935, 63.185980536000045],
              [-50.848866339999915, 63.21670156500005],
              [-50.82437089799993, 63.22406647300005],
              [-50.800892706999946, 63.234076239000046],
              [-50.778228318999936, 63.25307851800005],
              [-50.813343878999945, 63.25104401200008],
              [-50.857411261999914, 63.23932526200008],
              [-50.89891516799992, 63.22174713700008],
              [-50.92601477799991, 63.20213450700004],
              [-50.94880123599995, 63.18048737200007],
              [-50.96324622299994, 63.17084381700005],
              [-50.977447068999936, 63.164943752000056],
              [-51.00059973899994, 63.16474030200004],
              [-51.040679490999935, 63.18060944200005],
              [-51.056304490999935, 63.184759833000044],
              [-51.054676886999914, 63.19220612200007],
              [-51.048817511999914, 63.208685614000046],
              [-51.03986568899995, 63.22516510600008],
              [-51.028960740999935, 63.23261139500005],
              [-51.01939856699994, 63.234808661000045],
              [-51.00377356699994, 63.244574286000045],
              [-50.994252081999946, 63.24681224200003],
              [-50.98656165299991, 63.24485911700003],
              [-50.97911536399994, 63.24103424700007],
              [-50.97150631399995, 63.23822663000004],
              [-50.96385657499991, 63.23940664300005],
              [-50.955637173999946, 63.25067780200004],
              [-50.97301184799994, 63.257025458000044],
              [-51.01504472599993, 63.26048411700003],
              [-51.03075110599991, 63.25665924700007],
              [-51.04279537699995, 63.249660549000055],
              [-51.055572068999936, 63.246161200000074],
              [-51.07371985599991, 63.25307851800005],
              [-51.06224524599992, 63.26829661700003],
              [-51.04527747299994, 63.27362702000005],
              [-51.02525794199994, 63.27728913000004],
              [-51.004750128999945, 63.28778717700004],
              [-51.02285722599993, 63.29279205900008],
              [-51.07066809799994, 63.288397528000075],
              [-51.09080969999991, 63.297756252000056],
              [-51.09825598899994, 63.31146881700005],
              [-51.10106360599991, 63.328558661000045],
              [-51.097767706999946, 63.343085028000075],
              [-51.08702551999994, 63.349269924000055],
              [-50.83348548099991, 63.356675523000035],
              [-50.84093176999994, 63.356675523000035],
              [-50.49254309799994, 63.37189362200007],
              [-50.476633266999954, 63.37592194200005],
              [-50.47301184799994, 63.378973700000074],
              [-50.459828253999945, 63.39398834800005],
              [-50.45213782499991, 63.397691148000035],
              [-50.278553839999915, 63.40387604400007],
              [-50.33543860599991, 63.42161692900004],
              [-50.40196692599994, 63.42552317900004],
              [-50.46837317599994, 63.41779205900008],
              [-50.55382239499994, 63.39232005400004],
              [-50.751210089999915, 63.38694896000004],
              [-50.778228318999936, 63.37592194200005],
              [-50.78742428299995, 63.39288971600007],
              [-50.80247962099992, 63.39801666900007],
              [-50.82111568899995, 63.395819403000075],
              [-50.84093176999994, 63.39020416900007],
              [-50.85024980399993, 63.38617584800005],
              [-50.85781816299993, 63.38149648600006],
              [-50.86620032499991, 63.37759023600006],
              [-50.877837693999936, 63.37592194200005],
              [-50.89049231699994, 63.37689850500004],
              [-50.92292232999995, 63.38336823100008],
              [-50.96475175699993, 63.38125234600005],
              [-51.00772050699993, 63.37409088700008],
              [-51.049387173999946, 63.37156810100004],
              [-51.08731035099993, 63.38336823100008],
              [-51.06151282499991, 63.39695872600004],
              [-51.03823808499993, 63.419175523000035],
              [-51.01891028599994, 63.44578685100004],
              [-51.004750128999945, 63.47280508000006],
              [-51.027333136999914, 63.47345612200007],
              [-51.04710852799991, 63.47052643400008],
              [-51.06094316299993, 63.45929596600007],
              [-51.06627356699994, 63.434881903000075],
              [-51.075103318999936, 63.41966380400004],
              [-51.095692511999914, 63.40033600500004],
              [-51.11876380099994, 63.38353099200003],
              [-51.13512122299994, 63.37592194200005],
              [-51.171131964999915, 63.38100820500006],
              [-51.16624915299991, 63.39935944200005],
              [-51.146595831999946, 63.42072174700007],
              [-51.13825436099995, 63.434881903000075],
              [-51.16380774599992, 63.44757721600007],
              [-51.207020636999914, 63.428615627000056],
              [-51.22329667899993, 63.44489166900007],
              [-51.179798956999946, 63.46308014500005],
              [-51.16234290299991, 63.474310614000046],
              [-51.145090298999946, 63.489488023000035],
              [-51.12730872299994, 63.49555084800005],
              [-51.08535722599993, 63.48590729400007],
              [-51.069976365999935, 63.489488023000035],
              [-51.05650794199994, 63.49823639500005],
              [-51.039173956999946, 63.50385163000004],
              [-50.79474850199995, 63.52651601800005],
              [-50.76268469999991, 63.53587474200003],
              [-50.744130011999914, 63.554754950000074],
              [-50.807484503999945, 63.55573151200008],
              [-51.05528723899994, 63.526556708000044],
              [-51.07371985599991, 63.527411200000074],
              [-51.09312903599994, 63.53139883000006],
              [-51.10265051999994, 63.53705475500004],
              [-51.11778723899994, 63.55841705900008],
              [-51.13377844999991, 63.576605536000045],
              [-51.145741339999915, 63.594956773000035],
              [-51.144520636999914, 63.61310455900008],
              [-51.12083899599992, 63.63043854400007],
              [-51.10118567599994, 63.621527411000045],
              [-51.08446204299992, 63.62995026200008],
              [-51.06981360599991, 63.643744208000044],
              [-51.056304490999935, 63.65086497600004],
              [-51.034047003999945, 63.647772528000075],
              [-50.98810787699995, 63.63361237200007],
              [-50.91539466099994, 63.62299225500004],
              [-50.91120357999995, 63.620021877000056],
              [-50.90892493399991, 63.61163971600007],
              [-50.905506964999915, 63.60993073100008],
              [-50.898426886999914, 63.610988674000055],
              [-50.88609778599994, 63.61562734600005],
              [-50.88133704299992, 63.61676666900007],
              [-50.57339433499993, 63.64411041900007],
              [-50.562163865999935, 63.63621653900003],
              [-50.56509355399993, 63.620794989000046],
              [-50.56517493399991, 63.61017487200007],
              [-50.54552161399994, 63.61676666900007],
              [-50.53351803299995, 63.626288153000075],
              [-50.52208411399994, 63.64004140800006],
              [-50.50450598899994, 63.67137278900003],
              [-50.53140214799993, 63.67841217700004],
              [-50.894642706999946, 63.63043854400007],
              [-50.93317623599995, 63.63434479400007],
              [-51.045765753999945, 63.66453685100004],
              [-51.076161261999914, 63.66429271000004],
              [-51.12637285099993, 63.64240143400008],
              [-51.158762173999946, 63.63666413000004],
              [-51.18517005099994, 63.62885163000004],
              [-51.18712317599994, 63.61017487200007],
              [-51.175770636999914, 63.58746979400007],
              [-51.12848873599995, 63.52684153900003],
              [-51.13023841099994, 63.512884833000044],
              [-51.162180141999954, 63.507513739000046],
              [-51.17528235599991, 63.510646877000056],
              [-51.19522050699993, 63.524318752000056],
              [-51.20343990799995, 63.527411200000074],
              [-51.22451738199993, 63.52997467700004],
              [-51.278553839999915, 63.548529364000046],
              [-51.37092037699995, 63.55451080900008],
              [-51.37913977799991, 63.55385976800005],
              [-51.38548743399991, 63.55027903900003],
              [-51.38658606699994, 63.543850002000056],
              [-51.38158118399991, 63.53424713700008],
              [-51.39220130099994, 63.53412506700005],
              [-51.40265865799995, 63.53546784100007],
              [-51.42251542899993, 63.541001695000034],
              [-51.41771399599992, 63.55060455900008],
              [-51.41002356699994, 63.557074286000045],
              [-51.40001380099994, 63.56085846600007],
              [-51.38841712099992, 63.562201239000046],
              [-51.39110266799992, 63.56875234600005],
              [-51.39281165299991, 63.571600653000075],
              [-51.39586341099994, 63.57518138200004],
              [-51.32404537699995, 63.61351146000004],
              [-51.30646725199995, 63.63043854400007],
              [-51.361398891999954, 63.62299225500004],
              [-51.376210089999915, 63.626288153000075],
              [-51.40021725199995, 63.64077383000006],
              [-51.53921464799993, 63.68504466400003],
              [-51.53921464799993, 63.691839911000045],
              [-51.49644934799994, 63.705959377000056],
              [-51.34740149599992, 63.71979401200008],
              [-51.34740149599992, 63.72601959800005],
              [-51.429676886999914, 63.732855536000045],
              [-51.48180091099994, 63.723863023000035],
              [-51.48973548099991, 63.714544989000046],
              [-51.53551184799994, 63.705511786000045],
              [-51.55247962099992, 63.70575592700004],
              [-51.55968176999994, 63.716050523000035],
              [-51.55638587099992, 63.73041413000004],
              [-51.54832923099991, 63.74359772300005],
              [-51.52867591099994, 63.76414622600004],
              [-51.49767005099994, 63.78009674700007],
              [-51.210275844999956, 63.81537506700005],
              [-51.23110917899993, 63.82461172100005],
              [-51.21987870999993, 63.83706289300005],
              [-51.11481686099995, 63.878119208000044],
              [-50.95620683499993, 63.915350653000075],
              [-50.92292232999995, 63.932074286000045],
              [-50.92292232999995, 63.93829987200007],
              [-50.94469153599994, 63.93183014500005],
              [-51.02525794199994, 63.92462799700007],
              [-51.16905676999994, 63.891791083000044],
              [-51.29963131399995, 63.82843659100007],
              [-51.34044348899994, 63.81932200700004],
              [-51.40294348899994, 63.81273021000004],
              [-51.45840410099993, 63.817572333000044],
              [-51.477772589999915, 63.84271881700005],
              [-51.46446692599994, 63.857489325000074],
              [-51.442250128999945, 63.853216864000046],
              [-51.418853318999936, 63.84365469000005],
              [-51.402007615999935, 63.84271881700005],
              [-51.397775844999956, 63.85846588700008],
              [-51.40587317599994, 63.876288153000075],
              [-51.40526282499991, 63.88934967700004],
              [-51.37474524599992, 63.89109935100004],
              [-51.37474524599992, 63.897365627000056],
              [-51.392567511999914, 63.90273672100005],
              [-51.409494594999956, 63.91095612200007],
              [-51.40648352799991, 63.92926666900007],
              [-51.42479407499991, 63.93919505400004],
              [-51.44220943899995, 63.94623444200005],
              [-51.43651282499991, 63.95600006700005],
              [-51.41649329299992, 63.959418036000045],
              [-51.39293372299994, 63.958197333000044],
              [-51.37242591099994, 63.96002838700008],
              [-51.36107337099992, 63.97304922100005],
              [-51.41637122299994, 63.98651764500005],
              [-51.436838344999956, 63.98672109600005],
              [-51.486317511999914, 63.97479889500005],
              [-51.505116339999915, 63.97304922100005],
              [-51.54246985599991, 63.97943756700005],
              [-51.61937415299991, 64.00751373900005],
              [-51.65648352799991, 64.01406484600005],
              [-51.620350714999915, 64.03461334800005],
              [-51.580148891999954, 64.04238515800006],
              [-51.44200598899994, 64.03978099200003],
              [-51.41942298099991, 64.03554922100005],
              [-51.35147050699993, 64.01382070500006],
              [-51.32774817599994, 64.01292552300004],
              [-51.30646725199995, 64.02081940300008],
              [-51.38841712099992, 64.05499909100007],
              [-51.36168372299994, 64.06606679900005],
              [-51.12083899599992, 64.08974844000005],
              [-51.062570766999954, 64.07758209800005],
              [-51.032460089999915, 64.07477448100008],
              [-50.98281816299993, 64.09808991100005],
              [-50.88133704299992, 64.09658437700006],
              [-50.82689368399991, 64.11176178600005],
              [-50.68268795499995, 64.17169830900008],
              [-50.65269934799994, 64.17475006700005],
              [-50.59813391799992, 64.16185130400004],
              [-50.56627356699994, 64.15802643400008],
              [-50.49767005099994, 64.15802643400008],
              [-50.48387610599991, 64.15501536700003],
              [-50.464507615999935, 64.14130280200004],
              [-50.44994055899991, 64.13690827000005],
              [-50.43439693899995, 64.13751862200007],
              [-50.42125403599994, 64.14248281500005],
              [-50.409494594999956, 64.15070221600007],
              [-50.39806067599994, 64.16144440300008],
              [-50.38361568899995, 64.16705963700008],
              [-50.34292558499993, 64.16412995000007],
              [-50.32579505099994, 64.16486237200007],
              [-50.241444464999915, 64.20083242400005],
              [-50.21003170499995, 64.20579661700003],
              [-50.145375128999945, 64.20180898600006],
              [-50.11351477799991, 64.19269440300008],
              [-50.09984290299991, 64.17511627800008],
              [-50.099598761999914, 64.15131256700005],
              [-50.097645636999914, 64.14061107000003],
              [-50.093006964999915, 64.13007233300004],
              [-50.08385169199994, 64.12396881700005],
              [-50.07164466099994, 64.11945221600007],
              [-50.065012173999946, 64.11351146000004],
              [-50.07249915299991, 64.10342031500005],
              [-50.07249915299991, 64.09658437700006],
              [-50.05386308499993, 64.10712311400005],
              [-50.05842037699995, 64.12124258000006],
              [-50.07168535099993, 64.13572825700004],
              [-50.079335089999915, 64.14777252800008],
              [-50.07689368399991, 64.16640859600005],
              [-50.06989498599995, 64.17987702000005],
              [-50.05907141799992, 64.19017161700003],
              [-50.04523678299995, 64.19896067900004],
              [-50.06289628799993, 64.21181875200006],
              [-50.08653723899994, 64.21503327000005],
              [-50.11172441299993, 64.21527741100005],
              [-50.134022589999915, 64.21942780200004],
              [-50.129017706999946, 64.22260163000004],
              [-50.11929277299993, 64.23078034100007],
              [-50.114125128999945, 64.23379140800006],
              [-50.16258704299992, 64.24494049700007],
              [-50.435658331999946, 64.19155508000006],
              [-50.525461391999954, 64.18768952000005],
              [-50.55235755099994, 64.17853424700007],
              [-50.54328365799995, 64.20050690300008],
              [-50.533273891999954, 64.21320221600007],
              [-50.46304277299993, 64.26776764500005],
              [-50.44448808499993, 64.27871328300006],
              [-50.421986456999946, 64.28839752800008],
              [-50.41755123599995, 64.30646393400008],
              [-50.39045162699995, 64.32440827000005],
              [-50.33315995999993, 64.34979889500005],
              [-50.363840298999946, 64.35907623900005],
              [-50.395375128999945, 64.35537344000005],
              [-50.42422441299993, 64.34284088700008],
              [-50.48473059799994, 64.29450104400007],
              [-50.50645911399994, 64.28310781500005],
              [-50.564564581999946, 64.26483795800004],
              [-50.572824673999946, 64.26044342700004],
              [-50.58177649599992, 64.25189850500004],
              [-50.58828691299993, 64.24323151200008],
              [-50.59650631399995, 64.23647695500006],
              [-50.62523352799991, 64.23151276200008],
              [-50.65404212099992, 64.22174713700008],
              [-50.66901607999995, 64.21942780200004],
              [-50.720692511999914, 64.22109609600005],
              [-50.73729407499991, 64.21942780200004],
              [-50.76447506399995, 64.20892975500004],
              [-50.81427975199995, 64.17812734600005],
              [-51.12710527249993, 64.13019440300005],
              [-51.43993079299992, 64.08226146000004],
              [-51.44790605399993, 64.08421458500004],
              [-51.46003170499995, 64.09357330900008],
              [-51.47032630099994, 64.09658437700006],
              [-51.566517706999946, 64.09658437700006],
              [-51.55968176999994, 64.10342031500005],
              [-51.58340410099993, 64.10830312700006],
              [-51.60960852799991, 64.11001211100006],
              [-51.63316809799994, 64.11513906500005],
              [-51.64903723899994, 64.13007233300004],
              [-51.63060462099992, 64.13621653900003],
              [-51.580189581999946, 64.16486237200007],
              [-51.561838344999956, 64.16962311400005],
              [-51.522043423999946, 64.17182038000004],
              [-51.46153723899994, 64.16742584800005],
              [-51.391184048999946, 64.14862702000005],
              [-51.35484778599994, 64.14435455900008],
              [-51.379750128999945, 64.16034577000005],
              [-51.458648240999935, 64.18927643400008],
              [-51.49404863199993, 64.19696686400005],
              [-51.528960740999935, 64.20050690300008],
              [-51.54979407499991, 64.19525788000004],
              [-51.56798255099994, 64.18349844000005],
              [-51.671864386999914, 64.15192291900007],
              [-51.692616339999915, 64.15204498900005],
              [-51.70372473899994, 64.16201406500005],
              [-51.69749915299991, 64.18537018400008],
              [-51.71385657499991, 64.18939850500004],
              [-51.76512610599991, 64.18537018400008],
              [-51.73151607999995, 64.20844147300005],
              [-51.66242428299995, 64.21820709800005],
              [-51.41258704299992, 64.21942780200004],
              [-51.402414516999954, 64.21621328300006],
              [-51.372385219999956, 64.20058828300006],
              [-51.35138912699995, 64.18659088700008],
              [-51.33438066299993, 64.18195221600007],
              [-51.26577714799993, 64.17820872600004],
              [-51.13467363199993, 64.20774974200003],
              [-51.12083899599992, 64.21320221600007],
              [-51.08340410099993, 64.23688385600008],
              [-51.069976365999935, 64.23993561400005],
              [-51.01162675699993, 64.23993561400005],
              [-50.99681555899991, 64.23676178600005],
              [-50.96849524599992, 64.22264232000003],
              [-50.95327714799993, 64.21942780200004],
              [-50.94591223899994, 64.22264232000003],
              [-50.92259680899991, 64.23676178600005],
              [-50.91234290299991, 64.23993561400005],
              [-50.89586341099994, 64.24140045800004],
              [-50.84715735599991, 64.25421784100007],
              [-50.84715735599991, 64.26044342700004],
              [-50.89391028599994, 64.26837799700007],
              [-51.00059973899994, 64.25971100500004],
              [-51.045765753999945, 64.28148021000004],
              [-51.027333136999914, 64.28534577000005],
              [-51.01231848899994, 64.29242584800005],
              [-50.98770097599993, 64.31195709800005],
              [-50.982411261999914, 64.31484609600005],
              [-50.96816972599993, 64.31964752800008],
              [-50.96385657499991, 64.32245514500005],
              [-50.95860755099994, 64.33075592700004],
              [-50.957590298999946, 64.33441803600005],
              [-50.95783443899995, 64.33722565300008],
              [-50.95641028599994, 64.34296295800004],
              [-50.95641028599994, 64.34715403900003],
              [-50.96226966099994, 64.35407135600008],
              [-50.96385657499991, 64.36033763200004],
              [-50.95970618399991, 64.36542389500005],
              [-50.93960527299993, 64.37067291900007],
              [-50.932484503999945, 64.37396881700005],
              [-50.912220831999946, 64.39598216400003],
              [-50.89952551999994, 64.40668366100005],
              [-50.88809160099993, 64.41128164300005],
              [-50.80964107999995, 64.42739492400005],
              [-50.76414954299992, 64.42845286700003],
              [-50.744130011999914, 64.40814850500004],
              [-50.72142493399991, 64.39704010600008],
              [-50.61465410099993, 64.37986888200004],
              [-50.58023027299993, 64.38397858300004],
              [-50.59727942599994, 64.39476146000004],
              [-50.62474524599992, 64.40119049700007],
              [-50.67552649599992, 64.40509674700007],
              [-50.68578040299991, 64.41071198100008],
              [-50.68858801999994, 64.42401764500005],
              [-50.69005286399994, 64.43976471600007],
              [-50.69635982999995, 64.45221588700008],
              [-50.65562903599994, 64.43524811400005],
              [-50.517567511999914, 64.40509674700007],
              [-50.507069464999915, 64.40509674700007],
              [-50.49864661399994, 64.40643952000005],
              [-50.48961341099994, 64.40619538000004],
              [-50.464100714999915, 64.39728424700007],
              [-50.418853318999936, 64.39765045800004],
              [-50.36620032499991, 64.38922760600008],
              [-50.34121660099993, 64.39028554900005],
              [-50.34007727799991, 64.40509674700007],
              [-50.32689368399991, 64.40900299700007],
              [-50.27830969999991, 64.40509674700007],
              [-50.27017167899993, 64.40599192900004],
              [-50.255197719999956, 64.41030508000006],
              [-50.24762936099995, 64.41128164300005],
              [-50.24323482999995, 64.41400788000004],
              [-50.24376380099994, 64.42023346600007],
              [-50.24526933499993, 64.42706940300008],
              [-50.243804490999935, 64.43170807500007],
              [-50.23395748599995, 64.43402741100005],
              [-50.20372473899994, 64.43732330900008],
              [-50.18602454299992, 64.44619375200006],
              [-50.18028723899994, 64.44651927300004],
              [-50.17638098899994, 64.44818756700005],
              [-50.17491614499994, 64.45600006700005],
              [-50.17833411399994, 64.45962148600006],
              [-50.18635006399995, 64.46279531500005],
              [-50.19566809799994, 64.46507396000004],
              [-50.20287024599992, 64.46588776200008],
              [-50.20079505099994, 64.46967194200005],
              [-50.19823157499991, 64.47695547100005],
              [-50.19664466099994, 64.48016998900005],
              [-50.22520911399994, 64.47760651200008],
              [-50.248890753999945, 64.47093333500004],
              [-50.306752081999946, 64.44769928600005],
              [-50.35309811099995, 64.43854401200008],
              [-50.38239498599995, 64.42690664300005],
              [-50.394642706999946, 64.42487213700008],
              [-50.42658443899995, 64.42633698100008],
              [-50.62450110599991, 64.46670156500005],
              [-50.65469316299993, 64.48016998900005],
              [-50.65469316299993, 64.48700592700004],
              [-50.62877356699994, 64.49176666900007],
              [-50.55235755099994, 64.51496002800008],
              [-50.49095618399991, 64.52562083500004],
              [-50.46068274599992, 64.53701406500005],
              [-50.443023240999935, 64.55585358300004],
              [-50.47508704299992, 64.54409414300005],
              [-50.58023027299993, 64.53473541900007],
              [-50.64122473899994, 64.52244700700004],
              [-50.671131964999915, 64.52680084800005],
              [-50.689523891999954, 64.54840729400007],
              [-50.67446855399993, 64.55377838700008],
              [-50.655506964999915, 64.56509023600006],
              [-50.63805091099994, 64.57843659100007],
              [-50.62743079299992, 64.59003327000005],
              [-50.69017493399991, 64.58051178600005],
              [-50.72435462099992, 64.57990143400008],
              [-50.75157630099994, 64.59003327000005],
              [-50.744130011999914, 64.59686920800004],
              [-50.784820115999935, 64.60236237200007],
              [-50.87800045499995, 64.58222077000005],
              [-50.91539466099994, 64.60301341400003],
              [-50.88776607999995, 64.61554596600007],
              [-50.83641516799992, 64.64557526200008],
              [-50.80614173099991, 64.65143463700008],
              [-50.73875891799992, 64.64960358300004],
              [-50.68268795499995, 64.63784414300005],
              [-50.607533331999946, 64.63100820500006],
              [-50.59288489499994, 64.63422272300005],
              [-50.55601966099994, 64.65143463700008],
              [-50.54137122299994, 64.65546295800004],
              [-50.52497311099995, 64.66278717700004],
              [-50.50861568899995, 64.66718170800004],
              [-50.484364386999914, 64.65737539300005],
              [-50.47166907499991, 64.65790436400005],
              [-50.45921790299991, 64.66144440300008],
              [-50.44994055899991, 64.66571686400005],
              [-50.47728430899991, 64.67499420800004],
              [-50.50462805899991, 64.67788320500006],
              [-50.58946692599994, 64.66937897300005],
              [-50.61192786399994, 64.67230866100005],
              [-50.662180141999954, 64.68561432500007],
              [-50.662180141999954, 64.69245026200008],
              [-50.48033606699994, 64.71287669500003],
              [-50.46239173099991, 64.71019114800004],
              [-50.42723548099991, 64.69708893400008],
              [-50.408314581999946, 64.69245026200008],
              [-50.33775794199994, 64.68439362200007],
              [-50.30418860599991, 64.67450592700004],
              [-50.27513587099992, 64.65485260600008],
              [-50.261708136999914, 64.63849518400008],
              [-50.23766028599994, 64.58258698100008],
              [-50.225819464999915, 64.56366608300004],
              [-50.171864386999914, 64.50405508000006],
              [-50.14907792899993, 64.48672109600005],
              [-50.02013098899994, 64.45160553600005],
              [-49.94766191299993, 64.42157623900005],
              [-49.92027747299994, 64.41608307500007],
              [-49.89195716099994, 64.40704987200007],
              [-49.86241614499994, 64.40355052300004],
              [-49.84797115799995, 64.39996979400007],
              [-49.70860755099994, 64.34870026200008],
              [-49.65192623599995, 64.33559804900005],
              [-49.59276282499991, 64.34296295800004],
              [-49.585926886999914, 64.34296295800004],
              [-49.59748287699995, 64.35952383000006],
              [-49.625111456999946, 64.37103913000004],
              [-49.65733801999994, 64.38035716400003],
              [-49.68272864499994, 64.39077383000006],
              [-49.68272864499994, 64.39765045800004],
              [-49.68297278599994, 64.42234935100004],
              [-49.72569739499994, 64.43439362200007],
              [-49.81554114499994, 64.43854401200008],
              [-49.846587693999936, 64.45966217700004],
              [-49.88467363199993, 64.47768789300005],
              [-49.89439856699994, 64.48016998900005],
              [-49.920765753999945, 64.48383209800005],
              [-50.00487219999991, 64.50747304900005],
              [-50.04063880099994, 64.51898834800005],
              [-50.06289628799993, 64.52973053600005],
              [-50.07249915299991, 64.54498932500007],
              [-50.075835740999935, 64.55662669500003],
              [-50.084055141999954, 64.57037995000007],
              [-50.11091061099995, 64.60175202000005],
              [-50.11701412699995, 64.61237213700008],
              [-50.12059485599991, 64.62470123900005],
              [-50.120350714999915, 64.63784414300005],
              [-50.113270636999914, 64.65424225500004],
              [-50.10118567599994, 64.66315338700008],
              [-50.084868943999936, 64.66787344000005],
              [-50.00829016799992, 64.68146393400008],
              [-49.99400794199994, 64.68903229400007],
              [-49.99722245999993, 64.70115794500003],
              [-50.024647589999915, 64.70844147300005],
              [-50.07970130099994, 64.71287669500003],
              [-50.09976152299993, 64.71051666900007],
              [-50.13512122299994, 64.70062897300005],
              [-50.15501868399991, 64.69928620000007],
              [-50.17267818899995, 64.70254140800006],
              [-50.189442511999914, 64.70905182500007],
              [-50.21715247299994, 64.72589752800008],
              [-50.20571855399993, 64.74664948100008],
              [-50.199289516999954, 64.75381094000005],
              [-50.18919837099992, 64.76129791900007],
              [-50.173085089999915, 64.76776764500005],
              [-50.15477454299992, 64.77179596600007],
              [-50.13817298099991, 64.77741120000007],
              [-50.127797003999945, 64.78864166900007],
              [-50.14142818899995, 64.80141836100006],
              [-50.12987219999991, 64.81338125200006],
              [-49.99742591099994, 64.86371491100005],
              [-50.013783331999946, 64.87246328300006],
              [-50.04210364499994, 64.86408112200007],
              [-50.07384192599994, 64.85040924700007],
              [-50.100168423999946, 64.84320709800005],
              [-50.16250566299993, 64.83771393400008],
              [-50.195423956999946, 64.82843659100007],
              [-50.20970618399991, 64.81256745000007],
              [-50.22101803299995, 64.79633209800005],
              [-50.246937628999945, 64.77464427300004],
              [-50.27574622299994, 64.75580475500004],
              [-50.29564368399991, 64.74770742400005],
              [-50.31114661399994, 64.74803294500003],
              [-50.31981360599991, 64.75006745000007],
              [-50.32664954299992, 64.75507233300004],
              [-50.33665930899991, 64.76439036700003],
              [-50.347645636999914, 64.77065664300005],
              [-50.35659745999993, 64.76874420800004],
              [-50.36681067599994, 64.76406484600005],
              [-50.38133704299992, 64.76129791900007],
              [-50.53815670499995, 64.76919179900005],
              [-50.55968176999994, 64.77480703300006],
              [-50.575835740999935, 64.78546784100007],
              [-50.586496548999946, 64.80231354400007],
              [-50.59943600199995, 64.84015534100007],
              [-50.60728919199994, 64.85512929900005],
              [-50.621205206999946, 64.87055084800005],
              [-50.66364498599995, 64.89215729400007],
              [-50.683257615999935, 64.90753815300008],
              [-50.68268795499995, 64.92519765800006],
              [-50.68663489499994, 64.92938873900005],
              [-50.69180253799993, 64.93915436400005],
              [-50.69635982999995, 64.94562409100007],
              [-50.690297003999945, 64.95331452000005],
              [-50.69481360599991, 64.95986562700006],
              [-50.71739661399994, 64.97296784100007],
              [-50.703968878999945, 64.98346588700008],
              [-50.69595292899993, 64.99453359600005],
              [-50.69513912699995, 65.00519440300008],
              [-50.703195766999954, 65.01459381700005],
              [-50.726673956999946, 65.02130768400008],
              [-50.75234941299993, 65.02142975500004],
              [-50.77586829299992, 65.02488841400003],
              [-50.79255123599995, 65.04189687700006],
              [-50.78978430899991, 65.05052317900004],
              [-50.791086391999954, 65.06395091400003],
              [-50.79478919199994, 65.07851797100005],
              [-50.799387173999946, 65.09027741100005],
              [-50.83531653599994, 65.12335846600007],
              [-50.84093176999994, 65.13129303600005],
              [-50.82949785099993, 65.14199453300006],
              [-50.74559485599991, 65.17275625200006],
              [-50.70579993399991, 65.19293854400007],
              [-50.689523891999954, 65.20636627800008],
              [-50.70059160099993, 65.21051666900007],
              [-50.71239173099991, 65.21051666900007],
              [-50.73729407499991, 65.20636627800008],
              [-50.75080318899995, 65.19428131700005],
              [-50.87995357999995, 65.15228913000004],
              [-50.88752193899995, 65.15176015800006],
              [-50.895415818999936, 65.15599192900004],
              [-50.89981035099993, 65.16299062700006],
              [-50.90249589799993, 65.16937897300005],
              [-50.905506964999915, 65.17218659100007],
              [-50.91637122299994, 65.17682526200008],
              [-50.93126380099994, 65.18707916900007],
              [-50.95018469999991, 65.20327383000006],
              [-50.95482337099992, 65.21405670800004],
              [-50.96544348899994, 65.21967194200005],
              [-50.97695878799993, 65.21967194200005],
              [-50.984364386999914, 65.21381256700005],
              [-50.98399817599994, 65.20815664300005],
              [-50.98078365799995, 65.20115794500003],
              [-50.97671464799993, 65.19525788000004],
              [-50.97374426999994, 65.19269440300008],
              [-50.966053839999915, 65.19057851800005],
              [-50.96629798099991, 65.18520742400005],
              [-50.96934973899994, 65.17845286700003],
              [-50.970041469999956, 65.17218659100007],
              [-50.95807857999995, 65.14887116100005],
              [-50.94127356699994, 65.12909577000005],
              [-50.91812089799993, 65.11542389500005],
              [-50.88752193899995, 65.11009349200003],
              [-50.89586341099994, 65.09918854400007],
              [-50.910267706999946, 65.09491608300004],
              [-50.94273841099994, 65.09027741100005],
              [-50.94273841099994, 65.08283112200007],
              [-50.89952551999994, 65.07611725500004],
              [-50.881703253999945, 65.06940338700008],
              [-50.87441972599993, 65.05243561400005],
              [-50.87547766799992, 65.04401276200008],
              [-50.88023841099994, 65.02692291900007],
              [-50.88223222599993, 65.00849030200004],
              [-50.88654537699995, 64.99241771000004],
              [-50.88752193899995, 64.98354726800005],
              [-50.86620032499991, 64.97882721600007],
              [-50.832102016999954, 64.98680247600004],
              [-50.76211503799993, 65.00324127800008],
              [-50.72362219999991, 64.99408600500004],
              [-50.737619594999956, 64.97492096600007],
              [-50.72028561099995, 64.94521719000005],
              [-50.73729407499991, 64.93260325700004],
              [-50.726551886999914, 64.92767975500004],
              [-50.71743730399993, 64.92137278900003],
              [-50.70978756399995, 64.91372304900005],
              [-50.703195766999954, 64.90473053600005],
              [-50.718820766999954, 64.89337799700007],
              [-50.772043423999946, 64.87055084800005],
              [-50.74474036399994, 64.86444733300004],
              [-50.703236456999946, 64.86041901200008],
              [-50.66519120999993, 64.85199616100005],
              [-50.648548956999946, 64.83270905200004],
              [-50.65510006399995, 64.82160065300008],
              [-50.67027747299994, 64.81561920800004],
              [-50.68736731699994, 64.81146881700005],
              [-50.699777798999946, 64.80573151200008],
              [-50.70913652299993, 64.78961823100008],
              [-50.69884192599994, 64.78359609600005],
              [-50.662180141999954, 64.78119538000004],
              [-50.637928839999915, 64.77016836100006],
              [-50.64216061099995, 64.75922272300005],
              [-50.66397050699993, 64.75096263200004],
              [-50.69286048099991, 64.74770742400005],
              [-50.70213782499991, 64.75189850500004],
              [-50.703968878999945, 64.76097239800004],
              [-50.70718339799993, 64.77016836100006],
              [-50.72052975199995, 64.77435944200005],
              [-50.73477128799993, 64.77090078300006],
              [-50.880970831999946, 64.69586823100008],
              [-50.90973873599995, 64.68504466400003],
              [-51.06627356699994, 64.66571686400005],
              [-51.07526607999995, 64.65208567900004],
              [-51.06289628799993, 64.64838288000004],
              [-51.032093878999945, 64.65143463700008],
              [-51.01781165299991, 64.64826080900008],
              [-51.00934811099995, 64.64126211100006],
              [-51.00963294199994, 64.63418203300006],
              [-51.02183997299994, 64.63100820500006],
              [-51.145090298999946, 64.61664459800005],
              [-51.19896399599992, 64.62482330900008],
              [-51.21711178299995, 64.62417226800005],
              [-51.18138587099992, 64.67194245000007],
              [-51.16734778599994, 64.71116771000004],
              [-51.14631100199995, 64.72296784100007],
              [-51.12124589799993, 64.73053620000007],
              [-51.10724850199995, 64.74022044500003],
              [-51.09483801999994, 64.75836823100008],
              [-51.074208136999914, 64.75824616100005],
              [-51.04954993399991, 64.75433991100005],
              [-51.02525794199994, 64.76129791900007],
              [-51.03307044199994, 64.76211172100005],
              [-51.05260169199994, 64.76752350500004],
              [-51.048939581999946, 64.77065664300005],
              [-51.04255123599995, 64.77802155200004],
              [-51.03892981699994, 64.78119538000004],
              [-51.06578528599994, 64.78766510600008],
              [-51.10041256399995, 64.79222239800004],
              [-51.13499915299991, 64.79222239800004],
              [-51.25255286399994, 64.76019928600005],
              [-51.278553839999915, 64.74770742400005],
              [-51.29287675699993, 64.73224518400008],
              [-51.30882727799991, 64.70868561400005],
              [-51.32164466099994, 64.68305084800005],
              [-51.32697506399995, 64.66201406500005],
              [-51.33348548099991, 64.65204498900005],
              [-51.34870357999995, 64.65082428600005],
              [-51.36583411399994, 64.65159739800004],
              [-51.378163214999915, 64.64769114800004],
              [-51.414621548999946, 64.61994049700007],
              [-51.42251542899993, 64.61050039300005],
              [-51.434803839999915, 64.54486725500004],
              [-51.43993079299992, 64.53473541900007],
              [-51.44322669199994, 64.53050364800004],
              [-51.44908606699994, 64.52114492400005],
              [-51.45799719999991, 64.51170482000003],
              [-51.48184160099993, 64.50315989800004],
              [-51.490223761999914, 64.49331289300005],
              [-51.497385219999956, 64.48163483300004],
              [-51.505116339999915, 64.47272370000007],
              [-51.57664954299992, 64.43764883000006],
              [-51.59992428299995, 64.39956289300005],
              [-51.628977016999954, 64.38800690300008],
              [-51.69005286399994, 64.37775299700007],
              [-51.70958411399994, 64.36945221600007],
              [-51.711496548999946, 64.36180247600004],
              [-51.69908606699994, 64.35683828300006],
              [-51.675770636999914, 64.35663483300004],
              [-51.675770636999914, 64.34979889500005],
              [-51.68785559799994, 64.34023672100005],
              [-51.68691972599993, 64.32778554900005],
              [-51.67711341099994, 64.31610748900005],
              [-51.66270911399994, 64.30882396000004],
              [-51.70494544199994, 64.30052317900004],
              [-51.72252356699994, 64.29336172100005],
              [-51.73843339799993, 64.28148021000004],
              [-51.76207434799994, 64.25869375200006],
              [-51.77570553299995, 64.24872467700004],
              [-51.793080206999946, 64.23993561400005],
              [-51.83507239499994, 64.22504303600005],
              [-51.85655676999994, 64.22089264500005],
              [-51.88182532499991, 64.21942780200004],
              [-51.93651282499991, 64.22280508000006],
              [-51.95075436099995, 64.21942780200004],
              [-51.93569902299993, 64.21409739800004],
              [-51.930246548999946, 64.21320221600007],
              [-51.93883216099994, 64.20986562700006],
              [-51.96743730399993, 64.20555247600004],
              [-52.001616990999935, 64.20579661700003],
              [-52.03008552099993, 64.19823003900007],
              [-52.05176293099993, 64.19430351100004],
              [-52.073544857999934, 64.19127260000005],
              [-52.0827547909999, 64.20359548200008],
              [-52.083281136999915, 64.21789258300004],
              [-52.09688575999991, 64.23017780300006],
              [-52.1037451709999, 64.23774953700007],
              [-52.11628263099993, 64.22144225800008],
              [-52.14260625199995, 64.22218252700009],
              [-52.152147406999916, 64.24212614900006],
              [-52.16147667899992, 64.25634850200004],
              [-52.14902089499992, 64.27456030100007],
              [-52.125610054999925, 64.29380743200005],
              [-52.12187197399993, 64.31098638500004],
              [-52.12689348099991, 64.32713801900007],
              [-52.16233481799992, 64.33351875300008],
              [-52.15635028899993, 64.34880332600005],
              [-52.139241806999905, 64.36131842500004],
              [-52.12447488499993, 64.37761817200004],
              [-52.11046301999994, 64.39105866100005],
              [-52.1388277449999, 64.40606178000007],
              [-52.14818165499992, 64.41931332600006],
              [-52.15758645999995, 64.43351481800005],
              [-52.180093023999916, 64.44380306100004],
              [-52.19173734499992, 64.45798412100004],
              [-52.19455592999992, 64.47223617400005],
              [-52.174903155999914, 64.47810406100007],
              [-52.14577693199993, 64.46881802800004],
              [-52.109934048999946, 64.46580638200004],
              [-52.10179602799991, 64.47846100500004],
              [-52.088002081999946, 64.48607005400004],
              [-52.07213294199994, 64.49127838700008],
              [-52.04401607999995, 64.49555084800005],
              [-52.04015051999994, 64.50116608300004],
              [-52.046131964999915, 64.50824616100005],
              [-52.09180393999992, 64.50157594100006],
              [-52.11842769499992, 64.50328060100009],
              [-52.11881393199991, 64.51279169100007],
              [-52.12125145999994, 64.51848161100008],
              [-52.10837703999994, 64.52904183700008],
              [-52.141441553999925, 64.52498852000008],
              [-52.15522863599995, 64.53725071400004],
              [-52.14029205599991, 64.55163359200003],
              [-52.09260006399995, 64.56244538000004],
              [-52.05931555899991, 64.56952545800004],
              [-52.044992641999954, 64.57583242400005],
              [-52.030181443999936, 64.58502838700008],
              [-52.02367102799991, 64.59389883000006],
              [-52.021595831999946, 64.59674713700008],
              [-52.02586829299992, 64.61050039300005],
              [-52.037668423999946, 64.60150788000004],
              [-52.06398058399992, 64.58547135600008],
              [-52.09296330899991, 64.58907137900007],
              [-52.11004462199992, 64.57183125500006],
              [-52.1413602099999, 64.57825744700006],
              [-52.15089085499994, 64.59341039800006],
              [-52.16485404799994, 64.60758263800005],
              [-52.170096257999944, 64.62562772900009],
              [-52.161474728999906, 64.63234971000008],
              [-52.093805371999906, 64.61093463700007],
              [-52.049712693999936, 64.61359284100007],
              [-52.04507402299993, 64.62531159100007],
              [-52.05654863199993, 64.63214752800008],
              [-52.111887173999946, 64.64069245000007],
              [-52.12340247299994, 64.64520905200004],
              [-52.12828528599994, 64.65485260600008],
              [-52.12970943899995, 64.66616445500006],
              [-52.13438880099994, 64.67365143400008],
              [-52.14297441299993, 64.67767975500004],
              [-52.15615800699993, 64.67877838700008],
              [-52.13243567599994, 64.71283600500004],
              [-52.097645636999914, 64.73183828300006],
              [-52.05776933499993, 64.73965078300006],
              [-52.01838131399995, 64.74022044500003],
              [-51.99176998599995, 64.73655833500004],
              [-51.97874915299991, 64.73737213700008],
              [-51.96784420499995, 64.74396393400008],
              [-51.940663214999915, 64.78204987200007],
              [-51.93464107999995, 64.78681061400005],
              [-51.923085089999915, 64.78864166900007],
              [-51.911773240999935, 64.78693268400008],
              [-51.90274003799993, 64.78449127800008],
              [-51.895375128999945, 64.78571198100008],
              [-51.88927161399994, 64.79486725500004],
              [-51.90916907499991, 64.79486725500004],
              [-51.89635169199994, 64.81362539300005],
              [-51.87482662699995, 64.82489655200004],
              [-51.73843339799993, 64.85757070500006],
              [-51.72642981699994, 64.85805898600006],
              [-51.69786536399994, 64.85610586100006],
              [-51.68321692599994, 64.85757070500006],
              [-51.652902798999946, 64.86542389500005],
              [-51.642241990999935, 64.87055084800005],
              [-51.634429490999935, 64.87693919500003],
              [-51.62877356699994, 64.88393789300005],
              [-51.62124589799993, 64.88930898600006],
              [-51.60806230399993, 64.89105866100005],
              [-51.59585527299993, 64.88637929900005],
              [-51.58311926999994, 64.86786530200004],
              [-51.56993567599994, 64.86371491100005],
              [-51.54759680899991, 64.86473216400003],
              [-51.53160559799994, 64.86908600500004],
              [-51.51773027299993, 64.87848541900007],
              [-51.50169837099992, 64.89472077000005],
              [-51.48306230399993, 64.90704987200007],
              [-51.438710089999915, 64.92804596600007],
              [-51.43000240799995, 64.94257233300004],
              [-51.41783606699994, 64.95595937700006],
              [-51.39024817599994, 64.96816640800006],
              [-51.35997473899994, 64.97699616100005],
              [-51.31688391799992, 64.98419830900008],
              [-51.28986568899995, 64.99396393400008],
              [-51.26427161399994, 65.00722890800006],
              [-51.244984503999945, 65.02142975500004],
              [-51.27179928299995, 65.03314850500004],
              [-51.29556230399993, 65.02435944200005],
              [-51.32062740799995, 65.00901927300004],
              [-51.35118567599994, 65.00092194200005],
              [-51.40477454299992, 65.01044342700004],
              [-51.42251542899993, 65.00771719000005],
              [-51.43342037699995, 64.99974192900004],
              [-51.42296301999994, 64.99494049700007],
              [-51.38841712099992, 64.98663971600007],
              [-51.457142706999946, 64.97199127800008],
              [-51.47402910099993, 64.96336497600004],
              [-51.48863684799994, 64.95319245000007],
              [-51.583322719999956, 64.91193268400008],
              [-51.66270911399994, 64.89374420800004],
              [-51.703684048999946, 64.89105866100005],
              [-51.69277910099993, 64.89508698100008],
              [-51.68309485599991, 64.90086497600004],
              [-51.675119594999956, 64.90851471600007],
              [-51.66954505099994, 64.91836172100005],
              [-51.68614661399994, 64.92047760600008],
              [-51.68545488199993, 64.92670319200005],
              [-51.66616777299993, 64.94257233300004],
              [-51.66051184799994, 64.95018138200004],
              [-51.65217037699995, 64.96841054900005],
              [-51.64903723899994, 64.97296784100007],
              [-51.63784745999993, 64.97504303600005],
              [-51.590687628999945, 64.97296784100007],
              [-51.578195766999954, 64.97492096600007],
              [-51.56916256399995, 64.97988515800006],
              [-51.552845831999946, 64.99408600500004],
              [-51.62486731699994, 65.00771719000005],
              [-51.66234290299991, 65.02480703300006],
              [-51.675770636999914, 65.02757396000004],
              [-51.692697719999956, 65.02594635600008],
              [-51.70555579299992, 65.02155182500007],
              [-51.713775193999936, 65.01264069200005],
              [-51.716786261999914, 64.99750397300005],
              [-51.72179114499994, 64.98745351800005],
              [-51.73151607999995, 64.98187897300005],
              [-51.73729407499991, 64.97475820500006],
              [-51.731027798999946, 64.95994700700004],
              [-51.761382615999935, 64.95490143400008],
              [-51.792307094999956, 64.94599030200004],
              [-51.82013912699995, 64.93203359600005],
              [-51.84089107999995, 64.91217682500007],
              [-51.82945716099994, 64.91107819200005],
              [-51.81354732999995, 64.91193268400008],
              [-51.79922441299993, 64.91030508000006],
              [-51.793080206999946, 64.90159739800004],
              [-51.78819739499994, 64.88841380400004],
              [-51.76520748599995, 64.87592194200005],
              [-51.75767981699994, 64.86371491100005],
              [-51.76781165299991, 64.86074453300006],
              [-51.789133266999954, 64.85736725500004],
              [-51.79991614499994, 64.85757070500006],
              [-51.79991614499994, 64.86371491100005],
              [-51.78563391799992, 64.87055084800005],
              [-51.81871497299994, 64.88690827000005],
              [-51.83731035099993, 64.89109935100004],
              [-51.85484778599994, 64.88764069200005],
              [-51.87018795499995, 64.87547435100004],
              [-51.869252081999946, 64.86595286700003],
              [-51.86432857999995, 64.85618724200003],
              [-51.86754309799994, 64.84320709800005],
              [-51.87926184799994, 64.83706289300005],
              [-51.94017493399991, 64.81590403900003],
              [-51.94839433499993, 64.81509023600006],
              [-51.97118079299992, 64.80914948100008],
              [-52.01219641799992, 64.80914948100008],
              [-52.066395636999914, 64.79645416900007],
              [-52.087554490999935, 64.79486725500004],
              [-52.10533606699994, 64.79857005400004],
              [-52.09862219999991, 64.80719635600008],
              [-52.06676184799994, 64.82273997600004],
              [-52.00914466099994, 64.83331940300008],
              [-51.99168860599991, 64.83954498900005],
              [-51.985991990999935, 64.84345123900005],
              [-51.97118079299992, 64.85757070500006],
              [-51.943918423999946, 64.87738678600005],
              [-51.960926886999914, 64.88442617400005],
              [-52.004465298999946, 64.89642975500004],
              [-52.02208411399994, 64.89850495000007],
              [-52.03392493399991, 64.90521881700005],
              [-52.04482988199993, 64.91754791900007],
              [-52.05728105399993, 64.92373281500005],
              [-52.07359778599994, 64.91217682500007],
              [-52.04360917899993, 64.88084544500003],
              [-52.07917232999995, 64.84918854400007],
              [-52.18350175699993, 64.80231354400007],
              [-52.19644120999993, 64.80878327000005],
              [-52.21361243399991, 64.81391022300005],
              [-52.22423255099994, 64.82168203300006],
              [-52.217640753999945, 64.83584219000005],
              [-52.18004309799994, 64.84320709800005],
              [-52.15615800699993, 64.86371491100005],
              [-52.21629798099991, 64.88353099200003],
              [-52.22447669199994, 64.89472077000005],
              [-52.217681443999936, 64.91185130400004],
              [-52.20140540299991, 64.91876862200007],
              [-52.162993943999936, 64.92519765800006],
              [-52.125559048999946, 64.94037506700005],
              [-52.106312628999945, 64.94432200700004],
              [-52.08043372299994, 64.94562409100007],
              [-52.064116990999935, 64.94912344000005],
              [-52.04283606699994, 64.95774974200003],
              [-52.02326412699995, 64.96898021000004],
              [-52.01219641799992, 64.98041413000004],
              [-52.03184973899994, 64.98663971600007],
              [-52.101551886999914, 64.98663971600007],
              [-52.08470618399991, 65.00128815300008],
              [-52.076283331999946, 65.01349518400008],
              [-52.082142706999946, 65.02098216400003],
              [-52.10777747299994, 65.02142975500004],
              [-52.145741339999915, 65.00751373900005],
              [-52.16087805899991, 65.00438060100004],
              [-52.162993943999936, 65.01459381700005],
              [-52.18346106699994, 65.02505117400005],
              [-52.19098873599995, 65.02757396000004],
              [-52.17711341099994, 65.03953685100004],
              [-52.162993943999936, 65.04930247600004],
              [-52.242258266999954, 65.06305573100008],
              [-52.278553839999915, 65.07880280200004],
              [-52.27285722599993, 65.10394928600005],
              [-52.25438391799992, 65.11180247600004],
              [-52.23106848899994, 65.11322663000004],
              [-52.18724524599992, 65.11009349200003],
              [-52.17711341099994, 65.10809967700004],
              [-52.16641191299993, 65.10439687700006],
              [-52.15575110599991, 65.10276927300004],
              [-52.14590410099993, 65.10700104400007],
              [-52.13731848899994, 65.11229075700004],
              [-52.125070766999954, 65.11733633000006],
              [-52.101551886999914, 65.12376536700003],
              [-52.101551886999914, 65.13129303600005],
              [-52.11827551999994, 65.13084544500003],
              [-52.14753170499995, 65.12360260600008],
              [-52.162993943999936, 65.12376536700003],
              [-52.17674719999991, 65.12897370000007],
              [-52.18374589799993, 65.13641998900005],
              [-52.19098873599995, 65.15176015800006],
              [-52.19786536399994, 65.15859609600005],
              [-52.20417232999995, 65.16339752800008],
              [-52.207142706999946, 65.16901276200008],
              [-52.203968878999945, 65.17841217700004],
              [-52.19591223899994, 65.18451569200005],
              [-52.15615800699993, 65.20014069200005],
              [-52.06602942599994, 65.27850983300004],
              [-52.004750128999945, 65.31622955900008],
              [-52.02676347599993, 65.31598541900007],
              [-52.05687415299991, 65.30414459800005],
              [-52.08576412699995, 65.28729889500005],
              [-52.122710740999935, 65.25519440300008],
              [-52.17516028599994, 65.22272370000007],
              [-52.19098873599995, 65.21995677300004],
              [-52.21003170499995, 65.21165599200003],
              [-52.23159745999993, 65.20538971600007],
              [-52.25413977799991, 65.20148346600007],
              [-52.27599036399994, 65.20014069200005],
              [-52.29637610599991, 65.20327383000006],
              [-52.30919348899994, 65.21010976800005],
              [-52.30964107999995, 65.21686432500007],
              [-52.293039516999954, 65.21995677300004],
              [-52.26280676999994, 65.23212311400005],
              [-52.22252356699994, 65.25853099200003],
              [-52.19859778599994, 65.28461334800005],
              [-52.217640753999945, 65.29572174700007],
              [-52.19684811099995, 65.31061432500007],
              [-52.19505774599992, 65.32404205900008],
              [-52.20815995999993, 65.33185455900008],
              [-52.23192298099991, 65.32982005400004],
              [-52.242746548999946, 65.32477448100008],
              [-52.266916469999956, 65.30874258000006],
              [-52.27912350199995, 65.30255768400008],
              [-52.31012936099995, 65.29287344000005],
              [-52.32005774599992, 65.28827545800004],
              [-52.332142706999946, 65.29922109600005],
              [-52.337880011999914, 65.31317780200004],
              [-52.33653723899994, 65.32843659100007],
              [-52.32750403599994, 65.34349192900004],
              [-52.35000566299993, 65.33588288000004],
              [-52.36123613199993, 65.31769440300008],
              [-52.36856035099993, 65.29621002800008],
              [-52.379017706999946, 65.27863190300008],
              [-52.42690995999993, 65.22671133000006],
              [-52.444203253999945, 65.21381256700005],
              [-52.45612545499995, 65.20823802300004],
              [-52.46556555899991, 65.20624420800004],
              [-52.488270636999914, 65.20636627800008],
              [-52.518788214999915, 65.19456614800004],
              [-52.53465735599991, 65.19228750200006],
              [-52.529855923999946, 65.20327383000006],
              [-52.51121985599991, 65.21873607000003],
              [-52.47435462099992, 65.24111562700006],
              [-52.45726477799991, 65.25413646000004],
              [-52.47834225199995, 65.25413646000004],
              [-52.470773891999954, 65.25995514500005],
              [-52.462554490999935, 65.26414622600004],
              [-52.45372473899994, 65.26679108300004],
              [-52.444203253999945, 65.26776764500005],
              [-52.444203253999945, 65.27521393400008],
              [-52.46401933499993, 65.28204987200007],
              [-52.46401933499993, 65.28827545800004],
              [-52.460194464999915, 65.28998444200005],
              [-52.45034745999993, 65.29572174700007],
              [-52.469634568999936, 65.30215078300006],
              [-52.48570716099994, 65.29816315300008],
              [-52.499663865999935, 65.29100169500003],
              [-52.51244055899991, 65.28827545800004],
              [-52.52562415299991, 65.29266998900005],
              [-52.56704667899993, 65.31622955900008],
              [-52.56704667899993, 65.32245514500005],
              [-52.54718990799995, 65.33917877800008],
              [-52.520090298999946, 65.35236237200007],
              [-52.490793423999946, 65.36090729400007],
              [-52.46401933499993, 65.36399974200003],
              [-52.437570766999954, 65.37055084800005],
              [-52.38182532499991, 65.39911530200004],
              [-52.35106360599991, 65.40558502800008],
              [-52.28970292899993, 65.41120026200008],
              [-52.23192298099991, 65.42609284100007],
              [-52.15257727799991, 65.46527741100005],
              [-52.036040818999936, 65.49249909100007],
              [-51.981678839999915, 65.49494049700007],
              [-51.96865800699993, 65.49941640800006],
              [-51.95384680899991, 65.51113515800006],
              [-51.946603969999956, 65.51532623900005],
              [-51.92056230399993, 65.52631256700005],
              [-51.91258704299992, 65.52850983300004],
              [-51.89940344999991, 65.53050364800004],
              [-51.866118943999936, 65.54222239800004],
              [-51.85456295499995, 65.54897695500006],
              [-51.84996497299994, 65.55536530200004],
              [-51.845773891999954, 65.57054271000004],
              [-51.84089107999995, 65.57689036700003],
              [-51.812163865999935, 65.58624909100007],
              [-51.74559485599991, 65.58209870000007],
              [-51.716786261999914, 65.58999258000006],
              [-51.74193274599992, 65.59145742400005],
              [-51.78062903599994, 65.60663483300004],
              [-51.80333411399994, 65.61041901200008],
              [-51.857411261999914, 65.60447825700004],
              [-51.88243567599994, 65.60761139500005],
              [-51.90294348899994, 65.62409088700008],
              [-51.87340247299994, 65.64264557500007],
              [-51.76414954299992, 65.67560455900008],
              [-51.73843339799993, 65.67934804900005],
              [-51.717681443999936, 65.69407786700003],
              [-51.68809973899994, 65.70477936400005],
              [-51.491444464999915, 65.74079010600008],
              [-51.12828528599994, 65.76121653900003],
              [-51.09251868399991, 65.75409577000005],
              [-51.072336391999954, 65.75263092700004],
              [-51.02635657499991, 65.76703522300005],
              [-50.983265753999945, 65.76520416900007],
              [-50.93993079299992, 65.75726959800005],
              [-50.90925045499995, 65.74823639500005],
              [-50.80093339799993, 65.70066966400003],
              [-50.74054928299995, 65.68292877800008],
              [-50.675852016999954, 65.67934804900005],
              [-50.53184973899994, 65.69301992400005],
              [-50.53844153599994, 65.69757721600007],
              [-50.54430091099994, 65.70282623900005],
              [-50.54906165299991, 65.70823802300004],
              [-50.55235755099994, 65.71344635600008],
              [-50.68268795499995, 65.70600006700005],
              [-50.74327551999994, 65.69501373900005],
              [-50.772328253999945, 65.69871653900003],
              [-50.79255123599995, 65.72028229400007],
              [-50.75967363199993, 65.72768789300005],
              [-50.69383704299992, 65.72455475500004],
              [-50.662180141999954, 65.72772858300004],
              [-50.662180141999954, 65.73395416900007],
              [-50.66978919199994, 65.73427969000005],
              [-50.689523891999954, 65.74079010600008],
              [-50.68687903599994, 65.75079987200007],
              [-50.68545488199993, 65.75299713700008],
              [-50.68268795499995, 65.75507233300004],
              [-50.76797441299993, 65.76040273600006],
              [-50.81505286399994, 65.75608958500004],
              [-50.84093176999994, 65.74079010600008],
              [-50.86473548099991, 65.75210195500006],
              [-50.88707434799994, 65.76581452000005],
              [-50.91185462099992, 65.77749258000006],
              [-50.943023240999935, 65.78237539300005],
              [-51.042958136999914, 65.77362702000005],
              [-51.25218665299991, 65.79474518400008],
              [-51.44102942599994, 65.77252838700008],
              [-51.916005011999914, 65.66193268400008],
              [-51.93781490799995, 65.66006094000005],
              [-51.97008216099994, 65.67820872600004],
              [-51.99168860599991, 65.67251211100006],
              [-51.94798743399991, 65.62970612200007],
              [-51.933583136999914, 65.60468170800004],
              [-51.93651282499991, 65.57689036700003],
              [-51.916859503999945, 65.57029857000003],
              [-51.93122311099995, 65.55638255400004],
              [-51.99429277299993, 65.52191803600005],
              [-52.049672003999945, 65.51422760600008],
              [-52.07017981699994, 65.50458405200004],
              [-52.09032141799992, 65.49799225500004],
              [-52.18004309799994, 65.50116608300004],
              [-52.19367428299995, 65.49469635600008],
              [-52.22325598899994, 65.46613190300008],
              [-52.23501542899993, 65.45962148600006],
              [-52.27285722599993, 65.44651927300004],
              [-52.29674231699994, 65.44171784100007],
              [-52.32005774599992, 65.43976471600007],
              [-52.369984503999945, 65.44171784100007],
              [-52.39049231699994, 65.43829987200007],
              [-52.47313391799992, 65.39496491100005],
              [-52.49132239499994, 65.39191315300008],
              [-52.50365149599992, 65.39716217700004],
              [-52.546538865999935, 65.43231842700004],
              [-52.53392493399991, 65.44367096600007],
              [-52.49132239499994, 65.46702708500004],
              [-52.49876868399991, 65.47386302300004],
              [-52.452015753999945, 65.50873444200005],
              [-52.444203253999945, 65.51788971600007],
              [-52.45523027299993, 65.52415599200003],
              [-52.48033606699994, 65.51605866100005],
              [-52.50694739499994, 65.50218333500004],
              [-52.540272589999915, 65.47992584800005],
              [-52.563059048999946, 65.47211334800005],
              [-52.58531653599994, 65.46942780200004],
              [-52.60118567599994, 65.47386302300004],
              [-52.61424719999991, 65.48981354400007],
              [-52.60582434799994, 65.49738190300008],
              [-52.56704667899993, 65.50800202000005],
              [-52.599720831999946, 65.52277252800008],
              [-52.608713344999956, 65.52850983300004],
              [-52.57164466099994, 65.55768463700008],
              [-52.52183997299994, 65.58787669500003],
              [-52.481027798999946, 65.62433502800008],
              [-52.47085527299993, 65.67251211100006],
              [-52.50072180899991, 65.65412018400008],
              [-52.52672278599994, 65.63153717700004],
              [-52.53848222599993, 65.61131419500003],
              [-52.546538865999935, 65.60114166900007],
              [-52.55711829299992, 65.59674713700008],
              [-52.571603969999956, 65.59373607000003],
              [-52.586822068999936, 65.58616771000004],
              [-52.600900844999956, 65.57623932500007],
              [-52.61172441299993, 65.56606679900005],
              [-52.61554928299995, 65.56037018400008],
              [-52.61733964799993, 65.55288320500006],
              [-52.62169348899994, 65.54897695500006],
              [-52.63003495999993, 65.54490794500003],
              [-52.648548956999946, 65.53900788000004],
              [-52.65583248599995, 65.53534577000005],
              [-52.66698157499991, 65.52509186400005],
              [-52.67564856699994, 65.51471588700008],
              [-52.68472245999993, 65.50604889500005],
              [-52.69741777299993, 65.50116608300004],
              [-52.71556555899991, 65.50214264500005],
              [-52.72203528599994, 65.50946686400005],
              [-52.72569739499994, 65.51772695500006],
              [-52.73497473899994, 65.52167389500005],
              [-52.767241990999935, 65.52484772300005],
              [-52.79173743399991, 65.53473541900007],
              [-52.800852016999954, 65.55194733300004],
              [-52.786773240999935, 65.57689036700003],
              [-52.76667232999995, 65.57428620000007],
              [-52.73062089799993, 65.58567942900004],
              [-52.663319464999915, 65.61790599200003],
              [-52.69676673099991, 65.61587148600006],
              [-52.76642818899995, 65.59369538000004],
              [-52.800445115999935, 65.59674713700008],
              [-52.775054490999935, 65.61196523600006],
              [-52.649281378999945, 65.65363190300008],
              [-52.57892818899995, 65.66657135600008],
              [-52.546538865999935, 65.67934804900005],
              [-52.57286536399994, 65.68646881700005],
              [-52.605132615999935, 65.68036530200004],
              [-52.688343878999945, 65.65127187700006],
              [-52.74453691299993, 65.63873932500007],
              [-52.77253170499995, 65.63837311400005],
              [-52.75560462099992, 65.67230866100005],
              [-52.72085527299993, 65.69135163000004],
              [-52.64220130099994, 65.71344635600008],
              [-52.67808997299994, 65.72016022300005],
              [-52.69058183499993, 65.72028229400007],
              [-52.67878170499995, 65.75372955900008],
              [-52.68004309799994, 65.79022858300004],
              [-52.693430141999954, 65.80727773600006],
              [-52.71792558499993, 65.78237539300005],
              [-52.75816809799994, 65.71263255400004],
              [-52.78685462099992, 65.68406810100004],
              [-52.82404537699995, 65.67251211100006],
              [-52.83739173099991, 65.67568594000005],
              [-52.86302649599992, 65.68976471600007],
              [-52.875559048999946, 65.69301992400005],
              [-52.888010219999956, 65.69135163000004],
              [-52.912180141999954, 65.68301015800006],
              [-53.00108801999994, 65.66624583500004],
              [-53.19041907499991, 65.67523834800005],
              [-53.23924719999991, 65.68618398600006],
              [-53.149281378999945, 65.72772858300004],
              [-53.09561113199993, 65.73798248900005],
              [-53.01797441299993, 65.74371979400007],
              [-52.991118943999936, 65.75116608300004],
              [-52.96564693899995, 65.76117584800005],
              [-52.92617753799993, 65.78339264500005],
              [-52.877023891999954, 65.79450104400007],
              [-52.85448157499991, 65.80223216400003],
              [-52.877837693999936, 65.80878327000005],
              [-52.89024817599994, 65.81000397300005],
              [-52.902902798999946, 65.80971914300005],
              [-52.91429602799991, 65.80678945500006],
              [-52.934437628999945, 65.79791901200008],
              [-53.01357988199993, 65.77920156500005],
              [-53.06505286399994, 65.75495026200008],
              [-53.11070716099994, 65.74738190300008],
              [-53.23936926999994, 65.73989492400005],
              [-53.26024329299992, 65.74315013200004],
              [-53.262562628999945, 65.75165436400005],
              [-53.25332597599993, 65.75580475500004],
              [-53.21751868399991, 65.75507233300004],
              [-53.20958411399994, 65.75796133000006],
              [-53.193918423999946, 65.76683177300004],
              [-53.17906653599994, 65.77081940300008],
              [-53.163319464999915, 65.78021881700005],
              [-53.14004472599993, 65.78400299700007],
              [-53.11392167899993, 65.79254791900007],
              [-53.03921464799993, 65.80833567900004],
              [-53.019520636999914, 65.81586334800005],
              [-53.05455481699994, 65.81049225500004],
              [-53.07144120999993, 65.81028880400004],
              [-53.08849036399994, 65.81586334800005],
              [-53.07640540299991, 65.82404205900008],
              [-53.05060787699995, 65.85374583500004],
              [-53.03311113199993, 65.86395905200004],
              [-52.99156653599994, 65.86908600500004],
              [-52.931304490999935, 65.88548411700003],
              [-52.889230923999946, 65.89158763200004],
              [-52.869211391999954, 65.88910553600005],
              [-52.850493943999936, 65.88275788000004],
              [-52.83234615799995, 65.87909577000005],
              [-52.81407630099994, 65.88475169500003],
              [-52.82144120999993, 65.89203522300005],
              [-52.82656816299993, 65.89581940300008],
              [-52.833973761999914, 65.89838288000004],
              [-52.81358801999994, 65.91299062700006],
              [-52.77212480399993, 65.92617422100005],
              [-52.69399980399993, 65.93939850500004],
              [-52.65143795499995, 65.93195221600007],
              [-52.56680253799993, 65.89899323100008],
              [-52.409087693999936, 65.87791575700004],
              [-52.36009680899991, 65.87840403900003],
              [-52.33824622299994, 65.87457916900007],
              [-52.32005774599992, 65.86432526200008],
              [-52.31745357999995, 65.85907623900005],
              [-52.31794186099995, 65.84813060100004],
              [-52.31383216099994, 65.84320709800005],
              [-52.30874589799993, 65.84052155200004],
              [-52.29918372299994, 65.83714427300004],
              [-52.29002844999991, 65.83771393400008],
              [-52.28587805899991, 65.84686920800004],
              [-52.27725175699993, 65.86009349200003],
              [-52.25723222599993, 65.86839427300004],
              [-52.217640753999945, 65.87791575700004],
              [-52.217640753999945, 65.88475169500003],
              [-52.26121985599991, 65.89533112200007],
              [-52.26211503799993, 65.91421133000006],
              [-52.23574785099993, 65.93537018400008],
              [-52.19713294199994, 65.95302969000005],
              [-51.977406378999945, 66.00360748900005],
              [-51.93199622299994, 66.00360748900005],
              [-51.88719641799992, 65.99551015800006],
              [-51.84089107999995, 65.98094310100004],
              [-51.77448482999995, 65.94334544500003],
              [-51.73985755099994, 65.93060944200005],
              [-51.71117102799991, 65.93939850500004],
              [-51.745757615999935, 65.96401601800005],
              [-51.82603919199994, 65.99640534100007],
              [-51.84557044199994, 66.00763580900008],
              [-51.861317511999914, 66.02191803600005],
              [-51.832102016999954, 66.04047272300005],
              [-51.798817511999914, 66.05418528900003],
              [-51.731027798999946, 66.07037995000007],
              [-51.731027798999946, 66.07591380400004],
              [-51.79702714799993, 66.07070547100005],
              [-52.08775794199994, 66.00486888200004],
              [-52.181711391999954, 65.99799225500004],
              [-52.21068274599992, 65.98981354400007],
              [-52.23810787699995, 65.97418854400007],
              [-52.28685462099992, 65.91461823100008],
              [-52.303293423999946, 65.90521881700005],
              [-52.50454667899993, 65.90501536700003],
              [-52.53425045499995, 65.90985748900005],
              [-52.55711829299992, 65.92267487200007],
              [-52.59251868399991, 65.94798411700003],
              [-52.594309048999946, 65.95844147300005],
              [-52.57331295499995, 65.97418854400007],
              [-52.51927649599992, 65.99404531500005],
              [-52.56090247299994, 66.00804271000004],
              [-52.57640540299991, 66.00804271000004],
              [-52.690297003999945, 65.96356842700004],
              [-52.71499589799993, 65.96039459800005],
              [-52.738840298999946, 65.96808502800008],
              [-52.77965247299994, 65.99091217700004],
              [-52.80211341099994, 65.99481842700004],
              [-52.80028235599991, 65.98053620000007],
              [-52.78001868399991, 65.94684479400007],
              [-52.80768795499995, 65.94550202000005],
              [-52.864491339999915, 65.92479075700004],
              [-52.94371497299994, 65.90753815300008],
              [-52.966867641999954, 65.89590078300006],
              [-53.00405839799993, 65.89207591400003],
              [-53.15412350199995, 65.86054108300004],
              [-53.18101966099994, 65.85980866100005],
              [-53.20767167899993, 65.86298248900005],
              [-53.23184160099993, 65.87107982000003],
              [-53.218820766999954, 65.88955312700006],
              [-53.194569464999915, 65.89166901200008],
              [-53.14305579299992, 65.88475169500003],
              [-53.142567511999914, 65.88934967700004],
              [-53.14391028599994, 65.89057038000004],
              [-53.146473761999914, 65.89057038000004],
              [-53.149281378999945, 65.89158763200004],
              [-53.15929114499994, 65.89911530200004],
              [-53.26598059799994, 65.91209544500003],
              [-53.26598059799994, 65.91958242400005],
              [-53.13231360599991, 65.95282623900005],
              [-53.09552975199995, 65.96653880400004],
              [-52.87490800699993, 66.02191803600005],
              [-52.92100989499994, 66.03668854400007],
              [-52.97801673099991, 66.02269114800004],
              [-53.03595943899995, 65.99982330900008],
              [-53.12905839799993, 65.98163483300004],
              [-53.25914466099994, 65.93939850500004],
              [-53.25503495999993, 65.94623444200005],
              [-53.25230872299994, 65.95302969000005],
              [-53.29954993399991, 65.95490143400008],
              [-53.31436113199993, 65.95302969000005],
              [-53.32652747299994, 65.94790273600006],
              [-53.34557044199994, 65.93512604400007],
              [-53.35875403599994, 65.93256256700005],
              [-53.39020748599995, 65.93585846600007],
              [-53.42520097599993, 65.94550202000005],
              [-53.45539303299995, 65.96076080900008],
              [-53.47203528599994, 65.98094310100004],
              [-53.44806881399995, 65.98265208500004],
              [-53.42870032499991, 65.99005768400008],
              [-53.41047115799995, 65.99949778900003],
              [-53.38947506399995, 66.00763580900008],
              [-53.36660722599993, 66.00999583500004],
              [-53.296986456999946, 66.00145091400003],
              [-53.10765540299991, 66.02191803600005],
              [-53.15811113199993, 66.03070709800005],
              [-53.31436113199993, 66.01508209800005],
              [-53.31436113199993, 66.02191803600005],
              [-53.30724036399994, 66.02480703300006],
              [-53.30215410099993, 66.02822500200006],
              [-53.293853318999936, 66.03558991100005],
              [-53.42711341099994, 66.02228424700007],
              [-53.46458899599992, 66.03558991100005],
              [-53.382069464999915, 66.07831452000005],
              [-53.10765540299991, 66.15228913000004],
              [-52.99673417899993, 66.17177969000005],
              [-52.73940995999993, 66.26215241100005],
              [-52.71792558499993, 66.29262929900005],
              [-52.713002081999946, 66.31195709800005],
              [-52.70030676999994, 66.32428620000007],
              [-52.68276933499993, 66.33193594000005],
              [-52.48338782499991, 66.38930898600006],
              [-52.360991990999935, 66.44025299700007],
              [-52.24063066299993, 66.44969310100004],
              [-52.05313066299993, 66.48749420800004],
              [-52.00226803299995, 66.48505280200004],
              [-51.97793535099993, 66.48810455900008],
              [-51.96442623599995, 66.50112539300005],
              [-51.98322506399995, 66.50116608300004],
              [-52.00576738199993, 66.50568268400008],
              [-52.02476966099994, 66.51312897300005],
              [-52.03262285099993, 66.52220286700003],
              [-52.02513587099992, 66.53558991100005],
              [-52.00812740799995, 66.54852936400005],
              [-51.977406378999945, 66.56378815300008],
              [-51.97179114499994, 66.58112213700008],
              [-51.939564581999946, 66.60516998900005],
              [-51.874663865999935, 66.64203522300005],
              [-51.83922278599994, 66.65460846600007],
              [-51.72419186099995, 66.67243073100008],
              [-51.61497962099992, 66.70355866100005],
              [-51.459055141999954, 66.70429108300004],
              [-51.445423956999946, 66.70783112200007],
              [-51.43000240799995, 66.72085195500006],
              [-51.45445716099994, 66.72174713700008],
              [-51.48021399599992, 66.72549062700006],
              [-51.50470943899995, 66.73212311400005],
              [-51.52497311099995, 66.74192942900004],
              [-51.458973761999914, 66.76618073100008],
              [-51.43993079299992, 66.77920156500005],
              [-51.42235266799992, 66.78489817900004],
              [-51.36681067599994, 66.79621002800008],
              [-51.36107337099992, 66.80280182500007],
              [-51.28335527299993, 66.84491608300004],
              [-51.25804602799991, 66.85114166900007],
              [-51.18228105399993, 66.85114166900007],
              [-51.12100175699993, 66.83730703300006],
              [-51.10041256399995, 66.83755117400005],
              [-51.12368730399993, 66.85248444200005],
              [-51.14883378799993, 66.86420319200005],
              [-51.11628170499995, 66.88056061400005],
              [-51.05431067599994, 66.87323639500005],
              [-50.89305579299992, 66.83014557500007],
              [-50.72028561099995, 66.83966705900008],
              [-50.67756100199995, 66.84906647300005],
              [-50.65538489499994, 66.85114166900007],
              [-50.625559048999946, 66.84804922100005],
              [-50.56777910099993, 66.83388906500005],
              [-50.36400305899991, 66.82929108300004],
              [-50.33315995999993, 66.84495677300004],
              [-50.59703528599994, 66.85797760600008],
              [-50.678578253999945, 66.87543366100005],
              [-50.699777798999946, 66.86798737200007],
              [-50.73468990799995, 66.85077545800004],
              [-50.77969316299993, 66.85150788000004],
              [-51.01162675699993, 66.90574778900003],
              [-50.96397864499994, 66.93569570500006],
              [-50.85114498599995, 66.95921458500004],
              [-50.78384355399993, 66.98362864800004],
              [-50.73729407499991, 66.98834870000007],
              [-50.69664466099994, 67.00495026200008],
              [-50.68268795499995, 67.00885651200008],
              [-50.64753170499995, 67.00971100500004],
              [-50.57957923099991, 66.99778880400004],
              [-50.49351966099994, 66.99697500200006],
              [-50.47960364499994, 66.99681224200003],
              [-50.30064856699994, 66.99506256700005],
              [-50.132069464999915, 66.96735260600008],
              [-50.05882727799991, 66.96800364800004],
              [-49.99742591099994, 66.98151276200008],
              [-50.02721106699994, 66.99152252800008],
              [-50.10179602799991, 66.99616120000007],
              [-50.20018469999991, 66.99144114800004],
              [-50.22337805899991, 66.99457428600005],
              [-50.29059811099995, 67.01264069200005],
              [-50.350819464999915, 67.01512278900003],
              [-50.43492591099994, 67.00893789300005],
              [-50.4697566399999, 67.00051504100009],
              [-50.48037675699993, 67.00027090100008],
              [-50.49404863199993, 67.00051504100009],
              [-50.511504686999956, 67.00108470300006],
              [-50.57127844999991, 67.01642487200007],
              [-50.63426673099991, 67.01504140800006],
              [-50.63426673099991, 67.02252838700008],
              [-50.615305141999954, 67.02619049700007],
              [-50.57921301999994, 67.03864166900007],
              [-50.55972245999993, 67.04295482000003],
              [-50.48704993399991, 67.04246653900003],
              [-50.302845831999946, 67.06386953300006],
              [-50.28477942599994, 67.07025788000004],
              [-50.31932532499991, 67.07855866100005],
              [-50.59422766799992, 67.04214101800005],
              [-50.66356360599991, 67.01972077000005],
              [-50.712228969999956, 67.01288483300004],
              [-50.743397589999915, 67.00348541900007],
              [-50.75812740799995, 67.00141022300005],
              [-50.81476803299995, 67.00214264500005],
              [-50.89598548099991, 66.99290599200003],
              [-51.095814581999946, 66.93073151200008],
              [-51.12828528599994, 66.92694733300004],
              [-51.174672003999945, 66.92788320500006],
              [-51.18602454299992, 66.92324453300006],
              [-51.21397864499994, 66.90704987200007],
              [-51.32013912699995, 66.88593170800004],
              [-51.39753170499995, 66.84926992400005],
              [-51.460926886999914, 66.84125397300005],
              [-51.493397589999915, 66.83152903900003],
              [-51.71349036399994, 66.72370026200008],
              [-51.970814581999946, 66.66205475500004],
              [-52.02586829299992, 66.62523021000004],
              [-52.09825598899994, 66.54682038000004],
              [-52.13975989499994, 66.51756419500003],
              [-52.278228318999936, 66.48191966400003],
              [-52.30016028599994, 66.48126862200007],
              [-52.71922766799992, 66.34870026200008],
              [-52.88516191299993, 66.24884674700007],
              [-53.005848761999914, 66.20001862200007],
              [-53.35366777299993, 66.11212799700007],
              [-53.45091712099992, 66.10390859600005],
              [-53.59984290299991, 66.12474192900004],
              [-53.65021725199995, 66.12433502800008],
              [-53.52586829299992, 66.15204498900005],
              [-53.48570716099994, 66.15228913000004],
              [-53.48570716099994, 66.15851471600007],
              [-53.66319739499994, 66.13861725500004],
              [-53.63780676999994, 66.15058014500005],
              [-53.60680091099994, 66.17039622600004],
              [-53.583648240999935, 66.19147370000007],
              [-53.58189856699994, 66.20693594000005],
              [-53.58189856699994, 66.21377187700006],
              [-53.52969316299993, 66.23322174700007],
              [-53.47370357999995, 66.24363841400003],
              [-53.32697506399995, 66.25092194200005],
              [-53.121937628999945, 66.28945547100005],
              [-53.211048956999946, 66.28261953300006],
              [-53.289133266999954, 66.29067617400005],
              [-53.31436113199993, 66.28945547100005],
              [-53.37564042899993, 66.27094147300005],
              [-53.47508704299992, 66.26251862200007],
              [-53.49868730399993, 66.25470612200007],
              [-53.49868730399993, 66.26215241100005],
              [-53.52578691299993, 66.25275299700007],
              [-53.565012173999946, 66.24624258000006],
              [-53.602853969999956, 66.24502187700006],
              [-53.62596594999991, 66.25161367400005],
              [-53.65697180899991, 66.27521393400008],
              [-53.65534420499995, 66.28632233300004],
              [-53.64761308499993, 66.29262929900005],
              [-53.639515753999945, 66.29702383000006],
              [-53.63646399599992, 66.30312734600005],
              [-53.64903723899994, 66.32147858300004],
              [-53.68883216099994, 66.32737864800004],
              [-53.697336391999954, 66.34715403900003],
              [-53.695301886999914, 66.35883209800005],
              [-53.690337693999936, 66.36538320500006],
              [-53.68390865799995, 66.37034739800004],
              [-53.67747962099992, 66.37763092700004],
              [-53.66466223899994, 66.40412018400008],
              [-53.65697180899991, 66.41233958500004],
              [-53.636382615999935, 66.40509674700007],
              [-53.61705481699994, 66.41266510600008],
              [-53.58503170499995, 66.44334544500003],
              [-53.56680253799993, 66.45575592700004],
              [-53.54442298099991, 66.46393463700008],
              [-53.49868730399993, 66.47443268400008],
              [-53.49868730399993, 66.48126862200007],
              [-53.52830969999991, 66.48102448100008],
              [-53.56615149599992, 66.46759674700007],
              [-53.60216223899994, 66.44806549700007],
              [-53.64317786399994, 66.41787344000005],
              [-53.65001380099994, 66.42658112200007],
              [-53.650949673999946, 66.44196198100008],
              [-53.65021725199995, 66.45018138200004],
              [-53.64199785099993, 66.46043528900003],
              [-53.60236568899995, 66.47235748900005],
              [-53.58812415299991, 66.48126862200007],
              [-53.63646399599992, 66.50112539300005],
              [-53.62295488199993, 66.50897858300004],
              [-53.51943925699993, 66.52826569200005],
              [-53.39635169199994, 66.52846914300005],
              [-53.38556881399995, 66.53156159100007],
              [-53.377064581999946, 66.53774648600006],
              [-53.36799068899995, 66.54193756700005],
              [-53.32408606699994, 66.52887604400007],
              [-53.28551184799994, 66.52391185100004],
              [-53.21133378799993, 66.52220286700003],
              [-53.21133378799993, 66.51536692900004],
              [-53.35533606699994, 66.52220286700003],
              [-53.32799231699994, 66.51068756700005],
              [-53.29596920499995, 66.50283437700006],
              [-53.20099850199995, 66.49323151200008],
              [-53.17039954299992, 66.49494049700007],
              [-53.15615800699993, 66.49966054900005],
              [-53.12922115799995, 66.51268138200004],
              [-52.95140540299991, 66.54474518400008],
              [-52.83088131399995, 66.55011627800008],
              [-52.815337693999936, 66.54791901200008],
              [-52.78669186099995, 66.53807200700004],
              [-52.45726477799991, 66.52220286700003],
              [-52.44399980399993, 66.52537669500003],
              [-52.42951412699995, 66.53937409100007],
              [-52.41624915299991, 66.54271067900004],
              [-52.41624915299991, 66.55011627800008],
              [-52.45775305899991, 66.55866120000007],
              [-52.61485755099994, 66.55011627800008],
              [-52.724720831999946, 66.56378815300008],
              [-52.80532792899993, 66.56293366100005],
              [-52.820301886999914, 66.57001373900005],
              [-52.820301886999914, 66.57684967700004],
              [-52.98851477799991, 66.57684967700004],
              [-53.02131100199995, 66.57265859600005],
              [-53.08747311099995, 66.55434804900005],
              [-53.121937628999945, 66.55011627800008],
              [-53.22642981699994, 66.55223216400003],
              [-53.26659094999991, 66.56167226800005],
              [-53.41002356699994, 66.57135651200008],
              [-53.43106035099993, 66.58429596600007],
              [-53.414621548999946, 66.58633047100005],
              [-53.38516191299993, 66.59577057500007],
              [-53.36900794199994, 66.59796784100007],
              [-53.34276282499991, 66.59772370000007],
              [-53.33250891799992, 66.60346100500004],
              [-53.327381964999915, 66.61839427300004],
              [-53.34605872299994, 66.61798737200007],
              [-53.354074673999946, 66.61591217700004],
              [-53.362172003999945, 66.61098867400005],
              [-53.386708136999914, 66.61847565300008],
              [-53.45567786399994, 66.60561758000006],
              [-53.48570716099994, 66.61098867400005],
              [-53.47215735599991, 66.61579010600008],
              [-53.43106035099993, 66.62523021000004],
              [-53.43106035099993, 66.63206614800004],
              [-53.438343878999945, 66.63275788000004],
              [-53.45775305899991, 66.63825104400007],
              [-53.42690995999993, 66.64533112200007],
              [-53.28648841099994, 66.69354889500005],
              [-53.25934811099995, 66.69818756700005],
              [-53.23468990799995, 66.69721100500004],
              [-53.18399003799993, 66.68671295800004],
              [-53.09666907499991, 66.68903229400007],
              [-53.07762610599991, 66.68329498900005],
              [-53.05406653599994, 66.67291901200008],
              [-52.83348548099991, 66.68988678600005],
              [-52.78880774599992, 66.70400625200006],
              [-52.76598059799994, 66.70722077000005],
              [-52.66746985599991, 66.69301992400005],
              [-52.635975714999915, 66.69354889500005],
              [-52.63829505099994, 66.69794342700004],
              [-52.63906816299993, 66.69839101800005],
              [-52.64220130099994, 66.70038483300004],
              [-52.62865149599992, 66.70624420800004],
              [-52.61314856699994, 66.70799388200004],
              [-52.58071855399993, 66.70722077000005],
              [-52.592681443999936, 66.71332428600005],
              [-52.59703528599994, 66.72138092700004],
              [-52.594960089999915, 66.73102448100008],
              [-52.587554490999935, 66.74192942900004],
              [-52.67007402299993, 66.73509349200003],
              [-52.69220943899995, 66.73582591400003],
              [-52.752064581999946, 66.74811432500007],
              [-52.78844153599994, 66.74652741100005],
              [-52.98477128799993, 66.70722077000005],
              [-53.005116339999915, 66.70905182500007],
              [-53.04084225199995, 66.71816640800006],
              [-53.06114661399994, 66.72085195500006],
              [-53.11693274599992, 66.71820709800005],
              [-53.135609503999945, 66.72085195500006],
              [-53.20449785099993, 66.74811432500007],
              [-53.190297003999945, 66.75185781500005],
              [-53.14305579299992, 66.74192942900004],
              [-53.07721920499995, 66.74738190300008],
              [-53.046131964999915, 66.74282461100006],
              [-53.03087317599994, 66.74579498900005],
              [-53.005848761999914, 66.75433991100005],
              [-52.985585089999915, 66.75678131700005],
              [-52.815663214999915, 66.75836823100008],
              [-52.761830206999946, 66.77448151200008],
              [-52.74657141799992, 66.77643463700008],
              [-52.711048956999946, 66.77606842700004],
              [-52.69546464799993, 66.77944570500006],
              [-52.64903723899994, 66.80097077000005],
              [-52.652333136999914, 66.81098053600005],
              [-52.66665605399993, 66.82697174700007],
              [-52.68073482999995, 66.83348216400003],
              [-52.69644120999993, 66.82982005400004],
              [-52.724720831999946, 66.81708405200004],
              [-52.793039516999954, 66.80955638200004],
              [-52.81163489499994, 66.81126536700003],
              [-52.84552975199995, 66.82094961100006],
              [-52.86164303299995, 66.82322825700004],
              [-52.93309485599991, 66.81647370000007],
              [-53.09227454299992, 66.76634349200003],
              [-53.10765540299991, 66.77236562700006],
              [-53.10106360599991, 66.78400299700007],
              [-53.08551998599995, 66.79319896000004],
              [-53.06753495999993, 66.79970937700006],
              [-53.05370032499991, 66.80280182500007],
              [-53.05370032499991, 66.80955638200004],
              [-53.06289628799993, 66.81061432500007],
              [-53.08849036399994, 66.81708405200004],
              [-53.03278561099995, 66.84528229400007],
              [-53.002064581999946, 66.85512929900005],
              [-52.97179114499994, 66.85797760600008],
              [-52.90672766799992, 66.83877187700006],
              [-52.876616990999935, 66.83661530200004],
              [-52.87490800699993, 66.85797760600008],
              [-52.488352016999954, 66.85455963700008],
              [-52.34044348899994, 66.81679922100005],
              [-52.29527747299994, 66.81500885600008],
              [-52.25422115799995, 66.82273997600004],
              [-52.23192298099991, 66.84495677300004],
              [-52.32799231699994, 66.83950429900005],
              [-52.354807094999956, 66.84495677300004],
              [-52.395415818999936, 66.86798737200007],
              [-52.41169186099995, 66.87278880400004],
              [-52.446929490999935, 66.87348053600005],
              [-52.46401933499993, 66.87848541900007],
              [-52.44473222599993, 66.88410065300008],
              [-52.30955969999991, 66.89435455900008],
              [-52.29271399599992, 66.89960358300004],
              [-52.29767818899995, 66.90094635600008],
              [-52.302072719999956, 66.90395742400005],
              [-52.30638587099992, 66.90574778900003],
              [-52.30142167899993, 66.91107819200005],
              [-52.29271399599992, 66.92694733300004],
              [-52.31798255099994, 66.92462799700007],
              [-52.36461341099994, 66.91486237200007],
              [-52.475168423999946, 66.91107819200005],
              [-52.49876868399991, 66.91941966400003],
              [-52.48981686099995, 66.92788320500006],
              [-52.48851477799991, 66.93561432500007],
              [-52.49400794199994, 66.94204336100006],
              [-52.50499426999994, 66.94611237200007],
              [-52.47813880099994, 66.96173737200007],
              [-52.45034745999993, 66.97406647300005],
              [-52.45034745999993, 66.98151276200008],
              [-52.48875891799992, 66.97923411700003],
              [-52.518462693999936, 66.96499258000006],
              [-52.56704667899993, 66.92694733300004],
              [-52.603179490999935, 66.91201406500005],
              [-52.79979407499991, 66.89215729400007],
              [-52.82453365799995, 66.89472077000005],
              [-52.88239498599995, 66.91258372600004],
              [-53.06737219999991, 66.91258372600004],
              [-53.063343878999945, 66.92304108300004],
              [-53.06114661399994, 66.92694733300004],
              [-53.095773891999954, 66.93195221600007],
              [-53.35777747299994, 66.92133209800005],
              [-53.375843878999945, 66.91608307500007],
              [-53.389515753999945, 66.91445547100005],
              [-53.45091712099992, 66.91941966400003],
              [-53.647043423999946, 66.91156647300005],
              [-53.68431555899991, 66.91941966400003],
              [-53.678944464999915, 66.92865631700005],
              [-53.67096920499995, 66.93357982000003],
              [-53.65021725199995, 66.93992747600004],
              [-53.670480923999946, 66.94672272300005],
              [-53.77183997299994, 66.95677317900004],
              [-53.807484503999945, 66.97089264500005],
              [-53.82485917899993, 66.97406647300005],
              [-53.828684048999946, 66.97724030200004],
              [-53.82835852799991, 66.98432038000004],
              [-53.82457434799994, 66.99140045800004],
              [-53.81773841099994, 66.99457428600005],
              [-53.759429490999935, 66.99457428600005],
              [-53.63646399599992, 66.98151276200008],
              [-53.423939581999946, 66.99457428600005],
              [-53.31436113199993, 66.98151276200008],
              [-53.26447506399995, 66.98436107000003],
              [-53.21751868399991, 66.99457428600005],
              [-53.251616990999935, 67.00543854400007],
              [-53.56017005099994, 67.01504140800006],
              [-53.575103318999936, 67.01105377800008],
              [-53.601633266999954, 66.99799225500004],
              [-53.61538652299993, 66.99457428600005],
              [-53.63463294199994, 66.99652741100005],
              [-53.69054114499994, 67.01504140800006],
              [-53.77529863199993, 67.01776764500005],
              [-53.81493079299992, 67.02704498900005],
              [-53.81403561099995, 67.04979075700004],
              [-53.829416469999956, 67.06386953300006],
              [-53.80614173099991, 67.07282135600008],
              [-53.73892167899993, 67.07770416900007],
              [-53.588734503999945, 67.07025788000004],
              [-53.42983964799993, 67.09540436400005],
              [-53.40306555899991, 67.10492584800005],
              [-53.39781653599994, 67.11245351800005],
              [-53.43106035099993, 67.11127350500004],
              [-53.553944464999915, 67.09076569200005],
              [-53.964914516999954, 67.07770416900007],
              [-53.94579016799992, 67.09332916900007],
              [-53.93814042899993, 67.09760163000004],
              [-53.94640051999994, 67.09760163000004],
              [-53.964914516999954, 67.10443756700005],
              [-53.93578040299991, 67.11493561400005],
              [-53.91966712099992, 67.11790599200003],
              [-53.90343176999994, 67.11871979400007],
              [-53.923939581999946, 67.12490469000005],
              [-53.91665605399993, 67.13043854400007],
              [-53.90843665299991, 67.13475169500003],
              [-53.899322068999936, 67.13768138200004],
              [-53.88975989499994, 67.13922760600008],
              [-53.914621548999946, 67.14516836100006],
              [-53.923939581999946, 67.14541250200006],
              [-53.90689042899993, 67.15338776200008],
              [-53.89338131399995, 67.15338776200008],
              [-53.879750128999945, 67.15127187700006],
              [-53.86241614499994, 67.15281810100004],
              [-53.85700436099995, 67.15688711100006],
              [-53.85326087099992, 67.16351959800005],
              [-53.85073808499993, 67.16998932500007],
              [-53.84878495999993, 67.17328522300005],
              [-53.840687628999945, 67.17609284100007],
              [-53.71165930899991, 67.19228750200006],
              [-53.41185462099992, 67.19635651200008],
              [-53.38267981699994, 67.20685455900008],
              [-53.40615800699993, 67.20734284100007],
              [-53.453114386999914, 67.21393463700008],
              [-53.53453528599994, 67.20929596600007],
              [-53.563384568999936, 67.21133047100005],
              [-53.58812415299991, 67.22113678600005],
              [-53.559803839999915, 67.23236725500004],
              [-53.521473761999914, 67.24135976800005],
              [-53.48224850199995, 67.24445221600007],
              [-53.42015540299991, 67.23163483300004],
              [-53.38316809799994, 67.23436107000003],
              [-53.31436113199993, 67.24774811400005],
              [-53.074208136999914, 67.25527578300006],
              [-53.05724036399994, 67.25824616100005],
              [-53.02375240799995, 67.27204010600008],
              [-53.005848761999914, 67.27570221600007],
              [-52.93016516799992, 67.26951732000003],
              [-52.88589433499993, 67.28074778900003],
              [-52.85521399599992, 67.28465403900003],
              [-52.82408606699994, 67.29409414300005],
              [-52.58043372299994, 67.32416413000004],
              [-52.56041419199994, 67.32196686400005],
              [-52.51915442599994, 67.31264883000006],
              [-52.49819902299993, 67.31049225500004],
              [-52.478586391999954, 67.31264883000006],
              [-52.46837317599994, 67.31785716400003],
              [-52.461048956999946, 67.32461172100005],
              [-52.45034745999993, 67.33100006700005],
              [-52.41759192599994, 67.34064362200007],
              [-52.26793372299994, 67.35569896000004],
              [-52.190663214999915, 67.37189362200007],
              [-52.149322068999936, 67.37197500200006],
              [-52.04898027299993, 67.34223053600005],
              [-51.552845831999946, 67.33100006700005],
              [-51.49058997299994, 67.31565989800004],
              [-51.46117102799991, 67.30288320500006],
              [-51.43993079299992, 67.28628164300005],
              [-51.418853318999936, 67.26007721600007],
              [-51.415679490999935, 67.25153229400007],
              [-51.40990149599992, 67.24359772300005],
              [-51.37474524599992, 67.22797272300005],
              [-51.30304928299995, 67.16278717700004],
              [-51.27708899599992, 67.14740631700005],
              [-51.24242102799991, 67.13617584800005],
              [-51.17613684799994, 67.12490469000005],
              [-51.14004472599993, 67.12531159100007],
              [-51.00226803299995, 67.14337799700007],
              [-50.93809973899994, 67.16168854400007],
              [-50.89195716099994, 67.16766998900005],
              [-50.82848059799994, 67.18284739800004],
              [-50.669585740999935, 67.19318268400008],
              [-50.41812089799993, 67.17438385600008],
              [-50.34683183499993, 67.18695709800005],
              [-50.34642493399991, 67.19159577000005],
              [-50.347767706999946, 67.19277578300006],
              [-50.35033118399991, 67.19277578300006],
              [-50.35309811099995, 67.19379303600005],
              [-50.34683183499993, 67.19379303600005],
              [-50.36481686099995, 67.19904205900008],
              [-50.38133704299992, 67.19867584800005],
              [-50.41576087099992, 67.19379303600005],
              [-50.43211829299992, 67.19562409100007],
              [-50.473500128999945, 67.20685455900008],
              [-50.50918535099993, 67.22459544500003],
              [-50.524728969999956, 67.22797272300005],
              [-50.82921301999994, 67.19879791900007],
              [-51.11314856699994, 67.13939036700003],
              [-51.18228105399993, 67.14541250200006],
              [-51.21202551999994, 67.15607330900008],
              [-51.23713131399995, 67.16950104400007],
              [-51.31041419199994, 67.22117747600004],
              [-51.366444464999915, 67.24730052300004],
              [-51.38841712099992, 67.26951732000003],
              [-51.41820227799991, 67.31317780200004],
              [-51.439442511999914, 67.33075592700004],
              [-51.466908331999946, 67.33783600500004],
              [-51.48485266799992, 67.33856842700004],
              [-51.50682532499991, 67.34223053600005],
              [-51.52183997299994, 67.35049062700006],
              [-51.51870683499993, 67.36505768400008],
              [-51.503895636999914, 67.37079498900005],
              [-51.264881964999915, 67.38556549700007],
              [-51.18976803299995, 67.40607330900008],
              [-51.149728969999956, 67.40851471600007],
              [-51.13255774599992, 67.41351959800005],
              [-51.11465410099993, 67.42649974200003],
              [-51.544077114999936, 67.39313385650004],
              [-51.973500128999945, 67.35976797100005],
              [-52.01219641799992, 67.36505768400008],
              [-52.11400305899991, 67.40119049700007],
              [-52.149322068999936, 67.40607330900008],
              [-52.43077551999994, 67.37636953300006],
              [-52.48375403599994, 67.36200592700004],
              [-52.51244055899991, 67.35765208500004],
              [-52.57331295499995, 67.35765208500004],
              [-52.61465410099993, 67.34686920800004],
              [-52.86416581949993, 67.31348297750006],
              [-53.11367753799993, 67.28009674700007],
              [-53.23184160099993, 67.29621002800008],
              [-53.22109941299993, 67.31093984600005],
              [-53.183664516999954, 67.33002350500004],
              [-53.17039954299992, 67.34398021000004],
              [-53.18846594999991, 67.34316640800006],
              [-53.25104732999995, 67.32713450700004],
              [-53.296986456999946, 67.30780670800004],
              [-53.34483801999994, 67.27960846600007],
              [-53.38312740799995, 67.27317942900004],
              [-53.509022589999915, 67.27317942900004],
              [-53.596994594999956, 67.25527578300006],
              [-53.67341061099995, 67.22833893400008],
              [-53.766916469999956, 67.20661041900007],
              [-53.807850714999915, 67.20685455900008],
              [-53.807850714999915, 67.21430084800005],
              [-53.77306067599994, 67.22797272300005],
              [-53.793853318999936, 67.23456452000005],
              [-53.85130774599992, 67.22866445500006],
              [-53.87669837099992, 67.23476797100005],
              [-53.86888587099992, 67.23993561400005],
              [-53.860218878999945, 67.24384186400005],
              [-53.85094153599994, 67.24652741100005],
              [-53.84137936099995, 67.24774811400005],
              [-53.84137936099995, 67.25527578300006],
              [-53.86241614499994, 67.25731028900003],
              [-53.882923956999946, 67.26211172100005],
              [-53.87474524599992, 67.27602773600006],
              [-53.86351477799991, 67.28412506700005],
              [-53.85777747299994, 67.29242584800005],
              [-53.873036261999914, 67.31932200700004],
              [-53.86636308499993, 67.32485586100006],
              [-53.83511308499993, 67.33100006700005],
              [-53.85777747299994, 67.34955475500004],
              [-53.849598761999914, 67.36664459800005],
              [-53.82384192599994, 67.38129303600005],
              [-53.79356848899994, 67.39240143400008],
              [-53.801665818999936, 67.39459870000007],
              [-53.821522589999915, 67.40607330900008],
              [-53.80573482999995, 67.41860586100006],
              [-53.78270423099991, 67.42967357000003],
              [-53.75841223899994, 67.43773021000004],
              [-53.73892167899993, 67.44086334800005],
              [-53.729359503999945, 67.44354889500005],
              [-53.71263587099992, 67.45661041900007],
              [-53.70421301999994, 67.46133047100005],
              [-53.69489498599995, 67.46210358300004],
              [-53.67479407499991, 67.46088288000004],
              [-53.62677975199995, 67.48615143400008],
              [-53.575835740999935, 67.49750397300005],
              [-53.47826087099992, 67.50849030200004],
              [-53.407541469999956, 67.52700429900005],
              [-53.38609778599994, 67.52960846600007],
              [-53.37881425699993, 67.53229401200008],
              [-53.34911048099991, 67.54950592700004],
              [-53.311756964999915, 67.56232330900008],
              [-53.125843878999945, 67.59027741100005],
              [-53.10147050699993, 67.59788646000004],
              [-53.136708136999914, 67.60602448100008],
              [-53.20689856699994, 67.58372630400004],
              [-53.23924719999991, 67.59039948100008],
              [-53.11904863199993, 67.63410065300008],
              [-53.03465735599991, 67.64350006700005],
              [-52.99095618399991, 67.65412018400008],
              [-52.90973873599995, 67.68720123900005],
              [-52.96226966099994, 67.68528880400004],
              [-52.98985755099994, 67.68024323100008],
              [-53.02774003799993, 67.66205475500004],
              [-53.057484503999945, 67.65688711100006],
              [-53.08771725199995, 67.65558502800008],
              [-53.10765540299991, 67.65936920800004],
              [-53.081288214999915, 67.68048737200007],
              [-53.047718878999945, 67.69578685100004],
              [-52.978627081999946, 67.71454498900005],
              [-52.900461391999954, 67.72699616100005],
              [-52.820301886999914, 67.72821686400005],
              [-52.799672003999945, 67.72406647300005],
              [-52.76427161399994, 67.71059804900005],
              [-52.74522864499994, 67.70770905200004],
              [-52.59797115799995, 67.71893952000005],
              [-52.562611456999946, 67.72622304900005],
              [-52.53294837099992, 67.74188873900005],
              [-52.753895636999914, 67.73114655200004],
              [-52.82774817599994, 67.74188873900005],
              [-52.789621548999946, 67.75014883000006],
              [-52.64297441299993, 67.75116608300004],
              [-52.55406653599994, 67.76923248900005],
              [-52.409087693999936, 67.76923248900005],
              [-52.37840735599991, 67.76382070500006],
              [-52.32013912699995, 67.74042389500005],
              [-52.244699673999946, 67.73102448100008],
              [-52.12828528599994, 67.70026276200008],
              [-52.119252081999946, 67.69912344000005],
              [-52.09593665299991, 67.69871653900003],
              [-52.08726966099994, 67.70026276200008],
              [-52.08633378799993, 67.70384349200003],
              [-52.08665930899991, 67.71076080900008],
              [-52.08576412699995, 67.71784088700008],
              [-52.08112545499995, 67.72199127800008],
              [-52.06212317599994, 67.72109609600005],
              [-52.023996548999946, 67.70453522300005],
              [-51.98468990799995, 67.69721100500004],
              [-51.94359290299991, 67.68353913000004],
              [-51.914906378999945, 67.67942942900004],
              [-51.90562903599994, 67.67698802300004],
              [-51.888661261999914, 67.67015208500004],
              [-51.88158118399991, 67.66323476800005],
              [-51.88499915299991, 67.65717194200005],
              [-51.890288865999935, 67.65151601800005],
              [-51.88927161399994, 67.64569733300004],
              [-51.864125128999945, 67.63589101800005],
              [-51.75454667899993, 67.63263580900008],
              [-51.53237870999993, 67.65936920800004],
              [-51.403635219999956, 67.65839264500005],
              [-51.38158118399991, 67.66673411700003],
              [-51.40664628799993, 67.67279694200005],
              [-51.415679490999935, 67.67357005400004],
              [-51.415679490999935, 67.68040599200003],
              [-51.34801184799994, 67.67951080900008],
              [-51.31554114499994, 67.67454661700003],
              [-51.25426184799994, 67.65094635600008],
              [-51.04922441299993, 67.60773346600007],
              [-51.018422003999945, 67.59414297100005],
              [-51.00133216099994, 67.59052155200004],
              [-50.96190344999991, 67.59259674700007],
              [-50.94644120999993, 67.58730703300006],
              [-50.93350175699993, 67.57949453300006],
              [-50.88752193899995, 67.56370677300004],
              [-50.80313066299993, 67.52204010600008],
              [-50.77513587099992, 67.51593659100007],
              [-50.75914466099994, 67.51447174700007],
              [-50.74160722599993, 67.51044342700004],
              [-50.71031653599994, 67.49860260600008],
              [-50.69310462099992, 67.49408600500004],
              [-50.63426673099991, 67.49481842700004],
              [-50.57921301999994, 67.48248932500007],
              [-50.55972245999993, 67.48114655200004],
              [-50.54137122299994, 67.48346588700008],
              [-50.50255286399994, 67.49274323100008],
              [-50.48375403599994, 67.49481842700004],
              [-50.22423255099994, 67.47768789300005],
              [-50.19664466099994, 67.46747467700004],
              [-50.192616339999915, 67.47394440300008],
              [-50.20287024599992, 67.48114655200004],
              [-50.173817511999914, 67.49310944200005],
              [-50.10460364499994, 67.50531647300005],
              [-50.07249915299991, 67.51593659100007],
              [-50.09727942599994, 67.51577383000006],
              [-50.14427649599992, 67.50507233300004],
              [-50.28205318899995, 67.49481842700004],
              [-50.30711829299992, 67.49770742400005],
              [-50.38841712099992, 67.51593659100007],
              [-50.55174719999991, 67.51019928600005],
              [-50.74356035099993, 67.54572174700007],
              [-50.82689368399991, 67.58881256700005],
              [-50.87441972599993, 67.59788646000004],
              [-50.87441972599993, 67.60468170800004],
              [-50.85033118399991, 67.60732656500005],
              [-50.80455481699994, 67.62177155200004],
              [-50.60228430899991, 67.64850495000007],
              [-50.440337693999936, 67.69578685100004],
              [-50.34288489499994, 67.71015045800004],
              [-50.302805141999954, 67.73163483300004],
              [-50.28160559799994, 67.73847077000005],
              [-50.25072180899991, 67.73729075700004],
              [-50.19664466099994, 67.72821686400005],
              [-50.10521399599992, 67.72321198100008],
              [-50.079335089999915, 67.71454498900005],
              [-50.08674068899995, 67.71015045800004],
              [-50.09154212099992, 67.70514557500007],
              [-50.09984290299991, 67.69403717700004],
              [-50.01382402299993, 67.68463776200008],
              [-49.96857662699995, 67.68520742400005],
              [-49.93594316299993, 67.70026276200008],
              [-49.96971594999991, 67.70970286700003],
              [-50.03937740799995, 67.72028229400007],
              [-50.105580206999946, 67.74054596600007],
              [-50.286000128999945, 67.74542877800008],
              [-50.31871497299994, 67.74164459800005],
              [-50.44554602799991, 67.70441315300008],
              [-50.507069464999915, 67.69635651200008],
              [-50.59333248599995, 67.66673411700003],
              [-50.66047115799995, 67.65534088700008],
              [-50.730458136999914, 67.65314362200007],
              [-50.86082923099991, 67.63263580900008],
              [-51.01162675699993, 67.62518952000005],
              [-51.01162675699993, 67.63263580900008],
              [-50.98273678299995, 67.63532135600008],
              [-50.92878170499995, 67.65424225500004],
              [-50.90176347599993, 67.65936920800004],
              [-50.92711341099994, 67.66791413000004],
              [-50.95645097599993, 67.66828034100007],
              [-51.03693600199995, 67.65656159100007],
              [-51.10383053299995, 67.65936920800004],
              [-51.12267005099994, 67.66274648600006],
              [-51.28888912699995, 67.71430084800005],
              [-51.32013912699995, 67.71454498900005],
              [-51.317290818999936, 67.72459544500003],
              [-51.31281490799995, 67.73090241100005],
              [-51.30581620999993, 67.73407623900005],
              [-51.29588782499991, 67.73505280200004],
              [-51.28233801999994, 67.73330312700006],
              [-51.27334550699993, 67.72931549700007],
              [-51.26626542899993, 67.72500234600005],
              [-51.258656378999945, 67.72199127800008],
              [-51.235585089999915, 67.72052643400008],
              [-51.16893469999991, 67.72821686400005],
              [-51.06346594999991, 67.71820709800005],
              [-51.00377356699994, 67.72077057500007],
              [-50.970041469999956, 67.74188873900005],
              [-50.984364386999914, 67.74188873900005],
              [-50.984364386999914, 67.74868398600006],
              [-50.778553839999915, 67.77342357000003],
              [-50.73985755099994, 67.79218170800004],
              [-50.69713294199994, 67.80084870000007],
              [-50.661040818999936, 67.82005442900004],
              [-50.64142818899995, 67.82440827000005],
              [-50.41832434799994, 67.82184479400007],
              [-50.35309811099995, 67.80390045800004],
              [-50.332020636999914, 67.80390045800004],
              [-50.30687415299991, 67.80744049700007],
              [-50.28774980399993, 67.81439850500004],
              [-50.28477942599994, 67.82440827000005],
              [-50.264963344999956, 67.84491608300004],
              [-50.306752081999946, 67.83893463700008],
              [-50.35977128799993, 67.84015534100007],
              [-50.413400844999956, 67.84715403900003],
              [-50.456695115999935, 67.85854726800005],
              [-50.44831295499995, 67.88084544500003],
              [-50.46519934799994, 67.89508698100008],
              [-50.493072068999936, 67.89960358300004],
              [-50.517567511999914, 67.89272695500006],
              [-50.51121985599991, 67.88979726800005],
              [-50.49746660099993, 67.88157786700003],
              [-50.49087480399993, 67.87909577000005],
              [-50.52440344999991, 67.87250397300005],
              [-50.59585527299993, 67.88275788000004],
              [-50.621205206999946, 67.87909577000005],
              [-50.638783331999946, 67.88776276200008],
              [-50.75112870999993, 67.91083405200004],
              [-50.78429114499994, 67.91128164300005],
              [-50.814523891999954, 67.90403880400004],
              [-50.83348548099991, 67.88589101800005],
              [-50.813059048999946, 67.88589101800005],
              [-50.813059048999946, 67.87909577000005],
              [-50.87726803299995, 67.86640045800004],
              [-50.88752193899995, 67.85854726800005],
              [-50.87547766799992, 67.85008372600004],
              [-50.84898841099994, 67.85040924700007],
              [-50.805531378999945, 67.85854726800005],
              [-50.77025305899991, 67.87303294500003],
              [-50.75377356699994, 67.87523021000004],
              [-50.73106848899994, 67.87221914300005],
              [-50.66942298099991, 67.85171133000006],
              [-50.648548956999946, 67.85114166900007],
              [-50.70152747299994, 67.84031810100004],
              [-50.71739661399994, 67.83124420800004],
              [-50.70995032499991, 67.82440827000005],
              [-50.84288489499994, 67.81818268400008],
              [-50.86766516799992, 67.80390045800004],
              [-50.82664954299992, 67.80390045800004],
              [-50.85781816299993, 67.79173411700003],
              [-50.89395097599993, 67.79413483300004],
              [-50.93077551999994, 67.80125560100004],
              [-50.95641028599994, 67.80390045800004],
              [-50.97118079299992, 67.79755280200004],
              [-50.989491339999915, 67.77680084800005],
              [-51.004750128999945, 67.76923248900005],
              [-51.02196204299992, 67.76776764500005],
              [-51.07677161399994, 67.77602773600006],
              [-51.09943600199995, 67.77387116100005],
              [-51.14525305899991, 67.76439036700003],
              [-51.16869055899991, 67.76235586100006],
              [-51.18773352799991, 67.76455312700006],
              [-51.237538214999915, 67.78286367400005],
              [-51.237538214999915, 67.78969961100006],
              [-51.192616339999915, 67.80292389500005],
              [-51.17613684799994, 67.80390045800004],
              [-51.20018469999991, 67.81224192900004],
              [-51.22728430899991, 67.81679922100005],
              [-51.24950110599991, 67.82591380400004],
              [-51.258656378999945, 67.84796784100007],
              [-51.27456620999993, 67.86375560100004],
              [-51.34748287699995, 67.87299225500004],
              [-51.36790930899991, 67.88589101800005],
              [-51.337880011999914, 67.88703034100007],
              [-51.22166907499991, 67.90387604400007],
              [-51.076161261999914, 67.90790436400005],
              [-51.06309973899994, 67.90289948100008],
              [-51.05492102799991, 67.89618561400005],
              [-51.02953040299991, 67.88251373900005],
              [-51.018422003999945, 67.87909577000005],
              [-50.99209550699993, 67.87897370000007],
              [-50.97594153599994, 67.88686758000006],
              [-50.97419186099995, 67.89956289300005],
              [-50.991118943999936, 67.91376373900005],
              [-50.98460852799991, 67.91469961100006],
              [-50.970041469999956, 67.91998932500007],
              [-51.045765753999945, 67.94049713700008],
              [-51.04015051999994, 67.95307038000004],
              [-51.04043535099993, 67.96332428600005],
              [-51.04710852799991, 67.97085195500006],
              [-51.06004798099991, 67.97528717700004],
              [-51.03892981699994, 67.98151276200008],
              [-51.24388587099992, 67.96991608300004],
              [-51.26829993399991, 67.95783112200007],
              [-51.288319464999915, 67.94415924700007],
              [-51.314442511999914, 67.93195221600007],
              [-51.34154212099992, 67.92328522300005],
              [-51.364491339999915, 67.91998932500007],
              [-51.391184048999946, 67.92202383000006],
              [-51.403960740999935, 67.92523834800005],
              [-51.43423417899993, 67.93675364800004],
              [-51.47313391799992, 67.94082265800006],
              [-51.491444464999915, 67.94794342700004],
              [-51.50499426999994, 67.94326406500005],
              [-51.551665818999936, 67.93939850500004],
              [-51.57335364499994, 67.93427155200004],
              [-51.56045488199993, 67.91868724200003],
              [-51.50914466099994, 67.90070221600007],
              [-51.48770097599993, 67.88930898600006],
              [-51.47032630099994, 67.86542389500005],
              [-51.45299231699994, 67.86025625200006],
              [-51.41466223899994, 67.85976797100005],
              [-51.39671790299991, 67.85663483300004],
              [-51.33690344999991, 67.83795807500007],
              [-51.32555091099994, 67.82436758000006],
              [-51.34740149599992, 67.80390045800004],
              [-51.38744055899991, 67.78343333500004],
              [-51.398426886999914, 67.76927317900004],
              [-51.38158118399991, 67.75551992400005],
              [-51.38158118399991, 67.74868398600006],
              [-51.423491990999935, 67.74974192900004],
              [-51.44481360599991, 67.74705638200004],
              [-51.47443600199995, 67.73102448100008],
              [-51.495350714999915, 67.72797272300005],
              [-51.51671301999994, 67.72923411700003],
              [-51.53237870999993, 67.73505280200004],
              [-51.50499426999994, 67.74017975500004],
              [-51.47838294199994, 67.74945709800005],
              [-51.47020423099991, 67.75836823100008],
              [-51.49828040299991, 67.76235586100006],
              [-51.51317298099991, 67.76048411700003],
              [-51.552845831999946, 67.74868398600006],
              [-51.569243943999936, 67.74974192900004],
              [-51.584055141999954, 67.75336334800005],
              [-51.59780839799993, 67.75372955900008],
              [-51.61119544199994, 67.74530670800004],
              [-51.62970943899995, 67.73029205900008],
              [-51.653960740999935, 67.71710846600007],
              [-51.68000240799995, 67.70677317900004],
              [-51.703684048999946, 67.70026276200008],
              [-51.73257402299993, 67.69765859600005],
              [-51.769642706999946, 67.69920482000003],
              [-51.802845831999946, 67.70677317900004],
              [-51.820423956999946, 67.72199127800008],
              [-51.79991614499994, 67.72199127800008],
              [-51.79991614499994, 67.72821686400005],
              [-51.82534745999993, 67.72809479400007],
              [-51.837147589999915, 67.72996653900003],
              [-51.84829667899993, 67.73505280200004],
              [-51.81663977799991, 67.75348541900007],
              [-51.78335527299993, 67.76129791900007],
              [-51.64610755099994, 67.76044342700004],
              [-51.631703253999945, 67.76581452000005],
              [-51.62995357999995, 67.77659739800004],
              [-51.643462693999936, 67.78148021000004],
              [-51.66954505099994, 67.78286367400005],
              [-51.69180253799993, 67.78827545800004],
              [-51.73155676999994, 67.78978099200003],
              [-51.80606035099993, 67.78139883000006],
              [-51.81973222599993, 67.77692291900007],
              [-51.832020636999914, 67.76947663000004],
              [-51.844593878999945, 67.75893789300005],
              [-51.858713344999956, 67.75360748900005],
              [-52.23192298099991, 67.76923248900005],
              [-52.26357988199993, 67.77997467700004],
              [-52.298817511999914, 67.81061432500007],
              [-52.330922003999945, 67.81696198100008],
              [-52.34215247299994, 67.82172272300005],
              [-52.33356686099995, 67.83222077000005],
              [-52.318470831999946, 67.84292226800005],
              [-52.294992641999954, 67.85578034100007],
              [-52.23810787699995, 67.86542389500005],
              [-52.22301184799994, 67.87055084800005],
              [-52.196197068999936, 67.88328685100004],
              [-52.15900631399995, 67.89158763200004],
              [-52.149322068999936, 67.89272695500006],
              [-52.138783331999946, 67.89077383000006],
              [-52.13882402299993, 67.88637929900005],
              [-52.14590410099993, 67.88178131700005],
              [-52.15615800699993, 67.87909577000005],
              [-51.922759568999936, 67.88589101800005],
              [-51.90648352799991, 67.88983795800004],
              [-51.87205969999991, 67.90338776200008],
              [-51.828114386999914, 67.91071198100008],
              [-51.76402747299994, 67.92991771000004],
              [-51.731312628999945, 67.93427155200004],
              [-51.664906378999945, 67.93305084800005],
              [-51.62865149599992, 67.93675364800004],
              [-51.60130774599992, 67.94794342700004],
              [-51.60484778599994, 67.95457591400003],
              [-51.597320115999935, 67.95937734600005],
              [-51.57335364499994, 67.96841054900005],
              [-51.60659745999993, 67.97699616100005],
              [-51.836781378999945, 67.94049713700008],
              [-51.91673743399991, 67.91347890800006],
              [-51.948882615999935, 67.90814850500004],
              [-52.20421301999994, 67.90574778900003],
              [-52.23741614499994, 67.90180084800005],
              [-52.26203365799995, 67.88930898600006],
              [-52.27481035099993, 67.88442617400005],
              [-52.394602016999954, 67.87030670800004],
              [-52.409413214999915, 67.86542389500005],
              [-52.420033331999946, 67.85785553600005],
              [-52.44017493399991, 67.83885325700004],
              [-52.45034745999993, 67.83124420800004],
              [-52.466867641999954, 67.82355377800008],
              [-52.48314368399991, 67.81928131700005],
              [-52.55504309799994, 67.81268952000005],
              [-52.62604732999995, 67.79385000200006],
              [-52.663319464999915, 67.78969961100006],
              [-52.82404537699995, 67.79645416900007],
              [-52.83828691299993, 67.79336172100005],
              [-52.86168372299994, 67.77920156500005],
              [-52.875559048999946, 67.77602773600006],
              [-52.88524329299992, 67.77496979400007],
              [-52.901600714999915, 67.77024974200003],
              [-52.90973873599995, 67.76923248900005],
              [-52.94383704299992, 67.76923248900005],
              [-53.00377356699994, 67.75771719000005],
              [-53.06432044199994, 67.73574453300006],
              [-53.33165442599994, 67.59589264500005],
              [-53.576730923999946, 67.51886627800008],
              [-53.66738847599993, 67.50299713700008],
              [-53.67882239499994, 67.50263092700004],
              [-53.69054114499994, 67.50849030200004],
              [-53.67552649599992, 67.52057526200008],
              [-53.68081620999993, 67.52391185100004],
              [-53.70421301999994, 67.52277252800008],
              [-53.725493943999936, 67.53164297100005],
              [-53.729725714999915, 67.53807200700004],
              [-53.711008266999954, 67.56370677300004],
              [-53.72671464799993, 67.56622955900008],
              [-53.73790442599994, 67.57269928600005],
              [-53.74103756399995, 67.58136627800008],
              [-53.73273678299995, 67.59039948100008],
              [-53.75259355399993, 67.60301341400003],
              [-53.73534094999991, 67.61334870000007],
              [-53.589182094999956, 67.65062083500004],
              [-53.56017005099994, 67.65314362200007],
              [-53.56017005099994, 67.65936920800004],
              [-53.697336391999954, 67.64569733300004],
              [-53.58726966099994, 67.67218659100007],
              [-53.553944464999915, 67.68720123900005],
              [-53.56078040299991, 67.69017161700003],
              [-53.567697719999956, 67.69403717700004],
              [-53.555572068999936, 67.70136139500005],
              [-53.54556230399993, 67.71137116100005],
              [-53.54141191299993, 67.71967194200005],
              [-53.54710852799991, 67.72199127800008],
              [-53.55406653599994, 67.73541901200008],
              [-53.56550045499995, 67.74457428600005],
              [-53.56944739499994, 67.75250885600008],
              [-53.553944464999915, 67.76235586100006],
              [-53.57066809799994, 67.76186758000006],
              [-53.58885657499991, 67.76487864800004],
              [-53.60586503799993, 67.77090078300006],
              [-53.63752193899995, 67.79071686400005],
              [-53.65843665299991, 67.79564036700003],
              [-53.70421301999994, 67.79645416900007],
              [-53.68765214799993, 67.81183502800008],
              [-53.59557044199994, 67.83124420800004],
              [-53.55508378799993, 67.84784577000005],
              [-53.54092363199993, 67.85114166900007],
              [-53.526275193999936, 67.85028717700004],
              [-53.51305091099994, 67.84674713700008],
              [-53.49990800699993, 67.84540436400005],
              [-53.48570716099994, 67.85114166900007],
              [-53.489491339999915, 67.85407135600008],
              [-53.490345831999946, 67.85504791900007],
              [-53.49254309799994, 67.85854726800005],
              [-53.48033606699994, 67.85854726800005],
              [-53.46910559799994, 67.85415273600006],
              [-53.460926886999914, 67.84601471600007],
              [-53.45775305899991, 67.83466217700004],
              [-53.46251380099994, 67.82111237200007],
              [-53.47443600199995, 67.81614817900004],
              [-53.505523240999935, 67.81696198100008],
              [-53.505523240999935, 67.81012604400007],
              [-53.47964433499993, 67.80516185100004],
              [-53.43028723899994, 67.81549713700008],
              [-53.403187628999945, 67.81696198100008],
              [-53.41344153599994, 67.81028880400004],
              [-53.42516028599994, 67.80597565300008],
              [-53.43785559799994, 67.80390045800004],
              [-53.45091712099992, 67.80390045800004],
              [-53.45091712099992, 67.79645416900007],
              [-53.27798417899993, 67.80581289300005],
              [-53.24547278599994, 67.82440827000005],
              [-53.387277798999946, 67.82746002800008],
              [-53.43106035099993, 67.83808014500005],
              [-53.43106035099993, 67.84491608300004],
              [-53.418039516999954, 67.85187409100007],
              [-53.375843878999945, 67.86542389500005],
              [-53.402333136999914, 67.87299225500004],
              [-53.45962480399993, 67.87323639500005],
              [-53.48570716099994, 67.87909577000005],
              [-53.46108964799993, 67.89313385600008],
              [-53.43399003799993, 67.89899323100008],
              [-53.37926184799994, 67.89956289300005],
              [-53.37222245999993, 67.89769114800004],
              [-53.34170488199993, 67.88589101800005],
              [-53.312611456999946, 67.88605377800008],
              [-53.29922441299993, 67.88312409100007],
              [-53.293853318999936, 67.87221914300005],
              [-53.30064856699994, 67.86806875200006],
              [-53.31427975199995, 67.86322663000004],
              [-53.32534745999993, 67.85675690300008],
              [-53.324330206999946, 67.84796784100007],
              [-53.31436113199993, 67.84198639500005],
              [-53.291086391999954, 67.83812083500004],
              [-53.27965247299994, 67.83466217700004],
              [-53.26207434799994, 67.83222077000005],
              [-53.18399003799993, 67.83808014500005],
              [-53.18399003799993, 67.84491608300004],
              [-53.24128170499995, 67.84271881700005],
              [-53.27017167899993, 67.84634023600006],
              [-53.28648841099994, 67.85854726800005],
              [-53.15021725199995, 67.89118073100008],
              [-53.121937628999945, 67.89272695500006],
              [-53.06818600199995, 67.88231028900003],
              [-53.05370032499991, 67.88589101800005],
              [-53.08885657499991, 67.90224844000005],
              [-53.12515214799993, 67.91144440300008],
              [-53.16344153599994, 67.91299062700006],
              [-53.20449785099993, 67.90631745000007],
              [-53.250070766999954, 67.89374420800004],
              [-53.25914466099994, 67.89272695500006],
              [-53.264515753999945, 67.89533112200007],
              [-53.26642818899995, 67.89996979400007],
              [-53.26903235599991, 67.90444570500006],
              [-53.27647864499994, 67.90631745000007],
              [-53.29662024599992, 67.90790436400005],
              [-53.305531378999945, 67.91022370000007],
              [-53.31436113199993, 67.91376373900005],
              [-53.30020097599993, 67.91746653900003],
              [-53.267689581999946, 67.91819896000004],
              [-53.25572669199994, 67.92340729400007],
              [-53.24160722599993, 67.93211497600004],
              [-53.22520911399994, 67.93512604400007],
              [-53.19082597599993, 67.93427155200004],
              [-53.23399817599994, 67.94301992400005],
              [-53.25450598899994, 67.94940827000005],
              [-53.26598059799994, 67.96100495000007],
              [-53.250070766999954, 67.96482982000003],
              [-53.200428839999915, 67.96775950700004],
              [-53.159087693999936, 67.96002838700008],
              [-53.074208136999914, 67.97528717700004],
              [-52.889230923999946, 67.98151276200008],
              [-52.91397050699993, 67.99017975500004],
              [-52.97203528599994, 68.00202057500007],
              [-52.99844316299993, 68.00259023600006],
              [-53.00743567599994, 67.99994538000004],
              [-53.02098548099991, 67.99087148600006],
              [-53.032866990999935, 67.98895905200004],
              [-53.25914466099994, 67.98895905200004],
              [-53.252512173999946, 67.99754466400003],
              [-53.249256964999915, 68.00641510600008],
              [-53.25096594999991, 68.01508209800005],
              [-53.25914466099994, 68.02301666900007],
              [-53.228179490999935, 68.02728913000004],
              [-53.17658443899995, 68.04608795800004],
              [-53.04124915299991, 68.06305573100008],
              [-52.72923743399991, 67.96678294500003],
              [-52.63223222599993, 67.96100495000007],
              [-52.62441972599993, 67.95917389500005],
              [-52.62291419199994, 67.95506419500003],
              [-52.62344316299993, 67.95066966400003],
              [-52.62169348899994, 67.94794342700004],
              [-52.58922278599994, 67.94310130400004],
              [-52.53929602799991, 67.95343659100007],
              [-52.25861568899995, 67.94049713700008],
              [-52.221913214999915, 67.92845286700003],
              [-52.207102016999954, 67.92682526200008],
              [-52.18276933499993, 67.92894114800004],
              [-52.137928839999915, 67.93838125200006],
              [-52.114898240999935, 67.94049713700008],
              [-52.09947669199994, 67.94521719000005],
              [-52.05931555899991, 67.97528717700004],
              [-52.05931555899991, 67.98151276200008],
              [-52.08507239499994, 67.98086172100005],
              [-52.11278235599991, 67.97565338700008],
              [-52.16270911399994, 67.95783112200007],
              [-52.19749915299991, 67.95018138200004],
              [-52.476002570999924, 67.96841054900005],
              [-52.75450598899994, 67.98663971600007],
              [-52.82555091099994, 68.00543854400007],
              [-53.00413977799991, 68.07534414300005],
              [-53.13589433499993, 68.10911692900004],
              [-53.162953253999945, 68.12604401200008],
              [-53.14476477799991, 68.13833242400005],
              [-53.09902910099993, 68.15127187700006],
              [-53.080962693999936, 68.15961334800005],
              [-53.09434973899994, 68.17251211100006],
              [-53.11156165299991, 68.17841217700004],
              [-53.13060462099992, 68.17841217700004],
              [-53.149281378999945, 68.17328522300005],
              [-53.153187628999945, 68.15688711100006],
              [-53.17931067599994, 68.15053945500006],
              [-53.23924719999991, 68.14594147300005],
              [-53.26781165299991, 68.13349030200004],
              [-53.28400631399995, 68.13007233300004],
              [-53.296986456999946, 68.13597239800004],
              [-53.29625403599994, 68.14423248900005],
              [-53.28697669199994, 68.15379466400003],
              [-53.27489173099991, 68.16229889500005],
              [-53.26598059799994, 68.16705963700008],
              [-53.28701738199993, 68.16982656500005],
              [-53.330189581999946, 68.15664297100005],
              [-53.35220292899993, 68.15277741100005],
              [-53.45775305899991, 68.15277741100005],
              [-53.30797278599994, 68.18650950700004],
              [-53.15269934799994, 68.20115794500003],
              [-53.11481686099995, 68.19863515800006],
              [-53.07697506399995, 68.19159577000005],
              [-53.005848761999914, 68.16705963700008],
              [-52.972727016999954, 68.16054922100005],
              [-52.89317786399994, 68.15692780200004],
              [-52.86876380099994, 68.14594147300005],
              [-52.849720831999946, 68.14838288000004],
              [-52.817616339999915, 68.14020416900007],
              [-52.75951087099992, 68.11859772300005],
              [-52.72647050699993, 68.11123281500005],
              [-52.53156490799995, 68.09544505400004],
              [-52.446197068999936, 68.06899648600006],
              [-52.41519120999993, 68.06781647300005],
              [-52.38898678299995, 68.07762278900003],
              [-52.41454016799992, 68.07965729400007],
              [-52.51187089799993, 68.10272858300004],
              [-52.52794348899994, 68.10927969000005],
              [-52.53099524599992, 68.11725495000007],
              [-52.51244055899991, 68.12604401200008],
              [-52.53807532499991, 68.13377513200004],
              [-52.62169348899994, 68.12604401200008],
              [-52.637928839999915, 68.12889232000003],
              [-52.64037024599992, 68.13532135600008],
              [-52.63703365799995, 68.14203522300005],
              [-52.635975714999915, 68.14594147300005],
              [-52.652333136999914, 68.15058014500005],
              [-52.68736731699994, 68.15355052300004],
              [-52.70421301999994, 68.15961334800005],
              [-52.694569464999915, 68.16535065300008],
              [-52.69058183499993, 68.16705963700008],
              [-52.69058183499993, 68.17328522300005],
              [-52.713449673999946, 68.17918528900003],
              [-52.75413977799991, 68.16864655200004],
              [-52.78001868399991, 68.16705963700008],
              [-52.77253170499995, 68.16705963700008],
              [-52.79454505099994, 68.16583893400008],
              [-52.79914303299995, 68.17576732000003],
              [-52.79137122299994, 68.18821849200003],
              [-52.776234503999945, 68.19432200700004],
              [-52.724720831999946, 68.20115794500003],
              [-52.70946204299992, 68.19891998900005],
              [-52.678618943999936, 68.18915436400005],
              [-52.662953253999945, 68.18691640800006],
              [-52.582875128999945, 68.19106679900005],
              [-52.55406653599994, 68.18691640800006],
              [-52.47175045499995, 68.16128164300005],
              [-52.444203253999945, 68.15961334800005],
              [-52.44009355399993, 68.15387604400007],
              [-52.38898678299995, 68.14594147300005],
              [-52.326161261999914, 68.12811920800004],
              [-52.26512610599991, 68.11969635600008],
              [-52.19937089799993, 68.09162018400008],
              [-52.162993943999936, 68.08510976800005],
              [-52.086781378999945, 68.08515045800004],
              [-52.04751542899993, 68.08014557500007],
              [-51.97520911399994, 68.05402252800008],
              [-51.93154863199993, 68.04682038000004],
              [-51.57433020749994, 68.05884430550006],
              [-51.21711178299995, 68.07086823100008],
              [-51.16771399599992, 68.06513092700004],
              [-51.14329993399991, 68.05829498900005],
              [-51.107492641999954, 68.03754303600005],
              [-51.05931555899991, 68.02855052300004],
              [-50.99596106699994, 68.00946686400005],
              [-50.904367641999954, 67.99262116100005],
              [-50.86082923099991, 67.97833893400008],
              [-50.71361243399991, 67.95774974200003],
              [-50.689523891999954, 67.95136139500005],
              [-50.682199673999946, 67.94424062700006],
              [-50.61974036399994, 67.91376373900005],
              [-50.60464433499993, 67.90949127800008],
              [-50.56655839799993, 67.90631745000007],
              [-50.572824673999946, 67.91376373900005],
              [-50.56041419199994, 67.91876862200007],
              [-50.546864386999914, 67.92047760600008],
              [-50.51817786399994, 67.91998932500007],
              [-50.50816809799994, 67.92226797100005],
              [-50.489572719999956, 67.93203359600005],
              [-50.47720292899993, 67.93427155200004],
              [-50.23281816299993, 67.91242096600007],
              [-50.17845618399991, 67.92039622600004],
              [-50.14826412699995, 67.94794342700004],
              [-50.29906165299991, 67.93427155200004],
              [-50.31395423099991, 67.93650950700004],
              [-50.34284420499995, 67.94578685100004],
              [-50.462961391999954, 67.95477936400005],
              [-50.503244594999956, 67.96674225500004],
              [-50.51817786399994, 67.96841054900005],
              [-50.54710852799991, 67.96792226800005],
              [-50.560658331999946, 67.96979401200008],
              [-50.572824673999946, 67.97528717700004],
              [-50.563791469999956, 67.97988515800006],
              [-50.55565344999991, 67.98578522300005],
              [-50.54922441299993, 67.99331289300005],
              [-50.54552161399994, 68.00259023600006],
              [-50.59007727799991, 68.00869375200006],
              [-50.67906653599994, 67.99542877800008],
              [-50.72362219999991, 68.00259023600006],
              [-50.69859778599994, 68.00901927300004],
              [-50.68150794199994, 68.01748281500005],
              [-50.68032792899993, 68.02692291900007],
              [-50.703195766999954, 68.03668854400007],
              [-50.73485266799992, 68.03974030200004],
              [-50.79637610599991, 68.03363678600005],
              [-50.82664954299992, 68.03668854400007],
              [-50.86461341099994, 68.04901764500005],
              [-50.928293423999946, 68.05272044500003],
              [-50.94273841099994, 68.05719635600008],
              [-50.95213782499991, 68.06199778900003],
              [-50.96727454299992, 68.07241445500006],
              [-50.977447068999936, 68.07762278900003],
              [-50.99437415299991, 68.08222077000005],
              [-51.029286261999914, 68.08608633000006],
              [-51.045765753999945, 68.09129466400003],
              [-51.02183997299994, 68.10016510600008],
              [-50.93590247299994, 68.11859772300005],
              [-50.93590247299994, 68.12604401200008],
              [-50.971587693999936, 68.12246328300006],
              [-51.03848222599993, 68.10736725500004],
              [-51.07371985599991, 68.10496653900003],
              [-51.10065670499995, 68.10667552300004],
              [-51.11070716099994, 68.11151764500005],
              [-51.11465410099993, 68.12238190300008],
              [-51.12096106699994, 68.13007233300004],
              [-51.135975714999915, 68.13275788000004],
              [-51.16893469999991, 68.13226959800005],
              [-51.18394934799994, 68.13654205900008],
              [-51.214182094999956, 68.15521881700005],
              [-51.23070227799991, 68.15961334800005],
              [-51.24559485599991, 68.15595123900005],
              [-51.26134192599994, 68.14940013200004],
              [-51.27794348899994, 68.14716217700004],
              [-51.311756964999915, 68.16522858300004],
              [-51.36790930899991, 68.17328522300005],
              [-51.386382615999935, 68.18105703300006],
              [-51.41706295499995, 68.19818756700005],
              [-51.436838344999956, 68.20115794500003],
              [-51.436838344999956, 68.20799388200004],
              [-50.99795488199993, 68.18073151200008],
              [-50.96727454299992, 68.18402741100005],
              [-50.95588131399995, 68.18927643400008],
              [-50.96324622299994, 68.19773997600004],
              [-51.011708136999914, 68.21694570500006],
              [-51.03587805899991, 68.22150299700007],
              [-51.06004798099991, 68.22166575700004],
              [-51.11424719999991, 68.21482982000003],
              [-51.141835089999915, 68.21771881700005],
              [-51.18651282499991, 68.24607982000003],
              [-51.21133378799993, 68.25018952000005],
              [-51.35700436099995, 68.24835846600007],
              [-51.38158118399991, 68.25580475500004],
              [-51.363352016999954, 68.26569245000007],
              [-51.34284420499995, 68.26951732000003],
              [-51.22325598899994, 68.27480703300006],
              [-51.207142706999946, 68.28001536700003],
              [-51.19131425699993, 68.28876373900005],
              [-51.15562903599994, 68.29482656500005],
              [-51.145741339999915, 68.30304596600007],
              [-51.14834550699993, 68.30939362200007],
              [-51.149281378999945, 68.31818268400008],
              [-51.14883378799993, 68.32404205900008],
              [-51.143788214999915, 68.33124420800004],
              [-51.12083899599992, 68.35138580900008],
              [-51.128244594999956, 68.35512929900005],
              [-51.13540605399993, 68.35984935100004],
              [-51.14232337099992, 68.36566803600005],
              [-51.14883378799993, 68.37250397300005],
              [-51.12828528599994, 68.37250397300005],
              [-51.14240475199995, 68.37620677300004],
              [-51.16038977799991, 68.37872955900008],
              [-51.175770636999914, 68.38418203300006],
              [-51.18228105399993, 68.39642975500004],
              [-51.177845831999946, 68.40810781500005],
              [-51.16698157499991, 68.41421133000006],
              [-50.99819902299993, 68.44684479400007],
              [-50.94273841099994, 68.45001862200007],
              [-50.92906653599994, 68.45441315300008],
              [-50.88194739499994, 68.48216380400004],
              [-50.85643469999991, 68.48956940300008],
              [-50.82664954299992, 68.48236725500004],
              [-50.84780839799993, 68.47748444200005],
              [-50.86766516799992, 68.46869538000004],
              [-50.848540818999936, 68.46784088700008],
              [-50.81749426999994, 68.47370026200008],
              [-50.78758704299992, 68.48379140800006],
              [-50.772043423999946, 68.49542877800008],
              [-50.84801184799994, 68.50714752800008],
              [-51.23159745999993, 68.41575755400004],
              [-51.32013912699995, 68.42023346600007],
              [-51.43000240799995, 68.40599192900004],
              [-51.45938066299993, 68.40761953300006],
              [-51.53921464799993, 68.42772044500003],
              [-51.56908118399991, 68.43016185100004],
              [-51.59552975199995, 68.42723216400003],
              [-51.64903723899994, 68.41347890800006],
              [-51.61986243399991, 68.40448639500005],
              [-51.56090247299994, 68.39614492400005],
              [-51.51085364499994, 68.36664459800005],
              [-51.48338782499991, 68.35993073100008],
              [-51.313343878999945, 68.36570872600004],
              [-51.27879798099991, 68.35512929900005],
              [-51.23216712099992, 68.32904694200005],
              [-51.22093665299991, 68.31366608300004],
              [-51.244984503999945, 68.30418528900003],
              [-51.23542232999995, 68.29743073100008],
              [-51.22329667899993, 68.29677969000005],
              [-51.31314042899993, 68.28278229400007],
              [-51.64806067599994, 68.27464427300004],
              [-51.680246548999946, 68.26487864800004],
              [-51.69688880099994, 68.26264069200005],
              [-51.731353318999936, 68.26333242400005],
              [-51.74705969999991, 68.26064687700006],
              [-51.77765865799995, 68.24437083500004],
              [-51.79369055899991, 68.24412669500003],
              [-51.82656816299993, 68.24957916900007],
              [-52.05353756399995, 68.23623281500005],
              [-52.101551886999914, 68.22166575700004],
              [-52.136708136999914, 68.21796295800004],
              [-52.22687740799995, 68.22040436400005],
              [-52.28160559799994, 68.19965241100005],
              [-52.44513912699995, 68.18146393400008],
              [-52.46939042899993, 68.18447500200006],
              [-52.49132239499994, 68.19432200700004],
              [-52.50499426999994, 68.19432200700004],
              [-52.459055141999954, 68.21775950700004],
              [-52.444203253999945, 68.22846100500004],
              [-52.46353105399993, 68.23704661700003],
              [-52.521148240999935, 68.24579498900005],
              [-52.546864386999914, 68.25267161700003],
              [-52.56212317599994, 68.26439036700003],
              [-52.55215410099993, 68.27301666900007],
              [-52.53099524599992, 68.28095123900005],
              [-52.51244055899991, 68.29059479400007],
              [-52.54283606699994, 68.29555898600006],
              [-52.64220130099994, 68.27692291900007],
              [-52.75804602799991, 68.28270091400003],
              [-52.79527747299994, 68.27728913000004],
              [-52.78986568899995, 68.27606842700004],
              [-52.74193274599992, 68.26532623900005],
              [-52.67007402299993, 68.26093170800004],
              [-52.64679928299995, 68.25495026200008],
              [-52.62852942599994, 68.24213288000004],
              [-52.66812089799993, 68.22337474200003],
              [-52.71446692599994, 68.21548086100006],
              [-52.76235917899993, 68.21576569200005],
              [-52.806711391999954, 68.22166575700004],
              [-52.81297766799992, 68.22443268400008],
              [-52.82469641799992, 68.23322174700007],
              [-52.833973761999914, 68.23590729400007],
              [-52.846547003999945, 68.23533763200004],
              [-52.87144934799994, 68.22919342700004],
              [-52.88239498599995, 68.22846100500004],
              [-52.89952551999994, 68.23432038000004],
              [-52.891835089999915, 68.24192942900004],
              [-52.85448157499991, 68.25580475500004],
              [-52.89793860599991, 68.25372955900008],
              [-52.91978919199994, 68.25543854400007],
              [-52.937611456999946, 68.26264069200005],
              [-52.918080206999946, 68.27887604400007],
              [-52.88829505099994, 68.29026927300004],
              [-52.751942511999914, 68.31777578300006],
              [-52.71117102799991, 68.31899648600006],
              [-52.67796790299991, 68.30752187700006],
              [-52.666900193999936, 68.30996328300006],
              [-52.655588344999956, 68.31452057500007],
              [-52.64220130099994, 68.31785716400003],
              [-52.645090298999946, 68.32168203300006],
              [-52.64781653599994, 68.32831452000005],
              [-52.649647589999915, 68.33152903900003],
              [-52.61497962099992, 68.32982005400004],
              [-52.602406378999945, 68.33323802300004],
              [-52.60118567599994, 68.34454987200007],
              [-52.59780839799993, 68.34479401200008],
              [-52.59093176999994, 68.34422435100004],
              [-52.587554490999935, 68.34454987200007],
              [-52.587554490999935, 68.35138580900008],
              [-52.69058183499993, 68.33771393400008],
              [-52.78734290299991, 68.33673737200007],
              [-52.831369594999956, 68.31732819200005],
              [-53.07359778599994, 68.28754303600005],
              [-53.13744055899991, 68.28986237200007],
              [-53.17039954299992, 68.29677969000005],
              [-53.20417232999995, 68.30866120000007],
              [-53.22008216099994, 68.30939362200007],
              [-53.25568600199995, 68.29100169500003],
              [-53.305897589999915, 68.28778717700004],
              [-53.339507615999935, 68.27187734600005],
              [-53.35411536399994, 68.27480703300006],
              [-53.36660722599993, 68.28457265800006],
              [-53.375843878999945, 68.29677969000005],
              [-53.35179602799991, 68.29230377800008],
              [-53.34243730399993, 68.29482656500005],
              [-53.334868943999936, 68.30418528900003],
              [-53.377837693999936, 68.32160065300008],
              [-53.38947506399995, 68.33152903900003],
              [-53.29556230399993, 68.35126373900005],
              [-53.24791419199994, 68.35285065300008],
              [-53.20449785099993, 68.34454987200007],
              [-53.14631100199995, 68.32294342700004],
              [-53.114898240999935, 68.31586334800005],
              [-53.08849036399994, 68.31785716400003],
              [-53.02574622299994, 68.34454987200007],
              [-52.96239173099991, 68.34894440300008],
              [-52.94758053299995, 68.35512929900005],
              [-52.93195553299995, 68.36456940300008],
              [-52.910227016999954, 68.37152741100005],
              [-52.86876380099994, 68.37929922100005],
              [-52.799712693999936, 68.37885163000004],
              [-52.78001868399991, 68.38556549700007],
              [-52.791005011999914, 68.39004140800006],
              [-52.812163865999935, 68.39549388200004],
              [-52.820301886999914, 68.39980703300006],
              [-52.81395423099991, 68.40851471600007],
              [-52.80410722599993, 68.41307200700004],
              [-52.792307094999956, 68.41437409100007],
              [-52.78001868399991, 68.41347890800006],
              [-52.77521725199995, 68.42291901200008],
              [-52.71751868399991, 68.42377350500004],
              [-52.69399980399993, 68.43085358300004],
              [-52.68016516799992, 68.43927643400008],
              [-52.64053300699993, 68.45233795800004],
              [-52.56676184799994, 68.46124909100007],
              [-52.55992591099994, 68.46002838700008],
              [-52.546213344999956, 68.45514557500007],
              [-52.53978430899991, 68.45441315300008],
              [-52.536447719999956, 68.45693594000005],
              [-52.534047003999945, 68.46181875200006],
              [-52.53282630099994, 68.46662018400008],
              [-52.53294837099992, 68.46869538000004],
              [-52.44839433499993, 68.46214427300004],
              [-52.423085089999915, 68.46869538000004],
              [-52.47834225199995, 68.49542877800008],
              [-52.411366339999915, 68.50844961100006],
              [-52.38898678299995, 68.50967031500005],
              [-52.414621548999946, 68.51788971600007],
              [-52.44562740799995, 68.51801178600005],
              [-52.57485917899993, 68.50413646000004],
              [-52.608631964999915, 68.50702545800004],
              [-52.64220130099994, 68.51585521000004],
              [-52.616444464999915, 68.52594635600008],
              [-52.19318600199995, 68.57221100500004],
              [-52.18004309799994, 68.56769440300008],
              [-52.173085089999915, 68.56150950700004],
              [-52.165679490999935, 68.55670807500007],
              [-52.15615800699993, 68.55068594000005],
              [-52.14525305899991, 68.54633209800005],
              [-52.13329016799992, 68.54368724200003],
              [-52.12071692599994, 68.54287344000005],
              [-52.10777747299994, 68.54376862200007],
              [-52.11070716099994, 68.54759349200003],
              [-52.11213131399995, 68.55072663000004],
              [-52.11302649599992, 68.55377838700008],
              [-52.11461341099994, 68.55744049700007],
              [-51.96471106699994, 68.58755117400005],
              [-51.884877081999946, 68.59275950700004],
              [-51.81289628799993, 68.57855866100005],
              [-51.84878495999993, 68.56854889500005],
              [-51.96442623599995, 68.56427643400008],
              [-51.96442623599995, 68.55744049700007],
              [-51.916005011999914, 68.55744049700007],
              [-51.916005011999914, 68.55068594000005],
              [-51.92735755099994, 68.54995351800005],
              [-51.93814042899993, 68.54743073100008],
              [-51.948109503999945, 68.54315827000005],
              [-51.95689856699994, 68.53701406500005],
              [-51.93260657499991, 68.52960846600007],
              [-51.86440995999993, 68.51699453300006],
              [-51.84117591099994, 68.51959870000007],
              [-51.82054602799991, 68.52875397300005],
              [-51.80125891799992, 68.53400299700007],
              [-51.75767981699994, 68.53701406500005],
              [-51.63573157499991, 68.52362702000005],
              [-51.56883704299992, 68.52387116100005],
              [-51.53237870999993, 68.54376862200007],
              [-51.53392493399991, 68.55467357000003],
              [-51.51577714799993, 68.56273021000004],
              [-51.49038652299993, 68.56655508000006],
              [-51.47032630099994, 68.56427643400008],
              [-51.47032630099994, 68.55744049700007],
              [-51.505116339999915, 68.54376862200007],
              [-51.505116339999915, 68.53701406500005],
              [-51.458241339999915, 68.54730866100005],
              [-51.40884355399993, 68.55068594000005],
              [-51.36961829299992, 68.54547760600008],
              [-51.35187740799995, 68.54865143400008],
              [-51.34064693899995, 68.56427643400008],
              [-51.402007615999935, 68.56427643400008],
              [-51.402007615999935, 68.57111237200007],
              [-51.37791907499991, 68.57957591400003],
              [-51.34528561099995, 68.58478424700007],
              [-51.31200110599991, 68.58502838700008],
              [-51.28595943899995, 68.57855866100005],
              [-51.29963131399995, 68.57111237200007],
              [-51.14883378799993, 68.56391022300005],
              [-51.12083899599992, 68.57855866100005],
              [-51.12950598899994, 68.57908763200004],
              [-51.14883378799993, 68.58478424700007],
              [-51.09325110599991, 68.60407135600008],
              [-51.07371985599991, 68.60521067900004],
              [-51.07371985599991, 68.60024648600006],
              [-51.076283331999946, 68.59227122600004],
              [-51.08267167899993, 68.58417389500005],
              [-51.09414628799993, 68.57855866100005],
              [-51.05451412699995, 68.57953522300005],
              [-51.035715298999946, 68.58417389500005],
              [-51.03587805899991, 68.59467194200005],
              [-51.04181881399995, 68.60569896000004],
              [-51.04137122299994, 68.61815013200004],
              [-51.03477942599994, 68.62836334800005],
              [-51.02183997299994, 68.63255442900004],
              [-51.00609290299991, 68.64207591400003],
              [-51.02489173099991, 68.66388580900008],
              [-51.07371985599991, 68.70140208500004],
              [-51.04914303299995, 68.70140208500004],
              [-51.023548956999946, 68.69599030200004],
              [-50.966460740999935, 68.67177969000005],
              [-50.94273841099994, 68.65302155200004],
              [-50.93016516799992, 68.63641998900005],
              [-50.92259680899991, 68.62885163000004],
              [-50.91234290299991, 68.62571849200003],
              [-50.88036048099991, 68.61957428600005],
              [-50.86204993399991, 68.61981842700004],
              [-50.85399329299992, 68.62913646000004],
              [-50.85912024599992, 68.63825104400007],
              [-50.881703253999945, 68.64647044500003],
              [-50.88752193899995, 68.65302155200004],
              [-50.87767493399991, 68.66290924700007],
              [-50.82526607999995, 68.67377350500004],
              [-50.805531378999945, 68.68097565300008],
              [-50.900949673999946, 68.66974518400008],
              [-50.92906653599994, 68.67413971600007],
              [-50.925852016999954, 68.67780182500007],
              [-50.92406165299991, 68.68109772300005],
              [-50.92125403599994, 68.68414948100008],
              [-50.91539466099994, 68.68720123900005],
              [-50.92345130099994, 68.69940827000005],
              [-50.93517005099994, 68.70091380400004],
              [-50.94912675699993, 68.69912344000005],
              [-50.96385657499991, 68.70140208500004],
              [-50.972767706999946, 68.70791250200006],
              [-50.991118943999936, 68.73558177300004],
              [-50.88133704299992, 68.77033112200007],
              [-50.784047003999945, 68.77676015800006],
              [-50.764556443999936, 68.79022858300004],
              [-50.76475989499994, 68.80353424700007],
              [-50.65469316299993, 68.83120351800005],
              [-50.74323482999995, 68.84186432500007],
              [-50.78685462099992, 68.84194570500006],
              [-50.82664954299992, 68.83120351800005],
              [-50.86851966099994, 68.80927155200004],
              [-50.94554602799991, 68.78839752800008],
              [-51.018788214999915, 68.75263092700004],
              [-51.032093878999945, 68.74860260600008],
              [-51.11465410099993, 68.73558177300004],
              [-51.248605923999946, 68.74957916900007],
              [-51.29214433499993, 68.74860260600008],
              [-51.28107662699995, 68.76284414300005],
              [-51.26341712099992, 68.76951732000003],
              [-51.243031378999945, 68.77366771000004],
              [-51.223866339999915, 68.78025950700004],
              [-51.21251380099994, 68.78937409100007],
              [-51.20343990799995, 68.79950592700004],
              [-51.192616339999915, 68.80780670800004],
              [-51.17613684799994, 68.81126536700003],
              [-51.18350175699993, 68.82172272300005],
              [-51.20645097599993, 68.83417389500005],
              [-51.21711178299995, 68.84544505400004],
              [-51.180897589999915, 68.85667552300004],
              [-51.10187740799995, 68.86619700700004],
              [-51.069976365999935, 68.88239166900007],
              [-51.04482988199993, 68.89866771000004],
              [-50.98741614499994, 68.92084381700005],
              [-50.96385657499991, 68.93423086100006],
              [-50.993804490999935, 68.93195221600007],
              [-51.03307044199994, 68.92304108300004],
              [-51.06509355399993, 68.90949127800008],
              [-51.07371985599991, 68.89325592700004],
              [-51.09666907499991, 68.88589101800005],
              [-51.15599524599992, 68.88690827000005],
              [-51.18228105399993, 68.87897370000007],
              [-51.184478318999936, 68.88141510600008],
              [-51.18504798099991, 68.88251373900005],
              [-51.18614661399994, 68.88361237200007],
              [-51.18976803299995, 68.88580963700008],
              [-51.18976803299995, 68.89325592700004],
              [-51.18008378799993, 68.90375397300005],
              [-51.169911261999914, 68.91083405200004],
              [-51.109486456999946, 68.93357982000003],
              [-51.09398352799991, 68.94257233300004],
              [-51.08731035099993, 68.95132070500006],
              [-51.08901933499993, 68.98045482000003],
              [-51.095773891999954, 69.00267161700003],
              [-51.110259568999936, 69.02236562700006],
              [-51.13512122299994, 69.04409414300005],
              [-51.12132727799991, 69.04832591400003],
              [-51.093739386999914, 69.04730866100005],
              [-51.07990475199995, 69.05027903900003],
              [-51.096994594999956, 69.07770416900007],
              [-51.106678839999915, 69.08942291900007],
              [-51.12083899599992, 69.09870026200008],
              [-51.07591712099992, 69.10529205900008],
              [-51.06200110599991, 69.11440664300005],
              [-51.07990475199995, 69.13279857000003],
              [-50.79019120999993, 69.12848541900007],
              [-50.74941972599993, 69.12091705900008],
              [-50.744130011999914, 69.09870026200008],
              [-50.771148240999935, 69.08755117400005],
              [-50.90176347599993, 69.07819245000007],
              [-50.92906653599994, 69.05027903900003],
              [-50.94493567599994, 69.04718659100007],
              [-50.97642981699994, 69.04474518400008],
              [-50.991118943999936, 69.03725820500006],
              [-50.92430579299992, 69.02948639500005],
              [-50.90176347599993, 69.02977122600004],
              [-50.90176347599993, 69.03725820500006],
              [-50.90925045499995, 69.03725820500006],
              [-50.90925045499995, 69.04409414300005],
              [-50.701283331999946, 69.08148834800005],
              [-50.63426673099991, 69.07200755400004],
              [-50.64338131399995, 69.05560944200005],
              [-50.648548956999946, 69.05027903900003],
              [-50.63044186099995, 69.04433828300006],
              [-50.615223761999914, 69.04913971600007],
              [-50.60118567599994, 69.05560944200005],
              [-50.586781378999945, 69.05394114800004],
              [-50.540353969999956, 69.03327057500007],
              [-50.52501380099994, 69.02977122600004],
              [-50.535267706999946, 69.01080963700008],
              [-50.539133266999954, 69.00047435100004],
              [-50.53595943899995, 68.99127838700008],
              [-50.52501380099994, 68.97516510600008],
              [-50.52367102799991, 68.96759674700007],
              [-50.524647589999915, 68.95856354400007],
              [-50.523101365999935, 68.95107656500005],
              [-50.51447506399995, 68.94790273600006],
              [-50.457875128999945, 68.94163646000004],
              [-50.43040930899991, 68.93427155200004],
              [-50.40225175699993, 68.93012116100005],
              [-50.391509568999936, 68.92426178600005],
              [-50.384755011999914, 68.91494375200006],
              [-50.38320878799993, 68.91034577000005],
              [-50.378163214999915, 68.90839264500005],
              [-50.36050370999993, 68.90692780200004],
              [-50.33438066299993, 68.90778229400007],
              [-50.31981360599991, 68.91412995000007],
              [-50.320423956999946, 68.92438385600008],
              [-50.34007727799991, 68.93732330900008],
              [-50.34845943899995, 68.94448476800005],
              [-50.353627081999946, 68.95408763200004],
              [-50.35716712099992, 68.96312083500004],
              [-50.36050370999993, 68.96832916900007],
              [-50.37486731699994, 68.97337474200003],
              [-50.38805091099994, 68.97284577000005],
              [-50.41515051999994, 68.96832916900007],
              [-50.44367428299995, 68.96796295800004],
              [-50.45726477799991, 68.96987539300005],
              [-50.470366990999935, 68.97516510600008],
              [-50.475453253999945, 68.98151276200008],
              [-50.48302161399994, 68.99941640800006],
              [-50.48745683499993, 69.00311920800004],
              [-50.493031378999945, 69.00617096600007],
              [-50.48888098899994, 69.01300690300008],
              [-50.476633266999954, 69.02362702000005],
              [-50.46007239499994, 69.02960846600007],
              [-50.43919837099992, 69.03213125200006],
              [-50.41820227799991, 69.03107330900008],
              [-50.40147864499994, 69.02667877800008],
              [-50.36856035099993, 69.00141022300005],
              [-50.350900844999956, 68.99599844000005],
              [-50.33315995999993, 69.00934479400007],
              [-50.35387122299994, 69.03343333500004],
              [-50.33551998599995, 69.05442942900004],
              [-50.298939581999946, 69.06500885600008],
              [-50.264963344999956, 69.05776601800005],
              [-50.25499426999994, 69.03949616100005],
              [-50.26309160099993, 69.01902903900003],
              [-50.28062903599994, 69.00071849200003],
              [-50.29906165299991, 68.98883698100008],
              [-50.24852454299992, 68.96356842700004],
              [-50.22166907499991, 68.95990631700005],
              [-50.20287024599992, 68.97516510600008],
              [-50.210194464999915, 68.97809479400007],
              [-50.22301184799994, 68.98582591400003],
              [-50.23021399599992, 68.98883698100008],
              [-50.21519934799994, 69.00507233300004],
              [-50.212880011999914, 69.01333242400005],
              [-50.21715247299994, 69.02362702000005],
              [-50.193023240999935, 69.01870351800005],
              [-50.18321692599994, 69.01943594000005],
              [-50.17491614499994, 69.02362702000005],
              [-50.17491614499994, 69.02977122600004],
              [-50.210194464999915, 69.06386953300006],
              [-50.22337805899991, 69.07200755400004],
              [-50.25918535099993, 69.07953522300005],
              [-50.424672003999945, 69.06098053600005],
              [-50.50914466099994, 69.07070547100005],
              [-50.67617753799993, 69.11155833500004],
              [-50.689523891999954, 69.12665436400005],
              [-50.65453040299991, 69.13983795800004],
              [-50.49120032499991, 69.12665436400005],
              [-50.38438880099994, 69.13279857000003],
              [-50.315297003999945, 69.12177155200004],
              [-50.299387173999946, 69.12295156500005],
              [-50.27208411399994, 69.13735586100006],
              [-50.25816809799994, 69.14240143400008],
              [-50.23766028599994, 69.14712148600006],
              [-50.178944464999915, 69.15387604400007],
              [-50.16193600199995, 69.16014232000003],
              [-50.13975989499994, 69.17975495000007],
              [-50.130116339999915, 69.20246002800008],
              [-50.137277798999946, 69.22117747600004],
              [-50.16502844999991, 69.22907135600008],
              [-50.18228105399993, 69.22577545800004],
              [-50.196156378999945, 69.21796295800004],
              [-50.208973761999914, 69.20868561400005],
              [-50.22337805899991, 69.20111725500004],
              [-50.24278723899994, 69.19647858300004],
              [-50.30650794199994, 69.19489166900007],
              [-50.29906165299991, 69.19489166900007],
              [-50.32140051999994, 69.19481028900003],
              [-50.365793423999946, 69.20062897300005],
              [-50.38841712099992, 69.20111725500004],
              [-50.430978969999956, 69.19448476800005],
              [-50.451730923999946, 69.19627513200004],
              [-50.470366990999935, 69.20856354400007],
              [-50.450510219999956, 69.22500234600005],
              [-50.443023240999935, 69.22907135600008],
              [-50.45099850199995, 69.23139069200005],
              [-50.45571855399993, 69.23493073100008],
              [-50.462961391999954, 69.24266185100004],
              [-50.45409094999991, 69.24795156500005],
              [-50.453236456999946, 69.25185781500005],
              [-50.459095831999946, 69.25462474200003],
              [-50.470366990999935, 69.25633372600004],
              [-50.45885169199994, 69.27094147300005],
              [-50.46275794199994, 69.28245677300004],
              [-50.47052975199995, 69.29295482000003],
              [-50.470366990999935, 69.30414459800005],
              [-50.45091712099992, 69.31574127800008],
              [-50.390288865999935, 69.32562897300005],
              [-50.36668860599991, 69.33893463700008],
              [-50.42992102799991, 69.34715403900003],
              [-50.48818925699993, 69.32855866100005],
              [-50.60008704299992, 69.27680084800005],
              [-50.56187903599994, 69.26691315300008],
              [-50.54320227799991, 69.25804271000004],
              [-50.54238847599993, 69.24607982000003],
              [-50.55370032499991, 69.23647695500006],
              [-50.56688391799992, 69.22992584800005],
              [-50.59390214799993, 69.22138092700004],
              [-50.59276282499991, 69.21971263200004],
              [-50.59333248599995, 69.21539948100008],
              [-50.60822506399995, 69.21674225500004],
              [-50.64492753799993, 69.21572500200006],
              [-50.662180141999954, 69.22215403900003],
              [-50.64171301999994, 69.22907135600008],
              [-50.64171301999994, 69.23525625200006],
              [-50.68517005099994, 69.23236725500004],
              [-50.76720130099994, 69.20233795800004],
              [-50.83226477799991, 69.19212474200003],
              [-50.86856035099993, 69.17894114800004],
              [-50.88752193899995, 69.17446523600006],
              [-50.914947068999936, 69.17365143400008],
              [-51.003244594999956, 69.18048737200007],
              [-51.00999915299991, 69.18036530200004],
              [-51.01732337099992, 69.18447500200006],
              [-51.023508266999954, 69.19017161700003],
              [-51.03278561099995, 69.19489166900007],
              [-51.09414628799993, 69.20111725500004],
              [-51.11473548099991, 69.20648834800005],
              [-51.11510169199994, 69.21222565300008],
              [-51.07990475199995, 69.22907135600008],
              [-51.08556067599994, 69.23187897300005],
              [-51.095366990999935, 69.23956940300008],
              [-51.10041256399995, 69.24266185100004],
              [-51.08731035099993, 69.24746328300006],
              [-51.074330206999946, 69.24697500200006],
              [-51.045765753999945, 69.24266185100004],
              [-51.034413214999915, 69.24697500200006],
              [-51.02183997299994, 69.26577383000006],
              [-51.01162675699993, 69.27000560100004],
              [-50.93830318899995, 69.27240631700005],
              [-50.86766516799992, 69.28367747600004],
              [-50.892689581999946, 69.29865143400008],
              [-50.95189368399991, 69.30011627800008],
              [-50.97374426999994, 69.30756256700005],
              [-50.987538214999915, 69.32982005400004],
              [-50.970366990999935, 69.33783600500004],
              [-50.90925045499995, 69.33893463700008],
              [-50.912993943999936, 69.34882233300004],
              [-50.91539466099994, 69.35252513200004],
              [-50.89366614499994, 69.35407135600008],
              [-50.852772589999915, 69.33991120000007],
              [-50.83348548099991, 69.34511953300006],
              [-50.89220130099994, 69.38593170800004],
              [-50.89488684799994, 69.40033600500004],
              [-50.88272050699993, 69.41111888200004],
              [-50.856353318999936, 69.41693756700005],
              [-50.84715735599991, 69.42829010600008],
              [-50.84512285099993, 69.44147370000007],
              [-50.850819464999915, 69.44647858300004],
              [-50.85973059799994, 69.45087311400005],
              [-50.86766516799992, 69.46181875200006],
              [-50.75841223899994, 69.47606028900003],
              [-50.71080481699994, 69.48993561400005],
              [-50.68517005099994, 69.49225495000007],
              [-50.66161048099991, 69.48602936400005],
              [-50.623605923999946, 69.47003815300008],
              [-50.575062628999945, 69.45644765800006],
              [-50.525380011999914, 69.44814687700006],
              [-50.484038865999935, 69.44814687700006],
              [-50.484038865999935, 69.45433177300004],
              [-50.497303839999915, 69.45970286700003],
              [-50.504017706999946, 69.46727122600004],
              [-50.50914466099994, 69.47724030200004],
              [-50.517567511999914, 69.48969147300005],
              [-50.46983801999994, 69.50299713700008],
              [-50.41966712099992, 69.50893789300005],
              [-50.28892981699994, 69.50063711100006],
              [-50.26056881399995, 69.50421784100007],
              [-50.20287024599992, 69.52326080900008],
              [-50.230580206999946, 69.53180573100008],
              [-50.34007727799991, 69.52326080900008],
              [-50.35024980399993, 69.52606842700004],
              [-50.36318925699993, 69.53270091400003],
              [-50.384755011999914, 69.54779694200005],
              [-50.39598548099991, 69.54905833500004],
              [-50.44994055899991, 69.54433828300006],
              [-50.478505011999914, 69.53587474200003],
              [-50.53555253799993, 69.51129791900007],
              [-50.56655839799993, 69.50275299700007],
              [-50.592640753999945, 69.49628327000005],
              [-50.641468878999945, 69.49518463700008],
              [-50.69054114499994, 69.49957916900007],
              [-50.72362219999991, 69.50958893400008],
              [-50.70913652299993, 69.51552969000005],
              [-50.693918423999946, 69.51752350500004],
              [-50.662180141999954, 69.51703522300005],
              [-50.71580969999991, 69.52667877800008],
              [-50.76520748599995, 69.51166413000004],
              [-50.81102454299992, 69.49070872600004],
              [-50.85399329299992, 69.48224518400008],
              [-50.87450110599991, 69.49140045800004],
              [-50.88060462099992, 69.50787995000007],
              [-50.87340247299994, 69.52362702000005],
              [-50.85399329299992, 69.53070709800005],
              [-50.83495032499991, 69.53457265800006],
              [-50.81159420499995, 69.54450104400007],
              [-50.795765753999945, 69.55768463700008],
              [-50.799387173999946, 69.57168203300006],
              [-50.798817511999914, 69.58710358300004],
              [-50.81240800699993, 69.60032786700003],
              [-50.83145097599993, 69.61286041900007],
              [-50.84715735599991, 69.62628815300008],
              [-50.77525794199994, 69.65029531500005],
              [-50.69326738199993, 69.64520905200004],
              [-50.42418372299994, 69.59918854400007],
              [-50.408314581999946, 69.60578034100007],
              [-50.42324785099993, 69.61871979400007],
              [-50.44912675699993, 69.63296133000006],
              [-50.461496548999946, 69.64573802300004],
              [-50.435658331999946, 69.65420156500005],
              [-50.508656378999945, 69.64468008000006],
              [-50.53184973899994, 69.64671458500004],
              [-50.59455318899995, 69.67039622600004],
              [-50.621205206999946, 69.67405833500004],
              [-50.736317511999914, 69.66571686400005],
              [-50.79442298099991, 69.67206452000005],
              [-50.82664954299992, 69.70197174700007],
              [-50.796131964999915, 69.71987539300005],
              [-50.70689856699994, 69.73012929900005],
              [-50.66901607999995, 69.73956940300008],
              [-50.621205206999946, 69.76341380400004],
              [-50.60610917899993, 69.78327057500007],
              [-50.59434973899994, 69.79067617400005],
              [-50.57494055899991, 69.78900788000004],
              [-50.52721106699994, 69.77948639500005],
              [-50.42747962099992, 69.77480703300006],
              [-50.35391191299993, 69.76093170800004],
              [-50.27179928299995, 69.76341380400004],
              [-50.22996985599991, 69.75849030200004],
              [-50.20995032499991, 69.75861237200007],
              [-50.18919837099992, 69.76341380400004],
              [-50.24762936099995, 69.77602773600006],
              [-50.264963344999956, 69.78388092700004],
              [-50.27586829299992, 69.79140859600005],
              [-50.29564368399991, 69.81492747600004],
              [-50.30736243399991, 69.82257721600007],
              [-50.31851152299993, 69.82672760600008],
              [-50.32335364499994, 69.83173248900005],
              [-50.31582597599993, 69.84198639500005],
              [-50.30724036399994, 69.84910716400003],
              [-50.301625128999945, 69.85504791900007],
              [-50.300770636999914, 69.86220937700006],
              [-50.30650794199994, 69.87327708500004],
              [-50.332875128999945, 69.88996002800008],
              [-50.37336178299995, 69.89801666900007],
              [-50.48550370999993, 69.90241120000007],
              [-50.56126868399991, 69.91616445500006],
              [-50.59333248599995, 69.92792389500005],
              [-50.56655839799993, 69.94839101800005],
              [-50.586496548999946, 69.95526764500005],
              [-50.56094316299993, 69.97492096600007],
              [-50.34398352799991, 69.97858307500007],
              [-50.29906165299991, 69.98680247600004],
              [-50.20970618399991, 70.01675039300005],
              [-50.23729407499991, 70.03839752800008],
              [-50.27529863199993, 70.04584381700005],
              [-50.421986456999946, 70.03717682500007],
              [-50.432932094999956, 70.04169342700004],
              [-50.44945227799991, 70.05442942900004],
              [-50.456695115999935, 70.05760325700004],
              [-50.47105872299994, 70.05792877800008],
              [-50.47765051999994, 70.05459219000005],
              [-50.482411261999914, 70.04938385600008],
              [-50.49087480399993, 70.04401276200008],
              [-50.50145423099991, 70.04047272300005],
              [-50.718820766999954, 69.99652741100005],
              [-50.804798956999946, 69.99115631700005],
              [-50.939116990999935, 69.96356842700004],
              [-51.25967363199993, 69.96303945500006],
              [-51.28595943899995, 69.96954987200007],
              [-51.252064581999946, 69.96991608300004],
              [-51.22704016799992, 69.97919342700004],
              [-51.18228105399993, 70.00307851800005],
              [-51.164947068999936, 70.00511302300004],
              [-51.148508266999954, 70.00385163000004],
              [-51.13267981699994, 70.00482819200005],
              [-51.11778723899994, 70.01361725500004],
              [-51.09406490799995, 70.03424713700008],
              [-51.08702551999994, 70.03717682500007],
              [-51.05093339799993, 70.03534577000005],
              [-51.03473873599995, 70.03143952000005],
              [-51.018422003999945, 70.02411530200004],
              [-51.00938880099994, 70.01675039300005],
              [-51.00064042899993, 70.00747304900005],
              [-50.991525844999956, 69.99957916900007],
              [-50.98094641799992, 69.99624258000006],
              [-50.86082923099991, 70.02411530200004],
              [-50.898426886999914, 70.03880442900004],
              [-50.98184160099993, 70.03241608300004],
              [-51.018422003999945, 70.04401276200008],
              [-51.01040605399993, 70.04511139500005],
              [-50.991118943999936, 70.05145905200004],
              [-50.991118943999936, 70.05760325700004],
              [-51.03083248599995, 70.06582265800006],
              [-51.22105872299994, 70.07396067900004],
              [-51.244984503999945, 70.07135651200008],
              [-51.25938880099994, 70.06683991100005],
              [-51.26797441299993, 70.06098053600005],
              [-51.28595943899995, 70.04401276200008],
              [-51.38048255099994, 69.98847077000005],
              [-51.438710089999915, 69.96645742400005],
              [-51.47032630099994, 69.97573476800005],
              [-51.55532792899993, 69.97333405200004],
              [-51.57335364499994, 69.98314036700003],
              [-51.56895911399994, 69.98981354400007],
              [-51.541900193999936, 70.01162344000005],
              [-51.53237870999993, 70.02411530200004],
              [-51.54092363199993, 70.02777741100005],
              [-51.54979407499991, 70.03034088700008],
              [-51.56427975199995, 70.02871328300006],
              [-51.60806230399993, 70.01675039300005],
              [-51.62535559799994, 70.01504140800006],
              [-51.83511308499993, 70.02171458500004],
              [-51.92491614499994, 70.01105377800008],
              [-51.96898352799991, 70.01105377800008],
              [-52.009755011999914, 70.01984284100007],
              [-52.06126868399991, 70.05121491100005],
              [-52.08055579299992, 70.05121491100005],
              [-52.10065670499995, 70.04682038000004],
              [-52.19245357999995, 70.04144928600005],
              [-52.277455206999946, 70.05621979400007],
              [-52.29954993399991, 70.05760325700004],
              [-52.30492102799991, 70.05670807500007],
              [-52.31273352799991, 70.05243561400005],
              [-52.32066809799994, 70.05145905200004],
              [-52.32949785099993, 70.05361562700006],
              [-52.34398352799991, 70.06293366100005],
              [-52.37987219999991, 70.07339101800005],
              [-52.46401933499993, 70.13397858300004],
              [-52.50059973899994, 70.15208567900004],
              [-52.52061926999994, 70.15867747600004],
              [-52.53978430899991, 70.16132233300004],
              [-52.55264238199993, 70.16567617400005],
              [-52.56167558499993, 70.17584870000007],
              [-52.56895911399994, 70.18829987200007],
              [-52.577015753999945, 70.19887929900005],
              [-52.60997473899994, 70.21710846600007],
              [-52.92090816999993, 70.28510163000007],
              [-53.23184160099993, 70.35309479400007],
              [-53.53591874949993, 70.36688873900007],
              [-53.83999589799993, 70.38068268400008],
              [-54.01870683499993, 70.41323476800005],
              [-54.07799231699994, 70.44891998900005],
              [-54.11436926999994, 70.46255117400005],
              [-54.18464107999995, 70.47662995000007],
              [-54.186756964999915, 70.48871491100005],
              [-54.19961503799993, 70.50348541900007],
              [-54.21857662699995, 70.51837799700007],
              [-54.32526607999995, 70.57318756700005],
              [-54.45929928299995, 70.61908600500004],
              [-54.537098761999914, 70.65648021000004],
              [-54.55451412699995, 70.66095612200007],
              [-54.57396399599992, 70.66136302300004],
              [-54.61107337099992, 70.65468984600005],
              [-54.63023841099994, 70.65412018400008],
              [-54.63023841099994, 70.66095612200007],
              [-54.60265051999994, 70.67357005400004],
              [-54.58812415299991, 70.68256256700005],
              [-54.58185787699995, 70.69204336100006],
              [-54.58088131399995, 70.70526764500005],
              [-54.57750403599994, 70.71417877800008],
              [-54.571156378999945, 70.72052643400008],
              [-54.56102454299992, 70.72650788000004],
              [-54.523101365999935, 70.74017975500004],
              [-54.442250128999945, 70.75478750200006],
              [-54.325835740999935, 70.79759349200003],
              [-54.242176886999914, 70.81761302300004],
              [-54.15538489499994, 70.82880280200004],
              [-53.97964433499993, 70.82965729400007],
              [-53.93272864499994, 70.81899648600006],
              [-53.88939368399991, 70.81513092700004],
              [-53.82213294199994, 70.79376862200007],
              [-53.772043423999946, 70.79181549700007],
              [-53.67031816299993, 70.79877350500004],
              [-53.64728756399995, 70.79523346600007],
              [-53.58189856699994, 70.77081940300008],
              [-53.43399003799993, 70.75267161700003],
              [-53.19163977799991, 70.77216217700004],
              [-52.79063880099994, 70.75678131700005],
              [-52.45034745999993, 70.70258209800005],
              [-52.26992753799993, 70.63544342700004],
              [-52.12144934799994, 70.60175202000005],
              [-52.09410559799994, 70.58527252800008],
              [-52.052072719999956, 70.56915924700007],
              [-51.96507727799991, 70.54954661700003],
              [-51.843006964999915, 70.50726959800005],
              [-51.67528235599991, 70.47431061400005],
              [-51.54942786399994, 70.43158600500004],
              [-51.409494594999956, 70.43500397300005],
              [-51.19286048099991, 70.40257396000004],
              [-51.06627356699994, 70.36676666900007],
              [-50.82949785099993, 70.35639069200005],
              [-50.659413214999915, 70.32575104400007],
              [-50.61156165299991, 70.32440827000005],
              [-50.56663977799991, 70.33368561400005],
              [-50.53184973899994, 70.35932038000004],
              [-50.54181881399995, 70.37274811400005],
              [-50.55337480399993, 70.38178131700005],
              [-50.56786048099991, 70.38812897300005],
              [-50.586496548999946, 70.39411041900007],
              [-50.61119544199994, 70.39541250200006],
              [-50.63768469999991, 70.39126211100006],
              [-50.662668423999946, 70.39020416900007],
              [-50.68268795499995, 70.40086497600004],
              [-50.65933183499993, 70.41486237200007],
              [-50.59520423099991, 70.44358958500004],
              [-50.59333248599995, 70.46295807500007],
              [-50.57494055899991, 70.47451406500005],
              [-50.516916469999956, 70.49799225500004],
              [-50.50450598899994, 70.50018952000005],
              [-50.50169837099992, 70.50617096600007],
              [-50.49644934799994, 70.50901927300004],
              [-50.49372311099995, 70.51333242400005],
              [-50.49828040299991, 70.52383047100005],
              [-50.505116339999915, 70.52814362200007],
              [-50.53001868399991, 70.53656647300005],
              [-50.53864498599995, 70.53807200700004],
              [-50.55972245999993, 70.53266022300005],
              [-50.603505011999914, 70.50873444200005],
              [-50.642241990999935, 70.49701569200005],
              [-50.65343176999994, 70.46922435100004],
              [-50.66901607999995, 70.46295807500007],
              [-50.69245357999995, 70.45937734600005],
              [-50.744130011999914, 70.42820872600004],
              [-50.77208411399994, 70.42084381700005],
              [-50.99278723899994, 70.42495351800005],
              [-51.058583136999914, 70.43903229400007],
              [-51.09414628799993, 70.46979401200008],
              [-50.94273841099994, 70.46979401200008],
              [-50.96353105399993, 70.48480866100005],
              [-51.00426184799994, 70.49721914300005],
              [-51.07990475199995, 70.51072825700004],
              [-51.19025631399995, 70.50250885600008],
              [-51.22329667899993, 70.51072825700004],
              [-51.24058997299994, 70.53436920800004],
              [-51.32591712099992, 70.55540599200003],
              [-51.34740149599992, 70.57160065300008],
              [-51.31944739499994, 70.58295319200005],
              [-51.23070227799991, 70.60635000200006],
              [-51.207915818999936, 70.62230052300004],
              [-51.194976365999935, 70.62848541900007],
              [-51.18228105399993, 70.62620677300004],
              [-51.17650305899991, 70.61896393400008],
              [-51.17540442599994, 70.60976797100005],
              [-51.177805141999954, 70.60040924700007],
              [-51.18228105399993, 70.59271881700005],
              [-51.16124426999994, 70.57941315300008],
              [-51.130197719999956, 70.57099030200004],
              [-51.03648841099994, 70.56000397300005],
              [-50.97492428299995, 70.53656647300005],
              [-50.94310462099992, 70.53123607000003],
              [-50.91576087099992, 70.53143952000005],
              [-50.90575110599991, 70.52667877800008],
              [-50.90176347599993, 70.51414622600004],
              [-50.89683997299994, 70.51023997600004],
              [-50.88585364499994, 70.51080963700008],
              [-50.874256964999915, 70.51398346600007],
              [-50.86766516799992, 70.51764557500007],
              [-50.864491339999915, 70.53530508000006],
              [-50.87840735599991, 70.54718659100007],
              [-50.89745032499991, 70.55780670800004],
              [-50.90925045499995, 70.57160065300008],
              [-50.88975989499994, 70.57192617400005],
              [-50.78661048099991, 70.54808177300004],
              [-50.73729407499991, 70.54486725500004],
              [-50.76475989499994, 70.56207916900007],
              [-50.79869544199994, 70.57282135600008],
              [-50.86766516799992, 70.58527252800008],
              [-50.85757402299993, 70.59320709800005],
              [-50.83967037699995, 70.60415273600006],
              [-50.83348548099991, 70.61318594000005],
              [-50.85399329299992, 70.61298248900005],
              [-50.89293372299994, 70.60228099200003],
              [-50.91234290299991, 70.59951406500005],
              [-50.93260657499991, 70.60101959800005],
              [-50.991118943999936, 70.61318594000005],
              [-50.96971594999991, 70.63898346600007],
              [-50.92674719999991, 70.65558502800008],
              [-50.87873287699995, 70.66254303600005],
              [-50.756418423999946, 70.64972565300008],
              [-50.71939042899993, 70.62905508000006],
              [-50.696929490999935, 70.62372467700004],
              [-50.63621985599991, 70.62026601800005],
              [-50.624989386999914, 70.62238190300008],
              [-50.62352454299992, 70.62840403900003],
              [-50.63426673099991, 70.64052969000005],
              [-50.65269934799994, 70.65033600500004],
              [-50.91539466099994, 70.68891022300005],
              [-51.10041256399995, 70.66095612200007],
              [-51.10041256399995, 70.66779205900008],
              [-51.080067511999914, 70.67780182500007],
              [-51.07848059799994, 70.68939850500004],
              [-51.08458411399994, 70.70400625200006],
              [-51.08731035099993, 70.72304922100005],
              [-51.064564581999946, 70.74852122600004],
              [-51.05992591099994, 70.76097239800004],
              [-51.07990475199995, 70.76398346600007],
              [-51.09935462099992, 70.75702545800004],
              [-51.12067623599995, 70.74323151200008],
              [-51.16942298099991, 70.70270416900007],
              [-51.17625891799992, 70.69879791900007],
              [-51.18976803299995, 70.69513580900008],
              [-51.20811926999994, 70.69253164300005],
              [-51.39915930899991, 70.69733307500007],
              [-51.43000240799995, 70.70937734600005],
              [-51.44513912699995, 70.73191966400003],
              [-51.43822180899991, 70.74697500200006],
              [-51.416900193999936, 70.75527578300006],
              [-51.388742641999954, 70.75779857000003],
              [-51.33934485599991, 70.75535716400003],
              [-51.31395423099991, 70.75690338700008],
              [-51.29214433499993, 70.76398346600007],
              [-51.281320766999954, 70.77265045800004],
              [-51.27794348899994, 70.78050364800004],
              [-51.276600714999915, 70.78876373900005],
              [-51.27171790299991, 70.79877350500004],
              [-51.26085364499994, 70.81020742400005],
              [-51.25072180899991, 70.81386953300006],
              [-51.170765753999945, 70.80609772300005],
              [-51.09898841099994, 70.78799062700006],
              [-51.04002844999991, 70.78815338700008],
              [-51.01162675699993, 70.78449127800008],
              [-50.81859290299991, 70.72093333500004],
              [-50.68797766799992, 70.70693594000005],
              [-50.66161048099991, 70.71246979400007],
              [-50.651600714999915, 70.71857330900008],
              [-50.63829505099994, 70.72915273600006],
              [-50.63158118399991, 70.73908112200007],
              [-50.64142818899995, 70.74355703300006],
              [-50.71471106699994, 70.74433014500005],
              [-50.740223761999914, 70.75604889500005],
              [-50.73729407499991, 70.78449127800008],
              [-50.89411373599995, 70.80805084800005],
              [-50.91470292899993, 70.81610748900005],
              [-50.91539466099994, 70.82542552300004],
              [-50.920033331999946, 70.83869049700007],
              [-50.89781653599994, 70.85203685100004],
              [-50.84715735599991, 70.87323639500005],
              [-50.88634192599994, 70.88108958500004],
              [-50.94025631399995, 70.87588125200006],
              [-50.993804490999935, 70.86334870000007],
              [-51.032093878999945, 70.84931061400005],
              [-51.07298743399991, 70.84048086100006],
              [-51.12364661399994, 70.84389883000006],
              [-51.173166469999956, 70.85602448100008],
              [-51.210275844999956, 70.87323639500005],
              [-51.18976803299995, 70.88068268400008],
              [-51.18976803299995, 70.88690827000005],
              [-51.456695115999935, 70.90814850500004],
              [-51.53628495999993, 70.93036530200004],
              [-51.58922278599994, 70.92991771000004],
              [-51.61432857999995, 70.93528880400004],
              [-51.66283118399991, 70.96190013200004],
              [-51.91486568899995, 71.02142975500004],
              [-51.95689856699994, 71.02411530200004],
              [-51.946197068999936, 71.03143952000005],
              [-51.90916907499991, 71.04515208500004],
              [-51.891835089999915, 71.05658600500004],
              [-51.88255774599992, 71.06126536700003],
              [-51.86754309799994, 71.06565989800004],
              [-51.83193925699993, 71.06940338700008],
              [-51.51990719299994, 71.01581452000008],
              [-51.207875128999945, 70.96222565300008],
              [-50.997710740999935, 70.96515534100007],
              [-50.95531165299991, 70.97431061400005],
              [-50.93614661399994, 70.98688385600008],
              [-50.930978969999956, 71.01260000200006],
              [-50.91539466099994, 71.02411530200004],
              [-51.20213782499991, 71.01764557500007],
              [-51.251210089999915, 71.02411530200004],
              [-51.31285559799994, 71.04279205900008],
              [-51.419178839999915, 71.05076732000003],
              [-51.476551886999914, 71.06378815300008],
              [-51.48477128799993, 71.07037995000007],
              [-51.47061113199993, 71.08246491100005],
              [-51.43106035099993, 71.09170156500005],
              [-51.29214433499993, 71.07868073100008],
              [-51.31753495999993, 71.08612702000005],
              [-51.350453253999945, 71.08759186400005],
              [-51.38003495999993, 71.09324778900003],
              [-51.39586341099994, 71.11347077000005],
              [-51.22329667899993, 71.14077383000006],
              [-51.22329667899993, 71.14760976800005],
              [-51.34333248599995, 71.14655182500007],
              [-51.50877844999991, 71.11530182500007],
              [-51.673939581999946, 71.11090729400007],
              [-51.71117102799991, 71.11969635600008],
              [-51.73277747299994, 71.13255442900004],
              [-51.74596106699994, 71.13837311400005],
              [-51.76329505099994, 71.14077383000006],
              [-51.84251868399991, 71.13739655200004],
              [-51.84829667899993, 71.13397858300004],
              [-51.866851365999935, 71.12872955900008],
              [-51.96422278599994, 71.11652252800008],
              [-52.00487219999991, 71.10293203300006],
              [-52.025502081999946, 71.09979889500005],
              [-52.178293423999946, 71.10346100500004],
              [-52.22476152299993, 71.11652252800008],
              [-52.242746548999946, 71.12677643400008],
              [-52.24478105399993, 71.13471100500004],
              [-52.23322506399995, 71.14130280200004],
              [-52.210194464999915, 71.14760976800005],
              [-52.13780676999994, 71.15477122600004],
              [-52.11461341099994, 71.16058991100005],
              [-52.099273240999935, 71.16885000200006],
              [-52.05996660099993, 71.19912344000005],
              [-52.027333136999914, 71.21417877800008],
              [-51.903187628999945, 71.24774811400005],
              [-51.81017005099994, 71.25747304900005],
              [-51.621164516999954, 71.25063711100006],
              [-51.572377081999946, 71.25592682500007],
              [-51.54710852799991, 71.26312897300005],
              [-51.52867591099994, 71.27423737200007],
              [-51.524647589999915, 71.28327057500007],
              [-51.52403723899994, 71.29621002800008],
              [-51.52757727799991, 71.30776601800005],
              [-51.53575598899994, 71.31268952000005],
              [-51.668039516999954, 71.33665599200003],
              [-51.69005286399994, 71.34682851800005],
              [-51.665272589999915, 71.35407135600008],
              [-51.65343176999994, 71.35944245000007],
              [-51.642241990999935, 71.36733633000006],
              [-51.74901282499991, 71.36041901200008],
              [-52.04942786399994, 71.24725983300004],
              [-52.135324673999946, 71.23151276200008],
              [-52.23302161399994, 71.19501373900005],
              [-52.342355923999946, 71.17609284100007],
              [-52.42430579299992, 71.15167877800008],
              [-52.48375403599994, 71.14769114800004],
              [-52.51695716099994, 71.14826080900008],
              [-52.53433183499993, 71.15306224200003],
              [-52.55036373599995, 71.16437409100007],
              [-52.55772864499994, 71.17861562700006],
              [-52.553578253999945, 71.19041575700004],
              [-52.536366339999915, 71.20624420800004],
              [-52.49840247299994, 71.22671133000006],
              [-52.354807094999956, 71.23700592700004],
              [-52.29010982999995, 71.25527578300006],
              [-52.25890051999994, 71.27265045800004],
              [-52.24559485599991, 71.29535553600005],
              [-52.25820878799993, 71.31810130400004],
              [-52.28034420499995, 71.33454010600008],
              [-52.28815670499995, 71.34894440300008],
              [-52.25767981699994, 71.36554596600007],
              [-52.114491339999915, 71.39801666900007],
              [-52.04478919199994, 71.40326569200005],
              [-52.02847245999993, 71.40737539300005],
              [-51.99852454299992, 71.42133209800005],
              [-51.98082434799994, 71.42666250200006],
              [-51.94713294199994, 71.42780182500007],
              [-51.88426673099991, 71.44037506700005],
              [-51.612212693999936, 71.45624420800004],
              [-51.42137610599991, 71.43927643400008],
              [-51.38158118399991, 71.44863515800006],
              [-51.39586341099994, 71.46222565300008],
              [-51.37010657499991, 71.47162506700005],
              [-51.34740149599992, 71.48403554900005],
              [-51.36095130099994, 71.49371979400007],
              [-51.38036048099991, 71.49725983300004],
              [-51.68228105399993, 71.50958893400008],
              [-52.10732988199993, 71.44818756700005],
              [-52.240223761999914, 71.40570709800005],
              [-52.333322719999956, 71.39606354400007],
              [-52.42625891799992, 71.37225983300004],
              [-52.709258592499936, 71.39679596550005],
              [-52.992258266999954, 71.42133209800005],
              [-52.992258266999954, 71.42877838700008],
              [-52.975493943999936, 71.43195221600007],
              [-52.96711178299995, 71.43500397300005],
              [-52.94774329299992, 71.44623444200005],
              [-52.90510006399995, 71.45880768400008],
              [-52.82787024599992, 71.46893952000005],
              [-52.806711391999954, 71.47654857000003],
              [-52.73778235599991, 71.51268138200004],
              [-52.70091712099992, 71.52594635600008],
              [-52.25861568899995, 71.57953522300005],
              [-52.138783331999946, 71.57217031500005],
              [-51.78160559799994, 71.60272858300004],
              [-51.76109778599994, 71.60980866100005],
              [-51.741851365999935, 71.61969635600008],
              [-51.72760982999995, 71.63104889500005],
              [-51.70075436099995, 71.65790436400005],
              [-51.67601477799991, 71.67255280200004],
              [-51.654286261999914, 71.69599030200004],
              [-51.64622962099992, 71.71751536700003],
              [-51.66954505099994, 71.72296784100007],
              [-51.66270911399994, 71.72980377800008],
              [-51.757883266999954, 71.73045482000003],
              [-51.78563391799992, 71.72296784100007],
              [-51.79820716099994, 71.72052643400008],
              [-51.81017005099994, 71.71124909100007],
              [-51.83031165299991, 71.68537018400008],
              [-51.86343339799993, 71.66412995000007],
              [-51.90143795499995, 71.65265534100007],
              [-52.16641191299993, 71.61310455900008],
              [-52.57331295499995, 71.63792552300004],
              [-52.57070878799993, 71.65184153900003],
              [-52.56590735599991, 71.66510651200008],
              [-52.56330318899995, 71.67755768400008],
              [-52.56704667899993, 71.68878815300008],
              [-52.58145097599993, 71.69660065300008],
              [-52.60033118399991, 71.69550202000005],
              [-52.636830206999946, 71.68378327000005],
              [-52.662993943999936, 71.67975495000007],
              [-52.96448727099994, 71.69483063350006],
              [-53.26598059799994, 71.70990631700005],
              [-53.25914466099994, 71.70990631700005],
              [-53.262562628999945, 71.71063873900005],
              [-53.26520748599995, 71.71084219000005],
              [-53.266468878999945, 71.71230703300006],
              [-53.26598059799994, 71.71674225500004],
              [-53.21397864499994, 71.73273346600007],
              [-53.10985266799992, 71.78156159100007],
              [-53.00182044199994, 71.79694245000007],
              [-52.94688880099994, 71.81191640800006],
              [-52.89565995999993, 71.83563873900005],
              [-52.85448157499991, 71.86762116100005],
              [-52.89134680899991, 71.87588125200006],
              [-52.908762173999946, 71.88226959800005],
              [-52.91649329299992, 71.89423248900005],
              [-52.90782630099994, 71.91351959800005],
              [-52.88524329299992, 71.92133209800005],
              [-52.833973761999914, 71.92902252800008],
              [-52.81777910099993, 71.93919505400004],
              [-52.79662024599992, 71.96405670800004],
              [-52.78001868399991, 71.97626373900005],
              [-52.73302161399994, 71.99262116100005],
              [-52.68317623599995, 72.00409577000005],
              [-52.68317623599995, 72.01093170800004],
              [-52.74559485599991, 72.02057526200008],
              [-52.77599036399994, 72.01764557500007],
              [-52.826730923999946, 71.98590729400007],
              [-53.01732337099992, 71.93036530200004],
              [-53.033192511999914, 71.91885000200006],
              [-53.02782141799992, 71.90289948100008],
              [-53.01480058499993, 71.88174062700006],
              [-52.998890753999945, 71.86269765800006],
              [-52.98477128799993, 71.85325755400004],
              [-52.98477128799993, 71.84711334800005],
              [-53.225453253999945, 71.81150950700004],
              [-53.26598059799994, 71.79873281500005],
              [-53.29869544199994, 71.78436920800004],
              [-53.316395636999914, 71.77899811400005],
              [-53.327381964999915, 71.77822500200006],
              [-53.33922278599994, 71.77423737200007],
              [-53.35187740799995, 71.77431875200006],
              [-53.36432857999995, 71.77777741100005],
              [-53.375843878999945, 71.78436920800004],
              [-53.336008266999954, 71.81647370000007],
              [-53.325062628999945, 71.83209870000007],
              [-53.321197068999936, 71.85700104400007],
              [-53.33079993399991, 71.87506745000007],
              [-53.373117641999954, 71.90412018400008],
              [-53.386830206999946, 71.93593984600005],
              [-53.405181443999936, 71.95600006700005],
              [-53.40933183499993, 71.96662018400008],
              [-53.41051184799994, 71.97264232000003],
              [-53.41563880099994, 71.98200104400007],
              [-53.41681881399995, 71.98704661700003],
              [-53.41466223899994, 71.99347565300008],
              [-53.41002356699994, 71.99884674700007],
              [-53.403187628999945, 72.00409577000005],
              [-53.39826412699995, 72.01496002800008],
              [-53.392648891999954, 72.02293528900003],
              [-53.39126542899993, 72.03095123900005],
              [-53.399728969999956, 72.04197825700004],
              [-53.40990149599992, 72.04950592700004],
              [-53.48033606699994, 72.07819245000007],
              [-53.69831295499995, 72.12592194200005],
              [-53.72524980399993, 72.14874909100007],
              [-53.726633266999954, 72.15766022300005],
              [-53.72533118399991, 72.16901276200008],
              [-53.726633266999954, 72.17877838700008],
              [-53.73582923099991, 72.18284739800004],
              [-53.740223761999914, 72.18744538000004],
              [-53.76740475199995, 72.25726959800005],
              [-53.77769934799994, 72.27265045800004],
              [-53.79356848899994, 72.28530508000006],
              [-53.795806443999936, 72.29645416900007],
              [-53.81354732999995, 72.30198802300004],
              [-53.83503170499995, 72.30589427300004],
              [-53.84878495999993, 72.31264883000006],
              [-53.851633266999954, 72.33063385600008],
              [-53.835926886999914, 72.33881256700005],
              [-53.76447506399995, 72.34894440300008],
              [-53.58112545499995, 72.34951406500005],
              [-53.553944464999915, 72.35419342700004],
              [-53.553944464999915, 72.36041901200008],
              [-53.87022864499994, 72.35663483300004],
              [-53.92096920499995, 72.34906647300005],
              [-53.958648240999935, 72.32632070500006],
              [-53.923166469999956, 72.30267975500004],
              [-53.874989386999914, 72.27920156500005],
              [-53.84117591099994, 72.25189850500004],
              [-53.84878495999993, 72.21702708500004],
              [-53.84032141799992, 72.20355866100005],
              [-53.83869381399995, 72.19025299700007],
              [-53.83869381399995, 72.17666250200006],
              [-53.83511308499993, 72.16242096600007],
              [-53.81309973899994, 72.13865794500003],
              [-53.77965247299994, 72.12189362200007],
              [-53.601226365999935, 72.05792877800008],
              [-53.567697719999956, 72.03888580900008],
              [-53.54873613199993, 72.02195872600004],
              [-53.50210527299993, 71.96662018400008],
              [-53.48814856699994, 71.94525788000004],
              [-53.48273678299995, 71.92544179900005],
              [-53.47419186099995, 71.90656159100007],
              [-53.45091712099992, 71.88808828300006],
              [-53.41051184799994, 71.86640045800004],
              [-53.399728969999956, 71.85700104400007],
              [-53.39891516799992, 71.84589264500005],
              [-53.41112219999991, 71.83592357000003],
              [-53.42788652299993, 71.82876211100006],
              [-53.440663214999915, 71.82599518400008],
              [-53.452015753999945, 71.82147858300004],
              [-53.49254309799994, 71.79181549700007],
              [-53.63980058499993, 71.74778880400004],
              [-53.678944464999915, 71.74249909100007],
              [-53.828236456999946, 71.75543854400007],
              [-53.88548743399991, 71.75433991100005],
              [-53.91771399599992, 71.73725006700005],
              [-53.87368730399993, 71.73847077000005],
              [-53.81993567599994, 71.73322174700007],
              [-53.768869594999956, 71.71967194200005],
              [-53.73273678299995, 71.69627513200004],
              [-53.72288977799991, 71.67064036700003],
              [-53.73704993399991, 71.65216705900008],
              [-53.76585852799991, 71.64032623900005],
              [-53.80040442599994, 71.63483307500007],
              [-53.91055253799993, 71.64105866100005],
              [-53.93073482999995, 71.64638906500005],
              [-53.96666419199994, 71.66986725500004],
              [-53.98224850199995, 71.67519765800006],
              [-53.98664303299995, 71.68060944200005],
              [-53.99299068899995, 71.69253164300005],
              [-54.00255286399994, 71.70453522300005],
              [-54.01671301999994, 71.70990631700005],
              [-54.059885219999956, 71.71653880400004],
              [-54.08161373599995, 71.71735260600008],
              [-54.10204016799992, 71.70990631700005],
              [-54.06419837099992, 71.69790273600006],
              [-54.051625128999945, 71.68773021000004],
              [-54.04678300699993, 71.67177969000005],
              [-54.054351365999935, 71.65912506700005],
              [-54.09019934799994, 71.64423248900005],
              [-54.10204016799992, 71.63483307500007],
              [-54.080922003999945, 71.63491445500006],
              [-54.06525631399995, 71.62933991100005],
              [-54.03311113199993, 71.61310455900008],
              [-53.958648240999935, 71.60004303600005],
              [-53.895741339999915, 71.58148834800005],
              [-53.865305141999954, 71.56586334800005],
              [-53.84878495999993, 71.54547760600008],
              [-53.84976152299993, 71.52537669500003],
              [-53.85887610599991, 71.50348541900007],
              [-53.87140865799995, 71.48354726800005],
              [-53.882923956999946, 71.46971263200004],
              [-53.91258704299992, 71.45050690300008],
              [-53.95177161399994, 71.43781159100007],
              [-54.077381964999915, 71.42405833500004],
              [-54.205067511999914, 71.39398834800005],
              [-54.27318274599992, 71.39077383000006],
              [-54.31550045499995, 71.37759023600006],
              [-54.35973059799994, 71.37596263200004],
              [-54.435536261999914, 71.36517975500004],
              [-54.55016028599994, 71.36994049700007],
              [-54.62515214799993, 71.35130442900004],
              [-54.65025794199994, 71.35268789300005],
              [-54.698557094999956, 71.36050039300005],
              [-54.72118079299992, 71.35993073100008],
              [-54.76504472599993, 71.35350169500003],
              [-54.78726152299993, 71.35366445500006],
              [-54.78107662699995, 71.35366445500006],
              [-54.81602942599994, 71.35590241100005],
              [-54.925892706999946, 71.38564687700006],
              [-54.943918423999946, 71.39411041900007],
              [-54.952015753999945, 71.40428294500003],
              [-54.93809973899994, 71.41510651200008],
              [-54.98082434799994, 71.43622467700004],
              [-55.09251868399991, 71.43427155200004],
              [-55.14362545499995, 71.44236888200004],
              [-55.20588131399995, 71.48159414300005],
              [-55.244252081999946, 71.49632396000004],
              [-55.267689581999946, 71.48403554900005],
              [-55.257476365999935, 71.47809479400007],
              [-55.23289954299992, 71.45604075700004],
              [-55.21914628799993, 71.44749583500004],
              [-55.17796790299991, 71.43219635600008],
              [-55.131743943999936, 71.40403880400004],
              [-55.11750240799995, 71.38764069200005],
              [-55.136708136999914, 71.38031647300005],
              [-55.28758704299992, 71.38141510600008],
              [-55.40420488199993, 71.40766022300005],
              [-55.45360266799992, 71.43203359600005],
              [-55.51447506399995, 71.44916413000004],
              [-55.55382239499994, 71.48139069200005],
              [-55.66270911399994, 71.59756094000005],
              [-55.67174231699994, 71.61310455900008],
              [-55.67617753799993, 71.63011302300004],
              [-55.671538865999935, 71.63361237200007],
              [-55.63703365799995, 71.62738678600005],
              [-55.619130011999914, 71.62799713700008],
              [-55.60228430899991, 71.63080475500004],
              [-55.56932532499991, 71.64105866100005],
              [-55.58438066299993, 71.64789459800005],
              [-55.76231848899994, 71.66364166900007],
              [-55.80646725199995, 71.67304108300004],
              [-55.88711503799993, 71.67658112200007],
              [-55.90453040299991, 71.68203359600005],
              [-55.87962805899991, 71.70404694200005],
              [-55.84752356699994, 71.72199127800008],
              [-55.78783118399991, 71.74347565300008],
              [-55.731760219999956, 71.75116608300004],
              [-55.56187903599994, 71.74347565300008],
              [-55.565337693999936, 71.74949778900003],
              [-55.57209225199995, 71.76520416900007],
              [-55.57555091099994, 71.77138906500005],
              [-55.46401933499993, 71.80267975500004],
              [-55.424672003999945, 71.80613841400003],
              [-55.28465735599991, 71.76862213700008],
              [-55.26024329299992, 71.77822500200006],
              [-55.29246985599991, 71.78546784100007],
              [-55.37010657499991, 71.82599518400008],
              [-55.37669837099992, 71.84992096600007],
              [-55.359445766999954, 71.86969635600008],
              [-55.33043372299994, 71.88312409100007],
              [-55.30150305899991, 71.88808828300006],
              [-54.85334225199995, 71.91299062700006],
              [-54.555246548999946, 72.03375885600008],
              [-54.52721106699994, 72.05312734600005],
              [-54.512928839999915, 72.07990143400008],
              [-54.51545162699995, 72.08234284100007],
              [-54.52375240799995, 72.10171133000006],
              [-54.523508266999954, 72.10407135600008],
              [-54.52497311099995, 72.10976797100005],
              [-54.51992753799993, 72.11322663000004],
              [-54.50609290299991, 72.11737702000005],
              [-54.49596106699994, 72.12616608300004],
              [-54.484038865999935, 72.14866771000004],
              [-54.464100714999915, 72.16718170800004],
              [-54.44871985599991, 72.19293854400007],
              [-54.43846594999991, 72.20335521000004],
              [-54.42674719999991, 72.20941803600005],
              [-54.38320878799993, 72.22321198100008],
              [-54.408192511999914, 72.23248932500007],
              [-54.43346106699994, 72.22406647300005],
              [-54.479400193999936, 72.19594961100006],
              [-54.52904212099992, 72.17743561400005],
              [-54.541086391999954, 72.16063060100004],
              [-54.526600714999915, 72.13446686400005],
              [-54.53966223899994, 72.12783437700006],
              [-54.567616339999915, 72.11985911700003],
              [-54.58185787699995, 72.11395905200004],
              [-54.590687628999945, 72.10757070500006],
              [-54.60094153599994, 72.09369538000004],
              [-54.60912024599992, 72.08608633000006],
              [-54.62132727799991, 72.08014557500007],
              [-54.633697068999936, 72.07636139500005],
              [-54.64415442599994, 72.07050202000005],
              [-54.65013587099992, 72.05878327000005],
              [-54.64830481699994, 72.04604726800005],
              [-54.64098059799994, 72.03595612200007],
              [-54.63320878799993, 72.02875397300005],
              [-54.63023841099994, 72.02460358300004],
              [-54.64159094999991, 72.01850006700005],
              [-54.70539303299995, 72.01093170800004],
              [-54.798817511999914, 71.97138092700004],
              [-54.86603756399995, 71.95197174700007],
              [-54.89683997299994, 71.93927643400008],
              [-54.920806443999936, 71.93292877800008],
              [-55.26781165299991, 71.92731354400007],
              [-55.54344641799992, 71.98493073100008],
              [-55.60968990799995, 71.99046458500004],
              [-55.59618079299992, 71.99827708500004],
              [-55.58043372299994, 72.00458405200004],
              [-55.567290818999936, 72.01325104400007],
              [-55.56187903599994, 72.02802155200004],
              [-55.55174719999991, 72.03815338700008],
              [-55.434437628999945, 72.05971914300005],
              [-55.32998613199993, 72.05670807500007],
              [-55.281361456999946, 72.06557851800005],
              [-55.31090247299994, 72.07501862200007],
              [-55.411040818999936, 72.08608633000006],
              [-55.38536536399994, 72.10639069200005],
              [-55.23289954299992, 72.14130280200004],
              [-55.101673956999946, 72.18862539300005],
              [-55.08893795499995, 72.18976471600007],
              [-55.06468665299991, 72.21027252800008],
              [-54.88345292899993, 72.25116608300004],
              [-54.93032792899993, 72.26605866100005],
              [-54.94668535099993, 72.27789948100008],
              [-54.95177161399994, 72.29954661700003],
              [-54.92454993399991, 72.30975983300004],
              [-54.911366339999915, 72.31875234600005],
              [-54.90330969999991, 72.33307526200008],
              [-54.91978919199994, 72.33380768400008],
              [-54.93211829299992, 72.33905670800004],
              [-54.94204667899993, 72.34821198100008],
              [-54.95177161399994, 72.36041901200008],
              [-54.923898891999954, 72.36896393400008],
              [-54.882883266999954, 72.36961497600004],
              [-54.777902798999946, 72.35468170800004],
              [-54.684885219999956, 72.36717357000003],
              [-54.70376542899993, 72.37470123900005],
              [-54.724720831999946, 72.37441640800006],
              [-54.76675370999993, 72.36717357000003],
              [-54.908273891999954, 72.37995026200008],
              [-54.94395911399994, 72.39032623900005],
              [-54.97288977799991, 72.40818919500003],
              [-54.95221920499995, 72.41693756700005],
              [-54.90469316299993, 72.41885000200006],
              [-54.88345292899993, 72.42869700700004],
              [-54.95547441299993, 72.42251211100006],
              [-55.00365149599992, 72.42706940300008],
              [-55.02163652299993, 72.42365143400008],
              [-55.020090298999946, 72.40818919500003],
              [-55.04527747299994, 72.40070221600007],
              [-55.12987219999991, 72.39516836100006],
              [-55.19102942599994, 72.37189362200007],
              [-55.20498613199993, 72.36717357000003],
              [-55.22411048099991, 72.36176178600005],
              [-55.24510657499991, 72.36391836100006],
              [-55.28750566299993, 72.37409088700008],
              [-55.28750566299993, 72.38153717700004],
              [-55.24600175699993, 72.38776276200008],
              [-55.24600175699993, 72.39516836100006],
              [-55.267567511999914, 72.39533112200007],
              [-55.28384355399993, 72.40119049700007],
              [-55.296864386999914, 72.41242096600007],
              [-55.308664516999954, 72.42869700700004],
              [-55.30117753799993, 72.43618398600006],
              [-55.308664516999954, 72.44293854400007],
              [-55.304351365999935, 72.46092357000003],
              [-55.31700598899994, 72.47028229400007],
              [-55.33372962099992, 72.47016022300005],
              [-55.34215247299994, 72.46002838700008],
              [-55.34788977799991, 72.44269440300008],
              [-55.357492641999954, 72.42934804900005],
              [-55.359445766999954, 72.41840241100005],
              [-55.34215247299994, 72.40818919500003],
              [-55.35773678299995, 72.40395742400005],
              [-55.36978105399993, 72.40717194200005],
              [-55.38166256399995, 72.41278717700004],
              [-55.39679928299995, 72.41567617400005],
              [-55.416127081999946, 72.41233958500004],
              [-55.46003170499995, 72.39838288000004],
              [-55.48306230399993, 72.39516836100006],
              [-55.52912350199995, 72.39948151200008],
              [-55.57091223899994, 72.41054922100005],
              [-55.651275193999936, 72.44293854400007],
              [-55.651275193999936, 72.45038483300004],
              [-55.51211503799993, 72.51512278900003],
              [-55.47996985599991, 72.52488841400003],
              [-55.45913652299993, 72.52594635600008],
              [-55.411040818999936, 72.51064687700006],
              [-55.38687089799993, 72.50861237200007],
              [-55.33804277299993, 72.50995514500005],
              [-55.26667232999995, 72.49860260600008],
              [-55.123036261999914, 72.50438060100004],
              [-54.88817298099991, 72.46967194200005],
              [-54.739491339999915, 72.48395416900007],
              [-54.625559048999946, 72.48183828300006],
              [-54.583241339999915, 72.47239817900004],
              [-54.56102454299992, 72.47028229400007],
              [-54.42418372299994, 72.49762604400007],
              [-54.390695766999954, 72.49359772300005],
              [-54.324330206999946, 72.47638580900008],
              [-54.293853318999936, 72.48395416900007],
              [-54.31354732999995, 72.49457428600005],
              [-54.43919837099992, 72.51316966400003],
              [-54.54019120999993, 72.49762604400007],
              [-54.701283331999946, 72.49892812700006],
              [-54.78384355399993, 72.51605866100005],
              [-54.80093339799993, 72.55219147300005],
              [-54.82457434799994, 72.54588450700004],
              [-54.86831620999993, 72.52069733300004],
              [-54.89712480399993, 72.51805247600004],
              [-54.890288865999935, 72.51805247600004],
              [-54.96833248599995, 72.51699453300006],
              [-55.01056881399995, 72.52171458500004],
              [-55.01659094999991, 72.53546784100007],
              [-55.00914466099994, 72.54645416900007],
              [-55.00470943899995, 72.55890534100007],
              [-54.99844316299993, 72.57062409100007],
              [-54.98582923099991, 72.57953522300005],
              [-54.966460740999935, 72.58454010600008],
              [-54.90330969999991, 72.59381745000007],
              [-54.90583248599995, 72.59756094000005],
              [-54.910227016999954, 72.60748932500007],
              [-54.66466223899994, 72.61375560100004],
              [-54.63613847599993, 72.62225983300004],
              [-54.65013587099992, 72.63471100500004],
              [-54.67931067599994, 72.63735586100006],
              [-54.741078253999945, 72.62653229400007],
              [-54.83112545499995, 72.63593170800004],
              [-54.86091061099995, 72.64276764500005],
              [-54.86302649599992, 72.65521881700005],
              [-54.877064581999946, 72.66657135600008],
              [-54.88345292899993, 72.66889069200005],
              [-54.88345292899993, 72.67572663000004],
              [-54.859486456999946, 72.67519765800006],
              [-54.81484941299993, 72.66474030200004],
              [-54.791005011999914, 72.66205475500004],
              [-54.77228756399995, 72.66583893400008],
              [-54.76553300699993, 72.67499420800004],
              [-54.762277798999946, 72.68634674700007],
              [-54.75377356699994, 72.69684479400007],
              [-54.71422278599994, 72.70547109600005],
              [-54.62730872299994, 72.68813711100006],
              [-54.58869381399995, 72.69684479400007],
              [-54.624989386999914, 72.71360911700003],
              [-54.66901607999995, 72.72577545800004],
              [-54.75377356699994, 72.73777903900003],
              [-54.73379472599993, 72.75356679900005],
              [-54.66698157499991, 72.74860260600008],
              [-54.64020748599995, 72.75519440300008],
              [-54.615345831999946, 72.76752350500004],
              [-54.526600714999915, 72.77875397300005],
              [-54.53864498599995, 72.79173411700003],
              [-54.56191972599993, 72.80027903900003],
              [-54.58751380099994, 72.80231354400007],
              [-54.60606848899994, 72.79547760600008],
              [-54.630197719999956, 72.77903880400004],
              [-54.73277747299994, 72.75918203300006],
              [-54.866118943999936, 72.76463450700004],
              [-54.90298417899993, 72.77033112200007],
              [-54.92442786399994, 72.78558991100005],
              [-54.82457434799994, 72.80329010600008],
              [-54.80370032499991, 72.81305573100008],
              [-54.71898352799991, 72.80609772300005],
              [-54.65794837099992, 72.81378815300008],
              [-54.62808183499993, 72.82184479400007],
              [-54.60293535099993, 72.83397044500003],
              [-54.627064581999946, 72.83746979400007],
              [-54.65025794199994, 72.84495677300004],
              [-54.67027747299994, 72.85716380400004],
              [-54.684885219999956, 72.87498607000003],
              [-54.68773352799991, 72.90029531500005],
              [-54.731027798999946, 72.91852448100008],
              [-54.81460527299993, 72.93642812700006],
              [-54.78929602799991, 72.94481028900003],
              [-54.78184973899994, 72.95184967700004],
              [-54.78726152299993, 72.96369049700007],
              [-54.79751542899993, 72.96710846600007],
              [-54.84874426999994, 72.97052643400008],
              [-54.83177649599992, 72.98232656500005],
              [-54.79214433499993, 72.98554108300004],
              [-54.78107662699995, 72.99848053600005],
              [-54.81236731699994, 73.00800202000005],
              [-54.843006964999915, 73.01341380400004],
              [-54.87328040299991, 73.01459381700005],
              [-54.98143469999991, 72.99896881700005],
              [-55.02879798099991, 72.99823639500005],
              [-55.05418860599991, 73.01154205900008],
              [-55.021595831999946, 73.05101146000004],
              [-55.015695766999954, 73.07062409100007],
              [-55.04759680899991, 73.06305573100008],
              [-55.13621985599991, 73.02496979400007],
              [-55.164051886999914, 73.01898834800005],
              [-55.16673743399991, 73.01146067900004],
              [-55.17674719999991, 73.01748281500005],
              [-55.198150193999936, 73.03603750200006],
              [-55.21751868399991, 73.04140859600005],
              [-55.26089433499993, 73.04271067900004],
              [-55.267689581999946, 73.04629140800006],
              [-55.267689581999946, 73.05247630400004],
              [-55.27717037699995, 73.05231354400007],
              [-55.30117753799993, 73.04629140800006],
              [-55.37010657499991, 73.04629140800006],
              [-55.39411373599995, 73.05003489800004],
              [-55.44050045499995, 73.06757233300004],
              [-55.465687628999945, 73.07294342700004],
              [-55.66344153599994, 73.05735911700003],
              [-55.68032792899993, 73.05975983300004],
              [-55.695383266999954, 73.06952545800004],
              [-55.70030676999994, 73.07729726800005],
              [-55.70091712099992, 73.08161041900007],
              [-55.70303300699993, 73.08429596600007],
              [-55.71271725199995, 73.08722565300008],
              [-55.70303300699993, 73.09906647300005],
              [-55.68321692599994, 73.11298248900005],
              [-55.661447719999956, 73.12372467700004],
              [-55.64561926999994, 73.12641022300005],
              [-55.577463344999956, 73.11188385600008],
              [-55.50755774599992, 73.10712311400005],
              [-55.471547003999945, 73.10976797100005],
              [-55.45335852799991, 73.11399974200003],
              [-55.43781490799995, 73.12140534100007],
              [-55.43317623599995, 73.12661367400005],
              [-55.42418372299994, 73.14199453300006],
              [-55.418527798999946, 73.14809804900005],
              [-55.39806067599994, 73.15680573100008],
              [-55.350453253999945, 73.17059967700004],
              [-55.33531653599994, 73.18280670800004],
              [-55.367298956999946, 73.18244049700007],
              [-55.39801998599995, 73.17780182500007],
              [-55.42837480399993, 73.17731354400007],
              [-55.45946204299992, 73.18964264500005],
              [-55.43008378799993, 73.19623444200005],
              [-55.16258704299992, 73.18219635600008],
              [-55.14159094999991, 73.19037506700005],
              [-55.14362545499995, 73.21076080900008],
              [-55.156239386999914, 73.21747467700004],
              [-55.219309048999946, 73.22382233300004],
              [-55.21739661399994, 73.22833893400008],
              [-55.214507615999935, 73.23973216400003],
              [-55.21247311099995, 73.24428945500006],
              [-55.397775844999956, 73.24677155200004],
              [-55.45946204299992, 73.25787995000007],
              [-55.45946204299992, 73.26536692900004],
              [-55.441070115999935, 73.27041250200006],
              [-55.39000403599994, 73.30263906500005],
              [-55.338734503999945, 73.30634186400005],
              [-55.33356686099995, 73.30825429900005],
              [-55.31484941299993, 73.32062409100007],
              [-55.31484941299993, 73.32623932500007],
              [-55.34919186099995, 73.32562897300005],
              [-55.36302649599992, 73.32758209800005],
              [-55.37010657499991, 73.33368561400005],
              [-55.26911373599995, 73.38662344000005],
              [-55.249663865999935, 73.39203522300005],
              [-55.21739661399994, 73.37417226800005],
              [-55.17613684799994, 73.36249420800004],
              [-55.09512285099993, 73.35415273600006],
              [-55.08971106699994, 73.36790599200003],
              [-55.102853969999956, 73.37714264500005],
              [-55.12083899599992, 73.38442617400005],
              [-55.12987219999991, 73.39203522300005],
              [-55.14297441299993, 73.40619538000004],
              [-55.49583899599992, 73.46507396000004],
              [-55.51903235599991, 73.47260163000004],
              [-55.53457597599993, 73.48444245000007],
              [-55.533273891999954, 73.48753489800004],
              [-55.52916419199994, 73.49233633000006],
              [-55.52603105399993, 73.49827708500004],
              [-55.52782141799992, 73.50495026200008],
              [-55.53477942599994, 73.51080963700008],
              [-55.54259192599994, 73.51316966400003],
              [-55.55158443899995, 73.51487864800004],
              [-55.56187903599994, 73.51862213700008],
              [-55.62669837099992, 73.56582265800006],
              [-55.66515051999994, 73.58502838700008],
              [-55.684803839999915, 73.57387929900005],
              [-55.712228969999956, 73.56561920800004],
              [-55.744130011999914, 73.57123444200005],
              [-55.77391516799992, 73.58478424700007],
              [-55.79466712099992, 73.60053131700005],
              [-55.764515753999945, 73.61237213700008],
              [-55.75373287699995, 73.61481354400007],
              [-55.77257239499994, 73.62689850500004],
              [-55.808583136999914, 73.62555573100008],
              [-55.87791907499991, 73.61481354400007],
              [-55.95616614499994, 73.62091705900008],
              [-56.03111731699994, 73.63837311400005],
              [-56.06773841099994, 73.65302155200004],
              [-56.057199673999946, 73.65766022300005],
              [-55.986439581999946, 73.65574778900003],
              [-55.95091712099992, 73.65863678600005],
              [-55.843088344999956, 73.68309153900003],
              [-55.89049231699994, 73.69623444200005],
              [-55.99592037699995, 73.67991771000004],
              [-56.041086391999954, 73.69057851800005],
              [-56.041086391999954, 73.69672272300005],
              [-56.00031490799995, 73.70746491100005],
              [-55.92845618399991, 73.71767812700006],
              [-55.911366339999915, 73.72406647300005],
              [-55.94493567599994, 73.73371002800008],
              [-55.95230058499993, 73.73773834800005],
              [-55.96401933499993, 73.75291575700004],
              [-55.967355923999946, 73.76178620000007],
              [-55.96251380099994, 73.76561107000003],
              [-55.91454016799992, 73.76146067900004],
              [-55.891468878999945, 73.75413646000004],
              [-55.87413489499994, 73.74144114800004],
              [-55.850168423999946, 73.72915273600006],
              [-55.78433183499993, 73.72524648600006],
              [-55.75743567599994, 73.71381256700005],
              [-55.73420162699995, 73.70718008000006],
              [-55.651682094999956, 73.70136139500005],
              [-55.62954667899993, 73.70416901200008],
              [-55.63703365799995, 73.71039459800005],
              [-55.61266028599994, 73.72113678600005],
              [-55.644642706999946, 73.72426992400005],
              [-55.716135219999956, 73.72064850500004],
              [-55.72305253799993, 73.72406647300005],
              [-55.739125128999945, 73.72288646000004],
              [-55.74689693899995, 73.72406647300005],
              [-55.75377356699994, 73.72842031500005],
              [-55.76740475199995, 73.74042389500005],
              [-55.77415930899991, 73.74518463700008],
              [-55.78774980399993, 73.75153229400007],
              [-55.80313066299993, 73.75665924700007],
              [-55.81887773299991, 73.75938548400006],
              [-55.81432044199994, 73.76105377800008],
              [-55.808257615999935, 73.76561107000003],
              [-55.82335364499994, 73.77130768400008],
              [-55.85643469999991, 73.77879466400003],
              [-55.87100175699993, 73.78611888200004],
              [-55.899647589999915, 73.82111237200007],
              [-55.94546464799993, 73.86123281500005],
              [-55.841867641999954, 73.85317617400005],
              [-55.78038489499994, 73.85504791900007],
              [-55.72130286399994, 73.84320709800005],
              [-55.699330206999946, 73.84137604400007],
              [-55.66246497299994, 73.84393952000005],
              [-55.646148240999935, 73.84813060100004],
              [-55.62954667899993, 73.85504791900007],
              [-55.64476477799991, 73.87547435100004],
              [-55.67015540299991, 73.88532135600008],
              [-55.75633704299992, 73.89276764500005],
              [-55.817290818999936, 73.91160716400003],
              [-55.884877081999946, 73.91909414300005],
              [-55.914947068999936, 73.92723216400003],
              [-55.97280839799993, 73.95001862200007],
              [-56.00719153599994, 73.95677317900004],
              [-56.08153235599991, 73.96112702000005],
              [-56.10997473899994, 73.97044505400004],
              [-56.10582434799994, 73.98167552300004],
              [-56.10594641799992, 73.98891836100006],
              [-56.10997473899994, 73.99843984600005],
              [-56.102121548999946, 73.99896881700005],
              [-56.089182094999956, 74.00360748900005],
              [-56.082020636999914, 74.00527578300006],
              [-56.09170488199993, 74.00971100500004],
              [-56.10191809799994, 74.01215241100005],
              [-56.11270097599993, 74.01276276200008],
              [-56.124256964999915, 74.01211172100005],
              [-56.09593665299991, 74.02081940300008],
              [-55.99388587099992, 74.01211172100005],
              [-55.96361243399991, 74.01788971600007],
              [-55.97052975199995, 74.02708567900004],
              [-55.99742591099994, 74.03563060100004],
              [-56.331288214999915, 74.04450104400007],
              [-56.36318925699993, 74.05304596600007],
              [-56.36168372299994, 74.06366608300004],
              [-56.37482662699995, 74.06769440300008],
              [-56.41161048099991, 74.06732819200005],
              [-56.40477454299992, 74.07416413000004],
              [-56.35879472599993, 74.08307526200008],
              [-56.29942786399994, 74.08490631700005],
              [-56.24278723899994, 74.09308502800008],
              [-56.19871985599991, 74.12128327000005],
              [-56.29898027299993, 74.11155833500004],
              [-56.31602942599994, 74.12128327000005],
              [-56.26439368399991, 74.14655182500007],
              [-56.248036261999914, 74.16242096600007],
              [-56.26016191299993, 74.17658112200007],
              [-56.24429277299993, 74.18329498900005],
              [-56.223947719999956, 74.18748607000003],
              [-56.17137610599991, 74.19253164300005],
              [-56.16746985599991, 74.19855377800008],
              [-56.16734778599994, 74.20722077000005],
              [-56.164173956999946, 74.22699616100005],
              [-56.165272589999915, 74.23822663000004],
              [-56.16364498599995, 74.24774811400005],
              [-56.15465247299994, 74.25165436400005],
              [-56.14391028599994, 74.25429922100005],
              [-56.134755011999914, 74.26093170800004],
              [-56.12800045499995, 74.26996491100005],
              [-56.124256964999915, 74.27960846600007],
              [-56.16128495999993, 74.28534577000005],
              [-56.17955481699994, 74.28473541900007],
              [-56.25694739499994, 74.23794179900005],
              [-56.563343878999945, 74.16498444200005],
              [-56.929554816499945, 74.13237132350005],
              [-57.295765753999945, 74.09975820500006],
              [-57.314116990999935, 74.10268789300005],
              [-57.32217363199993, 74.11172109600005],
              [-57.318430141999954, 74.11920807500007],
              [-57.30939693899995, 74.12946198100008],
              [-57.29820716099994, 74.13849518400008],
              [-57.288319464999915, 74.14240143400008],
              [-57.20571855399993, 74.14911530200004],
              [-57.13182532499991, 74.13670482000003],
              [-57.10680091099994, 74.13711172100005],
              [-57.08942623599995, 74.14240143400008],
              [-57.12962805899991, 74.15363190300008],
              [-57.148101365999935, 74.16278717700004],
              [-57.158314581999946, 74.17658112200007],
              [-57.04059811099995, 74.17145416900007],
              [-57.001291469999956, 74.17658112200007],
              [-56.90977942599994, 74.20066966400003],
              [-56.70303300699993, 74.20384349200003],
              [-56.686756964999915, 74.20669179900005],
              [-56.658192511999914, 74.22016022300005],
              [-56.64439856699994, 74.22500234600005],
              [-56.59813391799992, 74.22646719000005],
              [-56.582915818999936, 74.23114655200004],
              [-56.58946692599994, 74.23541901200008],
              [-56.59752356699994, 74.24237702000005],
              [-56.60338294199994, 74.24481842700004],
              [-56.321929490999935, 74.28774648600006],
              [-56.30174719999991, 74.30630117400005],
              [-56.37096106699994, 74.31268952000005],
              [-56.582915818999936, 74.29262929900005],
              [-56.53620357999995, 74.31647370000007],
              [-56.53172766799992, 74.32477448100008],
              [-56.64053300699993, 74.32892487200007],
              [-56.678293423999946, 74.33466217700004],
              [-56.71324622299994, 74.34784577000005],
              [-56.67162024599992, 74.35602448100008],
              [-56.582142706999946, 74.34979889500005],
              [-56.50255286399994, 74.36725495000007],
              [-56.15465247299994, 74.36908600500004],
              [-56.13719641799992, 74.37470123900005],
              [-56.13044186099995, 74.38886139500005],
              [-56.13634192599994, 74.39492422100005],
              [-56.16323808499993, 74.40753815300008],
              [-56.17170162699995, 74.40989817900004],
              [-56.50377356699994, 74.41616445500006],
              [-56.524728969999956, 74.41315338700008],
              [-56.543039516999954, 74.40741608300004],
              [-56.56187903599994, 74.40412018400008],
              [-56.758656378999945, 74.44448476800005],
              [-56.79523678299995, 74.44403717700004],
              [-56.79523678299995, 74.45087311400005],
              [-56.61363684799994, 74.45087311400005],
              [-56.29552161399994, 74.48436107000003],
              [-56.16832434799994, 74.47752513200004],
              [-56.14476477799991, 74.49188873900005],
              [-56.24193274599992, 74.49770742400005],
              [-56.26016191299993, 74.51235586100006],
              [-56.25503495999993, 74.52985260600008],
              [-56.23509680899991, 74.54067617400005],
              [-56.19188391799992, 74.55329010600008],
              [-56.22179114499994, 74.56264883000006],
              [-56.421864386999914, 74.55329010600008],
              [-56.43146725199995, 74.55516185100004],
              [-56.46621660099993, 74.57070547100005],
              [-56.48078365799995, 74.57518138200004],
              [-56.51341712099992, 74.57660553600005],
              [-56.571522589999915, 74.58783600500004],
              [-56.590728318999936, 74.59454987200007],
              [-56.60338294199994, 74.60789622600004],
              [-56.53160559799994, 74.61725495000007],
              [-56.500559048999946, 74.62653229400007],
              [-56.47305253799993, 74.64264557500007],
              [-56.47305253799993, 74.64887116100005],
              [-56.70230058499993, 74.64472077000005],
              [-56.76789303299995, 74.66315338700008],
              [-56.75462805899991, 74.67348867400005],
              [-56.76402747299994, 74.67914459800005],
              [-56.802072719999956, 74.68366120000007],
              [-56.82262122299994, 74.68992747600004],
              [-56.855539516999954, 74.70783112200007],
              [-56.87743079299992, 74.71161530200004],
              [-56.923817511999914, 74.70628489800004],
              [-56.949208136999914, 74.69871653900003],
              [-56.969960089999915, 74.67519765800006],
              [-56.99156653599994, 74.67243073100008],
              [-57.014515753999945, 74.67780182500007],
              [-57.02794348899994, 74.69049713700008],
              [-57.01427161399994, 74.69733307500007],
              [-57.02912350199995, 74.70307038000004],
              [-57.06078040299991, 74.70600006700005],
              [-57.07579505099994, 74.71161530200004],
              [-57.06672115799995, 74.71954987200007],
              [-57.05687415299991, 74.72581614800004],
              [-57.04625403599994, 74.72992584800005],
              [-57.03477942599994, 74.73143138200004],
              [-57.054676886999914, 74.74526601800005],
              [-57.08999589799993, 74.74616120000007],
              [-57.158314581999946, 74.73826732000003],
              [-57.14867102799991, 74.74298737200007],
              [-57.14053300699993, 74.74917226800005],
              [-57.13434811099995, 74.75665924700007],
              [-57.13036048099991, 74.76557038000004],
              [-57.14639238199993, 74.76528554900005],
              [-57.193023240999935, 74.77301666900007],
              [-57.14403235599991, 74.79376862200007],
              [-57.11461341099994, 74.80084870000007],
              [-57.09312903599994, 74.79661692900004],
              [-57.07103430899991, 74.78229401200008],
              [-57.045765753999945, 74.77265045800004],
              [-57.017567511999914, 74.76727936400005],
              [-56.987212693999936, 74.76557038000004],
              [-56.97297115799995, 74.76776764500005],
              [-56.96458899599992, 74.77313873900005],
              [-56.95726477799991, 74.77977122600004],
              [-56.94603430899991, 74.78607819200005],
              [-56.93268795499995, 74.78925202000005],
              [-56.90416419199994, 74.79262929900005],
              [-56.86790930899991, 74.80589427300004],
              [-56.84601803299995, 74.81122467700004],
              [-56.79523678299995, 74.81395091400003],
              [-56.81777910099993, 74.83612702000005],
              [-56.85496985599991, 74.84845612200007],
              [-56.98696855399993, 74.85455963700008],
              [-57.00072180899991, 74.86810944200005],
              [-56.99449622299994, 74.90338776200008],
              [-57.01626542899993, 74.90696849200003],
              [-57.057850714999915, 74.92194245000007],
              [-57.08315995999993, 74.92381419500003],
              [-57.29259192599994, 74.90741608300004],
              [-57.31871497299994, 74.91396719000005],
              [-57.32966061099995, 74.93378327000005],
              [-57.33820553299995, 74.93838125200006],
              [-57.37828528599994, 74.94086334800005],
              [-57.39102128799993, 74.94432200700004],
              [-57.39679928299995, 74.95685455900008],
              [-57.42357337099992, 74.96356842700004],
              [-57.552805141999954, 74.97996653900003],
              [-57.664051886999914, 75.01422760600008],
              [-57.694203253999945, 75.01968008000006],
              [-57.84675045499995, 75.01972077000005],
              [-57.877797003999945, 75.02676015800006],
              [-57.89134680899991, 75.04336172100005],
              [-57.905140753999945, 75.05060455900008],
              [-57.97301184799994, 75.05927155200004],
              [-58.05638587099992, 75.05890534100007],
              [-58.099598761999914, 75.04852936400005],
              [-58.12140865799995, 75.04669830900008],
              [-58.14159094999991, 75.05182526200008],
              [-58.1594945949999, 75.06728750200006],
              [-58.146148240999935, 75.08380768400008],
              [-58.12515214799993, 75.08934153900003],
              [-58.07697506399995, 75.08771393400008],
              [-58.08824622299994, 75.09686920800004],
              [-58.102121548999946, 75.10175202000005],
              [-58.13149980399993, 75.10822174700007],
              [-57.940663214999915, 75.15094635600008],
              [-57.922718878999945, 75.16339752800008],
              [-57.939523891999954, 75.18024323100008],
              [-58.01231848899994, 75.19806549700007],
              [-58.16909745999993, 75.19672272300005],
              [-58.241444464999915, 75.21124909100007],
              [-58.24681555899991, 75.22797272300005],
              [-58.271473761999914, 75.23969147300005],
              [-58.330148891999954, 75.25218333500004],
              [-58.32787024599992, 75.25604889500005],
              [-58.32396399599992, 75.26650625200006],
              [-58.38939368399991, 75.28367747600004],
              [-58.42520097599993, 75.29913971600007],
              [-58.43936113199993, 75.31427643400008],
              [-58.428618943999936, 75.32538483300004],
              [-58.408314581999946, 75.32640208500004],
              [-58.37149003799993, 75.32050202000005],
              [-58.35094153599994, 75.32123444200005],
              [-58.33543860599991, 75.32367584800005],
              [-58.302845831999946, 75.33417389500005],
              [-58.31676184799994, 75.34113190300008],
              [-58.33250891799992, 75.34711334800005],
              [-58.364898240999935, 75.35521067900004],
              [-58.34642493399991, 75.37579987200007],
              [-58.27599036399994, 75.38841380400004],
              [-58.24762936099995, 75.40302155200004],
              [-58.302398240999935, 75.41144440300008],
              [-58.368804490999935, 75.41083405200004],
              [-58.43203691299993, 75.39866771000004],
              [-58.47728430899991, 75.37230052300004],
              [-58.49787350199995, 75.35468170800004],
              [-58.51748613199993, 75.34723541900007],
              [-58.700103318999936, 75.34845612200007],
              [-58.68659420499995, 75.36668528900003],
              [-58.65953528599994, 75.37734609600005],
              [-58.52684485599991, 75.40656159100007],
              [-58.44640051999994, 75.40985748900005],
              [-58.417632615999935, 75.41421133000006],
              [-58.37718665299991, 75.43341705900008],
              [-58.34976152299993, 75.43773021000004],
              [-58.239165818999936, 75.43667226800005],
              [-58.20665442599994, 75.44403717700004],
              [-58.21035722599993, 75.44721100500004],
              [-58.22032630099994, 75.45831940300008],
              [-58.206288214999915, 75.47052643400008],
              [-58.18439693899995, 75.48427969000005],
              [-58.16673743399991, 75.50043366100005],
              [-58.165679490999935, 75.51972077000005],
              [-58.18993079299992, 75.53436920800004],
              [-58.23306230399993, 75.54409414300005],
              [-58.39517167899993, 75.55662669500003],
              [-58.42613684799994, 75.56610748900005],
              [-58.41551673099991, 75.59174225500004],
              [-58.39244544199994, 75.60748932500007],
              [-58.31029212099992, 75.64325592700004],
              [-58.33861243399991, 75.65688711100006],
              [-58.37950598899994, 75.66010163000004],
              [-58.48265540299991, 75.64850495000007],
              [-58.52025305899991, 75.64915599200003],
              [-58.55724036399994, 75.65412018400008],
              [-58.584055141999954, 75.66372304900005],
              [-58.59434973899994, 75.67975495000007],
              [-58.57990475199995, 75.69220612200007],
              [-58.55370032499991, 75.70075104400007],
              [-58.52879798099991, 75.70465729400007],
              [-58.462880011999914, 75.69989655200004],
              [-58.42918860599991, 75.70258209800005],
              [-58.405913865999935, 75.71893952000005],
              [-58.44762122299994, 75.73135000200006],
              [-58.71336829299992, 75.73525625200006],
              [-58.794911261999914, 75.71918366100005],
              [-59.04161536399994, 75.70136139500005],
              [-59.07681230399993, 75.71149323100008],
              [-59.06322180899991, 75.71893952000005],
              [-59.06981360599991, 75.71995677300004],
              [-59.08429928299995, 75.72577545800004],
              [-59.05703691299993, 75.74371979400007],
              [-59.06753495999993, 75.76260000200006],
              [-59.098866339999915, 75.77537669500003],
              [-59.13390051999994, 75.77521393400008],
              [-59.207915818999936, 75.75995514500005],
              [-59.246205206999946, 75.75922272300005],
              [-59.282866990999935, 75.76609935100004],
              [-59.2376195949999, 75.77570221600007],
              [-59.22085527299993, 75.78363678600005],
              [-59.22150631399995, 75.80093008000006],
              [-59.23648027299993, 75.81321849200003],
              [-59.258697068999936, 75.81679922100005],
              [-59.30337480399993, 75.81452057500007],
              [-59.268137173999946, 75.82782623900005],
              [-59.22378495999993, 75.83624909100007],
              [-59.139515753999945, 75.84186432500007],
              [-59.18276933499993, 75.87360260600008],
              [-59.27220618399991, 75.88011302300004],
              [-59.50365149599992, 75.86676666900007],
              [-59.538319464999915, 75.86025625200006],
              [-59.570301886999914, 75.84808991100005],
              [-59.61363684799994, 75.82306549700007],
              [-59.640288865999935, 75.81244538000004],
              [-59.65221106699994, 75.81793854400007],
              [-59.65721594999991, 75.82831452000005],
              [-59.66869055899991, 75.82884349200003],
              [-59.681630011999914, 75.82396067900004],
              [-59.70295162699995, 75.80825429900005],
              [-59.71353105399993, 75.80341217700004],
              [-59.72565670499995, 75.80158112200007],
              [-59.77293860599991, 75.80141836100006],
              [-59.80186926999994, 75.80683014500005],
              [-59.81468665299991, 75.81948476800005],
              [-59.796864386999914, 75.84186432500007],
              [-59.77554277299993, 75.85321686400005],
              [-59.724598761999914, 75.87295156500005],
              [-59.704009568999936, 75.88593170800004],
              [-59.67650305899991, 75.89752838700008],
              [-59.61123613199993, 75.90322500200006],
              [-59.59142005099994, 75.91693756700005],
              [-59.64232337099992, 75.92719147300005],
              [-59.71226966099994, 75.96308014500005],
              [-59.73314368399991, 75.96954987200007],
              [-59.755848761999914, 75.97223541900007],
              [-59.78062903599994, 75.96930573100008],
              [-59.84398352799991, 75.94428131700005],
              [-59.89439856699994, 75.94330475500004],
              [-59.91637122299994, 75.93846263200004],
              [-59.912953253999945, 75.92377350500004],
              [-59.9661352199999, 75.92479075700004],
              [-59.9934789699999, 75.92914459800005],
              [-60.01659094999991, 75.93744538000004],
              [-59.98863684799994, 75.96539948100008],
              [-60.00772050699993, 75.97186920800004],
              [-60.07054602799991, 75.97223541900007],
              [-60.139515753999945, 75.98582591400003],
              [-60.131703253999945, 75.99640534100007],
              [-60.12018795499995, 76.00507233300004],
              [-60.118031378999945, 76.00507233300004],
              [-60.109934048999946, 76.00958893400008],
              [-60.091053839999915, 76.01312897300005],
              [-60.12417558499993, 76.03188711100006],
              [-60.46157792899993, 76.03363678600005],
              [-60.455637173999946, 76.05377838700008],
              [-60.473500128999945, 76.06386953300006],
              [-60.500843878999945, 76.06736888200004],
              [-60.52334550699993, 76.06777578300006],
              [-60.532093878999945, 76.06500885600008],
              [-60.54800370999993, 76.05048248900005],
              [-60.557199673999946, 76.04389069200005],
              [-60.57249915299991, 76.03998444200005],
              [-60.608631964999915, 76.03668854400007],
              [-60.63390051999994, 76.02448151200008],
              [-60.681304490999935, 76.01312897300005],
              [-60.7083227199999, 76.00047435100004],
              [-60.71857662699995, 75.99884674700007],
              [-60.733631964999915, 75.99917226800005],
              [-60.74547278599994, 76.00104401200008],
              [-60.75572669199994, 76.00633372600004],
              [-60.76634680899991, 76.01691315300008],
              [-60.78099524599992, 76.02586497600004],
              [-60.81627356699994, 76.02789948100008],
              [-60.832142706999946, 76.03363678600005],
              [-60.82713782499991, 76.03876373900005],
              [-60.81786048099991, 76.05414459800005],
              [-60.83836829299992, 76.05414459800005],
              [-60.82835852799991, 76.07562897300005],
              [-60.824777798999946, 76.08148834800005],
              [-60.90729732999995, 76.08148834800005],
              [-60.89329993399991, 76.09564850500004],
              [-60.847645636999914, 76.10346100500004],
              [-60.832142706999946, 76.11562734600005],
              [-60.85118567599994, 76.11774323100008],
              [-60.857533331999946, 76.12750885600008],
              [-60.85118567599994, 76.13825104400007],
              [-60.832142706999946, 76.14350006700005],
              [-60.87254798099991, 76.15814850500004],
              [-60.92406165299991, 76.16567617400005],
              [-60.97614498599995, 76.16596100500004],
              [-61.06273352799991, 76.15155670800004],
              [-61.107085740999935, 76.15412018400008],
              [-61.24038652299993, 76.17743561400005],
              [-61.41787675699993, 76.18154531500005],
              [-61.48265540299991, 76.17047760600008],
              [-61.65733801999994, 76.18292877800008],
              [-61.756418423999946, 76.20331452000005],
              [-61.77749589799993, 76.20498281500005],
              [-61.85265051999994, 76.20237864800004],
              [-61.869699673999946, 76.20868561400005],
              [-61.90147864499994, 76.23061758000006],
              [-61.93936113199993, 76.23920319200005],
              [-62.024281378999945, 76.23908112200007],
              [-62.11660722599993, 76.22394440300008],
              [-62.166859503999945, 76.22199127800008],
              [-62.19517981699994, 76.23908112200007],
              [-62.182484503999945, 76.24274323100008],
              [-62.147368943999936, 76.25958893400008],
              [-62.179798956999946, 76.27505117400005],
              [-62.22256425699993, 76.28583405200004],
              [-62.26675370999993, 76.28994375200006],
              [-62.30353756399995, 76.28510163000004],
              [-62.339507615999935, 76.27582428600005],
              [-62.35838782499991, 76.26776764500005],
              [-62.375843878999945, 76.24485911700003],
              [-62.39761308499993, 76.24457428600005],
              [-62.58067786399994, 76.26801178600005],
              [-62.736317511999914, 76.25731028900003],
              [-62.777414516999954, 76.23908112200007],
              [-62.72899329299992, 76.21857330900008],
              [-62.72899329299992, 76.21238841400003],
              [-62.756418423999946, 76.20132070500006],
              [-62.77358964799993, 76.19782135600008],
              [-62.79165605399993, 76.19814687700006],
              [-62.777414516999954, 76.21238841400003],
              [-62.840402798999946, 76.22817617400005],
              [-62.85313880099994, 76.23908112200007],
              [-62.852406378999945, 76.25397370000007],
              [-62.82526607999995, 76.26772695500006],
              [-62.819569464999915, 76.28001536700003],
              [-62.84919186099995, 76.30353424700007],
              [-63.05313066299993, 76.34186432500007],
              [-63.11278235599991, 76.34369538000004],
              [-63.17145748599995, 76.36200592700004],
              [-63.26402747299994, 76.35578034100007],
              [-63.289621548999946, 76.35932038000004],
              [-63.34137936099995, 76.37368398600006],
              [-63.367298956999946, 76.37689850500004],
              [-63.47691809799994, 76.37689850500004],
              [-63.478505011999914, 76.37702057500007],
              [-63.48281816299993, 76.37445709800005],
              [-63.49742591099994, 76.36945221600007],
              [-63.48501542899993, 76.33950429900005],
              [-63.51720130099994, 76.31028880400004],
              [-63.593006964999915, 76.27326080900008],
              [-63.60732988199993, 76.26243724200003],
              [-63.63304602799991, 76.23712799700007],
              [-63.64826412699995, 76.22540924700007],
              [-63.672434048999946, 76.21767812700006],
              [-63.728505011999914, 76.21133047100005],
              [-63.75059973899994, 76.19814687700006],
              [-63.743397589999915, 76.19692617400005],
              [-63.7337133449999, 76.19391510600008],
              [-63.72569739499994, 76.18964264500005],
              [-63.72329667899993, 76.18447500200006],
              [-63.72866777299993, 76.17804596600007],
              [-63.73672441299993, 76.17743561400005],
              [-63.746652798999946, 76.17861562700006],
              [-63.757476365999935, 76.17767975500004],
              [-63.81069902299993, 76.15912506700005],
              [-64.03111731699994, 76.13605377800008],
              [-64.09666907499991, 76.14573802300004],
              [-64.14915930899991, 76.17210521000004],
              [-64.19082597599993, 76.21137116100005],
              [-64.22423255099994, 76.25958893400008],
              [-64.21133378799993, 76.27220286700003],
              [-64.2044164699999, 76.27692291900007],
              [-64.19627844999991, 76.28001536700003],
              [-64.20059160099993, 76.28847890800006],
              [-64.20518958199995, 76.29315827000005],
              [-64.21226966099994, 76.29498932500007],
              [-64.22423255099994, 76.29433828300006],
              [-64.21275794199994, 76.30487702000005],
              [-64.19953365799995, 76.31159088700008],
              [-64.1848852199999, 76.31476471600007],
              [-64.16905676999994, 76.31484609600005],
              [-64.16905676999994, 76.32225169500003],
              [-64.32135982999995, 76.35272858300004],
              [-64.42906653599994, 76.34902578300006],
              [-64.41852779899995, 76.33836497600004],
              [-64.38817298099991, 76.32074616100005],
              [-64.37441972599993, 76.30801015800006],
              [-64.37987219999991, 76.30512116100005],
              [-64.38947506399995, 76.29767487200007],
              [-64.39492753799993, 76.29433828300006],
              [-64.37376868399991, 76.28961823100008],
              [-64.37051347599993, 76.27533600500004],
              [-64.38121497299994, 76.26032135600008],
              [-64.40176347599993, 76.25336334800005],
              [-64.42560787699995, 76.24860260600008],
              [-64.44440670499995, 76.23981354400007],
              [-64.46422278599994, 76.23505280200004],
              [-64.50690670499995, 76.24591705900008],
              [-64.53685462099992, 76.24005768400008],
              [-64.55109615799995, 76.24091217700004],
              [-64.61583411399994, 76.26772695500006],
              [-64.64443925699993, 76.27411530200004],
              [-64.67178300699993, 76.27167389500005],
              [-64.68976803299995, 76.25336334800005],
              [-64.68700110599991, 76.23444245000007],
              [-64.67080644399994, 76.21662018400008],
              [-64.64891516799992, 76.20335521000004],
              [-64.60399329299992, 76.19383372600004],
              [-64.58067786399994, 76.18447500200006],
              [-64.57461503799993, 76.17511627800008],
              [-64.60106360599991, 76.17084381700005],
              [-64.65282141799992, 76.18333567900004],
              [-64.68317623599995, 76.18585846600007],
              [-64.6966039699999, 76.17426178600005],
              [-64.68285071499992, 76.15729401200008],
              [-64.59414628799993, 76.13605377800008],
              [-64.64761308499993, 76.12299225500004],
              [-64.69961503799993, 76.12555573100008],
              [-64.75015214799993, 76.13955312700006],
              [-64.79930579299992, 76.16058991100005],
              [-64.85191809799994, 76.17641836100006],
              [-65.02497311099995, 76.17767975500004],
              [-65.01622473899994, 76.16494375200006],
              [-64.98713131399995, 76.14813873900005],
              [-64.97777258999992, 76.13605377800008],
              [-64.97838294199994, 76.12653229400007],
              [-64.97663326699995, 76.12278880400004],
              [-64.97032630099994, 76.11562734600005],
              [-64.97451738199993, 76.11041901200008],
              [-64.98794511599993, 76.10626862200007],
              [-65.00031490799995, 76.10830312700006],
              [-65.02497311099995, 76.12299225500004],
              [-65.05215410099993, 76.13515859600005],
              [-65.06676184799994, 76.13739655200004],
              [-65.16270911399994, 76.13035716400003],
              [-65.23786373599995, 76.13605377800008],
              [-65.20518958199995, 76.17084381700005],
              [-65.20767167899993, 76.18138255400004],
              [-65.23786373599995, 76.18447500200006],
              [-65.34264075399994, 76.17584870000007],
              [-65.36070716099994, 76.16400788000004],
              [-65.34935462099992, 76.16388580900008],
              [-65.33849036399994, 76.16152578300006],
              [-65.32843990799995, 76.15680573100008],
              [-65.31973222599993, 76.14972565300008],
              [-65.36070716099994, 76.13605377800008],
              [-65.30654863199993, 76.09039948100008],
              [-65.29991614499994, 76.07526276200008],
              [-65.31729081899994, 76.06126536700003],
              [-65.34455318899995, 76.05731842700004],
              [-65.36310787699995, 76.05023834800005],
              [-65.35448157499991, 76.02680084800005],
              [-65.66234290299991, 76.04047272300005],
              [-65.6536352199999, 76.04482656500005],
              [-65.64891516799992, 76.04913971600007],
              [-65.64248613199993, 76.06159088700008],
              [-65.71043860599991, 76.06159088700008],
              [-65.72476152299993, 76.06435781500005],
              [-65.75633704299992, 76.07729726800005],
              [-65.77220618399991, 76.08148834800005],
              [-65.86050370999993, 76.09271881700005],
              [-65.88890540299991, 76.10252513200004],
              [-65.85749264199995, 76.11977773600006],
              [-65.77904212099992, 76.12783437700006],
              [-65.75234941299993, 76.14350006700005],
              [-65.74998938699991, 76.15424225500004],
              [-65.75572669199994, 76.17576732000003],
              [-65.75234941299993, 76.18447500200006],
              [-65.73704993399991, 76.18870677300004],
              [-65.71861731699994, 76.18573639500005],
              [-65.70140540299991, 76.18553294500003],
              [-65.68968665299991, 76.19814687700006],
              [-65.73696855399993, 76.19863515800006],
              [-65.76008053299995, 76.20282623900005],
              [-65.77220618399991, 76.21238841400003],
              [-65.57827714799993, 76.23029205900008],
              [-65.55247962099992, 76.23908112200007],
              [-65.64134680899991, 76.26797109600005],
              [-65.74014238199993, 76.27850983300004],
              [-66.02367102799991, 76.26032135600008],
              [-66.06810462099992, 76.26398346600007],
              [-66.13662675699993, 76.28367747600004],
              [-66.17731686099995, 76.28607819200005],
              [-66.20726477799991, 76.27781810100004],
              [-66.20421301999994, 76.25336334800005],
              [-66.21043860599991, 76.25336334800005],
              [-66.21890214799993, 76.22508372600004],
              [-66.26252193899995, 76.20929596600007],
              [-66.35440019399994, 76.19065989800004],
              [-66.31981360599991, 76.16644928600005],
              [-66.33714758999992, 76.16205475500004],
              [-66.37702389199995, 76.16160716400003],
              [-66.40965735599991, 76.14972565300008],
              [-66.38662675699993, 76.13857656500005],
              [-66.36949622299994, 76.12628815300008],
              [-66.36558997299994, 76.11212799700007],
              [-66.38239498599995, 76.09568919500003],
              [-66.41372636599993, 76.08612702000005],
              [-66.51891028599994, 76.09568919500003],
              [-66.53319251199991, 76.09992096600007],
              [-66.55504309799994, 76.11880117400005],
              [-66.56700598899994, 76.12299225500004],
              [-66.58202063699991, 76.12567780200004],
              [-66.62905839799993, 76.14663320500006],
              [-66.66079667899993, 76.15420156500005],
              [-66.70006262899994, 76.15835195500006],
              [-66.73631751199991, 76.16608307500007],
              [-66.75914466099994, 76.18447500200006],
              [-66.73672441299993, 76.18748607000003],
              [-66.71003170499995, 76.19537995000007],
              [-66.68553626199991, 76.20644765800006],
              [-66.66974850199995, 76.21857330900008],
              [-66.76032467399995, 76.21491120000007],
              [-66.80601966099994, 76.22016022300005],
              [-66.81436113199993, 76.23908112200007],
              [-66.86681067599994, 76.25657786700003],
              [-66.92715410099993, 76.26650625200006],
              [-67.04710852799991, 76.26703522300005],
              [-67.09727942599994, 76.25897858300004],
              [-67.12303626199991, 76.25079987200007],
              [-67.14268958199995, 76.23908112200007],
              [-67.15599524599992, 76.23354726800005],
              [-67.15876217399995, 76.22882721600007],
              [-67.14981035099993, 76.22199127800008],
              [-67.14000403599994, 76.21808502800008],
              [-67.12970943899995, 76.21527741100005],
              [-67.10855058499993, 76.21238841400003],
              [-67.10855058499993, 76.20498281500005],
              [-67.15404212099992, 76.20050690300008],
              [-67.25031490799995, 76.20453522300005],
              [-67.29356848899994, 76.19065989800004],
              [-67.28726152299993, 76.18447500200006],
              [-67.29548092399995, 76.17983633000006],
              [-67.30020097599993, 76.17499420800004],
              [-67.30776933499993, 76.16400788000004],
              [-67.08788001199991, 76.14655182500007],
              [-67.05744381399995, 76.14020416900007],
              [-67.03197180899991, 76.12689850500004],
              [-67.01235917899993, 76.10252513200004],
              [-67.02326412699995, 76.09552643400008],
              [-67.03555253799993, 76.08978913000004],
              [-67.06017005099994, 76.08148834800005],
              [-67.03490149599992, 76.06443919500003],
              [-66.79165605399993, 76.03046295800004],
              [-66.74815833199995, 76.01634349200003],
              [-66.68936113199993, 76.00678131700005],
              [-66.61668860599991, 75.97858307500007],
              [-66.56086178299995, 75.96898021000004],
              [-66.51960201699995, 75.95490143400008],
              [-66.49811764199995, 75.95172760600008],
              [-66.48713131399995, 75.94741445500006],
              [-66.46642005099994, 75.92820872600004],
              [-66.45128333199995, 75.92377350500004],
              [-66.48843339799993, 75.90985748900005],
              [-66.56480872299994, 75.91657135600008],
              [-66.74649003799993, 75.95844147300005],
              [-66.93907630099994, 75.97524648600006],
              [-67.02696692599994, 75.97223541900007],
              [-67.05020097599993, 75.97540924700007],
              [-67.09756425699993, 75.98948802300004],
              [-67.43633650099993, 76.0119218336667],
              [-67.77510874499994, 76.03435564433339],
              [-68.11388098899994, 76.05678945500006],
              [-68.18358313699991, 76.07526276200008],
              [-68.38288326699995, 76.08148834800005],
              [-68.38825436099995, 76.07648346600007],
              [-68.40811113199993, 76.07623932500007],
              [-68.43252519399994, 76.07941315300008],
              [-68.47280839799993, 76.09174225500004],
              [-68.54596920499995, 76.10419342700004],
              [-68.56509355399993, 76.11131419500003],
              [-68.56956946499992, 76.11749909100007],
              [-68.56078040299991, 76.12319570500006],
              [-68.54051673099991, 76.12921784100007],
              [-68.43809973899994, 76.14350006700005],
              [-68.47057044199994, 76.16282786700003],
              [-68.52009029899995, 76.16803620000007],
              [-68.79246985599991, 76.16681549700007],
              [-68.74596106699994, 76.18447500200006],
              [-68.76854407499991, 76.19212474200003],
              [-68.81916256399995, 76.19537995000007],
              [-68.93150794199994, 76.22540924700007],
              [-68.91673743399991, 76.24323151200008],
              [-68.92369544199994, 76.24689362200007],
              [-69.09943600199995, 76.28339264500005],
              [-69.15416419199994, 76.28709544500003],
              [-69.20645097599993, 76.29824453300006],
              [-69.29458574099993, 76.30052317900004],
              [-69.38442949099993, 76.31362539300005],
              [-69.54784094999991, 76.36322663000004],
              [-69.61782792899993, 76.37103913000004],
              [-69.63727779899995, 76.38312409100007],
              [-69.62751217399995, 76.39032623900005],
              [-69.62092037699995, 76.39862702000005],
              [-69.61913001199991, 76.40766022300005],
              [-69.62360592399995, 76.41722239800004],
              [-69.60081946499992, 76.43170807500007],
              [-69.57725989499994, 76.43764883000006],
              [-69.32837887299993, 76.46898021050006],
              [-69.07949785099993, 76.50031159100007],
              [-68.90461178299995, 76.52236562700006],
              [-68.81480872299994, 76.55499909100007],
              [-68.83470618399991, 76.55963776200008],
              [-68.89679928299995, 76.56122467700004],
              [-68.86717688699991, 76.57021719000005],
              [-68.73277747299994, 76.58624909100007],
              [-68.38194739499994, 76.58515045800007],
              [-68.03111731699994, 76.58405182500007],
              [-68.00377356699994, 76.58999258000006],
              [-67.98648027299993, 76.60073476800005],
              [-67.98448645699995, 76.60199616100005],
              [-67.98558508999992, 76.62270742400005],
              [-68.00723222599993, 76.63764069200005],
              [-68.07054602799991, 76.64472077000005],
              [-68.09544837099992, 76.65741608300004],
              [-68.00226803299995, 76.67373281500005],
              [-67.98558508999992, 76.68414948100008],
              [-68.08242753799993, 76.70526764500005],
              [-68.10244706899994, 76.70628489800004],
              [-68.33877519399994, 76.67348867400005],
              [-68.62454179599993, 76.66917552300006],
              [-68.91030839799993, 76.66486237200007],
              [-69.13882402299993, 76.68610260600008],
              [-69.23989824099993, 76.67658112200007],
              [-69.28917395699995, 76.68252187700006],
              [-69.34048417899993, 76.69550202000005],
              [-69.62926184799991, 76.72296784050005],
              [-69.9180395169999, 76.75043366100005],
              [-69.96092688699991, 76.76361725500004],
              [-70.01121985599991, 76.76845937700006],
              [-70.0344945949999, 76.77350495000007],
              [-70.08519446499992, 76.79584381700005],
              [-70.10338294199994, 76.80145905200004],
              [-70.08592688699991, 76.82526276200008],
              [-70.05687415299991, 76.84076569200005],
              [-69.92088782499991, 76.86810944200005],
              [-69.89362545499995, 76.88104889500005],
              [-69.89793860599991, 76.90387604400007],
              [-69.85806230399993, 76.91526927300004],
              [-69.74339758999992, 76.96930573100008],
              [-69.68708248599995, 76.98200104400007],
              [-69.58189856699994, 76.98867422100005],
              [-69.55785071499992, 76.99469635600008],
              [-69.54165605399993, 77.00629303600005],
              [-69.72887122299994, 77.01642487200007],
              [-69.75698808499993, 77.01064687700006],
              [-69.76081295499995, 76.99262116100005],
              [-69.82290605399993, 76.97671133000006],
              [-69.90868079299992, 76.94208405200004],
              [-69.96784420499995, 76.92999909100007],
              [-70.05016028599994, 76.89203522300005],
              [-70.40746008999992, 76.79779694200005],
              [-70.52110755099994, 76.78717682500007],
              [-70.54137122299994, 76.79218170800004],
              [-70.55601966099994, 76.79303620000007],
              [-70.56582597599993, 76.79775625200006],
              [-70.57282467399995, 76.80316803600005],
              [-70.5833227199999, 76.80857982000003],
              [-70.59414628799993, 76.81240469000005],
              [-70.60216223899994, 76.81281159100007],
              [-70.64224199099993, 76.80158112200007],
              [-70.66014563699991, 76.80198802300004],
              [-70.82860266799992, 76.84186432500007],
              [-70.84227454299992, 76.84878164300005],
              [-70.83958899599992, 76.85691966400003],
              [-70.81533769399994, 76.86908600500004],
              [-70.84292558499993, 76.87425364800004],
              [-70.90538489499994, 76.86473216400003],
              [-70.92886308499993, 76.87278880400004],
              [-70.94212805899991, 76.88157786700003],
              [-70.98721269399994, 76.89704010600008],
              [-70.95547441299993, 76.90761953300006],
              [-70.82957923099991, 76.90387604400007],
              [-70.83702551999994, 76.91128164300005],
              [-70.69456946499992, 76.93162669500003],
              [-70.67878170499995, 76.93862539300005],
              [-70.80435136599993, 76.93203359600005],
              [-71.08283443899995, 76.96588776200008],
              [-71.07603919199994, 76.95913320500006],
              [-71.12144934799994, 76.95087311400005],
              [-71.09715735599991, 76.93178945500006],
              [-71.34561113199993, 76.99176666900007],
              [-71.38442949099993, 77.02399323100008],
              [-71.37254798099991, 77.05833567900004],
              [-71.34243730399993, 77.07074616100005],
              [-71.26138261599993, 77.06899648600006],
              [-71.23550370999993, 77.07249583500004],
              [-71.23232988199993, 77.08193594000005],
              [-71.23672441299993, 77.09511953300006],
              [-71.23363196499992, 77.10993073100008],
              [-71.22036699099993, 77.11465078300006],
              [-71.20107988199993, 77.11676666900007],
              [-71.18789628799993, 77.12238190300008],
              [-71.1926977199999, 77.13727448100008],
              [-71.00104732999995, 77.15542226800005],
              [-70.91026770699995, 77.14565664300005],
              [-70.6992895169999, 77.15086497600004],
              [-70.75308183499993, 77.16461823100008],
              [-70.92516028599994, 77.17816803600005],
              [-70.90330969999991, 77.19135163000004],
              [-70.51336286833326, 77.20723433400003],
              [-70.1234160366666, 77.22311703800004],
              [-69.73346920499995, 77.23899974200003],
              [-69.7141820949999, 77.23529694200005],
              [-69.67690995999993, 77.22207265800006],
              [-69.65807044199994, 77.21918366100005],
              [-69.57754472599993, 77.22581614800004],
              [-69.15306555899991, 77.20754629100006],
              [-68.7285863919999, 77.18927643400008],
              [-68.68537350199995, 77.17975495000007],
              [-68.62022864499994, 77.17645905200004],
              [-68.61335201699995, 77.17422109600005],
              [-68.61681067599994, 77.17072174700007],
              [-68.24748694549993, 77.18650950750006],
              [-67.87816321499992, 77.20229726800005],
              [-67.48094641799992, 77.17283763250006],
              [-67.08372962099992, 77.14337799700007],
              [-67.03164628799993, 77.14614492400005],
              [-66.95140540299991, 77.12995026200008],
              [-66.50894120999993, 77.13361237200007],
              [-66.41185462099992, 77.11444733300004],
              [-66.36192786399994, 77.11615631700005],
              [-66.38320878799993, 77.12327708500004],
              [-66.44058183499993, 77.13361237200007],
              [-66.45128333199995, 77.14411041900007],
              [-66.43529212099992, 77.15281810100004],
              [-66.24616451699995, 77.16404857000003],
              [-66.19762122299994, 77.17572663000004],
              [-66.17007402299993, 77.19867584800005],
              [-66.63683020699995, 77.15399811400005],
              [-67.08882944766661, 77.17800527533338],
              [-67.54082868833326, 77.20201243666672],
              [-67.99282792899993, 77.22601959800005],
              [-68.21597245999993, 77.20579661700003],
              [-68.63892574799993, 77.23153310750004],
              [-69.06187903599994, 77.25726959800005],
              [-69.1028539699999, 77.27440013200004],
              [-68.73617509649992, 77.32562897350005],
              [-68.36949622299994, 77.37685781500005],
              [-67.90271969299994, 77.38021474850007],
              [-67.43594316299993, 77.38357168200008],
              [-67.10435950399992, 77.36996084200007],
              [-66.7727758449999, 77.35635000200006],
              [-66.50503495999993, 77.27899811400005],
              [-66.26056881399995, 77.25185781500005],
              [-66.22614498599995, 77.25250885600008],
              [-66.19676673099991, 77.26072825700004],
              [-66.24274654899995, 77.28388092700004],
              [-66.44375566299993, 77.29425690300008],
              [-66.49722245999993, 77.31232330900008],
              [-66.5462133449999, 77.33588288000004],
              [-66.58495032499991, 77.36896393400008],
              [-66.60081946499992, 77.37685781500005],
              [-66.59752356699994, 77.38263580900008],
              [-66.66348222599993, 77.41779205900008],
              [-66.58665930899991, 77.43158600500004],
              [-66.20140540299991, 77.42450592700004],
              [-66.12515214799993, 77.43333567900004],
              [-66.06704667899993, 77.46621328300006],
              [-66.08731035099993, 77.47724030200004],
              [-66.09496008999992, 77.47988515800006],
              [-66.08478756399995, 77.48456452000005],
              [-66.05337480399993, 77.49347565300008],
              [-66.06899980399993, 77.50039297100005],
              [-66.10000566299993, 77.50556061400005],
              [-66.11514238199993, 77.51023997600004],
              [-66.12267005099994, 77.51601797100005],
              [-66.13829505099994, 77.53139883000006],
              [-66.14590410099993, 77.53449127800008],
              [-66.19383704299992, 77.53904857000003],
              [-66.21507727799991, 77.54539622600004],
              [-66.23155676999994, 77.55491771000004],
              [-66.21621660099993, 77.56199778900003],
              [-66.18101966099994, 77.56439850500004],
              [-66.16323808499993, 77.56858958500004],
              [-66.19375566299993, 77.57746002800008],
              [-66.29979407499991, 77.57538483300004],
              [-66.26374264199995, 77.58429596600007],
              [-66.24518795499995, 77.59125397300005],
              [-66.24144446499992, 77.59967682500007],
              [-66.25772050699993, 77.61058177300004],
              [-66.28132076699995, 77.61790599200003],
              [-66.48379472599993, 77.63410065300008],
              [-66.58385169199994, 77.65766022300005],
              [-66.59776770699995, 77.66791413000004],
              [-66.61343339799993, 77.67389557500007],
              [-66.68399003799993, 77.67161692900004],
              [-66.72374426999994, 77.68024323100008],
              [-66.71385657499991, 77.69232819200005],
              [-66.68399003799993, 77.70612213700008],
              [-66.66348222599993, 77.71942780200004],
              [-66.72264563699991, 77.71303945500006],
              [-66.84845943899995, 77.68488190300008],
              [-67.14085852799991, 77.67226797100005],
              [-67.16319739499994, 77.66421133000006],
              [-67.14354407499991, 77.65607330900008],
              [-67.15111243399991, 77.63955312700006],
              [-67.18736731699994, 77.60651276200008],
              [-67.21572831899994, 77.58698151200008],
              [-67.25011145699995, 77.57477448100008],
              [-67.59166419199994, 77.52435944200005],
              [-67.97404944599992, 77.51215241100005],
              [-68.35643469999991, 77.49994538000004],
              [-68.39028886599993, 77.50714752800008],
              [-68.37100175699993, 77.54588450700004],
              [-68.37026933499993, 77.56655508000006],
              [-68.39000403599994, 77.57538483300004],
              [-68.42243404899995, 77.57900625200006],
              [-68.52745520699995, 77.60956452000005],
              [-68.64500891799992, 77.66254303600005],
              [-68.68439693899995, 77.66909414300005],
              [-68.72984778599994, 77.66913483300004],
              [-68.81480872299994, 77.65802643400008],
              [-68.60997473899994, 77.56488678600005],
              [-68.59683183499993, 77.55182526200008],
              [-68.59508216099994, 77.53449127800008],
              [-68.61091061099995, 77.51772695500006],
              [-68.63841712099992, 77.50971100500004],
              [-68.93049068899992, 77.48130931200004],
              [-69.22256425699993, 77.45290761900003],
              [-69.56685679166661, 77.48772478500003],
              [-69.91114932633327, 77.52254195100004],
              [-70.25544186099995, 77.55735911700003],
              [-70.27525794199994, 77.56346263200004],
              [-70.28774980399993, 77.57538483300004],
              [-70.25902258999992, 77.57705312700006],
              [-70.20311438699991, 77.59223053600005],
              [-69.99868730399993, 77.62441640800006],
              [-69.87926184799994, 77.62946198100008],
              [-69.71979732999995, 77.66421133000006],
              [-69.63190670499995, 77.66819896000004],
              [-69.51817786399994, 77.68744538000004],
              [-69.49559485599991, 77.70209381700005],
              [-69.52057857999995, 77.73309967700004],
              [-69.47960364499994, 77.75421784100007],
              [-69.50747636599993, 77.76044342700004],
              [-69.54076087099992, 77.75193919500003],
              [-69.60244706899994, 77.72687409100007],
              [-69.72044837099992, 77.70400625200006],
              [-69.99941972599993, 77.69326406500005],
              [-70.01935787699995, 77.68988678600005],
              [-70.06818600199995, 77.67377350500004],
              [-70.37191728449994, 77.67696767800004],
              [-70.67564856699994, 77.68016185100004],
              [-70.70612545499995, 77.69147370000007],
              [-70.68049068899995, 77.70929596600007],
              [-70.36978105399993, 77.77020905200004],
              [-70.26256262899994, 77.81476471600007],
              [-70.21247311099995, 77.82721588700008],
              [-70.17096920499995, 77.82684967700004],
              [-70.14509029899995, 77.82245514500005],
              [-69.99290930899991, 77.82831452000005],
              [-69.97301184799994, 77.83612702000005],
              [-70.07017981699994, 77.85781484600005],
              [-70.28010006399995, 77.84813060100004],
              [-70.3769832019999, 77.86277903900003],
              [-70.41193600199995, 77.86269765800006],
              [-70.45734615799995, 77.85736725500004],
              [-70.54161536399994, 77.83612702000005],
              [-70.64419511599993, 77.78799062700006],
              [-70.6790258449999, 77.78148021000004],
              [-70.99592037649992, 77.77566152550006],
              [-71.31281490799995, 77.76984284100007],
              [-71.42951412699995, 77.79303620000007],
              [-71.43956458199995, 77.79999420800004],
              [-71.42577063699991, 77.81167226800005],
              [-71.40697180899991, 77.81879303600005],
              [-71.24034583199995, 77.85260651200008],
              [-71.21320553299995, 77.87030670800004],
              [-71.25088456899994, 77.88694896000004],
              [-71.31216386599993, 77.88882070500006],
              [-71.37580318899995, 77.88178131700005],
              [-71.47154700399994, 77.86017487200007],
              [-71.52489173099991, 77.85553620000007],
              [-71.6309301419999, 77.86277903900003],
              [-71.5957738919999, 77.89447663000004],
              [-71.59056555899991, 77.90497467700004],
              [-71.59821529899995, 77.92243073100008],
              [-71.61668860599991, 77.92523834800005],
              [-71.80894934799994, 77.90790436400005],
              [-71.85594641799992, 77.89581940300008],
              [-71.90566972599993, 77.88865794500003],
              [-71.95445716099994, 77.89606354400007],
              [-72.04987545499995, 77.92487213700008],
              [-72.14411373599995, 77.93744538000004],
              [-72.24168860599991, 77.93854401200008],
              [-72.23558508999992, 77.95075104400007],
              [-72.23253333199995, 77.95547109600005],
              [-72.22801673099991, 77.95966217700004],
              [-72.33576412699995, 78.00238678600005],
              [-72.35138912699995, 78.01496002800008],
              [-72.34105383999992, 78.02855052300004],
              [-72.31826738199993, 78.04067617400005],
              [-72.2969457669999, 78.04840729400007],
              [-72.2969457669999, 78.05585358300004],
              [-72.58259029899995, 78.06207916900007],
              [-72.60627193899995, 78.06708405200004],
              [-72.65562903599994, 78.09113190300008],
              [-72.67300370999993, 78.09686920800004],
              [-72.75670325399994, 78.10244375200006],
              [-72.78429114499994, 78.10761139500005],
              [-72.8509008449999, 78.14085521000004],
              [-72.89517167899993, 78.15395742400005],
              [-73.05724036399994, 78.15827057500007],
              [-73.02415930899991, 78.17841217700004],
              [-72.98257402299993, 78.18109772300005],
              [-72.89964758999992, 78.17194245000007],
              [-72.81607011599993, 78.17670319200005],
              [-72.73448645699995, 78.19236888200004],
              [-72.75405839799993, 78.20392487200007],
              [-72.81704667899993, 78.21914297100005],
              [-72.81704667899993, 78.22650788000004],
              [-72.78555253799993, 78.22748444200005],
              [-72.75499426999994, 78.23334381700005],
              [-72.76622473899994, 78.23859284100007],
              [-72.77830969999991, 78.24111562700006],
              [-72.79067949099993, 78.24176666900007],
              [-72.80337480399993, 78.24079010600008],
              [-72.77399654899995, 78.24762604400007],
              [-72.70946204299992, 78.24567291900007],
              [-72.67983964799993, 78.25385163000004],
              [-72.68907630099994, 78.25507233300004],
              [-72.69493567599994, 78.25771719000005],
              [-72.70718339799993, 78.26752350500004],
              [-72.66100012899994, 78.29116445500006],
              [-72.59129798099991, 78.29612864800004],
              [-72.46076412699995, 78.28864166900007],
              [-72.50479081899994, 78.30475495000007],
              [-72.85057532499991, 78.31533437700006],
              [-72.81704667899993, 78.32273997600004],
              [-72.82046464799993, 78.32672760600008],
              [-72.82282467399995, 78.33006419500003],
              [-72.82579505099994, 78.33323802300004],
              [-72.83128821499992, 78.33637116100005],
              [-72.82384192599994, 78.35126373900005],
              [-72.81387285099993, 78.35936107000003],
              [-72.8001195949999, 78.36294179900005],
              [-72.76244055899991, 78.36522044500003],
              [-72.64085852799991, 78.39032623900005],
              [-72.60362708199995, 78.40424225500004],
              [-72.58429928299995, 78.42511627800008],
              [-72.65050208199995, 78.43838125200006],
              [-72.67300370999993, 78.43886953300006],
              [-72.65453040299991, 78.45506419500003],
              [-72.58849036399994, 78.46723053600005],
              [-72.57062740799995, 78.48725006700005],
              [-72.60562089799993, 78.48639557500007],
              [-72.62287350199995, 78.48822663000004],
              [-72.63206946499992, 78.49408600500004],
              [-72.63890540299991, 78.50092194200005],
              [-72.59019934799994, 78.52122630400004],
              [-72.26600094299994, 78.53974030150005],
              [-71.94180253799993, 78.55825429900005],
              [-71.55455481699994, 78.64345937700006],
              [-71.21812903599994, 78.64252350500004],
              [-71.11400305899991, 78.62311432500007],
              [-70.86388098899994, 78.61530182500007],
              [-70.83702551999994, 78.61017487200007],
              [-70.81427975199995, 78.59894440300008],
              [-70.80199133999992, 78.59878164300005],
              [-70.78864498599995, 78.61017487200007],
              [-70.79417883999992, 78.61176178600005],
              [-70.80353756399995, 78.61562734600005],
              [-70.80915279899995, 78.61692942900004],
              [-70.78819739499994, 78.64765045800004],
              [-70.79112708199995, 78.65753815300008],
              [-70.80231686099995, 78.67841217700004],
              [-70.74583899599992, 78.69537995000007],
              [-70.48790442599994, 78.71727122600004],
              [-70.43687903599994, 78.72947825700004],
              [-70.37246660099993, 78.72443268400008],
              [-70.31798255099994, 78.73688385600008],
              [-69.98668372299994, 78.75348541900007],
              [-69.96279863199993, 78.76325104400007],
              [-69.97101803299995, 78.77000560100004],
              [-69.99571692599994, 78.77391185100004],
              [-70.02147376199991, 78.77521393400008],
              [-69.96886145699995, 78.79645416900007],
              [-69.90855872299994, 78.80394114800004],
              [-69.43862870999993, 78.80878327000005],
              [-69.3587133449999, 78.79938385600008],
              [-69.33901933499993, 78.80560944200005],
              [-69.32420813699991, 78.81574127800008],
              [-69.25031490799995, 78.84369538000004],
              [-69.20140540299991, 78.85382721600007],
              [-69.17796790299991, 78.86334870000007],
              [-69.19155839799993, 78.87079498900005],
              [-69.16673743399991, 78.87897370000007],
              [-69.14834550699993, 78.88060130400004],
              [-69.07876542899993, 78.86615631700005],
              [-69.01671301999994, 78.86688873900005],
              [-68.98615475199995, 78.86334870000007],
              [-68.91136633999992, 78.83966705900008],
              [-68.88353430899991, 78.83665599200003],
              [-68.78075110599991, 78.83665599200003],
              [-68.80638587099992, 78.84682851800005],
              [-68.8606664699999, 78.85944245000007],
              [-68.88312740799995, 78.87079498900005],
              [-68.88532467399995, 78.87474192900004],
              [-68.88756262899994, 78.88605377800008],
              [-68.89053300699993, 78.89069245000007],
              [-68.90013587099992, 78.89614492400005],
              [-68.91319739499994, 78.90086497600004],
              [-68.92658443899995, 78.90363190300008],
              [-68.93687903599994, 78.90314362200007],
              [-68.96857662699995, 78.89760976800005],
              [-69.14826412699995, 78.91575755400004],
              [-69.17174231699994, 78.92544179900005],
              [-69.14248613199993, 78.94916413000004],
              [-69.10850989499994, 78.96417877800008],
              [-69.03392493399991, 78.98004791900007],
              [-68.53705807199992, 79.02844879800006],
              [-68.04019120999993, 79.07684967700004],
              [-67.75865637899994, 79.03827545800004],
              [-67.67027747299994, 79.05516185100004],
              [-67.73770097599993, 79.06708405200004],
              [-67.74600175699993, 79.07684967700004],
              [-67.73424231699994, 79.08844635600008],
              [-67.7122289699999, 79.09438711100006],
              [-67.52692623599995, 79.11041901200008],
              [-67.49258378799993, 79.10529205900008],
              [-67.47598222599993, 79.10651276200008],
              [-67.47508704299992, 79.11416250200006],
              [-67.48355058499993, 79.11994049700007],
              [-67.49229895699995, 79.12278880400004],
              [-67.50011145699995, 79.12742747600004],
              [-67.50584876199991, 79.13833242400005],
              [-67.22691809799994, 79.11517975500004],
              [-67.17747962099992, 79.11786530200004],
              [-67.18439693899995, 79.12702057500007],
              [-67.19371497299994, 79.13178131700005],
              [-67.21841386599993, 79.13833242400005],
              [-67.19823157499991, 79.14423248900005],
              [-67.19050045499995, 79.14516836100006],
              [-67.19790605399993, 79.15131256700005],
              [-67.18285071499992, 79.15786367400005],
              [-67.16763261599993, 79.15741608300004],
              [-67.13585364499994, 79.15131256700005],
              [-67.12368730399993, 79.15322500200006],
              [-67.11270097599993, 79.15643952000005],
              [-67.10138912699995, 79.15558502800008],
              [-67.08812415299991, 79.14516836100006],
              [-67.09357662699995, 79.14370351800005],
              [-67.10301673099991, 79.13971588700008],
              [-67.10855058499993, 79.13833242400005],
              [-67.07835852799991, 79.11969635600008],
              [-67.04010982999995, 79.11570872600004],
              [-67.00177975199995, 79.12303294500003],
              [-66.97134355399993, 79.13833242400005],
              [-66.98086503799993, 79.15253327000005],
              [-66.96165930899991, 79.15412018400008],
              [-66.93195553299995, 79.14594147300005],
              [-66.90998287699995, 79.13084544500003],
              [-66.91584225199995, 79.12628815300008],
              [-66.92129472599993, 79.11994049700007],
              [-66.92625891799992, 79.11229075700004],
              [-66.93040930899991, 79.10358307500007],
              [-66.88296464799993, 79.11078522300005],
              [-66.79393469999991, 79.14077383000006],
              [-66.74547278599994, 79.14516836100006],
              [-66.78233801999994, 79.12905508000006],
              [-66.82062740799995, 79.11786530200004],
              [-66.79678300699993, 79.10956452000005],
              [-66.76626542899993, 79.11469147300005],
              [-66.70982825399994, 79.13641998900005],
              [-66.67886308499993, 79.14443594000005],
              [-66.58804277299993, 79.14516836100006],
              [-66.57282467399995, 79.14227936400005],
              [-66.54686438699991, 79.12864817900004],
              [-66.53319251199991, 79.12409088700008],
              [-66.51520748599995, 79.12449778900003],
              [-66.48546301999994, 79.13556549700007],
              [-66.47109941299993, 79.13833242400005],
              [-66.36310787699995, 79.14325592700004],
              [-66.32774817599994, 79.13833242400005],
              [-66.33067786399994, 79.13157786700003],
              [-66.33519446499992, 79.11664459800005],
              [-66.33397376199991, 79.11786530200004],
              [-66.33641516799992, 79.10956452000005],
              [-66.31680253799993, 79.10529205900008],
              [-66.27065995999993, 79.10358307500007],
              [-66.18748938699991, 79.11591217700004],
              [-66.11709550699993, 79.10276927300004],
              [-65.97765051999994, 79.10358307500007],
              [-65.99449622299994, 79.11994049700007],
              [-66.01988684799994, 79.12466054900005],
              [-66.04808508999992, 79.12563711100006],
              [-66.07323157499991, 79.13084544500003],
              [-65.81883704299992, 79.12909577000005],
              [-65.78587805899991, 79.13833242400005],
              [-65.84972083199995, 79.13719310100004],
              [-65.88084876199991, 79.14061107000003],
              [-65.89411373599995, 79.14850495000007],
              [-65.90941321499992, 79.15131256700005],
              [-65.88857988199993, 79.16681549700007],
              [-65.85757402299993, 79.17837148600006],
              [-65.69286048099991, 79.20905182500007],
              [-65.66234290299991, 79.22028229400007],
              [-65.67715410099993, 79.21979401200008],
              [-65.69188391799992, 79.22231679900005],
              [-65.70376542899993, 79.22882721600007],
              [-65.71019446499992, 79.24070872600004],
              [-65.66950436099995, 79.25324127800008],
              [-65.62140865799995, 79.26121653900003],
              [-65.54271399599992, 79.26044342700004],
              [-65.51895097599993, 79.26740143400008],
              [-65.53563391799992, 79.27912018400008],
              [-65.55247962099992, 79.28851959800005],
              [-65.53799394399994, 79.29547760600008],
              [-65.48424231699994, 79.30219147300005],
              [-65.4778539699999, 79.30548737200007],
              [-65.47179114499994, 79.31004466400003],
              [-65.46442623599995, 79.31415436400005],
              [-65.45376542899993, 79.31586334800005],
              [-65.44253495999993, 79.31915924700007],
              [-65.42808997299994, 79.33368561400005],
              [-65.41592363199993, 79.33698151200008],
              [-65.27037512899994, 79.35150788000004],
              [-65.23786373599995, 79.36424388200004],
              [-65.18073482999995, 79.37042877800008],
              [-65.15355383999992, 79.37641022300005],
              [-65.13475501199991, 79.39158763200004],
              [-65.14903723899994, 79.39899323100008],
              [-65.12677975199995, 79.41347890800006],
              [-65.07274329299992, 79.42275625200006],
              [-65.04662024599992, 79.43256256700005],
              [-65.06651770699995, 79.43768952000005],
              [-65.08698482999995, 79.44000885600008],
              [-65.05134029899995, 79.46381256700005],
              [-64.92072506399995, 79.48554108300004],
              [-64.85985266799992, 79.50775788000004],
              [-64.83141028599994, 79.52716705900008],
              [-64.81944739499994, 79.55239492400005],
              [-64.81969153599994, 79.57990143400008],
              [-64.82359778599994, 79.59808991100005],
              [-64.83580481699994, 79.61237213700008],
              [-64.86107337099992, 79.62807851800005],
              [-64.89683997299994, 79.64077383000006],
              [-64.97435462099992, 79.64984772300005],
              [-65.01187089799993, 79.65851471600007],
              [-64.98680579299992, 79.67096588700008],
              [-64.93024654899995, 79.68976471600007],
              [-64.90884355399993, 79.70693594000005],
              [-64.96833248599995, 79.73578522300005],
              [-65.03233801999994, 79.75462474200003],
              [-65.01357988199993, 79.76788971600007],
              [-64.96471106699994, 79.77582428600005],
              [-64.94298255099994, 79.78266022300005],
              [-65.00479081899994, 79.79734935100004],
              [-65.03628495999993, 79.80914948100008],
              [-65.05284583199995, 79.82355377800008],
              [-64.99819902299993, 79.82355377800008],
              [-64.99819902299993, 79.82977936400005],
              [-65.02774003799993, 79.82977936400005],
              [-65.1009008449999, 79.84080638200004],
              [-65.12857011599993, 79.85028717700004],
              [-65.10260982999995, 79.85903554900005],
              [-64.99819902299993, 79.86448802300004],
              [-65.00739498599995, 79.87457916900007],
              [-65.04662024599992, 79.89866771000004],
              [-65.00503495999993, 79.91168854400007],
              [-65.01447506399995, 79.92837148600006],
              [-64.99697831899994, 79.94106679900005],
              [-64.94981848899994, 79.96015045800004],
              [-64.97793535099993, 79.98086172100005],
              [-65.07335364499994, 80.00853099200003],
              [-65.04356848899994, 80.02387116100005],
              [-64.69225012949994, 80.05133698150004],
              [-64.34093176999994, 80.07880280200004],
              [-64.12604732999995, 80.14398834800005],
              [-64.08405514199995, 80.14642975500004],
              [-63.90880286399994, 80.13125234600005],
              [-63.81468665299991, 80.13857656500005],
              [-63.778553839999915, 80.15192291900007],
              [-64.14085852799991, 80.15875885600008],
              [-64.15904700399994, 80.16278717700004],
              [-64.17349199099993, 80.17230866100005],
              [-64.18724524599992, 80.18366120000007],
              [-64.20311438699991, 80.19285716400003],
              [-64.17837480399993, 80.22304922100005],
              [-64.1712133449999, 80.23908112200007],
              [-64.18114173099991, 80.24974192900004],
              [-64.20010331899994, 80.25389232000003],
              [-64.22276770699995, 80.25568268400008],
              [-64.24469967399995, 80.25324127800008],
              [-64.26113847599993, 80.24469635600008],
              [-64.26545162699995, 80.23200104400007],
              [-64.26008053299995, 80.21987539300005],
              [-64.25450598899994, 80.21067942900004],
              [-64.25804602799991, 80.20718008000006],
              [-64.29137122299994, 80.19643789300005],
              [-64.33495032499991, 80.14907461100006],
              [-64.36733964799993, 80.13825104400007],
              [-64.38829505099994, 80.13605377800008],
              [-64.47329667899993, 80.10565827000005],
              [-64.92601477799991, 80.07265859600005],
              [-65.30606035099993, 80.09601471600007],
              [-65.45018469999991, 80.05853913000004],
              [-65.86335201699995, 80.01203034100007],
              [-66.06110592399995, 80.02065664300005],
              [-66.09976152299993, 80.03286367400005],
              [-66.13597571499992, 80.05634186400005],
              [-66.17023678299995, 80.07290273600006],
              [-66.25316321499992, 80.08173248900005],
              [-66.31867428299995, 80.10122304900005],
              [-66.37730872299994, 80.10382721600007],
              [-66.40440833199995, 80.10903554900005],
              [-66.41860917899993, 80.11408112200007],
              [-66.43333899599992, 80.11733633000006],
              [-66.44774329299992, 80.11595286700003],
              [-66.50039628799993, 80.08392975500004],
              [-66.55321204299992, 80.07379791900007],
              [-67.0501195949999, 80.06118398600006],
              [-67.08063717399995, 80.07684967700004],
              [-67.05540930899991, 80.08372630400004],
              [-67.06354732999995, 80.09406159100007],
              [-67.10171464799993, 80.11098867400005],
              [-67.12360592399995, 80.12592194200005],
              [-67.12083899599992, 80.13279857000003],
              [-67.08063717399995, 80.14508698100008],
              [-67.10968990799995, 80.14838288000004],
              [-67.16445878799993, 80.16290924700007],
              [-67.19107011599993, 80.16620514500005],
              [-67.27432206899994, 80.15916575700004],
              [-67.46239173099991, 80.18471914300005],
              [-67.50584876199991, 80.20718008000006],
              [-67.49201412699995, 80.21271393400008],
              [-67.47663326699995, 80.21434153900003],
              [-67.44432532499991, 80.21336497600004],
              [-67.47166907499991, 80.22768789300005],
              [-67.45518958199995, 80.23407623900005],
              [-67.44701087099992, 80.23558177300004],
              [-67.43687903599994, 80.23509349200003],
              [-67.45148678299995, 80.24494049700007],
              [-67.46800696499992, 80.25348541900007],
              [-67.48542232999995, 80.25950755400004],
              [-67.51866614499994, 80.26552969000005],
              [-67.51008053299995, 80.27407461100006],
              [-67.47850501199991, 80.28974030200004],
              [-67.45714270699995, 80.30329010600008],
              [-67.44786536399994, 80.31391022300005],
              [-67.45579993399991, 80.32074616100005],
              [-67.48595130099994, 80.32318756700005],
              [-67.45543372299994, 80.34251536700003],
              [-67.32725989499994, 80.36505768400008],
              [-67.28677324099993, 80.36286041900007],
              [-67.26768958199995, 80.36615631700005],
              [-67.20909583199995, 80.38328685100004],
              [-67.19050045499995, 80.38523997600004],
              [-67.19790605399993, 80.38523997600004],
              [-67.16698157499991, 80.38812897300005],
              [-67.03587805899991, 80.41445547100005],
              [-66.91185462099992, 80.45453522300005],
              [-66.78750566299993, 80.46369049700007],
              [-66.77904212099992, 80.46841054900005],
              [-66.76935787699995, 80.47776927300004],
              [-66.75816809799994, 80.48334381700005],
              [-66.72496497299994, 80.48871491100005],
              [-66.71068274599992, 80.49457428600005],
              [-66.71784420499995, 80.49506256700005],
              [-66.72272701699995, 80.49681224200003],
              [-66.72691809799994, 80.49917226800005],
              [-66.73241126199991, 80.50136953300006],
              [-66.72508704299992, 80.50885651200008],
              [-66.71690833199995, 80.51479726800005],
              [-66.70775305899991, 80.51935455900008],
              [-66.69766191299993, 80.52244700700004],
              [-66.75039628799993, 80.52090078300006],
              [-66.77969316299993, 80.52362702000005],
              [-66.79263261599993, 80.53302643400008],
              [-66.78229732999995, 80.54633209800005],
              [-66.75841223899994, 80.55243561400005],
              [-66.45081539649993, 80.58041006050004],
              [-66.14321855399993, 80.60838450700004],
              [-66.10863196499992, 80.61741771000004],
              [-66.09068762899994, 80.63165924700007],
              [-66.08336341099994, 80.64752838700008],
              [-66.07494055899991, 80.66046784100007],
              [-66.05337480399993, 80.66583893400008],
              [-65.78929602799994, 80.66461823100008],
              [-65.52521725199995, 80.66339752800008],
              [-65.49791419199994, 80.67267487200007],
              [-65.68993079299992, 80.69489166900007],
              [-65.70787512899994, 80.70416901200008],
              [-65.69163977799991, 80.71605052300004],
              [-65.62437903599994, 80.73135000200006],
              [-65.37456214099993, 80.75554026900005],
              [-65.12474524599992, 80.77973053600005],
              [-65.07518469999991, 80.79340241100005],
              [-65.05284583199995, 80.80365631700005],
              [-65.05186926999994, 80.80678945500006],
              [-65.05138098899994, 80.81273021000004],
              [-65.05003821499992, 80.81928131700005],
              [-65.04662024599992, 80.82412344000005],
              [-65.04124915299991, 80.82562897300005],
              [-65.01720130099994, 80.82916901200008],
              [-65.00763912699995, 80.83295319200005],
              [-64.99893144399994, 80.83783600500004],
              [-64.99103756399995, 80.84393952000005],
              [-64.98395748599995, 80.85146719000005],
              [-65.03917395699995, 80.87872955900008],
              [-65.01744544199994, 80.89468008000006],
              [-64.97923743399991, 80.90273672100005],
              [-64.77700761599993, 80.90704987200007],
              [-64.73753821499992, 80.91909414300005],
              [-64.74327551999994, 80.92039622600004],
              [-64.75865637899994, 80.92649974200003],
              [-64.7102758449999, 80.94017161700003],
              [-64.76451575399994, 80.94940827000005],
              [-64.79405676999994, 80.95966217700004],
              [-64.80646725199995, 80.97431061400005],
              [-64.78978430899991, 80.99038320500006],
              [-64.75352942599994, 80.99624258000006],
              [-64.51768958199995, 81.00470612200007],
              [-64.43443762899994, 81.02798086100006],
              [-64.24058997299994, 81.02802155200004],
              [-64.11921139199995, 81.04804108300004],
              [-63.92943274599992, 81.05687083500004],
              [-63.82774817599994, 81.11326732000003],
              [-63.722767706999946, 81.13873932500007],
              [-63.67601477799991, 81.14350006700005],
              [-63.65501868399991, 81.14907461100006],
              [-63.59365800699993, 81.15086497600004],
              [-63.507476365999935, 81.13141510600008],
              [-63.43846594999991, 81.09601471600007],
              [-63.42853756399995, 81.05003489800004],
              [-63.39305579299992, 81.02716705900008],
              [-63.305572068999936, 80.95384349200003],
              [-63.24885006399995, 80.92731354400007],
              [-63.06004798099991, 80.87693919500003],
              [-63.02326412699995, 80.85561758000006],
              [-62.99046790299991, 80.82656484600005],
              [-62.95372473899994, 80.80097077000005],
              [-62.85973059799994, 80.78046295800004],
              [-62.819569464999915, 80.76410553600005],
              [-62.77993730399993, 80.75877513200004],
              [-62.736439581999946, 80.78253815300008],
              [-62.75572669199994, 80.78994375200006],
              [-62.84544837099992, 80.79877350500004],
              [-62.866118943999936, 80.80418528900003],
              [-62.87352454299992, 80.81268952000005],
              [-62.85313880099994, 80.82412344000005],
              [-62.89037024599992, 80.83258698100008],
              [-62.92520097599993, 80.84686920800004],
              [-62.98965410099993, 80.88556549700007],
              [-63.02708899599992, 80.90273672100005],
              [-63.15444902299993, 80.93675364800004],
              [-63.18431555899991, 80.95229726800005],
              [-63.323475714999915, 81.06195709800005],
              [-63.33975175699993, 81.08417389500005],
              [-63.33250891799992, 81.10618724200003],
              [-63.34471594999991, 81.12152741100005],
              [-63.36278235599991, 81.13703034100007],
              [-63.37328040299991, 81.15924713700008],
              [-63.19835364499994, 81.19599030200004],
              [-63.14989173099991, 81.21165599200003],
              [-62.97679602799991, 81.22833893400008],
              [-62.834543423999946, 81.22601959800005],
              [-62.76402747299994, 81.21454498900005],
              [-62.48021399649994, 81.20683421450005],
              [-62.19640051999994, 81.19912344000005],
              [-61.8506160149999, 81.12852610900006],
              [-61.54552161399994, 81.06622955900008],
              [-61.50308183499993, 81.07737864800004],
              [-61.53042558499993, 81.09784577000005],
              [-61.50153561099995, 81.10785553600005],
              [-61.371083136999914, 81.11367422100005],
              [-61.313384568999936, 81.12303294500003],
              [-61.07607988199993, 81.12051015800006],
              [-61.04409745999993, 81.13300202000005],
              [-60.99522864499994, 81.14447663000004],
              [-60.97207597599993, 81.14622630400004],
              [-60.964955206999946, 81.14883047100005],
              [-60.955189581999946, 81.16132233300004],
              [-60.94762122299994, 81.16616445500006],
              [-60.93517005099994, 81.16803620000007],
              [-60.89297441299993, 81.16616445500006],
              [-60.939523891999954, 81.18455638200004],
              [-61.03888912699995, 81.20441315300008],
              [-61.08543860599991, 81.22077057500007],
              [-61.15086829299992, 81.25592682500007],
              [-61.18122311099995, 81.27822500200006],
              [-61.20148678299995, 81.30329010600008],
              [-61.193470831999946, 81.30719635600008],
              [-61.172718878999945, 81.31460195500006],
              [-61.16051184799994, 81.31696198100008],
              [-61.29564368399991, 81.34959544500003],
              [-61.31135006399995, 81.36538320500006],
              [-61.29625403599994, 81.37103913000004],
              [-60.837147589999915, 81.45954010600008],
              [-60.802845831999946, 81.47199127800008],
              [-60.77318274599992, 81.49164459800005],
              [-60.78685462099992, 81.50885651200008],
              [-60.841460740999935, 81.52537669500003],
              [-60.94237219999991, 81.54291413000004],
              [-60.99445553299995, 81.54450104400007],
              [-61.023996548999946, 81.54954661700003],
              [-61.03697669199994, 81.56024811400005],
              [-61.037220831999946, 81.57538483300004],
              [-61.04039466099994, 81.58258698100008],
              [-61.05020097599993, 81.58685944200005],
              [-61.19277910099993, 81.62783437700006],
              [-61.25999915299991, 81.66828034100007],
              [-61.34239661399994, 81.68097565300008],
              [-61.37962805899991, 81.70050690300008],
              [-61.386382615999935, 81.72134023600006],
              [-61.45425370999993, 81.74502187700006],
              [-61.4348852199999, 81.76601797100005],
              [-61.41193600199995, 81.77570221600007],
              [-61.28107662699995, 81.81513092700004],
              [-60.907317674999945, 81.86393870650005],
              [-60.53355872299994, 81.91274648600006],
              [-60.481353318999936, 81.91128164300005],
              [-60.431630011999914, 81.91982656500005],
              [-60.38158118399991, 81.92072174700007],
              [-60.334055141999954, 81.93085358300004],
              [-60.06733150899993, 81.94737376500007],
              [-59.75259355399993, 81.92552317900004],
              [-59.605580206999946, 81.89362213700008],
              [-59.37047278599994, 81.89911530200004],
              [-59.10448157499994, 81.88068268450004],
              [-58.83849036399994, 81.86225006700005],
              [-58.79015051999994, 81.84931061400005],
              [-58.76895097599993, 81.82746002800008],
              [-58.75731360599991, 81.79946523600006],
              [-58.72931881399995, 81.78607819200005],
              [-58.69554602799991, 81.77887604400007],
              [-58.666574673999946, 81.76943594000005],
              [-58.73070227799991, 81.75519440300008],
              [-58.75536048099991, 81.73993561400005],
              [-58.75470943899995, 81.71417877800008],
              [-58.72704016799992, 81.69513580900008],
              [-58.68138587099992, 81.68402741100005],
              [-58.31163489449992, 81.63934967650005],
              [-57.94188391799992, 81.59467194200005],
              [-57.69554602799991, 81.59638092700004],
              [-57.64492753799993, 81.59129466400003],
              [-57.542307094999956, 81.56268952000005],
              [-57.53595943899995, 81.55662669500003],
              [-57.541859503999945, 81.54291413000004],
              [-57.22166907499991, 81.48843008000006],
              [-57.17878170499995, 81.47524648600006],
              [-57.20030676999994, 81.46588776200008],
              [-57.25666256399995, 81.46605052300004],
              [-57.28115800699993, 81.46100495000007],
              [-57.24136308499993, 81.43602122600004],
              [-57.19082597599993, 81.42499420800004],
              [-56.896148240999935, 81.40656159100007],
              [-56.84260006399995, 81.39500560100004],
              [-56.75426184799994, 81.39264557500007],
              [-56.70885169199994, 81.38495514500005],
              [-56.56948808499993, 81.33966705900008],
              [-56.54124915299991, 81.33592357000003],
              [-56.45254472599993, 81.33808014500005],
              [-56.463734503999945, 81.34861888200004],
              [-56.521473761999914, 81.36538320500006],
              [-56.564564581999946, 81.38886139500005],
              [-56.58315995999993, 81.39427317900004],
              [-57.02904212099992, 81.43170807500007],
              [-57.06554114499994, 81.43976471600007],
              [-57.09683183499993, 81.45351797100005],
              [-57.09532630099994, 81.47614166900007],
              [-57.18000240799995, 81.49933502800008],
              [-57.171986456999946, 81.52240631700005],
              [-57.20059160099993, 81.53424713700008],
              [-57.274322068999936, 81.54848867400005],
              [-57.33336341099994, 81.55329010600008],
              [-57.53433183499993, 81.60911692900004],
              [-57.67853756399995, 81.62262604400007],
              [-57.74754798099991, 81.65094635600008],
              [-58.13776607999995, 81.66697825700004],
              [-58.12938391799992, 81.67666250200006],
              [-58.12474524599992, 81.68008047100005],
              [-58.147328253999945, 81.69546133000006],
              [-58.22716223899994, 81.71417877800008],
              [-58.316517706999946, 81.74896881700005],
              [-58.41576087099992, 81.81565989800004],
              [-58.43614661399994, 81.81940338700008],
              [-58.47419186099995, 81.83087799700007],
              [-58.45836341099994, 81.84393952000005],
              [-58.45750891799992, 81.85993073100008],
              [-58.46792558499993, 81.87352122600004],
              [-58.48595130099994, 81.87929922100005],
              [-58.61709550699993, 81.89329661700003],
              [-58.822377081999946, 81.92902252800008],
              [-58.99176998599995, 81.93317291900007],
              [-59.426625128999945, 81.97968170800004],
              [-59.46788489499994, 82.00283437700006],
              [-59.039397752999946, 82.05402252800005],
              [-58.61091061099995, 82.10521067900004],
              [-58.330148891999954, 82.10521067900004],
              [-58.34447180899991, 82.11953359600005],
              [-58.31289628799993, 82.13035716400003],
              [-58.01307125549994, 82.14883047100005],
              [-57.71324622299994, 82.16730377800008],
              [-57.371429002999946, 82.17804596550008],
              [-57.02961178299995, 82.18878815300008],
              [-56.95262610599991, 82.20758698100008],
              [-56.85985266799992, 82.20416901200008],
              [-56.736398891999954, 82.22516510600008],
              [-56.466460740999935, 82.23554108300004],
              [-56.42926998599995, 82.23016998900005],
              [-56.355132615999935, 82.20648834800005],
              [-56.31602942599994, 82.20140208500004],
              [-56.33503170499995, 82.18984609600005],
              [-56.34276282499991, 82.18716054900005],
              [-56.307525193999936, 82.16644928600005],
              [-56.26146399599992, 82.16592031500005],
              [-56.214955206999946, 82.17780182500007],
              [-56.18740800699993, 82.19537995000007],
              [-56.19762122299994, 82.20888906500005],
              [-56.14476477799991, 82.23554108300004],
              [-56.12633216099994, 82.23997630400004],
              [-56.09837805899991, 82.25861237200007],
              [-56.07921301999994, 82.26288483300004],
              [-56.00914466099994, 82.26414622600004],
              [-55.986439581999946, 82.26288483300004],
              [-55.95889238199993, 82.27277252800008],
              [-55.61526445249993, 82.26117584850007],
              [-55.27163652299993, 82.24957916900007],
              [-55.25609290299991, 82.24738190300008],
              [-55.24103756399995, 82.24258047100005],
              [-55.22671464799993, 82.23554108300004],
              [-55.24445553299995, 82.22972239800004],
              [-55.266184048999946, 82.22744375200006],
              [-55.28848222599993, 82.22801341400003],
              [-55.327788865999935, 82.23407623900005],
              [-55.33238684799994, 82.23151276200008],
              [-55.322336391999954, 82.21507396000004],
              [-55.32298743399991, 82.21133047100005],
              [-55.325428839999915, 82.20766836100006],
              [-55.32494055899991, 82.20384349200003],
              [-55.31688391799992, 82.19965241100005],
              [-55.30528723899994, 82.19672272300005],
              [-55.19131425699993, 82.18716054900005],
              [-55.13963782499991, 82.16274648600006],
              [-55.112538214999915, 82.15717194200005],
              [-55.09203040299991, 82.17377350500004],
              [-55.10562089799993, 82.18943919500003],
              [-55.22671464799993, 82.21507396000004],
              [-55.17878170499995, 82.22866445500006],
              [-55.164051886999914, 82.23554108300004],
              [-55.205962693999936, 82.25779857000003],
              [-55.25536048099991, 82.27529531500005],
              [-55.30703691299993, 82.28652578300006],
              [-55.35582434799994, 82.29022858300004],
              [-55.57555091099994, 82.27505117400005],
              [-55.602853969999956, 82.28270091400003],
              [-55.566517706999946, 82.29197825700004],
              [-55.34788977799991, 82.29987213700008],
              [-55.25047766799992, 82.32099030200004],
              [-54.845611131499936, 82.34684886300005],
              [-54.440744594999956, 82.37270742400005],
              [-54.091908331999946, 82.32046133000006],
              [-54.07787024599992, 82.31224192900004],
              [-54.06558183499993, 82.30145905200004],
              [-54.04678300699993, 82.29022858300004],
              [-54.01903235599991, 82.28229401200008],
              [-53.959095831999946, 82.27411530200004],
              [-53.93101966099994, 82.26601797100005],
              [-53.887562628999945, 82.24445221600007],
              [-53.84752356699994, 82.23720937700006],
              [-53.83438066299993, 82.23216380400004],
              [-53.80890865799995, 82.21662018400008],
              [-53.750843878999945, 82.19212474200003],
              [-53.71174068899995, 82.18317291900007],
              [-53.688059048999946, 82.17308177300004],
              [-53.66592363199993, 82.15981679900005],
              [-53.65021725199995, 82.15363190300008],
              [-53.62677975199995, 82.14264557500007],
              [-53.57697506399995, 82.12933991100005],
              [-53.55703691299993, 82.11611562700006],
              [-53.55308997299994, 82.10480377800008],
              [-53.555978969999956, 82.07611725500004],
              [-53.553944464999915, 82.06427643400008],
              [-53.59471594999991, 82.04995351800005],
              [-53.61440995999993, 82.03856028900003],
              [-53.62287350199995, 82.02606842700004],
              [-53.61367753799993, 82.01300690300008],
              [-53.592640753999945, 82.00250885600008],
              [-53.553944464999915, 81.98851146000004],
              [-53.51707923099991, 81.96149323100008],
              [-53.50348873599995, 81.93650950700004],
              [-53.50999915299991, 81.91022370000007],
              [-53.567697719999956, 81.83087799700007],
              [-53.58771725199995, 81.81281159100007],
              [-53.61001542899993, 81.80072663000004],
              [-53.71621660099993, 81.76850006700005],
              [-53.76622473899994, 81.74526601800005],
              [-53.77513587099992, 81.73895905200004],
              [-53.776600714999915, 81.73379140800006],
              [-53.77456620999993, 81.72748444200005],
              [-53.77306067599994, 81.71792226800005],
              [-53.779408331999946, 81.71303945500006],
              [-53.821522589999915, 81.70050690300008],
              [-53.78258216099994, 81.68073151200008],
              [-53.77599036399994, 81.67112864800004],
              [-53.79356848899994, 81.66014232000003],
              [-53.78945878799993, 81.65485260600008],
              [-53.78425045499995, 81.64484284100007],
              [-53.77989661399994, 81.63971588700008],
              [-53.807850714999915, 81.58820221600007],
              [-53.804025844999956, 81.56622955900008],
              [-53.79279537699995, 81.55609772300005],
              [-53.68297278599994, 81.52631256700005],
              [-53.61367753799993, 81.51532623900005],
              [-53.47203528599994, 81.50873444200005],
              [-53.55992591099994, 81.52757396000004],
              [-53.65021725199995, 81.53607819200005],
              [-53.65021725199995, 81.54291413000004],
              [-53.48570716099994, 81.55027903900003],
              [-53.46458899599992, 81.56342194200005],
              [-53.49526933499993, 81.57607656500005],
              [-53.51773027299993, 81.59935130400004],
              [-53.553944464999915, 81.65277741100005],
              [-53.54084225199995, 81.67218659100007],
              [-53.52049719999991, 81.68024323100008],
              [-53.46475175699993, 81.68878815300008],
              [-53.27110755099994, 81.76373932500007],
              [-53.080962693999936, 81.79612864800004],
              [-53.04747473899994, 81.81037018400008],
              [-53.016916469999956, 81.82615794500003],
              [-52.94871985599991, 81.85268789300005],
              [-52.93016516799992, 81.86505768400008],
              [-52.930246548999946, 81.88898346600007],
              [-52.930572068999936, 81.90680573100008],
              [-52.936105923999946, 81.92446523600006],
              [-52.94383704299992, 81.94013092700004],
              [-52.953236456999946, 81.95815664300005],
              [-52.96719316299993, 81.97064850500004],
              [-53.00560462099992, 81.99192942900004],
              [-53.02375240799995, 82.00804271000004],
              [-53.01427161399994, 82.02122630400004],
              [-52.990223761999914, 82.03091054900005],
              [-52.96426347599993, 82.03632233300004],
              [-52.92564856699994, 82.03925202000005],
              [-52.77131100199995, 82.03314850500004],
              [-52.71051998599995, 82.01898834800005],
              [-52.51927649599992, 82.00967031500005],
              [-52.38898678299995, 81.98167552300004],
              [-52.18236243399991, 81.97821686400005],
              [-52.12205969999991, 81.96124909100007],
              [-52.11196855399993, 81.95579661700003],
              [-52.05052649599992, 81.94269440300008],
              [-51.718373175999915, 81.92377350450008],
              [-51.38621985599991, 81.90485260600008],
              [-51.08938554599993, 81.85423411650007],
              [-50.79255123599995, 81.80361562700006],
              [-50.73802649599992, 81.78172435100004],
              [-50.28697669199994, 81.72431061400005],
              [-50.23810787699995, 81.70978424700007],
              [-50.22337805899991, 81.70050690300008],
              [-50.22020423099991, 81.69183991100005],
              [-50.219593878999945, 81.66901276200008],
              [-50.21715247299994, 81.66014232000003],
              [-50.20335852799991, 81.64858633000006],
              [-50.18431555899991, 81.64321523600006],
              [-49.92149817599994, 81.61176178600005],
              [-49.613840298999946, 81.64594147300005],
              [-49.83608964799993, 81.65550364800004],
              [-49.87181555899991, 81.66254303600005],
              [-49.89781653599994, 81.67666250200006],
              [-49.89867102799991, 81.68162669500003],
              [-49.897328253999945, 81.68952057500007],
              [-49.897043423999946, 81.69879791900007],
              [-49.901234503999945, 81.70795319200005],
              [-49.91161048099991, 81.71417877800008],
              [-49.92735755099994, 81.71841054900005],
              [-50.21880042199993, 81.75393301000005],
              [-50.51024329299992, 81.78945547100005],
              [-50.64171301999994, 81.83087799700007],
              [-50.64171301999994, 81.83771393400008],
              [-50.621205206999946, 81.84454987200007],
              [-50.645415818999936, 81.85805898600006],
              [-50.67617753799993, 81.86107005400004],
              [-50.73729407499991, 81.85883209800005],
              [-50.890695766999954, 81.87811920800004],
              [-51.06627356699994, 81.93390534100007],
              [-51.03612219999991, 81.95636627800008],
              [-50.63377844999991, 81.92796458533341],
              [-50.23143469999991, 81.89956289266674],
              [-49.82909094999991, 81.87116120000007],
              [-49.75698808499993, 81.88344961100006],
              [-49.651600714999915, 81.88544342700004],
              [-49.47557532499991, 81.92715078300006],
              [-49.43569902299993, 81.92767975500004],
              [-49.464507615999935, 81.94721100500004],
              [-49.8367678156666, 82.01614004133337],
              [-50.20902801533325, 82.08506907766672],
              [-50.581288214999915, 82.15399811400005],
              [-50.731353318999936, 82.21015045800004],
              [-50.75841223899994, 82.23554108300004],
              [-50.79214433499993, 82.29702383000006],
              [-50.805531378999945, 82.31069570500006],
              [-50.81403561099995, 82.34170156500005],
              [-50.84943600199995, 82.36562734600005],
              [-51.04942786399994, 82.43781159100007],
              [-51.06078040299991, 82.44562409100007],
              [-51.05772864499994, 82.45628489800004],
              [-51.060658331999946, 82.47654857000003],
              [-51.08283443899995, 82.47992584800005],
              [-51.103505011999914, 82.48631419500003],
              [-51.12083899599992, 82.49628327000005],
              [-51.10724850199995, 82.50991445500006],
              [-50.68806718679995, 82.49883860860005],
              [-50.26888587159995, 82.48776276220005],
              [-49.84970455639994, 82.47668691580006],
              [-49.43052324119994, 82.46561106940005],
              [-49.01134192599994, 82.45453522300005],
              [-48.914051886999914, 82.43183014500005],
              [-48.78425045499995, 82.37299225500004],
              [-48.735259568999936, 82.35814036700003],
              [-48.36040876633327, 82.31617530600005],
              [-47.9855579636666, 82.27421024500006],
              [-47.61070716099994, 82.23224518400008],
              [-47.56493079299992, 82.21507396000004],
              [-47.571156378999945, 82.21507396000004],
              [-47.557525193999936, 82.20823802300004],
              [-47.58079993399991, 82.19293854400007],
              [-47.60586503799993, 82.18036530200004],
              [-47.56403561099995, 82.16803620000007],
              [-47.23127193899995, 82.17035553600005],
              [-46.82357065866662, 82.12563711133339],
              [-46.41586937833328, 82.08091868666673],
              [-46.00816809799994, 82.03620026200008],
              [-45.96727454299992, 82.01581452000005],
              [-46.00890051999994, 81.99534739800004],
              [-45.99669348899994, 81.98407623900005],
              [-45.98159745999993, 81.97772858300004],
              [-45.964833136999914, 81.97528717700004],
              [-45.94806881399995, 81.97553131700005],
              [-45.97057044199994, 81.96320221600007],
              [-46.02452551999994, 81.96002838700008],
              [-46.050445115999935, 81.95441315300008],
              [-46.02944902299993, 81.94668203300006],
              [-45.92638098899994, 81.94643789300005],
              [-45.66307532499994, 81.90690745650005],
              [-45.39976966099994, 81.86737702000005],
              [-45.378895636999914, 81.85883209800005],
              [-45.341786261999914, 81.83413320500006],
              [-45.327056443999936, 81.83087799700007],
              [-45.30308997299994, 81.82929108300004],
              [-45.24937903599994, 81.81928131700005],
              [-45.17292232999995, 81.79246653900003],
              [-45.15607662699995, 81.78986237200007],
              [-44.78237870999993, 81.77684153900003],
              [-44.70445716099994, 81.75885651200008],
              [-44.66283118399991, 81.75438060100004],
              [-44.63158118399991, 81.76264069200005],
              [-44.68000240799995, 81.77684153900003],
              [-44.651682094999956, 81.78583405200004],
              [-44.302723761999914, 81.81415436400005],
              [-44.25723222599993, 81.83673737200007],
              [-44.22826087099992, 81.83942291900007],
              [-44.17292232999995, 81.83771393400008],
              [-44.23216712099992, 81.84544505400004],
              [-44.355132615999935, 81.84650299700007],
              [-44.41250566299993, 81.85883209800005],
              [-44.39610755099994, 81.86493561400005],
              [-44.37669837099992, 81.86644114800004],
              [-44.33739173099991, 81.86505768400008],
              [-44.35789954299992, 81.86937083500004],
              [-44.40111243399991, 81.87213776200008],
              [-44.41930091099994, 81.87929922100005],
              [-44.39366614499994, 81.88532135600008],
              [-44.38451087099992, 81.88548411700003],
              [-44.44090735599991, 81.89492422100005],
              [-44.55573482999995, 81.88764069200005],
              [-44.61107337099992, 81.89980703300006],
              [-44.59748287699995, 81.90395742400005],
              [-44.57013912699995, 81.90851471600007],
              [-44.55650794199994, 81.91347890800006],
              [-44.59780839799993, 81.92365143400008],
              [-44.687163865999935, 81.92780182500007],
              [-44.72716223899994, 81.94013092700004],
              [-44.69155839799993, 81.94696686400005],
              [-44.51976477799991, 81.93699778900003],
              [-44.501210089999915, 81.94013092700004],
              [-44.49058997299994, 81.94627513200004],
              [-44.474598761999914, 81.96210358300004],
              [-44.46084550699993, 81.96808502800008],
              [-44.513661261999914, 81.98273346600007],
              [-44.884755011999914, 81.97939687700006],
              [-44.92638098899994, 81.99534739800004],
              [-44.90587317599994, 82.00283437700006],
              [-44.912180141999954, 82.01544830900008],
              [-44.93179277299993, 82.03343333500004],
              [-44.94005286399994, 82.04376862200007],
              [-44.728179490999935, 82.04718659100007],
              [-44.39879309799994, 82.10521067900004],
              [-44.507069464999915, 82.10797760600008],
              [-44.56484941299993, 82.11847565300008],
              [-44.65078691299993, 82.15241120000007],
              [-44.78087317599994, 82.18211497600004],
              [-44.793853318999936, 82.19196198100008],
              [-44.78750566299993, 82.20319245000007],
              [-44.70225989499994, 82.25779857000003],
              [-44.56285559799994, 82.29340241100005],
              [-44.232533331999946, 82.31981028900003],
              [-43.946766730499945, 82.29964834200004],
              [-43.661000128999945, 82.27948639500005],
              [-43.61034094999991, 82.26776764500005],
              [-43.17890377549992, 82.26115550300005],
              [-42.74746660099993, 82.25454336100006],
              [-42.71361243399991, 82.24176666900007],
              [-42.71361243399991, 82.24921295800004],
              [-42.70763098899994, 82.24380117400005],
              [-42.67886308499993, 82.23554108300004],
              [-42.68626868399991, 82.23061758000006],
              [-42.690297003999945, 82.22606028900003],
              [-42.69371497299994, 82.22125885600008],
              [-42.69937089799993, 82.21507396000004],
              [-42.30211341099994, 82.21507396000004],
              [-42.32949785099993, 82.23175690300008],
              [-42.70252438099993, 82.26439036650007],
              [-43.07555091099994, 82.29702383000006],
              [-43.17601477799991, 82.27798086100006],
              [-43.235585089999915, 82.27802155200004],
              [-43.53551184799991, 82.31000397350005],
              [-43.83543860599991, 82.34198639500005],
              [-43.86432857999995, 82.35333893400008],
              [-43.884877081999946, 82.37274811400005],
              [-43.85033118399991, 82.38987864800004],
              [-43.765736456999946, 82.39765045800004],
              [-43.72720292899993, 82.40688711100006],
              [-43.76402747299994, 82.41889069200005],
              [-43.934152798999946, 82.43341705900008],
              [-44.019642706999946, 82.45148346600007],
              [-44.19493567599994, 82.46352773600006],
              [-44.26870683499993, 82.48216380400004],
              [-44.30907141799992, 82.48777903900003],
              [-44.38027910099993, 82.48879629100003],
              [-44.39273027299993, 82.48843008000006],
              [-44.43455969999991, 82.49506256700005],
              [-44.44050045499995, 82.49823639500005],
              [-44.44469153599994, 82.50324127800008],
              [-44.447824673999946, 82.50787995000007],
              [-44.45030676999994, 82.50991445500006],
              [-44.49596106699994, 82.51504140800006],
              [-44.54084225199995, 82.52521393400008],
              [-44.55577551999994, 82.53290436400005],
              [-44.57689368399991, 82.55402252800008],
              [-44.59243730399993, 82.56264883000006],
              [-44.70494544199994, 82.58120351800005],
              [-44.78921464799993, 82.58441803600005],
              [-44.811390753999945, 82.58771393400008],
              [-44.85411536399994, 82.60219961100006],
              [-44.87515214799993, 82.60553620000007],
              [-44.91954505099994, 82.60651276200008],
              [-45.00914466099994, 82.61888255400004],
              [-45.09829667899993, 82.64960358300004],
              [-45.29271399599992, 82.67853424700007],
              [-45.382883266999954, 82.68195221600007],
              [-45.66274980399993, 82.72614166900007],
              [-45.744211391999954, 82.75356679900005],
              [-45.76927649599992, 82.76996491100005],
              [-45.74644934799994, 82.77700429900005],
              [-45.473317023999925, 82.78032054250005],
              [-45.20018469999991, 82.78363678600005],
              [-45.09434973899994, 82.79791901200008],
              [-45.01402747299994, 82.78530508000006],
              [-44.96141516799992, 82.76886627800008],
              [-44.47588728183325, 82.7667775193334],
              [-43.99035939566659, 82.76468876066673],
              [-43.50483150949992, 82.76260000200006],
              [-43.01930362333326, 82.76051124333338],
              [-42.53377573716659, 82.75842248466671],
              [-42.04824785099993, 82.75633372600004],
              [-42.14517167899993, 82.72793203300006],
              [-42.17178300699993, 82.70856354400007],
              [-41.89915930899991, 82.67129140800006],
              [-41.86107337099992, 82.66095612200007],
              [-41.82909094999991, 82.64166901200008],
              [-41.80125891799992, 82.61172109600005],
              [-41.865345831999946, 82.57416413000004],
              [-41.873036261999914, 82.55499909100007],
              [-41.83535722599993, 82.53725820500006],
              [-41.81297766799992, 82.53058502800008],
              [-41.79564368399991, 82.52313873900005],
              [-41.737538214999915, 82.48973216400003],
              [-41.72345943899995, 82.48427969000005],
              [-41.709055141999954, 82.48200104400007],
              [-41.61473548099991, 82.47968170800004],
              [-41.58897864499994, 82.48883698100008],
              [-41.55549068899995, 82.53351471600007],
              [-41.58470618399991, 82.55329010600008],
              [-41.64024817599994, 82.57037995000007],
              [-41.673898891999954, 82.58539459800005],
              [-41.63735917899993, 82.59870026200008],
              [-41.65099036399994, 82.60553620000007],
              [-41.61583411399994, 82.63666413000004],
              [-41.63145911399994, 82.65326569200005],
              [-41.719309048999946, 82.67438385600008],
              [-41.775949673999946, 82.70477936400005],
              [-41.82380123599995, 82.71063873900005],
              [-41.89806067599994, 82.72898997600004],
              [-41.86587480399993, 82.74754466400003],
              [-41.818470831999946, 82.75291575700004],
              [-41.57754472599993, 82.74730052300004],
              [-41.50877844999991, 82.73236725500004],
              [-41.25755774599992, 82.71173737200007],
              [-41.20938066299993, 82.70083242400005],
              [-41.177398240999935, 82.68060944200005],
              [-41.18492591099994, 82.67438385600008],
              [-40.74974524599992, 82.61676666900007],
              [-40.630848761999914, 82.57514069200005],
              [-40.52440344999991, 82.57318756700005],
              [-40.22760982999995, 82.56753164300005],
              [-40.207590298999946, 82.56134674700007],
              [-40.21849524599992, 82.55023834800005],
              [-40.203684048999946, 82.53782786700003],
              [-40.12291419199994, 82.50991445500006],
              [-40.00560462099992, 82.48883698100008],
              [-40.029286261999914, 82.47626373900005],
              [-40.060658331999946, 82.46564362200007],
              [-40.08360755099994, 82.45123932500007],
              [-40.08189856699994, 82.42739492400005],
              [-40.054798956999946, 82.41205475500004],
              [-39.92430579299992, 82.38641998900005],
              [-39.926665818999936, 82.38263580900008],
              [-39.93106035099993, 82.37274811400005],
              [-39.80410722599993, 82.36176178600005],
              [-39.76939856699994, 82.37588125200006],
              [-39.755970831999946, 82.39594147300005],
              [-39.762603318999936, 82.41030508000006],
              [-39.78197180899991, 82.42023346600007],
              [-39.80699622299994, 82.42739492400005],
              [-39.859486456999946, 82.43537018400008],
              [-39.87767493399991, 82.44599030200004],
              [-39.875884568999936, 82.46832916900007],
              [-39.85594641799992, 82.48261139500005],
              [-39.75914466099994, 82.50242747600004],
              [-39.77989661399994, 82.51239655200004],
              [-39.862172003999945, 82.51675039300005],
              [-39.963734503999945, 82.53888580900008],
              [-39.99583899599992, 82.55272044500003],
              [-40.00951087099992, 82.56354401200008],
              [-40.00934811099995, 82.57444896000004],
              [-39.99583899599992, 82.58344147300005],
              [-39.97691809799994, 82.59113190300008],
              [-39.957102016999954, 82.59662506700005],
              [-39.90184485599991, 82.60455963700008],
              [-39.88044186099995, 82.61107005400004],
              [-39.86900794199994, 82.61912669500003],
              [-39.869984503999945, 82.63141510600008],
              [-39.87987219999991, 82.64248281500005],
              [-39.90379798099991, 82.66010163000004],
              [-39.907460089999915, 82.66583893400008],
              [-39.908762173999946, 82.67157623900005],
              [-39.912098761999914, 82.67715078300006],
              [-39.92210852799991, 82.68256256700005],
              [-39.953114386999914, 82.69306061400005],
              [-40.31720943899995, 82.73069896000004],
              [-40.57945716099994, 82.71698639500005],
              [-40.81240800699993, 82.75454336100006],
              [-40.92756100199995, 82.75958893400008],
              [-40.976551886999914, 82.77435944200005],
              [-41.442677375249914, 82.78453705437505],
              [-41.908802863499915, 82.79471466675005],
              [-42.374928351749915, 82.80489227912506],
              [-42.841053839999915, 82.81506989150006],
              [-43.307179328249916, 82.82524750387506],
              [-43.773304816499916, 82.83542511625006],
              [-44.239430304749916, 82.84560272862507],
              [-44.70555579299992, 82.85578034100007],
              [-44.768137173999946, 82.86619700700004],
              [-44.83112545499995, 82.88947174700007],
              [-45.06297766799992, 82.91331614800004],
              [-45.06297766799992, 82.90717194200005],
              [-44.86497962099992, 82.87238190300008],
              [-44.86497962099992, 82.86619700700004],
              [-44.96629798099991, 82.84503815300008],
              [-45.30034339099993, 82.86127350450008],
              [-45.63438880099994, 82.87750885600008],
              [-45.67992102799991, 82.87238190300008],
              [-45.66755123599995, 82.86298248900005],
              [-45.66173255099994, 82.86041901200008],
              [-45.65265865799995, 82.85871002800008],
              [-45.65265865799995, 82.85195547100005],
              [-45.97443600199995, 82.84284088700008],
              [-46.032541469999956, 82.85028717700004],
              [-46.09483801999994, 82.84882233300004],
              [-46.15208899599992, 82.86009349200003],
              [-46.557525193999936, 82.89288971600007],
              [-46.553618943999936, 82.90013255400004],
              [-46.54735266799992, 82.90615469000005],
              [-46.539173956999946, 82.91058991100005],
              [-46.52965247299994, 82.91331614800004],
              [-46.57298743399991, 82.92332591400003],
              [-46.75495357999995, 82.93939850500004],
              [-46.846994594999956, 82.95966217700004],
              [-46.89273027299993, 82.96181875200006],
              [-46.84520423099991, 82.97601959800005],
              [-46.41340084549992, 82.94843170750005],
              [-45.98159745999993, 82.92084381700005],
              [-46.22557532499991, 82.98143138200004],
              [-46.70091712099992, 83.00275299700007],
              [-46.68028723899994, 83.01870351800005],
              [-46.642241990999935, 83.02431875200006],
              [-46.516184048999946, 83.02147044500003],
              [-46.50023352799991, 83.02920156500005],
              [-46.50914466099994, 83.05117422100005],
              [-46.43000240799995, 83.06207916900007],
              [-46.11082923099991, 83.06220123900005],
              [-46.07774817599994, 83.07782623900005],
              [-46.04039466099994, 83.09662506700005],
              [-45.970692511999914, 83.09650299700007],
              [-45.900054490999935, 83.08510976800005],
              [-45.78477942599994, 83.05353424700007],
              [-45.45323645749994, 83.02057526250007],
              [-45.12169348899994, 82.98761627800008],
              [-45.07721920499995, 82.96181875200006],
              [-45.09032141799992, 82.95425039300005],
              [-45.10431881399995, 82.94843170800004],
              [-45.11156165299991, 82.94245026200008],
              [-45.10509192599994, 82.93508535400008],
              [-44.73460852799991, 82.96857330900008],
              [-44.32816864066658, 82.95286692900008],
              [-43.92172875333326, 82.93716054900007],
              [-43.515288865999935, 82.92145416900007],
              [-43.48704993399991, 82.91331614800004],
              [-43.487538214999915, 82.91718170800004],
              [-43.48680579299992, 82.91982656500005],
              [-43.48534094999991, 82.92064036700003],
              [-43.45567786399994, 82.91693756700005],
              [-43.36351477799991, 82.92084381700005],
              [-43.36351477799991, 82.92706940300008],
              [-43.80274410724992, 82.95447418825007],
              [-44.24197343649993, 82.98187897350007],
              [-44.681202765749944, 83.00928375875007],
              [-45.120432094999956, 83.03668854400007],
              [-45.13219153599994, 83.04319896000004],
              [-45.11823482999995, 83.05117422100005],
              [-45.138742641999954, 83.05613841400003],
              [-45.179798956999946, 83.05536530200004],
              [-45.20018469999991, 83.05801015800006],
              [-45.201161261999914, 83.06061432500007],
              [-45.19994055899991, 83.06525299700007],
              [-45.19981848899994, 83.06972890800006],
              [-45.20384680899991, 83.07160065300008],
              [-45.21174068899995, 83.07257721600007],
              [-45.22716223899994, 83.07689036700003],
              [-45.32848059799994, 83.08185455900008],
              [-45.485666469999956, 83.11082591400003],
              [-45.518422003999945, 83.12274811400005],
              [-45.51602128799993, 83.13646067900004],
              [-45.486398891999954, 83.14691803600005],
              [-45.446156378999945, 83.15534088700008],
              [-45.40656490799995, 83.15859609600005],
              [-45.378895636999914, 83.15355052300004],
              [-45.40135657499991, 83.14911530200004],
              [-45.40119381399995, 83.14032623900005],
              [-45.38630123599995, 83.13133372600004],
              [-45.36461341099994, 83.12620677300004],
              [-45.22765051999994, 83.13605377800008],
              [-45.15379798099991, 83.16233958500004],
              [-45.13121497299994, 83.16705963700008],
              [-45.11270097599993, 83.16498444200005],
              [-45.07721920499995, 83.15355052300004],
              [-44.72435462099992, 83.10492584800005],
              [-44.68000240799995, 83.11261627800008],
              [-44.69758053299995, 83.11847565300008],
              [-44.714100714999915, 83.12620677300004],
              [-44.693023240999935, 83.12775299700007],
              [-44.67251542899993, 83.13304271000004],
              [-44.67251542899993, 83.13996002800008],
              [-44.692616339999915, 83.13983795800004],
              [-44.711048956999946, 83.14301178600005],
              [-44.74767005099994, 83.15355052300004],
              [-44.705922003999945, 83.17194245000007],
              [-44.64688066299993, 83.17511627800008],
              [-44.19727535699994, 83.15066152550006],
              [-43.74767005099994, 83.12620677300004],
              [-43.75454667899993, 83.12620677300004],
              [-43.73314368399991, 83.12140534100007],
              [-43.698475714999915, 83.11741771000004],
              [-43.66624915299991, 83.11871979400007],
              [-43.65208899599992, 83.12970612200007],
              [-43.63780676999994, 83.13597239800004],
              [-43.24400794199994, 83.11776357650004],
              [-42.85020911399994, 83.09955475500004],
              [-42.87938391799992, 83.11029694200005],
              [-43.25324459533325, 83.14085521033338],
              [-43.627105272666576, 83.17141347866674],
              [-44.00096594999991, 83.20197174700007],
              [-43.631038649666586, 83.20404694233339],
              [-43.26111134933327, 83.20612213766672],
              [-42.891184048999946, 83.20819733300004],
              [-42.891184048999946, 83.21564362200007],
              [-43.03945878799993, 83.21173737200007],
              [-43.082915818999936, 83.22247955900008],
              [-42.97988847599993, 83.22866445500006],
              [-42.97988847599993, 83.23607005400004],
              [-43.32258053299995, 83.23607005400004],
              [-43.32258053299995, 83.24290599200003],
              [-43.26642818899995, 83.24506256700005],
              [-43.248117641999954, 83.24974192900004],
              [-43.257150844999956, 83.25511302300004],
              [-43.26109778599994, 83.25665924700007],
              [-43.26109778599994, 83.26341380400004],
              [-42.96347001899994, 83.27230459200004],
              [-42.66584225199995, 83.28119538000004],
              [-42.51158606699994, 83.25112539300005],
              [-42.48029537699995, 83.23948802300004],
              [-42.43545488199993, 83.22894928600005],
              [-42.117298956999946, 83.24249909100007],
              [-42.023508266999954, 83.22455475500004],
              [-41.92398027299993, 83.21759674700007],
              [-41.83584550699993, 83.19794342700004],
              [-41.74071204299992, 83.19464752800008],
              [-41.70567786399994, 83.17401764500005],
              [-41.88329016799992, 83.12299225500004],
              [-41.93154863199993, 83.09210846600007],
              [-41.66954505099994, 83.13996002800008],
              [-41.36510169199994, 83.11884186400005],
              [-41.12486731699994, 83.06191640800006],
              [-41.02013098899994, 83.05467357000003],
              [-40.73867753799993, 83.00531647300005],
              [-40.690297003999945, 82.98651764500005],
              [-40.27273515499994, 82.97828468066672],
              [-39.85517330599995, 82.97005171633339],
              [-39.437611456999946, 82.96181875200006],
              [-39.00568600199995, 82.90033600500004],
              [-39.01280676999994, 82.89740631700005],
              [-39.02647864499994, 82.88922760600008],
              [-39.03359941299993, 82.88605377800008],
              [-39.00450598899994, 82.85569896000004],
              [-38.96080481699994, 82.83608633000006],
              [-38.86876380099994, 82.81289297100005],
              [-38.67955481699994, 82.79262929900005],
              [-38.642567511999914, 82.76996491100005],
              [-38.65217037699995, 82.76439036700003],
              [-38.65103105399993, 82.75861237200007],
              [-38.64403235599991, 82.75336334800005],
              [-38.63573157499991, 82.74949778900003],
              [-38.61510169199994, 82.74599844000005],
              [-38.59089107999995, 82.74762604400007],
              [-38.54637610599991, 82.75633372600004],
              [-38.601633266999954, 82.77619049700007],
              [-38.58535722599993, 82.78558991100005],
              [-38.56700598899994, 82.79376862200007],
              [-38.49449622299994, 82.81549713700008],
              [-38.48033606699994, 82.82151927300004],
              [-38.477406378999945, 82.83144765800006],
              [-38.642567511999914, 82.82461172100005],
              [-38.74331620999993, 82.83417389500005],
              [-38.76716061099995, 82.84739817900004],
              [-38.77912350199995, 82.85195547100005],
              [-38.780140753999945, 82.85773346600007],
              [-38.78652910099993, 82.86619700700004],
              [-38.783314581999946, 82.89907461100006],
              [-38.82485917899993, 82.91657135600008],
              [-38.91633053299995, 82.93447500200006],
              [-38.909494594999956, 82.93447500200006],
              [-38.93724524599992, 82.94537995000007],
              [-39.00926673099991, 82.94839101800005],
              [-39.12458248599995, 82.97138092700004],
              [-39.149647589999915, 82.98224518400008],
              [-39.127797003999945, 82.99530670800004],
              [-39.099680141999954, 83.00372955900008],
              [-38.64278113499995, 83.00519440275008],
              [-38.185882127999946, 83.00665924650008],
              [-37.72898312099994, 83.00812409025008],
              [-37.27208411399994, 83.00958893400008],
              [-37.31615149599992, 83.01752350500004],
              [-37.40660559799994, 83.01862213700008],
              [-37.59508216099994, 83.04140859600005],
              [-37.9831165576666, 83.04313114366671],
              [-38.37115095433327, 83.04485369133339],
              [-38.75918535099993, 83.04657623900005],
              [-38.800892706999946, 83.05801015800006],
              [-38.783273891999954, 83.06777578300006],
              [-38.321034308749944, 83.08612702000006],
              [-37.85879472549993, 83.10447825700007],
              [-37.39655514224992, 83.12282949400007],
              [-36.93431555899991, 83.14118073100008],
              [-36.88101152299993, 83.15355052300004],
              [-36.90208899599992, 83.16022370000007],
              [-37.26520748599992, 83.15688711150005],
              [-37.62832597599993, 83.15355052300004],
              [-37.54820716099994, 83.16014232000003],
              [-37.52529863199993, 83.16787344000005],
              [-37.58836829299992, 83.17837148600006],
              [-37.90892493399991, 83.18768952000005],
              [-37.99742591099994, 83.18073151200008],
              [-38.02619381399995, 83.18768952000005],
              [-37.962554490999935, 83.19464752800008],
              [-37.94367428299995, 83.20197174700007],
              [-38.23135331949993, 83.20197174700007],
              [-38.51903235599991, 83.20197174700007],
              [-38.68342037699995, 83.20840078300006],
              [-38.710194464999915, 83.21906159100007],
              [-38.73216712099992, 83.23175690300008],
              [-38.86168372299994, 83.25665924700007],
              [-38.83165442599994, 83.26972077000005],
              [-38.79552161399994, 83.27562083500004],
              [-38.72447669199994, 83.27708567900004],
              [-38.73151607999995, 83.28701406500005],
              [-38.73973548099991, 83.29474518400008],
              [-38.74909420499995, 83.30052317900004],
              [-38.75926673099991, 83.30438873900005],
              [-38.74400794199994, 83.30817291900007],
              [-38.71279863199993, 83.31220123900005],
              [-38.69713294199994, 83.31183502800008],
              [-38.69713294199994, 83.31806061400005],
              [-38.72801673099991, 83.31883372600004],
              [-38.765614386999914, 83.32501862200007],
              [-38.801625128999945, 83.33641185100004],
              [-38.82750403599994, 83.35285065300008],
              [-38.821156378999945, 83.35651276200008],
              [-38.800892706999946, 83.37270742400005],
              [-38.78612219999991, 83.37995026200008],
              [-38.73814856699994, 83.39374420800004],
              [-38.80500240799995, 83.40680573100008],
              [-38.868478969999956, 83.42731354400007],
              [-38.839100714999915, 83.43626536700003],
              [-38.79841061099995, 83.43984609600005],
              [-38.75719153599994, 83.43846263200004],
              [-38.690297003999945, 83.42548248900005],
              [-38.251678026499945, 83.39250315950005],
              [-37.813059048999946, 83.35952383000006],
              [-37.73818925699993, 83.37270742400005],
              [-37.81163489499994, 83.40350983300004],
              [-37.98281816299993, 83.41339752800008],
              [-38.05968176999994, 83.43475983300004],
              [-38.02383378799993, 83.44310130400004],
              [-37.91637122299994, 83.45522695500006],
              [-37.92454993399991, 83.46747467700004],
              [-37.93512936099995, 83.47606028900003],
              [-37.94831295499995, 83.48094310100004],
              [-37.964182094999956, 83.48191966400003],
              [-37.915679490999935, 83.49892812700006],
              [-37.58543860599991, 83.50804271000004],
              [-37.19957434799991, 83.47134023600006],
              [-36.813710089999915, 83.43463776200008],
              [-36.764963344999956, 83.42047760600008],
              [-36.723500128999945, 83.39842357000003],
              [-36.704335089999915, 83.39264557500007],
              [-36.449777798999946, 83.36176178600005],
              [-36.40184485599991, 83.37270742400005],
              [-36.59984290299991, 83.39374420800004],
              [-36.60920162699995, 83.40493398600006],
              [-36.636830206999946, 83.41156647300005],
              [-36.69611568899995, 83.41425202000005],
              [-36.647694464999915, 83.42841217700004],
              [-36.48375403599994, 83.43475983300004],
              [-36.53547115799995, 83.45115794500003],
              [-36.857085740999935, 83.48053620000007],
              [-36.90147864499994, 83.49616120000007],
              [-36.78563391799992, 83.49433014500005],
              [-36.75072180899991, 83.50360748900005],
              [-36.76610266799992, 83.50800202000005],
              [-36.78164628799993, 83.50975169500003],
              [-36.813384568999936, 83.50983307500007],
              [-36.78734290299991, 83.52802155200004],
              [-36.73859615799995, 83.53803131700005],
              [-36.24026445233327, 83.53774648633339],
              [-35.7419327466666, 83.53746165566673],
              [-35.24360104099992, 83.53717682500007],
              [-34.97303219299994, 83.57160065300008],
              [-34.702463344999956, 83.60602448100008],
              [-34.67715410099993, 83.60358307500007],
              [-34.62852942599994, 83.59162018400008],
              [-34.60619055899991, 83.58218008000006],
              [-34.58999589799993, 83.57160065300008],
              [-34.57787024599992, 83.56085846600007],
              [-34.56436113199993, 83.55145905200004],
              [-34.54409745999993, 83.54462311400005],
              [-34.52122962099992, 83.54218170800004],
              [-34.49836178299995, 83.54368724200003],
              [-34.47765051999994, 83.54901764500005],
              [-34.46157792899993, 83.55829498900005],
              [-34.452381964999915, 83.57005442900004],
              [-34.44896399599992, 83.58022695500006],
              [-34.441965298999946, 83.58909739800004],
              [-34.42210852799991, 83.59731679900005],
              [-34.39631100199995, 83.60162995000007],
              [-34.36290442599994, 83.60293203300006],
              [-34.33067786399994, 83.59926992400005],
              [-34.308257615999935, 83.58860911700003],
              [-34.30260169199994, 83.57697174700007],
              [-34.300892706999946, 83.56464264500005],
              [-34.295033331999946, 83.55483633000006],
              [-34.25243079299992, 83.54661692900004],
              [-34.20848548099991, 83.52830638200004],
              [-33.94505774599992, 83.48505280200004],
              [-33.93976803299995, 83.47573476800005],
              [-33.93614661399994, 83.46629466400003],
              [-33.92406165299991, 83.46206289300005],
              [-33.83047441299993, 83.46198151200008],
              [-33.78433183499993, 83.46967194200005],
              [-33.74278723899994, 83.48940664300005],
              [-33.787220831999946, 83.50031159100007],
              [-34.00743567599994, 83.52936432500007],
              [-34.04954993399991, 83.54205963700008],
              [-34.08543860599991, 83.56509023600006],
              [-34.08039303299995, 83.56806061400005],
              [-34.07188880099994, 83.57135651200008],
              [-34.01146399599992, 83.58759186400005],
              [-33.63127600774992, 83.59921906125005],
              [-33.25108801949992, 83.61084625850006],
              [-32.87090003124992, 83.62247345575007],
              [-32.49071204299992, 83.63410065300008],
              [-32.40758216099994, 83.61896393400008],
              [-32.207875128999945, 83.61347077000005],
              [-32.207875128999945, 83.60602448100008],
              [-32.23127193899995, 83.60614655200004],
              [-32.281361456999946, 83.59861888200004],
              [-32.30345618399991, 83.59178294500003],
              [-32.29678300699993, 83.59113190300008],
              [-32.28294837099992, 83.58551666900007],
              [-32.28888912699995, 83.58258698100008],
              [-32.30345618399991, 83.57127513200004],
              [-32.02672278549991, 83.58999258000006],
              [-31.749989386999914, 83.60871002800008],
              [-31.633412238999938, 83.58982982000003],
              [-31.196095344499923, 83.58641185100004],
              [-30.75877844999991, 83.58299388200004],
              [-30.64712480399993, 83.60175202000005],
              [-30.186824782333264, 83.57911475866672],
              [-29.726524760666603, 83.55647749733339],
              [-29.266224738999938, 83.53384023600006],
              [-29.261463995999918, 83.53025950700004],
              [-29.249175584999932, 83.53099192900004],
              [-29.236805792999917, 83.53025950700004],
              [-29.224720831999946, 83.52802155200004],
              [-29.213042772999927, 83.52411530200004],
              [-29.237904425999943, 83.51898834800005],
              [-29.261463995999918, 83.50983307500007],
              [-29.21385657499991, 83.48761627800008],
              [-29.14830481699994, 83.47752513200004],
              [-29.08104407499991, 83.47846100500004],
              [-29.02871660099993, 83.48940664300005],
              [-29.04841061099995, 83.50535716400003],
              [-29.055409308999913, 83.50983307500007],
              [-28.630116339999915, 83.52195872600004],
              [-28.55577551999994, 83.51487864800004],
              [-28.514149542999917, 83.48940664300005],
              [-28.67414303299995, 83.47528717700004],
              [-28.773426886999914, 83.48651764500005],
              [-28.82567298099991, 83.48676178600005],
              [-28.925119594999956, 83.47573476800005],
              [-28.88463294199994, 83.46344635600008],
              [-28.562570766999954, 83.42047760600008],
              [-28.150461391999954, 83.43475983300004],
              [-28.223784959999932, 83.43549225500004],
              [-28.372385219999956, 83.45453522300005],
              [-28.44522050699993, 83.45522695500006],
              [-28.38463294199994, 83.47125885600008],
              [-27.928802049999934, 83.44230784700007],
              [-27.472971157999933, 83.41335683800007],
              [-27.017140265999927, 83.38440582900006],
              [-26.561309373999922, 83.35545482000005],
              [-26.10547848199992, 83.32650381100005],
              [-25.649647589999915, 83.29755280200004],
              [-25.679351365999935, 83.27985260600008],
              [-25.719593878999945, 83.26947663000004],
              [-25.835926886999914, 83.25918203300006],
              [-25.91356360599991, 83.24042389500005],
              [-25.967600063999953, 83.23358795800004],
              [-26.019642706999946, 83.21564362200007],
              [-26.075428839999915, 83.20848216400003],
              [-26.54152991419992, 83.20134511970004],
              [-27.00763098839992, 83.19420807540004],
              [-27.473732062599925, 83.18707103110003],
              [-27.939833136799926, 83.17993398680004],
              [-28.40593421099993, 83.17279694250004],
              [-28.872035285199935, 83.16565989820005],
              [-29.338136359399936, 83.15852285390005],
              [-29.80423743359994, 83.15138580960004],
              [-30.27033850779994, 83.14424876530005],
              [-30.736439581999946, 83.13711172100005],
              [-30.89171301999994, 83.10569896000004],
              [-31.315052863666608, 83.09079281866671],
              [-31.738392707333276, 83.07588667733337],
              [-32.16173255099994, 83.06098053600005],
              [-32.23741614499994, 83.07713450700004],
              [-32.34634355399993, 83.08295319200005],
              [-32.44611568899995, 83.10569896000004],
              [-32.94296220599995, 83.13265615400005],
              [-33.43980872299994, 83.15961334800005],
              [-33.48281816299993, 83.14614492400005],
              [-33.341867641999954, 83.13996002800008],
              [-33.238270636999914, 83.11644114800004],
              [-33.134429490999935, 83.13377513200004],
              [-32.81958980999994, 83.09979889500005],
              [-32.504750128999945, 83.06582265800006],
              [-32.48908443899995, 83.05801015800006],
              [-32.480458136999914, 83.04425690300008],
              [-32.49054928299995, 83.03815338700008],
              [-32.95384680899991, 83.02228424700007],
              [-33.05174719999991, 83.00250885600008],
              [-33.47136389916658, 82.98879629100007],
              [-33.89098059833325, 82.97508372600008],
              [-34.310597297499925, 82.96137116100007],
              [-34.7302139966666, 82.94765859600007],
              [-35.149830695833266, 82.93394603100008],
              [-35.56944739499994, 82.92023346600007],
              [-35.620432094999956, 82.90717194200005],
              [-35.54133053299995, 82.89423248900005],
              [-35.37287350199995, 82.90143463700008],
              [-35.29824785099993, 82.89288971600007],
              [-35.32103430899991, 82.88491445500006],
              [-35.42088782499991, 82.86823151200008],
              [-35.42760169199994, 82.85854726800005],
              [-35.43321692599994, 82.84715403900003],
              [-35.44908606699994, 82.83828359600005],
              [-35.427723761999914, 82.83051178600005],
              [-35.40070553299995, 82.82461172100005],
              [-35.40070553299995, 82.81842682500007],
              [-35.48428300699993, 82.80410390800006],
              [-35.53099524599992, 82.78754303600005],
              [-35.55150305899991, 82.76654694200005],
              [-35.52684485599991, 82.75055573100008],
              [-35.47101803299995, 82.74616120000007],
              [-35.37401282499991, 82.74949778900003],
              [-35.396595831999946, 82.76276276200008],
              [-35.41954505099994, 82.77301666900007],
              [-35.42479407499991, 82.78363678600005],
              [-35.39443925699993, 82.79791901200008],
              [-35.29393469999991, 82.81256745000007],
              [-35.26414954299992, 82.82461172100005],
              [-35.30138098899994, 82.83795807500007],
              [-35.312570766999954, 82.84503815300008],
              [-35.28941809799994, 82.85455963700008],
              [-34.95103919199994, 82.90485260600008],
              [-34.48766028549994, 82.91223786000006],
              [-34.024281378999945, 82.91962311400005],
              [-33.84312903599994, 82.88629791900007],
              [-33.815663214999915, 82.86961497600004],
              [-33.804351365999935, 82.84170156500005],
              [-33.82091223899994, 82.82269928600005],
              [-33.93464107999995, 82.79791901200008],
              [-33.88463294199994, 82.79450104400007],
              [-33.72288977799991, 82.81753164300005],
              [-33.68822180899991, 82.83486562700006],
              [-33.696522589999915, 82.85358307500007],
              [-33.731027798999946, 82.89154694200005],
              [-33.735991990999935, 82.90717194200005],
              [-33.70978756399995, 82.92462799700007],
              [-33.60265051999994, 82.94537995000007],
              [-33.127797003999945, 82.96674225500004],
              [-33.048939581999946, 82.98200104400007],
              [-32.61133785699994, 82.98584625850006],
              [-32.17373613199993, 82.98969147300005],
              [-32.162098761999914, 82.99591705900008],
              [-31.826649542999917, 82.99457428600005],
              [-31.755686001999948, 82.98419830900008],
              [-31.738392706999946, 82.97858307500007],
              [-31.72057044199994, 82.96971263200004],
              [-31.713286912999934, 82.95913320500006],
              [-31.72809811099995, 82.94814687700006],
              [-31.724761522999927, 82.94497304900005],
              [-31.721424933999913, 82.94232819200005],
              [-31.713775193999936, 82.93789297100005],
              [-31.69237219999991, 82.93231842700004],
              [-31.66559811099995, 82.93170807500007],
              [-31.61510169199994, 82.93789297100005],
              [-31.59666907499991, 82.94318268400008],
              [-31.59166419199994, 82.94896067900004],
              [-31.590565558999913, 82.95697663000004],
              [-31.584095831999946, 82.96857330900008],
              [-31.548817511999914, 82.99274323100008],
              [-31.507191535999937, 83.00161367400005],
              [-31.462513800999943, 83.00556061400005],
              [-31.39199785099993, 83.02069733300004],
              [-31.012549065999924, 83.04621002833339],
              [-30.633100280999923, 83.07172272366672],
              [-30.253651495999918, 83.09723541900007],
              [-30.096913214999915, 83.12620677300004],
              [-29.63790849499992, 83.11582062400004],
              [-29.178903774999924, 83.10543447500004],
              [-28.719899054999928, 83.09504832600004],
              [-28.260894334999932, 83.08466217700004],
              [-28.251698370999918, 83.06085846600007],
              [-28.202300584999932, 83.04987213700008],
              [-28.14281165299991, 83.04791901200008],
              [-28.103260870999918, 83.05117422100005],
              [-27.948109503999945, 83.08177317900004],
              [-27.492176886999914, 83.07746002800008],
              [-27.380970831999946, 83.06061432500007],
              [-26.999562140999927, 83.06397125850006],
              [-26.61815344999991, 83.06732819200005],
              [-26.54784094999991, 83.08466217700004],
              [-26.10570227799991, 83.1123992646667],
              [-25.66356360599991, 83.14013635233339],
              [-25.221424933999913, 83.16787344000005],
              [-25.02676347599993, 83.15595123900005],
              [-24.84093176999994, 83.11261627800008],
              [-24.945668097999942, 83.10346100500004],
              [-24.971262173999946, 83.09210846600007],
              [-24.979807094999956, 83.07802969000005],
              [-24.972808397999927, 83.06915924700007],
              [-24.907093878999945, 83.04328034100007],
              [-24.78506425699993, 83.02838776200008],
              [-24.76943925699993, 83.02480703300006],
              [-24.758941209999932, 83.01703522300005],
              [-24.755238410999937, 83.01093170800004],
              [-24.752349412999934, 83.00405508000006],
              [-24.753651495999918, 82.99827708500004],
              [-24.76235917899993, 82.99591705900008],
              [-24.787220831999946, 82.99282461100006],
              [-24.894357876999948, 82.95571523600006],
              [-25.09325110599991, 82.91176992400005],
              [-25.114491339999915, 82.90322500200006],
              [-25.129750128999945, 82.89223867400005],
              [-25.130604620999918, 82.88108958500004],
              [-25.10846920499995, 82.87238190300008],
              [-25.149281378999945, 82.85285065300008],
              [-25.587635870999918, 82.79047272300005],
              [-25.903553839999915, 82.78363678600005],
              [-25.872710740999935, 82.77435944200005],
              [-25.767201300999943, 82.76850006700005],
              [-25.68663489499994, 82.77594635600008],
              [-25.58340410099993, 82.76935455900008],
              [-25.51626542899993, 82.78668854400007],
              [-25.17018252966659, 82.82457103100006],
              [-24.82409963033325, 82.86245351800005],
              [-24.47801673099991, 82.90033600500004],
              [-24.25218665299991, 82.88605377800008],
              [-24.061756964999915, 82.90387604400007],
              [-24.03929602799991, 82.91030508000006],
              [-23.996978318999936, 82.91722239800004],
              [-23.93309485599991, 82.91640859600005],
              [-23.87254798099991, 82.90810781500005],
              [-23.840402798999946, 82.89288971600007],
              [-23.886789516999954, 82.89077383000006],
              [-23.97996985599991, 82.87368398600006],
              [-24.02529863199993, 82.87238190300008],
              [-24.001779751999948, 82.84821198100008],
              [-23.911936001999948, 82.82200755400004],
              [-23.881337042999917, 82.79791901200008],
              [-23.912993943999936, 82.77936432500007],
              [-23.98973548099991, 82.77187734600005],
              [-24.02529863199993, 82.76312897300005],
              [-23.799672003999945, 82.77435944200005],
              [-23.765980597999942, 82.78270091400003],
              [-23.737945115999935, 82.79791901200008],
              [-23.748524542999917, 82.81346263200004],
              [-23.724964972999942, 82.82591380400004],
              [-23.662220831999946, 82.83828359600005],
              [-23.38418535099993, 82.85224030200004],
              [-23.209584113999938, 82.83795807500007],
              [-23.176340298999946, 82.82599518400008],
              [-23.176258917999917, 82.80353424700007],
              [-23.102162238999938, 82.79230377800008],
              [-22.935292120999918, 82.79865143400008],
              [-22.870838995999918, 82.76654694200005],
              [-22.842274542999917, 82.75885651200008],
              [-22.75104732999995, 82.77187734600005],
              [-22.691517706999946, 82.76951732000003],
              [-22.664906378999945, 82.77440013200004],
              [-22.646880662999934, 82.78595612200007],
              [-22.648589647999927, 82.80353424700007],
              [-22.56541907499991, 82.79653554900005],
              [-22.401722785999937, 82.76386139500005],
              [-22.191802537999934, 82.74738190300008],
              [-22.123117641999954, 82.72760651200008],
              [-22.050892706999946, 82.71507396000004],
              [-21.91197669199994, 82.71112702000005],
              [-21.879383917999917, 82.70302969000005],
              [-21.81663977799991, 82.70148346600007],
              [-21.786732550999943, 82.69668203300006],
              [-21.78465735599991, 82.68060944200005],
              [-21.62328040299991, 82.67230866100005],
              [-21.477772589999915, 82.64069245000007],
              [-21.339507615999935, 82.62628815300008],
              [-21.323109503999945, 82.61835358300004],
              [-21.318511522999927, 82.60553620000007],
              [-21.325917120999918, 82.59845612200007],
              [-21.357248501999948, 82.58397044500003],
              [-21.370025193999936, 82.57444896000004],
              [-21.402821417999917, 82.55524323100008],
              [-21.449330206999946, 82.54702383000006],
              [-21.538238084999932, 82.54340241100005],
              [-21.83885657499991, 82.48480866100005],
              [-22.140980597999942, 82.46149323100008],
              [-22.306019660999937, 82.42739492400005],
              [-22.278553839999915, 82.41868724200003],
              [-22.217640753999945, 82.40639883000006],
              [-22.196156378999945, 82.39256419500003],
              [-22.225005662999934, 82.37933991100005],
              [-22.437326626999948, 82.33999258000006],
              [-22.904137065333277, 82.32438114333338],
              [-23.37094750366661, 82.30876970666672],
              [-23.83775794199994, 82.29315827000005],
              [-23.886708136999914, 82.27887604400007],
              [-24.38383948466658, 82.26724884675006],
              [-24.880970832333247, 82.25562164950007],
              [-25.378102179999914, 82.24399445225006],
              [-25.87523352766658, 82.23236725500006],
              [-26.372364875333247, 82.22074005775006],
              [-26.869496222999913, 82.20911286050006],
              [-27.36662757066658, 82.19748566325005],
              [-27.863758918333247, 82.18585846600006],
              [-28.360890265999913, 82.17423126875005],
              [-28.85802161366658, 82.16260407150004],
              [-29.355152961333246, 82.15097687425005],
              [-29.852284308999913, 82.13934967700004],
              [-29.87336178299995, 82.14374420800004],
              [-29.908558722999942, 82.16290924700007],
              [-29.929676886999914, 82.16730377800008],
              [-30.22362219999991, 82.17084381700005],
              [-30.39484615799995, 82.19525788000004],
              [-30.73539520299994, 82.20201243733338],
              [-31.075944247999928, 82.2087669946667],
              [-31.416493292999917, 82.21552155200004],
              [-31.582102016999954, 82.22011953300006],
              [-31.62564042899993, 82.20823802300004],
              [-31.17956838033327, 82.19546133033337],
              [-30.73349633166661, 82.1826846376667],
              [-30.28742428299995, 82.16990794500003],
              [-30.205433722999942, 82.15648021000004],
              [-30.089670376999948, 82.15208567900004],
              [-30.03351803299995, 82.14109935100004],
              [-30.016753709999932, 82.13442617400005],
              [-29.989857550999943, 82.11953359600005],
              [-29.973378058999913, 82.11269765800006],
              [-29.905140753999945, 82.09837474200003],
              [-29.943186001999948, 82.08539459800005],
              [-30.317209439333283, 82.05910879100004],
              [-30.691232876666618, 82.03282298400005],
              [-31.065256313999953, 82.00653717700004],
              [-31.10179602799991, 81.99811432500007],
              [-31.126779751999948, 81.99750397300005],
              [-31.139027472999942, 81.99534739800004],
              [-31.147816535999937, 81.99115631700005],
              [-31.164540167999917, 81.97931549700007],
              [-31.172596808999913, 81.97553131700005],
              [-31.22557532499991, 81.96792226800005],
              [-31.499806281999923, 81.96464671450005],
              [-31.774037238999938, 81.96137116100005],
              [-31.80382239499994, 81.94757721600007],
              [-31.839182094999956, 81.93903229400007],
              [-31.91234290299991, 81.93911367400005],
              [-31.98729407499991, 81.92316315300008],
              [-32.07603919199994, 81.93105703300006],
              [-32.56285559799994, 81.88328685100004],
              [-32.67918860599991, 81.85268789300005],
              [-32.779408331999946, 81.84113190300008],
              [-32.78966223899994, 81.83710358300004],
              [-32.79845130099994, 81.82892487200007],
              [-32.80687415299991, 81.81391022300005],
              [-32.81330318899995, 81.79437897300005],
              [-32.81480872299994, 81.77509186400005],
              [-32.80850175699993, 81.76072825700004],
              [-32.78563391799992, 81.75079987200007],
              [-32.73082434799994, 81.75165436400005],
              [-32.70811926999994, 81.74494049700007],
              [-32.700835740999935, 81.73322174700007],
              [-32.70287024599992, 81.71906159100007],
              [-32.717681443999936, 81.69183991100005],
              [-32.66714433499993, 81.67698802300004],
              [-32.61180579299992, 81.67373281500005],
              [-32.503895636999914, 81.68423086100006],
              [-32.14793860599991, 81.68130117400005],
              [-32.144642706999946, 81.70555247600004],
              [-32.13125566299993, 81.72353750200006],
              [-32.111887173999946, 81.73623281500005],
              [-31.93496660099993, 81.79279205900008],
              [-31.680165167999917, 81.83478424700007],
              [-31.241749640999927, 81.85004303600007],
              [-30.803334113999938, 81.86530182500007],
              [-30.698963995999918, 81.88247304900005],
              [-30.59170488199993, 81.88149648600006],
              [-30.48619544199994, 81.90298086100006],
              [-30.112945115999935, 81.91966380400004],
              [-30.064198370999918, 81.93105703300006],
              [-29.788441535999937, 81.94822825700004],
              [-29.777088995999918, 81.94692617400005],
              [-29.758534308999913, 81.93903229400007],
              [-29.749663865999935, 81.93756745000007],
              [-29.570668097999942, 81.94310130400004],
              [-29.569935675999943, 81.91006094000005],
              [-29.564605272999927, 81.89695872600004],
              [-29.549672003999945, 81.89004140800006],
              [-29.341623501999948, 81.90322500200006],
              [-29.31859290299991, 81.91193268400008],
              [-29.309071417999917, 81.91860586100006],
              [-29.30174719999991, 81.92645905200004],
              [-29.29637610599991, 81.93585846600007],
              [-29.292632615999935, 81.94684479400007],
              [-29.29088294199994, 81.96043528900003],
              [-29.288685675999943, 81.96405670800004],
              [-29.28221594999991, 81.96784088700008],
              [-29.273548956999946, 81.96979401200008],
              [-29.24242102799991, 81.97016022300005],
              [-29.03856360599991, 81.99990469000005],
              [-28.785227016999954, 81.99998607000003],
              [-28.669545050999943, 82.01390208500004],
              [-28.554066535999937, 82.00844961100006],
              [-28.395253058999913, 82.03180573100008],
              [-28.335113084999932, 82.03229401200008],
              [-28.246245897999927, 82.02289459800005],
              [-28.19432532499991, 82.02855052300004],
              [-27.93781490799995, 82.02505117400005],
              [-27.818959113999938, 82.05613841400003],
              [-27.76195227799991, 82.06244538000004],
              [-27.313082300285625, 82.05173806971433],
              [-26.86421232257134, 82.04103075942861],
              [-26.415342344857056, 82.0303234491429],
              [-25.966472367142767, 82.01961613885719],
              [-25.517602389428482, 82.00890882857148],
              [-25.068732411714198, 81.99820151828575],
              [-24.619862433999913, 81.98749420800004],
              [-24.634836391999954, 81.96991608300004],
              [-24.681792772999927, 81.94277578300006],
              [-24.69831295499995, 81.92499420800004],
              [-24.656239386999914, 81.90989817900004],
              [-24.625396287999934, 81.87929922100005],
              [-24.61676998599995, 81.84149811400005],
              [-24.641102667999917, 81.80499909100007],
              [-24.656239386999914, 81.79555898600006],
              [-24.672027147999927, 81.78888580900008],
              [-24.706206834999932, 81.78119538000004],
              [-25.108357306999935, 81.74010854725005],
              [-25.510507778999937, 81.69902171450005],
              [-25.91265825099994, 81.65793488175005],
              [-26.314808722999942, 81.61684804900005],
              [-26.46239173099991, 81.57404205900008],
              [-26.60700436099995, 81.56077708500004],
              [-26.70376542899993, 81.54120514500005],
              [-26.723011847999942, 81.53148021000004],
              [-26.699370897999927, 81.53241608300004],
              [-26.493031378999945, 81.51557038000004],
              [-26.477040167999917, 81.51190827000005],
              [-26.46743730399993, 81.50332265800006],
              [-26.470326300999943, 81.49091217700004],
              [-26.498850063999953, 81.47093333500004],
              [-26.505604620999918, 81.45807526200008],
              [-26.484445766999954, 81.45189036700003],
              [-26.444935675999943, 81.43439362200007],
              [-26.42284094999991, 81.42918528900003],
              [-26.387196417999917, 81.42772044500003],
              [-26.002064581999917, 81.49435049050004],
              [-25.616932745999918, 81.56098053600005],
              [-25.478871222999942, 81.55638255400004],
              [-25.00395667199993, 81.60126373900005],
              [-24.529042120999918, 81.64614492400005],
              [-24.495716925999943, 81.64370351800005],
              [-24.46515865799995, 81.63621653900003],
              [-24.43464107999995, 81.63275788000004],
              [-24.40147864499994, 81.64232005400004],
              [-24.358713344999956, 81.66278717700004],
              [-24.313221808999913, 81.67560455900008],
              [-24.039784308999913, 81.71082184450006],
              [-23.766346808999913, 81.74603913000004],
              [-23.475738084999932, 81.71466705900008],
              [-23.403920050999943, 81.71881745000007],
              [-23.373036261999914, 81.72817617400005],
              [-23.355295376999948, 81.74095286700003],
              [-23.324818488999938, 81.77684153900003],
              [-23.30772864499994, 81.79254791900007],
              [-23.32725989499994, 81.79926178600005],
              [-23.32135982999995, 81.81244538000004],
              [-23.33698482999995, 81.83624909100007],
              [-23.329701300999943, 81.85203685100004],
              [-23.341135219999956, 81.85529205900008],
              [-23.353505011999914, 81.86367422100005],
              [-23.361683722999942, 81.87372467700004],
              [-23.36046301999994, 81.88239166900007],
              [-23.34679114499994, 81.88865794500003],
              [-23.288441535999937, 81.90176015800006],
              [-23.266224738999938, 81.91889069200005],
              [-23.27257239499994, 81.93439362200007],
              [-23.312123175999943, 81.96503327000005],
              [-23.234445766999954, 81.99013906500005],
              [-23.22956295499995, 81.99795156500005],
              [-23.229359503999945, 82.00535716400003],
              [-23.226226365999935, 82.01117584800005],
              [-23.195423956999946, 82.02228424700007],
              [-23.158273891999954, 82.02521393400008],
              [-23.085682745999918, 82.02269114800004],
              [-23.09398352799991, 82.01683177300004],
              [-23.114125128999945, 82.00873444200005],
              [-23.124256964999915, 82.00324127800008],
              [-23.087717251999948, 82.00458405200004],
              [-23.054676886999914, 82.00958893400008],
              [-22.955189581999946, 82.04148997600004],
              [-22.56349646674994, 82.05197785025004],
              [-22.171803351499932, 82.06246572450004],
              [-21.780110236249925, 82.07295359875005],
              [-21.388417120999918, 82.08344147300005],
              [-21.32762610599991, 82.07656484600005],
              [-21.290638800999943, 82.06411367400005],
              [-21.12051347599993, 81.97801341400003],
              [-21.090687628999945, 81.95774974200003],
              [-21.069203253999945, 81.93325429900005],
              [-21.056996222999942, 81.91303131700005],
              [-21.05492102799991, 81.90143463700008],
              [-21.061390753999945, 81.89093659100007],
              [-21.08584550699993, 81.86151764500005],
              [-21.089914516999954, 81.85797760600008],
              [-21.08820553299995, 81.84284088700008],
              [-21.08071855399993, 81.83551666900007],
              [-21.069569464999915, 81.83026764500005],
              [-21.05654863199993, 81.82119375200006],
              [-21.05109615799995, 81.81391022300005],
              [-21.041900193999936, 81.79572174700007],
              [-21.02562415299991, 81.77163320500006],
              [-21.024647589999915, 81.76654694200005],
              [-21.028920050999943, 81.76141998900005],
              [-21.033029751999948, 81.74477773600006],
              [-21.04210364499994, 81.73191966400003],
              [-21.078236456999946, 81.72455475500004],
              [-21.08739173099991, 81.71214427300004],
              [-21.09203040299991, 81.69354889500005],
              [-21.103993292999917, 81.67157623900005],
              [-21.123605923999946, 81.65265534100007],
              [-21.15135657499991, 81.64362213700008],
              [-21.145375128999945, 81.63629791900007],
              [-21.162587042999917, 81.62230052300004],
              [-21.197621222999942, 81.57363515800006],
              [-21.237619594999956, 81.53929271000004],
              [-21.25682532499991, 81.51748281500005],
              [-21.534738736499918, 81.41396719000005],
              [-21.812652147999927, 81.31045156500005],
              [-22.057118292999917, 81.27802155200004],
              [-22.08234615799995, 81.26886627800008],
              [-22.091053839999915, 81.26772695500006],
              [-22.094878709999932, 81.25604889500005],
              [-22.09756425699993, 81.21967194200005],
              [-22.110666469999956, 81.21930573100008],
              [-22.15147864499994, 81.20880768400008],
              [-22.182199673999946, 81.20482005400004],
              [-22.242543097999942, 81.20477936400005],
              [-22.255848761999914, 81.20237864800004],
              [-22.26716061099995, 81.19525788000004],
              [-22.27330481699994, 81.18524811400005],
              [-22.276234503999945, 81.17304108300004],
              [-22.27562415299991, 81.16071198100008],
              [-22.271148240999935, 81.15037669500003],
              [-22.443470831999946, 81.12433502800008],
              [-22.560373501999948, 81.12018463700008],
              [-22.571197068999936, 81.11713288000004],
              [-22.578684048999946, 81.10748932500007],
              [-22.58145097599993, 81.09418366100005],
              [-22.58112545499995, 81.08588288000004],
              [-22.584584113999938, 81.08030833500004],
              [-22.59829667899993, 81.07501862200007],
              [-22.66274980399993, 81.06492747600004],
              [-23.10700436099995, 80.92218659100007],
              [-23.13223222599993, 80.91791413000004],
              [-23.177845831999946, 80.91889069200005],
              [-23.266753709999932, 80.89630768400008],
              [-23.275013800999943, 80.88934967700004],
              [-23.269642706999946, 80.87734609600005],
              [-23.25731360599991, 80.86981842700004],
              [-23.226673956999946, 80.85927969000005],
              [-23.216420050999943, 80.84910716400003],
              [-23.216053839999915, 80.83466217700004],
              [-23.22642981699994, 80.82314687700006],
              [-23.26895097599993, 80.80133698100008],
              [-23.306996222999942, 80.79279205900008],
              [-23.361439581999946, 80.77383047100005],
              [-23.501779751999948, 80.75116608300004],
              [-23.49315344999991, 80.74282461100006],
              [-23.466867641999954, 80.73725006700005],
              [-23.45799719999991, 80.73037344000005],
              [-23.458973761999914, 80.71552155200004],
              [-23.47402910099993, 80.70734284100007],
              [-23.608754035999937, 80.68357982000003],
              [-23.679676886999914, 80.68280670800004],
              [-23.715646938999953, 80.67772044500003],
              [-23.850412563999953, 80.63629791900007],
              [-23.884388800999943, 80.61871979400007],
              [-23.897084113999938, 80.60065338700008],
              [-23.885609503999945, 80.58657461100006],
              [-23.86473548099991, 80.58356354400007],
              [-23.555816209999932, 80.64783356350006],
              [-23.246896938999953, 80.71210358300004],
              [-23.149037238999938, 80.71686432500007],
              [-23.09325110599991, 80.72797272300005],
              [-23.075795050999943, 80.75120677300004],
              [-23.11196855399993, 80.76170482000003],
              [-23.12409420499995, 80.76292552300004],
              [-23.101958787999934, 80.78363678600005],
              [-23.05968176999994, 80.79531484600005],
              [-22.93464107999995, 80.81488678600005],
              [-22.914133266999954, 80.82440827000005],
              [-22.910633917999917, 80.84003327000005],
              [-22.922596808999913, 80.85122304900005],
              [-22.980132615999935, 80.87250397300005],
              [-22.971913214999915, 80.88043854400007],
              [-22.74754798099991, 80.93146393400008],
              [-22.305409308999913, 80.96308014500005],
              [-22.289947068999936, 80.96727122600004],
              [-22.27647864499994, 80.97508372600004],
              [-22.264475063999953, 80.98566315300008],
              [-22.237660285999937, 81.01654694200005],
              [-22.231190558999913, 81.02045319200005],
              [-22.20376542899993, 81.02480703300006],
              [-22.08543860599991, 81.01040273600006],
              [-22.02757727799991, 81.01117584800005],
              [-21.958973761999914, 81.02138906500005],
              [-21.94713294199994, 81.02635325700004],
              [-21.938303188999953, 81.03489817900004],
              [-21.930287238999938, 81.05459219000005],
              [-21.922718878999945, 81.06403229400007],
              [-21.896107550999943, 81.07684967700004],
              [-21.800526495999918, 81.08820221600007],
              [-21.46084550699993, 81.16762929900005],
              [-21.387440558999913, 81.19476959800005],
              [-21.36278235599991, 81.20038483300004],
              [-20.951283331999946, 81.23574453300006],
              [-20.85960852799991, 81.27948639500005],
              [-20.754709438999953, 81.29002513200004],
              [-20.72419186099995, 81.30385976800005],
              [-20.716460740999935, 81.31468333500004],
              [-20.711537238999938, 81.34080638200004],
              [-20.705474412999934, 81.35195547100005],
              [-20.691761847999942, 81.35960521000004],
              [-20.271473761999943, 81.45125967000004],
              [-19.851185675999943, 81.54291413000004],
              [-19.83307857999995, 81.55556875200006],
              [-20.05064856699994, 81.58734772300005],
              [-20.036040818999936, 81.59821198100008],
              [-20.010894334999932, 81.60468170800004],
              [-19.87877356699994, 81.62221914300005],
              [-19.94640051999994, 81.64679596600007],
              [-19.93260657499991, 81.66030508000006],
              [-19.904449022999927, 81.66950104400007],
              [-19.708159959999932, 81.69550202000005],
              [-19.644642706999946, 81.68988678600005],
              [-19.644886847999942, 81.65814850500004],
              [-19.643869594999956, 81.64793528900003],
              [-19.639515753999945, 81.63646067900004],
              [-19.632801886999914, 81.63157786700003],
              [-19.62295488199993, 81.63056061400005],
              [-19.38621985599991, 81.63519928600005],
              [-19.315785285999937, 81.62152741100005],
              [-19.292225714999915, 81.62026601800005],
              [-19.29043535099993, 81.61200592700004],
              [-19.26130123599995, 81.61054108300004],
              [-19.153675910999937, 81.62433502800008],
              [-19.085275844999956, 81.62543366100005],
              [-19.025542772999927, 81.61884186400005],
              [-18.99754798099991, 81.61200592700004],
              [-18.98387610599991, 81.61029694200005],
              [-19.00617428299995, 81.59674713700008],
              [-19.24632727799991, 81.55475495000007],
              [-19.279286261999914, 81.54144928600005],
              [-19.289906378999945, 81.53343333500004],
              [-19.294300910999937, 81.52521393400008],
              [-19.296864386999914, 81.51557038000004],
              [-19.301909959999932, 81.50372955900008],
              [-19.305978969999956, 81.49823639500005],
              [-19.316029425999943, 81.48749420800004],
              [-19.320301886999914, 81.48114655200004],
              [-19.328846808999913, 81.46295807500007],
              [-19.33311926999994, 81.45685455900008],
              [-19.372222459999932, 81.42963288000004],
              [-19.466460740999935, 81.40436432500007],
              [-19.504505988999938, 81.37881094000005],
              [-19.460560675999943, 81.37470123900005],
              [-19.05937659399993, 81.43854401250005],
              [-18.658192511999914, 81.50238678600005],
              [-18.52375240799995, 81.50568268400008],
              [-18.47297115799995, 81.50043366100005],
              [-18.418446417999917, 81.48102448100008],
              [-18.36864173099991, 81.47504303600005],
              [-18.213002081999946, 81.48224518400008],
              [-17.977447068999936, 81.44696686400005],
              [-17.959055141999954, 81.44061920800004],
              [-17.914418097999942, 81.41510651200008],
              [-17.85533606699994, 81.40375397300005],
              [-17.832875128999945, 81.40326569200005],
              [-17.81944739499994, 81.40997955900008],
              [-17.820790167999917, 81.42413971600007],
              [-17.86074785099993, 81.46613190300008],
              [-17.851551886999914, 81.46686432500007],
              [-17.619699673999946, 81.43008047100005],
              [-17.603627081999946, 81.42308177300004],
              [-17.56004798099991, 81.39386627800008],
              [-17.546213344999956, 81.38934967700004],
              [-17.505930141999954, 81.38816966400003],
              [-17.465443488999938, 81.39203522300005],
              [-17.394276495999918, 81.40884023600006],
              [-17.146839972999942, 81.41339752800008],
              [-17.15062415299991, 81.42511627800008],
              [-17.16315670499995, 81.43427155200004],
              [-17.19098873599995, 81.44725169500003],
              [-17.200917120999918, 81.45408763200004],
              [-17.208729620999918, 81.46161530200004],
              [-17.21507727799991, 81.47040436400005],
              [-17.22020423099991, 81.48102448100008],
              [-17.19277910099993, 81.48419830900008],
              [-17.017323370999918, 81.48411692900004],
              [-16.990223761999914, 81.49237702000005],
              [-16.95921790299991, 81.50674062700006],
              [-16.925445115999935, 81.51683177300004],
              [-16.835316535999937, 81.52411530200004],
              [-16.812652147999927, 81.53668854400007],
              [-16.835926886999914, 81.55072663000004],
              [-16.873443162999934, 81.55451080900008],
              [-16.987538214999915, 81.55320872600004],
              [-17.035511847999942, 81.56183502800008],
              [-17.046538865999935, 81.56224192900004],
              [-17.04478919199994, 81.56488678600005],
              [-17.028635219999956, 81.58063385600008],
              [-17.019886847999942, 81.58466217700004],
              [-17.000721808999913, 81.58982982000003],
              [-16.976226365999935, 81.59259674700007],
              [-16.932484503999945, 81.58950429900005],
              [-16.915638800999943, 81.59100983300004],
              [-16.900217251999948, 81.59568919500003],
              [-16.853179490999935, 81.61937083500004],
              [-16.838002081999946, 81.62445709800005],
              [-16.729318813999953, 81.63104889500005],
              [-16.578521287999934, 81.61619700700004],
              [-16.47569739499994, 81.62470123900005],
              [-16.461293097999942, 81.63007233300004],
              [-16.45181230399993, 81.63971588700008],
              [-16.463246222999942, 81.64899323100008],
              [-16.54002844999991, 81.68455638200004],
              [-16.518137173999946, 81.69033437700006],
              [-16.500599738999938, 81.70600006700005],
              [-16.489003058999913, 81.72719961100006],
              [-16.485218878999945, 81.74945709800005],
              [-16.154042120999918, 81.75604889500005],
              [-16.14598548099991, 81.77309804900005],
              [-16.13890540299991, 81.78335195500006],
              [-16.127430792999917, 81.78717682500007],
              [-15.941151495999918, 81.77277252800008],
              [-15.845122850999928, 81.78180573100008],
              [-15.825672980999911, 81.78986237200007],
              [-15.828968878999945, 81.80097077000005],
              [-15.825021938999953, 81.81289297100005],
              [-15.816558397999927, 81.82322825700004],
              [-15.806630011999914, 81.82965729400007],
              [-15.792713995999918, 81.83201732000003],
              [-15.541371222999913, 81.83541494350004],
              [-15.290028449999909, 81.83881256700005],
              [-15.235707160999937, 81.83173248900005],
              [-15.240793423999946, 81.82868073100008],
              [-15.245838995999918, 81.82684967700004],
              [-15.256662563999953, 81.82477448100008],
              [-15.206654425999943, 81.81476471600007],
              [-14.777929925333277, 81.81391022366672],
              [-14.349205424666613, 81.81305573133339],
              [-13.920480923999946, 81.81220123900005],
              [-13.488636848499937, 81.76386139550004],
              [-13.056792772999927, 81.71552155200004],
              [-12.918853318999936, 81.72308991100005],
              [-12.802805141999954, 81.71478913000004],
              [-12.69444739499994, 81.69293854400007],
              [-12.570057745999918, 81.69623444200005],
              [-12.298858201999934, 81.66675446150006],
              [-12.02765865799995, 81.63727448100008],
              [-11.86904863199993, 81.59829336100006],
              [-11.745106574999909, 81.55048248900005],
              [-11.735096808999913, 81.54287344000005],
              [-11.708322719999956, 81.51630280200004],
              [-11.69522050699993, 81.50885651200008],
              [-11.68150794199994, 81.50409577000005],
              [-11.432525193999936, 81.49054596600007],
              [-11.37682044199994, 81.47601959800005],
              [-11.395863410999937, 81.46088288000004],
              [-11.63857988199993, 81.38841380400004],
              [-11.902129686499933, 81.36013418150006],
              [-12.165679490999935, 81.33185455900008],
              [-12.186146613999938, 81.32514069200005],
              [-12.196888800999943, 81.31834544500003],
              [-12.215891079999949, 81.30174388200004],
              [-12.22642981699994, 81.29482656500005],
              [-12.244984503999945, 81.28807200700004],
              [-12.284413214999915, 81.28156159100007],
              [-12.432769334999932, 81.24062734600005],
              [-12.492014126999948, 81.23354726800005],
              [-12.532622850999928, 81.22272370000007],
              [-12.526722785999937, 81.20416901200008],
              [-12.528187628999945, 81.19306061400005],
              [-12.53819739499994, 81.18695709800005],
              [-12.840016242499928, 81.13739655150005],
              [-13.141835089999915, 81.08783600500004],
              [-13.156809048999946, 81.08746979400007],
              [-13.187977667999917, 81.09218984600005],
              [-13.203968878999945, 81.09223053600005],
              [-13.288685675999943, 81.06329987200007],
              [-13.306304490999935, 81.05463288000004],
              [-13.322417772999927, 81.04303620000007],
              [-13.335682745999918, 81.02704498900005],
              [-13.34211178299995, 81.02244700700004],
              [-13.35460364499994, 81.01992422100005],
              [-13.684641079999949, 81.00079987200007],
              [-14.078968878999945, 81.02033112200007],
              [-14.552723761999914, 80.99062734600005],
              [-14.491525844999956, 80.96881745000007],
              [-14.203724738999938, 80.91437409100007],
              [-14.132191535999937, 80.88617584800005],
              [-14.157053188999953, 80.84149811400005],
              [-14.200754360999952, 80.81964752800008],
              [-14.294911261999914, 80.78432851800005],
              [-14.62132727799991, 80.74640534100007],
              [-14.724680141999954, 80.75210195500006],
              [-15.022694464999944, 80.73344554250005],
              [-15.320708787999934, 80.71478913000004],
              [-15.337961391999954, 80.71141185100004],
              [-15.359364386999914, 80.69733307500007],
              [-15.395822719999956, 80.65961334800005],
              [-15.420399542999917, 80.64838288000004],
              [-15.836577928499935, 80.64282868050006],
              [-16.252756313999953, 80.63727448100008],
              [-16.358550584999932, 80.65680573100008],
              [-16.710764126499924, 80.65981679900005],
              [-17.062977667999917, 80.66282786700003],
              [-17.086537238999938, 80.66787344000005],
              [-17.171864386999914, 80.70921458500004],
              [-17.203480597999942, 80.71893952000005],
              [-17.239898240999935, 80.72231679900005],
              [-17.463368292999917, 80.71662018400008],
              [-17.444976365999935, 80.67938873900005],
              [-17.439808722999942, 80.65371328300006],
              [-17.459095831999946, 80.64093659100007],
              [-17.617014126999948, 80.64785390800006],
              [-17.83775794199994, 80.62860748900005],
              [-18.065297003999945, 80.57664622600004],
              [-18.322255011999914, 80.55805084800005],
              [-18.593861456999946, 80.57343170800004],
              [-18.952788865999935, 80.63206614800004],
              [-19.166127081999946, 80.63458893400008],
              [-19.23582923099991, 80.64834219000005],
              [-19.47166907499991, 80.66543203300006],
              [-19.847238736499918, 80.61587148650005],
              [-20.222808397999927, 80.56631094000005],
              [-20.51634680899994, 80.56427643450004],
              [-20.809885219999956, 80.56224192900004],
              [-20.845448370999918, 80.55735911700003],
              [-20.82526607999995, 80.54572174700007],
              [-20.800038214999915, 80.54026927300004],
              [-20.406809048999946, 80.53888580900008],
              [-20.379790818999936, 80.53506094000005],
              [-20.360218878999945, 80.52553945500006],
              [-20.352406378999945, 80.51154205900008],
              [-20.35114498599995, 80.49457428600005],
              [-20.35265051999994, 80.46059804900005],
              [-20.29751542899993, 80.46710846600007],
              [-20.222727016999954, 80.49652741100005],
              [-19.855376756499936, 80.56568024300006],
              [-19.488026495999918, 80.63483307500007],
              [-19.021555141999954, 80.58885325700004],
              [-18.96202551999994, 80.57526276200008],
              [-18.84325110599991, 80.57225169500003],
              [-18.677398240999935, 80.54140859600005],
              [-18.397735154999936, 80.52342357000006],
              [-18.118072068999936, 80.50543854400007],
              [-18.055083787999934, 80.49176666900007],
              [-17.682504849499935, 80.50210195550005],
              [-17.309925910999937, 80.51243724200003],
              [-16.896229620999918, 80.58368561400005],
              [-16.860503709999932, 80.58173248900005],
              [-16.82323157499991, 80.57343170800004],
              [-16.697621222999942, 80.52798086100006],
              [-16.44823157499991, 80.47915273600006],
              [-16.120838996499913, 80.45819733250005],
              [-15.793446417999917, 80.43724192900004],
              [-15.755197719999956, 80.41941966400003],
              [-15.789173956999946, 80.40468984600005],
              [-16.270008917999917, 80.29047272300005],
              [-16.284982876999948, 80.29083893400008],
              [-16.29792232999995, 80.29328034100007],
              [-16.309925910999937, 80.29832591400003],
              [-16.346262173999946, 80.32355377800008],
              [-16.359364386999914, 80.32746002800008],
              [-16.37531490799995, 80.32591380400004],
              [-16.390451626999948, 80.31924062700006],
              [-16.401722785999937, 80.30857982000003],
              [-16.404896613999938, 80.29596588700008],
              [-16.39549719999991, 80.28335195500006],
              [-16.380116339999915, 80.27606842700004],
              [-16.344105597999942, 80.26788971600007],
              [-16.327463344999956, 80.26154205900008],
              [-16.372425910999937, 80.24286530200004],
              [-16.38036048099991, 80.23761627800008],
              [-16.38418535099993, 80.23574453300006],
              [-16.447336391999954, 80.21930573100008],
              [-16.846302863999938, 80.20282623900005],
              [-16.890695766999954, 80.19155508000006],
              [-17.12214107999995, 80.18292877800008],
              [-17.257883266999954, 80.21478913000004],
              [-17.288441535999937, 80.21800364800004],
              [-17.580657518999942, 80.18956126500004],
              [-17.872873501999948, 80.16111888200004],
              [-18.269256151499945, 80.18099599800004],
              [-18.665638800999943, 80.20087311400005],
              [-18.773589647999927, 80.22158437700006],
              [-19.025990363999938, 80.23615143400008],
              [-19.17955481699994, 80.26801178600005],
              [-19.474354620999918, 80.26019928600005],
              [-19.63809160099993, 80.22138092700004],
              [-19.727040167999917, 80.16258372600004],
              [-19.779855923999946, 80.14630768400008],
              [-20.171213344999956, 80.10431549700007],
              [-20.17174231699994, 80.09699127800008],
              [-19.99132239499994, 80.08885325700004],
              [-19.966460740999935, 80.08323802300004],
              [-19.99014238199993, 80.06940338700008],
              [-20.053089972999942, 80.04181549700007],
              [-20.07917232999995, 80.03676992400005],
              [-20.193959113999938, 80.03412506700005],
              [-20.228260870999918, 80.02399323100008],
              [-20.150542772999927, 80.01260000200006],
              [-20.077015753999945, 79.98973216400003],
              [-20.35338294199994, 79.88605377800008],
              [-20.389271613999938, 79.86322663000004],
              [-20.408924933999913, 79.85464101800005],
              [-20.41783606699994, 79.84845612200007],
              [-20.423085089999915, 79.83958567900004],
              [-20.352406378999945, 79.82013580900008],
              [-20.11432857999995, 79.82318756700005],
              [-20.101389126999948, 79.82094961100006],
              [-20.090321417999917, 79.81513092700004],
              [-20.082142706999946, 79.80414459800005],
              [-20.078928188999953, 79.79328034100007],
              [-20.077381964999915, 79.78343333500004],
              [-20.074818488999938, 79.77399323100008],
              [-20.068430141999954, 79.76390208500004],
              [-20.04600989499994, 79.75031159100007],
              [-19.99632727799991, 79.74770742400005],
              [-19.976226365999935, 79.73826732000003],
              [-19.970448370999918, 79.72532786700003],
              [-19.97288977799991, 79.71234772300005],
              [-19.976918097999942, 79.69940827000005],
              [-19.975738084999932, 79.68695709800005],
              [-19.966949022999927, 79.67938873900005],
              [-19.954701300999943, 79.67902252800008],
              [-19.929839647999927, 79.68455638200004],
              [-19.84862219999991, 79.68280670800004],
              [-19.82530676999994, 79.69057851800005],
              [-19.816883917999917, 79.69891998900005],
              [-19.804758266999954, 79.71967194200005],
              [-19.796050584999932, 79.72785065300008],
              [-19.78270423099991, 79.73248932500007],
              [-19.485666469999956, 79.77366771000004],
              [-19.465321417999917, 79.77326080900008],
              [-19.44517981699994, 79.76959870000007],
              [-19.368885870999918, 79.74481842700004],
              [-19.25812740799995, 79.72508372600004],
              [-19.207753058999913, 79.70848216400003],
              [-19.203521287999934, 79.69428131700005],
              [-19.21637936099995, 79.69269440300008],
              [-19.227853969999956, 79.68537018400008],
              [-19.248850063999953, 79.66718170800004],
              [-19.258941209999932, 79.66107819200005],
              [-19.385324673999946, 79.62409088700008],
              [-19.375721808999913, 79.60602448100008],
              [-19.36270097599993, 79.59072500200006],
              [-19.35265051999994, 79.57391998900005],
              [-19.35179602799991, 79.55133698100008],
              [-19.365712042999917, 79.54588450700004],
              [-19.406605597999942, 79.52049388200004],
              [-19.457020636999914, 79.50495026200008],
              [-19.472279425999943, 79.49603913000004],
              [-19.485096808999913, 79.47939687700006],
              [-19.498890753999945, 79.44049713700008],
              [-19.51130123599995, 79.42373281500005],
              [-19.56590735599991, 79.38593170800004],
              [-19.57249915299991, 79.37335846600007],
              [-19.56236731699994, 79.36713288000004],
              [-19.506337042999917, 79.35716380400004],
              [-19.493072068999936, 79.35024648600006],
              [-19.47915605399993, 79.34039948100008],
              [-19.468739386999914, 79.32831452000005],
              [-19.466053839999915, 79.31476471600007],
              [-19.47020423099991, 79.30707428600005],
              [-19.492787238999938, 79.28351471600007],
              [-19.511708136999914, 79.25629303600005],
              [-19.520253058999913, 79.24774811400005],
              [-19.56541907499991, 79.21312083500004],
              [-19.589588995999918, 79.20083242400005],
              [-19.599232550999943, 79.19228750200006],
              [-19.603586391999954, 79.17991771000004],
              [-19.591135219999956, 79.18414948100008],
              [-19.55768795499995, 79.20628489800004],
              [-19.501942511999914, 79.23411692900004],
              [-19.432199673999946, 79.27985260600008],
              [-19.405100063999953, 79.28733958500004],
              [-19.349273240999935, 79.28607819200005],
              [-19.32095292899993, 79.29071686400005],
              [-19.30650794199994, 79.30719635600008],
              [-19.307362433999913, 79.31403229400007],
              [-19.31403561099995, 79.32941315300008],
              [-19.316070115999935, 79.33665599200003],
              [-19.316517706999946, 79.34406159100007],
              [-19.31582597599993, 79.35101959800005],
              [-19.314116990999935, 79.35761139500005],
              [-19.311268683999913, 79.36456940300008],
              [-19.303212042999917, 79.37616608300004],
              [-19.291005011999914, 79.38593170800004],
              [-19.276682094999956, 79.39166901200008],
              [-19.262277798999946, 79.39069245000007],
              [-19.260609503999945, 79.38263580900008],
              [-19.246652798999946, 79.37620677300004],
              [-19.236683722999942, 79.36692942900004],
              [-19.23005123599995, 79.35472239800004],
              [-19.22642981699994, 79.33934153900003],
              [-19.225331183999913, 79.31452057500007],
              [-19.22647050699993, 79.30744049700007],
              [-19.23110917899993, 79.29889557500007],
              [-19.23737545499995, 79.29120514500005],
              [-19.24168860599991, 79.28310781500005],
              [-19.24087480399993, 79.27301666900007],
              [-19.22960364499994, 79.27460358300004],
              [-19.20645097599993, 79.28815338700008],
              [-19.194203253999945, 79.29230377800008],
              [-19.179676886999914, 79.29246653900003],
              [-19.165272589999915, 79.29047272300005],
              [-19.15143795499995, 79.28668854400007],
              [-19.13825436099995, 79.28143952000005],
              [-19.13809160099993, 79.27838776200008],
              [-19.136789516999954, 79.27138906500005],
              [-19.136708136999914, 79.26825592700004],
              [-18.937855597999942, 79.26146067900004],
              [-18.874745245999918, 79.23655833500004],
              [-18.87877356699994, 79.22508372600004],
              [-18.888417120999918, 79.22117747600004],
              [-18.948963995999918, 79.22638580900008],
              [-18.976918097999942, 79.22089264500005],
              [-18.99128170499995, 79.21552155200004],
              [-19.001210089999915, 79.20652903900003],
              [-19.002512173999946, 79.19245026200008],
              [-18.994536912999934, 79.18016185100004],
              [-18.966542120999918, 79.15961334800005],
              [-18.955189581999946, 79.14899323100008],
              [-18.992909308999913, 79.15058014500005],
              [-19.06786048099991, 79.14459870000007],
              [-19.104644334999932, 79.15228913000004],
              [-19.137521938999953, 79.16718170800004],
              [-19.15461178299995, 79.17153554900005],
              [-19.17292232999995, 79.17035553600005],
              [-19.190012173999946, 79.16225820500006],
              [-19.19908606699994, 79.14980703300006],
              [-19.210275844999956, 79.11749909100007],
              [-19.231312628999945, 79.09731679900005],
              [-19.260894334999932, 79.09638092700004],
              [-19.321888800999943, 79.11432526200008],
              [-19.35448157499991, 79.11725495000007],
              [-19.382150844999956, 79.11131419500003],
              [-19.437123175999943, 79.08690013200004],
              [-19.468576626999948, 79.08478424700007],
              [-19.52171790299991, 79.11286041900007],
              [-19.551340298999946, 79.11359284100007],
              [-19.567982550999943, 79.10529205900008],
              [-19.598866339999915, 79.08368561400005],
              [-19.615956183999913, 79.07587311400005],
              [-19.63190670499995, 79.07318756700005],
              [-19.698841925999943, 79.07729726800005],
              [-19.736439581999946, 79.07440827000005],
              [-19.754383917999917, 79.07025788000004],
              [-19.767201300999943, 79.06517161700003],
              [-19.802723761999914, 79.04572174700007],
              [-19.878529425999943, 79.03196849200003],
              [-19.910552537999934, 79.01825592700004],
              [-19.905506964999915, 78.99347565300008],
              [-19.88703365799995, 78.97890859600005],
              [-19.78425045499995, 78.93081289300005],
              [-19.769276495999918, 78.91624583500004],
              [-19.765695766999954, 78.89765045800004],
              [-19.775990363999938, 78.88125234600005],
              [-19.795318162999934, 78.86920807500007],
              [-19.881337042999917, 78.83685944200005],
              [-19.925852016999954, 78.82868073100008],
              [-20.238433397999927, 78.82660553600005],
              [-20.331776495999918, 78.83803945500006],
              [-20.40957597599993, 78.85854726800005],
              [-20.44163977799991, 78.86078522300005],
              [-20.637440558999913, 78.83502838700008],
              [-20.650502081999946, 78.83051178600005],
              [-20.602691209999932, 78.81012604400007],
              [-20.580230272999927, 78.79547760600008],
              [-20.56786048099991, 78.77655670800004],
              [-20.685943162999934, 78.76723867400005],
              [-20.948841925999943, 78.78302643400008],
              [-20.970814581999946, 78.77887604400007],
              [-20.978993292999917, 78.76683177300004],
              [-20.919911261999914, 78.74774811400005],
              [-20.85692298099991, 78.71808502800008],
              [-20.84203040299991, 78.71527741100005],
              [-20.861317511999914, 78.70441315300008],
              [-21.095814581999946, 78.67304108300004],
              [-21.192982550999943, 78.64447663000004],
              [-21.207753058999913, 78.63287995000007],
              [-20.89085852799991, 78.62714264500005],
              [-20.863270636999914, 78.62201569200005],
              [-20.84243730399993, 78.60854726800005],
              [-20.848215298999946, 78.59259674700007],
              [-20.868031378999945, 78.57705312700006],
              [-20.88975989499994, 78.56439850500004],
              [-21.046864386999914, 78.50454336100006],
              [-21.064523891999954, 78.48981354400007],
              [-21.07213294199994, 78.47321198100008],
              [-21.076893683999913, 78.45526764500005],
              [-21.086415167999917, 78.43646881700005],
              [-21.109974738999938, 78.41547272300005],
              [-21.22606360599991, 78.36074453300006],
              [-21.295033331999946, 78.29999420800004],
              [-21.301380988999938, 78.29303620000007],
              [-21.304351365999935, 78.28408437700006],
              [-21.299712693999936, 78.26984284100007],
              [-21.287993943999936, 78.25560130400004],
              [-21.262928839999915, 78.23212311400005],
              [-21.239979620999918, 78.18439362200007],
              [-21.26667232999995, 78.16063060100004],
              [-21.366444464999915, 78.14427317900004],
              [-21.35448157499991, 78.13226959800005],
              [-21.324370897999927, 78.11310455900008],
              [-21.316395636999914, 78.09788646000004],
              [-21.322336391999954, 78.07680898600006],
              [-21.342925584999932, 78.06655508000006],
              [-21.390370245999918, 78.06012604400007],
              [-21.62999426999994, 77.99811432500007],
              [-21.64712480399993, 77.98745351800005],
              [-21.64085852799991, 77.97833893400008],
              [-21.56314042899993, 77.94692617400005],
              [-21.547230597999942, 77.93207428600005],
              [-21.545318162999934, 77.91193268400008],
              [-21.557443813999953, 77.89850495000007],
              [-21.57876542899993, 77.88788483300004],
              [-21.620838995999918, 77.87579987200007],
              [-21.779652472999942, 77.85175202000005],
              [-21.803578253999945, 77.85248444200005],
              [-21.814849412999934, 77.85040924700007],
              [-21.819976365999935, 77.84267812700006],
              [-21.816761847999942, 77.83502838700008],
              [-21.80036373599995, 77.81830475500004],
              [-21.794911261999914, 77.81049225500004],
              [-21.802845831999946, 77.80731842700004],
              [-21.847035285999937, 77.78131745000007],
              [-21.855824347999942, 77.77130768400008],
              [-21.868519660999937, 77.74909088700008],
              [-21.87645423099991, 77.73916250200006],
              [-21.89940344999991, 77.72589752800008],
              [-21.92715410099993, 77.71600983300004],
              [-21.95221920499995, 77.70278554900005],
              [-21.967274542999917, 77.67918528900003],
              [-21.650502081999946, 77.65863678600005],
              [-21.493519660999937, 77.67352936400005],
              [-21.481068488999938, 77.67234935100004],
              [-21.44676673099991, 77.66258372600004],
              [-21.45335852799991, 77.65387604400007],
              [-21.59707597599993, 77.56159088700008],
              [-21.60460364499994, 77.55023834800005],
              [-21.590728318999936, 77.54889557500007],
              [-21.576242641999954, 77.54975006700005],
              [-21.56236731699994, 77.55316803600005],
              [-21.55064856699994, 77.55927155200004],
              [-21.518869594999956, 77.58372630400004],
              [-21.35456295499995, 77.66412995000007],
              [-21.292713995999918, 77.67454661700003],
              [-21.332183397999927, 77.67755768400008],
              [-21.37832597599993, 77.68927643400008],
              [-21.408924933999913, 77.71255117400005],
              [-21.40147864499994, 77.75018952000005],
              [-21.373890753999945, 77.77680084800005],
              [-20.962147589999915, 77.97036367400005],
              [-20.93740800699993, 77.97370026200008],
              [-20.760568813999953, 77.97060781500005],
              [-20.394968227999954, 77.89219798400006],
              [-20.029367641999954, 77.81378815300008],
              [-19.961008266999954, 77.79096100500004],
              [-19.658884243499955, 77.76203034100004],
              [-19.356760219999956, 77.73309967700004],
              [-19.293365037999934, 77.71478913000004],
              [-19.251210089999915, 77.70937734600005],
              [-19.192697719999956, 77.69082265800006],
              [-19.17992102799991, 77.68866608300004],
              [-19.142241990999935, 77.68720123900005],
              [-19.12682044199994, 77.68366120000007],
              [-19.113392706999946, 77.67739492400005],
              [-19.07168535099993, 77.65119049700007],
              [-19.02057857999995, 77.63377513200004],
              [-18.990386522999927, 77.61859772300005],
              [-18.97915605399993, 77.61684804900005],
              [-18.994699673999946, 77.59992096600007],
              [-19.036000128999945, 77.59552643400008],
              [-19.11237545499995, 77.59707265800006],
              [-19.132150844999956, 77.59223053600005],
              [-19.25536048099991, 77.54266998900005],
              [-19.357980923999946, 77.52635325700004],
              [-19.383615688999953, 77.52997467700004],
              [-19.411773240999935, 77.54287344000005],
              [-19.71607418499994, 77.61770254150005],
              [-20.020375128999945, 77.69253164300005],
              [-20.092152472999942, 77.70136139500005],
              [-20.259755011999914, 77.68919505400004],
              [-20.337513800999943, 77.66144440300008],
              [-20.355295376999948, 77.65924713700008],
              [-20.821522589999915, 77.65350983300004],
              [-20.809315558999913, 77.63129303600005],
              [-20.774769660999937, 77.61701080900008],
              [-20.34398352799991, 77.55487702000005],
              [-20.27843176999994, 77.53302643400008],
              [-20.277333136999914, 77.52952708500004],
              [-20.27692623599995, 77.52602773600006],
              [-20.27725175699993, 77.52252838700008],
              [-20.27830969999991, 77.51898834800005],
              [-20.339019334999932, 77.51691315300008],
              [-20.406361456999946, 77.52285390800006],
              [-20.470326300999943, 77.51862213700008],
              [-20.481597459999932, 77.51410553600005],
              [-20.463490363999938, 77.51137929900005],
              [-20.447336391999954, 77.50226471600007],
              [-20.441029425999943, 77.49017975500004],
              [-20.45254472599993, 77.47817617400005],
              [-20.468006964999915, 77.47443268400008],
              [-20.53897050699993, 77.47870514500005],
              [-20.817616339999915, 77.52826569200005],
              [-20.892201300999943, 77.53001536700003],
              [-20.926258917999917, 77.52240631700005],
              [-20.919260219999956, 77.50910065300008],
              [-20.89834550699993, 77.50283437700006],
              [-20.856027798999946, 77.49774811400005],
              [-20.81932532499991, 77.48753489800004],
              [-20.511301236499918, 77.45453522350005],
              [-20.203277147999927, 77.42153554900005],
              [-20.179798956999946, 77.41559479400007],
              [-20.168039516999954, 77.40412018400008],
              [-20.18228105399993, 77.39728424700007],
              [-20.465402798999946, 77.38279857000003],
              [-20.49176998599995, 77.37531159100007],
              [-20.502308722999942, 77.36212799700007],
              [-20.473378058999913, 77.35911692900004],
              [-20.230132615999935, 77.37250397300005],
              [-19.978891567999938, 77.35681793800006],
              [-19.72765051999994, 77.34113190300008],
              [-19.64907792899993, 77.30817291900007],
              [-19.627797003999945, 77.30353424700007],
              [-19.492014126999948, 77.29303620000007],
              [-19.464507615999935, 77.28213125200006],
              [-19.451730923999946, 77.26243724200003],
              [-19.443714972999942, 77.20986562700006],
              [-19.397613084999932, 77.21869538000004],
              [-19.381459113999938, 77.21771881700005],
              [-19.274566209999932, 77.18927643400008],
              [-19.252756313999953, 77.18817780200004],
              [-19.17674719999991, 77.19253164300005],
              [-19.124338344999956, 77.18968333500004],
              [-19.092925584999932, 77.18374258000006],
              [-19.076324022999927, 77.18256256700005],
              [-19.062652147999927, 77.18671295800004],
              [-19.084095831999946, 77.20416901200008],
              [-19.096424933999913, 77.21112702000005],
              [-19.108713344999956, 77.21548086100006],
              [-19.108143683999913, 77.22223541900007],
              [-19.10496985599991, 77.22577545800004],
              [-19.100900844999956, 77.22870514500005],
              [-19.097401495999918, 77.23383209800005],
              [-19.09557044199994, 77.24013906500005],
              [-19.09166419199994, 77.27440013200004],
              [-19.084339972999942, 77.30320872600004],
              [-19.082508917999917, 77.31842682500007],
              [-19.036284959999932, 77.32013580900008],
              [-18.833811001999948, 77.29144928600005],
              [-18.623158331999946, 77.29425690300008],
              [-18.564564581999946, 77.28827545800004],
              [-18.53612219999991, 77.28095123900005],
              [-18.50918535099993, 77.26935455900008],
              [-18.461781378999945, 77.24070872600004],
              [-18.44444739499994, 77.23371002800008],
              [-18.36196855399993, 77.22117747600004],
              [-18.32445227799991, 77.20848216400003],
              [-18.296498175999943, 77.17914459800005],
              [-18.268299933999913, 77.12759023600006],
              [-18.25877844999991, 77.10016510600008],
              [-18.258208787999934, 77.07245514500005],
              [-18.27017167899993, 77.01447174700007],
              [-18.270253058999913, 76.99420807500007],
              [-18.258615688999953, 76.94696686400005],
              [-18.25918535099993, 76.93219635600008],
              [-18.26593990799995, 76.92055898600006],
              [-18.300160285999937, 76.89337799700007],
              [-18.31240800699993, 76.87954336100006],
              [-18.333729620999918, 76.84955475500004],
              [-18.345855272999927, 76.83588288000004],
              [-18.38027910099993, 76.81940338700008],
              [-18.458973761999914, 76.80882396000004],
              [-18.489165818999936, 76.78497955900008],
              [-18.493967251999948, 76.77338288000004],
              [-18.497303839999915, 76.76044342700004],
              [-18.50218665299991, 76.74872467700004],
              [-18.51121985599991, 76.74091217700004],
              [-18.528472459999932, 76.74070872600004],
              [-18.54914303299995, 76.74835846600007],
              [-18.58535722599993, 76.76666901200008],
              [-18.61278235599991, 76.77643463700008],
              [-18.62604732999995, 76.77610911700003],
              [-18.63613847599993, 76.76727936400005],
              [-18.63890540299991, 76.75275299700007],
              [-18.63658606699994, 76.73456452000005],
              [-18.62840735599991, 76.70160553600005],
              [-18.680490688999953, 76.72361888200004],
              [-18.729400193999936, 76.75136953300006],
              [-18.756214972999942, 76.76064687700006],
              [-18.810699022999927, 76.76512278900003],
              [-18.83702551999994, 76.77440013200004],
              [-18.858143683999913, 76.78506094000005],
              [-18.878651495999918, 76.79173411700003],
              [-18.970692511999914, 76.80589427300004],
              [-18.985503709999932, 76.81028880400004],
              [-19.032378709999932, 76.83274974200003],
              [-19.062652147999927, 76.83787669500003],
              [-19.391346808999913, 76.83136627800008],
              [-19.445301886999914, 76.83954498900005],
              [-19.462880011999914, 76.84585195500006],
              [-19.509917772999927, 76.87531159100007],
              [-19.521555141999954, 76.87791575700004],
              [-19.582875128999945, 76.87270742400005],
              [-19.64793860599991, 76.87767161700003],
              [-19.895090298999946, 76.92536041900007],
              [-20.22362219999991, 76.93109772300005],
              [-20.241444464999915, 76.92914459800005],
              [-20.277333136999914, 76.92108795800004],
              [-20.317616339999915, 76.91681549700007],
              [-20.513417120999918, 76.94570547100005],
              [-20.59121660099993, 76.94098541900007],
              [-20.582386847999942, 76.92934804900005],
              [-20.58311926999994, 76.92084381700005],
              [-20.59129798099991, 76.91486237200007],
              [-20.746693488999938, 76.88768138200004],
              [-20.756214972999942, 76.88446686400005],
              [-20.77961178299995, 76.87327708500004],
              [-20.79165605399993, 76.87006256700005],
              [-20.80500240799995, 76.87103913000004],
              [-20.87995357999995, 76.88703034100007],
              [-21.03620357999995, 76.90241120000007],
              [-21.350900844999956, 76.88719310100004],
              [-21.504261847999942, 76.90346914300005],
              [-21.73005123599995, 76.89081452000005],
              [-21.712880011999914, 76.87763092700004],
              [-21.681467251999948, 76.87396881700005],
              [-21.58812415299991, 76.87518952000005],
              [-21.435658331999946, 76.85907623900005],
              [-21.069203253999945, 76.87360260600008],
              [-21.010650193999936, 76.86908600500004],
              [-20.924956834999932, 76.84536367400005],
              [-20.89395097599993, 76.84235260600008],
              [-20.805246548999946, 76.85077545800004],
              [-20.777333136999914, 76.84235260600008],
              [-20.94432532499991, 76.82697174700007],
              [-21.042958136999914, 76.79401276200008],
              [-21.06749426999994, 76.78896719000005],
              [-21.09316972599993, 76.78717682500007],
              [-21.108550584999932, 76.78949616100005],
              [-21.139475063999953, 76.79926178600005],
              [-21.176909959999932, 76.80263906500005],
              [-21.184315558999913, 76.80475495000007],
              [-21.181385870999918, 76.80829498900005],
              [-21.250355597999942, 76.81150950700004],
              [-21.285715298999946, 76.80801015800006],
              [-21.312326626999948, 76.79393138200004],
              [-21.284901495999918, 76.78595612200007],
              [-21.221913214999915, 76.78912995000007],
              [-21.194935675999943, 76.78034088700008],
              [-21.30101477799991, 76.76626211100006],
              [-21.318511522999927, 76.75641510600008],
              [-21.32994544199994, 76.74640534100007],
              [-21.49632727799991, 76.69521719000005],
              [-21.667958136999914, 76.68414948100008],
              [-21.634836391999954, 76.66889069200005],
              [-21.599720831999946, 76.65741608300004],
              [-21.623646613999938, 76.64642975500004],
              [-21.66112219999991, 76.64569733300004],
              [-21.73005123599995, 76.65741608300004],
              [-21.81944739499994, 76.69501373900005],
              [-21.828846808999913, 76.70148346600007],
              [-21.84479732999995, 76.71775950700004],
              [-21.853505011999914, 76.72508372600004],
              [-21.891753709999932, 76.74176666900007],
              [-21.926258917999917, 76.76422760600008],
              [-21.950550910999937, 76.77435944200005],
              [-22.068186001999948, 76.79657623900005],
              [-22.094593878999945, 76.80475495000007],
              [-22.15330969999991, 76.84442780200004],
              [-22.172759568999936, 76.85171133000006],
              [-22.196156378999945, 76.85667552300004],
              [-22.26585852799991, 76.85936107000003],
              [-22.469878709999932, 76.83559804900005],
              [-22.469878709999932, 76.82876211100006],
              [-22.432484503999945, 76.82733795800004],
              [-22.39635169199994, 76.81997304900005],
              [-22.382557745999918, 76.81264883000006],
              [-22.381214972999942, 76.80658600500004],
              [-22.383697068999936, 76.80068594000005],
              [-22.38117428299995, 76.79393138200004],
              [-22.363758917999917, 76.78245677300004],
              [-22.32335364499994, 76.76532623900005],
              [-22.306019660999937, 76.75307851800005],
              [-22.358021613999938, 76.74079010600008],
              [-22.53221594999991, 76.75307851800005],
              [-22.64561926999994, 76.74583567900004],
              [-22.702015753999945, 76.72968170800004],
              [-22.744211391999954, 76.69843170800004],
              [-22.722401495999918, 76.68227773600006],
              [-22.693470831999946, 76.67169830900008],
              [-22.662587042999917, 76.66596100500004],
              [-22.515004035999937, 76.66567617400005],
              [-22.48729407499991, 76.65399811400005],
              [-22.477365688999953, 76.64838288000004],
              [-22.46637936099995, 76.64398834800005],
              [-22.463693813999953, 76.63898346600007],
              [-22.478667772999927, 76.63190338700008],
              [-22.512440558999913, 76.62156810100004],
              [-22.518299933999913, 76.61644114800004],
              [-22.509103969999956, 76.60366445500006],
              [-22.45661373599995, 76.58173248900005],
              [-22.436390753999945, 76.56806061400005],
              [-22.44249426999994, 76.55695221600007],
              [-22.43260657499991, 76.55023834800005],
              [-22.399769660999937, 76.54254791900007],
              [-22.33299719999991, 76.51715729400007],
              [-22.322865363999938, 76.51504140800006],
              [-22.306996222999942, 76.51422760600008],
              [-22.29206295499995, 76.51569245000007],
              [-22.28429114499994, 76.52020905200004],
              [-22.285227016999954, 76.52806224200003],
              [-22.29165605399993, 76.53290436400005],
              [-22.29987545499995, 76.53644440300008],
              [-22.32408606699994, 76.55255768400008],
              [-22.326527472999942, 76.55955638200004],
              [-22.312163865999935, 76.56806061400005],
              [-22.321522589999915, 76.57062409100007],
              [-22.329253709999932, 76.57469310100004],
              [-22.33543860599991, 76.58063385600008],
              [-22.339507615999935, 76.58856842700004],
              [-22.302479620999918, 76.59414297100005],
              [-22.265980597999942, 76.60415273600006],
              [-22.21666419199994, 76.63007233300004],
              [-22.186024542999917, 76.63987864800004],
              [-22.145008917999917, 76.64581940300008],
              [-22.102162238999938, 76.64549388200004],
              [-22.065785285999937, 76.63694896000004],
              [-22.085560675999943, 76.63104889500005],
              [-22.093088344999956, 76.63007233300004],
              [-22.068104620999918, 76.61611562700006],
              [-21.93545488199993, 76.62270742400005],
              [-21.867176886999914, 76.61054108300004],
              [-21.805165167999917, 76.58856842700004],
              [-21.83189856699994, 76.57684967700004],
              [-21.96426347599993, 76.56606679900005],
              [-22.003977016999954, 76.55703359600005],
              [-22.086293097999942, 76.55499909100007],
              [-22.05260169199994, 76.54197825700004],
              [-22.003570115999935, 76.53099192900004],
              [-21.958241339999915, 76.53021881700005],
              [-21.93545488199993, 76.54755280200004],
              [-21.882069464999915, 76.56537506700005],
              [-21.81086178299995, 76.56134674700007],
              [-21.67479407499991, 76.52708567900004],
              [-22.011830206999946, 76.48232656500005],
              [-22.03848222599993, 76.46564362200007],
              [-21.831654425999943, 76.47622304900005],
              [-21.75885982999995, 76.49542877800008],
              [-21.72288977799991, 76.49974192900004],
              [-21.68106035099993, 76.49062734600005],
              [-21.699940558999913, 76.47020091400003],
              [-21.74754798099991, 76.44904205900008],
              [-21.79210364499994, 76.43768952000005],
              [-22.145253058999913, 76.43854401200008],
              [-22.228260870999918, 76.44936758000006],
              [-22.264475063999953, 76.46222565300008],
              [-22.30410722599993, 76.48309967700004],
              [-22.346994594999956, 76.49974192900004],
              [-22.436390753999945, 76.49974192900004],
              [-22.416859503999945, 76.48895905200004],
              [-22.353260870999918, 76.46564362200007],
              [-22.382883266999954, 76.44993724200003],
              [-22.42369544199994, 76.44651927300004],
              [-22.504017706999946, 76.45136139500005],
              [-22.412180141999954, 76.42536041900007],
              [-22.38117428299995, 76.42348867400005],
              [-22.28075110599991, 76.43463776200008],
              [-22.190297003999945, 76.41144440300008],
              [-21.90182451049995, 76.42829010600008],
              [-21.613352016999954, 76.44513580900008],
              [-21.58543860599991, 76.44306061400005],
              [-21.57754472599993, 76.43707916900007],
              [-21.58580481699994, 76.42829010600008],
              [-21.60651607999995, 76.41722239800004],
              [-21.57127844999991, 76.39728424700007],
              [-21.567250128999945, 76.38471100500004],
              [-21.62018795499995, 76.35578034100007],
              [-21.643788214999915, 76.33649323100008],
              [-21.657948370999918, 76.31517161700003],
              [-21.66860917899993, 76.29352448100008],
              [-21.682240363999938, 76.27326080900008],
              [-21.696603969999956, 76.26105377800008],
              [-21.70449785099993, 76.25560130400004],
              [-21.699940558999913, 76.25165436400005],
              [-21.652088995999918, 76.23773834800005],
              [-21.546254035999937, 76.22394440300008],
              [-21.446115688999953, 76.24404531500005],
              [-21.407948370999918, 76.24591705900008],
              [-21.407948370999918, 76.25336334800005],
              [-21.420033331999946, 76.25324127800008],
              [-21.45571855399993, 76.25958893400008],
              [-21.437489386999914, 76.28131745000007],
              [-21.400135870999918, 76.29279205900008],
              [-21.358021613999938, 76.29450104400007],
              [-21.325917120999918, 76.28685130400004],
              [-21.345448370999918, 76.28123607000003],
              [-21.407948370999918, 76.27326080900008],
              [-21.358021613999938, 76.26333242400005],
              [-21.12051347599993, 76.28461334800005],
              [-21.087554490999935, 76.27826569200005],
              [-20.919097459999932, 76.22186920800004],
              [-20.796945766999954, 76.21019114800004],
              [-20.770741339999915, 76.20156484600005],
              [-20.698841925999943, 76.16787344000005],
              [-20.674549933999913, 76.16400788000004],
              [-20.613880988999938, 76.16437409100007],
              [-20.58389238199993, 76.16034577000005],
              [-20.558216925999943, 76.14972565300008],
              [-20.58495032499991, 76.14175039300005],
              [-20.67491614499994, 76.13605377800008],
              [-20.655140753999945, 76.12409088700008],
              [-20.48582923099991, 76.14350006700005],
              [-20.43736731699994, 76.13621653900003],
              [-20.42100989499994, 76.13605377800008],
              [-20.42100989499994, 76.14350006700005],
              [-20.455881313999953, 76.14496491100005],
              [-20.558216925999943, 76.17084381700005],
              [-20.63662675699993, 76.17767975500004],
              [-20.648915167999917, 76.18085358300004],
              [-20.668812628999945, 76.19497304900005],
              [-20.678212042999917, 76.19814687700006],
              [-20.871693488999938, 76.23086172100005],
              [-20.887115037999934, 76.23908112200007],
              [-20.89321855399993, 76.24506256700005],
              [-20.900013800999943, 76.25519440300008],
              [-20.908273891999954, 76.26447174700007],
              [-20.984445766999954, 76.25608958500004],
              [-21.010650193999936, 76.25958893400008],
              [-21.06273352799991, 76.28851959800005],
              [-21.085682745999918, 76.29433828300006],
              [-21.062977667999917, 76.31110260600008],
              [-21.02440344999991, 76.31732819200005],
              [-20.89443925699993, 76.30792877800008],
              [-20.690744594999956, 76.25812409100007],
              [-20.58657792899993, 76.24664948100008],
              [-20.489125128999945, 76.22357819200005],
              [-20.306304490999935, 76.22776927300004],
              [-20.229237433999913, 76.24591705900008],
              [-19.93773352799991, 76.25796133000006],
              [-19.84723873599995, 76.24494049700007],
              [-19.763050910999937, 76.20498281500005],
              [-19.698109503999945, 76.14370351800005],
              [-19.67056230399993, 76.13605377800008],
              [-19.672434048999946, 76.12726471600007],
              [-19.721424933999913, 76.07526276200008],
              [-19.719309048999946, 76.07151927300004],
              [-19.715240037999934, 76.06159088700008],
              [-19.754505988999938, 76.05727773600006],
              [-19.827504035999937, 76.06509023600006],
              [-19.996490037999934, 76.06305573100008],
              [-20.26939856699994, 75.99233633000006],
              [-20.701364712666606, 75.99007124766672],
              [-21.133330858333277, 75.98780616533338],
              [-21.565297003999945, 75.98554108300004],
              [-21.613352016999954, 75.97524648600006],
              [-21.654896613999938, 75.97162506700005],
              [-21.702748175999943, 75.97418854400007],
              [-21.805531378999945, 75.99290599200003],
              [-21.83897864499994, 76.00462474200003],
              [-21.897328253999945, 76.04214101800005],
              [-21.923939581999946, 76.04816315300008],
              [-21.955922003999945, 76.04047272300005],
              [-21.952300584999932, 76.03363678600005],
              [-21.95018469999991, 76.02838776200008],
              [-21.947417772999927, 76.02431875200006],
              [-21.94172115799995, 76.02065664300005],
              [-21.973784959999932, 76.00128815300008],
              [-21.98387610599991, 75.99266185100004],
              [-21.96784420499995, 75.98818594000005],
              [-21.908192511999914, 75.98582591400003],
              [-21.91502844999991, 75.98582591400003],
              [-21.90343176999994, 75.98309967700004],
              [-21.894886847999942, 75.97711823100008],
              [-21.88780676999994, 75.97036367400005],
              [-21.880848761999914, 75.96539948100008],
              [-21.863392706999946, 75.95990631700005],
              [-21.84483801999994, 75.95783112200007],
              [-21.572458462499924, 75.96161530150007],
              [-21.300078904999907, 75.96539948100008],
              [-20.937082485999923, 75.96389394750005],
              [-20.57408606699994, 75.96238841400003],
              [-20.49315344999991, 75.95010000200006],
              [-20.444691535999937, 75.94798411700003],
              [-20.33226477799991, 75.92377350500004],
              [-19.93496660099993, 75.93402741100005],
              [-19.749379035999937, 75.88898346600007],
              [-19.641957160999937, 75.82827383000006],
              [-19.62995357999995, 75.81793854400007],
              [-19.570057745999918, 75.77899811400005],
              [-19.49705969999991, 75.75726959800005],
              [-19.345326300999943, 75.73261139500005],
              [-19.372670050999943, 75.72459544500003],
              [-19.48184160099993, 75.73883698100008],
              [-19.548654751999948, 75.73578522300005],
              [-19.575917120999918, 75.72589752800008],
              [-19.565052863999938, 75.70465729400007],
              [-19.61229407499991, 75.68423086100006],
              [-19.59483801999994, 75.66836172100005],
              [-19.50304114499994, 75.64325592700004],
              [-19.520863410999937, 75.62592194200005],
              [-19.501698370999918, 75.61066315300008],
              [-19.441558397999927, 75.58860911700003],
              [-19.41787675699993, 75.57566966400003],
              [-19.396229620999918, 75.55996328300006],
              [-19.38149980399993, 75.54132721600007],
              [-19.37881425699993, 75.51972077000005],
              [-19.37409420499995, 75.51166413000004],
              [-19.372385219999956, 75.50067780200004],
              [-19.372670050999943, 75.47504303600005],
              [-19.369130011999914, 75.46185944200005],
              [-19.35179602799991, 75.43683502800008],
              [-19.345326300999943, 75.42413971600007],
              [-19.341908331999946, 75.41132233300004],
              [-19.341949022999927, 75.40277741100005],
              [-19.34634355399993, 75.39533112200007],
              [-19.355865037999934, 75.38593170800004],
              [-19.363758917999917, 75.37396881700005],
              [-19.36750240799995, 75.34735748900005],
              [-19.365834113999938, 75.33417389500005],
              [-19.386870897999927, 75.27846914300005],
              [-19.40225175699993, 75.25250885600008],
              [-19.42723548099991, 75.22553131700005],
              [-19.46385657499991, 75.19839101800005],
              [-19.485585089999915, 75.18768952000005],
              [-19.530140753999945, 75.17694733300004],
              [-19.573841925999943, 75.14874909100007],
              [-19.588612433999913, 75.14232005400004],
              [-19.879790818999936, 75.14980703300006],
              [-19.908273891999954, 75.15656159100007],
              [-19.96434485599991, 75.17853424700007],
              [-20.002552863999938, 75.18577708500004],
              [-20.002552863999938, 75.19179922100005],
              [-20.000396287999934, 75.19891998900005],
              [-20.003285285999937, 75.20502350500004],
              [-20.01593990799995, 75.21010976800005],
              [-20.028472459999932, 75.21259186400005],
              [-20.04051673099991, 75.21649811400005],
              [-20.05101477799991, 75.22553131700005],
              [-20.023426886999914, 75.23240794500003],
              [-20.017730272999927, 75.23965078300006],
              [-20.021107550999943, 75.24738190300008],
              [-20.020008917999917, 75.25592682500007],
              [-20.006418423999946, 75.26569245000007],
              [-19.986805792999917, 75.27285390800006],
              [-19.947987433999913, 75.27952708500004],
              [-19.967152472999942, 75.29242584800005],
              [-19.99168860599991, 75.30117422100005],
              [-20.06432044199994, 75.31077708500004],
              [-20.140248175999943, 75.33608633000006],
              [-20.168690558999913, 75.34105052300004],
              [-20.307036912999934, 75.33624909100007],
              [-20.403920050999943, 75.31273021000004],
              [-20.66783606699994, 75.29315827000005],
              [-20.713693813999953, 75.29946523600006],
              [-20.852772589999915, 75.34662506700005],
              [-21.025013800999943, 75.36880117400005],
              [-21.161488410999937, 75.40493398600006],
              [-21.199940558999913, 75.42157623900005],
              [-21.216053839999915, 75.45482005400004],
              [-21.236887173999946, 75.47748444200005],
              [-21.28473873599995, 75.49542877800008],
              [-21.66905676999994, 75.59267812700006],
              [-21.966074185499934, 75.63108958550006],
              [-22.26309160099993, 75.66950104400007],
              [-22.28115800699993, 75.65997955900008],
              [-22.277088995999918, 75.65224844000005],
              [-22.259103969999956, 75.64459870000007],
              [-21.92572994699995, 75.58374664900006],
              [-21.592355923999946, 75.52289459800005],
              [-21.407948370999918, 75.45831940300008],
              [-21.443348761999914, 75.44961172100005],
              [-21.921335415499925, 75.48259105050005],
              [-22.399322068999936, 75.51557038000004],
              [-22.461333787999934, 75.53457265800006],
              [-22.469878709999932, 75.54022858300004],
              [-22.469349738999938, 75.54311758000006],
              [-22.467518683999913, 75.54808177300004],
              [-22.468495245999918, 75.55434804900005],
              [-22.476714647999927, 75.56069570500006],
              [-22.49242102799991, 75.55947500200006],
              [-22.504628058999913, 75.55133698100008],
              [-22.50649980399993, 75.53953685100004],
              [-22.497792120999918, 75.52716705900008],
              [-22.461415167999917, 75.50946686400005],
              [-22.11733964733325, 75.48358795766671],
              [-21.77326412666658, 75.45770905133338],
              [-21.42918860599991, 75.43183014500005],
              [-21.40103105399993, 75.42413971600007],
              [-21.38573157499991, 75.41547272300005],
              [-21.35265051999994, 75.38251373900005],
              [-21.31387285099993, 75.36371491100005],
              [-20.977894660999937, 75.31500885600008],
              [-20.946522589999915, 75.29686107000003],
              [-20.887115037999934, 75.27952708500004],
              [-20.84951738199993, 75.25674062700006],
              [-20.83340410099993, 75.25055573100008],
              [-20.651275193999936, 75.22479889500005],
              [-20.559925910999937, 75.19725169500003],
              [-20.517201300999943, 75.14232005400004],
              [-20.69050045499995, 75.12547435100004],
              [-20.996978318999936, 75.14232005400004],
              [-21.073109503999945, 75.12518952000005],
              [-21.181996222999942, 75.12189362200007],
              [-21.57909094999991, 75.00438060100004],
              [-21.76073157499991, 74.98529694200005],
              [-21.769886847999942, 74.98712799700007],
              [-21.805165167999917, 74.99896881700005],
              [-21.837635870999918, 75.00560130400004],
              [-21.847035285999937, 75.00922272300005],
              [-21.85838782499991, 75.01557038000004],
              [-21.864409959999932, 75.02130768400008],
              [-21.866851365999935, 75.02952708500004],
              [-21.867176886999914, 75.04336172100005],
              [-21.885243292999917, 75.06696198100008],
              [-21.92686926999994, 75.08274974200003],
              [-22.34679114499994, 75.16852448100008],
              [-22.436390753999945, 75.17023346600007],
              [-22.410267706999946, 75.15460846600007],
              [-22.34284420499995, 75.14638906500005],
              [-22.280018683999913, 75.12913646000004],
              [-22.14395097599993, 75.10805898600006],
              [-21.94172115799995, 75.05418528900003],
              [-21.953236456999946, 75.03693268400008],
              [-21.97362219999991, 75.02826569200005],
              [-22.018055792999917, 75.01886627800008],
              [-21.998402472999942, 75.01243724200003],
              [-21.928618943999936, 75.00580475500004],
              [-21.915394660999937, 75.00214264500005],
              [-21.867176886999914, 74.97846100500004],
              [-21.76911373599995, 74.96019114800004],
              [-21.667958136999914, 74.95799388200004],
              [-21.509388800999943, 74.98021067900004],
              [-21.115956183999913, 75.09088776200008],
              [-21.03111731699994, 75.08771393400008],
              [-20.935943162999934, 75.07119375200006],
              [-20.838734503999945, 75.06728750200006],
              [-20.731353318999936, 75.07632070500006],
              [-20.676625128999945, 75.07440827000005],
              [-20.62637285099993, 75.06037018400008],
              [-20.63072669199994, 75.05923086100006],
              [-20.640736456999946, 75.05418528900003],
              [-20.641835089999915, 75.02374909100007],
              [-20.71397864499994, 74.98016998900005],
              [-20.719553188999953, 74.96141185100004],
              [-20.696441209999932, 74.93984609600005],
              [-20.68663489499994, 74.92804596600007],
              [-20.681711391999954, 74.91705963700008],
              [-20.682240363999938, 74.89817942900004],
              [-20.690174933999913, 74.88739655200004],
              [-20.722645636999914, 74.87201569200005],
              [-20.75182044199994, 74.86456940300008],
              [-20.762318488999938, 74.85724518400008],
              [-20.764230923999946, 74.84072500200006],
              [-20.758168097999942, 74.83128489800004],
              [-20.74600175699993, 74.82143789300005],
              [-20.723255988999938, 74.80719635600008],
              [-20.652740037999934, 74.77435944200005],
              [-20.61668860599991, 74.75250885600008],
              [-20.609730597999942, 74.73484935100004],
              [-20.624256964999915, 74.72752513200004],
              [-20.662587042999917, 74.71784088700008],
              [-20.690297003999945, 74.70062897300005],
              [-20.791900193999936, 74.66596100500004],
              [-21.097645636999914, 74.67316315300008],
              [-21.119943813999953, 74.66689687700006],
              [-21.095814581999946, 74.65428294500003],
              [-21.041005011999914, 74.64704010600008],
              [-20.70075436099995, 74.64777252800008],
              [-20.674712693999936, 74.65119049700007],
              [-20.64244544199994, 74.66543203300006],
              [-20.59137936099995, 74.66962311400005],
              [-20.521107550999943, 74.68431224200003],
              [-20.349354620999918, 74.67059967700004],
              [-20.202300584999932, 74.67951080900008],
              [-20.154693162999934, 74.67682526200008],
              [-20.071522589999915, 74.66315338700008],
              [-20.055409308999913, 74.65753815300008],
              [-20.02448482999995, 74.63963450700004],
              [-20.01353919199994, 74.63589101800005],
              [-20.00694739499994, 74.63434479400007],
              [-19.981312628999945, 74.62396881700005],
              [-19.97061113199993, 74.62287018400008],
              [-19.93496660099993, 74.62905508000006],
              [-19.891753709999932, 74.62710195500006],
              [-19.86904863199993, 74.62173086100006],
              [-19.840687628999945, 74.59389883000006],
              [-19.79796301999994, 74.58710358300004],
              [-19.718373175999943, 74.58746979400007],
              [-19.707020636999914, 74.59100983300004],
              [-19.642567511999914, 74.62213776200008],
              [-19.571603969999956, 74.64297109600005],
              [-19.53115800699993, 74.64915599200003],
              [-19.447743292999917, 74.68366120000007],
              [-19.402821417999917, 74.68943919500003],
              [-19.355539516999954, 74.68451569200005],
              [-19.309885219999956, 74.67047760600008],
              [-19.269602016999954, 74.64887116100005],
              [-19.309478318999936, 74.61416250200006],
              [-19.312163865999935, 74.59784577000005],
              [-19.290760870999918, 74.58124420800004],
              [-19.313221808999913, 74.57233307500007],
              [-19.38630123599995, 74.56073639500005],
              [-19.35655676999994, 74.55560944200005],
              [-19.317005988999938, 74.56020742400005],
              [-19.281361456999946, 74.55971914300005],
              [-19.263417120999918, 74.53900788000004],
              [-19.268706834999932, 74.53790924700007],
              [-19.27879798099991, 74.53400299700007],
              [-19.28384355399993, 74.53278229400007],
              [-19.268788214999915, 74.52265045800004],
              [-19.251576300999943, 74.51959870000007],
              [-19.214995897999927, 74.51976146000004],
              [-19.12218176999994, 74.50556061400005],
              [-19.044585740999935, 74.50478750200006],
              [-19.007476365999935, 74.49872467700004],
              [-18.974761522999927, 74.48436107000003],
              [-19.00499426999994, 74.47601959800005],
              [-19.045318162999934, 74.45905182500007],
              [-19.077748175999943, 74.43768952000005],
              [-19.08462480399993, 74.41616445500006],
              [-19.10309811099995, 74.41644928600005],
              [-19.150013800999943, 74.41144440300008],
              [-19.166900193999936, 74.40619538000004],
              [-19.17804928299995, 74.39785390800006],
              [-19.175770636999914, 74.39223867400005],
              [-19.16893469999991, 74.38593170800004],
              [-19.166574673999946, 74.37579987200007],
              [-19.173085089999915, 74.35907623900005],
              [-19.18464107999995, 74.34829336100006],
              [-19.349232550999943, 74.28546784100007],
              [-19.36091061099995, 74.27936432500007],
              [-19.365834113999938, 74.26935455900008],
              [-19.374379035999937, 74.26683177300004],
              [-19.62653561099995, 74.23859284100007],
              [-19.91360429599993, 74.25918203350005],
              [-20.20067298099991, 74.27977122600004],
              [-20.222401495999918, 74.29633209800005],
              [-20.22057044199994, 74.30377838700008],
              [-20.216908331999946, 74.30780670800004],
              [-20.214100714999915, 74.31220123900005],
              [-20.214914516999954, 74.32054271000004],
              [-20.21788489499994, 74.32176341400003],
              [-20.231760219999956, 74.32982005400004],
              [-20.236073370999918, 74.33421458500004],
              [-20.23814856699994, 74.34503815300008],
              [-20.237660285999937, 74.36546458500004],
              [-20.24282792899993, 74.37579987200007],
              [-20.253895636999914, 74.38434479400007],
              [-20.282582160999937, 74.39789459800005],
              [-20.306752081999946, 74.41522858300004],
              [-20.33153235599991, 74.42584870000007],
              [-20.35732988199993, 74.44525788000004],
              [-20.37291419199994, 74.44843170800004],
              [-20.389393683999913, 74.44692617400005],
              [-20.43858801999994, 74.43707916900007],
              [-20.448882615999935, 74.43724192900004],
              [-20.45409094999991, 74.44057851800005],
              [-20.46393795499995, 74.45331452000005],
              [-20.46939042899993, 74.45709870000007],
              [-20.498158331999946, 74.45962148600006],
              [-20.55650794199994, 74.45136139500005],
              [-20.58551998599995, 74.45087311400005],
              [-20.655995245999918, 74.46430084800005],
              [-20.82921301999994, 74.45246002800008],
              [-21.255034959999932, 74.47418854400007],
              [-21.494496222999942, 74.45978424700007],
              [-21.569203253999945, 74.44647858300004],
              [-21.628895636999914, 74.44676341400003],
              [-21.805531378999945, 74.47894928600005],
              [-21.82249915299991, 74.48810455900008],
              [-21.829009568999936, 74.49681224200003],
              [-21.84166419199994, 74.51878489800004],
              [-21.850087042999917, 74.52944570500006],
              [-21.875884568999936, 74.54694245000007],
              [-22.046538865999935, 74.60008372600004],
              [-22.081776495999918, 74.60297272300005],
              [-22.11424719999991, 74.59422435100004],
              [-22.07843990799995, 74.57599518400008],
              [-21.93887285099993, 74.53229401200008],
              [-21.93268795499995, 74.52887604400007],
              [-21.92528235599991, 74.52289459800005],
              [-21.914133266999954, 74.50763580900008],
              [-21.87401282499991, 74.47479889500005],
              [-21.805083787999934, 74.44757721600007],
              [-21.784982876999948, 74.44403717700004],
              [-21.771636522999927, 74.43870677300004],
              [-21.76585852799991, 74.42694733300004],
              [-21.768788214999915, 74.41526927300004],
              [-21.792225714999915, 74.40607330900008],
              [-21.801136847999942, 74.39740631700005],
              [-21.812652147999927, 74.38263580900008],
              [-21.828114386999914, 74.37494538000004],
              [-21.963775193999936, 74.33486562700006],
              [-22.051584438999953, 74.32054271000004],
              [-22.206857876999948, 74.32196686400005],
              [-22.302072719999956, 74.30329010600008],
              [-22.436390753999945, 74.32054271000004],
              [-22.46043860599991, 74.31854889500005],
              [-22.47101803299995, 74.31366608300004],
              [-22.464955206999946, 74.30857982000003],
              [-22.41397050699993, 74.30402252800008],
              [-22.346994594999956, 74.28644440300008],
              [-22.166493292999917, 74.30011627800008],
              [-22.069081183999913, 74.29425690300008],
              [-22.03848222599993, 74.25165436400005],
              [-22.05890865799995, 74.23187897300005],
              [-22.09756425699993, 74.21430084800005],
              [-22.139149542999917, 74.20180898600006],
              [-22.191232876999948, 74.19383372600004],
              [-22.240589972999942, 74.17975495000007],
              [-22.264475063999953, 74.17658112200007],
              [-22.30410722599993, 74.17560455900008],
              [-22.322865363999938, 74.17169830900008],
              [-22.339507615999935, 74.16290924700007],
              [-22.31012936099995, 74.15668366100005],
              [-22.240061001999948, 74.16933828300006],
              [-22.209828253999945, 74.16974518400008],
              [-22.193837042999917, 74.16278717700004],
              [-22.178578253999945, 74.15155670800004],
              [-22.155181443999936, 74.12872955900008],
              [-22.17601477799991, 74.11261627800008],
              [-22.229400193999936, 74.10130442900004],
              [-22.333363410999937, 74.09398021000004],
              [-22.41624915299991, 74.10175202000005],
              [-22.47793535099993, 74.08779531500005],
              [-22.487945115999935, 74.08095937700006],
              [-22.477040167999917, 74.07074616100005],
              [-22.45421301999994, 74.06452057500007],
              [-22.34715735599991, 74.05735911700003],
              [-22.28429114499994, 74.03937409100007],
              [-22.106800910999937, 74.02570221600007],
              [-22.11424719999991, 74.02570221600007],
              [-22.088286912999934, 74.02509186400005],
              [-22.02887936099995, 74.01325104400007],
              [-21.988677537999934, 73.99872467700004],
              [-21.986805792999917, 73.99420807500007],
              [-21.993763800999943, 73.98663971600007],
              [-22.004383917999917, 73.97044505400004],
              [-21.991078253999945, 73.96775950700004],
              [-21.98542232999995, 73.96137116100005],
              [-21.98737545499995, 73.95278554900005],
              [-21.996937628999945, 73.94318268400008],
              [-21.964466925999943, 73.92987702000005],
              [-21.89321855399993, 73.91673411700003],
              [-21.859730597999942, 73.90224844000005],
              [-21.867176886999914, 73.89541250200006],
              [-21.812652147999927, 73.84760163000004],
              [-21.83690344999991, 73.82257721600007],
              [-21.84048417899993, 73.81720612200007],
              [-21.83897864499994, 73.81028880400004],
              [-21.83307857999995, 73.79828522300005],
              [-21.83307857999995, 73.79238515800006],
              [-21.83747311099995, 73.78656647300005],
              [-21.84984290299991, 73.77903880400004],
              [-21.853505011999914, 73.77252838700008],
              [-21.85383053299995, 73.76113515800006],
              [-21.85106360599991, 73.74762604400007],
              [-21.845326300999943, 73.73627350500004],
              [-21.836781378999945, 73.73151276200008],
              [-21.83340410099993, 73.72662995000007],
              [-21.832427537999934, 73.71539948100008],
              [-21.83307857999995, 73.69367096600007],
              [-21.83690344999991, 73.68292877800008],
              [-21.843820766999954, 73.67462799700007],
              [-21.84723873599995, 73.66640859600005],
              [-21.84048417899993, 73.65574778900003],
              [-21.82713782499991, 73.65167877800008],
              [-21.801503058999913, 73.66327545800004],
              [-21.788441535999937, 73.65924713700008],
              [-21.769154425999943, 73.65643952000005],
              [-21.74437415299991, 73.66811758000006],
              [-21.702748175999943, 73.69672272300005],
              [-21.711048956999946, 73.71426015800006],
              [-21.72411048099991, 73.72785065300008],
              [-21.75731360599991, 73.75136953300006],
              [-21.752674933999913, 73.75267161700003],
              [-21.749989386999914, 73.75438060100004],
              [-21.74754798099991, 73.75641510600008],
              [-21.74364173099991, 73.75885651200008],
              [-21.750355597999942, 73.76349518400008],
              [-21.75454667899993, 73.77024974200003],
              [-21.756703253999945, 73.77887604400007],
              [-21.75731360599991, 73.78925202000005],
              [-21.758371548999946, 73.79360586100006],
              [-21.76280676999994, 73.80174388200004],
              [-21.764149542999917, 73.80658600500004],
              [-21.762115037999934, 73.81077708500004],
              [-21.75226803299995, 73.81891510600008],
              [-21.74986731699994, 73.82367584800005],
              [-21.753732876999948, 73.83185455900008],
              [-21.761057094999956, 73.83991120000007],
              [-21.76549231699994, 73.84853750200006],
              [-21.76073157499991, 73.85809967700004],
              [-21.75812740799995, 73.86644114800004],
              [-21.764515753999945, 73.87421295800004],
              [-21.781239386999914, 73.88544342700004],
              [-21.788685675999943, 73.89398834800005],
              [-21.794667120999918, 73.90249258000006],
              [-21.80174719999991, 73.90997955900008],
              [-21.812652147999927, 73.91583893400008],
              [-21.829823370999918, 73.91815827000005],
              [-21.868519660999937, 73.91893138200004],
              [-21.88426673099991, 73.92641836100006],
              [-21.886708136999914, 73.93573639500005],
              [-21.867583787999934, 73.95014069200005],
              [-21.87059485599991, 73.96088288000004],
              [-21.880116339999915, 73.96808502800008],
              [-21.891021287999934, 73.97288646000004],
              [-21.91502844999991, 73.97793203300006],
              [-21.91161048099991, 73.98212311400005],
              [-21.909494594999956, 73.98566315300008],
              [-21.906605597999942, 73.98891836100006],
              [-21.900746222999942, 73.99217357000003],
              [-21.908558722999942, 74.01581452000005],
              [-21.87022864499994, 74.03424713700008],
              [-21.78465735599991, 74.05304596600007],
              [-21.59007727799991, 74.05768463700008],
              [-21.139332648999925, 73.97207265800006],
              [-20.68858801999994, 73.88646067900004],
              [-20.365793423999946, 73.89541250200006],
              [-20.319162563999953, 73.89166901200008],
              [-20.29600989499994, 73.88613515800006],
              [-20.27757727799991, 73.87547435100004],
              [-20.271962042999917, 73.86481354400007],
              [-20.270375128999945, 73.85358307500007],
              [-20.26549231699994, 73.84479401200008],
              [-20.249663865999935, 73.84137604400007],
              [-20.25845292899993, 73.83197663000004],
              [-20.26984615799995, 73.82786692900004],
              [-20.279652472999942, 73.82273997600004],
              [-20.287709113999938, 73.79791901200008],
              [-20.297678188999953, 73.79059479400007],
              [-20.311105923999946, 73.78705475500004],
              [-20.407582160999937, 73.78339264500005],
              [-20.44912675699993, 73.77533600500004],
              [-20.483021613999938, 73.75885651200008],
              [-20.471180792999917, 73.74949778900003],
              [-20.457590298999946, 73.74282461100006],
              [-20.442982550999943, 73.73871491100005],
              [-20.427845831999946, 73.73773834800005],
              [-20.427845831999946, 73.73151276200008],
              [-20.490305141999954, 73.73452383000006],
              [-20.52049719999991, 73.72894928600005],
              [-20.530873175999943, 73.71039459800005],
              [-20.526234503999945, 73.70343659100007],
              [-20.499826626999948, 73.68683502800008],
              [-20.494740363999938, 73.68089427300004],
              [-20.483021613999938, 73.66266510600008],
              [-20.47569739499994, 73.65525950700004],
              [-20.469634568999936, 73.65155670800004],
              [-20.465199347999942, 73.64655182500007],
              [-20.462554490999935, 73.63532135600008],
              [-20.46670488199993, 73.62824127800008],
              [-20.47614498599995, 73.62409088700008],
              [-20.482980923999946, 73.61945221600007],
              [-20.479359503999945, 73.61115143400008],
              [-20.481312628999945, 73.59772370000007],
              [-20.521595831999946, 73.57143789300005],
              [-20.52057857999995, 73.55646393400008],
              [-20.488758917999917, 73.54401276200008],
              [-20.411284959999932, 73.54572174700007],
              [-20.383697068999936, 73.53603750200006],
              [-20.382476365999935, 73.51788971600007],
              [-20.400542772999927, 73.49652741100005],
              [-20.42674719999991, 73.47736237200007],
              [-20.449777798999946, 73.46576569200005],
              [-20.54328365799995, 73.44904205900008],
              [-20.912098761999943, 73.45311106950007],
              [-21.280913865999935, 73.45718008000006],
              [-21.453724738999938, 73.48663971600007],
              [-21.54320227799991, 73.49042389500005],
              [-21.62018795499995, 73.45718008000006],
              [-21.60960852799991, 73.45677317900004],
              [-21.60496985599991, 73.45579661700003],
              [-21.576161261999914, 73.44013092700004],
              [-21.55532792899993, 73.42438385600008],
              [-21.54987545499995, 73.40859609600005],
              [-21.572417772999927, 73.39508698100008],
              [-21.598866339999915, 73.39154694200005],
              [-21.653553839999915, 73.39215729400007],
              [-21.703968878999945, 73.38133372600004],
              [-21.777821417999917, 73.37466054900005],
              [-21.963368292999917, 73.33368561400005],
              [-22.106800910999937, 73.27903880400004],
              [-22.208363410999937, 73.25397370000007],
              [-22.314076300999943, 73.25043366100005],
              [-22.63542639849993, 73.28998444200005],
              [-22.956776495999918, 73.32953522300005],
              [-23.011830206999946, 73.34398021000004],
              [-23.095814581999946, 73.35016510600008],
              [-23.114165818999936, 73.35415273600006],
              [-23.223459438999953, 73.40045807500007],
              [-23.449940558999913, 73.43610260600008],
              [-23.486398891999954, 73.44745514500005],
              [-23.54979407499991, 73.47817617400005],
              [-23.587147589999915, 73.49135976800005],
              [-23.82022050699993, 73.54669830900008],
              [-23.89561926999994, 73.57729726800005],
              [-23.917307094999956, 73.58295319200005],
              [-23.968495245999918, 73.58856842700004],
              [-23.98778235599991, 73.59739817900004],
              [-23.996937628999945, 73.60687897300005],
              [-24.015736456999946, 73.63157786700003],
              [-24.025746222999942, 73.65176015800006],
              [-24.025502081999946, 73.68720123900005],
              [-24.032826300999943, 73.69672272300005],
              [-24.015695766999954, 73.71889883000006],
              [-23.982980923999946, 73.72435130400004],
              [-23.916086391999954, 73.71723053600005],
              [-23.766957160999937, 73.72313060100004],
              [-23.68846594999991, 73.71027252800008],
              [-23.57168535099993, 73.71649811400005],
              [-23.516753709999932, 73.71067942900004],
              [-23.429066535999937, 73.68838125200006],
              [-23.390370245999918, 73.67194245000007],
              [-23.344105597999942, 73.65818919500003],
              [-23.127064581999946, 73.63226959800005],
              [-22.843129035999937, 73.56077708500004],
              [-22.662220831999946, 73.54865143400008],
              [-22.613392706999946, 73.56256745000007],
              [-22.492746548999946, 73.57241445500006],
              [-22.36750240799995, 73.60736725500004],
              [-22.175038214999915, 73.62787506700005],
              [-22.20885169199994, 73.63263580900008],
              [-22.328236456999946, 73.62612539300005],
              [-22.37490800699993, 73.61481354400007],
              [-22.436390753999945, 73.61481354400007],
              [-22.609730597999942, 73.57306549700007],
              [-22.79946855399993, 73.56761302300004],
              [-22.866566535999937, 73.57941315300008],
              [-22.938791469999956, 73.61774323100008],
              [-23.139881964999915, 73.65570709800005],
              [-23.168812628999945, 73.65574778900003],
              [-23.162587042999917, 73.65574778900003],
              [-23.55296790299991, 73.73574453300006],
              [-23.82607988199993, 73.73773834800005],
              [-23.863840298999946, 73.74408600500004],
              [-23.896880662999934, 73.75519440300008],
              [-24.005116339999915, 73.81232330900008],
              [-24.030425584999932, 73.82001373900005],
              [-24.06004798099991, 73.82025788000004],
              [-24.168527798999946, 73.80255768400008],
              [-24.248402472999942, 73.78042226800005],
              [-24.262115037999934, 73.77871328300006],
              [-24.322417772999927, 73.78359609600005],
              [-24.340565558999913, 73.77871328300006],
              [-24.333363410999937, 73.75291575700004],
              [-24.349720831999946, 73.74249909100007],
              [-24.378651495999918, 73.73749420800004],
              [-24.409535285999937, 73.72776927300004],
              [-24.43346106699994, 73.71161530200004],
              [-24.44749915299991, 73.69574616100005],
              [-24.471587693999936, 73.65574778900003],
              [-24.375396287999934, 73.55955638200004],
              [-24.39753170499995, 73.54637278900003],
              [-24.426136847999942, 73.54096100500004],
              [-24.456857876999948, 73.54144928600005],
              [-24.941517706999946, 73.61249420800004],
              [-24.984771287999934, 73.62848541900007],
              [-24.99518795499995, 73.64520905200004],
              [-24.977691209999932, 73.66608307500007],
              [-24.968739386999914, 73.68520742400005],
              [-24.973784959999932, 73.70233795800004],
              [-24.998605923999946, 73.71723053600005],
              [-25.178212042999917, 73.74974192900004],
              [-25.344634568999936, 73.82086823100008],
              [-25.358754035999937, 73.82233307500007],
              [-25.410145636999914, 73.81956614800004],
              [-25.42056230399993, 73.82046133000006],
              [-25.430287238999938, 73.82367584800005],
              [-25.434722459999932, 73.82819245000007],
              [-25.437855597999942, 73.83413320500006],
              [-25.441477016999954, 73.83917877800008],
              [-25.447621222999942, 73.84137604400007],
              [-25.50536048099991, 73.90778229400007],
              [-25.51866614499994, 73.91583893400008],
              [-25.54255123599995, 73.92304108300004],
              [-25.62173417899993, 73.93695709800005],
              [-25.672474738999938, 73.95644765800006],
              [-25.690663214999915, 73.95746491100005],
              [-25.703928188999953, 73.95563385600008],
              [-25.72093665299991, 73.94940827000005],
              [-25.734852667999917, 73.94025299700007],
              [-25.739084438999953, 73.92951080900008],
              [-25.726307745999918, 73.91828034100007],
              [-25.59007727799991, 73.86684804900005],
              [-25.563384568999936, 73.84552643400008],
              [-25.574574347999942, 73.82709381700005],
              [-25.550892706999946, 73.81122467700004],
              [-25.45848548099991, 73.78611888200004],
              [-25.386708136999914, 73.75519440300008],
              [-25.293527798999946, 73.74428945500006],
              [-25.087961391999954, 73.69672272300005],
              [-25.092274542999917, 73.69009023600006],
              [-25.087228969999956, 73.67291901200008],
              [-25.087961391999954, 73.66266510600008],
              [-25.099273240999935, 73.64862702000005],
              [-25.110218878999945, 73.64313385600008],
              [-25.11156165299991, 73.63715241100005],
              [-25.094146287999934, 73.62164948100008],
              [-25.056630011999914, 73.60162995000007],
              [-25.007435675999943, 73.58657461100006],
              [-24.851185675999943, 73.56704336100006],
              [-24.84284420499995, 73.56488678600005],
              [-24.834584113999938, 73.55548737200007],
              [-24.69204667899993, 73.53156159100007],
              [-24.67959550699993, 73.52464427300004],
              [-24.686675584999932, 73.50869375200006],
              [-24.701649542999917, 73.49754466400003],
              [-24.719105597999942, 73.49249909100007],
              [-25.00566565649993, 73.48301829650006],
              [-25.292225714999915, 73.47353750200006],
              [-25.498890753999945, 73.40253327000005],
              [-25.47996985599991, 73.39569733300004],
              [-25.440785285999937, 73.40204498900005],
              [-25.42373613199993, 73.39508698100008],
              [-25.439808722999942, 73.38385651200008],
              [-25.441477016999954, 73.37164948100008],
              [-25.437570766999954, 73.36098867400005],
              [-25.436756964999915, 73.35415273600006],
              [-25.45262610599991, 73.34577057500007],
              [-25.570871548999946, 73.32697174700007],
              [-25.70494544199994, 73.27220286700003],
              [-25.762562628999945, 73.25983307500007],
              [-25.879505988999938, 73.25531647300005],
              [-25.965402798999946, 73.24188873900005],
              [-26.15062415299991, 73.24087148600006],
              [-26.17723548099991, 73.24799225500004],
              [-26.324940558999913, 73.31631094000005],
              [-26.405995245999918, 73.33954498900005],
              [-26.485707160999937, 73.34731679900005],
              [-26.506662563999953, 73.34369538000004],
              [-26.54405676999994, 73.32933177300004],
              [-26.564564581999946, 73.32623932500007],
              [-26.64366614499994, 73.32514069200005],
              [-26.825550910999937, 73.34267812700006],
              [-27.170765753999945, 73.44562409100007],
              [-27.22960364499994, 73.48822663000004],
              [-27.261708136999914, 73.49701569200005],
              [-27.332386847999942, 73.49811432500007],
              [-27.34715735599991, 73.49457428600005],
              [-27.39753170499995, 73.47085195500006],
              [-27.43382727799991, 73.46417877800008],
              [-27.450103318999936, 73.45722077000005],
              [-27.459055141999954, 73.44354889500005],
              [-27.380970831999946, 73.44741445500006],
              [-27.34121660099993, 73.44310130400004],
              [-27.287464972999942, 73.41071198100008],
              [-27.12877356699994, 73.35419342700004],
              [-26.91710364499994, 73.32623932500007],
              [-26.924549933999913, 73.32623932500007],
              [-26.905873175999943, 73.32444896000004],
              [-26.85570227799991, 73.30634186400005],
              [-26.832386847999942, 73.30385976800005],
              [-26.759429490999935, 73.30634186400005],
              [-26.447255011999914, 73.28034088700008],
              [-26.401600714999915, 73.26349518400008],
              [-26.396962042999917, 73.23802317900004],
              [-26.412912563999953, 73.23289622600004],
              [-26.53661048099991, 73.22772858300004],
              [-26.58193925699993, 73.21698639500005],
              [-26.59752356699994, 73.21035390800006],
              [-26.607818162999934, 73.20278554900005],
              [-26.613636847999942, 73.19301992400005],
              [-26.61546790299991, 73.17938873900005],
              [-26.62450110599991, 73.17487213700008],
              [-26.66710364499994, 73.15957265800006],
              [-26.713368292999917, 73.13471100500004],
              [-26.753895636999914, 73.13532135600008],
              [-26.864409959999932, 73.15151601800005],
              [-26.91551673099991, 73.16640859600005],
              [-26.993519660999937, 73.17426178600005],
              [-27.04434160099993, 73.18622467700004],
              [-27.08934485599991, 73.19037506700005],
              [-27.19823157499991, 73.18219635600008],
              [-27.232411261999914, 73.18964264500005],
              [-27.39981035099993, 73.16254303600005],
              [-27.60415605399993, 73.16657135600008],
              [-27.671131964999915, 73.15916575700004],
              [-27.725900844999956, 73.13442617400005],
              [-27.675607876999948, 73.12262604400007],
              [-27.473378058999913, 73.13328685100004],
              [-27.431752081999946, 73.12693919500003],
              [-27.403553839999915, 73.11066315300008],
              [-27.411284959999932, 73.07977936400005],
              [-27.40379798099991, 73.07294342700004],
              [-27.411284959999932, 73.06610748900005],
              [-27.36620032499991, 73.01284414300005],
              [-27.363758917999917, 73.00348541900007],
              [-27.369618292999917, 72.99103424700007],
              [-27.381743943999936, 72.98305898600006],
              [-27.43846594999991, 72.95685455900008],
              [-27.50739498599995, 72.94708893400008],
              [-27.527902798999946, 72.93642812700006],
              [-27.48306230399993, 72.92568594000005],
              [-27.441395636999914, 72.93671295800004],
              [-27.400786912999934, 72.95449453300006],
              [-27.32762610599991, 72.96832916900007],
              [-27.317534959999932, 72.98159414300005],
              [-27.32184811099995, 73.02924225500004],
              [-27.318918423999946, 73.03823476800005],
              [-27.312123175999943, 73.04804108300004],
              [-27.298207160999937, 73.06305573100008],
              [-27.293365037999934, 73.07416413000004],
              [-27.299712693999936, 73.08246491100005],
              [-27.309396938999953, 73.08954498900005],
              [-27.31432044199994, 73.09715403900003],
              [-27.29784094999991, 73.11416250200006],
              [-27.260121222999942, 73.12718333500004],
              [-27.15029863199993, 73.14752838700008],
              [-26.70653235599991, 73.10211823100008],
              [-26.651682094999956, 73.10321686400005],
              [-26.602121548999946, 73.11798737200007],
              [-26.492543097999942, 73.18280670800004],
              [-26.444488084999932, 73.19668203300006],
              [-25.99901282499991, 73.20258209800005],
              [-25.887277798999946, 73.19086334800005],
              [-25.72061113199993, 73.13812897300005],
              [-25.38658606699994, 73.11102936400005],
              [-25.052561001999948, 73.08392975500004],
              [-25.046864386999914, 73.07542552300004],
              [-25.045399542999917, 73.06415436400005],
              [-25.039540167999917, 73.05247630400004],
              [-25.028553839999915, 73.04486725500004],
              [-24.98428300699993, 73.02578359600005],
              [-25.006459113999938, 72.99774811400005],
              [-25.039418097999942, 72.98550039300005],
              [-25.074940558999913, 72.97695547100005],
              [-25.135609503999945, 72.93976471600007],
              [-25.170806443999936, 72.92975495000007],
              [-25.262196417999917, 72.91889069200005],
              [-25.277943488999938, 72.91376373900005],
              [-25.291900193999936, 72.90696849200003],
              [-25.303944464999915, 72.89858633000006],
              [-25.320708787999934, 72.89301178600005],
              [-25.696156378999945, 72.90273672100005],
              [-25.739857550999943, 72.89630768400008],
              [-25.776275193999936, 72.87811920800004],
              [-25.803334113999938, 72.86029694200005],
              [-25.871571417999917, 72.83087799700007],
              [-25.988677537999934, 72.79682038000004],
              [-26.082630988999938, 72.78241608300004],
              [-26.17764238199993, 72.77802155200004],
              [-26.265980597999942, 72.78558991100005],
              [-26.599964972999942, 72.86237213700008],
              [-26.78278561099995, 72.87213776200008],
              [-27.102691209999932, 72.82599518400008],
              [-27.14907792899993, 72.82575104400007],
              [-27.272084113999938, 72.85911692900004],
              [-27.31737219999991, 72.86322663000004],
              [-27.355946417999917, 72.86066315300008],
              [-27.387562628999945, 72.84638092700004],
              [-27.362660285999937, 72.83315664300005],
              [-27.14952551999994, 72.80418528900003],
              [-27.12254798099991, 72.81232330900008],
              [-27.099964972999942, 72.80914948100008],
              [-26.94444739499994, 72.82892487200007],
              [-26.70030676999994, 72.83250560100004],
              [-26.52765865799995, 72.79262929900005],
              [-26.50096594999991, 72.79364655200004],
              [-26.464588995999918, 72.78929271000004],
              [-26.396962042999917, 72.77130768400008],
              [-26.54043535099993, 72.74652741100005],
              [-26.66950436099995, 72.74070872600004],
              [-26.709828253999945, 72.72748444200005],
              [-26.761382615999935, 72.71743398600006],
              [-26.780588344999956, 72.71670156500005],
              [-26.71971594999991, 72.70408763200004],
              [-26.34947669199994, 72.74494049700007],
              [-26.306996222999942, 72.73037344000005],
              [-26.324045376999948, 72.70970286700003],
              [-26.362172003999945, 72.64842357000003],
              [-26.38809160099993, 72.62738678600005],
              [-26.452951626999948, 72.60004303600005],
              [-26.47956295499995, 72.57953522300005],
              [-26.46898352799991, 72.57697174700007],
              [-26.437611456999946, 72.57953522300005],
              [-26.405873175999943, 72.58681875200006],
              [-26.23306230399993, 72.69090403900003],
              [-26.208322719999956, 72.71332428600005],
              [-26.17764238199993, 72.72589752800008],
              [-26.092925584999932, 72.71572500200006],
              [-25.882557745999918, 72.74103424700007],
              [-25.848540818999936, 72.75731028900003],
              [-25.709706183999913, 72.79450104400007],
              [-25.65184485599991, 72.81976959800005],
              [-25.609445766999954, 72.83148834800005],
              [-25.522775844999956, 72.84023672100005],
              [-25.47642981699994, 72.83368561400005],
              [-25.387928839999915, 72.80512116100005],
              [-25.341542120999918, 72.79857005400004],
              [-25.256214972999942, 72.81118398600006],
              [-25.231312628999945, 72.80609772300005],
              [-25.224680141999954, 72.79913971600007],
              [-25.21275794199994, 72.77850983300004],
              [-25.204009568999936, 72.77130768400008],
              [-25.201893683999913, 72.76536692900004],
              [-25.18659420499995, 72.75942617400005],
              [-25.14940344999991, 72.75202057500007],
              [-25.06749426999994, 72.75202057500007],
              [-25.05142167899993, 72.74860260600008],
              [-25.017933722999942, 72.73379140800006],
              [-24.998890753999945, 72.73037344000005],
              [-24.848378058999913, 72.72410716400003],
              [-24.833648240999935, 72.72044505400004],
              [-24.793120897999927, 72.70302969000005],
              [-24.716786261999914, 72.68642812700006],
              [-24.696888800999943, 72.67572663000004],
              [-24.732533331999946, 72.65729401200008],
              [-24.742665167999917, 72.64663320500006],
              [-24.734730597999942, 72.63129303600005],
              [-24.723988410999937, 72.62152741100005],
              [-24.715321417999917, 72.61139557500007],
              [-24.71385657499991, 72.60187409100007],
              [-24.724232550999943, 72.59381745000007],
              [-24.724232550999943, 72.58698151200008],
              [-24.708363410999937, 72.58771393400008],
              [-24.692128058999913, 72.58490631700005],
              [-24.67682857999995, 72.57973867400005],
              [-24.663400844999956, 72.57330963700008],
              [-24.675607876999948, 72.56037018400008],
              [-24.68195553299995, 72.55548737200007],
              [-24.690052863999938, 72.55219147300005],
              [-24.66828365799995, 72.54462311400005],
              [-24.623768683999913, 72.55621979400007],
              [-24.601307745999918, 72.55219147300005],
              [-24.610178188999953, 72.53266022300005],
              [-24.626210089999915, 72.52602773600006],
              [-24.646962042999917, 72.52399323100008],
              [-24.70254472599993, 72.50751373900005],
              [-24.77139238199993, 72.49787018400008],
              [-24.88735917899993, 72.46845123900005],
              [-25.13231360599991, 72.43618398600006],
              [-25.52102617099993, 72.42934804850006],
              [-25.90973873599995, 72.42251211100006],
              [-25.90973873599995, 72.41567617400005],
              [-25.877512173999946, 72.40794505400004],
              [-25.734852667999917, 72.39179108300004],
              [-25.423573370999918, 72.40558502800008],
              [-25.345529751999948, 72.39545319200005],
              [-25.31387285099993, 72.39516836100006],
              [-25.28892981699994, 72.39057038000004],
              [-25.300770636999914, 72.37392812700006],
              [-25.430043097999942, 72.27484772300005],
              [-25.459095831999946, 72.26068756700005],
              [-25.48851477799991, 72.23871491100005],
              [-25.495838995999918, 72.23065827000005],
              [-25.498890753999945, 72.22016022300005],
              [-25.495472785999937, 72.20400625200006],
              [-25.486927863999938, 72.18891022300005],
              [-25.46475175699993, 72.16242096600007],
              [-25.47809811099995, 72.15143463700008],
              [-25.510365363999938, 72.13739655200004],
              [-25.526193813999953, 72.12763092700004],
              [-25.50731360599991, 72.12376536700003],
              [-25.48338782499991, 72.12482330900008],
              [-25.45848548099991, 72.12909577000005],
              [-25.415679490999935, 72.14130280200004],
              [-25.402821417999917, 72.14862702000005],
              [-25.39679928299995, 72.15912506700005],
              [-25.395822719999956, 72.17544179900005],
              [-25.399566209999932, 72.18744538000004],
              [-25.40566972599993, 72.19403717700004],
              [-25.408680792999917, 72.20184967700004],
              [-25.403187628999945, 72.21702708500004],
              [-25.391428188999953, 72.22870514500005],
              [-25.37682044199994, 72.23810455900008],
              [-25.368519660999937, 72.24876536700003],
              [-25.375355597999942, 72.26422760600008],
              [-25.34361731699994, 72.28485748900005],
              [-25.263295050999943, 72.31903717700004],
              [-25.20811926999994, 72.35639069200005],
              [-25.180978969999956, 72.36538320500006],
              [-25.044667120999918, 72.38287995000007],
              [-25.019683397999927, 72.38153717700004],
              [-25.010487433999913, 72.38816966400003],
              [-24.923451300999943, 72.40200429900005],
              [-24.852284308999913, 72.43203359600005],
              [-24.827870245999918, 72.43618398600006],
              [-24.80565344999991, 72.43170807500007],
              [-24.763050910999937, 72.41254303600005],
              [-24.73818925699993, 72.40818919500003],
              [-24.72484290299991, 72.41014232000003],
              [-24.683257615999935, 72.42251211100006],
              [-24.668853318999936, 72.42243073100008],
              [-24.628651495999918, 72.41567617400005],
              [-24.54637610599991, 72.42340729400007],
              [-24.518788214999915, 72.41567617400005],
              [-24.450510219999956, 72.37067291900007],
              [-24.34203040299991, 72.33173248900005],
              [-24.277902798999946, 72.31915924700007],
              [-24.237619594999956, 72.32632070500006],
              [-24.24559485599991, 72.32884349200003],
              [-24.26549231699994, 72.34052155200004],
              [-24.23379472599993, 72.33673737200007],
              [-24.074818488999938, 72.27777741100005],
              [-24.045806443999936, 72.27167389500005],
              [-23.94322669199994, 72.27098216400003],
              [-23.930531378999945, 72.26886627800008],
              [-23.900461391999954, 72.25918203300006],
              [-23.868885870999918, 72.25592682500007],
              [-23.839100714999915, 72.25800202000005],
              [-23.81663977799991, 72.25360748900005],
              [-23.806792772999927, 72.23065827000005],
              [-23.822621222999942, 72.22724030200004],
              [-23.843373175999943, 72.22703685100004],
              [-23.86278235599991, 72.23029205900008],
              [-23.87450110599991, 72.23688385600008],
              [-23.881418423999946, 72.23261139500005],
              [-23.887521938999953, 72.23045482000003],
              [-23.895008917999917, 72.23065827000005],
              [-23.88434811099995, 72.22134023600006],
              [-23.871815558999913, 72.21743398600006],
              [-23.79442298099991, 72.21702708500004],
              [-23.775949673999946, 72.22264232000003],
              [-23.77953040299991, 72.23688385600008],
              [-23.76121985599991, 72.24445221600007],
              [-23.744536912999934, 72.23680247600004],
              [-23.728179490999935, 72.22431061400005],
              [-23.710682745999918, 72.21702708500004],
              [-23.714833136999914, 72.20718008000006],
              [-23.717518683999913, 72.20335521000004],
              [-23.71125240799995, 72.18195221600007],
              [-23.809071417999917, 72.13475169500003],
              [-23.82054602799991, 72.11395905200004],
              [-23.807484503999945, 72.11066315300008],
              [-23.78970292899993, 72.11273834800005],
              [-23.758412238999938, 72.12079498900005],
              [-23.69172115799995, 72.14842357000003],
              [-23.656605597999942, 72.15497467700004],
              [-23.620269334999932, 72.15643952000005],
              [-23.59398352799991, 72.15184153900003],
              [-23.577870245999918, 72.14720286700003],
              [-23.10838782499991, 72.06683991100005],
              [-23.086822068999936, 72.05878327000005],
              [-23.105824347999942, 72.04067617400005],
              [-23.13540605399993, 72.03168366100005],
              [-23.168080206999946, 72.02602773600006],
              [-23.19668535099993, 72.01776764500005],
              [-23.14281165299991, 72.00067780200004],
              [-23.11432857999995, 71.99579498900005],
              [-23.087228969999956, 72.00104401200008],
              [-23.05968176999994, 72.01117584800005],
              [-23.033599412999934, 72.01434967700004],
              [-23.005686001999948, 72.01113515800006],
              [-22.93268795499995, 71.99266185100004],
              [-22.681385870999918, 71.95831940300008],
              [-22.618519660999937, 71.93602122600004],
              [-22.554351365999935, 71.92487213700008],
              [-22.525135870999918, 71.91535065300008],
              [-22.516061977999925, 71.90924713700008],
              [-22.50340735599991, 71.90078359600005],
              [-22.50340735599991, 71.88947174700007],
              [-22.519154425999943, 71.88084544500003],
              [-22.544911261999914, 71.87445709800005],
              [-22.665272589999915, 71.86107005400004],
              [-22.72874915299991, 71.84516022300005],
              [-22.736805792999917, 71.81976959800005],
              [-22.783314581999946, 71.79140859600005],
              [-22.96198482999995, 71.74896881700005],
              [-23.05996660099993, 71.71210358300004],
              [-23.107818162999934, 71.68577708500004],
              [-23.135324673999946, 71.65534088700008],
              [-23.127797003999945, 71.64789459800005],
              [-23.123199022999927, 71.63190338700008],
              [-23.086659308999913, 71.63043854400007],
              [-23.011708136999914, 71.64105866100005],
              [-22.99087480399993, 71.64712148600006],
              [-22.949208136999914, 71.66469961100006],
              [-22.912180141999954, 71.67267487200007],
              [-22.881703253999945, 71.69196198100008],
              [-22.86742102799991, 71.69627513200004],
              [-22.82803300699993, 71.70099518400008],
              [-22.572621222999942, 71.76772695500006],
              [-22.53189042899993, 71.77138906500005],
              [-22.453928188999953, 71.79376862200007],
              [-22.415760870999918, 71.79653554900005],
              [-22.40843665299991, 71.77138906500005],
              [-22.427113410999937, 71.75324127800008],
              [-22.461822068999936, 71.73554108300004],
              [-22.498931443999936, 71.72211334800005],
              [-22.533558722999942, 71.71417877800008],
              [-22.545074022999927, 71.70140208500004],
              [-22.552479620999918, 71.69627513200004],
              [-22.562245245999918, 71.69367096600007],
              [-22.583322719999956, 71.69065989800004],
              [-22.643869594999956, 71.67544179900005],
              [-22.654855923999946, 71.66836172100005],
              [-22.655506964999915, 71.65058014500005],
              [-22.632476365999935, 71.61054108300004],
              [-22.638050910999937, 71.58982982000003],
              [-22.634429490999935, 71.58136627800008],
              [-22.617014126999948, 71.57420482000003],
              [-22.595529751999948, 71.57412344000005],
              [-22.579741990999935, 71.58641185100004],
              [-22.577504035999937, 71.59735748900005],
              [-22.58145097599993, 71.60431549700007],
              [-22.58975175699993, 71.60748932500007],
              [-22.600209113999938, 71.60687897300005],
              [-22.600209113999938, 71.61310455900008],
              [-22.576242641999954, 71.61554596600007],
              [-22.550933397999927, 71.62107982000003],
              [-22.504302537999934, 71.63792552300004],
              [-22.478993292999917, 71.64105866100005],
              [-22.422352667999917, 71.62653229400007],
              [-22.394154425999943, 71.62738678600005],
              [-22.395863410999937, 71.63117096600007],
              [-22.39671790299991, 71.63418203300006],
              [-22.398182745999918, 71.63715241100005],
              [-22.401600714999915, 71.64105866100005],
              [-22.38418535099993, 71.65810781500005],
              [-22.342274542999917, 71.67035553600005],
              [-22.319650844999956, 71.68203359600005],
              [-22.305083787999934, 71.69721100500004],
              [-22.306019660999937, 71.70624420800004],
              [-22.31041419199994, 71.71503327000005],
              [-22.306019660999937, 71.72980377800008],
              [-22.29434160099993, 71.73505280200004],
              [-22.21442623599995, 71.75649648600006],
              [-22.186838344999956, 71.76015859600005],
              [-22.16038977799991, 71.75726959800005],
              [-22.140980597999942, 71.74347565300008],
              [-22.160511847999942, 71.72235748900005],
              [-22.139149542999917, 71.71637604400007],
              [-21.894520636999914, 71.74347565300008],
              [-21.904449022999927, 71.73554108300004],
              [-21.91502844999991, 71.72996653900003],
              [-21.94172115799995, 71.72296784100007],
              [-21.94684811099995, 71.71100495000007],
              [-21.971058722999942, 71.70514557500007],
              [-22.02489173099991, 71.70311107000003],
              [-21.99010169199994, 71.68878815300008],
              [-22.012928839999915, 71.67470937700006],
              [-22.07876542899993, 71.67072174700007],
              [-22.19054114499994, 71.64862702000005],
              [-22.21666419199994, 71.63483307500007],
              [-22.155181443999936, 71.62055084800005],
              [-22.112538214999915, 71.61928945500006],
              [-22.099964972999942, 71.61310455900008],
              [-22.14830481699994, 71.59015534100007],
              [-22.276112433999913, 71.59617747600004],
              [-22.331857876999948, 71.59145742400005],
              [-22.354359503999945, 71.58661530200004],
              [-22.425445115999935, 71.58641185100004],
              [-22.447865363999938, 71.58104075700004],
              [-22.489898240999935, 71.55768463700008],
              [-22.507435675999943, 71.55223216400003],
              [-22.508371548999946, 71.54425690300008],
              [-22.531320766999954, 71.49701569200005],
              [-22.535308397999927, 71.48480866100005],
              [-22.535755988999938, 71.47467682500007],
              [-22.531402147999927, 71.46454498900005],
              [-22.499338344999956, 71.42593008000006],
              [-22.49315344999991, 71.41225820500006],
              [-22.490345831999946, 71.39398834800005],
              [-22.49282792899993, 71.38621653900003],
              [-22.49828040299991, 71.38239166900007],
              [-22.501576300999943, 71.37775299700007],
              [-22.497792120999918, 71.36733633000006],
              [-22.49010169199994, 71.35968659100007],
              [-22.46312415299991, 71.34682851800005],
              [-22.449370897999927, 71.33934153900003],
              [-22.462513800999943, 71.32562897300005],
              [-22.467600063999953, 71.31834544500003],
              [-22.469878709999932, 71.29840729400007],
              [-22.46593176999994, 71.29881419500003],
              [-22.459095831999946, 71.29385000200006],
              [-22.455230272999927, 71.28774648600006],
              [-22.45995032499991, 71.28473541900007],
              [-22.465443488999938, 71.28237539300005],
              [-22.46983801999994, 71.27667877800008],
              [-22.476714647999927, 71.26430898600006],
              [-22.43858801999994, 71.25690338700008],
              [-22.393299933999913, 71.25682200700004],
              [-22.35537675699993, 71.26984284100007],
              [-22.339507615999935, 71.30182526200008],
              [-22.333607550999943, 71.31989166900007],
              [-22.333973761999914, 71.32916901200008],
              [-22.34325110599991, 71.33319733300004],
              [-22.358021613999938, 71.33624909100007],
              [-22.359934048999946, 71.34349192900004],
              [-22.353260870999918, 71.35712311400005],
              [-22.306019660999937, 71.41510651200008],
              [-22.286000128999945, 71.43085358300004],
              [-22.13239498599995, 71.49091217700004],
              [-22.106800910999937, 71.49701569200005],
              [-22.056019660999937, 71.49689362200007],
              [-22.004383917999917, 71.49017975500004],
              [-21.983143683999913, 71.48187897300005],
              [-21.96190344999991, 71.47028229400007],
              [-21.94131425699993, 71.46352773600006],
              [-21.92178300699993, 71.46971263200004],
              [-21.928212042999917, 71.47874583500004],
              [-21.935658331999946, 71.48655833500004],
              [-21.944691535999937, 71.49274323100008],
              [-21.955922003999945, 71.49701569200005],
              [-21.90135657499991, 71.49005768400008],
              [-21.881459113999938, 71.49323151200008],
              [-21.894520636999914, 71.51752350500004],
              [-21.869862433999913, 71.51422760600008],
              [-21.84170488199993, 71.49091217700004],
              [-21.818755662999934, 71.49017975500004],
              [-21.810699022999927, 71.49624258000006],
              [-21.80577551999994, 71.50556061400005],
              [-21.798817511999914, 71.51410553600005],
              [-21.78465735599991, 71.51752350500004],
              [-21.774159308999913, 71.51463450700004],
              [-21.76463782499991, 71.50800202000005],
              [-21.756459113999938, 71.49925364800004],
              [-21.74986731699994, 71.49017975500004],
              [-21.778065558999913, 71.47601959800005],
              [-21.844593878999945, 71.46165599200003],
              [-21.87401282499991, 71.44863515800006],
              [-21.83657792899993, 71.44098541900007],
              [-21.755604620999918, 71.44916413000004],
              [-21.715728318999936, 71.44236888200004],
              [-21.73778235599991, 71.43480052300004],
              [-21.79596920499995, 71.42772044500003],
              [-21.818755662999934, 71.42877838700008],
              [-21.818755662999934, 71.42133209800005],
              [-21.695668097999942, 71.41648997600004],
              [-21.667958136999914, 71.40143463700008],
              [-21.692250128999945, 71.39850495000007],
              [-21.739857550999943, 71.38373444200005],
              [-21.81358801999994, 71.37596263200004],
              [-21.838612433999913, 71.36981842700004],
              [-21.853505011999914, 71.36050039300005],
              [-21.856190558999913, 71.34861888200004],
              [-21.845692511999914, 71.34625885600008],
              [-21.828724738999938, 71.35024648600006],
              [-21.81200110599991, 71.35712311400005],
              [-21.790394660999937, 71.36273834800005],
              [-21.715728318999936, 71.36050039300005],
              [-21.73033606699994, 71.35297272300005],
              [-21.76121985599991, 71.34491608300004],
              [-21.783680792999917, 71.33014557500007],
              [-21.795399542999917, 71.32514069200005],
              [-21.818755662999934, 71.31891510600008],
              [-21.795643683999913, 71.31952545800004],
              [-21.73005123599995, 71.33319733300004],
              [-21.60651607999995, 71.33319733300004],
              [-21.60651607999995, 71.32575104400007],
              [-21.963368292999917, 71.27045319200005],
              [-21.945423956999946, 71.26434967700004],
              [-21.905873175999943, 71.26239655200004],
              [-21.88768469999991, 71.25747304900005],
              [-21.88768469999991, 71.25063711100006],
              [-21.895334438999953, 71.24941640800006],
              [-21.91502844999991, 71.24380117400005],
              [-21.889515753999945, 71.23696523600006],
              [-21.86237545499995, 71.24038320500006],
              [-21.836659308999913, 71.25141022300005],
              [-21.815663214999915, 71.26740143400008],
              [-21.796498175999943, 71.27114492400005],
              [-21.766835089999915, 71.26512278900003],
              [-21.73851477799991, 71.25446198100008],
              [-21.723215298999946, 71.24380117400005],
              [-21.743031378999945, 71.23810455900008],
              [-21.74986731699994, 71.23700592700004],
              [-21.74986731699994, 71.22947825700004],
              [-21.72569739499994, 71.22870514500005],
              [-21.703114386999914, 71.21873607000003],
              [-21.66112219999991, 71.18854401200008],
              [-21.678944464999915, 71.17413971600007],
              [-21.693714972999942, 71.15253327000005],
              [-21.71279863199993, 71.13788483300004],
              [-21.74364173099991, 71.14419179900005],
              [-21.78652910099993, 71.18016185100004],
              [-21.81086178299995, 71.19358958500004],
              [-21.84666907499991, 71.19537995000007],
              [-21.837269660999937, 71.18195221600007],
              [-21.82518469999991, 71.16941966400003],
              [-21.820383266999954, 71.15790436400005],
              [-21.83307857999995, 71.14760976800005],
              [-21.80223548099991, 71.14606354400007],
              [-21.715728318999936, 71.11969635600008],
              [-21.75104732999995, 71.11029694200005],
              [-22.120757615999935, 71.07672760600008],
              [-22.16152910099993, 71.06769440300008],
              [-22.333363410999937, 71.05947500200006],
              [-22.296050584999932, 71.04157135600008],
              [-21.969878709999932, 71.06565989800004],
              [-21.886341925999943, 71.05687083500004],
              [-21.867176886999914, 71.06565989800004],
              [-21.87401282499991, 71.07245514500005],
              [-21.848866339999915, 71.07465241100005],
              [-21.805531378999945, 71.08397044500003],
              [-21.784982876999948, 71.08612702000005],
              [-21.72647050699993, 71.08478424700007],
              [-21.69684811099995, 71.07892487200007],
              [-21.67479407499991, 71.06565989800004],
              [-21.678456183999913, 71.05609772300005],
              [-21.681019660999937, 71.04319896000004],
              [-21.677072719999956, 71.03115469000005],
              [-21.66112219999991, 71.02411530200004],
              [-21.677845831999946, 71.01740143400008],
              [-21.74364173099991, 71.00421784100007],
              [-21.772368943999936, 70.99803294500003],
              [-21.83307857999995, 70.99530670800004],
              [-21.88817298099991, 70.97907135600008],
              [-21.99010169199994, 70.97626373900005],
              [-21.99010169199994, 70.96881745000007],
              [-21.91502844999991, 70.96259186400005],
              [-21.723947719999956, 70.99274323100008],
              [-21.695301886999914, 70.98309967700004],
              [-21.76671301999994, 70.96084219000005],
              [-21.798654751999948, 70.94472890800006],
              [-21.79210364499994, 70.92788320500006],
              [-21.731800910999937, 70.95526764500005],
              [-21.697255011999914, 70.96259186400005],
              [-21.667958136999914, 70.95579661700003],
              [-21.702748175999943, 70.94212474200003],
              [-21.66710364499994, 70.93797435100004],
              [-21.60024980399993, 70.96478913000004],
              [-21.572417772999927, 70.95579661700003],
              [-21.612172003999945, 70.92942942900004],
              [-21.714833136999914, 70.89061107000003],
              [-21.75731360599991, 70.86640045800004],
              [-21.74705969999991, 70.85871002800008],
              [-21.717600063999953, 70.84271881700005],
              [-21.70616614499994, 70.83974844000005],
              [-21.700428839999915, 70.83641185100004],
              [-21.70693925699993, 70.82929108300004],
              [-21.723215298999946, 70.81801992400005],
              [-21.73546301999994, 70.80438873900005],
              [-21.744292772999927, 70.80027903900003],
              [-21.826934373999904, 70.79889557500007],
              [-21.846058722999942, 70.80174388200004],
              [-21.887277798999946, 70.81329987200007],
              [-21.900746222999942, 70.81244538000004],
              [-21.904367641999954, 70.81329987200007],
              [-21.911000128999945, 70.81366608300004],
              [-21.928618943999936, 70.81244538000004],
              [-21.912831183999913, 70.79633209800005],
              [-21.882435675999943, 70.78530508000006],
              [-21.84870357999995, 70.77903880400004],
              [-21.822824673999946, 70.77704498900005],
              [-21.783314581999946, 70.77871328300006],
              [-21.665842251999948, 70.80223216400003],
              [-21.651600714999915, 70.80267975500004],
              [-21.639149542999917, 70.80060455900008],
              [-21.63377844999991, 70.79507070500006],
              [-21.635894334999932, 70.77948639500005],
              [-21.642241990999935, 70.77423737200007],
              [-21.667958136999914, 70.77081940300008],
              [-21.717681443999936, 70.75267161700003],
              [-21.73350989499994, 70.75039297100005],
              [-21.767730272999927, 70.75096263200004],
              [-21.782582160999937, 70.74701569200005],
              [-21.79210364499994, 70.73602936400005],
              [-21.76862545499995, 70.73720937700006],
              [-21.74551347599993, 70.74176666900007],
              [-21.723378058999913, 70.74339427300004],
              [-21.702748175999943, 70.73602936400005],
              [-21.66624915299991, 70.74730052300004],
              [-21.617746548999946, 70.74355703300006],
              [-21.57249915299991, 70.72939687700006],
              [-21.545725063999953, 70.70937734600005],
              [-21.764149542999917, 70.70937734600005],
              [-21.764149542999917, 70.70258209800005],
              [-21.743519660999937, 70.69684479400007],
              [-21.63044186099995, 70.69135163000004],
              [-21.604400193999936, 70.68504466400003],
              [-21.57921301999994, 70.67462799700007],
              [-21.595855272999927, 70.66836172100005],
              [-21.61510169199994, 70.66657135600008],
              [-21.654286261999914, 70.66779205900008],
              [-21.64907792899993, 70.65839264500005],
              [-21.640614386999914, 70.65159739800004],
              [-21.62018795499995, 70.64052969000005],
              [-21.645659959999932, 70.63369375200006],
              [-21.75731360599991, 70.63369375200006],
              [-21.74909420499995, 70.62913646000004],
              [-21.74437415299991, 70.62466054900005],
              [-21.73741614499994, 70.61318594000005],
              [-21.76276607999995, 70.60512929900005],
              [-21.771148240999935, 70.59007396000004],
              [-21.76085364499994, 70.57807038000004],
              [-21.73005123599995, 70.57904694200005],
              [-21.67882239499994, 70.59634023600006],
              [-21.653187628999945, 70.59931061400005],
              [-21.62018795499995, 70.59271881700005],
              [-21.62018795499995, 70.58527252800008],
              [-21.67479407499991, 70.57160065300008],
              [-21.65103105399993, 70.56346263200004],
              [-21.56554114499994, 70.55853913000004],
              [-21.550404425999943, 70.54669830900008],
              [-21.539906378999945, 70.54291413000004],
              [-21.516346808999913, 70.55312734600005],
              [-21.50182044199994, 70.55312734600005],
              [-21.48741614499994, 70.54987213700008],
              [-21.47679602799991, 70.54486725500004],
              [-21.538238084999932, 70.49705638200004],
              [-21.55728105399993, 70.48680247600004],
              [-21.600493943999936, 70.47016022300005],
              [-21.637521938999953, 70.44525788000004],
              [-21.663726365999935, 70.43553294500003],
              [-21.691477016999954, 70.42999909100007],
              [-21.751698370999918, 70.42694733300004],
              [-21.764149542999917, 70.42820872600004],
              [-21.78864498599995, 70.43545156500005],
              [-21.793080206999946, 70.44037506700005],
              [-21.840687628999945, 70.43235911700003],
              [-21.940052863999938, 70.39032623900005],
              [-21.990386522999927, 70.39744700700004],
              [-21.999826626999948, 70.41136302300004],
              [-21.988352016999954, 70.42609284100007],
              [-21.955922003999945, 70.44871653900003],
              [-21.94440670499995, 70.46283600500004],
              [-21.943714972999942, 70.47036367400005],
              [-21.95262610599991, 70.47565338700008],
              [-22.02285722599993, 70.49949778900003],
              [-22.076283331999946, 70.50189850500004],
              [-22.12954667899993, 70.49323151200008],
              [-22.28416907499991, 70.44627513200004],
              [-22.34137936099995, 70.43891022300005],
              [-22.38117428299995, 70.44871653900003],
              [-22.402007615999935, 70.46527741100005],
              [-22.41588294199994, 70.49725983300004],
              [-22.417713995999918, 70.53412506700005],
              [-22.40843665299991, 70.56537506700005],
              [-22.41588294199994, 70.57160065300008],
              [-22.40843665299991, 70.57904694200005],
              [-22.439930792999917, 70.63922760600008],
              [-22.448394334999932, 70.64618561400005],
              [-22.466542120999918, 70.65753815300008],
              [-22.47252356699994, 70.66510651200008],
              [-22.473011847999942, 70.67023346600007],
              [-22.471180792999917, 70.67597077000005],
              [-22.464955206999946, 70.71161530200004],
              [-22.444691535999937, 70.76894765800006],
              [-22.442534959999932, 70.78449127800008],
              [-22.436390753999945, 70.79389069200005],
              [-22.42918860599991, 70.81118398600006],
              [-22.42528235599991, 70.83051178600005],
              [-22.428863084999932, 70.84593333500004],
              [-22.448557094999956, 70.85455963700008],
              [-22.47915605399993, 70.85541413000004],
              [-22.510243292999917, 70.85150788000004],
              [-22.531320766999954, 70.84593333500004],
              [-22.57290605399993, 70.82542552300004],
              [-22.57843990799995, 70.81854889500005],
              [-22.58226477799991, 70.80532461100006],
              [-22.586008266999954, 70.79877350500004],
              [-22.601185675999943, 70.78172435100004],
              [-22.60806230399993, 70.77000560100004],
              [-22.603993292999917, 70.75893789300005],
              [-22.586008266999954, 70.74355703300006],
              [-22.60065670499995, 70.73602936400005],
              [-22.648589647999927, 70.72304922100005],
              [-22.641184048999946, 70.71556224200003],
              [-22.64801998599995, 70.70709870000007],
              [-22.64830481699994, 70.70172760600008],
              [-22.644276495999918, 70.69733307500007],
              [-22.638050910999937, 70.69204336100006],
              [-22.63467363199993, 70.68406810100004],
              [-22.63890540299991, 70.67755768400008],
              [-22.645334438999953, 70.67137278900003],
              [-22.648589647999927, 70.66437409100007],
              [-22.641102667999917, 70.65021393400008],
              [-22.623605923999946, 70.63934967700004],
              [-22.58975175699993, 70.62311432500007],
              [-22.581369594999956, 70.61343008000006],
              [-22.57363847599993, 70.59979889500005],
              [-22.568186001999948, 70.58494700700004],
              [-22.566070115999935, 70.57160065300008],
              [-22.56973222599993, 70.55768463700008],
              [-22.576893683999913, 70.54775625200006],
              [-22.582020636999914, 70.53774648600006],
              [-22.579741990999935, 70.52383047100005],
              [-22.58779863199993, 70.50983307500007],
              [-22.600412563999953, 70.47553131700005],
              [-22.61074785099993, 70.45954010600008],
              [-22.632557745999918, 70.44546133000006],
              [-22.660878058999913, 70.43846263200004],
              [-23.017201300999943, 70.44037506700005],
              [-23.09715735599991, 70.42633698100008],
              [-23.345448370999918, 70.44057851800005],
              [-23.68272864499994, 70.54486725500004],
              [-23.746449347999942, 70.55320872600004],
              [-23.809396938999953, 70.56899648600006],
              [-23.929798956999946, 70.61318594000005],
              [-24.020863410999937, 70.65875885600008],
              [-24.06627356699994, 70.68968333500004],
              [-24.080555792999917, 70.71556224200003],
              [-24.085764126999948, 70.71507396000004],
              [-24.092640753999945, 70.71792226800005],
              [-24.098500128999945, 70.72386302300004],
              [-24.10106360599991, 70.73297760600008],
              [-24.11237545499995, 70.75177643400008],
              [-24.165679490999935, 70.78750234600005],
              [-24.182972785999937, 70.80499909100007],
              [-24.207508917999917, 70.86131419500003],
              [-24.214955206999946, 70.89834219000005],
              [-24.222727016999954, 70.91449616100005],
              [-24.227853969999956, 70.93162669500003],
              [-24.223988410999937, 70.95579661700003],
              [-24.199289516999954, 70.99579498900005],
              [-24.19562740799995, 71.01227448100008],
              [-24.210926886999914, 71.02777741100005],
              [-24.221913214999915, 71.03579336100006],
              [-24.227691209999932, 71.04352448100008],
              [-24.231760219999956, 71.05133698100008],
              [-24.237619594999956, 71.05947500200006],
              [-24.264881964999915, 71.08136627800008],
              [-24.427479620999918, 71.16400788000004],
              [-24.508290167999917, 71.19025299700007],
              [-24.569650844999956, 71.21771881700005],
              [-24.583322719999956, 71.22833893400008],
              [-24.585316535999937, 71.24241771000004],
              [-24.573394334999932, 71.26430898600006],
              [-24.60057532499991, 71.27008698100008],
              [-24.637196417999917, 71.26923248900005],
              [-24.66942298099991, 71.27195872600004],
              [-24.683257615999935, 71.28851959800005],
              [-24.673817511999914, 71.30093008000006],
              [-24.614979620999918, 71.33934153900003],
              [-24.638010219999956, 71.36176178600005],
              [-24.672027147999927, 71.35700104400007],
              [-24.71007239499994, 71.34186432500007],
              [-24.744984503999945, 71.33319733300004],
              [-24.79991614499994, 71.33319733300004],
              [-24.808705206999946, 71.33063385600008],
              [-24.820423956999946, 71.31781647300005],
              [-24.827870245999918, 71.31268952000005],
              [-24.847727016999954, 71.30731842700004],
              [-24.86978105399993, 71.30491771000004],
              [-24.891468878999945, 71.30638255400004],
              [-24.909820115999935, 71.31268952000005],
              [-24.911854620999918, 71.31732819200005],
              [-24.927723761999914, 71.31903717700004],
              [-24.964466925999943, 71.31891510600008],
              [-24.982045050999943, 71.31679922100005],
              [-25.018422003999945, 71.30735911700003],
              [-25.03612219999991, 71.30524323100008],
              [-25.096058722999942, 71.30483633000006],
              [-25.121978318999936, 71.31150950700004],
              [-25.17218990799995, 71.34707265800006],
              [-25.236073370999918, 71.36273834800005],
              [-25.26549231699994, 71.37417226800005],
              [-25.295643683999913, 71.39988841400003],
              [-25.30768795499995, 71.40766022300005],
              [-25.342518683999913, 71.42438385600008],
              [-25.351714647999927, 71.43219635600008],
              [-25.37726803299995, 71.44578685100004],
              [-25.43846594999991, 71.44936758000006],
              [-25.46157792899993, 71.45917389500005],
              [-25.479725714999915, 71.46967194200005],
              [-25.526600714999915, 71.48338450700004],
              [-25.543527798999946, 71.49359772300005],
              [-25.558420376999948, 71.50800202000005],
              [-25.57559160099993, 71.52041250200006],
              [-25.596302863999938, 71.53058502800008],
              [-25.62173417899993, 71.53864166900007],
              [-25.64159094999991, 71.54165273600006],
              [-25.697743292999917, 71.53864166900007],
              [-25.74364173099991, 71.54572174700007],
              [-25.759510870999918, 71.54547760600008],
              [-25.765777147999927, 71.54987213700008],
              [-25.827788865999935, 71.55849844000005],
              [-25.839670376999948, 71.56321849200003],
              [-25.848866339999915, 71.56818268400008],
              [-25.859730597999942, 71.57172272300005],
              [-25.876210089999915, 71.57217031500005],
              [-25.955067511999914, 71.56500885600008],
              [-25.992909308999913, 71.56696198100008],
              [-26.07603919199994, 71.58637116100005],
              [-26.11278235599991, 71.58486562700006],
              [-26.19090735599991, 71.57217031500005],
              [-26.275502081999946, 71.57050202000005],
              [-26.31944739499994, 71.57831452000005],
              [-26.35260982999995, 71.59666575700004],
              [-26.384103969999956, 71.63222890800006],
              [-26.40147864499994, 71.64248281500005],
              [-26.424305792999917, 71.64105866100005],
              [-26.433583136999914, 71.63715241100005],
              [-26.444650844999956, 71.63092682500007],
              [-26.453846808999913, 71.62384674700007],
              [-26.457834438999953, 71.61684804900005],
              [-26.46865800699993, 71.57587311400005],
              [-26.500355597999942, 71.55971914300005],
              [-26.597645636999914, 71.54743073100008],
              [-26.785145636999914, 71.54653554900005],
              [-26.81468665299991, 71.55849844000005],
              [-26.876698370999918, 71.56659577000005],
              [-26.935617641999954, 71.58079661700003],
              [-27.157948370999918, 71.66836172100005],
              [-27.17528235599991, 71.67975495000007],
              [-27.21198482999995, 71.72296784100007],
              [-27.21239173099991, 71.72752513200004],
              [-27.211048956999946, 71.72898997600004],
              [-27.20449785099993, 71.72980377800008],
              [-27.222727016999954, 71.74506256700005],
              [-27.325917120999918, 71.78050364800004],
              [-27.36424719999991, 71.78270091400003],
              [-27.38239498599995, 71.78636302300004],
              [-27.420521613999938, 71.80385976800005],
              [-27.46434485599991, 71.81049225500004],
              [-27.614613410999937, 71.86692942900004],
              [-27.622222459999932, 71.88117096600007],
              [-27.602365688999953, 71.90167877800008],
              [-27.881743943999936, 71.97882721600007],
              [-27.931385870999918, 72.01048411700003],
              [-27.944162563999953, 72.00527578300006],
              [-27.966053839999915, 71.98362864800004],
              [-27.98460852799991, 71.97736237200007],
              [-28.005197719999956, 71.97532786700003],
              [-28.069203253999945, 71.97736237200007],
              [-28.12368730399993, 71.99046458500004],
              [-28.188384568999936, 71.99725983300004],
              [-28.206288214999915, 71.99795156500005],
              [-28.32921301999994, 72.05255768400008],
              [-28.46007239499994, 72.08173248900005],
              [-28.558338995999918, 72.12348053600005],
              [-28.58690344999991, 72.13153717700004],
              [-28.620269334999932, 72.13446686400005],
              [-28.632801886999914, 72.13100820500006],
              [-28.640004035999937, 72.12299225500004],
              [-28.64517167899993, 72.11395905200004],
              [-28.65135657499991, 72.10781484600005],
              [-28.665272589999915, 72.10309479400007],
              [-28.692982550999943, 72.09821198100008],
              [-28.705962693999936, 72.09349192900004],
              [-28.705962693999936, 72.08608633000006],
              [-28.67414303299995, 72.08100006700005],
              [-28.60728919199994, 72.08881256700005],
              [-28.575550910999937, 72.08295319200005],
              [-28.55500240799995, 72.07640208500004],
              [-28.460113084999932, 72.06244538000004],
              [-28.36042232999995, 72.00714752800008],
              [-28.402495897999927, 71.99066803600005],
              [-28.468739386999914, 71.97833893400008],
              [-28.490223761999914, 71.95941803600005],
              [-28.45693925699993, 71.93939850500004],
              [-28.159372524999924, 71.92371246950006],
              [-27.861805792999917, 71.90802643400008],
              [-27.82408606699994, 71.89728424700007],
              [-27.801625128999945, 71.87445709800005],
              [-27.850209113999938, 71.87909577000005],
              [-27.945912238999938, 71.89874909100007],
              [-27.993397589999915, 71.90167877800008],
              [-28.007964647999927, 71.89716217700004],
              [-28.023996548999946, 71.88784414300005],
              [-28.034087693999936, 71.87856679900005],
              [-28.030913865999935, 71.87445709800005],
              [-27.968006964999915, 71.87116120000007],
              [-27.649688279999936, 71.79498932500007],
              [-27.331369594999956, 71.71881745000007],
              [-27.33385169199994, 71.70892975500004],
              [-27.359364386999914, 71.68537018400008],
              [-27.36705481699994, 71.67548248900005],
              [-27.37262936099995, 71.66575755400004],
              [-27.379261847999942, 71.65648021000004],
              [-27.390736456999946, 71.64789459800005],
              [-27.408029751999948, 71.64248281500005],
              [-27.456206834999932, 71.63987864800004],
              [-27.63267981699994, 71.65249258000006],
              [-27.684925910999937, 71.64789459800005],
              [-27.811024542999917, 71.61200592700004],
              [-27.854359503999945, 71.60687897300005],
              [-27.938099738999938, 71.62661367400005],
              [-27.982899542999917, 71.63084544500003],
              [-28.007069464999915, 71.61310455900008],
              [-27.947661912999934, 71.60691966400003],
              [-27.93195553299995, 71.60004303600005],
              [-27.962269660999937, 71.58942291900007],
              [-28.391224738999938, 71.57217031500005],
              [-28.474273240999935, 71.58539459800005],
              [-28.49364173099991, 71.57953522300005],
              [-28.49128170499995, 71.57721588700008],
              [-28.48814856699994, 71.57538483300004],
              [-28.48778235599991, 71.57217031500005],
              [-28.49364173099991, 71.56590403900003],
              [-28.419911261999914, 71.54975006700005],
              [-28.164011196999923, 71.56006500850006],
              [-27.90811113199993, 71.57037995000007],
              [-27.800119594999956, 71.59585195500006],
              [-27.709828253999945, 71.60187409100007],
              [-27.650786912999934, 71.61310455900008],
              [-27.386667446999923, 71.59263743700006],
              [-27.12254798099991, 71.57217031500005],
              [-27.138295050999943, 71.55581289300005],
              [-27.168690558999913, 71.54425690300008],
              [-27.250803188999953, 71.52826569200005],
              [-27.30654863199993, 71.52631256700005],
              [-27.328602667999917, 71.51752350500004],
              [-27.219593878999945, 71.48139069200005],
              [-27.204741990999935, 71.48212311400005],
              [-27.19831295499995, 71.49359772300005],
              [-27.175526495999918, 71.50926341400003],
              [-27.12401282499991, 71.52094147300005],
              [-27.034413214999915, 71.53119538000004],
              [-26.97948157499991, 71.52920156500005],
              [-26.81468665299991, 71.50385163000004],
              [-26.766224738999938, 71.50600820500006],
              [-26.74160722599993, 71.50397370000007],
              [-26.70571855399993, 71.48407623900005],
              [-26.68708248599995, 71.48159414300005],
              [-26.522328253999945, 71.48891836100006],
              [-26.446888800999943, 71.51007721600007],
              [-26.32127844999991, 71.49701569200005],
              [-26.266102667999917, 71.50910065300008],
              [-26.15611731699994, 71.49017975500004],
              [-26.108265753999945, 71.48948802300004],
              [-26.013295050999943, 71.50315989800004],
              [-25.805043097999942, 71.49066803600005],
              [-25.727365688999953, 71.47443268400008],
              [-25.65648352799991, 71.44236888200004],
              [-25.59211178299995, 71.40306224200003],
              [-25.556019660999937, 71.38694896000004],
              [-25.52245032499991, 71.38031647300005],
              [-25.460113084999932, 71.38198476800005],
              [-25.444203253999945, 71.38031647300005],
              [-25.43586178299995, 71.37470123900005],
              [-25.429676886999914, 71.36615631700005],
              [-25.422230597999942, 71.35805898600006],
              [-25.41006425699993, 71.35366445500006],
              [-25.415679490999935, 71.33820221600007],
              [-25.416900193999936, 71.28473541900007],
              [-25.427113410999937, 71.27366771000004],
              [-25.504505988999938, 71.23554108300004],
              [-25.512521938999953, 71.21588776200008],
              [-25.54405676999994, 71.21600983300004],
              [-25.709095831999946, 71.26121653900003],
              [-25.749379035999937, 71.26471588700008],
              [-25.780018683999913, 71.25747304900005],
              [-25.73924719999991, 71.23578522300005],
              [-25.595082160999937, 71.19537995000007],
              [-25.580799933999913, 71.18854401200008],
              [-25.601918097999942, 71.16958242400005],
              [-25.680246548999946, 71.15623607000003],
              [-25.70799719999991, 71.14419179900005],
              [-25.723500128999945, 71.13532135600008],
              [-25.786854620999918, 71.12710195500006],
              [-25.848133917999917, 71.10846588700008],
              [-25.915272589999915, 71.10114166900007],
              [-25.93691972599993, 71.09495677300004],
              [-25.95811926999994, 71.08612702000005],
              [-25.986887173999946, 71.06903717700004],
              [-26.002064581999946, 71.06220123900005],
              [-26.019886847999942, 71.05947500200006],
              [-26.095326300999943, 71.05947500200006],
              [-26.170480923999946, 71.04515208500004],
              [-26.232533331999946, 71.04515208500004],
              [-26.25304114499994, 71.04124583500004],
              [-26.264149542999917, 71.03485748900005],
              [-26.284047003999945, 71.01410553600005],
              [-26.300770636999914, 71.00665924700007],
              [-26.338490363999938, 71.00531647300005],
              [-26.35570227799991, 71.00047435100004],
              [-26.38817298099991, 70.98578522300005],
              [-26.425607876999948, 70.97455475500004],
              [-26.82835852799991, 70.93528880400004],
              [-27.15420488199993, 70.94961172100005],
              [-27.25291907499991, 70.93528880400004],
              [-27.50617428299995, 70.94212474200003],
              [-27.517689581999946, 70.95624420800004],
              [-27.553293423999946, 70.99445221600007],
              [-27.575062628999945, 71.01105377800008],
              [-27.74046790299991, 71.10297272300005],
              [-27.753163214999915, 71.11347077000005],
              [-27.761463995999918, 71.12718333500004],
              [-27.76504472599993, 71.13800690300008],
              [-27.765736456999946, 71.13894277600008],
              [-27.77135169199994, 71.14671458500004],
              [-27.787953253999945, 71.15444570500006],
              [-27.806385870999918, 71.15656159100007],
              [-27.821197068999936, 71.15228913000004],
              [-27.83462480399993, 71.14581940300008],
              [-27.848784959999932, 71.14077383000006],
              [-27.907460089999915, 71.14032623900005],
              [-27.925119594999956, 71.13397858300004],
              [-27.91234290299991, 71.11546458500004],
              [-27.869862433999913, 71.08917877800008],
              [-27.848784959999932, 71.07245514500005],
              [-27.811879035999937, 71.03595612200007],
              [-27.789662238999938, 71.02252838700008],
              [-27.731800910999937, 71.01398346600007],
              [-27.697987433999913, 71.00511302300004],
              [-27.66559811099995, 70.99213288000004],
              [-27.63776607999995, 70.97626373900005],
              [-27.61815344999991, 70.95380280200004],
              [-27.63573157499991, 70.94399648600006],
              [-27.70539303299995, 70.94212474200003],
              [-27.74242102799991, 70.94696686400005],
              [-27.842600063999953, 70.97626373900005],
              [-27.955799933999913, 70.97626373900005],
              [-27.973459438999953, 70.97943756700005],
              [-28.003081834999932, 70.99359772300005],
              [-28.017241990999935, 70.99677155200004],
              [-28.055043097999942, 70.99477773600006],
              [-28.18301347599993, 70.97431061400005],
              [-28.230213995999918, 70.97626373900005],
              [-28.246693488999938, 70.97943756700005],
              [-28.27692623599995, 70.99359772300005],
              [-28.29133053299995, 70.99677155200004],
              [-28.363636847999942, 70.98997630400004],
              [-28.397613084999932, 70.98126862200007],
              [-28.41112219999991, 70.96881745000007],
              [-28.10700436099995, 70.93927643400008],
              [-28.067738410999937, 70.92243073100008],
              [-28.06163489499994, 70.89435455900008],
              [-28.01475989499994, 70.89325592700004],
              [-28.003651495999918, 70.89777252800008],
              [-27.99364173099991, 70.89911530200004],
              [-27.92088782499991, 70.88129303600005],
              [-27.92088782499991, 70.86806875200006],
              [-27.935699022999927, 70.85248444200005],
              [-27.952463344999956, 70.83974844000005],
              [-27.974232550999943, 70.81671784100007],
              [-27.994211391999954, 70.76544830900008],
              [-28.010487433999913, 70.73981354400007],
              [-28.041574673999946, 70.71238841400003],
              [-28.150461391999954, 70.64793528900003],
              [-28.190174933999913, 70.63324616100005],
              [-28.24014238199993, 70.62677643400008],
              [-28.336048956999946, 70.62620677300004],
              [-28.336048956999946, 70.62002187700006],
              [-28.315297003999945, 70.60858795800004],
              [-28.292632615999935, 70.60248444200005],
              [-28.23981686099995, 70.59951406500005],
              [-28.23981686099995, 70.59271881700005],
              [-28.26585852799991, 70.58710358300004],
              [-28.310292120999918, 70.56386953300006],
              [-28.364125128999945, 70.55536530200004],
              [-28.41665605399993, 70.54124583500004],
              [-28.44522050699993, 70.53807200700004],
              [-28.51821855399993, 70.54047272300005],
              [-28.541493292999917, 70.53807200700004],
              [-28.555409308999913, 70.53318919500003],
              [-28.580799933999913, 70.52020905200004],
              [-28.596424933999913, 70.51764557500007],
              [-28.716175910999937, 70.52383047100005],
              [-29.036000128999945, 70.47972239800004],
              [-29.061879035999937, 70.46605052300004],
              [-29.07648678299995, 70.46295807500007],
              [-29.171538865999935, 70.47089264500005],
              [-29.19863847599993, 70.46865469000005],
              [-29.222482876999948, 70.46161530200004],
              [-29.234120245999918, 70.44806549700007],
              [-29.233143683999913, 70.44570547100005],
              [-29.23350989499994, 70.44183991100005],
              [-29.18740800699993, 70.42767975500004],
              [-29.17955481699994, 70.42137278900003],
              [-29.18187415299991, 70.41254303600005],
              [-29.189808722999942, 70.40704987200007],
              [-29.199330206999946, 70.40192291900007],
              [-29.206206834999932, 70.39411041900007],
              [-29.110585089999915, 70.39411041900007],
              [-29.033273891999954, 70.41225820500006],
              [-29.00422115799995, 70.41453685100004],
              [-28.979359503999945, 70.41990794500003],
              [-28.936390753999945, 70.44334544500003],
              [-28.91169186099995, 70.44871653900003],
              [-28.881662563999953, 70.45132070500006],
              [-28.787912563999953, 70.46979401200008],
              [-28.573597785999937, 70.47443268400008],
              [-28.54210364499994, 70.47890859600005],
              [-28.49364173099991, 70.50482819200005],
              [-28.459543423999946, 70.50714752800008],
              [-28.394357876999948, 70.50332265800006],
              [-28.281361456999946, 70.51072825700004],
              [-28.289214647999927, 70.50214264500005],
              [-28.298939581999946, 70.49721914300005],
              [-28.30996660099993, 70.49555084800005],
              [-28.32168535099993, 70.49705638200004],
              [-28.314930792999917, 70.48541901200008],
              [-28.31041419199994, 70.48090241100005],
              [-28.301258917999917, 70.47662995000007],
              [-28.304839647999927, 70.47186920800004],
              [-28.327870245999918, 70.45221588700008],
              [-28.341908331999946, 70.44391510600008],
              [-28.348784959999932, 70.43398672100005],
              [-28.33942623599995, 70.41795482000003],
              [-28.325103318999936, 70.40704987200007],
              [-28.274566209999932, 70.38349030200004],
              [-28.232899542999917, 70.37201569200005],
              [-28.103260870999918, 70.38719310100004],
              [-28.04133053299995, 70.38483307500007],
              [-27.612456834999932, 70.42076243700006],
              [-27.183583136999914, 70.45669179900005],
              [-27.063791469999956, 70.44216543200008],
              [-26.905588344999956, 70.45457591400003],
              [-26.800119594999956, 70.48012929900005],
              [-26.743316209999932, 70.48411692900004],
              [-26.52920488199993, 70.47418854400007],
              [-26.483754035999937, 70.46161530200004],
              [-26.32127844999991, 70.37978750200006],
              [-26.340199347999942, 70.36823151200008],
              [-26.363392706999946, 70.35980866100005],
              [-26.38768469999991, 70.35480377800008],
              [-26.445871548999946, 70.35146719000005],
              [-26.455962693999936, 70.34540436400005],
              [-26.451568162999934, 70.33197663000004],
              [-26.69863847599993, 70.29043203300006],
              [-26.72451738199993, 70.28929271000004],
              [-26.85374915299991, 70.30101146000004],
              [-26.93504798099991, 70.32611725500004],
              [-26.97179114499994, 70.32868073100008],
              [-27.01903235599991, 70.30744049700007],
              [-27.08161373599995, 70.29783763200004],
              [-27.138661261999914, 70.27191803600005],
              [-27.176177537999934, 70.26365794500003],
              [-27.25682532499991, 70.25739166900007],
              [-27.295074022999927, 70.25006745000007],
              [-27.395130988999938, 70.19867584800005],
              [-27.411284959999932, 70.18488190300008],
              [-27.435292120999918, 70.17601146000004],
              [-27.703521287999934, 70.13544342700004],
              [-27.778472459999932, 70.10846588700008],
              [-27.818714972999942, 70.09894440300008],
              [-27.903960740999935, 70.09243398600006],
              [-28.107899542999917, 70.14370351800005],
              [-28.25413977799991, 70.14524974200003],
              [-28.260894334999932, 70.14020416900007],
              [-28.31541907499991, 70.13564687700006],
              [-28.42487545499995, 70.09320709800005],
              [-28.48005123599995, 70.08559804900005],
              [-28.57371985599991, 70.09967682500007],
              [-28.589914516999954, 70.09243398600006],
              [-28.582386847999942, 70.07538483300004],
              [-28.560292120999918, 70.05971914300005],
              [-28.534087693999936, 70.04816315300008],
              [-28.514149542999917, 70.04401276200008],
              [-28.44522050699993, 70.05145905200004],
              [-28.363352016999954, 70.05145905200004],
              [-28.22679602799991, 70.07135651200008],
              [-28.10265051999994, 70.07135651200008],
              [-28.07998613199993, 70.06391022300005],
              [-28.032582160999937, 70.03148021000004],
              [-27.997670050999943, 70.02228424700007],
              [-27.97687740799995, 70.01349518400008],
              [-27.966053839999915, 70.01048411700003],
              [-27.956288214999915, 70.01040273600006],
              [-27.93195553299995, 70.01675039300005],
              [-27.862660285999937, 70.02118561400005],
              [-27.804066535999937, 70.03900788000004],
              [-27.59471594999991, 70.06049225500004],
              [-27.553334113999938, 70.05971914300005],
              [-27.524159308999913, 70.04775625200006],
              [-27.519602016999954, 70.03754303600005],
              [-27.521229620999918, 70.02586497600004],
              [-27.527902798999946, 70.00307851800005],
              [-27.527740037999934, 69.98981354400007],
              [-27.524769660999937, 69.98167552300004],
              [-27.517933722999942, 69.97597890800006],
              [-27.50617428299995, 69.96954987200007],
              [-27.47362219999991, 69.95978424700007],
              [-27.339914516999954, 69.97113678600005],
              [-27.30968176999994, 69.97772858300004],
              [-27.283680792999917, 69.99201080900008],
              [-27.188384568999936, 70.08901601800005],
              [-27.17992102799991, 70.10293203300006],
              [-27.184478318999936, 70.10956452000005],
              [-27.193470831999946, 70.11538320500006],
              [-27.19831295499995, 70.12661367400005],
              [-27.19277910099993, 70.13743724200003],
              [-27.18272864499994, 70.14557526200008],
              [-27.177113410999937, 70.15444570500006],
              [-27.185292120999918, 70.16754791900007],
              [-27.102894660999937, 70.20331452000005],
              [-27.074818488999938, 70.20848216400003],
              [-27.02843176999994, 70.20160553600005],
              [-27.00499426999994, 70.20066966400003],
              [-26.97915605399993, 70.20848216400003],
              [-26.90965735599991, 70.24872467700004],
              [-26.883615688999953, 70.25690338700008],
              [-26.845448370999918, 70.26080963700008],
              [-26.635243292999917, 70.25092194200005],
              [-26.608631964999915, 70.24384186400005],
              [-26.536447719999956, 70.21222565300008],
              [-26.326161261999914, 70.19830963700008],
              [-26.273182745999918, 70.21222565300008],
              [-26.23574785099993, 70.22662995000007],
              [-25.982411261999914, 70.27781810100004],
              [-25.905913865999935, 70.30744049700007],
              [-25.466053839999915, 70.37933991100005],
              [-25.436838344999956, 70.39126211100006],
              [-25.360178188999953, 70.39911530200004],
              [-25.305287238999938, 70.41323476800005],
              [-25.24762936099995, 70.41347890800006],
              [-25.213246222999942, 70.40884023600006],
              [-25.203521287999934, 70.39834219000005],
              [-25.238758917999917, 70.37978750200006],
              [-25.276275193999936, 70.37348053600005],
              [-25.359527147999927, 70.37164948100008],
              [-25.395822719999956, 70.35932038000004],
              [-25.27293860599991, 70.35932038000004],
              [-25.28734290299991, 70.35126373900005],
              [-25.32640540299991, 70.33795807500007],
              [-25.334380662999934, 70.32855866100005],
              [-25.339100714999915, 70.32518138200004],
              [-25.348255988999938, 70.31443919500003],
              [-25.35496985599991, 70.30316803600005],
              [-25.34398352799991, 70.28701406500005],
              [-25.341175910999937, 70.28424713700008],
              [-25.33267167899993, 70.27993398600006],
              [-25.324940558999913, 70.27826569200005],
              [-25.23501542899993, 70.27732982000003],
              [-25.219309048999946, 70.27985260600008],
              [-25.211781378999945, 70.28632233300004],
              [-25.206654425999943, 70.29511139500005],
              [-25.197824673999946, 70.30467357000003],
              [-25.18382727799991, 70.31317780200004],
              [-25.058705206999946, 70.36139557500007],
              [-25.03270423099991, 70.36676666900007],
              [-25.000884568999936, 70.36562734600005],
              [-24.96003170499995, 70.35789622600004],
              [-24.92479407499991, 70.34511953300006],
              [-24.909820115999935, 70.32855866100005],
              [-24.90721594999991, 70.31557851800005],
              [-24.89989173099991, 70.30540599200003],
              [-24.88890540299991, 70.29913971600007],
              [-24.875070766999954, 70.29783763200004],
              [-24.862049933999913, 70.30149974200003],
              [-24.85924231699994, 70.30707428600005],
              [-24.859445766999954, 70.31321849200003],
              [-24.855213995999918, 70.31834544500003],
              [-24.819243943999936, 70.32465241100005],
              [-24.783802863999938, 70.31659577000005],
              [-24.74795488199993, 70.30426666900007],
              [-24.679066535999937, 70.29189687700006],
              [-24.61241614499994, 70.26959870000007],
              [-24.587635870999918, 70.26992422100005],
              [-24.57022050699993, 70.26129791900007],
              [-24.48468990799995, 70.24701569200005],
              [-24.47752844999991, 70.24079010600008],
              [-24.474720831999946, 70.23297760600008],
              [-24.47370357999995, 70.22601959800005],
              [-24.471587693999936, 70.22211334800005],
              [-24.462635870999918, 70.22036367400005],
              [-24.429758266999954, 70.22211334800005],
              [-24.21776282499991, 70.20848216400003],
              [-24.178212042999917, 70.19717031500005],
              [-24.034331834999932, 70.18512604400007],
              [-24.015736456999946, 70.17804596600007],
              [-24.001332160999937, 70.16657135600008],
              [-23.986439581999946, 70.15912506700005],
              [-23.967925584999932, 70.15509674700007],
              [-23.923085089999915, 70.15277741100005],
              [-23.911447719999956, 70.14935944200005],
              [-23.89366614499994, 70.13922760600008],
              [-23.863352016999954, 70.13373444200005],
              [-23.79710852799991, 70.15058014500005],
              [-23.758697068999936, 70.14362213700008],
              [-23.73460852799991, 70.13641998900005],
              [-23.65225175699993, 70.13397858300004],
              [-23.62999426999994, 70.13092682500007],
              [-23.583607550999943, 70.11676666900007],
              [-23.559803839999915, 70.11286041900007],
              [-23.163753492999927, 70.11359284066674],
              [-22.767703145999935, 70.11432526233341],
              [-22.371652798999946, 70.11505768400008],
              [-22.34406490799995, 70.12445709800005],
              [-22.289051886999914, 70.13080475500004],
              [-22.21007239499994, 70.14960358300004],
              [-22.109730597999942, 70.15521881700005],
              [-22.096506313999953, 70.15045807500007],
              [-22.080962693999936, 70.13849518400008],
              [-22.07713782499991, 70.13031647300005],
              [-22.08975175699993, 70.12661367400005],
              [-22.106800910999937, 70.11839427300004],
              [-22.153065558999913, 70.08148834800005],
              [-22.161447719999956, 70.07135651200008],
              [-22.243397589999915, 70.03717682500007],
              [-22.296131964999915, 70.00128815300008],
              [-22.336496548999946, 69.99087148600006],
              [-22.380034959999932, 69.97125885600008],
              [-22.401275193999936, 69.97260163000004],
              [-22.41429602799991, 69.98314036700003],
              [-22.420806443999936, 69.99567291900007],
              [-22.42870032499991, 70.00608958500004],
              [-22.44595292899993, 70.01048411700003],
              [-22.466053839999915, 70.01288483300004],
              [-22.47370357999995, 70.01007721600007],
              [-22.476714647999927, 69.99966054900005],
              [-22.478179490999935, 69.98871491100005],
              [-22.482899542999917, 69.98126862200007],
              [-22.491444464999915, 69.97703685100004],
              [-22.504302537999934, 69.97573476800005],
              [-22.54906165299991, 69.97797272300005],
              [-22.56163489499994, 69.96967194200005],
              [-22.566070115999935, 69.94529857000003],
              [-22.582386847999942, 69.93891022300005],
              [-22.73656165299991, 69.94676341400003],
              [-22.76073157499991, 69.94220612200007],
              [-22.77839107999995, 69.92792389500005],
              [-22.79946855399993, 69.93475983300004],
              [-22.79710852799991, 69.94293854400007],
              [-22.79246985599991, 69.94847239800004],
              [-22.78612219999991, 69.95233795800004],
              [-22.77839107999995, 69.95526764500005],
              [-22.80418860599991, 69.95514557500007],
              [-22.854807094999956, 69.96312083500004],
              [-22.881337042999917, 69.96271393400008],
              [-22.895415818999936, 69.95888906500005],
              [-22.91112219999991, 69.95164622600004],
              [-22.923939581999946, 69.94212474200003],
              [-22.92918860599991, 69.93134186400005],
              [-22.915760870999918, 69.91689687700006],
              [-22.884755011999914, 69.91022370000007],
              [-22.79637610599991, 69.90424225500004],
              [-22.779449022999927, 69.90021393400008],
              [-22.771555141999954, 69.89378489800004],
              [-22.776112433999913, 69.89057038000004],
              [-22.80573482999995, 69.87954336100006],
              [-22.828928188999953, 69.88882070500006],
              [-22.91559811099995, 69.89378489800004],
              [-22.93468176999994, 69.90037669500003],
              [-22.970814581999946, 69.92792389500005],
              [-23.006214972999942, 69.94261302300004],
              [-23.038441535999937, 69.94464752800008],
              [-23.067616339999915, 69.93642812700006],
              [-23.09361731699994, 69.92047760600008],
              [-23.04515540299991, 69.89378489800004],
              [-23.038441535999937, 69.88324616100005],
              [-23.04674231699994, 69.87360260600008],
              [-23.066395636999914, 69.87107982000003],
              [-23.196888800999943, 69.88056061400005],
              [-23.24132239499994, 69.87763092700004],
              [-23.278675910999937, 69.85968659100007],
              [-23.26789303299995, 69.85883209800005],
              [-23.248036261999914, 69.85394928600005],
              [-22.975941535999937, 69.84113190300008],
              [-22.932850714999915, 69.82217031500005],
              [-22.91783606699994, 69.81928131700005],
              [-22.909494594999956, 69.81342194200005],
              [-22.91559811099995, 69.79759349200003],
              [-22.924387173999946, 69.79100169500003],
              [-22.998850063999953, 69.76561107000003],
              [-23.032582160999937, 69.76170482000003],
              [-23.10728919199994, 69.77024974200003],
              [-23.17760169199994, 69.78839752800008],
              [-23.208973761999914, 69.80267975500004],
              [-23.26130123599995, 69.84048086100006],
              [-23.296701626999948, 69.85439687700006],
              [-23.334339972999942, 69.86151764500005],
              [-23.368031378999945, 69.85968659100007],
              [-23.389271613999938, 69.85260651200008],
              [-23.38780676999994, 69.84821198100008],
              [-23.37205969999991, 69.84601471600007],
              [-23.35065670499995, 69.84540436400005],
              [-23.336659308999913, 69.84223053600005],
              [-23.318023240999935, 69.82807038000004],
              [-23.291493292999917, 69.81586334800005],
              [-23.271595831999946, 69.79547760600008],
              [-23.256214972999942, 69.77456289300005],
              [-23.251332160999937, 69.76341380400004],
              [-23.243804490999935, 69.75348541900007],
              [-23.251779751999948, 69.75185781500005],
              [-23.347767706999946, 69.76211172100005],
              [-23.407541469999956, 69.75006745000007],
              [-23.631581183999913, 69.73265208500004],
              [-23.929798956999946, 69.75600820500006],
              [-23.909535285999937, 69.74575429900005],
              [-23.70303300699993, 69.71808502800008],
              [-23.68077551999994, 69.70669179900005],
              [-23.66319739499994, 69.69025299700007],
              [-23.656076626999948, 69.67096588700008],
              [-23.64712480399993, 69.65668366100005],
              [-23.62604732999995, 69.64557526200008],
              [-23.579701300999943, 69.63312409100007],
              [-23.579701300999943, 69.62628815300008],
              [-23.61856035099993, 69.61798737200007],
              [-23.693714972999942, 69.61432526200008],
              [-23.73110917899993, 69.60578034100007],
              [-23.73110917899993, 69.59955475500004],
              [-23.650380011999914, 69.59886302300004],
              [-23.621245897999927, 69.59210846600007],
              [-23.646880662999934, 69.56427643400008],
              [-23.68968665299991, 69.54653554900005],
              [-23.814198370999918, 69.51227448100008],
              [-23.937855597999942, 69.53538646000004],
              [-23.94790605399993, 69.54718659100007],
              [-23.953968878999945, 69.56244538000004],
              [-23.96385657499991, 69.57786692900004],
              [-23.98338782499991, 69.59080638200004],
              [-24.00340735599991, 69.59418366100005],
              [-24.01903235599991, 69.58690013200004],
              [-24.02529863199993, 69.56793854400007],
              [-24.037464972999942, 69.55857982000003],
              [-24.065052863999938, 69.55780670800004],
              [-24.25877844999991, 69.58535390800006],
              [-24.30801347599993, 69.60175202000005],
              [-24.333811001999948, 69.60602448100008],
              [-24.35488847599993, 69.59955475500004],
              [-24.20807857999995, 69.55402252800008],
              [-24.14354407499991, 69.55170319200005],
              [-24.11473548099991, 69.54433828300006],
              [-24.098784959999932, 69.53351471600007],
              [-24.085682745999918, 69.51870351800005],
              [-24.076893683999913, 69.50210195500006],
              [-24.07371985599991, 69.48602936400005],
              [-24.083607550999943, 69.47455475500004],
              [-24.107045050999943, 69.47223541900007],
              [-24.15566972599993, 69.47606028900003],
              [-24.147816535999937, 69.46369049700007],
              [-24.14289303299995, 69.45888906500005],
              [-24.135161912999934, 69.45433177300004],
              [-24.14952551999994, 69.44814687700006],
              [-24.14952551999994, 69.44135163000004],
              [-24.135365363999938, 69.43891022300005],
              [-24.10838782499991, 69.43073151200008],
              [-24.094227667999917, 69.42829010600008],
              [-24.108713344999956, 69.41722239800004],
              [-24.133208787999934, 69.41746653900003],
              [-24.258168097999942, 69.44228750200006],
              [-24.26549231699994, 69.44814687700006],
              [-24.34284420499995, 69.44253164300005],
              [-24.367909308999913, 69.44814687700006],
              [-24.341949022999927, 69.43496328300006],
              [-24.346262173999946, 69.41811758000006],
              [-24.366525844999956, 69.40070221600007],
              [-24.418080206999946, 69.36994049700007],
              [-24.44831295499995, 69.36212799700007],
              [-24.47960364499994, 69.36302317900004],
              [-24.512562628999945, 69.37299225500004],
              [-24.512562628999945, 69.37986888200004],
              [-24.471587693999936, 69.38605377800008],
              [-24.49132239499994, 69.39166901200008],
              [-24.580881313999953, 69.38605377800008],
              [-24.661284959999932, 69.39960358300004],
              [-24.683257615999935, 69.40778229400007],
              [-24.68781490799995, 69.41229889500005],
              [-24.696441209999932, 69.43040599200003],
              [-24.707508917999917, 69.43451569200005],
              [-24.73501542899993, 69.43366120000007],
              [-24.74209550699993, 69.42975495000007],
              [-24.73851477799991, 69.42084381700005],
              [-24.74445553299995, 69.41486237200007],
              [-24.746652798999946, 69.41136302300004],
              [-24.74986731699994, 69.40924713700008],
              [-24.758941209999932, 69.40778229400007],
              [-24.75153561099995, 69.40033600500004],
              [-24.715687628999945, 69.38296133000006],
              [-24.676380988999938, 69.37250397300005],
              [-24.642404751999948, 69.35561758000006],
              [-24.614979620999918, 69.31842682500007],
              [-24.630686001999948, 69.31854889500005],
              [-24.66828365799995, 69.31293366100005],
              [-24.702463344999956, 69.30239492400005],
              [-24.745472785999937, 69.30158112200007],
              [-24.76585852799991, 69.29791901200008],
              [-24.76585852799991, 69.29047272300005],
              [-24.736073370999918, 69.28481679900005],
              [-24.64907792899993, 69.29047272300005],
              [-24.627064581999946, 69.28717682500007],
              [-24.61510169199994, 69.28009674700007],
              [-24.616851365999935, 69.26959870000007],
              [-24.636097785999937, 69.25633372600004],
              [-24.675526495999918, 69.24461497600004],
              [-24.814198370999918, 69.24266185100004],
              [-24.814198370999918, 69.24949778900003],
              [-24.806467251999948, 69.25071849200003],
              [-24.80215410099993, 69.25238678600005],
              [-24.79869544199994, 69.25429922100005],
              [-24.793120897999927, 69.25633372600004],
              [-24.793120897999927, 69.26312897300005],
              [-24.817128058999913, 69.26080963700008],
              [-24.907093878999945, 69.26634349200003],
              [-24.950103318999936, 69.28046295800004],
              [-25.074940558999913, 69.30109284100007],
              [-25.101633266999954, 69.29791901200008],
              [-25.101633266999954, 69.30414459800005],
              [-25.117339647999927, 69.29661692900004],
              [-25.19098873599995, 69.28367747600004],
              [-25.209584113999938, 69.27545807500007],
              [-25.214833136999914, 69.27020905200004],
              [-25.209868943999936, 69.26312897300005],
              [-25.197824673999946, 69.24949778900003],
              [-25.258534308999913, 69.25275299700007],
              [-25.27293860599991, 69.24949778900003],
              [-25.280913865999935, 69.23761627800008],
              [-25.26984615799995, 69.23159414300005],
              [-25.066802537999934, 69.22907135600008],
              [-25.074330206999946, 69.22907135600008],
              [-25.02285722599993, 69.22504303600005],
              [-24.99941972599993, 69.21662018400008],
              [-24.98428300699993, 69.20111725500004],
              [-24.992746548999946, 69.19403717700004],
              [-24.99718176999994, 69.18598053600005],
              [-24.99705969999991, 69.17698802300004],
              [-24.99176998599995, 69.16693756700005],
              [-25.02135169199994, 69.16022370000007],
              [-25.087961391999954, 69.15729401200008],
              [-25.11587480399993, 69.14712148600006],
              [-25.09919186099995, 69.14081452000005],
              [-25.079457160999937, 69.13580963700008],
              [-25.05882727799991, 69.13279857000003],
              [-25.039540167999917, 69.13279857000003],
              [-25.07754472599993, 69.10984935100004],
              [-25.14439856699994, 69.11005280200004],
              [-25.21198482999995, 69.12327708500004],
              [-25.252430792999917, 69.13963450700004],
              [-25.250599738999938, 69.14581940300008],
              [-25.257069464999915, 69.14549388200004],
              [-25.279774542999917, 69.13963450700004],
              [-25.32754472599993, 69.13279857000003],
              [-25.293446417999917, 69.11640045800004],
              [-25.24242102799991, 69.07868073100008],
              [-25.211415167999917, 69.06460195500006],
              [-25.22402910099993, 69.04596588700008],
              [-25.24132239499994, 69.03815338700008],
              [-25.293446417999917, 69.03725820500006],
              [-25.293446417999917, 69.02977122600004],
              [-25.285959438999953, 69.02977122600004],
              [-25.285959438999953, 69.02362702000005],
              [-25.318959113999938, 69.02692291900007],
              [-25.35448157499991, 69.03827545800004],
              [-25.37132727799991, 69.05247630400004],
              [-25.34862219999991, 69.06460195500006],
              [-25.47996985599991, 69.06509023600006],
              [-25.58820553299995, 69.09674713700008],
              [-25.619252081999946, 69.09967682500007],
              [-25.65648352799991, 69.09186432500007],
              [-25.55378170499995, 69.04718659100007],
              [-25.54824785099993, 69.03327057500007],
              [-25.581654425999943, 69.02179596600007],
              [-25.65648352799991, 69.00934479400007],
              [-25.617298956999946, 68.99872467700004],
              [-25.498890753999945, 69.00311920800004],
              [-25.463734503999945, 68.99461497600004],
              [-25.445057745999918, 68.98078034100007],
              [-25.449818488999938, 68.96792226800005],
              [-25.485218878999945, 68.96214427300004],
              [-25.636057094999956, 68.96832916900007],
              [-25.701527472999942, 68.96214427300004],
              [-25.70262610599991, 68.95840078300006],
              [-25.71231035099993, 68.94037506700005],
              [-25.717925584999932, 68.93423086100006],
              [-25.688303188999953, 68.92641836100006],
              [-25.598459438999953, 68.92112864800004],
              [-25.578236456999946, 68.91498444200005],
              [-25.588286912999934, 68.90094635600008],
              [-25.625477667999917, 68.87588125200006],
              [-25.667713995999918, 68.87042877800008],
              [-25.789214647999927, 68.88857656500005],
              [-25.82095292899993, 68.87274811400005],
              [-25.77257239499994, 68.85846588700008],
              [-25.78416907499991, 68.85529205900008],
              [-25.80890865799995, 68.85248444200005],
              [-25.820668097999942, 68.84886302300004],
              [-25.833241339999915, 68.84723541900007],
              [-25.846831834999932, 68.84788646000004],
              [-25.85260982999995, 68.84650299700007],
              [-25.841460740999935, 68.83860911700003],
              [-25.841460740999935, 68.83120351800005],
              [-25.944488084999932, 68.79022858300004],
              [-26.06590735599991, 68.78115469000005],
              [-26.091908331999946, 68.78709544500003],
              [-26.11082923099991, 68.79360586100006],
              [-26.15721594999991, 68.78538646000004],
              [-26.17723548099991, 68.78709544500003],
              [-26.192982550999943, 68.79120514500005],
              [-26.235218878999945, 68.79262929900005],
              [-26.252349412999934, 68.79022858300004],
              [-26.26235917899993, 68.78742096600007],
              [-26.269357876999948, 68.78449127800008],
              [-26.284047003999945, 68.77342357000003],
              [-26.289418097999942, 68.76508209800005],
              [-26.285755988999938, 68.75877513200004],
              [-26.278553839999915, 68.75364817900004],
              [-26.273426886999914, 68.74860260600008],
              [-26.267567511999914, 68.74412669500003],
              [-26.259022589999915, 68.74274323100008],
              [-26.252430792999917, 68.73944733300004],
              [-26.252349412999934, 68.72939687700006],
              [-26.25804602799991, 68.72418854400007],
              [-26.268381313999953, 68.72166575700004],
              [-26.279449022999927, 68.72125885600008],
              [-26.287709113999938, 68.72199127800008],
              [-26.287709113999938, 68.71507396000004],
              [-26.265980597999942, 68.71507396000004],
              [-26.28538977799991, 68.69554271000004],
              [-26.325550910999937, 68.67914459800005],
              [-26.416737433999913, 68.65892161700003],
              [-26.45140540299991, 68.65827057500007],
              [-26.465240037999934, 68.66046784100007],
              [-26.477040167999917, 68.66596100500004],
              [-26.495716925999943, 68.67841217700004],
              [-26.506214972999942, 68.68097565300008],
              [-26.535552537999934, 68.67934804900005],
              [-26.605458136999914, 68.65741608300004],
              [-26.643381313999953, 68.65302155200004],
              [-26.67723548099991, 68.65680573100008],
              [-26.706654425999943, 68.66592031500005],
              [-26.71637936099995, 68.68060944200005],
              [-26.691151495999918, 68.70140208500004],
              [-26.743804490999935, 68.70522695500006],
              [-26.844349738999938, 68.63739655200004],
              [-26.916411912999934, 68.65322500200006],
              [-26.955067511999914, 68.64716217700004],
              [-26.992665167999917, 68.63637929900005],
              [-27.01276607999995, 68.62571849200003],
              [-27.013335740999935, 68.61644114800004],
              [-27.006743943999936, 68.59564850500004],
              [-27.00963294199994, 68.59153880400004],
              [-27.022287563999953, 68.58954498900005],
              [-27.04718990799995, 68.58055247600004],
              [-27.05760657499991, 68.57904694200005],
              [-27.141957160999937, 68.59186432500007],
              [-27.161040818999936, 68.60150788000004],
              [-27.182240363999938, 68.60932038000004],
              [-27.248402472999942, 68.60516998900005],
              [-27.296254035999937, 68.61212799700007],
              [-27.32408606699994, 68.60968659100007],
              [-27.33698482999995, 68.60077545800004],
              [-27.31432044199994, 68.58478424700007],
              [-27.259836391999954, 68.57103099200003],
              [-27.23379472599993, 68.56102122600004],
              [-27.218739386999914, 68.54376862200007],
              [-27.237904425999943, 68.53961823100008],
              [-27.276519334999932, 68.54393138200004],
              [-27.314442511999914, 68.53510163000004],
              [-27.45571855399993, 68.53912995000007],
              [-27.527902798999946, 68.55068594000005],
              [-27.527902798999946, 68.55744049700007],
              [-27.516224738999938, 68.56122467700004],
              [-27.495757615999935, 68.57160065300008],
              [-27.486317511999914, 68.57855866100005],
              [-27.582183397999927, 68.57855866100005],
              [-27.609201626999948, 68.56891510600008],
              [-27.63267981699994, 68.54970937700006],
              [-27.658314581999946, 68.53534577000005],
              [-27.722727016999954, 68.54425690300008],
              [-27.749663865999935, 68.53506094000005],
              [-27.756337042999917, 68.52228424700007],
              [-27.602365688999953, 68.49542877800008],
              [-27.630930141999954, 68.48061758000006],
              [-27.742583787999934, 68.47752513200004],
              [-27.78111731699994, 68.46869538000004],
              [-27.810373501999948, 68.47939687700006],
              [-27.884429490999935, 68.49506256700005],
              [-27.914540167999917, 68.51276276200008],
              [-27.928863084999932, 68.53534577000005],
              [-27.93541419199994, 68.55512116100005],
              [-27.948068813999953, 68.56830475500004],
              [-27.98033606699994, 68.57111237200007],
              [-28.022206183999913, 68.56289297100005],
              [-28.024322068999936, 68.54938385600008],
              [-28.01549231699994, 68.53050364800004],
              [-28.024159308999913, 68.50629303600005],
              [-28.02440344999991, 68.49628327000005],
              [-28.007069464999915, 68.47101471600007],
              [-28.010487433999913, 68.45783112200007],
              [-28.022206183999913, 68.45457591400003],
              [-28.035552537999934, 68.46039459800005],
              [-28.054839647999927, 68.47492096600007],
              [-28.069203253999945, 68.46503327000005],
              [-28.07998613199993, 68.45327383000006],
              [-28.091908331999946, 68.44375234600005],
              [-28.109486456999946, 68.44082265800006],
              [-28.124623175999943, 68.44513580900008],
              [-28.16905676999994, 68.46430084800005],
              [-28.22057044199994, 68.49355703300006],
              [-28.265288865999935, 68.50096263200004],
              [-28.35651607999995, 68.50287506700005],
              [-28.344593878999945, 68.49579498900005],
              [-28.31159420499995, 68.48834870000007],
              [-28.29442298099991, 68.48236725500004],
              [-28.282948370999918, 68.47455475500004],
              [-28.25348873599995, 68.44757721600007],
              [-28.25348873599995, 68.44082265800006],
              [-28.294748501999948, 68.42621491100005],
              [-28.44522050699993, 68.44757721600007],
              [-28.507923956999946, 68.44757721600007],
              [-28.494984503999945, 68.42275625200006],
              [-28.506581183999913, 68.41266510600008],
              [-28.529042120999918, 68.41156647300005],
              [-28.548898891999954, 68.41347890800006],
              [-28.576730923999946, 68.41282786700003],
              [-28.59707597599993, 68.40656159100007],
              [-28.615386522999927, 68.39862702000005],
              [-28.637074347999942, 68.39301178600005],
              [-28.637074347999942, 68.38556549700007],
              [-28.62999426999994, 68.38422272300005],
              [-28.61742102799991, 68.38019440300008],
              [-28.609730597999942, 68.37929922100005],
              [-28.631337042999917, 68.36273834800005],
              [-28.66315670499995, 68.36163971600007],
              [-28.791574673999946, 68.38056061400005],
              [-28.822255011999914, 68.38117096600007],
              [-28.843129035999937, 68.37250397300005],
              [-28.848540818999936, 68.35342031500005],
              [-28.85187740799995, 68.32855866100005],
              [-28.949940558999913, 68.35976797100005],
              [-28.98033606699994, 68.36249420800004],
              [-28.980295376999948, 68.34454987200007],
              [-29.006662563999953, 68.34760163000004],
              [-29.108713344999956, 68.38035716400003],
              [-29.127430792999917, 68.39077383000006],
              [-29.14793860599991, 68.39883047100005],
              [-29.17210852799991, 68.39980703300006],
              [-29.192697719999956, 68.39248281500005],
              [-29.20075436099995, 68.38031647300005],
              [-29.19640051999994, 68.36579010600008],
              [-29.17955481699994, 68.35138580900008],
              [-29.15420488199993, 68.34218984600005],
              [-29.130238410999937, 68.33808014500005],
              [-29.110218878999945, 68.33047109600005],
              [-29.096994594999956, 68.31037018400008],
              [-29.13825436099995, 68.27952708500004],
              [-29.162261522999927, 68.26748281500005],
              [-29.189116990999935, 68.26264069200005],
              [-29.207590298999946, 68.27220286700003],
              [-29.276234503999945, 68.32050202000005],
              [-29.281971808999913, 68.32404205900008],
              [-29.293568488999938, 68.31806061400005],
              [-29.329701300999943, 68.30955638200004],
              [-29.336537238999938, 68.30418528900003],
              [-29.34316972599993, 68.29197825700004],
              [-29.346099412999934, 68.26162344000005],
              [-29.357045050999943, 68.24957916900007],
              [-29.386463995999918, 68.24689362200007],
              [-29.44790605399993, 68.26337311400005],
              [-29.473784959999932, 68.24957916900007],
              [-29.448109503999945, 68.23908112200007],
              [-29.39517167899993, 68.22426992400005],
              [-29.377552863999938, 68.20799388200004],
              [-29.377552863999938, 68.20115794500003],
              [-29.40729732999995, 68.21198151200008],
              [-29.442982550999943, 68.21816640800006],
              [-29.51130123599995, 68.22166575700004],
              [-29.525746222999942, 68.22435130400004],
              [-29.576771613999938, 68.24213288000004],
              [-29.611480272999927, 68.24835846600007],
              [-29.625884568999936, 68.25372955900008],
              [-29.63825436099995, 68.26264069200005],
              [-29.632639126999948, 68.27244700700004],
              [-29.610951300999943, 68.29677969000005],
              [-29.67918860599991, 68.29059479400007],
              [-29.69668535099993, 68.29266998900005],
              [-29.730213995999918, 68.30206940300008],
              [-29.77245032499991, 68.30825429900005],
              [-29.781971808999913, 68.31867096600007],
              [-29.782826300999943, 68.33274974200003],
              [-29.781605597999942, 68.34796784100007],
              [-29.78465735599991, 68.36961497600004],
              [-29.793120897999927, 68.37714264500005],
              [-29.80614173099991, 68.37946198100008],
              [-29.822621222999942, 68.38556549700007],
              [-29.83702551999994, 68.39842357000003],
              [-29.844146287999934, 68.40949127800008],
              [-29.85265051999994, 68.41559479400007],
              [-29.87096106699994, 68.41347890800006],
              [-29.89517167899993, 68.39642975500004],
              [-29.905100063999953, 68.39240143400008],
              [-29.938832160999937, 68.38646067900004],
              [-29.973378058999913, 68.38458893400008],
              [-29.991851365999935, 68.37982819200005],
              [-30.00381425699993, 68.36859772300005],
              [-30.008168097999942, 68.34796784100007],
              [-30.02171790299991, 68.33510976800005],
              [-30.048980272999927, 68.32990143400008],
              [-30.06944739499994, 68.32099030200004],
              [-30.06281490799995, 68.29677969000005],
              [-30.04515540299991, 68.28534577000005],
              [-29.993885870999918, 68.26337311400005],
              [-29.987049933999913, 68.25580475500004],
              [-29.993397589999915, 68.25104401200008],
              [-30.012277798999946, 68.24579498900005],
              [-30.035633917999917, 68.24217357000003],
              [-30.04950924399992, 68.24217357000003],
              [-30.07530676999994, 68.24339427300004],
              [-30.135365363999938, 68.26308828300006],
              [-30.165760870999918, 68.26947663000004],
              [-30.19945227799991, 68.27106354400007],
              [-30.272775844999956, 68.26557038000004],
              [-30.30296790299991, 68.25580475500004],
              [-30.287261522999927, 68.24290599200003],
              [-30.259836391999954, 68.24213288000004],
              [-30.203684048999946, 68.24957916900007],
              [-30.175770636999914, 68.24648672100005],
              [-30.147816535999937, 68.23786041900007],
              [-30.122710740999935, 68.22467682500007],
              [-30.10374915299991, 68.20799388200004],
              [-30.103342251999948, 68.20384349200003],
              [-30.103993292999917, 68.19708893400008],
              [-30.102894660999937, 68.18891022300005],
              [-30.096913214999915, 68.18073151200008],
              [-30.089914516999954, 68.17731354400007],
              [-30.07290605399993, 68.17365143400008],
              [-30.066151495999918, 68.17015208500004],
              [-30.008168097999942, 68.12604401200008],
              [-30.031239386999914, 68.11774323100008],
              [-30.055978969999956, 68.11180247600004],
              [-30.09015865799995, 68.12457916900007],
              [-30.10374915299991, 68.12604401200008],
              [-30.116851365999935, 68.12299225500004],
              [-30.12726803299995, 68.11684804900005],
              [-30.13630123599995, 68.11001211100006],
              [-30.145334438999953, 68.10496653900003],
              [-30.16234290299991, 68.10252513200004],
              [-30.213612433999913, 68.11180247600004],
              [-30.23005123599995, 68.10911692900004],
              [-30.259755011999914, 68.09918854400007],
              [-30.273793097999942, 68.09825267100007],
              [-30.337635870999918, 68.09935130400004],
              [-30.36628170499995, 68.10748932500007],
              [-30.392404751999948, 68.12604401200008],
              [-30.40330969999991, 68.13886139500005],
              [-30.406809048999946, 68.14777252800008],
              [-30.40538489499994, 68.17015208500004],
              [-30.394642706999946, 68.19818756700005],
              [-30.392404751999948, 68.21442291900007],
              [-30.401966925999943, 68.22166575700004],
              [-30.456776495999918, 68.22361888200004],
              [-30.671620245999918, 68.25755442900004],
              [-30.816883917999917, 68.25580475500004],
              [-30.794300910999937, 68.24066803600005],
              [-30.494740363999938, 68.18475983300004],
              [-30.474720831999946, 68.17283763200004],
              [-30.461008266999954, 68.13117096600007],
              [-30.45067298099991, 68.11391836100006],
              [-30.446888800999943, 68.09821198100008],
              [-30.460601365999935, 68.08510976800005],
              [-30.43736731699994, 68.07855866100005],
              [-30.419667120999918, 68.07086823100008],
              [-30.450021938999953, 68.06171295800004],
              [-30.489979620999918, 68.05988190300008],
              [-30.529042120999918, 68.06525299700007],
              [-30.55622311099995, 68.07762278900003],
              [-30.55304928299995, 68.08161041900007],
              [-30.54979407499991, 68.08340078300006],
              [-30.541900193999936, 68.08510976800005],
              [-30.569650844999956, 68.08169179900005],
              [-30.62022864499994, 68.06679922100005],
              [-30.645008917999917, 68.06342194200005],
              [-30.686268683999913, 68.06342194200005],
              [-30.697743292999917, 68.06561920800004],
              [-30.71784420499995, 68.07542552300004],
              [-30.724436001999948, 68.07762278900003],
              [-30.761341925999943, 68.08551666900007],
              [-30.77529863199993, 68.08510976800005],
              [-30.809885219999956, 68.07282135600008],
              [-30.823109503999945, 68.07086823100008],
              [-30.871490037999934, 68.07807038000004],
              [-30.897084113999938, 68.07904694200005],
              [-30.919300910999937, 68.07086823100008],
              [-30.911040818999936, 68.06753164300005],
              [-30.89199785099993, 68.05719635600008],
              [-30.91274980399993, 68.04511139500005],
              [-30.99128170499995, 68.05499909100007],
              [-31.008697068999936, 68.04661692900004],
              [-31.017241990999935, 68.04108307500007],
              [-31.036488410999937, 68.04779694200005],
              [-31.06704667899993, 68.06342194200005],
              [-31.080962693999936, 68.06391022300005],
              [-31.08775794199994, 68.06313711100006],
              [-31.090646938999953, 68.06028880400004],
              [-31.09483801999994, 68.05158112200007],
              [-31.104644334999932, 68.05145905200004],
              [-31.12441972599993, 68.05719635600008],
              [-31.14289303299995, 68.06000397300005],
              [-31.19367428299995, 68.07762278900003],
              [-31.41112219999991, 68.11831289300005],
              [-31.453724738999938, 68.13226959800005],
              [-31.42955481699994, 68.14459870000007],
              [-31.39867102799991, 68.14817942900004],
              [-31.33702551999994, 68.14594147300005],
              [-31.365834113999938, 68.15827057500007],
              [-31.403675910999937, 68.16274648600006],
              [-31.44245357999995, 68.16046784100007],
              [-31.474232550999943, 68.15277741100005],
              [-31.484730597999942, 68.15180084800005],
              [-31.49795488199993, 68.14545319200005],
              [-31.502837693999936, 68.13422272300005],
              [-31.495269334999932, 68.11859772300005],
              [-31.478138800999943, 68.10952383000006],
              [-31.431385870999918, 68.10252513200004],
              [-31.41274980399993, 68.09129466400003],
              [-31.43700110599991, 68.08177317900004],
              [-31.469471808999913, 68.07794830900008],
              [-31.58116614499994, 68.07648346600007],
              [-31.602691209999932, 68.08209870000007],
              [-31.62564042899993, 68.09813060100004],
              [-31.62096106699994, 68.10097890800006],
              [-31.620472785999937, 68.10195547100005],
              [-31.61827551999994, 68.10496653900003],
              [-31.693837042999917, 68.09926992400005],
              [-31.700795050999943, 68.10496653900003],
              [-31.700835740999935, 68.10464101800005],
              [-31.70213782499991, 68.11416250200006],
              [-31.71247311099995, 68.13206614800004],
              [-31.71442623599995, 68.13226959800005],
              [-31.714466925999943, 68.14581940300008],
              [-31.713286912999934, 68.15127187700006],
              [-31.700795050999943, 68.16705963700008],
              [-31.690256313999953, 68.17747630400004],
              [-31.68309485599991, 68.18162669500003],
              [-31.684885219999956, 68.18524811400005],
              [-31.700795050999943, 68.19432200700004],
              [-31.714995897999927, 68.19822825700004],
              [-31.728627081999946, 68.19855377800008],
              [-31.740223761999914, 68.20164622600004],
              [-31.748524542999917, 68.21426015800006],
              [-31.732085740999935, 68.21409739800004],
              [-31.714182094999956, 68.21759674700007],
              [-31.70303300699993, 68.22479889500005],
              [-31.70693925699993, 68.23590729400007],
              [-31.691395636999914, 68.24038320500006],
              [-31.67218990799995, 68.23720937700006],
              [-31.651600714999915, 68.23151276200008],
              [-31.577951626999948, 68.22577545800004],
              [-31.55036373599995, 68.22748444200005],
              [-31.52887936099995, 68.23590729400007],
              [-31.545521613999938, 68.24632396000004],
              [-31.56826738199993, 68.25275299700007],
              [-31.59211178299995, 68.25576406500005],
              [-31.902821417999917, 68.26947663000004],
              [-31.91319739499994, 68.26740143400008],
              [-31.937245245999918, 68.25812409100007],
              [-31.947255011999914, 68.25580475500004],
              [-31.96906490799995, 68.25608958500004],
              [-31.99128170499995, 68.25999583500004],
              [-32.00853430899991, 68.26959870000007],
              [-32.01549231699994, 68.28681061400005],
              [-32.02452551999994, 68.29657623900005],
              [-32.06623287699995, 68.31850820500006],
              [-32.078114386999914, 68.33152903900003],
              [-32.07787024599992, 68.34658437700006],
              [-32.074208136999914, 68.35765208500004],
              [-32.07750403599994, 68.36762116100005],
              [-32.09801184799994, 68.37929922100005],
              [-32.14500891799992, 68.38906484600005],
              [-32.15835527299993, 68.39765045800004],
              [-32.16006425699993, 68.42023346600007],
              [-32.15404212099992, 68.43231842700004],
              [-32.131743943999936, 68.45978424700007],
              [-32.12535559799994, 68.47492096600007],
              [-32.148426886999914, 68.48639557500007],
              [-32.166127081999946, 68.48578522300005],
              [-32.180572068999936, 68.47626373900005],
              [-32.221262173999946, 68.43178945500006],
              [-32.23814856699994, 68.42332591400003],
              [-32.25625566299993, 68.42023346600007],
              [-32.31480872299994, 68.44350820500006],
              [-32.33145097599993, 68.45441315300008],
              [-32.32249915299991, 68.46385325700004],
              [-32.30345618399991, 68.49542877800008],
              [-32.336822068999936, 68.51544830900008],
              [-32.34447180899991, 68.52334219000005],
              [-32.34923255099994, 68.53351471600007],
              [-32.35338294199994, 68.55402252800008],
              [-32.35806230399993, 68.56427643400008],
              [-32.37059485599991, 68.57908763200004],
              [-32.41051184799994, 68.61546458500004],
              [-32.426991339999915, 68.62571849200003],
              [-32.45799719999991, 68.63056061400005],
              [-32.487172003999945, 68.62392812700006],
              [-32.50332597599993, 68.60639069200005],
              [-32.49522864499994, 68.57855866100005],
              [-32.477772589999915, 68.56354401200008],
              [-32.45250403599994, 68.55182526200008],
              [-32.42479407499991, 68.54482656500005],
              [-32.399728969999956, 68.54376862200007],
              [-32.42174231699994, 68.53823476800005],
              [-32.42821204299992, 68.50950755400004],
              [-32.45494544199994, 68.50287506700005],
              [-32.54015051999994, 68.50413646000004],
              [-32.57095292899993, 68.50967031500005],
              [-32.501210089999915, 68.42902252800008],
              [-32.45860755099994, 68.39826080900008],
              [-32.407093878999945, 68.37929922100005],
              [-32.29531816299993, 68.35610586100006],
              [-32.23452714799993, 68.35883209800005],
              [-32.20885169199994, 68.34804922100005],
              [-32.19371497299994, 68.32892487200007],
              [-32.18187415299991, 68.30923086100006],
              [-32.16624915299991, 68.29677969000005],
              [-32.16075598899994, 68.27912018400008],
              [-32.07070878799993, 68.19432200700004],
              [-32.09064693899995, 68.18732330900008],
              [-32.113270636999914, 68.19163646000004],
              [-32.13695227799991, 68.20075104400007],
              [-32.22301184799994, 68.22064850500004],
              [-32.39281165299991, 68.22846100500004],
              [-32.43984941299993, 68.24152252800008],
              [-32.451161261999914, 68.23899974200003],
              [-32.45230058499993, 68.23354726800005],
              [-32.45099850199995, 68.21564362200007],
              [-32.45425370999993, 68.20799388200004],
              [-32.44078528599994, 68.19961172100005],
              [-32.42520097599993, 68.19546133000006],
              [-32.40957597599993, 68.19672272300005],
              [-32.38003495999993, 68.21238841400003],
              [-32.35846920499995, 68.21381256700005],
              [-32.31712805899991, 68.20799388200004],
              [-32.180531378999945, 68.16705963700008],
              [-32.185210740999935, 68.16331614800004],
              [-32.194203253999945, 68.15277741100005],
              [-32.101551886999914, 68.15936920800004],
              [-32.05150305899991, 68.15550364800004],
              [-32.02977454299992, 68.13597239800004],
              [-32.025461391999954, 68.12221914300005],
              [-32.004017706999946, 68.10342031500005],
              [-31.99559485599991, 68.09129466400003],
              [-31.99632727799991, 68.08295319200005],
              [-32.00112870999993, 68.07526276200008],
              [-32.003244594999956, 68.06533437700006],
              [-31.99559485599991, 68.05036041900007],
              [-32.018422003999945, 68.05194733300004],
              [-32.078114386999914, 68.06342194200005],
              [-32.09154212099992, 68.06146881700005],
              [-32.12539628799993, 68.05068594000005],
              [-32.14639238199993, 68.05036041900007],
              [-32.137562628999945, 68.03851959800005],
              [-32.12364661399994, 68.03107330900008],
              [-32.09117591099994, 68.02301666900007],
              [-32.09752356699994, 68.01178620000007],
              [-32.10728919199994, 68.00409577000005],
              [-32.11937415299991, 67.99884674700007],
              [-32.102853969999956, 68.00104401200008],
              [-32.07070878799993, 68.00259023600006],
              [-32.08047441299993, 67.98794179900005],
              [-32.09544837099992, 67.97939687700006],
              [-32.10680091099994, 67.97040436400005],
              [-32.105458136999914, 67.95477936400005],
              [-32.091135219999956, 67.94529857000003],
              [-32.04869544199994, 67.93976471600007],
              [-32.03652910099993, 67.92682526200008],
              [-32.05540930899991, 67.92698802300004],
              [-32.11168372299994, 67.93427155200004],
              [-32.10822506399995, 67.92812734600005],
              [-32.101551886999914, 67.91242096600007],
              [-32.09801184799994, 67.90631745000007],
              [-32.12800045499995, 67.90729401200008],
              [-32.15689042899993, 67.91901276200008],
              [-32.17870032499991, 67.92182038000004],
              [-32.18736731699994, 67.89614492400005],
              [-32.17300370999993, 67.89101797100005],
              [-32.14513098899994, 67.87531159100007],
              [-32.12637285099993, 67.85883209800005],
              [-32.139556443999936, 67.85114166900007],
              [-32.27383378799993, 67.86286041900007],
              [-32.31017005099994, 67.88157786700003],
              [-32.33104407499991, 67.88589101800005],
              [-32.420765753999945, 67.87221914300005],
              [-32.51915442599994, 67.87221914300005],
              [-32.54246985599991, 67.86786530200004],
              [-32.54466712099992, 67.85712311400005],
              [-32.53502356699994, 67.84369538000004],
              [-32.52257239499994, 67.83124420800004],
              [-32.55772864499994, 67.81850820500006],
              [-32.64244544199994, 67.80829498900005],
              [-32.68081620999993, 67.79645416900007],
              [-32.66954505099994, 67.78139883000006],
              [-32.67760169199994, 67.77024974200003],
              [-32.69579016799992, 67.76203034100007],
              [-32.76895097599993, 67.74188873900005],
              [-32.77562415299991, 67.73688385600008],
              [-32.782093878999945, 67.73021067900004],
              [-32.79076087099992, 67.72451406500005],
              [-32.818430141999954, 67.71971263200004],
              [-32.841053839999915, 67.70994700700004],
              [-32.90025794199994, 67.70132070500006],
              [-32.92731686099995, 67.68935781500005],
              [-33.05426998599995, 67.68528880400004],
              [-33.13243567599994, 67.70136139500005],
              [-33.15965735599991, 67.70221588700008],
              [-33.186105923999946, 67.70014069200005],
              [-33.20225989499994, 67.69403717700004],
              [-33.21011308499993, 67.67641836100006],
              [-33.200510219999956, 67.66380442900004],
              [-33.18106035099993, 67.65615469000005],
              [-33.16002356699994, 67.65314362200007],
              [-33.102406378999945, 67.65241120000007],
              [-33.074208136999914, 67.64687734600005],
              [-33.05699622299994, 67.63263580900008],
              [-33.06672115799995, 67.62913646000004],
              [-33.09312903599994, 67.61505768400008],
              [-33.098540818999936, 67.60846588700008],
              [-33.10415605399993, 67.59857819200005],
              [-33.117298956999946, 67.59406159100007],
              [-33.13219153599994, 67.59145742400005],
              [-33.14321855399993, 67.58730703300006],
              [-33.18667558499993, 67.55768463700008],
              [-33.210275844999956, 67.54730866100005],
              [-33.23228919199994, 67.54328034100007],
              [-33.27106686099995, 67.54205963700008],
              [-33.28351803299995, 67.54328034100007],
              [-33.32404537699995, 67.56220123900005],
              [-33.33812415299991, 67.56370677300004],
              [-33.36571204299992, 67.55141836100006],
              [-33.359038865999935, 67.53424713700008],
              [-33.33511308499993, 67.51805247600004],
              [-33.31086178299995, 67.50849030200004],
              [-33.34557044199994, 67.48867422100005],
              [-33.29963131399995, 67.49433014500005],
              [-33.278635219999956, 67.49241771000004],
              [-33.26988684799994, 67.47801341400003],
              [-33.27965247299994, 67.46356842700004],
              [-33.30235755099994, 67.45233795800004],
              [-33.34557044199994, 67.44086334800005],
              [-33.34557044199994, 67.43402741100005],
              [-33.28083248599995, 67.41844310100004],
              [-33.26988684799994, 67.41290924700007],
              [-33.27367102799991, 67.40078359600005],
              [-33.287098761999914, 67.39549388200004],
              [-33.30308997299994, 67.39301178600005],
              [-33.314564581999946, 67.38898346600007],
              [-33.33185787699995, 67.36863841400003],
              [-33.34357662699995, 67.36078522300005],
              [-33.36237545499995, 67.35765208500004],
              [-33.39720618399991, 67.35618724200003],
              [-33.41197669199994, 67.36005280200004],
              [-33.42072506399995, 67.37197500200006],
              [-33.406320766999954, 67.37970612200007],
              [-33.41755123599995, 67.38947174700007],
              [-33.43700110599991, 67.39313385600008],
              [-33.44741777299993, 67.38251373900005],
              [-33.45567786399994, 67.38080475500004],
              [-33.51008053299995, 67.38556549700007],
              [-33.50694739499994, 67.38174062700006],
              [-33.50548255099994, 67.37848541900007],
              [-33.50438391799992, 67.37555573100008],
              [-33.50259355399993, 67.37197500200006],
              [-33.52708899599992, 67.37278880400004],
              [-33.55190995999993, 67.37815989800004],
              [-33.57591712099992, 67.38043854400007],
              [-33.598215298999946, 67.37197500200006],
              [-33.56468665299991, 67.35765208500004],
              [-33.567616339999915, 67.35565827000005],
              [-33.56871497299994, 67.35512929900005],
              [-33.56944739499994, 67.35431549700007],
              [-33.571522589999915, 67.35146719000005],
              [-33.54796301999994, 67.34560781500005],
              [-33.42072506399995, 67.33783600500004],
              [-33.42072506399995, 67.33100006700005],
              [-33.435210740999935, 67.33079661700003],
              [-33.47524980399993, 67.32416413000004],
              [-33.47524980399993, 67.31671784100007],
              [-33.45421301999994, 67.31561920800004],
              [-33.43472245999993, 67.31146881700005],
              [-33.42711341099994, 67.30337148600006],
              [-33.44115149599992, 67.28998444200005],
              [-33.42853756399995, 67.27545807500007],
              [-33.381743943999936, 67.26166413000004],
              [-33.36546790299991, 67.24774811400005],
              [-33.48619544199994, 67.23476797100005],
              [-33.550770636999914, 67.23476797100005],
              [-33.56558183499993, 67.23749420800004],
              [-33.575103318999936, 67.24371979400007],
              [-33.58283443899995, 67.25055573100008],
              [-33.59203040299991, 67.25527578300006],
              [-33.60065670499995, 67.25560130400004],
              [-33.60960852799991, 67.25307851800005],
              [-33.668080206999946, 67.22321198100008],
              [-33.67052161399994, 67.21771881700005],
              [-33.65392005099994, 67.21133047100005],
              [-33.59137936099995, 67.22113678600005],
              [-33.57241777299993, 67.21869538000004],
              [-33.51626542899993, 67.20062897300005],
              [-33.53087317599994, 67.17788320500006],
              [-33.546986456999946, 67.16681549700007],
              [-33.54759680899991, 67.15888092700004],
              [-33.51626542899993, 67.14541250200006],
              [-33.53783118399991, 67.13092682500007],
              [-33.54674231699994, 67.12225983300004],
              [-33.55101477799991, 67.11127350500004],
              [-33.546131964999915, 67.10394928600005],
              [-33.53628495999993, 67.09609609600005],
              [-33.53026282499991, 67.08734772300005],
              [-33.53742428299995, 67.07770416900007],
              [-33.54820716099994, 67.07819245000007],
              [-33.59203040299991, 67.09760163000004],
              [-33.60700436099995, 67.09910716400003],
              [-33.65343176999994, 67.09760163000004],
              [-33.64720618399991, 67.09760163000004],
              [-33.66120357999995, 67.09560781500005],
              [-33.67442786399994, 67.08982982000003],
              [-33.68431555899991, 67.08026764500005],
              [-33.68822180899991, 67.06683991100005],
              [-33.69493567599994, 67.05727773600006],
              [-33.71080481699994, 67.05215078300006],
              [-33.81680253799993, 67.04071686400005],
              [-33.85562089799993, 67.02977122600004],
              [-33.87999426999994, 67.01504140800006],
              [-33.83897864499994, 67.00958893400008],
              [-33.798898891999954, 67.02049388200004],
              [-33.76158606699994, 67.02529531500005],
              [-33.72915605399993, 67.00141022300005],
              [-33.73412024599992, 66.99909088700008],
              [-33.72915605399993, 66.99457428600005],
              [-33.750884568999936, 66.98834870000007],
              [-33.97565670499995, 66.99457428600005],
              [-33.95836341099994, 66.98566315300008],
              [-33.89366614499994, 66.96784088700008],
              [-33.885975714999915, 66.97113678600005],
              [-33.86546790299991, 66.95978424700007],
              [-33.85887610599991, 66.95355866100005],
              [-33.887603318999936, 66.94586823100008],
              [-33.91641191299993, 66.94977448100008],
              [-33.94562740799995, 66.95734284100007],
              [-33.97565670499995, 66.96039459800005],
              [-33.99913489499994, 66.95449453300006],
              [-33.99400794199994, 66.94432200700004],
              [-33.97297115799995, 66.93390534100007],
              [-33.94831295499995, 66.92694733300004],
              [-33.95579993399991, 66.91754791900007],
              [-33.982411261999914, 66.89960358300004],
              [-33.99063066299993, 66.89130280200004],
              [-34.015695766999954, 66.85342031500005],
              [-34.01939856699994, 66.83999258000006],
              [-34.01512610599991, 66.82684967700004],
              [-34.00352942599994, 66.80955638200004],
              [-33.995432094999956, 66.79328034100007],
              [-33.98932857999995, 66.78742096600007],
              [-33.97565670499995, 66.78229401200008],
              [-33.96165930899991, 66.78180573100008],
              [-33.94741777299993, 66.78314850500004],
              [-33.93700110599991, 66.78066640800006],
              [-33.93464107999995, 66.76862213700008],
              [-33.94806881399995, 66.75214264500005],
              [-33.97142493399991, 66.74286530200004],
              [-33.988392706999946, 66.74652741100005],
              [-33.982411261999914, 66.76862213700008],
              [-34.025502081999946, 66.77777741100005],
              [-34.03701738199993, 66.78229401200008],
              [-34.048939581999946, 66.79189687700006],
              [-34.05842037699995, 66.80194733300004],
              [-34.06916256399995, 66.80898672100005],
              [-34.08543860599991, 66.80955638200004],
              [-34.07957923099991, 66.79734935100004],
              [-34.05724036399994, 66.76178620000007],
              [-34.04759680899991, 66.75433991100005],
              [-34.04596920499995, 66.75116608300004],
              [-34.05028235599991, 66.74510325700004],
              [-34.05850175699993, 66.74135976800005],
              [-34.068348761999914, 66.74506256700005],
              [-34.08145097599993, 66.75551992400005],
              [-34.08934485599991, 66.75934479400007],
              [-34.09911048099991, 66.76178620000007],
              [-34.08824622299994, 66.72125885600008],
              [-34.11750240799995, 66.70945872600004],
              [-34.16738847599993, 66.71401601800005],
              [-34.15371660099993, 66.70038483300004],
              [-34.15855872299994, 66.69867584800005],
              [-34.16258704299992, 66.69521719000005],
              [-34.16738847599993, 66.69354889500005],
              [-34.148426886999914, 66.67999909100007],
              [-34.15070553299995, 66.67157623900005],
              [-34.181630011999914, 66.65875885600008],
              [-34.19570878799993, 66.64996979400007],
              [-34.21007239499994, 66.63812897300005],
              [-34.218739386999914, 66.62661367400005],
              [-34.21580969999991, 66.61839427300004],
              [-34.25645911399994, 66.58478424700007],
              [-34.270375128999945, 66.57684967700004],
              [-34.29198157499991, 66.57306549700007],
              [-34.30182857999995, 66.57977936400005],
              [-34.30028235599991, 66.59271881700005],
              [-34.277414516999954, 66.62099844000005],
              [-34.26740475199995, 66.65009186400005],
              [-34.26012122299994, 66.66250234600005],
              [-34.25963294199994, 66.67332591400003],
              [-34.27131100199995, 66.68256256700005],
              [-34.288726365999935, 66.68423086100006],
              [-34.30516516799992, 66.67243073100008],
              [-34.298817511999914, 66.65668366100005],
              [-34.30695553299995, 66.64362213700008],
              [-34.35619055899991, 66.60439687700006],
              [-34.372385219999956, 66.59699127800008],
              [-34.38573157499991, 66.61676666900007],
              [-34.397328253999945, 66.62954336100006],
              [-34.40444902299993, 66.64516836100006],
              [-34.38980058499993, 66.67617422100005],
              [-34.390614386999914, 66.69179922100005],
              [-34.397328253999945, 66.70742422100005],
              [-34.40758216099994, 66.72085195500006],
              [-34.41746985599991, 66.74994538000004],
              [-34.43394934799994, 66.73688385600008],
              [-34.441517706999946, 66.70892975500004],
              [-34.43150794199994, 66.69354889500005],
              [-34.432850714999915, 66.68793366100005],
              [-34.475900844999956, 66.65534088700008],
              [-34.491078253999945, 66.64996979400007],
              [-34.51695716099994, 66.64533112200007],
              [-34.530506964999915, 66.63825104400007],
              [-34.492258266999954, 66.63788483300004],
              [-34.47573808499993, 66.63226959800005],
              [-34.46157792899993, 66.61839427300004],
              [-34.475900844999956, 66.60944245000007],
              [-34.50739498599995, 66.60374583500004],
              [-34.52367102799991, 66.59796784100007],
              [-34.49974524599992, 66.57819245000007],
              [-34.43431555899991, 66.56329987200007],
              [-34.40758216099994, 66.54271067900004],
              [-34.44994055899991, 66.52374909100007],
              [-34.46157792899993, 66.51536692900004],
              [-34.47345943899995, 66.50897858300004],
              [-34.51903235599991, 66.51243724200003],
              [-34.537953253999945, 66.50112539300005],
              [-34.54360917899993, 66.48476797100005],
              [-34.547718878999945, 66.46491120000007],
              [-34.55711829299992, 66.44944896000004],
              [-34.57892818899995, 66.44647858300004],
              [-34.58275305899991, 66.44106679900005],
              [-34.59992428299995, 66.43939850500004],
              [-34.64037024599992, 66.44025299700007],
              [-34.659087693999936, 66.43846263200004],
              [-34.67345130099994, 66.43378327000005],
              [-34.702463344999956, 66.41917552300004],
              [-34.702463344999956, 66.41233958500004],
              [-34.68932044199994, 66.41233958500004],
              [-34.68000240799995, 66.41689687700006],
              [-34.67149817599994, 66.42259349200003],
              [-34.66087805899991, 66.42601146000004],
              [-34.650054490999935, 66.42552317900004],
              [-34.63194739499994, 66.42047760600008],
              [-34.623605923999946, 66.41917552300004],
              [-34.62319902299993, 66.41225820500006],
              [-34.63133704299992, 66.39667389500005],
              [-34.64329993399991, 66.38043854400007],
              [-34.653960740999935, 66.37140534100007],
              [-34.67023678299995, 66.37140534100007],
              [-34.68545488199993, 66.37689850500004],
              [-34.71231035099993, 66.40241120000007],
              [-34.72419186099995, 66.40713125200006],
              [-34.73289954299992, 66.40033600500004],
              [-34.735666469999956, 66.38837311400005],
              [-34.729725714999915, 66.37763092700004],
              [-34.729725714999915, 66.35712311400005],
              [-34.719634568999936, 66.35370514500005],
              [-34.71654212099992, 66.35053131700005],
              [-34.71544348899994, 66.34406159100007],
              [-34.763783331999946, 66.34271881700005],
              [-34.77383378799993, 66.33470286700003],
              [-34.78380286399994, 66.32461172100005],
              [-34.79735266799992, 66.31679922100005],
              [-34.81582597599993, 66.31606679900005],
              [-34.833973761999914, 66.32111237200007],
              [-34.84434973899994, 66.32733795800004],
              [-34.83926347599993, 66.33038971600007],
              [-34.83104407499991, 66.33283112200007],
              [-34.82579505099994, 66.33877187700006],
              [-34.824777798999946, 66.34625885600008],
              [-34.828968878999945, 66.35370514500005],
              [-34.839100714999915, 66.35822174700007],
              [-34.84947669199994, 66.35651276200008],
              [-34.859934048999946, 66.35248444200005],
              [-34.870025193999936, 66.35028717700004],
              [-34.93517005099994, 66.34406159100007],
              [-34.928944464999915, 66.34406159100007],
              [-34.93211829299992, 66.34369538000004],
              [-34.94200598899994, 66.34406159100007],
              [-34.93455969999991, 66.33441803600005],
              [-34.915272589999915, 66.32562897300005],
              [-34.90721594999991, 66.31679922100005],
              [-34.92638098899994, 66.30145905200004],
              [-34.94798743399991, 66.29189687700006],
              [-34.97325598899994, 66.28953685100004],
              [-35.12287350199995, 66.33584219000005],
              [-35.13377844999991, 66.34406159100007],
              [-35.12071692599994, 66.35667552300004],
              [-35.11237545499995, 66.37323639500005],
              [-35.10781816299993, 66.39142487200007],
              [-35.10651607999995, 66.40892161700003],
              [-35.11424719999991, 66.42145416900007],
              [-35.132150844999956, 66.41657135600008],
              [-35.16486568899995, 66.39931875200006],
              [-35.16755123599995, 66.39590078300006],
              [-35.173898891999954, 66.38104889500005],
              [-35.17882239499994, 66.37763092700004],
              [-35.19863847599993, 66.37767161700003],
              [-35.20763098899994, 66.37592194200005],
              [-35.21637936099995, 66.37140534100007],
              [-35.224273240999935, 66.35789622600004],
              [-35.22227942599994, 66.34389883000006],
              [-35.22248287699995, 66.33152903900003],
              [-35.23680579299992, 66.32363515800006],
              [-35.22826087099992, 66.31256745000007],
              [-35.216786261999914, 66.30988190300008],
              [-35.203236456999946, 66.31049225500004],
              [-35.188384568999936, 66.30931224200003],
              [-35.13377844999991, 66.28945547100005],
              [-35.05772864499994, 66.27309804900005],
              [-35.03819739499994, 66.26215241100005],
              [-35.06720943899995, 66.24306875200006],
              [-35.11888587099992, 66.23590729400007],
              [-35.21637936099995, 66.24103424700007],
              [-35.34878495999993, 66.28261953300006],
              [-35.38703365799995, 66.28945547100005],
              [-35.41934160099993, 66.28851959800005],
              [-35.43504798099991, 66.29010651200008],
              [-35.44908606699994, 66.29564036700003],
              [-35.44005286399994, 66.30353424700007],
              [-35.43455969999991, 66.31517161700003],
              [-35.43541419199994, 66.32583242400005],
              [-35.445383266999954, 66.33038971600007],
              [-35.46031653599994, 66.32758209800005],
              [-35.47638912699995, 66.32054271000004],
              [-35.50430253799993, 66.30312734600005],
              [-35.50177975199995, 66.29938385600008],
              [-35.49689693899995, 66.28945547100005],
              [-35.58934485599991, 66.28945547100005],
              [-35.60716712099992, 66.29694245000007],
              [-35.62913977799991, 66.32977936400005],
              [-35.64806067599994, 66.33722565300008],
              [-35.66641191299993, 66.34198639500005],
              [-35.685536261999914, 66.35321686400005],
              [-35.73375403599994, 66.38934967700004],
              [-35.75308183499993, 66.39956289300005],
              [-35.774647589999915, 66.40741608300004],
              [-35.79857337099992, 66.41233958500004],
              [-35.79857337099992, 66.41917552300004],
              [-35.782093878999945, 66.42340729400007],
              [-35.763661261999914, 66.42523834800005],
              [-35.747303839999915, 66.42926666900007],
              [-35.73713131399995, 66.44025299700007],
              [-35.81558183499993, 66.43659088700008],
              [-35.83263098899994, 66.44350820500006],
              [-35.851633266999954, 66.43744538000004],
              [-35.88109290299991, 66.41917552300004],
              [-35.87364661399994, 66.41917552300004],
              [-35.869984503999945, 66.41307200700004],
              [-35.85374915299991, 66.40387604400007],
              [-35.832915818999936, 66.39549388200004],
              [-35.81558183499993, 66.39183177300004],
              [-35.80345618399991, 66.38760000200006],
              [-35.78034420499995, 66.36884186400005],
              [-35.76203365799995, 66.36225006700005],
              [-35.73648027299993, 66.34715403900003],
              [-35.72647050699993, 66.34495677300004],
              [-35.70567786399994, 66.34589264500005],
              [-35.696156378999945, 66.34406159100007],
              [-35.685536261999914, 66.33820221600007],
              [-35.67821204299992, 66.33120351800005],
              [-35.67642167899993, 66.32379791900007],
              [-35.682484503999945, 66.31679922100005],
              [-35.675038214999915, 66.30931224200003],
              [-35.68993079299992, 66.29706452000005],
              [-35.70718339799993, 66.28754303600005],
              [-35.74331620999993, 66.27521393400008],
              [-35.74331620999993, 66.26837799700007],
              [-35.67613684799994, 66.27631256700005],
              [-35.655181443999936, 66.27521393400008],
              [-35.64110266799992, 66.27090078300006],
              [-35.61461341099994, 66.25893789300005],
              [-35.59996497299994, 66.25470612200007],
              [-35.56330318899995, 66.25193919500003],
              [-35.55150305899991, 66.24848053600005],
              [-35.55150305899991, 66.24103424700007],
              [-35.58861243399991, 66.23236725500004],
              [-35.669911261999914, 66.22467682500007],
              [-35.70230058499993, 66.20693594000005],
              [-35.63719641799992, 66.21377187700006],
              [-35.62462317599994, 66.20941803600005],
              [-35.61620032499991, 66.19977448100008],
              [-35.60973059799994, 66.19013092700004],
              [-35.59471594999991, 66.18089427300004],
              [-35.58470618399991, 66.16937897300005],
              [-35.576283331999946, 66.15582916900007],
              [-35.57262122299994, 66.14484284100007],
              [-35.57530676999994, 66.13287995000007],
              [-35.586781378999945, 66.12079498900005],
              [-35.58629309799994, 66.11131419500003],
              [-35.609364386999914, 66.11107005400004],
              [-35.63219153599994, 66.11579010600008],
              [-35.64565995999993, 66.12665436400005],
              [-35.64085852799991, 66.14484284100007],
              [-35.64858964799993, 66.14883047100005],
              [-35.655181443999936, 66.15350983300004],
              [-35.66820227799991, 66.16596100500004],
              [-35.66982988199993, 66.16974518400008],
              [-35.673491990999935, 66.18235911700003],
              [-35.675038214999915, 66.18577708500004],
              [-35.69440670499995, 66.19501373900005],
              [-35.719593878999945, 66.19965241100005],
              [-35.745025193999936, 66.19920482000003],
              [-35.76504472599993, 66.19330475500004],
              [-35.75015214799993, 66.18329498900005],
              [-35.71784420499995, 66.17963288000004],
              [-35.70230058499993, 66.17275625200006],
              [-35.69806881399995, 66.16657135600008],
              [-35.688710089999915, 66.13861725500004],
              [-35.710601365999935, 66.12303294500003],
              [-35.74742591099994, 66.12295156500005],
              [-35.81899980399993, 66.13117096600007],
              [-35.84805253799993, 66.14329661700003],
              [-35.88581295499995, 66.14179108300004],
              [-35.92100989499994, 66.12811920800004],
              [-35.94249426999994, 66.10390859600005],
              [-35.91588294199994, 66.10602448100008],
              [-35.86660722599993, 66.11542389500005],
              [-35.839507615999935, 66.11749909100007],
              [-35.73204505099994, 66.09658437700006],
              [-35.71662350199995, 66.09023672100005],
              [-35.75796464799993, 66.08026764500005],
              [-35.80540930899991, 66.07591380400004],
              [-35.88255774599992, 66.09007396000004],
              [-35.90843665299991, 66.09023672100005],
              [-35.90843665299991, 66.08344147300005],
              [-35.89867102799991, 66.08331940300008],
              [-35.89216061099995, 66.08177317900004],
              [-35.88109290299991, 66.07591380400004],
              [-35.917307094999956, 66.07754140800006],
              [-35.93297278599994, 66.07412344000005],
              [-35.94249426999994, 66.06289297100005],
              [-35.92442786399994, 66.06268952000005],
              [-35.89159094999991, 66.05646393400008],
              [-35.87364661399994, 66.05609772300005],
              [-35.87364661399994, 66.04926178600005],
              [-35.88658606699994, 66.05003489800004],
              [-35.899281378999945, 66.04922109600005],
              [-35.91128495999993, 66.04669830900008],
              [-35.92202714799993, 66.04242584800005],
              [-35.92202714799993, 66.03558991100005],
              [-35.91454016799992, 66.03266022300005],
              [-35.90151933499993, 66.02505117400005],
              [-35.89415442599994, 66.02191803600005],
              [-35.89415442599994, 66.01508209800005],
              [-35.98863684799994, 65.98480866100005],
              [-36.04556230399993, 65.97418854400007],
              [-36.04556230399993, 65.96670156500005],
              [-36.04124915299991, 65.96552155200004],
              [-36.03189042899993, 65.96051666900007],
              [-36.07380123599995, 65.93549225500004],
              [-36.08967037699995, 65.93256256700005],
              [-36.10269120999993, 65.93480052300004],
              [-36.13121497299994, 65.94684479400007],
              [-36.15294348899994, 65.94326406500005],
              [-36.17552649599992, 65.93671295800004],
              [-36.19896399599992, 65.93341705900008],
              [-36.22378495999993, 65.93939850500004],
              [-36.20523027299993, 65.96185944200005],
              [-36.19758053299995, 65.97479889500005],
              [-36.20262610599991, 65.98094310100004],
              [-36.23985755099994, 65.95941803600005],
              [-36.261789516999954, 65.95172760600008],
              [-36.271555141999954, 65.96356842700004],
              [-36.265614386999914, 65.97508372600004],
              [-36.25495357999995, 65.98969147300005],
              [-36.24986731699994, 66.00234609600005],
              [-36.260975714999915, 66.00763580900008],
              [-36.27171790299991, 66.00511302300004],
              [-36.28929602799991, 65.99241771000004],
              [-36.298817511999914, 65.98777903900003],
              [-36.31004798099991, 65.98627350500004],
              [-36.346587693999936, 65.98777903900003],
              [-36.346587693999936, 65.98094310100004],
              [-36.33897864499994, 65.98021067900004],
              [-36.31993567599994, 65.97418854400007],
              [-36.33023027299993, 65.96157461100006],
              [-36.32689368399991, 65.94061920800004],
              [-36.33360755099994, 65.92572663000004],
              [-36.32892818899995, 65.91913483300004],
              [-36.326161261999914, 65.91209544500003],
              [-36.36392167899993, 65.91600169500003],
              [-36.38068600199995, 65.92885976800005],
              [-36.38540605399993, 65.95221588700008],
              [-36.388783331999946, 66.01552969000005],
              [-36.38414466099994, 66.03998444200005],
              [-36.36929277299993, 66.06037018400008],
              [-36.33975175699993, 66.07591380400004],
              [-36.35850989499994, 66.09137604400007],
              [-36.38902747299994, 66.08966705900008],
              [-36.44961503799993, 66.07591380400004],
              [-36.519520636999914, 66.08437734600005],
              [-36.553618943999936, 66.08380768400008],
              [-36.57998613199993, 66.07037995000007],
              [-36.567616339999915, 66.06195709800005],
              [-36.54987545499995, 66.05560944200005],
              [-36.530140753999945, 66.05125560100004],
              [-36.511708136999914, 66.04926178600005],
              [-36.50267493399991, 66.05068594000005],
              [-36.49242102799991, 66.05341217700004],
              [-36.48306230399993, 66.05414459800005],
              [-36.47695878799993, 66.04926178600005],
              [-36.47752844999991, 66.04401276200008],
              [-36.48216712099992, 66.03998444200005],
              [-36.487538214999915, 66.03636302300004],
              [-36.52163652299993, 65.99091217700004],
              [-36.53612219999991, 65.98525625200006],
              [-36.681752081999946, 65.96051666900007],
              [-36.740345831999946, 65.93598053600005],
              [-36.76158606699994, 65.93256256700005],
              [-36.90900631399995, 65.93256256700005],
              [-36.896595831999946, 65.91941966400003],
              [-36.87657630099994, 65.91766998900005],
              [-36.852121548999946, 65.92011139500005],
              [-36.82640540299991, 65.91958242400005],
              [-36.84984290299991, 65.88646067900004],
              [-36.86050370999993, 65.87791575700004],
              [-36.880848761999914, 65.86904531500005],
              [-36.99014238199993, 65.84149811400005],
              [-37.013783331999946, 65.83958567900004],
              [-37.03184973899994, 65.84320709800005],
              [-37.04287675699993, 65.85565827000005],
              [-37.02301998599995, 65.87250397300005],
              [-37.03868567599994, 65.88475169500003],
              [-37.03197180899991, 65.88422272300005],
              [-37.02871660099993, 65.88629791900007],
              [-37.03099524599992, 65.89435455900008],
              [-37.04084225199995, 65.90159739800004],
              [-37.059803839999915, 65.91209544500003],
              [-37.061431443999936, 65.91571686400005],
              [-37.06480872299994, 65.92877838700008],
              [-37.06663977799991, 65.93256256700005],
              [-37.07323157499991, 65.93537018400008],
              [-37.08999589799993, 65.93895091400003],
              [-37.09703528599994, 65.94310130400004],
              [-37.09703528599994, 65.95962148600006],
              [-37.08088131399995, 65.98021067900004],
              [-37.06163489499994, 65.99941640800006],
              [-37.05235755099994, 66.01137929900005],
              [-37.04914303299995, 66.02142975500004],
              [-37.03506425699993, 66.04100169500003],
              [-37.03184973899994, 66.05267975500004],
              [-37.03770911399994, 66.06069570500006],
              [-37.05138098899994, 66.06460195500006],
              [-37.067250128999945, 66.06509023600006],
              [-37.07970130099994, 66.06289297100005],
              [-37.09797115799995, 66.05023834800005],
              [-37.10415605399993, 66.03261953300006],
              [-37.09984290299991, 66.01292552300004],
              [-37.086496548999946, 65.99404531500005],
              [-37.104807094999956, 65.98908112200007],
              [-37.121205206999946, 65.99721914300005],
              [-37.138335740999935, 66.00901927300004],
              [-37.15880286399994, 66.01508209800005],
              [-37.167958136999914, 66.00897858300004],
              [-37.15721594999991, 65.99469635600008],
              [-37.12743079299992, 65.96670156500005],
              [-37.14411373599995, 65.95551178600005],
              [-37.162220831999946, 65.94684479400007],
              [-37.14757239499994, 65.93598053600005],
              [-37.130848761999914, 65.91966380400004],
              [-37.12291419199994, 65.90493398600006],
              [-37.13459225199995, 65.89838288000004],
              [-37.23729407499991, 65.90521881700005],
              [-37.23729407499991, 65.89838288000004],
              [-37.12572180899991, 65.86859772300005],
              [-37.086496548999946, 65.86432526200008],
              [-37.09829667899993, 65.83771393400008],
              [-37.11436926999994, 65.81688060100004],
              [-37.13719641799992, 65.80426666900007],
              [-37.16966712099992, 65.80223216400003],
              [-37.194203253999945, 65.81000397300005],
              [-37.218739386999914, 65.82257721600007],
              [-37.24437415299991, 65.83197663000004],
              [-37.27208411399994, 65.83014557500007],
              [-37.27208411399994, 65.82269928600005],
              [-37.210601365999935, 65.80223216400003],
              [-37.187570766999954, 65.78949616100005],
              [-37.175770636999914, 65.78449127800008],
              [-37.162220831999946, 65.78237539300005],
              [-37.18455969999991, 65.77407461100006],
              [-37.21011308499993, 65.77529531500005],
              [-37.46385657499991, 65.85687897300005],
              [-37.55260169199994, 65.90521881700005],
              [-37.57445227799991, 65.91258372600004],
              [-37.64195716099994, 65.92572663000004],
              [-37.67853756399995, 65.94570547100005],
              [-37.68980872299994, 65.94684479400007],
              [-37.69310462099992, 65.94257233300004],
              [-37.700062628999945, 65.92511627800008],
              [-37.70409094999991, 65.91958242400005],
              [-37.723215298999946, 65.91278717700004],
              [-37.76585852799991, 65.91071198100008],
              [-37.786000128999945, 65.90521881700005],
              [-37.80296790299991, 65.89337799700007],
              [-37.81480872299994, 65.88304271000004],
              [-37.82925370999993, 65.87872955900008],
              [-37.85423743399991, 65.88475169500003],
              [-37.85423743399991, 65.89158763200004],
              [-37.83812415299991, 65.89594147300005],
              [-37.82555091099994, 65.90827057500007],
              [-37.81550045499995, 65.92251211100006],
              [-37.80650794199994, 65.93256256700005],
              [-37.795033331999946, 65.93854401200008],
              [-37.77110755099994, 65.94660065300008],
              [-37.758697068999936, 65.95302969000005],
              [-37.75133216099994, 65.95994700700004],
              [-37.740223761999914, 65.97500234600005],
              [-37.73078365799995, 65.98094310100004],
              [-37.77843176999994, 65.99160390800006],
              [-37.792958136999914, 66.00079987200007],
              [-37.778553839999915, 66.01508209800005],
              [-37.78941809799994, 66.01703522300005],
              [-37.803293423999946, 66.02179596600007],
              [-37.812570766999954, 66.02912018400008],
              [-37.809885219999956, 66.03900788000004],
              [-37.79792232999995, 66.04873281500005],
              [-37.758697068999936, 66.06663646000004],
              [-37.73412024599992, 66.07391998900005],
              [-37.64883378799993, 66.07037995000007],
              [-37.66246497299994, 66.07591380400004],
              [-37.63581295499995, 66.10455963700008],
              [-37.621937628999945, 66.11395905200004],
              [-37.60069739499994, 66.11749909100007],
              [-37.556304490999935, 66.11131419500003],
              [-37.54718990799995, 66.11383698100008],
              [-37.54702714799993, 66.11969635600008],
              [-37.55260169199994, 66.13117096600007],
              [-37.55386308499993, 66.13597239800004],
              [-37.55724036399994, 66.14264557500007],
              [-37.56012936099995, 66.15045807500007],
              [-37.56004798099991, 66.15851471600007],
              [-37.55500240799995, 66.16779205900008],
              [-37.54767818899995, 66.17267487200007],
              [-37.53880774599992, 66.17658112200007],
              [-37.49388587099992, 66.20685455900008],
              [-37.472727016999954, 66.21698639500005],
              [-37.43968665299991, 66.22549062700006],
              [-37.31135006399995, 66.29755280200004],
              [-37.29137122299994, 66.29975006700005],
              [-37.25157630099994, 66.29564036700003],
              [-37.23078365799995, 66.29734935100004],
              [-37.20995032499991, 66.30194733300004],
              [-37.16966712099992, 66.31679922100005],
              [-37.16966712099992, 66.32363515800006],
              [-37.193348761999914, 66.34048086100006],
              [-37.215402798999946, 66.34617747600004],
              [-37.391835089999915, 66.32363515800006],
              [-37.41930091099994, 66.32778554900005],
              [-37.457020636999914, 66.34609609600005],
              [-37.48468990799995, 66.35028717700004],
              [-37.50991777299993, 66.34552643400008],
              [-37.55223548099991, 66.32599518400008],
              [-37.576283331999946, 66.32391998900005],
              [-37.61636308499993, 66.32880280200004],
              [-37.695423956999946, 66.35187409100007],
              [-37.75658118399991, 66.35980866100005],
              [-37.80382239499994, 66.37567780200004],
              [-37.82013912699995, 66.38507721600007],
              [-37.832142706999946, 66.39813873900005],
              [-37.83812415299991, 66.41128164300005],
              [-37.84748287699995, 66.44025299700007],
              [-37.85236568899995, 66.44472890800006],
              [-37.85960852799991, 66.44057851800005],
              [-37.864165818999936, 66.43097565300008],
              [-37.86790930899991, 66.41917552300004],
              [-37.86778723899994, 66.41185130400004],
              [-37.86392167899993, 66.38788483300004],
              [-37.86168372299994, 66.38507721600007],
              [-37.874256964999915, 66.37767161700003],
              [-37.89757239499994, 66.37287018400008],
              [-37.92341061099995, 66.37225983300004],
              [-37.936838344999956, 66.37763092700004],
              [-37.94310462099992, 66.38080475500004],
              [-37.94953365799995, 66.38304271000004],
              [-37.95645097599993, 66.38442617400005],
              [-37.95677649599992, 66.38715241100005],
              [-37.95734615799995, 66.39183177300004],
              [-37.99974524599992, 66.38792552300004],
              [-38.098500128999945, 66.39447663000004],
              [-38.13198808499993, 66.38129303600005],
              [-38.14049231699994, 66.36920807500007],
              [-38.14297441299993, 66.35911692900004],
              [-38.14167232999995, 66.34064362200007],
              [-37.758697068999936, 66.29564036700003],
              [-37.74120032499991, 66.28974030200004],
              [-37.707590298999946, 66.27387116100005],
              [-37.68980872299994, 66.26837799700007],
              [-37.68980872299994, 66.26215241100005],
              [-37.744699673999946, 66.22858307500007],
              [-37.76549231699994, 66.22117747600004],
              [-37.78774980399993, 66.22011953300006],
              [-37.80650794199994, 66.22504303600005],
              [-37.813059048999946, 66.23309967700004],
              [-37.79898027299993, 66.24103424700007],
              [-37.79898027299993, 66.24848053600005],
              [-37.90269934799994, 66.24103424700007],
              [-37.92808997299994, 66.24433014500005],
              [-37.95189368399991, 66.25136953300006],
              [-37.97496497299994, 66.25324127800008],
              [-37.99828040299991, 66.24103424700007],
              [-37.941517706999946, 66.22606028900003],
              [-37.90721594999991, 66.20685455900008],
              [-37.87083899599992, 66.20758698100008],
              [-37.85423743399991, 66.19944896000004],
              [-37.88158118399991, 66.18577708500004],
              [-37.864125128999945, 66.18301015800006],
              [-37.86392167899993, 66.17536041900007],
              [-37.87437903599994, 66.16620514500005],
              [-37.88841712099992, 66.15851471600007],
              [-37.898508266999954, 66.15615469000005],
              [-37.920033331999946, 66.15517812700006],
              [-37.93000240799995, 66.15228913000004],
              [-37.937611456999946, 66.14716217700004],
              [-37.95360266799992, 66.12775299700007],
              [-37.96792558499993, 66.11798737200007],
              [-37.985991990999935, 66.11041901200008],
              [-38.00499426999994, 66.10561758000006],
              [-38.03311113199993, 66.10293203300006],
              [-38.05304928299995, 66.09861888200004],
              [-38.06346594999991, 66.09764232000003],
              [-38.07298743399991, 66.10073476800005],
              [-38.077788865999935, 66.10736725500004],
              [-38.081369594999956, 66.11408112200007],
              [-38.08702551999994, 66.11749909100007],
              [-38.106678839999915, 66.11448802300004],
              [-38.11192786399994, 66.10488515800006],
              [-38.10464433499993, 66.09300364800004],
              [-38.08702551999994, 66.08344147300005],
              [-38.06798255099994, 66.08047109600005],
              [-38.01634680899991, 66.08209870000007],
              [-37.97984778599994, 66.09194570500006],
              [-37.96711178299995, 66.08746979400007],
              [-37.95962480399993, 66.07587311400005],
              [-37.95734615799995, 66.05951569200005],
              [-37.96776282499991, 66.05125560100004],
              [-37.98863684799994, 66.04584381700005],
              [-38.00405839799993, 66.03969961100006],
              [-37.99828040299991, 66.02944570500006],
              [-37.996205206999946, 66.01097239800004],
              [-37.98997962099992, 65.99135976800005],
              [-37.986398891999954, 65.97077057500007],
              [-37.985218878999945, 65.94989655200004],
              [-37.998931443999936, 65.93842194200005],
              [-38.02977454299992, 65.92747630400004],
              [-38.06200110599991, 65.92011139500005],
              [-38.080189581999946, 65.91958242400005],
              [-38.074208136999914, 65.93105703300006],
              [-38.069203253999945, 65.94676341400003],
              [-38.07054602799991, 65.96067942900004],
              [-38.08360755099994, 65.96670156500005],
              [-38.09194902299993, 65.96344635600008],
              [-38.11481686099995, 65.94965241100005],
              [-38.12865149599992, 65.94684479400007],
              [-38.12865149599992, 65.95302969000005],
              [-38.12865149599992, 65.96051666900007],
              [-38.128244594999956, 65.96450429900005],
              [-38.132150844999956, 65.96633535400008],
              [-38.14915930899991, 65.96474844000005],
              [-38.155913865999935, 65.96051666900007],
              [-38.16856848899994, 65.97113678600005],
              [-38.18439693899995, 65.97223541900007],
              [-38.19277910099993, 65.96401601800005],
              [-38.18321692599994, 65.94684479400007],
              [-38.17398027299993, 65.94277578300006],
              [-38.14728756399995, 65.93488190300008],
              [-38.14167232999995, 65.92914459800005],
              [-38.14370683499993, 65.92157623900005],
              [-38.149322068999936, 65.91380442900004],
              [-38.15729732999995, 65.90770091400003],
              [-38.16649329299992, 65.90521881700005],
              [-38.269642706999946, 65.90517812700006],
              [-38.31712805899991, 65.91478099200003],
              [-38.355132615999935, 65.93939850500004],
              [-38.34707597599993, 65.94672272300005],
              [-38.34276282499991, 65.95844147300005],
              [-38.345366990999935, 65.96938711100006],
              [-38.369211391999954, 65.97939687700006],
              [-38.38512122299994, 66.00242747600004],
              [-38.39240475199995, 66.00763580900008],
              [-38.40330969999991, 66.00999583500004],
              [-38.42882239499994, 66.02008698100008],
              [-38.44395911399994, 66.02191803600005],
              [-38.46743730399993, 66.02118561400005],
              [-38.47679602799991, 66.01943594000005],
              [-38.48485266799992, 66.01508209800005],
              [-38.45445716099994, 65.98094310100004],
              [-38.45075436099995, 65.96670156500005],
              [-38.45335852799991, 65.95058828300006],
              [-38.45856686099995, 65.93756745000007],
              [-38.459828253999945, 65.92548248900005],
              [-38.45075436099995, 65.91209544500003],
              [-38.43244381399995, 65.90216705900008],
              [-38.29234778599994, 65.86196523600006],
              [-38.27261308499993, 65.85065338700008],
              [-38.27501380099994, 65.84686920800004],
              [-38.279408331999946, 65.83698151200008],
              [-38.237172003999945, 65.83563873900005],
              [-38.12144934799994, 65.81586334800005],
              [-38.10610917899993, 65.81073639500005],
              [-38.10094153599994, 65.79857005400004],
              [-38.103505011999914, 65.78408437700006],
              [-38.11123613199993, 65.77179596600007],
              [-38.12482662699995, 65.76874420800004],
              [-38.19009355399993, 65.77488841400003],
              [-38.18419348899994, 65.76642487200007],
              [-38.170033331999946, 65.75519440300008],
              [-38.163400844999956, 65.74823639500005],
              [-38.16661536399994, 65.74795156500005],
              [-38.17320716099994, 65.74835846600007],
              [-38.17638098899994, 65.74823639500005],
              [-38.169178839999915, 65.73810455900008],
              [-38.16519120999993, 65.73566315300008],
              [-38.16563880099994, 65.72964101800005],
              [-38.18321692599994, 65.71344635600008],
              [-38.18512936099995, 65.70905182500007],
              [-38.184478318999936, 65.70262278900003],
              [-38.18154863199993, 65.69481028900003],
              [-38.17638098899994, 65.68618398600006],
              [-38.19562740799995, 65.68707916900007],
              [-38.209868943999936, 65.69318268400008],
              [-38.22297115799995, 65.70062897300005],
              [-38.23851477799991, 65.70600006700005],
              [-38.25894120999993, 65.70514557500007],
              [-38.24657141799992, 65.69350820500006],
              [-38.223215298999946, 65.68060944200005],
              [-38.21056067599994, 65.67593008000006],
              [-38.22057044199994, 65.64642975500004],
              [-38.24583899599992, 65.63727448100008],
              [-38.27953040299991, 65.64134349200003],
              [-38.31419837099992, 65.65135325700004],
              [-38.316517706999946, 65.65680573100008],
              [-38.32860266799992, 65.65912506700005],
              [-38.361398891999954, 65.65884023600006],
              [-38.37083899599992, 65.65737539300005],
              [-38.38609778599994, 65.65249258000006],
              [-38.39549719999991, 65.65135325700004],
              [-38.40074622299994, 65.65350983300004],
              [-38.413319464999915, 65.66290924700007],
              [-38.41942298099991, 65.66502513200004],
              [-38.43081620999993, 65.65786367400005],
              [-38.439442511999914, 65.62075429900005],
              [-38.45075436099995, 65.60419342700004],
              [-38.46165930899991, 65.59861888200004],
              [-38.47508704299992, 65.59503815300008],
              [-38.48851477799991, 65.59414297100005],
              [-38.49913489499994, 65.59674713700008],
              [-38.507923956999946, 65.60398997600004],
              [-38.50914466099994, 65.61090729400007],
              [-38.50698808499993, 65.61847565300008],
              [-38.50536048099991, 65.62783437700006],
              [-38.49791419199994, 65.65241120000007],
              [-38.47923743399991, 65.66290924700007],
              [-38.45482337099992, 65.66876862200007],
              [-38.43028723899994, 65.67934804900005],
              [-38.45384680899991, 65.68423086100006],
              [-38.49453691299993, 65.67584870000007],
              [-38.51219641799992, 65.67934804900005],
              [-38.51659094999991, 65.68488190300008],
              [-38.52086341099994, 65.70014069200005],
              [-38.52586829299992, 65.70600006700005],
              [-38.538319464999915, 65.71039459800005],
              [-38.54312089799993, 65.70697663000004],
              [-38.541005011999914, 65.69989655200004],
              [-38.53270423099991, 65.69301992400005],
              [-38.544992641999954, 65.67983633000006],
              [-38.550038214999915, 65.67251211100006],
              [-38.55382239499994, 65.66502513200004],
              [-38.55247962099992, 65.65916575700004],
              [-38.54800370999993, 65.65176015800006],
              [-38.54450436099995, 65.64423248900005],
              [-38.54637610599991, 65.63837311400005],
              [-38.56029212099992, 65.63495514500005],
              [-38.57725989499994, 65.63886139500005],
              [-38.59260006399995, 65.64573802300004],
              [-38.601633266999954, 65.65135325700004],
              [-38.596587693999936, 65.65802643400008],
              [-38.58731035099993, 65.67934804900005],
              [-38.605580206999946, 65.68349844000005],
              [-38.62950598899994, 65.68455638200004],
              [-38.64439856699994, 65.68134186400005],
              [-38.63573157499991, 65.67251211100006],
              [-38.63573157499991, 65.66502513200004],
              [-38.68854732999995, 65.66250234600005],
              [-38.703968878999945, 65.66502513200004],
              [-38.72150631399995, 65.67523834800005],
              [-38.736317511999914, 65.68716054900005],
              [-38.75230872299994, 65.69330475500004],
              [-38.77285722599993, 65.68618398600006],
              [-38.78205318899995, 65.66421133000006],
              [-38.75328528599994, 65.64716217700004],
              [-38.71035722599993, 65.63593170800004],
              [-38.676665818999936, 65.63153717700004],
              [-38.667958136999914, 65.63344961100006],
              [-38.66051184799994, 65.63703034100007],
              [-38.65347245999993, 65.63886139500005],
              [-38.64085852799991, 65.63251373900005],
              [-38.63023841099994, 65.63129303600005],
              [-38.62828528599994, 65.62783437700006],
              [-38.629017706999946, 65.61351146000004],
              [-38.62828528599994, 65.61041901200008],
              [-38.60732988199993, 65.59064362200007],
              [-38.60033118399991, 65.57786692900004],
              [-38.60838782499991, 65.56940338700008],
              [-38.61888587099992, 65.57168203300006],
              [-38.65416419199994, 65.58588288000004],
              [-38.669260219999956, 65.58999258000006],
              [-38.75926673099991, 65.58999258000006],
              [-38.77989661399994, 65.59202708500004],
              [-38.81208248599995, 65.61273834800005],
              [-38.830922003999945, 65.61790599200003],
              [-38.84276282499991, 65.61640045800004],
              [-38.85505123599995, 65.61237213700008],
              [-38.86461341099994, 65.60687897300005],
              [-38.88145911399994, 65.57880280200004],
              [-38.91152910099993, 65.56858958500004],
              [-38.94566809799994, 65.57001373900005],
              [-38.97085527299993, 65.58315664300005],
              [-38.962961391999954, 65.58421458500004],
              [-38.95913652299993, 65.58600495000007],
              [-38.956288214999915, 65.58808014500005],
              [-38.95103919199994, 65.58999258000006],
              [-38.98412024599992, 65.58722565300008],
              [-39.01549231699994, 65.57982005400004],
              [-39.07453365799995, 65.55516185100004],
              [-39.07017981699994, 65.57648346600007],
              [-39.06712805899991, 65.58315664300005],
              [-39.08299719999991, 65.59589264500005],
              [-39.10846920499995, 65.63654205900008],
              [-39.12401282499991, 65.64907461100006],
              [-39.14159094999991, 65.66714101800005],
              [-39.149647589999915, 65.67251211100006],
              [-39.16112219999991, 65.67218659100007],
              [-39.16978919199994, 65.66811758000006],
              [-39.17951412699995, 65.66697825700004],
              [-39.23387610599991, 65.69574616100005],
              [-39.27757727799991, 65.70221588700008],
              [-39.31627356699994, 65.71360911700003],
              [-39.34142005099994, 65.74823639500005],
              [-39.366444464999915, 65.72174713700008],
              [-39.357411261999914, 65.71084219000005],
              [-39.32998613199993, 65.70477936400005],
              [-39.29987545499995, 65.69301992400005],
              [-39.291086391999954, 65.68512604400007],
              [-39.27257239499994, 65.65884023600006],
              [-39.24885006399995, 65.64183177300004],
              [-39.241851365999935, 65.63202545800004],
              [-39.24526933499993, 65.61790599200003],
              [-39.228586391999954, 65.61912669500003],
              [-39.21320553299995, 65.61595286700003],
              [-39.20181230399993, 65.60761139500005],
              [-39.19741777299993, 65.59332916900007],
              [-39.20567786399994, 65.58246491100005],
              [-39.22451738199993, 65.57998281500005],
              [-39.25951087099992, 65.58315664300005],
              [-39.27257239499994, 65.58808014500005],
              [-39.29336503799993, 65.60822174700007],
              [-39.30736243399991, 65.61041901200008],
              [-39.31822669199994, 65.60272858300004],
              [-39.31981360599991, 65.58950429900005],
              [-39.31517493399991, 65.57477448100008],
              [-39.30736243399991, 65.56264883000006],
              [-39.314116990999935, 65.55255768400008],
              [-39.323475714999915, 65.54547760600008],
              [-39.33495032499991, 65.54511139500005],
              [-39.34825598899994, 65.55516185100004],
              [-39.35415605399993, 65.56753164300005],
              [-39.35179602799991, 65.57868073100008],
              [-39.34601803299995, 65.59031810100004],
              [-39.34142005099994, 65.60419342700004],
              [-39.33946692599994, 65.61798737200007],
              [-39.339914516999954, 65.62588125200006],
              [-39.34434973899994, 65.62783437700006],
              [-39.35448157499991, 65.62409088700008],
              [-39.35415605399993, 65.62152741100005],
              [-39.36192786399994, 65.60419342700004],
              [-39.367298956999946, 65.60040924700007],
              [-39.389881964999915, 65.58999258000006],
              [-39.37987219999991, 65.56708405200004],
              [-39.38516191299993, 65.55194733300004],
              [-39.40119381399995, 65.54368724200003],
              [-39.42341061099995, 65.54148997600004],
              [-39.448150193999936, 65.54694245000007],
              [-39.46816972599993, 65.55931224200003],
              [-39.50527910099993, 65.58999258000006],
              [-39.49864661399994, 65.59389883000006],
              [-39.49160722599993, 65.59674713700008],
              [-39.49160722599993, 65.60419342700004],
              [-39.50914466099994, 65.60541413000004],
              [-39.53197180899991, 65.61025625200006],
              [-39.54759680899991, 65.61977773600006],
              [-39.54344641799992, 65.63495514500005],
              [-39.53270423099991, 65.64329661700003],
              [-39.513335740999935, 65.65273672100005],
              [-39.50527910099993, 65.65884023600006],
              [-39.52489173099991, 65.66498444200005],
              [-39.544911261999914, 65.65843333500004],
              [-39.56407630099994, 65.64874909100007],
              [-39.58104407499991, 65.64520905200004],
              [-39.59996497299994, 65.65302155200004],
              [-39.635650193999936, 65.67902252800008],
              [-39.65611731699994, 65.68618398600006],
              [-39.66836503799993, 65.68475983300004],
              [-39.68663489499994, 65.67999909100007],
              [-39.703684048999946, 65.67300039300005],
              [-39.71202551999994, 65.66502513200004],
              [-39.70274817599994, 65.65521881700005],
              [-39.635609503999945, 65.62409088700008],
              [-39.65807044199994, 65.61774323100008],
              [-39.682850714999915, 65.62592194200005],
              [-39.70807857999995, 65.63849518400008],
              [-39.73184160099993, 65.64520905200004],
              [-39.75938880099994, 65.64057038000004],
              [-39.77647864499994, 65.62881094000005],
              [-39.774647589999915, 65.61505768400008],
              [-39.74547278599994, 65.60419342700004],
              [-39.74547278599994, 65.59674713700008],
              [-39.79320227799991, 65.59772370000007],
              [-39.81582597599993, 65.59406159100007],
              [-39.834868943999936, 65.58315664300005],
              [-39.729359503999945, 65.56537506700005],
              [-39.71580969999991, 65.55560944200005],
              [-39.71446692599994, 65.54425690300008],
              [-39.73184160099993, 65.53534577000005],
              [-39.75108801999994, 65.53607819200005],
              [-39.79039466099994, 65.55125560100004],
              [-39.810658331999946, 65.55516185100004],
              [-39.822255011999914, 65.54840729400007],
              [-39.82070878799993, 65.53314850500004],
              [-39.81322180899991, 65.51707591400003],
              [-39.80699622299994, 65.50800202000005],
              [-39.82843990799995, 65.50165436400005],
              [-39.85138912699995, 65.50128815300008],
              [-39.87450110599991, 65.50592682500007],
              [-39.99254309799994, 65.55516185100004],
              [-40.01797441299993, 65.57269928600005],
              [-40.03026282499991, 65.57929108300004],
              [-40.04718990799995, 65.58315664300005],
              [-40.06737219999991, 65.58173248900005],
              [-40.08608964799993, 65.57501862200007],
              [-40.102447068999936, 65.56533437700006],
              [-40.11538652299993, 65.55516185100004],
              [-40.11538652299993, 65.54897695500006],
              [-40.104807094999956, 65.54279205900008],
              [-40.082875128999945, 65.53335195500006],
              [-40.07445227799991, 65.52850983300004],
              [-40.065337693999936, 65.51972077000005],
              [-40.05907141799992, 65.51178620000007],
              [-40.05223548099991, 65.50543854400007],
              [-40.04092363199993, 65.50116608300004],
              [-40.04092363199993, 65.49494049700007],
              [-40.08145097599993, 65.50088125200006],
              [-40.12677975199995, 65.51292552300004],
              [-40.171864386999914, 65.51927317900004],
              [-40.21165930899991, 65.50800202000005],
              [-40.21849524599992, 65.50800202000005],
              [-40.19127356699994, 65.47943756700005],
              [-40.13304602799991, 65.45962148600006],
              [-39.96910559799994, 65.43699778900003],
              [-39.92564856699994, 65.43939850500004],
              [-39.88463294199994, 65.43659088700008],
              [-39.84170488199993, 65.41864655200004],
              [-39.82331295499995, 65.42649974200003],
              [-39.804351365999935, 65.42304108300004],
              [-39.788726365999935, 65.41217682500007],
              [-39.78026282499991, 65.39813873900005],
              [-39.85960852799991, 65.41034577000005],
              [-39.89134680899991, 65.40615469000005],
              [-39.88267981699994, 65.37763092700004],
              [-39.94200598899994, 65.36839427300004],
              [-39.95099850199995, 65.36058177300004],
              [-39.94172115799995, 65.35407135600008],
              [-39.88267981699994, 65.32982005400004],
              [-39.87149003799993, 65.31793854400007],
              [-39.86485755099994, 65.30426666900007],
              [-39.86815344999991, 65.29291413000004],
              [-39.886382615999935, 65.28827545800004],
              [-39.89216061099995, 65.28583405200004],
              [-39.88829505099994, 65.28042226800005],
              [-39.875884568999936, 65.27155182500007],
              [-39.86440995999993, 65.26650625200006],
              [-39.85252844999991, 65.26337311400005],
              [-39.827463344999956, 65.26097239800004],
              [-39.84142005099994, 65.28807200700004],
              [-39.821156378999945, 65.28766510600008],
              [-39.76598059799994, 65.26776764500005],
              [-39.76598059799994, 65.26097239800004],
              [-39.78648841099994, 65.26097239800004],
              [-39.78648841099994, 65.25413646000004],
              [-39.77749589799993, 65.25389232000003],
              [-39.77139238199993, 65.25238678600005],
              [-39.75914466099994, 65.24730052300004],
              [-39.77586829299992, 65.24225495000007],
              [-39.827463344999956, 65.24115631700005],
              [-39.85757402299993, 65.23578522300005],
              [-39.86815344999991, 65.23558177300004],
              [-39.86900794199994, 65.24115631700005],
              [-39.87913977799991, 65.24494049700007],
              [-39.89122473899994, 65.25128815300008],
              [-39.90416419199994, 65.25580475500004],
              [-39.91681881399995, 65.25413646000004],
              [-39.92715410099993, 65.24477773600006],
              [-39.930572068999936, 65.23273346600007],
              [-39.92711341099994, 65.22138092700004],
              [-39.91681881399995, 65.21381256700005],
              [-39.923939581999946, 65.20612213700008],
              [-39.93309485599991, 65.19830963700008],
              [-39.94444739499994, 65.19293854400007],
              [-39.95840410099993, 65.19269440300008],
              [-39.999989386999914, 65.20014069200005],
              [-40.01162675699993, 65.19769928600005],
              [-40.02529863199993, 65.19277578300006],
              [-40.032093878999945, 65.18797435100004],
              [-39.97057044199994, 65.17918528900003],
              [-39.91681881399995, 65.16535065300008],
              [-39.94249426999994, 65.14891185100004],
              [-39.971587693999936, 65.14581940300008],
              [-40.03010006399995, 65.15176015800006],
              [-40.09117591099994, 65.16632721600007],
              [-40.12287350199995, 65.16620514500005],
              [-40.11538652299993, 65.14492422100005],
              [-40.12291419199994, 65.13743724200003],
              [-40.07371985599991, 65.12909577000005],
              [-40.055531378999945, 65.12262604400007],
              [-40.067616339999915, 65.11009349200003],
              [-40.03758704299992, 65.10285065300008],
              [-39.965687628999945, 65.10765208500004],
              [-39.93732662699995, 65.09650299700007],
              [-39.95763098899994, 65.09003327000005],
              [-39.98029537699995, 65.09129466400003],
              [-40.00377356699994, 65.09528229400007],
              [-40.026682094999956, 65.09650299700007],
              [-40.13512122299994, 65.08746979400007],
              [-40.15306555899991, 65.08197663000004],
              [-40.16584225199995, 65.07196686400005],
              [-40.170033331999946, 65.05548737200007],
              [-40.16466223899994, 65.04083893400008],
              [-40.158273891999954, 65.02895742400005],
              [-40.16319739499994, 65.02334219000005],
              [-40.19176184799994, 65.02757396000004],
              [-40.189116990999935, 65.03148021000004],
              [-40.18431555899991, 65.04189687700006],
              [-40.22911536399994, 65.03974030200004],
              [-40.246937628999945, 65.03375885600008],
              [-40.25951087099992, 65.02142975500004],
              [-40.26081295499995, 65.00360748900005],
              [-40.281361456999946, 65.00116608300004],
              [-40.30125891799992, 65.00885651200008],
              [-40.30040442599994, 65.02142975500004],
              [-40.32713782499991, 65.04035065300008],
              [-40.352121548999946, 65.06391022300005],
              [-40.37873287699995, 65.08344147300005],
              [-40.410267706999946, 65.09027741100005],
              [-40.374338344999956, 65.05385976800005],
              [-40.36929277299993, 65.03847890800006],
              [-40.37926184799994, 65.03204987200007],
              [-40.40184485599991, 65.03270091400003],
              [-40.42617753799993, 65.03803131700005],
              [-40.44163977799991, 65.04559967700004],
              [-40.47842363199993, 65.07135651200008],
              [-40.56525631399995, 65.10081614800004],
              [-40.60204016799992, 65.12376536700003],
              [-40.59361731699994, 65.13934967700004],
              [-40.602772589999915, 65.14520905200004],
              [-40.63341223899994, 65.14492422100005],
              [-40.648996548999946, 65.14203522300005],
              [-40.65843665299991, 65.13442617400005],
              [-40.67100989499994, 65.11009349200003],
              [-40.66348222599993, 65.10394928600005],
              [-40.678578253999945, 65.09369538000004],
              [-40.70445716099994, 65.05548737200007],
              [-40.69871985599991, 65.03851959800005],
              [-40.70718339799993, 65.02960846600007],
              [-40.71979732999995, 65.02928294500003],
              [-40.732411261999914, 65.04604726800005],
              [-40.77334550699993, 65.06915924700007],
              [-40.76781165299991, 65.07233307500007],
              [-40.764963344999956, 65.07542552300004],
              [-40.76284745999993, 65.07892487200007],
              [-40.75967363199993, 65.08283112200007],
              [-40.84634355399993, 65.09662506700005],
              [-40.87580318899995, 65.09650299700007],
            ],
          ],
          [
            [
              [-44.59801184799994, 59.964056708000044],
              [-44.58751380099994, 59.97797272300005],
              [-44.55842037699995, 59.98663971600007],
              [-44.52830969999991, 59.98729075700004],
              [-44.514881964999915, 59.97768789300005],
              [-44.515288865999935, 59.95604075700004],
              [-44.54271399599992, 59.94489166900007],
              [-44.577015753999945, 59.946600653000075],
              [-44.59801184799994, 59.964056708000044],
            ],
          ],
          [
            [
              [-44.35098222599993, 59.98452383000006],
              [-44.369211391999954, 59.96588776200008],
              [-44.399281378999945, 59.95331452000005],
              [-44.42568925699993, 59.956366278000075],
              [-44.43297278599994, 59.98452383000006],
              [-44.42882239499994, 59.99408600500004],
              [-44.415353969999956, 60.01459381700005],
              [-44.409494594999956, 60.044989325000074],
              [-44.401600714999915, 60.057521877000056],
              [-44.37828528599994, 60.08075592700004],
              [-44.408314581999946, 60.07656484600005],
              [-44.42495683499993, 60.05451080900008],
              [-44.43724524599992, 60.02753327000005],
              [-44.454009568999936, 60.00836823100008],
              [-44.471547003999945, 60.00263092700004],
              [-44.48607337099992, 60.003607489000046],
              [-44.494699673999946, 60.01117584800005],
              [-44.49437415299991, 60.025458075000074],
              [-44.48591061099995, 60.03900788000004],
              [-44.46507727799991, 60.055121161000045],
              [-44.46084550699993, 60.07013580900008],
              [-44.46007239499994, 60.096136786000045],
              [-44.45531165299991, 60.11937083500004],
              [-44.44294186099995, 60.137884833000044],
              [-44.41930091099994, 60.149603583000044],
              [-44.38687089799993, 60.149318752000056],
              [-44.337961391999954, 60.14142487200007],
              [-44.29198157499991, 60.128973700000074],
              [-44.268462693999936, 60.11481354400007],
              [-44.251942511999914, 60.10809967700004],
              [-44.23936926999994, 60.095363674000055],
              [-44.22008216099994, 60.066473700000074],
              [-44.21080481699994, 60.05805084800005],
              [-44.203684048999946, 60.053168036000045],
              [-44.20225989499994, 60.047308661000045],
              [-44.21043860599991, 60.036037502000056],
              [-44.21983801999994, 60.031683661000045],
              [-44.26162675699993, 60.025458075000074],
              [-44.29954993399991, 60.00495026200008],
              [-44.30186926999994, 60.00092194200005],
              [-44.303944464999915, 59.991888739000046],
              [-44.30821692599994, 59.98257070500006],
              [-44.31688391799992, 59.97768789300005],
              [-44.32892818899995, 59.97996653900003],
              [-44.337147589999915, 59.98773834800005],
              [-44.34203040299991, 59.998114325000074],
              [-44.34357662699995, 60.00836823100008],
              [-44.338734503999945, 60.01308828300006],
              [-44.316517706999946, 60.029364325000074],
              [-44.31004798099991, 60.03974030200004],
              [-44.339955206999946, 60.03314850500004],
              [-44.36681067599994, 60.01361725500004],
              [-44.37547766799992, 59.99331289300005],
              [-44.35098222599993, 59.98452383000006],
            ],
          ],
          [
            [
              [-44.20360266799992, 60.10736725500004],
              [-44.21275794199994, 60.10984935100004],
              [-44.24058997299994, 60.12295156500005],
              [-44.248036261999914, 60.12909577000005],
              [-44.244984503999945, 60.147365627000056],
              [-44.228586391999954, 60.166449286000045],
              [-44.20811926999994, 60.17527903900003],
              [-44.19273841099994, 60.16266510600008],
              [-44.179676886999914, 60.15656159100007],
              [-44.17015540299991, 60.14679596600007],
              [-44.16698157499991, 60.13471100500004],
              [-44.17292232999995, 60.12164948100008],
              [-44.161366339999915, 60.108303127000056],
              [-44.14708411399994, 60.09589264500005],
              [-44.11082923099991, 60.073919989000046],
              [-44.08556067599994, 60.06541575700004],
              [-44.032093878999945, 60.05548737200007],
              [-44.00841223899994, 60.046576239000046],
              [-44.03262285099993, 60.04047272300005],
              [-44.138661261999914, 60.04132721600007],
              [-44.15367591099994, 60.04669830900008],
              [-44.16270911399994, 60.057074286000045],
              [-44.18517005099994, 60.09398021000004],
              [-44.19371497299994, 60.10346100500004],
              [-44.20360266799992, 60.10736725500004],
            ],
          ],
          [
            [
              [-45.30378170499995, 60.14215729400007],
              [-45.29015051999994, 60.165716864000046],
              [-45.26968339799993, 60.18451569200005],
              [-45.24571692599994, 60.189113674000055],
              [-45.221262173999946, 60.17011139500005],
              [-45.22175045499995, 60.165716864000046],
              [-45.22325598899994, 60.16120026200008],
              [-45.22378495999993, 60.15607330900008],
              [-45.221262173999946, 60.149603583000044],
              [-45.26244055899991, 60.13776276200008],
              [-45.28416907499991, 60.136419989000046],
              [-45.30378170499995, 60.14215729400007],
            ],
          ],
          [
            [
              [-45.15294348899994, 60.38239166900007],
              [-45.13695227799991, 60.361029364000046],
              [-45.142689581999946, 60.343736070000034],
              [-45.17284094999991, 60.31346263200004],
              [-45.180897589999915, 60.27806224200003],
              [-45.18333899599992, 60.27252838700008],
              [-45.19640051999994, 60.269191799000055],
              [-45.224598761999914, 60.25470612200007],
              [-45.27013098899994, 60.24286530200004],
              [-45.31810462099992, 60.20530833500004],
              [-45.34410559799994, 60.19676341400003],
              [-45.40099036399994, 60.18964264500005],
              [-45.411366339999915, 60.194525458000044],
              [-45.38573157499991, 60.217230536000045],
              [-45.39293372299994, 60.23078034100007],
              [-45.38906816299993, 60.247259833000044],
              [-45.37144934799994, 60.27871328300006],
              [-45.36558997299994, 60.29242584800005],
              [-45.36156165299991, 60.30756256700005],
              [-45.35680091099994, 60.374335028000075],
              [-45.34976152299993, 60.38947174700007],
              [-45.33385169199994, 60.39598216400003],
              [-45.307850714999915, 60.393459377000056],
              [-45.287220831999946, 60.38617584800005],
              [-45.24852454299992, 60.36127350500004],
              [-45.232085740999935, 60.38149648600006],
              [-45.207915818999936, 60.39004140800006],
              [-45.18016516799992, 60.38939036700003],
              [-45.15294348899994, 60.38239166900007],
            ],
          ],
          [
            [
              [-45.05614173099991, 60.38239166900007],
              [-45.09609941299993, 60.382473049000055],
              [-45.11603756399995, 60.38812897300005],
              [-45.13182532499991, 60.40216705900008],
              [-45.132150844999956, 60.43378327000005],
              [-45.09406490799995, 60.44782135600008],
              [-45.00210527299993, 60.45062897300005],
              [-45.00210527299993, 60.44623444200005],
              [-45.00348873599995, 60.44318268400008],
              [-45.008371548999946, 60.43695709800005],
              [-45.02757727799991, 60.40375397300005],
              [-45.04124915299991, 60.388657945000034],
              [-45.05614173099991, 60.38239166900007],
            ],
          ],
          [
            [
              [-44.99526933499993, 60.41307200700004],
              [-44.98900305899991, 60.437160549000055],
              [-44.972645636999914, 60.45172760600008],
              [-44.950428839999915, 60.45294830900008],
              [-44.92638098899994, 60.43695709800005],
              [-44.93065344999991, 60.43390534100007],
              [-44.93211829299992, 60.43060944200005],
              [-44.93244381399995, 60.42715078300006],
              [-44.93382727799991, 60.42332591400003],
              [-44.93932044199994, 60.413316148000035],
              [-44.95002193899995, 60.40253327000005],
              [-44.97109941299993, 60.38544342700004],
              [-44.99754798099991, 60.356634833000044],
              [-45.008371548999946, 60.34760163000004],
              [-45.06427975199995, 60.320379950000074],
              [-45.09618079299992, 60.31126536700003],
              [-45.11823482999995, 60.31346263200004],
              [-45.10374915299991, 60.320746161000045],
              [-45.089507615999935, 60.330145575000074],
              [-45.08112545499995, 60.34162018400008],
              [-45.084095831999946, 60.35504791900007],
              [-45.05622311099995, 60.35895416900007],
              [-45.02725175699993, 60.368801174000055],
              [-45.00450598899994, 60.38617584800005],
              [-44.99526933499993, 60.41307200700004],
            ],
          ],
          [
            [
              [-45.35838782499991, 60.47797272300005],
              [-45.35228430899991, 60.45774974200003],
              [-45.360991990999935, 60.44940827000005],
              [-45.37873287699995, 60.44505442900004],
              [-45.39940344999991, 60.43695709800005],
              [-45.39533443899995, 60.42719147300005],
              [-45.40697180899991, 60.424709377000056],
              [-45.425038214999915, 60.42682526200008],
              [-45.440297003999945, 60.43081289300005],
              [-45.430978969999956, 60.43895091400003],
              [-45.417225714999915, 60.443793036000045],
              [-45.40477454299992, 60.44977448100008],
              [-45.39427649599992, 60.47089264500005],
              [-45.38243567599994, 60.47809479400007],
              [-45.36876380099994, 60.48102448100008],
              [-45.35838782499991, 60.47797272300005],
            ],
          ],
          [
            [
              [-45.974720831999946, 60.66974518400008],
              [-45.978627081999946, 60.68048737200007],
              [-45.955189581999946, 60.68195221600007],
              [-45.81163489499994, 60.67182038000004],
              [-45.78294837099992, 60.66290924700007],
              [-45.792225714999915, 60.65289948100008],
              [-45.80797278599994, 60.64370351800005],
              [-45.82579505099994, 60.639837958000044],
              [-45.84129798099991, 60.646185614000046],
              [-45.853179490999935, 60.645697333000044],
              [-45.913319464999915, 60.62872955900008],
              [-45.949330206999946, 60.62287018400008],
              [-45.978505011999914, 60.62327708500004],
              [-45.99038652299993, 60.636704820000034],
              [-45.974720831999946, 60.66974518400008],
            ],
          ],
          [
            [
              [-45.89281165299991, 60.697699286000045],
              [-45.96865800699993, 60.69708893400008],
              [-45.98973548099991, 60.694566148000035],
              [-46.007923956999946, 60.68768952000005],
              [-46.04466712099992, 60.65961334800005],
              [-46.06407630099994, 60.64923737200007],
              [-46.08942623599995, 60.64288971600007],
              [-46.10118567599994, 60.64215729400007],
              [-46.11192786399994, 60.64305247600004],
              [-46.12242591099994, 60.64679596600007],
              [-46.130116339999915, 60.65497467700004],
              [-46.139230923999946, 60.656683661000045],
              [-46.14956620999993, 60.65521881700005],
              [-46.165272589999915, 60.64915599200003],
              [-46.173939581999946, 60.64923737200007],
              [-46.19871985599991, 60.671087958000044],
              [-46.20750891799992, 60.67658112200007],
              [-46.17686926999994, 60.68805573100008],
              [-45.90835527299993, 60.704291083000044],
              [-45.900380011999914, 60.70209381700005],
              [-45.89281165299991, 60.697699286000045],
            ],
          ],
          [
            [
              [-46.63267981699994, 60.75234609600005],
              [-46.605132615999935, 60.76788971600007],
              [-46.568348761999914, 60.77435944200005],
              [-46.532866990999935, 60.76972077000005],
              [-46.50914466099994, 60.75234609600005],
              [-46.537098761999914, 60.75234609600005],
              [-46.553578253999945, 60.74481842700004],
              [-46.56948808499993, 60.74079010600008],
              [-46.63731848899994, 60.73550039300005],
              [-46.642648891999954, 60.73895905200004],
              [-46.63267981699994, 60.75234609600005],
            ],
          ],
          [
            [
              [-46.27635657499991, 60.772772528000075],
              [-46.26695716099994, 60.77045319200005],
              [-46.25934811099995, 60.76634349200003],
              [-46.253244594999956, 60.76032135600008],
              [-46.24844316299993, 60.75234609600005],
              [-46.31655839799993, 60.737616278000075],
              [-46.35684160099993, 60.71898021000004],
              [-46.39883378799993, 60.725775458000044],
              [-46.42039954299992, 60.71816640800006],
              [-46.401234503999945, 60.71385325700004],
              [-46.34528561099995, 60.69017161700003],
              [-46.34528561099995, 60.66974518400008],
              [-46.44566809799994, 60.67731354400007],
              [-46.45348059799994, 60.67999909100007],
              [-46.45913652299993, 60.685248114000046],
              [-46.46133378799993, 60.69399648600006],
              [-46.466786261999914, 60.69871653900003],
              [-46.47923743399991, 60.70148346600007],
              [-46.50234941299993, 60.70392487200007],
              [-46.461781378999945, 60.733303127000056],
              [-46.39085852799991, 60.76422760600008],
              [-46.319203253999945, 60.78221263200004],
              [-46.27635657499991, 60.772772528000075],
            ],
          ],
          [
            [
              [-47.31794186099995, 60.81313711100006],
              [-47.312489386999914, 60.80174388200004],
              [-47.30016028599994, 60.79987213700008],
              [-47.28457597599993, 60.80133698100008],
              [-47.269520636999914, 60.800116278000075],
              [-47.222320115999935, 60.786444403000075],
              [-47.24449622299994, 60.768866278000075],
              [-47.28538977799991, 60.77358633000006],
              [-47.35887610599991, 60.792669989000046],
              [-47.350493943999936, 60.80149974200003],
              [-47.34019934799994, 60.80695221600007],
              [-47.31794186099995, 60.81313711100006],
            ],
          ],
          [
            [
              [-47.00259355399993, 60.80695221600007],
              [-46.99046790299991, 60.796576239000046],
              [-46.98399817599994, 60.78534577000005],
              [-46.98680579299992, 60.77631256700005],
              [-47.00259355399993, 60.772772528000075],
              [-47.01622473899994, 60.77684153900003],
              [-47.03746497299994, 60.794989325000074],
              [-47.05101477799991, 60.800116278000075],
              [-47.04283606699994, 60.810532945000034],
              [-47.03034420499995, 60.814154364000046],
              [-47.01610266799992, 60.81240469000005],
              [-47.00259355399993, 60.80695221600007],
            ],
          ],
          [
            [
              [-47.222320115999935, 60.81313711100006],
              [-47.21865800699993, 60.82591380400004],
              [-47.19505774599992, 60.827053127000056],
              [-47.166086391999954, 60.82111237200007],
              [-47.146595831999946, 60.81313711100006],
              [-47.160145636999914, 60.80329010600008],
              [-47.18317623599995, 60.79930247600004],
              [-47.20685787699995, 60.80223216400003],
              [-47.222320115999935, 60.81313711100006],
            ],
          ],
          [
            [
              [-46.30308997299994, 60.82054271000004],
              [-46.32555091099994, 60.799709377000056],
              [-46.365305141999954, 60.784857489000046],
              [-46.40501868399991, 60.78270091400003],
              [-46.42723548099991, 60.800116278000075],
              [-46.35716712099992, 60.82575104400007],
              [-46.33104407499991, 60.827378648000035],
              [-46.32335364499994, 60.82680898600006],
              [-46.316395636999914, 60.82534414300005],
              [-46.30308997299994, 60.82054271000004],
            ],
          ],
          [
            [
              [-47.19440670499995, 60.841009833000044],
              [-47.17174231699994, 60.85224030200004],
              [-47.10114498599995, 60.868841864000046],
              [-47.084543423999946, 60.868353583000044],
              [-47.08568274599992, 60.83746979400007],
              [-47.11733964799993, 60.82684967700004],
              [-47.160227016999954, 60.830145575000074],
              [-47.19440670499995, 60.841009833000044],
            ],
          ],
          [
            [
              [-47.18138587099992, 60.87579987200007],
              [-47.194569464999915, 60.865301825000074],
              [-47.220041469999956, 60.85211823100008],
              [-47.244699673999946, 60.844631252000056],
              [-47.255848761999914, 60.851263739000046],
              [-47.24767005099994, 60.868841864000046],
              [-47.22789466099994, 60.87921784100007],
              [-47.20335852799991, 60.88178131700005],
              [-47.18138587099992, 60.87579987200007],
            ],
          ],
          [
            [
              [-47.173939581999946, 60.882025458000044],
              [-47.15802975199995, 60.89638906500005],
              [-47.133371548999946, 60.90468984600005],
              [-47.11359615799995, 60.913763739000046],
              [-47.11245683499993, 60.93040599200003],
              [-47.071522589999915, 60.93040599200003],
              [-47.084543423999946, 60.91681549700007],
              [-47.09805253799993, 60.89915599200003],
              [-47.12169348899994, 60.88861725500004],
              [-47.14903723899994, 60.88344961100006],
              [-47.173939581999946, 60.882025458000044],
            ],
          ],
          [
            [
              [-47.05101477799991, 60.895697333000044],
              [-47.036773240999935, 60.912176825000074],
              [-47.01187089799993, 60.92633698100008],
              [-46.98424231699994, 60.93378327000005],
              [-46.96165930899991, 60.93040599200003],
              [-46.961048956999946, 60.925482489000046],
              [-46.962554490999935, 60.92401764500005],
              [-46.96544348899994, 60.923895575000074],
              [-46.96910559799994, 60.92300039300005],
              [-46.98888098899994, 60.91107819200005],
              [-47.029408331999946, 60.90346914300005],
              [-47.05101477799991, 60.895697333000044],
            ],
          ],
          [
            [
              [-46.55386308499993, 60.79633209800005],
              [-46.56712805899991, 60.78986237200007],
              [-46.58617102799991, 60.78701406500005],
              [-46.622710740999935, 60.786444403000075],
              [-46.63451087099992, 60.78807200700004],
              [-46.641468878999945, 60.791449286000045],
              [-46.64830481699994, 60.793850002000056],
              [-46.66002356699994, 60.792669989000046],
              [-46.66665605399993, 60.78986237200007],
              [-46.66779537699995, 60.78652578300006],
              [-46.664906378999945, 60.78302643400008],
              [-46.66002356699994, 60.77960846600007],
              [-46.70067298099991, 60.765692450000074],
              [-46.75804602799991, 60.75405508000006],
              [-46.81265214799993, 60.75340403900003],
              [-46.84557044199994, 60.772772528000075],
              [-46.68789628799993, 60.827378648000035],
              [-46.55150305899991, 60.853949286000045],
              [-46.48350989499994, 60.89012278900003],
              [-46.201283331999946, 60.950873114000046],
              [-46.21939042899993, 60.93939850500004],
              [-46.20856686099995, 60.93439362200007],
              [-46.18626868399991, 60.93146393400008],
              [-46.17027747299994, 60.92670319200005],
              [-46.164133266999954, 60.911444403000075],
              [-46.17516028599994, 60.90094635600008],
              [-46.306630011999914, 60.85374583500004],
              [-46.33812415299991, 60.84788646000004],
              [-46.39159094999991, 60.86078522300005],
              [-46.39989173099991, 60.85809967700004],
              [-46.402333136999914, 60.850816148000035],
              [-46.408273891999954, 60.84662506700005],
              [-46.41515051999994, 60.84393952000005],
              [-46.423491990999935, 60.83901601800005],
              [-46.43407141799992, 60.827378648000035],
              [-46.45421301999994, 60.81500885600008],
              [-46.46629798099991, 60.809800523000035],
              [-46.48180091099994, 60.80695221600007],
              [-46.51976477799991, 60.80731842700004],
              [-46.53856360599991, 60.80483633000006],
              [-46.55386308499993, 60.79633209800005],
            ],
          ],
          [
            [
              [-46.52965247299994, 60.991888739000046],
              [-46.50601152299993, 60.99917226800005],
              [-46.47948157499991, 60.99433014500005],
              [-46.42723548099991, 60.978216864000046],
              [-46.43073482999995, 60.97650788000004],
              [-46.436390753999945, 60.97284577000005],
              [-46.440297003999945, 60.97138092700004],
              [-46.42625891799992, 60.93805573100008],
              [-46.45107988199993, 60.92617422100005],
              [-46.48802649599992, 60.92495351800005],
              [-46.51659094999991, 60.93724192900004],
              [-46.50926673099991, 60.95164622600004],
              [-46.51211503799993, 60.96576569200005],
              [-46.52965247299994, 60.991888739000046],
            ],
          ],
          [
            [
              [-48.16112219999991, 61.057074286000045],
              [-48.18382727799991, 61.066107489000046],
              [-48.19591223899994, 61.06777578300006],
              [-48.23509680899991, 61.05499909100007],
              [-48.28351803299995, 61.05451080900008],
              [-48.33145097599993, 61.05955638200004],
              [-48.36009680899991, 61.067572333000044],
              [-48.355580206999946, 61.07290273600006],
              [-48.356312628999945, 61.07611725500004],
              [-48.362172003999945, 61.07859935100004],
              [-48.373117641999954, 61.081244208000044],
              [-48.34727942599994, 61.096991278000075],
              [-48.296986456999946, 61.102850653000075],
              [-48.24193274599992, 61.101223049000055],
              [-48.16193600199995, 61.08893463700008],
              [-48.11986243399991, 61.08808014500005],
              [-48.10069739499994, 61.08539459800005],
              [-48.04409745999993, 61.067572333000044],
              [-48.062489386999914, 61.06085846600007],
              [-48.08250891799992, 61.05890534100007],
              [-48.12328040299991, 61.06012604400007],
              [-48.15330969999991, 61.055975653000075],
              [-48.16112219999991, 61.057074286000045],
            ],
          ],
          [
            [
              [-48.934803839999915, 61.265611070000034],
              [-48.91319739499994, 61.28974030200004],
              [-48.84703528599994, 61.30459219000005],
              [-48.77183997299994, 61.30695221600007],
              [-48.72313391799992, 61.29352448100008],
              [-48.73680579299992, 61.28729889500005],
              [-48.820871548999946, 61.28595612200007],
              [-48.84666907499991, 61.27985260600008],
              [-48.87873287699995, 61.263332424000055],
              [-48.893869594999956, 61.259426174000055],
              [-48.927072719999956, 61.25458405200004],
              [-48.943470831999946, 61.25495026200008],
              [-48.955922003999945, 61.259426174000055],
              [-48.95018469999991, 61.26048411700003],
              [-48.934803839999915, 61.265611070000034],
            ],
          ],
          [
            [
              [-48.688710089999915, 61.36928945500006],
              [-48.55894934799994, 61.37287018400008],
              [-48.52391516799992, 61.36180247600004],
              [-48.51553300699993, 61.33657461100006],
              [-48.533192511999914, 61.325425523000035],
              [-48.586008266999954, 61.31403229400007],
              [-48.58389238199993, 61.31867096600007],
              [-48.580637173999946, 61.329779364000046],
              [-48.57852128799993, 61.33445872600004],
              [-48.63060462099992, 61.31745026200008],
              [-48.64745032499991, 61.31403229400007],
              [-48.666005011999914, 61.31517161700003],
              [-48.715687628999945, 61.33445872600004],
              [-48.77684485599991, 61.32709381700005],
              [-48.81224524599992, 61.32709381700005],
              [-48.83299719999991, 61.34129466400003],
              [-48.72769120999993, 61.36692942900004],
              [-48.688710089999915, 61.36928945500006],
            ],
          ],
          [
            [
              [-49.16478430899991, 61.70136139500005],
              [-49.150380011999914, 61.702378648000035],
              [-49.12559973899994, 61.69578685100004],
              [-49.10065670499995, 61.685980536000045],
              [-49.08568274599992, 61.67715078300006],
              [-49.08429928299995, 61.657904364000046],
              [-49.086496548999946, 61.64288971600007],
              [-49.096913214999915, 61.632879950000074],
              [-49.120350714999915, 61.62872955900008],
              [-49.144520636999914, 61.63157786700003],
              [-49.21662350199995, 61.656683661000045],
              [-49.19908606699994, 61.664496161000045],
              [-49.18586178299995, 61.67593008000006],
              [-49.16478430899991, 61.70136139500005],
            ],
          ],
          [
            [
              [-50.686105923999946, 63.09906647300005],
              [-50.66746985599991, 63.106350002000056],
              [-50.645375128999945, 63.10423411700003],
              [-50.63072669199994, 63.09369538000004],
              [-50.63426673099991, 63.075506903000075],
              [-50.64793860599991, 63.06688060100004],
              [-50.66270911399994, 63.04922109600005],
              [-50.67926998599995, 63.02366771000004],
              [-50.69806881399995, 63.038763739000046],
              [-50.75841223899994, 63.068060614000046],
              [-50.74083411399994, 63.07656484600005],
              [-50.703114386999914, 63.088324286000045],
              [-50.686105923999946, 63.09906647300005],
            ],
          ],
          [
            [
              [-50.68268795499995, 63.12335846600007],
              [-50.69050045499995, 63.11322663000004],
              [-50.69969641799992, 63.11078522300005],
              [-50.71068274599992, 63.11115143400008],
              [-50.72362219999991, 63.10968659100007],
              [-50.74453691299993, 63.102728583000044],
              [-50.76524817599994, 63.09227122600004],
              [-50.78978430899991, 63.08437734600005],
              [-50.81720943899995, 63.084051825000074],
              [-50.843413865999935, 63.09137604400007],
              [-50.86424719999991, 63.10594310100004],
              [-50.87877356699994, 63.12518952000005],
              [-50.88003495999993, 63.13841380400004],
              [-50.86754309799994, 63.14834219000005],
              [-50.818470831999946, 63.16290924700007],
              [-50.81090247299994, 63.16665273600006],
              [-50.79328365799995, 63.184027411000045],
              [-50.783314581999946, 63.190659898000035],
              [-50.77196204299992, 63.191839911000045],
              [-50.73062089799993, 63.171942450000074],
              [-50.71117102799991, 63.13458893400008],
              [-50.68268795499995, 63.12335846600007],
            ],
          ],
          [
            [
              [-50.49767005099994, 63.17450592700004],
              [-50.48595130099994, 63.167629299000055],
              [-50.472727016999954, 63.15704987200007],
              [-50.46934973899994, 63.14740631700005],
              [-50.48745683499993, 63.14321523600006],
              [-50.57754472599993, 63.13385651200008],
              [-50.607533331999946, 63.11969635600008],
              [-50.624338344999956, 63.116522528000075],
              [-50.63809160099993, 63.11741771000004],
              [-50.65294348899994, 63.12059153900003],
              [-50.66637122299994, 63.12689850500004],
              [-50.675852016999954, 63.13694896000004],
              [-50.679798956999946, 63.148504950000074],
              [-50.67601477799991, 63.15403880400004],
              [-50.65469316299993, 63.164943752000056],
              [-50.60220292899993, 63.20465729400007],
              [-50.57144120999993, 63.21283600500004],
              [-50.53929602799991, 63.198431708000044],
              [-50.53335527299993, 63.18724192900004],
              [-50.52403723899994, 63.18235911700003],
              [-50.51195227799991, 63.17959219000005],
              [-50.49767005099994, 63.17450592700004],
            ],
          ],
          [
            [
              [-52.06676184799994, 64.16486237200007],
              [-52.02765865799995, 64.18138255400004],
              [-51.93858801999994, 64.18537018400008],
              [-51.89549719999991, 64.19155508000006],
              [-51.88166539999992, 64.16751398500008],
              [-51.9320671129999, 64.13409389400005],
              [-51.993905852999944, 64.12183051000005],
              [-52.02925852599992, 64.12627739700008],
              [-52.0447347139999, 64.10488349000008],
              [-52.083428745999925, 64.12824889700005],
              [-52.06676184799994, 64.16486237200007],
            ],
          ],
          [
            [
              [-50.805531378999945, 64.52798086100006],
              [-50.822377081999946, 64.48517487200007],
              [-50.862172003999945, 64.46214427300004],
              [-50.95641028599994, 64.43170807500007],
              [-50.999989386999914, 64.40412018400008],
              [-51.03892981699994, 64.37030670800004],
              [-51.06505286399994, 64.33466217700004],
              [-51.08218339799993, 64.32074616100005],
              [-51.107492641999954, 64.31500885600008],
              [-51.12682044199994, 64.30556875200006],
              [-51.138661261999914, 64.26373932500007],
              [-51.15534420499995, 64.25421784100007],
              [-51.18126380099994, 64.24876536700003],
              [-51.230539516999954, 64.22492096600007],
              [-51.25804602799991, 64.21942780200004],
              [-51.282093878999945, 64.22264232000003],
              [-51.31460527299993, 64.23175690300008],
              [-51.33861243399991, 64.24579498900005],
              [-51.336822068999936, 64.26410553600005],
              [-51.30964107999995, 64.27435944200005],
              [-51.24657141799992, 64.25698476800005],
              [-51.21711178299995, 64.26044342700004],
              [-51.22728430899991, 64.26984284100007],
              [-51.23908443899995, 64.27578359600005],
              [-51.264881964999915, 64.28148021000004],
              [-51.24742591099994, 64.29913971600007],
              [-51.21910559799994, 64.30060455900008],
              [-51.18789628799993, 64.29755280200004],
              [-51.16185462099992, 64.30141836100006],
              [-51.19298255099994, 64.32416413000004],
              [-51.20677649599992, 64.33722565300008],
              [-51.19579016799992, 64.34625885600008],
              [-51.19082597599993, 64.35350169500003],
              [-51.184437628999945, 64.36078522300005],
              [-51.175445115999935, 64.36408112200007],
              [-51.16356360599991, 64.36522044500003],
              [-51.152902798999946, 64.36871979400007],
              [-51.143422003999945, 64.37490469000005],
              [-51.13512122299994, 64.38397858300004],
              [-51.14525305899991, 64.39069245000007],
              [-51.15684973899994, 64.39520905200004],
              [-51.16930091099994, 64.39752838700008],
              [-51.18228105399993, 64.39765045800004],
              [-51.157541469999956, 64.41083405200004],
              [-51.11831620999993, 64.42584870000007],
              [-51.08731035099993, 64.44379303600005],
              [-51.08731035099993, 64.46588776200008],
              [-51.077463344999956, 64.48411692900004],
              [-51.06285559799994, 64.49827708500004],
              [-51.02525794199994, 64.52114492400005],
              [-51.03010006399995, 64.52798086100006],
              [-51.03335527299993, 64.53974030200004],
              [-51.03172766799992, 64.55093008000006],
              [-51.02183997299994, 64.55585358300004],
              [-50.86558997299994, 64.55719635600008],
              [-50.82982337099992, 64.54950592700004],
              [-50.805531378999945, 64.52798086100006],
            ],
          ],
          [
            [
              [-51.29930579299992, 64.38080475500004],
              [-51.31908118399991, 64.37612539300005],
              [-51.34406490799995, 64.37523021000004],
              [-51.36815344999991, 64.37881094000005],
              [-51.40347245999993, 64.39716217700004],
              [-51.42463131399995, 64.39728424700007],
              [-51.505116339999915, 64.38397858300004],
              [-51.51553300699993, 64.38719310100004],
              [-51.51520748599995, 64.39447663000004],
              [-51.50804602799991, 64.40176015800006],
              [-51.49828040299991, 64.40509674700007],
              [-51.45376542899993, 64.40741608300004],
              [-51.43146725199995, 64.41331614800004],
              [-51.415679490999935, 64.42487213700008],
              [-51.42137610599991, 64.42812734600005],
              [-51.42442786399994, 64.43134186400005],
              [-51.42674719999991, 64.43480052300004],
              [-51.43000240799995, 64.43854401200008],
              [-51.383697068999936, 64.44204336100006],
              [-51.34064693899995, 64.45221588700008],
              [-51.350493943999936, 64.47968170800004],
              [-51.27611243399991, 64.53424713700008],
              [-51.264881964999915, 64.56207916900007],
              [-51.09414628799993, 64.56952545800004],
              [-51.09414628799993, 64.56207916900007],
              [-51.098500128999945, 64.56191640800006],
              [-51.10130774599992, 64.56045156500005],
              [-51.10383053299995, 64.55825429900005],
              [-51.14077714799993, 64.53510163000004],
              [-51.15648352799991, 64.52236562700006],
              [-51.16869055899991, 64.50747304900005],
              [-51.171213344999956, 64.49750397300005],
              [-51.172434048999946, 64.47101471600007],
              [-51.17613684799994, 64.45966217700004],
              [-51.210275844999956, 64.44599030200004],
              [-51.24714107999995, 64.41014232000003],
              [-51.26284745999993, 64.39899323100008],
              [-51.29930579299992, 64.38080475500004],
            ],
          ],
          [
            [
              [-43.706695115999935, 59.90253327000005],
              [-43.65916907499991, 59.88320547100005],
              [-43.639515753999945, 59.869126695000034],
              [-43.644642706999946, 59.85419342700004],
              [-43.65762285099993, 59.85138580900008],
              [-43.66930091099994, 59.85687897300005],
              [-43.67882239499994, 59.864569403000075],
              [-43.68590247299994, 59.868475653000075],
              [-43.69493567599994, 59.86505768400008],
              [-43.72720292899993, 59.841131903000075],
              [-43.73265540299991, 59.841498114000046],
              [-43.73818925699993, 59.84516022300005],
              [-43.744252081999946, 59.84760163000004],
              [-43.75112870999993, 59.84454987200007],
              [-43.75340735599991, 59.83974844000005],
              [-43.75499426999994, 59.829413153000075],
              [-43.75829016799992, 59.827460028000075],
              [-43.77013098899994, 59.823879299000055],
              [-43.780913865999935, 59.817694403000075],
              [-43.79149329299992, 59.816473700000074],
              [-43.80296790299991, 59.827460028000075],
              [-43.79670162699995, 59.839911200000074],
              [-43.79796301999994, 59.84271881700005],
              [-43.80296790299991, 59.84796784100007],
              [-43.783314581999946, 59.86151764500005],
              [-43.76838131399995, 59.878241278000075],
              [-43.76720130099994, 59.89008209800005],
              [-43.78868567599994, 59.88890208500004],
              [-43.80736243399991, 59.87958405200004],
              [-43.82502193899995, 59.86383698100008],
              [-43.83470618399991, 59.84520091400003],
              [-43.82966061099995, 59.827460028000075],
              [-43.846587693999936, 59.81146881700005],
              [-43.87083899599992, 59.79877350500004],
              [-43.89671790299991, 59.792629299000055],
              [-43.91905676999994, 59.796128648000035],
              [-43.93276933499993, 59.80996328300006],
              [-43.931304490999935, 59.82648346600007],
              [-43.90587317599994, 59.87103913000004],
              [-43.90111243399991, 59.876613674000055],
              [-43.90021725199995, 59.88141510600008],
              [-43.90538489499994, 59.88890208500004],
              [-43.91624915299991, 59.89667389500005],
              [-43.92162024599992, 59.891506252000056],
              [-43.924712693999936, 59.88068268400008],
              [-43.928944464999915, 59.871527411000045],
              [-43.94481360599991, 59.863714911000045],
              [-43.964955206999946, 59.85732656500005],
              [-43.978179490999935, 59.84870026200008],
              [-43.97362219999991, 59.833685614000046],
              [-44.00767981699994, 59.81785716400003],
              [-44.05386308499993, 59.80609772300005],
              [-44.09609941299993, 59.80809153900003],
              [-44.11827551999994, 59.833685614000046],
              [-44.11546790299991, 59.84202708500004],
              [-44.113392706999946, 59.86033763200004],
              [-44.11082923099991, 59.868475653000075],
              [-44.104725714999915, 59.87718333500004],
              [-44.07079016799992, 59.90680573100008],
              [-44.02611243399991, 59.93353913000004],
              [-44.011830206999946, 59.94721100500004],
              [-43.96133378799993, 59.978176174000055],
              [-43.913319464999915, 59.971136786000045],
              [-43.86400305899991, 59.94969310100004],
              [-43.809803839999915, 59.93732330900008],
              [-43.78205318899995, 59.93431224200003],
              [-43.75560462099992, 59.92633698100008],
              [-43.706695115999935, 59.90253327000005],
            ],
          ],
          [
            [
              [-43.20645097599993, 59.97089264500005],
              [-43.21890214799993, 59.97174713700008],
              [-43.23119055899991, 59.971136786000045],
              [-43.243031378999945, 59.96869538000004],
              [-43.25426184799994, 59.964056708000044],
              [-43.22012285099993, 59.95099518400008],
              [-43.236887173999946, 59.94318268400008],
              [-43.270375128999945, 59.94578685100004],
              [-43.285267706999946, 59.94041575700004],
              [-43.299387173999946, 59.92865631700005],
              [-43.301991339999915, 59.928941148000035],
              [-43.30231686099995, 59.93764883000006],
              [-43.309478318999936, 59.95099518400008],
              [-43.30772864499994, 59.95795319200005],
              [-43.31004798099991, 59.962144273000035],
              [-43.31944739499994, 59.964056708000044],
              [-43.32640540299991, 59.96157461100006],
              [-43.32945716099994, 59.95538971600007],
              [-43.32998613199993, 59.94041575700004],
              [-43.33389238199993, 59.927801825000074],
              [-43.343861456999946, 59.91791413000004],
              [-43.357085740999935, 59.91307200700004],
              [-43.37096106699994, 59.91559479400007],
              [-43.37100175699993, 59.92055898600006],
              [-43.36937415299991, 59.92365143400008],
              [-43.36351477799991, 59.92987702000005],
              [-43.32921301999994, 59.99583567900004],
              [-43.31602942599994, 60.00495026200008],
              [-43.290272589999915, 60.00214264500005],
              [-43.25914466099994, 59.99477773600006],
              [-43.22899329299992, 59.98383209800005],
              [-43.20645097599993, 59.97089264500005],
            ],
          ],
          [
            [
              [-44.00841223899994, 59.99135976800005],
              [-44.06777910099993, 59.95579661700003],
              [-44.08657792899993, 59.95099518400008],
              [-44.102406378999945, 59.94440338700008],
              [-44.13499915299991, 59.913316148000035],
              [-44.151275193999936, 59.90289948100008],
              [-44.16258704299992, 59.91315338700008],
              [-44.16234290299991, 59.92641836100006],
              [-44.15176347599993, 59.964056708000044],
              [-44.15282141799992, 59.986029364000046],
              [-44.15965735599991, 59.98493073100008],
              [-44.166127081999946, 59.97011953300006],
              [-44.166086391999954, 59.95099518400008],
              [-44.18504798099991, 59.91225820500006],
              [-44.19273841099994, 59.90253327000005],
              [-44.20763098899994, 59.89789459800005],
              [-44.24937903599994, 59.893011786000045],
              [-44.279286261999914, 59.87885163000004],
              [-44.30052649599992, 59.87567780200004],
              [-44.34044348899994, 59.874660549000055],
              [-44.351551886999914, 59.87909577000005],
              [-44.39879309799994, 59.909409898000035],
              [-44.37157141799992, 59.91811758000006],
              [-44.34984290299991, 59.93195221600007],
              [-44.31004798099991, 59.964056708000044],
              [-44.27452551999994, 59.98102448100008],
              [-44.268462693999936, 59.987941799000055],
              [-44.263661261999914, 60.00332265800006],
              [-44.252023891999954, 60.01080963700008],
              [-44.23737545499995, 60.01544830900008],
              [-44.22374426999994, 60.02240631700005],
              [-44.200103318999936, 60.02789948100008],
              [-44.02513587099992, 60.01805247600004],
              [-43.997385219999956, 60.01007721600007],
              [-44.00841223899994, 59.99135976800005],
            ],
          ],
          [
            [
              [-43.37718665299991, 59.99135976800005],
              [-43.36204993399991, 59.979681708000044],
              [-43.372303839999915, 59.95872630400004],
              [-43.394602016999954, 59.938788153000075],
              [-43.415353969999956, 59.92987702000005],
              [-43.43146725199995, 59.934027411000045],
              [-43.43773352799991, 59.94318268400008],
              [-43.44054114499994, 59.952337958000044],
              [-43.44603430899991, 59.95661041900007],
              [-43.459828253999945, 59.952378648000035],
              [-43.47134355399993, 59.94179922100005],
              [-43.47716223899994, 59.92829010600008],
              [-43.47337805899991, 59.91559479400007],
              [-43.49372311099995, 59.91128164300005],
              [-43.514963344999956, 59.909409898000035],
              [-43.507476365999935, 59.91559479400007],
              [-43.504465298999946, 59.929022528000075],
              [-43.48704993399991, 59.964056708000044],
              [-43.49449622299994, 59.97089264500005],
              [-43.48257402299993, 59.98452383000006],
              [-43.47789466099994, 60.00580475500004],
              [-43.46934973899994, 60.02680084800005],
              [-43.44603430899991, 60.03974030200004],
              [-43.413400844999956, 60.03660716400003],
              [-43.37169348899994, 60.02411530200004],
              [-43.35000566299993, 60.00722890800006],
              [-43.37718665299991, 59.99135976800005],
            ],
          ],
          [
            [
              [-43.17170162699995, 60.073919989000046],
              [-43.15074622299994, 60.071519273000035],
              [-43.13076738199993, 60.066473700000074],
              [-43.13585364499994, 60.06028880400004],
              [-43.14244544199994, 60.054754950000074],
              [-43.15013587099992, 60.05019765800006],
              [-43.15868079299992, 60.046576239000046],
              [-43.14098059799994, 60.03221263200004],
              [-43.157134568999936, 60.01243724200003],
              [-43.189523891999954, 59.99591705900008],
              [-43.22012285099993, 59.99135976800005],
              [-43.23672441299993, 59.99640534100007],
              [-43.246205206999946, 60.003241278000075],
              [-43.25462805899991, 60.011053778000075],
              [-43.26793372299994, 60.01927317900004],
              [-43.28473873599995, 60.02362702000005],
              [-43.32022050699993, 60.02643463700008],
              [-43.33617102799991, 60.03229401200008],
              [-43.34219316299993, 60.03961823100008],
              [-43.34483801999994, 60.048163153000075],
              [-43.35000566299993, 60.05573151200008],
              [-43.36351477799991, 60.060248114000046],
              [-43.36974036399994, 60.05658600500004],
              [-43.37535559799994, 60.04828522300005],
              [-43.38117428299995, 60.04169342700004],
              [-43.38805091099994, 60.04315827000005],
              [-43.395375128999945, 60.04710521000004],
              [-43.42560787699995, 60.052801825000074],
              [-43.50169837099992, 60.07770416900007],
              [-43.54206295499995, 60.085191148000035],
              [-43.57640540299991, 60.08075592700004],
              [-43.57640540299991, 60.073919989000046],
              [-43.52525794199994, 60.06981028900003],
              [-43.49669348899994, 60.06297435100004],
              [-43.48082434799994, 60.052801825000074],
              [-43.48143469999991, 60.03925202000005],
              [-43.48875891799992, 60.020819403000075],
              [-43.49795488199993, 60.00458405200004],
              [-43.50438391799992, 59.99750397300005],
              [-43.51891028599994, 59.99115631700005],
              [-43.52293860599991, 59.962958075000074],
              [-43.541900193999936, 59.95661041900007],
              [-43.55223548099991, 59.950384833000044],
              [-43.55577551999994, 59.937201239000046],
              [-43.564442511999914, 59.92536041900007],
              [-43.59007727799991, 59.923041083000044],
              [-43.60260982999995, 59.92519765800006],
              [-43.61363684799994, 59.92837148600006],
              [-43.623890753999945, 59.93317291900007],
              [-43.63414466099994, 59.94041575700004],
              [-43.64024817599994, 59.94684479400007],
              [-43.64134680899991, 59.951239325000074],
              [-43.641468878999945, 59.95612213700008],
              [-43.647368943999936, 59.97329336100006],
              [-43.64688066299993, 59.98078034100007],
              [-43.64879309799994, 59.987494208000044],
              [-43.65892493399991, 59.99445221600007],
              [-43.67064368399991, 59.99843984600005],
              [-43.679025844999956, 59.99778880400004],
              [-43.68394934799994, 59.992173570000034],
              [-43.685658331999946, 59.98110586100006],
              [-43.68468176999994, 59.966131903000075],
              [-43.68614661399994, 59.95693594000005],
              [-43.69595292899993, 59.95229726800005],
              [-43.720366990999935, 59.95099518400008],
              [-43.77098548099991, 59.95555247600004],
              [-43.79539954299992, 59.96173737200007],
              [-43.81655839799993, 59.97089264500005],
              [-43.84015865799995, 59.97492096600007],
              [-43.89976966099994, 59.992173570000034],
              [-43.91905676999994, 60.00495026200008],
              [-43.881703253999945, 60.023098049000055],
              [-43.86204993399991, 60.02968984600005],
              [-43.77391516799992, 60.048041083000044],
              [-43.76817786399994, 60.046576239000046],
              [-43.72248287699995, 60.06281159100007],
              [-43.79401607999995, 60.06264883000006],
              [-43.82359778599994, 60.05345286700003],
              [-43.85680091099994, 60.05927155200004],
              [-43.87189693899995, 60.060248114000046],
              [-43.91079667899993, 60.04779694200005],
              [-43.925852016999954, 60.046576239000046],
              [-43.94082597599993, 60.04857005400004],
              [-43.95409094999991, 60.05304596600007],
              [-43.966053839999915, 60.06012604400007],
              [-43.97704016799992, 60.07013580900008],
              [-43.988840298999946, 60.07640208500004],
              [-44.02122962099992, 60.08022695500006],
              [-44.090687628999945, 60.100775458000044],
              [-44.112538214999915, 60.11225006700005],
              [-44.11082923099991, 60.12909577000005],
              [-44.12962805899991, 60.14203522300005],
              [-44.12214107999995, 60.15766022300005],
              [-44.099598761999914, 60.170803127000056],
              [-44.07331295499995, 60.17633698100008],
              [-43.62250729099995, 60.12512848500006],
              [-43.17170162699995, 60.073919989000046],
            ],
          ],
          [
            [
              [-47.72203528599994, 60.759100653000075],
              [-47.70616614499994, 60.76154205900008],
              [-47.65306555899991, 60.759100653000075],
              [-47.68431555899991, 60.74237702000005],
              [-47.71922766799992, 60.72943756700005],
              [-47.75568600199995, 60.721136786000045],
              [-47.80646725199995, 60.71662018400008],
              [-47.82286536399994, 60.71263255400004],
              [-47.837880011999914, 60.707098700000074],
              [-47.86196855399993, 60.69318268400008],
              [-47.88121497299994, 60.68634674700007],
              [-47.900461391999954, 60.68244049700007],
              [-47.913726365999935, 60.684027411000045],
              [-47.90758216099994, 60.69599030200004],
              [-47.89875240799995, 60.70547109600005],
              [-47.88711503799993, 60.711004950000074],
              [-47.87279212099992, 60.711371161000045],
              [-47.89427649599992, 60.73004791900007],
              [-47.921213344999956, 60.723089911000045],
              [-47.948109503999945, 60.706732489000046],
              [-47.96934973899994, 60.697699286000045],
              [-48.037993943999936, 60.695379950000074],
              [-48.07066809799994, 60.700873114000046],
              [-48.07201087099992, 60.71816640800006],
              [-48.086008266999954, 60.71735260600008],
              [-48.10008704299992, 60.71832916900007],
              [-48.113840298999946, 60.72093333500004],
              [-48.12669837099992, 60.72500234600005],
              [-48.11974036399994, 60.73265208500004],
              [-48.11164303299995, 60.737494208000044],
              [-48.10228430899991, 60.739447333000044],
              [-48.091908331999946, 60.73867422100005],
              [-48.09723873599995, 60.746527411000045],
              [-48.10289466099994, 60.749212958000044],
              [-48.10920162699995, 60.75092194200005],
              [-48.116444464999915, 60.75576406500005],
              [-48.12657630099994, 60.76080963700008],
              [-48.13377844999991, 60.75625234600005],
              [-48.139881964999915, 60.74872467700004],
              [-48.146555141999954, 60.74481842700004],
              [-48.165272589999915, 60.746527411000045],
              [-48.169260219999956, 60.751288153000075],
              [-48.168853318999936, 60.759751695000034],
              [-48.17446855399993, 60.772772528000075],
              [-48.18736731699994, 60.78115469000005],
              [-48.23595130099994, 60.800116278000075],
              [-48.22496497299994, 60.807074286000045],
              [-48.203114386999914, 60.80878327000005],
              [-48.16454016799992, 60.80695221600007],
              [-48.013661261999914, 60.82371653900003],
              [-47.983265753999945, 60.837876695000034],
              [-47.96934973899994, 60.841009833000044],
              [-47.92926998599995, 60.83673737200007],
              [-47.91356360599991, 60.83038971600007],
              [-47.913726365999935, 60.82054271000004],
              [-47.89891516799992, 60.801947333000044],
              [-47.882801886999914, 60.804022528000075],
              [-47.86595618399991, 60.81439850500004],
              [-47.84862219999991, 60.82054271000004],
              [-47.772328253999945, 60.81289297100005],
              [-47.756743943999936, 60.80695221600007],
              [-47.76524817599994, 60.79677969000005],
              [-47.77562415299991, 60.78929271000004],
              [-47.79832923099991, 60.77960846600007],
              [-47.78575598899994, 60.77391185100004],
              [-47.77953040299991, 60.77240631700005],
              [-47.770375128999945, 60.772772528000075],
              [-47.770375128999945, 60.76654694200005],
              [-47.80150305899991, 60.76837799700007],
              [-47.818023240999935, 60.76752350500004],
              [-47.82872473899994, 60.762884833000044],
              [-47.82774817599994, 60.751654364000046],
              [-47.80899003799993, 60.746161200000074],
              [-47.77379309799994, 60.74168528900003],
              [-47.759877081999946, 60.73529694200005],
              [-47.74828040299991, 60.74046458500004],
              [-47.73648027299993, 60.75067780200004],
              [-47.72203528599994, 60.759100653000075],
            ],
          ],
          [
            [
              [-42.77476966099994, 60.90253327000005],
              [-42.624256964999915, 60.895697333000044],
              [-42.64610755099994, 60.88190338700008],
              [-42.69115149599992, 60.871079820000034],
              [-42.76829993399991, 60.86155833500004],
              [-42.90892493399991, 60.87604401200008],
              [-42.95262610599991, 60.87579987200007],
              [-42.944569464999915, 60.87840403900003],
              [-42.924672003999945, 60.88947174700007],
              [-42.905140753999945, 60.89109935100004],
              [-42.85020911399994, 60.90253327000005],
              [-42.77476966099994, 60.90253327000005],
            ],
          ],
          [
            [
              [-42.49388587099992, 61.451157945000034],
              [-42.48216712099992, 61.46478913000004],
              [-42.44904537699995, 61.48615143400008],
              [-42.41234290299991, 61.49860260600008],
              [-42.390288865999935, 61.48533763200004],
              [-42.41942298099991, 61.47752513200004],
              [-42.44432532499991, 61.45482005400004],
              [-42.468088344999956, 61.43886953300006],
              [-42.49388587099992, 61.451157945000034],
            ],
          ],
          [
            [
              [-42.08238684799994, 61.87641022300005],
              [-42.09512285099993, 61.86155833500004],
              [-42.09349524599992, 61.847316799000055],
              [-42.089833136999914, 61.83454010600008],
              [-42.09634355399993, 61.82453034100007],
              [-42.11473548099991, 61.81753164300005],
              [-42.17178300699993, 61.80744049700007],
              [-42.16307532499991, 61.794582424000055],
              [-42.149322068999936, 61.79364655200004],
              [-42.134022589999915, 61.79531484600005],
              [-42.12022864499994, 61.79010651200008],
              [-42.11754309799994, 61.77879466400003],
              [-42.13239498599995, 61.77411530200004],
              [-42.16437740799995, 61.77334219000005],
              [-42.26268469999991, 61.753119208000044],
              [-42.28791256399995, 61.75971100500004],
              [-42.277007615999935, 61.761704820000034],
              [-42.24689693899995, 61.77334219000005],
              [-42.178618943999936, 61.82111237200007],
              [-42.18602454299992, 61.82794830900008],
              [-42.17955481699994, 61.83038971600007],
              [-42.16437740799995, 61.84162018400008],
              [-42.16543535099993, 61.857082424000055],
              [-42.14053300699993, 61.86994049700007],
              [-42.10704505099994, 61.877386786000045],
              [-42.08238684799994, 61.87641022300005],
            ],
          ],
          [
            [
              [-42.30211341099994, 62.574652411000045],
              [-42.28966223899994, 62.58112213700008],
              [-42.27525794199994, 62.58283112200007],
              [-42.26219641799992, 62.57892487200007],
              [-42.25373287699995, 62.568426825000074],
              [-42.27415930899991, 62.568426825000074],
              [-42.231678839999915, 62.55145905200004],
              [-42.160145636999914, 62.58022695500006],
              [-42.12340247299994, 62.560980536000045],
              [-42.13809160099993, 62.54360586100006],
              [-42.142648891999954, 62.527411200000074],
              [-42.13744055899991, 62.51264069200005],
              [-42.12340247299994, 62.49957916900007],
              [-42.14806067599994, 62.498114325000074],
              [-42.17027747299994, 62.490668036000045],
              [-42.19298255099994, 62.48582591400003],
              [-42.219593878999945, 62.49274323100008],
              [-42.21275794199994, 62.49957916900007],
              [-42.22520911399994, 62.50576406500005],
              [-42.26439368399991, 62.511379299000055],
              [-42.28038489499994, 62.52000560100004],
              [-42.286000128999945, 62.530462958000044],
              [-42.29556230399993, 62.561753648000035],
              [-42.30211341099994, 62.574652411000045],
            ],
          ],
          [
            [
              [-42.035267706999946, 62.76703522300005],
              [-41.993478969999956, 62.75047435100004],
              [-41.863270636999914, 62.74591705900008],
              [-41.863270636999914, 62.73908112200007],
              [-41.884022589999915, 62.737209377000056],
              [-41.92520097599993, 62.72760651200008],
              [-41.94591223899994, 62.725490627000056],
              [-41.967355923999946, 62.72955963700008],
              [-42.00621497299994, 62.74827708500004],
              [-42.02782141799992, 62.75336334800005],
              [-42.18614661399994, 62.73932526200008],
              [-42.205922003999945, 62.73289622600004],
              [-42.17788652299993, 62.72402578300006],
              [-42.14289303299995, 62.72150299700007],
              [-42.076242641999954, 62.725490627000056],
              [-42.04718990799995, 62.732082424000055],
              [-42.03075110599991, 62.73261139500005],
              [-42.02090410099993, 62.725490627000056],
              [-42.02208411399994, 62.71499258000006],
              [-42.03156490799995, 62.708685614000046],
              [-42.04409745999993, 62.704006252000056],
              [-42.05451412699995, 62.69818756700005],
              [-42.04906165299991, 62.695013739000046],
              [-42.035267706999946, 62.68451569200005],
              [-42.11656653599994, 62.68451569200005],
              [-42.13320878799993, 62.68886953300006],
              [-42.16392981699994, 62.70807526200008],
              [-42.18228105399993, 62.71246979400007],
              [-42.21076412699995, 62.71336497600004],
              [-42.219593878999945, 62.71246979400007],
              [-42.22752844999991, 62.70917389500005],
              [-42.23460852799991, 62.704291083000044],
              [-42.23908443899995, 62.69989655200004],
              [-42.23940995999993, 62.69818756700005],
              [-42.259429490999935, 62.69765859600005],
              [-42.27135169199994, 62.70343659100007],
              [-42.27424068899995, 62.71539948100008],
              [-42.26740475199995, 62.73289622600004],
              [-42.315744594999956, 62.70453522300005],
              [-42.33568274599992, 62.69818756700005],
              [-42.337880011999914, 62.699204820000034],
              [-42.341053839999915, 62.702053127000056],
              [-42.344960089999915, 62.704779364000046],
              [-42.34935462099992, 62.70563385600008],
              [-42.35391191299993, 62.70302969000005],
              [-42.36172441299993, 62.69391510600008],
              [-42.367298956999946, 62.69196198100008],
              [-42.37743079299992, 62.689886786000045],
              [-42.386057094999956, 62.687201239000046],
              [-42.394642706999946, 62.68829987200007],
              [-42.40453040299991, 62.69818756700005],
              [-42.40217037699995, 62.701605536000045],
              [-42.41201738199993, 62.70547109600005],
              [-42.41982988199993, 62.71430084800005],
              [-42.42564856699994, 62.725490627000056],
              [-42.41112219999991, 62.74664948100008],
              [-42.40453040299991, 62.75336334800005],
              [-42.44554602799991, 62.75336334800005],
              [-42.40510006399995, 62.78583405200004],
              [-42.36388098899994, 62.81146881700005],
              [-42.34935462099992, 62.81329987200007],
              [-42.29841061099995, 62.801214911000045],
              [-42.236398891999954, 62.80801015800006],
              [-42.00658118399991, 62.78237539300005],
              [-41.98619544199994, 62.76703522300005],
              [-42.035267706999946, 62.76703522300005],
            ],
          ],
          [
            [
              [-41.917958136999914, 62.81484609600005],
              [-41.86693274599992, 62.803941148000035],
              [-41.84251868399991, 62.803615627000056],
              [-41.81554114499994, 62.80801015800006],
              [-41.83674068899995, 62.78929271000004],
              [-41.87669837099992, 62.778631903000075],
              [-41.916900193999936, 62.77924225500004],
              [-41.93903561099995, 62.79437897300005],
              [-41.952381964999915, 62.816839911000045],
              [-41.95750891799992, 62.82925039300005],
              [-41.95579993399991, 62.83844635600008],
              [-41.93789628799993, 62.84430573100008],
              [-41.913400844999956, 62.84088776200008],
              [-41.87010657499991, 62.82916901200008],
              [-41.87877356699994, 62.81708405200004],
              [-41.891184048999946, 62.81513092700004],
              [-41.90501868399991, 62.81659577000005],
              [-41.917958136999914, 62.81484609600005],
            ],
          ],
          [
            [
              [-41.58584550699993, 63.01040273600006],
              [-41.56187903599994, 63.01862213700008],
              [-41.52033443899995, 63.02138906500005],
              [-41.47801673099991, 63.019598700000074],
              [-41.45177161399994, 63.014105536000045],
              [-41.469960089999915, 62.987494208000044],
              [-41.47044837099992, 62.97508372600004],
              [-41.45177161399994, 62.973089911000045],
              [-41.50698808499993, 62.938381252000056],
              [-41.51911373599995, 62.92658112200007],
              [-41.54454505099994, 62.89337799700007],
              [-41.55313066299993, 62.886704820000034],
              [-41.56822669199994, 62.87807851800005],
              [-41.58250891799992, 62.875433661000045],
              [-41.58897864499994, 62.88686758000006],
              [-41.582020636999914, 62.900824286000045],
              [-41.54759680899991, 62.921087958000044],
              [-41.53433183499993, 62.93154531500005],
              [-41.556630011999914, 62.93183014500005],
              [-41.596547003999945, 62.911363023000035],
              [-41.612172003999945, 62.91742584800005],
              [-41.610991990999935, 62.91889069200005],
              [-41.610991990999935, 62.921576239000046],
              [-41.61009680899991, 62.92475006700005],
              [-41.58617102799991, 62.95921458500004],
              [-41.58275305899991, 62.96938711100006],
              [-41.58495032499991, 62.97801341400003],
              [-41.588775193999936, 62.988267320000034],
              [-41.59044348899994, 62.999335028000075],
              [-41.58584550699993, 63.01040273600006],
            ],
          ],
          [
            [
              [-41.52749589799993, 63.081732489000046],
              [-41.503895636999914, 63.09739817900004],
              [-41.46971594999991, 63.10814036700003],
              [-41.403960740999935, 63.116522528000075],
              [-41.37364661399994, 63.11115143400008],
              [-41.33189856699994, 63.08445872600004],
              [-41.30842037699995, 63.075506903000075],
              [-41.33543860599991, 63.05418528900003],
              [-41.38548743399991, 63.04734935100004],
              [-41.43968665299991, 63.05101146000004],
              [-41.49242102799991, 63.063666083000044],
              [-41.50422115799995, 63.068060614000046],
              [-41.52749589799993, 63.081732489000046],
            ],
          ],
          [
            [
              [-41.212147589999915, 63.157456773000035],
              [-41.32201087099992, 63.164943752000056],
              [-41.29645748599995, 63.14789459800005],
              [-41.216786261999914, 63.13373444200005],
              [-41.18492591099994, 63.12335846600007],
              [-41.24632727799991, 63.12335846600007],
              [-41.27887936099995, 63.12685781500005],
              [-41.352121548999946, 63.12592194200005],
              [-41.38385982999995, 63.13353099200003],
              [-41.43736731699994, 63.156317450000074],
              [-41.46275794199994, 63.17487213700008],
              [-41.46202551999994, 63.195013739000046],
              [-41.43517005099994, 63.210191148000035],
              [-41.40282141799992, 63.213324286000045],
              [-41.301991339999915, 63.19977448100008],
              [-41.212147589999915, 63.164943752000056],
              [-41.212147589999915, 63.157456773000035],
            ],
          ],
          [
            [
              [-41.147043423999946, 63.284369208000044],
              [-41.105580206999946, 63.24201080900008],
              [-41.09898841099994, 63.22223541900007],
              [-41.12279212099992, 63.21206289300005],
              [-41.15880286399994, 63.218817450000074],
              [-41.18789628799993, 63.23940664300005],
              [-41.24010169199994, 63.28778717700004],
              [-41.232411261999914, 63.259019273000035],
              [-41.21812903599994, 63.237616278000075],
              [-41.21983801999994, 63.22418854400007],
              [-41.260324673999946, 63.21954987200007],
              [-41.29015051999994, 63.233587958000044],
              [-41.34219316299993, 63.28473541900007],
              [-41.36986243399991, 63.28099192900004],
              [-41.352853969999956, 63.271185614000046],
              [-41.34532630099994, 63.25726959800005],
              [-41.348500128999945, 63.24310944200005],
              [-41.36363684799994, 63.23261139500005],
              [-41.38898678299995, 63.228583075000074],
              [-41.41478430899991, 63.23216380400004],
              [-41.438710089999915, 63.24103424700007],
              [-41.45860755099994, 63.25307851800005],
              [-41.48619544199994, 63.26593659100007],
              [-41.554798956999946, 63.311712958000044],
              [-41.67149817599994, 63.362941799000055],
              [-41.719309048999946, 63.39020416900007],
              [-41.73696855399993, 63.39500560100004],
              [-41.77721106699994, 63.40110911700003],
              [-41.84740149599992, 63.432928778000075],
              [-41.86693274599992, 63.45075104400007],
              [-41.863270636999914, 63.47280508000006],
              [-41.83893795499995, 63.48786041900007],
              [-41.803578253999945, 63.49603913000004],
              [-41.70002193899995, 63.49982330900008],
              [-41.68138587099992, 63.49681224200003],
              [-41.65493730399993, 63.48094310100004],
              [-41.623036261999914, 63.472723700000074],
              [-41.61009680899991, 63.46653880400004],
              [-41.60627193899995, 63.461004950000074],
              [-41.600453253999945, 63.44481028900003],
              [-41.59642493399991, 63.438666083000044],
              [-41.58299719999991, 63.43008047100005],
              [-41.53433183499993, 63.41474030200004],
              [-41.518137173999946, 63.41185130400004],
              [-41.48399817599994, 63.41828034100007],
              [-41.465728318999936, 63.41474030200004],
              [-41.42536373599995, 63.396144924000055],
              [-41.417632615999935, 63.39020416900007],
              [-41.41323808499993, 63.374253648000035],
              [-41.41832434799994, 63.364447333000044],
              [-41.44554602799991, 63.349269924000055],
              [-41.28083248599995, 63.349269924000055],
              [-41.26309160099993, 63.34674713700008],
              [-41.23786373599995, 63.34003327000005],
              [-41.21519934799994, 63.330145575000074],
              [-41.197377081999946, 63.30731842700004],
              [-41.147043423999946, 63.284369208000044],
            ],
          ],
          [
            [
              [-51.22329667899993, 63.513739325000074],
              [-51.21751868399991, 63.51190827000005],
              [-51.21239173099991, 63.509426174000055],
              [-51.207875128999945, 63.505560614000046],
              [-51.20409094999991, 63.500067450000074],
              [-51.246083136999914, 63.483587958000044],
              [-51.39586341099994, 63.46653880400004],
              [-51.39586341099994, 63.47280508000006],
              [-51.35716712099992, 63.48647695500006],
              [-51.34740149599992, 63.49323151200008],
              [-51.34520423099991, 63.498928127000056],
              [-51.34288489499994, 63.51593659100007],
              [-51.34064693899995, 63.521185614000046],
              [-51.316395636999914, 63.52985260600008],
              [-51.28307044199994, 63.52985260600008],
              [-51.24913489499994, 63.52374909100007],
              [-51.22329667899993, 63.513739325000074],
            ],
          ],
          [
            [
              [-40.77334550699993, 63.64411041900007],
              [-40.681304490999935, 63.65448639500005],
              [-40.66348222599993, 63.64411041900007],
              [-40.689116990999935, 63.622259833000044],
              [-40.70571855399993, 63.61351146000004],
              [-40.72557532499991, 63.60993073100008],
              [-40.799712693999936, 63.609808661000045],
              [-40.82176673099991, 63.61676666900007],
              [-40.83812415299991, 63.63434479400007],
              [-40.82371985599991, 63.642645575000074],
              [-40.79625403599994, 63.64484284100007],
              [-40.77334550699993, 63.64411041900007],
            ],
          ],
          [
            [
              [-40.67100989499994, 64.21942780200004],
              [-40.65855872299994, 64.21564362200007],
              [-40.64635169199994, 64.21625397300005],
              [-40.63426673099991, 64.22044505400004],
              [-40.62254798099991, 64.22687409100007],
              [-40.63133704299992, 64.20648834800005],
              [-40.65078691299993, 64.20380280200004],
              [-40.69798743399991, 64.21320221600007],
              [-40.931304490999935, 64.21320221600007],
              [-41.01781165299991, 64.20160553600005],
              [-41.034047003999945, 64.20579661700003],
              [-41.04678300699993, 64.21906159100007],
              [-41.05382239499994, 64.22382233300004],
              [-41.06200110599991, 64.22687409100007],
              [-41.06200110599991, 64.23379140800006],
              [-41.05040442599994, 64.23517487200007],
              [-41.04336503799993, 64.23883698100008],
              [-41.04206295499995, 64.24506256700005],
              [-41.047718878999945, 64.25421784100007],
              [-41.03563391799992, 64.25820547100005],
              [-41.01146399599992, 64.26040273600006],
              [-40.99990800699993, 64.26410553600005],
              [-40.99132239499994, 64.27045319200005],
              [-40.980539516999954, 64.28310781500005],
              [-40.972645636999914, 64.28839752800008],
              [-40.95075436099995, 64.29580312700006],
              [-40.82713782499991, 64.31378815300008],
              [-40.72301184799994, 64.30605703300006],
              [-40.677805141999954, 64.29523346600007],
              [-40.68883216099994, 64.29010651200008],
              [-40.69701087099992, 64.28139883000006],
              [-40.71198482999995, 64.26044342700004],
              [-40.70645097599993, 64.25747304900005],
              [-40.696522589999915, 64.24966054900005],
              [-40.691477016999954, 64.24677155200004],
              [-40.711496548999946, 64.23875560100004],
              [-40.732411261999914, 64.23379140800006],
              [-40.71861731699994, 64.22768789300005],
              [-40.707142706999946, 64.22638580900008],
              [-40.66307532499991, 64.22907135600008],
              [-40.659413214999915, 64.22768789300005],
              [-40.67100989499994, 64.21942780200004],
            ],
          ],
          [
            [
              [-40.143422003999945, 64.48700592700004],
              [-40.15526282499991, 64.48090241100005],
              [-40.182199673999946, 64.46246979400007],
              [-40.19176184799994, 64.45221588700008],
              [-40.17711341099994, 64.44061920800004],
              [-40.183664516999954, 64.43414948100008],
              [-40.19774329299992, 64.43427155200004],
              [-40.20543372299994, 64.44232819200005],
              [-40.216053839999915, 64.44912344000005],
              [-40.32095292899993, 64.45368073100008],
              [-40.41055253799993, 64.46702708500004],
              [-40.44505774599992, 64.48016998900005],
              [-40.45856686099995, 64.48191966400003],
              [-40.47671464799993, 64.48663971600007],
              [-40.49278723899994, 64.49408600500004],
              [-40.49962317599994, 64.50405508000006],
              [-40.49644934799994, 64.51585521000004],
              [-40.48232988199993, 64.52912018400008],
              [-40.47911536399994, 64.53815338700008],
              [-40.485259568999936, 64.54730866100005],
              [-40.49950110599991, 64.55320872600004],
              [-40.51549231699994, 64.55756256700005],
              [-40.52696692599994, 64.56207916900007],
              [-40.53502356699994, 64.56891510600008],
              [-40.54051673099991, 64.57636139500005],
              [-40.54454505099994, 64.58527252800008],
              [-40.548085089999915, 64.59686920800004],
              [-40.51984615799995, 64.59613678600005],
              [-40.511789516999954, 64.60297272300005],
              [-40.52013098899994, 64.61432526200008],
              [-40.55504309799994, 64.63788483300004],
              [-40.56212317599994, 64.64984772300005],
              [-40.567290818999936, 64.66351959800005],
              [-40.57534745999993, 64.67877838700008],
              [-40.56794186099995, 64.67877838700008],
              [-40.57652747299994, 64.68943919500003],
              [-40.58812415299991, 64.69627513200004],
              [-40.61632239499994, 64.70673248900005],
              [-40.60204016799992, 64.71287669500003],
              [-40.60204016799992, 64.71971263200004],
              [-40.621205206999946, 64.72308991100005],
              [-40.67300370999993, 64.74632396000004],
              [-40.706288214999915, 64.77301666900007],
              [-40.77334550699993, 64.80231354400007],
              [-40.80626380099994, 64.83002350500004],
              [-40.822377081999946, 64.84857819200005],
              [-40.82518469999991, 64.86066315300008],
              [-40.826283331999946, 64.87152741100005],
              [-40.840728318999936, 64.88515859600005],
              [-40.86953691299993, 64.90473053600005],
              [-40.82872473899994, 64.92902252800008],
              [-40.77281653599994, 64.93866608300004],
              [-40.71654212099992, 64.93227773600006],
              [-40.65575110599991, 64.89687734600005],
              [-40.60997473899994, 64.88544342700004],
              [-40.57201087099992, 64.85887278900003],
              [-40.49962317599994, 64.82957591400003],
              [-40.51073157499991, 64.82733795800004],
              [-40.51984615799995, 64.82330963700008],
              [-40.52765865799995, 64.81732819200005],
              [-40.534413214999915, 64.80914948100008],
              [-40.52281653599994, 64.79979075700004],
              [-40.49762936099995, 64.79035065300008],
              [-40.485991990999935, 64.78119538000004],
              [-40.493397589999915, 64.77435944200005],
              [-40.448475714999915, 64.75242747600004],
              [-40.43919837099992, 64.74087148600006],
              [-40.458648240999935, 64.72589752800008],
              [-40.47337805899991, 64.72223541900007],
              [-40.48615475199995, 64.72313060100004],
              [-40.49876868399991, 64.72553131700005],
              [-40.51329505099994, 64.72589752800008],
              [-40.52611243399991, 64.72247955900008],
              [-40.541005011999914, 64.71588776200008],
              [-40.548166469999956, 64.70962148600006],
              [-40.50999915299991, 64.70123932500007],
              [-40.46080481699994, 64.67739492400005],
              [-40.407134568999936, 64.66644928600005],
              [-40.39443925699993, 64.65265534100007],
              [-40.38719641799992, 64.63471100500004],
              [-40.37612870999993, 64.61664459800005],
              [-40.386830206999946, 64.61591217700004],
              [-40.40721594999991, 64.61082591400003],
              [-40.41710364499994, 64.61050039300005],
              [-40.42796790299991, 64.61456940300008],
              [-40.44863847599993, 64.62807851800005],
              [-40.458648240999935, 64.63100820500006],
              [-40.48338782499991, 64.62759023600006],
              [-40.48204505099994, 64.61884186400005],
              [-40.451283331999946, 64.59686920800004],
              [-40.45929928299995, 64.59467194200005],
              [-40.47911536399994, 64.58258698100008],
              [-40.443470831999946, 64.56574127800008],
              [-40.39492753799993, 64.55532461100006],
              [-40.26463782499991, 64.54279205900008],
              [-40.21890214799993, 64.52830638200004],
              [-40.17552649599992, 64.50849030200004],
              [-40.143422003999945, 64.48700592700004],
            ],
          ],
          [
            [
              [-39.54723059799994, 65.31932200700004],
              [-39.55931555899991, 65.32269928600005],
              [-39.57209225199995, 65.32306549700007],
              [-39.58446204299992, 65.32074616100005],
              [-39.59532630099994, 65.31622955900008],
              [-39.56798255099994, 65.29572174700007],
              [-39.57298743399991, 65.28880442900004],
              [-39.57066809799994, 65.28705475500004],
              [-39.537953253999945, 65.28998444200005],
              [-39.52367102799991, 65.29352448100008],
              [-39.509022589999915, 65.29450104400007],
              [-39.49160722599993, 65.28827545800004],
              [-39.51943925699993, 65.27952708500004],
              [-39.54332434799994, 65.27488841400003],
              [-39.56883704299992, 65.27553945500006],
              [-39.72500566299993, 65.31622955900008],
              [-39.79360917899993, 65.32245514500005],
              [-39.80247962099992, 65.32636139500005],
              [-39.80337480399993, 65.33462148600006],
              [-39.79605058499993, 65.34202708500004],
              [-39.78026282499991, 65.34349192900004],
              [-39.780181443999936, 65.36627838700008],
              [-39.752797003999945, 65.37689850500004],
              [-39.72695878799993, 65.37433502800008],
              [-39.73184160099993, 65.35716380400004],
              [-39.709828253999945, 65.35065338700008],
              [-39.608306443999936, 65.35101959800005],
              [-39.59487870999993, 65.34886302300004],
              [-39.563384568999936, 65.33934153900003],
              [-39.546864386999914, 65.33665599200003],
              [-39.513742641999954, 65.33779531500005],
              [-39.49986731699994, 65.33413320500006],
              [-39.49160722599993, 65.32245514500005],
              [-39.53575598899994, 65.31785716400003],
              [-39.54723059799994, 65.31932200700004],
            ],
          ],
          [
            [
              [-37.21743730399993, 65.58315664300005],
              [-37.17487545499995, 65.59129466400003],
              [-37.11009680899991, 65.59007396000004],
              [-37.050892706999946, 65.57758209800005],
              [-37.02501380099994, 65.55206940300008],
              [-37.032866990999935, 65.53754303600005],
              [-37.051625128999945, 65.54043203300006],
              [-37.07412675699993, 65.54987213700008],
              [-37.09333248599995, 65.55516185100004],
              [-37.120432094999956, 65.54987213700008],
              [-37.169260219999956, 65.53270091400003],
              [-37.19635982999995, 65.53534577000005],
              [-37.19009355399993, 65.53534577000005],
              [-37.20445716099994, 65.54092031500005],
              [-37.21401933499993, 65.55003489800004],
              [-37.21507727799991, 65.56037018400008],
              [-37.20376542899993, 65.56940338700008],
              [-37.20836341099994, 65.57221100500004],
              [-37.21275794199994, 65.57831452000005],
              [-37.21743730399993, 65.58315664300005],
            ],
          ],
          [
            [
              [-52.937611456999946, 65.65884023600006],
              [-52.885975714999915, 65.66071198100008],
              [-52.85960852799991, 65.65619538000004],
              [-52.84825598899994, 65.64179108300004],
              [-52.85309811099995, 65.62421295800004],
              [-52.86514238199993, 65.60980866100005],
              [-52.880848761999914, 65.59845612200007],
              [-52.954416469999956, 65.56598541900007],
              [-52.99510657499991, 65.55882396000004],
              [-53.037098761999914, 65.54328034100007],
              [-53.05846106699994, 65.54531484600005],
              [-53.12767493399991, 65.55434804900005],
              [-53.165679490999935, 65.56028880400004],
              [-53.19082597599993, 65.57689036700003],
              [-53.22447669199994, 65.59292226800005],
              [-53.23078365799995, 65.60224030200004],
              [-53.21816972599993, 65.61416250200006],
              [-53.196197068999936, 65.62441640800006],
              [-53.17536373599995, 65.63084544500003],
              [-52.937611456999946, 65.65884023600006],
            ],
          ],
          [
            [
              [-36.93626868399991, 65.67934804900005],
              [-36.956288214999915, 65.66937897300005],
              [-36.94953365799995, 65.66250234600005],
              [-36.90900631399995, 65.65135325700004],
              [-36.92528235599991, 65.63646067900004],
              [-36.953684048999946, 65.62824127800008],
              [-37.011382615999935, 65.62409088700008],
              [-37.00450598899994, 65.61017487200007],
              [-36.99962317599994, 65.59625885600008],
              [-37.004017706999946, 65.58771393400008],
              [-37.02501380099994, 65.58999258000006],
              [-37.046864386999914, 65.59821198100008],
              [-37.093739386999914, 65.60883209800005],
              [-37.11506100199995, 65.61790599200003],
              [-37.07827714799993, 65.63222890800006],
              [-37.06663977799991, 65.63837311400005],
              [-37.081288214999915, 65.64569733300004],
              [-37.10627193899995, 65.64960358300004],
              [-37.15225175699993, 65.65135325700004],
              [-37.15684973899994, 65.65363190300008],
              [-37.17613684799994, 65.66876862200007],
              [-37.18903561099995, 65.67291901200008],
              [-37.200062628999945, 65.67352936400005],
              [-37.20946204299992, 65.67609284100007],
              [-37.21743730399993, 65.68618398600006],
              [-37.10789954299992, 65.71686432500007],
              [-37.08763587099992, 65.73037344000005],
              [-37.07534745999993, 65.73407623900005],
              [-37.059478318999936, 65.73086172100005],
              [-37.009103969999956, 65.70880768400008],
              [-36.99087480399993, 65.70600006700005],
              [-36.99518795499995, 65.69651927300004],
              [-36.997710740999935, 65.69301992400005],
              [-36.93626868399991, 65.67934804900005],
            ],
          ],
          [
            [
              [-36.78551184799994, 65.87107982000003],
              [-36.76390540299991, 65.85390859600005],
              [-36.77122962099992, 65.84271881700005],
              [-36.79088294199994, 65.83368561400005],
              [-36.805978969999956, 65.82269928600005],
              [-36.80443274599992, 65.81281159100007],
              [-36.78551184799994, 65.76121653900003],
              [-36.828114386999914, 65.74237702000005],
              [-36.84845943899995, 65.73822663000004],
              [-36.868031378999945, 65.74823639500005],
              [-36.87926184799994, 65.76593659100007],
              [-36.89903723899994, 65.77269114800004],
              [-36.921945766999954, 65.77578359600005],
              [-36.94249426999994, 65.78237539300005],
              [-36.93394934799994, 65.78522370000007],
              [-36.92650305899991, 65.78945547100005],
              [-36.92039954299992, 65.79507070500006],
              [-36.91576087099992, 65.80223216400003],
              [-36.95836341099994, 65.80442942900004],
              [-36.97813880099994, 65.80857982000003],
              [-36.997710740999935, 65.81586334800005],
              [-36.970814581999946, 65.81631094000005],
              [-36.941517706999946, 65.82086823100008],
              [-36.88849850199995, 65.83698151200008],
              [-36.839100714999915, 65.86615631700005],
              [-36.81273352799991, 65.87571849200003],
              [-36.78551184799994, 65.87107982000003],
            ],
          ],
          [
            [
              [-37.453968878999945, 65.79254791900007],
              [-37.46165930899991, 65.79783763200004],
              [-37.47484290299991, 65.80438873900005],
              [-37.488392706999946, 65.80927155200004],
              [-37.497385219999956, 65.80971914300005],
              [-37.49885006399995, 65.80337148600006],
              [-37.48961341099994, 65.79584381700005],
              [-37.477447068999936, 65.78839752800008],
              [-37.47008216099994, 65.78237539300005],
              [-37.46861731699994, 65.77240631700005],
              [-37.47248287699995, 65.76532623900005],
              [-37.47520911399994, 65.75824616100005],
              [-37.47008216099994, 65.74823639500005],
              [-37.45929928299995, 65.74237702000005],
              [-37.41539466099994, 65.73395416900007],
              [-37.47874915299991, 65.72662995000007],
              [-37.497385219999956, 65.72028229400007],
              [-37.47227942599994, 65.70734284100007],
              [-37.38320878799993, 65.71898021000004],
              [-37.35057532499991, 65.70970286700003],
              [-37.33836829299992, 65.70408763200004],
              [-37.323109503999945, 65.70132070500006],
              [-37.31224524599992, 65.69513580900008],
              [-37.313059048999946, 65.67934804900005],
              [-37.325062628999945, 65.66681549700007],
              [-37.35985266799992, 65.66205475500004],
              [-37.37450110599991, 65.65135325700004],
              [-37.37100175699993, 65.64057038000004],
              [-37.38499915299991, 65.63458893400008],
              [-37.42292232999995, 65.63153717700004],
              [-37.41624915299991, 65.64606354400007],
              [-37.42479407499991, 65.65493398600006],
              [-37.44090735599991, 65.65704987200007],
              [-37.457020636999914, 65.65135325700004],
              [-37.45299231699994, 65.64866771000004],
              [-37.448109503999945, 65.64272695500006],
              [-37.443348761999914, 65.63837311400005],
              [-37.470692511999914, 65.63361237200007],
              [-37.47752844999991, 65.63153717700004],
              [-37.47984778599994, 65.62645091400003],
              [-37.47931881399995, 65.61937083500004],
              [-37.48119055899991, 65.61318594000005],
              [-37.49083411399994, 65.61041901200008],
              [-37.51040605399993, 65.61416250200006],
              [-37.517648891999954, 65.62262604400007],
              [-37.52000891799992, 65.63202545800004],
              [-37.52529863199993, 65.63837311400005],
              [-37.54588782499991, 65.63735586100006],
              [-37.55581620999993, 65.62051015800006],
              [-37.56944739499994, 65.60211823100008],
              [-37.60106360599991, 65.59674713700008],
              [-37.591908331999946, 65.61261627800008],
              [-37.586781378999945, 65.61790599200003],
              [-37.59483801999994, 65.62030670800004],
              [-37.61465410099993, 65.63153717700004],
              [-37.60106360599991, 65.63837311400005],
              [-37.61375891799992, 65.64423248900005],
              [-37.627023891999954, 65.64740631700005],
              [-37.69277910099993, 65.65497467700004],
              [-37.71129309799994, 65.65420156500005],
              [-37.71397864499994, 65.64826080900008],
              [-37.70140540299991, 65.63361237200007],
              [-37.69298255099994, 65.62689850500004],
              [-37.68297278599994, 65.62409088700008],
              [-37.667307094999956, 65.62319570500006],
              [-37.65111243399991, 65.62006256700005],
              [-37.63719641799992, 65.61395905200004],
              [-37.62832597599993, 65.60419342700004],
              [-37.70665442599994, 65.57330963700008],
              [-37.73790442599994, 65.56940338700008],
              [-37.75649980399993, 65.57265859600005],
              [-37.79161536399994, 65.58673737200007],
              [-37.843006964999915, 65.59438711100006],
              [-37.854725714999915, 65.59296295800004],
              [-37.84748287699995, 65.58315664300005],
              [-37.87572180899991, 65.57709381700005],
              [-37.90689042899993, 65.58779531500005],
              [-37.93407141799992, 65.60639069200005],
              [-37.94981848899994, 65.62409088700008],
              [-37.94688880099994, 65.63483307500007],
              [-37.94806881399995, 65.64817942900004],
              [-37.952015753999945, 65.66156647300005],
              [-37.95734615799995, 65.67251211100006],
              [-37.961781378999945, 65.67890045800004],
              [-37.964507615999935, 65.68146393400008],
              [-37.96792558499993, 65.68378327000005],
              [-37.98159745999993, 65.69550202000005],
              [-37.985991990999935, 65.69818756700005],
              [-37.98729407499991, 65.70058828300006],
              [-37.97052975199995, 65.73712799700007],
              [-37.96589107999995, 65.75267161700003],
              [-37.964182094999956, 65.77179596600007],
              [-37.954335089999915, 65.79637278900003],
              [-37.93073482999995, 65.80231354400007],
              [-37.90151933499993, 65.80052317900004],
              [-37.87535559799994, 65.80223216400003],
              [-37.85985266799992, 65.81647370000007],
              [-37.83775794199994, 65.86151764500005],
              [-37.823557094999956, 65.87107982000003],
              [-37.80833899599992, 65.87287018400008],
              [-37.758697068999936, 65.88475169500003],
              [-37.69664466099994, 65.89158763200004],
              [-37.69566809799994, 65.89402903900003],
              [-37.69676673099991, 65.89874909100007],
              [-37.69688880099994, 65.90326569200005],
              [-37.69318600199995, 65.90521881700005],
              [-37.641184048999946, 65.90501536700003],
              [-37.603627081999946, 65.90070221600007],
              [-37.58702551999994, 65.89496491100005],
              [-37.52183997299994, 65.85431549700007],
              [-37.497385219999956, 65.84320709800005],
              [-37.43150794199994, 65.83283112200007],
              [-37.39688066299993, 65.82322825700004],
              [-37.36709550699993, 65.78799062700006],
              [-37.27208411399994, 65.76121653900003],
              [-37.29320227799991, 65.75556061400005],
              [-37.401275193999936, 65.75775788000004],
              [-37.42096920499995, 65.76532623900005],
              [-37.43809973899994, 65.77716705900008],
              [-37.453968878999945, 65.79254791900007],
            ],
          ],
          [
            [
              [-36.22996985599991, 65.91958242400005],
              [-36.23428300699993, 65.90395742400005],
              [-36.22179114499994, 65.89569733300004],
              [-36.18276933499993, 65.88475169500003],
              [-36.19786536399994, 65.87201569200005],
              [-36.21955318899995, 65.85871002800008],
              [-36.23985755099994, 65.85325755400004],
              [-36.25104732999995, 65.86432526200008],
              [-36.261789516999954, 65.85980866100005],
              [-36.273548956999946, 65.85708242400005],
              [-36.286000128999945, 65.85610586100006],
              [-36.298817511999914, 65.85687897300005],
              [-36.294260219999956, 65.84686920800004],
              [-36.29198157499991, 65.84320709800005],
              [-36.33495032499991, 65.82306549700007],
              [-36.35960852799991, 65.82135651200008],
              [-36.38072669199994, 65.83698151200008],
              [-36.38072669199994, 65.86774323100008],
              [-36.37401282499991, 65.88129303600005],
              [-36.35802161399994, 65.88719310100004],
              [-36.326161261999914, 65.89158763200004],
              [-36.30626380099994, 65.89948151200008],
              [-36.29906165299991, 65.90501536700003],
              [-36.28864498599995, 65.91583893400008],
              [-36.27749589799993, 65.92047760600008],
              [-36.22996985599991, 65.91958242400005],
            ],
          ],
          [
            [
              [-36.75072180899991, 65.90521881700005],
              [-36.70881100199995, 65.93085358300004],
              [-36.627837693999936, 65.95319245000007],
              [-36.54674231699994, 65.96344635600008],
              [-36.50426184799994, 65.95302969000005],
              [-36.504750128999945, 65.92975495000007],
              [-36.52183997299994, 65.91136302300004],
              [-36.56602942599994, 65.88816966400003],
              [-36.58067786399994, 65.88662344000005],
              [-36.594960089999915, 65.88987864800004],
              [-36.60680091099994, 65.88971588700008],
              [-36.614125128999945, 65.87791575700004],
              [-36.61192786399994, 65.86945221600007],
              [-36.604074673999946, 65.86151764500005],
              [-36.586822068999936, 65.85065338700008],
              [-36.59312903599994, 65.84186432500007],
              [-36.59609941299993, 65.83307526200008],
              [-36.59447180899991, 65.82428620000007],
              [-36.586822068999936, 65.81586334800005],
              [-36.621937628999945, 65.79857005400004],
              [-36.63524329299992, 65.79604726800005],
              [-36.646555141999954, 65.80654531500005],
              [-36.73704993399991, 65.80223216400003],
              [-36.72789466099994, 65.81879303600005],
              [-36.68342037699995, 65.84039948100008],
              [-36.685536261999914, 65.85374583500004],
              [-36.69249426999994, 65.86082591400003],
              [-36.70665442599994, 65.88133372600004],
              [-36.71593176999994, 65.88861725500004],
              [-36.75072180899991, 65.90521881700005],
            ],
          ],
          [
            [
              [-35.55150305899991, 66.20693594000005],
              [-35.527902798999946, 66.22968170800004],
              [-35.48216712099992, 66.24213288000004],
              [-35.38703365799995, 66.24848053600005],
              [-35.39679928299995, 66.23786041900007],
              [-35.42064368399991, 66.22931549700007],
              [-35.414947068999936, 66.22117747600004],
              [-35.44912675699993, 66.20050690300008],
              [-35.484486456999946, 66.18488190300008],
              [-35.52086341099994, 66.18048737200007],
              [-35.55833899599992, 66.19330475500004],
              [-35.554351365999935, 66.19643789300005],
              [-35.55308997299994, 66.19965241100005],
              [-35.552805141999954, 66.20307038000004],
              [-35.55150305899991, 66.20693594000005],
            ],
          ],
          [
            [
              [-33.86571204299992, 66.82322825700004],
              [-33.85627193899995, 66.82941315300008],
              [-33.847727016999954, 66.83002350500004],
              [-33.84142005099994, 66.82469310100004],
              [-33.83901933499993, 66.81338125200006],
              [-33.84605872299994, 66.80190664300005],
              [-33.86290442599994, 66.79706452000005],
              [-33.95225989499994, 66.79523346600007],
              [-33.970773891999954, 66.80463288000004],
              [-33.97565670499995, 66.83071523600006],
              [-33.966460740999935, 66.85480377800008],
              [-33.951283331999946, 66.85211823100008],
              [-33.933705206999946, 66.83877187700006],
              [-33.91759192599994, 66.83071523600006],
              [-33.912180141999954, 66.84235260600008],
              [-33.91319739499994, 66.86517975500004],
              [-33.905140753999945, 66.88100820500006],
              [-33.87254798099991, 66.87164948100008],
              [-33.866118943999936, 66.85895416900007],
              [-33.87417558499993, 66.84589264500005],
              [-33.89012610599991, 66.83543528900003],
              [-33.90733801999994, 66.83071523600006],
              [-33.89606686099995, 66.82436758000006],
              [-33.88353430899991, 66.81976959800005],
              [-33.870757615999935, 66.81879303600005],
              [-33.86571204299992, 66.82322825700004],
            ],
          ],
          [
            [
              [-33.47524980399993, 67.18695709800005],
              [-33.44611568899995, 67.19725169500003],
              [-33.37026933499993, 67.20807526200008],
              [-33.33812415299991, 67.20685455900008],
              [-33.37291419199994, 67.17609284100007],
              [-33.41047115799995, 67.15277741100005],
              [-33.44985917899993, 67.14150625200006],
              [-33.48281816299993, 67.15281810100004],
              [-33.46304277299993, 67.16559479400007],
              [-33.452381964999915, 67.17023346600007],
              [-33.44115149599992, 67.17328522300005],
              [-33.47524980399993, 67.18695709800005],
            ],
          ],
          [
            [
              [-33.24937903599994, 67.35765208500004],
              [-33.248036261999914, 67.35407135600008],
              [-33.24742591099994, 67.35065338700008],
              [-33.246083136999914, 67.34731679900005],
              [-33.24254309799994, 67.34398021000004],
              [-33.27672278599994, 67.33100006700005],
              [-33.25377356699994, 67.31924062700006],
              [-33.24649003799993, 67.30560944200005],
              [-33.25609290299991, 67.29775625200006],
              [-33.28351803299995, 67.30304596600007],
              [-33.331288214999915, 67.33783600500004],
              [-33.31484941299993, 67.35268789300005],
              [-33.290272589999915, 67.36859772300005],
              [-33.265614386999914, 67.37596263200004],
              [-33.24937903599994, 67.36505768400008],
              [-33.255116339999915, 67.36054108300004],
              [-33.25495357999995, 67.35919830900008],
              [-33.252023891999954, 67.35895416900007],
              [-33.24937903599994, 67.35765208500004],
            ],
          ],
          [
            [
              [-29.712717251999948, 68.22166575700004],
              [-29.701324022999927, 68.21832916900007],
              [-29.694976365999935, 68.21287669500003],
              [-29.695912238999938, 68.20673248900005],
              [-29.70653235599991, 68.20115794500003],
              [-29.705189581999946, 68.18707916900007],
              [-29.71593176999994, 68.17633698100008],
              [-29.733143683999913, 68.16941966400003],
              [-29.776966925999943, 68.16449616100005],
              [-29.83625240799995, 68.14594147300005],
              [-29.867258266999954, 68.14297109600005],
              [-29.899159308999913, 68.14541250200006],
              [-29.93065344999991, 68.15151601800005],
              [-29.986317511999914, 68.16889069200005],
              [-30.001332160999937, 68.17902252800008],
              [-30.009388800999943, 68.19310130400004],
              [-30.014393683999913, 68.21426015800006],
              [-29.981597459999932, 68.22898997600004],
              [-29.947743292999917, 68.23745351800005],
              [-29.87413489499994, 68.24213288000004],
              [-29.81672115799995, 68.23061758000006],
              [-29.727691209999932, 68.22711823100008],
              [-29.712717251999948, 68.22166575700004],
            ],
          ],
          [
            [
              [-53.09805253799993, 68.45441315300008],
              [-53.06362870999993, 68.44847239800004],
              [-53.03237870999993, 68.43744538000004],
              [-53.00243079299992, 68.43154531500005],
              [-52.97179114499994, 68.44082265800006],
              [-52.991525844999956, 68.44696686400005],
              [-53.03555253799993, 68.46662018400008],
              [-53.05060787699995, 68.47858307500007],
              [-53.04991614499994, 68.49079010600008],
              [-53.02916419199994, 68.49542877800008],
              [-52.992258266999954, 68.49542877800008],
              [-52.966135219999956, 68.48696523600006],
              [-52.94717363199993, 68.46613190300008],
              [-52.92853756399995, 68.44969310100004],
              [-52.902902798999946, 68.45441315300008],
              [-52.90973873599995, 68.46124909100007],
              [-52.89199785099993, 68.45892975500004],
              [-52.87401282499991, 68.45209381700005],
              [-52.86009680899991, 68.44049713700008],
              [-52.85448157499991, 68.42401764500005],
              [-52.864165818999936, 68.41006094000005],
              [-52.88630123599995, 68.39915599200003],
              [-52.91063391799992, 68.39032623900005],
              [-52.95034745999993, 68.36859772300005],
              [-52.97687740799995, 68.36383698100008],
              [-53.091786261999914, 68.36102936400005],
              [-53.114898240999935, 68.36448802300004],
              [-53.11514238199993, 68.37929922100005],
              [-53.12515214799993, 68.38226959800005],
              [-53.15611731699994, 68.38556549700007],
              [-53.19688880099994, 68.39793528900003],
              [-53.207915818999936, 68.39980703300006],
              [-53.205637173999946, 68.41449616100005],
              [-53.20962480399993, 68.42597077000005],
              [-53.22500566299993, 68.43390534100007],
              [-53.19212805899991, 68.43707916900007],
              [-53.13109290299991, 68.45123932500007],
              [-53.09805253799993, 68.45441315300008],
            ],
          ],
          [
            [
              [-51.834095831999946, 68.60521067900004],
              [-51.85899817599994, 68.60659414300005],
              [-51.88634192599994, 68.60480377800008],
              [-51.86392167899993, 68.61212799700007],
              [-51.844634568999936, 68.60883209800005],
              [-51.834095831999946, 68.60521067900004],
            ],
          ],
          [
            [
              [-51.95689856699994, 68.63568756700005],
              [-51.94082597599993, 68.64667389500005],
              [-51.82335364499994, 68.63727448100008],
              [-51.806752081999946, 68.63255442900004],
              [-51.806752081999946, 68.62571849200003],
              [-51.89500891799992, 68.62539297100005],
              [-51.922759568999936, 68.61953359600005],
              [-51.91844641799992, 68.61163971600007],
              [-51.912180141999954, 68.60687897300005],
              [-51.904286261999914, 68.60447825700004],
              [-52.03278561099995, 68.58502838700008],
              [-52.09845943899995, 68.56574127800008],
              [-52.114898240999935, 68.56427643400008],
              [-52.130970831999946, 68.56659577000005],
              [-52.15387936099995, 68.57900625200006],
              [-52.169260219999956, 68.58478424700007],
              [-52.20738684799994, 68.58856842700004],
              [-52.32750403599994, 68.57855866100005],
              [-52.35928300699993, 68.58307526200008],
              [-52.36815344999991, 68.58169179900005],
              [-52.398426886999914, 68.56622955900008],
              [-52.409087693999936, 68.56427643400008],
              [-52.41755123599995, 68.56883372600004],
              [-52.42218990799995, 68.57929108300004],
              [-52.42373613199993, 68.59056224200003],
              [-52.423085089999915, 68.59780508000006],
              [-52.401234503999945, 68.61688873900005],
              [-52.36782792899993, 68.62197500200006],
              [-52.30016028599994, 68.61953359600005],
              [-52.26866614499994, 68.62539297100005],
              [-52.20946204299992, 68.64337799700007],
              [-52.176625128999945, 68.64618561400005],
              [-52.05972245999993, 68.63564687700006],
              [-52.03262285099993, 68.62571849200003],
              [-52.05353756399995, 68.61786530200004],
              [-52.10142981699994, 68.60984935100004],
              [-52.11461341099994, 68.59780508000006],
              [-52.10586503799993, 68.59223053600005],
              [-52.09585527299993, 68.58734772300005],
              [-52.08495032499991, 68.58441803600005],
              [-52.07359778599994, 68.58478424700007],
              [-52.07359778599994, 68.59113190300008],
              [-52.05996660099993, 68.59699127800008],
              [-51.98338782499991, 68.61102936400005],
              [-51.96471106699994, 68.61896393400008],
              [-51.95689856699994, 68.63568756700005],
            ],
          ],
          [
            [
              [-52.35106360599991, 68.64248281500005],
              [-52.37132727799991, 68.65729401200008],
              [-52.39366614499994, 68.66327545800004],
              [-52.419585740999935, 68.66156647300005],
              [-52.48452714799993, 68.64337799700007],
              [-52.63414466099994, 68.62787506700005],
              [-52.64903723899994, 68.62262604400007],
              [-52.66942298099991, 68.61831289300005],
              [-52.735259568999936, 68.62571849200003],
              [-52.93663489499994, 68.60565827000005],
              [-53.05964107999995, 68.57754140800006],
              [-53.121937628999945, 68.57111237200007],
              [-53.09605872299994, 68.60700104400007],
              [-53.065663214999915, 68.63011302300004],
              [-53.02574622299994, 68.64248281500005],
              [-52.82575436099995, 68.65485260600008],
              [-52.765695766999954, 68.66669342700004],
              [-52.782866990999935, 68.67365143400008],
              [-52.84825598899994, 68.66669342700004],
              [-52.84825598899994, 68.67413971600007],
              [-52.632476365999935, 68.70038483300004],
              [-52.63841712099992, 68.70184967700004],
              [-52.64338131399995, 68.70477936400005],
              [-52.64712480399993, 68.70905182500007],
              [-52.649647589999915, 68.71507396000004],
              [-52.52611243399991, 68.71507396000004],
              [-52.53083248599995, 68.71320221600007],
              [-52.53477942599994, 68.71035390800006],
              [-52.53774980399993, 68.70648834800005],
              [-52.53978430899991, 68.70140208500004],
              [-52.25890051999994, 68.70766836100006],
              [-52.24681555899991, 68.71019114800004],
              [-52.22687740799995, 68.71946849200003],
              [-52.217355923999946, 68.71849192900004],
              [-52.19640051999994, 68.71133047100005],
              [-52.17463131399995, 68.70819733300004],
              [-52.12828528599994, 68.70766836100006],
              [-52.137603318999936, 68.70416901200008],
              [-52.147694464999915, 68.70184967700004],
              [-52.15835527299993, 68.70087311400005],
              [-52.169260219999956, 68.70140208500004],
              [-52.20490475199995, 68.69505442900004],
              [-52.21393795499995, 68.69061920800004],
              [-52.241444464999915, 68.66962311400005],
              [-52.270741339999915, 68.65867747600004],
              [-52.29784094999991, 68.64345937700006],
              [-52.32591712099992, 68.63373444200005],
              [-52.35106360599991, 68.64248281500005],
            ],
          ],
          [
            [
              [-51.22329667899993, 69.91425202000005],
              [-51.194650844999956, 69.92194245000007],
              [-51.13658606699994, 69.91852448100008],
              [-51.082102016999954, 69.92690664300005],
              [-51.014963344999956, 69.92536041900007],
              [-51.004750128999945, 69.92047760600008],
              [-50.92943274599992, 69.89813873900005],
              [-50.90176347599993, 69.89378489800004],
              [-50.83665930899991, 69.90062083500004],
              [-50.803944464999915, 69.90037669500003],
              [-50.778228318999936, 69.88694896000004],
              [-50.78555253799993, 69.88202545800004],
              [-50.799387173999946, 69.86587148600006],
              [-50.680531378999945, 69.87030670800004],
              [-50.662180141999954, 69.85626862200007],
              [-50.661366339999915, 69.84284088700008],
              [-50.66185462099992, 69.83515045800004],
              [-50.66759192599994, 69.82933177300004],
              [-50.766835089999915, 69.78388092700004],
              [-50.791086391999954, 69.76837799700007],
              [-50.805531378999945, 69.76341380400004],
              [-50.82656816299993, 69.76357656500005],
              [-50.85879472599993, 69.77513255400004],
              [-50.87441972599993, 69.77708567900004],
              [-50.88914954299992, 69.77204010600008],
              [-50.93590247299994, 69.74298737200007],
              [-50.962147589999915, 69.73041413000004],
              [-50.97150631399995, 69.71954987200007],
              [-50.963734503999945, 69.69721100500004],
              [-50.962554490999935, 69.68496328300006],
              [-50.96369381399995, 69.67267487200007],
              [-50.966908331999946, 69.66445547100005],
              [-50.98534094999991, 69.64350006700005],
              [-50.987172003999945, 69.63410065300008],
              [-50.984364386999914, 69.61945221600007],
              [-50.95543372299994, 69.57880280200004],
              [-50.95107988199993, 69.55939362200007],
              [-50.97716223899994, 69.55117422100005],
              [-50.99852454299992, 69.54995351800005],
              [-51.04670162699995, 69.54083893400008],
              [-51.116078253999945, 69.51276276200008],
              [-51.13512122299994, 69.50958893400008],
              [-51.16746985599991, 69.51194896000004],
              [-51.21251380099994, 69.52179596600007],
              [-51.245350714999915, 69.53831614800004],
              [-51.24132239499994, 69.56110260600008],
              [-51.237538214999915, 69.56419505400004],
              [-51.28563391799992, 69.60708242400005],
              [-51.29963131399995, 69.62628815300008],
              [-51.32266191299993, 69.67536041900007],
              [-51.33311926999994, 69.68773021000004],
              [-51.370025193999936, 69.69513580900008],
              [-51.386789516999954, 69.70115794500003],
              [-51.38499915299991, 69.71190013200004],
              [-51.364491339999915, 69.73041413000004],
              [-51.352772589999915, 69.73834870000007],
              [-51.34064693899995, 69.74298737200007],
              [-51.28701738199993, 69.74042389500005],
              [-51.26406816299993, 69.74713776200008],
              [-51.27171790299991, 69.77024974200003],
              [-51.21666419199994, 69.80438873900005],
              [-51.18321692599994, 69.81891510600008],
              [-51.11945553299995, 69.83152903900003],
              [-51.03111731699994, 69.86810944200005],
              [-51.004750128999945, 69.88694896000004],
              [-51.04605058499993, 69.88426341400003],
              [-51.085926886999914, 69.87689850500004],
              [-51.16185462099992, 69.85285065300008],
              [-51.212147589999915, 69.84296295800004],
              [-51.36107337099992, 69.85285065300008],
              [-51.31993567599994, 69.86945221600007],
              [-51.210926886999914, 69.88837311400005],
              [-51.18228105399993, 69.90745677300004],
              [-51.19359290299991, 69.90656159100007],
              [-51.20421301999994, 69.90713125200006],
              [-51.214182094999956, 69.90949127800008],
              [-51.22329667899993, 69.91425202000005],
            ],
          ],
          [
            [
              [-52.902902798999946, 69.34511953300006],
              [-52.934803839999915, 69.35073476800005],
              [-53.20645097599993, 69.31443919500003],
              [-53.28416907499991, 69.28742096600007],
              [-53.512928839999915, 69.25214264500005],
              [-53.55215410099993, 69.23590729400007],
              [-53.57445227799991, 69.23525625200006],
              [-53.58739173099991, 69.23908112200007],
              [-53.62287350199995, 69.25633372600004],
              [-53.639556443999936, 69.26056549700007],
              [-53.72826087099992, 69.25556061400005],
              [-53.844634568999936, 69.26504140800006],
              [-53.869252081999946, 69.28025950700004],
              [-53.88585364499994, 69.30914948100008],
              [-53.92520097599993, 69.32221100500004],
              [-54.148548956999946, 69.33783600500004],
              [-54.217355923999946, 69.36310455900008],
              [-54.22801673099991, 69.37107982000003],
              [-54.23232988199993, 69.38296133000006],
              [-54.238392706999946, 69.38336823100008],
              [-54.265736456999946, 69.39541250200006],
              [-54.27334550699993, 69.40033600500004],
              [-54.265695766999954, 69.41766998900005],
              [-54.25438391799992, 69.42601146000004],
              [-54.21934973899994, 69.43451569200005],
              [-54.226633266999954, 69.43748607000003],
              [-54.24600175699993, 69.44814687700006],
              [-54.224680141999954, 69.45368073100008],
              [-54.20457923099991, 69.45237864800004],
              [-54.164133266999954, 69.44135163000004],
              [-54.14329993399991, 69.43829987200007],
              [-54.00743567599994, 69.44379303600005],
              [-53.79869544199994, 69.42625560100004],
              [-53.682199673999946, 69.44065989800004],
              [-53.66193600199995, 69.44961172100005],
              [-53.64834550699993, 69.44782135600008],
              [-53.63463294199994, 69.44367096600007],
              [-53.62222245999993, 69.44135163000004],
              [-53.40298417899993, 69.43919505400004],
              [-53.375843878999945, 69.44814687700006],
              [-53.53937740799995, 69.45425039300005],
              [-53.58189856699994, 69.46865469000005],
              [-53.58189856699994, 69.47606028900003],
              [-53.57331295499995, 69.48163483300004],
              [-53.553944464999915, 69.50958893400008],
              [-53.54328365799995, 69.52094147300005],
              [-53.50926673099991, 69.54779694200005],
              [-53.47301184799994, 69.56696198100008],
              [-53.389881964999915, 69.57123444200005],
              [-53.34911048099991, 69.57786692900004],
              [-53.34911048099991, 69.58535390800006],
              [-53.42495683499993, 69.58490631700005],
              [-53.564442511999914, 69.56891510600008],
              [-53.59357662699995, 69.55556875200006],
              [-53.60855058499993, 69.55117422100005],
              [-53.59349524599992, 69.53148021000004],
              [-53.61851966099994, 69.50751373900005],
              [-53.657541469999956, 69.48655833500004],
              [-53.68431555899991, 69.47606028900003],
              [-53.77285722599993, 69.45880768400008],
              [-53.81663977799991, 69.45856354400007],
              [-53.86241614499994, 69.46865469000005],
              [-53.75959225199995, 69.49994538000004],
              [-53.73273678299995, 69.51703522300005],
              [-53.76471920499995, 69.52480703300006],
              [-53.93936113199993, 69.48956940300008],
              [-53.972767706999946, 69.48908112200007],
              [-53.99962317599994, 69.50275299700007],
              [-53.96898352799991, 69.52362702000005],
              [-53.91966712099992, 69.54181549700007],
              [-53.88109290299991, 69.56110260600008],
              [-53.882923956999946, 69.58535390800006],
              [-53.90111243399991, 69.59463125200006],
              [-53.93008378799993, 69.60394928600005],
              [-53.95946204299992, 69.60993073100008],
              [-53.97883053299995, 69.60919830900008],
              [-53.98814856699994, 69.60317617400005],
              [-53.99132239499994, 69.59686920800004],
              [-53.989125128999945, 69.58978913000004],
              [-53.98224850199995, 69.58161041900007],
              [-53.97956295499995, 69.57465241100005],
              [-53.98265540299991, 69.56769440300008],
              [-53.988392706999946, 69.56183502800008],
              [-53.99327551999994, 69.55801015800006],
              [-54.12999426999994, 69.55117422100005],
              [-54.24669348899994, 69.56879303600005],
              [-54.27334550699993, 69.57168203300006],
              [-54.33999589799993, 69.56171295800004],
              [-54.73737545499995, 69.58905670800004],
              [-54.77196204299992, 69.59813060100004],
              [-54.828236456999946, 69.61945221600007],
              [-54.82339433499993, 69.62466054900005],
              [-54.81460527299993, 69.64057038000004],
              [-54.85850989499994, 69.64472077000005],
              [-54.91274980399993, 69.65680573100008],
              [-54.96247311099995, 69.67609284100007],
              [-54.992746548999946, 69.70197174700007],
              [-54.98375403599994, 69.70197174700007],
              [-54.97765051999994, 69.70376211100006],
              [-54.97227942599994, 69.70644765800006],
              [-54.96544348899994, 69.70880768400008],
              [-54.97508704299992, 69.72357819200005],
              [-54.96349036399994, 69.73289622600004],
              [-54.89281165299991, 69.75116608300004],
              [-54.86266028599994, 69.75409577000005],
              [-54.83250891799992, 69.75141022300005],
              [-54.80093339799993, 69.74298737200007],
              [-54.78294837099992, 69.74957916900007],
              [-54.684885219999956, 69.75600820500006],
              [-54.661447719999956, 69.75299713700008],
              [-54.64403235599991, 69.74518463700008],
              [-54.60912024599992, 69.72247955900008],
              [-54.581288214999915, 69.71271393400008],
              [-54.493072068999936, 69.70197174700007],
              [-54.440744594999956, 69.68048737200007],
              [-54.41307532499991, 69.67426178600005],
              [-54.38939368399991, 69.68154531500005],
              [-54.499256964999915, 69.72866445500006],
              [-54.55577551999994, 69.73810455900008],
              [-54.57135982999995, 69.74640534100007],
              [-54.58336341099994, 69.75503164300005],
              [-54.61986243399991, 69.77358633000006],
              [-54.63341223899994, 69.77708567900004],
              [-54.81615149599992, 69.79364655200004],
              [-54.91185462099992, 69.82062409100007],
              [-54.93195553299995, 69.86587148600006],
              [-54.890288865999935, 69.87734609600005],
              [-54.87328040299991, 69.87954336100006],
              [-54.79409745999993, 69.87954336100006],
              [-54.83462480399993, 69.89850495000007],
              [-54.84874426999994, 69.90745677300004],
              [-54.85912024599992, 69.91803620000007],
              [-54.86705481699994, 69.93158600500004],
              [-54.86497962099992, 69.94342682500007],
              [-54.826283331999946, 69.95136139500005],
              [-54.78661048099991, 69.96531810100004],
              [-54.76675370999993, 69.96954987200007],
              [-54.66344153599994, 69.97345612200007],
              [-54.62083899599992, 69.95831940300008],
              [-54.24596106699994, 69.91388580900008],
              [-54.22492428299995, 69.92047760600008],
              [-54.25560462099992, 69.93732330900008],
              [-54.293527798999946, 69.94806549700007],
              [-54.511708136999914, 69.96893952000005],
              [-54.76134192599994, 70.03510163000004],
              [-54.79409745999993, 70.05145905200004],
              [-54.82787024599992, 70.08075592700004],
              [-54.83193925699993, 70.08559804900005],
              [-54.841908331999946, 70.17495351800005],
              [-54.82917232999995, 70.20083242400005],
              [-54.806630011999914, 70.21718984600005],
              [-54.780506964999915, 70.23041413000004],
              [-54.75690670499995, 70.24701569200005],
              [-54.740793423999946, 70.25446198100008],
              [-54.64806067599994, 70.26520416900007],
              [-54.45303300699993, 70.31329987200007],
              [-54.329741990999935, 70.32404205900008],
              [-54.30125891799992, 70.31834544500003],
              [-53.90343176999994, 70.29043203300006],
              [-53.772043423999946, 70.26080963700008],
              [-53.490345831999946, 70.24249909100007],
              [-53.373605923999946, 70.21881745000007],
              [-53.33531653599994, 70.20587799700007],
              [-53.26598059799994, 70.20229726800005],
              [-53.199208136999914, 70.17304108300004],
              [-53.121937628999945, 70.15387604400007],
              [-53.07022050699993, 70.13007233300004],
              [-53.03148352799991, 70.11904531500005],
              [-53.00621497299994, 70.10138580900008],
              [-52.96426347599993, 70.06513092700004],
              [-52.93228105399993, 70.04385000200006],
              [-52.833973761999914, 69.99624258000006],
              [-52.765288865999935, 69.94843170800004],
              [-52.72809811099995, 69.92865631700005],
              [-52.630930141999954, 69.91315338700008],
              [-52.51891028599994, 69.88068268400008],
              [-52.43236243399991, 69.87152741100005],
              [-52.31126868399991, 69.84357330900008],
              [-52.210194464999915, 69.83856842700004],
              [-52.217640753999945, 69.83856842700004],
              [-51.998158331999946, 69.80508047100005],
              [-51.93651282499991, 69.77708567900004],
              [-51.91348222599993, 69.75731028900003],
              [-51.90855872299994, 69.74282461100006],
              [-51.91755123599995, 69.72992584800005],
              [-51.96251380099994, 69.69098541900007],
              [-51.96784420499995, 69.68773021000004],
              [-51.98155676999994, 69.68671295800004],
              [-52.01402747299994, 69.67951080900008],
              [-52.02586829299992, 69.67405833500004],
              [-51.891835089999915, 69.64012278900003],
              [-51.85456295499995, 69.64671458500004],
              [-51.850819464999915, 69.65045807500007],
              [-51.83747311099995, 69.64362213700008],
              [-51.83641516799992, 69.63178131700005],
              [-51.85265051999994, 69.62181224200003],
              [-51.88556881399995, 69.60919830900008],
              [-51.90762285099993, 69.59100983300004],
              [-52.02570553299995, 69.52033112200007],
              [-52.054025844999956, 69.51410553600005],
              [-52.09862219999991, 69.49909088700008],
              [-52.14159094999991, 69.47728099200003],
              [-52.27769934799994, 69.44647858300004],
              [-52.34048417899993, 69.44814687700006],
              [-52.820301886999914, 69.35252513200004],
              [-52.88853919199994, 69.35272858300004],
              [-52.902902798999946, 69.34511953300006],
            ],
          ],
          [
            [
              [-54.71898352799991, 70.37978750200006],
              [-54.856760219999956, 70.36896393400008],
              [-54.92650305899991, 70.37474192900004],
              [-54.98582923099991, 70.40086497600004],
              [-54.99746660099993, 70.41132233300004],
              [-55.00853430899991, 70.42430247600004],
              [-55.016835089999915, 70.43854401200008],
              [-55.02635657499991, 70.47675202000005],
              [-55.027455206999946, 70.48627350500004],
              [-55.01984615799995, 70.48956940300008],
              [-54.79865475199995, 70.45799388200004],
              [-54.68211829299992, 70.41396719000005],
              [-54.66441809799994, 70.40086497600004],
              [-54.65420488199993, 70.38287995000007],
              [-54.66714433499993, 70.37775299700007],
              [-54.71898352799991, 70.37978750200006],
            ],
          ],
          [
            [
              [-51.66307532499991, 70.72304922100005],
              [-51.62474524599992, 70.71771881700005],
              [-51.505116339999915, 70.67462799700007],
              [-51.53380286399994, 70.65497467700004],
              [-51.58340410099993, 70.65814850500004],
              [-51.861317511999914, 70.72304922100005],
              [-51.856353318999936, 70.73647695500006],
              [-51.847320115999935, 70.74355703300006],
              [-51.820423956999946, 70.75039297100005],
              [-51.80064856699994, 70.74404531500005],
              [-51.71336829299992, 70.73407623900005],
              [-51.67870032499991, 70.72504303600005],
              [-51.66307532499991, 70.72304922100005],
            ],
          ],
          [
            [
              [-51.81663977799991, 70.94212474200003],
              [-51.77806555899991, 70.93602122600004],
              [-51.66954505099994, 70.89435455900008],
              [-51.58775794199994, 70.88825104400007],
              [-51.56582597599993, 70.87970612200007],
              [-51.593820766999954, 70.85960521000004],
              [-51.63121497299994, 70.84784577000005],
              [-51.665353969999956, 70.84552643400008],
              [-51.841135219999956, 70.85276927300004],
              [-51.930246548999946, 70.86640045800004],
              [-52.09520423099991, 70.86066315300008],
              [-52.14248613199993, 70.87323639500005],
              [-52.161366339999915, 70.89166901200008],
              [-52.156809048999946, 70.90973541900007],
              [-52.143422003999945, 70.92938873900005],
              [-52.13573157499991, 70.95270416900007],
              [-52.11392167899993, 70.96963125200006],
              [-52.064523891999954, 70.97858307500007],
              [-52.01109778599994, 70.98053620000007],
              [-51.93830318899995, 70.97431061400005],
              [-51.85692298099991, 70.94863515800006],
              [-51.81663977799991, 70.94212474200003],
            ],
          ],
          [
            [
              [-53.896595831999946, 71.08246491100005],
              [-53.963775193999936, 71.10211823100008],
              [-53.98570716099994, 71.11774323100008],
              [-53.978505011999914, 71.14760976800005],
              [-53.954009568999936, 71.17064036700003],
              [-53.92129472599993, 71.18756745000007],
              [-53.85562089799993, 71.21279531500005],
              [-53.80626380099994, 71.24042389500005],
              [-53.76634680899991, 71.24738190300008],
              [-53.74649003799993, 71.25608958500004],
              [-53.647043423999946, 71.31395091400003],
              [-53.61180579299992, 71.32172272300005],
              [-53.56940670499995, 71.29437897300005],
              [-53.479400193999936, 71.22199127800008],
              [-53.43114173099991, 71.19245026200008],
              [-53.40933183499993, 71.17487213700008],
              [-53.39134680899991, 71.15485260600008],
              [-53.382069464999915, 71.13662344000005],
              [-53.384022589999915, 71.11774323100008],
              [-53.399728969999956, 71.09638092700004],
              [-53.42235266799992, 71.07583242400005],
              [-53.44908606699994, 71.05687083500004],
              [-53.479400193999936, 71.04311758000006],
              [-53.51244055899991, 71.03774648600006],
              [-53.66771399599992, 71.03168366100005],
              [-53.874338344999956, 71.07404205900008],
              [-53.896595831999946, 71.08246491100005],
            ],
          ],
          [
            [
              [-52.48485266799992, 71.26430898600006],
              [-52.51911373599995, 71.26089101800005],
              [-52.56212317599994, 71.25145091400003],
              [-52.60342363199993, 71.23729075700004],
              [-52.63223222599993, 71.21954987200007],
              [-52.639515753999945, 71.20718008000006],
              [-52.63906816299993, 71.19635651200008],
              [-52.636830206999946, 71.18683502800008],
              [-52.63906816299993, 71.17861562700006],
              [-52.66161048099991, 71.16840241100005],
              [-52.95742753799993, 71.15444570500006],
              [-52.97500566299993, 71.15761953300006],
              [-53.087228969999956, 71.19944896000004],
              [-53.10460364499994, 71.20282623900005],
              [-53.11974036399994, 71.21283600500004],
              [-53.13508053299995, 71.23590729400007],
              [-53.16954505099994, 71.30312734600005],
              [-53.17747962099992, 71.32762278900003],
              [-53.16974850199995, 71.34625885600008],
              [-53.13630123599995, 71.35366445500006],
              [-53.09630286399994, 71.35785553600005],
              [-52.97179114499994, 71.38715241100005],
              [-52.69043941949994, 71.37040843300005],
              [-52.409087693999936, 71.35366445500006],
              [-52.38805091099994, 71.34564850500004],
              [-52.35142981699994, 71.30902741100005],
              [-52.32750403599994, 71.29840729400007],
              [-52.35195878799993, 71.27635325700004],
              [-52.39696204299992, 71.26650625200006],
              [-52.48485266799992, 71.26430898600006],
            ],
          ],
          [
            [
              [-53.293853318999936, 71.53864166900007],
              [-53.40562903599994, 71.54669830900008],
              [-53.43724524599992, 71.55849844000005],
              [-53.45409094999991, 71.57941315300008],
              [-53.466908331999946, 71.63410065300008],
              [-53.47826087099992, 71.65534088700008],
              [-53.43724524599992, 71.66836172100005],
              [-53.39867102799991, 71.67438385600008],
              [-53.13939368399991, 71.67108795800004],
              [-53.07689368399991, 71.66022370000007],
              [-53.05549068899995, 71.65932851800005],
              [-52.99478105399993, 71.66779205900008],
              [-52.77721106699994, 71.66543203300006],
              [-52.75951087099992, 71.66152578300006],
              [-52.80931555899991, 71.63715241100005],
              [-52.90933183499993, 71.60956452000005],
              [-53.07359778599994, 71.58661530200004],
              [-53.10147050699993, 71.57217031500005],
              [-53.10179602799991, 71.56753164300005],
              [-53.09951738199993, 71.56028880400004],
              [-53.098215298999946, 71.55231354400007],
              [-53.10147050699993, 71.54547760600008],
              [-53.11245683499993, 71.54096100500004],
              [-53.162953253999945, 71.53119538000004],
              [-53.229359503999945, 71.53017812700006],
              [-53.293853318999936, 71.53864166900007],
            ],
          ],
          [
            [
              [-55.68691972599993, 71.91718170800004],
              [-55.647328253999945, 71.92731354400007],
              [-55.60423743399991, 71.93292877800008],
              [-55.56102454299992, 71.93357982000003],
              [-55.46361243399991, 71.91771067900004],
              [-55.43578040299991, 71.90810781500005],
              [-55.411040818999936, 71.89423248900005],
              [-55.44908606699994, 71.86286041900007],
              [-55.50308183499993, 71.83690013200004],
              [-55.56086178299995, 71.82143789300005],
              [-55.60977128799993, 71.82143789300005],
              [-55.698150193999936, 71.83266836100006],
              [-55.72638912699995, 71.84332916900007],
              [-55.76475989499994, 71.86774323100008],
              [-55.78302975199995, 71.87616608300004],
              [-55.808257615999935, 71.88125234600005],
              [-55.787098761999914, 71.89988841400003],
              [-55.68691972599993, 71.91718170800004],
            ],
          ],
          [
            [
              [-55.04796301999994, 72.31883372600004],
              [-55.03966223899994, 72.30809153900003],
              [-55.03473873599995, 72.30353424700007],
              [-55.027455206999946, 72.29954661700003],
              [-55.04450436099995, 72.30019765800006],
              [-55.07323157499991, 72.31159088700008],
              [-55.08893795499995, 72.31264883000006],
              [-55.103505011999914, 72.30585358300004],
              [-55.112212693999936, 72.29458242400005],
              [-55.11953691299993, 72.28196849200003],
              [-55.12987219999991, 72.27167389500005],
              [-55.15099036399994, 72.26422760600008],
              [-55.19839433499993, 72.25885651200008],
              [-55.219309048999946, 72.25116608300004],
              [-55.231678839999915, 72.24054596600007],
              [-55.25365149599992, 72.21572500200006],
              [-55.26707923099991, 72.20648834800005],
              [-55.339100714999915, 72.17670319200005],
              [-55.37612870999993, 72.16722239800004],
              [-55.43537350199995, 72.15985748900005],
              [-55.46865800699993, 72.15070221600007],
              [-55.48619544199994, 72.14874909100007],
              [-55.50487219999991, 72.15232982000003],
              [-55.53433183499993, 72.16941966400003],
              [-55.55508378799993, 72.17544179900005],
              [-55.647043423999946, 72.17902252800008],
              [-55.682932094999956, 72.19000885600008],
              [-55.67174231699994, 72.21702708500004],
              [-55.637603318999936, 72.23330312700006],
              [-55.44985917899993, 72.25885651200008],
              [-55.43464107999995, 72.26797109600005],
              [-55.43569902299993, 72.28066640800006],
              [-55.459868943999936, 72.28314850500004],
              [-55.53164628799993, 72.27521393400008],
              [-55.602853969999956, 72.27789948100008],
              [-55.62718665299991, 72.28339264500005],
              [-55.63312740799995, 72.29437897300005],
              [-55.623931443999936, 72.30263906500005],
              [-55.602853969999956, 72.30573151200008],
              [-55.58372962099992, 72.29962799700007],
              [-55.418527798999946, 72.29214101800005],
              [-55.38072669199994, 72.29987213700008],
              [-55.306630011999914, 72.32558828300006],
              [-55.267689581999946, 72.33307526200008],
              [-55.209055141999954, 72.33307526200008],
              [-55.19981848899994, 72.33519114800004],
              [-55.147694464999915, 72.36981842700004],
              [-55.13304602799991, 72.37409088700008],
              [-55.04405676999994, 72.38336823100008],
              [-55.01317298099991, 72.38153717700004],
              [-55.01341712099992, 72.36640045800004],
              [-55.016835089999915, 72.34544505400004],
              [-55.027007615999935, 72.32684967700004],
              [-55.04796301999994, 72.31883372600004],
            ],
          ],
          [
            [
              [-55.80211341099994, 72.68939850500004],
              [-55.83958899599992, 72.69741445500006],
              [-55.87718665299991, 72.70990631700005],
              [-55.856760219999956, 72.71670156500005],
              [-55.87657630099994, 72.72288646000004],
              [-55.90306555899991, 72.72345612200007],
              [-55.92682857999995, 72.71723053600005],
              [-55.93862870999993, 72.70302969000005],
              [-55.935658331999946, 72.68915436400005],
              [-55.924712693999936, 72.67938873900005],
              [-55.897694464999915, 72.66205475500004],
              [-55.91787675699993, 72.66225820500006],
              [-55.95384680899991, 72.67291901200008],
              [-55.97280839799993, 72.67572663000004],
              [-55.99592037699995, 72.67234935100004],
              [-56.03815670499995, 72.65802643400008],
              [-56.062163865999935, 72.65521881700005],
              [-56.15379798099991, 72.66095612200007],
              [-56.17821204299992, 72.66889069200005],
              [-56.188343878999945, 72.67755768400008],
              [-56.19835364499994, 72.68878815300008],
              [-56.210194464999915, 72.69867584800005],
              [-56.22598222599993, 72.70302969000005],
              [-56.22598222599993, 72.70990631700005],
              [-56.19546464799993, 72.71605052300004],
              [-56.12718665299991, 72.71312083500004],
              [-56.09666907499991, 72.72040436400005],
              [-56.07079016799992, 72.73037344000005],
              [-56.00096594999991, 72.74457428600005],
              [-55.97280839799993, 72.74457428600005],
              [-55.983713344999956, 72.75763580900008],
              [-55.99010169199994, 72.76162344000005],
              [-56.000111456999946, 72.76508209800005],
              [-55.97203528599994, 72.77313873900005],
              [-55.86388098899994, 72.77130768400008],
              [-55.77212480399993, 72.78204987200007],
              [-55.74689693899995, 72.78558991100005],
              [-55.73940995999993, 72.77875397300005],
              [-55.74388587099992, 72.76947663000004],
              [-55.72618567599994, 72.77252838700008],
              [-55.684803839999915, 72.78558991100005],
              [-55.66576087099992, 72.78538646000004],
              [-55.64696204299992, 72.78148021000004],
              [-55.64024817599994, 72.77594635600008],
              [-55.657460089999915, 72.77130768400008],
              [-55.67442786399994, 72.77057526200008],
              [-55.69090735599991, 72.76463450700004],
              [-55.69758053299995, 72.75543854400007],
              [-55.684803839999915, 72.74457428600005],
              [-55.69884192599994, 72.73273346600007],
              [-55.710926886999914, 72.71678294500003],
              [-55.726226365999935, 72.70282623900005],
              [-55.75031490799995, 72.69684479400007],
              [-55.76390540299991, 72.69501373900005],
              [-55.78628495999993, 72.68870677300004],
              [-55.80211341099994, 72.68939850500004],
            ],
          ],
          [
            [
              [-55.73940995999993, 72.61424388200004],
              [-55.82095292899993, 72.61762116100005],
              [-55.849273240999935, 72.61424388200004],
              [-55.83458411399994, 72.63939036700003],
              [-55.81541907499991, 72.65631745000007],
              [-55.791005011999914, 72.66583893400008],
              [-55.67878170499995, 72.67658112200007],
              [-55.63634192599994, 72.68903229400007],
              [-55.60968990799995, 72.70990631700005],
              [-55.60529537699995, 72.73297760600008],
              [-55.61082923099991, 72.74884674700007],
              [-55.60724850199995, 72.75901927300004],
              [-55.57555091099994, 72.76508209800005],
              [-55.50829016799992, 72.76715729400007],
              [-55.447255011999914, 72.78131745000007],
              [-55.40420488199993, 72.78558991100005],
              [-55.37804114499994, 72.80426666900007],
              [-55.24657141799992, 72.81976959800005],
              [-55.140736456999946, 72.79987213700008],
              [-55.12547766799992, 72.79913971600007],
              [-55.109445766999954, 72.80609772300005],
              [-55.19945227799991, 72.81732819200005],
              [-55.22671464799993, 72.82656484600005],
              [-55.23289954299992, 72.84023672100005],
              [-55.21621660099993, 72.84487539300005],
              [-55.19884192599994, 72.84699127800008],
              [-54.98460852799991, 72.82330963700008],
              [-54.96544348899994, 72.81232330900008],
              [-54.97793535099993, 72.80467357000003],
              [-55.045033331999946, 72.79022858300004],
              [-55.068470831999946, 72.77875397300005],
              [-55.07555091099994, 72.76487864800004],
              [-55.08112545499995, 72.74896881700005],
              [-55.090687628999945, 72.73578522300005],
              [-55.10973059799994, 72.73037344000005],
              [-55.12441972599993, 72.72821686400005],
              [-55.15343176999994, 72.71881745000007],
              [-55.22378495999993, 72.71185944200005],
              [-55.23940995999993, 72.70648834800005],
              [-55.28075110599991, 72.68622467700004],
              [-55.28978430899991, 72.67865631700005],
              [-55.29149329299992, 72.66998932500007],
              [-55.29116777299993, 72.66168854400007],
              [-55.29434160099993, 72.65521881700005],
              [-55.318023240999935, 72.64321523600006],
              [-55.33946692599994, 72.63833242400005],
              [-55.35732988199993, 72.63165924700007],
              [-55.37010657499991, 72.61424388200004],
              [-55.36876380099994, 72.60590241100005],
              [-55.364898240999935, 72.59699127800008],
              [-55.36705481699994, 72.58991120000007],
              [-55.38377844999991, 72.58698151200008],
              [-55.39635169199994, 72.58779531500005],
              [-55.403187628999945, 72.59088776200008],
              [-55.403635219999956, 72.59711334800005],
              [-55.39679928299995, 72.60748932500007],
              [-55.42682857999995, 72.61635976800005],
              [-55.448109503999945, 72.60297272300005],
              [-55.46621660099993, 72.58340078300006],
              [-55.48648027299993, 72.57330963700008],
              [-55.50031490799995, 72.56952545800004],
              [-55.52892005099994, 72.55524323100008],
              [-55.541127081999946, 72.55560944200005],
              [-55.56737219999991, 72.56769440300008],
              [-55.57921301999994, 72.57538483300004],
              [-55.58922278599994, 72.58698151200008],
              [-55.567290818999936, 72.59711334800005],
              [-55.47996985599991, 72.61424388200004],
              [-55.50743567599994, 72.61953359600005],
              [-55.58922278599994, 72.62051015800006],
              [-55.61237545499995, 72.63068268400008],
              [-55.630116339999915, 72.64476146000004],
              [-55.64806067599994, 72.65371328300006],
              [-55.67174231699994, 72.64842357000003],
              [-55.67613684799994, 72.64362213700008],
              [-55.67642167899993, 72.63788483300004],
              [-55.67617753799993, 72.63226959800005],
              [-55.678578253999945, 72.62791575700004],
              [-55.69310462099992, 72.61961497600004],
              [-55.70677649599992, 72.61538320500006],
              [-55.721587693999936, 72.61395905200004],
              [-55.73940995999993, 72.61424388200004],
            ],
          ],
          [
            [
              [-55.60968990799995, 73.03603750200006],
              [-55.588002081999946, 73.04120514500005],
              [-55.53648841099994, 73.04523346600007],
              [-55.52090410099993, 73.05247630400004],
              [-55.15933183499993, 72.99774811400005],
              [-55.10041256399995, 72.98061758000006],
              [-55.068470831999946, 72.95685455900008],
              [-55.08263098899994, 72.95709870000007],
              [-55.096547003999945, 72.95477936400005],
              [-55.10928300699993, 72.94928620000007],
              [-55.119984503999945, 72.94013092700004],
              [-55.13361568899995, 72.93244049700007],
              [-55.299712693999936, 72.92218659100007],
              [-55.32909094999991, 72.92963288000004],
              [-55.316395636999914, 72.94529857000003],
              [-55.32445227799991, 72.95685455900008],
              [-55.35582434799994, 72.97052643400008],
              [-55.35265051999994, 72.97638580900008],
              [-55.34951738199993, 72.98550039300005],
              [-55.349598761999914, 72.99404531500005],
              [-55.35582434799994, 72.99848053600005],
              [-55.36473548099991, 72.99673086100006],
              [-55.36856035099993, 72.99079010600008],
              [-55.37124589799993, 72.98338450700004],
              [-55.376942511999914, 72.97736237200007],
              [-55.403187628999945, 72.96662018400008],
              [-55.43578040299991, 72.95815664300005],
              [-55.50047766799992, 72.95010000200006],
              [-55.52501380099994, 72.95319245000007],
              [-55.59605872299994, 72.97736237200007],
              [-55.67129472599993, 72.98639557500007],
              [-55.692250128999945, 72.99848053600005],
              [-55.60968990799995, 73.03603750200006],
            ],
          ],
          [
            [
              [-56.03111731699994, 73.57046133000006],
              [-56.00763912699995, 73.56061432500007],
              [-55.96776282499991, 73.57819245000007],
              [-55.94546464799993, 73.57387929900005],
              [-55.93297278599994, 73.56981028900003],
              [-55.92617753799993, 73.56293366100005],
              [-55.92052161399994, 73.55451080900008],
              [-55.911366339999915, 73.54588450700004],
              [-55.89903723899994, 73.54002513200004],
              [-55.81525631399995, 73.52187734600005],
              [-55.72606360599991, 73.51414622600004],
              [-55.669911261999914, 73.49648672100005],
              [-55.62336178299995, 73.49135976800005],
              [-55.60968990799995, 73.48525625200006],
              [-55.591460740999935, 73.46954987200007],
              [-55.58238684799994, 73.46401601800005],
              [-55.553618943999936, 73.46019114800004],
              [-55.52013098899994, 73.45966217700004],
              [-55.490345831999946, 73.45270416900007],
              [-55.47252356699994, 73.42987702000005],
              [-55.54963131399995, 73.42365143400008],
              [-55.58967037699995, 73.41600169500003],
              [-55.60968990799995, 73.39508698100008],
              [-55.59976152299993, 73.39288971600007],
              [-55.59593665299991, 73.39052969000005],
              [-55.593820766999954, 73.38703034100007],
              [-55.58922278599994, 73.38149648600006],
              [-55.62559973899994, 73.37995026200008],
              [-55.63703365799995, 73.38149648600006],
              [-55.64753170499995, 73.38666413000004],
              [-55.65416419199994, 73.39374420800004],
              [-55.66161048099991, 73.39988841400003],
              [-55.67454993399991, 73.40253327000005],
              [-55.69591223899994, 73.39964427300004],
              [-55.71393795499995, 73.39435455900008],
              [-55.73200436099995, 73.39118073100008],
              [-55.75373287699995, 73.39508698100008],
              [-55.73550370999993, 73.41372304900005],
              [-55.70494544199994, 73.41461823100008],
              [-55.67223059799994, 73.41185130400004],
              [-55.64757239499994, 73.41925690300008],
              [-55.64024817599994, 73.43744538000004],
              [-55.656239386999914, 73.44647858300004],
              [-55.680531378999945, 73.44944896000004],
              [-55.698475714999915, 73.44969310100004],
              [-55.685658331999946, 73.45425039300005],
              [-55.67528235599991, 73.46206289300005],
              [-55.667958136999914, 73.47235748900005],
              [-55.66429602799991, 73.48444245000007],
              [-55.72520911399994, 73.46759674700007],
              [-55.75243079299992, 73.46409739800004],
              [-55.78038489499994, 73.47085195500006],
              [-55.78172766799992, 73.47394440300008],
              [-55.78034420499995, 73.47858307500007],
              [-55.77989661399994, 73.48273346600007],
              [-55.784087693999936, 73.48444245000007],
              [-55.79454505099994, 73.48554108300004],
              [-55.81509355399993, 73.49022044500003],
              [-55.86693274599992, 73.49408600500004],
              [-55.88581295499995, 73.50031159100007],
              [-55.897694464999915, 73.51239655200004],
              [-55.89024817599994, 73.51316966400003],
              [-55.87100175699993, 73.51862213700008],
              [-55.89785722599993, 73.52960846600007],
              [-55.96247311099995, 73.52460358300004],
              [-55.99388587099992, 73.52545807500007],
              [-56.08389238199993, 73.55353424700007],
              [-56.11681067599994, 73.55955638200004],
              [-56.09666907499991, 73.57123444200005],
              [-56.07213294199994, 73.57770416900007],
              [-56.04857337099992, 73.57782623900005],
              [-56.03111731699994, 73.57046133000006],
            ],
          ],
          [
            [
              [-56.127064581999946, 73.82709381700005],
              [-56.16380774599992, 73.82436758000006],
              [-56.19871985599991, 73.81403229400007],
              [-56.235991990999935, 73.79511139500005],
              [-56.24681555899991, 73.79238515800006],
              [-56.31700598899994, 73.78660716400003],
              [-56.348500128999945, 73.78994375200006],
              [-56.35700436099995, 73.80658600500004],
              [-56.34557044199994, 73.81045156500005],
              [-56.334828253999945, 73.81635163000004],
              [-56.32494055899991, 73.82420482000003],
              [-56.31602942599994, 73.83392975500004],
              [-56.33531653599994, 73.83991120000007],
              [-56.61668860599991, 73.81614817900004],
              [-56.65868079299992, 73.81883372600004],
              [-56.69277910099993, 73.84137604400007],
              [-56.63133704299992, 73.86123281500005],
              [-56.657134568999936, 73.87909577000005],
              [-56.74478105399993, 73.86835358300004],
              [-56.77476966099994, 73.88231028900003],
              [-56.623890753999945, 73.92328522300005],
              [-56.59129798099991, 73.91364166900007],
              [-56.288075324499914, 73.88475169500006],
              [-55.98485266799992, 73.85586172100005],
              [-55.964182094999956, 73.84662506700005],
              [-55.95457923099991, 73.83299388200004],
              [-55.96593176999994, 73.81403229400007],
              [-55.99844316299993, 73.80516185100004],
              [-56.127064581999946, 73.82709381700005],
            ],
          ],
          [
            [
              [-56.51821855399993, 74.49481842700004],
              [-56.72647050699993, 74.49371979400007],
              [-56.72691809799994, 74.49803294500003],
              [-57.09390214799993, 74.48847077000005],
              [-57.19517981699994, 74.47333405200004],
              [-57.50951087099992, 74.48139069200005],
              [-57.55622311099995, 74.49188873900005],
              [-57.55622311099995, 74.49803294500003],
              [-57.20199540899995, 74.51837799700004],
              [-56.847767706999946, 74.53872304900005],
              [-56.76789303299995, 74.55707428600005],
              [-56.712880011999914, 74.56073639500005],
              [-56.61949622299994, 74.55198802300004],
              [-56.52769934799994, 74.53278229400007],
              [-56.53026282499991, 74.52602773600006],
              [-56.534820115999935, 74.52260976800005],
              [-56.548817511999914, 74.51976146000004],
              [-56.466867641999954, 74.51235586100006],
              [-56.48473059799994, 74.49970123900005],
              [-56.51821855399993, 74.49481842700004],
            ],
          ],
          [
            [
              [-69.49665279899995, 76.59227122600004],
              [-69.48420162699995, 76.58563873900005],
              [-69.47203528599994, 76.58331940300008],
              [-69.46792558499993, 76.57941315300008],
              [-69.47960364499994, 76.56806061400005],
              [-69.49445553299995, 76.56216054900005],
              [-69.53612219999991, 76.55658600500004],
              [-69.59357662699995, 76.54222239800004],
              [-69.67772376199991, 76.53384023600006],
              [-70.01378333199995, 76.55658600500004],
              [-70.0344945949999, 76.56806061400005],
              [-70.0196020169999, 76.58234284100007],
              [-69.98106848899994, 76.59080638200004],
              [-69.55675208199995, 76.61395905200004],
              [-69.5235082669999, 76.60883209800005],
              [-69.49665279899995, 76.59227122600004],
            ],
          ],
          [
            [
              [-71.57628333199995, 77.39044830900008],
              [-71.51952063699991, 77.38996002800008],
              [-71.45323645699995, 77.39931875200006],
              [-71.39037024599992, 77.40082428600005],
              [-71.34349524599992, 77.37685781500005],
              [-71.37706458199995, 77.35932038000004],
              [-71.50796464799993, 77.34886302300004],
              [-71.56745357999995, 77.33100006700005],
              [-71.65200761599993, 77.32904694200005],
              [-71.69041907499991, 77.31712474200003],
              [-71.70352128799993, 77.31537506700005],
              [-72.13182532499991, 77.32160065300008],
              [-72.13182532499991, 77.32904694200005],
              [-72.12071692599994, 77.32973867400005],
              [-72.10631262899994, 77.33364492400005],
              [-72.09752356699994, 77.33901601800005],
              [-72.10301673099991, 77.34430573100008],
              [-72.21153723899994, 77.35781484600005],
              [-72.28258216099994, 77.35443756700005],
              [-72.52965247299994, 77.39044830900008],
              [-72.57681230399993, 77.41160716400003],
              [-72.56240800699993, 77.42438385600008],
              [-72.53807532499991, 77.42951080900008],
              [-72.3645727199999, 77.44574616100005],
              [-72.36668860599991, 77.44904205900008],
              [-72.36693274599992, 77.45001862200007],
              [-72.37140865799995, 77.45254140800006],
              [-72.33934485599991, 77.46039459800005],
              [-72.23424231699994, 77.45872630400004],
              [-72.22301184799994, 77.45697663000004],
              [-72.20335852799991, 77.44818756700005],
              [-72.19326738199993, 77.44574616100005],
              [-72.13182532499991, 77.45254140800006],
              [-71.75405839799993, 77.41608307500007],
              [-71.67735755099994, 77.42523834800005],
              [-71.65078691299993, 77.42096588700008],
              [-71.57628333199995, 77.39044830900008],
            ],
          ],
          [
            [
              [-70.35659745999993, 77.41779205900008],
              [-70.12905839799993, 77.41551341400003],
              [-70.05500240799995, 77.40412018400008],
              [-70.09032141799992, 77.39443594000005],
              [-70.17015540299991, 77.39716217700004],
              [-70.24551347599993, 77.38580963700008],
              [-70.66272945899993, 77.38178131700008],
              [-71.07994544199994, 77.37775299700007],
              [-71.11143958199995, 77.38251373900005],
              [-71.14028886599993, 77.39386627800008],
              [-71.16881262899994, 77.41469961100006],
              [-71.1966039699999, 77.42999909100007],
              [-71.30260169199994, 77.45254140800006],
              [-71.28872636599993, 77.45783112200007],
              [-71.27285722599993, 77.45954010600008],
              [-71.20409094999991, 77.45791250200006],
              [-71.12775631399995, 77.46434153900003],
              [-70.97362219999991, 77.46076080900008],
              [-70.89867102799991, 77.47345612200007],
              [-70.62763424399992, 77.44562409050008],
              [-70.35659745999993, 77.41779205900008],
            ],
          ],
          [
            [
              [-53.27476966099994, 82.17234935100004],
              [-53.33507239499994, 82.19163646000004],
              [-53.34911048099991, 82.20140208500004],
              [-53.33946692599994, 82.25873444200005],
              [-53.244984503999945, 82.29913971600007],
              [-53.05370032499991, 82.33112213700008],
              [-52.786773240999935, 82.31753164300005],
              [-52.55406653599994, 82.27655670800004],
              [-52.60118567599994, 82.26911041900007],
              [-52.59552975199995, 82.26032135600008],
              [-52.585601365999935, 82.25250885600008],
              [-52.52920488199993, 82.21942780200004],
              [-52.51398678299995, 82.21332428600005],
              [-52.46519934799994, 82.19989655200004],
              [-52.05394446533327, 82.13792552333338],
              [-51.642689582666584, 82.07595449466673],
              [-51.23143469999991, 82.01398346600007],
              [-51.18976803299995, 81.99534739800004],
              [-51.20303300699993, 81.99188873900005],
              [-51.237538214999915, 81.98851146000004],
              [-51.29466712099992, 81.97870514500005],
              [-51.69994055849992, 81.98706696150006],
              [-52.10521399599992, 81.99542877800008],
              [-52.20811926999994, 82.01821523600006],
              [-52.53380286399994, 82.04791901200008],
              [-52.61107337099992, 82.06525299700007],
              [-53.01748613199993, 82.08856842700004],
              [-53.08702551999994, 82.10610586100006],
              [-53.19009355399993, 82.11237213700008],
              [-53.23184160099993, 82.13190338700008],
              [-53.233713344999956, 82.13593170800004],
              [-53.23542232999995, 82.14801666900007],
              [-53.23924719999991, 82.15363190300008],
              [-53.24754798099991, 82.15997955900008],
              [-53.255970831999946, 82.16478099200003],
              [-53.27476966099994, 82.17234935100004],
            ],
          ],
          [
            [
              [-44.52916419199994, 82.41376373900005],
              [-44.454009568999936, 82.40119049700007],
              [-44.42210852799991, 82.38467031500005],
              [-44.42613684799994, 82.35846588700008],
              [-44.43895423099991, 82.35297272300005],
              [-44.52769934799994, 82.33344147300005],
              [-44.710926886999914, 82.31614817900004],
              [-45.070423956999946, 82.22256094000005],
              [-45.03628495999993, 82.19745514500005],
              [-44.90526282499991, 82.16356028900003],
              [-44.73460852799991, 82.09837474200003],
              [-44.77090410099993, 82.07977936400005],
              [-44.825062628999945, 82.07050202000005],
              [-45.03502356699994, 82.05927155200004],
              [-45.08812415299991, 82.06403229400007],
              [-45.307525193999936, 82.12864817900004],
              [-45.32363847599993, 82.15363190300008],
              [-45.42341061099995, 82.18447500200006],
              [-45.90759572399994, 82.24298737166673],
              [-46.39178083699992, 82.30149974133339],
              [-46.87596594999991, 82.36001211100006],
              [-46.997303839999915, 82.39085521000004],
              [-47.00450598899994, 82.39622630400004],
              [-47.01008053299995, 82.40688711100006],
              [-47.00259355399993, 82.41376373900005],
              [-47.04336503799993, 82.44489166900007],
              [-47.11074785099993, 82.48383209800005],
              [-47.18073482999995, 82.51178620000007],
              [-47.22911536399994, 82.50991445500006],
              [-47.252797003999945, 82.52016836100006],
              [-47.36571204299992, 82.53725820500006],
              [-47.56509355399993, 82.61505768400008],
              [-47.74986731699994, 82.62531159100007],
              [-47.729074673999946, 82.63751862200007],
              [-47.69806881399995, 82.64378489800004],
              [-47.278655565499946, 82.64512767150003],
              [-46.85924231699994, 82.64647044500003],
              [-46.81017005099994, 82.64020416900007],
              [-46.78624426999994, 82.64012278900003],
              [-46.763010219999956, 82.64647044500003],
              [-46.782460089999915, 82.65875885600008],
              [-46.85924231699994, 82.67438385600008],
              [-46.59172522699993, 82.67645905150007],
              [-46.324208136999914, 82.67853424700007],
              [-45.98840627066659, 82.64052968966674],
              [-45.65260440433326, 82.60252513233341],
              [-45.31680253799993, 82.56452057500007],
              [-45.31680253799993, 82.55707428600005],
              [-45.32363847599993, 82.55707428600005],
              [-45.32363847599993, 82.55023834800005],
              [-45.213734503999945, 82.55023834800005],
              [-44.896148240999935, 82.49949778900003],
              [-44.830189581999946, 82.47577545800004],
              [-44.52916419199994, 82.41376373900005],
            ],
          ],
          [
            [
              [-47.85216223899994, 82.78363678600005],
              [-48.330922003999945, 82.79189687700006],
              [-48.36750240799995, 82.79779694200005],
              [-48.40001380099994, 82.80939362200007],
              [-48.414051886999914, 82.82802969000005],
              [-48.41274980399993, 82.85276927300004],
              [-48.40660559799994, 82.86831289300005],
              [-48.392241990999935, 82.87815989800004],
              [-48.36628170499995, 82.88605377800008],
              [-48.287220831999946, 82.89663320500006],
              [-47.89698238799994, 82.86249420750005],
              [-47.506743943999936, 82.82835521000004],
              [-47.44204667899993, 82.81098053600005],
              [-47.48009192599994, 82.79169342700004],
              [-47.53335527299993, 82.78392161700003],
              [-47.85216223899994, 82.78363678600005],
            ],
          ],
          [
            [
              [-39.437611456999946, 83.10516998900005],
              [-39.30125891799992, 83.09662506700005],
              [-39.28888912699995, 83.09243398600006],
              [-39.29076087099992, 83.08478424700007],
              [-39.30736243399991, 83.07160065300008],
              [-39.347727016999954, 83.05076732000003],
              [-39.522328253999945, 83.00665924700007],
              [-39.66649329299992, 82.99551015800006],
              [-39.73696855399993, 83.00112539300005],
              [-39.76598059799994, 83.00958893400008],
              [-39.84015865799995, 83.01626211100006],
              [-39.977121548999946, 83.06093984600005],
              [-40.04784094999991, 83.07160065300008],
              [-40.31395423099991, 83.07868073100008],
              [-40.359934048999946, 83.08490631700005],
              [-40.396595831999946, 83.09955475500004],
              [-40.39354407499991, 83.10333893400008],
              [-40.38975989499994, 83.11261627800008],
              [-40.416005011999914, 83.11444733300004],
              [-40.46703040299991, 83.12946198100008],
              [-40.493072068999936, 83.13304271000004],
              [-40.513661261999914, 83.13849518400008],
              [-40.53624426999994, 83.15045807500007],
              [-40.54662024599992, 83.16242096600007],
              [-40.53066972599993, 83.16787344000005],
              [-40.25169837149994, 83.16384511950005],
              [-39.972727016999954, 83.15981679900005],
              [-39.818430141999954, 83.12311432500007],
              [-39.437611456999946, 83.10516998900005],
            ],
          ],
          [
            [
              [-40.10334225199995, 83.05613841400003],
              [-40.052723761999914, 83.02724844000005],
              [-40.03530839799993, 83.02326080900008],
              [-39.988392706999946, 83.01976146000004],
              [-39.94448808499993, 83.01064687700006],
              [-39.862172003999945, 82.98224518400008],
              [-40.282928026499945, 83.00551992400005],
              [-40.703684048999946, 83.02879466400003],
              [-40.903187628999945, 83.07184479400007],
              [-41.02721106699994, 83.07782623900005],
              [-41.06208248599995, 83.08397044500003],
              [-41.15697180899991, 83.11880117400005],
              [-41.44871985599991, 83.16144440300008],
              [-41.48656165299991, 83.16038646000004],
              [-41.47911536399994, 83.16787344000005],
              [-41.48656165299991, 83.16787344000005],
              [-41.429758266999954, 83.17816803600005],
              [-41.14391028549994, 83.17538076400004],
              [-40.85806230399993, 83.17259349200003],
              [-40.80809485599991, 83.16038646000004],
              [-40.746083136999914, 83.12620677300004],
              [-40.719309048999946, 83.11928945500006],
              [-40.636830206999946, 83.11261627800008],
              [-40.48668372299994, 83.07689036700003],
              [-40.26463782499991, 83.07050202000005],
              [-40.18468176999994, 83.05971914300005],
              [-40.12922115799995, 83.06073639500005],
              [-40.10334225199995, 83.05613841400003],
            ],
          ],
          [
            [
              [-38.83433997299994, 83.17401764500005],
              [-38.80894934799994, 83.17039622600004],
              [-38.66169186099995, 83.12787506700005],
              [-38.642567511999914, 83.11880117400005],
              [-38.91734778599994, 83.10956452000005],
              [-38.95103919199994, 83.11880117400005],
              [-38.944203253999945, 83.11880117400005],
              [-39.394866502999946, 83.15932851750006],
              [-39.84552975199995, 83.19985586100006],
              [-39.868031378999945, 83.20734284100007],
              [-39.90501868399991, 83.22955963700008],
              [-40.04991614499994, 83.26129791900007],
              [-40.33995520749994, 83.26609935100007],
              [-40.62999426999994, 83.27090078300006],
              [-40.664051886999914, 83.28351471600007],
              [-40.66734778599994, 83.30255768400008],
              [-40.64858964799993, 83.32269928600005],
              [-40.61632239499994, 83.33856842700004],
              [-40.56582597599993, 83.34731679900005],
              [-40.40343176999994, 83.33856842700004],
              [-40.40343176999994, 83.34536367400005],
              [-40.47240149599992, 83.34813060100004],
              [-40.54063880099994, 83.35903554900005],
              [-40.48741614499994, 83.36591217700004],
              [-40.29605058499993, 83.35049062700006],
              [-40.22565670499995, 83.33051178600005],
              [-39.99852454299992, 83.29922109600005],
              [-39.77424068899995, 83.30141836100006],
              [-39.67039954299992, 83.27708567900004],
              [-39.57579505099994, 83.24286530200004],
              [-39.47492428299995, 83.21954987200007],
              [-39.154632127999946, 83.19678375850006],
              [-38.83433997299994, 83.17401764500005],
            ],
          ],
          [
            [
              [-23.43968665299991, 69.74298737200007],
              [-23.347320115999935, 69.74652741100005],
              [-23.298573370999918, 69.74290599200003],
              [-23.258168097999942, 69.72866445500006],
              [-23.227772589999915, 69.68390534100007],
              [-23.22402910099993, 69.67096588700008],
              [-23.240386522999927, 69.65330638200004],
              [-23.277740037999934, 69.64655182500007],
              [-23.48037675699993, 69.65534088700008],
              [-23.544545050999943, 69.67568594000005],
              [-23.593373175999943, 69.71503327000005],
              [-23.55923417899993, 69.72748444200005],
              [-23.51748613199993, 69.73615143400008],
              [-23.43968665299991, 69.74298737200007],
            ],
          ],
          [
            [
              [-26.208322719999956, 70.56537506700005],
              [-26.193348761999914, 70.56415436400005],
              [-26.18455969999991, 70.56000397300005],
              [-26.16706295499995, 70.54144928600005],
              [-26.14671790299991, 70.53123607000003],
              [-26.096262173999946, 70.52924225500004],
              [-26.074208136999914, 70.52383047100005],
              [-26.09984290299991, 70.51390208500004],
              [-26.106678839999915, 70.50820547100005],
              [-26.10773678299995, 70.50018952000005],
              [-26.101551886999914, 70.48965078300006],
              [-26.16002356699994, 70.46507396000004],
              [-26.189523891999954, 70.45844147300005],
              [-26.265451626999948, 70.45644765800006],
              [-26.288807745999918, 70.45941803600005],
              [-26.303863084999932, 70.46637604400007],
              [-26.32168535099993, 70.47809479400007],
              [-26.362904425999943, 70.48379140800006],
              [-26.38267981699994, 70.48965078300006],
              [-26.377756313999953, 70.49282461100006],
              [-26.36823482999995, 70.50047435100004],
              [-26.362172003999945, 70.50332265800006],
              [-26.368397589999915, 70.50804271000004],
              [-26.38267981699994, 70.52383047100005],
              [-26.361398891999954, 70.52488841400003],
              [-26.32530676999994, 70.54051341400003],
              [-26.306996222999942, 70.54486725500004],
              [-26.289173956999946, 70.54266998900005],
              [-26.252349412999934, 70.53221263200004],
              [-26.232533331999946, 70.53123607000003],
              [-26.232533331999946, 70.53807200700004],
              [-26.241363084999932, 70.54010651200008],
              [-26.265980597999942, 70.55170319200005],
              [-26.25291907499991, 70.55805084800005],
              [-26.238880988999938, 70.56224192900004],
              [-26.22402910099993, 70.56464264500005],
              [-26.208322719999956, 70.56537506700005],
            ],
          ],
          [
            [
              [-27.71906490799995, 70.73981354400007],
              [-27.739857550999943, 70.75409577000005],
              [-27.748890753999945, 70.76911041900007],
              [-27.748158331999946, 70.78758372600004],
              [-27.739572719999956, 70.81244538000004],
              [-27.749623175999943, 70.82562897300005],
              [-27.757639126999948, 70.84149811400005],
              [-27.75999915299991, 70.85809967700004],
              [-27.753163214999915, 70.87323639500005],
              [-27.722767706999946, 70.88857656500005],
              [-27.676177537999934, 70.89691803600005],
              [-27.58934485599991, 70.90119049700007],
              [-27.565337693999936, 70.89887116100005],
              [-27.51707923099991, 70.88890208500004],
              [-27.49315344999991, 70.88690827000005],
              [-27.239857550999943, 70.89435455900008],
              [-27.24828040299991, 70.88857656500005],
              [-27.25617428299995, 70.88450755400004],
              [-27.26431230399993, 70.88190338700008],
              [-27.273426886999914, 70.88068268400008],
              [-27.28457597599993, 70.87230052300004],
              [-27.32184811099995, 70.85276927300004],
              [-27.356760219999956, 70.82514069200005],
              [-27.369618292999917, 70.81801992400005],
              [-27.410755988999938, 70.80499909100007],
              [-27.498402472999942, 70.79075755400004],
              [-27.58145097599993, 70.76064687700006],
              [-27.671620245999918, 70.73847077000005],
              [-27.697417772999927, 70.73529694200005],
              [-27.71906490799995, 70.73981354400007],
            ],
          ],
          [
            [
              [-25.317250128999945, 70.74697500200006],
              [-25.31468665299991, 70.73338450700004],
              [-25.298207160999937, 70.71369049700007],
              [-25.28351803299995, 70.69086334800005],
              [-25.285959438999953, 70.66779205900008],
              [-25.301136847999942, 70.65729401200008],
              [-25.321522589999915, 70.65387604400007],
              [-25.36229407499991, 70.65412018400008],
              [-25.418812628999945, 70.64232005400004],
              [-25.570139126999948, 70.63410065300008],
              [-25.652821417999917, 70.60911692900004],
              [-25.696888800999943, 70.60464101800005],
              [-25.786854620999918, 70.60635000200006],
              [-25.82530676999994, 70.60126373900005],
              [-25.96475175699993, 70.54230377800008],
              [-25.999745245999918, 70.53510163000004],
              [-26.071156378999945, 70.53123607000003],
              [-26.074208136999914, 70.53339264500005],
              [-26.076893683999913, 70.53807200700004],
              [-26.080881313999953, 70.54279205900008],
              [-26.08820553299995, 70.54486725500004],
              [-26.132883266999954, 70.54486725500004],
              [-26.14053300699993, 70.54970937700006],
              [-26.16356360599991, 70.57904694200005],
              [-26.194569464999915, 70.58759186400005],
              [-26.237945115999935, 70.58926015800006],
              [-26.281809048999946, 70.58486562700006],
              [-26.348255988999938, 70.56366608300004],
              [-26.500355597999942, 70.54791901200008],
              [-26.547678188999953, 70.52977122600004],
              [-26.575103318999936, 70.52383047100005],
              [-26.924549933999913, 70.51764557500007],
              [-26.941761847999942, 70.52130768400008],
              [-26.955067511999914, 70.52606842700004],
              [-26.968495245999918, 70.52806224200003],
              [-26.985991990999935, 70.52383047100005],
              [-26.993885870999918, 70.51854075700004],
              [-27.000884568999936, 70.51170482000003],
              [-27.009022589999915, 70.50580475500004],
              [-27.01984615799995, 70.50332265800006],
              [-27.369130011999953, 70.4791256093334],
              [-27.718413865999953, 70.45492856066674],
              [-28.067697719999956, 70.43073151200008],
              [-28.116118943999936, 70.43707916900007],
              [-28.13735917899993, 70.45954010600008],
              [-28.12682044199994, 70.47528717700004],
              [-28.101673956999946, 70.48704661700003],
              [-28.014027472999942, 70.51373932500007],
              [-27.99510657499991, 70.52187734600005],
              [-27.98656165299991, 70.53123607000003],
              [-27.994618292999917, 70.54181549700007],
              [-28.048003709999932, 70.55853913000004],
              [-28.06432044199994, 70.58161041900007],
              [-28.046254035999937, 70.59536367400005],
              [-28.014515753999945, 70.60516998900005],
              [-27.963368292999917, 70.63125234600005],
              [-27.92731686099995, 70.63825104400007],
              [-27.678089972999942, 70.65412018400008],
              [-27.65135657499991, 70.66087474200003],
              [-27.582508917999917, 70.70937734600005],
              [-27.55565344999991, 70.72256094000005],
              [-27.490834113999938, 70.74616120000007],
              [-27.453684048999946, 70.75348541900007],
              [-27.428578253999945, 70.76764557500007],
              [-27.414621548999946, 70.77081940300008],
              [-27.39549719999991, 70.77244700700004],
              [-27.27171790299991, 70.79889557500007],
              [-27.242014126999948, 70.81354401200008],
              [-27.215402798999946, 70.83600495000007],
              [-27.149647589999915, 70.87783437700006],
              [-27.06749426999994, 70.89354075700004],
              [-26.662505662999934, 70.89647044500003],
              [-26.30890865799995, 70.93854401200008],
              [-26.287220831999946, 70.94660065300008],
              [-26.246205206999946, 70.96881745000007],
              [-26.22720292899993, 70.97455475500004],
              [-26.08299719999991, 70.99339427300004],
              [-26.02212480399993, 71.01455312700006],
              [-25.70376542899993, 71.08584219000005],
              [-25.676991339999915, 71.08612702000005],
              [-25.676991339999915, 71.07868073100008],
              [-25.683257615999935, 71.07811107000003],
              [-25.684193488999938, 71.07538483300004],
              [-25.683338995999918, 71.07099030200004],
              [-25.684437628999945, 71.06565989800004],
              [-25.681752081999946, 71.05589427300004],
              [-25.678537563999953, 71.02781810100004],
              [-25.676991339999915, 71.02411530200004],
              [-25.686838344999956, 71.01105377800008],
              [-25.697865363999938, 71.00478750200006],
              [-25.710682745999918, 70.99982330900008],
              [-25.725453253999945, 70.99054596600007],
              [-25.67764238199993, 70.97626373900005],
              [-25.50877844999991, 70.96881745000007],
              [-25.48534094999991, 70.96352773600006],
              [-25.41006425699993, 70.92475006700005],
              [-25.39757239499994, 70.91425202000005],
              [-25.375355597999942, 70.87323639500005],
              [-25.38463294199994, 70.86591217700004],
              [-25.394683397999927, 70.85980866100005],
              [-25.405425584999932, 70.85541413000004],
              [-25.416900193999936, 70.85276927300004],
              [-25.399159308999913, 70.84345123900005],
              [-25.35533606699994, 70.83576080900008],
              [-25.341175910999937, 70.82542552300004],
              [-25.341786261999914, 70.80971914300005],
              [-25.359730597999942, 70.80182526200008],
              [-25.451527472999942, 70.79759349200003],
              [-25.475005662999934, 70.79238515800006],
              [-25.485218878999945, 70.78070709800005],
              [-25.47801673099991, 70.77122630400004],
              [-25.461008266999954, 70.76845937700006],
              [-25.357533331999946, 70.76894765800006],
              [-25.32176673099991, 70.76178620000007],
              [-25.317250128999945, 70.74697500200006],
            ],
          ],
          [
            [
              [-25.56191972599993, 71.10716380400004],
              [-25.538441535999937, 71.11139557500007],
              [-25.510894334999932, 71.11176178600005],
              [-25.46475175699993, 71.10602448100008],
              [-25.45213782499991, 71.10016510600008],
              [-25.43423417899993, 71.08388906500005],
              [-25.42373613199993, 71.07868073100008],
              [-25.403187628999945, 71.07855866100005],
              [-25.383371548999946, 71.08307526200008],
              [-25.363026495999918, 71.08539459800005],
              [-25.341175910999937, 71.07868073100008],
              [-25.355091925999943, 71.07465241100005],
              [-25.368885870999918, 71.06541575700004],
              [-25.375599738999938, 71.05613841400003],
              [-25.368804490999935, 71.05198802300004],
              [-25.350819464999915, 71.04970937700006],
              [-25.331776495999918, 71.04287344000005],
              [-25.31598873599995, 71.03192780200004],
              [-25.30768795499995, 71.01727936400005],
              [-25.33267167899993, 71.01919179900005],
              [-25.353586391999954, 71.02484772300005],
              [-25.395822719999956, 71.04515208500004],
              [-25.400502081999946, 71.02627187700006],
              [-25.41397050699993, 71.02741120000007],
              [-25.430531378999945, 71.03921133000006],
              [-25.444203253999945, 71.05198802300004],
              [-25.444488084999932, 71.06122467700004],
              [-25.45616614499994, 71.07493724200003],
              [-25.47215735599991, 71.08746979400007],
              [-25.485218878999945, 71.09296295800004],
              [-25.537098761999914, 71.08612702000005],
              [-25.560943162999934, 71.08893463700008],
              [-25.580799933999913, 71.10602448100008],
              [-25.576161261999914, 71.10675690300008],
              [-25.573394334999932, 71.10862864800004],
              [-25.570871548999946, 71.11102936400005],
              [-25.567128058999913, 71.11347077000005],
              [-25.56191972599993, 71.10716380400004],
            ],
          ],
          [
            [
              [-21.94908606699994, 72.42869700700004],
              [-21.93504798099991, 72.41347890800006],
              [-21.928618943999936, 72.40818919500003],
              [-21.96190344999991, 72.39008209800005],
              [-22.00572669199994, 72.38641998900005],
              [-22.05215410099993, 72.39207591400003],
              [-22.15770423099991, 72.42031484600005],
              [-22.252756313999953, 72.42829010600008],
              [-22.271311001999948, 72.43618398600006],
              [-22.265980597999942, 72.43964264500005],
              [-22.263010219999956, 72.44285716400003],
              [-22.26085364499994, 72.44635651200008],
              [-22.257639126999948, 72.45038483300004],
              [-22.284331834999932, 72.44904205900008],
              [-22.332875128999945, 72.43280670800004],
              [-22.36034094999991, 72.42869700700004],
              [-22.641428188999953, 72.46552155200004],
              [-22.675933397999927, 72.46344635600008],
              [-22.725900844999956, 72.45351797100005],
              [-22.760121222999942, 72.44106679900005],
              [-22.76130123599995, 72.43695709800005],
              [-22.755197719999956, 72.43301015800006],
              [-22.749338344999956, 72.42304108300004],
              [-22.74054928299995, 72.41913483300004],
              [-22.736805792999917, 72.41567617400005],
              [-22.735666469999956, 72.41083405200004],
              [-22.738392706999946, 72.40888092700004],
              [-22.742298956999946, 72.40770091400003],
              [-22.744211391999954, 72.40509674700007],
              [-22.740956183999913, 72.39179108300004],
              [-22.732818162999934, 72.38369375200006],
              [-22.675160285999937, 72.36163971600007],
              [-22.327381964999915, 72.31045156500005],
              [-22.298573370999918, 72.29214101800005],
              [-22.319650844999956, 72.26422760600008],
              [-22.30304928299995, 72.25726959800005],
              [-22.28156490799995, 72.25592682500007],
              [-22.25999915299991, 72.26056549700007],
              [-22.243397589999915, 72.27167389500005],
              [-22.246978318999936, 72.28253815300008],
              [-22.22101803299995, 72.28729889500005],
              [-22.161447719999956, 72.28530508000006],
              [-22.10456295499995, 72.27484772300005],
              [-22.045318162999934, 72.27167389500005],
              [-22.062163865999935, 72.26312897300005],
              [-22.120432094999956, 72.24433014500005],
              [-22.17528235599991, 72.21381256700005],
              [-22.196156378999945, 72.20962148600006],
              [-22.190297003999945, 72.19733307500007],
              [-22.180287238999938, 72.19135163000004],
              [-22.155181443999936, 72.18284739800004],
              [-22.13304602799991, 72.16909414300005],
              [-22.12523352799991, 72.15936920800004],
              [-22.146229620999918, 72.15167877800008],
              [-22.18187415299991, 72.13108958500004],
              [-22.201283331999946, 72.12514883000006],
              [-22.250355597999942, 72.12099844000005],
              [-22.52489173099991, 72.13483307500007],
              [-22.600209113999938, 72.15497467700004],
              [-22.600209113999938, 72.16242096600007],
              [-22.54133053299995, 72.17645905200004],
              [-22.51471920499995, 72.18817780200004],
              [-22.497792120999918, 72.20962148600006],
              [-22.544300910999937, 72.21735260600008],
              [-22.55923417899993, 72.21332428600005],
              [-22.593129035999937, 72.19033437700006],
              [-22.60765540299991, 72.18284739800004],
              [-22.64639238199993, 72.17202383000006],
              [-22.68464107999995, 72.17129140800006],
              [-22.721913214999915, 72.17885976800005],
              [-22.803618943999936, 72.20880768400008],
              [-22.94835364499994, 72.23883698100008],
              [-22.97569739499994, 72.24990469000005],
              [-22.99551347599993, 72.26117584800005],
              [-23.028553839999915, 72.28872304900005],
              [-23.06509355399993, 72.31000397300005],
              [-23.35627193949992, 72.36603424650005],
              [-23.64745032499991, 72.42206452000005],
              [-23.762277798999946, 72.42820872600004],
              [-23.905629035999937, 72.46613190300008],
              [-23.953277147999927, 72.47288646000004],
              [-23.998646613999938, 72.47028229400007],
              [-24.015004035999937, 72.46401601800005],
              [-24.039173956999946, 72.44692617400005],
              [-24.053293423999946, 72.44293854400007],
              [-24.06354732999995, 72.44525788000004],
              [-24.073882615999935, 72.45164622600004],
              [-24.080881313999953, 72.46059804900005],
              [-24.080555792999917, 72.47028229400007],
              [-24.05614173099991, 72.48078034100007],
              [-24.01862545499995, 72.48786041900007],
              [-23.998443162999934, 72.49896881700005],
              [-24.025949673999946, 72.52142975500004],
              [-24.06314042899993, 72.53733958500004],
              [-24.098500128999945, 72.54694245000007],
              [-24.140248175999943, 72.55097077000005],
              [-24.135161912999934, 72.54535553600005],
              [-24.16161048099991, 72.53099192900004],
              [-24.205555792999917, 72.54295482000003],
              [-24.286000128999945, 72.57953522300005],
              [-24.330922003999945, 72.58588288000004],
              [-24.35179602799991, 72.59129466400003],
              [-24.371693488999938, 72.60407135600008],
              [-24.378163214999915, 72.61286041900007],
              [-24.395863410999937, 72.64524974200003],
              [-24.397816535999937, 72.65546295800004],
              [-24.406605597999942, 72.67853424700007],
              [-24.408924933999913, 72.68939850500004],
              [-24.40807044199994, 72.70213450700004],
              [-24.405995245999918, 72.71295807500007],
              [-24.40538489499994, 72.72406647300005],
              [-24.408924933999913, 72.73777903900003],
              [-24.423451300999943, 72.76325104400007],
              [-24.443430141999954, 72.78709544500003],
              [-24.485259568999936, 72.82656484600005],
              [-24.467396613999938, 72.84324778900003],
              [-24.43545488199993, 72.85370514500005],
              [-24.400135870999918, 72.85911692900004],
              [-23.930409308999913, 72.88153717700004],
              [-23.80064856699994, 72.85956452000005],
              [-23.715443488999938, 72.86009349200003],
              [-23.633168097999942, 72.83795807500007],
              [-23.14679928299995, 72.84019603100006],
              [-23.13703365799995, 72.84003327000005],
              [-23.12726803299995, 72.83661530200004],
              [-23.119496222999942, 72.82982005400004],
              [-23.114165818999936, 72.81976959800005],
              [-23.103871222999942, 72.81561920800004],
              [-23.067005988999938, 72.79425690300008],
              [-23.04515540299991, 72.75995514500005],
              [-23.014800584999932, 72.74673086100006],
              [-22.984527147999927, 72.73749420800004],
              [-22.970814581999946, 72.72724030200004],
              [-22.95140540299991, 72.71686432500007],
              [-22.866078253999945, 72.70722077000005],
              [-22.84666907499991, 72.68622467700004],
              [-22.72960364499994, 72.66795482000003],
              [-22.703277147999927, 72.64842357000003],
              [-22.70929928299995, 72.64524974200003],
              [-22.71231035099993, 72.64199453300006],
              [-22.71434485599991, 72.63849518400008],
              [-22.717518683999913, 72.63471100500004],
              [-22.586740688999953, 72.60761139500005],
              [-22.552357550999943, 72.60854726800005],
              [-22.518299933999913, 72.61424388200004],
              [-22.491851365999935, 72.62628815300008],
              [-22.48151607999995, 72.62645091400003],
              [-22.476714647999927, 72.61424388200004],
              [-22.465402798999946, 72.60333893400008],
              [-22.445871548999946, 72.59564850500004],
              [-22.401275193999936, 72.59381745000007],
              [-22.37653561099995, 72.58942291900007],
              [-22.32453365799995, 72.57021719000005],
              [-22.182484503999945, 72.54535553600005],
              [-22.164906378999945, 72.53839752800008],
              [-22.15192623599995, 72.52846914300005],
              [-22.15062415299991, 72.51837799700007],
              [-22.16820227799991, 72.51064687700006],
              [-22.174549933999913, 72.50812409100007],
              [-22.187123175999943, 72.50311920800004],
              [-22.197092251999948, 72.49518463700008],
              [-22.202300584999932, 72.48395416900007],
              [-22.02830969999991, 72.50438060100004],
              [-21.98656165299991, 72.50043366100005],
              [-21.951730923999946, 72.48810455900008],
              [-21.935373501999948, 72.46686432500007],
              [-21.94908606699994, 72.43618398600006],
              [-21.94908606699994, 72.42869700700004],
            ],
          ],
          [
            [
              [-24.79991614499994, 72.91596100500004],
              [-24.787098761999914, 72.91547272300005],
              [-24.77647864499994, 72.91356028900003],
              [-24.77253170499995, 72.90936920800004],
              [-24.779449022999927, 72.90167877800008],
              [-24.799672003999945, 72.88764069200005],
              [-24.882476365999935, 72.86749909100007],
              [-24.872303839999915, 72.85390859600005],
              [-24.86823482999995, 72.83466217700004],
              [-24.86937415299991, 72.81460195500006],
              [-24.875070766999954, 72.79857005400004],
              [-24.90143795499995, 72.78204987200007],
              [-24.941395636999914, 72.77920156500005],
              [-25.041574673999946, 72.78782786700003],
              [-25.094146287999934, 72.80609772300005],
              [-25.286854620999918, 72.83405182500007],
              [-25.320668097999942, 72.84699127800008],
              [-25.289214647999927, 72.84520091400003],
              [-25.212269660999937, 72.85228099200003],
              [-25.18350175699993, 72.86066315300008],
              [-25.17487545499995, 72.86676666900007],
              [-25.158273891999954, 72.88320547100005],
              [-25.14940344999991, 72.88861725500004],
              [-25.128285285999937, 72.89227936400005],
              [-25.05695553299995, 72.88861725500004],
              [-25.036488410999937, 72.89175039300005],
              [-24.99559485599991, 72.90534088700008],
              [-24.974680141999954, 72.90843333500004],
              [-24.79991614499994, 72.91596100500004],
            ],
          ],
          [
            [
              [-21.928618943999936, 72.73777903900003],
              [-21.900461391999954, 72.73358795800004],
              [-21.878651495999918, 72.72329336100006],
              [-21.87490800699993, 72.70990631700005],
              [-21.900746222999942, 72.69684479400007],
              [-21.895659959999932, 72.69476959800005],
              [-21.896311001999948, 72.69330475500004],
              [-21.900746222999942, 72.68939850500004],
              [-21.894520636999914, 72.68939850500004],
              [-21.91893469999991, 72.68480052300004],
              [-21.994536912999934, 72.68256256700005],
              [-22.010568813999953, 72.68622467700004],
              [-22.020415818999936, 72.69651927300004],
              [-22.04320227799991, 72.69586823100008],
              [-22.086293097999942, 72.68939850500004],
              [-22.045318162999934, 72.71670156500005],
              [-22.07017981699994, 72.72093333500004],
              [-22.103627081999946, 72.71881745000007],
              [-22.13703365799995, 72.71222565300008],
              [-22.161447719999956, 72.70302969000005],
              [-22.16950436099995, 72.69562409100007],
              [-22.26504472599993, 72.70990631700005],
              [-22.654042120999918, 72.69806549700007],
              [-22.69204667899993, 72.70465729400007],
              [-22.723133917999917, 72.71670156500005],
              [-22.618519660999937, 72.72418854400007],
              [-22.613880988999938, 72.73777903900003],
              [-22.631337042999917, 72.74457428600005],
              [-22.71007239499994, 72.74457428600005],
              [-22.741851365999935, 72.75250885600008],
              [-22.771555141999954, 72.76508209800005],
              [-22.759917772999927, 72.77741120000007],
              [-22.763050910999937, 72.78733958500004],
              [-22.775461391999954, 72.79458242400005],
              [-22.79198157499991, 72.79857005400004],
              [-22.785227016999954, 72.80609772300005],
              [-22.819569464999915, 72.81879303600005],
              [-23.163319464999915, 72.87791575700004],
              [-23.262847459999932, 72.87156810100004],
              [-23.35265051999994, 72.87872955900008],
              [-23.470448370999918, 72.87498607000003],
              [-23.464222785999937, 72.87498607000003],
              [-23.616078253999945, 72.87091705900008],
              [-23.71898352799991, 72.89691803600005],
              [-23.83112545499995, 72.90778229400007],
              [-24.178679979499947, 72.90473053600007],
              [-24.526234503999945, 72.90167877800008],
              [-24.550038214999915, 72.91030508000006],
              [-24.57412675699993, 72.92788320500006],
              [-24.58690344999991, 72.95042552300004],
              [-24.57713782499991, 72.97394440300008],
              [-24.536488410999937, 72.99188873900005],
              [-24.157826301499938, 73.00366852400006],
              [-23.77916419199994, 73.01544830900008],
              [-23.704335089999915, 73.03070709800005],
              [-23.552357550999943, 73.03266022300005],
              [-23.238270636999914, 73.07526276200008],
              [-22.922434048999946, 73.03949616100005],
              [-22.81932532499991, 73.03949616100005],
              [-22.793568488999938, 73.03587474200003],
              [-22.744984503999945, 73.02204010600008],
              [-22.255034959999932, 72.97846100500004],
              [-22.095448370999918, 72.92999909100007],
              [-22.086293097999942, 72.92963288000004],
              [-22.08580481699994, 72.93183014500005],
              [-22.083159959999932, 72.93671295800004],
              [-22.078724738999938, 72.94159577000005],
              [-22.072621222999942, 72.94383372600004],
              [-22.046254035999937, 72.94013092700004],
              [-22.02179928299995, 72.93398672100005],
              [-21.996937628999945, 72.93268463700008],
              [-21.969593878999945, 72.94383372600004],
              [-21.957834438999953, 72.92934804900005],
              [-21.93736731699994, 72.92475006700005],
              [-21.915842251999948, 72.92275625200006],
              [-21.900746222999942, 72.91596100500004],
              [-21.898060675999943, 72.91095612200007],
              [-21.89606686099995, 72.90558502800008],
              [-21.89321855399993, 72.90021393400008],
              [-21.88768469999991, 72.89545319200005],
              [-21.916737433999913, 72.88641998900005],
              [-21.979359503999945, 72.87909577000005],
              [-22.004383917999917, 72.86066315300008],
              [-21.996693488999938, 72.85809967700004],
              [-21.97642981699994, 72.84699127800008],
              [-21.988392706999946, 72.84381745000007],
              [-22.021148240999935, 72.84699127800008],
              [-22.03416907499991, 72.84536367400005],
              [-22.07323157499991, 72.83397044500003],
              [-22.160267706999946, 72.82265859600005],
              [-22.188710089999915, 72.81232330900008],
              [-22.159779425999943, 72.80426666900007],
              [-22.135243292999917, 72.80438873900005],
              [-22.113636847999942, 72.80683014500005],
              [-22.093088344999956, 72.80609772300005],
              [-22.09093176999994, 72.80353424700007],
              [-22.08897864499994, 72.79889557500007],
              [-22.084868943999936, 72.79441966400003],
              [-22.07603919199994, 72.79242584800005],
              [-21.994984503999945, 72.78335195500006],
              [-21.978993292999917, 72.77960846600007],
              [-21.963368292999917, 72.77130768400008],
              [-21.978138800999943, 72.76630280200004],
              [-22.02489173099991, 72.75824616100005],
              [-22.016102667999917, 72.74848053600005],
              [-22.004709438999953, 72.74506256700005],
              [-21.97642981699994, 72.74457428600005],
              [-21.968739386999914, 72.74567291900007],
              [-21.96275794199994, 72.74848053600005],
              [-21.956654425999943, 72.75039297100005],
              [-21.948841925999943, 72.74835846600007],
              [-21.93455969999991, 72.73883698100008],
              [-21.928618943999936, 72.73777903900003],
            ],
          ],
          [
            [
              [-21.325917120999918, 73.14809804900005],
              [-21.203521287999934, 73.14606354400007],
              [-21.168324347999942, 73.13442617400005],
              [-21.178618943999936, 73.13300202000005],
              [-21.185943162999934, 73.13035716400003],
              [-21.189605272999927, 73.12645091400003],
              [-21.188791469999956, 73.12140534100007],
              [-21.328277147999927, 73.10097890800006],
              [-21.39671790299991, 73.09975820500006],
              [-21.462513800999943, 73.12140534100007],
              [-21.361887173999946, 73.14712148600006],
              [-21.325917120999918, 73.14809804900005],
            ],
          ],
          [
            [
              [-24.524281378999945, 73.04791901200008],
              [-24.55654863199993, 73.05296458500004],
              [-24.652821417999917, 73.04629140800006],
              [-24.675526495999918, 73.04950592700004],
              [-24.75153561099995, 73.07294342700004],
              [-24.88540605399993, 73.07855866100005],
              [-25.063221808999913, 73.11835358300004],
              [-25.430531378999945, 73.12140534100007],
              [-25.573475714999915, 73.14826080900008],
              [-25.658558722999942, 73.17641836100006],
              [-25.701527472999942, 73.18280670800004],
              [-25.70726477799991, 73.18471914300005],
              [-25.71043860599991, 73.18927643400008],
              [-25.71080481699994, 73.19489166900007],
              [-25.70799719999991, 73.20018138200004],
              [-25.69945227799991, 73.20701732000003],
              [-25.691151495999918, 73.21010976800005],
              [-25.64635169199994, 73.21393463700008],
              [-25.600493943999936, 73.22809479400007],
              [-25.577381964999915, 73.23126862200007],
              [-25.567534959999932, 73.23468659100007],
              [-25.533314581999946, 73.26166413000004],
              [-25.44953365799995, 73.29730866100005],
              [-25.31236731699994, 73.32001373900005],
              [-25.285959438999953, 73.33368561400005],
              [-25.285755988999938, 73.34756094000005],
              [-25.29482988199993, 73.35903554900005],
              [-25.30215410099993, 73.37075429900005],
              [-25.29678300699993, 73.38519928600005],
              [-25.27257239499994, 73.40249258000006],
              [-25.243519660999937, 73.41111888200004],
              [-24.85179602799994, 73.41807689000004],
              [-24.46007239499994, 73.42503489800004],
              [-24.395863410999937, 73.41559479400007],
              [-24.00731360599993, 73.3607716603334],
              [-23.618763800999925, 73.30594852666673],
              [-23.230213995999918, 73.25112539300005],
              [-23.209787563999953, 73.23126862200007],
              [-23.257801886999914, 73.22113678600005],
              [-23.685963507999915, 73.24718862525005],
              [-24.114125128999916, 73.27324046450005],
              [-24.542286749999917, 73.29929230375005],
              [-24.970448370999918, 73.32534414300005],
              [-24.99242102799991, 73.32160065300008],
              [-25.012196417999917, 73.31317780200004],
              [-24.98546301999994, 73.30654531500005],
              [-24.95811926999994, 73.31000397300005],
              [-24.930409308999913, 73.31688060100004],
              [-24.907460089999915, 73.31728750200006],
              [-24.882639126999948, 73.31395091400003],
              [-24.816883917999917, 73.30182526200008],
              [-24.436756964999915, 73.27391185100004],
              [-24.374256964999915, 73.25629303600005],
              [-24.30650794199994, 73.26536692900004],
              [-24.056935187999926, 73.23287588100004],
              [-23.807362433999913, 73.20038483300004],
              [-23.785755988999938, 73.20331452000005],
              [-23.766224738999938, 73.19529857000003],
              [-23.423430956499942, 73.18563467000004],
              [-23.080637173999946, 73.17597077000005],
              [-22.992787238999938, 73.15159739800004],
              [-22.96397864499994, 73.14809804900005],
              [-22.89244544199994, 73.15802643400008],
              [-22.91624915299991, 73.14801666900007],
              [-22.96198482999995, 73.11440664300005],
              [-22.98070227799991, 73.10712311400005],
              [-23.476307746666578, 73.08344147333338],
              [-23.971913215333245, 73.05975983266671],
              [-24.467518683999913, 73.03607819200005],
              [-24.524281378999945, 73.04791901200008],
            ],
          ],
          [
            [
              [-20.352691209999932, 74.25165436400005],
              [-20.29751542899993, 74.23216380400004],
              [-20.26939856699994, 74.22719961100006],
              [-20.249663865999935, 74.23114655200004],
              [-20.22134355399993, 74.22134023600006],
              [-20.17731686099995, 74.21942780200004],
              [-20.140248175999943, 74.21320221600007],
              [-20.132964647999927, 74.19017161700003],
              [-20.16152910099993, 74.16876862200007],
              [-20.46487382749993, 74.14366282750007],
              [-20.76821855399993, 74.11855703300006],
              [-20.875152147999927, 74.12221914300005],
              [-21.025461391999954, 74.09634023600006],
              [-21.26866614499994, 74.08779531500005],
              [-21.278635219999956, 74.08954498900005],
              [-21.405873175999943, 74.13719310100004],
              [-21.66940263549995, 74.17243073100005],
              [-21.932932094999956, 74.20766836100006],
              [-21.97996985599991, 74.22528717700004],
              [-21.98696855399993, 74.24823639500005],
              [-21.960560675999943, 74.27431875200006],
              [-21.95962480399993, 74.27960846600007],
              [-21.94440670499995, 74.29271067900004],
              [-21.94172115799995, 74.29633209800005],
              [-21.900746222999942, 74.31370677300004],
              [-21.896107550999943, 74.31435781500005],
              [-21.885161912999934, 74.31268952000005],
              [-21.880848761999914, 74.31370677300004],
              [-21.87686113199993, 74.31879303600005],
              [-21.875884568999936, 74.32493724200003],
              [-21.875599738999938, 74.33063385600008],
              [-21.87401282499991, 74.33421458500004],
              [-21.85806230399993, 74.34369538000004],
              [-21.839995897999927, 74.35122304900005],
              [-21.543527798999918, 74.40416087450006],
              [-21.24705969999991, 74.45709870000007],
              [-20.980946417999917, 74.45018138200004],
              [-20.968739386999914, 74.44818756700005],
              [-20.955962693999936, 74.44403717700004],
              [-20.95140540299991, 74.44086334800005],
              [-20.94237219999991, 74.43036530200004],
              [-20.921254035999937, 74.42527903900003],
              [-20.856353318999936, 74.43036530200004],
              [-20.547596808999913, 74.40989817900004],
              [-20.533355272999927, 74.40672435100004],
              [-20.51073157499991, 74.39008209800005],
              [-20.496083136999914, 74.38263580900008],
              [-20.458241339999915, 74.36896393400008],
              [-20.44163977799991, 74.35797760600008],
              [-20.43464107999995, 74.34442780200004],
              [-20.438710089999915, 74.33649323100008],
              [-20.45734615799995, 74.32904694200005],
              [-20.462554490999935, 74.32054271000004],
              [-20.46080481699994, 74.30914948100008],
              [-20.45303300699993, 74.30536530200004],
              [-20.442250128999945, 74.30312734600005],
              [-20.431263800999943, 74.29633209800005],
              [-20.427113410999937, 74.29035065300008],
              [-20.425119594999956, 74.28583405200004],
              [-20.42015540299991, 74.28070709800005],
              [-20.40733801999994, 74.27277252800008],
              [-20.352691209999932, 74.25165436400005],
            ],
          ],
          [
            [
              [-18.735218878999945, 74.63247304900005],
              [-18.726226365999935, 74.63300202000005],
              [-18.723500128999945, 74.62661367400005],
              [-18.728342251999948, 74.61884186400005],
              [-18.74205481699994, 74.61542389500005],
              [-18.74323482999995, 74.61220937700006],
              [-18.743031378999945, 74.60919830900008],
              [-18.744252081999946, 74.60740794500003],
              [-18.74950110599991, 74.60789622600004],
              [-18.728911912999934, 74.58755117400005],
              [-18.73619544199994, 74.57273997600004],
              [-18.758534308999913, 74.56240469000005],
              [-18.82335364499994, 74.54730866100005],
              [-19.14639238199993, 74.55133698100008],
              [-19.173491990999935, 74.54523346600007],
              [-19.162709113999938, 74.55149974200003],
              [-19.157582160999937, 74.55560944200005],
              [-19.152943488999938, 74.56073639500005],
              [-19.189930792999917, 74.56956614800004],
              [-19.207508917999917, 74.57648346600007],
              [-19.221831834999932, 74.58746979400007],
              [-19.20604407499991, 74.59723541900007],
              [-19.14671790299991, 74.60789622600004],
              [-19.080230272999927, 74.63483307500007],
              [-18.904896613999938, 74.67548248900005],
              [-18.855213995999918, 74.67670319200005],
              [-18.793365037999934, 74.67161692900004],
              [-18.763783331999946, 74.66327545800004],
              [-18.74950110599991, 74.64887116100005],
              [-18.78547115799995, 74.64142487200007],
              [-18.80109615799995, 74.63410065300008],
              [-18.810292120999918, 74.62221914300005],
              [-18.771839972999942, 74.62303294500003],
              [-18.75291907499991, 74.62612539300005],
              [-18.735218878999945, 74.63247304900005],
            ],
          ],
          [
            [
              [-18.371490037999934, 74.71161530200004],
              [-18.319081183999913, 74.71417877800008],
              [-18.30382239499994, 74.71161530200004],
              [-18.311105923999946, 74.70600006700005],
              [-18.31899980399993, 74.70343659100007],
              [-18.327951626999948, 74.70307038000004],
              [-18.338002081999946, 74.70408763200004],
              [-18.34911048099991, 74.70359935100004],
              [-18.359771287999934, 74.70010000200006],
              [-18.378895636999914, 74.69049713700008],
              [-18.378895636999914, 74.68366120000007],
              [-18.346831834999932, 74.67133209800005],
              [-18.32445227799991, 74.65298086100006],
              [-18.32408606699994, 74.63629791900007],
              [-18.35846920499995, 74.62905508000006],
              [-18.482574022999927, 74.62921784100007],
              [-18.49901282499991, 74.63300202000005],
              [-18.49559485599991, 74.64264557500007],
              [-18.507883266999954, 74.65395742400005],
              [-18.536488410999937, 74.66771067900004],
              [-18.55028235599991, 74.67682526200008],
              [-18.548939581999946, 74.69318268400008],
              [-18.561350063999953, 74.70490143400008],
              [-18.57835852799991, 74.71466705900008],
              [-18.591175910999937, 74.72528717700004],
              [-18.471424933999913, 74.71161530200004],
              [-18.371490037999934, 74.71161530200004],
            ],
          ],
          [
            [
              [-19.80996660099993, 74.89085521000004],
              [-19.764881964999915, 74.88662344000005],
              [-19.741118943999936, 74.88133372600004],
              [-19.728871222999942, 74.86859772300005],
              [-19.734974738999938, 74.85529205900008],
              [-19.75300045499995, 74.84564850500004],
              [-19.790394660999937, 74.83441803600005],
              [-19.891021287999934, 74.77411530200004],
              [-19.96776282499991, 74.75722890800006],
              [-20.04600989499994, 74.71735260600008],
              [-20.08580481699994, 74.70408763200004],
              [-20.13825436099995, 74.69928620000007],
              [-20.253081834999932, 74.70673248900005],
              [-20.327870245999918, 74.72589752800008],
              [-20.43317623599995, 74.73419830900008],
              [-20.662587042999917, 74.80524323100008],
              [-20.68073482999995, 74.82094961100006],
              [-20.65957597599993, 74.83567942900004],
              [-20.592274542999917, 74.86237213700008],
              [-20.575998501999948, 74.87457916900007],
              [-20.560536261999914, 74.89004140800006],
              [-20.54906165299991, 74.90790436400005],
              [-20.54450436099995, 74.92723216400003],
              [-20.552479620999918, 74.94619375200006],
              [-20.571522589999915, 74.96149323100008],
              [-20.613392706999946, 74.98529694200005],
              [-20.599720831999946, 74.99896881700005],
              [-20.560902472999942, 75.00690338700008],
              [-20.47996985599991, 75.03945547100005],
              [-20.339100714999915, 75.05418528900003],
              [-20.18895423099991, 75.04409414300005],
              [-20.101551886999914, 75.02374909100007],
              [-20.006255662999934, 75.01650625200006],
              [-19.97687740799995, 75.01064687700006],
              [-19.961659308999913, 74.99896881700005],
              [-19.967152472999942, 74.98460521000004],
              [-19.985503709999932, 74.97492096600007],
              [-20.175119594999956, 74.93895091400003],
              [-20.201893683999913, 74.92381419500003],
              [-20.195668097999942, 74.91168854400007],
              [-20.176380988999938, 74.90387604400007],
              [-20.15416419199994, 74.90045807500007],
              [-20.13857988199993, 74.90143463700008],
              [-20.132069464999915, 74.90741608300004],
              [-20.128163214999915, 74.91669342700004],
              [-20.12295488199993, 74.92568594000005],
              [-20.112538214999915, 74.93065013200004],
              [-20.09902910099993, 74.92609284100007],
              [-20.08702551999994, 74.92666250200006],
              [-20.061268683999913, 74.93065013200004],
              [-20.030506964999915, 74.93008047100005],
              [-20.017567511999914, 74.92804596600007],
              [-20.016957160999937, 74.92381419500003],
              [-19.992990688999953, 74.92413971600007],
              [-19.80996660099993, 74.89085521000004],
            ],
          ],
          [
            [
              [-17.316965298999946, 75.13613515800006],
              [-17.380197719999956, 75.10077545800004],
              [-17.39952551999994, 75.07697174700007],
              [-17.38585364499994, 75.04677969000005],
              [-17.374623175999943, 75.04144928600005],
              [-17.363270636999914, 75.04096100500004],
              [-17.35460364499994, 75.03896719000005],
              [-17.35106360599991, 75.02936432500007],
              [-17.355295376999948, 75.02594635600008],
              [-17.38385982999995, 75.01715729400007],
              [-17.449330206999946, 75.00726959800005],
              [-17.51553300699993, 75.00580475500004],
              [-17.49762936099995, 74.99811432500007],
              [-17.496245897999927, 74.98582591400003],
              [-17.506214972999942, 74.97239817900004],
              [-17.52245032499991, 74.96141185100004],
              [-17.549672003999945, 74.94961172100005],
              [-17.583973761999914, 74.93927643400008],
              [-17.618397589999915, 74.93573639500005],
              [-17.64590410099993, 74.94432200700004],
              [-17.63267981699994, 74.94769928600005],
              [-17.61937415299991, 74.95433177300004],
              [-17.609038865999935, 74.96369049700007],
              [-17.60496985599991, 74.97540924700007],
              [-17.605946417999917, 74.99168528900003],
              [-17.611073370999918, 74.99762604400007],
              [-17.64590410099993, 74.99896881700005],
              [-17.73468990799995, 75.01264069200005],
              [-17.817209438999953, 75.00580475500004],
              [-17.817209438999953, 75.01264069200005],
              [-17.810373501999948, 75.01264069200005],
              [-17.83617102799991, 75.03082916900007],
              [-17.880116339999915, 75.03595612200007],
              [-18.100738084999932, 75.03803131700005],
              [-18.178212042999917, 75.01752350500004],
              [-18.447865363999938, 74.98529694200005],
              [-18.823841925999943, 75.00714752800008],
              [-18.892648891999954, 74.99921295800004],
              [-18.908680792999917, 75.00910065300008],
              [-18.918690558999913, 75.02619049700007],
              [-18.92760169199994, 75.04677969000005],
              [-18.92088782499991, 75.05451080900008],
              [-18.923491990999935, 75.06142812700006],
              [-18.928212042999917, 75.06976959800005],
              [-18.92760169199994, 75.08148834800005],
              [-18.919260219999956, 75.09487539300005],
              [-18.90721594999991, 75.10504791900007],
              [-18.838002081999946, 75.14984772300005],
              [-18.83145097599993, 75.15664297100005],
              [-18.83893795499995, 75.16771067900004],
              [-18.886708136999914, 75.19074127800008],
              [-18.850412563999953, 75.19415924700007],
              [-18.83690344999991, 75.20587799700007],
              [-18.83820553299995, 75.26308828300006],
              [-18.853260870999918, 75.29482656500005],
              [-18.887603318999936, 75.30776601800005],
              [-18.924672003999945, 75.31610748900005],
              [-18.948068813999953, 75.33417389500005],
              [-18.797271287999934, 75.33624909100007],
              [-18.769642706999946, 75.34198639500005],
              [-18.71320553299995, 75.36029694200005],
              [-18.69908606699994, 75.36188385600008],
              [-18.67284094999991, 75.35651276200008],
              [-18.659820115999935, 75.35700104400007],
              [-18.539621548999946, 75.37506745000007],
              [-18.513417120999918, 75.37319570500006],
              [-18.42178300699993, 75.34064362200007],
              [-18.39940344999991, 75.32786692900004],
              [-18.38853919199994, 75.31085846600007],
              [-18.38573157499991, 75.30744049700007],
              [-18.372303839999915, 75.30426666900007],
              [-18.316802537999934, 75.29999420800004],
              [-18.213612433999913, 75.31012604400007],
              [-18.16038977799991, 75.32306549700007],
              [-18.125721808999913, 75.34153880400004],
              [-18.13109290299991, 75.35016510600008],
              [-18.13418535099993, 75.35903554900005],
              [-18.134592251999948, 75.36766185100004],
              [-18.132476365999935, 75.37567780200004],
              [-18.135894334999932, 75.38401927300004],
              [-18.129465298999946, 75.39207591400003],
              [-18.117746548999946, 75.39874909100007],
              [-18.105132615999935, 75.40302155200004],
              [-18.09406490799995, 75.41933828300006],
              [-18.051340298999946, 75.42011139500005],
              [-18.00145423099991, 75.41233958500004],
              [-17.96861731699994, 75.40302155200004],
              [-17.959462042999917, 75.39948151200008],
              [-17.934152798999946, 75.38092682500007],
              [-17.91934160099993, 75.37396881700005],
              [-17.866851365999935, 75.35993073100008],
              [-17.84520423099991, 75.34804922100005],
              [-17.851307745999918, 75.33417389500005],
              [-17.81436113199993, 75.32151927300004],
              [-17.802886522999927, 75.31427643400008],
              [-17.832508917999917, 75.29474518400008],
              [-17.975331183999913, 75.25999583500004],
              [-18.122792120999918, 75.26675039300005],
              [-18.146148240999935, 75.25967031500005],
              [-18.11827551999994, 75.25967031500005],
              [-18.104644334999932, 75.25714752800008],
              [-18.091542120999918, 75.25218333500004],
              [-18.17686926999994, 75.24603913000004],
              [-18.19835364499994, 75.24164459800005],
              [-18.211048956999946, 75.23208242400005],
              [-18.20921790299991, 75.22235748900005],
              [-18.11978105399993, 75.20941803600005],
              [-18.027333136999914, 75.23265208500004],
              [-18.015777147999927, 75.22894928600005],
              [-18.01781165299991, 75.21702708500004],
              [-18.022816535999937, 75.21039459800005],
              [-18.029449022999927, 75.20526764500005],
              [-18.047027147999927, 75.18524811400005],
              [-18.052357550999943, 75.18235911700003],
              [-18.020090298999946, 75.15867747600004],
              [-18.000721808999913, 75.14862702000005],
              [-17.98033606699994, 75.14081452000005],
              [-17.96117102799991, 75.13613515800006],
              [-17.923654751999948, 75.13816966400003],
              [-17.91274980399993, 75.13613515800006],
              [-17.906320766999954, 75.13092682500007],
              [-17.902943488999938, 75.12457916900007],
              [-17.901112433999913, 75.11884186400005],
              [-17.899159308999913, 75.11562734600005],
              [-17.858998175999943, 75.09943268400008],
              [-17.813384568999936, 75.08885325700004],
              [-17.72166907499991, 75.08148834800005],
              [-17.602894660999937, 75.09882233300004],
              [-17.590321417999917, 75.10285065300008],
              [-17.58385169199994, 75.10822174700007],
              [-17.585275844999956, 75.11688873900005],
              [-17.59276282499991, 75.12189362200007],
              [-17.60106360599991, 75.12506745000007],
              [-17.60496985599991, 75.12872955900008],
              [-17.589914516999954, 75.15253327000005],
              [-17.554798956999946, 75.15546295800004],
              [-17.511870897999927, 75.15029531500005],
              [-17.473947719999956, 75.14980703300006],
              [-17.433664516999954, 75.15692780200004],
              [-17.394642706999946, 75.15961334800005],
              [-17.356068488999938, 75.15399811400005],
              [-17.316965298999946, 75.13613515800006],
            ],
          ],
          [
            [
              [-18.55028235599991, 76.05414459800005],
              [-18.55378170499995, 76.04165273600006],
              [-18.549305792999917, 76.01463450700004],
              [-18.55028235599991, 75.99884674700007],
              [-18.56822669199994, 75.96898021000004],
              [-18.569081183999913, 75.95530833500004],
              [-18.55028235599991, 75.94428131700005],
              [-18.568470831999946, 75.92658112200007],
              [-18.59788977799991, 75.90460846600007],
              [-18.629302537999934, 75.89223867400005],
              [-18.65330969999991, 75.90326569200005],
              [-18.652699347999942, 75.92137278900003],
              [-18.63963782499991, 75.94106679900005],
              [-18.62913977799991, 75.96157461100006],
              [-18.63585364499994, 75.98212311400005],
              [-18.87100175699993, 76.19399648600006],
              [-18.902902798999946, 76.23822663000004],
              [-18.903146938999953, 76.27016836100006],
              [-18.891346808999913, 76.29092031500005],
              [-18.902333136999914, 76.30678945500006],
              [-18.948068813999953, 76.33527252800008],
              [-19.10643469999991, 76.47345612200007],
              [-19.132923956999946, 76.51300690300008],
              [-19.125599738999938, 76.55499909100007],
              [-19.095041469999956, 76.58193594000005],
              [-19.057240363999938, 76.59369538000004],
              [-19.015248175999943, 76.59638092700004],
              [-18.815663214999915, 76.58454010600008],
              [-18.76317298099991, 76.58856842700004],
              [-18.770008917999917, 76.59552643400008],
              [-18.778187628999945, 76.60016510600008],
              [-18.787261522999927, 76.60248444200005],
              [-18.797271287999934, 76.60219961100006],
              [-18.787587042999917, 76.60822174700007],
              [-18.783029751999948, 76.60960521000004],
              [-18.783029751999948, 76.61644114800004],
              [-18.93578040299991, 76.62384674700007],
              [-18.984934048999946, 76.61615631700005],
              [-18.984974738999938, 76.62579987200007],
              [-18.998890753999945, 76.63666413000004],
              [-19.01707923099991, 76.64765045800004],
              [-19.030018683999913, 76.65741608300004],
              [-19.035267706999946, 76.67182038000004],
              [-19.03892981699994, 76.68988678600005],
              [-19.047434048999946, 76.70547109600005],
              [-19.083648240999935, 76.71889883000006],
              [-19.072743292999917, 76.73432038000004],
              [-19.04987545499995, 76.75055573100008],
              [-19.030018683999913, 76.75983307500007],
              [-19.00182044199994, 76.76512278900003],
              [-18.974720831999946, 76.76609935100004],
              [-18.947865363999938, 76.76227448100008],
              [-18.92015540299991, 76.75307851800005],
              [-18.89867102799991, 76.74030182500007],
              [-18.726226365999935, 76.69074127800008],
              [-18.70103919199994, 76.67792389500005],
              [-18.67341061099995, 76.65546295800004],
              [-18.660145636999914, 76.63287995000007],
              [-18.660308397999927, 76.60871002800008],
              [-18.673166469999956, 76.58173248900005],
              [-18.71312415299991, 76.53921133000006],
              [-18.721547003999945, 76.52708567900004],
              [-18.72297115799995, 76.51097239800004],
              [-18.71621660099993, 76.50067780200004],
              [-18.707020636999914, 76.49140045800004],
              [-18.70103919199994, 76.47870514500005],
              [-18.70262610599991, 76.45530833500004],
              [-18.709095831999946, 76.43268463700008],
              [-18.711496548999946, 76.40916575700004],
              [-18.707875128999945, 76.38312409100007],
              [-18.70148678299995, 76.36920807500007],
              [-18.699208136999914, 76.34357330900008],
              [-18.69481360599991, 76.32843659100007],
              [-18.686146613999938, 76.31443919500003],
              [-18.67341061099995, 76.29926178600005],
              [-18.61864173099991, 76.25014883000006],
              [-18.607167120999918, 76.23493073100008],
              [-18.605458136999914, 76.21857330900008],
              [-18.61904863199993, 76.20343659100007],
              [-18.63931230399993, 76.19232819200005],
              [-18.652902798999946, 76.18073151200008],
              [-18.646473761999914, 76.16400788000004],
              [-18.620350714999915, 76.12531159100007],
              [-18.60887610599991, 76.11212799700007],
              [-18.570708787999934, 76.08486562700006],
              [-18.56822669199994, 76.07623932500007],
              [-18.562245245999918, 76.06704336100006],
              [-18.55028235599991, 76.05414459800005],
            ],
          ],
          [
            [
              [-18.00649980399993, 77.63690827000005],
              [-18.227162238999938, 77.63735586100006],
              [-18.267201300999943, 77.65672435100004],
              [-18.228627081999946, 77.66522858300004],
              [-18.136830206999946, 77.72939687700006],
              [-17.993804490999935, 77.77220286700003],
              [-17.97179114499994, 77.79047272300005],
              [-17.967396613999938, 77.82420482000003],
              [-17.95335852799991, 77.84454987200007],
              [-17.928089972999942, 77.85724518400008],
              [-17.89012610599991, 77.86835358300004],
              [-17.861480272999927, 77.87343984600005],
              [-17.723459438999953, 77.88178131700005],
              [-17.702748175999943, 77.88019440300008],
              [-17.698597785999937, 77.87030670800004],
              [-17.633534308999913, 77.82782623900005],
              [-17.617298956999946, 77.80658600500004],
              [-17.635975714999915, 77.78025950700004],
              [-17.70262610599991, 77.74494049700007],
              [-17.718495245999918, 77.73309967700004],
              [-17.744618292999917, 77.69350820500006],
              [-17.75576738199993, 77.68158600500004],
              [-17.80890865799995, 77.65546295800004],
              [-17.875803188999953, 77.64374420800004],
              [-18.00649980399993, 77.63690827000005],
            ],
          ],
          [
            [
              [-21.38149980399993, 77.86432526200008],
              [-21.394520636999914, 77.87262604400007],
              [-21.403553839999915, 77.88247304900005],
              [-21.405588344999956, 77.89337799700007],
              [-21.39793860599991, 77.90534088700008],
              [-21.368519660999937, 77.92743561400005],
              [-21.33299719999991, 77.94594961100006],
              [-21.295033331999946, 77.95868561400005],
              [-21.24754798099991, 77.96564362200007],
              [-21.23033606699994, 77.97540924700007],
              [-21.127756313999953, 77.99030182500007],
              [-21.107411261999914, 77.98956940300008],
              [-21.086415167999917, 77.98452383000006],
              [-21.092681443999936, 77.98191966400003],
              [-21.09593665299991, 77.97797272300005],
              [-21.09788977799991, 77.97382233300004],
              [-21.100005662999934, 77.97085195500006],
              [-21.123890753999945, 77.96906159100007],
              [-21.15379798099991, 77.96108633000006],
              [-21.172230597999942, 77.94773997600004],
              [-21.161488410999937, 77.92987702000005],
              [-21.179839647999927, 77.92039622600004],
              [-21.216786261999914, 77.90957265800006],
              [-21.234120245999918, 77.89850495000007],
              [-21.237049933999913, 77.89423248900005],
              [-21.238026495999918, 77.88930898600006],
              [-21.23786373599995, 77.87836334800005],
              [-21.243397589999915, 77.87567780200004],
              [-21.329701300999943, 77.85496653900003],
              [-21.35460364499994, 77.85516998900005],
              [-21.38149980399993, 77.86432526200008],
            ],
          ],
          [
            [
              [-19.318023240999935, 77.88328685100004],
              [-19.29246985599991, 77.87775299700007],
              [-19.263417120999918, 77.86481354400007],
              [-19.241078253999945, 77.84756094000005],
              [-19.23546301999994, 77.82868073100008],
              [-19.261341925999943, 77.80898672100005],
              [-19.30846106699994, 77.80369700700004],
              [-19.69682098433327, 77.85198259733339],
              [-20.085180901666604, 77.90026818766673],
              [-20.473540818999936, 77.94855377800008],
              [-20.489857550999943, 77.95966217700004],
              [-20.467640753999945, 77.97060781500005],
              [-20.438221808999913, 77.97679271000004],
              [-20.205962693999936, 77.97284577000005],
              [-20.161488410999937, 77.97679271000004],
              [-20.117787238999938, 77.98794179900005],
              [-20.052479620999918, 77.99091217700004],
              [-20.01431230399993, 77.99860260600008],
              [-19.995716925999943, 77.99994538000004],
              [-19.976551886999914, 77.99494049700007],
              [-19.95840410099993, 77.98248932500007],
              [-19.928212042999917, 77.95042552300004],
              [-19.911284959999932, 77.93671295800004],
              [-19.897694464999915, 77.93036530200004],
              [-19.746652798999946, 77.89443594000005],
              [-19.358306443999936, 77.89765045800004],
              [-19.318023240999935, 77.88328685100004],
            ],
          ],
          [
            [
              [-19.17137610599991, 77.99530670800004],
              [-19.12450110599991, 78.02387116100005],
              [-19.107085740999935, 78.04287344000005],
              [-19.113880988999938, 78.06134674700007],
              [-19.16392981699994, 78.07660553600005],
              [-19.23350989499994, 78.08608633000006],
              [-19.29482988199993, 78.10407135600008],
              [-19.320423956999946, 78.14447663000004],
              [-19.296498175999943, 78.14378489800004],
              [-19.224964972999942, 78.11994049700007],
              [-19.177561001999948, 78.11005280200004],
              [-19.15257727799991, 78.10883209800005],
              [-18.950550910999937, 78.12738678600005],
              [-18.877674933999913, 78.14472077000005],
              [-18.859852667999917, 78.14447663000004],
              [-18.869618292999917, 78.12710195500006],
              [-18.88853919199994, 78.11546458500004],
              [-18.909901495999918, 78.10578034100007],
              [-18.92686926999994, 78.09418366100005],
              [-18.93195553299995, 78.07660553600005],
              [-18.925445115999935, 78.05687083500004],
              [-18.91161048099991, 78.04328034100007],
              [-18.89439856699994, 78.04385000200006],
              [-19.11156165299991, 77.93227773600006],
              [-19.15538489499994, 77.92055898600006],
              [-19.172678188999953, 77.91889069200005],
              [-19.18932044199994, 77.92023346600007],
              [-19.201771613999938, 77.92743561400005],
              [-19.20612545499995, 77.94367096600007],
              [-19.202381964999915, 77.95868561400005],
              [-19.194243943999936, 77.97304922100005],
              [-19.183257615999935, 77.98554108300004],
              [-19.17137610599991, 77.99530670800004],
            ],
          ],
          [
            [
              [-20.379505988999938, 78.13605377800008],
              [-20.43350175699993, 78.12750885600008],
              [-20.600331183999913, 78.13324616100005],
              [-20.814605272999927, 78.17499420800004],
              [-20.789418097999942, 78.18244049700007],
              [-20.711537238999938, 78.18968333500004],
              [-20.68350175699993, 78.19619375200006],
              [-20.55260169199994, 78.24310944200005],
              [-20.505034959999932, 78.25092194200005],
              [-20.467640753999945, 78.24945709800005],
              [-20.43106035099993, 78.24087148600006],
              [-20.396473761999914, 78.22565338700008],
              [-20.365589972999942, 78.20449453300006],
              [-20.346506313999953, 78.18292877800008],
              [-20.34211178299995, 78.16351959800005],
              [-20.35293535099993, 78.14740631700005],
              [-20.379505988999938, 78.13605377800008],
            ],
          ],
          [
            [
              [-19.445057745999918, 78.20001862200007],
              [-19.496693488999938, 78.20136139500005],
              [-19.51431230399993, 78.20966217700004],
              [-19.501291469999956, 78.22842031500005],
              [-19.558949347999942, 78.24909088700008],
              [-19.62840735599991, 78.25495026200008],
              [-19.64757239499994, 78.26479726800005],
              [-19.65778561099995, 78.28359609600005],
              [-19.659047003999945, 78.30687083500004],
              [-19.65416419199994, 78.33063385600008],
              [-19.64639238199993, 78.35081614800004],
              [-19.630034959999932, 78.36481354400007],
              [-19.607980923999946, 78.36151764500005],
              [-19.560943162999934, 78.33954498900005],
              [-19.469105597999942, 78.30963776200008],
              [-19.44163977799991, 78.29279205900008],
              [-19.429514126999948, 78.28021881700005],
              [-19.403675910999937, 78.23704661700003],
              [-19.392201300999943, 78.22443268400008],
              [-19.381743943999936, 78.21784088700008],
              [-19.369536912999934, 78.21531810100004],
              [-19.352406378999945, 78.21482982000003],
              [-19.445057745999918, 78.20001862200007],
            ],
          ],
          [
            [
              [-18.91783606699994, 78.44354889500005],
              [-18.891102667999917, 78.40648021000004],
              [-18.889963344999956, 78.39423248900005],
              [-18.901193813999953, 78.39321523600006],
              [-18.91392981699994, 78.38996002800008],
              [-18.925852016999954, 78.38495514500005],
              [-18.93464107999995, 78.37860748900005],
              [-18.90770423099991, 78.35276927300004],
              [-18.905100063999953, 78.34149811400005],
              [-18.92284094999991, 78.33344147300005],
              [-18.942250128999945, 78.33169179900005],
              [-19.020130988999938, 78.33331940300008],
              [-19.04002844999991, 78.33026764500005],
              [-19.056385870999918, 78.32290273600006],
              [-19.063384568999936, 78.30882396000004],
              [-19.056630011999914, 78.29230377800008],
              [-19.04002844999991, 78.28095123900005],
              [-18.897084113999938, 78.24213288000004],
              [-18.88076738199993, 78.23183828300006],
              [-18.881459113999938, 78.22020091400003],
              [-18.89366614499994, 78.21039459800005],
              [-18.912098761999914, 78.20506419500003],
              [-19.002105272999927, 78.19578685100004],
              [-19.04906165299991, 78.18475983300004],
              [-19.07380123599995, 78.18504466400003],
              [-19.088612433999913, 78.19896067900004],
              [-19.271107550999943, 78.23065827000005],
              [-19.26040605399993, 78.24433014500005],
              [-19.257557745999918, 78.25751373900005],
              [-19.260324673999946, 78.27191803600005],
              [-19.266428188999953, 78.28888580900008],
              [-19.277170376999948, 78.30585358300004],
              [-19.306263800999943, 78.33340078300006],
              [-19.31550045499995, 78.34772370000007],
              [-19.289214647999927, 78.36810944200005],
              [-19.257435675999943, 78.38434479400007],
              [-18.93846594999991, 78.47528717700004],
              [-18.928578253999945, 78.47321198100008],
              [-18.923085089999915, 78.46735260600008],
              [-18.920643683999913, 78.45978424700007],
              [-18.91783606699994, 78.44354889500005],
            ],
          ],
          [
            [
              [-18.234934048999946, 78.61692942900004],
              [-18.251576300999943, 78.60468170800004],
              [-18.315052863999938, 78.58038971600007],
              [-18.473866339999915, 78.54930247600004],
              [-18.472401495999918, 78.54596588700008],
              [-18.47012285099993, 78.53888580900008],
              [-18.467640753999945, 78.53506094000005],
              [-18.509755011999914, 78.52558014500005],
              [-18.563710089999915, 78.52362702000005],
              [-18.61587480399993, 78.53253815300008],
              [-18.652699347999942, 78.55548737200007],
              [-18.633168097999942, 78.56785716400003],
              [-18.56236731699994, 78.58148834800005],
              [-18.50291907499991, 78.61115143400008],
              [-18.451527472999942, 78.62592194200005],
              [-18.39199785099993, 78.63641998900005],
              [-18.25694739499994, 78.63255442900004],
              [-18.227447068999936, 78.62376536700003],
              [-18.234934048999946, 78.61692942900004],
            ],
          ],
          [
            [
              [-18.205189581999946, 78.73676178600005],
              [-18.23428300699993, 78.75112539300005],
              [-18.244862433999913, 78.76251862200007],
              [-18.232411261999914, 78.77773672100005],
              [-18.239857550999943, 78.78514232000003],
              [-18.206776495999918, 78.81256745000007],
              [-18.161773240999935, 78.82929108300004],
              [-18.113107876999948, 78.83234284100007],
              [-18.06859290299991, 78.81867096600007],
              [-18.03473873599995, 78.79385000200006],
              [-18.004750128999945, 78.77903880400004],
              [-18.00031490799995, 78.76581452000005],
              [-18.042795376999948, 78.74555084800005],
              [-18.178944464999915, 78.71149323100008],
              [-18.205189581999946, 78.69578685100004],
              [-18.211008266999954, 78.70819733300004],
              [-18.207875128999945, 78.71600983300004],
              [-18.20343990799995, 78.72394440300008],
              [-18.205189581999946, 78.73676178600005],
            ],
          ],
          [
            [
              [-19.124379035999937, 78.71067942900004],
              [-19.155629035999937, 78.70111725500004],
              [-19.31432044199994, 78.69562409100007],
              [-19.39557857999995, 78.70530833500004],
              [-19.512074347999942, 78.74282461100006],
              [-19.577056443999936, 78.74819570500006],
              [-19.60415605399993, 78.75629303600005],
              [-19.610666469999956, 78.77000560100004],
              [-19.58307857999995, 78.78949616100005],
              [-19.154855923999946, 78.92829010600008],
              [-19.114979620999918, 78.93211497600004],
              [-19.07567298099991, 78.93113841400003],
              [-19.048003709999932, 78.92357005400004],
              [-19.051991339999915, 78.92015208500004],
              [-19.053456183999913, 78.91669342700004],
              [-19.054066535999937, 78.91315338700008],
              [-19.055409308999913, 78.90932851800005],
              [-19.165272589999915, 78.89565664300005],
              [-19.154367641999954, 78.89109935100004],
              [-19.147816535999937, 78.88507721600007],
              [-19.146636522999927, 78.87750885600008],
              [-19.151682094999956, 78.86835358300004],
              [-19.13931230399993, 78.86420319200005],
              [-19.100493943999936, 78.86835358300004],
              [-19.020741339999915, 78.86835358300004],
              [-19.04792232999995, 78.85101959800005],
              [-19.151112433999913, 78.83755117400005],
              [-19.18586178299995, 78.82054271000004],
              [-19.175038214999915, 78.82168203300006],
              [-19.164540167999917, 78.82086823100008],
              [-19.154449022999927, 78.81826406500005],
              [-19.14484615799995, 78.81366608300004],
              [-19.15965735599991, 78.80377838700008],
              [-19.17674719999991, 78.79629140800006],
              [-19.195139126999948, 78.79214101800005],
              [-19.21320553299995, 78.79262929900005],
              [-19.180165167999917, 78.78302643400008],
              [-19.055409308999913, 78.79262929900005],
              [-19.062245245999918, 78.78636302300004],
              [-19.041818813999953, 78.77899811400005],
              [-19.09483801999994, 78.76410553600005],
              [-19.281361456999946, 78.76593659100007],
              [-19.260487433999913, 78.75287506700005],
              [-19.22215735599991, 78.74819570500006],
              [-19.18077551999994, 78.74921295800004],
              [-19.121571417999917, 78.75706614800004],
              [-19.050770636999914, 78.75242747600004],
              [-19.020741339999915, 78.74542877800008],
              [-19.042795376999948, 78.73578522300005],
              [-19.137440558999913, 78.71751536700003],
              [-19.124379035999937, 78.71067942900004],
            ],
          ],
          [
            [
              [-17.532948370999918, 79.03221263200004],
              [-17.681996222999942, 79.03851959800005],
              [-17.70421301999994, 79.03221263200004],
              [-17.689116990999935, 79.02090078300006],
              [-17.68309485599991, 79.01788971600007],
              [-17.70103919199994, 79.00995514500005],
              [-17.725331183999913, 79.00568268400008],
              [-17.77253170499995, 79.00429922100005],
              [-17.753285285999937, 78.99335358300004],
              [-17.74518795499995, 78.99066803600005],
              [-17.765370245999918, 78.98346588700008],
              [-17.787912563999953, 78.97890859600005],
              [-17.833973761999914, 78.97699616100005],
              [-17.815174933999913, 78.96796295800004],
              [-17.828846808999913, 78.96043528900003],
              [-17.896636522999927, 78.94806549700007],
              [-17.920521613999938, 78.94765859600005],
              [-17.944203253999945, 78.95014069200005],
              [-17.964955206999946, 78.95587799700007],
              [-17.950795050999943, 78.96255117400005],
              [-17.932850714999915, 78.96637604400007],
              [-17.896636522999927, 78.96946849200003],
              [-17.918568488999938, 78.98338450700004],
              [-17.944162563999953, 78.99408600500004],
              [-17.95962480399993, 79.00975169500003],
              [-17.951283331999946, 79.03839752800008],
              [-17.92145748599995, 79.06273021000004],
              [-17.800404425999943, 79.10053131700005],
              [-17.745838995999918, 79.15355052300004],
              [-17.724720831999946, 79.16132233300004],
              [-17.686105923999946, 79.17035553600005],
              [-17.645741339999915, 79.18671295800004],
              [-17.605539516999954, 79.19383372600004],
              [-17.56704667899993, 79.17560455900008],
              [-17.532053188999953, 79.17308177300004],
              [-17.421538865999935, 79.13621653900003],
              [-17.405913865999935, 79.12327708500004],
              [-17.408314581999946, 79.10488515800006],
              [-17.41942298099991, 79.08637116100005],
              [-17.450998501999948, 79.04523346600007],
              [-17.461659308999913, 79.04319896000004],
              [-17.498768683999913, 79.04523346600007],
              [-17.507923956999946, 79.04242584800005],
              [-17.524647589999915, 79.03400299700007],
              [-17.532948370999918, 79.03221263200004],
            ],
          ],
          [
            [
              [-18.764271613999938, 79.97329336100006],
              [-18.738107876999948, 79.97296784100007],
              [-18.68541419199994, 79.98090241100005],
              [-18.598866339999915, 80.01215241100005],
              [-18.57762610599991, 80.01699453300006],
              [-18.159230109999925, 80.05410390800006],
              [-17.740834113999938, 80.09121328300006],
              [-17.66397050699993, 80.08856842700004],
              [-17.277495897999927, 80.01312897300005],
              [-17.26911373599995, 80.00910065300008],
              [-17.260975714999915, 80.00360748900005],
              [-17.314442511999914, 79.97833893400008],
              [-17.34203040299991, 79.96161530200004],
              [-17.35578365799995, 79.94375234600005],
              [-17.596038377999946, 79.84312571850006],
              [-17.836293097999942, 79.74249909100007],
              [-18.173939581999946, 79.69367096600007],
              [-18.485218878999945, 79.68610260600008],
              [-18.568959113999938, 79.70807526200008],
              [-18.831023729499947, 79.74292633650006],
              [-19.093088344999956, 79.77777741100005],
              [-19.15973873599995, 79.79604726800005],
              [-19.249623175999943, 79.83128489800004],
              [-19.393137173999946, 79.84870026200008],
              [-19.414173956999946, 79.84813060100004],
              [-19.357492641999954, 79.87067291900007],
              [-19.148915167999917, 79.90326569200005],
              [-19.067982550999943, 79.92780182500007],
              [-19.031239386999914, 79.93113841400003],
              [-18.956206834999932, 79.92942942900004],
              [-18.91942298099991, 79.93366120000007],
              [-18.92491614499994, 79.94672272300005],
              [-18.93541419199994, 79.95648834800005],
              [-18.95889238199993, 79.97370026200008],
              [-18.98591061099995, 80.00299713700008],
              [-19.002349412999934, 80.01430898600006],
              [-18.853871222999942, 80.02716705900008],
              [-18.826283331999946, 80.02509186400005],
              [-18.813710089999915, 80.02204010600008],
              [-18.783558722999942, 80.00934479400007],
              [-18.773182745999918, 80.00120677300004],
              [-18.767323370999918, 79.99005768400008],
              [-18.764271613999938, 79.97329336100006],
            ],
          ],
          [
            [
              [-19.52285722599993, 80.03025950700004],
              [-19.655995245999918, 80.02285390800006],
              [-19.66510982999995, 80.02741120000007],
              [-19.70409094999991, 80.05756256700005],
              [-19.64439856699994, 80.07518138200004],
              [-19.62840735599991, 80.08551666900007],
              [-19.639556443999936, 80.08978913000004],
              [-19.64020748599995, 80.09369538000004],
              [-19.62840735599991, 80.10537344000005],
              [-19.623931443999936, 80.10846588700008],
              [-19.61001542899993, 80.11237213700008],
              [-19.60448157499991, 80.11562734600005],
              [-19.60187740799995, 80.12067291900007],
              [-19.60260982999995, 80.12523021000004],
              [-19.605091925999943, 80.12775299700007],
              [-19.607899542999917, 80.12645091400003],
              [-19.605620897999927, 80.13255442900004],
              [-19.604237433999913, 80.14630768400008],
              [-19.60106360599991, 80.15314362200007],
              [-19.59243730399993, 80.15997955900008],
              [-19.565785285999937, 80.17161692900004],
              [-19.48737545499995, 80.19586823100008],
              [-19.34992428299995, 80.21320221600007],
              [-19.206695115999935, 80.21019114800004],
              [-18.737131313999953, 80.13816966400003],
              [-18.70299231699994, 80.12645091400003],
              [-18.719960089999915, 80.12107982000003],
              [-18.75454667899993, 80.11709219000005],
              [-18.771839972999942, 80.11225006700005],
              [-19.147348599499935, 80.07125478700004],
              [-19.52285722599993, 80.03025950700004],
            ],
          ],
          [
            [
              [-17.732818162999934, 81.59564850500004],
              [-17.79637610599991, 81.61688873900005],
              [-18.213449673999946, 81.69220612200007],
              [-18.28148352799991, 81.71849192900004],
              [-18.25694739499994, 81.72996653900003],
              [-18.225209113999938, 81.73529694200005],
              [-17.793771938999953, 81.74616120000007],
              [-17.770659959999932, 81.73529694200005],
              [-17.748850063999953, 81.72036367400005],
              [-17.72020423099991, 81.71308014500005],
              [-17.66392981699994, 81.70490143400008],
              [-17.56151282499991, 81.67357005400004],
              [-17.510487433999913, 81.64813873900005],
              [-17.484201626999948, 81.63939036700003],
              [-17.425160285999937, 81.63117096600007],
              [-17.365956183999913, 81.61127350500004],
              [-17.335560675999943, 81.60862864800004],
              [-17.335560675999943, 81.60248444200005],
              [-17.37999426999994, 81.59149811400005],
              [-17.732818162999934, 81.59564850500004],
            ],
          ],
          [
            [
              [-19.459584113999938, 81.95319245000007],
              [-19.59666907499991, 81.99176666900007],
              [-19.634917772999927, 82.01459381700005],
              [-19.649037238999938, 82.03046295800004],
              [-19.661936001999948, 82.05223216400003],
              [-19.667225714999915, 82.07501862200007],
              [-19.658192511999914, 82.09406159100007],
              [-19.638661261999914, 82.10175202000005],
              [-19.524159308999913, 82.11786530200004],
              [-19.410552537999934, 82.11994049700007],
              [-19.36119544199994, 82.11277903900003],
              [-19.31200110599991, 82.09886302300004],
              [-19.260365363999938, 82.09100983300004],
              [-19.091420050999943, 82.04266998900005],
              [-19.069162563999953, 82.02142975500004],
              [-19.050607876999948, 81.99640534100007],
              [-19.00731360599991, 81.98281484600005],
              [-18.91982988199993, 81.96816640800006],
              [-18.67926998599995, 81.86904531500005],
              [-18.64940344999991, 81.84821198100008],
              [-18.630930141999954, 81.81972890800006],
              [-18.688384568999936, 81.81370677300004],
              [-19.045033331999946, 81.82510000200006],
              [-19.459584113999938, 81.95319245000007],
            ],
          ],
          [
            [
              [-66.77562415299991, 80.59857819200005],
              [-66.79027258999992, 80.59857819200005],
              [-66.80048580599993, 80.59947337400007],
              [-66.81041419199994, 80.60028717700004],
              [-66.82070878799993, 80.60106028900003],
              [-66.84788977799991, 80.60565827000005],
              [-66.84776770699995, 80.61233144700003],
              [-66.8603816399999, 80.61526113500008],
              [-66.88544674399992, 80.61530182500007],
              [-66.89053300699993, 80.61615631700005],
              [-66.90046139199995, 80.61692942900004],
              [-66.90802975199995, 80.61737702000005],
              [-66.91291256399995, 80.61904531500005],
              [-66.91291256399995, 80.62071360900006],
              [-66.92300370999993, 80.62409088700008],
              [-66.93309485599991, 80.62738678600005],
              [-66.93793697799993, 80.63072337400007],
              [-66.94306393099993, 80.63149648600006],
              [-66.94298255099994, 80.63320547100005],
              [-66.95278886599993, 80.63483307500007],
              [-66.95278886599993, 80.63991933800008],
              [-66.95783443899995, 80.64069245000007],
              [-66.95795650899993, 80.64984772300005],
              [-66.96300208199995, 80.65070221600007],
              [-66.96300208199995, 80.65403880400004],
              [-66.9680883449999, 80.65493398600006],
              [-66.9680883449999, 80.65818919500003],
              [-66.97276770699995, 80.65900299700007],
              [-66.9780574209999, 80.66567617400005],
              [-66.98070227799991, 80.66616445500006],
              [-66.98273678299995, 80.66653066600003],
              [-66.98273678299995, 80.67157623900005],
              [-66.97801673099991, 80.67234935100004],
              [-66.97801673099991, 80.67405833500004],
              [-66.96544348899994, 80.67531972900008],
              [-66.96043860599991, 80.67531972900008],
              [-66.95555579299992, 80.67531972900008],
              [-66.9505102199999, 80.67609284100007],
              [-66.91047115799995, 80.67605215100008],
              [-66.90575110599991, 80.67527903900003],
              [-66.89537512899994, 80.67446523600006],
              [-66.88548743399991, 80.67446523600006],
              [-66.88044186099995, 80.67361074400003],
              [-66.87047278599994, 80.67275625200006],
              [-66.86042232999995, 80.67194245000007],
              [-66.85045325399994, 80.67108795800004],
              [-66.84064693899995, 80.67108795800004],
              [-66.83047441299993, 80.66946035400008],
              [-66.82559160099993, 80.66946035400008],
              [-66.81065833199995, 80.66689687700006],
              [-66.80540930899991, 80.66697825700004],
              [-66.7578425769999, 80.65904368700006],
              [-66.75800533799992, 80.65818919500003],
              [-66.74286861899992, 80.65570709800005],
              [-66.74303137899994, 80.65485260600008],
              [-66.73289954299992, 80.65322500200006],
              [-66.72809811099995, 80.65151601800005],
              [-66.71788489499994, 80.64732493700006],
              [-66.71812903599994, 80.64484284100007],
              [-66.70299231699994, 80.64236074400003],
              [-66.70319576699995, 80.64150625200006],
              [-66.6531062489999, 80.63320547100005],
              [-66.65294348899994, 80.63239166900007],
              [-66.6355281239999, 80.62946198100008],
              [-66.63060462099992, 80.62942129100003],
              [-66.61803137899994, 80.62653229400007],
              [-66.61790930899991, 80.62567780200004],
              [-66.60798092399995, 80.62490469000005],
              [-66.60781816299993, 80.62400950700004],
              [-66.5930883449999, 80.62148672100005],
              [-66.58796139199995, 80.61981842700004],
              [-66.58820553299995, 80.61070384300007],
              [-66.60057532499991, 80.60866933800008],
              [-66.61058508999992, 80.60777415600006],
              [-66.63532467399995, 80.60773346600007],
              [-66.6404109369999, 80.60696035400008],
              [-66.70038814999992, 80.60696035400008],
              [-66.70547441299993, 80.60610586100006],
              [-66.71544348899994, 80.60533274900007],
              [-66.72557532499991, 80.60525136900003],
              [-66.73554439999992, 80.60447825700004],
              [-66.74551347599993, 80.60362376500007],
              [-66.7578425769999, 80.60154857000003],
              [-66.7656550769999, 80.59947337400007],
              [-66.77562415299991, 80.59857819200005],
            ],
          ],
          [
            [
              [-66.32050533799992, 80.82025788000004],
              [-66.34048417899993, 80.82029857000003],
              [-66.35057532499991, 80.82111237200007],
              [-66.37311764199995, 80.82489655200004],
              [-66.37303626199991, 80.82648346600007],
              [-66.37775631399995, 80.82737864800004],
              [-66.37791907499991, 80.83071523600006],
              [-66.3703914049999, 80.83197663000004],
              [-66.36046301999994, 80.83283112200007],
              [-66.34552975199995, 80.83274974200003],
              [-66.33535722599993, 80.83193594000005],
              [-66.32038326699995, 80.82941315300008],
              [-66.31037350199995, 80.82941315300008],
              [-66.29796301999994, 80.82652415600006],
              [-66.29800370999993, 80.82404205900008],
              [-66.31065833199995, 80.82111237200007],
              [-66.32050533799992, 80.82025788000004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Curaçao',
        iso3: 'CUW',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-68.78075110599991, 12.097805080000057],
            [-68.74522864499994, 12.062241929000038],
            [-68.73973548099991, 12.05304596600007],
            [-68.74864661399994, 12.047023830000057],
            [-68.76984615799995, 12.042914130000042],
            [-68.79474850199995, 12.04132721600007],
            [-68.81480872299994, 12.043158270000049],
            [-68.84117591099994, 12.055487372000073],
            [-68.89342200399994, 12.090521552000041],
            [-68.94473222599993, 12.105617580000057],
            [-68.97777258999992, 12.124579169000071],
            [-69.00743567599994, 12.148179429000038],
            [-69.02025305899991, 12.169745184000078],
            [-69.02721106699994, 12.19009023600006],
            [-69.04360917899993, 12.196682033000059],
            [-69.06289628799993, 12.198431708000044],
            [-69.07860266799992, 12.204250393000052],
            [-69.09190833199995, 12.219875393000052],
            [-69.12267005099994, 12.269029039000088],
            [-69.13438880099994, 12.27732982000009],
            [-69.14810136599993, 12.284409898000092],
            [-69.15953528599994, 12.293361721000053],
            [-69.16429602799991, 12.30695221600007],
            [-69.16197669199994, 12.34284088700008],
            [-69.16380774599992, 12.361883856000077],
            [-69.17174231699994, 12.37889232000009],
            [-69.16612708199995, 12.387844143000052],
            [-69.16120357999995, 12.391506252000056],
            [-69.15623938699991, 12.39061107000009],
            [-69.15062415299991, 12.38572825700004],
            [-69.10777747299994, 12.36782461100006],
            [-69.08958899599992, 12.35687897300005],
            [-69.07152258999992, 12.341376044000071],
            [-69.06041419199994, 12.32257721600007],
            [-69.04995683499993, 12.27610911700009],
            [-69.04076087099992, 12.256048895000049],
            [-69.00401770699995, 12.22166575700004],
            [-68.96129309799994, 12.201361395000049],
            [-68.8352758449999, 12.171047268000052],
            [-68.82079016799992, 12.16233958500004],
            [-68.81480872299994, 12.149603583000044],
            [-68.8118383449999, 12.129339911000045],
            [-68.8040258449999, 12.117010809000078],
            [-68.78075110599991, 12.097805080000057],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Aruba',
        iso3: 'ABW',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-69.99693762899994, 12.57758209800005],
            [-69.93639075399994, 12.531724351000037],
            [-69.92467200399994, 12.519232489000046],
            [-69.91576087099992, 12.497015692000048],
            [-69.8801977199999, 12.453558661000045],
            [-69.87682044199994, 12.427394924000055],
            [-69.88809160099993, 12.417669989000046],
            [-69.90880286399994, 12.417792059000078],
            [-69.93053137899994, 12.425970770000049],
            [-69.94513912699995, 12.440375067000048],
            [-69.92467200399994, 12.440375067000048],
            [-69.92467200399994, 12.447211005000042],
            [-69.95856686099995, 12.46320221600007],
            [-70.02765865799995, 12.522935289000088],
            [-70.04808508999992, 12.53115469000005],
            [-70.05809485599991, 12.537176825000074],
            [-70.06240800699993, 12.546820380000042],
            [-70.06037350199995, 12.55695221600007],
            [-70.05109615799995, 12.574042059000078],
            [-70.04873613199993, 12.583726304000038],
            [-70.05264238199993, 12.600002346000053],
            [-70.05964107999995, 12.61424388200004],
            [-70.06110592399995, 12.625392971000053],
            [-70.04873613199993, 12.632147528000075],
            [-70.0071508449999, 12.585516669000071],
            [-69.99693762899994, 12.57758209800005],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bahamas',
        iso3: 'BHS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-72.99957214499995, 21.45170771100004],
              [-73.03366326799994, 21.43588833800004],
              [-73.0437249819999, 21.42606686000005],
              [-73.05304575199995, 21.42490354000006],
              [-73.05494807399992, 21.435439992000056],
              [-73.0521743239999, 21.447796365000045],
              [-73.05930925099995, 21.467041444000074],
              [-73.07243081799993, 21.486336651000045],
              [-73.07623436799992, 21.506795732000057],
              [-73.06618412899991, 21.514148289000047],
              [-73.04281768099992, 21.521400826000047],
              [-73.02403723899994, 21.532171942000048],
              [-73.00656224199992, 21.552084944000057],
              [-72.9915258449999, 21.56199778900009],
              [-72.98216712099992, 21.55654531500005],
              [-72.97002673799994, 21.541885567000065],
              [-72.95945733199994, 21.533127982000053],
              [-72.9395715519999, 21.523055712000087],
              [-72.91974850199995, 21.514797268000052],
              [-72.91043831699994, 21.504850291000082],
              [-72.91464979799991, 21.485062200000073],
              [-72.93342899699991, 21.473451972000078],
              [-72.97076639099993, 21.469428091000054],
              [-72.98822983799994, 21.454092202000083],
              [-72.99957214499995, 21.45170771100004],
            ],
          ],
          [
            [
              [-73.13914954299992, 22.363348700000074],
              [-73.15640214799993, 22.367661851000037],
              [-73.16600501199991, 22.374212958000044],
              [-73.16372636599993, 22.383693752000056],
              [-73.14537512899994, 22.396877346000053],
              [-73.15111243399991, 22.403957424000055],
              [-73.15151933499993, 22.408596096000053],
              [-73.14537512899994, 22.41860586100006],
              [-73.1406957669999, 22.43154531500005],
              [-73.14244544199994, 22.442287502000056],
              [-73.14224199099993, 22.45136139500005],
              [-73.13170325399994, 22.459540106000077],
              [-73.1145727199999, 22.43854401200008],
              [-73.10606848899994, 22.43349844000005],
              [-73.09080969999991, 22.431586005000042],
              [-73.09089107999995, 22.433661200000074],
              [-73.08511308499993, 22.43817780200004],
              [-73.07705644399994, 22.44285716400009],
              [-73.07022050699993, 22.445257880000042],
              [-73.06314042899993, 22.44472890800006],
              [-73.04824785099993, 22.44013092700004],
              [-73.03990637899994, 22.43903229400007],
              [-73.01520748599995, 22.430487372000073],
              [-72.96373450399994, 22.397650458000044],
              [-72.93993079299992, 22.396877346000053],
              [-72.94481360599991, 22.402492580000057],
              [-72.95360266799992, 22.41860586100006],
              [-72.92027747299994, 22.402899481000077],
              [-72.9036352199999, 22.39907461100006],
              [-72.89281165299991, 22.40428294500009],
              [-72.87710527299993, 22.393011786000045],
              [-72.86168372299994, 22.386867580000057],
              [-72.84373938699991, 22.38434479400007],
              [-72.82046464799993, 22.38377513200004],
              [-72.8137914699999, 22.381008205000057],
              [-72.8059789699999, 22.374253648000035],
              [-72.79283606699994, 22.35960521000004],
              [-72.78331458199995, 22.353216864000046],
              [-72.76366126199991, 22.353216864000046],
              [-72.75499426999994, 22.349676825000074],
              [-72.7461645169999, 22.331284898000035],
              [-72.75088456899994, 22.31122467700004],
              [-72.76382402299993, 22.294867255000042],
              [-72.77944902299993, 22.288234768000052],
              [-72.79723059799994, 22.29364655200004],
              [-72.84373938699991, 22.336004950000074],
              [-72.86400305899991, 22.34992096600007],
              [-72.87999426999994, 22.358221747000073],
              [-72.89757239499994, 22.362250067000048],
              [-72.92292232999995, 22.363348700000074],
              [-72.93419348899994, 22.362127997000073],
              [-72.94912675699993, 22.35700104400007],
              [-72.95702063699991, 22.355902411000045],
              [-72.9688207669999, 22.35809967700004],
              [-72.97533118399991, 22.362982489000046],
              [-72.98045813699991, 22.36786530200004],
              [-72.9883520169999, 22.37018463700008],
              [-73.00991777299993, 22.36595286700009],
              [-73.04954993399991, 22.346625067000048],
              [-73.07371985599991, 22.342230536000045],
              [-73.08429928299995, 22.34438711100006],
              [-73.09097245999993, 22.34906647300005],
              [-73.09593665299991, 22.35370514500005],
              [-73.10130774599992, 22.355902411000045],
              [-73.13914954299992, 22.363348700000074],
            ],
          ],
          [
            [
              [-73.46873625299992, 22.58766229300005],
              [-73.4752329449999, 22.586170179000078],
              [-73.51743936699995, 22.598202018000052],
              [-73.53611469799995, 22.603462445000048],
              [-73.55641857299992, 22.606473875000063],
              [-73.55885331399992, 22.61172282700005],
              [-73.54098037499995, 22.613960339000073],
              [-73.52392126799992, 22.61619629900008],
              [-73.5011859949999, 22.610929788000078],
              [-73.47846199399993, 22.601163606000057],
              [-73.46873625299992, 22.58766229300005],
            ],
          ],
          [
            [
              [-73.64707081799992, 21.061555161000058],
              [-73.64517348299995, 21.080532573000085],
              [-73.65693080199992, 21.093983190000074],
              [-73.66786106699993, 21.104998324000064],
              [-73.6678331409999, 21.115223100000037],
              [-73.63344490599991, 21.099701976000063],
              [-73.61308669699991, 21.106896778000078],
              [-73.59586063499995, 21.11264424700005],
              [-73.58409706499992, 21.12134069800004],
              [-73.55288739499991, 21.13020428300007],
              [-73.54579357499995, 21.149742968000055],
              [-73.52369848299992, 21.168271383000047],
              [-73.51460433599993, 21.18686665300004],
              [-73.49262555699994, 21.18208591700005],
              [-73.47276770699995, 21.192694403000075],
              [-73.44359290299991, 21.19293854400007],
              [-73.43333899599992, 21.19326406500005],
              [-73.42320716099994, 21.19790273600006],
              [-73.41291256399995, 21.205145575000074],
              [-73.39818274599992, 21.22483958500004],
              [-73.38988196499992, 21.233303127000056],
              [-73.38621985599991, 21.228989976000037],
              [-73.37979081899994, 21.208197333000044],
              [-73.36388098899994, 21.190252997000073],
              [-73.34383419599993, 21.16541318500009],
              [-73.31794350199993, 21.154067681000072],
              [-73.2551523969999, 21.135060132000035],
              [-73.23308077699994, 21.147964784000067],
              [-73.21102369099992, 21.158073590000072],
              [-73.1609611959999, 21.16986297300008],
              [-73.13773470399991, 21.19767059800006],
              [-73.11738404399995, 21.23670132300009],
              [-73.06818600199995, 21.309881903000075],
              [-73.05304928299995, 21.329291083000044],
              [-73.03376217399995, 21.340399481000077],
              [-73.01219641799992, 21.33201732000009],
              [-73.00462805899991, 21.31443919500009],
              [-73.00572669199994, 21.291449286000045],
              [-73.02554277299993, 21.18455638200004],
              [-73.03392986299991, 21.156731490000084],
              [-73.09759423299994, 21.081400047000045],
              [-73.12982146599995, 20.993662571000073],
              [-73.15119381399995, 20.982123114000046],
              [-73.22556430799995, 20.952463097000077],
              [-73.26891028599994, 20.958726304000038],
              [-73.28160559799994, 20.95506419500009],
              [-73.2910863919999, 20.95058828300006],
              [-73.31045488199993, 20.937648830000057],
              [-73.31729081899994, 20.937648830000057],
              [-73.31729081899994, 20.945054429000038],
              [-73.31065833199995, 20.950506903000075],
              [-73.32543493799994, 20.961337770000057],
              [-73.34692155599993, 20.96382728000009],
              [-73.3989574819999, 20.935761355000068],
              [-73.43342037699995, 20.937648830000057],
              [-73.4926142509999, 20.924457277000045],
              [-73.53681058799992, 20.94123591400006],
              [-73.60081946499992, 20.946519273000035],
              [-73.61522376199991, 20.944566148000035],
              [-73.63142089299993, 20.936681229000044],
              [-73.63561799699994, 20.92926324700005],
              [-73.64144993399992, 20.920330965000062],
              [-73.64511012499992, 20.912398909000046],
              [-73.65161212999993, 20.913781123000035],
              [-73.66335589399995, 20.921082134000073],
              [-73.67614103599993, 20.93516228200008],
              [-73.67897042099992, 20.94599493600009],
              [-73.68143384299992, 20.963241811000046],
              [-73.68226118299992, 20.98578499100006],
              [-73.69995646899991, 21.01432784700006],
              [-73.70320851199995, 21.019765722000045],
              [-73.6999099219999, 21.026871362000065],
              [-73.67009365599995, 21.029793419000043],
              [-73.65333525799991, 21.039886040000056],
              [-73.64707081799992, 21.061555161000058],
            ],
          ],
          [
            [
              [-74.28376217399995, 22.671820380000042],
              [-74.28892981699994, 22.643744208000044],
              [-74.31753495999993, 22.602484442000048],
              [-74.35472571499992, 22.563299872000073],
              [-74.38556881399995, 22.541449286000045],
              [-74.37669837099992, 22.584377346000053],
              [-74.34764563699991, 22.612941799000055],
              [-74.31200110599991, 22.638332424000055],
              [-74.28376217399995, 22.671820380000042],
            ],
          ],
          [
            [
              [-73.99571692599994, 22.657538153000075],
              [-74.00210527299993, 22.66404857000009],
              [-74.01622473899994, 22.684881903000075],
              [-73.98314368399991, 22.67597077000005],
              [-73.97524980399993, 22.671820380000042],
              [-73.97191321499992, 22.682928778000075],
              [-73.96450761599993, 22.691473700000074],
              [-73.95555579299992, 22.695379950000074],
              [-73.9473363919999, 22.692287502000056],
              [-73.94127356699994, 22.696478583000044],
              [-73.93854732999995, 22.69790273600006],
              [-73.93431555899991, 22.698472398000035],
              [-73.93431555899991, 22.705959377000056],
              [-73.94249426999994, 22.70807526200008],
              [-73.94587154899995, 22.710191148000035],
              [-73.9485570949999, 22.713771877000056],
              [-73.95474199099993, 22.72020091400009],
              [-73.90314693899995, 22.719671942000048],
              [-73.87848873599995, 22.72333405200004],
              [-73.85171464799993, 22.733303127000056],
              [-73.85065670499995, 22.729437567000048],
              [-73.85020911399994, 22.726223049000055],
              [-73.84878495999993, 22.723130601000037],
              [-73.84487870999993, 22.72020091400009],
              [-73.8684789699999, 22.681463934000078],
              [-73.87970943899995, 22.671820380000042],
              [-73.8801977199999, 22.68187083500004],
              [-73.88369706899994, 22.689846096000053],
              [-73.89024817599994, 22.695461330000057],
              [-73.89952551999994, 22.698472398000035],
              [-73.89606686099995, 22.684881903000075],
              [-73.88780676999994, 22.671820380000042],
              [-73.87694251199991, 22.66547272300005],
              [-73.86538652299993, 22.671820380000042],
              [-73.85863196499992, 22.657171942000048],
              [-73.84947669199994, 22.582464911000045],
              [-73.84398352799991, 22.56712474200009],
              [-73.83120683499993, 22.541449286000045],
              [-73.84837805899991, 22.537583726000037],
              [-73.85558020699995, 22.520656643000052],
              [-73.85912024599992, 22.49872467700004],
              [-73.86538652299993, 22.48004791900007],
              [-73.87515214799993, 22.468491929000038],
              [-73.88955644399994, 22.455023505000042],
              [-73.90477454299992, 22.443752346000053],
              [-73.91690019399994, 22.43903229400007],
              [-73.92837480399993, 22.430121161000045],
              [-73.96157792899993, 22.37018463700008],
              [-74.01378333199995, 22.33006419500009],
              [-74.02301998599995, 22.32575104400007],
              [-74.03359941299993, 22.325018622000073],
              [-74.09439042899993, 22.301906643000052],
              [-74.11937415299991, 22.29686107000009],
              [-74.13467363199993, 22.28388092700004],
              [-74.15965735599991, 22.246649481000077],
              [-74.16771399599992, 22.238430080000057],
              [-74.19416256399995, 22.216864325000074],
              [-74.20425370999993, 22.21246979400007],
              [-74.22691809799994, 22.20921458500004],
              [-74.24474036399994, 22.200384833000044],
              [-74.27696692599994, 22.171535549000055],
              [-74.27822831899994, 22.180568752000056],
              [-74.27696692599994, 22.21588776200008],
              [-74.27245032499991, 22.225734768000052],
              [-74.26195227799991, 22.22850169500009],
              [-74.22252356699994, 22.225531317000048],
              [-74.21410071499992, 22.22919342700004],
              [-74.18390865799995, 22.25409577000005],
              [-74.18309485599991, 22.26048411700009],
              [-74.19371497299994, 22.26776764500005],
              [-74.19371497299994, 22.273911851000037],
              [-74.17414303299995, 22.285549221000053],
              [-74.16706295499995, 22.288234768000052],
              [-74.17292232999995, 22.289862372000073],
              [-74.17747962099992, 22.29169342700004],
              [-74.18049068899995, 22.295314846000053],
              [-74.18130449099993, 22.301906643000052],
              [-74.16120357999995, 22.30923086100006],
              [-74.13182532499991, 22.325913804000038],
              [-74.1087133449999, 22.32916901200008],
              [-74.10334225199995, 22.332424221000053],
              [-74.09239661399994, 22.346502997000073],
              [-74.07917232999995, 22.355169989000046],
              [-74.08023027299993, 22.367743231000077],
              [-74.0840551419999, 22.38153717700004],
              [-74.08385169199994, 22.39061107000009],
              [-74.06541907499991, 22.39752838700008],
              [-74.03807532499991, 22.400213934000078],
              [-74.01333574099993, 22.40582916900007],
              [-74.00255286399994, 22.421698309000078],
              [-73.99840247299994, 22.445868231000077],
              [-73.98692786399994, 22.457505601000037],
              [-73.96934973899994, 22.462225653000075],
              [-73.9473363919999, 22.465765692000048],
              [-73.90770423099991, 22.479437567000048],
              [-73.8801977199999, 22.50291575700004],
              [-73.87083899599992, 22.535305080000057],
              [-73.88589433499993, 22.57558828300006],
              [-73.91344153599994, 22.59446849200009],
              [-73.98452714799993, 22.59560781500005],
              [-74.01622473899994, 22.61033763200004],
              [-74.03123938699991, 22.62368398600006],
              [-74.02953040299991, 22.627427476000037],
              [-74.01744544199994, 22.64549388200004],
              [-74.01085364499994, 22.651271877000056],
              [-74.00357011599993, 22.655096747000073],
              [-73.99571692599994, 22.657538153000075],
            ],
          ],
          [
            [
              [-74.28685462099992, 22.733303127000056],
              [-74.35195878799993, 22.822658596000053],
              [-74.34821529899995, 22.825873114000046],
              [-74.34658769399994, 22.82916901200008],
              [-74.34585527299993, 22.832586981000077],
              [-74.34455318899995, 22.83624909100007],
              [-74.33356686099995, 22.836859442000048],
              [-74.31688391799992, 22.842230536000045],
              [-74.31041419199994, 22.84316640800006],
              [-74.29845130099994, 22.839992580000057],
              [-74.27009029899995, 22.822658596000053],
              [-74.26008053299995, 22.82021719000005],
              [-74.2383520169999, 22.818426825000074],
              [-74.22850501199991, 22.81582265800006],
              [-74.20055091099994, 22.794663804000038],
              [-74.19749915299991, 22.78611888200004],
              [-74.19635982999995, 22.768500067000048],
              [-74.19371497299994, 22.76117584800005],
              [-74.19017493399991, 22.760239976000037],
              [-74.17796790299991, 22.76170482000009],
              [-74.1738988919999, 22.76117584800005],
              [-74.17178300699993, 22.758246161000045],
              [-74.16706295499995, 22.746893622000073],
              [-74.14753170499995, 22.740668036000045],
              [-74.11164303299995, 22.738348700000074],
              [-74.09068762899994, 22.733303127000056],
              [-74.09813391799992, 22.746893622000073],
              [-74.07591712099992, 22.741888739000046],
              [-74.01622473899994, 22.72020091400009],
              [-74.09068762899994, 22.657538153000075],
              [-74.09410559799994, 22.665676174000055],
              [-74.09459387899994, 22.66787344000005],
              [-74.10496985599991, 22.671820380000042],
              [-74.10407467399995, 22.688299872000073],
              [-74.12242591099994, 22.685207424000055],
              [-74.14842688699991, 22.677801825000074],
              [-74.22227942599994, 22.69562409100007],
              [-74.23257402299993, 22.703517971000053],
              [-74.24893144399994, 22.72020091400009],
              [-74.25446529899995, 22.70848216400009],
              [-74.26642818899995, 22.698553778000075],
              [-74.27830969999991, 22.693182684000078],
              [-74.28376217399995, 22.695379950000074],
              [-74.27798417899993, 22.71702708500004],
              [-74.27814693899995, 22.72842031500005],
              [-74.28685462099992, 22.733303127000056],
            ],
          ],
          [
            [
              [-73.66616777299993, 23.089544989000046],
              [-73.75523841099994, 23.07298411700009],
              [-73.79735266799992, 23.07379791900007],
              [-73.81696529899995, 23.10382721600007],
              [-73.74185136599993, 23.096991278000075],
              [-73.68569902299993, 23.102484442000048],
              [-73.66616777299993, 23.096991278000075],
              [-73.66616777299993, 23.089544989000046],
            ],
          ],
          [
            [
              [-75.65355383999992, 23.459458726000037],
              [-75.61998450399994, 23.457098700000074],
              [-75.57697506399995, 23.445868231000077],
              [-75.53978430899991, 23.427679755000042],
              [-75.52383378799993, 23.404852606000077],
              [-75.55980383999992, 23.41559479400007],
              [-75.60187740799995, 23.42340729400007],
              [-75.63731848899994, 23.435492255000042],
              [-75.65355383999992, 23.459458726000037],
            ],
          ],
          [
            [
              [-75.79820716099994, 23.53864166900007],
              [-75.7825414699999, 23.507554429000038],
              [-75.74494381399995, 23.48273346600007],
              [-75.66104081899994, 23.45262278900009],
              [-75.67536373599995, 23.43854401200008],
              [-75.69823157499991, 23.444281317000048],
              [-75.74299068899995, 23.466945705000057],
              [-75.79377193899995, 23.470526434000078],
              [-75.81273352799991, 23.47955963700008],
              [-75.80443274599992, 23.500433661000045],
              [-75.82298743399991, 23.51239655200004],
              [-75.84190833199995, 23.528509833000044],
              [-75.85924231699994, 23.537543036000045],
              [-75.87336178299995, 23.52838776200008],
              [-75.90807044199994, 23.56240469000005],
              [-75.94546464799993, 23.588039455000057],
              [-75.98770097599993, 23.600816148000035],
              [-76.0371801419999, 23.596625067000048],
              [-76.0371801419999, 23.603461005000042],
              [-76.00767981699994, 23.611761786000045],
              [-76.00304114499994, 23.61399974200009],
              [-76.00495357999995, 23.62295156500005],
              [-76.01158606699994, 23.632025458000044],
              [-76.01056881399995, 23.637600002000056],
              [-76.02114824099993, 23.64411041900007],
              [-76.02944902299993, 23.65566640800006],
              [-76.03148352799991, 23.668524481000077],
              [-76.02354895699995, 23.67918528900009],
              [-76.01121985599991, 23.676947333000044],
              [-76.00259355399993, 23.680161851000037],
              [-75.99608313699991, 23.68455638200004],
              [-75.98997962099992, 23.685980536000045],
              [-75.98224850199995, 23.68268463700008],
              [-75.97704016799992, 23.677435614000046],
              [-75.96825110599991, 23.664943752000056],
              [-75.95718339799993, 23.654852606000077],
              [-75.94497636599993, 23.648830471000053],
              [-75.92931067599994, 23.645819403000075],
              [-75.90807044199994, 23.645005601000037],
              [-75.9114477199999, 23.640773830000057],
              [-75.91323808499993, 23.637518622000073],
              [-75.91588294199994, 23.63467031500005],
              [-75.92174231699994, 23.631415106000077],
              [-75.85631262899994, 23.567287502000056],
              [-75.80894934799994, 23.54197825700004],
              [-75.79820716099994, 23.53864166900007],
            ],
          ],
          [
            [
              [-74.85912024599992, 22.980292059000078],
              [-74.84703528599994, 22.97011953300006],
              [-74.83844967399995, 22.94440338700008],
              [-74.83340410099993, 22.914129950000074],
              [-74.83202063699991, 22.874945380000042],
              [-74.83397376199991, 22.86432526200008],
              [-74.83995520699995, 22.859930731000077],
              [-74.85228430899991, 22.86359284100007],
              [-74.85806230399993, 22.87055084800005],
              [-74.86534583199995, 22.90452708500004],
              [-74.86904863199993, 22.902167059000078],
              [-74.8789770169999, 22.897772528000075],
              [-74.88548743399991, 22.92381419500009],
              [-74.91405188699991, 22.970851955000057],
              [-74.92442786399994, 23.01170482000009],
              [-74.93390865799995, 23.02570221600007],
              [-74.96764075399994, 23.06386953300006],
              [-74.97801673099991, 23.07294342700004],
              [-74.99054928299995, 23.078558661000045],
              [-75.10488847599993, 23.099554755000042],
              [-75.12975012899994, 23.11399974200009],
              [-75.14256751199991, 23.12368398600006],
              [-75.21397864499994, 23.16547272300005],
              [-75.22964433499993, 23.17145416900007],
              [-75.22671464799993, 23.18121979400007],
              [-75.22203528599994, 23.19009023600006],
              [-75.21580969999991, 23.19822825700004],
              [-75.20791581899994, 23.206244208000044],
              [-75.20173092399995, 23.206244208000044],
              [-75.19172115799995, 23.191799221000053],
              [-75.16356360599991, 23.179022528000075],
              [-75.15330969999991, 23.165228583000044],
              [-75.17906653599994, 23.16860586100006],
              [-75.18740800699993, 23.17145416900007],
              [-75.18057206899994, 23.159857489000046],
              [-75.17027747299994, 23.14996979400007],
              [-75.15831458199995, 23.144191799000055],
              [-75.14647376199991, 23.14476146000004],
              [-75.13426673099991, 23.137274481000077],
              [-75.11522376199991, 23.122381903000075],
              [-75.10610917899993, 23.11749909100007],
              [-75.09483801999994, 23.114976304000038],
              [-75.07868404899995, 23.113674221000053],
              [-75.06847083199995, 23.11664459800005],
              [-75.07510331899994, 23.127386786000045],
              [-75.13219153599994, 23.185980536000045],
              [-75.13963782499991, 23.202826239000046],
              [-75.13585364499994, 23.229803778000075],
              [-75.12743079299992, 23.249253648000035],
              [-75.11831620999993, 23.26512278900009],
              [-75.11294511599993, 23.281317450000074],
              [-75.11375891799992, 23.305080471000053],
              [-75.12035071499992, 23.33193594000005],
              [-75.13166256399995, 23.35578034100007],
              [-75.14647376199991, 23.370754299000055],
              [-75.15005449099993, 23.366156317000048],
              [-75.16075598899994, 23.35700104400007],
              [-75.15904700399994, 23.380601304000038],
              [-75.19688880099994, 23.41014232000009],
              [-75.19489498599995, 23.432114976000037],
              [-75.20836341099994, 23.435248114000046],
              [-75.22057044199994, 23.43976471600007],
              [-75.22687740799995, 23.44725169500009],
              [-75.22223873599995, 23.459458726000037],
              [-75.24250240799995, 23.474310614000046],
              [-75.2500707669999, 23.490179755000042],
              [-75.25633704299992, 23.53514232000009],
              [-75.27684485599991, 23.582953192000048],
              [-75.28648841099994, 23.587632554000038],
              [-75.2930395169999, 23.58543528900009],
              [-75.30016028599994, 23.580471096000053],
              [-75.31159420499995, 23.57680898600006],
              [-75.3047582669999, 23.624945380000042],
              [-75.31045488199993, 23.63939036700009],
              [-75.33141028599994, 23.623968817000048],
              [-75.32201087099992, 23.637193101000037],
              [-75.31786048099991, 23.641546942000048],
              [-75.31159420499995, 23.645005601000037],
              [-75.32412675699993, 23.64866771000004],
              [-75.33234615799995, 23.641506252000056],
              [-75.34032141799992, 23.630804755000042],
              [-75.35260982999995, 23.623968817000048],
              [-75.35260982999995, 23.631415106000077],
              [-75.34239661399994, 23.641424872000073],
              [-75.33458411399994, 23.653143622000073],
              [-75.33043372299994, 23.667669989000046],
              [-75.33141028599994, 23.685980536000045],
              [-75.32534745999993, 23.684515692000048],
              [-75.32030188699991, 23.68162669500009],
              [-75.31582597599993, 23.677476304000038],
              [-75.31159420499995, 23.672349351000037],
              [-75.25291907499991, 23.582953192000048],
              [-75.23932857999995, 23.575100002000056],
              [-75.22130286399994, 23.55605703300006],
              [-75.20457923099991, 23.533351955000057],
              [-75.19489498599995, 23.514105536000045],
              [-75.18272864499994, 23.446437893000052],
              [-75.17072506399995, 23.42910390800006],
              [-75.15322831899994, 23.41120026200008],
              [-75.09406490799995, 23.30532461100006],
              [-75.09557044199994, 23.294989325000074],
              [-75.08771725199995, 23.28579336100006],
              [-75.08511308499993, 23.264064846000053],
              [-75.08503170499995, 23.219875393000052],
              [-75.07689368399991, 23.171698309000078],
              [-75.05996660099993, 23.14166901200008],
              [-75.03160559799994, 23.12335846600007],
              [-74.94635982999995, 23.09373607000009],
              [-74.90965735599991, 23.067328192000048],
              [-74.84483801999994, 23.000148830000057],
              [-74.84911048099991, 22.995021877000056],
              [-74.85460364499994, 22.985256252000056],
              [-74.85912024599992, 22.980292059000078],
            ],
          ],
          [
            [
              [-74.90005449099993, 23.70648834800005],
              [-74.84972083199995, 23.72011953300006],
              [-74.81236731699994, 23.719671942000048],
              [-74.79963131399995, 23.714544989000046],
              [-74.77721106699994, 23.699652411000045],
              [-74.78726152299993, 23.684068101000037],
              [-74.79369055899991, 23.67133209800005],
              [-74.80378170499995, 23.66404857000009],
              [-74.82494055899991, 23.664943752000056],
              [-74.82494055899991, 23.658677476000037],
              [-74.81871497299994, 23.65106842700004],
              [-74.83674068899995, 23.650824286000045],
              [-74.86074785099993, 23.657904364000046],
              [-74.87279212099992, 23.672349351000037],
              [-74.89085852799991, 23.66474030200004],
              [-74.9238988919999, 23.664455471000053],
              [-74.94163977799991, 23.658677476000037],
              [-74.9453832669999, 23.681586005000042],
              [-74.93862870999993, 23.69432200700004],
              [-74.92308508999992, 23.701239325000074],
              [-74.90005449099993, 23.70648834800005],
            ],
          ],
          [
            [
              [-76.32518469999991, 23.97402578300006],
              [-76.34019934799994, 23.98818594000005],
              [-76.35863196499992, 24.02366771000004],
              [-76.37498938699991, 24.046576239000046],
              [-76.38727779899995, 24.07640208500004],
              [-76.39761308499993, 24.09251536700009],
              [-76.40147864499994, 24.10293203300006],
              [-76.40147864499994, 24.11737702000005],
              [-76.37677975199995, 24.101385809000078],
              [-76.31895911399994, 23.980210679000038],
              [-76.32518469999991, 23.97402578300006],
            ],
          ],
          [
            [
              [-74.46865800699993, 24.02179596600007],
              [-74.47691809799994, 24.00999583500004],
              [-74.49128170499995, 23.969183661000045],
              [-74.49229895699995, 23.96039459800005],
              [-74.55809485599991, 23.953558661000045],
              [-74.55809485599991, 23.96039459800005],
              [-74.5410863919999, 23.98004791900007],
              [-74.52965247299994, 24.011053778000075],
              [-74.5254613919999, 24.045721747000073],
              [-74.53014075399994, 24.07640208500004],
              [-74.52969316299993, 24.100409247000073],
              [-74.51870683499993, 24.114935614000046],
              [-74.5012914699999, 24.123846747000073],
              [-74.4817602199999, 24.13104889500005],
              [-74.47622636599993, 24.135199286000045],
              [-74.4707738919999, 24.140692450000074],
              [-74.46483313699991, 24.14394765800006],
              [-74.45815995999993, 24.14130280200004],
              [-74.44318600199995, 24.11668528900009],
              [-74.44078528599994, 24.11424388200004],
              [-74.4387914699999, 24.10382721600007],
              [-74.42967688699991, 24.089789130000042],
              [-74.42711341099994, 24.083238023000035],
              [-74.42772376199991, 24.074164130000042],
              [-74.43321692599994, 24.054429429000038],
              [-74.43455969999991, 24.045396226000037],
              [-74.47549394399994, 23.980210679000038],
              [-74.47850501199991, 23.99168528900009],
              [-74.47671464799993, 24.001613674000055],
              [-74.46865800699993, 24.02179596600007],
            ],
          ],
          [
            [
              [-77.88068600199995, 24.18626536700009],
              [-77.89366614499994, 24.17763906500005],
              [-77.94456946499992, 24.154242255000042],
              [-77.96255449099993, 24.152167059000078],
              [-77.96906490799995, 24.15957265800006],
              [-77.97419186099995, 24.17283763200004],
              [-77.97622636599993, 24.186835028000075],
              [-77.97337805899991, 24.196193752000056],
              [-77.96422278599994, 24.19717031500005],
              [-77.95173092399995, 24.19399648600006],
              [-77.94058183499993, 24.19358958500004],
              [-77.93586178299995, 24.203070380000042],
              [-77.92593339799993, 24.20644765800006],
              [-77.87100175699993, 24.24091217700004],
              [-77.86628170499995, 24.242743231000077],
              [-77.85000566299993, 24.25145091400009],
              [-77.83967037699995, 24.25458405200004],
              [-77.79869544199994, 24.25458405200004],
              [-77.80239824099993, 24.24445221600007],
              [-77.80842037699995, 24.239447333000044],
              [-77.82599850199995, 24.23468659100007],
              [-77.83421790299991, 24.23456452000005],
              [-77.83853105399993, 24.237941799000055],
              [-77.84357662699995, 24.23969147300005],
              [-77.85391191299993, 24.23468659100007],
              [-77.86082923099991, 24.22524648600006],
              [-77.87047278599994, 24.19790273600006],
              [-77.88068600199995, 24.18626536700009],
            ],
          ],
          [
            [
              [-77.92162024599992, 24.26203034100007],
              [-77.93639075399994, 24.261542059000078],
              [-77.94261633999992, 24.253119208000044],
              [-77.94188391799992, 24.24046458500004],
              [-77.93586178299995, 24.22724030200004],
              [-77.95026607999995, 24.230536200000074],
              [-77.97557532499991, 24.227118231000077],
              [-77.99046790299991, 24.22724030200004],
              [-78.00133216099994, 24.23143138200004],
              [-78.01292883999992, 24.23965078300006],
              [-78.0169164699999, 24.248439846000053],
              [-78.00475012899994, 24.25458405200004],
              [-77.97874915299991, 24.25922272300005],
              [-77.95287024599992, 24.270453192000048],
              [-77.93219967399995, 24.27570221600007],
              [-77.92162024599992, 24.26203034100007],
            ],
          ],
          [
            [
              [-76.46300208199995, 24.21360911700009],
              [-76.48180091099994, 24.213771877000056],
              [-76.49315344999991, 24.218817450000074],
              [-76.53526770699995, 24.268377997000073],
              [-76.54458574099993, 24.283026434000078],
              [-76.54491126199991, 24.29555898600006],
              [-76.52953040299991, 24.28742096600007],
              [-76.52041581899994, 24.27496979400007],
              [-76.51341712099992, 24.260891018000052],
              [-76.50389563699991, 24.247748114000046],
              [-76.49205481699994, 24.239203192000048],
              [-76.48131262899994, 24.234320380000042],
              [-76.47166907499991, 24.22760651200008],
              [-76.46300208199995, 24.21360911700009],
            ],
          ],
          [
            [
              [-77.52497311099995, 23.93305084800005],
              [-77.51650956899994, 23.918850002000056],
              [-77.52261308499993, 23.881008205000057],
              [-77.51748613199993, 23.864162502000056],
              [-77.53457597599993, 23.828558661000045],
              [-77.54792232999995, 23.82225169500009],
              [-77.57274329299992, 23.829413153000075],
              [-77.56944739499994, 23.816839911000045],
              [-77.55134029899995, 23.803127346000053],
              [-77.54548092399995, 23.788397528000075],
              [-77.5469457669999, 23.77496979400007],
              [-77.55260169199994, 23.760239976000037],
              [-77.55980383999992, 23.747707424000055],
              [-77.56590735599991, 23.740668036000045],
              [-77.59732011599993, 23.730617580000057],
              [-77.62120520699995, 23.740057684000078],
              [-77.64297441299993, 23.75486888200004],
              [-77.66832434799994, 23.76113515800006],
              [-77.65111243399991, 23.741929429000038],
              [-77.65143795499995, 23.73314036700009],
              [-77.66087805899991, 23.72016022300005],
              [-77.66832434799994, 23.72016022300005],
              [-77.68492591099994, 23.741441148000035],
              [-77.71458899599992, 23.74872467700004],
              [-77.77818762899994, 23.74681224200009],
              [-77.74404863199993, 23.76113515800006],
              [-77.74909420499995, 23.778265692000048],
              [-77.72769120999993, 23.777736721000053],
              [-77.67516028599994, 23.76113515800006],
              [-77.66905676999994, 23.779242255000042],
              [-77.65892493399991, 23.79205963700008],
              [-77.64500891799992, 23.80145905200004],
              [-77.59129798099991, 23.82489655200004],
              [-77.57616126199991, 23.83584219000005],
              [-77.57616126199991, 23.84711334800005],
              [-77.59406490799995, 23.853461005000042],
              [-77.61164303299995, 23.844142971000053],
              [-77.62857011599993, 23.83026764500005],
              [-77.64476477799991, 23.823187567000048],
              [-77.70311438699991, 23.788397528000075],
              [-77.69920813699991, 23.785630601000037],
              [-77.69627844999991, 23.78221263200004],
              [-77.72020423099991, 23.784816799000055],
              [-77.74429277299993, 23.81639232000009],
              [-77.76455644399994, 23.823187567000048],
              [-77.69884192599994, 23.84511953300006],
              [-77.66559811099995, 23.86347077000005],
              [-77.66087805899991, 23.88467031500005],
              [-77.67520097599993, 23.87051015800006],
              [-77.69481360599991, 23.86469147300005],
              [-77.74779212099992, 23.864162502000056],
              [-77.76207434799994, 23.86155833500004],
              [-77.77424068899995, 23.856756903000075],
              [-77.78587805899991, 23.85370514500005],
              [-77.79869544199994, 23.856675523000035],
              [-77.80679277299993, 23.86469147300005],
              [-77.81285559799994, 23.876654364000046],
              [-77.8274633449999, 23.943915106000077],
              [-77.82876542899993, 23.969183661000045],
              [-77.82258053299995, 23.980210679000038],
              [-77.8372289699999, 23.984808661000045],
              [-77.83775794199994, 23.995917059000078],
              [-77.83348548099991, 24.009588934000078],
              [-77.83348548099991, 24.02179596600007],
              [-77.84483801999994, 24.03339264500005],
              [-77.85863196499992, 24.040961005000042],
              [-77.8665258449999, 24.04755280200004],
              [-77.86009680899991, 24.055975653000075],
              [-77.86009680899991, 24.06273021000004],
              [-77.87962805899991, 24.073960679000038],
              [-77.94204667899993, 24.096869208000044],
              [-77.93610592399995, 24.10447825700004],
              [-77.92906653599994, 24.11123281500005],
              [-77.91470292899993, 24.10252513200004],
              [-77.90908769399994, 24.105292059000078],
              [-77.9082738919999, 24.112616278000075],
              [-77.90855872299994, 24.11737702000005],
              [-77.90794837099992, 24.126776434000078],
              [-77.91079667899993, 24.131333726000037],
              [-77.91100012899994, 24.13580963700008],
              [-77.90233313699991, 24.14472077000005],
              [-77.89216061099995, 24.149644273000035],
              [-77.86510169199994, 24.157945054000038],
              [-77.85391191299993, 24.165838934000078],
              [-77.84992428299995, 24.174302476000037],
              [-77.84341386599993, 24.198879299000055],
              [-77.83967037699995, 24.206732489000046],
              [-77.80540930899991, 24.208929755000042],
              [-77.79246985599991, 24.21360911700009],
              [-77.78237870999993, 24.221584377000056],
              [-77.77887936099995, 24.227850653000075],
              [-77.77672278599994, 24.235581773000035],
              [-77.77074133999992, 24.247748114000046],
              [-77.75572669199994, 24.25926341400009],
              [-77.71442623599995, 24.275091864000046],
              [-77.70311438699991, 24.288723049000055],
              [-77.67516028599994, 24.30296458500004],
              [-77.66584225199995, 24.289496161000045],
              [-77.65851803299995, 24.273504950000074],
              [-77.65021725199995, 24.260158596000053],
              [-77.63792883999992, 24.25458405200004],
              [-77.63121497299994, 24.24909088700008],
              [-77.64073645699995, 24.23729075700004],
              [-77.7024633449999, 24.190252997000073],
              [-77.72695878799993, 24.177801825000074],
              [-77.75772050699993, 24.17259349200009],
              [-77.75772050699993, 24.165838934000078],
              [-77.73997962099992, 24.164496161000045],
              [-77.73253333199995, 24.157049872000073],
              [-77.73692786399994, 24.14862702000005],
              [-77.75462805899991, 24.14472077000005],
              [-77.75853430899991, 24.140773830000057],
              [-77.7481176419999, 24.131781317000048],
              [-77.72354081899994, 24.11737702000005],
              [-77.70767167899993, 24.12372467700004],
              [-77.70225989499994, 24.11273834800005],
              [-77.70482337099992, 24.094671942000048],
              [-77.72126217399995, 24.066229559000078],
              [-77.72459876199991, 24.053290106000077],
              [-77.72984778599994, 24.042629299000055],
              [-77.74404863199993, 24.03546784100007],
              [-77.72545325399994, 24.03066640800006],
              [-77.70958411399994, 24.04368724200009],
              [-77.67853756399995, 24.10175202000005],
              [-77.65770423099991, 24.123480536000045],
              [-77.64785722599993, 24.137884833000044],
              [-77.6438695949999, 24.157538153000075],
              [-77.64273027299993, 24.182806708000044],
              [-77.63914954299992, 24.20648834800005],
              [-77.62734941299993, 24.221096096000053],
              [-77.60753333199995, 24.21824778900009],
              [-77.59260006399995, 24.19822825700004],
              [-77.58047441299993, 24.173163153000075],
              [-77.56932532499991, 24.15525950700004],
              [-77.55663001199991, 24.141058661000045],
              [-77.54946855399993, 24.125921942000048],
              [-77.5462133449999, 24.108303127000056],
              [-77.54430091099994, 24.07526276200008],
              [-77.53917395699995, 24.05414459800005],
              [-77.53799394399994, 24.045396226000037],
              [-77.53917395699995, 24.03392161700009],
              [-77.54430091099994, 24.01471588700008],
              [-77.54548092399995, 24.004380601000037],
              [-77.54222571499992, 23.998846747000073],
              [-77.52818762899994, 23.97988515800006],
              [-77.52497311099995, 23.970363674000055],
              [-77.52818762899994, 23.95856354400007],
              [-77.5352270169999, 23.95058828300006],
              [-77.54222571499992, 23.94562409100007],
              [-77.54548092399995, 23.942694403000075],
              [-77.55577551999994, 23.938299872000073],
              [-77.57754472599993, 23.93781159100007],
              [-77.59707597599993, 23.93036530200004],
              [-77.60069739499994, 23.905096747000073],
              [-77.5657445949999, 23.92796458500004],
              [-77.54503333199995, 23.93659088700008],
              [-77.52497311099995, 23.93305084800005],
            ],
          ],
          [
            [
              [-77.76768958199995, 24.326605536000045],
              [-77.78685462099992, 24.314601955000057],
              [-77.79979407499991, 24.317287502000056],
              [-77.80443274599992, 24.32721588700008],
              [-77.79869544199994, 24.337103583000044],
              [-77.7766820949999, 24.34715403900009],
              [-77.75804602799991, 24.35936107000009],
              [-77.73924719999991, 24.367132880000042],
              [-77.71922766799992, 24.37173086100006],
              [-77.70311438699991, 24.37059153900009],
              [-77.69615637899994, 24.36709219000005],
              [-77.68809973899994, 24.36078522300005],
              [-77.68244381399995, 24.352769273000035],
              [-77.68260657499991, 24.34393952000005],
              [-77.69033769399994, 24.338446356000077],
              [-77.70059160099993, 24.341498114000046],
              [-77.71125240799995, 24.347479559000078],
              [-77.71983801999994, 24.350775458000044],
              [-77.73753821499992, 24.349676825000074],
              [-77.74803626199991, 24.34593333500004],
              [-77.76768958199995, 24.326605536000045],
            ],
          ],
          [
            [
              [-75.31468665299991, 24.217352606000077],
              [-75.30699622299994, 24.20254140800006],
              [-75.29043535099993, 24.14472077000005],
              [-75.33580481699994, 24.15851471600007],
              [-75.35643469999991, 24.16014232000009],
              [-75.37987219999991, 24.15839264500005],
              [-75.4251195949999, 24.14996979400007],
              [-75.44090735599991, 24.14203522300005],
              [-75.45840410099993, 24.12791575700004],
              [-75.48314368399991, 24.12571849200009],
              [-75.50991777299993, 24.14207591400009],
              [-75.52131100199995, 24.162583726000037],
              [-75.49962317599994, 24.17259349200009],
              [-75.48493404899995, 24.176214911000045],
              [-75.46361243399991, 24.185614325000074],
              [-75.44391842399995, 24.19871653900009],
              [-75.43390865799995, 24.21360911700009],
              [-75.41466223899994, 24.21312083500004],
              [-75.40575110599991, 24.240301825000074],
              [-75.41006425699993, 24.27289459800005],
              [-75.43073482999995, 24.288723049000055],
              [-75.45995032499991, 24.294582424000055],
              [-75.48058020699995, 24.309393622000073],
              [-75.53400631399995, 24.389227606000077],
              [-75.54190019399994, 24.41746653900009],
              [-75.56110592399995, 24.443426825000074],
              [-75.56550045499995, 24.45693594000005],
              [-75.57152258999992, 24.488755601000037],
              [-75.58849036399994, 24.512640692000048],
              [-75.61436926999994, 24.526597398000035],
              [-75.64736894399994, 24.528957424000055],
              [-75.64346269399994, 24.539455471000053],
              [-75.6426488919999, 24.55149974200009],
              [-75.64415442599994, 24.564154364000046],
              [-75.64736894399994, 24.576117255000042],
              [-75.65274003799993, 24.588364976000037],
              [-75.65782630099994, 24.592922268000052],
              [-75.66470292899993, 24.59601471600007],
              [-75.70885169199994, 24.631333726000037],
              [-75.74107825399994, 24.646144924000055],
              [-75.74982662699995, 24.65180084800005],
              [-75.75658118399991, 24.660305080000057],
              [-75.75755774599992, 24.667914130000042],
              [-75.75300045499995, 24.67601146000004],
              [-75.73216712099992, 24.69863515800006],
              [-75.72386633999992, 24.70184967700004],
              [-75.70885169199994, 24.70018138200004],
              [-75.70221920499995, 24.695746161000045],
              [-75.67536373599995, 24.672308661000045],
              [-75.64932206899994, 24.66307200700004],
              [-75.63731848899994, 24.65696849200009],
              [-75.62633216099994, 24.645005601000037],
              [-75.61856035099993, 24.581244208000044],
              [-75.6126195949999, 24.562445380000042],
              [-75.6028539699999, 24.551906643000052],
              [-75.58682206899994, 24.53851959800005],
              [-75.57201087099992, 24.522691148000035],
              [-75.55996660099993, 24.491441148000035],
              [-75.53221594999991, 24.44489166900007],
              [-75.47606360599991, 24.37059153900009],
              [-75.45811926999994, 24.35732656500005],
              [-75.41901607999995, 24.337836005000042],
              [-75.40038001199991, 24.323472398000035],
              [-75.37559973899994, 24.275946356000077],
              [-75.36961829299992, 24.26825592700004],
              [-75.35850989499994, 24.261419989000046],
              [-75.31468665299991, 24.217352606000077],
            ],
          ],
          [
            [
              [-77.47996985599991, 24.991359768000052],
              [-77.49510657499991, 24.999335028000075],
              [-77.51447506399995, 25.001166083000044],
              [-77.53294837099992, 25.00071849200009],
              [-77.54548092399995, 25.001898505000042],
              [-77.56187903599994, 25.018866278000075],
              [-77.55101477799991, 25.038031317000048],
              [-77.52717037699995, 25.054388739000046],
              [-77.50450598899994, 25.063299872000073],
              [-77.48985755099994, 25.065619208000044],
              [-77.45604407499991, 25.076971747000073],
              [-77.44082597599993, 25.078517971000053],
              [-77.39806067599994, 25.076971747000073],
              [-77.35562089799993, 25.084051825000074],
              [-77.33999589799993, 25.083807684000078],
              [-77.32607988199993, 25.079331773000035],
              [-77.3020727199999, 25.066107489000046],
              [-77.26382402299993, 25.05809153900009],
              [-77.2747289699999, 25.046087958000044],
              [-77.37950598899994, 25.00153229400007],
              [-77.40367591099994, 25.00214264500005],
              [-77.4356176419999, 25.014878648000035],
              [-77.44139563699991, 25.00653717700004],
              [-77.45287024599992, 24.994614976000037],
              [-77.46678626199991, 24.98700592700004],
              [-77.47996985599991, 24.991359768000052],
            ],
          ],
          [
            [
              [-78.3535863919999, 24.65924713700008],
              [-78.34284420499995, 24.665350653000075],
              [-78.33507239499994, 24.67283763200004],
              [-78.3333227199999, 24.682114976000037],
              [-78.34056555899991, 24.693426825000074],
              [-78.3274633449999, 24.710638739000046],
              [-78.31143144399994, 24.710109768000052],
              [-78.29792232999995, 24.69684479400007],
              [-78.29214433499993, 24.67601146000004],
              [-78.29332434799994, 24.65884023600006],
              [-78.29702714799993, 24.643784898000035],
              [-78.30345618399991, 24.63031647300005],
              [-78.31261145699995, 24.617661851000037],
              [-78.3301488919999, 24.60643138200004],
              [-78.33311926999994, 24.603989976000037],
              [-78.33112545499995, 24.594142971000053],
              [-78.32632402299993, 24.58539459800005],
              [-78.31899980399993, 24.581732489000046],
              [-78.29206295499995, 24.597357489000046],
              [-78.27725175699993, 24.601263739000046],
              [-78.26911373599995, 24.609198309000078],
              [-78.27163652299993, 24.631333726000037],
              [-78.25218665299991, 24.622788804000038],
              [-78.2520238919999, 24.604803778000075],
              [-78.25723222599993, 24.583807684000078],
              [-78.25426184799994, 24.566148179000038],
              [-78.23770097599993, 24.55687083500004],
              [-78.22826087099992, 24.569484768000052],
              [-78.22594153599994, 24.591538804000038],
              [-78.23070227799991, 24.61082591400009],
              [-78.22109941299993, 24.60691966400009],
              [-78.21068274599992, 24.601263739000046],
              [-78.20173092399995, 24.598781643000052],
              [-78.19652258999992, 24.603989976000037],
              [-78.19713294199994, 24.618353583000044],
              [-78.20449785099993, 24.62832265800006],
              [-78.21458899599992, 24.63629791900007],
              [-78.22325598899994, 24.645005601000037],
              [-78.22451738199993, 24.650946356000077],
              [-78.22223873599995, 24.666083075000074],
              [-78.22325598899994, 24.672308661000045],
              [-78.22935950399994, 24.679754950000074],
              [-78.24498450399994, 24.69285716400009],
              [-78.25112870999993, 24.70018138200004],
              [-78.25511633999992, 24.714178778000075],
              [-78.2578832669999, 24.72992584800005],
              [-78.26402747299994, 24.73932526200008],
              [-78.27847245999993, 24.73436107000009],
              [-78.26789303299995, 24.72606028900009],
              [-78.26414954299992, 24.71051666900007],
              [-78.26480058499993, 24.672308661000045],
              [-78.27424068899995, 24.682928778000075],
              [-78.28062903599994, 24.69920482000009],
              [-78.28844153599994, 24.714178778000075],
              [-78.30235755099994, 24.72068919500009],
              [-78.30406653599994, 24.728216864000046],
              [-78.30113684799994, 24.745347398000035],
              [-78.29214433499993, 24.775336005000042],
              [-78.27684485599991, 24.789984442000048],
              [-78.25495357999995, 24.806463934000078],
              [-78.23961341099994, 24.82636139500005],
              [-78.24372311099995, 24.85101959800005],
              [-78.23424231699994, 24.857123114000046],
              [-78.20811926999994, 24.861802476000037],
              [-78.20274817599994, 24.86782461100006],
              [-78.19969641799992, 24.88043854400007],
              [-78.18602454299992, 24.904771226000037],
              [-78.1829320949999, 24.91868724200009],
              [-78.17393958199995, 24.919623114000046],
              [-78.17747962099992, 24.927435614000046],
              [-78.18553626199991, 24.937892971000053],
              [-78.18968665299991, 24.94668203300006],
              [-78.18761145699995, 24.95457591400009],
              [-78.18224036399994, 24.968491929000038],
              [-78.17454993399991, 24.981675523000035],
              [-78.16551673099991, 24.987616278000075],
              [-78.15770423099991, 25.00018952000005],
              [-78.15990149599992, 25.02830638200004],
              [-78.1692602199999, 25.07322825700004],
              [-78.18004309799994, 25.10492584800005],
              [-78.20091712099992, 25.146429755000042],
              [-78.21434485599991, 25.18463776200008],
              [-78.20274817599994, 25.206732489000046],
              [-78.18590247299994, 25.205877997000073],
              [-78.14956620999993, 25.19953034100007],
              [-78.13442949099993, 25.19367096600007],
              [-78.12218176999994, 25.18317291900007],
              [-78.11534583199995, 25.172023830000057],
              [-78.10704505099994, 25.16307200700004],
              [-78.09044348899994, 25.159491278000075],
              [-78.07518469999991, 25.165350653000075],
              [-78.06045488199993, 25.176336981000077],
              [-78.04515540299991, 25.18309153900009],
              [-78.02798417899993, 25.176255601000037],
              [-78.01524817599994, 25.167792059000078],
              [-78.00121008999992, 25.160956122000073],
              [-77.98766028599994, 25.15224844000005],
              [-77.97687740799995, 25.138413804000038],
              [-77.99176998599995, 25.122788804000038],
              [-77.99429277299993, 25.105169989000046],
              [-77.9863988919999, 25.088771877000056],
              [-77.96996008999992, 25.076971747000073],
              [-77.98253333199995, 25.037502346000053],
              [-77.98656165299991, 25.012884833000044],
              [-77.98058020699995, 25.001898505000042],
              [-77.96226966099994, 24.999335028000075],
              [-77.94725501199991, 24.991156317000048],
              [-77.93419348899994, 24.976223049000055],
              [-77.87336178299995, 24.83856842700004],
              [-77.82917232999995, 24.778225002000056],
              [-77.8125707669999, 24.76190827000005],
              [-77.79556230399993, 24.754828192000048],
              [-77.78351803299995, 24.74823639500005],
              [-77.74649003799993, 24.714504299000055],
              [-77.73721269399994, 24.70018138200004],
              [-77.73615475199995, 24.682196356000077],
              [-77.73778235599991, 24.65770091400009],
              [-77.74181067599994, 24.634711005000042],
              [-77.74779212099992, 24.62107982000009],
              [-77.75357011599993, 24.602036851000037],
              [-77.74547278599994, 24.57758209800005],
              [-77.72354081899994, 24.535101630000042],
              [-77.71873938699991, 24.499823309000078],
              [-77.72789466099994, 24.47418854400007],
              [-77.75108801999994, 24.45848216400009],
              [-77.78872636599993, 24.453192450000074],
              [-77.80410722599993, 24.44879791900007],
              [-77.81456458199995, 24.438706773000035],
              [-77.82331295499995, 24.42731354400007],
              [-77.83348548099991, 24.419094143000052],
              [-77.86384029899995, 24.41543203300006],
              [-77.87169348899994, 24.406805731000077],
              [-77.86009680899991, 24.384914455000057],
              [-77.87205969999991, 24.37376536700009],
              [-77.90855872299994, 24.350775458000044],
              [-77.92662512899994, 24.345770575000074],
              [-77.96141516799992, 24.345526434000078],
              [-77.97337805899991, 24.34052155200004],
              [-78.01276607999995, 24.314154364000046],
              [-78.01781165299991, 24.30609772300005],
              [-78.01577714799993, 24.297349351000037],
              [-78.01244055899991, 24.28925202000005],
              [-78.01170813699991, 24.28188711100006],
              [-78.01781165299991, 24.275051174000055],
              [-78.02745520699995, 24.27285390800006],
              [-78.03697669199994, 24.275946356000077],
              [-78.04552161399994, 24.28196849200009],
              [-78.05190995999993, 24.288723049000055],
              [-78.06330318899995, 24.316229559000078],
              [-78.06969153599994, 24.350409247000073],
              [-78.0801488919999, 24.379461981000077],
              [-78.10342363199993, 24.391750393000052],
              [-78.13414466099994, 24.403957424000055],
              [-78.14085852799991, 24.43349844000005],
              [-78.13442949099993, 24.501613674000055],
              [-78.15245520699995, 24.488755601000037],
              [-78.16478430899991, 24.475409247000073],
              [-78.18004309799994, 24.464911200000074],
              [-78.20645097599993, 24.460638739000046],
              [-78.22642981699994, 24.46548086100006],
              [-78.3516332669999, 24.530462958000044],
              [-78.41148841099994, 24.58104075700004],
              [-78.43053137899994, 24.60179271000004],
              [-78.44298255099994, 24.62449778900009],
              [-78.42959550699993, 24.627508856000077],
              [-78.40884355399993, 24.63617584800005],
              [-78.38980058499993, 24.64671458500004],
              [-78.38149980399993, 24.655503648000035],
              [-78.37840735599991, 24.66941966400009],
              [-78.37108313699991, 24.66815827000005],
              [-78.36180579299992, 24.661444403000075],
              [-78.3535863919999, 24.65924713700008],
            ],
          ],
          [
            [
              [-76.16128495999993, 25.165716864000046],
              [-76.13125566299993, 25.147772528000075],
              [-76.11827551999994, 25.133937893000052],
              [-76.11290442599994, 25.114894924000055],
              [-76.12132727799991, 25.030096747000073],
              [-76.12559973899994, 25.014064846000053],
              [-76.12657630099994, 25.00531647300005],
              [-76.13060462099992, 24.99485911700009],
              [-76.13975989499994, 24.98847077000005],
              [-76.14928137899994, 24.984523830000057],
              [-76.15444902299993, 24.981390692000048],
              [-76.15794837099992, 24.962144273000035],
              [-76.15355383999992, 24.94432200700004],
              [-76.14085852799991, 24.91868724200009],
              [-76.13695227799991, 24.902167059000078],
              [-76.14085852799991, 24.854437567000048],
              [-76.14614824099993, 24.83421458500004],
              [-76.16966712099992, 24.79979075700004],
              [-76.17495683499993, 24.78587474200009],
              [-76.17747962099992, 24.71580638200004],
              [-76.17398027299993, 24.67731354400007],
              [-76.16128495999993, 24.645005601000037],
              [-76.19448808499993, 24.65839264500005],
              [-76.21178137899994, 24.690252997000073],
              [-76.22264563699991, 24.726955471000053],
              [-76.23643958199995, 24.754828192000048],
              [-76.25300045499995, 24.765773830000057],
              [-76.29670162699995, 24.782049872000073],
              [-76.31525631399995, 24.792669989000046],
              [-76.33633378799993, 24.814927476000037],
              [-76.33372962099992, 24.824164130000042],
              [-76.31745357999995, 24.82526276200008],
              [-76.21934973899994, 24.81004466400009],
              [-76.21275794199994, 24.81273021000004],
              [-76.20811926999994, 24.819159247000073],
              [-76.20396887899994, 24.82689036700009],
              [-76.19884192599994, 24.833685614000046],
              [-76.18244381399995, 24.848781643000052],
              [-76.17764238199993, 24.85765208500004],
              [-76.17495683499993, 24.871527411000045],
              [-76.17577063699991, 24.89451732000009],
              [-76.18394934799994, 24.88930898600006],
              [-76.19542395699995, 24.87327708500004],
              [-76.20596269399994, 24.864081122000073],
              [-76.21202551999994, 24.875392971000053],
              [-76.21092688699991, 24.90102773600006],
              [-76.20225989499994, 24.94668203300006],
              [-76.1966039699999, 24.963446356000077],
              [-76.19383704299992, 24.96743398600006],
              [-76.18797766799992, 24.973944403000075],
              [-76.15925045499995, 24.998195705000057],
              [-76.15444902299993, 25.00531647300005],
              [-76.14671790299991, 25.062445380000042],
              [-76.14704342399995, 25.083807684000078],
              [-76.16494706899994, 25.129828192000048],
              [-76.19635982999995, 25.15428294500009],
              [-76.23228919199994, 25.17096588700008],
              [-76.2637426419999, 25.19367096600007],
              [-76.34626217399995, 25.303534247000073],
              [-76.37157141799992, 25.32249583500004],
              [-76.40953528599994, 25.335191148000035],
              [-76.48961341099994, 25.351304429000038],
              [-76.53083248599995, 25.370428778000075],
              [-76.59121660099993, 25.42255280200004],
              [-76.63052324099993, 25.433254299000055],
              [-76.65233313699991, 25.435370184000078],
              [-76.69367428299995, 25.44476959800005],
              [-76.71275794199994, 25.446926174000055],
              [-76.73428300699993, 25.441839911000045],
              [-76.76939856699994, 25.42405833500004],
              [-76.7844945949999, 25.42641836100006],
              [-76.75951087099992, 25.450018622000073],
              [-76.74551347599993, 25.48924388200004],
              [-76.72984778599994, 25.563625393000052],
              [-76.73668372299994, 25.563625393000052],
              [-76.70230058499993, 25.56395091400009],
              [-76.68675696499992, 25.56207916900007],
              [-76.67520097599993, 25.556789455000057],
              [-76.68614661399994, 25.54132721600007],
              [-76.69098873599995, 25.525946356000077],
              [-76.69131425699993, 25.50885651200008],
              [-76.68887285099993, 25.48786041900007],
              [-76.6731664699999, 25.506659247000073],
              [-76.66197669199994, 25.497259833000044],
              [-76.65298417899993, 25.47797272300005],
              [-76.64391028599994, 25.467352606000077],
              [-76.62458248599995, 25.46246979400007],
              [-76.49762936099995, 25.373480536000045],
              [-76.46092688699991, 25.35455963700008],
              [-76.41454016799992, 25.34446849200009],
              [-76.36827551999994, 25.342718817000048],
              [-76.3516332669999, 25.33860911700009],
              [-76.33576412699995, 25.327093817000048],
              [-76.28416907499991, 25.26190827000005],
              [-76.22370357999995, 25.20807526200008],
              [-76.16128495999993, 25.165716864000046],
            ],
          ],
          [
            [
              [-77.81920325399994, 25.707586981000077],
              [-77.83145097599993, 25.708685614000046],
              [-77.84406490799995, 25.72207265800006],
              [-77.86009680899991, 25.748521226000037],
              [-77.88048255099994, 25.76898834800005],
              [-77.88731848899994, 25.78143952000005],
              [-77.88068600199995, 25.789536851000037],
              [-77.86803137899994, 25.78742096600007],
              [-77.85826575399994, 25.777289130000042],
              [-77.82087154899995, 25.716620184000078],
              [-77.81920325399994, 25.707586981000077],
            ],
          ],
          [
            [
              [-77.53799394399994, 26.306586005000042],
              [-77.5423070949999, 26.298976955000057],
              [-77.57274329299992, 26.268703518000052],
              [-77.56704667899993, 26.29100169500009],
              [-77.57217363199993, 26.30487702000005],
              [-77.57933508999992, 26.318019924000055],
              [-77.57957923099991, 26.337591864000046],
              [-77.5703832669999, 26.33270905200004],
              [-77.54356848899994, 26.31248607000009],
              [-77.53799394399994, 26.306586005000042],
            ],
          ],
          [
            [
              [-78.59007727799991, 26.53620026200008],
              [-78.60761892799991, 26.525734450000073],
              [-78.62896577499993, 26.51610211700006],
              [-78.64644049499992, 26.504853429000036],
              [-78.65577003499993, 26.497788470000046],
              [-78.67671736599993, 26.496131503000072],
              [-78.68613184999992, 26.49191095300006],
              [-78.72696836599994, 26.49544569200009],
              [-78.76683934699992, 26.508104203000073],
              [-78.79108864499995, 26.529699767000068],
              [-78.83455712699993, 26.55365117100007],
              [-78.93959961399992, 26.65078778700007],
              [-78.98729407499991, 26.68622467700004],
              [-78.99787350199995, 26.701320705000057],
              [-78.98713131399995, 26.70148346600007],
              [-78.97838294199994, 26.69940827000005],
              [-78.97093665299991, 26.69489166900007],
              [-78.96434485599991, 26.68768952000005],
              [-78.83580481699994, 26.614569403000075],
              [-78.80606035099993, 26.577826239000046],
              [-78.7862224559999, 26.581143507000036],
              [-78.77037512399994, 26.58332478400007],
              [-78.73815509299993, 26.57080854600008],
              [-78.7142887789999, 26.570519948000083],
              [-78.69172287099991, 26.579970039000045],
              [-78.67125234799994, 26.59291820100009],
              [-78.65751282199994, 26.598588549000056],
              [-78.64578727799994, 26.60509679200004],
              [-78.63797875099993, 26.609730986000045],
              [-78.63425147899994, 26.617819430000054],
              [-78.62161113499991, 26.62701354400008],
              [-78.61901136299991, 26.63951757600006],
              [-78.6044346509999, 26.65053474000007],
              [-78.59219252499992, 26.673048306000055],
              [-78.5736332699999, 26.68415929300005],
              [-78.5759422349999, 26.694769508000036],
              [-78.60000566299993, 26.708197333000044],
              [-78.64159094999991, 26.714992580000057],
              [-78.63467363199993, 26.72797272300005],
              [-78.60741126199991, 26.755926825000074],
              [-78.60155188699991, 26.76825592700004],
              [-78.5938207669999, 26.81053294500009],
              [-78.57477779899995, 26.79828522300005],
              [-78.55719967399995, 26.778550523000035],
              [-78.5442602199999, 26.757025458000044],
              [-78.53917395699995, 26.739203192000048],
              [-78.5202572959999, 26.728995355000052],
              [-78.43781648399994, 26.69982110500007],
              [-78.41705909299992, 26.704749029000084],
              [-78.37096106699994, 26.694525458000044],
              [-78.31998377999992, 26.68652744500008],
              [-78.28708191999993, 26.68549205900007],
              [-78.27361518799995, 26.703582975000074],
              [-78.25292968999992, 26.712942463000047],
              [-78.22168484799994, 26.700293688000045],
              [-78.20264129899994, 26.697158680000086],
              [-78.16705098299991, 26.710400108000044],
              [-78.11894820799995, 26.704328287000067],
              [-78.0872289699999, 26.71312083500004],
              [-78.05540930899991, 26.72601959800005],
              [-78.03514563699991, 26.728583075000074],
              [-77.97166907499991, 26.72955963700008],
              [-77.95628821499992, 26.73541901200008],
              [-77.94684811099995, 26.746568101000037],
              [-77.94005286399994, 26.759466864000046],
              [-77.93114173099991, 26.77049388200004],
              [-77.91539466099994, 26.77643463700008],
              [-77.91307532499991, 26.757879950000074],
              [-77.91808020699995, 26.737494208000044],
              [-77.92080644399994, 26.716945705000057],
              [-77.90294348899994, 26.681586005000042],
              [-77.90217037699995, 26.66242096600007],
              [-77.91055253799993, 26.646307684000078],
              [-77.92906653599994, 26.639227606000077],
              [-77.93626868399991, 26.641791083000044],
              [-77.9531957669999, 26.654852606000077],
              [-77.96255449099993, 26.65973541900007],
              [-77.97541256399995, 26.661769924000055],
              [-78.04076087099992, 26.65843333500004],
              [-78.10033118399991, 26.64606354400007],
              [-78.23770620099992, 26.621325470000045],
              [-78.29338578699992, 26.621300259000066],
              [-78.50340735599991, 26.573065497000073],
              [-78.52147376199991, 26.570379950000074],
              [-78.54015051999994, 26.565008856000077],
              [-78.57046464799993, 26.541571356000077],
              [-78.59007727799991, 26.53620026200008],
            ],
          ],
          [
            [
              [-77.81236731699994, 26.906805731000077],
              [-77.83067786399994, 26.909409898000035],
              [-77.90977942599994, 26.904038804000038],
              [-77.9414770169999, 26.89354075700004],
              [-77.96255449099993, 26.893052476000037],
              [-77.95962480399993, 26.896958726000037],
              [-77.95665442599994, 26.89842357000009],
              [-77.94945227799991, 26.89988841400009],
              [-77.91344153599994, 26.92096588700008],
              [-77.86815344999991, 26.92841217700004],
              [-77.77448482999995, 26.92723216400009],
              [-77.68236243399991, 26.90843333500004],
              [-77.62979081899994, 26.90420156500005],
              [-77.60684160099993, 26.920396226000037],
              [-77.55357825399994, 26.89801666900007],
              [-77.51130123599995, 26.869533596000053],
              [-77.32795162699995, 26.709133205000057],
              [-77.30711829299992, 26.696437893000052],
              [-77.28368079299992, 26.68968333500004],
              [-77.25059973899994, 26.68768952000005],
              [-77.25914466099994, 26.676703192000048],
              [-77.27261308499993, 26.673000393000052],
              [-77.30524654899995, 26.67401764500005],
              [-77.29059811099995, 26.646958726000037],
              [-77.26988684799994, 26.625067450000074],
              [-77.24388587099992, 26.610500393000052],
              [-77.18276933499993, 26.60028717700004],
              [-77.15526282499991, 26.58808014500005],
              [-77.10724850199995, 26.556708075000074],
              [-77.07054602799991, 26.53851959800005],
              [-77.05882727799991, 26.529364325000074],
              [-77.04979407499991, 26.51634349200009],
              [-77.0423070949999, 26.49803294500009],
              [-77.04214433499993, 26.48183828300006],
              [-77.05540930899991, 26.47479889500005],
              [-77.05858313699991, 26.46784088700008],
              [-77.05882727799991, 26.42324453300006],
              [-77.05540930899991, 26.40692780200004],
              [-77.04625403599994, 26.396307684000078],
              [-77.03294837099992, 26.389878648000035],
              [-77.01720130099994, 26.385972398000035],
              [-77.03001868399991, 26.36273834800005],
              [-77.03156490799995, 26.355292059000078],
              [-77.02928626199991, 26.34442780200004],
              [-77.02440344999991, 26.337591864000046],
              [-77.01943925699993, 26.33270905200004],
              [-77.01720130099994, 26.32762278900009],
              [-77.01610266799992, 26.319525458000044],
              [-77.01475989499994, 26.315659898000035],
              [-77.01650956899994, 26.311712958000044],
              [-77.0247289699999, 26.30345286700009],
              [-77.03270423099991, 26.297430731000077],
              [-77.04100501199991, 26.293768622000073],
              [-77.05882727799991, 26.29043203300006],
              [-77.05675208199995, 26.294663804000038],
              [-77.05199133999992, 26.30963776200008],
              [-77.08446204299992, 26.30613841400009],
              [-77.1153051419999, 26.29043203300006],
              [-77.1426488919999, 26.26825592700004],
              [-77.16494706899994, 26.245428778000075],
              [-77.17438717399995, 26.22068919500009],
              [-77.18321692599994, 26.144273179000038],
              [-77.1817113919999, 26.12531159100007],
              [-77.19220943899995, 26.06899648600006],
              [-77.18716386599993, 25.98847077000005],
              [-77.1907445949999, 25.91632721600007],
              [-77.22667395699995, 25.88507721600007],
              [-77.25304114499994, 25.897609768000052],
              [-77.27623450399994, 25.92601146000004],
              [-77.29271399599992, 25.95726146000004],
              [-77.29898027299993, 25.97793203300006],
              [-77.31505286399994, 25.99095286700009],
              [-77.38817298099991, 26.00543854400007],
              [-77.4082738919999, 26.029730536000045],
              [-77.39207923099991, 26.029852606000077],
              [-77.37393144399994, 26.03546784100007],
              [-77.35912024599992, 26.04588450700004],
              [-77.34788977799991, 26.07062409100007],
              [-77.33560136599993, 26.07367584800005],
              [-77.32103430899991, 26.07518138200004],
              [-77.30894934799994, 26.080633856000077],
              [-77.27236894399994, 26.118312893000052],
              [-77.24893144399994, 26.136053778000075],
              [-77.22329667899993, 26.145819403000075],
              [-77.2298070949999, 26.153998114000046],
              [-77.23379472599993, 26.162258205000057],
              [-77.23582923099991, 26.171698309000078],
              [-77.23631751199991, 26.183661200000074],
              [-77.24034583199995, 26.190578518000052],
              [-77.24876868399991, 26.196519273000035],
              [-77.25641842399995, 26.203924872000073],
              [-77.25804602799991, 26.21474844000005],
              [-77.25182044199994, 26.22601959800005],
              [-77.24250240799995, 26.234523830000057],
              [-77.23387610599991, 26.24404531500005],
              [-77.23013261599993, 26.258734442000048],
              [-77.23058020699995, 26.285101630000042],
              [-77.23338782499991, 26.298000393000052],
              [-77.25035559799994, 26.313055731000077],
              [-77.21861731699994, 26.355292059000078],
              [-77.21987870999993, 26.364935614000046],
              [-77.22862708199995, 26.37693919500009],
              [-77.23013261599993, 26.44745514500005],
              [-77.21544348899994, 26.447699286000045],
              [-77.20457923099991, 26.45331452000005],
              [-77.19619706899994, 26.46287669500009],
              [-77.18919837099992, 26.47479889500005],
              [-77.18809973899994, 26.479803778000075],
              [-77.18919837099992, 26.498968817000048],
              [-77.18643144399994, 26.505926825000074],
              [-77.18016516799992, 26.51007721600007],
              [-77.17300370999993, 26.512844143000052],
              [-77.16808020699995, 26.515773830000057],
              [-77.15794837099992, 26.53143952000005],
              [-77.15355383999992, 26.54946523600006],
              [-77.16071529899995, 26.564195054000038],
              [-77.19615637899994, 26.572658596000053],
              [-77.21955318899995, 26.582424221000053],
              [-77.31216386599993, 26.594671942000048],
              [-77.32974199099993, 26.60455963700008],
              [-77.34097245999993, 26.621527411000045],
              [-77.35301673099991, 26.64606354400007],
              [-77.34845943899995, 26.652167059000078],
              [-77.34732011599993, 26.660305080000057],
              [-77.35008704299992, 26.66901276200008],
              [-77.36143958199995, 26.68231842700004],
              [-77.36656653599994, 26.693019924000055],
              [-77.37010657499991, 26.69790273600006],
              [-77.37535559799994, 26.69953034100007],
              [-77.38003495999993, 26.695705471000053],
              [-77.38491777299993, 26.690334377000056],
              [-77.39085852799991, 26.68768952000005],
              [-77.41124426999994, 26.689398505000042],
              [-77.42699133999992, 26.695135809000078],
              [-77.43399003799993, 26.705511786000045],
              [-77.42813066299993, 26.721177476000037],
              [-77.44469153599994, 26.755072333000044],
              [-77.49022376199991, 26.82330963700008],
              [-77.51748613199993, 26.85219961100006],
              [-77.53441321499992, 26.86318594000005],
              [-77.55622311099995, 26.87055084800005],
              [-77.57848059799994, 26.871161200000074],
              [-77.5969945949999, 26.86204661700009],
              [-77.61432857999995, 26.85651276200008],
              [-77.63805091099994, 26.859930731000077],
              [-77.69684811099995, 26.877346096000053],
              [-77.71495520699995, 26.879380601000037],
              [-77.75462805899991, 26.879461981000077],
              [-77.76642818899995, 26.88279857000009],
              [-77.79466712099992, 26.899725653000075],
              [-77.81236731699994, 26.906805731000077],
            ],
          ],
          [
            [
              [-79.51402747299994, 23.49567291900007],
              [-79.51756751199991, 23.49404531500005],
              [-79.53661048099991, 23.50649648600006],
              [-79.5384008449999, 23.510239976000037],
              [-79.51402747299994, 23.49567291900007],
            ],
          ],
          [
            [
              [-79.56334387899994, 23.546698309000078],
              [-79.55288652299993, 23.533758856000077],
              [-79.55455481699994, 23.533148505000042],
              [-79.59434973899994, 23.574652411000045],
              [-79.58869381399995, 23.57135651200008],
              [-79.56334387899994, 23.546698309000078],
            ],
          ],
          [
            [
              [-79.26870683499993, 25.53856028900009],
              [-79.26650956899994, 25.53782786700009],
              [-79.26211503799993, 25.52806224200009],
              [-79.26431230399993, 25.52879466400009],
              [-79.26870683499993, 25.53856028900009],
            ],
          ],
          [
            [
              [-79.28892981699994, 25.559149481000077],
              [-79.28844153599994, 25.562974351000037],
              [-79.27940833199995, 25.551662502000056],
              [-79.27989661399994, 25.547796942000048],
              [-79.28892981699994, 25.559149481000077],
            ],
          ],
          [
            [
              [-75.72207597599993, 22.20258209800005],
              [-75.71816972599993, 22.195786851000037],
              [-75.71471106699994, 22.182928778000075],
              [-75.72191321499992, 22.17536041900007],
              [-75.73436438699991, 22.175034898000035],
              [-75.74266516799992, 22.183254299000055],
              [-75.74852454299992, 22.19668203300006],
              [-75.74974524599992, 22.20453522300005],
              [-75.74502519399994, 22.20575592700004],
              [-75.73912512899994, 22.203924872000073],
              [-75.73302161399994, 22.199774481000077],
              [-75.73399817599994, 22.205959377000056],
              [-75.73949133999992, 22.22284577000005],
              [-75.73623613199993, 22.22479889500005],
              [-75.73143469999991, 22.21820709800005],
              [-75.72207597599993, 22.20258209800005],
            ],
          ],
          [
            [
              [-75.74596106699994, 22.236029364000046],
              [-75.74966386599993, 22.234849351000037],
              [-75.75340735599991, 22.23737213700008],
              [-75.75186113199993, 22.26325104400007],
              [-75.74754798099991, 22.261460679000038],
              [-75.74486243399991, 22.244696356000077],
              [-75.74596106699994, 22.236029364000046],
            ],
          ],
          [
            [
              [-75.81167558499993, 22.371568101000037],
              [-75.80785071499992, 22.365668036000045],
              [-75.80264238199993, 22.353176174000055],
              [-75.80549068899995, 22.347601630000042],
              [-75.81314042899993, 22.356268622000073],
              [-75.82017981699994, 22.37132396000004],
              [-75.82363847599993, 22.38572825700004],
              [-75.81956946499992, 22.388413804000038],
              [-75.81362870999993, 22.377875067000048],
              [-75.81167558499993, 22.371568101000037],
            ],
          ],
          [
            [
              [-73.61817706699992, 22.601249625000037],
              [-73.60598340899992, 22.60949395500006],
              [-73.59379446199995, 22.601993096000058],
              [-73.60761801299992, 22.57725526300004],
              [-73.62549800399995, 22.574257902000056],
              [-73.61817706699992, 22.601249625000037],
            ],
          ],
          [
            [
              [-75.10903886599993, 23.846909898000035],
              [-75.10606848899994, 23.842352606000077],
              [-75.10578365799995, 23.83144765800006],
              [-75.11070716099994, 23.81867096600007],
              [-75.11742102799991, 23.81513092700004],
              [-75.12364661399994, 23.831000067000048],
              [-75.11729895699995, 23.845445054000038],
              [-75.10903886599993, 23.846909898000035],
            ],
          ],
          [
            [
              [-77.8692113919999, 24.346828518000052],
              [-77.83975175699993, 24.350083726000037],
              [-77.83283443899995, 24.349554755000042],
              [-77.83702551999994, 24.342189846000053],
              [-77.84862219999991, 24.32758209800005],
              [-77.86729895699995, 24.319484768000052],
              [-77.88369706899994, 24.327337958000044],
              [-77.88361568899995, 24.341131903000075],
              [-77.8692113919999, 24.346828518000052],
            ],
          ],
          [
            [
              [-76.77432206899994, 24.53864166900007],
              [-76.77306067599994, 24.531724351000037],
              [-76.77257239499994, 24.51911041900007],
              [-76.77892005099994, 24.51434967700004],
              [-76.78929602799991, 24.518500067000048],
              [-76.79507402299993, 24.53143952000005],
              [-76.79238847599993, 24.54913971600007],
              [-76.78465735599991, 24.55296458500004],
              [-76.77749589799993, 24.543850002000056],
              [-76.77432206899994, 24.53864166900007],
            ],
          ],
          [
            [
              [-77.86412512899994, 25.407904364000046],
              [-77.87950598899994, 25.407863674000055],
              [-77.88841712099992, 25.408758856000077],
              [-77.90672766799992, 25.409084377000056],
              [-77.90587317599994, 25.410956122000073],
              [-77.90001380099994, 25.41547272300005],
              [-77.89240475199995, 25.41868724200009],
              [-77.88630123599995, 25.419175523000035],
              [-77.87482662699995, 25.41828034100007],
              [-77.85912024599992, 25.419256903000075],
              [-77.84727942599994, 25.425848700000074],
              [-77.83958899599992, 25.43496328300006],
              [-77.83682206899994, 25.434515692000048],
              [-77.84215247299994, 25.42324453300006],
              [-77.85204016799992, 25.41274648600006],
              [-77.86412512899994, 25.407904364000046],
            ],
          ],
          [
            [
              [-79.2500707669999, 25.774725653000075],
              [-79.24608313699991, 25.76386139500005],
              [-79.24323482999995, 25.74290599200009],
              [-79.24592037699995, 25.73456452000005],
              [-79.24803626199991, 25.73895905200004],
              [-79.25462805899991, 25.736029364000046],
              [-79.26695716099994, 25.732489325000074],
              [-79.26870683499993, 25.74160390800006],
              [-79.26170813699991, 25.756659247000073],
              [-79.26553300699993, 25.76162344000005],
              [-79.27904212099992, 25.74998607000009],
              [-79.28624426999994, 25.741522528000075],
              [-79.29157467399995, 25.73383209800005],
              [-79.29385331899994, 25.72068919500009],
              [-79.28331458199995, 25.71279531500005],
              [-79.26813717399995, 25.707098700000074],
              [-79.25804602799991, 25.699042059000078],
              [-79.26183020699995, 25.693752346000053],
              [-79.28917395699995, 25.697658596000053],
              [-79.30064856699994, 25.69794342700004],
              [-79.30426998599995, 25.702337958000044],
              [-79.30125891799992, 25.716864325000074],
              [-79.29381262899994, 25.736029364000046],
              [-79.28034420499995, 25.75722890800006],
              [-79.2610570949999, 25.771918036000045],
              [-79.2500707669999, 25.774725653000075],
            ],
          ],
          [
            [
              [-77.24425208199995, 26.478461005000042],
              [-77.2376195949999, 26.47406647300005],
              [-77.23607337099992, 26.470363674000055],
              [-77.23656165299991, 26.46938711100006],
              [-77.23843339799993, 26.47016022300005],
              [-77.24209550699993, 26.47060781500005],
              [-77.24299068899995, 26.46906159100007],
              [-77.24071204299992, 26.467352606000077],
              [-77.24046790299991, 26.466620184000078],
              [-77.24250240799995, 26.46621328300006],
              [-77.24351966099994, 26.454413153000075],
              [-77.24103756399995, 26.44281647300005],
              [-77.24665279899995, 26.438666083000044],
              [-77.25055904899995, 26.43821849200009],
              [-77.25454667899993, 26.43813711100006],
              [-77.26329505099994, 26.442206122000073],
              [-77.26744544199994, 26.453273830000057],
              [-77.27232825399994, 26.460679429000038],
              [-77.27822831899994, 26.46580638200004],
              [-77.2766820949999, 26.469956773000035],
              [-77.27236894399994, 26.46946849200009],
              [-77.26756751199991, 26.47256094000005],
              [-77.26183020699995, 26.477850653000075],
              [-77.25377356699994, 26.48004791900007],
              [-77.24425208199995, 26.478461005000042],
            ],
          ],
          [
            [
              [-77.85383053299995, 26.600775458000044],
              [-77.84845943899995, 26.605536200000074],
              [-77.83751380099994, 26.61351146000004],
              [-77.83462480399993, 26.610541083000044],
              [-77.84361731699994, 26.600734768000052],
              [-77.84707597599993, 26.594875393000052],
              [-77.84715735599991, 26.59052155200004],
              [-77.85187740799995, 26.583319403000075],
              [-77.85558020699995, 26.572739976000037],
              [-77.86192786399994, 26.564113674000055],
              [-77.86839758999992, 26.56386953300006],
              [-77.87051347599993, 26.56671784100007],
              [-77.87287350199995, 26.57054271000004],
              [-77.88658606699994, 26.585598049000055],
              [-77.89110266799992, 26.59406159100007],
              [-77.89313717399995, 26.60260651200008],
              [-77.88780676999994, 26.606594143000052],
              [-77.85757402299993, 26.611761786000045],
              [-77.85309811099995, 26.60700104400007],
              [-77.86241614499994, 26.596625067000048],
              [-77.86449133999992, 26.59365469000005],
              [-77.85708574099993, 26.59784577000005],
              [-77.85383053299995, 26.600775458000044],
            ],
          ],
          [
            [
              [-76.77018559585534, 25.551304288339367],
              [-76.75843196916557, 25.54895356300141],
              [-76.74589476736315, 25.54503568743816],
              [-76.74981264292641, 25.5395506616496],
              [-76.76078269450352, 25.540334236762252],
              [-76.78742424833366, 25.541901386987554],
              [-76.78115564743246, 25.548169987888762],
              [-76.77018559585534, 25.551304288339367],
            ],
          ],
          [
            [
              [-76.82895372930416, 25.53171491052309],
              [-76.81798367772706, 25.532498485635738],
              [-76.80936435148789, 25.529364185185134],
              [-76.81093150171318, 25.52387915939658],
              [-76.82895372930416, 25.516826983382717],
              [-76.84854310712045, 25.516826983382717],
              [-76.86108030892287, 25.508207657143558],
              [-76.87205036049997, 25.506640506918256],
              [-76.87283393561262, 25.514476258044766],
              [-76.8571624333596, 25.52387915939658],
              [-76.84462523155719, 25.52622988473453],
              [-76.82895372930416, 25.53171491052309],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Turks and Caicos Is.',
        iso3: 'TCA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-72.46076412699995, 21.70538971600007],
              [-72.43342037699995, 21.70921458500004],
              [-72.43325761599993, 21.680121161000045],
              [-72.45201575399994, 21.644964911000045],
              [-72.48131262899994, 21.63031647300005],
              [-72.48131262899994, 21.636542059000078],
              [-72.47020423099991, 21.646877346000053],
              [-72.46336829299992, 21.664943752000056],
              [-72.46043860599991, 21.686021226000037],
              [-72.46076412699995, 21.70538971600007],
            ],
          ],
          [
            [
              [-71.50796464799993, 21.70538971600007],
              [-71.52892005099994, 21.71743398600006],
              [-71.57323157499991, 21.735296942000048],
              [-71.59056555899991, 21.75381094000005],
              [-71.58592688699991, 21.75682200700004],
              [-71.58177649599992, 21.758368231000077],
              [-71.57848059799994, 21.760931708000044],
              [-71.57628333199995, 21.766831773000035],
              [-71.54308020699995, 21.746527411000045],
              [-71.52554277299993, 21.73981354400007],
              [-71.50112870999993, 21.733343817000048],
              [-71.48094641799992, 21.725490627000056],
              [-71.46178137899994, 21.71084219000005],
              [-71.45189368399991, 21.69017161700009],
              [-71.45958411399994, 21.664455471000053],
              [-71.47126217399995, 21.662176825000074],
              [-71.48534094999991, 21.675441799000055],
              [-71.50796464799993, 21.70538971600007],
            ],
          ],
          [
            [
              [-71.80284583199995, 21.787909247000073],
              [-71.82770748599995, 21.78579336100006],
              [-71.83551998599995, 21.791489976000037],
              [-71.84439042899993, 21.807806708000044],
              [-71.84801184799994, 21.81940338700008],
              [-71.85065670499995, 21.856268622000073],
              [-71.84235592399995, 21.855617580000057],
              [-71.83381100199995, 21.85382721600007],
              [-71.82583574099993, 21.850775458000044],
              [-71.80939693899995, 21.839992580000057],
              [-71.79991614499994, 21.839911200000074],
              [-71.79076087099992, 21.842230536000045],
              [-71.78172766799992, 21.84316640800006],
              [-71.72032630099994, 21.835760809000078],
              [-71.69176184799994, 21.84121328300006],
              [-71.67878170499995, 21.841864325000074],
              [-71.66563880099994, 21.835760809000078],
              [-71.65518144399994, 21.82322825700004],
              [-71.6309301419999, 21.774318752000056],
              [-71.64806067599994, 21.77960846600007],
              [-71.65904700399994, 21.793524481000077],
              [-71.66808020699995, 21.809759833000044],
              [-71.67931067599994, 21.822088934000078],
              [-71.6712133449999, 21.799750067000048],
              [-71.6524145169999, 21.764960028000075],
              [-71.64517167899993, 21.74640534100007],
              [-71.65859941299993, 21.743882554000038],
              [-71.66852779899995, 21.750433661000045],
              [-71.68614661399994, 21.774318752000056],
              [-71.69200598899994, 21.764064846000053],
              [-71.69359290299991, 21.75999583500004],
              [-71.69981848899994, 21.75999583500004],
              [-71.71544348899994, 21.78729889500005],
              [-71.74111894399994, 21.79490794500009],
              [-71.80284583199995, 21.787909247000073],
            ],
          ],
          [
            [
              [-72.3372289699999, 21.80097077000005],
              [-72.34019934799994, 21.81403229400007],
              [-72.32974199099993, 21.845404364000046],
              [-72.33043372299994, 21.862453518000052],
              [-72.3079320949999, 21.85224030200004],
              [-72.24502519399994, 21.79791901200008],
              [-72.2317602199999, 21.793361721000053],
              [-72.21214758999992, 21.793443101000037],
              [-72.1926977199999, 21.796576239000046],
              [-72.17959550699993, 21.80097077000005],
              [-72.16527258999992, 21.81386953300006],
              [-72.15713456899994, 21.82453034100007],
              [-72.14631100199995, 21.82713450700004],
              [-72.12437903599994, 21.815252997000073],
              [-72.12437903599994, 21.807806708000044],
              [-72.15103105399993, 21.78384023600006],
              [-72.15908769399994, 21.774318752000056],
              [-72.16429602799991, 21.788804429000038],
              [-72.16527258999992, 21.79482656500005],
              [-72.19326738199993, 21.78115469000005],
              [-72.1895238919999, 21.77993398600006],
              [-72.18610592399995, 21.779242255000042],
              [-72.18285071499992, 21.777818101000037],
              [-72.17959550699993, 21.774318752000056],
              [-72.19444739499994, 21.766913153000075],
              [-72.21971594999991, 21.770331122000073],
              [-72.23424231699994, 21.766831773000035],
              [-72.23424231699994, 21.78115469000005],
              [-72.27383378799993, 21.75141022300005],
              [-72.29185950399994, 21.748928127000056],
              [-72.30308997299994, 21.774318752000056],
              [-72.2969457669999, 21.774318752000056],
              [-72.29067949099993, 21.76581452000005],
              [-72.28123938699991, 21.761542059000078],
              [-72.27424068899995, 21.763617255000042],
              [-72.27513587099992, 21.774318752000056],
              [-72.28123938699991, 21.77960846600007],
              [-72.31615149599992, 21.79482656500005],
              [-72.31289628799993, 21.78115469000005],
              [-72.31541907499991, 21.770819403000075],
              [-72.32363847599993, 21.763820705000057],
              [-72.3372289699999, 21.75999583500004],
              [-72.33950761599993, 21.76666901200008],
              [-72.33999589799993, 21.771226304000038],
              [-72.3391820949999, 21.775458075000074],
              [-72.3372289699999, 21.78115469000005],
              [-72.33556067599994, 21.77684153900009],
              [-72.33519446499992, 21.776190497000073],
              [-72.33409583199995, 21.776190497000073],
              [-72.33043372299994, 21.774318752000056],
              [-72.32652747299994, 21.78742096600007],
              [-72.31395423099991, 21.809068101000037],
              [-72.30992591099994, 21.822088934000078],
              [-72.33141028599994, 21.806586005000042],
              [-72.3372289699999, 21.80097077000005],
            ],
          ],
          [
            [
              [-72.02196204299992, 21.90460846600007],
              [-72.02611243399991, 21.914007880000042],
              [-72.02448482999995, 21.923773505000042],
              [-72.02501380099994, 21.932562567000048],
              [-72.03624426999994, 21.938788153000075],
              [-72.03180904899995, 21.946478583000044],
              [-72.0254613919999, 21.95258209800005],
              [-72.01744544199994, 21.95693594000005],
              [-72.00829016799992, 21.95921458500004],
              [-71.94994055899991, 21.95921458500004],
              [-71.94399980399993, 21.95807526200008],
              [-71.93049068899995, 21.952948309000078],
              [-71.92267818899995, 21.95180898600006],
              [-71.91104081899994, 21.948431708000044],
              [-71.90876217399995, 21.94049713700008],
              [-71.91209876199991, 21.925116278000075],
              [-71.90339107999995, 21.866522528000075],
              [-71.88857988199993, 21.846177476000037],
              [-71.85741126199991, 21.84316640800006],
              [-71.87730872299994, 21.82831452000005],
              [-71.89464270699995, 21.832180080000057],
              [-71.90965735599991, 21.84316640800006],
              [-71.92267818899995, 21.849351304000038],
              [-71.93106035099993, 21.85187409100007],
              [-71.94298255099994, 21.85814036700009],
              [-71.95425370999993, 21.866929429000038],
              [-71.96051998599995, 21.876695054000038],
              [-71.95921790299991, 21.889797268000052],
              [-71.94383704299992, 21.91315338700008],
              [-71.94001217399995, 21.925116278000075],
              [-71.94758053299995, 21.94245026200008],
              [-71.96401933499993, 21.933417059000078],
              [-71.98786373599995, 21.90778229400007],
              [-71.99193274599992, 21.89988841400009],
              [-72.00161699099993, 21.897772528000075],
              [-72.0130102199999, 21.89988841400009],
              [-72.02196204299992, 21.90460846600007],
            ],
          ],
          [
            [
              [-71.13809160099993, 21.513617255000042],
              [-71.13036048099991, 21.498114325000074],
              [-71.12889563699991, 21.47223541900007],
              [-71.13361568899995, 21.446478583000044],
              [-71.14488684799994, 21.43162669500009],
              [-71.1516820949999, 21.45058828300006],
              [-71.15099036399994, 21.47284577000005],
              [-71.14549719999991, 21.495062567000048],
              [-71.13809160099993, 21.513617255000042],
            ],
          ],
          [
            [
              [-71.68781490799995, 21.29979075700004],
              [-71.68032792899993, 21.304429429000038],
              [-71.67406165299991, 21.30654531500005],
              [-71.67861894399994, 21.298895575000074],
              [-71.69587154899995, 21.29010651200008],
              [-71.69908606699994, 21.291937567000048],
              [-71.68781490799995, 21.29979075700004],
            ],
          ],
          [
            [
              [-71.63434811099995, 21.318793036000045],
              [-71.62881425699993, 21.324367580000057],
              [-71.6282445949999, 21.310248114000046],
              [-71.63467363199993, 21.29450104400007],
              [-71.64085852799991, 21.30296458500004],
              [-71.63434811099995, 21.318793036000045],
            ],
          ],
          [
            [
              [-71.20982825399994, 21.34137604400007],
              [-71.20006262899994, 21.341050523000035],
              [-71.19249426999994, 21.33502838700008],
              [-71.2012426419999, 21.323065497000073],
              [-71.21369381399995, 21.310614325000074],
              [-71.21922766799992, 21.31435781500005],
              [-71.21426347599993, 21.332831122000073],
              [-71.20982825399994, 21.34137604400007],
            ],
          ],
          [
            [
              [-71.49828040299991, 21.56940338700008],
              [-71.49624589799993, 21.563421942000048],
              [-71.49718176999994, 21.53025950700004],
              [-71.49632727799991, 21.50739166900007],
              [-71.50426184799994, 21.49404531500005],
              [-71.52098548099991, 21.48932526200008],
              [-71.53758704299992, 21.49945709800005],
              [-71.53970292899993, 21.516546942000048],
              [-71.52782141799992, 21.524318752000056],
              [-71.51573645699995, 21.522691148000035],
              [-71.50894120999993, 21.527818101000037],
              [-71.50877844999991, 21.551662502000056],
              [-71.50157630099994, 21.56907786700009],
              [-71.49828040299991, 21.56940338700008],
            ],
          ],
          [
            [
              [-72.12490800699993, 21.854641018000052],
              [-72.11949622299994, 21.857896226000037],
              [-72.11628170499995, 21.85374583500004],
              [-72.12437903599994, 21.846869208000044],
              [-72.13304602799991, 21.84764232000009],
              [-72.12490800699993, 21.854641018000052],
            ],
          ],
          [
            [
              [-72.09479732999995, 21.882513739000046],
              [-72.08950761599993, 21.88544342700004],
              [-72.08702551999994, 21.880926825000074],
              [-72.08706620999993, 21.872748114000046],
              [-72.09300696499992, 21.86717357000009],
              [-72.0996801419999, 21.864569403000075],
              [-72.10155188699991, 21.871649481000077],
              [-72.09479732999995, 21.882513739000046],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'St. Pierre and Miquelon',
        iso3: 'SPM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-56.150949673999946, 46.79364655200004],
              [-56.15648352799991, 46.78925202000005],
              [-56.16079667899993, 46.784369208000044],
              [-56.16380774599992, 46.77887604400007],
              [-56.16519120999993, 46.77252838700008],
              [-56.15021725199995, 46.766913153000075],
              [-56.14476477799991, 46.765692450000074],
              [-56.168080206999946, 46.75726959800005],
              [-56.19579016799992, 46.75275299700007],
              [-56.221913214999915, 46.75462474200003],
              [-56.240305141999954, 46.765692450000074],
              [-56.21890214799993, 46.788275458000044],
              [-56.20750891799992, 46.79783763200004],
              [-56.19188391799992, 46.806626695000034],
              [-56.180246548999946, 46.80955638200004],
              [-56.161366339999915, 46.81159088700008],
              [-56.14753170499995, 46.807847398000035],
              [-56.150949673999946, 46.79364655200004],
            ],
          ],
          [
            [
              [-56.27379309799994, 46.89545319200005],
              [-56.23550370999993, 46.87201569200005],
              [-56.249256964999915, 46.84227122600004],
              [-56.28929602799991, 46.813788153000075],
              [-56.346262173999946, 46.78359609600005],
              [-56.35850989499994, 46.78074778900009],
              [-56.37067623599995, 46.78620026200008],
              [-56.37791907499991, 46.79901764500005],
              [-56.375070766999954, 46.80695221600007],
              [-56.375111456999946, 46.81395091400009],
              [-56.39110266799992, 46.82404205900008],
              [-56.39635169199994, 46.836371161000045],
              [-56.37987219999991, 46.85150788000004],
              [-56.34276282499991, 46.87555573100008],
              [-56.32827714799993, 46.914943752000056],
              [-56.336781378999945, 46.95425039300005],
              [-56.38499915299991, 47.03563060100004],
              [-56.38817298099991, 47.05182526200008],
              [-56.39110266799992, 47.08783600500004],
              [-56.396595831999946, 47.10398997600004],
              [-56.39590410099993, 47.11359284100007],
              [-56.38768469999991, 47.12539297100005],
              [-56.37743079299992, 47.13426341400009],
              [-56.36628170499995, 47.14020416900007],
              [-56.35464433499993, 47.14126211100006],
              [-56.34276282499991, 47.135646877000056],
              [-56.361317511999914, 47.12596263200004],
              [-56.37169348899994, 47.11615631700005],
              [-56.371164516999954, 47.105902411000045],
              [-56.35700436099995, 47.09467194200005],
              [-56.34032141799992, 47.089056708000044],
              [-56.304798956999946, 47.08315664300005],
              [-56.25332597599993, 47.05369700700004],
              [-56.25169837099992, 47.04389069200005],
              [-56.25230872299994, 47.03021881700005],
              [-56.25601152299993, 47.018011786000045],
              [-56.26935787699995, 47.00844961100006],
              [-56.27379309799994, 46.99909088700008],
              [-56.28034420499995, 46.98969147300005],
              [-56.291859503999945, 46.98541901200008],
              [-56.29759680899991, 46.987534898000035],
              [-56.30028235599991, 46.992254950000074],
              [-56.301991339999915, 46.996975002000056],
              [-56.30516516799992, 46.99909088700008],
              [-56.312163865999935, 46.99835846600007],
              [-56.32970130099994, 46.992254950000074],
              [-56.34357662699995, 46.99591705900008],
              [-56.35020911399994, 46.99461497600004],
              [-56.350168423999946, 46.98541901200008],
              [-56.345773891999954, 46.97992584800005],
              [-56.33971106699994, 46.97907135600008],
              [-56.33385169199994, 46.97955963700008],
              [-56.32591712099992, 46.97646719000005],
              [-56.32005774599992, 46.97638580900008],
              [-56.313710089999915, 46.97565338700008],
              [-56.308583136999914, 46.97174713700008],
              [-56.306752081999946, 46.96499258000006],
              [-56.30968176999994, 46.960150458000044],
              [-56.31387285099993, 46.956691799000055],
              [-56.31602942599994, 46.95380280200004],
              [-56.31602942599994, 46.91278717700004],
              [-56.311756964999915, 46.90013255400004],
              [-56.30117753799993, 46.89630768400008],
              [-56.27379309799994, 46.89545319200005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Trinidad and Tobago',
        iso3: 'TTO',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-61.00226803299995, 10.699367580000057],
              [-61.02086341099994, 10.702704169000071],
              [-61.03270423099991, 10.683539130000042],
              [-61.03807532499991, 10.653631903000075],
              [-61.03697669199994, 10.62490469000005],
              [-61.017567511999914, 10.564113674000055],
              [-61.01353919199994, 10.534491278000075],
              [-61.04246985599991, 10.509955145000049],
              [-61.041859503999945, 10.48187897300005],
              [-61.03844153599994, 10.463649807000081],
              [-61.02814693899995, 10.40851471600007],
              [-61.02301998599995, 10.39484284100007],
              [-61.01634680899991, 10.382147528000075],
              [-60.99844316299993, 10.355943101000037],
              [-60.96129309799994, 10.330023505000042],
              [-60.990223761999914, 10.299261786000045],
              [-61.002797003999945, 10.247544664000088],
              [-61.00332597599993, 10.189113674000055],
              [-60.99600175699993, 10.138251044000071],
              [-61.01748613199993, 10.14288971600007],
              [-61.041574673999946, 10.135646877000056],
              [-61.06432044199994, 10.12181224200009],
              [-61.082020636999914, 10.10687897300005],
              [-61.099680141999954, 10.095200914000088],
              [-61.1223852199999, 10.086818752000056],
              [-61.16734778599994, 10.07615794500009],
              [-61.17764238199993, 10.07518138200004],
              [-61.19163977799991, 10.073797919000071],
              [-61.25300045499995, 10.083644924000055],
              [-61.27501380099994, 10.081732489000046],
              [-61.33869381399995, 10.06932200700004],
              [-61.41746985599991, 10.07615794500009],
              [-61.50308183499993, 10.06932200700004],
              [-61.50413977799991, 10.069525458000044],
              [-61.54409745999993, 10.07615794500009],
              [-61.55345618399991, 10.073879299000055],
              [-61.58193925699993, 10.062567450000074],
              [-61.59312903599994, 10.061428127000056],
              [-61.61278235599991, 10.056789455000057],
              [-61.62291419199994, 10.05565013200004],
              [-61.63703365799995, 10.057806708000044],
              [-61.64696204299992, 10.062974351000037],
              [-61.65607662699995, 10.069647528000075],
              [-61.66759192599994, 10.07615794500009],
              [-61.68618730399993, 10.081610419000071],
              [-61.706695115999935, 10.08397044500009],
              [-61.79332434799994, 10.084133205000057],
              [-61.81704667899993, 10.081366278000075],
              [-61.835194464999915, 10.072739976000037],
              [-61.84984290299991, 10.061468817000048],
              [-61.86929277299993, 10.050034898000092],
              [-61.88975989499994, 10.042303778000075],
              [-61.90721594999991, 10.04205963700008],
              [-61.92870032499991, 10.056463934000078],
              [-61.91893469999991, 10.070013739000046],
              [-61.886708136999914, 10.086737372000073],
              [-61.88194739499994, 10.09048086100006],
              [-61.87096106699994, 10.093817450000074],
              [-61.83853105399993, 10.09983958500004],
              [-61.83193925699993, 10.106146552000041],
              [-61.821522589999915, 10.121161200000074],
              [-61.805897589999915, 10.132879950000074],
              [-61.789173956999946, 10.14093659100007],
              [-61.71206620999993, 10.163641669000071],
              [-61.70738684799994, 10.16587962400007],
              [-61.66905676999994, 10.184027411000045],
              [-61.63931230399993, 10.21006907800006],
              [-61.638783331999946, 10.210516669000071],
              [-61.63963782499991, 10.240668036000045],
              [-61.626942511999914, 10.247259833000044],
              [-61.61180579299992, 10.24750397300005],
              [-61.56012936099995, 10.238714911000045],
              [-61.52078202999991, 10.24013906500005],
              [-61.51781165299991, 10.240261135000083],
              [-61.50658118399991, 10.240668036000045],
              [-61.49526933499993, 10.245021877000056],
              [-61.48192298099991, 10.255682684000078],
              [-61.46983801999994, 10.269273179000038],
              [-61.462147589999915, 10.28221263200004],
              [-61.45836341099994, 10.30219147300005],
              [-61.45962480399993, 10.309719143000052],
              [-61.46125240799995, 10.31899648600006],
              [-61.46629798099991, 10.335191148000092],
              [-61.46898352799991, 10.353949286000045],
              [-61.470814581999946, 10.35936107000009],
              [-61.47956295499995, 10.366603908000059],
              [-61.48265540299991, 10.37099844000005],
              [-61.48306230399993, 10.376450914000088],
              [-61.48033606699994, 10.37791575700004],
              [-61.47691809799994, 10.378607489000046],
              [-61.47520911399994, 10.381537177000041],
              [-61.47618567599994, 10.38930898600006],
              [-61.48200436099995, 10.408880927000041],
              [-61.48574785099993, 10.415716864000046],
              [-61.487945115999935, 10.430121161000045],
              [-61.48224850199995, 10.44985586100006],
              [-61.46898352799991, 10.480861721000053],
              [-61.46231035099993, 10.518866278000075],
              [-61.462147589999915, 10.558172919000071],
              [-61.47227942599994, 10.594875393000052],
              [-61.49624589799993, 10.62490469000005],
              [-61.48888098899994, 10.631048895000049],
              [-61.52879798099991, 10.657904364000046],
              [-61.54906165299991, 10.66705963700008],
              [-61.57762610599991, 10.67991771000004],
              [-61.59902910099993, 10.684393622000073],
              [-61.65001380099994, 10.68781159100007],
              [-61.656361456999946, 10.68976471600007],
              [-61.66128495999993, 10.695135809000078],
              [-61.66759192599994, 10.706773179000038],
              [-61.61563066299993, 10.74217357000009],
              [-61.602121548999946, 10.747748114000046],
              [-61.56114661399994, 10.744330145000049],
              [-61.51512610599991, 10.75495026200008],
              [-61.49010169199994, 10.75462474200009],
              [-61.48574785099993, 10.754584052000041],
              [-61.473215298999946, 10.760239976000037],
              [-61.46556555899991, 10.77024974200009],
              [-61.46043860599991, 10.774359442000048],
              [-61.45531165299991, 10.76203034100007],
              [-61.44786536399994, 10.76203034100007],
              [-61.44758053299995, 10.765366929000038],
              [-61.44786536399994, 10.77570221600007],
              [-61.44172115799995, 10.77570221600007],
              [-61.44102942599994, 10.770656643000052],
              [-61.43936113199993, 10.768011786000045],
              [-61.43700110599991, 10.76585521000004],
              [-61.43423417899993, 10.76203034100007],
              [-61.44172115799995, 10.754584052000041],
              [-61.43342037699995, 10.756537177000041],
              [-61.42756100199995, 10.76117584800005],
              [-61.42365475199995, 10.76593659100007],
              [-61.4212133449999, 10.768255927000041],
              [-61.40192623599995, 10.768866278000075],
              [-61.400054490999935, 10.768255927000041],
              [-61.391835089999915, 10.77562083500004],
              [-61.37291419199994, 10.79751211100006],
              [-61.36656653599994, 10.80296458500004],
              [-61.35260982999995, 10.804103908000059],
              [-61.34911048099991, 10.804388739000046],
              [-61.296131964999915, 10.798041083000044],
              [-61.18008378799993, 10.797552802000041],
              [-61.17157955599993, 10.803941148000092],
              [-61.154855923999946, 10.816473700000074],
              [-61.096547003999945, 10.823431708000044],
              [-61.07852128799993, 10.830959377000056],
              [-60.94884192599994, 10.845282294000071],
              [-60.90729732999995, 10.837144273000092],
              [-60.949777798999946, 10.763495184000078],
              [-61.00226803299995, 10.699367580000057],
            ],
          ],
          [
            [
              [-60.530506964999915, 11.351060289000088],
              [-60.52306067599994, 11.34365469000005],
              [-60.52208411399994, 11.318833726000037],
              [-60.52554277299993, 11.28815338700008],
              [-60.53302975199995, 11.266506252000056],
              [-60.544178839999915, 11.269110419000071],
              [-60.55036373599995, 11.269110419000071],
              [-60.55650794199994, 11.254095770000049],
              [-60.565297003999945, 11.252427476000037],
              [-60.57526607999995, 11.25576406500005],
              [-60.58511308499993, 11.255519924000055],
              [-60.58706620999993, 11.251125393000052],
              [-60.60204016799992, 11.23143138200004],
              [-60.605580206999946, 11.230658270000049],
              [-60.62877356699994, 11.216538804000038],
              [-60.6360570949999, 11.210760809000078],
              [-60.64712480399993, 11.20416901200008],
              [-60.65977942599994, 11.204291083000044],
              [-60.671864386999914, 11.206732489000046],
              [-60.681304490999935, 11.207098700000074],
              [-60.74176998599995, 11.177069403000075],
              [-60.75951087099992, 11.17291901200008],
              [-60.7864477199999, 11.149969794000071],
              [-60.80333411399994, 11.143255927000041],
              [-60.81041419199994, 11.15924713700008],
              [-60.825428839999915, 11.15180084800005],
              [-60.83934485599991, 11.154120184000078],
              [-60.84752356699994, 11.16396719000005],
              [-60.84520423099991, 11.17914459800005],
              [-60.83674068899995, 11.183335679000038],
              [-60.82286536399994, 11.18553294500009],
              [-60.80992591099994, 11.190659898000092],
              [-60.80426998599995, 11.203680731000077],
              [-60.79434160099993, 11.216620184000078],
              [-60.70970618399991, 11.271307684000078],
              [-60.69163977799991, 11.288885809000078],
              [-60.681304490999935, 11.296454169000071],
              [-60.66860917899993, 11.302923895000049],
              [-60.63581295499995, 11.314846096000053],
              [-60.60757402299993, 11.320705471000053],
              [-60.595814581999946, 11.327297268000052],
              [-60.583648240999935, 11.32953522300005],
              [-60.56773841099994, 11.32029857000009],
              [-60.56037350199995, 11.321193752000056],
              [-60.54133053299995, 11.343410549000055],
              [-60.530506964999915, 11.351060289000088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Grenada',
        iso3: 'GRD',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-61.612945115999935, 12.214422919000071],
              [-61.60456295499995, 12.197455145000049],
              [-61.602772589999915, 12.182928778000075],
              [-61.606312628999945, 12.13377513200004],
              [-61.6087133449999, 12.126776434000078],
              [-61.61310787699995, 12.11985911700009],
              [-61.61978105399993, 12.10455963700008],
              [-61.61945553299995, 12.09674713700008],
              [-61.613840298999946, 12.08038971600007],
              [-61.61636308499993, 12.077297268000052],
              [-61.62157141799992, 12.07493724200009],
              [-61.62450110599991, 12.069037177000041],
              [-61.62572180899991, 12.061224677000041],
              [-61.62604732999995, 12.05304596600007],
              [-61.63158118399991, 12.044094143000052],
              [-61.67442786399994, 12.022040106000077],
              [-61.67442786399994, 12.029486395000049],
              [-61.68297278599994, 12.02537669500009],
              [-61.68936113199993, 12.01976146000004],
              [-61.693430141999954, 12.012274481000077],
              [-61.69493567599994, 12.002834377000056],
              [-61.70425370999993, 12.00454336100006],
              [-61.71324622299994, 12.00726959800005],
              [-61.72175045499995, 12.011053778000075],
              [-61.72964433499993, 12.015814520000049],
              [-61.73997962099992, 12.00690338700008],
              [-61.75694739499994, 12.003404039000088],
              [-61.77554277299993, 12.004339911000045],
              [-61.79051673099991, 12.008368231000077],
              [-61.755848761999914, 12.03025950700004],
              [-61.74950110599991, 12.036322333000044],
              [-61.74596106699994, 12.050930080000057],
              [-61.74885006399995, 12.062648830000057],
              [-61.75377356699994, 12.074164130000042],
              [-61.756418423999946, 12.087836005000042],
              [-61.75104732999995, 12.11009349200009],
              [-61.73029537699995, 12.149318752000056],
              [-61.72964433499993, 12.16665273600006],
              [-61.67145748599995, 12.236070054000038],
              [-61.650502081999946, 12.239732164000088],
              [-61.62767493399991, 12.236721096000053],
              [-61.606027798999946, 12.22337474200009],
              [-61.606678839999915, 12.220282294000071],
              [-61.612945115999935, 12.214422919000071],
            ],
          ],
          [
            [
              [-61.42804928299995, 12.454657294000071],
              [-61.44566809799994, 12.459784247000073],
              [-61.462554490999935, 12.455145575000074],
              [-61.47923743399991, 12.44672272300005],
              [-61.49624589799993, 12.440375067000048],
              [-61.49278723899994, 12.446478583000044],
              [-61.48607337099992, 12.462225653000075],
              [-61.48265540299991, 12.468329169000071],
              [-61.48574785099993, 12.468817450000074],
              [-61.49624589799993, 12.468329169000071],
              [-61.49478105399993, 12.472316799000055],
              [-61.48888098899994, 12.482001044000071],
              [-61.46727454299992, 12.47557200700004],
              [-61.454335089999915, 12.49282461100006],
              [-61.443470831999946, 12.516546942000048],
              [-61.42804928299995, 12.529730536000045],
              [-61.42162024599992, 12.513373114000046],
              [-61.42332923099991, 12.49518463700008],
              [-61.427398240999935, 12.475409247000073],
              [-61.42804928299995, 12.454657294000071],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'St. Vin. and Gren.',
        iso3: 'VCT',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-61.19399980399993, 13.036851304000038],
              [-61.2083227199999, 13.023260809000078],
              [-61.22642981699994, 12.99315013200004],
              [-61.24242102799991, 12.982245184000078],
              [-61.23497473899994, 12.982245184000078],
              [-61.24242102799991, 12.974798895000049],
              [-61.24754798099991, 12.982123114000046],
              [-61.25548255099994, 12.986721096000053],
              [-61.265614386999914, 12.988714911000045],
              [-61.27721106699994, 12.988470770000049],
              [-61.27721106699994, 12.995917059000078],
              [-61.26231848899994, 12.991359768000052],
              [-61.23961341099994, 12.995794989000046],
              [-61.2395727199999, 13.003851630000042],
              [-61.246205206999946, 13.011216539000088],
              [-61.249256964999915, 13.01634349200009],
              [-61.24095618399991, 13.024237372000073],
              [-61.21312415299991, 13.041815497000073],
              [-61.20148678299995, 13.051174221000053],
              [-61.200062628999945, 13.047308661000045],
              [-61.19961503799993, 13.04368724200009],
              [-61.19823157499991, 13.040228583000044],
              [-61.19399980399993, 13.036851304000038],
            ],
          ],
          [
            [
              [-61.16734778599994, 13.146063544000071],
              [-61.185210740999935, 13.132513739000046],
              [-61.210194464999915, 13.144191799000055],
              [-61.27135169199994, 13.18650950700004],
              [-61.279367641999954, 13.21588776200008],
              [-61.2766820949999, 13.24990469000005],
              [-61.262928839999915, 13.27643463700008],
              [-61.26553300699993, 13.280218817000048],
              [-61.270375128999945, 13.29010651200008],
              [-61.243397589999915, 13.29437897300005],
              [-61.23184160099993, 13.316961981000077],
              [-61.22496497299994, 13.345770575000074],
              [-61.21202551999994, 13.368882554000038],
              [-61.19912675699993, 13.377020575000074],
              [-61.18712317599994, 13.380438544000071],
              [-61.17638098899994, 13.38076406500005],
              [-61.151234503999945, 13.376776434000078],
              [-61.14403235599991, 13.37409088700008],
              [-61.14004472599993, 13.367377020000049],
              [-61.13377844999991, 13.352769273000092],
              [-61.123931443999936, 13.308254299000055],
              [-61.12441972599993, 13.246975002000056],
              [-61.1380102199999, 13.186916408000059],
              [-61.16734778599994, 13.146063544000071],
            ],
          ],
          [
            [
              [-61.441395636999914, 12.607896226000037],
              [-61.429351365999935, 12.600490627000056],
              [-61.426625128999945, 12.591864325000074],
              [-61.43272864499994, 12.587836005000042],
              [-61.44322669199994, 12.585150458000044],
              [-61.455922003999945, 12.586086330000057],
              [-61.459828253999945, 12.591457424000055],
              [-61.45567786399994, 12.596584377000056],
              [-61.45466061099995, 12.600775458000044],
              [-61.45677649599992, 12.604437567000048],
              [-61.45555579299992, 12.607082424000055],
              [-61.44831295499995, 12.609930731000077],
              [-61.441395636999914, 12.607896226000037],
            ],
          ],
          [
            [
              [-61.31940670499995, 12.733791408000059],
              [-61.31631425699993, 12.730047919000071],
              [-61.31436113199993, 12.720892645000049],
              [-61.31969153599994, 12.71393463700008],
              [-61.3255102199999, 12.708197333000044],
              [-61.32835852799991, 12.69944896000004],
              [-61.33389238199993, 12.69358958500004],
              [-61.34410559799994, 12.693060614000046],
              [-61.35309811099995, 12.696478583000044],
              [-61.35065670499995, 12.69953034100007],
              [-61.33926347599993, 12.701971747000073],
              [-61.333973761999914, 12.708563544000071],
              [-61.33584550699993, 12.71743398600006],
              [-61.33535722599993, 12.72719961100006],
              [-61.32632402299993, 12.73314036700009],
              [-61.31940670499995, 12.733791408000059],
            ],
          ],
          [
            [
              [-61.19176184799994, 12.86823151200008],
              [-61.18317623599995, 12.883490302000041],
              [-61.17495683499993, 12.881781317000048],
              [-61.183583136999914, 12.862005927000041],
              [-61.187611456999946, 12.856390692000048],
              [-61.19082597599993, 12.855861721000053],
              [-61.19176184799994, 12.86823151200008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Barbados',
        iso3: 'BRB',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-59.42690995999993, 13.16038646000004],
            [-59.43004309799994, 13.125921942000048],
            [-59.45571855399993, 13.100043036000045],
            [-59.475778774999924, 13.086493231000077],
            [-59.487538214999915, 13.078558661000045],
            [-59.50885982999995, 13.057318427000041],
            [-59.51671301999994, 13.056382554000038],
            [-59.523101365999935, 13.056463934000078],
            [-59.529286261999914, 13.05540599200009],
            [-59.53612219999991, 13.051174221000053],
            [-59.54596920499995, 13.067694403000075],
            [-59.564442511999914, 13.07802969000005],
            [-59.58690344999991, 13.083197333000044],
            [-59.60024980399993, 13.084133205000057],
            [-59.60814368399991, 13.084662177000041],
            [-59.62157141799992, 13.09398021000004],
            [-59.63312740799995, 13.115912177000041],
            [-59.64606686099995, 13.16038646000004],
            [-59.65420488199993, 13.295111395000049],
            [-59.65221106699994, 13.310614325000074],
            [-59.64513098899994, 13.323716539000088],
            [-59.630930141999954, 13.337958075000074],
            [-59.61286373599995, 13.344549872000073],
            [-59.59447180899991, 13.334784247000073],
            [-59.58071855399993, 13.314520575000074],
            [-59.57591712099992, 13.304388739000046],
            [-59.56895911399994, 13.289658921000068],
            [-59.54979407499991, 13.249172268000052],
            [-59.53661048099991, 13.231390692000048],
            [-59.51805579299992, 13.21751536700009],
            [-59.49181067599994, 13.197943427000041],
            [-59.476673956999946, 13.189398505000042],
            [-59.457102016999954, 13.183172919000071],
            [-59.43862870999993, 13.17487213700008],
            [-59.42690995999993, 13.16038646000004],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Saint Lucia',
        iso3: 'LCA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-60.886789516999954, 14.01007721600007],
            [-60.88296464799993, 13.980617580000057],
            [-60.88304602799991, 13.954413153000075],
            [-60.895090298999946, 13.877346096000053],
            [-60.89220130099994, 13.833197333000044],
            [-60.90461178299995, 13.78424713700008],
            [-60.90729732999995, 13.77732982000009],
            [-60.91030839799993, 13.77610911700009],
            [-60.92284094999991, 13.772691148000092],
            [-60.92711341099994, 13.769924221000053],
            [-60.931752081999946, 13.760321356000077],
            [-60.94078528599994, 13.72211334800005],
            [-60.94701087099992, 13.716294664000088],
            [-60.950103318999936, 13.714667059000078],
            [-60.955067511999914, 13.714667059000078],
            [-60.97337805899991, 13.73899974200009],
            [-61.0481664699999, 13.767320054000038],
            [-61.06493079299992, 13.786932684000078],
            [-61.06810462099992, 13.792181708000044],
            [-61.074208136999914, 13.79873281500005],
            [-61.078114386999914, 13.806301174000055],
            [-61.071156378999945, 13.821966864000046],
            [-61.07005774599992, 13.832098700000074],
            [-61.071156378999945, 13.85179271000004],
            [-61.07274329299992, 13.858221747000073],
            [-61.07559160099993, 13.86326732000009],
            [-61.078114386999914, 13.869614976000037],
            [-61.07852128799993, 13.879787502000056],
            [-61.07591712099992, 13.890366929000038],
            [-61.06688391799992, 13.909002997000073],
            [-61.06493079299992, 13.917303778000075],
            [-61.059478318999936, 13.931219794000071],
            [-61.03555253799993, 13.964911200000074],
            [-61.026600714999915, 13.98737213700008],
            [-61.00226803299995, 14.023138739000046],
            [-60.99705969999991, 14.027167059000078],
            [-60.98729407499991, 14.032538153000075],
            [-60.98232988199993, 14.03733958500004],
            [-60.97996985599991, 14.043524481000077],
            [-60.97606360599991, 14.06118398600006],
            [-60.97207597599993, 14.068101304000038],
            [-60.94762122299994, 14.10228099200009],
            [-60.93346106699994, 14.111883856000077],
            [-60.914133266999954, 14.10569896000004],
            [-60.91860917899993, 14.088446356000077],
            [-60.91193600199995, 14.079494533000059],
            [-60.90103105399993, 14.073391018000052],
            [-60.89297441299993, 14.06468333500004],
            [-60.89020748599995, 14.052232164000088],
            [-60.886789516999954, 14.01007721600007],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Dominica',
        iso3: 'DMA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-61.36286373599995, 15.20180898600006],
            [-61.37409420499995, 15.204820054000038],
            [-61.37612870999993, 15.212836005000042],
            [-61.37279212099992, 15.237209377000056],
            [-61.37328040299991, 15.266424872000073],
            [-61.37279212099992, 15.270697333000044],
            [-61.37828528599994, 15.282049872000073],
            [-61.39093990799995, 15.296291408000059],
            [-61.39321855399993, 15.308294989000046],
            [-61.39500891799992, 15.33307526200008],
            [-61.39956620999993, 15.351141669000071],
            [-61.413726365999935, 15.380560614000046],
            [-61.415679490999935, 15.387640692000048],
            [-61.418080206999946, 15.405951239000046],
            [-61.4212133449999, 15.414740302000041],
            [-61.444203253999945, 15.436835028000075],
            [-61.44786536399994, 15.445135809000078],
            [-61.449777798999946, 15.454657294000071],
            [-61.45425370999993, 15.46482982000009],
            [-61.46003170499995, 15.47288646000004],
            [-61.46556555899991, 15.476141669000071],
            [-61.47207597599993, 15.481390692000048],
            [-61.474273240999935, 15.493475653000075],
            [-61.47520911399994, 15.517767645000049],
            [-61.479359503999945, 15.525458075000074],
            [-61.48485266799992, 15.53034088700008],
            [-61.48892167899993, 15.535711981000077],
            [-61.48888098899994, 15.545070705000057],
            [-61.48399817599994, 15.551581122000073],
            [-61.46727454299992, 15.562974351000037],
            [-61.462147589999915, 15.57298411700009],
            [-61.46906490799995, 15.574286200000074],
            [-61.48119055899991, 15.578558661000045],
            [-61.48888098899994, 15.579250393000052],
            [-61.48062089799993, 15.591009833000044],
            [-61.46898352799991, 15.63385651200008],
            [-61.449208136999914, 15.633083401000079],
            [-61.43724524599992, 15.632635809000078],
            [-61.42593339799993, 15.628485419000071],
            [-61.413726365999935, 15.619574286000045],
            [-61.39757239499994, 15.596625067000048],
            [-61.38463294199994, 15.588364976000037],
            [-61.36974036399994, 15.59593333500004],
            [-61.35732988199993, 15.59829336100006],
            [-61.30768795499995, 15.579250393000052],
            [-61.305897589999915, 15.572455145000049],
            [-61.29954993399991, 15.557196356000077],
            [-61.289621548999946, 15.540961005000042],
            [-61.284047003999945, 15.531398830000057],
            [-61.26862545499995, 15.509914455000057],
            [-61.26716061099995, 15.50779857000009],
            [-61.25767981699994, 15.472601630000042],
            [-61.25601152299993, 15.435939846000053],
            [-61.262928839999915, 15.407904364000046],
            [-61.258371548999946, 15.406317450000074],
            [-61.25422115799995, 15.40298086100006],
            [-61.249256964999915, 15.401068427000041],
            [-61.255523240999935, 15.364569403000075],
            [-61.25405839799993, 15.33266836100006],
            [-61.25373287699995, 15.324693101000037],
            [-61.25666256399995, 15.285345770000049],
            [-61.27721106699994, 15.25023021000004],
            [-61.284413214999915, 15.244818427000041],
            [-61.28929602799991, 15.24359772300005],
            [-61.29320227799991, 15.243882554000038],
            [-61.30337480399993, 15.242580471000053],
            [-61.31187903599994, 15.244533596000053],
            [-61.31818600199995, 15.243394273000092],
            [-61.32359778599994, 15.23859284100007],
            [-61.32872473899994, 15.22557200700004],
            [-61.342681443999936, 15.219671942000048],
            [-61.34593665299991, 15.21234772300005],
            [-61.34638424399992, 15.211696682000081],
            [-61.35073808499993, 15.205145575000074],
            [-61.36286373599995, 15.20180898600006],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'U.S. Minor Outlying Is.',
        iso3: 'UMI',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-169.5302628249999, 16.760199286000045],
              [-169.52082271999993, 16.762600002000056],
              [-169.51740475199992, 16.76243724200009],
              [-169.52350826699993, 16.75849030200004],
              [-169.52839107999992, 16.75604889500005],
              [-169.53327389199993, 16.754787502000056],
              [-169.53917395699992, 16.754461981000077],
              [-169.53722083199992, 16.75649648600006],
              [-169.5325821609999, 16.75849030200004],
              [-169.5302628249999, 16.760199286000045],
            ],
          ],
          [
            [
              [-160.02997799399992, -0.376153252999927],
              [-160.0089005199999, -0.372491143999923],
              [-160.0124405589999, -0.38209400799991],
              [-160.0247696609999, -0.388767184999949],
              [-160.02997799399992, -0.376153252999927],
            ],
          ],
          [
            [
              [-176.4858292309999, 0.196519273000092],
              [-176.48212643099993, 0.196682033000059],
              [-176.4791153639999, 0.19790273600006],
              [-176.47687740799992, 0.197455145000049],
              [-176.47529049399992, 0.193101304000038],
              [-176.47931881399992, 0.190334377000056],
              [-176.48127193899992, 0.191473700000074],
              [-176.48289954299992, 0.194322007000039],
              [-176.4858292309999, 0.196519273000092],
            ],
          ],
          [
            [
              [-176.45954342399992, 0.225897528000075],
              [-176.45917721299992, 0.219224351000094],
              [-176.46393795499992, 0.221869208000044],
              [-176.45954342399992, 0.225897528000075],
            ],
          ],
          [
            [
              [-176.63617916599992, 0.790187893000052],
              [-176.6404923169999, 0.801988023000092],
              [-176.6400447259999, 0.803534247000073],
              [-176.6396378249999, 0.804958401000079],
              [-176.6390274729999, 0.80695221600007],
              [-176.6360977859999, 0.803412177000041],
              [-176.63617916599992, 0.790187893000052],
            ],
          ],
          [
            [
              [166.61939537900003, 19.281642971000053],
              [166.629730665, 19.282416083000044],
              [166.63819420700008, 19.286444403000075],
              [166.64087975400003, 19.29401276200008],
              [166.6347762380001, 19.30573151200008],
              [166.64812259200005, 19.297756252000056],
              [166.6523543630001, 19.28424713700008],
              [166.64421634200005, 19.27558014500005],
              [166.61939537900003, 19.281642971000053],
            ],
          ],
          [
            [
              [-177.32892818899992, 28.211086330000057],
              [-177.3228653639999, 28.20766836100006],
              [-177.32115637899992, 28.205877997000073],
              [-177.32489986899992, 28.20498281500005],
              [-177.3352758449999, 28.204291083000044],
              [-177.32892818899992, 28.211086330000057],
            ],
          ],
          [
            [
              [-177.3576554029999, 28.21442291900007],
              [-177.36445064999992, 28.207586981000077],
              [-177.3721817699999, 28.202337958000044],
              [-177.3807266919999, 28.198919989000046],
              [-177.3895971339999, 28.197658596000053],
              [-177.38524329299992, 28.206976630000042],
              [-177.37800045499992, 28.212836005000042],
              [-177.3686417309999, 28.215318101000037],
              [-177.3576554029999, 28.21442291900007],
            ],
          ],
          [
            [
              [-169.5323380199999, 16.73305898600006],
              [-169.52240963399993, 16.732163804000038],
              [-169.54169674399992, 16.721909898000092],
              [-169.54735266799992, 16.72101471600007],
              [-169.54950924399992, 16.723456122000073],
              [-169.54767818899992, 16.727362372000073],
              [-169.5323380199999, 16.73305898600006],
            ],
          ],
          [
            [
              [-169.5136612619999, 16.743963934000078],
              [-169.5136612619999, 16.74559153900009],
              [-169.51276607999992, 16.74433014500005],
              [-169.5136612619999, 16.743963934000078],
            ],
          ],
          [
            [
              [-75.02432206899994, 18.417263088000084],
              [-75.02106686099995, 18.415635484000063],
              [-75.01073157499991, 18.415635484000063],
              [-75.01024329299992, 18.41514720300006],
              [-75.00698808499993, 18.41514720300006],
              [-75.00373287699995, 18.41079336100006],
              [-75.00263424399992, 18.410223700000074],
              [-75.00263424399992, 18.40643952000005],
              [-75.00263424399992, 18.404771226000037],
              [-75.00316321499992, 18.40371328300006],
              [-75.00316321499992, 18.397731838000084],
              [-75.00531979099992, 18.396104234000063],
              [-75.00698808499993, 18.396104234000063],
              [-75.00804602799991, 18.395005601000037],
              [-75.01073157499991, 18.395005601000037],
              [-75.01183020699995, 18.396104234000063],
              [-75.01508541599992, 18.396104234000063],
              [-75.01618404899995, 18.39667389500005],
              [-75.01781165299991, 18.39667389500005],
              [-75.01891028599994, 18.397731838000084],
              [-75.01891028599994, 18.398830471000053],
              [-75.02049719999991, 18.400417385000083],
              [-75.02049719999991, 18.40261465100008],
              [-75.02375240799995, 18.40643952000005],
              [-75.02375240799995, 18.40696849200009],
              [-75.02594967399995, 18.408026434000078],
              [-75.03083248599995, 18.41347890800006],
              [-75.03026282499991, 18.417263088000084],
              [-75.02432206899994, 18.417263088000084],
            ],
          ],
          [
            [
              [-162.06086178299992, 5.887193101000094],
              [-162.05760657499988, 5.882473049000168],
              [-162.06110592399986, 5.873439846000167],
              [-162.0730688139999, 5.869370834999984],
              [-162.09113521999993, 5.871649481000077],
              [-162.09434973899988, 5.875352281],
              [-162.0907690089999, 5.874823309000135],
              [-162.08706620999988, 5.878241278000019],
              [-162.07506262899994, 5.885524807000081],
              [-162.07819576699993, 5.885402736000174],
              [-162.08271236899986, 5.884182033000172],
              [-162.0873103509999, 5.883856512000136],
              [-162.0938614569999, 5.885809637000193],
              [-162.1002904939999, 5.886419989000046],
              [-162.10362708199992, 5.888576565000164],
              [-162.10171464799987, 5.890244859000177],
              [-162.0713598299999, 5.890163479000194],
              [-162.06086178299992, 5.887193101000094],
            ],
          ],
          [
            [
              [-162.40017656199993, 6.445135809000078],
              [-162.3852839829999, 6.445135809000078],
              [-162.3852839829999, 6.430243231000077],
              [-162.40017656199993, 6.430243231000077],
              [-162.40017656199993, 6.445135809000078],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Montserrat',
        iso3: 'MSR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-62.147368943999936, 16.744289455000057],
            [-62.147694464999915, 16.73704661700009],
            [-62.15176347599993, 16.72451406500005],
            [-62.15078691299993, 16.720363674000055],
            [-62.14757239499994, 16.71588776200008],
            [-62.14391028599994, 16.70897044500009],
            [-62.141184048999946, 16.70184967700004],
            [-62.14053300699993, 16.696478583000044],
            [-62.14403235599991, 16.68821849200009],
            [-62.14976966099994, 16.681789455000057],
            [-62.15782630099994, 16.67731354400007],
            [-62.16787675699993, 16.67536041900007],
            [-62.218861456999946, 16.688706773000092],
            [-62.230132615999935, 16.72760651200008],
            [-62.218861456999946, 16.776312567000048],
            [-62.202015753999945, 16.81932200700004],
            [-62.189442511999914, 16.81443919500009],
            [-62.1829320949999, 16.81273021000004],
            [-62.174672003999945, 16.81313711100006],
            [-62.17931067599994, 16.79450104400007],
            [-62.170033331999946, 16.777004299000055],
            [-62.156320766999954, 16.760321356000077],
            [-62.147368943999936, 16.744289455000057],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Antigua and Barb.',
        iso3: 'ATG',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-61.88361568899995, 17.04901764500005],
              [-61.87922115799995, 17.06045156500005],
              [-61.882801886999914, 17.07021719000005],
              [-61.88243567599994, 17.07880280200004],
              [-61.86620032499991, 17.086859442000048],
              [-61.87336178299995, 17.089544989000046],
              [-61.89415442599994, 17.100531317000048],
              [-61.88312740799995, 17.110500393000052],
              [-61.86538652299993, 17.11782461100006],
              [-61.842355923999946, 17.12441640800006],
              [-61.850453253999945, 17.137640692000048],
              [-61.84878495999993, 17.14948151200008],
              [-61.83967037699995, 17.159857489000046],
              [-61.82526607999995, 17.168768622000073],
              [-61.79336503799993, 17.164943752000056],
              [-61.78066972599993, 17.14716217700004],
              [-61.77301998599995, 17.12653229400007],
              [-61.756418423999946, 17.114162502000056],
              [-61.75544186099995, 17.12303294500009],
              [-61.75275631399995, 17.12889232000009],
              [-61.74331620999993, 17.141506252000056],
              [-61.7376195949999, 17.132961330000057],
              [-61.72984778599994, 17.12799713700008],
              [-61.72008216099994, 17.12636953300006],
              [-61.70860755099994, 17.127834377000056],
              [-61.71349036399994, 17.12254466400009],
              [-61.71629798099991, 17.118801174000055],
              [-61.72052975199995, 17.116115627000056],
              [-61.72964433499993, 17.114162502000056],
              [-61.72508704299992, 17.09983958500004],
              [-61.714833136999914, 17.093085028000075],
              [-61.70164954299992, 17.093451239000046],
              [-61.68809973899994, 17.100531317000048],
              [-61.68065344999991, 17.100531317000048],
              [-61.67552649599992, 17.09560781500005],
              [-61.67210852799991, 17.090643622000073],
              [-61.66759192599994, 17.079413153000075],
              [-61.674387173999946, 17.079901434000078],
              [-61.68814042899993, 17.078924872000073],
              [-61.69493567599994, 17.079413153000075],
              [-61.685658331999946, 17.06826406500005],
              [-61.6770727199999, 17.062933661000045],
              [-61.67218990799995, 17.057562567000048],
              [-61.67442786399994, 17.04588450700004],
              [-61.68569902299993, 17.028550523000092],
              [-61.69701087099992, 17.027818101000037],
              [-61.70995032499991, 17.03416575700004],
              [-61.726226365999935, 17.03847890800006],
              [-61.73399817599994, 17.034857489000046],
              [-61.734364386999914, 17.025783596000053],
              [-61.72964433499993, 17.001166083000044],
              [-61.73713131399995, 16.98924388200004],
              [-61.75352942599994, 16.99681224200009],
              [-61.76976477799991, 17.010972398000092],
              [-61.77684485599991, 17.01854075700004],
              [-61.78359941299993, 17.016913153000075],
              [-61.80406653599994, 17.00731028900009],
              [-61.81786048099991, 17.00495026200008],
              [-61.83869381399995, 17.004828192000048],
              [-61.85171464799993, 17.007635809000078],
              [-61.883656378999945, 17.026271877000056],
              [-61.89037024599992, 17.03538646000004],
              [-61.88361568899995, 17.04901764500005],
            ],
          ],
          [
            [
              [-61.83893795499995, 17.59332916900007],
              [-61.85179602799991, 17.58657461100006],
              [-61.85728919199994, 17.60097890800006],
              [-61.859364386999914, 17.641791083000044],
              [-61.86392167899993, 17.66014232000009],
              [-61.86974036399994, 17.675482489000046],
              [-61.87385006399995, 17.691148179000038],
              [-61.873036261999914, 17.710638739000046],
              [-61.86937415299991, 17.70734284100007],
              [-61.86782792899993, 17.70408763200004],
              [-61.86620032499991, 17.69635651200008],
              [-61.86009680899991, 17.68423086100006],
              [-61.84422766799992, 17.665961005000042],
              [-61.83893795499995, 17.655422268000052],
              [-61.83922278599994, 17.641424872000073],
              [-61.84316972599993, 17.62958405200004],
              [-61.84316972599993, 17.62018463700008],
              [-61.83145097599993, 17.613836981000077],
              [-61.82648678299995, 17.632473049000055],
              [-61.82502193899995, 17.657945054000038],
              [-61.83120683499993, 17.680487372000073],
              [-61.84919186099995, 17.69013092700004],
              [-61.85643469999991, 17.70107656500005],
              [-61.851673956999946, 17.72028229400007],
              [-61.83779863199993, 17.727687893000052],
              [-61.81786048099991, 17.703192450000074],
              [-61.82457434799994, 17.699367580000057],
              [-61.83145097599993, 17.69635651200008],
              [-61.81822669199994, 17.691839911000045],
              [-61.79727128799993, 17.69879791900007],
              [-61.78429114499994, 17.69635651200008],
              [-61.76817786399994, 17.68463776200008],
              [-61.75426184799994, 17.668768622000073],
              [-61.74327551999994, 17.65135325700004],
              [-61.73591061099995, 17.634914455000057],
              [-61.72874915299991, 17.60496653900009],
              [-61.727772589999915, 17.588446356000077],
              [-61.72964433499993, 17.572821356000077],
              [-61.736398891999954, 17.554022528000075],
              [-61.74327551999994, 17.550604559000078],
              [-61.753570115999935, 17.55149974200009],
              [-61.77065995999993, 17.54555898600006],
              [-61.77696692599994, 17.563421942000048],
              [-61.79474850199995, 17.576117255000042],
              [-61.83893795499995, 17.59332916900007],
            ],
          ],
          [
            [
              [-62.345589180022046, 16.93913955217448],
              [-62.34460506906287, 16.94040483769342],
              [-62.343058608984165, 16.940896893173008],
              [-62.342918021704286, 16.938366322135128],
              [-62.343058608984165, 16.935062521057894],
              [-62.34446448178299, 16.932531950020014],
              [-62.34706534646081, 16.931969600900484],
              [-62.34826033833981, 16.93365664825907],
              [-62.34727622738063, 16.93738221117595],
              [-62.345589180022046, 16.93913955217448],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'St. Kitts and Nevis',
        iso3: 'KNA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-62.59923255099994, 17.202948309000078],
              [-62.57843990799995, 17.20254140800006],
              [-62.56037350199995, 17.19672272300005],
              [-62.54649817599994, 17.18378327000005],
              [-62.53844153599994, 17.161932684000078],
              [-62.53726152299993, 17.152899481000077],
              [-62.536773240999935, 17.129706122000073],
              [-62.53844153599994, 17.12099844000005],
              [-62.54356848899994, 17.10887278900009],
              [-62.54759680899991, 17.104641018000052],
              [-62.5657445949999, 17.100531317000048],
              [-62.612172003999945, 17.10415273600006],
              [-62.62637285099993, 17.140692450000074],
              [-62.61864173099991, 17.182806708000044],
              [-62.59923255099994, 17.202948309000078],
            ],
          ],
          [
            [
              [-62.650461391999954, 17.26561107000009],
              [-62.636830206999946, 17.258205471000053],
              [-62.62482662699995, 17.241848049000055],
              [-62.62474524599992, 17.22528717700004],
              [-62.647043423999946, 17.217189846000053],
              [-62.65973873599995, 17.225490627000056],
              [-62.670480923999946, 17.26316966400009],
              [-62.690297003999945, 17.27496979400007],
              [-62.70335852799991, 17.289129950000074],
              [-62.712554490999935, 17.292303778000075],
              [-62.74404863199993, 17.29059479400007],
              [-62.75694739499994, 17.292303778000075],
              [-62.788726365999935, 17.30467357000009],
              [-62.83161373599995, 17.330145575000074],
              [-62.86107337099992, 17.36229075700004],
              [-62.85313880099994, 17.39472077000005],
              [-62.84923255099994, 17.398138739000046],
              [-62.846547003999945, 17.39996979400007],
              [-62.84357662699995, 17.40106842700004],
              [-62.83885657499991, 17.402167059000078],
              [-62.82664954299992, 17.407171942000048],
              [-62.822336391999954, 17.410101630000042],
              [-62.819569464999915, 17.415838934000078],
              [-62.719960089999915, 17.358547268000052],
              [-62.69546464799993, 17.333238023000092],
              [-62.67813066299993, 17.292222398000092],
              [-62.666859503999945, 17.273504950000074],
              [-62.650461391999954, 17.26561107000009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'U.S. Virgin Is.',
        iso3: 'VIR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-64.55939693899995, 17.751613674000055],
              [-64.58519446499992, 17.748968817000048],
              [-64.60667883999992, 17.742254950000074],
              [-64.64879309799994, 17.72370026200008],
              [-64.67052161399994, 17.717230536000045],
              [-64.87637285099993, 17.689113674000055],
              [-64.89517167899993, 17.682766018000052],
              [-64.88784745999993, 17.69989655200004],
              [-64.88662675699993, 17.71442291900007],
              [-64.88768469999991, 17.75527578300006],
              [-64.88463294199994, 17.76788971600007],
              [-64.87645423099991, 17.775864976000037],
              [-64.83869381399995, 17.764837958000044],
              [-64.81745357999995, 17.77411530200004],
              [-64.79548092399995, 17.787543036000045],
              [-64.77163652299993, 17.792629299000055],
              [-64.76915442599994, 17.79002513200004],
              [-64.73078365799995, 17.765285549000055],
              [-64.70970618399991, 17.758205471000053],
              [-64.69904537699995, 17.752834377000056],
              [-64.68976803299995, 17.74477773600006],
              [-64.66690019399994, 17.762884833000044],
              [-64.63097083199995, 17.770331122000073],
              [-64.59178626199991, 17.76829661700009],
              [-64.55939693899995, 17.75844961100006],
              [-64.55939693899995, 17.751613674000055],
            ],
          ],
          [
            [
              [-64.70099350799995, 18.34297606800004],
              [-64.70816063399991, 18.340145034000045],
              [-64.69742311599992, 18.32653998300009],
              [-64.70400507199992, 18.303310064000073],
              [-64.7362304209999, 18.319753190000085],
              [-64.78636715499994, 18.315221772000086],
              [-64.80128501799993, 18.328253009000036],
              [-64.78636541799995, 18.34977205200005],
              [-64.7696488979999, 18.356589046000067],
              [-64.75173632899993, 18.36168915400009],
              [-64.75591344999992, 18.369056759000046],
              [-64.74695540599993, 18.37358996200004],
              [-64.71351856599995, 18.365083232000075],
              [-64.69739686899993, 18.362243917000058],
              [-64.6824723069999, 18.35600306300006],
              [-64.66456145799992, 18.346927221000044],
              [-64.66039026099992, 18.33672316800005],
              [-64.6741299759999, 18.33446290200004],
              [-64.70099350799995, 18.34297606800004],
            ],
          ],
          [
            [
              [-64.87163696599993, 18.314623045000076],
              [-64.8788391729999, 18.30444051300009],
              [-64.91049791299992, 18.315757749000056],
              [-64.92185889299992, 18.322554686000046],
              [-64.93083383699991, 18.339550364000047],
              [-64.93502297799995, 18.33048606200009],
              [-64.94458577799992, 18.33671428300005],
              [-64.96609509199993, 18.332735290000073],
              [-64.98164310499993, 18.335558349000053],
              [-64.99362102299995, 18.348024010000074],
              [-65.02530892999994, 18.33892613800009],
              [-65.04149344199993, 18.353658056000086],
              [-65.01187089799993, 18.36859772300005],
              [-64.98664303299995, 18.374823309000078],
              [-64.9500023299999, 18.373553979000064],
              [-64.93497996399992, 18.36332002200004],
              [-64.92601936499995, 18.366153559000054],
              [-64.94225088299993, 18.378099150000082],
              [-64.95002834499991, 18.386598614000036],
              [-64.92850484399992, 18.380369590000043],
              [-64.8914364549999, 18.35996824600005],
              [-64.85498378299991, 18.340129434000062],
              [-64.84007959199994, 18.317489213000044],
              [-64.85140819399993, 18.315781814000047],
              [-64.86031207099995, 18.318590940000036],
              [-64.87163696599993, 18.314623045000076],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'St-Barthélemy',
        iso3: 'BLM',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-62.83885657499991, 17.881984768000052],
            [-62.85094153599994, 17.890448309000078],
            [-62.861317511999914, 17.905422268000052],
            [-62.86733964799993, 17.920396226000037],
            [-62.866118943999936, 17.92914459800005],
            [-62.857411261999914, 17.925034898000092],
            [-62.79165605399993, 17.91547272300005],
            [-62.798939581999946, 17.90448639500005],
            [-62.81012936099995, 17.892279364000046],
            [-62.82384192599994, 17.883246161000045],
            [-62.83885657499991, 17.881984768000052],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Puerto Rico',
        iso3: 'PRI',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-67.85586503799993, 18.11469147300005],
              [-67.84434973899994, 18.10455963700008],
              [-67.84414628799993, 18.09756094000005],
              [-67.84976152299993, 18.090643622000073],
              [-67.85993404899995, 18.073146877000056],
              [-67.86416581899994, 18.068752346000053],
              [-67.86754309799994, 18.064195054000038],
              [-67.86888587099992, 18.056341864000046],
              [-67.87315833199995, 18.05345286700009],
              [-67.88255774599992, 18.052557684000078],
              [-67.89195716099994, 18.05345286700009],
              [-67.89622962099992, 18.056341864000046],
              [-67.90269934799994, 18.06541575700004],
              [-67.93114173099991, 18.080511786000045],
              [-67.93781490799995, 18.094224351000037],
              [-67.93130449099993, 18.108710028000075],
              [-67.91974850199995, 18.114488023000092],
              [-67.86188717399995, 18.116115627000056],
              [-67.85586503799993, 18.11469147300005],
            ],
          ],
          [
            [
              [-65.34772701699995, 18.11469147300005],
              [-65.35659745999993, 18.122870184000078],
              [-65.37120520699995, 18.119533596000053],
              [-65.39024817599994, 18.11196523600006],
              [-65.46857662699995, 18.09442780200004],
              [-65.48424231699994, 18.08734772300005],
              [-65.50487219999991, 18.09365469000005],
              [-65.53600012899994, 18.09007396000004],
              [-65.56509355399993, 18.09393952000005],
              [-65.58043372299994, 18.12213776200008],
              [-65.56493079299992, 18.12262604400007],
              [-65.55992591099994, 18.12213776200008],
              [-65.54015051999994, 18.12376536700009],
              [-65.52025305899991, 18.130926825000074],
              [-65.50218665299991, 18.14126211100006],
              [-65.48794511599993, 18.152289130000042],
              [-65.47850501199991, 18.157049872000073],
              [-65.39854895699995, 18.16933828300006],
              [-65.38581295499995, 18.167181708000044],
              [-65.35106360599991, 18.15570709800005],
              [-65.29857337099992, 18.15371328300006],
              [-65.28555253799993, 18.148871161000045],
              [-65.27574622299994, 18.137152411000045],
              [-65.28307044199994, 18.13349030200004],
              [-65.30980383999992, 18.135199286000045],
              [-65.31655839799993, 18.13279857000009],
              [-65.33556067599994, 18.120266018000052],
              [-65.34080969999991, 18.11469147300005],
              [-65.34772701699995, 18.11469147300005],
            ],
          ],
          [
            [
              [-65.27879798099991, 18.27920156500005],
              [-65.29259192599994, 18.299953518000052],
              [-65.33433997299994, 18.337103583000044],
              [-65.33405514199995, 18.340643622000073],
              [-65.30943762899994, 18.340765692000048],
              [-65.28091386599993, 18.335272528000075],
              [-65.25666256399995, 18.323919989000046],
              [-65.24461829299992, 18.30654531500005],
              [-65.24754798099991, 18.305853583000044],
              [-65.25829016799992, 18.30654531500005],
              [-65.25145423099991, 18.299709377000056],
              [-65.26211503799993, 18.299221096000053],
              [-65.27041581899994, 18.30141836100006],
              [-65.27603105399993, 18.306341864000046],
              [-65.27879798099991, 18.31395091400009],
              [-65.28555253799993, 18.31395091400009],
              [-65.27651933499993, 18.296942450000074],
              [-65.27481035099993, 18.289007880000042],
              [-65.27879798099991, 18.27920156500005],
            ],
          ],
          [
            [
              [-65.62881425699993, 18.27920156500005],
              [-65.63292395699995, 18.266913153000075],
              [-65.62580318899995, 18.259833075000074],
              [-65.61759110999992, 18.256343797000056],
              [-65.60370190899994, 18.262860527000043],
              [-65.60658699899994, 18.25360994600004],
              [-65.60377320799995, 18.246339934000048],
              [-65.5917638869999, 18.230884786000047],
              [-65.60211212299993, 18.223753350000038],
              [-65.60353254999995, 18.215270496000073],
              [-65.61244261999991, 18.214503295000043],
              [-65.62221824399995, 18.22926327600004],
              [-65.63336336299994, 18.22918349400004],
              [-65.63699476699992, 18.21857009900009],
              [-65.62723464499993, 18.20592874400006],
              [-65.63683059899995, 18.198096500000077],
              [-65.6487347719999, 18.200131146000047],
              [-65.66551673099991, 18.20844147300005],
              [-65.68297278599994, 18.202826239000046],
              [-65.70128333199995, 18.194240627000056],
              [-65.72101803299995, 18.189846096000053],
              [-65.73753821499992, 18.18268463700008],
              [-65.75487219999991, 18.16624583500004],
              [-65.7902891789999, 18.113972511000043],
              [-65.79314209199993, 18.087630827000055],
              [-65.80699622299994, 18.07029857000009],
              [-65.81216386599993, 18.067287502000056],
              [-65.8352758449999, 18.06248607000009],
              [-65.84048417899993, 18.056341864000046],
              [-65.83026947699994, 18.026906814000085],
              [-65.84974571799995, 18.009711121000066],
              [-65.88717781499992, 17.98772697900006],
              [-65.93911699099993, 17.970526434000078],
              [-65.96165930899991, 17.97101471600007],
              [-65.98452714799993, 17.97565338700008],
              [-66.00499426999994, 17.97752513200004],
              [-66.01707923099991, 17.975083726000037],
              [-66.04653886599993, 17.96385325700004],
              [-66.05357825399994, 17.96312083500004],
              [-66.08409583199995, 17.96385325700004],
              [-66.10464433499993, 17.958929755000042],
              [-66.16323808499993, 17.92914459800005],
              [-66.17560787699995, 17.928208726000037],
              [-66.18663489499994, 17.928615627000056],
              [-66.19627844999991, 17.92772044500009],
              [-66.20421301999994, 17.92291901200008],
              [-66.20856686099995, 17.92914459800005],
              [-66.20982825399994, 17.93187083500004],
              [-66.21043860599991, 17.93659088700008],
              [-66.19957434799994, 17.939601955000057],
              [-66.19701087099992, 17.94440338700008],
              [-66.20116126199991, 17.950506903000075],
              [-66.21043860599991, 17.957098700000074],
              [-66.22988847599993, 17.94041575700004],
              [-66.24136308499993, 17.937323309000078],
              [-66.25552324099993, 17.940659898000092],
              [-66.28307044199994, 17.943426825000074],
              [-66.29259192599994, 17.945746161000045],
              [-66.29771887899994, 17.95140208500004],
              [-66.30138098899994, 17.958197333000044],
              [-66.30663001199991, 17.96385325700004],
              [-66.31916256399995, 17.970363674000055],
              [-66.32811438699991, 17.972316799000055],
              [-66.34447180899991, 17.97134023600006],
              [-66.36766516799992, 17.966009833000044],
              [-66.39614824099993, 17.94725169500009],
              [-66.41649329299992, 17.949611721000053],
              [-66.43590247299994, 17.964016018000052],
              [-66.45213782499991, 17.982163804000038],
              [-66.46914628799993, 17.992661851000037],
              [-66.48779985999994, 17.98885369700008],
              [-66.50196912099995, 17.98711535600006],
              [-66.51252193899995, 17.98200104400007],
              [-66.52700761599993, 17.979315497000073],
              [-66.5598852199999, 17.97752513200004],
              [-66.57042395699995, 17.972357489000046],
              [-66.58063717399995, 17.96580638200004],
              [-66.59251868399991, 17.96356842700004],
              [-66.60826575399994, 17.97134023600006],
              [-66.61530514199995, 17.966742255000042],
              [-66.62254798099991, 17.96385325700004],
              [-66.62938391799992, 17.975165106000077],
              [-66.64659583199995, 17.976629950000074],
              [-66.68740800699993, 17.97134023600006],
              [-66.69497636599993, 17.973089911000045],
              [-66.72496497299994, 17.98436107000009],
              [-66.76593990799995, 17.98436107000009],
              [-66.76512610599991, 17.99803294500009],
              [-66.77403723899994, 18.00218333500004],
              [-66.78746497299994, 17.999335028000075],
              [-66.8001195949999, 17.991848049000055],
              [-66.8001195949999, 17.98436107000009],
              [-66.7864477199999, 17.98436107000009],
              [-66.79796301999994, 17.969305731000077],
              [-66.8176977199999, 17.95897044500009],
              [-66.84056555899991, 17.95270416900007],
              [-66.86148027299993, 17.949611721000053],
              [-66.89264889199995, 17.95066966400009],
              [-66.90782630099994, 17.94920482000009],
              [-66.91901607999995, 17.950140692000048],
              [-66.92422441299993, 17.949611721000053],
              [-66.92821204299992, 17.94554271000004],
              [-66.92992102799991, 17.938625393000052],
              [-66.93040930899991, 17.92914459800005],
              [-66.94912675699993, 17.93121979400007],
              [-66.96324622299994, 17.941066799000055],
              [-66.98570716099994, 17.96385325700004],
              [-67.00595940199992, 17.964910772000053],
              [-67.02852830299992, 17.968537713000046],
              [-67.0527129699999, 17.968166438000083],
              [-67.06700598899994, 17.97256094000005],
              [-67.08092200399994, 17.96124909100007],
              [-67.09732011599993, 17.952866929000038],
              [-67.11196855399993, 17.949611721000053],
              [-67.12401282499991, 17.95115794500009],
              [-67.15855980099991, 17.95456875600007],
              [-67.1804672479999, 17.966118460000075],
              [-67.19122136399994, 17.957993996000084],
              [-67.18419235399995, 17.935072253000044],
              [-67.19507325399991, 17.935682387000043],
              [-67.20961020999994, 17.95688978800007],
              [-67.2147711799999, 17.966335022000067],
              [-67.21434917099992, 17.994143776000044],
              [-67.19050045499995, 18.004828192000048],
              [-67.18333899599992, 18.00853099200009],
              [-67.17422441299993, 18.01117584800005],
              [-67.16649329299992, 18.01504140800006],
              [-67.16319739499994, 18.02252838700008],
              [-67.16722571499992, 18.027899481000077],
              [-67.17686926999994, 18.03270091400009],
              [-67.19007559899995, 18.030314326000052],
              [-67.20287512399995, 18.035716432000072],
              [-67.2021340469999, 18.05435783100006],
              [-67.19540025899994, 18.06376811800004],
              [-67.18569259899994, 18.07042742100009],
              [-67.18974067499994, 18.080609646000084],
              [-67.19387679699992, 18.097302159000037],
              [-67.18324455999993, 18.107688841000083],
              [-67.1837782849999, 18.139945037000075],
              [-67.17369544199994, 18.176174221000053],
              [-67.16590894699993, 18.184074226000064],
              [-67.15753586199992, 18.19173440900005],
              [-67.15185783099992, 18.203392396000083],
              [-67.15846512199994, 18.213957881000056],
              [-67.17119829599994, 18.22487028200004],
              [-67.18708248599995, 18.272772528000075],
              [-67.1965115289999, 18.291338513000085],
              [-67.21882878499991, 18.295573695000087],
              [-67.23690628299994, 18.29986180800006],
              [-67.2527742339999, 18.329337017000057],
              [-67.2626007099999, 18.343812572000047],
              [-67.27084218099992, 18.361826454000038],
              [-67.26882485699991, 18.36889997800006],
              [-67.2402673439999, 18.37681236500009],
              [-67.21735592399995, 18.38617584800005],
              [-67.19839433499993, 18.393703518000052],
              [-67.18431555899991, 18.402085679000038],
              [-67.15945110799993, 18.42091074600006],
              [-67.1581179989999, 18.44311083200006],
              [-67.16869874199995, 18.46060467600006],
              [-67.17000663599993, 18.486019825000085],
              [-67.1516820949999, 18.508937893000052],
              [-67.10171464799993, 18.522772528000075],
              [-67.04845130099994, 18.521144924000055],
              [-67.01235917899993, 18.50576406500005],
              [-66.90731563999992, 18.485324843000058],
              [-66.80345618399991, 18.49827708500004],
              [-66.78921464799993, 18.496527411000045],
              [-66.75169837099992, 18.484035549000055],
              [-66.73680579299992, 18.48314036700009],
              [-66.69766191299993, 18.491441148000092],
              [-66.64085852799991, 18.49640534100007],
              [-66.61432857999995, 18.49323151200008],
              [-66.58779863199993, 18.484035549000055],
              [-66.57144120999993, 18.48700592700004],
              [-66.50706946499992, 18.486395575000074],
              [-66.46743730399993, 18.47528717700004],
              [-66.38239498599995, 18.491441148000092],
              [-66.30386308499993, 18.468817450000074],
              [-66.25812740799995, 18.48151276200008],
              [-66.20518958199995, 18.465399481000077],
              [-66.19398862199995, 18.47358656700004],
              [-66.18089758999992, 18.471502997000073],
              [-66.17369544199994, 18.462958075000074],
              [-66.17007402299993, 18.45734284100007],
              [-66.1615840849999, 18.45329822100007],
              [-66.15200759599992, 18.458723638000038],
              [-66.14408516299994, 18.468702418000078],
              [-66.13414466099994, 18.46588776200008],
              [-66.13747020199992, 18.45275593200006],
              [-66.11808062099993, 18.44302686800006],
              [-66.11485755099994, 18.43317291900007],
              [-66.10846920499995, 18.42064036700009],
              [-66.09316972599993, 18.41982656500005],
              [-66.06021074099993, 18.429388739000046],
              [-66.06021074099993, 18.436835028000075],
              [-66.07677161399994, 18.43886953300006],
              [-66.09496008999992, 18.447699286000045],
              [-66.10936438699991, 18.461411851000037],
              [-66.12163115699991, 18.473470242000076],
              [-66.05589758999992, 18.45380280200004],
              [-66.03970292899993, 18.450506903000075],
              [-66.02818465099995, 18.446870575000048],
              [-66.0120997539999, 18.44396181500008],
              [-65.99771739999994, 18.45018494100009],
              [-65.98888098899994, 18.46308014500005],
              [-65.96621660099993, 18.45844147300005],
              [-65.92043842799995, 18.44588943100007],
              [-65.90482604999994, 18.45592492600008],
              [-65.89281165299991, 18.453599351000037],
              [-65.88052324099993, 18.44481028900009],
              [-65.84829667899993, 18.437892971000053],
              [-65.83079993399991, 18.42869700700004],
              [-65.81260562999995, 18.41040538200008],
              [-65.8016258159999, 18.415443225000047],
              [-65.79416880699995, 18.425405872000056],
              [-65.7883472609999, 18.423249257000066],
              [-65.78714832199995, 18.41830708100008],
              [-65.79231770299992, 18.41276352400007],
              [-65.7963071769999, 18.405028206000054],
              [-65.7887771039999, 18.406737253000074],
              [-65.77837209599994, 18.410669300000052],
              [-65.7720271419999, 18.41457015000009],
              [-65.75500242699991, 18.391041037000036],
              [-65.7381071609999, 18.382365176000064],
              [-65.72484854399994, 18.391266958000074],
              [-65.6980147829999, 18.371110745000067],
              [-65.66320028799993, 18.366413598000065],
              [-65.64574133999992, 18.37840403900009],
              [-65.63776607999995, 18.385687567000048],
              [-65.62938391799992, 18.391058661000045],
              [-65.62140865799995, 18.389064846000053],
              [-65.62100175699993, 18.38226959800005],
              [-65.63076738199993, 18.332831122000073],
              [-65.63296464799993, 18.29100169500009],
              [-65.62881425699993, 18.27920156500005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Anguilla',
        iso3: 'AIA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-63.00739498599995, 18.27301666900007],
              [-62.98399817599994, 18.27643463700008],
              [-62.972645636999914, 18.275864976000037],
              [-62.97288977799991, 18.269273179000038],
              [-62.99290930899991, 18.236883856000077],
              [-63.000559048999946, 18.227362372000073],
              [-63.01154537699995, 18.220445054000038],
              [-63.037668423999946, 18.212958075000074],
              [-63.09951738199993, 18.176174221000053],
              [-63.10236568899995, 18.18040599200009],
              [-63.10912024599992, 18.18504466400009],
              [-63.113840298999946, 18.189846096000053],
              [-63.136830206999946, 18.17340729400007],
              [-63.150502081999946, 18.169094143000052],
              [-63.16783606699994, 18.16933828300006],
              [-63.14207923099991, 18.198146877000056],
              [-63.13434811099995, 18.20408763200004],
              [-63.12279212099992, 18.20807526200008],
              [-63.09723873599995, 18.21246979400007],
              [-63.08584550699993, 18.217718817000048],
              [-63.06777910099993, 18.236476955000057],
              [-63.05508378799993, 18.254339911000045],
              [-63.03819739499994, 18.267726955000057],
              [-63.00739498599995, 18.27301666900007],
            ],
          ],
          [
            [
              [-63.42796790299991, 18.59284088700008],
              [-63.42882239499994, 18.601263739000046],
              [-63.42357337099992, 18.600043036000045],
              [-63.42796790299991, 18.59284088700008],
            ],
          ],
          [
            [
              [-62.95820458534228, 18.28942162673183],
              [-62.95067631598569, 18.292131803700205],
              [-62.94766500824305, 18.297251026862686],
              [-62.93381299262692, 18.294540849894315],
              [-62.92568246172179, 18.289722757506095],
              [-62.93200620798133, 18.287313711311985],
              [-62.94495483127468, 18.283700142020816],
              [-62.94736387746879, 18.280387703503916],
              [-62.95669893147096, 18.27436508801864],
              [-62.96001136998786, 18.27767752653554],
              [-62.95609666992243, 18.28249561892376],
              [-62.95820458534228, 18.28942162673183],
            ],
          ],
          [
            [
              [-63.252030887180354, 18.272969970560457],
              [-63.26147434826127, 18.276246273384444],
              [-63.262630690434435, 18.28202798425031],
              [-63.25357267674458, 18.28684607663853],
              [-63.2456059437692, 18.283210111463976],
              [-63.236034820451465, 18.282991602727954],
              [-63.252030887180354, 18.272969970560457],
            ],
          ],
          [
            [
              [-63.1845043622015, 18.26804736437459],
              [-63.179493546117754, 18.266505574810356],
              [-63.18354074372386, 18.265156508941654],
              [-63.18700977024338, 18.265349232637185],
              [-63.18970790198078, 18.267469193288],
              [-63.19221331002265, 18.268818259156703],
              [-63.190093349371836, 18.26920370654776],
              [-63.18643159915679, 18.268432811765646],
              [-63.1845043622015, 18.26804736437459],
            ],
          ],
          [
            [
              [-63.174290006338474, 18.26457833785507],
              [-63.172362769383184, 18.26457833785507],
              [-63.171206427210016, 18.265541956332715],
              [-63.16908646655919, 18.265349232637185],
              [-63.16831557177708, 18.261880206117667],
              [-63.17139915090554, 18.26149475872661],
              [-63.17409728264295, 18.262072929813193],
              [-63.174290006338474, 18.26457833785507],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'British Virgin Is.',
        iso3: 'VGB',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-64.63512122299994, 18.405503648000092],
              [-64.64366614499994, 18.39394765800006],
              [-64.65968514299993, 18.383071612000037],
              [-64.67547765499995, 18.38410507800006],
              [-64.68962849699994, 18.384639981000078],
              [-64.71412824599992, 18.386202581000077],
              [-64.70050873399992, 18.398069858000042],
              [-64.68255356999993, 18.39954839300009],
              [-64.67439957199991, 18.412397892000058],
              [-64.66564710999995, 18.424396466000076],
              [-64.66182129899994, 18.44041567000005],
              [-64.64170492799991, 18.45115772200006],
              [-64.62726803299995, 18.447088934000078],
              [-64.60363300099993, 18.451616123000065],
              [-64.59270478999991, 18.448562173000084],
              [-64.56016094899991, 18.454102780000085],
              [-64.52719946799994, 18.44911813200008],
              [-64.51684528599992, 18.43929038100009],
              [-64.52012864599993, 18.43412304600008],
              [-64.53159171999994, 18.43567723600006],
              [-64.5485961629999, 18.440270558000066],
              [-64.56116595099991, 18.43354551400006],
              [-64.56639563699991, 18.425726630000042],
              [-64.57404537699995, 18.419134833000044],
              [-64.5833227199999, 18.41632721600007],
              [-64.59117591099994, 18.417792059000078],
              [-64.5969945949999, 18.420803127000056],
              [-64.60338294199994, 18.423041083000044],
              [-64.61339270699995, 18.42255280200004],
              [-64.61286373599995, 18.41950104400007],
              [-64.62071692599994, 18.41156647300005],
              [-64.63036048099991, 18.404852606000077],
              [-64.63512122299994, 18.405503648000092],
            ],
          ],
          [
            [
              [-64.38060462099992, 18.480902411000045],
              [-64.38902747299994, 18.471096096000053],
              [-64.40819251199991, 18.456691799000055],
              [-64.42931067599994, 18.44489166900007],
              [-64.44334876199991, 18.443060614000046],
              [-64.41852779899995, 18.47532786700009],
              [-64.41173255099994, 18.491359768000052],
              [-64.41539466099994, 18.51194896000004],
              [-64.41095943899995, 18.51194896000004],
              [-64.40811113199993, 18.51048411700009],
              [-64.40575110599991, 18.508205471000053],
              [-64.40241451699995, 18.50576406500005],
              [-64.34683183499993, 18.50690338700008],
              [-64.32603919199994, 18.51194896000004],
              [-64.33429928299995, 18.49705638200004],
              [-64.35309811099995, 18.487209377000056],
              [-64.37197831899994, 18.48191966400009],
              [-64.38060462099992, 18.480902411000045],
            ],
          ],
          [
            [
              [-64.33653723899994, 18.724269924000055],
              [-64.38052324099993, 18.72614166900007],
              [-64.39867102799991, 18.732082424000055],
              [-64.40855872299994, 18.744696356000077],
              [-64.32030188699991, 18.746242580000057],
              [-64.28506425699993, 18.734076239000046],
              [-64.27074133999992, 18.70066966400009],
              [-64.27953040299991, 18.701239325000074],
              [-64.33653723899994, 18.724269924000055],
            ],
          ],
          [
            [
              [-64.56944739499994, 18.357977606000077],
              [-64.56818600199995, 18.350897528000075],
              [-64.56786048099991, 18.33738841400009],
              [-64.57091223899994, 18.33466217700004],
              [-64.57469641799992, 18.343003648000092],
              [-64.58531653599994, 18.34861888200004],
              [-64.60073808499993, 18.351629950000074],
              [-64.60301673099991, 18.355617580000057],
              [-64.59406490799995, 18.357814846000053],
              [-64.58690344999991, 18.357977606000077],
              [-64.58283443899995, 18.359442450000074],
              [-64.57835852799991, 18.360581773000092],
              [-64.56944739499994, 18.357977606000077],
            ],
          ],
          [
            [
              [-64.7298070949999, 18.45343659100007],
              [-64.72752844999991, 18.44989655200004],
              [-64.72423255099994, 18.442694403000075],
              [-64.73033606699994, 18.437892971000053],
              [-64.75938880099994, 18.441839911000045],
              [-64.77399654899995, 18.442287502000056],
              [-64.76842200399994, 18.449652411000045],
              [-64.74290930899991, 18.45498281500005],
              [-64.7298070949999, 18.45343659100007],
            ],
          ],
          [
            [
              [-64.53270423099991, 18.49412669500009],
              [-64.52953040299991, 18.492580471000053],
              [-64.52892005099994, 18.48183828300006],
              [-64.52916419199994, 18.476385809000078],
              [-64.53160559799994, 18.46702708500004],
              [-64.53652910099993, 18.46238841400009],
              [-64.53823808499993, 18.46515534100007],
              [-64.53734290299991, 18.471828518000052],
              [-64.53945878799993, 18.482855536000045],
              [-64.53770911399994, 18.490668036000045],
              [-64.53270423099991, 18.49412669500009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Jamaica',
        iso3: 'JAM',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-76.2637426419999, 18.01235586100006],
            [-76.25678463399993, 17.99632396000004],
            [-76.24876868399991, 17.977850653000075],
            [-76.23403886599993, 17.953924872000073],
            [-76.21524003799993, 17.93496328300006],
            [-76.18797766799992, 17.91547272300005],
            [-76.19839433499993, 17.907416083000044],
            [-76.2500707669999, 17.894964911000045],
            [-76.28648841099994, 17.875881252000056],
            [-76.30736243399991, 17.87010325700004],
            [-76.32518469999991, 17.87449778900009],
            [-76.31822669199994, 17.879299221000053],
            [-76.31541907499991, 17.88271719000005],
            [-76.31151282499991, 17.894964911000045],
            [-76.32957923099991, 17.88865794500009],
            [-76.34561113199993, 17.86587148600006],
            [-76.36302649599992, 17.86082591400009],
            [-76.37852942599994, 17.865057684000078],
            [-76.3965551419999, 17.872992255000042],
            [-76.41490637899994, 17.877508856000077],
            [-76.44493567599994, 17.86676666900007],
            [-76.52354895699995, 17.860256252000056],
            [-76.57900956899994, 17.868312893000052],
            [-76.58706620999993, 17.867987372000073],
            [-76.59459387899994, 17.86660390800006],
            [-76.60277258999992, 17.867621161000045],
            [-76.61314856699994, 17.87449778900009],
            [-76.61766516799992, 17.88353099200009],
            [-76.61969967399995, 17.895086981000077],
            [-76.62271074099993, 17.90501536700009],
            [-76.63052324099993, 17.90924713700008],
            [-76.63857988199993, 17.91160716400009],
            [-76.64395097599993, 17.917222398000092],
            [-76.64858964799993, 17.923895575000074],
            [-76.65477454299992, 17.92914459800005],
            [-76.68480383999992, 17.936021226000037],
            [-76.69229081899994, 17.940008856000077],
            [-76.70767167899993, 17.94594961100006],
            [-76.72842363199993, 17.94476959800005],
            [-76.76463782499991, 17.93659088700008],
            [-76.78010006399995, 17.934800523000092],
            [-76.83226477799991, 17.93659088700008],
            [-76.83226477799991, 17.943426825000074],
            [-76.72240149599992, 17.949611721000053],
            [-76.72931881399995, 17.955959377000056],
            [-76.73436438699991, 17.960598049000055],
            [-76.74746660099993, 17.963446356000077],
            [-76.77765865799995, 17.96385325700004],
            [-76.79816383499991, 17.96341979500005],
            [-76.8190558949999, 17.975272920000066],
            [-76.83682900899993, 17.98635859600006],
            [-76.8499673899999, 17.992276476000086],
            [-76.8530687729999, 17.98196832600007],
            [-76.85776052599994, 17.971398026000088],
            [-76.87017289399995, 17.958049775000063],
            [-76.8740045749999, 17.950349069000083],
            [-76.88715631699995, 17.951856130000067],
            [-76.89103748899993, 17.94450240000009],
            [-76.8949439559999, 17.921681026000044],
            [-76.91282793799991, 17.86128743200004],
            [-76.92609615799995, 17.84332916900007],
            [-76.94212805899991, 17.83356354400007],
            [-76.95531165299991, 17.83344147300005],
            [-76.96401933499993, 17.837225653000075],
            [-76.97207597599993, 17.84243398600006],
            [-76.98306230399993, 17.846584377000056],
            [-77.03831946499992, 17.846584377000056],
            [-77.03831946499992, 17.853989976000037],
            [-77.01720130099994, 17.86082591400009],
            [-77.02798417899993, 17.86981842700004],
            [-77.04149329299992, 17.887152411000045],
            [-77.05199133999992, 17.894964911000045],
            [-77.06419837099992, 17.89948151200008],
            [-77.09300696499992, 17.902492580000057],
            [-77.11910936299995, 17.89380331600006],
            [-77.14165204099993, 17.881133913000042],
            [-77.15807908699992, 17.849874593000038],
            [-77.16197669199994, 17.840765692000048],
            [-77.15440833199995, 17.813055731000077],
            [-77.16169186099995, 17.810288804000038],
            [-77.17438717399995, 17.80292389500005],
            [-77.1817113919999, 17.799994208000044],
            [-77.17910722599993, 17.794745184000078],
            [-77.17735755099994, 17.78461334800005],
            [-77.17491614499994, 17.778265692000048],
            [-77.1856176419999, 17.782904364000046],
            [-77.19635982999995, 17.78339264500005],
            [-77.20677649599992, 17.779852606000077],
            [-77.21646074099993, 17.77212148600006],
            [-77.19888261599993, 17.761786200000074],
            [-77.18032792899993, 17.757879950000074],
            [-77.16087805899991, 17.759426174000055],
            [-77.14073645699995, 17.765285549000055],
            [-77.13060462099992, 17.727687893000052],
            [-77.13365637899994, 17.71043528900009],
            [-77.15811113199993, 17.703192450000074],
            [-77.17894446499992, 17.70416901200008],
            [-77.19758053299995, 17.708197333000044],
            [-77.21605383999992, 17.71670156500005],
            [-77.30288652299993, 17.790838934000078],
            [-77.32087154899995, 17.812445380000042],
            [-77.39561926999994, 17.853949286000045],
            [-77.41771399599992, 17.861721096000053],
            [-77.44102942599994, 17.86465078300006],
            [-77.45946204299992, 17.85740794500009],
            [-77.48062089799993, 17.84373607000009],
            [-77.50182044199994, 17.841945705000057],
            [-77.54548092399995, 17.853989976000037],
            [-77.58836829299992, 17.860988674000055],
            [-77.72386633999992, 17.853583075000074],
            [-77.73070227799991, 17.854803778000075],
            [-77.75153561099995, 17.868312893000052],
            [-77.78673255099994, 17.88495514500005],
            [-77.79556230399993, 17.891546942000048],
            [-77.79991614499994, 17.89911530200004],
            [-77.81029212099992, 17.924750067000048],
            [-77.81236731699994, 17.932847398000092],
            [-77.81615149599992, 17.939195054000038],
            [-77.8340551419999, 17.94529857000009],
            [-77.83967037699995, 17.949611721000053],
            [-77.8411352199999, 17.97060781500005],
            [-77.83934485599991, 17.995835679000038],
            [-77.84557044199994, 18.01703522300005],
            [-77.87100175699993, 18.025946356000077],
            [-77.94033769399994, 18.026516018000052],
            [-77.95628821499992, 18.032171942000048],
            [-77.97996985599991, 18.084458726000037],
            [-77.98786373599995, 18.095363674000055],
            [-77.99644934799994, 18.10101959800005],
            [-78.00641842399995, 18.105861721000053],
            [-78.01439368399991, 18.107855536000045],
            [-78.02057857999995, 18.113104559000078],
            [-78.02538001199991, 18.12518952000005],
            [-78.03148352799991, 18.148871161000045],
            [-78.05028235599991, 18.18512604400007],
            [-78.07518469999991, 18.198431708000044],
            [-78.14879309799994, 18.19668203300006],
            [-78.19375566299993, 18.203924872000073],
            [-78.21019446499992, 18.20408763200004],
            [-78.21959387899994, 18.195868231000077],
            [-78.22728430899991, 18.191839911000045],
            [-78.23403886599993, 18.193182684000078],
            [-78.25865637899994, 18.20262278900009],
            [-78.26113847599993, 18.20408763200004],
            [-78.27513587099992, 18.206244208000044],
            [-78.30589758999992, 18.215643622000073],
            [-78.32315019399994, 18.217718817000048],
            [-78.34072831899994, 18.221869208000044],
            [-78.35773678299995, 18.23273346600007],
            [-78.37026933499993, 18.248114325000074],
            [-78.37466386599993, 18.265570380000042],
            [-78.36913001199991, 18.273871161000045],
            [-78.35431881399995, 18.28384023600006],
            [-78.34732011599993, 18.292222398000092],
            [-78.34439042899993, 18.30536530200004],
            [-78.34581458199995, 18.33551666900007],
            [-78.34390214799993, 18.34406159100007],
            [-78.33629309799994, 18.355902411000045],
            [-78.33543860599991, 18.363430080000057],
            [-78.33193925699993, 18.36737702000005],
            [-78.31639563699991, 18.36859772300005],
            [-78.30663001199991, 18.374660549000055],
            [-78.29869544199994, 18.386379299000055],
            [-78.2884008449999, 18.394354559000078],
            [-78.27163652299993, 18.389064846000053],
            [-78.26130123599995, 18.41738515800006],
            [-78.23062089799993, 18.444240627000056],
            [-78.19497636599993, 18.455471096000053],
            [-78.1692602199999, 18.436835028000075],
            [-78.15440833199995, 18.453517971000053],
            [-78.13853919199994, 18.45384349200009],
            [-78.11998450399994, 18.447333075000074],
            [-78.09723873599995, 18.443060614000046],
            [-78.0325414699999, 18.45062897300005],
            [-78.01097571499992, 18.450506903000075],
            [-78.00015214799993, 18.44668203300006],
            [-77.99242102799991, 18.44399648600006],
            [-77.98135331899994, 18.441351630000042],
            [-77.96996008999992, 18.443060614000046],
            [-77.95982825399994, 18.44989655200004],
            [-77.95885169199994, 18.45644765800006],
            [-77.95913652299993, 18.464097398000092],
            [-77.95295162699995, 18.474432684000078],
            [-77.93028723899994, 18.502020575000074],
            [-77.9199926419999, 18.51117584800005],
            [-77.90233313699991, 18.518784898000092],
            [-77.86188717399995, 18.525091864000046],
            [-77.81607011599993, 18.52342357000009],
            [-77.73554439999992, 18.506699937000064],
            [-77.66454016799992, 18.491929429000038],
            [-77.56725012899994, 18.490179755000042],
            [-77.52428137899994, 18.480210679000038],
            [-77.45498613199993, 18.47532786700009],
            [-77.42886308499993, 18.469224351000037],
            [-77.4082738919999, 18.45734284100007],
            [-77.37653561099995, 18.46515534100007],
            [-77.32530676999994, 18.46503327000005],
            [-77.27261308499993, 18.459377346000053],
            [-77.23631751199991, 18.450506903000075],
            [-77.23184160099993, 18.44603099200009],
            [-77.22813880099994, 18.433661200000074],
            [-77.22329667899993, 18.429388739000046],
            [-77.21743730399993, 18.429348049000055],
            [-77.21202551999994, 18.431789455000057],
            [-77.20885169199994, 18.43496328300006],
            [-77.20962480399993, 18.436835028000075],
            [-77.16494706899994, 18.429388739000046],
            [-77.15941321499992, 18.426214911000045],
            [-77.14256751199991, 18.41209544500009],
            [-77.13735917899993, 18.40892161700009],
            [-77.10472571499992, 18.407863674000055],
            [-77.0703425769999, 18.413356838000084],
            [-77.05199133999992, 18.41632721600007],
            [-77.04002844999991, 18.41347890800006],
            [-77.01915442599994, 18.404120184000078],
            [-77.00731360599991, 18.402085679000038],
            [-76.94815019399994, 18.40448639500005],
            [-76.9366151609999, 18.410295018000056],
            [-76.92033834599994, 18.41219546600007],
            [-76.90711820799993, 18.411205408000058],
            [-76.89491886399992, 18.409251286000085],
            [-76.88782656899991, 18.40055241300007],
            [-76.89091562999994, 18.389946614000053],
            [-76.89094812399992, 18.37644053400004],
            [-76.87978282499995, 18.366768827000044],
            [-76.84421063799994, 18.345446595000055],
            [-76.81275421399994, 18.32800966500008],
            [-76.80762233099995, 18.31830830000007],
            [-76.79832923099991, 18.29205963700008],
            [-76.79238847599993, 18.28339264500005],
            [-76.78282630099994, 18.277818101000037],
            [-76.76463782499991, 18.27301666900007],
            [-76.71288001199991, 18.269191799000055],
            [-76.69570878799993, 18.265570380000042],
            [-76.68101966099994, 18.25812409100007],
            [-76.66197669199994, 18.23981354400007],
            [-76.64732825399994, 18.23078034100007],
            [-76.63036048099991, 18.225734768000052],
            [-76.59715816799991, 18.22774776300008],
            [-76.57977010499991, 18.216029546000073],
            [-76.57420813699991, 18.214667059000078],
            [-76.56920325399994, 18.210109768000052],
            [-76.56305904899995, 18.205959377000056],
            [-76.55479895699995, 18.20408763200004],
            [-76.47972571499992, 18.20408763200004],
            [-76.47447669199994, 18.20107656500005],
            [-76.46662350199995, 18.186753648000092],
            [-76.46300208199995, 18.18235911700009],
            [-76.38939368399991, 18.169175523000092],
            [-76.35114498599995, 18.155991929000038],
            [-76.34626217399995, 18.135199286000045],
            [-76.31786048099991, 18.10927969000005],
            [-76.29580644399994, 18.07916901200008],
            [-76.2637426419999, 18.01235586100006],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cayman Is.',
        iso3: 'CYM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-81.13609778599994, 19.35488515800006],
              [-81.11754309799994, 19.352769273000035],
              [-81.09951738199993, 19.347316799000055],
              [-81.08950761599993, 19.33539459800005],
              [-81.08658644399992, 19.309926720000078],
              [-81.10667716099994, 19.295317337000085],
              [-81.13510021899992, 19.29074154700004],
              [-81.16950382599993, 19.29956335600008],
              [-81.19319154199991, 19.29611406300006],
              [-81.21450913599995, 19.292671674000076],
              [-81.2334577339999, 19.28923422400004],
              [-81.24882112299991, 19.279096906000063],
              [-81.26646887899994, 19.266058661000045],
              [-81.27635657499991, 19.264837958000044],
              [-81.34127167199995, 19.27306034500009],
              [-81.35788245399993, 19.27409358400007],
              [-81.37572180899991, 19.272284247000073],
              [-81.3874861669999, 19.263863615000048],
              [-81.39793860599991, 19.27415599200009],
              [-81.39592479999993, 19.289561692000063],
              [-81.39240029899992, 19.296295951000047],
              [-81.38889892799995, 19.307506249000085],
              [-81.3854264979999, 19.324311033000072],
              [-81.3855032479999, 19.33885820100005],
              [-81.39032561899995, 19.35226029800009],
              [-81.40581841499994, 19.363369769000087],
              [-81.41654202099994, 19.370027621000077],
              [-81.41423831499992, 19.382348880000052],
              [-81.40834634899994, 19.39021230700007],
              [-81.39412368799992, 19.394760508000047],
              [-81.37572180899991, 19.38898346600007],
              [-81.37858544199992, 19.375817494000046],
              [-81.3689985609999, 19.35908261800006],
              [-81.36059002799993, 19.34010395900009],
              [-81.36404493099991, 19.31994567000004],
              [-81.34971793699992, 19.30211449600006],
              [-81.32243823399995, 19.302250520000086],
              [-81.30349769499992, 19.30905467100007],
              [-81.30125891799992, 19.32062409100007],
              [-81.29381262899994, 19.334377346000053],
              [-81.28807532499991, 19.331366278000075],
              [-81.27330481699994, 19.32758209800005],
              [-81.27342688699991, 19.332098700000074],
              [-81.27489173099991, 19.335272528000075],
              [-81.27953040299991, 19.34178294500009],
              [-81.27330481699994, 19.334377346000053],
              [-81.27521725199995, 19.33856842700004],
              [-81.27769934799994, 19.34137604400007],
              [-81.27798417899993, 19.34406159100007],
              [-81.27330481699994, 19.348049221000053],
              [-81.27790279899995, 19.35187409100007],
              [-81.28075110599991, 19.356268622000073],
              [-81.28628495999993, 19.368475653000075],
              [-81.26813717399995, 19.36627838700008],
              [-81.23155676999994, 19.35154857000009],
              [-81.21182206899994, 19.348049221000053],
              [-81.15778561099995, 19.35504791900007],
              [-81.13609778599994, 19.35488515800006],
            ],
          ],
          [
            [
              [-80.03782980299991, 19.70403532200004],
              [-80.00873641399994, 19.703951043000075],
              [-79.98102779899995, 19.71430084800005],
              [-79.96426347599993, 19.704901434000078],
              [-79.96816972599993, 19.703192450000074],
              [-79.97793535099993, 19.69745514500005],
              [-80.00391779199992, 19.690270050000038],
              [-80.07796825799994, 19.654020437000042],
              [-80.11315546199995, 19.65866019300006],
              [-80.0985525989999, 19.676856942000086],
              [-80.08154331799994, 19.685929059000046],
              [-80.06208774699991, 19.70068152400006],
              [-80.03782980299991, 19.70403532200004],
            ],
          ],
          [
            [
              [-79.87188918099991, 19.704636140000048],
              [-79.80283746799995, 19.732826662000036],
              [-79.76889869799993, 19.75203648300004],
              [-79.74589952199995, 19.75763083700008],
              [-79.73151607999995, 19.752101955000057],
              [-79.72664269199993, 19.737063377000084],
              [-79.77389263799995, 19.713364056000046],
              [-79.85500065699995, 19.69091674000009],
              [-79.89375366899992, 19.679672759000084],
              [-79.87188918099991, 19.704636140000048],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bermuda',
        iso3: 'BMU',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-64.67609615799995, 32.388657945000034],
              [-64.64763070564054, 32.368227979697025],
              [-64.65538235713095, 32.35931358048306],
              [-64.65576993970546, 32.3503991812691],
              [-64.66042093059971, 32.35349984186526],
              [-64.66739741694107, 32.35892599790854],
              [-64.680780750445, 32.361732180740006],
              [-64.685226215369, 32.35737566761046],
              [-64.69142753656132, 32.3639645713773],
              [-64.70809358726568, 32.35156192899266],
              [-64.70499292666952, 32.34303511235322],
              [-64.694915779732, 32.33993445175705],
              [-64.67786214645311, 32.334508295713775],
              [-64.69840402290268, 32.326369061648855],
              [-64.71700798647964, 32.315516749562285],
              [-64.74058997299994, 32.300441799000055],
              [-64.75487219999991, 32.29311758000006],
              [-64.76390547799659, 32.28257223072808],
              [-64.78328460672259, 32.26745651032179],
              [-64.80925263921544, 32.256216615660705],
              [-64.83405792398473, 32.248077381595785],
              [-64.84917364439102, 32.2484649641703],
              [-64.86080112162662, 32.24885254674482],
              [-64.87630442460743, 32.257766945958785],
              [-64.88289332837427, 32.271719918641516],
              [-64.88599398897043, 32.28257223072808],
              [-64.87663404547075, 32.27891173925333],
              [-64.87797690356818, 32.28607364910635],
              [-64.87454840416746, 32.29568128932394],
              [-64.8797926677781, 32.305439602624766],
              [-64.87242859886221, 32.30311410717764],
              [-64.86894035569154, 32.308927845795445],
              [-64.8642893647973, 32.30311410717764],
              [-64.85808804360498, 32.297687951134364],
              [-64.86700244281894, 32.29109904736752],
              [-64.86980647402979, 32.279784793540905],
              [-64.8720410162877, 32.27637090953576],
              [-64.86700244281894, 32.27288266636507],
              [-64.8487860618165, 32.27094475349247],
              [-64.8487860618165, 32.26784409289631],
              [-64.86313074850332, 32.26900756702507],
              [-64.8642893647973, 32.262417936853026],
              [-64.85770046103045, 32.254666285362624],
              [-64.84684814894389, 32.254666285362624],
              [-64.83289517626116, 32.25970485883139],
              [-64.82901935051596, 32.26668134517275],
              [-64.81971736872748, 32.26745651032179],
              [-64.80305131802311, 32.27598332696123],
              [-64.78091386599993, 32.287543036000045],
              [-64.77902119840287, 32.29109904736752],
              [-64.79452450138368, 32.28954871706944],
              [-64.80537681347023, 32.29342454281464],
              [-64.81396733425684, 32.3039784237389],
              [-64.81083399869615, 32.3075593786654],
              [-64.78014075399994, 32.30341217700004],
              [-64.76183020699995, 32.31093984600005],
              [-64.75121008999992, 32.31362539300005],
              [-64.74026294095086, 32.32404356620173],
              [-64.73599953263113, 32.32288081847817],
              [-64.71855831677773, 32.32365598362721],
              [-64.71390732588348, 32.329469722245015],
              [-64.70538050924404, 32.336058626011855],
              [-64.71313216073445, 32.342647529778695],
              [-64.72463708989119, 32.33878621989682],
              [-64.73289887203497, 32.33373313056473],
              [-64.73473870650784, 32.32770225012702],
              [-64.73948777580182, 32.32869455709597],
              [-64.74165990765948, 32.33307298398109],
              [-64.73638711520566, 32.34381027750226],
              [-64.72202022916721, 32.35251162240483],
              [-64.71313216073445, 32.36435215395183],
              [-64.69725501199991, 32.37352122600004],
              [-64.67609615799995, 32.388657945000034],
            ],
          ],
          [
            [
              [-64.81545396040777, 32.2887735519204],
              [-64.81196571723707, 32.28993629964396],
              [-64.80770230891736, 32.286448056473276],
              [-64.79995065742695, 32.283347395877115],
              [-64.80266373544859, 32.28102190043],
              [-64.81119055208804, 32.28218464815355],
              [-64.82049253387652, 32.28102190043],
              [-64.829794515665, 32.281797065579035],
              [-64.83250759368664, 32.28722322162232],
              [-64.82940693309048, 32.28916113449492],
              [-64.82088011645104, 32.28722322162232],
              [-64.81545396040777, 32.2887735519204],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bajo Nuevo Bank',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-79.9892878899999, 15.794948635000083],
            [-79.9878230459999, 15.796210028000075],
            [-79.9863988919999, 15.794419664000088],
            [-79.98814856699994, 15.794175523000092],
            [-79.9892878899999, 15.794948635000083],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Serranilla Bank',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-78.63707434799994, 15.862087307000081],
            [-78.6404109369999, 15.86399974200009],
            [-78.63687089799993, 15.867295640000066],
            [-78.63707434799994, 15.862087307000081],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Indonesia',
        iso3: 'IDN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [117.70360790395524, 4.163414542001791],
              [117.70360790400008, 4.163414542000055],
              [117.73807146200011, 4.157241908000032],
              [117.78357224700005, 4.157241908000032],
              [117.85255730900013, 4.157241908000032],
              [117.9070390276059, 4.156683015004099],
              [117.91211998800009, 4.144924221000053],
              [117.91822350400003, 4.100043036000045],
              [117.93482506600003, 4.059881903000075],
              [117.90137780000009, 4.036688544000071],
              [117.887054884, 4.031927802000041],
              [117.87256920700008, 4.03156159100007],
              [117.83855228000004, 4.040187893000052],
              [117.81910241000003, 4.06867096600007],
              [117.76270592500009, 4.100734768000052],
              [117.73943118600005, 4.132310289000088],
              [117.70360790395524, 4.163414542001791],
            ],
          ],
          [
            [
              [124.45053144600001, -9.180189710999912],
              [124.46583092500009, -9.17937590899993],
              [124.51783287900003, -9.17782968499995],
              [124.56324303500003, -9.17083098799992],
              [124.60434004000001, -9.15634530999995],
              [124.66797936300009, -9.11305103999996],
              [124.67115319100003, -9.10751718499995],
              [124.67318769600001, -9.09929778399993],
              [124.68360436300009, -9.074802341999941],
              [124.68799889400009, -9.069512627999927],
              [124.69157962300005, -9.067803643999923],
              [124.75806725400003, -9.047946872999944],
              [124.76734459700003, -9.042901299999926],
              [124.78882897200003, -9.018975518999923],
              [124.82496178500003, -9.008070570999905],
              [124.84034264400009, -9.001071872999944],
              [124.86988366000003, -8.994398695999905],
              [124.89714603000004, -8.974541924999926],
              [124.91928144600001, -8.962090752999927],
              [124.91950720683661, -8.962015500097579],
              [124.92248295100006, -8.986323750999958],
              [124.90915043100011, -9.020326842999907],
              [124.90791019700009, -9.037483418999955],
              [124.91297448700004, -9.05277964199992],
              [124.92129439300004, -9.065492044999885],
              [124.93302494300008, -9.07448374399992],
              [124.94785608000012, -9.07851450599992],
              [124.96589115400002, -9.077274271999968],
              [124.97891361500007, -9.072003274999943],
              [125.00444177300011, -9.055570169999967],
              [125.05182906100009, -9.035002949999893],
              [125.06531661000014, -9.023220723999898],
              [125.06857222500003, -9.015882669999897],
              [125.07301639900004, -8.996452331999919],
              [125.07647871900008, -8.990767923999968],
              [125.08681400600011, -8.98622039799993],
              [125.09151656100005, -8.988597513999892],
              [125.09528894100009, -8.994798684999878],
              [125.10252364200005, -9.00130991599994],
              [125.12133386200009, -9.011851907999898],
              [125.13942061400007, -9.024771015999917],
              [125.15399336800016, -9.040790709999953],
              [125.1623649500001, -9.06063446099995],
              [125.16200321400004, -9.082338561999947],
              [125.14500166900007, -9.145177103999927],
              [125.14696537300006, -9.154478861999863],
              [125.1512028410001, -9.165020852999916],
              [125.15265373200015, -9.170824418999956],
              [125.153890015, -9.17576955099993],
              [125.15063440000011, -9.185381367999952],
              [125.14252120000003, -9.189102070999866],
              [125.11792321800016, -9.187551777999943],
              [125.10696781400009, -9.188481953999897],
              [125.09146488400006, -9.196750182999935],
              [125.08257653800001, -9.20553517699993],
              [125.0739465740001, -9.211322936999906],
              [125.05968387900009, -9.21049611399988],
              [125.05337935400007, -9.206672057999938],
              [125.04144209800006, -9.193236185999893],
              [125.034517456, -9.188171895999915],
              [125.02769616800003, -9.186311543999906],
              [125.00723230100004, -9.186104837999949],
              [124.97446944200016, -9.191892598999914],
              [124.95793298400008, -9.21194305399996],
              [124.9541089280001, -9.241501973999988],
              [124.9601550700001, -9.276021829999877],
              [124.96599450700006, -9.293385111999896],
              [124.97281579600013, -9.304650572999947],
              [124.9966903080001, -9.325837910999908],
              [125.01787764500006, -9.338963724999886],
              [125.02340702400016, -9.345578307999887],
              [125.02480228700006, -9.351986184999916],
              [125.02278690600008, -9.367695820999884],
              [125.02376875800007, -9.3747238159999],
              [125.04629968300009, -9.409863788999942],
              [125.05093075400009, -9.42469684299995],
              [125.06161543100006, -9.485772393999923],
              [125.06128991000003, -9.48601653399993],
              [125.03077233200008, -9.50750090899993],
              [125.00196373800009, -9.536309502999927],
              [124.98658287900003, -9.577325127999927],
              [124.97974694100003, -9.649021091999941],
              [124.97071373800009, -9.662367445999905],
              [124.87476647200003, -9.72470468499995],
              [124.84693444100003, -9.748223565999922],
              [124.75847415500004, -9.850762627999927],
              [124.74781334700003, -9.886163018999923],
              [124.73454837300005, -9.899509372999944],
              [124.67847741000003, -9.930108330999929],
              [124.64128665500004, -9.956638278999947],
              [124.60808353000004, -9.986748955999929],
              [124.56031334700003, -10.015232028999947],
              [124.54078209700003, -10.036553643999923],
              [124.52466881600003, -10.083428643999923],
              [124.51002037900003, -10.096286716999941],
              [124.49935957100001, -10.111993096999925],
              [124.45199629000001, -10.146416924999926],
              [124.41846764400009, -10.16383228999996],
              [124.38086998800009, -10.170505466999941],
              [124.27198326900009, -10.166192315999922],
              [124.19678795700008, -10.173760674999926],
              [124.16480553500003, -10.18059661299992],
              [124.15365644600001, -10.178806247999944],
              [124.13412519600001, -10.172133070999905],
              [124.12240644600001, -10.172539971999925],
              [124.10767662900003, -10.184340101999908],
              [124.08741295700008, -10.225681247999944],
              [124.07813561300009, -10.234633070999905],
              [124.05738366000003, -10.238946221999925],
              [124.04851321700005, -10.249607028999947],
              [124.04346764400009, -10.263116143999923],
              [124.03386478000004, -10.276136976999908],
              [124.01978600400003, -10.28101978999996],
              [123.93279056100005, -10.294854424999926],
              [123.82634524800005, -10.363946221999925],
              [123.79932701900009, -10.37468840899993],
              [123.78736412900003, -10.368340752999927],
              [123.77816816500001, -10.35833098799992],
              [123.75709069100003, -10.360446872999944],
              [123.719086134, -10.371758721999925],
              [123.69898522200003, -10.367364190999922],
              [123.67872155000009, -10.356622002999927],
              [123.65886478000004, -10.34929778399993],
              [123.63965905000009, -10.355075778999947],
              [123.61744225400003, -10.366306247999944],
              [123.60206139400009, -10.36142343499995],
              [123.57447350400003, -10.33766041499996],
              [123.55941816500001, -10.33375416499996],
              [123.53646894600001, -10.331963799999926],
              [123.51539147200003, -10.335544528999947],
              [123.50220787900003, -10.35320403399993],
              [123.49293053500003, -10.360772393999923],
              [123.48161868600005, -10.36614348799992],
              [123.47201582100001, -10.36492278399993],
              [123.46859785200002, -10.356215101999908],
              [123.47242272200003, -10.345147393999923],
              [123.48568769600001, -10.32390715899993],
              [123.49341881600003, -10.301934502999927],
              [123.49496504000001, -10.28215911299992],
              [123.492523634, -10.245212497999944],
              [123.49952233200008, -10.230726820999905],
              [123.51539147200003, -10.213067315999922],
              [123.54712975400003, -10.18678150799991],
              [123.59791100400003, -10.166680596999925],
              [123.61231530000009, -10.156426690999922],
              [123.62037194100003, -10.153008721999925],
              [123.65699303500003, -10.146416924999926],
              [123.66570071700005, -10.143161716999941],
              [123.74854576900009, -10.09775155999995],
              [123.76465905000009, -10.074965101999908],
              [123.74577884200005, -10.050388278999947],
              [123.72608483200008, -10.039239190999922],
              [123.70582116000003, -10.030694268999923],
              [123.68433678500003, -10.024997653999947],
              [123.66041100400003, -10.023044528999947],
              [123.63835696700005, -10.029961846999925],
              [123.60564212300005, -10.054294528999947],
              [123.58814537900003, -10.050388278999947],
              [123.57740319100003, -10.034356377999927],
              [123.57618248800009, -10.013929945999905],
              [123.58375084700003, -9.944024346999925],
              [123.59229576900009, -9.928806247999944],
              [123.62907962300005, -9.90634530999995],
              [123.65015709700003, -9.889418226999908],
              [123.66041100400003, -9.871270440999922],
              [123.66374759200005, -9.85084400799991],
              [123.66382897200003, -9.827243747999944],
              [123.66041100400003, -9.816582940999922],
              [123.64576256600003, -9.796807549999926],
              [123.64332116000003, -9.782810153999947],
              [123.64649498800009, -9.774997653999947],
              [123.65259850400003, -9.770277601999908],
              [123.65919030000009, -9.76653411299992],
              [123.66382897200003, -9.761651299999926],
              [123.66993248800009, -9.740492445999905],
              [123.67156009200005, -9.65016041499996],
              [123.67660566500001, -9.629652601999908],
              [123.68881269600001, -9.61142343499995],
              [123.71168053500003, -9.59156666499996],
              [123.74691816500001, -9.57398853999996],
              [123.75635826900009, -9.567071221999925],
              [123.78394616000003, -9.525811455999929],
              [123.79379316500001, -9.517022393999923],
              [123.801117384, -9.514418226999908],
              [123.80933678500003, -9.513278903999947],
              [123.82154381600003, -9.50904713299991],
              [123.82699629000001, -9.504652601999908],
              [123.83668053500003, -9.492608330999929],
              [123.84205162900003, -9.48796965899993],
              [123.84669030000009, -9.48723723799992],
              [123.85865319100003, -9.489027601999908],
              [123.86304772200003, -9.48796965899993],
              [123.89576256600003, -9.440524997999944],
              [123.90723717500009, -9.43328215899993],
              [123.91260826900009, -9.425957940999922],
              [123.95866946700005, -9.385511976999908],
              [123.97950280000009, -9.358493747999944],
              [123.99146569100003, -9.348077080999929],
              [124.010101759, -9.343926690999922],
              [124.03003991000003, -9.341973565999922],
              [124.06269047, -9.397874856999891],
              [124.09028568500003, -9.421542662999911],
              [124.1210848390001, -9.42691701299988],
              [124.13374556500003, -9.419268899999906],
              [124.15379602100006, -9.391880391999862],
              [124.167231893, -9.380614928999904],
              [124.18361332300009, -9.37389699299996],
              [124.19746260600004, -9.373173522999878],
              [124.21069177300006, -9.378857930999914],
              [124.22578129100015, -9.391570332999962],
              [124.23715010600012, -9.405212910999879],
              [124.24686527500006, -9.421542662999911],
              [124.25399662300003, -9.438699238999973],
              [124.25751062100005, -9.455442402999921],
              [124.25689050300002, -9.462883808999948],
              [124.25337650600005, -9.48055714899995],
              [124.25337650600005, -9.486448261999954],
              [124.25658044500011, -9.499367370999963],
              [124.25751062100005, -9.501227721999967],
              [124.26159305900006, -9.49792042999988],
              [124.2738403730001, -9.494923196999949],
              [124.293064006, -9.49306284499994],
              [124.31006555200014, -9.488722025999962],
              [124.32355310100002, -9.480350443999896],
              [124.33233809500007, -9.466604511999961],
              [124.33337162300006, -9.457199401999901],
              [124.32882409700005, -9.439836119999896],
              [124.32861739100008, -9.433014831999927],
              [124.33207971200005, -9.425470071999882],
              [124.34174320500006, -9.41182749399988],
              [124.34541223200006, -9.404179381999896],
              [124.3478927000001, -9.374620462999872],
              [124.35455896000013, -9.364181823999928],
              [124.3580729580001, -9.362218118999905],
              [124.3626204840001, -9.362011413999937],
              [124.37187056500005, -9.357050475999898],
              [124.40168786600015, -9.331832376999941],
              [124.42091149900006, -9.30692433699997],
              [124.42478723200009, -9.303513691999854],
              [124.42793949400004, -9.299482929999954],
              [124.43181522700002, -9.29080128999989],
              [124.436621134, -9.255868021999902],
              [124.45150394800015, -9.200574238999877],
              [124.45053144600001, -9.180189710999912],
            ],
          ],
          [
            [
              [117.56714928500003, 4.159654039000131],
              [117.56706790500004, 4.15961334800005],
              [117.55551191500001, 4.151841539000088],
              [117.52833092500009, 4.127508856000077],
              [117.51856530000009, 4.122259833000044],
              [117.50782311300009, 4.123480536000045],
              [117.37305748800009, 4.169745184000078],
              [117.37387129000001, 4.165269273000092],
              [117.37712649800005, 4.154364325000074],
              [117.379242384, 4.149237372000073],
              [117.38689212300005, 4.142482815000051],
              [117.39616946700005, 4.139634507000039],
              [117.40398196700005, 4.13548411700009],
              [117.40739993600005, 4.124986070000091],
              [117.40308678500003, 4.120347398000092],
              [117.39633222700002, 4.10968659100007],
              [117.39584394600001, 4.098944403000075],
              [117.41041100400003, 4.093939520000049],
              [117.43132571700005, 4.092596747000073],
              [117.45069420700008, 4.088120835000041],
              [117.46648196700005, 4.079901434000078],
              [117.47559655000009, 4.067328192000048],
              [117.46827233200008, 4.052923895000049],
              [117.46827233200008, 4.043524481000077],
              [117.47901451900009, 4.03937409100007],
              [117.48894290500004, 4.042954820000091],
              [117.49968509200005, 4.049790757000039],
              [117.51042728000004, 4.053941148000092],
              [117.52027428500003, 4.049302476000094],
              [117.61378014400009, 3.957098700000074],
              [117.62794030000009, 3.947088934000078],
              [117.66146894600001, 3.94017161700009],
              [117.67847741000003, 3.932440497000073],
              [117.68930097700002, 3.921454169000071],
              [117.68848717500009, 3.909002997000073],
              [117.67269941500001, 3.897772528000075],
              [117.65088951900009, 3.895209052000041],
              [117.62810306100005, 3.900376695000091],
              [117.59066816500001, 3.92609284100007],
              [117.57007897200003, 3.933172919000071],
              [117.52344811300009, 3.936346747000073],
              [117.52344811300009, 3.929510809000078],
              [117.55209394600001, 3.927150783000059],
              [117.57943769600001, 3.914536851000094],
              [117.60377037900003, 3.896714585000041],
              [117.62330162900003, 3.878607489000046],
              [117.63672936300009, 3.872870184000078],
              [117.65235436300009, 3.875148830000057],
              [117.66822350400003, 3.880031643000052],
              [117.68165123800009, 3.88226959800005],
              [117.68970787900003, 3.878810940000051],
              [117.719086134, 3.860581773000092],
              [117.72510826900009, 3.850897528000075],
              [117.77719160200002, 3.79913971600007],
              [117.78199303500003, 3.787339585000041],
              [117.78288821700005, 3.779038804000038],
              [117.77670332100001, 3.774115302000041],
              [117.76050866000003, 3.772406317000048],
              [117.70215905000009, 3.778713283000059],
              [117.71485436300009, 3.763576565000051],
              [117.73422285200002, 3.752142645000049],
              [117.77719160200002, 3.73773834800005],
              [117.81788170700008, 3.730047919000071],
              [117.82927493600005, 3.721584377000056],
              [117.82618248800009, 3.703599351000094],
              [117.81723066500001, 3.694810289000088],
              [117.78793379000001, 3.678656317000048],
              [117.77719160200002, 3.668850002000056],
              [117.76107832100001, 3.643744208000044],
              [117.74854576900009, 3.636948960000041],
              [117.65064537900003, 3.627875067000048],
              [117.62867272200003, 3.632066148000092],
              [117.58765709700003, 3.650864976000094],
              [117.56836998800009, 3.655096747000073],
              [117.54664147200003, 3.664007880000042],
              [117.53370201900009, 3.684759833000044],
              [117.52426191500001, 3.708889065000051],
              [117.50855553500003, 3.735907294000071],
              [117.50538170700008, 3.746771552000041],
              [117.50359134200005, 3.768744208000044],
              [117.49919681100005, 3.775580145000049],
              [117.48894290500004, 3.782171942000048],
              [117.46876061300009, 3.792303778000075],
              [117.47999108200008, 3.771185614000046],
              [117.48243248800009, 3.764960028000075],
              [117.49195397200003, 3.707098700000074],
              [117.49976647200003, 3.692694403000075],
              [117.51335696700005, 3.674872137000079],
              [117.52344811300009, 3.650213934000078],
              [117.52426191500001, 3.625433661000045],
              [117.50977623800009, 3.607367255000042],
              [117.49439537900003, 3.608343817000048],
              [117.45101972700002, 3.629299221000053],
              [117.43091881600003, 3.634670315000051],
              [117.30225670700008, 3.633246161000045],
              [117.21949303500003, 3.647365627000056],
              [117.09050540500004, 3.645819403000075],
              [117.05567467500009, 3.631903387000079],
              [117.03052819100003, 3.59438711100006],
              [117.05396569100003, 3.608303127000056],
              [117.08318118600005, 3.61664459800005],
              [117.11426842500009, 3.620591539000088],
              [117.16928144600001, 3.621039130000042],
              [117.19922936300009, 3.616278387000079],
              [117.21656334700003, 3.603013414000088],
              [117.20533287900003, 3.576971747000073],
              [117.19996178500003, 3.55499909100007],
              [117.21029707100001, 3.528876044000071],
              [117.22754967500009, 3.505194403000075],
              [117.24284915500004, 3.490668036000045],
              [117.25310306100005, 3.486070054000038],
              [117.29070071700005, 3.477036851000094],
              [117.30453535200002, 3.46938711100006],
              [117.31202233200008, 3.461127020000049],
              [117.32545006600003, 3.436021226000094],
              [117.34498131600003, 3.446519273000092],
              [117.37435957100001, 3.448635158000059],
              [117.40495853000004, 3.444484768000052],
              [117.42774498800009, 3.436021226000094],
              [117.43572024800005, 3.43431224200009],
              [117.44214928500003, 3.435695705000057],
              [117.44654381600003, 3.434759833000044],
              [117.44825280000009, 3.42609284100007],
              [117.44825280000009, 3.398504950000074],
              [117.44654381600003, 3.385199286000045],
              [117.44190514400009, 3.373032945000091],
              [117.43441816500001, 3.364325262000079],
              [117.42432701900009, 3.360988674000055],
              [117.414398634, 3.35618724200009],
              [117.40552819100003, 3.345607815000051],
              [117.39372806100005, 3.326239325000074],
              [117.38689212300005, 3.319891669000071],
              [117.37777754000001, 3.31313711100006],
              [117.36963951900009, 3.305243231000077],
              [117.36638431100005, 3.295803127000056],
              [117.36312910200002, 3.254868882000039],
              [117.35954837300005, 3.244289455000057],
              [117.34473717500009, 3.230454820000091],
              [117.33366946700005, 3.232123114000046],
              [117.31177819100003, 3.251695054000038],
              [117.281586134, 3.263251044000071],
              [117.273773634, 3.264797268000052],
              [117.26465905000009, 3.261786200000074],
              [117.26441491000003, 3.254339911000045],
              [117.26783287900003, 3.244533596000053],
              [117.27003014400009, 3.234320380000042],
              [117.28150475400003, 3.223089911000045],
              [117.35271243600005, 3.182806708000044],
              [117.37029056100005, 3.17719147300005],
              [117.38990319100003, 3.175197658000059],
              [117.43091881600003, 3.175360419000071],
              [117.45394941500001, 3.171210028000075],
              [117.45777428500003, 3.160345770000049],
              [117.45411217500009, 3.14516836100006],
              [117.45508873800009, 3.128159898000092],
              [117.48170006600003, 3.101263739000046],
              [117.52003014400009, 3.098456122000073],
              [117.56373131600003, 3.10187409100007],
              [117.605804884, 3.093410549000055],
              [117.61719811300009, 3.085882880000042],
              [117.62086022200003, 3.079494533000059],
              [117.62322024800005, 3.072455145000049],
              [117.63013756600003, 3.062974351000094],
              [117.63428795700008, 3.052394924000055],
              [117.62940514400009, 3.042385158000059],
              [117.61963951900009, 3.034898179000038],
              [117.60922285200002, 3.03196849200009],
              [117.60084069100003, 3.024969794000071],
              [117.57504316500001, 2.992865302000041],
              [117.56495201900009, 2.983547268000052],
              [117.58033287900003, 2.978989976000094],
              [117.60157311300009, 2.980658270000049],
              [117.62240644600001, 2.986476955000057],
              [117.63672936300009, 2.994126695000091],
              [117.65560957100001, 2.997381903000075],
              [117.67546634200005, 2.98578522300005],
              [117.68799889400009, 2.970648505000042],
              [117.68506920700008, 2.963080145000049],
              [117.66732832100001, 2.959540106000077],
              [117.63054446700005, 2.942328192000048],
              [117.61280358200008, 2.936428127000056],
              [117.54379316500001, 2.928941148000092],
              [117.54379316500001, 2.922105210000041],
              [117.56739342500009, 2.922552802000041],
              [117.64014733200008, 2.90851471600007],
              [117.73633873800009, 2.901597398000092],
              [117.72510826900009, 2.886542059000078],
              [117.70427493600005, 2.878973700000074],
              [117.68132571700005, 2.873277085000041],
              [117.66431725400003, 2.864081122000073],
              [117.62712649800005, 2.836981512000079],
              [117.61963951900009, 2.825506903000075],
              [117.63331139400009, 2.812241929000038],
              [117.67351321700005, 2.799261786000045],
              [117.71436608200008, 2.794094143000052],
              [117.75220787900003, 2.78461334800005],
              [117.78402754000001, 2.758246161000045],
              [117.79200280000009, 2.742336330000057],
              [117.79623457100001, 2.723211981000077],
              [117.80079186300009, 2.657171942000048],
              [117.80738366000003, 2.638006903000075],
              [117.81625410200002, 2.621527411000045],
              [117.82618248800009, 2.607407945000091],
              [117.86703535200002, 2.572699286000045],
              [117.88168379000001, 2.55141836100006],
              [117.97901451900009, 2.466538804000038],
              [117.98780358200008, 2.456366278000075],
              [117.99968509200005, 2.434271552000041],
              [118.00684655000009, 2.425523179000038],
              [118.02409915500004, 2.382025458000044],
              [118.03711998800009, 2.363959052000041],
              [118.04468834700003, 2.381537177000041],
              [118.06348717500009, 2.366929429000038],
              [118.08220462300005, 2.337469794000071],
              [118.09587649800005, 2.30414459800005],
              [118.09937584700003, 2.277818101000094],
              [118.09148196700005, 2.26203034100007],
              [118.05779056100005, 2.219956773000092],
              [118.04468834700003, 2.208929755000042],
              [117.97559655000009, 2.192084052000041],
              [117.955414259, 2.18227773600006],
              [117.94125410200002, 2.163153387000079],
              [117.93921959700003, 2.143377997000073],
              [117.93523196700005, 2.124172268000052],
              [117.91504967500009, 2.106512762000079],
              [117.91472415500004, 2.093491929000038],
              [117.88282311300009, 2.095445054000038],
              [117.82618248800009, 2.106512762000079],
              [117.84424889400009, 2.08820221600007],
              [117.88209069100003, 2.068060614000046],
              [117.90040123800009, 2.049994208000044],
              [117.85987389400009, 2.038275458000044],
              [117.82545006600003, 2.036281643000052],
              [117.79151451900009, 2.038275458000044],
              [117.75464928500003, 2.04633209800005],
              [117.74073326900009, 2.044989325000074],
              [117.75001061300009, 2.031439520000049],
              [117.76465905000009, 2.024969794000071],
              [117.80290774800005, 2.021307684000078],
              [117.81885826900009, 2.017157294000071],
              [117.83179772200003, 2.005682684000078],
              [117.84400475400003, 1.991441148000092],
              [117.85564212300005, 1.983384507000039],
              [117.86719811300009, 1.990464585000041],
              [117.873383009, 1.990464585000041],
              [117.87476647200003, 1.947495835000041],
              [117.87224368600005, 1.924709377000056],
              [117.86353600400003, 1.914740302000041],
              [117.85670006600003, 1.909369208000044],
              [117.85726972700002, 1.897650458000044],
              [117.86255944100003, 1.885931708000044],
              [117.87037194100003, 1.880601304000038],
              [117.88103274800005, 1.882066148000092],
              [117.88396243600005, 1.884100653000075],
              [117.88599694100003, 1.882554429000038],
              [117.89389082100001, 1.87376536700009],
              [117.90333092500009, 1.857407945000091],
              [117.91187584700003, 1.836859442000048],
              [117.92408287900003, 1.819159247000073],
              [117.94483483200008, 1.811712958000044],
              [117.96534264400009, 1.808417059000078],
              [117.98096764400009, 1.800767320000091],
              [117.99488366000003, 1.791693427000041],
              [118.01059004000001, 1.784369208000044],
              [118.03484134200005, 1.784898179000038],
              [118.04615319100003, 1.783107815000051],
              [118.05095462300005, 1.774481512000079],
              [118.04932701900009, 1.76203034100007],
              [118.04712975400003, 1.75226471600007],
              [118.04786217500009, 1.743557033000059],
              [118.05469811300009, 1.733465887000079],
              [118.12671959700003, 1.654689846000053],
              [118.18531334700003, 1.631781317000048],
              [118.27125084700003, 1.562730210000041],
              [118.31128991000003, 1.541978257000039],
              [118.35279381600003, 1.533596096000053],
              [118.36980228000004, 1.522772528000075],
              [118.39421634200005, 1.497015692000048],
              [118.41684004000001, 1.491848049000055],
              [118.42505944100003, 1.485744533000059],
              [118.41846764400009, 1.472845770000049],
              [118.40365644600001, 1.461737372000073],
              [118.39966881600003, 1.454413153000075],
              [118.40479576900009, 1.445217190000051],
              [118.41472415500004, 1.44086334800005],
              [118.43824303500003, 1.440578518000052],
              [118.44890384200005, 1.435532945000091],
              [118.45101972700002, 1.42845286700009],
              [118.45394941500001, 1.403225002000056],
              [118.45630944100003, 1.394598700000074],
              [118.46314537900003, 1.394598700000074],
              [118.47624759200005, 1.402044989000046],
              [118.49219811300009, 1.395697333000044],
              [118.52393639400009, 1.374172268000052],
              [118.53598066500001, 1.370672919000071],
              [118.58228600400003, 1.367336330000057],
              [118.61329186300009, 1.351223049000055],
              [118.67514082100001, 1.280422268000052],
              [118.71290123800009, 1.26430898600006],
              [118.72925866000003, 1.253851630000042],
              [118.75416100400003, 1.229559637000079],
              [118.77637780000009, 1.201971747000073],
              [118.78467858200008, 1.181708075000074],
              [118.78052819100003, 1.177313544000071],
              [118.77361087300005, 1.175726630000042],
              [118.76710045700008, 1.172674872000073],
              [118.76417076900009, 1.164007880000042],
              [118.79786217500009, 1.149969794000071],
              [118.808929884, 1.139715887000079],
              [118.82618248800009, 1.119696356000077],
              [118.85694420700008, 1.058172919000071],
              [118.87086022200003, 1.056301174000055],
              [118.87818444100003, 1.055975653000075],
              [118.88770592500009, 1.058172919000071],
              [118.89437910200002, 1.06281159100007],
              [118.90650475400003, 1.075384833000044],
              [118.91553795700008, 1.078599351000094],
              [118.933929884, 1.076076565000051],
              [118.98519941500001, 1.057562567000048],
              [119.00098717500009, 1.047919012000079],
              [119.00554446700005, 1.037583726000094],
              [119.00318444100003, 1.026312567000048],
              [118.99903405000009, 1.014634507000039],
              [118.99756920700008, 1.003607489000046],
              [119.00066165500004, 0.999090887000079],
              [119.00635826900009, 0.99485911700009],
              [119.01124108200008, 0.988226630000042],
              [119.01172936300009, 0.976263739000046],
              [119.00294030000009, 0.962469794000071],
              [118.97055097700002, 0.935736395000049],
              [118.95655358200008, 0.912665106000077],
              [118.93995201900009, 0.902085679000038],
              [118.86500084700003, 0.868841864000046],
              [118.85132897200003, 0.856919664000088],
              [118.84099368600005, 0.829901434000078],
              [118.82837975400003, 0.818101304000038],
              [118.81275475400003, 0.809149481000077],
              [118.79818769600001, 0.804917710000041],
              [118.78630618600005, 0.804592190000051],
              [118.77426191500001, 0.805731512000079],
              [118.76319420700008, 0.809027411000045],
              [118.74170983200008, 0.822170315000051],
              [118.71753991000003, 0.828273830000057],
              [118.70582116000003, 0.835923570000091],
              [118.68604576900009, 0.846136786000045],
              [118.66277103000004, 0.846380927000041],
              [118.63941491000003, 0.840521552000041],
              [118.58318118600005, 0.813666083000044],
              [118.57545006600003, 0.808335679000038],
              [118.56527754000001, 0.804022528000075],
              [118.55469811300009, 0.807928778000075],
              [118.54395592500009, 0.814520575000074],
              [118.53419030000009, 0.818019924000055],
              [118.51417076900009, 0.822007554000038],
              [118.47348066500001, 0.838283596000053],
              [118.42839603000004, 0.839992580000057],
              [118.41871178500003, 0.837225653000075],
              [118.41098066500001, 0.821844794000071],
              [118.40235436300009, 0.813950914000088],
              [118.39193769600001, 0.807603257000039],
              [118.38396243600005, 0.804917710000041],
              [118.36719811300009, 0.810370184000078],
              [118.35645592500009, 0.823228257000039],
              [118.34685306100005, 0.839016018000052],
              [118.33277428500003, 0.852728583000044],
              [118.31690514400009, 0.85883209800005],
              [118.187836134, 0.875230210000041],
              [118.12907962300005, 0.893011786000045],
              [118.09669030000009, 0.908636786000045],
              [118.06918379000001, 0.928778387000079],
              [118.04468834700003, 0.955145575000074],
              [118.02849368600005, 0.984523830000057],
              [118.00554446700005, 1.051011460000041],
              [117.98951256600003, 1.078599351000094],
              [117.97584069100003, 1.088120835000041],
              [117.93677819100003, 1.10814036700009],
              [117.92872155000009, 1.116603908000059],
              [117.92400149800005, 1.124986070000091],
              [117.91334069100003, 1.124945380000042],
              [117.90162194100003, 1.11985911700009],
              [117.89389082100001, 1.113470770000049],
              [117.890961134, 1.104193427000041],
              [117.89283287900003, 1.094875393000052],
              [117.90137780000009, 1.078599351000094],
              [117.93360436300009, 1.038763739000046],
              [117.93799889400009, 1.031480210000041],
              [117.97527103000004, 0.983099677000041],
              [117.97974694100003, 0.966213283000059],
              [117.98462975400003, 0.926214911000045],
              [117.99293053500003, 0.91079336100006],
              [117.99586022200003, 0.906724351000094],
              [118.00318444100003, 0.893744208000044],
              [118.00562584700003, 0.891913153000075],
              [118.01417076900009, 0.88812897300005],
              [118.01685631600003, 0.886216539000088],
              [118.02475019600001, 0.872788804000038],
              [118.03044681100005, 0.858954169000071],
              [118.03402754000001, 0.843329169000071],
              [118.03630618600005, 0.820705471000053],
              [118.03296959700003, 0.80023834800005],
              [118.02051842500009, 0.79132721600007],
              [118.00521894600001, 0.788763739000046],
              [117.99390709700003, 0.788478908000059],
              [117.98267662900003, 0.79132721600007],
              [117.97331790500004, 0.798488674000055],
              [117.96241295700008, 0.817084052000041],
              [117.955414259, 0.825425523000092],
              [117.94743899800005, 0.831122137000079],
              [117.93816165500004, 0.835638739000046],
              [117.92725670700008, 0.838690497000073],
              [117.91407311300009, 0.839667059000078],
              [117.90251712300005, 0.837469794000071],
              [117.89478600400003, 0.832586981000077],
              [117.88933353000004, 0.827704169000071],
              [117.88428795700008, 0.825425523000092],
              [117.85035241000003, 0.824286200000074],
              [117.82935631600003, 0.820257880000042],
              [117.81128991000003, 0.811753648000092],
              [117.78834069100003, 0.792303778000075],
              [117.74317467500009, 0.74054596600007],
              [117.72950280000009, 0.71556224200009],
              [117.72486412900003, 0.65265534100007],
              [117.719086134, 0.636786200000074],
              [117.69581139400009, 0.617092190000051],
              [117.68848717500009, 0.606350002000056],
              [117.68441816500001, 0.596380927000041],
              [117.67904707100001, 0.574693101000094],
              [117.67481530000009, 0.56476471600007],
              [117.62037194100003, 0.502020575000074],
              [117.61280358200008, 0.479071356000077],
              [117.61548912900003, 0.469183661000045],
              [117.62623131600003, 0.444037177000041],
              [117.62712649800005, 0.434393622000073],
              [117.61931399800005, 0.423895575000074],
              [117.60767662900003, 0.417181708000044],
              [117.59538821700005, 0.412298895000049],
              [117.58545983200008, 0.407131252000056],
              [117.56950931100005, 0.389064846000053],
              [117.55372155000009, 0.349514065000051],
              [117.51726321700005, 0.290961005000042],
              [117.51441491000003, 0.280340887000079],
              [117.515961134, 0.275295315000051],
              [117.51954186300009, 0.271063544000071],
              [117.52344811300009, 0.263088283000059],
              [117.52654056100005, 0.242173570000091],
              [117.52312259200005, 0.225775458000044],
              [117.51392662900003, 0.211859442000048],
              [117.49097741000003, 0.189886786000045],
              [117.48365319100003, 0.178859768000052],
              [117.48015384200005, 0.166489976000094],
              [117.48243248800009, 0.153794664000088],
              [117.48829186300009, 0.15110911700009],
              [117.49822024800005, 0.150824286000045],
              [117.50912519600001, 0.148586330000057],
              [117.51726321700005, 0.140204169000071],
              [117.50684655000009, 0.133042710000041],
              [117.48365319100003, 0.124823309000078],
              [117.47559655000009, 0.119086005000042],
              [117.46998131600003, 0.108791408000059],
              [117.47055097700002, 0.10219961100006],
              [117.47364342500009, 0.095526434000078],
              [117.47559655000009, 0.085598049000055],
              [117.47486412900003, 0.074774481000077],
              [117.47364342500009, 0.069240627000056],
              [117.47339928500003, 0.064886786000045],
              [117.47559655000009, 0.057603257000039],
              [117.48243248800009, 0.054592190000051],
              [117.49219811300009, 0.054632880000042],
              [117.49708092500009, 0.051011460000041],
              [117.48910566500001, 0.037176825000074],
              [117.50001061300009, 0.033026434000078],
              [117.50904381600003, 0.02602773600006],
              [117.51685631600003, 0.01593659100007],
              [117.52344811300009, 0.003078518000052],
              [117.52906334700003, -0.019463799999926],
              [117.53028405000009, -0.032321872999944],
              [117.52686608200008, -0.037896416999956],
              [117.52523847700002, -0.042046807999952],
              [117.51286868600005, -0.05913665199995],
              [117.50733483200008, -0.069634697999959],
              [117.49488366000003, -0.080336195999962],
              [117.48910566500001, -0.085707289999959],
              [117.48487389400009, -0.092217705999929],
              [117.46949303500003, -0.128838799999926],
              [117.46534264400009, -0.144463799999926],
              [117.46192467500009, -0.185723565999922],
              [117.45639082100001, -0.205498955999929],
              [117.43506920700008, -0.239678643999923],
              [117.433929884, -0.263848565999922],
              [117.44206790500004, -0.281914971999925],
              [117.45777428500003, -0.308200778999947],
              [117.47461998800009, -0.330254815999922],
              [117.48585045700008, -0.335870049999926],
              [117.49537194100003, -0.333754164999959],
              [117.49708092500009, -0.350274346999925],
              [117.49398847700002, -0.372653903999947],
              [117.48910566500001, -0.387383721999925],
              [117.46753991000003, -0.411553643999923],
              [117.45753014400009, -0.42701588299991],
              [117.45850670700008, -0.438897393999923],
              [117.46648196700005, -0.457289320999962],
              [117.46241295700008, -0.479913018999923],
              [117.45215905000009, -0.501722914999959],
              [117.44141686300009, -0.517754815999922],
              [117.44141686300009, -0.525160414999959],
              [117.474945509, -0.50904713299991],
              [117.59595787900003, -0.422621351999908],
              [117.615570509, -0.415215752999927],
              [117.63013756600003, -0.418715101999908],
              [117.63884524800005, -0.436455987999921],
              [117.63160241000003, -0.447523695999962],
              [117.61931399800005, -0.456231377999927],
              [117.61280358200008, -0.466892184999949],
              [117.60547936300009, -0.476169528999947],
              [117.57048587300005, -0.485039971999925],
              [117.55811608200008, -0.490411065999922],
              [117.55453535200002, -0.502699476999908],
              [117.58952884200005, -0.51100025799991],
              [117.59896894600001, -0.521416924999926],
              [117.59750410200002, -0.559502862999921],
              [117.59351647200003, -0.574639580999929],
              [117.58073978000004, -0.592950127999927],
              [117.578461134, -0.59693775799991],
              [117.57390384200005, -0.599053643999923],
              [117.54297936300009, -0.600681247999944],
              [117.53614342500009, -0.602959893999923],
              [117.53028405000009, -0.60711028399993],
              [117.53028405000009, -0.613946221999925],
              [117.54712975400003, -0.619724216999941],
              [117.56519616000003, -0.622816664999959],
              [117.57593834700003, -0.629978122999944],
              [117.57178795700008, -0.64812590899993],
              [117.55990644600001, -0.658298434999949],
              [117.54615319100003, -0.665622653999947],
              [117.53988691500001, -0.674493096999925],
              [117.55128014400009, -0.689629815999922],
              [117.53931725400003, -0.694512627999927],
              [117.52751712300005, -0.693942966999941],
              [117.49976647200003, -0.689629815999922],
              [117.48585045700008, -0.692803643999923],
              [117.48292076900009, -0.699639580999929],
              [117.48853600400003, -0.706475518999923],
              [117.49976647200003, -0.709567966999941],
              [117.52068118600005, -0.712823174999926],
              [117.57504316500001, -0.727308851999908],
              [117.60238691500001, -0.730645440999922],
              [117.613617384, -0.73406340899993],
              [117.62208092500009, -0.743096612999921],
              [117.62680097700002, -0.755954684999949],
              [117.62712649800005, -0.770928643999923],
              [117.62273196700005, -0.781508070999962],
              [117.61500084700003, -0.786065362999921],
              [117.58570397200003, -0.792413018999923],
              [117.57154381600003, -0.790785414999959],
              [117.56495201900009, -0.791436455999929],
              [117.55795332100001, -0.795668226999908],
              [117.54460696700005, -0.808851820999962],
              [117.53760826900009, -0.812595309999949],
              [117.48910566500001, -0.798923434999949],
              [117.49350019600001, -0.82781340899993],
              [117.45818118600005, -0.820489190999922],
              [117.44825280000009, -0.842950127999927],
              [117.45191491000003, -0.86646900799991],
              [117.44654381600003, -0.877048434999949],
              [117.42774498800009, -0.880791924999926],
              [117.41285241000003, -0.874932549999926],
              [117.39087975400003, -0.848565362999921],
              [117.379242384, -0.839288018999923],
              [117.37468509200005, -0.855889580999929],
              [117.36378014400009, -0.878513278999947],
              [117.35035241000003, -0.896905205999929],
              [117.33904056100005, -0.901299737999921],
              [117.33277428500003, -0.891778252999927],
              [117.33082116000003, -0.877699476999908],
              [117.33220462300005, -0.850192966999941],
              [117.32789147200003, -0.84148528399993],
              [117.301117384, -0.816013278999947],
              [117.28150475400003, -0.809177341999941],
              [117.26742597700002, -0.828301690999922],
              [117.25928795700008, -0.858330987999921],
              [117.25652103000004, -0.884209893999923],
              [117.250336134, -0.909274997999944],
              [117.23511803500003, -0.924493096999925],
              [117.19507897200003, -0.949151299999926],
              [117.16391035200002, -0.98170338299991],
              [117.06519616000003, -1.121840101999908],
              [117.03923587300005, -1.137790622999944],
              [117.03288821700005, -1.159356377999927],
              [117.029633009, -1.184177341999941],
              [117.02369225400003, -1.202894789999959],
              [117.00782311300009, -1.216403903999947],
              [116.98340905000009, -1.229668877999927],
              [116.95769290500004, -1.23992278399993],
              [116.85181725400003, -1.264418226999908],
              [116.82984459700003, -1.265801690999922],
              [116.81983483200008, -1.26140715899993],
              [116.81739342500009, -1.247491143999923],
              [116.81763756600003, -1.22039153399993],
              [116.82935631600003, -1.204034112999921],
              [116.83073978000004, -1.19500090899993],
              [116.81763756600003, -1.189385674999926],
              [116.81137129000001, -1.19264088299991],
              [116.80518639400009, -1.201348565999922],
              [116.79712975400003, -1.217217705999929],
              [116.79322350400003, -1.203301690999922],
              [116.79249108200008, -1.17115650799991],
              [116.787445509, -1.158868096999925],
              [116.74634850400003, -1.110528252999927],
              [116.74333743600005, -1.085381768999923],
              [116.75684655000009, -1.023695570999962],
              [116.74317467500009, -1.024834893999923],
              [116.728851759, -1.044040622999944],
              [116.72038821700005, -1.070977471999925],
              [116.71534264400009, -1.124769789999959],
              [116.71949303500003, -1.136325778999947],
              [116.74935957100001, -1.168877862999921],
              [116.75709069100003, -1.182224216999941],
              [116.75757897200003, -1.188409112999921],
              [116.75391686300009, -1.193454684999949],
              [116.74935957100001, -1.202894789999959],
              [116.73796634200005, -1.215020440999922],
              [116.73609459700003, -1.220961195999962],
              [116.77735436300009, -1.233982028999947],
              [116.77906334700003, -1.236423434999949],
              [116.78321373800009, -1.23756275799991],
              [116.78777103000004, -1.239434502999927],
              [116.79086347700002, -1.243910414999959],
              [116.79086347700002, -1.249118747999944],
              [116.78891035200002, -1.254489841999941],
              [116.77906334700003, -1.273858330999929],
              [116.76661217500009, -1.287692966999941],
              [116.76303144600001, -1.29851653399993],
              [116.76742597700002, -1.344333591999941],
              [116.76238040500004, -1.365329684999949],
              [116.73975670700008, -1.37428150799991],
              [116.71900475400003, -1.377211195999962],
              [116.609711134, -1.420586846999925],
              [116.56763756600003, -1.44654713299991],
              [116.53923587300005, -1.481215101999908],
              [116.53711998800009, -1.525648695999962],
              [116.54460696700005, -1.540459893999923],
              [116.55355879000001, -1.551364841999941],
              [116.56120853000004, -1.56373463299991],
              [116.56446373800009, -1.583428643999923],
              [116.55746504000001, -1.606215101999908],
              [116.54021243600005, -1.62273528399993],
              [116.51783287900003, -1.634372653999947],
              [116.42994225400003, -1.659356377999927],
              [116.39079837300005, -1.684502862999921],
              [116.34571373800009, -1.695977471999925],
              [116.32488040500004, -1.703871351999908],
              [116.27198326900009, -1.74928150799991],
              [116.26335696700005, -1.761895440999922],
              [116.23194420700008, -1.777113539999959],
              [116.22242272200003, -1.789646091999941],
              [116.24293053500003, -1.805759372999944],
              [116.26099694100003, -1.808526299999926],
              [116.28589928500003, -1.807061455999929],
              [116.30787194100003, -1.800876559999949],
              [116.31739342500009, -1.789239190999922],
              [116.32105553500003, -1.782810153999947],
              [116.33008873800009, -1.778090101999908],
              [116.35141035200002, -1.772149346999925],
              [116.35743248800009, -1.772230726999908],
              [116.36670983200008, -1.778090101999908],
              [116.37256920700008, -1.77898528399993],
              [116.37281334700003, -1.776950778999947],
              [116.37916100400003, -1.767347914999959],
              [116.37956790500004, -1.76531340899993],
              [116.40259850400003, -1.763929945999962],
              [116.42481530000009, -1.766371351999908],
              [116.44166100400003, -1.776055596999925],
              [116.44825280000009, -1.796075127999927],
              [116.43287194100003, -1.821872653999947],
              [116.41358483200008, -1.847263278999947],
              [116.45183353000004, -1.883965752999927],
              [116.46656334700003, -1.90748463299991],
              [116.45045006600003, -1.957452080999929],
              [116.46314537900003, -2.019952080999929],
              [116.45785566500001, -2.042413018999923],
              [116.43848717500009, -2.066989841999941],
              [116.42693118600005, -2.076348565999922],
              [116.35889733200008, -2.093682549999926],
              [116.33668053500003, -2.108168226999908],
              [116.31218509200005, -2.129001559999949],
              [116.29200280000009, -2.150974216999941],
              [116.28321373800009, -2.169366143999923],
              [116.289398634, -2.169366143999923],
              [116.33716881600003, -2.146091403999947],
              [116.37086022200003, -2.137872002999927],
              [116.38624108200008, -2.152276299999926],
              [116.39283287900003, -2.19109465899993],
              [116.41065514400009, -2.203789971999925],
              [116.43702233200008, -2.198337497999944],
              [116.50066165500004, -2.169691664999959],
              [116.51783287900003, -2.166436455999929],
              [116.53093509200005, -2.169366143999923],
              [116.531586134, -2.177829684999949],
              [116.53541100400003, -2.195245049999926],
              [116.54273522200003, -2.209242445999962],
              [116.55445397200003, -2.207207940999922],
              [116.56625410200002, -2.197686455999929],
              [116.58326256600003, -2.187676690999922],
              [116.59864342500009, -2.183851820999962],
              [116.60547936300009, -2.193617445999962],
              [116.60328209700003, -2.224216403999947],
              [116.57292728000004, -2.362806898999906],
              [116.54004967500009, -2.512872002999927],
              [116.517914259, -2.553887627999927],
              [116.48243248800009, -2.560316664999959],
              [116.47315514400009, -2.547458591999941],
              [116.46810957100001, -2.526462497999944],
              [116.46094811300009, -2.507012627999927],
              [116.44459069100003, -2.498304945999962],
              [116.41895592500009, -2.496514580999929],
              [116.40674889400009, -2.498304945999962],
              [116.40162194100003, -2.500746351999908],
              [116.39185631600003, -2.509209893999923],
              [116.38624108200008, -2.511976820999962],
              [116.37973066500001, -2.511895440999922],
              [116.37427819100003, -2.509372653999947],
              [116.36963951900009, -2.506442966999941],
              [116.36573326900009, -2.50514088299991],
              [116.33326256600003, -2.511163018999923],
              [116.32105553500003, -2.511976820999962],
              [116.31006920700008, -2.516289971999925],
              [116.30420983200008, -2.525648695999962],
              [116.303070509, -2.535088799999926],
              [116.30713951900009, -2.539320570999962],
              [116.32374108200008, -2.547539971999925],
              [116.32081139400009, -2.566989841999941],
              [116.29688561300009, -2.608168226999908],
              [116.31055748800009, -2.615004164999959],
              [116.34156334700003, -2.566582940999922],
              [116.36622155000009, -2.556735934999949],
              [116.38200931100005, -2.557712497999944],
              [116.39307701900009, -2.573988539999959],
              [116.39039147200003, -2.589043877999927],
              [116.37061608200008, -2.632907809999949],
              [116.36573326900009, -2.652601820999962],
              [116.36996504000001, -2.82390715899993],
              [116.36475670700008, -2.861423434999949],
              [116.35141035200002, -2.89617278399993],
              [116.33423912900003, -2.925551039999959],
              [116.28760826900009, -2.987074476999908],
              [116.26335696700005, -3.005466403999947],
              [116.24382571700005, -3.00904713299991],
              [116.22877037900003, -3.00164153399993],
              [116.21900475400003, -2.985039971999925],
              [116.21461022200003, -2.938653252999927],
              [116.21241295700008, -2.930352471999925],
              [116.20818118600005, -2.922946872999944],
              [116.19996178500003, -2.915215752999927],
              [116.18360436300009, -2.909356377999927],
              [116.17408287900003, -2.903008721999925],
              [116.16570071700005, -2.889092705999929],
              [116.15919030000009, -2.867445570999962],
              [116.15503991000003, -2.843926690999922],
              [116.15357506600003, -2.82390715899993],
              [116.15064537900003, -2.816338799999926],
              [116.14454186300009, -2.816827080999929],
              [116.13770592500009, -2.823418877999927],
              [116.13306725400003, -2.834161065999922],
              [116.13396243600005, -2.840020440999922],
              [116.13965905000009, -2.857842705999929],
              [116.13982181100005, -2.868910414999959],
              [116.13062584700003, -2.88990650799991],
              [116.11744225400003, -2.909763278999947],
              [116.11133873800009, -2.930271091999941],
              [116.12281334700003, -2.953871351999908],
              [116.12671959700003, -2.96607838299991],
              [116.11963951900009, -2.976495049999926],
              [116.10987389400009, -2.986586195999962],
              [116.10572350400003, -2.997979424999926],
              [116.11019941500001, -3.006280205999929],
              [116.11833743600005, -3.005303643999923],
              [116.13306725400003, -2.997979424999926],
              [116.16138756600003, -3.003513278999947],
              [116.16749108200008, -3.014825127999927],
              [116.16732832100001, -3.030694268999923],
              [116.17750084700003, -3.049899997999944],
              [116.19206790500004, -3.063571872999944],
              [116.25489342500009, -3.10865650799991],
              [116.26726321700005, -3.124200127999927],
              [116.26490319100003, -3.136895440999922],
              [116.21924889400009, -3.146661065999922],
              [116.18018639400009, -3.161309502999927],
              [116.16724694100003, -3.156345309999949],
              [116.16334069100003, -3.172946872999944],
              [116.18327884200005, -3.20826588299991],
              [116.18767337300005, -3.232028903999947],
              [116.18132571700005, -3.255954684999949],
              [116.16846764400009, -3.265801690999922],
              [116.14966881600003, -3.270684502999927],
              [116.12623131600003, -3.279880466999941],
              [116.12769616000003, -3.264825127999927],
              [116.13428795700008, -3.254327080999929],
              [116.14356530000009, -3.251560153999947],
              [116.15357506600003, -3.259372653999947],
              [116.16065514400009, -3.253024997999944],
              [116.16724694100003, -3.245700778999947],
              [116.17212975400003, -3.226169528999947],
              [116.15601647200003, -3.225681247999944],
              [116.12281334700003, -3.238213799999926],
              [116.11052493600005, -3.246189059999949],
              [116.10027103000004, -3.26490650799991],
              [116.08521569100003, -3.307061455999929],
              [116.02344811300009, -3.41179778399993],
              [116.00953209700003, -3.451104424999926],
              [115.99976647200003, -3.540134372999944],
              [115.98951256600003, -3.582696221999925],
              [115.96794681100005, -3.608819268999923],
              [115.94890384200005, -3.614190362999921],
              [115.88257897200003, -3.61492278399993],
              [115.85816491000003, -3.620212497999944],
              [115.83619225400003, -3.633233330999929],
              [115.79664147200003, -3.66961028399993],
              [115.75879967500009, -3.69695403399993],
              [115.58334394600001, -3.78053150799991],
              [115.31364993600005, -3.883070570999905],
              [115.06031334700003, -3.985772393999923],
              [114.87598717500009, -4.070977471999925],
              [114.71290123800009, -4.170830987999921],
              [114.66431725400003, -4.184177341999941],
              [114.62476647200003, -4.170505466999941],
              [114.60661868600005, -4.132256768999923],
              [114.61060631600003, -4.088799737999921],
              [114.63160241000003, -4.012872002999927],
              [114.61133873800009, -3.926364841999941],
              [114.60425866000003, -3.85515715899993],
              [114.61109459700003, -3.683851820999905],
              [114.59644616000003, -3.637872002999927],
              [114.53687584700003, -3.563409112999921],
              [114.52230879000001, -3.519301039999959],
              [114.52393639400009, -3.47584400799991],
              [114.55030358200008, -3.348077080999929],
              [114.52906334700003, -3.357354424999926],
              [114.51172936300009, -3.367608330999929],
              [114.50001061300009, -3.382745049999926],
              [114.48829186300009, -3.488376559999949],
              [114.47681725400003, -3.500664971999925],
              [114.451508009, -3.498711846999925],
              [114.412445509, -3.485284112999921],
              [114.36793053500003, -3.458591403999947],
              [114.28882897200003, -3.424493096999925],
              [114.27222741000003, -3.413262627999927],
              [114.26351972700002, -3.397556247999944],
              [114.26514733200008, -3.378350518999923],
              [114.27540123800009, -3.362399997999944],
              [114.29297936300009, -3.355564059999949],
              [114.30193118600005, -3.345798434999949],
              [114.32374108200008, -3.279880466999941],
              [114.35084069100003, -3.248955987999921],
              [114.35962975400003, -3.234470309999949],
              [114.36475670700008, -3.211521091999941],
              [114.32406660200002, -3.247979424999926],
              [114.28956139400009, -3.306410414999959],
              [114.24805748800009, -3.360284112999921],
              [114.18653405000009, -3.382256768999923],
              [114.15316816500001, -3.378350518999923],
              [114.12582441500001, -3.367852471999925],
              [114.10824629000001, -3.34734465899993],
              [114.10401451900009, -3.313897393999923],
              [114.12256920700008, -3.21607838299991],
              [114.11768639400009, -3.190362237999921],
              [114.11231530000009, -3.19890715899993],
              [114.10889733200008, -3.208428643999923],
              [114.09929446700005, -3.253350518999923],
              [114.09717858200008, -3.276055596999925],
              [114.09400475400003, -3.281182549999926],
              [114.08033287900003, -3.291273695999962],
              [114.04200280000009, -3.355564059999949],
              [113.98064212300005, -3.385023695999962],
              [113.94800866000003, -3.394789320999962],
              [113.88550866000003, -3.430596612999921],
              [113.81470787900003, -3.455254815999922],
              [113.71314537900003, -3.472588799999926],
              [113.63249759200005, -3.456801039999959],
              [113.62476647200003, -3.382256768999923],
              [113.63754316500001, -3.341729424999926],
              [113.64380944100003, -3.298435153999947],
              [113.64210045700008, -3.255954684999949],
              [113.62037194100003, -3.185316664999959],
              [113.61150149800005, -3.174248955999929],
              [113.59351647200003, -3.170017184999949],
              [113.50806725400003, -3.170017184999949],
              [113.48617597700002, -3.174737237999921],
              [113.46631920700008, -3.184258721999925],
              [113.45215905000009, -3.199395440999922],
              [113.44662519600001, -3.221123955999929],
              [113.43970787900003, -3.238457940999922],
              [113.42302493600005, -3.247247002999927],
              [113.36573326900009, -3.252862237999921],
              [113.35279381600003, -3.24928150799991],
              [113.34587649800005, -3.237888278999947],
              [113.34359785200002, -3.214613539999959],
              [113.33961022200003, -3.200290622999944],
              [113.32935631600003, -3.182793877999927],
              [113.31592858200008, -3.168064059999949],
              [113.30274498800009, -3.162530205999929],
              [113.34522545700008, -3.246514580999929],
              [113.35108483200008, -3.272393487999921],
              [113.29932701900009, -3.214613539999959],
              [113.28500410200002, -3.204196872999944],
              [113.25464928500003, -3.186944268999923],
              [113.24122155000009, -3.176853122999944],
              [113.23047936300009, -3.164320570999962],
              [113.22169030000009, -3.149997653999947],
              [113.21558678500003, -3.134209893999923],
              [113.20997155000009, -3.103773695999962],
              [113.20167076900009, -3.09303150799991],
              [113.18262780000009, -3.077080987999921],
              [113.15919030000009, -3.064629815999922],
              [113.12826582100001, -3.054945570999962],
              [113.10132897200003, -3.042575778999947],
              [113.03516686300009, -2.922946872999944],
              [113.03711998800009, -2.993096612999921],
              [113.03150475400003, -3.008884372999944],
              [113.02523847700002, -3.017347914999959],
              [113.01734459700003, -3.03679778399993],
              [113.00782311300009, -3.046482028999947],
              [113.00342858200008, -3.047458591999941],
              [112.99195397200003, -3.045668226999908],
              [112.98731530000009, -3.046482028999947],
              [112.98316491000003, -3.049737237999921],
              [112.97632897200003, -3.057549737999921],
              [112.96338951900009, -3.069024346999925],
              [112.94906660200002, -3.086032809999949],
              [112.94109134200005, -3.106377862999921],
              [112.94947350400003, -3.125176690999922],
              [112.96192467500009, -3.13836028399993],
              [112.96843509200005, -3.143975518999923],
              [112.97982832100001, -3.149509372999944],
              [112.99048912900003, -3.151788018999923],
              [113.01140384200005, -3.153252862999921],
              [113.02149498800009, -3.156345309999949],
              [113.02149498800009, -3.162530205999929],
              [112.66976972700002, -3.388604424999926],
              [112.63803144600001, -3.416761976999908],
              [112.61801191500001, -3.423760674999926],
              [112.58155358200008, -3.415948174999926],
              [112.57593834700003, -3.420098565999922],
              [112.57309004000001, -3.430352471999925],
              [112.56576582100001, -3.437920830999929],
              [112.55591881600003, -3.44264088299991],
              [112.54509524800005, -3.444268487999921],
              [112.52466881600003, -3.437758070999962],
              [112.39047285200002, -3.339939059999949],
              [112.34896894600001, -3.322849216999941],
              [112.30274498800009, -3.313897393999923],
              [112.20289147200003, -3.329522393999923],
              [112.11687259200005, -3.382256768999923],
              [111.97315514400003, -3.525567315999922],
              [111.93100019600007, -3.559014580999929],
              [111.90528405000003, -3.572035414999959],
              [111.88721764400003, -3.570245049999926],
              [111.86947675900007, -3.560153903999947],
              [111.82203209700003, -3.545098565999922],
              [111.80876712300005, -3.532972914999959],
              [111.80836022200003, -3.511814059999949],
              [111.82976321700005, -3.468194268999923],
              [111.83529707100007, -3.447686455999929],
              [111.84294681100005, -3.38445403399993],
              [111.84278405000003, -3.361748955999929],
              [111.81495201900003, -3.190362237999921],
              [111.81755618600005, -3.144463799999926],
              [111.83253014400003, -3.061618747999944],
              [111.82243899800005, -3.018487237999921],
              [111.76026451900003, -2.907647393999923],
              [111.75407962300005, -2.868910414999959],
              [111.75407962300005, -2.82390715899993],
              [111.75098717500003, -2.820407809999949],
              [111.74382571700005, -2.817478122999944],
              [111.73682701900003, -2.812676690999922],
              [111.73357181100005, -2.803399346999925],
              [111.73747806100005, -2.783379815999922],
              [111.75277754000007, -2.756280205999929],
              [111.75407962300005, -2.738539320999962],
              [111.73943118600005, -2.746189059999949],
              [111.72348066500007, -2.75904713299991],
              [111.71078535200007, -2.774590752999927],
              [111.70573978000004, -2.789727471999925],
              [111.71265709700003, -2.835056247999944],
              [111.71314537900003, -2.848402601999908],
              [111.70801842500003, -2.859633070999962],
              [111.69874108200003, -2.868096612999921],
              [111.68978925900007, -2.874200127999927],
              [111.68580162900003, -2.878838799999926],
              [111.68311608200003, -2.882989190999922],
              [111.67750084700003, -2.88795338299991],
              [111.67253665500004, -2.894626559999949],
              [111.67156009200005, -2.903008721999925],
              [111.67546634200005, -2.911065362999921],
              [111.68091881600003, -2.914483330999929],
              [111.68677819100003, -2.916924737999921],
              [111.69556725400003, -2.926202080999929],
              [111.70004316500007, -2.928155205999929],
              [111.70394941500007, -2.931817315999922],
              [111.70573978000004, -2.940036716999941],
              [111.70346113400007, -2.943617445999962],
              [111.69418379000007, -2.94304778399993],
              [111.69206790500004, -2.946872653999947],
              [111.64893639400003, -2.962009372999944],
              [111.58432050900007, -3.008884372999944],
              [111.56983483200003, -3.015720309999949],
              [111.55176842500003, -3.018487237999921],
              [111.53435306100005, -3.012139580999929],
              [111.52572675900007, -2.996840101999908],
              [111.52084394600007, -2.978936455999929],
              [111.51441491000003, -2.963799737999921],
              [111.48568769600007, -2.941501559999949],
              [111.44752037900003, -2.929782809999949],
              [111.36304772200003, -2.922946872999944],
              [111.32422936300003, -2.925957940999922],
              [111.29615319100003, -2.936455987999921],
              [111.06080162900003, -3.061130466999941],
              [110.98617597700007, -3.087497653999947],
              [110.94239342500003, -3.09148528399993],
              [110.90650475400003, -3.08326588299991],
              [110.82374108200003, -3.037204684999949],
              [110.80665123800003, -3.032972914999959],
              [110.77027428500003, -3.032159112999921],
              [110.75424238400007, -3.026055596999925],
              [110.75554446700005, -3.011814059999949],
              [110.76498457100007, -2.99578215899993],
              [110.77409915500004, -2.984307549999926],
              [110.80437259200005, -2.959079684999949],
              [110.83790123800003, -2.94500090899993],
              [110.87208092500003, -2.93523528399993],
              [110.95606530000003, -2.90007903399993],
              [110.96583092500003, -2.899590752999927],
              [110.95606530000003, -2.879001559999949],
              [110.93409264400003, -2.883884372999944],
              [110.89698326900003, -2.90984465899993],
              [110.87940514400003, -2.918145440999922],
              [110.83008873800003, -2.933770440999922],
              [110.81153405000003, -2.936618747999944],
              [110.79395592500003, -2.943536065999922],
              [110.77686608200003, -2.959730726999908],
              [110.69792728000004, -3.062676690999922],
              [110.66244550900007, -3.080743096999925],
              [110.63062584700003, -3.053317966999941],
              [110.62818444100003, -3.04265715899993],
              [110.63314863400007, -3.039483330999929],
              [110.64014733200003, -3.037204684999949],
              [110.64356530000003, -3.02898528399993],
              [110.64258873800003, -3.018731377999927],
              [110.63672936300003, -2.994886976999908],
              [110.63502037900003, -2.974216403999947],
              [110.63038170700003, -2.951348565999922],
              [110.61695397200003, -2.90984465899993],
              [110.58855228000004, -2.876560153999947],
              [110.54948978000004, -2.867608330999929],
              [110.50806725400003, -2.874607028999947],
              [110.40406334700003, -2.920505466999941],
              [110.30103600400003, -2.997979424999926],
              [110.26319420700003, -3.002862237999921],
              [110.24024498800003, -2.973077080999929],
              [110.22364342500003, -2.930352471999925],
              [110.20484459700003, -2.89617278399993],
              [110.22169030000003, -2.876071872999944],
              [110.23755944100003, -2.84693775799991],
              [110.24708092500003, -2.815118096999925],
              [110.24586022200003, -2.786309502999927],
              [110.22754967500003, -2.741957289999959],
              [110.22315514400003, -2.701918226999908],
              [110.21387780000003, -2.669040622999944],
              [110.21168053500003, -2.652601820999962],
              [110.20378665500004, -2.640069268999923],
              [110.16749108200003, -2.632419528999947],
              [110.15699303500003, -2.621270440999922],
              [110.16041100400003, -2.612399997999944],
              [110.17969811300003, -2.590020440999922],
              [110.18433678500003, -2.577243747999944],
              [110.19922936300003, -2.552341403999947],
              [110.23194420700003, -2.556735934999949],
              [110.26490319100003, -2.556573174999926],
              [110.28052819100003, -2.518243096999925],
              [110.24683678500003, -2.539808851999908],
              [110.22103925900007, -2.532810153999947],
              [110.20118248800003, -2.508233330999929],
              [110.15992272200003, -2.436455987999921],
              [110.15699303500003, -2.419528903999947],
              [110.15479576900003, -2.37623463299991],
              [110.14087975400003, -2.289727471999925],
              [110.13209069100003, -2.268161716999941],
              [110.11947675900007, -2.258721612999921],
              [110.10466556100005, -2.252048434999949],
              [110.09717858200003, -2.235772393999923],
              [110.09498131600003, -2.215508721999925],
              [110.09555097700007, -2.197360934999949],
              [110.10531660200007, -2.154392184999949],
              [110.11988366000003, -2.112074476999908],
              [110.12916100400003, -2.069512627999927],
              [110.12354576900003, -2.025485934999949],
              [110.09546959700003, -1.960137627999927],
              [110.09253991000003, -1.949639580999929],
              [110.07504316500007, -1.922458591999941],
              [110.06576582100007, -1.917575778999947],
              [110.03419030000003, -1.909356377999927],
              [109.98755944100003, -1.884698174999926],
              [109.96859785200007, -1.881442966999941],
              [109.95362389400003, -1.87428150799991],
              [109.90381920700003, -1.826104424999926],
              [109.90894616000003, -1.823337497999944],
              [109.91895592500003, -1.815850518999923],
              [109.92432701900003, -1.813164971999925],
              [109.91627037900003, -1.807793877999927],
              [109.91081790500004, -1.799899997999944],
              [109.90870201900003, -1.790134372999944],
              [109.91065514400003, -1.77898528399993],
              [109.92164147200003, -1.769626559999949],
              [109.96802819100003, -1.74342213299991],
              [109.98267662900003, -1.73796965899993],
              [109.99390709700003, -1.730238539999959],
              [110.00464928500003, -1.71217213299991],
              [110.03394616000003, -1.64617278399993],
              [110.03858483200003, -1.627618096999925],
              [110.04175866000003, -1.55982838299991],
              [110.06853274800005, -1.432549737999921],
              [110.07105553500003, -1.38990650799991],
              [110.06137129000007, -1.346368096999925],
              [110.04411868600005, -1.304782809999949],
              [110.02955162900003, -1.285902601999908],
              [110.01002037900003, -1.278008721999925],
              [109.98829186300003, -1.274997653999947],
              [109.96420332100007, -1.265720309999949],
              [109.94849694100003, -1.250746351999908],
              [109.95150800900007, -1.230889580999929],
              [109.92986087300005, -1.223239841999941],
              [109.92204837300005, -1.201592705999929],
              [109.92367597700007, -1.174004815999922],
              [109.93685957100007, -1.127618096999925],
              [109.93458092500003, -1.11256275799991],
              [109.92269941500007, -1.103610934999949],
              [109.90015709700003, -1.100518487999921],
              [109.89405358200003, -1.098565362999921],
              [109.86963951900003, -1.086195570999962],
              [109.85906009200005, -1.085056247999944],
              [109.83545983200003, -1.086195570999962],
              [109.82300866000003, -1.075290622999944],
              [109.80990644600007, -1.045179945999962],
              [109.78565514400003, -1.032972914999959],
              [109.77515709700003, -1.018731377999927],
              [109.75977623800003, -0.990655205999929],
              [109.74048912900003, -0.967543226999908],
              [109.73414147200003, -0.954034112999921],
              [109.73178144600007, -0.932305596999925],
              [109.73487389400003, -0.91765715899993],
              [109.74219811300003, -0.908135674999926],
              [109.75131269600007, -0.899590752999927],
              [109.75977623800003, -0.887627862999921],
              [109.76514733200003, -0.87428150799991],
              [109.76351972700007, -0.870863539999959],
              [109.73487389400003, -0.879001559999949],
              [109.72437584700003, -0.888767184999949],
              [109.71949303500003, -0.904066664999959],
              [109.71810957100007, -0.925876559999949],
              [109.71412194100003, -0.947360934999949],
              [109.70386803500003, -0.96062590899993],
              [109.67725670700003, -0.983819268999923],
              [109.64795983200003, -0.967461846999925],
              [109.62989342500003, -0.951918226999908],
              [109.62322024800005, -0.951592705999929],
              [109.61622155000003, -0.954685153999947],
              [109.60523522200003, -0.956638278999947],
              [109.59864342500003, -0.947849216999941],
              [109.58171634200005, -0.894463799999926],
              [109.55982506600003, -0.877373955999929],
              [109.52564537900003, -0.862399997999944],
              [109.48878014400003, -0.851657809999949],
              [109.43824303500003, -0.845635674999926],
              [109.42798912900003, -0.846612237999921],
              [109.42066491000003, -0.850192966999941],
              [109.41382897200003, -0.860121351999908],
              [109.41586347700007, -0.866957289999959],
              [109.42107181100005, -0.873793226999908],
              [109.42408287900003, -0.884209893999923],
              [109.41895592500003, -0.90357838299991],
              [109.40650475400003, -0.91139088299991],
              [109.39079837300005, -0.911879164999959],
              [109.37623131600003, -0.908786716999941],
              [109.33521569100003, -0.889092705999929],
              [109.32837975400003, -0.884209893999923],
              [109.32048587300005, -0.883396091999941],
              [109.28386478000004, -0.863213799999926],
              [109.27320397200003, -0.853610934999949],
              [109.24529056100005, -0.695896091999941],
              [109.25098717500003, -0.677666924999926],
              [109.26254316500007, -0.667413018999923],
              [109.27857506600003, -0.669040622999944],
              [109.29737389400003, -0.685642184999949],
              [109.31381269600007, -0.69500090899993],
              [109.38306725400003, -0.695896091999941],
              [109.39820397200003, -0.703057549999926],
              [109.42920983200003, -0.725762627999927],
              [109.45582116000003, -0.73211028399993],
              [109.46192467500003, -0.734795830999929],
              [109.46859785200007, -0.737074476999908],
              [109.47868899800005, -0.736911716999941],
              [109.50171959700003, -0.731052341999941],
              [109.50961347700007, -0.725030205999929],
              [109.50652103000004, -0.716403903999947],
              [109.49732506600003, -0.713636976999908],
              [109.47152754000007, -0.716566664999959],
              [109.46159915500004, -0.712985934999949],
              [109.44361412900003, -0.687432549999926],
              [109.43458092500003, -0.678806247999944],
              [109.41293379000007, -0.663995049999926],
              [109.38990319100003, -0.654880466999941],
              [109.37916100400003, -0.652927341999941],
              [109.36255944100003, -0.651950778999947],
              [109.35515384200005, -0.64812590899993],
              [109.35515384200005, -0.641289971999925],
              [109.35962975400003, -0.639743747999944],
              [109.36882571700005, -0.633884372999944],
              [109.36475670700003, -0.63014088299991],
              [109.35962975400003, -0.623630466999941],
              [109.35515384200005, -0.620212497999944],
              [109.35515384200005, -0.613946221999925],
              [109.37322024800005, -0.614190362999921],
              [109.40626061300003, -0.620212497999944],
              [109.42408287900003, -0.620212497999944],
              [109.42408287900003, -0.613946221999925],
              [109.40064537900003, -0.59734465899993],
              [109.37452233200003, -0.587334893999923],
              [109.34400475400003, -0.583754164999959],
              [109.27759850400003, -0.586195570999962],
              [109.26238040500004, -0.592461846999925],
              [109.25660241000003, -0.588474216999941],
              [109.25033613400007, -0.582289320999962],
              [109.23536217500003, -0.576348565999922],
              [109.23113040500004, -0.57000090899993],
              [109.22803795700003, -0.563083591999941],
              [109.22478274800005, -0.558689059999949],
              [109.21509850400003, -0.553399346999925],
              [109.21176191500007, -0.552178643999923],
              [109.20777428500003, -0.55242278399993],
              [109.19752037900003, -0.551853122999944],
              [109.18734785200007, -0.552992445999962],
              [109.17969811300003, -0.556084893999923],
              [109.17139733200003, -0.55632903399993],
              [109.15992272200003, -0.548760674999926],
              [109.13941491000003, -0.52857838299991],
              [109.13013756600003, -0.515720309999949],
              [109.12330162900003, -0.49968840899993],
              [109.10279381600003, -0.409926039999959],
              [109.10059655000003, -0.369724216999941],
              [109.10254967500003, -0.361097914999959],
              [109.11247806100005, -0.359795830999929],
              [109.13599694100003, -0.360039971999925],
              [109.10320071700005, -0.31414153399993],
              [109.09083092500003, -0.287204684999949],
              [109.10132897200003, -0.263848565999922],
              [109.10132897200003, -0.257582289999959],
              [109.08936608200003, -0.253024997999944],
              [109.07642662900003, -0.250583591999941],
              [109.06739342500003, -0.25514088299991],
              [109.06706790500004, -0.271254164999959],
              [109.05030358200003, -0.261895440999922],
              [109.04623457100007, -0.245863539999959],
              [109.05095462300005, -0.229099216999941],
              [109.06031334700003, -0.216729424999926],
              [109.07032311300003, -0.211846612999921],
              [109.08611087300005, -0.207452080999929],
              [109.11866295700003, -0.203057549999926],
              [109.14665774800005, -0.205254815999922],
              [109.17603600400003, -0.212009372999944],
              [109.20167076900003, -0.222751559999949],
              [109.21851647200003, -0.237237237999921],
              [109.22478274800005, -0.237237237999921],
              [109.21876061300003, -0.221612237999921],
              [109.19857832100007, -0.20086028399993],
              [109.19060306100005, -0.18873463299991],
              [109.18848717500003, -0.177341403999947],
              [109.19060306100005, -0.137302341999941],
              [109.18685957100007, -0.082207940999922],
              [109.17969811300003, -0.055474541999956],
              [109.16041100400003, -0.023695570999962],
              [109.15739993600005, -0.009291273999906],
              [109.15650475400003, 0.020086981000077],
              [109.16098066500007, 0.03392161700009],
              [109.17212975400003, 0.034165757000039],
              [109.19752037900003, 0.023504950000074],
              [109.30046634200005, 0.01048411700009],
              [109.28052819100003, 0.027492580000057],
              [109.23666425900007, 0.05727773600006],
              [109.17693118600005, 0.107611395000049],
              [109.16675866000003, 0.112290757000039],
              [109.10230553500003, 0.243109442000048],
              [109.04664147200003, 0.287054755000042],
              [109.03321373800003, 0.293361721000053],
              [109.01612389400003, 0.296820380000042],
              [108.95313561300003, 0.301743882000039],
              [108.92872155000003, 0.31509023600006],
              [108.92090905000003, 0.340277411000045],
              [108.93116295700003, 0.379787502000056],
              [108.94239342500003, 0.408270575000074],
              [108.94434655000003, 0.42251211100006],
              [108.94483483200003, 0.445298570000091],
              [108.93848717500003, 0.46515534100007],
              [108.91309655000003, 0.504339911000045],
              [108.91000410200007, 0.530585028000075],
              [108.91431725400003, 0.541408596000053],
              [108.92823326900003, 0.563666083000044],
              [108.93116295700003, 0.575018622000073],
              [108.93116295700003, 0.616197007000039],
              [108.92725670700003, 0.640773830000057],
              [108.91724694100003, 0.661078192000048],
              [108.87598717500003, 0.714667059000078],
              [108.87745201900003, 0.723822333000044],
              [108.88502037900003, 0.733221747000073],
              [108.88965905000003, 0.753729559000078],
              [108.88257897200003, 0.777533270000049],
              [108.85596764400003, 0.811590887000079],
              [108.85547936300003, 0.832220770000049],
              [108.86264082100007, 0.841742255000042],
              [108.87696373800003, 0.855536200000074],
              [108.89332116000003, 0.86790599200009],
              [108.90658613400007, 0.873236395000049],
              [108.92603600400003, 0.875962632000039],
              [108.94141686300003, 0.884019273000092],
              [108.95394941500007, 0.896877346000053],
              [108.96534264400003, 0.914211330000057],
              [108.98080488400007, 0.956040757000039],
              [108.98031660200007, 0.99555084800005],
              [108.92701256600003, 1.140448309000078],
              [108.92432701900003, 1.164007880000042],
              [108.93262780000003, 1.17804596600007],
              [108.95232181100005, 1.184068101000094],
              [108.99268639400003, 1.187892971000053],
              [109.03272545700003, 1.199042059000078],
              [109.10816491000003, 1.228705145000049],
              [109.14283287900003, 1.25063711100006],
              [109.15845787900003, 1.264634507000039],
              [109.21566816500007, 1.335435289000088],
              [109.22803795700003, 1.358628648000092],
              [109.24341881600003, 1.379868882000039],
              [109.26636803500003, 1.394598700000074],
              [109.26636803500003, 1.401434637000079],
              [109.24048912900003, 1.404201565000051],
              [109.22730553500003, 1.388861395000049],
              [109.21729576900003, 1.36945221600007],
              [109.20118248800003, 1.359849351000094],
              [109.18824303500003, 1.349188544000071],
              [109.16504967500003, 1.302232164000088],
              [109.15308678500003, 1.291571356000077],
              [109.14926191500007, 1.286200262000079],
              [109.14470462300005, 1.27415599200009],
              [109.13738040500004, 1.262274481000077],
              [109.12574303500003, 1.256822007000039],
              [109.11402428500003, 1.254461981000077],
              [109.10450280000003, 1.248846747000073],
              [109.08822675900007, 1.236314195000091],
              [109.06617272200003, 1.229559637000079],
              [109.01221764400003, 1.224310614000046],
              [108.98585045700003, 1.215806382000039],
              [108.99040774800005, 1.247463283000059],
              [109.00603274800005, 1.27415599200009],
              [109.04037519600007, 1.318915106000077],
              [109.05437259200005, 1.352240302000041],
              [109.06080162900003, 1.383856512000079],
              [109.06080162900003, 1.499009507000039],
              [109.07300866000003, 1.53392161700009],
              [109.09595787900003, 1.560614325000074],
              [109.25269616000003, 1.668361721000053],
              [109.27222741000003, 1.693793036000045],
              [109.30339603000004, 1.752630927000041],
              [109.32105553500003, 1.778225002000056],
              [109.33912194100003, 1.797756252000056],
              [109.34205162900003, 1.801825262000079],
              [109.34310957100007, 1.804388739000046],
              [109.34546959700003, 1.806463934000078],
              [109.34782962300005, 1.809556382000039],
              [109.34888756600003, 1.815415757000039],
              [109.34669030000003, 1.818793036000045],
              [109.34180748800003, 1.819973049000055],
              [109.33692467500003, 1.818793036000045],
              [109.33464603000004, 1.815415757000039],
              [109.28679446700005, 1.778225002000056],
              [109.28923587300005, 1.795965887000079],
              [109.29997806100005, 1.80695221600007],
              [109.31446373800003, 1.817206122000073],
              [109.32837975400003, 1.832831122000073],
              [109.33513431100005, 1.850165106000077],
              [109.33643639400003, 1.86790599200009],
              [109.33464603000004, 1.90110911700009],
              [109.34099368600005, 1.935532945000091],
              [109.35889733200003, 1.948309637000079],
              [109.42408287900003, 1.95571523600006],
              [109.56120853000004, 1.990464585000041],
              [109.57886803500003, 1.997626044000071],
              [109.59278405000003, 2.007513739000046],
              [109.60466556100005, 2.02094147300005],
              [109.63502037900003, 2.074042059000078],
              [109.64527428500003, 2.083238023000092],
              [109.62662072800003, 2.029696350000066],
              [109.6002657470001, 1.98313588500011],
              [109.58507287600008, 1.960915019000069],
              [109.57442753100008, 1.948590190000033],
              [109.53794397000007, 1.917713522000042],
              [109.52936568200005, 1.905156149000035],
              [109.52843550600005, 1.88998911600001],
              [109.53474003200006, 1.853893127000092],
              [109.53432662000006, 1.846451721000079],
              [109.53474003200006, 1.838984477000054],
              [109.53980432200007, 1.826556295000074],
              [109.54662561000004, 1.814334818000049],
              [109.55561731000006, 1.802165019000128],
              [109.56698612500003, 1.792553203000125],
              [109.58011193900012, 1.787979838000084],
              [109.62403690700006, 1.787773132000041],
              [109.6418135990001, 1.781003520000084],
              [109.64718794800012, 1.761883240000088],
              [109.64057336400003, 1.683025004000072],
              [109.64171024600006, 1.637162171000099],
              [109.6469812420001, 1.617628479000103],
              [109.6580399990001, 1.597190450000141],
              [109.67726363200012, 1.572850850000037],
              [109.76635380100004, 1.496473084000087],
              [109.77317509000005, 1.4858535770001],
              [109.77555220500011, 1.457948303000109],
              [109.78154667200005, 1.456294658000061],
              [109.8005635990001, 1.466759135000103],
              [109.80779829900007, 1.459963684000058],
              [109.8254716400001, 1.41756317100004],
              [109.84283492000009, 1.403274638000056],
              [109.86288537700005, 1.401465963000064],
              [109.88272912600013, 1.403843079000112],
              [109.90205611200008, 1.403791402000095],
              [109.92024621600012, 1.394773865000047],
              [109.93254520700009, 1.37852162700004],
              [109.95176883900007, 1.319662170000043],
              [109.96375777200006, 1.298578186000015],
              [109.97626346900006, 1.28772613600006],
              [110.0121269120001, 1.270517883000082],
              [110.03073042800003, 1.253568014000081],
              [110.05181441200006, 1.21548248300013],
              [110.07455204300004, 1.198635966000055],
              [110.0934656170001, 1.191607971000053],
              [110.15217004500005, 1.183856507000129],
              [110.17036014900009, 1.17445139600008],
              [110.1851396080001, 1.154194234000087],
              [110.20674035700006, 1.111716207000129],
              [110.25655643700003, 1.039059144000092],
              [110.26172408000014, 1.014719544000087],
              [110.26348107900009, 0.994307353000039],
              [110.27278283800013, 0.991051737000063],
              [110.28632206300011, 0.995340881000118],
              [110.30079146400004, 0.997717997000066],
              [110.35164107300005, 0.98650421100011],
              [110.36414676900006, 0.981388245000034],
              [110.38068322800012, 0.966608785000105],
              [110.42264449100003, 0.90945465100009],
              [110.46026493300008, 0.879740703000024],
              [110.5063603110001, 0.857313131000112],
              [110.5539026290001, 0.851370341000106],
              [110.59607059800004, 0.87111073800007],
              [110.60599247300007, 0.883306376000078],
              [110.60960982300003, 0.890851136000038],
              [110.61343387900007, 0.893951721000079],
              [110.62480269400004, 0.893124898000053],
              [110.63214074800004, 0.888629049000116],
              [110.63885868300008, 0.880774231000089],
              [110.64774703000012, 0.873901266000118],
              [110.66128625500005, 0.872144267000053],
              [110.67441206900003, 0.877001851000074],
              [110.69301558500007, 0.894675192000065],
              [110.70417769400012, 0.901393127000091],
              [110.70944869000004, 0.901393127000091],
              [110.72071415200003, 0.89736236600001],
              [110.72484826700003, 0.897259013000067],
              [110.74479537000008, 0.905062154000092],
              [110.74572554600013, 0.908007711000096],
              [110.75833459500006, 0.914518941000068],
              [110.76112512300011, 0.912865296000106],
              [110.77125370300007, 0.904390361000111],
              [110.77673140500013, 0.903253479000099],
              [110.78396610600004, 0.908162740000122],
              [110.78623986800005, 0.916275940000048],
              [110.78706669100006, 0.934155986000093],
              [110.79698856600004, 0.949658915000015],
              [110.85269576100006, 0.997201233000027],
              [110.88039432900013, 1.010533753000047],
              [110.91057336500012, 1.015701396000054],
              [110.97341190700007, 1.0177167760001],
              [111.1975842700001, 1.075232646000117],
              [111.21753137200011, 1.073268942000098],
              [111.3517867430001, 1.013892721000062],
              [111.37411096200003, 1.007536519000041],
              [111.39550500500008, 1.00629628500009],
              [111.41503869700006, 1.010223694000061],
              [111.4545194910001, 1.022626038000041],
              [111.4720894780001, 1.02221262700003],
              [111.48242476400009, 1.012859192000079],
              [111.48800581900008, 0.997924703000123],
              [111.4920365810001, 0.98087148000009],
              [111.50319869000003, 0.958443909000096],
              [111.51539432800013, 0.964490051000041],
              [111.53885542900014, 0.997717997000066],
              [111.62267460100009, 1.03027415000011],
              [111.6373507080001, 1.032237854000044],
              [111.65523075400006, 1.03079091400005],
              [111.68210249800006, 1.023452861000067],
              [111.73419234300007, 1.00143870000008],
              [111.76282108600009, 0.993015442000086],
              [111.82307580600013, 1.008466695000081],
              [111.91009891800007, 1.114041646000075],
              [111.9733508710001, 1.134040426000098],
              [112.05406945800013, 1.133627014000098],
              [112.07949426300002, 1.137244365000072],
              [112.09293013500007, 1.143135478000076],
              [112.1000614830001, 1.154917705000074],
              [112.15266809100001, 1.3062779750001],
              [112.18398400900003, 1.369039001000061],
              [112.18739465300013, 1.379658508000134],
              [112.1880147710001, 1.391414896000043],
              [112.18181359900012, 1.40001902200008],
              [112.15907596900001, 1.400794169000079],
              [112.15411503100006, 1.409527486000059],
              [112.16155643700012, 1.434538880000062],
              [112.18005660000006, 1.449034119000089],
              [112.295191692, 1.503811137000071],
              [112.31906620300003, 1.511743469000038],
              [112.38097456900005, 1.517712097000057],
              [112.3985445560001, 1.523344828000077],
              [112.41590783700013, 1.536651510000098],
              [112.42975712100008, 1.550681662000017],
              [112.44588016800009, 1.562076315000098],
              [112.47047815000013, 1.567657369000116],
              [112.76885787000003, 1.552231954000121],
              [112.79479943900009, 1.544377136000094],
              [112.801517375, 1.543782858000043],
              [112.81350630800006, 1.549338073000044],
              [112.82053430200006, 1.557632141000099],
              [112.8266321210001, 1.567192281000089],
              [112.83645064300009, 1.576054789000096],
              [112.85495080600003, 1.582721049000028],
              [112.87138391200006, 1.580653991000062],
              [112.88812707600005, 1.574866232000076],
              [112.90766076700004, 1.570525411000105],
              [112.956029908, 1.572334086000097],
              [112.97318648300012, 1.56985361800011],
              [112.99716434800007, 1.560164287000092],
              [113.01411421700004, 1.550785014000041],
              [113.02341597500009, 1.537013244000093],
              [113.02434615100003, 1.514378968000045],
              [113.01845503800013, 1.492390645000071],
              [113.00729292800008, 1.473270365000076],
              [112.99168664500007, 1.456966452000046],
              [112.96119755100005, 1.434383850000103],
              [112.95530643700016, 1.423557638000077],
              [112.95820031800008, 1.415651143000034],
              [112.97318648300012, 1.415082703000067],
              [113.01142704300003, 1.427975973000073],
              [113.050597778, 1.434797262000117],
              [113.0890450440001, 1.431334940000085],
              [113.12573531200007, 1.413635763000073],
              [113.15860152200003, 1.388159281000057],
              [113.17276086500016, 1.38374094600006],
              [113.21771936100009, 1.380898742000085],
              [113.2760103760001, 1.368883973000024],
              [113.32365604700016, 1.351391500000062],
              [113.39755334500006, 1.293927307000047],
              [113.442925253, 1.292377015000028],
              [113.48230269400005, 1.308706767000061],
              [113.50338667900007, 1.314494527000136],
              [113.52447066200006, 1.313564351000082],
              [113.54617476400011, 1.301575419000116],
              [113.59650760900001, 1.241630758000042],
              [113.6248262950001, 1.22757476800011],
              [113.64952762900009, 1.233259176000061],
              [113.8081742760001, 1.339712626000093],
              [113.86822229000012, 1.415496114000078],
              [113.89116662600014, 1.434952291000073],
              [113.90966678900008, 1.442471212000015],
              [114.0539473880001, 1.465053813000054],
              [114.09425500500004, 1.465673930000108],
              [114.13094527200008, 1.454175924000083],
              [114.14107385300008, 1.445261739000074],
              [114.15027225800014, 1.434280497000088],
              [114.16040083900009, 1.424797872000099],
              [114.17342329900015, 1.420508728000044],
              [114.18324182200001, 1.423454285000048],
              [114.20484257100009, 1.438362935000086],
              [114.20740588700005, 1.439443127000118],
              [114.35573775300008, 1.501950786000066],
              [114.37485803300001, 1.506937562000118],
              [114.3982157800001, 1.503552754000097],
              [114.4213668220001, 1.492183940000118],
              [114.50063846900008, 1.436037496000068],
              [114.5222392180001, 1.429422913000067],
              [114.54559696500007, 1.434952291000073],
              [114.56161665800005, 1.450015971000056],
              [114.56802453700004, 1.469394633000121],
              [114.5677144770001, 1.490917867000078],
              [114.56316695200013, 1.512260233000077],
              [114.56316695200013, 1.536393128000029],
              [114.57453576700004, 1.553420512000059],
              [114.6096757410001, 1.581635844000118],
              [114.6244552010001, 1.59879242000008],
              [114.65029341700011, 1.641451315000069],
              [114.6690002850001, 1.694006246000058],
              [114.6800590420001, 1.76327850400007],
              [114.67892216000007, 1.794361878000117],
              [114.67582157400005, 1.806738383000081],
              [114.67261763500005, 1.814076436000079],
              [114.67137740100014, 1.820975240000053],
              [114.67416792900008, 1.831904806000111],
              [114.679542277, 1.840741476000119],
              [114.68863733000006, 1.850224101],
              [114.69917932100009, 1.858053080000033],
              [114.70899784400007, 1.861980490000093],
              [114.76305139200014, 1.868698425000019],
              [114.81906864500007, 1.890299174000091],
              [114.83198775300008, 1.902520650000014],
              [114.83364139800005, 1.921356710000026],
              [114.829403931, 1.942647400000112],
              [114.829403931, 1.959778138000061],
              [114.83384810400008, 1.976676331000064],
              [114.84252974400016, 1.997166036000124],
              [114.84511356700006, 2.009749248000048],
              [114.8453202720001, 2.024967957000072],
              [114.84108280500004, 2.038222962000077],
              [114.8313676350001, 2.044760030000063],
              [114.8082165940001, 2.0419695020001],
              [114.79219690000008, 2.03481231700006],
              [114.78062137900014, 2.036052552000086],
              [114.7702860920001, 2.058221741000111],
              [114.76925256400006, 2.066644999000104],
              [114.7702860920001, 2.100053813000073],
              [114.76801233000009, 2.110208232000048],
              [114.75674686700006, 2.126047059000129],
              [114.75302616400012, 2.134806213000033],
              [114.75209598800006, 2.153513082000103],
              [114.76346480400008, 2.208083395000131],
              [114.77876102700009, 2.24720245400006],
              [114.80904341700005, 2.264669088000105],
              [114.8864547120001, 2.275159404000064],
              [114.9133264570001, 2.28404775000007],
              [114.91963098100007, 2.295674947000037],
              [114.91673710200013, 2.311229554000064],
              [114.91529016200002, 2.332055155000106],
              [114.92221480300009, 2.353914287000052],
              [114.93451379500004, 2.360683899000094],
              [114.9729610600001, 2.35747996000012],
              [114.9920813390001, 2.369882304000086],
              [115.03476607300007, 2.406417541000025],
              [115.05202600100006, 2.414013977000081],
              [115.06742557800015, 2.423109029000059],
              [115.10504602100008, 2.465690409000032],
              [115.12654341700011, 2.479229634000106],
              [115.17181197100001, 2.483312073000107],
              [115.19268925000006, 2.490546773000077],
              [115.20612512200006, 2.509873759000129],
              [115.20374800700012, 2.527547099000031],
              [115.19237919200009, 2.55105987600011],
              [115.1769796150001, 2.574159241000089],
              [115.16189009600009, 2.590385641000097],
              [115.15196822100012, 2.597051900000025],
              [115.13977258300008, 2.60283966100009],
              [115.12685347500008, 2.60676707000006],
              [115.11496789600005, 2.607903951000068],
              [115.10411584500002, 2.604751689000111],
              [115.08251509600007, 2.59436472600008],
              [115.07145634000005, 2.594623108000064],
              [115.05647017500007, 2.608627422000069],
              [115.05864058500009, 2.628832906000056],
              [115.06742557800015, 2.651208801000038],
              [115.07186975200005, 2.671827698000129],
              [115.0687691650001, 2.681542868000079],
              [115.05791711500007, 2.701489970000097],
              [115.05698693900001, 2.711256816000045],
              [115.06318811000011, 2.723659159000107],
              [115.07217981000014, 2.727431539000051],
              [115.08272180200004, 2.729550273000115],
              [115.09357385300007, 2.737043356000058],
              [115.10463261000007, 2.761486308000087],
              [115.09812137900008, 2.78107167600011],
              [115.07186975200005, 2.814764710000077],
              [115.06690881300011, 2.828200582000122],
              [115.069079224, 2.832644755000032],
              [115.0775541590001, 2.836520488000076],
              [115.09119673700002, 2.848147685000043],
              [115.09905155500013, 2.859671529000067],
              [115.10277225800007, 2.869955139000069],
              [115.10525272600006, 2.880290425000069],
              [115.10959354700003, 2.892020976000069],
              [115.12282271400011, 2.912949931000057],
              [115.13904911300011, 2.928452860000064],
              [115.19640995300011, 2.967623596000095],
              [115.20798547400005, 2.98069773400006],
              [115.22503869700006, 3.015889384000019],
              [115.24209192, 3.041624247000101],
              [115.25583785000003, 3.037490133000091],
              [115.28136600800008, 2.999559631000082],
              [115.30999475100015, 2.98591705300008],
              [115.34151737500014, 2.991136373000089],
              [115.40683638500008, 3.019506734000103],
              [115.44797082500014, 3.024054261000046],
              [115.46409387300002, 3.030823873000074],
              [115.47215539600012, 3.050512594000026],
              [115.47597945200005, 3.093042297000082],
              [115.48218062400014, 3.110974020000057],
              [115.51701053900001, 3.157276103000129],
              [115.5144267180001, 3.164769186000072],
              [115.49933719900002, 3.169781800000038],
              [115.48352421100003, 3.189005432000059],
              [115.482800741, 3.206472066000103],
              [115.51763065600005, 3.357160543000049],
              [115.53582076000009, 3.403617656000065],
              [115.55721480300014, 3.425450948000091],
              [115.56713667800005, 3.42384897900007],
              [115.57602502500004, 3.419404805000056],
              [115.58501672400007, 3.416820984000054],
              [115.59545536300004, 3.420851746000054],
              [115.601243124, 3.43023101900009],
              [115.60062300600009, 3.441212260000086],
              [115.59266483600004, 3.461960348000019],
              [115.57612837800008, 3.491674296000085],
              [115.57271773300016, 3.50415415500008],
              [115.57240767500008, 3.514256897000038],
              [115.574474731, 3.534565735000044],
              [115.57333785000003, 3.545004374000087],
              [115.548533163, 3.605284933000064],
              [115.54439904800006, 3.629159445000141],
              [115.54460575400003, 3.668976136000069],
              [115.5504968670001, 3.708224385000037],
              [115.58935754500015, 3.824522197000121],
              [115.58863407400008, 3.857595113000116],
              [115.57457808400017, 3.872090353000146],
              [115.554114217, 3.883562520000069],
              [115.53830122900001, 3.897825216000044],
              [115.53881799400006, 3.920614522000037],
              [115.54584598900016, 3.927720032000067],
              [115.580985962, 3.946917827000078],
              [115.5902877200001, 3.958002421000089],
              [115.60951135200003, 3.996914774000075],
              [115.62212040200006, 4.040219625000134],
              [115.63328251200011, 4.128560486000126],
              [115.63913433100004, 4.145949698000067],
              [115.64692508900009, 4.16910064700005],
              [115.65591678900006, 4.178634949000042],
              [115.6759672450001, 4.184164327000047],
              [115.68278853400005, 4.19064972000011],
              [115.68981652900004, 4.199977315000041],
              [115.73260461500001, 4.239380595000057],
              [115.74025272700015, 4.236202495000086],
              [115.74717736900004, 4.227624207000062],
              [115.7568925380001, 4.222172343000068],
              [115.77074182100006, 4.225608825000108],
              [115.7753927010001, 4.236099142000057],
              [115.77942346200012, 4.248940735000048],
              [115.81745731700005, 4.281316020000048],
              [115.82190149000007, 4.311236674000071],
              [115.82117802000005, 4.344335429000068],
              [115.8309965420001, 4.3761164350001],
              [115.84412235500008, 4.38921641000006],
              [115.85611128800014, 4.390766703000082],
              [115.86489628100003, 4.38257598900006],
              [115.86944380700004, 4.366685486000037],
              [115.87884891800002, 4.352138570000079],
              [115.89879602100007, 4.347125956000113],
              [115.94096398900001, 4.344361267000068],
              [115.96483850100009, 4.335472921000061],
              [115.97724084500015, 4.328625794000089],
              [115.98344201700002, 4.321391093000031],
              [115.9873694260001, 4.304777120000026],
              [115.99357059800002, 4.288912455000101],
              [116.0040092370001, 4.276690980000083],
              [116.02064904800005, 4.270851542000102],
              [116.03315474500005, 4.277724507000073],
              [116.08121382700011, 4.325473531000043],
              [116.09940393100015, 4.336506449000041],
              [116.10994592300011, 4.345110575000078],
              [116.11749068300009, 4.357228699000075],
              [116.12575891200004, 4.378906962000059],
              [116.13650760900015, 4.373041687000068],
              [116.14684289600012, 4.371207173000073],
              [116.17009729000006, 4.369915263000024],
              [116.21505578700015, 4.357848816000043],
              [116.22880171700001, 4.356117656000066],
              [116.25722375600003, 4.364153341000048],
              [116.28512902900002, 4.378390198000119],
              [116.31065718600007, 4.383376974000072],
              [116.33752893100007, 4.357228699000075],
              [116.3442468670001, 4.356918640000089],
              [116.35127486200008, 4.357900492000056],
              [116.35819950400008, 4.355445862000082],
              [116.36181685400004, 4.350381572000103],
              [116.36543420400005, 4.337695008000068],
              [116.39106571500008, 4.294674377000078],
              [116.40088423700007, 4.2899976610001],
              [116.4113228760001, 4.288654074000135],
              [116.42176151600006, 4.291832174000092],
              [116.446359497, 4.317256979000106],
              [116.45710819500005, 4.316766052000077],
              [116.46837365800002, 4.312321879000066],
              [116.48594364400009, 4.316921082000107],
              [116.4941085210001, 4.324853414000074],
              [116.49193811000009, 4.331287130000121],
              [116.48697717300007, 4.338573507000092],
              [116.48646040900013, 4.348831278000091],
              [116.49431522600003, 4.363223165000093],
              [116.5153992110001, 4.384152120000081],
              [116.52222050000006, 4.396787008000018],
              [116.53327925700006, 4.395365906000038],
              [116.5768941660001, 4.332010600000018],
              [116.59022668500012, 4.33113210100008],
              [116.61554813700002, 4.344077047000098],
              [116.64179976500009, 4.333870952000026],
              [116.66112675000016, 4.334387716000066],
              [116.68004032400012, 4.339917094000072],
              [116.7116663000001, 4.366788838000062],
              [116.72944299300002, 4.364463399000044],
              [116.7661332610001, 4.338573507000092],
              [116.804477173, 4.330072733000094],
              [116.88302535100007, 4.344903870000024],
              [116.92426314300008, 4.34495554700004],
              [116.9805904540001, 4.329555970000058],
              [117.1646619060001, 4.333147481000125],
              [117.17437707500005, 4.338418477000062],
              [117.19039676900007, 4.353017069000117],
              [117.20269576100009, 4.35606597900005],
              [117.21716516200007, 4.353430481000132],
              [117.22481327300005, 4.346583354000074],
              [117.23060103400007, 4.337178243000025],
              [117.2386625580001, 4.326868795000024],
              [117.27555953000001, 4.300978903000086],
              [117.35658817600006, 4.259508566000108],
              [117.41291548700013, 4.200080668000069],
              [117.43647994000003, 4.185611267000041],
              [117.46417850800009, 4.177911479000045],
              [117.49838830600004, 4.172614644000106],
              [117.51461470500016, 4.171942851000026],
              [117.54220992000006, 4.173829040000044],
              [117.55833296800006, 4.167653707000056],
              [117.56714928500003, 4.159654039000131],
            ],
          ],
          [
            [
              [140.97445722700002, -2.600518487999921],
              [140.9744747320001, -2.63120778399994],
              [140.9739062910001, -2.807321064999897],
              [140.97328617400007, -3.002451272999906],
              [140.972355998, -3.250601500999935],
              [140.97318282100002, -3.581744079999908],
              [140.9735445560001, -3.800025329999912],
              [140.97421635, -4.002286884999961],
              [140.97473311400006, -4.173645934999925],
              [140.97576664300004, -4.595945739999962],
              [140.97623173000005, -4.77371266699987],
              [140.976870791, -4.988486058999896],
              [140.97690352400002, -4.999487],
              [140.97690352400002, -5.002277526999876],
              [140.97690352400002, -5.197407734999985],
              [140.97690352400002, -5.322878112999973],
              [140.97690352400002, -5.363805846999909],
              [140.97690352400002, -5.621154478999927],
              [140.97690352400002, -5.806466165999964],
              [140.97690352400002, -6.002113137999928],
              [140.97690352400002, -6.229386087999984],
              [140.97690352400002, -6.33511606799992],
              [140.97287276200012, -6.336563008999903],
              [140.96372603400005, -6.348035175999925],
              [140.9586617440001, -6.368085631999875],
              [140.95385583500007, -6.370152689999927],
              [140.9528223060001, -6.373770039999911],
              [140.9549927170001, -6.379661152999915],
              [140.9646562100001, -6.388032734999896],
              [140.96708500200015, -6.393923847999901],
              [140.963157593, -6.404259135],
              [140.95561283400002, -6.411287129999906],
              [140.950186809, -6.41893524199989],
              [140.9528223060001, -6.431750996999966],
              [140.94155684400005, -6.430924173999941],
              [140.93101485200015, -6.431440937999895],
              [140.92129968300003, -6.433921406999957],
              [140.91251469000014, -6.438572285999925],
              [140.92316003500002, -6.439812519999862],
              [140.9299813240001, -6.444980163999958],
              [140.93318526200005, -6.453765156999864],
              [140.93282352700015, -6.465960794999958],
              [140.94858483900015, -6.465547383999947],
              [140.9531323660001, -6.480533548999929],
              [140.950186809, -6.498723652999956],
              [140.94346887200004, -6.507508645999863],
              [140.9282243250001, -6.509679055999939],
              [140.92098962400013, -6.516396992999958],
              [140.91876753800005, -6.527869160999984],
              [140.917837362, -6.553087259999941],
              [140.91509851100005, -6.558461608999906],
              [140.90987919100013, -6.561355488999894],
              [140.90161096300005, -6.562078958999891],
              [140.8929809980001, -6.565386249999975],
              [140.896494996, -6.573034362999863],
              [140.90331628400014, -6.582129413999922],
              [140.9049699310001, -6.589467467999924],
              [140.89055220600005, -6.599802754999928],
              [140.87391239500005, -6.603420104999913],
              [140.8592879640001, -6.608381041999863],
              [140.85039961800015, -6.623573913999891],
              [140.86492069500002, -6.630601908999907],
              [140.86579919400003, -6.649205423999945],
              [140.8571692310001, -6.682174986999911],
              [140.85174320500005, -6.693957213999909],
              [140.84921106000002, -6.702845559999929],
              [140.85039961800015, -6.712974140999975],
              [140.8578410240001, -6.723619486999965],
              [140.87871830300003, -6.742223001999932],
              [140.884506063, -6.753901875999901],
              [140.88269738800005, -6.760619811999931],
              [140.87324060100008, -6.773642272999965],
              [140.87086348600013, -6.778396503999957],
              [140.87417077700002, -6.789455260999958],
              [140.88243900600008, -6.798240254999939],
              [140.90161096300005, -6.812192890999938],
              [140.90672692900006, -6.828212584999989],
              [140.9083288980001, -6.849296569999922],
              [140.916028687, -6.862732441999881],
              [140.93969649300004, -6.856324564999923],
              [140.9433138440001, -6.888053893999952],
              [140.962175741, -6.897975768999942],
              [140.9771619060001, -6.896632181999891],
              [140.97700687700006, -7.004739277999946],
              [140.97700687700006, -7.157081399999939],
              [140.97690352400002, -7.282758482999895],
              [140.97690352400002, -7.323686217999921],
              [140.97690352400002, -7.587546080999914],
              [140.97690352400002, -7.772857767999952],
              [140.97690352400002, -7.962096862999971],
              [140.97690352400002, -8.001991068999914],
              [140.97700687700006, -8.1701461789999],
              [140.97731693600014, -8.434936217999862],
              [140.97762699400005, -8.611152851999933],
              [140.97752364100012, -8.798221536999947],
              [140.9771619060001, -8.99107798199995],
              [140.9769800140001, -9.106133721999925],
              [140.97681725400003, -9.106052341999941],
              [140.9326278000001, -9.08017343499995],
              [140.92107181100005, -9.079278252999927],
              [140.85694420700008, -9.049086195999905],
              [140.6215926440001, -8.80673593499995],
              [140.50749759200005, -8.638116143999923],
              [140.45289147200003, -8.586683851999908],
              [140.4462996750001, -8.577569268999923],
              [140.37810306100005, -8.522230726999908],
              [140.3676863940001, -8.508396091999941],
              [140.36345462300005, -8.490817966999941],
              [140.3540145190001, -8.488539320999905],
              [140.30144290500004, -8.467461846999925],
              [140.2666121750001, -8.430840752999927],
              [140.25163821700005, -8.408949476999908],
              [140.03191165500004, -8.246351820999905],
              [139.98812910200002, -8.192478122999944],
              [139.9736434250001, -8.165215752999927],
              [139.9707137380001, -8.142185153999947],
              [139.97974694100003, -8.121514580999929],
              [139.99773196700005, -8.103773695999905],
              [140.0214949880001, -8.08953215899993],
              [140.03492272200003, -8.08684661299992],
              [140.04810631600003, -8.086602471999925],
              [140.05836022200003, -8.081963799999926],
              [140.06234785200002, -8.06617603999996],
              [140.06568444100003, -8.029473565999922],
              [140.05681399800005, -7.996189059999949],
              [140.054047071, -7.971612237999921],
              [140.0605574880001, -7.948337497999944],
              [140.0830184250001, -7.932549737999921],
              [140.11158287900003, -7.94654713299991],
              [140.12867272200003, -7.936130466999941],
              [140.151703321, -7.884698174999926],
              [140.135101759, -7.892673434999949],
              [140.11898847700002, -7.914808851999908],
              [140.10035241000003, -7.919528903999947],
              [140.07496178500003, -7.920017184999949],
              [140.0610457690001, -7.924411716999941],
              [140.05396569100003, -7.936211846999925],
              [140.04566491000003, -7.98015715899993],
              [140.04184004, -8.045505466999941],
              [140.03402754, -8.058770440999922],
              [140.01539147200003, -8.073663018999923],
              [139.9736434250001, -8.09693775799991],
              [139.93238366000003, -8.108575127999927],
              [139.76880944100003, -8.110446872999944],
              [139.63054446700005, -8.124932549999926],
              [139.59937584700003, -8.135430596999925],
              [139.54664147200003, -8.166192315999922],
              [139.514984571, -8.178887627999927],
              [139.43531334700003, -8.19695403399993],
              [139.39519290500004, -8.20094166499996],
              [139.35670006600003, -8.199395440999922],
              [139.31950931100005, -8.190199476999908],
              [139.28337649800005, -8.172539971999925],
              [139.25464928500003, -8.146091403999947],
              [139.24000084700003, -8.11060963299991],
              [139.2402449880001, -8.101820570999905],
              [139.242523634, -8.090508721999925],
              [139.2461043630001, -8.079522393999923],
              [139.25025475400003, -8.072686455999929],
              [139.25171959700003, -8.067478122999944],
              [139.24789472700002, -8.048760674999926],
              [139.2451278000001, -8.015069268999923],
              [139.24008222700002, -8.00286223799992],
              [139.21892337300005, -7.979668877999927],
              [139.2348738940001, -7.975355726999908],
              [139.25171959700003, -7.982191664999959],
              [139.26937910200002, -7.986260674999926],
              [139.28785241000003, -7.973402601999908],
              [139.24293053500003, -7.956963799999926],
              [139.217133009, -7.951348565999922],
              [139.20590254, -7.963148695999905],
              [139.20679772200003, -7.97429778399993],
              [139.21119225400003, -7.994073174999926],
              [139.21216881600003, -8.004164320999905],
              [139.21412194100003, -8.00709400799991],
              [139.22486412900003, -8.00872161299992],
              [139.2295028000001, -8.011325778999947],
              [139.23218834700003, -8.017836195999905],
              [139.23023522200003, -8.022881768999923],
              [139.2270613940001, -8.028090101999908],
              [139.22445722700002, -8.074395440999922],
              [139.2011824880001, -8.095635674999926],
              [139.12273196700005, -8.117445570999905],
              [139.08952884200005, -8.133558851999908],
              [138.97331790500004, -8.229913018999923],
              [138.9633895190001, -8.245538018999923],
              [138.9594832690001, -8.265232028999947],
              [138.95720462300005, -8.27076588299991],
              [138.9511824880001, -8.28134530999995],
              [138.9433699880001, -8.291192315999922],
              [138.93523196700005, -8.295586846999925],
              [138.92107181100005, -8.294854424999926],
              [138.914398634, -8.292087497999944],
              [138.87647545700008, -8.218682549999926],
              [138.85303795700008, -8.183851820999905],
              [138.8427840500001, -8.161309502999927],
              [138.83855228000004, -8.13836028399993],
              [138.8427840500001, -8.117445570999905],
              [138.85865319100003, -8.10133228999996],
              [138.900726759, -8.092380466999941],
              [138.921234571, -8.079522393999923],
              [138.92530358200008, -8.070489190999922],
              [138.9243270190001, -8.06064218499995],
              [138.92017662900003, -8.05242278399993],
              [138.90577233200008, -8.043633721999925],
              [138.90552819100003, -8.030694268999923],
              [138.910980665, -8.00758228999996],
              [138.910980665, -7.922539971999925],
              [138.915375196, -7.903252862999921],
              [138.92741946700005, -7.894138278999947],
              [138.96631920700008, -7.884698174999926],
              [138.99398847700002, -7.865492445999905],
              [139.002289259, -7.835707289999959],
              [139.007172071, -7.754327080999929],
              [139.034515821, -7.690362237999921],
              [139.04509524800005, -7.675225518999923],
              [139.048187696, -7.668064059999949],
              [139.05494225400003, -7.634209893999923],
              [139.059418165, -7.62273528399993],
              [139.0693465500001, -7.613946221999925],
              [139.08082116000003, -7.606052341999941],
              [139.089203321, -7.596774997999944],
              [139.09302819100003, -7.559991143999923],
              [139.07105553500003, -7.532647393999923],
              [139.03589928500003, -7.515232028999947],
              [139.0004988940001, -7.507907809999949],
              [138.9580184250001, -7.507256768999923],
              [138.9443465500001, -7.497002862999921],
              [138.934906446, -7.448825778999947],
              [138.92554772200003, -7.427341403999947],
              [138.886078321, -7.360935153999947],
              [138.86548912900003, -7.336032809999949],
              [138.84058678500003, -7.314548434999949],
              [138.7666121750001, -7.265394789999959],
              [138.7509871750001, -7.257745049999926],
              [138.74561608200008, -7.250664971999925],
              [138.7387801440001, -7.243584893999923],
              [138.72925866000003, -7.240411065999922],
              [138.70850670700008, -7.239190362999921],
              [138.69996178500003, -7.237074476999908],
              [138.69125410200002, -7.233575127999927],
              [138.67701256600003, -7.223402601999908],
              [138.666351759, -7.209893487999921],
              [138.66749108200008, -7.197849216999941],
              [138.68824303500003, -7.19264088299991],
              [138.90455162900003, -7.199395440999922],
              [138.94516035200002, -7.206231377999927],
              [138.96168053500003, -7.21453215899993],
              [138.99097741000003, -7.23601653399993],
              [139.0039168630001, -7.240411065999922],
              [139.157074415, -7.243096612999921],
              [139.17457116000003, -7.236993096999925],
              [139.18824303500003, -7.215020440999922],
              [139.19947350400003, -7.18873463299991],
              [139.21461022200003, -7.166924737999921],
              [139.24000084700003, -7.158461195999905],
              [139.24000084700003, -7.151055596999925],
              [139.22185306100005, -7.143975518999923],
              [139.2060653000001, -7.150485934999949],
              [139.18140709700003, -7.17546965899993],
              [139.167328321, -7.195489190999922],
              [139.15943444100003, -7.203220309999949],
              [139.14722741000003, -7.206231377999927],
              [139.1035262380001, -7.206231377999927],
              [139.0605574880001, -7.212497653999947],
              [139.0376082690001, -7.211846612999921],
              [139.01937910200002, -7.194431247999944],
              [138.96631920700008, -7.164727471999925],
              [138.946136915, -7.157159112999921],
              [138.92530358200008, -7.153008721999925],
              [138.85808353000004, -7.149590752999927],
              [138.84253991000003, -7.145603122999944],
              [138.814789259, -7.13054778399993],
              [138.76197350400003, -7.113864841999941],
              [138.75342858200008, -7.106622002999927],
              [138.74781334700003, -7.098239841999941],
              [138.64616946700005, -6.99968840899993],
              [138.57203209700003, -6.942478122999944],
              [138.5615340500001, -6.918633721999925],
              [138.581390821, -6.890883070999905],
              [138.59742272200003, -6.881442966999941],
              [138.61255944100003, -6.877211195999905],
              [138.65406334700003, -6.87664153399993],
              [138.67457116000003, -6.881117445999905],
              [138.7158309250001, -6.89771900799991],
              [138.73975670700008, -6.897149346999925],
              [138.7563582690001, -6.88795338299991],
              [138.78345787900003, -6.861748955999929],
              [138.79810631600003, -6.856215101999908],
              [138.8837996750001, -6.849379164999959],
              [138.91724694100003, -6.842217705999929],
              [138.93148847700002, -6.842543226999908],
              [138.9404403000001, -6.845472914999959],
              [138.95980879, -6.854424737999921],
              [138.9697371750001, -6.856215101999908],
              [138.98943118600005, -6.865899346999925],
              [139.01775149800005, -6.908623955999929],
              [139.03793379, -6.918226820999905],
              [139.068695509, -6.942152601999908],
              [139.0727645190001, -6.948825778999947],
              [139.0825301440001, -6.953301690999922],
              [139.1035262380001, -6.959161065999922],
              [139.11793053500003, -6.968194268999923],
              [139.12647545700008, -6.971612237999921],
              [139.14039147200003, -6.972914320999905],
              [139.18189537900003, -6.971449476999908],
              [139.192230665, -6.972914320999905],
              [139.18043053500003, -6.959161065999922],
              [139.1567488940001, -6.954034112999921],
              [139.1333113940001, -6.95240650799991],
              [139.12273196700005, -6.948988539999959],
              [139.11548912900003, -6.941013278999947],
              [139.068695509, -6.918226820999905],
              [138.99976647200003, -6.852715752999927],
              [138.96631920700008, -6.835707289999959],
              [138.92367597700002, -6.825778903999947],
              [138.85670006600003, -6.82000090899993],
              [138.8379012380001, -6.814548434999949],
              [138.82243899800005, -6.806084893999923],
              [138.76840254, -6.756605726999908],
              [138.74577884200005, -6.740166924999926],
              [138.70045006600003, -6.72820403399993],
              [138.68344160200002, -6.71453215899993],
              [138.6728621750001, -6.694919528999947],
              [138.6709090500001, -6.671807549999926],
              [138.68246504, -6.645114841999941],
              [138.70289147200003, -6.645440362999921],
              [138.7431746750001, -6.664971612999921],
              [138.76319420700008, -6.670179945999905],
              [138.8291121750001, -6.705987237999921],
              [138.7089949880001, -6.629652601999908],
              [138.67758222700002, -6.602959893999923],
              [138.63160241000003, -6.544122002999927],
              [138.61939537900003, -6.534763278999947],
              [138.60377037900003, -6.527927341999941],
              [138.46607506600003, -6.402113539999959],
              [138.42115319100003, -6.318536065999922],
              [138.41358483200008, -6.291436455999929],
              [138.395355665, -6.25318775799991],
              [138.39039147200003, -6.23365650799991],
              [138.39210045700008, -6.186211846999925],
              [138.39039147200003, -6.17156340899993],
              [138.3720809250001, -6.12428150799991],
              [138.36980228000004, -6.106377862999921],
              [138.36548912900003, -6.091729424999926],
              [138.3466903000001, -6.071221612999921],
              [138.34253991000003, -6.05828215899993],
              [138.33912194100003, -6.042575778999947],
              [138.2763778000001, -5.946221612999921],
              [138.26246178500003, -5.914727471999925],
              [138.270843946, -5.886976820999905],
              [138.30420983200008, -5.868259372999944],
              [138.37671959700003, -5.855645440999922],
              [138.40398196700005, -5.835707289999959],
              [138.38550866000003, -5.837334893999923],
              [138.34253991000003, -5.848809502999927],
              [138.32203209700003, -5.851006768999923],
              [138.20875084700003, -5.825290622999944],
              [138.1821395190001, -5.809665622999944],
              [138.17798912900003, -5.804457289999959],
              [138.17554772200003, -5.795668226999908],
              [138.16960696700005, -5.786553643999923],
              [138.157562696, -5.773695570999905],
              [138.2519637380001, -5.718926690999922],
              [138.3066512380001, -5.695733330999929],
              [138.36296634200005, -5.678806247999944],
              [138.343109571, -5.670179945999905],
              [138.3203231130001, -5.67115650799991],
              [138.2773543630001, -5.678806247999944],
              [138.25269616000003, -5.679864190999922],
              [138.23267662900003, -5.683851820999905],
              [138.2138778000001, -5.691989841999941],
              [138.1718856130001, -5.716973565999922],
              [138.15202884200005, -5.723077080999929],
              [138.1059676440001, -5.726006768999923],
              [138.08578535200002, -5.73992278399993],
              [138.08326256600003, -5.738213799999926],
              [138.08155358200008, -5.734307549999926],
              [138.07105553500003, -5.728610934999949],
              [138.06910241000003, -5.719659112999921],
              [138.06918379, -5.708428643999923],
              [138.06812584700003, -5.698011976999908],
              [138.05738366000003, -5.657810153999947],
              [138.05339603000004, -5.61296965899993],
              [138.05486087300005, -5.589613539999959],
              [138.05982506600003, -5.575290622999944],
              [138.06861412900003, -5.565036716999941],
              [138.08179772200003, -5.554620049999926],
              [138.0918074880001, -5.55006275799991],
              [138.10124759200005, -5.54851653399993],
              [138.1079207690001, -5.544854424999926],
              [138.109711134, -5.534112237999921],
              [138.10531660200002, -5.53093840899993],
              [138.0849715500001, -5.522230726999908],
              [138.0781356130001, -5.520440362999921],
              [138.06421959700003, -5.511163018999923],
              [138.06421959700003, -5.489434502999927],
              [138.07439212300005, -5.444756768999923],
              [138.07488040500004, -5.41961028399993],
              [138.07105553500003, -5.409926039999959],
              [138.06137129, -5.403741143999923],
              [138.05811608200008, -5.420342705999929],
              [138.0512801440001, -5.431817315999922],
              [138.04078209700003, -5.436130466999941],
              [138.02654056100005, -5.431084893999923],
              [138.03484134200005, -5.45476653399993],
              [138.035980665, -5.474786065999922],
              [138.02564537900003, -5.484958591999941],
              [137.99927819100003, -5.478936455999929],
              [137.98658287900003, -5.46998463299991],
              [137.9589949880001, -5.431084893999923],
              [137.9145613940001, -5.386895440999922],
              [137.90845787900003, -5.363051039999959],
              [137.9248153000001, -5.328708591999941],
              [137.90414472700002, -5.32350025799991],
              [137.85336347700002, -5.361586195999905],
              [137.82178795700008, -5.362888278999947],
              [137.81397545700008, -5.358168226999908],
              [137.8086043630001, -5.352959893999923],
              [137.78296959700003, -5.317966403999947],
              [137.78012129, -5.315036716999941],
              [137.78288821700005, -5.297539971999925],
              [137.80152428500003, -5.270440362999921],
              [137.80811608200008, -5.253024997999944],
              [137.77100670700008, -5.272393487999921],
              [137.75163821700005, -5.277764580999929],
              [137.7324324880001, -5.273370049999926],
              [137.71558678500003, -5.256524346999925],
              [137.70630944100003, -5.22193775799991],
              [137.69068444100003, -5.211358330999929],
              [137.6821395190001, -5.212660414999959],
              [137.67261803500003, -5.217543226999908],
              [137.66285241000003, -5.220310153999947],
              [137.6469832690001, -5.211846612999921],
              [137.61638431100005, -5.205173434999949],
              [137.59839928500003, -5.196384372999944],
              [137.57984459700003, -5.181898695999905],
              [137.5742293630001, -5.167087497999944],
              [137.595062696, -5.156833591999941],
              [137.595062696, -5.149997653999947],
              [137.58082116000003, -5.142998955999929],
              [137.5727645190001, -5.12078215899993],
              [137.5610457690001, -5.115817966999941],
              [137.55616295700008, -5.121026299999926],
              [137.54029381600003, -5.14421965899993],
              [137.53305097700002, -5.149997653999947],
              [137.51929772200003, -5.148532809999949],
              [137.50928795700008, -5.142022393999923],
              [137.4921981130001, -5.123223565999922],
              [137.48194420700008, -5.117364190999922],
              [137.47380618600005, -5.115004164999959],
              [137.468109571, -5.110039971999925],
              [137.4648543630001, -5.095879815999922],
              [137.4326278000001, -5.103448174999926],
              [137.40357506600003, -5.097588799999926],
              [137.37777754, -5.082452080999929],
              [137.35564212300005, -5.06178150799991],
              [137.3632918630001, -5.054620049999926],
              [137.368011915, -5.046319268999923],
              [137.36996504, -5.036879164999959],
              [137.3691512380001, -5.026462497999944],
              [137.36304772200003, -5.026462497999944],
              [137.3496199880001, -5.040459893999923],
              [137.33464603000004, -5.03093840899993],
              [137.30787194100003, -4.999118747999944],
              [137.30933678500003, -5.021661065999922],
              [137.301605665, -5.02662525799991],
              [137.27654056100005, -5.020196221999925],
              [137.2680770190001, -5.013848565999922],
              [137.26710045700008, -4.999444268999923],
              [137.282562696, -4.939711195999905],
              [137.27881920700008, -4.936618747999944],
              [137.2324324880001, -4.969414971999925],
              [137.22437584700003, -4.98211028399993],
              [137.23210696700005, -4.999118747999944],
              [137.21900475400003, -5.01336028399993],
              [137.16944420700008, -4.991143487999921],
              [137.15211022200003, -4.974379164999959],
              [137.14966881600003, -4.945082289999959],
              [137.11540774800005, -4.979180596999925],
              [137.09009850400003, -4.960137627999927],
              [137.08773847700002, -4.94304778399993],
              [137.09595787900003, -4.921644789999959],
              [137.10173587300005, -4.889255466999941],
              [137.09498131600003, -4.889255466999941],
              [137.07300866000003, -4.923923434999949],
              [137.04184004, -4.94304778399993],
              [137.00652103000004, -4.945733330999929],
              [136.95386803500003, -4.922784112999921],
              [136.94654381600003, -4.91765715899993],
              [136.94410241000003, -4.910332940999922],
              [136.94996178500003, -4.899021091999941],
              [136.9619246750001, -4.891045830999929],
              [136.9736434250001, -4.885023695999905],
              [136.978851759, -4.879571221999925],
              [136.9692488940001, -4.869561455999929],
              [136.9472762380001, -4.875583591999941],
              [136.87452233200008, -4.919854424999926],
              [136.85377037900003, -4.928155205999929],
              [136.83179772200003, -4.931410414999959],
              [136.82211347700002, -4.928317966999941],
              [136.811859571, -4.920342705999929],
              [136.80396569100003, -4.910251559999949],
              [136.80062910200002, -4.900485934999949],
              [136.80298912900003, -4.882907809999949],
              [136.799164259, -4.880059502999927],
              [136.78638756600003, -4.876153252999927],
              [136.76343834700003, -4.874118747999944],
              [136.75310306100005, -4.880059502999927],
              [136.7431746750001, -4.881524346999925],
              [136.6958113940001, -4.846856377999927],
              [136.62647545700008, -4.822849216999941],
              [136.53785241000003, -4.773614190999922],
              [136.46371504, -4.73601653399993],
              [136.44019616000003, -4.715264580999929],
              [136.43344160200002, -4.712334893999923],
              [136.4130965500001, -4.711683851999908],
              [136.4028426440001, -4.707696221999925],
              [136.37566165500004, -4.683770440999922],
              [136.3554793630001, -4.67742278399993],
              [136.26734459700003, -4.676202080999929],
              [136.17701256600003, -4.649590752999927],
              [136.14665774800005, -4.626397393999923],
              [136.14600670700008, -4.62232838299991],
              [136.121918165, -4.619317315999922],
              [136.10670006600003, -4.612074476999908],
              [136.0947371750001, -4.603122653999947],
              [136.08073978000004, -4.59498463299991],
              [136.0629988940001, -4.590590101999908],
              [136.04965254, -4.590020440999922],
              [136.03581790500004, -4.586032809999949],
              [136.01587975400003, -4.571465752999927],
              [135.97046959700003, -4.519626559999949],
              [135.95045006600003, -4.506280205999929],
              [135.91228274800005, -4.498142184999949],
              [135.828949415, -4.498630466999941],
              [135.79273522200003, -4.485772393999923],
              [135.77621504, -4.494561455999929],
              [135.750336134, -4.497247002999927],
              [135.7246199880001, -4.495293877999927],
              [135.7080184250001, -4.489190362999921],
              [135.699554884, -4.487237237999921],
              [135.65609785200002, -4.485772393999923],
              [135.6142684250001, -4.474704684999949],
              [135.60474694100003, -4.46843840899993],
              [135.58741295700008, -4.460381768999923],
              [135.46656334700003, -4.446058851999908],
              [135.44361412900003, -4.44068775799991],
              [135.42953535200002, -4.430433851999908],
              [135.41334069100003, -4.436293226999908],
              [135.35914147200003, -4.443617445999905],
              [135.3305770190001, -4.439873955999929],
              [135.2719832690001, -4.458428643999923],
              [135.22779381600003, -4.461195570999905],
              [135.1855574880001, -4.44890715899993],
              [134.95915774800005, -4.318617445999905],
              [134.94312584700003, -4.30592213299991],
              [134.93620853000004, -4.290215752999927],
              [134.92741946700005, -4.275648695999905],
              [134.906586134, -4.264092705999929],
              [134.8818465500001, -4.256117445999905],
              [134.86109459700003, -4.252373955999929],
              [134.82349694100003, -4.259372653999947],
              [134.82007897200003, -4.259209893999923],
              [134.80982506600003, -4.254082940999922],
              [134.79224694100003, -4.238702080999929],
              [134.73975670700008, -4.204034112999921],
              [134.7334090500001, -4.197523695999905],
              [134.73072350400003, -4.187595309999949],
              [134.72584069100003, -4.15007903399993],
              [134.72388756600003, -4.142510674999926],
              [134.706390821, -4.137302341999941],
              [134.68116295700008, -4.136814059999949],
              [134.65805097700002, -4.133396091999941],
              [134.64820397200003, -4.118747653999947],
              [134.6552840500001, -4.099786065999922],
              [134.68775475400003, -4.073174737999921],
              [134.69654381600003, -4.053155205999929],
              [134.69410241000003, -4.045179945999905],
              [134.6806746750001, -4.03289153399993],
              [134.67603600400003, -4.026462497999944],
              [134.67457116000003, -4.016289971999925],
              [134.67920983200008, -3.960707289999959],
              [134.6884871750001, -3.947442315999922],
              [134.70337975400003, -3.940362237999921],
              [134.72388756600003, -3.937758070999905],
              [134.74089603000004, -3.939548434999949],
              [134.7822371750001, -3.949151299999926],
              [134.86443118600005, -3.953220309999949],
              [134.88209069100003, -3.957614841999941],
              [134.907074415, -3.975518487999921],
              [134.91627037900003, -3.978692315999922],
              [134.9277449880001, -3.976657809999949],
              [134.93572024800005, -3.97193775799991],
              [134.9414168630001, -3.967217705999929],
              [134.94703209700003, -3.965020440999922],
              [134.96745853000004, -3.951836846999925],
              [134.97095787900003, -3.947930596999925],
              [134.9677840500001, -3.93678150799991],
              [134.960297071, -3.939385674999926],
              [134.95142662900003, -3.947198174999926],
              [134.94361412900003, -3.951348565999922],
              [134.93091881600003, -3.948337497999944],
              [134.9238387380001, -3.943129164999959],
              [134.921234571, -3.938653252999927],
              [134.92261803500003, -3.937758070999905],
              [134.92066491000003, -3.934747002999927],
              [134.9209090500001, -3.93092213299991],
              [134.9204207690001, -3.926853122999944],
              [134.91627037900003, -3.923435153999947],
              [134.90845787900003, -3.922539971999925],
              [134.90186608200008, -3.925225518999923],
              [134.89576256600003, -3.92896900799991],
              [134.88892662900003, -3.93092213299991],
              [134.844574415, -3.930108330999929],
              [134.7700301440001, -3.918226820999905],
              [134.692230665, -3.914808851999908],
              [134.6860457690001, -3.913506768999923],
              [134.6757918630001, -3.908379815999922],
              [134.66968834700003, -3.914239190999922],
              [134.6660262380001, -3.924004815999922],
              [134.66236412900003, -3.93092213299991],
              [134.63355553500003, -3.945082289999959],
              [134.62029056100005, -3.954685153999947],
              [134.614593946, -3.96843840899993],
              [134.61150149800005, -3.988213799999926],
              [134.60222415500004, -4.000664971999925],
              [134.58716881600003, -4.008070570999905],
              [134.532562696, -4.022067966999941],
              [134.52523847700002, -4.026462497999944],
              [134.509125196, -4.015883070999905],
              [134.4843856130001, -3.990492445999905],
              [134.4638778000001, -3.978692315999922],
              [134.47836347700002, -3.961602471999925],
              [134.46697024800005, -3.943291924999926],
              [134.44703209700003, -3.926446221999925],
              [134.4365340500001, -3.913506768999923],
              [134.43043053500003, -3.907810153999947],
              [134.41675866000003, -3.904554945999905],
              [134.39210045700008, -3.903008721999925],
              [134.37525475400003, -3.899102471999925],
              [134.33350670700008, -3.86882903399993],
              [134.35141035200002, -3.899102471999925],
              [134.3603621750001, -3.925957940999922],
              [134.348968946, -3.943454684999949],
              [134.30616295700008, -3.944512627999927],
              [134.30616295700008, -3.951348565999922],
              [134.31861412900003, -3.958184502999927],
              [134.32960045700008, -3.96843840899993],
              [134.33741295700008, -3.981215101999908],
              [134.3403426440001, -3.996026299999926],
              [134.3266707690001, -4.019707940999922],
              [134.31527754, -4.020277601999908],
              [134.30933678500003, -4.015557549999926],
              [134.306000196, -4.009535414999959],
              [134.3027449880001, -4.006605726999908],
              [134.29273522200003, -4.000176690999922],
              [134.28386478000004, -3.985935153999947],
              [134.27222741000003, -3.971449476999908],
              [134.2544051440001, -3.965020440999922],
              [134.2348738940001, -3.962660414999959],
              [134.21119225400003, -3.955336195999905],
              [134.19117272200003, -3.943536065999922],
              [134.1826278000001, -3.927178643999923],
              [134.18148847700002, -3.917575778999947],
              [134.1762801440001, -3.900323174999926],
              [134.175140821, -3.893324476999908],
              [134.1704207690001, -3.888116143999923],
              [134.15967858200008, -3.892754815999922],
              [134.14812259200005, -3.90007903399993],
              [134.1411238940001, -3.903008721999925],
              [134.13396243600005, -3.890069268999923],
              [134.14421634200005, -3.874769789999959],
              [134.18580162900003, -3.842543226999908],
              [134.19263756600003, -3.835544528999947],
              [134.19092858200008, -3.826267184999949],
              [134.17310631600003, -3.787855726999908],
              [134.16163170700008, -3.771661065999922],
              [134.1469832690001, -3.757582289999959],
              [134.1274520190001, -3.745293877999927],
              [134.12224368600005, -3.753676039999959],
              [134.12330162900003, -3.760918877999927],
              [134.12647545700008, -3.768731377999927],
              [134.1274520190001, -3.779473565999922],
              [134.12647545700008, -3.799248955999929],
              [134.122406446, -3.805352471999925],
              [134.1103621750001, -3.817559502999927],
              [134.0918074880001, -3.823988539999959],
              [134.07447350400003, -3.812920830999929],
              [134.05738366000003, -3.79810963299991],
              [134.03931725400003, -3.793145440999922],
              [134.02320397200003, -3.805108330999929],
              [133.999359571, -3.846286716999941],
              [133.987640821, -3.85515715899993],
              [133.971039259, -3.850274346999925],
              [133.9589949880001, -3.83757903399993],
              [133.91334069100003, -3.729424737999921],
              [133.89600670700008, -3.70240650799991],
              [133.85271243600005, -3.653903903999947],
              [133.84359785200002, -3.63836028399993],
              [133.84009850400003, -3.618340752999927],
              [133.84099368600005, -3.597751559999949],
              [133.83814537900003, -3.590427341999941],
              [133.82984459700003, -3.58757903399993],
              [133.82252037900003, -3.589939059999949],
              [133.81324303500003, -3.59539153399993],
              [133.80445397200003, -3.602308851999908],
              [133.79908287900003, -3.608819268999923],
              [133.7954207690001, -3.631524346999925],
              [133.80339603000004, -3.654066664999959],
              [133.81413821700005, -3.675388278999947],
              [133.8232528000001, -3.704522393999923],
              [133.8291121750001, -3.714450778999947],
              [133.82927493600005, -3.721856377999927],
              [133.815765821, -3.724786065999922],
              [133.80982506600003, -3.720310153999947],
              [133.79908287900003, -3.69068775799991],
              [133.79021243600005, -3.680352471999925],
              [133.77759850400003, -3.669122002999927],
              [133.76295006600003, -3.660251559999949],
              [133.74756920700008, -3.656508070999905],
              [133.73259524800005, -3.662855726999908],
              [133.71656334700003, -3.672784112999921],
              [133.7031356130001, -3.672621351999908],
              [133.69605553500003, -3.649102471999925],
              [133.70728600400003, -3.630303643999923],
              [133.70972741000003, -3.621758721999925],
              [133.7080184250001, -3.610121351999908],
              [133.69841556100005, -3.590264580999929],
              [133.689789259, -3.564548434999949],
              [133.64820397200003, -3.505059502999927],
              [133.641449415, -3.48365650799991],
              [133.64185631600003, -3.461602471999925],
              [133.653168165, -3.444431247999944],
              [133.67896569100003, -3.437432549999926],
              [133.69678795700008, -3.42742278399993],
              [133.7021590500001, -3.404392184999949],
              [133.7002059250001, -3.379001559999949],
              [133.68336022200003, -3.304945570999962],
              [133.68311608200008, -3.232517184999949],
              [133.69092858200008, -3.21607838299991],
              [133.70972741000003, -3.232028903999947],
              [133.7138778000001, -3.224704684999949],
              [133.7158309250001, -3.215915622999944],
              [133.71656334700003, -3.193780205999929],
              [133.72242272200003, -3.183038018999923],
              [133.735687696, -3.183363539999959],
              [133.75806725400003, -3.190362237999921],
              [133.77116946700005, -3.17546965899993],
              [133.78394616000003, -3.131442966999941],
              [133.80250084700003, -3.122165622999944],
              [133.822601759, -3.115655205999929],
              [133.84644616000003, -3.087090752999927],
              [133.86394290500004, -3.080498955999929],
              [133.8828231130001, -3.091566664999959],
              [133.89909915500004, -3.11296965899993],
              [133.9140731130001, -3.126560153999947],
              [133.92945397200003, -3.114678643999923],
              [133.92359459700003, -3.11101653399993],
              [133.91944420700008, -3.106377862999921],
              [133.91675866000003, -3.099867445999962],
              [133.91578209700003, -3.090915622999944],
              [133.91228274800005, -3.083428643999923],
              [133.90406334700003, -3.07935963299991],
              [133.89478600400003, -3.076836846999925],
              [133.8877059250001, -3.073663018999923],
              [133.8789168630001, -3.065524997999944],
              [133.87037194100003, -3.055108330999929],
              [133.86394290500004, -3.042087497999944],
              [133.86052493600005, -3.025974216999941],
              [133.86304772200003, -3.008233330999929],
              [133.87769616000003, -2.979261976999908],
              [133.88160241000003, -2.963799737999921],
              [133.87964928500003, -2.952243747999944],
              [133.874359571, -2.940606377999927],
              [133.86736087300005, -2.930352471999925],
              [133.86052493600005, -2.922946872999944],
              [133.8437606130001, -2.927829684999949],
              [133.82569420700008, -2.928887627999927],
              [133.81755618600005, -2.934747002999927],
              [133.82984459700003, -2.953871351999908],
              [133.82789147200003, -2.959649346999925],
              [133.81519616000003, -2.983575127999927],
              [133.8090926440001, -3.010186455999929],
              [133.801605665, -3.018161716999941],
              [133.73414147200003, -3.052666924999926],
              [133.71998131600003, -3.063571872999944],
              [133.69092858200008, -3.092868747999944],
              [133.66822350400003, -3.122165622999944],
              [133.65552819100003, -3.188897393999923],
              [133.66334069100003, -3.361504815999922],
              [133.62769616000003, -3.416273695999962],
              [133.613617384, -3.421970309999949],
              [133.55884850400003, -3.43328215899993],
              [133.55103600400003, -3.431573174999926],
              [133.54558353000004, -3.424248955999929],
              [133.52849368600005, -3.386651299999926],
              [133.52466881600003, -3.382256768999923],
              [133.514008009, -3.378350518999923],
              [133.51319420700008, -3.384372653999947],
              [133.5185653000001, -3.403252862999921],
              [133.51937910200002, -3.430840752999927],
              [133.51197350400003, -3.438653252999927],
              [133.490570509, -3.437432549999926],
              [133.490570509, -3.444268487999921],
              [133.51124108200008, -3.455173434999949],
              [133.55062910200002, -3.468682549999926],
              [133.56910241000003, -3.481866143999923],
              [133.58228600400003, -3.500176690999922],
              [133.590179884, -3.522230726999908],
              [133.5918074880001, -3.545342705999929],
              [133.58619225400003, -3.566582940999922],
              [133.57593834700003, -3.580498955999929],
              [133.55925540500004, -3.596449476999908],
              [133.539886915, -3.609551690999922],
              [133.52165774800005, -3.61492278399993],
              [133.50562584700003, -3.62232838299991],
              [133.40886478000004, -3.722426039999959],
              [133.39665774800005, -3.755954684999949],
              [133.4087020190001, -3.800551039999959],
              [133.44019616000003, -3.827569268999923],
              [133.4555770190001, -3.84693775799991],
              [133.45337975400003, -3.865411065999922],
              [133.44312584700003, -3.872816664999959],
              [133.42074629, -3.88054778399993],
              [133.41179446700005, -3.886163018999923],
              [133.40308678500003, -3.896416924999926],
              [133.38819420700008, -3.923435153999947],
              [133.26937910200002, -4.05201588299991],
              [133.2509871750001, -4.066827080999929],
              [133.2109481130001, -4.078383070999905],
              [133.16391035200002, -4.076267184999949],
              [133.0791121750001, -4.060642184999949],
              [133.05152428500003, -4.061211846999925],
              [133.0351668630001, -4.070082289999959],
              [133.00749759200005, -4.104668877999927],
              [132.98991946700005, -4.113946221999925],
              [132.96941165500004, -4.111993096999925],
              [132.91814212300005, -4.09107838299991],
              [132.91228274800005, -4.090264580999929],
              [132.90772545700008, -4.088148695999905],
              [132.90162194100003, -4.081149997999944],
              [132.89625084700003, -4.068942966999941],
              [132.8969832690001, -4.048272393999923],
              [132.89136803500003, -4.036716403999947],
              [132.88111412900003, -4.027764580999929],
              [132.8593856130001, -4.016534112999921],
              [132.849945509, -4.009698174999926],
              [132.841156446, -3.998142184999949],
              [132.83155358200008, -3.975355726999908],
              [132.82585696700005, -3.965020440999922],
              [132.8169051440001, -3.957614841999941],
              [132.8056746750001, -3.949965101999908],
              [132.7959090500001, -3.940606377999927],
              [132.79175866000003, -3.927178643999923],
              [132.79639733200008, -3.918145440999922],
              [132.80681399800005, -3.922133070999905],
              [132.82585696700005, -3.937758070999905],
              [132.82634524800005, -3.926446221999925],
              [132.824554884, -3.916436455999929],
              [132.802093946, -3.858168226999908],
              [132.78793379, -3.844008070999905],
              [132.78492272200003, -3.837823174999926],
              [132.78589928500003, -3.80396900799991],
              [132.78492272200003, -3.793145440999922],
              [132.7309676440001, -3.682305596999925],
              [132.72966556100005, -3.649102471999925],
              [132.75611412900003, -3.627536716999941],
              [132.79712975400003, -3.63404713299991],
              [132.8422957690001, -3.646579684999949],
              [132.88111412900003, -3.642836195999905],
              [132.89014733200008, -3.634535414999959],
              [132.89079837300005, -3.626885674999926],
              [132.88835696700005, -3.618584893999923],
              [132.88795006600003, -3.608819268999923],
              [132.8916121750001, -3.594903252999927],
              [132.89625084700003, -3.586358330999929],
              [132.91187584700003, -3.570245049999926],
              [132.92750084700003, -3.561130466999941],
              [132.93181399800005, -3.554131768999923],
              [132.92546634200005, -3.543226820999905],
              [132.91529381600003, -3.53484465899993],
              [132.907562696, -3.529961846999925],
              [132.90113366000003, -3.524021091999941],
              [132.89478600400003, -3.511895440999922],
              [132.8808699880001, -3.475355726999908],
              [132.8715926440001, -3.471368096999925],
              [132.849945509, -3.470961195999962],
              [132.83187910200002, -3.461032809999949],
              [132.821136915, -3.437432549999926],
              [132.81275475400003, -3.389743747999944],
              [132.811859571, -3.366631768999923],
              [132.81902103000004, -3.303643487999921],
              [132.81169681100005, -3.281670830999929],
              [132.79444420700008, -3.271661065999922],
              [132.77409915500004, -3.269789320999962],
              [132.7407332690001, -3.276543877999927],
              [132.73389733200008, -3.279961846999925],
              [132.72966556100005, -3.286065362999921],
              [132.72934004, -3.298435153999947],
              [132.73755944100003, -3.321058851999908],
              [132.73324629, -3.330987237999921],
              [132.71412194100003, -3.340020440999922],
              [132.69214928500003, -3.338148695999962],
              [132.67115319100003, -3.328545830999929],
              [132.65447024800005, -3.313897393999923],
              [132.6489363940001, -3.304864190999922],
              [132.63404381600003, -3.272393487999921],
              [132.62614993600005, -3.262627862999921],
              [132.60303795700008, -3.24187590899993],
              [132.60222415500004, -3.231866143999923],
              [132.61638431100005, -3.224867445999962],
              [132.6298934250001, -3.215101820999962],
              [132.62720787900003, -3.197360934999949],
              [132.62061608200008, -3.192315362999921],
              [132.59644616000003, -3.17937590899993],
              [132.58936608200008, -3.176853122999944],
              [132.58179772200003, -3.170342705999929],
              [132.572601759, -3.142185153999947],
              [132.56861412900003, -3.135837497999944],
              [132.56324303500003, -3.130466403999947],
              [132.55933678500003, -3.118747653999947],
              [132.553070509, -3.107028903999947],
              [132.54118899800005, -3.101657809999949],
              [132.53394616000003, -3.09734465899993],
              [132.5146590500001, -3.078057549999926],
              [132.50709069100003, -3.073663018999923],
              [132.49586022200003, -3.070570570999962],
              [132.48845462300005, -3.063083591999941],
              [132.4824324880001, -3.053887627999927],
              [132.47584069100003, -3.046482028999947],
              [132.3657332690001, -2.985284112999921],
              [132.3398543630001, -2.977634372999944],
              [132.3422957690001, -2.958184502999927],
              [132.32569420700008, -2.94654713299991],
              [132.277679884, -2.936618747999944],
              [132.26685631600003, -2.935479424999926],
              [132.23316491000003, -2.936618747999944],
              [132.21989993600005, -2.934258721999925],
              [132.2094832690001, -2.92896900799991],
              [132.1997176440001, -2.922539971999925],
              [132.188324415, -2.916680596999925],
              [132.1845809250001, -2.936211846999925],
              [132.168793165, -2.946465752999927],
              [132.15105228000004, -2.946709893999923],
              [132.1406356130001, -2.936618747999944],
              [132.1313582690001, -2.941338799999926],
              [132.12330162900003, -2.942315362999921],
              [132.1152449880001, -2.940524997999944],
              [132.1064559250001, -2.936618747999944],
              [132.11109459700003, -2.954278252999927],
              [132.10124759200005, -2.959893487999921],
              [132.07545006600003, -2.957696221999925],
              [132.07349694100003, -2.951429945999962],
              [132.057953321, -2.916680596999925],
              [132.03874759200005, -2.926446221999925],
              [131.996918165, -2.914808851999908],
              [131.98218834700003, -2.929782809999949],
              [131.97608483200008, -2.929782809999949],
              [131.977875196, -2.914646091999941],
              [131.98454837300005, -2.907647393999923],
              [131.99366295700008, -2.903090101999908],
              [132.00342858200008, -2.89617278399993],
              [132.01286868600005, -2.885918877999927],
              [132.01775149800005, -2.87859465899993],
              [132.0239363940001, -2.854668877999927],
              [132.00570722700002, -2.852715752999927],
              [131.98975670700008, -2.848402601999908],
              [131.98975670700008, -2.840997002999927],
              [132.0044051440001, -2.837090752999927],
              [132.0224715500001, -2.829034112999921],
              [132.03785241000003, -2.817559502999927],
              [132.04444420700008, -2.803399346999925],
              [132.03500410200002, -2.793552341999941],
              [132.01286868600005, -2.790948174999926],
              [131.96558678500003, -2.793145440999922],
              [131.9580184250001, -2.788181247999944],
              [131.9726668630001, -2.776950778999947],
              [132.0102645190001, -2.75904713299991],
              [132.02719160200002, -2.75904713299991],
              [132.04444420700008, -2.761163018999923],
              [132.05827884200005, -2.758558851999908],
              [132.0654403000001, -2.744805596999925],
              [132.0742293630001, -2.755791924999926],
              [132.08155358200008, -2.757907809999949],
              [132.08423912900003, -2.751722914999959],
              [132.078461134, -2.738539320999962],
              [132.08806399800005, -2.73560963299991],
              [132.13038170700008, -2.738539320999962],
              [132.15577233200008, -2.733493747999944],
              [132.18148847700002, -2.724867445999962],
              [132.1601668630001, -2.715590101999908],
              [132.11085045700008, -2.719414971999925],
              [132.1132918630001, -2.70435963299991],
              [132.12134850400003, -2.697930596999925],
              [132.16163170700008, -2.68328215899993],
              [132.18148847700002, -2.68328215899993],
              [132.19483483200008, -2.678317966999941],
              [132.20191491000003, -2.676446221999925],
              [132.31177819100003, -2.676446221999925],
              [132.32569420700008, -2.679864190999922],
              [132.3671981130001, -2.69695403399993],
              [132.38200931100005, -2.699314059999949],
              [132.41553795700008, -2.69695403399993],
              [132.40805097700002, -2.69695403399993],
              [132.4130965500001, -2.696465752999927],
              [132.42847741000003, -2.69695403399993],
              [132.4243270190001, -2.710381768999923],
              [132.430023634, -2.721449476999908],
              [132.43336022200003, -2.732191664999959],
              [132.42115319100003, -2.744805596999925],
              [132.437836134, -2.745049737999921],
              [132.4599715500001, -2.732679945999962],
              [132.47584069100003, -2.731133721999925],
              [132.47584069100003, -2.724867445999962],
              [132.46892337300005, -2.707614841999941],
              [132.48462975400003, -2.699476820999962],
              [132.5063582690001, -2.698011976999908],
              [132.51734459700003, -2.700778903999947],
              [132.5254012380001, -2.710544528999947],
              [132.544281446, -2.713799737999921],
              [132.566742384, -2.71453215899993],
              [132.58570397200003, -2.717461846999925],
              [132.62061608200008, -2.740899346999925],
              [132.679047071, -2.801690362999921],
              [132.71599368600005, -2.814222914999959],
              [132.72828209700003, -2.813164971999925],
              [132.73658287900003, -2.809991143999923],
              [132.75505618600005, -2.79656340899993],
              [132.7636824880001, -2.786309502999927],
              [132.77686608200008, -2.779229424999926],
              [132.835297071, -2.73601653399993],
              [132.85303795700008, -2.717461846999925],
              [132.90300540500004, -2.645928643999923],
              [132.9277449880001, -2.627699476999908],
              [132.94939212300005, -2.580254815999922],
              [133.0083113940001, -2.514418226999908],
              [133.01710045700008, -2.494886976999908],
              [133.033539259, -2.479424737999921],
              [133.11215254, -2.442803643999923],
              [133.1377059250001, -2.435723565999922],
              [133.143890821, -2.434991143999923],
              [133.15154056100005, -2.43287525799991],
              [133.15886478000004, -2.429864190999922],
              [133.16472415500004, -2.426039320999962],
              [133.1728621750001, -2.422051690999922],
              [133.1801863940001, -2.423760674999926],
              [133.1875106130001, -2.427666924999926],
              [133.1962996750001, -2.429457289999959],
              [133.21314537900003, -2.426364841999941],
              [133.239593946, -2.416761976999908],
              [133.25847415500004, -2.416436455999929],
              [133.31234785200002, -2.44304778399993],
              [133.31763756600003, -2.45671965899993],
              [133.32056725400003, -2.49187590899993],
              [133.32601972700002, -2.50514088299991],
              [133.3383895190001, -2.496189059999949],
              [133.35377037900003, -2.496270440999922],
              [133.36898847700002, -2.502536716999941],
              [133.38070722700002, -2.511976820999962],
              [133.39031009200005, -2.52662525799991],
              [133.39210045700008, -2.538669528999947],
              [133.38819420700008, -2.566582940999922],
              [133.38835696700005, -2.652276299999926],
              [133.38070722700002, -2.676446221999925],
              [133.40300540500004, -2.675225518999923],
              [133.40805097700002, -2.659600518999923],
              [133.40186608200008, -2.615004164999959],
              [133.40455162900003, -2.591403903999947],
              [133.410980665, -2.566501559999949],
              [133.4379988940001, -2.503024997999944],
              [133.44556725400003, -2.494724216999941],
              [133.45655358200008, -2.498304945999962],
              [133.45866946700005, -2.506931247999944],
              [133.45655358200008, -2.54615650799991],
              [133.46119225400003, -2.595310153999947],
              [133.4589949880001, -2.618096612999921],
              [133.45036868600005, -2.642347914999959],
              [133.46509850400003, -2.636163018999923],
              [133.4731551440001, -2.615980726999908],
              [133.476898634, -2.570407809999949],
              [133.47478274800005, -2.558363539999959],
              [133.47087649800005, -2.545098565999922],
              [133.469086134, -2.532159112999921],
              [133.473480665, -2.521661065999922],
              [133.48503665500004, -2.516534112999921],
              [133.492523634, -2.523532809999949],
              [133.497406446, -2.533949476999908],
              [133.50945071700005, -2.55006275799991],
              [133.5122176440001, -2.572198174999926],
              [133.51872806100005, -2.589613539999959],
              [133.53834069100003, -2.587090752999927],
              [133.5395613940001, -2.58326588299991],
              [133.53972415500004, -2.568780205999929],
              [133.54175866000003, -2.563571872999944],
              [133.5473738940001, -2.560804945999962],
              [133.5595809250001, -2.561618747999944],
              [133.56568444100003, -2.560316664999959],
              [133.58562259200005, -2.55242278399993],
              [133.59522545700008, -2.545668226999908],
              [133.60670006600003, -2.53248463299991],
              [133.6152449880001, -2.541110934999949],
              [133.62232506600003, -2.541761976999908],
              [133.62842858200008, -2.539646091999941],
              [133.63396243600005, -2.539320570999962],
              [133.6406356130001, -2.542901299999926],
              [133.66724694100003, -2.563409112999921],
              [133.67335045700008, -2.574802341999941],
              [133.67546634200005, -2.588067315999922],
              [133.6762801440001, -2.649021091999941],
              [133.6718856130001, -2.65943775799991],
              [133.6684676440001, -2.670830987999921],
              [133.68238366000003, -2.717461846999925],
              [133.691742384, -2.704278252999927],
              [133.6923934250001, -2.691501559999949],
              [133.689789259, -2.676202080999929],
              [133.68921959700003, -2.656019789999959],
              [133.6933699880001, -2.637302341999941],
              [133.70679772200003, -2.597832940999922],
              [133.70972741000003, -2.577243747999944],
              [133.70972741000003, -2.52117278399993],
              [133.71314537900003, -2.511976820999962],
              [133.73503665500004, -2.516778252999927],
              [133.747406446, -2.529229424999926],
              [133.76433353000004, -2.566582940999922],
              [133.78541100400003, -2.597751559999949],
              [133.79908287900003, -2.642347914999959],
              [133.8110457690001, -2.65398528399993],
              [133.8169051440001, -2.649021091999941],
              [133.81918379, -2.632989190999922],
              [133.81959069100003, -2.611586195999962],
              [133.82789147200003, -2.549899997999944],
              [133.82300866000003, -2.539320570999962],
              [133.82178795700008, -2.535577080999929],
              [133.80884850400003, -2.520196221999925],
              [133.80591881600003, -2.518243096999925],
              [133.80396569100003, -2.506768487999921],
              [133.80486087300005, -2.497002862999921],
              [133.8095809250001, -2.487481377999927],
              [133.81959069100003, -2.477227471999925],
              [133.8017684250001, -2.470310153999947],
              [133.76726321700005, -2.47193775799991],
              [133.75123131600003, -2.462985934999949],
              [133.74097741000003, -2.445896091999941],
              [133.74724368600005, -2.437920830999929],
              [133.76319420700008, -2.435723565999922],
              [133.7817488940001, -2.435723565999922],
              [133.8261824880001, -2.426202080999929],
              [133.8501082690001, -2.424248955999929],
              [133.86052493600005, -2.432549737999921],
              [133.8662215500001, -2.442966403999947],
              [133.89332116000003, -2.465997002999927],
              [133.90211022200003, -2.477227471999925],
              [133.90837649800005, -2.477227471999925],
              [133.8964949880001, -2.457940362999921],
              [133.87647545700008, -2.43287525799991],
              [133.86646569100003, -2.41139088299991],
              [133.88461347700002, -2.402113539999959],
              [133.95460045700008, -2.409112237999921],
              [133.98658287900003, -2.406182549999926],
              [134.00513756600003, -2.388441664999959],
              [133.94890384200005, -2.390394789999959],
              [133.9209090500001, -2.387627862999921],
              [133.89869225400003, -2.377618096999925],
              [133.8945418630001, -2.363376559999949],
              [133.94507897200003, -2.343926690999922],
              [133.96355228000004, -2.326429945999962],
              [133.937836134, -2.327325127999927],
              [133.89283287900003, -2.340264580999929],
              [133.86736087300005, -2.341241143999923],
              [133.86736087300005, -2.333916924999926],
              [133.91358483200008, -2.319512627999927],
              [133.934418165, -2.308689059999949],
              [133.94996178500003, -2.292901299999926],
              [133.9570418630001, -2.272637627999927],
              [133.95972741000003, -2.246677341999941],
              [133.957367384, -2.221449476999908],
              [133.94996178500003, -2.203545830999929],
              [133.93970787900003, -2.255059502999927],
              [133.92896569100003, -2.274183851999908],
              [133.90837649800005, -2.258721612999921],
              [133.90211022200003, -2.258721612999921],
              [133.87419681100005, -2.281670830999929],
              [133.85474694100003, -2.294122002999927],
              [133.84009850400003, -2.299737237999921],
              [133.82349694100003, -2.294854424999926],
              [133.80730228000004, -2.27117278399993],
              [133.79566491000003, -2.265557549999926],
              [133.7920028000001, -2.260186455999929],
              [133.799164259, -2.248630466999941],
              [133.81316165500004, -2.236911716999941],
              [133.84750410200002, -2.227715752999927],
              [133.86304772200003, -2.217950127999927],
              [133.87476647200003, -2.204685153999947],
              [133.88160241000003, -2.189873955999929],
              [133.9013778000001, -2.198418877999927],
              [133.9170028000001, -2.190850518999923],
              [133.931976759, -2.177504164999959],
              [133.94996178500003, -2.169366143999923],
              [133.94312584700003, -2.162530205999929],
              [133.93116295700008, -2.168633721999925],
              [133.91293379, -2.175225518999923],
              [133.89795983200008, -2.17546965899993],
              [133.89527428500003, -2.162530205999929],
              [133.9004012380001, -2.159274997999944],
              [133.9218856130001, -2.152764580999929],
              [133.92945397200003, -2.148858330999929],
              [133.93279056100005, -2.14226653399993],
              [133.93531334700003, -2.125664971999925],
              [133.93970787900003, -2.118259372999944],
              [133.9404403000001, -2.107598565999922],
              [133.922211134, -2.104424737999921],
              [133.89909915500004, -2.106377862999921],
              [133.88461347700002, -2.111423434999949],
              [133.87916100400003, -2.110772393999923],
              [133.868500196, -2.108168226999908],
              [133.85816491000003, -2.107354424999926],
              [133.85368899800005, -2.111423434999949],
              [133.83855228000004, -2.13600025799991],
              [133.83326256600003, -2.142185153999947],
              [133.82447350400003, -2.145440362999921],
              [133.8076278000001, -2.146579684999949],
              [133.79908287900003, -2.148858330999929],
              [133.77320397200003, -2.16529713299991],
              [133.76433353000004, -2.169366143999923],
              [133.72608483200008, -2.170505466999941],
              [133.7099715500001, -2.175551039999959],
              [133.703461134, -2.193617445999962],
              [133.6958113940001, -2.197849216999941],
              [133.67896569100003, -2.204278252999927],
              [133.6621199880001, -2.213962497999944],
              [133.65447024800005, -2.227715752999927],
              [133.65186608200008, -2.234144789999959],
              [133.64576256600003, -2.23601653399993],
              [133.63819420700008, -2.23365650799991],
              [133.6308699880001, -2.227715752999927],
              [133.62330162900003, -2.225274346999925],
              [133.61304772200003, -2.228285414999959],
              [133.59359785200002, -2.23756275799991],
              [133.59685306100005, -2.195082289999959],
              [133.59359785200002, -2.183038018999923],
              [133.5771590500001, -2.220472914999959],
              [133.56462649800005, -2.237888278999947],
              [133.54859459700003, -2.245049737999921],
              [133.53305097700002, -2.238457940999922],
              [133.52125084700003, -2.209649346999925],
              [133.50416100400003, -2.203545830999929],
              [133.50416100400003, -2.211032809999949],
              [133.5146590500001, -2.226006768999923],
              [133.49976647200003, -2.230726820999962],
              [133.47608483200008, -2.231540622999944],
              [133.44556725400003, -2.237888278999947],
              [133.4072371750001, -2.222263278999947],
              [133.38819420700008, -2.217217705999929],
              [133.34164472700002, -2.222751559999949],
              [133.31657962300005, -2.222588799999926],
              [133.305511915, -2.214043877999927],
              [133.29615319100003, -2.204196872999944],
              [133.274261915, -2.20631275799991],
              [133.23121178500003, -2.217217705999929],
              [133.19214928500003, -2.214288018999923],
              [133.16944420700008, -2.216892184999949],
              [133.13502037900003, -2.238457940999922],
              [133.1123153000001, -2.242933851999908],
              [133.06609134200005, -2.245049737999921],
              [133.02019290500004, -2.255791924999926],
              [132.98121178500003, -2.272149346999925],
              [132.94361412900003, -2.283379815999922],
              [132.90162194100003, -2.279229424999926],
              [132.83952884200005, -2.249118747999944],
              [132.81592858200008, -2.245049737999921],
              [132.793304884, -2.249444268999923],
              [132.77076256600003, -2.260023695999962],
              [132.69874108200008, -2.305352471999925],
              [132.68873131600003, -2.307224216999941],
              [132.6806746750001, -2.303155205999929],
              [132.67562910200002, -2.295993747999944],
              [132.669281446, -2.289157809999949],
              [132.65796959700003, -2.286065362999921],
              [132.6367293630001, -2.277276299999926],
              [132.62671959700003, -2.256442966999941],
              [132.62094160200002, -2.231540622999944],
              [132.61353600400003, -2.211032809999949],
              [132.60279381600003, -2.201755466999941],
              [132.5830184250001, -2.190850518999923],
              [132.56039472700002, -2.185642184999949],
              [132.54118899800005, -2.193617445999962],
              [132.52369225400003, -2.204196872999944],
              [132.45533287900003, -2.217217705999929],
              [132.38493899800005, -2.256524346999925],
              [132.34791100400003, -2.270114841999941],
              [132.3056746750001, -2.265557549999926],
              [132.28052819100003, -2.249769789999959],
              [132.2646590500001, -2.228285414999959],
              [132.2519637380001, -2.20476653399993],
              [132.23617597700002, -2.183038018999923],
              [132.21452884200005, -2.165785414999959],
              [132.07341556100005, -2.10515715899993],
              [132.04835045700008, -2.083184502999927],
              [132.04444420700008, -2.059502862999921],
              [132.05258222700002, -2.052829684999949],
              [132.0800887380001, -2.037692966999941],
              [132.0859481130001, -2.028903903999947],
              [132.09058678500003, -2.015557549999926],
              [132.10181725400003, -2.006931247999944],
              [132.1269637380001, -1.998142184999949],
              [132.0996199880001, -2.00123463299991],
              [132.0532332690001, -2.015394789999959],
              [132.0273543630001, -2.018487237999921],
              [132.00342858200008, -1.983819268999923],
              [131.98324629, -1.972588799999926],
              [131.97291100400003, -1.964613539999959],
              [131.96859785200002, -1.953383070999962],
              [131.971039259, -1.943129164999959],
              [131.97543379, -1.932224216999941],
              [131.97730553500003, -1.921644789999959],
              [131.97234134200005, -1.912367445999962],
              [131.96469160200002, -1.908868096999925],
              [131.95687910200002, -1.907647393999923],
              [131.9492293630001, -1.904473565999922],
              [131.9419051440001, -1.895114841999941],
              [131.938324415, -1.883721612999921],
              [131.9419051440001, -1.850681247999944],
              [131.94109134200005, -1.837497653999947],
              [131.93824303500003, -1.828301690999922],
              [131.9277449880001, -1.805759372999944],
              [131.9492293630001, -1.794691664999959],
              [131.9633895190001, -1.778497002999927],
              [131.97535241000003, -1.760430596999925],
              [131.98975670700008, -1.744805596999925],
              [132.00709069100003, -1.732191664999959],
              [132.01832116000003, -1.721286716999941],
              [132.0224715500001, -1.70631275799991],
              [132.01832116000003, -1.682793877999927],
              [132.01880944100003, -1.684014580999929],
              [132.02019290500004, -1.685642184999949],
              [132.0219832690001, -1.683851820999962],
              [132.0239363940001, -1.675957940999922],
              [132.0009871750001, -1.677911065999922],
              [131.96753991000003, -1.697198174999926],
              [131.92725670700008, -1.706231377999927],
              [131.91749108200008, -1.707289320999962],
              [131.90967858200008, -1.703301690999922],
              [131.9004012380001, -1.690199476999908],
              [131.90113366000003, -1.684177341999941],
              [131.90577233200008, -1.67742278399993],
              [131.9087020190001, -1.672051690999922],
              [131.9013778000001, -1.66765715899993],
              [131.89527428500003, -1.662855726999908],
              [131.88941491000003, -1.657159112999921],
              [131.8867293630001, -1.65203215899993],
              [131.8935653000001, -1.61101653399993],
              [131.89673912900003, -1.601495049999926],
              [131.91089928500003, -1.590264580999929],
              [131.9140731130001, -1.583428643999923],
              [131.92058353000004, -1.579196872999944],
              [131.94906660200002, -1.573337497999944],
              [131.9555770190001, -1.569756768999923],
              [131.97632897200003, -1.548597914999959],
              [131.98218834700003, -1.53875090899993],
              [131.96404056100005, -1.53875090899993],
              [131.90577233200008, -1.567071221999925],
              [131.8798934250001, -1.57350025799991],
              [131.88884524800005, -1.556573174999926],
              [131.88347415500004, -1.550876559999949],
              [131.87126712300005, -1.553155205999929],
              [131.8593856130001, -1.55982838299991],
              [131.82146243600005, -1.598239841999941],
              [131.80486087300005, -1.607598565999922],
              [131.79761803500003, -1.580824476999908],
              [131.80640709700003, -1.549981377999927],
              [131.8110457690001, -1.520440362999921],
              [131.79118899800005, -1.49773528399993],
              [131.78972415500004, -1.525648695999962],
              [131.78402754, -1.547458591999941],
              [131.77165774800005, -1.563246351999908],
              [131.75017337300005, -1.57350025799991],
              [131.7231551440001, -1.57195403399993],
              [131.70777428500003, -1.555840752999927],
              [131.70671634200005, -1.534763278999947],
              [131.72291100400003, -1.518243096999925],
              [131.70378665500004, -1.51100025799991],
              [131.68506920700008, -1.51490650799991],
              [131.666351759, -1.522393487999921],
              [131.64722741000003, -1.525648695999962],
              [131.62875410200002, -1.520928643999923],
              [131.61353600400003, -1.511163018999923],
              [131.58871504, -1.48756275799991],
              [131.57309004, -1.48015715899993],
              [131.55250084700003, -1.476983330999929],
              [131.52019290500004, -1.476739190999922],
              [131.51392662900003, -1.475192966999941],
              [131.5078231130001, -1.47193775799991],
              [131.5004988940001, -1.469659112999921],
              [131.48951256600003, -1.470472914999959],
              [131.4775496750001, -1.474053643999923],
              [131.469086134, -1.479099216999941],
              [131.465668165, -1.486586195999962],
              [131.46900475400003, -1.49773528399993],
              [131.45687910200002, -1.502862237999921],
              [131.446136915, -1.503838799999926],
              [131.4365340500001, -1.501722914999959],
              [131.42750084700003, -1.49773528399993],
              [131.40495853000004, -1.469903252999927],
              [131.40064537900003, -1.467054945999962],
              [131.39665774800005, -1.461032809999949],
              [131.38982181100005, -1.456801039999959],
              [131.3872176440001, -1.450778903999947],
              [131.3969832690001, -1.439385674999926],
              [131.40186608200008, -1.427341403999947],
              [131.395355665, -1.41375090899993],
              [131.383636915, -1.401950778999947],
              [131.37281334700003, -1.394707940999922],
              [131.342133009, -1.40357838299991],
              [131.3222762380001, -1.401055596999925],
              [131.27711022200003, -1.37428150799991],
              [131.27491295700008, -1.39185963299991],
              [131.2920028000001, -1.410088799999926],
              [131.3349715500001, -1.439385674999926],
              [131.3369246750001, -1.453057549999926],
              [131.32374108200008, -1.469170830999929],
              [131.3051863940001, -1.483086846999925],
              [131.2915145190001, -1.490980726999908],
              [131.25733483200008, -1.49773528399993],
              [131.22543379, -1.515557549999926],
              [131.20573978000004, -1.523614190999922],
              [131.19849694100003, -1.521254164999959],
              [131.19288170700008, -1.494805596999925],
              [131.1865340500001, -1.485039971999925],
              [131.17750084700003, -1.477308851999908],
              [131.16724694100003, -1.470472914999959],
              [131.126312696, -1.453301690999922],
              [131.0864363940001, -1.451267184999949],
              [131.00359134200005, -1.456231377999927],
              [130.97730553500003, -1.452894789999959],
              [130.960297071, -1.446221612999921],
              [130.95093834700003, -1.433689059999949],
              [130.9482528000001, -1.412204684999949],
              [130.9531356130001, -1.405043226999908],
              [130.98585045700008, -1.391289971999925],
              [130.99952233200008, -1.379082940999922],
              [131.0044051440001, -1.37232838299991],
              [131.03012129, -1.29851653399993],
              [131.02759850400003, -1.284112237999921],
              [131.03003991000003, -1.275567315999922],
              [131.04078209700003, -1.271905205999929],
              [131.04216556100005, -1.267836195999962],
              [131.05738366000003, -1.24773528399993],
              [131.07447350400003, -1.23756275799991],
              [131.1552840500001, -1.224541924999926],
              [131.1816512380001, -1.217217705999929],
              [131.18864993600005, -1.207207940999922],
              [131.2021590500001, -1.162692966999941],
              [131.23161868600005, -1.126071872999944],
              [131.23617597700002, -1.117282809999949],
              [131.23951256600003, -1.105645440999922],
              [131.25416100400003, -1.080254815999922],
              [131.25733483200008, -1.062676690999922],
              [131.25367272200003, -1.027601820999962],
              [131.25709069100003, -1.014336846999925],
              [131.27100670700008, -1.003676039999959],
              [131.26636803500003, -0.987888278999947],
              [131.2714949880001, -0.949395440999922],
              [131.26351972700002, -0.929294528999947],
              [131.27019290500004, -0.926853122999944],
              [131.2915145190001, -0.914971612999921],
              [131.25025475400003, -0.872653903999947],
              [131.2353621750001, -0.846449476999908],
              [131.243011915, -0.819431247999944],
              [131.33220462300005, -0.792738539999959],
              [131.3735457690001, -0.787855726999908],
              [131.387543165, -0.782647393999923],
              [131.398773634, -0.766289971999925],
              [131.4267684250001, -0.75945403399993],
              [131.4379988940001, -0.754001559999949],
              [131.45036868600005, -0.750095309999949],
              [131.4882918630001, -0.746840101999908],
              [131.49634850400003, -0.740329684999949],
              [131.5029403000001, -0.733330987999921],
              [131.517914259, -0.73170338299991],
              [131.5341903000001, -0.733493747999944],
              [131.54476972700002, -0.736911716999941],
              [131.5234481130001, -0.761976820999962],
              [131.5166121750001, -0.774346612999921],
              [131.51677493600005, -0.785251559999949],
              [131.53288821700005, -0.782647393999923],
              [131.55347741000003, -0.776788018999923],
              [131.5712996750001, -0.76921965899993],
              [131.57886803500003, -0.76100025799991],
              [131.590179884, -0.756524346999925],
              [131.77955162900003, -0.719170830999929],
              [131.86345462300005, -0.691989841999941],
              [131.87647545700008, -0.689629815999922],
              [131.88428795700008, -0.681898695999962],
              [131.90845787900003, -0.633884372999944],
              [131.95191491000003, -0.588799737999921],
              [131.978851759, -0.566664320999962],
              [132.00342858200008, -0.551853122999944],
              [132.056000196, -0.534274997999944],
              [132.0688582690001, -0.531996351999908],
              [132.07488040500004, -0.523370049999926],
              [132.09205162900003, -0.483005466999941],
              [132.0996199880001, -0.469903252999927],
              [132.1508895190001, -0.435723565999922],
              [132.16627037900003, -0.432224216999941],
              [132.19988040500004, -0.414646091999941],
              [132.23715254, -0.401543877999927],
              [132.2700301440001, -0.384535414999959],
              [132.28793379, -0.381117445999962],
              [132.31275475400003, -0.379327080999929],
              [132.39665774800005, -0.353448174999926],
              [132.43718509200005, -0.347100518999923],
              [132.67920983200008, -0.368910414999959],
              [132.70915774800005, -0.360039971999925],
              [132.9052840500001, -0.453220309999949],
              [132.92546634200005, -0.45631275799991],
              [132.93677819100003, -0.454034112999921],
              [132.95980879, -0.441989841999941],
              [132.9751082690001, -0.444756768999923],
              [132.97868899800005, -0.451836846999925],
              [132.97868899800005, -0.460870049999926],
              [132.9834090500001, -0.469903252999927],
              [132.99968509200005, -0.480889580999929],
              [133.033539259, -0.49732838299991],
              [133.04835045700008, -0.507907809999949],
              [133.05730228000004, -0.511163018999923],
              [133.06959069100003, -0.511895440999922],
              [133.0898543630001, -0.510918877999927],
              [133.09522545700008, -0.513767184999949],
              [133.10670006600003, -0.527520440999922],
              [133.1132918630001, -0.531996351999908],
              [133.12322024800005, -0.533379815999922],
              [133.14470462300005, -0.531182549999926],
              [133.1547957690001, -0.531996351999908],
              [133.28891035200002, -0.628513278999947],
              [133.3149520190001, -0.65398528399993],
              [133.32601972700002, -0.678806247999944],
              [133.33562259200005, -0.690362237999921],
              [133.37907962300005, -0.717705987999921],
              [133.3916121750001, -0.723239841999941],
              [133.55836022200003, -0.743747653999947],
              [133.56267337300005, -0.745212497999944],
              [133.567230665, -0.748304945999962],
              [133.5727645190001, -0.750909112999921],
              [133.57935631600003, -0.750583591999941],
              [133.58619225400003, -0.736911716999941],
              [133.59245853000004, -0.73211028399993],
              [133.59750410200002, -0.726739190999922],
              [133.60474694100003, -0.725681247999944],
              [133.61695397200003, -0.73365650799991],
              [133.63306725400003, -0.74187590899993],
              [133.65609785200002, -0.747002862999921],
              [133.74537194100003, -0.750746351999908],
              [133.759125196, -0.745212497999944],
              [133.75123131600003, -0.730645440999922],
              [133.75993899800005, -0.720879815999922],
              [133.77409915500004, -0.717217705999929],
              [133.790375196, -0.718519789999959],
              [133.80591881600003, -0.723239841999941],
              [133.81226647200003, -0.727634372999944],
              [133.82984459700003, -0.743747653999947],
              [133.8383895190001, -0.743096612999921],
              [133.85084069100003, -0.739190362999921],
              [133.9072371750001, -0.731133721999925],
              [133.94841556100005, -0.731540622999944],
              [133.9638778000001, -0.729587497999944],
              [133.97722415500004, -0.723239841999941],
              [133.99488366000003, -0.733330987999921],
              [134.05640709700003, -0.795179945999962],
              [134.066742384, -0.80242278399993],
              [134.08936608200008, -0.807549737999921],
              [134.10075931100005, -0.812595309999949],
              [134.10914147200003, -0.820082289999959],
              [134.125336134, -0.838799737999921],
              [134.13493899800005, -0.846774997999944],
              [134.16382897200003, -0.858086846999925],
              [134.17212975400003, -0.863864841999941],
              [134.171234571, -0.875909112999921],
              [134.15154056100005, -0.882989190999922],
              [134.08871504, -0.890069268999923],
              [134.07447350400003, -0.894952080999929],
              [134.06812584700003, -0.907403252999927],
              [134.06657962300005, -0.932305596999925],
              [134.058929884, -0.948174737999921],
              [134.04468834700003, -0.951348565999922],
              [134.0361434250001, -0.957777601999908],
              [134.07797285200002, -1.045586846999925],
              [134.09050540500004, -1.062676690999922],
              [134.095062696, -1.07195403399993],
              [134.097992384, -1.09343840899993],
              [134.10377037900003, -1.103936455999929],
              [134.11215254, -1.115411065999922],
              [134.1274520190001, -1.148370049999926],
              [134.141449415, -1.165785414999959],
              [134.15992272200003, -1.183689059999949],
              [134.17847741000003, -1.197442315999922],
              [134.19288170700008, -1.202894789999959],
              [134.20378665500004, -1.21257903399993],
              [134.26742597700002, -1.330254815999922],
              [134.28199303500003, -1.350192966999941],
              [134.239105665, -1.416273695999962],
              [134.2304793630001, -1.436293226999908],
              [134.2304793630001, -1.476739190999922],
              [134.22144616000003, -1.544040622999944],
              [134.2158309250001, -1.560316664999959],
              [134.20720462300005, -1.57350025799991],
              [134.1543074880001, -1.628350518999923],
              [134.139008009, -1.638116143999923],
              [134.1259871750001, -1.652276299999926],
              [134.1171981130001, -1.655450127999927],
              [134.10531660200002, -1.65748463299991],
              [134.09644616000003, -1.663181247999944],
              [134.0903426440001, -1.671807549999926],
              [134.08708743600005, -1.682793877999927],
              [134.089203321, -1.697035414999959],
              [134.1035262380001, -1.737725518999923],
              [134.144867384, -1.93914153399993],
              [134.14958743600005, -2.01531340899993],
              [134.14861087300005, -2.025485934999949],
              [134.149750196, -2.02898528399993],
              [134.1528426440001, -2.033786716999941],
              [134.15552819100003, -2.039483330999929],
              [134.1552840500001, -2.045830987999921],
              [134.1513778000001, -2.047295830999929],
              [134.14429772200003, -2.045830987999921],
              [134.13786868600005, -2.045342705999929],
              [134.13493899800005, -2.049574476999908],
              [134.1196395190001, -2.113864841999941],
              [134.12061608200008, -2.135349216999941],
              [134.12614993600005, -2.144952080999929],
              [134.14234459700003, -2.154717705999929],
              [134.14861087300005, -2.162530205999929],
              [134.15211022200003, -2.17546965899993],
              [134.15162194100003, -2.184991143999923],
              [134.14966881600003, -2.19459400799991],
              [134.14861087300005, -2.207207940999922],
              [134.151703321, -2.227634372999944],
              [134.16570071700005, -2.259698174999926],
              [134.1689559250001, -2.279229424999926],
              [134.16277103000004, -2.301690362999921],
              [134.16163170700008, -2.31023528399993],
              [134.16480553500003, -2.320489190999922],
              [134.17945397200003, -2.33562590899993],
              [134.1826278000001, -2.344414971999925],
              [134.18572024800005, -2.361911716999941],
              [134.1933699880001, -2.379082940999922],
              [134.20435631600003, -2.395114841999941],
              [134.2168074880001, -2.408949476999908],
              [134.259125196, -2.440524997999944],
              [134.270843946, -2.465020440999922],
              [134.28435306100005, -2.479261976999908],
              [134.300140821, -2.491957289999959],
              [134.3129988940001, -2.498304945999962],
              [134.3193465500001, -2.505303643999923],
              [134.33025149800005, -2.522230726999908],
              [134.33757571700005, -2.541924737999921],
              [134.34546959700003, -2.576592705999929],
              [134.363617384, -2.617852471999925],
              [134.36150149800005, -2.634942315999922],
              [134.3813582690001, -2.65398528399993],
              [134.3906356130001, -2.681084893999923],
              [134.401703321, -2.744805596999925],
              [134.40902754, -2.75514088299991],
              [134.42074629, -2.766045830999929],
              [134.4316512380001, -2.779392184999949],
              [134.44027754, -2.80828215899993],
              [134.4638778000001, -2.854668877999927],
              [134.4638778000001, -2.862074476999908],
              [134.488617384, -2.861260674999926],
              [134.50554446700005, -2.853773695999962],
              [134.53272545700008, -2.834161065999922],
              [134.52662194100003, -2.82195403399993],
              [134.51905358200008, -2.778903903999947],
              [134.5146590500001, -2.769626559999949],
              [134.50318444100003, -2.750909112999921],
              [134.49927819100003, -2.738539320999962],
              [134.498383009, -2.724867445999962],
              [134.50025475400003, -2.69695403399993],
              [134.49927819100003, -2.68328215899993],
              [134.4946395190001, -2.670098565999922],
              [134.4814559250001, -2.645440362999921],
              [134.4775496750001, -2.634942315999922],
              [134.473968946, -2.606540622999944],
              [134.47437584700003, -2.580743096999925],
              [134.47803795700008, -2.558038018999923],
              [134.4843856130001, -2.539320570999962],
              [134.49634850400003, -2.517836195999962],
              [134.50928795700008, -2.507745049999926],
              [134.5537215500001, -2.49146900799991],
              [134.54118899800005, -2.486748955999929],
              [134.534515821, -2.478773695999962],
              [134.5356551440001, -2.46998463299991],
              [134.54639733200008, -2.462985934999949],
              [134.55632571700005, -2.464776299999926],
              [134.57699629, -2.480726820999962],
              [134.58423912900003, -2.484633070999962],
              [134.60425866000003, -2.488457940999922],
              [134.6230574880001, -2.498142184999949],
              [134.63843834700003, -2.511163018999923],
              [134.64820397200003, -2.52507903399993],
              [134.65805097700002, -2.562758070999962],
              [134.66684004, -2.825616143999923],
              [134.67001386800007, -2.837660414999959],
              [134.70134524800005, -2.95867278399993],
              [134.7270613940001, -2.985772393999923],
              [134.77222741000003, -2.977634372999944],
              [134.82781009200005, -2.91375090899993],
              [134.85132897200003, -2.899834893999923],
              [134.86109459700003, -2.940036716999941],
              [134.85181725400003, -3.003676039999959],
              [134.84685306100005, -3.018487237999921],
              [134.84245853000004, -3.023044528999947],
              [134.8369246750001, -3.025811455999929],
              [134.8310653000001, -3.030205987999921],
              [134.82634524800005, -3.039646091999941],
              [134.8242293630001, -3.050388278999947],
              [134.82634524800005, -3.083916924999926],
              [134.81666100400003, -3.121840101999908],
              [134.81853274800005, -3.136325778999947],
              [134.85368899800005, -3.147881768999923],
              [134.86117597700002, -3.162692966999941],
              [134.86793053500003, -3.204034112999921],
              [134.8696395190001, -3.209161065999922],
              [134.8730574880001, -3.213148695999962],
              [134.87476647200003, -3.217705987999921],
              [134.87452233200008, -3.217950127999927],
              [134.8759871750001, -3.231866143999923],
              [134.87476647200003, -3.232028903999947],
              [134.88062584700003, -3.242933851999908],
              [134.88591556100005, -3.249769789999959],
              [134.8989363940001, -3.262790622999944],
              [134.914398634, -3.26881275799991],
              [134.93181399800005, -3.261651299999926],
              [134.96412194100003, -3.238213799999926],
              [134.96257571700005, -3.249444268999923],
              [134.95679772200003, -3.269463799999926],
              [134.95671634200005, -3.279880466999941],
              [134.960297071, -3.285332940999922],
              [134.9746199880001, -3.300876559999949],
              [134.984711134, -3.329685153999947],
              [135.00212649800005, -3.336114190999922],
              [135.04607181100005, -3.334405205999929],
              [135.06910241000003, -3.338555596999925],
              [135.09717858200008, -3.357517184999949],
              [135.11150149800005, -3.361748955999929],
              [135.27564537900003, -3.368584893999923],
              [135.29607181100005, -3.372002862999921],
              [135.32203209700003, -3.386488539999959],
              [135.3408309250001, -3.389743747999944],
              [135.3623153000001, -3.386163018999923],
              [135.40308678500003, -3.371840101999908],
              [135.47046959700003, -3.363051039999959],
              [135.48894290500004, -3.35670338299991],
              [135.50538170700008, -3.348077080999929],
              [135.52173912900003, -3.335544528999947],
              [135.56364993600005, -3.289727471999925],
              [135.56910241000003, -3.281670830999929],
              [135.5732528000001, -3.270114841999941],
              [135.57439212300005, -3.258070570999962],
              [135.57048587300005, -3.248711846999925],
              [135.57374108200008, -3.241306247999944],
              [135.6015731130001, -3.204034112999921],
              [135.63892662900003, -3.178155205999929],
              [135.71900475400003, -3.148614190999922],
              [135.75171959700003, -3.128350518999923],
              [135.76710045700008, -3.108819268999923],
              [135.76319420700008, -3.099541924999926],
              [135.7519637380001, -3.091729424999926],
              [135.74561608200008, -3.077080987999921],
              [135.747406446, -3.07000090899993],
              [135.75180097700002, -3.062107028999947],
              [135.75733483200008, -3.055840752999927],
              [135.76490319100003, -3.052178643999923],
              [135.76685631600003, -3.049899997999944],
              [135.76978600400003, -3.047539971999925],
              [135.77564537900003, -3.046482028999947],
              [135.79948978000004, -3.053317966999941],
              [135.8169051440001, -3.042901299999926],
              [135.843109571, -3.011976820999962],
              [135.88851972700002, -3.000095309999949],
              [135.90992272200003, -2.985772393999923],
              [135.92652428500003, -2.965915622999944],
              [135.93677819100003, -2.943454684999949],
              [135.935883009, -2.927178643999923],
              [135.92497806100005, -2.890394789999959],
              [135.9267684250001, -2.878838799999926],
              [135.95191491000003, -2.852146091999941],
              [135.96045983200008, -2.837660414999959],
              [135.96461022200003, -2.820489190999922],
              [135.96461022200003, -2.775811455999929],
              [135.969574415, -2.770114841999941],
              [135.99236087300005, -2.752048434999949],
              [135.99878991000003, -2.744805596999925],
              [136.01295006600003, -2.747002862999921],
              [136.02320397200003, -2.707696221999925],
              [136.03638756600003, -2.69695403399993],
              [136.0454207690001, -2.696221612999921],
              [136.0556746750001, -2.693454684999949],
              [136.06373131600003, -2.688164971999925],
              [136.06714928500003, -2.679864190999922],
              [136.0722762380001, -2.672621351999908],
              [136.0844832690001, -2.668064059999949],
              [136.10865319100003, -2.662774346999925],
              [136.19743899800005, -2.624444268999923],
              [136.2368270190001, -2.596123955999929],
              [136.26636803500003, -2.560316664999959],
              [136.27605228000004, -2.540134372999944],
              [136.28239993600005, -2.519707940999922],
              [136.28874759200005, -2.450127862999921],
              [136.2939559250001, -2.433526299999926],
              [136.30241946700005, -2.420830987999921],
              [136.3344832690001, -2.384535414999959],
              [136.344086134, -2.368259372999944],
              [136.3481551440001, -2.35125090899993],
              [136.34717858200008, -2.340264580999929],
              [136.34253991000003, -2.319105726999908],
              [136.34009850400003, -2.289239190999922],
              [136.34197024800005, -2.283379815999922],
              [136.3481551440001, -2.271742445999962],
              [136.36207116000003, -2.252129815999922],
              [136.3808699880001, -2.23406340899993],
              [136.40381920700008, -2.219659112999921],
              [136.4301863940001, -2.211032809999949],
              [136.4814559250001, -2.211032809999949],
              [136.49293053500003, -2.207126559999949],
              [136.52214603000004, -2.191338799999926],
              [136.532562696, -2.189873955999929],
              [136.53679446700005, -2.198988539999959],
              [136.5337020190001, -2.213067315999922],
              [136.53296959700003, -2.22584400799991],
              [136.5434676440001, -2.231377862999921],
              [136.56820722700002, -2.233005466999941],
              [136.5947371750001, -2.23756275799991],
              [136.6020613940001, -2.249769789999959],
              [136.60523522200003, -2.252048434999949],
              [136.61304772200003, -2.250909112999921],
              [136.62647545700008, -2.246270440999922],
              [136.6328231130001, -2.245049737999921],
              [136.6464949880001, -2.246351820999962],
              [136.683929884, -2.258721612999921],
              [136.70460045700008, -2.23756275799991],
              [136.71697024800005, -2.239190362999921],
              [136.73715254, -2.249444268999923],
              [136.74927819100003, -2.252048434999949],
              [136.758636915, -2.248711846999925],
              [136.76547285200002, -2.241631768999923],
              [136.770843946, -2.234633070999962],
              [136.77686608200008, -2.231377862999921],
              [136.80591881600003, -2.226739190999922],
              [136.8144637380001, -2.224053643999923],
              [136.8671981130001, -2.188164971999925],
              [136.92701256600003, -2.176202080999929],
              [136.9384871750001, -2.172539971999925],
              [136.94312584700003, -2.163506768999923],
              [136.9458113940001, -2.152276299999926],
              [136.951508009, -2.142185153999947],
              [136.9814559250001, -2.126560153999947],
              [137.02409915500004, -2.11842213299991],
              [137.1543074880001, -2.111504815999922],
              [137.17847741000003, -2.106133721999925],
              [137.19459069100003, -2.09734465899993],
              [137.22632897200003, -2.074395440999922],
              [137.23365319100003, -2.060967705999929],
              [137.22527103000004, -2.038995049999926],
              [137.20264733200008, -2.01881275799991],
              [137.19117272200003, -2.004571221999925],
              [137.19459069100003, -1.998142184999949],
              [137.20533287900003, -1.992608330999929],
              [137.21013431100005, -1.979261976999908],
              [137.20964603000004, -1.963474216999941],
              [137.20484459700003, -1.949639580999929],
              [137.1938582690001, -1.943942966999941],
              [137.16749108200008, -1.934340101999908],
              [137.15699303500003, -1.929131768999923],
              [137.10173587300005, -1.888278903999947],
              [137.1118270190001, -1.874769789999959],
              [137.115570509, -1.854424737999921],
              [137.11540774800005, -1.809340101999908],
              [137.1235457690001, -1.797458591999941],
              [137.14283287900003, -1.787041924999926],
              [137.34880618600005, -1.710137627999927],
              [137.4648543630001, -1.641778252999927],
              [137.48585045700008, -1.63250090899993],
              [137.4921981130001, -1.628106377999927],
              [137.4985457690001, -1.62078215899993],
              [137.5102645190001, -1.604099216999941],
              [137.51636803500003, -1.60084400799991],
              [137.53248131600003, -1.597751559999949],
              [137.79444420700008, -1.484144789999959],
              [137.83912194100003, -1.471123955999929],
              [137.883148634, -1.470472914999959],
              [137.9248153000001, -1.484144789999959],
              [137.93246504, -1.491306247999944],
              [137.9555770190001, -1.518243096999925],
              [137.96501712300005, -1.522637627999927],
              [137.98316491000003, -1.541924737999921],
              [137.9892684250001, -1.54615650799991],
              [138.00220787900003, -1.547784112999921],
              [138.01140384200005, -1.55201588299991],
              [138.0576278000001, -1.599053643999923],
              [138.07488040500004, -1.610284112999921],
              [138.11890709700003, -1.61687590899993],
              [138.22917728000004, -1.649102471999925],
              [138.35670006600003, -1.710137627999927],
              [138.52751712300005, -1.758477471999925],
              [138.59750410200002, -1.769789320999962],
              [138.6196395190001, -1.778090101999908],
              [138.66521243600005, -1.789157809999949],
              [138.735199415, -1.843926690999922],
              [138.8032332690001, -1.920830987999921],
              [138.8427840500001, -1.949639580999929],
              [138.86215254, -1.955743096999925],
              [138.928070509, -1.957126559999949],
              [138.949554884, -1.959893487999921],
              [139.10670006600003, -2.012790622999944],
              [139.2832137380001, -2.121840101999908],
              [139.38404381600003, -2.155694268999923],
              [139.44011478000004, -2.185723565999922],
              [139.45533287900003, -2.189873955999929],
              [139.4687606130001, -2.195082289999959],
              [139.514984571, -2.231377862999921],
              [139.6782332690001, -2.292901299999926],
              [139.78077233200008, -2.354668877999927],
              [139.82211347700002, -2.367364190999922],
              [139.86475670700008, -2.372002862999921],
              [140.05933678500003, -2.354261976999908],
              [140.08619225400003, -2.343682549999926],
              [140.09717858200008, -2.323663018999923],
              [140.10474694100003, -2.320082289999959],
              [140.12126712300005, -2.326836846999925],
              [140.1450301440001, -2.341241143999923],
              [140.15113366000003, -2.337334893999923],
              [140.15259850400003, -2.322442315999922],
              [140.15796959700003, -2.320896091999941],
              [140.16570071700005, -2.325372002999927],
              [140.1679793630001, -2.33171965899993],
              [140.168793165, -2.339288018999923],
              [140.172211134, -2.347426039999959],
              [140.21021569100003, -2.402113539999959],
              [140.22543379, -2.405368747999944],
              [140.28834069100003, -2.431084893999923],
              [140.31128991000003, -2.44695403399993],
              [140.33228600400003, -2.455743096999925],
              [140.35043379, -2.44304778399993],
              [140.36101321700005, -2.449802341999941],
              [140.37126712300005, -2.448663018999923],
              [140.37964928500003, -2.44109465899993],
              [140.38453209700003, -2.429457289999959],
              [140.3798934250001, -2.419528903999947],
              [140.36890709700003, -2.412041924999926],
              [140.36394290500004, -2.404880466999941],
              [140.37712649800005, -2.395277601999908],
              [140.38851972700002, -2.397067966999941],
              [140.48316491000003, -2.432224216999941],
              [140.50066165500004, -2.435723565999922],
              [140.60759524800005, -2.439385674999926],
              [140.730804884, -2.49146900799991],
              [140.7446395190001, -2.499118747999944],
              [140.74675540500004, -2.516696872999944],
              [140.74089603000004, -2.549574476999908],
              [140.73609459700003, -2.563653252999927],
              [140.698578321, -2.608168226999908],
              [140.70435631600003, -2.616957289999959],
              [140.713226759, -2.626722914999959],
              [140.72380618600005, -2.633965752999927],
              [140.73462975400003, -2.634942315999922],
              [140.74000084700003, -2.627699476999908],
              [140.7407332690001, -2.616306247999944],
              [140.7426863940001, -2.605564059999949],
              [140.75171959700003, -2.600762627999927],
              [140.75709069100003, -2.603936455999929],
              [140.77564537900003, -2.618096612999921],
              [140.785492384, -2.621270440999922],
              [140.79558353000004, -2.619398695999962],
              [140.81804446700005, -2.61101653399993],
              [140.82960045700008, -2.608168226999908],
              [140.92212975400003, -2.608168226999908],
              [140.96501712300005, -2.600762627999927],
              [140.97413170700008, -2.600518487999921],
              [140.97445722700002, -2.600518487999921],
            ],
          ],
          [
            [
              [113.39519290500004, -8.44703541499996],
              [113.40609785200002, -8.45322030999995],
              [113.41211998800009, -8.46689218499995],
              [113.41309655000009, -8.48056405999995],
              [113.40919030000009, -8.486748955999929],
              [113.39665774800005, -8.48837655999995],
              [113.37191816500001, -8.494724216999941],
              [113.29249108200008, -8.494805596999925],
              [113.28199303500003, -8.488213799999926],
              [113.27800540500004, -8.473321221999925],
              [113.28199303500003, -8.457207940999922],
              [113.29590905000009, -8.44703541499996],
              [113.29175866000003, -8.439711195999905],
              [113.28907311300009, -8.432793877999927],
              [113.33985436300009, -8.444024346999925],
              [113.39519290500004, -8.44703541499996],
            ],
          ],
          [
            [
              [123.14625084700003, -8.425957940999922],
              [123.16976972700002, -8.43132903399993],
              [123.17994225400003, -8.444431247999944],
              [123.17750084700003, -8.46021900799991],
              [123.16358483200008, -8.473728122999944],
              [123.12175540500004, -8.486260674999926],
              [123.03785241000003, -8.49187590899993],
              [123.00660241000003, -8.50790780999995],
              [122.95525149800005, -8.58562590899993],
              [122.93083743600005, -8.604099216999941],
              [122.91391035200002, -8.60833098799992],
              [122.90259850400003, -8.604587497999944],
              [122.88298587300005, -8.58294036299992],
              [122.91041100400003, -8.514743747999944],
              [122.99984785200002, -8.448663018999923],
              [123.00904381600003, -8.44817473799992],
              [123.01832116000003, -8.45126718499995],
              [123.02979576900009, -8.45322030999995],
              [123.04249108200008, -8.451429945999905],
              [123.07422936300009, -8.439629815999922],
              [123.08578535200002, -8.438571872999944],
              [123.10474694100003, -8.44068775799991],
              [123.11589603000004, -8.439629815999922],
              [123.12435957100001, -8.436293226999908],
              [123.14039147200003, -8.427666924999926],
              [123.14625084700003, -8.425957940999922],
            ],
          ],
          [
            [
              [128.23121178500003, -8.25123463299991],
              [128.237640821, -8.264092705999929],
              [128.2314559250001, -8.272881768999923],
              [128.21900475400003, -8.27857838299991],
              [128.20728600400003, -8.281914971999925],
              [128.181976759, -8.285088799999926],
              [128.15162194100003, -8.284600518999923],
              [128.12330162900003, -8.28093840899993],
              [128.10368899800005, -8.27507903399993],
              [128.09685306100005, -8.270928643999923],
              [128.088226759, -8.263848565999922],
              [128.08326256600003, -8.254571221999925],
              [128.08716881600003, -8.244317315999922],
              [128.094574415, -8.232354424999926],
              [128.097992384, -8.220961195999905],
              [128.10377037900003, -8.21184661299992],
              [128.11793053500003, -8.20680103999996],
              [128.1391707690001, -8.21648528399993],
              [128.1660262380001, -8.210544528999947],
              [128.192718946, -8.20094166499996],
              [128.21355228000004, -8.199395440999922],
              [128.22193444100003, -8.208916924999926],
              [128.22641035200002, -8.239678643999923],
              [128.23121178500003, -8.25123463299991],
            ],
          ],
          [
            [
              [129.029633009, -8.20680103999996],
              [129.0361434250001, -8.220310153999947],
              [129.03500410200002, -8.23609791499996],
              [129.027679884, -8.25090911299992],
              [129.015961134, -8.26140715899993],
              [129.006195509, -8.263604424999926],
              [128.99341881600003, -8.26148853999996],
              [128.9790145190001, -8.255059502999927],
              [128.96461022200003, -8.244317315999922],
              [128.9492293630001, -8.23601653399993],
              [128.93913821700005, -8.240655205999929],
              [128.9296981130001, -8.24968840899993],
              [128.916351759, -8.254652601999908],
              [128.8877059250001, -8.244886976999908],
              [128.85230553500003, -8.222914320999905],
              [128.8344832690001, -8.199802341999941],
              [128.8584090500001, -8.185723565999922],
              [128.88949629, -8.17782968499995],
              [128.9853621750001, -8.185723565999922],
              [128.98951256600003, -8.188897393999923],
              [129.029633009, -8.20680103999996],
            ],
          ],
          [
            [
              [127.74187259200005, -8.158949476999908],
              [127.76059004000001, -8.17392343499995],
              [127.77198326900009, -8.194431247999944],
              [127.76880944100003, -8.21257903399993],
              [127.74488366000003, -8.22047291499996],
              [127.72437584700003, -8.223728122999944],
              [127.68913821700005, -8.237888278999947],
              [127.66920006600003, -8.240899346999925],
              [127.64812259200005, -8.235772393999923],
              [127.62077884200005, -8.21266041499996],
              [127.60401451900009, -8.20680103999996],
              [127.68295332100001, -8.15520598799992],
              [127.70264733200008, -8.151462497999944],
              [127.72291100400003, -8.153008721999925],
              [127.74187259200005, -8.158949476999908],
            ],
          ],
          [
            [
              [117.66431725400003, -8.14812590899993],
              [117.67310631600003, -8.15406666499996],
              [117.68336022200003, -8.158623955999929],
              [117.691742384, -8.164727471999925],
              [117.69532311300009, -8.17587655999995],
              [117.69255618600005, -8.183526299999926],
              [117.68539472700002, -8.18922291499996],
              [117.66732832100001, -8.199395440999922],
              [117.64031009200005, -8.224053643999923],
              [117.62061608200008, -8.25359465899993],
              [117.56657962300005, -8.363946221999925],
              [117.55372155000009, -8.37900155999995],
              [117.53394616000003, -8.384942315999922],
              [117.52613366000003, -8.38176848799992],
              [117.492523634, -8.36101653399993],
              [117.48487389400009, -8.350192966999941],
              [117.48560631600003, -8.34303150799991],
              [117.49594160200002, -8.32976653399993],
              [117.51124108200008, -8.295505466999941],
              [117.51075280000009, -8.28101978999996],
              [117.49976647200003, -8.265232028999947],
              [117.48975670700008, -8.257419528999947],
              [117.48462975400003, -8.255059502999927],
              [117.48267662900003, -8.250664971999925],
              [117.48047936300009, -8.209161065999922],
              [117.48161868600005, -8.19500090899993],
              [117.48682701900009, -8.18287525799991],
              [117.49390709700003, -8.176202080999929],
              [117.54835045700008, -8.149021091999941],
              [117.56348717500009, -8.145196221999925],
              [117.66431725400003, -8.14812590899993],
            ],
          ],
          [
            [
              [127.21631920700008, -8.026950778999947],
              [127.22641035200002, -8.039239190999922],
              [127.23210696700005, -8.054294528999947],
              [127.23422285200002, -8.07040780999995],
              [127.23462975400003, -8.086521091999941],
              [127.224945509, -8.108575127999927],
              [127.20215905000009, -8.111260674999926],
              [127.15211022200003, -8.09693775799991],
              [127.15211022200003, -8.08953215899993],
              [127.15756269600001, -8.07935963299991],
              [127.15560957100001, -8.048435153999947],
              [127.15894616000003, -8.03492603999996],
              [127.17074629000001, -8.023858330999929],
              [127.185883009, -8.018731377999927],
              [127.20191491000003, -8.019789320999905],
              [127.21631920700008, -8.026950778999947],
            ],
          ],
          [
            [
              [131.10499108200008, -7.629001559999949],
              [131.11898847700002, -7.619317315999922],
              [131.12647545700008, -7.617771091999941],
              [131.13257897200003, -7.623304945999905],
              [131.11939537900003, -7.663262627999927],
              [131.10922285200002, -7.681817315999922],
              [131.0922957690001, -7.692315362999921],
              [131.0498153000001, -7.683770440999922],
              [131.03589928500003, -7.687595309999949],
              [131.043793165, -7.713474216999941],
              [130.9868270190001, -7.711846612999921],
              [130.9712020190001, -7.701348565999922],
              [130.9824324880001, -7.671807549999926],
              [130.98951256600003, -7.663832289999959],
              [130.99952233200008, -7.65748463299991],
              [131.01189212300005, -7.653497002999927],
              [131.04029381600003, -7.650160414999959],
              [131.05494225400003, -7.645603122999944],
              [131.06853274800005, -7.638848565999922],
              [131.07789147200003, -7.630791924999926],
              [131.07837975400003, -7.633396091999941],
              [131.0825301440001, -7.635023695999905],
              [131.0903426440001, -7.635918877999927],
              [131.0937606130001, -7.635023695999905],
              [131.10499108200008, -7.629001559999949],
            ],
          ],
          [
            [
              [130.96859785200002, -7.534600518999923],
              [130.9765731130001, -7.53639088299991],
              [130.98422285200002, -7.539971612999921],
              [130.9882918630001, -7.545179945999905],
              [130.98585045700008, -7.551934502999927],
              [130.97917728000004, -7.555271091999941],
              [130.97339928500003, -7.551202080999929],
              [130.96705162900003, -7.545179945999905],
              [130.95850670700008, -7.542087497999944],
              [130.95386803500003, -7.54420338299991],
              [130.94166100400003, -7.553480726999908],
              [130.93767337300005, -7.555759372999944],
              [130.89771569100003, -7.554457289999959],
              [130.85661868600005, -7.546970309999949],
              [130.84522545700008, -7.542087497999944],
              [130.84099368600005, -7.528741143999923],
              [130.84449303500003, -7.513848565999922],
              [130.85865319100003, -7.486911716999941],
              [130.86475670700008, -7.489190362999921],
              [130.89372806100005, -7.514092705999929],
              [130.9067488940001, -7.50750090899993],
              [130.9204207690001, -7.510918877999927],
              [130.9336043630001, -7.517836195999905],
              [130.94483483200008, -7.521579684999949],
              [130.9775496750001, -7.51531340899993],
              [130.98462975400003, -7.518161716999941],
              [130.96859785200002, -7.534600518999923],
            ],
          ],
          [
            [
              [131.1748153000001, -7.404229424999926],
              [131.17750084700003, -7.406670830999929],
              [131.18140709700003, -7.411309502999927],
              [131.18287194100003, -7.415948174999926],
              [131.16586347700002, -7.424493096999925],
              [131.1269637380001, -7.466403903999947],
              [131.11646569100003, -7.471856377999927],
              [131.10515384200005, -7.476006768999923],
              [131.09595787900003, -7.481377862999921],
              [131.0888778000001, -7.49773528399993],
              [131.08033287900003, -7.503676039999959],
              [131.06918379, -7.50750090899993],
              [131.05738366000003, -7.507907809999949],
              [131.05738366000003, -7.500420830999929],
              [131.06316165500004, -7.497002862999921],
              [131.06666100400003, -7.492852471999925],
              [131.07178795700008, -7.479424737999921],
              [131.047211134, -7.480401299999926],
              [131.02458743600005, -7.485284112999921],
              [131.0048934250001, -7.485772393999923],
              [130.9892684250001, -7.473239841999941],
              [130.985199415, -7.455987237999921],
              [130.99105879, -7.438897393999923],
              [131.003265821, -7.424493096999925],
              [131.01823978000004, -7.415215752999927],
              [131.02711022200003, -7.413018487999921],
              [131.03500410200002, -7.413506768999923],
              [131.0512801440001, -7.417168877999927],
              [131.0673934250001, -7.417738539999959],
              [131.12476647200003, -7.410414320999905],
              [131.141449415, -7.405368747999944],
              [131.153656446, -7.404229424999926],
              [131.1601668630001, -7.402927341999941],
              [131.163422071, -7.400485934999949],
              [131.16724694100003, -7.399997653999947],
              [131.1748153000001, -7.404229424999926],
            ],
          ],
          [
            [
              [131.28394616000003, -7.32976653399993],
              [131.29273522200003, -7.31804778399993],
              [131.29761803500003, -7.319105726999908],
              [131.299164259, -7.32740650799991],
              [131.29761803500003, -7.336602471999925],
              [131.2934676440001, -7.340590101999908],
              [131.27100670700008, -7.35711028399993],
              [131.27711022200003, -7.37078215899993],
              [131.2275496750001, -7.362481377999927],
              [131.2158309250001, -7.35711028399993],
              [131.223480665, -7.35125090899993],
              [131.2309676440001, -7.344170830999929],
              [131.243011915, -7.32976653399993],
              [131.25757897200003, -7.30396900799991],
              [131.264984571, -7.297133070999905],
              [131.2695418630001, -7.302911065999922],
              [131.2822371750001, -7.32350025799991],
              [131.28394616000003, -7.32976653399993],
            ],
          ],
          [
            [
              [120.96045983200008, -7.281996351999908],
              [121.019867384, -7.280368747999944],
              [121.04997806100005, -7.285821221999925],
              [121.06690514400009, -7.302504164999959],
              [121.05689537900003, -7.321058851999908],
              [121.02564537900003, -7.331638278999947],
              [120.99268639400009, -7.333591403999947],
              [120.97738691500001, -7.326348565999922],
              [120.96387780000009, -7.313897393999923],
              [120.90040123800009, -7.303887627999927],
              [120.88135826900009, -7.295017184999949],
              [120.86410566500001, -7.301934502999927],
              [120.840179884, -7.304457289999959],
              [120.81625410200002, -7.30242278399993],
              [120.79932701900009, -7.295017184999949],
              [120.79395592500009, -7.287692966999941],
              [120.79232832100001, -7.279473565999922],
              [120.79428144600001, -7.27117278399993],
              [120.79965254000001, -7.263848565999922],
              [120.81568444100003, -7.25750090899993],
              [120.83464603000004, -7.260511976999908],
              [120.87110436300009, -7.273532809999949],
              [120.96045983200008, -7.281996351999908],
            ],
          ],
          [
            [
              [120.75782311300009, -7.075941664999959],
              [120.77263431100005, -7.058851820999905],
              [120.78126061300009, -7.05592213299991],
              [120.78516686300009, -7.072442315999922],
              [120.78305097700002, -7.088636976999908],
              [120.773773634, -7.115817966999941],
              [120.77149498800009, -7.13054778399993],
              [120.7422614510001, -7.134935144999929],
              [120.70558207900001, -7.133380463999913],
              [120.68336022200003, -7.12428150799991],
              [120.68189537900003, -7.139418226999908],
              [120.67034946900003, -7.150959797999917],
              [120.633489112, -7.131528227999922],
              [120.62040736900008, -7.108675148999907],
              [120.624171241, -7.09396032099994],
              [120.59842208200007, -7.098033898999915],
              [120.58092290500008, -7.091815049999923],
              [120.56290620300001, -7.094537751999951],
              [120.55625306400009, -7.072889484999905],
              [120.56586410600005, -7.067054209999924],
              [120.5911130290001, -7.079589061999911],
              [120.61369512200008, -7.069816589999959],
              [120.61989363100008, -7.044242793999956],
              [120.61572917600006, -7.02256112799995],
              [120.62125566200007, -6.998245237999924],
              [120.63550866000003, -7.007012627999927],
              [120.65361520400006, -7.010104614999932],
              [120.677673562, -7.043671315999916],
              [120.73023522200003, -7.067152601999908],
              [120.74496504000001, -7.074151299999926],
              [120.75782311300009, -7.075941664999959],
            ],
          ],
          [
            [
              [138.75342858200008, -6.778252862999921],
              [138.75904381600003, -6.791680596999925],
              [138.78305097700002, -6.814222914999959],
              [138.787445509, -6.829522393999923],
              [138.78150475400003, -6.838962497999944],
              [138.76872806100005, -6.849379164999959],
              [138.7465926440001, -6.863051039999959],
              [138.72828209700003, -6.867771091999941],
              [138.71631920700008, -6.864678643999923],
              [138.70655358200008, -6.859144789999959],
              [138.69507897200003, -6.856215101999908],
              [138.681976759, -6.847751559999949],
              [138.6728621750001, -6.810153903999947],
              [138.66089928500003, -6.801527601999908],
              [138.65015709700003, -6.797295830999929],
              [138.63892662900003, -6.787367445999905],
              [138.6230574880001, -6.767347914999959],
              [138.61695397200003, -6.748142184999949],
              [138.618500196, -6.729099216999941],
              [138.6269637380001, -6.720147393999923],
              [138.64128665500004, -6.730645440999922],
              [138.66553795700008, -6.750258070999905],
              [138.67920983200008, -6.758070570999905],
              [138.69507897200003, -6.761325778999947],
              [138.73121178500003, -6.763116143999923],
              [138.74683678500003, -6.768161716999941],
              [138.75342858200008, -6.778252862999921],
            ],
          ],
          [
            [
              [131.59742272200003, -6.679131768999923],
              [131.61931399800005, -6.682549737999921],
              [131.62867272200003, -6.693942966999941],
              [131.62452233200008, -6.709730726999908],
              [131.60621178500003, -6.727146091999941],
              [131.5839949880001, -6.719496351999908],
              [131.568695509, -6.732598565999922],
              [131.56617272200003, -6.75164153399993],
              [131.59131920700008, -6.767673434999949],
              [131.5820418630001, -6.781670830999929],
              [131.564789259, -6.795586846999925],
              [131.55103600400003, -6.801527601999908],
              [131.5273543630001, -6.780857028999947],
              [131.53736412900003, -6.738051039999959],
              [131.56568444100003, -6.696465752999927],
              [131.59742272200003, -6.679131768999923],
            ],
          ],
          [
            [
              [134.707367384, -6.589043877999927],
              [134.720062696, -6.595310153999947],
              [134.73015384200005, -6.60475025799991],
              [134.7363387380001, -6.61687590899993],
              [134.73755944100003, -6.630954684999949],
              [134.7295028000001, -6.664808851999908],
              [134.72217858200008, -6.682793877999927],
              [134.71363366000003, -6.695733330999929],
              [134.70329837300005, -6.707777601999908],
              [134.68043053500003, -6.743259372999944],
              [134.67603600400003, -6.75750090899993],
              [134.66944420700008, -6.772881768999923],
              [134.653656446, -6.76881275799991],
              [134.621429884, -6.747002862999921],
              [134.63005618600005, -6.735772393999923],
              [134.63160241000003, -6.727227471999925],
              [134.628265821, -6.709405205999929],
              [134.63257897200003, -6.700372002999927],
              [134.66578209700003, -6.650485934999949],
              [134.676605665, -6.610528252999927],
              [134.68148847700002, -6.599867445999905],
              [134.68767337300005, -6.591973565999922],
              [134.69605553500003, -6.587985934999949],
              [134.707367384, -6.589043877999927],
            ],
          ],
          [
            [
              [134.607758009, -6.421482028999947],
              [134.60222415500004, -6.441582940999922],
              [134.58814537900003, -6.455254815999922],
              [134.5537215500001, -6.473239841999941],
              [134.56568444100003, -6.491387627999927],
              [134.5605574880001, -6.516045830999929],
              [134.54175866000003, -6.529473565999922],
              [134.51156660200002, -6.513604424999926],
              [134.502289259, -6.500176690999922],
              [134.49586022200003, -6.485284112999921],
              [134.49236087300005, -6.471612237999921],
              [134.4912215500001, -6.462334893999923],
              [134.48658287900003, -6.45435963299991],
              [134.4638778000001, -6.424899997999944],
              [134.45142662900003, -6.424899997999944],
              [134.4379988940001, -6.427504164999959],
              [134.42725670700008, -6.426364841999941],
              [134.4228621750001, -6.414646091999941],
              [134.41773522200003, -6.406426690999922],
              [134.3584090500001, -6.379489841999941],
              [134.35035241000003, -6.371758721999925],
              [134.34717858200008, -6.359633070999905],
              [134.34986412900003, -6.350681247999944],
              [134.3564559250001, -6.341566664999959],
              [134.36451256600003, -6.333591403999947],
              [134.3720809250001, -6.32781340899993],
              [134.3867293630001, -6.31959400799991],
              [134.39136803500003, -6.31609465899993],
              [134.40642337300005, -6.299574476999908],
              [134.413422071, -6.294528903999947],
              [134.42115319100003, -6.290134372999944],
              [134.42937259200005, -6.286716403999947],
              [134.43775475400003, -6.285088799999926],
              [134.446136915, -6.285414320999905],
              [134.4521590500001, -6.288018487999921],
              [134.46355228000004, -6.296970309999949],
              [134.49496504, -6.313897393999923],
              [134.504730665, -6.321221612999921],
              [134.528656446, -6.350274346999925],
              [134.54420006600003, -6.363864841999941],
              [134.56316165500004, -6.369561455999929],
              [134.5747176440001, -6.374769789999959],
              [134.58961022200003, -6.387790622999944],
              [134.60230553500003, -6.404554945999905],
              [134.607758009, -6.421482028999947],
            ],
          ],
          [
            [
              [134.84058678500003, -6.287692966999941],
              [134.85613040500004, -6.283786716999941],
              [134.87183678500003, -6.288506768999923],
              [134.8837996750001, -6.299493096999925],
              [134.88819420700008, -6.314060153999947],
              [134.88591556100005, -6.336358330999929],
              [134.8789168630001, -6.355889580999929],
              [134.86109459700003, -6.390069268999923],
              [134.83765709700003, -6.460056247999944],
              [134.82634524800005, -6.473239841999941],
              [134.81177819100003, -6.464288018999923],
              [134.79835045700008, -6.452243747999944],
              [134.7939559250001, -6.440524997999944],
              [134.80640709700003, -6.431735934999949],
              [134.80640709700003, -6.424899997999944],
              [134.79411868600005, -6.401950778999947],
              [134.79900149800005, -6.370538018999923],
              [134.81421959700003, -6.345798434999949],
              [134.83375084700003, -6.342380466999941],
              [134.83366946700005, -6.311455987999921],
              [134.83562259200005, -6.29656340899993],
              [134.84058678500003, -6.287692966999941],
            ],
          ],
          [
            [
              [134.3779403000001, -6.254082940999922],
              [134.38591556100005, -6.25750090899993],
              [134.39568118600005, -6.26490650799991],
              [134.40788821700005, -6.271905205999929],
              [134.4228621750001, -6.274021091999941],
              [134.4228621750001, -6.280857028999947],
              [134.3974715500001, -6.284926039999959],
              [134.3808699880001, -6.298760674999926],
              [134.36646569100003, -6.31568775799991],
              [134.34717858200008, -6.329278252999927],
              [134.33765709700003, -6.331963799999926],
              [134.33480879, -6.328871351999908],
              [134.33318118600005, -6.320570570999905],
              [134.3266707690001, -6.308200778999947],
              [134.30396569100003, -6.287530205999929],
              [134.29078209700003, -6.280043226999908],
              [134.28500410200002, -6.284274997999944],
              [134.27759850400003, -6.27507903399993],
              [134.23389733200008, -6.239353122999944],
              [134.21794681100005, -6.207614841999941],
              [134.20281009200005, -6.194268487999921],
              [134.1826278000001, -6.205743096999925],
              [134.16228274800005, -6.19654713299991],
              [134.1660262380001, -6.183038018999923],
              [134.17986087300005, -6.167087497999944],
              [134.1894637380001, -6.150485934999949],
              [134.1860457690001, -6.133965752999927],
              [134.17164147200003, -6.136488539999959],
              [134.1411238940001, -6.15789153399993],
              [134.12037194100003, -6.122165622999944],
              [134.11491946700005, -6.076836846999925],
              [134.1259871750001, -6.034274997999944],
              [134.1552840500001, -6.006524346999925],
              [134.1552840500001, -6.048028252999927],
              [134.1606551440001, -6.043552341999941],
              [134.20679772200003, -6.025323174999926],
              [134.2177840500001, -6.023614190999922],
              [134.22584069100003, -6.028741143999923],
              [134.23585045700008, -6.062676690999922],
              [134.24048912900003, -6.07350025799991],
              [134.24480228000004, -6.075941664999959],
              [134.2509871750001, -6.070977471999925],
              [134.2714949880001, -6.061700127999927],
              [134.26579837300005, -6.07740650799991],
              [134.24634850400003, -6.096449476999908],
              [134.2373153000001, -6.110121351999908],
              [134.23414147200003, -6.130059502999927],
              [134.242523634, -6.14421965899993],
              [134.25700931100005, -6.158379815999922],
              [134.2714949880001, -6.178399346999925],
              [134.28630618600005, -6.174981377999927],
              [134.2998153000001, -6.184502862999921],
              [134.33326256600003, -6.234551690999922],
              [134.3427840500001, -6.239353122999944],
              [134.36150149800005, -6.239353122999944],
              [134.35320071700005, -6.250420830999929],
              [134.3559676440001, -6.254571221999925],
              [134.3779403000001, -6.254082940999922],
            ],
          ],
          [
            [
              [109.90601647200003, -7.837660414999959],
              [109.88306725400003, -7.844821872999944],
              [109.84742272200003, -7.836683851999908],
              [109.81177819100003, -7.823418877999927],
              [109.75245201900003, -7.811944268999923],
              [109.65674889400003, -7.781670830999929],
              [109.48609459700003, -7.761814059999949],
              [109.44678795700003, -7.772067966999941],
              [109.42628014400003, -7.774183851999908],
              [109.41724694100003, -7.76490650799991],
              [109.41472415500004, -7.757907809999949],
              [109.40853925900007, -7.754978122999944],
              [109.40170332100007, -7.752618096999925],
              [109.39665774800005, -7.747491143999923],
              [109.39722741000003, -7.74187590899993],
              [109.40455162900003, -7.731052341999941],
              [109.40349368600005, -7.726332289999959],
              [109.39763431100005, -7.722832940999922],
              [109.36882571700005, -7.713474216999941],
              [109.19723358700003, -7.696216842999945],
              [109.09814586600004, -7.686861173999944],
              [109.04655524300006, -7.701853287999938],
              [109.03296959700003, -7.720147393999923],
              [109.02125084700003, -7.732028903999947],
              [109.01441491000003, -7.732598565999922],
              [108.98389733200003, -7.707207940999922],
              [108.97364342500003, -7.702243747999944],
              [108.96159915500004, -7.700372002999927],
              [108.93897545700003, -7.699476820999905],
              [108.91830488400007, -7.696384372999944],
              [108.90154056100005, -7.689629815999922],
              [108.88965905000003, -7.678643487999921],
              [108.88160241000003, -7.63250090899993],
              [108.87322024800005, -7.61060963299991],
              [108.85865319100003, -7.614027601999908],
              [108.85206139400003, -7.61882903399993],
              [108.82748457100007, -7.630791924999926],
              [108.82048587300005, -7.637872002999927],
              [108.80697675900007, -7.658135674999926],
              [108.79900149800005, -7.664727471999925],
              [108.78825931100005, -7.67351653399993],
              [108.76105384500005, -7.69276457999996],
              [108.73536217500003, -7.678643487999921],
              [108.72901451900003, -7.675957940999922],
              [108.72193444100003, -7.670342705999929],
              [108.71387780000003, -7.66570403399993],
              [108.70394941500007, -7.665622653999947],
              [108.69174238400007, -7.672295830999929],
              [108.68171394000007, -7.682244261999926],
              [108.67314890500006, -7.690752519999933],
              [108.67953535200007, -7.71021900799991],
              [108.67774498800003, -7.718926690999922],
              [108.67261803500003, -7.720635674999926],
              [108.65174052100008, -7.716271036999956],
              [108.64649498800003, -7.692966403999947],
              [108.63892662900003, -7.687920830999929],
              [108.62549889400003, -7.686130466999941],
              [108.55941816500007, -7.687432549999926],
              [108.53956139400003, -7.692315362999921],
              [108.50782311300003, -7.719496351999908],
              [108.50383388100005, -7.764224063999961],
              [108.49526643100006, -7.792922989999909],
              [108.45371146800005, -7.818501408999907],
              [108.32682945600004, -7.817471294999905],
              [108.13791037300007, -7.786661276999951],
              [107.95353055200007, -7.739873403999923],
              [107.90528615500006, -7.738783636999926],
              [107.86453418900004, -7.745130128999961],
              [107.83022842600008, -7.729167343999961],
              [107.82814549600005, -7.700493919999928],
              [107.80673901800003, -7.686675730999923],
              [107.77879648400005, -7.680248537999944],
              [107.71439665500003, -7.671659197999929],
              [107.68654876600004, -7.662075041999913],
              [107.67801324100003, -7.639753394999957],
              [107.66083976400006, -7.614208032999954],
              [107.62546860400005, -7.598219571999948],
              [107.59096020900006, -7.570433912999931],
              [107.55544769800008, -7.56182328299991],
              [107.52851427600007, -7.548963287999925],
              [107.48115147000004, -7.538193522999961],
              [107.47050903500008, -7.516909873999907],
              [107.45207948700005, -7.512536997999916],
              [107.43189537900003, -7.506524346999925],
              [107.42603600400003, -7.507907809999949],
              [107.42017662900003, -7.505629164999959],
              [107.41138756600003, -7.495863539999959],
              [107.36153061900006, -7.503713305999952],
              [107.29778959400005, -7.496136852999939],
              [107.24632553600003, -7.489654141999949],
              [107.21200781200008, -7.485328705999905],
              [107.17985941700005, -7.475696022999955],
              [107.14558584200006, -7.467119921999938],
              [107.10704903400006, -7.456406114999936],
              [106.87141725100003, -7.43771129299995],
              [106.79102156000005, -7.435331375999908],
              [106.60792076900003, -7.417901299999926],
              [106.52266213700005, -7.410957330999906],
              [106.48082591500003, -7.375669131999928],
              [106.45933116000003, -7.365995098999917],
              [106.43392988400007, -7.361993096999925],
              [106.40747974700008, -7.37531699199991],
              [106.39776049700004, -7.378465401999961],
              [106.39889456100008, -7.360363496999923],
              [106.39905776800003, -7.334824459999936],
              [106.37536532100006, -7.310194341999932],
              [106.38314863400007, -7.267673434999949],
              [106.38070722700007, -7.247247002999927],
              [106.38607832100007, -7.230645440999922],
              [106.39844811300003, -7.207777601999908],
              [106.41488691500007, -7.187676690999922],
              [106.43262780000003, -7.178887627999927],
              [106.45004316500007, -7.179131768999923],
              [106.46729576900003, -7.176446221999925],
              [106.47299238400007, -7.166599216999941],
              [106.45655358200003, -7.144789320999905],
              [106.47437584700003, -7.128106377999927],
              [106.51396716500005, -7.079596706999951],
              [106.54050382500003, -7.054612118999955],
              [106.54200280000003, -7.016778252999927],
              [106.53714925700007, -6.982961612999929],
              [106.51080421300003, -6.963798794999946],
              [106.48145592500003, -6.967054945999905],
              [106.45170181000003, -6.955059068999958],
              [106.42386967900006, -6.963220839999906],
              [106.40463300900007, -6.991306247999944],
              [106.40162194100003, -6.993096612999921],
              [106.37891686300003, -6.999769789999959],
              [106.35450280000003, -7.002699476999908],
              [106.33301842500003, -7.000746351999908],
              [106.31967207100007, -6.996189059999949],
              [106.31104576900003, -6.99146900799991],
              [106.30241946700005, -6.98796965899993],
              [106.28858483200003, -6.986504815999922],
              [106.28337649800005, -6.983330987999921],
              [106.27320397200003, -6.969333591999941],
              [106.26783287900003, -6.96607838299991],
              [106.25424238400007, -6.964288018999923],
              [106.25033613400007, -6.959567966999941],
              [106.24935957100007, -6.95281340899993],
              [106.24415123800003, -6.945570570999905],
              [106.23755944100003, -6.940606377999927],
              [106.20116190500005, -6.913679238999919],
              [106.16837141600007, -6.915809251999917],
              [106.12470716300004, -6.896279079999942],
              [106.05298499400004, -6.83680556999991],
              [106.00831139400003, -6.82195403399993],
              [105.97870617700005, -6.817711560999953],
              [105.95957332400008, -6.817628373999923],
              [105.93962649800005, -6.820977471999925],
              [105.91895592500003, -6.823988539999959],
              [105.90162194100003, -6.829522393999923],
              [105.89819202700005, -6.843176040999936],
              [105.88437996900007, -6.847672883999905],
              [105.87373494300004, -6.834708033999959],
              [105.85450280000003, -6.838148695999905],
              [105.82313270100008, -6.839039911999919],
              [105.79241752600007, -6.845743527999957],
              [105.77474377900006, -6.850226666999959],
              [105.75560366100007, -6.844816069999922],
              [105.72331790500004, -6.838555596999925],
              [105.70289147200003, -6.835707289999959],
              [105.59653182000005, -6.849073272999931],
              [105.55518770700007, -6.855680446999941],
              [105.53512074200006, -6.872326969999961],
              [105.49846030200007, -6.860727447999921],
              [105.48613478600004, -6.867515500999957],
              [105.47095787900003, -6.853448174999926],
              [105.46045983200003, -6.845310153999947],
              [105.44223066500007, -6.842543226999908],
              [105.43881269600007, -6.845961195999905],
              [105.42969811300003, -6.852715752999927],
              [105.42009524800005, -6.856866143999923],
              [105.41553795700003, -6.85279713299991],
              [105.41358483200003, -6.845798434999949],
              [105.40894616000003, -6.838148695999905],
              [105.40308678500003, -6.832126559999949],
              [105.39795983200003, -6.829522393999923],
              [105.35612567800007, -6.812872490999951],
              [105.31078445900005, -6.810354247999953],
              [105.30111738400007, -6.81414153399993],
              [105.29639733200003, -6.83326588299991],
              [105.29118899800005, -6.840997002999927],
              [105.28370201900003, -6.84693775799991],
              [105.27466881600003, -6.849379164999959],
              [105.25611412900003, -6.842380466999941],
              [105.24708092500003, -6.82545338299991],
              [105.23617597700007, -6.787855726999908],
              [105.22217858200003, -6.778497002999927],
              [105.21680748800003, -6.772067966999941],
              [105.21973717500003, -6.764336846999925],
              [105.22706139400003, -6.762627862999921],
              [105.26075280000003, -6.767347914999959],
              [105.27466881600003, -6.761651299999926],
              [105.29184004000007, -6.748223565999922],
              [105.31934655000003, -6.719659112999921],
              [105.32886803500003, -6.702732028999947],
              [105.33627363400007, -6.68482838299991],
              [105.34636478000004, -6.670668226999908],
              [105.36378014400003, -6.664971612999921],
              [105.37623131600003, -6.670017184999949],
              [105.38982181100005, -6.681410414999959],
              [105.40137780000003, -6.69500090899993],
              [105.40821373800003, -6.705987237999921],
              [105.41081790500004, -6.71843840899993],
              [105.41041100400003, -6.728773695999905],
              [105.41163170700003, -6.738946221999925],
              [105.43539472700007, -6.778252862999921],
              [105.44068444100003, -6.794122002999927],
              [105.45362389400003, -6.808770440999922],
              [105.47120201900003, -6.815850518999923],
              [105.49008222700007, -6.809014580999929],
              [105.50261478000004, -6.791110934999949],
              [105.51726321700005, -6.744235934999949],
              [105.52857506600003, -6.723321221999925],
              [105.60743248800003, -6.651462497999944],
              [105.62224368600005, -6.631605726999908],
              [105.62794030000003, -6.615980726999908],
              [105.61897438500006, -6.532504875999905],
              [105.64385850000008, -6.48233328799995],
              [105.65624206700005, -6.473264317999906],
              [105.67778979500008, -6.474924131999956],
              [105.68223819200006, -6.51153452899996],
              [105.69911100100006, -6.520773518999931],
              [105.71136412400006, -6.534563343999935],
              [105.73908515500005, -6.530148685999961],
              [105.78223428000007, -6.512107304999915],
              [105.80853431500003, -6.477215533999924],
              [105.82409120800003, -6.434645719999935],
              [105.82129967500003, -6.401136976999908],
              [105.83236738400007, -6.228692315999922],
              [105.83961022200003, -6.192071221999925],
              [105.86719811300003, -6.110121351999908],
              [105.88786868600005, -6.070570570999905],
              [105.95704186300003, -5.998711846999925],
              [105.96680748800003, -5.992852471999925],
              [105.97730553500003, -5.983493747999944],
              [105.99724368600005, -5.917738539999959],
              [106.02003014400003, -5.893243096999925],
              [106.05274498800003, -5.881036065999922],
              [106.08521569100003, -5.885511976999908],
              [106.10710696700005, -5.910902601999908],
              [106.11158287900003, -5.975192966999941],
              [106.11793053500003, -5.98601653399993],
              [106.12867272200003, -5.990329684999949],
              [106.15919030000003, -6.009535414999959],
              [106.17603600400003, -6.013929945999905],
              [106.20948326900003, -5.998304945999905],
              [106.23145592500003, -5.966973565999922],
              [106.25652103000004, -5.941582940999922],
              [106.29883873800003, -5.94500090899993],
              [106.36101321700005, -5.99342213299991],
              [106.38493899800005, -6.000258070999905],
              [106.40935306100005, -6.004327080999929],
              [106.47006269600007, -6.034356377999927],
              [106.49537194100003, -6.03484465899993],
              [106.51205488400007, -6.024834893999923],
              [106.52767988400007, -6.012465101999908],
              [106.54932701900003, -6.006524346999925],
              [106.66293379000007, -6.007989190999922],
              [106.68539472700007, -6.012465101999908],
              [106.70582116000003, -6.020196221999925],
              [106.72087649800005, -6.03093840899993],
              [106.72901451900003, -6.047539971999925],
              [106.73104902400007, -6.058851820999905],
              [106.73243248800003, -6.066582940999922],
              [106.73780358200003, -6.083916924999926],
              [106.75196373800003, -6.095879815999922],
              [106.79322350400003, -6.104099216999941],
              [106.83773847700007, -6.102715752999927],
              [106.98829186300003, -6.07935963299991],
              [106.99350019600007, -6.078545830999929],
              [107.00513756600003, -6.072360934999949],
              [107.00855553500003, -6.053155205999929],
              [107.01392662900003, -6.040459893999923],
              [107.01498457100007, -6.02898528399993],
              [107.00513756600003, -6.013929945999905],
              [106.99903405000003, -6.003513278999947],
              [107.00456790500004, -5.988213799999926],
              [107.02564537900003, -5.95867278399993],
              [107.02125084700003, -5.924086195999905],
              [107.04444420700003, -5.914320570999905],
              [107.08033287900003, -5.92156340899993],
              [107.11443118600005, -5.938164971999925],
              [107.12574303500003, -5.94890715899993],
              [107.13648522200003, -5.961602471999925],
              [107.15007571700005, -5.973077080999929],
              [107.16968834700003, -5.97975025799991],
              [107.18775475400003, -5.98015715899993],
              [107.20533287900003, -5.977308851999908],
              [107.28093509200005, -5.95476653399993],
              [107.32064731700007, -5.962415976999921],
              [107.35413648700006, -5.975994692999961],
              [107.37963099700005, -6.008516380999936],
              [107.41307761500008, -6.063173971999959],
              [107.44565470100008, -6.104322740999919],
              [107.47026793800006, -6.145432463999953],
              [107.51077896500004, -6.164443739999911],
              [107.56317927900005, -6.184246526999914],
              [107.62113228600003, -6.187473681999961],
              [107.65522183400003, -6.225378002999946],
              [107.67822384900006, -6.238022903999934],
              [107.69966144000006, -6.226997790999917],
              [107.71552606800003, -6.235689939999929],
              [107.73219448300006, -6.23254847599992],
              [107.74490028600007, -6.223092012999928],
              [107.76807701900003, -6.213311455999929],
              [107.77369225400003, -6.207940362999921],
              [107.78296959700003, -6.205743096999925],
              [107.79297936300003, -6.207940362999921],
              [107.80290774800005, -6.211521091999941],
              [107.81031334700003, -6.211195570999905],
              [107.81324303500003, -6.202325127999927],
              [107.81083632800005, -6.189346824999916],
              [107.82626293400006, -6.18513007599995],
              [107.84768385100006, -6.191952341999922],
              [107.84940290500003, -6.205527749999931],
              [107.86396034600006, -6.206397675999938],
              [107.87766123600005, -6.191151889999958],
              [107.88535929500006, -6.18692221699996],
              [107.89563098100007, -6.20983057299992],
              [107.89562430100005, -6.231024718999947],
              [107.94727623800003, -6.263116143999923],
              [107.99047130700006, -6.281091899999922],
              [108.04934250100007, -6.309907120999924],
              [108.07406950600006, -6.318379011999923],
              [108.09368265800003, -6.326846921999959],
              [108.11328863600005, -6.326847264999913],
              [108.12947950200004, -6.326001111999915],
              [108.14226053200008, -6.322614955999939],
              [108.15844983600005, -6.311609683999961],
              [108.18360436300003, -6.296970309999949],
              [108.18702233200003, -6.294528903999947],
              [108.19507653400007, -6.287061085999937],
              [108.20359445600008, -6.276057684999955],
              [108.20699858400008, -6.26251325699991],
              [108.20529439700005, -6.249816209999949],
              [108.19848087200006, -6.240504778999934],
              [108.18655716400008, -6.231192666999959],
              [108.19848107500007, -6.227807820999942],
              [108.21636382600008, -6.237965338999913],
              [108.24872349800006, -6.247274812999933],
              [108.31088199700008, -6.248956414999952],
              [108.33217267500004, -6.261646979999909],
              [108.33898106000004, -6.250641592999955],
              [108.36026907700005, -6.246400944999948],
              [108.36453480500006, -6.272639433999927],
              [108.37222736900003, -6.340352902999939],
              [108.45541425900007, -6.442071221999925],
              [108.47461998800003, -6.452080987999921],
              [108.48780358200003, -6.456801039999959],
              [108.53956139400003, -6.486911716999941],
              [108.57455488400007, -6.66961028399993],
              [108.60547936300003, -6.761651299999926],
              [108.66309655000003, -6.767347914999959],
              [108.70533287900003, -6.795993747999944],
              [108.74878991000003, -6.81218840899993],
              [108.79224694100003, -6.811130466999941],
              [108.83497155000003, -6.787855726999908],
              [108.84327233200003, -6.797946872999944],
              [108.85865319100003, -6.80242278399993],
              [108.87614993600005, -6.804864190999922],
              [108.88965905000003, -6.809014580999929],
              [108.89519290500004, -6.814222914999959],
              [108.90357506600003, -6.822198174999926],
              [108.91187584700003, -6.834893487999921],
              [108.92302493600005, -6.844659112999921],
              [108.94483483200003, -6.849379164999959],
              [108.96892337300005, -6.848321221999925],
              [108.98340905000003, -6.841729424999926],
              [108.99073326900003, -6.827894789999959],
              [108.99268639400003, -6.805352471999925],
              [109.00131269600007, -6.789157809999949],
              [109.02084394600007, -6.788669528999947],
              [109.04151451900003, -6.795586846999925],
              [109.05347741000003, -6.801527601999908],
              [109.09205162900003, -6.831475518999923],
              [109.11548912900003, -6.838555596999925],
              [109.14283287900003, -6.856215101999908],
              [109.15040123800003, -6.857028903999947],
              [109.17693118600005, -6.856215101999908],
              [109.35189863400007, -6.875664971999925],
              [109.43824303500003, -6.860121351999908],
              [109.49293053500003, -6.801527601999908],
              [109.53199303500003, -6.835137627999927],
              [109.72559655000003, -6.863051039999959],
              [109.89633222700007, -6.918226820999905],
              [109.94068444100003, -6.923435153999947],
              [109.98389733200003, -6.922621351999908],
              [110.11426842500003, -6.903903903999947],
              [110.13884524800005, -6.897149346999925],
              [110.14958743600005, -6.887302341999941],
              [110.15284264400003, -6.881768487999921],
              [110.16976972700007, -6.860935153999947],
              [110.17750084700003, -6.856215101999908],
              [110.18832441500007, -6.860284112999921],
              [110.19206790500004, -6.869805596999925],
              [110.19353274800005, -6.881117445999905],
              [110.19800866000003, -6.890883070999905],
              [110.21257571700005, -6.899997653999947],
              [110.25879967500003, -6.920993747999944],
              [110.29297936300003, -6.931247653999947],
              [110.33464603000004, -6.961358330999929],
              [110.35572350400003, -6.972914320999905],
              [110.38103274800005, -6.975681247999944],
              [110.39909915500004, -6.967868747999944],
              [110.41504967500003, -6.957452080999929],
              [110.43458092500003, -6.95240650799991],
              [110.45606530000003, -6.950941664999959],
              [110.47242272200003, -6.946384372999944],
              [110.48617597700007, -6.937920830999929],
              [110.52702884200005, -6.895196221999925],
              [110.57154381600003, -6.836195570999905],
              [110.64470462300005, -6.688164971999925],
              [110.65739993600005, -6.643975518999923],
              [110.66325931100005, -6.606052341999941],
              [110.66480553500003, -6.565362237999921],
              [110.66968834700003, -6.546319268999923],
              [110.67847741000003, -6.534600518999923],
              [110.68189537900003, -6.521905205999929],
              [110.67107181100005, -6.499932549999926],
              [110.69166100400003, -6.496026299999926],
              [110.70199629000007, -6.488702080999929],
              [110.71876061300003, -6.465752862999921],
              [110.73047936300003, -6.456963799999926],
              [110.78109785200007, -6.436455987999921],
              [110.80811608200003, -6.431735934999949],
              [110.81812584700003, -6.428155205999929],
              [110.83375084700003, -6.420668226999908],
              [110.84229576900003, -6.418064059999949],
              [110.90316816500007, -6.410821221999925],
              [110.92481530000003, -6.403741143999923],
              [110.93409264400003, -6.411065362999921],
              [110.96176191500007, -6.427911065999922],
              [110.97250410200007, -6.431735934999949],
              [110.99219811300003, -6.432305596999925],
              [111.00245201900003, -6.431247653999947],
              [111.00684655000003, -6.428317966999941],
              [111.01075280000003, -6.420993747999944],
              [111.01929772200003, -6.426364841999941],
              [111.02670332100007, -6.435316664999959],
              [111.02784264400003, -6.438409112999921],
              [111.04086347700007, -6.447360934999949],
              [111.05176842500003, -6.45671965899993],
              [111.05925540500004, -6.469903252999927],
              [111.06544030000003, -6.509372653999947],
              [111.08236738400007, -6.543877862999921],
              [111.11931399800005, -6.64967213299991],
              [111.13705488400007, -6.685479424999926],
              [111.14437910200007, -6.691827080999929],
              [111.15056399800005, -6.692966403999947],
              [111.15691165500004, -6.692071221999925],
              [111.34253991000003, -6.712823174999926],
              [111.36638431100005, -6.712009372999944],
              [111.40805097700007, -6.701755466999941],
              [111.42872155000003, -6.699151299999926],
              [111.44410241000003, -6.689060153999947],
              [111.47779381600003, -6.64031340899993],
              [111.49341881600003, -6.623467705999929],
              [111.51986738400007, -6.63990650799991],
              [111.57699629000007, -6.650974216999941],
              [111.61011803500003, -6.664971612999921],
              [111.62142988400007, -6.674574476999908],
              [111.65463300900007, -6.716241143999923],
              [111.67269941500007, -6.73365650799991],
              [111.69499759200005, -6.75514088299991],
              [111.71680748800003, -6.770684502999927],
              [111.74040774800005, -6.781670830999929],
              [111.80730228000004, -6.799493096999925],
              [111.84945722700007, -6.803887627999927],
              [111.86622155000003, -6.807793877999927],
              [111.88233483200003, -6.808689059999949],
              [111.90430748800003, -6.801527601999908],
              [111.93653405000003, -6.784926039999959],
              [111.95850670700003, -6.779392184999949],
              [111.97624759200005, -6.78484465899993],
              [112.00993899800005, -6.818617445999905],
              [112.06788170700008, -6.893649997999944],
              [112.08399498800009, -6.906019789999959],
              [112.10694420700008, -6.910821221999925],
              [112.15064537900003, -6.910088799999926],
              [112.19288170700008, -6.904554945999905],
              [112.22657311300009, -6.892673434999949],
              [112.23707116000003, -6.890883070999905],
              [112.27816816500001, -6.890883070999905],
              [112.29867597700002, -6.887465101999908],
              [112.33969160200002, -6.873142184999949],
              [112.36353600400003, -6.870538018999923],
              [112.40007571700005, -6.876722914999959],
              [112.41504967500009, -6.88250090899993],
              [112.42237389400009, -6.878838799999926],
              [112.42920983200008, -6.873223565999922],
              [112.43523196700005, -6.870538018999923],
              [112.45484459700003, -6.875420830999929],
              [112.47120201900009, -6.887139580999929],
              [112.48601321700005, -6.900567315999922],
              [112.50074303500003, -6.910821221999925],
              [112.52271569100003, -6.91765715899993],
              [112.54281660200002, -6.917575778999947],
              [112.55713951900009, -6.90789153399993],
              [112.562836134, -6.887302341999941],
              [112.56218509200005, -6.874200127999927],
              [112.56251061300009, -6.866794528999947],
              [112.56812584700003, -6.865411065999922],
              [112.58277428500003, -6.870538018999923],
              [112.58985436300009, -6.876071872999944],
              [112.59620201900009, -6.885186455999929],
              [112.60108483200008, -6.895603122999944],
              [112.60377037900003, -6.904554945999905],
              [112.60254967500009, -6.925957940999922],
              [112.58668053500003, -6.965590101999908],
              [112.58277428500003, -6.98992278399993],
              [112.58716881600003, -6.999607028999947],
              [112.60954837300005, -7.033379815999922],
              [112.61801191500001, -7.041192315999922],
              [112.62867272200003, -7.045342705999929],
              [112.64332116000003, -7.039483330999929],
              [112.65739993600005, -7.037855726999908],
              [112.66578209700003, -7.054864190999922],
              [112.63379967500009, -7.06373463299991],
              [112.61768639400009, -7.070570570999905],
              [112.61060631600003, -7.07935963299991],
              [112.61410566500001, -7.091241143999923],
              [112.62256920700008, -7.108493747999944],
              [112.63282311300009, -7.123793226999908],
              [112.64161217500009, -7.13054778399993],
              [112.65837649800005, -7.137627862999921],
              [112.67465254000001, -7.154473565999922],
              [112.68384850400003, -7.174899997999944],
              [112.67896569100003, -7.19264088299991],
              [112.66431725400003, -7.198825778999947],
              [112.60377037900003, -7.19264088299991],
              [112.62012780000009, -7.214939059999949],
              [112.64551842500009, -7.23015715899993],
              [112.70069420700008, -7.254652601999908],
              [112.71631920700008, -7.239190362999921],
              [112.72950280000009, -7.220472914999959],
              [112.74512780000009, -7.205173434999949],
              [112.76823978000004, -7.199395440999922],
              [112.78443444100003, -7.205498955999929],
              [112.79786217500009, -7.218926690999922],
              [112.80860436300009, -7.234551690999922],
              [112.82325280000009, -7.262627862999921],
              [112.82667076900009, -7.277927341999941],
              [112.82634524800005, -7.293226820999905],
              [112.81812584700003, -7.329522393999923],
              [112.81617272200003, -7.34693775799991],
              [112.81609134200005, -7.387139580999929],
              [112.80746504000001, -7.407321872999944],
              [112.77003014400009, -7.432712497999944],
              [112.76148522200003, -7.44890715899993],
              [112.76148522200003, -7.531182549999926],
              [112.84489993600005, -7.592868747999944],
              [112.97201582100001, -7.647637627999927],
              [112.99048912900003, -7.651950778999947],
              [113.01628665500004, -7.652276299999926],
              [113.03711998800009, -7.655043226999908],
              [113.05600019600001, -7.663018487999921],
              [113.07618248800009, -7.678643487999921],
              [113.11150149800005, -7.713148695999905],
              [113.13266035200002, -7.72779713299991],
              [113.16537519600001, -7.735935153999947],
              [113.18726647200003, -7.745049737999921],
              [113.199554884, -7.747491143999923],
              [113.20826256600003, -7.746270440999922],
              [113.22974694100003, -7.740817966999941],
              [113.24122155000009, -7.740655205999929],
              [113.26099694100003, -7.750176690999922],
              [113.28532962300005, -7.781670830999929],
              [113.29932701900009, -7.788506768999923],
              [113.32309004000001, -7.785577080999929],
              [113.34253991000003, -7.777764580999929],
              [113.37777754000001, -7.754327080999929],
              [113.41374759200005, -7.736260674999926],
              [113.43580162900003, -7.729180596999925],
              [113.45687910200002, -7.726332289999959],
              [113.47282962300005, -7.722100518999923],
              [113.50456790500004, -7.703789971999925],
              [113.52857506600003, -7.700372002999927],
              [113.65894616000003, -7.720147393999923],
              [113.67107181100005, -7.717950127999927],
              [113.69092858200008, -7.709079684999949],
              [113.69996178500003, -7.706638278999947],
              [113.722992384, -7.70826588299991],
              [113.76303144600001, -7.722832940999922],
              [113.78589928500003, -7.726332289999959],
              [113.80388431100005, -7.721774997999944],
              [113.81657962300005, -7.71062590899993],
              [113.83716881600003, -7.686130466999941],
              [113.85474694100003, -7.67701588299991],
              [113.86963951900009, -7.677992445999905],
              [113.88607832100001, -7.683038018999923],
              [113.90943444100003, -7.686130466999941],
              [113.93051191500001, -7.683851820999905],
              [113.94507897200003, -7.677992445999905],
              [114.01612389400009, -7.618096612999921],
              [114.04558353000004, -7.611993096999925],
              [114.07732181100005, -7.630791924999926],
              [114.11695397200003, -7.680596612999921],
              [114.14039147200003, -7.70086028399993],
              [114.172211134, -7.713474216999941],
              [114.19597415500004, -7.71412525799991],
              [114.23682701900009, -7.703301690999922],
              [114.25855553500003, -7.700372002999927],
              [114.27361087300005, -7.705498955999929],
              [114.31006920700008, -7.740655205999929],
              [114.32520592500009, -7.750258070999905],
              [114.33448326900009, -7.75318775799991],
              [114.34750410200002, -7.754327080999929],
              [114.36963951900009, -7.75318775799991],
              [114.38111412900003, -7.754164320999905],
              [114.38892662900003, -7.758070570999905],
              [114.40674889400009, -7.773207289999959],
              [114.44597415500004, -7.794691664999959],
              [114.46021569100003, -7.809665622999944],
              [114.46729576900009, -7.830987237999921],
              [114.46648196700005, -7.852715752999927],
              [114.46021569100003, -7.894952080999929],
              [114.457367384, -7.902520440999922],
              [114.44459069100003, -7.920668226999908],
              [114.44044030000009, -7.932549737999921],
              [114.44027754000001, -7.943780205999929],
              [114.44255618600005, -7.95240650799991],
              [114.44548587300005, -7.959649346999925],
              [114.44727623800009, -7.966566664999959],
              [114.44678795700008, -8.014255466999941],
              [114.40479576900009, -8.158379815999922],
              [114.36597741000003, -8.35719166499996],
              [114.36353600400003, -8.386163018999923],
              [114.35865319100003, -8.40911223799992],
              [114.35792076900009, -8.419122002999927],
              [114.36011803500003, -8.43059661299992],
              [114.37159264400009, -8.45322030999995],
              [114.373383009, -8.498467705999929],
              [114.37671959700003, -8.519463799999926],
              [114.38892662900003, -8.52825286299992],
              [114.40113366000003, -8.517185153999947],
              [114.40512129000001, -8.491794528999947],
              [114.40560957100001, -8.44703541499996],
              [114.42318769600001, -8.465020440999922],
              [114.42741946700005, -8.496840101999908],
              [114.426117384, -8.562432549999926],
              [114.43287194100003, -8.582614841999941],
              [114.44532311300009, -8.60279713299991],
              [114.46119225400003, -8.618340752999927],
              [114.47803795700008, -8.624607028999947],
              [114.49805748800009, -8.625258070999905],
              [114.51075280000009, -8.628350518999923],
              [114.53598066500001, -8.645114841999941],
              [114.58912194100003, -8.664239190999922],
              [114.59742272200003, -8.675713799999926],
              [114.60336347700002, -8.688164971999925],
              [114.615570509, -8.70012786299992],
              [114.62566165500004, -8.71607838299991],
              [114.62476647200003, -8.740655205999929],
              [114.59717858200008, -8.775567315999922],
              [114.55534915500004, -8.777927341999941],
              [114.46762129000001, -8.74814218499995],
              [114.44532311300009, -8.744073174999926],
              [114.38892662900003, -8.74814218499995],
              [114.36695397200003, -8.74146900799991],
              [114.36980228000004, -8.72633228999996],
              [114.39193769600001, -8.700290622999944],
              [114.38526451900009, -8.664727471999925],
              [114.34961998800009, -8.63250090899993],
              [114.30258222700002, -8.611911716999941],
              [114.26172936300009, -8.610935153999947],
              [114.22087649800005, -8.63648853999996],
              [114.19703209700003, -8.645603122999944],
              [114.18653405000009, -8.63486093499995],
              [114.17481530000009, -8.619805596999925],
              [114.14820397200003, -8.62232838299991],
              [114.10401451900009, -8.638116143999923],
              [114.09489993600005, -8.637872002999927],
              [114.05933678500003, -8.631442966999941],
              [114.05079186300009, -8.627129815999922],
              [114.04151451900009, -8.60833098799992],
              [114.03199303500003, -8.604099216999941],
              [114.01238040500004, -8.60947030999995],
              [113.99488366000003, -8.618340752999927],
              [113.97999108200008, -8.620212497999944],
              [113.96802819100003, -8.604099216999941],
              [113.96924889400009, -8.59351978999996],
              [113.97315514400009, -8.579685153999947],
              [113.97388756600003, -8.567559502999927],
              [113.96436608200008, -8.562432549999926],
              [113.95427493600005, -8.564711195999905],
              [113.93376712300005, -8.574476820999905],
              [113.92286217500009, -8.576755466999941],
              [113.90560957100001, -8.57390715899993],
              [113.87964928500003, -8.56617603999996],
              [113.85377037900003, -8.555108330999929],
              [113.83716881600003, -8.542087497999944],
              [113.83204186300009, -8.546807549999926],
              [113.828461134, -8.54892343499995],
              [113.82593834700003, -8.551039320999905],
              [113.82349694100003, -8.55632903399993],
              [113.81885826900009, -8.541761976999908],
              [113.81381269600001, -8.507745049999926],
              [113.80616295700008, -8.501071872999944],
              [113.79078209700003, -8.503024997999944],
              [113.77369225400003, -8.508070570999905],
              [113.760101759, -8.515801690999922],
              [113.75456790500004, -8.524997653999947],
              [113.75074303500003, -8.528090101999908],
              [113.74170983200008, -8.52898528399993],
              [113.72388756600003, -8.52825286299992],
              [113.71973717500009, -8.52467213299991],
              [113.72185306100005, -8.507419528999947],
              [113.72046959700003, -8.501071872999944],
              [113.70728600400003, -8.492364190999922],
              [113.69874108200008, -8.493584893999923],
              [113.68897545700008, -8.496840101999908],
              [113.67261803500003, -8.494805596999925],
              [113.65845787900003, -8.484958591999941],
              [113.64047285200002, -8.458591403999947],
              [113.62794030000009, -8.45322030999995],
              [113.59693444100003, -8.44703541499996],
              [113.59058678500003, -8.442071221999925],
              [113.57911217500009, -8.428806247999944],
              [113.57300866000003, -8.425957940999922],
              [113.54086347700002, -8.43059661299992],
              [113.52719160200002, -8.429294528999947],
              [113.49048912900003, -8.408379815999922],
              [113.48389733200008, -8.40203215899993],
              [113.478851759, -8.394707940999922],
              [113.47242272200003, -8.38209400799991],
              [113.46656334700003, -8.377536716999941],
              [113.44605553500003, -8.375583591999941],
              [113.42945397200003, -8.38404713299991],
              [113.41358483200008, -8.390232028999947],
              [113.39519290500004, -8.381280205999929],
              [113.34595787900003, -8.324151299999926],
              [113.32309004000001, -8.309258721999925],
              [113.28199303500003, -8.292087497999944],
              [113.24073326900009, -8.28093840899993],
              [113.19792728000004, -8.277276299999926],
              [113.07007897200003, -8.292413018999923],
              [113.02670332100001, -8.302992445999905],
              [112.98731530000009, -8.32350025799991],
              [112.93677819100003, -8.381280205999929],
              [112.902679884, -8.40398528399993],
              [112.87061608200008, -8.391778252999927],
              [112.85743248800009, -8.39267343499995],
              [112.83383222700002, -8.375746351999908],
              [112.82976321700005, -8.381280205999929],
              [112.82634524800005, -8.390069268999923],
              [112.81788170700008, -8.39657968499995],
              [112.80787194100003, -8.398858330999929],
              [112.79908287900003, -8.395196221999925],
              [112.78980553500003, -8.387872002999927],
              [112.78419030000009, -8.38681405999995],
              [112.76921634200005, -8.395196221999925],
              [112.75513756600003, -8.40797291499996],
              [112.74781334700003, -8.412855726999908],
              [112.73316491000003, -8.41765715899993],
              [112.71680748800009, -8.419122002999927],
              [112.70191491000003, -8.422295830999929],
              [112.69044030000009, -8.429864190999922],
              [112.67269941500001, -8.44703541499996],
              [112.65626061300009, -8.43645598799992],
              [112.61215254000001, -8.416436455999929],
              [112.57341556100005, -8.410088799999926],
              [112.52068118600005, -8.391778252999927],
              [112.44239342500009, -8.391778252999927],
              [112.42652428500003, -8.38762786299992],
              [112.41358483200008, -8.379082940999922],
              [112.39869225400003, -8.371758721999925],
              [112.37663821700005, -8.371270440999922],
              [112.38135826900009, -8.36142343499995],
              [112.38404381600003, -8.357598565999922],
              [112.36622155000009, -8.341973565999922],
              [112.34156334700003, -8.332696221999925],
              [112.31592858200008, -8.32903411299992],
              [112.295258009, -8.32976653399993],
              [112.28451582100001, -8.332696221999925],
              [112.25782311300009, -8.343357028999947],
              [112.24439537900003, -8.341973565999922],
              [112.23755944100003, -8.338474216999941],
              [112.23308353000004, -8.333916924999926],
              [112.22706139400009, -8.32976653399993],
              [112.20899498800009, -8.323663018999923],
              [112.02475019600001, -8.304945570999905],
              [112.00269616000003, -8.29778411299992],
              [111.97071373800003, -8.277764580999929],
              [111.96119225400003, -8.27825286299992],
              [111.93620853000004, -8.294854424999926],
              [111.93165123800003, -8.299574476999908],
              [111.92725670700003, -8.30250416499996],
              [111.91863040500004, -8.302992445999905],
              [111.89869225400003, -8.296482028999947],
              [111.87476647200003, -8.273858330999929],
              [111.85987389400003, -8.26881275799991],
              [111.83375084700003, -8.270684502999927],
              [111.82243899800005, -8.26881275799991],
              [111.81128991000003, -8.264418226999908],
              [111.80152428500003, -8.258884372999944],
              [111.79200280000003, -8.256524346999925],
              [111.78142337300005, -8.26140715899993],
              [111.77100670700003, -8.281508070999905],
              [111.77222741000003, -8.30169036299992],
              [111.77035566500007, -8.31731536299992],
              [111.75066165500004, -8.32350025799991],
              [111.74659264400003, -8.31804778399993],
              [111.74187259200005, -8.306084893999923],
              [111.73536217500003, -8.294040622999944],
              [111.72608483200003, -8.28875090899993],
              [111.71729576900003, -8.29273853999996],
              [111.71192467500003, -8.302178643999923],
              [111.70573978000004, -8.32350025799991],
              [111.70248457100007, -8.32740650799991],
              [111.69678795700003, -8.33684661299992],
              [111.69483483200003, -8.346368096999925],
              [111.70923912900003, -8.354099216999941],
              [111.71127363400007, -8.36101653399993],
              [111.70753014400003, -8.36809661299992],
              [111.69581139400003, -8.371270440999922],
              [111.67335045700003, -8.367852471999925],
              [111.65406334700003, -8.358086846999925],
              [111.63917076900003, -8.34303150799991],
              [111.63054446700005, -8.32350025799991],
              [111.62370853000004, -8.32350025799991],
              [111.61255944100003, -8.337009372999944],
              [111.59587649800005, -8.334405205999929],
              [111.56169681100005, -8.316664320999905],
              [111.54802493600005, -8.315606377999927],
              [111.53288821700005, -8.326592705999929],
              [111.51783287900003, -8.32976653399993],
              [111.44874108200003, -8.312920830999929],
              [111.44166100400003, -8.296807549999926],
              [111.44353274800005, -8.28484465899993],
              [111.44206790500004, -8.276055596999925],
              [111.42505944100003, -8.26881275799991],
              [111.41749108200003, -8.269138278999947],
              [111.39991295700003, -8.27434661299992],
              [111.39039147200003, -8.27507903399993],
              [111.38412519600007, -8.272881768999923],
              [111.37240644600007, -8.264418226999908],
              [111.36304772200003, -8.26140715899993],
              [111.31153405000003, -8.26140715899993],
              [111.30062910200007, -8.26295338299991],
              [111.29493248800003, -8.260430596999925],
              [111.28419030000003, -8.25123463299991],
              [111.27613366000003, -8.248304945999905],
              [111.26579837300005, -8.24928150799991],
              [111.25700931100005, -8.253024997999944],
              [111.25318444100003, -8.257989190999922],
              [111.17123457100007, -8.282647393999923],
              [111.16195722700007, -8.281914971999925],
              [111.15821373800003, -8.272067966999941],
              [111.15544681100005, -8.26100025799991],
              [111.14828535200007, -8.253513278999947],
              [111.13843834700003, -8.249200127999927],
              [111.12720787900003, -8.24773528399993],
              [111.11475670700003, -8.24195728999996],
              [111.11117597700007, -8.229180596999925],
              [111.10971113400007, -8.215427341999941],
              [111.10303795700003, -8.20680103999996],
              [111.09555097700007, -8.208184502999927],
              [111.09083092500003, -8.215508721999925],
              [111.08716881600003, -8.225274346999925],
              [111.08236738400007, -8.233493747999944],
              [111.07276451900003, -8.24700286299992],
              [111.06666100400003, -8.252536716999941],
              [111.05827884200005, -8.254652601999908],
              [111.01734459700003, -8.254652601999908],
              [110.99822024800005, -8.250176690999922],
              [110.93100019600007, -8.22047291499996],
              [110.84791100400003, -8.201104424999926],
              [110.71534264400003, -8.19312916499996],
              [110.70557701900003, -8.190036716999941],
              [110.69125410200007, -8.17587655999995],
              [110.68148847700007, -8.172621351999908],
              [110.66065514400003, -8.169854424999926],
              [110.63941491000003, -8.162774346999925],
              [110.60271243600005, -8.144789320999905],
              [110.60271243600005, -8.151543877999927],
              [110.54908287900003, -8.127618096999925],
              [110.52116946700005, -8.120212497999944],
              [110.49626712300005, -8.117445570999905],
              [110.47673587300005, -8.111911716999941],
              [110.41089928500003, -8.07586028399993],
              [110.40056399800005, -8.074639580999929],
              [110.38941491000003, -8.074883721999925],
              [110.38038170700003, -8.07317473799992],
              [110.37671959700003, -8.06617603999996],
              [110.35230553500003, -8.041680596999925],
              [110.34742272200003, -8.03883228999996],
              [110.32837975400003, -8.02117278399993],
              [110.31910241000003, -8.018731377999927],
              [110.28736412900003, -8.015069268999923],
              [110.03419030000003, -7.884698174999926],
              [109.93189537900003, -7.854913018999923],
              [109.90601647200003, -7.837660414999959],
            ],
          ],
          [
            [
              [124.06519616000003, -5.962497653999947],
              [124.07398522200003, -5.985284112999921],
              [124.07113691500001, -6.011325778999947],
              [124.05933678500003, -6.027439059999949],
              [124.04127037900003, -6.02076588299991],
              [124.037445509, -6.011651299999926],
              [124.03589928500003, -5.987399997999944],
              [124.03044681100005, -5.976006768999923],
              [124.01856530000009, -5.967950127999927],
              [123.99293053500003, -5.961195570999905],
              [123.98259524800005, -5.955254815999922],
              [123.96892337300005, -5.935316664999959],
              [123.96607506600003, -5.915459893999923],
              [123.97071373800009, -5.893975518999923],
              [123.97917728000004, -5.869886976999908],
              [123.98609459700003, -5.879815362999921],
              [124.037445509, -5.914320570999905],
              [124.04639733200008, -5.925713799999926],
              [124.05762780000009, -5.951104424999926],
              [124.06519616000003, -5.962497653999947],
            ],
          ],
          [
            [
              [132.7973738940001, -5.60906340899993],
              [132.79672285200002, -5.625664971999925],
              [132.7993270190001, -5.641534112999921],
              [132.80453535200002, -5.656670830999929],
              [132.81275475400003, -5.671319268999923],
              [132.80746504, -5.679864190999922],
              [132.80543053500003, -5.684991143999923],
              [132.7978621750001, -5.680433851999908],
              [132.7920028000001, -5.674493096999925],
              [132.78785241000003, -5.666680596999925],
              [132.78492272200003, -5.657647393999923],
              [132.78492272200003, -5.672539971999925],
              [132.78052819100003, -5.680352471999925],
              [132.772797071, -5.682224216999941],
              [132.7636824880001, -5.678806247999944],
              [132.75847415500004, -5.670668226999908],
              [132.7431746750001, -5.630303643999923],
              [132.7431746750001, -5.604424737999921],
              [132.750824415, -5.57350025799991],
              [132.76531009200005, -5.545342705999929],
              [132.78492272200003, -5.527276299999926],
              [132.78980553500003, -5.535821221999925],
              [132.79127037900003, -5.544366143999923],
              [132.789398634, -5.552911065999922],
              [132.78492272200003, -5.561455987999921],
              [132.78980553500003, -5.557305596999925],
              [132.7973738940001, -5.55396900799991],
              [132.8051863940001, -5.552992445999905],
              [132.8110457690001, -5.555596612999921],
              [132.811859571, -5.565524997999944],
              [132.7973738940001, -5.60906340899993],
            ],
          ],
          [
            [
              [132.31861412900003, -5.513604424999926],
              [132.3462020190001, -5.535902601999908],
              [132.36117597700002, -5.54029713299991],
              [132.38070722700002, -5.534112237999921],
              [132.37761478000004, -5.54420338299991],
              [132.371429884, -5.554131768999923],
              [132.3632918630001, -5.562920830999929],
              [132.3535262380001, -5.568942966999941],
              [132.34001712300005, -5.573663018999923],
              [132.334320509, -5.572930596999925],
              [132.33155358200008, -5.568291924999926],
              [132.3173934250001, -5.551039320999905],
              [132.30884850400003, -5.535739841999941],
              [132.3071395190001, -5.52117278399993],
              [132.31861412900003, -5.513604424999926],
            ],
          ],
          [
            [
              [123.77711022200003, -5.513604424999926],
              [123.80144290500004, -5.52271900799991],
              [123.80836022200003, -5.545017184999949],
              [123.80925540500004, -5.57195403399993],
              [123.81470787900003, -5.595635674999926],
              [123.793304884, -5.58912525799991],
              [123.77816816500001, -5.572686455999929],
              [123.75318444100003, -5.534112237999921],
              [123.73462975400003, -5.518324476999908],
              [123.71664472700002, -5.506524346999925],
              [123.70167076900009, -5.493096612999921],
              [123.69117272200003, -5.472751559999949],
              [123.70484459700003, -5.472751559999949],
              [123.73324629000001, -5.475274346999925],
              [123.74976647200003, -5.489841403999947],
              [123.76197350400003, -5.505954684999949],
              [123.77711022200003, -5.513604424999926],
            ],
          ],
          [
            [
              [123.53972415500004, -5.245538018999923],
              [123.56348717500009, -5.252618096999925],
              [123.59555097700002, -5.256768487999921],
              [123.62378991000003, -5.266534112999921],
              [123.63591556100005, -5.290785414999959],
              [123.63835696700005, -5.343519789999959],
              [123.63379967500009, -5.36687590899993],
              [123.61915123800009, -5.376560153999947],
              [123.59058678500003, -5.374118747999944],
              [123.57211347700002, -5.366143487999921],
              [123.55925540500004, -5.351332289999959],
              [123.52295983200008, -5.277439059999949],
              [123.519867384, -5.251722914999959],
              [123.53972415500004, -5.245538018999923],
            ],
          ],
          [
            [
              [129.92725670700008, -4.530450127999927],
              [129.93181399800005, -4.515069268999923],
              [129.94109134200005, -4.508884372999944],
              [129.94849694100003, -4.514336846999925],
              [129.945648634, -4.556084893999923],
              [129.93336022200003, -4.562920830999929],
              [129.9160262380001, -4.563897393999923],
              [129.899261915, -4.568291924999926],
              [129.89332116000003, -4.56023528399993],
              [129.8837996750001, -4.555596612999921],
              [129.87183678500003, -4.553887627999927],
              [129.85906009200005, -4.554782809999949],
              [129.8740340500001, -4.545830987999921],
              [129.91814212300005, -4.537204684999949],
              [129.92725670700008, -4.530450127999927],
            ],
          ],
          [
            [
              [127.23462975400003, -3.821058851999908],
              [127.24611869600005, -3.836224612999956],
              [127.25320002800004, -3.849206734999939],
              [127.25602091500002, -3.874534031999929],
              [127.24952506, -3.89027974499993],
              [127.242639844, -3.900407626999936],
              [127.24136752900006, -3.91081651099995],
              [127.2269705540001, -3.917062727999905],
              [127.20952868300003, -3.914779310999961],
              [127.1907268430001, -3.91173099599996],
              [127.1725526240001, -3.910109891999923],
              [127.16049974600003, -3.899030720999917],
              [127.14508612100008, -3.884983417999933],
              [127.13604776400007, -3.86985890099993],
              [127.13793300500004, -3.846851729999912],
              [127.16521243600005, -3.81414153399993],
              [127.18189537900003, -3.808526299999926],
              [127.19898522200003, -3.810316664999959],
              [127.23462975400003, -3.821058851999908],
            ],
          ],
          [
            [
              [122.32129967500009, -3.511895440999922],
              [122.33301842500009, -3.516696872999944],
              [122.34400475400003, -3.52898528399993],
              [122.35222415500004, -3.543877862999921],
              [122.35547936300009, -3.556573174999926],
              [122.34652754000001, -3.557305596999925],
              [122.32667076900009, -3.562269789999959],
              [122.30567467500009, -3.570733330999929],
              [122.293304884, -3.580824476999908],
              [122.28467858200008, -3.562920830999929],
              [122.29037519600001, -3.541192315999922],
              [122.30486087300005, -3.522067966999941],
              [122.32129967500009, -3.511895440999922],
            ],
          ],
          [
            [
              [132.70281009200005, -3.453301690999922],
              [132.71045983200008, -3.469496351999908],
              [132.71469160200002, -3.486993096999925],
              [132.7129012380001, -3.504164320999905],
              [132.70289147200003, -3.519301039999959],
              [132.6899520190001, -3.509535414999959],
              [132.67888431100005, -3.495863539999959],
              [132.67115319100003, -3.479424737999921],
              [132.666351759, -3.453383070999962],
              [132.6611434250001, -3.450616143999923],
              [132.64429772200003, -3.451104424999926],
              [132.63746178500003, -3.447523695999962],
              [132.62029056100005, -3.423760674999926],
              [132.62680097700002, -3.418389580999929],
              [132.6435653000001, -3.408623955999929],
              [132.65162194100003, -3.406019789999959],
              [132.6665145190001, -3.410251559999949],
              [132.68116295700008, -3.423435153999947],
              [132.70281009200005, -3.453301690999922],
            ],
          ],
          [
            [
              [122.43962649800005, -3.419040622999944],
              [122.461273634, -3.436130466999941],
              [122.46469160200002, -3.440850518999923],
              [122.46338951900009, -3.452243747999944],
              [122.45866946700005, -3.466973565999922],
              [122.44922936300009, -3.47975025799991],
              [122.43360436300009, -3.485284112999921],
              [122.42579186300009, -3.477308851999908],
              [122.41553795700008, -3.459649346999925],
              [122.40259850400003, -3.430596612999921],
              [122.40211022200003, -3.420505466999941],
              [122.40349368600005, -3.407972914999959],
              [122.40650475400003, -3.39617278399993],
              [122.41228274800005, -3.387790622999944],
              [122.41537519600001, -3.385430596999925],
              [122.41781660200002, -3.384535414999959],
              [122.42042076900009, -3.385186455999929],
              [122.42359459700003, -3.387465101999908],
              [122.42847741000003, -3.394301039999959],
              [122.43490644600001, -3.41139088299991],
              [122.43962649800005, -3.419040622999944],
            ],
          ],
          [
            [
              [127.61548912900003, -3.307386976999908],
              [127.62867272200003, -3.321872653999947],
              [127.64161217500009, -3.340264580999929],
              [127.64356530000009, -3.356052341999941],
              [127.62452233200008, -3.361748955999929],
              [127.60303795700008, -3.356866143999923],
              [127.56544030000009, -3.338474216999941],
              [127.51970462300005, -3.330254815999922],
              [127.50359134200005, -3.320082289999959],
              [127.490570509, -3.306817315999922],
              [127.48047936300009, -3.293389580999929],
              [127.48511803500003, -3.292087497999944],
              [127.50961347700002, -3.276543877999927],
              [127.51270592500009, -3.273614190999922],
              [127.521820509, -3.261814059999949],
              [127.52475019600001, -3.256117445999962],
              [127.52637780000009, -3.254327080999929],
              [127.529633009, -3.253350518999923],
              [127.53223717500009, -3.254489841999941],
              [127.53443444100003, -3.255791924999926],
              [127.56397545700008, -3.255791924999926],
              [127.58301842500009, -3.267998955999929],
              [127.61548912900003, -3.307386976999908],
            ],
          ],
          [
            [
              [127.77222741000003, -3.162530205999929],
              [127.78443444100003, -3.168715101999908],
              [127.78825931100005, -3.18328215899993],
              [127.78980553500003, -3.199639580999929],
              [127.79639733200008, -3.211521091999941],
              [127.78565514400009, -3.234307549999926],
              [127.77849368600005, -3.244235934999949],
              [127.76644941500001, -3.246270440999922],
              [127.74187259200005, -3.245700778999947],
              [127.67920983200008, -3.25164153399993],
              [127.658539259, -3.245700778999947],
              [127.64332116000003, -3.224379164999959],
              [127.65967858200008, -3.201429945999962],
              [127.68734785200002, -3.178317966999941],
              [127.70630944100003, -3.156345309999949],
              [127.74187259200005, -3.156345309999949],
              [127.75342858200008, -3.150567315999922],
              [127.758148634, -3.149509372999944],
              [127.76140384200005, -3.151543877999927],
              [127.76335696700005, -3.15593840899993],
              [127.76628665500004, -3.160414320999962],
              [127.77222741000003, -3.162530205999929],
            ],
          ],
          [
            [
              [127.95411217500009, -2.916680596999925],
              [127.96998131600003, -2.920179945999962],
              [127.98536217500009, -2.929457289999959],
              [127.99439537900003, -2.939060153999947],
              [127.99154707100001, -2.943454684999949],
              [127.98357181100005, -2.948825778999947],
              [127.969086134, -2.972263278999947],
              [127.96404056100005, -2.977634372999944],
              [127.96094811300009, -2.983493747999944],
              [127.95093834700003, -3.010918877999927],
              [127.94727623800009, -3.018487237999921],
              [127.93425540500004, -3.025567315999922],
              [127.91846764400009, -3.029229424999926],
              [127.83838951900009, -3.033298434999949],
              [127.82699629000001, -3.02898528399993],
              [127.82545006600003, -3.016534112999921],
              [127.83716881600003, -3.001885674999926],
              [127.85401451900009, -2.989434502999927],
              [127.86801191500001, -2.984307549999926],
              [127.87525475400003, -2.983005466999941],
              [127.87964928500003, -2.979424737999921],
              [127.88892662900003, -2.967217705999929],
              [127.89649498800009, -2.961846612999921],
              [127.90235436300009, -2.962497653999947],
              [127.90739993600005, -2.96453215899993],
              [127.91236412900003, -2.963799737999921],
              [127.92530358200008, -2.955173434999949],
              [127.93287194100003, -2.945977471999925],
              [127.93376712300005, -2.934014580999929],
              [127.92603600400003, -2.916680596999925],
              [127.95411217500009, -2.916680596999925],
            ],
          ],
          [
            [
              [123.87671959700003, -2.018487237999921],
              [123.87891686300009, -2.032321872999944],
              [123.88786868600005, -2.050876559999949],
              [123.88965905000009, -2.063246351999908],
              [123.88697350400003, -2.07390715899993],
              [123.88054446700005, -2.069431247999944],
              [123.86931399800005, -2.053317966999941],
              [123.86426842500009, -2.055108330999929],
              [123.84986412900003, -2.054864190999922],
              [123.83936608200008, -2.049086195999962],
              [123.84538821700005, -2.035577080999929],
              [123.85987389400009, -2.010511976999908],
              [123.86744225400003, -2.00554778399993],
              [123.87671959700003, -2.018487237999921],
            ],
          ],
          [
            [
              [124.34888756600003, -1.959567966999941],
              [124.36622155000009, -1.971286716999941],
              [124.37208092500009, -1.992608330999929],
              [124.37029056100005, -2.038995049999926],
              [124.35840905000009, -2.033298434999949],
              [124.33472741000003, -2.004978122999944],
              [124.32545006600003, -2.001153252999927],
              [124.31421959700003, -1.999444268999923],
              [124.30469811300009, -1.996026299999926],
              [124.30062910200002, -1.987481377999927],
              [124.30567467500009, -1.973402601999908],
              [124.31812584700003, -1.963962497999944],
              [124.33383222700002, -1.959242445999962],
              [124.34888756600003, -1.959567966999941],
            ],
          ],
          [
            [
              [123.65699303500003, -1.909356377999927],
              [123.664398634, -1.94890715899993],
              [123.66382897200003, -1.963311455999929],
              [123.65699303500003, -1.963311455999929],
              [123.65162194100003, -1.949395440999922],
              [123.64958743600005, -1.934177341999941],
              [123.64958743600005, -1.901788018999923],
              [123.65699303500003, -1.901788018999923],
              [123.65699303500003, -1.909356377999927],
            ],
          ],
          [
            [
              [123.73804772200003, -1.90789153399993],
              [123.73951256600003, -1.915948174999926],
              [123.74634850400003, -1.929131768999923],
              [123.74577884200005, -1.935967705999929],
              [123.74048912900003, -1.940524997999944],
              [123.71168053500003, -1.957126559999949],
              [123.70557701900009, -1.933770440999922],
              [123.71290123800009, -1.911716403999947],
              [123.72608483200008, -1.899997653999947],
              [123.73804772200003, -1.90789153399993],
            ],
          ],
          [
            [
              [108.67725670700003, -1.713799737999921],
              [108.69141686300003, -1.699151299999926],
              [108.72315514400003, -1.693617445999962],
              [108.75709069100003, -1.695407809999949],
              [108.77808678500003, -1.702732028999947],
              [108.75879967500003, -1.717461846999925],
              [108.72461998800003, -1.719414971999925],
              [108.67725670700003, -1.713799737999921],
            ],
          ],
          [
            [
              [127.37110436300009, -1.367445570999962],
              [127.38135826900009, -1.397067966999941],
              [127.37875410200002, -1.405450127999927],
              [127.36117597700002, -1.408379815999922],
              [127.34782962300005, -1.412774346999925],
              [127.32667076900009, -1.431817315999922],
              [127.31666100400003, -1.436293226999908],
              [127.28419030000009, -1.425388278999947],
              [127.28581790500004, -1.400323174999926],
              [127.30453535200002, -1.377699476999908],
              [127.32349694100003, -1.37428150799991],
              [127.32545006600003, -1.36882903399993],
              [127.32740319100003, -1.365411065999922],
              [127.32886803500003, -1.361260674999926],
              [127.33025149800005, -1.353773695999962],
              [127.33708743600005, -1.353773695999962],
              [127.34571373800009, -1.365655205999929],
              [127.35417728000004, -1.365329684999949],
              [127.36255944100003, -1.36256275799991],
              [127.37110436300009, -1.367445570999962],
            ],
          ],
          [
            [
              [109.17017662900003, -1.257582289999959],
              [109.18189537900003, -1.266208591999941],
              [109.17693118600005, -1.278497002999927],
              [109.14421634200005, -1.311455987999921],
              [109.13851972700007, -1.31414153399993],
              [109.13599694100003, -1.309177341999941],
              [109.13379967500003, -1.297133070999962],
              [109.12842858200003, -1.29656340899993],
              [109.12159264400003, -1.299899997999944],
              [109.11491946700005, -1.29851653399993],
              [109.11573326900003, -1.303887627999927],
              [109.10824629000007, -1.304457289999959],
              [109.10075931100005, -1.300551039999959],
              [109.10132897200003, -1.292413018999923],
              [109.10792076900003, -1.284600518999923],
              [109.11475670700003, -1.280205987999921],
              [109.12281334700003, -1.278497002999927],
              [109.13257897200003, -1.278008721999925],
              [109.14372806100005, -1.273532809999949],
              [109.16130618600005, -1.256605726999908],
              [109.17017662900003, -1.257582289999959],
            ],
          ],
          [
            [
              [109.25464928500003, -1.169366143999923],
              [109.26490319100003, -1.174981377999927],
              [109.26514733200003, -1.187920830999929],
              [109.25977623800003, -1.202243747999944],
              [109.25294030000003, -1.212497653999947],
              [109.24577884200005, -1.217868747999944],
              [109.23414147200003, -1.224541924999926],
              [109.22339928500003, -1.227146091999941],
              [109.21851647200003, -1.22039153399993],
              [109.21851647200003, -1.206638278999947],
              [109.21998131600003, -1.198011976999908],
              [109.22388756600003, -1.191338799999926],
              [109.24244225400003, -1.174411716999941],
              [109.24870853000004, -1.170830987999921],
              [109.25464928500003, -1.169366143999923],
            ],
          ],
          [
            [
              [104.47999108200003, -0.271254164999959],
              [104.48780358200003, -0.274102471999925],
              [104.49366295700003, -0.281182549999926],
              [104.49708092500003, -0.289971612999921],
              [104.49708092500003, -0.298597914999959],
              [104.49252363400007, -0.308770440999922],
              [104.48650149800005, -0.310723565999922],
              [104.47885175900007, -0.309991143999923],
              [104.46957441500007, -0.312269789999959],
              [104.45622806100005, -0.318617445999962],
              [104.44613691500007, -0.320082289999959],
              [104.41822350400008, -0.318536065999922],
              [104.40650475400008, -0.31178150799991],
              [104.40088951900003, -0.297295830999929],
              [104.40495853000004, -0.283379815999922],
              [104.42123457100007, -0.278090101999908],
              [104.47999108200003, -0.271254164999959],
            ],
          ],
          [
            [
              [102.83912194100003, 0.290961005000042],
              [102.85450280000003, 0.303168036000045],
              [102.88453209700003, 0.315252997000073],
              [102.91391035200007, 0.320257880000042],
              [102.92725670700003, 0.31085846600007],
              [102.90772545700003, 0.298529364000046],
              [102.87533613400007, 0.284084377000056],
              [102.84701582100007, 0.27806224200009],
              [102.83912194100003, 0.290961005000042],
            ],
          ],
          [
            [
              [103.07960045700003, 0.624416408000059],
              [103.08432050900007, 0.608547268000052],
              [103.08545983200003, 0.600083726000094],
              [103.08497155000003, 0.592027085000041],
              [103.08139082100007, 0.579291083000044],
              [103.07699629000007, 0.574774481000077],
              [103.07146243600005, 0.577215887000079],
              [103.06446373800003, 0.585191148000092],
              [103.05787194100003, 0.596380927000041],
              [103.04566491000003, 0.627834377000056],
              [103.04330488400007, 0.640448309000078],
              [103.04086347700007, 0.646714585000041],
              [103.03728274800005, 0.65265534100007],
              [103.03663170700003, 0.657538153000075],
              [103.04330488400007, 0.660956122000073],
              [103.05543053500003, 0.658677476000094],
              [103.06576582100007, 0.649237372000073],
              [103.07398522200003, 0.636460679000038],
              [103.07960045700003, 0.624416408000059],
            ],
          ],
          [
            [
              [103.50635826900003, 0.70189036700009],
              [103.51742597700007, 0.698431708000044],
              [103.52182050900007, 0.689846096000053],
              [103.52133222700007, 0.678656317000048],
              [103.51791425900007, 0.667629299000055],
              [103.50611412900008, 0.640773830000057],
              [103.49789472700007, 0.627020575000074],
              [103.48902428500003, 0.619940497000073],
              [103.47201582100007, 0.622992255000042],
              [103.46924889400003, 0.637396552000041],
              [103.47388756600003, 0.653469143000052],
              [103.47901451900003, 0.660956122000073],
              [103.48585045700003, 0.667385158000059],
              [103.49952233200003, 0.695502020000049],
              [103.50635826900003, 0.70189036700009],
            ],
          ],
          [
            [
              [103.11280358200003, 0.792954820000091],
              [103.12094160200007, 0.779974677000041],
              [103.11622155000003, 0.757757880000042],
              [103.10450280000003, 0.735419012000079],
              [103.09229576900003, 0.722357489000046],
              [103.08627363400007, 0.724676825000074],
              [103.08082116000003, 0.734279690000051],
              [103.07715905000003, 0.745510158000059],
              [103.07585696700005, 0.752834377000056],
              [103.07715905000003, 0.760891018000052],
              [103.08025149800005, 0.768622137000079],
              [103.08472741000003, 0.77570221600007],
              [103.09457441500007, 0.786037502000056],
              [103.10035241000003, 0.790187893000052],
              [103.10661868600005, 0.792954820000091],
              [103.11280358200003, 0.792954820000091],
            ],
          ],
          [
            [
              [104.56462649800005, 0.798163153000075],
              [104.60564212300005, 0.793890692000048],
              [104.62159264400003, 0.78742096600007],
              [104.62045332100007, 0.777044989000046],
              [104.61353600400008, 0.765855210000041],
              [104.60189863400007, 0.764349677000041],
              [104.57203209700003, 0.770819403000075],
              [104.55396569100003, 0.770697333000044],
              [104.54102623800003, 0.766587632000039],
              [104.51124108200003, 0.75031159100007],
              [104.51189212300005, 0.77374909100007],
              [104.52344811300003, 0.788397528000075],
              [104.54232832100007, 0.795884507000039],
              [104.56462649800005, 0.798163153000075],
            ],
          ],
          [
            [
              [103.66773522200003, 0.839667059000078],
              [103.70264733200003, 0.814154364000046],
              [103.71810957100007, 0.798081773000092],
              [103.72730553500003, 0.779852606000077],
              [103.72486412900008, 0.766506252000056],
              [103.71338951900003, 0.76243724200009],
              [103.70093834700003, 0.765692450000074],
              [103.69507897200003, 0.773911851000094],
              [103.68881269600007, 0.79165273600006],
              [103.66651451900003, 0.823635158000059],
              [103.66773522200003, 0.839667059000078],
            ],
          ],
          [
            [
              [103.46216881600003, 0.918931382000039],
              [103.47266686300003, 0.90884023600006],
              [103.47950280000003, 0.893622137000079],
              [103.47934004000007, 0.878851630000042],
              [103.46900475400008, 0.869614976000094],
              [103.45826256600003, 0.869696356000077],
              [103.44467207100007, 0.873602606000077],
              [103.43295332100007, 0.880682684000078],
              [103.42807050900007, 0.890041408000059],
              [103.42156009200005, 0.896714585000041],
              [103.41041100400008, 0.904730536000045],
              [103.40707441500007, 0.911444403000075],
              [103.45346113400007, 0.92055898600006],
              [103.46216881600003, 0.918931382000039],
            ],
          ],
          [
            [
              [120.64918053500003, 1.072455145000049],
              [120.65992272200003, 1.067613023000092],
              [120.66871178500003, 1.061021226000094],
              [120.68336022200003, 1.044582424000055],
              [120.66716556100005, 1.043117580000057],
              [120.63209069100003, 1.068508205000057],
              [120.60759524800005, 1.072455145000049],
              [120.617523634, 1.07680898600006],
              [120.62826582100001, 1.07884349200009],
              [120.63917076900009, 1.07758209800005],
              [120.64918053500003, 1.072455145000049],
            ],
          ],
          [
            [
              [120.37761478000004, 1.079901434000078],
              [120.39242597700002, 1.086086330000057],
              [120.40235436300009, 1.077215887000079],
              [120.40650475400003, 1.060980536000045],
              [120.40398196700005, 1.044867255000042],
              [120.39966881600003, 1.037502346000053],
              [120.39372806100005, 1.030747789000088],
              [120.38624108200008, 1.025946356000077],
              [120.37794030000009, 1.02407461100006],
              [120.36866295700008, 1.031724351000094],
              [120.36768639400009, 1.049221096000053],
              [120.37159264400009, 1.068019924000055],
              [120.37761478000004, 1.079901434000078],
            ],
          ],
          [
            [
              [119.84652754000001, -0.874607028999947],
              [119.86231530000009, -0.834161065999922],
              [119.86589603000004, -0.813571872999944],
              [119.86719811300009, -0.78834400799991],
              [119.86500084700003, -0.78289153399993],
              [119.85613040500004, -0.769138278999947],
              [119.85401451900009, -0.76100025799991],
              [119.85523522200003, -0.727146091999941],
              [119.85401451900009, -0.716403903999947],
              [119.84693444100003, -0.701267184999949],
              [119.82406660200002, -0.67506275799991],
              [119.81934655000009, -0.665459893999923],
              [119.81576582100001, -0.653415622999944],
              [119.79200280000009, -0.60711028399993],
              [119.78248131600003, -0.569105726999908],
              [119.77833092500009, -0.535088799999926],
              [119.77540123800009, -0.522637627999927],
              [119.76156660200002, -0.490655205999929],
              [119.75782311300009, -0.469903252999927],
              [119.78109785200002, -0.239353122999944],
              [119.79053795700008, -0.208754164999959],
              [119.80225670700008, -0.195570570999962],
              [119.80836022200003, -0.182793877999927],
              [119.80640709700003, -0.15398528399993],
              [119.79997806100005, -0.123793226999908],
              [119.79200280000009, -0.10678476399994],
              [119.76254316500001, -0.119480075999945],
              [119.73047936300009, -0.121351820999962],
              [119.69996178500003, -0.114108981999948],
              [119.67530358200008, -0.099379164999959],
              [119.65756269600001, -0.080132744999958],
              [119.63868248800009, -0.050876559999949],
              [119.62769616000003, -0.018365166999956],
              [119.63445071700005, 0.01048411700009],
              [119.65064537900003, 0.001613674000055],
              [119.65943444100003, -0.001519463999955],
              [119.66846764400009, -0.003838799999926],
              [119.66797936300009, 0.007025458000044],
              [119.66895592500009, 0.01626211100006],
              [119.67139733200008, 0.023993231000077],
              [119.67530358200008, 0.030340887000079],
              [119.69809004000001, 0.016913153000075],
              [119.71583092500009, 0.001532294000071],
              [119.74415123800009, -0.031101169999943],
              [119.76587975400003, -0.063246351999908],
              [119.77833092500009, -0.076348565999922],
              [119.79883873800009, -0.085707289999959],
              [119.81641686300009, -0.090020440999922],
              [119.82593834700003, -0.089939059999949],
              [119.83269290500004, -0.084405205999929],
              [119.84717858200008, -0.061578057999952],
              [119.85678144600001, -0.041029554999909],
              [119.87794030000009, 0.045477606000077],
              [119.88819420700008, 0.071275132000039],
              [119.86980228000004, 0.105658270000049],
              [119.79395592500009, 0.196600653000075],
              [119.78785241000003, 0.208400783000059],
              [119.78565514400009, 0.221096096000053],
              [119.78516686300009, 0.239488023000092],
              [119.79444420700008, 0.250189520000049],
              [119.85401451900009, 0.269924221000053],
              [119.869476759, 0.287176825000074],
              [119.86768639400009, 0.302069403000075],
              [119.85914147200003, 0.318915106000077],
              [119.85401451900009, 0.342230536000045],
              [119.85873457100001, 0.364243882000039],
              [119.88355553500003, 0.400051174000055],
              [119.89503014400009, 0.420721747000073],
              [119.89730879000001, 0.431138414000088],
              [119.89844811300009, 0.451605536000045],
              [119.90186608200008, 0.461737372000073],
              [119.91179446700005, 0.473700262000079],
              [119.92383873800009, 0.480861721000053],
              [119.93620853000004, 0.486395575000074],
              [119.94654381600003, 0.493353583000044],
              [119.96461022200003, 0.501125393000052],
              [120.01246178500003, 0.504787502000056],
              [120.03223717500009, 0.516302802000041],
              [120.04517662900003, 0.549994208000044],
              [120.04037519600001, 0.588120835000041],
              [120.029633009, 0.628119208000044],
              [120.02475019600001, 0.667181708000044],
              [120.02751712300005, 0.68891022300005],
              [120.03419030000009, 0.713812567000048],
              [120.04574629000001, 0.734361070000091],
              [120.062836134, 0.742865302000041],
              [120.07227623800009, 0.744045315000051],
              [120.09742272200003, 0.75031159100007],
              [120.11052493600005, 0.75141022300005],
              [120.12086022200003, 0.754339911000045],
              [120.18653405000009, 0.784002997000073],
              [120.20728600400003, 0.79759349200009],
              [120.22706139400009, 0.814886786000045],
              [120.23552493600005, 0.831529039000088],
              [120.24708092500009, 0.933294989000046],
              [120.25652103000004, 0.968898830000057],
              [120.27849368600005, 0.994208075000074],
              [120.31959069100003, 0.996079820000091],
              [120.34164472700002, 0.982855536000045],
              [120.34669030000009, 0.963080145000049],
              [120.34009850400003, 0.917914130000042],
              [120.34034264400009, 0.872381903000075],
              [120.34644616000003, 0.855617580000057],
              [120.36182701900009, 0.866400458000044],
              [120.36736087300005, 0.866400458000044],
              [120.37525475400003, 0.848700262000079],
              [120.387054884, 0.833929755000042],
              [120.40284264400009, 0.82172272300005],
              [120.42204837300005, 0.811753648000092],
              [120.45337975400003, 0.805080471000053],
              [120.46957441500001, 0.796820380000042],
              [120.47681725400003, 0.800970770000049],
              [120.48267662900003, 0.80805084800005],
              [120.48780358200008, 0.811753648000092],
              [120.51148522200003, 0.810614325000074],
              [120.52759850400003, 0.806057033000059],
              [120.54102623800009, 0.796576239000046],
              [120.55640709700003, 0.780747789000088],
              [120.56812584700003, 0.782131252000056],
              [120.58472741000003, 0.797552802000041],
              [120.61443118600005, 0.832220770000049],
              [120.60222415500004, 0.855698960000041],
              [120.61784915500004, 0.898586330000057],
              [120.66228274800005, 0.968817450000074],
              [120.68336022200003, 0.991929429000038],
              [120.69019616000003, 0.996079820000091],
              [120.699554884, 0.992377020000049],
              [120.71094811300009, 0.983465887000079],
              [120.72266686300009, 0.976752020000049],
              [120.73389733200008, 0.979681708000044],
              [120.74000084700003, 0.989162502000056],
              [120.74756920700008, 1.010565497000073],
              [120.754242384, 1.020656643000052],
              [120.76303144600001, 1.02602773600006],
              [120.78370201900009, 1.03196849200009],
              [120.79249108200008, 1.03774648600006],
              [120.80176842500009, 1.052639065000051],
              [120.80323326900009, 1.068426825000074],
              [120.79867597700002, 1.130845445000091],
              [120.79948978000004, 1.142075914000088],
              [120.80250084700003, 1.146958726000094],
              [120.80250084700003, 1.152044989000046],
              [120.80909264400009, 1.162787177000041],
              [120.81690514400009, 1.172674872000073],
              [120.81983483200008, 1.174872137000079],
              [120.82593834700003, 1.196682033000059],
              [120.82764733200008, 1.214016018000052],
              [120.82667076900009, 1.253729559000078],
              [120.81967207100001, 1.290920315000051],
              [120.82081139400009, 1.31000397300005],
              [120.83350670700008, 1.325669664000088],
              [120.84302819100003, 1.328314520000049],
              [120.86459394600001, 1.325140692000048],
              [120.87452233200008, 1.325669664000088],
              [120.88445071700005, 1.330633856000077],
              [120.90919030000009, 1.353664455000057],
              [120.90609785200002, 1.324286200000074],
              [120.908539259, 1.311428127000056],
              [120.91920006600003, 1.31517161700009],
              [120.93848717500009, 1.337225653000075],
              [120.94947350400003, 1.343817450000074],
              [120.96729576900009, 1.346177476000094],
              [121.06120853000004, 1.327093817000048],
              [121.080414259, 1.331935940000051],
              [121.13379967500009, 1.314601955000057],
              [121.15870201900009, 1.302801825000074],
              [121.18279056100005, 1.271429755000042],
              [121.26490319100003, 1.229559637000079],
              [121.31763756600003, 1.253851630000042],
              [121.33716881600003, 1.256822007000039],
              [121.38168379000001, 1.256659247000073],
              [121.39909915500004, 1.262396552000041],
              [121.42253665500004, 1.277289130000042],
              [121.44166100400003, 1.294582424000055],
              [121.45142662900003, 1.297552802000041],
              [121.46412194100003, 1.291571356000077],
              [121.46949303500003, 1.282863674000055],
              [121.47201582100001, 1.269924221000053],
              [121.47152754000001, 1.25657786700009],
              [121.46753991000003, 1.246893622000073],
              [121.45948326900009, 1.242661851000094],
              [121.43506920700008, 1.235296942000048],
              [121.430023634, 1.232977606000077],
              [121.43140709700003, 1.22601959800005],
              [121.43962649800005, 1.212103583000044],
              [121.44361412900003, 1.202215887000079],
              [121.44507897200003, 1.193345445000091],
              [121.44459069100003, 1.186835028000075],
              [121.44556725400003, 1.179185289000088],
              [121.45045006600003, 1.16742584800005],
              [121.46843509200005, 1.146307684000078],
              [121.47095787900003, 1.13703034100007],
              [121.48072350400003, 1.120917059000078],
              [121.52857506600003, 1.083238023000092],
              [121.54672285200002, 1.072455145000049],
              [121.58676191500001, 1.061753648000092],
              [121.63086998800009, 1.06195709800005],
              [121.926117384, 1.098700262000079],
              [121.94320722700002, 1.091131903000075],
              [121.95582116000003, 1.04555898600006],
              [121.97022545700008, 1.029486395000049],
              [121.99024498800009, 1.021918036000045],
              [122.01221764400009, 1.02407461100006],
              [122.02719160200002, 1.034002997000073],
              [122.04883873800009, 1.059759833000044],
              [122.06373131600003, 1.065008856000077],
              [122.08773847700002, 1.061590887000079],
              [122.14942467500009, 1.03774648600006],
              [122.17790774800005, 1.035630601000094],
              [122.19092858200008, 1.031480210000041],
              [122.19735761800007, 1.02765534100007],
              [122.22282962300005, 1.01235586100006],
              [122.23536217500009, 1.009833075000074],
              [122.24537194100003, 1.010931708000044],
              [122.26465905000009, 1.016058661000045],
              [122.27621504000001, 1.017279364000046],
              [122.28142337300005, 1.016058661000045],
              [122.29070071700005, 1.010931708000044],
              [122.29672285200002, 1.009833075000074],
              [122.29981530000009, 1.011786200000074],
              [122.30827884200005, 1.021185614000046],
              [122.31373131600003, 1.02407461100006],
              [122.32829837300005, 1.024359442000048],
              [122.37598717500009, 1.009833075000074],
              [122.39551842500009, 1.010972398000092],
              [122.441742384, 1.021673895000049],
              [122.45411217500009, 1.020656643000052],
              [122.48560631600003, 0.995998440000051],
              [122.52418053500003, 0.979966539000088],
              [122.56519616000003, 0.971380927000041],
              [122.62378991000003, 0.966376044000071],
              [122.64527428500003, 0.959173895000049],
              [122.66285241000003, 0.947414455000057],
              [122.67017662900003, 0.931301174000055],
              [122.67937259200005, 0.918850002000056],
              [122.70045006600003, 0.908189195000091],
              [122.73902428500003, 0.893744208000044],
              [122.74691816500001, 0.886664130000042],
              [122.75114993600005, 0.880072333000044],
              [122.75684655000009, 0.875148830000057],
              [122.76970462300005, 0.873236395000049],
              [122.77881920700008, 0.870062567000048],
              [122.78101647200003, 0.855902411000045],
              [122.80600019600001, 0.847845770000049],
              [122.83073978000004, 0.82493724200009],
              [122.84888756600003, 0.818019924000055],
              [122.88990319100003, 0.848211981000077],
              [122.90699303500003, 0.852728583000044],
              [122.91846764400009, 0.859564520000049],
              [122.93824303500003, 0.907416083000044],
              [122.94304446700005, 0.912502346000053],
              [122.95386803500003, 0.921454169000071],
              [122.95818118600005, 0.927883205000057],
              [122.95818118600005, 0.945746161000045],
              [122.96078535200002, 0.957261460000041],
              [122.96802819100003, 0.962591864000046],
              [122.99089603000004, 0.961859442000048],
              [123.00505618600005, 0.959458726000094],
              [123.07129967500009, 0.934759833000044],
              [123.09571373800009, 0.928900458000044],
              [123.09725996200007, 0.92914459800005],
              [123.11207116000003, 0.931301174000055],
              [123.13445071700005, 0.93891022300005],
              [123.17562910200002, 0.922552802000041],
              [123.19092858200008, 0.927883205000057],
              [123.18669681100005, 0.938177802000041],
              [123.18238366000003, 0.960109768000052],
              [123.18669681100005, 0.973618882000039],
              [123.20785566500001, 0.958889065000051],
              [123.22575931100005, 0.94953034100007],
              [123.25489342500009, 0.960679429000038],
              [123.27344811300009, 0.948919989000046],
              [123.27833092500009, 0.938788153000075],
              [123.27906334700003, 0.929836330000057],
              [123.28207441500001, 0.921779690000051],
              [123.29395592500009, 0.914211330000057],
              [123.30396569100003, 0.912298895000049],
              [123.33130944100003, 0.91282786700009],
              [123.34180748800009, 0.914211330000057],
              [123.35206139400009, 0.918158270000049],
              [123.35962975400003, 0.923407294000071],
              [123.36866295700008, 0.927435614000046],
              [123.38331139400009, 0.927883205000057],
              [123.39112389400009, 0.923814195000091],
              [123.39714603000004, 0.917873440000051],
              [123.40495853000004, 0.915350653000075],
              [123.41732832100001, 0.921616929000038],
              [123.44507897200003, 0.90298086100006],
              [123.51978600400003, 0.886623440000051],
              [123.55054772200003, 0.869818427000041],
              [123.56299889400009, 0.866929429000038],
              [123.59669030000009, 0.881822007000039],
              [123.61231530000009, 0.886216539000088],
              [123.63200931100005, 0.881659247000073],
              [123.67212975400003, 0.859930731000077],
              [123.69117272200003, 0.852728583000044],
              [123.83179772200003, 0.832220770000049],
              [123.90040123800009, 0.839667059000078],
              [123.90992272200003, 0.837876695000091],
              [123.92920983200008, 0.831529039000088],
              [123.93751061300009, 0.832220770000049],
              [123.94792728000004, 0.838934637000079],
              [123.95142662900003, 0.846136786000045],
              [123.94809004000001, 0.853013414000088],
              [123.93751061300009, 0.858954169000071],
              [123.95240319100003, 0.867987372000073],
              [123.99170983200008, 0.880682684000078],
              [124.00806725400003, 0.898179429000038],
              [124.12029056100005, 0.939113674000055],
              [124.15300540500004, 0.94594961100006],
              [124.16667728000004, 0.956935940000051],
              [124.19076582100001, 0.983099677000041],
              [124.22364342500009, 0.998724677000041],
              [124.29037519600001, 1.017320054000038],
              [124.31495201900009, 1.03774648600006],
              [124.32976321700005, 1.070542710000041],
              [124.34652754000001, 1.139634507000039],
              [124.36280358200008, 1.16742584800005],
              [124.37403405000009, 1.177069403000075],
              [124.38941491000003, 1.186102606000077],
              [124.40772545700008, 1.192775783000059],
              [124.42790774800005, 1.195379950000074],
              [124.49431399800005, 1.192206122000073],
              [124.51417076900009, 1.195379950000074],
              [124.52344811300009, 1.201239325000074],
              [124.52955162900003, 1.208685614000046],
              [124.53663170700008, 1.214667059000078],
              [124.54835045700008, 1.215806382000039],
              [124.55600019600001, 1.210598049000055],
              [124.56072024800005, 1.201076565000051],
              [124.56690514400009, 1.19204336100006],
              [124.57911217500009, 1.187892971000053],
              [124.59376061300009, 1.195868231000077],
              [124.60678144600001, 1.214789130000042],
              [124.61500084700003, 1.237534898000092],
              [124.61597741000003, 1.256822007000039],
              [124.60645592500009, 1.273342190000051],
              [124.59083092500009, 1.278794664000088],
              [124.55144290500004, 1.277289130000042],
              [124.53443444100003, 1.288641669000071],
              [124.53296959700003, 1.314520575000074],
              [124.53980553500003, 1.34243398600006],
              [124.54835045700008, 1.359849351000094],
              [124.60181725400003, 1.400132554000038],
              [124.609711134, 1.410711981000077],
              [124.62037194100003, 1.417141018000052],
              [124.691742384, 1.401434637000079],
              [124.71729576900009, 1.405829169000071],
              [124.73243248800009, 1.415676174000055],
              [124.75660241000003, 1.445217190000051],
              [124.77418053500003, 1.455226955000057],
              [124.81576582100001, 1.460598049000055],
              [124.83570397200003, 1.469142971000053],
              [124.85043379000001, 1.48969147300005],
              [124.84392337300005, 1.50853099200009],
              [124.82984459700003, 1.527533270000049],
              [124.82203209700003, 1.548529364000046],
              [124.82593834700003, 1.57290273600006],
              [124.83692467500009, 1.588853257000039],
              [124.93653405000009, 1.665594794000071],
              [124.94556725400003, 1.678290106000077],
              [124.94988040500004, 1.682603257000039],
              [124.96859785200002, 1.673814195000091],
              [124.97291100400003, 1.678290106000077],
              [124.97095787900003, 1.71320221600007],
              [124.97291100400003, 1.72296784100007],
              [124.98389733200008, 1.731594143000052],
              [125.00473066500001, 1.741034247000073],
              [125.02515709700003, 1.744126695000091],
              [125.03443444100003, 1.733465887000079],
              [125.03492272200003, 1.69204336100006],
              [125.04273522200003, 1.680568752000056],
              [125.06169681100005, 1.67454661700009],
              [125.08171634200005, 1.674383856000077],
              [125.14763431100005, 1.682033596000053],
              [125.17530358200008, 1.678168036000045],
              [125.17994225400003, 1.66742584800005],
              [125.16529381600003, 1.627346096000053],
              [125.16781660200002, 1.584784247000073],
              [125.187836134, 1.560532945000091],
              [125.215179884, 1.543931382000039],
              [125.23975670700008, 1.523667710000041],
              [125.24919681100005, 1.48468659100007],
              [125.22022545700008, 1.459051825000074],
              [125.17701256600003, 1.44017161700009],
              [125.14429772200003, 1.42133209800005],
              [125.11540774800005, 1.385199286000045],
              [125.09620201900009, 1.349514065000051],
              [125.03370201900009, 1.175441799000055],
              [124.98658287900003, 1.092962958000044],
              [124.95427493600005, 1.053534247000073],
              [124.92115319100003, 1.020656643000052],
              [124.91627037900003, 1.013006903000075],
              [124.90593509200005, 0.988104559000078],
              [124.90398196700005, 0.979681708000044],
              [124.89869225400003, 0.973049221000053],
              [124.86304772200003, 0.955145575000074],
              [124.83082116000003, 0.946437893000052],
              [124.82203209700003, 0.941473700000074],
              [124.81446373800009, 0.931708075000074],
              [124.79900149800005, 0.905747789000088],
              [124.79102623800009, 0.900580145000049],
              [124.76644941500001, 0.895005601000094],
              [124.74634850400003, 0.881252346000053],
              [124.71216881600003, 0.845282294000071],
              [124.67872155000009, 0.820379950000074],
              [124.66382897200003, 0.805609442000048],
              [124.65430748800009, 0.778021552000041],
              [124.63982181100005, 0.75844961100006],
              [124.63648522200003, 0.746649481000077],
              [124.63672936300009, 0.731756903000075],
              [124.63607832100001, 0.725083726000094],
              [124.62403405000009, 0.708156643000052],
              [124.58790123800009, 0.676988023000092],
              [124.57935631600003, 0.658189195000091],
              [124.57325280000009, 0.649115302000041],
              [124.56934655000009, 0.638861395000049],
              [124.57211347700002, 0.629584052000041],
              [124.57935631600003, 0.621039130000042],
              [124.58220462300005, 0.613755601000094],
              [124.58253014400009, 0.595445054000038],
              [124.57789147200003, 0.591620184000078],
              [124.55632571700005, 0.592962958000044],
              [124.54835045700008, 0.592027085000041],
              [124.54411868600005, 0.587713934000078],
              [124.50342858200008, 0.534002997000073],
              [124.49976647200003, 0.518540757000039],
              [124.51417076900009, 0.51007721600007],
              [124.51417076900009, 0.503322658000059],
              [124.49480228000004, 0.496283270000049],
              [124.48292076900009, 0.482896226000094],
              [124.46583092500009, 0.44867584800005],
              [124.43897545700008, 0.456447658000059],
              [124.41456139400009, 0.448146877000056],
              [124.39258873800009, 0.43500397300005],
              [124.37330162900003, 0.428168036000045],
              [124.34929446700005, 0.422796942000048],
              [124.32178795700008, 0.398871161000045],
              [124.19971764400009, 0.374090887000079],
              [124.15056399800005, 0.36985911700009],
              [124.10938561300009, 0.387193101000094],
              [124.09734134200005, 0.37962474200009],
              [124.06853274800005, 0.35187409100007],
              [124.041351759, 0.359198309000078],
              [124.03386478000004, 0.359320380000042],
              [124.02393639400009, 0.354437567000048],
              [124.00611412900003, 0.341457424000055],
              [123.99626712300005, 0.338812567000048],
              [123.93140709700003, 0.33624909100007],
              [123.91089928500003, 0.332017320000091],
              [123.86931399800005, 0.318304755000042],
              [123.85889733200008, 0.31704336100006],
              [123.82496178500003, 0.318304755000042],
              [123.80730228000004, 0.31085846600007],
              [123.79053795700008, 0.301255601000094],
              [123.78199303500003, 0.298570054000038],
              [123.77051842500009, 0.302069403000075],
              [123.75806725400003, 0.307521877000056],
              [123.74577884200005, 0.31085846600007],
              [123.72461998800009, 0.308823960000041],
              [123.68970787900003, 0.294501044000071],
              [123.65650475400003, 0.288275458000044],
              [123.64698326900009, 0.281642971000053],
              [123.63249759200005, 0.266506252000056],
              [123.62598717500009, 0.266587632000039],
              [123.61646569100003, 0.272040106000077],
              [123.58423912900003, 0.29759349200009],
              [123.57105553500003, 0.303615627000056],
              [123.46631920700008, 0.312323309000078],
              [123.44467207100001, 0.31085846600007],
              [123.40723717500009, 0.300441799000055],
              [123.39014733200008, 0.297837632000039],
              [123.29200280000009, 0.308335679000038],
              [123.25912519600001, 0.320868231000077],
              [123.24610436300009, 0.322088934000078],
              [123.23878014400009, 0.32453034100007],
              [123.23503665500004, 0.328924872000073],
              [123.22706139400009, 0.342678127000056],
              [123.22193444100003, 0.345648505000042],
              [123.21558678500003, 0.352769273000092],
              [123.19092858200008, 0.390326239000046],
              [123.18669681100005, 0.393866278000075],
              [123.16773522200003, 0.393052476000094],
              [123.16358483200008, 0.39679596600007],
              [123.16179446700005, 0.401353257000039],
              [123.13257897200003, 0.44757721600007],
              [123.08936608200008, 0.494289455000057],
              [123.07422936300009, 0.516302802000041],
              [123.06739342500009, 0.516302802000041],
              [123.05404707100001, 0.500962632000039],
              [123.03248131600003, 0.491359768000052],
              [122.97787519600001, 0.482814846000053],
              [122.83073978000004, 0.492336330000057],
              [122.73829186300009, 0.481675523000092],
              [122.69410241000003, 0.482814846000053],
              [122.68230228000004, 0.48859284100007],
              [122.66293379000001, 0.515692450000074],
              [122.64966881600003, 0.523830471000053],
              [122.65552819100003, 0.492865302000041],
              [122.65316816500001, 0.480414130000042],
              [122.63941491000003, 0.47532786700009],
              [122.62224368600005, 0.476548570000091],
              [122.60808353000004, 0.480861721000053],
              [122.59685306100005, 0.489447333000044],
              [122.58301842500009, 0.494330145000049],
              [122.56592858200008, 0.496527411000045],
              [122.32439212300005, 0.497056382000039],
              [122.31251061300009, 0.49485911700009],
              [122.29314212300005, 0.485052802000041],
              [122.28345787900003, 0.482814846000053],
              [122.20720462300005, 0.48383209800005],
              [122.19711347700002, 0.482814846000053],
              [122.18832441500001, 0.479681708000044],
              [122.17286217500009, 0.470933335000041],
              [122.166351759, 0.469183661000045],
              [122.14454186300009, 0.471258856000077],
              [122.10425866000003, 0.480698960000041],
              [122.03777103000004, 0.482123114000046],
              [122.01970462300005, 0.477118231000077],
              [122.00416100400003, 0.454901434000078],
              [121.98511803500003, 0.448431708000044],
              [121.892914259, 0.435451565000051],
              [121.84083092500009, 0.434393622000073],
              [121.80046634200005, 0.426459052000041],
              [121.78630618600005, 0.428168036000045],
              [121.77947024800005, 0.433172919000071],
              [121.73259524800005, 0.499945380000042],
              [121.71550540500004, 0.51508209800005],
              [121.69011478000004, 0.523830471000053],
              [121.67644290500004, 0.523260809000078],
              [121.64503014400009, 0.517157294000071],
              [121.63599694100003, 0.516302802000041],
              [121.62378991000003, 0.522528387000079],
              [121.61736087300005, 0.531317450000074],
              [121.611664259, 0.541408596000053],
              [121.601898634, 0.551743882000039],
              [121.59669030000009, 0.539007880000042],
              [121.58773847700002, 0.532863674000055],
              [121.57447350400003, 0.530747789000088],
              [121.55665123800009, 0.530585028000075],
              [121.54460696700005, 0.533677476000094],
              [121.53589928500003, 0.538397528000075],
              [121.52833092500009, 0.53742096600007],
              [121.51872806100005, 0.523830471000053],
              [121.51490319100003, 0.51040273600006],
              [121.51270592500009, 0.497056382000039],
              [121.50782311300009, 0.486802476000094],
              [121.49512780000009, 0.482814846000053],
              [121.47852623800009, 0.482082424000055],
              [121.46534264400009, 0.479641018000052],
              [121.45411217500009, 0.47532786700009],
              [121.44361412900003, 0.469183661000045],
              [121.42676842500009, 0.482367255000042],
              [121.41334069100003, 0.483099677000041],
              [121.39698326900009, 0.478461005000042],
              [121.36133873800009, 0.473211981000077],
              [121.34205162900003, 0.463853257000039],
              [121.33033287900003, 0.461737372000073],
              [121.31967207100001, 0.464748440000051],
              [121.29639733200008, 0.478583075000074],
              [121.28589928500003, 0.482814846000053],
              [121.26059004000001, 0.482489325000074],
              [121.22046959700003, 0.465969143000052],
              [121.20020592500009, 0.461737372000073],
              [121.17969811300009, 0.461004950000074],
              [121.16382897200003, 0.457464911000045],
              [121.14991295700008, 0.449286200000074],
              [121.135101759, 0.434393622000073],
              [121.12501061300009, 0.417629299000055],
              [121.11915123800009, 0.411444403000075],
              [121.10792076900009, 0.407131252000056],
              [121.09913170700008, 0.407375393000052],
              [121.06316165500004, 0.413967190000051],
              [121.04737389400009, 0.418931382000039],
              [121.01978600400003, 0.44204336100006],
              [121.00489342500009, 0.44867584800005],
              [120.98698978000004, 0.447007554000038],
              [120.95533287900003, 0.431870835000041],
              [120.89242597700002, 0.423325914000088],
              [120.87647545700008, 0.424505927000041],
              [120.86068769600001, 0.434393622000073],
              [120.85670006600003, 0.44086334800005],
              [120.85181725400003, 0.455755927000041],
              [120.84717858200008, 0.461737372000073],
              [120.83961022200003, 0.464097398000092],
              [120.80933678500003, 0.469183661000045],
              [120.80543053500003, 0.472357489000046],
              [120.80258222700002, 0.479396877000056],
              [120.79786217500009, 0.486476955000057],
              [120.78882897200003, 0.489650783000059],
              [120.77719160200002, 0.488104559000078],
              [120.76002037900003, 0.482611395000049],
              [120.75082441500001, 0.482814846000053],
              [120.73015384200005, 0.493475653000075],
              [120.69857832100001, 0.52415599200009],
              [120.67953535200002, 0.530585028000075],
              [120.50269616000003, 0.528876044000071],
              [120.48609459700003, 0.524237372000073],
              [120.40886478000004, 0.485744533000059],
              [120.39161217500009, 0.482814846000053],
              [120.37525475400003, 0.477687893000052],
              [120.36182701900009, 0.465643622000073],
              [120.35075931100005, 0.451971747000073],
              [120.34009850400003, 0.441880601000094],
              [120.31470787900003, 0.423163153000075],
              [120.27295983200008, 0.378119208000044],
              [120.21452884200005, 0.291937567000048],
              [120.15821373800009, 0.227769273000092],
              [120.13331139400009, 0.191229559000078],
              [120.12842858200008, 0.18109772300005],
              [120.12134850400003, 0.14516836100006],
              [120.117523634, 0.136786200000074],
              [120.103851759, 0.117254950000074],
              [120.09848066500001, 0.096991278000075],
              [120.09424889400009, 0.05141836100006],
              [120.08423912900003, 0.006252346000053],
              [120.07545006600003, -0.016412041999956],
              [120.062836134, -0.03451913899994],
              [120.02849368600005, -0.061822197999959],
              [120.02295983200008, -0.070977471999925],
              [120.02230879000001, -0.08171965899993],
              [120.02475019600001, -0.10678476399994],
              [120.01889082100001, -0.152520440999922],
              [120.01197350400003, -0.175225518999923],
              [120.00147545700008, -0.192152601999908],
              [119.99561608200008, -0.209242445999962],
              [119.99659264400009, -0.234307549999926],
              [120.01856530000009, -0.363457940999922],
              [120.02491295700008, -0.38404713299991],
              [120.05298912900003, -0.419366143999923],
              [120.05941816500001, -0.441989841999941],
              [120.05746504000001, -0.45240650799991],
              [120.04810631600003, -0.472751559999949],
              [120.04574629000001, -0.483005466999941],
              [120.04786217500009, -0.493747653999947],
              [120.05730228000004, -0.517185153999947],
              [120.07309004000001, -0.613946221999925],
              [120.08920332100001, -0.657321872999944],
              [120.24390709700003, -0.887627862999921],
              [120.25562584700003, -0.899346612999921],
              [120.30274498800009, -0.932305596999925],
              [120.32553144600001, -0.938653252999927],
              [120.34791100400003, -0.927504164999959],
              [120.36890709700003, -0.911065362999921],
              [120.38786868600005, -0.901299737999921],
              [120.412445509, -0.904961846999925],
              [120.42579186300009, -0.920017184999949],
              [120.43490644600001, -0.940362237999921],
              [120.44678795700008, -0.960056247999944],
              [120.45508873800009, -0.965997002999927],
              [120.465179884, -0.969008070999962],
              [120.48780358200008, -0.970310153999947],
              [120.500336134, -0.975274346999925],
              [120.508148634, -0.987074476999908],
              [120.51807701900009, -1.011163018999923],
              [120.582367384, -1.105238539999959],
              [120.58676191500001, -1.116631768999923],
              [120.58790123800009, -1.12859465899993],
              [120.58375084700003, -1.138116143999923],
              [120.57699629000001, -1.146742445999962],
              [120.57545006600003, -1.154392184999949],
              [120.57536868600005, -1.16334400799991],
              [120.57349694100003, -1.176364841999941],
              [120.56690514400009, -1.201429945999962],
              [120.56544030000009, -1.215508721999925],
              [120.57243899800005, -1.227715752999927],
              [120.61939537900003, -1.280450127999927],
              [120.63086998800009, -1.30046965899993],
              [120.63917076900009, -1.341241143999923],
              [120.64893639400009, -1.364353122999944],
              [120.66187584700003, -1.384860934999949],
              [120.67595462300005, -1.394707940999922],
              [120.73731530000009, -1.367445570999962],
              [120.73731530000009, -1.36060963299991],
              [120.80388431100005, -1.342868747999944],
              [120.83008873800009, -1.340101820999962],
              [120.83277428500003, -1.344821872999944],
              [120.82667076900009, -1.377699476999908],
              [120.83204186300009, -1.38445403399993],
              [120.84441165500004, -1.389580987999921],
              [120.86768639400009, -1.394707940999922],
              [120.88990319100003, -1.395277601999908],
              [120.95777428500003, -1.386895440999922],
              [120.97657311300009, -1.38209400799991],
              [120.98780358200008, -1.381117445999962],
              [120.99830162900003, -1.385918877999927],
              [121.02247155000009, -1.408379815999922],
              [121.03272545700008, -1.415785414999959],
              [121.07325280000009, -1.421319268999923],
              [121.10547936300009, -1.405857028999947],
              [121.13054446700005, -1.379815362999921],
              [121.16700280000009, -1.322930596999925],
              [121.17400149800005, -1.305433851999908],
              [121.17847741000003, -1.268161716999941],
              [121.18970787900003, -1.221368096999925],
              [121.19711347700002, -1.202894789999959],
              [121.20655358200008, -1.191338799999926],
              [121.22282962300005, -1.175388278999947],
              [121.24097741000003, -1.161228122999944],
              [121.25562584700003, -1.155205987999921],
              [121.26677493600005, -1.148614190999922],
              [121.27686608200008, -1.132907809999949],
              [121.29216556100005, -1.100518487999921],
              [121.31836998800009, -1.067152601999908],
              [121.37452233200008, -1.020684502999927],
              [121.42994225400003, -0.933770440999922],
              [121.45248457100001, -0.905694268999923],
              [121.50066165500004, -0.859307549999926],
              [121.515961134, -0.850274346999925],
              [121.53614342500009, -0.846774997999944],
              [121.57781009200005, -0.846774997999944],
              [121.58521569100003, -0.842705987999921],
              [121.58594811300009, -0.832940362999921],
              [121.58513431100005, -0.821709893999923],
              [121.58765709700003, -0.812595309999949],
              [121.59489993600005, -0.80828215899993],
              [121.62012780000009, -0.800388278999947],
              [121.62916100400003, -0.798923434999949],
              [121.64063561300009, -0.800957940999922],
              [121.64869225400003, -0.805596612999921],
              [121.65479576900009, -0.810316664999959],
              [121.65967858200008, -0.812595309999949],
              [121.66065514400009, -0.873223565999922],
              [121.66285241000003, -0.887627862999921],
              [121.69011478000004, -0.908786716999941],
              [121.69996178500003, -0.923435153999947],
              [121.70720462300005, -0.931735934999949],
              [121.71420332100001, -0.935479424999926],
              [121.79997806100005, -0.935479424999926],
              [121.84538821700005, -0.941013278999947],
              [121.88697350400003, -0.951348565999922],
              [121.92603600400003, -0.955336195999962],
              [121.96371504000001, -0.942966403999947],
              [121.99952233200008, -0.922051690999922],
              [122.01856530000009, -0.916761976999908],
              [122.04322350400003, -0.914971612999921],
              [122.06641686300009, -0.919528903999947],
              [122.08570397200003, -0.926446221999925],
              [122.10531660200002, -0.926202080999929],
              [122.12891686300009, -0.908786716999941],
              [122.14136803500003, -0.886814059999949],
              [122.15284264400009, -0.85320403399993],
              [122.15943444100003, -0.82000090899993],
              [122.15626061300009, -0.798923434999949],
              [122.19361412900003, -0.768975518999923],
              [122.20769290500004, -0.764743747999944],
              [122.41016686300009, -0.75750090899993],
              [122.45101972700002, -0.750583591999941],
              [122.48747806100005, -0.74968840899993],
              [122.55713951900009, -0.768161716999941],
              [122.59498131600003, -0.764743747999944],
              [122.60059655000009, -0.76140715899993],
              [122.60572350400003, -0.756524346999925],
              [122.61247806100005, -0.752211195999962],
              [122.62232506600003, -0.750583591999941],
              [122.63575280000009, -0.753838799999926],
              [122.65642337300005, -0.767754815999922],
              [122.68336022200003, -0.775567315999922],
              [122.69890384200005, -0.784926039999959],
              [122.71648196700005, -0.792413018999923],
              [122.73902428500003, -0.791436455999929],
              [122.787445509, -0.773695570999962],
              [122.912445509, -0.762872002999927],
              [122.92904707100001, -0.758884372999944],
              [122.94450931100005, -0.750583591999941],
              [122.95972741000003, -0.737074476999908],
              [122.96021569100003, -0.730564059999949],
              [122.89730879000001, -0.716403903999947],
              [122.89405358200008, -0.71257903399993],
              [122.88624108200008, -0.699395440999922],
              [122.88298587300005, -0.695896091999941],
              [122.86784915500004, -0.692803643999923],
              [122.78012129000001, -0.686618747999944],
              [122.76644941500001, -0.683038018999923],
              [122.75269616000003, -0.676039320999962],
              [122.74170983200008, -0.668064059999949],
              [122.73324629000001, -0.657972914999959],
              [122.73462975400003, -0.648370049999926],
              [122.75269616000003, -0.641289971999925],
              [122.76563561300009, -0.649834893999923],
              [122.77930748800009, -0.646254164999959],
              [122.80738366000003, -0.627618096999925],
              [122.81275475400003, -0.622247002999927],
              [122.81739342500009, -0.615492445999962],
              [122.82300866000003, -0.612237237999921],
              [122.83887780000009, -0.620538018999923],
              [122.84644616000003, -0.619235934999949],
              [122.85254967500009, -0.615329684999949],
              [122.85499108200008, -0.610528252999927],
              [122.94304446700005, -0.605075778999947],
              [122.96436608200008, -0.599704684999949],
              [122.97608483200008, -0.607191664999959],
              [122.99431399800005, -0.608005466999941],
              [123.01295006600003, -0.604424737999921],
              [123.02637780000009, -0.599704684999949],
              [123.03825931100005, -0.589613539999959],
              [123.05005944100003, -0.566989841999941],
              [123.06055748800009, -0.558689059999949],
              [123.07585696700005, -0.556410414999959],
              [123.23951256600003, -0.570489190999922],
              [123.27369225400003, -0.58326588299991],
              [123.34180748800009, -0.620212497999944],
              [123.40349368600005, -0.642673434999949],
              [123.41732832100001, -0.654880466999941],
              [123.40593509200005, -0.668389580999929],
              [123.40381920700008, -0.672539971999925],
              [123.40593509200005, -0.677911065999922],
              [123.41529381600003, -0.686944268999923],
              [123.41732832100001, -0.692803643999923],
              [123.41944420700008, -0.702732028999947],
              [123.42530358200008, -0.708428643999923],
              [123.43409264400009, -0.71062590899993],
              [123.44467207100001, -0.709567966999941],
              [123.43848717500009, -0.730401299999926],
              [123.45435631600003, -0.758233330999929],
              [123.44044030000009, -0.792901299999926],
              [123.44483483200008, -0.833103122999944],
              [123.437836134, -0.853610934999949],
              [123.40992272200003, -0.880303643999923],
              [123.40015709700003, -0.894789320999962],
              [123.38965905000009, -0.98365650799991],
              [123.38331139400009, -1.003676039999959],
              [123.35238691500001, -1.039727471999925],
              [123.31120853000004, -1.051446221999925],
              [123.26978600400003, -1.04461028399993],
              [123.23878014400009, -1.024834893999923],
              [123.21094811300009, -0.983330987999921],
              [123.20101972700002, -0.976983330999929],
              [123.19629967500009, -0.97039153399993],
              [123.14991295700008, -0.935479424999926],
              [123.14779707100001, -0.922946872999944],
              [123.15552819100003, -0.89812590899993],
              [123.15674889400009, -0.887627862999921],
              [123.15088951900009, -0.872979424999926],
              [123.14087975400003, -0.862237237999921],
              [123.11890709700003, -0.842950127999927],
              [123.09620201900009, -0.835056247999944],
              [123.06080162900003, -0.88054778399993],
              [123.04004967500009, -0.880791924999926],
              [123.00945071700005, -0.893731377999927],
              [122.91700280000009, -0.899590752999927],
              [122.87614993600005, -0.908786716999941],
              [122.83871504000001, -0.899183851999908],
              [122.81169681100005, -0.924086195999962],
              [122.76970462300005, -1.019789320999962],
              [122.76075280000009, -1.034356377999927],
              [122.73560631600003, -1.062676690999922],
              [122.73047936300009, -1.07000090899993],
              [122.72706139400009, -1.078545830999929],
              [122.72527103000004, -1.087660414999959],
              [122.72478274800005, -1.097100518999923],
              [122.72095787900003, -1.10906340899993],
              [122.71208743600005, -1.114353122999944],
              [122.70069420700008, -1.11687590899993],
              [122.69068444100003, -1.121026299999926],
              [122.66163170700008, -1.142836195999962],
              [122.64828535200002, -1.15943775799991],
              [122.63843834700003, -1.206149997999944],
              [122.62647545700008, -1.21843840899993],
              [122.58814537900003, -1.237074476999908],
              [122.57211347700002, -1.25318775799991],
              [122.52955162900003, -1.316013278999947],
              [122.51197350400003, -1.326592705999929],
              [122.50269616000003, -1.333754164999959],
              [122.49878991000003, -1.343194268999923],
              [122.49610436300009, -1.352959893999923],
              [122.48292076900009, -1.375095309999949],
              [122.47828209700003, -1.381117445999962],
              [122.40601647200003, -1.446221612999921],
              [122.38209069100003, -1.478692315999922],
              [122.36882571700005, -1.492771091999941],
              [122.30632571700005, -1.524346612999921],
              [122.23316491000003, -1.574314059999949],
              [122.20053144600001, -1.604180596999925],
              [122.183929884, -1.614190362999921],
              [122.17188561300009, -1.609795830999929],
              [122.15984134200005, -1.600192966999941],
              [122.14323978000004, -1.594008070999962],
              [122.12403405000009, -1.597588799999926],
              [122.08350670700008, -1.616794528999947],
              [122.06373131600003, -1.621270440999922],
              [122.05404707100001, -1.619805596999925],
              [122.03646894600001, -1.613946221999925],
              [122.02588951900009, -1.614434502999927],
              [122.01856530000009, -1.618096612999921],
              [122.01392662900003, -1.623630466999941],
              [122.01026451900009, -1.629652601999908],
              [122.00538170700008, -1.634942315999922],
              [121.97364342500009, -1.655368747999944],
              [121.95476321700005, -1.663832289999959],
              [121.94320722700002, -1.662286065999922],
              [121.91928144600001, -1.673028252999927],
              [121.90137780000009, -1.67546965899993],
              [121.86133873800009, -1.669691664999959],
              [121.85613040500004, -1.688083591999941],
              [121.84766686300009, -1.690199476999908],
              [121.83122806100005, -1.701918226999908],
              [121.82016035200002, -1.707614841999941],
              [121.81039472700002, -1.710137627999927],
              [121.79859459700003, -1.717950127999927],
              [121.79004967500009, -1.736423434999949],
              [121.78003991000003, -1.772149346999925],
              [121.75513756600003, -1.833754164999959],
              [121.73902428500003, -1.861748955999929],
              [121.71802819100003, -1.888278903999947],
              [121.69214928500003, -1.908135674999926],
              [121.66114342500009, -1.920668226999908],
              [121.62769616000003, -1.927341403999947],
              [121.56251061300009, -1.930596612999921],
              [121.55298912900003, -1.929131768999923],
              [121.54004967500009, -1.923435153999947],
              [121.53451582100001, -1.916599216999941],
              [121.53052819100003, -1.908379815999922],
              [121.51156660200002, -1.883558851999908],
              [121.50473066500001, -1.876722914999959],
              [121.49512780000009, -1.873955987999921],
              [121.49146569100003, -1.871677341999941],
              [121.45671634200005, -1.860935153999947],
              [121.44507897200003, -1.841566664999959],
              [121.44516035200002, -1.825616143999923],
              [121.44092858200008, -1.813571872999944],
              [121.41627037900003, -1.805759372999944],
              [121.37134850400003, -1.805759372999944],
              [121.36459394600001, -1.802341403999947],
              [121.35450280000009, -1.785577080999929],
              [121.34742272200003, -1.77898528399993],
              [121.31185957100001, -1.78289153399993],
              [121.29607181100005, -1.816664320999962],
              [121.30420983200008, -1.84693775799991],
              [121.34058678500003, -1.839776299999926],
              [121.34571373800009, -1.855726820999962],
              [121.34009850400003, -1.875664971999925],
              [121.33139082100001, -1.897556247999944],
              [121.32699629000001, -1.919040622999944],
              [121.32911217500009, -1.927911065999922],
              [121.33838951900009, -1.937595309999949],
              [121.34058678500003, -1.94654713299991],
              [121.34058678500003, -1.991306247999944],
              [121.35132897200003, -1.984144789999959],
              [121.36085045700008, -1.97584400799991],
              [121.36866295700008, -1.966566664999959],
              [121.37476647200003, -1.957126559999949],
              [121.37956790500004, -1.942966403999947],
              [121.38249759200005, -1.928887627999927],
              [121.38843834700003, -1.917168877999927],
              [121.40202884200005, -1.909356377999927],
              [121.41456139400009, -1.927341403999947],
              [121.43628991000003, -1.98015715899993],
              [121.46664472700002, -2.000909112999921],
              [121.47787519600001, -2.020277601999908],
              [121.49146569100003, -2.035332940999922],
              [121.51189212300005, -2.032321872999944],
              [121.53532962300005, -2.058770440999922],
              [121.555023634, -2.133965752999927],
              [121.574554884, -2.162530205999929],
              [121.61768639400009, -2.177992445999962],
              [121.65992272200003, -2.176690362999921],
              [121.70085696700005, -2.180352471999925],
              [121.73902428500003, -2.211032809999949],
              [121.76693769600001, -2.241631768999923],
              [121.82292728000004, -2.287286065999922],
              [121.84766686300009, -2.320896091999941],
              [121.86475670700008, -2.358493747999944],
              [121.87208092500009, -2.380303643999923],
              [121.87501061300009, -2.398695570999962],
              [121.88257897200003, -2.41334400799991],
              [121.92969811300009, -2.462985934999949],
              [121.96550540500004, -2.518243096999925],
              [121.97787519600001, -2.55396900799991],
              [122.00928795700008, -2.593519789999959],
              [122.01905358200008, -2.615004164999959],
              [122.01921634200005, -2.635430596999925],
              [122.01335696700005, -2.68092213299991],
              [122.01563561300009, -2.693536065999922],
              [122.05990644600001, -2.744805596999925],
              [122.08383222700002, -2.763929945999962],
              [122.09896894600001, -2.770277601999908],
              [122.137054884, -2.775485934999949],
              [122.14576256600003, -2.778741143999923],
              [122.14942467500009, -2.782647393999923],
              [122.152679884, -2.794122002999927],
              [122.160492384, -2.798760674999926],
              [122.16968834700003, -2.801364841999941],
              [122.17725670700008, -2.806817315999922],
              [122.18165123800009, -2.822930596999925],
              [122.18531334700003, -2.845798434999949],
              [122.19263756600003, -2.866306247999944],
              [122.20769290500004, -2.875176690999922],
              [122.24537194100003, -2.875258070999962],
              [122.26612389400009, -2.879164320999962],
              [122.28711998800009, -2.888767184999949],
              [122.31251061300009, -2.926853122999944],
              [122.29444420700008, -2.96453215899993],
              [122.27084394600001, -3.002129815999922],
              [122.279633009, -3.039646091999941],
              [122.28687584700003, -3.044691664999959],
              [122.31373131600003, -3.060153903999947],
              [122.38591556100005, -3.132012627999927],
              [122.39437910200002, -3.133477471999925],
              [122.40699303500003, -3.127618096999925],
              [122.42009524800005, -3.119561455999929],
              [122.43043053500003, -3.114678643999923],
              [122.43384850400003, -3.12859465899993],
              [122.43873131600003, -3.140069268999923],
              [122.44613691500001, -3.149346612999921],
              [122.45728600400003, -3.156345309999949],
              [122.46753991000003, -3.148207289999959],
              [122.47291100400003, -3.151136976999908],
              [122.47217858200008, -3.16179778399993],
              [122.46469160200002, -3.176853122999944],
              [122.45915774800005, -3.180108330999929],
              [122.44263756600003, -3.18523528399993],
              [122.43669681100005, -3.190362237999921],
              [122.43539472700002, -3.196384372999944],
              [122.43718509200005, -3.211195570999962],
              [122.43669681100005, -3.217705987999921],
              [122.43360436300009, -3.234551690999922],
              [122.43295332100001, -3.243096612999921],
              [122.42920983200008, -3.245863539999959],
              [122.41627037900003, -3.245700778999947],
              [122.41879316500001, -3.243747653999947],
              [122.41342207100001, -3.238946221999925],
              [122.40259850400003, -3.232028903999947],
              [122.39535566500001, -3.230238539999959],
              [122.38982181100005, -3.23170338299991],
              [122.38575280000009, -3.234958591999941],
              [122.38266035200002, -3.238213799999926],
              [122.35792076900009, -3.217543226999908],
              [122.33936608200008, -3.23756275799991],
              [122.32129967500009, -3.25709400799991],
              [122.29566491000003, -3.312920830999929],
              [122.30355879000001, -3.341241143999923],
              [122.31690514400009, -3.344821872999944],
              [122.35938561300009, -3.363457940999922],
              [122.37256920700008, -3.372247002999927],
              [122.38062584700003, -3.391534112999921],
              [122.38363691500001, -3.418633721999925],
              [122.37842858200008, -3.43873463299991],
              [122.36158287900003, -3.437432549999926],
              [122.36890709700003, -3.425713799999926],
              [122.36198978000004, -3.41334400799991],
              [122.34620201900009, -3.404473565999922],
              [122.32748457100001, -3.403252862999921],
              [122.33204186300009, -3.393487237999921],
              [122.33497155000009, -3.389743747999944],
              [122.32520592500009, -3.375258070999962],
              [122.31104576900009, -3.368584893999923],
              [122.29509524800005, -3.364027601999908],
              [122.279633009, -3.355564059999949],
              [122.27686608200008, -3.366306247999944],
              [122.27247155000009, -3.37623463299991],
              [122.26482181100005, -3.381117445999962],
              [122.25171959700003, -3.376071872999944],
              [122.25440514400009, -3.395114841999941],
              [122.26124108200008, -3.409926039999959],
              [122.27125084700003, -3.422295830999929],
              [122.28345787900003, -3.434014580999929],
              [122.29216556100005, -3.45086028399993],
              [122.29053795700008, -3.471368096999925],
              [122.28272545700008, -3.492771091999941],
              [122.26661217500009, -3.522881768999923],
              [122.26246178500003, -3.52898528399993],
              [122.25660241000003, -3.533461195999905],
              [122.24561608200008, -3.539808851999908],
              [122.23438561300009, -3.54420338299991],
              [122.21070397200003, -3.550551039999959],
              [122.20053144600001, -3.556573174999926],
              [122.19792728000004, -3.571709893999923],
              [122.205414259, -3.593845309999949],
              [122.22510826900009, -3.629164320999905],
              [122.23560631600003, -3.643161716999941],
              [122.25049889400009, -3.656182549999926],
              [122.26880944100003, -3.665785414999959],
              [122.29029381600003, -3.66961028399993],
              [122.30543053500003, -3.674981377999927],
              [122.31519616000003, -3.688164971999925],
              [122.32357832100001, -3.704278252999927],
              [122.33497155000009, -3.71803150799991],
              [122.35523522200003, -3.72779713299991],
              [122.37647545700008, -3.729180596999925],
              [122.41968834700003, -3.724786065999922],
              [122.44141686300009, -3.731052341999941],
              [122.45337975400003, -3.746270440999922],
              [122.47095787900003, -3.786309502999927],
              [122.52955162900003, -3.865411065999922],
              [122.54867597700002, -3.878676039999959],
              [122.568695509, -3.882907809999949],
              [122.63689212300005, -3.883477471999925],
              [122.64730879000001, -3.884942315999922],
              [122.65642337300005, -3.889336846999925],
              [122.66334069100003, -3.897149346999925],
              [122.66895592500009, -3.908623955999929],
              [122.66724694100003, -3.918877862999921],
              [122.64616946700005, -3.92546965899993],
              [122.63819420700008, -3.930352471999925],
              [122.63184655000009, -3.936211846999925],
              [122.62435957100001, -3.95240650799991],
              [122.61329186300009, -3.956475518999923],
              [122.58814537900003, -3.957614841999941],
              [122.56576582100001, -3.963962497999944],
              [122.55128014400009, -3.970798434999949],
              [122.55250084700003, -3.976332289999959],
              [122.60075931100005, -3.98015715899993],
              [122.62281334700003, -3.985039971999925],
              [122.64210045700008, -3.993747653999947],
              [122.65642337300005, -4.006605726999908],
              [122.66382897200003, -4.02312590899993],
              [122.66553795700008, -4.042168877999927],
              [122.66325931100005, -4.084567966999941],
              [122.66651451900009, -4.102471612999921],
              [122.67505944100003, -4.12273528399993],
              [122.68816165500004, -4.13836028399993],
              [122.70427493600005, -4.142510674999926],
              [122.70777428500003, -4.139092705999929],
              [122.71021569100003, -4.13209400799991],
              [122.71143639400009, -4.123467705999929],
              [122.71111087300005, -4.115329684999949],
              [122.73902428500003, -4.129327080999929],
              [122.77816816500001, -4.136976820999905],
              [122.81641686300009, -4.137302341999941],
              [122.84205162900003, -4.128838799999926],
              [122.78931725400003, -4.073988539999959],
              [122.77515709700003, -4.048272393999923],
              [122.80738366000003, -4.04070403399993],
              [122.84498131600003, -4.057712497999944],
              [122.87281334700003, -4.093194268999923],
              [122.89185631600003, -4.136488539999959],
              [122.90707441500001, -4.195977471999925],
              [122.90894616000003, -4.216729424999926],
              [122.90723717500009, -4.235528252999927],
              [122.89242597700002, -4.266045830999929],
              [122.89389082100001, -4.286065362999921],
              [122.90357506600003, -4.328220309999949],
              [122.90528405000009, -4.370212497999944],
              [122.90015709700003, -4.388767184999949],
              [122.88640384200005, -4.396416924999926],
              [122.86687259200005, -4.400323174999926],
              [122.85914147200003, -4.410332940999922],
              [122.85401451900009, -4.423923434999949],
              [122.84205162900003, -4.438083591999941],
              [122.82740319100003, -4.41961028399993],
              [122.75879967500009, -4.369073174999926],
              [122.72291100400003, -4.332452080999929],
              [122.69971764400009, -4.318291924999926],
              [122.67017662900003, -4.314548434999949],
              [122.68083743600005, -4.334161065999922],
              [122.72169030000009, -4.372491143999923],
              [122.72779381600003, -4.381117445999905],
              [122.73812910200002, -4.400567315999922],
              [122.74512780000009, -4.410088799999926],
              [122.74935957100001, -4.410902601999908],
              [122.76221764400009, -4.409112237999921],
              [122.76628665500004, -4.410088799999926],
              [122.77027428500003, -4.416761976999908],
              [122.76872806100005, -4.420586846999925],
              [122.76587975400003, -4.424086195999905],
              [122.76628665500004, -4.430433851999908],
              [122.77100670700008, -4.442559502999927],
              [122.77295983200008, -4.450127862999921],
              [122.77312259200005, -4.46843840899993],
              [122.76880944100003, -4.478448174999926],
              [122.758148634, -4.484795830999929],
              [122.74577884200005, -4.486504815999922],
              [122.73560631600003, -4.482354424999926],
              [122.71111087300005, -4.451755466999941],
              [122.69996178500003, -4.451836846999925],
              [122.69727623800009, -4.457940362999921],
              [122.69988040500004, -4.46607838299991],
              [122.70427493600005, -4.472100518999923],
              [122.69117272200003, -4.483819268999923],
              [122.68230228000004, -4.480401299999926],
              [122.67017662900003, -4.458428643999923],
              [122.67009524800005, -4.432224216999941],
              [122.64047285200002, -4.408461195999905],
              [122.59913170700008, -4.396742445999905],
              [122.56373131600003, -4.406914971999925],
              [122.53142337300005, -4.427911065999922],
              [122.49756920700008, -4.43523528399993],
              [122.46363366000003, -4.430840752999927],
              [122.43043053500003, -4.416924737999921],
              [122.39193769600001, -4.438083591999941],
              [122.35035241000003, -4.452894789999959],
              [122.30600019600001, -4.461683851999908],
              [122.24040774800005, -4.465915622999944],
              [122.23324629000001, -4.46803150799991],
              [122.22510826900009, -4.472100518999923],
              [122.20899498800009, -4.484551690999922],
              [122.19939212300005, -4.490166924999926],
              [122.17652428500003, -4.49578215899993],
              [122.15894616000003, -4.509942315999922],
              [122.15284264400009, -4.513116143999923],
              [122.11622155000009, -4.517510674999926],
              [122.107758009, -4.519952080999929],
              [122.08716881600003, -4.543226820999905],
              [122.06568444100003, -4.582289320999905],
              [122.04835045700008, -4.625909112999921],
              [122.03956139400009, -4.66334400799991],
              [122.04297936300009, -4.707777601999908],
              [122.05933678500003, -4.742445570999905],
              [122.08277428500003, -4.770196221999925],
              [122.107758009, -4.793633721999925],
              [122.11158287900003, -4.795830987999921],
              [122.12891686300009, -4.80046965899993],
              [122.12891686300009, -4.80787525799991],
              [122.11060631600003, -4.813246351999908],
              [122.09099368600005, -4.836683851999908],
              [122.07740319100003, -4.842054945999905],
              [122.05518639400009, -4.844333591999941],
              [122.01124108200008, -4.853692315999922],
              [121.99170983200008, -4.855726820999905],
              [121.88746178500003, -4.846368096999925],
              [121.86963951900009, -4.840915622999944],
              [121.84083092500009, -4.82154713299991],
              [121.82325280000009, -4.813083591999941],
              [121.80876712300005, -4.814060153999947],
              [121.79224694100003, -4.818780205999929],
              [121.76954186300009, -4.82154713299991],
              [121.75082441500001, -4.816013278999947],
              [121.74244225400003, -4.81609465899993],
              [121.73902428500003, -4.824639580999929],
              [121.73487389400009, -4.828220309999949],
              [121.72535241000003, -4.832289320999905],
              [121.71387780000009, -4.83521900799991],
              [121.70435631600003, -4.83521900799991],
              [121.68555748800009, -4.822442315999922],
              [121.65723717500009, -4.787204684999949],
              [121.63917076900009, -4.779961846999925],
              [121.62549889400009, -4.776788018999923],
              [121.56657962300005, -4.752618096999925],
              [121.55420983200008, -4.743747653999947],
              [121.50342858200008, -4.674899997999944],
              [121.49830162900003, -4.66334400799991],
              [121.49439537900003, -4.660902601999908],
              [121.49122155000009, -4.661309502999927],
              [121.48804772200003, -4.661065362999921],
              [121.48462975400003, -4.656426690999922],
              [121.47771243600005, -4.622979424999926],
              [121.48047936300009, -4.580824476999908],
              [121.49830162900003, -4.500095309999949],
              [121.52051842500009, -4.439629815999922],
              [121.52930748800009, -4.397556247999944],
              [121.53296959700003, -4.356215101999908],
              [121.52930748800009, -4.277520440999922],
              [121.533539259, -4.24773528399993],
              [121.53321373800009, -4.238051039999959],
              [121.53630618600005, -4.230564059999949],
              [121.54672285200002, -4.225192966999941],
              [121.55958092500009, -4.225192966999941],
              [121.56316165500004, -4.232517184999949],
              [121.56023196700005, -4.243096612999921],
              [121.55298912900003, -4.252373955999929],
              [121.58497155000009, -4.236748955999929],
              [121.61719811300009, -4.166924737999921],
              [121.62769616000003, -4.087090752999927],
              [121.59449303500003, -4.04070403399993],
              [121.55518639400009, -4.021416924999926],
              [121.430023634, -3.999200127999927],
              [121.35425866000003, -3.96843840899993],
              [121.35108483200008, -3.95826588299991],
              [121.33692467500009, -3.943536065999922],
              [121.33375084700003, -3.934340101999908],
              [121.33139082100001, -3.923028252999927],
              [121.32569420700008, -3.912530205999929],
              [121.31267337300005, -3.897393487999921],
              [121.29615319100003, -3.886814059999949],
              [121.28443444100003, -3.88990650799991],
              [121.27263431100005, -3.898207289999959],
              [121.25562584700003, -3.903008721999925],
              [121.24610436300009, -3.89421965899993],
              [121.25131269600001, -3.874118747999944],
              [121.26099694100003, -3.85125090899993],
              [121.26490319100003, -3.834649346999925],
              [121.25513756600003, -3.81568775799991],
              [121.24024498800009, -3.80787525799991],
              [121.20020592500009, -3.807305596999925],
              [121.176117384, -3.804457289999959],
              [121.16032962300005, -3.79615650799991],
              [121.10515384200005, -3.730238539999959],
              [120.89380944100003, -3.539157809999949],
              [120.87452233200008, -3.498955987999921],
              [120.86768639400009, -3.469496351999908],
              [120.86768639400009, -3.457940362999921],
              [120.87029056100005, -3.445733330999929],
              [120.87940514400009, -3.42351653399993],
              [120.88135826900009, -3.413262627999927],
              [120.88941491000003, -3.388767184999949],
              [120.908539259, -3.367608330999929],
              [120.93140709700003, -3.347914320999962],
              [120.95020592500009, -3.327569268999923],
              [120.96802819100003, -3.285739841999941],
              [120.97901451900009, -3.267022393999923],
              [120.99488366000003, -3.259372653999947],
              [121.00554446700005, -3.257256768999923],
              [121.01531009200005, -3.25164153399993],
              [121.02247155000009, -3.24382903399993],
              [121.02523847700002, -3.235039971999925],
              [121.02979576900009, -3.226820570999962],
              [121.04037519600001, -3.220961195999962],
              [121.05193118600005, -3.216403903999947],
              [121.05933678500003, -3.211521091999941],
              [121.066742384, -3.193780205999929],
              [121.07341556100005, -3.139418226999908],
              [121.07300866000003, -3.114678643999923],
              [121.06836998800009, -3.090427341999941],
              [121.06332441500001, -3.078708591999941],
              [121.05632571700005, -3.073663018999923],
              [121.04810631600003, -3.066176039999959],
              [121.05290774800005, -3.049493096999925],
              [121.06690514400009, -3.022149346999925],
              [121.06853274800005, -3.007989190999922],
              [121.07683353000004, -2.989434502999927],
              [121.080414259, -2.977634372999944],
              [121.07943769600001, -2.936700127999927],
              [121.08383222700002, -2.926364841999941],
              [121.08725019600001, -2.904554945999962],
              [121.08171634200005, -2.87232838299991],
              [121.07081139400009, -2.851006768999923],
              [121.05933678500003, -2.862074476999908],
              [121.05323326900009, -2.862074476999908],
              [121.04810631600003, -2.85125090899993],
              [121.04102623800009, -2.824395440999922],
              [121.03272545700008, -2.814222914999959],
              [121.02442467500009, -2.822686455999929],
              [121.01677493600005, -2.842868747999944],
              [121.01172936300009, -2.848402601999908],
              [121.00171959700003, -2.848077080999929],
              [120.99301191500001, -2.841729424999926],
              [120.98682701900009, -2.832614841999941],
              [120.98438561300009, -2.82390715899993],
              [120.99073326900009, -2.811618747999944],
              [121.00489342500009, -2.808363539999959],
              [121.01889082100001, -2.801853122999944],
              [121.02523847700002, -2.778903903999947],
              [121.04167728000004, -2.783868096999925],
              [121.05250084700003, -2.777601820999962],
              [121.06690514400009, -2.752211195999962],
              [121.070648634, -2.755303643999923],
              [121.07374108200008, -2.756605726999908],
              [121.07683353000004, -2.757419528999947],
              [121.080414259, -2.75904713299991],
              [121.04818769600001, -2.698988539999959],
              [121.03589928500003, -2.690118096999925],
              [121.03646894600001, -2.686455987999921],
              [121.02930748800009, -2.678399346999925],
              [121.01539147200003, -2.665948174999926],
              [121.00586998800009, -2.660821221999925],
              [120.88502037900003, -2.642347914999959],
              [120.87240644600001, -2.644138278999947],
              [120.86255944100003, -2.646661065999922],
              [120.85377037900003, -2.64617278399993],
              [120.84376061300009, -2.638604424999926],
              [120.83277428500003, -2.627862237999921],
              [120.82349694100003, -2.621514580999929],
              [120.81324303500003, -2.617933851999908],
              [120.79932701900009, -2.615004164999959],
              [120.77605228000004, -2.61492278399993],
              [120.76099694100003, -2.622002862999921],
              [120.74870853000004, -2.630629164999959],
              [120.73389733200008, -2.634942315999922],
              [120.71257571700005, -2.636895440999922],
              [120.69629967500009, -2.642185153999947],
              [120.64210045700008, -2.670342705999929],
              [120.62671959700003, -2.674737237999921],
              [120.60450280000009, -2.676446221999925],
              [120.58448326900009, -2.682061455999929],
              [120.57471764400009, -2.695977471999925],
              [120.568695509, -2.713799737999921],
              [120.55982506600003, -2.731133721999925],
              [120.54297936300009, -2.747247002999927],
              [120.29224694100003, -2.903008721999925],
              [120.25294030000009, -2.936455987999921],
              [120.23161868600005, -2.950372002999927],
              [120.203461134, -2.957696221999925],
              [120.20899498800009, -2.97039153399993],
              [120.22641035200002, -2.988051039999959],
              [120.23023522200003, -3.001722914999959],
              [120.23121178500003, -3.014336846999925],
              [120.23438561300009, -3.026543877999927],
              [120.24000084700003, -3.035902601999908],
              [120.24781334700003, -3.039646091999941],
              [120.26140384200005, -3.050388278999947],
              [120.27540123800009, -3.102715752999927],
              [120.28541100400003, -3.122165622999944],
              [120.27865644600001, -3.125258070999962],
              [120.27426191500001, -3.129489841999941],
              [120.26433353000004, -3.142022393999923],
              [120.28532962300005, -3.162530205999929],
              [120.30681399800005, -3.17351653399993],
              [120.35377037900003, -3.190362237999921],
              [120.38306725400003, -3.209079684999949],
              [120.38786868600005, -3.214613539999959],
              [120.38941491000003, -3.223321221999925],
              [120.39389082100001, -3.237237237999921],
              [120.40040123800009, -3.250909112999921],
              [120.40821373800009, -3.259372653999947],
              [120.42579186300009, -3.256117445999962],
              [120.42156009200005, -3.267510674999926],
              [120.40919030000009, -3.284112237999921],
              [120.40211022200003, -3.296807549999926],
              [120.40398196700005, -3.307224216999941],
              [120.40699303500003, -3.318454684999949],
              [120.408539259, -3.329034112999921],
              [120.40284264400009, -3.345635674999926],
              [120.39527428500003, -3.382256768999923],
              [120.39771569100003, -3.392185153999947],
              [120.40626061300009, -3.412367445999962],
              [120.40821373800009, -3.423760674999926],
              [120.40772545700008, -3.433363539999959],
              [120.40316816500001, -3.449639580999929],
              [120.39893639400009, -3.500909112999921],
              [120.40015709700003, -3.517836195999905],
              [120.41781660200002, -3.563571872999944],
              [120.42188561300009, -3.582452080999929],
              [120.42204837300005, -3.666436455999929],
              [120.42505944100003, -3.673028252999927],
              [120.443695509, -3.69068775799991],
              [120.44654381600003, -3.728692315999922],
              [120.430023634, -3.766778252999927],
              [120.38786868600005, -3.827894789999959],
              [120.371429884, -3.860446872999944],
              [120.359711134, -3.89421965899993],
              [120.35352623800009, -3.930840752999927],
              [120.351898634, -4.100274346999925],
              [120.35564212300005, -4.11646900799991],
              [120.37720787900003, -4.152764580999929],
              [120.38135826900009, -4.16725025799991],
              [120.38160241000003, -4.207696221999925],
              [120.38054446700005, -4.217950127999927],
              [120.37525475400003, -4.237725518999923],
              [120.37419681100005, -4.24928150799991],
              [120.37582441500001, -4.263278903999947],
              [120.38786868600005, -4.294040622999944],
              [120.38624108200008, -4.329278252999927],
              [120.36231530000009, -4.386976820999905],
              [120.36736087300005, -4.424411716999941],
              [120.39177493600005, -4.452894789999959],
              [120.40259850400003, -4.472100518999923],
              [120.39869225400003, -4.489190362999921],
              [120.39275149800005, -4.506280205999929],
              [120.39307701900009, -4.531670830999929],
              [120.39714603000004, -4.557224216999941],
              [120.40211022200003, -4.574476820999905],
              [120.41423587300005, -4.592868747999944],
              [120.44410241000003, -4.62664153399993],
              [120.44996178500003, -4.646579684999949],
              [120.44662519600001, -4.656670830999929],
              [120.43848717500009, -4.665134372999944],
              [120.41920006600003, -4.680759372999944],
              [120.41586347700002, -4.688897393999923],
              [120.39616946700005, -4.787204684999949],
              [120.39527428500003, -4.810967705999929],
              [120.38656660200002, -4.829278252999927],
              [120.36638431100005, -4.83562590899993],
              [120.34343509200005, -4.837497653999947],
              [120.32642662900003, -4.842054945999905],
              [120.30941816500001, -4.871270440999922],
              [120.30665123800009, -4.992852471999925],
              [120.28402754000001, -5.111586195999905],
              [120.27564537900003, -5.133884372999944],
              [120.26433353000004, -5.149997653999947],
              [120.30665123800009, -5.211358330999929],
              [120.31495201900009, -5.228936455999929],
              [120.32829837300005, -5.268731377999927],
              [120.33692467500009, -5.283786716999941],
              [120.38111412900003, -5.337334893999923],
              [120.38786868600005, -5.352227471999925],
              [120.38892662900003, -5.371677341999941],
              [120.43295332100001, -5.527601820999905],
              [120.43628991000003, -5.565199476999908],
              [120.44060306100005, -5.573988539999959],
              [120.459320509, -5.601983330999929],
              [120.46363366000003, -5.620212497999944],
              [120.45834394600001, -5.626071872999944],
              [120.43051191500001, -5.613946221999925],
              [120.416351759, -5.616794528999947],
              [120.37964928500003, -5.576348565999922],
              [120.37419681100005, -5.565199476999908],
              [120.37126712300005, -5.553887627999927],
              [120.35499108200008, -5.522393487999921],
              [120.34750410200002, -5.513604424999926],
              [120.32325280000009, -5.509535414999959],
              [120.29786217500009, -5.518975518999923],
              [120.27344811300009, -5.532403252999927],
              [120.25196373800009, -5.540948174999926],
              [120.20671634200005, -5.547784112999921],
              [120.19922936300009, -5.550551039999959],
              [120.17554772200003, -5.568942966999941],
              [120.15691165500004, -5.576836846999925],
              [120.11866295700008, -5.587985934999949],
              [120.10043379000001, -5.595635674999926],
              [120.09400475400003, -5.590752862999921],
              [120.08790123800009, -5.589288018999923],
              [120.07309004000001, -5.588799737999921],
              [120.01026451900009, -5.57781340899993],
              [119.99805748800009, -5.57195403399993],
              [119.98658287900003, -5.564222914999959],
              [119.96070397200003, -5.562595309999949],
              [119.93262780000009, -5.564711195999905],
              [119.91488691500001, -5.568942966999941],
              [119.89918053500003, -5.57935963299991],
              [119.85718834700003, -5.620212497999944],
              [119.85124759200005, -5.63054778399993],
              [119.84815514400009, -5.65203215899993],
              [119.84351647200003, -5.661065362999921],
              [119.82349694100003, -5.67937590899993],
              [119.80567467500009, -5.692478122999944],
              [119.77222741000003, -5.701267184999949],
              [119.72364342500009, -5.703789971999925],
              [119.67693118600005, -5.697035414999959],
              [119.64795983200008, -5.678806247999944],
              [119.64405358200008, -5.660088799999926],
              [119.64242597700002, -5.636976820999905],
              [119.63404381600003, -5.617445570999905],
              [119.609711134, -5.609144789999959],
              [119.59034264400009, -5.620538018999923],
              [119.57984459700003, -5.64226653399993],
              [119.56999759200005, -5.65593840899993],
              [119.55241946700005, -5.643324476999908],
              [119.54712975400003, -5.631768487999921],
              [119.54761803500003, -5.608168226999908],
              [119.54566491000003, -5.595635674999926],
              [119.53834069100003, -5.58521900799991],
              [119.52898196700005, -5.579685153999947],
              [119.52116946700005, -5.572523695999905],
              [119.51758873800009, -5.558038018999923],
              [119.50277754000001, -5.555840752999927],
              [119.47413170700008, -5.560804945999905],
              [119.45533287900003, -5.573825778999947],
              [119.46989993600005, -5.595635674999926],
              [119.44825280000009, -5.59498463299991],
              [119.43327884200005, -5.587823174999926],
              [119.42481530000009, -5.573337497999944],
              [119.42212975400003, -5.551202080999929],
              [119.42595462300005, -5.541761976999908],
              [119.43327884200005, -5.532159112999921],
              [119.43751061300009, -5.521742445999905],
              [119.43238366000003, -5.510349216999941],
              [119.42481530000009, -5.50123463299991],
              [119.41472415500004, -5.482354424999926],
              [119.38013756600003, -5.434014580999929],
              [119.36036217500009, -5.396416924999926],
              [119.35279381600003, -5.355645440999922],
              [119.36060631600003, -5.307549737999921],
              [119.36963951900009, -5.276788018999923],
              [119.37525475400003, -5.211521091999941],
              [119.37989342500009, -5.191664320999905],
              [119.39470462300005, -5.156833591999941],
              [119.40365644600001, -5.124118747999944],
              [119.40845787900003, -5.115817966999941],
              [119.41700280000009, -5.109470309999949],
              [119.43734785200002, -5.098809502999927],
              [119.44597415500004, -5.092461846999925],
              [119.45997155000009, -5.07350025799991],
              [119.46566816500001, -5.055596612999921],
              [119.46989993600005, -5.020196221999925],
              [119.48324629000001, -4.986260674999926],
              [119.51978600400003, -4.916680596999925],
              [119.52515709700003, -4.883070570999905],
              [119.49122155000009, -4.754082940999922],
              [119.49708092500009, -4.717950127999927],
              [119.50212649800005, -4.713555596999925],
              [119.51905358200008, -4.703545830999929],
              [119.52515709700003, -4.698011976999908],
              [119.53882897200003, -4.666680596999925],
              [119.54184004000001, -4.652927341999941],
              [119.58497155000009, -4.579196872999944],
              [119.59107506600003, -4.56414153399993],
              [119.60621178500003, -4.420342705999929],
              [119.62330162900003, -4.352227471999925],
              [119.62680097700002, -4.314548434999949],
              [119.62582441500001, -4.304457289999959],
              [119.62159264400009, -4.286879164999959],
              [119.62061608200008, -4.27662525799991],
              [119.617523634, -4.265069268999923],
              [119.60336347700002, -4.25164153399993],
              [119.60010826900009, -4.242445570999905],
              [119.60450280000009, -4.222914320999905],
              [119.62330162900003, -4.183770440999922],
              [119.62680097700002, -4.163018487999921],
              [119.61841881600003, -4.121026299999926],
              [119.61353600400003, -4.11296965899993],
              [119.60865319100003, -4.107679945999905],
              [119.60629316500001, -4.104668877999927],
              [119.60816491000003, -4.093194268999923],
              [119.61719811300009, -4.076755466999941],
              [119.62061608200008, -4.066827080999929],
              [119.62110436300009, -4.057061455999929],
              [119.61841881600003, -4.038506768999923],
              [119.62061608200008, -4.026462497999944],
              [119.64307701900009, -3.992771091999941],
              [119.64698326900009, -3.977959893999923],
              [119.63062584700003, -3.971856377999927],
              [119.60710696700005, -3.97584400799991],
              [119.60043379000001, -3.986993096999925],
              [119.59961998800009, -4.004164320999905],
              [119.59343509200005, -4.026462497999944],
              [119.58773847700002, -4.008884372999944],
              [119.58521569100003, -3.970310153999947],
              [119.56609134200005, -3.939873955999929],
              [119.519867384, -3.826348565999922],
              [119.49740644600001, -3.793877862999921],
              [119.48568769600001, -3.754082940999922],
              [119.45671634200005, -3.71453215899993],
              [119.45427493600005, -3.700127862999921],
              [119.46989993600005, -3.66961028399993],
              [119.48365319100003, -3.61492278399993],
              [119.49398847700002, -3.597588799999926],
              [119.50896243600005, -3.577732028999947],
              [119.514008009, -3.563083591999941],
              [119.51197350400003, -3.547621351999908],
              [119.49756920700008, -3.495293877999927],
              [119.49398847700002, -3.488376559999949],
              [119.48585045700008, -3.483493747999944],
              [119.46566816500001, -3.477227471999925],
              [119.45679772200003, -3.470961195999962],
              [119.43238366000003, -3.475030205999929],
              [119.40300540500004, -3.461521091999941],
              [119.37289472700002, -3.442559502999927],
              [119.34693444100003, -3.430596612999921],
              [119.31177819100003, -3.426364841999941],
              [119.29761803500003, -3.427911065999922],
              [119.29167728000004, -3.434014580999929],
              [119.28394616000003, -3.445896091999941],
              [119.24537194100003, -3.476169528999947],
              [119.22966556100005, -3.485284112999921],
              [119.20899498800009, -3.489841403999947],
              [119.19214928500003, -3.486911716999941],
              [119.17595462300005, -3.481377862999921],
              [119.15796959700003, -3.478448174999926],
              [119.14087975400003, -3.48211028399993],
              [119.11768639400009, -3.49968840899993],
              [119.09937584700003, -3.505059502999927],
              [119.02702884200005, -3.509698174999926],
              [118.99870853000004, -3.524997653999947],
              [119.00440514400009, -3.559747002999927],
              [118.99236087300005, -3.556735934999949],
              [118.97917728000004, -3.542168877999927],
              [118.97022545700008, -3.539808851999908],
              [118.96192467500009, -3.546075127999927],
              [118.94947350400003, -3.569024346999925],
              [118.93881269600001, -3.573988539999959],
              [118.92676842500009, -3.56609465899993],
              [118.91684004000001, -3.546807549999926],
              [118.88013756600003, -3.443129164999959],
              [118.85889733200008, -3.411309502999927],
              [118.84896894600001, -3.390557549999926],
              [118.84229576900009, -3.368340752999927],
              [118.83985436300009, -3.348077080999929],
              [118.84376061300009, -3.329034112999921],
              [118.85043379000001, -3.312432549999926],
              [118.85254967500009, -3.295586846999925],
              [118.83448326900009, -3.259942315999922],
              [118.82341556100005, -3.193291924999926],
              [118.81714928500003, -3.171807549999926],
              [118.81185957100001, -3.162530205999929],
              [118.80347741000003, -3.156508070999962],
              [118.79200280000009, -3.151543877999927],
              [118.78199303500003, -3.144301039999959],
              [118.77784264400009, -3.132012627999927],
              [118.77564537900003, -3.122165622999944],
              [118.76636803500003, -3.102634372999944],
              [118.76417076900009, -3.090915622999944],
              [118.76775149800005, -3.084161065999922],
              [118.78492272200003, -3.064548434999949],
              [118.791351759, -3.060153903999947],
              [118.799164259, -3.06178150799991],
              [118.82252037900003, -3.071465752999927],
              [118.83611087300005, -3.073663018999923],
              [118.84839928500003, -3.067803643999923],
              [118.85328209700003, -3.053399346999925],
              [118.85694420700008, -2.972832940999922],
              [118.86402428500003, -2.942966403999947],
              [118.88249759200005, -2.923760674999926],
              [118.88575280000009, -2.909926039999959],
              [118.88770592500009, -2.88250090899993],
              [118.88550866000003, -2.869561455999929],
              [118.88062584700003, -2.86101653399993],
              [118.87240644600001, -2.854668877999927],
              [118.86036217500009, -2.848402601999908],
              [118.834320509, -2.840997002999927],
              [118.81299889400009, -2.844170830999929],
              [118.77165774800005, -2.862074476999908],
              [118.77100670700008, -2.839288018999923],
              [118.760101759, -2.796807549999926],
              [118.75733483200008, -2.775811455999929],
              [118.76042728000004, -2.765394789999959],
              [118.77458743600005, -2.745293877999927],
              [118.77784264400009, -2.734795830999929],
              [118.77784264400009, -2.690118096999925],
              [118.78248131600003, -2.672946872999944],
              [118.79232832100001, -2.649997653999947],
              [118.80616295700008, -2.629815362999921],
              [118.82276451900009, -2.621270440999922],
              [118.84148196700005, -2.627699476999908],
              [118.85547936300009, -2.641534112999921],
              [118.87110436300009, -2.653903903999947],
              [118.89454186300009, -2.656019789999959],
              [118.914398634, -2.648370049999926],
              [118.95850670700008, -2.618747653999947],
              [118.98170006600003, -2.597426039999959],
              [119.00440514400009, -2.585137627999927],
              [119.01490319100003, -2.577243747999944],
              [119.02100670700008, -2.567478122999944],
              [119.031586134, -2.53248463299991],
              [119.04737389400009, -2.512872002999927],
              [119.064789259, -2.503024997999944],
              [119.08350670700008, -2.495049737999921],
              [119.13575280000009, -2.454278252999927],
              [119.14144941500001, -2.441989841999941],
              [119.13754316500001, -2.379571221999925],
              [119.13038170700008, -2.35475025799991],
              [119.12720787900003, -2.255303643999923],
              [119.131195509, -2.244398695999962],
              [119.13843834700003, -2.231052341999941],
              [119.14185631600003, -2.216729424999926],
              [119.13404381600003, -2.203545830999929],
              [119.17123457100001, -2.149509372999944],
              [119.18555748800009, -2.120863539999959],
              [119.21607506600003, -2.009942315999922],
              [119.23462975400003, -1.982191664999959],
              [119.26441491000003, -1.963311455999929],
              [119.28736412900003, -1.958428643999923],
              [119.30404707100001, -1.961521091999941],
              [119.31902103000004, -1.967054945999962],
              [119.33643639400009, -1.970147393999923],
              [119.34701582100001, -1.959405205999929],
              [119.35401451900009, -1.934747002999927],
              [119.36744225400003, -1.847263278999947],
              [119.36703535200002, -1.832940362999921],
              [119.36524498800009, -1.827732028999947],
              [119.36011803500003, -1.824476820999962],
              [119.35010826900009, -1.816176039999959],
              [119.33570397200003, -1.79810963299991],
              [119.32878665500004, -1.781182549999926],
              [119.30844160200002, -1.694919528999947],
              [119.30543053500003, -1.65203215899993],
              [119.30982506600003, -1.63014088299991],
              [119.32886803500003, -1.593194268999923],
              [119.33326256600003, -1.57350025799991],
              [119.30909264400009, -1.504571221999925],
              [119.30241946700005, -1.493747653999947],
              [119.29688561300009, -1.41139088299991],
              [119.29476972700002, -1.405368747999944],
              [119.29444420700008, -1.399183851999908],
              [119.29859459700003, -1.387872002999927],
              [119.30551191500001, -1.38054778399993],
              [119.328461134, -1.36060963299991],
              [119.33326256600003, -1.350192966999941],
              [119.33073978000004, -1.330254815999922],
              [119.312836134, -1.28484465899993],
              [119.31364993600005, -1.24578215899993],
              [119.32837975400003, -1.214450778999947],
              [119.35043379000001, -1.18914153399993],
              [119.37370853000004, -1.168877862999921],
              [119.38135826900009, -1.158623955999929],
              [119.38941491000003, -1.145196221999925],
              [119.39918053500003, -1.133477471999925],
              [119.41187584700003, -1.128513278999947],
              [119.42920983200008, -1.12428150799991],
              [119.44361412900003, -1.113051039999959],
              [119.45313561300009, -1.096449476999908],
              [119.45997155000009, -1.057712497999944],
              [119.47413170700008, -1.020928643999923],
              [119.48243248800009, -0.963474216999941],
              [119.48975670700008, -0.945977471999925],
              [119.50082441500001, -0.932305596999925],
              [119.50855553500003, -0.918715101999908],
              [119.51807701900009, -0.876722914999959],
              [119.52515709700003, -0.860446872999944],
              [119.53736412900003, -0.850030205999929],
              [119.56625410200002, -0.83367278399993],
              [119.57357832100001, -0.829522393999923],
              [119.58716881600003, -0.819431247999944],
              [119.59913170700008, -0.795505466999941],
              [119.60328209700003, -0.791436455999929],
              [119.63445071700005, -0.778415622999944],
              [119.68213951900009, -0.736911716999941],
              [119.65821373800009, -0.712090752999927],
              [119.65479576900009, -0.706149997999944],
              [119.65943444100003, -0.696221612999921],
              [119.67017662900003, -0.689222914999959],
              [119.69263756600003, -0.678806247999944],
              [119.70386803500003, -0.666761976999908],
              [119.72461998800009, -0.639255466999941],
              [119.73365319100003, -0.633884372999944],
              [119.73519941500001, -0.641045830999929],
              [119.75049889400009, -0.678806247999944],
              [119.75562584700003, -0.703789971999925],
              [119.79200280000009, -0.778415622999944],
              [119.80982506600003, -0.833916924999926],
              [119.82488040500004, -0.85865650799991],
              [119.84652754000001, -0.874607028999947],
            ],
          ],
          [
            [
              [127.78589928500003, 2.264227606000077],
              [127.80144290500004, 2.265041408000059],
              [127.81055748800009, 2.263861395000049],
              [127.81511478000004, 2.255275783000059],
              [127.81617272200003, 2.233791408000059],
              [127.80518639400009, 2.21234772300005],
              [127.78126061300009, 2.208929755000042],
              [127.75766035200002, 2.221380927000041],
              [127.74822024800005, 2.247381903000075],
              [127.75171959700003, 2.265855210000041],
              [127.75993899800005, 2.269924221000053],
              [127.78589928500003, 2.264227606000077],
            ],
          ],
          [
            [
              [128.19361412900003, 2.367254950000074],
              [128.192230665, 2.354641018000052],
              [128.1699324880001, 2.297430731000077],
              [128.154633009, 2.286363023000092],
              [128.1411238940001, 2.296372789000088],
              [128.13070722700002, 2.316473700000074],
              [128.12525475400003, 2.335638739000046],
              [128.12525475400003, 2.347479559000078],
              [128.12867272200003, 2.358303127000056],
              [128.1347762380001, 2.368312893000052],
              [128.14210045700008, 2.377834377000056],
              [128.149750196, 2.390611070000091],
              [128.15414472700002, 2.400580145000049],
              [128.1601668630001, 2.404852606000077],
              [128.173187696, 2.40070221600007],
              [128.19361412900003, 2.367254950000074],
            ],
          ],
          [
            [
              [100.94727623800003, 1.825384833000044],
              [100.94190514400003, 1.841864325000074],
              [100.94605553500003, 1.861314195000091],
              [100.94825280000003, 1.882757880000042],
              [100.93702233200003, 1.904527085000041],
              [100.92408287900008, 1.922756252000056],
              [100.91578209700003, 1.944728908000059],
              [100.90577233200003, 1.990464585000041],
              [100.88550866000003, 2.036322333000044],
              [100.82349694100003, 2.11595286700009],
              [100.80323326900003, 2.161810614000046],
              [100.79997806100005, 2.208929755000042],
              [100.81275475400008, 2.249823309000078],
              [100.84115644600007, 2.280829169000071],
              [100.88591556100005, 2.29828522300005],
              [100.90788821700005, 2.299505927000041],
              [101.05030358200003, 2.291489976000094],
              [101.05860436300003, 2.280422268000052],
              [101.05648847700007, 2.241156317000048],
              [101.06739342500003, 2.219794012000079],
              [101.18181399800005, 2.145005601000094],
              [101.29997806100005, 2.046616929000038],
              [101.31714928500003, 2.024603583000044],
              [101.32585696700005, 2.002183335000041],
              [101.32699629000007, 1.981268622000073],
              [101.32341556100005, 1.938950914000088],
              [101.32667076900003, 1.916449286000045],
              [101.35132897200003, 1.86009349200009],
              [101.37761478000004, 1.773260809000078],
              [101.39730879000007, 1.736395575000074],
              [101.42701256600003, 1.70929596600007],
              [101.49447675900007, 1.678697007000039],
              [101.52963300900007, 1.670803127000056],
              [101.56739342500003, 1.655910549000055],
              [101.59156334700003, 1.654689846000053],
              [101.67351321700005, 1.669501044000071],
              [101.71168053500003, 1.671128648000092],
              [101.74919681100005, 1.661525783000059],
              [101.77857506600003, 1.644273179000038],
              [102.02149498800003, 1.437892971000053],
              [102.11817467500003, 1.386542059000078],
              [102.14332116000003, 1.35773346600007],
              [102.15333092500003, 1.311468817000048],
              [102.14698326900003, 1.273138739000046],
              [102.14722741000003, 1.247788804000038],
              [102.15674889400003, 1.236314195000091],
              [102.17310631600003, 1.230902411000045],
              [102.18726647200003, 1.217271226000094],
              [102.19727623800003, 1.199611721000053],
              [102.20101972700007, 1.181708075000074],
              [102.19312584700003, 1.10423411700009],
              [102.19418379000007, 1.065904039000088],
              [102.20850670700003, 1.02407461100006],
              [102.24008222700007, 0.982082424000055],
              [102.32105553500003, 0.917181708000044],
              [102.42505944100003, 0.804266669000071],
              [102.46387780000003, 0.774115302000041],
              [102.50953209700003, 0.75031159100007],
              [102.53223717500003, 0.742377020000049],
              [102.55193118600005, 0.738104559000078],
              [102.59498131600003, 0.736029364000046],
              [102.61638431100005, 0.738267320000091],
              [102.64795983200003, 0.748114325000074],
              [102.66716556100005, 0.75031159100007],
              [102.78126061300003, 0.730902411000045],
              [102.87712649800005, 0.726385809000078],
              [102.91814212300005, 0.70766836100006],
              [102.95378665500004, 0.675848700000074],
              [103.05632571700005, 0.558294989000046],
              [103.08375084700003, 0.515570380000042],
              [103.09229576900003, 0.469183661000045],
              [103.07471764400003, 0.442328192000048],
              [103.03728274800005, 0.42064036700009],
              [102.96143639400003, 0.387193101000094],
              [102.92123457100007, 0.357367255000042],
              [102.89909915500004, 0.344183661000045],
              [102.86150149800005, 0.335760809000078],
              [102.74626712300005, 0.27765534100007],
              [102.73243248800003, 0.266506252000056],
              [102.71566816500007, 0.257635809000078],
              [102.64600670700003, 0.242621161000045],
              [102.62769616000003, 0.234320380000042],
              [102.61988366000003, 0.229478257000039],
              [102.61198978000004, 0.222154039000088],
              [102.59180748800003, 0.18626536700009],
              [102.58187910200007, 0.18109772300005],
              [102.55494225400008, 0.186428127000056],
              [102.53663170700003, 0.199774481000077],
              [102.50269616000003, 0.236395575000074],
              [102.48585045700003, 0.242743231000077],
              [102.45997155000003, 0.24750397300005],
              [102.43726647200003, 0.249172268000052],
              [102.43043053500003, 0.246323960000041],
              [102.43962649800005, 0.239243882000039],
              [102.44939212300005, 0.236476955000057],
              [102.47201582100007, 0.236395575000074],
              [102.48072350400008, 0.234279690000051],
              [102.48658287900008, 0.228908596000053],
              [102.49586022200003, 0.215969143000052],
              [102.51783287900008, 0.192572333000044],
              [102.54574629000007, 0.169134833000044],
              [102.57789147200003, 0.15851471600007],
              [102.61198978000004, 0.173651434000078],
              [102.61898847700007, 0.181626695000091],
              [102.62794030000003, 0.19562409100007],
              [102.63306725400008, 0.201646226000094],
              [102.64437910200007, 0.209540106000077],
              [102.66773522200003, 0.219183661000045],
              [102.67774498800003, 0.225572007000039],
              [102.69548587300005, 0.232082424000055],
              [102.74154707100007, 0.226629950000074],
              [102.76343834700003, 0.228949286000045],
              [102.81820722700007, 0.253729559000078],
              [102.88591556100005, 0.261419989000046],
              [102.90267988400007, 0.267767645000049],
              [102.97291100400008, 0.31313711100006],
              [102.99244225400008, 0.318304755000042],
              [103.00757897200003, 0.324652411000045],
              [103.05762780000003, 0.372951565000051],
              [103.07593834700003, 0.383002020000049],
              [103.09888756600003, 0.391791083000044],
              [103.12256920700003, 0.397935289000088],
              [103.14356530000003, 0.400213934000078],
              [103.16627037900008, 0.407904364000046],
              [103.18132571700005, 0.42641836100006],
              [103.20150800900007, 0.469183661000045],
              [103.22364342500003, 0.488430080000057],
              [103.28012129000007, 0.498602606000077],
              [103.30811608200003, 0.513169664000088],
              [103.33578535200007, 0.531683661000045],
              [103.36215254000007, 0.536281643000052],
              [103.38990319100003, 0.53001536700009],
              [103.42123457100007, 0.516302802000041],
              [103.48096764400003, 0.482326565000051],
              [103.54102623800003, 0.434637762000079],
              [103.58765709700003, 0.376532294000071],
              [103.60629316500007, 0.31085846600007],
              [103.61752363400007, 0.330267645000049],
              [103.62501061300003, 0.339829820000091],
              [103.63428795700003, 0.345648505000042],
              [103.64527428500003, 0.345282294000071],
              [103.65577233200003, 0.340399481000077],
              [103.66488691500007, 0.33470286700009],
              [103.69019616000003, 0.325995184000078],
              [103.71119225400008, 0.311468817000048],
              [103.73047936300003, 0.293443101000094],
              [103.74341881600003, 0.277329820000091],
              [103.76002037900008, 0.239488023000092],
              [103.80046634200005, 0.034572658000059],
              [103.80836022200003, 0.023504950000074],
              [103.81397545700003, 0.018866278000075],
              [103.81128991000003, 0.00853099200009],
              [103.80176842500003, -0.007256768999923],
              [103.79151451900003, -0.012546481999948],
              [103.77833092500003, -0.013116143999923],
              [103.75652103000004, -0.010674737999921],
              [103.67115319100003, -0.017429294999943],
              [103.66374759200005, -0.021742445999962],
              [103.66423587300005, -0.040541273999906],
              [103.65748131600003, -0.044732354999951],
              [103.64470462300005, -0.045993747999944],
              [103.63624108200003, -0.048028252999927],
              [103.62916100400008, -0.048394463999955],
              [103.61988366000003, -0.044732354999951],
              [103.61182701900003, -0.036879164999959],
              [103.60075931100005, -0.016900322999959],
              [103.59205162900008, -0.010674737999921],
              [103.58619225400008, -0.01108163899994],
              [103.57699629000007, -0.013970635999954],
              [103.56869550900007, -0.018568617999961],
              [103.56470787900008, -0.024265231999948],
              [103.56690514400003, -0.035210869999958],
              [103.57341556100005, -0.037163994999958],
              [103.58082116000003, -0.037774346999925],
              [103.58578535200007, -0.044732354999951],
              [103.58423912900008, -0.053155205999929],
              [103.58033287900008, -0.063531182999952],
              [103.57813561300003, -0.074029229999951],
              [103.58716881600003, -0.09498463299991],
              [103.57585696700005, -0.104424737999921],
              [103.55827884200005, -0.110772393999923],
              [103.54420006600003, -0.113702080999929],
              [103.50798587300005, -0.114434502999927],
              [103.49439537900008, -0.11842213299991],
              [103.48902428500003, -0.130791924999926],
              [103.48308353000004, -0.15943775799991],
              [103.46680748800003, -0.183038018999923],
              [103.44304446700005, -0.202080987999921],
              [103.41456139400003, -0.216729424999926],
              [103.30144290500004, -0.23756275799991],
              [103.27051842500003, -0.257582289999959],
              [103.28711998800003, -0.257745049999926],
              [103.31666100400008, -0.262872002999927],
              [103.33253014400003, -0.263848565999922],
              [103.34986412900008, -0.260186455999929],
              [103.38062584700003, -0.247002862999921],
              [103.39714603000004, -0.244073174999926],
              [103.42481530000003, -0.234958591999941],
              [103.45932050900007, -0.21843840899993],
              [103.48926842500003, -0.211521091999941],
              [103.50269616000003, -0.230401299999926],
              [103.49463951900003, -0.25359465899993],
              [103.45671634200005, -0.288995049999926],
              [103.44800866000003, -0.315362237999921],
              [103.43677819100003, -0.337985934999949],
              [103.40951582100007, -0.349704684999949],
              [103.34555097700007, -0.360039971999925],
              [103.34555097700007, -0.36687590899993],
              [103.37940514400003, -0.380303643999923],
              [103.40056399800005, -0.384535414999959],
              [103.41797936300003, -0.377536716999941],
              [103.42953535200007, -0.374932549999926],
              [103.48218834700003, -0.373711846999925],
              [103.49301191500007, -0.375420830999929],
              [103.50269616000003, -0.378513278999947],
              [103.51148522200003, -0.383558851999908],
              [103.52003014400003, -0.391208591999941],
              [103.53052819100003, -0.397149346999925],
              [103.55250084700003, -0.399997653999947],
              [103.59050540500004, -0.424574476999908],
              [103.59839928500003, -0.43678150799991],
              [103.59205162900008, -0.45631275799991],
              [103.57325280000003, -0.475355726999908],
              [103.54704837300005, -0.489841403999947],
              [103.51579837300005, -0.499607028999947],
              [103.41797936300003, -0.517754815999922],
              [103.40162194100003, -0.509535414999959],
              [103.39014733200003, -0.490411065999922],
              [103.37289472700007, -0.449395440999922],
              [103.38038170700003, -0.514336846999925],
              [103.38477623800003, -0.522881768999923],
              [103.40650475400008, -0.540785414999959],
              [103.41456139400003, -0.551853122999944],
              [103.41627037900008, -0.575372002999927],
              [103.40853925900007, -0.604913018999923],
              [103.39356530000003, -0.632012627999927],
              [103.37289472700007, -0.64812590899993],
              [103.37289472700007, -0.654880466999941],
              [103.38892662900008, -0.665948174999926],
              [103.38575280000003, -0.68092213299991],
              [103.36939537900008, -0.693291924999926],
              [103.34555097700007, -0.695896091999941],
              [103.35645592500003, -0.711358330999929],
              [103.37598717500003, -0.726820570999962],
              [103.39991295700003, -0.738864841999941],
              [103.43604576900003, -0.745293877999927],
              [103.43873131600003, -0.746189059999949],
              [103.45069420700003, -0.750095309999949],
              [103.46314537900008, -0.757745049999926],
              [103.46851647200003, -0.767836195999962],
              [103.46485436300003, -0.782972914999959],
              [103.44752037900008, -0.799411716999941],
              [103.44117272200003, -0.812595309999949],
              [103.48536217500003, -0.804945570999962],
              [103.50733483200003, -0.804945570999962],
              [103.52711022200003, -0.816013278999947],
              [103.53760826900003, -0.830336195999962],
              [103.55250084700003, -0.861097914999959],
              [103.56470787900008, -0.874607028999947],
              [103.56910241000003, -0.875664971999925],
              [103.58106530000003, -0.873793226999908],
              [103.58578535200007, -0.874607028999947],
              [103.58741295700003, -0.877048434999949],
              [103.59050540500004, -0.885186455999929],
              [103.59205162900008, -0.887627862999921],
              [103.59831790500004, -0.894463799999926],
              [103.60474694100003, -0.90357838299991],
              [103.61264082100007, -0.911553643999923],
              [103.63445071700005, -0.919366143999923],
              [103.64063561300003, -0.928887627999927],
              [103.64478600400008, -0.938571872999944],
              [103.65040123800003, -0.942966403999947],
              [103.68873131600003, -0.949151299999926],
              [103.70289147200003, -0.960056247999944],
              [103.72510826900003, -0.98560963299991],
              [103.73975670700003, -0.990655205999929],
              [103.76205488400007, -0.992771091999941],
              [103.78003991000003, -0.998793226999908],
              [103.79411868600005, -1.00945403399993],
              [103.80494225400008, -1.024834893999923],
              [103.82081139400003, -1.063083591999941],
              [103.82886803500003, -1.073418877999927],
              [103.83912194100003, -1.032810153999947],
              [103.85629316500007, -1.013767184999949],
              [103.87859134200005, -0.99928150799991],
              [103.90040123800003, -0.990655205999929],
              [103.94239342500003, -0.982028903999947],
              [103.95582116000003, -0.976983330999929],
              [104.02230879000007, -1.008233330999929],
              [104.04078209700003, -1.021742445999962],
              [104.05689537900008, -1.027520440999922],
              [104.10792076900003, -1.02898528399993],
              [104.12696373800003, -1.031670830999929],
              [104.18946373800003, -1.068129164999959],
              [104.21241295700003, -1.073337497999944],
              [104.25367272200003, -1.055840752999927],
              [104.26270592500003, -1.050551039999959],
              [104.31959069100003, -1.033623955999929],
              [104.37720787900008, -1.031670830999929],
              [104.38184655000003, -1.040785414999959],
              [104.41049238400007, -1.128350518999923],
              [104.39747155000003, -1.191338799999926],
              [104.40137780000003, -1.230889580999929],
              [104.41065514400003, -1.262465101999908],
              [104.41504967500003, -1.271905205999929],
              [104.44499759200005, -1.304620049999926],
              [104.44922936300003, -1.316013278999947],
              [104.45606530000003, -1.379082940999922],
              [104.45435631600003, -1.531019789999959],
              [104.46273847700007, -1.57350025799991],
              [104.47925866000003, -1.615817966999941],
              [104.51734459700003, -1.688409112999921],
              [104.53158613400007, -1.73406340899993],
              [104.53353925900007, -1.740492445999962],
              [104.53760826900003, -1.760674737999921],
              [104.53736412900008, -1.772149346999925],
              [104.53345787900008, -1.783461195999962],
              [104.51742597700007, -1.809340101999908],
              [104.51238040500004, -1.821465752999927],
              [104.48902428500003, -1.860039971999925],
              [104.48340905000003, -1.881442966999941],
              [104.48406009200005, -1.897067966999941],
              [104.48682701900003, -1.910332940999922],
              [104.49708092500003, -1.935967705999929],
              [104.51351972700007, -1.918633721999925],
              [104.52735436300003, -1.867445570999962],
              [104.53736412900008, -1.854099216999941],
              [104.56446373800003, -1.857679945999962],
              [104.58668053500003, -1.877211195999962],
              [104.60572350400008, -1.899021091999941],
              [104.62354576900003, -1.909356377999927],
              [104.63697350400008, -1.92156340899993],
              [104.62964928500003, -1.949151299999926],
              [104.61426842500003, -1.97820403399993],
              [104.60279381600003, -1.994724216999941],
              [104.59473717500003, -2.003024997999944],
              [104.58741295700003, -2.012790622999944],
              [104.58887780000003, -2.019463799999926],
              [104.60621178500003, -2.018487237999921],
              [104.62061608200003, -2.010430596999925],
              [104.64258873800003, -1.98170338299991],
              [104.65455162900008, -1.970147393999923],
              [104.65984134200005, -1.990166924999926],
              [104.66041100400008, -2.012872002999927],
              [104.66382897200003, -2.031345309999949],
              [104.67790774800005, -2.038995049999926],
              [104.68083743600005, -2.040134372999944],
              [104.68287194100003, -2.042413018999923],
              [104.68580162900008, -2.044691664999959],
              [104.69190514400003, -2.045830987999921],
              [104.69467207100007, -2.043715101999908],
              [104.69678795700003, -2.038995049999926],
              [104.69996178500003, -2.034356377999927],
              [104.70582116000003, -2.032321872999944],
              [104.71045983200003, -2.029473565999922],
              [104.72917728000004, -2.011651299999926],
              [104.77263431100005, -1.99773528399993],
              [104.81462649800005, -2.008396091999941],
              [104.85027103000004, -2.037855726999908],
              [104.87427819100003, -2.080010674999926],
              [104.88282311300003, -2.125664971999925],
              [104.87614993600005, -2.164727471999925],
              [104.85971113400007, -2.199395440999922],
              [104.82829837300005, -2.246677341999941],
              [104.75700931100005, -2.330498955999929],
              [104.74341881600003, -2.341241143999923],
              [104.72689863400007, -2.344496351999908],
              [104.68474368600005, -2.345798434999949],
              [104.67139733200003, -2.35125090899993],
              [104.65723717500003, -2.36451588299991],
              [104.62338300900007, -2.387465101999908],
              [104.60621178500003, -2.402113539999959],
              [104.67603600400008, -2.371758721999925],
              [104.70964603000004, -2.370863539999959],
              [104.72917728000004, -2.408949476999908],
              [104.73015384200005, -2.452732028999947],
              [104.72681725400008, -2.478122653999947],
              [104.71314537900008, -2.511488539999959],
              [104.71314537900008, -2.557793877999927],
              [104.70923912900008, -2.573988539999959],
              [104.69874108200003, -2.582207940999922],
              [104.68091881600003, -2.590997002999927],
              [104.66098066500007, -2.597832940999922],
              [104.64380944100003, -2.600762627999927],
              [104.63282311300003, -2.60515715899993],
              [104.60279381600003, -2.62664153399993],
              [104.56950931100005, -2.656426690999922],
              [104.54867597700007, -2.68482838299991],
              [104.53598066500007, -2.719333591999941],
              [104.53736412900008, -2.75904713299991],
              [104.53541100400008, -2.757256768999923],
              [104.53321373800003, -2.762627862999921],
              [104.53109785200007, -2.772637627999927],
              [104.54721113400007, -2.759535414999959],
              [104.56275475400008, -2.738376559999949],
              [104.57439212300005, -2.71453215899993],
              [104.57886803500003, -2.693536065999922],
              [104.58513431100005, -2.677666924999926],
              [104.59986412900008, -2.66375090899993],
              [104.63355553500003, -2.642347914999959],
              [104.70281009200005, -2.609470309999949],
              [104.73145592500003, -2.590752862999921],
              [104.75025475400008, -2.560316664999959],
              [104.76856530000003, -2.494724216999941],
              [104.77076256600003, -2.473809502999927],
              [104.76823978000004, -2.430108330999929],
              [104.77182050900007, -2.414239190999922],
              [104.78435306100005, -2.395277601999908],
              [104.81641686300003, -2.36492278399993],
              [104.83220462300005, -2.345310153999947],
              [104.84595787900008, -2.302178643999923],
              [104.86264082100007, -2.28875090899993],
              [104.88331139400003, -2.284926039999959],
              [104.90105228000004, -2.292901299999926],
              [104.90870201900003, -2.312676690999922],
              [104.90870201900003, -2.337334893999923],
              [104.91163170700003, -2.360284112999921],
              [104.92896569100003, -2.374769789999959],
              [104.93091881600003, -2.351169528999947],
              [104.94141686300003, -2.336195570999962],
              [104.95826256600003, -2.328545830999929],
              [104.98023522200003, -2.326429945999962],
              [105.00196373800003, -2.331963799999926],
              [105.01644941500007, -2.344659112999921],
              [105.02906334700003, -2.358493747999944],
              [105.04509524800005, -2.367364190999922],
              [105.05396569100003, -2.367120049999926],
              [105.07520592500003, -2.361504815999922],
              [105.08668053500003, -2.361260674999926],
              [105.09701582100007, -2.365411065999922],
              [105.11133873800003, -2.377699476999908],
              [105.11670983200003, -2.380466403999947],
              [105.13843834700003, -2.37623463299991],
              [105.20215905000003, -2.347426039999959],
              [105.22364342500003, -2.34343840899993],
              [105.24691816500007, -2.342868747999944],
              [105.26929772200003, -2.34734465899993],
              [105.30738366000003, -2.36882903399993],
              [105.33106530000003, -2.373142184999949],
              [105.38021894600007, -2.374769789999959],
              [105.46680748800003, -2.388441664999959],
              [105.51124108200003, -2.390801690999922],
              [105.53500410200007, -2.394789320999962],
              [105.55209394600007, -2.402113539999959],
              [105.55209394600007, -2.408949476999908],
              [105.54883873800003, -2.409356377999927],
              [105.54175866000003, -2.408786716999941],
              [105.53842207100007, -2.408949476999908],
              [105.54900149800005, -2.42115650799991],
              [105.56381269600007, -2.414971612999921],
              [105.57886803500003, -2.402276299999926],
              [105.59001712300005, -2.395277601999908],
              [105.60857181100005, -2.39617278399993],
              [105.62378991000003, -2.401788018999923],
              [105.63331139400003, -2.416192315999922],
              [105.63477623800003, -2.44304778399993],
              [105.62924238400007, -2.464613539999959],
              [105.61117597700007, -2.505954684999949],
              [105.60743248800003, -2.528741143999923],
              [105.60840905000003, -2.552341403999947],
              [105.61207116000003, -2.574151299999926],
              [105.61841881600003, -2.594903252999927],
              [105.62794030000003, -2.615004164999959],
              [105.63851972700007, -2.630791924999926],
              [105.65447024800005, -2.648614190999922],
              [105.67310631600003, -2.663018487999921],
              [105.70199629000007, -2.671319268999923],
              [105.72250410200007, -2.681084893999923],
              [105.73340905000003, -2.68328215899993],
              [105.75709069100003, -2.68287525799991],
              [105.76807701900003, -2.684747002999927],
              [105.77808678500003, -2.690118096999925],
              [105.79493248800003, -2.724053643999923],
              [105.79175866000003, -2.862074476999908],
              [105.80958092500003, -2.899021091999941],
              [105.84017988400007, -2.930108330999929],
              [105.87924238400007, -2.951104424999926],
              [105.92261803500003, -2.957696221999925],
              [105.93327884200005, -2.955987237999921],
              [105.95183353000004, -2.950941664999959],
              [105.96314537900003, -2.950290622999944],
              [105.97510826900003, -2.95281340899993],
              [105.99097741000003, -2.961846612999921],
              [106.00082441500007, -2.963799737999921],
              [106.01563561300003, -2.969496351999908],
              [106.02849368600005, -2.982842705999929],
              [106.04558353000004, -3.012302341999941],
              [106.05404707100007, -3.046970309999949],
              [106.05347741000003, -3.12859465899993],
              [106.05933678500003, -3.170017184999949],
              [106.06373131600003, -3.179864190999922],
              [106.07650800900007, -3.20086028399993],
              [106.07976321700005, -3.211521091999941],
              [106.07935631600003, -3.223728122999944],
              [106.07422936300003, -3.244724216999941],
              [106.07300866000003, -3.25554778399993],
              [106.06316165500004, -3.266696872999944],
              [105.99724368600005, -3.300225518999923],
              [105.96273847700007, -3.328789971999925],
              [105.92904707100007, -3.365411065999922],
              [105.90023847700007, -3.407159112999921],
              [105.88111412900003, -3.451104424999926],
              [105.81959069100003, -3.672539971999925],
              [105.82569420700003, -3.711521091999941],
              [105.85108483200003, -3.743340752999927],
              [105.93344160200007, -3.802341403999947],
              [105.95248457100007, -3.833754164999959],
              [105.95289147200003, -3.869073174999926],
              [105.93580162900003, -3.90984465899993],
              [105.87012780000003, -4.004164320999905],
              [105.86060631600003, -4.036716403999947],
              [105.85523522200003, -4.070896091999941],
              [105.83130944100003, -4.140232028999947],
              [105.82797285200007, -4.157972914999959],
              [105.81275475400003, -4.238702080999929],
              [105.81421959700003, -4.27312590899993],
              [105.81902103000004, -4.300225518999923],
              [105.82960045700003, -4.324476820999905],
              [105.84603925900007, -4.35320403399993],
              [105.85743248800003, -4.381280205999929],
              [105.85328209700003, -4.403903903999947],
              [105.86817467500003, -4.412041924999926],
              [105.87916100400003, -4.424899997999944],
              [105.89478600400003, -4.458428643999923],
              [105.89698326900003, -4.455498955999929],
              [105.89747155000003, -4.454522393999923],
              [105.90162194100003, -4.451755466999941],
              [105.90626061300003, -4.469333591999941],
              [105.89869225400003, -4.511976820999905],
              [105.90943444100003, -4.546644789999959],
              [105.90267988400007, -4.56568775799991],
              [105.89291425900007, -4.585137627999927],
              [105.88795006600003, -4.601820570999905],
              [105.89063561300003, -4.619398695999905],
              [105.90503991000003, -4.670098565999922],
              [105.89047285200007, -4.677829684999949],
              [105.88184655000003, -4.696221612999921],
              [105.86866295700003, -4.78093840899993],
              [105.86744225400003, -4.824639580999929],
              [105.87240644600007, -4.848565362999921],
              [105.90845787900003, -4.910332940999922],
              [105.90967858200003, -4.943129164999959],
              [105.89682050900007, -4.975192966999941],
              [105.87956790500004, -5.007582289999959],
              [105.86744225400003, -5.041273695999905],
              [105.86182701900003, -5.126560153999947],
              [105.86744225400003, -5.211358330999929],
              [105.86451256600003, -5.25554778399993],
              [105.83952884200005, -5.33717213299991],
              [105.83334394600007, -5.383233330999929],
              [105.83961022200003, -5.468926690999922],
              [105.83619225400003, -5.491794528999947],
              [105.82406660200007, -5.530450127999927],
              [105.83277428500003, -5.592543226999908],
              [105.83334394600007, -5.633721612999921],
              [105.82960045700003, -5.654717705999929],
              [105.81128991000003, -5.696872653999947],
              [105.80543053500003, -5.71843840899993],
              [105.79363040500004, -5.795586846999925],
              [105.78256269600007, -5.828545830999929],
              [105.76441491000003, -5.856215101999908],
              [105.73357181100005, -5.89031340899993],
              [105.72974694100003, -5.896661065999922],
              [105.71989993600005, -5.887139580999929],
              [105.71949303500003, -5.848728122999944],
              [105.71290123800003, -5.832126559999949],
              [105.68100019600007, -5.819024346999925],
              [105.60206139400003, -5.80982838299991],
              [105.58619225400003, -5.790785414999959],
              [105.58082116000003, -5.713148695999905],
              [105.56861412900003, -5.680352471999925],
              [105.54525800900007, -5.657647393999923],
              [105.53988691500007, -5.662692966999941],
              [105.53028405000003, -5.675551039999959],
              [105.52540123800003, -5.678806247999944],
              [105.51498457100007, -5.677829684999949],
              [105.50733483200003, -5.672784112999921],
              [105.50074303500003, -5.667087497999944],
              [105.49390709700003, -5.664483330999929],
              [105.48357181100005, -5.658949476999908],
              [105.44971764400003, -5.623467705999929],
              [105.39820397200003, -5.58131275799991],
              [105.37598717500003, -5.557712497999944],
              [105.31072024800005, -5.465997002999927],
              [105.27963300900007, -5.444268487999921],
              [105.25049889400003, -5.459079684999949],
              [105.24634850400003, -5.478773695999905],
              [105.25700931100005, -5.51726653399993],
              [105.24708092500003, -5.537530205999929],
              [105.24789472700007, -5.541273695999905],
              [105.23878014400003, -5.568942966999941],
              [105.23617597700007, -5.57195403399993],
              [105.23080488400007, -5.576348565999922],
              [105.21900475400003, -5.574802341999941],
              [105.20215905000003, -5.568942966999941],
              [105.18002363400007, -5.580498955999929],
              [105.18018639400003, -5.59693775799991],
              [105.18978925900007, -5.617282809999949],
              [105.19581139400003, -5.64031340899993],
              [105.19581139400003, -5.667901299999926],
              [105.19922936300003, -5.678887627999927],
              [105.20671634200005, -5.686944268999923],
              [105.21371504000007, -5.692966403999947],
              [105.21631920700003, -5.698011976999908],
              [105.20191491000003, -5.706801039999959],
              [105.17546634200005, -5.715590101999908],
              [105.15479576900003, -5.726820570999905],
              [105.15805097700007, -5.742933851999908],
              [105.17798912900003, -5.750420830999929],
              [105.20215905000003, -5.75359465899993],
              [105.21534264400003, -5.75904713299991],
              [105.20215905000003, -5.773695570999905],
              [105.18360436300003, -5.782159112999921],
              [105.16325931100005, -5.786065362999921],
              [105.13062584700003, -5.787367445999905],
              [105.11841881600003, -5.782159112999921],
              [105.07300866000003, -5.746351820999905],
              [104.90105228000004, -5.671319268999923],
              [104.83863366000003, -5.623467705999929],
              [104.79078209700003, -5.609470309999949],
              [104.76929772200003, -5.591973565999922],
              [104.70972741000003, -5.525811455999929],
              [104.69841556100005, -5.515557549999926],
              [104.68132571700005, -5.506931247999944],
              [104.64226321700005, -5.497816664999959],
              [104.62281334700003, -5.490655205999929],
              [104.61304772200003, -5.478936455999929],
              [104.60621178500003, -5.478936455999929],
              [104.60816491000003, -5.483330987999921],
              [104.61304772200003, -5.49928150799991],
              [104.58708743600005, -5.49928150799991],
              [104.56763756600003, -5.50123463299991],
              [104.55144290500004, -5.508477471999925],
              [104.53419030000003, -5.523858330999929],
              [104.52849368600005, -5.540459893999923],
              [104.53321373800003, -5.55982838299991],
              [104.68873131600003, -5.80787525799991],
              [104.69776451900003, -5.84539153399993],
              [104.70240319100003, -5.886976820999905],
              [104.71387780000003, -5.910088799999926],
              [104.71607506600003, -5.921075127999927],
              [104.71094811300003, -5.927829684999949],
              [104.69906660200007, -5.930433851999908],
              [104.56128991000003, -5.928317966999941],
              [104.55339603000004, -5.919122002999927],
              [104.55836022200003, -5.883558851999908],
              [104.55372155000003, -5.860039971999925],
              [104.54175866000003, -5.841892184999949],
              [104.48878014400003, -5.796970309999949],
              [104.47877037900008, -5.790215752999927],
              [104.46314537900008, -5.782810153999947],
              [104.45671634200005, -5.772067966999941],
              [104.44922936300003, -5.752618096999925],
              [104.38404381600003, -5.692478122999944],
              [104.36768639400003, -5.685723565999922],
              [104.29769941500007, -5.643324476999908],
              [104.29078209700003, -5.625420830999929],
              [104.31446373800003, -5.605075778999947],
              [104.30152428500003, -5.58562590899993],
              [104.25798587300005, -5.539808851999908],
              [104.23617597700007, -5.527276299999926],
              [104.22478274800005, -5.524021091999941],
              [104.21566816500007, -5.52271900799991],
              [104.20671634200005, -5.520440362999921],
              [104.19532311300003, -5.513604424999926],
              [104.18978925900007, -5.505303643999923],
              [104.18490644600007, -5.493747653999947],
              [104.17750084700003, -5.483330987999921],
              [104.14486738400007, -5.47389088299991],
              [104.12663821700005, -5.461683851999908],
              [104.11085045700003, -5.446221612999921],
              [104.03882897200003, -5.356622002999927],
              [103.99317467500003, -5.312676690999922],
              [103.98812910200007, -5.296319268999923],
              [103.99976647200003, -5.276950778999947],
              [104.00245201900003, -5.262872002999927],
              [103.99138431100005, -5.246351820999905],
              [103.97510826900003, -5.232354424999926],
              [103.96257571700005, -5.225030205999929],
              [103.94109134200005, -5.222832940999922],
              [103.91879316500007, -5.223077080999929],
              [103.90137780000003, -5.218519789999959],
              [103.89429772200003, -5.201429945999905],
              [103.89730879000007, -5.191664320999905],
              [103.91098066500007, -5.172295830999929],
              [103.91407311300003, -5.160088799999926],
              [103.91342207100007, -5.139255466999941],
              [103.91187584700003, -5.130791924999926],
              [103.90845787900008, -5.123223565999922],
              [103.89112389400003, -5.104180596999925],
              [103.83228600400008, -5.06804778399993],
              [103.80762780000003, -5.041924737999921],
              [103.79216556100005, -5.03093840899993],
              [103.77377363400007, -5.026462497999944],
              [103.74822024800005, -5.026543877999927],
              [103.73682701900003, -5.023695570999905],
              [103.72608483200003, -5.016778252999927],
              [103.72584069100003, -5.007012627999927],
              [103.73552493600005, -4.977959893999923],
              [103.73292076900003, -4.971774997999944],
              [103.72681725400008, -4.968682549999926],
              [103.71745853000004, -4.961846612999921],
              [103.70541425900007, -4.955010674999926],
              [103.69206790500004, -4.951918226999908],
              [103.68165123800003, -4.954685153999947],
              [103.67172285200007, -4.961521091999941],
              [103.65406334700003, -4.979180596999925],
              [103.63062584700003, -4.934991143999923],
              [103.61695397200003, -4.919854424999926],
              [103.59205162900008, -4.910332940999922],
              [103.58464603000004, -4.909600518999923],
              [103.56128991000003, -4.910332940999922],
              [103.55355879000007, -4.908868096999925],
              [103.55005944100003, -4.905368747999944],
              [103.54786217500003, -4.901055596999925],
              [103.54420006600003, -4.897230726999908],
              [103.53370201900003, -4.890232028999947],
              [103.51832116000003, -4.875664971999925],
              [103.51002037900008, -4.869317315999922],
              [103.50001061300003, -4.863946221999925],
              [103.48780358200003, -4.859144789999959],
              [103.47478274800005, -4.856052341999941],
              [103.46168053500003, -4.855726820999905],
              [103.44988040500004, -4.859795830999929],
              [103.43702233200003, -4.866306247999944],
              [103.42481530000003, -4.870863539999959],
              [103.41456139400003, -4.869317315999922],
              [103.40984134200005, -4.860039971999925],
              [103.39340254000007, -4.81414153399993],
              [103.38599694100003, -4.804945570999905],
              [103.37818444100003, -4.798923434999949],
              [103.35922285200007, -4.787367445999905],
              [103.34449303500003, -4.80046965899993],
              [103.32886803500003, -4.794122002999927],
              [103.31657962300005, -4.776543877999927],
              [103.30355879000007, -4.734144789999959],
              [103.28451582100007, -4.715020440999922],
              [103.17286217500003, -4.617933851999908],
              [103.04997806100005, -4.543064059999949],
              [102.92042076900003, -4.492608330999929],
              [102.90430748800003, -4.47779713299991],
              [102.88990319100003, -4.440362237999921],
              [102.87631269600007, -4.420586846999925],
              [102.70118248800003, -4.270440362999921],
              [102.52751712300005, -4.151136976999908],
              [102.36622155000003, -4.026462497999944],
              [102.33936608200003, -4.011325778999947],
              [102.31251061300003, -3.99146900799991],
              [102.29175866000003, -3.965427341999941],
              [102.28353925900007, -3.93092213299991],
              [102.28785241000003, -3.91529713299991],
              [102.30665123800003, -3.884698174999926],
              [102.31088300900007, -3.865411065999922],
              [102.30453535200007, -3.845147393999923],
              [102.27409915500004, -3.810479424999926],
              [102.26319420700003, -3.793145440999922],
              [102.26107832100007, -3.781914971999925],
              [102.26172936300003, -3.772556247999944],
              [102.26319420700003, -3.764825127999927],
              [102.26319420700003, -3.758396091999941],
              [102.25766035200007, -3.746840101999908],
              [102.25082441500007, -3.737725518999923],
              [102.24512780000003, -3.727959893999923],
              [102.24268639400003, -3.714613539999959],
              [102.24048912900008, -3.678480726999908],
              [102.23438561300003, -3.659356377999927],
              [102.22217858200003, -3.642836195999905],
              [102.06568444100003, -3.55046965899993],
              [101.87696373800003, -3.421319268999923],
              [101.63746178500003, -3.250664971999925],
              [101.61133873800003, -3.224541924999926],
              [101.58448326900003, -3.176853122999944],
              [101.56495201900003, -3.162286065999922],
              [101.41895592500003, -2.927341403999947],
              [101.40796959700003, -2.885511976999908],
              [101.32699629000007, -2.739190362999921],
              [101.29932701900003, -2.707614841999941],
              [101.26254316500007, -2.68328215899993],
              [101.17839603000004, -2.641289971999925],
              [101.13982181100005, -2.61687590899993],
              [101.10482832100007, -2.587090752999927],
              [101.01783287900008, -2.467950127999927],
              [100.92310631600003, -2.333428643999923],
              [100.83952884200005, -2.16725025799991],
              [100.83399498800003, -2.159112237999921],
              [100.83155358200003, -2.141289971999925],
              [100.84571373800003, -2.119398695999962],
              [100.87826582100007, -2.080010674999926],
              [100.88721764400003, -2.037204684999949],
              [100.88135826900003, -1.994886976999908],
              [100.87061608200003, -1.953301690999922],
              [100.86459394600007, -1.912367445999962],
              [100.85759524800005, -1.89185963299991],
              [100.84107506600003, -1.87037525799991],
              [100.78394616000003, -1.815524997999944],
              [100.77605228000004, -1.805759372999944],
              [100.77133222700007, -1.795586846999925],
              [100.76465905000003, -1.772067966999941],
              [100.71843509200005, -1.698174737999921],
              [100.66830488400007, -1.639743747999944],
              [100.65447024800005, -1.617608330999929],
              [100.64551842500003, -1.594008070999962],
              [100.63656660200007, -1.551364841999941],
              [100.63257897200003, -1.507989190999922],
              [100.62435957100007, -1.497491143999923],
              [100.58464603000004, -1.460381768999923],
              [100.57056725400008, -1.442559502999927],
              [100.57642662900008, -1.437758070999962],
              [100.57992597700007, -1.431898695999962],
              [100.58423912900008, -1.415785414999959],
              [100.58171634200005, -1.416680596999925],
              [100.57325280000003, -1.407647393999923],
              [100.57056725400008, -1.408379815999922],
              [100.57276451900003, -1.404473565999922],
              [100.57740319100003, -1.39812590899993],
              [100.58187910200007, -1.393649997999944],
              [100.58423912900008, -1.394707940999922],
              [100.57683353000004, -1.355645440999922],
              [100.56918379000007, -1.330824476999908],
              [100.55990644600007, -1.31959400799991],
              [100.53980553500003, -1.314222914999959],
              [100.49870853000004, -1.29029713299991],
              [100.47917728000004, -1.282972914999959],
              [100.47348066500007, -1.278497002999927],
              [100.46412194100003, -1.268161716999941],
              [100.45826256600003, -1.263848565999922],
              [100.45557701900003, -1.265720309999949],
              [100.45346113400007, -1.269707940999922],
              [100.45045006600003, -1.271905205999929],
              [100.42579186300003, -1.276055596999925],
              [100.41553795700003, -1.274509372999944],
              [100.40601647200003, -1.264418226999908],
              [100.40967858200003, -1.258558851999908],
              [100.42652428500003, -1.243910414999959],
              [100.43181399800005, -1.234551690999922],
              [100.43360436300003, -1.228692315999922],
              [100.43327884200005, -1.20671965899993],
              [100.42741946700005, -1.192559502999927],
              [100.38493899800005, -1.155205987999921],
              [100.37012780000003, -1.160902601999908],
              [100.36605879000007, -1.150485934999949],
              [100.36801191500007, -1.133721612999921],
              [100.37126712300005, -1.121026299999926],
              [100.37419681100005, -1.117608330999929],
              [100.37875410200007, -1.115166924999926],
              [100.38306725400008, -1.111423434999949],
              [100.38493899800005, -1.103936455999929],
              [100.38331139400003, -1.096774997999944],
              [100.37126712300005, -1.073337497999944],
              [100.38103274800005, -1.068617445999962],
              [100.39193769600007, -1.067071221999925],
              [100.40284264400003, -1.068617445999962],
              [100.41285241000003, -1.073337497999944],
              [100.41635175900007, -1.064629815999922],
              [100.41773522200003, -1.056247653999947],
              [100.41635175900007, -1.047784112999921],
              [100.41285241000003, -1.039157809999949],
              [100.39096113400007, -1.041599216999941],
              [100.37989342500003, -1.030450127999927],
              [100.35303795700003, -0.977146091999941],
              [100.34400475400008, -0.908786716999941],
              [100.32789147200003, -0.858819268999923],
              [100.30144290500004, -0.816338799999926],
              [100.15967858200003, -0.667901299999926],
              [100.13404381600003, -0.634698174999926],
              [100.09058678500003, -0.557224216999941],
              [100.03492272200003, -0.48796965899993],
              [100.00131269600007, -0.45631275799991],
              [99.93043053500003, -0.40943775799991],
              [99.91944420700003, -0.398044528999947],
              [99.91032962300005, -0.375176690999922],
              [99.88884524800005, -0.357598565999922],
              [99.84359785200007, -0.332126559999949],
              [99.82398522200003, -0.313409112999921],
              [99.81381269600007, -0.29461028399993],
              [99.81006920700003, -0.273370049999926],
              [99.80958092500003, -0.247165622999944],
              [99.80591881600003, -0.22779713299991],
              [99.79721113400007, -0.215915622999944],
              [99.78598066500007, -0.206638278999947],
              [99.77540123800003, -0.195570570999962],
              [99.76587975400008, -0.181247653999947],
              [99.75945071700005, -0.168389580999929],
              [99.75603274800005, -0.154717705999929],
              [99.75489342500003, -0.137302341999941],
              [99.75798587300005, -0.115817966999941],
              [99.76384524800005, -0.095879815999922],
              [99.76677493600005, -0.075372002999927],
              [99.76172936300003, -0.052178643999923],
              [99.74724368600005, -0.02983977699995],
              [99.68946373800003, 0.020086981000077],
              [99.63282311300003, 0.081000067000048],
              [99.61085045700003, 0.098578192000048],
              [99.53402754000007, 0.140326239000046],
              [99.49048912900008, 0.155422268000052],
              [99.45020592500003, 0.161281643000052],
              [99.42693118600005, 0.161363023000092],
              [99.40821373800003, 0.163885809000078],
              [99.39258873800003, 0.171698309000078],
              [99.37818444100003, 0.187974351000094],
              [99.35661868600005, 0.225653387000079],
              [99.34107506600003, 0.238755601000094],
              [99.31617272200003, 0.242621161000045],
              [99.29656009200005, 0.237697658000059],
              [99.26059004000007, 0.219875393000052],
              [99.24415123800003, 0.215969143000052],
              [99.23340905000003, 0.217027085000041],
              [99.22193444100003, 0.220363674000055],
              [99.21127363400007, 0.225653387000079],
              [99.20313561300003, 0.23273346600007],
              [99.19369550900007, 0.243150132000039],
              [99.18881269600007, 0.245591539000088],
              [99.18230228000004, 0.244086005000042],
              [99.16871178500003, 0.242621161000045],
              [99.16211998800003, 0.245266018000052],
              [99.14234459700003, 0.258246161000045],
              [99.13795006600003, 0.263088283000059],
              [99.13933353000004, 0.27374909100007],
              [99.15308678500003, 0.287176825000074],
              [99.15845787900008, 0.297837632000039],
              [99.15845787900008, 0.320013739000046],
              [99.14844811300003, 0.333156643000052],
              [99.13152103000004, 0.34056224200009],
              [99.11060631600003, 0.345648505000042],
              [99.12875410200007, 0.391791083000044],
              [99.13233483200003, 0.412054755000042],
              [99.12720787900008, 0.484361070000091],
              [99.12256920700003, 0.509019273000092],
              [99.11060631600003, 0.523830471000053],
              [99.09839928500003, 0.514227606000077],
              [99.09734134200005, 0.530747789000088],
              [99.10385175900007, 0.57843659100007],
              [99.10027103000004, 0.601752020000049],
              [99.08985436300003, 0.622015692000048],
              [99.07276451900003, 0.630804755000042],
              [99.04859459700003, 0.619940497000073],
              [99.04004967500003, 0.650458075000074],
              [99.04737389400003, 0.739732164000088],
              [99.04175866000003, 0.777044989000046],
              [99.00611412900008, 0.818752346000053],
              [98.99732506600003, 0.825425523000092],
              [98.98121178500003, 0.831732489000046],
              [98.97673587300005, 0.847357489000046],
              [98.98031660200007, 0.886216539000088],
              [98.97584069100003, 0.920843817000048],
              [98.91732832100007, 1.117173570000091],
              [98.85059655000003, 1.277289130000042],
              [98.83904056100005, 1.301255601000094],
              [98.83692467500003, 1.311468817000048],
              [98.83887780000003, 1.321356512000079],
              [98.84294681100005, 1.33344147300005],
              [98.84457441500007, 1.345892645000049],
              [98.84001712300005, 1.356756903000075],
              [98.79908287900008, 1.39874909100007],
              [98.78858483200003, 1.413804429000038],
              [98.77540123800003, 1.451564846000053],
              [98.77027428500003, 1.474595445000091],
              [98.76807701900003, 1.49359772300005],
              [98.76465905000003, 1.498846747000073],
              [98.75652103000004, 1.504461981000077],
              [98.74626712300005, 1.508937893000052],
              [98.73698978000004, 1.510687567000048],
              [98.73023522200003, 1.51439036700009],
              [98.72584069100003, 1.523627020000049],
              [98.72022545700003, 1.545396226000094],
              [98.70964603000004, 1.564113674000055],
              [98.71127363400007, 1.569566148000092],
              [98.72706139400003, 1.572170315000051],
              [98.73365319100003, 1.569891669000071],
              [98.74040774800005, 1.56391022300005],
              [98.74537194100003, 1.556138414000088],
              [98.74740644600007, 1.548529364000046],
              [98.75342858200003, 1.535630601000094],
              [98.76644941500007, 1.549017645000049],
              [98.78858483200003, 1.586411851000094],
              [98.79818769600007, 1.59906647300005],
              [98.81885826900003, 1.619696356000077],
              [98.82260175900007, 1.630438544000071],
              [98.82357832100007, 1.666693427000041],
              [98.81910241000003, 1.682318427000041],
              [98.80591881600003, 1.688869533000059],
              [98.78809655000003, 1.691351630000042],
              [98.78370201900003, 1.699042059000078],
              [98.78451582100007, 1.711859442000048],
              [98.78296959700003, 1.729722398000092],
              [98.77393639400003, 1.748602606000077],
              [98.76010175900007, 1.764146226000094],
              [98.72706139400003, 1.791896877000056],
              [98.71501712300005, 1.784979559000078],
              [98.71111087300005, 1.779120184000078],
              [98.71273847700007, 1.763902085000041],
              [98.71509850400008, 1.76398346600007],
              [98.72494550900007, 1.756822007000039],
              [98.72706139400003, 1.75649648600006],
              [98.72673587300005, 1.749416408000059],
              [98.72152754000007, 1.739081122000073],
              [98.72022545700003, 1.733465887000079],
              [98.71111087300005, 1.725775458000044],
              [98.69068444100003, 1.736273505000042],
              [98.65821373800003, 1.763902085000041],
              [98.57618248800003, 1.888088283000059],
              [98.53516686300003, 1.936468817000048],
              [98.44402103000004, 1.991156317000048],
              [98.42611738400007, 1.997626044000071],
              [98.40699303500003, 2.001939195000091],
              [98.38786868600005, 2.003485419000071],
              [98.36597741000003, 2.002875067000048],
              [98.35450280000003, 2.003810940000051],
              [98.34961998800003, 2.007228908000059],
              [98.34937584700003, 2.021429755000042],
              [98.34717858200003, 2.028998114000046],
              [98.34115644600007, 2.033392645000049],
              [98.32984459700003, 2.038275458000044],
              [98.31177819100003, 2.039618231000077],
              [98.28882897200003, 2.037339585000041],
              [98.26921634200005, 2.038072007000039],
              [98.26091556100005, 2.048529364000046],
              [98.25611412900008, 2.073309637000079],
              [98.24366295700003, 2.087551174000055],
              [98.20948326900003, 2.109930731000077],
              [98.15259850400008, 2.156927802000041],
              [98.08961022200003, 2.195868231000077],
              [97.98357181100005, 2.244370835000041],
              [97.95590254000007, 2.271714585000041],
              [97.93336022200003, 2.269761460000041],
              [97.88111412900008, 2.25031159100007],
              [97.86687259200005, 2.247463283000059],
              [97.85075931100005, 2.251206773000092],
              [97.82943769600007, 2.264227606000077],
              [97.81771894600007, 2.258937893000052],
              [97.80990644600007, 2.263657945000091],
              [97.80339603000004, 2.272040106000077],
              [97.79476972700007, 2.277818101000094],
              [97.78614342500003, 2.278021552000041],
              [97.76856530000003, 2.273016669000071],
              [97.75733483200003, 2.271673895000049],
              [97.74439537900008, 2.281073309000078],
              [97.70606530000003, 2.346136786000045],
              [97.67644290500004, 2.375921942000048],
              [97.66358483200003, 2.392075914000088],
              [97.65821373800003, 2.41156647300005],
              [97.66114342500003, 2.527329820000091],
              [97.64405358200003, 2.668890692000048],
              [97.60889733200003, 2.848618882000039],
              [97.60271243600005, 2.866197007000039],
              [97.59278405000003, 2.87368398600006],
              [97.57740319100003, 2.875921942000048],
              [97.53532962300005, 2.888251044000071],
              [97.48462975400008, 2.913031317000048],
              [97.46387780000003, 2.919623114000046],
              [97.44166100400008, 2.922105210000041],
              [97.42212975400008, 2.92837148600006],
              [97.40503991000003, 2.943345445000091],
              [97.33204186300003, 3.031398830000057],
              [97.31348717500003, 3.061672268000052],
              [97.30079186300003, 3.093410549000055],
              [97.28516686300003, 3.17845286700009],
              [97.27076256600003, 3.214422919000071],
              [97.24048912900008, 3.238023179000038],
              [97.20671634200005, 3.240790106000077],
              [97.18262780000003, 3.245998440000051],
              [97.17164147200003, 3.254828192000048],
              [97.16635175900007, 3.267971096000053],
              [97.01856530000003, 3.522691148000092],
              [96.99976647200003, 3.545884507000039],
              [96.92172285200007, 3.605698960000041],
              [96.90349368600005, 3.634670315000051],
              [96.89210045700003, 3.666489976000094],
              [96.88355553500003, 3.682440497000073],
              [96.87305748800003, 3.689276434000078],
              [96.86605879000007, 3.69212474200009],
              [96.84205162900008, 3.706732489000046],
              [96.83814537900008, 3.712632554000038],
              [96.82886803500003, 3.716620184000078],
              [96.81763756600003, 3.719916083000044],
              [96.80787194100003, 3.72406647300005],
              [96.77800540500004, 3.742987372000073],
              [96.76050866000003, 3.74868398600006],
              [96.55982506600003, 3.746568101000094],
              [96.51986738400007, 3.754828192000048],
              [96.47950280000003, 3.778713283000059],
              [96.43034915500004, 3.825262762000079],
              [96.27930748800003, 4.025783596000053],
              [96.21143639400003, 4.093939520000049],
              [96.20753014400003, 4.100490627000056],
              [96.20191491000003, 4.115179755000042],
              [96.19776451900003, 4.121283270000049],
              [96.19092858200003, 4.125962632000039],
              [96.17530358200003, 4.132717190000051],
              [96.16765384200005, 4.138373114000046],
              [96.15967858200003, 4.141302802000041],
              [96.14714603000004, 4.142482815000051],
              [96.13526451900003, 4.141669012000079],
              [96.13013756600003, 4.138373114000046],
              [96.12517337300005, 4.136419989000046],
              [96.11378014400003, 4.147162177000041],
              [96.06519616000003, 4.205023505000042],
              [96.04965254000007, 4.21430084800005],
              [96.03077233200003, 4.217474677000041],
              [96.01002037900008, 4.225653387000079],
              [95.90349368600005, 4.344712632000039],
              [95.81413821700005, 4.432847398000092],
              [95.80713951900003, 4.446112372000073],
              [95.75896243600005, 4.484442450000074],
              [95.72584069100003, 4.531683661000045],
              [95.65650475400008, 4.579982815000051],
              [95.61654707100007, 4.628404039000088],
              [95.59896894600007, 4.635199286000045],
              [95.57618248800003, 4.634670315000051],
              [95.56544030000003, 4.637518622000073],
              [95.56088300900007, 4.645738023000092],
              [95.56324303500003, 4.651556708000044],
              [95.57292728000004, 4.660711981000077],
              [95.57520592500003, 4.666571356000077],
              [95.57252037900008, 4.673814195000091],
              [95.56666100400008, 4.675197658000059],
              [95.55958092500003, 4.674627997000073],
              [95.55404707100007, 4.676214911000045],
              [95.52686608200003, 4.697251695000091],
              [95.51514733200003, 4.71352773600006],
              [95.48910566500007, 4.76243724200009],
              [95.46843509200005, 4.789496161000045],
              [95.45997155000003, 4.79718659100007],
              [95.44125410200007, 4.810614325000074],
              [95.43433678500003, 4.81712474200009],
              [95.42628014400003, 4.827337958000044],
              [95.42457116000003, 4.83234284100007],
              [95.42505944100003, 4.83734772300005],
              [95.42383873800003, 4.847479559000078],
              [95.41846764400003, 4.862494208000044],
              [95.40577233200003, 4.887681382000039],
              [95.40015709700003, 4.910549221000053],
              [95.38599694100003, 4.935126044000071],
              [95.37989342500003, 4.960435289000088],
              [95.34888756600003, 5.037502346000053],
              [95.33887780000003, 5.053534247000073],
              [95.32447350400008, 5.070298570000091],
              [95.31283613400007, 5.087144273000092],
              [95.30591881600003, 5.103583075000074],
              [95.29688561300003, 5.116400458000044],
              [95.27979576900003, 5.12250397300005],
              [95.29916425900007, 5.150336005000042],
              [95.30160566500007, 5.172430731000077],
              [95.29127037900008, 5.191636460000041],
              [95.27295983200003, 5.211167710000041],
              [95.25603274800005, 5.22337474200009],
              [95.24870853000004, 5.231024481000077],
              [95.24561608200003, 5.24164459800005],
              [95.24398847700007, 5.256048895000049],
              [95.23951256600003, 5.270819403000075],
              [95.23194420700003, 5.282294012000079],
              [95.22144616000003, 5.286932684000078],
              [95.19898522200003, 5.292873440000051],
              [95.20533287900008, 5.307562567000048],
              [95.22217858200003, 5.326402085000041],
              [95.23194420700003, 5.344631252000056],
              [95.23389733200003, 5.359320380000042],
              [95.24529056100005, 5.379136460000041],
              [95.25171959700003, 5.395575262000079],
              [95.25359134200005, 5.41156647300005],
              [95.24968509200005, 5.424953518000052],
              [95.23194420700003, 5.450751044000071],
              [95.24545332100007, 5.460516669000071],
              [95.23682701900003, 5.474025783000059],
              [95.22388756600003, 5.489569403000075],
              [95.22510826900003, 5.505438544000071],
              [95.20362389400003, 5.533677476000094],
              [95.19727623800003, 5.546372789000088],
              [95.21273847700007, 5.573146877000056],
              [95.22388756600003, 5.580267645000049],
              [95.23878014400003, 5.574367580000057],
              [95.25049889400003, 5.579046942000048],
              [95.26042728000004, 5.577541408000059],
              [95.26970462300005, 5.574408270000049],
              [95.27979576900003, 5.574367580000057],
              [95.28834069100003, 5.57876211100006],
              [95.30494225400008, 5.591986395000049],
              [95.31576582100007, 5.59796784100007],
              [95.33529707100007, 5.612127997000073],
              [95.34522545700003, 5.615301825000074],
              [95.35889733200003, 5.616888739000046],
              [95.36915123800003, 5.621283270000049],
              [95.41285241000003, 5.649562893000052],
              [95.43189537900008, 5.654689846000053],
              [95.44971764400003, 5.649562893000052],
              [95.47706139400003, 5.623602606000077],
              [95.49431399800005, 5.612290757000039],
              [95.50269616000003, 5.605129299000055],
              [95.51124108200003, 5.603013414000088],
              [95.52125084700003, 5.609198309000078],
              [95.53370201900003, 5.622137762000079],
              [95.57618248800003, 5.631252346000053],
              [95.61158287900008, 5.626654364000046],
              [95.76221764400003, 5.576849677000041],
              [95.83961022200003, 5.528550523000092],
              [95.85547936300003, 5.522162177000041],
              [95.87256920700003, 5.519720770000049],
              [95.88754316500007, 5.512152411000045],
              [95.89437910200007, 5.493801174000055],
              [95.90357506600003, 5.450751044000071],
              [95.93043053500003, 5.414496161000045],
              [96.05494225400008, 5.313625393000052],
              [96.08806399800005, 5.295477606000077],
              [96.12623131600003, 5.281805731000077],
              [96.29053795700003, 5.258978583000044],
              [96.30396569100003, 5.254299221000053],
              [96.34441165500004, 5.232326565000051],
              [96.36215254000007, 5.225490627000056],
              [96.40658613400007, 5.217230536000045],
              [96.42945397200003, 5.218329169000071],
              [96.44849694100003, 5.228583075000074],
              [96.46631920700003, 5.235541083000044],
              [96.48633873800003, 5.229396877000056],
              [96.50709069100003, 5.218573309000078],
              [96.52735436300003, 5.211167710000041],
              [96.56763756600003, 5.20844147300005],
              [96.65056399800005, 5.21625397300005],
              [96.68490644600007, 5.225490627000056],
              [96.78513172900006, 5.259857206000049],
              [96.82837975400008, 5.280178127000056],
              [96.84864342500003, 5.276597398000092],
              [96.89437910200007, 5.262111721000053],
              [96.90723717500003, 5.262681382000039],
              [96.92286217500003, 5.269476630000042],
              [96.97339928500003, 5.273423570000091],
              [97.03019801000005, 5.251295019000054],
              [97.07433856600005, 5.238154799000085],
              [97.10964054600004, 5.214092463000043],
              [97.14934477700007, 5.198772387000076],
              [97.16602623800003, 5.173732815000051],
              [97.17595462300005, 5.161281643000052],
              [97.19516035200007, 5.156642971000053],
              [97.22655294300006, 5.146221342000047],
              [97.26836827800008, 5.155068075000088],
              [97.49683678500003, 5.251898505000042],
              [97.52621504000007, 5.242254950000074],
              [97.66439863400007, 5.073431708000044],
              [97.83008873800003, 4.938788153000075],
              [97.87387129000007, 4.918850002000056],
              [97.89380944100003, 4.905829169000071],
              [97.90919030000003, 4.889593817000048],
              [97.95606530000003, 4.808010158000059],
              [97.96322675900007, 4.789496161000045],
              [97.97535241000003, 4.706244208000044],
              [97.98373457100007, 4.678412177000041],
              [98.00700931100005, 4.633856512000079],
              [98.00879967500003, 4.62368398600006],
              [98.00709069100003, 4.597723700000074],
              [97.99683678500003, 4.570217190000051],
              [97.99252363400007, 4.553778387000079],
              [97.99683678500003, 4.546454169000071],
              [98.02621504000007, 4.553168036000045],
              [98.03882897200003, 4.551947333000044],
              [98.04802493600005, 4.539007880000042],
              [98.05396569100003, 4.553168036000045],
              [98.06128991000003, 4.554836330000057],
              [98.07593834700003, 4.546454169000071],
              [98.07886803500003, 4.540513414000088],
              [98.08285566500007, 4.536078192000048],
              [98.08961022200003, 4.532782294000071],
              [98.09400475400008, 4.533189195000091],
              [98.10572350400008, 4.53782786700009],
              [98.11353600400008, 4.539007880000042],
              [98.13819420700003, 4.534409898000092],
              [98.15967858200003, 4.522284247000073],
              [98.17611738400007, 4.504828192000048],
              [98.18580162900008, 4.484442450000074],
              [98.19214928500003, 4.484442450000074],
              [98.19516035200007, 4.489203192000048],
              [98.20191491000003, 4.494086005000042],
              [98.20573978000004, 4.498032945000091],
              [98.21900475400008, 4.484767971000053],
              [98.24057050900007, 4.456732489000046],
              [98.25416100400008, 4.443426825000074],
              [98.26832116000003, 4.432318427000041],
              [98.27556399800005, 4.425360419000071],
              [98.27857506600003, 4.41547272300005],
              [98.28248131600003, 4.364935614000046],
              [98.26775149800005, 4.292629299000055],
              [98.26758873800003, 4.287909247000073],
              [98.26636803500003, 4.21157461100006],
              [98.26343834700003, 4.202866929000038],
              [98.24048912900008, 4.19017161700009],
              [98.19613691500007, 4.175116278000075],
              [98.18580162900008, 4.169745184000078],
              [98.18002363400007, 4.158189195000091],
              [98.17807050900007, 4.141831773000092],
              [98.17896569100003, 4.108221747000073],
              [98.20183353000004, 4.132147528000075],
              [98.21705162900008, 4.144110419000071],
              [98.23707116000003, 4.149237372000073],
              [98.23959394600007, 4.153713283000059],
              [98.25684655000003, 4.171779690000051],
              [98.26091556100005, 4.173163153000075],
              [98.26303144600007, 4.177313544000071],
              [98.29948978000004, 4.089016018000052],
              [98.30567467500003, 4.080308335000041],
              [98.36296634200005, 4.087551174000055],
              [98.38445071700005, 4.086493231000077],
              [98.40577233200003, 4.078924872000073],
              [98.44166100400008, 4.057521877000056],
              [98.46265709700003, 4.05304596600007],
              [98.47722415500004, 4.046210028000075],
              [98.49756920700003, 4.014553127000056],
              [98.50798587300005, 4.004584052000041],
              [98.52637780000003, 4.003241278000075],
              [98.54420006600003, 4.005194403000075],
              [98.55779056100005, 4.000799872000073],
              [98.56788170700003, 3.966457424000055],
              [98.57960045700003, 3.95384349200009],
              [98.59489993600005, 3.94367096600007],
              [98.61036217500003, 3.936346747000073],
              [98.67661980100007, 3.914546933000054],
              [98.70026879800008, 3.875304345000075],
              [98.69971764400003, 3.833929755000042],
              [98.71062259200005, 3.803778387000079],
              [98.79658192100004, 3.725442643000065],
              [98.89658286500003, 3.681402408000054],
              [98.95753014400003, 3.67133209800005],
              [98.97790659800006, 3.657914212000094],
              [99.00925159800005, 3.635417095000093],
              [99.02688536000005, 3.629545113000063],
              [99.05235717900007, 3.621714496000038],
              [99.07391004800007, 3.608994286000041],
              [99.10134006900006, 3.582579167000063],
              [99.17976094400007, 3.546337688000051],
              [99.27003805900006, 3.484585772000059],
              [99.36817467500003, 3.407945054000038],
              [99.38396243600005, 3.398871161000045],
              [99.42090905000003, 3.391546942000048],
              [99.43327884200005, 3.382879950000074],
              [99.45386803500003, 3.360988674000055],
              [99.47877037900008, 3.34601471600007],
              [99.48975670700003, 3.33624909100007],
              [99.49756920700003, 3.309515692000048],
              [99.50603274800005, 3.295965887000079],
              [99.52767988400007, 3.271551825000074],
              [99.55811608200003, 3.244574286000045],
              [99.58936608200003, 3.22797272300005],
              [99.68531334700003, 3.204738674000055],
              [99.71949303500003, 3.191595770000049],
              [99.73755944100003, 3.189032294000071],
              [99.75074303500003, 3.180487372000073],
              [99.78158613400007, 3.120754299000055],
              [99.83399498800003, 3.072414455000057],
              [99.85287519600007, 3.047267971000053],
              [99.85792076900003, 3.011460679000038],
              [99.88998457100007, 3.018255927000041],
              [99.91130618600005, 3.000067450000074],
              [99.93051191500007, 2.975409247000073],
              [99.95728600400008, 2.963080145000049],
              [99.97950280000003, 2.948472398000092],
              [99.99024498800003, 2.914496161000045],
              [99.99789472700007, 2.79913971600007],
              [99.99586022200003, 2.785589911000045],
              [99.98861738400007, 2.772040106000077],
              [99.97901451900003, 2.759466864000046],
              [99.97071373800003, 2.745428778000075],
              [99.96713300900007, 2.727240302000041],
              [99.96461022200003, 2.71938711100006],
              [99.95435631600003, 2.70384349200009],
              [99.95346113400007, 2.696234442000048],
              [99.95923912900008, 2.687892971000053],
              [99.96762129000007, 2.68431224200009],
              [99.97673587300005, 2.682440497000073],
              [99.98414147200003, 2.678778387000079],
              [99.99268639400003, 2.668768622000073],
              [99.99170983200003, 2.664211330000057],
              [99.98764082100007, 2.66087474200009],
              [99.98764082100007, 2.65460846600007],
              [100.00879967500003, 2.620428778000075],
              [100.00586998800003, 2.609198309000078],
              [100.00798587300005, 2.602606512000079],
              [100.01392662900008, 2.601629950000074],
              [100.02247155000003, 2.607407945000091],
              [100.02816816500007, 2.617580471000053],
              [100.02515709700003, 2.624579169000071],
              [100.01889082100007, 2.630804755000042],
              [100.01563561300003, 2.63812897300005],
              [100.01449629000007, 2.671535549000055],
              [100.01221764400003, 2.678778387000079],
              [99.98023522200003, 2.697333075000074],
              [99.97396894600007, 2.703070380000042],
              [99.98568769600007, 2.718451239000046],
              [100.01856530000003, 2.731675523000092],
              [100.05494225400008, 2.72728099200009],
              [100.07699629000007, 2.689398505000042],
              [100.07781009200005, 2.675848700000074],
              [100.07601972700007, 2.648260809000078],
              [100.07699629000007, 2.634711005000042],
              [100.08838951900003, 2.601507880000042],
              [100.09009850400008, 2.590073960000041],
              [100.09595787900008, 2.570461330000057],
              [100.10971113400007, 2.54564036700009],
              [100.12582441500007, 2.530096747000073],
              [100.13851972700007, 2.537909247000073],
              [100.13746178500003, 2.551947333000044],
              [100.12142988400007, 2.58820221600007],
              [100.11744225400008, 2.603705145000049],
              [100.11744225400008, 2.64516836100006],
              [100.12110436300003, 2.663560289000088],
              [100.13111412900008, 2.681870835000041],
              [100.14380944100003, 2.695054429000038],
              [100.15943444100003, 2.70376211100006],
              [100.17920983200003, 2.70844147300005],
              [100.20337975400008, 2.709865627000056],
              [100.21062259200005, 2.706244208000044],
              [100.21257571700005, 2.697699286000045],
              [100.21338951900003, 2.687445380000042],
              [100.21745853000004, 2.678778387000079],
              [100.22486412900008, 2.673773505000042],
              [100.24244225400008, 2.66632721600007],
              [100.24838300900007, 2.662054755000042],
              [100.25131269600007, 2.654771226000094],
              [100.25464928500003, 2.62726471600007],
              [100.25806725400008, 2.619086005000042],
              [100.26693769600007, 2.602606512000079],
              [100.26880944100003, 2.596869208000044],
              [100.27369225400008, 2.59015534100007],
              [100.29957116000003, 2.572088934000078],
              [100.30836022200003, 2.569484768000052],
              [100.31218509200005, 2.562892971000053],
              [100.31364993600005, 2.55455149900007],
              [100.31373131600003, 2.554266669000071],
              [100.38168379000007, 2.355047919000071],
              [100.40528405000003, 2.312689520000049],
              [100.43433678500003, 2.273342190000051],
              [100.50733483200003, 2.199164130000042],
              [100.56104576900003, 2.156805731000077],
              [100.61784915500004, 2.129055080000057],
              [100.66618899800005, 2.134466864000046],
              [100.78907311300003, 2.048529364000046],
              [100.81275475400008, 2.039740302000041],
              [100.83228600400008, 2.016302802000041],
              [100.84083092500003, 2.010972398000092],
              [100.85572350400008, 1.999212958000044],
              [100.87240644600007, 1.971991278000075],
              [100.88624108200003, 1.940985419000071],
              [100.89210045700003, 1.918158270000049],
              [100.89551842500003, 1.886216539000088],
              [100.90593509200005, 1.856919664000088],
              [100.92310631600003, 1.834947007000039],
              [100.94727623800003, 1.825384833000044],
            ],
          ],
          [
            [
              [120.79249108200008, -9.960870049999926],
              [120.81226647200003, -9.983575127999927],
              [120.83155358200008, -10.014418226999908],
              [120.83985436300009, -10.051364841999941],
              [120.82667076900009, -10.091241143999923],
              [120.81739342500009, -10.101820570999905],
              [120.78516686300009, -10.12476978999996],
              [120.74187259200005, -10.170993747999944],
              [120.72461998800009, -10.196872653999947],
              [120.71119225400003, -10.20671965899993],
              [120.65056399800005, -10.22356536299992],
              [120.64161217500009, -10.231215101999908],
              [120.63054446700005, -10.235935153999947],
              [120.56609134200005, -10.22779713299991],
              [120.54737389400009, -10.23333098799992],
              [120.50074303500003, -10.25676848799992],
              [120.49146569100003, -10.265883070999905],
              [120.48975670700008, -10.28525155999995],
              [120.48316491000003, -10.300957940999922],
              [120.47046959700003, -10.31031666499996],
              [120.44996178500003, -10.31031666499996],
              [120.43230228000004, -10.30006275799991],
              [120.40935306100005, -10.26962655999995],
              [120.39161217500009, -10.263116143999923],
              [120.24187259200005, -10.241631768999923],
              [120.23023522200003, -10.245212497999944],
              [120.22046959700003, -10.239434502999927],
              [120.15560957100001, -10.220961195999905],
              [120.15015709700003, -10.214450778999947],
              [120.13990319100003, -10.193942966999941],
              [120.13461347700002, -10.18678150799991],
              [120.09310957100001, -10.168389580999929],
              [120.08692467500009, -10.162855726999908],
              [120.05941816500001, -10.118584893999923],
              [120.04835045700008, -10.113213799999926],
              [120.03980553500003, -10.114678643999923],
              [120.03419030000009, -10.112074476999908],
              [120.02719160200002, -10.06764088299991],
              [120.01490319100003, -10.043226820999905],
              [119.97632897200003, -9.992445570999905],
              [119.96729576900009, -9.983575127999927],
              [119.95728600400003, -9.976983330999929],
              [119.94654381600003, -9.974541924999926],
              [119.93148847700002, -9.97356536299992],
              [119.92066491000003, -9.969496351999908],
              [119.91325931100005, -9.961358330999929],
              [119.90870201900009, -9.947198174999926],
              [119.89625084700003, -9.955336195999905],
              [119.89047285200002, -9.95126718499995],
              [119.88689212300005, -9.941582940999922],
              [119.88070722700002, -9.933526299999926],
              [119.86036217500009, -9.922539971999925],
              [119.85084069100003, -9.920098565999922],
              [119.81137129000001, -9.917168877999927],
              [119.79395592500009, -9.910577080999929],
              [119.75782311300009, -9.885186455999929],
              [119.69711347700002, -9.852634372999944],
              [119.68897545700008, -9.84107838299991],
              [119.68506920700008, -9.812758070999905],
              [119.67408287900003, -9.800225518999923],
              [119.63445071700005, -9.789646091999941],
              [119.63363691500001, -9.786228122999944],
              [119.63502037900003, -9.772637627999927],
              [119.63445071700005, -9.769138278999947],
              [119.62810306100005, -9.768649997999944],
              [119.62208092500009, -9.77117278399993],
              [119.61687259200005, -9.774183851999908],
              [119.61312910200002, -9.775323174999926],
              [119.58887780000009, -9.770277601999908],
              [119.54004967500009, -9.765883070999905],
              [119.49903405000009, -9.752129815999922],
              [119.47730553500003, -9.748630466999941],
              [119.46029707100001, -9.75009530999995],
              [119.439789259, -9.754652601999908],
              [119.42253665500004, -9.762139580999929],
              [119.41529381600003, -9.772230726999908],
              [119.40609785200002, -9.790134372999944],
              [119.38559004000001, -9.78289153399993],
              [119.34693444100003, -9.755466403999947],
              [119.33838951900009, -9.755059502999927],
              [119.32789147200003, -9.76181405999995],
              [119.31910241000003, -9.761651299999926],
              [119.31080162900003, -9.758070570999905],
              [119.28484134200005, -9.74114348799992],
              [119.26148522200003, -9.74578215899993],
              [119.21973717500009, -9.74618905999995],
              [119.17709394600001, -9.741387627999927],
              [119.13672936300009, -9.724053643999923],
              [119.09685306100005, -9.717543226999908],
              [119.08253014400009, -9.710544528999947],
              [119.03736412900003, -9.67587655999995],
              [119.02475019600001, -9.659274997999944],
              [119.00717207100001, -9.628106377999927],
              [118.99781334700003, -9.616794528999947],
              [118.98389733200008, -9.604668877999927],
              [118.95573978000004, -9.585056247999944],
              [118.94157962300005, -9.570489190999922],
              [118.93539472700002, -9.553399346999925],
              [118.94190514400009, -9.525567315999922],
              [118.95801842500009, -9.499607028999947],
              [118.97917728000004, -9.47625090899993],
              [119.02466881600003, -9.437676690999922],
              [119.05079186300009, -9.424004815999922],
              [119.07894941500001, -9.415622653999947],
              [119.11011803500003, -9.412774346999925],
              [119.12354576900009, -9.409356377999927],
              [119.15333092500009, -9.39226653399993],
              [119.16871178500003, -9.385511976999908],
              [119.20687910200002, -9.37900155999995],
              [119.24024498800009, -9.378106377999927],
              [119.24634850400003, -9.37590911299992],
              [119.25977623800009, -9.36646900799991],
              [119.26783287900003, -9.364434502999927],
              [119.30543053500003, -9.364434502999927],
              [119.38453209700003, -9.378106377999927],
              [119.39429772200003, -9.37590911299992],
              [119.40756269600001, -9.36646900799991],
              [119.45679772200003, -9.357598565999922],
              [119.47608483200008, -9.36109791499996],
              [119.51734459700003, -9.374932549999926],
              [119.52857506600003, -9.374932549999926],
              [119.54753665500004, -9.362888278999947],
              [119.57081139400009, -9.354099216999941],
              [119.629242384, -9.34189218499995],
              [119.64747155000009, -9.342217705999929],
              [119.66236412900003, -9.347914320999905],
              [119.66846764400009, -9.36101653399993],
              [119.68043053500003, -9.37078215899993],
              [119.79948978000004, -9.38372161299992],
              [119.82129967500009, -9.37859465899993],
              [119.94597415500004, -9.288262627999927],
              [119.95875084700003, -9.290459893999923],
              [119.96387780000009, -9.313164971999925],
              [119.97071373800009, -9.323011976999908],
              [120.01172936300009, -9.357598565999922],
              [120.07097415500004, -9.441013278999947],
              [120.09424889400009, -9.461195570999905],
              [120.11085045700008, -9.470635674999926],
              [120.12940514400009, -9.478122653999947],
              [120.14828535200002, -9.479668877999927],
              [120.16529381600003, -9.470879815999922],
              [120.18311608200008, -9.46689218499995],
              [120.20679772200003, -9.476169528999947],
              [120.22925866000003, -9.49228280999995],
              [120.24390709700003, -9.50904713299991],
              [120.24390709700003, -9.549981377999927],
              [120.25114993600005, -9.575372002999927],
              [120.25342858200008, -9.613864841999941],
              [120.25896243600005, -9.630791924999926],
              [120.27116946700005, -9.642510674999926],
              [120.33033287900003, -9.669366143999923],
              [120.34693444100003, -9.670505466999941],
              [120.35377037900003, -9.655857028999947],
              [120.36475670700008, -9.645277601999908],
              [120.39014733200008, -9.63795338299991],
              [120.43628991000003, -9.631280205999929],
              [120.45850670700008, -9.63250090899993],
              [120.47828209700003, -9.641045830999929],
              [120.49236087300005, -9.657647393999923],
              [120.49773196700005, -9.683200778999947],
              [120.50855553500003, -9.69695403399993],
              [120.58033287900003, -9.734958591999941],
              [120.60678144600001, -9.769463799999926],
              [120.64576256600003, -9.852308851999908],
              [120.66968834700003, -9.885186455999929],
              [120.697601759, -9.904473565999922],
              [120.76441491000003, -9.938897393999923],
              [120.79249108200008, -9.960870049999926],
            ],
          ],
          [
            [
              [115.55014082100001, -8.666192315999922],
              [115.57309004000001, -8.67197030999995],
              [115.589153388, -8.695665505999955],
              [115.59774535300005, -8.718726089999905],
              [115.61573089800004, -8.739627448999954],
              [115.62420393700006, -8.768908689999932],
              [115.60694420700008, -8.786553643999923],
              [115.58887780000009, -8.807305596999925],
              [115.56080162900003, -8.799004815999922],
              [115.50538170700008, -8.760918877999927],
              [115.48878014400009, -8.740655205999929],
              [115.47461998800009, -8.736586195999905],
              [115.46827233200008, -8.731866143999923],
              [115.47136478000004, -8.723809502999927],
              [115.50700931100005, -8.67896900799991],
              [115.51758873800009, -8.670179945999905],
              [115.5350554470001, -8.673678329999916],
              [115.55014082100001, -8.666192315999922],
            ],
          ],
          [
            [
              [119.722992384, -8.62118905999995],
              [119.73780358200008, -8.617120049999926],
              [119.76758873800009, -8.617120049999926],
              [119.79151451900009, -8.624200127999927],
              [119.78858483200008, -8.64153411299992],
              [119.75806725400003, -8.66106536299992],
              [119.74732506600003, -8.672133070999905],
              [119.75049889400009, -8.685967705999929],
              [119.73560631600003, -8.68922291499996],
              [119.72095787900003, -8.689711195999905],
              [119.70915774800005, -8.693536065999922],
              [119.70264733200008, -8.706475518999923],
              [119.70508873800009, -8.724053643999923],
              [119.72339928500003, -8.741794528999947],
              [119.722992384, -8.76181405999995],
              [119.71876061300009, -8.77044036299992],
              [119.70264733200008, -8.792413018999923],
              [119.69825280000009, -8.801527601999908],
              [119.68864993600005, -8.799248955999929],
              [119.67920983200008, -8.79265715899993],
              [119.66895592500009, -8.781996351999908],
              [119.66293379000001, -8.772556247999944],
              [119.65552819100003, -8.76685963299991],
              [119.64454186300009, -8.771661065999922],
              [119.63477623800009, -8.778415622999944],
              [119.62484785200002, -8.78053150799991],
              [119.61524498800009, -8.777520440999922],
              [119.60629316500001, -8.768649997999944],
              [119.61426842500009, -8.739841403999947],
              [119.62061608200008, -8.730075778999947],
              [119.63445071700005, -8.726983330999929],
              [119.629242384, -8.717543226999908],
              [119.62680097700002, -8.713962497999944],
              [119.64210045700008, -8.706149997999944],
              [119.65699303500003, -8.695489190999922],
              [119.66041100400003, -8.685479424999926],
              [119.64128665500004, -8.679131768999923],
              [119.64673912900003, -8.65715911299992],
              [119.62720787900003, -8.618340752999927],
              [119.63445071700005, -8.59661223799992],
              [119.65512129000001, -8.611586195999905],
              [119.66098066500001, -8.617771091999941],
              [119.66480553500003, -8.627373955999929],
              [119.66895592500009, -8.64967213299991],
              [119.67530358200008, -8.658786716999941],
              [119.69548587300005, -8.667087497999944],
              [119.71062259200005, -8.659763278999947],
              [119.71989993600005, -8.642510674999926],
              [119.722992384, -8.62118905999995],
            ],
          ],
          [
            [
              [119.55925540500004, -8.518161716999941],
              [119.56177819100003, -8.53215911299992],
              [119.56836998800009, -8.54029713299991],
              [119.57740319100003, -8.548435153999947],
              [119.58716881600003, -8.562432549999926],
              [119.572601759, -8.565606377999927],
              [119.57056725400003, -8.575372002999927],
              [119.57243899800005, -8.58562590899993],
              [119.56983483200008, -8.590427341999941],
              [119.53785241000003, -8.593682549999926],
              [119.52515709700003, -8.590427341999941],
              [119.51587975400003, -8.572686455999929],
              [119.50668379000001, -8.565850518999923],
              [119.49398847700002, -8.573011976999908],
              [119.47999108200008, -8.591729424999926],
              [119.47095787900003, -8.596774997999944],
              [119.45679772200003, -8.59661223799992],
              [119.46273847700002, -8.609307549999926],
              [119.47071373800009, -8.615411065999922],
              [119.47828209700003, -8.614027601999908],
              [119.48357181100005, -8.604099216999941],
              [119.49097741000003, -8.610935153999947],
              [119.48023522200003, -8.635430596999925],
              [119.47315514400009, -8.647230726999908],
              [119.46648196700005, -8.64853280999995],
              [119.45533287900003, -8.64430103999996],
              [119.44825280000009, -8.65357838299991],
              [119.44255618600005, -8.679131768999923],
              [119.44361412900003, -8.690606377999927],
              [119.44849694100003, -8.709161065999922],
              [119.457367384, -8.728122653999947],
              [119.46989993600005, -8.740655205999929],
              [119.44662519600001, -8.746351820999905],
              [119.39909915500004, -8.726495049999926],
              [119.38111412900003, -8.740655205999929],
              [119.37370853000004, -8.73447030999995],
              [119.38111412900003, -8.73447030999995],
              [119.37720787900003, -8.72242603999996],
              [119.381195509, -8.708916924999926],
              [119.40015709700003, -8.674981377999927],
              [119.40211022200003, -8.667575778999947],
              [119.40154056100005, -8.64153411299992],
              [119.39844811300009, -8.634372653999947],
              [119.39136803500003, -8.63209400799991],
              [119.38428795700008, -8.631117445999905],
              [119.38111412900003, -8.628024997999944],
              [119.38111412900003, -8.600355726999908],
              [119.37818444100003, -8.57398853999996],
              [119.37964928500003, -8.565850518999923],
              [119.38795006600003, -8.55632903399993],
              [119.39356530000009, -8.554945570999905],
              [119.40943444100003, -8.557386976999908],
              [119.41529381600003, -8.55632903399993],
              [119.41504967500009, -8.553155205999929],
              [119.42156009200005, -8.535739841999941],
              [119.42212975400003, -8.53525155999995],
              [119.42237389400009, -8.526462497999944],
              [119.41846764400009, -8.494805596999925],
              [119.42701256600003, -8.48805103999996],
              [119.42481530000009, -8.472588799999926],
              [119.41529381600003, -8.443291924999926],
              [119.42156009200005, -8.44150155999995],
              [119.45679772200003, -8.425957940999922],
              [119.46078535200002, -8.44109465899993],
              [119.46338951900009, -8.461195570999905],
              [119.46876061300009, -8.479180596999925],
              [119.48031660200002, -8.486748955999929],
              [119.52881920700008, -8.479261976999908],
              [119.54566491000003, -8.481133721999925],
              [119.55453535200002, -8.484551690999922],
              [119.56023196700005, -8.48796965899993],
              [119.56983483200008, -8.497979424999926],
              [119.57471764400009, -8.507012627999927],
              [119.57048587300005, -8.512139580999929],
              [119.56299889400009, -8.51531340899993],
              [119.55925540500004, -8.518161716999941],
            ],
          ],
          [
            [
              [123.34864342500009, -8.26881275799991],
              [123.35027103000004, -8.280043226999908],
              [123.34538821700005, -8.287774346999925],
              [123.33871504000001, -8.293715101999908],
              [123.33545983200008, -8.299248955999929],
              [123.32748457100001, -8.367608330999929],
              [123.32113691500001, -8.384942315999922],
              [123.28931725400003, -8.404473565999922],
              [123.24488366000003, -8.404717705999929],
              [123.16358483200008, -8.391778252999927],
              [123.08155358200008, -8.408623955999929],
              [123.04102623800009, -8.410821221999925],
              [123.01954186300009, -8.391778252999927],
              [123.02084394600001, -8.35833098799992],
              [123.03646894600001, -8.332289320999905],
              [123.12582441500001, -8.25872161299992],
              [123.14161217500009, -8.249932549999926],
              [123.15650475400003, -8.243584893999923],
              [123.18824303500003, -8.234958591999941],
              [123.20443769600001, -8.233493747999944],
              [123.23731530000009, -8.23406340899993],
              [123.26368248800009, -8.237888278999947],
              [123.28785241000003, -8.246351820999905],
              [123.31430097700002, -8.26140715899993],
              [123.32154381600003, -8.25562916499996],
              [123.33082116000003, -8.254652601999908],
              [123.34058678500003, -8.258884372999944],
              [123.34864342500009, -8.26881275799991],
            ],
          ],
          [
            [
              [116.63331139400009, -8.27507903399993],
              [116.66822350400003, -8.289239190999922],
              [116.70622806100005, -8.317071221999925],
              [116.73511803500003, -8.352959893999923],
              [116.74317467500009, -8.391778252999927],
              [116.73511803500003, -8.408868096999925],
              [116.70215905000009, -8.457452080999929],
              [116.69166100400003, -8.467461846999925],
              [116.68523196700005, -8.48056405999995],
              [116.68100019600001, -8.55632903399993],
              [116.66879316500001, -8.573825778999947],
              [116.62777754000001, -8.614841403999947],
              [116.61898847700002, -8.63486093499995],
              [116.59952836700006, -8.666385866999917],
              [116.58161992600003, -8.697813045999908],
              [116.55530487600004, -8.74497247599993],
              [116.51940387400009, -8.77856350199994],
              [116.50043781400007, -8.802687801999923],
              [116.50831139400009, -8.83294036299992],
              [116.50611412900003, -8.847588799999926],
              [116.50912519600001, -8.858005466999941],
              [116.52003014400009, -8.85947030999995],
              [116.529154145, -8.842353687999946],
              [116.54079663800007, -8.836037974999954],
              [116.54718187800006, -8.84543317999993],
              [116.55990644600001, -8.848809502999927],
              [116.57178795700008, -8.858819268999923],
              [116.58887780000009, -8.863213799999926],
              [116.5653685210001, -8.895582838999928],
              [116.524046602, -8.902006540999935],
              [116.50917661100004, -8.896829057999923],
              [116.47559655000009, -8.92001718499995],
              [116.44661086600001, -8.92008037799991],
              [116.4327889000001, -8.910705027999938],
              [116.45290485600003, -8.886558814999944],
              [116.46026020200009, -8.864555973999927],
              [116.47187992400006, -8.839399234999917],
              [116.45557701900009, -8.83367278399993],
              [116.4231158120001, -8.83640640099992],
              [116.39769974600006, -8.855322488999946],
              [116.39772762900009, -8.882544563999943],
              [116.4020081970001, -8.916042998999956],
              [116.40308678500003, -8.954196872999944],
              [116.38917076900009, -8.949151299999926],
              [116.38819420700008, -8.93759530999995],
              [116.38868248800009, -8.92351653399993],
              [116.37956790500004, -8.91187916499996],
              [116.37012780000009, -8.91106536299992],
              [116.36060631600003, -8.924493096999925],
              [116.35141035200002, -8.926202080999929],
              [116.34742272200003, -8.921319268999923],
              [116.34310957100001, -8.912041924999926],
              [116.33716881600003, -8.903008721999925],
              [116.32789147200003, -8.898858330999929],
              [116.31006920700008, -8.90243905999995],
              [116.27230879000001, -8.91725025799991],
              [116.25521894600001, -8.92001718499995],
              [116.24935957100001, -8.917413018999923],
              [116.24268639400009, -8.90789153399993],
              [116.23609459700003, -8.905694268999923],
              [116.22486412900003, -8.90797291499996],
              [116.21192467500009, -8.91773853999996],
              [116.20476321700005, -8.92001718499995],
              [116.19646243600005, -8.914320570999905],
              [116.17847741000003, -8.887790622999944],
              [116.16724694100003, -8.878513278999947],
              [116.15235436300009, -8.875664971999925],
              [116.10572350400003, -8.87468840899993],
              [116.10132897200003, -8.888929945999905],
              [116.09066816500001, -8.895928643999923],
              [116.07715905000009, -8.89462655999995],
              [116.06421959700003, -8.883965752999927],
              [116.07553144600001, -8.879489841999941],
              [116.08253014400009, -8.87273528399993],
              [116.08375084700003, -8.86500416499996],
              [116.07781009200005, -8.858005466999941],
              [116.06861412900003, -8.855726820999905],
              [116.05925540500004, -8.858493747999944],
              [116.04981530000009, -8.862725518999923],
              [116.04029381600003, -8.864678643999923],
              [116.03614342500009, -8.870538018999923],
              [116.03687584700003, -8.883070570999905],
              [116.04029381600003, -8.902276299999926],
              [116.02995853000004, -8.908135674999926],
              [116.01929772200003, -8.908135674999926],
              [116.00953209700003, -8.904473565999922],
              [116.00212649800005, -8.898858330999929],
              [115.996429884, -8.889743747999944],
              [115.98853600400003, -8.86728280999995],
              [115.98161868600005, -8.858005466999941],
              [115.96924889400009, -8.84937916499996],
              [115.96436608200008, -8.850274346999925],
              [115.95875084700003, -8.855075778999947],
              [115.94434655000009, -8.858005466999941],
              [115.92823326900009, -8.854913018999923],
              [115.86744225400003, -8.82122161299992],
              [115.83926184100005, -8.816856514999927],
              [115.82863780700006, -8.791785517999926],
              [115.83069647400009, -8.769811756999957],
              [115.833821339, -8.748873542999945],
              [115.84859164500006, -8.724792571999956],
              [115.86890709700003, -8.730645440999922],
              [115.87940514400009, -8.724786065999922],
              [115.88445071700005, -8.732842705999929],
              [115.88746178500003, -8.74578215899993],
              [115.89226321700005, -8.75481536299992],
              [115.91846409200002, -8.75374046199994],
              [115.9417594360001, -8.754876932999935],
              [115.9544494700001, -8.753719628999932],
              [115.96820292200005, -8.74744955899996],
              [115.98302589600007, -8.737059159999944],
              [115.99301191500001, -8.742364190999922],
              [116.00261478000004, -8.742771091999941],
              [116.01384524800005, -8.746677341999941],
              [116.02320397200003, -8.74814218499995],
              [116.02784264400009, -8.744724216999941],
              [116.03370201900009, -8.738864841999941],
              [116.04118899800005, -8.73414478999996],
              [116.05054772200003, -8.73447030999995],
              [116.05323326900009, -8.73951588299991],
              [116.05746504000001, -8.749932549999926],
              [116.06566998700009, -8.759974082999918],
              [116.07728005000001, -8.74319823199994],
              [116.08757571700005, -8.73723723799992],
              [116.09148196700005, -8.726983330999929],
              [116.06027107900002, -8.713907240999959],
              [116.06334853100009, -8.673058821999916],
              [116.07067293, -8.638494197999933],
              [116.0726445250001, -8.577783690999922],
              [116.06299408200005, -8.521300971999949],
              [116.03859148100003, -8.500403088999917],
              [116.02793675600003, -8.445007651999958],
              [116.05004674600002, -8.414638435999905],
              [116.06908823800006, -8.406236988999922],
              [116.09791100400003, -8.408461195999905],
              [116.10572350400003, -8.405450127999927],
              [116.11060631600003, -8.399183851999908],
              [116.11719811300009, -8.382012627999927],
              [116.12281334700003, -8.374444268999923],
              [116.13843834700003, -8.36296965899993],
              [116.16797936300009, -8.34693775799991],
              [116.18091881600003, -8.33717213299991],
              [116.26970462300005, -8.24773528399993],
              [116.28638756600003, -8.236260674999926],
              [116.37623131600003, -8.201836846999925],
              [116.39380944100003, -8.201104424999926],
              [116.42465254000001, -8.21770598799992],
              [116.49740644600001, -8.237399997999944],
              [116.53907311300009, -8.24382903399993],
              [116.55445397200003, -8.25123463299991],
              [116.57300866000003, -8.264092705999929],
              [116.59099368600005, -8.269707940999922],
              [116.63331139400009, -8.27507903399993],
            ],
          ],
          [
            [
              [119.08643639400009, -8.131524346999925],
              [119.11304772200003, -8.146661065999922],
              [119.13152103000004, -8.166273695999905],
              [119.13746178500003, -8.190606377999927],
              [119.12720787900003, -8.22047291499996],
              [119.11654707100001, -8.23560963299991],
              [119.10035241000003, -8.251560153999947],
              [119.07878665500004, -8.262139580999929],
              [119.05152428500003, -8.26140715899993],
              [119.02279707100001, -8.234307549999926],
              [119.02027428500003, -8.189711195999905],
              [119.04200280000009, -8.14853280999995],
              [119.08643639400009, -8.131524346999925],
            ],
          ],
          [
            [
              [119.20362389400009, -8.610935153999947],
              [119.19922936300009, -8.612399997999944],
              [119.19312584700003, -8.615980726999908],
              [119.18930097700002, -8.617771091999941],
              [119.19434655000009, -8.626071872999944],
              [119.18946373800009, -8.631280205999929],
              [119.18091881600003, -8.63648853999996],
              [119.17497806100005, -8.645114841999941],
              [119.17408287900003, -8.65992603999996],
              [119.17701256600003, -8.674493096999925],
              [119.18246504000001, -8.688164971999925],
              [119.18930097700002, -8.700290622999944],
              [119.18100019600001, -8.703383070999905],
              [119.17774498800009, -8.70680103999996],
              [119.17823326900009, -8.712090752999927],
              [119.18181399800005, -8.72079843499995],
              [119.16456139400009, -8.731540622999944],
              [119.15162194100003, -8.742364190999922],
              [119.13843834700003, -8.74578215899993],
              [119.12037194100003, -8.73447030999995],
              [119.11670983200008, -8.74781666499996],
              [119.11003665500004, -8.75359465899993],
              [119.10059655000009, -8.752129815999922],
              [119.08969160200002, -8.744317315999922],
              [119.07789147200003, -8.739353122999944],
              [119.06544030000009, -8.74114348799992],
              [119.05298912900003, -8.745538018999923],
              [118.99154707100001, -8.755059502999927],
              [118.97185306100005, -8.751153252999927],
              [118.94597415500004, -8.730645440999922],
              [118.92359459700003, -8.69850025799991],
              [118.91553795700008, -8.692152601999908],
              [118.89844811300009, -8.68840911299992],
              [118.89193769600001, -8.69345468499995],
              [118.88851972700002, -8.703301690999922],
              [118.88086998800009, -8.713962497999944],
              [118.85710696700005, -8.721774997999944],
              [118.81332441500001, -8.71021900799991],
              [118.791351759, -8.72079843499995],
              [118.76514733200008, -8.710870049999926],
              [118.746429884, -8.717868747999944],
              [118.72779381600003, -8.733168226999908],
              [118.70199629000001, -8.74814218499995],
              [118.71192467500009, -8.75481536299992],
              [118.72657311300009, -8.769789320999905],
              [118.73617597700002, -8.77467213299991],
              [118.74659264400009, -8.77629973799992],
              [118.82569420700008, -8.776543877999927],
              [118.90723717500009, -8.789727471999925],
              [118.92693118600005, -8.79656340899993],
              [118.93539472700002, -8.806084893999923],
              [118.93775475400003, -8.81226978999996],
              [118.94752037900003, -8.825372002999927],
              [118.94971764400009, -8.83367278399993],
              [118.94459069100003, -8.84148528399993],
              [118.93246504000001, -8.846449476999908],
              [118.90805097700002, -8.85051848799992],
              [118.896820509, -8.849786065999922],
              [118.87696373800009, -8.84539153399993],
              [118.86719811300009, -8.844333591999941],
              [118.85173587300005, -8.838148695999905],
              [118.84595787900003, -8.83684661299992],
              [118.84669030000009, -8.83912525799991],
              [118.84229576900009, -8.843926690999922],
              [118.83562259200005, -8.848402601999908],
              [118.82927493600005, -8.85051848799992],
              [118.81763756600003, -8.84351978999996],
              [118.77735436300009, -8.811618747999944],
              [118.75733483200008, -8.80201588299991],
              [118.71404056100005, -8.799981377999927],
              [118.66895592500009, -8.806898695999905],
              [118.46501712300005, -8.86500416499996],
              [118.41423587300005, -8.85361093499995],
              [118.38738040500004, -8.79583098799992],
              [118.39112389400009, -8.770196221999925],
              [118.40503991000003, -8.750420830999929],
              [118.42212975400003, -8.731052341999941],
              [118.43523196700005, -8.706475518999923],
              [118.43873131600003, -8.690036716999941],
              [118.43970787900003, -8.674574476999908],
              [118.43832441500001, -8.659763278999947],
              [118.43523196700005, -8.645114841999941],
              [118.42855879000001, -8.62981536299992],
              [118.42042076900009, -8.615655205999929],
              [118.41456139400009, -8.60051848799992],
              [118.41472415500004, -8.58294036299992],
              [118.40040123800009, -8.596123955999929],
              [118.39698326900009, -8.617933851999908],
              [118.40113366000003, -8.662367445999905],
              [118.39356530000009, -8.674574476999908],
              [118.37623131600003, -8.680759372999944],
              [118.35564212300005, -8.684991143999923],
              [118.33904056100005, -8.692152601999908],
              [118.31226647200003, -8.726983330999929],
              [118.29932701900009, -8.75790780999995],
              [118.29493248800009, -8.765232028999947],
              [118.28663170700008, -8.77044036299992],
              [118.27491295700008, -8.772149346999925],
              [118.15772545700008, -8.867852471999925],
              [118.14031009200005, -8.872247002999927],
              [118.119476759, -8.86296965899993],
              [118.097992384, -8.850274346999925],
              [118.07886803500003, -8.844333591999941],
              [118.07016035200002, -8.846286716999941],
              [118.03728274800005, -8.858005466999941],
              [118.03858483200008, -8.856052341999941],
              [118.03516686300009, -8.853122653999947],
              [118.02955162900003, -8.85084400799991],
              [118.02418053500003, -8.85051848799992],
              [118.01677493600005, -8.86256275799991],
              [118.00847415500004, -8.867771091999941],
              [117.998383009, -8.88095468499995],
              [117.89047285200002, -8.93678150799991],
              [117.88013756600003, -8.928317966999941],
              [117.87289472700002, -8.92782968499995],
              [117.86622155000009, -8.93092213299991],
              [117.85670006600003, -8.933038018999923],
              [117.85303795700008, -8.929131768999923],
              [117.84498131600003, -8.910902601999908],
              [117.83936608200008, -8.905694268999923],
              [117.82545006600003, -8.905450127999927],
              [117.81763756600003, -8.911228122999944],
              [117.81202233200008, -8.91920338299991],
              [117.80518639400009, -8.926202080999929],
              [117.79558353000004, -8.930759372999944],
              [117.78793379000001, -8.932793877999927],
              [117.77442467500009, -8.933038018999923],
              [117.76758873800009, -8.931247653999947],
              [117.75717207100001, -8.926527601999908],
              [117.74781334700003, -8.920993747999944],
              [117.73780358200008, -8.909763278999947],
              [117.72510826900009, -8.912041924999926],
              [117.71290123800009, -8.917413018999923],
              [117.70899498800009, -8.92001718499995],
              [117.66765384200005, -8.937107028999947],
              [117.55811608200008, -9.001885674999926],
              [117.51807701900009, -9.017836195999905],
              [117.47388756600003, -9.029961846999925],
              [117.38886774800005, -9.053738711999927],
              [117.334132038, -9.059354224999936],
              [117.30050792500003, -9.047070401999918],
              [117.273858389, -9.040239581999913],
              [117.22614543300006, -9.023780684999906],
              [117.19240561200002, -9.02372681299994],
              [117.17144575300006, -9.032049267999923],
              [117.15346468000007, -9.061166275999938],
              [117.14096893700003, -9.076417890999949],
              [117.12680097700002, -9.091241143999923],
              [117.07129967500009, -9.101739190999922],
              [117.00973561500007, -9.10729288899995],
              [116.99142139600008, -9.085126613999932],
              [116.97039034600004, -9.07133469899992],
              [116.94922936300009, -9.060153903999947],
              [116.92823326900009, -9.063897393999923],
              [116.90642337300005, -9.06340911299992],
              [116.85027103000004, -9.045342705999929],
              [116.82829837300005, -9.042901299999926],
              [116.80616295700008, -9.036309502999927],
              [116.77393639400009, -9.012790622999944],
              [116.76303144600001, -9.015557549999926],
              [116.75855553500003, -9.004571221999925],
              [116.74537194100003, -8.983086846999925],
              [116.728451662, -8.963095719999956],
              [116.73119975700001, -8.946521530999917],
              [116.74790651800004, -8.92292800499996],
              [116.7408678060001, -8.905055321999953],
              [116.73661259900007, -8.883020736999924],
              [116.73517982600004, -8.873397366999939],
              [116.75883945400005, -8.849859070999912],
              [116.77690855500009, -8.826346783999952],
              [116.81714928500003, -8.81812916499996],
              [116.82447350400003, -8.799004815999922],
              [116.82129967500009, -8.787286065999922],
              [116.81446373800009, -8.780043226999908],
              [116.80762780000009, -8.77548593499995],
              [116.80453535200002, -8.771661065999922],
              [116.80250084700003, -8.76458098799992],
              [116.79737389400009, -8.754571221999925],
              [116.79070071700005, -8.74537525799991],
              [116.77107815800002, -8.74781528199992],
              [116.76407471300001, -8.738189313999953],
              [116.77234298600001, -8.705071437999948],
              [116.77226736300008, -8.680257197999936],
              [116.74851672300008, -8.666544377999912],
              [116.79009149300009, -8.583704495999939],
              [116.83204186300009, -8.574802341999941],
              [116.83936608200008, -8.554864190999922],
              [116.83814537900003, -8.50790780999995],
              [116.85726972700002, -8.524021091999941],
              [116.86589603000004, -8.527601820999905],
              [116.87964928500003, -8.52825286299992],
              [116.89039147200003, -8.52629973799992],
              [116.98454837300005, -8.49578215899993],
              [117.03199303500003, -8.468357028999947],
              [117.090179884, -8.425225518999923],
              [117.12614993600005, -8.405450127999927],
              [117.11768639400009, -8.383477471999925],
              [117.14047285200002, -8.37200286299992],
              [117.17351321700005, -8.365166924999926],
              [117.19507897200003, -8.357598565999922],
              [117.21558678500003, -8.384942315999922],
              [117.22901451900009, -8.388116143999923],
              [117.26197350400003, -8.39031340899993],
              [117.273773634, -8.395196221999925],
              [117.28736412900003, -8.404961846999925],
              [117.31609134200005, -8.41969166499996],
              [117.35320071700005, -8.446709893999923],
              [117.433929884, -8.481133721999925],
              [117.42774498800009, -8.465264580999929],
              [117.43116295700008, -8.453301690999922],
              [117.43775475400003, -8.44231536299992],
              [117.44141686300009, -8.42937590899993],
              [117.44271894600001, -8.410739841999941],
              [117.44727623800009, -8.408623955999929],
              [117.45573978000004, -8.414239190999922],
              [117.46876061300009, -8.419122002999927],
              [117.51970462300005, -8.418715101999908],
              [117.54411868600005, -8.414239190999922],
              [117.55811608200008, -8.405450127999927],
              [117.56788170700008, -8.422295830999929],
              [117.57691491000003, -8.487074476999908],
              [117.59229576900009, -8.514743747999944],
              [117.59815514400009, -8.49391041499996],
              [117.599945509, -8.446058851999908],
              [117.61280358200008, -8.432793877999927],
              [117.62330162900003, -8.43840911299992],
              [117.62907962300005, -8.457452080999929],
              [117.63550866000003, -8.524997653999947],
              [117.63965905000009, -8.540622653999947],
              [117.64909915500004, -8.551853122999944],
              [117.69874108200008, -8.576755466999941],
              [117.71111087300005, -8.57390715899993],
              [117.72087649800005, -8.568536065999922],
              [117.73072350400003, -8.56536223799992],
              [117.74382571700005, -8.56926848799992],
              [117.73943118600005, -8.57626718499995],
              [117.73633873800009, -8.58294036299992],
              [117.74756920700008, -8.58570728999996],
              [117.756195509, -8.58953215899993],
              [117.76368248800009, -8.595310153999947],
              [117.77165774800005, -8.604099216999941],
              [117.76889082100001, -8.60711028399993],
              [117.76465905000009, -8.61419036299992],
              [117.76465905000009, -8.621270440999922],
              [117.77442467500009, -8.624607028999947],
              [117.78207441500001, -8.625258070999905],
              [117.78630618600005, -8.627699476999908],
              [117.78874759200005, -8.631931247999944],
              [117.79151451900009, -8.638116143999923],
              [117.78077233200008, -8.63762786299992],
              [117.77149498800009, -8.638604424999926],
              [117.76368248800009, -8.641045830999929],
              [117.75733483200008, -8.645114841999941],
              [117.76531009200005, -8.65992603999996],
              [117.77833092500009, -8.695977471999925],
              [117.78785241000003, -8.71021900799991],
              [117.80518639400009, -8.71998463299991],
              [117.82349694100003, -8.719333591999941],
              [117.88656660200002, -8.699476820999905],
              [117.89389082100001, -8.700290622999944],
              [117.90007571700005, -8.70671965899993],
              [117.90235436300009, -8.715590101999908],
              [117.90308678500003, -8.72356536299992],
              [117.90447024800005, -8.726983330999929],
              [117.91684004000001, -8.727308851999908],
              [117.93425540500004, -8.72975025799991],
              [117.95289147200003, -8.73601653399993],
              [117.96900475400003, -8.74814218499995],
              [117.988617384, -8.732354424999926],
              [118.03028405000009, -8.688246351999908],
              [118.04786217500009, -8.679131768999923],
              [118.04859459700003, -8.675957940999922],
              [118.05486087300005, -8.66920338299991],
              [118.06185957100001, -8.66334400799991],
              [118.06527754000001, -8.662367445999905],
              [118.06812584700003, -8.65593840899993],
              [118.07496178500003, -8.653741143999923],
              [118.08375084700003, -8.65325286299992],
              [118.12281334700003, -8.64576588299991],
              [118.15772545700008, -8.645114841999941],
              [118.16578209700003, -8.647230726999908],
              [118.18376712300005, -8.656508070999905],
              [118.19190514400009, -8.658786716999941],
              [118.24610436300009, -8.65715911299992],
              [118.26563561300009, -8.65203215899993],
              [118.28174889400009, -8.64153411299992],
              [118.29127037900003, -8.624607028999947],
              [118.29086347700002, -8.605889580999929],
              [118.28288821700005, -8.58798593499995],
              [118.26954186300009, -8.574476820999905],
              [118.25359134200005, -8.56926848799992],
              [118.25025475400003, -8.56454843499995],
              [118.24187259200005, -8.555108330999929],
              [118.23316491000003, -8.54851653399993],
              [118.22917728000004, -8.55250416499996],
              [118.22706139400009, -8.55836353999996],
              [118.22234134200005, -8.564873955999929],
              [118.20923912900003, -8.576755466999941],
              [118.19288170700008, -8.549493096999925],
              [118.14893639400009, -8.512139580999929],
              [118.13355553500003, -8.486748955999929],
              [118.12671959700003, -8.486748955999929],
              [118.11719811300009, -8.496514580999929],
              [118.10328209700003, -8.48837655999995],
              [118.07545006600003, -8.456963799999926],
              [118.05746504000001, -8.450616143999923],
              [118.03638756600003, -8.457289320999905],
              [118.00318444100003, -8.473728122999944],
              [117.98845462300005, -8.46998463299991],
              [117.97022545700008, -8.461358330999929],
              [117.95492597700002, -8.45126718499995],
              [117.93995201900009, -8.432793877999927],
              [117.88152103000004, -8.398614190999922],
              [117.82252037900003, -8.354180596999925],
              [117.81006920700008, -8.340020440999922],
              [117.78663170700008, -8.30559661299992],
              [117.77165774800005, -8.28875090899993],
              [117.74382571700005, -8.26881275799991],
              [117.730804884, -8.252699476999908],
              [117.72217858200008, -8.244561455999929],
              [117.71225019600001, -8.240899346999925],
              [117.70630944100003, -8.229668877999927],
              [117.71111087300005, -8.203871351999908],
              [117.72071373800009, -8.176202080999929],
              [117.72950280000009, -8.158949476999908],
              [117.74097741000003, -8.147881768999923],
              [117.74968509200005, -8.144952080999929],
              [117.75684655000009, -8.145603122999944],
              [117.76351972700002, -8.144789320999905],
              [117.78980553500003, -8.127373955999929],
              [117.79493248800009, -8.124932549999926],
              [117.81251061300009, -8.121840101999908],
              [117.89527428500003, -8.090020440999922],
              [117.91781660200002, -8.085870049999926],
              [117.95875084700003, -8.08326588299991],
              [117.96558678500003, -8.088962497999944],
              [117.97120201900009, -8.100355726999908],
              [117.97754967500009, -8.10914478999996],
              [117.98609459700003, -8.10719166499996],
              [117.99610436300009, -8.100681247999944],
              [118.00505618600005, -8.100192966999941],
              [118.02418053500003, -8.103773695999905],
              [118.07154381600003, -8.105401299999926],
              [118.11524498800009, -8.113864841999941],
              [118.14966881600003, -8.13445403399993],
              [118.16822350400003, -8.172621351999908],
              [118.17269941500001, -8.213148695999905],
              [118.17725670700008, -8.232679945999905],
              [118.18506920700008, -8.240899346999925],
              [118.18913821700005, -8.248223565999922],
              [118.22291100400003, -8.28875090899993],
              [118.24390709700003, -8.328708591999941],
              [118.25359134200005, -8.340264580999929],
              [118.25953209700003, -8.342868747999944],
              [118.26417076900009, -8.340997002999927],
              [118.26807701900009, -8.338067315999922],
              [118.27068118600005, -8.33717213299991],
              [118.30396569100003, -8.368259372999944],
              [118.31226647200003, -8.371270440999922],
              [118.32781009200005, -8.367608330999929],
              [118.34701582100001, -8.357354424999926],
              [118.36524498800009, -8.34465911299992],
              [118.39161217500009, -8.31845468499995],
              [118.39828535200002, -8.309014580999929],
              [118.40113366000003, -8.299248955999929],
              [118.40642337300005, -8.295586846999925],
              [118.41814212300005, -8.290134372999944],
              [118.42986087300005, -8.28248463299991],
              [118.44361412900003, -8.25790780999995],
              [118.46338951900009, -8.249444268999923],
              [118.48609459700003, -8.24618905999995],
              [118.50342858200008, -8.24773528399993],
              [118.51319420700008, -8.25318775799991],
              [118.52955162900003, -8.266289971999925],
              [118.54102623800009, -8.26881275799991],
              [118.58228600400003, -8.26881275799991],
              [118.590179884, -8.270684502999927],
              [118.59644616000003, -8.27467213299991],
              [118.60173587300005, -8.27906666499996],
              [118.60645592500009, -8.281914971999925],
              [118.63941491000003, -8.286309502999927],
              [118.64747155000009, -8.28875090899993],
              [118.66374759200005, -8.305759372999944],
              [118.69581139400009, -8.371270440999922],
              [118.68913821700005, -8.387872002999927],
              [118.68474368600005, -8.412692966999941],
              [118.68148847700002, -8.456963799999926],
              [118.65650475400003, -8.526462497999944],
              [118.65430748800009, -8.542087497999944],
              [118.66732832100001, -8.547295830999929],
              [118.68311608200008, -8.533461195999905],
              [118.69646243600005, -8.51458098799992],
              [118.70199629000001, -8.504489841999941],
              [118.70427493600005, -8.49700286299992],
              [118.715179884, -8.471449476999908],
              [118.726898634, -8.451836846999925],
              [118.72584069100003, -8.441989841999941],
              [118.72095787900003, -8.432061455999929],
              [118.71631920700008, -8.419122002999927],
              [118.71697024800005, -8.379571221999925],
              [118.73145592500009, -8.34929778399993],
              [118.75391686300009, -8.326429945999905],
              [118.77784264400009, -8.309258721999925],
              [118.81267337300005, -8.295586846999925],
              [118.85922285200002, -8.28883228999996],
              [118.90805097700002, -8.28883228999996],
              [118.94971764400009, -8.295586846999925],
              [118.97250410200002, -8.30201588299991],
              [118.98829186300009, -8.309014580999929],
              [118.99830162900003, -8.32122161299992],
              [119.00440514400009, -8.343357028999947],
              [119.00733483200008, -8.37200286299992],
              [119.02165774800005, -8.419528903999947],
              [119.051117384, -8.47047291499996],
              [119.04558353000004, -8.508965752999927],
              [119.03052819100003, -8.54778411299992],
              [119.03842207100001, -8.58294036299992],
              [119.03834069100003, -8.607679945999905],
              [119.04151451900009, -8.62981536299992],
              [119.05225670700008, -8.645684502999927],
              [119.07569420700008, -8.651950778999947],
              [119.09050540500004, -8.649102471999925],
              [119.11085045700008, -8.64226653399993],
              [119.13013756600003, -8.633396091999941],
              [119.14087975400003, -8.624607028999947],
              [119.14039147200003, -8.61532968499995],
              [119.13542728000004, -8.606215101999908],
              [119.13396243600005, -8.59937916499996],
              [119.15455162900003, -8.594414971999925],
              [119.15967858200008, -8.588067315999922],
              [119.16138756600003, -8.578383070999905],
              [119.16138756600003, -8.565850518999923],
              [119.16732832100001, -8.559747002999927],
              [119.18091881600003, -8.573011976999908],
              [119.19507897200003, -8.594008070999905],
              [119.20362389400009, -8.610935153999947],
            ],
          ],
          [
            [
              [123.02637780000009, -8.28875090899993],
              [123.02800540500004, -8.297051690999922],
              [123.02637780000009, -8.32008228999996],
              [123.01872806100005, -8.33407968499995],
              [123.00074303500003, -8.340997002999927],
              [122.94288170700008, -8.343926690999922],
              [122.92115319100003, -8.34970468499995],
              [122.90414472700002, -8.36337655999995],
              [122.89730879000001, -8.38836028399993],
              [122.90381920700008, -8.426934502999927],
              [122.90455162900003, -8.44703541499996],
              [122.89730879000001, -8.46062590899993],
              [122.87842858200008, -8.462090752999927],
              [122.85287519600001, -8.454278252999927],
              [122.83057701900009, -8.44345468499995],
              [122.82097415500004, -8.436211846999925],
              [122.81771894600001, -8.426446221999925],
              [122.81080162900003, -8.42864348799992],
              [122.80355879000001, -8.437920830999929],
              [122.80054772200003, -8.45012786299992],
              [122.801117384, -8.469496351999908],
              [122.803070509, -8.477634372999944],
              [122.80738366000003, -8.486748955999929],
              [122.84937584700003, -8.55201588299991],
              [122.84839928500003, -8.583591403999947],
              [122.80738366000003, -8.610935153999947],
              [122.79712975400003, -8.613539320999905],
              [122.74732506600003, -8.62004973799992],
              [122.74097741000003, -8.623630466999941],
              [122.72852623800009, -8.63486093499995],
              [122.721039259, -8.636651299999926],
              [122.68751061300009, -8.631442966999941],
              [122.67920983200008, -8.63290780999995],
              [122.65642337300005, -8.645114841999941],
              [122.64966881600003, -8.651950778999947],
              [122.63819420700008, -8.651950778999947],
              [122.56544030000009, -8.669122002999927],
              [122.55494225400003, -8.676527601999908],
              [122.52540123800009, -8.70631275799991],
              [122.51514733200008, -8.712090752999927],
              [122.44947350400003, -8.734307549999926],
              [122.40788821700005, -8.74146900799991],
              [122.30388431100005, -8.739027601999908],
              [122.28711998800009, -8.740655205999929],
              [122.26531009200005, -8.74814218499995],
              [122.25277754000001, -8.74968840899993],
              [122.22706139400009, -8.73723723799992],
              [122.16293379000001, -8.726983330999929],
              [122.11451256600003, -8.732354424999926],
              [122.07781009200005, -8.753838799999926],
              [122.04420006600003, -8.780694268999923],
              [122.00538170700008, -8.80201588299991],
              [121.87614993600005, -8.83766041499996],
              [121.83472741000003, -8.858005466999941],
              [121.79371178500003, -8.883965752999927],
              [121.78044681100005, -8.88795338299991],
              [121.76978600400003, -8.88762786299992],
              [121.75977623800009, -8.885349216999941],
              [121.74870853000004, -8.883965752999927],
              [121.73406009200005, -8.879978122999944],
              [121.71583092500009, -8.870538018999923],
              [121.69922936300009, -8.85947030999995],
              [121.69011478000004, -8.85051848799992],
              [121.67432701900009, -8.862725518999923],
              [121.65935306100005, -8.89820728999996],
              [121.64600670700008, -8.905694268999923],
              [121.64063561300009, -8.896661065999922],
              [121.63086998800009, -8.852634372999944],
              [121.62175540500004, -8.83684661299992],
              [121.58106530000009, -8.81764088299991],
              [121.54086347700002, -8.814873955999929],
              [121.50001061300009, -8.81650155999995],
              [121.45671634200005, -8.810153903999947],
              [121.42017662900003, -8.798028252999927],
              [121.39600670700008, -8.794122002999927],
              [121.37818444100003, -8.799004815999922],
              [121.36703535200002, -8.819919528999947],
              [121.37012780000009, -8.842380466999941],
              [121.37623131600003, -8.864353122999944],
              [121.37476647200003, -8.883965752999927],
              [121.34058678500003, -8.91806405999995],
              [121.29851321700005, -8.918389580999929],
              [121.21094811300009, -8.892022393999923],
              [121.16529381600003, -8.895114841999941],
              [121.12867272200003, -8.908623955999929],
              [121.06690514400009, -8.940524997999944],
              [121.04810631600003, -8.944105726999908],
              [120.99488366000003, -8.940524997999944],
              [120.96387780000009, -8.929620049999926],
              [120.95850670700008, -8.925957940999922],
              [120.93213951900009, -8.926934502999927],
              [120.92286217500009, -8.926202080999929],
              [120.90650475400003, -8.91383228999996],
              [120.86329186300009, -8.869317315999922],
              [120.85450280000009, -8.854180596999925],
              [120.84839928500003, -8.82976653399993],
              [120.83318118600005, -8.816989841999941],
              [120.81299889400009, -8.815036716999941],
              [120.79249108200008, -8.82317473799992],
              [120.78052819100003, -8.836683851999908],
              [120.77312259200005, -8.85247161299992],
              [120.76417076900009, -8.865492445999905],
              [120.74781334700003, -8.871026299999926],
              [120.72584069100003, -8.867445570999905],
              [120.71159915500004, -8.859551690999922],
              [120.69939212300005, -8.850681247999944],
              [120.68336022200003, -8.844333591999941],
              [120.67310631600003, -8.84384530999995],
              [120.65162194100003, -8.845635674999926],
              [120.64161217500009, -8.844333591999941],
              [120.62427819100003, -8.82626718499995],
              [120.61784915500004, -8.82317473799992],
              [120.60108483200008, -8.80201588299991],
              [120.59392337300005, -8.79583098799992],
              [120.58619225400003, -8.79225025799991],
              [120.57789147200003, -8.790215752999927],
              [120.55640709700003, -8.788995049999926],
              [120.53386478000004, -8.791599216999941],
              [120.49268639400009, -8.801364841999941],
              [120.47046959700003, -8.80201588299991],
              [120.437836134, -8.79656340899993],
              [120.42579186300009, -8.79583098799992],
              [120.41431725400003, -8.797621351999908],
              [120.40430748800009, -8.800713799999926],
              [120.39372806100005, -8.801202080999929],
              [120.38160241000003, -8.79583098799992],
              [120.32300866000003, -8.830661716999941],
              [120.27906334700003, -8.82935963299991],
              [120.24390709700003, -8.82317473799992],
              [120.22364342500009, -8.81145598799992],
              [120.18262780000009, -8.776055596999925],
              [120.16529381600003, -8.768649997999944],
              [120.14478600400003, -8.768731377999927],
              [120.13103274800005, -8.77076588299991],
              [120.09424889400009, -8.788995049999926],
              [120.05884850400003, -8.799899997999944],
              [119.97575931100005, -8.813897393999923],
              [119.94711347700002, -8.832696221999925],
              [119.94336998800009, -8.832289320999905],
              [119.93930097700002, -8.832696221999925],
              [119.935883009, -8.83684661299992],
              [119.93637129000001, -8.842543226999908],
              [119.943695509, -8.853122653999947],
              [119.94271894600001, -8.858005466999941],
              [119.93376712300005, -8.864434502999927],
              [119.91993248800009, -8.87078215899993],
              [119.90739993600005, -8.871677341999941],
              [119.90186608200008, -8.861260674999926],
              [119.89185631600003, -8.80673593499995],
              [119.88363691500001, -8.802992445999905],
              [119.87256920700008, -8.803399346999925],
              [119.86036217500009, -8.80201588299991],
              [119.83969160200002, -8.792901299999926],
              [119.82398522200003, -8.780368747999944],
              [119.81275475400003, -8.763278903999947],
              [119.80567467500009, -8.740655205999929],
              [119.80372155000009, -8.596774997999944],
              [119.80779056100005, -8.57000090899993],
              [119.820648634, -8.54656340899993],
              [119.87110436300009, -8.494073174999926],
              [119.87370853000004, -8.472263278999947],
              [119.86768639400009, -8.447849216999941],
              [119.86719811300009, -8.412855726999908],
              [119.89795983200008, -8.444756768999923],
              [119.91944420700008, -8.461195570999905],
              [119.92920983200008, -8.456963799999926],
              [119.93425540500004, -8.455824476999908],
              [119.96387780000009, -8.439629815999922],
              [119.97046959700003, -8.43759530999995],
              [119.97730553500003, -8.436293226999908],
              [119.98414147200003, -8.438653252999927],
              [119.990570509, -8.44703541499996],
              [120.00269616000003, -8.43873463299991],
              [120.00977623800009, -8.42473723799992],
              [120.01514733200008, -8.405450127999927],
              [120.01783287900003, -8.402520440999922],
              [120.02222741000003, -8.388848565999922],
              [120.02475019600001, -8.384942315999922],
              [120.03345787900003, -8.383477471999925],
              [120.04175866000003, -8.38600025799991],
              [120.049164259, -8.389825127999927],
              [120.05600019600001, -8.391778252999927],
              [120.05909264400009, -8.39072030999995],
              [120.06332441500001, -8.38836028399993],
              [120.06918379000001, -8.38600025799991],
              [120.076508009, -8.384942315999922],
              [120.084320509, -8.387383721999925],
              [120.08814537900003, -8.397556247999944],
              [120.09424889400009, -8.398614190999922],
              [120.10889733200008, -8.39185963299991],
              [120.11402428500003, -8.38095468499995],
              [120.11597741000003, -8.36687590899993],
              [120.12094160200002, -8.350762627999927],
              [120.12614993600005, -8.354668877999927],
              [120.13697350400003, -8.364678643999923],
              [120.14210045700008, -8.371270440999922],
              [120.14893639400009, -8.371270440999922],
              [120.16089928500003, -8.349867445999905],
              [120.19605553500003, -8.31568775799991],
              [120.203461134, -8.299248955999929],
              [120.21290123800009, -8.29273853999996],
              [120.27702884200005, -8.26921965899993],
              [120.37794030000009, -8.27507903399993],
              [120.39193769600001, -8.267836195999905],
              [120.41098066500001, -8.235528252999927],
              [120.42204837300005, -8.227308851999908],
              [120.43726647200003, -8.232354424999926],
              [120.44467207100001, -8.24700286299992],
              [120.44971764400009, -8.26376718499995],
              [120.457367384, -8.27507903399993],
              [120.48340905000009, -8.278741143999923],
              [120.52173912900003, -8.255466403999947],
              [120.54273522200003, -8.265232028999947],
              [120.55290774800005, -8.272881768999923],
              [120.56771894600001, -8.28053150799991],
              [120.58301842500009, -8.284600518999923],
              [120.59392337300005, -8.281914971999925],
              [120.60108483200008, -8.269789320999905],
              [120.60141035200002, -8.257012627999927],
              [120.59392337300005, -8.233493747999944],
              [120.63575280000009, -8.249607028999947],
              [120.65455162900003, -8.261651299999926],
              [120.66228274800005, -8.278497002999927],
              [120.67310631600003, -8.29225025799991],
              [120.72584069100003, -8.322686455999929],
              [120.74463951900009, -8.32976653399993],
              [120.81251061300009, -8.320977471999925],
              [120.83008873800009, -8.326592705999929],
              [120.84644616000003, -8.334161065999922],
              [120.87037194100003, -8.339288018999923],
              [120.90919030000009, -8.343357028999947],
              [120.95435631600003, -8.337497653999947],
              [120.97608483200008, -8.337497653999947],
              [120.99488366000003, -8.347100518999923],
              [121.01783287900003, -8.378513278999947],
              [121.03093509200005, -8.39267343499995],
              [121.05323326900009, -8.405450127999927],
              [121.10629316500001, -8.42392343499995],
              [121.12501061300009, -8.425957940999922],
              [121.14730879000001, -8.426039320999905],
              [121.15707441500001, -8.428887627999927],
              [121.16618899800005, -8.436211846999925],
              [121.17530358200008, -8.44036223799992],
              [121.19996178500003, -8.43873463299991],
              [121.21094811300009, -8.439629815999922],
              [121.21843509200005, -8.44459400799991],
              [121.22339928500003, -8.451755466999941],
              [121.22982832100001, -8.45794036299992],
              [121.24154707100001, -8.46062590899993],
              [121.25123131600003, -8.461114190999922],
              [121.27051842500009, -8.46453215899993],
              [121.27914472700002, -8.467461846999925],
              [121.29053795700008, -8.47747161299992],
              [121.31641686300009, -8.514743747999944],
              [121.33716881600003, -8.525323174999926],
              [121.38054446700005, -8.572198174999926],
              [121.40886478000004, -8.58294036299992],
              [121.42465254000001, -8.579278252999927],
              [121.43702233200008, -8.57195403399993],
              [121.45085696700005, -8.566664320999905],
              [121.47095787900003, -8.56926848799992],
              [121.48943118600005, -8.576104424999926],
              [121.49577884200005, -8.582452080999929],
              [121.49830162900003, -8.59351978999996],
              [121.50171959700003, -8.601820570999905],
              [121.50953209700003, -8.602146091999941],
              [121.52247155000009, -8.59661223799992],
              [121.52808678500003, -8.591241143999923],
              [121.56568444100003, -8.568942966999941],
              [121.574554884, -8.565850518999923],
              [121.57349694100003, -8.547295830999929],
              [121.57447350400003, -8.537855726999908],
              [121.58375084700003, -8.53639088299991],
              [121.60816491000003, -8.542087497999944],
              [121.60271243600005, -8.521091403999947],
              [121.60271243600005, -8.496351820999905],
              [121.60962975400003, -8.476006768999923],
              [121.62549889400009, -8.467461846999925],
              [121.63868248800009, -8.47275155999995],
              [121.68043053500003, -8.511325778999947],
              [121.69629967500009, -8.51067473799992],
              [121.75131269600001, -8.490817966999941],
              [121.77271569100003, -8.486748955999929],
              [121.78443444100003, -8.489434502999927],
              [121.79029381600003, -8.492608330999929],
              [121.79590905000009, -8.494724216999941],
              [121.80681399800005, -8.494805596999925],
              [121.81397545700008, -8.491794528999947],
              [121.83472741000003, -8.473728122999944],
              [121.85157311300009, -8.484551690999922],
              [121.87159264400009, -8.49195728999996],
              [121.89275149800005, -8.492852471999925],
              [121.931976759, -8.474216403999947],
              [121.94011478000004, -8.467950127999927],
              [121.94320722700002, -8.456963799999926],
              [121.94825280000009, -8.452569268999923],
              [121.98487389400009, -8.44703541499996],
              [121.99333743600005, -8.44150155999995],
              [122.00049889400009, -8.433851820999905],
              [122.008148634, -8.42750416499996],
              [122.01905358200008, -8.425957940999922],
              [122.02865644600001, -8.43092213299991],
              [122.03728274800005, -8.440199476999908],
              [122.04118899800005, -8.449151299999926],
              [122.02654056100005, -8.461114190999922],
              [122.02214603000004, -8.479261976999908],
              [122.02564537900003, -8.49976978999996],
              [122.03956139400009, -8.514743747999944],
              [122.04908287900003, -8.51653411299992],
              [122.07105553500003, -8.514092705999929],
              [122.08106530000009, -8.514743747999944],
              [122.09205162900003, -8.519707940999922],
              [122.11247806100005, -8.532647393999923],
              [122.12549889400009, -8.53525155999995],
              [122.14112389400009, -8.541680596999925],
              [122.22974694100003, -8.61687590899993],
              [122.25806725400003, -8.631280205999929],
              [122.28842207100001, -8.633884372999944],
              [122.45101972700002, -8.604099216999941],
              [122.47738691500001, -8.59498463299991],
              [122.50074303500003, -8.57626718499995],
              [122.51465905000009, -8.552666924999926],
              [122.51246178500003, -8.52825286299992],
              [122.506195509, -8.522556247999944],
              [122.49048912900003, -8.518324476999908],
              [122.48511803500003, -8.514743747999944],
              [122.48121178500003, -8.506117445999905],
              [122.48170006600003, -8.500583591999941],
              [122.48389733200008, -8.494398695999905],
              [122.48511803500003, -8.483982028999947],
              [122.49415123800009, -8.475030205999929],
              [122.54656009200005, -8.45322030999995],
              [122.56153405000009, -8.441338799999926],
              [122.59815514400009, -8.395196221999925],
              [122.61402428500003, -8.38640715899993],
              [122.65284264400009, -8.384209893999923],
              [122.67017662900003, -8.377536716999941],
              [122.68824303500003, -8.384698174999926],
              [122.70411217500009, -8.379082940999922],
              [122.71941165500004, -8.369561455999929],
              [122.73560631600003, -8.36451588299991],
              [122.758148634, -8.36101653399993],
              [122.77222741000003, -8.351983330999929],
              [122.79371178500003, -8.32350025799991],
              [122.82016035200002, -8.305433851999908],
              [122.88086998800009, -8.285739841999941],
              [122.94410241000003, -8.215427341999941],
              [122.95069420700008, -8.203057549999926],
              [122.94044030000009, -8.19312916499996],
              [122.91700280000009, -8.187676690999922],
              [122.87614993600005, -8.185723565999922],
              [122.85303795700008, -8.19150155999995],
              [122.830414259, -8.201592705999929],
              [122.80933678500003, -8.21493905999995],
              [122.79029381600003, -8.230401299999926],
              [122.785492384, -8.22942473799992],
              [122.74887129000001, -8.233493747999944],
              [122.74138431100005, -8.23023853999996],
              [122.74040774800005, -8.22242603999996],
              [122.74512780000009, -8.20680103999996],
              [122.77515709700003, -8.162774346999925],
              [122.78003991000003, -8.14812590899993],
              [122.78419030000009, -8.12395598799992],
              [122.79566491000003, -8.110039971999925],
              [122.83464603000004, -8.08953215899993],
              [122.85320071700005, -8.07431405999995],
              [122.86255944100003, -8.069756768999923],
              [122.87614993600005, -8.06959400799991],
              [122.88559004000001, -8.074965101999908],
              [122.89429772200003, -8.09303150799991],
              [122.90040123800009, -8.09693775799991],
              [122.91749108200008, -8.10133228999996],
              [122.93653405000009, -8.111504815999922],
              [122.96436608200008, -8.131036065999922],
              [122.97966556100005, -8.146905205999929],
              [122.98292076900009, -8.160332940999922],
              [122.97787519600001, -8.196384372999944],
              [123.00660241000003, -8.26140715899993],
              [123.02149498800009, -8.27898528399993],
              [123.02637780000009, -8.28875090899993],
            ],
          ],
          [
            [
              [115.61915123800009, -8.28875090899993],
              [115.65251712300005, -8.31845468499995],
              [115.69109134200005, -8.344414971999925],
              [115.71420332100001, -8.375176690999922],
              [115.70093834700003, -8.419122002999927],
              [115.69068444100003, -8.42945728999996],
              [115.65845787900003, -8.455498955999929],
              [115.63990319100003, -8.466241143999923],
              [115.61548912900003, -8.492445570999905],
              [115.60482832100001, -8.501071872999944],
              [115.53370201900009, -8.506524346999925],
              [115.52295983200008, -8.511325778999947],
              [115.515961134, -8.534356377999927],
              [115.49878991000003, -8.548435153999947],
              [115.36402428500003, -8.59693775799991],
              [115.322601759, -8.623793226999908],
              [115.29078209700003, -8.658786716999941],
              [115.26880944100003, -8.699151299999926],
              [115.25391686300009, -8.71461353999996],
              [115.23170006600003, -8.72079843499995],
              [115.21241295700008, -8.728448174999926],
              [115.20313561300009, -8.74700286299992],
              [115.20533287900003, -8.769463799999926],
              [115.22055097700002, -8.788995049999926],
              [115.22803795700008, -8.78215911299992],
              [115.22348066500001, -8.778008721999925],
              [115.21436608200008, -8.76181405999995],
              [115.23243248800009, -8.75400155999995],
              [115.23796634200005, -8.772230726999908],
              [115.23552493600005, -8.819756768999923],
              [115.22901451900009, -8.830254815999922],
              [115.213226759, -8.83993905999995],
              [115.19507897200003, -8.847100518999923],
              [115.18091881600003, -8.85051848799992],
              [115.15739993600005, -8.851820570999905],
              [115.13453209700003, -8.850762627999927],
              [115.11345462300005, -8.84539153399993],
              [115.09498131600003, -8.83367278399993],
              [115.09424889400009, -8.81845468499995],
              [115.11491946700005, -8.803399346999925],
              [115.15919030000009, -8.78215911299992],
              [115.17066491000003, -8.768731377999927],
              [115.18189537900003, -8.746351820999905],
              [115.18628991000003, -8.72234465899993],
              [115.17693118600005, -8.703383070999905],
              [115.17237389400009, -8.69654713299991],
              [115.15609785200002, -8.662041924999926],
              [115.14869225400003, -8.658135674999926],
              [115.13982181100005, -8.655368747999944],
              [115.13184655000009, -8.651950778999947],
              [115.10336347700002, -8.629652601999908],
              [115.09009850400003, -8.614841403999947],
              [115.08472741000003, -8.600355726999908],
              [115.07667076900009, -8.585137627999927],
              [115.05811608200008, -8.570733330999929],
              [115.02263431100005, -8.54892343499995],
              [114.95313561300009, -8.485121351999908],
              [114.92701256600003, -8.467461846999925],
              [114.79664147200003, -8.405450127999927],
              [114.75586998800009, -8.39771900799991],
              [114.639008009, -8.398614190999922],
              [114.60450280000009, -8.38648853999996],
              [114.57422936300009, -8.362481377999927],
              [114.54908287900003, -8.334242445999905],
              [114.46843509200005, -8.21851978999996],
              [114.44792728000004, -8.121840101999908],
              [114.45240319100003, -8.095147393999923],
              [114.48145592500009, -8.08953215899993],
              [114.50473066500001, -8.090427341999941],
              [114.51783287900003, -8.09970468499995],
              [114.52735436300009, -8.113539320999905],
              [114.53972415500004, -8.128024997999944],
              [114.55534915500004, -8.133884372999944],
              [114.57097415500004, -8.129489841999941],
              [114.59742272200003, -8.11060963299991],
              [114.61255944100003, -8.121840101999908],
              [114.63404381600003, -8.127211195999905],
              [114.67310631600003, -8.131036065999922],
              [114.69141686300009, -8.135023695999905],
              [114.85759524800005, -8.19312916499996],
              [114.892914259, -8.180271091999941],
              [114.98438561300009, -8.180433851999908],
              [115.02263431100005, -8.172621351999908],
              [115.06324303500003, -8.143243096999925],
              [115.13591556100005, -8.072849216999941],
              [115.17286217500009, -8.055352471999925],
              [115.19312584700003, -8.055108330999929],
              [115.21550540500004, -8.05950286299992],
              [115.23617597700002, -8.067966403999947],
              [115.25196373800009, -8.079522393999923],
              [115.26880944100003, -8.089450778999947],
              [115.33790123800009, -8.103773695999905],
              [115.50245201900009, -8.172621351999908],
              [115.53532962300005, -8.19459400799991],
              [115.56511478000004, -8.22161223799992],
              [115.61915123800009, -8.28875090899993],
            ],
          ],
          [
            [
              [109.01929772200003, -7.758070570999905],
              [109.02369225400003, -7.762383721999925],
              [109.04273522200003, -7.761488539999959],
              [109.04664147200003, -7.767998955999929],
              [109.04314212300005, -7.778903903999947],
              [109.03581790500004, -7.780368747999944],
              [109.02621504000007, -7.777520440999922],
              [108.99927819100003, -7.772881768999923],
              [108.94483483200003, -7.754327080999929],
              [108.88607832100007, -7.743910414999959],
              [108.87281334700003, -7.737237237999921],
              [108.85743248800003, -7.732028903999947],
              [108.81527754000007, -7.737725518999923],
              [108.80014082100007, -7.733819268999923],
              [108.79411868600005, -7.719414971999925],
              [108.79704837300005, -7.701592705999929],
              [108.80689537900003, -7.686211846999925],
              [108.82154381600003, -7.678643487999921],
              [108.87387129000007, -7.703220309999949],
              [108.92505944100003, -7.710381768999923],
              [108.95777428500003, -7.720147393999923],
              [109.01099694100003, -7.750258070999905],
              [109.01929772200003, -7.758070570999905],
            ],
          ],
          [
            [
              [115.570648634, -6.904554945999905],
              [115.57227623800009, -6.930596612999921],
              [115.55713951900009, -6.940036716999941],
              [115.51270592500009, -6.93873463299991],
              [115.50318444100003, -6.936618747999944],
              [115.48316491000003, -6.927341403999947],
              [115.46705162900003, -6.923923434999949],
              [115.45484459700003, -6.917575778999947],
              [115.45118248800009, -6.914646091999941],
              [115.44410241000003, -6.910088799999926],
              [115.43897545700008, -6.91179778399993],
              [115.43409264400009, -6.918226820999905],
              [115.42579186300009, -6.920098565999922],
              [115.41911868600005, -6.92506275799991],
              [115.41309655000009, -6.92506275799991],
              [115.40512129000001, -6.921644789999959],
              [115.40040123800009, -6.916924737999921],
              [115.39429772200003, -6.912692966999941],
              [115.38233483200008, -6.910821221999925],
              [115.35043379000001, -6.927504164999959],
              [115.34473717500009, -6.928155205999929],
              [115.34815514400009, -6.940606377999927],
              [115.35661868600005, -6.945407809999949],
              [115.36784915500004, -6.947686455999929],
              [115.37891686300009, -6.95240650799991],
              [115.390961134, -6.961195570999905],
              [115.39600670700008, -6.96607838299991],
              [115.40064537900003, -6.972914320999905],
              [115.37826582100001, -6.987399997999944],
              [115.35531660200002, -6.982028903999947],
              [115.31739342500009, -6.95240650799991],
              [115.30323326900009, -6.96607838299991],
              [115.30103600400003, -6.972263278999947],
              [115.30054772200003, -6.977959893999923],
              [115.30152428500003, -6.981215101999908],
              [115.30323326900009, -6.980401299999926],
              [115.30355879000001, -6.985935153999947],
              [115.31137129000001, -6.995538018999923],
              [115.31055748800009, -7.000746351999908],
              [115.30600019600001, -7.004164320999905],
              [115.29948978000004, -7.007012627999927],
              [115.293304884, -7.007582289999959],
              [115.29078209700003, -7.004001559999949],
              [115.28711998800009, -7.003024997999944],
              [115.26563561300009, -6.983493747999944],
              [115.26531009200005, -6.976006768999923],
              [115.27588951900009, -6.93873463299991],
              [115.23804772200003, -6.942315362999921],
              [115.22144616000003, -6.939711195999905],
              [115.21436608200008, -6.928155205999929],
              [115.21851647200003, -6.904392184999949],
              [115.22877037900003, -6.891534112999921],
              [115.24203535200002, -6.880954684999949],
              [115.25538170700008, -6.863051039999959],
              [115.24431399800005, -6.846449476999908],
              [115.25505618600005, -6.838148695999905],
              [115.275726759, -6.835381768999923],
              [115.29493248800009, -6.83562590899993],
              [115.379242384, -6.834730726999908],
              [115.46078535200002, -6.842543226999908],
              [115.48357181100005, -6.851657809999949],
              [115.55347741000003, -6.889418226999908],
              [115.570648634, -6.904554945999905],
            ],
          ],
          [
            [
              [112.70069420700008, -5.726006768999923],
              [112.71469160200002, -5.736097914999959],
              [112.72706139400009, -5.74732838299991],
              [112.73617597700002, -5.763116143999923],
              [112.74040774800005, -5.787367445999905],
              [112.73853600400003, -5.809991143999923],
              [112.73145592500009, -5.828383070999905],
              [112.71876061300009, -5.841566664999959],
              [112.70069420700008, -5.848809502999927],
              [112.69109134200005, -5.849541924999926],
              [112.66391035200002, -5.848321221999925],
              [112.65837649800005, -5.84539153399993],
              [112.65479576900009, -5.83717213299991],
              [112.64625084700003, -5.839288018999923],
              [112.63054446700005, -5.848809502999927],
              [112.60425866000003, -5.847426039999959],
              [112.59620201900009, -5.836032809999949],
              [112.59343509200005, -5.817315362999921],
              [112.58277428500003, -5.79420338299991],
              [112.59009850400003, -5.785577080999929],
              [112.61801191500001, -5.763441664999959],
              [112.62110436300009, -5.757907809999949],
              [112.64535566500001, -5.73211028399993],
              [112.65707441500001, -5.736748955999929],
              [112.67017662900003, -5.733493747999944],
              [112.68458092500009, -5.727959893999923],
              [112.70069420700008, -5.726006768999923],
            ],
          ],
          [
            [
              [102.40650475400008, -5.403741143999923],
              [102.40023847700007, -5.418389580999929],
              [102.38648522200003, -5.430271091999941],
              [102.36622155000003, -5.441582940999922],
              [102.36963951900003, -5.453301690999922],
              [102.38249759200005, -5.466241143999923],
              [102.39014733200003, -5.476983330999929],
              [102.37875410200007, -5.482191664999959],
              [102.33236738400007, -5.472263278999947],
              [102.32447350400008, -5.468926690999922],
              [102.32129967500003, -5.472914320999905],
              [102.31364993600005, -5.472914320999905],
              [102.30469811300003, -5.471856377999927],
              [102.29786217500003, -5.472751559999949],
              [102.29420006600003, -5.477471612999921],
              [102.28353925900007, -5.49928150799991],
              [102.27035566500007, -5.488702080999929],
              [102.25733483200003, -5.457207940999922],
              [102.24610436300003, -5.441582940999922],
              [102.12769616000003, -5.349541924999926],
              [102.09864342500003, -5.334893487999921],
              [102.14722741000003, -5.289646091999941],
              [102.17204837300005, -5.280368747999944],
              [102.20101972700007, -5.287204684999949],
              [102.22828209700003, -5.301853122999944],
              [102.24170983200003, -5.306084893999923],
              [102.25977623800003, -5.307549737999921],
              [102.27393639400003, -5.312269789999959],
              [102.28638756600003, -5.323011976999908],
              [102.30404707100007, -5.342380466999941],
              [102.36589603000004, -5.361260674999926],
              [102.39437910200007, -5.375909112999921],
              [102.40650475400008, -5.403741143999923],
            ],
          ],
          [
            [
              [115.84587649800005, -4.764092705999929],
              [115.84669030000009, -4.768649997999944],
              [115.84913170700008, -4.77467213299991],
              [115.85303795700008, -4.779473565999922],
              [115.85808353000004, -4.779961846999925],
              [115.80681399800005, -4.821872653999947],
              [115.78638756600003, -4.82781340899993],
              [115.77344811300009, -4.815118096999925],
              [115.795258009, -4.786309502999927],
              [115.85181725400003, -4.739027601999908],
              [115.85181725400003, -4.745538018999923],
              [115.84701582100001, -4.757745049999926],
              [115.84587649800005, -4.764092705999929],
            ],
          ],
          [
            [
              [116.39926191500001, -3.392754815999922],
              [116.40447024800005, -3.374607028999947],
              [116.41586347700002, -3.381768487999921],
              [116.43441816500001, -3.409763278999947],
              [116.43140709700003, -3.447523695999962],
              [116.41146894600001, -3.520928643999923],
              [116.40455162900003, -3.576836846999925],
              [116.39527428500003, -3.613457940999922],
              [116.39307701900009, -3.632419528999947],
              [116.38599694100003, -3.639580987999921],
              [116.37012780000009, -3.621351820999905],
              [116.33220462300005, -3.561700127999927],
              [116.32536868600005, -3.547621351999908],
              [116.32471764400009, -3.532972914999959],
              [116.33106530000009, -3.511895440999922],
              [116.35564212300005, -3.459730726999908],
              [116.35889733200008, -3.440850518999923],
              [116.36524498800009, -3.429131768999923],
              [116.39307701900009, -3.405857028999947],
              [116.39926191500001, -3.392754815999922],
            ],
          ],
          [
            [
              [116.30372155000009, -3.71803150799991],
              [116.30974368600005, -3.724541924999926],
              [116.32496178500003, -3.732028903999947],
              [116.33106530000009, -3.739027601999908],
              [116.33326256600003, -3.749769789999959],
              [116.32105553500003, -3.756931247999944],
              [116.31153405000009, -3.785739841999941],
              [116.29932701900009, -3.799086195999905],
              [116.28923587300005, -3.815606377999927],
              [116.289398634, -3.840915622999944],
              [116.29493248800009, -3.854587497999944],
              [116.30795332100001, -3.87859465899993],
              [116.31055748800009, -3.893324476999908],
              [116.30648847700002, -3.904473565999922],
              [116.29688561300009, -3.907972914999959],
              [116.285492384, -3.908298434999949],
              [116.27637780000009, -3.90984465899993],
              [116.26758873800009, -3.917901299999926],
              [116.26270592500009, -3.92701588299991],
              [116.25709069100003, -3.934665622999944],
              [116.24594160200002, -3.937758070999905],
              [116.23121178500003, -3.938083591999941],
              [116.22185306100005, -3.939629815999922],
              [116.21509850400003, -3.943780205999929],
              [116.20818118600005, -3.951348565999922],
              [116.20655358200008, -3.95671965899993],
              [116.20753014400009, -3.969496351999908],
              [116.20476321700005, -3.975274346999925],
              [116.19898522200003, -3.979261976999908],
              [116.18384850400003, -3.987074476999908],
              [116.18091881600003, -3.989353122999944],
              [116.17774498800009, -3.995293877999927],
              [116.170258009, -4.004001559999949],
              [116.15357506600003, -4.019707940999922],
              [116.14454186300009, -4.024102471999925],
              [116.12468509200005, -4.030368747999944],
              [116.115570509, -4.036716403999947],
              [116.09978274800005, -4.060642184999949],
              [116.09148196700005, -4.066827080999929],
              [116.09034264400009, -4.050551039999959],
              [116.08285566500001, -4.037774346999925],
              [116.07105553500003, -4.03289153399993],
              [116.05738366000003, -4.04070403399993],
              [116.05014082100001, -4.020196221999925],
              [116.05347741000003, -3.997816664999959],
              [116.06031334700003, -3.975355726999908],
              [116.06421959700003, -3.954522393999923],
              [116.06836998800009, -3.951104424999926],
              [116.07781009200005, -3.948337497999944],
              [116.08716881600003, -3.943536065999922],
              [116.09148196700005, -3.934340101999908],
              [116.08871504000001, -3.924737237999921],
              [116.07601972700002, -3.90984465899993],
              [116.07154381600003, -3.903008721999925],
              [116.06885826900009, -3.885511976999908],
              [116.07781009200005, -3.824476820999905],
              [116.07447350400003, -3.800876559999949],
              [116.06609134200005, -3.787041924999926],
              [116.04371178500003, -3.765801690999922],
              [116.02564537900003, -3.740166924999926],
              [116.01905358200008, -3.724867445999905],
              [116.01303144600001, -3.650485934999949],
              [116.01636803500003, -3.629164320999905],
              [116.04053795700008, -3.566338799999926],
              [116.04639733200008, -3.497491143999923],
              [116.05250084700003, -3.478692315999922],
              [116.09669030000009, -3.39967213299991],
              [116.11793053500003, -3.336114190999922],
              [116.11939537900003, -3.324151299999926],
              [116.12623131600003, -3.318617445999962],
              [116.15919030000009, -3.303643487999921],
              [116.17066491000003, -3.296807549999926],
              [116.22917728000004, -3.245538018999923],
              [116.24594160200002, -3.238213799999926],
              [116.25473066500001, -3.232598565999922],
              [116.26140384200005, -3.222588799999926],
              [116.26783287900003, -3.218845309999949],
              [116.27637780000009, -3.232028903999947],
              [116.27857506600003, -3.244724216999941],
              [116.27613366000003, -3.256280205999929],
              [116.27214603000004, -3.267754815999922],
              [116.25896243600005, -3.366631768999923],
              [116.26303144600001, -3.40553150799991],
              [116.289398634, -3.444268487999921],
              [116.30469811300009, -3.460137627999927],
              [116.31885826900009, -3.480401299999926],
              [116.32105553500003, -3.49773528399993],
              [116.27637780000009, -3.513604424999926],
              [116.27409915500004, -3.53289153399993],
              [116.28199303500003, -3.553643487999921],
              [116.289398634, -3.566582940999922],
              [116.29704837300005, -3.584730726999908],
              [116.29883873800009, -3.602146091999941],
              [116.29688561300009, -3.646091403999947],
              [116.30258222700002, -3.669854424999926],
              [116.30372155000009, -3.680108330999929],
              [116.30372155000009, -3.71803150799991],
            ],
          ],
          [
            [
              [100.50847415500004, -3.122165622999944],
              [100.50831139400003, -3.140801690999922],
              [100.51547285200007, -3.153903903999947],
              [100.53638756600003, -3.176853122999944],
              [100.52881920700003, -3.183526299999926],
              [100.50668379000007, -3.178399346999925],
              [100.49366295700003, -3.160251559999949],
              [100.49301191500007, -3.138278903999947],
              [100.50847415500004, -3.122165622999944],
            ],
          ],
          [
            [
              [100.39861087300005, -3.183526299999926],
              [100.41163170700003, -3.213474216999941],
              [100.42652428500003, -3.238213799999926],
              [100.46697024800005, -3.287286065999922],
              [100.47828209700003, -3.315199476999908],
              [100.46070397200003, -3.334405205999929],
              [100.44825280000003, -3.325372002999927],
              [100.42937259200005, -3.303155205999929],
              [100.41895592500003, -3.293389580999929],
              [100.40788821700005, -3.286879164999959],
              [100.38607832100007, -3.277520440999922],
              [100.37867272200003, -3.272393487999921],
              [100.37761478000004, -3.268161716999941],
              [100.37867272200003, -3.248711846999925],
              [100.37623131600003, -3.241143487999921],
              [100.37037194100003, -3.23951588299991],
              [100.36361738400007, -3.239841403999947],
              [100.35824629000007, -3.238213799999926],
              [100.33692467500003, -3.222588799999926],
              [100.33041425900007, -3.212985934999949],
              [100.33033287900008, -3.197360934999949],
              [100.33716881600003, -3.197360934999949],
              [100.33920332100007, -3.203220309999949],
              [100.34245853000004, -3.207696221999925],
              [100.34734134200005, -3.210544528999947],
              [100.35450280000003, -3.211521091999941],
              [100.36019941500007, -3.207452080999929],
              [100.35580488400007, -3.198337497999944],
              [100.34400475400008, -3.183526299999926],
              [100.33765709700003, -3.161553643999923],
              [100.33716881600003, -3.152927341999941],
              [100.34351647200003, -3.13640715899993],
              [100.34522545700003, -3.126560153999947],
              [100.29232832100007, -3.077080987999921],
              [100.27735436300003, -3.072930596999925],
              [100.25928795700003, -3.073174737999921],
              [100.24822024800005, -3.069431247999944],
              [100.25464928500003, -3.053317966999941],
              [100.24415123800003, -3.044040622999944],
              [100.21322675900007, -3.006931247999944],
              [100.20679772200003, -2.994886976999908],
              [100.20362389400003, -2.983819268999923],
              [100.18946373800003, -2.966566664999959],
              [100.18628991000003, -2.953871351999908],
              [100.18848717500003, -2.941664320999962],
              [100.19776451900003, -2.929294528999947],
              [100.19996178500003, -2.919854424999926],
              [100.19752037900008, -2.896254164999959],
              [100.17945397200003, -2.827325127999927],
              [100.17896569100003, -2.802911065999922],
              [100.18913821700005, -2.791192315999922],
              [100.22730553500003, -2.772637627999927],
              [100.24024498800003, -2.778252862999921],
              [100.24903405000003, -2.784356377999927],
              [100.25538170700003, -2.791436455999929],
              [100.27507571700005, -2.820489190999922],
              [100.28150475400008, -2.826104424999926],
              [100.28638756600003, -2.828708591999941],
              [100.29086347700007, -2.830661716999941],
              [100.29615319100003, -2.834161065999922],
              [100.35434004000007, -2.894463799999926],
              [100.38510175900007, -2.914646091999941],
              [100.41586347700007, -2.965915622999944],
              [100.46753991000003, -3.01531340899993],
              [100.47144616000003, -3.037855726999908],
              [100.47201582100007, -3.051690362999921],
              [100.46753991000003, -3.066989841999941],
              [100.47331790500004, -3.08717213299991],
              [100.47291100400008, -3.113946221999925],
              [100.46452884200005, -3.13250090899993],
              [100.44703209700003, -3.128350518999923],
              [100.43718509200005, -3.134372653999947],
              [100.42652428500003, -3.13640715899993],
              [100.41586347700007, -3.134372653999947],
              [100.40601647200003, -3.128350518999923],
              [100.38640384200005, -3.14381275799991],
              [100.38070722700007, -3.152520440999922],
              [100.38868248800003, -3.156345309999949],
              [100.40211022200003, -3.158868096999925],
              [100.40316816500007, -3.165459893999923],
              [100.39942467500003, -3.174248955999929],
              [100.39861087300005, -3.183526299999926],
            ],
          ],
          [
            [
              [100.20679772200003, -2.693536065999922],
              [100.20972741000003, -2.707696221999925],
              [100.21517988400007, -2.723565362999921],
              [100.21859785200007, -2.739353122999944],
              [100.21517988400007, -2.752862237999921],
              [100.20411217500003, -2.759942315999922],
              [100.17237389400003, -2.765557549999926],
              [100.15894616000003, -2.772637627999927],
              [100.15137780000003, -2.78484465899993],
              [100.14519290500004, -2.811130466999941],
              [100.13851972700007, -2.820489190999922],
              [100.11524498800003, -2.827894789999959],
              [100.08985436300003, -2.824395440999922],
              [100.06666100400008, -2.815524997999944],
              [100.04965254000007, -2.806817315999922],
              [100.04476972700007, -2.820896091999941],
              [100.03834069100003, -2.833754164999959],
              [100.02930748800003, -2.840101820999962],
              [100.01563561300003, -2.834161065999922],
              [100.00782311300003, -2.819512627999927],
              [100.00700931100005, -2.781914971999925],
              [100.00131269600007, -2.76531340899993],
              [99.98682701900003, -2.767185153999947],
              [99.98845462300005, -2.744886976999908],
              [100.00131269600007, -2.686700127999927],
              [100.00049889400003, -2.658868096999925],
              [99.99626712300005, -2.638767184999949],
              [99.98601321700005, -2.62468840899993],
              [99.96713300900007, -2.615004164999959],
              [99.97575931100005, -2.603448174999926],
              [99.97559655000003, -2.594903252999927],
              [99.96713300900007, -2.580254815999922],
              [99.96143639400003, -2.559014580999929],
              [99.96094811300003, -2.552911065999922],
              [99.96729576900003, -2.51490650799991],
              [99.97461998800003, -2.493910414999959],
              [99.98414147200003, -2.484633070999962],
              [100.00294030000003, -2.490899346999925],
              [100.01368248800003, -2.504815362999921],
              [100.02173912900008, -2.518731377999927],
              [100.03239993600005, -2.52507903399993],
              [100.08708743600005, -2.576267184999949],
              [100.10759524800005, -2.600274346999925],
              [100.11744225400008, -2.608168226999908],
              [100.15211022200003, -2.618584893999923],
              [100.16667728000004, -2.627862237999921],
              [100.17261803500003, -2.64576588299991],
              [100.17798912900008, -2.65593840899993],
              [100.20142662900008, -2.678155205999929],
              [100.20679772200003, -2.693536065999922],
            ],
          ],
          [
            [
              [99.82325280000003, -2.292901299999926],
              [99.84961998800003, -2.333916924999926],
              [99.85873457100007, -2.356866143999923],
              [99.85792076900003, -2.374769789999959],
              [99.85792076900003, -2.367364190999922],
              [99.85336347700007, -2.377618096999925],
              [99.84620201900003, -2.380059502999927],
              [99.83969160200007, -2.375258070999962],
              [99.83334394600007, -2.352308851999908],
              [99.82455488400007, -2.347588799999926],
              [99.79957116000003, -2.347426039999959],
              [99.78809655000003, -2.344414971999925],
              [99.77995853000004, -2.337009372999944],
              [99.77214603000004, -2.328220309999949],
              [99.76172936300003, -2.320896091999941],
              [99.74976647200003, -2.31804778399993],
              [99.72510826900003, -2.317071221999925],
              [99.71338951900003, -2.313409112999921],
              [99.69922936300003, -2.300876559999949],
              [99.68702233200003, -2.284926039999959],
              [99.67172285200007, -2.271254164999959],
              [99.64844811300003, -2.265557549999926],
              [99.61085045700003, -2.267185153999947],
              [99.60352623800003, -2.265557549999926],
              [99.60254967500003, -2.253024997999944],
              [99.61158287900008, -2.242771091999941],
              [99.61646569100003, -2.233575127999927],
              [99.60352623800003, -2.224053643999923],
              [99.59766686300003, -2.229099216999941],
              [99.59392337300005, -2.22779713299991],
              [99.59148196700005, -2.221368096999925],
              [99.58985436300003, -2.211032809999949],
              [99.58301842500003, -2.211032809999949],
              [99.57618248800003, -2.224053643999923],
              [99.56771894600007, -2.215101820999962],
              [99.55567467500003, -2.183038018999923],
              [99.53126061300003, -2.15593840899993],
              [99.52767988400007, -2.145440362999921],
              [99.53101647200003, -2.134209893999923],
              [99.53842207100007, -2.131768487999921],
              [99.55225670700003, -2.135349216999941],
              [99.56446373800003, -2.131117445999962],
              [99.56226647200003, -2.121677341999941],
              [99.54883873800003, -2.101169528999947],
              [99.54835045700003, -2.061455987999921],
              [99.56495201900003, -2.030857028999947],
              [99.59400475400008, -2.014825127999927],
              [99.63135826900003, -2.018487237999921],
              [99.64332116000003, -2.028415622999944],
              [99.65186608200003, -2.042087497999944],
              [99.66285241000003, -2.054294528999947],
              [99.68262780000003, -2.059502862999921],
              [99.69434655000003, -2.067803643999923],
              [99.70053144600007, -2.087497653999947],
              [99.70720462300005, -2.127699476999908],
              [99.72136478000004, -2.159112237999921],
              [99.77540123800003, -2.23756275799991],
              [99.77588951900003, -2.242445570999962],
              [99.77426191500007, -2.254327080999929],
              [99.77540123800003, -2.258721612999921],
              [99.77881920700003, -2.261651299999926],
              [99.78581790500004, -2.263441664999959],
              [99.81462649800005, -2.284356377999927],
              [99.82325280000003, -2.292901299999926],
            ],
          ],
          [
            [
              [108.96420332100007, -1.573418877999927],
              [108.96753991000003, -1.587985934999949],
              [108.96436608200003, -1.604180596999925],
              [108.95728600400003, -1.619561455999929],
              [108.94825280000003, -1.631524346999925],
              [108.93327884200005, -1.640801690999922],
              [108.86980228000004, -1.662286065999922],
              [108.85816491000003, -1.663995049999926],
              [108.83122806100005, -1.662286065999922],
              [108.82837975400003, -1.656996351999908],
              [108.82520592500003, -1.645114841999941],
              [108.82341556100005, -1.632419528999947],
              [108.82439212300005, -1.62468840899993],
              [108.82984459700003, -1.615899346999925],
              [108.83228600400003, -1.605401299999926],
              [108.83155358200003, -1.595147393999923],
              [108.82748457100007, -1.586602471999925],
              [108.82105553500003, -1.58326588299991],
              [108.80420983200003, -1.584893487999921],
              [108.79330488400007, -1.580336195999962],
              [108.80713951900003, -1.565036716999941],
              [108.83106530000003, -1.556084893999923],
              [108.87598717500003, -1.54615650799991],
              [108.88689212300005, -1.539727471999925],
              [108.89283287900003, -1.534274997999944],
              [108.90056399800005, -1.53289153399993],
              [108.91684004000007, -1.53875090899993],
              [108.92855879000007, -1.544854424999926],
              [108.95573978000004, -1.563571872999944],
              [108.96420332100007, -1.573418877999927],
            ],
          ],
          [
            [
              [109.75977623800003, -1.103936455999929],
              [109.76295006600003, -1.109551690999922],
              [109.77003014400003, -1.11492278399993],
              [109.77711022200003, -1.121758721999925],
              [109.78028405000003, -1.131605726999908],
              [109.77686608200003, -1.140801690999922],
              [109.76807701900003, -1.146905205999929],
              [109.74610436300003, -1.155205987999921],
              [109.69825280000003, -1.190524997999944],
              [109.68775475400003, -1.196058851999908],
              [109.67448978000004, -1.199395440999922],
              [109.60132897200003, -1.230075778999947],
              [109.56950931100005, -1.24773528399993],
              [109.53598066500007, -1.25904713299991],
              [109.50245201900003, -1.292168877999927],
              [109.47868899800005, -1.29851653399993],
              [109.46558678500003, -1.293389580999929],
              [109.44499759200005, -1.281345309999949],
              [109.42554772200003, -1.26685963299991],
              [109.41724694100003, -1.254489841999941],
              [109.42066491000003, -1.231622002999927],
              [109.44450931100005, -1.168877862999921],
              [109.45232181100005, -1.004001559999949],
              [109.45923912900003, -0.985446872999944],
              [109.47543379000007, -0.976983330999929],
              [109.49122155000003, -0.979180596999925],
              [109.52515709700003, -0.988457940999922],
              [109.54420006600003, -0.990655205999929],
              [109.55616295700003, -0.987481377999927],
              [109.57715905000003, -0.973321221999925],
              [109.58790123800003, -0.970310153999947],
              [109.60629316500007, -0.974704684999949],
              [109.63965905000003, -0.996270440999922],
              [109.65674889400003, -1.003676039999959],
              [109.67457116000003, -1.00359465899993],
              [109.68620853000004, -0.996840101999908],
              [109.69507897200003, -0.988539320999962],
              [109.70460045700003, -0.983819268999923],
              [109.72348066500007, -0.987074476999908],
              [109.73926842500003, -0.998711846999925],
              [109.75131269600007, -1.01490650799991],
              [109.75977623800003, -1.031670830999929],
              [109.75977623800003, -1.103936455999929],
            ],
          ],
          [
            [
              [99.27442467500003, -1.634942315999922],
              [99.28687584700003, -1.653741143999923],
              [99.29428144600007, -1.686211846999925],
              [99.29200280000003, -1.718926690999922],
              [99.27442467500003, -1.73796965899993],
              [99.26148522200003, -1.669691664999959],
              [99.25416100400008, -1.654473565999922],
              [99.22673587300005, -1.614434502999927],
              [99.21404056100005, -1.623630466999941],
              [99.20875084700003, -1.625746351999908],
              [99.20004316500007, -1.628106377999927],
              [99.21078535200007, -1.638929945999962],
              [99.24537194100003, -1.715508721999925],
              [99.25505618600005, -1.756036065999922],
              [99.25489342500003, -1.772067966999941],
              [99.24415123800003, -1.77898528399993],
              [99.23080488400007, -1.77703215899993],
              [99.20818118600005, -1.770603122999944],
              [99.18213951900003, -1.773695570999962],
              [99.16456139400003, -1.778415622999944],
              [99.14820397200003, -1.785821221999925],
              [99.13428795700003, -1.796075127999927],
              [99.11850019600007, -1.802341403999947],
              [99.10059655000003, -1.799411716999941],
              [98.98568769600007, -1.740004164999959],
              [98.96013431100005, -1.713067315999922],
              [98.89869225400008, -1.687758070999962],
              [98.88477623800003, -1.67937590899993],
              [98.84302819100003, -1.621270440999922],
              [98.83814537900008, -1.617852471999925],
              [98.82642662900008, -1.612481377999927],
              [98.82260175900007, -1.607598565999922],
              [98.83033287900008, -1.570245049999926],
              [98.81169681100005, -1.52898528399993],
              [98.65137780000003, -1.29851653399993],
              [98.63550866000003, -1.289646091999941],
              [98.63086998800003, -1.28484465899993],
              [98.63005618600005, -1.280205987999921],
              [98.63160241000003, -1.26921965899993],
              [98.63086998800003, -1.264418226999908],
              [98.61378014400003, -1.229180596999925],
              [98.60694420700003, -1.22039153399993],
              [98.59376061300003, -1.198418877999927],
              [98.59791100400008, -1.176934502999927],
              [98.62403405000003, -1.134698174999926],
              [98.64283287900008, -1.093926690999922],
              [98.64893639400003, -1.072035414999959],
              [98.65137780000003, -1.049004815999922],
              [98.64975019600007, -1.004327080999929],
              [98.65162194100003, -0.982028903999947],
              [98.65821373800003, -0.963474216999941],
              [98.66846764400003, -0.95435963299991],
              [98.68482506600003, -0.948011976999908],
              [98.70411217500003, -0.944105726999908],
              [98.72364342500003, -0.942966403999947],
              [98.73796634200005, -0.945733330999929],
              [98.76905358200003, -0.956475518999923],
              [98.78858483200003, -0.956638278999947],
              [98.80323326900003, -0.949802341999941],
              [98.82748457100007, -0.927178643999923],
              [98.84001712300005, -0.922458591999941],
              [98.88282311300003, -0.913181247999944],
              [98.89820397200003, -0.91570403399993],
              [98.89161217500003, -0.935479424999926],
              [98.91797936300003, -0.940118096999925],
              [98.93751061300003, -0.960056247999944],
              [98.94581139400003, -0.984633070999962],
              [98.93930097700007, -1.003676039999959],
              [98.93238366000003, -0.996840101999908],
              [98.92481530000003, -0.992445570999962],
              [98.91602623800003, -0.990492445999962],
              [98.90528405000003, -0.990655205999929],
              [98.91293379000007, -1.006117445999962],
              [98.92188561300003, -1.017510674999926],
              [98.92945397200003, -1.029961846999925],
              [98.93246504000007, -1.049004815999922],
              [98.93832441500007, -1.065118096999925],
              [98.95240319100003, -1.07545338299991],
              [98.96810957100007, -1.08367278399993],
              [98.98031660200007, -1.093682549999926],
              [98.98926842500003, -1.111097914999959],
              [99.00171959700003, -1.144707940999922],
              [99.01099694100003, -1.158868096999925],
              [99.02662194100003, -1.174248955999929],
              [99.03256269600007, -1.182549737999921],
              [99.03492272200003, -1.192803643999923],
              [99.03638756600003, -1.205498955999929],
              [99.04037519600007, -1.210137627999927],
              [99.04704837300005, -1.213799737999921],
              [99.06430097700007, -1.234551690999922],
              [99.06763756600003, -1.241387627999927],
              [99.06959069100003, -1.251397393999923],
              [99.06519616000003, -1.251885674999926],
              [99.05738366000003, -1.261488539999959],
              [99.05307050900007, -1.272637627999927],
              [99.05909264400003, -1.278008721999925],
              [99.07764733200003, -1.283379815999922],
              [99.08741295700003, -1.296807549999926],
              [99.09644616000003, -1.332696221999925],
              [99.11670983200003, -1.366631768999923],
              [99.14405358200003, -1.389092705999929],
              [99.16472415500004, -1.414239190999922],
              [99.16529381600003, -1.456231377999927],
              [99.15577233200003, -1.451267184999949],
              [99.13054446700005, -1.428887627999927],
              [99.12427819100003, -1.428887627999927],
              [99.13062584700003, -1.448174737999921],
              [99.14584394600007, -1.469414971999925],
              [99.17888431100005, -1.504571221999925],
              [99.18824303500003, -1.510349216999941],
              [99.19703209700003, -1.512872002999927],
              [99.20362389400003, -1.51726653399993],
              [99.20630944100003, -1.528903903999947],
              [99.20630944100003, -1.556084893999923],
              [99.20972741000003, -1.572930596999925],
              [99.21941165500004, -1.57976653399993],
              [99.23365319100003, -1.580824476999908],
              [99.25123131600003, -1.580336195999962],
              [99.26205488400007, -1.586683851999908],
              [99.27247155000003, -1.601820570999962],
              [99.27808678500003, -1.620049737999921],
              [99.27442467500003, -1.634942315999922],
            ],
          ],
          [
            [
              [98.50196373800003, -0.460544528999947],
              [98.50456790500004, -0.473565362999921],
              [98.50163821700005, -0.486097914999959],
              [98.49512780000003, -0.498630466999941],
              [98.48682701900003, -0.510918877999927],
              [98.49642988400007, -0.520928643999923],
              [98.50269616000003, -0.535414320999962],
              [98.50440514400003, -0.551202080999929],
              [98.50049889400003, -0.565606377999927],
              [98.49366295700003, -0.565606377999927],
              [98.49293053500003, -0.55787525799991],
              [98.49138431100005, -0.553887627999927],
              [98.48910566500007, -0.550713799999926],
              [98.48682701900003, -0.545586846999925],
              [98.47925866000003, -0.553155205999929],
              [98.47348066500007, -0.556735934999949],
              [98.46745853000004, -0.556084893999923],
              [98.45899498800003, -0.551853122999944],
              [98.46778405000003, -0.538832289999959],
              [98.46208743600005, -0.529473565999922],
              [98.44792728000004, -0.526299737999921],
              [98.43165123800003, -0.531996351999908],
              [98.42554772200003, -0.543389580999929],
              [98.42188561300003, -0.56178150799991],
              [98.42042076900003, -0.579034112999921],
              [98.42204837300005, -0.586602471999925],
              [98.39031009200005, -0.577080987999921],
              [98.31674238400007, -0.535088799999926],
              [98.27515709700003, -0.525160414999959],
              [98.28419030000003, -0.521742445999962],
              [98.29509524800005, -0.51336028399993],
              [98.30201256600003, -0.510918877999927],
              [98.31185957100007, -0.511976820999962],
              [98.32927493600005, -0.518731377999927],
              [98.33611087300005, -0.517754815999922],
              [98.34213300900007, -0.506280205999929],
              [98.36402428500003, -0.441989841999941],
              [98.36597741000003, -0.422051690999922],
              [98.36264082100007, -0.38014088299991],
              [98.36402428500003, -0.360039971999925],
              [98.36890709700003, -0.349216403999947],
              [98.38941491000003, -0.320896091999941],
              [98.39812259200005, -0.312269789999959],
              [98.40544681100005, -0.308851820999962],
              [98.41342207100007, -0.306735934999949],
              [98.42066491000003, -0.303806247999944],
              [98.42546634200005, -0.298597914999959],
              [98.42611738400007, -0.288181247999944],
              [98.41863040500004, -0.257582289999959],
              [98.42920983200003, -0.24382903399993],
              [98.44068444100003, -0.246514580999929],
              [98.45118248800003, -0.258396091999941],
              [98.49341881600003, -0.329196872999944],
              [98.50733483200003, -0.36492278399993],
              [98.50049889400003, -0.387383721999925],
              [98.51026451900003, -0.403741143999923],
              [98.51238040500004, -0.422946872999944],
              [98.50879967500003, -0.442559502999927],
              [98.50196373800003, -0.460544528999947],
            ],
          ],
          [
            [
              [98.47999108200003, -0.158379815999922],
              [98.49732506600003, -0.199802341999941],
              [98.53223717500003, -0.239353122999944],
              [98.55982506600003, -0.278252862999921],
              [98.55518639400003, -0.318536065999922],
              [98.55518639400003, -0.312269789999959],
              [98.55176842500003, -0.322198174999926],
              [98.54322350400008, -0.334079684999949],
              [98.54151451900003, -0.34303150799991],
              [98.54265384200005, -0.354180596999925],
              [98.54786217500003, -0.369235934999949],
              [98.54900149800005, -0.381117445999962],
              [98.54151451900003, -0.381117445999962],
              [98.51246178500003, -0.319024346999925],
              [98.40552819100003, -0.168226820999962],
              [98.38998457100007, -0.140394789999959],
              [98.36329186300003, -0.074395440999922],
              [98.34351647200003, -0.044732354999951],
              [98.33187910200007, -0.03679778399993],
              [98.31592858200003, -0.028334242999961],
              [98.30176842500003, -0.018731377999927],
              [98.29566491000003, -0.007256768999923],
              [98.30445397200003, -0.001722914999959],
              [98.32496178500003, 0.003973700000074],
              [98.36402428500003, 0.01048411700009],
              [98.40609785200007, -0.007378838999955],
              [98.44336998800003, -0.05201588299991],
              [98.46998131600003, -0.107517184999949],
              [98.47999108200003, -0.158379815999922],
            ],
          ],
          [
            [
              [103.29363040500004, 0.625433661000045],
              [103.29786217500003, 0.604722398000092],
              [103.29997806100005, 0.575425523000092],
              [103.29574629000007, 0.549383856000077],
              [103.28077233200003, 0.538031317000048],
              [103.19556725400008, 0.520453192000048],
              [103.18336022200003, 0.514837958000044],
              [103.17066491000003, 0.513739325000074],
              [103.15316816500007, 0.523830471000053],
              [103.14047285200007, 0.53937409100007],
              [103.13599694100003, 0.556219794000071],
              [103.13672936300003, 0.573879299000055],
              [103.15894616000003, 0.66478099200009],
              [103.17920983200003, 0.695502020000049],
              [103.21176191500007, 0.708156643000052],
              [103.23023522200003, 0.704169012000079],
              [103.24691816500007, 0.694037177000041],
              [103.26148522200003, 0.68032461100006],
              [103.27320397200003, 0.665676174000055],
              [103.28516686300003, 0.646389065000051],
              [103.29363040500004, 0.625433661000045],
            ],
          ],
          [
            [
              [103.51872806100005, 0.818426825000074],
              [103.52320397200003, 0.807928778000075],
              [103.52442467500003, 0.798488674000055],
              [103.52344811300003, 0.777818101000094],
              [103.49048912900008, 0.821275132000039],
              [103.47592207100007, 0.832220770000049],
              [103.44027754000007, 0.844224351000094],
              [103.42579186300003, 0.854396877000056],
              [103.42123457100007, 0.873236395000049],
              [103.43083743600005, 0.867661851000094],
              [103.48853600400008, 0.845445054000038],
              [103.49732506600003, 0.840236721000053],
              [103.50554446700005, 0.833970445000091],
              [103.51270592500003, 0.82680898600006],
              [103.51872806100005, 0.818426825000074],
            ],
          ],
          [
            [
              [103.81861412900008, 0.886216539000088],
              [103.86329186300003, 0.876898505000042],
              [103.89820397200003, 0.853338934000078],
              [103.92416425900007, 0.822455145000049],
              [103.94214928500003, 0.79132721600007],
              [103.94141686300003, 0.77570221600007],
              [103.93287194100003, 0.770331122000073],
              [103.92139733200003, 0.772772528000075],
              [103.91138756600003, 0.780747789000088],
              [103.89503014400003, 0.810248114000046],
              [103.88746178500003, 0.818019924000055],
              [103.85173587300005, 0.835353908000059],
              [103.84595787900008, 0.842474677000041],
              [103.84229576900003, 0.850653387000079],
              [103.81861412900008, 0.880072333000044],
              [103.81861412900008, 0.886216539000088],
            ],
          ],
          [
            [
              [103.48902428500003, 0.777044989000046],
              [103.50196373800003, 0.763373114000046],
              [103.50684655000003, 0.755438544000071],
              [103.51002037900008, 0.742865302000041],
              [103.48031660200007, 0.685248114000046],
              [103.45948326900003, 0.658107815000051],
              [103.43433678500003, 0.647284247000073],
              [103.41570071700005, 0.657375393000052],
              [103.40308678500003, 0.678208726000094],
              [103.39372806100005, 0.698797919000071],
              [103.38379967500003, 0.708156643000052],
              [103.34555097700007, 0.763373114000046],
              [103.34050540500004, 0.784002997000073],
              [103.33871504000007, 0.804917710000041],
              [103.34115644600007, 0.817368882000039],
              [103.35035241000003, 0.839178778000075],
              [103.35743248800003, 0.872463283000059],
              [103.36988366000003, 0.886053778000075],
              [103.38550866000003, 0.888861395000049],
              [103.40088951900003, 0.880072333000044],
              [103.41000410200007, 0.864569403000075],
              [103.41749108200003, 0.846502997000073],
              [103.42758222700007, 0.831610419000071],
              [103.45972741000003, 0.820379950000074],
              [103.47046959700003, 0.807928778000075],
              [103.48902428500003, 0.777044989000046],
            ],
          ],
          [
            [
              [103.80176842500003, 0.852728583000044],
              [103.81706790500004, 0.841701565000051],
              [103.83106530000003, 0.816351630000042],
              [103.83952884200005, 0.788397528000075],
              [103.83765709700003, 0.769517320000091],
              [103.83228600400008, 0.765366929000038],
              [103.82667076900003, 0.765692450000074],
              [103.82105553500003, 0.768947658000059],
              [103.80128014400003, 0.784247137000079],
              [103.76392662900008, 0.804917710000041],
              [103.74634850400008, 0.822739976000094],
              [103.73047936300003, 0.847560940000051],
              [103.72624759200005, 0.873236395000049],
              [103.74341881600003, 0.893744208000044],
              [103.75025475400008, 0.888861395000049],
              [103.76775149800005, 0.884344794000071],
              [103.77759850400008, 0.880072333000044],
              [103.80176842500003, 0.852728583000044],
            ],
          ],
          [
            [
              [103.94214928500003, 0.996079820000091],
              [103.95199629000007, 0.987941799000055],
              [103.96143639400003, 0.974798895000049],
              [103.96729576900003, 0.960109768000052],
              [103.96664472700007, 0.947211005000042],
              [103.95883222700007, 0.93976471600007],
              [103.94629967500003, 0.935614325000074],
              [103.93279056100005, 0.934027411000045],
              [103.92164147200003, 0.934637762000079],
              [103.91138756600003, 0.937933661000045],
              [103.85661868600005, 0.968410549000055],
              [103.84644616000003, 0.977484442000048],
              [103.83969160200007, 0.989935614000046],
              [103.83887780000003, 1.002997137000079],
              [103.84473717500003, 1.012681382000039],
              [103.85661868600005, 1.01439036700009],
              [103.87378991000003, 1.003607489000046],
              [103.87370853000004, 1.011908270000049],
              [103.88005618600005, 1.031480210000041],
              [103.89283287900008, 1.014349677000041],
              [103.90902754000007, 1.005926825000074],
              [103.94214928500003, 0.996079820000091],
            ],
          ],
          [
            [
              [104.79859459700003, 1.031480210000041],
              [104.81104576900003, 1.025620835000041],
              [104.83008873800003, 1.023382880000042],
              [104.84351647200003, 1.01821523600006],
              [104.83904056100005, 1.003607489000046],
              [104.84555097700007, 0.997788804000038],
              [104.84994550900007, 0.991197007000039],
              [104.85230553500003, 0.983710028000075],
              [104.85279381600003, 0.975490627000056],
              [104.84961998800003, 0.968898830000057],
              [104.84538821700005, 0.963324286000045],
              [104.83969160200007, 0.958807684000078],
              [104.83277428500003, 0.955145575000074],
              [104.82829837300005, 0.964992580000057],
              [104.82634524800005, 0.976629950000074],
              [104.82593834700003, 0.992987372000073],
              [104.82178795700003, 0.998724677000041],
              [104.79118899800005, 1.02407461100006],
              [104.79859459700003, 1.031480210000041],
            ],
          ],
          [
            [
              [107.56202233200003, 1.037176825000074],
              [107.58594811300003, 1.026068427000041],
              [107.59888756600003, 1.017157294000071],
              [107.60157311300003, 1.009833075000074],
              [107.57545006600003, 0.980169989000046],
              [107.55958092500003, 0.97016022300005],
              [107.54712975400003, 0.976263739000046],
              [107.54761803500003, 0.982123114000046],
              [107.55339603000004, 0.987453518000052],
              [107.55909264400003, 0.993963934000078],
              [107.55941816500007, 1.003607489000046],
              [107.55404707100007, 1.006903387000079],
              [107.54525800900007, 1.006252346000053],
              [107.53598066500007, 1.007879950000074],
              [107.52955162900003, 1.018052476000094],
              [107.53126061300003, 1.027899481000077],
              [107.53907311300003, 1.034328518000052],
              [107.55014082100007, 1.037502346000053],
              [107.56202233200003, 1.037176825000074],
            ],
          ],
          [
            [
              [103.44312584700003, 1.012762762000079],
              [103.44483483200003, 1.00617096600007],
              [103.44483483200003, 1.00031159100007],
              [103.44223066500007, 0.995266018000052],
              [103.43702233200003, 0.991400458000044],
              [103.42359459700003, 0.990179755000042],
              [103.40756269600007, 0.994940497000073],
              [103.38038170700003, 1.009833075000074],
              [103.35767662900008, 1.004461981000077],
              [103.34083092500003, 1.019517320000091],
              [103.31478925900007, 1.061590887000079],
              [103.31560306100005, 1.073187567000048],
              [103.32349694100003, 1.092759507000039],
              [103.33383222700007, 1.111395575000074],
              [103.34213300900007, 1.119696356000077],
              [103.34791100400008, 1.121771552000041],
              [103.36646569100003, 1.13117096600007],
              [103.37671959700003, 1.133286851000094],
              [103.38982181100005, 1.130275783000059],
              [103.39136803500003, 1.122463283000059],
              [103.38819420700003, 1.111721096000053],
              [103.38721764400003, 1.099798895000049],
              [103.39307701900003, 1.076076565000051],
              [103.39779707100007, 1.064154364000046],
              [103.40398196700005, 1.054836330000057],
              [103.40967858200003, 1.051174221000053],
              [103.42269941500007, 1.049709377000056],
              [103.42839603000004, 1.04718659100007],
              [103.43140709700003, 1.042710679000038],
              [103.43165123800003, 1.038153387000079],
              [103.43116295700003, 1.033392645000049],
              [103.43189537900008, 1.028387762000079],
              [103.43425540500004, 1.024237372000073],
              [103.44060306100005, 1.017157294000071],
              [103.44312584700003, 1.012762762000079],
            ],
          ],
          [
            [
              [103.04867597700007, 0.797023830000057],
              [103.05176842500003, 0.784654039000088],
              [103.05445397200003, 0.777736721000053],
              [103.05762780000003, 0.777044989000046],
              [103.04908287900008, 0.757798570000091],
              [103.04371178500003, 0.720689195000091],
              [103.03370201900003, 0.705023505000042],
              [103.02784264400003, 0.701239325000074],
              [103.01734459700003, 0.696112372000073],
              [103.00733483200003, 0.693833726000094],
              [103.00294030000003, 0.698472398000092],
              [102.99976647200003, 0.700751044000071],
              [102.98243248800003, 0.722357489000046],
              [102.92994225400008, 0.770005601000094],
              [102.89470462300005, 0.789984442000048],
              [102.85222415500004, 0.798163153000075],
              [102.76685631600003, 0.79132721600007],
              [102.74512780000003, 0.793768622000073],
              [102.70215905000003, 0.803900458000044],
              [102.68148847700007, 0.804917710000041],
              [102.59766686300003, 0.785060940000051],
              [102.55787194100003, 0.780259507000039],
              [102.51636803500003, 0.79132721600007],
              [102.46729576900003, 0.826971747000073],
              [102.45801842500003, 0.832220770000049],
              [102.40650475400008, 0.873236395000049],
              [102.40943444100003, 0.894720770000049],
              [102.42457116000003, 0.914496161000045],
              [102.44507897200003, 0.929022528000075],
              [102.48943118600005, 0.93976471600007],
              [102.50066165500004, 0.953273830000057],
              [102.50171959700003, 0.972886460000041],
              [102.46989993600005, 1.067368882000039],
              [102.46762129000007, 1.106431382000039],
              [102.48902428500003, 1.133286851000094],
              [102.52751712300005, 1.139837958000044],
              [102.55640709700003, 1.125677802000041],
              [102.60792076900003, 1.068915106000077],
              [102.61573326900003, 1.057684637000079],
              [102.61736087300005, 1.044256903000075],
              [102.60889733200003, 1.027777411000045],
              [102.60547936300003, 1.01117584800005],
              [102.62175540500004, 1.001613674000055],
              [102.64527428500003, 0.997219143000052],
              [102.66374759200005, 0.996079820000091],
              [102.67807050900007, 0.999416408000059],
              [102.70533287900008, 1.013902085000041],
              [102.71876061300003, 1.017279364000046],
              [102.74301191500007, 1.01593659100007],
              [102.76384524800005, 1.01117584800005],
              [102.78256269600007, 1.001776434000078],
              [102.83253014400003, 0.963771877000056],
              [102.90902754000007, 0.927720445000091],
              [103.02173912900008, 0.845282294000071],
              [103.03646894600007, 0.828192450000074],
              [103.04037519600007, 0.821275132000039],
              [103.04867597700007, 0.797023830000057],
            ],
          ],
          [
            [
              [103.12647545700003, 0.927883205000057],
              [103.16325931100005, 0.899603583000044],
              [103.17457116000003, 0.882147528000075],
              [103.16749108200003, 0.858954169000071],
              [103.12712649800005, 0.834418036000045],
              [103.08627363400007, 0.841009833000044],
              [102.95150800900007, 0.924627997000073],
              [102.95118248800003, 0.927883205000057],
              [102.90674889400003, 0.968817450000074],
              [102.89332116000003, 0.97532786700009],
              [102.85889733200003, 0.987697658000059],
              [102.84229576900003, 0.989935614000046],
              [102.82439212300005, 0.995428778000075],
              [102.81153405000003, 1.008042710000041],
              [102.80103600400008, 1.021958726000094],
              [102.79070071700005, 1.031480210000041],
              [102.77361087300005, 1.03546784100007],
              [102.71192467500003, 1.031480210000041],
              [102.69263756600003, 1.025824286000045],
              [102.67058353000004, 1.014553127000056],
              [102.64763431100005, 1.006293036000045],
              [102.62623131600003, 1.009833075000074],
              [102.62476647200003, 1.021958726000094],
              [102.63721764400003, 1.041001695000091],
              [102.67058353000004, 1.075588283000059],
              [102.68523196700005, 1.095404364000046],
              [102.70191491000003, 1.137762762000079],
              [102.71558678500003, 1.154445705000057],
              [102.75538170700003, 1.167914130000042],
              [102.80176842500003, 1.163275458000044],
              [102.88624108200003, 1.133286851000094],
              [102.96713300900007, 1.091538804000038],
              [103.03711998800003, 1.044582424000055],
              [103.07764733200003, 1.003404039000088],
              [103.12647545700003, 0.927883205000057],
            ],
          ],
          [
            [
              [104.14633222700007, 1.16046784100007],
              [104.15235436300003, 1.140041408000059],
              [104.15170332100007, 1.11945221600007],
              [104.13111412900008, 1.048773505000042],
              [104.12322024800005, 1.049627997000073],
              [104.10596764400003, 1.065008856000077],
              [104.10417728000004, 1.057766018000052],
              [104.10417728000004, 1.051662502000056],
              [104.10670006600003, 1.045477606000077],
              [104.11280358200003, 1.03774648600006],
              [104.10450280000003, 1.033270575000074],
              [104.10059655000003, 1.027044989000046],
              [104.09782962300005, 1.019110419000071],
              [104.09229576900003, 1.009833075000074],
              [104.09156334700003, 1.005560614000046],
              [104.09327233200003, 0.993638414000088],
              [104.09229576900003, 0.989935614000046],
              [104.08790123800003, 0.988959052000041],
              [104.07642662900008, 0.990464585000041],
              [104.07178795700003, 0.989935614000046],
              [104.04916425900007, 0.984198309000078],
              [104.03174889400003, 0.989447333000044],
              [103.99610436300003, 1.009833075000074],
              [103.98796634200005, 1.01048411700009],
              [103.96664472700007, 1.00812409100007],
              [103.95582116000003, 1.009833075000074],
              [103.95053144600007, 1.014105536000045],
              [103.91822350400008, 1.051336981000077],
              [103.90674889400003, 1.071682033000059],
              [103.90259850400008, 1.090521552000041],
              [103.91407311300003, 1.099798895000049],
              [103.92383873800003, 1.096136786000045],
              [103.93816165500004, 1.079575914000088],
              [103.94898522200003, 1.078599351000094],
              [103.95622806100005, 1.084865627000056],
              [103.95533287900008, 1.093573309000078],
              [103.95134524800005, 1.103583075000074],
              [103.94654381600003, 1.124701239000046],
              [103.94320722700007, 1.130926825000074],
              [103.94450931100005, 1.135239976000094],
              [103.95582116000003, 1.140773830000057],
              [103.96705162900008, 1.141669012000079],
              [103.98764082100007, 1.13422272300005],
              [103.99610436300003, 1.133286851000094],
              [104.01107832100007, 1.144720770000049],
              [104.01921634200005, 1.178859768000052],
              [104.03093509200005, 1.187892971000053],
              [104.04135175900007, 1.181382554000038],
              [104.07081139400003, 1.14594147300005],
              [104.08545983200003, 1.133286851000094],
              [104.09164472700007, 1.145493882000039],
              [104.09156334700003, 1.158433335000041],
              [104.08659915500004, 1.170965887000079],
              [104.07862389400003, 1.181708075000074],
              [104.09058678500003, 1.18781159100007],
              [104.10320071700005, 1.189520575000074],
              [104.11573326900003, 1.187241929000038],
              [104.12769616000003, 1.181301174000055],
              [104.13819420700003, 1.172023830000057],
              [104.14275149800005, 1.166489976000094],
              [104.14633222700007, 1.16046784100007],
            ],
          ],
          [
            [
              [104.65455162900008, 1.096380927000041],
              [104.65642337300005, 1.08038971600007],
              [104.66749108200003, 1.030585028000075],
              [104.65162194100003, 1.009019273000092],
              [104.64714603000004, 0.996893622000073],
              [104.65398196700005, 0.97687409100007],
              [104.65479576900003, 0.947699286000045],
              [104.65772545700003, 0.941473700000074],
              [104.66163170700003, 0.937241929000038],
              [104.65870201900003, 0.927883205000057],
              [104.64991295700003, 0.918443101000094],
              [104.63697350400008, 0.914211330000057],
              [104.62354576900003, 0.912176825000074],
              [104.61638431100005, 0.906195380000042],
              [104.61353600400008, 0.896429755000042],
              [104.61304772200003, 0.88312409100007],
              [104.59986412900008, 0.835028387000079],
              [104.56706790500004, 0.82953522300005],
              [104.48340905000003, 0.858954169000071],
              [104.48926842500003, 0.875148830000057],
              [104.48373457100007, 0.89329661700009],
              [104.46949303500003, 0.908107815000051],
              [104.44922936300003, 0.914211330000057],
              [104.44922936300003, 0.921616929000038],
              [104.47339928500003, 0.920599677000041],
              [104.48462975400008, 0.92218659100007],
              [104.49024498800003, 0.927883205000057],
              [104.48658287900008, 0.937079169000071],
              [104.47486412900008, 0.94009023600006],
              [104.44922936300003, 0.941473700000074],
              [104.42896569100003, 0.948919989000046],
              [104.42107181100005, 0.956610419000071],
              [104.42123457100007, 0.968817450000074],
              [104.42758222700007, 0.974798895000049],
              [104.46273847700007, 0.983099677000041],
              [104.45801842500003, 0.993719794000071],
              [104.45736738400007, 1.001939195000091],
              [104.46273847700007, 1.017279364000046],
              [104.46827233200003, 1.018052476000094],
              [104.47966556100005, 1.025336005000042],
              [104.48519941500007, 1.033677476000094],
              [104.47299238400007, 1.03774648600006],
              [104.46778405000003, 1.040920315000051],
              [104.45777428500003, 1.05499909100007],
              [104.45248457100007, 1.058172919000071],
              [104.43873131600003, 1.056870835000041],
              [104.42994225400008, 1.053615627000056],
              [104.38624108200003, 1.029852606000077],
              [104.37142988400007, 1.025620835000041],
              [104.34945722700007, 1.02407461100006],
              [104.34058678500003, 1.020900783000059],
              [104.32715905000003, 1.006781317000048],
              [104.31544030000003, 1.003607489000046],
              [104.28150475400008, 1.002142645000049],
              [104.27100670700003, 1.003607489000046],
              [104.24561608200003, 1.017279364000046],
              [104.24138431100005, 1.035549221000053],
              [104.24244225400008, 1.055894273000092],
              [104.23275800900007, 1.075588283000059],
              [104.23194420700003, 1.093329169000071],
              [104.25635826900003, 1.108872789000088],
              [104.30518639400003, 1.126450914000088],
              [104.31657962300005, 1.132879950000074],
              [104.32227623800003, 1.138657945000091],
              [104.33253014400003, 1.154445705000057],
              [104.33676191500007, 1.165025132000039],
              [104.33725019600007, 1.173732815000051],
              [104.34131920700003, 1.179592190000051],
              [104.35629316500007, 1.181708075000074],
              [104.37842858200003, 1.17649974200009],
              [104.38933353000004, 1.178656317000048],
              [104.39389082100007, 1.191595770000049],
              [104.39966881600003, 1.202622789000088],
              [104.41260826900003, 1.20062897300005],
              [104.43555748800003, 1.187892971000053],
              [104.47608483200003, 1.178290106000077],
              [104.50814863400007, 1.179510809000078],
              [104.53809655000003, 1.190252997000073],
              [104.57203209700003, 1.209051825000074],
              [104.56804446700005, 1.22016022300005],
              [104.57569420700003, 1.225409247000073],
              [104.58692467500003, 1.219916083000044],
              [104.59253991000003, 1.198797919000071],
              [104.58692467500003, 1.162054755000042],
              [104.58822675900007, 1.144598700000074],
              [104.59937584700003, 1.126450914000088],
              [104.64714603000004, 1.104966539000088],
              [104.65455162900008, 1.096380927000041],
            ],
          ],
          [
            [
              [102.47339928500003, 1.242010809000078],
              [102.47950280000003, 1.219142971000053],
              [102.47608483200003, 1.194525458000044],
              [102.44743899800005, 1.100490627000056],
              [102.44556725400008, 1.076157945000091],
              [102.44743899800005, 1.051336981000077],
              [102.46517988400007, 0.994818427000041],
              [102.46802819100003, 0.972560940000051],
              [102.46485436300003, 0.963446356000077],
              [102.45687910200007, 0.96234772300005],
              [102.44703209700003, 0.962958075000074],
              [102.43751061300003, 0.958889065000051],
              [102.40748131600003, 0.932847398000092],
              [102.39966881600003, 0.927883205000057],
              [102.36931399800005, 0.935207424000055],
              [102.33375084700003, 0.963690497000073],
              [102.26710045700003, 1.036851304000038],
              [102.25131269600007, 1.066799221000053],
              [102.23926842500003, 1.082098700000074],
              [102.23292076900003, 1.099514065000051],
              [102.23422285200007, 1.124212958000044],
              [102.24268639400003, 1.16742584800005],
              [102.24512780000003, 1.203924872000073],
              [102.24187259200005, 1.221869208000044],
              [102.22291100400008, 1.238023179000038],
              [102.21257571700005, 1.258002020000049],
              [102.20411217500003, 1.280829169000071],
              [102.20101972700007, 1.297756252000056],
              [102.20346113400007, 1.306545315000051],
              [102.21265709700003, 1.325425523000092],
              [102.21461022200003, 1.335638739000046],
              [102.20850670700003, 1.377183335000041],
              [102.21062259200005, 1.398260809000078],
              [102.21745853000004, 1.409165757000039],
              [102.23121178500003, 1.413234768000052],
              [102.25294030000003, 1.413804429000038],
              [102.29086347700007, 1.404527085000041],
              [102.32211347700007, 1.38149648600006],
              [102.37574303500003, 1.322251695000091],
              [102.45142662900008, 1.267279364000046],
              [102.46705162900008, 1.251206773000092],
              [102.47339928500003, 1.242010809000078],
            ],
          ],
          [
            [
              [102.49586022200003, 1.36359284100007],
              [102.51148522200003, 1.295314846000053],
              [102.50953209700003, 1.277289130000042],
              [102.47877037900008, 1.270738023000092],
              [102.43474368600005, 1.29913971600007],
              [102.37232506600003, 1.359849351000094],
              [102.33025149800005, 1.413275458000044],
              [102.31462649800005, 1.42133209800005],
              [102.30469811300003, 1.423529364000046],
              [102.28516686300003, 1.433335679000038],
              [102.13453209700003, 1.45571523600006],
              [102.09555097700007, 1.47524648600006],
              [102.05697675900007, 1.510687567000048],
              [102.02654056100005, 1.547674872000073],
              [102.00440514400003, 1.585679429000038],
              [102.00782311300003, 1.615383205000057],
              [102.05372155000003, 1.627346096000053],
              [102.07243899800005, 1.623236395000049],
              [102.12012780000003, 1.600734768000052],
              [102.13624108200003, 1.589544989000046],
              [102.15235436300003, 1.581122137000079],
              [102.17505944100003, 1.575751044000071],
              [102.23764082100007, 1.570257880000042],
              [102.29786217500003, 1.558498440000051],
              [102.32829837300005, 1.559271552000041],
              [102.33814537900008, 1.558498440000051],
              [102.34896894600007, 1.554632880000042],
              [102.36915123800003, 1.542303778000075],
              [102.37916100400008, 1.537990627000056],
              [102.46265709700003, 1.515448309000078],
              [102.49048912900008, 1.48969147300005],
              [102.49586022200003, 1.441799221000053],
              [102.49586022200003, 1.36359284100007],
            ],
          ],
          [
            [
              [98.55518639400003, 1.682033596000053],
              [98.57097415500004, 1.673081773000092],
              [98.59066816500007, 1.651922919000071],
              [98.59913170700003, 1.631984768000052],
              [98.58106530000003, 1.626776434000078],
              [98.55990644600007, 1.623602606000077],
              [98.52881920700003, 1.623236395000049],
              [98.49756920700003, 1.62726471600007],
              [98.46485436300003, 1.644191799000055],
              [98.45183353000004, 1.646226304000038],
              [98.43995201900003, 1.64984772300005],
              [98.43165123800003, 1.661525783000059],
              [98.43018639400003, 1.676459052000041],
              [98.43482506600003, 1.691961981000077],
              [98.44564863400007, 1.704331773000092],
              [98.46265709700003, 1.70929596600007],
              [98.47706139400003, 1.703599351000094],
              [98.48812910200007, 1.690497137000079],
              [98.50416100400008, 1.664943752000056],
              [98.52100670700003, 1.655585028000075],
              [98.53109785200007, 1.661444403000075],
              [98.54053795700003, 1.673407294000071],
              [98.55518639400003, 1.682033596000053],
            ],
          ],
          [
            [
              [97.15113366000003, 2.058091539000088],
              [97.14478600400008, 2.051947333000044],
              [97.12305748800003, 2.039292710000041],
              [97.12012780000003, 2.034857489000046],
              [97.12427819100003, 2.021673895000049],
              [97.11500084700003, 2.014715887000079],
              [97.10230553500003, 2.016058661000045],
              [97.06902103000004, 2.087144273000092],
              [97.07545006600003, 2.086004950000074],
              [97.08725019600007, 2.096869208000044],
              [97.09253991000003, 2.105536200000074],
              [97.10035241000003, 2.111273505000042],
              [97.12012780000003, 2.113348700000074],
              [97.13379967500003, 2.107163804000038],
              [97.14291425900007, 2.092271226000094],
              [97.14844811300003, 2.074164130000042],
              [97.15113366000003, 2.058091539000088],
            ],
          ],
          [
            [
              [101.72120201900003, 2.058091539000088],
              [101.75798587300005, 2.011297919000071],
              [101.77027428500003, 1.985052802000041],
              [101.77556399800005, 1.94798411700009],
              [101.76775149800005, 1.925604559000078],
              [101.73585045700003, 1.887681382000039],
              [101.72877037900008, 1.863226630000042],
              [101.73243248800003, 1.817938544000071],
              [101.72917728000004, 1.799058335000041],
              [101.71509850400008, 1.778225002000056],
              [101.66627037900008, 1.744940497000073],
              [101.65984134200005, 1.733465887000079],
              [101.64942467500003, 1.722235419000071],
              [101.62525475400008, 1.714422919000071],
              [101.59750410200007, 1.710028387000079],
              [101.57732181100005, 1.70929596600007],
              [101.53060957100007, 1.718166408000059],
              [101.49073326900003, 1.736761786000045],
              [101.46013431100005, 1.765529690000051],
              [101.44068444100003, 1.804877020000049],
              [101.43034915500004, 1.850287177000041],
              [101.42221113400007, 1.872992255000042],
              [101.39714603000004, 1.909369208000044],
              [101.39380944100003, 1.930609442000048],
              [101.40577233200003, 2.013861395000049],
              [101.41814212300005, 2.044419664000088],
              [101.44092858200003, 2.064927476000094],
              [101.47828209700003, 2.072414455000057],
              [101.49577884200005, 2.068833726000094],
              [101.53101647200003, 2.056463934000078],
              [101.55054772200003, 2.058091539000088],
              [101.56641686300003, 2.067938544000071],
              [101.61508222700007, 2.117092190000051],
              [101.64926191500007, 2.128485419000071],
              [101.68165123800003, 2.108954169000071],
              [101.70720462300005, 2.078802802000041],
              [101.72120201900003, 2.058091539000088],
            ],
          ],
          [
            [
              [96.64405358200003, 2.127020575000074],
              [96.65796959700003, 2.12181224200009],
              [96.66822350400008, 2.113430080000057],
              [96.67172285200007, 2.101996161000045],
              [96.66537519600007, 2.087876695000091],
              [96.64356530000003, 2.074448960000041],
              [96.62289472700007, 2.07062409100007],
              [96.60962975400008, 2.080145575000074],
              [96.60987389400003, 2.106512762000079],
              [96.61329186300003, 2.119126695000091],
              [96.61833743600005, 2.126857815000051],
              [96.62769616000003, 2.129461981000077],
              [96.64405358200003, 2.127020575000074],
            ],
          ],
          [
            [
              [97.32862389400003, 2.147528387000079],
              [97.33627363400007, 2.126654364000046],
              [97.34107506600003, 2.105698960000041],
              [97.34302819100003, 2.083319403000075],
              [97.34229576900003, 2.058091539000088],
              [97.33952884200005, 2.04946523600006],
              [97.33521569100003, 2.042181708000044],
              [97.32935631600003, 2.036322333000044],
              [97.32178795700003, 2.031439520000049],
              [97.32032311300003, 2.049994208000044],
              [97.32178795700003, 2.058091539000088],
              [97.30616295700003, 2.057196356000077],
              [97.29615319100003, 2.069525458000044],
              [97.28785241000003, 2.087469794000071],
              [97.27808678500003, 2.103094794000071],
              [97.23389733200003, 2.147162177000041],
              [97.22681725400008, 2.158026434000078],
              [97.20736738400007, 2.175523179000038],
              [97.10279381600003, 2.212713934000078],
              [97.10938561300003, 2.22016022300005],
              [97.12517337300005, 2.225490627000056],
              [97.16700280000003, 2.233099677000041],
              [97.17172285200007, 2.233099677000041],
              [97.17847741000003, 2.230658270000049],
              [97.18279056100005, 2.226060289000088],
              [97.19157962300005, 2.208929755000042],
              [97.20801842500003, 2.207586981000077],
              [97.22071373800003, 2.21430084800005],
              [97.23292076900003, 2.223822333000044],
              [97.24675540500004, 2.230658270000049],
              [97.26465905000003, 2.232245184000078],
              [97.28126061300003, 2.229071356000077],
              [97.28923587300005, 2.221177476000094],
              [97.28150475400008, 2.208929755000042],
              [97.30583743600005, 2.185370184000078],
              [97.31983483200003, 2.178656317000048],
              [97.32374108200003, 2.169582424000055],
              [97.32862389400003, 2.147528387000079],
            ],
          ],
          [
            [
              [118.59961998800009, 2.244330145000049],
              [118.62387129000001, 2.213080145000049],
              [118.63949629000001, 2.198635158000059],
              [118.65430748800009, 2.189683335000041],
              [118.65430748800009, 2.18227773600006],
              [118.63209069100003, 2.187241929000038],
              [118.61011803500003, 2.202297268000052],
              [118.59115644600001, 2.22101471600007],
              [118.578461134, 2.236883856000077],
              [118.56836998800009, 2.255601304000038],
              [118.55689537900003, 2.285956122000073],
              [118.55640709700003, 2.312201239000046],
              [118.578461134, 2.318793036000045],
              [118.58985436300009, 2.305568752000056],
              [118.62256920700008, 2.286118882000039],
              [118.63379967500009, 2.271673895000049],
              [118.63266035200002, 2.260687567000048],
              [118.61744225400003, 2.268540757000039],
              [118.58594811300009, 2.291489976000094],
              [118.57488040500004, 2.294175523000092],
              [118.57488040500004, 2.29242584800005],
              [118.58033287900003, 2.286851304000038],
              [118.58594811300009, 2.277818101000094],
              [118.59961998800009, 2.244330145000049],
            ],
          ],
          [
            [
              [109.10865319100003, 2.531683661000045],
              [109.11394290500004, 2.523179429000038],
              [109.11085045700003, 2.516058661000045],
              [109.09506269600007, 2.504380601000094],
              [109.07846113400007, 2.496039130000042],
              [109.05225670700003, 2.487616278000075],
              [109.02670332100007, 2.485825914000088],
              [109.01246178500003, 2.497544664000088],
              [109.01482181100005, 2.511053778000075],
              [109.02247155000003, 2.520005601000094],
              [109.02328535200007, 2.527818101000094],
              [109.00562584700003, 2.537909247000073],
              [109.00082441500007, 2.53742096600007],
              [108.99073326900003, 2.529730536000045],
              [108.98560631600003, 2.527736721000053],
              [108.97982832100007, 2.529120184000078],
              [108.97437584700003, 2.532904364000046],
              [108.97006269600007, 2.538153387000079],
              [108.96810957100007, 2.543646552000041],
              [108.97193444100003, 2.555121161000045],
              [108.98275800900007, 2.560614325000074],
              [108.99642988400007, 2.561753648000092],
              [109.00831139400003, 2.560126044000071],
              [109.01978600400003, 2.555121161000045],
              [109.04200280000003, 2.541978257000039],
              [109.05347741000003, 2.537909247000073],
              [109.09685306100005, 2.537176825000074],
              [109.10865319100003, 2.531683661000045],
            ],
          ],
          [
            [
              [106.24317467500003, 2.76048411700009],
              [106.24341881600003, 2.745428778000075],
              [106.24154707100007, 2.738023179000038],
              [106.23780358200003, 2.732855536000045],
              [106.23243248800003, 2.741766669000071],
              [106.21949303500003, 2.758368231000077],
              [106.21265709700003, 2.781480210000041],
              [106.20435631600003, 2.796128648000092],
              [106.19898522200003, 2.809515692000048],
              [106.20329837300005, 2.81907786700009],
              [106.21631920700003, 2.822455145000049],
              [106.22624759200005, 2.81704336100006],
              [106.23316491000003, 2.806301174000055],
              [106.23780358200003, 2.793768622000073],
              [106.24317467500003, 2.76048411700009],
            ],
          ],
          [
            [
              [96.47950280000003, 2.414984442000048],
              [96.47510826900003, 2.397853908000059],
              [96.48121178500003, 2.378851630000042],
              [96.48121178500003, 2.36399974200009],
              [96.45850670700003, 2.359808661000045],
              [96.46583092500003, 2.359808661000045],
              [96.43067467500003, 2.348781643000052],
              [96.42090905000003, 2.343003648000092],
              [96.41138756600003, 2.343817450000074],
              [96.36963951900003, 2.367254950000074],
              [96.35108483200003, 2.355047919000071],
              [96.33497155000003, 2.355454820000091],
              [96.32081139400003, 2.363470770000049],
              [96.30762780000003, 2.374090887000079],
              [96.31283613400007, 2.378648179000038],
              [96.32260175900007, 2.389797268000052],
              [96.32813561300003, 2.394517320000091],
              [96.30616295700003, 2.405096747000073],
              [96.28516686300003, 2.436428127000056],
              [96.23991946700005, 2.44867584800005],
              [96.06568444100003, 2.579413153000075],
              [96.04265384200005, 2.592027085000041],
              [96.02027428500003, 2.600002346000053],
              [96.01099694100003, 2.600897528000075],
              [95.98609459700003, 2.600002346000053],
              [95.98064212300005, 2.602687893000052],
              [95.97193444100003, 2.612209377000056],
              [95.96509850400008, 2.614243882000039],
              [95.96127363400007, 2.607123114000046],
              [95.95801842500003, 2.602240302000041],
              [95.95508873800003, 2.600002346000053],
              [95.94752037900008, 2.598049221000053],
              [95.93995201900003, 2.59516022300005],
              [95.93140709700003, 2.595607815000051],
              [95.91146894600007, 2.610296942000048],
              [95.89210045700003, 2.615627346000053],
              [95.88306725400008, 2.620428778000075],
              [95.87818444100003, 2.628566799000055],
              [95.87777754000007, 2.637111721000053],
              [95.87476647200003, 2.645819403000075],
              [95.86255944100003, 2.65460846600007],
              [95.79053795700003, 2.65460846600007],
              [95.78532962300005, 2.660589911000045],
              [95.78744550900007, 2.674058335000041],
              [95.79428144600007, 2.696234442000048],
              [95.78891035200007, 2.704006252000056],
              [95.75896243600005, 2.724107164000088],
              [95.76156660200007, 2.739935614000046],
              [95.74878991000003, 2.749904690000051],
              [95.73519941500007, 2.757879950000074],
              [95.73568769600007, 2.76788971600007],
              [95.74008222700007, 2.77806224200009],
              [95.72787519600007, 2.779242255000042],
              [95.71021569100003, 2.777492580000057],
              [95.69800866000003, 2.77875397300005],
              [95.69263756600003, 2.792059637000079],
              [95.69263756600003, 2.81281159100007],
              [95.69955488400007, 2.831773179000038],
              [95.71485436300003, 2.84015534100007],
              [95.76872806100005, 2.840806382000039],
              [95.78003991000003, 2.846380927000041],
              [95.78150475400008, 2.855047919000071],
              [95.77662194100003, 2.860988674000055],
              [95.76986738400007, 2.864894924000055],
              [95.76636803500003, 2.86749909100007],
              [95.76677493600005, 2.878119208000044],
              [95.77182050900007, 2.895453192000048],
              [95.77320397200003, 2.90501536700009],
              [95.78467858200003, 2.924953518000052],
              [95.78687584700003, 2.932684637000079],
              [95.79151451900003, 2.942531643000052],
              [95.80152428500003, 2.937567450000074],
              [95.81104576900003, 2.927435614000046],
              [95.81413821700005, 2.922105210000041],
              [95.88404381600003, 2.919012762000079],
              [95.91187584700003, 2.906236070000091],
              [95.91041100400008, 2.87368398600006],
              [95.89079837300005, 2.889105536000045],
              [95.88298587300005, 2.883937893000052],
              [95.88306725400008, 2.846380927000041],
              [95.91724694100003, 2.860663153000075],
              [95.92774498800003, 2.844549872000073],
              [95.96452884200005, 2.827948309000078],
              [95.98170006600003, 2.790350653000075],
              [96.00326582100007, 2.777004299000055],
              [96.02833092500003, 2.768459377000056],
              [96.09050540500004, 2.757798570000091],
              [96.10678144600007, 2.749660549000055],
              [96.12631269600007, 2.733710028000075],
              [96.13086998800003, 2.715277411000045],
              [96.10181725400008, 2.675441799000055],
              [96.10279381600003, 2.65460846600007],
              [96.11866295700003, 2.666001695000091],
              [96.12973066500007, 2.66478099200009],
              [96.13843834700003, 2.658392645000049],
              [96.14714603000004, 2.65460846600007],
              [96.15626061300003, 2.648423570000091],
              [96.16187584700003, 2.647772528000075],
              [96.16423587300005, 2.65460846600007],
              [96.16089928500003, 2.661200262000079],
              [96.14698326900003, 2.670721747000073],
              [96.14372806100005, 2.678778387000079],
              [96.15796959700003, 2.68040599200009],
              [96.24610436300003, 2.600002346000053],
              [96.25782311300003, 2.591864325000074],
              [96.29070071700005, 2.575181382000039],
              [96.30420983200003, 2.572088934000078],
              [96.32129967500003, 2.566148179000038],
              [96.33594811300003, 2.552150783000059],
              [96.35914147200003, 2.521429755000042],
              [96.36394290500004, 2.508490302000041],
              [96.36784915500004, 2.48969147300005],
              [96.37525475400008, 2.473863023000092],
              [96.39014733200003, 2.469671942000048],
              [96.39527428500003, 2.477362372000073],
              [96.39698326900003, 2.493109442000048],
              [96.39649498800003, 2.52484772300005],
              [96.41065514400003, 2.508937893000052],
              [96.41724694100003, 2.506333726000094],
              [96.42432701900003, 2.510565497000073],
              [96.44410241000003, 2.490383205000057],
              [96.46501712300005, 2.43781159100007],
              [96.47950280000003, 2.414984442000048],
            ],
          ],
          [
            [
              [108.84245853000004, 2.973618882000039],
              [108.85572350400003, 3.00336334800005],
              [108.88135826900003, 3.002997137000079],
              [108.89861087300005, 2.982855536000045],
              [108.88624108200003, 2.953111070000091],
              [108.88412519600007, 2.941636460000041],
              [108.89226321700005, 2.903876044000071],
              [108.88965905000003, 2.888006903000075],
              [108.88355553500003, 2.883978583000044],
              [108.86280358200003, 2.877142645000049],
              [108.85547936300003, 2.87368398600006],
              [108.85173587300005, 2.867661851000094],
              [108.84587649800005, 2.850653387000079],
              [108.84245853000004, 2.846380927000041],
              [108.82960045700003, 2.847601630000042],
              [108.81812584700003, 2.855902411000045],
              [108.80014082100007, 2.87368398600006],
              [108.78296959700003, 2.88226959800005],
              [108.77588951900003, 2.888006903000075],
              [108.77515709700003, 2.895086981000077],
              [108.77588951900003, 2.89594147300005],
              [108.79688561300003, 2.90766022300005],
              [108.81430097700007, 2.921454169000071],
              [108.82927493600005, 2.93626536700009],
              [108.83627363400007, 2.94757721600007],
              [108.84083092500003, 2.960109768000052],
              [108.84245853000004, 2.973618882000039],
            ],
          ],
          [
            [
              [107.80713951900003, 3.014878648000092],
              [107.81324303500003, 2.994940497000073],
              [107.81120853000004, 2.986802476000094],
              [107.76823978000004, 2.979071356000077],
              [107.75611412900003, 2.978461005000042],
              [107.74512780000003, 2.983547268000052],
              [107.75123131600003, 3.01203034100007],
              [107.77295983200003, 3.025295315000051],
              [107.79623457100007, 3.025539455000057],
              [107.80713951900003, 3.014878648000092],
            ],
          ],
          [
            [
              [105.80201256600003, 2.997259833000044],
              [105.81348717500003, 2.996039130000042],
              [105.84400475400003, 2.988470770000049],
              [105.85328209700003, 2.983547268000052],
              [105.84693444100003, 2.969916083000044],
              [105.83961022200003, 2.969916083000044],
              [105.83961022200003, 2.977362372000073],
              [105.83334394600007, 2.977362372000073],
              [105.81185957100007, 2.904486395000049],
              [105.80201256600003, 2.898179429000038],
              [105.78891035200007, 2.907171942000048],
              [105.78142337300005, 2.904974677000041],
              [105.77556399800005, 2.898504950000074],
              [105.72974694100003, 2.88117096600007],
              [105.73406009200005, 2.873277085000041],
              [105.73894290500004, 2.869289455000057],
              [105.74537194100003, 2.867743231000077],
              [105.75416100400003, 2.86749909100007],
              [105.76221764400003, 2.864203192000048],
              [105.76514733200003, 2.856919664000088],
              [105.76441491000003, 2.849676825000074],
              [105.76099694100003, 2.846380927000041],
              [105.74887129000007, 2.844549872000073],
              [105.73658287900003, 2.84125397300005],
              [105.72445722700007, 2.839667059000078],
              [105.71265709700003, 2.843166408000059],
              [105.70484459700003, 2.850978908000059],
              [105.69947350400003, 2.86163971600007],
              [105.69646243600005, 2.873480536000045],
              [105.69556725400003, 2.884588934000078],
              [105.69760175900007, 2.896470445000091],
              [105.70687910200007, 2.920803127000056],
              [105.71168053500003, 2.94367096600007],
              [105.72217858200003, 2.969224351000094],
              [105.72348066500007, 2.977362372000073],
              [105.71534264400003, 2.98899974200009],
              [105.69117272200003, 3.002346096000053],
              [105.68189537900003, 3.011460679000038],
              [105.69190514400003, 3.020493882000039],
              [105.69556725400003, 3.034165757000039],
              [105.69410241000003, 3.048570054000038],
              [105.68873131600003, 3.059963283000059],
              [105.70289147200003, 3.066107489000046],
              [105.71029707100007, 3.048488674000055],
              [105.71290123800003, 3.04564036700009],
              [105.71517988400007, 3.043890692000048],
              [105.73218834700003, 3.035386460000041],
              [105.73707116000003, 3.03196849200009],
              [105.73943118600005, 3.015122789000088],
              [105.73682701900003, 2.999579169000071],
              [105.73853600400003, 2.988104559000078],
              [105.75416100400003, 2.983547268000052],
              [105.76238040500004, 2.982326565000051],
              [105.77816816500007, 2.977606512000079],
              [105.78492272200003, 2.977362372000073],
              [105.79029381600003, 2.981594143000052],
              [105.79224694100003, 2.988267320000091],
              [105.79460696700005, 2.994533596000053],
              [105.80201256600003, 2.997259833000044],
            ],
          ],
          [
            [
              [106.28516686300003, 3.179103908000059],
              [106.28516686300003, 3.087225653000075],
              [106.27906334700003, 3.087225653000075],
              [106.25782311300003, 3.11391836100006],
              [106.24187259200005, 3.107855536000045],
              [106.23389733200003, 3.115220445000091],
              [106.22608483200003, 3.125555731000077],
              [106.21070397200003, 3.128159898000092],
              [106.21509850400003, 3.134833075000074],
              [106.21607506600003, 3.140814520000049],
              [106.21599368600005, 3.147162177000041],
              [106.21697024800005, 3.15493398600006],
              [106.20582116000003, 3.20571523600006],
              [106.20777428500003, 3.22532786700009],
              [106.22380618600005, 3.223781643000052],
              [106.23853600400003, 3.226507880000042],
              [106.25912519600007, 3.214748440000051],
              [106.27735436300003, 3.196234442000048],
              [106.28516686300003, 3.179103908000059],
            ],
          ],
          [
            [
              [117.50359134200005, 3.333644924000055],
              [117.52084394600001, 3.32453034100007],
              [117.52784264400009, 3.317368882000039],
              [117.53028405000009, 3.305650132000039],
              [117.52751712300005, 3.290838934000078],
              [117.52149498800009, 3.288072007000039],
              [117.51335696700005, 3.290838934000078],
              [117.50359134200005, 3.292669989000046],
              [117.47217858200008, 3.29360586100006],
              [117.46192467500009, 3.292669989000046],
              [117.45337975400003, 3.289252020000049],
              [117.44027754000001, 3.28001536700009],
              [117.433929884, 3.278998114000046],
              [117.41700280000009, 3.288723049000055],
              [117.41391035200002, 3.304836330000057],
              [117.42090905000009, 3.322414455000057],
              [117.43336022200003, 3.336411851000094],
              [117.44988040500004, 3.343939520000049],
              [117.46843509200005, 3.345282294000071],
              [117.48707116000003, 3.341457424000055],
              [117.50359134200005, 3.333644924000055],
            ],
          ],
          [
            [
              [106.27084394600007, 3.360988674000055],
              [106.29200280000003, 3.368150132000039],
              [106.29737389400003, 3.358303127000056],
              [106.29200280000003, 3.316555080000057],
              [106.29395592500003, 3.281073309000078],
              [106.29200280000003, 3.271551825000074],
              [106.28565514400003, 3.263861395000049],
              [106.28158613400007, 3.267523505000042],
              [106.27963300900007, 3.27765534100007],
              [106.27906334700003, 3.288967190000051],
              [106.27670332100007, 3.292385158000059],
              [106.27173912900003, 3.293524481000077],
              [106.26685631600003, 3.292385158000059],
              [106.26465905000003, 3.288967190000051],
              [106.26547285200007, 3.281805731000077],
              [106.27515709700003, 3.25421784100007],
              [106.28028405000003, 3.24750397300005],
              [106.28288821700005, 3.24087148600006],
              [106.27906334700003, 3.230617580000057],
              [106.23047936300003, 3.257961330000057],
              [106.23536217500003, 3.262640692000048],
              [106.23682701900003, 3.268540757000039],
              [106.23682701900003, 3.285223700000074],
              [106.24675540500004, 3.306341864000046],
              [106.24976647200003, 3.326646226000094],
              [106.25489342500003, 3.34516022300005],
              [106.27084394600007, 3.360988674000055],
            ],
          ],
          [
            [
              [117.62525475400003, 3.437689520000049],
              [117.64047285200002, 3.436509507000039],
              [117.65699303500003, 3.433539130000042],
              [117.67156009200005, 3.426988023000092],
              [117.68165123800009, 3.415513414000088],
              [117.683929884, 3.399603583000044],
              [117.681976759, 3.377508856000077],
              [117.67725670700008, 3.356431382000039],
              [117.66537519600001, 3.329291083000044],
              [117.66732832100001, 3.271551825000074],
              [117.65992272200003, 3.255275783000059],
              [117.64844811300009, 3.246039130000042],
              [117.63795006600003, 3.248724677000041],
              [117.63331139400009, 3.26821523600006],
              [117.62484785200002, 3.283270575000074],
              [117.57178795700008, 3.31313711100006],
              [117.55640709700003, 3.331854559000078],
              [117.54363040500004, 3.354803778000075],
              [117.53467858200008, 3.379380601000094],
              [117.53126061300009, 3.403143622000073],
              [117.54151451900009, 3.42845286700009],
              [117.56666100400003, 3.438421942000048],
              [117.62525475400003, 3.437689520000049],
            ],
          ],
          [
            [
              [117.89389082100001, 3.49750397300005],
              [117.89551842500009, 3.486273505000042],
              [117.89600670700008, 3.468410549000055],
              [117.89128665500004, 3.455633856000077],
              [117.87745201900009, 3.459947007000039],
              [117.82618248800009, 3.494086005000042],
              [117.81885826900009, 3.511623440000051],
              [117.785492384, 3.538478908000059],
              [117.77759850400003, 3.558417059000078],
              [117.78492272200003, 3.581976630000042],
              [117.80372155000009, 3.591050523000092],
              [117.82699629000001, 3.588080145000049],
              [117.84791100400003, 3.575425523000092],
              [117.86304772200003, 3.559027411000045],
              [117.87663821700005, 3.53978099200009],
              [117.88721764400009, 3.518947658000059],
              [117.89389082100001, 3.49750397300005],
            ],
          ],
          [
            [
              [117.51726321700005, 3.477036851000094],
              [117.49675540500004, 3.455552476000094],
              [117.45582116000003, 3.464260158000059],
              [117.37305748800009, 3.49750397300005],
              [117.28760826900009, 3.49750397300005],
              [117.27076256600003, 3.500189520000049],
              [117.25489342500009, 3.507066148000092],
              [117.24089603000004, 3.516180731000077],
              [117.22974694100003, 3.525376695000091],
              [117.22201582100001, 3.535549221000053],
              [117.21778405000009, 3.547837632000039],
              [117.21802819100003, 3.560288804000038],
              [117.22413170700008, 3.570990302000041],
              [117.23292076900009, 3.578680731000077],
              [117.244476759, 3.586493231000077],
              [117.25709069100003, 3.592027085000041],
              [117.26840254000001, 3.592922268000052],
              [117.27857506600003, 3.58852773600006],
              [117.29712975400003, 3.575873114000046],
              [117.30795332100001, 3.573187567000048],
              [117.39372806100005, 3.566392320000091],
              [117.40821373800009, 3.55609772300005],
              [117.43531334700003, 3.524603583000044],
              [117.45167076900009, 3.517971096000053],
              [117.46176191500001, 3.51593659100007],
              [117.48210696700005, 3.506984768000052],
              [117.506195509, 3.502142645000049],
              [117.51392662900003, 3.495306708000044],
              [117.51710045700008, 3.486273505000042],
              [117.51726321700005, 3.477036851000094],
            ],
          ],
          [
            [
              [117.84620201900009, 3.79913971600007],
              [117.83155358200008, 3.798081773000092],
              [117.81226647200003, 3.804673570000091],
              [117.78402754000001, 3.819647528000075],
              [117.76954186300009, 3.831244208000044],
              [117.74463951900009, 3.857896226000094],
              [117.72950280000009, 3.868068752000056],
              [117.73617597700002, 3.867987372000073],
              [117.75521894600001, 3.87335846600007],
              [117.76295006600003, 3.874497789000088],
              [117.76677493600005, 3.874009507000039],
              [117.78760826900009, 3.866685289000088],
              [117.80738366000003, 3.856146552000041],
              [117.82911217500009, 3.84125397300005],
              [117.84424889400009, 3.827541408000059],
              [117.85287519600001, 3.812404690000051],
              [117.84620201900009, 3.79913971600007],
            ],
          ],
          [
            [
              [117.69874108200008, 4.111314195000091],
              [117.74122155000009, 4.088283596000053],
              [117.75001061300009, 4.080308335000041],
              [117.75318444100003, 4.051825262000079],
              [117.74105879000001, 4.025620835000041],
              [117.70557701900009, 3.987494208000044],
              [117.66529381600003, 3.98305898600006],
              [117.62029056100005, 4.015326239000046],
              [117.59449303500003, 4.063869533000059],
              [117.61280358200008, 4.108221747000073],
              [117.64633222700002, 4.140814520000049],
              [117.66114342500009, 4.149237372000073],
              [117.67359459700003, 4.140611070000091],
              [117.69874108200008, 4.111314195000091],
            ],
          ],
          [
            [
              [108.39616946700005, 3.874823309000078],
              [108.40650475400003, 3.884588934000078],
              [108.40626061300003, 3.874335028000075],
              [108.38933353000004, 3.822170315000051],
              [108.38257897200003, 3.809881903000075],
              [108.34107506600003, 3.756293036000045],
              [108.33326256600003, 3.740423895000049],
              [108.32789147200003, 3.72406647300005],
              [108.32398522200003, 3.692694403000075],
              [108.31763756600003, 3.683783270000049],
              [108.30005944100003, 3.676255601000094],
              [108.28516686300003, 3.67446523600006],
              [108.25359134200005, 3.676988023000092],
              [108.23853600400003, 3.676255601000094],
              [108.22364342500003, 3.670396226000094],
              [108.19499759200005, 3.652289130000042],
              [108.18384850400003, 3.648342190000051],
              [108.17448978000004, 3.651922919000071],
              [108.14226321700005, 3.676255601000094],
              [108.10482832100007, 3.690578518000052],
              [108.09449303500003, 3.696193752000056],
              [108.11817467500003, 3.725775458000044],
              [108.12183678500003, 3.734605210000041],
              [108.12501061300003, 3.747870184000078],
              [108.13233483200003, 3.752183335000041],
              [108.14047285200007, 3.751776434000078],
              [108.14600670700003, 3.75071849200009],
              [108.16488691500007, 3.75726959800005],
              [108.17139733200003, 3.771470445000091],
              [108.17554772200003, 3.785834052000041],
              [108.18702233200003, 3.792303778000075],
              [108.20248457100007, 3.792466539000088],
              [108.21363366000003, 3.791164455000057],
              [108.22437584700003, 3.785345770000049],
              [108.23853600400003, 3.772406317000048],
              [108.26685631600003, 3.738755601000094],
              [108.28003991000003, 3.731512762000079],
              [108.27759850400003, 3.745062567000048],
              [108.26238040500004, 3.792303778000075],
              [108.25733483200003, 3.795355536000045],
              [108.24887129000007, 3.80931224200009],
              [108.24537194100003, 3.813462632000039],
              [108.23682701900003, 3.815008856000077],
              [108.20753014400003, 3.813462632000039],
              [108.18034915500004, 3.816839911000045],
              [108.10336347700007, 3.845892645000049],
              [108.07154381600003, 3.852240302000041],
              [108.06234785200007, 3.855943101000094],
              [108.05298912900003, 3.864650783000059],
              [108.04476972700007, 3.877020575000074],
              [108.03003991000003, 3.908880927000041],
              [108.02808678500003, 3.917222398000092],
              [108.02613366000003, 3.932928778000075],
              [108.02344811300003, 3.94171784100007],
              [108.01685631600003, 3.946763414000088],
              [108.00993899800005, 3.951076565000051],
              [108.00513756600003, 3.957464911000045],
              [108.00391686300003, 3.964341539000088],
              [108.00513756600003, 3.987494208000044],
              [108.00212649800005, 3.997626044000071],
              [107.99545332100007, 4.00226471600007],
              [107.98853600400003, 4.005601304000038],
              [107.98462975400003, 4.01203034100007],
              [107.98780358200003, 4.020697333000044],
              [107.99724368600005, 4.034247137000079],
              [108.02247155000003, 4.063544012000079],
              [108.03223717500003, 4.069973049000055],
              [108.04151451900003, 4.07094961100006],
              [108.05054772200003, 4.070786851000094],
              [108.06031334700003, 4.074123440000051],
              [108.06666100400003, 4.080145575000074],
              [108.08033287900003, 4.097235419000071],
              [108.08423912900003, 4.100775458000044],
              [108.09449303500003, 4.105373440000051],
              [108.17025800900007, 4.179429429000038],
              [108.18197675900007, 4.20453522300005],
              [108.19556725400003, 4.220363674000055],
              [108.21159915500004, 4.235419012000079],
              [108.22486412900003, 4.244818427000041],
              [108.24244225400003, 4.230698960000041],
              [108.25025475400003, 4.21124909100007],
              [108.25220787900003, 4.159165757000039],
              [108.25733483200003, 4.130560614000046],
              [108.27076256600003, 4.112982489000046],
              [108.30681399800005, 4.086493231000077],
              [108.36540774800005, 4.015448309000078],
              [108.39136803500003, 3.997015692000048],
              [108.39616946700005, 3.990912177000041],
              [108.39820397200003, 3.976467190000051],
              [108.39771569100003, 3.949367580000057],
              [108.40357506600003, 3.936346747000073],
              [108.39283287900003, 3.924383856000077],
              [108.37826582100007, 3.915757554000038],
              [108.36597741000003, 3.905462958000044],
              [108.36207116000003, 3.888576565000051],
              [108.37208092500003, 3.893540757000039],
              [108.38013756600003, 3.891180731000077],
              [108.39616946700005, 3.874823309000078],
            ],
          ],
          [
            [
              [108.00513756600003, 4.772365627000056],
              [108.01270592500003, 4.768133856000077],
              [108.01197350400003, 4.760931708000044],
              [108.00782311300003, 4.752630927000041],
              [108.00513756600003, 4.745062567000048],
              [108.00049889400003, 4.709133205000057],
              [107.99341881600003, 4.691310940000051],
              [107.98121178500003, 4.683661200000074],
              [107.95899498800003, 4.684393622000073],
              [107.94646243600005, 4.686712958000044],
              [107.93734785200007, 4.691392320000091],
              [107.93555748800003, 4.694525458000044],
              [107.93531334700003, 4.698391018000052],
              [107.93677819100003, 4.703070380000042],
              [107.94060306100005, 4.708644924000055],
              [107.95191491000003, 4.717678127000056],
              [107.96664472700007, 4.726141669000071],
              [107.97917728000004, 4.735988674000055],
              [107.98462975400003, 4.74876536700009],
              [107.98633873800003, 4.755804755000042],
              [107.99122155000003, 4.76398346600007],
              [107.99781334700003, 4.770453192000048],
              [108.00513756600003, 4.772365627000056],
            ],
          ],
          [
            [
              [95.17741946700005, 5.62836334800005],
              [95.19109134200005, 5.608465887000079],
              [95.18051191500007, 5.609198309000078],
              [95.17139733200003, 5.607245184000078],
              [95.16325931100005, 5.602443752000056],
              [95.15626061300003, 5.594794012000079],
              [95.14527428500003, 5.60423411700009],
              [95.13379967500003, 5.60618724200009],
              [95.12232506600003, 5.606756903000075],
              [95.11158287900008, 5.611883856000077],
              [95.10914147200003, 5.622015692000048],
              [95.11817467500003, 5.631659247000073],
              [95.12989342500003, 5.640041408000059],
              [95.13575280000003, 5.646307684000078],
              [95.14177493600005, 5.664129950000074],
              [95.15503991000003, 5.656683661000045],
              [95.17741946700005, 5.62836334800005],
            ],
          ],
          [
            [
              [95.11524498800003, 5.711493231000077],
              [95.12696373800003, 5.702053127000056],
              [95.13331139400003, 5.691310940000051],
              [95.13233483200003, 5.680121161000045],
              [95.12208092500003, 5.669256903000075],
              [95.09473717500003, 5.683579820000091],
              [95.06072024800005, 5.656236070000091],
              [95.05689537900008, 5.669094143000052],
              [95.05713951900003, 5.674750067000048],
              [95.06072024800005, 5.683579820000091],
              [95.05030358200003, 5.686224677000041],
              [95.04786217500003, 5.689642645000049],
              [95.05103600400008, 5.694403387000079],
              [95.05730228000004, 5.700913804000038],
              [95.05713951900003, 5.70734284100007],
              [95.05103600400008, 5.712958075000074],
              [95.04867597700007, 5.718451239000046],
              [95.06072024800005, 5.724554755000042],
              [95.06072024800005, 5.732001044000071],
              [95.04883873800003, 5.736476955000057],
              [95.04037519600007, 5.736029364000046],
              [95.03272545700003, 5.733547268000052],
              [95.02312259200005, 5.732001044000071],
              [95.01270592500003, 5.735825914000088],
              [95.01465905000003, 5.744614976000094],
              [95.02369225400008, 5.754055080000057],
              [95.03394616000003, 5.759914455000057],
              [95.05827884200005, 5.757310289000088],
              [95.08090254000007, 5.74095286700009],
              [95.10230553500003, 5.720200914000088],
              [95.12208092500003, 5.704657294000071],
              [95.11524498800003, 5.711493231000077],
            ],
          ],
          [
            [
              [95.34180748800003, 5.896429755000042],
              [95.35132897200003, 5.88703034100007],
              [95.38282311300003, 5.841864325000074],
              [95.38282311300003, 5.807074286000045],
              [95.37598717500003, 5.807074286000045],
              [95.37256920700003, 5.813625393000052],
              [95.36866295700003, 5.818304755000042],
              [95.35547936300003, 5.82758209800005],
              [95.35531660200007, 5.795152085000041],
              [95.35043379000007, 5.783636786000045],
              [95.33838951900003, 5.779201565000051],
              [95.32032311300003, 5.780747789000088],
              [95.30274498800003, 5.785711981000077],
              [95.28663170700003, 5.794419664000088],
              [95.27295983200003, 5.807074286000045],
              [95.26587975400008, 5.821112372000073],
              [95.25977623800003, 5.839260158000059],
              [95.25269616000003, 5.854966539000088],
              [95.23145592500003, 5.869289455000057],
              [95.22055097700007, 5.885931708000044],
              [95.21355228000004, 5.902533270000049],
              [95.21461022200003, 5.910101630000042],
              [95.23617597700007, 5.909125067000048],
              [95.24781334700003, 5.905218817000048],
              [95.25928795700003, 5.896429755000042],
              [95.27247155000003, 5.870306708000044],
              [95.28386478000004, 5.857407945000091],
              [95.29712975400008, 5.858587958000044],
              [95.30730228000004, 5.872381903000075],
              [95.31495201900003, 5.887762762000079],
              [95.32496178500003, 5.898016669000071],
              [95.34180748800003, 5.896429755000042],
            ],
          ],
          [
            [
              [123.39014733200008, -10.59148528399993],
              [123.41309655000009, -10.604587497999944],
              [123.42042076900009, -10.619073174999926],
              [123.41732832100001, -10.663506768999923],
              [123.40919030000009, -10.679131768999923],
              [123.38941491000003, -10.680108330999929],
              [123.36654707100001, -10.67546965899993],
              [123.34864342500009, -10.674086195999905],
              [123.33155358200008, -10.682305596999925],
              [123.27686608200008, -10.725030205999929],
              [123.26742597700002, -10.72942473799992],
              [123.25473066500001, -10.733086846999925],
              [123.24341881600003, -10.737725518999923],
              [123.23878014400009, -10.74537525799991],
              [123.23780358200008, -10.76881275799991],
              [123.23585045700008, -10.77898528399993],
              [123.23194420700008, -10.789483330999929],
              [123.20915774800005, -10.813083591999941],
              [123.17701256600003, -10.82040780999995],
              [123.13982181100005, -10.822686455999929],
              [122.98804772200003, -10.86500416499996],
              [122.96753991000003, -10.87590911299992],
              [122.95769290500004, -10.888116143999923],
              [122.97169030000009, -10.89934661299992],
              [122.97169030000009, -10.906182549999926],
              [122.88021894600001, -10.922621351999908],
              [122.84180748800009, -10.921075127999927],
              [122.82097415500004, -10.893243096999925],
              [122.81470787900003, -10.803806247999944],
              [122.81006920700008, -10.78484465899993],
              [122.81251061300009, -10.778415622999944],
              [122.83334394600001, -10.77320728999996],
              [122.85499108200008, -10.755303643999923],
              [122.91765384200005, -10.737481377999927],
              [122.94141686300009, -10.734958591999941],
              [122.96265709700003, -10.73601653399993],
              [122.97364342500009, -10.735121351999908],
              [122.98170006600003, -10.731540622999944],
              [122.99415123800009, -10.72356536299992],
              [123.00505618600005, -10.722100518999923],
              [123.01531009200005, -10.722914320999905],
              [123.02637780000009, -10.721856377999927],
              [123.049164259, -10.711358330999929],
              [123.09839928500003, -10.663506768999923],
              [123.119476759, -10.650648695999905],
              [123.16163170700008, -10.633396091999941],
              [123.17725670700008, -10.61882903399993],
              [123.18116295700008, -10.60906340899993],
              [123.18433678500003, -10.588962497999944],
              [123.19092858200008, -10.57781340899993],
              [123.20036868600005, -10.57350025799991],
              [123.20915774800005, -10.57594166499996],
              [123.21558678500003, -10.574965101999908],
              [123.21810957100001, -10.560479424999926],
              [123.22510826900009, -10.543633721999925],
              [123.24195397200003, -10.528903903999947],
              [123.28028405000009, -10.508965752999927],
              [123.33545983200008, -10.49032968499995],
              [123.35230553500003, -10.47820403399993],
              [123.37403405000009, -10.443536065999922],
              [123.38648522200003, -10.433038018999923],
              [123.39625084700003, -10.447523695999905],
              [123.39714603000004, -10.463474216999941],
              [123.39226321700005, -10.475681247999944],
              [123.37582441500001, -10.49586353999996],
              [123.39389082100001, -10.509209893999923],
              [123.38803144600001, -10.529717705999929],
              [123.37525475400003, -10.548435153999947],
              [123.37281334700003, -10.556817315999922],
              [123.37818444100003, -10.561618747999944],
              [123.37159264400009, -10.571709893999923],
              [123.36133873800009, -10.580336195999905],
              [123.35596764400009, -10.581231377999927],
              [123.35938561300009, -10.59075286299992],
              [123.36768639400009, -10.591973565999922],
              [123.37875410200002, -10.590427341999941],
              [123.39014733200008, -10.59148528399993],
            ],
          ],
          [
            [
              [121.94019616000003, -10.430108330999929],
              [121.95980879000001, -10.440118096999925],
              [121.97950280000009, -10.437920830999929],
              [121.99594160200002, -10.441338799999926],
              [122.00538170700008, -10.467950127999927],
              [121.99789472700002, -10.508965752999927],
              [121.99089603000004, -10.52157968499995],
              [121.95281009200005, -10.553399346999925],
              [121.930023634, -10.566664320999905],
              [121.91968834700003, -10.574395440999922],
              [121.91504967500009, -10.57708098799992],
              [121.90992272200003, -10.578057549999926],
              [121.89893639400009, -10.57781340899993],
              [121.89185631600003, -10.580743096999925],
              [121.88746178500003, -10.587497653999947],
              [121.88453209700003, -10.594414971999925],
              [121.88184655000009, -10.598321221999925],
              [121.859711134, -10.604099216999941],
              [121.79688561300009, -10.598321221999925],
              [121.75318444100003, -10.601006768999923],
              [121.73210696700005, -10.59734465899993],
              [121.71045983200008, -10.584649346999925],
              [121.69906660200002, -10.575778903999947],
              [121.69434655000009, -10.571058851999908],
              [121.69011478000004, -10.56422291499996],
              [121.70622806100005, -10.55242278399993],
              [121.82642662900003, -10.49382903399993],
              [121.86133873800009, -10.440606377999927],
              [121.87964928500003, -10.428887627999927],
              [121.90162194100003, -10.420993747999944],
              [121.92310631600003, -10.420342705999929],
              [121.94019616000003, -10.430108330999929],
            ],
          ],
          [
            [
              [123.46583092500009, -10.149834893999923],
              [123.47380618600005, -10.162855726999908],
              [123.50464928500003, -10.171319268999923],
              [123.50611412900003, -10.18678150799991],
              [123.49496504000001, -10.19817473799992],
              [123.45923912900003, -10.21461353999996],
              [123.45167076900009, -10.22437916499996],
              [123.44662519600001, -10.239678643999923],
              [123.43506920700008, -10.242771091999941],
              [123.42156009200005, -10.235935153999947],
              [123.41065514400009, -10.220961195999905],
              [123.39625084700003, -10.22779713299991],
              [123.41863040500004, -10.273044528999947],
              [123.42448978000004, -10.299004815999922],
              [123.41065514400009, -10.31031666499996],
              [123.41675866000003, -10.324639580999929],
              [123.41342207100001, -10.332614841999941],
              [123.40357506600003, -10.334405205999929],
              [123.39014733200008, -10.330824476999908],
              [123.38738040500004, -10.324639580999929],
              [123.37745201900009, -10.310804945999905],
              [123.36703535200002, -10.301202080999929],
              [123.36215254000001, -10.306898695999905],
              [123.35474694100003, -10.322442315999922],
              [123.33838951900009, -10.337497653999947],
              [123.32178795700008, -10.338962497999944],
              [123.31430097700002, -10.31340911299992],
              [123.31519616000003, -10.283949476999908],
              [123.31999759200005, -10.267754815999922],
              [123.33228600400003, -10.254571221999925],
              [123.35596764400009, -10.234633070999905],
              [123.36980228000004, -10.21689218499995],
              [123.38941491000003, -10.175225518999923],
              [123.40381920700008, -10.157647393999923],
              [123.41724694100003, -10.14967213299991],
              [123.43824303500003, -10.141289971999925],
              [123.45753014400009, -10.139336846999925],
              [123.46583092500009, -10.149834893999923],
            ],
          ],
          [
            [
              [123.92798912900003, -8.227308851999908],
              [123.93881269600001, -8.23219166499996],
              [123.94117272200003, -8.243747653999947],
              [123.93751061300009, -8.265232028999947],
              [123.93238366000003, -8.271416924999926],
              [123.92058353000004, -8.276136976999908],
              [123.87647545700008, -8.286228122999944],
              [123.81128991000003, -8.28875090899993],
              [123.78988691500001, -8.293633721999925],
              [123.77540123800009, -8.305840752999927],
              [123.76587975400003, -8.321709893999923],
              [123.75098717500009, -8.35637786299992],
              [123.728851759, -8.393324476999908],
              [123.68751061300009, -8.436211846999925],
              [123.67676842500009, -8.438164971999925],
              [123.66879316500001, -8.42742278399993],
              [123.66277103000004, -8.41334400799991],
              [123.65699303500003, -8.405450127999927],
              [123.64307701900009, -8.411228122999944],
              [123.62468509200005, -8.427666924999926],
              [123.60865319100003, -8.445896091999941],
              [123.60181725400003, -8.456963799999926],
              [123.59620201900009, -8.46184661299992],
              [123.58383222700002, -8.465997002999927],
              [123.57211347700002, -8.47161223799992],
              [123.56763756600003, -8.481133721999925],
              [123.57374108200008, -8.49187590899993],
              [123.60922285200002, -8.53525155999995],
              [123.59791100400003, -8.555352471999925],
              [123.58301842500009, -8.565524997999944],
              [123.56470787900003, -8.568942966999941],
              [123.54346764400009, -8.56926848799992],
              [123.53386478000004, -8.563083591999941],
              [123.51148522200003, -8.532810153999947],
              [123.50001061300009, -8.52157968499995],
              [123.45508873800009, -8.56926848799992],
              [123.44532311300009, -8.572523695999905],
              [123.43051191500001, -8.587090752999927],
              [123.42074629000001, -8.590427341999941],
              [123.40674889400009, -8.589450778999947],
              [123.39942467500009, -8.58603280999995],
              [123.38331139400009, -8.56926848799992],
              [123.34685306100005, -8.543226820999905],
              [123.32439212300005, -8.534600518999923],
              [123.31080162900003, -8.549248955999929],
              [123.30201256600003, -8.55282968499995],
              [123.29175866000003, -8.555352471999925],
              [123.28337649800005, -8.55632903399993],
              [123.27914472700002, -8.554945570999905],
              [123.26685631600003, -8.548272393999923],
              [123.26319420700008, -8.545505466999941],
              [123.25611412900003, -8.54192473799992],
              [123.25074303500003, -8.54469166499996],
              [123.24545332100001, -8.548760674999926],
              [123.23878014400009, -8.54892343499995],
              [123.22730553500003, -8.526055596999925],
              [123.25269616000003, -8.49700286299992],
              [123.31430097700002, -8.45322030999995],
              [123.35759524800005, -8.411309502999927],
              [123.37281334700003, -8.405450127999927],
              [123.387054884, -8.401788018999923],
              [123.46810957100001, -8.365980726999908],
              [123.48015384200005, -8.358086846999925],
              [123.48568769600001, -8.350762627999927],
              [123.48365319100003, -8.33017343499995],
              [123.47331790500004, -8.320977471999925],
              [123.437836134, -8.316664320999905],
              [123.36963951900009, -8.316664320999905],
              [123.36638431100005, -8.30445728999996],
              [123.38005618600005, -8.288262627999927],
              [123.39966881600003, -8.273858330999929],
              [123.41423587300005, -8.267185153999947],
              [123.42758222700002, -8.270277601999908],
              [123.44288170700008, -8.276950778999947],
              [123.45679772200003, -8.27906666499996],
              [123.46583092500009, -8.26881275799991],
              [123.48015384200005, -8.267510674999926],
              [123.50220787900003, -8.246270440999922],
              [123.51612389400009, -8.240899346999925],
              [123.54273522200003, -8.242771091999941],
              [123.56763756600003, -8.24773528399993],
              [123.56234785200002, -8.255059502999927],
              [123.56348717500009, -8.271905205999929],
              [123.56080162900003, -8.281914971999925],
              [123.55298912900003, -8.291761976999908],
              [123.52662194100003, -8.316664320999905],
              [123.51710045700008, -8.337497653999947],
              [123.517914259, -8.352959893999923],
              [123.52849368600005, -8.364027601999908],
              [123.54712975400003, -8.371270440999922],
              [123.56836998800009, -8.374932549999926],
              [123.58912194100003, -8.373630466999941],
              [123.60466556100005, -8.36419036299992],
              [123.60922285200002, -8.343357028999947],
              [123.60059655000009, -8.329278252999927],
              [123.58676191500001, -8.317152601999908],
              [123.58228600400003, -8.306084893999923],
              [123.60181725400003, -8.295586846999925],
              [123.61402428500003, -8.309258721999925],
              [123.62794030000009, -8.307305596999925],
              [123.63917076900009, -8.294122002999927],
              [123.64332116000003, -8.27507903399993],
              [123.63892662900003, -8.26140715899993],
              [123.63086998800009, -8.252699476999908],
              [123.625336134, -8.244886976999908],
              [123.62907962300005, -8.233493747999944],
              [123.63428795700008, -8.228122653999947],
              [123.64161217500009, -8.223077080999929],
              [123.64966881600003, -8.21998463299991],
              [123.65699303500003, -8.22047291499996],
              [123.66570071700005, -8.226983330999929],
              [123.66749108200008, -8.234551690999922],
              [123.66724694100003, -8.24195728999996],
              [123.67066491000003, -8.24773528399993],
              [123.68409264400009, -8.251560153999947],
              [123.70134524800005, -8.25123463299991],
              [123.71168053500003, -8.245538018999923],
              [123.70484459700003, -8.233493747999944],
              [123.70484459700003, -8.227308851999908],
              [123.73072350400003, -8.223321221999925],
              [123.75049889400009, -8.20875416499996],
              [123.76710045700008, -8.19304778399993],
              [123.78394616000003, -8.185723565999922],
              [123.78882897200003, -8.184665622999944],
              [123.79818769600001, -8.179945570999905],
              [123.80445397200003, -8.178887627999927],
              [123.81031334700003, -8.181247653999947],
              [123.81316165500004, -8.185967705999929],
              [123.81495201900009, -8.191013278999947],
              [123.81812584700003, -8.19312916499996],
              [123.82309004000001, -8.195733330999929],
              [123.83985436300009, -8.208428643999923],
              [123.84880618600005, -8.213636976999908],
              [123.86402428500003, -8.218682549999926],
              [123.88404381600003, -8.222914320999905],
              [123.92798912900003, -8.227308851999908],
            ],
          ],
          [
            [
              [124.30811608200008, -8.22047291499996],
              [124.29379316500001, -8.257989190999922],
              [124.29102623800009, -8.28053150799991],
              [124.29761803500003, -8.299248955999929],
              [124.29997806100005, -8.31926848799992],
              [124.28345787900003, -8.338555596999925],
              [124.24675540500004, -8.36451588299991],
              [124.23218834700003, -8.381280205999929],
              [124.21876061300009, -8.401543877999927],
              [124.20883222700002, -8.423028252999927],
              [124.20134524800005, -8.465590101999908],
              [124.19166100400003, -8.489353122999944],
              [124.17872155000009, -8.511325778999947],
              [124.16480553500003, -8.52825286299992],
              [124.14958743600005, -8.539320570999905],
              [124.12989342500009, -8.548272393999923],
              [124.10759524800005, -8.554131768999923],
              [124.08497155000009, -8.55632903399993],
              [124.05933678500003, -8.551527601999908],
              [124.05128014400009, -8.53915780999995],
              [124.05494225400003, -8.501071872999944],
              [124.05062910200002, -8.48211028399993],
              [124.03126061300009, -8.456475518999923],
              [124.02702884200005, -8.443291924999926],
              [124.01880944100003, -8.429945570999905],
              [123.99952233200008, -8.430271091999941],
              [123.976898634, -8.437920830999929],
              [123.93897545700008, -8.457777601999908],
              [123.93116295700008, -8.460056247999944],
              [123.92115319100003, -8.46062590899993],
              [123.90723717500009, -8.45484791499996],
              [123.91285241000003, -8.442152601999908],
              [123.92530358200008, -8.430271091999941],
              [123.93140709700003, -8.425957940999922],
              [123.96697024800005, -8.360772393999923],
              [123.98511803500003, -8.338311455999929],
              [124.02328535200002, -8.31340911299992],
              [124.04420006600003, -8.304864190999922],
              [124.05836022200003, -8.306084893999923],
              [124.06910241000003, -8.315606377999927],
              [124.07374108200008, -8.320977471999925],
              [124.08301842500009, -8.349867445999905],
              [124.08253014400009, -8.35247161299992],
              [124.08326256600003, -8.355889580999929],
              [124.09717858200008, -8.377211195999905],
              [124.10206139400009, -8.381442966999941],
              [124.10938561300009, -8.384942315999922],
              [124.11036217500009, -8.363702080999929],
              [124.12208092500009, -8.349786065999922],
              [124.15056399800005, -8.32976653399993],
              [124.18441816500001, -8.27117278399993],
              [124.20411217500009, -8.25172291499996],
              [124.23178144600001, -8.20907968499995],
              [124.24708092500009, -8.19622161299992],
              [124.25123131600003, -8.18914153399993],
              [124.258148634, -8.182061455999929],
              [124.27027428500003, -8.178887627999927],
              [124.28467858200008, -8.18328215899993],
              [124.29493248800009, -8.193942966999941],
              [124.30811608200008, -8.22047291499996],
            ],
          ],
          [
            [
              [138.89730879, -8.33717213299991],
              [138.90447024800005, -8.351739190999922],
              [138.91089928500003, -8.37476978999996],
              [138.90984134200005, -8.396091403999947],
              [138.89405358200008, -8.405450127999927],
              [138.69996178500003, -8.39462655999995],
              [138.65406334700003, -8.376153252999927],
              [138.6298934250001, -8.371270440999922],
              [138.582367384, -8.372979424999926],
              [138.55836022200003, -8.366631768999923],
              [138.54802493600005, -8.347100518999923],
              [138.55225670700008, -8.322686455999929],
              [138.56421959700003, -8.307305596999925],
              [138.639984571, -8.257012627999927],
              [138.6572371750001, -8.24114348799992],
              [138.66472415500004, -8.22389088299991],
              [138.66716556100005, -8.203057549999926],
              [138.67505944100003, -8.18914153399993],
              [138.688812696, -8.18132903399993],
              [138.7285262380001, -8.17669036299992],
              [138.78532962300005, -8.158949476999908],
              [138.8169051440001, -8.16187916499996],
              [138.831390821, -8.18564218499995],
              [138.835297071, -8.219008070999905],
              [138.835297071, -8.25123463299991],
              [138.84197024800005, -8.276950778999947],
              [138.85816491000003, -8.297458591999941],
              [138.89730879, -8.33717213299991],
            ],
          ],
          [
            [
              [125.13404381600003, -8.217054945999905],
              [125.13917076900009, -8.233575127999927],
              [125.13746178500003, -8.321384372999944],
              [125.13428795700008, -8.339043877999927],
              [125.12330162900003, -8.352308851999908],
              [125.09978274800005, -8.357598565999922],
              [125.07886803500003, -8.359307549999926],
              [125.02125084700003, -8.371270440999922],
              [124.93238366000003, -8.377373955999929],
              [124.76612389400009, -8.408461195999905],
              [124.72535241000003, -8.409763278999947],
              [124.67009524800005, -8.403090101999908],
              [124.66163170700008, -8.403415622999944],
              [124.65015709700003, -8.405450127999927],
              [124.63917076900009, -8.41025155999995],
              [124.61670983200008, -8.42310963299991],
              [124.59644616000003, -8.428155205999929],
              [124.57601972700002, -8.437432549999926],
              [124.55909264400009, -8.44068775799991],
              [124.54957116000003, -8.445896091999941],
              [124.54460696700005, -8.44703541499996],
              [124.53842207100001, -8.44500090899993],
              [124.52654056100005, -8.43564218499995],
              [124.52035566500001, -8.432793877999927],
              [124.50196373800009, -8.42978280999995],
              [124.49545332100001, -8.430352471999925],
              [124.48633873800009, -8.432793877999927],
              [124.46070397200003, -8.44508228999996],
              [124.455414259, -8.44703541499996],
              [124.449554884, -8.450290622999944],
              [124.44418379000001, -8.457207940999922],
              [124.43751061300009, -8.464288018999923],
              [124.42790774800005, -8.467461846999925],
              [124.41822350400003, -8.46461353999996],
              [124.40691165500004, -8.451104424999926],
              [124.396820509, -8.44703541499996],
              [124.390961134, -8.44890715899993],
              [124.37322024800005, -8.45826588299991],
              [124.37029056100005, -8.46062590899993],
              [124.35710696700005, -8.45631275799991],
              [124.35075931100005, -8.448825778999947],
              [124.34620201900009, -8.43922291499996],
              [124.33855228000004, -8.42937590899993],
              [124.33350670700008, -8.41301848799992],
              [124.34538821700005, -8.396416924999926],
              [124.37647545700008, -8.371270440999922],
              [124.38607832100001, -8.35833098799992],
              [124.40674889400009, -8.320570570999905],
              [124.410492384, -8.306084893999923],
              [124.47266686300009, -8.26881275799991],
              [124.50440514400009, -8.264092705999929],
              [124.51417076900009, -8.26140715899993],
              [124.51929772200003, -8.25750090899993],
              [124.53296959700003, -8.24382903399993],
              [124.54297936300009, -8.237888278999947],
              [124.54761803500003, -8.230726820999905],
              [124.54761803500003, -8.223728122999944],
              [124.53777103000004, -8.22047291499996],
              [124.51563561300009, -8.225681247999944],
              [124.49317467500009, -8.233493747999944],
              [124.42123457100001, -8.267510674999926],
              [124.39242597700002, -8.265232028999947],
              [124.396820509, -8.22047291499996],
              [124.40552819100003, -8.211114190999922],
              [124.41968834700003, -8.202243747999944],
              [124.43279056100005, -8.19109465899993],
              [124.43848717500009, -8.17587655999995],
              [124.44190514400009, -8.162041924999926],
              [124.45069420700008, -8.149021091999941],
              [124.46265709700003, -8.138604424999926],
              [124.47527103000004, -8.13258228999996],
              [124.49634850400003, -8.138604424999926],
              [124.54542076900009, -8.13014088299991],
              [124.568695509, -8.131036065999922],
              [124.58570397200003, -8.14576588299991],
              [124.58920332100001, -8.190606377999927],
              [124.60303795700008, -8.20680103999996],
              [124.64340254000001, -8.180433851999908],
              [124.66504967500009, -8.16969166499996],
              [124.68799889400009, -8.165215752999927],
              [124.77361087300005, -8.158949476999908],
              [124.89828535200002, -8.168145440999922],
              [124.93816165500004, -8.158949476999908],
              [124.94532311300009, -8.154554945999905],
              [124.94776451900009, -8.151136976999908],
              [124.95232181100005, -8.149834893999923],
              [124.96607506600003, -8.151543877999927],
              [124.97087649800005, -8.154229424999926],
              [124.97624759200005, -8.158868096999925],
              [124.98422285200002, -8.163262627999927],
              [124.99675540500004, -8.165215752999927],
              [125.04656009200005, -8.157810153999947],
              [125.08082116000003, -8.15943775799991],
              [125.08692467500009, -8.158786716999941],
              [125.09253991000003, -8.161553643999923],
              [125.10320071700005, -8.172621351999908],
              [125.12452233200008, -8.205824476999908],
              [125.13404381600003, -8.217054945999905],
            ],
          ],
          [
            [
              [128.09058678500003, -8.131036065999922],
              [128.1235457690001, -8.150323174999926],
              [128.1274520190001, -8.161309502999927],
              [128.11793053500003, -8.178887627999927],
              [128.0664168630001, -8.22047291499996],
              [128.05396569100003, -8.226820570999905],
              [128.0415145190001, -8.255059502999927],
              [128.02564537900003, -8.26140715899993],
              [128.008636915, -8.25872161299992],
              [127.99415123800009, -8.251885674999926],
              [127.95199629000001, -8.22389088299991],
              [127.93930097700002, -8.218194268999923],
              [127.92530358200008, -8.215101820999905],
              [127.86378014400009, -8.21070728999996],
              [127.84359785200002, -8.205743096999925],
              [127.82699629000001, -8.196384372999944],
              [127.80209394600001, -8.176202080999929],
              [127.79322350400003, -8.162367445999905],
              [127.78956139400009, -8.141371351999908],
              [127.78516686300009, -8.131605726999908],
              [127.77556399800005, -8.124607028999947],
              [127.76156660200002, -8.117445570999905],
              [127.76563561300009, -8.108086846999925],
              [127.77418053500003, -8.103448174999926],
              [127.78516686300009, -8.102308851999908],
              [127.79639733200008, -8.103773695999905],
              [127.83253014400009, -8.09856536299992],
              [127.86793053500003, -8.106215101999908],
              [127.94027754000001, -8.131036065999922],
              [128.01783287900003, -8.143161716999941],
              [128.05738366000003, -8.142022393999923],
              [128.09058678500003, -8.131036065999922],
            ],
          ],
          [
            [
              [131.1093856130001, -8.131036065999922],
              [131.12484785200002, -8.127699476999908],
              [131.1416121750001, -8.121677341999941],
              [131.1601668630001, -8.118747653999947],
              [131.1816512380001, -8.124932549999926],
              [131.16081790500004, -8.152276299999926],
              [131.13168379, -8.16765715899993],
              [131.100922071, -8.179620049999926],
              [131.06120853000004, -8.205824476999908],
              [130.99105879, -8.234795830999929],
              [130.97966556100005, -8.23609791499996],
              [130.9516707690001, -8.233493747999944],
              [130.90211022200003, -8.24968840899993],
              [130.89372806100005, -8.25123463299991],
              [130.89625084700003, -8.284356377999927],
              [130.89242597700002, -8.296075127999927],
              [130.8794051440001, -8.309258721999925],
              [130.83472741000003, -8.33562590899993],
              [130.8212996750001, -8.347100518999923],
              [130.810883009, -8.35133228999996],
              [130.76335696700005, -8.350762627999927],
              [130.7744246750001, -8.334161065999922],
              [130.81527754, -8.285332940999922],
              [130.83578535200002, -8.268649997999944],
              [130.8442488940001, -8.254327080999929],
              [130.85499108200008, -8.24000416499996],
              [130.86939537900003, -8.233493747999944],
              [130.87907962300005, -8.231215101999908],
              [130.90552819100003, -8.219414971999925],
              [130.913422071, -8.213636976999908],
              [130.922211134, -8.198418877999927],
              [130.92107181100005, -8.187758070999905],
              [130.9160262380001, -8.176446221999925],
              [130.913422071, -8.158949476999908],
              [130.91749108200008, -8.141289971999925],
              [130.92644290500004, -8.13250090899993],
              [130.9384871750001, -8.13258228999996],
              [130.9516707690001, -8.141371351999908],
              [130.97380618600005, -8.145277601999908],
              [131.01441491000003, -8.09539153399993],
              [131.0376082690001, -8.08326588299991],
              [131.05095462300005, -8.091241143999923],
              [131.08545983200008, -8.124932549999926],
              [131.07984459700003, -8.133233330999929],
              [131.0771590500001, -8.142022393999923],
              [131.079437696, -8.148858330999929],
              [131.0888778000001, -8.151543877999927],
              [131.09400475400003, -8.148370049999926],
              [131.1040145190001, -8.134372653999947],
              [131.1093856130001, -8.131036065999922],
            ],
          ],
          [
            [
              [129.841156446, -7.877862237999921],
              [129.8545028000001, -7.88404713299991],
              [129.86101321700005, -7.898858330999929],
              [129.86207116000003, -7.916924737999921],
              [129.85906009200005, -7.932549737999921],
              [129.84791100400003, -7.94654713299991],
              [129.8115340500001, -7.983005466999941],
              [129.7822371750001, -8.046075127999927],
              [129.7763778000001, -8.055352471999925],
              [129.7587996750001, -8.05445728999996],
              [129.6938582690001, -8.038262627999927],
              [129.6884871750001, -8.028415622999944],
              [129.5942488940001, -7.924004815999922],
              [129.58521569100003, -7.90203215899993],
              [129.58757571700005, -7.83562590899993],
              [129.60124759200005, -7.807305596999925],
              [129.63249759200005, -7.795993747999944],
              [129.72486412900003, -7.795993747999944],
              [129.7329207690001, -7.798028252999927],
              [129.7587996750001, -7.808689059999949],
              [129.7661238940001, -7.813083591999941],
              [129.77523847700002, -7.817071221999925],
              [129.8105574880001, -7.816501559999949],
              [129.8193465500001, -7.819268487999921],
              [129.82984459700003, -7.82390715899993],
              [129.839203321, -7.829847914999959],
              [129.844574415, -7.836195570999905],
              [129.8442488940001, -7.846856377999927],
              [129.8383895190001, -7.87273528399993],
              [129.841156446, -7.877862237999921],
            ],
          ],
          [
            [
              [126.83676191500001, -7.726332289999959],
              [126.84001712300005, -7.739434502999927],
              [126.83920332100001, -7.748223565999922],
              [126.83334394600001, -7.758070570999905],
              [126.82349694100003, -7.762383721999925],
              [126.81348717500009, -7.758070570999905],
              [126.80298912900003, -7.751153252999927],
              [126.79232832100001, -7.747491143999923],
              [126.74903405000009, -7.754001559999949],
              [126.72787519600001, -7.754652601999908],
              [126.71338951900009, -7.747491143999923],
              [126.63135826900009, -7.775485934999949],
              [126.62045332100001, -7.781345309999949],
              [126.59734134200005, -7.802178643999923],
              [126.58936608200008, -7.806247653999947],
              [126.56836998800009, -7.81414153399993],
              [126.55933678500003, -7.819919528999947],
              [126.50440514400009, -7.888116143999923],
              [126.50220787900003, -7.894789320999905],
              [126.50416100400003, -7.903090101999908],
              [126.504242384, -7.912367445999905],
              [126.49732506600003, -7.922539971999925],
              [126.48812910200002, -7.932712497999944],
              [126.47527103000004, -7.955336195999905],
              [126.46615644600001, -7.966566664999959],
              [126.45476321700005, -7.958184502999927],
              [126.43327884200005, -7.936700127999927],
              [126.42188561300009, -7.932549737999921],
              [126.37378991000003, -7.932549737999921],
              [126.35027103000004, -7.929294528999947],
              [126.30054772200003, -7.915215752999927],
              [126.27442467500009, -7.911879164999959],
              [126.189789259, -7.92351653399993],
              [126.16895592500009, -7.91570403399993],
              [126.15552819100003, -7.90162525799991],
              [126.13689212300005, -7.888604424999926],
              [126.11451256600003, -7.882989190999922],
              [126.09009850400003, -7.891534112999921],
              [126.07496178500003, -7.883884372999944],
              [126.05396569100003, -7.884698174999926],
              [125.99878991000003, -7.893731377999927],
              [125.98031660200002, -7.903497002999927],
              [125.96941165500004, -7.905857028999947],
              [125.94613691500001, -7.906019789999959],
              [125.93506920700008, -7.90789153399993],
              [125.92505944100003, -7.911879164999959],
              [125.92400149800005, -7.915134372999944],
              [125.92139733200008, -7.927504164999959],
              [125.91814212300005, -7.932549737999921],
              [125.91285241000003, -7.934991143999923],
              [125.90202884200005, -7.937269789999959],
              [125.89771569100003, -7.939222914999959],
              [125.81202233200008, -8.00758228999996],
              [125.78931725400003, -8.016045830999929],
              [125.77418053500003, -8.00758228999996],
              [125.77588951900009, -7.991794528999947],
              [125.78630618600005, -7.971123955999929],
              [125.79818769600001, -7.953220309999949],
              [125.80518639400009, -7.945489190999922],
              [125.80844160200002, -7.934258721999925],
              [125.80836022200003, -7.864190362999921],
              [125.81421959700003, -7.850274346999925],
              [125.82504316500001, -7.837009372999944],
              [125.83887780000009, -7.827080987999921],
              [125.85328209700003, -7.823337497999944],
              [125.86980228000004, -7.814711195999905],
              [125.87623131600003, -7.794691664999959],
              [125.87891686300009, -7.771905205999929],
              [125.88404381600003, -7.754327080999929],
              [125.88803144600001, -7.751885674999926],
              [125.90259850400003, -7.747247002999927],
              [125.90821373800009, -7.744073174999926],
              [125.914398634, -7.736586195999905],
              [125.92115319100003, -7.721123955999929],
              [125.94792728000004, -7.678317966999941],
              [125.95720462300005, -7.667901299999926],
              [125.96892337300005, -7.660088799999926],
              [125.98064212300005, -7.658623955999929],
              [125.99268639400009, -7.661553643999923],
              [126.02271569100003, -7.676039320999905],
              [126.03126061300009, -7.682305596999925],
              [126.03492272200003, -7.68914153399993],
              [126.04615319100003, -7.693454684999949],
              [126.20313561300009, -7.713474216999941],
              [126.21485436300009, -7.709405205999929],
              [126.24537194100003, -7.691176039999959],
              [126.26148522200003, -7.686130466999941],
              [126.28003991000003, -7.688083591999941],
              [126.30437259200005, -7.693454684999949],
              [126.32837975400003, -7.695733330999929],
              [126.34644616000003, -7.68914153399993],
              [126.39795983200008, -7.64381275799991],
              [126.45240319100003, -7.619561455999929],
              [126.48454837300005, -7.597263278999947],
              [126.50375410200002, -7.590427341999941],
              [126.60352623800009, -7.569431247999944],
              [126.61744225400003, -7.562107028999947],
              [126.62696373800009, -7.559991143999923],
              [126.63135826900009, -7.565362237999921],
              [126.63021894600001, -7.58717213299991],
              [126.63086998800009, -7.598565362999921],
              [126.63453209700003, -7.606866143999923],
              [126.64698326900009, -7.616957289999959],
              [126.69271894600001, -7.637627862999921],
              [126.70313561300009, -7.64771900799991],
              [126.71159915500004, -7.658868096999925],
              [126.72169030000009, -7.668064059999949],
              [126.73755944100003, -7.671807549999926],
              [126.79883873800009, -7.664239190999922],
              [126.81324303500003, -7.668633721999925],
              [126.82162519600001, -7.680271091999941],
              [126.82911217500009, -7.695489190999922],
              [126.834320509, -7.711846612999921],
              [126.83676191500001, -7.726332289999959],
            ],
          ],
          [
            [
              [127.47022545700008, -7.527764580999929],
              [127.48438561300009, -7.532403252999927],
              [127.48926842500009, -7.544528903999947],
              [127.48780358200008, -7.579278252999927],
              [127.48170006600003, -7.590101820999905],
              [127.46729576900009, -7.599053643999923],
              [127.43116295700008, -7.613051039999959],
              [127.41863040500004, -7.614678643999923],
              [127.41285241000003, -7.617771091999941],
              [127.40837649800005, -7.623304945999905],
              [127.39861087300005, -7.64381275799991],
              [127.38949629000001, -7.64967213299991],
              [127.37330162900003, -7.656182549999926],
              [127.35767662900003, -7.655694268999923],
              [127.35075931100005, -7.640801690999922],
              [127.34766686300009, -7.622979424999926],
              [127.34839928500003, -7.615329684999949],
              [127.35450280000009, -7.606866143999923],
              [127.36198978000004, -7.60279713299991],
              [127.36988366000003, -7.600274346999925],
              [127.37614993600005, -7.595879815999922],
              [127.37867272200003, -7.585870049999926],
              [127.37574303500003, -7.569919528999947],
              [127.36443118600005, -7.53679778399993],
              [127.36443118600005, -7.521579684999949],
              [127.37273196700005, -7.506117445999905],
              [127.38493899800005, -7.502862237999921],
              [127.41846764400009, -7.507907809999949],
              [127.44068444100003, -7.520603122999944],
              [127.45411217500009, -7.525648695999905],
              [127.47022545700008, -7.527764580999929],
            ],
          ],
          [
            [
              [138.93897545700008, -7.542087497999944],
              [138.97413170700008, -7.553399346999925],
              [139.04639733200008, -7.561944268999923],
              [139.075531446, -7.576267184999949],
              [139.05738366000003, -7.594659112999921],
              [139.04444420700008, -7.611423434999949],
              [139.0351668630001, -7.629571221999925],
              [139.02027428500003, -7.671970309999949],
              [138.99366295700008, -7.720147393999923],
              [138.9887801440001, -7.73796965899993],
              [138.98267662900003, -7.829847914999959],
              [138.97722415500004, -7.840915622999944],
              [138.96631920700008, -7.850518487999921],
              [138.9106551440001, -7.878513278999947],
              [138.8911238940001, -7.898044528999947],
              [138.8837996750001, -7.932549737999921],
              [138.88648522200003, -8.007012627999927],
              [138.8925887380001, -8.041273695999905],
              [138.90414472700002, -8.07586028399993],
              [138.85767662900003, -8.075290622999944],
              [138.83668053500003, -8.080010674999926],
              [138.81820722700002, -8.093194268999923],
              [138.78834069100003, -8.130059502999927],
              [138.771820509, -8.143161716999941],
              [138.7465926440001, -8.151543877999927],
              [138.70093834700003, -8.15398528399993],
              [138.6796981130001, -8.15748463299991],
              [138.66089928500003, -8.169040622999944],
              [138.64616946700005, -8.18873463299991],
              [138.62126712300005, -8.233819268999923],
              [138.6025496750001, -8.254652601999908],
              [138.53581790500004, -8.302178643999923],
              [138.5175887380001, -8.309258721999925],
              [138.5078231130001, -8.31568775799991],
              [138.47217858200008, -8.357598565999922],
              [138.44418379, -8.379082940999922],
              [138.4121199880001, -8.39625416499996],
              [138.3759871750001, -8.409600518999923],
              [138.33570397200003, -8.419122002999927],
              [138.2934676440001, -8.418715101999908],
              [138.22339928500003, -8.39185963299991],
              [138.17798912900003, -8.384942315999922],
              [138.0341903000001, -8.381931247999944],
              [137.84913170700008, -8.377536716999941],
              [137.801605665, -8.382989190999922],
              [137.75953209700003, -8.393975518999923],
              [137.677093946, -8.425957940999922],
              [137.63819420700008, -8.42587655999995],
              [137.63697350400003, -8.389418226999908],
              [137.72624759200005, -8.144789320999905],
              [137.74976647200003, -8.101169528999947],
              [137.75277754, -8.086521091999941],
              [137.75904381600003, -8.073418877999927],
              [137.789398634, -8.052341403999947],
              [137.80054772200003, -8.041680596999925],
              [137.80974368600005, -7.983575127999927],
              [137.81820722700002, -7.973402601999908],
              [137.82439212300005, -7.964288018999923],
              [137.894867384, -7.816176039999959],
              [137.9179793630001, -7.781670830999929],
              [137.9658309250001, -7.739434502999927],
              [137.9726668630001, -7.723321221999925],
              [137.97624759200005, -7.702894789999959],
              [137.985199415, -7.679294528999947],
              [138.00668379, -7.637627862999921],
              [138.02808678500003, -7.610039971999925],
              [138.08863366000003, -7.55982838299991],
              [138.2441512380001, -7.456475518999923],
              [138.3950301440001, -7.404880466999941],
              [138.52906334700003, -7.386488539999959],
              [138.55648847700002, -7.377048434999949],
              [138.62086022200003, -7.364678643999923],
              [138.71705162900003, -7.359551690999922],
              [138.80453535200002, -7.374200127999927],
              [138.8427840500001, -7.421644789999959],
              [138.8481551440001, -7.43523528399993],
              [138.89600670700008, -7.505059502999927],
              [138.9087020190001, -7.519789320999905],
              [138.9228621750001, -7.531914971999925],
              [138.93897545700008, -7.542087497999944],
            ],
          ],
          [
            [
              [131.698578321, -7.226739190999922],
              [131.6836043630001, -7.225030205999929],
              [131.67457116000003, -7.222588799999926],
              [131.6665145190001, -7.22389088299991],
              [131.654633009, -7.233575127999927],
              [131.6455184250001, -7.244805596999925],
              [131.64275149800005, -7.254815362999921],
              [131.64722741000003, -7.281996351999908],
              [131.6464949880001, -7.302178643999923],
              [131.64722741000003, -7.309258721999925],
              [131.64869225400003, -7.310316664999959],
              [131.66944420700008, -7.344008070999905],
              [131.67505944100003, -7.358168226999908],
              [131.67335045700008, -7.371840101999908],
              [131.66089928500003, -7.383884372999944],
              [131.6684676440001, -7.39421965899993],
              [131.67790774800005, -7.400811455999929],
              [131.68726647200003, -7.405857028999947],
              [131.69499759200005, -7.41179778399993],
              [131.6992293630001, -7.413995049999926],
              [131.7031356130001, -7.412774346999925],
              [131.70630944100003, -7.412692966999941],
              [131.70923912900003, -7.417901299999926],
              [131.70875084700003, -7.424574476999908],
              [131.7036238940001, -7.425388278999947],
              [131.6977645190001, -7.42506275799991],
              [131.69499759200005, -7.428806247999944],
              [131.68344160200002, -7.451592705999929],
              [131.67986087300005, -7.473077080999929],
              [131.67554772200003, -7.48015715899993],
              [131.66911868600005, -7.484551690999922],
              [131.66089928500003, -7.486911716999941],
              [131.66871178500003, -7.509209893999923],
              [131.66293379, -7.531833591999941],
              [131.65259850400003, -7.554945570999905],
              [131.64332116000003, -7.599053643999923],
              [131.63306725400003, -7.620049737999921],
              [131.61890709700003, -7.636976820999905],
              [131.60279381600003, -7.64381275799991],
              [131.5986434250001, -7.648532809999949],
              [131.57935631600003, -7.688897393999923],
              [131.5742293630001, -7.694919528999947],
              [131.55836022200003, -7.706638278999947],
              [131.53858483200008, -7.71257903399993],
              [131.51335696700005, -7.716973565999922],
              [131.496918165, -7.726332289999959],
              [131.50318444100003, -7.747491143999923],
              [131.497406446, -7.756117445999905],
              [131.49000084700003, -7.763278903999947],
              [131.48072350400003, -7.766208591999941],
              [131.46900475400003, -7.761814059999949],
              [131.474945509, -7.782972914999959],
              [131.46412194100003, -7.794366143999923],
              [131.44890384200005, -7.800225518999923],
              [131.44117272200003, -7.805840752999927],
              [131.43433678500003, -7.814060153999947],
              [131.38990319100003, -7.847100518999923],
              [131.38257897200003, -7.859551690999922],
              [131.380218946, -7.873223565999922],
              [131.37964928500003, -7.891534112999921],
              [131.36866295700008, -7.90398528399993],
              [131.35808353000004, -7.912286065999922],
              [131.3481551440001, -7.922133070999905],
              [131.33863366000003, -7.939222914999959],
              [131.3486434250001, -7.939060153999947],
              [131.35726972700002, -7.941582940999922],
              [131.36085045700008, -7.947360934999949],
              [131.35572350400003, -7.95631275799991],
              [131.34978274800005, -7.96412525799991],
              [131.348480665, -7.969903252999927],
              [131.34839928500003, -7.976657809999949],
              [131.34546959700003, -7.987074476999908],
              [131.33521569100003, -8.00090911299992],
              [131.316742384, -8.017998955999929],
              [131.2993270190001, -8.025648695999905],
              [131.2915145190001, -8.011325778999947],
              [131.306000196, -7.973402601999908],
              [131.31080162900003, -7.954034112999921],
              [131.30144290500004, -7.945489190999922],
              [131.2939559250001, -7.942478122999944],
              [131.28931725400003, -7.93718840899993],
              [131.28345787900003, -7.936130466999941],
              [131.27100670700008, -7.945489190999922],
              [131.26587975400003, -7.95435963299991],
              [131.26189212300005, -7.976983330999929],
              [131.25733483200008, -7.987074476999908],
              [131.22966556100005, -8.003513278999947],
              [131.190765821, -8.006605726999908],
              [131.1162215500001, -8.000746351999908],
              [131.10661868600005, -7.991306247999944],
              [131.11158287900003, -7.969496351999908],
              [131.1269637380001, -7.929131768999923],
              [131.12387129, -7.913669528999947],
              [131.11597741000003, -7.898695570999905],
              [131.10474694100003, -7.889580987999921],
              [131.0922957690001, -7.891534112999921],
              [131.08570397200003, -7.871758721999925],
              [131.090179884, -7.848809502999927],
              [131.1025496750001, -7.828545830999929],
              [131.1196395190001, -7.816501559999949],
              [131.13298587300005, -7.816582940999922],
              [131.14380944100003, -7.821221612999921],
              [131.1528426440001, -7.821872653999947],
              [131.1611434250001, -7.809665622999944],
              [131.1611434250001, -7.799574476999908],
              [131.1552840500001, -7.791599216999941],
              [131.14714603000004, -7.785577080999929],
              [131.139984571, -7.781670830999929],
              [131.139984571, -7.775485934999949],
              [131.15699303500003, -7.774346612999921],
              [131.1567488940001, -7.766045830999929],
              [131.1513778000001, -7.753838799999926],
              [131.153656446, -7.740655205999929],
              [131.14405358200008, -7.744398695999905],
              [131.13738040500004, -7.74342213299991],
              [131.13355553500003, -7.737481377999927],
              [131.133148634, -7.726332289999959],
              [131.1269637380001, -7.726332289999959],
              [131.1269637380001, -7.733819268999923],
              [131.1196395190001, -7.733819268999923],
              [131.11475670700008, -7.706963799999926],
              [131.12256920700008, -7.691013278999947],
              [131.1391707690001, -7.686130466999941],
              [131.1611434250001, -7.692315362999921],
              [131.20386803500003, -7.713311455999929],
              [131.22331790500004, -7.714450778999947],
              [131.24984785200002, -7.706638278999947],
              [131.23210696700005, -7.702569268999923],
              [131.21168053500003, -7.694919528999947],
              [131.19483483200008, -7.683770440999922],
              [131.18132571700005, -7.649590752999927],
              [131.18140709700003, -7.641208591999941],
              [131.19157962300005, -7.637627862999921],
              [131.18970787900003, -7.632419528999947],
              [131.19516035200002, -7.596774997999944],
              [131.202484571, -7.579522393999923],
              [131.22478274800005, -7.546319268999923],
              [131.2295028000001, -7.531182549999926],
              [131.23267662900003, -7.50709400799991],
              [131.241547071, -7.487725518999923],
              [131.254730665, -7.472263278999947],
              [131.31519616000003, -7.422946872999944],
              [131.3281356130001, -7.417901299999926],
              [131.33570397200003, -7.422539971999925],
              [131.341156446, -7.431573174999926],
              [131.347015821, -7.438246351999908],
              [131.35572350400003, -7.435316664999959],
              [131.36060631600003, -7.427666924999926],
              [131.37281334700003, -7.398044528999947],
              [131.37964928500003, -7.389336846999925],
              [131.38428795700008, -7.38600025799991],
              [131.38835696700005, -7.381931247999944],
              [131.39332116000003, -7.37078215899993],
              [131.39136803500003, -7.368340752999927],
              [131.38982181100005, -7.35865650799991],
              [131.39079837300005, -7.348321221999925],
              [131.3969832690001, -7.34343840899993],
              [131.4531356130001, -7.334405205999929],
              [131.4541121750001, -7.328301690999922],
              [131.4497176440001, -7.31959400799991],
              [131.44849694100003, -7.309258721999925],
              [131.4550887380001, -7.291192315999922],
              [131.46265709700003, -7.278741143999923],
              [131.48267662900003, -7.254652601999908],
              [131.4868270190001, -7.24537525799991],
              [131.48902428500003, -7.236504815999922],
              [131.49398847700002, -7.229587497999944],
              [131.5068465500001, -7.226739190999922],
              [131.526703321, -7.225518487999921],
              [131.53581790500004, -7.223402601999908],
              [131.54476972700002, -7.219903252999927],
              [131.532074415, -7.190362237999921],
              [131.52881920700008, -7.170098565999922],
              [131.53695722700002, -7.154229424999926],
              [131.56861412900003, -7.130954684999949],
              [131.5898543630001, -7.120212497999944],
              [131.6171981130001, -7.112237237999921],
              [131.637543165, -7.10906340899993],
              [131.6543074880001, -7.112888278999947],
              [131.660980665, -7.12859465899993],
              [131.65357506600003, -7.166192315999922],
              [131.654633009, -7.172133070999905],
              [131.66822350400003, -7.166680596999925],
              [131.67652428500003, -7.160577080999929],
              [131.6919051440001, -7.141208591999941],
              [131.7041121750001, -7.131524346999925],
              [131.7099715500001, -7.137465101999908],
              [131.71371504, -7.150485934999949],
              [131.73951256600003, -7.195977471999925],
              [131.74333743600005, -7.196058851999908],
              [131.7382918630001, -7.206638278999947],
              [131.72608483200008, -7.216566664999959],
              [131.71119225400003, -7.22389088299991],
              [131.698578321, -7.226739190999922],
            ],
          ],
          [
            [
              [131.98218834700003, -7.188897393999923],
              [131.98601321700005, -7.225274346999925],
              [131.98170006600003, -7.245700778999947],
              [131.96558678500003, -7.254652601999908],
              [131.95590254, -7.249200127999927],
              [131.92164147200003, -7.22389088299991],
              [131.9140731130001, -7.21648528399993],
              [131.90398196700005, -7.180352471999925],
              [131.8779403000001, -7.164483330999929],
              [131.8427840500001, -7.16179778399993],
              [131.77222741000003, -7.164971612999921],
              [131.7426863940001, -7.158379815999922],
              [131.73218834700003, -7.141208591999941],
              [131.75700931100005, -7.110039971999925],
              [131.87842858200008, -7.106052341999941],
              [131.9004012380001, -7.110039971999925],
              [131.9184676440001, -7.103610934999949],
              [131.93384850400003, -7.111586195999905],
              [131.94418379, -7.12664153399993],
              [131.94809004, -7.141208591999941],
              [131.953461134, -7.154066664999959],
              [131.9770613940001, -7.174086195999905],
              [131.98218834700003, -7.188897393999923],
            ],
          ],
          [
            [
              [128.66968834700003, -7.137383721999925],
              [128.658539259, -7.14381275799991],
              [128.66822350400003, -7.158135674999926],
              [128.680511915, -7.172458591999941],
              [128.67652428500003, -7.178887627999927],
              [128.6386824880001, -7.219903252999927],
              [128.62232506600003, -7.210137627999927],
              [128.5839949880001, -7.178887627999927],
              [128.54664147200003, -7.162692966999941],
              [128.53272545700008, -7.151055596999925],
              [128.52881920700008, -7.13054778399993],
              [128.539398634, -7.112237237999921],
              [128.56324303500003, -7.091241143999923],
              [128.59245853000004, -7.073011976999908],
              [128.6196395190001, -7.063164971999925],
              [128.62859134200005, -7.068536065999922],
              [128.64340254, -7.082777601999908],
              [128.6523543630001, -7.08953215899993],
              [128.66081790500004, -7.092461846999925],
              [128.67896569100003, -7.093845309999949],
              [128.68637129, -7.096368096999925],
              [128.6997176440001, -7.109551690999922],
              [128.70134524800005, -7.122816664999959],
              [128.69125410200002, -7.133233330999929],
              [128.66968834700003, -7.137383721999925],
            ],
          ],
          [
            [
              [114.04566491000003, -6.914646091999941],
              [114.06568444100003, -6.922621351999908],
              [114.09353610000005, -6.93265686999996],
              [114.1097903210001, -6.946898122999926],
              [114.1248013610001, -6.981610298999954],
              [114.09668590600006, -6.982878634999906],
              [114.05110424100008, -7.011430963999942],
              [113.98113040500004, -7.020684502999927],
              [113.95556836000003, -7.04494862699994],
              [113.93558346700001, -7.049914273999946],
              [113.909978539, -7.04806317799995],
              [113.89187473100003, -7.05922549099995],
              [113.8706545120001, -7.095177104999948],
              [113.88625582000009, -7.099515480999912],
              [113.89499926500002, -7.109432092999953],
              [113.89535566500001, -7.120538018999923],
              [113.87281334700003, -7.128838799999926],
              [113.83253315700006, -7.132019753999941],
              [113.77671570200005, -7.125256053999919],
              [113.70624848300008, -7.113613321999935],
              [113.6866677800001, -7.112641921999909],
              [113.66521243600005, -7.110039971999925],
              [113.64532689200007, -7.131133891999923],
              [113.61005227600003, -7.129187025999954],
              [113.59337868, -7.13890102299996],
              [113.58276663400011, -7.153486441999917],
              [113.57728379800005, -7.168367782999951],
              [113.57044638000002, -7.181896028999915],
              [113.565882429, -7.193622593999919],
              [113.55948926100007, -7.21211735199995],
              [113.548984206, -7.233778153999936],
              [113.53394127900003, -7.240101743999958],
              [113.51342534300011, -7.247781563999922],
              [113.507057809, -7.240109507999932],
              [113.49521340900003, -7.230636771999912],
              [113.47247064700002, -7.222049961999915],
              [113.42269941500001, -7.226739190999922],
              [113.26905358200008, -7.217461846999925],
              [113.25123131600003, -7.209649346999925],
              [113.23438561300009, -7.207614841999941],
              [113.18653405000009, -7.223321221999925],
              [113.16553795700008, -7.219903252999927],
              [113.15870201900009, -7.18523528399993],
              [113.15316816500001, -7.17742278399993],
              [113.14633222700002, -7.17156340899993],
              [113.14576256600003, -7.165785414999959],
              [113.15870201900009, -7.158461195999905],
              [113.15870201900009, -7.151055596999925],
              [113.14600670700008, -7.149590752999927],
              [113.12232506600003, -7.139418226999908],
              [113.11426842500009, -7.141208591999941],
              [113.10962975400003, -7.151462497999944],
              [113.109711134, -7.171482028999947],
              [113.10336347700002, -7.178887627999927],
              [113.11638431100005, -7.19068775799991],
              [113.13526451900009, -7.202732028999947],
              [113.14869225400003, -7.214776299999926],
              [113.14503014400009, -7.226739190999922],
              [113.12794030000009, -7.231052341999941],
              [112.81812584700003, -7.16139088299991],
              [112.77808678500003, -7.158461195999905],
              [112.742523634, -7.16139088299991],
              [112.72641035200002, -7.158786716999941],
              [112.71989993600005, -7.147881768999923],
              [112.71705162900003, -7.117608330999929],
              [112.71876061300009, -7.103285414999959],
              [112.72730553500003, -7.08953215899993],
              [112.71989993600005, -7.082777601999908],
              [112.70997155000009, -7.09734465899993],
              [112.70134524800005, -7.092054945999905],
              [112.69499759200005, -7.076104424999926],
              [112.69263756600003, -7.058526299999926],
              [112.69450931100005, -7.038995049999926],
              [112.70093834700003, -7.033298434999949],
              [112.71363366000003, -7.032403252999927],
              [112.73414147200003, -7.028090101999908],
              [112.76351972700002, -7.01100025799991],
              [112.79265384200005, -6.98406340899993],
              [112.84400475400003, -6.92506275799991],
              [112.84197024800005, -6.908868096999925],
              [112.87322024800005, -6.89771900799991],
              [112.91529381600003, -6.891696872999944],
              [112.94402103000004, -6.890964450999945],
              [112.98170006600003, -6.891289971999925],
              [113.06739342500009, -6.881036065999922],
              [113.14601986800005, -6.894371211999953],
              [113.2733567350001, -6.892996303999951],
              [113.44558230000007, -6.882377938999923],
              [113.526227887, -6.896293042999957],
              [113.67205189100002, -6.879398963999961],
              [113.79311278800003, -6.882479059999923],
              [113.92367597700002, -6.864841403999947],
              [113.96802819100003, -6.870538018999923],
              [113.98991946700005, -6.877862237999921],
              [114.00961347700002, -6.886976820999905],
              [114.02800540500004, -6.899021091999941],
              [114.04566491000003, -6.914646091999941],
            ],
          ],
          [
            [
              [105.26417076900003, -6.527927341999941],
              [105.26563561300003, -6.553317966999941],
              [105.26384524800005, -6.592380466999941],
              [105.25603274800005, -6.62818775799991],
              [105.23991946700005, -6.643975518999923],
              [105.22242272200003, -6.649346612999921],
              [105.20386803500003, -6.673272393999923],
              [105.19214928500003, -6.678806247999944],
              [105.18295332100007, -6.67156340899993],
              [105.18506920700003, -6.655043226999908],
              [105.19353274800005, -6.636651299999926],
              [105.20215905000003, -6.623467705999929],
              [105.18995201900003, -6.617852471999925],
              [105.18295332100007, -6.607679945999905],
              [105.17546634200005, -6.583103122999944],
              [105.13209069100003, -6.626885674999926],
              [105.12012780000003, -6.630954684999949],
              [105.11768639400003, -6.612399997999944],
              [105.13795006600003, -6.587334893999923],
              [105.18848717500003, -6.547621351999908],
              [105.19581139400003, -6.555108330999929],
              [105.20411217500003, -6.545179945999905],
              [105.21558678500003, -6.538832289999959],
              [105.22559655000003, -6.53639088299991],
              [105.22999108200003, -6.538181247999944],
              [105.23357181100005, -6.531833591999941],
              [105.24203535200007, -6.528415622999944],
              [105.25318444100003, -6.527276299999926],
              [105.26417076900003, -6.527927341999941],
            ],
          ],
          [
            [
              [134.4843856130001, -6.575616143999923],
              [134.51050866000003, -6.580661716999941],
              [134.5214949880001, -6.586846612999921],
              [134.51539147200003, -6.599541924999926],
              [134.5083113940001, -6.60906340899993],
              [134.50416100400003, -6.627536716999941],
              [134.49927819100003, -6.637790622999944],
              [134.47217858200008, -6.66179778399993],
              [134.45036868600005, -6.660577080999929],
              [134.4287215500001, -6.652764580999929],
              [134.401703321, -6.65748463299991],
              [134.401703321, -6.664971612999921],
              [134.4204207690001, -6.664157809999949],
              [134.43376712300005, -6.67701588299991],
              [134.4365340500001, -6.682061455999929],
              [134.4321395190001, -6.691582940999922],
              [134.42156009200005, -6.704196872999944],
              [134.40894616000003, -6.715020440999922],
              [134.39828535200002, -6.719659112999921],
              [134.34717858200008, -6.801527601999908],
              [134.3642684250001, -6.807793877999927],
              [134.35889733200008, -6.820733330999929],
              [134.31072024800005, -6.859470309999949],
              [134.24480228000004, -6.883477471999925],
              [134.207367384, -6.911309502999927],
              [134.18506920700008, -6.918633721999925],
              [134.15845787900003, -6.873630466999941],
              [134.14616946700005, -6.858982028999947],
              [134.14047285200002, -6.854913018999923],
              [134.1274520190001, -6.849379164999959],
              [134.0898543630001, -6.838311455999929],
              [134.07341556100005, -6.826755466999941],
              [134.0644637380001, -6.795586846999925],
              [134.055023634, -6.775160414999959],
              [134.05298912900003, -6.764336846999925],
              [134.05445397200003, -6.75164153399993],
              [134.06657962300005, -6.719659112999921],
              [134.0859481130001, -6.642022393999923],
              [134.10377037900003, -6.474867445999905],
              [134.11060631600003, -6.459161065999922],
              [134.117523634, -6.452080987999921],
              [134.12061608200008, -6.462334893999923],
              [134.13111412900003, -6.47975025799991],
              [134.18580162900003, -6.489190362999921],
              [134.2099715500001, -6.507419528999947],
              [134.20826256600003, -6.489841403999947],
              [134.19117272200003, -6.462823174999926],
              [134.1894637380001, -6.445245049999926],
              [134.13697350400003, -6.450372002999927],
              [134.12037194100003, -6.419854424999926],
              [134.1274520190001, -6.325290622999944],
              [134.1215926440001, -6.291924737999921],
              [134.09913170700008, -6.225681247999944],
              [134.09750410200002, -6.192071221999925],
              [134.10271243600005, -6.180108330999929],
              [134.11198978000004, -6.172946872999944],
              [134.12378991000003, -6.17156340899993],
              [134.13599694100003, -6.176934502999927],
              [134.14600670700008, -6.18873463299991],
              [134.15406334700003, -6.203057549999926],
              [134.16382897200003, -6.215020440999922],
              [134.19874108200008, -6.22429778399993],
              [134.21404056100005, -6.234795830999929],
              [134.24724368600005, -6.268324476999908],
              [134.27711022200003, -6.290215752999927],
              [134.28882897200003, -6.294528903999947],
              [134.29460696700005, -6.297784112999921],
              [134.2988387380001, -6.305840752999927],
              [134.2998153000001, -6.315850518999923],
              [134.2959090500001, -6.325290622999944],
              [134.2880965500001, -6.336032809999949],
              [134.28777103000004, -6.341892184999949],
              [134.31275475400003, -6.374200127999927],
              [134.32976321700005, -6.389336846999925],
              [134.34937584700003, -6.399834893999923],
              [134.39242597700002, -6.408298434999949],
              [134.4072371750001, -6.419122002999927],
              [134.4204207690001, -6.432793877999927],
              [134.4365340500001, -6.445245049999926],
              [134.44263756600003, -6.446384372999944],
              [134.44605553500003, -6.443454684999949],
              [134.44996178500003, -6.441338799999926],
              [134.4570418630001, -6.445245049999926],
              [134.461273634, -6.45086028399993],
              [134.46208743600005, -6.455661716999941],
              [134.46208743600005, -6.460381768999923],
              [134.4638778000001, -6.465752862999921],
              [134.48170006600003, -6.49773528399993],
              [134.4853621750001, -6.506931247999944],
              [134.48780358200008, -6.508558851999908],
              [134.49000084700003, -6.511325778999947],
              [134.4912215500001, -6.51726653399993],
              [134.48902428500003, -6.520684502999927],
              [134.4843856130001, -6.522637627999927],
              [134.47974694100003, -6.525485934999949],
              [134.4775496750001, -6.531345309999949],
              [134.4843856130001, -6.575616143999923],
            ],
          ],
          [
            [
              [120.54615319100003, -5.938164971999925],
              [120.55518639400009, -5.979424737999921],
              [120.55933678500003, -6.022556247999944],
              [120.55860436300009, -6.066338799999926],
              [120.55298912900003, -6.110121351999908],
              [120.52979576900009, -6.17310963299991],
              [120.52621504000001, -6.195489190999922],
              [120.53207441500001, -6.248304945999905],
              [120.53012129000001, -6.287286065999922],
              [120.52247155000009, -6.336521091999941],
              [120.51498457100001, -6.352471612999921],
              [120.50261478000004, -6.373467705999929],
              [120.50098717500009, -6.392510674999926],
              [120.50513756600003, -6.431735934999949],
              [120.50001061300009, -6.451592705999929],
              [120.49048912900003, -6.471449476999908],
              [120.48129316500001, -6.477308851999908],
              [120.47510826900009, -6.434502862999921],
              [120.46566816500001, -6.402764580999929],
              [120.46363366000003, -6.383884372999944],
              [120.47087649800005, -6.275160414999959],
              [120.46810957100001, -6.264336846999925],
              [120.46045983200008, -6.259698174999926],
              [120.44825280000009, -6.256524346999925],
              [120.44483483200008, -6.248467705999929],
              [120.44507897200003, -6.237725518999923],
              [120.443695509, -6.226169528999947],
              [120.43083743600005, -6.194512627999927],
              [120.42945397200003, -6.185804945999905],
              [120.43336022200003, -6.174004815999922],
              [120.44695071700005, -6.154473565999922],
              [120.44996178500003, -6.140801690999922],
              [120.45215905000009, -6.080824476999908],
              [120.44141686300009, -5.977634372999944],
              [120.44825280000009, -5.843926690999922],
              [120.457367384, -5.801039320999905],
              [120.47046959700003, -5.76685963299991],
              [120.48047936300009, -5.764092705999929],
              [120.488617384, -5.76726653399993],
              [120.49439537900003, -5.774509372999944],
              [120.49708092500009, -5.783298434999949],
              [120.49561608200008, -5.806410414999959],
              [120.50342858200008, -5.822686455999929],
              [120.51335696700005, -5.836602471999925],
              [120.51807701900009, -5.852634372999944],
              [120.52149498800009, -5.87468840899993],
              [120.54615319100003, -5.938164971999925],
            ],
          ],
          [
            [
              [104.83277428500003, -5.760023695999905],
              [104.84636478000004, -5.772556247999944],
              [104.84978274800005, -5.783298434999949],
              [104.84644616000003, -5.811211846999925],
              [104.83838951900003, -5.820407809999949],
              [104.82016035200007, -5.812269789999959],
              [104.79004967500003, -5.787692966999941],
              [104.77670332100007, -5.771579684999949],
              [104.77165774800005, -5.761651299999926],
              [104.77035566500007, -5.752048434999949],
              [104.77654056100005, -5.741143487999921],
              [104.78679446700005, -5.742120049999926],
              [104.80787194100003, -5.754327080999929],
              [104.82699629000007, -5.757907809999949],
              [104.83277428500003, -5.760023695999905],
            ],
          ],
          [
            [
              [132.80201256600003, -5.787367445999905],
              [132.8110457690001, -5.797051690999922],
              [132.81226647200003, -5.81959400799991],
              [132.80543053500003, -5.862481377999927],
              [132.79712975400003, -5.885837497999944],
              [132.78736412900003, -5.905857028999947],
              [132.77556399800005, -5.923923434999949],
              [132.76059004, -5.941582940999922],
              [132.741547071, -5.950372002999927],
              [132.73072350400003, -5.934177341999941],
              [132.7236434250001, -5.910332940999922],
              [132.71599368600005, -5.896661065999922],
              [132.71648196700005, -5.906996351999908],
              [132.714203321, -5.918389580999929],
              [132.70866946700005, -5.927504164999959],
              [132.6992293630001, -5.93132903399993],
              [132.6919051440001, -5.928806247999944],
              [132.6860457690001, -5.922051690999922],
              [132.67505944100003, -5.904066664999959],
              [132.67505944100003, -5.910902601999908],
              [132.66968834700003, -5.899997653999947],
              [132.66781660200002, -5.888116143999923],
              [132.66822350400003, -5.862481377999927],
              [132.6670028000001, -5.857517184999949],
              [132.66480553500003, -5.85515715899993],
              [132.66236412900003, -5.852146091999941],
              [132.66138756600003, -5.84539153399993],
              [132.663422071, -5.838555596999925],
              [132.6679793630001, -5.836521091999941],
              [132.672699415, -5.836358330999929],
              [132.67505944100003, -5.835707289999959],
              [132.67164147200003, -5.783379815999922],
              [132.67448978000004, -5.760023695999905],
              [132.68873131600003, -5.760023695999905],
              [132.68336022200003, -5.749118747999944],
              [132.67505944100003, -5.71217213299991],
              [132.67017662900003, -5.711521091999941],
              [132.66138756600003, -5.711114190999922],
              [132.65503991000003, -5.708754164999959],
              [132.65796959700003, -5.701755466999941],
              [132.66041100400003, -5.697198174999926],
              [132.66195722700002, -5.691013278999947],
              [132.66236412900003, -5.684340101999908],
              [132.66138756600003, -5.678806247999944],
              [132.65748131600003, -5.67742278399993],
              [132.6504012380001, -5.677504164999959],
              [132.64380944100003, -5.67546965899993],
              [132.64087975400003, -5.667901299999926],
              [132.641937696, -5.648532809999949],
              [132.64087975400003, -5.643324476999908],
              [132.634125196, -5.633396091999941],
              [132.62761478000004, -5.625583591999941],
              [132.62232506600003, -5.616631768999923],
              [132.61980228000004, -5.602959893999923],
              [132.65691165500004, -5.62037525799991],
              [132.66138756600003, -5.623467705999929],
              [132.67530358200008, -5.612888278999947],
              [132.687836134, -5.600030205999929],
              [132.69752037900003, -5.597426039999959],
              [132.70289147200003, -5.616794528999947],
              [132.69947350400003, -5.631524346999925],
              [132.6923934250001, -5.642022393999923],
              [132.69060306100005, -5.65007903399993],
              [132.70289147200003, -5.657647393999923],
              [132.71111087300005, -5.658623955999929],
              [132.72632897200003, -5.654961846999925],
              [132.73357181100005, -5.655043226999908],
              [132.74048912900003, -5.660088799999926],
              [132.74366295700008, -5.668389580999929],
              [132.74537194100003, -5.686455987999921],
              [132.757172071, -5.722914320999905],
              [132.75757897200003, -5.73211028399993],
              [132.76238040500004, -5.722426039999959],
              [132.7636824880001, -5.71843840899993],
              [132.77125084700003, -5.71843840899993],
              [132.7763778000001, -5.738457940999922],
              [132.7793074880001, -5.76100025799991],
              [132.78589928500003, -5.779717705999929],
              [132.80201256600003, -5.787367445999905],
            ],
          ],
          [
            [
              [134.75806725400003, -6.15789153399993],
              [134.758148634, -6.167901299999926],
              [134.75660241000003, -6.175957940999922],
              [134.75318444100003, -6.182793877999927],
              [134.74781334700003, -6.189060153999947],
              [134.74366295700008, -6.198825778999947],
              [134.751312696, -6.219170830999929],
              [134.74781334700003, -6.229913018999923],
              [134.739593946, -6.241957289999959],
              [134.72087649800005, -6.281833591999941],
              [134.71705162900003, -6.297946872999944],
              [134.70183353000004, -6.321872653999947],
              [134.630218946, -6.35125090899993],
              [134.607758009, -6.369561455999929],
              [134.58366946700005, -6.352308851999908],
              [134.57056725400003, -6.348809502999927],
              [134.55933678500003, -6.355889580999929],
              [134.5537215500001, -6.355889580999929],
              [134.540375196, -6.338067315999922],
              [134.53581790500004, -6.335381768999923],
              [134.53484134200005, -6.331231377999927],
              [134.51628665500004, -6.313897393999923],
              [134.51156660200002, -6.311618747999944],
              [134.5019637380001, -6.299248955999929],
              [134.45923912900003, -6.278415622999944],
              [134.44947350400003, -6.263767184999949],
              [134.43775475400003, -6.264092705999929],
              [134.3779403000001, -6.239353122999944],
              [134.3715926440001, -6.23756275799991],
              [134.36890709700003, -6.233168226999908],
              [134.36736087300005, -6.227959893999923],
              [134.36451256600003, -6.223077080999929],
              [134.35865319100003, -6.219821872999944],
              [134.3540145190001, -6.221368096999925],
              [134.34937584700003, -6.224541924999926],
              [134.3437606130001, -6.226169528999947],
              [134.33350670700008, -6.221449476999908],
              [134.3266707690001, -6.21062590899993],
              [134.32146243600005, -6.198174737999921],
              [134.31609134200005, -6.189060153999947],
              [134.291351759, -6.156345309999949],
              [134.27662194100003, -6.119317315999922],
              [134.2758895190001, -6.083591403999947],
              [134.29249108200008, -6.054864190999922],
              [134.31202233200008, -6.047133070999905],
              [134.3305770190001, -6.050388278999947],
              [134.34888756600003, -6.050876559999949],
              [134.3676863940001, -6.034356377999927],
              [134.36931399800005, -6.023858330999929],
              [134.33326256600003, -6.026055596999925],
              [134.3129988940001, -6.027601820999905],
              [134.3017684250001, -6.016289971999925],
              [134.3056746750001, -6.00123463299991],
              [134.31511478000004, -5.983982028999947],
              [134.31910241000003, -5.96607838299991],
              [134.31226647200003, -5.95435963299991],
              [134.2880965500001, -5.923923434999949],
              [134.28882897200003, -5.917738539999959],
              [134.299164259, -5.913018487999921],
              [134.3125106130001, -5.901950778999947],
              [134.32252037900003, -5.889418226999908],
              [134.32349694100003, -5.868259372999944],
              [134.3603621750001, -5.849541924999926],
              [134.3540145190001, -5.835707289999959],
              [134.3540145190001, -5.828301690999922],
              [134.37647545700008, -5.805596612999921],
              [134.378265821, -5.793715101999908],
              [134.36150149800005, -5.78053150799991],
              [134.352386915, -5.793389580999929],
              [134.34099368600005, -5.804294528999947],
              [134.33090254, -5.80396900799991],
              [134.3266707690001, -5.783949476999908],
              [134.31820722700002, -5.772556247999944],
              [134.299164259, -5.768243096999925],
              [134.26514733200008, -5.76685963299991],
              [134.24789472700002, -5.760430596999925],
              [134.23267662900003, -5.750909112999921],
              [134.20655358200008, -5.729099216999941],
              [134.20199629, -5.712497653999947],
              [134.21550540500004, -5.695896091999941],
              [134.2373153000001, -5.68328215899993],
              [134.2578231130001, -5.678806247999944],
              [134.27719160200002, -5.685723565999922],
              [134.30974368600005, -5.71257903399993],
              [134.3300887380001, -5.71843840899993],
              [134.35181725400003, -5.714450778999947],
              [134.358734571, -5.703545830999929],
              [134.360687696, -5.688409112999921],
              [134.3676863940001, -5.671319268999923],
              [134.37818444100003, -5.66179778399993],
              [134.39185631600003, -5.652113539999959],
              [134.40406334700003, -5.640883070999905],
              [134.4091903000001, -5.626885674999926],
              [134.412445509, -5.613946221999925],
              [134.4570418630001, -5.534112237999921],
              [134.46265709700003, -5.552829684999949],
              [134.47250410200002, -5.55787525799991],
              [134.48316491000003, -5.552829684999949],
              [134.4912215500001, -5.540948174999926],
              [134.49480228000004, -5.543226820999905],
              [134.504730665, -5.547784112999921],
              [134.5058699880001, -5.528252862999921],
              [134.50505618600005, -5.517754815999922],
              [134.5019637380001, -5.510349216999941],
              [134.4946395190001, -5.500746351999908],
              [134.49203535200002, -5.49578215899993],
              [134.4912215500001, -5.448174737999921],
              [134.492523634, -5.441827080999929],
              [134.4965926440001, -5.436130466999941],
              [134.50212649800005, -5.431735934999949],
              [134.5083113940001, -5.42937590899993],
              [134.51547285200002, -5.429457289999959],
              [134.51929772200003, -5.432305596999925],
              [134.5224715500001, -5.436293226999908],
              [134.52711022200003, -5.440036716999941],
              [134.53972415500004, -5.440606377999927],
              [134.56788170700008, -5.427829684999949],
              [134.58122806100005, -5.424248955999929],
              [134.628265821, -5.444756768999923],
              [134.63591556100005, -5.455254815999922],
              [134.64820397200003, -5.493096612999921],
              [134.65894616000003, -5.504652601999908],
              [134.6884871750001, -5.523858330999929],
              [134.69654381600003, -5.534112237999921],
              [134.68897545700008, -5.536879164999959],
              [134.66863040500004, -5.547784112999921],
              [134.67530358200008, -5.552178643999923],
              [134.67896569100003, -5.55787525799991],
              [134.68238366000003, -5.575127862999921],
              [134.67603600400003, -5.575127862999921],
              [134.67603600400003, -5.568942966999941],
              [134.651703321, -5.574639580999929],
              [134.641449415, -5.579196872999944],
              [134.635101759, -5.588799737999921],
              [134.64429772200003, -5.586195570999905],
              [134.6723738940001, -5.588799737999921],
              [134.68034915500004, -5.590915622999944],
              [134.69117272200003, -5.596368096999925],
              [134.71021569100003, -5.609144789999959],
              [134.7368270190001, -5.63795338299991],
              [134.75806725400003, -5.671319268999923],
              [134.73975670700008, -5.685153903999947],
              [134.72641035200002, -5.711195570999905],
              [134.7187606130001, -5.73756275799991],
              [134.71705162900003, -5.752618096999925],
              [134.72624759200005, -5.754327080999929],
              [134.73316491000003, -5.756605726999908],
              [134.73755944100003, -5.760023695999905],
              [134.738617384, -5.765557549999926],
              [134.7387801440001, -5.773532809999949],
              [134.73755944100003, -5.787367445999905],
              [134.73121178500003, -5.802911065999922],
              [134.71111087300005, -5.823663018999923],
              [134.70289147200003, -5.835707289999959],
              [134.723968946, -5.837823174999926],
              [134.74333743600005, -5.84693775799991],
              [134.7544051440001, -5.860772393999923],
              [134.75123131600003, -5.876722914999959],
              [134.7558699880001, -5.879327080999929],
              [134.76002037900003, -5.885674737999921],
              [134.76490319100003, -5.890394789999959],
              [134.754242384, -5.898370049999926],
              [134.7343856130001, -5.90984465899993],
              [134.72388756600003, -5.917738539999959],
              [134.72022545700008, -5.900567315999922],
              [134.70964603000004, -5.89617278399993],
              [134.69947350400003, -5.902601820999905],
              [134.69654381600003, -5.917738539999959],
              [134.70289147200003, -5.925957940999922],
              [134.72779381600003, -5.936944268999923],
              [134.73755944100003, -5.94500090899993],
              [134.7270613940001, -5.944756768999923],
              [134.72388756600003, -5.94500090899993],
              [134.73609459700003, -5.969496351999908],
              [134.72095787900003, -5.971612237999921],
              [134.6953231130001, -5.96217213299991],
              [134.67603600400003, -5.951836846999925],
              [134.6684676440001, -5.944756768999923],
              [134.66277103000004, -5.938164971999925],
              [134.6543074880001, -5.93328215899993],
              [134.63884524800005, -5.93132903399993],
              [134.6259871750001, -5.933038018999923],
              [134.61451256600003, -5.937432549999926],
              [134.60572350400003, -5.943942966999941],
              [134.60108483200008, -5.951836846999925],
              [134.6425887380001, -5.947523695999905],
              [134.65699303500003, -5.953871351999908],
              [134.66236412900003, -5.976006768999923],
              [134.67066491000003, -5.986748955999929],
              [134.7114363940001, -6.020277601999908],
              [134.72730553500003, -6.027601820999905],
              [134.76514733200008, -6.076836846999925],
              [134.77222741000003, -6.089613539999959],
              [134.76823978000004, -6.11296965899993],
              [134.75464928500003, -6.135511976999908],
              [134.73601321700005, -6.15398528399993],
              [134.71705162900003, -6.164727471999925],
              [134.71314537900003, -6.161716403999947],
              [134.71021569100003, -6.160088799999926],
              [134.70289147200003, -6.15789153399993],
              [134.70142662900003, -6.170586846999925],
              [134.6972762380001, -6.180840752999927],
              [134.69109134200005, -6.188083591999941],
              [134.7407332690001, -6.17115650799991],
              [134.75806725400003, -6.15789153399993],
            ],
          ],
          [
            [
              [133.18433678500003, -5.310316664999959],
              [133.18816165500004, -5.324802341999941],
              [133.18873131600003, -5.344496351999908],
              [133.18433678500003, -5.361993096999925],
              [133.17212975400003, -5.369724216999941],
              [133.165375196, -5.38014088299991],
              [133.13892662900003, -5.52117278399993],
              [133.1132918630001, -5.595635674999926],
              [133.1059676440001, -5.605645440999922],
              [133.07960045700008, -5.631768487999921],
              [133.06910241000003, -5.637139580999929],
              [133.06080162900003, -5.639336846999925],
              [133.04704837300005, -5.648614190999922],
              [133.033539259, -5.654392184999949],
              [133.02711022200003, -5.662692966999941],
              [133.01710045700008, -5.678806247999944],
              [132.99724368600005, -5.699965101999908],
              [132.97543379, -5.728692315999922],
              [132.9575301440001, -5.76140715899993],
              [132.94939212300005, -5.79420338299991],
              [132.95093834700003, -5.813083591999941],
              [132.95850670700008, -5.844333591999941],
              [132.95679772200003, -5.862481377999927],
              [132.94947350400003, -5.87428150799991],
              [132.856781446, -5.989434502999927],
              [132.8422957690001, -5.996840101999908],
              [132.84050540500004, -5.984958591999941],
              [132.90007571700005, -5.813897393999923],
              [132.92351321700005, -5.786716403999947],
              [132.92888431100005, -5.777113539999959],
              [132.93116295700008, -5.714939059999949],
              [132.92888431100005, -5.698011976999908],
              [132.96412194100003, -5.640720309999949],
              [132.98031660200002, -5.644626559999949],
              [132.9965926440001, -5.651543877999927],
              [133.00407962300005, -5.647149346999925],
              [133.01490319100003, -5.60711028399993],
              [133.0185653000001, -5.566176039999959],
              [133.02295983200008, -5.54851653399993],
              [133.03874759200005, -5.513604424999926],
              [133.07585696700005, -5.398044528999947],
              [133.0966903000001, -5.366306247999944],
              [133.10434004, -5.350681247999944],
              [133.11011803500003, -5.310967705999929],
              [133.12134850400003, -5.29461028399993],
              [133.13786868600005, -5.287286065999922],
              [133.15609785200002, -5.28834400799991],
              [133.17261803500003, -5.296482028999947],
              [133.18433678500003, -5.310316664999959],
            ],
          ],
          [
            [
              [122.06739342500009, -5.215020440999922],
              [122.06421959700003, -5.223565362999921],
              [122.05713951900009, -5.226657809999949],
              [122.05014082100001, -5.230889580999929],
              [122.04688561300009, -5.242364190999922],
              [122.05176842500009, -5.269789320999905],
              [122.05298912900003, -5.432305596999925],
              [122.04688561300009, -5.451592705999929],
              [122.03199303500003, -5.465264580999929],
              [122.01441491000003, -5.465264580999929],
              [121.99675540500004, -5.462823174999926],
              [121.98145592500009, -5.468926690999922],
              [121.96827233200008, -5.467950127999927],
              [121.93921959700003, -5.420993747999944],
              [121.92351321700005, -5.403741143999923],
              [121.90992272200003, -5.399509372999944],
              [121.90056399800005, -5.399102471999925],
              [121.89210045700008, -5.39771900799991],
              [121.88184655000009, -5.390232028999947],
              [121.87696373800009, -5.381931247999944],
              [121.86841881600003, -5.359958591999941],
              [121.82715905000009, -5.300713799999926],
              [121.80681399800005, -5.259860934999949],
              [121.81373131600003, -5.24968840899993],
              [121.81218509200005, -5.220961195999905],
              [121.81723066500001, -5.20826588299991],
              [121.82618248800009, -5.197686455999929],
              [121.83375084700003, -5.185316664999959],
              [121.83887780000009, -5.172539971999925],
              [121.84083092500009, -5.160088799999926],
              [121.84636478000004, -5.152764580999929],
              [121.87256920700008, -5.148532809999949],
              [121.88184655000009, -5.143731377999927],
              [121.88152103000004, -5.133884372999944],
              [121.87305748800009, -5.122247002999927],
              [121.853851759, -5.102146091999941],
              [121.86491946700005, -5.086521091999941],
              [121.88038170700008, -5.072198174999926],
              [121.89795983200008, -5.060967705999929],
              [121.91602623800009, -5.05437590899993],
              [121.91016686300009, -5.070570570999905],
              [121.91089928500003, -5.085707289999959],
              [121.91944420700008, -5.095472914999959],
              [121.93702233200008, -5.095879815999922],
              [121.94418379000001, -5.091892184999949],
              [121.95948326900009, -5.071221612999921],
              [121.96957441500001, -5.066989841999941],
              [121.97730553500003, -5.070489190999922],
              [121.98267662900003, -5.079034112999921],
              [121.99659264400009, -5.137872002999927],
              [122.00977623800009, -5.153741143999923],
              [122.03337649800005, -5.149997653999947],
              [122.04509524800005, -5.165134372999944],
              [122.05616295700008, -5.175713799999926],
              [122.06421959700003, -5.189873955999929],
              [122.06739342500009, -5.215020440999922],
            ],
          ],
          [
            [
              [131.73308353000004, -4.69304778399993],
              [131.75017337300005, -4.710544528999947],
              [131.7544051440001, -4.736504815999922],
              [131.74870853000004, -4.75904713299991],
              [131.73650149800005, -4.766289971999925],
              [131.7290145190001, -4.754652601999908],
              [131.7251082690001, -4.73170338299991],
              [131.72608483200008, -4.707777601999908],
              [131.73308353000004, -4.69304778399993],
            ],
          ],
          [
            [
              [122.78003991000003, -4.916599216999941],
              [122.78060957100001, -4.939060153999947],
              [122.77857506600003, -4.949476820999905],
              [122.77312259200005, -4.958184502999927],
              [122.76539147200003, -4.957940362999921],
              [122.75391686300009, -4.953871351999908],
              [122.74350019600001, -4.95281340899993],
              [122.73902428500003, -4.961846612999921],
              [122.73487389400009, -4.974704684999949],
              [122.724945509, -4.989678643999923],
              [122.66138756600003, -5.055352471999925],
              [122.64340254000001, -5.078789971999925],
              [122.60425866000003, -5.159926039999959],
              [122.60124759200005, -5.18092213299991],
              [122.60661868600005, -5.190524997999944],
              [122.61866295700008, -5.191176039999959],
              [122.63062584700003, -5.190199476999908],
              [122.63599694100003, -5.194268487999921],
              [122.63453209700003, -5.206963799999926],
              [122.62989342500009, -5.216729424999926],
              [122.62240644600001, -5.222832940999922],
              [122.59815514400009, -5.228448174999926],
              [122.60645592500009, -5.235772393999923],
              [122.62916100400003, -5.245538018999923],
              [122.64771569100003, -5.256117445999905],
              [122.65235436300009, -5.261814059999949],
              [122.65642337300005, -5.273370049999926],
              [122.658539259, -5.296482028999947],
              [122.65544681100005, -5.322523695999905],
              [122.64747155000009, -5.344903252999927],
              [122.63599694100003, -5.355401299999926],
              [122.62452233200008, -5.342461846999925],
              [122.61597741000003, -5.356052341999941],
              [122.61060631600003, -5.380466403999947],
              [122.60865319100003, -5.400485934999949],
              [122.60547936300009, -5.413018487999921],
              [122.59839928500003, -5.420098565999922],
              [122.59148196700005, -5.420668226999908],
              [122.58814537900003, -5.413995049999926],
              [122.58448326900009, -5.409112237999921],
              [122.57618248800009, -5.414320570999905],
              [122.56373131600003, -5.427666924999926],
              [122.54346764400009, -5.428806247999944],
              [122.54086347700002, -5.38795338299991],
              [122.54281660200002, -5.338799737999921],
              [122.53663170700008, -5.315036716999941],
              [122.52881920700008, -5.306410414999959],
              [122.52084394600001, -5.291680596999925],
              [122.51148522200003, -5.286716403999947],
              [122.49878991000003, -5.307549737999921],
              [122.49691816500001, -5.318291924999926],
              [122.49919681100005, -5.339288018999923],
              [122.49878991000003, -5.349216403999947],
              [122.48511803500003, -5.383233330999929],
              [122.46859785200002, -5.396416924999926],
              [122.45020592500009, -5.399346612999921],
              [122.431976759, -5.392673434999949],
              [122.41627037900003, -5.376560153999947],
              [122.40723717500009, -5.35320403399993],
              [122.41488691500001, -5.339288018999923],
              [122.45101972700002, -5.321221612999921],
              [122.45101972700002, -5.315036716999941],
              [122.43360436300009, -5.315036716999941],
              [122.42156009200005, -5.311944268999923],
              [122.41016686300009, -5.311944268999923],
              [122.39519290500004, -5.321221612999921],
              [122.38721764400009, -5.330661716999941],
              [122.38363691500001, -5.341566664999959],
              [122.38266035200002, -5.373142184999949],
              [122.37720787900003, -5.384942315999922],
              [122.36394290500004, -5.389825127999927],
              [122.31332441500001, -5.389580987999921],
              [122.30054772200003, -5.386976820999905],
              [122.29021243600005, -5.380791924999926],
              [122.279633009, -5.369724216999941],
              [122.28711998800009, -5.362888278999947],
              [122.27621504000001, -5.345961195999905],
              [122.27515709700003, -5.327569268999923],
              [122.28150475400003, -5.307793877999927],
              [122.30713951900009, -5.263929945999905],
              [122.31568444100003, -5.242608330999929],
              [122.32007897200003, -5.219496351999908],
              [122.32601972700002, -5.144707940999922],
              [122.33253014400009, -5.123793226999908],
              [122.34180748800009, -5.108982028999947],
              [122.35084069100003, -5.105075778999947],
              [122.37720787900003, -5.098239841999941],
              [122.38266035200002, -5.092461846999925],
              [122.385101759, -5.08717213299991],
              [122.40259850400003, -5.06178150799991],
              [122.39600670700008, -5.048435153999947],
              [122.39177493600005, -5.030450127999927],
              [122.38591556100005, -4.978773695999905],
              [122.37224368600005, -4.955010674999926],
              [122.36524498800009, -4.915459893999923],
              [122.35499108200008, -4.884860934999949],
              [122.34156334700003, -4.857679945999905],
              [122.32748457100001, -4.842054945999905],
              [122.32748457100001, -4.83521900799991],
              [122.34498131600003, -4.814629815999922],
              [122.36670983200008, -4.765801690999922],
              [122.38266035200002, -4.745863539999959],
              [122.40495853000004, -4.737888278999947],
              [122.47095787900003, -4.731377862999921],
              [122.49878991000003, -4.725355726999908],
              [122.52947024800005, -4.710056247999944],
              [122.60124759200005, -4.656426690999922],
              [122.65699303500003, -4.62428150799991],
              [122.69068444100003, -4.611748955999929],
              [122.71111087300005, -4.615492445999905],
              [122.72722415500004, -4.628106377999927],
              [122.73552493600005, -4.643731377999927],
              [122.75269616000003, -4.773207289999959],
              [122.75277754000001, -4.844333591999941],
              [122.75570722700002, -4.855726820999905],
              [122.77027428500003, -4.87428150799991],
              [122.77312259200005, -4.879571221999925],
              [122.77409915500004, -4.887790622999944],
              [122.77857506600003, -4.905043226999908],
              [122.78003991000003, -4.916599216999941],
            ],
          ],
          [
            [
              [131.60621178500003, -4.430433851999908],
              [131.61353600400003, -4.425225518999923],
              [131.61980228000004, -4.424493096999925],
              [131.62614993600005, -4.426853122999944],
              [131.63347415500004, -4.430433851999908],
              [131.6494246750001, -4.45240650799991],
              [131.67074629, -4.490166924999926],
              [131.68043053500003, -4.524021091999941],
              [131.66089928500003, -4.534274997999944],
              [131.65503991000003, -4.525648695999905],
              [131.61646569100003, -4.441582940999922],
              [131.60621178500003, -4.430433851999908],
            ],
          ],
          [
            [
              [123.14991295700008, -5.225030205999929],
              [123.18881269600001, -5.247816664999959],
              [123.209320509, -5.265394789999959],
              [123.21810957100001, -5.283786716999941],
              [123.21314537900003, -5.301690362999921],
              [123.20142662900003, -5.317071221999925],
              [123.17725670700008, -5.342380466999941],
              [123.15805097700002, -5.373793226999908],
              [123.14503014400009, -5.385430596999925],
              [123.10303795700008, -5.395277601999908],
              [123.06560306100005, -5.418389580999929],
              [123.04688561300009, -5.424248955999929],
              [123.03052819100003, -5.419528903999947],
              [123.01026451900009, -5.395684502999927],
              [122.99537194100003, -5.390232028999947],
              [122.97754967500009, -5.39421965899993],
              [122.892914259, -5.444268487999921],
              [122.87623131600003, -5.458428643999923],
              [122.86280358200008, -5.495863539999959],
              [122.86101321700005, -5.508070570999905],
              [122.86597741000003, -5.513604424999926],
              [122.87631269600001, -5.510918877999927],
              [122.90170332100001, -5.499932549999926],
              [122.91041100400003, -5.49928150799991],
              [122.91822350400003, -5.527439059999949],
              [122.896820509, -5.571221612999921],
              [122.84888756600003, -5.637139580999929],
              [122.82764733200008, -5.676202080999929],
              [122.81348717500009, -5.687920830999929],
              [122.79029381600003, -5.692478122999944],
              [122.78793379000001, -5.687269789999959],
              [122.78630618600005, -5.662692966999941],
              [122.78345787900003, -5.654229424999926],
              [122.77100670700008, -5.642022393999923],
              [122.76783287900003, -5.641371351999908],
              [122.76628665500004, -5.64812590899993],
              [122.75359134200005, -5.665785414999959],
              [122.75049889400009, -5.675388278999947],
              [122.74659264400009, -5.67937590899993],
              [122.73902428500003, -5.671319268999923],
              [122.73682701900009, -5.661065362999921],
              [122.73959394600001, -5.636895440999922],
              [122.73560631600003, -5.626885674999926],
              [122.72234134200005, -5.627699476999908],
              [122.69092858200008, -5.665785414999959],
              [122.67701256600003, -5.678806247999944],
              [122.65430748800009, -5.678480726999908],
              [122.63835696700005, -5.662204684999949],
              [122.56714928500003, -5.506931247999944],
              [122.64429772200003, -5.439385674999926],
              [122.65455162900003, -5.424737237999921],
              [122.65211022200003, -5.41139088299991],
              [122.62916100400003, -5.403741143999923],
              [122.63559004000001, -5.391045830999929],
              [122.66325931100005, -5.355401299999926],
              [122.67261803500003, -5.324151299999926],
              [122.67839603000004, -5.322442315999922],
              [122.68506920700008, -5.322930596999925],
              [122.69068444100003, -5.321221612999921],
              [122.70411217500009, -5.302911065999922],
              [122.721039259, -5.266208591999941],
              [122.73218834700003, -5.253024997999944],
              [122.75269616000003, -5.245863539999959],
              [122.77947024800005, -5.241143487999921],
              [122.80323326900009, -5.231866143999923],
              [122.81470787900003, -5.211358330999929],
              [122.81413821700005, -5.193129164999959],
              [122.80860436300009, -5.189385674999926],
              [122.76343834700003, -5.207940362999921],
              [122.75757897200003, -5.20671965899993],
              [122.76628665500004, -5.190850518999923],
              [122.75456790500004, -5.177666924999926],
              [122.75660241000003, -5.164727471999925],
              [122.77312259200005, -5.143731377999927],
              [122.77849368600005, -5.129571221999925],
              [122.77808678500003, -5.104587497999944],
              [122.78003991000003, -5.089043877999927],
              [122.79761803500003, -5.060642184999949],
              [122.80445397200003, -5.043633721999925],
              [122.80054772200003, -5.026462497999944],
              [122.79118899800005, -5.021254164999959],
              [122.77979576900009, -5.024997653999947],
              [122.76661217500009, -5.031182549999926],
              [122.75269616000003, -5.033868096999925],
              [122.76189212300005, -5.015394789999959],
              [122.81788170700008, -4.968682549999926],
              [122.82740319100003, -4.952325127999927],
              [122.83350670700008, -4.929131768999923],
              [122.83594811300009, -4.904392184999949],
              [122.83464603000004, -4.883070570999905],
              [122.83073978000004, -4.873223565999922],
              [122.82496178500003, -4.862888278999947],
              [122.82048587300005, -4.852227471999925],
              [122.82097415500004, -4.842054945999905],
              [122.82886803500003, -4.835870049999926],
              [122.840179884, -4.834649346999925],
              [122.85059655000009, -4.831149997999944],
              [122.85499108200008, -4.817803643999923],
              [122.847992384, -4.648858330999929],
              [122.85499108200008, -4.609551690999922],
              [122.86939537900003, -4.568291924999926],
              [122.89942467500009, -4.510023695999905],
              [122.90357506600003, -4.489190362999921],
              [122.90894616000003, -4.474541924999926],
              [122.92261803500003, -4.461602471999925],
              [123.01954186300009, -4.390232028999947],
              [123.041351759, -4.384372653999947],
              [123.06910241000003, -4.383233330999929],
              [123.08570397200003, -4.389092705999929],
              [123.06153405000009, -4.421319268999923],
              [123.06853274800005, -4.439629815999922],
              [123.08423912900003, -4.456149997999944],
              [123.14779707100001, -4.508477471999925],
              [123.16358483200008, -4.526788018999923],
              [123.19044030000009, -4.566827080999929],
              [123.20045006600003, -4.589043877999927],
              [123.20443769600001, -4.611748955999929],
              [123.20240319100003, -4.621514580999929],
              [123.19304446700005, -4.641371351999908],
              [123.19092858200008, -4.653008721999925],
              [123.19336998800009, -4.662855726999908],
              [123.19922936300009, -4.667413018999923],
              [123.20606530000009, -4.670830987999921],
              [123.211273634, -4.677504164999959],
              [123.21705162900003, -4.711195570999905],
              [123.21973717500009, -4.816664320999905],
              [123.211273634, -4.842054945999905],
              [123.19703209700003, -4.836846612999921],
              [123.18873131600003, -4.816582940999922],
              [123.18409264400009, -4.776543877999927],
              [123.18189537900003, -4.771905205999929],
              [123.17115319100003, -4.756036065999922],
              [123.16700280000009, -4.752618096999925],
              [123.15772545700008, -4.748467705999929],
              [123.154633009, -4.738539320999905],
              [123.15349368600005, -4.726983330999929],
              [123.14991295700008, -4.717950127999927],
              [123.12387129000001, -4.71021900799991],
              [123.10531660200002, -4.76726653399993],
              [123.08155358200008, -4.739027601999908],
              [123.07797285200002, -4.74342213299991],
              [123.07105553500003, -4.748304945999905],
              [123.06739342500009, -4.752618096999925],
              [123.05209394600001, -4.740329684999949],
              [123.04639733200008, -4.752862237999921],
              [123.04688561300009, -4.797051690999922],
              [123.04265384200005, -4.803317966999941],
              [123.023773634, -4.815118096999925],
              [123.01954186300009, -4.824639580999929],
              [123.01295006600003, -4.85711028399993],
              [123.01221764400009, -4.869317315999922],
              [123.01742597700002, -4.90984465899993],
              [123.01514733200008, -4.92937590899993],
              [122.98991946700005, -4.945082289999959],
              [122.97738691500001, -4.96217213299991],
              [122.96794681100005, -4.980889580999929],
              [122.96436608200008, -4.992852471999925],
              [122.96607506600003, -5.003838799999926],
              [122.96989993600005, -5.012139580999929],
              [122.97437584700003, -5.01921965899993],
              [122.97787519600001, -5.026462497999944],
              [122.98462975400003, -5.052504164999959],
              [122.98536217500009, -5.064873955999929],
              [122.98357181100005, -5.087823174999926],
              [122.97852623800009, -5.103285414999959],
              [122.95525149800005, -5.149997653999947],
              [122.94792728000004, -5.172133070999905],
              [122.94988040500004, -5.190199476999908],
              [122.96802819100003, -5.197686455999929],
              [122.98845462300005, -5.186700127999927],
              [123.00342858200008, -5.163262627999927],
              [123.02035566500001, -5.142185153999947],
              [123.04688561300009, -5.137465101999908],
              [123.05933678500003, -5.144138278999947],
              [123.06267337300005, -5.152764580999929],
              [123.06299889400009, -5.162041924999926],
              [123.06739342500009, -5.170505466999941],
              [123.10206139400009, -5.18092213299991],
              [123.10670006600003, -5.197686455999929],
              [123.11793053500003, -5.209161065999922],
              [123.14991295700008, -5.225030205999929],
            ],
          ],
          [
            [
              [133.55836022200003, -4.232028903999947],
              [133.60857181100005, -4.291761976999908],
              [133.62769616000003, -4.300225518999923],
              [133.60417728000004, -4.300713799999926],
              [133.5791121750001, -4.278497002999927],
              [133.5551863940001, -4.251722914999959],
              [133.5351668630001, -4.238702080999929],
              [133.52271569100003, -4.23992278399993],
              [133.49952233200008, -4.245049737999921],
              [133.48755944100003, -4.246189059999949],
              [133.47038821700005, -4.246026299999926],
              [133.46045983200008, -4.244073174999926],
              [133.4511824880001, -4.237888278999947],
              [133.435883009, -4.225192966999941],
              [133.42335045700008, -4.217380466999941],
              [133.3994246750001, -4.209893487999921],
              [133.38819420700008, -4.204685153999947],
              [133.37671959700003, -4.193536065999922],
              [133.36939537900003, -4.182386976999908],
              [133.360199415, -4.173923434999949],
              [133.3437606130001, -4.170505466999941],
              [133.331390821, -4.165215752999927],
              [133.32374108200008, -4.152927341999941],
              [133.32007897200003, -4.137627862999921],
              [133.3193465500001, -4.124200127999927],
              [133.3242293630001, -4.108330987999921],
              [133.3344832690001, -4.10906340899993],
              [133.407562696, -4.160332940999922],
              [133.4126082690001, -4.162286065999922],
              [133.41863040500004, -4.163018487999921],
              [133.42139733200008, -4.165948174999926],
              [133.4267684250001, -4.179864190999922],
              [133.429047071, -4.184177341999941],
              [133.44597415500004, -4.19695403399993],
              [133.4560653000001, -4.20240650799991],
              [133.46664472700002, -4.204685153999947],
              [133.49431399800005, -4.206638278999947],
              [133.51970462300005, -4.21217213299991],
              [133.54127037900003, -4.220879815999922],
              [133.55836022200003, -4.232028903999947],
            ],
          ],
          [
            [
              [131.36597741000003, -4.122165622999944],
              [131.38550866000003, -4.140232028999947],
              [131.39185631600003, -4.153497002999927],
              [131.38542728000004, -4.156182549999926],
              [131.35271243600005, -4.133396091999941],
              [131.305023634, -4.115329684999949],
              [131.29656009200005, -4.10906340899993],
              [131.28923587300005, -4.100030205999929],
              [131.2837020190001, -4.089776299999926],
              [131.28052819100003, -4.079522393999923],
              [131.28044681100005, -4.074802341999941],
              [131.28150475400003, -4.07000090899993],
              [131.2841903000001, -4.06609465899993],
              [131.28834069100003, -4.063409112999921],
              [131.29460696700005, -4.063164971999925],
              [131.29851321700005, -4.065850518999923],
              [131.30437259200005, -4.074883721999925],
              [131.31763756600003, -4.088067315999922],
              [131.36597741000003, -4.122165622999944],
            ],
          ],
          [
            [
              [131.23503665500004, -3.98756275799991],
              [131.24048912900003, -3.991794528999947],
              [131.24537194100003, -3.996840101999908],
              [131.24870853000004, -4.002862237999921],
              [131.24984785200002, -4.009698174999926],
              [131.2504988940001, -4.032321872999944],
              [131.24756920700008, -4.04265715899993],
              [131.239593946, -4.047051690999922],
              [131.22608483200008, -4.03834400799991],
              [131.21648196700005, -4.018649997999944],
              [131.21078535200002, -3.99578215899993],
              [131.20915774800005, -3.978936455999929],
              [131.23503665500004, -3.98756275799991],
            ],
          ],
          [
            [
              [123.20443769600001, -3.992933851999908],
              [123.23414147200003, -4.01531340899993],
              [123.25123131600003, -4.050876559999949],
              [123.25342858200008, -4.089776299999926],
              [123.23878014400009, -4.122165622999944],
              [123.19629967500009, -4.187676690999922],
              [123.16928144600001, -4.221123955999929],
              [123.13624108200008, -4.238702080999929],
              [123.08659915500004, -4.234470309999949],
              [123.04476972700002, -4.209649346999925],
              [123.00912519600001, -4.171970309999949],
              [122.97787519600001, -4.128838799999926],
              [122.96876061300009, -4.108493747999944],
              [122.95972741000003, -4.065118096999925],
              [122.95069420700008, -4.047051690999922],
              [122.96119225400003, -4.03484465899993],
              [122.98658287900003, -4.017754815999922],
              [122.998383009, -4.006605726999908],
              [123.01563561300009, -3.981133721999925],
              [123.02816816500001, -3.973809502999927],
              [123.04688561300009, -3.978692315999922],
              [123.06185957100001, -3.986504815999922],
              [123.08179772200003, -4.00123463299991],
              [123.10230553500003, -4.012465101999908],
              [123.11890709700003, -4.009698174999926],
              [123.13502037900003, -4.000176690999922],
              [123.15845787900003, -3.993096612999921],
              [123.18360436300009, -3.990329684999949],
              [123.20443769600001, -3.992933851999908],
            ],
          ],
          [
            [
              [131.44483483200008, -4.036716403999947],
              [131.45329837300005, -4.055759372999944],
              [131.4423934250001, -4.065118096999925],
              [131.4218856130001, -4.062920830999929],
              [131.40064537900003, -4.047051690999922],
              [131.39128665500004, -4.031508070999905],
              [131.3701278000001, -3.985284112999921],
              [131.36597741000003, -3.96843840899993],
              [131.3696395190001, -3.96217213299991],
              [131.37769616000003, -3.957126559999949],
              [131.39437910200002, -3.951592705999929],
              [131.4160262380001, -3.958591403999947],
              [131.42701256600003, -3.983330987999921],
              [131.43433678500003, -4.013604424999926],
              [131.44483483200008, -4.036716403999947],
            ],
          ],
          [
            [
              [128.796234571, -3.642836195999905],
              [128.79712975400003, -3.652520440999922],
              [128.79965254, -3.66139088299991],
              [128.80420983200008, -3.669366143999923],
              [128.8105574880001, -3.676446221999925],
              [128.79712975400003, -3.693780205999929],
              [128.7793074880001, -3.702243747999944],
              [128.7617293630001, -3.699639580999929],
              [128.7485457690001, -3.683851820999905],
              [128.74634850400003, -3.659763278999947],
              [128.75798587300005, -3.643649997999944],
              [128.77686608200008, -3.637302341999941],
              [128.796234571, -3.642836195999905],
            ],
          ],
          [
            [
              [123.17725670700008, -3.573988539999959],
              [123.17709394600001, -3.601006768999923],
              [123.15992272200003, -3.603773695999905],
              [123.13941491000003, -3.602715752999927],
              [123.12940514400009, -3.618340752999927],
              [123.11988366000003, -3.629164320999905],
              [123.09880618600005, -3.619235934999949],
              [123.07837975400003, -3.602634372999944],
              [123.06666100400003, -3.589613539999959],
              [123.06169681100005, -3.580254815999922],
              [123.06104576900009, -3.570896091999941],
              [123.07081139400009, -3.566582940999922],
              [123.08277428500003, -3.564222914999959],
              [123.14063561300009, -3.539157809999949],
              [123.15723717500009, -3.544854424999926],
              [123.16976972700002, -3.55828215899993],
              [123.17725670700008, -3.573988539999959],
            ],
          ],
          [
            [
              [128.52881920700008, -3.532972914999959],
              [128.54281660200002, -3.547458591999941],
              [128.55884850400003, -3.570489190999922],
              [128.563812696, -3.591892184999949],
              [128.5459090500001, -3.601332289999959],
              [128.52898196700005, -3.604424737999921],
              [128.490570509, -3.618584893999923],
              [128.44906660200002, -3.623142184999949],
              [128.4316512380001, -3.627048434999949],
              [128.392914259, -3.642836195999905],
              [128.387543165, -3.626885674999926],
              [128.392914259, -3.606622002999927],
              [128.4013778000001, -3.586358330999929],
              [128.40601647200003, -3.570245049999926],
              [128.40691165500004, -3.556817315999922],
              [128.4101668630001, -3.543226820999905],
              [128.4165145190001, -3.531345309999949],
              [128.427093946, -3.52271900799991],
              [128.4614363940001, -3.512139580999929],
              [128.47730553500003, -3.519789320999905],
              [128.5127059250001, -3.526055596999925],
              [128.52881920700008, -3.532972914999959],
            ],
          ],
          [
            [
              [128.33082116000003, -3.511895440999922],
              [128.34937584700003, -3.529473565999922],
              [128.344574415, -3.542087497999944],
              [128.3310653000001, -3.554131768999923],
              [128.32341556100005, -3.570245049999926],
              [128.32886803500003, -3.591729424999926],
              [128.33716881600003, -3.611586195999905],
              [128.3349715500001, -3.627211195999905],
              [128.30974368600005, -3.635430596999925],
              [128.303070509, -3.633965752999927],
              [128.28305097700002, -3.621758721999925],
              [128.26921634200005, -3.615817966999941],
              [128.263031446, -3.615004164999959],
              [128.2519637380001, -3.61492278399993],
              [128.2465926440001, -3.62037525799991],
              [128.25123131600003, -3.632582289999959],
              [128.2758895190001, -3.666192315999922],
              [128.278168165, -3.674411716999941],
              [128.27491295700008, -3.681084893999923],
              [128.2548934250001, -3.709567966999941],
              [128.23650149800005, -3.722263278999947],
              [128.21265709700003, -3.729261976999908],
              [128.18311608200008, -3.731622002999927],
              [128.161468946, -3.739027601999908],
              [128.14673912900003, -3.755059502999927],
              [128.12867272200003, -3.769626559999949],
              [128.09742272200003, -3.773207289999959],
              [128.1040145190001, -3.763767184999949],
              [128.12712649800005, -3.749444268999923],
              [128.13209069100003, -3.742282809999949],
              [128.15202884200005, -3.703057549999926],
              [128.20435631600003, -3.668145440999922],
              [128.22095787900003, -3.649102471999925],
              [128.20289147200003, -3.639336846999925],
              [128.18376712300005, -3.646905205999929],
              [128.14519290500004, -3.676446221999925],
              [128.10670006600003, -3.692071221999925],
              [128.08073978000004, -3.708184502999927],
              [128.055511915, -3.713311455999929],
              [128.04273522200003, -3.71803150799991],
              [128.02173912900003, -3.736423434999949],
              [128.00570722700002, -3.756768487999921],
              [127.98601321700005, -3.771579684999949],
              [127.95411217500009, -3.773207289999959],
              [127.93344160200002, -3.763441664999959],
              [127.92676842500009, -3.746840101999908],
              [127.92335045700008, -3.726006768999923],
              [127.91236412900003, -3.703057549999926],
              [127.916351759, -3.693942966999941],
              [127.96094811300009, -3.64031340899993],
              [127.98414147200003, -3.620538018999923],
              [128.034515821, -3.589043877999927],
              [128.047699415, -3.584730726999908],
              [128.0625106130001, -3.583591403999947],
              [128.14730879, -3.588474216999941],
              [128.1587020190001, -3.584649346999925],
              [128.24170983200008, -3.522149346999925],
              [128.2871199880001, -3.504571221999925],
              [128.33082116000003, -3.511895440999922],
            ],
          ],
          [
            [
              [128.72055097700002, -3.525567315999922],
              [128.72641035200002, -3.545993747999944],
              [128.72803795700008, -3.61492278399993],
              [128.70655358200008, -3.602959893999923],
              [128.68702233200008, -3.582207940999922],
              [128.668793165, -3.569268487999921],
              [128.6523543630001, -3.580824476999908],
              [128.65162194100003, -3.59148528399993],
              [128.65544681100005, -3.602146091999941],
              [128.65601647200003, -3.612399997999944],
              [128.6455184250001, -3.621758721999925],
              [128.63624108200008, -3.622816664999959],
              [128.6274520190001, -3.617608330999929],
              [128.61898847700002, -3.607517184999949],
              [128.61060631600003, -3.593926690999922],
              [128.6181746750001, -3.593926690999922],
              [128.6035262380001, -3.583428643999923],
              [128.5937606130001, -3.568617445999905],
              [128.58570397200003, -3.552992445999905],
              [128.56788170700008, -3.528008721999925],
              [128.5590926440001, -3.509372653999947],
              [128.5610457690001, -3.493747653999947],
              [128.5839949880001, -3.49146900799991],
              [128.59782962300005, -3.491794528999947],
              [128.606293165, -3.496677341999941],
              [128.6215926440001, -3.515720309999949],
              [128.63168379, -3.522556247999944],
              [128.6606551440001, -3.533379815999922],
              [128.6728621750001, -3.539808851999908],
              [128.68246504, -3.517022393999923],
              [128.69320722700002, -3.502048434999949],
              [128.70573978000004, -3.502536716999941],
              [128.72055097700002, -3.525567315999922],
            ],
          ],
          [
            [
              [127.24089603000004, -3.470961195999962],
              [127.24341881600003, -3.606052341999941],
              [127.22722415500004, -3.642836195999905],
              [127.20573978000004, -3.659600518999923],
              [127.18580162900003, -3.659926039999959],
              [127.16521243600005, -3.653415622999944],
              [127.14144941500001, -3.649102471999925],
              [127.12159264400009, -3.653252862999921],
              [127.00196373800009, -3.713799737999921],
              [126.99073326900009, -3.71803150799991],
              [126.98072350400003, -3.724541924999926],
              [126.95679772200003, -3.755629164999959],
              [126.94605553500003, -3.765801690999922],
              [126.90699955900004, -3.78734113999991],
              [126.82692928800009, -3.810093289999941],
              [126.77708639000002, -3.832694756999956],
              [126.74218531500003, -3.859378355999922],
              [126.718896104, -3.854854321999937],
              [126.69657344000007, -3.863792105999948],
              [126.67427504300008, -3.842502851999939],
              [126.65629280300004, -3.834851643999912],
              [126.58932542100001, -3.816639322999947],
              [126.55852750400004, -3.793291256999908],
              [126.52505747300006, -3.789916427999913],
              [126.438879444, -3.750449915999923],
              [126.38062584700003, -3.703057549999926],
              [126.36443118600005, -3.697198174999926],
              [126.32466369400004, -3.687644316999922],
              [126.274895582, -3.663260553999919],
              [126.25879663700005, -3.642255465999938],
              [126.24391844900003, -3.631398868999952],
              [126.2030208440001, -3.630993787999955],
              [126.1735606200001, -3.602527212999917],
              [126.16529381600003, -3.567966403999947],
              [126.14855361100001, -3.52550066099991],
              [126.08812775800004, -3.483623285999954],
              [126.06850725100003, -3.467379435999931],
              [126.05262796, -3.446320133999961],
              [126.04175866000003, -3.420098565999922],
              [126.04118899800005, -3.412855726999908],
              [126.00722645200005, -3.36101182799996],
              [125.9917424030001, -3.248191339999948],
              [126.01726321700005, -3.17115650799991],
              [126.03656216900004, -3.153592708999952],
              [126.06460853800002, -3.132931362999955],
              [126.09092117500006, -3.112098279999941],
              [126.11086722700009, -3.121706119999942],
              [126.121615228, -3.147897929999942],
              [126.136318502, -3.160623631999954],
              [126.16134390700006, -3.172316784999907],
              [126.18508540000005, -3.180893844999957],
              [126.20200119800006, -3.181841811999959],
              [126.22774030100004, -3.174758609999913],
              [126.22657311300009, -3.149509372999944],
              [126.25831139400009, -3.122002862999921],
              [126.29712975400003, -3.105889580999929],
              [126.42139733200008, -3.070489190999922],
              [126.72022545700008, -3.060153903999947],
              [126.84001712300005, -3.073663018999923],
              [126.85889733200008, -3.085870049999926],
              [126.87525475400003, -3.109470309999949],
              [126.89340254000001, -3.125583591999941],
              [126.91871178500003, -3.114678643999923],
              [126.93409264400009, -3.13054778399993],
              [126.95573978000004, -3.137790622999944],
              [126.97917728000004, -3.14226653399993],
              [127.00066165500004, -3.149509372999944],
              [127.03500410200002, -3.17351653399993],
              [127.05494225400003, -3.179457289999959],
              [127.08423912900003, -3.194268487999921],
              [127.09351647200003, -3.200778903999947],
              [127.10230553500003, -3.210381768999923],
              [127.10694420700008, -3.218845309999949],
              [127.10914147200003, -3.229424737999921],
              [127.11231530000009, -3.264418226999908],
              [127.11182701900009, -3.272067966999941],
              [127.10645592500009, -3.273044528999947],
              [127.09351647200003, -3.272393487999921],
              [127.08301842500009, -3.268161716999941],
              [127.06983483200008, -3.260918877999927],
              [127.05591881600003, -3.259535414999959],
              [127.04224694100003, -3.272393487999921],
              [127.04078209700003, -3.286716403999947],
              [127.04615319100003, -3.305352471999925],
              [127.05453535200002, -3.323011976999908],
              [127.06275475400003, -3.334405205999929],
              [127.06950931100005, -3.336683851999908],
              [127.08008873800009, -3.348809502999927],
              [127.09473717500009, -3.362074476999908],
              [127.11394290500004, -3.368584893999923],
              [127.12476647200003, -3.363213799999926],
              [127.13786868600005, -3.339776299999926],
              [127.14828535200002, -3.334405205999929],
              [127.15894616000003, -3.33717213299991],
              [127.19312584700003, -3.355564059999949],
              [127.23853600400003, -3.363213799999926],
              [127.25977623800009, -3.371189059999949],
              [127.26880944100003, -3.385918877999927],
              [127.26465905000009, -3.404717705999929],
              [127.24634850400003, -3.449965101999908],
              [127.24089603000004, -3.470961195999962],
            ],
          ],
          [
            [
              [106.90894616000003, -2.929782809999949],
              [106.91570071700005, -2.950941664999959],
              [106.89079837300005, -2.994886976999908],
              [106.89527428500003, -3.018487237999921],
              [106.86589603000004, -3.026543877999927],
              [106.86117597700007, -3.02898528399993],
              [106.81576582100007, -3.018487237999921],
              [106.79859459700003, -3.01100025799991],
              [106.75806725400003, -2.97820403399993],
              [106.72266686300003, -2.96607838299991],
              [106.72559655000003, -2.956231377999927],
              [106.73406009200005, -2.94654713299991],
              [106.73829186300003, -2.943454684999949],
              [106.74561608200003, -2.926934502999927],
              [106.74952233200003, -2.92310963299991],
              [106.77222741000003, -2.907321872999944],
              [106.79232832100007, -2.896416924999926],
              [106.81251061300003, -2.892185153999947],
              [106.82642662900003, -2.903008721999925],
              [106.84351647200003, -2.911879164999959],
              [106.88990319100003, -2.919854424999926],
              [106.90894616000003, -2.929782809999949],
            ],
          ],
          [
            [
              [107.09923179600003, -2.859058011999934],
              [107.09676088100008, -2.885194687999956],
              [107.09075137900004, -2.902999833999957],
              [107.08375084700003, -2.90984465899993],
              [107.06999759200005, -2.90748463299991],
              [107.05958092500003, -2.901462497999944],
              [107.04437189200007, -2.896928103999926],
              [107.03369812700004, -2.888574783999957],
              [107.01707568300003, -2.880205997999951],
              [107.03260859400007, -2.858870155999909],
              [107.04574629000007, -2.840752862999921],
              [107.05941816500007, -2.831963799999926],
              [107.06104576900003, -2.827243747999944],
              [107.06462649800005, -2.822523695999962],
              [107.07349694100003, -2.820489190999922],
              [107.07789147200003, -2.823337497999944],
              [107.08621031600006, -2.840005214999906],
              [107.09923179600003, -2.859058011999934],
            ],
          ],
          [
            [
              [107.39503014400003, -2.868910414999959],
              [107.40023847700007, -2.850762627999927],
              [107.42579186300003, -2.83521900799991],
              [107.45818118600005, -2.824476820999962],
              [107.48438561300003, -2.820489190999922],
              [107.49519204700005, -2.823489319999908],
              [107.49383832500007, -2.837821595999912],
              [107.49773196700005, -2.845147393999923],
              [107.50473066500007, -2.854668877999927],
              [107.49488366000003, -2.876397393999923],
              [107.48096764400003, -2.898695570999962],
              [107.46290123800003, -2.915948174999926],
              [107.42798912900003, -2.925713799999926],
              [107.41014730800003, -2.947565211999915],
              [107.39845358700006, -2.938427947999912],
              [107.36924703000005, -2.905168980999917],
              [107.34129222600006, -2.88685845099991],
              [107.34848817300008, -2.875167492999935],
              [107.36605373000003, -2.882383951999941],
              [107.38105223200006, -2.875274658999956],
              [107.39503014400003, -2.868910414999959],
            ],
          ],
          [
            [
              [130.87322024800005, -3.573988539999959],
              [130.87574303500003, -3.58562590899993],
              [130.87623131600003, -3.595310153999947],
              [130.87322024800005, -3.61492278399993],
              [130.86866295700008, -3.625746351999908],
              [130.854828321, -3.646416924999926],
              [130.8520613940001, -3.652927341999941],
              [130.84888756600003, -3.662692966999941],
              [130.83472741000003, -3.682305596999925],
              [130.83155358200008, -3.694105726999908],
              [130.8247176440001, -3.824476820999905],
              [130.8310653000001, -3.837497653999947],
              [130.84148196700005, -3.85279713299991],
              [130.84156334700003, -3.865004164999959],
              [130.81788170700008, -3.86882903399993],
              [130.79957116000003, -3.861748955999929],
              [130.76734459700003, -3.834079684999949],
              [130.75277754, -3.827894789999959],
              [130.73121178500003, -3.825941664999959],
              [130.63160241000003, -3.788669528999947],
              [130.61646569100003, -3.786309502999927],
              [130.60694420700008, -3.778497002999927],
              [130.56470787900003, -3.731622002999927],
              [130.5512801440001, -3.720961195999905],
              [130.5351668630001, -3.711846612999921],
              [130.51579837300005, -3.705498955999929],
              [130.4926863940001, -3.703057549999926],
              [130.47779381600003, -3.697360934999949],
              [130.46558678500003, -3.683851820999905],
              [130.44800866000003, -3.656508070999905],
              [130.43531334700003, -3.645440362999921],
              [130.418793165, -3.636895440999922],
              [130.3989363940001, -3.631280205999929],
              [130.3759871750001, -3.629164320999905],
              [130.3564559250001, -3.62468840899993],
              [130.31080162900003, -3.593926690999922],
              [130.12647545700008, -3.532972914999959],
              [130.10661868600005, -3.514825127999927],
              [130.101898634, -3.511895440999922],
              [130.08806399800005, -3.509698174999926],
              [130.0371199880001, -3.49146900799991],
              [130.00171959700003, -3.473077080999929],
              [129.98316491000003, -3.459730726999908],
              [129.9751082690001, -3.447686455999929],
              [129.97291100400003, -3.441501559999949],
              [129.96363366000003, -3.428317966999941],
              [129.961273634, -3.420098565999922],
              [129.962250196, -3.390801690999922],
              [129.961273634, -3.382256768999923],
              [129.93384850400003, -3.348321221999925],
              [129.89047285200002, -3.333103122999944],
              [129.5449324880001, -3.297784112999921],
              [129.50961347700002, -3.302504164999959],
              [129.5019637380001, -3.334405205999929],
              [129.55144290500004, -3.403252862999921],
              [129.56324303500003, -3.439629815999922],
              [129.53003991000003, -3.464776299999926],
              [129.48560631600003, -3.463474216999941],
              [129.40154056100005, -3.422946872999944],
              [129.35808353000004, -3.410088799999926],
              [129.23617597700002, -3.40162525799991],
              [129.19361412900003, -3.389743747999944],
              [129.11353600400003, -3.348809502999927],
              [129.084320509, -3.341241143999923],
              [129.05844160200002, -3.340752862999921],
              [128.98422285200002, -3.347426039999959],
              [128.96078535200002, -3.355564059999949],
              [128.93962649800005, -3.332614841999941],
              [128.93767337300005, -3.320407809999949],
              [128.94703209700003, -3.300225518999923],
              [128.98194420700008, -3.251885674999926],
              [128.96892337300005, -3.233005466999941],
              [128.95289147200003, -3.22039153399993],
              [128.93336022200003, -3.213555596999925],
              [128.909515821, -3.211521091999941],
              [128.8896590500001, -3.20435963299991],
              [128.8774520190001, -3.202569268999923],
              [128.8720809250001, -3.207777601999908],
              [128.8691512380001, -3.213636976999908],
              [128.850922071, -3.238213799999926],
              [128.79216556100005, -3.260430596999925],
              [128.78272545700008, -3.26921965899993],
              [128.77686608200008, -3.279392184999949],
              [128.69255618600005, -3.348728122999944],
              [128.68637129, -3.358575127999927],
              [128.68433678500003, -3.363864841999941],
              [128.67953535200002, -3.368747653999947],
              [128.67497806100005, -3.375420830999929],
              [128.6728621750001, -3.385918877999927],
              [128.67603600400003, -3.394789320999962],
              [128.68327884200005, -3.401055596999925],
              [128.6904403000001, -3.405694268999923],
              [128.6938582690001, -3.410088799999926],
              [128.67758222700002, -3.432305596999925],
              [128.63591556100005, -3.436618747999944],
              [128.5869246750001, -3.434340101999908],
              [128.5493270190001, -3.437432549999926],
              [128.5083113940001, -3.456963799999926],
              [128.48414147200003, -3.462497653999947],
              [128.464203321, -3.454522393999923],
              [128.4497176440001, -3.443291924999926],
              [128.41618899800005, -3.425957940999922],
              [128.39918053500003, -3.410088799999926],
              [128.282074415, -3.220879815999922],
              [128.27214603000004, -3.211521091999941],
              [128.2309676440001, -3.208754164999959],
              [128.2114363940001, -3.204278252999927],
              [128.18287194100003, -3.193780205999929],
              [128.1787215500001, -3.194268487999921],
              [128.17855879, -3.191013278999947],
              [128.1801863940001, -3.166761976999908],
              [128.185883009, -3.140720309999949],
              [128.200043165, -3.111423434999949],
              [128.19678795700008, -3.090915622999944],
              [128.18433678500003, -3.074395440999922],
              [128.16578209700003, -3.066989841999941],
              [128.1357528000001, -3.075372002999927],
              [128.11060631600003, -3.100030205999929],
              [128.090668165, -3.132012627999927],
              [128.07691491000003, -3.162530205999929],
              [128.06657962300005, -3.19695403399993],
              [128.05689537900003, -3.296807549999926],
              [128.053070509, -3.310642184999949],
              [128.04420006600003, -3.325778903999947],
              [128.03150475400003, -3.357679945999962],
              [128.02222741000003, -3.368584893999923],
              [128.0141707690001, -3.371351820999962],
              [127.99390709700003, -3.373711846999925],
              [127.98755944100003, -3.376071872999944],
              [127.98145592500009, -3.385023695999962],
              [127.97559655000009, -3.405043226999908],
              [127.96216881600003, -3.425713799999926],
              [127.95289147200003, -3.443942966999941],
              [127.94027754000001, -3.478448174999926],
              [127.935883009, -3.497002862999921],
              [127.93718509200005, -3.50554778399993],
              [127.94385826900009, -3.515720309999949],
              [127.94263756600003, -3.521661065999922],
              [127.92920983200008, -3.542738539999959],
              [127.92603600400003, -3.553480726999908],
              [127.89861087300005, -3.523858330999929],
              [127.90308678500003, -3.476657809999949],
              [127.93344160200002, -3.389743747999944],
              [127.93384850400003, -3.345310153999947],
              [127.93018639400009, -3.323337497999944],
              [127.92302493600005, -3.313897393999923],
              [127.91570071700005, -3.307224216999941],
              [127.88575280000009, -3.266208591999941],
              [127.87525475400003, -3.208754164999959],
              [127.86801191500001, -3.193780205999929],
              [127.84229576900009, -3.173272393999923],
              [127.84392337300005, -3.166110934999949],
              [127.86475670700008, -3.156345309999949],
              [127.87403405000009, -3.154392184999949],
              [127.89649498800009, -3.152113539999959],
              [127.90560957100001, -3.149509372999944],
              [127.91627037900003, -3.13990650799991],
              [127.93873131600003, -3.113376559999949],
              [127.95069420700008, -3.107842705999929],
              [127.96729576900009, -3.103692315999922],
              [127.99293053500003, -3.082614841999941],
              [128.00806725400003, -3.073663018999923],
              [128.02564537900003, -3.068617445999962],
              [128.04615319100003, -3.065850518999923],
              [128.06666100400003, -3.066989841999941],
              [128.08375084700003, -3.073663018999923],
              [128.10368899800005, -3.066989841999941],
              [128.0918074880001, -3.034600518999923],
              [128.09058678500003, -3.022149346999925],
              [128.09498131600003, -3.010918877999927],
              [128.114105665, -2.993584893999923],
              [128.11793053500003, -2.984307549999926],
              [128.106293165, -2.975518487999921],
              [128.0849715500001, -2.97389088299991],
              [128.06999759200005, -2.970635674999926],
              [128.07691491000003, -2.957696221999925],
              [128.08545983200008, -2.954847914999959],
              [128.11215254, -2.949965101999908],
              [128.1211043630001, -2.944512627999927],
              [128.13892662900003, -2.90984465899993],
              [128.13648522200003, -2.911879164999959],
              [128.13624108200008, -2.907647393999923],
              [128.13746178500003, -2.901299737999921],
              [128.13892662900003, -2.89617278399993],
              [128.14323978000004, -2.894626559999949],
              [128.14991295700008, -2.894952080999929],
              [128.15609785200002, -2.893243096999925],
              [128.15886478000004, -2.885674737999921],
              [128.16089928500003, -2.874118747999944],
              [128.16667728000004, -2.863946221999925],
              [128.17546634200005, -2.857028903999947],
              [128.18677819100003, -2.854668877999927],
              [128.21241295700008, -2.860528252999927],
              [128.38103274800005, -2.859958591999941],
              [128.417328321, -2.850518487999921],
              [128.45972741000003, -2.846286716999941],
              [128.4985457690001, -2.836521091999941],
              [128.51587975400003, -2.834161065999922],
              [128.53785241000003, -2.83717213299991],
              [128.57545006600003, -2.851332289999959],
              [128.60075931100005, -2.854668877999927],
              [128.80054772200003, -2.856215101999908],
              [128.8422957690001, -2.862237237999921],
              [128.8652449880001, -2.862074476999908],
              [128.9082137380001, -2.855401299999926],
              [128.9472762380001, -2.844414971999925],
              [129.015961134, -2.814222914999959],
              [129.05290774800005, -2.804457289999959],
              [129.0688582690001, -2.821221612999921],
              [129.07056725400003, -2.854913018999923],
              [129.0644637380001, -2.89617278399993],
              [129.079437696, -2.905368747999944],
              [129.10523522200003, -2.947930596999925],
              [129.12183678500003, -2.957696221999925],
              [129.133148634, -2.956475518999923],
              [129.15259850400003, -2.951348565999922],
              [129.16285241000003, -2.950290622999944],
              [129.16911868600005, -2.951348565999922],
              [129.17212975400003, -2.953871351999908],
              [129.174164259, -2.956475518999923],
              [129.177093946, -2.957696221999925],
              [129.18539472700002, -2.955173434999949],
              [129.18433678500003, -2.949151299999926],
              [129.180511915, -2.942152601999908],
              [129.180511915, -2.936618747999944],
              [129.17994225400003, -2.934258721999925],
              [129.1782332690001, -2.930433851999908],
              [129.17945397200003, -2.926446221999925],
              [129.18734785200002, -2.922946872999944],
              [129.1919051440001, -2.923028252999927],
              [129.1953231130001, -2.928399346999925],
              [129.20045006600003, -2.929782809999949],
              [129.21159915500004, -2.940850518999923],
              [129.21851647200003, -2.941176039999959],
              [129.22144616000003, -2.926364841999941],
              [129.22779381600003, -2.915215752999927],
              [129.2431746750001, -2.906833591999941],
              [129.27613366000003, -2.89617278399993],
              [129.32837975400003, -2.866794528999947],
              [129.3584090500001, -2.856215101999908],
              [129.364105665, -2.842054945999962],
              [129.36646569100003, -2.823988539999959],
              [129.37289472700002, -2.806817315999922],
              [129.40023847700002, -2.791599216999941],
              [129.44353274800005, -2.784926039999959],
              [129.52320397200003, -2.786309502999927],
              [129.53484134200005, -2.780043226999908],
              [129.5410262380001, -2.780043226999908],
              [129.54371178500003, -2.789727471999925],
              [129.545258009, -2.793552341999941],
              [129.54957116000003, -2.796644789999959],
              [129.55494225400003, -2.799004815999922],
              [129.6118270190001, -2.806817315999922],
              [129.75375410200002, -2.86646900799991],
              [129.7661238940001, -2.868910414999959],
              [129.77808678500003, -2.875420830999929],
              [129.79802493600005, -2.906426690999922],
              [129.8105574880001, -2.916680596999925],
              [129.82545006600003, -2.91765715899993],
              [129.83814537900003, -2.912692966999941],
              [129.84986412900003, -2.906182549999926],
              [129.86207116000003, -2.903008721999925],
              [129.86833743600005, -2.906996351999908],
              [129.86988366000003, -2.916273695999962],
              [129.87330162900003, -2.927504164999959],
              [129.88559004, -2.936618747999944],
              [129.8950301440001, -2.925388278999947],
              [129.91163170700008, -2.933200778999947],
              [129.92758222700002, -2.94695403399993],
              [129.9438582690001, -2.96453215899993],
              [129.9648543630001, -2.973565362999921],
              [130.04664147200003, -2.992120049999926],
              [130.21265709700003, -2.990411065999922],
              [130.30152428500003, -2.977227471999925],
              [130.34498131600003, -2.977634372999944],
              [130.38933353000004, -2.99382903399993],
              [130.48894290500004, -3.087497653999947],
              [130.5029403000001, -3.094496351999908],
              [130.578461134, -3.122816664999959],
              [130.5879012380001, -3.129489841999941],
              [130.59197024800005, -3.138848565999922],
              [130.59937584700003, -3.173028252999927],
              [130.60222415500004, -3.180108330999929],
              [130.62224368600005, -3.21257903399993],
              [130.63103274800005, -3.252699476999908],
              [130.6328231130001, -3.337823174999926],
              [130.6372176440001, -3.353610934999949],
              [130.65593509200005, -3.380954684999949],
              [130.66032962300005, -3.392754815999922],
              [130.66667728000004, -3.40357838299991],
              [130.6826278000001, -3.406426690999922],
              [130.72234134200005, -3.403252862999921],
              [130.76148522200003, -3.405857028999947],
              [130.7929793630001, -3.416436455999929],
              [130.81657962300005, -3.434258721999925],
              [130.83155358200008, -3.457940362999921],
              [130.810883009, -3.464939059999949],
              [130.81080162900003, -3.484551690999922],
              [130.8193465500001, -3.50514088299991],
              [130.831390821, -3.526462497999944],
              [130.86280358200008, -3.557305596999925],
              [130.87322024800005, -3.573988539999959],
            ],
          ],
          [
            [
              [131.59937584700003, -2.634860934999949],
              [131.6259871750001, -2.619561455999929],
              [131.63990319100003, -2.613702080999929],
              [131.654633009, -2.613213799999926],
              [131.64405358200008, -2.628676039999959],
              [131.62256920700008, -2.643649997999944],
              [131.5981551440001, -2.653903903999947],
              [131.57886803500003, -2.656019789999959],
              [131.57252037900003, -2.651055596999925],
              [131.57935631600003, -2.644626559999949],
              [131.59937584700003, -2.634860934999949],
            ],
          ],
          [
            [
              [108.29371178500003, -2.848402601999908],
              [108.28874759200005, -2.866631768999923],
              [108.27914472700007, -2.88014088299991],
              [108.27003014400003, -2.890801690999922],
              [108.26579837300005, -2.899590752999927],
              [108.25668379000007, -2.926202080999929],
              [108.21558678500003, -2.978692315999922],
              [108.20435631600003, -3.005466403999947],
              [108.20492597700007, -3.014580987999921],
              [108.21021569100003, -3.030450127999927],
              [108.21062259200005, -3.039646091999941],
              [108.20777428500003, -3.049411716999941],
              [108.19939212300005, -3.068617445999962],
              [108.19752037900003, -3.077080987999921],
              [108.19532311300003, -3.081475518999923],
              [108.19068444100003, -3.087497653999947],
              [108.18604576900003, -3.095472914999959],
              [108.18384850400003, -3.10475025799991],
              [108.18767337300005, -3.112074476999908],
              [108.20492597700007, -3.125909112999921],
              [108.21062259200005, -3.135837497999944],
              [108.18767337300005, -3.136895440999922],
              [108.15219160200007, -3.152439059999949],
              [108.13209069100003, -3.156345309999949],
              [108.10873457100007, -3.157159112999921],
              [108.09083092500003, -3.16139088299991],
              [108.07911217500003, -3.171807549999926],
              [108.07398522200003, -3.190362237999921],
              [108.07398522200003, -3.226006768999923],
              [108.06413821700005, -3.231052341999941],
              [108.03614342500003, -3.232028903999947],
              [108.01197350400003, -3.236504815999922],
              [107.99398847700007, -3.242445570999962],
              [107.98096764400003, -3.239841403999947],
              [107.97095787900003, -3.217705987999921],
              [107.96973717500003, -3.172133070999962],
              [107.96607506600003, -3.150974216999941],
              [107.94141686300003, -3.13445403399993],
              [107.88843834700003, -3.087497653999947],
              [107.89047285200007, -3.086114190999922],
              [107.89136803500003, -3.079278252999927],
              [107.88917076900003, -3.06959400799991],
              [107.88217207100007, -3.060153903999947],
              [107.87045332100007, -3.051690362999921],
              [107.86500084700003, -3.052666924999926],
              [107.85906009200005, -3.057305596999925],
              [107.84473717500003, -3.060153903999947],
              [107.82545006600003, -3.066176039999959],
              [107.82545006600003, -3.080661716999941],
              [107.84115644600007, -3.107842705999929],
              [107.84180748800003, -3.145440362999921],
              [107.81519616000003, -3.16725025799991],
              [107.75314994000007, -3.198455191999926],
              [107.68627137700003, -3.198206957999957],
              [107.65883946100007, -3.232633893999946],
              [107.63139902600005, -3.240863765999961],
              [107.60279400700006, -3.228857672999936],
              [107.59449787800003, -3.206238452999912],
              [107.60526631300007, -3.176545423999926],
              [107.64079837300005, -3.132582289999959],
              [107.64258873800003, -3.128350518999923],
              [107.64039147200003, -3.121677341999941],
              [107.63559004000007, -3.117608330999929],
              [107.63111412900003, -3.11451588299991],
              [107.62468509200005, -3.105401299999926],
              [107.59791100400003, -3.083916924999926],
              [107.59359785200007, -3.074965101999908],
              [107.59343509200005, -3.063164971999925],
              [107.59449303500003, -3.05046965899993],
              [107.59424889400003, -3.039646091999941],
              [107.59034264400003, -3.029229424999926],
              [107.58521569100003, -3.020277601999908],
              [107.58106530000003, -3.010674737999921],
              [107.58057701900003, -2.997979424999926],
              [107.58594811300003, -2.98560963299991],
              [107.60434004000007, -2.964043877999927],
              [107.60840905000003, -2.953871351999908],
              [107.61101321700005, -2.917901299999926],
              [107.60531660200007, -2.91375090899993],
              [107.58741295700003, -2.916680596999925],
              [107.56267337300005, -2.927666924999926],
              [107.55298912900003, -2.927992445999962],
              [107.54712975400003, -2.916680596999925],
              [107.54908287900003, -2.904961846999925],
              [107.55795332100007, -2.893975518999923],
              [107.57056725400003, -2.885837497999944],
              [107.58399498800003, -2.88250090899993],
              [107.60336347700007, -2.871026299999926],
              [107.60962975400003, -2.843682549999926],
              [107.60572350400003, -2.81178150799991],
              [107.59424889400003, -2.786309502999927],
              [107.60710696700005, -2.78093840899993],
              [107.62305748800003, -2.770603122999944],
              [107.63672936300003, -2.758558851999908],
              [107.64258873800003, -2.748467705999929],
              [107.63868248800003, -2.684991143999923],
              [107.65455162900003, -2.584893487999921],
              [107.67025800900007, -2.561455987999921],
              [107.71143639400003, -2.552911065999922],
              [107.72779381600003, -2.553155205999929],
              [107.75660241000003, -2.560642184999949],
              [107.77295983200003, -2.560316664999959],
              [107.78907311300003, -2.553806247999944],
              [107.81836998800003, -2.531914971999925],
              [107.83432050900007, -2.52507903399993],
              [107.84815514400003, -2.549899997999944],
              [107.88347415500004, -2.564222914999959],
              [107.91968834700003, -2.568617445999962],
              [107.93620853000004, -2.563571872999944],
              [107.98845462300005, -2.574151299999926],
              [108.00513756600003, -2.580254815999922],
              [108.01400800900007, -2.59107838299991],
              [108.03239993600005, -2.642347914999959],
              [108.03980553500003, -2.642347914999959],
              [108.04623457100007, -2.61492278399993],
              [108.05307050900007, -2.60279713299991],
              [108.06657962300005, -2.594496351999908],
              [108.09791100400003, -2.608168226999908],
              [108.10417728000004, -2.612399997999944],
              [108.11451256600003, -2.630629164999959],
              [108.11841881600003, -2.634942315999922],
              [108.13559004000007, -2.639255466999941],
              [108.14958743600005, -2.650323174999926],
              [108.15894616000003, -2.665785414999959],
              [108.16277103000004, -2.68328215899993],
              [108.18279056100005, -2.67351653399993],
              [108.19776451900003, -2.678155205999929],
              [108.26726321700005, -2.757419528999947],
              [108.27613366000003, -2.793877862999921],
              [108.29086347700007, -2.828708591999941],
              [108.29371178500003, -2.848402601999908],
            ],
          ],
          [
            [
              [134.58122806100005, -2.416436455999929],
              [134.58366946700005, -2.438409112999921],
              [134.58025149800005, -2.445082289999959],
              [134.5669051440001, -2.45045338299991],
              [134.54965254, -2.451348565999922],
              [134.53728274800005, -2.445733330999929],
              [134.53443444100003, -2.435642184999949],
              [134.54639733200008, -2.422621351999908],
              [134.5214949880001, -2.406670830999929],
              [134.524261915, -2.39226653399993],
              [134.5537215500001, -2.367364190999922],
              [134.56023196700005, -2.351495049999926],
              [134.56421959700003, -2.329847914999959],
              [134.5669051440001, -2.292901299999926],
              [134.57683353000004, -2.29851653399993],
              [134.58130944100003, -2.30787525799991],
              [134.58228600400003, -2.319756768999923],
              [134.58122806100005, -2.332696221999925],
              [134.58122806100005, -2.416436455999929],
            ],
          ],
          [
            [
              [134.38502037900003, -2.00359465899993],
              [134.3974715500001, -2.005791924999926],
              [134.4106551440001, -2.012465101999908],
              [134.42156009200005, -2.022230726999908],
              [134.42652428500003, -2.033298434999949],
              [134.4262801440001, -2.039727471999925],
              [134.4243270190001, -2.045993747999944],
              [134.3974715500001, -2.091973565999922],
              [134.39014733200008, -2.131442966999941],
              [134.3774520190001, -2.149834893999923],
              [134.3598738940001, -2.153252862999921],
              [134.3403426440001, -2.135349216999941],
              [134.332367384, -2.111097914999959],
              [134.33326256600003, -2.08326588299991],
              [134.3403426440001, -2.055840752999927],
              [134.3505965500001, -2.032647393999923],
              [134.35670006600003, -2.022881768999923],
              [134.36451256600003, -2.013767184999949],
              [134.37378991000003, -2.006931247999944],
              [134.38502037900003, -2.00359465899993],
            ],
          ],
          [
            [
              [126.06910241000003, -2.38445403399993],
              [126.07447350400003, -2.406508070999962],
              [126.08423912900003, -2.423923434999949],
              [126.08806399800005, -2.44109465899993],
              [126.07585696700005, -2.462985934999949],
              [126.04615319100003, -2.474216403999947],
              [126.01343834700003, -2.459567966999941],
              [125.98454837300005, -2.43132903399993],
              [125.96599368600005, -2.402113539999959],
              [125.95777428500003, -2.369235934999949],
              [125.95476321700005, -2.302178643999923],
              [125.94613691500001, -2.271742445999962],
              [125.93726647200003, -2.260837497999944],
              [125.91187584700003, -2.239678643999923],
              [125.90455162900003, -2.231377862999921],
              [125.90040123800009, -2.217705987999921],
              [125.89771569100003, -2.169366143999923],
              [125.88770592500009, -2.142347914999959],
              [125.873383009, -2.115492445999962],
              [125.86255944100003, -2.086602471999925],
              [125.86353600400003, -2.053317966999941],
              [125.86996504000001, -2.035577080999929],
              [125.87940514400009, -2.018487237999921],
              [125.90259850400003, -1.987888278999947],
              [125.916351759, -1.97389088299991],
              [125.92457116000003, -1.968194268999923],
              [125.93336022200003, -1.96453215899993],
              [125.94459069100003, -1.965427341999941],
              [125.95525149800005, -1.971123955999929],
              [125.98536217500009, -1.993747653999947],
              [125.99341881600003, -2.00359465899993],
              [125.99878991000003, -2.015232028999947],
              [126.00098717500009, -2.028252862999921],
              [125.99732506600003, -2.055352471999925],
              [125.97877037900003, -2.108168226999908],
              [125.97282962300005, -2.135349216999941],
              [125.97722415500004, -2.180352471999925],
              [126.06511478000004, -2.363946221999925],
              [126.06910241000003, -2.38445403399993],
            ],
          ],
          [
            [
              [123.85743248800009, -1.950372002999927],
              [123.86443118600005, -1.989434502999927],
              [123.86931399800005, -1.998142184999949],
              [123.85621178500003, -1.992445570999962],
              [123.84782962300005, -1.995538018999923],
              [123.84058678500003, -2.00164153399993],
              [123.83179772200003, -2.004978122999944],
              [123.80909264400009, -1.99968840899993],
              [123.79420006600003, -1.992120049999926],
              [123.78736412900003, -1.980645440999922],
              [123.77328535200002, -1.922621351999908],
              [123.77173912900003, -1.895603122999944],
              [123.78736412900003, -1.873955987999921],
              [123.84473717500009, -1.928643487999921],
              [123.85238691500001, -1.93873463299991],
              [123.85743248800009, -1.950372002999927],
            ],
          ],
          [
            [
              [126.32911217500009, -1.819268487999921],
              [126.34148196700005, -1.82000090899993],
              [126.34522545700008, -1.81764088299991],
              [126.34449303500003, -1.818780205999929],
              [126.34327233200008, -1.829847914999959],
              [126.33594811300009, -1.837985934999949],
              [126.27214603000004, -1.867282809999949],
              [126.25806725400003, -1.869073174999926],
              [126.22348066500001, -1.867771091999941],
              [126.201508009, -1.870538018999923],
              [126.19044030000009, -1.873793226999908],
              [126.18572024800005, -1.877618096999925],
              [126.17994225400003, -1.88445403399993],
              [126.16700280000009, -1.885023695999962],
              [126.14478600400003, -1.881442966999941],
              [126.05909264400009, -1.888278903999947],
              [126.04997806100005, -1.89031340899993],
              [126.02426191500001, -1.901788018999923],
              [125.99073326900009, -1.900567315999922],
              [125.98023522200003, -1.901788018999923],
              [125.94849694100003, -1.922946872999944],
              [125.92758222700002, -1.931410414999959],
              [125.90821373800009, -1.925713799999926],
              [125.88770592500009, -1.909274997999944],
              [125.87175540500004, -1.902520440999922],
              [125.85596764400009, -1.903415622999944],
              [125.787445509, -1.918715101999908],
              [125.62029056100005, -1.915622653999947],
              [125.59986412900003, -1.918633721999925],
              [125.55274498800009, -1.932793877999927],
              [125.53109785200002, -1.935967705999929],
              [125.48340905000009, -1.935967705999929],
              [125.46851647200003, -1.937758070999962],
              [125.43213951900009, -1.949639580999929],
              [125.43799889400009, -1.932549737999921],
              [125.43970787900003, -1.913262627999927],
              [125.43775475400003, -1.895114841999941],
              [125.43213951900009, -1.881442966999941],
              [125.42335045700008, -1.875095309999949],
              [125.38062584700003, -1.854099216999941],
              [125.37183678500003, -1.858330987999921],
              [125.36638431100005, -1.877129815999922],
              [125.35645592500009, -1.881442966999941],
              [125.34880618600005, -1.877862237999921],
              [125.34205162900003, -1.869317315999922],
              [125.33716881600003, -1.859144789999959],
              [125.33529707100001, -1.850681247999944],
              [125.33814537900003, -1.828057549999926],
              [125.34693444100003, -1.810967705999929],
              [125.36207116000003, -1.80242278399993],
              [125.37794030000009, -1.799248955999929],
              [125.37891686300009, -1.789971612999921],
              [125.38404381600003, -1.781182549999926],
              [125.39063561300009, -1.775974216999941],
              [125.40211022200003, -1.77467213299991],
              [125.40967858200008, -1.779229424999926],
              [125.42212975400003, -1.794122002999927],
              [125.43083743600005, -1.798272393999923],
              [125.44019616000003, -1.798028252999927],
              [125.45948326900009, -1.79265715899993],
              [125.47413170700008, -1.781182549999926],
              [125.48324629000001, -1.776950778999947],
              [125.48747806100005, -1.782403252999927],
              [125.48780358200008, -1.790215752999927],
              [125.48910566500001, -1.797784112999921],
              [125.49195397200003, -1.803399346999925],
              [125.49708092500009, -1.805759372999944],
              [125.55884850400003, -1.798028252999927],
              [125.58985436300009, -1.799086195999962],
              [125.61036217500009, -1.813164971999925],
              [125.625336134, -1.80982838299991],
              [125.70289147200003, -1.819268487999921],
              [125.71273847700002, -1.817803643999923],
              [125.72396894600001, -1.814060153999947],
              [125.73487389400009, -1.808689059999949],
              [125.75562584700003, -1.794528903999947],
              [125.76563561300009, -1.793715101999908],
              [125.78785241000003, -1.799493096999925],
              [125.82886803500003, -1.801527601999908],
              [125.94613691500001, -1.785821221999925],
              [125.99341881600003, -1.785821221999925],
              [126.11670983200008, -1.805759372999944],
              [126.28882897200003, -1.813164971999925],
              [126.32911217500009, -1.819268487999921],
            ],
          ],
          [
            [
              [123.13282311300009, -1.76531340899993],
              [123.14323978000004, -1.775485934999949],
              [123.15154056100005, -1.798760674999926],
              [123.15284264400009, -1.823825778999947],
              [123.14242597700002, -1.839776299999926],
              [123.13013756600003, -1.846774997999944],
              [123.11703535200002, -1.857842705999929],
              [123.10645592500009, -1.871189059999949],
              [123.10206139400009, -1.884860934999949],
              [123.09669030000009, -1.895277601999908],
              [123.08472741000003, -1.901788018999923],
              [123.07276451900009, -1.90162525799991],
              [123.06739342500009, -1.891696872999944],
              [123.07007897200003, -1.840752862999921],
              [123.07447350400003, -1.818942966999941],
              [123.090179884, -1.779961846999925],
              [123.09343509200005, -1.768243096999925],
              [123.09457441500001, -1.755059502999927],
              [123.10206139400009, -1.748467705999929],
              [123.11744225400003, -1.752862237999921],
              [123.13103274800005, -1.760918877999927],
              [123.13282311300009, -1.76531340899993],
            ],
          ],
          [
            [
              [134.23585045700008, -1.738539320999962],
              [134.24822024800005, -1.743910414999959],
              [134.2500106130001, -1.761488539999959],
              [134.24480228000004, -1.796075127999927],
              [134.2363387380001, -1.799411716999941],
              [134.21998131600003, -1.812595309999949],
              [134.2080184250001, -1.826836846999925],
              [134.22388756600003, -1.849053643999923],
              [134.21241295700008, -1.884209893999923],
              [134.19166100400003, -1.921482028999947],
              [134.175140821, -1.943454684999949],
              [134.16163170700008, -1.895114841999941],
              [134.16163170700008, -1.877536716999941],
              [134.1689559250001, -1.829847914999959],
              [134.22681725400003, -1.744235934999949],
              [134.23585045700008, -1.738539320999962],
            ],
          ],
          [
            [
              [130.38648522200003, -1.888278903999947],
              [130.35499108200008, -1.912204684999949],
              [130.3442488940001, -1.928480726999908],
              [130.43433678500003, -1.963311455999929],
              [130.436859571, -1.976332289999959],
              [130.42986087300005, -1.980238539999959],
              [130.4179793630001, -1.980726820999962],
              [130.4062606130001, -1.983819268999923],
              [130.3984481130001, -1.989678643999923],
              [130.393890821, -1.994805596999925],
              [130.38990319100003, -2.000664971999925],
              [130.38306725400003, -2.008396091999941],
              [130.3735457690001, -2.012790622999944],
              [130.36548912900003, -2.008558851999908],
              [130.35759524800005, -2.00164153399993],
              [130.34839928500003, -1.998142184999949],
              [130.34001712300005, -1.99342213299991],
              [130.33952884200005, -1.983330987999921],
              [130.34245853000004, -1.973565362999921],
              [130.34498131600003, -1.970147393999923],
              [130.34302819100003, -1.964939059999949],
              [130.34107506600003, -1.955336195999962],
              [130.33814537900003, -1.949639580999929],
              [130.32699629, -1.960544528999947],
              [130.30884850400003, -1.99146900799991],
              [130.30054772200003, -1.998142184999949],
              [130.2871199880001, -2.004571221999925],
              [130.27523847700002, -2.019138278999947],
              [130.264984571, -2.035251559999949],
              [130.25611412900003, -2.045830987999921],
              [130.22339928500003, -2.057793877999927],
              [130.1543074880001, -2.058770440999922],
              [130.12647545700008, -2.066989841999941],
              [130.119476759, -2.059014580999929],
              [130.11304772200003, -2.053155205999929],
              [130.1064559250001, -2.048760674999926],
              [130.098480665, -2.045830987999921],
              [130.10857181100005, -2.040459893999923],
              [130.11280358200008, -2.038995049999926],
              [130.0869246750001, -2.026136976999908],
              [130.06592858200008, -2.022637627999927],
              [130.01286868600005, -2.025485934999949],
              [129.96892337300005, -2.004978122999944],
              [129.92554772200003, -2.003838799999926],
              [129.9170028000001, -2.001560153999947],
              [129.90406334700003, -1.993259372999944],
              [129.873383009, -1.982028903999947],
              [129.85621178500003, -1.969496351999908],
              [129.8408309250001, -1.964043877999927],
              [129.834320509, -1.960137627999927],
              [129.8164168630001, -1.940850518999923],
              [129.8105574880001, -1.935967705999929],
              [129.7680770190001, -1.918145440999922],
              [129.74382571700005, -1.912204684999949],
              [129.7329207690001, -1.903741143999923],
              [129.7148543630001, -1.881442966999941],
              [129.74529056100005, -1.863457940999922],
              [129.87256920700008, -1.819268487999921],
              [129.87623131600003, -1.815850518999923],
              [129.87720787900003, -1.811944268999923],
              [129.87761478000004, -1.80828215899993],
              [129.8794051440001, -1.805759372999944],
              [129.89527428500003, -1.796807549999926],
              [129.90503991000003, -1.793715101999908],
              [129.93873131600003, -1.789239190999922],
              [129.95875084700003, -1.780694268999923],
              [130.01197350400003, -1.750176690999922],
              [130.03077233200008, -1.74382903399993],
              [130.0517684250001, -1.739434502999927],
              [130.096039259, -1.735446872999944],
              [130.137054884, -1.725274346999925],
              [130.160492384, -1.72429778399993],
              [130.22046959700003, -1.73601653399993],
              [130.23170006600003, -1.734307549999926],
              [130.24822024800005, -1.718845309999949],
              [130.26775149800005, -1.704522393999923],
              [130.2890731130001, -1.692152601999908],
              [130.32154381600003, -1.679131768999923],
              [130.33228600400003, -1.676690362999921],
              [130.34294681100005, -1.676690362999921],
              [130.35336347700002, -1.680108330999929],
              [130.35718834700003, -1.694919528999947],
              [130.35181725400003, -1.741387627999927],
              [130.4062606130001, -1.77898528399993],
              [130.4179793630001, -1.793552341999941],
              [130.43132571700005, -1.814629815999922],
              [130.4399520190001, -1.835707289999959],
              [130.43775475400003, -1.850681247999944],
              [130.428070509, -1.855726820999962],
              [130.4204207690001, -1.855645440999922],
              [130.41570071700005, -1.858086846999925],
              [130.41179446700005, -1.881768487999921],
              [130.40577233200008, -1.885023695999962],
              [130.3969832690001, -1.885430596999925],
              [130.38648522200003, -1.888278903999947],
            ],
          ],
          [
            [
              [125.314789259, -1.77898528399993],
              [125.31983483200008, -1.793389580999929],
              [125.32162519600001, -1.864353122999944],
              [125.31836998800009, -1.882582289999959],
              [125.30884850400003, -1.884942315999922],
              [125.27393639400009, -1.873955987999921],
              [125.25123131600003, -1.873467705999929],
              [125.18824303500003, -1.881442966999941],
              [125.17953535200002, -1.880303643999923],
              [125.15845787900003, -1.875095309999949],
              [125.14763431100005, -1.873955987999921],
              [125.13754316500001, -1.876885674999926],
              [125.12094160200002, -1.890720309999949],
              [125.11003665500004, -1.895114841999941],
              [125.09115644600001, -1.893649997999944],
              [125.07081139400009, -1.888848565999922],
              [125.05046634200005, -1.88795338299991],
              [125.03101647200003, -1.898532809999949],
              [125.02263431100005, -1.916273695999962],
              [125.02116946700005, -1.933363539999959],
              [125.01351972700002, -1.944268487999921],
              [124.98658287900003, -1.943454684999949],
              [124.95923912900003, -1.922458591999941],
              [124.94629967500009, -1.91961028399993],
              [124.91456139400009, -1.922458591999941],
              [124.89112389400009, -1.91725025799991],
              [124.85328209700003, -1.896905205999929],
              [124.82829837300005, -1.895114841999941],
              [124.78598066500001, -1.907972914999959],
              [124.71159915500004, -1.95240650799991],
              [124.67115319100003, -1.970147393999923],
              [124.58171634200005, -1.994235934999949],
              [124.56519616000003, -2.00164153399993],
              [124.55445397200003, -2.004978122999944],
              [124.54322350400003, -2.006524346999925],
              [124.51417076900009, -2.004978122999944],
              [124.45281009200005, -2.012465101999908],
              [124.43091881600003, -2.011651299999926],
              [124.40601647200003, -2.004082940999922],
              [124.39722741000003, -1.991387627999927],
              [124.39258873800009, -1.97429778399993],
              [124.33594811300009, -1.888116143999923],
              [124.32911217500009, -1.87078215899993],
              [124.33139082100001, -1.826918226999908],
              [124.338226759, -1.807793877999927],
              [124.35254967500009, -1.789239190999922],
              [124.36890709700003, -1.750746351999908],
              [124.37305748800009, -1.705010674999926],
              [124.38493899800005, -1.667901299999926],
              [124.42481530000009, -1.655450127999927],
              [124.44239342500009, -1.654392184999949],
              [124.488617384, -1.645684502999927],
              [124.50326582100001, -1.63836028399993],
              [124.51807701900009, -1.62623463299991],
              [124.52654056100005, -1.625664971999925],
              [124.52955162900003, -1.635674737999921],
              [124.52784264400009, -1.655450127999927],
              [124.55632571700005, -1.641208591999941],
              [124.59278405000009, -1.633233330999929],
              [124.63282311300009, -1.631117445999962],
              [124.68767337300005, -1.63836028399993],
              [124.72901451900009, -1.650567315999922],
              [124.74293053500003, -1.658868096999925],
              [124.75700931100005, -1.665134372999944],
              [124.81519616000003, -1.669691664999959],
              [124.87159264400009, -1.69304778399993],
              [124.93816165500004, -1.703871351999908],
              [124.94361412900003, -1.702894789999959],
              [124.95069420700008, -1.697686455999929],
              [124.95557701900009, -1.696465752999927],
              [124.96070397200003, -1.698337497999944],
              [124.96810957100001, -1.707289320999962],
              [124.97291100400003, -1.710137627999927],
              [125.00017337300005, -1.716729424999926],
              [125.01042728000004, -1.717461846999925],
              [125.02295983200008, -1.723077080999929],
              [125.03467858200008, -1.752129815999922],
              [125.04802493600005, -1.76531340899993],
              [125.04981530000009, -1.760511976999908],
              [125.05355879000001, -1.756524346999925],
              [125.05543053500003, -1.75164153399993],
              [125.06763756600003, -1.760430596999925],
              [125.08155358200008, -1.764743747999944],
              [125.096039259, -1.764092705999929],
              [125.11003665500004, -1.758477471999925],
              [125.10035241000003, -1.753106377999927],
              [125.09644616000003, -1.75164153399993],
              [125.10303795700008, -1.736993096999925],
              [125.11491946700005, -1.692152601999908],
              [125.12029056100005, -1.682793877999927],
              [125.13070722700002, -1.684991143999923],
              [125.13746178500003, -1.689629815999922],
              [125.14226321700005, -1.694268487999921],
              [125.15015709700003, -1.697686455999929],
              [125.18523196700005, -1.703871351999908],
              [125.19532311300009, -1.72193775799991],
              [125.19646243600005, -1.744235934999949],
              [125.19141686300009, -1.782403252999927],
              [125.19678795700008, -1.78875090899993],
              [125.20834394600001, -1.791110934999949],
              [125.22022545700008, -1.788995049999926],
              [125.22543379000001, -1.782403252999927],
              [125.22730553500003, -1.773044528999947],
              [125.23161868600005, -1.76140715899993],
              [125.23975670700008, -1.744805596999925],
              [125.25342858200008, -1.732842705999929],
              [125.26872806100005, -1.72820403399993],
              [125.28402754000001, -1.731052341999941],
              [125.29810631600003, -1.741387627999927],
              [125.30005944100003, -1.750909112999921],
              [125.29363040500004, -1.760918877999927],
              [125.28492272200003, -1.771416924999926],
              [125.28077233200008, -1.782403252999927],
              [125.28484134200005, -1.785902601999908],
              [125.30583743600005, -1.777927341999941],
              [125.314789259, -1.77898528399993],
            ],
          ],
          [
            [
              [136.848480665, -1.76531340899993],
              [136.899261915, -1.79461028399993],
              [136.8994246750001, -1.799493096999925],
              [136.88835696700005, -1.802504164999959],
              [136.8813582690001, -1.816176039999959],
              [136.87232506600003, -1.819268487999921],
              [136.79420006600003, -1.820733330999929],
              [136.7597762380001, -1.826104424999926],
              [136.729828321, -1.826104424999926],
              [136.7255965500001, -1.829847914999959],
              [136.72250410200002, -1.83953215899993],
              [136.71501712300005, -1.847263278999947],
              [136.70484459700003, -1.852227471999925],
              [136.68287194100003, -1.856377862999921],
              [136.6743270190001, -1.861911716999941],
              [136.666351759, -1.86842213299991],
              [136.6567488940001, -1.873955987999921],
              [136.644867384, -1.876397393999923],
              [136.55298912900003, -1.867120049999926],
              [136.532562696, -1.867771091999941],
              [136.532562696, -1.873955987999921],
              [136.5400496750001, -1.879571221999925],
              [136.54615319100003, -1.889092705999929],
              [136.54639733200008, -1.897881768999923],
              [136.53630618600005, -1.901788018999923],
              [136.52491295700008, -1.899997653999947],
              [136.50660241000003, -1.890801690999922],
              [136.4985457690001, -1.888278903999947],
              [136.4863387380001, -1.888441664999959],
              [136.4658309250001, -1.893731377999927],
              [136.453949415, -1.895114841999941],
              [136.4438582690001, -1.892836195999962],
              [136.4130965500001, -1.881442966999941],
              [136.39714603000004, -1.87818775799991],
              [136.3574324880001, -1.864027601999908],
              [136.33765709700003, -1.860935153999947],
              [136.3320418630001, -1.86296965899993],
              [136.32300866000003, -1.871840101999908],
              [136.31714928500003, -1.873955987999921],
              [136.31706790500004, -1.87468840899993],
              [136.30844160200002, -1.876071872999944],
              [136.30030358200008, -1.87623463299991],
              [136.30046634200005, -1.873955987999921],
              [136.29029381600003, -1.880466403999947],
              [136.28386478000004, -1.886976820999962],
              [136.278656446, -1.89576588299991],
              [136.27320397200003, -1.909356377999927],
              [136.26636803500003, -1.909356377999927],
              [136.26091556100005, -1.896905205999929],
              [136.25269616000003, -1.892347914999959],
              [136.2426863940001, -1.894463799999926],
              [136.23218834700003, -1.901788018999923],
              [136.21607506600003, -1.873304945999962],
              [136.18482506600003, -1.855889580999929],
              [136.10865319100003, -1.839776299999926],
              [136.09831790500004, -1.839450778999947],
              [136.0771590500001, -1.840915622999944],
              [136.06714928500003, -1.839776299999926],
              [136.05811608200008, -1.83521900799991],
              [136.04322350400003, -1.822035414999959],
              [136.03638756600003, -1.819268487999921],
              [136.0141707690001, -1.81804778399993],
              [135.99756920700008, -1.814385674999926],
              [135.98414147200003, -1.808200778999947],
              [135.957367384, -1.79225025799991],
              [135.91236412900003, -1.771661065999922],
              [135.90259850400003, -1.768731377999927],
              [135.894867384, -1.75750090899993],
              [135.87623131600003, -1.753676039999959],
              [135.834320509, -1.75164153399993],
              [135.81568444100003, -1.744724216999941],
              [135.78386478000004, -1.727715752999927],
              [135.74878991000003, -1.723565362999921],
              [135.741547071, -1.720472914999959],
              [135.7285262380001, -1.706963799999926],
              [135.71802819100003, -1.703301690999922],
              [135.70582116000003, -1.70476653399993],
              [135.69092858200008, -1.710137627999927],
              [135.67994225400003, -1.705336195999962],
              [135.668304884, -1.694105726999908],
              [135.65609785200002, -1.690199476999908],
              [135.64616946700005, -1.693129164999959],
              [135.63160241000003, -1.699883721999925],
              [135.6162215500001, -1.704196872999944],
              [135.60474694100003, -1.700127862999921],
              [135.58082116000003, -1.684258721999925],
              [135.55453535200002, -1.68328215899993],
              [135.52662194100003, -1.686211846999925],
              [135.49789472700002, -1.682793877999927],
              [135.48389733200008, -1.674981377999927],
              [135.48023522200003, -1.666192315999922],
              [135.47868899800005, -1.655450127999927],
              [135.4712020190001, -1.641778252999927],
              [135.46599368600005, -1.64031340899993],
              [135.4492293630001, -1.642673434999949],
              [135.44320722700002, -1.641778252999927],
              [135.44068444100003, -1.635674737999921],
              [135.43962649800005, -1.626560153999947],
              [135.43620853000004, -1.618096612999921],
              [135.42652428500003, -1.614434502999927],
              [135.422211134, -1.610772393999923],
              [135.433929884, -1.603122653999947],
              [135.4497176440001, -1.596856377999927],
              [135.4575301440001, -1.597426039999959],
              [135.46355228000004, -1.58953215899993],
              [135.47730553500003, -1.589939059999949],
              [135.5830184250001, -1.613864841999941],
              [135.786468946, -1.628106377999927],
              [135.8559676440001, -1.643975518999923],
              [135.89673912900003, -1.648044528999947],
              [135.95728600400003, -1.631524346999925],
              [136.03248131600003, -1.651950778999947],
              [136.06031334700003, -1.641778252999927],
              [136.09888756600003, -1.654717705999929],
              [136.19125410200002, -1.653903903999947],
              [136.23218834700003, -1.662286065999922],
              [136.23698978000004, -1.666436455999929],
              [136.24561608200008, -1.678399346999925],
              [136.25269616000003, -1.682793877999927],
              [136.26351972700002, -1.683689059999949],
              [136.28785241000003, -1.682061455999929],
              [136.29704837300005, -1.686455987999921],
              [136.31177819100003, -1.697849216999941],
              [136.33269290500004, -1.709649346999925],
              [136.3681746750001, -1.72429778399993],
              [136.39031009200005, -1.725762627999927],
              [136.453949415, -1.717461846999925],
              [136.61890709700003, -1.73796965899993],
              [136.70460045700008, -1.730564059999949],
              [136.7231551440001, -1.734307549999926],
              [136.7607528000001, -1.748467705999929],
              [136.77686608200008, -1.75164153399993],
              [136.8144637380001, -1.754164320999962],
              [136.83082116000003, -1.758396091999941],
              [136.848480665, -1.76531340899993],
            ],
          ],
          [
            [
              [106.76905358200003, -2.560316664999959],
              [106.81544030000003, -2.560967705999929],
              [106.83326256600003, -2.566582940999922],
              [106.83326256600003, -2.580254815999922],
              [106.82642662900003, -2.586032809999949],
              [106.81869550900007, -2.586195570999962],
              [106.80974368600005, -2.58521900799991],
              [106.79908287900003, -2.587090752999927],
              [106.76596113400007, -2.605645440999922],
              [106.75538170700003, -2.608168226999908],
              [106.73804772200003, -2.614434502999927],
              [106.72193444100003, -2.629327080999929],
              [106.67481530000003, -2.699802341999941],
              [106.61198978000004, -2.87037525799991],
              [106.60377037900003, -2.910251559999949],
              [106.61304772200003, -2.942559502999927],
              [106.64893639400003, -2.963799737999921],
              [106.65992272200003, -2.965915622999944],
              [106.67432701900003, -2.966892184999949],
              [106.68295332100007, -2.970635674999926],
              [106.69255618600005, -2.979261976999908],
              [106.69825280000003, -2.988213799999926],
              [106.70582116000003, -2.995212497999944],
              [106.72087649800005, -2.997979424999926],
              [106.73845462300005, -3.004571221999925],
              [106.74577884200005, -3.020114841999941],
              [106.74496504000007, -3.03834400799991],
              [106.73829186300003, -3.053317966999941],
              [106.74756920700003, -3.068617445999962],
              [106.75196373800003, -3.073663018999923],
              [106.74447675900007, -3.080498955999929],
              [106.73568769600007, -3.076755466999941],
              [106.72828209700003, -3.082126559999949],
              [106.71957441500007, -3.090101820999962],
              [106.70728600400003, -3.094170830999929],
              [106.70036868600005, -3.092217705999929],
              [106.69369550900007, -3.088555596999925],
              [106.68702233200003, -3.086846612999921],
              [106.67066491000003, -3.096123955999929],
              [106.66529381600003, -3.092217705999929],
              [106.66130618600005, -3.08521900799991],
              [106.65577233200003, -3.080498955999929],
              [106.60124759200005, -3.071058851999908],
              [106.57374108200003, -3.076755466999941],
              [106.56641686300003, -3.101657809999949],
              [106.55648847700007, -3.096856377999927],
              [106.55274498800003, -3.094170830999929],
              [106.53223717500003, -3.105645440999922],
              [106.51710045700003, -3.094821872999944],
              [106.50757897200003, -3.072442315999922],
              [106.50440514400003, -3.049899997999944],
              [106.49968509200005, -3.038995049999926],
              [106.48902428500003, -3.030043226999908],
              [106.46705162900003, -3.01531340899993],
              [106.45899498800003, -3.004327080999929],
              [106.44703209700003, -2.981133721999925],
              [106.43604576900003, -2.970635674999926],
              [106.41651451900003, -2.965508721999925],
              [106.36866295700003, -2.966973565999922],
              [106.35035241000003, -2.960707289999959],
              [106.30201256600003, -2.913262627999927],
              [106.09400475400003, -2.840590101999908],
              [106.07390384200005, -2.836195570999962],
              [106.00245201900003, -2.830743096999925],
              [105.98650149800005, -2.821221612999921],
              [105.92253665500004, -2.715997002999927],
              [105.90756269600007, -2.674574476999908],
              [105.90162194100003, -2.628676039999959],
              [105.91236412900003, -2.58562590899993],
              [105.93262780000003, -2.541924737999921],
              [105.94434655000003, -2.498793226999908],
              [105.92888431100005, -2.45671965899993],
              [105.89747155000003, -2.436130466999941],
              [105.85938561300003, -2.420098565999922],
              [105.82878665500004, -2.395114841999941],
              [105.81902103000004, -2.347426039999959],
              [105.82553144600007, -2.318536065999922],
              [105.82593834700003, -2.307224216999941],
              [105.82341556100005, -2.297539971999925],
              [105.81470787900003, -2.282321872999944],
              [105.81055748800003, -2.265883070999962],
              [105.80079186300003, -2.245538018999923],
              [105.79859459700003, -2.234551690999922],
              [105.79908287900003, -2.20086028399993],
              [105.79574629000007, -2.171807549999926],
              [105.79029381600003, -2.159763278999947],
              [105.78044681100005, -2.150811455999929],
              [105.76441491000003, -2.142185153999947],
              [105.74756920700003, -2.13600025799991],
              [105.68873131600003, -2.127699476999908],
              [105.68384850400003, -2.125420830999929],
              [105.67367597700007, -2.11687590899993],
              [105.66944420700003, -2.114841403999947],
              [105.66309655000003, -2.115411065999922],
              [105.65219160200007, -2.120538018999923],
              [105.64828535200007, -2.121514580999929],
              [105.61622155000003, -2.117608330999929],
              [105.60743248800003, -2.114841403999947],
              [105.59376061300003, -2.103610934999949],
              [105.57764733200003, -2.077080987999921],
              [105.56576582100007, -2.066989841999941],
              [105.54224694100003, -2.081801039999959],
              [105.49122155000003, -2.098402601999908],
              [105.47022545700003, -2.108005466999941],
              [105.45036868600005, -2.122653903999947],
              [105.44109134200005, -2.123793226999908],
              [105.42188561300003, -2.121514580999929],
              [105.35694420700003, -2.121514580999929],
              [105.30640709700003, -2.135023695999962],
              [105.29835045700003, -2.131524346999925],
              [105.29314212300005, -2.12623463299991],
              [105.27149498800003, -2.094903252999927],
              [105.26791425900007, -2.087497653999947],
              [105.22982832100007, -2.070082289999959],
              [105.21290123800003, -2.066989841999941],
              [105.17896569100003, -2.069919528999947],
              [105.16114342500003, -2.07390715899993],
              [105.14747155000003, -2.080010674999926],
              [105.12794030000003, -2.04461028399993],
              [105.12549889400003, -2.004082940999922],
              [105.13591556100005, -1.965508721999925],
              [105.15430748800003, -1.935967705999929],
              [105.18360436300003, -1.916924737999921],
              [105.29835045700003, -1.873955987999921],
              [105.37566165500004, -1.821872653999947],
              [105.40235436300003, -1.783298434999949],
              [105.39454186300003, -1.73796965899993],
              [105.35523522200003, -1.715020440999922],
              [105.33545983200003, -1.697930596999925],
              [105.34302819100003, -1.690199476999908],
              [105.35108483200003, -1.68678150799991],
              [105.35132897200003, -1.678480726999908],
              [105.34603925900007, -1.658868096999925],
              [105.34986412900003, -1.648695570999962],
              [105.35914147200003, -1.64381275799991],
              [105.37029056100005, -1.640557549999926],
              [105.38021894600007, -1.634942315999922],
              [105.38379967500003, -1.629082940999922],
              [105.38933353000004, -1.613864841999941],
              [105.39454186300003, -1.607598565999922],
              [105.40015709700003, -1.606215101999908],
              [105.41285241000003, -1.607517184999949],
              [105.41871178500003, -1.604180596999925],
              [105.45964603000004, -1.562920830999929],
              [105.47169030000003, -1.558363539999959],
              [105.51807701900003, -1.55982838299991],
              [105.53679446700005, -1.555271091999941],
              [105.54639733200003, -1.549004815999922],
              [105.55372155000003, -1.541110934999949],
              [105.56576582100007, -1.531914971999925],
              [105.59408613400007, -1.525567315999922],
              [105.61101321700005, -1.540215752999927],
              [105.61890709700003, -1.565199476999908],
              [105.62110436300003, -1.590264580999929],
              [105.62875410200007, -1.614027601999908],
              [105.64844811300003, -1.633233330999929],
              [105.67497806100005, -1.647230726999908],
              [105.70289147200003, -1.655450127999927],
              [105.69141686300003, -1.671319268999923],
              [105.65170332100007, -1.706963799999926],
              [105.64975019600007, -1.721856377999927],
              [105.66309655000003, -1.739678643999923],
              [105.68181399800005, -1.755791924999926],
              [105.69556725400003, -1.76531340899993],
              [105.71509850400003, -1.773532809999949],
              [105.72820071700005, -1.772556247999944],
              [105.74122155000003, -1.767998955999929],
              [105.76099694100003, -1.76531340899993],
              [105.76563561300003, -1.768975518999923],
              [105.77263431100005, -1.78679778399993],
              [105.77808678500003, -1.79265715899993],
              [105.78541100400003, -1.794040622999944],
              [105.81275475400003, -1.79265715899993],
              [105.80469811300003, -1.772637627999927],
              [105.79167728000004, -1.753676039999959],
              [105.76099694100003, -1.720879815999922],
              [105.75098717500003, -1.703057549999926],
              [105.75082441500007, -1.683526299999926],
              [105.75757897200003, -1.645196221999925],
              [105.75464928500003, -1.642673434999949],
              [105.73707116000003, -1.614434502999927],
              [105.73389733200003, -1.605238539999959],
              [105.73170006600003, -1.589043877999927],
              [105.72974694100003, -1.580336195999962],
              [105.72396894600007, -1.56609465899993],
              [105.71664472700007, -1.55242278399993],
              [105.70728600400003, -1.540622653999947],
              [105.69556725400003, -1.531914971999925],
              [105.71998131600003, -1.524183851999908],
              [105.80909264400003, -1.525648695999962],
              [105.83432050900007, -1.517836195999962],
              [105.87574303500003, -1.489190362999921],
              [105.89429772200003, -1.490817966999941],
              [105.89437910200007, -1.490817966999941],
              [105.91374759200005, -1.494235934999949],
              [105.92172285200007, -1.504489841999941],
              [105.92750084700003, -1.518975518999923],
              [105.93946373800003, -1.535332940999922],
              [105.94760175900007, -1.538995049999926],
              [105.95883222700007, -1.539808851999908],
              [105.98047936300003, -1.53875090899993],
              [105.98707116000003, -1.542087497999944],
              [106.03394616000003, -1.57586028399993],
              [106.04151451900003, -1.583591403999947],
              [106.04558353000004, -1.594008070999962],
              [106.04444420700003, -1.604099216999941],
              [106.03443444100003, -1.613051039999959],
              [106.03191165500004, -1.62468840899993],
              [106.03191165500004, -1.665948174999926],
              [106.03549238400007, -1.678317966999941],
              [106.04371178500003, -1.686130466999941],
              [106.05290774800005, -1.691501559999949],
              [106.05933678500003, -1.696465752999927],
              [106.06373131600003, -1.705254815999922],
              [106.06934655000003, -1.723402601999908],
              [106.07300866000003, -1.730564059999949],
              [106.07894941500007, -1.736097914999959],
              [106.08570397200003, -1.740329684999949],
              [106.09107506600003, -1.745700778999947],
              [106.09343509200005, -1.755059502999927],
              [106.09449303500003, -1.767185153999947],
              [106.09839928500003, -1.776950778999947],
              [106.10580488400007, -1.783461195999962],
              [106.11793053500003, -1.785821221999925],
              [106.12696373800003, -1.790134372999944],
              [106.12647545700003, -1.799981377999927],
              [106.12273196700005, -1.811211846999925],
              [106.12134850400003, -1.819268487999921],
              [106.17457116000003, -1.879082940999922],
              [106.17945397200003, -1.888278903999947],
              [106.17481530000003, -1.898207289999959],
              [106.16236412900003, -1.963311455999929],
              [106.16260826900003, -2.007012627999927],
              [106.20069420700003, -2.178155205999929],
              [106.26417076900003, -2.351332289999959],
              [106.28907311300003, -2.393487237999921],
              [106.31885826900003, -2.43132903399993],
              [106.35401451900003, -2.462985934999949],
              [106.37086022200003, -2.47234465899993],
              [106.39616946700005, -2.48211028399993],
              [106.41911868600005, -2.484958591999941],
              [106.42920983200003, -2.473809502999927],
              [106.44109134200005, -2.471368096999925],
              [106.55339603000004, -2.510430596999925],
              [106.68295332100007, -2.53248463299991],
              [106.74838300900007, -2.557061455999929],
              [106.76905358200003, -2.560316664999959],
            ],
          ],
          [
            [
              [135.2856551440001, -1.476739190999922],
              [135.29664147200003, -1.480401299999926],
              [135.305023634, -1.485284112999921],
              [135.31568444100003, -1.487888278999947],
              [135.3339949880001, -1.484144789999959],
              [135.311859571, -1.510186455999929],
              [135.2754012380001, -1.522230726999908],
              [135.186859571, -1.525648695999962],
              [135.10434004, -1.518243096999925],
              [135.09685306100005, -1.508558851999908],
              [135.09839928500003, -1.489027601999908],
              [135.10906009200005, -1.473809502999927],
              [135.12867272200003, -1.476739190999922],
              [135.1508895190001, -1.483005466999941],
              [135.20476321700005, -1.477715752999927],
              [135.2275496750001, -1.48756275799991],
              [135.2392684250001, -1.489678643999923],
              [135.2856551440001, -1.476739190999922],
            ],
          ],
          [
            [
              [128.14519290500004, -1.594008070999962],
              [128.15902754, -1.636976820999962],
              [128.15113366000003, -1.669691664999959],
              [128.12647545700008, -1.693617445999962],
              [128.09058678500003, -1.710137627999927],
              [128.05152428500003, -1.71453215899993],
              [127.93344160200002, -1.682793877999927],
              [127.91309655000009, -1.682386976999908],
              [127.87696373800009, -1.693454684999949],
              [127.85474694100003, -1.696465752999927],
              [127.70329837300005, -1.690199476999908],
              [127.68458092500009, -1.695570570999962],
              [127.66968834700003, -1.707289320999962],
              [127.65805097700002, -1.719008070999962],
              [127.64869225400003, -1.72429778399993],
              [127.56885826900009, -1.732191664999959],
              [127.53272545700008, -1.731377862999921],
              [127.49415123800009, -1.717461846999925],
              [127.43262780000009, -1.686455987999921],
              [127.37867272200003, -1.632256768999923],
              [127.38306725400003, -1.61060963299991],
              [127.39861087300005, -1.57350025799991],
              [127.39828535200002, -1.554294528999947],
              [127.39649498800009, -1.54029713299991],
              [127.39926191500001, -1.527601820999962],
              [127.41285241000003, -1.51140715899993],
              [127.40357506600003, -1.491631768999923],
              [127.40943444100003, -1.473402601999908],
              [127.42009524800005, -1.45631275799991],
              [127.42579186300009, -1.439385674999926],
              [127.42839603000004, -1.415134372999944],
              [127.43531334700003, -1.412204684999949],
              [127.45997155000009, -1.428887627999927],
              [127.48170006600003, -1.448174737999921],
              [127.48780358200008, -1.449965101999908],
              [127.49390709700003, -1.444756768999923],
              [127.51099694100003, -1.421319268999923],
              [127.51465905000009, -1.412204684999949],
              [127.52149498800009, -1.401055596999925],
              [127.62452233200008, -1.329522393999923],
              [127.63428795700008, -1.328708591999941],
              [127.71355228000004, -1.34498463299991],
              [127.74105879000001, -1.35475025799991],
              [127.76539147200003, -1.36842213299991],
              [127.77588951900009, -1.38445403399993],
              [127.78484134200005, -1.402439059999949],
              [127.80567467500009, -1.41920338299991],
              [127.83082116000003, -1.431573174999926],
              [127.85173587300005, -1.436293226999908],
              [127.85840905000009, -1.434014580999929],
              [127.87549889400009, -1.424004815999922],
              [127.88575280000009, -1.422051690999922],
              [127.89893639400009, -1.426690362999921],
              [127.91911868600005, -1.445733330999929],
              [127.92986087300005, -1.449965101999908],
              [128.00806725400003, -1.504571221999925],
              [128.02662194100003, -1.529473565999922],
              [128.03532962300005, -1.53875090899993],
              [128.04672285200002, -1.546319268999923],
              [128.070648634, -1.556735934999949],
              [128.08033287900003, -1.562920830999929],
              [128.08961022200003, -1.567315362999921],
              [128.09839928500003, -1.56568775799991],
              [128.10670006600003, -1.561944268999923],
              [128.11451256600003, -1.55982838299991],
              [128.126312696, -1.563653252999927],
              [128.13461347700002, -1.572849216999941],
              [128.14519290500004, -1.594008070999962],
            ],
          ],
          [
            [
              [127.68995201900009, -1.213799737999921],
              [127.697601759, -1.231133721999925],
              [127.69288170700008, -1.249444268999923],
              [127.68067467500009, -1.264255466999941],
              [127.66602623800009, -1.271905205999929],
              [127.64584394600001, -1.270603122999944],
              [127.59034264400009, -1.243910414999959],
              [127.55258222700002, -1.236911716999941],
              [127.53150475400003, -1.237888278999947],
              [127.52214603000004, -1.24773528399993],
              [127.51490319100003, -1.262139580999929],
              [127.49830162900003, -1.259209893999923],
              [127.478851759, -1.249607028999947],
              [127.46338951900009, -1.243910414999959],
              [127.46070397200003, -1.235772393999923],
              [127.47388756600003, -1.217705987999921],
              [127.50163821700005, -1.189385674999926],
              [127.51644941500001, -1.179294528999947],
              [127.53150475400003, -1.172621351999908],
              [127.547211134, -1.171075127999927],
              [127.61019941500001, -1.193129164999959],
              [127.62745201900009, -1.207614841999941],
              [127.67448978000004, -1.209730726999908],
              [127.68995201900009, -1.213799737999921],
            ],
          ],
          [
            [
              [123.50310306100005, -1.264418226999908],
              [123.52173912900003, -1.266289971999925],
              [123.53907311300009, -1.27271900799991],
              [123.55095462300005, -1.284763278999947],
              [123.55372155000009, -1.303399346999925],
              [123.55176842500009, -1.324314059999949],
              [123.53842207100001, -1.36060963299991],
              [123.53345787900003, -1.381117445999962],
              [123.53484134200005, -1.412286065999922],
              [123.53345787900003, -1.422051690999922],
              [123.52857506600003, -1.433038018999923],
              [123.50310306100005, -1.460056247999944],
              [123.46216881600003, -1.494317315999922],
              [123.45386803500003, -1.498793226999908],
              [123.43572024800005, -1.503106377999927],
              [123.42758222700002, -1.507989190999922],
              [123.40837649800005, -1.516534112999921],
              [123.381195509, -1.498304945999962],
              [123.36215254000001, -1.51140715899993],
              [123.35718834700003, -1.472914320999962],
              [123.35010826900009, -1.45671965899993],
              [123.33179772200003, -1.449965101999908],
              [123.32764733200008, -1.44459400799991],
              [123.32813561300009, -1.43287525799991],
              [123.32683353000004, -1.42115650799991],
              [123.31771894600001, -1.415785414999959],
              [123.30551191500001, -1.416110934999949],
              [123.29639733200008, -1.41765715899993],
              [123.28858483200008, -1.42156340899993],
              [123.28028405000009, -1.428887627999927],
              [123.25879967500009, -1.465997002999927],
              [123.24984785200002, -1.510674737999921],
              [123.252289259, -1.60084400799991],
              [123.25049889400009, -1.62273528399993],
              [123.24333743600005, -1.632419528999947],
              [123.23552493600005, -1.627048434999949],
              [123.23194420700008, -1.604180596999925],
              [123.22681725400003, -1.593357028999947],
              [123.215179884, -1.595472914999959],
              [123.17839603000004, -1.622491143999923],
              [123.16993248800009, -1.619398695999962],
              [123.164398634, -1.609633070999962],
              [123.15674889400009, -1.60084400799991],
              [123.12387129000001, -1.59148528399993],
              [123.11589603000004, -1.586602471999925],
              [123.11068769600001, -1.576918226999908],
              [123.10914147200003, -1.56568775799991],
              [123.11182701900009, -1.55632903399993],
              [123.11890709700003, -1.55242278399993],
              [123.13086998800009, -1.547621351999908],
              [123.17725670700008, -1.518243096999925],
              [123.18482506600003, -1.48560963299991],
              [123.16358483200008, -1.353773695999962],
              [123.16488691500001, -1.322035414999959],
              [123.16358483200008, -1.31218840899993],
              [123.15943444100003, -1.306247653999947],
              [123.15235436300009, -1.300551039999959],
              [123.14551842500009, -1.299981377999927],
              [123.13697350400003, -1.324476820999962],
              [123.12354576900009, -1.332777601999908],
              [123.10792076900009, -1.338555596999925],
              [123.09457441500001, -1.346368096999925],
              [123.07195071700005, -1.393975518999923],
              [123.06397545700008, -1.40162525799991],
              [123.05339603000004, -1.408461195999962],
              [123.04517662900003, -1.424493096999925],
              [123.03321373800009, -1.456231377999927],
              [123.01392662900003, -1.48560963299991],
              [122.99317467500009, -1.509209893999923],
              [122.91993248800009, -1.574476820999962],
              [122.89584394600001, -1.58953215899993],
              [122.87403405000009, -1.584567966999941],
              [122.81202233200008, -1.443617445999962],
              [122.80738366000003, -1.40162525799991],
              [122.810883009, -1.358086846999925],
              [122.82081139400009, -1.31373463299991],
              [122.83611087300005, -1.274021091999941],
              [122.89869225400003, -1.184340101999908],
              [122.91382897200003, -1.176364841999941],
              [122.93580162900003, -1.179864190999922],
              [122.97152754000001, -1.194431247999944],
              [122.98536217500009, -1.196058851999908],
              [122.99732506600003, -1.190362237999921],
              [123.01710045700008, -1.172621351999908],
              [123.02979576900009, -1.168877862999921],
              [123.07422936300009, -1.162692966999941],
              [123.11207116000003, -1.162692966999941],
              [123.11833743600005, -1.165785414999959],
              [123.12517337300005, -1.172784112999921],
              [123.13379967500009, -1.179864190999922],
              [123.14625084700003, -1.183200778999947],
              [123.15935306100005, -1.179294528999947],
              [123.16309655000009, -1.169854424999926],
              [123.16431725400003, -1.158379815999922],
              [123.17042076900009, -1.148370049999926],
              [123.18287194100003, -1.14226653399993],
              [123.18946373800009, -1.145277601999908],
              [123.19418379000001, -1.15162525799991],
              [123.20101972700002, -1.155205987999921],
              [123.24610436300009, -1.223402601999908],
              [123.23707116000003, -1.232679945999962],
              [123.23047936300009, -1.241794528999947],
              [123.22217858200008, -1.248711846999925],
              [123.20785566500001, -1.251397393999923],
              [123.20183353000004, -1.256524346999925],
              [123.19874108200008, -1.268731377999927],
              [123.197601759, -1.295505466999941],
              [123.20167076900009, -1.307305596999925],
              [123.21045983200008, -1.316827080999929],
              [123.21998131600003, -1.324965101999908],
              [123.22575931100005, -1.332696221999925],
              [123.22803795700008, -1.348402601999908],
              [123.22779381600003, -1.379652601999908],
              [123.23194420700008, -1.394707940999922],
              [123.25538170700008, -1.377129815999922],
              [123.27214603000004, -1.35475025799991],
              [123.30079186300009, -1.30592213299991],
              [123.30469811300009, -1.302829684999949],
              [123.31657962300005, -1.296482028999947],
              [123.32113691500001, -1.292413018999923],
              [123.33545983200008, -1.271905205999929],
              [123.34441165500004, -1.242608330999929],
              [123.35222415500004, -1.229180596999925],
              [123.36597741000003, -1.223402601999908],
              [123.38363691500001, -1.22429778399993],
              [123.39283287900003, -1.223565362999921],
              [123.40007571700005, -1.22039153399993],
              [123.40691165500004, -1.219496351999908],
              [123.40992272200003, -1.22820403399993],
              [123.41179446700005, -1.239841403999947],
              [123.41407311300009, -1.24773528399993],
              [123.42847741000003, -1.257745049999926],
              [123.43523196700005, -1.250664971999925],
              [123.44166100400003, -1.237725518999923],
              [123.45508873800009, -1.230889580999929],
              [123.46501712300005, -1.236260674999926],
              [123.48682701900009, -1.259209893999923],
              [123.50310306100005, -1.264418226999908],
            ],
          ],
          [
            [
              [129.954437696, -1.162692966999941],
              [129.96070397200003, -1.176364841999941],
              [129.95329837300005, -1.189629815999922],
              [129.92725670700008, -1.210381768999923],
              [129.92530358200008, -1.205173434999949],
              [129.922699415, -1.20086028399993],
              [129.92074629, -1.195977471999925],
              [129.9204207690001, -1.189385674999926],
              [129.88209069100003, -1.219659112999921],
              [129.85922285200002, -1.233168226999908],
              [129.83090254, -1.237074476999908],
              [129.87256920700008, -1.21021900799991],
              [129.8794051440001, -1.202894789999959],
              [129.87419681100005, -1.19695403399993],
              [129.8618270190001, -1.20045338299991],
              [129.8496199880001, -1.206963799999926],
              [129.844574415, -1.210381768999923],
              [129.83326256600003, -1.211846612999921],
              [129.7627059250001, -1.210381768999923],
              [129.74390709700003, -1.199883721999925],
              [129.74878991000003, -1.185804945999962],
              [129.76742597700002, -1.172051690999922],
              [129.85865319100003, -1.142022393999923],
              [129.8794051440001, -1.141534112999921],
              [129.89633222700002, -1.154229424999926],
              [129.9170028000001, -1.156426690999922],
              [129.93767337300005, -1.156508070999962],
              [129.954437696, -1.162692966999941],
            ],
          ],
          [
            [
              [134.99822024800005, -1.018649997999944],
              [134.993011915, -1.033298434999949],
              [134.9912215500001, -1.049248955999929],
              [134.99138431100005, -1.082940362999921],
              [134.95671634200005, -1.128513278999947],
              [134.94255618600005, -1.133965752999927],
              [134.9257918630001, -1.135511976999908],
              [134.89210045700008, -1.134698174999926],
              [134.87842858200008, -1.130791924999926],
              [134.86353600400003, -1.121026299999926],
              [134.8515731130001, -1.10865650799991],
              [134.83513431100005, -1.071465752999927],
              [134.812836134, -1.049899997999944],
              [134.80005944100003, -1.027764580999929],
              [134.8164168630001, -1.000664971999925],
              [134.81853274800005, -0.99578215899993],
              [134.82007897200003, -0.976983330999929],
              [134.82593834700003, -0.965752862999921],
              [134.82984459700003, -0.96062590899993],
              [134.83375084700003, -0.956638278999947],
              [134.84913170700008, -0.944431247999944],
              [134.86280358200008, -0.937595309999949],
              [134.87777754, -0.936130466999941],
              [134.92359459700003, -0.949965101999908],
              [134.9375106130001, -0.957614841999941],
              [134.94361412900003, -0.966892184999949],
              [134.94556725400003, -0.975192966999941],
              [134.95460045700008, -0.990655205999929],
              [134.95671634200005, -1.000664971999925],
              [134.95573978000004, -1.008884372999944],
              [134.95142662900003, -1.024346612999921],
              [134.95045006600003, -1.035332940999922],
              [134.9321395190001, -1.057712497999944],
              [134.92798912900003, -1.072035414999959],
              [134.94361412900003, -1.079522393999923],
              [134.9619246750001, -1.070570570999962],
              [134.9785262380001, -1.027601820999962],
              [134.99822024800005, -1.018649997999944],
            ],
          ],
          [
            [
              [131.05738366000003, -1.000664971999925],
              [131.05933678500003, -1.004978122999944],
              [131.06861412900003, -1.021254164999959],
              [131.07178795700008, -1.031670830999929],
              [131.07252037900003, -1.077569268999923],
              [131.03736412900003, -1.226332289999959],
              [131.0146590500001, -1.268975518999923],
              [131.0097762380001, -1.288669528999947],
              [131.00660241000003, -1.310804945999962],
              [130.99756920700008, -1.332452080999929],
              [130.98259524800005, -1.348565362999921],
              [130.9619246750001, -1.353773695999962],
              [130.94849694100003, -1.348402601999908],
              [130.93238366000003, -1.326592705999929],
              [130.9209090500001, -1.31959400799991],
              [130.9082137380001, -1.321465752999927],
              [130.89470462300005, -1.328708591999941],
              [130.8794051440001, -1.340101820999962],
              [130.86304772200003, -1.33717213299991],
              [130.85328209700003, -1.330661716999941],
              [130.828949415, -1.291436455999929],
              [130.82048587300005, -1.281670830999929],
              [130.7973738940001, -1.264418226999908],
              [130.76970462300005, -1.248223565999922],
              [130.75806725400003, -1.238213799999926],
              [130.74968509200005, -1.223402601999908],
              [130.74878991000003, -1.216973565999922],
              [130.75025475400003, -1.202732028999947],
              [130.74968509200005, -1.196058851999908],
              [130.74626712300005, -1.190036716999941],
              [130.74187259200005, -1.186293226999908],
              [130.73780358200008, -1.184340101999908],
              [130.73601321700005, -1.183200778999947],
              [130.73226972700002, -1.167901299999926],
              [130.73121178500003, -1.158379815999922],
              [130.72925866000003, -1.150811455999929],
              [130.72234134200005, -1.141534112999921],
              [130.711761915, -1.13250090899993],
              [130.703461134, -1.127373955999929],
              [130.69597415500004, -1.120700778999947],
              [130.68824303500003, -1.107354424999926],
              [130.71013431100005, -1.092868747999944],
              [130.7119246750001, -1.069919528999947],
              [130.70183353000004, -1.045098565999922],
              [130.68824303500003, -1.024834893999923],
              [130.6494246750001, -0.988376559999949],
              [130.649750196, -0.973809502999927],
              [130.6806746750001, -0.956638278999947],
              [130.7900496750001, -0.929294528999947],
              [130.8305770190001, -0.90748463299991],
              [130.868500196, -0.89381275799991],
              [130.89185631600003, -0.88990650799991],
              [130.91293379, -0.89421965899993],
              [130.929047071, -0.911553643999923],
              [130.934906446, -0.925876559999949],
              [130.93970787900003, -0.932305596999925],
              [130.94483483200008, -0.932305596999925],
              [130.96078535200002, -0.922946872999944],
              [130.98031660200002, -0.91765715899993],
              [131.02662194100003, -0.913995049999926],
              [131.03077233200008, -0.913018487999921],
              [131.03484134200005, -0.914808851999908],
              [131.043793165, -0.922458591999941],
              [131.0527449880001, -0.932305596999925],
              [131.07488040500004, -0.966892184999949],
              [131.0761824880001, -0.97429778399993],
              [131.0615340500001, -0.98992278399993],
              [131.05738366000003, -1.000664971999925],
            ],
          ],
          [
            [
              [130.91724694100003, -0.778415622999944],
              [130.92457116000003, -0.780694268999923],
              [130.91675866000003, -0.785739841999941],
              [130.9047957690001, -0.79029713299991],
              [130.89991295700008, -0.791436455999929],
              [130.8911238940001, -0.794854424999926],
              [130.88249759200005, -0.795993747999944],
              [130.87574303500003, -0.799248955999929],
              [130.87322024800005, -0.808851820999962],
              [130.87671959700003, -0.817559502999927],
              [130.88428795700008, -0.819512627999927],
              [130.8916121750001, -0.820407809999949],
              [130.89372806100005, -0.826267184999949],
              [130.8896590500001, -0.832777601999908],
              [130.88160241000003, -0.83953215899993],
              [130.87183678500003, -0.844659112999921],
              [130.84750410200002, -0.851006768999923],
              [130.8193465500001, -0.870293877999927],
              [130.8007918630001, -0.874607028999947],
              [130.7622176440001, -0.87664153399993],
              [130.61793053500003, -0.908461195999962],
              [130.5434676440001, -0.913832289999959],
              [130.51002037900003, -0.922458591999941],
              [130.51002037900003, -0.914971612999921],
              [130.519867384, -0.911309502999927],
              [130.52369225400003, -0.908786716999941],
              [130.50359134200005, -0.907403252999927],
              [130.4873153000001, -0.903903903999947],
              [130.47543379, -0.90593840899993],
              [130.46851647200003, -0.922458591999941],
              [130.46168053500003, -0.922458591999941],
              [130.45264733200008, -0.910577080999929],
              [130.43677819100003, -0.913262627999927],
              [130.40015709700003, -0.929294528999947],
              [130.40943444100003, -0.912041924999926],
              [130.4277449880001, -0.902927341999941],
              [130.44068444100003, -0.893161716999941],
              [130.43433678500003, -0.874607028999947],
              [130.44752037900003, -0.860935153999947],
              [130.44841556100005, -0.818617445999962],
              [130.46168053500003, -0.805108330999929],
              [130.461273634, -0.816013278999947],
              [130.46168053500003, -0.819431247999944],
              [130.46851647200003, -0.819431247999944],
              [130.4707137380001, -0.806735934999949],
              [130.4785262380001, -0.799899997999944],
              [130.49000084700003, -0.799248955999929],
              [130.50318444100003, -0.805108330999929],
              [130.4946395190001, -0.827894789999959],
              [130.51905358200008, -0.839613539999959],
              [130.55095462300005, -0.834161065999922],
              [130.56470787900003, -0.805108330999929],
              [130.57398522200003, -0.80982838299991],
              [130.580414259, -0.815606377999927],
              [130.58464603000004, -0.823174737999921],
              [130.5864363940001, -0.833103122999944],
              [130.61589603000004, -0.81178150799991],
              [130.631195509, -0.806247653999947],
              [130.64665774800005, -0.812595309999949],
              [130.6450301440001, -0.814222914999959],
              [130.64380944100003, -0.814873955999929],
              [130.6425887380001, -0.816013278999947],
              [130.6411238940001, -0.819431247999944],
              [130.6543074880001, -0.823988539999959],
              [130.66391035200002, -0.820896091999941],
              [130.6718856130001, -0.815199476999908],
              [130.6806746750001, -0.812595309999949],
              [130.69459069100003, -0.815199476999908],
              [130.71851647200003, -0.824314059999949],
              [130.732758009, -0.826267184999949],
              [130.75798587300005, -0.818942966999941],
              [130.7802840500001, -0.80592213299991],
              [130.800140821, -0.801446221999925],
              [130.81788170700008, -0.819431247999944],
              [130.81918379, -0.809665622999944],
              [130.81755618600005, -0.80592213299991],
              [130.8110457690001, -0.798923434999949],
              [130.81657962300005, -0.788262627999927],
              [130.80062910200002, -0.769952080999929],
              [130.80420983200008, -0.757256768999923],
              [130.811859571, -0.764743747999944],
              [130.81999759200005, -0.767347914999959],
              [130.83912194100003, -0.767510674999926],
              [130.8520613940001, -0.76921965899993],
              [130.85718834700003, -0.768731377999927],
              [130.8735457690001, -0.764580987999921],
              [130.8794051440001, -0.764743747999944],
              [130.88941491000003, -0.768161716999941],
              [130.90601647200003, -0.77662525799991],
              [130.91724694100003, -0.778415622999944],
            ],
          ],
          [
            [
              [136.37566165500004, -1.093682549999926],
              [136.38493899800005, -1.107517184999949],
              [136.38111412900003, -1.123223565999922],
              [136.36841881600003, -1.136163018999923],
              [136.35132897200003, -1.141534112999921],
              [136.340668165, -1.147393487999921],
              [136.29363040500004, -1.183200778999947],
              [136.23064212300005, -1.192966403999947],
              [136.21469160200002, -1.199476820999962],
              [136.2011824880001, -1.207940362999921],
              [136.1816512380001, -1.215427341999941],
              [136.1606551440001, -1.220879815999922],
              [136.14283287900003, -1.223402601999908],
              [136.09945722700002, -1.215997002999927],
              [136.03638756600003, -1.176446221999925],
              [135.99138431100005, -1.168877862999921],
              [135.96851647200003, -1.172621351999908],
              [135.92994225400003, -1.186293226999908],
              [135.90601647200003, -1.189385674999926],
              [135.88502037900003, -1.183038018999923],
              [135.86402428500003, -1.167575778999947],
              [135.8462020190001, -1.147637627999927],
              [135.834320509, -1.128513278999947],
              [135.82829837300005, -1.107842705999929],
              [135.834320509, -1.049004815999922],
              [135.8310653000001, -1.039646091999941],
              [135.8164168630001, -1.020277601999908],
              [135.81324303500003, -1.01490650799991],
              [135.81177819100003, -1.003513278999947],
              [135.79948978000004, -0.970310153999947],
              [135.78101647200003, -0.872653903999947],
              [135.76539147200003, -0.839288018999923],
              [135.74097741000003, -0.819024346999925],
              [135.719086134, -0.824802341999941],
              [135.69996178500003, -0.844903252999927],
              [135.6840926440001, -0.867120049999926],
              [135.66081790500004, -0.887139580999929],
              [135.6406356130001, -0.881605726999908],
              [135.4848738940001, -0.757256768999923],
              [135.4790145190001, -0.768731377999927],
              [135.47974694100003, -0.780205987999921],
              [135.49170983200008, -0.805108330999929],
              [135.45866946700005, -0.792738539999959],
              [135.42261803500003, -0.762383721999925],
              [135.39372806100005, -0.723402601999908],
              [135.36988366000003, -0.653497002999927],
              [135.37037194100003, -0.635918877999927],
              [135.38933353000004, -0.627618096999925],
              [135.3989363940001, -0.631036065999922],
              [135.4145613940001, -0.648695570999962],
              [135.42335045700008, -0.654880466999941],
              [135.42945397200003, -0.655450127999927],
              [135.44092858200008, -0.652439059999949],
              [135.44678795700008, -0.652113539999959],
              [135.452484571, -0.654229424999926],
              [135.46314537900003, -0.66139088299991],
              [135.46900475400003, -0.664239190999922],
              [135.49878991000003, -0.672458591999941],
              [135.5512801440001, -0.677178643999923],
              [135.56267337300005, -0.676364841999941],
              [135.583343946, -0.666680596999925],
              [135.59245853000004, -0.67546965899993],
              [135.6015731130001, -0.695896091999941],
              [135.6665145190001, -0.682793877999927],
              [135.67725670700008, -0.685642184999949],
              [135.67945397200003, -0.691338799999926],
              [135.68873131600003, -0.70867278399993],
              [135.69092858200008, -0.719821872999944],
              [135.69507897200003, -0.729587497999944],
              [135.70492597700002, -0.726739190999922],
              [135.71631920700008, -0.719496351999908],
              [135.7251082690001, -0.716403903999947],
              [135.75709069100003, -0.739353122999944],
              [135.77751712300005, -0.748711846999925],
              [135.786468946, -0.740329684999949],
              [135.79281660200002, -0.729180596999925],
              [135.8086043630001, -0.71412525799991],
              [135.82837975400003, -0.70086028399993],
              [135.84742272200003, -0.695896091999941],
              [135.86931399800005, -0.703789971999925],
              [135.8935653000001, -0.721123955999929],
              [135.96631920700008, -0.796075127999927],
              [136.04558353000004, -0.85320403399993],
              [136.065765821, -0.871677341999941],
              [136.07764733200008, -0.899997653999947],
              [136.08464603000004, -0.910251559999949],
              [136.09253991000003, -0.918877862999921],
              [136.10499108200008, -0.927829684999949],
              [136.10906009200005, -0.940118096999925],
              [136.1118270190001, -0.953789971999925],
              [136.11475670700008, -0.963474216999941],
              [136.129730665, -0.978448174999926],
              [136.14812259200005, -0.991387627999927],
              [136.16358483200008, -1.004978122999944],
              [136.17335045700008, -1.031345309999949],
              [136.18734785200002, -1.049574476999908],
              [136.1962996750001, -1.066582940999922],
              [136.20875084700003, -1.064060153999947],
              [136.22055097700002, -1.056735934999949],
              [136.2246199880001, -1.052829684999949],
              [136.24594160200002, -1.048760674999926],
              [136.2734481130001, -1.047295830999929],
              [136.29712975400003, -1.05437590899993],
              [136.30730228000004, -1.076348565999922],
              [136.316742384, -1.08562590899993],
              [136.37566165500004, -1.093682549999926],
            ],
          ],
          [
            [
              [127.29615319100003, -0.743747653999947],
              [127.31804446700005, -0.780043226999908],
              [127.31983483200008, -0.793633721999925],
              [127.27881920700008, -0.805596612999921],
              [127.26880944100003, -0.805108330999929],
              [127.26490319100003, -0.80201588299991],
              [127.25310306100005, -0.788995049999926],
              [127.24830162900003, -0.785251559999949],
              [127.21656334700003, -0.782403252999927],
              [127.18018639400009, -0.783868096999925],
              [127.15552819100003, -0.772393487999921],
              [127.15894616000003, -0.730645440999922],
              [127.16895592500009, -0.71021900799991],
              [127.18018639400009, -0.693129164999959],
              [127.18930097700002, -0.674981377999927],
              [127.19459069100003, -0.635186455999929],
              [127.20085696700005, -0.622816664999959],
              [127.21404056100005, -0.615411065999922],
              [127.24415123800009, -0.613946221999925],
              [127.25082441500001, -0.61492278399993],
              [127.25660241000003, -0.616957289999959],
              [127.26124108200008, -0.620212497999944],
              [127.24878991000003, -0.637627862999921],
              [127.25513756600003, -0.650485934999949],
              [127.26807701900009, -0.661228122999944],
              [127.27507571700005, -0.672539971999925],
              [127.27800540500004, -0.675713799999926],
              [127.29175866000003, -0.694512627999927],
              [127.29615319100003, -0.702732028999947],
              [127.297211134, -0.71257903399993],
              [127.29517662900003, -0.73365650799991],
              [127.29615319100003, -0.743747653999947],
            ],
          ],
          [
            [
              [130.67758222700002, -0.435804945999962],
              [130.68637129, -0.449151299999926],
              [130.6879988940001, -0.463148695999962],
              [130.68344160200002, -0.477227471999925],
              [130.65455162900003, -0.516696872999944],
              [130.6411238940001, -0.527520440999922],
              [130.59636478000004, -0.538506768999923],
              [130.5810653000001, -0.539239190999922],
              [130.57154381600003, -0.531996351999908],
              [130.58366946700005, -0.523858330999929],
              [130.5976668630001, -0.490817966999941],
              [130.59685306100005, -0.46453215899993],
              [130.56470787900003, -0.476739190999922],
              [130.56226647200003, -0.481052341999941],
              [130.55827884200005, -0.495049737999921],
              [130.55445397200003, -0.500909112999921],
              [130.54761803500003, -0.505303643999923],
              [130.5337020190001, -0.509860934999949],
              [130.52711022200003, -0.514336846999925],
              [130.51710045700008, -0.517754815999922],
              [130.46168053500003, -0.525160414999959],
              [130.47046959700003, -0.514336846999925],
              [130.4824324880001, -0.509209893999923],
              [130.492523634, -0.503350518999923],
              [130.49634850400003, -0.490411065999922],
              [130.48113040500004, -0.49578215899993],
              [130.46949303500003, -0.490329684999949],
              [130.4609481130001, -0.478122653999947],
              [130.45484459700003, -0.463799737999921],
              [130.46355228000004, -0.465508721999925],
              [130.46859785200002, -0.467217705999929],
              [130.47217858200008, -0.470310153999947],
              [130.47584069100003, -0.476739190999922],
              [130.48218834700003, -0.46453215899993],
              [130.49382571700005, -0.450127862999921],
              [130.50505618600005, -0.441338799999926],
              [130.51002037900003, -0.445733330999929],
              [130.51343834700003, -0.461846612999921],
              [130.5224715500001, -0.468926690999922],
              [130.5351668630001, -0.468926690999922],
              [130.55046634200005, -0.463799737999921],
              [130.55933678500003, -0.455987237999921],
              [130.56959069100003, -0.444105726999908],
              [130.58228600400003, -0.433200778999947],
              [130.60613040500004, -0.426690362999921],
              [130.61011803500003, -0.422621351999908],
              [130.61312910200002, -0.417575778999947],
              [130.61744225400003, -0.412530205999929],
              [130.6250106130001, -0.409600518999923],
              [130.63209069100003, -0.411309502999927],
              [130.645843946, -0.419366143999923],
              [130.670258009, -0.430271091999941],
              [130.67758222700002, -0.435804945999962],
            ],
          ],
          [
            [
              [121.853851759, -0.401055596999925],
              [121.89551842500009, -0.428399346999925],
              [121.90170332100001, -0.43718840899993],
              [121.91065514400009, -0.460381768999923],
              [121.91602623800009, -0.469903252999927],
              [121.91358483200008, -0.486423434999949],
              [121.90642337300005, -0.49928150799991],
              [121.89478600400003, -0.507907809999949],
              [121.87842858200008, -0.510918877999927],
              [121.87452233200008, -0.505954684999949],
              [121.84791100400003, -0.483330987999921],
              [121.83472741000003, -0.476739190999922],
              [121.84644616000003, -0.500258070999962],
              [121.84473717500009, -0.507989190999922],
              [121.83090254000001, -0.510918877999927],
              [121.81657962300005, -0.507745049999926],
              [121.80128014400009, -0.493584893999923],
              [121.79004967500009, -0.490411065999922],
              [121.74634850400003, -0.48365650799991],
              [121.73536217500009, -0.479913018999923],
              [121.72559655000009, -0.483086846999925],
              [121.70093834700003, -0.535088799999926],
              [121.68897545700008, -0.543145440999922],
              [121.67172285200002, -0.550388278999947],
              [121.65455162900003, -0.55242278399993],
              [121.64226321700005, -0.545586846999925],
              [121.64177493600005, -0.531019789999959],
              [121.65015709700003, -0.512627862999921],
              [121.67986087300005, -0.468926690999922],
              [121.68970787900003, -0.458184502999927],
              [121.70191491000003, -0.449639580999929],
              [121.73422285200002, -0.434991143999923],
              [121.74089603000004, -0.429131768999923],
              [121.75212649800005, -0.401055596999925],
              [121.77857506600003, -0.424574476999908],
              [121.79948978000004, -0.420505466999941],
              [121.82211347700002, -0.406670830999929],
              [121.853851759, -0.401055596999925],
            ],
          ],
          [
            [
              [104.54851321700005, -0.398044528999947],
              [104.59294681100005, -0.448418877999927],
              [104.59937584700003, -0.463799737999921],
              [104.59164472700007, -0.483575127999927],
              [104.57300866000003, -0.500420830999929],
              [104.53419030000003, -0.52857838299991],
              [104.52662194100003, -0.547621351999908],
              [104.52198326900003, -0.596612237999921],
              [104.51124108200003, -0.613946221999925],
              [104.47673587300005, -0.614027601999908],
              [104.44711347700007, -0.588067315999922],
              [104.42042076900003, -0.574965101999908],
              [104.39389082100007, -0.613946221999925],
              [104.38363691500007, -0.653497002999927],
              [104.37582441500007, -0.660088799999926],
              [104.35629316500007, -0.661716403999947],
              [104.34603925900007, -0.579196872999944],
              [104.33578535200007, -0.54265715899993],
              [104.32634524800005, -0.529880466999941],
              [104.31202233200003, -0.531996351999908],
              [104.25586998800003, -0.475518487999921],
              [104.25367272200003, -0.460056247999944],
              [104.26319420700003, -0.446221612999921],
              [104.27702884200005, -0.413018487999921],
              [104.28402754000007, -0.401055596999925],
              [104.31185957100007, -0.378350518999923],
              [104.32471764400003, -0.364841403999947],
              [104.33253014400003, -0.346449476999908],
              [104.33936608200003, -0.346449476999908],
              [104.34555097700007, -0.363702080999929],
              [104.33480879000007, -0.404880466999941],
              [104.33936608200003, -0.428399346999925],
              [104.34603925900007, -0.428399346999925],
              [104.34831790500004, -0.407403252999927],
              [104.35287519600007, -0.387383721999925],
              [104.35971113400007, -0.387383721999925],
              [104.38266035200007, -0.401462497999944],
              [104.41578209700003, -0.381931247999944],
              [104.46957441500007, -0.332126559999949],
              [104.48926842500003, -0.349379164999959],
              [104.49675540500004, -0.353936455999929],
              [104.51823978000004, -0.36256275799991],
              [104.52491295700003, -0.36687590899993],
              [104.53093509200005, -0.373467705999929],
              [104.54135175900007, -0.389336846999925],
              [104.54851321700005, -0.398044528999947],
            ],
          ],
          [
            [
              [122.02955162900003, -0.332126559999949],
              [122.04371178500003, -0.334649346999925],
              [122.05144290500004, -0.342054945999962],
              [122.05404707100001, -0.35515715899993],
              [122.053070509, -0.373711846999925],
              [122.04273522200003, -0.393487237999921],
              [122.02662194100003, -0.406914971999925],
              [122.00660241000003, -0.410739841999941],
              [121.98487389400009, -0.401055596999925],
              [121.96412194100003, -0.41334400799991],
              [121.93181399800005, -0.414646091999941],
              [121.89869225400003, -0.40748463299991],
              [121.87501061300009, -0.394789320999962],
              [121.86085045700008, -0.377862237999921],
              [121.86011803500003, -0.367445570999962],
              [121.86500084700003, -0.357842705999929],
              [121.86817467500009, -0.34303150799991],
              [121.87232506600003, -0.332614841999941],
              [121.88233483200008, -0.330010674999926],
              [121.90235436300009, -0.332126559999949],
              [121.90333092500009, -0.333916924999926],
              [121.90837649800005, -0.337334893999923],
              [121.91553795700008, -0.340020440999922],
              [121.92351321700005, -0.339613539999959],
              [121.92481530000009, -0.334567966999941],
              [121.92269941500001, -0.316338799999926],
              [121.92652428500003, -0.312269789999959],
              [121.96656334700003, -0.314711195999962],
              [121.97803795700008, -0.318536065999922],
              [122.00440514400009, -0.330254815999922],
              [122.01351972700002, -0.331963799999926],
              [122.02955162900003, -0.332126559999949],
            ],
          ],
          [
            [
              [127.88892662900003, -0.764743747999944],
              [127.89820397200003, -0.767347914999959],
              [127.89820397200003, -0.773532809999949],
              [127.89193769600001, -0.785251559999949],
              [127.88819420700008, -0.802178643999923],
              [127.87623131600003, -0.817803643999923],
              [127.83082116000003, -0.859144789999959],
              [127.82227623800009, -0.864353122999944],
              [127.81267337300005, -0.866631768999923],
              [127.79948978000004, -0.867120049999926],
              [127.78663170700008, -0.87037525799991],
              [127.76531009200005, -0.884535414999959],
              [127.75489342500009, -0.887627862999921],
              [127.74878991000003, -0.885349216999941],
              [127.72754967500009, -0.867120049999926],
              [127.71778405000009, -0.862237237999921],
              [127.69402103000004, -0.854668877999927],
              [127.68311608200008, -0.853610934999949],
              [127.68018639400009, -0.850274346999925],
              [127.67847741000003, -0.843357028999947],
              [127.67383873800009, -0.836195570999962],
              [127.66236412900003, -0.833103122999944],
              [127.65349368600005, -0.82740650799991],
              [127.65349368600005, -0.814629815999922],
              [127.658539259, -0.791436455999929],
              [127.65552819100003, -0.78093840899993],
              [127.65064537900003, -0.77117278399993],
              [127.64478600400003, -0.76295338299991],
              [127.63819420700008, -0.757256768999923],
              [127.62574303500003, -0.752373955999929],
              [127.62045332100001, -0.75554778399993],
              [127.61638431100005, -0.761488539999959],
              [127.60743248800009, -0.764743747999944],
              [127.58969160200002, -0.768731377999927],
              [127.53565514400009, -0.798923434999949],
              [127.46989993600005, -0.818454684999949],
              [127.45769290500004, -0.815606377999927],
              [127.45248457100001, -0.80201588299991],
              [127.45053144600001, -0.792901299999926],
              [127.44157962300005, -0.772881768999923],
              [127.43726647200003, -0.729099216999941],
              [127.43946373800009, -0.716403903999947],
              [127.47071373800009, -0.652520440999922],
              [127.47022545700008, -0.641289971999925],
              [127.46705162900003, -0.639825127999927],
              [127.43604576900009, -0.630629164999959],
              [127.42693118600005, -0.625583591999941],
              [127.40886478000004, -0.624200127999927],
              [127.39861087300005, -0.620212497999944],
              [127.39730879000001, -0.61687590899993],
              [127.39535566500001, -0.604668877999927],
              [127.39234459700003, -0.599704684999949],
              [127.38746178500003, -0.597426039999959],
              [127.37452233200008, -0.594008070999962],
              [127.37110436300009, -0.592868747999944],
              [127.35328209700003, -0.562920830999929],
              [127.35075931100005, -0.555271091999941],
              [127.34441165500004, -0.54461028399993],
              [127.31397545700008, -0.522230726999908],
              [127.30298912900003, -0.510918877999927],
              [127.295258009, -0.494317315999922],
              [127.29118899800005, -0.476820570999962],
              [127.29184004000001, -0.460137627999927],
              [127.29957116000003, -0.445733330999929],
              [127.31177819100003, -0.432224216999941],
              [127.32243899800005, -0.416924737999921],
              [127.32935631600003, -0.398044528999947],
              [127.33025149800005, -0.373711846999925],
              [127.32813561300009, -0.365166924999926],
              [127.31666100400003, -0.339613539999959],
              [127.330414259, -0.339450778999947],
              [127.35075931100005, -0.328708591999941],
              [127.36117597700002, -0.32586028399993],
              [127.37281334700003, -0.329034112999921],
              [127.38282311300009, -0.336358330999929],
              [127.39861087300005, -0.353936455999929],
              [127.40503991000003, -0.35865650799991],
              [127.41146894600001, -0.362399997999944],
              [127.41651451900009, -0.367771091999941],
              [127.42058353000004, -0.388929945999962],
              [127.42652428500003, -0.401462497999944],
              [127.43531334700003, -0.411228122999944],
              [127.44629967500009, -0.41529713299991],
              [127.46094811300009, -0.406833591999941],
              [127.46892337300005, -0.38640715899993],
              [127.47413170700008, -0.363213799999926],
              [127.48047936300009, -0.346449476999908],
              [127.486664259, -0.342461846999925],
              [127.49586022200003, -0.33912525799991],
              [127.50416100400003, -0.335137627999927],
              [127.50782311300009, -0.329034112999921],
              [127.50879967500009, -0.320733330999929],
              [127.51156660200002, -0.310642184999949],
              [127.51685631600003, -0.301934502999927],
              [127.52418053500003, -0.298028252999927],
              [127.52816816500001, -0.298760674999926],
              [127.52979576900009, -0.300713799999926],
              [127.53077233200008, -0.303155205999929],
              [127.53223717500009, -0.304945570999962],
              [127.56617272200003, -0.316501559999949],
              [127.57862389400009, -0.324965101999908],
              [127.58350670700008, -0.34303150799991],
              [127.58887780000009, -0.351983330999929],
              [127.61231530000009, -0.366306247999944],
              [127.61768639400009, -0.377536716999941],
              [127.61915123800009, -0.388604424999926],
              [127.62256920700008, -0.399590752999927],
              [127.62720787900003, -0.408949476999908],
              [127.63200931100005, -0.41529713299991],
              [127.63591556100005, -0.416192315999922],
              [127.64779707100001, -0.414320570999962],
              [127.65170332100001, -0.41529713299991],
              [127.658539259, -0.428399346999925],
              [127.66627037900003, -0.435723565999922],
              [127.68311608200008, -0.460056247999944],
              [127.68799889400009, -0.480645440999922],
              [127.67652428500003, -0.503513278999947],
              [127.61768639400009, -0.573174737999921],
              [127.60767662900003, -0.593845309999949],
              [127.60401451900009, -0.617120049999926],
              [127.60645592500009, -0.629082940999922],
              [127.61304772200003, -0.63640715899993],
              [127.62289472700002, -0.640232028999947],
              [127.63502037900003, -0.641289971999925],
              [127.64747155000009, -0.644301039999959],
              [127.65113366000003, -0.652439059999949],
              [127.65137780000009, -0.685804945999962],
              [127.64966881600003, -0.696709893999923],
              [127.652679884, -0.707207940999922],
              [127.66602623800009, -0.716403903999947],
              [127.67823326900009, -0.717705987999921],
              [127.69019616000003, -0.713636976999908],
              [127.70118248800009, -0.706801039999959],
              [127.71013431100005, -0.699314059999949],
              [127.72510826900009, -0.694024346999925],
              [127.78956139400009, -0.689629815999922],
              [127.80469811300009, -0.694105726999908],
              [127.84864342500009, -0.712985934999949],
              [127.85792076900009, -0.719821872999944],
              [127.86109459700003, -0.725762627999927],
              [127.87517337300005, -0.744317315999922],
              [127.87826582100001, -0.754001559999949],
              [127.87842858200008, -0.760186455999929],
              [127.87956790500004, -0.76336028399993],
              [127.88266035200002, -0.764580987999921],
              [127.88892662900003, -0.764743747999944],
            ],
          ],
          [
            [
              [127.23462975400003, -0.490411065999922],
              [127.21094811300009, -0.513278903999947],
              [127.19874108200008, -0.520603122999944],
              [127.17945397200003, -0.525160414999959],
              [127.11736087300005, -0.525160414999959],
              [127.11996504000001, -0.517998955999929],
              [127.12159264400009, -0.51490650799991],
              [127.12476647200003, -0.510918877999927],
              [127.10857181100005, -0.501071872999944],
              [127.11255944100003, -0.49187590899993],
              [127.12435957100001, -0.485284112999921],
              [127.13103274800005, -0.483005466999941],
              [127.13062584700003, -0.470147393999923],
              [127.12614993600005, -0.45671965899993],
              [127.11988366000003, -0.446221612999921],
              [127.11394290500004, -0.441989841999941],
              [127.10230553500003, -0.437758070999962],
              [127.10230553500003, -0.42742278399993],
              [127.11052493600005, -0.404717705999929],
              [127.11052493600005, -0.377536716999941],
              [127.11255944100003, -0.369398695999962],
              [127.11695397200003, -0.365655205999929],
              [127.12183678500003, -0.363457940999922],
              [127.12476647200003, -0.360039971999925],
              [127.12256920700008, -0.337334893999923],
              [127.11426842500009, -0.31023528399993],
              [127.11036217500009, -0.287692966999941],
              [127.12110436300009, -0.278090101999908],
              [127.12818444100003, -0.276136976999908],
              [127.15381920700008, -0.265720309999949],
              [127.16211998800009, -0.260837497999944],
              [127.17481530000009, -0.25554778399993],
              [127.203461134, -0.257256768999923],
              [127.21363366000003, -0.250176690999922],
              [127.22038821700005, -0.257582289999959],
              [127.22820071700005, -0.251722914999959],
              [127.23487389400009, -0.251722914999959],
              [127.24138431100005, -0.256442966999941],
              [127.24830162900003, -0.263848565999922],
              [127.25456790500004, -0.275648695999962],
              [127.26392662900003, -0.279473565999922],
              [127.29249108200008, -0.278090101999908],
              [127.29712975400003, -0.281914971999925],
              [127.29607181100005, -0.29029713299991],
              [127.29224694100003, -0.299574476999908],
              [127.28874759200005, -0.305433851999908],
              [127.28288821700005, -0.307305596999925],
              [127.26490319100003, -0.306247653999947],
              [127.25782311300009, -0.308851820999962],
              [127.25131269600001, -0.323337497999944],
              [127.25473066500001, -0.338799737999921],
              [127.26335696700005, -0.353122653999947],
              [127.27198326900009, -0.363457940999922],
              [127.27702884200005, -0.373467705999929],
              [127.28077233200008, -0.388604424999926],
              [127.28003991000003, -0.402520440999922],
              [127.26156660200002, -0.414646091999941],
              [127.26197350400003, -0.428806247999944],
              [127.26880944100003, -0.45631275799991],
              [127.265961134, -0.46453215899993],
              [127.25660241000003, -0.477634372999944],
              [127.25196373800009, -0.497165622999944],
              [127.24626712300005, -0.496351820999962],
              [127.23959394600001, -0.491794528999947],
              [127.23462975400003, -0.490411065999922],
            ],
          ],
          [
            [
              [103.71273847700007, -0.269707940999922],
              [103.73462975400008, -0.281182549999926],
              [103.75611412900008, -0.301202080999929],
              [103.76685631600003, -0.324639580999929],
              [103.75652103000004, -0.346449476999908],
              [103.74935957100007, -0.348809502999927],
              [103.71241295700003, -0.346449476999908],
              [103.69825280000003, -0.349541924999926],
              [103.67066491000003, -0.363702080999929],
              [103.65748131600003, -0.36687590899993],
              [103.64966881600003, -0.370049737999921],
              [103.62623131600003, -0.384209893999923],
              [103.61255944100003, -0.387383721999925],
              [103.60401451900003, -0.383477471999925],
              [103.59262129000007, -0.376153252999927],
              [103.58033287900008, -0.372002862999921],
              [103.56812584700003, -0.377536716999941],
              [103.54664147200003, -0.382989190999922],
              [103.49000084700003, -0.361586195999962],
              [103.46168053500003, -0.36687590899993],
              [103.46062259200005, -0.333916924999926],
              [103.48511803500003, -0.28679778399993],
              [103.52214603000004, -0.24382903399993],
              [103.55787194100003, -0.223402601999908],
              [103.57455488400007, -0.224704684999949],
              [103.62867272200003, -0.234307549999926],
              [103.64039147200003, -0.240655205999929],
              [103.64958743600005, -0.254815362999921],
              [103.67066491000003, -0.262627862999921],
              [103.71273847700007, -0.269707940999922],
            ],
          ],
          [
            [
              [122.21762129000001, -0.247165622999944],
              [122.22095787900003, -0.250176690999922],
              [122.23519941500001, -0.258233330999929],
              [122.23878014400009, -0.263848565999922],
              [122.23650149800005, -0.273370049999926],
              [122.23015384200005, -0.274346612999921],
              [122.22291100400003, -0.270196221999925],
              [122.21762129000001, -0.263848565999922],
              [122.21143639400009, -0.263848565999922],
              [122.19996178500003, -0.267754815999922],
              [122.164398634, -0.249444268999923],
              [122.14625084700003, -0.244073174999926],
              [122.14437910200002, -0.233005466999941],
              [122.15837649800005, -0.211358330999929],
              [122.17709394600001, -0.196384372999944],
              [122.18970787900003, -0.205254815999922],
              [122.17725670700008, -0.230401299999926],
              [122.18962649800005, -0.23015715899993],
              [122.20264733200008, -0.232191664999959],
              [122.213226759, -0.23756275799991],
              [122.21762129000001, -0.247165622999944],
            ],
          ],
          [
            [
              [122.36915123800009, -0.263848565999922],
              [122.36491946700005, -0.282159112999921],
              [122.36793053500003, -0.304457289999959],
              [122.37517337300005, -0.325616143999923],
              [122.38266035200002, -0.339613539999959],
              [122.37598717500009, -0.346449476999908],
              [122.35425866000003, -0.321709893999923],
              [122.32154381600003, -0.257907809999949],
              [122.293304884, -0.237237237999921],
              [122.28858483200008, -0.23796965899993],
              [122.27328535200002, -0.243747653999947],
              [122.26612389400009, -0.244073174999926],
              [122.26050866000003, -0.240980726999908],
              [122.24561608200008, -0.223402601999908],
              [122.228851759, -0.207940362999921],
              [122.22584069100003, -0.199395440999922],
              [122.23194420700008, -0.18873463299991],
              [122.24073326900009, -0.195407809999949],
              [122.26734459700003, -0.205010674999926],
              [122.27279707100001, -0.206149997999944],
              [122.27711022200003, -0.213962497999944],
              [122.28728274800005, -0.218845309999949],
              [122.32781009200005, -0.230564059999949],
              [122.34538821700005, -0.238702080999929],
              [122.35938561300009, -0.24928150799991],
              [122.36915123800009, -0.263848565999922],
            ],
          ],
          [
            [
              [121.574554884, -0.182549737999921],
              [121.56910241000003, -0.144789320999962],
              [121.59742272200003, -0.12468840899993],
              [121.633148634, -0.12468840899993],
              [121.64966881600003, -0.147393487999921],
              [121.64258873800009, -0.176853122999944],
              [121.62452233200008, -0.198418877999927],
              [121.60027103000004, -0.203220309999949],
              [121.574554884, -0.182549737999921],
            ],
          ],
          [
            [
              [131.29761803500003, -0.237237237999921],
              [131.3066512380001, -0.251397393999923],
              [131.33855228000004, -0.277601820999962],
              [131.34546959700003, -0.288181247999944],
              [131.34009850400003, -0.296075127999927],
              [131.31666100400003, -0.299574476999908],
              [131.31137129, -0.308851820999962],
              [131.3066512380001, -0.321221612999921],
              [131.29672285200002, -0.328545830999929],
              [131.28728274800005, -0.33717213299991],
              [131.28394616000003, -0.353936455999929],
              [131.27947024800005, -0.351739190999922],
              [131.2680770190001, -0.348565362999921],
              [131.26351972700002, -0.346449476999908],
              [131.2622176440001, -0.368340752999927],
              [131.2529403000001, -0.384372653999947],
              [131.23796634200005, -0.389255466999941],
              [131.2192488940001, -0.377536716999941],
              [131.18091881600003, -0.346449476999908],
              [131.15772545700008, -0.332940362999921],
              [131.1474715500001, -0.335870049999926],
              [131.1430770190001, -0.332126559999949],
              [131.11280358200008, -0.332126559999949],
              [131.10434004, -0.328220309999949],
              [131.10222415500004, -0.324395440999922],
              [131.098480665, -0.322930596999925],
              [131.08545983200008, -0.32586028399993],
              [131.06983483200008, -0.332940362999921],
              [131.02328535200002, -0.36687590899993],
              [131.021820509, -0.352959893999923],
              [131.0156356130001, -0.349867445999962],
              [130.9961043630001, -0.353936455999929],
              [130.99586022200003, -0.354913018999923],
              [130.99105879, -0.357028903999947],
              [130.9843856130001, -0.359144789999959],
              [130.9790145190001, -0.360039971999925],
              [130.97046959700003, -0.358005466999941],
              [130.95826256600003, -0.348565362999921],
              [130.9516707690001, -0.346449476999908],
              [130.93091881600003, -0.315362237999921],
              [130.9052840500001, -0.298435153999947],
              [130.89991295700008, -0.291192315999922],
              [130.9072371750001, -0.284926039999959],
              [130.8930770190001, -0.264336846999925],
              [130.8794051440001, -0.254082940999922],
              [130.8632918630001, -0.250583591999941],
              [130.83423912900003, -0.24928150799991],
              [130.8169051440001, -0.244886976999908],
              [130.8076278000001, -0.244073174999926],
              [130.79672285200002, -0.239190362999921],
              [130.79444420700008, -0.22820403399993],
              [130.7973738940001, -0.209242445999962],
              [130.79224694100003, -0.189873955999929],
              [130.78484134200005, -0.17937590899993],
              [130.73023522200003, -0.130466403999947],
              [130.71949303500003, -0.114108981999948],
              [130.71550540500004, -0.093194268999923],
              [130.7070418630001, -0.096286716999941],
              [130.7011824880001, -0.096449476999908],
              [130.68824303500003, -0.093194268999923],
              [130.692718946, -0.086358330999929],
              [130.69556725400003, -0.079522393999923],
              [130.67701256600003, -0.077894789999959],
              [130.65007571700005, -0.07976653399993],
              [130.62525475400003, -0.084974867999961],
              [130.61304772200003, -0.093194268999923],
              [130.63746178500003, -0.098728122999944],
              [130.64722741000003, -0.103855075999945],
              [130.65406334700003, -0.113702080999929],
              [130.636078321, -0.113457940999922],
              [130.62623131600003, -0.125746351999908],
              [130.629242384, -0.140720309999949],
              [130.665375196, -0.154392184999949],
              [130.68238366000003, -0.169854424999926],
              [130.7177840500001, -0.216973565999922],
              [130.7387801440001, -0.255791924999926],
              [130.7426863940001, -0.27467213299991],
              [130.7509871750001, -0.287530205999929],
              [130.79273522200003, -0.307224216999941],
              [130.8110457690001, -0.318536065999922],
              [130.8154403000001, -0.302178643999923],
              [130.8203231130001, -0.294122002999927],
              [130.8281356130001, -0.291436455999929],
              [130.871918165, -0.293226820999962],
              [130.887054884, -0.296482028999947],
              [130.89372806100005, -0.30201588299991],
              [130.89665774800005, -0.312107028999947],
              [130.90381920700008, -0.317559502999927],
              [130.91285241000003, -0.321058851999908],
              [130.9209090500001, -0.32586028399993],
              [130.92953535200002, -0.336114190999922],
              [130.94011478000004, -0.355889580999929],
              [130.9482528000001, -0.36687590899993],
              [130.94027754, -0.370863539999959],
              [130.93140709700003, -0.379001559999949],
              [130.92400149800005, -0.388604424999926],
              [130.9209090500001, -0.398044528999947],
              [130.91675866000003, -0.406019789999959],
              [130.90650475400003, -0.413018487999921],
              [130.86548912900003, -0.429294528999947],
              [130.7793074880001, -0.445082289999959],
              [130.75603274800005, -0.445977471999925],
              [130.73308353000004, -0.441501559999949],
              [130.71550540500004, -0.428399346999925],
              [130.7060653000001, -0.410251559999949],
              [130.6806746750001, -0.339613539999959],
              [130.69361412900003, -0.33131275799991],
              [130.69597415500004, -0.318129164999959],
              [130.69255618600005, -0.303480726999908],
              [130.68824303500003, -0.291192315999922],
              [130.60914147200003, -0.314060153999947],
              [130.5791121750001, -0.333916924999926],
              [130.56470787900003, -0.373711846999925],
              [130.57154381600003, -0.373711846999925],
              [130.58228600400003, -0.366143487999921],
              [130.5786238940001, -0.383884372999944],
              [130.5615340500001, -0.42701588299991],
              [130.55445397200003, -0.433526299999926],
              [130.5473738940001, -0.436130466999941],
              [130.54420006600003, -0.432061455999929],
              [130.54574629, -0.420179945999962],
              [130.55844160200002, -0.387383721999925],
              [130.54118899800005, -0.38250090899993],
              [130.54053795700008, -0.367933851999908],
              [130.5454207690001, -0.347751559999949],
              [130.54420006600003, -0.32586028399993],
              [130.53793379, -0.316501559999949],
              [130.52222741000003, -0.301934502999927],
              [130.5161238940001, -0.291192315999922],
              [130.51710045700008, -0.282647393999923],
              [130.5224715500001, -0.274834893999923],
              [130.52654056100005, -0.266778252999927],
              [130.52369225400003, -0.257582289999959],
              [130.50660241000003, -0.250258070999962],
              [130.485687696, -0.255303643999923],
              [130.45484459700003, -0.271254164999959],
              [130.4511824880001, -0.274183851999908],
              [130.44450931100005, -0.283135674999926],
              [130.44117272200003, -0.284926039999959],
              [130.4355574880001, -0.28289153399993],
              [130.43238366000003, -0.273695570999962],
              [130.42750084700003, -0.271254164999959],
              [130.40845787900003, -0.269707940999922],
              [130.399750196, -0.267673434999949],
              [130.39275149800005, -0.263848565999922],
              [130.382172071, -0.275648695999962],
              [130.37566165500004, -0.274590752999927],
              [130.37086022200003, -0.267998955999929],
              [130.36597741000003, -0.263848565999922],
              [130.3388778000001, -0.262872002999927],
              [130.33814537900003, -0.263848565999922],
              [130.31625410200002, -0.259942315999922],
              [130.31080162900003, -0.257582289999959],
              [130.30738366000003, -0.251885674999926],
              [130.3046981130001, -0.242771091999941],
              [130.30054772200003, -0.234144789999959],
              [130.29371178500003, -0.230401299999926],
              [130.26539147200003, -0.224786065999922],
              [130.2324324880001, -0.212823174999926],
              [130.21705162900003, -0.20086028399993],
              [130.24195397200003, -0.195570570999962],
              [130.25017337300005, -0.197442315999922],
              [130.2675887380001, -0.206149997999944],
              [130.27662194100003, -0.209242445999962],
              [130.27995853000004, -0.20867278399993],
              [130.3032332690001, -0.20867278399993],
              [130.30396569100003, -0.209242445999962],
              [130.33855228000004, -0.203220309999949],
              [130.35670006600003, -0.201836846999925],
              [130.3691512380001, -0.206149997999944],
              [130.38355553500003, -0.214450778999947],
              [130.39861087300005, -0.214450778999947],
              [130.41285241000003, -0.208428643999923],
              [130.42408287900003, -0.199314059999949],
              [130.42986087300005, -0.186293226999908],
              [130.41667728000004, -0.184177341999941],
              [130.39771569100003, -0.183363539999959],
              [130.38648522200003, -0.17506275799991],
              [130.402679884, -0.169854424999926],
              [130.4121199880001, -0.157321872999944],
              [130.41374759200005, -0.141534112999921],
              [130.4062606130001, -0.127373955999929],
              [130.39771569100003, -0.145928643999923],
              [130.38461347700002, -0.15748463299991],
              [130.3740340500001, -0.155857028999947],
              [130.37224368600005, -0.134209893999923],
              [130.36597741000003, -0.134209893999923],
              [130.3613387380001, -0.143243096999925],
              [130.354828321, -0.146661065999922],
              [130.34693444100003, -0.145440362999921],
              [130.33814537900003, -0.14031340899993],
              [130.34131920700008, -0.154473565999922],
              [130.34750410200002, -0.168389580999929],
              [130.35075931100005, -0.180352471999925],
              [130.34498131600003, -0.18873463299991],
              [130.3330184250001, -0.188246351999908],
              [130.31706790500004, -0.181817315999922],
              [130.303070509, -0.172946872999944],
              [130.29712975400003, -0.165215752999927],
              [130.2939559250001, -0.15203215899993],
              [130.2797957690001, -0.131442966999941],
              [130.27662194100003, -0.117120049999926],
              [130.280609571, -0.104994398999906],
              [130.29078209700003, -0.099216403999947],
              [130.304047071, -0.099867445999962],
              [130.31763756600003, -0.10678476399994],
              [130.32349694100003, -0.102634372999944],
              [130.3291121750001, -0.096612237999921],
              [130.33423912900003, -0.088962497999944],
              [130.33814537900003, -0.079522393999923],
              [130.343109571, -0.093519789999959],
              [130.34498131600003, -0.10906340899993],
              [130.34839928500003, -0.121840101999908],
              [130.35865319100003, -0.127373955999929],
              [130.36866295700008, -0.121840101999908],
              [130.3691512380001, -0.108330987999921],
              [130.3642684250001, -0.092380466999941],
              [130.35865319100003, -0.079522393999923],
              [130.3808699880001, -0.073663018999923],
              [130.39429772200003, -0.082818291999956],
              [130.40699303500003, -0.097263278999947],
              [130.42750084700003, -0.10678476399994],
              [130.42335045700008, -0.086195570999962],
              [130.42066491000003, -0.079522393999923],
              [130.42750084700003, -0.079522393999923],
              [130.42986087300005, -0.086602471999925],
              [130.43433678500003, -0.093194268999923],
              [130.47779381600003, -0.075494072999959],
              [130.4985457690001, -0.062676690999922],
              [130.51002037900003, -0.044732354999951],
              [130.5195418630001, -0.049655856999948],
              [130.52808678500003, -0.056410414999959],
              [130.54420006600003, -0.072686455999929],
              [130.5454207690001, -0.068617445999962],
              [130.55046634200005, -0.058444919999943],
              [130.5527449880001, -0.063083591999941],
              [130.55616295700008, -0.067925713999955],
              [130.55844160200002, -0.072686455999929],
              [130.56080162900003, -0.065606377999927],
              [130.57154381600003, -0.044732354999951],
              [130.57496178500003, -0.048597914999959],
              [130.5864363940001, -0.058444919999943],
              [130.59522545700008, -0.047214450999945],
              [130.62273196700005, -0.051771742999961],
              [130.6411238940001, -0.044732354999951],
              [130.660980665, -0.044732354999951],
              [130.69109134200005, -0.035739841999941],
              [130.71631920700008, -0.033257744999958],
              [130.72234134200005, -0.052178643999923],
              [130.73609459700003, -0.046888929999909],
              [130.76547285200002, -0.049981377999927],
              [130.78386478000004, -0.044732354999951],
              [130.77686608200008, -0.037286065999922],
              [130.768890821, -0.032525322999959],
              [130.7597762380001, -0.03053150799991],
              [130.74968509200005, -0.031101169999943],
              [130.76148522200003, -0.018365166999956],
              [130.77906334700003, -0.008965752999927],
              [130.80062910200002, -0.003838799999926],
              [130.8247176440001, -0.003838799999926],
              [130.9619246750001, -0.044732354999951],
              [130.96656334700003, -0.04810963299991],
              [130.96998131600003, -0.053521416999956],
              [130.9736434250001, -0.05718352699995],
              [130.9790145190001, -0.055352471999925],
              [130.9868270190001, -0.048150322999959],
              [130.990570509, -0.04615650799991],
              [131.01978600400003, -0.038628838999955],
              [131.026703321, -0.037896416999956],
              [131.04460696700005, -0.038262627999927],
              [131.05640709700003, -0.041029554999909],
              [131.05779056100005, -0.049086195999962],
              [131.043793165, -0.065240166999956],
              [131.05982506600003, -0.066420179999909],
              [131.08619225400003, -0.07154713299991],
              [131.11353600400003, -0.073663018999923],
              [131.12671959700003, -0.076429945999962],
              [131.153656446, -0.085707289999959],
              [131.16187584700003, -0.092380466999941],
              [131.1704207690001, -0.101657809999949],
              [131.180023634, -0.110039971999925],
              [131.19157962300005, -0.113702080999929],
              [131.196625196, -0.119235934999949],
              [131.20191491000003, -0.130059502999927],
              [131.21159915500004, -0.137872002999927],
              [131.2295028000001, -0.134209893999923],
              [131.23389733200008, -0.138116143999923],
              [131.23853600400003, -0.139825127999927],
              [131.25367272200003, -0.14031340899993],
              [131.2636824880001, -0.142673434999949],
              [131.26929772200003, -0.147556247999944],
              [131.2739363940001, -0.152439059999949],
              [131.2973738940001, -0.159274997999944],
              [131.30591881600003, -0.171075127999927],
              [131.31820722700002, -0.203057549999926],
              [131.30486087300005, -0.217543226999908],
              [131.2988387380001, -0.226657809999949],
              [131.29761803500003, -0.237237237999921],
            ],
          ],
          [
            [
              [104.92896569100003, -0.237237237999921],
              [105.01148522200003, -0.281508070999962],
              [105.00269616000003, -0.294854424999926],
              [104.98178144600007, -0.29070403399993],
              [104.95655358200003, -0.281182549999926],
              [104.93523196700005, -0.278090101999908],
              [104.91716556100005, -0.287530205999929],
              [104.92017662900008, -0.299004815999922],
              [104.93067467500003, -0.313409112999921],
              [104.93523196700005, -0.332126559999949],
              [104.88168379000007, -0.308363539999959],
              [104.86353600400008, -0.305433851999908],
              [104.85132897200003, -0.301202080999929],
              [104.83285566500007, -0.282403252999927],
              [104.77808678500003, -0.257582289999959],
              [104.76343834700003, -0.242933851999908],
              [104.75074303500003, -0.227146091999941],
              [104.73552493600005, -0.214450778999947],
              [104.71265709700003, -0.209242445999962],
              [104.67090905000003, -0.211602471999925],
              [104.65495853000004, -0.215915622999944],
              [104.64039147200003, -0.223402601999908],
              [104.61695397200003, -0.240329684999949],
              [104.60621178500003, -0.244073174999926],
              [104.60035241000003, -0.243584893999923],
              [104.58513431100005, -0.237237237999921],
              [104.57992597700007, -0.240329684999949],
              [104.57105553500003, -0.248467705999929],
              [104.56299889400003, -0.253513278999947],
              [104.55054772200003, -0.267998955999929],
              [104.54135175900007, -0.271254164999959],
              [104.52865644600007, -0.269952080999929],
              [104.52393639400003, -0.265883070999962],
              [104.52182050900007, -0.259372653999947],
              [104.51742597700007, -0.250176690999922],
              [104.50733483200003, -0.236097914999959],
              [104.49789472700007, -0.228122653999947],
              [104.48389733200003, -0.224379164999959],
              [104.45932050900007, -0.223402601999908],
              [104.44711347700007, -0.220961195999962],
              [104.43995201900003, -0.214288018999923],
              [104.43637129000007, -0.20435963299991],
              [104.43555748800003, -0.192152601999908],
              [104.43726647200003, -0.181084893999923],
              [104.44190514400003, -0.175551039999959],
              [104.45590254000007, -0.168226820999962],
              [104.49447675900007, -0.135674737999921],
              [104.51075280000003, -0.113702080999929],
              [104.51742597700007, -0.089450778999947],
              [104.52507571700005, -0.007745049999926],
              [104.53736412900008, 0.021307684000078],
              [104.55836022200003, 0.003078518000052],
              [104.55982506600003, 0.010158596000053],
              [104.56381269600007, 0.022609768000052],
              [104.56462649800005, 0.030340887000079],
              [104.57162519600007, 0.017645575000074],
              [104.58790123800003, 0.008286851000094],
              [104.62037194100003, -0.004245700999945],
              [104.67554772200003, -0.053806247999944],
              [104.68132571700005, -0.065240166999956],
              [104.64722741000003, -0.072686455999929],
              [104.64722741000003, -0.080743096999925],
              [104.65251712300005, -0.08953215899993],
              [104.65943444100003, -0.096530856999948],
              [104.66456139400003, -0.099379164999959],
              [104.67546634200005, -0.095798434999949],
              [104.68311608200003, -0.089613539999959],
              [104.69190514400003, -0.087497653999947],
              [104.70582116000003, -0.096286716999941],
              [104.73658287900008, -0.127373955999929],
              [104.75391686300003, -0.170586846999925],
              [104.76628665500004, -0.188246351999908],
              [104.78777103000004, -0.195570570999962],
              [104.81413821700005, -0.192803643999923],
              [104.82032311300003, -0.184340101999908],
              [104.81983483200003, -0.16961028399993],
              [104.82593834700003, -0.14771900799991],
              [104.84888756600003, -0.139580987999921],
              [104.87728925900007, -0.166599216999941],
              [104.92896569100003, -0.237237237999921],
            ],
          ],
          [
            [
              [129.53687584700003, -0.134209893999923],
              [129.5576278000001, -0.158786716999941],
              [129.5673934250001, -0.175551039999959],
              [129.57154381600003, -0.192152601999908],
              [129.56820722700002, -0.200127862999921],
              [129.56023196700005, -0.208103122999944],
              [129.54997806100005, -0.21412525799991],
              [129.54029381600003, -0.216729424999926],
              [129.52613366000003, -0.214613539999959],
              [129.51677493600005, -0.208754164999959],
              [129.5019637380001, -0.18873463299991],
              [129.45826256600003, -0.113702080999929],
              [129.37289472700002, -0.079522393999923],
              [129.37037194100003, -0.066338799999926],
              [129.37224368600005, -0.050347588999955],
              [129.3715926440001, -0.03679778399993],
              [129.361664259, -0.031101169999943],
              [129.33757571700005, 0.006781317000048],
              [129.33277428500003, 0.011379299000055],
              [129.31006920700008, 0.02484772300005],
              [129.29908287900003, 0.033433335000041],
              [129.2934676440001, 0.036322333000044],
              [129.29029381600003, 0.040594794000071],
              [129.2934676440001, 0.047674872000073],
              [129.30046634200005, 0.050604559000078],
              [129.30925540500004, 0.048041083000044],
              [129.45980879, -0.080173434999949],
              [129.5127059250001, -0.114353122999944],
              [129.53687584700003, -0.134209893999923],
            ],
          ],
          [
            [
              [127.45997155000009, -0.003838799999926],
              [127.46168053500003, -0.025160414999959],
              [127.46029707100001, -0.038872979999951],
              [127.45289147200003, -0.041029554999909],
              [127.43604576900009, -0.027683200999945],
              [127.43262780000009, -0.020806572999959],
              [127.43189537900003, -0.011569919999943],
              [127.43262780000009, 0.006781317000048],
              [127.42994225400003, 0.008286851000094],
              [127.41285241000003, 0.023504950000074],
              [127.41187584700003, 0.016099351000094],
              [127.40967858200008, 0.010565497000073],
              [127.40552819100003, 0.00649648600006],
              [127.39861087300005, 0.003078518000052],
              [127.39136803500003, 0.02602773600006],
              [127.39136803500003, 0.05304596600007],
              [127.39861087300005, 0.10610586100006],
              [127.40886478000004, 0.147040106000077],
              [127.43881269600001, 0.139715887000079],
              [127.45248457100001, 0.140204169000071],
              [127.44825280000009, 0.134263414000088],
              [127.44019616000003, 0.120266018000052],
              [127.45997155000009, -0.003838799999926],
            ],
          ],
          [
            [
              [104.49708092500003, 0.071275132000039],
              [104.48585045700003, 0.065822658000059],
              [104.47950280000003, 0.063950914000088],
              [104.46957441500007, 0.063788153000075],
              [104.47999108200003, 0.045111395000049],
              [104.48308353000004, 0.035711981000077],
              [104.48340905000003, 0.023504950000074],
              [104.47657311300003, 0.023504950000074],
              [104.45915774800005, 0.047308661000045],
              [104.41138756600003, 0.091701565000051],
              [104.40137780000003, 0.119086005000042],
              [104.40756269600007, 0.119086005000042],
              [104.41187584700003, 0.114569403000075],
              [104.41602623800003, 0.111721096000053],
              [104.42872155000003, 0.10610586100006],
              [104.42359459700003, 0.112209377000056],
              [104.40870201900003, 0.150946356000077],
              [104.40674889400003, 0.161200262000079],
              [104.40788821700005, 0.170599677000041],
              [104.41391035200007, 0.175848700000074],
              [104.42115319100003, 0.172756252000056],
              [104.42839603000004, 0.163763739000046],
              [104.43962649800005, 0.146185614000046],
              [104.49008222700007, 0.082586981000077],
              [104.49708092500003, 0.071275132000039],
            ],
          ],
          [
            [
              [104.68873131600003, 0.071275132000039],
              [104.70785566500007, 0.043646552000041],
              [104.70289147200003, 0.032782294000071],
              [104.68392988400007, 0.036281643000052],
              [104.66089928500003, 0.05141836100006],
              [104.63990319100003, 0.070054429000038],
              [104.63355553500003, 0.078111070000091],
              [104.62614993600005, 0.102240302000041],
              [104.61980228000004, 0.10578034100007],
              [104.60621178500003, 0.091782945000091],
              [104.59522545700003, 0.101629950000074],
              [104.57886803500003, 0.124904690000051],
              [104.56836998800003, 0.136786200000074],
              [104.56576582100007, 0.142726955000057],
              [104.56421959700003, 0.158148505000042],
              [104.56153405000003, 0.161281643000052],
              [104.55339603000004, 0.161525783000059],
              [104.54672285200007, 0.162502346000053],
              [104.54070071700005, 0.165228583000044],
              [104.53419030000003, 0.170599677000041],
              [104.52979576900003, 0.177313544000071],
              [104.52735436300003, 0.189886786000045],
              [104.52491295700003, 0.195461330000057],
              [104.49854576900003, 0.22329336100006],
              [104.49366295700003, 0.231146552000041],
              [104.49024498800003, 0.242621161000045],
              [104.50220787900008, 0.238267320000091],
              [104.51197350400008, 0.232896226000094],
              [104.53109785200007, 0.215969143000052],
              [104.53052819100003, 0.21906159100007],
              [104.53239993600005, 0.222886460000041],
              [104.53549238400007, 0.226385809000078],
              [104.53882897200003, 0.228257554000038],
              [104.54322350400008, 0.227443752000056],
              [104.54810631600003, 0.224310614000046],
              [104.68873131600003, 0.071275132000039],
            ],
          ],
          [
            [
              [104.40552819100003, 0.338812567000048],
              [104.41618899800005, 0.328802802000041],
              [104.42139733200003, 0.317938544000071],
              [104.42017662900008, 0.306301174000055],
              [104.41138756600003, 0.294419664000088],
              [104.40512129000007, 0.292141018000052],
              [104.39958743600005, 0.294989325000074],
              [104.39551842500003, 0.300930080000057],
              [104.39185631600003, 0.316595770000049],
              [104.38689212300005, 0.319281317000048],
              [104.38021894600007, 0.320379950000074],
              [104.37354576900003, 0.32453034100007],
              [104.34693444100003, 0.359930731000077],
              [104.33936608200003, 0.365464585000041],
              [104.34148196700005, 0.366359768000052],
              [104.34831790500004, 0.370510158000059],
              [104.35181725400008, 0.371242580000057],
              [104.35816491000003, 0.368882554000038],
              [104.37623131600003, 0.354315497000073],
              [104.40552819100003, 0.338812567000048],
            ],
          ],
          [
            [
              [127.39869225400003, 0.379584052000041],
              [127.41871178500003, 0.353989976000094],
              [127.41716556100005, 0.312933661000045],
              [127.39625084700003, 0.281073309000078],
              [127.35816491000003, 0.28351471600007],
              [127.34750410200002, 0.296128648000092],
              [127.34107506600003, 0.314642645000049],
              [127.33790123800009, 0.333970445000091],
              [127.33708743600005, 0.348781643000052],
              [127.34327233200008, 0.361395575000074],
              [127.35873457100001, 0.371283270000049],
              [127.37891686300009, 0.37767161700009],
              [127.39869225400003, 0.379584052000041],
            ],
          ],
          [
            [
              [104.21583092500003, 0.708156643000052],
              [104.24146569100003, 0.695379950000074],
              [104.27051842500003, 0.675034898000092],
              [104.28760826900003, 0.650783596000053],
              [104.27735436300003, 0.626166083000044],
              [104.26644941500007, 0.633002020000049],
              [104.26026451900003, 0.643377997000073],
              [104.24984785200007, 0.667181708000044],
              [104.22201582100007, 0.69603099200009],
              [104.21583092500003, 0.708156643000052],
            ],
          ],
          [
            [
              [127.37867272200003, 0.623032945000091],
              [127.37330162900003, 0.633490302000041],
              [127.363617384, 0.648260809000078],
              [127.35865319100003, 0.665838934000078],
              [127.37574303500003, 0.698797919000071],
              [127.38493899800005, 0.757147528000075],
              [127.39454186300009, 0.75259023600006],
              [127.40381920700008, 0.750392971000053],
              [127.41211998800009, 0.751654364000046],
              [127.41846764400009, 0.757147528000075],
              [127.42562910200002, 0.75421784100007],
              [127.43140709700003, 0.750921942000048],
              [127.43604576900009, 0.747219143000052],
              [127.43946373800009, 0.742865302000041],
              [127.44483483200008, 0.727443752000056],
              [127.44825280000009, 0.706610419000071],
              [127.44906660200002, 0.68500397300005],
              [127.44629967500009, 0.667181708000044],
              [127.433929884, 0.652167059000078],
              [127.41089928500003, 0.63226959800005],
              [127.38868248800009, 0.618841864000046],
              [127.37867272200003, 0.623032945000091],
            ],
          ],
          [
            [
              [104.28402754000007, 0.708156643000052],
              [104.27442467500003, 0.70343659100007],
              [104.26482181100005, 0.702215887000079],
              [104.25538170700003, 0.704901434000078],
              [104.23609459700003, 0.718451239000046],
              [104.21452884200005, 0.721177476000094],
              [104.20557701900003, 0.726060289000088],
              [104.19166100400008, 0.745998440000051],
              [104.18824303500003, 0.764471747000073],
              [104.19581139400003, 0.779974677000041],
              [104.21583092500003, 0.79132721600007],
              [104.23389733200003, 0.786444403000075],
              [104.24488366000003, 0.786525783000059],
              [104.24984785200007, 0.794745184000078],
              [104.25416100400008, 0.797837632000039],
              [104.26368248800003, 0.79913971600007],
              [104.27295983200003, 0.796535549000055],
              [104.27735436300003, 0.787909247000073],
              [104.27759850400008, 0.76430898600006],
              [104.27979576900003, 0.747056382000039],
              [104.28589928500003, 0.730373440000051],
              [104.29769941500007, 0.708156643000052],
              [104.28402754000007, 0.708156643000052],
            ],
          ],
          [
            [
              [127.37110436300009, 0.784491278000075],
              [127.36003665500004, 0.76508209800005],
              [127.34693444100003, 0.757391669000071],
              [127.33130944100003, 0.756415106000077],
              [127.312836134, 0.757147528000075],
              [127.30339603000004, 0.764878648000092],
              [127.293304884, 0.78266022300005],
              [127.28565514400009, 0.802150783000059],
              [127.28248131600003, 0.814886786000045],
              [127.28882897200003, 0.836900132000039],
              [127.30486087300005, 0.855169989000046],
              [127.32488040500004, 0.862860419000071],
              [127.36345462300005, 0.840969143000052],
              [127.37435957100001, 0.826239325000074],
              [127.37696373800009, 0.807766018000052],
              [127.37110436300009, 0.784491278000075],
            ],
          ],
          [
            [
              [104.22608483200003, 0.880072333000044],
              [104.24146569100003, 0.877020575000074],
              [104.25782311300003, 0.86859772300005],
              [104.26628665500004, 0.855861721000053],
              [104.25749759200005, 0.839667059000078],
              [104.25025475400008, 0.830023505000042],
              [104.23951256600003, 0.822455145000049],
              [104.18751061300003, 0.799261786000045],
              [104.17644290500004, 0.798488674000055],
              [104.16749108200003, 0.804917710000041],
              [104.16114342500003, 0.818793036000045],
              [104.15601647200003, 0.846380927000041],
              [104.14763431100005, 0.858954169000071],
              [104.13412519600007, 0.867254950000074],
              [104.10718834700003, 0.872992255000042],
              [104.09229576900003, 0.880072333000044],
              [104.09937584700003, 0.894761460000041],
              [104.09400475400008, 0.933091539000088],
              [104.09913170700003, 0.948919989000046],
              [104.11255944100003, 0.95258209800005],
              [104.12769616000003, 0.942531643000052],
              [104.15748131600003, 0.91079336100006],
              [104.16293379000007, 0.901922919000071],
              [104.16635175900007, 0.891791083000044],
              [104.17212975400008, 0.883490302000041],
              [104.18482506600003, 0.880072333000044],
              [104.22608483200003, 0.880072333000044],
            ],
          ],
          [
            [
              [97.92847741000003, 0.996079820000091],
              [97.93921959700003, 0.986070054000038],
              [97.93441816500007, 0.96360911700009],
              [97.91773522200003, 0.927883205000057],
              [97.91773522200003, 0.934637762000079],
              [97.90137780000003, 0.905951239000046],
              [97.89828535200007, 0.87531159100007],
              [97.90406334700003, 0.814886786000045],
              [97.90186608200003, 0.800726630000042],
              [97.89258873800003, 0.777044989000046],
              [97.88453209700003, 0.71820709800005],
              [97.88298587300005, 0.642971096000053],
              [97.87427819100003, 0.622015692000048],
              [97.82715905000003, 0.562689520000049],
              [97.81934655000003, 0.558539130000042],
              [97.80925540500004, 0.560288804000038],
              [97.80030358200003, 0.565497137000079],
              [97.77426191500007, 0.585191148000092],
              [97.76417076900003, 0.567572333000044],
              [97.75228925900007, 0.568345445000091],
              [97.72641035200007, 0.585191148000092],
              [97.72527103000004, 0.580755927000041],
              [97.71534264400003, 0.574448960000041],
              [97.70411217500003, 0.572739976000094],
              [97.69613691500007, 0.586371161000045],
              [97.69044030000003, 0.591620184000078],
              [97.68384850400008, 0.596136786000045],
              [97.67872155000003, 0.598863023000092],
              [97.69092858200003, 0.624212958000044],
              [97.68384850400008, 0.643052476000094],
              [97.66895592500003, 0.658758856000077],
              [97.65821373800003, 0.674627997000073],
              [97.65748131600003, 0.687241929000038],
              [97.65919030000003, 0.715399481000077],
              [97.65455162900008, 0.726060289000088],
              [97.64771569100003, 0.736314195000091],
              [97.63306725400008, 0.769476630000042],
              [97.63038170700003, 0.780747789000088],
              [97.61378014400003, 0.823553778000075],
              [97.57439212300005, 0.860907294000071],
              [97.48633873800003, 0.914211330000057],
              [97.49187259200005, 0.933010158000059],
              [97.47934004000007, 0.943426825000074],
              [97.45736738400007, 0.94798411700009],
              [97.43506920700003, 0.948919989000046],
              [97.39535566500007, 0.944891669000071],
              [97.38884524800005, 0.952093817000048],
              [97.38998457100007, 0.976263739000046],
              [97.38770592500003, 1.018784898000092],
              [97.37159264400003, 1.059759833000044],
              [97.32178795700003, 1.140773830000057],
              [97.31226647200003, 1.166937567000048],
              [97.30827884200005, 1.174872137000079],
              [97.29883873800003, 1.183254299000055],
              [97.28785241000003, 1.190822658000059],
              [97.27857506600003, 1.199693101000094],
              [97.27133222700007, 1.222235419000071],
              [97.25684655000003, 1.23501211100006],
              [97.25359134200005, 1.246893622000073],
              [97.25171959700003, 1.25922272300005],
              [97.24724368600005, 1.26703522300005],
              [97.24057050900007, 1.272406317000048],
              [97.23308353000004, 1.277289130000042],
              [97.22291100400008, 1.28188711100006],
              [97.21265709700003, 1.284328518000052],
              [97.20215905000003, 1.288316148000092],
              [97.19157962300005, 1.297756252000056],
              [97.18580162900008, 1.307766018000052],
              [97.17595462300005, 1.331854559000078],
              [97.16822350400008, 1.342840887000079],
              [97.12842858200003, 1.382635809000078],
              [97.10726972700007, 1.397772528000075],
              [97.08228600400008, 1.407619533000059],
              [97.08228600400008, 1.405340887000079],
              [97.06861412900008, 1.394598700000074],
              [97.06364993600005, 1.415228583000044],
              [97.08041425900007, 1.42914459800005],
              [97.10694420700003, 1.436021226000094],
              [97.13062584700003, 1.435532945000091],
              [97.13949629000007, 1.432196356000077],
              [97.15072675900007, 1.425930080000057],
              [97.16065514400003, 1.41828034100007],
              [97.16480553500003, 1.410711981000077],
              [97.16968834700003, 1.415961005000042],
              [97.18140709700003, 1.416449286000045],
              [97.20582116000003, 1.413804429000038],
              [97.23585045700003, 1.416693427000041],
              [97.25782311300003, 1.423651434000078],
              [97.27735436300003, 1.436224677000041],
              [97.32105553500003, 1.47406647300005],
              [97.33073978000004, 1.486558335000041],
              [97.33480879000007, 1.500148830000057],
              [97.33179772200003, 1.527818101000094],
              [97.33545983200003, 1.537665106000077],
              [97.34978274800005, 1.545396226000094],
              [97.37452233200003, 1.518540757000039],
              [97.39161217500003, 1.508937893000052],
              [97.40748131600003, 1.514064846000053],
              [97.41675866000003, 1.519232489000046],
              [97.42432701900003, 1.514878648000092],
              [97.43799889400003, 1.495266018000052],
              [97.43897545700003, 1.484605210000041],
              [97.44166100400008, 1.479681708000044],
              [97.44727623800003, 1.47687409100007],
              [97.45997155000003, 1.47797272300005],
              [97.47038821700005, 1.475653387000079],
              [97.48170006600003, 1.477443752000056],
              [97.48633873800003, 1.476548570000091],
              [97.48780358200003, 1.473089911000045],
              [97.49146569100003, 1.459784247000073],
              [97.49317467500003, 1.456040757000039],
              [97.51685631600003, 1.431789455000057],
              [97.52418053500003, 1.428127346000053],
              [97.52808678500003, 1.422919012000079],
              [97.53353925900007, 1.39984772300005],
              [97.53988691500007, 1.390570380000042],
              [97.59213300900007, 1.339911200000074],
              [97.60474694100003, 1.322333075000074],
              [97.61654707100007, 1.280910549000055],
              [97.69361412900008, 1.186021226000094],
              [97.71265709700003, 1.172674872000073],
              [97.75733483200003, 1.163885809000078],
              [97.77654056100005, 1.155096747000073],
              [97.79224694100003, 1.14398834800005],
              [97.80225670700003, 1.133286851000094],
              [97.81902103000004, 1.109930731000077],
              [97.82642662900008, 1.096258856000077],
              [97.82943769600007, 1.082098700000074],
              [97.83627363400007, 1.069973049000055],
              [97.85279381600003, 1.065008856000077],
              [97.87281334700003, 1.062486070000091],
              [97.89039147200003, 1.058172919000071],
              [97.90447024800005, 1.044012762000079],
              [97.92221113400007, 1.004339911000045],
              [97.92847741000003, 0.996079820000091],
            ],
          ],
          [
            [
              [125.29509524800005, 1.551662502000056],
              [125.30128014400009, 1.551662502000056],
              [125.30128014400009, 1.531195380000042],
              [125.29639733200008, 1.502752997000073],
              [125.29509524800005, 1.472845770000049],
              [125.29175866000003, 1.465277411000045],
              [125.27711022200003, 1.453070380000042],
              [125.27393639400009, 1.445217190000051],
              [125.26710045700008, 1.413804429000038],
              [125.248383009, 1.40298086100006],
              [125.21599368600005, 1.392726955000057],
              [125.18531334700003, 1.390692450000074],
              [125.17156009200005, 1.404486395000049],
              [125.17465254000001, 1.41547272300005],
              [125.18295332100001, 1.42133209800005],
              [125.20492597700002, 1.428127346000053],
              [125.25001061300009, 1.448635158000059],
              [125.29509524800005, 1.551662502000056],
            ],
          ],
          [
            [
              [127.66602623800009, -0.209242445999962],
              [127.66724694100003, -0.185804945999962],
              [127.68262780000009, -0.144952080999929],
              [127.68653405000009, -0.123874606999948],
              [127.68539472700002, -0.008314710999912],
              [127.68653405000009, 0.003078518000052],
              [127.68946373800009, 0.014837958000044],
              [127.69825280000009, 0.037787177000041],
              [127.70020592500009, 0.047674872000073],
              [127.69752037900003, 0.070786851000094],
              [127.68458092500009, 0.099351304000038],
              [127.67969811300009, 0.119086005000042],
              [127.68067467500009, 0.162258205000057],
              [127.71371504000001, 0.277329820000091],
              [127.71680748800009, 0.296454169000071],
              [127.71558678500003, 0.312567450000074],
              [127.70915774800005, 0.327215887000079],
              [127.69678795700008, 0.342230536000045],
              [127.685883009, 0.346625067000048],
              [127.66423587300005, 0.339789130000042],
              [127.65512129000001, 0.342230536000045],
              [127.61085045700008, 0.379787502000056],
              [127.60865319100003, 0.382879950000074],
              [127.605804884, 0.390448309000078],
              [127.60401451900009, 0.393459377000056],
              [127.58350670700008, 0.407131252000056],
              [127.576508009, 0.415513414000088],
              [127.57227623800009, 0.422349351000094],
              [127.57032311300009, 0.431138414000088],
              [127.56861412900003, 0.462836005000042],
              [127.56104576900009, 0.509426174000055],
              [127.55616295700008, 0.523830471000053],
              [127.55054772200003, 0.529364325000074],
              [127.54249108200008, 0.534654039000088],
              [127.53443444100003, 0.54165273600006],
              [127.52833092500009, 0.551743882000039],
              [127.52686608200008, 0.560614325000074],
              [127.52947024800005, 0.605902411000045],
              [127.54249108200008, 0.667181708000044],
              [127.54737389400009, 0.715399481000077],
              [127.55543053500003, 0.739894924000055],
              [127.58806399800005, 0.76117584800005],
              [127.60466556100005, 0.786037502000056],
              [127.61833743600005, 0.813462632000039],
              [127.62452233200008, 0.832220770000049],
              [127.61158287900003, 0.85773346600007],
              [127.57748457100001, 0.869289455000057],
              [127.53760826900009, 0.87571849200009],
              [127.50782311300009, 0.886216539000088],
              [127.49463951900009, 0.90501536700009],
              [127.49854576900009, 0.922796942000048],
              [127.50879967500009, 0.940375067000048],
              [127.51465905000009, 0.958889065000051],
              [127.51254316500001, 0.968898830000057],
              [127.50359134200005, 0.987209377000056],
              [127.50163821700005, 0.992987372000073],
              [127.49935957100001, 0.996486721000053],
              [127.49000084700003, 0.995998440000051],
              [127.48780358200008, 0.999904690000051],
              [127.48853600400003, 1.018255927000041],
              [127.48780358200008, 1.02407461100006],
              [127.48902428500003, 1.034572658000059],
              [127.49268639400009, 1.044867255000042],
              [127.49195397200003, 1.054917710000041],
              [127.48047936300009, 1.065008856000077],
              [127.47144616000003, 1.065578518000052],
              [127.46290123800009, 1.060614325000074],
              [127.45533287900003, 1.054388739000046],
              [127.44947350400003, 1.051336981000077],
              [127.43213951900009, 1.046820380000042],
              [127.41627037900003, 1.040350653000075],
              [127.40414472700002, 1.042792059000078],
              [127.39861087300005, 1.065008856000077],
              [127.39975019600001, 1.07876211100006],
              [127.40447024800005, 1.087388414000088],
              [127.41098066500001, 1.09516022300005],
              [127.41846764400009, 1.105943101000094],
              [127.42546634200005, 1.120428778000075],
              [127.42741946700005, 1.128485419000071],
              [127.42579186300009, 1.15070221600007],
              [127.42066491000003, 1.163804429000038],
              [127.41000410200002, 1.175523179000038],
              [127.40023847700002, 1.189439195000091],
              [127.39861087300005, 1.209051825000074],
              [127.40593509200005, 1.229885158000059],
              [127.43482506600003, 1.277411200000074],
              [127.46338951900009, 1.314113674000055],
              [127.48780358200008, 1.38031647300005],
              [127.52637780000009, 1.438544012000079],
              [127.54078209700003, 1.475653387000079],
              [127.53199303500003, 1.506903387000079],
              [127.51937910200002, 1.531927802000041],
              [127.52515709700003, 1.556626695000091],
              [127.55616295700008, 1.600043036000045],
              [127.54672285200002, 1.615423895000049],
              [127.54371178500003, 1.622992255000042],
              [127.54249108200008, 1.630438544000071],
              [127.54639733200008, 1.64288971600007],
              [127.55518639400009, 1.648423570000091],
              [127.56430097700002, 1.65102773600006],
              [127.56983483200008, 1.654689846000053],
              [127.57309004000001, 1.664007880000042],
              [127.57488040500004, 1.675279039000088],
              [127.57154381600003, 1.684800523000092],
              [127.55933678500003, 1.688869533000059],
              [127.55567467500009, 1.692531643000052],
              [127.55958092500009, 1.700832424000055],
              [127.56983483200008, 1.715521552000041],
              [127.58090254000001, 1.751776434000078],
              [127.62973066500001, 1.83539459800005],
              [127.654633009, 1.865668036000045],
              [127.67741946700005, 1.907456773000092],
              [127.68995201900009, 1.925279039000088],
              [127.74659264400009, 1.973130601000094],
              [127.76970462300005, 2.008693752000056],
              [127.86109459700003, 2.104437567000048],
              [127.89258873800009, 2.129055080000057],
              [127.89942467500009, 2.137884833000044],
              [127.90430748800009, 2.153998114000046],
              [127.91724694100003, 2.172105210000041],
              [127.93482506600003, 2.187648830000057],
              [127.95411217500009, 2.195868231000077],
              [127.97315514400009, 2.193101304000038],
              [127.98812910200002, 2.18431224200009],
              [128.0039168630001, 2.180609442000048],
              [128.0473738940001, 2.20384349200009],
              [128.0566512380001, 2.192450262000079],
              [128.05681399800005, 2.169907945000091],
              [128.050140821, 2.147528387000079],
              [128.02906334700003, 2.10968659100007],
              [128.0161238940001, 2.093003648000092],
              [128.00464928500003, 2.086004950000074],
              [127.99952233200008, 2.081691799000055],
              [127.994476759, 2.072088934000078],
              [127.98764082100001, 2.062445380000042],
              [127.96461022200003, 2.053615627000056],
              [127.95850670700008, 2.04242584800005],
              [127.95411217500009, 2.017157294000071],
              [127.94336998800009, 1.98078034100007],
              [127.93458092500009, 1.96320221600007],
              [127.92302493600005, 1.95571523600006],
              [127.90495853000004, 1.95343659100007],
              [127.889008009, 1.947333075000074],
              [127.87566165500004, 1.938788153000075],
              [127.86475670700008, 1.929022528000075],
              [127.85661868600005, 1.912502346000053],
              [127.84929446700005, 1.88353099200009],
              [127.84644616000003, 1.851467190000051],
              [127.85173587300005, 1.825384833000044],
              [127.87566165500004, 1.807928778000075],
              [127.94068444100003, 1.800034898000092],
              [127.95411217500009, 1.788153387000079],
              [127.96355228000004, 1.773586330000057],
              [128.00538170700008, 1.739406643000052],
              [128.01490319100003, 1.719224351000094],
              [128.0058699880001, 1.645493882000039],
              [128.002289259, 1.633734442000048],
              [127.99561608200008, 1.627346096000053],
              [128.00147545700008, 1.613836981000077],
              [128.00855553500003, 1.606390692000048],
              [128.01579837300005, 1.600775458000044],
              [128.02222741000003, 1.592596747000073],
              [128.02719160200002, 1.580552476000094],
              [128.03532962300005, 1.537990627000056],
              [128.0322371750001, 1.516994533000059],
              [128.015961134, 1.464178778000075],
              [128.01490319100003, 1.435532945000091],
              [128.01636803500003, 1.404038804000038],
              [128.01490319100003, 1.394598700000074],
              [128.01059004, 1.389349677000041],
              [128.00416100400003, 1.38540273600006],
              [127.99822024800005, 1.380072333000044],
              [127.99561608200008, 1.370754299000055],
              [127.99984785200002, 1.35228099200009],
              [128.01539147200003, 1.317287502000056],
              [128.01490319100003, 1.305243231000077],
              [128.00611412900003, 1.299872137000079],
              [127.98292076900009, 1.300360419000071],
              [127.97388756600003, 1.297756252000056],
              [127.96949303500003, 1.290432033000059],
              [127.95850670700008, 1.264593817000048],
              [127.95069420700008, 1.253729559000078],
              [127.93140709700003, 1.233791408000059],
              [127.91911868600005, 1.216050523000092],
              [127.89942467500009, 1.174872137000079],
              [127.89527428500003, 1.162990627000056],
              [127.89429772200003, 1.156642971000053],
              [127.89063561300009, 1.152411200000074],
              [127.87826582100001, 1.146958726000094],
              [127.86744225400003, 1.145697333000044],
              [127.84359785200002, 1.147772528000075],
              [127.83399498800009, 1.143866278000075],
              [127.75489342500009, 1.078599351000094],
              [127.67107181100005, 1.031805731000077],
              [127.63754316500001, 1.00071849200009],
              [127.62452233200008, 0.955145575000074],
              [127.62761478000004, 0.937404690000051],
              [127.63550866000003, 0.918931382000039],
              [127.64535566500001, 0.902411200000074],
              [127.65512129000001, 0.890041408000059],
              [127.67009524800005, 0.878973700000074],
              [127.705414259, 0.863714911000045],
              [127.72071373800009, 0.852728583000044],
              [127.72543379000001, 0.845404364000046],
              [127.73511803500003, 0.825913804000038],
              [127.74187259200005, 0.818019924000055],
              [127.750336134, 0.81476471600007],
              [127.75912519600001, 0.815659898000092],
              [127.76856530000009, 0.815375067000048],
              [127.79566491000003, 0.799058335000041],
              [127.81560306100005, 0.799058335000041],
              [127.83545983200008, 0.804632880000042],
              [127.85173587300005, 0.811753648000092],
              [127.87240644600001, 0.823960679000038],
              [127.906586134, 0.852484442000048],
              [127.92302493600005, 0.869818427000041],
              [127.92758222700002, 0.885158596000053],
              [127.93295332100001, 0.973211981000077],
              [127.93230228000004, 0.989935614000046],
              [127.93637129000001, 1.007310289000088],
              [127.99390709700003, 1.082993882000039],
              [128.01490319100003, 1.099798895000049],
              [128.035492384, 1.112127997000073],
              [128.05494225400003, 1.120428778000075],
              [128.07569420700008, 1.125067450000074],
              [128.14478600400003, 1.124660549000055],
              [128.1606551440001, 1.132147528000075],
              [128.17945397200003, 1.154445705000057],
              [128.1923934250001, 1.177435614000046],
              [128.19605553500003, 1.196437893000052],
              [128.19060306100005, 1.214056708000044],
              [128.1762801440001, 1.232977606000077],
              [128.15650475400003, 1.241766669000071],
              [128.113617384, 1.231838283000059],
              [128.09742272200003, 1.236314195000091],
              [128.09205162900003, 1.25726959800005],
              [128.10710696700005, 1.276434637000079],
              [128.14210045700008, 1.301459052000041],
              [128.15455162900003, 1.319281317000048],
              [128.17448978000004, 1.356634833000044],
              [128.18677819100003, 1.374172268000052],
              [128.20460045700008, 1.389960028000075],
              [128.2470809250001, 1.416489976000094],
              [128.26531009200005, 1.431830145000049],
              [128.28239993600005, 1.442613023000092],
              [128.3261824880001, 1.456610419000071],
              [128.34449303500003, 1.469142971000053],
              [128.35027103000004, 1.477932033000059],
              [128.35767662900003, 1.495062567000048],
              [128.36491946700005, 1.503241278000075],
              [128.37273196700005, 1.507473049000055],
              [128.3935653000001, 1.515041408000059],
              [128.41716556100005, 1.530585028000075],
              [128.43726647200003, 1.539292710000041],
              [128.45972741000003, 1.544989325000074],
              [128.48161868600005, 1.545396226000094],
              [128.48894290500004, 1.542181708000044],
              [128.49333743600005, 1.536932684000078],
              [128.4985457690001, 1.532294012000079],
              [128.50904381600003, 1.531195380000042],
              [128.51929772200003, 1.535589911000045],
              [128.5273543630001, 1.544256903000075],
              [128.53931725400003, 1.561916408000059],
              [128.5537215500001, 1.568426825000074],
              [128.60466556100005, 1.57689036700009],
              [128.64722741000003, 1.579006252000056],
              [128.71949303500003, 1.57062409100007],
              [128.72478274800005, 1.565985419000071],
              [128.72730553500003, 1.558579820000091],
              [128.72803795700008, 1.548529364000046],
              [128.72478274800005, 1.541978257000039],
              [128.70069420700008, 1.523667710000041],
              [128.6875106130001, 1.503241278000075],
              [128.683929884, 1.483343817000048],
              [128.68637129, 1.445217190000051],
              [128.68913821700005, 1.436753648000092],
              [128.69548587300005, 1.429754950000074],
              [128.71461022200003, 1.414618231000077],
              [128.72681725400003, 1.408758856000077],
              [128.74097741000003, 1.404852606000077],
              [128.74333743600005, 1.398382880000042],
              [128.74170983200008, 1.387152411000045],
              [128.74577884200005, 1.36945221600007],
              [128.74830162900003, 1.34406159100007],
              [128.7465926440001, 1.321275132000039],
              [128.7382918630001, 1.311468817000048],
              [128.7212020190001, 1.304185289000088],
              [128.7158309250001, 1.286525783000059],
              [128.71436608200008, 1.243150132000039],
              [128.70240319100003, 1.193752346000053],
              [128.70069420700008, 1.171128648000092],
              [128.70850670700008, 1.103461005000042],
              [128.70687910200002, 1.085516669000071],
              [128.7036238940001, 1.075018622000073],
              [128.7011824880001, 1.070868231000077],
              [128.68637129, 1.065008856000077],
              [128.6762801440001, 1.063706773000092],
              [128.6626082690001, 1.063788153000075],
              [128.65064537900003, 1.06195709800005],
              [128.6455184250001, 1.054754950000074],
              [128.563324415, 1.007391669000071],
              [128.5488387380001, 0.996039130000042],
              [128.54249108200008, 0.986517645000049],
              [128.5332137380001, 0.979437567000048],
              [128.47478274800005, 0.962591864000046],
              [128.45289147200003, 0.941229559000078],
              [128.439789259, 0.931789455000057],
              [128.42335045700008, 0.927883205000057],
              [128.40398196700005, 0.925482489000046],
              [128.3154403000001, 0.901556708000044],
              [128.30046634200005, 0.893744208000044],
              [128.2920028000001, 0.879868882000039],
              [128.28931725400003, 0.855861721000053],
              [128.29639733200008, 0.835760809000078],
              [128.29835045700008, 0.823431708000044],
              [128.2929793630001, 0.818019924000055],
              [128.280609571, 0.820461330000057],
              [128.25945071700005, 0.830633856000077],
              [128.24878991000003, 0.832220770000049],
              [128.231781446, 0.826076565000051],
              [128.22095787900003, 0.812689520000049],
              [128.21509850400003, 0.794623114000046],
              [128.21355228000004, 0.773911851000094],
              [128.21949303500003, 0.758368231000077],
              [128.23422285200002, 0.742621161000045],
              [128.26872806100005, 0.71556224200009],
              [128.29517662900003, 0.684637762000079],
              [128.3134871750001, 0.668158270000049],
              [128.34343509200005, 0.657782294000071],
              [128.364593946, 0.643622137000079],
              [128.37517337300005, 0.640448309000078],
              [128.40886478000004, 0.641546942000048],
              [128.43628991000003, 0.638861395000049],
              [128.44288170700008, 0.636419989000046],
              [128.450531446, 0.629584052000041],
              [128.46664472700002, 0.611517645000049],
              [128.4765731130001, 0.602728583000044],
              [128.48503665500004, 0.598863023000092],
              [128.52019290500004, 0.594427802000041],
              [128.53931725400003, 0.589097398000092],
              [128.57056725400003, 0.570257880000042],
              [128.58545983200008, 0.568508205000057],
              [128.60035241000003, 0.570868231000077],
              [128.6181746750001, 0.571600653000075],
              [128.62956790500004, 0.567450262000079],
              [128.641449415, 0.560980536000045],
              [128.65406334700003, 0.55805084800005],
              [128.66667728000004, 0.56476471600007],
              [128.68083743600005, 0.554510809000078],
              [128.68433678500003, 0.541693427000041],
              [128.6801863940001, 0.51007721600007],
              [128.6777449880001, 0.504828192000048],
              [128.67359459700003, 0.499579169000071],
              [128.67172285200002, 0.493719794000071],
              [128.6816512380001, 0.479315497000073],
              [128.6845809250001, 0.470689195000091],
              [128.6860457690001, 0.461371161000045],
              [128.68539472700002, 0.382025458000044],
              [128.69011478000004, 0.346991278000075],
              [128.70386803500003, 0.332017320000091],
              [128.7622176440001, 0.321437893000052],
              [128.7705184250001, 0.315904039000088],
              [128.8242293630001, 0.31085846600007],
              [128.85043379, 0.289862372000073],
              [128.879730665, 0.255845445000091],
              [128.90015709700003, 0.221991278000075],
              [128.89958743600005, 0.207790432000081],
              [128.86117597700002, 0.243557033000059],
              [128.84791100400003, 0.250067450000074],
              [128.83415774800005, 0.251532294000071],
              [128.70036868600005, 0.290961005000042],
              [128.6801863940001, 0.28351471600007],
              [128.6567488940001, 0.297023830000057],
              [128.62867272200003, 0.30805084800005],
              [128.59791100400003, 0.315619208000044],
              [128.56666100400003, 0.318304755000042],
              [128.5376082690001, 0.326849677000041],
              [128.51343834700003, 0.346828518000052],
              [128.47478274800005, 0.387193101000094],
              [128.46111087300005, 0.39484284100007],
              [128.449554884, 0.39679596600007],
              [128.41960696700005, 0.393459377000056],
              [128.4028426440001, 0.393500067000048],
              [128.37671959700003, 0.398871161000045],
              [128.36150149800005, 0.400213934000078],
              [128.29460696700005, 0.38898346600007],
              [128.2622176440001, 0.39134349200009],
              [128.23462975400003, 0.413967190000051],
              [128.21021569100003, 0.406805731000077],
              [128.1879988940001, 0.420843817000048],
              [128.1684676440001, 0.441880601000094],
              [128.15202884200005, 0.455511786000045],
              [128.0703231130001, 0.463364976000094],
              [128.05591881600003, 0.461737372000073],
              [128.031586134, 0.47134023600006],
              [127.97868899800005, 0.472560940000051],
              [127.96021569100003, 0.482814846000053],
              [127.94109134200005, 0.465806382000039],
              [127.92335045700008, 0.45343659100007],
              [127.910492384, 0.437689520000049],
              [127.89649498800009, 0.355658270000049],
              [127.88282311300009, 0.335923570000091],
              [127.87826582100001, 0.32453034100007],
              [127.88086998800009, 0.301743882000039],
              [127.90609785200002, 0.275376695000091],
              [127.91236412900003, 0.253485419000071],
              [127.92123457100001, 0.145575262000079],
              [127.91920006600003, 0.131333726000094],
              [127.91146894600001, 0.118882554000038],
              [127.89576256600003, 0.102362372000073],
              [127.88786868600005, 0.087469794000071],
              [127.88461347700002, 0.06704336100006],
              [127.88575280000009, 0.023504950000074],
              [127.89242597700002, -0.017185153999947],
              [127.90381920700008, -0.049493096999925],
              [127.93344160200002, -0.10678476399994],
              [127.95460045700008, -0.163506768999923],
              [127.97315514400009, -0.196872653999947],
              [127.97657311300009, -0.243340752999927],
              [127.98072350400003, -0.263848565999922],
              [127.99170983200008, -0.281426690999922],
              [128.01734459700003, -0.312595309999949],
              [128.02222741000003, -0.329034112999921],
              [128.02418053500003, -0.349786065999922],
              [128.035492384, -0.395928643999923],
              [128.04273522200003, -0.41529713299991],
              [128.0844832690001, -0.480889580999929],
              [128.09636478000004, -0.51726653399993],
              [128.12574303500003, -0.543633721999925],
              [128.13892662900003, -0.558689059999949],
              [128.22779381600003, -0.709567966999941],
              [128.28199303500003, -0.766208591999941],
              [128.33765709700003, -0.812595309999949],
              [128.34742272200003, -0.823418877999927],
              [128.36890709700003, -0.852715752999927],
              [128.38542728000004, -0.867120049999926],
              [128.4204207690001, -0.883070570999962],
              [128.43539472700002, -0.893324476999908],
              [128.44068444100003, -0.908786716999941],
              [128.43327884200005, -0.908786716999941],
              [128.40601647200003, -0.89226653399993],
              [128.37086022200003, -0.884860934999949],
              [128.28402754, -0.87818775799991],
              [128.26636803500003, -0.873711846999925],
              [128.2509871750001, -0.866794528999947],
              [128.23804772200003, -0.857028903999947],
              [128.228851759, -0.839939059999949],
              [128.23511803500003, -0.829034112999921],
              [128.24870853000004, -0.826104424999926],
              [128.26189212300005, -0.833103122999944],
              [128.26872806100005, -0.833103122999944],
              [128.24952233200008, -0.796482028999947],
              [128.203949415, -0.769463799999926],
              [128.0488387380001, -0.712823174999926],
              [128.0322371750001, -0.699314059999949],
              [128.02068118600005, -0.682061455999929],
              [127.96851647200003, -0.559502862999921],
              [127.91236412900003, -0.476739190999922],
              [127.88559004000001, -0.406019789999959],
              [127.86882571700005, -0.389336846999925],
              [127.85132897200003, -0.365492445999962],
              [127.84083092500009, -0.360039971999925],
              [127.83220462300005, -0.357517184999949],
              [127.77759850400003, -0.328057549999926],
              [127.74146569100003, -0.303399346999925],
              [127.72413170700008, -0.298597914999959],
              [127.70834394600001, -0.287041924999926],
              [127.68881269600001, -0.260186455999929],
              [127.67237389400009, -0.23015715899993],
              [127.66602623800009, -0.209242445999962],
            ],
          ],
          [
            [
              [125.43213951900009, 2.387681382000039],
              [125.45069420700008, 2.377915757000039],
              [125.45622806100005, 2.367743231000077],
              [125.45264733200008, 2.333075262000079],
              [125.42310631600003, 2.31712474200009],
              [125.39234459700003, 2.325669664000088],
              [125.37094160200002, 2.348130601000094],
              [125.369476759, 2.374090887000079],
              [125.38062584700003, 2.385728257000039],
              [125.396820509, 2.391424872000073],
              [125.41504967500009, 2.391831773000092],
              [125.43213951900009, 2.387681382000039],
            ],
          ],
          [
            [
              [128.68637129, 2.483954169000071],
              [128.69450931100005, 2.438869533000059],
              [128.6816512380001, 2.39907461100006],
              [128.66081790500004, 2.362290757000039],
              [128.6455184250001, 2.326239325000074],
              [128.64210045700008, 2.26117584800005],
              [128.58521569100003, 2.154852606000077],
              [128.57300866000003, 2.120591539000088],
              [128.56666100400003, 2.109930731000077],
              [128.50953209700003, 2.062445380000042],
              [128.4902449880001, 2.054266669000071],
              [128.34498131600003, 2.039943752000056],
              [128.33082116000003, 2.034857489000046],
              [128.31706790500004, 2.019720770000049],
              [128.2895613940001, 2.00141022300005],
              [128.26905358200008, 1.995347398000092],
              [128.27556399800005, 2.017157294000071],
              [128.28858483200008, 2.039618231000077],
              [128.2837020190001, 2.057603257000039],
              [128.2519637380001, 2.089422919000071],
              [128.2461043630001, 2.106146552000041],
              [128.24878991000003, 2.175441799000055],
              [128.24146569100003, 2.222479559000078],
              [128.23210696700005, 2.24681224200009],
              [128.217133009, 2.257391669000071],
              [128.19711347700002, 2.266180731000077],
              [128.20777428500003, 2.286525783000059],
              [128.24878991000003, 2.326239325000074],
              [128.27662194100003, 2.368719794000071],
              [128.321136915, 2.458644924000055],
              [128.35808353000004, 2.497544664000088],
              [128.400726759, 2.518377997000073],
              [128.41944420700008, 2.532619533000059],
              [128.430023634, 2.567572333000044],
              [128.43767337300005, 2.575669664000088],
              [128.457367384, 2.590073960000041],
              [128.46656334700003, 2.594305731000077],
              [128.47478274800005, 2.590765692000048],
              [128.48845462300005, 2.57953522300005],
              [128.51514733200008, 2.573391018000052],
              [128.52515709700003, 2.582424221000053],
              [128.53142337300005, 2.601141669000071],
              [128.5459090500001, 2.623846747000073],
              [128.5664168630001, 2.633612372000073],
              [128.58326256600003, 2.625189520000049],
              [128.596039259, 2.608587958000044],
              [128.6201278000001, 2.560451565000051],
              [128.63038170700008, 2.544623114000046],
              [128.64210045700008, 2.537909247000073],
              [128.68637129, 2.483954169000071],
            ],
          ],
          [
            [
              [125.44361412900003, 2.793036200000074],
              [125.45101972700002, 2.778387762000079],
              [125.45045006600003, 2.764837958000044],
              [125.44304446700005, 2.75259023600006],
              [125.41602623800009, 2.73078034100007],
              [125.40967858200008, 2.724514065000051],
              [125.40495853000004, 2.716701565000051],
              [125.40186608200008, 2.69993724200009],
              [125.406586134, 2.686346747000073],
              [125.41846764400009, 2.668890692000048],
              [125.42188561300009, 2.657212632000039],
              [125.42367597700002, 2.644720770000049],
              [125.42107181100005, 2.633937893000052],
              [125.41114342500009, 2.62726471600007],
              [125.39258873800009, 2.628892320000091],
              [125.38257897200003, 2.641831773000092],
              [125.37826582100001, 2.660345770000049],
              [125.37761478000004, 2.678778387000079],
              [125.37427819100003, 2.693101304000038],
              [125.359711134, 2.723089911000045],
              [125.35645592500009, 2.74054596600007],
              [125.36011803500003, 2.753322658000059],
              [125.37891686300009, 2.790961005000042],
              [125.38721764400009, 2.802394924000055],
              [125.40162194100003, 2.810207424000055],
              [125.41700280000009, 2.810248114000046],
              [125.43148847700002, 2.804103908000059],
              [125.44361412900003, 2.793036200000074],
            ],
          ],
          [
            [
              [125.65251712300005, 3.469631252000056],
              [125.65552819100003, 3.461737372000073],
              [125.66342207100001, 3.446112372000073],
              [125.66578209700003, 3.438788153000075],
              [125.66456139400009, 3.430894273000092],
              [125.65951582100001, 3.424790757000039],
              [125.62435957100001, 3.397650458000044],
              [125.61719811300009, 3.395086981000077],
              [125.60271243600005, 3.398098049000055],
              [125.59913170700008, 3.405503648000092],
              [125.59839928500003, 3.41547272300005],
              [125.59302819100003, 3.42609284100007],
              [125.57203209700003, 3.43813711100006],
              [125.52418053500003, 3.450588283000059],
              [125.50733483200008, 3.463324286000045],
              [125.50505618600005, 3.48078034100007],
              [125.51392662900003, 3.529120184000078],
              [125.51758873800009, 3.539048570000091],
              [125.52076256600003, 3.544012762000079],
              [125.52100670700008, 3.576971747000073],
              [125.51734459700003, 3.58234284100007],
              [125.49366295700008, 3.59438711100006],
              [125.44214928500003, 3.637762762000079],
              [125.43051191500001, 3.651353257000039],
              [125.42115319100003, 3.668036200000074],
              [125.41651451900009, 3.687567450000074],
              [125.41846764400009, 3.709784247000073],
              [125.44206790500004, 3.736558335000041],
              [125.47779381600003, 3.73078034100007],
              [125.51295006600003, 3.707912502000056],
              [125.53451582100001, 3.68305084800005],
              [125.56999759200005, 3.628119208000044],
              [125.57545006600003, 3.61078522300005],
              [125.574554884, 3.604396877000056],
              [125.57300866000003, 3.598456122000073],
              [125.572601759, 3.59125397300005],
              [125.57545006600003, 3.580633856000077],
              [125.57976321700005, 3.575873114000046],
              [125.59652754000001, 3.560980536000045],
              [125.60352623800009, 3.552720445000091],
              [125.61378014400009, 3.525376695000091],
              [125.61654707100001, 3.523016669000071],
              [125.627289259, 3.51821523600006],
              [125.63892662900003, 3.514349677000041],
              [125.64437910200002, 3.514878648000092],
              [125.64698326900009, 3.492010809000078],
              [125.65251712300005, 3.469631252000056],
            ],
          ],
          [
            [
              [126.74399309, 3.853385379000088],
              [126.78026560600006, 3.843554032000043],
              [126.81158808600003, 3.82386568000004],
              [126.83300521500007, 3.795958589000065],
              [126.84288583400007, 3.779539954000086],
              [126.85605696000005, 3.758195233000038],
              [126.8379150720001, 3.743390532000092],
              [126.81153026000004, 3.731861627000058],
              [126.7653818440001, 3.772892250000041],
              [126.739012355, 3.823800694000056],
              [126.74399309, 3.853385379000088],
            ],
          ],
          [
            [
              [126.6565467590001, 3.981478084000059],
              [126.70107204300007, 3.93385124100007],
              [126.71262861800005, 3.920714118000092],
              [126.71427584700007, 3.901001649000079],
              [126.7010539910001, 3.879630668000061],
              [126.68785141700005, 3.853330733000064],
              [126.696088573, 3.812256189000038],
              [126.67792364500008, 3.812235590000057],
              [126.66968603400005, 3.854956748000063],
              [126.66143107800008, 3.897676902000057],
              [126.66639148400009, 3.930547457000046],
              [126.64821454700007, 3.951896161000093],
              [126.62672243600002, 3.965031270000054],
              [126.62009585600003, 3.991323517000069],
              [126.61346434300003, 4.025835761000053],
              [126.6151077190001, 4.04391471200006],
              [126.64322211600006, 4.027484228000048],
              [126.6565467590001, 3.981478084000059],
            ],
          ],
          [
            [
              [126.87070871900005, 4.331393328000047],
              [126.90042581300008, 4.306702378000068],
              [126.92212975400003, 4.282049872000073],
              [126.86353600400003, 4.210638739000046],
              [126.80987476200005, 4.157243649000065],
              [126.8083074000001, 4.08661131100007],
              [126.80997871500006, 4.037348902000076],
              [126.79843750500004, 4.017644473000075],
              [126.75889699200002, 3.993006460000061],
              [126.71452884200005, 4.011623440000051],
              [126.67641998500005, 4.004482550000091],
              [126.6647620230001, 4.034055368000054],
              [126.67628605300001, 4.060346120000077],
              [126.69118589000004, 4.078410261000045],
              [126.72092916300005, 4.096468192000088],
              [126.75869722000004, 4.185200129000066],
              [126.80320654700006, 4.222968111000057],
              [126.79163159300003, 4.241055919000075],
              [126.7767722750001, 4.245998363000069],
              [126.75860813200006, 4.250943112000073],
              [126.7107003320001, 4.264137215000062],
              [126.70735641200008, 4.28716412700004],
              [126.71565150200001, 4.308494709000058],
              [126.70720462300005, 4.333563544000071],
              [126.70337975400003, 4.343247789000088],
              [126.69996178500003, 4.355454820000091],
              [126.69922936300009, 4.36790599200009],
              [126.69720714800007, 4.397426780000046],
              [126.70540705600001, 4.423747300000059],
              [126.73951256600003, 4.473089911000045],
              [126.74073326900009, 4.480169989000046],
              [126.74122155000009, 4.491888739000046],
              [126.74008222700002, 4.501695054000038],
              [126.73487389400009, 4.523871161000045],
              [126.73373457100001, 4.53587474200009],
              [126.74439537900003, 4.545599677000041],
              [126.76872806100005, 4.550279039000088],
              [126.79639733200008, 4.550482489000046],
              [126.81625410200002, 4.546454169000071],
              [126.82984459700003, 4.537054755000042],
              [126.83334394600001, 4.527736721000053],
              [126.83513431100005, 4.517523505000042],
              [126.84302819100003, 4.504868882000039],
              [126.85572350400003, 4.498277085000041],
              [126.86695397200003, 4.497992255000042],
              [126.87501061300009, 4.494330145000049],
              [126.877289259, 4.478013414000088],
              [126.87720787900003, 4.478176174000055],
              [126.88477623800009, 4.456854559000078],
              [126.87907962300005, 4.43585846600007],
              [126.86890709700003, 4.41437409100007],
              [126.86353600400003, 4.391913153000075],
              [126.85912907900001, 4.367569102000061],
              [126.87070871900005, 4.331393328000047],
            ],
          ],
          [
            [
              [122.36085045700008, -8.43287525799991],
              [122.387054884, -8.43564218499995],
              [122.41016686300009, -8.443942966999941],
              [122.42074629000001, -8.460137627999927],
              [122.40919030000009, -8.486748955999929],
              [122.37680097700002, -8.50172291499996],
              [122.35222415500004, -8.48015715899993],
              [122.34392337300005, -8.448418877999927],
              [122.36085045700008, -8.43287525799991],
            ],
          ],
          [
            [
              [121.71029707100001, -8.28875090899993],
              [121.73406009200005, -8.293145440999922],
              [121.74529056100005, -8.311700127999927],
              [121.74439537900003, -8.334405205999929],
              [121.73145592500009, -8.350762627999927],
              [121.70899498800009, -8.35475025799991],
              [121.69385826900009, -8.344333591999941],
              [121.676117384, -8.309258721999925],
              [121.68531334700003, -8.303806247999944],
              [121.69166100400003, -8.29778411299992],
              [121.69874108200008, -8.29225025799991],
              [121.71029707100001, -8.28875090899993],
            ],
          ],
          [
            [
              [121.77979576900009, -7.34343840899993],
              [121.81820722700002, -7.333591403999947],
              [121.83708743600005, -7.356540622999944],
              [121.83480879000001, -7.388278903999947],
              [121.81031334700003, -7.404229424999926],
              [121.77588951900009, -7.416924737999921],
              [121.75904381600003, -7.415785414999959],
              [121.75180097700002, -7.394301039999959],
              [121.75407962300005, -7.379082940999922],
              [121.75993899800005, -7.363539320999905],
              [121.76889082100001, -7.350762627999927],
              [121.77979576900009, -7.34343840899993],
            ],
          ],
          [
            [
              [114.59376061300009, -7.13054778399993],
              [114.60474694100003, -7.130629164999959],
              [114.61459394600001, -7.13209400799991],
              [114.62183678500003, -7.137302341999941],
              [114.62452233200008, -7.147881768999923],
              [114.62305748800009, -7.163262627999927],
              [114.61882571700005, -7.16725025799991],
              [114.53272545700008, -7.158461195999905],
              [114.51124108200008, -7.159274997999944],
              [114.50017337300005, -7.158298434999949],
              [114.49537194100003, -7.154717705999929],
              [114.49634850400003, -7.14381275799991],
              [114.49919681100005, -7.137872002999927],
              [114.50464928500003, -7.134372653999947],
              [114.54102623800009, -7.118584893999923],
              [114.55005944100003, -7.11687590899993],
              [114.55909264400009, -7.119073174999926],
              [114.58130944100003, -7.128350518999923],
              [114.59376061300009, -7.13054778399993],
            ],
          ],
          [
            [
              [114.36925548200009, -7.08958267099996],
              [114.38306849500009, -7.113356878999923],
              [114.39685522900004, -7.131462291999924],
              [114.39465789400003, -7.15756483499996],
              [114.39185631600003, -7.178887627999927],
              [114.37826582100001, -7.178155205999929],
              [114.35726972700002, -7.167413018999923],
              [114.33179772200003, -7.159356377999927],
              [114.32520592500009, -7.147637627999927],
              [114.30655821900007, -7.14877918399992],
              [114.29282201900003, -7.143151295999928],
              [114.28476081600002, -7.12616477399996],
              [114.27324774500005, -7.101247319999914],
              [114.26976204800008, -7.080834943999946],
              [114.29482566800004, -7.054665923999949],
              [114.32225455000003, -7.050030942999911],
              [114.34294681100005, -7.055759372999944],
              [114.35775148900007, -7.069202446999952],
              [114.36925548200009, -7.08958267099996],
            ],
          ],
          [
            [
              [123.36573326900009, -1.67310963299991],
              [123.37614993600005, -1.678806247999944],
              [123.38200931100005, -1.689629815999922],
              [123.38282311300009, -1.702243747999944],
              [123.37818444100003, -1.712823174999926],
              [123.36980228000004, -1.719903252999927],
              [123.35027103000004, -1.730889580999929],
              [123.34180748800009, -1.73796965899993],
              [123.31771894600001, -1.774509372999944],
              [123.30128014400009, -1.78834400799991],
              [123.28028405000009, -1.785821221999925],
              [123.27100670700008, -1.769301039999959],
              [123.27979576900009, -1.748223565999922],
              [123.33025149800005, -1.694919528999947],
              [123.35613040500004, -1.675876559999949],
              [123.36109459700003, -1.673760674999926],
              [123.36573326900009, -1.67310963299991],
            ],
          ],
          [
            [
              [122.13941491000003, -0.384209893999923],
              [122.12387129000001, -0.392673434999949],
              [122.11500084700003, -0.388929945999962],
              [122.10718834700003, -0.382256768999923],
              [122.09473717500009, -0.381117445999962],
              [122.08985436300009, -0.389255466999941],
              [122.08887780000009, -0.401543877999927],
              [122.08464603000004, -0.407810153999947],
              [122.07056725400003, -0.398044528999947],
              [122.05990644600001, -0.353936455999929],
              [122.06031334700003, -0.329278252999927],
              [122.06560306100005, -0.296075127999927],
              [122.07667076900009, -0.269138278999947],
              [122.09473717500009, -0.263848565999922],
              [122.10157311300009, -0.315362237999921],
              [122.105804884, -0.321384372999944],
              [122.13168379000001, -0.337985934999949],
              [122.13795006600003, -0.347263278999947],
              [122.14323978000004, -0.360446872999944],
              [122.14454186300009, -0.373955987999921],
              [122.13941491000003, -0.384209893999923],
            ],
          ],
          [
            [
              [130.06666100400003, -7.762627862999921],
              [130.077484571, -7.765883070999905],
              [130.08375084700003, -7.772556247999944],
              [130.08033287900003, -7.787367445999905],
              [130.06592858200008, -7.787855726999908],
              [130.05250084700003, -7.777113539999959],
              [130.04517662900003, -7.77507903399993],
              [130.03248131600003, -7.774997653999947],
              [130.02564537900003, -7.772556247999944],
              [130.02906334700003, -7.767836195999905],
              [130.03093509200005, -7.762627862999921],
              [130.0371199880001, -7.761651299999926],
              [130.0468856130001, -7.76336028399993],
              [130.05591881600003, -7.761488539999959],
              [130.06666100400003, -7.762627862999921],
            ],
          ],
          [
            [
              [130.0078231130001, -7.724867445999905],
              [130.01539147200003, -7.744073174999926],
              [130.00847415500004, -7.750420830999929],
              [129.99724368600005, -7.748223565999922],
              [129.9941512380001, -7.744398695999905],
              [129.9926863940001, -7.738539320999905],
              [129.98316491000003, -7.732354424999926],
              [129.97974694100003, -7.722100518999923],
              [129.978851759, -7.712660414999959],
              [129.98259524800005, -7.704847914999959],
              [129.99195397200003, -7.702080987999921],
              [130.0009871750001, -7.70671965899993],
              [130.0058699880001, -7.714043877999927],
              [130.0078231130001, -7.724867445999905],
            ],
          ],
          [
            [
              [129.675140821, -7.57154713299991],
              [129.6552840500001, -7.560479424999926],
              [129.65357506600003, -7.547051690999922],
              [129.658539259, -7.535088799999926],
              [129.66374759200005, -7.536553643999923],
              [129.6806746750001, -7.554131768999923],
              [129.69068444100003, -7.559991143999923],
              [129.700043165, -7.558363539999959],
              [129.70679772200003, -7.554782809999949],
              [129.7138778000001, -7.558200778999947],
              [129.71216881600003, -7.569512627999927],
              [129.69459069100003, -7.577569268999923],
              [129.681976759, -7.577243747999944],
              [129.675140821, -7.57154713299991],
            ],
          ],
          [
            [
              [129.1250106130001, -6.993259372999944],
              [129.1162215500001, -6.983330987999921],
              [129.11744225400003, -6.972751559999949],
              [129.1250106130001, -6.965752862999921],
              [129.13428795700008, -6.961114190999922],
              [129.14478600400003, -6.962090752999927],
              [129.1528426440001, -6.976169528999947],
              [129.1504012380001, -6.99146900799991],
              [129.1425887380001, -6.997491143999923],
              [129.13542728000004, -6.998142184999949],
              [129.1250106130001, -6.993259372999944],
            ],
          ],
          [
            [
              [129.48454837300005, -6.755303643999923],
              [129.4809676440001, -6.760023695999905],
              [129.477875196, -6.756036065999922],
              [129.47877037900003, -6.744073174999926],
              [129.4863387380001, -6.729099216999941],
              [129.4970809250001, -6.722588799999926],
              [129.5097762380001, -6.723402601999908],
              [129.52019290500004, -6.721123955999929],
              [129.52906334700003, -6.723077080999929],
              [129.53077233200008, -6.731215101999908],
              [129.52906334700003, -6.739190362999921],
              [129.5180770190001, -6.763116143999923],
              [129.51156660200002, -6.769707940999922],
              [129.501312696, -6.770603122999944],
              [129.4931746750001, -6.765720309999949],
              [129.48812910200002, -6.760837497999944],
              [129.48617597700002, -6.754571221999925],
              [129.48454837300005, -6.755303643999923],
            ],
          ],
          [
            [
              [130.0136824880001, -6.328383070999905],
              [130.00611412900003, -6.324883721999925],
              [129.99870853000004, -6.317152601999908],
              [129.99781334700003, -6.309747002999927],
              [130.00375410200002, -6.306247653999947],
              [130.02076256600003, -6.312432549999926],
              [130.02605228000004, -6.318454684999949],
              [130.02165774800005, -6.324965101999908],
              [130.0136824880001, -6.328383070999905],
            ],
          ],
          [
            [
              [127.55128014400009, -5.512383721999925],
              [127.55518639400009, -5.506605726999908],
              [127.56137129000001, -5.51726653399993],
              [127.55128014400009, -5.512383721999925],
            ],
          ],
          [
            [
              [127.55486087300005, -5.490492445999905],
              [127.556976759, -5.499769789999959],
              [127.54590905000009, -5.495293877999927],
              [127.55486087300005, -5.490492445999905],
            ],
          ],
          [
            [
              [127.79004967500009, -5.409600518999923],
              [127.79851321700005, -5.400160414999959],
              [127.80339603000004, -5.407647393999923],
              [127.79004967500009, -5.409600518999923],
            ],
          ],
          [
            [
              [127.77686608200008, -5.348809502999927],
              [127.77906334700003, -5.342868747999944],
              [127.78516686300009, -5.352959893999923],
              [127.77686608200008, -5.348809502999927],
            ],
          ],
          [
            [
              [131.98650149800005, -5.31764088299991],
              [131.99724368600005, -5.312432549999926],
              [132.008636915, -5.312758070999905],
              [132.01628665500004, -5.330824476999908],
              [132.000336134, -5.373223565999922],
              [131.99203535200002, -5.377373955999929],
              [131.985199415, -5.377862237999921],
              [131.98072350400003, -5.379652601999908],
              [131.9751082690001, -5.387465101999908],
              [131.96558678500003, -5.388767184999949],
              [131.9594832690001, -5.372979424999926],
              [131.96241295700008, -5.343519789999959],
              [131.977386915, -5.323337497999944],
              [131.98650149800005, -5.31764088299991],
            ],
          ],
          [
            [
              [129.7578231130001, -4.522556247999944],
              [129.7627059250001, -4.51881275799991],
              [129.7783309250001, -4.524509372999944],
              [129.77027428500003, -4.539320570999905],
              [129.7578231130001, -4.522556247999944],
            ],
          ],
          [
            [
              [134.31031334700003, 0.75649648600006],
              [134.32683353000004, 0.766180731000077],
              [134.34294681100005, 0.765204169000071],
              [134.34693444100003, 0.752020575000074],
              [134.33863366000003, 0.737534898000092],
              [134.32252037900003, 0.730536200000074],
              [134.30486087300005, 0.732896226000094],
              [134.30046634200005, 0.743475653000075],
              [134.31031334700003, 0.75649648600006],
            ],
          ],
          [
            [
              [131.2363387380001, 1.019354559000078],
              [131.23707116000003, 1.024969794000071],
              [131.24488366000003, 1.035345770000049],
              [131.2441512380001, 1.029730536000045],
              [131.2363387380001, 1.019354559000078],
            ],
          ],
          [
            [
              [131.25562584700003, 1.068793036000045],
              [131.26351972700002, 1.075913804000038],
              [131.27116946700005, 1.072007554000038],
              [131.27019290500004, 1.060980536000045],
              [131.26539147200003, 1.052720445000091],
              [131.2548934250001, 1.044256903000075],
              [131.25359134200005, 1.052639065000051],
              [131.25562584700003, 1.068793036000045],
            ],
          ],
          [
            [
              [126.394867384, 1.339341539000088],
              [126.40162194100003, 1.332017320000091],
              [126.39039147200003, 1.310248114000046],
              [126.39079837300005, 1.304022528000075],
              [126.38542728000004, 1.286281643000052],
              [126.38086998800009, 1.283392645000049],
              [126.35906009200005, 1.316107489000046],
              [126.35084069100003, 1.318508205000057],
              [126.34717858200008, 1.323309637000079],
              [126.35238691500001, 1.335882880000042],
              [126.361664259, 1.344712632000039],
              [126.36963951900009, 1.348822333000044],
              [126.37769616000003, 1.347479559000078],
              [126.38493899800005, 1.342189846000053],
              [126.394867384, 1.339341539000088],
            ],
          ],
          [
            [
              [125.39340254000001, 2.118231512000079],
              [125.40495853000004, 2.130275783000059],
              [125.40845787900003, 2.122259833000044],
              [125.40626061300009, 2.107326565000051],
              [125.40316816500001, 2.102769273000092],
              [125.39779707100001, 2.104193427000041],
              [125.39332116000003, 2.104396877000056],
              [125.39087975400003, 2.101752020000049],
              [125.37549889400009, 2.09210846600007],
              [125.37012780000009, 2.091701565000051],
              [125.36215254000001, 2.086371161000045],
              [125.35613040500004, 2.077215887000079],
              [125.34913170700008, 2.071234442000048],
              [125.34050540500004, 2.073309637000079],
              [125.33423912900003, 2.081854559000078],
              [125.33521569100003, 2.09243398600006],
              [125.34058678500003, 2.100775458000044],
              [125.34457441500001, 2.102240302000041],
              [125.35035241000003, 2.109035549000055],
              [125.35718834700003, 2.109849351000094],
              [125.35718834700003, 2.11391836100006],
              [125.35377037900003, 2.116685289000088],
              [125.35124759200005, 2.122259833000044],
              [125.35425866000003, 2.129868882000039],
              [125.35987389400009, 2.127630927000041],
              [125.36451256600003, 2.123602606000077],
              [125.36793053500003, 2.12563711100006],
              [125.37208092500009, 2.124416408000059],
              [125.37794030000009, 2.120591539000088],
              [125.38624108200008, 2.118312893000052],
              [125.39340254000001, 2.118231512000079],
            ],
          ],
          [
            [
              [126.59115644600001, 5.557114976000094],
              [126.59864342500009, 5.565375067000048],
              [126.60287519600001, 5.564032294000071],
              [126.59937584700003, 5.553615627000056],
              [126.59546959700003, 5.548407294000071],
              [126.59115644600001, 5.557114976000094],
            ],
          ],
          [
            [
              [121.61410566500001, -10.60247161299992],
              [121.62159264400009, -10.60133228999996],
              [121.63331139400009, -10.604180596999925],
              [121.63111412900003, -10.61532968499995],
              [121.61500084700003, -10.62664153399993],
              [121.59522545700008, -10.63453541499996],
              [121.574554884, -10.639825127999927],
              [121.55274498800009, -10.64039478999996],
              [121.53142337300005, -10.63844166499996],
              [121.52719160200002, -10.629571221999925],
              [121.54102623800009, -10.614841403999947],
              [121.56495201900009, -10.603692315999922],
              [121.59742272200003, -10.601169528999947],
              [121.61410566500001, -10.60247161299992],
            ],
          ],
          [
            [
              [115.89087975400003, -7.10711028399993],
              [115.89429772200003, -7.111586195999905],
              [115.89600670700008, -7.124932549999926],
              [115.89429772200003, -7.164483330999929],
              [115.87574303500003, -7.185723565999922],
              [115.83773847700002, -7.197198174999926],
              [115.79590905000009, -7.190036716999941],
              [115.75733483200008, -7.169691664999959],
              [115.74301191500001, -7.150323174999926],
              [115.75294030000009, -7.14031340899993],
              [115.76221764400009, -7.139092705999929],
              [115.765961134, -7.143975518999923],
              [115.769867384, -7.142185153999947],
              [115.77816816500001, -7.115492445999905],
              [115.78598066500001, -7.115980726999908],
              [115.79127037900003, -7.125664971999925],
              [115.79476972700002, -7.137872002999927],
              [115.80103600400003, -7.146416924999926],
              [115.80795332100001, -7.149834893999923],
              [115.82276451900009, -7.149509372999944],
              [115.84278405000009, -7.157647393999923],
              [115.87012780000009, -7.15984465899993],
              [115.88021894600001, -7.158461195999905],
              [115.88379967500009, -7.153252862999921],
              [115.88135826900009, -7.152927341999941],
              [115.87517337300005, -7.15357838299991],
              [115.86939537900003, -7.147149346999925],
              [115.86670983200008, -7.137302341999941],
              [115.86963951900009, -7.128676039999959],
              [115.87745201900009, -7.123467705999929],
              [115.88355553500003, -7.123955987999921],
              [115.88599694100003, -7.129571221999925],
              [115.88697350400003, -7.126560153999947],
              [115.889008009, -7.113702080999929],
              [115.89087975400003, -7.10711028399993],
            ],
          ],
          [
            [
              [134.72779381600003, -6.504571221999925],
              [134.7309676440001, -6.514336846999925],
              [134.7343856130001, -6.525811455999929],
              [134.729828321, -6.54615650799991],
              [134.7153426440001, -6.552992445999905],
              [134.702484571, -6.550957940999922],
              [134.6938582690001, -6.553480726999908],
              [134.6884871750001, -6.558526299999926],
              [134.6748153000001, -6.563083591999941],
              [134.6562606130001, -6.559014580999929],
              [134.64812259200005, -6.541924737999921],
              [134.64429772200003, -6.52076588299991],
              [134.63591556100005, -6.506280205999929],
              [134.62614993600005, -6.497165622999944],
              [134.62378991000003, -6.486097914999959],
              [134.6313582690001, -6.47584400799991],
              [134.64478600400003, -6.464450778999947],
              [134.66325931100005, -6.454847914999959],
              [134.68433678500003, -6.457777601999908],
              [134.70484459700003, -6.470472914999959],
              [134.71949303500003, -6.486260674999926],
              [134.72779381600003, -6.504571221999925],
            ],
          ],
          [
            [
              [110.43132571700005, -5.837334893999923],
              [110.45923912900003, -5.831638278999947],
              [110.46558678500003, -5.83953215899993],
              [110.46363366000003, -5.85711028399993],
              [110.44988040500004, -5.874444268999923],
              [110.43799889400003, -5.881036065999922],
              [110.43034915500004, -5.873711846999925],
              [110.42660566500007, -5.861504815999922],
              [110.42164147200003, -5.851332289999959],
              [110.42066491000003, -5.843682549999926],
              [110.43132571700005, -5.837334893999923],
            ],
          ],
          [
            [
              [134.21273847700002, -5.758721612999921],
              [134.2255965500001, -5.77117278399993],
              [134.22828209700003, -5.773370049999926],
              [134.22779381600003, -5.789320570999905],
              [134.22038821700005, -5.815606377999927],
              [134.20687910200002, -5.827325127999927],
              [134.19459069100003, -5.830173434999949],
              [134.180511915, -5.827325127999927],
              [134.16968834700003, -5.811130466999941],
              [134.16749108200008, -5.788995049999926],
              [134.16968834700003, -5.768324476999908],
              [134.1777449880001, -5.754489841999941],
              [134.19206790500004, -5.753024997999944],
              [134.2002059250001, -5.755303643999923],
              [134.20484459700003, -5.756117445999905],
              [134.21273847700002, -5.758721612999921],
            ],
          ],
          [
            [
              [133.5918074880001, -2.461521091999941],
              [133.6054793630001, -2.46803150799991],
              [133.605804884, -2.488946221999925],
              [133.58521569100003, -2.512627862999921],
              [133.5629988940001, -2.512872002999927],
              [133.56169681100005, -2.508721612999921],
              [133.55738366000003, -2.504327080999929],
              [133.52328535200002, -2.48796965899993],
              [133.51351972700002, -2.476006768999923],
              [133.50709069100003, -2.46021900799991],
              [133.49789472700002, -2.446384372999944],
              [133.49000084700003, -2.431247653999947],
              [133.5058699880001, -2.424493096999925],
              [133.5390731130001, -2.440118096999925],
              [133.55388431100005, -2.449883721999925],
              [133.55396569100003, -2.442966403999947],
              [133.56023196700005, -2.44304778399993],
              [133.5708113940001, -2.450941664999959],
              [133.58375084700003, -2.45867278399993],
              [133.5918074880001, -2.461521091999941],
            ],
          ],
          [
            [
              [123.60059655000009, -1.603285414999959],
              [123.61036217500009, -1.611586195999962],
              [123.61646569100003, -1.624607028999947],
              [123.61597741000003, -1.64031340899993],
              [123.61410566500001, -1.652439059999949],
              [123.60873457100001, -1.674248955999929],
              [123.60865319100003, -1.68873463299991],
              [123.60132897200003, -1.70281340899993],
              [123.58643639400009, -1.712985934999949],
              [123.57927493600005, -1.71607838299991],
              [123.57488040500004, -1.71998463299991],
              [123.56421959700003, -1.72193775799991],
              [123.55396569100003, -1.720635674999926],
              [123.54542076900009, -1.721856377999927],
              [123.53435306100005, -1.716566664999959],
              [123.52214603000004, -1.705824476999908],
              [123.51514733200008, -1.703383070999962],
              [123.51172936300009, -1.709405205999929],
              [123.50367272200003, -1.712823174999926],
              [123.49350019600001, -1.709649346999925],
              [123.48731530000009, -1.699965101999908],
              [123.48487389400009, -1.693536065999922],
              [123.47779381600003, -1.668633721999925],
              [123.47559655000009, -1.649102471999925],
              [123.47852623800009, -1.634535414999959],
              [123.47836347700002, -1.619561455999929],
              [123.480804884, -1.615004164999959],
              [123.482758009, -1.610446872999944],
              [123.48804772200003, -1.603285414999959],
              [123.49268639400009, -1.59498463299991],
              [123.49146569100003, -1.584730726999908],
              [123.48503665500004, -1.579685153999947],
              [123.47950280000009, -1.577080987999921],
              [123.476898634, -1.570245049999926],
              [123.47673587300005, -1.562758070999962],
              [123.47779381600003, -1.557712497999944],
              [123.48194420700008, -1.544691664999959],
              [123.49089603000004, -1.524509372999944],
              [123.50074303500003, -1.509372653999947],
              [123.51140384200005, -1.505629164999959],
              [123.52068118600005, -1.504815362999921],
              [123.52523847700002, -1.498223565999922],
              [123.52328535200002, -1.482679945999962],
              [123.52906334700003, -1.480238539999959],
              [123.53736412900003, -1.485039971999925],
              [123.54468834700003, -1.497002862999921],
              [123.56006920700008, -1.545993747999944],
              [123.55925540500004, -1.555759372999944],
              [123.55591881600003, -1.563409112999921],
              [123.55738366000003, -1.581149997999944],
              [123.56885826900009, -1.60084400799991],
              [123.58130944100003, -1.602634372999944],
              [123.59034264400009, -1.598728122999944],
              [123.60059655000009, -1.603285414999959],
            ],
          ],
          [
            [
              [128.36736087300005, -0.988376559999949],
              [128.40349368600005, -0.995293877999927],
              [128.411468946, -1.009535414999959],
              [128.4067488940001, -1.025974216999941],
              [128.39275149800005, -1.035414320999962],
              [128.37289472700002, -1.037692966999941],
              [128.36508222700002, -1.03639088299991],
              [128.36890709700003, -1.034112237999921],
              [128.361664259, -1.033623955999929],
              [128.3437606130001, -1.029961846999925],
              [128.33033287900003, -1.020196221999925],
              [128.32683353000004, -1.006605726999908],
              [128.32960045700008, -0.991631768999923],
              [128.32960045700008, -0.978692315999922],
              [128.30543053500003, -0.96217213299991],
              [128.30046634200005, -0.955498955999929],
              [128.30152428500003, -0.951104424999926],
              [128.30616295700008, -0.943291924999926],
              [128.31421959700003, -0.939385674999926],
              [128.32349694100003, -0.941338799999926],
              [128.33090254, -0.949151299999926],
              [128.33545983200008, -0.960870049999926],
              [128.3408309250001, -0.96998463299991],
              [128.35808353000004, -0.979668877999927],
              [128.36736087300005, -0.988376559999949],
            ],
          ],
          [
            [
              [129.9023543630001, -0.408461195999962],
              [129.91000410200002, -0.413506768999923],
              [129.91618899800005, -0.42742278399993],
              [129.91382897200003, -0.442559502999927],
              [129.908539259, -0.449395440999922],
              [129.9028426440001, -0.459161065999922],
              [129.89714603000004, -0.479180596999925],
              [129.88819420700008, -0.494724216999941],
              [129.8779403000001, -0.502373955999929],
              [129.86443118600005, -0.498630466999941],
              [129.85141035200002, -0.481622002999927],
              [129.844086134, -0.462334893999923],
              [129.8442488940001, -0.444268487999921],
              [129.84888756600003, -0.432386976999908],
              [129.8545028000001, -0.426527601999908],
              [129.85962975400003, -0.422946872999944],
              [129.87378991000003, -0.414971612999921],
              [129.89234459700003, -0.409356377999927],
              [129.9023543630001, -0.408461195999962],
            ],
          ],
          [
            [
              [98.54759660600007, 0.159326621000048],
              [98.59004914400003, 0.171655865000048],
              [98.62541622300006, 0.175154445000089],
              [98.67314881800007, 0.169812204000038],
              [98.71735171300003, 0.175119907000067],
              [98.74386804200003, 0.166265774000067],
              [98.76685525200003, 0.166260799000042],
              [98.80574359100007, 0.160915958000089],
              [98.83579891300008, 0.141468860000089],
              [98.85168541500008, 0.109621341000093],
              [98.84458901000005, 0.084859408000057],
              [98.80215138800003, 0.086636337000073],
              [98.76325605100004, 0.086647611000046],
              [98.72612544600003, 0.07428458000004],
              [98.68900355200003, 0.070775303000062],
              [98.65012344900003, 0.079621516000088],
              [98.62008145400006, 0.08670274800005],
              [98.57588254200004, 0.086750186000074],
              [98.53873988200007, 0.090335129000039],
              [98.52813318600005, 0.111575879000043],
              [98.52460056700005, 0.145197070000052],
              [98.54759660600007, 0.159326621000048],
            ],
          ],
          [
            [
              [104.72486412900008, 0.749660549000055],
              [104.74097741000003, 0.748928127000056],
              [104.75416100400008, 0.737250067000048],
              [104.74903405000003, 0.722601630000042],
              [104.73926842500003, 0.71625397300005],
              [104.73145592500003, 0.722479559000078],
              [104.72071373800003, 0.737860419000071],
              [104.72486412900008, 0.749660549000055],
            ],
          ],
          [
            [
              [104.65943444100003, 0.845892645000049],
              [104.66277103000004, 0.834214585000041],
              [104.66325931100005, 0.829087632000039],
              [104.66138756600003, 0.820135809000078],
              [104.65658613400007, 0.813869533000059],
              [104.65154056100005, 0.809963283000059],
              [104.64283287900008, 0.806830145000049],
              [104.63038170700003, 0.806545315000051],
              [104.62549889400003, 0.810695705000057],
              [104.63021894600007, 0.816351630000042],
              [104.63542728000004, 0.828558661000045],
              [104.63917076900003, 0.84796784100007],
              [104.64861087300005, 0.857896226000094],
              [104.65943444100003, 0.845892645000049],
            ],
          ],
          [
            [
              [125.172211134, 1.799221096000053],
              [125.17660566500001, 1.792792059000078],
              [125.17701256600003, 1.77875397300005],
              [125.15406334700003, 1.75649648600006],
              [125.15202884200005, 1.747707424000055],
              [125.14942467500009, 1.742173570000091],
              [125.14470462300005, 1.741848049000055],
              [125.13721764400009, 1.747951565000051],
              [125.13209069100003, 1.758368231000077],
              [125.12973066500001, 1.772406317000048],
              [125.12387129000001, 1.789048570000091],
              [125.12232506600003, 1.807033596000053],
              [125.12598717500009, 1.815415757000039],
              [125.12940514400009, 1.82843659100007],
              [125.13526451900009, 1.830959377000056],
              [125.14454186300009, 1.822333075000074],
              [125.15398196700005, 1.810736395000049],
              [125.16570071700005, 1.802232164000088],
              [125.172211134, 1.799221096000053],
            ],
          ],
          [
            [
              [127.13038170700008, 4.774400132000039],
              [127.13917076900009, 4.766587632000039],
              [127.14576256600003, 4.752183335000041],
              [127.13599694100003, 4.740383205000057],
              [127.12305748800009, 4.752508856000077],
              [127.121429884, 4.768500067000048],
              [127.12403405000009, 4.772040106000077],
              [127.13038170700008, 4.774400132000039],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Malaysia',
        iso3: 'MYS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [117.70360790395524, 4.163414542001791],
              [117.69711347700002, 4.16905345300006],
              [117.64405358200008, 4.215236721000053],
              [117.64014733200008, 4.227443752000056],
              [117.64763431100005, 4.240627346000053],
              [117.66553795700008, 4.253119208000044],
              [117.68604576900009, 4.262844143000052],
              [117.70167076900009, 4.267523505000042],
              [117.72022545700008, 4.266424872000073],
              [117.75635826900009, 4.254584052000041],
              [117.77442467500009, 4.251654364000046],
              [117.78541100400003, 4.246649481000077],
              [117.79493248800009, 4.235256252000056],
              [117.80827884200005, 4.214056708000044],
              [117.81771894600001, 4.204738674000055],
              [117.82634524800005, 4.199408270000049],
              [117.83619225400003, 4.196966864000046],
              [117.84986412900003, 4.196356512000079],
              [117.89625084700003, 4.181341864000046],
              [117.90064537900003, 4.171454169000071],
              [117.900726759, 4.171291408000059],
              [117.9070390276059, 4.156683015004099],
              [117.85255730900013, 4.157241908000032],
              [117.78357224700005, 4.157241908000032],
              [117.73807146200011, 4.157241908000032],
              [117.70360790400008, 4.163414542000055],
              [117.70360790395524, 4.163414542001791],
            ],
          ],
          [
            [
              [102.07309004000007, 6.257513739000046],
              [102.09864342500003, 6.239081122000073],
              [102.15211022200003, 6.203192450000074],
              [102.16358483200003, 6.197495835000041],
              [102.18702233200003, 6.20343659100007],
              [102.19166100400008, 6.215073960000041],
              [102.18311608200003, 6.223049221000053],
              [102.16684004000007, 6.217962958000044],
              [102.17807050900007, 6.233628648000092],
              [102.19955488400007, 6.232814846000053],
              [102.31568444100003, 6.190375067000048],
              [102.33814537900008, 6.176988023000092],
              [102.37989342500003, 6.132961330000057],
              [102.49984785200007, 5.897406317000048],
              [102.52076256600003, 5.87173086100006],
              [102.54200280000003, 5.854763088000084],
              [102.55046634200005, 5.848049221000053],
              [102.60328209700003, 5.815375067000048],
              [102.62631269600007, 5.79718659100007],
              [102.64600670700003, 5.772935289000088],
              [102.65902754000007, 5.74054596600007],
              [102.66920006600003, 5.725002346000053],
              [102.69646243600005, 5.712876695000091],
              [102.87566165500004, 5.571437893000052],
              [102.91814212300005, 5.550441799000055],
              [102.95948326900003, 5.542059637000079],
              [102.97559655000003, 5.531317450000074],
              [103.02759850400008, 5.485500393000052],
              [103.12029056100005, 5.381333726000094],
              [103.22242272200003, 5.221136786000045],
              [103.25733483200003, 5.13617584800005],
              [103.35661868600005, 4.970404364000046],
              [103.41529381600003, 4.863348700000074],
              [103.42123457100007, 4.844142971000053],
              [103.42505944100003, 4.837144273000092],
              [103.44263756600003, 4.816595770000049],
              [103.44800866000003, 4.806545315000051],
              [103.44857832100007, 4.795070705000057],
              [103.44117272200003, 4.765570380000042],
              [103.44263756600003, 4.74282461100006],
              [103.45248457100007, 4.701076565000051],
              [103.46941165500004, 4.550034898000092],
              [103.46810957100007, 4.527085679000038],
              [103.45826256600003, 4.508286851000094],
              [103.45142662900008, 4.488470770000049],
              [103.46371504000007, 4.443752346000053],
              [103.46168053500003, 4.42914459800005],
              [103.49415123800003, 4.336615302000041],
              [103.49642988400007, 4.306219794000071],
              [103.49390709700003, 4.295314846000053],
              [103.48031660200007, 4.260239976000094],
              [103.47234134200005, 4.248236395000049],
              [103.46583092500003, 4.242092190000051],
              [103.45167076900003, 4.225165106000077],
              [103.44800866000003, 4.217474677000041],
              [103.44841556100005, 4.208807684000078],
              [103.45484459700003, 4.182766018000052],
              [103.44857832100007, 4.172430731000077],
              [103.44280032600005, 4.168972072000088],
              [103.44092858200003, 4.167873440000051],
              [103.43279056100005, 4.164862372000073],
              [103.42465254000007, 4.159165757000039],
              [103.40398196700005, 4.131822007000039],
              [103.39519290500004, 4.116278387000079],
              [103.39405358200003, 4.098618882000039],
              [103.40088951900003, 4.067328192000048],
              [103.43799889400003, 3.975043036000045],
              [103.43433678500003, 3.950018622000073],
              [103.41163170700003, 3.963934637000079],
              [103.39470462300005, 3.93500397300005],
              [103.38404381600003, 3.890326239000046],
              [103.38038170700003, 3.857489325000074],
              [103.38135826900003, 3.820502020000049],
              [103.37842858200003, 3.802435614000046],
              [103.36101321700005, 3.801988023000092],
              [103.35108483200003, 3.789211330000057],
              [103.34278405000003, 3.771918036000045],
              [103.33871504000007, 3.758205471000053],
              [103.33961022200003, 3.738348700000074],
              [103.34498131600003, 3.721584377000056],
              [103.38355553500003, 3.637274481000077],
              [103.38721764400003, 3.624741929000038],
              [103.40455162900008, 3.600043036000045],
              [103.43873131600003, 3.56781647300005],
              [103.46216881600003, 3.534125067000048],
              [103.44800866000003, 3.504950262000079],
              [103.48218834700003, 3.511786200000074],
              [103.43336022200003, 3.408392645000049],
              [103.42807050900007, 3.367173570000091],
              [103.44450931100005, 3.243557033000059],
              [103.45142662900008, 3.223781643000052],
              [103.45606530000003, 3.20376211100006],
              [103.43458092500003, 2.961818752000056],
              [103.44117272200003, 2.922105210000041],
              [103.47364342500003, 2.85101959800005],
              [103.52019290500004, 2.789007880000042],
              [103.63843834700003, 2.672105210000041],
              [103.64031009200005, 2.671291408000059],
              [103.65211022200003, 2.666001695000091],
              [103.66749108200003, 2.662909247000073],
              [103.68506920700003, 2.662054755000042],
              [103.69044030000003, 2.659125067000048],
              [103.70541425900007, 2.645453192000048],
              [103.71615644600007, 2.641546942000048],
              [103.72584069100003, 2.643052476000094],
              [103.74968509200005, 2.65460846600007],
              [103.76514733200003, 2.648911851000094],
              [103.76677493600005, 2.641750393000052],
              [103.76417076900003, 2.633246161000045],
              [103.76710045700003, 2.623846747000073],
              [103.80176842500003, 2.596869208000044],
              [103.81397545700003, 2.58148834800005],
              [103.83969160200007, 2.52484772300005],
              [103.83106530000003, 2.501695054000038],
              [103.83033287900008, 2.482367255000042],
              [103.83765709700003, 2.463812567000048],
              [103.91138756600003, 2.370672919000071],
              [103.92009524800005, 2.362616278000075],
              [103.94206790500004, 2.346502997000073],
              [103.94898522200003, 2.339911200000074],
              [103.95337975400008, 2.329413153000075],
              [103.95362389400003, 2.309475002000056],
              [103.95582116000003, 2.29828522300005],
              [103.96241295700003, 2.287298895000049],
              [103.97999108200003, 2.265570380000042],
              [103.98365319100003, 2.253648179000038],
              [103.98145592500003, 2.244330145000049],
              [103.97169030000003, 2.224595445000091],
              [103.96941165500004, 2.212713934000078],
              [103.97641035200007, 2.192368882000039],
              [104.02328535200007, 2.134466864000046],
              [104.04883873800003, 2.071763414000088],
              [104.06723066500007, 2.046820380000042],
              [104.07886803500003, 2.02179596600007],
              [104.08545983200003, 2.010972398000092],
              [104.10645592500003, 1.986883856000077],
              [104.11280358200003, 1.976141669000071],
              [104.12086022200003, 1.954046942000048],
              [104.12232506600003, 1.934637762000079],
              [104.11963951900003, 1.891180731000077],
              [104.12427819100003, 1.87055084800005],
              [104.13542728000004, 1.848944403000075],
              [104.14918053500003, 1.837469794000071],
              [104.16114342500003, 1.847072658000059],
              [104.16749108200003, 1.847072658000059],
              [104.19532311300003, 1.798732815000051],
              [104.20427493600005, 1.752875067000048],
              [104.22291100400008, 1.72687409100007],
              [104.22803795700003, 1.712103583000044],
              [104.22950280000003, 1.678290106000077],
              [104.23536217500003, 1.66437409100007],
              [104.24724368600005, 1.650539455000057],
              [104.25521894600007, 1.637762762000079],
              [104.24984785200007, 1.627346096000053],
              [104.25652103000004, 1.613836981000077],
              [104.26368248800003, 1.572170315000051],
              [104.28402754000007, 1.517482815000051],
              [104.29371178500003, 1.471584377000056],
              [104.29468834700003, 1.446519273000092],
              [104.28785241000003, 1.435532945000091],
              [104.27955162900008, 1.426459052000041],
              [104.28239993600005, 1.382635809000078],
              [104.27735436300003, 1.367336330000057],
              [104.23959394600007, 1.367336330000057],
              [104.23462975400008, 1.36399974200009],
              [104.22413170700003, 1.349514065000051],
              [104.21924889400003, 1.346177476000094],
              [104.17408287900008, 1.348211981000077],
              [104.15447024800005, 1.35228099200009],
              [104.11402428500003, 1.368475653000075],
              [104.10621178500003, 1.375189520000049],
              [104.10523522200003, 1.38540273600006],
              [104.10596764400003, 1.404486395000049],
              [104.10059655000003, 1.418850002000056],
              [104.08863366000003, 1.429429429000038],
              [104.07488040500004, 1.438706773000092],
              [104.06495201900003, 1.448635158000059],
              [104.05941816500007, 1.485337632000039],
              [104.08627363400007, 1.502875067000048],
              [104.12322024800005, 1.517523505000042],
              [104.14763431100005, 1.545396226000094],
              [104.12891686300003, 1.549709377000056],
              [104.11117597700007, 1.545070705000057],
              [104.09449303500003, 1.535223700000074],
              [104.06080162900008, 1.51007721600007],
              [104.05339603000004, 1.506293036000045],
              [104.04981530000003, 1.513088283000059],
              [104.04395592500003, 1.531195380000042],
              [104.01221764400003, 1.596869208000044],
              [103.98853600400008, 1.632391669000071],
              [103.96599368600005, 1.647853908000059],
              [103.96021569100003, 1.635809637000079],
              [103.97038821700005, 1.608628648000092],
              [104.00831139400003, 1.548732815000051],
              [104.00863691500007, 1.534857489000046],
              [104.00342858200003, 1.506903387000079],
              [104.00570722700007, 1.493841864000046],
              [104.01002037900008, 1.479478257000039],
              [104.01246178500003, 1.464260158000059],
              [104.00977623800003, 1.448635158000059],
              [103.97445722700007, 1.419826565000051],
              [103.92652428500003, 1.431708075000074],
              [103.83969160200007, 1.476548570000091],
              [103.81430097700007, 1.474514065000051],
              [103.77409915500004, 1.453680731000077],
              [103.75310306100005, 1.448635158000059],
              [103.71265709700003, 1.452093817000048],
              [103.69760175900007, 1.45062897300005],
              [103.68140709700003, 1.441799221000053],
              [103.63005618600005, 1.377427476000094],
              [103.60010826900003, 1.353461005000042],
              [103.56470787900008, 1.359849351000094],
              [103.56275475400008, 1.364406643000052],
              [103.55551191500007, 1.374741929000038],
              [103.54786217500003, 1.382066148000092],
              [103.54420006600003, 1.377183335000041],
              [103.54525800900007, 1.36595286700009],
              [103.55005944100003, 1.351060289000088],
              [103.55103600400008, 1.342840887000079],
              [103.54851321700005, 1.331691799000055],
              [103.53052819100003, 1.305243231000077],
              [103.51636803500003, 1.270453192000048],
              [103.50407962300005, 1.289943752000056],
              [103.46900475400008, 1.319973049000055],
              [103.45484459700003, 1.339422919000071],
              [103.44629967500003, 1.359320380000042],
              [103.41391035200007, 1.467840887000079],
              [103.39535566500007, 1.506415106000077],
              [103.36736087300005, 1.538397528000075],
              [103.32504316500007, 1.565334377000056],
              [103.20606530000003, 1.610419012000079],
              [103.03711998800003, 1.715521552000041],
              [102.99634850400008, 1.734930731000077],
              [102.97413170700003, 1.741156317000048],
              [102.95118248800003, 1.743394273000092],
              [102.93458092500003, 1.747544664000088],
              [102.92318769600007, 1.757879950000074],
              [102.90674889400003, 1.784369208000044],
              [102.88746178500003, 1.807114976000094],
              [102.86361738400007, 1.827785549000055],
              [102.83562259200005, 1.845648505000042],
              [102.80445397200003, 1.86009349200009],
              [102.78842207100007, 1.854193427000041],
              [102.73878014400003, 1.846625067000048],
              [102.72185306100005, 1.847072658000059],
              [102.69939212300005, 1.859442450000074],
              [102.68620853000004, 1.879055080000057],
              [102.66716556100005, 1.921576239000046],
              [102.65064537900008, 1.940904039000088],
              [102.56885826900003, 2.006415106000077],
              [102.55762780000003, 2.018744208000044],
              [102.55046634200005, 2.031439520000049],
              [102.55909264400003, 2.033189195000091],
              [102.56031334700003, 2.036444403000075],
              [102.55827884200005, 2.040594794000071],
              [102.55730228000004, 2.045111395000049],
              [102.54468834700003, 2.057684637000079],
              [102.52686608200003, 2.070868231000077],
              [102.48902428500003, 2.092922268000052],
              [102.34864342500003, 2.149969794000071],
              [102.18799889400003, 2.216376044000071],
              [102.15430748800003, 2.235663153000075],
              [102.12696373800003, 2.257310289000088],
              [102.05128014400003, 2.340887762000079],
              [102.04029381600003, 2.346136786000045],
              [102.01872806100005, 2.350409247000073],
              [101.99903405000003, 2.36163971600007],
              [101.98707116000003, 2.377142645000049],
              [101.98878014400003, 2.394517320000091],
              [101.97217858200003, 2.398586330000057],
              [101.95622806100005, 2.404771226000094],
              [101.92676842500003, 2.422430731000077],
              [101.90919030000003, 2.41079336100006],
              [101.87745201900003, 2.40884023600006],
              [101.86524498800003, 2.394517320000091],
              [101.85816491000003, 2.419419664000088],
              [101.85621178500003, 2.451361395000049],
              [101.85108483200003, 2.478949286000045],
              [101.83423912900008, 2.490708726000094],
              [101.82740319100003, 2.494126695000091],
              [101.81771894600007, 2.502183335000041],
              [101.80323326900003, 2.518011786000045],
              [101.78305097700007, 2.575873114000046],
              [101.77442467500003, 2.58657461100006],
              [101.76099694100003, 2.59210846600007],
              [101.71338951900003, 2.596584377000056],
              [101.70093834700003, 2.60415273600006],
              [101.69092858200003, 2.614894924000055],
              [101.67351321700005, 2.62726471600007],
              [101.61833743600005, 2.636908270000049],
              [101.59791100400008, 2.646307684000078],
              [101.56421959700003, 2.652004299000055],
              [101.54232832100007, 2.661281643000052],
              [101.50277754000007, 2.689398505000042],
              [101.47966556100005, 2.716986395000049],
              [101.43018639400003, 2.792466539000088],
              [101.39918053500003, 2.81907786700009],
              [101.35515384200005, 2.829250393000052],
              [101.31055748800003, 2.833563544000071],
              [101.28638756600003, 2.849676825000074],
              [101.30347741000003, 2.89484284100007],
              [101.28101647200003, 2.897853908000059],
              [101.28305097700007, 2.911200262000079],
              [101.33277428500003, 2.972357489000046],
              [101.34717858200003, 2.985500393000052],
              [101.36158287900008, 2.991034247000073],
              [101.37281334700003, 3.002346096000053],
              [101.37281334700003, 3.028306382000039],
              [101.36500084700003, 3.076361395000049],
              [101.35857181100005, 3.089260158000059],
              [101.32984459700003, 3.111761786000045],
              [101.32341556100005, 3.12445709800005],
              [101.30347741000003, 3.254828192000048],
              [101.29761803500003, 3.274603583000044],
              [101.28321373800003, 3.290838934000078],
              [101.24887129000007, 3.319973049000055],
              [101.24488366000003, 3.32758209800005],
              [101.24146569100003, 3.336615302000041],
              [101.23568769600007, 3.344142971000053],
              [101.21558678500003, 3.349188544000071],
              [101.20573978000004, 3.35382721600007],
              [101.19760175900007, 3.359320380000042],
              [101.19418379000007, 3.364081122000073],
              [101.18718509200005, 3.380194403000075],
              [101.13965905000003, 3.442857164000088],
              [101.10840905000003, 3.473944403000075],
              [101.10222415500004, 3.482896226000094],
              [101.09400475400008, 3.505804755000042],
              [101.07422936300003, 3.534409898000092],
              [101.06446373800003, 3.579046942000048],
              [101.05713951900003, 3.600531317000048],
              [101.04053795700003, 3.621975002000056],
              [100.96794681100005, 3.672064520000049],
              [100.94336998800003, 3.682603257000039],
              [100.93360436300003, 3.689276434000078],
              [100.92798912900008, 3.696600653000075],
              [100.91244550900007, 3.72406647300005],
              [100.88648522200003, 3.756333726000094],
              [100.86963951900003, 3.768011786000045],
              [100.82292728000004, 3.776068427000041],
              [100.81226647200003, 3.78656647300005],
              [100.81324303500003, 3.803778387000079],
              [100.82374108200003, 3.827093817000048],
              [100.84156334700003, 3.843736070000091],
              [100.84538821700005, 3.851263739000046],
              [100.83399498800003, 3.854396877000056],
              [100.81177819100003, 3.851223049000055],
              [100.80054772200003, 3.847805080000057],
              [100.79590905000003, 3.843817450000074],
              [100.78484134200005, 3.839341539000088],
              [100.76010175900007, 3.847154039000088],
              [100.73462975400008, 3.859442450000074],
              [100.72071373800003, 3.868068752000056],
              [100.70948326900003, 3.883042710000041],
              [100.70337975400008, 3.898871161000045],
              [100.70069420700003, 3.917222398000092],
              [100.70118248800003, 3.967230536000045],
              [100.70630944100003, 3.983587958000044],
              [100.71876061300003, 3.99087148600006],
              [100.78174889400003, 3.988023179000038],
              [100.80152428500003, 3.991115627000056],
              [100.81739342500003, 4.010809637000079],
              [100.83464603000004, 4.018540757000039],
              [100.85499108200003, 4.022162177000041],
              [100.87142988400007, 4.018866278000075],
              [100.86150149800005, 4.040350653000075],
              [100.83814537900008, 4.037990627000056],
              [100.81430097700007, 4.026068427000041],
              [100.80323326900003, 4.018866278000075],
              [100.77759850400008, 4.021389065000051],
              [100.77295983200003, 4.037014065000051],
              [100.77670332100007, 4.060532945000091],
              [100.77605228000004, 4.086493231000077],
              [100.76587975400008, 4.099839585000041],
              [100.71387780000003, 4.134955145000049],
              [100.69752037900008, 4.150864976000094],
              [100.67774498800003, 4.165187893000052],
              [100.65552819100003, 4.169501044000071],
              [100.63257897200003, 4.155462958000044],
              [100.62256920700003, 4.175848700000074],
              [100.61304772200003, 4.208400783000059],
              [100.60889733200003, 4.238430080000057],
              [100.61524498800003, 4.251654364000046],
              [100.60027103000004, 4.256537177000041],
              [100.59571373800003, 4.268744208000044],
              [100.59498131600003, 4.284409898000092],
              [100.59099368600005, 4.300034898000092],
              [100.57960045700003, 4.311224677000041],
              [100.56967207100007, 4.313381252000056],
              [100.56544030000003, 4.319159247000073],
              [100.57056725400008, 4.341009833000044],
              [100.57984459700003, 4.366441148000092],
              [100.58301842500003, 4.380072333000044],
              [100.58423912900008, 4.39907461100006],
              [100.58855228000004, 4.412258205000057],
              [100.60767662900008, 4.426214911000045],
              [100.61207116000003, 4.440008856000077],
              [100.61475670700003, 4.467759507000039],
              [100.63257897200003, 4.532904364000046],
              [100.64551842500003, 4.560044664000088],
              [100.63021894600007, 4.553941148000092],
              [100.61231530000003, 4.558742580000057],
              [100.59734134200005, 4.571926174000055],
              [100.59099368600005, 4.590806382000039],
              [100.59441165500004, 4.610907294000071],
              [100.60377037900008, 4.629461981000077],
              [100.61695397200003, 4.638251044000071],
              [100.63257897200003, 4.629055080000057],
              [100.63949629000007, 4.643133856000077],
              [100.64730879000007, 4.654730536000045],
              [100.65609785200007, 4.663723049000055],
              [100.66618899800005, 4.669907945000091],
              [100.64234459700003, 4.674302476000094],
              [100.62037194100003, 4.666205145000049],
              [100.60417728000004, 4.665838934000078],
              [100.59782962300005, 4.693548895000049],
              [100.59449303500003, 4.743068752000056],
              [100.60385175900007, 4.756048895000049],
              [100.63257897200003, 4.75812409100007],
              [100.63257897200003, 4.765570380000042],
              [100.62680097700007, 4.766587632000039],
              [100.61207116000003, 4.772365627000056],
              [100.61980228000004, 4.786444403000075],
              [100.61736087300005, 4.792914130000042],
              [100.59782962300005, 4.799709377000056],
              [100.58765709700003, 4.800970770000049],
              [100.58122806100005, 4.797919012000079],
              [100.57618248800003, 4.799261786000045],
              [100.57056725400008, 4.813381252000056],
              [100.56950931100005, 4.827134507000039],
              [100.57740319100003, 4.843980210000041],
              [100.57740319100003, 4.854315497000073],
              [100.57154381600003, 4.85773346600007],
              [100.56177819100003, 4.858303127000056],
              [100.55307050900007, 4.86204661700009],
              [100.55005944100003, 4.875433661000045],
              [100.53988691500007, 4.870021877000056],
              [100.52914472700007, 4.867865302000041],
              [100.50538170700003, 4.867987372000073],
              [100.49439537900008, 4.872259833000044],
              [100.49927819100003, 4.881048895000049],
              [100.50961347700007, 4.888617255000042],
              [100.51531009200005, 4.889064846000053],
              [100.51465905000003, 4.902492580000057],
              [100.51099694100003, 4.906927802000041],
              [100.50342858200003, 4.910142320000091],
              [100.49170983200003, 4.919826565000051],
              [100.48170006600003, 4.924709377000056],
              [100.47071373800003, 4.922308661000045],
              [100.46070397200003, 4.916001695000091],
              [100.45386803500003, 4.90892161700009],
              [100.44157962300005, 4.922837632000039],
              [100.43580162900008, 4.936102606000077],
              [100.43238366000003, 4.949652411000045],
              [100.42652428500003, 4.964178778000075],
              [100.40186608200003, 4.992336330000057],
              [100.39568118600005, 5.013373114000046],
              [100.38070722700007, 5.047349351000094],
              [100.37232506600003, 5.061428127000056],
              [100.36451256600003, 5.08429596600007],
              [100.36589603000004, 5.09251536700009],
              [100.36947675900007, 5.093247789000088],
              [100.37419681100005, 5.091945705000057],
              [100.37867272200003, 5.094549872000073],
              [100.38884524800005, 5.105658270000049],
              [100.40007571700005, 5.114894924000055],
              [100.40902754000007, 5.126654364000046],
              [100.41627037900008, 5.15961334800005],
              [100.43091881600003, 5.190619208000044],
              [100.43327884200005, 5.211167710000041],
              [100.43067467500003, 5.222357489000046],
              [100.42115319100003, 5.242417710000041],
              [100.41895592500003, 5.248480536000045],
              [100.42123457100007, 5.260646877000056],
              [100.43116295700003, 5.278957424000055],
              [100.43327884200005, 5.290025132000039],
              [100.43002363400007, 5.302883205000057],
              [100.40601647200003, 5.34837474200009],
              [100.38526451900003, 5.376939195000091],
              [100.38021894600007, 5.390692450000074],
              [100.37867272200003, 5.413275458000044],
              [100.38493899800005, 5.499253648000092],
              [100.37842858200003, 5.522772528000075],
              [100.35572350400008, 5.562689520000049],
              [100.35084069100003, 5.584214585000041],
              [100.34400475400008, 5.669256903000075],
              [100.35320071700005, 5.665350653000075],
              [100.36491946700005, 5.662665106000077],
              [100.37631269600007, 5.663316148000092],
              [100.38493899800005, 5.669256903000075],
              [100.38640384200005, 5.679103908000059],
              [100.37875410200007, 5.685207424000055],
              [100.36915123800003, 5.689601955000057],
              [100.36451256600003, 5.69407786700009],
              [100.37574303500003, 5.810939846000053],
              [100.34913170700003, 6.012681382000039],
              [100.34058678500003, 6.02993398600006],
              [100.32593834700003, 6.049058335000041],
              [100.31397545700003, 6.07062409100007],
              [100.29615319100003, 6.11554596600007],
              [100.26002037900008, 6.180894273000092],
              [100.24789472700007, 6.220770575000074],
              [100.23259524800005, 6.236232815000051],
              [100.19996178500003, 6.258978583000044],
              [100.17457116000003, 6.290961005000042],
              [100.15284264400003, 6.333929755000042],
              [100.13746178500003, 6.380519924000055],
              [100.13111412900008, 6.423407294000071],
              [100.12728925900007, 6.442287502000056],
              [100.1355721440001, 6.457720643000087],
              [100.14435713700004, 6.479579773000125],
              [100.1484912520001, 6.504487814000086],
              [100.14807784100009, 6.513221131000066],
              [100.1448222250001, 6.530584412000081],
              [100.14570072500004, 6.539524435000104],
              [100.15241866100007, 6.54998891200006],
              [100.16120365400013, 6.557456156000086],
              [100.16719812000008, 6.566137797000053],
              [100.1651827390001, 6.580322978000098],
              [100.15717289200006, 6.603525696000105],
              [100.15608768800013, 6.620578919000124],
              [100.16275394700006, 6.661119080000049],
              [100.16404585800012, 6.683727519000087],
              [100.16683638600006, 6.695122172000083],
              [100.17329593900013, 6.703416240000138],
              [100.18755863400008, 6.707963766000077],
              [100.1966536870001, 6.702486064000084],
              [100.1992002020001, 6.69941363900007],
              [100.20378503500012, 6.693881938000061],
              [100.21236332200004, 6.689179383000081],
              [100.22750451700006, 6.688869324000095],
              [100.22750451700006, 6.690833028000029],
              [100.24264571200007, 6.700263977000091],
              [100.25174076400003, 6.701090801000106],
              [100.2633162840001, 6.700005595000022],
              [100.27396163000009, 6.696259053000091],
              [100.28078291900005, 6.688921000000107],
              [100.3178865970001, 6.576705628000113],
              [100.32920373500008, 6.557766215000072],
              [100.34878910300012, 6.54060963900011],
              [100.37765899000004, 6.526754413000091],
              [100.38739139900008, 6.522083639000073],
              [100.40966394000003, 6.51526234900011],
              [100.42651045700012, 6.51389292500005],
              [100.45234867400006, 6.516864319000149],
              [100.46723148600006, 6.513221131000066],
              [100.49916752200005, 6.490302633000042],
              [100.51740930200003, 6.481905213000061],
              [100.5784391680001, 6.464257711000059],
              [100.6126489670001, 6.449168193000062],
              [100.63068404100011, 6.444775696000065],
              [100.64840905700004, 6.447152812000112],
              [100.71284956900013, 6.493041484000088],
              [100.72995446800007, 6.493196513000029],
              [100.73150476100011, 6.487021179000052],
              [100.7311947020001, 6.464722799000086],
              [100.73388187700004, 6.456377055000118],
              [100.74230513500004, 6.45012420700003],
              [100.75160689400013, 6.44880645700006],
              [100.76189050400006, 6.448961487000105],
              [100.77325931800004, 6.447307841000054],
              [100.79630700700011, 6.433949484000038],
              [100.80560876500004, 6.414803365000125],
              [100.80845096900009, 6.367261048000017],
              [100.81072473200004, 6.355763041000088],
              [100.81516890500012, 6.344833476000105],
              [100.82710616100007, 6.324550477000102],
              [100.82901818900007, 6.316256409000047],
              [100.8268994550001, 6.307058004000055],
              [100.82373221800003, 6.298604273000123],
              [100.82338545800008, 6.297678731000104],
              [100.82152510600014, 6.288764547000085],
              [100.82214522400011, 6.259877422000031],
              [100.82457401500005, 6.251480001000047],
              [100.83299727400009, 6.236674703000034],
              [100.83733809400013, 6.237191467000073],
              [100.84281579600014, 6.243935242000092],
              [100.85511478700005, 6.247914328000078],
              [100.86844730700011, 6.24615732800001],
              [100.91009851100011, 6.235796204000081],
              [100.92890873200014, 6.240627950000103],
              [100.95516036000004, 6.268636576000105],
              [100.97428064000007, 6.272615662000092],
              [101.0064750570001, 6.246364034000067],
              [101.02306319200011, 6.240989685000102],
              [101.0689518640001, 6.250859883000075],
              [101.08166426600013, 6.246467387000081],
              [101.08827884900012, 6.233522441000076],
              [101.09101770000007, 6.213161926000041],
              [101.08915734900006, 6.188848165000124],
              [101.08001062000005, 6.18034739200003],
              [101.06688480700012, 6.174327088000084],
              [101.05344893400007, 6.157609761000046],
              [101.05251875900012, 6.134562073000083],
              [101.06853845200004, 6.119550069000098],
              [101.08714196800003, 6.105597433000113],
              [101.09427331500007, 6.085753683000121],
              [101.08900232000013, 6.046608785000089],
              [101.0874520270001, 5.98968719500003],
              [101.08042403200011, 5.957027690000047],
              [101.07877038600003, 5.93816579200012],
              [101.07112227400006, 5.919846497000051],
              [101.05293217000013, 5.913102722000104],
              [101.03184818500011, 5.908916931000078],
              [101.0153117270001, 5.898349101000093],
              [100.97428064000007, 5.815305075000126],
              [100.96771773300009, 5.804117126000094],
              [100.96528894000011, 5.792412415000115],
              [100.96720096800004, 5.781017762000118],
              [100.97242665500005, 5.772852627000077],
              [100.98001672400011, 5.760993144000082],
              [100.99174727400009, 5.737480367000089],
              [100.99862023900005, 5.729548035000036],
              [101.00838708500004, 5.725672302000078],
              [101.02740401200009, 5.726550802000119],
              [101.03732588700007, 5.724587097000082],
              [101.05980513500009, 5.709575094000101],
              [101.07877038600003, 5.687767640000089],
              [101.0939632570001, 5.662652893000057],
              [101.1054354260001, 5.637641500000072],
              [101.12217858900004, 5.629890035000059],
              [101.1499805090001, 5.638649190000137],
              [101.19685103400013, 5.666812846000084],
              [101.21230228700011, 5.681514791000083],
              [101.22501469000008, 5.699213969000098],
              [101.23359297700011, 5.719419454000089],
              [101.23664188700013, 5.741666158000029],
              [101.2489925540001, 5.786986389000049],
              [101.27968835500013, 5.803031921000098],
              [101.31896244400008, 5.810085755000031],
              [101.35756473800006, 5.8284050500001],
              [101.39265303600013, 5.851091004000068],
              [101.50020142500006, 5.892693601000047],
              [101.53465987100003, 5.906023051000091],
              [101.55791426600013, 5.911345724000043],
              [101.57930831000004, 5.906333109000073],
              [101.59512129800004, 5.885352478000073],
              [101.5997721760001, 5.874061178000105],
              [101.60514652500007, 5.866103007000049],
              [101.61289799000008, 5.861348775000053],
              [101.62457686400006, 5.859410909000118],
              [101.63408532700004, 5.855586853000077],
              [101.63439538600011, 5.847344462000137],
              [101.63129480000009, 5.837370911000036],
              [101.63077803600004, 5.8284050500001],
              [101.65036340400013, 5.782645569000067],
              [101.66591800900005, 5.765592346000034],
              [101.68669193600005, 5.761199849000135],
              [101.69661381100013, 5.766264140000104],
              [101.6975667000001, 5.767138300000056],
              [101.71475223800013, 5.782903951000037],
              [101.72679284700013, 5.786469625000095],
              [101.74002201400003, 5.782361349000084],
              [101.74787683100004, 5.772387797000079],
              [101.75418135600006, 5.760269674000085],
              [101.76286299700013, 5.74954681400007],
              [101.78415368600008, 5.738100484000057],
              [101.80048343900006, 5.739909159000149],
              [101.81226566600003, 5.752544047000086],
              [101.82022383600008, 5.773731384000129],
              [101.82549483300005, 5.779829203000091],
              [101.8547436930001, 5.797657573000052],
              [101.86084151200004, 5.806494242000042],
              [101.86425215700007, 5.815408427000065],
              [101.86921309400003, 5.823857524000061],
              [101.88032352800013, 5.831040548000104],
              [101.91293135600012, 5.85930755600009],
              [101.91928755700013, 5.897573955000084],
              [101.91975264500013, 5.940258687000082],
              [101.93473881000011, 5.98172902400006],
              [101.95938846900003, 6.011598002000071],
              [102.03344079600004, 6.068390402000105],
              [102.06000248200007, 6.094797058000083],
              [102.07126794400011, 6.126655579000044],
              [102.06665583400007, 6.204748336000051],
              [102.07309004000007, 6.257513739000046],
            ],
          ],
          [
            [
              [115.14616946700005, 4.908514716000127],
              [115.16285241000003, 4.908026434000078],
              [115.17823326900009, 4.910060940000051],
              [115.18946373800009, 4.917466539000088],
              [115.19890384200005, 4.950751044000071],
              [115.21062259200005, 4.95970286700009],
              [115.22437584700003, 4.958319403000075],
              [115.23552493600005, 4.944322007000039],
              [115.238617384, 4.937323309000078],
              [115.24390709700003, 4.935451565000051],
              [115.26563561300009, 4.936916408000059],
              [115.27523847700002, 4.935248114000046],
              [115.28532962300005, 4.931219794000071],
              [115.29322350400003, 4.925726630000042],
              [115.30396569100003, 4.906154690000051],
              [115.32162519600001, 4.900132554000038],
              [115.34229576900009, 4.899807033000059],
              [115.35840905000009, 4.902777411000045],
              [115.37029056100005, 4.91087474200009],
              [115.40349368600005, 4.944322007000039],
              [115.40788821700005, 4.950344143000052],
              [115.44776451900009, 4.985296942000048],
              [115.47974694100003, 5.02602773600006],
              [115.49219811300009, 5.032456773000092],
              [115.51246178500003, 5.03587474200009],
              [115.53174889400009, 5.044623114000046],
              [115.54761803500003, 5.055812893000052],
              [115.556976759, 5.067206122000073],
              [115.56299889400009, 5.083156643000052],
              [115.56983483200008, 5.123724677000041],
              [115.57129967500009, 5.160060940000051],
              [115.57349694100003, 5.169663804000038],
              [115.58423912900003, 5.190130927000041],
              [115.59253991000003, 5.19867584800005],
              [115.60132897200003, 5.204575914000088],
              [115.60523522200003, 5.212103583000044],
              [115.59864342500009, 5.225490627000056],
              [115.56080162900003, 5.207831122000073],
              [115.523773634, 5.208807684000078],
              [115.48975670700008, 5.22296784100007],
              [115.40064537900003, 5.299994208000044],
              [115.39812259200005, 5.30931224200009],
              [115.40040123800009, 5.317857164000088],
              [115.39975019600001, 5.324204820000091],
              [115.38917076900009, 5.326646226000094],
              [115.38477623800009, 5.324408270000049],
              [115.36524498800009, 5.307440497000073],
              [115.35962975400003, 5.319647528000075],
              [115.36264082100001, 5.333889065000051],
              [115.36866295700008, 5.349310614000046],
              [115.37525475400003, 5.381984768000052],
              [115.38233483200008, 5.39524974200009],
              [115.38941491000003, 5.405666408000059],
              [115.39258873800009, 5.413275458000044],
              [115.40430748800009, 5.423895575000074],
              [115.45639082100001, 5.454331773000092],
              [115.46827233200008, 5.474676825000074],
              [115.47950280000009, 5.48969147300005],
              [115.55014082100001, 5.540187893000052],
              [115.58521569100003, 5.616156317000048],
              [115.60482832100001, 5.635809637000079],
              [115.61882571700005, 5.612860419000071],
              [115.584320509, 5.548488674000055],
              [115.60482832100001, 5.519720770000049],
              [115.61003665500004, 5.530096747000073],
              [115.61443118600005, 5.55727773600006],
              [115.61915123800009, 5.568060614000046],
              [115.65333092500009, 5.538641669000071],
              [115.67408287900003, 5.529364325000074],
              [115.76238040500004, 5.523138739000046],
              [115.79127037900003, 5.524888414000088],
              [115.81771894600001, 5.533351955000057],
              [115.84864342500009, 5.56000397300005],
              [115.87435957100001, 5.599351304000038],
              [115.89421634200005, 5.643255927000041],
              [115.90650475400003, 5.683579820000091],
              [115.91407311300009, 5.727443752000056],
              [115.91993248800009, 5.746771552000041],
              [115.93067467500009, 5.763006903000075],
              [115.94532311300009, 5.77484772300005],
              [116.03516686300009, 5.82493724200009],
              [116.05079186300009, 5.842271226000094],
              [116.05738366000003, 5.865139065000051],
              [116.06031334700003, 5.911281643000052],
              [116.06641686300009, 5.930650132000039],
              [116.12769616000003, 6.029771226000094],
              [116.14185631600003, 6.073065497000073],
              [116.12623131600003, 6.102525132000039],
              [116.10377037900003, 6.094712632000039],
              [116.09595787900003, 6.10773346600007],
              [116.10596764400009, 6.126450914000088],
              [116.13640384200005, 6.136053778000075],
              [116.15406334700003, 6.147284247000073],
              [116.20134524800005, 6.217962958000044],
              [116.22266686300009, 6.237209377000056],
              [116.23536217500009, 6.243475653000075],
              [116.25220787900003, 6.245917059000078],
              [116.264008009, 6.241888739000046],
              [116.27898196700005, 6.234930731000077],
              [116.29151451900009, 6.232611395000049],
              [116.29688561300009, 6.24249909100007],
              [116.29273522200003, 6.275783596000053],
              [116.28052819100003, 6.278550523000092],
              [116.26140384200005, 6.269354559000078],
              [116.23609459700003, 6.26634349200009],
              [116.23609459700003, 6.272609768000052],
              [116.26335696700005, 6.286851304000038],
              [116.27906334700003, 6.303941148000092],
              [116.28321373800009, 6.30735911700009],
              [116.29053795700008, 6.308579820000091],
              [116.31055748800009, 6.30735911700009],
              [116.31999759200005, 6.313381252000056],
              [116.32203209700003, 6.31671784100007],
              [116.32195071700005, 6.322333075000074],
              [116.33057701900009, 6.35423411700009],
              [116.33326256600003, 6.360581773000092],
              [116.33838951900009, 6.368841864000046],
              [116.34766686300009, 6.379584052000041],
              [116.43637129000001, 6.446844794000071],
              [116.45142662900003, 6.461900132000039],
              [116.46949303500003, 6.475775458000044],
              [116.48829186300009, 6.484279690000051],
              [116.50318444100003, 6.495184637000079],
              [116.50912519600001, 6.516546942000048],
              [116.50968438934618, 6.532064549194557],
              [116.50977623800009, 6.53461334800005],
              [116.51319420700008, 6.553697007000039],
              [116.52068118600005, 6.568752346000053],
              [116.53394616000003, 6.57485586100006],
              [116.55152428500003, 6.588364976000094],
              [116.61353600400003, 6.671087958000044],
              [116.62859134200005, 6.685370184000078],
              [116.639008009, 6.699286200000074],
              [116.64503014400009, 6.716945705000057],
              [116.64698326900009, 6.742417710000041],
              [116.64535566500001, 6.776312567000048],
              [116.64698326900009, 6.786525783000059],
              [116.65113366000003, 6.794419664000088],
              [116.66334069100003, 6.811021226000094],
              [116.66749108200008, 6.821275132000039],
              [116.66578209700003, 6.859605210000041],
              [116.66920006600003, 6.87641022300005],
              [116.69752037900003, 6.889715887000079],
              [116.70582116000003, 6.905340887000079],
              [116.71534264400009, 6.94476959800005],
              [116.71656334700003, 6.966742255000042],
              [116.71892337300005, 6.975409247000073],
              [116.72608483200008, 6.978949286000045],
              [116.73023522200003, 6.982407945000091],
              [116.74097741000003, 6.998439846000053],
              [116.746429884, 7.010443427000041],
              [116.75505618600005, 7.018744208000044],
              [116.76587975400003, 7.025091864000046],
              [116.77735436300009, 7.026760158000059],
              [116.78052819100003, 7.022772528000075],
              [116.79086347700002, 7.000067450000074],
              [116.83204186300009, 6.973334052000041],
              [116.83814537900003, 6.962144273000092],
              [116.85181725400003, 6.890204169000071],
              [116.83326256600003, 6.900824286000045],
              [116.82252037900003, 6.904120184000078],
              [116.81763756600003, 6.900091864000046],
              [116.81120853000004, 6.868841864000046],
              [116.81080162900003, 6.862860419000071],
              [116.82227623800009, 6.852850653000075],
              [116.83814537900003, 6.847398179000038],
              [116.85238691500001, 6.83852773600006],
              [116.85865319100003, 6.817857164000088],
              [116.85466556100005, 6.778509833000044],
              [116.84392337300005, 6.75226471600007],
              [116.81080162900003, 6.704575914000088],
              [116.79273522200003, 6.669745184000078],
              [116.77849368600005, 6.626532294000071],
              [116.78394616000003, 6.591620184000078],
              [116.82447350400003, 6.581732489000046],
              [116.84546959700003, 6.592027085000041],
              [116.86101321700005, 6.610541083000044],
              [116.87305748800009, 6.62836334800005],
              [116.88306725400003, 6.636297919000071],
              [116.89673912900003, 6.642075914000088],
              [116.94117272200003, 6.684759833000044],
              [116.97380618600005, 6.708075262000079],
              [116.98023522200003, 6.720363674000055],
              [116.98414147200003, 6.754950262000079],
              [116.98902428500003, 6.759182033000059],
              [116.99561608200008, 6.761135158000059],
              [117.00261478000004, 6.766669012000079],
              [117.01628665500004, 6.793931382000039],
              [117.05250084700003, 6.830755927000041],
              [117.05787194100003, 6.845526434000078],
              [117.05176842500009, 6.866197007000039],
              [117.02930748800009, 6.909979559000078],
              [117.03052819100003, 6.931138414000088],
              [117.03858483200008, 6.942613023000092],
              [117.04656009200005, 6.943793036000045],
              [117.05583743600005, 6.940375067000048],
              [117.06812584700003, 6.937974351000094],
              [117.07667076900009, 6.941310940000051],
              [117.08326256600003, 6.948472398000092],
              [117.08594811300009, 6.955755927000041],
              [117.08204186300009, 6.959051825000074],
              [117.07447350400003, 6.963771877000056],
              [117.07252037900003, 6.974310614000046],
              [117.07447350400003, 6.985663153000075],
              [117.07837975400003, 6.992621161000045],
              [117.08887780000009, 6.994696356000077],
              [117.10084069100003, 6.991603908000059],
              [117.11215254000001, 6.987290757000039],
              [117.11988366000003, 6.98578522300005],
              [117.12867272200003, 6.990668036000045],
              [117.14380944100003, 7.003729559000078],
              [117.15023847700002, 7.003119208000044],
              [117.15805097700002, 6.998724677000041],
              [117.18344160200002, 6.987860419000071],
              [117.19166100400003, 6.98578522300005],
              [117.19499759200005, 6.981838283000059],
              [117.24675540500004, 6.950506903000075],
              [117.25245201900009, 6.945786851000094],
              [117.25652103000004, 6.937974351000094],
              [117.25733483200008, 6.920843817000048],
              [117.25098717500009, 6.872788804000038],
              [117.24659264400009, 6.862860419000071],
              [117.232758009, 6.855454820000091],
              [117.22836347700002, 6.838080145000049],
              [117.23031660200002, 6.817531643000052],
              [117.23601321700005, 6.800767320000091],
              [117.27198326900009, 6.753729559000078],
              [117.27759850400003, 6.735663153000075],
              [117.28028405000009, 6.673570054000038],
              [117.28443444100003, 6.657416083000044],
              [117.29590905000009, 6.636297919000071],
              [117.308929884, 6.628810940000051],
              [117.34929446700005, 6.630113023000092],
              [117.36475670700008, 6.625148830000057],
              [117.37818444100003, 6.613470770000049],
              [117.39991295700008, 6.588568427000041],
              [117.42481530000009, 6.565578518000052],
              [117.44223066500001, 6.55304596600007],
              [117.45850670700008, 6.547552802000041],
              [117.47486412900003, 6.551459052000041],
              [117.48585045700008, 6.562445380000042],
              [117.50977623800009, 6.60219961100006],
              [117.52540123800009, 6.620998440000051],
              [117.53370201900009, 6.621039130000042],
              [117.53695722700002, 6.605698960000041],
              [117.53760826900009, 6.578314520000049],
              [117.54175866000003, 6.57758209800005],
              [117.56495201900009, 6.554388739000046],
              [117.56104576900009, 6.555731512000079],
              [117.55844160200002, 6.551214911000045],
              [117.55738366000003, 6.544745184000078],
              [117.55811608200008, 6.540106512000079],
              [117.56177819100003, 6.538316148000092],
              [117.574554884, 6.534979559000078],
              [117.57862389400009, 6.533270575000074],
              [117.59359785200002, 6.519598700000074],
              [117.60328209700003, 6.514715887000079],
              [117.61622155000009, 6.512844143000052],
              [117.63021894600001, 6.51984284100007],
              [117.64087975400003, 6.521714585000041],
              [117.65064537900003, 6.516546942000048],
              [117.67465254000001, 6.488959052000041],
              [117.68531334700003, 6.473089911000045],
              [117.69532311300009, 6.451361395000049],
              [117.70215905000009, 6.451361395000049],
              [117.70582116000003, 6.460028387000079],
              [117.71070397200003, 6.463771877000056],
              [117.71631920700008, 6.462958075000074],
              [117.72250410200002, 6.458197333000044],
              [117.72706139400009, 6.451157945000091],
              [117.72828209700003, 6.44367096600007],
              [117.72820071700005, 6.434759833000044],
              [117.72950280000009, 6.423407294000071],
              [117.732758009, 6.414129950000074],
              [117.74195397200003, 6.396714585000041],
              [117.74382571700005, 6.389878648000092],
              [117.74000084700003, 6.380560614000046],
              [117.73308353000004, 6.371568101000094],
              [117.72852623800009, 6.362372137000079],
              [117.73878014400009, 6.335679429000038],
              [117.72950280000009, 6.269476630000042],
              [117.722992384, 6.25462474200009],
              [117.70801842500009, 6.252875067000048],
              [117.67481530000009, 6.258978583000044],
              [117.65626061300009, 6.252752997000073],
              [117.63819420700008, 6.240627346000053],
              [117.60922285200002, 6.214829820000091],
              [117.60035241000003, 6.197821356000077],
              [117.60564212300005, 6.181830145000049],
              [117.62712649800005, 6.156480210000041],
              [117.64332116000003, 6.11749909100007],
              [117.65788821700005, 6.111273505000042],
              [117.66114342500009, 6.105617580000057],
              [117.66260826900009, 6.095770575000074],
              [117.66521243600005, 6.08820221600007],
              [117.66553795700008, 6.079901434000078],
              [117.66114342500009, 6.067775783000059],
              [117.65284264400009, 6.05931224200009],
              [117.64356530000009, 6.056301174000055],
              [117.63607832100001, 6.051947333000044],
              [117.63331139400009, 6.039862372000073],
              [117.63990319100003, 6.023423570000091],
              [117.65414472700002, 6.019761460000041],
              [117.668304884, 6.013413804000038],
              [117.67481530000009, 5.988959052000041],
              [117.66895592500009, 5.972642320000091],
              [117.654633009, 5.958685614000046],
              [117.61963951900009, 5.937445380000042],
              [117.49284915500004, 5.894680080000057],
              [117.46876061300009, 5.868557033000059],
              [117.48650149800005, 5.871771552000041],
              [117.54379316500001, 5.896429755000042],
              [117.56934655000009, 5.902899481000077],
              [117.64014733200008, 5.903265692000048],
              [117.70704186300009, 5.911607164000088],
              [117.75660241000003, 5.906154690000051],
              [117.77426191500001, 5.908026434000078],
              [117.78028405000009, 5.919419664000088],
              [117.77165774800005, 5.944281317000048],
              [117.78223717500009, 5.95062897300005],
              [117.79265384200005, 5.950018622000073],
              [117.80445397200003, 5.946478583000044],
              [117.81885826900009, 5.944281317000048],
              [117.83659915500004, 5.945502020000049],
              [117.88404381600003, 5.954657294000071],
              [117.89389082100001, 5.961330471000053],
              [117.90007571700005, 5.973944403000075],
              [117.91391035200002, 5.986476955000057],
              [117.94109134200005, 6.005682684000078],
              [117.97364342500009, 6.047756252000056],
              [117.99138431100005, 6.056789455000057],
              [117.99545332100001, 6.061712958000044],
              [118.00261478000004, 6.064601955000057],
              [118.01685631600003, 6.060980536000045],
              [118.05095462300005, 6.026190497000073],
              [118.05323326900009, 6.016302802000041],
              [118.05250084700003, 6.00531647300005],
              [118.05372155000009, 5.996323960000041],
              [118.07097415500004, 5.987372137000079],
              [118.07357832100001, 5.975287177000041],
              [118.07203209700003, 5.954779364000046],
              [118.07715905000009, 5.931586005000042],
              [118.11898847700002, 5.875392971000053],
              [118.12452233200008, 5.870347398000092],
              [118.12517337300005, 5.86391836100006],
              [118.09595787900003, 5.824164130000042],
              [118.08106530000009, 5.815375067000048],
              [118.05884850400003, 5.808986721000053],
              [118.03541100400003, 5.807766018000052],
              [118.01685631600003, 5.814520575000074],
              [118.00001061300009, 5.808986721000053],
              [117.93799889400009, 5.814520575000074],
              [117.92115319100003, 5.809027411000045],
              [117.91041100400003, 5.796861070000091],
              [117.90845787900003, 5.784654039000088],
              [117.91773522200003, 5.779201565000051],
              [117.92204837300005, 5.771714585000041],
              [117.95199629000001, 5.69407786700009],
              [117.96029707100001, 5.687160549000055],
              [117.96485436300009, 5.686224677000041],
              [117.97055097700002, 5.688544012000079],
              [117.98267662900003, 5.691066799000055],
              [117.99805748800009, 5.69594961100006],
              [118.03785241000003, 5.71430084800005],
              [118.05469811300009, 5.718329169000071],
              [118.06275475400003, 5.716620184000078],
              [118.06959069100003, 5.707993882000039],
              [118.07886803500003, 5.704657294000071],
              [118.08659915500004, 5.706366278000075],
              [118.09620201900009, 5.710516669000071],
              [118.10661868600005, 5.712591864000046],
              [118.11646569100003, 5.708075262000079],
              [118.12671959700003, 5.693548895000049],
              [118.13404381600003, 5.689642645000049],
              [118.14372806100005, 5.69407786700009],
              [118.15154056100005, 5.705145575000074],
              [118.15162194100003, 5.714097398000092],
              [118.14714603000004, 5.724554755000042],
              [118.15381920700008, 5.742132880000042],
              [118.15821373800009, 5.749009507000039],
              [118.16456139400009, 5.75617096600007],
              [118.16724694100003, 5.76439036700009],
              [118.15935306100005, 5.782782294000071],
              [118.16081790500004, 5.793402411000045],
              [118.17628014400009, 5.805161851000094],
              [118.22095787900003, 5.809556382000039],
              [118.26221764400009, 5.827866929000038],
              [118.28370201900009, 5.823228257000039],
              [118.33578535200002, 5.795843817000048],
              [118.34066816500001, 5.794256903000075],
              [118.34571373800009, 5.798407294000071],
              [118.35670006600003, 5.810777085000041],
              [118.36524498800009, 5.813788153000075],
              [118.375336134, 5.809881903000075],
              [118.38453209700003, 5.803941148000092],
              [118.39079837300005, 5.800930080000057],
              [118.41065514400009, 5.796128648000092],
              [118.51303144600001, 5.736761786000045],
              [118.54810631600003, 5.708075262000079],
              [118.56185957100001, 5.699774481000077],
              [118.57927493600005, 5.69171784100007],
              [118.59400475400003, 5.682074286000045],
              [118.59961998800009, 5.669256903000075],
              [118.59595787900003, 5.659369208000044],
              [118.58863366000003, 5.653631903000075],
              [118.58171634200005, 5.649969794000071],
              [118.578461134, 5.646307684000078],
              [118.568695509, 5.589544989000046],
              [118.56202233200008, 5.568019924000055],
              [118.55884850400003, 5.546861070000091],
              [118.56544030000009, 5.525946356000077],
              [118.57227623800009, 5.525946356000077],
              [118.58220462300005, 5.551336981000077],
              [118.58838951900009, 5.562689520000049],
              [118.59595787900003, 5.571234442000048],
              [118.60059655000009, 5.581284898000092],
              [118.59896894600001, 5.607977606000077],
              [118.60303795700008, 5.618719794000071],
              [118.62907962300005, 5.636623440000051],
              [118.65105228000004, 5.636419989000046],
              [118.670258009, 5.623032945000091],
              [118.71729576900009, 5.565822658000059],
              [118.73658287900003, 5.547837632000039],
              [118.75391686300009, 5.540187893000052],
              [118.78028405000009, 5.535345770000049],
              [118.80005944100003, 5.52212148600006],
              [118.81299889400009, 5.502346096000053],
              [118.81934655000009, 5.478094794000071],
              [118.82683353000004, 5.483628648000092],
              [118.83106530000009, 5.48859284100007],
              [118.83277428500003, 5.495266018000052],
              [118.832367384, 5.505438544000071],
              [118.87956790500004, 5.469794012000079],
              [118.89795983200008, 5.464504299000055],
              [118.91879316500001, 5.454982815000051],
              [118.93572024800005, 5.433986721000053],
              [118.93946373800009, 5.41282786700009],
              [118.92172285200002, 5.403021552000041],
              [118.93262780000009, 5.394110419000071],
              [118.94825280000009, 5.388576565000051],
              [118.96452884200005, 5.388413804000038],
              [118.97641035200002, 5.395575262000079],
              [118.97925866000003, 5.409125067000048],
              [118.97339928500003, 5.419582424000055],
              [118.97087649800005, 5.428290106000077],
              [118.98389733200008, 5.436509507000039],
              [119.00831139400009, 5.43585846600007],
              [119.05567467500009, 5.410956122000073],
              [119.08570397200003, 5.409857489000046],
              [119.16382897200003, 5.446966864000046],
              [119.18930097700002, 5.450751044000071],
              [119.20484459700003, 5.443345445000091],
              [119.21957441500001, 5.427923895000049],
              [119.24333743600005, 5.395575262000079],
              [119.26498457100001, 5.374212958000044],
              [119.27426191500001, 5.361151434000078],
              [119.27808678500003, 5.344631252000056],
              [119.27588951900009, 5.322943427000041],
              [119.26644941500001, 5.28978099200009],
              [119.26441491000003, 5.272691148000092],
              [119.26929772200003, 5.226223049000055],
              [119.26710045700008, 5.201076565000051],
              [119.24415123800009, 5.181341864000046],
              [119.19556725400003, 5.128648179000038],
              [119.15593509200005, 5.10618724200009],
              [118.97315514400009, 5.039943752000056],
              [118.78663170700008, 4.986029364000046],
              [118.75074303500003, 4.964056708000044],
              [118.72730553500003, 4.953924872000073],
              [118.70248457100001, 4.946600653000075],
              [118.68148847700002, 4.944322007000039],
              [118.66586347700002, 4.94798411700009],
              [118.63445071700005, 4.961330471000053],
              [118.605804884, 4.965765692000048],
              [118.58497155000009, 4.971869208000044],
              [118.57227623800009, 4.971625067000048],
              [118.56023196700005, 4.96743398600006],
              [118.53077233200008, 4.944322007000039],
              [118.50904381600003, 4.931057033000059],
              [118.49935957100001, 4.931463934000078],
              [118.48633873800009, 4.940619208000044],
              [118.48072350400003, 4.94798411700009],
              [118.46265709700003, 4.978745835000041],
              [118.42839603000004, 5.018784898000092],
              [118.39698326900009, 5.034816799000055],
              [118.37623131600003, 5.041083075000074],
              [118.36687259200005, 5.03587474200009],
              [118.35718834700003, 5.038804429000038],
              [118.33578535200002, 5.025132554000038],
              [118.30486087300005, 4.998928127000056],
              [118.29672285200002, 5.004584052000041],
              [118.29167728000004, 5.000921942000048],
              [118.28972415500004, 4.99095286700009],
              [118.29127037900003, 4.977850653000075],
              [118.25269616000003, 4.987127997000073],
              [118.21697024800005, 4.965806382000039],
              [118.16081790500004, 4.902777411000045],
              [118.14389082100001, 4.890285549000055],
              [118.13648522200003, 4.882310289000088],
              [118.13355553500003, 4.87173086100006],
              [118.13493899800005, 4.859605210000041],
              [118.139008009, 4.855373440000051],
              [118.14576256600003, 4.853216864000046],
              [118.17139733200008, 4.83657461100006],
              [118.17798912900003, 4.830755927000041],
              [118.18384850400003, 4.821844794000071],
              [118.19499759200005, 4.792914130000042],
              [118.21900475400003, 4.756293036000045],
              [118.246429884, 4.723822333000044],
              [118.27759850400003, 4.695135809000078],
              [118.31226647200003, 4.669907945000091],
              [118.32520592500009, 4.657863674000055],
              [118.33350670700008, 4.651556708000044],
              [118.34262129000001, 4.648871161000045],
              [118.35181725400003, 4.648627020000049],
              [118.37281334700003, 4.645819403000075],
              [118.38054446700005, 4.642645575000074],
              [118.38526451900009, 4.636664130000042],
              [118.39323978000004, 4.618353583000044],
              [118.39771569100003, 4.611314195000091],
              [118.40406334700003, 4.605861721000053],
              [118.41114342500009, 4.601507880000042],
              [118.42839603000004, 4.594305731000077],
              [118.43083743600005, 4.611273505000042],
              [118.44459069100003, 4.614935614000046],
              [118.46241295700008, 4.61001211100006],
              [118.47673587300005, 4.601141669000071],
              [118.48747806100005, 4.587591864000046],
              [118.48951256600003, 4.575100002000056],
              [118.48438561300009, 4.562730210000041],
              [118.47331790500004, 4.549872137000079],
              [118.46941165500004, 4.537176825000074],
              [118.47820071700005, 4.526068427000041],
              [118.49040774800005, 4.516506252000056],
              [118.49659264400009, 4.508286851000094],
              [118.50489342500009, 4.502386786000045],
              [118.52328535200002, 4.511623440000051],
              [118.55193118600005, 4.532782294000071],
              [118.56316165500004, 4.527248440000051],
              [118.58741295700008, 4.523830471000053],
              [118.59961998800009, 4.519191799000055],
              [118.59400475400003, 4.505519924000055],
              [118.60564212300005, 4.486883856000077],
              [118.64527428500003, 4.444037177000041],
              [118.64576256600003, 4.436753648000092],
              [118.63721764400009, 4.426011460000041],
              [118.62623131600003, 4.419338283000059],
              [118.617523634, 4.420721747000073],
              [118.60759524800005, 4.425523179000038],
              [118.592133009, 4.42914459800005],
              [118.59742272200003, 4.412298895000049],
              [118.59278405000009, 4.397365627000056],
              [118.58277428500003, 4.384588934000078],
              [118.57227623800009, 4.374579169000071],
              [118.55689537900003, 4.363511460000041],
              [118.54281660200002, 4.36001211100006],
              [118.50342858200008, 4.361517645000049],
              [118.48658287900003, 4.359523830000057],
              [118.45435631600003, 4.350287177000041],
              [118.43523196700005, 4.347235419000071],
              [118.39193769600001, 4.346380927000041],
              [118.36890709700003, 4.350572007000039],
              [118.35328209700003, 4.361517645000049],
              [118.340179884, 4.34406159100007],
              [118.33253014400009, 4.339016018000052],
              [118.24203535200002, 4.313666083000044],
              [118.16081790500004, 4.306219794000071],
              [118.137054884, 4.298651434000078],
              [118.00456790500004, 4.231634833000044],
              [117.98267662900003, 4.231146552000041],
              [117.92107181100005, 4.249090887000079],
              [117.90447024800005, 4.251654364000046],
              [117.89226321700005, 4.256984768000052],
              [117.85368899800005, 4.292629299000055],
              [117.83961022200003, 4.300848700000074],
              [117.83122806100005, 4.304673570000091],
              [117.82252037900003, 4.306219794000071],
              [117.81885826900009, 4.310532945000091],
              [117.81202233200008, 4.329291083000044],
              [117.80827884200005, 4.333563544000071],
              [117.79476972700002, 4.334906317000048],
              [117.76351972700002, 4.347235419000071],
              [117.73845462300005, 4.351792710000041],
              [117.72950280000009, 4.354681708000044],
              [117.70753014400009, 4.369940497000073],
              [117.69613691500001, 4.387762762000079],
              [117.68702233200008, 4.407049872000073],
              [117.67115319100003, 4.426011460000041],
              [117.65601647200003, 4.424221096000053],
              [117.63412519600001, 4.410101630000042],
              [117.61459394600001, 4.393052476000094],
              [117.605804884, 4.382025458000044],
              [117.60962975400003, 4.37335846600007],
              [117.62875410200002, 4.361761786000045],
              [117.63331139400009, 4.350978908000059],
              [117.63331139400009, 4.309637762000079],
              [117.63697350400003, 4.299017645000049],
              [117.65211022200003, 4.284857489000046],
              [117.65365644600001, 4.272162177000041],
              [117.64909915500004, 4.260728257000039],
              [117.64047285200002, 4.251369533000059],
              [117.61963951900009, 4.237372137000079],
              [117.61304772200003, 4.230902411000045],
              [117.60808353000004, 4.222235419000071],
              [117.60206139400009, 4.215277411000045],
              [117.59896894600001, 4.206935940000051],
              [117.60271243600005, 4.201727606000077],
              [117.62029056100005, 4.184719143000052],
              [117.62712649800005, 4.17649974200009],
              [117.61703535200002, 4.177435614000046],
              [117.60840905000009, 4.176214911000045],
              [117.56714928500003, 4.159654039000131],
              [117.55833296800006, 4.167653707000056],
              [117.54220992000006, 4.173829040000044],
              [117.51461470500016, 4.171942851000026],
              [117.49838830600004, 4.172614644000106],
              [117.46417850800009, 4.177911479000045],
              [117.43647994000003, 4.185611267000041],
              [117.41291548700013, 4.200080668000069],
              [117.35658817600006, 4.259508566000108],
              [117.27555953000001, 4.300978903000086],
              [117.2386625580001, 4.326868795000024],
              [117.23060103400007, 4.337178243000025],
              [117.22481327300005, 4.346583354000074],
              [117.21716516200007, 4.353430481000132],
              [117.20269576100009, 4.35606597900005],
              [117.19039676900007, 4.353017069000117],
              [117.17437707500005, 4.338418477000062],
              [117.1646619060001, 4.333147481000125],
              [116.9805904540001, 4.329555970000058],
              [116.92426314300008, 4.34495554700004],
              [116.88302535100007, 4.344903870000024],
              [116.804477173, 4.330072733000094],
              [116.7661332610001, 4.338573507000092],
              [116.72944299300002, 4.364463399000044],
              [116.7116663000001, 4.366788838000062],
              [116.68004032400012, 4.339917094000072],
              [116.66112675000016, 4.334387716000066],
              [116.64179976500009, 4.333870952000026],
              [116.61554813700002, 4.344077047000098],
              [116.59022668500012, 4.33113210100008],
              [116.5768941660001, 4.332010600000018],
              [116.53327925700006, 4.395365906000038],
              [116.52222050000006, 4.396787008000018],
              [116.5153992110001, 4.384152120000081],
              [116.49431522600003, 4.363223165000093],
              [116.48646040900013, 4.348831278000091],
              [116.48697717300007, 4.338573507000092],
              [116.49193811000009, 4.331287130000121],
              [116.4941085210001, 4.324853414000074],
              [116.48594364400009, 4.316921082000107],
              [116.46837365800002, 4.312321879000066],
              [116.45710819500005, 4.316766052000077],
              [116.446359497, 4.317256979000106],
              [116.42176151600006, 4.291832174000092],
              [116.4113228760001, 4.288654074000135],
              [116.40088423700007, 4.2899976610001],
              [116.39106571500008, 4.294674377000078],
              [116.36543420400005, 4.337695008000068],
              [116.36181685400004, 4.350381572000103],
              [116.35819950400008, 4.355445862000082],
              [116.35127486200008, 4.357900492000056],
              [116.3442468670001, 4.356918640000089],
              [116.33752893100007, 4.357228699000075],
              [116.31065718600007, 4.383376974000072],
              [116.28512902900002, 4.378390198000119],
              [116.25722375600003, 4.364153341000048],
              [116.22880171700001, 4.356117656000066],
              [116.21505578700015, 4.357848816000043],
              [116.17009729000006, 4.369915263000024],
              [116.14684289600012, 4.371207173000073],
              [116.13650760900015, 4.373041687000068],
              [116.12575891200004, 4.378906962000059],
              [116.11749068300009, 4.357228699000075],
              [116.10994592300011, 4.345110575000078],
              [116.09940393100015, 4.336506449000041],
              [116.08121382700011, 4.325473531000043],
              [116.03315474500005, 4.277724507000073],
              [116.02064904800005, 4.270851542000102],
              [116.0040092370001, 4.276690980000083],
              [115.99357059800002, 4.288912455000101],
              [115.9873694260001, 4.304777120000026],
              [115.98344201700002, 4.321391093000031],
              [115.97724084500015, 4.328625794000089],
              [115.96483850100009, 4.335472921000061],
              [115.94096398900001, 4.344361267000068],
              [115.89879602100007, 4.347125956000113],
              [115.87884891800002, 4.352138570000079],
              [115.86944380700004, 4.366685486000037],
              [115.86489628100003, 4.38257598900006],
              [115.85611128800014, 4.390766703000082],
              [115.84412235500008, 4.38921641000006],
              [115.8309965420001, 4.3761164350001],
              [115.82117802000005, 4.344335429000068],
              [115.82190149000007, 4.311236674000071],
              [115.81745731700005, 4.281316020000048],
              [115.77942346200012, 4.248940735000048],
              [115.7753927010001, 4.236099142000057],
              [115.77074182100006, 4.225608825000108],
              [115.7568925380001, 4.222172343000068],
              [115.74717736900004, 4.227624207000062],
              [115.74025272700015, 4.236202495000086],
              [115.73260461500001, 4.239380595000057],
              [115.68981652900004, 4.199977315000041],
              [115.68278853400005, 4.19064972000011],
              [115.6759672450001, 4.184164327000047],
              [115.65591678900006, 4.178634949000042],
              [115.64692508900009, 4.16910064700005],
              [115.63913433100004, 4.145949698000067],
              [115.63328251200011, 4.128560486000126],
              [115.62212040200006, 4.040219625000134],
              [115.60951135200003, 3.996914774000075],
              [115.5902877200001, 3.958002421000089],
              [115.580985962, 3.946917827000078],
              [115.54584598900016, 3.927720032000067],
              [115.53881799400006, 3.920614522000037],
              [115.53830122900001, 3.897825216000044],
              [115.554114217, 3.883562520000069],
              [115.57457808400017, 3.872090353000146],
              [115.58863407400008, 3.857595113000116],
              [115.58935754500015, 3.824522197000121],
              [115.5504968670001, 3.708224385000037],
              [115.54460575400003, 3.668976136000069],
              [115.54439904800006, 3.629159445000141],
              [115.548533163, 3.605284933000064],
              [115.57333785000003, 3.545004374000087],
              [115.574474731, 3.534565735000044],
              [115.57240767500008, 3.514256897000038],
              [115.57271773300016, 3.50415415500008],
              [115.57612837800008, 3.491674296000085],
              [115.59266483600004, 3.461960348000019],
              [115.60062300600009, 3.441212260000086],
              [115.601243124, 3.43023101900009],
              [115.59545536300004, 3.420851746000054],
              [115.58501672400007, 3.416820984000054],
              [115.57602502500004, 3.419404805000056],
              [115.56713667800005, 3.42384897900007],
              [115.55721480300014, 3.425450948000091],
              [115.53582076000009, 3.403617656000065],
              [115.51763065600005, 3.357160543000049],
              [115.482800741, 3.206472066000103],
              [115.48352421100003, 3.189005432000059],
              [115.49933719900002, 3.169781800000038],
              [115.5144267180001, 3.164769186000072],
              [115.51701053900001, 3.157276103000129],
              [115.48218062400014, 3.110974020000057],
              [115.47597945200005, 3.093042297000082],
              [115.47215539600012, 3.050512594000026],
              [115.46409387300002, 3.030823873000074],
              [115.44797082500014, 3.024054261000046],
              [115.40683638500008, 3.019506734000103],
              [115.34151737500014, 2.991136373000089],
              [115.30999475100015, 2.98591705300008],
              [115.28136600800008, 2.999559631000082],
              [115.25583785000003, 3.037490133000091],
              [115.24209192, 3.041624247000101],
              [115.22503869700006, 3.015889384000019],
              [115.20798547400005, 2.98069773400006],
              [115.19640995300011, 2.967623596000095],
              [115.13904911300011, 2.928452860000064],
              [115.12282271400011, 2.912949931000057],
              [115.10959354700003, 2.892020976000069],
              [115.10525272600006, 2.880290425000069],
              [115.10277225800007, 2.869955139000069],
              [115.09905155500013, 2.859671529000067],
              [115.09119673700002, 2.848147685000043],
              [115.0775541590001, 2.836520488000076],
              [115.069079224, 2.832644755000032],
              [115.06690881300011, 2.828200582000122],
              [115.07186975200005, 2.814764710000077],
              [115.09812137900008, 2.78107167600011],
              [115.10463261000007, 2.761486308000087],
              [115.09357385300007, 2.737043356000058],
              [115.08272180200004, 2.729550273000115],
              [115.07217981000014, 2.727431539000051],
              [115.06318811000011, 2.723659159000107],
              [115.05698693900001, 2.711256816000045],
              [115.05791711500007, 2.701489970000097],
              [115.0687691650001, 2.681542868000079],
              [115.07186975200005, 2.671827698000129],
              [115.06742557800015, 2.651208801000038],
              [115.05864058500009, 2.628832906000056],
              [115.05647017500007, 2.608627422000069],
              [115.07145634000005, 2.594623108000064],
              [115.08251509600007, 2.59436472600008],
              [115.10411584500002, 2.604751689000111],
              [115.11496789600005, 2.607903951000068],
              [115.12685347500008, 2.60676707000006],
              [115.13977258300008, 2.60283966100009],
              [115.15196822100012, 2.597051900000025],
              [115.16189009600009, 2.590385641000097],
              [115.1769796150001, 2.574159241000089],
              [115.19237919200009, 2.55105987600011],
              [115.20374800700012, 2.527547099000031],
              [115.20612512200006, 2.509873759000129],
              [115.19268925000006, 2.490546773000077],
              [115.17181197100001, 2.483312073000107],
              [115.12654341700011, 2.479229634000106],
              [115.10504602100008, 2.465690409000032],
              [115.06742557800015, 2.423109029000059],
              [115.05202600100006, 2.414013977000081],
              [115.03476607300007, 2.406417541000025],
              [114.9920813390001, 2.369882304000086],
              [114.9729610600001, 2.35747996000012],
              [114.93451379500004, 2.360683899000094],
              [114.92221480300009, 2.353914287000052],
              [114.91529016200002, 2.332055155000106],
              [114.91673710200013, 2.311229554000064],
              [114.91963098100007, 2.295674947000037],
              [114.9133264570001, 2.28404775000007],
              [114.8864547120001, 2.275159404000064],
              [114.80904341700005, 2.264669088000105],
              [114.77876102700009, 2.24720245400006],
              [114.76346480400008, 2.208083395000131],
              [114.75209598800006, 2.153513082000103],
              [114.75302616400012, 2.134806213000033],
              [114.75674686700006, 2.126047059000129],
              [114.76801233000009, 2.110208232000048],
              [114.7702860920001, 2.100053813000073],
              [114.76925256400006, 2.066644999000104],
              [114.7702860920001, 2.058221741000111],
              [114.78062137900014, 2.036052552000086],
              [114.79219690000008, 2.03481231700006],
              [114.8082165940001, 2.0419695020001],
              [114.8313676350001, 2.044760030000063],
              [114.84108280500004, 2.038222962000077],
              [114.8453202720001, 2.024967957000072],
              [114.84511356700006, 2.009749248000048],
              [114.84252974400016, 1.997166036000124],
              [114.83384810400008, 1.976676331000064],
              [114.829403931, 1.959778138000061],
              [114.829403931, 1.942647400000112],
              [114.83364139800005, 1.921356710000026],
              [114.83198775300008, 1.902520650000014],
              [114.81906864500007, 1.890299174000091],
              [114.76305139200014, 1.868698425000019],
              [114.70899784400007, 1.861980490000093],
              [114.69917932100009, 1.858053080000033],
              [114.68863733000006, 1.850224101],
              [114.679542277, 1.840741476000119],
              [114.67416792900008, 1.831904806000111],
              [114.67137740100014, 1.820975240000053],
              [114.67261763500005, 1.814076436000079],
              [114.67582157400005, 1.806738383000081],
              [114.67892216000007, 1.794361878000117],
              [114.6800590420001, 1.76327850400007],
              [114.6690002850001, 1.694006246000058],
              [114.65029341700011, 1.641451315000069],
              [114.6244552010001, 1.59879242000008],
              [114.6096757410001, 1.581635844000118],
              [114.57453576700004, 1.553420512000059],
              [114.56316695200013, 1.536393128000029],
              [114.56316695200013, 1.512260233000077],
              [114.5677144770001, 1.490917867000078],
              [114.56802453700004, 1.469394633000121],
              [114.56161665800005, 1.450015971000056],
              [114.54559696500007, 1.434952291000073],
              [114.5222392180001, 1.429422913000067],
              [114.50063846900008, 1.436037496000068],
              [114.4213668220001, 1.492183940000118],
              [114.3982157800001, 1.503552754000097],
              [114.37485803300001, 1.506937562000118],
              [114.35573775300008, 1.501950786000066],
              [114.20740588700005, 1.439443127000118],
              [114.20484257100009, 1.438362935000086],
              [114.18324182200001, 1.423454285000048],
              [114.17342329900015, 1.420508728000044],
              [114.16040083900009, 1.424797872000099],
              [114.15027225800014, 1.434280497000088],
              [114.14107385300008, 1.445261739000074],
              [114.13094527200008, 1.454175924000083],
              [114.09425500500004, 1.465673930000108],
              [114.0539473880001, 1.465053813000054],
              [113.90966678900008, 1.442471212000015],
              [113.89116662600014, 1.434952291000073],
              [113.86822229000012, 1.415496114000078],
              [113.8081742760001, 1.339712626000093],
              [113.64952762900009, 1.233259176000061],
              [113.6248262950001, 1.22757476800011],
              [113.59650760900001, 1.241630758000042],
              [113.54617476400011, 1.301575419000116],
              [113.52447066200006, 1.313564351000082],
              [113.50338667900007, 1.314494527000136],
              [113.48230269400005, 1.308706767000061],
              [113.442925253, 1.292377015000028],
              [113.39755334500006, 1.293927307000047],
              [113.32365604700016, 1.351391500000062],
              [113.2760103760001, 1.368883973000024],
              [113.21771936100009, 1.380898742000085],
              [113.17276086500016, 1.38374094600006],
              [113.15860152200003, 1.388159281000057],
              [113.12573531200007, 1.413635763000073],
              [113.0890450440001, 1.431334940000085],
              [113.050597778, 1.434797262000117],
              [113.01142704300003, 1.427975973000073],
              [112.97318648300012, 1.415082703000067],
              [112.95820031800008, 1.415651143000034],
              [112.95530643700016, 1.423557638000077],
              [112.96119755100005, 1.434383850000103],
              [112.99168664500007, 1.456966452000046],
              [113.00729292800008, 1.473270365000076],
              [113.01845503800013, 1.492390645000071],
              [113.02434615100003, 1.514378968000045],
              [113.02341597500009, 1.537013244000093],
              [113.01411421700004, 1.550785014000041],
              [112.99716434800007, 1.560164287000092],
              [112.97318648300012, 1.56985361800011],
              [112.956029908, 1.572334086000097],
              [112.90766076700004, 1.570525411000105],
              [112.88812707600005, 1.574866232000076],
              [112.87138391200006, 1.580653991000062],
              [112.85495080600003, 1.582721049000028],
              [112.83645064300009, 1.576054789000096],
              [112.8266321210001, 1.567192281000089],
              [112.82053430200006, 1.557632141000099],
              [112.81350630800006, 1.549338073000044],
              [112.801517375, 1.543782858000043],
              [112.79479943900009, 1.544377136000094],
              [112.76885787000003, 1.552231954000121],
              [112.47047815000013, 1.567657369000116],
              [112.44588016800009, 1.562076315000098],
              [112.42975712100008, 1.550681662000017],
              [112.41590783700013, 1.536651510000098],
              [112.3985445560001, 1.523344828000077],
              [112.38097456900005, 1.517712097000057],
              [112.31906620300003, 1.511743469000038],
              [112.295191692, 1.503811137000071],
              [112.18005660000006, 1.449034119000089],
              [112.16155643700012, 1.434538880000062],
              [112.15411503100006, 1.409527486000059],
              [112.15907596900001, 1.400794169000079],
              [112.18181359900012, 1.40001902200008],
              [112.1880147710001, 1.391414896000043],
              [112.18739465300013, 1.379658508000134],
              [112.18398400900003, 1.369039001000061],
              [112.15266809100001, 1.3062779750001],
              [112.1000614830001, 1.154917705000074],
              [112.09293013500007, 1.143135478000076],
              [112.07949426300002, 1.137244365000072],
              [112.05406945800013, 1.133627014000098],
              [111.9733508710001, 1.134040426000098],
              [111.91009891800007, 1.114041646000075],
              [111.82307580600013, 1.008466695000081],
              [111.76282108600009, 0.993015442000086],
              [111.73419234300007, 1.00143870000008],
              [111.68210249800006, 1.023452861000067],
              [111.65523075400006, 1.03079091400005],
              [111.6373507080001, 1.032237854000044],
              [111.62267460100009, 1.03027415000011],
              [111.53885542900014, 0.997717997000066],
              [111.51539432800013, 0.964490051000041],
              [111.50319869000003, 0.958443909000096],
              [111.4920365810001, 0.98087148000009],
              [111.48800581900008, 0.997924703000123],
              [111.48242476400009, 1.012859192000079],
              [111.4720894780001, 1.02221262700003],
              [111.4545194910001, 1.022626038000041],
              [111.41503869700006, 1.010223694000061],
              [111.39550500500008, 1.00629628500009],
              [111.37411096200003, 1.007536519000041],
              [111.3517867430001, 1.013892721000062],
              [111.21753137200011, 1.073268942000098],
              [111.1975842700001, 1.075232646000117],
              [110.97341190700007, 1.0177167760001],
              [110.91057336500012, 1.015701396000054],
              [110.88039432900013, 1.010533753000047],
              [110.85269576100006, 0.997201233000027],
              [110.79698856600004, 0.949658915000015],
              [110.78706669100006, 0.934155986000093],
              [110.78623986800005, 0.916275940000048],
              [110.78396610600004, 0.908162740000122],
              [110.77673140500013, 0.903253479000099],
              [110.77125370300007, 0.904390361000111],
              [110.76112512300011, 0.912865296000106],
              [110.75833459500006, 0.914518941000068],
              [110.74572554600013, 0.908007711000096],
              [110.74479537000008, 0.905062154000092],
              [110.72484826700003, 0.897259013000067],
              [110.72071415200003, 0.89736236600001],
              [110.70944869000004, 0.901393127000091],
              [110.70417769400012, 0.901393127000091],
              [110.69301558500007, 0.894675192000065],
              [110.67441206900003, 0.877001851000074],
              [110.66128625500005, 0.872144267000053],
              [110.64774703000012, 0.873901266000118],
              [110.63885868300008, 0.880774231000089],
              [110.63214074800004, 0.888629049000116],
              [110.62480269400004, 0.893124898000053],
              [110.61343387900007, 0.893951721000079],
              [110.60960982300003, 0.890851136000038],
              [110.60599247300007, 0.883306376000078],
              [110.59607059800004, 0.87111073800007],
              [110.5539026290001, 0.851370341000106],
              [110.5063603110001, 0.857313131000112],
              [110.46026493300008, 0.879740703000024],
              [110.42264449100003, 0.90945465100009],
              [110.38068322800012, 0.966608785000105],
              [110.36414676900006, 0.981388245000034],
              [110.35164107300005, 0.98650421100011],
              [110.30079146400004, 0.997717997000066],
              [110.28632206300011, 0.995340881000118],
              [110.27278283800013, 0.991051737000063],
              [110.26348107900009, 0.994307353000039],
              [110.26172408000014, 1.014719544000087],
              [110.25655643700003, 1.039059144000092],
              [110.20674035700006, 1.111716207000129],
              [110.1851396080001, 1.154194234000087],
              [110.17036014900009, 1.17445139600008],
              [110.15217004500005, 1.183856507000129],
              [110.0934656170001, 1.191607971000053],
              [110.07455204300004, 1.198635966000055],
              [110.05181441200006, 1.21548248300013],
              [110.03073042800003, 1.253568014000081],
              [110.0121269120001, 1.270517883000082],
              [109.97626346900006, 1.28772613600006],
              [109.96375777200006, 1.298578186000015],
              [109.95176883900007, 1.319662170000043],
              [109.93254520700009, 1.37852162700004],
              [109.92024621600012, 1.394773865000047],
              [109.90205611200008, 1.403791402000095],
              [109.88272912600013, 1.403843079000112],
              [109.86288537700005, 1.401465963000064],
              [109.84283492000009, 1.403274638000056],
              [109.8254716400001, 1.41756317100004],
              [109.80779829900007, 1.459963684000058],
              [109.8005635990001, 1.466759135000103],
              [109.78154667200005, 1.456294658000061],
              [109.77555220500011, 1.457948303000109],
              [109.77317509000005, 1.4858535770001],
              [109.76635380100004, 1.496473084000087],
              [109.67726363200012, 1.572850850000037],
              [109.6580399990001, 1.597190450000141],
              [109.6469812420001, 1.617628479000103],
              [109.64171024600006, 1.637162171000099],
              [109.64057336400003, 1.683025004000072],
              [109.64718794800012, 1.761883240000088],
              [109.6418135990001, 1.781003520000084],
              [109.62403690700006, 1.787773132000041],
              [109.58011193900012, 1.787979838000084],
              [109.56698612500003, 1.792553203000125],
              [109.55561731000006, 1.802165019000128],
              [109.54662561000004, 1.814334818000049],
              [109.53980432200007, 1.826556295000074],
              [109.53474003200006, 1.838984477000054],
              [109.53432662000006, 1.846451721000079],
              [109.53474003200006, 1.853893127000092],
              [109.52843550600005, 1.88998911600001],
              [109.52936568200005, 1.905156149000035],
              [109.53794397000007, 1.917713522000042],
              [109.57442753100008, 1.948590190000033],
              [109.58507287600008, 1.960915019000069],
              [109.6002657470001, 1.98313588500011],
              [109.62662072800003, 2.029696350000066],
              [109.64527428500003, 2.083238023000092],
              [109.64543704500005, 2.082586981000077],
              [109.64991295700003, 2.065578518000052],
              [109.65219160200007, 2.043443101000094],
              [109.66211998800003, 2.002752997000073],
              [109.66358483200003, 1.98305898600006],
              [109.66000410200007, 1.967027085000041],
              [109.65528405000003, 1.953111070000091],
              [109.65463300900007, 1.936997789000088],
              [109.66358483200003, 1.914740302000041],
              [109.69304446700005, 1.873114325000074],
              [109.71143639400003, 1.854478257000039],
              [109.73178144600007, 1.839585679000038],
              [109.79346764400003, 1.813462632000039],
              [109.82894941500007, 1.790106512000079],
              [109.86963951900003, 1.77289459800005],
              [109.88672936300003, 1.760199286000045],
              [109.89877363400007, 1.743109442000048],
              [109.91553795700003, 1.708400783000059],
              [109.92774498800003, 1.692287502000056],
              [109.94174238400007, 1.689195054000038],
              [109.99122155000003, 1.69017161700009],
              [110.00318444100003, 1.692287502000056],
              [110.01840254000007, 1.700181382000039],
              [110.04004967500003, 1.702785549000055],
              [110.16765384200005, 1.701849677000041],
              [110.18091881600003, 1.698716539000088],
              [110.20045006600003, 1.685207424000055],
              [110.21168053500003, 1.682033596000053],
              [110.21631920700003, 1.684759833000044],
              [110.23170006600003, 1.697699286000045],
              [110.23902428500003, 1.701849677000041],
              [110.24838300900007, 1.705226955000057],
              [110.25416100400003, 1.706203518000052],
              [110.26002037900003, 1.702622789000088],
              [110.28394616000003, 1.67609284100007],
              [110.29078209700003, 1.673976955000057],
              [110.29566491000003, 1.691555080000057],
              [110.30534915500004, 1.703314520000049],
              [110.30787194100003, 1.70929596600007],
              [110.30713951900003, 1.715521552000041],
              [110.30225670700003, 1.725653387000079],
              [110.30103600400003, 1.729722398000092],
              [110.29957116000003, 1.761419989000046],
              [110.30103600400003, 1.770738023000092],
              [110.31332441500007, 1.792629299000055],
              [110.32935631600003, 1.802557684000078],
              [110.34302819100003, 1.79751211100006],
              [110.35075931100005, 1.768500067000048],
              [110.35987389400003, 1.756293036000045],
              [110.36304772200003, 1.750230210000041],
              [110.36378014400003, 1.74359772300005],
              [110.36215254000007, 1.729437567000048],
              [110.36304772200003, 1.72296784100007],
              [110.36646569100003, 1.715887762000079],
              [110.37094160200007, 1.710191148000092],
              [110.37631269600007, 1.70571523600006],
              [110.38298587300005, 1.701849677000041],
              [110.39014733200003, 1.699042059000078],
              [110.39893639400003, 1.697088934000078],
              [110.42115319100003, 1.695705471000053],
              [110.43132571700005, 1.699896552000041],
              [110.44361412900003, 1.718695380000042],
              [110.47364342500003, 1.728949286000045],
              [110.49187259200005, 1.738959052000041],
              [110.50798587300005, 1.740912177000041],
              [110.52076256600003, 1.72296784100007],
              [110.50847415500004, 1.707586981000077],
              [110.49968509200005, 1.693589585000041],
              [110.49463951900003, 1.678127346000053],
              [110.49284915500004, 1.658107815000051],
              [110.48910566500007, 1.650295315000051],
              [110.47136478000004, 1.631984768000052],
              [110.46558678500003, 1.62055084800005],
              [110.49244225400003, 1.631659247000073],
              [110.50635826900003, 1.633002020000049],
              [110.52076256600003, 1.627346096000053],
              [110.53028405000003, 1.616156317000048],
              [110.53296959700003, 1.605373440000051],
              [110.53630618600005, 1.596869208000044],
              [110.54753665500004, 1.592596747000073],
              [110.55665123800003, 1.594671942000048],
              [110.57740319100003, 1.605210679000038],
              [110.58904056100005, 1.606268622000073],
              [110.60254967500003, 1.601507880000042],
              [110.64356530000003, 1.579006252000056],
              [110.70118248800003, 1.561712958000044],
              [110.72673587300005, 1.547430731000077],
              [110.73926842500003, 1.523667710000041],
              [110.73340905000003, 1.49868398600006],
              [110.71558678500003, 1.480617580000057],
              [110.67790774800005, 1.456040757000039],
              [110.67790774800005, 1.448635158000059],
              [110.70435631600003, 1.449367580000057],
              [110.72510826900003, 1.453111070000091],
              [110.74350019600007, 1.462388414000088],
              [110.76343834700003, 1.479681708000044],
              [110.77344811300003, 1.498602606000077],
              [110.77222741000003, 1.518011786000045],
              [110.76726321700005, 1.536200262000079],
              [110.76661217500003, 1.551662502000056],
              [110.79330488400007, 1.572414455000057],
              [110.83961022200003, 1.565985419000071],
              [110.92481530000003, 1.531195380000042],
              [110.96794681100005, 1.503241278000075],
              [111.04395592500003, 1.426947333000044],
              [111.08236738400007, 1.401434637000079],
              [111.14193769600007, 1.371527411000045],
              [111.15455162900003, 1.367336330000057],
              [111.17855879000007, 1.370794989000046],
              [111.21176191500007, 1.388088283000059],
              [111.23267662900003, 1.394598700000074],
              [111.26514733200003, 1.381781317000048],
              [111.30128014400003, 1.351996161000045],
              [111.34058678500003, 1.333319403000075],
              [111.38355553500003, 1.353664455000057],
              [111.36695397200003, 1.354396877000056],
              [111.33912194100003, 1.36469147300005],
              [111.32553144600007, 1.367336330000057],
              [111.32105553500003, 1.373602606000077],
              [111.31177819100003, 1.401353257000039],
              [111.30469811300003, 1.407619533000059],
              [111.28882897200003, 1.410060940000051],
              [111.26099694100003, 1.419907945000091],
              [111.24634850400003, 1.42133209800005],
              [111.23462975400003, 1.417954820000091],
              [111.19849694100003, 1.401434637000079],
              [111.17676842500003, 1.400580145000049],
              [111.15796959700003, 1.406154690000051],
              [111.14161217500003, 1.416937567000048],
              [111.12720787900003, 1.431830145000049],
              [111.10922285200007, 1.445013739000046],
              [111.06495201900003, 1.462713934000078],
              [111.04835045700003, 1.476548570000091],
              [111.03028405000003, 1.524318752000056],
              [111.01107832100007, 1.542954820000091],
              [111.00684655000003, 1.555080471000053],
              [111.00562584700003, 1.584458726000094],
              [111.00684655000003, 1.592596747000073],
              [111.02035566500007, 1.627346096000053],
              [111.02857506600003, 1.664007880000042],
              [111.03785241000003, 1.676947333000044],
              [111.09546959700003, 1.687974351000094],
              [111.11752363400007, 1.688869533000059],
              [111.13705488400007, 1.682033596000053],
              [111.15023847700007, 1.664129950000074],
              [111.16334069100003, 1.640855210000041],
              [111.17945397200003, 1.627020575000074],
              [111.20232181100005, 1.637274481000077],
              [111.21509850400003, 1.639837958000044],
              [111.22901451900003, 1.630031643000052],
              [111.24577884200005, 1.621323960000041],
              [111.26742597700007, 1.627346096000053],
              [111.24732506600003, 1.633368231000077],
              [111.23780358200003, 1.637762762000079],
              [111.21998131600003, 1.651434637000079],
              [111.21119225400003, 1.652492580000057],
              [111.20240319100003, 1.651922919000071],
              [111.18262780000003, 1.657294012000079],
              [111.17611738400007, 1.656805731000077],
              [111.17286217500003, 1.659369208000044],
              [111.17188561300003, 1.671454169000071],
              [111.16041100400003, 1.68781159100007],
              [111.15821373800003, 1.692287502000056],
              [111.15455162900003, 1.695990302000041],
              [111.13648522200003, 1.699611721000053],
              [111.13021894600007, 1.701849677000041],
              [111.12614993600005, 1.706610419000071],
              [111.10303795700003, 1.746079820000091],
              [111.09799238400007, 1.759588934000078],
              [111.09603925900007, 1.774481512000079],
              [111.10084069100003, 1.780259507000039],
              [111.12322024800005, 1.78579336100006],
              [111.13021894600007, 1.791896877000056],
              [111.12859134200005, 1.79759349200009],
              [111.11353600400003, 1.807196356000077],
              [111.10987389400003, 1.815415757000039],
              [111.11312910200007, 1.835516669000071],
              [111.12159264400003, 1.853908596000053],
              [111.14389082100007, 1.888088283000059],
              [111.17530358200003, 1.953192450000074],
              [111.20394941500007, 2.04564036700009],
              [111.20590254000007, 2.06899648600006],
              [111.21127363400007, 2.073919989000046],
              [111.22339928500003, 2.072088934000078],
              [111.24333743600005, 2.065578518000052],
              [111.26783287900003, 2.067531643000052],
              [111.24187259200005, 2.089422919000071],
              [111.24008222700007, 2.113348700000074],
              [111.25391686300003, 2.126125393000052],
              [111.27173912900003, 2.124701239000046],
              [111.29151451900003, 2.117621161000045],
              [111.32797285200007, 2.110419012000079],
              [111.33643639400003, 2.112127997000073],
              [111.34994550900007, 2.120794989000046],
              [111.35645592500003, 2.128078518000052],
              [111.37501061300003, 2.153998114000046],
              [111.37794030000003, 2.161810614000046],
              [111.36866295700003, 2.169989325000074],
              [111.35678144600007, 2.166205145000049],
              [111.34685306100005, 2.155747789000088],
              [111.33863366000003, 2.130804755000042],
              [111.32911217500003, 2.128729559000078],
              [111.31861412900003, 2.132798570000091],
              [111.29127037900003, 2.150376695000091],
              [111.27051842500003, 2.153794664000088],
              [111.19890384200005, 2.143255927000041],
              [111.18474368600005, 2.145086981000077],
              [111.17945397200003, 2.155910549000055],
              [111.17872155000003, 2.178859768000052],
              [111.18482506600003, 2.19476959800005],
              [111.20004316500007, 2.210882880000042],
              [111.21998131600003, 2.220404364000046],
              [111.24008222700007, 2.216376044000071],
              [111.22950280000003, 2.235256252000056],
              [111.21070397200003, 2.242173570000091],
              [111.19288170700003, 2.245591539000088],
              [111.18482506600003, 2.253648179000038],
              [111.18653405000003, 2.271714585000041],
              [111.19849694100003, 2.318793036000045],
              [111.20850670700003, 2.388861395000049],
              [111.22095787900003, 2.416083075000074],
              [111.24634850400003, 2.436102606000077],
              [111.25473066500007, 2.419256903000075],
              [111.26783287900003, 2.411200262000079],
              [111.30152428500003, 2.40070221600007],
              [111.31299889400003, 2.390814520000049],
              [111.33806399800005, 2.36009349200009],
              [111.34636478000004, 2.353583075000074],
              [111.35206139400003, 2.350572007000039],
              [111.35840905000003, 2.344794012000079],
              [111.36548912900003, 2.340765692000048],
              [111.37387129000007, 2.343003648000092],
              [111.40528405000003, 2.364325262000079],
              [111.41456139400003, 2.367254950000074],
              [111.44825280000003, 2.372381903000075],
              [111.45557701900003, 2.370672919000071],
              [111.47364342500003, 2.357326565000051],
              [111.49341881600003, 2.346136786000045],
              [111.48511803500003, 2.364162502000056],
              [111.46509850400003, 2.384833075000074],
              [111.43246504000007, 2.414984442000048],
              [111.42416425900007, 2.427232164000088],
              [111.41228274800005, 2.469224351000094],
              [111.40455162900003, 2.483954169000071],
              [111.43555748800003, 2.482123114000046],
              [111.46338951900003, 2.47492096600007],
              [111.48731530000003, 2.473944403000075],
              [111.50709069100003, 2.490708726000094],
              [111.51254316500007, 2.488267320000091],
              [111.51400800900007, 2.48696523600006],
              [111.51563561300003, 2.487494208000044],
              [111.52125084700003, 2.490708726000094],
              [111.49952233200003, 2.498846747000073],
              [111.46168053500003, 2.508002020000049],
              [111.44556725400003, 2.518011786000045],
              [111.43295332100007, 2.52875397300005],
              [111.42286217500003, 2.539618231000077],
              [111.41724694100003, 2.555121161000045],
              [111.41765384200005, 2.57953522300005],
              [111.43531334700003, 2.64093659100007],
              [111.44027754000007, 2.680121161000045],
              [111.44703209700003, 2.694647528000075],
              [111.45785566500007, 2.705633856000077],
              [111.52979576900003, 2.760687567000048],
              [111.63892662900003, 2.828192450000074],
              [111.66960696700005, 2.843085028000075],
              [111.86060631600003, 2.880601304000038],
              [112.01351972700002, 2.885931708000044],
              [112.29786217500009, 2.961004950000074],
              [112.57471764400009, 3.03392161700009],
              [112.72730553500003, 3.066107489000046],
              [112.78882897200003, 3.090277411000045],
              [112.80054772200003, 3.090033270000049],
              [112.97437584700003, 3.144232489000046],
              [113.00782311300009, 3.161688544000071],
              [113.06120853000004, 3.218654690000051],
              [113.08228600400003, 3.256781317000048],
              [113.06934655000009, 3.278998114000046],
              [113.07691491000003, 3.287787177000041],
              [113.10336347700002, 3.305650132000039],
              [113.15137780000009, 3.347723700000074],
              [113.16211998800009, 3.353461005000042],
              [113.16618899800005, 3.362941799000055],
              [113.199554884, 3.415513414000088],
              [113.27759850400003, 3.484198309000078],
              [113.29590905000009, 3.511786200000074],
              [113.29908287900003, 3.519598700000074],
              [113.301117384, 3.527736721000053],
              [113.30274498800009, 3.549261786000045],
              [113.30811608200008, 3.55931224200009],
              [113.33155358200008, 3.577541408000059],
              [113.33676191500001, 3.583807684000078],
              [113.34359785200002, 3.59446849200009],
              [113.39144941500001, 3.648342190000051],
              [113.41488691500001, 3.688706773000092],
              [113.42302493600005, 3.71124909100007],
              [113.426117384, 3.734605210000041],
              [113.43425540500004, 3.753159898000092],
              [113.45313561300009, 3.768744208000044],
              [113.494476759, 3.792303778000075],
              [113.73682701900009, 4.001288153000075],
              [113.94678795700008, 4.273830471000053],
              [113.96778405000009, 4.322170315000051],
              [113.96062259200005, 4.361517645000049],
              [113.98194420700008, 4.394720770000049],
              [113.99219811300009, 4.437079169000071],
              [113.99187259200005, 4.484442450000074],
              [113.96941165500004, 4.578517971000053],
              [113.97584069100003, 4.594712632000039],
              [113.99878991000003, 4.601141669000071],
              [114.06417932200009, 4.570032247000086],
              [114.11895634000007, 4.561634827000105],
              [114.1400403240001, 4.55065358500012],
              [114.17269983000006, 4.525228780000106],
              [114.19729781100006, 4.51582367000006],
              [114.20908003800002, 4.508149719000073],
              [114.216728149, 4.487660014000099],
              [114.22292932200003, 4.484636943000083],
              [114.23832889800008, 4.484223532000073],
              [114.24556359900015, 4.481433004000024],
              [114.24783736200004, 4.474766744000107],
              [114.24876753800004, 4.466886088000066],
              [114.25207483000014, 4.460349020000081],
              [114.26261682100011, 4.448721823000128],
              [114.268507935, 4.437740581000043],
              [114.27625940000007, 4.409731954000037],
              [114.27625940000007, 4.381852519000063],
              [114.2899019780001, 4.361311137000072],
              [114.29672326700006, 4.316662700000052],
              [114.29341597500007, 4.307050883000045],
              [114.27946333800008, 4.294881084000039],
              [114.27625940000007, 4.289015808000045],
              [114.27801639800015, 4.274055481000076],
              [114.28266727700014, 4.264908753000086],
              [114.31677372200011, 4.262505799000039],
              [114.36049198500007, 4.253875834000084],
              [114.4014197190001, 4.261213887000082],
              [114.41991988200004, 4.26012868300009],
              [114.43252893100015, 4.246925354000098],
              [114.4533028570001, 4.18369923900012],
              [114.46312137900014, 4.164139709000011],
              [114.47738407500003, 4.144967753000088],
              [114.54022261600011, 4.08693512000012],
              [114.56140995300007, 4.072026469000079],
              [114.5693681240001, 4.064404195000108],
              [114.57422570800014, 4.05414642300012],
              [114.58166711500007, 4.029341736000077],
              [114.58662805200004, 4.021435242000038],
              [114.6277624920001, 4.016681010000042],
              [114.674891398, 4.044069519000075],
              [114.76687544800006, 4.131816101000112],
              [114.77452356000009, 4.146466370000013],
              [114.78010461500008, 4.187755839000118],
              [114.78713260900008, 4.207212016000099],
              [114.809973592, 4.241292623000064],
              [114.81720829300008, 4.259663595000063],
              [114.81379764900015, 4.277104391000094],
              [114.78258508400006, 4.264417826000056],
              [114.78196496600009, 4.284933370000118],
              [114.78785607900011, 4.294157613000039],
              [114.79416325000005, 4.300239528000105],
              [114.81824182100007, 4.323458151000096],
              [114.82899051900006, 4.340485535000113],
              [114.83643192500011, 4.357228699000075],
              [114.84563033100011, 4.395107524000068],
              [114.847904094, 4.423736268000127],
              [114.840462688, 4.428619691000065],
              [114.82568322700007, 4.426190898000101],
              [114.80604618300003, 4.433322246000046],
              [114.78816613800007, 4.46120168000003],
              [114.78217167200006, 4.49778859500006],
              [114.77731408700004, 4.614654847000111],
              [114.773903442, 4.636824036000036],
              [114.76811568300002, 4.657494609000054],
              [114.748788697, 4.694391581000076],
              [114.74134729000008, 4.71294342000003],
              [114.74196740800005, 4.729454040000107],
              [114.743192034, 4.730585208000079],
              [114.7517859300001, 4.738523255000075],
              [114.78847619700008, 4.753896993000055],
              [114.80542606700016, 4.764568177000044],
              [114.83767216000001, 4.795315654000092],
              [114.85575891100007, 4.806658630000086],
              [114.87818648300004, 4.81280812600005],
              [114.89647994000012, 4.811826274000083],
              [114.91487675000008, 4.808725688000052],
              [114.93244673700008, 4.809139099000063],
              [114.94836307800011, 4.818931783000025],
              [114.95487430900005, 4.834202169000065],
              [114.95570113100007, 4.850919495000099],
              [114.95890507000007, 4.866293234000082],
              [114.98170006600003, 4.889064846000053],
              [114.99244225400003, 4.894232489000046],
              [115.00196373800009, 4.900051174000055],
              [115.00993899800005, 4.907171942000048],
              [115.01579837300005, 4.916408596000053],
              [115.02263431100005, 4.895900783000059],
              [115.02361087300005, 4.857082424000055],
              [115.02955162900003, 4.820868231000077],
              [115.02977835200011, 4.820641508000094],
              [115.022777141, 4.741365458000047],
              [115.02680790200009, 4.660026754000043],
              [115.0354895430001, 4.621243592000013],
              [115.06814904800007, 4.543367208000049],
              [115.07982792200005, 4.503963928000132],
              [115.09181685400006, 4.405416972000069],
              [115.09977502500016, 4.391231791000109],
              [115.11300419200006, 4.382369284000092],
              [115.16995162, 4.36125946000007],
              [115.19082889800006, 4.356763611000048],
              [115.22069787600009, 4.359760844000064],
              [115.22906945800008, 4.356763611000048],
              [115.24467574100004, 4.343663635000084],
              [115.25511438100006, 4.339245300000087],
              [115.27433801300009, 4.340020447000086],
              [115.28312300700014, 4.3367648320001],
              [115.30120975800008, 4.324698385000119],
              [115.32436080000008, 4.314595642000086],
              [115.34627160700012, 4.313768820000064],
              [115.36074100800016, 4.329555970000058],
              [115.35826053900007, 4.350278219000074],
              [115.34379113800003, 4.371672261000086],
              [115.30865116400003, 4.404693502000072],
              [115.28560347500002, 4.435363465000094],
              [115.27247766200009, 4.474663391000078],
              [115.26689660600005, 4.516857198000139],
              [115.26741337100009, 4.556208802000128],
              [115.27547489400001, 4.595741272000069],
              [115.2770251880001, 4.613052877000072],
              [115.27268436700001, 4.636772359000119],
              [115.20736535700007, 4.825598043000127],
              [115.18225061100014, 4.8612289430001],
              [115.16933150200015, 4.869988098000093],
              [115.15599898300002, 4.876292623000012],
              [115.14680057800001, 4.885620219000131],
              [115.14616946700005, 4.908514716000127],
            ],
          ],
          [
            [
              [118.21949303500003, 5.855536200000074],
              [118.23308353000004, 5.851141669000071],
              [118.23609459700003, 5.841498114000046],
              [118.230804884, 5.831935940000051],
              [118.21949303500003, 5.82758209800005],
              [118.21314537900003, 5.826605536000045],
              [118.19548587300005, 5.820257880000042],
              [118.18921959700003, 5.819728908000059],
              [118.18189537900003, 5.820257880000042],
              [118.17253665500004, 5.822821356000077],
              [118.16553795700008, 5.827541408000059],
              [118.16382897200003, 5.834418036000045],
              [118.16993248800009, 5.843695380000042],
              [118.18100019600001, 5.851263739000046],
              [118.19312584700003, 5.854681708000044],
              [118.21949303500003, 5.855536200000074],
            ],
          ],
          [
            [
              [111.41138756600003, 2.391099351000094],
              [111.41244550900007, 2.38735586100006],
              [111.41334069100003, 2.378241278000075],
              [111.41049238400007, 2.372219143000052],
              [111.40088951900003, 2.377834377000056],
              [111.39096113400007, 2.382147528000075],
              [111.38184655000003, 2.377875067000048],
              [111.37435957100007, 2.369086005000042],
              [111.36988366000003, 2.359808661000045],
              [111.35914147200003, 2.373114325000074],
              [111.34262129000007, 2.413885809000078],
              [111.33204186300003, 2.422430731000077],
              [111.31267337300005, 2.431341864000046],
              [111.30811608200003, 2.452134507000039],
              [111.31568444100003, 2.496242580000057],
              [111.31763756600003, 2.536769924000055],
              [111.29900149800005, 2.702704169000071],
              [111.30095462300005, 2.752630927000041],
              [111.31544030000003, 2.784491278000075],
              [111.34994550900007, 2.771307684000078],
              [111.37029056100005, 2.739732164000088],
              [111.38103274800005, 2.69790273600006],
              [111.38184655000003, 2.523342190000051],
              [111.39039147200003, 2.449164130000042],
              [111.41138756600003, 2.391099351000094],
            ],
          ],
          [
            [
              [104.22266686300003, 2.785589911000045],
              [104.22510826900003, 2.735907294000071],
              [104.22266686300003, 2.724107164000088],
              [104.21078535200007, 2.715073960000041],
              [104.19206790500004, 2.709051825000074],
              [104.17212975400008, 2.70774974200009],
              [104.15748131600003, 2.713283596000053],
              [104.13843834700003, 2.733628648000092],
              [104.13062584700003, 2.745794989000046],
              [104.13013756600003, 2.75454336100006],
              [104.13070722700007, 2.76007721600007],
              [104.12582441500007, 2.777044989000046],
              [104.12696373800003, 2.785589911000045],
              [104.13160241000003, 2.791083075000074],
              [104.14421634200005, 2.79759349200009],
              [104.15064537900008, 2.802394924000055],
              [104.16032962300005, 2.817857164000088],
              [104.16032962300005, 2.83266836100006],
              [104.15626061300003, 2.847723700000074],
              [104.15381920700003, 2.864081122000073],
              [104.15601647200003, 2.874579169000071],
              [104.16187584700003, 2.884833075000074],
              [104.17066491000003, 2.891099351000094],
              [104.18140709700003, 2.889797268000052],
              [104.18620853000004, 2.885321356000077],
              [104.18775475400008, 2.879706122000073],
              [104.18897545700003, 2.867580471000053],
              [104.19166100400008, 2.860296942000048],
              [104.20435631600003, 2.840887762000079],
              [104.21062259200005, 2.827866929000038],
              [104.22266686300003, 2.785589911000045],
            ],
          ],
          [
            [
              [118.72624759200005, 4.491888739000046],
              [118.74878991000003, 4.485500393000052],
              [118.76002037900003, 4.471380927000041],
              [118.75611412900003, 4.457220770000049],
              [118.73308353000004, 4.450873114000046],
              [118.69581139400009, 4.450873114000046],
              [118.68165123800009, 4.437079169000071],
              [118.67481530000009, 4.436590887000079],
              [118.66920006600003, 4.439846096000053],
              [118.66920006600003, 4.443060614000046],
              [118.66797936300009, 4.463934637000079],
              [118.66325931100005, 4.469224351000094],
              [118.65121504000001, 4.479071356000077],
              [118.64747155000009, 4.484442450000074],
              [118.64405358200008, 4.495306708000044],
              [118.64763431100005, 4.498032945000091],
              [118.65805097700002, 4.498195705000057],
              [118.66065514400009, 4.498195705000057],
              [118.67514082100001, 4.49835846600007],
              [118.72624759200005, 4.491888739000046],
            ],
          ],
          [
            [
              [118.51026451900009, 4.648871161000045],
              [118.523773634, 4.665716864000046],
              [118.54948978000004, 4.665187893000052],
              [118.57781009200005, 4.655096747000073],
              [118.59961998800009, 4.642645575000074],
              [118.59961998800009, 4.635199286000045],
              [118.58480879000001, 4.634019273000092],
              [118.57536868600005, 4.627386786000045],
              [118.57105553500003, 4.616034247000073],
              [118.57227623800009, 4.601141669000071],
              [118.55298912900003, 4.618801174000055],
              [118.54810631600003, 4.621568101000094],
              [118.54297936300009, 4.616929429000038],
              [118.53956139400009, 4.607855536000045],
              [118.53516686300009, 4.601304429000038],
              [118.52735436300009, 4.604559637000079],
              [118.51197350400003, 4.616359768000052],
              [118.49561608200008, 4.623928127000056],
              [118.47999108200008, 4.627875067000048],
              [118.46656334700003, 4.629055080000057],
              [118.46265709700003, 4.630804755000042],
              [118.45362389400009, 4.639471747000073],
              [118.44890384200005, 4.642645575000074],
              [118.41472415500004, 4.648871161000045],
              [118.34644616000003, 4.669907945000091],
              [118.34644616000003, 4.676214911000045],
              [118.42530358200008, 4.676214911000045],
              [118.43628991000003, 4.679266669000071],
              [118.44320722700002, 4.686102606000077],
              [118.44898522200003, 4.693182684000078],
              [118.45630944100003, 4.697251695000091],
              [118.47608483200008, 4.693793036000045],
              [118.48511803500003, 4.679429429000038],
              [118.49317467500009, 4.661851304000038],
              [118.51026451900009, 4.648871161000045],
            ],
          ],
          [
            [
              [115.24854576900009, 5.365464585000041],
              [115.25977623800009, 5.315375067000048],
              [115.25928795700008, 5.291205145000049],
              [115.24170983200008, 5.272691148000092],
              [115.23194420700008, 5.273138739000046],
              [115.21225019600001, 5.284979559000078],
              [115.20411217500009, 5.283596096000053],
              [115.18425540500004, 5.26703522300005],
              [115.15919030000009, 5.252183335000041],
              [115.16089928500003, 5.266994533000059],
              [115.18913821700005, 5.344794012000079],
              [115.19727623800009, 5.354641018000052],
              [115.22608483200008, 5.381048895000049],
              [115.24170983200008, 5.387396552000041],
              [115.24854576900009, 5.365464585000041],
            ],
          ],
          [
            [
              [100.30982506600003, 5.450751044000071],
              [100.31853274800005, 5.435288804000038],
              [100.33399498800003, 5.426947333000044],
              [100.34343509200005, 5.417629299000055],
              [100.32520592500003, 5.383286851000094],
              [100.32081139400003, 5.344549872000073],
              [100.31666100400008, 5.326646226000094],
              [100.29224694100003, 5.280462958000044],
              [100.28874759200005, 5.262681382000039],
              [100.23471113400007, 5.272691148000092],
              [100.19499759200005, 5.272284247000073],
              [100.19361412900008, 5.270086981000077],
              [100.19271894600007, 5.267645575000074],
              [100.18970787900008, 5.266506252000056],
              [100.18433678500003, 5.268540757000039],
              [100.18002363400007, 5.273342190000051],
              [100.17896569100003, 5.27798086100006],
              [100.19271894600007, 5.285956122000073],
              [100.19613691500007, 5.299994208000044],
              [100.19117272200003, 5.352525132000039],
              [100.19312584700003, 5.399318752000056],
              [100.19092858200003, 5.408433335000041],
              [100.18628991000003, 5.416205145000049],
              [100.18165123800003, 5.422349351000094],
              [100.17945397200003, 5.426906643000052],
              [100.18165123800003, 5.436590887000079],
              [100.18523196700005, 5.444281317000048],
              [100.18588300900007, 5.451117255000042],
              [100.17945397200003, 5.458197333000044],
              [100.19206790500004, 5.462958075000074],
              [100.19711347700007, 5.457261460000041],
              [100.20118248800003, 5.448472398000092],
              [100.21062259200005, 5.44399648600006],
              [100.21859785200007, 5.44672272300005],
              [100.22445722700007, 5.452948309000078],
              [100.22934004000007, 5.459906317000048],
              [100.23471113400007, 5.464504299000055],
              [100.25375410200007, 5.46906159100007],
              [100.27409915500004, 5.468491929000038],
              [100.29330488400007, 5.462591864000046],
              [100.30982506600003, 5.450751044000071],
            ],
          ],
          [
            [
              [99.78629161100008, 6.24182214800004],
              [99.80044244900006, 6.27281133200006],
              [99.82392178600003, 6.282135856000082],
              [99.83697849400005, 6.294227056000068],
              [99.83978225000004, 6.277297115000067],
              [99.83231797400003, 6.268914560000042],
              [99.82485877300007, 6.257720434000078],
              [99.82496178500003, 6.245591539000088],
              [99.82325280000003, 6.239081122000073],
              [99.82381200400005, 6.222867477000079],
              [99.83023316600003, 6.205753451000078],
              [99.82642783100005, 6.190674611000077],
              [99.81695288700007, 6.176527626000052],
              [99.80559648300004, 6.171792982000056],
              [99.78952269900003, 6.185875956000075],
              [99.78405904600004, 6.201118998000084],
              [99.77471042300004, 6.204017199000077],
              [99.76723441600006, 6.223804251000047],
              [99.78629161100008, 6.24182214800004],
            ],
          ],
          [
            [
              [99.90061659800006, 6.364303784000072],
              [99.91086526100003, 6.348726301000056],
              [99.91447663800005, 6.339711457000078],
              [99.91627037900008, 6.331529039000088],
              [99.90610298600006, 6.326067391000038],
              [99.89169428400004, 6.321944661000089],
              [99.88316172000003, 6.312731168000084],
              [99.87050805600006, 6.304923615000064],
              [99.86569178000008, 6.290526604000092],
              [99.84941794500003, 6.300711598000078],
              [99.84458594200004, 6.324685901000066],
              [99.82533255000004, 6.324098670000069],
              [99.80730692400005, 6.317532434000043],
              [99.79177021900006, 6.298457169000073],
              [99.77803186100004, 6.282972726000082],
              [99.76166422200004, 6.282842796000068],
              [99.74894929300007, 6.270182652000074],
              [99.73667266600006, 6.264571008000075],
              [99.72873460300008, 6.261475800000085],
              [99.71545779600007, 6.310057516000086],
              [99.72213222700003, 6.327483499000039],
              [99.71904369200007, 6.353230673000041],
              [99.70280726000004, 6.358625424000081],
              [99.67683825200004, 6.363973760000079],
              [99.65870201900003, 6.362616278000075],
              [99.65007571700005, 6.376695054000038],
              [99.64600670700003, 6.394191799000055],
              [99.64522806000008, 6.435840878000079],
              [99.66944363000005, 6.426886127000046],
              [99.68875121300005, 6.43530531600004],
              [99.72137140400008, 6.434151632000066],
              [99.73647816000005, 6.423983516000078],
              [99.77092667200003, 6.419841624000071],
              [99.78599624100008, 6.422854432000065],
              [99.80224884300003, 6.436050476000048],
              [99.81429161100004, 6.454036660000043],
              [99.82395070300004, 6.45464585700006],
              [99.83920332100007, 6.454820054000038],
              [99.83448326900003, 6.463283596000053],
              [99.83277428500003, 6.470851955000057],
              [99.84202909600003, 6.469639039000072],
              [99.85108483200003, 6.465643622000073],
              [99.85889733200003, 6.443793036000045],
              [99.86646569100003, 6.429673570000091],
              [99.87826582100007, 6.419745184000078],
              [99.89893639400003, 6.410345770000049],
              [99.89759415000003, 6.402046953000081],
              [99.90479576900003, 6.397772528000075],
              [99.91334069100003, 6.390204169000071],
              [99.90903044100003, 6.37806779400006],
              [99.90061659800006, 6.364303784000072],
            ],
          ],
          [
            [
              [117.46876061300009, 6.766669012000079],
              [117.49390709700003, 6.735419012000079],
              [117.51075280000009, 6.704291083000044],
              [117.50660241000003, 6.673488674000055],
              [117.46876061300009, 6.643133856000077],
              [117.44304446700005, 6.635728257000039],
              [117.41236412900003, 6.634914455000057],
              [117.38168379000001, 6.639349677000041],
              [117.35621178500003, 6.64789459800005],
              [117.34693444100003, 6.654974677000041],
              [117.34343509200005, 6.66351959800005],
              [117.34595787900003, 6.672308661000045],
              [117.35499108200008, 6.679632880000042],
              [117.365570509, 6.68305084800005],
              [117.41627037900003, 6.685288804000038],
              [117.43213951900009, 6.689357815000051],
              [117.44385826900009, 6.698553778000075],
              [117.44825280000009, 6.71515534100007],
              [117.43930097700002, 6.723944403000075],
              [117.40357506600003, 6.725816148000092],
              [117.39991295700008, 6.739325262000079],
              [117.41163170700008, 6.751369533000059],
              [117.45248457100001, 6.756740627000056],
              [117.46876061300009, 6.766669012000079],
            ],
          ],
          [
            [
              [117.00261478000004, 7.355698960000041],
              [117.01685631600003, 7.342596747000073],
              [117.02271569100003, 7.318833726000094],
              [117.02035566500001, 7.294582424000055],
              [117.01002037900003, 7.279974677000041],
              [116.99154707100001, 7.29718659100007],
              [116.97673587300005, 7.290228583000044],
              [116.97144616000003, 7.271389065000051],
              [116.98218834700003, 7.253322658000059],
              [116.88648522200003, 7.229396877000056],
              [116.89112389400009, 7.219916083000044],
              [116.89975019600001, 7.214585679000038],
              [116.90512129000001, 7.208929755000042],
              [116.90015709700003, 7.198065497000073],
              [116.890961134, 7.19367096600007],
              [116.87680097700002, 7.192531643000052],
              [116.86231530000009, 7.194159247000073],
              [116.85181725400003, 7.198065497000073],
              [116.90015709700003, 7.28742096600007],
              [116.914398634, 7.293931382000039],
              [116.94800866000003, 7.301906643000052],
              [116.96168053500003, 7.307928778000075],
              [117.00261478000004, 7.355698960000041],
            ],
          ],
          [
            [
              [117.17115319100003, 7.342678127000056],
              [117.24626712300005, 7.35578034100007],
              [117.27003014400009, 7.348863023000092],
              [117.28191165500004, 7.33234284100007],
              [117.28321373800009, 7.308783270000049],
              [117.27344811300009, 7.231919664000088],
              [117.26238040500004, 7.201971747000073],
              [117.24708092500009, 7.183172919000071],
              [117.22974694100003, 7.191839911000045],
              [117.21094811300009, 7.184393622000073],
              [117.15284264400009, 7.173081773000092],
              [117.14039147200003, 7.167629299000055],
              [117.13477623800009, 7.161932684000078],
              [117.10808353000004, 7.149562893000052],
              [117.09888756600003, 7.143459377000056],
              [117.09205162900003, 7.131984768000052],
              [117.08790123800009, 7.120754299000055],
              [117.082367384, 7.110663153000075],
              [117.07154381600003, 7.102484442000048],
              [117.06413821700005, 7.126654364000046],
              [117.05640709700003, 7.202866929000038],
              [117.06128991000003, 7.219142971000053],
              [117.06519616000003, 7.226385809000078],
              [117.06413821700005, 7.270738023000092],
              [117.06771894600001, 7.28001536700009],
              [117.07325280000009, 7.284979559000078],
              [117.08904056100005, 7.290350653000075],
              [117.09888756600003, 7.295843817000048],
              [117.12289472700002, 7.320013739000046],
              [117.14527428500003, 7.335516669000071],
              [117.15772545700008, 7.340725002000056],
              [117.17115319100003, 7.342678127000056],
            ],
          ],
          [
            [
              [101.27116946700005, 3.046454169000071],
              [101.26734459700003, 3.035305080000057],
              [101.25961347700007, 3.030218817000048],
              [101.24382571700005, 3.026190497000073],
              [101.23698978000004, 3.035060940000051],
              [101.24439537900008, 3.049017645000049],
              [101.26286868600005, 3.056341864000046],
              [101.27116946700005, 3.046454169000071],
            ],
          ],
          [
            [
              [101.33765709700003, 3.051825262000079],
              [101.33643639400003, 3.044745184000078],
              [101.33790123800003, 3.031927802000041],
              [101.33529707100007, 3.009019273000092],
              [101.32146243600005, 2.996161200000074],
              [101.30225670700003, 2.988674221000053],
              [101.28728274800005, 2.978216864000046],
              [101.28142337300005, 2.972479559000078],
              [101.27564537900008, 2.967718817000048],
              [101.26807701900003, 2.96515534100007],
              [101.26636803500003, 2.971502997000073],
              [101.26807701900003, 2.982123114000046],
              [101.29232832100007, 3.042914130000042],
              [101.30591881600003, 3.063950914000088],
              [101.32349694100003, 3.071112372000073],
              [101.33619225400008, 3.065008856000077],
              [101.33765709700003, 3.051825262000079],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Dhekelia',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.78093509200005, 34.97634511900009],
            [33.760427280000044, 34.979681708000044],
            [33.71729576900009, 34.977769273000035],
            [33.701508009000065, 34.97288646000004],
            [33.7029346110001, 34.98794301400004],
            [33.71146122200008, 34.98556589900009],
            [33.7154403080001, 34.997296448000085],
            [33.6997306720001, 35.00272247300005],
            [33.696630086000084, 35.00897532200007],
            [33.70531172700004, 35.01522817000004],
            [33.70221114100008, 35.02225616500006],
            [33.68500289000008, 35.029284160000074],
            [33.6794345990001, 35.03389876400006],
            [33.67564945500004, 35.03703562400007],
            [33.67409916200006, 35.04644073400003],
            [33.67885339400004, 35.055794169000066],
            [33.694459675000076, 35.05817128500003],
            [33.70531172700004, 35.06674957300005],
            [33.71471683800007, 35.06674957300005],
            [33.719367716000136, 35.062770487000066],
            [33.71146122200008, 35.04096303300004],
            [33.70758548900005, 35.029284160000074],
            [33.718489217000126, 35.032384745000016],
            [33.73967655400014, 35.04721588200006],
            [33.76613488800007, 35.03160959900002],
            [33.7755399990001, 35.040187887000044],
            [33.78649540200007, 35.038534241],
            [33.794350220000126, 35.040187887000044],
            [33.79827762800011, 35.05264190700002],
            [33.824012492000065, 35.06674957300005],
            [33.83486454200005, 35.063597311000095],
            [33.842719360000046, 35.056620993000095],
            [33.853571411000075, 35.05817128500003],
            [33.866903930000035, 35.06674957300005],
            [33.87155481000008, 35.07305409800007],
            [33.87692915900004, 35.0768264770001],
            [33.87155481000008, 35.08545644200005],
            [33.87155481000008, 35.10023590100006],
            [33.876205689000074, 35.11899444600006],
            [33.88943485500005, 35.11899444600006],
            [33.891811971000095, 35.11046783400003],
            [33.89883996600008, 35.108814189000086],
            [33.90359419800012, 35.099512431000065],
            [33.905867961000126, 35.096360169],
            [33.905867961000126, 35.090882466000025],
            [33.913619425000036, 35.090882466000025],
            [33.92147424400014, 35.08070221000004],
            [33.91444624900004, 35.07305409800007],
            [33.90824507700006, 35.07072865800005],
            [33.906505327911546, 35.06910491074929],
            [33.898116496000114, 35.06127187200006],
            [33.880133098000044, 35.07305409800007],
            [33.87465539600004, 35.067524719000076],
            [33.86762740100005, 35.06049672400006],
            [33.85512170400011, 35.05341705300013],
            [33.84116906700012, 35.051091613],
            [33.83486454200005, 35.056620993000095],
            [33.82711307900013, 35.06127187200006],
            [33.813780558000076, 35.055794169000066],
            [33.80437544700004, 35.04954132100006],
            [33.799001099000066, 35.038534241],
            [33.822358847000146, 35.03005930600007],
            [33.83021366400004, 35.02303131100008],
            [33.829386841000144, 35.00117218000004],
            [33.84034224400011, 34.993369039000115],
            [33.85904911300008, 34.991818745],
            [33.85904911300008, 34.97466217100005],
            [33.85047082500006, 34.97300852500008],
            [33.83806848100011, 34.96370676700006],
            [33.84581994600012, 34.959727682000064],
            [33.86442346200005, 34.962983297000065],
            [33.89184063943094, 34.958139066829645],
            [33.883799675000034, 34.94912344000005],
            [33.87452233200008, 34.94122955900008],
            [33.862315300000034, 34.93789297100005],
            [33.84742272200009, 34.94245026200008],
            [33.81967207100007, 34.96474844000005],
            [33.80420983200008, 34.97260163000004],
            [33.78183027400007, 34.976223049000055],
            [33.78494511000008, 34.97621246400006],
            [33.78804569400012, 34.97698761000005],
            [33.7927999260001, 34.977762757000065],
            [33.794350220000126, 34.977762757000065],
            [33.79114628100007, 34.98241363600003],
            [33.78649540200007, 34.984687399000066],
            [33.78256799400009, 34.984687399000066],
            [33.77791711500004, 34.984687399000066],
            [33.773989705000076, 34.988666484000035],
            [33.76613488800007, 34.99026845400006],
            [33.76148400900007, 34.99026845400006],
            [33.759210246000066, 34.988666484000035],
            [33.76541141800004, 34.98556589900009],
            [33.76933882600014, 34.98396392900007],
            [33.77088912000005, 34.98008819600001],
            [33.7755399990001, 34.98008819600001],
            [33.78019087800004, 34.9793130500001],
            [33.78093509200005, 34.97634511900009],
          ],
          [
            [33.74279201400009, 35.001232847],
            [33.746688555000105, 35.00271084500007],
            [33.75206309600014, 35.00432320700007],
            [33.75206309600014, 35.01440047000004],
            [33.74615110100012, 35.01520665100004],
            [33.741314015000114, 35.01372865300006],
            [33.74023910700009, 35.0101008380001],
            [33.73876110800006, 35.00526375200009],
            [33.73970165300011, 35.002576482000066],
            [33.74279201400009, 35.001232847],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cyprus',
        iso3: 'CYP',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [33.78183027400007, 34.976223049000055],
              [33.78093509200005, 34.97634511900009],
              [33.78019087800004, 34.9793130500001],
              [33.7755399990001, 34.98008819600001],
              [33.77088912000005, 34.98008819600001],
              [33.76933882600014, 34.98396392900007],
              [33.76541141800004, 34.98556589900009],
              [33.759210246000066, 34.988666484000035],
              [33.76148400900007, 34.99026845400006],
              [33.76613488800007, 34.99026845400006],
              [33.773989705000076, 34.988666484000035],
              [33.77791711500004, 34.984687399000066],
              [33.78256799400009, 34.984687399000066],
              [33.78649540200007, 34.984687399000066],
              [33.79114628100007, 34.98241363600003],
              [33.794350220000126, 34.977762757000065],
              [33.7927999260001, 34.977762757000065],
              [33.78804569400012, 34.97698761000005],
              [33.78494511000008, 34.97621246400006],
              [33.78183027400007, 34.976223049000055],
            ],
          ],
          [
            [
              [33.74279201400009, 35.001232847],
              [33.73970165300011, 35.002576482000066],
              [33.73876110800006, 35.00526375200009],
              [33.74023910700009, 35.0101008380001],
              [33.741314015000114, 35.01372865300006],
              [33.74615110100012, 35.01520665100004],
              [33.75206309600014, 35.01440047000004],
              [33.75206309600014, 35.00432320700007],
              [33.746688555000105, 35.00271084500007],
              [33.74279201400009, 35.001232847],
            ],
          ],
          [
            [
              [33.7029346110001, 34.98794301400004],
              [33.701508009000065, 34.97288646000004],
              [33.680349155000044, 34.96629466400009],
              [33.65406334700009, 34.94472890800006],
              [33.64665774800005, 34.93195221600007],
              [33.63982181100005, 34.915676174000055],
              [33.634776238000086, 34.897650458000044],
              [33.63298587300005, 34.87982819200005],
              [33.63502037900008, 34.86074453300006],
              [33.63257897200009, 34.85248444200005],
              [33.623057488000086, 34.84906647300005],
              [33.61695397200009, 34.84528229400007],
              [33.610036655000044, 34.827460028000075],
              [33.60564212300005, 34.82176341400009],
              [33.590179884000065, 34.818060614000046],
              [33.556976759000065, 34.81777578300006],
              [33.54420006600009, 34.81500885600008],
              [33.535492384000065, 34.807521877000056],
              [33.52515709700009, 34.79596588700008],
              [33.51319420700008, 34.78546784100007],
              [33.49952233200008, 34.78082916900007],
              [33.46762129000007, 34.774318752000056],
              [33.43864993600005, 34.76276276200008],
              [33.41521243600005, 34.75844961100006],
              [33.40015709700009, 34.77338288000004],
              [33.399180535000085, 34.745306708000044],
              [33.37086022200009, 34.73086172100005],
              [33.29656009200005, 34.71816640800006],
              [33.281586134000065, 34.71234772300005],
              [33.272552931000064, 34.70734284100007],
              [33.260101759000065, 34.700506903000075],
              [33.24561608200008, 34.69822825700004],
              [33.17359459700009, 34.705145575000074],
              [33.101898634000065, 34.69822825700004],
              [33.08643639400009, 34.69481028900009],
              [33.072276238000086, 34.686753648000035],
              [33.02588951900009, 34.65131256700005],
              [33.01563463629242, 34.63442454100009],
              [32.99073002100005, 34.63442454100009],
              [32.9695426830001, 34.63204742500004],
              [32.9625146890001, 34.62501943000002],
              [32.955590047000044, 34.62889516200009],
              [32.95403975500011, 34.642951152000094],
              [32.96561527600005, 34.65158111600006],
              [32.970266154000115, 34.64610341500007],
              [32.98979984500011, 34.64610341500007],
              [32.9875260820001, 34.673388571000075],
              [32.95471154800009, 34.677315979000056],
              [32.942257528000084, 34.66713572200008],
              [32.93605635600011, 34.65773061100002],
              [32.92975183100009, 34.662484843000115],
              [32.917246135000084, 34.66713572200008],
              [32.91366655000013, 34.660279908000106],
              [32.8845035650001, 34.6666068790001],
              [32.8656130550001, 34.67873549600007],
              [32.860430068000085, 34.687620615000085],
              [32.85968964200009, 34.700578081000074],
              [32.85376622900009, 34.699467441000095],
              [32.84599175000005, 34.699467441000095],
              [32.84080876400009, 34.699467441000095],
              [32.835625777000075, 34.69983765400009],
              [32.83229385800007, 34.70094829400007],
              [32.827481085000045, 34.6965057340001],
              [32.822668312000076, 34.691322748000076],
              [32.81933639200008, 34.687620615000085],
              [32.806008714000086, 34.68576954900006],
              [32.79860444800005, 34.670961017000124],
              [32.778612929000076, 34.673182297000054],
              [32.766766104000055, 34.67614400300006],
              [32.760102265000114, 34.66910995000008],
              [32.76067142000005, 34.653225002000056],
              [32.74919681100005, 34.64984772300005],
              [32.707367384000065, 34.645412502000056],
              [32.66578209700009, 34.65216705900008],
              [32.62623131600009, 34.66648997600004],
              [32.57504316500007, 34.69281647300005],
              [32.556651238000086, 34.69936758000006],
              [32.535817905000044, 34.703558661000045],
              [32.49333743600005, 34.70726146000004],
              [32.47584069100009, 34.71320221600007],
              [32.458994988000086, 34.721869208000044],
              [32.41911868600005, 34.74799225500004],
              [32.41334069100009, 34.75348541900007],
              [32.40707441500007, 34.782416083000044],
              [32.403005405000044, 34.78705475500004],
              [32.402354363000086, 34.79645416900007],
              [32.37916100400008, 34.84906647300005],
              [32.367930535000085, 34.85700104400007],
              [32.346690300000034, 34.86859772300005],
              [32.33765709700009, 34.87641022300005],
              [32.32943769600007, 34.886419989000046],
              [32.32341556100005, 34.898423570000034],
              [32.32276451900009, 34.911363023000035],
              [32.33139082100007, 34.92422109600005],
              [32.31218509200005, 34.95026276200008],
              [32.31031334700009, 34.96076080900008],
              [32.31031334700009, 34.98257070500006],
              [32.30591881600009, 35.00141022300005],
              [32.284190300000034, 35.03237539300005],
              [32.276133660000085, 35.047756252000056],
              [32.27173912900008, 35.07282135600008],
              [32.27515709700009, 35.091050523000035],
              [32.28663170700008, 35.09715403900009],
              [32.30689537900008, 35.085598049000055],
              [32.336680535000085, 35.05874258000006],
              [32.35336347700007, 35.04791901200008],
              [32.37232506600009, 35.04148997600004],
              [32.41382897200009, 35.043036200000074],
              [32.449961785000085, 35.05882396000004],
              [32.47966556100005, 35.08295319200005],
              [32.501963738000086, 35.10919830900008],
              [32.51685631600009, 35.14020416900007],
              [32.52759850400008, 35.15704987200007],
              [32.54346764400009, 35.16648997600004],
              [32.54542076900009, 35.171210028000075],
              [32.54818769600007, 35.17597077000005],
              [32.55396569100009, 35.17804596600007],
              [32.558929884000065, 35.17690664300005],
              [32.56649824300007, 35.172715562000064],
              [32.56820722700007, 35.17177969000005],
              [32.57471764400009, 35.17059967700004],
              [32.58480879000007, 35.17251211100006],
              [32.592614787000116, 35.16111073800009],
              [32.607497599000055, 35.154082743000075],
              [32.622225382000124, 35.15180898000007],
              [32.63395593200005, 35.154082743000075],
              [32.646461629000044, 35.16111073800009],
              [32.653489624000144, 35.17433990600007],
              [32.659812714000054, 35.18708213000012],
              [32.691548895582855, 35.183705160320315],
              [32.69803470800014, 35.15723500600005],
              [32.70413252700007, 35.143902486000016],
              [32.71271081600014, 35.13377390600006],
              [32.72831709800005, 35.12679758700007],
              [32.75487878500007, 35.119769592000054],
              [32.77523929800009, 35.11046783400003],
              [32.79559981300014, 35.10261301700008],
              [32.80650354000011, 35.09480987600007],
              [32.81027592000004, 35.079927064000046],
              [32.81027592000004, 35.07072865800005],
              [32.81585697400004, 35.062770487000066],
              [32.8259855550001, 35.05894643200013],
              [32.834563842000136, 35.05894643200013],
              [32.86102217700011, 35.06509592700009],
              [32.87347619600013, 35.07227895100006],
              [32.87673181100007, 35.0768264770001],
              [32.8829329830001, 35.087781881000055],
              [32.8907878010001, 35.09165761300004],
              [32.90019291200008, 35.087781881000055],
              [32.906394084000055, 35.08070221000004],
              [32.92194868900009, 35.07227895100006],
              [32.9352295330001, 35.07227895100006],
              [32.94840702400006, 35.07915191700003],
              [32.96711389200004, 35.09480987600007],
              [32.985148966000054, 35.108814189000086],
              [33.003132365000056, 35.1158938600001],
              [33.02638675900005, 35.1276244110001],
              [33.03734216300012, 35.136099345],
              [33.0467472740001, 35.137752991000056],
              [33.071655314000054, 35.135324199000095],
              [33.098217, 35.13067332000013],
              [33.12307336400005, 35.13067332000013],
              [33.13712935400014, 35.136099345],
              [33.1434855550001, 35.14007843000009],
              [33.14968672700007, 35.148656718000026],
              [33.17387129700012, 35.162661032000116],
              [33.18947758000007, 35.162661032000116],
              [33.20281009900009, 35.15801015300006],
              [33.21614261900004, 35.154082743000075],
              [33.22854496200006, 35.153359274000096],
              [33.23867354400005, 35.14943186400002],
              [33.25210941600011, 35.136926168000016],
              [33.26213464300008, 35.12607411800006],
              [33.27856774900005, 35.118219300000035],
              [33.301202027000045, 35.11356842100007],
              [33.309056844000054, 35.1158938600001],
              [33.31365604600012, 35.12131988600008],
              [33.31525801600014, 35.129123027],
              [33.32771203600004, 35.136926168000016],
              [33.348020875000145, 35.154909566000114],
              [33.35659916100008, 35.15723500600005],
              [33.37303226700004, 35.1556847130001],
              [33.39866377800013, 35.15801015300006],
              [33.415923706000115, 35.16033559200007],
              [33.421401408000065, 35.15723500600005],
              [33.421401408000065, 35.144729309000056],
              [33.42450199400014, 35.12989817400002],
              [33.43235681200008, 35.12364532500003],
              [33.44320886300011, 35.11356842100007],
              [33.45726485200004, 35.10106272400007],
              [33.45881514500013, 35.09480987600007],
              [33.460365437000064, 35.07760162400011],
              [33.45881514500013, 35.06127187200006],
              [33.45881514500013, 35.04168650300004],
              [33.452510620000055, 35.0191039030001],
              [33.446309448000136, 35.00117218000004],
              [33.449410034000095, 34.98794301400004],
              [33.45881514500013, 34.977762757000065],
              [33.46977054800004, 34.977762757000065],
              [33.486203654000064, 34.98163848900002],
              [33.493128296000066, 34.997296448000085],
              [33.49700402800005, 35.0260802210001],
              [33.50281057400014, 35.030870057000115],
              [33.510284871000124, 35.03703562400007],
              [33.51958663000005, 35.044115295],
              [33.527441447000115, 35.03703562400007],
              [33.527441447000115, 35.01285105400011],
              [33.53364261900009, 34.999570211],
              [33.54604496200005, 34.994971009000054],
              [33.56413171400004, 35.00117218000004],
              [33.571883179000054, 35.01440134700003],
              [33.58056481900013, 35.01993072500004],
              [33.59152022400008, 35.018380432000114],
              [33.60299239100004, 35.012075908],
              [33.61167403200005, 35.01362620100012],
              [33.61952885000011, 35.016830140000096],
              [33.630329224000036, 35.01362620100012],
              [33.639786011000126, 35.009750468000064],
              [33.66159346500007, 35.000345357000114],
              [33.67409916200006, 34.998795064],
              [33.68500289000008, 34.997296448000085],
              [33.70055749400012, 34.988666484000035],
              [33.7029346110001, 34.98794301400004],
            ],
          ],
          [
            [
              [33.898116496000114, 35.06127187200006],
              [33.910518839000076, 35.057396139],
              [33.92147424400014, 35.05341705300013],
              [33.93077600100008, 35.051091613],
              [33.944935343000054, 35.051091613],
              [33.9620919190001, 35.057396139],
              [33.98007531700006, 35.057396139],
              [33.989480428000036, 35.05186676100003],
              [34.00198612400004, 35.04721588200006],
              [34.01190800000012, 35.04881785],
              [34.017489054000066, 35.05186676100003],
              [34.0219607300001, 35.05700872100003],
              [34.035899285000085, 35.04718659100007],
              [34.05103600400008, 35.03302643400008],
              [34.06218509200005, 35.00568268400008],
              [34.07341556100005, 34.98810455900008],
              [34.08708743600005, 34.971909898000035],
              [34.09913170700008, 34.96515534100007],
              [34.08521569100009, 34.96434153900009],
              [34.05941816500007, 34.96662018400008],
              [34.03451582100007, 34.97247955900008],
              [34.023448113000086, 34.98257070500006],
              [34.01156660200007, 34.987616278000075],
              [33.95728600400008, 34.98191966400009],
              [33.910166863000086, 34.97016022300005],
              [33.89991295700008, 34.96515534100007],
              [33.89184063943094, 34.958139066829645],
              [33.86442346200005, 34.962983297000065],
              [33.84581994600012, 34.959727682000064],
              [33.83806848100011, 34.96370676700006],
              [33.85047082500006, 34.97300852500008],
              [33.85904911300008, 34.97466217100005],
              [33.85904911300008, 34.991818745],
              [33.84034224400011, 34.993369039000115],
              [33.829386841000144, 35.00117218000004],
              [33.83021366400004, 35.02303131100008],
              [33.822358847000146, 35.03005930600007],
              [33.799001099000066, 35.038534241],
              [33.80437544700004, 35.04954132100006],
              [33.813780558000076, 35.055794169000066],
              [33.82711307900013, 35.06127187200006],
              [33.83486454200005, 35.056620993000095],
              [33.84116906700012, 35.051091613],
              [33.85512170400011, 35.05341705300013],
              [33.86762740100005, 35.06049672400006],
              [33.87465539600004, 35.067524719000076],
              [33.880133098000044, 35.07305409800007],
              [33.898116496000114, 35.06127187200006],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'India',
        iso3: 'IND',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [77.80034631400014, 35.49540557900012],
              [77.81533247900012, 35.47333974200002],
              [77.83424605300007, 35.452152405000064],
              [77.85708703600005, 35.43659779900004],
              [77.88313195800004, 35.431068420000045],
              [77.91269087700005, 35.44099029500005],
              [77.95785607900012, 35.482073059000086],
              [77.98586470600003, 35.49416534400008],
              [78.04425907400008, 35.491633199],
              [78.0556278900001, 35.45287587500006],
              [78.03805790200005, 35.398098857],
              [78.00984257100004, 35.34745595300002],
              [78.0011609290001, 35.26890777600009],
              [78.03640425700007, 35.19423533100009],
              [78.13004195100012, 35.05543243400008],
              [78.13924035700012, 35.01894887300007],
              [78.14812870300005, 34.94313954700006],
              [78.16218469300003, 34.90882639600004],
              [78.20249230900009, 34.86572825100005],
              [78.21138065600013, 34.84826161700009],
              [78.2731856690001, 34.658867493000045],
              [78.29602665200014, 34.62465769500004],
              [78.3353007400001, 34.59437530600009],
              [78.37943241400006, 34.578665670000035],
              [78.6073254800001, 34.54647125300009],
              [78.66458296800005, 34.52642079700006],
              [78.75067590400005, 34.47128204400006],
              [78.80173221800004, 34.41500640900007],
              [78.83924930800003, 34.396893820000045],
              [78.8858614500001, 34.38575754800003],
              [78.92213830600014, 34.37229583700007],
              [78.95118046100004, 34.34917063400009],
              [78.95693951600003, 34.33996090500004],
              [78.97619185400004, 34.30917307600002],
              [78.98539025900004, 34.28635793100001],
              [78.98849084500006, 34.26312937400009],
              [78.98549361200014, 34.239900818000095],
              [78.97619185400004, 34.2171631880001],
              [78.90322473100008, 34.15812286400008],
              [78.80607303900013, 34.12298289000002],
              [78.73010868400007, 34.079264629000036],
              [78.7211169840001, 33.99438608900009],
              [78.77031294800008, 33.872352193000026],
              [78.78726281700011, 33.808428447000054],
              [78.79408410700006, 33.743910421000024],
              [78.7813717040001, 33.55278513600008],
              [78.80090539600008, 33.494235738],
              [78.82426314300005, 33.46105946900006],
              [78.91594777500006, 33.387655981000094],
              [78.91769413200012, 33.386257833000045],
              [78.96498571648198, 33.344254148471954],
              [78.99344870739196, 33.330781826020484],
              [79.02304063027336, 33.31798038693261],
              [79.05327756453967, 33.307872984457326],
              [79.07504815721146, 33.29574255484219],
              [79.09802822725385, 33.28765466454805],
              [79.12503824122189, 33.29020260316764],
              [79.15021349475705, 33.29255492117272],
              [79.26006124250934, 33.29177628972042],
              [79.34030669939472, 33.27513188662732],
              [79.42008441515759, 33.27516911050025],
              [79.45609607657275, 33.25039903388836],
              [79.42347470306436, 33.15782502934888],
              [79.3731702070001, 33.11214019800006],
              [79.38106298759733, 33.06176785943445],
              [79.39927298712544, 33.026877543090805],
              [79.33978723100012, 33.013257345000014],
              [79.33358605900014, 32.99429209500006],
              [79.3784615590933, 32.97888079862581],
              [79.41408948759245, 32.9720529162554],
              [79.4710886681076, 32.908959488689504],
              [79.56409288128151, 32.793927891059354],
              [79.61391341067542, 32.76503545442273],
              [79.62067291506752, 32.72872513425561],
              [79.57617012539868, 32.6706463645242],
              [79.53120131304826, 32.648316794003655],
              [79.51574063362341, 32.608119744630585],
              [79.47211298523796, 32.56547177661887],
              [79.44349727169374, 32.53477259180094],
              [79.40682034478317, 32.52968335070614],
              [79.37947682579494, 32.57644972217696],
              [79.32046626650504, 32.59226722135526],
              [79.28741156145267, 32.53257939116813],
              [79.23560754400012, 32.504296163000035],
              [79.21524703000006, 32.507913513000105],
              [79.19116581200012, 32.504270325],
              [79.16140018800013, 32.496467184],
              [79.13287479700011, 32.4854601040001],
              [79.11292769400006, 32.47238596700005],
              [79.10290246600005, 32.449855042000124],
              [79.0917403570001, 32.39055633500003],
              [79.07530725100014, 32.370790100000036],
              [79.0663155520001, 32.37006663100006],
              [79.03965051300008, 32.37598358100006],
              [79.02817834500007, 32.377094626000044],
              [79.01474247300007, 32.373994039000095],
              [78.98983443200012, 32.364098003000024],
              [78.97619185400004, 32.36161753300006],
              [78.94342899600014, 32.346372986000105],
              [78.9112862550001, 32.35474456800007],
              [78.88152063000013, 32.37626780200013],
              [78.85568241400006, 32.40045237300011],
              [78.77144982900012, 32.461663106000046],
              [78.75470666500013, 32.493805847000075],
              [78.73692997300003, 32.54579233800008],
              [78.73496626800011, 32.56064931300004],
              [78.74065067600003, 32.578684387000024],
              [78.74912561100012, 32.5958668010001],
              [78.75098596200013, 32.61279083300009],
              [78.73682661900011, 32.629844056000124],
              [78.7132621670001, 32.637518006],
              [78.69445194500008, 32.629663188000066],
              [78.66489302600013, 32.59901906300006],
              [78.64773645100007, 32.58597076500011],
              [78.63016646300008, 32.57801259400004],
              [78.58985884700007, 32.569925232000045],
              [78.44754195200011, 32.566256205000045],
              [78.40816451000006, 32.55837555],
              [78.38480676200004, 32.54754933700006],
              [78.3809827070001, 32.528041484000084],
              [78.40919803900005, 32.4766234340001],
              [78.44878218600013, 32.42678151500006],
              [78.45219283000006, 32.41678212500004],
              [78.44816206900003, 32.41065846800008],
              [78.44144413200013, 32.40494822200013],
              [78.43637984200006, 32.39616322900004],
              [78.43451949100006, 32.38376088500006],
              [78.43596643100005, 32.377973125],
              [78.43886031100004, 32.37329640700004],
              [78.46273482300012, 32.28180328400008],
              [78.46139123600005, 32.26015085900009],
              [78.45632694500006, 32.24211578400009],
              [78.45798059100014, 32.229661764000085],
              [78.46854076900007, 32.22666774700009],
              [78.46901739200007, 32.226532615000096],
              [78.47648075400014, 32.22441660600008],
              [78.51306766800008, 32.2075700890001],
              [78.53497847500006, 32.18134429900006],
              [78.55182499200004, 32.15039011700007],
              [78.64928674300012, 32.036443583],
              [78.67832889800007, 32.01675486300006],
              [78.72215051300009, 31.99458567300003],
              [78.73382938700007, 31.984663798000028],
              [78.74457808500011, 31.964199931000067],
              [78.7419942630001, 31.945338033000056],
              [78.72018680900004, 31.902911682000124],
              [78.71419234300004, 31.88301625600012],
              [78.70664758300006, 31.840796611000044],
              [78.7003430580001, 31.821676331000035],
              [78.67409143000003, 31.786949768000014],
              [78.67088749200008, 31.770516663000038],
              [78.69558882600006, 31.746693827000072],
              [78.69517541500005, 31.737960511],
              [78.69259159400008, 31.728400370000102],
              [78.69321171100006, 31.71853017200003],
              [78.69806929500004, 31.71103709000009],
              [78.71047164000004, 31.698169658],
              [78.71842981000009, 31.680599671000024],
              [78.72401086500008, 31.67331329300005],
              [78.7313489180001, 31.668042298],
              [78.73982385300008, 31.666026917000053],
              [78.75811731000005, 31.666595358],
              [78.79532434100008, 31.633780823000095],
              [78.81888879400009, 31.607374166000014],
              [78.81403120900006, 31.59502349900005],
              [78.79697798700005, 31.578848775000054],
              [78.69951623500003, 31.51001576800006],
              [78.69538212100014, 31.488104961000104],
              [78.73300256300007, 31.467744446000083],
              [78.76256148300007, 31.44511016900013],
              [78.7600810140001, 31.412037252000047],
              [78.74550826100005, 31.373538310000086],
              [78.73848026600012, 31.334987691000023],
              [78.74085738200006, 31.317727763000036],
              [78.74509484900005, 31.308115947000104],
              [78.75315637200003, 31.30196645100004],
              [78.78447229000005, 31.288272197000097],
              [78.79604781100005, 31.288117167000067],
              [78.82198938000005, 31.29369822200009],
              [78.84865441900007, 31.29090769500003],
              [78.86198693800009, 31.291476135],
              [78.88697183608144, 31.28417089736905],
              [78.92100839989331, 31.269685496828163],
              [78.94028174400734, 31.301576298907094],
              [78.95955204300003, 31.325117493000036],
              [78.98880090300014, 31.34325592100005],
              [79.01552948833853, 31.383397147758455],
              [79.04993667283924, 31.422952683719416],
              [79.07021024772884, 31.461381390199218],
              [79.07799043411131, 31.461664353726974],
              [79.13139720595568, 31.438433157420082],
              [79.15769333967592, 31.414925750622956],
              [79.17921754805144, 31.393795999286],
              [79.19244185390846, 31.369789449823315],
              [79.20762798854088, 31.351372703987124],
              [79.23831863759511, 31.3296556045226],
              [79.2392392007286, 31.311723913427898],
              [79.25411000876994, 31.29900573432724],
              [79.26202358591979, 31.27851309060668],
              [79.24843045010522, 31.256703749478504],
              [79.2528602604927, 31.24543676949139],
              [79.2783162706794, 31.240043992036647],
              [79.28832134985049, 31.225473994629226],
              [79.29807839147153, 31.203242202430214],
              [79.30320907773682, 31.183103768324315],
              [79.30216249530298, 31.163450395319558],
              [79.31941711251294, 31.142279974197177],
              [79.3670479880583, 31.111559061766084],
              [79.37234338400009, 31.094072165000043],
              [79.38259259500006, 31.07833466600009],
              [79.38836307800011, 31.069474182000064],
              [79.3949776610001, 31.036711324000052],
              [79.40159224500013, 31.02363718700012],
              [79.414408, 31.02038157100013],
              [79.43073775300013, 31.023172099000092],
              [79.4463440350001, 31.023792216000047],
              [79.46164025900003, 31.02110504200003],
              [79.47641971900003, 31.014025371000102],
              [79.48076053900013, 31.01004628500003],
              [79.4842745360001, 31.005447083000078],
              [79.48685835800006, 31.00022776300004],
              [79.48820194600006, 30.99449167900009],
              [79.4976070560001, 30.981210836000074],
              [79.51269657400007, 30.966172994000104],
              [79.5296464440001, 30.953563945000084],
              [79.54421919800006, 30.947414449000107],
              [79.56592329900008, 30.942453512000057],
              [79.57780887900009, 30.938371074000045],
              [79.58948775300007, 30.94023142500005],
              [79.63031213400006, 30.962503967000103],
              [79.64819217900003, 30.965759583000093],
              [79.68849979700008, 30.96741322900003],
              [79.73903934800012, 30.979247131000065],
              [79.76064009600009, 30.977231751000105],
              [79.83350386600006, 30.96152211500005],
              [79.85035038300003, 30.954494120000035],
              [79.86285607900004, 30.941523336],
              [79.8804260660001, 30.912842916],
              [79.90316369700008, 30.89020863900005],
              [79.91463535600008, 30.88381888700009],
              [79.91936951600007, 30.88118194500005],
              [79.93489302600011, 30.872535299000063],
              [80.00558638600012, 30.847265524000093],
              [80.02863407400008, 30.830780742000016],
              [80.04444706200007, 30.80669952400008],
              [80.06253381400006, 30.784788717000097],
              [80.09219608500007, 30.774505107000024],
              [80.10924930900006, 30.778122458],
              [80.14066858000012, 30.79321197500009],
              [80.15710168400011, 30.793160299000093],
              [80.16929732200009, 30.78525380400005],
              [80.19606571500009, 30.748098450000057],
              [80.22459110500012, 30.734094137000042],
              [80.23141239400007, 30.724947408000062],
              [80.20702111900005, 30.68613840700003],
              [80.19988977100013, 30.68071238200004],
              [80.19172489400012, 30.679678853000055],
              [80.18200972500006, 30.680040589000058],
              [80.1729146730001, 30.67916208900003],
              [80.16661014800007, 30.674407858000038],
              [80.16692020700003, 30.661902161000043],
              [80.17725549300008, 30.649861552000047],
              [80.19058801300008, 30.637975973000025],
              [80.19988977100013, 30.62588368700004],
              [80.20330041600005, 30.60634999600005],
              [80.19782271300005, 30.591363831000066],
              [80.18841760200007, 30.576997783000067],
              [80.17983931500004, 30.559479472000092],
              [80.21621952300006, 30.566817526000094],
              [80.2528064380001, 30.565008851000087],
              [80.32587691200013, 30.54650868700007],
              [80.42499230900006, 30.49782948800005],
              [80.47542850700006, 30.48046620700002],
              [80.5082947190001, 30.46232777900009],
              [80.52514123600008, 30.458607076000092],
              [80.54508833800008, 30.461035869000042],
              [80.55997115100007, 30.465118306000065],
              [80.57526737500012, 30.466255188000062],
              [80.59635136000003, 30.45979563500002],
              [80.69474328600006, 30.41173655200005],
              [80.72306197200004, 30.392047832000102],
              [80.73536096200007, 30.378198547000054],
              [80.75499800600005, 30.345797425000043],
              [80.76719364400003, 30.331431376000026],
              [80.78166304500007, 30.320992737],
              [80.86698083500005, 30.28848826100007],
              [80.94377201300011, 30.270143128000072],
              [80.97601810700007, 30.255208638000042],
              [80.99627526900008, 30.226889954000043],
              [81.00330326400012, 30.212730611000083],
              [80.99601688700011, 30.19696930000002],
              [80.98816225269584, 30.196555926350566],
              [80.92082703591576, 30.176660408536822],
              [80.903309336412, 30.180432806924035],
              [80.89364690080846, 30.198104359137524],
              [80.8838787660946, 30.210405146915726],
              [80.88368373459112, 30.210280032524576],
              [80.8679110110001, 30.200173238000062],
              [80.85039270000004, 30.181931458000022],
              [80.83644006400004, 30.170045879000085],
              [80.84966923100006, 30.143380840000034],
              [80.82982548000007, 30.11712921200011],
              [80.76967411300012, 30.077286682000093],
              [80.75572147700012, 30.06457428000003],
              [80.72574914600011, 30.02276804700007],
              [80.71582727100008, 30.013311259000105],
              [80.68017053200003, 29.99207224500013],
              [80.65412561000005, 29.970574849000073],
              [80.64141320800007, 29.96344350200006],
              [80.62229292800009, 29.958172506000025],
              [80.58622277800009, 29.95414174500003],
              [80.57133996600004, 29.946855367000055],
              [80.56286503100006, 29.92969879200008],
              [80.5495325120001, 29.893680319000097],
              [80.52731164500005, 29.86241607700002],
              [80.47615197800008, 29.806140442000114],
              [80.45486128700009, 29.79058583600009],
              [80.39522668500007, 29.776581523000075],
              [80.36897505700006, 29.757926330000103],
              [80.35429895100009, 29.730279440000103],
              [80.35440230300009, 29.704880473000102],
              [80.36391076700005, 29.679714050000072],
              [80.37755334500008, 29.652945659000082],
              [80.38675175000009, 29.626823222],
              [80.38520145600006, 29.604834900000114],
              [80.37331587800003, 29.58419016500001],
              [80.35078495300013, 29.562072652],
              [80.3451005450001, 29.558351949000084],
              [80.33269820200007, 29.552460836000094],
              [80.32722050000012, 29.548585103000036],
              [80.32360314900012, 29.541660462000053],
              [80.3250500900001, 29.535510966000075],
              [80.32763391200012, 29.529929911000053],
              [80.32722050000012, 29.524839783000075],
              [80.3200891520001, 29.515822245000024],
              [80.31151086400013, 29.508122457000027],
              [80.29146040900008, 29.49473826100011],
              [80.29115035000012, 29.494609070000067],
              [80.28205529800005, 29.48429962200005],
              [80.27306359800008, 29.47866689100003],
              [80.26624231000005, 29.47212982200007],
              [80.26345178200006, 29.459236552000064],
              [80.25745731700005, 29.450063986000075],
              [80.22831180800006, 29.441718242],
              [80.21766646400005, 29.434638570000075],
              [80.21373905400009, 29.416887716000062],
              [80.22097375500005, 29.4001187140001],
              [80.24216109200012, 29.367407532000087],
              [80.24949914600006, 29.326996562000105],
              [80.25497684700008, 29.316635437000016],
              [80.26355513600004, 29.315317688000064],
              [80.27275354000011, 29.315705261000048],
              [80.28009159300012, 29.310150045000043],
              [80.28277876900012, 29.29131398500003],
              [80.27874800600006, 29.26808542900001],
              [80.25818078600014, 29.202456360000085],
              [80.24867232300005, 29.204394226000105],
              [80.23606327400006, 29.213075867000057],
              [80.21880334400004, 29.21108632400002],
              [80.21373905400009, 29.196565246],
              [80.23048221800013, 29.154733174000015],
              [80.23306604000004, 29.139307760000023],
              [80.22066369600003, 29.12607859300003],
              [80.20144006400005, 29.121169332000093],
              [80.18056278500006, 29.12132436100005],
              [80.16350956300005, 29.1233655810001],
              [80.13260705600004, 29.11021392800002],
              [80.11307336500005, 29.072205913000104],
              [80.10470178300005, 29.027609151000078],
              [80.10790572100012, 28.99476877900007],
              [80.10790572100012, 28.99458791100001],
              [80.09943078600008, 28.977276306000093],
              [80.08516809100013, 28.967483623000035],
              [80.06842492700008, 28.959938864],
              [80.05292199700006, 28.94911265000006],
              [80.04051965400004, 28.932808737000116],
              [80.03390507000012, 28.915936381000037],
              [80.03111454300006, 28.897797953000108],
              [80.03028772000005, 28.877669983000132],
              [80.0363855390001, 28.837026469000094],
              [80.05478234800006, 28.824184876000103],
              [80.07305357600006, 28.820924647000098],
              [80.08186079900014, 28.819353129],
              [80.11421024600014, 28.80258412700003],
              [80.14759322100008, 28.763310038000057],
              [80.16206262200012, 28.753284811000057],
              [80.18118290200005, 28.74729034500011],
              [80.21642622900009, 28.74194183400006],
              [80.23327274600007, 28.732717591000053],
              [80.23895715300011, 28.726258037],
              [80.24939579300008, 28.71021250500003],
              [80.25704390500005, 28.7027452600001],
              [80.26520878100007, 28.69928293800008],
              [80.28339888500011, 28.6953555300001],
              [80.29104699700008, 28.689671123000053],
              [80.31833215400007, 28.64011342400009],
              [80.32970096800005, 28.627478537000073],
              [80.34975142400003, 28.620217998000086],
              [80.3690784100001, 28.622646789000058],
              [80.38830204300012, 28.627245993000102],
              [80.40835249900005, 28.626341655000047],
              [80.42654260300009, 28.616807353000056],
              [80.46881392500006, 28.571848857000035],
              [80.48845096900004, 28.562443746],
              [80.49341190600006, 28.575647074000088],
              [80.48493697100008, 28.63928660100008],
              [80.4876241450001, 28.65646901500004],
              [80.49754602100006, 28.670137431000043],
              [80.51759647600005, 28.680033468000133],
              [80.53444380100007, 28.679555368000095],
              [80.55583703600013, 28.67894826200005],
              [80.55904097500007, 28.67303131200005],
              [80.55738732900005, 28.664349671000068],
              [80.55687056500011, 28.655022075000048],
              [80.56358850100014, 28.647038066000064],
              [80.58136519400006, 28.638950704000067],
              [80.59852176900012, 28.633783061000074],
              [80.6356254480001, 28.627866109000067],
              [80.64833785000008, 28.61975291000006],
              [80.66818160000014, 28.586344097000094],
              [80.6786202400001, 28.57471689800012],
              [80.69577681500004, 28.567508036000063],
              [80.72709273300006, 28.559679057000054],
              [80.74352583900003, 28.549963887],
              [80.78166304500007, 28.514746399000032],
              [80.79840620900012, 28.505703024000084],
              [80.8170097260001, 28.502550761000023],
              [80.85798913600013, 28.502447409000084],
              [80.87225183100009, 28.496866353000073],
              [80.88036503100011, 28.481880189],
              [80.88186364800004, 28.46684234700011],
              [80.88666955600013, 28.452786357],
              [80.90527307200006, 28.44084910100004],
              [80.92134444200013, 28.436198222000073],
              [80.94118819200014, 28.432684225000045],
              [80.9605151780001, 28.432270814000034],
              [80.97601810700007, 28.43692169200007],
              [80.9878003340001, 28.430978902000064],
              [80.99131433200006, 28.420256043000066],
              [80.99317468300006, 28.407827861000087],
              [81.00040938300003, 28.397001649000046],
              [81.04706637000004, 28.389087804],
              [81.14634362800007, 28.3722486380001],
              [81.16970137600003, 28.361319072000057],
              [81.19037194900005, 28.33811635300013],
              [81.21073246300006, 28.27863678000007],
              [81.22432336400004, 28.25078318300011],
              [81.28235599800013, 28.191587830000017],
              [81.2959469000001, 28.167454936000055],
              [81.2807540280001, 28.161977234000076],
              [81.27677494300008, 28.153786520000054],
              [81.28307946800004, 28.146086731000068],
              [81.29940922000009, 28.1425210580001],
              [81.29620528100008, 28.128310038000038],
              [81.30705733200006, 28.1238141890001],
              [81.32369714400005, 28.12624298100006],
              [81.3381148690001, 28.132728373000035],
              [81.34726159700006, 28.144433086],
              [81.35144738800011, 28.156809591000084],
              [81.35790694200006, 28.165982157000073],
              [81.37320316600011, 28.167842509000067],
              [81.39604414900003, 28.16063364700001],
              [81.41733483900009, 28.147016907000122],
              [81.43526656100005, 28.12978281600003],
              [81.4482373460001, 28.111411845000035],
              [81.4529399010001, 28.097045797000035],
              [81.45402510600007, 28.086607157000103],
              [81.45821089700013, 28.077279562000072],
              [81.47345544400014, 28.066401672000026],
              [81.56192549700006, 28.025990703000033],
              [81.58218265800008, 28.013278300000067],
              [81.59510176600008, 27.994881490000083],
              [81.59536014800005, 27.994778138000058],
              [81.61504886900013, 27.98123891300007],
              [81.66543339000003, 27.97080027300005],
              [81.6889461670001, 27.96320383700008],
              [81.71039188600014, 27.9475200400001],
              [81.75013106300014, 27.909667054000025],
              [81.80015384900008, 27.88408722000007],
              [81.82785241700003, 27.86563873300007],
              [81.85565433700009, 27.850936788000055],
              [81.88319787600005, 27.84905059900005],
              [81.90609053500009, 27.863106588000065],
              [81.94639815300013, 27.905352072000042],
              [81.97590539600009, 27.91695343000002],
              [82.0272200930001, 27.912405904000067],
              [82.05021249900011, 27.90558612200006],
              [82.05161136900006, 27.90517120300011],
              [82.07166182500009, 27.890030009],
              [82.09036869300007, 27.87233083100007],
              [82.10742191600008, 27.863571675000102],
              [82.15103682400007, 27.84827545200004],
              [82.27040938300007, 27.760477193],
              [82.34792403200004, 27.726009013000024],
              [82.40192590400011, 27.67717478400006],
              [82.44068322800007, 27.666426086000044],
              [82.52615604700009, 27.67521108000004],
              [82.65214318800008, 27.704149883000085],
              [82.67389143300011, 27.696458430000078],
              [82.6796867270001, 27.694408875000036],
              [82.69705000800008, 27.669397481000047],
              [82.70924564600011, 27.630924377],
              [82.71885746300012, 27.556122742000056],
              [82.7297095130001, 27.518166402000062],
              [82.75213708500007, 27.49496368400004],
              [82.87626387600011, 27.487548116000127],
              [82.90127526900011, 27.48036509200007],
              [82.94716394100004, 27.457317403000033],
              [83.01046757100005, 27.443390604000044],
              [83.13278568600009, 27.444217428000073],
              [83.16963098200011, 27.431194967000025],
              [83.2192403570001, 27.393781230000045],
              [83.23159102400007, 27.381223856000034],
              [83.24311486900007, 27.36215525300007],
              [83.2494193930001, 27.348099263000037],
              [83.25949629800004, 27.338125713000025],
              [83.28244063400007, 27.330942688000093],
              [83.30486820500005, 27.33192454100005],
              [83.32435022000004, 27.341691386000022],
              [83.34114506000003, 27.35693593300006],
              [83.3627458090001, 27.38561635400005],
              [83.36956709800012, 27.398173726000053],
              [83.37096236200011, 27.41021433500002],
              [83.35582116800009, 27.42866282200005],
              [83.35385746300005, 27.440290019000102],
              [83.35592452000003, 27.45248565700011],
              [83.36098881100008, 27.462200826000057],
              [83.38703373200008, 27.470469056000084],
              [83.48098148600008, 27.469745585000098],
              [83.59043217000004, 27.456619771000035],
              [83.66339929300005, 27.432280172000034],
              [83.80199548400003, 27.365927633000084],
              [83.84798750900012, 27.35104482000004],
              [83.85334011200007, 27.346194023000052],
              [83.8546020920001, 27.345050354000122],
              [83.86173343900003, 27.354507142000088],
              [83.86752120000006, 27.358382873000053],
              [83.87739139900003, 27.361741842000058],
              [83.87764978000007, 27.36990671900007],
              [83.8736706950001, 27.380086975000026],
              [83.87119022600012, 27.389440410000063],
              [83.8427165120001, 27.418069153000047],
              [83.83408654800013, 27.43403717000008],
              [83.85351688700013, 27.440961813000072],
              [83.89987064700011, 27.44385569200007],
              [83.92204311000006, 27.449695761],
              [83.92302168800012, 27.449953511000032],
              [83.93594079600012, 27.446077780000067],
              [83.97583500200005, 27.439721578000032],
              [84.00766768400013, 27.440806783000127],
              [84.02890669800007, 27.453725891000047],
              [84.07960127800004, 27.509536438000012],
              [84.0995483800001, 27.51687449100011],
              [84.11717004400009, 27.51328297900004],
              [84.12156254100006, 27.49496368400004],
              [84.1309676510001, 27.486411235000034],
              [84.14171634900003, 27.480752666000072],
              [84.16574589100009, 27.472174378000048],
              [84.17509932500008, 27.46297597300007],
              [84.18584802300012, 27.43863637400004],
              [84.1952531340001, 27.43605255100003],
              [84.22553552300008, 27.440393372000116],
              [84.23902307100008, 27.43114329100011],
              [84.24889327000005, 27.412436422000027],
              [84.26770349200007, 27.388561910000035],
              [84.28940759300008, 27.376107890000057],
              [84.5770386150001, 27.329030660000072],
              [84.60654585800012, 27.310478821000018],
              [84.63191898600013, 27.277044169000035],
              [84.64819706300005, 27.240715637000065],
              [84.65765384900004, 27.203405253000128],
              [84.65982426000011, 27.165113017000024],
              [84.65439823400004, 27.12537384100004],
              [84.64452803500006, 27.103721415000038],
              [84.63036869400008, 27.08082875600003],
              [84.6214803470001, 27.057987773000022],
              [84.62726810700008, 27.036490377000078],
              [84.64023889200007, 27.02837717700008],
              [84.7606966560001, 26.999024963000082],
              [84.77196211800009, 26.999179993000055],
              [84.78550134300013, 27.008481751000076],
              [84.80193444900004, 27.013752747000083],
              [84.81748905400013, 27.01060048400005],
              [84.82813440000012, 26.994942526000088],
              [84.82828942900005, 26.994839172000056],
              [84.85175052900007, 26.982126770000022],
              [84.90156661000009, 26.967192281000038],
              [84.92404585800011, 26.95566843700003],
              [84.93856693500004, 26.936599834000035],
              [84.94425134300008, 26.915722554000055],
              [84.95272627800011, 26.897635803000057],
              [84.97577396700007, 26.886887105000127],
              [84.98817631000003, 26.883786520000072],
              [85.00083703600006, 26.882236227000064],
              [85.01804528800005, 26.874433086000053],
              [85.01685673100013, 26.859240214000025],
              [85.01856205200005, 26.84580434200008],
              [85.0439868580001, 26.843737284],
              [85.10021081500008, 26.863529358000093],
              [85.12284509300008, 26.865699768000084],
              [85.16201582800005, 26.851023662000088],
              [85.16552982600012, 26.82079294900008],
              [85.16568485500005, 26.786273092],
              [85.1949337160001, 26.75888458300004],
              [85.28727950000007, 26.736973776000085],
              [85.30236901900008, 26.73733551],
              [85.33704390500003, 26.746792298000074],
              [85.35321862800009, 26.757592672],
              [85.35535245800008, 26.759912352000086],
              [85.36923832200006, 26.77500762900003],
              [85.38587813300006, 26.788443502000078],
              [85.4031897380001, 26.787616679000067],
              [85.42153487200005, 26.782655742000102],
              [85.43962162300011, 26.787720032],
              [85.47569177300011, 26.805238343000056],
              [85.51946171000009, 26.8264256800001],
              [85.59857832800009, 26.854382630000103],
              [85.60937870300012, 26.851023662000088],
              [85.6877718500001, 26.811852926000043],
              [85.70182784000013, 26.7966083780001],
              [85.70963098200014, 26.762450256000122],
              [85.70224125100003, 26.68844960600002],
              [85.71288659700014, 26.65320627900003],
              [85.72704593900005, 26.637599996000105],
              [85.78099613500012, 26.599204407000073],
              [85.7899878340001, 26.597033997000082],
              [85.80006473800012, 26.600703023000065],
              [85.80972823100007, 26.603028463],
              [85.81763472500006, 26.596723938000096],
              [85.81954675300011, 26.588300680000103],
              [85.81975345900008, 26.579515687000097],
              [85.82161381000009, 26.571712545000096],
              [85.82853845200003, 26.566131490000075],
              [85.84476485200008, 26.568508606000123],
              [85.86636560100004, 26.579929098000022],
              [85.93468184400007, 26.632897441000026],
              [85.95214847900013, 26.6420441690001],
              [85.97571293100003, 26.644369609000037],
              [86.01136967000014, 26.65444651300008],
              [86.04170373500006, 26.645454814000047],
              [86.11069177300004, 26.60674916600003],
              [86.11585941500005, 26.602563375000088],
              [86.12206058800012, 26.600289612000054],
              [86.14479821800006, 26.601529847000094],
              [86.14635461800009, 26.60135577600009],
              [86.15265303600012, 26.600651347000067],
              [86.16779423000014, 26.596620585000053],
              [86.17446049000006, 26.593313293000065],
              [86.17926639900003, 26.58861073800007],
              [86.18536421800007, 26.584424947000045],
              [86.19585453300004, 26.582667949000083],
              [86.20288252800009, 26.584579977000075],
              [86.22515507100013, 26.597395732000066],
              [86.26308557100003, 26.60907460600005],
              [86.28442793800014, 26.612020162000036],
              [86.30137780800004, 26.609022930000023],
              [86.30861250800007, 26.60214996300006],
              [86.30902592000012, 26.58799062200002],
              [86.31600223800012, 26.58096262700009],
              [86.32318526200004, 26.580084127000063],
              [86.34483768800004, 26.582616272000067],
              [86.35367435800003, 26.582616272000067],
              [86.38364668800006, 26.572849427],
              [86.4448315840001, 26.543083802000112],
              [86.47547570800003, 26.531973368000095],
              [86.4949060460001, 26.527839254000085],
              [86.5106156820001, 26.52013946600009],
              [86.52430993700011, 26.509080709000088],
              [86.53774580900006, 26.4948696900001],
              [86.53795251500003, 26.4948696900001],
              [86.55789961800014, 26.484017639000072],
              [86.62533736100005, 26.45631907100004],
              [86.69520389800005, 26.418233541000077],
              [86.71360070900005, 26.414564515000095],
              [86.72409102400007, 26.421954244000105],
              [86.73070560700006, 26.43378814800012],
              [86.7381986900001, 26.44371002200002],
              [86.75189294500012, 26.44551869700011],
              [86.78723962400005, 26.43306467700002],
              [86.79643802900006, 26.431514384000096],
              [86.82186283400006, 26.438128967000083],
              [86.84635746300012, 26.452650045000055],
              [86.86568444800014, 26.472442119000036],
              [86.87596805800007, 26.494921367000032],
              [86.9071289470001, 26.51150950100005],
              [86.93515347300013, 26.520289336000033],
              [86.97244795800009, 26.531973368000095],
              [86.98521203600012, 26.540655009000048],
              [87.01544274900004, 26.568973694000064],
              [87.02991215000009, 26.579774068000077],
              [87.04133264100005, 26.580187480000106],
              [87.04443322800012, 26.561170553000025],
              [87.04500166800005, 26.544272359000033],
              [87.05647383700011, 26.494921367000032],
              [87.05668054200004, 26.4948696900001],
              [87.06670577000006, 26.46562082900006],
              [87.08329390500006, 26.43208282500005],
              [87.10628991700014, 26.40474599300002],
              [87.13502201400013, 26.394204],
              [87.18845544500005, 26.399578349000123],
              [87.2190995690001, 26.408104960000045],
              [87.22943485500008, 26.398751526000083],
              [87.23630782100014, 26.383300273000103],
              [87.24529952000012, 26.370226136000056],
              [87.25842533400004, 26.36293975800008],
              [87.3004899500001, 26.345989888000062],
              [87.31402917500009, 26.343767802000073],
              [87.32622481300007, 26.353327942000064],
              [87.3449316820001, 26.389346416000038],
              [87.35640384900006, 26.403712464000037],
              [87.38420577000005, 26.418646953000106],
              [87.41645186400012, 26.426966858000057],
              [87.44962813400014, 26.428620504000023],
              [87.48032393400007, 26.423401185],
              [87.55205082300006, 26.38671091700003],
              [87.58698409000004, 26.378029277000067],
              [87.6239844160001, 26.392912089],
              [87.64874495200013, 26.40999327100006],
              [87.6596411540001, 26.417510071],
              [87.68119022600013, 26.424228007000025],
              [87.6975716550001, 26.41626983700006],
              [87.71090417500011, 26.405676168000085],
              [87.72754398600011, 26.403764140000064],
              [87.74222009300013, 26.410482076000093],
              [87.7494547930001, 26.425726624000035],
              [87.75617273000012, 26.446913961000078],
              [87.76898848500008, 26.451461487000117],
              [87.78593835400011, 26.445983785000024],
              [87.80443851800004, 26.437353821000087],
              [87.8215950930001, 26.437508851000032],
              [87.85208418800005, 26.460659892000123],
              [87.86980920500008, 26.464638978],
              [87.87068770400003, 26.460711569000026],
              [87.89476892100004, 26.442934876000024],
              [87.89730106600007, 26.44345164000005],
              [87.90200362200005, 26.43528676300012],
              [87.90851485200011, 26.417820130000067],
              [87.91476770100007, 26.408259990000076],
              [87.92897871900004, 26.396426086000062],
              [87.96122481300011, 26.378959453000036],
              [87.97548750900012, 26.366557108000066],
              [88.00664839700005, 26.369864400000054],
              [88.04432051600008, 26.405676168000085],
              [88.07418949400011, 26.453941955000104],
              [88.08225101700009, 26.4948696900001],
              [88.07915043200006, 26.507375387000096],
              [88.07982222500004, 26.51755564400007],
              [88.08713624100011, 26.539100004000105],
              [88.10168135600009, 26.581944479000086],
              [88.14663985200008, 26.661216126000014],
              [88.16338301600007, 26.70514109300005],
              [88.16751713100007, 26.725036519000057],
              [88.1690674240001, 26.74400177000011],
              [88.16782718900004, 26.762915344000035],
              [88.15904219600009, 26.802551169000097],
              [88.15532149300003, 26.845597636000022],
              [88.15139408400006, 26.862805888000096],
              [88.14281579600004, 26.878412170000033],
              [88.12043990100005, 26.9088495890001],
              [88.11180993700003, 26.924300842],
              [88.09682377100006, 26.95933746400003],
              [88.07687666900006, 26.991790263000027],
              [88.05594771400007, 27.018041891000067],
              [88.04282190000009, 27.028945618000122],
              [88.02737064700011, 27.03535349500008],
              [88.00949060100004, 27.04563710500007],
              [87.99130049700011, 27.08150055],
              [87.97548750900012, 27.095143128000117],
              [87.97073327700008, 27.10273956300007],
              [87.96918298300005, 27.11080108700007],
              [87.97083663000012, 27.119224345000063],
              [87.9854610590001, 27.148369853000062],
              [87.98933679200007, 27.2183914190001],
              [88.0046627590001, 27.249163088],
              [88.02902429200003, 27.298076477000066],
              [88.03512211100008, 27.322571106000012],
              [88.0325382900001, 27.333888245000068],
              [88.02013594600004, 27.353370260000062],
              [88.01579512500007, 27.364222311000034],
              [88.01476159700007, 27.378071594000076],
              [88.01724206500006, 27.389233704000034],
              [88.02582035300009, 27.412074686000025],
              [88.02959273300007, 27.418740947000046],
              [88.03481205300011, 27.42380523700011],
              [88.03930790200013, 27.42948964400007],
              [88.04163334200007, 27.438067933000085],
              [88.03977299000007, 27.442357077000068],
              [88.03078129100004, 27.450728659000035],
              [88.02809411600009, 27.45512115500013],
              [88.02333988400011, 27.474654847000025],
              [88.02209965000009, 27.48424082500013],
              [88.02333988400011, 27.494912008000128],
              [88.04876468900011, 27.545348206000043],
              [88.11087976100009, 27.639502666000013],
              [88.1348576260001, 27.723166809000062],
              [88.14932702700014, 27.748772482],
              [88.15966231300013, 27.774119772000105],
              [88.15459802200007, 27.815150859000042],
              [88.16658695500013, 27.83359934600007],
              [88.16462325100008, 27.84535573400005],
              [88.15640669800007, 27.85127268500007],
              [88.14302250200012, 27.855716858000065],
              [88.11821781400005, 27.860884501000058],
              [88.10488529500003, 27.8797205610001],
              [88.09749556500003, 27.904008484000073],
              [88.09992435700008, 27.928322246000093],
              [88.11573734600012, 27.947261658000045],
              [88.12669274900009, 27.950439759000105],
              [88.15118737800003, 27.947209982000018],
              [88.16296960500006, 27.946899923000032],
              [88.17485518400008, 27.94976796500002],
              [88.19785119700003, 27.95829457600003],
              [88.37877038600004, 27.982634176000047],
              [88.39975101800007, 27.99472646100004],
              [88.39985437100012, 27.99472646100004],
              [88.39990604700012, 27.994881490000083],
              [88.45576827000008, 28.03152008100004],
              [88.47540531400011, 28.036248474000033],
              [88.50207035300008, 28.02888458300002],
              [88.5171598720001, 28.039581604000105],
              [88.53080245000007, 28.0590119430001],
              [88.55281660900005, 28.078054708000067],
              [88.59400272600004, 28.106605937000026],
              [88.61048750800012, 28.105830790000127],
              [88.63167484600007, 28.083351542000017],
              [88.65203536000013, 28.069398906000018],
              [88.7101196700001, 28.061983337000115],
              [88.73564782700004, 28.055265402000074],
              [88.78014123500003, 28.028341980000064],
              [88.80293054200013, 28.011004537000062],
              [88.8175032960001, 27.994881490000083],
              [88.81771000200013, 27.994881490000083],
              [88.81771000200013, 27.99472646100004],
              [88.81967370600006, 27.977337342000013],
              [88.80975183200007, 27.9444969690001],
              [88.81068200700014, 27.927857158000066],
              [88.81889856000004, 27.91519643200003],
              [88.84277307100012, 27.892407125000133],
              [88.85155806500012, 27.877162577],
              [88.85507206300008, 27.859179179000094],
              [88.85388350400007, 27.843676249000097],
              [88.80566939300007, 27.655108948000063],
              [88.78308679200012, 27.622036031000064],
              [88.76737715600007, 27.586198425000035],
              [88.74815352400003, 27.560127666000042],
              [88.7410221770001, 27.545709941000027],
              [88.74164229300004, 27.531679789000023],
              [88.75755863400008, 27.511448466000033],
              [88.75719689900006, 27.49496368400004],
              [88.75435469600012, 27.464216207000092],
              [88.75978072200007, 27.435070699000065],
              [88.77357832900003, 27.408509013000057],
              [88.79538578300009, 27.385926412000018],
              [88.80820153800005, 27.378381653000062],
              [88.8198287350001, 27.37362742200007],
              [88.8308358160001, 27.36732289600006],
              [88.85202315300006, 27.342363180000078],
              [88.86463220200005, 27.332389628000087],
              [88.89233077000011, 27.315543111000082],
              [88.88463098200003, 27.286345927000056],
              [88.87611560500005, 27.28048567900005],
              [88.86142826300011, 27.270377910000022],
              [88.80117354300006, 27.256425273000033],
              [88.77585209100005, 27.240870667000095],
              [88.75435469600012, 27.21260365800002],
              [88.7384383540001, 27.17978912300002],
              [88.73006677200004, 27.150953674000064],
              [88.73308231500005, 27.148972387000114],
              [88.74257246900004, 27.142737122000042],
              [88.80525598100013, 27.11302317300006],
              [88.82763187700004, 27.097881979000064],
              [88.84080936700008, 27.075247701000094],
              [88.84561527500011, 27.04956451400004],
              [88.84561527500011, 26.994942526000088],
              [88.84561527500011, 26.994839172000056],
              [88.85171309400005, 26.94543650400003],
              [88.86711267100003, 26.964246725000052],
              [88.8864396570001, 26.978974508000064],
              [88.90664514100007, 26.98109324200003],
              [88.92447351100003, 26.96166290300006],
              [88.92695398000012, 26.94941558800012],
              [88.9254036860001, 26.939028626],
              [88.92530033400004, 26.929365133000076],
              [88.9323283280001, 26.9192365520001],
              [88.94276696800011, 26.913707174000123],
              [88.95454919500008, 26.91262196900003],
              [88.96581465700007, 26.915464173000103],
              [88.97532312000004, 26.921717021000077],
              [88.99661381100003, 26.92275054900007],
              [89.02157352700004, 26.912673645000027],
              [89.04487959900007, 26.897119039000117],
              [89.06069258700006, 26.88146108000005],
              [89.07433516500004, 26.856398010000035],
              [89.08244836400007, 26.836037496000117],
              [89.0965043540001, 26.821413066000034],
              [89.12807865500008, 26.813454895000078],
              [89.18461267100014, 26.81056101500009],
              [89.21282800300008, 26.813041484000067],
              [89.24083662900011, 26.819759420000096],
              [89.25261885600008, 26.826787415000084],
              [89.26295414200013, 26.836347555000103],
              [89.27359948700007, 26.84389231400006],
              [89.28636356600009, 26.84497751900004],
              [89.3001611730001, 26.844409078000083],
              [89.34165734900012, 26.854330953000087],
              [89.36889455700003, 26.837358593000076],
              [89.40733809400012, 26.81340321900005],
              [89.44289148000007, 26.797021789000027],
              [89.50541996200008, 26.80368804900003],
              [89.54650272600003, 26.79753855400004],
              [89.5860868740001, 26.784051005],
              [89.61135664900007, 26.76596425400008],
              [89.61347538300004, 26.748549296000036],
              [89.59750736500013, 26.720954081000045],
              [89.60980635600004, 26.712220765000083],
              [89.6283065180001, 26.71253082300005],
              [89.66323978700007, 26.725501607000083],
              [89.68515059500004, 26.72457143100003],
              [89.73873905400006, 26.703280742000047],
              [89.75466966300013, 26.700988568000113],
              [89.76028812700014, 26.700180156],
              [89.80007898000014, 26.700490214000084],
              [89.80405806500005, 26.699766744000087],
              [89.81366988200006, 26.696149394000102],
              [89.81728723200013, 26.6962010700001],
              [89.82209314000005, 26.70100697900004],
              [89.82524540200006, 26.70767323900013],
              [89.8267956950001, 26.71351267500002],
              [89.8267440190001, 26.715683085000094],
              [89.82726078300004, 26.7179051720001],
              [89.82767419500004, 26.722452698000055],
              [89.82974125100003, 26.727620341000048],
              [89.83496057100012, 26.73154775000002],
              [89.83904301000013, 26.731237691000032],
              [89.84700118000012, 26.724829814000103],
              [89.85077355900012, 26.72317616800005],
              [89.85870063400006, 26.722056524000052],
              [89.85992028800013, 26.7218842570001],
              [89.88028080200013, 26.71625152600008],
              [89.89040938400007, 26.714856262000083],
              [89.91211348500008, 26.716716614000077],
              [89.97526208500005, 26.73185780900009],
              [90.0891569420001, 26.741728008000095],
              [90.12719079600004, 26.75139150000011],
              [90.15220218900004, 26.771752014000057],
              [90.17742028900005, 26.832058410000045],
              [90.21090661700009, 26.85148875000003],
              [90.22914839700013, 26.852884013000093],
              [90.26599369300004, 26.851592103000044],
              [90.28444218000004, 26.857069804000034],
              [90.30087528500013, 26.868283590000075],
              [90.31420780500014, 26.88037587500007],
              [90.32857385300014, 26.890659485000057],
              [90.34883101400004, 26.89665395100009],
              [90.38262740100004, 26.891796367000055],
              [90.4752315670001, 26.832420146000047],
              [90.58778283800007, 26.78007192000011],
              [90.71707727100011, 26.767049459000063],
              [90.94449258000003, 26.778869550000096],
              [91.00739546800008, 26.78213897700006],
              [91.01278080700007, 26.784348086000065],
              [91.06206913300014, 26.804566549000057],
              [91.09193811100005, 26.80477325500003],
              [91.12707808500011, 26.800897522000056],
              [91.19818485600013, 26.80234446200005],
              [91.23249800600013, 26.795161438000022],
              [91.26195357300003, 26.779038392000032],
              [91.27600956200007, 26.77407745400008],
              [91.29657678200005, 26.77459421800002],
              [91.31321659300005, 26.77867665700002],
              [91.33006311000014, 26.785497945000074],
              [91.34556604000005, 26.79469635000008],
              [91.35838179600006, 26.806168519],
              [91.37006066900011, 26.824668681000034],
              [91.37812219300008, 26.84280710800006],
              [91.38845747900012, 26.858465068],
              [91.4063375240001, 26.869523824000012],
              [91.42018680900003, 26.871539205000047],
              [91.46059777800014, 26.869368795000057],
              [91.47506717900006, 26.86554473900013],
              [91.4844722900001, 26.852728984000052],
              [91.50741662600007, 26.80802887],
              [91.52064579300003, 26.79759023000007],
              [91.53935266200011, 26.798830465000023],
              [91.5756295170001, 26.81014760300009],
              [91.5937162680001, 26.81076772100006],
              [91.63795129500011, 26.798985494000036],
              [91.6537642830001, 26.797951965000053],
              [91.70213342300013, 26.803481344000076],
              [91.73158898900004, 26.816193746000025],
              [91.79525435400006, 26.853504131000065],
              [91.82512333200009, 26.858465068],
              [91.84393355300006, 26.849370015000133],
              [91.8495146080001, 26.834745586000068],
              [91.8524084880001, 26.818519185000056],
              [91.8630538330001, 26.80477325500003],
              [91.8786601160001, 26.80301625600005],
              [91.88692834500006, 26.814436747000045],
              [91.88589481600008, 26.830869853000095],
              [91.87400923700005, 26.84430572500007],
              [91.89550663300008, 26.853504131000065],
              [91.89550663300008, 26.868283590000075],
              [91.89312951700003, 26.881357727000122],
              [91.90821903500006, 26.885181784000068],
              [91.92568566900007, 26.878670553000106],
              [91.9574149980001, 26.85427927700006],
              [91.97508833800003, 26.84663116500009],
              [92.03585982200013, 26.85484771800013],
              [92.07275679500003, 26.88776560500007],
              [92.08037091600005, 26.921570891000087],
              [92.08391890500008, 26.937323303000127],
              [92.06696903500006, 26.994839172000056],
              [92.06696903500006, 26.994942526000088],
              [92.04970910700007, 27.026826885000062],
              [91.99989302600005, 27.071526998000095],
              [91.98769738800013, 27.104031474000024],
              [91.9879040940001, 27.122273255],
              [91.99079797400009, 27.140773418000023],
              [91.99586226400004, 27.158033346000096],
              [92.00299361200007, 27.172606100000067],
              [92.00578806200014, 27.1761123430001],
              [92.00847131400008, 27.179479065000024],
              [92.02149377500012, 27.19182973300009],
              [92.02707482900013, 27.199839580000074],
              [92.02996871000005, 27.208469544000096],
              [92.03317264800012, 27.227434794000047],
              [92.03678999800007, 27.236478170000012],
              [92.05063928300012, 27.25141265900008],
              [92.08185184800004, 27.2751321410001],
              [92.08877648900011, 27.292340394000078],
              [92.08484908100013, 27.30422597300013],
              [92.02359761663678, 27.446779847112282],
              [91.97508833800003, 27.472432760000018],
              [91.96330611200011, 27.468918763000076],
              [91.90059085495413, 27.459729852655357],
              [91.8565776472989, 27.46623873822671],
              [91.8162322069483, 27.4613571100768],
              [91.77955453390229, 27.45647526576099],
              [91.72709172100008, 27.45994159900009],
              [91.72704146300003, 27.46000457700005],
              [91.70492395000008, 27.468763733000046],
              [91.6802226160001, 27.47284617100003],
              [91.65738163300011, 27.479150696000048],
              [91.6416719980001, 27.49496368400004],
              [91.63288700400005, 27.51165517200009],
              [91.60446496600008, 27.53214487700005],
              [91.59505985500004, 27.54638173400012],
              [91.57325240100005, 27.619710592000033],
              [91.57986698400003, 27.65797699000005],
              [91.62668583200013, 27.716423035000034],
              [91.6349570594208, 27.746570816190285],
              [91.63576961127859, 27.78252481766623],
              [91.60533558693375, 27.810658168996827],
              [91.5660232169979, 27.821073950502466],
              [91.56435452404213, 27.85137236654151],
              [91.6283394780001, 27.852693787000035],
              [91.68013149075769, 27.849823277598603],
              [91.72987134422583, 27.804136158001306],
              [91.82658872441321, 27.807627271770244],
              [91.85637335954294, 27.764539482011514],
              [91.86491418500009, 27.72998809800002],
              [91.90873579900006, 27.731900126000127],
              [91.95224735500011, 27.724820455],
              [91.96800093766346, 27.746278233869482],
              [91.98889765320416, 27.76939841380579],
              [92.06487820550117, 27.76172129397611],
              [92.10615954418942, 27.786080717238843],
              [92.1262935790001, 27.81272206600009],
              [92.23956831900006, 27.865276998000056],
              [92.24918013500007, 27.862641500000038],
              [92.25827518700004, 27.848197937000023],
              [92.27522505700006, 27.81168853700011],
              [92.28876428200005, 27.793085022000056],
              [92.30385380100006, 27.786160380000055],
              [92.31728967300006, 27.80367869100003],
              [92.32917525300013, 27.832927552000072],
              [92.33465295400003, 27.83127390600002],
              [92.33982059800013, 27.815564270000053],
              [92.35005253100007, 27.802541809000033],
              [92.36793257700003, 27.80383372000007],
              [92.37558068800013, 27.821119487000075],
              [92.38105839100012, 27.842461853000074],
              [92.39284061800004, 27.85602691700005],
              [92.40441613800004, 27.85383066900006],
              [92.41733524600005, 27.828948466],
              [92.42756717900005, 27.82117116400009],
              [92.43903934800005, 27.823289897000066],
              [92.47510949800005, 27.846595968000074],
              [92.51815087726021, 27.839468002981643],
              [92.57497681769904, 27.847806414432647],
              [92.59291178341888, 27.868193283595886],
              [92.63646812873851, 27.89536981004999],
              [92.68367428669768, 27.910450219011963],
              [92.71077012957788, 27.949702392409918],
              [92.73639150917766, 27.98590893651867],
              [92.70134891800006, 28.025241394000133],
              [92.70134891800006, 28.037824606000058],
              [92.68925663200014, 28.048314921],
              [92.65422001100012, 28.052087301000128],
              [92.63892378800006, 28.057487488000092],
              [92.63727014200003, 28.071982728000123],
              [92.65484012900009, 28.105830790000127],
              [92.67861128800007, 28.133064270000105],
              [92.70786014900011, 28.155414328000106],
              [92.7700785720001, 28.192182108000097],
              [92.77917362500011, 28.195902812],
              [92.78289432800011, 28.190941874000046],
              [92.78537479700009, 28.183293762000076],
              [92.79023238100007, 28.178901266000068],
              [92.80532190000008, 28.17802276700003],
              [92.81989465400005, 28.17926300100008],
              [92.8347774660001, 28.183526306000132],
              [92.85028039600013, 28.19194956500003],
              [92.8653699140001, 28.20520457000002],
              [92.88955448400009, 28.23582285600004],
              [92.90381717900004, 28.2496979780001],
              [92.92200728300008, 28.25863800100005],
              [92.96035119600003, 28.270213521000088],
              [92.97492395000006, 28.28230580700007],
              [93.04639880818196, 28.302097099545048],
              [93.12982812476821, 28.325961566073488],
              [93.20782489381371, 28.340539283245555],
              [93.21807344565363, 28.39464655767386],
              [93.1862858334245, 28.431995228097378],
              [93.21883846222534, 28.457435846387227],
              [93.25906765301328, 28.496023260000364],
              [93.2869721652333, 28.520517242676647],
              [93.30284340070244, 28.556921073348917],
              [93.31717003715039, 28.603462550497838],
              [93.35543239724171, 28.624065359777703],
              [93.44621301300003, 28.671894430000023],
              [93.55173628800009, 28.67894826200005],
              [93.60713342300005, 28.672204488000105],
              [93.62553023300006, 28.67235951800005],
              [93.64341027900008, 28.680240174000105],
              [93.66490848182954, 28.690238755807428],
              [93.70552535000007, 28.69189320900007],
              [93.72247522000009, 28.696647441000053],
              [93.78174379684887, 28.68050383781251],
              [93.86307969177443, 28.704870831024095],
              [93.92778566056765, 28.68275160171495],
              [93.96109345404737, 28.72994349590268],
              [93.9815905577272, 28.768130860141966],
              [93.99313607399837, 28.80188742309345],
              [93.99201949100012, 28.844648743000064],
              [94.01144982900013, 28.85302032500003],
              [94.02684940600011, 28.864182435000075],
              [94.07947398050715, 28.883072105010925],
              [94.1353958914097, 28.897788397353693],
              [94.17365825150097, 28.930164240507835],
              [94.2501829716835, 28.933107498976327],
              [94.29138859024334, 28.977256376004746],
              [94.34731050114596, 29.024348511501685],
              [94.30904814105469, 29.059667613124404],
              [94.27078578096348, 29.097929973215642],
              [94.28750533100003, 29.147937724000073],
              [94.32378218600007, 29.146025696000052],
              [94.33577111900013, 29.149617208000038],
              [94.34631311100009, 29.1590739950001],
              [94.36253951000009, 29.185325623000026],
              [94.37287479700012, 29.19630686500001],
              [94.39643925000013, 29.207081400000035],
              [94.42238081900007, 29.210492045000066],
              [94.47498742700003, 29.210802104000052],
              [94.49824182200007, 29.21522043900005],
              [94.51477828000009, 29.22105987600004],
              [94.52862756400003, 29.2312401330001],
              [94.5826811120001, 29.302915345000073],
              [94.59994104000009, 29.316635437000016],
              [94.6304301350001, 29.319451803000064],
              [94.66846399000013, 29.306610209000084],
              [94.70422408000013, 29.284699402000044],
              [94.75641727800013, 29.230516663000017],
              [94.76768273900007, 29.21385101300008],
              [94.76148156800008, 29.174706116000053],
              [94.77657108500011, 29.16669626900007],
              [94.79879195200004, 29.1664378870001],
              [94.81543176300005, 29.16886667900006],
              [94.85408573500007, 29.17000356000007],
              [94.89129276600005, 29.160495097000094],
              [94.98906457600003, 29.15398386700012],
              [95.04766564900007, 29.140806377000033],
              [95.09903202400011, 29.113779603000083],
              [95.11691206900008, 29.108095195000047],
              [95.19153283800006, 29.096829733000092],
              [95.19969771300003, 29.094245911000073],
              [95.2078625900001, 29.089595032000105],
              [95.21282352700013, 29.08186940500012],
              [95.21406376100009, 29.07308441200003],
              [95.21633752500009, 29.06499705000003],
              [95.22491581200012, 29.05936431900001],
              [95.2815531820001, 29.052672221000094],
              [95.36740605062847, 29.03649616327051],
              [95.42982403198397, 29.046524645630395],
              [95.48757683710141, 29.068994487006023],
              [95.51130660000013, 29.131788839000095],
              [95.52143518100007, 29.13786082000003],
              [95.52267541500004, 29.161192729000064],
              [95.51192671700011, 29.19754709900006],
              [95.51533736200014, 29.209432679000074],
              [95.55016727700007, 29.212481588000017],
              [95.55202762800008, 29.220129700000072],
              [95.55068404100012, 29.230284119000046],
              [95.55378462800007, 29.239043275000128],
              [95.56442997300007, 29.2456061810001],
              [95.57290490800006, 29.247259827000065],
              [95.58168990100006, 29.24746653300012],
              [95.59233524600006, 29.249688619000025],
              [95.64669738938943, 29.22835044810863],
              [95.71716496895556, 29.218283651027733],
              [95.7473653601981, 29.27365103497256],
              [95.74478072100004, 29.340432435000068],
              [95.77640669800007, 29.345548401000073],
              [95.79594038900007, 29.352886455000046],
              [95.86313352662813, 29.32398502037684],
              [95.95373470035588, 29.35921881015993],
              [96.01413548284108, 29.364252208700393],
              [96.07453626532634, 29.369285607240855],
              [96.14196578000008, 29.368466899000097],
              [96.15095747900011, 29.35407501200008],
              [96.16604699800013, 29.303173726000054],
              [96.17627893100013, 29.28645640100011],
              [96.20542443800014, 29.256949158000097],
              [96.23529341600005, 29.241213684000016],
              [96.26784956900008, 29.24173044900006],
              [96.30412642400006, 29.261212464000053],
              [96.32324670400004, 29.275010071000096],
              [96.33709598900009, 29.27971262700008],
              [96.34991174300006, 29.274234924],
              [96.36624149600004, 29.257233379000056],
              [96.36686161300008, 29.24421091700013],
              [96.34236698400014, 29.21064707500001],
              [96.32748417200008, 29.180442200000087],
              [96.31642541500008, 29.171863912000063],
              [96.21007531700008, 29.145767314000082],
              [96.19364221300003, 29.13693064400009],
              [96.1835136310001, 29.123778992000027],
              [96.17462528500005, 29.108844503000043],
              [96.17595371463305, 29.017353609711428],
              [96.19532275757172, 28.941105845485463],
              [96.24858762565306, 28.945343306324006],
              [96.29465549772947, 28.99232448388489],
              [96.36656829155606, 29.036536563468914],
              [96.45760542900013, 28.99458791100001],
              [96.45119755100012, 28.98138458300012],
              [96.45212772700006, 28.970377502000034],
              [96.46008589700011, 28.963349507000103],
              [96.47465865100008, 28.962057597000054],
              [96.49222863800003, 28.94800160700005],
              [96.50039351400005, 28.929243062000054],
              [96.51083215400013, 28.885524801000074],
              [96.52375126100003, 28.864414979000045],
              [96.57666792800006, 28.808526917000066],
              [96.59258426900004, 28.757884013000094],
              [96.59800971353144, 28.709910398443995],
              [96.50104350465409, 28.687631303142155],
              [96.50237514126326, 28.644476217418358],
              [96.40901887262294, 28.558928647938785],
              [96.33645875408492, 28.47966681390912],
              [96.30185249373439, 28.420710938634112],
              [96.36964414401973, 28.378115826943503],
              [96.44112658162652, 28.39541577691665],
              [96.49522587100006, 28.42147043900009],
              [96.51238244700005, 28.428808492000073],
              [96.5615177204665, 28.44729288316006],
              [96.60442611830537, 28.444534241434948],
              [96.71692392905247, 28.436539447625634],
              [96.89788863200005, 28.354704489000042],
              [96.93395878200005, 28.336617737000026],
              [96.96579146400012, 28.330468242000066],
              [96.9974174400001, 28.337082825000053],
              [97.03297082600005, 28.357029928000074],
              [97.07844608600004, 28.3751425170001],
              [97.11554976400004, 28.366564230000066],
              [97.18272912600008, 28.31499115000007],
              [97.19327111900003, 28.311399638000083],
              [97.20277958200012, 28.31155466700004],
              [97.21053104700013, 28.308092346000066],
              [97.22076298000007, 28.28339101200008],
              [97.22965132700011, 28.274606018000085],
              [97.2852551680001, 28.235667827],
              [97.32349572800013, 28.217477723000073],
              [97.32866337100012, 28.190011699000095],
              [97.29889774600014, 28.12924021400009],
              [97.29290328000008, 28.095082092],
              [97.3065458580001, 28.0696572880001],
              [97.3551217050001, 28.02304514600003],
              [97.36225305200003, 27.994881490000083],
              [97.35677535000013, 27.98056711800008],
              [97.34003218600003, 27.951809184000084],
              [97.33569136600005, 27.93560862200006],
              [97.33631148300009, 27.91318105100008],
              [97.33817183500008, 27.90155385300004],
              [97.33352095600003, 27.894164124000028],
              [97.3149174400001, 27.884603983000105],
              [97.29290328000008, 27.877550151],
              [97.28866581300014, 27.88434560200004],
              [97.28804569500005, 27.8977556360001],
              [97.27636682200011, 27.910338847],
              [97.26065718600006, 27.912044170000073],
              [97.24122684700006, 27.907858379000047],
              [97.2229333900001, 27.899719341000022],
              [97.21094445800003, 27.88951324500006],
              [97.19802535100013, 27.87326100700004],
              [97.1821090090001, 27.857267151000073],
              [97.13177616400003, 27.816856181],
              [97.12319787600006, 27.812153625000022],
              [97.11244917900007, 27.809208069000036],
              [97.10604130000013, 27.805539043000024],
              [97.09818648300006, 27.791017965],
              [97.09219201700006, 27.785488587000074],
              [97.07234826700005, 27.779184062000084],
              [97.06532027200006, 27.773990581000064],
              [97.06201298100007, 27.763345235000074],
              [97.06035933400011, 27.750451965000067],
              [97.05674198400004, 27.746782939000056],
              [97.05054081200007, 27.746782939000056],
              [97.03617476400007, 27.742920068000032],
              [97.00403202400008, 27.73427724200006],
              [96.99090621000005, 27.72662913000009],
              [96.95700647000012, 27.68807851200002],
              [96.93953983600011, 27.6740225220001],
              [96.89974898300005, 27.649476217000128],
              [96.88352258400005, 27.636324565000066],
              [96.87019006400004, 27.61909047500008],
              [96.86212854000007, 27.599298401000098],
              [96.86202518800013, 27.57836944600011],
              [96.86615930200003, 27.56844757100002],
              [96.87732141200007, 27.553073832000038],
              [96.88031864400011, 27.543849589000033],
              [96.88104211500007, 27.534392802000056],
              [96.88465946500008, 27.515840963000116],
              [96.88848352100013, 27.507185160000077],
              [96.89024051900009, 27.492483215000064],
              [96.87701135200007, 27.463079325000095],
              [96.8813521730001, 27.44411407500003],
              [96.90512333200013, 27.408405660000128],
              [97.06790409400008, 27.21709950800006],
              [97.09549930900005, 27.19126129200002],
              [97.10128706900014, 27.183303121000066],
              [97.10170048100014, 27.165268046000065],
              [97.1043876550001, 27.15601796500006],
              [97.11172570800005, 27.14883494100009],
              [97.12082076100006, 27.143925680000066],
              [97.12929569600004, 27.137879537000018],
              [97.13477339700012, 27.12733754500006],
              [97.13301639900004, 27.119586080000047],
              [97.1228878170001, 27.093696188000123],
              [97.1191671140001, 27.08728831000009],
              [97.10604130000013, 27.08258575400002],
              [97.09797977800014, 27.085893046000095],
              [97.08991825400005, 27.09219757100003],
              [97.07720585100009, 27.09648671500007],
              [97.06697391800003, 27.095246480000057],
              [97.05882660700013, 27.092075635000057],
              [97.0478536380001, 27.087805074000116],
              [97.03803511600006, 27.087029928],
              [97.02676965400008, 27.091474101000117],
              [97.01891483600014, 27.098708802000075],
              [97.01188684100003, 27.107028707000055],
              [97.00299849500004, 27.11452179000007],
              [96.86533247900013, 27.1716242480001],
              [96.84269820200007, 27.188522441000075],
              [96.84176802600012, 27.204387106000084],
              [96.85127649000003, 27.221181946000073],
              [96.85964807200008, 27.240715637000065],
              [96.85375695800008, 27.248725485000037],
              [96.82171757000009, 27.273065084000066],
              [96.80993534400005, 27.285777487000118],
              [96.78916141700012, 27.31797190400006],
              [96.77634566300003, 27.330632630000096],
              [96.75887902800008, 27.341743063000123],
              [96.72415246600008, 27.35626414000005],
              [96.70523889200012, 27.360759989000073],
              [96.68725549300012, 27.361741842000058],
              [96.67588667900003, 27.357659404000046],
              [96.65924686700004, 27.341433004000024],
              [96.64901493300005, 27.336213685000118],
              [96.63640588400011, 27.335541891000034],
              [96.62927453600008, 27.338694153000077],
              [96.62317671800014, 27.34365509100003],
              [96.61418501800006, 27.34840932300004],
              [96.58689986200005, 27.353576966000034],
              [96.57604781100014, 27.34541208900002],
              [96.5674695240001, 27.328307191000064],
              [96.54731571500014, 27.306448059000033],
              [96.53181278500011, 27.298541565000065],
              [96.51093550700006, 27.292495422000044],
              [96.49005822700008, 27.290738424000054],
              [96.47465865100008, 27.29538930300002],
              [96.40778934700012, 27.29817983000008],
              [96.14258589700006, 27.25751047800013],
              [96.07416630100005, 27.22986358600012],
              [96.01318811100009, 27.190796204000023],
              [95.97484419800008, 27.142892151000083],
              [95.93836063700007, 27.079898580000062],
              [95.91644983000003, 27.051373189000017],
              [95.88885461500013, 27.0270335900001],
              [95.86146610500009, 27.014217835000025],
              [95.8049320880001, 27.00476104800005],
              [95.77795699100005, 26.995149231000042],
              [95.73496219900011, 26.947296855000033],
              [95.70922733600003, 26.907454326000035],
              [95.69930546100011, 26.896188863000063],
              [95.68607629400003, 26.89127960300003],
              [95.63998091600007, 26.88642201800009],
              [95.62427128100012, 26.880737610000054],
              [95.61331587700005, 26.867921855000063],
              [95.60339400200013, 26.844254049000043],
              [95.59130171700008, 26.823738505000065],
              [95.57476525900006, 26.81614207000011],
              [95.55440474400012, 26.816607157000035],
              [95.53135705600005, 26.820276185000026],
              [95.4898092040001, 26.810716044000046],
              [95.46273075300013, 26.777178040000123],
              [95.43999312400007, 26.73537180600006],
              [95.4106409100001, 26.701627096],
              [95.3926575110001, 26.691756898],
              [95.31596968600007, 26.66907094300005],
              [95.27896936100012, 26.65294789700006],
              [95.26057255100011, 26.647625224000123],
              [95.24693311800007, 26.64890392100004],
              [95.23907515500008, 26.649640605000073],
              [95.22326216700009, 26.67036285400009],
              [95.20486535700007, 26.66757232700003],
              [95.19556359900014, 26.660751038000072],
              [95.18161096200004, 26.641682435000106],
              [95.1732393800001, 26.63382761700008],
              [95.16342085800011, 26.62974517800005],
              [95.14140669800014, 26.624990946000068],
              [95.13262170500013, 26.620805155000127],
              [95.12280318300009, 26.611606751000025],
              [95.11908247900004, 26.604217021000025],
              [95.1158785400001, 26.575639954000067],
              [95.11618859900005, 26.56933542900005],
              [95.11494836400004, 26.562565816000117],
              [95.10957401600007, 26.55130035400005],
              [95.09923872900009, 26.536107484000027],
              [95.06988651600011, 26.506238506],
              [95.05438358600009, 26.494921367000032],
              [95.04063765500013, 26.47559438100008],
              [95.04260135900006, 26.459678040000043],
              [95.0617216390001, 26.426605123000073],
              [95.06606245900014, 26.407433167000065],
              [95.06420210800013, 26.392602031000123],
              [95.05045617700011, 26.359064026000013],
              [95.04363488800004, 26.327696432],
              [95.04177453600005, 26.287595520000096],
              [95.04632206200006, 26.24795969700004],
              [95.05872440600007, 26.217677307000102],
              [95.06637251800004, 26.2110110470001],
              [95.07453739500005, 26.208323873000055],
              [95.08280562300007, 26.20661855100009],
              [95.09076379400005, 26.202691142000035],
              [95.09448449700005, 26.195043030000065],
              [95.08973026500007, 26.187601624000123],
              [95.08239221200006, 26.179798483000113],
              [95.07836145100009, 26.171323548000103],
              [95.08817997300008, 26.10409250900004],
              [95.10171919800013, 26.09339548800004],
              [95.13747928900005, 26.082956848],
              [95.1500883380001, 26.070967916000043],
              [95.15122522000007, 26.04993560800004],
              [95.13954634600003, 26.02993682900008],
              [95.10823042800013, 25.99510691300013],
              [95.0658557540001, 25.953817444000023],
              [95.04942264900012, 25.943740540000064],
              [95.01200891200006, 25.93144154900004],
              [95.0006400960001, 25.922036438000063],
              [94.99402551300005, 25.90043569],
              [94.99319869000004, 25.88095367400011],
              [95.01345585200005, 25.777704163000053],
              [95.01531620300005, 25.755121562000014],
              [95.00880497300011, 25.73713816300004],
              [94.99991662700006, 25.731557109000036],
              [94.97862593600007, 25.72907664000006],
              [94.96901412000005, 25.725614319],
              [94.96146936100013, 25.717966207000032],
              [94.87165572100014, 25.59802520800004],
              [94.86803837100007, 25.59471791600005],
              [94.85749637900005, 25.589343567000085],
              [94.8534656170001, 25.58603627500007],
              [94.85294885300004, 25.58076528000005],
              [94.86101037600014, 25.571411846],
              [94.86028690600006, 25.567174378000047],
              [94.85077844300014, 25.56278188100005],
              [94.83103804600012, 25.56247182300008],
              [94.82235640500005, 25.559112854000077],
              [94.80799035600012, 25.542628072000085],
              [94.78235884600008, 25.504594219000055],
              [94.76437544800007, 25.49167511000003],
              [94.74577193200014, 25.486610820000053],
              [94.71114872200013, 25.482786764000124],
              [94.69202844200004, 25.476327210000065],
              [94.65947229000005, 25.45550160800012],
              [94.6503600370001, 25.446649705000098],
              [94.63053348800008, 25.427389629000075],
              [94.60800256400012, 25.394626770000073],
              [94.55012496000006, 25.245281881],
              [94.55332889800013, 25.20414744000003],
              [94.57689335200013, 25.173606670000126],
              [94.61296350100014, 25.1613593550001],
              [94.65327111800008, 25.15412465400003],
              [94.68913456300004, 25.138518372000092],
              [94.70680790300014, 25.10994130500002],
              [94.71383589700014, 25.068264262000085],
              [94.7085649010001, 25.025889587000094],
              [94.68975467900003, 24.99509043400012],
              [94.67352828000008, 24.974807434000112],
              [94.65482141100011, 24.889153748000027],
              [94.63911177600005, 24.862798767000058],
              [94.59901086400004, 24.813473612000067],
              [94.59322310400006, 24.7837855020001],
              [94.59322310400006, 24.765931295000044],
              [94.58950240100006, 24.747250264000073],
              [94.58154423100012, 24.73011952800003],
              [94.56945194600013, 24.716399434],
              [94.55570601400007, 24.70885467600006],
              [94.54340702300004, 24.70733022000003],
              [94.53100468000008, 24.70748525000006],
              [94.51632857300007, 24.704953105000087],
              [94.50795699100013, 24.689010925000062],
              [94.48707971200014, 24.620462138000036],
              [94.47498742700003, 24.597388611000056],
              [94.43023563600008, 24.570904439000074],
              [94.4184534100001, 24.56031077100009],
              [94.41080529800013, 24.54594472300009],
              [94.39705936700005, 24.495069275000063],
              [94.38186649600004, 24.486310120000084],
              [94.37039432800003, 24.47773183300005],
              [94.36367639200012, 24.46582041500001],
              [94.36119592300014, 24.425409444000124],
              [94.35220422300011, 24.413937277000016],
              [94.34000858600007, 24.40600494400006],
              [94.32874312400003, 24.39448110000002],
              [94.32832971200003, 24.388486634000103],
              [94.33174035600013, 24.371097514000084],
              [94.33070682800013, 24.36285512300013],
              [94.32367883300003, 24.35466440800009],
              [94.30280155400004, 24.341021831000106],
              [94.29536014800004, 24.332598572],
              [94.28998580000007, 24.316759746000017],
              [94.28688521300006, 24.283066712000064],
              [94.28275109900011, 24.26642690100003],
              [94.23396854600009, 24.160335185000108],
              [94.22218632100004, 24.122637228000073],
              [94.21846561700005, 24.086670431000087],
              [94.21412479700007, 24.069177959000044],
              [94.20368615700005, 24.05775746700003],
              [94.19913863200003, 24.048093974000025],
              [94.19386763500006, 24.00967254700008],
              [94.1902502850001, 23.995280660000063],
              [94.14487837800004, 23.93887583400003],
              [94.13505985500007, 23.919006246000052],
              [94.13361291500007, 23.899162496000045],
              [94.13505985500007, 23.877303365],
              [94.13185591700011, 23.856968689000084],
              [94.12885926700005, 23.853904873000076],
              [94.11686975100014, 23.84164662700003],
              [94.09971317600008, 23.842628479000084],
              [94.08534712700009, 23.857511292000126],
              [94.07108443200008, 23.876114808000082],
              [94.05506473800006, 23.88794871],
              [93.99791060400014, 23.916965027000074],
              [93.97506962100005, 23.920918274000044],
              [93.94054976400014, 23.928876445000114],
              [93.91233443200008, 23.93900502500007],
              [93.88318892500007, 23.94530955000009],
              [93.80371057200006, 23.936059469000057],
              [93.78283329300007, 23.94546457900013],
              [93.74304244000007, 23.995280660000063],
              [93.71110640500012, 24.005460917000036],
              [93.66046350100004, 24.011222839000098],
              [93.61240441900009, 24.00905243000001],
              [93.58801314300007, 23.995228984000036],
              [93.58563602700008, 23.98729665100008],
              [93.58181197200008, 23.979596863],
              [93.57695438700006, 23.97300811800001],
              [93.57106327400004, 23.968021343000046],
              [93.5613481040001, 23.965695903000025],
              [93.55525028500006, 23.97099273700006],
              [93.54997928900013, 23.978020732000076],
              [93.54346805900013, 23.980888774000064],
              [93.52682824700014, 23.97538523300007],
              [93.49571903500009, 23.959132996000037],
              [93.47484175700009, 23.957505189000088],
              [93.45665165200006, 23.959959819000076],
              [93.44900354000009, 23.96892568],
              [93.44559289600005, 23.98161224400006],
              [93.4391850180001, 23.995228984000036],
              [93.40652551300013, 24.025847270000057],
              [93.39650028500012, 24.03752614400004],
              [93.36828495300006, 24.078479716000075],
              [93.34854455600009, 24.088892517000104],
              [93.32218957500004, 24.080055847],
              [93.30968387900003, 24.063984477000034],
              [93.30296594200013, 24.041143494000025],
              [93.30255946900013, 24.035774655000083],
              [93.30110559100012, 24.016571350000035],
              [93.30296594200013, 23.995280660000063],
              [93.30813358600011, 23.977503968000022],
              [93.31609175600005, 23.961096700000084],
              [93.33758915200013, 23.928411357000087],
              [93.34596073400007, 23.918696188000055],
              [93.35185184800008, 23.913916117000056],
              [93.35598596200003, 23.906991475000083],
              [93.3591899010001, 23.89094594300012],
              [93.35825972500004, 23.85526336700012],
              [93.37479618400005, 23.739017232000023],
              [93.4063188070001, 23.719121806000132],
              [93.41231327300011, 23.708709005000102],
              [93.42595585100014, 23.69080312100003],
              [93.43029667200011, 23.6803386430001],
              [93.43236372900009, 23.647317404000106],
              [93.40022098800011, 23.454021709000088],
              [93.3998075770001, 23.426090597000027],
              [93.4059053960001, 23.367670390000043],
              [93.4077657470001, 23.35637908900007],
              [93.40724898300004, 23.34725819900008],
              [93.40373498600007, 23.338757426000072],
              [93.38420129400009, 23.313125916000033],
              [93.37789676900007, 23.29682200100008],
              [93.37644982900008, 23.279484559000068],
              [93.38079065000005, 23.237264913],
              [93.37272912600008, 23.169827169000072],
              [93.37303918400005, 23.15422088700005],
              [93.37520959500006, 23.142154439000066],
              [93.37489953600004, 23.129726257000087],
              [93.33335168500008, 23.05228912300005],
              [93.31826216700006, 23.033659770000085],
              [93.29883182800006, 23.01795013400003],
              [93.27278690600008, 23.005909526000053],
              [93.24653527900006, 23.00448842400006],
              [93.22555464700008, 23.020378927000067],
              [93.21211877500014, 23.03988678000006],
              [93.19651249200007, 23.053839417000077],
              [93.17708215400012, 23.058438619000114],
              [93.15238081900009, 23.049937846000105],
              [93.14008182800006, 23.031902771000105],
              [93.13822147700006, 23.005263570000054],
              [93.14318241400008, 22.97751332600002],
              [93.15114058400007, 22.95622263600005],
              [93.17108768700007, 22.92043670700012],
              [93.17739221200009, 22.900205384000017],
              [93.17553186100008, 22.881705220000086],
              [93.16106246000004, 22.86098297200006],
              [93.12530236800012, 22.821553854000044],
              [93.11589725800007, 22.79840281200005],
              [93.11238326000012, 22.799953105000085],
              [93.07951704900012, 22.772719626000068],
              [93.07083540900004, 22.69287953700008],
              [93.07393599400007, 22.671898905000077],
              [93.08189416500005, 22.652830302000027],
              [93.10442509000006, 22.61593332900007],
              [93.11052290900011, 22.596347962000053],
              [93.10907596900012, 22.57469553600008],
              [93.09822391800009, 22.535266419000052],
              [93.09915409300004, 22.511960347000027],
              [93.10959273300006, 22.479042460000088],
              [93.11786096200012, 22.46286773700008],
              [93.15351770000012, 22.427521057],
              [93.16592004400007, 22.38659332300007],
              [93.17429162700006, 22.26939117400012],
              [93.17367150900009, 22.259417623000033],
              [93.16902063000003, 22.246911927000028],
              [93.16126916500008, 22.24251943000003],
              [93.15145064300003, 22.24096913700002],
              [93.12974654200013, 22.23161570200007],
              [93.12478560400007, 22.23228749600004],
              [93.12354537000004, 22.230685527],
              [93.12313195800004, 22.218386536000068],
              [93.14173547400009, 22.18727732400002],
              [93.11951460800009, 22.180972799000088],
              [93.10432173700013, 22.187173970000075],
              [93.09057580600012, 22.197147522000094],
              [93.07248905400007, 22.202470195000032],
              [93.04582401500005, 22.20686269100004],
              [93.03641890500006, 22.206242575000076],
              [93.02453332500005, 22.201901754000076],
              [93.02236291600008, 22.19621734600004],
              [93.02391320800007, 22.18882761700003],
              [93.02256962100012, 22.120976461000097],
              [93.0254635010001, 22.1129149370001],
              [93.00748010300003, 22.1059386190001],
              [92.99518111200007, 22.103251445000083],
              [92.98546594300012, 22.095965068000012],
              [92.9671724860001, 22.06268544600006],
              [92.96531213400004, 22.049559632000083],
              [92.96841272000012, 22.03617543500006],
              [92.97492395000006, 22.02330800400007],
              [92.97792118400008, 22.016486715000028],
              [92.97957482900006, 22.009355367000083],
              [92.97988488800013, 22.00227569600004],
              [92.97895471200007, 21.995351054000068],
              [92.97709436100007, 21.993025615000036],
              [92.97492395000006, 21.990906881000072],
              [92.96810266200004, 21.98723785400007],
              [92.9616947830001, 21.98687611900006],
              [92.95559696500004, 21.98961497],
              [92.95032596900006, 21.995351054000068],
              [92.93740686000007, 22.013024394000055],
              [92.92097375600014, 22.02180938700006],
              [92.90619429500009, 22.01731353800004],
              [92.89864953600005, 21.995402731000084],
              [92.88924442500007, 21.966722311000083],
              [92.87746219900009, 21.95700714200005],
              [92.86702356000006, 21.966515605000026],
              [92.8620626230001, 21.995402731000084],
              [92.85389774600009, 22.024134827000083],
              [92.83612105300006, 22.046510722000065],
              [92.77162886600013, 22.104181621000052],
              [92.7080668540001, 22.14795155800003],
              [92.68377893100006, 22.154307760000066],
              [92.67396040900007, 22.147073059],
              [92.67106652800004, 22.133895569000018],
              [92.6746838790001, 22.105576884000115],
              [92.67396040900007, 22.0952415980001],
              [92.6695162360001, 22.092657777000014],
              [92.66455529800004, 22.093846334000133],
              [92.66207482900006, 22.094776510000074],
              [92.65618371600004, 22.075294495],
              [92.65608036300006, 22.060566711],
              [92.65835412600006, 22.04656239800009],
              [92.65835412600006, 22.032816468000036],
              [92.65091272000012, 22.019173890000033],
              [92.63985396300012, 22.013386129000068],
              [92.6275549720001, 22.012352600000085],
              [92.61525598200006, 22.0087869260001],
              [92.60388716700004, 21.995402731000084],
              [92.59799605400008, 21.989304912000122],
              [92.59127811700006, 21.98424062200006],
              [92.58383671100012, 21.98031321200007],
              [92.57587854000013, 21.977574362000027],
              [92.57515507000005, 21.98656606100009],
              [92.57308801300007, 21.995402731000084],
              [92.55996219900004, 22.061341859],
              [92.5373279210001, 22.128624573000067],
              [92.54931685400004, 22.138494772000072],
              [92.56419966700008, 22.1383397420001],
              [92.57556848200005, 22.143300680000053],
              [92.57701542200004, 22.168673808000065],
              [92.51893111200008, 22.49537221300004],
              [92.51738081900004, 22.512580465],
              [92.50456506400008, 22.54379303000009],
              [92.50084436000009, 22.560536194000022],
              [92.50291141800011, 22.618620504000106],
              [92.49588342300012, 22.695618388000028],
              [92.49154260200004, 22.711069641000037],
              [92.48069055200011, 22.726159159000034],
              [92.45371545400008, 22.74796661400005],
              [92.44203658000009, 22.762926941000032],
              [92.4350085860001, 22.793286846000072],
              [92.42632694500003, 22.871059876000103],
              [92.4118575440001, 22.887932231],
              [92.37868127500008, 22.900437928000073],
              [92.35987105300006, 22.92661204000008],
              [92.3522229410001, 22.96033091300005],
              [92.3530497650001, 23.02991322800007],
              [92.3276249590001, 23.171429138000022],
              [92.32855513500004, 23.211194153000022],
              [92.3326892500001, 23.226257833000105],
              [92.35067264900005, 23.26098439500005],
              [92.35749393700013, 23.278941956000025],
              [92.35687382000003, 23.289122213],
              [92.3522229410001, 23.29883738200003],
              [92.3470552980001, 23.315425517000037],
              [92.34674523900009, 23.325295715000024],
              [92.34953576700013, 23.344958598000076],
              [92.34860559100008, 23.354105326000038],
              [92.34488488800008, 23.359117940000104],
              [92.33165572100012, 23.368652243],
              [92.32669478400004, 23.375266825],
              [92.32535119700009, 23.382165629000085],
              [92.32690149000013, 23.39601491300003],
              [92.32535119700009, 23.403507995000083],
              [92.31977014200004, 23.412163798000037],
              [92.30674768100005, 23.423868510000105],
              [92.30147668500007, 23.431800842000072],
              [92.29682580600013, 23.446580302000072],
              [92.29103804500005, 23.49528534000011],
              [92.25279748500009, 23.609309388],
              [92.25000695800003, 23.642614848000036],
              [92.26168583200007, 23.68511871300008],
              [92.25973660500011, 23.702640572000078],
              [92.25930871600013, 23.706486918000095],
              [92.23874149600005, 23.7168480430001],
              [92.22210168500004, 23.70777882900005],
              [92.20938928200007, 23.661605937],
              [92.19429976400005, 23.648144226000042],
              [92.18076053900012, 23.665378317000105],
              [92.17063195800006, 23.70364471400002],
              [92.15078820800005, 23.731653341000126],
              [92.10841353400014, 23.718243307000094],
              [92.09218713400003, 23.701345114],
              [92.05963098100005, 23.659487203000126],
              [92.04237105300007, 23.64556040500004],
              [92.01901330600003, 23.640056865000034],
              [92.00351037700005, 23.647420757000035],
              [91.96165246600009, 23.691139018000015],
              [91.94914677000008, 23.709768372000084],
              [91.93664107300009, 23.723540141000043],
              [91.9226884360001, 23.72297170000006],
              [91.91648726400007, 23.7098717250001],
              [91.91442020700003, 23.68832265300007],
              [91.91597050000007, 23.650159607000077],
              [91.94232548000008, 23.534430237000052],
              [91.94077518800009, 23.495181986000077],
              [91.91814091000003, 23.459938660000105],
              [91.9051184490001, 23.446631979000088],
              [91.88909875500013, 23.43593495800009],
              [91.83380497300004, 23.413894959000103],
              [91.81768192600003, 23.40092417400008],
              [91.79163700400005, 23.368342183000024],
              [91.7625948490001, 23.321549174],
              [91.74368127400004, 23.27232737300004],
              [91.74915897700004, 23.232407329000083],
              [91.76393843600005, 23.200626323000037],
              [91.77902795400013, 23.131767476000036],
              [91.79194706200013, 23.101149190000015],
              [91.79556441200003, 23.08949615500005],
              [91.7913269450001, 23.080375265000086],
              [91.77623742700007, 23.065259909000062],
              [91.77375695800004, 23.06489817300006],
              [91.76424849400013, 23.065647481000084],
              [91.76094120300013, 23.065492453000033],
              [91.75598026500006, 23.061539206000063],
              [91.75556685400005, 23.05683665000008],
              [91.75629032400008, 23.052159933000027],
              [91.75505009000011, 23.048232524000056],
              [91.73830692600006, 23.02466807100005],
              [91.73127893100008, 23.017330018000038],
              [91.7144324140001, 23.00311899800009],
              [91.70699100800005, 22.995367534000067],
              [91.69469201700014, 22.98813283300011],
              [91.66761356600006, 22.982629293000016],
              [91.65407434100007, 22.978055929000064],
              [91.64694299300004, 22.97658315000008],
              [91.63991499800005, 22.978004253000066],
              [91.63278365100012, 22.98030385300008],
              [91.62575565600008, 22.98154408800012],
              [91.61666060400012, 22.978055929000064],
              [91.61200972500006, 22.969839376000053],
              [91.60828902200006, 22.96033091300005],
              [91.60239790900005, 22.95296702100005],
              [91.58606815600012, 22.94446624800004],
              [91.58296757000005, 22.94790273100007],
              [91.5830709230001, 22.957798767000057],
              [91.57676639900006, 22.96880584800006],
              [91.5631238200001, 22.974981181000132],
              [91.54979130000004, 22.977229106000053],
              [91.53656213400006, 22.981854146],
              [91.52364302600006, 22.995212504000037],
              [91.51940555800007, 23.005625305000066],
              [91.51816532400005, 23.03508087200008],
              [91.51558150200009, 23.03880157500008],
              [91.50607303900006, 23.041178691000127],
              [91.50328251200011, 23.0444084680001],
              [91.49811486900012, 23.069962464000056],
              [91.47506717900006, 23.14308461500012],
              [91.47041630100011, 23.153290711000082],
              [91.46359501200004, 23.184115702000057],
              [91.46121789600011, 23.184425761000043],
              [91.44643843600005, 23.1978874710001],
              [91.44540490800011, 23.203029277],
              [91.44674849500007, 23.20879119900006],
              [91.44643843600005, 23.215534973],
              [91.43992720500012, 23.223518983000062],
              [91.43961714700004, 23.22264048200013],
              [91.43620650200012, 23.215715841000062],
              [91.43651656100008, 23.214863180000023],
              [91.42814498000013, 23.229513449000095],
              [91.41357222500005, 23.248633728000087],
              [91.39434859200003, 23.2626638790001],
              [91.37212772600009, 23.261888733000077],
              [91.36096561700003, 23.247522685],
              [91.35569462100011, 23.224139099000027],
              [91.35590132700008, 23.17964569100006],
              [91.37460819500006, 23.095723165000052],
              [91.37088749200007, 23.06277944],
              [91.33740116400003, 23.071073507000037],
              [91.31352665200006, 23.101045838000076],
              [91.30050419200012, 23.14230946900001],
              [91.27724979600009, 23.303255717000027],
              [91.27290897700004, 23.313487651000017],
              [91.26753462700009, 23.321549174],
              [91.26577762900007, 23.329352315000037],
              [91.27290897700004, 23.338499044000017],
              [91.28293420400007, 23.34764577300008],
              [91.28727502500004, 23.35555226700005],
              [91.28396773300005, 23.36144338000004],
              [91.27094527200006, 23.3645956430001],
              [91.2581295170001, 23.37363901800005],
              [91.24789758300005, 23.393766989000127],
              [91.23446171100005, 23.436270854000085],
              [91.22970747900007, 23.461178894000042],
              [91.22733036300014, 23.4687753300001],
              [91.22081913300008, 23.47789622000009],
              [91.20335249900012, 23.487921448000108],
              [91.19508426900006, 23.495181986000077],
              [91.1858858650001, 23.511563416000044],
              [91.17751428300011, 23.544274597000125],
              [91.16986617000003, 23.561973776000045],
              [91.14082401500013, 23.61209991500006],
              [91.13627648900012, 23.629514872000087],
              [91.13968713400004, 23.65357025100012],
              [91.15229618400014, 23.655094707000032],
              [91.1664555260001, 23.654087016000048],
              [91.1752405200001, 23.67031341600007],
              [91.16893599500008, 23.685377096000067],
              [91.15239953700006, 23.691009827000087],
              [91.13658654800008, 23.698890483000028],
              [91.13234908000004, 23.720646261000056],
              [91.14175419100008, 23.73989573200008],
              [91.15756717900007, 23.744985861000046],
              [91.17658410700005, 23.746536154000083],
              [91.19498091600013, 23.755166118000105],
              [91.20521285000012, 23.77157338500008],
              [91.2252633060001, 23.82614369800011],
              [91.22815718600009, 23.844979757000104],
              [91.22402307100003, 23.857485453000024],
              [91.2127576090001, 23.880739848000033],
              [91.21193078600004, 23.89445994100008],
              [91.21627160700012, 23.90838673900005],
              [91.25037805200003, 23.96404225700006],
              [91.26092004400004, 23.97727142400008],
              [91.27414921100006, 23.988226827000048],
              [91.29161584500008, 23.994815573000025],
              [91.30494836400004, 23.993859558000068],
              [91.30843257700013, 23.992501035000103],
              [91.31621382700007, 23.989467062000088],
              [91.32706587800004, 23.987865092000035],
              [91.3390548100001, 23.995228984000036],
              [91.34928674300005, 24.036053366000132],
              [91.35083703600009, 24.074242249000022],
              [91.36303267500011, 24.099847921000062],
              [91.40458052600007, 24.103129374000062],
              [91.48044152900013, 24.088014018000067],
              [91.51754520700007, 24.085197652000076],
              [91.55867964700008, 24.089667663000014],
              [91.58183068900007, 24.096101380000064],
              [91.59650679500004, 24.104989726000056],
              [91.60601525900012, 24.11886484800003],
              [91.61376672300014, 24.140103862],
              [91.62451542100007, 24.203459168000037],
              [91.62906294800007, 24.21531890900006],
              [91.63950158700004, 24.211701559000076],
              [91.65717492700003, 24.17136810400011],
              [91.66616662600006, 24.155916850000025],
              [91.68415002500006, 24.145478211000082],
              [91.70368371600006, 24.14294606500009],
              [91.72115035100012, 24.148992208000024],
              [91.73262251800003, 24.164314270000077],
              [91.73200240000006, 24.181677551000107],
              [91.72580122900007, 24.202063904000042],
              [91.72301070200012, 24.22097747800008],
              [91.73293257600011, 24.234284159000097],
              [91.79659794100013, 24.221597595000063],
              [91.80703658100003, 24.221132507000036],
              [91.8097237550001, 24.214543763000037],
              [91.81137740100013, 24.192038676000024],
              [91.81375451700006, 24.183124492],
              [91.84424361200007, 24.155322571000042],
              [91.86450077300009, 24.15059417700006],
              [91.87710982300007, 24.158035584000075],
              [91.88434452300004, 24.17555389500005],
              [91.90594527200011, 24.260639140000066],
              [91.90687544800005, 24.28035369900003],
              [91.89643680900014, 24.32011871400003],
              [91.89984745300006, 24.338050435000085],
              [91.92186161300003, 24.34450999000005],
              [91.93095666500011, 24.336965231000093],
              [91.95307417800012, 24.322986755],
              [91.97219445900004, 24.316062114000104],
              [91.97136763500009, 24.329678853000118],
              [91.94883671100007, 24.363526917000016],
              [91.9499735920001, 24.37538665800004],
              [92.03337935400003, 24.368849590000067],
              [92.06273156800012, 24.37102],
              [92.08825972500006, 24.38163950700003],
              [92.10758671100012, 24.40597910600006],
              [92.11120406100008, 24.43429779100005],
              [92.10593306500004, 24.495250143000092],
              [92.11089400300011, 24.514292908000087],
              [92.12319299300003, 24.525377503000087],
              [92.13859257000013, 24.533723246000065],
              [92.14997986200007, 24.54218295400004],
              [92.1531653240001, 24.54454945900001],
              [92.16360396300013, 24.55919972800008],
              [92.16887496000004, 24.574315084000077],
              [92.1734224860001, 24.60839569200006],
              [92.18293094900008, 24.647256368000015],
              [92.23378055900008, 24.777532654000098],
              [92.23646773300004, 24.793035584],
              [92.23688114400005, 24.808590190000032],
              [92.23502079300005, 24.824764914000028],
              [92.23492786100007, 24.82499071000008],
              [92.22179162600014, 24.856907654000068],
              [92.22175905800003, 24.857046883000052],
              [92.21765751100003, 24.874580994000084],
              [92.2230318610001, 24.89137583400013],
              [92.2521773680001, 24.902977194000087],
              [92.29024450000003, 24.891351286000045],
              [92.29041792900011, 24.891298320000104],
              [92.35814605200005, 24.853748899000024],
              [92.35832076000014, 24.853652039000096],
              [92.35932057700006, 24.84642836600004],
              [92.35935428900012, 24.846184794000052],
              [92.36350740900014, 24.841120014000026],
              [92.36359175600006, 24.84101715100006],
              [92.37092980900007, 24.837916565000015],
              [92.38074833200005, 24.836702169000077],
              [92.44203658000009, 24.855409037000058],
              [92.47769331900008, 24.863909810000067],
              [92.49154260200004, 24.883727722000046],
              [92.49453983600006, 24.894863993000072],
              [92.49133589700006, 24.91227895100012],
              [92.49126714800008, 24.912424218000055],
              [92.48379113800013, 24.92822113000004],
              [92.4743860270001, 24.93667022800004],
              [92.4742723330001, 24.936715371000062],
              [92.4497880460001, 24.946437073000098],
              [92.45002848600006, 24.94663618700004],
              [92.45805627500005, 24.953284201000045],
              [92.45782812800007, 24.953557685000035],
              [92.45402551300003, 24.95811594700008],
              [92.45376877000012, 24.9582310630001],
              [92.44451704900007, 24.96237925200002],
              [92.44444627300004, 24.962427197000082],
              [92.41247766200007, 24.98408335400002],
              [92.41246032100014, 24.98436081700008],
              [92.4122709560001, 24.987390646000037],
              [92.41213950000014, 24.987434336],
              [92.41186000600004, 24.987527227000058],
              [92.39470096900004, 24.993230082000096],
              [92.38694950400003, 24.99509043400012],
              [92.38692635100006, 24.99520183],
              [92.38687592400004, 24.9954444560001],
              [92.38493703500006, 25.004773236000048],
              [92.38105839100012, 25.02343495700002],
              [92.35625370300005, 25.037000021],
              [92.32814172400003, 25.048007101000096],
              [92.31212203000007, 25.0686001590001],
              [92.30354374200004, 25.07428456600003],
              [92.25155725100012, 25.080795797000107],
              [92.2336772060001, 25.08495575000005],
              [92.22013798000012, 25.090381775000097],
              [92.20804569500012, 25.098107401],
              [92.19409305900012, 25.109166159000026],
              [92.17921024600008, 25.126684469000068],
              [92.17269901600008, 25.131955465000104],
              [92.16474084500004, 25.133557434000053],
              [92.15099491400008, 25.129733379000086],
              [92.14551721200013, 25.13169708200003],
              [92.13859257000013, 25.136399638000015],
              [92.12412316900003, 25.136968079000056],
              [92.11616499900003, 25.139448548000033],
              [92.11037723800007, 25.144874573000024],
              [92.1004553630001, 25.159085592000068],
              [92.09291060400011, 25.164718323],
              [92.06603886000005, 25.174536845000077],
              [92.03399947100013, 25.181668193000107],
              [92.00175337700006, 25.18296010400006],
              [91.97508833800003, 25.175363668],
              [91.95627811700012, 25.169782613000066],
              [91.90057092300009, 25.177585754000106],
              [91.79370406100003, 25.16533844000007],
              [91.74533492100011, 25.169369202000055],
              [91.73014204900005, 25.167457174000063],
              [91.72373417200004, 25.161927796000057],
              [91.71773970600009, 25.149835511000063],
              [91.7107117110001, 25.14466786800007],
              [91.70182336400006, 25.14714833600003],
              [91.68890425700005, 25.15298777300002],
              [91.67743208800005, 25.152626038000037],
              [91.67226444500005, 25.13650299100003],
              [91.66203251100006, 25.127201233],
              [91.63867476400003, 25.12404897100005],
              [91.61314660700009, 25.12513417600006],
              [91.59619673700007, 25.128906555000086],
              [91.5801770430001, 25.140895488000027],
              [91.57345910700008, 25.152264302000034],
              [91.56612105300007, 25.15996409100002],
              [91.5487577720001, 25.161100973000103],
              [91.54017948400013, 25.157638652000074],
              [91.52343632100008, 25.145184632000095],
              [91.51165409400011, 25.14249745700006],
              [91.50090539600006, 25.14115387],
              [91.4807515870001, 25.135262757000092],
              [91.47103641800004, 25.133919170000027],
              [91.43186568300013, 25.137949931000023],
              [91.28396773300005, 25.178981018000073],
              [91.23570194500013, 25.201925354000096],
              [91.22495324700009, 25.201615296000043],
              [91.20314579300009, 25.191331686000026],
              [91.19084680200012, 25.189471334000032],
              [91.13534631400006, 25.191228333000097],
              [90.97514937400013, 25.167818909000047],
              [90.9434200450001, 25.15743194600013],
              [90.93482138600007, 25.156359858000044],
              [90.82198042800007, 25.142290752000108],
              [90.7939718020001, 25.14539133700005],
              [90.77939904800013, 25.151954244000038],
              [90.76689335100014, 25.16053253200006],
              [90.75397424300013, 25.167560527000077],
              [90.73795454900005, 25.16942087900007],
              [90.73268355400006, 25.16688873300008],
              [90.72203820800007, 25.15660512300009],
              [90.71635380000009, 25.153556214000062],
              [90.70767216000013, 25.15298777300002],
              [90.67056848100009, 25.158775533],
              [90.64896773300012, 25.167818909000047],
              [90.6375989180001, 25.171074524000048],
              [90.62343957500008, 25.171436259000032],
              [90.58333866400005, 25.16203114900007],
              [90.50137984200012, 25.168800761000014],
              [90.39978397700008, 25.149008687000034],
              [90.36464400300014, 25.149990540000104],
              [90.28692264800003, 25.180066223000082],
              [90.13008467700013, 25.211588847000044],
              [89.90813440000011, 25.29690663700002],
              [89.87020389800011, 25.29556305000007],
              [89.83459883600011, 25.282437236000092],
              [89.81904423000009, 25.284969381000067],
              [89.80736535600005, 25.304503073],
              [89.79852868700004, 25.340056458000035],
              [89.79501469000007, 25.374162903000112],
              [89.79923403500004, 25.402892809000022],
              [89.80069909700012, 25.41286855100013],
              [89.80856794000005, 25.439507112000015],
              [89.82323002100003, 25.489142965000056],
              [89.82509037300014, 25.56448720300004],
              [89.83439213000008, 25.63476715100002],
              [89.82421187300008, 25.674092916000106],
              [89.80152592000013, 25.72468414400005],
              [89.78312911000006, 25.81444610700005],
              [89.7869531660001, 25.839147441000065],
              [89.83005131100009, 25.90798044900005],
              [89.83439213000008, 25.931751608000113],
              [89.82643396000003, 25.937487691000072],
              [89.81072432500014, 25.938779603000015],
              [89.79201745600005, 25.94911488900003],
              [89.81155114700005, 25.955212708000076],
              [89.82560713700008, 25.965703024000035],
              [89.82865604700004, 25.979397278000064],
              [89.8152718500001, 25.99510691300013],
              [89.81413496900007, 25.99614044200011],
              [89.81268802900007, 25.996347148000055],
              [89.81103438300005, 25.99603708900007],
              [89.80932906100008, 25.995210266000058],
              [89.80917403100011, 25.99510691300013],
              [89.80886397300003, 25.99510691300013],
              [89.80204268400007, 25.98864736000006],
              [89.79553145400013, 25.985960185000053],
              [89.78943363500014, 25.9879755650001],
              [89.78395593200008, 25.99510691300013],
              [89.77641117400003, 26.008232727000077],
              [89.75584395400011, 26.032417297000066],
              [89.75021122300012, 26.041564026000046],
              [89.74871260600008, 26.05903066000009],
              [89.75114139900006, 26.071536357000085],
              [89.74984948700012, 26.08388702400005],
              [89.73672367300003, 26.100578511],
              [89.72876550300009, 26.114169413000084],
              [89.72432133000007, 26.130654195000048],
              [89.7184818930001, 26.14553700800009],
              [89.70654463700004, 26.154166972000056],
              [89.69765629100004, 26.154787089000095],
              [89.67770918800011, 26.153133443000073],
              [89.6703711340001, 26.15411529600003],
              [89.65817549700012, 26.159231262000034],
              [89.65579838100007, 26.161298320000085],
              [89.65724532100006, 26.165380758000097],
              [89.6578286080001, 26.18717448300005],
              [89.65838220200004, 26.207858785000028],
              [89.65300785400007, 26.222689921000054],
              [89.63492110200008, 26.22584218300001],
              [89.61332035300012, 26.219382629000066],
              [89.60639571100012, 26.2110110470001],
              [89.60846276900008, 26.180676982000037],
              [89.61528405800004, 26.169101461000096],
              [89.6144055580001, 26.164192200000073],
              [89.59399336800004, 26.16972157800008],
              [89.58675866700008, 26.169204814000025],
              [89.57993737800012, 26.166104228000094],
              [89.57342614800007, 26.16072987900013],
              [89.56278080300007, 26.142591452000104],
              [89.56939538600005, 26.130085754],
              [89.58577681500003, 26.122902731000053],
              [89.60422530100004, 26.120732320000073],
              [89.59254642800005, 26.113962708000102],
              [89.57787032100009, 26.107244771000083],
              [89.56691491700008, 26.098976543000063],
              [89.56701827000012, 26.087090963000023],
              [89.57694014500004, 26.082646790000112],
              [89.5907894290001, 26.085023906000046],
              [89.60386356700013, 26.084662171000062],
              [89.61135664900007, 26.072208150000066],
              [89.60288171400009, 26.055258280000075],
              [89.55916345200006, 26.02223704],
              [89.55068851700008, 25.995055237000102],
              [89.55182539900011, 25.98151601200003],
              [89.54908654800005, 25.96885528600008],
              [89.54169681900004, 25.959708558],
              [89.52841597500003, 25.957124735000022],
              [89.51818404200003, 25.96208567400005],
              [89.50945072500008, 25.97262766500002],
              [89.49534305900005, 25.995055237000102],
              [89.49064050300007, 25.997329],
              [89.4856278900001, 25.998724263000028],
              [89.48061527500005, 25.999241028000043],
              [89.42640669700012, 25.995055237000102],
              [89.42635502100012, 25.994951884000088],
              [89.42118737800007, 25.993194885000023],
              [89.41612308700013, 25.992626444000066],
              [89.4112655030001, 25.993194885000023],
              [89.40661462500003, 25.995055237000102],
              [89.39142175300003, 26.015467428000065],
              [89.37974287900005, 26.015312399000024],
              [89.3677539470001, 26.005442200000047],
              [89.35147587100005, 25.996863912000023],
              [89.33530114700005, 25.998569235000062],
              [89.31514733900008, 26.006785787000084],
              [89.29690555800005, 26.0181546030001],
              [89.27297937100013, 26.043476054000067],
              [89.23763269000011, 26.058100484000036],
              [89.22926110800006, 26.067195537000103],
              [89.22305993600008, 26.086574198000065],
              [89.21262129800004, 26.098976543000063],
              [89.19784183700011, 26.107709859000025],
              [89.13159265100012, 26.133754781],
              [89.11919030800004, 26.1466222130001],
              [89.11169722500011, 26.16450225900006],
              [89.10337732000005, 26.22517039000003],
              [89.09588423700012, 26.24103505500004],
              [89.07588545700008, 26.271059062000106],
              [89.06942590300014, 26.287388815000057],
              [89.0688574620001, 26.314260559000033],
              [89.0803296310001, 26.315604146000013],
              [89.09479903200014, 26.30950632700005],
              [89.10353234900009, 26.313692118000077],
              [89.10291223200011, 26.327334696],
              [89.09572920800008, 26.33451772100004],
              [89.07185469600006, 26.34061554],
              [89.05521488500005, 26.347023417000045],
              [89.05407800300003, 26.353948059000018],
              [89.05728194200003, 26.362629700000085],
              [89.05263106300004, 26.374618632000036],
              [89.04374271700004, 26.381078186000096],
              [89.02178023300007, 26.38624582900009],
              [89.01087650500011, 26.390173239000077],
              [89.00178145400014, 26.397149557000077],
              [88.98653690600008, 26.4127041630001],
              [88.97532312000004, 26.417871806000093],
              [88.95930342700012, 26.428568828],
              [88.95015669700012, 26.436940410000076],
              [88.94100996900005, 26.439420878000064],
              [88.92457686400007, 26.43213450100008],
              [88.91196781400004, 26.421230774000023],
              [88.89946211800003, 26.40448761000006],
              [88.89124556500013, 26.38578074100006],
              [88.89186568200006, 26.368779196000062],
              [88.91243290200009, 26.348935445000066],
              [88.94121667500008, 26.340098775000072],
              [88.96602136200005, 26.328471578000105],
              [88.97532312000004, 26.29994618800005],
              [88.9817309980001, 26.291832987000063],
              [88.98968916900009, 26.289404195000074],
              [88.99862919200007, 26.291522929000067],
              [89.00798262600011, 26.29715566],
              [89.00436527500005, 26.275709941000073],
              [89.01159997600013, 26.2691987110001],
              [89.02353723100003, 26.2688369750001],
              [89.03433760600007, 26.26578806600007],
              [89.03971195500003, 26.24718455000003],
              [89.01945479300014, 26.23447214800005],
              [88.97532312000004, 26.22434356700002],
              [88.94684940600013, 26.232921855000043],
              [88.90271773300003, 26.272919414000015],
              [88.8757943110001, 26.27736358600002],
              [88.85564050400012, 26.2651162720001],
              [88.84065433800009, 26.2320433550001],
              [88.82484134900005, 26.22656565400011],
              [88.80799483200008, 26.23343861900007],
              [88.7984863690001, 26.247649638000055],
              [88.79202681500004, 26.264599508000046],
              [88.78401696800006, 26.27994740900003],
              [88.74794681800006, 26.292504782000023],
              [88.6634041750001, 26.26444447900009],
              [88.64583418800004, 26.27601999900004],
              [88.65327559400004, 26.283099671000073],
              [88.69012089100005, 26.299842835000035],
              [88.70298832200007, 26.309661357],
              [88.71223840300007, 26.328264872000048],
              [88.70970625900009, 26.34061554],
              [88.69627038600004, 26.350279032000046],
              [88.67337772700012, 26.360717672000064],
              [88.66743493700011, 26.36815907800009],
              [88.66852014200009, 26.385729065000064],
              [88.66107873600009, 26.388881328000124],
              [88.6522420660001, 26.39151682600003],
              [88.64986495000005, 26.3983897910001],
              [88.65193200700008, 26.407071432000052],
              [88.65627282700007, 26.41513295500006],
              [88.63301843300013, 26.4200938930001],
              [88.62237308800007, 26.424538066000096],
              [88.6115210370001, 26.43084259100003],
              [88.60356286700005, 26.44019602500005],
              [88.59787845900007, 26.451461487000117],
              [88.59116052200005, 26.46122833300008],
              [88.57917159000004, 26.466034241000088],
              [88.55798425300009, 26.465724182000102],
              [88.54976770000013, 26.466654358000042],
              [88.52682336400011, 26.475387676000125],
              [88.50682458500006, 26.487634989000057],
              [88.49865970900004, 26.4948696900001],
              [88.48791101100011, 26.50577341800009],
              [88.47540531400011, 26.514971823000067],
              [88.46238285300007, 26.528821106000052],
              [88.44646651200009, 26.53553904300007],
              [88.41101648000011, 26.545099182000072],
              [88.39789066600008, 26.558690084000048],
              [88.39499678600009, 26.578378805000014],
              [88.39592696100004, 26.599566142000057],
              [88.39437666800012, 26.61801462800007],
              [88.38528161700003, 26.623544007000064],
              [88.37251753700008, 26.611606751000025],
              [88.36027022300004, 26.59310658800011],
              [88.35282881700005, 26.578688864000085],
              [88.33236495000006, 26.514661764],
              [88.31934248900012, 26.494921367000032],
              [88.31386478700006, 26.481537170000095],
              [88.31510502100008, 26.465052389],
              [88.32254642700008, 26.451771546000103],
              [88.33562056500006, 26.44820587200003],
              [88.34021976700006, 26.454148662000065],
              [88.34301029400007, 26.477196351000103],
              [88.34652429200008, 26.484017639000072],
              [88.35355228700013, 26.484586080000028],
              [88.37691003500004, 26.475335999000023],
              [88.43458093200013, 26.465155741000032],
              [88.46114261900004, 26.453890280000067],
              [88.47540531400011, 26.432031148000036],
              [88.49545577000009, 26.378080953000094],
              [88.49762618100004, 26.352707825],
              [88.47540531400011, 26.35580841100004],
              [88.46791223200006, 26.35405141200006],
              [88.4579903560001, 26.353017883000078],
              [88.44863692200005, 26.353431295000078],
              [88.44202233900006, 26.356118470000112],
              [88.43168705300013, 26.362216289000074],
              [88.4260026450001, 26.35792714500009],
              [88.42119673700012, 26.348728740000112],
              [88.41380700700006, 26.340202129000076],
              [88.36678145400003, 26.31343373600002],
              [88.35169193600012, 26.300979717000033],
              [88.33660241700011, 26.281807760000035],
              [88.33293339100004, 26.267235006000064],
              [88.33453536000013, 26.23080312100008],
              [88.32626713100012, 26.215920309000026],
              [88.30869714400012, 26.206101787000065],
              [88.25030277600007, 26.18801503500005],
              [88.22978723200009, 26.18403595000005],
              [88.21888350500012, 26.180160217000022],
              [88.21195886300006, 26.173752340000064],
              [88.20565433800004, 26.16641428700008],
              [88.19692102100004, 26.159644674000035],
              [88.16379642800007, 26.140472717000122],
              [88.15563155100006, 26.128483785000057],
              [88.14446944200012, 26.095875957000104],
              [88.14136885600004, 26.090501607000036],
              [88.13992191600005, 26.085333964000043],
              [88.14116215000013, 26.075463766000055],
              [88.14477950000008, 26.0705028280001],
              [88.15098067200006, 26.066988830000057],
              [88.15640669800007, 26.061407776000053],
              [88.15790531400006, 26.050452373000056],
              [88.1510323490001, 26.031332093000074],
              [88.12586592600007, 26.013400371],
              [88.10653894000012, 25.97996571900002],
              [88.08803877800005, 25.923224996],
              [88.08266442900003, 25.9159386190001],
              [88.07739343300005, 25.91278635700006],
              [88.07439620000008, 25.90813547800009],
              [88.08204431200005, 25.86384877600007],
              [88.08896895400005, 25.84865590400004],
              [88.08757369000006, 25.839974264000077],
              [88.08757369000006, 25.830982564000024],
              [88.10333500200005, 25.814807841000047],
              [88.1080375570001, 25.806281230000124],
              [88.11491052200006, 25.787264303000043],
              [88.12772627800007, 25.77491363500009],
              [88.14643314600005, 25.77574045800013],
              [88.16622522000011, 25.78364695300006],
              [88.18271000200008, 25.792431946000065],
              [88.22746179300003, 25.80426584900006],
              [88.25991459200009, 25.789021301000034],
              [88.32027266500006, 25.725252584000103],
              [88.39298140400012, 25.680759176000024],
              [88.41943973800011, 25.653784078000072],
              [88.42378055900008, 25.592237447000073],
              [88.43778487200012, 25.579835104],
              [88.47540531400011, 25.56257517600001],
              [88.48558557100012, 25.542628072000085],
              [88.51276737500007, 25.523714498000047],
              [88.52046716400008, 25.50929677400002],
              [88.53028568600013, 25.500201721000067],
              [88.55095625800004, 25.49648101800004],
              [88.59358931500003, 25.495085755000062],
              [88.61317468300007, 25.486404114000024],
              [88.64542077600004, 25.46733551000004],
              [88.66634973200013, 25.46289133800012],
              [88.67808028100006, 25.465888570000047],
              [88.68707198100003, 25.47389841700003],
              [88.69565026900005, 25.48361358600006],
              [88.70619226100013, 25.49167511000003],
              [88.71415043100006, 25.492811992000057],
              [88.72314213100003, 25.49141672800006],
              [88.73265059500011, 25.49100331700005],
              [88.74257246900004, 25.495189108000105],
              [88.74195235200006, 25.51275909400006],
              [88.77233809500012, 25.501958720000047],
              [88.78096805800004, 25.495189108000105],
              [88.79311202000014, 25.481959941000085],
              [88.80582442200011, 25.471676331000097],
              [88.81491947500007, 25.45860219300006],
              [88.81631473800007, 25.437208151000036],
              [88.79931319200006, 25.401706442000105],
              [88.79962325000014, 25.39560862300003],
              [88.81037194800012, 25.388425598000097],
              [88.81326582800011, 25.380054016000102],
              [88.81404097600006, 25.370390524000086],
              [88.81833011900011, 25.35964182600007],
              [88.84199792500004, 25.332821757000076],
              [88.84902592000003, 25.327189026000056],
              [88.85925785400013, 25.32470855700008],
              [88.88018680800008, 25.32346832300003],
              [88.88612959800014, 25.31907582600006],
              [88.90287276200007, 25.30341786700008],
              [88.92648889200007, 25.300472310000075],
              [88.97532312000004, 25.302642721000083],
              [88.98271285000004, 25.29447784400007],
              [88.98493493700005, 25.284969381000067],
              [88.98235111500009, 25.27489247700005],
              [88.97532312000004, 25.265228984000103],
              [88.93775435400005, 25.240165914],
              [88.9290727130001, 25.229417216000073],
              [88.9279875090001, 25.215929667000026],
              [88.93077803600005, 25.202648825000026],
              [88.92788415600006, 25.192726949000118],
              [88.90964237500003, 25.189161275000046],
              [88.92416345200007, 25.167870585000074],
              [88.89863529500013, 25.169317526000057],
              [88.83021569900012, 25.191331686000026],
              [88.82360111500003, 25.194845683],
              [88.81708988500009, 25.19680938700013],
              [88.8091317140001, 25.195259094],
              [88.80251713100012, 25.188127747000053],
              [88.79233687400006, 25.166578675000025],
              [88.78422367300004, 25.16094594400009],
              [88.72453739400004, 25.166475322000068],
              [88.66459273300012, 25.18688751200004],
              [88.6342586670001, 25.19226186200008],
              [88.59911869300004, 25.193140361000033],
              [88.59012699400012, 25.190143127000013],
              [88.57772465000005, 25.177482401000063],
              [88.57069665500012, 25.173244935000028],
              [88.55937951600004, 25.17076446600005],
              [88.55467696100004, 25.171126201000035],
              [88.5500260820001, 25.1731415820001],
              [88.5231543380001, 25.179807841000112],
              [88.49183842000008, 25.191124980000083],
              [88.47540531400011, 25.195104065000052],
              [88.44129886900004, 25.189729716],
              [88.4314803470001, 25.173038229000056],
              [88.43416752100012, 25.11665924100005],
              [88.42579593900007, 25.051056010000124],
              [88.41411706500008, 25.021522929000085],
              [88.39101770100007, 24.99509043400012],
              [88.38786543800006, 24.968761292000053],
              [88.37566980000014, 24.945610251000076],
              [88.34089156100009, 24.904139913],
              [88.32275313400004, 24.8746843470001],
              [88.31360640500009, 24.868302307000064],
              [88.29681156400011, 24.86969757100006],
              [88.25485030100009, 24.87995534300005],
              [88.24275801600004, 24.880601299000105],
              [88.24187951700009, 24.898765564000044],
              [88.23283614100012, 24.918273417000037],
              [88.21878015100009, 24.93514577200004],
              [88.20245039900004, 24.945300191000072],
              [88.1830200610001, 24.946979675000037],
              [88.16451989700005, 24.941114400000046],
              [88.11491052200006, 24.916413066000032],
              [88.11491052200006, 24.912020569000035],
              [88.12033654800007, 24.906775411000027],
              [88.12493575100012, 24.89814544700006],
              [88.13806156400005, 24.863496399000056],
              [88.14095544500003, 24.844582825000103],
              [88.13124027500004, 24.831767070000055],
              [88.11739099100004, 24.81926137300003],
              [88.10777917500013, 24.801097107000103],
              [88.09480839000008, 24.803112488000053],
              [88.08824548300004, 24.796136170000054],
              [88.08535160400004, 24.78401804600007],
              [88.0840080160001, 24.770452983000084],
              [88.07698002200004, 24.761177063000062],
              [88.06426761900013, 24.759161682000112],
              [88.05320886200013, 24.754975891000086],
              [88.04845463100014, 24.71120595300009],
              [88.0354321690001, 24.69381683400006],
              [88.02716394100014, 24.675730082000044],
              [88.02178959200006, 24.64560272200005],
              [88.04090987200004, 24.640435079000056],
              [88.05723962400003, 24.63410471600004],
              [88.06726485200005, 24.613666687000077],
              [88.08183760600008, 24.599869080000033],
              [88.08498986800004, 24.593874614000086],
              [88.08498986800004, 24.541733093000047],
              [88.08602339700013, 24.536720480000085],
              [88.09000248300003, 24.532999777000057],
              [88.0987874760001, 24.5224836230001],
              [88.10793420400006, 24.50796254500007],
              [88.10994958500004, 24.50098622700007],
              [88.13878503400008, 24.495250143000092],
              [88.40130131100011, 24.36941803000012],
              [88.47540531400011, 24.315467835000064],
              [88.49834965000008, 24.31097198500005],
              [88.56310021900003, 24.308207296000077],
              [88.61245121300004, 24.292885234000025],
              [88.63451705000006, 24.294125468000047],
              [88.64950321500004, 24.31536448200002],
              [88.66014856000004, 24.338257141000057],
              [88.68180098500011, 24.333890483000076],
              [88.71456384300012, 24.315416158000048],
              [88.73750817900003, 24.28709747300006],
              [88.74303755700004, 24.24753916500002],
              [88.74494958500009, 24.24337921200008],
              [88.74748173000006, 24.226971945000017],
              [88.74980717000005, 24.223251242000103],
              [88.74639652500014, 24.21407867500001],
              [88.73482100400008, 24.19842071500007],
              [88.73161706600013, 24.18984242800012],
              [88.73145573500011, 24.1897713150001],
              [88.71590743000007, 24.182917786000033],
              [88.69378991700006, 24.17532135100008],
              [88.68376468900004, 24.166536356000094],
              [88.67808028100006, 24.154289043000077],
              [88.67828698800014, 24.144651388000042],
              [88.68298954300013, 24.12429087300002],
              [88.68180098500011, 24.112663676000054],
              [88.67539310700005, 24.09183807400008],
              [88.67410119700003, 24.082639669000102],
              [88.67901045700006, 24.071219178],
              [88.69782067900007, 24.05625885000002],
              [88.70092126500009, 24.043649801000086],
              [88.72500248200004, 24.03837880500008],
              [88.72546757000009, 24.028896179000085],
              [88.7138403730001, 24.01468516100003],
              [88.70159305800007, 23.995280660000063],
              [88.70836267100003, 23.98355011000008],
              [88.71435713700004, 23.964403992000072],
              [88.71714766500003, 23.9431391400001],
              [88.71415043100006, 23.925155742000115],
              [88.70443526200006, 23.913709412000102],
              [88.66650476100006, 23.87949961400001],
              [88.65312056500011, 23.869784445000064],
              [88.63394860900007, 23.866141256000063],
              [88.61317468300007, 23.867846578000027],
              [88.59358931500003, 23.866916402000086],
              [88.57762129700012, 23.855160014000077],
              [88.57436568200012, 23.845625712000086],
              [88.5754508870001, 23.836556499000025],
              [88.57762129700012, 23.827616476000102],
              [88.57751794500007, 23.818521424000025],
              [88.57235030200007, 23.806894226000068],
              [88.55767419400007, 23.785681051000026],
              [88.55271325700005, 23.774984029],
              [88.55250655100008, 23.765423890000093],
              [88.55974125200004, 23.75028269500008],
              [88.56118819200003, 23.74100677500006],
              [88.54010420800012, 23.64995290100005],
              [88.54155114800011, 23.63876495400008],
              [88.55095625800004, 23.6344241340001],
              [88.56123986800003, 23.632486268],
              [88.56635583500014, 23.628739726000063],
              [88.56439213100009, 23.61620819100007],
              [88.5610848390001, 23.608611756000087],
              [88.56170495600009, 23.602023010000025],
              [88.57142012600013, 23.592333679000077],
              [88.58154870600009, 23.58832875600008],
              [88.60128910400005, 23.59034413700003],
              [88.6092472740001, 23.588793844000023],
              [88.62423344000007, 23.573859355000067],
              [88.64764286400003, 23.535076193000023],
              [88.66448938000008, 23.518307190000073],
              [88.69378991700006, 23.499807028000035],
              [88.70464196800003, 23.495181986000077],
              [88.71942142800003, 23.468103536000015],
              [88.73192712400004, 23.472625224000055],
              [88.74370935100012, 23.489316711000086],
              [88.7568351650001, 23.49879933700005],
              [88.77016768400011, 23.48882578600005],
              [88.76789392100011, 23.467276713],
              [88.71926639800006, 23.348291728000063],
              [88.69503015100008, 23.312609152000064],
              [88.68593510000005, 23.293308004000025],
              [88.68660689300003, 23.271603902000024],
              [88.69658044500011, 23.252354432000104],
              [88.71001631700005, 23.241218160000088],
              [88.77569706300011, 23.22163279200005],
              [88.78618737800008, 23.221529439000037],
              [88.79419722500006, 23.224965922000067],
              [88.80096683800008, 23.23075368300003],
              [88.80954512500011, 23.236050517000066],
              [88.82267093900009, 23.237962545000087],
              [88.83962080900011, 23.234810283000044],
              [88.90964237500003, 23.212434388000062],
              [88.91806563300008, 23.208584493],
              [88.92695398000012, 23.206517436000055],
              [88.95423913600013, 23.207421773000092],
              [88.9599752200001, 23.2026933800001],
              [88.95982019100006, 23.19445098900006],
              [88.95470422400007, 23.18380564400009],
              [88.94586755400007, 23.174348857000027],
              [88.91909916200007, 23.153859152000038],
              [88.86478723200014, 23.10027069100009],
              [88.85129968300004, 23.07513010700005],
              [88.84871586100007, 23.02384124800001],
              [88.83941410300014, 22.995367534000067],
              [88.83879398700009, 22.975808004000058],
              [88.84277307100012, 22.964568380000017],
              [88.86173832200006, 22.942399190000074],
              [88.87217696100004, 22.926767070000054],
              [88.89346765200008, 22.879638164000127],
              [88.90514652600007, 22.86643483500005],
              [88.93310347500011, 22.85811492900008],
              [88.94452396600008, 22.848012187000037],
              [88.94679773000013, 22.834524638000076],
              [88.94514408400005, 22.815094300000098],
              [88.94121667500008, 22.795663961000017],
              [88.9368758550001, 22.782331441000096],
              [88.92623051000004, 22.767035218000032],
              [88.91496504800006, 22.75440033000011],
              [88.90814375800011, 22.74078359000002],
              [88.91057255100009, 22.722593486000065],
              [88.92250980600011, 22.69370636000012],
              [88.92592045100014, 22.680838928000114],
              [88.93000288900004, 22.658618063000077],
              [88.9423535570001, 22.637482402000032],
              [88.95201704900012, 22.611902568000076],
              [88.95640954600003, 22.584979146000066],
              [88.95031172700004, 22.561983134000016],
              [88.9279875090001, 22.54813385000007],
              [88.95904504400005, 22.53681671100007],
              [88.97098230000006, 22.52792836500008],
              [88.979974, 22.490928039000025],
              [88.99837080900011, 22.45124053900004],
              [89.00250492300006, 22.427986145000105],
              [89.00074792500004, 22.420131328000068],
              [88.99216963700013, 22.406953837000103],
              [88.98948246300012, 22.396670227000115],
              [88.98958581600004, 22.386903382000057],
              [89.00152307100007, 22.333676656000094],
              [89.00694909700013, 22.32142934200006],
              [89.02353723100003, 22.294815979000035],
              [89.00911950700004, 22.285617575000046],
              [89.01862797100011, 22.26468861900004],
              [89.06229455500011, 22.21156524700011],
              [89.07071781400009, 22.194822083000062],
              [89.07619551700009, 22.175030009000082],
              [89.07815922000009, 22.150845439000122],
              [89.06069258700006, 22.130484925000076],
              [89.06039472700007, 22.12986888200004],
              [89.06031334700003, 22.130601304000038],
              [89.04371178500003, 22.13739655200004],
              [89.04859459700003, 22.12295156500005],
              [89.04566491000003, 22.11204661700009],
              [89.03988691500007, 22.100897528000075],
              [89.03687584700003, 22.085598049000055],
              [89.04004967500003, 22.069525458000044],
              [89.05404707100007, 22.04364655200004],
              [89.05738366000003, 22.03123607000009],
              [89.06560306100005, 21.96710846600007],
              [89.06088300900007, 21.93846263200004],
              [89.03687584700003, 21.925116278000075],
              [89.02312259200005, 21.93109772300005],
              [89.01303144600007, 21.929429429000038],
              [89.00806725400008, 21.92055898600006],
              [89.00953209700003, 21.90460846600007],
              [88.99301191500007, 21.912665106000077],
              [88.96045983200008, 21.93431224200009],
              [88.94467207100007, 21.938788153000075],
              [88.93783613400007, 21.94871653900009],
              [88.93458092500003, 21.969305731000077],
              [88.92872155000003, 21.98655833500004],
              [88.91391035200007, 21.98655833500004],
              [88.90503991000003, 21.96942780200004],
              [88.91081790500004, 21.946478583000044],
              [88.92408287900008, 21.926336981000077],
              [88.93783613400007, 21.917669989000046],
              [88.95191491000003, 21.913885809000078],
              [88.96827233200008, 21.904730536000045],
              [88.99586022200003, 21.88418203300006],
              [89.01587975400008, 21.853338934000078],
              [89.03093509200005, 21.770453192000048],
              [89.04371178500003, 21.733343817000048],
              [89.04786217500003, 21.72801341400009],
              [89.06788170700008, 21.709133205000057],
              [89.08277428500003, 21.678208726000037],
              [89.08521569100003, 21.674709377000056],
              [89.08822675900007, 21.633734442000048],
              [89.08269290500004, 21.617336330000057],
              [89.06421959700003, 21.609198309000078],
              [89.05323326900003, 21.609808661000045],
              [89.04468834700003, 21.61351146000004],
              [89.03882897200003, 21.61945221600007],
              [89.03687584700003, 21.626898505000042],
              [89.03394616000003, 21.633246161000045],
              [89.02759850400008, 21.62457916900007],
              [89.02165774800005, 21.611802476000037],
              [89.01978600400008, 21.60610586100006],
              [89.00025475400008, 21.60342031500005],
              [88.97575931100005, 21.61591217700004],
              [88.93384850400008, 21.64394765800006],
              [88.89698326900003, 21.650132554000038],
              [88.89161217500003, 21.653509833000044],
              [88.88607832100007, 21.661810614000046],
              [88.88160241000003, 21.672023830000057],
              [88.87208092500003, 21.74900950700004],
              [88.86605879000007, 21.766831773000035],
              [88.85865319100003, 21.766831773000035],
              [88.85572350400008, 21.748846747000073],
              [88.84156334700003, 21.71625397300005],
              [88.83822675900007, 21.701971747000073],
              [88.84294681100005, 21.684149481000077],
              [88.85987389400003, 21.65257396000004],
              [88.85865319100003, 21.636542059000078],
              [88.84424889400003, 21.622219143000052],
              [88.82398522200003, 21.617254950000074],
              [88.80583743600005, 21.622870184000078],
              [88.79786217500003, 21.64020416900007],
              [88.81478925900007, 21.65387604400007],
              [88.81836998800003, 21.65761953300006],
              [88.81853274800005, 21.665838934000078],
              [88.81666100400008, 21.675034898000035],
              [88.81088300900007, 21.69171784100007],
              [88.80494225400008, 21.67186107000009],
              [88.80046634200005, 21.661851304000038],
              [88.79420006600003, 21.65761953300006],
              [88.78402754000007, 21.655951239000046],
              [88.77906334700003, 21.651190497000073],
              [88.77711022200003, 21.64354075700004],
              [88.77686608200008, 21.63344961100006],
              [88.78174889400003, 21.61424388200004],
              [88.79102623800003, 21.598863023000035],
              [88.79664147200003, 21.584418036000045],
              [88.79053795700008, 21.56826406500005],
              [88.76246178500003, 21.555853583000044],
              [88.72787519600007, 21.559881903000075],
              [88.70753014400003, 21.57831452000005],
              [88.72217858200008, 21.609198309000078],
              [88.68799889400003, 21.678127346000053],
              [88.68490644600007, 21.697211005000042],
              [88.70362389400003, 21.810614325000074],
              [88.69800866000003, 21.825506903000075],
              [88.69450931100005, 21.83982982000009],
              [88.71469160200007, 21.89785390800006],
              [88.71697024800005, 21.951971747000073],
              [88.72217858200008, 21.966131903000075],
              [88.73316491000003, 21.97719961100006],
              [88.74683678500003, 21.987127997000073],
              [88.75831139400003, 21.99945709800005],
              [88.76303144600007, 22.017279364000046],
              [88.75464928500003, 22.037583726000037],
              [88.71705162900008, 22.05805084800005],
              [88.70850670700008, 22.072211005000042],
              [88.71485436300003, 22.08698151200008],
              [88.73015384200005, 22.103583075000074],
              [88.76303144600007, 22.130560614000046],
              [88.74390709700003, 22.129339911000045],
              [88.72657311300003, 22.121161200000074],
              [88.71216881600003, 22.109035549000055],
              [88.70167076900003, 22.095851955000057],
              [88.69483483200008, 22.08152903900009],
              [88.69288170700008, 22.06586334800005],
              [88.69947350400008, 22.053208726000037],
              [88.71851647200003, 22.048041083000044],
              [88.73072350400008, 22.037176825000074],
              [88.72331790500004, 22.01308828300006],
              [88.70167076900003, 21.97601959800005],
              [88.69841556100005, 21.962591864000046],
              [88.68995201900003, 21.94599030200004],
              [88.67872155000003, 21.936672268000052],
              [88.66700280000003, 21.945013739000046],
              [88.65626061300003, 21.941066799000055],
              [88.64258873800003, 21.94090403900009],
              [88.63086998800003, 21.945461330000057],
              [88.62598717500003, 21.955511786000045],
              [88.62745201900003, 21.970404364000046],
              [88.63168379000007, 21.979803778000075],
              [88.64633222700007, 22.00023021000004],
              [88.65349368600005, 22.018011786000045],
              [88.65259850400008, 22.031805731000077],
              [88.64877363400007, 22.046047268000052],
              [88.64503014400003, 22.075140692000048],
              [88.63949629000007, 22.09723541900007],
              [88.63949629000007, 22.109523830000057],
              [88.65699303500003, 22.15106842700004],
              [88.67400149800005, 22.162054755000042],
              [88.68311608200008, 22.18496328300006],
              [88.67994225400008, 22.204413153000075],
              [88.66016686300003, 22.205023505000042],
              [88.66114342500003, 22.198960679000038],
              [88.65601647200003, 22.183254299000055],
              [88.64966881600003, 22.169094143000052],
              [88.64633222700007, 22.167792059000078],
              [88.64429772200003, 22.16229889500005],
              [88.63493899800005, 22.144964911000045],
              [88.63086998800003, 22.125799872000073],
              [88.62208092500003, 22.116034247000073],
              [88.61915123800003, 22.109523830000057],
              [88.61833743600005, 22.10297272300005],
              [88.61996504000007, 22.07831452000005],
              [88.62549889400003, 22.05927155200004],
              [88.62598717500003, 22.048041083000044],
              [88.62037194100003, 22.02997467700004],
              [88.60254967500003, 22.006415106000077],
              [88.59864342500003, 21.990301825000074],
              [88.60027103000004, 21.947211005000042],
              [88.59839928500003, 21.929348049000055],
              [88.56706790500004, 21.850816148000035],
              [88.56462649800005, 21.83234284100007],
              [88.56544030000003, 21.771185614000046],
              [88.56462649800005, 21.766831773000035],
              [88.58130944100003, 21.76943594000005],
              [88.60417728000004, 21.77875397300005],
              [88.62403405000003, 21.77802155200004],
              [88.63282311300003, 21.750067450000074],
              [88.63021894600007, 21.731756903000075],
              [88.62338300900007, 21.710272528000075],
              [88.61264082100007, 21.69749583500004],
              [88.59864342500003, 21.70538971600007],
              [88.59180748800003, 21.70538971600007],
              [88.59961998800003, 21.637274481000077],
              [88.59506269600007, 21.612127997000073],
              [88.57813561300003, 21.623439846000053],
              [88.57813561300003, 21.57168203300006],
              [88.57227623800003, 21.557928778000075],
              [88.55892988400007, 21.555568752000056],
              [88.54476972700007, 21.56199778900009],
              [88.53646894600007, 21.575100002000056],
              [88.53028405000003, 21.564398505000042],
              [88.52963300900007, 21.55337148600006],
              [88.53443444100003, 21.542914130000042],
              [88.54395592500003, 21.534084377000056],
              [88.51295006600003, 21.524644273000035],
              [88.49390709700003, 21.534816799000055],
              [88.48796634200005, 21.55654531500005],
              [88.49561608200008, 21.581854559000078],
              [88.50212649800005, 21.58934153900009],
              [88.50879967500003, 21.59438711100006],
              [88.51400800900007, 21.600816148000035],
              [88.51612389400003, 21.612616278000075],
              [88.51661217500003, 21.62641022300005],
              [88.51880944100003, 21.639146226000037],
              [88.52295983200008, 21.64988841400009],
              [88.52963300900007, 21.65761953300006],
              [88.50953209700003, 21.71230703300006],
              [88.50489342500003, 21.741522528000075],
              [88.51270592500003, 21.763413804000038],
              [88.53288821700005, 21.795314846000053],
              [88.53101647200003, 21.82412344000005],
              [88.51587975400008, 21.850816148000035],
              [88.49561608200008, 21.876695054000038],
              [88.51465905000003, 21.91620514500005],
              [88.51498457100007, 21.937201239000046],
              [88.49561608200008, 21.95180898600006],
              [88.49984785200007, 21.933661200000074],
              [88.49236087300005, 21.922023830000057],
              [88.48121178500003, 21.909898179000038],
              [88.47445722700007, 21.890326239000046],
              [88.47706139400003, 21.87181224200009],
              [88.49203535200007, 21.837144273000035],
              [88.49561608200008, 21.81867096600007],
              [88.49350019600007, 21.805161851000037],
              [88.48829186300003, 21.803656317000048],
              [88.48145592500003, 21.805161851000037],
              [88.47445722700007, 21.80097077000005],
              [88.46827233200008, 21.77724844000005],
              [88.45769290500004, 21.75885651200008],
              [88.45337975400008, 21.74176666900007],
              [88.45215905000003, 21.722805080000057],
              [88.45476321700005, 21.70538971600007],
              [88.46859785200007, 21.67715078300006],
              [88.47217858200008, 21.663275458000044],
              [88.46827233200008, 21.64394765800006],
              [88.45630944100003, 21.62400950700004],
              [88.44190514400003, 21.616156317000048],
              [88.42611738400007, 21.611029364000046],
              [88.40967858200008, 21.599269924000055],
              [88.39307701900003, 21.60024648600006],
              [88.38355553500003, 21.631415106000077],
              [88.38282311300003, 21.67133209800005],
              [88.39258873800003, 21.698553778000075],
              [88.38062584700003, 21.696193752000056],
              [88.36451256600003, 21.68695709800005],
              [88.35572350400008, 21.68496328300006],
              [88.34620201900003, 21.688625393000052],
              [88.34066816500007, 21.69749583500004],
              [88.33643639400003, 21.708726304000038],
              [88.33122806100005, 21.71906159100007],
              [88.32634524800005, 21.711086330000057],
              [88.32471764400003, 21.70136139500005],
              [88.32740319100003, 21.691107489000046],
              [88.34571373800003, 21.67059967700004],
              [88.34945722700007, 21.660956122000073],
              [88.34880618600005, 21.65029531500005],
              [88.34546959700003, 21.636542059000078],
              [88.33545983200008, 21.615790106000077],
              [88.32178795700008, 21.60565827000005],
              [88.30974368600005, 21.610174872000073],
              [88.30445397200003, 21.63344961100006],
              [88.30201256600003, 21.74518463700008],
              [88.29818769600007, 21.764105536000045],
              [88.28980553500003, 21.780218817000048],
              [88.27312259200005, 21.79791901200008],
              [88.26156660200007, 21.798651434000078],
              [88.26417076900003, 21.77529531500005],
              [88.29542076900003, 21.676581122000073],
              [88.29704837300005, 21.65387604400007],
              [88.29444420700008, 21.64280833500004],
              [88.28419030000003, 21.621242580000057],
              [88.28337649800005, 21.609198309000078],
              [88.28760826900003, 21.60028717700004],
              [88.30062910200007, 21.58934153900009],
              [88.30445397200003, 21.581854559000078],
              [88.30583743600005, 21.57168203300006],
              [88.30372155000003, 21.568793036000045],
              [88.29786217500003, 21.566555080000057],
              [88.28711998800003, 21.558294989000046],
              [88.27898196700005, 21.555161851000037],
              [88.26612389400003, 21.553859768000052],
              [88.25440514400003, 21.55467357000009],
              [88.24927819100003, 21.558294989000046],
              [88.24594160200007, 21.579901434000078],
              [88.23747806100005, 21.601711330000057],
              [88.22437584700003, 21.613023179000038],
              [88.20826256600003, 21.60297272300005],
              [88.18946373800003, 21.641791083000044],
              [88.18189537900008, 21.665228583000044],
              [88.18091881600003, 21.68496328300006],
              [88.19044030000003, 21.70408763200004],
              [88.20346113400007, 21.724351304000038],
              [88.21045983200008, 21.747259833000044],
              [88.20142662900008, 21.774318752000056],
              [88.20972741000003, 21.78856028900009],
              [88.20378665500004, 21.80540599200009],
              [88.15406334700003, 21.88808828300006],
              [88.15642337300005, 21.89785390800006],
              [88.15943444100003, 21.90615469000005],
              [88.14673912900008, 21.95921458500004],
              [88.14991295700008, 21.976385809000078],
              [88.15626061300003, 21.99087148600006],
              [88.16431725400008, 22.003119208000044],
              [88.20679772200003, 22.05337148600006],
              [88.22242272200003, 22.077948309000078],
              [88.21273847700007, 22.100043036000045],
              [88.20337975400008, 22.15176015800006],
              [88.19800866000003, 22.167792059000078],
              [88.16529381600003, 22.18500397300005],
              [88.11841881600003, 22.20018138200004],
              [88.08130944100003, 22.217352606000077],
              [88.07732181100005, 22.24042389500005],
              [88.05974368600005, 22.22947825700004],
              [88.04346764400003, 22.224758205000057],
              [88.02702884200005, 22.227850653000075],
              [88.00904381600003, 22.24042389500005],
              [87.98511803500003, 22.26593659100007],
              [87.97266686300003, 22.28318919500009],
              [87.96745853000004, 22.298488674000055],
              [87.96420332100007, 22.319281317000048],
              [87.95069420700008, 22.35618724200009],
              [87.94752037900008, 22.373846747000073],
              [87.94613691500007, 22.394924221000053],
              [87.94044030000003, 22.413031317000048],
              [87.92798912900008, 22.424221096000053],
              [87.90658613400007, 22.424750067000048],
              [87.90658613400007, 22.41860586100006],
              [87.92286217500003, 22.397772528000075],
              [87.93580162900008, 22.355169989000046],
              [87.94752037900008, 22.27765534100007],
              [87.95281009200005, 22.26243724200009],
              [87.96534264400003, 22.24481842700004],
              [87.99195397200003, 22.21588776200008],
              [88.00847415500004, 22.204901434000078],
              [88.02540123800003, 22.200913804000038],
              [88.05738366000003, 22.198879299000055],
              [88.09546959700003, 22.191229559000078],
              [88.13257897200003, 22.17914459800005],
              [88.16098066500007, 22.15656159100007],
              [88.17351321700005, 22.116888739000046],
              [88.16431725400008, 22.089789130000042],
              [88.14063561300003, 22.06012604400007],
              [88.11117597700007, 22.034857489000046],
              [88.08472741000003, 22.020697333000044],
              [88.04859459700003, 22.020738023000035],
              [88.04314212300005, 22.017279364000046],
              [88.04517662900008, 22.00653717700004],
              [88.04900149800005, 21.995428778000075],
              [88.05079186300003, 21.98501211100006],
              [88.04688561300003, 21.97601959800005],
              [88.03239993600005, 21.957180080000057],
              [87.98365319100003, 21.85419342700004],
              [87.97046959700003, 21.836493231000077],
              [87.95777428500003, 21.828924872000073],
              [87.94800866000003, 21.825384833000044],
              [87.90902754000007, 21.79881419500009],
              [87.90219160200007, 21.796820380000042],
              [87.89918053500003, 21.79482656500005],
              [87.89568118600005, 21.78937409100007],
              [87.89478600400008, 21.77875397300005],
              [87.89291425900007, 21.774318752000056],
              [87.86719811300003, 21.750799872000073],
              [87.83399498800003, 21.729315497000073],
              [87.75570722700007, 21.69171784100007],
              [87.70378665500004, 21.655503648000035],
              [87.68384850400008, 21.650132554000038],
              [87.64210045700008, 21.652085679000038],
              [87.62134850400008, 21.65062083500004],
              [87.47738691500007, 21.61359284100007],
              [87.46876061300003, 21.611395575000074],
              [87.40495853000004, 21.58665599200009],
              [87.34180748800003, 21.56240469000005],
              [87.29346764400003, 21.553656317000048],
              [87.25611412900008, 21.56199778900009],
              [87.24594160200007, 21.556586005000042],
              [87.23519941500007, 21.554510809000078],
              [87.21143639400003, 21.55459219000005],
              [87.20093834700003, 21.551988023000035],
              [87.11304772200003, 21.507961330000057],
              [87.06373131600003, 21.475002346000053],
              [86.91765384200005, 21.327378648000035],
              [86.86695397200003, 21.25604889500005],
              [86.83725019600007, 21.174709377000056],
              [86.84400475400008, 21.08222077000005],
              [86.95215905000003, 20.84910716400009],
              [86.96566816500007, 20.805975653000075],
              [86.95386803500003, 20.780585028000075],
              [86.93628991000003, 20.787502346000053],
              [86.91651451900003, 20.78807200700004],
              [86.87875410200007, 20.780585028000075],
              [86.88933353000004, 20.764471747000073],
              [86.91065514400003, 20.756415106000077],
              [86.95720462300005, 20.753241278000075],
              [86.97999108200008, 20.755560614000046],
              [86.98658287900008, 20.75185781500005],
              [86.99488366000003, 20.73895905200004],
              [87.00001061300003, 20.728216864000046],
              [87.00180097700007, 20.71898021000004],
              [86.99870853000004, 20.71112702000005],
              [86.98861738400007, 20.704250393000052],
              [86.97575931100005, 20.710679429000038],
              [86.96119225400008, 20.712836005000042],
              [86.94825280000003, 20.709051825000074],
              [86.94019616000003, 20.69798411700009],
              [86.95191491000003, 20.697007554000038],
              [86.96119225400008, 20.695054429000038],
              [86.96851647200003, 20.691148179000038],
              [86.97429446700005, 20.684393622000073],
              [86.98170006600003, 20.685370184000078],
              [86.98650149800005, 20.684393622000073],
              [86.99024498800003, 20.67999909100007],
              [86.99488366000003, 20.670721747000073],
              [87.01937910200007, 20.68036530200004],
              [87.03337649800005, 20.69017161700009],
              [87.04322350400008, 20.69798411700009],
              [87.02751712300005, 20.67967357000009],
              [87.00359134200005, 20.657049872000073],
              [86.97624759200005, 20.637884833000044],
              [86.92318769600007, 20.62173086100006],
              [86.77418053500003, 20.51194896000004],
              [86.75147545700008, 20.489162502000056],
              [86.73389733200008, 20.462225653000075],
              [86.72461998800003, 20.43195221600007],
              [86.72046959700003, 20.368475653000075],
              [86.74195397200003, 20.37954336100006],
              [86.75635826900003, 20.393744208000044],
              [86.76978600400008, 20.40070221600007],
              [86.78874759200005, 20.39012278900009],
              [86.78825931100005, 20.402818101000037],
              [86.78980553500003, 20.41469961100006],
              [86.79615319100003, 20.437323309000078],
              [86.80982506600003, 20.41510651200008],
              [86.79420006600003, 20.378159898000035],
              [86.76832116000003, 20.343451239000046],
              [86.75147545700008, 20.328070380000042],
              [86.73926842500003, 20.32420482000009],
              [86.71973717500003, 20.31509023600006],
              [86.70167076900003, 20.30377838700008],
              [86.69369550900007, 20.29393138200004],
              [86.70167076900003, 20.28465403900009],
              [86.71973717500003, 20.29173411700009],
              [86.75464928500003, 20.31443919500009],
              [86.71745853000004, 20.286932684000078],
              [86.62818444100003, 20.235256252000056],
              [86.58383222700007, 20.21820709800005],
              [86.53419030000003, 20.20612213700008],
              [86.51148522200003, 20.19745514500005],
              [86.49512780000003, 20.184068101000037],
              [86.49040774800005, 20.17405833500004],
              [86.47885175900007, 20.129339911000045],
              [86.46851647200003, 20.10927969000005],
              [86.46713300900007, 20.094671942000048],
              [86.41504967500003, 20.036322333000044],
              [86.39144941500007, 20.02020905200004],
              [86.39673912900008, 20.00995514500005],
              [86.40414472700007, 20.00263092700004],
              [86.41407311300003, 19.998846747000073],
              [86.42628014400003, 19.999172268000052],
              [86.39722741000003, 19.982855536000045],
              [86.34839928500003, 20.00885651200008],
              [86.27540123800003, 20.06736888200004],
              [86.23129316500007, 20.064886786000045],
              [86.20915774800005, 20.06663646000004],
              [86.19971764400003, 20.077948309000078],
              [86.19597415500004, 20.08030833500004],
              [86.17302493600005, 20.10219961100006],
              [86.16846764400003, 20.11318594000005],
              [86.16309655000003, 20.134833075000074],
              [86.15870201900003, 20.143133856000077],
              [86.15251712300005, 20.143133856000077],
              [86.14503014400003, 20.122015692000048],
              [86.15430748800003, 20.089992580000057],
              [86.15870201900003, 20.08104075700004],
              [86.16773522200003, 20.07294342700004],
              [86.18775475400008, 20.063666083000044],
              [86.21371504000007, 20.04242584800005],
              [86.23023522200003, 20.035305080000057],
              [86.26856530000003, 20.02643463700008],
              [86.27344811300003, 20.026190497000073],
              [86.28467858200008, 20.027492580000057],
              [86.28907311300003, 20.02643463700008],
              [86.29322350400008, 20.021429755000042],
              [86.29411868600005, 20.015692450000074],
              [86.29420006600003, 20.01040273600006],
              [86.29590905000003, 20.00657786700009],
              [86.30290774800005, 19.99909088700008],
              [86.30811608200008, 19.99209219000005],
              [86.31495201900003, 19.986883856000077],
              [86.32667076900003, 19.984849351000037],
              [86.34156334700003, 19.97988515800006],
              [86.35645592500003, 19.970404364000046],
              [86.37240644600007, 19.964992580000057],
              [86.26856530000003, 19.91034577000005],
              [86.11158287900008, 19.85569896000004],
              [86.08904056100005, 19.844224351000037],
              [86.07837975400008, 19.843573309000078],
              [86.06674238400007, 19.851996161000045],
              [86.05665123800003, 19.85687897300005],
              [86.04656009200005, 19.85252513200004],
              [86.03793379000007, 19.84528229400007],
              [86.03207441500007, 19.841498114000046],
              [86.01351972700007, 19.839056708000044],
              [85.88884524800005, 19.80296458500004],
              [85.84636478000004, 19.795843817000048],
              [85.80860436300003, 19.773382880000042],
              [85.78882897200003, 19.765692450000074],
              [85.77808678500003, 19.76463450700004],
              [85.74439537900008, 19.765692450000074],
              [85.73438561300003, 19.763617255000042],
              [85.71485436300003, 19.75421784100007],
              [85.68458092500003, 19.747748114000046],
              [85.62427819100003, 19.718573309000078],
              [85.62598717500003, 19.72288646000004],
              [85.63599694100003, 19.726629950000074],
              [85.63795006600003, 19.731634833000044],
              [85.61426842500003, 19.72793203300006],
              [85.54916425900007, 19.690619208000044],
              [85.48047936300003, 19.66632721600007],
              [85.45679772200003, 19.663316148000035],
              [85.44988040500004, 19.66669342700004],
              [85.44752037900008, 19.674627997000073],
              [85.44678795700008, 19.690619208000044],
              [85.44312584700003, 19.69245026200008],
              [85.43685957100007, 19.691351630000042],
              [85.43043053500003, 19.69171784100007],
              [85.42628014400003, 19.69745514500005],
              [85.42701256600003, 19.70408763200004],
              [85.43165123800003, 19.704901434000078],
              [85.43685957100007, 19.70465729400007],
              [85.43930097700007, 19.70799388200004],
              [85.45085696700005, 19.71629466400009],
              [85.47754967500003, 19.723863023000035],
              [85.52198326900003, 19.739081122000073],
              [85.52556399800005, 19.734035549000055],
              [85.52344811300003, 19.72870514500005],
              [85.51889082100007, 19.721584377000056],
              [85.51498457100007, 19.71112702000005],
              [85.55884850400008, 19.738104559000078],
              [85.57650800900007, 19.745835679000038],
              [85.56763756600003, 19.750799872000073],
              [85.56324303500003, 19.75690338700008],
              [85.56413821700005, 19.76439036700009],
              [85.57032311300003, 19.773179429000038],
              [85.56714928500003, 19.79165273600006],
              [85.57032311300003, 19.87563711100006],
              [85.55713951900003, 19.881781317000048],
              [85.51498457100007, 19.88930898600006],
              [85.47681725400008, 19.90102773600006],
              [85.46355228000004, 19.902899481000077],
              [85.44011478000004, 19.896226304000038],
              [85.41627037900008, 19.879787502000056],
              [85.37452233200008, 19.83779531500005],
              [85.31959069100003, 19.79364655200004],
              [85.30420983200008, 19.792669989000046],
              [85.29029381600003, 19.789943752000056],
              [85.27808678500003, 19.785589911000045],
              [85.26807701900003, 19.78001536700009],
              [85.24683678500003, 19.762640692000048],
              [85.22095787900008, 19.736029364000046],
              [85.20337975400008, 19.70726146000004],
              [85.20655358200008, 19.68378327000005],
              [85.18995201900003, 19.67096588700008],
              [85.17514082100007, 19.63690827000005],
              [85.16553795700008, 19.625799872000073],
              [85.15015709700003, 19.61347077000005],
              [85.14014733200008, 19.596584377000056],
              [85.13933353000004, 19.579779364000046],
              [85.15137780000003, 19.56777578300006],
              [85.15137780000003, 19.560288804000038],
              [85.13917076900003, 19.557074286000045],
              [85.12289472700007, 19.54901764500005],
              [85.10889733200008, 19.53896719000005],
              [85.10287519600007, 19.52960846600007],
              [85.10450280000003, 19.514878648000035],
              [85.10873457100007, 19.506781317000048],
              [85.11548912900008, 19.507473049000055],
              [85.12403405000003, 19.519354559000078],
              [85.12875410200007, 19.509507554000038],
              [85.13021894600007, 19.49872467700004],
              [85.12867272200003, 19.487982489000046],
              [85.12403405000003, 19.478338934000078],
              [85.13575280000003, 19.481594143000052],
              [85.14177493600005, 19.487127997000073],
              [85.14576256600003, 19.493475653000075],
              [85.15137780000003, 19.498846747000073],
              [85.16244550900007, 19.50348541900007],
              [85.17115319100003, 19.504461981000077],
              [85.17855879000007, 19.504299221000053],
              [85.18555748800003, 19.505682684000078],
              [85.20289147200003, 19.51715729400007],
              [85.20191491000003, 19.527085679000038],
              [85.19629967500003, 19.53847890800006],
              [85.19922936300003, 19.55410390800006],
              [85.20630944100003, 19.548000393000052],
              [85.21452884200005, 19.547267971000053],
              [85.22364342500003, 19.549953518000052],
              [85.23324629000007, 19.55410390800006],
              [85.20378665500004, 19.57050202000005],
              [85.19304446700005, 19.573919989000046],
              [85.19304446700005, 19.58079661700009],
              [85.21290123800003, 19.58112213700008],
              [85.22364342500003, 19.590236721000053],
              [85.23259524800005, 19.60154857000009],
              [85.24756920700008, 19.608710028000075],
              [85.24756920700008, 19.614935614000046],
              [85.24187259200005, 19.617010809000078],
              [85.23731530000003, 19.62055084800005],
              [85.23438561300003, 19.62567780200004],
              [85.23324629000007, 19.632554429000038],
              [85.23633873800003, 19.635321356000077],
              [85.24781334700003, 19.653143622000073],
              [85.24756920700008, 19.65648021000004],
              [85.26075280000003, 19.656073309000078],
              [85.30909264400003, 19.642238674000055],
              [85.35059655000003, 19.67763906500005],
              [85.36378014400003, 19.67804596600007],
              [85.37435957100007, 19.674709377000056],
              [85.38306725400008, 19.67609284100007],
              [85.39144941500007, 19.690619208000044],
              [85.39918053500003, 19.67914459800005],
              [85.40316816500007, 19.67129140800006],
              [85.40495853000004, 19.661932684000078],
              [85.40528405000003, 19.64594147300005],
              [85.40219160200007, 19.64398834800005],
              [85.38868248800003, 19.63825104400007],
              [85.38461347700007, 19.635972398000035],
              [85.38217207100007, 19.63108958500004],
              [85.38038170700008, 19.619614976000037],
              [85.37794030000003, 19.614935614000046],
              [85.36841881600003, 19.60809967700004],
              [85.35230553500003, 19.599432684000078],
              [85.33676191500007, 19.596096096000053],
              [85.33008873800003, 19.60496653900009],
              [85.32642662900008, 19.618801174000055],
              [85.31836998800003, 19.619533596000053],
              [85.31104576900003, 19.610500393000052],
              [85.30909264400003, 19.595038153000075],
              [85.30347741000003, 19.597479559000078],
              [85.29379316500007, 19.599554755000042],
              [85.28842207100007, 19.601263739000046],
              [85.30250084700003, 19.58665599200009],
              [85.30583743600005, 19.580145575000074],
              [85.30290774800005, 19.573919989000046],
              [85.33057701900003, 19.57640208500004],
              [85.57650800900007, 19.690619208000044],
              [85.54029381600003, 19.669582424000055],
              [85.46338951900003, 19.63104889500005],
              [85.38021894600007, 19.593817450000074],
              [85.33668053500003, 19.57518138200004],
              [85.28541100400008, 19.536281643000052],
              [85.24057050900007, 19.518052476000037],
              [85.18043053500003, 19.475002346000053],
              [85.06950931100005, 19.37213776200008],
              [84.99586022200003, 19.32330963700008],
              [84.87208092500003, 19.219875393000052],
              [84.79102623800003, 19.12059153900009],
              [84.77776126400005, 19.11619700700004],
              [84.77515709700003, 19.115301825000074],
              [84.76441491000003, 19.123439846000053],
              [84.75066165500004, 19.138373114000046],
              [84.73878014400003, 19.147650458000044],
              [84.73365319100003, 19.139146226000037],
              [84.73121178500003, 19.12881094000005],
              [84.72095787900008, 19.11424388200004],
              [84.71998131600003, 19.101629950000074],
              [84.72282962300005, 19.09601471600007],
              [84.73536217500003, 19.083197333000044],
              [84.74048912900008, 19.07367584800005],
              [84.75684655000003, 19.09764232000009],
              [84.76099694100003, 19.101629950000074],
              [84.76783287900008, 19.10179271000004],
              [84.77523847700007, 19.100490627000056],
              [84.78003991000003, 19.09707265800006],
              [84.77833092500003, 19.091009833000044],
              [84.75114993600005, 19.053900458000044],
              [84.74105879000007, 19.028143622000073],
              [84.69947350400008, 18.977484442000048],
              [84.67953535200007, 18.945705471000053],
              [84.66504967500003, 18.930121161000045],
              [84.63086998800003, 18.915716864000046],
              [84.54786217500003, 18.796087958000044],
              [84.54184004000007, 18.775783596000053],
              [84.44825280000003, 18.68065013200004],
              [84.43718509200005, 18.66278717700004],
              [84.43262780000003, 18.645697333000044],
              [84.42367597700007, 18.636460679000038],
              [84.37045332100007, 18.601304429000038],
              [84.34945722700007, 18.56981028900009],
              [84.33285566500007, 18.55369700700004],
              [84.31226647200003, 18.546698309000078],
              [84.30632571700005, 18.54368724200009],
              [84.28858483200008, 18.529771226000037],
              [84.28174889400003, 18.52558014500005],
              [84.27271569100003, 18.524318752000056],
              [84.25001061300003, 18.524237372000073],
              [84.24691816500007, 18.52558014500005],
              [84.23764082100007, 18.510931708000044],
              [84.24935957100007, 18.501654364000046],
              [84.27100670700008, 18.50018952000005],
              [84.29769941500007, 18.51630280200004],
              [84.32618248800003, 18.53742096600007],
              [84.34994550900007, 18.55292389500005],
              [84.33122806100005, 18.53864166900007],
              [84.28793379000007, 18.50576406500005],
              [84.24008222700007, 18.460760809000078],
              [84.23047936300003, 18.446234442000048],
              [84.18832441500007, 18.418036200000074],
              [84.17448978000004, 18.39984772300005],
              [84.15284264400003, 18.383612372000073],
              [84.14389082100007, 18.374823309000078],
              [84.13892662900008, 18.364162502000056],
              [84.13648522200003, 18.353583075000074],
              [84.13282311300003, 18.343410549000055],
              [84.12403405000003, 18.333807684000078],
              [84.11312910200007, 18.29828522300005],
              [84.07740319100003, 18.271551825000074],
              [83.77515709700003, 18.139593817000048],
              [83.61394290500004, 18.04515208500004],
              [83.58228600400008, 18.01911041900007],
              [83.57618248800003, 18.00975169500009],
              [83.56283613400007, 17.98309967700004],
              [83.55836022200003, 17.97752513200004],
              [83.55665123800003, 17.973456122000073],
              [83.53891035200007, 17.956284898000092],
              [83.53443444100003, 17.95331452000005],
              [83.52613366000003, 17.942531643000052],
              [83.48658287900008, 17.916896877000056],
              [83.47291100400008, 17.902492580000057],
              [83.46558678500003, 17.902492580000057],
              [83.46290123800003, 17.90851471600007],
              [83.45191491000003, 17.92291901200008],
              [83.44898522200003, 17.90688711100006],
              [83.45240319100003, 17.88621653900009],
              [83.45297285200007, 17.868475653000075],
              [83.43116295700008, 17.85423411700009],
              [83.42530358200008, 17.83860911700009],
              [83.41773522200003, 17.80621979400007],
              [83.40235436300003, 17.784491278000075],
              [83.34131920700008, 17.71743398600006],
              [83.31910241000003, 17.703192450000074],
              [83.31324303500003, 17.70115794500009],
              [83.30437259200005, 17.692206122000073],
              [83.29859459700003, 17.69013092700004],
              [83.29273522200003, 17.691148179000038],
              [83.28956139400003, 17.69326406500005],
              [83.28744550900007, 17.695379950000074],
              [83.28467858200008, 17.69635651200008],
              [83.28223717500003, 17.699286200000074],
              [83.28028405000003, 17.705959377000056],
              [83.27637780000003, 17.71308014500005],
              [83.26823978000004, 17.71747467700004],
              [83.24691816500007, 17.71625397300005],
              [83.24203535200007, 17.70652903900009],
              [83.24927819100003, 17.695379950000074],
              [83.27198326900003, 17.68813711100006],
              [83.29249108200008, 17.677476304000038],
              [83.29859459700003, 17.672796942000048],
              [83.29908287900008, 17.66429271000004],
              [83.28923587300005, 17.65761953300006],
              [83.26823978000004, 17.648586330000057],
              [83.25513756600003, 17.63812897300005],
              [83.24691816500007, 17.63422272300005],
              [83.21290123800003, 17.634914455000057],
              [83.23389733200008, 17.60773346600007],
              [83.23894290500004, 17.592962958000044],
              [83.22291100400008, 17.586493231000077],
              [83.20923912900008, 17.583685614000046],
              [83.19613691500007, 17.57680898600006],
              [83.17139733200008, 17.559800523000092],
              [83.08822675900007, 17.53070709800005],
              [83.05323326900003, 17.50649648600006],
              [83.01986738400007, 17.49091217700004],
              [82.99642988400007, 17.473456122000073],
              [82.97584069100003, 17.453680731000077],
              [82.96957441500007, 17.450100002000056],
              [82.95281009200005, 17.44594961100006],
              [82.94548587300005, 17.443101304000038],
              [82.89682050900007, 17.409328518000052],
              [82.88868248800003, 17.41014232000009],
              [82.88331139400003, 17.42206452000005],
              [82.86915123800003, 17.414007880000042],
              [82.85425866000008, 17.402818101000037],
              [82.83765709700003, 17.39276764500005],
              [82.79639733200008, 17.38304271000004],
              [82.75814863400007, 17.359198309000078],
              [82.71851647200003, 17.34861888200004],
              [82.47486412900008, 17.205959377000056],
              [82.45191491000008, 17.182440497000073],
              [82.43506920700008, 17.15379466400009],
              [82.42286217500003, 17.139960028000075],
              [82.38770592500003, 17.12693919500009],
              [82.37037194100003, 17.11009349200009],
              [82.34205162900008, 17.073187567000048],
              [82.31169681100005, 17.046616929000038],
              [82.29932701900003, 17.03034088700008],
              [82.29167728000004, 16.998439846000053],
              [82.25269616000008, 16.92918528900009],
              [82.25074303500008, 16.907863674000055],
              [82.25513756600003, 16.885321356000077],
              [82.26791425900007, 16.86749909100007],
              [82.29835045700008, 16.85846588700008],
              [82.30355879000007, 16.85419342700004],
              [82.30811608200008, 16.849554755000042],
              [82.31421959700003, 16.846625067000048],
              [82.31959069100003, 16.84723541900007],
              [82.32715905000003, 16.849432684000078],
              [82.33334394600007, 16.852118231000077],
              [82.33464603000004, 16.854071356000077],
              [82.35206139400003, 16.845404364000046],
              [82.36247806100005, 16.859076239000046],
              [82.36117597700007, 16.89134349200009],
              [82.35743248800003, 16.92487213700008],
              [82.34888756600003, 16.95648834800005],
              [82.36117597700007, 16.936021226000037],
              [82.36654707100007, 16.908636786000045],
              [82.36744225400008, 16.860296942000048],
              [82.36557050900007, 16.81159088700008],
              [82.35206139400003, 16.76129791900007],
              [82.34595787900008, 16.70612213700008],
              [82.33814537900008, 16.67841217700004],
              [82.31421959700003, 16.628159898000092],
              [82.31234785200007, 16.61985911700009],
              [82.31381269600007, 16.612982489000046],
              [82.31283613400007, 16.60814036700009],
              [82.30396569100003, 16.60643138200004],
              [82.29932701900003, 16.61009349200009],
              [82.29379316500007, 16.62563711100006],
              [82.28687584700003, 16.628159898000092],
              [82.28093509200005, 16.620835679000038],
              [82.28549238400007, 16.60651276200008],
              [82.29607181100005, 16.591009833000044],
              [82.30738366000008, 16.579779364000046],
              [82.25904381600003, 16.56549713700008],
              [82.20346113400007, 16.51268138200004],
              [82.18824303500008, 16.504055080000057],
              [82.17302493600005, 16.500921942000048],
              [82.12289472700007, 16.477362372000073],
              [82.09066816500007, 16.454779364000046],
              [82.06861412900008, 16.444281317000048],
              [82.03736412900008, 16.447658596000053],
              [82.02271569100003, 16.43573639500005],
              [82.00782311300003, 16.419582424000055],
              [81.99268639400003, 16.40843333500004],
              [81.98170006600003, 16.407863674000055],
              [81.96794681100005, 16.40892161700009],
              [81.95622806100005, 16.407171942000048],
              [81.94809004000007, 16.391546942000048],
              [81.94076582100007, 16.388373114000046],
              [81.89991295700008, 16.38580963700008],
              [81.88054446700005, 16.381659247000073],
              [81.86166425900007, 16.375392971000053],
              [81.78321373800003, 16.33856842700004],
              [81.76295006600003, 16.32257721600007],
              [81.71762129000007, 16.312201239000046],
              [81.71159915500004, 16.312201239000046],
              [81.69605553500008, 16.314927476000037],
              [81.67693118600005, 16.327378648000092],
              [81.65626061300003, 16.33734772300005],
              [81.63640384200005, 16.33270905200004],
              [81.62094160200007, 16.339504299000055],
              [81.58497155000003, 16.34210846600007],
              [81.56812584700003, 16.34638092700004],
              [81.57390384200005, 16.358343817000048],
              [81.56918379000007, 16.367580471000053],
              [81.55697675900007, 16.37303294500009],
              [81.54021243600005, 16.37368398600006],
              [81.54908287900008, 16.352362372000073],
              [81.53598066500007, 16.350043036000045],
              [81.49586022200003, 16.360663153000075],
              [81.47535241000008, 16.358628648000092],
              [81.41667728000004, 16.34015534100007],
              [81.42115319100003, 16.35097890800006],
              [81.42611738400007, 16.358710028000075],
              [81.42823326900003, 16.365668036000045],
              [81.42408287900008, 16.37368398600006],
              [81.41138756600003, 16.382513739000046],
              [81.39893639400003, 16.382635809000078],
              [81.38697350400008, 16.376776434000078],
              [81.37574303500008, 16.36749909100007],
              [81.35962975400008, 16.374335028000075],
              [81.34522545700008, 16.373602606000077],
              [81.33155358200008, 16.36977773600006],
              [81.31739342500003, 16.36749909100007],
              [81.25961347700007, 16.33270905200004],
              [81.24854576900003, 16.320135809000078],
              [81.24984785200007, 16.311021226000037],
              [81.25603274800005, 16.30182526200008],
              [81.25961347700007, 16.28864166900007],
              [81.25416100400008, 16.271307684000078],
              [81.23031660200007, 16.24359772300005],
              [81.21851647200003, 16.19944896000004],
              [81.19027754000007, 16.13886139500005],
              [81.18002363400007, 16.086737372000073],
              [81.16195722700007, 16.057074286000045],
              [81.15601647200003, 16.03851959800005],
              [81.15544681100005, 15.985500393000052],
              [81.14975019600007, 15.969631252000056],
              [81.13510175900007, 15.966498114000046],
              [81.08822675900007, 15.921210028000075],
              [81.04330488400007, 15.894110419000071],
              [81.02686608200008, 15.88084544500009],
              [80.99887129000007, 15.84674713700008],
              [80.99838300900007, 15.83470286700009],
              [81.00294030000003, 15.82526276200008],
              [81.00879967500003, 15.81781647300005],
              [81.01254316500007, 15.81195709800005],
              [81.01921634200005, 15.792385158000059],
              [81.01905358200008, 15.78416575700004],
              [81.01254316500007, 15.777818101000037],
              [81.00473066500007, 15.778509833000044],
              [80.99586022200003, 15.784328518000052],
              [80.98829186300003, 15.791205145000049],
              [80.97901451900003, 15.803412177000041],
              [80.94947350400008, 15.827866929000038],
              [80.94068444100003, 15.83299388200004],
              [80.92164147200003, 15.83860911700009],
              [80.91000410200007, 15.852687893000052],
              [80.90430748800003, 15.871283270000049],
              [80.90267988400007, 15.890814520000049],
              [80.91016686300003, 15.96588776200008],
              [80.90894616000008, 15.98346588700008],
              [80.90601647200003, 15.999823309000078],
              [80.89649498800003, 16.031073309000078],
              [80.89226321700005, 16.02094147300005],
              [80.89649498800003, 16.010565497000073],
              [80.88900800900007, 16.003729559000078],
              [80.88575280000003, 16.008693752000056],
              [80.88282311300003, 16.011460679000038],
              [80.87533613400007, 16.017401434000078],
              [80.89128665500004, 15.978257554000038],
              [80.89576256600003, 15.936021226000037],
              [80.89014733200008, 15.89524974200009],
              [80.85572350400008, 15.822699286000045],
              [80.83025149800005, 15.747626044000071],
              [80.82007897200003, 15.72687409100007],
              [80.80713951900003, 15.716376044000071],
              [80.80836022200003, 15.803941148000092],
              [80.80274498800003, 15.84243398600006],
              [80.77613366000008, 15.884263414000088],
              [80.76010175900007, 15.892971096000053],
              [80.73633873800003, 15.897609768000052],
              [80.69044030000003, 15.90070221600007],
              [80.68246504000007, 15.903265692000048],
              [80.67628014400003, 15.907171942000048],
              [80.67017662900008, 15.907700914000088],
              [80.66309655000003, 15.90070221600007],
              [80.66041100400008, 15.893947658000059],
              [80.66285241000008, 15.889349677000041],
              [80.61841881600003, 15.88768138200004],
              [80.60010826900003, 15.882228908000059],
              [80.58432050900007, 15.872544664000088],
              [80.57113691500007, 15.868719794000071],
              [80.56072024800005, 15.88084544500009],
              [80.55388431100005, 15.88084544500009],
              [80.54167728000004, 15.868068752000056],
              [80.52588951900003, 15.856919664000088],
              [80.49187259200005, 15.839260158000059],
              [80.48267662900008, 15.836411851000037],
              [80.47559655000003, 15.83592357000009],
              [80.46908613400007, 15.834662177000041],
              [80.46143639400003, 15.829657294000071],
              [80.44548587300005, 15.814398505000042],
              [80.43628991000008, 15.808294989000046],
              [80.39332116000008, 15.797023830000057],
              [80.35962975400008, 15.775824286000045],
              [80.27963300900007, 15.700669664000088],
              [80.26319420700008, 15.67454661700009],
              [80.21949303500008, 15.56745026200008],
              [80.21745853000004, 15.548163153000075],
              [80.20134524800005, 15.51829661700009],
              [80.19760175900007, 15.503078518000052],
              [80.21119225400008, 15.496649481000077],
              [80.20045006600003, 15.482163804000038],
              [80.18384850400008, 15.452297268000052],
              [80.17286217500003, 15.438299872000073],
              [80.14031009200005, 15.406398830000057],
              [80.12680097700007, 15.38812897300005],
              [80.12126712300005, 15.370021877000056],
              [80.09058678500008, 15.304877020000049],
              [80.09253991000008, 15.296576239000046],
              [80.08236738400007, 15.20408763200004],
              [80.05298912900008, 15.092596747000073],
              [80.05453535200007, 15.014146226000037],
              [80.06153405000003, 14.974676825000074],
              [80.07341556100005, 14.94204336100006],
              [80.07300866000008, 14.92055898600006],
              [80.10515384200005, 14.763861395000049],
              [80.10816491000008, 14.714341539000088],
              [80.11068769600007, 14.704779364000046],
              [80.11695397200003, 14.698146877000056],
              [80.12818444100003, 14.68846263200004],
              [80.15186608200008, 14.672796942000048],
              [80.15984134200005, 14.662665106000077],
              [80.16635175900007, 14.628159898000092],
              [80.17359459700003, 14.616522528000075],
              [80.17847741000008, 14.60578034100007],
              [80.17595462300005, 14.592962958000044],
              [80.16968834700003, 14.58584219000005],
              [80.16089928500008, 14.579820054000038],
              [80.14185631600003, 14.571234442000048],
              [80.14918053500008, 14.565008856000077],
              [80.15935306100005, 14.565741278000075],
              [80.18327884200005, 14.571112372000073],
              [80.19019616000008, 14.571234442000048],
              [80.19695071700005, 14.565008856000077],
              [80.19605553500008, 14.559027411000045],
              [80.19239342500003, 14.553208726000037],
              [80.19019616000008, 14.54759349200009],
              [80.18824303500008, 14.52570221600007],
              [80.17595462300005, 14.46873607000009],
              [80.17872155000003, 14.38939036700009],
              [80.17497806100005, 14.344549872000073],
              [80.15943444100003, 14.324774481000077],
              [80.13705488400007, 14.269924221000053],
              [80.12818444100003, 14.256537177000041],
              [80.09791100400008, 14.254299221000053],
              [80.08716881600003, 14.25031159100007],
              [80.07178795700008, 14.232245184000078],
              [80.07007897200003, 14.229193427000041],
              [80.05502363400007, 14.221584377000056],
              [80.04664147200003, 14.206610419000071],
              [80.05062910200007, 14.196112372000073],
              [80.07349694100003, 14.201849677000041],
              [80.09099368600005, 14.216742255000042],
              [80.10661868600005, 14.234035549000055],
              [80.12110436300003, 14.242010809000078],
              [80.13559004000007, 14.229193427000041],
              [80.12338300900007, 14.193508205000057],
              [80.12582441500007, 14.148504950000074],
              [80.14966881600003, 14.027736721000053],
              [80.16391035200007, 13.987982489000046],
              [80.23715254000007, 13.839667059000078],
              [80.24927819100003, 13.800279039000088],
              [80.24545332100007, 13.755601304000038],
              [80.22738691500007, 13.720526434000078],
              [80.22095787900008, 13.696966864000046],
              [80.22771243600005, 13.677069403000075],
              [80.23804772200003, 13.660223700000074],
              [80.25904381600003, 13.591742255000042],
              [80.28809655000003, 13.527085679000038],
              [80.30958092500003, 13.479315497000073],
              [80.31373131600003, 13.440904039000088],
              [80.30689537900008, 13.440904039000088],
              [80.27776126400005, 13.512518622000073],
              [80.24545332100007, 13.591742255000042],
              [80.19727623800003, 13.64362213700008],
              [80.18360436300003, 13.679185289000088],
              [80.15251712300005, 13.718939520000049],
              [80.14185631600003, 13.728949286000045],
              [80.14177493600005, 13.649115302000041],
              [80.13559004000007, 13.619086005000042],
              [80.12126712300005, 13.62726471600007],
              [80.11768639400003, 13.638861395000049],
              [80.12126712300005, 13.663763739000046],
              [80.11784915500004, 13.674505927000041],
              [80.10987389400003, 13.68073151200008],
              [80.10084069100003, 13.68626536700009],
              [80.09400475400008, 13.69476959800005],
              [80.09359785200007, 13.67133209800005],
              [80.09131920700008, 13.659125067000048],
              [80.07553144600007, 13.648382880000042],
              [80.05298912900008, 13.619086005000042],
              [80.05648847700007, 13.59516022300005],
              [80.06950931100005, 13.574408270000049],
              [80.10132897200003, 13.53709544500009],
              [80.11207116000008, 13.511542059000078],
              [80.11939537900008, 13.500677802000041],
              [80.13184655000003, 13.496161200000074],
              [80.15308678500008, 13.494208075000074],
              [80.17595462300005, 13.48932526200008],
              [80.21973717500003, 13.487779039000088],
              [80.22771243600005, 13.485581773000092],
              [80.23511803500008, 13.478094794000071],
              [80.24341881600003, 13.472154039000088],
              [80.25342858200008, 13.46865469000005],
              [80.26018313900005, 13.468451239000046],
              [80.26587975400008, 13.468247789000088],
              [80.26238040500004, 13.451239325000074],
              [80.27475019600007, 13.440008856000077],
              [80.29314212300005, 13.42914459800005],
              [80.30689537900008, 13.413031317000048],
              [80.31226647200003, 13.423163153000075],
              [80.31373131600003, 13.427232164000088],
              [80.32699629000007, 13.430365302000041],
              [80.33399498800003, 13.413031317000048],
              [80.34400475400008, 13.375433661000045],
              [80.34782962300005, 13.34906647300005],
              [80.34555097700007, 13.321234442000048],
              [80.33627363400007, 13.27094147300005],
              [80.33415774800005, 13.24290599200009],
              [80.32374108200008, 13.246893622000073],
              [80.31983483200008, 13.249172268000052],
              [80.31804446700005, 13.230902411000045],
              [80.31373131600003, 13.215033270000049],
              [80.31820722700007, 13.216986395000049],
              [80.33415774800005, 13.221177476000037],
              [80.33277428500008, 13.198146877000056],
              [80.32422936300003, 13.180365302000041],
              [80.31381269600007, 13.16429271000004],
              [80.30689537900008, 13.146063544000071],
              [80.30713951900003, 13.135646877000056],
              [80.31373131600003, 13.10578034100007],
              [80.30795332100007, 13.09601471600007],
              [80.28972415500004, 13.076727606000077],
              [80.28581790500004, 13.067572333000044],
              [80.28272545700008, 13.029364325000074],
              [80.26905358200008, 12.95726146000004],
              [80.26319420700008, 12.835353908000059],
              [80.25171959700003, 12.762518622000073],
              [80.23365319100003, 12.711004950000074],
              [80.22868899800005, 12.674994208000044],
              [80.22217858200008, 12.659979559000078],
              [80.20386803500008, 12.632147528000075],
              [80.19646243600005, 12.613714911000045],
              [80.18506920700008, 12.56712474200009],
              [80.18336022200003, 12.546820380000042],
              [80.17969811300003, 12.532619533000059],
              [80.15601647200003, 12.47451406500005],
              [80.12126712300005, 12.416815497000073],
              [80.11703535200007, 12.400946356000077],
              [80.09595787900008, 12.362250067000048],
              [80.08716881600003, 12.35101959800005],
              [80.06373131600003, 12.337469794000071],
              [80.05982506600003, 12.33421458500004],
              [80.05746504000007, 12.331244208000044],
              [80.02572675900007, 12.276516018000052],
              [80.00513756600003, 12.256048895000049],
              [79.95215905000003, 12.22992584800005],
              [79.94385826900003, 12.21784088700008],
              [79.95313561300003, 12.213568427000041],
              [79.97380618600005, 12.222398179000038],
              [80.00513756600003, 12.241766669000071],
              [79.94760175900007, 12.153631903000075],
              [79.93360436300003, 12.138739325000074],
              [79.92750084700003, 12.12986888200004],
              [79.89698326900003, 12.068752346000053],
              [79.87012780000003, 12.03742096600007],
              [79.86182701900003, 12.022040106000077],
              [79.86052493600005, 12.011542059000078],
              [79.86182701900003, 11.97797272300005],
              [79.85962975400008, 11.972723700000074],
              [79.85035241000008, 11.959133205000057],
              [79.84953860800005, 11.95506419500009],
              [79.84498131600003, 11.933254299000055],
              [79.82032311300003, 11.878648179000038],
              [79.80323326900003, 11.796087958000044],
              [79.79273522200003, 11.78807200700004],
              [79.78589928500008, 11.769191799000055],
              [79.76710045700008, 11.673651434000078],
              [79.76343834700003, 11.634263414000088],
              [79.75416100400008, 11.596991278000075],
              [79.75196373800003, 11.576971747000073],
              [79.75733483200008, 11.536078192000048],
              [79.78077233200008, 11.46507396000004],
              [79.78598066500007, 11.426174221000053],
              [79.79297936300003, 11.426174221000053],
              [79.79737389400003, 11.434881903000075],
              [79.79916425900007, 11.442206122000073],
              [79.79761803500008, 11.44830963700008],
              [79.79297936300003, 11.453517971000053],
              [79.80933678500008, 11.451361395000049],
              [79.81666100400008, 11.443060614000046],
              [79.82195071700005, 11.391058661000045],
              [79.81934655000003, 11.38149648600006],
              [79.81031334700003, 11.37889232000009],
              [79.78272545700008, 11.37889232000009],
              [79.77605228000004, 11.380357164000088],
              [79.76929772200003, 11.380926825000074],
              [79.75879967500003, 11.37836334800005],
              [79.74984785200007, 11.37368398600006],
              [79.74040774800005, 11.366441148000092],
              [79.68433678500008, 11.312201239000046],
              [79.67628014400003, 11.296454169000071],
              [79.68311608200008, 11.296454169000071],
              [79.69629967500003, 11.303412177000041],
              [79.74203535200007, 11.335598049000055],
              [79.75196373800003, 11.340521552000041],
              [79.75928795700008, 11.358343817000048],
              [79.77637780000003, 11.362982489000046],
              [79.79688561300003, 11.359035549000055],
              [79.82374108200008, 11.34666575700004],
              [79.82992597700007, 11.346096096000053],
              [79.83301842500003, 11.341986395000049],
              [79.83497155000003, 11.263861395000049],
              [79.85531660200007, 11.159857489000046],
              [79.85222415500004, 11.006984768000052],
              [79.84669030000003, 10.979844468000067],
              [79.84066816500007, 10.950140692000048],
              [79.84734134200005, 10.80963776200008],
              [79.84986412900008, 10.755194403000075],
              [79.85027103000004, 10.59210846600007],
              [79.85962975400008, 10.551459052000041],
              [79.86378014400003, 10.378729559000078],
              [79.85670006600003, 10.29328034100007],
              [79.85132897200003, 10.28221263200004],
              [79.83432050900007, 10.27875397300005],
              [79.81462649800005, 10.272406317000048],
              [79.79509524800005, 10.269232489000046],
              [79.77857506600003, 10.27537669500009],
              [79.78003991000008, 10.296616929000038],
              [79.75709069100003, 10.309068101000037],
              [79.63314863400007, 10.328599351000037],
              [79.62126712300005, 10.324164130000042],
              [79.61410566500007, 10.30955638200004],
              [79.63038170700008, 10.310492255000042],
              [79.64649498800003, 10.30963776200008],
              [79.66179446700005, 10.307074286000045],
              [79.67628014400003, 10.30272044500009],
              [79.68458092500003, 10.29873281500005],
              [79.69467207100007, 10.29165273600006],
              [79.70362389400003, 10.28904857000009],
              [79.73080488400007, 10.28904857000009],
              [79.75896243600005, 10.28221263200004],
              [79.77369225400008, 10.27366771000004],
              [79.77247155000003, 10.26170482000009],
              [79.75977623800003, 10.258246161000045],
              [79.58008873800003, 10.29588450700004],
              [79.56348717500003, 10.29710521000004],
              [79.55665123800003, 10.298651434000078],
              [79.55274498800003, 10.30272044500009],
              [79.55176842500003, 10.313299872000073],
              [79.55689537900008, 10.316066799000055],
              [79.56519616000008, 10.315741278000075],
              [79.57390384200005, 10.316961981000077],
              [79.60401451900003, 10.32908763200004],
              [79.60710696700005, 10.336004950000074],
              [79.58692467500003, 10.343695380000042],
              [79.56771894600007, 10.335882880000042],
              [79.52857506600003, 10.338324286000045],
              [79.53223717500003, 10.330023505000042],
              [79.53223717500003, 10.323187567000048],
              [79.51148522200003, 10.316595770000049],
              [79.45972741000008, 10.308294989000046],
              [79.43726647200003, 10.30955638200004],
              [79.41195722700007, 10.320990302000041],
              [79.39812259200005, 10.324652411000045],
              [79.38550866000008, 10.320135809000078],
              [79.36378014400003, 10.301906643000052],
              [79.30494225400008, 10.268133856000077],
              [79.28614342500003, 10.252834377000056],
              [79.27222741000008, 10.234442450000074],
              [79.27027428500008, 10.223334052000041],
              [79.27068118600005, 10.209540106000077],
              [79.26921634200005, 10.197821356000077],
              [79.26197350400008, 10.192857164000088],
              [79.24830162900008, 10.189195054000038],
              [79.24000084700003, 10.179754950000074],
              [79.23633873800003, 10.166571356000077],
              [79.23747806100005, 10.151922919000071],
              [79.24431399800005, 10.08494700700004],
              [79.25416100400008, 10.054266669000071],
              [79.27906334700003, 10.035834052000041],
              [79.24073326900003, 10.010565497000073],
              [79.20036868600005, 9.970282294000071],
              [79.14185631600003, 9.891180731000077],
              [79.12134850400008, 9.85024648600006],
              [79.10352623800003, 9.830145575000074],
              [79.10084069100003, 9.82607656500005],
              [79.09408613400007, 9.802313544000071],
              [79.07781009200005, 9.782171942000048],
              [79.03882897200003, 9.747219143000052],
              [78.98080488400007, 9.667181708000044],
              [78.97982832100007, 9.658636786000045],
              [78.98023522200003, 9.649115302000041],
              [78.97730553500008, 9.637925523000092],
              [78.97282962300005, 9.631293036000045],
              [78.96208743600005, 9.622707424000055],
              [78.95679772200003, 9.61749909100007],
              [78.94752037900008, 9.602850653000075],
              [78.93832441500007, 9.583685614000046],
              [78.93148847700007, 9.561672268000052],
              [78.92530358200008, 9.513617255000042],
              [78.91325931100005, 9.474269924000055],
              [78.91529381600003, 9.45302969000005],
              [78.93344160200007, 9.416449286000045],
              [78.95972741000008, 9.384955145000049],
              [79.03988691500007, 9.31468333500004],
              [79.07471764400003, 9.29987213700008],
              [79.11557050900007, 9.29124583500004],
              [79.25171959700003, 9.28851959800005],
              [79.27377363400007, 9.296698309000078],
              [79.29712975400008, 9.312648830000057],
              [79.32007897200003, 9.32330963700008],
              [79.34107506600003, 9.31586334800005],
              [79.34571373800003, 9.30654531500005],
              [79.34253991000008, 9.299017645000049],
              [79.33668053500008, 9.29047272300005],
              [79.33366946700005, 9.278265692000048],
              [79.33570397200003, 9.267645575000074],
              [79.34058678500008, 9.260931708000044],
              [79.34522545700008, 9.255926825000074],
              [79.34734134200005, 9.25031159100007],
              [79.35352623800003, 9.240912177000041],
              [79.36793053500008, 9.22760651200008],
              [79.43824303500008, 9.176336981000077],
              [79.45362389400003, 9.159002997000073],
              [79.44027754000007, 9.15135325700004],
              [79.42400149800005, 9.159084377000056],
              [79.36101321700005, 9.213446356000077],
              [79.29273522200003, 9.25031159100007],
              [79.23243248800003, 9.257879950000074],
              [79.21697024800005, 9.267401434000078],
              [79.20101972700007, 9.266506252000056],
              [79.18409264400003, 9.27179596600007],
              [79.16537519600007, 9.274237372000073],
              [79.12940514400003, 9.256333726000037],
              [79.09864342500003, 9.257228908000059],
              [79.08716881600003, 9.25381094000005],
              [79.06080162900008, 9.264593817000048],
              [79.02572675900007, 9.27374909100007],
              [78.98894290500004, 9.278265692000048],
              [78.95679772200003, 9.27484772300005],
              [78.94898522200003, 9.27049388200004],
              [78.92896569100003, 9.25381094000005],
              [78.91846764400003, 9.251613674000055],
              [78.91130618600005, 9.252142645000049],
              [78.90447024800005, 9.253566799000055],
              [78.89551842500003, 9.25381094000005],
              [78.86101321700005, 9.248968817000048],
              [78.84376061300003, 9.243963934000078],
              [78.81519616000008, 9.22842031500005],
              [78.77711022200003, 9.21938711100006],
              [78.76156660200007, 9.20970286700009],
              [78.75196373800003, 9.200588283000059],
              [78.74073326900003, 9.19281647300005],
              [78.72779381600003, 9.187445380000042],
              [78.67628014400003, 9.184149481000077],
              [78.66130618600005, 9.17719147300005],
              [78.65512129000007, 9.16156647300005],
              [78.64893639400003, 9.15143463700008],
              [78.63477623800003, 9.144598700000074],
              [78.61882571700005, 9.14052969000005],
              [78.48585045700008, 9.124823309000078],
              [78.44988040500004, 9.116603908000059],
              [78.41211998800003, 9.09983958500004],
              [78.37745201900003, 9.077460028000075],
              [78.23975670700008, 8.96556224200009],
              [78.21762129000007, 8.938950914000088],
              [78.18279056100005, 8.877101955000057],
              [78.17790774800005, 8.861070054000038],
              [78.17448978000004, 8.794419664000088],
              [78.17042076900003, 8.771877346000053],
              [78.16236412900008, 8.753485419000071],
              [78.17579186300003, 8.76390208500004],
              [78.18873131600003, 8.765448309000078],
              [78.20045006600003, 8.769680080000057],
              [78.21021569100003, 8.788275458000044],
              [78.21517988400007, 8.765448309000078],
              [78.20460045700008, 8.753322658000059],
              [78.18653405000003, 8.744940497000073],
              [78.16920006600003, 8.733628648000092],
              [78.16480553500008, 8.726507880000042],
              [78.15495853000004, 8.698879299000055],
              [78.14047285200007, 8.680609442000048],
              [78.13672936300003, 8.669867255000042],
              [78.14258873800003, 8.657904364000046],
              [78.11459394600007, 8.657904364000046],
              [78.13550866000008, 8.625799872000073],
              [78.14234459700003, 8.593085028000075],
              [78.12826582100007, 8.488023179000038],
              [78.12330162900008, 8.47752513200004],
              [78.11459394600007, 8.466131903000075],
              [78.08716881600003, 8.44049713700008],
              [78.07984459700003, 8.43195221600007],
              [78.06275475400008, 8.373195705000057],
              [78.05591881600003, 8.363714911000045],
              [78.03882897200003, 8.360907294000071],
              [77.99976647200003, 8.344916083000044],
              [77.80616295700008, 8.228664455000057],
              [77.79346764400003, 8.215318101000037],
              [77.76832116000008, 8.18154531500005],
              [77.75245201900003, 8.17381419500009],
              [77.64380944100003, 8.15570709800005],
              [77.59522545700008, 8.13898346600007],
              [77.56104576900003, 8.114569403000075],
              [77.56527754000007, 8.082505601000037],
              [77.51091556100005, 8.075995184000078],
              [77.44971764400003, 8.087469794000071],
              [77.31560306100005, 8.127752997000073],
              [77.30860436300003, 8.130926825000074],
              [77.29468834700003, 8.147040106000077],
              [77.28679446700005, 8.153509833000044],
              [77.26295006600003, 8.168402411000045],
              [77.23894290500004, 8.175116278000075],
              [77.22527103000004, 8.184393622000073],
              [77.12875410200007, 8.27179596600007],
              [77.11036217500003, 8.285183010000083],
              [76.99586022200003, 8.368109442000048],
              [76.96257571700005, 8.404689846000053],
              [76.88013756600003, 8.520697333000044],
              [76.82650800900007, 8.569810289000088],
              [76.81373131600003, 8.601263739000046],
              [76.74170983200008, 8.684515692000048],
              [76.73129316500007, 8.707953192000048],
              [76.69564863400007, 8.739813544000071],
              [76.66032962300005, 8.799750067000048],
              [76.64454186300003, 8.81899648600006],
              [76.55860436300003, 8.890692450000074],
              [76.54395592500003, 8.912502346000053],
              [76.54810631600003, 8.924221096000053],
              [76.55909264400003, 8.92523834800005],
              [76.57325280000003, 8.904445705000057],
              [76.59115644600007, 8.908148505000042],
              [76.60987389400003, 8.91795482000009],
              [76.62061608200008, 8.925441799000055],
              [76.60726972700007, 8.92576732000009],
              [76.59376061300003, 8.921047268000052],
              [76.58155358200008, 8.91990794500009],
              [76.57227623800003, 8.93162669500009],
              [76.57398522200003, 8.942572333000044],
              [76.58228600400008, 8.956366278000075],
              [76.59327233200008, 8.96820709800005],
              [76.60328209700003, 8.973211981000077],
              [76.65756269600007, 8.966376044000071],
              [76.66081790500004, 8.969875393000052],
              [76.65211022200003, 8.97728099200009],
              [76.64039147200003, 8.984442450000074],
              [76.63428795700008, 8.986883856000077],
              [76.64193769600007, 8.991359768000052],
              [76.65650475400008, 8.995062567000048],
              [76.66846764400003, 8.999823309000078],
              [76.66846764400003, 9.007391669000071],
              [76.65788821700005, 9.010687567000048],
              [76.64405358200008, 9.007879950000074],
              [76.63209069100003, 9.002346096000053],
              [76.62671959700003, 8.997463283000059],
              [76.62061608200008, 8.987127997000073],
              [76.60645592500003, 8.989406643000052],
              [76.58277428500008, 9.000555731000077],
              [76.57683353000004, 8.99412669500009],
              [76.56592858200008, 8.963283596000053],
              [76.55860436300003, 8.952093817000048],
              [76.55111738400007, 8.966376044000071],
              [76.55811608200008, 8.973049221000053],
              [76.56153405000003, 8.978989976000037],
              [76.56544030000003, 8.994330145000049],
              [76.54965254000007, 8.984442450000074],
              [76.53882897200003, 8.972601630000042],
              [76.53443444100003, 8.957831122000073],
              [76.53809655000003, 8.939113674000055],
              [76.52808678500008, 8.946966864000046],
              [76.52149498800003, 8.961330471000053],
              [76.51791425900007, 8.977443752000056],
              [76.51685631600003, 8.990627346000053],
              [76.51384524800005, 9.002142645000049],
              [76.50017337300005, 9.022284247000073],
              [76.48926842500003, 9.055568752000056],
              [76.46045983200008, 9.114935614000046],
              [76.46241295700008, 9.138332424000055],
              [76.46452884200005, 9.132513739000046],
              [76.46664472700007, 9.128973700000074],
              [76.46827233200008, 9.124579169000071],
              [76.46908613400007, 9.116603908000059],
              [76.47657311300003, 9.116603908000059],
              [76.47624759200005, 9.131252346000053],
              [76.48275800900007, 9.171820380000042],
              [76.47331790500004, 9.164252020000049],
              [76.47095787900008, 9.16014232000009],
              [76.46908613400007, 9.15135325700004],
              [76.46241295700008, 9.15135325700004],
              [76.44336998800003, 9.212144273000092],
              [76.42823326900003, 9.245347398000092],
              [76.41456139400003, 9.246975002000056],
              [76.41602623800003, 9.23631419500009],
              [76.44678795700008, 9.15961334800005],
              [76.44874108200008, 9.14516836100006],
              [76.44255618600005, 9.14516836100006],
              [76.36296634200005, 9.32518138200004],
              [76.31177819100003, 9.492987372000073],
              [76.29102623800003, 9.633205471000053],
              [76.29712975400008, 9.65843333500004],
              [76.27735436300003, 9.809271552000041],
              [76.25318444100003, 9.883734442000048],
              [76.24675540500004, 9.893744208000044],
              [76.24024498800003, 9.939398505000042],
              [76.23633873800003, 9.952704169000071],
              [76.25147545700008, 9.96312083500004],
              [76.26954186300003, 9.950995184000078],
              [76.28467858200008, 9.928534247000073],
              [76.29102623800003, 9.908596096000053],
              [76.28565514400003, 9.904364325000074],
              [76.26221764400003, 9.91156647300005],
              [76.25684655000003, 9.908596096000053],
              [76.25766035200007, 9.895819403000075],
              [76.26059004000007, 9.884711005000042],
              [76.26685631600003, 9.87604401200008],
              [76.27735436300003, 9.870754299000055],
              [76.27857506600003, 9.876898505000042],
              [76.28419030000003, 9.891180731000077],
              [76.28907311300003, 9.877142645000049],
              [76.28825931100005, 9.86123281500005],
              [76.28443444100003, 9.848211981000077],
              [76.28077233200008, 9.84284088700008],
              [76.28980553500008, 9.843817450000074],
              [76.29997806100005, 9.847805080000057],
              [76.30469811300003, 9.856268622000073],
              [76.29712975400008, 9.870754299000055],
              [76.30860436300003, 9.87962474200009],
              [76.31381269600007, 9.86131419500009],
              [76.33887780000003, 9.699408270000049],
              [76.34620201900003, 9.699408270000049],
              [76.34734134200005, 9.72687409100007],
              [76.33757571700005, 9.789252020000049],
              [76.34620201900003, 9.816107489000046],
              [76.32398522200003, 9.846177476000037],
              [76.32007897200003, 9.86163971600007],
              [76.33269290500004, 9.870754299000055],
              [76.33741295700008, 9.85618724200009],
              [76.35303795700008, 9.829820054000038],
              [76.35922285200007, 9.816107489000046],
              [76.36109459700003, 9.803859768000052],
              [76.35865319100003, 9.781805731000077],
              [76.35922285200007, 9.76829661700009],
              [76.36801191500007, 9.71556224200009],
              [76.37712649800005, 9.695502020000049],
              [76.39405358200008, 9.678941148000092],
              [76.39242597700007, 9.66282786700009],
              [76.38656660200007, 9.64984772300005],
              [76.37916100400008, 9.63776276200008],
              [76.37289472700007, 9.624335028000075],
              [76.35328209700003, 9.535345770000049],
              [76.35743248800003, 9.520697333000044],
              [76.37671959700003, 9.514471747000073],
              [76.42579186300003, 9.505275783000059],
              [76.43506920700008, 9.507635809000078],
              [76.45899498800003, 9.497300523000092],
              [76.47706139400003, 9.503729559000078],
              [76.50326582100007, 9.534979559000078],
              [76.48438561300003, 9.543768622000073],
              [76.46656334700003, 9.556382554000038],
              [76.44849694100003, 9.563421942000048],
              [76.42823326900003, 9.55540599200009],
              [76.41724694100003, 9.561428127000056],
              [76.40699303500008, 9.56907786700009],
              [76.41968834700003, 9.594183661000045],
              [76.41960696700005, 9.614488023000092],
              [76.41504967500003, 9.63617584800005],
              [76.41456139400003, 9.68268463700008],
              [76.41000410200007, 9.70026276200008],
              [76.40259850400008, 9.710598049000055],
              [76.39405358200008, 9.706244208000044],
              [76.39210045700008, 9.716945705000057],
              [76.39478600400008, 9.735174872000073],
              [76.39405358200008, 9.747219143000052],
              [76.39079837300005, 9.756984768000052],
              [76.38209069100003, 9.774725653000075],
              [76.38038170700008, 9.785101630000042],
              [76.38404381600003, 9.80263906500005],
              [76.39128665500004, 9.812201239000046],
              [76.39649498800003, 9.822658596000053],
              [76.39405358200008, 9.84284088700008],
              [76.38559004000007, 9.861517645000049],
              [76.36378014400003, 9.899237372000073],
              [76.35922285200007, 9.915432033000059],
              [76.32081139400003, 9.953314520000049],
              [76.31153405000003, 9.966945705000057],
              [76.29428144600007, 9.951320705000057],
              [76.27816816500007, 9.977932033000059],
              [76.26929772200003, 10.01626211100006],
              [76.27393639400003, 10.035834052000041],
              [76.25505618600005, 10.047674872000073],
              [76.24512780000003, 10.10219961100006],
              [76.23633873800003, 10.103461005000042],
              [76.22771243600005, 10.109564520000049],
              [76.22291100400008, 10.117621161000045],
              [76.21534264400003, 10.138251044000071],
              [76.20753014400003, 10.117132880000042],
              [76.21355228000004, 10.098822333000044],
              [76.22348066500007, 10.082098700000074],
              [76.22901451900003, 10.065904039000088],
              [76.23096764400003, 10.025824286000045],
              [76.23503665500004, 10.005072333000044],
              [76.24268639400003, 9.987453518000052],
              [76.22820071700005, 9.999945380000042],
              [76.21461022200003, 10.02448151200008],
              [76.18238366000008, 10.105658270000049],
              [76.18116295700008, 10.121161200000074],
              [76.18490644600007, 10.13580963700008],
              [76.18458092500003, 10.144924221000053],
              [76.17774498800003, 10.15534088700008],
              [76.17750084700003, 10.17064036700009],
              [76.22413170700008, 10.196926174000055],
              [76.23633873800003, 10.210272528000075],
              [76.23731530000003, 10.216986395000049],
              [76.24170983200008, 10.223944403000075],
              [76.24268639400003, 10.231024481000077],
              [76.24024498800003, 10.238959052000041],
              [76.23438561300003, 10.237941799000055],
              [76.22779381600003, 10.23427969000005],
              [76.22282962300005, 10.234442450000074],
              [76.21338951900003, 10.253241278000075],
              [76.20630944100003, 10.262884833000044],
              [76.19483483200008, 10.26862213700008],
              [76.20785566500007, 10.234564520000049],
              [76.20948326900003, 10.216009833000044],
              [76.20167076900003, 10.199693101000037],
              [76.18409264400003, 10.18935781500005],
              [76.17058353000004, 10.193752346000053],
              [76.16049238400007, 10.206244208000044],
              [76.15316816500007, 10.22016022300005],
              [76.13819420700008, 10.261053778000075],
              [76.12061608200008, 10.343573309000078],
              [76.10613040500004, 10.38467031500005],
              [76.07007897200003, 10.432806708000044],
              [76.06511478000004, 10.44985586100006],
              [76.06332441500007, 10.47016022300005],
              [76.05241946700005, 10.51398346600007],
              [76.04460696700005, 10.52928294500009],
              [76.01872806100005, 10.553412177000041],
              [76.00806725400008, 10.567084052000041],
              [75.99968509200005, 10.605536200000074],
              [75.93913821700005, 10.726060289000088],
              [75.93474368600005, 10.744330145000049],
              [75.93213951900003, 10.75096263200004],
              [75.92693118600005, 10.75771719000005],
              [75.92204837300005, 10.765570380000042],
              [75.92107181100005, 10.77570221600007],
              [75.92408287900008, 10.78070709800005],
              [75.93653405000003, 10.790716864000046],
              [75.94157962300005, 10.796210028000075],
              [75.91114342500003, 10.80923086100006],
              [75.89454186300003, 10.849758205000057],
              [75.88013756600003, 10.93268463700008],
              [75.83277428500008, 11.097845770000049],
              [75.74293053500008, 11.310126044000071],
              [75.73780358200008, 11.319484768000052],
              [75.73365319100003, 11.32518138200004],
              [75.73080488400007, 11.331732489000046],
              [75.72925866000008, 11.34365469000005],
              [75.73951256600003, 11.350734768000052],
              [75.74244225400008, 11.358710028000075],
              [75.73552493600005, 11.371527411000045],
              [75.72217858200008, 11.36749909100007],
              [75.71119225400008, 11.381781317000048],
              [75.69516035200007, 11.419989325000074],
              [75.67709394600007, 11.450100002000056],
              [75.66480553500008, 11.462632554000038],
              [75.65015709700003, 11.46775950700004],
              [75.63013756600003, 11.46873607000009],
              [75.61654707100007, 11.47361888200004],
              [75.60889733200008, 11.484930731000077],
              [75.60629316500007, 11.50531647300005],
              [75.60084069100003, 11.523382880000042],
              [75.58187910200007, 11.54979075700004],
              [75.58529707100007, 11.563381252000056],
              [75.53077233200008, 11.69367096600007],
              [75.50611412900008, 11.727240302000041],
              [75.37973066500007, 11.864976304000038],
              [75.37256920700008, 11.864732164000088],
              [75.35580488400007, 11.85765208500004],
              [75.35254967500003, 11.86155833500004],
              [75.34937584700003, 11.871975002000056],
              [75.32455488400007, 11.899115302000041],
              [75.30762780000003, 11.932196356000077],
              [75.32650800900007, 11.93585846600007],
              [75.40023847700007, 11.92023346600007],
              [75.40023847700007, 11.926459052000041],
              [75.38656660200007, 11.935126044000071],
              [75.38282311300003, 11.945502020000049],
              [75.38599694100003, 11.958319403000075],
              [75.39340254000007, 11.97483958500004],
              [75.38021894600007, 11.968695380000042],
              [75.36133873800003, 11.951239325000074],
              [75.34913170700008, 11.94757721600007],
              [75.33171634200005, 11.94953034100007],
              [75.31609134200005, 11.955633856000077],
              [75.30225670700008, 11.966050523000092],
              [75.29037519600007, 11.98110586100006],
              [75.27881920700008, 12.003241278000075],
              [75.28109785200007, 12.010646877000056],
              [75.31470787900008, 12.008368231000077],
              [75.32976321700005, 12.012640692000048],
              [75.32496178500008, 12.022650458000044],
              [75.30559329500005, 12.041774807000081],
              [75.30420983200008, 12.043158270000049],
              [75.26433353000004, 12.013332424000055],
              [75.26050866000008, 11.997788804000038],
              [75.27670332100007, 11.96743398600006],
              [75.24561608200008, 12.00291575700004],
              [75.23926842500003, 12.008368231000077],
              [75.23324629000007, 12.01048411700009],
              [75.22820071700005, 12.01508209800005],
              [75.22445722700007, 12.019354559000078],
              [75.22217858200008, 12.022040106000077],
              [75.21648196700005, 12.021063544000071],
              [75.21062259200005, 12.016994533000059],
              [75.20704186300003, 12.01203034100007],
              [75.20850670700008, 12.008368231000077],
              [75.19369550900007, 12.022284247000073],
              [75.18628991000008, 12.041571356000077],
              [75.18051191500007, 12.077297268000052],
              [75.14380944100003, 12.161322333000044],
              [75.13086998800003, 12.207831122000073],
              [75.13965905000003, 12.241766669000071],
              [75.13965905000003, 12.248602606000077],
              [75.12671959700003, 12.245835679000038],
              [75.11963951900003, 12.23899974200009],
              [75.11394290500004, 12.230169989000046],
              [75.10547936300003, 12.221258856000077],
              [75.10613040500004, 12.233710028000075],
              [75.10474694100003, 12.24607982000009],
              [75.09864342500003, 12.269029039000088],
              [75.08285566500007, 12.305894273000092],
              [75.01840254000007, 12.414740302000041],
              [75.01099694100003, 12.43577708500004],
              [75.00993899800005, 12.443793036000045],
              [75.00660241000008, 12.44944896000004],
              [74.99935957100007, 12.454901434000078],
              [74.99203535200007, 12.461737372000073],
              [74.98878014400003, 12.471380927000041],
              [74.98536217500003, 12.491359768000052],
              [74.97673587300005, 12.507025458000044],
              [74.95525149800005, 12.537258205000057],
              [74.87964928500008, 12.725490627000056],
              [74.87012780000003, 12.742865302000041],
              [74.85572350400008, 12.759426174000055],
              [74.85425866000008, 12.765285549000055],
              [74.85474694100003, 12.78701406500005],
              [74.85230553500008, 12.797308661000045],
              [74.84400475400008, 12.808010158000059],
              [74.83497155000003, 12.815822658000059],
              [74.82764733200008, 12.824652411000045],
              [74.82496178500008, 12.83820221600007],
              [74.85141035200007, 12.825506903000075],
              [74.85914147200003, 12.824611721000053],
              [74.86695397200003, 12.830023505000042],
              [74.88111412900008, 12.848049221000053],
              [74.88982181100005, 12.85187409100007],
              [74.90113366000008, 12.85342031500005],
              [74.91749108200008, 12.85814036700009],
              [74.93287194100003, 12.866441148000092],
              [74.94092858200008, 12.878607489000046],
              [74.89478600400008, 12.871161200000074],
              [74.85059655000003, 12.857163804000038],
              [74.81755618600005, 12.861761786000045],
              [74.77027428500008, 13.052435614000046],
              [74.78337649800005, 13.084662177000041],
              [74.77409915500004, 13.093410549000055],
              [74.76921634200005, 13.099554755000042],
              [74.76295006600003, 13.118801174000055],
              [74.76189212300005, 13.143133856000077],
              [74.75977623800003, 13.155218817000048],
              [74.75294030000003, 13.16038646000004],
              [74.74878991000008, 13.170843817000048],
              [74.73780358200008, 13.221380927000041],
              [74.73340905000003, 13.26276276200008],
              [74.71509850400008, 13.33104075700004],
              [74.70720462300005, 13.34837474200009],
              [74.69613691500007, 13.36595286700009],
              [74.68946373800003, 13.38157786700009],
              [74.69459069100003, 13.393133856000077],
              [74.68751061300003, 13.410345770000049],
              [74.68336022200003, 13.44281647300005],
              [74.68091881600003, 13.468247789000088],
              [74.69076582100007, 13.439113674000055],
              [74.69369550900007, 13.415269273000092],
              [74.70826256600003, 13.413031317000048],
              [74.70191491000008, 13.420355536000045],
              [74.70240319100003, 13.442613023000092],
              [74.70142662900008, 13.461371161000045],
              [74.67709394600007, 13.526760158000059],
              [74.67798912900008, 13.54913971600007],
              [74.67139733200008, 13.603949286000045],
              [74.67351321700005, 13.619086005000042],
              [74.66993248800003, 13.622015692000048],
              [74.66797936300003, 13.625148830000057],
              [74.66716556100005, 13.628607489000046],
              [74.66667728000004, 13.632757880000042],
              [74.67286217500003, 13.62889232000009],
              [74.67709394600007, 13.63031647300005],
              [74.67969811300003, 13.636460679000038],
              [74.68091881600003, 13.646958726000037],
              [74.68718509200005, 13.646958726000037],
              [74.69678795700008, 13.640448309000078],
              [74.70997155000003, 13.640570380000042],
              [74.72380618600005, 13.64557526200008],
              [74.73560631600003, 13.653794664000088],
              [74.72055097700007, 13.652289130000042],
              [74.71290123800003, 13.656195380000042],
              [74.70142662900008, 13.67373281500005],
              [74.68832441500007, 13.685939846000053],
              [74.68897545700008, 13.69086334800005],
              [74.70142662900008, 13.69476959800005],
              [74.68775475400008, 13.711818752000056],
              [74.67603600400008, 13.70107656500005],
              [74.66049238400007, 13.66006094000005],
              [74.64698326900003, 13.692084052000041],
              [74.62305748800003, 13.77415599200009],
              [74.61459394600007, 13.835516669000071],
              [74.59595787900008, 13.871486721000053],
              [74.58399498800003, 13.903876044000071],
              [74.55079186300003, 13.945502020000049],
              [74.53638756600003, 13.969875393000052],
              [74.50473066500007, 14.010239976000037],
              [74.49537194100003, 14.030585028000075],
              [74.49480228000004, 14.040716864000046],
              [74.49626712300005, 14.06150950700004],
              [74.49537194100003, 14.071519273000092],
              [74.49138431100005, 14.080633856000077],
              [74.47917728000004, 14.095648505000042],
              [74.47486412900008, 14.10569896000004],
              [74.47315514400003, 14.161688544000071],
              [74.46745853000004, 14.181382554000038],
              [74.43873131600003, 14.220119533000059],
              [74.42904707100007, 14.240423895000049],
              [74.43336022200003, 14.263373114000046],
              [74.44703209700003, 14.253973700000074],
              [74.47103925900007, 14.24868398600006],
              [74.49496504000007, 14.247463283000059],
              [74.50896243600005, 14.25031159100007],
              [74.50001061300003, 14.257961330000057],
              [74.43637129000007, 14.279689846000053],
              [74.42774498800003, 14.28384023600006],
              [74.41537519600007, 14.30109284100007],
              [74.41260826900003, 14.34479401200008],
              [74.40357506600003, 14.362982489000046],
              [74.39698326900003, 14.372748114000046],
              [74.39437910200007, 14.384914455000057],
              [74.39421634200005, 14.41079336100006],
              [74.39185631600003, 14.41901276200008],
              [74.38672936300003, 14.424221096000053],
              [74.38160241000008, 14.431219794000071],
              [74.37427819100003, 14.467271226000037],
              [74.35385175900007, 14.505072333000044],
              [74.35189863400007, 14.530218817000048],
              [74.36703535200007, 14.51235586100006],
              [74.37745201900003, 14.48460521000004],
              [74.38884524800005, 14.462713934000078],
              [74.40723717500003, 14.46198151200008],
              [74.39763431100005, 14.475409247000073],
              [74.40113366000008, 14.479722398000092],
              [74.42774498800003, 14.476263739000046],
              [74.38542728000004, 14.524115302000041],
              [74.37240644600007, 14.530218817000048],
              [74.37468509200005, 14.533758856000077],
              [74.37712649800005, 14.54100169500009],
              [74.37924238400007, 14.544582424000055],
              [74.36833743600005, 14.549709377000056],
              [74.36410566500007, 14.54913971600007],
              [74.35873457100007, 14.544582424000055],
              [74.35547936300003, 14.557074286000045],
              [74.35580488400007, 14.56240469000005],
              [74.35873457100007, 14.571234442000048],
              [74.34294681100005, 14.563666083000044],
              [74.34099368600005, 14.551174221000053],
              [74.34294681100005, 14.536851304000038],
              [74.33904056100005, 14.523993231000077],
              [74.32488040500004, 14.517238674000055],
              [74.30982506600003, 14.51943594000005],
              [74.30054772200003, 14.527411200000074],
              [74.30355879000007, 14.537665106000077],
              [74.29590905000003, 14.565008856000077],
              [74.29517662900008, 14.587307033000059],
              [74.30738366000008, 14.60187409100007],
              [74.33904056100005, 14.605943101000037],
              [74.33904056100005, 14.612779039000088],
              [74.32390384200005, 14.61859772300005],
              [74.31226647200003, 14.61546458500004],
              [74.30111738400007, 14.609320380000042],
              [74.28711998800003, 14.605943101000037],
              [74.27588951900003, 14.610174872000073],
              [74.26807701900003, 14.619940497000073],
              [74.26685631600003, 14.631293036000045],
              [74.27621504000007, 14.64008209800005],
              [74.26921634200005, 14.65892161700009],
              [74.26319420700008, 14.701605536000045],
              [74.25294030000003, 14.718939520000049],
              [74.23406009200005, 14.734076239000046],
              [74.22046959700003, 14.738104559000078],
              [74.20875084700003, 14.731838283000059],
              [74.19434655000003, 14.71580638200004],
              [74.18067467500003, 14.74217357000009],
              [74.17383873800003, 14.749945380000042],
              [74.16944420700008, 14.750881252000056],
              [74.15772545700008, 14.748968817000048],
              [74.15333092500003, 14.749945380000042],
              [74.14649498800003, 14.761867580000057],
              [74.14584394600007, 14.763617255000042],
              [74.11133873800003, 14.78034088700008],
              [74.09644616000008, 14.793361721000053],
              [74.09131920700008, 14.811428127000056],
              [74.10914147200003, 14.80263906500005],
              [74.11402428500008, 14.808417059000078],
              [74.11426842500003, 14.82094961100006],
              [74.11866295700008, 14.831854559000078],
              [74.12875410200007, 14.837469794000071],
              [74.14047285200007, 14.838771877000056],
              [74.15154056100005, 14.835109768000052],
              [74.15951582100007, 14.825669664000088],
              [74.16968834700003, 14.84446849200009],
              [74.17896569100003, 14.856268622000073],
              [74.19068444100003, 14.863104559000078],
              [74.20801842500003, 14.86664459800005],
              [74.21810957100007, 14.865383205000057],
              [74.22689863400007, 14.86273834800005],
              [74.23308353000004, 14.864569403000075],
              [74.23519941500007, 14.876532294000071],
              [74.23072350400008, 14.880113023000092],
              [74.22087649800005, 14.882066148000092],
              [74.21119225400008, 14.88735586100006],
              [74.20801842500003, 14.900824286000045],
              [74.19752037900008, 14.89085521000004],
              [74.16618899800005, 14.876532294000071],
              [74.15951582100007, 14.86977773600006],
              [74.15406334700003, 14.862127997000073],
              [74.14087975400008, 14.852687893000052],
              [74.12501061300003, 14.845851955000057],
              [74.11182701900003, 14.846177476000037],
              [74.10303795700008, 14.856919664000088],
              [74.09115644600007, 14.887600002000056],
              [74.08106530000003, 14.89398834800005],
              [74.07715905000003, 14.898382880000042],
              [74.03598066500007, 14.921291408000059],
              [74.03028405000003, 14.935207424000055],
              [74.03101647200003, 14.949774481000077],
              [74.03598066500007, 14.979641018000052],
              [74.03126061300003, 14.995306708000044],
              [74.02019290500004, 15.001776434000078],
              [74.00684655000003, 15.00486888200004],
              [73.99577884200005, 15.010687567000048],
              [73.97299238400007, 15.05687083500004],
              [73.96436608200008, 15.064642645000049],
              [73.91309655000003, 15.078924872000073],
              [73.92253665500004, 15.107855536000045],
              [73.92896569100003, 15.120591539000088],
              [73.93702233200008, 15.130438544000071],
              [73.95826256600003, 15.143133856000077],
              [73.96216881600003, 15.152044989000046],
              [73.95411217500003, 15.16828034100007],
              [73.94727623800003, 15.160834052000041],
              [73.89128665500004, 15.34320709800005],
              [73.88257897200003, 15.355292059000078],
              [73.86947675900007, 15.359564520000049],
              [73.84839928500008, 15.36009349200009],
              [73.82740319100003, 15.365179755000042],
              [73.81039472700007, 15.37759023600006],
              [73.78288821700005, 15.407904364000046],
              [73.83936608200008, 15.404038804000038],
              [73.84839928500008, 15.404486395000049],
              [73.86011803500008, 15.407863674000055],
              [73.87191816500007, 15.401841539000088],
              [73.88493899800005, 15.398016669000071],
              [73.89958743600005, 15.407904364000046],
              [73.93336022200003, 15.395412502000056],
              [73.94532311300003, 15.385687567000048],
              [73.95411217500003, 15.36627838700008],
              [73.95850670700008, 15.36717357000009],
              [73.96168053500008, 15.36823151200008],
              [73.96420332100007, 15.37018463700008],
              [73.96778405000003, 15.37376536700009],
              [73.95997155000003, 15.380682684000078],
              [73.93702233200008, 15.411322333000044],
              [73.92758222700007, 15.417385158000059],
              [73.88591556100005, 15.435207424000055],
              [73.87916100400008, 15.43577708500004],
              [73.86508222700007, 15.43431224200009],
              [73.85857181100005, 15.435207424000055],
              [73.85417728000004, 15.438299872000073],
              [73.84685306100005, 15.447088934000078],
              [73.84156334700003, 15.448879299000055],
              [73.80616295700008, 15.45221588700008],
              [73.79639733200008, 15.448879299000055],
              [73.79517662900008, 15.460760809000078],
              [73.80046634200005, 15.475002346000053],
              [73.80884850400008, 15.488023179000038],
              [73.81755618600005, 15.496649481000077],
              [73.82813561300003, 15.50141022300005],
              [73.87224368600005, 15.510931708000044],
              [73.86312910200007, 15.51634349200009],
              [73.85954837300005, 15.521144924000055],
              [73.86052493600005, 15.525864976000037],
              [73.86597741000008, 15.531398830000057],
              [73.86597741000008, 15.537583726000037],
              [73.79639733200008, 15.500392971000053],
              [73.78638756600003, 15.49217357000009],
              [73.76628665500004, 15.497259833000044],
              [73.75123131600003, 15.51312897300005],
              [73.75611412900008, 15.537583726000037],
              [73.74122155000003, 15.559963283000059],
              [73.73682701900003, 15.57172272300005],
              [73.73511803500008, 15.586004950000074],
              [73.73707116000008, 15.598537502000056],
              [73.74170983200008, 15.604193427000041],
              [73.74659264400003, 15.60838450700004],
              [73.74870853000004, 15.616766669000071],
              [73.76042728000004, 15.632025458000044],
              [73.78736412900008, 15.641791083000044],
              [73.83814537900008, 15.65428294500009],
              [73.83814537900008, 15.66111888200004],
              [73.80103600400008, 15.661851304000038],
              [73.78386478000004, 15.659125067000048],
              [73.77662194100003, 15.650864976000037],
              [73.76823978000004, 15.646918036000045],
              [73.73324629000007, 15.625067450000074],
              [73.72828209700003, 15.619574286000045],
              [73.71827233200008, 15.627142645000049],
              [73.70704186300003, 15.643703518000052],
              [73.69792728000004, 15.66282786700009],
              [73.69076582100007, 15.693793036000045],
              [73.68588300900007, 15.704291083000044],
              [73.68677819100003, 15.71312083500004],
              [73.70085696700005, 15.723211981000077],
              [73.68987063900005, 15.72447337400007],
              [73.67237389400003, 15.726507880000042],
              [73.65601647200003, 15.730292059000078],
              [73.64625084700003, 15.736883856000077],
              [73.64356530000003, 15.74909088700008],
              [73.64625084700003, 15.792141018000052],
              [73.63884524800005, 15.817206122000073],
              [73.60466556100005, 15.88084544500009],
              [73.58757571700005, 15.902899481000077],
              [73.52898196700005, 15.949164130000042],
              [73.51010175900007, 15.967596747000073],
              [73.49097741000008, 15.993475653000075],
              [73.48731530000003, 16.014227606000077],
              [73.51596113400007, 16.017401434000078],
              [73.51596113400007, 16.02484772300005],
              [73.49927819100003, 16.024318752000056],
              [73.48389733200008, 16.028225002000056],
              [73.47250410200007, 16.036363023000092],
              [73.46810957100007, 16.048488674000055],
              [73.46485436300003, 16.051662502000056],
              [73.45753014400003, 16.05418528900009],
              [73.45036868600005, 16.05890534100007],
              [73.44703209700003, 16.068915106000077],
              [73.45297285200007, 16.074164130000042],
              [73.45753014400003, 16.07953522300005],
              [73.46070397200003, 16.086330471000053],
              [73.46070397200003, 16.144680080000057],
              [73.46338951900003, 16.15957265800006],
              [73.47022545700008, 16.168890692000048],
              [73.47925866000008, 16.17723216400009],
              [73.48796634200005, 16.18935781500005],
              [73.46501712300005, 16.18227773600006],
              [73.45281009200005, 16.166571356000077],
              [73.44800866000008, 16.14329661700009],
              [73.44703209700003, 16.11359284100007],
              [73.44019616000008, 16.16201406500005],
              [73.44019616000008, 16.202337958000044],
              [73.43523196700005, 16.21784088700008],
              [73.43083743600005, 16.21873607000009],
              [73.42595462300005, 16.21515534100007],
              [73.41968834700003, 16.21670156500005],
              [73.41358483200008, 16.223944403000075],
              [73.41041100400008, 16.23045482000009],
              [73.40609785200007, 16.250799872000073],
              [73.37867272200003, 16.33270905200004],
              [73.37777754000007, 16.337958075000074],
              [73.37867272200003, 16.35691966400009],
              [73.37566165500004, 16.360256252000056],
              [73.35824629000007, 16.36749909100007],
              [73.35938561300003, 16.380601304000038],
              [73.36443118600005, 16.38930898600006],
              [73.37305748800003, 16.395656643000052],
              [73.38493899800005, 16.401597398000092],
              [73.36744225400008, 16.408636786000045],
              [73.35206139400003, 16.418117580000057],
              [73.34131920700008, 16.432074286000045],
              [73.33399498800003, 16.46816640800006],
              [73.31918379000007, 16.50975169500009],
              [73.31381269600007, 16.51829661700009],
              [73.30583743600005, 16.522650458000044],
              [73.30298912900008, 16.533026434000078],
              [73.30372155000003, 16.555568752000056],
              [73.30730228000004, 16.56317780200004],
              [73.31495201900003, 16.55760325700004],
              [73.32195071700005, 16.548488674000055],
              [73.32349694100003, 16.544989325000074],
              [73.34400475400008, 16.523586330000057],
              [73.35572350400008, 16.51943594000005],
              [73.37867272200003, 16.51829661700009],
              [73.36947675900007, 16.52147044500009],
              [73.36231530000003, 16.525458075000074],
              [73.35621178500008, 16.53074778900009],
              [73.35084069100003, 16.53815338700008],
              [73.35434004000007, 16.54315827000005],
              [73.36500084700003, 16.554388739000046],
              [73.37126712300005, 16.55927155200004],
              [73.35401451900003, 16.55963776200008],
              [73.33643639400003, 16.565619208000044],
              [73.32276451900003, 16.57615794500009],
              [73.31723066500007, 16.590277411000045],
              [73.31609134200005, 16.59829336100006],
              [73.31462649800005, 16.599432684000078],
              [73.31609134200005, 16.600043036000045],
              [73.32349694100003, 16.60643138200004],
              [73.32699629000007, 16.607123114000046],
              [73.35824629000007, 16.62067291900007],
              [73.35840905000003, 16.603949286000045],
              [73.36304772200003, 16.596828518000052],
              [73.36866295700008, 16.59902578300006],
              [73.37126712300005, 16.610174872000073],
              [73.36646569100003, 16.628078518000052],
              [73.35425866000008, 16.63467031500005],
              [73.33887780000003, 16.631659247000073],
              [73.32349694100003, 16.62067291900007],
              [73.31218509200005, 16.64472077000005],
              [73.31055748800003, 16.65143463700008],
              [73.31251061300003, 16.65839264500005],
              [73.32146243600005, 16.670843817000048],
              [73.32349694100003, 16.67910390800006],
              [73.32162519600007, 16.69245026200008],
              [73.31657962300005, 16.69989655200004],
              [73.30030358200008, 16.71320221600007],
              [73.28956139400003, 16.74022044500009],
              [73.29525800900007, 16.768052476000037],
              [73.30445397200003, 16.793524481000077],
              [73.30372155000003, 16.81313711100006],
              [73.29688561300003, 16.80565013200004],
              [73.28663170700008, 16.820868231000077],
              [73.27466881600003, 16.848822333000044],
              [73.26937910200007, 16.87563711100006],
              [73.27955162900008, 16.887640692000048],
              [73.27906334700003, 16.891913153000075],
              [73.26937910200007, 16.92918528900009],
              [73.27051842500003, 16.945013739000046],
              [73.27491295700008, 16.958644924000055],
              [73.28939863400007, 16.98383209800005],
              [73.26238040500004, 16.996975002000056],
              [73.25456790500004, 17.006740627000056],
              [73.26270592500003, 17.01854075700004],
              [73.25123131600003, 17.032171942000048],
              [73.25147545700008, 17.04242584800005],
              [73.25896243600005, 17.044094143000052],
              [73.26937910200007, 17.031642971000053],
              [73.27735436300003, 17.05467357000009],
              [73.27572675900007, 17.078599351000037],
              [73.26742597700007, 17.101385809000078],
              [73.25513756600003, 17.12099844000005],
              [73.26197350400008, 17.13495514500005],
              [73.26059004000007, 17.150539455000057],
              [73.25513756600003, 17.165187893000052],
              [73.23617597700007, 17.19920482000009],
              [73.23601321700005, 17.22060781500005],
              [73.21802819100003, 17.253241278000075],
              [73.21485436300003, 17.268744208000044],
              [73.21119225400008, 17.275091864000046],
              [73.19312584700003, 17.29401276200008],
              [73.18702233200008, 17.305975653000075],
              [73.20346113400007, 17.29873281500005],
              [73.21713300900007, 17.286851304000038],
              [73.23121178500008, 17.27928294500009],
              [73.24903405000003, 17.284857489000046],
              [73.23471113400007, 17.30231354400007],
              [73.20736738400007, 17.35374583500004],
              [73.19597415500004, 17.36937083500004],
              [73.17058353000004, 17.38971588700008],
              [73.16651451900003, 17.402167059000078],
              [73.16529381600003, 17.413031317000048],
              [73.17709394600007, 17.426662502000056],
              [73.18539472700007, 17.441880601000037],
              [73.17335045700008, 17.457424221000053],
              [73.18067467500003, 17.477687893000052],
              [73.16553795700008, 17.50340403900009],
              [73.13168379000007, 17.53937409100007],
              [73.12598717500003, 17.55654531500005],
              [73.12794030000003, 17.56468333500004],
              [73.13640384200005, 17.567206122000073],
              [73.14942467500003, 17.567287502000056],
              [73.16342207100007, 17.569484768000052],
              [73.20069420700008, 17.586493231000077],
              [73.18588300900007, 17.59251536700009],
              [73.15406334700003, 17.59560781500005],
              [73.13917076900003, 17.600775458000044],
              [73.12818444100003, 17.61155833500004],
              [73.12134850400008, 17.62641022300005],
              [73.12029056100005, 17.64203522300005],
              [73.12614993600005, 17.655422268000052],
              [73.11890709700003, 17.66347890800006],
              [73.11052493600005, 17.675726630000042],
              [73.10547936300003, 17.68891022300005],
              [73.10816491000008, 17.699774481000077],
              [73.11736087300005, 17.71124909100007],
              [73.12322024800005, 17.72333405200004],
              [73.12330162900008, 17.73578522300005],
              [73.11500084700003, 17.748195705000057],
              [73.10987389400003, 17.758286851000037],
              [73.10661868600005, 17.785549221000053],
              [73.10132897200003, 17.79633209800005],
              [73.08545983200008, 17.813666083000044],
              [73.07943769600007, 17.824611721000053],
              [73.07374108200008, 17.857123114000046],
              [73.06519616000008, 17.87836334800005],
              [73.01856530000003, 17.951727606000077],
              [73.01710045700008, 17.97211334800005],
              [73.03541100400008, 17.991848049000055],
              [73.01889082100007, 17.99249909100007],
              [73.00863691500007, 18.00023021000004],
              [73.00521894600007, 18.01235586100006],
              [73.00879967500003, 18.025946356000077],
              [73.01954186300003, 18.03587474200009],
              [73.03248131600003, 18.041083075000074],
              [73.04224694100003, 18.048976955000057],
              [73.04346764400003, 18.066961981000077],
              [73.03199303500008, 18.06391022300005],
              [73.02271569100003, 18.05768463700008],
              [73.01514733200008, 18.04913971600007],
              [73.00879967500003, 18.039007880000042],
              [73.00114993600005, 18.052069403000075],
              [72.98731530000003, 18.066555080000057],
              [72.98096764400003, 18.080552476000037],
              [72.98316491000008, 18.081732489000046],
              [72.98666425900007, 18.087713934000078],
              [72.98812910200007, 18.09601471600007],
              [72.98462975400008, 18.10419342700004],
              [72.97836347700007, 18.111883856000077],
              [72.97608483200008, 18.11863841400009],
              [72.96729576900003, 18.19599030200004],
              [72.95484459700003, 18.21751536700009],
              [72.92693118600005, 18.223944403000075],
              [72.93523196700005, 18.24477773600006],
              [72.93995201900003, 18.251288153000075],
              [72.93482506600003, 18.257879950000074],
              [72.93327884200005, 18.26658763200004],
              [72.93506920700008, 18.276312567000048],
              [72.93995201900003, 18.286037502000056],
              [72.95313561300003, 18.281317450000074],
              [72.95753014400003, 18.274603583000044],
              [72.95923912900008, 18.26585521000004],
              [72.96452884200005, 18.25495026200008],
              [72.97266686300003, 18.244696356000077],
              [72.97673587300005, 18.242580471000053],
              [72.98226972700007, 18.244208075000074],
              [72.99512780000003, 18.245062567000048],
              [73.01246178500008, 18.24315013200004],
              [73.03239993600005, 18.23786041900007],
              [73.05095462300005, 18.227484442000048],
              [73.06348717500003, 18.21035390800006],
              [73.04761803500008, 18.20115794500009],
              [73.04761803500008, 18.188788153000075],
              [73.05746504000007, 18.185614325000074],
              [73.07154381600003, 18.20408763200004],
              [73.07398522200003, 18.22418854400007],
              [73.06527754000007, 18.257554429000038],
              [73.07154381600003, 18.27301666900007],
              [73.05697675900007, 18.280951239000046],
              [73.04297936300003, 18.282375393000052],
              [73.01246178500008, 18.27920156500005],
              [72.99488366000008, 18.283596096000053],
              [72.97738691500007, 18.295070705000057],
              [72.96802819100003, 18.310614325000074],
              [72.97478274800005, 18.32758209800005],
              [72.95875084700003, 18.32811107000009],
              [72.95085696700005, 18.332953192000048],
              [72.93360436300003, 18.35492584800005],
              [72.92790774800005, 18.357570705000057],
              [72.92253665500004, 18.356634833000044],
              [72.91732832100007, 18.356390692000048],
              [72.91260826900003, 18.361151434000078],
              [72.90984134200005, 18.368068752000056],
              [72.91016686300003, 18.37250397300005],
              [72.91163170700008, 18.377346096000053],
              [72.91260826900003, 18.385646877000056],
              [72.91016686300003, 18.399237372000073],
              [72.90430748800003, 18.40851471600007],
              [72.89722741000008, 18.417303778000075],
              [72.89144941500007, 18.429388739000046],
              [72.88965905000003, 18.44131094000005],
              [72.89144941500007, 18.480902411000045],
              [72.89576256600003, 18.50299713700008],
              [72.90723717500003, 18.523586330000057],
              [72.92465254000007, 18.535630601000037],
              [72.94678795700008, 18.532416083000044],
              [72.96111087300005, 18.517726955000057],
              [72.99024498800003, 18.469956773000092],
              [73.00879967500003, 18.450506903000075],
              [73.01498457100007, 18.469956773000092],
              [73.00440514400003, 18.48004791900007],
              [72.98878014400003, 18.489935614000046],
              [72.98096764400003, 18.50885651200008],
              [72.97787519600007, 18.52411530200004],
              [72.97038821700005, 18.54100169500009],
              [72.96029707100007, 18.55467357000009],
              [72.95020592500003, 18.560370184000078],
              [72.92115319100003, 18.55487702000005],
              [72.91016686300003, 18.558986721000053],
              [72.90577233200008, 18.57713450700004],
              [72.88217207100007, 18.63548411700009],
              [72.86451256600003, 18.648911851000037],
              [72.85531660200007, 18.68113841400009],
              [72.85173587300005, 18.719671942000048],
              [72.85238691500007, 18.769924221000053],
              [72.85694420700008, 18.78620026200008],
              [72.86557050900007, 18.799383856000077],
              [72.87916100400008, 18.80735911700009],
              [72.88705488400007, 18.807033596000053],
              [72.90202884200005, 18.79950592700004],
              [72.91260826900003, 18.799994208000044],
              [72.92693118600005, 18.826646226000037],
              [72.93897545700008, 18.816961981000077],
              [72.97478274800005, 18.77948639500005],
              [72.96631920700008, 18.761419989000046],
              [72.96957441500007, 18.746975002000056],
              [72.98064212300005, 18.736761786000045],
              [72.99512780000003, 18.731024481000077],
              [72.98804772200003, 18.753851630000042],
              [72.99170983200008, 18.779364325000074],
              [73.00245201900003, 18.80145905200004],
              [73.01628665500004, 18.813625393000052],
              [72.98796634200005, 18.82493724200009],
              [72.98129316500007, 18.83270905200004],
              [72.97478274800005, 18.84833405200004],
              [72.97608483200008, 18.854396877000056],
              [72.97974694100003, 18.863348700000074],
              [72.98170006600003, 18.871486721000053],
              [72.97779381600003, 18.87498607000009],
              [72.97217858200008, 18.874253648000035],
              [72.96697024800005, 18.87213776200008],
              [72.96314537900008, 18.868963934000078],
              [72.96168053500008, 18.86513906500005],
              [72.94613691500007, 18.858303127000056],
              [72.91627037900008, 18.87051015800006],
              [72.89682050900007, 18.894476630000042],
              [72.91260826900003, 18.923488674000055],
              [72.92807050900007, 18.911363023000035],
              [72.93458092500003, 18.920803127000056],
              [72.93677819100003, 18.947414455000057],
              [72.94922936300003, 18.95148346600007],
              [72.96338951900003, 18.94798411700009],
              [72.97722415500004, 18.948431708000044],
              [72.98829186300003, 18.96442291900007],
              [72.95362389400003, 18.96442291900007],
              [72.95362389400003, 18.971258856000077],
              [72.96827233200008, 18.972601630000042],
              [72.99203535200007, 18.982489325000074],
              [73.04216556100005, 18.995754299000055],
              [73.04664147200003, 18.99518463700008],
              [73.05681399800005, 19.015326239000046],
              [73.03980553500008, 19.017523505000042],
              [73.01189212300005, 19.009426174000055],
              [72.98829186300003, 18.998602606000077],
              [72.98357181100005, 19.01044342700004],
              [72.98780358200008, 19.036932684000078],
              [72.98096764400003, 19.04637278900009],
              [72.99187259200005, 19.067206122000073],
              [72.98568769600007, 19.074286200000074],
              [72.97380618600005, 19.078558661000045],
              [72.96729576900003, 19.091009833000044],
              [72.97478274800005, 19.16307200700004],
              [72.96729576900003, 19.16307200700004],
              [72.95004316500007, 19.12791575700004],
              [72.93555748800003, 19.115057684000078],
              [72.93392988400007, 19.08030833500004],
              [72.92693118600005, 19.066839911000045],
              [72.94336998800003, 19.055121161000045],
              [72.93425540500004, 19.034084377000056],
              [72.89144941500007, 18.99176666900007],
              [72.89144941500007, 19.00136953300006],
              [72.88526451900003, 19.025864976000037],
              [72.86931399800005, 19.011419989000046],
              [72.85108483200008, 18.987127997000073],
              [72.83627363400007, 18.959133205000057],
              [72.82764733200008, 18.918361721000053],
              [72.82129967500003, 18.90330638200004],
              [72.81251061300003, 18.89744700700004],
              [72.80274498800003, 18.909816799000055],
              [72.80201256600003, 18.920477606000077],
              [72.80534915500004, 18.930975653000075],
              [72.80738366000008, 18.94281647300005],
              [72.80274498800003, 18.957586981000077],
              [72.79590905000003, 18.957586981000077],
              [72.79232832100007, 18.951239325000074],
              [72.78825931100005, 18.946519273000035],
              [72.77540123800003, 18.93650950700004],
              [72.77035566500007, 18.948187567000048],
              [72.77605228000004, 18.95970286700009],
              [72.79590905000003, 18.984930731000077],
              [72.80241946700005, 18.999660549000055],
              [72.80494225400008, 19.011053778000075],
              [72.80274498800003, 19.040187893000052],
              [72.81299889400003, 19.035549221000053],
              [72.81706790500004, 19.03270091400009],
              [72.82178795700008, 19.04197825700004],
              [72.82422936300003, 19.053534247000073],
              [72.82129967500003, 19.06317780200004],
              [72.80958092500003, 19.066839911000045],
              [72.82195071700005, 19.09711334800005],
              [72.82309004000007, 19.10846588700008],
              [72.82105553500008, 19.119208075000074],
              [72.81177819100003, 19.13735586100006],
              [72.80958092500003, 19.146307684000078],
              [72.81218509200005, 19.15371328300006],
              [72.82243899800005, 19.163763739000046],
              [72.82309004000007, 19.169256903000075],
              [72.81804446700005, 19.17536041900007],
              [72.81120853000004, 19.175523179000038],
              [72.80518639400003, 19.171820380000042],
              [72.79957116000008, 19.15688711100006],
              [72.79216556100005, 19.150458075000074],
              [72.78492272200003, 19.15037669500009],
              [72.78158613400007, 19.15965403900009],
              [72.78337649800005, 19.16864655200004],
              [72.80250084700003, 19.21161530200004],
              [72.81983483200008, 19.240627346000053],
              [72.83008873800003, 19.252427476000037],
              [72.81511478000004, 19.253648179000038],
              [72.80209394600007, 19.23786041900007],
              [72.78939863400007, 19.217352606000077],
              [72.77540123800003, 19.20465729400007],
              [72.77222741000008, 19.26512278900009],
              [72.77564537900008, 19.29901764500005],
              [72.78541100400008, 19.31391022300005],
              [72.83936608200008, 19.31907786700009],
              [72.86703535200007, 19.316799221000053],
              [72.88550866000008, 19.296047268000052],
              [72.90056399800005, 19.290757554000038],
              [72.93034915500004, 19.28656647300005],
              [72.94654381600003, 19.289862372000073],
              [72.95972741000008, 19.29482656500005],
              [72.97266686300003, 19.29368724200009],
              [72.98829186300003, 19.279120184000078],
              [73.01050866000008, 19.224310614000046],
              [73.02662194100003, 19.205511786000045],
              [73.04965254000007, 19.217718817000048],
              [73.03003991000008, 19.227728583000044],
              [73.02800540500004, 19.244086005000042],
              [73.02914472700007, 19.25934479400007],
              [73.01929772200003, 19.266058661000045],
              [73.01246178500008, 19.27244700700004],
              [73.00180097700007, 19.28656647300005],
              [72.98780358200008, 19.30068594000005],
              [72.97095787900008, 19.307033596000053],
              [72.91675866000008, 19.30337148600006],
              [72.89893639400003, 19.307033596000053],
              [72.88355553500008, 19.31639232000009],
              [72.85531660200007, 19.339504299000055],
              [72.83692467500003, 19.348049221000053],
              [72.81853274800005, 19.33026764500005],
              [72.80209394600007, 19.33193594000005],
              [72.78760826900003, 19.34520091400009],
              [72.76343834700003, 19.380194403000075],
              [72.75977623800003, 19.38898346600007],
              [72.74822024800005, 19.444240627000056],
              [72.74683678500008, 19.467962958000044],
              [72.75440514400003, 19.481756903000075],
              [72.76921634200005, 19.49046458500004],
              [72.87916100400008, 19.532375393000052],
              [72.85670006600003, 19.54132721600007],
              [72.83594811300003, 19.53668854400007],
              [72.81592858200008, 19.528509833000044],
              [72.79590905000003, 19.52680084800005],
              [72.78785241000008, 19.53025950700004],
              [72.78126061300003, 19.53656647300005],
              [72.77702884200005, 19.54555898600006],
              [72.77540123800003, 19.557196356000077],
              [72.77068118600005, 19.566148179000038],
              [72.76002037900008, 19.573065497000073],
              [72.74195397200003, 19.58079661700009],
              [72.73454837300005, 19.58079661700009],
              [72.73829186300003, 19.570257880000042],
              [72.74073326900003, 19.56073639500005],
              [72.73975670700008, 19.552679755000042],
              [72.73454837300005, 19.546616929000038],
              [72.74927819100003, 19.53424713700008],
              [72.75489342500003, 19.527044989000046],
              [72.75562584700003, 19.519354559000078],
              [72.74919681100005, 19.512600002000056],
              [72.74154707100007, 19.516017971000053],
              [72.72250410200007, 19.536281643000052],
              [72.71078535200007, 19.587591864000046],
              [72.71802819100003, 19.606675523000035],
              [72.70964603000004, 19.64996979400007],
              [72.68669681100005, 19.72479889500005],
              [72.69410241000008, 19.72020091400009],
              [72.69996178500008, 19.714178778000075],
              [72.70460045700008, 19.70652903900009],
              [72.70777428500008, 19.69745514500005],
              [72.72641035200007, 19.70579661700009],
              [72.72641035200007, 19.715236721000053],
              [72.71859785200007, 19.72793203300006],
              [72.71404056100005, 19.745835679000038],
              [72.71729576900003, 19.75153229400007],
              [72.72437584700003, 19.75267161700009],
              [72.73129316500007, 19.75458405200004],
              [72.73454837300005, 19.762640692000048],
              [72.73406009200005, 19.771918036000045],
              [72.73275800900007, 19.779730536000045],
              [72.72828209700003, 19.79364655200004],
              [72.69011478000004, 19.748968817000048],
              [72.67790774800005, 19.746568101000037],
              [72.67579186300003, 19.764146226000037],
              [72.67986087300005, 19.800482489000046],
              [72.67286217500003, 19.81281159100007],
              [72.65007571700005, 19.84198639500005],
              [72.64918053500008, 19.851996161000045],
              [72.65919030000003, 19.866441148000035],
              [72.66423587300005, 19.88157786700009],
              [72.66618899800005, 19.916571356000077],
              [72.66277103000004, 19.941799221000053],
              [72.66521243600005, 19.952948309000078],
              [72.67644290500004, 19.957505601000037],
              [72.68433678500008, 19.964016018000052],
              [72.69450931100005, 19.979315497000073],
              [72.70337975400008, 19.99762604400007],
              [72.70777428500008, 20.01276276200008],
              [72.70777428500008, 20.071112372000073],
              [72.71029707100007, 20.082912502000056],
              [72.72828209700003, 20.129461981000077],
              [72.73454837300005, 20.173529364000046],
              [72.73764082100007, 20.18427155200004],
              [72.75228925900007, 20.20376211100006],
              [72.75562584700003, 20.21515534100007],
              [72.75359134200005, 20.21820709800005],
              [72.74903405000003, 20.21832916900007],
              [72.74439537900008, 20.21938711100006],
              [72.74195397200003, 20.225043036000045],
              [72.74195397200003, 20.24555084800005],
              [72.74301191500007, 20.247748114000046],
              [72.74822024800005, 20.28034088700008],
              [72.75660241000008, 20.29596588700008],
              [72.76783287900008, 20.31195709800005],
              [72.77751712300005, 20.33006419500009],
              [72.78158613400007, 20.35228099200009],
              [72.78679446700005, 20.35224030200004],
              [72.79818769600007, 20.359320380000042],
              [72.81031334700003, 20.368841864000046],
              [72.81706790500004, 20.375921942000048],
              [72.82081139400003, 20.38613515800006],
              [72.82309004000007, 20.416815497000073],
              [72.82943769600007, 20.437933661000045],
              [72.84001712300005, 20.458726304000038],
              [72.87916100400008, 20.51243724200009],
              [72.88648522200003, 20.53156159100007],
              [72.89039147200003, 20.552679755000042],
              [72.89144941500007, 20.575140692000048],
              [72.89063561300003, 20.587062893000052],
              [72.88624108200008, 20.60846588700008],
              [72.88526451900003, 20.619208075000074],
              [72.88843834700003, 20.62848541900007],
              [72.90259850400008, 20.641913153000075],
              [72.90577233200008, 20.65330638200004],
              [72.90943444100003, 20.69867584800005],
              [72.90796959700003, 20.71832916900007],
              [72.89893639400003, 20.732163804000038],
              [72.94027754000007, 20.759426174000055],
              [72.94678795700008, 20.759466864000046],
              [72.94499759200005, 20.770005601000037],
              [72.93637129000007, 20.776271877000056],
              [72.92644290500004, 20.780991929000038],
              [72.91944420700008, 20.78742096600007],
              [72.91911868600005, 20.79559967700004],
              [72.92286217500003, 20.802679755000042],
              [72.92497806100005, 20.810614325000074],
              [72.91944420700008, 20.821519273000035],
              [72.90023847700007, 20.79913971600007],
              [72.88575280000003, 20.807114976000037],
              [72.88013756600003, 20.829901434000078],
              [72.88843834700003, 20.851955471000053],
              [72.90040123800003, 20.868109442000048],
              [72.89380944100003, 20.870062567000048],
              [72.88119550900007, 20.865668036000045],
              [72.87533613400007, 20.862494208000044],
              [72.83692467500003, 20.83584219000005],
              [72.84587649800005, 20.85179271000004],
              [72.85425866000008, 20.887152411000045],
              [72.86491946700005, 20.897284247000073],
              [72.83668053500008, 20.92991771000004],
              [72.85645592500003, 20.94798411700009],
              [72.88648522200003, 20.962103583000044],
              [72.88843834700003, 20.98261139500005],
              [72.87598717500003, 20.981350002000056],
              [72.85377037900008, 20.97492096600007],
              [72.83269290500004, 20.972357489000046],
              [72.82309004000007, 20.98261139500005],
              [72.82129967500003, 20.99160390800006],
              [72.81609134200005, 20.99900950700004],
              [72.80836022200003, 21.003973700000074],
              [72.79932701900003, 21.00584544500009],
              [72.78760826900003, 21.00690338700008],
              [72.78199303500008, 21.010158596000053],
              [72.77198326900003, 21.023871161000045],
              [72.76685631600003, 21.03856028900009],
              [72.78394616000008, 21.04043203300006],
              [72.82309004000007, 21.03384023600006],
              [72.84498131600003, 21.038316148000035],
              [72.84986412900008, 21.048000393000052],
              [72.81592858200008, 21.121486721000053],
              [72.80958092500003, 21.130031643000052],
              [72.79957116000008, 21.12881094000005],
              [72.75562584700003, 21.10956452000005],
              [72.75277754000007, 21.113714911000045],
              [72.74634850400008, 21.118353583000044],
              [72.74195397200003, 21.12323639500005],
              [72.73764082100007, 21.11737702000005],
              [72.73560631600003, 21.11074453300006],
              [72.73454837300005, 21.09247467700004],
              [72.73015384200005, 21.087836005000042],
              [72.70036868600005, 21.074774481000077],
              [72.70582116000008, 21.106350002000056],
              [72.72055097700007, 21.129706122000073],
              [72.72868899800005, 21.148098049000055],
              [72.71404056100005, 21.164129950000074],
              [72.70655358200008, 21.15770091400009],
              [72.68669681100005, 21.158148505000042],
              [72.67644290500004, 21.153631903000075],
              [72.67269941500007, 21.145738023000035],
              [72.67188561300003, 21.134426174000055],
              [72.67302493600005, 21.112616278000075],
              [72.67123457100007, 21.09979889500005],
              [72.66635175900007, 21.097398179000038],
              [72.65870201900003, 21.097601630000042],
              [72.63786868600005, 21.08539459800005],
              [72.62964928500008, 21.087958075000074],
              [72.61500084700003, 21.105861721000053],
              [72.61548912900008, 21.11981842700004],
              [72.63038170700008, 21.135972398000035],
              [72.69353274800005, 21.17845286700009],
              [72.71176191500007, 21.19403717700004],
              [72.72103925900007, 21.19879791900007],
              [72.73454837300005, 21.198919989000046],
              [72.72364342500003, 21.209133205000057],
              [72.68767337300005, 21.220445054000038],
              [72.67986087300005, 21.228989976000037],
              [72.67318769600007, 21.239081122000073],
              [72.65935306100005, 21.244696356000077],
              [72.64698326900003, 21.253607489000046],
              [72.64576256600003, 21.273382880000042],
              [72.62517337300005, 21.25934479400007],
              [72.61841881600003, 21.25291575700004],
              [72.60613040500004, 21.26658763200004],
              [72.60206139400003, 21.27765534100007],
              [72.59791100400008, 21.307562567000048],
              [72.58863366000008, 21.331976630000042],
              [72.58676191500007, 21.34121328300006],
              [72.59050540500004, 21.348537502000056],
              [72.60320071700005, 21.352728583000044],
              [72.63851972700007, 21.357163804000038],
              [72.64576256600003, 21.36277903900009],
              [72.63868248800003, 21.371242580000057],
              [72.62338300900007, 21.370266018000052],
              [72.59408613400007, 21.36277903900009],
              [72.57886803500008, 21.367010809000078],
              [72.56763756600003, 21.37641022300005],
              [72.56462649800005, 21.38580963700008],
              [72.57374108200008, 21.39008209800005],
              [72.63510175900007, 21.407456773000035],
              [72.67286217500003, 21.428127346000053],
              [72.67644290500004, 21.43162669500009],
              [72.72828209700003, 21.46580638200004],
              [72.74708092500003, 21.452866929000038],
              [72.75261478000004, 21.46356842700004],
              [72.74854576900003, 21.479641018000052],
              [72.73829186300003, 21.482855536000045],
              [72.68327884200005, 21.46580638200004],
              [72.66504967500003, 21.45722077000005],
              [72.61247806100005, 21.42186107000009],
              [72.58366946700005, 21.41742584800005],
              [72.58985436300003, 21.432766018000052],
              [72.61963951900003, 21.48737213700008],
              [72.63510175900007, 21.499335028000075],
              [72.65105228000004, 21.507025458000044],
              [72.69011478000004, 21.540676174000055],
              [72.70394941500007, 21.54840729400007],
              [72.72681725400008, 21.553168036000045],
              [72.75114993600005, 21.56513092700004],
              [72.77320397200003, 21.580511786000045],
              [72.78907311300003, 21.595526434000078],
              [72.81039472700007, 21.63507721600007],
              [72.82309004000007, 21.64394765800006],
              [72.83399498800003, 21.644476630000042],
              [72.85873457100007, 21.637600002000056],
              [72.87159264400003, 21.636542059000078],
              [72.88965905000003, 21.64052969000005],
              [72.93555748800003, 21.658351955000057],
              [72.96534264400003, 21.67877838700008],
              [73.02247155000003, 21.698553778000075],
              [73.08497155000003, 21.729681708000044],
              [73.10816491000008, 21.733343817000048],
              [73.11695397200003, 21.737250067000048],
              [73.12696373800003, 21.74677155200004],
              [73.13200931100005, 21.75779857000009],
              [73.12614993600005, 21.766831773000035],
              [73.11882571700005, 21.76471588700008],
              [73.08399498800003, 21.74640534100007],
              [73.04664147200003, 21.733343817000048],
              [73.04102623800003, 21.730169989000046],
              [73.02247155000003, 21.716009833000044],
              [73.01246178500008, 21.712836005000042],
              [72.99146569100003, 21.70844147300005],
              [72.95020592500003, 21.689154364000046],
              [72.92693118600005, 21.68496328300006],
              [72.88282311300003, 21.693019924000055],
              [72.85816491000008, 21.694973049000055],
              [72.84034264400003, 21.688381252000056],
              [72.81918379000007, 21.675034898000035],
              [72.79810631600003, 21.673529364000046],
              [72.75562584700003, 21.68496328300006],
              [72.73324629000007, 21.68748607000009],
              [72.67644290500004, 21.678127346000053],
              [72.65300540500004, 21.680568752000056],
              [72.63493899800005, 21.68463776200008],
              [72.61605879000007, 21.68545156500005],
              [72.57048587300005, 21.670477606000077],
              [72.55030358200008, 21.66669342700004],
              [72.53467858200008, 21.67291901200008],
              [72.52849368600005, 21.695135809000078],
              [72.53207441500007, 21.71385325700004],
              [72.55014082100007, 21.75193919500009],
              [72.55632571700005, 21.774318752000056],
              [72.56275475400008, 21.83942291900007],
              [72.56690514400003, 21.849351304000038],
              [72.58545983200008, 21.85887278900009],
              [72.59880618600005, 21.881008205000057],
              [72.61841881600003, 21.925116278000075],
              [72.63404381600003, 21.93748607000009],
              [72.65211022200003, 21.941066799000055],
              [72.69011478000004, 21.938788153000075],
              [72.70232181100005, 21.94757721600007],
              [72.70679772200003, 21.966131903000075],
              [72.71404056100005, 21.982977606000077],
              [72.73454837300005, 21.98655833500004],
              [72.73454837300005, 21.99404531500005],
              [72.72641035200007, 21.995754299000055],
              [72.71989993600005, 21.99632396000004],
              [72.71371504000007, 21.995794989000046],
              [72.70777428500008, 21.99404531500005],
              [72.70093834700003, 21.98891836100006],
              [72.69752037900008, 21.982123114000046],
              [72.69564863400007, 21.975897528000075],
              [72.69353274800005, 21.972316799000055],
              [72.62305748800003, 21.966620184000078],
              [72.61158287900008, 21.955511786000045],
              [72.60271243600005, 21.94358958500004],
              [72.58179772200003, 21.928168036000045],
              [72.55860436300003, 21.915269273000035],
              [72.54273522200003, 21.91083405200004],
              [72.53337649800005, 21.920314846000053],
              [72.50709069100003, 21.96230703300006],
              [72.50171959700003, 21.97601959800005],
              [72.50456790500004, 21.994208075000074],
              [72.51775149800005, 22.032131252000056],
              [72.52222741000008, 22.05426666900007],
              [72.52149498800003, 22.066148179000038],
              [72.51954186300003, 22.07754140800006],
              [72.51954186300003, 22.088446356000077],
              [72.53003991000008, 22.107489325000074],
              [72.53337649800005, 22.11855703300006],
              [72.53589928500008, 22.14052969000005],
              [72.54216556100005, 22.156724351000037],
              [72.55738366000008, 22.176662502000056],
              [72.57545006600003, 22.194525458000044],
              [72.59050540500004, 22.205023505000042],
              [72.61410566500007, 22.211737372000073],
              [72.63445071700005, 22.21039459800005],
              [72.65235436300003, 22.202337958000044],
              [72.66960696700005, 22.18891022300005],
              [72.68189537900008, 22.181586005000042],
              [72.69166100400008, 22.18195221600007],
              [72.69971764400003, 22.18496328300006],
              [72.70777428500008, 22.18577708500004],
              [72.71941165500004, 22.182196356000077],
              [72.72925866000008, 22.177435614000046],
              [72.74822024800005, 22.16404857000009],
              [72.79021243600005, 22.217230536000045],
              [72.81226647200003, 22.234116929000038],
              [72.84742272200003, 22.24042389500005],
              [72.86508222700007, 22.23346588700008],
              [72.88111412900008, 22.220404364000046],
              [72.89722741000008, 22.213039455000057],
              [72.91602623800003, 22.223089911000045],
              [72.92212975400008, 22.23651764500005],
              [72.92269941500007, 22.25458405200004],
              [72.91749108200008, 22.271429755000042],
              [72.90577233200008, 22.281398830000057],
              [72.89966881600003, 22.269191799000055],
              [72.88607832100007, 22.26239655200004],
              [72.86947675900007, 22.26239655200004],
              [72.85425866000008, 22.270819403000075],
              [72.83863366000008, 22.276556708000044],
              [72.81820722700007, 22.27342357000009],
              [72.79867597700007, 22.265570380000042],
              [72.78541100400008, 22.25690338700008],
              [72.75660241000008, 22.24371979400007],
              [72.72657311300003, 22.248928127000056],
              [72.65943444100003, 22.273911851000037],
              [72.64649498800003, 22.273911851000037],
              [72.63526451900003, 22.271633205000057],
              [72.62501061300003, 22.27138906500005],
              [72.60661868600005, 22.28384023600006],
              [72.59636478000004, 22.286932684000078],
              [72.57374108200008, 22.288234768000052],
              [72.55307050900007, 22.282456773000035],
              [72.52116946700005, 22.253119208000044],
              [72.50171959700003, 22.24042389500005],
              [72.47901451900003, 22.23338450700004],
              [72.46615644600007, 22.232570705000057],
              [72.45704186300003, 22.236721096000053],
              [72.45484459700003, 22.245306708000044],
              [72.46697024800005, 22.25584544500009],
              [72.46387780000003, 22.26398346600007],
              [72.44874108200008, 22.266831773000035],
              [72.43230228000004, 22.25584544500009],
              [72.41374759200005, 22.24632396000004],
              [72.39185631600003, 22.25348541900007],
              [72.38624108200008, 22.266506252000056],
              [72.38103274800005, 22.289943752000056],
              [72.38038170700008, 22.31240469000005],
              [72.38819420700008, 22.322333075000074],
              [72.40495853000004, 22.332953192000048],
              [72.40805097700007, 22.353461005000042],
              [72.39722741000008, 22.36676666900007],
              [72.37134850400008, 22.355902411000045],
              [72.36101321700005, 22.343451239000046],
              [72.34961998800003, 22.324367580000057],
              [72.34050540500004, 22.303208726000037],
              [72.33659915500004, 22.284816799000055],
              [72.32829837300005, 22.26072825700004],
              [72.30909264400003, 22.25722890800006],
              [72.28834069100003, 22.26129791900007],
              [72.27515709700003, 22.260321356000077],
              [72.26319420700008, 22.27635325700004],
              [72.26596113400007, 22.28733958500004],
              [72.26465905000003, 22.29523346600007],
              [72.24040774800005, 22.301906643000052],
              [72.22339928500008, 22.303168036000045],
              [72.20850670700008, 22.300441799000055],
              [72.20093834700003, 22.291449286000045],
              [72.20630944100003, 22.273911851000037],
              [72.16179446700005, 22.280951239000046],
              [72.14877363400007, 22.277899481000077],
              [72.16602623800003, 22.260321356000077],
              [72.19068444100003, 22.251288153000075],
              [72.20923912900008, 22.259426174000055],
              [72.24040774800005, 22.288234768000052],
              [72.24610436300003, 22.27558014500005],
              [72.24317467500003, 22.26593659100007],
              [72.23731530000003, 22.256293036000045],
              [72.23414147200003, 22.24355703300006],
              [72.23910566500007, 22.23891836100006],
              [72.26832116000008, 22.22675202000005],
              [72.30648847700007, 22.22955963700008],
              [72.31723066500007, 22.184881903000075],
              [72.30762780000003, 22.079006252000056],
              [72.29802493600005, 22.061672268000052],
              [72.29566491000008, 22.051174221000053],
              [72.29175866000008, 22.05341217700004],
              [72.28345787900008, 22.04360586100006],
              [72.27613366000008, 22.031642971000053],
              [72.27515709700003, 22.02753327000005],
              [72.25766035200007, 22.012152411000045],
              [72.24935957100007, 22.008286851000037],
              [72.23731530000003, 22.007025458000044],
              [72.22095787900008, 22.010972398000035],
              [72.21648196700005, 22.00779857000009],
              [72.21436608200008, 21.99404531500005],
              [72.20630944100003, 21.99404531500005],
              [72.19988040500004, 22.006984768000052],
              [72.19516035200007, 22.003648179000038],
              [72.19117272200003, 21.99363841400009],
              [72.18637129000007, 21.98655833500004],
              [72.18246504000007, 21.98273346600007],
              [72.17310631600003, 21.97565338700008],
              [72.16342207100007, 21.973211981000077],
              [72.15919030000003, 21.98314036700009],
              [72.15170332100007, 21.993882554000038],
              [72.13428795700008, 22.00458405200004],
              [72.11378014400003, 22.010565497000073],
              [72.09701582100007, 22.007025458000044],
              [72.11931399800005, 21.99363841400009],
              [72.12810306100005, 21.983547268000052],
              [72.12484785200007, 21.972316799000055],
              [72.11491946700005, 21.96938711100006],
              [72.07650800900007, 21.979722398000035],
              [72.08253014400003, 21.97337474200009],
              [72.10450280000003, 21.95921458500004],
              [72.10482832100007, 21.95148346600007],
              [72.10206139400003, 21.945054429000038],
              [72.09620201900003, 21.943019924000055],
              [72.08741295700008, 21.948431708000044],
              [72.07325280000003, 21.95449453300006],
              [72.05518639400003, 21.953517971000053],
              [72.03842207100007, 21.94757721600007],
              [72.02865644600007, 21.938788153000075],
              [72.08757571700005, 21.919663804000038],
              [72.10450280000003, 21.917669989000046],
              [72.14210045700008, 21.924994208000044],
              [72.15650475400008, 21.925848700000074],
              [72.14535566500007, 21.917669989000046],
              [72.14535566500007, 21.91083405200004],
              [72.15919030000003, 21.90460846600007],
              [72.15235436300003, 21.89785390800006],
              [72.16976972700007, 21.890448309000078],
              [72.16732832100007, 21.87913646000004],
              [72.16000410200007, 21.86591217700004],
              [72.16260826900003, 21.852850653000075],
              [72.16944420700008, 21.84137604400007],
              [72.16187584700003, 21.839178778000075],
              [72.13086998800003, 21.846258856000077],
              [72.12330162900008, 21.85374583500004],
              [72.11133873800003, 21.86985911700009],
              [72.09848066500007, 21.880519924000055],
              [72.07764733200008, 21.89443594000005],
              [72.05795332100007, 21.89874909100007],
              [72.04932701900003, 21.88043854400007],
              [72.05290774800005, 21.87653229400007],
              [72.06153405000003, 21.873114325000074],
              [72.07178795700008, 21.870794989000046],
              [72.08033287900008, 21.86985911700009],
              [72.08643639400003, 21.865627346000053],
              [72.10450280000003, 21.835760809000078],
              [72.08676191500007, 21.83026764500005],
              [72.06283613400007, 21.834377346000053],
              [72.00416100400008, 21.85773346600007],
              [71.99732506600003, 21.85492584800005],
              [71.99463951900003, 21.839504299000055],
              [71.99415123800003, 21.812201239000046],
              [71.99610436300003, 21.79950592700004],
              [72.00147545700008, 21.787909247000073],
              [72.00538170700008, 21.79295482000009],
              [72.00961347700007, 21.79559967700004],
              [72.02182050900007, 21.80097077000005],
              [72.02149498800003, 21.79441966400009],
              [72.02230879000007, 21.780910549000055],
              [72.02182050900007, 21.774318752000056],
              [72.05494225400008, 21.785589911000045],
              [72.07390384200005, 21.788723049000055],
              [72.08741295700008, 21.784491278000075],
              [72.10320071700005, 21.775213934000078],
              [72.11744225400008, 21.776597398000035],
              [72.16602623800003, 21.79393138200004],
              [72.17107181100005, 21.790961005000042],
              [72.17269941500007, 21.777736721000053],
              [72.17701256600003, 21.76666901200008],
              [72.19581139400003, 21.75779857000009],
              [72.20004316500007, 21.750067450000074],
              [72.20240319100003, 21.748114325000074],
              [72.21436608200008, 21.712836005000042],
              [72.21900475400008, 21.706000067000048],
              [72.22380618600005, 21.70058828300006],
              [72.23023522200003, 21.69599030200004],
              [72.24040774800005, 21.69171784100007],
              [72.25180097700007, 21.69090403900009],
              [72.26303144600007, 21.692328192000048],
              [72.27173912900008, 21.69090403900009],
              [72.27833092500003, 21.671942450000074],
              [72.28541100400008, 21.66502513200004],
              [72.29249108200008, 21.659491278000075],
              [72.29566491000008, 21.65387604400007],
              [72.29664147200003, 21.64215729400007],
              [72.29851321700005, 21.633978583000044],
              [72.29883873800003, 21.626288153000075],
              [72.29566491000008, 21.616034247000073],
              [72.29200280000003, 21.611761786000045],
              [72.27914472700007, 21.600531317000048],
              [72.27515709700003, 21.595526434000078],
              [72.24219811300003, 21.48078034100007],
              [72.21989993600005, 21.44472890800006],
              [72.16684004000007, 21.39207591400009],
              [72.15919030000003, 21.37327708500004],
              [72.15162194100003, 21.360174872000073],
              [72.11605879000007, 21.322739976000037],
              [72.10450280000003, 21.315008856000077],
              [72.11003665500004, 21.304836330000057],
              [72.11150149800005, 21.296087958000044],
              [72.10775800900007, 21.289984442000048],
              [72.09701582100007, 21.287665106000077],
              [72.10254967500003, 21.27440013200004],
              [72.09937584700003, 21.264960028000075],
              [72.09359785200007, 21.258205471000053],
              [72.09083092500003, 21.25291575700004],
              [72.09351647200003, 21.24355703300006],
              [72.10450280000003, 21.22215403900009],
              [72.10474694100003, 21.20506419500009],
              [72.09083092500003, 21.191473700000074],
              [72.08480879000007, 21.188706773000035],
              [72.07545006600003, 21.185695705000057],
              [72.06666100400008, 21.181341864000046],
              [72.06283613400007, 21.174709377000056],
              [72.05502363400007, 21.168361721000053],
              [71.99073326900003, 21.136379299000055],
              [71.97242272200003, 21.13226959800005],
              [71.92628014400003, 21.130031643000052],
              [71.80616295700008, 21.06207916900007],
              [71.78858483200008, 21.04751211100006],
              [71.76295006600003, 21.03229401200008],
              [71.74366295700008, 21.02757396000004],
              [71.73023522200003, 21.03070709800005],
              [71.71762129000007, 21.032049872000073],
              [71.69974337837239, 21.021306493560147],
              [71.68336022200003, 21.011460679000038],
              [71.63998457100007, 20.99681224200009],
              [71.58350670700008, 20.958238023000035],
              [71.54957116000008, 20.951239325000074],
              [71.55730228000004, 20.966009833000044],
              [71.56234785200007, 20.97296784100007],
              [71.56934655000003, 20.97919342700004],
              [71.55111738400007, 20.973578192000048],
              [71.53679446700005, 20.96430084800005],
              [71.49341881600003, 20.92914459800005],
              [71.48438561300009, 20.917141018000052],
              [71.48072350400008, 20.90037669500009],
              [71.46225019600007, 20.885321356000077],
              [71.37810306100005, 20.859442450000074],
              [71.31861412900008, 20.849310614000046],
              [71.14063561300009, 20.765692450000074],
              [71.11695397200003, 20.766913153000075],
              [71.11011803500008, 20.759466864000046],
              [71.09546959700003, 20.763739325000074],
              [71.08326256600003, 20.75653717700004],
              [71.07260175900007, 20.74567291900007],
              [71.06234785200007, 20.73895905200004],
              [71.04444420700008, 20.74054596600007],
              [71.02418053500008, 20.744533596000053],
              [71.00766035200007, 20.74160390800006],
              [71.00595136800007, 20.73655833500004],
              [71.00082441500007, 20.72215403900009],
              [70.98243248800009, 20.710150458000044],
              [70.97299238400007, 20.70962148600006],
              [70.90253114232611, 20.70551993138298],
              [70.84017988400007, 20.70189036700009],
              [70.81967207100007, 20.702948309000078],
              [70.80160566500007, 20.709051825000074],
              [70.78516686300009, 20.72215403900009],
              [70.77458743600005, 20.727362372000073],
              [70.76319420700008, 20.724554755000042],
              [70.75163821700005, 20.719631252000056],
              [70.74024498800009, 20.718491929000038],
              [70.73080488400007, 20.723211981000077],
              [70.69857832100007, 20.74640534100007],
              [70.56217415529785, 20.799766947861755],
              [70.54151451900003, 20.807847398000035],
              [70.48414147200003, 20.84393952000005],
              [70.46306399800005, 20.848863023000035],
              [70.45142662900008, 20.855902411000045],
              [70.41700280000003, 20.890448309000078],
              [70.39877363400007, 20.903509833000044],
              [70.33668053500008, 20.927069403000075],
              [70.29997806100005, 20.95856354400007],
              [70.26351972700007, 20.980414130000042],
              [70.15219160200007, 21.078517971000053],
              [70.05444521916755, 21.15315547561164],
              [69.9883320892602, 21.23340013122087],
              [69.96801943816754, 21.25805456361161],
              [69.96615644600007, 21.263413804000038],
              [69.95826256600003, 21.27334219000005],
              [69.91163170700008, 21.315008856000077],
              [69.84498131600003, 21.389593817000048],
              [69.81470787900008, 21.433661200000074],
              [69.80860436300009, 21.46580638200004],
              [69.78874759200005, 21.469305731000077],
              [69.77149498800009, 21.47842031500005],
              [69.75635826900003, 21.49042389500005],
              [69.62973066500007, 21.616034247000073],
              [69.56820722700007, 21.650132554000038],
              [69.55274498800009, 21.665187893000052],
              [69.51978600400008, 21.704779364000046],
              [69.49935957100007, 21.72020091400009],
              [69.47852623800009, 21.75263092700004],
              [69.44629967500003, 21.76630280200004],
              [69.42741946700005, 21.78123607000009],
              [69.39771569100003, 21.815252997000073],
              [69.39177493600005, 21.832180080000057],
              [69.39519290500004, 21.86131419500009],
              [69.39087975400008, 21.876695054000038],
              [69.36784915500004, 21.85610586100006],
              [69.35547936300009, 21.853176174000055],
              [69.33619225400008, 21.862453518000052],
              [69.24390709700003, 21.94594961100006],
              [69.21225019600007, 21.96747467700004],
              [69.19841556100005, 21.979722398000035],
              [69.15064537900008, 22.04120514500005],
              [69.11931399800005, 22.06207916900007],
              [69.10303795700008, 22.07636139500005],
              [69.09205162900008, 22.09959544500009],
              [69.04818769600007, 22.157904364000046],
              [69.01254316500007, 22.185614325000074],
              [68.99415123800009, 22.203924872000073],
              [68.98047936300009, 22.235541083000044],
              [68.95329837300005, 22.27602773600006],
              [68.94459069100003, 22.295070705000057],
              [68.94402103000004, 22.31826406500005],
              [68.95142662900008, 22.334865627000056],
              [68.96062259200005, 22.34951406500005],
              [68.96501712300005, 22.36676666900007],
              [68.96762129000007, 22.387193101000037],
              [68.97437584700003, 22.404730536000045],
              [68.98324629000007, 22.41937897300005],
              [68.99293053500008, 22.431586005000042],
              [69.00749759200005, 22.443182684000078],
              [69.04753665500004, 22.464016018000052],
              [69.07357832100007, 22.48187897300005],
              [69.08139082100007, 22.480536200000074],
              [69.08521569100003, 22.47288646000004],
              [69.08228600400008, 22.459540106000077],
              [69.07447350400008, 22.44944896000004],
              [69.05600019600007, 22.441839911000045],
              [69.04818769600007, 22.431586005000042],
              [69.06226647200003, 22.40770091400009],
              [69.07178795700008, 22.39948151200008],
              [69.08855228000004, 22.396877346000053],
              [69.09742272200003, 22.398871161000045],
              [69.11378014400003, 22.407863674000055],
              [69.12273196700005, 22.411078192000048],
              [69.13200931100005, 22.41046784100007],
              [69.13982181100005, 22.407131252000056],
              [69.14698326900003, 22.404852606000077],
              [69.15463300900007, 22.40770091400009],
              [69.16879316500007, 22.42064036700009],
              [69.17855879000007, 22.42763906500005],
              [69.18824303500008, 22.42641836100006],
              [69.20215905000003, 22.414862372000073],
              [69.20573978000004, 22.39866771000004],
              [69.18213951900003, 22.366441148000035],
              [69.18531334700003, 22.349676825000074],
              [69.16968834700003, 22.327948309000078],
              [69.17383873800009, 22.308294989000046],
              [69.19044030000003, 22.292303778000075],
              [69.21208743600005, 22.281398830000057],
              [69.21208743600005, 22.273911851000037],
              [69.28646894600007, 22.28461334800005],
              [69.33570397200003, 22.30613841400009],
              [69.34644616000008, 22.32489655200004],
              [69.35987389400003, 22.32916901200008],
              [69.43539472700007, 22.33038971600007],
              [69.46892337300005, 22.337836005000042],
              [69.47966556100005, 22.342230536000045],
              [69.48536217500003, 22.34756094000005],
              [69.50001061300009, 22.36676666900007],
              [69.50269616000008, 22.372259833000044],
              [69.50855553500008, 22.374253648000035],
              [69.51514733200008, 22.37518952000005],
              [69.51986738400007, 22.37763092700004],
              [69.52564537900008, 22.39207591400009],
              [69.52279707100007, 22.40387604400007],
              [69.51693769600007, 22.416083075000074],
              [69.51368248800009, 22.431586005000042],
              [69.51596113400007, 22.448146877000056],
              [69.52198326900003, 22.448919989000046],
              [69.53077233200008, 22.446112372000073],
              [69.54102623800009, 22.452093817000048],
              [69.54786217500003, 22.452093817000048],
              [69.55982506600003, 22.41152578300006],
              [69.56169681100005, 22.39158763200004],
              [69.55469811300009, 22.37763092700004],
              [69.56902103000004, 22.37055084800005],
              [69.60108483200008, 22.363836981000077],
              [69.61605879000007, 22.355902411000045],
              [69.61744225400008, 22.365057684000078],
              [69.61988366000008, 22.371039130000042],
              [69.62973066500007, 22.38377513200004],
              [69.64039147200003, 22.37596263200004],
              [69.64722741000008, 22.38043854400007],
              [69.65235436300009, 22.389878648000035],
              [69.65772545700008, 22.396877346000053],
              [69.66130618600005, 22.400213934000078],
              [69.66521243600005, 22.40497467700004],
              [69.66944420700008, 22.40924713700008],
              [69.67465254000007, 22.411078192000048],
              [69.68083743600005, 22.40961334800005],
              [69.69450931100005, 22.403957424000055],
              [69.69939212300005, 22.40428294500009],
              [69.70899498800009, 22.418890692000048],
              [69.72535241000008, 22.464544989000046],
              [69.73340905000003, 22.48004791900007],
              [69.74219811300009, 22.47296784100007],
              [69.78874759200005, 22.423163153000075],
              [69.79493248800009, 22.41860586100006],
              [69.80697675900007, 22.42096588700008],
              [69.81299889400003, 22.429510809000078],
              [69.81690514400003, 22.44098541900007],
              [69.82227623800009, 22.452093817000048],
              [69.83326256600003, 22.463812567000048],
              [69.84180748800009, 22.46637604400007],
              [69.85108483200008, 22.465236721000053],
              [69.86378014400003, 22.465765692000048],
              [69.88477623800009, 22.473578192000048],
              [69.90528405000003, 22.486395575000074],
              [69.96208743600005, 22.53534577000005],
              [69.97299238400007, 22.541449286000045],
              [69.97388756600003, 22.539984442000048],
              [69.99626712300005, 22.541449286000045],
              [70.00269616000008, 22.54315827000005],
              [70.02084394600007, 22.555121161000045],
              [70.05909264400003, 22.558417059000078],
              [70.14470462300005, 22.547796942000048],
              [70.17847741000008, 22.56195709800005],
              [70.18970787900008, 22.577785549000055],
              [70.20728600400008, 22.614976304000038],
              [70.23487389400003, 22.648871161000045],
              [70.26726321700005, 22.705959377000056],
              [70.31910241000008, 22.778265692000048],
              [70.32325280000003, 22.787665106000077],
              [70.32154381600003, 22.811712958000044],
              [70.32252037900008, 22.822658596000053],
              [70.32545006600003, 22.826320705000057],
              [70.34294681100005, 22.84316640800006],
              [70.37525475400008, 22.90265534100007],
              [70.38770592500003, 22.91201406500005],
              [70.40463300900007, 22.91950104400007],
              [70.43685957100007, 22.954901434000078],
              [70.45337975400008, 22.966620184000078],
              [70.46273847700007, 22.966538804000038],
              [70.47429446700005, 22.964056708000044],
              [70.48633873800009, 22.963690497000073],
              [70.49756920700008, 22.970038153000075],
              [70.50473066500007, 22.97955963700008],
              [70.51238040500004, 22.995347398000035],
              [70.51791425900007, 23.00389232000009],
              [70.52719160200007, 23.023586330000057],
              [70.52849368600005, 23.04706452000005],
              [70.52369225400008, 23.070379950000074],
              [70.51490319100003, 23.089544989000046],
              [70.50294030000003, 23.104396877000056],
              [70.48422285200007, 23.12213776200008],
              [70.46713300900007, 23.129706122000073],
              [70.45964603000004, 23.11399974200009],
              [70.45093834700003, 23.10565827000005],
              [70.41065514400003, 23.086004950000074],
              [70.39877363400007, 23.06903717700004],
              [70.39893639400003, 23.059068101000037],
              [70.40105228000004, 23.045396226000037],
              [70.40447024800005, 23.033351955000057],
              [70.41098066500007, 23.023179429000038],
              [70.40186608200008, 22.999253648000035],
              [70.40202884200005, 22.99022044500009],
              [70.40381920700008, 22.98187897300005],
              [70.40349368600005, 22.96784088700008],
              [70.40162194100003, 22.95384349200009],
              [70.39877363400007, 22.94550202000005],
              [70.39242597700007, 22.94086334800005],
              [70.38453209700003, 22.93886953300006],
              [70.36353600400008, 22.938706773000035],
              [70.35767662900008, 22.936712958000044],
              [70.35238691500007, 22.93305084800005],
              [70.34669030000003, 22.931301174000055],
              [70.33952884200005, 22.935288804000038],
              [70.33448326900003, 22.94013092700004],
              [70.33041425900007, 22.943304755000042],
              [70.32569420700008, 22.945013739000046],
              [70.31910241000008, 22.94550202000005],
              [70.31462649800005, 22.943508205000057],
              [70.30876712300005, 22.93976471600007],
              [70.30347741000008, 22.93813711100006],
              [70.30005944100003, 22.944281317000048],
              [70.29363040500004, 22.95140208500004],
              [70.29175866000008, 22.95302969000005],
              [70.26929772200003, 22.95856354400007],
              [70.25831139400003, 22.971869208000044],
              [70.24968509200005, 22.987453518000052],
              [70.23308353000004, 23.000148830000057],
              [70.23194420700008, 22.97492096600007],
              [70.22201582100007, 22.95917389500005],
              [70.20411217500003, 22.95221588700008],
              [70.17847741000008, 22.95302969000005],
              [70.17172285200007, 22.951971747000073],
              [70.16773522200003, 22.94912344000005],
              [70.16309655000003, 22.948960679000038],
              [70.15430748800009, 22.95604075700004],
              [70.15072675900007, 22.961004950000074],
              [70.14966881600003, 22.96430084800005],
              [70.14747155000003, 22.966050523000035],
              [70.14063561300009, 22.966620184000078],
              [70.12907962300005, 22.969305731000077],
              [70.12501061300009, 22.97597890800006],
              [70.12623131600003, 22.984808661000045],
              [70.13062584700003, 22.993963934000078],
              [70.10954837300005, 22.95917389500005],
              [70.12045332100007, 22.95258209800005],
              [70.13233483200008, 22.941066799000055],
              [70.13542728000004, 22.92999909100007],
              [70.12012780000003, 22.925034898000035],
              [70.06177819100003, 22.91819896000004],
              [69.99691816500007, 22.893784898000035],
              [69.94068444100003, 22.88613515800006],
              [69.88428795700008, 22.86782461100006],
              [69.85287519600007, 22.86359284100007],
              [69.83318118600005, 22.85846588700008],
              [69.80681399800005, 22.84528229400007],
              [69.78012129000007, 22.827460028000075],
              [69.76010175900007, 22.808335679000038],
              [69.72885175900007, 22.754828192000048],
              [69.71583092500003, 22.746893622000073],
              [69.69434655000003, 22.749701239000046],
              [69.65381920700008, 22.76048411700009],
              [69.58570397200003, 22.76117584800005],
              [69.57569420700008, 22.76434967700004],
              [69.55697675900007, 22.778509833000044],
              [69.54444420700008, 22.781683661000045],
              [69.51075280000003, 22.780503648000035],
              [69.50001061300009, 22.781683661000045],
              [69.48943118600005, 22.78473541900007],
              [69.48259524800005, 22.78847890800006],
              [69.47730553500008, 22.79205963700008],
              [69.47217858200008, 22.794663804000038],
              [69.42465254000007, 22.80426666900007],
              [69.40593509200005, 22.813666083000044],
              [69.37256920700008, 22.81899648600006],
              [69.33814537900008, 22.83307526200008],
              [69.23878014400003, 22.841945705000057],
              [69.20191491000008, 22.85224030200004],
              [69.13559004000007, 22.888373114000046],
              [69.03988691500007, 22.950506903000075],
              [68.86622155000003, 23.019964911000045],
              [68.69125410200007, 23.130519924000055],
              [68.66065514400003, 23.154242255000042],
              [68.65406334700003, 23.15778229400007],
              [68.65064537900008, 23.162054755000042],
              [68.65113366000008, 23.17145416900007],
              [68.64966881600003, 23.180853583000044],
              [68.62256920700008, 23.191555080000057],
              [68.60914147200003, 23.206773179000038],
              [68.59994550900007, 23.225043036000045],
              [68.59571373800009, 23.240383205000057],
              [68.59831790500004, 23.23696523600006],
              [68.60938561300009, 23.226711330000057],
              [68.62012780000003, 23.245428778000075],
              [68.62322024800005, 23.25617096600007],
              [68.62305748800009, 23.267645575000074],
              [68.60531660200007, 23.259588934000078],
              [68.57781009200005, 23.25527578300006],
              [68.55225670700008, 23.259711005000042],
              [68.54102623800009, 23.278225002000056],
              [68.56104576900003, 23.316107489000046],
              [68.56853274800005, 23.318426825000074],
              [68.59913170700008, 23.32225169500009],
              [68.60694420700008, 23.32558828300006],
              [68.60303795700008, 23.332831122000073],
              [68.59205162900008, 23.34007396000004],
              [68.57837975400008, 23.343410549000055],
              [68.57105553500008, 23.34638092700004],
              [68.56666100400008, 23.35297272300005],
              [68.56373131600003, 23.359930731000077],
              [68.56104576900003, 23.36391836100006],
              [68.55518639400003, 23.36395905200004],
              [68.54851321700005, 23.36151764500005],
              [68.54314212300005, 23.358587958000044],
              [68.54102623800009, 23.35700104400007],
              [68.52947024800005, 23.363104559000078],
              [68.52068118600005, 23.369208075000074],
              [68.51514733200008, 23.377020575000074],
              [68.51319420700008, 23.38808828300006],
              [68.51514733200008, 23.399318752000056],
              [68.52076256600003, 23.407538153000075],
              [68.52955162900008, 23.411932684000078],
              [68.54102623800009, 23.41168854400007],
              [68.53638756600003, 23.42133209800005],
              [68.53012129000007, 23.42568594000005],
              [68.52214603000004, 23.424750067000048],
              [68.51319420700008, 23.418524481000077],
              [68.50147545700008, 23.42328522300005],
              [68.49642988400007, 23.41787344000005],
              [68.49048912900008, 23.409328518000052],
              [68.47535241000008, 23.404852606000077],
              [68.46257571700005, 23.409125067000048],
              [68.45883222700007, 23.41982656500005],
              [68.46111087300005, 23.43317291900007],
              [68.46550540500004, 23.445786851000037],
              [68.45191491000008, 23.43773021000004],
              [68.44044030000003, 23.43427155200004],
              [68.43091881600003, 23.43659088700008],
              [68.42367597700007, 23.445786851000037],
              [68.43295332100007, 23.46588776200008],
              [68.44743899800005, 23.487453518000052],
              [68.46558678500008, 23.50527578300006],
              [68.48585045700008, 23.514105536000045],
              [68.48129316500007, 23.525132554000038],
              [68.47559655000003, 23.52411530200004],
              [68.46802819100003, 23.51984284100007],
              [68.45866946700005, 23.52147044500009],
              [68.45411217500003, 23.526271877000056],
              [68.44402103000004, 23.54120514500005],
              [68.43734785200007, 23.54881419500009],
              [68.44141686300009, 23.532049872000073],
              [68.44743899800005, 23.51634349200009],
              [68.44695071700005, 23.50299713700008],
              [68.43116295700008, 23.49359772300005],
              [68.41163170700008, 23.494696356000077],
              [68.40609785200007, 23.508734442000048],
              [68.41081790500004, 23.54881419500009],
              [68.40495853000004, 23.597601630000042],
              [68.40886478000004, 23.62132396000004],
              [68.42750084700003, 23.631415106000077],
              [68.47152754000007, 23.61863841400009],
              [68.49146569100003, 23.618841864000046],
              [68.49268639400003, 23.637600002000056],
              [68.48617597700007, 23.641424872000073],
              [68.47689863400007, 23.63934967700004],
              [68.46876061300009, 23.64081452000005],
              [68.46550540500004, 23.65525950700004],
              [68.46941165500004, 23.65924713700008],
              [68.48894290500004, 23.66478099200009],
              [68.50473066500007, 23.674221096000053],
              [68.52393639400003, 23.675930080000057],
              [68.53353925900007, 23.67918528900009],
              [68.53882897200003, 23.684027411000045],
              [68.55469811300009, 23.70648834800005],
              [68.58350670700008, 23.735296942000048],
              [68.60173587300005, 23.74868398600006],
              [68.63786868600005, 23.761542059000078],
              [68.65455162900008, 23.79905833500004],
              [68.67074629000007, 23.815741278000075],
              [68.68018639400003, 23.81777578300006],
              [68.71558678500008, 23.815741278000075],
              [68.72559655000003, 23.818915106000077],
              [68.74512780000003, 23.83307526200008],
              [68.75652103000004, 23.83624909100007],
              [68.76880944100003, 23.841131903000075],
              [68.82162519600007, 23.87840403900009],
              [68.80567467500003, 23.884426174000055],
              [68.78003991000008, 23.87409088700008],
              [68.76693769600007, 23.87840403900009],
              [68.74024498800009, 23.853461005000042],
              [68.71778405000003, 23.841009833000044],
              [68.69190514400003, 23.83665599200009],
              [68.65406334700003, 23.83624909100007],
              [68.63347415500004, 23.83307526200008],
              [68.62305748800009, 23.82440827000005],
              [68.60938561300009, 23.79523346600007],
              [68.59888756600003, 23.78188711100006],
              [68.58773847700007, 23.77570221600007],
              [68.55469811300009, 23.76854075700004],
              [68.53834069100003, 23.76129791900007],
              [68.52475019600007, 23.752020575000074],
              [68.51002037900008, 23.744086005000042],
              [68.47282962300005, 23.737494208000044],
              [68.44971764400003, 23.72333405200004],
              [68.42774498800009, 23.71430084800005],
              [68.41081790500004, 23.700506903000075],
              [68.34197024800005, 23.623968817000048],
              [68.35157311300009, 23.61782461100006],
              [68.35303795700008, 23.610663153000075],
              [68.34888756600003, 23.60342031500005],
              [68.34197024800005, 23.596625067000048],
              [68.32732181100005, 23.58690013200004],
              [68.31763756600003, 23.58612702000005],
              [68.30811608200008, 23.589056708000044],
              [68.29411868600005, 23.590399481000077],
              [68.23080488400007, 23.58808014500005],
              [68.18140709700003, 23.59406159100007],
              [68.15739993600005, 23.600816148000035],
              [68.14340254000007, 23.61269765800006],
              [68.15015645095593, 23.63137154007535],
              [68.15706876431224, 23.632131490950385],
              [68.16722858354798, 23.63172995620358],
              [68.17432701900003, 23.631415106000077],
              [68.1743704718451, 23.631447695639434],
              [68.17543015294328, 23.631405815092982],
              [68.17867448857325, 23.633717564794274],
              [68.18189537900008, 23.64785390800006],
              [68.18475307804235, 23.652180537982442],
              [68.19267313840308, 23.656280333866516],
              [68.19966291913201, 23.659597272305227],
              [68.20932050900007, 23.66274648600006],
              [68.22078669376458, 23.65842972024138],
              [68.22078917108306, 23.658426923269154],
              [68.2325784065528, 23.644912289923393],
              [68.23266870071008, 23.64501455229441],
              [68.23267662900008, 23.645005601000037],
              [68.24512780000003, 23.659125067000033],
              [68.25893106243088, 23.660480711637636],
              [68.27588951900002, 23.665838934000075],
              [68.28044681100005, 23.685980536000045],
              [68.25896243600005, 23.674709377000056],
              [68.24097741000008, 23.674017645000028],
              [68.23716490511609, 23.67587580238526],
              [68.22486412900008, 23.68187083500004],
              [68.20875084700003, 23.696234442000048],
              [68.19752037900008, 23.714544989000046],
              [68.19581139400003, 23.73346588700008],
              [68.19792728000004, 23.75340403900009],
              [68.19776451900003, 23.77480703300006],
              [68.18772313233943, 23.764263577263478],
              [68.17773551671786, 23.753962042365877],
              [68.16927547207618, 23.7482310535329],
              [68.16374759200005, 23.75771719000005],
              [68.16602623800009, 23.773179429000038],
              [68.17562910200007, 23.79824453300006],
              [68.1798569604983, 23.82793657049472],
              [68.18246504000007, 23.835760809000078],
              [68.18303470100005, 23.84210846600007],
              [68.18351729300008, 23.843300273000054],
              [68.20728845300005, 23.877019145000034],
              [68.21503991700007, 23.881747539000017],
              [68.23291996300009, 23.889111430000114],
              [68.23994795800013, 23.893116353],
              [68.24304854300004, 23.893426412000096],
              [68.25286706500003, 23.891695252000105],
              [68.2567944750001, 23.891927796000076],
              [68.26036014800007, 23.89554514600006],
              [68.25793135600009, 23.89947255500003],
              [68.25374556500009, 23.902779847000133],
              [68.25193689000008, 23.904821066000082],
              [68.2530737720001, 23.911228943000125],
              [68.25266036000005, 23.920091452000023],
              [68.25493412300011, 23.929108989000085],
              [68.26392582200003, 23.935930277000026],
              [68.27400272600005, 23.93768727700011],
              [68.27767175300005, 23.933501486000083],
              [68.2800488690001, 23.92572418300007],
              [68.28619836500008, 23.91637074800012],
              [68.30040938300004, 23.910505473000043],
              [68.31405196100013, 23.91590566100008],
              [68.32598921800007, 23.92779123900003],
              [68.33503259300005, 23.940994568000107],
              [68.33368900500011, 23.948048401000037],
              [68.32986494900007, 23.95815114400007],
              [68.33043339000011, 23.966574402000063],
              [68.34262902800003, 23.9685639450001],
              [68.34888187700011, 23.964610698000044],
              [68.35239587400008, 23.95654917400013],
              [68.35384281400007, 23.947169902],
              [68.35363610900009, 23.939289246000058],
              [68.38546879000006, 23.960424907000075],
              [68.43156416900007, 23.967142843000104],
              [68.54783614100006, 23.966316020000093],
              [68.64643477400006, 23.965695903000025],
              [68.72446618700008, 23.965179139000085],
              [68.72508630400011, 24.10405955000003],
              [68.72555139200006, 24.208911032000103],
              [68.72591312700007, 24.289216207000024],
              [68.74730716900007, 24.331177470000043],
              [68.79919030800005, 24.32908457400005],
              [68.81381473800013, 24.308439840000048],
              [68.81965417500004, 24.250303853000062],
              [68.83877445500013, 24.23645457],
              [68.84890303600008, 24.24402516700006],
              [68.88011560100006, 24.29735524500005],
              [68.88326786300013, 24.30536509200003],
              [68.88507653800008, 24.313555807000043],
              [68.89029585800012, 24.31947275900005],
              [68.9041968190001, 24.32058380200006],
              [68.91318851700004, 24.317250671000053],
              [68.92197351100003, 24.310506897000025],
              [68.92941491800013, 24.302367859000086],
              [68.94869022600011, 24.270276795000072],
              [68.9626428630001, 24.257228495000035],
              [68.98078129100008, 24.25539398200003],
              [69.00780806500006, 24.264566549000037],
              [69.04847741700007, 24.285237121000037],
              [69.06770105000004, 24.288441061000114],
              [69.09188562000008, 24.28190399200004],
              [69.1482129310001, 24.25666005500007],
              [69.16671309400004, 24.253171896000126],
              [69.20624556500007, 24.258572083],
              [69.28081465700012, 24.283738506000034],
              [69.56307133000013, 24.276762187000045],
              [69.59232019000007, 24.264618226000053],
              [69.67055830900011, 24.188705546],
              [69.7145866300001, 24.16857757600006],
              [69.76905358900007, 24.162557272000114],
              [69.97203861500003, 24.16521860800013],
              [70.01596358300009, 24.17405527800004],
              [70.05213708500008, 24.202063904000042],
              [70.06298913600006, 24.2203056850001],
              [70.08717370700003, 24.28254994700002],
              [70.09787072800003, 24.29882802300004],
              [70.10970463000012, 24.30490000400009],
              [70.14458622300003, 24.30789723700009],
              [70.20220544400007, 24.32557057800001],
              [70.22277266400005, 24.326707459000104],
              [70.24256473800006, 24.33060902900006],
              [70.27909997600005, 24.35507782000012],
              [70.29853031400006, 24.363423564000087],
              [70.35320397900011, 24.366265768000048],
              [70.37077396700005, 24.372363587],
              [70.41635258000008, 24.401948344000047],
              [70.52094567900008, 24.424918519000087],
              [70.5629069420001, 24.424091695000058],
              [70.57520593200013, 24.400036316000026],
              [70.56921146600007, 24.38988189800007],
              [70.55195153800008, 24.379365744000026],
              [70.54647383700012, 24.373138733000033],
              [70.54564701400011, 24.362183330000065],
              [70.55536218300011, 24.327017518],
              [70.56021976700004, 24.28725250300009],
              [70.56766117400008, 24.272808940000075],
              [70.5847143960001, 24.25790028900012],
              [70.62150801600012, 24.241157125000072],
              [70.75545332900009, 24.231441956000126],
              [70.77602054900007, 24.23668711400005],
              [70.81358931500012, 24.254463807],
              [70.83410485800005, 24.261285095000048],
              [70.85146813900008, 24.26487660700012],
              [70.85756595900006, 24.27167205800005],
              [70.84454349800012, 24.288286031000084],
              [70.84092614800011, 24.30583018000003],
              [70.85653243000007, 24.323813578000042],
              [70.91771732600006, 24.361718242000038],
              [70.93632084200004, 24.367195943000112],
              [70.9553377690001, 24.365904033000064],
              [70.97714522300004, 24.357248230000025],
              [70.99667891500013, 24.356602275000043],
              [71.00711755400005, 24.363966167000044],
              [71.01435225500006, 24.375205790000095],
              [71.02510095200006, 24.386290385],
              [71.07305668100008, 24.402103374],
              [71.08277185000014, 24.411508484000066],
              [71.07502038600012, 24.436416525000126],
              [71.04008711800003, 24.446777649000026],
              [71.00008955900006, 24.4529013060001],
              [70.97714522300004, 24.464941915000068],
              [70.97435469500005, 24.472202453000037],
              [70.97311446100014, 24.479643860000053],
              [70.97321781400007, 24.487240295000035],
              [70.9747681070001, 24.49496592200002],
              [70.97714522300004, 24.515068054],
              [70.98050419100014, 24.52188934400006],
              [70.98189945500013, 24.528529765000044],
              [70.98086592600004, 24.53473093700005],
              [70.97714522300004, 24.540389506000068],
              [70.95776656100008, 24.55602162700002],
              [70.95482100400005, 24.584521180000067],
              [70.96277917500004, 24.61578542100007],
              [70.97714522300004, 24.63968577100006],
              [71.04334273300003, 24.66906382300003],
              [71.06385827700007, 24.682577209],
              [71.05663232900014, 24.69281974700006],
              [71.03693485500008, 24.72074025500008],
              [71.00319014500008, 24.80820261700005],
              [70.94303877700008, 24.894063009000078],
              [70.91523685700008, 24.946617941000042],
              [70.89332605000004, 25.00188588500005],
              [70.85989139800006, 25.139448548000033],
              [70.84857425900009, 25.163323060000025],
              [70.83141768400003, 25.183321839000072],
              [70.7683724370001, 25.233086243000074],
              [70.73488610900012, 25.267347717000078],
              [70.72310388200003, 25.287294820000014],
              [70.71855635600008, 25.310807597000107],
              [70.7104948330001, 25.335870667],
              [70.67039392100008, 25.37555816700008],
              [70.65447758000005, 25.396590475000025],
              [70.64662276300004, 25.431368713000055],
              [70.65282393400008, 25.545883687000057],
              [70.65747481300008, 25.633630270000097],
              [70.65385746300007, 25.67445465100009],
              [70.63230839000005, 25.701378073000015],
              [70.59225915600007, 25.70881947900004],
              [70.55443200700006, 25.698794251000024],
              [70.51665653500004, 25.68385976200007],
              [70.47722741700011, 25.676315003000113],
              [70.3601286220001, 25.673472799000038],
              [70.30369795700005, 25.684583232000065],
              [70.26457889800014, 25.697295634000014],
              [70.24923099800003, 25.70768259700013],
              [70.23445153800003, 25.73098866800005],
              [70.2139876710001, 25.786334127000103],
              [70.19559086200007, 25.806953024],
              [70.15424971500005, 25.839405823000035],
              [70.11497562700009, 25.881728821000124],
              [70.08324629700007, 25.92994293300002],
              [70.06464278200008, 25.98032745400012],
              [70.06428104700012, 25.995520325000044],
              [70.07291101100003, 26.047455139000064],
              [70.07389286300008, 26.083111878000054],
              [70.07828536000011, 26.09964833600013],
              [70.1320288500001, 26.180470276000094],
              [70.14691166200004, 26.217418925000047],
              [70.15161421800013, 26.25405751600009],
              [70.14401778200005, 26.29431345700003],
              [70.14246748900013, 26.313692118000077],
              [70.14794519100013, 26.33322581],
              [70.15714359600014, 26.353999736000034],
              [70.16050256400013, 26.371311340000048],
              [70.15698856600011, 26.410947164],
              [70.16293135500013, 26.493319397000093],
              [70.15807377100009, 26.53011301700009],
              [70.12960005700006, 26.56251414000009],
              [70.09368493700009, 26.58039418600005],
              [70.05606449400005, 26.589075826000013],
              [69.81556237800004, 26.580290833000035],
              [69.77225752700014, 26.595070292000045],
              [69.70022058100005, 26.652999573000088],
              [69.65939620000006, 26.67770090800009],
              [69.50416019700003, 26.735165101000106],
              [69.47284427900007, 26.766584371000036],
              [69.46509281400012, 26.807770487000127],
              [69.48597009300005, 26.926832988000072],
              [69.50757084200012, 27.050081279000082],
              [69.53444258600013, 27.125580546],
              [69.57557702600013, 27.18841908800006],
              [69.6661141350001, 27.270016174000133],
              [69.73060632300013, 27.31032379200009],
              [69.84801517700004, 27.41036936500005],
              [69.90806319200004, 27.49728912400009],
              [69.99353601100006, 27.57108306900004],
              [70.01689375800004, 27.60059031200005],
              [70.09068770400006, 27.793550110000083],
              [70.10195316600004, 27.81174021400001],
              [70.18902784200009, 27.891790496000098],
              [70.19900150500013, 27.900959575000073],
              [70.2677311600001, 27.945272116000083],
              [70.32385176600013, 28.000436707000077],
              [70.34193851700013, 28.01146962500009],
              [70.35950850500012, 28.01632721],
              [70.39826582900014, 28.021649882000062],
              [70.43691980000006, 28.03534413700008],
              [70.45624678600012, 28.039788310000077],
              [70.47722741700011, 28.0372561650001],
              [70.50678633700005, 28.028962097000132],
              [70.53489831600007, 28.015965474000026],
              [70.55980635600014, 27.99844716400004],
              [70.59287927300011, 27.964495748000033],
              [70.62119795800004, 27.944135234],
              [70.63318688900006, 27.93162953700009],
              [70.64161014800004, 27.91126902200007],
              [70.63763106300007, 27.874217021000092],
              [70.64073164900003, 27.85478668200001],
              [70.67173750800004, 27.791095480000095],
              [70.71039147900007, 27.741150207000132],
              [70.76175785300012, 27.709782613000115],
              [70.83157271300007, 27.70146270700006],
              [70.91378991700003, 27.717818299],
              [71.02758142100004, 27.76804779000004],
              [71.15067468300009, 27.82241139800003],
              [71.22632897900013, 27.84535573400005],
              [71.31144006300008, 27.861711324000098],
              [71.39779138200004, 27.8683775840001],
              [71.47711470600007, 27.862434794000094],
              [71.56072717300009, 27.868532614000046],
              [71.70139042200003, 27.906773173000133],
              [71.86086389200005, 27.95020721500005],
              [71.87440311700004, 27.959689840000024],
              [71.87998417200004, 27.974908550000052],
              [71.89155969300009, 28.09709747400005],
              [71.89693404100007, 28.115545959000073],
              [71.90830285600003, 28.13557057700011],
              [71.98819462100005, 28.228097230000046],
              [72.11097782400009, 28.317626648000058],
              [72.14994185400008, 28.353774313000102],
              [72.17764042200008, 28.397053325000044],
              [72.1977942310001, 28.444879863000054],
              [72.25649865700012, 28.64559112500008],
              [72.2802698160001, 28.687164816000077],
              [72.35458052600006, 28.767185771000115],
              [72.3821757400001, 28.784006450000092],
              [72.52562951600004, 28.8499197390001],
              [72.65854130100007, 28.9110012820001],
              [72.77253951000006, 28.963349507000103],
              [72.90152388500007, 29.02262237600003],
              [72.91816369600014, 29.032854310000104],
              [72.93035933400012, 29.047685445000027],
              [72.96291548700009, 29.116828512000026],
              [72.98865035000006, 29.154629822000075],
              [73.05086877500008, 29.22821706100008],
              [73.1289001880001, 29.360302023000074],
              [73.1779927980001, 29.44344940200007],
              [73.23287316900013, 29.536596171000085],
              [73.28475630700012, 29.683744813000047],
              [73.32744104000011, 29.80521026600006],
              [73.37033247900007, 29.927321676000034],
              [73.38521529100012, 29.942307841000016],
              [73.55781457500012, 30.01253611300008],
              [73.73971561700006, 30.04845123300005],
              [73.7782662350001, 30.067313131000063],
              [73.94435428900005, 30.18828765900004],
              [73.94683102300007, 30.204076838000034],
              [73.94890181500006, 30.217278138000026],
              [73.9346391200001, 30.261048076000108],
              [73.91190148900012, 30.303784485000037],
              [73.89164432800004, 30.329777731],
              [73.84234501100013, 30.352980448],
              [73.84523889200011, 30.35695953400007],
              [73.85175012200006, 30.372669169000048],
              [73.86766646300009, 30.387448629000048],
              [73.88761356600014, 30.396543681000125],
              [73.90611372900014, 30.394838359000076],
              [73.90425337800013, 30.401452942000063],
              [73.90208296700007, 30.41561228400009],
              [73.89991255700005, 30.42212351500008],
              [73.91665572100004, 30.41716257800003],
              [73.92926477000003, 30.419074606000052],
              [73.93908329300012, 30.42605092400005],
              [73.98982955000008, 30.487804261000022],
              [73.99603072100007, 30.500981751],
              [74.00440230300006, 30.508939922000067],
              [74.04408980400012, 30.5186550910001],
              [74.05752567600007, 30.531367493000047],
              [74.06145308400005, 30.555603740000052],
              [74.0582491450001, 30.574465637000074],
              [74.05711226400007, 30.59157053700001],
              [74.0674475510001, 30.610535787000074],
              [74.08222701000011, 30.62588368700004],
              [74.09586958900013, 30.6371491500001],
              [74.11147587100004, 30.646244202000062],
              [74.13266320800011, 30.655494283000095],
              [74.15571089700006, 30.65957672100008],
              [74.16366906800005, 30.664899394000045],
              [74.16676965300007, 30.679110413],
              [74.17007694500006, 30.687171936000098],
              [74.18464969900003, 30.69683543000012],
              [74.19116093000008, 30.717040914],
              [74.19880904200005, 30.72499908400006],
              [74.21513879500003, 30.737453105000057],
              [74.23570601500012, 30.764118144000108],
              [74.24407759700006, 30.771249491000034],
              [74.25916711400009, 30.781016337],
              [74.26671187300013, 30.788354391000084],
              [74.26578169800007, 30.795434062000098],
              [74.2566866460001, 30.815277812000105],
              [74.26020064300008, 30.81941192600003],
              [74.27994104000004, 30.824682923000054],
              [74.30019820200005, 30.838170471000026],
              [74.31136031100004, 30.855947164000057],
              [74.30402225700004, 30.874033915000055],
              [74.31074019400006, 30.8844725550001],
              [74.3192151290001, 30.893412578000024],
              [74.32975712100006, 30.899613750000114],
              [74.34246952300003, 30.90193918900006],
              [74.35363163200003, 30.90111236600002],
              [74.37967655500012, 30.89449778300012],
              [74.40127730300009, 30.89310251900004],
              [74.40913212100014, 30.901009013000092],
              [74.41336958800008, 30.915065003],
              [74.42432499200004, 30.932324931],
              [74.44158492000014, 30.946174215000056],
              [74.45853479000004, 30.953408916000043],
              [74.47724165900013, 30.95609609000006],
              [74.49946252400008, 30.95650950100007],
              [74.51930627500008, 30.962452291000076],
              [74.53480920500004, 30.976249899000052],
              [74.54876184100004, 30.99216624000006],
              [74.56405806500004, 31.00436187800007],
              [74.56426477100007, 31.025032450000097],
              [74.57945764200008, 31.042705791000103],
              [74.60095503700006, 31.056606751000075],
              [74.65883264100006, 31.083788554000066],
              [74.65025435400014, 31.093141989000102],
              [74.63196089700006, 31.107508037000102],
              [74.61697473200007, 31.115259501000097],
              [74.59692427600004, 31.115776266000054],
              [74.55310266100014, 31.108954977000096],
              [74.5367729080001, 31.11515614900007],
              [74.52354374200013, 31.129315491000042],
              [74.51486210100006, 31.14182118700002],
              [74.50959110600013, 31.156083883000107],
              [74.50638716600014, 31.17541086900006],
              [74.50907434100009, 31.19566803000005],
              [74.52509403500005, 31.235407206000062],
              [74.52530074100008, 31.28021067300004],
              [74.53222538200009, 31.303206685000063],
              [74.57160282400008, 31.389247945000065],
              [74.58369510900008, 31.40655955000007],
              [74.60002486200011, 31.42412953700004],
              [74.61191044200012, 31.44020090800008],
              [74.61718143700006, 31.45890777600009],
              [74.61459761600014, 31.47782135100003],
              [74.58452193200009, 31.517508851000102],
              [74.55558313000012, 31.61223175100004],
              [74.49946252400008, 31.699874980000047],
              [74.48943729700005, 31.711192118000028],
              [74.49264123600011, 31.714551087000032],
              [74.50328658000012, 31.730570781],
              [74.50545699000008, 31.732017721],
              [74.51331180900013, 31.735118307000036],
              [74.51620568800013, 31.73739207000004],
              [74.5182727460001, 31.741836243000066],
              [74.52116662600008, 31.753773499000104],
              [74.52302697800008, 31.75847605400007],
              [74.5307784420001, 31.767829488000118],
              [74.53511926300007, 31.77113678000002],
              [74.53697961400007, 31.775735982000057],
              [74.53739302600007, 31.78891347300005],
              [74.5408036710001, 31.810875956000118],
              [74.55041548700012, 31.826999004000086],
              [74.56560835800013, 31.840538229000074],
              [74.64105594900013, 31.890561015000074],
              [74.65717899600014, 31.89567698200004],
              [74.6699947510001, 31.90415191600006],
              [74.69841678900013, 31.950247295000068],
              [74.76301232900005, 31.938981832000124],
              [74.78368290200007, 31.942857565000068],
              [74.80249312400008, 31.968850810000035],
              [74.81127811700009, 32.00373240100002],
              [74.82864139800012, 32.02543650300002],
              [74.8731864830001, 32.01169057200006],
              [74.88910282400013, 32.02889882500004],
              [74.9088432210001, 32.031896057000054],
              [74.93137414600011, 32.02982900100001],
              [74.95566206900014, 32.03220611600004],
              [74.96785770700012, 32.037890523],
              [74.97405887900004, 32.04497019500012],
              [74.97850305200012, 32.05339345300011],
              [74.98615116400009, 32.06321197500007],
              [74.99555627500007, 32.06739776600001],
              [75.02015425600013, 32.06584747300009],
              [75.03017948400009, 32.066415914000046],
              [75.0226347250001, 32.094682923000036],
              [75.04082482900009, 32.097990215000024],
              [75.10211307800012, 32.07809478800003],
              [75.11027795400014, 32.07762970000009],
              [75.11895959500009, 32.08104034500012],
              [75.12981164600012, 32.09023874900002],
              [75.13838993300004, 32.093494364],
              [75.16133426900012, 32.0879649860001],
              [75.17415002500007, 32.086828105000095],
              [75.17311649600009, 32.10972076500009],
              [75.19575077300004, 32.128634339000044],
              [75.22644657400008, 32.1420702110001],
              [75.24990767500009, 32.14889150000006],
              [75.26334354700003, 32.1509068810001],
              [75.29465946500005, 32.14889150000006],
              [75.29807011000014, 32.15979522700012],
              [75.30840539500008, 32.19390167300007],
              [75.31657027200009, 32.21074818900006],
              [75.34860966000008, 32.24201243200007],
              [75.35904829900011, 32.2616753140001],
              [75.35295048000006, 32.28438710600007],
              [75.32690555900007, 32.312473246000096],
              [75.29840293600006, 32.332426605000094],
              [75.23016727700008, 32.3801952110001],
              [75.19616418500004, 32.397300110000046],
              [75.12598759000008, 32.41174367300006],
              [75.09219120300008, 32.42933949800006],
              [75.05488081900006, 32.455539450000074],
              [75.02366825400009, 32.46626230900007],
              [74.99069869000004, 32.463368429000084],
              [74.94842736900006, 32.44876983600004],
              [74.9069828690001, 32.445178324000054],
              [74.83814986200008, 32.47486643500012],
              [74.79939253800006, 32.47267018700002],
              [74.7635290930001, 32.462670797],
              [74.72497847500006, 32.460810445],
              [74.68932173700006, 32.47135243800007],
              [74.6625533450001, 32.4983792120001],
              [74.63258101400004, 32.568168233000065],
              [74.62958378100012, 32.58808949800009],
              [74.63692183400013, 32.6062537640001],
              [74.64798059100013, 32.623617046000035],
              [74.65604211400012, 32.64067026800008],
              [74.65728234900007, 32.66059153300007],
              [74.6501510010001, 32.701235047000026],
              [74.64973759000009, 32.723145854000066],
              [74.65697229000006, 32.745340882],
              [74.68229374200013, 32.787327983000026],
              [74.68911503100009, 32.808825378000066],
              [74.68529097500004, 32.831227112000036],
              [74.67175175000006, 32.84058054600008],
              [74.65356164600013, 32.83742828400004],
              [74.63588830500004, 32.822080384000074],
              [74.62627648900013, 32.80265004500008],
              [74.62203902200008, 32.7854159540001],
              [74.6140808510001, 32.770403951000034],
              [74.59341027800008, 32.75787241600001],
              [74.57377323400004, 32.75254974400006],
              [74.52095992000011, 32.745289205000105],
              [74.50090946500006, 32.7460126750001],
              [74.4844763590001, 32.75353159600003],
              [74.45533085200009, 32.778594666000046],
              [74.43869104000004, 32.78598439500006],
              [74.41895064300007, 32.78461497100007],
              [74.38639449100003, 32.76776845400009],
              [74.36768762200006, 32.76353098600005],
              [74.34619022600003, 32.766889954000064],
              [74.32934370900006, 32.776424256000055],
              [74.31632124800012, 32.79107452400005],
              [74.30650272600013, 32.809910584000065],
              [74.31593865300005, 32.82175000200009],
              [74.31698854100006, 32.823067314000085],
              [74.3229358320001, 32.83052948000007],
              [74.33378788300007, 32.849262187000036],
              [74.33668176300006, 32.870139466000026],
              [74.32448612500013, 32.92140248600005],
              [74.32200565600004, 32.972045390000105],
              [74.31125695800011, 32.99429209500006],
              [74.28397180200011, 33.008813171],
              [74.19085087100012, 33.022094015],
              [74.15385054600006, 33.040180766000034],
              [74.0984534100001, 33.10482798300008],
              [74.06579390500013, 33.132604065000024],
              [74.02941369700005, 33.154153137],
              [74.00233524600009, 33.17769175200009],
              [73.98848596200014, 33.20862009700009],
              [73.99179325300014, 33.252570903000034],
              [74.00171512900005, 33.270166728],
              [74.01783817600011, 33.279494324000055],
              [74.05535526500012, 33.29202585900005],
              [74.07199507700011, 33.30228363100004],
              [74.08512089100009, 33.31432424000009],
              [74.09597294100013, 33.32848358200006],
              [74.10548140500003, 33.345200907],
              [74.13628055800007, 33.418013],
              [74.15777795400004, 33.494235738],
              [74.14155155500004, 33.54937449100008],
              [74.08811812300007, 33.58528961300003],
              [74.02424605300007, 33.614254252000094],
              [73.97670373600005, 33.648386536000075],
              [73.96833215400005, 33.662080790000104],
              [73.96306115700014, 33.67675689700009],
              [73.96078739500012, 33.692285665],
              [73.96306115700014, 33.72156036400007],
              [73.96616174300004, 33.73453114800007],
              [73.9707092700001, 33.747062683000095],
              [73.97670373600005, 33.75892242500002],
              [74.01132694600005, 33.81046966600012],
              [74.03458134000005, 33.82860809300006],
              [74.14227502400013, 33.844240215000085],
              [74.17751835100012, 33.8575468960001],
              [74.21255497200013, 33.878424174000074],
              [74.23953007000006, 33.9010067760001],
              [74.26247440600008, 33.92994557800007],
              [74.27229292800013, 33.96213999500013],
              [74.25968387800003, 33.99438608900009],
              [74.22836796100012, 34.01288625100001],
              [74.19209110500003, 34.01185272200003],
              [74.15426395700007, 34.004101258000034],
              [74.11840051300004, 34.002525127000084],
              [74.06527714000009, 34.01833811500008],
              [74.04501997900007, 34.01942332000009],
              [73.97670373600005, 34.00459218300007],
              [73.94580122900004, 34.00978566500008],
              [73.91624231000003, 34.027949931000094],
              [73.89371138500007, 34.054304911000074],
              [73.88440962700014, 34.08419972800009],
              [73.89329797400006, 34.11474049900009],
              [73.91686242700007, 34.13525604200005],
              [73.97670373600005, 34.16155934700002],
              [73.99541060400009, 34.17644215900005],
              [73.99830448400007, 34.19680267400007],
              [73.99055301900012, 34.21850677500008],
              [73.97670373600005, 34.237549540000046],
              [73.95437951700006, 34.287184753000034],
              [73.93773970500013, 34.30421213800007],
              [73.90745731600003, 34.30679596000006],
              [73.8790352790001, 34.30428965300008],
              [73.85330041500009, 34.30741607700004],
              [73.82911584500005, 34.315348409000094],
              [73.80420780500009, 34.327492371000076],
              [73.78271040900012, 34.34681935700006],
              [73.77485559100006, 34.37095225000009],
              [73.77981652900013, 34.396066996000016],
              [73.7962496340001, 34.418546244000126],
              [73.80679162600006, 34.425160828000045],
              [73.83159631300009, 34.436400452000086],
              [73.84038130700009, 34.44441029900007],
              [73.84554895000008, 34.456476746000035],
              [73.84699589000007, 34.49417470300007],
              [73.84699589000007, 34.49432973300013],
              [73.86311893800007, 34.517067363000095],
              [73.91097131300006, 34.54497263600008],
              [73.92595747900003, 34.56497141500002],
              [73.9254407140001, 34.59339345400004],
              [73.91748254400005, 34.619283346000074],
              [73.91934289500006, 34.64253774100008],
              [73.9485917560001, 34.662743225000085],
              [73.96223433500012, 34.668169251000066],
              [74.12088098100008, 34.690855204000016],
              [74.14682255100007, 34.70186228500002],
              [74.22175337700008, 34.747750956000075],
              [74.28583215300011, 34.76888661700012],
              [74.34887740000005, 34.773434143000046],
              [74.41212935400006, 34.76449412100003],
              [74.66493046100004, 34.68832306000003],
              [75.01777714000008, 34.62972198500002],
              [75.11100142400005, 34.633649394000074],
              [75.1763204350001, 34.645379944000055],
              [75.21290734900003, 34.644966532000055],
              [75.22454384500014, 34.63862163200007],
              [75.23688521300005, 34.631892395000094],
              [75.25135461500008, 34.6130821740001],
              [75.26747766100004, 34.59830271400007],
              [75.30695845600007, 34.57401479100007],
              [75.34809289600013, 34.55721995100003],
              [75.61164270100005, 34.49836049400001],
              [75.65556766800006, 34.49696523100003],
              [75.7136519770001, 34.50851491300007],
              [75.73483931500004, 34.5086182670001],
              [75.77711063700013, 34.503812358000104],
              [75.79581750500012, 34.50792063500002],
              [75.81617801900012, 34.52166656500005],
              [75.87395227000013, 34.57137929300005],
              [75.93927128100006, 34.612048646000105],
              [75.9662463790001, 34.61907664000002],
              [75.97337772700013, 34.622332256],
              [75.98671024600009, 34.63602651000012],
              [76.00748417200003, 34.66512034100002],
              [76.02340051300013, 34.6771609500001],
              [76.05833378100004, 34.6834137980001],
              [76.12179244000009, 34.66088287400008],
              [76.15496870900006, 34.66165802100009],
              [76.26204227700009, 34.68465403200004],
              [76.39991499800004, 34.750748190000095],
              [76.43815555800012, 34.76289215100009],
              [76.47649947100012, 34.75777618400009],
              [76.51990767400014, 34.73111114500007],
              [76.53582401500006, 34.72620188500012],
              [76.55318729700008, 34.72584014900012],
              [76.63959029100005, 34.74113637400008],
              [76.6526127520001, 34.74697581000008],
              [76.74387333200008, 34.819271138000104],
              [76.75327844200007, 34.83833974300008],
              [76.74955773900012, 34.892083232000104],
              [76.75761926300004, 34.91513092000007],
              [76.78201053900005, 34.93089223300005],
              [76.81704716000007, 34.94076243100004],
              [76.85260054600013, 34.94334625300003],
              [76.87957564300007, 34.93709340400004],
              [76.90593062300013, 34.92314076800004],
              [76.92112349500013, 34.92071197500006],
              [76.93383589700011, 34.9288768520001],
              [76.95295617700009, 34.9465501910001],
              [77.01310754400004, 34.986392721000115],
              [77.02861047400006, 35.00339426700013],
              [77.03522505700005, 35.034503479000094],
              [77.02706018000003, 35.062098694],
              [77.02313277200005, 35.08633494100006],
              [77.04242614700007, 35.10701374400007],
              [77.04897098800006, 35.110441997000024],
              [77.42465865100007, 35.302923788000115],
              [77.80034631400014, 35.49540557900012],
            ],
          ],
          [
            [
              [80.96827233200008, 15.79523346600007],
              [80.98316491000008, 15.780747789000088],
              [80.98853600400008, 15.770738023000092],
              [80.98487389400003, 15.761786200000074],
              [80.97169030000003, 15.750474351000037],
              [80.94263756600003, 15.741034247000073],
              [80.94255618600005, 15.741074937000064],
              [80.91797936300003, 15.755113023000092],
              [80.86850019600007, 15.81195709800005],
              [80.87916100400008, 15.84007396000004],
              [80.88835696700005, 15.84674713700008],
              [80.93726647200003, 15.818915106000077],
              [80.96827233200008, 15.79523346600007],
            ],
          ],
          [
            [
              [73.64633222700007, 10.08470286700009],
              [73.64405358200008, 10.076971747000073],
              [73.64096113400007, 10.06932200700004],
              [73.63705488400007, 10.062567450000074],
              [73.63257897200003, 10.05727773600006],
              [73.63168379000007, 10.067775783000059],
              [73.63331139400003, 10.077866929000038],
              [73.63746178500008, 10.087062893000052],
              [73.64389082100007, 10.094549872000073],
              [73.64397220100005, 10.09446849200009],
              [73.64519290500004, 10.092189846000053],
              [73.64633222700007, 10.08470286700009],
            ],
          ],
          [
            [
              [73.66228274800005, 10.144598700000074],
              [73.66220136800007, 10.14451732000009],
              [73.66032962300005, 10.142523505000042],
              [73.65935306100005, 10.139960028000075],
              [73.65788821700005, 10.139064846000053],
              [73.65463300900007, 10.141506252000056],
              [73.65560957100007, 10.14476146000004],
              [73.65748131600003, 10.145086981000077],
              [73.65967858200008, 10.144354559000078],
              [73.66228274800005, 10.144598700000074],
            ],
          ],
          [
            [
              [72.64975019600007, 10.566839911000045],
              [72.63851972700007, 10.559393622000073],
              [72.63306725400008, 10.55654531500005],
              [72.62753339900007, 10.554795640000066],
              [72.62745201900003, 10.554754950000074],
              [72.63209069100003, 10.56000397300005],
              [72.64861087300005, 10.573960679000038],
              [72.64869225400008, 10.573919989000046],
              [72.65056399800005, 10.57257721600007],
              [72.65040123800003, 10.571193752000056],
              [72.64958743600005, 10.56932200700004],
              [72.64975019600007, 10.566839911000045],
            ],
          ],
          [
            [
              [72.54883873800003, 10.779445705000057],
              [72.54875735800005, 10.779323635000083],
              [72.54118899800005, 10.77289459800005],
              [72.54086347700007, 10.776516018000052],
              [72.54249108200008, 10.777899481000077],
              [72.54542076900003, 10.77830638200004],
              [72.54883873800003, 10.779445705000057],
            ],
          ],
          [
            [
              [73.67139733200008, 10.829738674000055],
              [73.68124433700007, 10.828070380000042],
              [73.68441816500007, 10.827541408000059],
              [73.67628014400003, 10.824367580000057],
              [73.67286217500003, 10.824693101000037],
              [73.67188561300003, 10.827093817000048],
              [73.67139733200008, 10.829657294000071],
              [73.67139733200008, 10.829738674000055],
            ],
          ],
          [
            [
              [72.75001061300003, 11.119086005000042],
              [72.74756920700008, 11.115423895000049],
              [72.74675540500004, 11.11196523600006],
              [72.74496504000007, 11.109523830000057],
              [72.73951256600003, 11.10883209800005],
              [72.73951256600003, 11.113959052000041],
              [72.74203535200007, 11.11595286700009],
              [72.74577884200005, 11.116888739000046],
              [72.75001061300003, 11.119086005000042],
            ],
          ],
          [
            [
              [73.01319420700008, 11.50218333500004],
              [73.01091556100005, 11.49013906500005],
              [73.00879967500003, 11.48468659100007],
              [73.00562584700003, 11.479641018000052],
              [73.00440514400003, 11.488836981000077],
              [73.00440514400003, 11.496486721000053],
              [73.00709069100003, 11.501288153000075],
              [73.01319420700008, 11.50218333500004],
            ],
          ],
          [
            [
              [72.71615644600007, 11.694159247000073],
              [72.71607506600003, 11.69407786700009],
              [72.70866946700005, 11.689154364000046],
              [72.70525149800005, 11.687323309000078],
              [72.70110110800005, 11.686428127000056],
              [72.70093834700003, 11.686428127000056],
              [72.70508873800003, 11.692328192000048],
              [72.70923912900008, 11.694159247000073],
              [72.71615644600007, 11.694159247000073],
            ],
          ],
          [
            [
              [93.87281334700003, 12.268866278000075],
              [93.85377037900008, 12.260565497000073],
              [93.85189863400007, 12.271551825000074],
              [93.86060631600003, 12.281195380000042],
              [93.87281334700003, 12.268866278000075],
            ],
          ],
          [
            [
              [94.28093509200005, 13.443548895000049],
              [94.29078209700003, 13.42291901200008],
              [94.27491295700003, 13.420314846000053],
              [94.26189212300005, 13.429266669000071],
              [94.28093509200005, 13.443548895000049],
            ],
          ],
          [
            [
              [93.92025800900007, 7.024318752000056],
              [93.92872155000003, 7.01235586100006],
              [93.92986087300005, 6.959051825000074],
              [93.92107181100005, 6.933823960000041],
              [93.89356530000003, 6.876776434000078],
              [93.88941491000003, 6.841782945000091],
              [93.89283287900008, 6.834051825000074],
              [93.89926191500007, 6.827134507000039],
              [93.90414472700007, 6.819240627000056],
              [93.90308678500003, 6.808294989000046],
              [93.89844811300003, 6.804185289000088],
              [93.88990319100003, 6.800970770000049],
              [93.88005618600005, 6.800441799000055],
              [93.87175540500004, 6.804510809000078],
              [93.85938561300003, 6.804266669000071],
              [93.84791100400008, 6.785305080000057],
              [93.83423912900008, 6.74555084800005],
              [93.81267337300005, 6.753973700000074],
              [93.80933678500003, 6.769029039000088],
              [93.81324303500003, 6.788031317000048],
              [93.81373131600003, 6.808294989000046],
              [93.80543053500003, 6.81671784100007],
              [93.79216556100005, 6.825873114000046],
              [93.78443444100003, 6.836411851000094],
              [93.79322350400008, 6.849188544000071],
              [93.78370201900003, 6.857977606000077],
              [93.77572675900007, 6.867377020000049],
              [93.77312259200005, 6.877997137000079],
              [93.77955162900008, 6.890204169000071],
              [93.77076256600003, 6.893866278000075],
              [93.76612389400003, 6.90110911700009],
              [93.76449629000007, 6.911525783000059],
              [93.76531009200005, 6.924302476000094],
              [93.74805748800003, 6.923570054000038],
              [93.73747806100005, 6.943264065000051],
              [93.72877037900008, 6.970526434000078],
              [93.71753991000003, 6.992621161000045],
              [93.70362389400003, 7.006293036000045],
              [93.68433678500003, 7.020900783000059],
              [93.66456139400003, 7.026516018000052],
              [93.64918053500003, 7.013088283000059],
              [93.64966881600003, 7.119614976000094],
              [93.65357506600003, 7.13149648600006],
              [93.67644290500004, 7.181870835000041],
              [93.68539472700007, 7.184515692000048],
              [93.70753014400003, 7.184393622000073],
              [93.71729576900003, 7.187689520000049],
              [93.72461998800003, 7.194973049000055],
              [93.73015384200005, 7.202215887000079],
              [93.73462975400008, 7.205511786000045],
              [93.73991946700005, 7.207098700000074],
              [93.76531009200005, 7.219142971000053],
              [93.77214603000004, 7.211737372000073],
              [93.79761803500003, 7.234605210000041],
              [93.81397545700008, 7.241848049000055],
              [93.83082116000003, 7.235907294000071],
              [93.85531660200007, 7.214178778000075],
              [93.86500084700003, 7.200669664000088],
              [93.87037194100003, 7.180568752000056],
              [93.87671959700003, 7.163560289000088],
              [93.88062584700003, 7.144273179000038],
              [93.88314863400007, 7.104722398000092],
              [93.88705488400007, 7.08930084800005],
              [93.90308678500003, 7.06085846600007],
              [93.91293379000007, 7.035101630000042],
              [93.92025800900007, 7.024318752000056],
            ],
          ],
          [
            [
              [93.73121178500003, 7.369370835000041],
              [93.73438561300003, 7.350816148000092],
              [93.72852623800003, 7.337103583000044],
              [93.71550540500004, 7.325832424000055],
              [93.69695071700005, 7.31476471600007],
              [93.67920983200008, 7.298325914000088],
              [93.64421634200005, 7.257513739000046],
              [93.62818444100003, 7.253322658000059],
              [93.61793053500003, 7.259955145000049],
              [93.61638431100005, 7.267279364000046],
              [93.61744225400008, 7.276068427000041],
              [93.61508222700007, 7.28742096600007],
              [93.61085045700008, 7.294501044000071],
              [93.59400475400008, 7.31476471600007],
              [93.60694420700008, 7.326402085000041],
              [93.61036217500003, 7.347316799000055],
              [93.61670983200008, 7.367254950000074],
              [93.63868248800003, 7.376166083000044],
              [93.66724694100003, 7.382757880000042],
              [93.67798912900008, 7.399400132000039],
              [93.68376712300005, 7.421698309000078],
              [93.69695071700005, 7.445054429000038],
              [93.69695071700005, 7.417792059000078],
              [93.69947350400008, 7.39874909100007],
              [93.70948326900003, 7.388739325000074],
              [93.72169030000003, 7.38117096600007],
              [93.73121178500003, 7.369370835000041],
            ],
          ],
          [
            [
              [93.42945397200003, 7.955267645000049],
              [93.43311608200008, 7.954291083000044],
              [93.45980879000007, 7.91079336100006],
              [93.46045983200008, 7.89984772300005],
              [93.45736738400007, 7.880194403000075],
              [93.45443769600007, 7.869289455000057],
              [93.44792728000004, 7.87140534100007],
              [93.43685957100007, 7.883286851000037],
              [93.42123457100007, 7.891791083000044],
              [93.41504967500003, 7.892238674000055],
              [93.40211022200003, 7.89008209800005],
              [93.38917076900003, 7.885809637000079],
              [93.37842858200008, 7.880764065000051],
              [93.36784915500004, 7.878607489000046],
              [93.35425866000003, 7.883286851000037],
              [93.34498131600003, 7.89134349200009],
              [93.34034264400003, 7.901271877000056],
              [93.34107506600003, 7.912583726000037],
              [93.34815514400003, 7.924872137000079],
              [93.34066816500007, 7.931708075000074],
              [93.33269290500004, 7.924953518000052],
              [93.32300866000003, 7.924383856000077],
              [93.31364993600005, 7.929185289000088],
              [93.30665123800003, 7.938544012000079],
              [93.30502363400007, 7.94993724200009],
              [93.31332441500007, 7.989732164000088],
              [93.32260175900007, 8.002101955000057],
              [93.34441165500004, 8.012111721000053],
              [93.37029056100005, 8.017320054000038],
              [93.39136803500003, 8.015570380000042],
              [93.39478600400008, 8.006740627000056],
              [93.39616946700005, 7.997219143000052],
              [93.39600670700008, 7.976385809000078],
              [93.40121504000007, 7.967962958000044],
              [93.42416425900007, 7.959865627000056],
              [93.42945397200003, 7.955267645000049],
            ],
          ],
          [
            [
              [93.56592858200008, 7.999335028000075],
              [93.57032311300003, 7.98899974200009],
              [93.57422936300003, 7.968817450000074],
              [93.57398522200003, 7.924872137000079],
              [93.51832116000003, 7.965806382000039],
              [93.51075280000003, 7.980169989000046],
              [93.51148522200003, 7.995510158000059],
              [93.52076256600003, 8.004380601000037],
              [93.53931725400008, 7.999335028000075],
              [93.54029381600003, 8.016180731000077],
              [93.54835045700008, 8.020086981000077],
              [93.55860436300003, 8.013617255000042],
              [93.56592858200008, 7.999335028000075],
            ],
          ],
          [
            [
              [93.53191165500004, 8.034735419000071],
              [93.52800540500004, 8.032416083000044],
              [93.51490319100003, 8.02765534100007],
              [93.51197350400008, 8.02415599200009],
              [93.50977623800003, 8.01854075700004],
              [93.49496504000007, 7.996283270000049],
              [93.48438561300003, 7.991888739000046],
              [93.47925866000003, 8.00291575700004],
              [93.47730553500003, 8.030991929000038],
              [93.48080488400007, 8.040513414000088],
              [93.48853600400008, 8.04437897300005],
              [93.49561608200008, 8.049383856000077],
              [93.49781334700003, 8.061997789000088],
              [93.50521894600007, 8.061997789000088],
              [93.51482181100005, 8.056219794000071],
              [93.51693769600007, 8.063299872000073],
              [93.51148522200003, 8.07485586100006],
              [93.49781334700003, 8.082505601000037],
              [93.49219811300003, 8.063625393000052],
              [93.47974694100003, 8.06321849200009],
              [93.46631920700008, 8.074408270000049],
              [93.45736738400007, 8.089992580000057],
              [93.44662519600007, 8.154364325000074],
              [93.44654381600003, 8.164496161000045],
              [93.45484459700003, 8.170111395000049],
              [93.46509850400008, 8.183294989000046],
              [93.47364342500003, 8.198187567000048],
              [93.47730553500003, 8.209133205000057],
              [93.48585045700008, 8.220119533000059],
              [93.50464928500003, 8.226996161000045],
              [93.52344811300003, 8.225816148000092],
              [93.53166751400005, 8.21320221600007],
              [93.53101647200003, 8.193752346000053],
              [93.52149498800003, 8.179103908000059],
              [93.51050866000003, 8.166571356000077],
              [93.50521894600007, 8.147040106000077],
              [93.50855553500003, 8.12881094000005],
              [93.52515709700003, 8.095038153000075],
              [93.53760826900003, 8.057318427000041],
              [93.53736412900008, 8.047796942000048],
              [93.53191165500004, 8.034735419000071],
            ],
          ],
          [
            [
              [73.07715905000003, 8.315252997000073],
              [73.08179772200003, 8.315822658000059],
              [73.08301842500003, 8.31435781500005],
              [73.08301842500003, 8.311672268000052],
              [73.08399498800003, 8.30849844000005],
              [73.06609134200005, 8.270453192000048],
              [73.05665123800003, 8.25999583500004],
              [73.04468834700003, 8.252427476000037],
              [73.03272545700008, 8.249497789000088],
              [73.02409915500004, 8.255438544000071],
              [73.02247155000003, 8.274359442000048],
              [73.02930748800003, 8.274318752000056],
              [73.02930748800003, 8.274115302000041],
              [73.02898196700005, 8.263413804000038],
              [73.02930748800003, 8.25999583500004],
              [73.04835045700008, 8.26756419500009],
              [73.06316165500004, 8.279486395000049],
              [73.07300866000008, 8.295396226000037],
              [73.07715905000003, 8.315252997000073],
            ],
          ],
          [
            [
              [93.13453209700003, 8.240179755000042],
              [93.16081790500004, 8.22874583500004],
              [93.17302493600005, 8.221258856000077],
              [93.17628014400003, 8.21287669500009],
              [93.16732832100007, 8.20453522300005],
              [93.15349368600005, 8.205511786000045],
              [93.12468509200005, 8.21287669500009],
              [93.10254967500003, 8.221502997000073],
              [93.08155358200008, 8.242377020000049],
              [93.06576582100007, 8.268133856000077],
              [93.05958092500003, 8.291408596000053],
              [93.06128991000003, 8.320746161000045],
              [93.06430097700007, 8.336127020000049],
              [93.06983483200008, 8.346625067000048],
              [93.08375084700003, 8.355902411000045],
              [93.09506269600007, 8.355169989000046],
              [93.10141035200007, 8.345770575000074],
              [93.10075931100005, 8.299261786000045],
              [93.10401451900003, 8.275580145000049],
              [93.11410566500007, 8.256415106000077],
              [93.13453209700003, 8.240179755000042],
            ],
          ],
          [
            [
              [93.60767662900008, 8.548041083000044],
              [93.62175540500004, 8.520086981000077],
              [93.62680097700007, 8.50584544500009],
              [93.62818444100003, 8.48655833500004],
              [93.62517337300005, 8.47361888200004],
              [93.61833743600005, 8.453924872000073],
              [93.60971113400007, 8.438421942000048],
              [93.60141035200007, 8.438177802000041],
              [93.60035241000003, 8.450344143000052],
              [93.60710696700005, 8.490790106000077],
              [93.60767662900008, 8.507066148000092],
              [93.59555097700007, 8.54173411700009],
              [93.59498131600003, 8.558010158000059],
              [93.60767662900008, 8.569159247000073],
              [93.60767662900008, 8.548041083000044],
            ],
          ],
          [
            [
              [92.81137327200008, 9.23116996200008],
              [92.83384929400006, 9.202359329000046],
              [92.83198132300004, 9.145025417000056],
              [92.79956466200008, 9.110154001000069],
              [92.73121178500003, 9.13084544500009],
              [92.72022545700008, 9.14712148600006],
              [92.71168053500003, 9.175116278000075],
              [92.70850670700008, 9.201605536000045],
              [92.71387780000003, 9.213446356000077],
              [92.72925866000003, 9.21784088700008],
              [92.74512780000003, 9.229071356000077],
              [92.75440514400003, 9.24445221600007],
              [92.75098717500003, 9.261216539000088],
              [92.76303144600007, 9.264146226000037],
              [92.77271569100003, 9.25922272300005],
              [92.79527168600004, 9.24081809200004],
              [92.81137327200008, 9.23116996200008],
            ],
          ],
          [
            [
              [92.58509171100008, 10.771268527000075],
              [92.58698631700008, 10.736294028000088],
              [92.59805874400007, 10.709302238000078],
              [92.59590764100005, 10.678363602000047],
              [92.57449158100007, 10.655484179000041],
              [92.56124016500007, 10.642554828000073],
              [92.55105552400005, 10.634602821000044],
              [92.53983511800004, 10.620669338000084],
              [92.54175975000004, 10.591720078000037],
              [92.55596403200008, 10.588675204000083],
              [92.57421307300007, 10.580623724000077],
              [92.54667534900005, 10.547781204000046],
              [92.53542331400007, 10.52486095100005],
              [92.51302707600007, 10.507968928000082],
              [92.47955770100003, 10.516073275000053],
              [92.46337193000005, 10.531103139000038],
              [92.44413915300004, 10.545142522000049],
              [92.42178793400006, 10.546203260000084],
              [92.40646613500007, 10.529265955000085],
              [92.38411072300005, 10.529328010000086],
              [92.37805710600003, 10.541328843000088],
              [92.40255653800006, 10.575206237000089],
              [92.41385518600003, 10.606117140000038],
              [92.41700341400008, 10.629058572000076],
              [92.40891697100005, 10.647054595000043],
              [92.39067425200005, 10.663085336000051],
              [92.37948613800006, 10.672121597000057],
              [92.37858586200008, 10.718070586000067],
              [92.37867064300008, 10.750037311000085],
              [92.37568046700005, 10.775030574000084],
              [92.37672144300006, 10.784019970000088],
              [92.38587826200006, 10.781981174000066],
              [92.40726464100004, 10.789890639000077],
              [92.41541966300008, 10.79886279100009],
              [92.42259792800007, 10.82283624200005],
              [92.42896569100003, 10.850816148000092],
              [92.48279630600007, 10.885621584000091],
              [92.52759174000005, 10.89546557400007],
              [92.54887977100003, 10.874373390000073],
              [92.56505953100003, 10.849308437000047],
              [92.56798145700003, 10.815300556000068],
              [92.58211625500007, 10.790261387000044],
              [92.58509171100008, 10.771268527000075],
            ],
          ],
          [
            [
              [92.67652428500003, 11.412543036000045],
              [92.68506920700008, 11.399359442000048],
              [92.69678795700008, 11.391791083000044],
              [92.69988040500004, 11.384426174000055],
              [92.68279056100005, 11.371527411000045],
              [92.67318769600007, 11.367336330000057],
              [92.64600670700008, 11.359076239000046],
              [92.63502037900008, 11.357896226000037],
              [92.61963951900003, 11.360744533000059],
              [92.61085045700008, 11.366156317000048],
              [92.60377037900008, 11.37250397300005],
              [92.59351647200003, 11.37836334800005],
              [92.59896894600007, 11.401312567000048],
              [92.60084069100003, 11.406317450000074],
              [92.60816491000003, 11.411322333000044],
              [92.62387129000007, 11.412502346000053],
              [92.63119550900007, 11.41624583500004],
              [92.63721764400003, 11.430161851000037],
              [92.63526451900003, 11.447007554000038],
              [92.62761478000004, 11.477362372000073],
              [92.63559004000007, 11.50804271000004],
              [92.65414472700007, 11.50812409100007],
              [92.67505944100003, 11.490423895000049],
              [92.68970787900008, 11.46775950700004],
              [92.69629967500003, 11.454413153000075],
              [92.68970787900008, 11.442531643000052],
              [92.67969811300003, 11.429388739000046],
              [92.67652428500003, 11.412543036000045],
            ],
          ],
          [
            [
              [92.26677493600005, 11.589544989000046],
              [92.27808678500003, 11.583807684000078],
              [92.28687584700003, 11.563177802000041],
              [92.28500410200007, 11.54401276200008],
              [92.27320397200003, 11.531073309000078],
              [92.25212649800005, 11.529242255000042],
              [92.23454837300005, 11.540350653000075],
              [92.23023522200003, 11.577337958000044],
              [92.21729576900003, 11.59125397300005],
              [92.21729576900003, 11.598089911000045],
              [92.22868899800005, 11.597723700000074],
              [92.25489342500003, 11.593817450000074],
              [92.26677493600005, 11.589544989000046],
            ],
          ],
          [
            [
              [93.04249108200008, 11.96116771000004],
              [93.04867597700007, 11.952785549000055],
              [93.06641686300003, 11.899115302000041],
              [93.04932701900003, 11.896144924000055],
              [93.03541100400008, 11.911932684000078],
              [93.02654056100005, 11.93162669500009],
              [93.02491295700008, 11.940130927000041],
              [93.01539147200003, 11.945990302000041],
              [93.00131269600007, 11.94920482000009],
              [92.99057050900007, 11.954413153000075],
              [92.98023522200003, 11.963690497000073],
              [92.97445722700007, 11.972235419000071],
              [92.96753991000003, 11.978583075000074],
              [92.95313561300003, 11.98110586100006],
              [92.94703209700003, 11.98969147300005],
              [92.95720462300005, 12.008693752000056],
              [92.97217858200008, 12.027736721000053],
              [92.98072350400008, 12.036322333000044],
              [93.01465905000003, 12.037176825000074],
              [93.02540123800003, 12.03156159100007],
              [93.01856530000003, 12.015814520000049],
              [93.04037519600007, 11.96906159100007],
              [93.04249108200008, 11.96116771000004],
            ],
          ],
          [
            [
              [93.10328209700003, 12.19049713700008],
              [93.10377037900008, 12.187933661000045],
              [93.10385175900007, 12.185288804000038],
              [93.10328209700003, 12.180080471000053],
              [93.09620201900003, 12.158758856000077],
              [93.09498131600003, 12.151760158000059],
              [93.10230553500003, 12.119533596000053],
              [93.10328209700003, 12.102036851000037],
              [93.09424889400003, 12.090969143000052],
              [93.08545983200008, 12.095851955000057],
              [93.07422936300003, 12.11033763200004],
              [93.06430097700007, 12.127142645000049],
              [93.05958092500003, 12.138739325000074],
              [93.05933678500003, 12.153550523000092],
              [93.06153405000003, 12.172308661000045],
              [93.06625410200007, 12.189846096000053],
              [93.07325280000003, 12.200832424000055],
              [93.08204186300003, 12.204779364000046],
              [93.09107506600003, 12.204250393000052],
              [93.09848066500007, 12.199408270000049],
              [93.10328209700003, 12.19049713700008],
            ],
          ],
          [
            [
              [92.73308353000004, 12.972479559000078],
              [92.73747806100005, 12.961737372000073],
              [92.73218834700003, 12.945705471000053],
              [92.72999108200008, 12.895209052000041],
              [92.72437584700003, 12.872381903000075],
              [92.71762129000007, 12.862209377000056],
              [92.70150800900007, 12.844427802000041],
              [92.69711347700007, 12.83820221600007],
              [92.69507897200003, 12.825100002000056],
              [92.69654381600003, 12.813299872000073],
              [92.69467207100007, 12.80377838700008],
              [92.68279056100005, 12.797308661000045],
              [92.67025800900007, 12.867661851000037],
              [92.67286217500003, 12.878607489000046],
              [92.67774498800003, 12.890366929000038],
              [92.68490644600007, 12.945054429000038],
              [92.68279056100005, 12.961737372000073],
              [92.69507897200003, 12.973456122000073],
              [92.70240319100003, 12.98305898600006],
              [92.70834394600007, 12.988674221000053],
              [92.71697024800005, 12.988470770000049],
              [92.72250410200007, 12.98578522300005],
              [92.72706139400003, 12.982001044000071],
              [92.73072350400008, 12.977484442000048],
              [92.73308353000004, 12.972479559000078],
            ],
          ],
          [
            [
              [93.05274498800003, 13.283880927000041],
              [93.07569420700008, 13.269110419000071],
              [93.07943769600007, 13.259833075000074],
              [93.05689537900008, 13.224798895000049],
              [93.05258222700007, 13.196966864000046],
              [93.05274498800003, 13.13304271000004],
              [93.04810631600003, 13.103705145000049],
              [93.03679446700005, 13.062160549000055],
              [93.01954186300003, 13.033636786000045],
              [92.99805748800003, 13.04368724200009],
              [92.99057050900007, 13.04368724200009],
              [92.98682701900003, 13.033677476000037],
              [92.97934004000007, 13.02952708500004],
              [92.97087649800005, 13.030747789000088],
              [92.96404056100005, 13.036851304000038],
              [92.96143639400003, 13.048163153000075],
              [92.96656334700003, 13.07217031500005],
              [92.96404056100005, 13.084662177000041],
              [92.95655358200008, 13.084662177000041],
              [92.95655358200008, 13.064154364000046],
              [92.93702233200008, 13.067084052000041],
              [92.92888431100005, 13.050197658000059],
              [92.92839603000004, 13.027492580000057],
              [92.93262780000003, 13.013006903000075],
              [92.95069420700008, 12.993638414000088],
              [92.95622806100005, 12.981675523000092],
              [92.95264733200008, 12.970770575000074],
              [92.94288170700008, 12.954291083000044],
              [92.93604576900003, 12.954291083000044],
              [92.93474368600005, 12.973049221000053],
              [92.92741946700005, 12.981024481000077],
              [92.91651451900003, 12.98265208500004],
              [92.90528405000003, 12.982245184000078],
              [92.90259850400008, 12.974025783000059],
              [92.88070722700007, 12.93040599200009],
              [92.87907962300005, 12.921942450000074],
              [92.87631269600007, 12.91665273600006],
              [92.87680097700007, 12.911525783000059],
              [92.88453209700003, 12.903469143000052],
              [92.89633222700007, 12.899725653000075],
              [92.90552819100003, 12.906073309000078],
              [92.91553795700008, 12.919582424000055],
              [92.92448978000004, 12.91437409100007],
              [92.92823326900003, 12.90534088700008],
              [92.92986087300005, 12.896673895000049],
              [92.93262780000003, 12.89288971600007],
              [92.94068444100003, 12.88930898600006],
              [92.96404056100005, 12.864935614000046],
              [92.96070397200003, 12.847154039000088],
              [92.96583092500003, 12.82562897300005],
              [92.96802819100003, 12.803168036000045],
              [92.95655358200008, 12.783026434000078],
              [92.97315514400003, 12.764349677000041],
              [92.98438561300003, 12.74510325700004],
              [92.99048912900008, 12.724310614000046],
              [92.99057050900007, 12.701117255000042],
              [92.97681725400008, 12.65493398600006],
              [92.97291100400008, 12.628119208000044],
              [92.98902428500003, 12.59210846600007],
              [92.99154707100007, 12.567084052000041],
              [92.99057050900007, 12.519232489000046],
              [92.98170006600003, 12.506048895000049],
              [92.96485436300003, 12.491034247000073],
              [92.95590254000007, 12.477443752000056],
              [92.97022545700008, 12.468329169000071],
              [92.96241295700008, 12.454413153000075],
              [92.94971764400003, 12.446966864000046],
              [92.93864993600005, 12.43813711100006],
              [92.93604576900003, 12.41990794500009],
              [92.92920983200008, 12.41990794500009],
              [92.92383873800003, 12.430975653000075],
              [92.91586347700007, 12.44086334800005],
              [92.90601647200003, 12.448960679000038],
              [92.89503014400003, 12.454657294000071],
              [92.89714603000004, 12.44993724200009],
              [92.90186608200008, 12.433539130000042],
              [92.87330162900008, 12.431382554000038],
              [92.84669030000003, 12.433539130000042],
              [92.84669030000003, 12.427394924000055],
              [92.85352623800003, 12.416815497000073],
              [92.86361738400007, 12.38548411700009],
              [92.87110436300003, 12.37889232000009],
              [92.88184655000003, 12.375921942000048],
              [92.89405358200008, 12.368109442000048],
              [92.90251712300005, 12.357123114000046],
              [92.90186608200008, 12.34479401200008],
              [92.91504967500003, 12.338364976000037],
              [92.91277103000004, 12.333644924000055],
              [92.90316816500007, 12.32908763200004],
              [92.89503014400003, 12.32367584800005],
              [92.88640384200005, 12.315741278000075],
              [92.88111412900008, 12.314601955000057],
              [92.87924238400007, 12.312974351000037],
              [92.88070722700007, 12.303859768000052],
              [92.88575280000003, 12.29555898600006],
              [92.89340254000007, 12.290350653000075],
              [92.90015709700003, 12.28318919500009],
              [92.90186608200008, 12.269029039000088],
              [92.89625084700003, 12.26170482000009],
              [92.88640384200005, 12.25336334800005],
              [92.87989342500003, 12.24359772300005],
              [92.88453209700003, 12.231838283000059],
              [92.88868248800003, 12.225002346000053],
              [92.89258873800003, 12.214544989000046],
              [92.89421634200005, 12.205023505000042],
              [92.89161217500003, 12.200832424000055],
              [92.87256920700008, 12.20148346600007],
              [92.87452233200008, 12.183742580000057],
              [92.86402428500003, 12.171535549000055],
              [92.84294681100005, 12.156195380000042],
              [92.82740319100003, 12.140122789000088],
              [92.83366946700005, 12.125677802000041],
              [92.83366946700005, 12.11823151200008],
              [92.82593834700003, 12.115668036000045],
              [92.80640709700003, 12.10455963700008],
              [92.80892988400007, 12.095770575000074],
              [92.79932701900003, 12.089544989000046],
              [92.78394616000003, 12.085882880000042],
              [92.76880944100003, 12.08470286700009],
              [92.75749759200005, 12.077460028000075],
              [92.76726321700005, 12.061224677000041],
              [92.79265384200005, 12.036322333000044],
              [92.78101647200003, 12.037787177000041],
              [92.77125084700003, 12.036078192000048],
              [92.76368248800003, 12.030951239000046],
              [92.75855553500003, 12.022040106000077],
              [92.76539147200003, 12.022040106000077],
              [92.74561608200008, 11.996649481000077],
              [92.74057050900007, 11.983628648000092],
              [92.73747806100005, 11.96116771000004],
              [92.73747806100005, 11.878648179000038],
              [92.74488366000003, 11.878648179000038],
              [92.74903405000003, 11.912258205000057],
              [92.75375410200007, 11.931586005000042],
              [92.76197350400008, 11.940130927000041],
              [92.77637780000003, 11.939276434000078],
              [92.78793379000007, 11.934515692000048],
              [92.79590905000003, 11.92218659100007],
              [92.79948978000004, 11.899115302000041],
              [92.79688561300003, 11.86513906500005],
              [92.76002037900008, 11.708685614000046],
              [92.75473066500007, 11.701117255000042],
              [92.73454837300005, 11.699286200000074],
              [92.72291100400008, 11.693793036000045],
              [92.68995201900003, 11.66006094000005],
              [92.68392988400007, 11.649888414000088],
              [92.68262780000003, 11.63694896000004],
              [92.68279056100005, 11.615179755000042],
              [92.68702233200008, 11.61155833500004],
              [92.69678795700008, 11.61123281500005],
              [92.70639082100007, 11.614488023000092],
              [92.71070397200003, 11.62173086100006],
              [92.71070397200003, 11.659572658000059],
              [92.71534264400003, 11.657619533000059],
              [92.72673587300005, 11.654689846000053],
              [92.73121178500003, 11.652736721000053],
              [92.73023522200003, 11.671454169000071],
              [92.73601321700005, 11.682440497000073],
              [92.74610436300003, 11.683742580000057],
              [92.75855553500003, 11.673244533000059],
              [92.76148522200003, 11.663641669000071],
              [92.76563561300003, 11.629584052000041],
              [92.76539147200003, 11.61859772300005],
              [92.76050866000003, 11.61033763200004],
              [92.74756920700008, 11.597845770000049],
              [92.74488366000003, 11.587591864000046],
              [92.74488366000003, 11.557114976000037],
              [92.73511803500003, 11.523871161000045],
              [92.72673587300005, 11.50617096600007],
              [92.71697024800005, 11.49445221600007],
              [92.71314537900008, 11.507310289000088],
              [92.70704186300003, 11.511053778000075],
              [92.69898522200003, 11.511786200000074],
              [92.68970787900008, 11.515570380000042],
              [92.65894616000003, 11.546291408000059],
              [92.65479576900003, 11.555894273000092],
              [92.65560957100007, 11.565985419000071],
              [92.65463300900007, 11.573797919000071],
              [92.64527428500003, 11.576971747000073],
              [92.63355553500003, 11.582586981000077],
              [92.62566165500004, 11.595404364000046],
              [92.62159264400003, 11.60936107000009],
              [92.62134850400008, 11.61859772300005],
              [92.62794030000003, 11.625148830000057],
              [92.63738040500004, 11.627142645000049],
              [92.64568118600005, 11.629828192000048],
              [92.64869225400008, 11.638495184000078],
              [92.64283287900008, 11.64524974200009],
              [92.63111412900008, 11.64744700700004],
              [92.61963951900003, 11.651312567000048],
              [92.61451256600003, 11.662990627000056],
              [92.61345462300005, 11.674221096000053],
              [92.60816491000003, 11.69326406500005],
              [92.60710696700005, 11.70453522300005],
              [92.60377037900008, 11.718898830000057],
              [92.59595787900008, 11.72016022300005],
              [92.58676191500007, 11.716009833000044],
              [92.57984459700003, 11.714178778000075],
              [92.56324303500003, 11.72557200700004],
              [92.56031334700003, 11.741359768000052],
              [92.56666100400008, 11.78620026200008],
              [92.56666100400008, 11.82713450700004],
              [92.56324303500003, 11.833929755000042],
              [92.55494225400008, 11.837836005000042],
              [92.54566491000003, 11.84080638200004],
              [92.53435306100005, 11.846869208000044],
              [92.53093509200005, 11.845892645000049],
              [92.52808678500003, 11.845892645000049],
              [92.52515709700003, 11.851304429000038],
              [92.52491295700008, 11.857489325000074],
              [92.52735436300003, 11.862005927000041],
              [92.53052819100003, 11.864650783000059],
              [92.53199303500003, 11.864976304000038],
              [92.53972415500004, 11.89443594000005],
              [92.56299889400003, 11.930161851000037],
              [92.57056725400008, 11.93260325700004],
              [92.57715905000003, 11.927394924000055],
              [92.59213300900007, 11.905747789000088],
              [92.59473717500003, 11.89874909100007],
              [92.60027103000004, 11.89549388200004],
              [92.61451256600003, 11.899115302000041],
              [92.60767662900008, 11.88279857000009],
              [92.61085045700008, 11.870510158000059],
              [92.61768639400003, 11.866400458000044],
              [92.62134850400008, 11.874945380000042],
              [92.62452233200008, 11.930161851000037],
              [92.62940514400003, 11.943752346000053],
              [92.62728925900007, 11.958929755000042],
              [92.62305748800003, 11.974269924000055],
              [92.62134850400008, 11.987941799000055],
              [92.62501061300003, 12.003119208000044],
              [92.63738040500004, 12.02529531500005],
              [92.64185631600003, 12.036322333000044],
              [92.64014733200008, 12.136135158000059],
              [92.64527428500003, 12.156073309000078],
              [92.66822350400008, 12.200995184000078],
              [92.68181399800005, 12.219631252000056],
              [92.68970787900008, 12.20766836100006],
              [92.69711347700007, 12.20766836100006],
              [92.70386803500003, 12.225165106000077],
              [92.71306399800005, 12.232570705000057],
              [92.72095787900008, 12.22654857000009],
              [92.72437584700003, 12.204250393000052],
              [92.71908613400007, 12.184515692000048],
              [92.71949303500003, 12.176255601000037],
              [92.72779381600003, 12.17283763200004],
              [92.73373457100007, 12.174017645000049],
              [92.73633873800003, 12.176581122000073],
              [92.73780358200008, 12.17914459800005],
              [92.74105879000007, 12.18032461100006],
              [92.76099694100003, 12.179877020000049],
              [92.76539147200003, 12.18032461100006],
              [92.78402754000007, 12.18935781500005],
              [92.78882897200003, 12.19554271000004],
              [92.79265384200005, 12.20766836100006],
              [92.78239993600005, 12.248602606000077],
              [92.77556399800005, 12.25063711100006],
              [92.76775149800005, 12.255438544000071],
              [92.76124108200008, 12.26117584800005],
              [92.75855553500003, 12.26593659100007],
              [92.75879967500003, 12.276556708000044],
              [92.76042728000004, 12.276841539000088],
              [92.76449629000007, 12.274318752000056],
              [92.78101647200003, 12.279242255000042],
              [92.78939863400007, 12.279486395000049],
              [92.79420006600003, 12.28318919500009],
              [92.79265384200005, 12.296372789000088],
              [92.78695722700007, 12.306301174000055],
              [92.77849368600005, 12.310126044000071],
              [92.75473066500007, 12.310044664000088],
              [92.73365319100003, 12.318060614000046],
              [92.72234134200005, 12.33779531500005],
              [92.71778405000003, 12.362494208000044],
              [92.72169030000003, 12.599432684000078],
              [92.72681725400008, 12.612982489000046],
              [92.74480228000004, 12.633490302000041],
              [92.75017337300005, 12.644273179000038],
              [92.75473066500007, 12.649562893000052],
              [92.76002037900008, 12.65110911700009],
              [92.77523847700007, 12.651760158000059],
              [92.77898196700005, 12.65265534100007],
              [92.78321373800003, 12.664984442000048],
              [92.77735436300003, 12.669338283000059],
              [92.76628665500004, 12.671535549000055],
              [92.75473066500007, 12.67719147300005],
              [92.74773196700005, 12.692694403000075],
              [92.74488366000003, 12.762518622000073],
              [92.73747806100005, 12.807196356000077],
              [92.74089603000004, 12.819647528000075],
              [92.74887129000007, 12.82811107000009],
              [92.75814863400007, 12.835679429000038],
              [92.76539147200003, 12.845119533000059],
              [92.78565514400003, 12.840033270000049],
              [92.80030358200008, 12.857814846000053],
              [92.80933678500003, 12.884507554000038],
              [92.81324303500003, 12.90648021000004],
              [92.81324303500003, 12.95807526200008],
              [92.82813561300003, 12.985174872000073],
              [92.83472741000003, 13.002020575000074],
              [92.83025149800005, 13.009507554000038],
              [92.80795332100007, 13.020086981000077],
              [92.80925540500004, 13.044745184000078],
              [92.82960045700008, 13.103461005000042],
              [92.84839928500003, 13.13670482000009],
              [92.85303795700008, 13.142726955000057],
              [92.85417728000004, 13.146063544000071],
              [92.85108483200008, 13.152044989000046],
              [92.83765709700003, 13.16705963700008],
              [92.83366946700005, 13.174017645000049],
              [92.84473717500003, 13.186997789000088],
              [92.84205162900008, 13.20774974200009],
              [92.84278405000003, 13.226996161000045],
              [92.86402428500003, 13.235500393000052],
              [92.86394290500004, 13.244696356000077],
              [92.84986412900008, 13.289007880000042],
              [92.85417728000004, 13.304388739000046],
              [92.85417728000004, 13.310614325000074],
              [92.84115644600007, 13.324896552000041],
              [92.84742272200003, 13.344916083000044],
              [92.88689212300005, 13.393459377000056],
              [92.89136803500003, 13.400946356000077],
              [92.89503014400003, 13.413031317000048],
              [92.89568118600005, 13.42283763200004],
              [92.89454186300003, 13.44725169500009],
              [92.89503014400003, 13.454575914000088],
              [92.90186608200008, 13.468247789000088],
              [92.90333092500003, 13.46775950700004],
              [92.91553795700008, 13.475734768000052],
              [92.93799889400003, 13.501369533000059],
              [92.94288170700008, 13.50922272300005],
              [92.94548587300005, 13.519720770000049],
              [92.94548587300005, 13.536932684000078],
              [92.94971764400003, 13.544623114000046],
              [92.95850670700008, 13.55023834800005],
              [92.97722415500004, 13.55377838700008],
              [92.98438561300003, 13.55760325700004],
              [92.99170983200008, 13.550034898000092],
              [92.99732506600003, 13.546698309000078],
              [93.00318444100003, 13.547064520000049],
              [93.01172936300003, 13.55076732000009],
              [93.00611412900008, 13.55662669500009],
              [93.00456790500004, 13.562201239000046],
              [93.00652103000004, 13.568793036000045],
              [93.01172936300003, 13.57811107000009],
              [93.01628665500004, 13.56736888200004],
              [93.02279707100007, 13.566107489000046],
              [93.03158613400007, 13.56907786700009],
              [93.04249108200008, 13.571234442000048],
              [93.04997806100005, 13.56639232000009],
              [93.06641686300003, 13.53709544500009],
              [93.05502363400007, 13.503078518000052],
              [93.05372155000003, 13.47142161700009],
              [93.05958092500003, 13.406805731000077],
              [93.06413821700005, 13.408636786000045],
              [93.07545006600003, 13.41111888200004],
              [93.08008873800003, 13.413031317000048],
              [93.07837975400008, 13.39712148600006],
              [93.05787194100003, 13.382879950000074],
              [93.05274498800003, 13.368882554000038],
              [93.04688561300003, 13.35740794500009],
              [93.03345787900008, 13.348578192000048],
              [93.01734459700003, 13.34048086100006],
              [93.00424238400007, 13.33104075700004],
              [93.00367272200003, 13.34861888200004],
              [92.99512780000003, 13.357367255000042],
              [92.98438561300003, 13.35643138200004],
              [92.97706139400003, 13.345363674000055],
              [92.97934004000007, 13.329779364000046],
              [92.99048912900008, 13.31781647300005],
              [93.00456790500004, 13.311835028000075],
              [93.02556399800005, 13.316148179000038],
              [93.03565514400003, 13.30695221600007],
              [93.05274498800003, 13.283880927000041],
            ],
          ],
          [
            [
              [93.03907311300003, 13.667466539000088],
              [93.04281660200007, 13.662054755000042],
              [93.05274498800003, 13.640204169000071],
              [93.01954186300003, 13.64940013200004],
              [93.00049889400003, 13.657700914000088],
              [92.99057050900007, 13.667466539000088],
              [93.01954186300003, 13.680121161000045],
              [93.03321373800003, 13.680243231000077],
              [93.03907311300003, 13.667466539000088],
            ],
          ],
          [
            [
              [88.87289472700007, 21.595526434000078],
              [88.88851972700007, 21.589544989000046],
              [88.90202884200005, 21.58026764500005],
              [88.91130618600005, 21.566880601000037],
              [88.91391035200007, 21.54840729400007],
              [88.90796959700003, 21.53070709800005],
              [88.89576256600003, 21.528469143000052],
              [88.87973066500007, 21.52997467700004],
              [88.86247806100005, 21.523586330000057],
              [88.83871504000007, 21.53192780200004],
              [88.83082116000003, 21.577378648000035],
              [88.84131920700008, 21.61399974200009],
              [88.87289472700007, 21.595526434000078],
            ],
          ],
          [
            [
              [88.05054772200003, 21.70538971600007],
              [88.09001712300005, 21.808661200000074],
              [88.11931399800005, 21.859523830000057],
              [88.14673912900008, 21.86985911700009],
              [88.16700280000003, 21.765448309000078],
              [88.16342207100007, 21.705471096000053],
              [88.13257897200003, 21.68496328300006],
              [88.14437910200007, 21.65778229400007],
              [88.14600670700008, 21.643744208000044],
              [88.13941491000003, 21.63031647300005],
              [88.13005618600005, 21.625921942000048],
              [88.11850019600007, 21.62767161700009],
              [88.09156334700003, 21.636542059000078],
              [88.06348717500003, 21.636664130000042],
              [88.05176842500003, 21.64158763200004],
              [88.04314212300005, 21.65761953300006],
              [88.04224694100003, 21.66815827000005],
              [88.04395592500003, 21.680853583000044],
              [88.05054772200003, 21.70538971600007],
            ],
          ],
          [
            [
              [88.63624108200008, 21.92137278900009],
              [88.65015709700003, 21.927435614000046],
              [88.66325931100005, 21.92129140800006],
              [88.67058353000004, 21.907416083000044],
              [88.66700280000003, 21.890326239000046],
              [88.65528405000003, 21.86660390800006],
              [88.64918053500003, 21.842352606000077],
              [88.64633222700007, 21.787909247000073],
              [88.63624108200008, 21.792669989000046],
              [88.59961998800003, 21.803656317000048],
              [88.59180748800003, 21.804388739000046],
              [88.59050540500004, 21.812892971000053],
              [88.58497155000003, 21.826605536000045],
              [88.58432050900007, 21.835760809000078],
              [88.58627363400007, 21.843003648000035],
              [88.59864342500003, 21.86985911700009],
              [88.61646569100003, 21.89793528900009],
              [88.63624108200008, 21.92137278900009],
            ],
          ],
          [
            [
              [88.08090254000007, 21.849351304000038],
              [88.07227623800003, 21.856756903000075],
              [88.07105553500003, 21.873602606000077],
              [88.07390384200005, 21.89215729400007],
              [88.07732181100005, 21.90460846600007],
              [88.08472741000003, 21.921576239000046],
              [88.09424889400003, 21.937892971000053],
              [88.10572350400008, 21.94757721600007],
              [88.11890709700003, 21.945013739000046],
              [88.13257897200003, 21.920477606000077],
              [88.12501061300003, 21.88865794500009],
              [88.10499108200008, 21.861151434000078],
              [88.08090254000007, 21.849351304000038],
            ],
          ],
          [
            [
              [72.17269941500007, 10.80923086100006],
              [72.17261803500008, 10.82998281500005],
              [72.17904707100007, 10.84870026200008],
              [72.18515058700007, 10.858303127000056],
              [72.18930097700007, 10.864935614000046],
              [72.19564863400007, 10.872707424000055],
              [72.20004316500007, 10.878078518000052],
              [72.20004316500007, 10.864447333000044],
              [72.18816165500004, 10.836127020000049],
              [72.17269941500007, 10.80923086100006],
            ],
          ],
          [
            [
              [72.78907311300003, 11.261664130000042],
              [72.78923587300005, 11.261664130000042],
              [72.79590905000003, 11.261664130000042],
              [72.79558353000004, 11.257228908000059],
              [72.79395592500003, 11.254299221000053],
              [72.79151451900003, 11.251654364000046],
              [72.78907311300003, 11.24803294500009],
              [72.78793379000007, 11.232245184000078],
              [72.78492272200003, 11.216376044000071],
              [72.77548261800007, 11.186753648000092],
              [72.77540123800003, 11.18659088700008],
              [72.77116946700005, 11.201117255000042],
              [72.77035566500007, 11.203640041000085],
              [72.77418053500008, 11.22288646000004],
              [72.78907311300003, 11.261664130000042],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'China',
        iso3: 'CHN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [78.91769413200012, 33.386257833000045],
              [78.91594777500006, 33.387655981000094],
              [78.82426314300005, 33.46105946900006],
              [78.80090539600008, 33.494235738],
              [78.7813717040001, 33.55278513600008],
              [78.79408410700006, 33.743910421000024],
              [78.78726281700011, 33.808428447000054],
              [78.77031294800008, 33.872352193000026],
              [78.7211169840001, 33.99438608900009],
              [78.73010868400007, 34.079264629000036],
              [78.80607303900013, 34.12298289000002],
              [78.90322473100008, 34.15812286400008],
              [78.97619185400004, 34.2171631880001],
              [78.98549361200014, 34.239900818000095],
              [78.98849084500006, 34.26312937400009],
              [78.98539025900004, 34.28635793100001],
              [78.97619185400004, 34.30917307600002],
              [78.95693951600003, 34.33996090500004],
              [78.95118046100004, 34.34917063400009],
              [78.92213830600014, 34.37229583700007],
              [78.8858614500001, 34.38575754800003],
              [78.83924930800003, 34.396893820000045],
              [78.80173221800004, 34.41500640900007],
              [78.75067590400005, 34.47128204400006],
              [78.66458296800005, 34.52642079700006],
              [78.6073254800001, 34.54647125300009],
              [78.37943241400006, 34.578665670000035],
              [78.3353007400001, 34.59437530600009],
              [78.29602665200014, 34.62465769500004],
              [78.2731856690001, 34.658867493000045],
              [78.21138065600013, 34.84826161700009],
              [78.20249230900009, 34.86572825100005],
              [78.16218469300003, 34.90882639600004],
              [78.14812870300005, 34.94313954700006],
              [78.13924035700012, 35.01894887300007],
              [78.13004195100012, 35.05543243400008],
              [78.03640425700007, 35.19423533100009],
              [78.0011609290001, 35.26890777600009],
              [78.00984257100004, 35.34745595300002],
              [78.03805790200005, 35.398098857],
              [78.0556278900001, 35.45287587500006],
              [78.04425907400008, 35.491633199],
              [77.98586470600003, 35.49416534400008],
              [77.95785607900012, 35.482073059000086],
              [77.91269087700005, 35.44099029500005],
              [77.88313195800004, 35.431068420000045],
              [77.85708703600005, 35.43659779900004],
              [77.83424605300007, 35.452152405000064],
              [77.81533247900012, 35.47333974200002],
              [77.80034631400014, 35.49540557900012],
              [77.77357792200007, 35.498971253],
              [77.76034875500005, 35.49809275300005],
              [77.74742964700005, 35.494320374000026],
              [77.71673384600012, 35.47540680000007],
              [77.68965539600009, 35.46269439700005],
              [77.66061324100008, 35.45809519500007],
              [77.51960817800011, 35.477439204000035],
              [77.51219852700007, 35.478455709000016],
              [77.47643843600014, 35.47716379800006],
              [77.41277307100012, 35.46941233300005],
              [77.38373091600005, 35.47199615500007],
              [77.35200158700013, 35.48605214500007],
              [77.30538944500006, 35.51783315100003],
              [77.28110152200009, 35.52801340800009],
              [77.25081913300005, 35.53070058200011],
              [77.17754195100014, 35.52315582300007],
              [77.14126509600004, 35.525377910000074],
              [77.10529829900008, 35.537986959000094],
              [77.09227583900014, 35.54780548200007],
              [77.07108850100008, 35.571008199000076],
              [77.05816939300007, 35.58010325200003],
              [77.03904911300009, 35.58501251200006],
              [77.01755171800005, 35.58459910100005],
              [76.97641727700005, 35.578656312000035],
              [76.93579960200003, 35.579638164000116],
              [76.91502567600008, 35.58315216100006],
              [76.89642216000004, 35.58961171500003],
              [76.88050581900012, 35.60067047200003],
              [76.85694136500013, 35.62857574500002],
              [76.84298872900013, 35.64128814800007],
              [76.82459191900011, 35.647799378000045],
              [76.78283736200007, 35.64573232000008],
              [76.77735074100008, 35.6461117140001],
              [76.76340702300007, 35.64707590700003],
              [76.74542362500011, 35.6550340780001],
              [76.73291792900011, 35.66660959900004],
              [76.70904341700003, 35.694049785000104],
              [76.67669397000003, 35.71379018200007],
              [76.60424361200006, 35.73570098900011],
              [76.57075728400014, 35.75125559500013],
              [76.5511202400001, 35.78401845300003],
              [76.56527958200007, 35.86546051100008],
              [76.5554610590001, 35.89786163400008],
              [76.53716760300011, 35.90251251300005],
              [76.50016727800005, 35.871506653000026],
              [76.47649947100012, 35.86525380500011],
              [76.45396854700004, 35.86478871700008],
              [76.4429097900001, 35.86329010100009],
              [76.43205773900007, 35.860499573000126],
              [76.42244592300005, 35.85429840100004],
              [76.41035363800006, 35.836831767],
              [76.4031189370001, 35.830992330000086],
              [76.38410201000005, 35.828201803000056],
              [76.36642867100005, 35.83088897700007],
              [76.34885868300006, 35.830992330000086],
              [76.31196171000005, 35.8096499630001],
              [76.29656213400006, 35.809494935000075],
              [76.28054244000009, 35.81424916700006],
              [76.26038863200012, 35.817814840000025],
              [76.23713423600003, 35.815489401],
              [76.18979862500004, 35.804999084000045],
              [76.16602746600006, 35.806239319000085],
              [76.13812219200008, 35.82665151000002],
              [76.1277869060001, 35.86210154200005],
              [76.12375614400008, 35.9034943650001],
              [76.11466109200012, 35.941786601],
              [76.08995975700003, 35.97811513300009],
              [76.06143436700006, 35.99160268200005],
              [75.98433313000004, 35.995633444000035],
              [75.95301721200008, 36.00726064100009],
              [75.92232141100004, 36.03165191700002],
              [75.8999971930001, 36.06348459900006],
              [75.89431278500007, 36.09738433900007],
              [75.9014441330001, 36.113610738],
              [75.91456994700007, 36.12389434800009],
              [75.96417932100013, 36.14983591800005],
              [75.97151737500013, 36.15500356100004],
              [75.97658166500008, 36.162755026000056],
              [75.97740848800004, 36.17376210500005],
              [75.96914025900008, 36.19169382800003],
              [75.97007043500014, 36.202339172],
              [75.98340295400004, 36.215413310000045],
              [76.00159305800008, 36.222131246000075],
              [76.01440881400009, 36.23039947500003],
              [76.01192834500011, 36.24812449100004],
              [76.00169641100013, 36.261457011000076],
              [75.97658166500008, 36.286985169],
              [75.96883020000013, 36.30197133400007],
              [75.96862349500003, 36.34181386400009],
              [75.98743371600006, 36.42118886300007],
              [75.98108273200012, 36.445443571000084],
              [75.9768113990001, 36.461755995000075],
              [75.97658166500008, 36.46263336200012],
              [75.87477909400013, 36.61947133400004],
              [75.84976770000003, 36.64474111],
              [75.79054650900008, 36.687839254000025],
              [75.72874149600005, 36.723185934000114],
              [75.64977990700004, 36.75403676400002],
              [75.5705082610001, 36.766749166000054],
              [75.50797977700006, 36.74762888700006],
              [75.50188195800013, 36.73796539300004],
              [75.49888472500004, 36.727630107000024],
              [75.49258020000008, 36.72070546500005],
              [75.43191206900013, 36.72292755100004],
              [75.41051802600003, 36.747318827000086],
              [75.40338667800006, 36.784784241000054],
              [75.40142297300014, 36.8258670040001],
              [75.39449833200007, 36.86426259400004],
              [75.37796187400005, 36.894286601000104],
              [75.35129683500008, 36.91578399700005],
              [75.31346968600013, 36.92875478100008],
              [75.19513065600006, 36.948882752000046],
              [75.16123091600008, 36.9642048140001],
              [75.13280887900004, 36.98469451900006],
              [75.11854618400008, 36.99123158800005],
              [75.10014937300008, 36.994125468000036],
              [75.01446984800009, 36.98448781300003],
              [74.9768494060001, 36.98428110800005],
              [74.94232955000007, 36.97699473100009],
              [74.9249662680001, 36.970871074000016],
              [74.91049686700006, 36.96255116800005],
              [74.90078169800012, 36.949916280000124],
              [74.89199670400012, 36.92097747800007],
              [74.88579553300013, 36.91144317600008],
              [74.87235966000009, 36.907102356000095],
              [74.86677860500009, 36.91655914300007],
              [74.86088749200007, 36.94689320900001],
              [74.8532393800001, 36.95898549400009],
              [74.8245072840001, 36.994125468000036],
              [74.82430057800013, 36.994125468000036],
              [74.79257124800012, 37.01515777600004],
              [74.71919071500008, 37.01644968700002],
              [74.69221561700004, 37.03588002600007],
              [74.67795292100004, 37.051693014000065],
              [74.66244999200006, 37.05448354100004],
              [74.62606978300005, 37.04275299100006],
              [74.56178430200009, 37.029678854000096],
              [74.54235396300004, 37.021669006000124],
              [74.51920292200003, 37.03024729400006],
              [74.50576705000009, 37.0470421350001],
              [74.4940881760001, 37.066472473000076],
              [74.47662154100004, 37.083138123000126],
              [74.41440311700006, 37.107839457000026],
              [74.38257043400012, 37.126572164000024],
              [74.36613732900014, 37.14775950100007],
              [74.36830774000003, 37.16706064900002],
              [74.38226037600003, 37.17204742500009],
              [74.42029423100007, 37.1680683390001],
              [74.44158492000014, 37.17054880800008],
              [74.45667443900004, 37.177318420000105],
              [74.46762984200012, 37.18992747000003],
              [74.47662154100004, 37.21005544100011],
              [74.48726688600004, 37.22594594300001],
              [74.50008264200005, 37.23163035100008],
              [74.53222538200009, 37.23219879200012],
              [74.57594364500005, 37.242146505000036],
              [74.5899996340001, 37.24336090100006],
              [74.59651086500014, 37.24075124100004],
              [74.60901656100003, 37.230183411000084],
              [74.61501102700004, 37.228374736],
              [74.6232792560001, 37.23080352800004],
              [74.62720666500007, 37.234317525000094],
              [74.62999719300012, 37.23829661100008],
              [74.64301965300007, 37.2483735150001],
              [74.64632694500006, 37.25483306900007],
              [74.65097782400005, 37.25963897700008],
              [74.67092492700004, 37.261344299000044],
              [74.67629927600012, 37.26372141500009],
              [74.69893355300007, 37.2803095500001],
              [74.7093721920001, 37.290825704000056],
              [74.7214644770001, 37.29777618500013],
              [74.73738081900012, 37.29612253800009],
              [74.74399540200011, 37.288396912000096],
              [74.78326949100006, 37.2196672570001],
              [74.7940181890001, 37.21393117300006],
              [74.81313846800009, 37.215429789000055],
              [74.89230676300008, 37.231113587000024],
              [74.91266727700014, 37.23899424300008],
              [74.92372603400014, 37.25519480500007],
              [74.93292443900003, 37.27250640900006],
              [74.95152795400008, 37.281291403000054],
              [74.9754024660001, 37.28428863500007],
              [75.06842004400005, 37.312142233000046],
              [75.07710168400013, 37.32420867900002],
              [75.0795821530001, 37.361234843],
              [75.09177779200007, 37.378443095000065],
              [75.1152388920001, 37.387796529000084],
              [75.16412479700006, 37.40063812300009],
              [75.13249882000008, 37.418492330000035],
              [75.10397343000011, 37.44060984300005],
              [75.05343387900007, 37.493836568000106],
              [75.03586389200012, 37.50639394100001],
              [74.94522343000006, 37.54856191000009],
              [74.91504439300007, 37.5707311],
              [74.89189335200007, 37.59920481400003],
              [74.88217818200008, 37.63442230300011],
              [74.88610559100005, 37.653465068000074],
              [74.89706099500012, 37.6675727340001],
              [74.91091027900006, 37.68023346000005],
              [74.92362268100004, 37.69532297800005],
              [74.92692997300009, 37.703591207],
              [74.92879032400003, 37.712427877],
              [74.93189091000005, 37.72157460600009],
              [74.93860884700007, 37.730824687],
              [74.95442183500006, 37.7477228800001],
              [74.96175988800007, 37.758084005000015],
              [74.9651705330001, 37.76746327800005],
              [74.96144982900012, 37.78547251500005],
              [74.94925419100008, 37.79531687400002],
              [74.89840458200007, 37.817589416000075],
              [74.89116988100011, 37.823041280000055],
              [74.88610559100005, 37.830560202000086],
              [74.88321171100006, 37.8438668830001],
              [74.88734582500007, 37.848931173],
              [74.89458052600014, 37.85210927400006],
              [74.91163374800004, 37.87376169900004],
              [74.91370080600012, 37.880841370000056],
              [74.90522587100008, 37.8869391890001],
              [74.89396040800005, 37.89226186200007],
              [74.8907564700001, 37.89771372500006],
              [74.89116988100011, 37.90425079400002],
              [74.88879276500006, 37.93091583300007],
              [74.89282352800006, 37.99401275700011],
              [74.88042118300007, 38.021659648000124],
              [74.80993453000013, 38.053208110000085],
              [74.79071089700011, 38.08144928000006],
              [74.77128055900005, 38.19627431200006],
              [74.77107385300008, 38.29153981600005],
              [74.77479455600007, 38.30962656700005],
              [74.78430302000004, 38.32567209900013],
              [74.82667769400007, 38.36321502700012],
              [74.83825321400013, 38.37941558800013],
              [74.84414432800014, 38.39776072200003],
              [74.84435103300007, 38.417242737000024],
              [74.8371163330001, 38.44574229000004],
              [74.83577274600003, 38.45517323800003],
              [74.83287886600004, 38.463648173000095],
              [74.82616092900014, 38.46964263900004],
              [74.80848759000014, 38.477652486000025],
              [74.80125289000006, 38.482820130000036],
              [74.79226119000003, 38.49385304800002],
              [74.7921578370001, 38.49403391500006],
              [74.77634484900011, 38.510673727],
              [74.76032515500003, 38.5199754850001],
              [74.74203169700007, 38.52307607000007],
              [74.71908736100005, 38.521525777000036],
              [74.69645308500009, 38.523980408000014],
              [74.67960656800011, 38.53490997400009],
              [74.66431034400006, 38.54901763900001],
              [74.64612023900008, 38.561109925],
              [74.47662154100004, 38.61206288700005],
              [74.33420129400008, 38.66699493400007],
              [74.31342736800013, 38.66921702100008],
              [74.24376753700011, 38.650200094000084],
              [74.22144331900012, 38.64970916800006],
              [74.20201298100005, 38.65231882700009],
              [74.14041467300012, 38.66921702100008],
              [74.12336145000006, 38.66947540300005],
              [74.1090987550001, 38.66229237900008],
              [74.09504276600006, 38.6457559200001],
              [74.09266565000013, 38.63769439800011],
              [74.09287235500011, 38.62875437500007],
              [74.09142541500012, 38.6204344690001],
              [74.08439742000007, 38.61402659100007],
              [74.04491662600009, 38.603458761000084],
              [74.03726851400006, 38.598471986000035],
              [74.03809533700013, 38.57922251400002],
              [74.05080773900005, 38.5626602170001],
              [74.05876591000003, 38.54702809700008],
              [74.04553674300013, 38.530414124000046],
              [74.02889693200012, 38.52723602400009],
              [73.93288212100003, 38.52966481500006],
              [73.91727583900007, 38.53708038400008],
              [73.8870968010001, 38.55904286700003],
              [73.86973352100006, 38.56679433200004],
              [73.83356001800013, 38.57795644200006],
              [73.81640344300007, 38.58658640600002],
              [73.79738651500008, 38.60283864400013],
              [73.78860152200014, 38.6185741180001],
              [73.77909305800006, 38.66019948300003],
              [73.7722717690001, 38.67461720800013],
              [73.73640832600006, 38.72166860000003],
              [73.73268762200013, 38.737171530000026],
              [73.73899214700003, 38.781096497000064],
              [73.73589156100007, 38.8004234830001],
              [73.72493615700012, 38.814556987000046],
              [73.6957906500001, 38.840110983],
              [73.68369836500011, 38.85494211900003],
              [73.68080448400013, 38.87297719300004],
              [73.68896936000004, 38.891089783000055],
              [73.70292199700003, 38.90703196200009],
              [73.71718469300004, 38.91858164500012],
              [73.7399223220001, 38.926927389000085],
              [73.78787805200011, 38.92708241900003],
              [73.80958215300012, 38.93266347300006],
              [73.82394820200011, 38.944936626000086],
              [73.82911584500005, 38.960155335000124],
              [73.82611861200013, 38.97689849900006],
              [73.81599003200006, 38.99377085400006],
              [73.80162398300007, 39.00144480400003],
              [73.76865441900003, 39.02991851900008],
              [73.7093298750001, 39.065471904000034],
              [73.69816776600004, 39.07841685000004],
              [73.69186324100014, 39.09446238200012],
              [73.68297489400004, 39.12874969600004],
              [73.67377649000014, 39.14262481700008],
              [73.63140181500012, 39.17510345400002],
              [73.60783736200011, 39.20732371000007],
              [73.60225630700006, 39.235771587],
              [73.61011112500012, 39.26545969700008],
              [73.64132369000009, 39.335274557000034],
              [73.64380415900007, 39.351294251000084],
              [73.64256392500005, 39.371758118000045],
              [73.63191857900006, 39.42880889900006],
              [73.63264204900014, 39.44834259000005],
              [73.82074426200006, 39.46818634100005],
              [73.83831425000005, 39.47567942400009],
              [73.84802941900006, 39.489735413000105],
              [73.85919152800011, 39.5242552700001],
              [73.87045699100008, 39.546786194],
              [73.88306604000007, 39.56120391900002],
              [73.89929244000007, 39.571539206000026],
              [73.92161665900005, 39.582132874000095],
              [73.92678430200004, 39.592881572000024],
              [73.90425337800013, 39.646470032000096],
              [73.89960249900008, 39.68946482300008],
              [73.89350468000004, 39.71039377900006],
              [73.87934533700007, 39.72791208900013],
              [73.85991499900007, 39.73716217000005],
              [73.84306848200004, 39.740366110000096],
              [73.82952925700005, 39.74698069200009],
              [73.81981408700011, 39.766721090000075],
              [73.81857385300009, 39.78604807600003],
              [73.82301802600006, 39.805685120000064],
              [73.83200972500003, 39.823720195000064],
              [73.84410201000009, 39.83808624300006],
              [73.87293746000006, 39.85684478800006],
              [73.88068892400014, 39.865009664000084],
              [73.88544315600012, 39.876533508000094],
              [73.89319462100013, 39.9181330360001],
              [73.90756066900013, 39.93787343400008],
              [73.9273010660001, 39.95332468700006],
              [73.94404423100008, 39.970067851000024],
              [73.94972863700008, 39.993683981000046],
              [73.95210575300007, 40.008256734],
              [73.95789351400003, 40.02143422500008],
              [73.96636844900013, 40.033268128000074],
              [73.97670373600005, 40.04360341400009],
              [74.00398889100006, 40.06081166600008],
              [74.06951460800013, 40.067787985000066],
              [74.10124393700005, 40.07884674100008],
              [74.13286991400008, 40.09533152300004],
              [74.16759647600009, 40.10639027900005],
              [74.20314986200003, 40.10985260000008],
              [74.23787642400009, 40.103909811000094],
              [74.27229292800013, 40.09383290600006],
              [74.30288537600006, 40.090060527000034],
              [74.33378788300007, 40.09372955300002],
              [74.36985803300007, 40.105821839],
              [74.47662154100004, 40.17243276],
              [74.5654016520001, 40.246950176000055],
              [74.59868127500005, 40.26617380800006],
              [74.63764530500004, 40.28198679700007],
              [74.65438846900008, 40.291546936000074],
              [74.70575484200003, 40.331286113000075],
              [74.72466841600004, 40.33753896100005],
              [74.74668257600013, 40.33650543200007],
              [74.83091516100012, 40.31991729800008],
              [74.8621277260001, 40.32617014600008],
              [74.85385949700009, 40.35882965100005],
              [74.84166385900005, 40.37205881800004],
              [74.79463830600008, 40.40554514600005],
              [74.78740360500012, 40.42073801700006],
              [74.79463830600008, 40.44073679600011],
              [74.80704064900004, 40.46176910400003],
              [74.81510217300013, 40.4801142380001],
              [74.81603234900007, 40.48367991100007],
              [74.82006311000009, 40.493963521000055],
              [74.83231214200009, 40.508116118000075],
              [74.83535933500013, 40.51163686100007],
              [74.85644331900005, 40.513187154],
              [74.87918094900004, 40.50507395400008],
              [74.96610070800006, 40.45928863500005],
              [75.00237756300004, 40.44729970300007],
              [75.03906783100007, 40.441098531000094],
              [75.06438928300008, 40.44383738200004],
              [75.11317183400013, 40.46078725200006],
              [75.13807987500007, 40.463887838000076],
              [75.15658003700008, 40.45815175400013],
              [75.17528690600011, 40.44812652600011],
              [75.19389042200004, 40.44125356100004],
              [75.21249393800008, 40.44471588200007],
              [75.22014204900006, 40.45298411100002],
              [75.22396610500004, 40.46244089800008],
              [75.22923710200007, 40.47034739200005],
              [75.2415360930001, 40.47406809500005],
              [75.25331831900007, 40.47598012400009],
              [75.2632401940001, 40.48016591500003],
              [75.48183150200009, 40.614111227000095],
              [75.5237927660001, 40.63317983000009],
              [75.55986291500011, 40.632869772],
              [75.58766483600004, 40.61194081700002],
              [75.60564823400011, 40.56941111300007],
              [75.61081587700005, 40.51287709600011],
              [75.61794722500008, 40.493963521000055],
              [75.62900598200008, 40.48130279500002],
              [75.65722131300004, 40.46109731000003],
              [75.66693648300009, 40.450245260000074],
              [75.66931359800003, 40.43236521400003],
              [75.65959842900008, 40.41908437100001],
              [75.64636926200006, 40.40533844],
              [75.63830774000007, 40.38611480800007],
              [75.64016809100008, 40.36730458600006],
              [75.65629113800009, 40.323069560000036],
              [75.66486942600011, 40.305706279],
              [75.68181929600013, 40.291701966000105],
              [75.70445357300008, 40.2931489060001],
              [75.75054895000011, 40.308341777000024],
              [75.77204634600014, 40.310150452000116],
              [75.79375044800014, 40.30891021800009],
              [75.85855269300004, 40.29635284500007],
              [75.88046350100007, 40.29526763900007],
              [75.90185754400011, 40.29888499000005],
              [75.92149458900013, 40.30911692400004],
              [75.93803104600005, 40.326221822],
              [75.94929650900008, 40.343068339000055],
              [75.96242232300006, 40.35733103400004],
              [76.05161584500007, 40.39019724500007],
              [76.07611047400007, 40.39195424400005],
              [76.09523075400006, 40.387355042000095],
              [76.13254113800008, 40.371542053],
              [76.1513513590001, 40.36813140900007],
              [76.18504439300006, 40.384202779000034],
              [76.21543013500008, 40.416552226000036],
              [76.24416223100013, 40.44120188400002],
              [76.27341109200006, 40.434122213000094],
              [76.28333296800014, 40.41727569600003],
              [76.29935266100011, 40.35567738900009],
              [76.31351200400007, 40.343326721000025],
              [76.33015181500008, 40.34808095300012],
              [76.36198449700004, 40.3719037880001],
              [76.44911096200008, 40.41551869700005],
              [76.47649947100012, 40.436137594000044],
              [76.49892704300004, 40.46461130800007],
              [76.53117313600012, 40.534994609000094],
              [76.55639123500004, 40.565690410000045],
              [76.60941125500005, 40.59710968000009],
              [76.62078007100013, 40.611320699000046],
              [76.62419071400006, 40.62754709900007],
              [76.63080529800004, 40.728884583000095],
              [76.6478585210001, 40.76485138000005],
              [76.67421350100005, 40.795443828000074],
              [76.70728641800014, 40.817613017],
              [76.74687056500011, 40.83445953400009],
              [76.76247684700013, 40.84701690700008],
              [76.77084843000011, 40.86711903900006],
              [76.76836796100014, 40.887014465000064],
              [76.76092655500014, 40.90659983300007],
              [76.75741255700007, 40.9257717900001],
              [76.76681766800004, 40.94468536400002],
              [76.7839742430001, 40.957139384000115],
              [76.82087121600011, 40.97780995700002],
              [76.83492720500004, 40.993519592],
              [76.86097212800013, 41.01320831300005],
              [76.90014286300004, 41.02576568600007],
              [77.00773319500007, 41.04421417300007],
              [77.03501835100008, 41.0403384400001],
              [77.08855513500004, 41.019564515000084],
              [77.11883752500006, 41.01165802100003],
              [77.24317102100014, 41.005663554000094],
              [77.30115197800012, 41.01930613200001],
              [77.33298466000014, 41.020649719000076],
              [77.38879520600011, 41.01165802100003],
              [77.44522587100005, 40.99367462200003],
              [77.4748881430001, 40.98204742500009],
              [77.5035168870001, 40.98106557200002],
              [77.58072147700005, 40.997705383000024],
              [77.63177779200004, 40.99579335500003],
              [77.65027795400005, 40.997136943000086],
              [77.66557417800004, 41.001271058],
              [77.79755578600009, 41.05470448800013],
              [77.83104211400007, 41.06297271800007],
              [77.86669885300006, 41.06405792200006],
              [77.99764693200007, 41.049795227000075],
              [78.03650761000011, 41.036100973000075],
              [78.05717818200003, 41.034343974000095],
              [78.07495487500006, 41.03951161700009],
              [78.17603397600004, 41.10550242200013],
              [78.19050337700014, 41.11774973600005],
              [78.20445601400013, 41.133717753],
              [78.23133511000003, 41.172855896],
              [78.25034468600012, 41.200535380000034],
              [78.27535608000011, 41.22885406500005],
              [78.29158247900011, 41.24079132100009],
              [78.33147668500004, 41.258723043000046],
              [78.34946008300005, 41.27040191700003],
              [78.35969201700004, 41.28745513900007],
              [78.35690148900005, 41.30554189100006],
              [78.3393315030001, 41.34404083200003],
              [78.3434656170001, 41.36202423100012],
              [78.35989872300007, 41.37752716100003],
              [78.3776754160001, 41.38662221300011],
              [78.41756962100004, 41.400471497000055],
              [78.51038049400006, 41.454421692000025],
              [78.58396773300007, 41.46599721300008],
              [78.61921106000005, 41.47808949900006],
              [78.62913293500003, 41.48795969600003],
              [78.6374011640001, 41.51286773700009],
              [78.64504927600007, 41.523719788000065],
              [78.65827844200004, 41.532453105000045],
              [78.67212772700003, 41.53844757100005],
              [78.80731327300003, 41.57844513000002],
              [78.89743697200004, 41.626271668000115],
              [78.91583378100012, 41.63317047200009],
              [78.97619185400004, 41.641800435000036],
              [79.08874312300003, 41.70254608200004],
              [79.12791385900005, 41.71430247000005],
              [79.17452600100012, 41.722622375000086],
              [79.19592004400005, 41.72952117900006],
              [79.21752079300012, 41.74122589200006],
              [79.26485640400006, 41.77450551300008],
              [79.28232303900012, 41.78349721300013],
              [79.30413049300012, 41.78755381300003],
              [79.36738244600014, 41.77238678000002],
              [79.39084354700009, 41.7726968380001],
              [79.41099735600005, 41.77858795200011],
              [79.4898555910001, 41.81925730500005],
              [79.5546578370001, 41.83760243700003],
              [79.61098514800011, 41.867626445],
              [79.65573693800008, 41.87584299800004],
              [79.70296919800012, 41.87493866000007],
              [79.7475142830001, 41.879744568],
              [79.78327437300004, 41.90509185800006],
              [79.79257613100003, 41.922816874],
              [79.80384159300007, 41.959998068000104],
              [79.81283329300004, 41.977619731000075],
              [79.82678592900004, 41.992244161000045],
              [79.84290897700004, 42.00183013900006],
              [79.87949589000004, 42.01319895500005],
              [79.93086226400004, 42.023275859000094],
              [80.18190637200013, 42.02097625800006],
              [80.23120568900003, 42.03368866000001],
              [80.2575606690001, 42.06526296],
              [80.2565271410001, 42.084357401],
              [80.24743208800004, 42.09841339100011],
              [80.23513309800006, 42.110944926000016],
              [80.22459110500012, 42.12556935700009],
              [80.21983687300013, 42.14187327100011],
              [80.21652958200013, 42.174403585000064],
              [80.21032841000005, 42.18951894100006],
              [80.24908573500005, 42.20489268000004],
              [80.26045454900009, 42.2164940390001],
              [80.26841272000013, 42.23796559700013],
              [80.24949914600006, 42.30995086700007],
              [80.23554650900007, 42.32457529700007],
              [80.22552128100006, 42.33901886100007],
              [80.21869999200004, 42.354935201],
              [80.19616906800007, 42.434594422000046],
              [80.19472212700003, 42.44629913400003],
              [80.20629764800003, 42.46596201600006],
              [80.21208540900011, 42.478751933000055],
              [80.21053511600007, 42.49084421900004],
              [80.20009647600006, 42.50838836700008],
              [80.1737414960001, 42.53691375800004],
              [80.16237268100014, 42.55239084900005],
              [80.1534843340001, 42.591535747000094],
              [80.14542281100012, 42.60711619100003],
              [80.14004846200004, 42.62295501800013],
              [80.14376916500004, 42.64476247200004],
              [80.15245080500011, 42.660368755],
              [80.18893436700006, 42.701580709],
              [80.20536747200009, 42.73108795200001],
              [80.22748498600004, 42.79098093700007],
              [80.24825891100005, 42.81619903600004],
              [80.2648987230001, 42.82366628000007],
              [80.28174524000013, 42.822736105],
              [80.3167818610001, 42.81560475700006],
              [80.33393843600004, 42.81707753600007],
              [80.38168746000008, 42.83141774600007],
              [80.4004976810001, 42.84301910400002],
              [80.47615197800008, 42.863896383000096],
              [80.52669152900012, 42.86839223300011],
              [80.54860233600004, 42.87846913600005],
              [80.55449344900006, 42.898933004000114],
              [80.54291792800012, 42.91665802100003],
              [80.52193729700014, 42.92544301400001],
              [80.47615197800008, 42.93027476000013],
              [80.40773238100007, 42.95469187400006],
              [80.37383264200008, 42.975181580000125],
              [80.3551257740001, 43.00058054600002],
              [80.36814823400005, 43.028459982000086],
              [80.41021285000005, 43.048665467],
              [80.49785607900009, 43.076183166000064],
              [80.57588749200005, 43.119410502],
              [80.61846887200005, 43.13426747700005],
              [80.66001672300013, 43.13282053600007],
              [80.71076298000014, 43.10478607200004],
              [80.73153690600009, 43.10109120700004],
              [80.75344771400012, 43.10403676400004],
              [80.77339481600012, 43.11292511000006],
              [80.78786421700005, 43.12804046700005],
              [80.7934452720001, 43.14946034800009],
              [80.78817427600006, 43.16824473100009],
              [80.76522994000004, 43.199948223],
              [80.75995894400006, 43.218784282000016],
              [80.75913212100005, 43.23824045900001],
              [80.75582482900006, 43.25761912000006],
              [80.74848677600005, 43.27516326900003],
              [80.73546431500012, 43.28888336200005],
              [80.69598352100007, 43.303275249000066],
              [80.65846643100008, 43.31063914000008],
              [80.64286014800007, 43.326219585],
              [80.69422652200012, 43.39471669600003],
              [80.71014286300004, 43.42585174600008],
              [80.71272668500006, 43.45887298600006],
              [80.59443933150015, 43.68455688500008],
              [80.47615197800008, 43.910240784000095],
              [80.4398751220001, 43.948998108000026],
              [80.42313195800006, 43.97214914900012],
              [80.41269331900014, 43.99323313400005],
              [80.41269331900014, 43.993336487000064],
              [80.41238326000007, 44.01359364900007],
              [80.41000614400008, 44.03193878200007],
              [80.40380497300004, 44.048940328000086],
              [80.39233280400009, 44.065476787000065],
              [80.35977665200005, 44.08929962200004],
              [80.3451005450001, 44.103097229000085],
              [80.3388993740001, 44.1214940390001],
              [80.34603072100003, 44.15890777600005],
              [80.3732125250001, 44.23099640000005],
              [80.37300581900007, 44.270218812000095],
              [80.33290490700006, 44.417393291000096],
              [80.33042443900007, 44.45305002900007],
              [80.33786584500012, 44.49402944000009],
              [80.36453088400003, 44.56968373700006],
              [80.37993046100013, 44.59133616200005],
              [80.38375451700006, 44.60280833000006],
              [80.37724328600012, 44.615314026000064],
              [80.35915653500007, 44.63257395400005],
              [80.35450565600013, 44.64177236000005],
              [80.35584924300008, 44.652882793000074],
              [80.37631311000007, 44.67127960300006],
              [80.4111430260001, 44.6828034470001],
              [80.47615197800008, 44.69365549800004],
              [80.49196496600007, 44.70171702100005],
              [80.49744266800008, 44.714946187000024],
              [80.49227502400004, 44.72796864800007],
              [80.47615197800008, 44.7354100540001],
              [80.31450809800003, 44.78031687400009],
              [80.26324507600003, 44.80935902900008],
              [80.24474491400008, 44.81597361300008],
              [80.21828658100003, 44.81809234600006],
              [80.03938277200012, 44.790497132000056],
              [79.99173710100007, 44.79364939400001],
              [79.86864384000012, 44.84935658800005],
              [79.84301232900003, 44.873489482000096],
              [79.8582052000001, 44.90372019500002],
              [79.87815230300009, 44.91472727500012],
              [79.92466109300005, 44.931677144000034],
              [80.02377649000005, 44.99327545200005],
              [80.06170699100005, 45.01895863900005],
              [80.10335819500006, 45.03218780500002],
              [80.14759322100008, 45.034461569000044],
              [80.21901005100011, 45.02603831000006],
              [80.29053023300014, 45.04624379500005],
              [80.36504764900008, 45.04319488600002],
              [80.39005904100009, 45.045778707000025],
              [80.40638879400012, 45.05663075800008],
              [80.42509566300009, 45.09213246700001],
              [80.44535282400011, 45.104224752],
              [80.46757369000005, 45.10629181000006],
              [80.53682010900008, 45.10107249000005],
              [80.69712040200011, 45.14365387000002],
              [80.74569624800012, 45.14427398800008],
              [80.82755171700006, 45.12577382400006],
              [80.85385502200012, 45.12649729500005],
              [80.97601810700007, 45.16106882800004],
              [81.02190677900006, 45.161637268],
              [81.06252445500007, 45.172230937000066],
              [81.1441732180001, 45.204683736],
              [81.54203007000007, 45.293308818000085],
              [81.62259362800006, 45.33433990500002],
              [81.66522668500005, 45.347982483000024],
              [81.70475915500009, 45.33986928300003],
              [81.73927901200005, 45.33806060800005],
              [81.76516890500011, 45.3077265430001],
              [81.78144698100004, 45.266643779000034],
              [81.78733809400012, 45.232330628000014],
              [81.78847497600003, 45.209127910000106],
              [81.79364261900014, 45.19564036100003],
              [81.80728519700006, 45.18871571900006],
              [81.87534305800006, 45.18106760700009],
              [81.89100101800011, 45.173729554],
              [81.91012129800009, 45.15801991800002],
              [81.95011885600007, 45.144480693000034],
              [82.00045170100003, 45.153524069000085],
              [82.19175785300013, 45.22220204700007],
              [82.24529463800008, 45.231813863000056],
              [82.29459395300006, 45.22819651300007],
              [82.3418262130001, 45.204890442000064],
              [82.42745406100005, 45.137245993000064],
              [82.47582320100008, 45.11569692000002],
              [82.53974694900006, 45.12365509100009],
              [82.58522220800012, 45.176830140000035],
              [82.61457442300008, 45.24855702700002],
              [82.63384973100005, 45.33935251900009],
              [82.63638187700013, 45.37888499000003],
              [82.63198938000005, 45.41583363900007],
              [82.61571130400011, 45.43541900700008],
              [82.51303023300011, 45.46575307300013],
              [82.36265181500005, 45.481204326000025],
              [82.32777022300007, 45.49329661100002],
              [82.32761519400003, 45.493348288000035],
              [82.3274601650001, 45.493348288000035],
              [82.29149336800003, 45.53319081700006],
              [82.29713742600012, 45.554544911000036],
              [82.30461918200007, 45.58285186800005],
              [82.33603845300013, 45.63514841700005],
              [82.37221195500007, 45.73416046200005],
              [82.44750451700008, 45.82542104100007],
              [82.47582320100008, 45.873170065000025],
              [82.48894901500006, 45.90169545500008],
              [82.5158724370001, 45.99311106400002],
              [82.54186568200004, 46.13150054900002],
              [82.56827233900003, 46.196509501],
              [82.60785648600006, 46.25521392900005],
              [82.67436405500013, 46.33112660700006],
              [82.68929854400011, 46.362545878],
              [82.70128747600006, 46.416857809000064],
              [82.70785038300005, 46.43416941400007],
              [82.74743452900009, 46.49333892800003],
              [82.83895349200009, 46.732445781000095],
              [82.98550785300006, 46.942510478000074],
              [82.99181237800008, 46.958736878000096],
              [82.99336267100011, 46.97560923300007],
              [82.98835005700005, 46.9929983520001],
              [82.98550785300006, 47.01253204300009],
              [82.99015873200005, 47.03216908800003],
              [83.00545495600011, 47.06978953100007],
              [83.00628177900012, 47.08061574300011],
              [82.99946049000005, 47.10004608200008],
              [82.99822025600014, 47.11025217700005],
              [83.0013208420001, 47.12136261000008],
              [83.01217289300013, 47.14265330000005],
              [83.01517012600004, 47.15438385100005],
              [83.01351648000008, 47.19458811500006],
              [83.02147465000007, 47.20590525400006],
              [83.04689945500007, 47.21466440800002],
              [83.07160079000005, 47.21851430300008],
              [83.09909265200014, 47.2197028610001],
              [83.12637780800009, 47.21758412700002],
              [83.15035567200005, 47.21153798500008],
              [83.20192875200007, 47.1803512580001],
              [83.22197920800005, 47.171902161],
              [83.3141699630001, 47.15794952400002],
              [83.35339237500006, 47.1449787400001],
              [83.52449304200013, 47.067102357000024],
              [83.90534834800013, 46.97395558700002],
              [83.99919274900003, 46.97431732200003],
              [84.06962772600014, 46.96442128500003],
              [84.09396732600004, 46.96741851900005],
              [84.15783939700003, 46.9929983520001],
              [84.15814945500011, 46.99310170500003],
              [84.15871789600004, 46.993153382000045],
              [84.15907963100005, 46.99325673500006],
              [84.26584314000007, 47.000129700000045],
              [84.38862634300011, 46.9929983520001],
              [84.38934981300014, 46.993153382000045],
              [84.4058862710001, 46.99423858700003],
              [84.42180261300012, 46.99310170500003],
              [84.4757528080001, 46.97524749800006],
              [84.5210213630001, 46.969795634],
              [84.6160026450001, 46.98628041700006],
              [84.6635449630001, 46.98385162400011],
              [84.6992017010001, 46.97023488400002],
              [84.73165450100004, 46.94775563600011],
              [84.75160160300004, 46.9179900110001],
              [84.74958622300011, 46.88246246400006],
              [84.7385791420001, 46.86615854900005],
              [84.72441980000008, 46.85026804700003],
              [84.71553145400003, 46.8351785280001],
              [84.71976892100008, 46.82130340600004],
              [84.73961267100009, 46.81476633700008],
              [84.76710453300007, 46.81807362900007],
              [84.84017500900012, 46.8391317750001],
              [84.91603601100013, 46.85055226600009],
              [84.93680993700008, 46.86101674500013],
              [84.95939253800009, 46.89088572300004],
              [84.97577396700007, 46.90199615500008],
              [84.99039839700004, 46.90768056300003],
              [85.03535689300003, 46.9149669400001],
              [85.04822432500004, 46.92070302400005],
              [85.07716312700012, 46.943311463],
              [85.14599613500008, 46.97808970200005],
              [85.16739017800012, 46.9929983520001],
              [85.19152307100006, 47.02328074100002],
              [85.20511397300004, 47.03371938100007],
              [85.2258362230001, 47.041574199000095],
              [85.24614506000012, 47.04441640200007],
              [85.30371260600003, 47.039403789000104],
              [85.43212854000006, 47.05312388100005],
              [85.49863610900013, 47.051831971000084],
              [85.50576745700005, 47.06389841700006],
              [85.50809289600011, 47.08252777100002],
              [85.51687788900006, 47.10030446400005],
              [85.52974532000007, 47.11428293900006],
              [85.53863366700006, 47.127925517000065],
              [85.5442663980001, 47.143221741],
              [85.5471086020001, 47.16203196300002],
              [85.55682377100004, 47.17874928800008],
              [85.57749434400006, 47.189162089],
              [85.6016272380001, 47.19443308500003],
              [85.64730920400012, 47.197895407000075],
              [85.65965987200008, 47.20652537000011],
              [85.66441410300007, 47.22130483100004],
              [85.66839318900003, 47.2418720510001],
              [85.67898685700004, 47.274893290000094],
              [85.67898685700004, 47.29070627900008],
              [85.67020186400003, 47.30905141200007],
              [85.66720463000013, 47.326052959],
              [85.67402592000008, 47.34429474000005],
              [85.67888350400011, 47.363828431000044],
              [85.67035689300008, 47.38434397400003],
              [85.60023197500004, 47.46320221000006],
              [85.58457401500004, 47.492941997000045],
              [85.58457401500004, 47.493097026000086],
              [85.57997481300004, 47.523766989000094],
              [85.59578780100003, 47.59089467400004],
              [85.59542606600013, 47.62407094400005],
              [85.51537927200008, 47.92028025300006],
              [85.51780806500011, 47.944645692000066],
              [85.52871179300007, 47.96660817500005],
              [85.5471086020001, 47.9929889940001],
              [85.56178470900005, 48.03066111300005],
              [85.58638269000005, 48.14124867700009],
              [85.71867435700011, 48.3588322960001],
              [85.7474064540001, 48.390096538000094],
              [85.78368330900008, 48.40758901000005],
              [86.00599532100006, 48.42955149400002],
              [86.19203047700012, 48.41823435500005],
              [86.24670414200006, 48.437354635000034],
              [86.28628829000013, 48.46970408200012],
              [86.30737227400004, 48.48308827700005],
              [86.33383060700004, 48.49040049300005],
              [86.43062056500014, 48.48587880500013],
              [86.54642745000012, 48.51722056100003],
              [86.56508264200005, 48.527323303000074],
              [86.57515954600012, 48.539829001000086],
              [86.59355635600014, 48.574142151],
              [86.60554528900008, 48.590110169000056],
              [86.62109989400011, 48.603158468000075],
              [86.66900394700014, 48.63424184200004],
              [86.74450321400013, 48.70353993700006],
              [86.75199629700006, 48.7154255170001],
              [86.75189294500012, 48.72917144900002],
              [86.74052413000004, 48.77170115200009],
              [86.7391805420001, 48.78353505500009],
              [86.74610518400004, 48.79283681200012],
              [86.7646570230001, 48.80761627300005],
              [86.78946171100006, 48.83913889600011],
              [86.77370039900006, 48.85851755800006],
              [86.7418677170001, 48.87872304400007],
              [86.71804488100014, 48.912519430000046],
              [86.71158532800007, 48.93706573500002],
              [86.70941491700012, 48.954222311000066],
              [86.71385909000003, 48.969931946000045],
              [86.7275016690001, 48.99034413700009],
              [86.74352136300007, 49.007707419],
              [86.76005782100003, 49.020109762000075],
              [86.79891849800003, 49.04222727500009],
              [86.81617842600008, 49.05845367500008],
              [86.8381925860001, 49.09385203],
              [86.85948327600005, 49.10532419900004],
              [86.88733687400003, 49.10682281600005],
              [86.94655806500003, 49.094472148000065],
              [86.97544519000007, 49.092405090000014],
              [87.11631514500004, 49.12976715100008],
              [87.16199711100006, 49.122790832000064],
              [87.20065108200009, 49.10873484300005],
              [87.32379602100013, 49.08527374300009],
              [87.36229496300007, 49.075093485000096],
              [87.40043217000004, 49.0710110480001],
              [87.43836267100005, 49.074680074000085],
              [87.47556970200009, 49.08759918300011],
              [87.48177087400006, 49.09162994400002],
              [87.48714522300003, 49.09695261700004],
              [87.49158939600011, 49.103205465000045],
              [87.50006433100003, 49.11917348200008],
              [87.50605879700004, 49.12087880500006],
              [87.51401696800008, 49.11963857000002],
              [87.52528243000006, 49.11979360000005],
              [87.71638187700012, 49.158860982000064],
              [87.81632409700006, 49.16583730100008],
              [87.81808109500014, 49.15400339800006],
              [87.83244714400013, 49.12387603800006],
              [87.83554773000009, 49.100724997000086],
              [87.82965661700007, 49.085997213000084],
              [87.82107832900004, 49.071837870000124],
              [87.81596236200005, 49.050598857000054],
              [87.82190515100007, 49.028739726000126],
              [87.83782149300009, 49.02041982000007],
              [87.85694177200008, 49.01561391300005],
              [87.87223799700013, 49.004090068000025],
              [87.87259973200014, 48.968019918000024],
              [87.83585778800006, 48.9459024050001],
              [87.7568961990001, 48.92037424700008],
              [87.74361535700007, 48.90518137700006],
              [87.73570886300013, 48.88673289000003],
              [87.73787927300003, 48.86936960900003],
              [87.75472579000012, 48.85727732300005],
              [87.77673995000009, 48.851179505000076],
              [87.78748864800014, 48.84658030200002],
              [87.79606693600005, 48.83975901300006],
              [87.80051110900007, 48.830302226000086],
              [87.8021647540001, 48.80957997700007],
              [87.80588545800003, 48.800588278000035],
              [87.82107832900004, 48.7882892870001],
              [87.84169722500013, 48.77934926400006],
              [87.90758467600006, 48.758833720000084],
              [87.95243982000005, 48.761107483],
              [87.97548750900012, 48.755991516],
              [88.03377852400013, 48.729119772],
              [88.05941003400011, 48.70808746400009],
              [88.06385420800012, 48.68261098200007],
              [88.05501753800007, 48.67341257800008],
              [88.01016239400013, 48.653413799000035],
              [88.00339278200005, 48.64599823000002],
              [87.99781172700006, 48.63517201800009],
              [87.98964685000004, 48.624164937],
              [87.97548750900012, 48.61651682600002],
              [87.94282800400003, 48.599489441000074],
              [87.95181970200008, 48.5752015180001],
              [87.98303226800004, 48.55233469700006],
              [88.01662194900007, 48.53980316200007],
              [88.02830082200006, 48.539622294000125],
              [88.05196862800005, 48.543187968],
              [88.06251062000013, 48.542877910000115],
              [88.07181237900005, 48.5387954720001],
              [88.08824548300004, 48.52608306900005],
              [88.11573734600012, 48.51649709100003],
              [88.14829349800004, 48.49936635300007],
              [88.16596683800003, 48.49373362200005],
              [88.18348514900003, 48.49275177],
              [88.21784997600014, 48.494999695],
              [88.23562666800007, 48.493191020000026],
              [88.30487308800008, 48.46900645000004],
              [88.33210656800009, 48.45399444600007],
              [88.38342126500004, 48.40867421500003],
              [88.4167008880001, 48.39410146100009],
              [88.43964522400012, 48.39371388800008],
              [88.45912723800012, 48.398132223000076],
              [88.47912601700006, 48.400147604000026],
              [88.50269047100005, 48.392551168000054],
              [88.56511560100012, 48.34299347000008],
              [88.57297041800012, 48.325320130000094],
              [88.5587594000001, 48.288087261000086],
              [88.56123986800003, 48.268269349],
              [88.56883630400011, 48.24920074500001],
              [88.57348718300005, 48.229718730000016],
              [88.58077356000007, 48.21199371400009],
              [88.59622481300005, 48.197679342000114],
              [88.63580896000008, 48.17584604900007],
              [88.65544600500004, 48.17116933200002],
              [88.68066410300008, 48.173029683000024],
              [88.70918949400004, 48.16636342400001],
              [88.7753353270001, 48.120552267000065],
              [88.8054110110001, 48.105953675000094],
              [88.83145593300009, 48.10515269000008],
              [88.88928186100009, 48.11091461200003],
              [88.91682539900006, 48.105953675000094],
              [88.9323283280001, 48.09696197500004],
              [89.04555139200005, 47.9929889940001],
              [89.04580977400008, 47.9929889940001],
              [89.04591312600013, 47.99288564100006],
              [89.07469690000005, 47.98425567600002],
              [89.16714603700007, 47.983997295000066],
              [89.21871911700009, 47.97696930000005],
              [89.24398889200006, 47.98022491500002],
              [89.26858687400005, 47.993144023000056],
              [89.28569177200006, 48.00559804300012],
              [89.33426761900006, 48.0323664350001],
              [89.35426639900004, 48.03877431300005],
              [89.36920088700009, 48.038154195000075],
              [89.40919844600006, 48.023116354000095],
              [89.42542484500007, 48.02164357600007],
              [89.47534428000012, 48.022961325000054],
              [89.50366296400011, 48.02998931900005],
              [89.54180017100009, 48.031022848000035],
              [89.57187585500003, 48.02045501700006],
              [89.57621667500013, 47.99288564100006],
              [89.57564823400008, 47.97603912400008],
              [89.58324467000006, 47.962034811000095],
              [89.59657718900007, 47.95257802400003],
              [89.61342370600005, 47.94958079100009],
              [89.62737634300004, 47.94394806000007],
              [89.63616133700003, 47.92958201100008],
              [89.64391280100011, 47.912761333],
              [89.65528161700013, 47.89981638600007],
              [89.67202478100006, 47.89408030200012],
              [89.70726810700012, 47.889041851000044],
              [89.72339115400013, 47.878163961],
              [89.73114261900014, 47.86475392700005],
              [89.7402376710001, 47.836151021],
              [89.75129642700011, 47.82431711900007],
              [89.78354252100007, 47.81850352],
              [89.88906579600012, 47.82431711900007],
              [89.92136356600008, 47.83209442100009],
              [89.93443770300007, 47.84426422200009],
              [89.93764164300012, 47.85754506400009],
              [89.93903690700012, 47.8708517460001],
              [89.9466850180001, 47.883176575000064],
              [89.96316980000006, 47.88865427700004],
              [90.00249556500006, 47.880386048],
              [90.04461185800011, 47.87976593100005],
              [90.05985640500012, 47.868810527000065],
              [90.06435225400003, 47.85062042200012],
              [90.05598067200009, 47.82891632100002],
              [90.05215661700004, 47.81070037900007],
              [90.05877119900003, 47.78951304100012],
              [90.07065677900005, 47.76985015900006],
              [90.08285241700008, 47.75610422800004],
              [90.11995609500008, 47.73013682100007],
              [90.16341597500008, 47.71000885000011],
              [90.20971805800013, 47.69574615600003],
              [90.30211552000003, 47.67851206500005],
              [90.32350956200008, 47.67016632100008],
              [90.34480025200003, 47.65864247700004],
              [90.34955448400007, 47.6477904260001],
              [90.33746219900007, 47.63699005100007],
              [90.32743697200004, 47.62303741500007],
              [90.33849572800005, 47.60278025400008],
              [90.35203495300004, 47.58831085200005],
              [90.38159387300004, 47.53839141900009],
              [90.3946163330001, 47.524671326000046],
              [90.42727583800007, 47.50655873600003],
              [90.44122847500006, 47.49304535000006],
              [90.44360559100011, 47.462788798000034],
              [90.44174523900011, 47.430542705000065],
              [90.44815311700012, 47.40403269500008],
              [90.4752315670001, 47.39108774900005],
              [90.48722050000003, 47.378194479000044],
              [90.49001102800008, 47.361838888000094],
              [90.48556685400007, 47.34491485600002],
              [90.4752315670001, 47.33029042600005],
              [90.46851363200005, 47.32352081300009],
              [90.4663432210001, 47.31633778900006],
              [90.46872033700004, 47.30892222100003],
              [90.71211633400003, 47.0147024540001],
              [90.74239872300006, 46.99186147100009],
              [90.7818795170001, 46.98633209200007],
              [90.80554732300004, 46.98684885700003],
              [90.82818160000011, 46.98230133100007],
              [90.8494722910001, 46.973206279000024],
              [90.86983280400011, 46.96033884700002],
              [90.88512902800005, 46.94473256400009],
              [90.89370731600008, 46.92817026800007],
              [90.90032190000011, 46.910677795000126],
              [90.91014042200004, 46.89238433800007],
              [90.91768518100008, 46.88540802000007],
              [90.92585005700005, 46.88065378900008],
              [90.9327746990001, 46.87478851400009],
              [90.9364954020001, 46.864427389000056],
              [90.93442834500007, 46.856830953],
              [90.92274947100009, 46.84158640600005],
              [90.91995894400003, 46.83362823500009],
              [90.92533329300011, 46.81313853000002],
              [90.93938928200009, 46.79884999700003],
              [90.97514937400013, 46.774148661000126],
              [91.00481164500007, 46.74042979000008],
              [91.01556034300012, 46.70319692000005],
              [91.01429189300012, 46.689843915000026],
              [91.01173628700008, 46.66294097900003],
              [90.99809371000003, 46.62025624700003],
              [90.99592329900008, 46.59462473600006],
              [91.01132287600007, 46.58532297800012],
              [91.03251021300008, 46.57992279100007],
              [91.04749637900005, 46.56640940400008],
              [91.04532596900009, 46.55108734100013],
              [91.03561079900004, 46.529073181000044],
              [91.01411340300012, 46.49318390000009],
              [91.00140100200014, 46.47504547100006],
              [90.9861047770001, 46.43525461900005],
              [90.97514937400013, 46.41654775000008],
              [90.93577193200014, 46.343864848000024],
              [90.90600630700004, 46.3173031620001],
              [90.89618778500005, 46.30203277600005],
              [90.89918501800008, 46.28167226200013],
              [90.94879439300007, 46.168294170000124],
              [90.97514937400013, 46.140543925000074],
              [90.99592329900008, 46.113723857000096],
              [91.00543176300005, 46.068093567000076],
              [91.00243452900003, 46.02184316000002],
              [90.98620813000014, 45.99311106400002],
              [90.97514937400013, 45.98732330400004],
              [90.91923547300013, 45.95006459600002],
              [90.71077274600009, 45.75219553700005],
              [90.69661340400006, 45.73002634700005],
              [90.65113814300008, 45.493141581000074],
              [90.67232548100003, 45.47567494800002],
              [90.73795454900005, 45.44172353100002],
              [90.75325077400004, 45.420949606000065],
              [90.76255253200009, 45.391597392000094],
              [90.77805546000008, 45.36529408800003],
              [90.79045780500013, 45.337698873000036],
              [90.79097456900007, 45.30431589800007],
              [90.79655562400012, 45.29284373000006],
              [90.83717329900003, 45.28002797500007],
              [90.85443322800012, 45.27062286400012],
              [90.86662886600004, 45.25356964200007],
              [90.86590539600013, 45.2425625610001],
              [90.86032434100014, 45.23165883500003],
              [90.85763716600007, 45.21507069900012],
              [90.87324344900003, 45.18618357400008],
              [90.9054895430001, 45.18597686800011],
              [90.97514937400013, 45.214863994000055],
              [91.01132287600007, 45.21894643200007],
              [91.0567981370001, 45.2175511680001],
              [91.10134322100004, 45.21067820300003],
              [91.13503625500005, 45.19786244700005],
              [91.14774865700014, 45.187217103000066],
              [91.1697628170001, 45.16354929600003],
              [91.18433557100008, 45.15383412700008],
              [91.24913781800007, 45.129701233000034],
              [91.34670292200008, 45.113733216000085],
              [91.3665466710001, 45.114249980000025],
              [91.38359989500009, 45.12422353100003],
              [91.3997229410001, 45.13688425700006],
              [91.41687951700004, 45.14566925100006],
              [91.43848026500012, 45.146134339000085],
              [91.45605025300006, 45.13745269800005],
              [91.52178267400006, 45.07745636100013],
              [91.53397831200004, 45.071100159000096],
              [91.5432800700001, 45.071823629],
              [91.55227176900013, 45.07533762600006],
              [91.56395064300011, 45.07714630100004],
              [91.66296268700012, 45.05952463800007],
              [91.68363326000014, 45.061178284],
              [91.72466434700004, 45.07073842400011],
              [91.74698856600003, 45.072443746000076],
              [91.91907108600009, 45.06557078100009],
              [91.97508833800003, 45.0733739220001],
              [92.00940149000013, 45.07621612600009],
              [92.04299117000005, 45.074820862000095],
              [92.07565067500013, 45.06887807300011],
              [92.10841353400014, 45.05818105100009],
              [92.19367964700012, 45.01451446500003],
              [92.21889774600004, 45.010121969000025],
              [92.26788700400004, 45.01952708000009],
              [92.28535363800012, 45.01952708000009],
              [92.33103560400014, 45.00784820600002],
              [92.34736535700006, 45.00764150000005],
              [92.3964579680001, 45.013119202000055],
              [92.41382124900014, 45.01125885000003],
              [92.45898645000011, 44.9979263310001],
              [92.47510949800005, 44.9974612430001],
              [92.57205448400003, 45.01301584900001],
              [92.63851037600006, 45.01559967100012],
              [92.75271529200012, 45.0379755660001],
              [92.79891402200013, 45.0331696570001],
              [92.81421024600013, 45.033893128],
              [92.84759322200006, 45.0391124480001],
              [92.86102909400012, 45.037872213000085],
              [92.91621952400004, 45.01456614200005],
              [92.94505497300014, 45.00583282500007],
              [92.97492395000006, 45.00469594300007],
              [92.99445764100005, 45.008364970000045],
              [93.01388798100004, 45.009295146000014],
              [93.03311161400006, 45.00764150000005],
              [93.05243859900003, 45.00345570900002],
              [93.07594097800006, 45.00519247600003],
              [93.13915165200007, 45.009863587000055],
              [93.1657133380001, 45.00764150000005],
              [93.24415816300012, 44.98154490200007],
              [93.2689628500001, 44.98009796200007],
              [93.31722863800007, 44.98588572200005],
              [93.34099979700005, 44.984852194000055],
              [93.36136031100006, 44.978392640000024],
              [93.39991093000003, 44.96056427100008],
              [93.42058150300005, 44.955086568000084],
              [93.52527795500004, 44.95126251300003],
              [93.68826542200009, 44.89105946900007],
              [93.71400028500011, 44.874574687000106],
              [93.87450728300007, 44.71422271800013],
              [93.92742395000005, 44.672933248000035],
              [93.97506962100005, 44.659962464],
              [94.05857873600013, 44.65128082300005],
              [94.1037439370001, 44.651642558000034],
              [94.14901249200005, 44.66719716400006],
              [94.16534224500003, 44.66585357700008],
              [94.18187870300011, 44.66084096300004],
              [94.19500451700009, 44.65432973300007],
              [94.27748010200008, 44.58957916300007],
              [94.29546350100009, 44.57138905800012],
              [94.32192183400008, 44.52803253200004],
              [94.33845829300003, 44.51211619100012],
              [94.36636356600013, 44.50431305000011],
              [94.43013228400008, 44.504468079000034],
              [94.46031132000007, 44.49330596900002],
              [94.58805546100007, 44.43610015900008],
              [94.65719852700005, 44.388816224000024],
              [94.67259810400003, 44.373778382000026],
              [94.68396692000005, 44.356621806000064],
              [94.69822961400013, 44.343495992],
              [94.72086389200007, 44.33579620400012],
              [94.90576216700009, 44.294248352000025],
              [94.99381880800013, 44.259418437000065],
              [95.03681359900003, 44.25497426400007],
              [95.37942834500006, 44.2871170050001],
              [95.39772180200009, 44.280502422],
              [95.38924686800004, 44.26076202400013],
              [95.35968794800004, 44.231823222000074],
              [95.34749231000012, 44.21492502900007],
              [95.34056766800012, 44.18753652000002],
              [95.32713179500007, 44.16831288700011],
              [95.3226876220001, 44.15823598200008],
              [95.32144738800014, 44.14841746000009],
              [95.3282686770001, 44.09823964500008],
              [95.31876021300013, 44.040723776000036],
              [95.31896691900005, 44.01710764600004],
              [95.32754520700007, 44.0066690070001],
              [95.42273319500003, 43.9886339320001],
              [95.47492639200004, 43.986618551000035],
              [95.51027307200013, 43.979125468000106],
              [95.53528446500013, 43.957679748000075],
              [95.5892346600001, 43.86949391800003],
              [95.69248417200004, 43.63054209400009],
              [95.83283736200008, 43.40890187600006],
              [95.84141564900011, 43.37252166800009],
              [95.84544641200011, 43.32647796600007],
              [95.85495487500009, 43.28454254200007],
              [95.87438521400009, 43.247102966000014],
              [95.90849165900005, 43.21454681400006],
              [96.29430790200007, 42.93327199400004],
              [96.31869917800009, 42.910069275000026],
              [96.33068811000004, 42.88970876100011],
              [96.33719934100003, 42.86648020500009],
              [96.35063521400008, 42.740906474000084],
              [96.35776656100012, 42.72449920700002],
              [96.36633990100006, 42.722922619000045],
              [96.37926395700003, 42.72054596000005],
              [96.47465865100008, 42.732147319],
              [96.83266919250008, 42.75960440550007],
              [97.19067973400013, 42.78706149200006],
              [97.19327111900003, 42.78726023400007],
              [97.52163164700005, 42.755152400000085],
              [97.84999217500012, 42.72304456600001],
              [98.25611301750013, 42.68333315300008],
              [98.66223386000013, 42.643621740000086],
              [99.06835470250013, 42.603910327000065],
              [99.47447554500013, 42.56419891400007],
              [99.62190342900004, 42.59744260600006],
              [99.97155114800012, 42.6762850950001],
              [100.01697473100006, 42.67651763900007],
              [100.41755320866673, 42.62762312166676],
              [100.81813168633346, 42.578728604333335],
              [101.21871016400007, 42.529834087000026],
              [101.41073978700013, 42.54487192900011],
              [101.52494470200008, 42.53745636000009],
              [101.63759932500005, 42.51544220000001],
              [101.73537113500004, 42.461156108000054],
              [101.88647302300012, 42.27801483200001],
              [101.97421960500003, 42.20788991400006],
              [102.03416426600012, 42.184609681000026],
              [102.38060306833341, 42.12457889200003],
              [102.72704187066677, 42.064548103],
              [103.07348067300012, 42.0045173140001],
              [103.10438317900014, 41.99363942500004],
              [103.10479659100014, 41.993587748000024],
              [103.3981120205001, 41.87641143800009],
              [103.6914274500001, 41.75923512800004],
              [103.72098636900006, 41.75556610100004],
              [104.11088505050014, 41.813081970000084],
              [104.50078373200012, 41.8705978390001],
              [104.49799320500006, 41.66577830000004],
              [104.50491784700006, 41.65655405700004],
              [104.60124271700005, 41.64544362400004],
              [104.8923360600001, 41.64477183000004],
              [104.91367842700004, 41.63833811500008],
              [104.93543420400005, 41.622421774000074],
              [104.97382979400004, 41.586144918000016],
              [105.01480920400007, 41.596144308000035],
              [105.20089603700006, 41.743473816000076],
              [105.2182593180001, 41.748434754000115],
              [105.27448327700006, 41.75546274900002],
              [105.32595300400004, 41.77670176200009],
              [105.3445565190001, 41.781120097],
              [105.35819909700007, 41.78584849100007],
              [105.40274418100012, 41.811531678000065],
              [105.47385095200013, 41.840341289],
              [105.86860721900007, 41.993484395000095],
              [106.31821801850009, 42.14005167650008],
              [106.76782881800005, 42.286618958000076],
              [107.19511260100012, 42.337452507000066],
              [107.62239638400007, 42.38828605600007],
              [108.04968016700008, 42.4391196050001],
              [108.17735518400008, 42.45430898100001],
              [108.23476770000008, 42.450071513000054],
              [108.3197754310001, 42.43255320200008],
              [108.53645471300007, 42.43511118600007],
              [108.7968522540001, 42.398369243],
              [108.82852990800012, 42.400048727000055],
              [108.86268803000007, 42.40885955900005],
              [108.96128666200008, 42.44753936800005],
              [108.99446293200009, 42.44952891100009],
              [109.25341353400006, 42.42593862000008],
              [109.28028527900005, 42.428315735000055],
              [109.32855106700009, 42.440485535000036],
              [109.48513065600008, 42.44929636700003],
              [109.49009159400003, 42.451285909],
              [109.49381229700009, 42.45521331800005],
              [109.50001346900007, 42.463326518000045],
              [109.50487105400009, 42.4649284880001],
              [109.51034875500005, 42.46474762000004],
              [109.51830692600004, 42.46733144200003],
              [109.66734175700003, 42.54898020400013],
              [109.91270145700008, 42.62882029300003],
              [109.98732222500007, 42.6364684040001],
              [110.04271936100002, 42.635951640000044],
              [110.06018599400005, 42.63835459500011],
              [110.07486210100006, 42.64352223800002],
              [110.0842672120001, 42.650059306000074],
              [110.09315555900008, 42.65786244700011],
              [110.10566125500003, 42.66667327900011],
              [110.13987105300009, 42.68261545800003],
              [110.4067281500001, 42.7686050410001],
              [110.42481490100005, 42.78524485300004],
              [110.44941288300004, 42.83733469600007],
              [110.47339074700011, 42.85490468400006],
              [110.56671838400007, 42.91056020200007],
              [110.60816288300003, 42.944666647000034],
              [110.64102909400009, 42.98779062900006],
              [110.66573042800007, 43.03740000500004],
              [110.68009647600007, 43.05765716600003],
              [110.79698856600004, 43.14891774500005],
              [110.93372440600012, 43.28777231900007],
              [110.97341190700007, 43.31560007800003],
              [111.09609175600013, 43.3666563930001],
              [111.33855757600008, 43.43817657500004],
              [111.40139611900008, 43.475512797000064],
              [111.42868127500009, 43.48393605600005],
              [111.5350313720001, 43.4907315060001],
              [111.56769087700008, 43.50253957200003],
              [111.59724979700007, 43.52339101200009],
              [111.75382938700005, 43.66320160000008],
              [111.77263960800013, 43.669299419000126],
              [111.84581343600013, 43.66692230300008],
              [111.8932524010001, 43.68260610000003],
              [111.91040897700009, 43.684983216],
              [111.93335331300011, 43.696636251000044],
              [111.94513553900003, 43.72386973100005],
              [111.94792606700008, 43.75696848600005],
              [111.94430871600008, 43.78637237600013],
              [111.93056278500006, 43.820142924000024],
              [111.83878544100003, 43.938792013000054],
              [111.81139693300008, 43.96429433200008],
              [111.78070113100011, 43.986205139000035],
              [111.66814986200006, 44.04134389200003],
              [111.63445682800011, 44.06594187500009],
              [111.54381636600004, 44.15673736600006],
              [111.51942508900004, 44.1885700480001],
              [111.50371545400009, 44.22572540300011],
              [111.49813440000008, 44.26443105100013],
              [111.4905896410001, 44.28262115500006],
              [111.47322635900008, 44.29884755400006],
              [111.41059452300004, 44.32608103500009],
              [111.39643518100013, 44.346596578000046],
              [111.39705529800011, 44.38736928300004],
              [111.4063570560001, 44.41646311500004],
              [111.42413374800003, 44.44803741500003],
              [111.44687137900013, 44.475891012],
              [111.47084924300003, 44.49330596900002],
              [111.47322635900008, 44.495321350000054],
              [111.48376835200003, 44.50643178300008],
              [111.50898645100011, 44.546584371000094],
              [111.53017378700008, 44.57061391200001],
              [111.53823531100005, 44.58342966800011],
              [111.54381636600004, 44.60125803600003],
              [111.54443648300003, 44.61810455300012],
              [111.54009566300005, 44.652210998000086],
              [111.54102583800011, 44.66823069300004],
              [111.55136112500003, 44.693190410000014],
              [111.73853316300006, 44.96630035400004],
              [111.76065067600007, 44.98929636700008],
              [111.78648889200008, 45.0085716760001],
              [111.84333296700004, 45.03952585900002],
              [111.86317671800003, 45.04629547100005],
              [111.90627486200003, 45.054150289000106],
              [111.92673872900008, 45.06091990200004],
              [111.9385209560001, 45.068981426000036],
              [111.94792606700008, 45.07771474200008],
              [111.95826135200008, 45.08453603100004],
              [111.9733508710001, 45.08701650000002],
              [111.98463721200005, 45.08715413800006],
              [112.01148807900006, 45.087481588000045],
              [112.10760624200014, 45.0673794560001],
              [112.37963098200015, 45.07073842400011],
              [112.412807251, 45.06603586900003],
              [112.44133264200002, 45.05239329000001],
              [112.52391158100016, 44.99327545200005],
              [112.56452925600001, 44.94392445900006],
              [112.58602665200016, 44.923822327],
              [112.6142419840001, 44.90883616100011],
              [112.74849735600009, 44.865272930000074],
              [112.97318648300012, 44.82124460900012],
              [113.0169047440001, 44.82108958000008],
              [113.10485803200004, 44.794372864000096],
              [113.47320764200009, 44.770705058],
              [113.48891727800009, 44.76626088500008],
              [113.5171326090001, 44.74951772100003],
              [113.5324288330001, 44.745280253000075],
              [113.60477583900007, 44.73969919900007],
              [113.63505822800005, 44.74626210500004],
              [113.67247196500006, 44.7681729130001],
              [113.73562056500009, 44.815921936000066],
              [113.83762984200013, 44.8679084270001],
              [113.88930627500014, 44.90826772100006],
              [113.9138009030001, 44.91545074500003],
              [113.97312544800002, 44.91932647700007],
              [114.01705041600007, 44.927284648000025],
              [114.05529097500005, 44.94056549100013],
              [114.08929406800007, 44.961752828],
              [114.12040327900007, 44.99322377600005],
              [114.13921350100014, 45.019165344],
              [114.14934208200009, 45.030069072000046],
              [114.1636047770001, 45.04014597600009],
              [114.21176721200004, 45.06216013600006],
              [114.41888635300006, 45.20147979700003],
              [114.47304325400006, 45.259202373],
              [114.50229211400011, 45.30323069300006],
              [114.51169722500003, 45.32550323500003],
              [114.51944869000016, 45.370926820000065],
              [114.52378951000003, 45.38028025400011],
              [114.53371138500006, 45.38549957300002],
              [114.669310344, 45.42280995800006],
              [114.70331343600003, 45.42715077700005],
              [114.73731652900005, 45.425032044000076],
              [114.90526493300001, 45.377748108000034],
              [114.93885461400009, 45.37376902300004],
              [115.12633671100008, 45.394439596000055],
              [115.33727990800008, 45.394697978000025],
              [115.47298221900013, 45.41278472900005],
              [115.63783003800006, 45.44435903000003],
              [115.66738895700007, 45.4542809040001],
              [115.69240035000007, 45.468957011],
              [115.76733117700013, 45.53014190700013],
              [115.98282190000009, 45.65964304600003],
              [116.00214888500005, 45.67555938800005],
              [116.0119674070001, 45.678556620000066],
              [116.06333378100015, 45.673337301000046],
              [116.07873335800002, 45.67338897800006],
              [116.09485640500009, 45.676541240000105],
              [116.14394901600014, 45.69462799100002],
              [116.16989058400009, 45.70909739200006],
              [116.23035201000005, 45.76976552300003],
              [116.25164270100004, 45.80325185200003],
              [116.24213423700013, 45.82691965800005],
              [116.22094690000006, 45.84976064100006],
              [116.20709761600011, 45.88086985300002],
              [116.21319543500016, 45.908155009000026],
              [116.3571659750001, 46.10555898100007],
              [116.5251143800001, 46.22679189100002],
              [116.53958378100003, 46.241209616000035],
              [116.5482654220001, 46.25929636700003],
              [116.56831587800008, 46.29087066600003],
              [116.58195926300004, 46.29801243800004],
              [116.60355920500001, 46.30931915300003],
              [116.64521040900007, 46.31846588100002],
              [116.70732548100005, 46.324227804000074],
              [116.72200158700002, 46.3286978150001],
              [116.78484012900009, 46.365904847000095],
              [116.80458052600017, 46.38290639300003],
              [116.81460575400007, 46.38673044800008],
              [116.83165897700007, 46.38636871400006],
              [116.95785282500009, 46.366421611000064],
              [117.30170780500009, 46.35014353500013],
              [117.33746789500003, 46.357274882000056],
              [117.3530741780001, 46.37949574800011],
              [117.35751835100007, 46.448406271000025],
              [117.36919722500016, 46.47569142700003],
              [117.40547408100014, 46.51080556300009],
              [117.41250207600001, 46.52462900900004],
              [117.41012496000008, 46.53979604100006],
              [117.39379520700004, 46.57137034100005],
              [117.4728601490001, 46.584677022000065],
              [117.49177372200006, 46.57909596800003],
              [117.50179895100007, 46.57726145500003],
              [117.51006718000014, 46.57847585100008],
              [117.55626591000009, 46.601601055000046],
              [117.5681514900001, 46.60353892000008],
              [117.582000773, 46.59198923800004],
              [117.6075289310001, 46.550544739000074],
              [117.62520227100003, 46.53566192700005],
              [117.67336470600003, 46.5160248830001],
              [117.69620568900012, 46.512252503000084],
              [117.79759484900006, 46.52026235000004],
              [117.81702518700001, 46.527471212000094],
              [117.83273482300001, 46.54279327400006],
              [117.85929650900005, 46.58028452600006],
              [117.8783134360001, 46.59638173500004],
              [117.90063765500014, 46.60759552100008],
              [117.92378869700013, 46.61519195600003],
              [117.97277795400015, 46.62340850900007],
              [118.00554081200005, 46.62697418200004],
              [118.08388228300015, 46.66826365200005],
              [118.10196903500008, 46.67306956000006],
              [118.1555058190001, 46.67456817600008],
              [118.16904504400009, 46.67849558500005],
              [118.20604537000014, 46.70092315700005],
              [118.2382914640001, 46.71539255800006],
              [118.26898726400015, 46.72293731700002],
              [118.3008199460001, 46.72484934500004],
              [118.3355465090001, 46.72216217100002],
              [118.37120324800003, 46.713971457000085],
              [118.43517867100002, 46.691156311000086],
              [118.47279911300012, 46.685678610000096],
              [118.55196740800005, 46.68575612400012],
              [118.567728719, 46.68973521],
              [118.59516890500004, 46.70304189100001],
              [118.60937992400005, 46.705780742000044],
              [118.64741377800016, 46.697719218000074],
              [118.68462080900008, 46.68345652300009],
              [118.7200708420001, 46.67673858700006],
              [118.75381555200016, 46.691156311000086],
              [118.79221114100011, 46.737768453000044],
              [118.81624068200006, 46.75818064400009],
              [118.84652307200008, 46.76549285900008],
              [118.86745202700007, 46.75833567300005],
              [118.87520349100015, 46.74396962500005],
              [118.87964766500016, 46.7273298140001],
              [118.89055139200002, 46.71353220600007],
              [118.90708785000004, 46.70939809200003],
              [118.92207401600001, 46.715495911000104],
              [118.94703373300007, 46.73714833700008],
              [118.96723921700004, 46.74045562800008],
              [118.98491255800008, 46.72453928700004],
              [119.01405806500009, 46.68330149400005],
              [119.036950724, 46.66872874000008],
              [119.06237552900012, 46.660951437000065],
              [119.31693363500005, 46.61167795800007],
              [119.36328739400005, 46.61304738400007],
              [119.45294600400013, 46.627490947000084],
              [119.50126346900004, 46.62800771100002],
              [119.57588423700014, 46.61917104100003],
              [119.60218754100009, 46.61968780600007],
              [119.62347823100004, 46.61632883700004],
              [119.65877323500007, 46.596175029000065],
              [119.68011560100007, 46.591627503000055],
              [119.69778894000007, 46.59488311800003],
              [119.7196480720001, 46.602712098000055],
              [119.74026696800001, 46.61325409000001],
              [119.75442631000016, 46.62439036100004],
              [119.770032593, 46.64356231700005],
              [119.78222823100009, 46.65562876400013],
              [119.79628422100012, 46.6588327030001],
              [119.81726485200011, 46.651623841000045],
              [119.8344214280001, 46.65095204700005],
              [119.85442020700009, 46.65965952600003],
              [119.87266198700007, 46.6732245890001],
              [119.890335327, 46.69477366100007],
              [119.89798343900014, 46.701646627000045],
              [119.90418461200011, 46.708933004000116],
              [119.90702681500011, 46.71831227600005],
              [119.9033577890001, 46.726399639000064],
              [119.8871830650001, 46.744279683000016],
              [119.88310062700009, 46.7530130010001],
              [119.88589115400015, 46.77006622300003],
              [119.89865523300006, 46.80205393500002],
              [119.89798343900014, 46.82437815400009],
              [119.89891361500008, 46.831251119000044],
              [119.90211755400009, 46.837348938],
              [119.9028927010001, 46.84241322800007],
              [119.89679488200011, 46.84646982800008],
              [119.89162723900012, 46.84848521000002],
              [119.88682133000009, 46.851456604000035],
              [119.88310062700009, 46.85543569000002],
              [119.88124027600009, 46.8605516570001],
              [119.88144698100007, 46.87285064700005],
              [119.88496097900008, 46.88091217100005],
              [119.8904386800001, 46.88825022400003],
              [119.89643314600005, 46.898585510000046],
              [119.89291914900008, 46.90551015200002],
              [119.87922489400006, 46.908145651000055],
              [119.86294681800013, 46.909024150000064],
              [119.85230147400006, 46.91072947200006],
              [119.84351648000006, 46.918170878000055],
              [119.83969242400008, 46.9256639610001],
              [119.83685022000014, 46.93357045500004],
              [119.83168257700004, 46.94214874300009],
              [119.81741988100015, 46.954912822000054],
              [119.78429528800007, 46.978322246000104],
              [119.7701359460001, 46.9929983520001],
              [119.76729374300015, 46.998114319000095],
              [119.7649683030001, 47.003824565000045],
              [119.7617126880001, 47.01547760000001],
              [119.76052412900009, 47.07459543900008],
              [119.75396122200004, 47.094439189000056],
              [119.7288981530001, 47.12864898700006],
              [119.69995935100013, 47.15952565500005],
              [119.6294210210001, 47.21608551100012],
              [119.58735640500004, 47.238358053000056],
              [119.52508630400013, 47.25081207400005],
              [119.51299401900013, 47.262671815000076],
              [119.50389896700005, 47.27918243500007],
              [119.49066980000009, 47.29716583200003],
              [119.47599369300008, 47.30920644200002],
              [119.32065433800005, 47.407029928],
              [119.28189701300005, 47.41485890700001],
              [119.2888216550001, 47.4291474410001],
              [119.31259281500002, 47.452246807000066],
              [119.31776045700008, 47.46211700400006],
              [119.3101123460001, 47.47609548000007],
              [119.29104374300005, 47.48438954700002],
              [119.25104618300008, 47.492941997000045],
              [119.15756351700009, 47.51766917000005],
              [119.13389571200003, 47.527539368000035],
              [119.12211348500006, 47.53895985900003],
              [119.11653243, 47.55603892000006],
              [119.1042334390001, 47.627739970000064],
              [119.09694706300002, 47.646601868000076],
              [119.08345951400014, 47.66156219500006],
              [119.05958500200006, 47.67347361300007],
              [118.97261356700011, 47.695126038000055],
              [118.76740645400008, 47.75615590400004],
              [118.71330122900008, 47.793621318000035],
              [118.60524580900011, 47.91467336100003],
              [118.5422522390001, 47.966246440000035],
              [118.47279911300012, 47.98944915800003],
              [118.28004602100015, 47.998130799000094],
              [118.25431115800006, 48.00285919200009],
              [118.20625207600011, 48.02329722100005],
              [118.18248091600003, 48.02820648200007],
              [118.12253625600016, 48.027508851000064],
              [118.06403853400008, 48.01957651800002],
              [117.9971692310001, 47.9999911500001],
              [117.97277795400015, 47.99789825500004],
              [117.815164836, 48.00482289600002],
              [117.76689904900002, 47.993144023000056],
              [117.74168095000005, 47.97758941700003],
              [117.52722375500002, 47.78648997000009],
              [117.4728601490001, 47.75724111000004],
              [117.43647994000003, 47.730498556000086],
              [117.39989302600009, 47.685669251],
              [117.360825643, 47.65086517400003],
              [117.31710738200002, 47.654069112000016],
              [117.06968062300007, 47.810157776000025],
              [117.04735640500013, 47.819459534000046],
              [116.97283899000007, 47.83764963800009],
              [116.8532597250001, 47.87211781800006],
              [116.82204716000001, 47.876303609],
              [116.75166386000006, 47.8741331990001],
              [116.49968957600004, 47.83635772800004],
              [116.42889286300016, 47.835143331000026],
              [116.24389123600008, 47.86289357500006],
              [116.18156945800007, 47.84958689400004],
              [116.08431441300007, 47.80692799900005],
              [115.97290002500006, 47.709052837000044],
              [115.91450565600013, 47.68391225200013],
              [115.8527006430001, 47.7055646780001],
              [115.59989953600012, 47.88741404300002],
              [115.57571496600008, 47.90973826100007],
              [115.56186568200008, 47.93319936200005],
              [115.54584598900016, 47.9929889940001],
              [115.51453007100014, 48.12210256000007],
              [115.51422001100008, 48.131636862000065],
              [115.536440878, 48.14915517200002],
              [115.77084517400016, 48.22408599900008],
              [115.7999906820001, 48.242327779000036],
              [115.80929244000004, 48.27395375600004],
              [115.78655481000015, 48.47301137400002],
              [115.78655481000015, 48.49301015300007],
              [115.7912056890001, 48.51383575400011],
              [115.8004040940001, 48.53037221300009],
              [116.02819380800008, 48.76746368500004],
              [116.0480375570001, 48.79976145500011],
              [116.04762414600009, 48.81769317600008],
              [116.03356815600006, 48.8523680630001],
              [116.0378056240001, 48.87014475500003],
              [116.24776696850012, 49.18146942150007],
              [116.45772831300008, 49.492794088000025],
              [116.47292118300004, 49.51646189400013],
              [116.68427779200016, 49.8232648730001],
              [116.7223116460001, 49.80166412400003],
              [117.05758833800007, 49.67288645400005],
              [117.25292525200007, 49.62245025600005],
              [117.4728601490001, 49.614285381000016],
              [117.7588375250001, 49.51274119100002],
              [117.76886275200008, 49.51098419200004],
              [117.7774410400001, 49.51284454400006],
              [117.79501102700016, 49.51914906800006],
              [117.80358931500007, 49.51889068600009],
              [117.8157849530001, 49.51196604500002],
              [117.82260624200006, 49.51026072200004],
              [117.831908, 49.50979563400004],
              [117.83686893800012, 49.50902048800002],
              [117.84089969900003, 49.50964060500009],
              [117.87376591000015, 49.513206279000045],
              [117.89381636600001, 49.54664093100003],
              [117.90466841700004, 49.552738749000085],
              [117.93071333800003, 49.567311503000056],
              [118.0171163330001, 49.595785217000085],
              [118.054943481, 49.61402699800006],
              [118.07127323400005, 49.62513743200007],
              [118.08915328, 49.64012359700003],
              [118.10641320800005, 49.65180247100001],
              [118.16863163300007, 49.67149119100007],
              [118.18847538300008, 49.68125803700012],
              [118.20821578000005, 49.69541737900006],
              [118.22340865100006, 49.712108867],
              [118.22940311700006, 49.72921376600006],
              [118.24170210800003, 49.72916208900004],
              [118.30516076700007, 49.767092591000036],
              [118.32872522000008, 49.77303538000005],
              [118.35363326000004, 49.776446025000084],
              [118.3729602460001, 49.78631622400006],
              [118.38091841700015, 49.8114826460001],
              [118.39373417100006, 49.8200092580001],
              [118.45584924400009, 49.828639221000046],
              [118.47703658100016, 49.83597727500005],
              [118.48106734300006, 49.84243682900011],
              [118.4864416910001, 49.86067861000005],
              [118.49078251200001, 49.86951528000007],
              [118.4980172120001, 49.87674998000004],
              [118.52127160700002, 49.89406158500013],
              [118.55455122900003, 49.9097712210001],
              [118.57062260000009, 49.92072662400007],
              [118.59997481300007, 49.93095855700007],
              [118.64436486800003, 49.95457468700006],
              [118.67056482000015, 49.96206777000002],
              [118.71293949400007, 49.949458721000084],
              [118.74146488400004, 49.95307607100007],
              [118.79164270000007, 49.96635691400009],
              [118.89137821500003, 49.97932769800009],
              [118.90248864800009, 49.982118226000054],
              [118.9129272880001, 49.987699280000086],
              [118.92377933800003, 49.99162668900006],
              [118.9357682700001, 49.98961130800008],
              [118.94780887900009, 49.985218811],
              [118.9625366620001, 49.982014873000125],
              [118.99044193600008, 49.97932769800009],
              [119.09167606600016, 49.98656239800006],
              [119.18955122900007, 50.007284648000095],
              [119.20851648000013, 50.015139466000036],
              [119.22329594000013, 50.025009664000024],
              [119.25104618300008, 50.04826405800013],
              [119.30132735300003, 50.07978668300008],
              [119.31621016500009, 50.0926541140001],
              [119.32861250800016, 50.10805369100008],
              [119.33775923700006, 50.12412506100004],
              [119.34396040800004, 50.14241851900003],
              [119.34830122900007, 50.18458648800008],
              [119.34726770000009, 50.19507680300002],
              [119.34359867400013, 50.20220815100005],
              [119.33414188600005, 50.21114817400009],
              [119.33155806500014, 50.21734934500007],
              [119.33378015200003, 50.27626047800008],
              [119.33853438300002, 50.294037170000095],
              [119.35041996300009, 50.301478577000026],
              [119.36246057200003, 50.30416575200006],
              [119.365509481, 50.31083201100007],
              [119.36395918900007, 50.319461975000124],
              [119.35662113400008, 50.340752666000085],
              [119.35290043100014, 50.34550689700008],
              [119.33357344600012, 50.349899394],
              [119.31434981300009, 50.35170806900008],
              [119.2507878020001, 50.342509665000065],
              [119.24644698100013, 50.34416331000004],
              [119.23301110900007, 50.352741598000065],
              [119.22370935100002, 50.35610056600008],
              [119.21358077000002, 50.35656565400011],
              [119.1879492600001, 50.3547053030001],
              [119.17534021000012, 50.35610056600008],
              [119.18050785300011, 50.36979482],
              [119.17187789000008, 50.375685934],
              [119.14123376500004, 50.37661611000006],
              [119.13348230000014, 50.381473694000064],
              [119.13756473800004, 50.392532451000065],
              [119.14671146600011, 50.40426300100005],
              [119.15487634300013, 50.411394348],
              [119.16769209900013, 50.414081523000036],
              [119.19843957600006, 50.41309967100007],
              [119.20675948100006, 50.415115051],
              [119.2161645920001, 50.424933573000075],
              [119.24365645400007, 50.44550079300005],
              [119.26122644000014, 50.47924550400005],
              [119.26458540900006, 50.48275950200009],
              [119.26401696800008, 50.48958079000003],
              [119.26236332200006, 50.491957906],
              [119.25915938400016, 50.493249817000034],
              [119.2545085050001, 50.49702219700005],
              [119.25089115500015, 50.50451527900002],
              [119.254405152, 50.509527893000055],
              [119.2606063240001, 50.51407542],
              [119.26458540900006, 50.520018209000014],
              [119.28654789200004, 50.577740784000085],
              [119.28525598200008, 50.58890289400004],
              [119.29357588700015, 50.59923817900004],
              [119.30308435100011, 50.602752177000085],
              [119.31388472600014, 50.60461252900008],
              [119.32613204000006, 50.609986877000054],
              [119.33533044500007, 50.619236960000066],
              [119.34116988100004, 50.62807362900007],
              [119.3489730230001, 50.634688213000075],
              [119.36437260000008, 50.63727203400008],
              [119.37372603400001, 50.642749736000056],
              [119.38307946800006, 50.66662424700006],
              [119.39165775600009, 50.672050273000124],
              [119.40390507000012, 50.673238831000035],
              [119.41775435400007, 50.67628774100008],
              [119.44281742400005, 50.68507273400006],
              [119.4572868250001, 50.6962865200001],
              [119.49666426700003, 50.73705922500007],
              [119.50493249500005, 50.750598450000055],
              [119.51485437100007, 50.79193959600009],
              [119.51407922400006, 50.81338531500002],
              [119.49749108900005, 50.83591624000003],
              [119.51578454600008, 50.84811187800007],
              [119.5279801850001, 50.86676707000002],
              [119.52999556500004, 50.88707590800006],
              [119.5179549560001, 50.90480092400007],
              [119.57319706300012, 50.945832011],
              [119.59402266400008, 50.969551494000044],
              [119.60425459800007, 50.978181458000094],
              [119.68321618700008, 51.01606028300007],
              [119.71019128500012, 51.0385395310001],
              [119.7103979900001, 51.062465719],
              [119.72843306500016, 51.064532776000064],
              [119.74083540900006, 51.07153493200006],
              [119.74827681500005, 51.083394674],
              [119.7507056070001, 51.099982809],
              [119.75463301700012, 51.114297180000065],
              [119.7617126880001, 51.12817230200004],
              [119.76522668500007, 51.14243499800004],
              [119.75814701300015, 51.158015442000064],
              [119.76708703600008, 51.15972076400003],
              [119.77282312100016, 51.16269215900003],
              [119.78543217000009, 51.171658021000056],
              [119.75814701300015, 51.19902069200002],
              [119.76217777600004, 51.21504038500005],
              [119.77230635600012, 51.218476868],
              [119.802433716, 51.21328338600007],
              [119.81499109000009, 51.21589304600009],
              [119.81478438300013, 51.22274017400004],
              [119.8094100350001, 51.232610372000025],
              [119.80594771400007, 51.244005026000124],
              [119.81623132400006, 51.2689905810001],
              [119.81964196800004, 51.274726665000074],
              [119.82884037300005, 51.27971344100003],
              [119.8506478270001, 51.28433848100009],
              [119.860621379, 51.28901519800006],
              [119.88330733200007, 51.31800567700013],
              [119.8918856200001, 51.322553203000055],
              [119.91565677900007, 51.33074391700008],
              [119.91271122300014, 51.34963165300012],
              [119.90015384900005, 51.37025055000002],
              [119.89529626500013, 51.38397064200005],
              [119.943045289, 51.39081777000011],
              [119.95286381100004, 51.39766489700007],
              [119.95684289600007, 51.40451202500013],
              [119.95999515800008, 51.41228932700004],
              [119.9672815350001, 51.42182362900003],
              [119.98273278900007, 51.44215830500006],
              [119.98056237800006, 51.45272613500005],
              [119.97415450100004, 51.46417246500003],
              [119.977203411, 51.48701344900006],
              [119.99218957500005, 51.50326568600006],
              [120.0421606860001, 51.53853485100005],
              [120.05290938400003, 51.55220326800007],
              [120.05352950000008, 51.577033794],
              [120.05673343900008, 51.59638661700008],
              [120.0648983160001, 51.61488678000008],
              [120.08587894700008, 51.64436818500009],
              [120.10045170100005, 51.65994862900003],
              [120.10820316600007, 51.665193787000064],
              [120.12236250900003, 51.66715749100008],
              [120.15378178000003, 51.66397939000002],
              [120.16561568200007, 51.66855275500008],
              [120.18148034700005, 51.682970479000076],
              [120.31930139200011, 51.776039734000065],
              [120.3744401460001, 51.80231720000002],
              [120.40833988500003, 51.82608835900008],
              [120.42756351800006, 51.833658956000036],
              [120.4540218510001, 51.836449484000084],
              [120.46482222500003, 51.84019602500011],
              [120.47148848500007, 51.849006857000106],
              [120.47593265800009, 51.85913543700006],
              [120.4808935960001, 51.86686106400005],
              [120.49314091000008, 51.87572357200007],
              [120.502080933, 51.87724802700008],
              [120.51189945500005, 51.876188660000096],
              [120.52662723800006, 51.87742889400003],
              [120.54114831600009, 51.88298411100003],
              [120.54936486800005, 51.89047719400007],
              [120.55613448100007, 51.89838368800012],
              [120.56631473800013, 51.905334168000095],
              [120.5786137290001, 51.90768544600006],
              [120.62496748900008, 51.905334168000095],
              [120.6476017660001, 51.91101857500006],
              [120.66207116700008, 51.92504872700006],
              [120.683516886, 51.95931020200008],
              [120.7057894290001, 51.979954936000084],
              [120.71090539600004, 51.98832651800005],
              [120.71157718900008, 52.00158152300007],
              [120.707546428, 52.01240773500011],
              [120.70108687400005, 52.02287221300004],
              [120.696384319, 52.034473572000095],
              [120.69731449400001, 52.04871042900005],
              [120.7056344, 52.06103525800002],
              [120.71803674400007, 52.06653879800011],
              [120.73198938100006, 52.07018198700008],
              [120.74506351800011, 52.07666737900006],
              [120.75307336500009, 52.08633087200009],
              [120.76666426600008, 52.1084483850001],
              [120.77916996300007, 52.11759511400008],
              [120.77431237800016, 52.124261374000085],
              [120.77126346900002, 52.13247792600002],
              [120.77126346900002, 52.14097869900003],
              [120.77555261200007, 52.14836842900006],
              [120.7840792240001, 52.158006083000075],
              [120.78320072500009, 52.16198516900003],
              [120.77741296400006, 52.164956564000065],
              [120.77178023300007, 52.17162282400007],
              [120.76666426600008, 52.17955515500002],
              [120.75374515800007, 52.194463807000076],
              [120.7512646890001, 52.20296457900007],
              [120.75234989400008, 52.21185292600008],
              [120.75705245000006, 52.22787262000004],
              [120.75808597900004, 52.237406922000034],
              [120.73896569900006, 52.25660471600004],
              [120.6549398200001, 52.2991085820001],
              [120.63576786300013, 52.32618703200005],
              [120.633442424, 52.33546295200007],
              [120.62910160400008, 52.34088897700006],
              [120.626156047, 52.34680592900007],
              [120.62837813300007, 52.35789052400007],
              [120.633442424, 52.361740418000025],
              [120.64315759300013, 52.36633962000006],
              [120.65220096800016, 52.37246327800004],
              [120.65623173100005, 52.381429139000076],
              [120.6604175220001, 52.39879242000008],
              [120.68139815300003, 52.422976990000066],
              [120.69038985300006, 52.439125875000045],
              [120.69038985300006, 52.470157573000066],
              [120.69256026200003, 52.47460174600009],
              [120.701965373, 52.48876108800003],
              [120.70413578300008, 52.49783030200008],
              [120.704807577, 52.50917328000007],
              [120.70811486900004, 52.518139140000116],
              [120.72397953300009, 52.542168681000035],
              [120.70739139800008, 52.55033355700006],
              [120.6544747320001, 52.566999207],
              [120.60874108900015, 52.574001363],
              [120.53959802300005, 52.603663636000064],
              [120.49184899900001, 52.61725453700005],
              [120.464150432, 52.63603892000005],
              [120.4540218510001, 52.63903615400007],
              [120.4299406340001, 52.63609059700006],
              [120.38942631100008, 52.622163798000074],
              [120.36761885600004, 52.61725453700005],
              [120.2611137290001, 52.611053365000046],
              [120.24209680200016, 52.60722930900003],
              [120.19812015800011, 52.58911672],
              [120.17595096800005, 52.58374237100004],
              [120.11285404500012, 52.58451751700004],
              [120.07936771700014, 52.589969381000046],
              [120.05642338100012, 52.60051137400008],
              [120.04267745000004, 52.613507996000024],
              [120.03378910300006, 52.62536773700005],
              [120.03012007700016, 52.63937205000006],
              [120.03260054600003, 52.658879903000056],
              [120.036579631, 52.66812998500008],
              [120.05290938400003, 52.69301218700012],
              [120.05156579600009, 52.70458770800006],
              [120.0440210380001, 52.7235271200001],
              [120.04608809400008, 52.73399159800006],
              [120.0329622800001, 52.76065663700011],
              [120.06582849200004, 52.78321339900005],
              [120.15595218900006, 52.809077454000075],
              [120.17739790900015, 52.81791412400007],
              [120.21961755400002, 52.844915060000105],
              [120.25248376500008, 52.852692363000116],
              [120.26721154800009, 52.858144227000096],
              [120.2801823320001, 52.86592153000002],
              [120.28571171100009, 52.87488739000004],
              [120.29072432500004, 52.885351868000086],
              [120.3023515220001, 52.891242982000094],
              [120.32669112200006, 52.899046123000105],
              [120.33723311400001, 52.90770192500007],
              [120.34240075700012, 52.915427552000054],
              [120.34658654800006, 52.923463237000036],
              [120.35407963100016, 52.933230082000094],
              [120.36203780100004, 52.93937957800007],
              [120.39190677900007, 52.9567686970001],
              [120.450301147, 53.00834177700001],
              [120.52760909100004, 53.055806580000095],
              [120.61478723100004, 53.097070211000116],
              [120.65220096800016, 53.1228309130001],
              [120.714057658, 53.185049337000024],
              [120.7512646890001, 53.206908468000066],
              [120.82387007700004, 53.235227153000054],
              [120.83043298400003, 53.24483897000006],
              [120.825988811, 53.26186635400008],
              [120.84572920700015, 53.273441875000046],
              [120.8742545980001, 53.28015981100005],
              [121.05486372900009, 53.290004171000035],
              [121.151808716, 53.27450124100004],
              [121.20348514900007, 53.276749166000045],
              [121.25355961200006, 53.2869294230001],
              [121.299965047, 53.30253570600003],
              [121.32833540900009, 53.31997650199999],
              [121.34099613500013, 53.323645529000075],
              [121.35763594600013, 53.324058940000086],
              [121.40579838100012, 53.316824240000116],
              [121.413274785, 53.31733482400007],
              [121.45876672400004, 53.3204415900001],
              [121.51214847800014, 53.32982086200006],
              [121.64102950100005, 53.384907939000115],
              [121.88897302300012, 53.43058990500005],
              [122.02505194200006, 53.429823366000036],
              [122.08162276200005, 53.42950470000004],
              [122.10808109500016, 53.43808298800006],
              [122.1477685960001, 53.461130676000025],
              [122.16869755100004, 53.46914052300009],
              [122.22569665600008, 53.473946432],
              [122.2937028400001, 53.4926533000001],
              [122.31675052900005, 53.496012269000104],
              [122.33783451400006, 53.491309713000035],
              [122.35809167500008, 53.479579163000054],
              [122.37969242400004, 53.46164744100007],
              [122.40160323100008, 53.45095041900005],
              [122.42516768400003, 53.45244903600006],
              [122.47121138500012, 53.46474802700003],
              [122.85966312700015, 53.473946432],
              [123.0025484630001, 53.507329407000086],
              [123.15359867400002, 53.51311716700006],
              [123.16424401900008, 53.51637278300005],
              [123.18005700700013, 53.53048044900008],
              [123.20325972500012, 53.53828359000009],
              [123.23473067300006, 53.56034942700008],
              [123.25255904200003, 53.56779083300002],
              [123.27731205300006, 53.56944447900007],
              [123.30955814700008, 53.56748077500002],
              [123.34025394700012, 53.561434632000086],
              [123.3677458090001, 53.54582834900005],
              [123.38025150600009, 53.542831116000045],
              [123.4199390060001, 53.53854197300005],
              [123.43166955600009, 53.53580312200002],
              [123.47140873300009, 53.51900828100007],
              [123.4815373130001, 53.5180781050001],
              [123.48551639800007, 53.52598460000006],
              [123.48608483900006, 53.543916321000026],
              [123.49476648000012, 53.56009104500002],
              [123.51440352500003, 53.56241648400005],
              [123.53528080300009, 53.554613342000025],
              [123.54747644100013, 53.54050567600008],
              [123.53936324100005, 53.53704335600007],
              [123.53259362900008, 53.532495830000116],
              [123.51957116700015, 53.51999013300012],
              [123.54189538600014, 53.51409902000002],
              [123.56091231300002, 53.52417592400006],
              [123.59191817300012, 53.5578689580001],
              [123.6142940680001, 53.56334666000002],
              [123.63956384300008, 53.55125437400001],
              [123.67775272700015, 53.51999013300012],
              [123.70178226800016, 53.51006825800003],
              [123.73216801, 53.5037637330001],
              [123.85019698100007, 53.49497874000012],
              [123.87655196200006, 53.48867421500002],
              [123.97055139200006, 53.45518788700012],
              [123.98972334900009, 53.4414936320001],
              [124.01008386300015, 53.41467356400001],
              [124.017370239, 53.40702545200013],
              [124.02992761300004, 53.399945781],
              [124.05566247600012, 53.39488149000003],
              [124.06889164200004, 53.38961049400008],
              [124.10025923700005, 53.36335886700006],
              [124.12180830900002, 53.35268768400006],
              [124.14025679600002, 53.357803650000065],
              [124.15777510600009, 53.37002512600007],
              [124.18221805900009, 53.3785517380001],
              [124.20877974500002, 53.38268585200002],
              [124.23270593300003, 53.38165232300004],
              [124.25306644700004, 53.37550282800005],
              [124.27539066600002, 53.36470245400004],
              [124.29342574100014, 53.35129242000009],
              [124.3047428800001, 53.32904571600004],
              [124.32138269100011, 53.309770406],
              [124.32582686400013, 53.305998027000086],
              [124.34251835200007, 53.27248586000006],
              [124.3599333090001, 53.25946339900004],
              [124.38370446800008, 53.24613088000011],
              [124.40819909700008, 53.23569224100008],
              [124.45393273900004, 53.22819915800004],
              [124.500493205, 53.21367808000009],
              [124.528191773, 53.210344951000096],
              [124.64022627800006, 53.210344951000096],
              [124.65159509300014, 53.20876882000006],
              [124.6786735440001, 53.19933787000009],
              [124.68828536, 53.19360178700005],
              [124.69639856000003, 53.18375742600007],
              [124.69686364800015, 53.17634185900006],
              [124.69557173700008, 53.16980478900008],
              [124.69825891200003, 53.16264760400013],
              [124.72016971900007, 53.14882415800007],
              [124.74729984600003, 53.14771311500006],
              [124.8013533940001, 53.155154521],
              [124.82202396700006, 53.14724802700006],
              [124.84812056500004, 53.11368418400012],
              [124.87013472500013, 53.107999776000085],
              [124.8962313240001, 53.11766327000002],
              [124.89178715100002, 53.13425140400001],
              [124.8791781010001, 53.15386261100004],
              [124.88041833500012, 53.172517802000115],
              [124.89767826400009, 53.18551442500005],
              [124.91917566000006, 53.193937683000044],
              [125.01942793800009, 53.210732524],
              [125.07368819200008, 53.212205303000076],
              [125.12743168100013, 53.20654673300005],
              [125.42808516500008, 53.09469309500007],
              [125.45640385000002, 53.09089487800013],
              [125.47650598200005, 53.08350514800013],
              [125.49950199400013, 53.05061309899999],
              [125.52130944900006, 53.04242238400006],
              [125.58404463700009, 53.058907166000054],
              [125.6213550220001, 53.06213694300003],
              [125.63799483300016, 53.04614308700006],
              [125.65019047100014, 53.023379619000096],
              [125.67861250800001, 53.00568044000009],
              [125.73354455600008, 52.98165090000005],
              [125.72429447400009, 52.952763774000104],
              [125.71985030200011, 52.946304220000044],
              [125.711065308, 52.94121409200007],
              [125.68858606000009, 52.936459860000085],
              [125.67887089100014, 52.933230082000094],
              [125.66093916900007, 52.91935496000012],
              [125.64708988500001, 52.90090647400011],
              [125.64646976800014, 52.88488678000006],
              [125.6686906330001, 52.877962138000086],
              [125.69173832200016, 52.88129526800007],
              [125.73649011200013, 52.89579050700003],
              [125.83736250800013, 52.9067200730001],
              [125.85694787700004, 52.899046123000105],
              [125.86371748900001, 52.88858164500006],
              [125.86185713700007, 52.88145029700003],
              [125.85751631700009, 52.87442230300012],
              [125.85694787700004, 52.864319560000084],
              [125.86103031500016, 52.856025492000114],
              [125.867438192, 52.8493592330001],
              [125.97694055200014, 52.764997458],
              [125.98526045800008, 52.764532370000055],
              [126.00748132400014, 52.77866587400008],
              [126.01781661000007, 52.78238657700011],
              [126.06670251500015, 52.78318756200012],
              [126.08804488100014, 52.77541025800012],
              [126.1040645760001, 52.75445546500002],
              [126.06603072100006, 52.74417185500003],
              [126.04902917600015, 52.73709218300009],
              [126.03512821500016, 52.72711863299999],
              [126.0619482830001, 52.69662953700002],
              [126.06861454300014, 52.67988637300006],
              [126.0526465260001, 52.67249664400005],
              [126.02768680800006, 52.671178894],
              [126.002572063, 52.66549448700006],
              [125.98277998900005, 52.653040467000054],
              [125.97316817300009, 52.63156890900002],
              [125.97730228700004, 52.61076914500008],
              [125.99084151200009, 52.58642954500006],
              [126.00923832300009, 52.568394471000076],
              [126.02804854400011, 52.56637909000001],
              [126.03952071200007, 52.56966054400003],
              [126.050786174, 52.57118499800002],
              [126.05910607900006, 52.57549998000009],
              [126.06251672400009, 52.58717885400007],
              [126.06861454300014, 52.59531789200007],
              [126.08277388500011, 52.59335418700006],
              [126.17036543800009, 52.5475947070001],
              [126.21232670100011, 52.53304779100007],
              [126.21046634900011, 52.51142120400009],
              [126.20064782700001, 52.48653900200013],
              [126.20033776900004, 52.46708282500005],
              [126.21677087500012, 52.4647573860001],
              [126.24679488100008, 52.46584259100011],
              [126.27599206600007, 52.46328460800002],
              [126.28896285000013, 52.45002960300009],
              [126.29619755100009, 52.435198466000074],
              [126.312682333, 52.417421773000044],
              [126.34368819200006, 52.39137685200008],
              [126.3507161870001, 52.37690745100004],
              [126.34430830900016, 52.35758046500008],
              [126.31573124200008, 52.31621348100005],
              [126.34441166300007, 52.302622579000044],
              [126.42120284000015, 52.28730051700008],
              [126.43928959200008, 52.27528574700004],
              [126.39205733300003, 52.26435618100005],
              [126.31221724500006, 52.22795013400007],
              [126.30932336500007, 52.213868307000055],
              [126.31671309500007, 52.19976064100011],
              [126.33283614100003, 52.19337860100008],
              [126.3507161870001, 52.19169911700003],
              [126.45329390500007, 52.165628358000035],
              [126.49380822800009, 52.16126169800005],
              [126.53117028800006, 52.15265757200011],
              [126.55597497600007, 52.130643412000026],
              [126.55132409700002, 52.11297007300003],
              [126.51980147300003, 52.06126780199999],
              [126.514427125, 52.04871042900005],
              [126.514427125, 52.042535096000094],
              [126.49158614200007, 52.03878855400008],
              [126.46709151200002, 52.03165720700004],
              [126.44735111500006, 52.01878977500003],
              [126.43928959200008, 51.99786082000004],
              [126.44605920400011, 51.982538757000086],
              [126.64790734900015, 51.741261496000035],
              [126.66242842600002, 51.733432516],
              [126.71358809500009, 51.72317474400002],
              [126.71575850400006, 51.71749033600007],
              [126.72557702700016, 51.70873118200008],
              [126.72795414300009, 51.70304677400004],
              [126.72485355700007, 51.697543234000065],
              [126.71787723900007, 51.69092865000006],
              [126.7107458910001, 51.68601938900012],
              [126.70733524600007, 51.68563181600011],
              [126.71575850400006, 51.66317840700002],
              [126.724543498, 51.649587505000014],
              [126.72371667500016, 51.63589325],
              [126.70397627800008, 51.61359486900004],
              [126.67514082900004, 51.588376770000096],
              [126.67689782700012, 51.5765945430001],
              [126.70056563400016, 51.56271942200003],
              [126.77559981300016, 51.545769552000095],
              [126.8074324960001, 51.53421986900007],
              [126.83037683200013, 51.50812327100009],
              [126.8015930580001, 51.4772207650001],
              [126.7927047120001, 51.459056498000066],
              [126.78929406800006, 51.43580210400005],
              [126.80030114800007, 51.41895558700007],
              [126.82593265800011, 51.412082622000085],
              [126.87688562000005, 51.40988637300008],
              [126.89011478700007, 51.40701833200002],
              [126.9019486900001, 51.400998027000085],
              [126.90944177300003, 51.39110199],
              [126.90892500900009, 51.37702016200005],
              [126.89750451700007, 51.36195648200008],
              [126.88029626500008, 51.35622039800002],
              [126.86086592700008, 51.35392079700007],
              [126.84345096900006, 51.34937327100006],
              [126.82701786300004, 51.33898630800003],
              [126.81415043200002, 51.32493031900002],
              [126.80732914200007, 51.30810964000004],
              [126.80898278900008, 51.289066875000074],
              [126.8237105720001, 51.26555409800007],
              [126.8458797610001, 51.251472270000065],
              [126.869909302, 51.251730652000035],
              [126.89068322800011, 51.27149688700008],
              [126.89290531400002, 51.28201304100004],
              [126.88918461100002, 51.28932525700013],
              [126.8848437910001, 51.295629781000045],
              [126.88530887900004, 51.30289032000012],
              [126.8913550210001, 51.310512594],
              [126.89936486800008, 51.316507060000035],
              [126.90825321500006, 51.321235453],
              [126.91729659100014, 51.324723613000046],
              [126.93445316600003, 51.32875437500006],
              [126.9546069750001, 51.32958119800007],
              [126.97217696100006, 51.32400014300005],
              [126.98116866100008, 51.30885894800004],
              [126.97775801700004, 51.2965599570001],
              [126.967939495, 51.28154795400012],
              [126.94711389200006, 51.25813853000007],
              [126.9163147380001, 51.232765402000055],
              [126.90892500900009, 51.22162913100006],
              [126.90515262900016, 51.20811574300008],
              [126.90380904200009, 51.19338796000007],
              [126.90541101100013, 51.164268291000056],
              [126.90959680200007, 51.146000672000085],
              [126.92298099800007, 51.10791514200004],
              [126.92582320200006, 51.086004334000094],
              [126.93176599200007, 51.06378346800007],
              [126.94644209900008, 51.04833221500006],
              [126.98116866100008, 51.02768748000004],
              [127.03232832900011, 50.97244537400003],
              [127.04710778800012, 50.96722605400002],
              [127.11077315300008, 50.931517640000024],
              [127.14425948100012, 50.90350901300009],
              [127.2207406010001, 50.788167216000076],
              [127.2411011150001, 50.774679667],
              [127.26621586100015, 50.76408599900013],
              [127.287351522, 50.751011862000084],
              [127.29644657500006, 50.730082907000096],
              [127.295516399, 50.722796529],
              [127.29324263600006, 50.715355123000094],
              [127.28988366800007, 50.708378805000095],
              [127.28580122900007, 50.702487692],
              [127.2822872320001, 50.69483958000011],
              [127.28383752500014, 50.68827667300003],
              [127.28709314000002, 50.68202382400004],
              [127.28895349200002, 50.675150859000055],
              [127.29494795800014, 50.666417542],
              [127.327090698, 50.63727203400008],
              [127.34398889200008, 50.627763570000084],
              [127.3587166750001, 50.60502594000009],
              [127.36708825800014, 50.57779246000011],
              [127.36481449400003, 50.554744772000035],
              [127.35685632300016, 50.544616191],
              [127.3337052820001, 50.52503082300008],
              [127.32362837800014, 50.5137653610001],
              [127.31029585800002, 50.48839223300011],
              [127.30264774600005, 50.47759185900007],
              [127.28895349200002, 50.46601633700003],
              [127.30466312700008, 50.451443584000074],
              [127.34915653500008, 50.42617380800003],
              [127.35850997, 50.415115051],
              [127.35964685100015, 50.39289418600008],
              [127.3587166750001, 50.38131866500002],
              [127.35478926600001, 50.373463847],
              [127.34574589000016, 50.36442047200005],
              [127.33752933800014, 50.35268992100005],
              [127.33184493000016, 50.340184225000044],
              [127.33065637200008, 50.328195292],
              [127.35463423700008, 50.298636374000054],
              [127.404812053, 50.2759504190001],
              [127.57839318800006, 50.22055328400005],
              [127.59064050300009, 50.20871938100002],
              [127.58981368000008, 50.18639516300006],
              [127.58671309500005, 50.16717153000003],
              [127.580615276, 50.14913645400004],
              [127.57017663600004, 50.13022288000009],
              [127.50661462400006, 50.06345693000007],
              [127.48666752200006, 50.02562978200008],
              [127.49441898600003, 49.973178203000046],
              [127.52160079000015, 49.94119049100003],
              [127.53400313300011, 49.92248362200006],
              [127.53224613500004, 49.90765248600003],
              [127.52087732000012, 49.8917878220001],
              [127.51162723800013, 49.86905019200013],
              [127.50671797700011, 49.844297181000016],
              [127.50811324100005, 49.822334697000045],
              [127.53865401200005, 49.789933574000045],
              [127.64428064000009, 49.76714426700006],
              [127.67998905500008, 49.73918731800005],
              [127.6862935800001, 49.71681142200008],
              [127.68696537300008, 49.69887970000009],
              [127.689962606, 49.681464742000074],
              [127.70360518500001, 49.660639141],
              [127.7220019940001, 49.64859853100005],
              [127.77000940000005, 49.633870748000035],
              [127.78990482600005, 49.62307037400011],
              [127.80964522400012, 49.607102356000055],
              [127.83088423700008, 49.593873189000064],
              [127.854655395, 49.58488149100002],
              [127.90731368100006, 49.58023061200005],
              [127.92069787600008, 49.581109111],
              [127.93015466400004, 49.585191549000015],
              [127.94080000800005, 49.595888570000014],
              [127.94793135600008, 49.601211243000066],
              [127.955476116, 49.603019918000044],
              [127.96793013500007, 49.603226624000015],
              [127.99159794100007, 49.59873077400009],
              [128.0124752200001, 49.58741363500012],
              [128.04689172400003, 49.55826812800008],
              [128.06714888600004, 49.546692607000054],
              [128.09247033800006, 49.54157664000006],
              [128.1983036700001, 49.53899281900006],
              [128.22507206300008, 49.54183502300005],
              [128.2454325770001, 49.55139516200002],
              [128.26786014800007, 49.55878489300004],
              [128.32036340400015, 49.54478057900003],
              [128.3447546800001, 49.54798451800009],
              [128.35281620400008, 49.55449574900008],
              [128.36501184100007, 49.56974029600012],
              [128.372039836, 49.575321350000124],
              [128.38351200400012, 49.57935211300013],
              [128.5512537030001, 49.5884471640001],
              [128.62866499800015, 49.575321350000124],
              [128.63517622900008, 49.578163554000085],
              [128.66618208900002, 49.60947947200002],
              [128.67186649600006, 49.611443177000055],
              [128.6867493090001, 49.603226624000015],
              [128.73418827400008, 49.58441640300002],
              [128.7595097250001, 49.5778018190001],
              [128.78658817600007, 49.575321350000124],
              [128.79692346200005, 49.57247914600005],
              [128.80167769400015, 49.565141093000065],
              [128.80322798700007, 49.55516754200006],
              [128.803434692, 49.54426381500009],
              [128.79950728400007, 49.53186147100003],
              [128.790412232, 49.52710723900013],
              [128.77925012200006, 49.525091859000085],
              [128.76932824700015, 49.5206993610001],
              [128.75413537600002, 49.50245758100003],
              [128.75020796700005, 49.484525858000055],
              [128.76012984200014, 49.47088328100004],
              [128.78658817600007, 49.46545725500009],
              [128.80984257100016, 49.46871287000006],
              [128.85356083200014, 49.480546774000075],
              [128.879192342, 49.479719951000064],
              [128.90192997300005, 49.47171010400008],
              [128.94709517400014, 49.44954091400005],
              [128.9981514900001, 49.441272685000015],
              [129.0145845950001, 49.43109242800004],
              [129.05055139200016, 49.376677145000045],
              [129.06688114500002, 49.361639303000075],
              [129.08786177600007, 49.352079163000084],
              [129.11535363800016, 49.34877187100007],
              [129.13602421100006, 49.35414622000003],
              [129.17116418500012, 49.380346171000056],
              [129.193901815, 49.389699605],
              [129.21787968, 49.390784811000074],
              [129.24557824700003, 49.38592722600008],
              [129.27234663900003, 49.37528188100008],
              [129.316064901, 49.344120993],
              [129.34097294100008, 49.341175436000114],
              [129.3620569260001, 49.34980540000005],
              [129.37321903500003, 49.369855856000086],
              [129.37146203600008, 49.410576885000054],
              [129.37869673700004, 49.4250462860001],
              [129.40339807200013, 49.43067901700003],
              [129.4550745040001, 49.427268372000086],
              [129.48060266200002, 49.42127390600008],
              [129.50241011600014, 49.41078359000004],
              [129.519670044, 49.39708933600009],
              [129.52773156800004, 49.38484202100007],
              [129.53021203600008, 49.36933909100007],
              [129.53207238800007, 49.32153839100006],
              [129.53899703000008, 49.30371002200003],
              [129.55181278500004, 49.29048085600003],
              [129.57175988900008, 49.27983551000004],
              [129.61919885300006, 49.27425445600004],
              [129.66922163900006, 49.27916371700006],
              [129.71118290200008, 49.27415110300011],
              [129.73505741400004, 49.23890777600012],
              [129.73753788300013, 49.20547312400005],
              [129.741775351, 49.19570627800009],
              [129.75562463400001, 49.18428578700009],
              [129.77598514900006, 49.17756785100006],
              [129.82466434700007, 49.17415720600003],
              [129.84151086400004, 49.16718088800003],
              [129.845438273, 49.154055074000055],
              [129.84151086400004, 49.109199931],
              [129.86249149600008, 49.10651275600004],
              [129.8831620690001, 49.09979482100003],
              [129.9206791590001, 49.081863099000046],
              [129.91168745900006, 49.0592804970001],
              [129.91344445800013, 49.03954010000005],
              [129.92646692000005, 49.02569081600008],
              [129.9742159430001, 49.015148825000026],
              [129.99685022000006, 49.00238474600006],
              [130.03746789600012, 48.97199900300011],
              [130.20179895100006, 48.88259877500012],
              [130.24934126800008, 48.86451202400009],
              [130.2935762940001, 48.87014475500003],
              [130.33812137900009, 48.885337626000066],
              [130.38680057800002, 48.896293030000024],
              [130.439717245, 48.89649973600008],
              [130.46534875600008, 48.89133209300009],
              [130.47620080600012, 48.879498190000064],
              [130.48663944500004, 48.86368520200007],
              [130.51165083900003, 48.85552032500006],
              [130.54089969900008, 48.85345326800008],
              [130.56487756400008, 48.85588206000004],
              [130.6249255780001, 48.87433054600005],
              [130.62528640000005, 48.874359528000056],
              [130.650660441, 48.87639760400002],
              [130.67432824800005, 48.870816549000025],
              [130.67649865800007, 48.85743235300008],
              [130.66668013600008, 48.841464335000026],
              [130.6278194580001, 48.79604075100009],
              [130.53325158700005, 48.635792135000045],
              [130.52973759000008, 48.616258443000035],
              [130.5407963460001, 48.598352560000066],
              [130.56239709500005, 48.58814646400002],
              [130.58637496000006, 48.583443909000025],
              [130.60766565000006, 48.57672597300011],
              [130.62017134600006, 48.56049957300009],
              [130.6207914630001, 48.54931162600006],
              [130.6147969980001, 48.53016550700006],
              [130.61345341000003, 48.51946848600004],
              [130.6157271730001, 48.50809967100007],
              [130.62430546100006, 48.4883592740001],
              [130.62637251800004, 48.48226145500003],
              [130.63929162700003, 48.477248841000076],
              [130.71587609900013, 48.4990562950001],
              [130.74429813700016, 48.497325135000025],
              [130.75897424300007, 48.48572377500007],
              [130.75959436100004, 48.467921245000056],
              [130.74646854700006, 48.44779327500008],
              [130.73830367100004, 48.429809876],
              [130.743264608, 48.41159393400004],
              [130.763625123, 48.382965190000064],
              [130.77375370300007, 48.364232483000066],
              [130.7796448160001, 48.35637766500004],
              [130.7902901610001, 48.348212790000034],
              [130.803415975, 48.34273508700004],
              [130.814474732, 48.33997039900008],
              [130.8221228430001, 48.333769226000086],
              [130.82512007700012, 48.31777537100005],
              [130.8239831950001, 48.29415924100003],
              [130.8194356690001, 48.28188608800009],
              [130.773857056, 48.24418813100006],
              [130.76889611800004, 48.23674672500003],
              [130.763625123, 48.22527455700002],
              [130.75277307200008, 48.18961781900002],
              [130.74646854700006, 48.1843726610001],
              [130.72951867700016, 48.177964783000064],
              [130.7072978110001, 48.163366191000094],
              [130.67474165900006, 48.13592600600005],
              [130.6633728440001, 48.116443990000036],
              [130.6648197840001, 48.10205210400004],
              [130.67091760300002, 48.086575012000125],
              [130.67474165900006, 48.06394073500009],
              [130.68238977100015, 48.05034983400007],
              [130.85736617100008, 47.92777333600007],
              [130.90697554600007, 47.884261780000045],
              [130.94170210800007, 47.820596415000054],
              [130.942322225, 47.7898231],
              [130.9382914640001, 47.75109161400006],
              [130.94180546100011, 47.717967021000064],
              [130.96567997300014, 47.70393687000005],
              [130.98345666500006, 47.70003529900002],
              [131.0233508710001, 47.682284445000064],
              [131.04412479700005, 47.67722015400001],
              [131.08432906100006, 47.675127259000035],
              [131.10386275300004, 47.676548360000126],
              [131.12918420400007, 47.68122507800008],
              [131.16721805900016, 47.69714141900003],
              [131.21010949700013, 47.709207865000096],
              [131.41836552000012, 47.74261667900008],
              [131.44089644400003, 47.741169739000085],
              [131.4750028890001, 47.734477641000055],
              [131.507765747, 47.72153269400003],
              [131.5379447840001, 47.70321339900006],
              [131.57742557800015, 47.66856435200005],
              [131.5847636320001, 47.6646886190001],
              [131.5939620370001, 47.662311503000055],
              [131.60326379400016, 47.66153635700003],
              [131.61246219900016, 47.66200144500006],
              [131.62166060500016, 47.663810120000065],
              [131.6306523030001, 47.66685902900009],
              [131.68356897000007, 47.69460927400003],
              [131.70299930900006, 47.69615956700004],
              [131.78041060400005, 47.67910634400003],
              [131.79901412000004, 47.67936472600009],
              [131.83591109200006, 47.6845323700001],
              [131.85461796100003, 47.68406728200007],
              [131.86484989400003, 47.681560974],
              [131.89430546100004, 47.67001129200004],
              [131.90350386600005, 47.66809926400002],
              [131.914045858, 47.667634176],
              [131.92448449800014, 47.66892608700006],
              [131.93295943300012, 47.67223337900005],
              [131.95735070800004, 47.68693532300004],
              [131.96654911400003, 47.69001007100009],
              [132.02535689300015, 47.697864889000115],
              [132.0892289630001, 47.69476430300007],
              [132.11703088400014, 47.68944163000002],
              [132.16167932100007, 47.69001007100009],
              [132.188964478, 47.69564280200011],
              [132.20219364500008, 47.70050038600003],
              [132.25076949100009, 47.72535675100009],
              [132.26441206900006, 47.728844910000035],
              [132.33241825400006, 47.73651886000003],
              [132.36652469900002, 47.735330302000094],
              [132.4006311450001, 47.72980092400009],
              [132.4532377530001, 47.710525615000066],
              [132.47576867700002, 47.70675323500002],
              [132.5246545820001, 47.70752838100013],
              [132.53643680900012, 47.711068217],
              [132.54718550700005, 47.71677846300004],
              [132.55669397000008, 47.72349639900007],
              [132.57416060400016, 47.73959360800005],
              [132.58036177600002, 47.747991028000044],
              [132.58232548000007, 47.75613006600004],
              [132.58077518800013, 47.76483754500002],
              [132.5736438400001, 47.78222666400005],
              [132.57385054500008, 47.788350322],
              [132.57643436700005, 47.7942414350001],
              [132.581395304, 47.80070098900005],
              [132.6074402270001, 47.82762441000007],
              [132.65880660100004, 47.86981821800005],
              [132.66800500500005, 47.88131622400006],
              [132.67234582600014, 47.89444203700002],
              [132.67141565000009, 47.90250356000011],
              [132.6681083580001, 47.90932485000006],
              [132.66407759600008, 47.91583608100005],
              [132.66087365700002, 47.92301910400009],
              [132.66035689300008, 47.93133901000006],
              [132.66314742000014, 47.93867706300004],
              [132.6681083580001, 47.9451366170001],
              [132.67461958900003, 47.95061431900008],
              [132.68908899000007, 47.95769399000001],
              [132.70572880100008, 47.960381164000054],
              [132.72247196500007, 47.95893422500005],
              [132.73818160000013, 47.95412831700004],
              [132.76257287700003, 47.939374695000126],
              [132.774871867, 47.93376780200002],
              [132.789651327, 47.932734274000026],
              [132.8058777270001, 47.936196594000066],
              [132.82065718600012, 47.94237192800004],
              [132.8333695880001, 47.95159617100005],
              [132.8536267500001, 47.97614247700004],
              [132.8647888590001, 47.9856509400001],
              [132.94033980300003, 48.02257375100005],
              [132.94075321400015, 48.02670786600005],
              [133.02467574100007, 48.05244272900005],
              [133.0328406170001, 48.05675771100003],
              [133.03935184800002, 48.0615119430001],
              [133.04400272700002, 48.06621449800009],
              [133.04751672400005, 48.071640523000056],
              [133.05103072100013, 48.07853932700006],
              [133.0609525960001, 48.091846009000065],
              [133.07542199700003, 48.100915222000125],
              [133.09195845600004, 48.10678049700003],
              [133.18518273900008, 48.12481557300002],
              [133.22373335800006, 48.125978293000045],
              [133.26280074100015, 48.11944122300007],
              [133.27272261600007, 48.115152079],
              [133.29070601500013, 48.10440338100007],
              [133.30145471300006, 48.101276957000024],
              [133.323675578, 48.10011423700011],
              [133.37948612500008, 48.10631541],
              [133.39622928900013, 48.105927837000095],
              [133.41317915900004, 48.102956441000075],
              [133.45079960100014, 48.09138092100004],
              [133.46371871000014, 48.089520569000044],
              [133.52438684100002, 48.09543752100005],
              [133.54402388600016, 48.10150950100008],
              [133.55994022700008, 48.113291728],
              [133.57203251200008, 48.13277374300007],
              [133.57782027200005, 48.14502105700011],
              [133.58484826700015, 48.155356344000026],
              [133.59383996600002, 48.16419301400002],
              [133.60551884000006, 48.171634420000046],
              [133.6214351810001, 48.177267151000066],
              [133.65450809700008, 48.18390757300007],
              [133.67021773300007, 48.189979553000015],
              [133.685513957, 48.202071838],
              [133.70773482300007, 48.231656596000036],
              [133.72127404800005, 48.2447565720001],
              [133.73791386000005, 48.25108693500003],
              [133.796618286, 48.2505960080001],
              [133.81480839000005, 48.25511769600003],
              [133.84953495300016, 48.26930287700007],
              [133.8676217040001, 48.27431549100005],
              [133.87754357900008, 48.275297344000094],
              [133.93697147700004, 48.27328196200007],
              [133.96642704300012, 48.27865631100012],
              [133.9824467370001, 48.28516754200008],
              [134.02482141100012, 48.31506235800002],
              [134.0406344000001, 48.32247792600002],
              [134.05717085800006, 48.32718048200009],
              [134.1160819910001, 48.33519032800008],
              [134.20620568900006, 48.35965911900003],
              [134.36712609900013, 48.37704823900005],
              [134.3863497320001, 48.381337383000115],
              [134.40547001200002, 48.37033030200003],
              [134.45311568300008, 48.34418202700003],
              [134.471305787, 48.33989288300005],
              [134.48980594900007, 48.33916941400007],
              [134.50820275900003, 48.34258005800008],
              [134.52587609900007, 48.34898793600003],
              [134.542619263, 48.35730784100009],
              [134.569491008, 48.31552744600005],
              [134.6113489180001, 48.28542592400005],
              [134.661164999, 48.26697743700005],
              [134.700852499, 48.26152557400006],
              [134.71873254400015, 48.26341176400008],
              [134.70302290900008, 48.252559713000025],
              [134.68741662600013, 48.21984853100004],
              [134.68297245300005, 48.13551259400002],
              [134.66271529200003, 48.107969056000044],
              [134.64793583200003, 48.10218129500008],
              [134.5864408770001, 48.061150208000115],
              [134.56721724500005, 48.04037628200008],
              [134.55936242700005, 48.00952545200009],
              [134.5669071860001, 47.98549591100006],
              [134.60132369100006, 47.94412892700002],
              [134.58768111200004, 47.92591298400008],
              [134.599049927, 47.91069427500004],
              [134.62271773300006, 47.9002297980001],
              [134.64576542200012, 47.89630238900013],
              [134.65775435400008, 47.88669057200012],
              [134.66757287700005, 47.86467641200004],
              [134.674084107, 47.84044016600005],
              [134.67646122300005, 47.82431711900007],
              [134.69651167900008, 47.79506825800003],
              [134.76978885900013, 47.741014710000044],
              [134.76513798000008, 47.718173727000035],
              [134.77257938700006, 47.710732321000094],
              [134.72545048100005, 47.66324167900011],
              [134.71397831300015, 47.65613617000007],
              [134.69289432900013, 47.64890146900011],
              [134.68669315600005, 47.631150615000095],
              [134.6861763920001, 47.608852234000025],
              [134.68266239500014, 47.58784576400002],
              [134.66819299400004, 47.573996481000066],
              [134.6242680260001, 47.54963104300005],
              [134.61496626800016, 47.53663442],
              [134.60411421800012, 47.52772023600009],
              [134.56060266200006, 47.481805725000115],
              [134.55688195900007, 47.47118621900002],
              [134.53528121, 47.46557932600008],
              [134.50045129400013, 47.43891428700006],
              [134.48463830600014, 47.43018097000008],
              [134.47192590300006, 47.428630676000054],
              [134.43657922400007, 47.42981923500007],
              [134.414978475, 47.43922434500003],
              [134.40185266100002, 47.437363993000034],
              [134.38903690700016, 47.43276479100008],
              [134.37818485600013, 47.43018097000008],
              [134.35400028500015, 47.42935414700007],
              [134.33260624200005, 47.42635691400004],
              [134.3128658450001, 47.42012990400006],
              [134.2928153900001, 47.409717103000034],
              [134.2794828700001, 47.397805685],
              [134.25746870900002, 47.367239075000086],
              [134.24506636600006, 47.355095113000075],
              [134.20300175, 47.33842946400004],
              [134.18357141100006, 47.327499899000074],
              [134.17550988800014, 47.31042083800004],
              [134.17013553900006, 47.28680470800002],
              [134.16000695900004, 47.27163767500009],
              [134.15411584500015, 47.25789174400008],
              [134.16186731000005, 47.23843556800007],
              [134.16837854100004, 47.230580749000055],
              [134.1864652920001, 47.21370839500007],
              [134.19318322800007, 47.210478617],
              [134.19721398900003, 47.20533681300007],
              [134.195560344, 47.19370961600002],
              [134.18977258300004, 47.172935689000084],
              [134.19876428300006, 47.155546570000055],
              [134.21623091700013, 47.13766652400001],
              [134.2272896730001, 47.11774526000009],
              [134.21716109300007, 47.094439189000056],
              [134.1971106360001, 47.085163269000034],
              [134.14574426300015, 47.081184184000065],
              [134.124246867, 47.070513001000066],
              [134.1142216400001, 47.05581105600005],
              [134.087349894, 46.998811951000064],
              [134.08083866400005, 46.99268829400002],
              [134.07412072800003, 46.988140768000065],
              [134.06915979000007, 46.981241964],
              [134.06698938, 46.96778025300004],
              [134.06698938, 46.926800843000095],
              [134.0627519130001, 46.906853740000074],
              [134.02048059100002, 46.8340416460001],
              [134.0166565350001, 46.819468892000046],
              [134.02141076700008, 46.80613637300003],
              [134.03588016800012, 46.78959991500004],
              [134.044665162, 46.77200409000004],
              [134.041771282, 46.752702942],
              [134.0258549400001, 46.71081919300012],
              [134.0147961830001, 46.66503387400009],
              [134.00528772000007, 46.64583608000008],
              [133.99849762100007, 46.637704225000036],
              [133.98802779200003, 46.62516550700006],
              [133.96735721900006, 46.611187033000064],
              [133.92033166600004, 46.59033559200007],
              [133.90245162000008, 46.57364410400005],
              [133.89883427000007, 46.56325714200004],
              [133.8963538010001, 46.538194072000024],
              [133.89190962700002, 46.528969828000115],
              [133.849328248, 46.480290630000084],
              [133.84581425000016, 46.47065297500008],
              [133.84777795500008, 46.45698455800006],
              [133.85439253800007, 46.444659729000094],
              [133.86152388500005, 46.441042379000024],
              [133.87041223100005, 46.44047393800007],
              [133.88188440000016, 46.43711497000005],
              [133.90028121000006, 46.426572978000095],
              [133.92146854700002, 46.410139872000045],
              [133.93387089100008, 46.390761211000054],
              [133.92601607300008, 46.37130503400009],
              [133.880850871, 46.35365753200007],
              [133.8633842370001, 46.33929148400007],
              [133.87444299400016, 46.31978363100008],
              [133.8851916920001, 46.32657908200012],
              [133.8963538010001, 46.32719919900008],
              [133.9069991460001, 46.322470805000094],
              [133.915990845, 46.31298818000003],
              [133.893769979, 46.301877747],
              [133.89408003800008, 46.29133575400006],
              [133.90193485600003, 46.27805491200003],
              [133.90245162000008, 46.25898630800005],
              [133.890049276, 46.25082143200005],
              [133.86958540900002, 46.24451690700003],
              [133.85532271400007, 46.23655873700007],
              [133.86090376900006, 46.223587952000045],
              [133.8528422450001, 46.21754180900008],
              [133.83661584500015, 46.20043691000005],
              [133.8301046150001, 46.19687123700008],
              [133.8212162690001, 46.200126852000054],
              [133.81294803900005, 46.214182841000095],
              [133.80623010300013, 46.21738678000007],
              [133.79351770100004, 46.21428619400011],
              [133.78648970600005, 46.20668975900004],
              [133.78173547400007, 46.19671620700005],
              [133.77512089000004, 46.18669097900003],
              [133.766025839, 46.177957662000054],
              [133.74101444500002, 46.1590440880001],
              [133.7200338140001, 46.15020741800002],
              [133.6987431240001, 46.14901886000008],
              [133.687374309, 46.14183583600003],
              [133.69636600800004, 46.11501576800005],
              [133.71931034400006, 46.07930735300003],
              [133.7200338140001, 46.063752747000095],
              [133.69481571500006, 46.02277333600007],
              [133.65812544800008, 45.93450999],
              [133.64985721900013, 45.92784373000008],
              [133.6277397060001, 45.93776560500008],
              [133.61761112500005, 45.93626698800007],
              [133.61006636600013, 45.92980743400001],
              [133.60696578, 45.91947214800011],
              [133.60613895700016, 45.90510610000011],
              [133.60303837100003, 45.89864654600005],
              [133.586501913, 45.88841461200006],
              [133.58443485500004, 45.8841254690001],
              [133.5860885020001, 45.879836325000056],
              [133.58588179500015, 45.876322327000096],
              [133.57968062300006, 45.87477203400006],
              [133.57006880700015, 45.87642568000011],
              [133.56407434100004, 45.880559794000035],
              [133.55911340300008, 45.88521067300009],
              [133.552292115, 45.88841461200006],
              [133.5316215410001, 45.88815623],
              [133.514361613, 45.87926788400007],
              [133.50268273900014, 45.862007955000095],
              [133.49834191900004, 45.83720326800007],
              [133.494001099, 45.833327535000095],
              [133.4849060470001, 45.82841827400007],
              [133.477257935, 45.820098369],
              [133.477257935, 45.80583567300003],
              [133.483769166, 45.79658559200003],
              [133.50340621000015, 45.78764556900008],
              [133.51136438100002, 45.77855051700003],
              [133.4849060470001, 45.76847361300007],
              [133.470850057, 45.72888946600004],
              [133.44304813700006, 45.7096658330001],
              [133.45162642400015, 45.69917551700006],
              [133.47663781800014, 45.693594462000036],
              [133.48779992700008, 45.68666982000006],
              [133.49152063000008, 45.67338897800006],
              [133.48283899000006, 45.6628986620001],
              [133.45669071500004, 45.648790995000056],
              [133.46216841700004, 45.64403676400006],
              [133.47178023300006, 45.63246124300012],
              [133.477257935, 45.62770701100003],
              [133.45844771400004, 45.62264272100005],
              [133.44201460800008, 45.62062734000001],
              [133.42764856000014, 45.61525299100005],
              [133.41514286300003, 45.60042185500002],
              [133.42516809100005, 45.5804230750001],
              [133.413489218, 45.573343405000074],
              [133.3748352460001, 45.573085022],
              [133.36253625500007, 45.56791737900009],
              [133.3302901620001, 45.549262187000025],
              [133.29887089000016, 45.54207916300008],
              [133.27168908700008, 45.52843658500005],
              [133.24088993300012, 45.52326894200006],
              [133.20213260900005, 45.51128000900009],
              [133.1892135020001, 45.50414866200008],
              [133.1798083910001, 45.493813375000045],
              [133.14022424400008, 45.43541900700008],
              [133.13319624900015, 45.419606019000085],
              [133.12875207500014, 45.40275950200002],
              [133.12720178300003, 45.38508616100002],
              [133.10188033100013, 45.28721099900012],
              [133.10673791500005, 45.264628398000085],
              [133.09753951000005, 45.243544413000066],
              [133.10653121000007, 45.214708964000025],
              [133.12069055200004, 45.18344472300002],
              [133.12720178300003, 45.15538442000009],
              [133.12523807800005, 45.141328431],
              [133.12151737500005, 45.13125152600004],
              [133.115419556, 45.12303497300012],
              [133.098779745, 45.10779042600008],
              [133.07335494000006, 45.09063385000012],
              [133.04968713400007, 45.0817455040001],
              [133.02384891800006, 45.058336080000046],
              [132.99263635200015, 45.04846588200006],
              [132.9661780200001, 45.02888051400002],
              [132.95336226400008, 45.024384664000095],
              [132.92121952300016, 45.027898662000055],
              [132.8397774660001, 45.05916290300006],
              [132.40471358250005, 45.14649607350013],
              [131.969649699, 45.233829244000034],
              [131.96882287600016, 45.233984274000065],
              [131.94990930200004, 45.239720357000024],
              [131.93151249200002, 45.24871205700005],
              [131.91456262200012, 45.26013254900006],
              [131.9004032800001, 45.27289662700004],
              [131.88841434800014, 45.291138407000076],
              [131.88045617700004, 45.309896952000074],
              [131.8707410080001, 45.32633005800004],
              [131.85306766800005, 45.33759552000002],
              [131.8180310470001, 45.33278961200001],
              [131.78526818900002, 45.30472930900008],
              [131.72315311800003, 45.215329082],
              [131.71126753800002, 45.20866282200008],
              [131.66692915900006, 45.20959299800005],
              [131.64450158700004, 45.20644073600006],
              [131.62775842400004, 45.19848256500002],
              [131.615149374, 45.18494334000003],
              [131.60522749900008, 45.16463450100012],
              [131.60491744, 45.14742625000004],
              [131.62238407400002, 45.12365509100009],
              [131.61980025300005, 45.10365631100005],
              [131.60905155500012, 45.08970367400006],
              [131.47148889200002, 44.99663442000006],
              [131.46570113100006, 44.99322377600005],
              [131.45216190600001, 44.98371531200006],
              [131.442963501, 44.971312969000095],
              [131.4337650970001, 44.96128774000006],
              [131.41950240100005, 44.95896230100003],
              [131.35035933500006, 44.96800567700008],
              [131.32948205600007, 44.967643942000095],
              [131.31315230400003, 44.96366485600002],
              [131.29992313700012, 44.95648183200005],
              [131.25899540300009, 44.92816314700006],
              [131.2446293540001, 44.92216868100003],
              [131.176519816, 44.90341013600003],
              [131.15801965400016, 44.90170481400007],
              [131.140449666, 44.906820781000064],
              [131.12360314900002, 44.91560577400004],
              [131.11006392400014, 44.91953318300001],
              [131.09580122900007, 44.91911977100001],
              [131.05156620300016, 44.90904286700008],
              [131.04536503200006, 44.9054255170001],
              [131.04112756400002, 44.897777405000014],
              [131.04205774000008, 44.882481181000045],
              [131.03885380100007, 44.874574687000106],
              [131.0247978120001, 44.86243072600011],
              [131.00826135300008, 44.85628123000005],
              [130.990277955, 44.85416249600006],
              [130.97157108600004, 44.85405914400003],
              [130.93343387900006, 44.84170847600008],
              [130.93012658700007, 44.82496531200003],
              [130.97157108600004, 44.77561431900001],
              [131.0075378830001, 44.75732086200004],
              [131.02138716700006, 44.746882223000014],
              [131.06582889900005, 44.682028301000074],
              [131.16515100150008, 44.36811981300009],
              [131.2644731040001, 44.054211325000026],
              [131.26147587100002, 44.046098124000096],
              [131.2515539970001, 44.041550599000075],
              [131.2353275960001, 44.03111195900003],
              [131.21775761000004, 44.01607411700006],
              [131.21310673100004, 44.00687571200005],
              [131.21290002500007, 43.99323313400005],
              [131.2066988530001, 43.974784648000124],
              [131.20793908700006, 43.95948842400007],
              [131.21837772700007, 43.92587290500005],
              [131.2173441980001, 43.90848378600002],
              [131.19284956900003, 43.860243835000105],
              [131.172799113, 43.79911061600008],
              [131.17031864400013, 43.78110138000001],
              [131.17786340300006, 43.725497538000084],
              [131.17496952300007, 43.70146799800007],
              [131.17507287600012, 43.69376820900008],
              [131.17744999200016, 43.684466451000034],
              [131.18540816300003, 43.666328024],
              [131.1879919850001, 43.6566645300001],
              [131.18726851400004, 43.64798289000002],
              [131.18148075400006, 43.629844463],
              [131.180240519, 43.62302317300005],
              [131.18241093000012, 43.614031474000015],
              [131.19078251200006, 43.595893046000086],
              [131.19202274600002, 43.588632507000014],
              [131.185718221, 43.574447327000044],
              [131.16566776500014, 43.54902252300003],
              [131.160706828, 43.53277028400002],
              [131.166908, 43.52106557300006],
              [131.25284846300008, 43.46916859100007],
              [131.26168257700016, 43.463833923],
              [131.2742916260001, 43.45119903600006],
              [131.27780562300012, 43.438486633000096],
              [131.281836386, 43.39314056500008],
              [131.28090621000007, 43.380221456000086],
              [131.26964074800003, 43.36474436500008],
              [131.25775516800007, 43.355726828000016],
              [131.24793664600008, 43.344202982000084],
              [131.24245894400013, 43.32141367600009],
              [131.242045533, 43.28376739500008],
              [131.2377047120001, 43.26583567400009],
              [131.225509074, 43.251934713000125],
              [131.193056275, 43.23079905300007],
              [131.17858687400008, 43.21738901800005],
              [131.16907841, 43.20170522100007],
              [131.16721805900016, 43.18155141200002],
              [131.17496952300007, 43.16839976100003],
              [131.18489139800016, 43.15633331300005],
              [131.18985233600011, 43.139150899000086],
              [131.1839612230001, 43.120805766],
              [131.16938846800008, 43.10780914400006],
              [131.13435184700006, 43.08933481900006],
              [131.12660038300015, 43.08238433900006],
              [131.12401656100013, 43.07535634400004],
              [131.12298303300014, 43.06773407000007],
              [131.11988244600002, 43.05900075300009],
              [131.11244104000002, 43.05186940600005],
              [131.094044231, 43.046830953],
              [131.0854659430001, 43.04210256],
              [131.078334595, 43.031818950000016],
              [131.0752340090001, 43.019597473],
              [131.07430383400003, 42.99339752200008],
              [131.08277876900002, 42.96523386700004],
              [131.09931522600004, 42.935442403000124],
              [131.10303592900004, 42.91043101000004],
              [131.07399377400014, 42.896581726000065],
              [131.039473918, 42.89800282900005],
              [131.0238676360001, 42.8962716680001],
              [131.00877811700002, 42.88689239500003],
              [131.00195682900005, 42.873301493000056],
              [130.999579713, 42.8587545780001],
              [130.9924483650001, 42.848729350000056],
              [130.856229289, 42.84976287800005],
              [130.8165417890001, 42.86405141200002],
              [130.79432092300016, 42.869064026],
              [130.76951623600013, 42.865808411],
              [130.75680383300005, 42.85327687600001],
              [130.74801884000016, 42.837489726000015],
              [130.734893026, 42.82449310300008],
              [130.73096561700004, 42.825888367000076],
              [130.64911014900008, 42.828937277000094],
              [130.5864783130001, 42.817258403000025],
              [130.49098026600012, 42.780826518000126],
              [130.40716109200008, 42.73537709600008],
              [130.3796692310001, 42.69667144800006],
              [130.40375044800015, 42.67755116800005],
              [130.43806359900015, 42.67530324400006],
              [130.47434045400013, 42.67904978500006],
              [130.50389937400007, 42.67780955100004],
              [130.52674035600006, 42.66576894100005],
              [130.55113163300007, 42.645615133],
              [130.57190555900002, 42.621818136000016],
              [130.5843079020001, 42.598899639000095],
              [130.58451460800006, 42.56890146900004],
              [130.56756473800016, 42.55275258400006],
              [130.53077111900006, 42.53048004200009],
              [130.52519006400013, 42.549238587],
              [130.5195056560001, 42.58859019000009],
              [130.516508423, 42.59936472700012],
              [130.5014189050001, 42.610785217000014],
              [130.484158976, 42.61001007100002],
              [130.46782922400007, 42.6003982540001],
              [130.4551168220001, 42.58515370700006],
              [130.47103316300002, 42.56975413000008],
              [130.46793257700006, 42.554897156000024],
              [130.452533, 42.54934194000002],
              [130.43124231000002, 42.561511739000125],
              [130.4263847250001, 42.5721054080001],
              [130.43000207500006, 42.59148407000008],
              [130.42772831200006, 42.59936472700012],
              [130.4204936120001, 42.60427398700004],
              [130.41274214700007, 42.604635722000054],
              [130.40395715400007, 42.6040672810001],
              [130.3930017500001, 42.606237692],
              [130.32478885900008, 42.650291850000045],
              [130.3171407480001, 42.66739674900002],
              [130.2626737870001, 42.7086087040001],
              [130.24303674300006, 42.743361105000034],
              [130.24220992100004, 42.782015076000036],
              [130.256472616, 42.8668936160001],
              [130.2390059820001, 42.902240296000016],
              [130.19384078000007, 42.90820892300003],
              [130.1404073490001, 42.90712371900004],
              [130.09875614500004, 42.92151560500004],
              [130.11157190000006, 42.92906036400008],
              [130.12252730300014, 42.94332306000008],
              [130.130485474, 42.95947194500006],
              [130.13358606000014, 42.97272695000005],
              [130.12149377400016, 42.98184784000004],
              [130.09431197200007, 42.976938578],
              [130.047286418, 42.96190073600012],
              [130.00821903500008, 42.96055714900005],
              [129.9957133380001, 42.96190073600012],
              [129.9813472900001, 42.96673248400005],
              [129.97173547400007, 42.97373464000013],
              [129.94155643700003, 43.00362945600007],
              [129.93411503100003, 43.00840952600005],
              [129.9206791590001, 43.010269878000074],
              [129.90920699100008, 43.00843536400005],
              [129.89070682800002, 42.999417827000016],
              [129.879751425, 42.9960330200001],
              [129.88409224500003, 42.98851409900006],
              [129.89008671100015, 42.982803854000096],
              [129.89773482300006, 42.978747253000094],
              [129.90703658100006, 42.976137593],
              [129.89329065000004, 42.97153839100004],
              [129.86311161300006, 42.968980408000036],
              [129.85174279800003, 42.96190073600012],
              [129.84760868300015, 42.95128123000005],
              [129.84667850800008, 42.92823354100007],
              [129.84151086400004, 42.91779490200004],
              [129.8341728110001, 42.907485454000025],
              [129.79903283700003, 42.83666290300009],
              [129.79500207600006, 42.80648386600008],
              [129.78952437400005, 42.79247955300009],
              [129.7735046800001, 42.76695139600004],
              [129.76130904200016, 42.74604827900008],
              [129.7572782800001, 42.73470530200008],
              [129.75562463400001, 42.722277120000015],
              [129.757588339, 42.70364776600006],
              [129.76440962700013, 42.6968523150001],
              [129.77453820900007, 42.693338318000045],
              [129.78652714100014, 42.68473419200011],
              [129.78756066900013, 42.67685353600008],
              [129.7793957930001, 42.67039398200002],
              [129.77226444600007, 42.66166066500004],
              [129.77670861800004, 42.647191264000114],
              [129.751077108, 42.642927958000044],
              [129.74156864400004, 42.62900116000007],
              [129.7462195230001, 42.615513611],
              [129.76306604000007, 42.61238718700007],
              [129.76306604000007, 42.606237692],
              [129.73650435400015, 42.58515370700006],
              [129.73144006400008, 42.550918071000055],
              [129.73361047400016, 42.511799011000036],
              [129.72885624200006, 42.47585805300007],
              [129.70332808500012, 42.44237172400007],
              [129.6711853440001, 42.43792755200006],
              [129.63346154900006, 42.44542063400009],
              [129.59170699100002, 42.44795277900006],
              [129.5956344, 42.435602112000126],
              [129.59449751800008, 42.42221791700008],
              [129.58767622900012, 42.411365866000025],
              [129.56318160000006, 42.40410532700007],
              [129.56028772000008, 42.39679311200008],
              [129.55946089700006, 42.3870004270001],
              [129.5541899010001, 42.37687184700006],
              [129.5453015550001, 42.37131663000007],
              [129.53517297400003, 42.36955963100009],
              [129.52680139200004, 42.37307362900013],
              [129.52339074700006, 42.38338307700003],
              [129.5170862230001, 42.39095367400007],
              [129.48887089100003, 42.40255503400003],
              [129.48246301300003, 42.410719910000054],
              [129.43409387200006, 42.44110565300012],
              [129.418797649, 42.44105397600002],
              [129.40618859900007, 42.435963847000025],
              [129.3954399010001, 42.43020192500005],
              [129.38624149600008, 42.42810902900008],
              [129.3720821540001, 42.43255320200008],
              [129.3630904540001, 42.445007223000076],
              [129.35213505000002, 42.44795277900006],
              [129.34014611800006, 42.4454723110001],
              [129.33859582500014, 42.43836680100007],
              [129.34376346800002, 42.42922007300008],
              [129.35213505000002, 42.42061594700006],
              [129.33787235600005, 42.414414775000054],
              [129.32650354000015, 42.42676544200002],
              [129.31544478400014, 42.42232126900011],
              [129.30707320200008, 42.407619324],
              [129.30376591000004, 42.389584249],
              [129.296634562, 42.387232971000074],
              [129.2430977790001, 42.378706361000056],
              [129.23606978400005, 42.374365540000085],
              [129.2311088460001, 42.367647603000066],
              [129.22800826000008, 42.35919850700007],
              [129.22862837800005, 42.35020680800001],
              [129.23420943300005, 42.34656361900004],
              [129.2403072520001, 42.34403147400003],
              [129.24227095600014, 42.33873464],
              [129.23627648900003, 42.32387766600006],
              [129.22614790900008, 42.31814158100009],
              [129.193901815, 42.31824493400005],
              [129.193901815, 42.31077769000011],
              [129.20372033700005, 42.31015757300004],
              [129.212401977, 42.30775461800009],
              [129.220670207, 42.30367218000008],
              [129.22800826000008, 42.29772939100006],
              [129.21612268100006, 42.29106313100006],
              [129.214158977, 42.28369923900006],
              [129.21477909300006, 42.27563771600005],
              [129.2111617430001, 42.267007752000026],
              [129.20289351500003, 42.26274444600004],
              [129.1921448170001, 42.259850566000054],
              [129.18335982300005, 42.25455373200002],
              [129.18077600100003, 42.24310740200012],
              [129.18687382000007, 42.236027731],
              [129.2093013920001, 42.23468414400013],
              [129.21426232900006, 42.225692444000074],
              [129.2111617430001, 42.219956360000126],
              [129.2042371020001, 42.214323629],
              [129.1963822840001, 42.209181824],
              [129.1776754160001, 42.19344635000003],
              [129.14801314300013, 42.173705953000066],
              [129.119797812, 42.14936635300005],
              [129.1055351160001, 42.14210581500008],
              [129.08848189400015, 42.14319102000006],
              [129.06471073400013, 42.153758850000045],
              [129.0634705, 42.13608551100005],
              [129.0533419200001, 42.122856344000056],
              [129.02657352700015, 42.10187571200005],
              [129.00890018800015, 42.09508026200008],
              [128.98502567600008, 42.092909852],
              [128.96383833800007, 42.08851735500012],
              [128.95484663900004, 42.075236511000114],
              [128.94006718000003, 42.03536814400006],
              [128.9034802650001, 42.02627309200001],
              [128.883171897, 42.03040885700007],
              [128.81707727100002, 42.043868918000086],
              [128.720959107, 42.047589621],
              [128.70928023300013, 42.03017466300007],
              [128.68251184100006, 42.025730489000054],
              [128.60789107300002, 42.03017466300007],
              [128.5975557870001, 42.02712575300005],
              [128.587737264, 42.019994406000095],
              [128.573681275, 42.00431060900003],
              [128.56437951700008, 42.00079661100007],
              [128.55332076100007, 42.00663604800006],
              [128.54370894400006, 42.00805714900007],
              [128.502367799, 41.996094055000086],
              [128.4883118090001, 41.9975151580001],
              [128.45399865800005, 42.01033091200007],
              [128.40759322100007, 42.008341370000025],
              [128.38712935400008, 42.02069203800009],
              [128.36377160700016, 42.02647979700005],
              [128.2619690350001, 42.032861837],
              [128.10053186000005, 41.99909128900002],
              [128.05464318900016, 41.99831614200009],
              [128.03459273300012, 41.993742778000055],
              [128.02146691900015, 41.979815979000065],
              [128.02043339100015, 41.96506235800008],
              [128.0399670820001, 41.87958953900004],
              [128.04782190000003, 41.863983256000026],
              [128.05764042200008, 41.849849752000054],
              [128.09102339800006, 41.84173655200006],
              [128.09701786300008, 41.822616272000076],
              [128.144250123, 41.75471344100002],
              [128.15489546700007, 41.733758647000016],
              [128.15913293500006, 41.71182200100007],
              [128.18600467900006, 41.69290842700012],
              [128.2241418870001, 41.66944732700004],
              [128.2509102790001, 41.66011973100002],
              [128.26899703000004, 41.64337656600007],
              [128.281399373, 41.62299021500003],
              [128.28325972500016, 41.605058492000055],
              [128.30300012200007, 41.58340606700007],
              [128.28760054600008, 41.54470041900005],
              [128.1856946210001, 41.40445058200005],
              [128.146110474, 41.37633860300009],
              [128.10394250500008, 41.37912913000007],
              [128.11820520100002, 41.39344350200007],
              [128.10394250500008, 41.399592998000045],
              [128.08812951700008, 41.38889597600003],
              [128.06415165200013, 41.38843088800009],
              [128.04689172400003, 41.3987661740001],
              [128.0506124270001, 41.42072865800007],
              [128.03366255700007, 41.41375234000007],
              [128.02384403500002, 41.41147857700007],
              [128.01516239500006, 41.413287252000046],
              [128.01154504500005, 41.42434600900005],
              [128.0130953370001, 41.44227773000004],
              [128.01237186700007, 41.46010610000006],
              [128.0014164630001, 41.470854798000076],
              [127.99273482300015, 41.461139629000044],
              [127.98446659400008, 41.4540082810001],
              [127.97423466100014, 41.4503392540001],
              [127.94421065300008, 41.470854798000076],
              [127.903592978, 41.46625559500005],
              [127.881475464, 41.460881246000085],
              [127.8718636480001, 41.453749899000044],
              [127.86514571200007, 41.43742014600009],
              [127.84886763600008, 41.431322327000046],
              [127.82886885700009, 41.433957825000064],
              [127.8103686930001, 41.44356964100008],
              [127.78463383000008, 41.43690338200007],
              [127.69027266500007, 41.438970439000045],
              [127.66267745000005, 41.446980286],
              [127.65812992400004, 41.446566874],
              [127.64707116800002, 41.4329759730001],
              [127.63833785000014, 41.42987538700005],
              [127.63068973900016, 41.43287262000008],
              [127.59751346900015, 41.4503392540001],
              [127.55880782100013, 41.45824574800007],
              [127.5447518310001, 41.46889109300007],
              [127.5428914790001, 41.491318665000065],
              [127.52583825700009, 41.48434234600005],
              [127.508474976, 41.488166402],
              [127.49100834100005, 41.49540110300005],
              [127.47411014900001, 41.49881174700009],
              [127.45710860200012, 41.49472930900008],
              [127.44305261300008, 41.48801137300005],
              [127.42734297800013, 41.483102112000026],
              [127.40512211100008, 41.484497376],
              [127.40134973200009, 41.486822815000025],
              [127.39592370700007, 41.491370341000064],
              [127.38848230000008, 41.49602122000003],
              [127.3789738370001, 41.49881174700009],
              [127.37111901900005, 41.49808827800008],
              [127.35370406100003, 41.49271392800004],
              [127.34424727400005, 41.491318665000065],
              [127.30512821500014, 41.49467763300005],
              [127.28636967, 41.49901845300003],
              [127.26905806500014, 41.50496124300007],
              [127.27515588400007, 41.50733835900009],
              [127.28357914200006, 41.51219594400003],
              [127.28978031500003, 41.518552145000044],
              [127.28895349200002, 41.52547678600003],
              [127.28146040900009, 41.53105784100005],
              [127.27469079600007, 41.530437725000084],
              [127.2674560960001, 41.52733713800005],
              [127.2583093670001, 41.52547678600003],
              [127.24451176000002, 41.52800893200002],
              [127.22198083500012, 41.54077301000008],
              [127.20709802300007, 41.5459406530001],
              [127.20032841000005, 41.54206492200005],
              [127.187254273, 41.52149770200005],
              [127.17970951300003, 41.51695017500002],
              [127.174335165, 41.51927561400005],
              [127.1703560790001, 41.523926494000094],
              [127.16513676, 41.528525696000074],
              [127.1559383550001, 41.53054107700011],
              [127.14239912900013, 41.523926494000094],
              [127.1346476650001, 41.5220144660001],
              [127.12823978800014, 41.531574605000074],
              [127.12085005700015, 41.53477854400005],
              [127.11196171100005, 41.53663889600007],
              [127.10467533400004, 41.53741404300008],
              [127.118007853, 41.55575917600005],
              [127.1365080160001, 41.56924672500013],
              [127.1578503830001, 41.57860015900006],
              [127.17970951300003, 41.58516306600005],
              [127.1660669360001, 41.59495575000001],
              [127.11397709200008, 41.610355327],
              [127.09723392800004, 41.612448222000054],
              [127.10188480700009, 41.62229258300003],
              [127.10467533400004, 41.6261683150001],
              [127.07403121000004, 41.635702616000074],
              [127.05899336800013, 41.643299052000046],
              [127.04943322800005, 41.653427633],
              [127.04545414300009, 41.66800038700005],
              [127.04896814000011, 41.67774139400011],
              [127.059613485, 41.68223724400012],
              [127.07661503100013, 41.68079030300002],
              [127.06834680200006, 41.693580221],
              [127.0467977300001, 41.71923756900007],
              [127.04266361600003, 41.73264760400012],
              [127.03315515200012, 41.731588237000025],
              [126.99963111400012, 41.752049230000026],
              [126.98116866100008, 41.763317566000055],
              [126.95858606000007, 41.7668057260001],
              [126.94613204000007, 41.76618560800004],
              [126.94065433800006, 41.771766663000065],
              [126.93962080900008, 41.7937291460001],
              [126.92980228700003, 41.80104136200002],
              [126.90851159700003, 41.79615793900008],
              [126.88711755400004, 41.78491831500013],
              [126.8774540610001, 41.773549500000044],
              [126.86479333500006, 41.747272034],
              [126.8088794360001, 41.729831238000045],
              [126.79627038600006, 41.70494903600009],
              [126.78862227400009, 41.695905661000054],
              [126.7713623460001, 41.70448394800006],
              [126.74154504400008, 41.729185282000074],
              [126.727282349, 41.73691090900009],
              [126.712502889, 41.74122589200006],
              [126.69658654800008, 41.74122589200006],
              [126.67948164900014, 41.735980733000034],
              [126.68712976100011, 41.72401763900008],
              [126.6996354580001, 41.7164212040001],
              [126.71415653500003, 41.70990997400004],
              [126.72795414300009, 41.70125417100009],
              [126.71224450800003, 41.694174500000074],
              [126.680101766, 41.67190195700003],
              [126.66930139200008, 41.66712188700002],
              [126.63395471200016, 41.66862050400003],
              [126.61788334200008, 41.6659333300001],
              [126.6020703530001, 41.64205881800011],
              [126.56703373200008, 41.61415354400013],
              [126.56651696800014, 41.60193206800001],
              [126.57726566600007, 41.58831532900011],
              [126.58088301700002, 41.575241191000046],
              [126.57726566600007, 41.561805318],
              [126.55876550300002, 41.53415842800008],
              [126.54222904500006, 41.488993225000016],
              [126.50760583500005, 41.44723866900007],
              [126.50130131100002, 41.434371236000075],
              [126.50827762900008, 41.40915313700013],
              [126.52212691200009, 41.377630514000074],
              [126.52212691200009, 41.351947327000076],
              [126.487658732, 41.344402568000035],
              [126.487658732, 41.351792298000035],
              [126.49375655100005, 41.35478953000005],
              [126.49649540200011, 41.35804514600004],
              [126.49820072500006, 41.361765849000065],
              [126.50130131100002, 41.36610666900013],
              [126.47251753800009, 41.36652008100005],
              [126.44089156100011, 41.34838165300003],
              [126.3914888920001, 41.3034231570001],
              [126.38058516500013, 41.29081410700006],
              [126.35733077000009, 41.249421285000025],
              [126.34616866100015, 41.237690735000044],
              [126.32100223900005, 41.21888051400002],
              [126.30953007000011, 41.20782175700002],
              [126.28436364800007, 41.16410349500005],
              [126.27475183200016, 41.15257965100001],
              [126.26069584200002, 41.143122864000034],
              [126.14742110200007, 41.09227325500002],
              [126.123753297, 41.07553009100009],
              [126.13817102100006, 41.056978252000036],
              [126.12644047100008, 41.04323232000009],
              [126.1115059820001, 41.032431946000074],
              [126.10132572500004, 41.02209665900007],
              [126.1040645760001, 41.009177552000054],
              [126.093367554, 41.00623199500005],
              [126.08370406100005, 41.00251129200005],
              [126.07564253800007, 40.99708526700006],
              [126.06928633600006, 40.989385478000074],
              [126.07197351100007, 40.980600485000096],
              [126.06582401600008, 40.96861155300003],
              [126.04551517800007, 40.94468536400002],
              [126.028565308, 40.93528025300007],
              [126.00954838100012, 40.93269643100008],
              [125.99203007100004, 40.92835561200009],
              [125.9805579020001, 40.91362782800009],
              [125.99662927300011, 40.91491973900004],
              [126.01001346900006, 40.91388621100005],
              [126.01533614200008, 40.909131979000065],
              [126.00784305900004, 40.899313457000105],
              [125.99507898000007, 40.894145813000094],
              [125.96427982600011, 40.89130361000012],
              [125.94960371900004, 40.88257029300006],
              [125.93616784700015, 40.87740264900005],
              [125.924023885, 40.88406890900005],
              [125.91229333500007, 40.894145813000094],
              [125.90154463700003, 40.899313457000105],
              [125.8852148850001, 40.89750478200001],
              [125.87270918800004, 40.8926988730001],
              [125.83167810100008, 40.870839743000076],
              [125.82196293100003, 40.86975453700008],
              [125.7791748460001, 40.884637349000016],
              [125.77080326400005, 40.88623931900004],
              [125.76093306500007, 40.885670878],
              [125.75473189300016, 40.88169179400002],
              [125.75075280800002, 40.87476715100003],
              [125.74589522300005, 40.86815256800013],
              [125.73700687700006, 40.86520701100004],
              [125.70641442900006, 40.860452779000056],
              [125.70408969200008, 40.85919462500003],
              [125.68321171100001, 40.847895407000024],
              [125.64481612100008, 40.810585023],
              [125.67334151200015, 40.78407501200009],
              [125.68264327000009, 40.76888214100005],
              [125.6686906330001, 40.76216420500005],
              [125.60993453000003, 40.761285706000095],
              [125.60812585500003, 40.76417958600008],
              [125.60032271400013, 40.772706198],
              [125.58652510600007, 40.78185292600007],
              [125.57174564700006, 40.78490183600012],
              [125.56006677300007, 40.77833892900013],
              [125.55536421800002, 40.758753561],
              [125.55334883600005, 40.73710113600002],
              [125.5464758710001, 40.72593902600009],
              [125.53309167500004, 40.72180491200008],
              [125.49164717600001, 40.72092641300013],
              [125.478779745, 40.718756002000035],
              [125.46906457500006, 40.71291656600006],
              [125.45981449400006, 40.70134104400002],
              [125.45692061400007, 40.69369293300004],
              [125.45630049700009, 40.67968862000002],
              [125.4529932050001, 40.6733840940001],
              [125.44369144800015, 40.668733215000046],
              [125.42632816600013, 40.67116200800011],
              [125.41888676000013, 40.66656280600007],
              [125.41515982600004, 40.652684880000024],
              [125.41495935100016, 40.651938375000086],
              [125.41712976200006, 40.63927764900005],
              [125.41325402900009, 40.63178456600009],
              [125.3908781340001, 40.63245636000009],
              [125.38457360900009, 40.63509185800011],
              [125.3724813230001, 40.64392852800002],
              [125.36359297700011, 40.64671905500008],
              [125.35604821800013, 40.646047262000096],
              [125.33666955600006, 40.641138001000044],
              [125.323182008, 40.64485870400007],
              [125.30819584200003, 40.64981964200011],
              [125.2933130290001, 40.64857940700007],
              [125.2771899820001, 40.64361847000002],
              [125.27098881000012, 40.63245636000009],
              [125.26483931500007, 40.62248280900009],
              [125.25610599800007, 40.615041402000074],
              [125.24241174300005, 40.611320699000046],
              [125.21641849800011, 40.60263905900008],
              [125.181536907, 40.593957418000045],
              [125.1530631930001, 40.58398386700013],
              [125.13306441200007, 40.572873433],
              [125.11461592700005, 40.564140117000036],
              [125.08965620900005, 40.55551015200008],
              [125.07358484000008, 40.54801707000006],
              [125.05002038600009, 40.54181589800005],
              [125.02511234500003, 40.534374492000055],
              [125.01529382300015, 40.521972148000074],
              [125.01529382300015, 40.508277894000045],
              [125.02769616800003, 40.49587555000009],
              [125.03885827700003, 40.48347320600003],
              [125.04629968300009, 40.47107086200005],
              [125.04128706900013, 40.46109731000003],
              [125.02630090400015, 40.45737660700003],
              [125.00661218300002, 40.45613637300009],
              [124.98661340400008, 40.45737660700003],
              [124.9595866300001, 40.453655904000115],
              [124.93529870600003, 40.45556793200002],
              [124.92589359600004, 40.45789337200007],
              [124.9179354260001, 40.46109731000003],
              [124.91514489800011, 40.46585154200004],
              [124.90563643400009, 40.47649688800003],
              [124.89550785400002, 40.48362823500007],
              [124.8906502690001, 40.477892152],
              [124.88382898000015, 40.46554148400004],
              [124.84987756400011, 40.431590068000034],
              [124.80083662900006, 40.39407297800004],
              [124.77985599800002, 40.383479310000055],
              [124.756808309, 40.37919016600007],
              [124.7412020270001, 40.37035349600008],
              [124.73128015200007, 40.34973459900009],
              [124.72296024600013, 40.32668691000002],
              [124.71246993, 40.31030548100007],
              [124.6930395920001, 40.30281239800003],
              [124.6426033940001, 40.29428578700002],
              [124.627203817, 40.28612091100008],
              [124.61118412300004, 40.272168275000084],
              [124.5708765060001, 40.252427877000045],
              [124.55485681100004, 40.24142079700006],
              [124.55175622600012, 40.23620147800004],
              [124.55020593300009, 40.22472930900001],
              [124.54865564000016, 40.22090525300008],
              [124.54302290900006, 40.21764963800008],
              [124.53237756400006, 40.21599599200003],
              [124.528191773, 40.21413564100003],
              [124.38556482000007, 40.110472718000054],
              [124.36996504000001, 40.098293361000074],
              [124.35824629000001, 40.089056708000044],
              [124.35694420700008, 40.07632070500006],
              [124.36255944100003, 40.04677969000005],
              [124.36402428500003, 40.02090078300006],
              [124.36133873800009, 40.01117584800005],
              [124.35230553500003, 39.99896881700005],
              [124.30787194100003, 39.96108633000006],
              [124.30298912900003, 39.95408763200004],
              [124.29908287900003, 39.94037506700005],
              [124.29420006600003, 39.93378327000005],
              [124.28671308700007, 39.929348049000055],
              [124.28028405000009, 39.92869700700004],
              [124.27369225400003, 39.928900458000044],
              [124.26636803500003, 39.926947333000044],
              [124.20215905000009, 39.878607489000046],
              [124.15503991000003, 39.861314195000034],
              [124.13721764400009, 39.84235260600008],
              [124.11817467500009, 39.83315664300005],
              [124.08814537900003, 39.85187409100007],
              [124.06690514400009, 39.83616771000004],
              [124.05543053500003, 39.82990143400008],
              [124.04102623800009, 39.82453034100007],
              [123.99805748800009, 39.81590403900009],
              [123.98568769600001, 39.810248114000046],
              [123.97510826900009, 39.81500885600008],
              [123.96778405000009, 39.82054271000004],
              [123.95492597700002, 39.83417389500005],
              [123.94214928500003, 39.84056224200009],
              [123.93067467500009, 39.83685944200005],
              [123.920258009, 39.82949453300006],
              [123.91065514400009, 39.82453034100007],
              [123.88754316500001, 39.82290273600006],
              [123.86036217500009, 39.82440827000005],
              [123.83407636800007, 39.82916901200008],
              [123.81446373800009, 39.837591864000046],
              [123.80762780000009, 39.837591864000046],
              [123.77304121200007, 39.818345445000034],
              [123.72006269600001, 39.83055247600004],
              [123.66968834700003, 39.85659414300005],
              [123.64307701900009, 39.878566799000055],
              [123.65674889400009, 39.91950104400007],
              [123.64014733200008, 39.91469961100006],
              [123.63095136800007, 39.903998114000046],
              [123.62623131600003, 39.889105536000045],
              [123.62256920700008, 39.87173086100006],
              [123.60157311300009, 39.81708405200004],
              [123.59766686300009, 39.792629299000055],
              [123.59140058700007, 39.78432851800005],
              [123.56373131600003, 39.77094147300005],
              [123.56324303500003, 39.768784898000035],
              [123.56324303500003, 39.770412502000056],
              [123.55372155000009, 39.77610911700009],
              [123.55079186300009, 39.77948639500005],
              [123.54737389400009, 39.78534577000005],
              [123.54184004000001, 39.79169342700004],
              [123.53321373800009, 39.79661692900004],
              [123.51319420700008, 39.79779694200005],
              [123.49561608200008, 39.790716864000046],
              [123.48153730600006, 39.77968984600005],
              [123.445648634, 39.73704661700009],
              [123.42774498800009, 39.726629950000074],
              [123.41041100400003, 39.73517487200007],
              [123.40845787900003, 39.74599844000005],
              [123.41041100400003, 39.79661692900004],
              [123.41309655000009, 39.80182526200008],
              [123.41822350400003, 39.80654531500005],
              [123.42115319100003, 39.81321849200009],
              [123.41708418100006, 39.82453034100007],
              [123.41163170700008, 39.82566966400009],
              [123.40308678500003, 39.823553778000075],
              [123.39820397200003, 39.818345445000034],
              [123.40357506600003, 39.810248114000046],
              [123.38672936300009, 39.78961823100008],
              [123.36451256600003, 39.785223700000074],
              [123.33936608200008, 39.78489817900004],
              [123.31405683700007, 39.77610911700009],
              [123.30298912900003, 39.784491278000075],
              [123.28500410200002, 39.80345286700009],
              [123.27320397200003, 39.810248114000046],
              [123.26417076900009, 39.797308661000045],
              [123.25717207100001, 39.80109284100007],
              [123.25277754000001, 39.81118398600006],
              [123.25204511800007, 39.81708405200004],
              [123.24472089900007, 39.81403229400007],
              [123.23804772200003, 39.80923086100006],
              [123.23585045700008, 39.802435614000046],
              [123.24219811300009, 39.79352448100008],
              [123.25277754000001, 39.782904364000046],
              [123.26351972700002, 39.767645575000074],
              [123.26539147200003, 39.75409577000005],
              [123.24903405000009, 39.74823639500005],
              [123.222992384, 39.75495026200008],
              [123.20997155000009, 39.75495026200008],
              [123.20419355600006, 39.74506256700005],
              [123.20639082100001, 39.73468659100007],
              [123.21216881600003, 39.73139069200005],
              [123.22079511800007, 39.73069896000004],
              [123.24227949300007, 39.725490627000056],
              [123.24927819100003, 39.72532786700009],
              [123.25513756600003, 39.72410716400009],
              [123.26295006600003, 39.718085028000075],
              [123.26913496200007, 39.70758698100008],
              [123.26587975400003, 39.70107656500005],
              [123.22315514400009, 39.679754950000074],
              [123.17432701900009, 39.66575755400004],
              [123.12842858200008, 39.66486237200007],
              [123.10800214900007, 39.69013092700004],
              [123.099945509, 39.68577708500004],
              [123.05811608200008, 39.67475006700005],
              [123.03980553500003, 39.673081773000035],
              [123.029633009, 39.674709377000056],
              [123.01661217500009, 39.67951080900008],
              [123.00912519600001, 39.68048737200007],
              [123.00570722700002, 39.677435614000046],
              [123.00058027400007, 39.671087958000044],
              [122.99195397200003, 39.66592031500005],
              [122.97763105600006, 39.66624583500004],
              [122.97763105600006, 39.65884023600006],
              [122.99634850400003, 39.649644273000035],
              [122.99244225400003, 39.636704820000034],
              [122.96412194100003, 39.61163971600007],
              [122.94491621200007, 39.61969635600008],
              [122.87159264400009, 39.60578034100007],
              [122.84864342500009, 39.61786530200004],
              [122.78817793100006, 39.572333075000074],
              [122.77979576900009, 39.56045156500005],
              [122.76913496200007, 39.55817291900007],
              [122.71078535200002, 39.53595612200007],
              [122.69654381600003, 39.523871161000045],
              [122.68824303500003, 39.51862213700008],
              [122.67676842500009, 39.51544830900008],
              [122.67294355600006, 39.519964911000045],
              [122.66098066500001, 39.52802155200004],
              [122.64844811300009, 39.532416083000044],
              [122.64258873800009, 39.52602773600006],
              [122.63656660200002, 39.50844961100006],
              [122.58790123800009, 39.46698639500005],
              [122.57691491000003, 39.47565338700008],
              [122.56910241000003, 39.48354726800005],
              [122.56210371200007, 39.486761786000045],
              [122.55323326900009, 39.481350002000056],
              [122.55323326900009, 39.47752513200004],
              [122.55722089900007, 39.47329336100006],
              [122.56104576900009, 39.467962958000044],
              [122.56006920700008, 39.46076080900008],
              [122.55543053500003, 39.45600006700005],
              [122.551117384, 39.455959377000056],
              [122.54647871200007, 39.45661041900007],
              [122.54004967500009, 39.454006252000056],
              [122.49561608200008, 39.42719147300005],
              [122.46981855600006, 39.41669342700004],
              [122.44703209700003, 39.41242096600007],
              [122.41382897200003, 39.41364166900007],
              [122.39633222700002, 39.411037502000056],
              [122.38331139400009, 39.39565664300005],
              [122.35596764400009, 39.387884833000044],
              [122.34473717500009, 39.382025458000044],
              [122.33326256600003, 39.37205638200004],
              [122.31885826900009, 39.36200592700004],
              [122.30355879000001, 39.35415273600006],
              [122.29004967500009, 39.35097890800006],
              [122.28370201900009, 39.343410549000055],
              [122.27711022200003, 39.32851797100005],
              [122.26742597700002, 39.318019924000055],
              [122.25147545700008, 39.32367584800005],
              [122.25074303500003, 39.31903717700004],
              [122.24952233200008, 39.31655508000006],
              [122.24537194100003, 39.310614325000074],
              [122.24024498800009, 39.28563060100004],
              [122.19857832100001, 39.251206773000035],
              [122.11500084700003, 39.20075104400007],
              [122.11670983200008, 39.188666083000044],
              [122.11060631600003, 39.174994208000044],
              [122.10401451900009, 39.16380442900004],
              [122.10450280000009, 39.15912506700005],
              [122.13583418100006, 39.15814850500004],
              [122.14991295700008, 39.15444570500006],
              [122.16268964900007, 39.146144924000055],
              [122.14267011800007, 39.14630768400008],
              [122.12745201900009, 39.14199453300006],
              [122.07333418100006, 39.10455963700008],
              [122.06397545700008, 39.10175202000005],
              [122.05567467500009, 39.10138580900008],
              [122.04786217500009, 39.09918854400007],
              [122.03931725400003, 39.09088776200008],
              [122.05128014400009, 39.06712474200009],
              [122.04232832100001, 39.05971914300005],
              [121.98804772200003, 39.062933661000045],
              [121.98047936300009, 39.05878327000005],
              [121.97128339900007, 39.04962799700007],
              [121.959320509, 39.04047272300005],
              [121.94296308700007, 39.03628164300005],
              [121.92945397200003, 39.03986237200007],
              [121.91724694100003, 39.04633209800005],
              [121.90430748800009, 39.04938385600008],
              [121.88843834700003, 39.04246653900009],
              [121.90194746200007, 39.03803131700005],
              [121.91293379000001, 39.03070709800005],
              [121.920258009, 39.02094147300005],
              [121.92318769600001, 39.008978583000044],
              [121.87940514400009, 39.027411200000074],
              [121.85596764400009, 39.03375885600008],
              [121.82691491000003, 39.03628164300005],
              [121.83798261800007, 39.01508209800005],
              [121.88013756600003, 38.99701569200005],
              [121.89527428500003, 38.98102448100008],
              [121.89478600400003, 38.970770575000074],
              [121.88754316500001, 38.96238841400009],
              [121.87134850400003, 38.95062897300005],
              [121.85987389400009, 38.944647528000075],
              [121.84791100400003, 38.94745514500005],
              [121.81153405000009, 38.97284577000005],
              [121.78711998800009, 39.00690338700008],
              [121.77247155000009, 39.02195872600004],
              [121.74488366000003, 39.03351471600007],
              [121.72470136800007, 39.030178127000056],
              [121.72006269600001, 39.019517320000034],
              [121.73878014400009, 39.008978583000044],
              [121.73878014400009, 39.00153229400007],
              [121.71045983200008, 39.006740627000056],
              [121.68018639400009, 39.008978583000044],
              [121.67090905000009, 39.00771719000005],
              [121.63575280000009, 38.995306708000044],
              [121.64926191500001, 38.99445221600007],
              [121.65601647200003, 38.99062734600005],
              [121.65780683700007, 38.98387278900009],
              [121.65634199300007, 38.97418854400007],
              [121.65259850400003, 38.96344635600008],
              [121.64779707100001, 38.95937734600005],
              [121.62891686300009, 38.954331773000035],
              [121.60434004000001, 38.95197174700007],
              [121.592133009, 38.94867584800005],
              [121.58741295700008, 38.94009023600006],
              [121.59253991000003, 38.935980536000045],
              [121.61817467500009, 38.92641836100006],
              [121.65919030000009, 38.92625560100004],
              [121.67676842500009, 38.921535549000055],
              [121.69361412900003, 38.90961334800005],
              [121.70362389400009, 38.891913153000075],
              [121.70484459700003, 38.873114325000074],
              [121.69629967500009, 38.862941799000055],
              [121.676117384, 38.871161200000074],
              [121.65479576900009, 38.857855536000045],
              [121.58106530000009, 38.862982489000046],
              [121.55274498800009, 38.85814036700009],
              [121.51221764400009, 38.82697174700007],
              [121.50489342500009, 38.82648346600007],
              [121.49887129000001, 38.81464264500005],
              [121.48495527400007, 38.809881903000075],
              [121.38013756600003, 38.81659577000005],
              [121.34473717500009, 38.81464264500005],
              [121.28760826900009, 38.78807200700004],
              [121.26075280000009, 38.79511139500005],
              [121.236664259, 38.798488674000055],
              [121.21753991000003, 38.77558014500005],
              [121.22559655000009, 38.77631256700005],
              [121.24472089900007, 38.77558014500005],
              [121.19849694100003, 38.727850653000075],
              [121.17953535200002, 38.72093333500004],
              [121.15308678500003, 38.72760651200008],
              [121.14136803500003, 38.74274323100008],
              [121.13241621200007, 38.75873444200005],
              [121.11451256600003, 38.76813385600008],
              [121.12411543100006, 38.77838776200008],
              [121.13404381600003, 38.78221263200004],
              [121.13925214900007, 38.789496161000045],
              [121.13485761800007, 38.809759833000044],
              [121.12777754000001, 38.81891510600008],
              [121.11793053500003, 38.828192450000074],
              [121.11133873800009, 38.840277411000045],
              [121.11451256600003, 38.85814036700009],
              [121.14014733200008, 38.874253648000035],
              [121.15235436300009, 38.88629791900007],
              [121.14852949300007, 38.89907461100006],
              [121.09042402400007, 38.89907461100006],
              [121.08619225400003, 38.90570709800005],
              [121.09620201900009, 38.92059967700004],
              [121.11793053500003, 38.943426825000074],
              [121.12875410200002, 38.947333075000074],
              [121.17953535200002, 38.954331773000035],
              [121.18881269600001, 38.95229726800005],
              [121.20199629000001, 38.94285716400009],
              [121.21070397200003, 38.94009023600006],
              [121.21949303500003, 38.94049713700008],
              [121.23438561300009, 38.94562409100007],
              [121.25684655000009, 38.949652411000045],
              [121.29184004000001, 38.96735260600008],
              [121.32032311300009, 38.966498114000046],
              [121.334320509, 38.96857330900008],
              [121.34034264400009, 38.97760651200008],
              [121.33814537900003, 38.985256252000056],
              [121.32886803500003, 39.00141022300005],
              [121.32675214900007, 39.01203034100007],
              [121.33423912900003, 39.026597398000035],
              [121.35230553500003, 39.03807200700004],
              [121.37484785200002, 39.044175523000035],
              [121.39551842500009, 39.04246653900009],
              [121.40333092500009, 39.038275458000044],
              [121.408539259, 39.032863674000055],
              [121.41920006600003, 39.01854075700004],
              [121.428070509, 39.01471588700008],
              [121.44149824300007, 39.01390208500004],
              [121.46729576900009, 39.01512278900009],
              [121.48633873800009, 39.019598700000074],
              [121.54647871200007, 39.049261786000045],
              [121.63233483200008, 39.06948476800005],
              [121.67408287900003, 39.08803945500006],
              [121.689789259, 39.11815013200004],
              [121.68100019600001, 39.136419989000046],
              [121.64918053500003, 39.15814850500004],
              [121.64193769600001, 39.176214911000045],
              [121.62989342500009, 39.17324453300006],
              [121.60670006600003, 39.18081289300005],
              [121.59262129000001, 39.19220612200007],
              [121.60792076900009, 39.20075104400007],
              [121.60596764400009, 39.20538971600007],
              [121.60336347700002, 39.216498114000046],
              [121.60165449300007, 39.22125885600008],
              [121.62631269600001, 39.22451406500005],
              [121.63306725400003, 39.23615143400008],
              [121.6040857700001, 39.252949595000075],
              [121.58993856400002, 39.264053964000084],
              [121.61198414700004, 39.274980894000066],
              [121.63697350400003, 39.272650458000044],
              [121.64193769600001, 39.27216217700004],
              [121.64698326900009, 39.264878648000035],
              [121.65845787900003, 39.266791083000044],
              [121.68018639400009, 39.27521393400008],
              [121.71778405000009, 39.296942450000074],
              [121.73609459700003, 39.311753648000035],
              [121.73829186300009, 39.319647528000075],
              [121.73129316500001, 39.33047109600005],
              [121.75350996200007, 39.35521067900004],
              [121.76514733200008, 39.36538320500006],
              [121.77979576900009, 39.37148672100005],
              [121.79127037900003, 39.37132396000004],
              [121.83749433700007, 39.36465078300006],
              [121.86548912900003, 39.37055084800005],
              [121.91504967500009, 39.395412502000056],
              [121.94296308700007, 39.39935944200005],
              [121.93124433700007, 39.417181708000044],
              [121.92237389400009, 39.415228583000044],
              [121.91268964900007, 39.40525950700004],
              [121.89869225400003, 39.39935944200005],
              [121.88095136800007, 39.39716217700004],
              [121.84888756600003, 39.38735586100006],
              [121.83065839900007, 39.38507721600007],
              [121.74537194100003, 39.39789459800005],
              [121.70777428500003, 39.39565664300005],
              [121.71778405000009, 39.37148672100005],
              [121.54892011800007, 39.36188385600008],
              [121.52588951900009, 39.36465078300006],
              [121.49195397200003, 39.38898346600007],
              [121.46143639400009, 39.47370026200008],
              [121.43604576900009, 39.50861237200007],
              [121.41993248800009, 39.516058661000045],
              [121.39950605600006, 39.52020905200004],
              [121.35401451900009, 39.52220286700009],
              [121.34042402400007, 39.51927317900004],
              [121.31942793100006, 39.50568268400008],
              [121.30616295700008, 39.50177643400008],
              [121.29981530000009, 39.50336334800005],
              [121.28248131600003, 39.512152411000045],
              [121.27271569100003, 39.51544830900008],
              [121.23682701900009, 39.51471588700008],
              [121.22779381600003, 39.518866278000075],
              [121.22339928500003, 39.528631903000075],
              [121.22852623800009, 39.536444403000075],
              [121.23837324300007, 39.54148997600004],
              [121.24854576900009, 39.543402411000045],
              [121.26000136500011, 39.563673366000046],
              [121.29151451900009, 39.586371161000045],
              [121.30616295700008, 39.59796784100007],
              [121.326508009, 39.60236237200007],
              [121.38218295200011, 39.601336840000045],
              [121.4498053850001, 39.615098025000066],
              [121.47071373800009, 39.632147528000075],
              [121.46387780000009, 39.645819403000075],
              [121.498165438, 39.65292419200006],
              [121.52588951900009, 39.61786530200004],
              [121.53329511800007, 39.622300523000035],
              [121.53614342500009, 39.626654364000046],
              [121.53720136800007, 39.63198476800005],
              [121.53956139400009, 39.63898346600007],
              [121.53768964900007, 39.64142487200007],
              [121.52784264400009, 39.649603583000044],
              [121.52588951900009, 39.65265534100007],
              [121.52865644600001, 39.655951239000046],
              [121.53768964900007, 39.66290924700007],
              [121.53956139400009, 39.66624583500004],
              [121.54232832100001, 39.66937897300005],
              [121.54737389400009, 39.673163153000075],
              [121.55014082100001, 39.67865631700005],
              [121.54647871200007, 39.686712958000044],
              [121.537445509, 39.69253164300005],
              [121.53028405000009, 39.69098541900007],
              [121.52401777400007, 39.68732330900008],
              [121.51840254000001, 39.686712958000044],
              [121.50684655000009, 39.69432200700004],
              [121.49086364000004, 39.720994069000085],
              [121.46387780000009, 39.73859284100007],
              [121.46265709700003, 39.741522528000075],
              [121.45980879000001, 39.74433014500005],
              [121.45728600400003, 39.748480536000045],
              [121.47418492300005, 39.75607402900005],
              [121.48461221900004, 39.764005018000034],
              [121.48732049700004, 39.77800009900005],
              [121.47754967500009, 39.786769924000055],
              [121.47152754000001, 39.80508047100005],
              [121.47071373800009, 39.810248114000046],
              [121.50991686300006, 39.824031398000045],
              [121.53589928500003, 39.861761786000045],
              [121.56629232600005, 39.85884151800008],
              [121.61609295800008, 39.87170050600008],
              [121.635971735, 39.89668676800005],
              [121.68490644600001, 39.92251211100006],
              [121.70712324300007, 39.926947333000044],
              [121.73438561300009, 39.92328522300005],
              [121.75464928500003, 39.91828034100007],
              [121.77442467500009, 39.92084381700005],
              [121.79965254000001, 39.94000885600008],
              [121.80380293100006, 39.94871653900009],
              [121.80518639400009, 39.95783112200007],
              [121.80966230600006, 39.96503327000005],
              [121.83602949300007, 39.971136786000045],
              [121.85474694100003, 39.98517487200007],
              [121.87378991000003, 39.991400458000044],
              [121.88013756600003, 39.99872467700004],
              [121.88095136800007, 40.00796133000006],
              [121.87476647200003, 40.01630280200004],
              [121.86475670700008, 40.01943594000005],
              [121.83790123800009, 40.02045319200005],
              [121.82691491000003, 40.02252838700008],
              [121.88046117600004, 40.041498612000055],
              [121.92946773000006, 40.077286453000056],
              [121.93311608200008, 40.10138580900008],
              [121.99566779300005, 40.12389527500005],
              [122.00635826900009, 40.156317450000074],
              [121.99146569100003, 40.18699778900009],
              [122.015961134, 40.18813711100006],
              [122.03858483200008, 40.19635651200008],
              [122.05884850400003, 40.20921458500004],
              [122.09164569300003, 40.22720738800007],
              [122.10230553500003, 40.24872467700004],
              [122.10751386800007, 40.262152411000045],
              [122.10938561300009, 40.275458075000074],
              [122.10816491000003, 40.28388092700004],
              [122.10865319100003, 40.29181549700007],
              [122.10611612000002, 40.310122817000035],
              [122.12868679100006, 40.325917007000044],
              [122.18032824700003, 40.352419843000064],
              [122.21102949300007, 40.38060130400004],
              [122.20362389400009, 40.42723216400009],
              [122.24195397200003, 40.42723216400009],
              [122.25009199300007, 40.43060944200005],
              [122.25098717500009, 40.43842194200005],
              [122.24976647200003, 40.447333075000074],
              [122.25147545700008, 40.45392487200007],
              [122.26563561300009, 40.461371161000045],
              [122.27955162900003, 40.465725002000056],
              [122.28809655000009, 40.47284577000005],
              [122.28687584700003, 40.488714911000045],
              [122.30184980600006, 40.50234609600005],
              [122.29395592500009, 40.52301666900007],
              [122.27564537900003, 40.54364655200004],
              [122.22486412900003, 40.57851797100005],
              [122.17649690600001, 40.58658253600004],
              [122.15043401500009, 40.60386446400008],
              [122.13758565700005, 40.624020286000075],
              [122.16797936300009, 40.653509833000044],
              [122.17066491000003, 40.68650950700004],
              [122.15943444100003, 40.701605536000045],
              [122.13697350400003, 40.68512604400007],
              [122.12183678500003, 40.680121161000045],
              [122.10865319100003, 40.69953034100007],
              [122.06714928500003, 40.73505280200004],
              [122.04908287900003, 40.746079820000034],
              [121.89718454000001, 40.80783650200004],
              [121.87200535, 40.81505719300009],
              [121.85108483200008, 40.83226146000004],
              [121.84376061300009, 40.85968659100007],
              [121.84058678500003, 40.91380442900004],
              [121.83619225400003, 40.91974518400008],
              [121.82837975400003, 40.93390534100007],
              [121.82593834700003, 40.94818756700005],
              [121.83749433700007, 40.954779364000046],
              [121.84888756600003, 40.95844147300005],
              [121.85889733200008, 40.96747467700004],
              [121.87476647200003, 40.989569403000075],
              [121.86793053500003, 40.995794989000046],
              [121.82601972700002, 40.97402578300006],
              [121.80738366000003, 40.96002838700008],
              [121.77770903800001, 40.93497152900005],
              [121.78005610600007, 40.907909722000056],
              [121.76920249300008, 40.888949284000034],
              [121.75838975800002, 40.87199238000005],
              [121.73955232000003, 40.849078718000044],
              [121.6944232940001, 40.84836295100007],
              [121.5949618630001, 40.845923568000046],
              [121.57504316500001, 40.841498114000046],
              [121.56763756600003, 40.84552643400008],
              [121.52888779, 40.86726698700005],
              [121.51042757300002, 40.87935670400009],
              [121.47999656000002, 40.88448912000007],
              [121.45020592500009, 40.885931708000044],
              [121.44092858200008, 40.89134349200003],
              [121.43685957100001, 40.89907461100006],
              [121.43458092500009, 40.90721263200004],
              [121.42977949300007, 40.91380442900004],
              [121.41846764400009, 40.91889069200005],
              [121.39454186300009, 40.92422109600005],
              [121.38477623800009, 40.93060944200005],
              [121.36133873800009, 40.93964264500005],
              [121.33725019600001, 40.928168036000045],
              [121.31552168100006, 40.910142320000034],
              [121.29932701900009, 40.899603583000044],
              [121.28565514400009, 40.89923737200007],
              [121.27393639400009, 40.90302155200004],
              [121.26490319100003, 40.91038646000004],
              [121.25839277400007, 40.92064036700003],
              [121.24472089900007, 40.90639883000006],
              [121.224945509, 40.927069403000075],
              [121.20028730600006, 40.93073151200008],
              [121.17579186300009, 40.922308661000045],
              [121.15536543100006, 40.90639883000006],
              [121.14242597700002, 40.90070221600007],
              [121.13062584700003, 40.89329661700003],
              [121.11996504000001, 40.88491445500006],
              [121.11109459700003, 40.87604401200008],
              [121.10604902400007, 40.87323639500005],
              [121.08358808700007, 40.86542389500005],
              [121.07992597700002, 40.862982489000046],
              [121.08008873800009, 40.857082424000055],
              [121.08114668100006, 40.85024648600006],
              [121.08017011800007, 40.844916083000044],
              [121.08027266400006, 40.82839510800005],
              [121.06572061200006, 40.818395836000036],
              [121.06835077700009, 40.80338908600004],
              [121.049850107, 40.797400734000064],
              [121.041923989, 40.81440147100005],
              [121.029633009, 40.82648346600007],
              [121.00497480600006, 40.83307526200008],
              [120.99097741000003, 40.831284898000035],
              [120.98194420700008, 40.82680898600006],
              [120.97046959700003, 40.81793854400007],
              [120.963226759, 40.80658600500004],
              [120.96705162900003, 40.79401276200008],
              [120.96851647200003, 40.78359609600005],
              [120.95785566500001, 40.774725653000075],
              [120.94385826900009, 40.76585521000004],
              [120.93628991000003, 40.755560614000046],
              [120.93954511800007, 40.74054596600007],
              [120.95603623200009, 40.73733066700004],
              [120.97584685800007, 40.73934102100009],
              [120.99439537900003, 40.73627350500004],
              [121.01026451900009, 40.73086172100005],
              [121.020737908, 40.719330067000044],
              [120.99564874300006, 40.715318538000076],
              [120.96263662700005, 40.709290141000054],
              [120.94019490100004, 40.691246239000066],
              [120.92302989300003, 40.68922261600005],
              [120.89530456400007, 40.68518129900008],
              [120.88477623800009, 40.68048737200007],
              [120.86768639400009, 40.67865631700005],
              [120.84776417300009, 40.68309677500008],
              [120.82532081500005, 40.67403348000005],
              [120.81959069100003, 40.65692780200004],
              [120.81641686300009, 40.64004140800006],
              [120.80860436300009, 40.618353583000044],
              [120.79843183700007, 40.599676825000074],
              [120.78858483200008, 40.59174225500004],
              [120.77003014400009, 40.58576080900008],
              [120.70011311600001, 40.53724422300007],
              [120.67878839700006, 40.52191605100006],
              [120.6696190030001, 40.50284098100008],
              [120.665702947, 40.49080019000007],
              [120.65911435200007, 40.48376149400008],
              [120.63331139400009, 40.47516510600008],
              [120.62094160200002, 40.47443268400008],
              [120.60409589900007, 40.46515534100007],
              [120.59701582100001, 40.45001862200007],
              [120.59848066500001, 40.43183014500005],
              [120.5973763720001, 40.42242315000004],
              [120.58407636800007, 40.413723049000055],
              [120.56210371200007, 40.411322333000044],
              [120.54566491000003, 40.402411200000074],
              [120.53907311300009, 40.382879950000074],
              [120.547526447, 40.37615916700008],
              [120.56731603700007, 40.38023714700006],
              [120.588395547, 40.384320341000034],
              [120.59115289700003, 40.36729769300007],
              [120.56486835200008, 40.35418214200007],
              [120.53458443400007, 40.34405893500008],
              [120.501757645, 40.32690995200005],
              [120.50098717500009, 40.307847398000035],
              [120.50131269600001, 40.291896877000056],
              [120.50660241000003, 40.27334219000005],
              [120.50489342500009, 40.24909088700008],
              [120.492523634, 40.23126862200007],
              [120.47201582100001, 40.21430084800005],
              [120.45069420700008, 40.20107656500005],
              [120.43604576900009, 40.19448476800005],
              [120.39435218400001, 40.19431209000004],
              [120.35800214900007, 40.19179922100005],
              [120.33358808700007, 40.18699778900009],
              [120.30902673000003, 40.17966794800009],
              [120.289474445, 40.16348444100004],
              [120.26132246200007, 40.14671458500004],
              [120.246356977, 40.144123369000056],
              [120.225469191, 40.134946995000064],
              [120.19393964900007, 40.126654364000046],
              [120.18897545700008, 40.126166083000044],
              [120.18319746200007, 40.12323639500005],
              [120.15496447700002, 40.111354927000036],
              [120.11842925100007, 40.10003543800008],
              [119.95027692000008, 40.05650213300004],
              [119.91531026300004, 40.03615345600008],
              [119.911798266, 40.01110570800006],
              [119.91199784800006, 39.99808813300007],
              [119.875500944, 39.99473907500004],
              [119.85018964900007, 39.986314195000034],
              [119.81104576900009, 39.97304922100005],
              [119.79249108200008, 39.96344635600008],
              [119.77442467500009, 39.950506903000075],
              [119.74964876900003, 39.952396744000055],
              [119.7082172590001, 39.93493496200006],
              [119.66089928500003, 39.93268463700008],
              [119.62061608200008, 39.911037502000056],
              [119.60303795700008, 39.90643952000005],
              [119.57186375200001, 39.904296285000044],
              [119.55369991300006, 39.89906255800008],
              [119.53559238800005, 39.89082558800004],
              [119.52491295700008, 39.87173086100006],
              [119.519867384, 39.858303127000056],
              [119.52489928500006, 39.841649302000064],
              [119.53069893500003, 39.81470221200004],
              [119.49552420000009, 39.813235671000086],
              [119.46679518000008, 39.81484778200007],
              [119.42940637800007, 39.795305952000035],
              [119.41153788600002, 39.778029364000076],
              [119.38586899000006, 39.75963047200008],
              [119.3678657160001, 39.74834820700005],
              [119.355804884, 39.73578522300005],
              [119.34986412900003, 39.731756903000075],
              [119.33961022200003, 39.71556224200009],
              [119.31405683700007, 39.64118073100008],
              [119.30233808700007, 39.61782461100006],
              [119.28492272200003, 39.59544505400004],
              [119.28101647200003, 39.59674713700008],
              [119.26758873800009, 39.59796784100007],
              [119.24537194100003, 39.59446849200009],
              [119.22323652400007, 39.58466217700004],
              [119.20858808700007, 39.569566148000035],
              [119.20899498800009, 39.55019765800006],
              [119.23267662900003, 39.56622955900008],
              [119.24301191500001, 39.57070547100005],
              [119.23804772200003, 39.56273021000004],
              [119.23414147200003, 39.554388739000046],
              [119.23121178500003, 39.54547760600008],
              [119.22934004000001, 39.53595612200007],
              [119.24268639400009, 39.54588450700004],
              [119.26239651600008, 39.57751181200007],
              [119.27014167200002, 39.58063606700006],
              [119.281398136, 39.57501372400009],
              [119.26198127500004, 39.53508424100005],
              [119.25642455900004, 39.49311137600006],
              [119.27076255400004, 39.489060804000076],
              [119.2971032150001, 39.455216619000055],
              [119.30507538100005, 39.432977787000084],
              [119.29612802500003, 39.41163902300008],
              [119.2794293290001, 39.38400560800005],
              [119.2556602730001, 39.36552154900005],
              [119.22584968500007, 39.35776693100007],
              [119.20334492500001, 39.36343799300005],
              [119.18480422500011, 39.35481411000006],
              [119.12926608300006, 39.29407360400006],
              [119.09376740800008, 39.26080836400007],
              [119.06234862200006, 39.23146551500008],
              [119.03931725400003, 39.212876695000034],
              [119.01563561300009, 39.18976471600007],
              [118.99350019600001, 39.17963288000004],
              [118.94019616000003, 39.13886139500005],
              [118.92603600400003, 39.13060130400004],
              [118.91041100400003, 39.125433661000045],
              [118.89429772200003, 39.12441640800006],
              [118.89429772200003, 39.13182200700004],
              [118.93189537900003, 39.15224844000005],
              [118.94198652400007, 39.15912506700005],
              [118.947601759, 39.16860586100006],
              [118.95069420700008, 39.179022528000075],
              [118.95630944100003, 39.18805573100008],
              [118.96998131600003, 39.19330475500004],
              [118.94556725400003, 39.19212474200009],
              [118.902679884, 39.176662502000056],
              [118.88062584700003, 39.17279694200005],
              [118.88550866000003, 39.185248114000046],
              [118.871429884, 39.200100002000056],
              [118.87378991000003, 39.21381256700005],
              [118.85897871200007, 39.20750560100004],
              [118.84053530200003, 39.17563023000008],
              [118.816200267, 39.16366540100006],
              [118.79599059200007, 39.15177712700006],
              [118.77469445200006, 39.14817017000007],
              [118.72777874000008, 39.14724971000004],
              [118.68720441900007, 39.153473287000054],
              [118.64908209600003, 39.15973155800009],
              [118.61935987000004, 39.16104245200006],
              [118.59015064900007, 39.14831235200006],
              [118.56049306700004, 39.147042929000065],
              [118.52711022200003, 39.14923737200007],
              [118.51937910200002, 39.13934967700004],
              [118.529146018, 39.124652763000086],
              [118.51214550700001, 39.115980154000056],
              [118.48709561800001, 39.102018411000074],
              [118.46910620000006, 39.09779346100004],
              [118.40995940100004, 39.06289983500005],
              [118.38011530900008, 39.050422282000056],
              [118.36035134000008, 39.04194827400005],
              [118.344269586, 39.03070861800006],
              [118.32609628900002, 39.03093224600008],
              [118.30012638000005, 39.040563804000044],
              [118.26785485100004, 39.043004120000035],
              [118.23528462200011, 39.053097566000076],
              [118.20712242500008, 39.076705813000046],
              [118.18680376100008, 39.11008019800005],
              [118.17093646400008, 39.135250764000034],
              [118.14052807300004, 39.17283510700008],
              [118.09640359000002, 39.20239193700007],
              [118.04537990800009, 39.21897204800007],
              [118.02801994200001, 39.219798051000055],
              [117.97372480600006, 39.216131903000075],
              [117.93116295700008, 39.212103583000044],
              [117.88559004000001, 39.20111725500004],
              [117.811815508, 39.15136979500005],
              [117.75733483200008, 39.114447333000044],
              [117.73755944100003, 39.10639069200005],
              [117.71542402400007, 39.111395575000074],
              [117.71827233200008, 39.093003648000035],
              [117.72664914300003, 39.08829118400007],
              [117.73781695600007, 39.078387182000085],
              [117.751477841, 39.06791408700008],
              [117.75748395000005, 39.04508591500007],
              [117.76577158100008, 39.02615531500004],
              [117.773615103, 38.99890416300008],
              [117.775263945, 38.981058362000056],
              [117.74325605600006, 38.98224518400008],
              [117.72950280000009, 38.984361070000034],
              [117.70191491000003, 38.995306708000044],
              [117.70435631600003, 38.98615143400008],
              [117.70557701900009, 38.984361070000034],
              [117.70875084700003, 38.98102448100008],
              [117.58399498800009, 38.81159088700008],
              [117.57837975400003, 38.792669989000046],
              [117.57626386800007, 38.77374909100007],
              [117.573222256, 38.71374780800005],
              [117.55877791300009, 38.69094144700006],
              [117.557246286, 38.67234853300005],
              [117.56047272400008, 38.657096624000076],
              [117.5529534530001, 38.64344657500004],
              [117.54354902400007, 38.62132396000004],
              [117.56597071300007, 38.61250744900008],
              [117.58043785300003, 38.58481046600008],
              [117.66804518100002, 38.44615737100008],
              [117.71608248500002, 38.37851093200004],
              [117.80389382300007, 38.29401812600008],
              [117.83716881600003, 38.27090078300006],
              [117.90015709700003, 38.246161200000074],
              [117.9416977510001, 38.23394647100008],
              [117.9633461090001, 38.21069368600007],
              [117.97754417700003, 38.19483706400007],
              [117.98899518300004, 38.19856575100005],
              [118.00719688600009, 38.19700984200006],
              [118.03822468700002, 38.18071770500006],
              [118.05372658700003, 38.17325326400004],
              [118.0577849340001, 38.161079362000066],
              [118.05240830600007, 38.153659066000046],
              [118.06521373100009, 38.143082037000056],
              [118.08179772200003, 38.140692450000074],
              [118.08480879000001, 38.138739325000074],
              [118.09579511800007, 38.14232005400004],
              [118.10767662900003, 38.14858633000006],
              [118.11923261800007, 38.15228913000004],
              [118.14608808700007, 38.14248281500005],
              [118.21583092500009, 38.144964911000045],
              [118.31202233200008, 38.12787506700005],
              [118.42400472600002, 38.11156859500005],
              [118.4489284440001, 38.10778712200005],
              [118.47250485200004, 38.101881035000076],
              [118.49415123800009, 38.093817450000074],
              [118.51229902400007, 38.08808014500005],
              [118.53394616000003, 38.07294342700004],
              [118.54297936300009, 38.068345445000034],
              [118.55062910200002, 38.070013739000046],
              [118.55689537900003, 38.073919989000046],
              [118.56153405000009, 38.07607656500005],
              [118.57300866000003, 38.07990143400008],
              [118.58350670700008, 38.089178778000075],
              [118.59937584700003, 38.11082591400009],
              [118.615777009, 38.12512038300008],
              [118.6548709430001, 38.145694596000055],
              [118.76035265500002, 38.15513204600006],
              [118.80543053500003, 38.15180084800005],
              [118.82506583500003, 38.151642167000034],
              [118.84009850400003, 38.15257396000004],
              [118.8982451820001, 38.12329876700005],
              [118.95003676100009, 38.09726186800009],
              [118.92481530000009, 38.05776601800005],
              [118.94198652400007, 38.04938385600008],
              [118.95614668100006, 38.03359609600005],
              [118.97339928500003, 37.99648672100005],
              [118.99659264400009, 37.96312083500004],
              [119.04840455700003, 37.94797820300005],
              [119.09249331, 37.91277311500005],
              [119.11694226300006, 37.85327074700007],
              [119.155697433, 37.82396426300005],
              [119.20683608900003, 37.802838559000065],
              [119.243083071, 37.76948233600007],
              [119.25959745600005, 37.71584741200007],
              [119.25566353600004, 37.67186657700006],
              [119.21773647400005, 37.67524798000005],
              [119.1893132240001, 37.70073456600005],
              [119.12014099700002, 37.737507864000065],
              [119.06947218100004, 37.74063064900008],
              [119.03712772600011, 37.72208882600006],
              [119.02752700200006, 37.703942931000086],
              [119.02540081300003, 37.68992311800008],
              [119.01075280000009, 37.65375397300005],
              [118.99244225400003, 37.63336823100008],
              [118.97665449300007, 37.61090729400007],
              [118.96998131600003, 37.593451239000046],
              [118.96778405000009, 37.57322825700004],
              [118.95785566500001, 37.53139883000006],
              [118.94459069100003, 37.378119208000044],
              [118.94947350400003, 37.33616771000004],
              [118.96119225400003, 37.29564036700009],
              [118.97242272200003, 37.28066640800006],
              [118.99048912900003, 37.274725653000075],
              [119.01474043100006, 37.26984284100007],
              [119.03012129000001, 37.257798570000034],
              [119.04273522200003, 37.24237702000005],
              [119.05860436300009, 37.22760651200008],
              [119.11500084700003, 37.20111725500004],
              [119.14551842500009, 37.17885976800005],
              [119.28711998800009, 37.13727448100008],
              [119.44117272200003, 37.12055084800005],
              [119.47510826900009, 37.13328685100004],
              [119.52450605600006, 37.13906484600005],
              [119.53858483200008, 37.137600002000056],
              [119.56348717500009, 37.141791083000044],
              [119.66073652400007, 37.137600002000056],
              [119.71680748800009, 37.14158763200004],
              [119.77059980600006, 37.15184153900009],
              [119.77890058700007, 37.16705963700008],
              [119.79184004000001, 37.180568752000056],
              [119.87745201900009, 37.23383209800005],
              [119.89730879000001, 37.24941640800006],
              [119.88672936300009, 37.28465403900009],
              [119.86353600400003, 37.321926174000055],
              [119.84628339900007, 37.34369538000004],
              [119.85889733200008, 37.36017487200007],
              [119.88233483200008, 37.370754299000055],
              [119.92896569100003, 37.38458893400008],
              [119.98829186300009, 37.413275458000044],
              [119.99781334700003, 37.42182038000004],
              [120.00904381600003, 37.42234935100004],
              [120.05982506600003, 37.44041575700004],
              [120.18759199300007, 37.511786200000074],
              [120.29761803500003, 37.59788646000004],
              [120.32252037900003, 37.63239166900007],
              [120.30640709700003, 37.66518789300005],
              [120.29379316500001, 37.67031484600005],
              [120.27857506600003, 37.67243073100008],
              [120.24756920700008, 37.67259349200009],
              [120.23536217500009, 37.67475006700005],
              [120.22291100400003, 37.67942942900004],
              [120.21566816500001, 37.68406810100004],
              [120.21998131600003, 37.68626536700009],
              [120.31185957100001, 37.68626536700009],
              [120.36850019600001, 37.69472890800006],
              [120.38599694100003, 37.70453522300005],
              [120.39136803500003, 37.706732489000046],
              [120.41098066500001, 37.712103583000044],
              [120.44312584700003, 37.73818594000005],
              [120.46338951900009, 37.747748114000046],
              [120.55616295700008, 37.761379299000055],
              [120.56454511800007, 37.76434967700004],
              [120.59359785200002, 37.78188711100006],
              [120.63526451900009, 37.788723049000055],
              [120.67432701900009, 37.801988023000035],
              [120.70492597700002, 37.82094961100006],
              [120.73804772200003, 37.833970445000034],
              [120.78492272200003, 37.82965729400007],
              [120.82162519600001, 37.81732819200005],
              [120.83668053500003, 37.81598541900007],
              [120.84644616000003, 37.81810130400004],
              [120.86597741000003, 37.82754140800006],
              [120.87769616000003, 37.82965729400007],
              [120.89942467500009, 37.827053127000056],
              [120.92579186300009, 37.81928131700005],
              [120.94076582100001, 37.80646393400008],
              [120.92880293100006, 37.788723049000055],
              [120.94092858200008, 37.77399323100008],
              [120.95687910200002, 37.76089101800005],
              [120.97535241000003, 37.75136953300006],
              [120.99463951900009, 37.747748114000046],
              [121.00538170700008, 37.74428945500006],
              [121.01148522200003, 37.73590729400007],
              [121.01612389400009, 37.72573476800005],
              [121.02198326900009, 37.71670156500005],
              [121.03256269600001, 37.71039459800005],
              [121.04354902400007, 37.71035390800006],
              [121.05469811300009, 37.71271393400008],
              [121.06666100400003, 37.71356842700004],
              [121.11329186300009, 37.708238023000035],
              [121.13795006600003, 37.701157945000034],
              [121.14852949300007, 37.68939850500004],
              [121.14242597700002, 37.67682526200008],
              [121.13217207100001, 37.664496161000045],
              [121.13013756600003, 37.65180084800005],
              [121.14852949300007, 37.637884833000044],
              [121.13550866000003, 37.626288153000075],
              [121.13436933700007, 37.610541083000044],
              [121.14210045700008, 37.59467194200005],
              [121.15536543100006, 37.58258698100008],
              [121.17164147200003, 37.57709381700005],
              [121.19149824300007, 37.57518138200004],
              [121.30811608200008, 37.581244208000044],
              [121.34473717500009, 37.59080638200004],
              [121.37452233200008, 37.610541083000044],
              [121.36060631600003, 37.63133372600004],
              [121.35401451900009, 37.637884833000044],
              [121.37216230600006, 37.63271719000005],
              [121.39356530000009, 37.62246328300006],
              [121.41407311300009, 37.60968659100007],
              [121.42977949300007, 37.596869208000044],
              [121.39844811300009, 37.59487539300005],
              [121.38143964900007, 37.58299388200004],
              [121.38168379000001, 37.566107489000046],
              [121.40170332100001, 37.54905833500004],
              [121.42457116000003, 37.536322333000044],
              [121.44678795700008, 37.519598700000074],
              [121.46395918100006, 37.49945709800005],
              [121.47071373800009, 37.47646719000005],
              [121.476898634, 37.468003648000035],
              [121.49146569100003, 37.462958075000074],
              [121.52222741000003, 37.45970286700009],
              [121.53711998800009, 37.456244208000044],
              [121.54981530000009, 37.44782135600008],
              [121.57032311300009, 37.42865631700005],
              [121.59164472700002, 37.42446523600006],
              [121.65162194100003, 37.43707916900007],
              [121.676117384, 37.43919505400004],
              [121.65487714900007, 37.45770905200004],
              [121.63428795700008, 37.46238841400009],
              [121.58741295700008, 37.453558661000045],
              [121.59278405000009, 37.46385325700004],
              [121.60254967500009, 37.471869208000044],
              [121.61304772200003, 37.47728099200009],
              [121.621429884, 37.480169989000046],
              [121.63502037900003, 37.48126862200007],
              [121.64478600400003, 37.47846100500004],
              [121.65235436300009, 37.474676825000074],
              [121.65943444100003, 37.472723700000074],
              [121.73243248800009, 37.46173737200007],
              [121.937836134, 37.46426015800006],
              [121.95728600400003, 37.45970286700009],
              [121.95728600400003, 37.453558661000045],
              [121.94906660200002, 37.44839101800005],
              [121.94459069100003, 37.440741278000075],
              [121.94459069100003, 37.432521877000056],
              [121.94979902400007, 37.42560455900008],
              [121.95728600400003, 37.423814195000034],
              [121.98804772200003, 37.42560455900008],
              [121.99740644600001, 37.43406810100004],
              [121.97779381600003, 37.47166575700004],
              [121.98121178500003, 37.480169989000046],
              [121.99463951900009, 37.48672109600005],
              [122.01636803500003, 37.517564195000034],
              [122.02564537900003, 37.52802155200004],
              [122.04379316500001, 37.53392161700009],
              [122.06153405000009, 37.537176825000074],
              [122.07178795700008, 37.54450104400007],
              [122.06714928500003, 37.56273021000004],
              [122.07333418100006, 37.56273021000004],
              [122.08204186300009, 37.55292389500005],
              [122.09506269600001, 37.54913971600007],
              [122.10946699300007, 37.55223216400009],
              [122.12183678500003, 37.56273021000004],
              [122.13949629000001, 37.55060455900008],
              [122.15186608200008, 37.532863674000055],
              [122.15259850400003, 37.514553127000056],
              [122.13550866000003, 37.50067780200004],
              [122.12989342500009, 37.48346588700008],
              [122.14144941500001, 37.45661041900007],
              [122.16211998800009, 37.43309153900009],
              [122.18319746200007, 37.41815827000005],
              [122.19776451900009, 37.43235911700009],
              [122.20972741000003, 37.447333075000074],
              [122.22421308700007, 37.45799388200004],
              [122.24537194100003, 37.45970286700009],
              [122.26181074300007, 37.45091380400004],
              [122.27857506600003, 37.423895575000074],
              [122.29647871200007, 37.41815827000005],
              [122.45704186300009, 37.41815827000005],
              [122.46151777400007, 37.419623114000046],
              [122.46607506600003, 37.42267487200007],
              [122.47120201900009, 37.42536041900007],
              [122.47803795700008, 37.42560455900008],
              [122.48218834700003, 37.42267487200007],
              [122.48495527400007, 37.41380442900004],
              [122.48804772200003, 37.41193268400008],
              [122.57056725400003, 37.401556708000044],
              [122.59164472700002, 37.404364325000074],
              [122.60092207100001, 37.41502513200004],
              [122.61239668100006, 37.41860586100006],
              [122.66504967500009, 37.414048570000034],
              [122.68043053500003, 37.41502513200004],
              [122.68824303500003, 37.409816799000055],
              [122.68873131600003, 37.38971588700008],
              [122.67896569100003, 37.374660549000055],
              [122.65609785200002, 37.38458893400008],
              [122.61459394600001, 37.37091705900008],
              [122.58505293100006, 37.35268789300005],
              [122.57740319100003, 37.34983958500004],
              [122.57081139400009, 37.34479401200008],
              [122.59115644600001, 37.314154364000046],
              [122.59473717500009, 37.29523346600007],
              [122.55762780000009, 37.31907786700009],
              [122.54965254000001, 37.31976959800005],
              [122.54908287900003, 37.31085846600007],
              [122.56006920700008, 37.274725653000075],
              [122.56666100400003, 37.26634349200009],
              [122.58985436300009, 37.243353583000044],
              [122.59473717500009, 37.23688385600008],
              [122.59669030000009, 37.22089264500005],
              [122.60287519600001, 37.20990631700005],
              [122.61353600400003, 37.20307038000004],
              [122.62891686300009, 37.199652411000045],
              [122.62891686300009, 37.19281647300005],
              [122.58521569100003, 37.188706773000035],
              [122.57431074300007, 37.18537018400008],
              [122.56324303500003, 37.173163153000075],
              [122.56885826900009, 37.165676174000055],
              [122.57715905000009, 37.15778229400007],
              [122.57431074300007, 37.14443594000005],
              [122.54346764400009, 37.15664297100005],
              [122.51002037900003, 37.15521881700005],
              [122.48267662900003, 37.139960028000075],
              [122.47071373800009, 37.11029694200005],
              [122.46444746200007, 37.11029694200005],
              [122.46583092500009, 37.14516836100006],
              [122.46444746200007, 37.15184153900009],
              [122.45394941500001, 37.154282945000034],
              [122.447601759, 37.14744700700004],
              [122.44434655000009, 37.13654205900008],
              [122.441742384, 37.11709219000005],
              [122.43628991000003, 37.09918854400007],
              [122.43637129000001, 37.08978913000004],
              [122.44052168100006, 37.08490631700005],
              [122.44752037900003, 37.08226146000004],
              [122.45411217500009, 37.077460028000075],
              [122.45704186300009, 37.06590403900009],
              [122.44849694100003, 37.05719635600008],
              [122.41122480600006, 37.03652578300006],
              [122.40235436300009, 37.021470445000034],
              [122.40919030000009, 37.006293036000045],
              [122.42432701900009, 37.00364817900004],
              [122.43702233200008, 37.01162344000005],
              [122.43637129000001, 37.02773672100005],
              [122.46119225400003, 37.03082916900007],
              [122.51303144600001, 37.02049388200004],
              [122.54004967500009, 37.02773672100005],
              [122.52540123800009, 36.94448476800005],
              [122.53272545700008, 36.92593008000006],
              [122.52645918100006, 36.91425202000005],
              [122.51734459700003, 36.90314362200007],
              [122.50741621200007, 36.89801666900007],
              [122.49854576900009, 36.90420156500005],
              [122.50009199300007, 36.91559479400007],
              [122.50904381600003, 36.92625560100004],
              [122.51270592500009, 36.93463776200008],
              [122.49854576900009, 36.93891022300005],
              [122.49390709700003, 36.93260325700004],
              [122.47730553500003, 36.92597077000005],
              [122.45663496200007, 36.92064036700009],
              [122.43995201900009, 36.91844310100004],
              [122.43051191500001, 36.92011139500005],
              [122.42090905000009, 36.923081773000035],
              [122.41220136800007, 36.92475006700005],
              [122.40577233200008, 36.92218659100007],
              [122.40219160200002, 36.914496161000045],
              [122.40341230600006, 36.90664297100005],
              [122.40748131600003, 36.900458075000074],
              [122.41260826900009, 36.89801666900007],
              [122.42139733200008, 36.89516836100006],
              [122.42945397200003, 36.88812897300005],
              [122.43515058700007, 36.87921784100007],
              [122.43637129000001, 36.87067291900007],
              [122.43100019600001, 36.86465078300006],
              [122.42066491000003, 36.86078522300005],
              [122.40235436300009, 36.85700104400007],
              [122.39722741000003, 36.85691966400009],
              [122.39332116000003, 36.85911692900004],
              [122.38990319100003, 36.86196523600006],
              [122.38559004000001, 36.86322663000004],
              [122.37973066500001, 36.861395575000074],
              [122.37777754000001, 36.857123114000046],
              [122.37720787900003, 36.85248444200005],
              [122.37574303500003, 36.84955475500004],
              [122.37118574300007, 36.84564850500004],
              [122.36109459700003, 36.83344147300005],
              [122.35523522200003, 36.82908763200004],
              [122.31983483200008, 36.82294342700004],
              [122.20028730600006, 36.84275950700004],
              [122.18531334700003, 36.84992096600007],
              [122.18067467500009, 36.866400458000044],
              [122.18482506600003, 36.88495514500005],
              [122.19686933700007, 36.89801666900007],
              [122.26587975400003, 36.89801666900007],
              [122.25294030000009, 36.905951239000046],
              [122.21119225400003, 36.91844310100004],
              [122.17465254000001, 36.941107489000046],
              [122.16268964900007, 36.94578685100004],
              [122.17855879000001, 36.98627350500004],
              [122.17969811300009, 37.00580475500004],
              [122.16610761800007, 37.014105536000045],
              [122.14999433700007, 37.00531647300005],
              [122.14795983200008, 36.98501211100006],
              [122.14918053500003, 36.962144273000035],
              [122.142914259, 36.94578685100004],
              [122.12842858200008, 36.94562409100007],
              [122.11011803500003, 36.95189036700009],
              [122.09433027400007, 36.95091380400004],
              [122.08765709700003, 36.929022528000075],
              [122.08090254000001, 36.91657135600008],
              [122.06519616000003, 36.90672435100004],
              [122.04688561300009, 36.90033600500004],
              [122.03305097700002, 36.89801666900007],
              [122.03541100400003, 36.91681549700007],
              [122.03475996200007, 36.941839911000045],
              [122.03760826900009, 36.96369049700007],
              [122.04981530000009, 36.973089911000045],
              [122.05380293100006, 36.97524648600006],
              [122.049164259, 36.97992584800005],
              [122.03964277400007, 36.98460521000004],
              [122.02930748800009, 36.986761786000045],
              [122.00416100400003, 36.986029364000046],
              [121.96143639400009, 36.99286530200004],
              [121.92628014400009, 36.99359772300005],
              [121.91488691500001, 36.98582591400009],
              [121.92335045700008, 36.96849192900004],
              [121.94979902400007, 36.93891022300005],
              [121.91513105600006, 36.92023346600007],
              [121.78598066500001, 36.89118073100008],
              [121.77686608200008, 36.88646067900004],
              [121.75586998800009, 36.872300523000035],
              [121.75180097700002, 36.86692942900004],
              [121.75001061300009, 36.857407945000034],
              [121.74488366000003, 36.84723541900007],
              [121.73715254000001, 36.839178778000075],
              [121.72803795700008, 36.835923570000034],
              [121.70850670700008, 36.83283112200007],
              [121.67147871200007, 36.81928131700005],
              [121.64942467500009, 36.816066799000055],
              [121.64942467500009, 36.822251695000034],
              [121.67408287900003, 36.833238023000035],
              [121.68417402400007, 36.835923570000034],
              [121.68417402400007, 36.84275950700004],
              [121.65821373800009, 36.84015534100007],
              [121.63746178500003, 36.831366278000075],
              [121.62452233200008, 36.81476471600007],
              [121.621429884, 36.788763739000046],
              [121.63209069100003, 36.76121653900009],
              [121.63428795700008, 36.74656810100004],
              [121.62525475400003, 36.74038320500006],
              [121.61255944100003, 36.74298737200007],
              [121.60352623800009, 36.749660549000055],
              [121.59766686300009, 36.75849030200004],
              [121.59424889400009, 36.767645575000074],
              [121.58301842500009, 36.76284414300005],
              [121.57300866000003, 36.76361725500004],
              [121.56006920700008, 36.767645575000074],
              [121.55038496200007, 36.76434967700004],
              [121.53711998800009, 36.75576406500005],
              [121.52588951900009, 36.753973700000074],
              [121.50350996200007, 36.76044342700004],
              [121.496429884, 36.77448151200008],
              [121.50318444100003, 36.78864166900007],
              [121.52222741000003, 36.794989325000074],
              [121.53711998800009, 36.79564036700009],
              [121.54737389400009, 36.798163153000075],
              [121.55518639400009, 36.80341217700004],
              [121.56324303500003, 36.81232330900008],
              [121.57300866000003, 36.819647528000075],
              [121.59522545700008, 36.82632070500006],
              [121.60474694100003, 36.83250560100004],
              [121.60718834700003, 36.844956773000035],
              [121.58814537900003, 36.84617747600004],
              [121.562836134, 36.84137604400007],
              [121.54647871200007, 36.835923570000034],
              [121.53809655000009, 36.82884349200009],
              [121.53052819100003, 36.81989166900007],
              [121.52222741000003, 36.812160549000055],
              [121.51156660200002, 36.808579820000034],
              [121.49813886800007, 36.81085846600007],
              [121.49423261800007, 36.81688060100004],
              [121.49227949300007, 36.823919989000046],
              [121.48438561300009, 36.82908763200004],
              [121.45948326900009, 36.82868073100008],
              [121.45297285200002, 36.816392320000034],
              [121.45801842500009, 36.801947333000044],
              [121.46729576900009, 36.794989325000074],
              [121.47071373800009, 36.78961823100008],
              [121.46615644600001, 36.77757396000004],
              [121.45337975400003, 36.75739166900007],
              [121.44483483200008, 36.75348541900007],
              [121.43246504000001, 36.75275299700007],
              [121.40894616000003, 36.753973700000074],
              [121.39014733200008, 36.74681224200009],
              [121.37777754000001, 36.73151276200008],
              [121.37940514400009, 36.71698639500005],
              [121.40170332100001, 36.71238841400009],
              [121.38526451900009, 36.70648834800005],
              [121.36841881600003, 36.70677317900004],
              [121.33350670700008, 36.71238841400009],
              [121.31421959700003, 36.711818752000056],
              [121.15772545700008, 36.66860586100006],
              [121.12802168100006, 36.65094635600008],
              [121.08969160200002, 36.616400458000044],
              [121.08017011800007, 36.61001211100006],
              [121.06275475400003, 36.61005280200004],
              [121.04249108200008, 36.62767161700009],
              [121.03248131600003, 36.624253648000035],
              [121.03077233200008, 36.61709219000005],
              [121.03402754000001, 36.59682851800005],
              [121.03248131600003, 36.589504299000055],
              [121.02352949300007, 36.58392975500004],
              [121.01465905000009, 36.58454010600008],
              [121.00611412900003, 36.58763255400004],
              [120.998383009, 36.589504299000055],
              [120.94467207100001, 36.59121328300006],
              [120.92880293100006, 36.59634023600006],
              [120.93653405000009, 36.61196523600006],
              [120.93336022200003, 36.62026601800005],
              [120.92212975400003, 36.62368398600006],
              [120.90552819100003, 36.624253648000035],
              [120.89267011800007, 36.62848541900007],
              [120.86475670700008, 36.64671458500004],
              [120.85059655000009, 36.65094635600008],
              [120.82406660200002, 36.64398834800005],
              [120.77084394600001, 36.617173570000034],
              [120.75058027400007, 36.616848049000055],
              [120.74732506600003, 36.60822174700007],
              [120.74691816500001, 36.603176174000055],
              [120.75001061300009, 36.59983958500004],
              [120.75757897200003, 36.59634023600006],
              [120.74732506600003, 36.57729726800005],
              [120.74227949300007, 36.555853583000044],
              [120.75025475400003, 36.54075755400004],
              [120.77865644600001, 36.541083075000074],
              [120.79379316500001, 36.55097077000005],
              [120.81356855600006, 36.583685614000046],
              [120.82642662900003, 36.59634023600006],
              [120.85035241000003, 36.60455963700008],
              [120.86459394600001, 36.597723700000074],
              [120.89478600400003, 36.56159088700008],
              [120.90528405000009, 36.557074286000045],
              [120.91407311300009, 36.55703359600005],
              [120.920258009, 36.55329010600008],
              [120.92261803500003, 36.53766510600008],
              [120.92750084700003, 36.532904364000046],
              [120.93848717500009, 36.534369208000044],
              [120.95020592500009, 36.54002513200004],
              [120.95679772200003, 36.54791901200008],
              [120.96363366000003, 36.54791901200008],
              [120.96143639400009, 36.53143952000005],
              [120.95191491000003, 36.51992422100005],
              [120.94117272200003, 36.50971100500004],
              [120.93628991000003, 36.49701569200005],
              [120.937836134, 36.48769765800006],
              [120.94996178500003, 36.45917389500005],
              [120.93433678500003, 36.45677317900004],
              [120.91952558700007, 36.45648834800005],
              [120.90626061300009, 36.452378648000035],
              [120.89478600400003, 36.438666083000044],
              [120.90097089900007, 36.42767975500004],
              [120.90137780000009, 36.41901276200008],
              [120.89828535200002, 36.41160716400009],
              [120.89039147200003, 36.39793528900009],
              [120.88266035200002, 36.388739325000074],
              [120.87427819100003, 36.38060130400004],
              [120.86744225400003, 36.37718333500004],
              [120.84970136800007, 36.38613515800006],
              [120.84400475400003, 36.42267487200007],
              [120.82642662900003, 36.432521877000056],
              [120.83204186300009, 36.45526764500005],
              [120.80689537900003, 36.46393463700008],
              [120.77247155000009, 36.46352773600006],
              [120.75058027400007, 36.45917389500005],
              [120.74781334700003, 36.45563385600008],
              [120.74048912900003, 36.44281647300005],
              [120.73707116000003, 36.438666083000044],
              [120.73170006600003, 36.43622467700004],
              [120.71900475400003, 36.43235911700009],
              [120.71412194100003, 36.42869700700004],
              [120.68653405000009, 36.387152411000045],
              [120.69068444100003, 36.37083567900004],
              [120.70956464900007, 36.34935130400004],
              [120.72217858200008, 36.33055247600004],
              [120.70728600400003, 36.32265859600005],
              [120.693695509, 36.32489655200004],
              [120.66903730600006, 36.33462148600006],
              [120.66195722700002, 36.33633047100005],
              [120.64771569100003, 36.33087799700007],
              [120.64364668100006, 36.32249583500004],
              [120.64869225400003, 36.31240469000005],
              [120.66195722700002, 36.30149974200009],
              [120.65455162900003, 36.288275458000044],
              [120.66024824300007, 36.277329820000034],
              [120.67042076900009, 36.26581452000005],
              [120.67562910200002, 36.25063711100006],
              [120.68751061300009, 36.18789297100005],
              [120.69336998800009, 36.17487213700008],
              [120.70484459700003, 36.156236070000034],
              [120.69678795700008, 36.14398834800005],
              [120.62777754000001, 36.116522528000075],
              [120.62387129000001, 36.11766185100004],
              [120.62061608200008, 36.12128327000005],
              [120.61670983200008, 36.12335846600007],
              [120.59359785200002, 36.10976797100005],
              [120.56519616000003, 36.11579010600008],
              [120.55160566500001, 36.113714911000045],
              [120.54590905000009, 36.09975820500006],
              [120.53622480600006, 36.091457424000055],
              [120.51417076900009, 36.08856842700004],
              [120.47364342500009, 36.08926015800006],
              [120.46192467500009, 36.08576080900008],
              [120.43563886800007, 36.06850820500006],
              [120.42172285200002, 36.06195709800005],
              [120.369476759, 36.04877350500004],
              [120.35352623800009, 36.04083893400008],
              [120.33936608200008, 36.04995351800005],
              [120.32471764400009, 36.05719635600008],
              [120.30909264400009, 36.06150950700004],
              [120.29200280000009, 36.06195709800005],
              [120.29200280000009, 36.06810130400004],
              [120.30844160200002, 36.07953522300005],
              [120.31226647200003, 36.09129466400009],
              [120.31348717500009, 36.10447825700004],
              [120.32276451900009, 36.11994049700007],
              [120.33497155000009, 36.13613515800006],
              [120.36158287900003, 36.19163646000004],
              [120.34848066500001, 36.21336497600004],
              [120.33920332100001, 36.22260163000004],
              [120.32276451900009, 36.22638580900008],
              [120.31177819100003, 36.26585521000004],
              [120.30640709700003, 36.27423737200007],
              [120.28646894600001, 36.26382070500006],
              [120.27352949300007, 36.23427969000005],
              [120.27515709700003, 36.20408763200004],
              [120.29883873800009, 36.19163646000004],
              [120.28451582100001, 36.17597077000005],
              [120.26425214900007, 36.180853583000044],
              [120.24398847700002, 36.191107489000046],
              [120.22999108200008, 36.19163646000004],
              [120.22608483200008, 36.19407786700009],
              [120.22388756600003, 36.196519273000035],
              [120.22128339900007, 36.19839101800005],
              [120.21631920700008, 36.19912344000005],
              [120.219086134, 36.221909898000035],
              [120.18677819100003, 36.21906159100007],
              [120.14454186300009, 36.20888906500005],
              [120.11727949300007, 36.20966217700004],
              [120.11239668100006, 36.21747467700004],
              [120.11142011800007, 36.222723700000074],
              [120.10816491000003, 36.22553131700005],
              [120.09717858200008, 36.22638580900008],
              [120.09286543100006, 36.22321198100008],
              [120.08790123800009, 36.21621328300006],
              [120.08594811300009, 36.20913320500006],
              [120.09034264400009, 36.205959377000056],
              [120.10531660200002, 36.200873114000046],
              [120.10922285200002, 36.188788153000075],
              [120.10523522200003, 36.17422109600005],
              [120.08936608200008, 36.147691148000035],
              [120.08643639400009, 36.13003164300005],
              [120.08969160200002, 36.11172109600005],
              [120.10018964900007, 36.09609609600005],
              [120.11679121200007, 36.087591864000046],
              [120.13575280000009, 36.08340078300006],
              [120.15406334700003, 36.077053127000056],
              [120.16846764400009, 36.06195709800005],
              [120.17188561300009, 36.046128648000035],
              [120.17074629000001, 36.008693752000056],
              [120.17530358200008, 35.99363841400009],
              [120.18604576900009, 35.98452383000006],
              [120.19776451900009, 35.98529694200005],
              [120.22999108200008, 35.99990469000005],
              [120.22950280000009, 35.97280508000006],
              [120.24276777400007, 35.97357819200005],
              [120.27491295700008, 35.99363841400009],
              [120.28077233200008, 35.99823639500005],
              [120.28199303500003, 36.00665924700007],
              [120.28492272200003, 36.010931708000044],
              [120.29542076900009, 36.00332265800006],
              [120.303070509, 35.99404531500005],
              [120.30526777400007, 35.98700592700004],
              [120.30347741000003, 35.980536200000074],
              [120.29883873800009, 35.97313060100004],
              [120.28443444100003, 35.962591864000046],
              [120.24439537900003, 35.95307038000004],
              [120.22681725400003, 35.941839911000045],
              [120.18515058700007, 35.90375397300005],
              [120.17530358200008, 35.89004140800006],
              [120.17050214900007, 35.907456773000035],
              [120.17945397200003, 35.92007070500006],
              [120.18970787900003, 35.93154531500005],
              [120.18897545700008, 35.94525788000004],
              [120.16846764400009, 35.93842194200005],
              [120.16285241000003, 35.933294989000046],
              [120.14551842500009, 35.91380442900004],
              [120.14185631600003, 35.90794505400004],
              [120.13575280000009, 35.90412018400008],
              [120.10718834700003, 35.903998114000046],
              [120.09717858200008, 35.900824286000045],
              [120.05225670700008, 35.862616278000075],
              [120.03882897200003, 35.84284088700008],
              [120.01978600400003, 35.759751695000034],
              [120.00294030000009, 35.727769273000035],
              [119.96998131600003, 35.73236725500004],
              [119.94971764400009, 35.75381094000005],
              [119.93775475400003, 35.76113515800006],
              [119.92554772200003, 35.75682200700004],
              [119.90821373800009, 35.74485911700009],
              [119.90015709700003, 35.73627350500004],
              [119.93124433700007, 35.71084219000005],
              [119.93563886800007, 35.70502350500004],
              [119.93075605600006, 35.69953034100007],
              [119.90829511800007, 35.680894273000035],
              [119.90162194100003, 35.671535549000055],
              [119.90048261800007, 35.66054922100005],
              [119.90292402400007, 35.652411200000074],
              [119.90674889400009, 35.64447663000004],
              [119.90845787900003, 35.633978583000044],
              [119.90455162900003, 35.62457916900007],
              [119.89559980600006, 35.620306708000044],
              [119.88526451900009, 35.617621161000045],
              [119.87745201900009, 35.61318594000005],
              [119.86019941500001, 35.60610586100006],
              [119.84327233200008, 35.61579010600008],
              [119.83407636800007, 35.63532135600008],
              [119.84009850400003, 35.657904364000046],
              [119.81161543100006, 35.64789459800005],
              [119.77100670700008, 35.59332916900007],
              [119.74390709700003, 35.57591380400004],
              [119.74805748800009, 35.59979889500005],
              [119.748383009, 35.60932038000004],
              [119.74390709700003, 35.616888739000046],
              [119.73251386800007, 35.62083567900004],
              [119.71876061300009, 35.61953359600005],
              [119.70712324300007, 35.614162502000056],
              [119.70240319100003, 35.60602448100008],
              [119.69678795700008, 35.59943268400008],
              [119.68384850400003, 35.59398021000004],
              [119.66895592500009, 35.59031810100004],
              [119.65772545700008, 35.58893463700008],
              [119.64795983200008, 35.58392975500004],
              [119.64136803500003, 35.57200755400004],
              [119.63412519600001, 35.548041083000044],
              [119.60409589900007, 35.48802317900004],
              [119.59986412900003, 35.469183661000045],
              [119.59595787900003, 35.46198151200008],
              [119.56959069100003, 35.434759833000044],
              [119.56454511800007, 35.424709377000056],
              [119.56226647200003, 35.40062083500004],
              [119.558929884, 35.390326239000046],
              [119.55152428500003, 35.38003164300005],
              [119.52230879000001, 35.352728583000044],
              [119.51351972700002, 35.33930084800005],
              [119.50766035200002, 35.33234284100007],
              [119.46957441500001, 35.321478583000044],
              [119.43580162900003, 35.32257721600007],
              [119.42872155000009, 35.321478583000044],
              [119.42392011800007, 35.31346263200004],
              [119.42188561300009, 35.30052317900004],
              [119.42188561300009, 35.277411200000074],
              [119.41871178500003, 35.27130768400008],
              [119.40455162900003, 35.25372955900008],
              [119.38770592500009, 35.20538971600007],
              [119.37061608200008, 35.11741771000004],
              [119.35800214900007, 35.09711334800005],
              [119.33619225400003, 35.08869049700007],
              [119.31430097700002, 35.08624909100007],
              [119.28028405000009, 35.076605536000045],
              [119.25049889400009, 35.06818268400008],
              [119.22909589900007, 35.066107489000046],
              [119.22120201900009, 35.06403229400007],
              [119.21265709700003, 35.05801015800006],
              [119.20728600400003, 35.04840729400007],
              [119.20394941500001, 35.02496979400007],
              [119.19931074300007, 35.01666901200008],
              [119.19288170700008, 35.000433661000045],
              [119.19288170700008, 34.97402578300006],
              [119.19703209700003, 34.947699286000045],
              [119.20337975400003, 34.931626695000034],
              [119.18869763400005, 34.856274168000084],
              [119.19312584700003, 34.809881903000075],
              [119.20191491000003, 34.78497955900008],
              [119.18905683700007, 34.76654694200005],
              [119.19532311300009, 34.75971100500004],
              [119.19027754000001, 34.749253648000035],
              [119.18873131600003, 34.73305898600006],
              [119.19223066500001, 34.71820709800005],
              [119.20337975400003, 34.71190013200004],
              [119.20980879000001, 34.71857330900008],
              [119.22095787900003, 34.74941640800006],
              [119.22934004000001, 34.75971100500004],
              [119.24179121200007, 34.76166413000004],
              [119.291351759, 34.75348541900007],
              [119.31177819100003, 34.755072333000044],
              [119.32496178500003, 34.75999583500004],
              [119.33505293100006, 34.76850006700005],
              [119.34669030000009, 34.78082916900007],
              [119.35800214900007, 34.774603583000044],
              [119.37558027400007, 34.75934479400007],
              [119.38770592500009, 34.75348541900007],
              [119.40145918100006, 34.75112539300005],
              [119.42823326900009, 34.74994538000004],
              [119.44223066500001, 34.74603913000004],
              [119.463226759, 34.73236725500004],
              [119.47421308700007, 34.715277411000045],
              [119.47274824300007, 34.698146877000056],
              [119.45655358200008, 34.68455638200004],
              [119.53174889400009, 34.61570872600004],
              [119.58871504000001, 34.58222077000005],
              [119.59986412900003, 34.56854889500005],
              [119.60922285200002, 34.56273021000004],
              [119.640961134, 34.55052317900004],
              [119.640961134, 34.54572174700007],
              [119.64144941500001, 34.54083893400008],
              [119.64340254000001, 34.53656647300005],
              [119.64771569100003, 34.53384023600006],
              [119.65845787900003, 34.53156159100007],
              [119.68531334700003, 34.53384023600006],
              [119.70533287900003, 34.53115469000005],
              [119.728851759, 34.52411530200004],
              [119.75123131600003, 34.51422760600008],
              [119.795258009, 34.481675523000035],
              [119.82618248800009, 34.470404364000046],
              [119.86207116000003, 34.46580638200004],
              [119.90503991000003, 34.464911200000074],
              [119.93995201900009, 34.457912502000056],
              [119.98292076900009, 34.440741278000075],
              [120.02295983200008, 34.41937897300005],
              [120.07870527400007, 34.37750885600008],
              [120.11817467500009, 34.35960521000004],
              [120.23975670700008, 34.32367584800005],
              [120.25709069100003, 34.311835028000075],
              [120.264008009, 34.29075755400004],
              [120.26669355600006, 34.26630280200004],
              [120.27418053500003, 34.24453359600005],
              [120.29883873800009, 34.20425039300005],
              [120.30937427900005, 34.17407134900009],
              [120.317212315, 34.152123405000054],
              [120.32496554200009, 34.13645107200006],
              [120.3252237590001, 34.111297999000044],
              [120.34823652400007, 34.07684967700004],
              [120.35352623800009, 34.06077708500004],
              [120.35849043100006, 34.05345286700009],
              [120.36532636800007, 34.04564036700009],
              [120.37134850400003, 34.036037502000056],
              [120.38502037900003, 33.970404364000046],
              [120.40796959700003, 33.91681549700007],
              [120.41334069100003, 33.897365627000056],
              [120.41260826900009, 33.88751862200007],
              [120.39844811300009, 33.878973700000074],
              [120.39966881600003, 33.86933014500005],
              [120.40707441500001, 33.85976797100005],
              [120.41895592500009, 33.85537344000005],
              [120.43140709700003, 33.84601471600007],
              [120.44336998800009, 33.82469310100004],
              [120.45093834700003, 33.80149974200009],
              [120.44971764400009, 33.786444403000075],
              [120.46412194100003, 33.77496979400007],
              [120.48243248800009, 33.76512278900009],
              [120.49830162900003, 33.75332265800006],
              [120.50489342500009, 33.735581773000035],
              [120.50586998800009, 33.69717031500005],
              [120.51172936300009, 33.65672435100004],
              [120.50269616000003, 33.66156647300005],
              [120.49512780000009, 33.662176825000074],
              [120.48902428500003, 33.65839264500005],
              [120.48373457100001, 33.64996979400007],
              [120.52597089900007, 33.610663153000075],
              [120.53907311300009, 33.59467194200005],
              [120.56324303500003, 33.54800039300005],
              [120.57325280000009, 33.533270575000074],
              [120.62777754000001, 33.47801341400009],
              [120.63436933700007, 33.46694570500006],
              [120.65211022200003, 33.42812734600005],
              [120.65577233200008, 33.41315338700008],
              [120.66195722700002, 33.33803945500006],
              [120.66724694100003, 33.325100002000056],
              [120.680023634, 33.30801015800006],
              [120.69507897200003, 33.29315827000005],
              [120.70728600400003, 33.286810614000046],
              [120.72046959700003, 33.28497955900008],
              [120.73788496200007, 33.279282945000034],
              [120.75025475400003, 33.269598700000074],
              [120.74756920700008, 33.25580475500004],
              [120.74268639400009, 33.25267161700009],
              [120.73707116000003, 33.25092194200005],
              [120.73218834700003, 33.24823639500005],
              [120.73023522200003, 33.24213288000004],
              [120.73251386800007, 33.23712799700007],
              [120.742523634, 33.227769273000035],
              [120.74439537900003, 33.22410716400009],
              [120.74350019600001, 33.208644924000055],
              [120.74008222700002, 33.205511786000045],
              [120.73023522200003, 33.20490143400008],
              [120.78524824300007, 33.16502513200004],
              [120.806976759, 33.13776276200008],
              [120.79224694100003, 33.108710028000075],
              [120.81251061300009, 33.10578034100007],
              [120.81893964900007, 33.09218984600005],
              [120.81959069100003, 33.05410390800006],
              [120.82593834700003, 33.030178127000056],
              [120.83375084700003, 33.02562083500004],
              [120.84644616000003, 33.02985260600008],
              [120.86744225400003, 33.03237539300005],
              [120.89014733200008, 33.02610911700009],
              [120.89576256600003, 33.01357656500005],
              [120.88851972700002, 32.977728583000044],
              [120.88868248800009, 32.96271393400008],
              [120.90780683700007, 32.84389883000006],
              [120.90479576900009, 32.81264883000006],
              [120.88030821400002, 32.77203182900007],
              [120.85238691500001, 32.75600820500006],
              [120.86142011800007, 32.71967194200005],
              [120.86044355600006, 32.68976471600007],
              [120.85018964900007, 32.696600653000075],
              [120.84310957100001, 32.70392487200007],
              [120.84140058700007, 32.71108633000006],
              [120.84693444100003, 32.717678127000056],
              [120.84009850400003, 32.72451406500005],
              [120.83017011800007, 32.709418036000045],
              [120.83033287900003, 32.69765859600005],
              [120.863868238, 32.67105755700004],
              [120.90661411500002, 32.65971027300009],
              [120.91119932700008, 32.630121296000084],
              [120.94388695400005, 32.60522416300006],
              [120.97502096700009, 32.59511507700006],
              [121.02070551400004, 32.568521788000055],
              [121.04278207100003, 32.55754181600008],
              [121.06625410200002, 32.54401276200008],
              [121.08619225400003, 32.536037502000056],
              [121.09872480600006, 32.521144924000055],
              [121.10084069100003, 32.49795156500005],
              [121.10767662900003, 32.49795156500005],
              [121.12020918100006, 32.50739166900007],
              [121.157256416, 32.49559551700008],
              [121.1737999820001, 32.487625079000054],
              [121.191507408, 32.47865253500004],
              [121.21510394400002, 32.472664414000064],
              [121.2717099360001, 32.44773449200005],
              [121.35413965600003, 32.41482275900006],
              [121.38940888400009, 32.38494757500007],
              [121.40111730900003, 32.35213194900007],
              [121.41602623800009, 32.26894765800006],
              [121.41773522200003, 32.25527578300006],
              [121.41928144600001, 32.25031159100007],
              [121.41578209700003, 32.24860260600008],
              [121.40170332100001, 32.24469635600008],
              [121.37720787900003, 32.24164459800005],
              [121.36670983200008, 32.23895905200004],
              [121.36085045700008, 32.231634833000044],
              [121.36801191500001, 32.22736237200007],
              [121.39869225400003, 32.16893138200004],
              [121.42514082100001, 32.164048570000034],
              [121.43116295700008, 32.15135325700004],
              [121.43213951900009, 32.13385651200008],
              [121.44336998800009, 32.11432526200008],
              [121.44947350400003, 32.11273834800005],
              [121.45614668100006, 32.11554596600007],
              [121.46241295700008, 32.11969635600008],
              [121.46729576900009, 32.12177155200004],
              [121.472992384, 32.11961497600004],
              [121.48194420700008, 32.110256252000056],
              [121.48804772200003, 32.10814036700009],
              [121.49659264400009, 32.110256252000056],
              [121.53081178900004, 32.10851859600007],
              [121.55423799100004, 32.10249823500004],
              [121.59424889400009, 32.08706289300005],
              [121.65536543100006, 32.062933661000045],
              [121.68311608200008, 32.042629299000055],
              [121.71778405000009, 32.02558014500005],
              [121.72730553500003, 32.01658763200004],
              [121.76436590100002, 31.995286882000073],
              [121.79864398300003, 31.970474858000046],
              [121.82194511600005, 31.952486444000044],
              [121.82520592500009, 31.927720445000034],
              [121.84783311500007, 31.904607285000054],
              [121.87496019900004, 31.863722900000084],
              [121.87468722000006, 31.82590347100006],
              [121.90177628000004, 31.786487458000067],
              [121.9220571830001, 31.754378129000088],
              [121.93038277800008, 31.726714179000055],
              [121.91484204100004, 31.706434259000048],
              [121.87199794100002, 31.69068168800004],
              [121.81730624900001, 31.690949425000042],
              [121.74904506100006, 31.711633711000047],
              [121.7029101820001, 31.720554647000085],
              [121.675554272, 31.723572594000075],
              [121.65505997000002, 31.732380486000068],
              [121.60719438800004, 31.74855079100007],
              [121.57431074300007, 31.76552969000005],
              [121.55160566500001, 31.77374909100007],
              [121.52906334700003, 31.77920156500005],
              [121.51742597700002, 31.78343333500004],
              [121.50790449300007, 31.79287344000005],
              [121.50049889400009, 31.80219147300005],
              [121.49488366000003, 31.806463934000078],
              [121.48023522200003, 31.810980536000045],
              [121.41602623800009, 31.840643622000073],
              [121.31739683400008, 31.883248006000088],
              [121.28641836400004, 31.89058916600004],
              [121.22786432600003, 31.865903812000056],
              [121.18515058700007, 31.836737372000073],
              [121.11508706100005, 31.79633360300005],
              [121.08662362000007, 31.801835915000083],
              [121.06241343500005, 31.813500849000036],
              [121.0399349060001, 31.81933228400004],
              [121.00536508300002, 31.82077902700007],
              [120.977816792, 31.814365316000078],
              [120.95062836200009, 31.825236128000086],
              [120.94056409400002, 31.84464723700006],
              [120.94312584700003, 31.86790599200009],
              [120.94312584700003, 31.87531159100007],
              [120.94483483200008, 31.884588934000078],
              [120.94141686300009, 31.892523505000042],
              [120.92579186300009, 31.89590078300006],
              [120.91928144600001, 31.899359442000048],
              [120.91089928500003, 31.917669989000046],
              [120.90552819100003, 31.92597077000005],
              [120.84693444100003, 31.991441148000035],
              [120.81080162900003, 32.02260976800005],
              [120.74364441600005, 32.03604475700007],
              [120.63437647600006, 32.077009598000075],
              [120.56548762200009, 32.07671334500009],
              [120.52236056200002, 32.08260123700006],
              [120.49075762900009, 32.08245338200004],
              [120.42782102700005, 32.052929987000084],
              [120.36158287900003, 32.02558014500005],
              [120.30030358200008, 31.97166575700004],
              [120.26710045700008, 31.94867584800005],
              [120.22372480600006, 31.936835028000075],
              [120.17587324300007, 31.936672268000052],
              [120.13135826900009, 31.943182684000078],
              [120.09009850400003, 31.955023505000042],
              [120.05233808700007, 31.97093333500004],
              [120.02003014400009, 31.990790106000077],
              [119.99203535200002, 32.01585521000004],
              [119.92139733200008, 32.10854726800005],
              [119.91220136800007, 32.12372467700004],
              [119.90845787900003, 32.13886139500005],
              [119.91098066500001, 32.15814850500004],
              [119.92115319100003, 32.196478583000044],
              [119.92212975400003, 32.21743398600006],
              [119.90048261800007, 32.19818756700005],
              [119.88754316500001, 32.21385325700004],
              [119.87427819100003, 32.26512278900009],
              [119.86215254000001, 32.28115469000005],
              [119.842133009, 32.29905833500004],
              [119.81836998800009, 32.313706773000035],
              [119.79517662900003, 32.31976959800005],
              [119.78199303500003, 32.32123444200005],
              [119.75806725400003, 32.32697174700007],
              [119.74390709700003, 32.32721588700008],
              [119.69239342500009, 32.31976959800005],
              [119.67684980600006, 32.32843659100007],
              [119.66089928500003, 32.345770575000074],
              [119.64087975400003, 32.35883209800005],
              [119.61288496200007, 32.35455963700008],
              [119.64901777400007, 32.33608633000006],
              [119.66073652400007, 32.32721588700008],
              [119.67855879000001, 32.30621979400007],
              [119.68539472700002, 32.29242584800005],
              [119.67847741000003, 32.28628164300005],
              [119.67603600400003, 32.27806224200009],
              [119.65455162900003, 32.23476797100005],
              [119.64901777400007, 32.21954987200007],
              [119.63575280000009, 32.211004950000074],
              [119.61988366000003, 32.20490143400008],
              [119.60604902400007, 32.196926174000055],
              [119.62769616000003, 32.18939850500004],
              [119.64527428500003, 32.19521719000005],
              [119.65975996200007, 32.207912502000056],
              [119.67164147200003, 32.220770575000074],
              [119.69044030000009, 32.23533763200004],
              [119.70142662900003, 32.23346588700008],
              [119.71216881600003, 32.22260163000004],
              [119.73023522200003, 32.210598049000055],
              [119.75513756600003, 32.20587799700007],
              [119.77857506600003, 32.20465729400007],
              [119.78858483200008, 32.19863515800006],
              [119.76376386800007, 32.16250234600005],
              [119.76441491000003, 32.143744208000044],
              [119.77247155000009, 32.12677643400008],
              [119.78492272200003, 32.11432526200008],
              [119.85556074300007, 32.08698151200008],
              [119.86695397200003, 32.07709381700005],
              [119.90716251700007, 32.04538471300009],
              [119.93850207500009, 32.018042851000075],
              [119.96122240600005, 31.990615801000047],
              [119.97868014300002, 31.96895660200005],
              [120.00639553200006, 31.950304999000082],
              [120.03882897200003, 31.943060614000046],
              [120.13095136800007, 31.91229889500005],
              [120.17831464900007, 31.90420156500005],
              [120.22999108200008, 31.90888092700004],
              [120.34117085600008, 31.95632050800009],
              [120.41822350400003, 31.969671942000048],
              [120.43222089900007, 31.975165106000077],
              [120.455781043, 31.982518923000043],
              [120.45415713800003, 32.003185570000085],
              [120.455412335, 32.02142844200006],
              [120.46949303500003, 32.02513255400004],
              [120.51783287900003, 32.018744208000044],
              [120.60425866000003, 31.991441148000035],
              [120.67001386800007, 31.998846747000073],
              [120.68995201900009, 31.99823639500005],
              [120.7503538740001, 31.97833627600005],
              [120.779818159, 31.91588266800005],
              [120.80744703300002, 31.873769896000056],
              [120.824798601, 31.82870246600004],
              [120.80775223800003, 31.809740522000084],
              [120.75147545700008, 31.824693101000037],
              [120.73853600400003, 31.836818752000056],
              [120.72763105600006, 31.85065338700008],
              [120.717133009, 31.861070054000038],
              [120.72079511800007, 31.83193594000005],
              [120.73145592500009, 31.81386953300006],
              [120.748383009, 31.80223216400009],
              [120.83189898, 31.777766057000065],
              [120.89536285100007, 31.76332027400008],
              [120.94849694100003, 31.757879950000074],
              [120.98072350400003, 31.751206773000035],
              [121.01376436400005, 31.74303425700009],
              [121.06702629300003, 31.724085562000084],
              [121.14440229000002, 31.684658291000062],
              [121.21168053500003, 31.62763092700004],
              [121.24472089900007, 31.600409247000073],
              [121.32032311300009, 31.504828192000048],
              [121.34091230600006, 31.49095286700009],
              [121.36085045700008, 31.477484442000048],
              [121.41773522200003, 31.452785549000055],
              [121.44800866000003, 31.42649974200009],
              [121.54623457100001, 31.366115627000056],
              [121.63160241000003, 31.335760809000078],
              [121.66993248800009, 31.313055731000077],
              [121.725163995, 31.281567150000058],
              [121.7775017130001, 31.214393784000038],
              [121.877024548, 31.099135878000084],
              [121.95082006200005, 30.982080909000047],
              [121.97738292300005, 30.914923436000038],
              [121.96007537800006, 30.87425678200009],
              [121.907399241, 30.85708552400007],
              [121.81080854200002, 30.853230646000043],
              [121.73283463300004, 30.846316906000084],
              [121.63113225500001, 30.83655553300008],
              [121.5429370380001, 30.816494909000085],
              [121.492037449, 30.797734233000085],
              [121.45640612300008, 30.783278050000035],
              [121.41059758600011, 30.767388095000058],
              [121.35059655000009, 30.713446356000077],
              [121.33350670700008, 30.703070380000042],
              [121.26465905000009, 30.689195054000038],
              [121.22193444100003, 30.674994208000044],
              [121.20289147200003, 30.66510651200008],
              [121.17774498800009, 30.645656643000052],
              [121.15894616000003, 30.636704820000034],
              [121.14852949300007, 30.627834377000056],
              [121.14161217500009, 30.617743231000077],
              [121.13656660200002, 30.60814036700009],
              [121.13086998800009, 30.599758205000057],
              [121.12134850400003, 30.593003648000035],
              [121.10238691500001, 30.589056708000044],
              [121.047400391, 30.58275702800006],
              [121.02022566300002, 30.571071146000065],
              [120.99814597, 30.557924187000083],
              [120.977758677, 30.543317594000087],
              [120.94889073600007, 30.506815232000065],
              [120.93165123800009, 30.473049221000053],
              [120.92880293100006, 30.453070380000042],
              [120.93238366000003, 30.439398505000042],
              [120.93848717500009, 30.43073151200008],
              [120.93954511800007, 30.421942450000074],
              [120.92880293100006, 30.40810781500005],
              [120.92164147200003, 30.405218817000048],
              [120.90170332100001, 30.403550523000035],
              [120.89478600400003, 30.401271877000056],
              [120.90455162900003, 30.388617255000042],
              [120.90902754000001, 30.384426174000055],
              [120.91513105600006, 30.38076406500005],
              [120.91513105600006, 30.37457916900007],
              [120.900726759, 30.373602606000077],
              [120.88819420700008, 30.36855703300006],
              [120.85058016300002, 30.33021752800005],
              [120.83179130300005, 30.30525044600006],
              [120.81073172600009, 30.29656770200006],
              [120.78743319500006, 30.29362528200005],
              [120.76961920800011, 30.306027723000057],
              [120.75398941000003, 30.32706166400004],
              [120.7449630210001, 30.35961442900009],
              [120.72711885500007, 30.37584626100005],
              [120.69814822600006, 30.393950619000066],
              [120.66700167800002, 30.401499973000057],
              [120.61919297100007, 30.406095993000065],
              [120.47914493200005, 30.403523661000065],
              [120.43031537900004, 30.389840062000076],
              [120.41602459900002, 30.36770970200007],
              [120.40723189700009, 30.35423589700008],
              [120.39748223900006, 30.321579641000085],
              [120.38883165800007, 30.290844994000054],
              [120.37896691200001, 30.27352374800006],
              [120.36455484100009, 30.26863725700008],
              [120.3422755470001, 30.27424635600005],
              [120.31625410200002, 30.29092031500005],
              [120.28516686300009, 30.298814195000034],
              [120.25790449300007, 30.298081773000035],
              [120.23977767200006, 30.28888044900009],
              [120.19576726000003, 30.23288844600006],
              [120.147094433, 30.19889096500009],
              [120.17896569100003, 30.20066966400009],
              [120.19996178500003, 30.21784088700008],
              [120.23024299000008, 30.23603538900005],
              [120.25001061300009, 30.270086981000077],
              [120.2743871350001, 30.277618205000067],
              [120.29552252500002, 30.278726003000088],
              [120.31456869600004, 30.26351106900006],
              [120.33136769600003, 30.249238020000064],
              [120.350337835, 30.24073406100007],
              [120.368120847, 30.240851155000087],
              [120.38472004300002, 30.24958816600008],
              [120.39503014400009, 30.26471588700008],
              [120.404633009, 30.27993398600006],
              [120.42095557900006, 30.305419965000056],
              [120.45049431400003, 30.368860059000042],
              [120.47713307700008, 30.374754400000086],
              [120.524908407, 30.377872730000036],
              [120.62160579500005, 30.372562878000053],
              [120.65167061600005, 30.359270455000058],
              [120.6573474810001, 30.336294046000035],
              [120.68494114100008, 30.271780919000037],
              [120.69868588700001, 30.251796329000058],
              [120.7255176650001, 30.242635629000063],
              [120.73440116100005, 30.23221314300008],
              [120.69135211000003, 30.197451019000084],
              [120.665955661, 30.16624150000007],
              [120.64381338500004, 30.145872987000075],
              [120.63010994900003, 30.13497216400009],
              [120.63178902200002, 30.122387742000058],
              [120.65332335800008, 30.102544600000044],
              [120.68246504000001, 30.084906317000048],
              [120.70101972700002, 30.08075592700004],
              [120.72339928500003, 30.079738674000055],
              [120.75497480600006, 30.086859442000048],
              [120.76498457100001, 30.08661530200004],
              [120.77198326900009, 30.083197333000044],
              [120.78402754000001, 30.07168203300006],
              [120.79224694100003, 30.066066799000055],
              [120.78370201900009, 30.08930084800005],
              [120.76465905000009, 30.096625067000048],
              [120.71412194100003, 30.09332916900007],
              [120.68799889400009, 30.097805080000057],
              [120.66456139400009, 30.10960521000004],
              [120.64625084700003, 30.126939195000034],
              [120.66285241000003, 30.141180731000077],
              [120.70104639800002, 30.184552056000086],
              [120.75142508700003, 30.225625953000076],
              [120.81348715800004, 30.213253156000064],
              [120.82862042500005, 30.184990129000084],
              [120.85321522200002, 30.174436014000037],
              [120.89281215100004, 30.169796399000063],
              [120.92350395900007, 30.185866239000063],
              [120.95419355600006, 30.191961981000077],
              [120.96021569100003, 30.195786851000037],
              [120.99439537900003, 30.211086330000057],
              [121.10914147200003, 30.28278229400007],
              [121.12877910600002, 30.30162684000004],
              [121.149696726, 30.325753330000055],
              [121.18538938300003, 30.337563798000076],
              [121.25410242800001, 30.34839323400007],
              [121.3132175180001, 30.338191748000042],
              [121.37738414700004, 30.325063579000073],
              [121.42959194500008, 30.29297626600004],
              [121.50684671500005, 30.220026009000037],
              [121.55459636900002, 30.160891366000044],
              [121.58703420200004, 30.11151193900008],
              [121.62332169700005, 30.05987467300008],
              [121.643193688, 30.03649266800005],
              [121.65830555600007, 30.01838893900009],
              [121.67775592200007, 30.000640952000083],
              [121.70676302900006, 29.985109125000065],
              [121.73234373800005, 29.97860254300008],
              [121.72193444100003, 29.96051666900007],
              [121.7322478750001, 29.96206013500006],
              [121.7501100820001, 29.97250518700008],
              [121.76748188600004, 29.973176555000066],
              [121.79664147200003, 29.963039455000057],
              [121.8164296970001, 29.95148136800009],
              [121.84981429900006, 29.940380340000047],
              [121.87323052700003, 29.932336897000084],
              [121.89925264600004, 29.92313947300005],
              [121.91487649700002, 29.91869584300008],
              [121.93555748800009, 29.88735586100006],
              [121.9495907810001, 29.886934479000047],
              [121.96241295700008, 29.888495184000078],
              [121.98170006600003, 29.890285549000055],
              [122.05624433700007, 29.88735586100006],
              [122.06763756600003, 29.889553127000056],
              [122.08668053500003, 29.899359442000048],
              [122.10588654700007, 29.906953422000072],
              [122.1291433020001, 29.903776502000085],
              [122.136414564, 29.884535001000074],
              [122.11475531500002, 29.871553919000064],
              [122.06861412900003, 29.851548570000034],
              [122.02816816500001, 29.836004950000074],
              [121.98303901000008, 29.82317576300005],
              [121.96604681100007, 29.81124658200008],
              [121.93677819100003, 29.79169342700004],
              [121.92441021800005, 29.77347324300007],
              [121.90217086500002, 29.752539493000086],
              [121.88532463900003, 29.76128376400004],
              [121.87314894400004, 29.753828466000073],
              [121.86610718400004, 29.736565399000085],
              [121.86244825200004, 29.70800212100005],
              [121.83459789300002, 29.687086355000076],
              [121.77646532300002, 29.652624736000064],
              [121.717726545, 29.588653511000075],
              [121.70411217500009, 29.572007554000038],
              [121.68734785200002, 29.562648830000057],
              [121.66700280000009, 29.556586005000042],
              [121.64820397200003, 29.556708075000074],
              [121.63589838100006, 29.554350982000074],
              [121.62387129000001, 29.554429429000038],
              [121.60914147200003, 29.545721747000073],
              [121.59253991000003, 29.54360586100006],
              [121.57431074300007, 29.55215078300006],
              [121.530822295, 29.51001492200004],
              [121.52255000100001, 29.512921688000063],
              [121.520119206, 29.528061679000075],
              [121.5168359160001, 29.546090835000086],
              [121.51104346500006, 29.548988326000085],
              [121.49927819100003, 29.549261786000045],
              [121.48438561300009, 29.544663804000038],
              [121.47543379000001, 29.538763739000046],
              [121.46786543100006, 29.531195380000042],
              [121.45834394600001, 29.525213934000078],
              [121.44336998800009, 29.524237372000073],
              [121.44336998800009, 29.518011786000045],
              [121.44825280000009, 29.514105536000045],
              [121.45701871400001, 29.500870888000065],
              [121.45532372600007, 29.48935530300008],
              [121.44115978900004, 29.481526372000076],
              [121.42783560400005, 29.46794695600005],
              [121.44271132200004, 29.439767174000053],
              [121.44259289400009, 29.415369252000062],
              [121.4650741590001, 29.420886452000047],
              [121.47346109500006, 29.44893344400009],
              [121.47974694100003, 29.474758205000057],
              [121.50489342500009, 29.48383209800005],
              [121.50009199300007, 29.475897528000075],
              [121.49179121200007, 29.455959377000056],
              [121.51368248800009, 29.451971747000073],
              [121.51172936300009, 29.437567450000074],
              [121.49716230600006, 29.42218659100007],
              [121.48096764400009, 29.414984442000048],
              [121.47763105600006, 29.41274648600006],
              [121.47665449300007, 29.40778229400007],
              [121.478851759, 29.402899481000077],
              [121.48486407400003, 29.390540112000053],
              [121.49731378400008, 29.393352530000072],
              [121.508929985, 29.398349478000057],
              [121.519709767, 29.406974949000073],
              [121.53132511900003, 29.417036778000067],
              [121.53797279100002, 29.424224223000067],
              [121.5487961230001, 29.438601128000073],
              [121.55380850900008, 29.450117227000078],
              [121.55965554800002, 29.463073242000064],
              [121.569641348, 29.47457382400006],
              [121.58125579200009, 29.47813910700006],
              [121.6019944520001, 29.483113264000053],
              [121.64267244900009, 29.495218252000086],
              [121.67554772200003, 29.51048411700009],
              [121.674300001, 29.520331513000087],
              [121.68175557900008, 29.523910369000077],
              [121.69979902400007, 29.534328518000052],
              [121.71094811300009, 29.53864166900007],
              [121.72461998800009, 29.53847890800006],
              [121.72535241000003, 29.53546784100007],
              [121.72535241000003, 29.529038804000038],
              [121.72657311300009, 29.522284247000073],
              [121.73129316500001, 29.518011786000045],
              [121.73764082100001, 29.51898834800005],
              [121.74586022200003, 29.523098049000055],
              [121.76399931200001, 29.530761435000045],
              [121.76646070200002, 29.520648665000067],
              [121.75722263800003, 29.499048921000053],
              [121.76128901000004, 29.486046644000055],
              [121.76456720800002, 29.476650154000083],
              [121.7783813100001, 29.46942307800009],
              [121.79032644300003, 29.475795453000046],
              [121.81198839800004, 29.490118476000077],
              [121.82132673000001, 29.51459860700004],
              [121.83057701900009, 29.52806224200009],
              [121.84742272200003, 29.524237372000073],
              [121.84481855600006, 29.53620026200008],
              [121.83651777400007, 29.54238515800006],
              [121.82553144600001, 29.54637278900009],
              [121.81397545700008, 29.55215078300006],
              [121.79981530000009, 29.54559967700004],
              [121.78272545700008, 29.543443101000037],
              [121.76571699300007, 29.545721747000073],
              [121.75827350300005, 29.54809864200007],
              [121.74496504000001, 29.544663804000038],
              [121.74842207900008, 29.562566943000036],
              [121.77432204500008, 29.575436248000074],
              [121.79612041300004, 29.600591156000064],
              [121.81836998800009, 29.606634833000044],
              [121.8345277200001, 29.615570072000082],
              [121.85401451900009, 29.61591217700004],
              [121.86793053500003, 29.62726471600007],
              [121.88013756600003, 29.623521226000037],
              [121.89964357200006, 29.627526790000047],
              [121.91578209700003, 29.64085521000004],
              [121.92725670700008, 29.634466864000046],
              [121.94263756600003, 29.611273505000042],
              [121.95362389400009, 29.60614655200004],
              [121.96631920700008, 29.602484442000048],
              [121.97120201900009, 29.59332916900007],
              [121.97095787900003, 29.568915106000077],
              [121.96371504000001, 29.560207424000055],
              [121.94971764400009, 29.556341864000046],
              [121.94117272200003, 29.551174221000053],
              [121.94979902400007, 29.53847890800006],
              [121.92212975400003, 29.53115469000005],
              [121.91041100400003, 29.524562893000052],
              [121.91236412900003, 29.51430898600006],
              [121.922211134, 29.50922272300005],
              [121.93555748800009, 29.504380601000037],
              [121.94410241000003, 29.497707424000055],
              [121.93995201900009, 29.48700592700004],
              [121.94271894600001, 29.479722398000035],
              [121.97095787900003, 29.44912344000005],
              [121.96933027400007, 29.439154364000046],
              [121.963226759, 29.43195221600007],
              [121.95777428500003, 29.423081773000035],
              [121.95728600400003, 29.408148505000042],
              [121.94752037900003, 29.421087958000044],
              [121.93628991000003, 29.42772044500009],
              [121.93005624400007, 29.42531477700004],
              [121.92255563600008, 29.418146385000057],
              [121.92910204500004, 29.40873509100004],
              [121.92157721900003, 29.39863437100007],
              [121.91572936400007, 29.39070356600007],
              [121.92144327000005, 29.381303450000075],
              [121.916348019, 29.36329405300006],
              [121.91624575700007, 29.34893666100004],
              [121.92701256600003, 29.33860911700009],
              [121.92945397200003, 29.33926015800006],
              [121.93148847700002, 29.331203518000052],
              [121.93140709700003, 29.323879299000055],
              [121.92505944100003, 29.31907786700009],
              [121.90894616000003, 29.318793036000045],
              [121.91163170700008, 29.315008856000077],
              [121.91578209700003, 29.305121161000045],
              [121.90048261800007, 29.298651434000078],
              [121.90585371200007, 29.28461334800005],
              [121.922211134, 29.27049388200004],
              [121.93995201900009, 29.264146226000037],
              [121.949554884, 29.267279364000046],
              [121.96265709700003, 29.28143952000005],
              [121.97437584700003, 29.28461334800005],
              [121.97559655000009, 29.280951239000046],
              [121.98585045700008, 29.263332424000055],
              [121.99146569100003, 29.25731028900009],
              [121.96656334700003, 29.25576406500005],
              [121.95321699300007, 29.249660549000055],
              [121.95069420700008, 29.237127997000073],
              [121.95728600400003, 29.21637604400007],
              [121.94296308700007, 29.223211981000077],
              [121.93970787900003, 29.210109768000052],
              [121.93995201900009, 29.204291083000044],
              [121.94296308700007, 29.195868231000077],
              [121.92212975400003, 29.195786851000037],
              [121.89380944100003, 29.18707916900007],
              [121.84058678500003, 29.16111888200004],
              [121.812551203, 29.161484647000066],
              [121.7853467440001, 29.168085488000088],
              [121.78803572600009, 29.20194310800008],
              [121.78977036700007, 29.21562526300005],
              [121.79490121800006, 29.24370471800006],
              [121.795868692, 29.266036602000042],
              [121.80182094300005, 29.292667717000086],
              [121.79965254000001, 29.305121161000045],
              [121.80868574300007, 29.311753648000035],
              [121.81836998800009, 29.316229559000078],
              [121.82886803500003, 29.31854889500005],
              [121.84058678500003, 29.318793036000045],
              [121.83065839900007, 29.33388906500005],
              [121.81698652400007, 29.332180080000057],
              [121.80494225400003, 29.32371653900009],
              [121.79965254000001, 29.318793036000045],
              [121.78817793100006, 29.328558661000045],
              [121.78793379000001, 29.342596747000073],
              [121.79965254000001, 29.373968817000048],
              [121.78663170700008, 29.37449778900009],
              [121.77588951900009, 29.37262604400007],
              [121.76685631600003, 29.367743231000077],
              [121.75863691500001, 29.359767971000053],
              [121.77084394600001, 29.33779531500005],
              [121.777880546, 29.296383845000037],
              [121.77431375900005, 29.25388736900004],
              [121.75863691500001, 29.229396877000056],
              [121.74569746200007, 29.201605536000045],
              [121.73878014400009, 29.195868231000077],
              [121.72432815900004, 29.182034848000058],
              [121.70446018300004, 29.174182362000067],
              [121.67059743200002, 29.175747914000056],
              [121.65245779600002, 29.183020241000065],
              [121.64193769600001, 29.202093817000048],
              [121.63917076900009, 29.217271226000037],
              [121.64161217500009, 29.26756419500009],
              [121.64576256600003, 29.281195380000042],
              [121.65455162900003, 29.299994208000044],
              [121.64039147200003, 29.30662669500009],
              [121.62484785200002, 29.30145905200004],
              [121.62891686300009, 29.28461334800005],
              [121.62289472700002, 29.264105536000045],
              [121.63233483200008, 29.210638739000046],
              [121.62891686300009, 29.188421942000048],
              [121.61475670700008, 29.206000067000048],
              [121.60645592500009, 29.227362372000073],
              [121.58871504000001, 29.291489976000037],
              [121.58399498800009, 29.29987213700008],
              [121.57431074300007, 29.305121161000045],
              [121.56308027400007, 29.30418528900009],
              [121.56202233200008, 29.295843817000048],
              [121.56723066500001, 29.285305080000057],
              [121.57431074300007, 29.277777411000045],
              [121.56275475400003, 29.271877346000053],
              [121.55054772200003, 29.271429755000042],
              [121.52588951900009, 29.277777411000045],
              [121.52588951900009, 29.27098216400009],
              [121.53638756600003, 29.258286851000037],
              [121.53052819100003, 29.238226630000042],
              [121.51693769600001, 29.21906159100007],
              [121.50489342500009, 29.208929755000042],
              [121.50489342500009, 29.202093817000048],
              [121.51172936300009, 29.189276434000078],
              [121.50350996200007, 29.178941148000035],
              [121.49097741000003, 29.17597077000005],
              [121.48438561300009, 29.185288804000038],
              [121.48023522200003, 29.197211005000042],
              [121.47120201900009, 29.191351630000042],
              [121.46151777400007, 29.17645905200004],
              [121.45639082100001, 29.16111888200004],
              [121.43140709700003, 29.17218659100007],
              [121.41976972700002, 29.17145416900007],
              [121.408539259, 29.16111888200004],
              [121.44336998800009, 29.147406317000048],
              [121.43930097700002, 29.145453192000048],
              [121.43848717500009, 29.14484284100007],
              [121.43808027400007, 29.143866278000075],
              [121.43604576900009, 29.14061107000009],
              [121.45639082100001, 29.14061107000009],
              [121.45639082100001, 29.13377513200004],
              [121.44149824300007, 29.13108958500004],
              [121.42831464900007, 29.12714264500005],
              [121.41537519600001, 29.119696356000077],
              [121.40170332100001, 29.10651276200008],
              [121.49683678500003, 29.104437567000048],
              [121.52865644600001, 29.115057684000078],
              [121.621429884, 29.11326732000009],
              [121.62452233200008, 29.104396877000056],
              [121.62460371200007, 29.088283596000053],
              [121.621429884, 29.070868231000077],
              [121.61475670700008, 29.05805084800005],
              [121.59921308700007, 29.05023834800005],
              [121.58505293100006, 29.053615627000056],
              [121.57113691500001, 29.06085846600007],
              [121.55640709700003, 29.064886786000045],
              [121.53687584700003, 29.06118398600006],
              [121.53028405000009, 29.051174221000053],
              [121.53207441500001, 29.02049388200004],
              [121.53809655000009, 29.018052476000037],
              [121.54859459700003, 29.021429755000042],
              [121.55274498800009, 29.02871328300006],
              [121.53956139400009, 29.037583726000037],
              [121.55738366000003, 29.04901764500005],
              [121.61744225400003, 29.039984442000048],
              [121.64193769600001, 29.051255601000037],
              [121.68173261800007, 29.02676015800006],
              [121.689789259, 29.01707591400009],
              [121.67587324300007, 29.01325104400007],
              [121.66171308700007, 29.00291575700004],
              [121.65381920700008, 28.98859284100007],
              [121.65943444100003, 28.972723700000074],
              [121.66382897200003, 28.969916083000044],
              [121.66895592500009, 28.96898021000004],
              [121.68018639400009, 28.969305731000077],
              [121.68466230600006, 28.96751536700009],
              [121.68417402400007, 28.963446356000077],
              [121.68287194100003, 28.95888906500005],
              [121.68417402400007, 28.955633856000077],
              [121.69214928500003, 28.95335521000004],
              [121.70948326900009, 28.95115794500009],
              [121.71778405000009, 28.94879791900007],
              [121.69752037900003, 28.936835028000075],
              [121.68946373800009, 28.927801825000074],
              [121.68417402400007, 28.91469961100006],
              [121.62850996200007, 28.93195221600007],
              [121.60531660200002, 28.942572333000044],
              [121.58741295700008, 28.96312083500004],
              [121.58529707100001, 28.938299872000073],
              [121.57081139400009, 28.930080471000053],
              [121.55429121200007, 28.935695705000057],
              [121.54647871200007, 28.95221588700008],
              [121.53711998800009, 28.955023505000042],
              [121.51685631600003, 28.956366278000075],
              [121.49781334700003, 28.949652411000045],
              [121.49179121200007, 28.92837148600006],
              [121.50489342500009, 28.935207424000055],
              [121.50766035200002, 28.924994208000044],
              [121.51181074300007, 28.916937567000048],
              [121.51767011800007, 28.91278717700004],
              [121.52588951900009, 28.91469961100006],
              [121.53516686300009, 28.90371328300006],
              [121.54981530000009, 28.89785390800006],
              [121.56617272200003, 28.893377997000073],
              [121.58057701900009, 28.886786200000074],
              [121.59034264400009, 28.891913153000075],
              [121.60165449300007, 28.89362213700008],
              [121.61085045700008, 28.891180731000077],
              [121.61695397200003, 28.88027578300006],
              [121.62671959700003, 28.88084544500009],
              [121.62891686300009, 28.87714264500005],
              [121.62777754000001, 28.870835679000038],
              [121.62265058700007, 28.861273505000042],
              [121.621429884, 28.856350002000056],
              [121.62354576900009, 28.842271226000037],
              [121.62826582100001, 28.84125397300005],
              [121.63502037900003, 28.84520091400009],
              [121.64193769600001, 28.845851955000057],
              [121.65650475400003, 28.838039455000057],
              [121.66236412900003, 28.83344147300005],
              [121.66993248800009, 28.825344143000052],
              [121.65381920700008, 28.81195709800005],
              [121.64673912900003, 28.80768463700008],
              [121.63575280000009, 28.804836330000057],
              [121.63575280000009, 28.798041083000044],
              [121.66260826900009, 28.798041083000044],
              [121.66260826900009, 28.79059479400007],
              [121.65113366000003, 28.787909247000073],
              [121.64258873800009, 28.784002997000073],
              [121.63550866000003, 28.778509833000044],
              [121.62891686300009, 28.770697333000044],
              [121.62623131600003, 28.768052476000037],
              [121.62232506600003, 28.76552969000005],
              [121.61825605600006, 28.76194896000004],
              [121.61475670700008, 28.756415106000077],
              [121.61972089900007, 28.74827708500004],
              [121.62240644600001, 28.741888739000046],
              [121.621429884, 28.73590729400007],
              [121.60556074300007, 28.724676825000074],
              [121.50277754000001, 28.700384833000044],
              [121.35116621200007, 28.711859442000048],
              [121.33423912900003, 28.71702708500004],
              [121.32016035200002, 28.72483958500004],
              [121.30616295700008, 28.73590729400007],
              [121.29843183700007, 28.74363841400009],
              [121.29493248800009, 28.748114325000074],
              [121.29029381600003, 28.751613674000055],
              [121.27890058700007, 28.756415106000077],
              [121.26889082100001, 28.758286851000037],
              [121.246429884, 28.76007721600007],
              [121.23788496200007, 28.76386139500005],
              [121.234711134, 28.769964911000045],
              [121.22738691500001, 28.791408596000053],
              [121.22437584700003, 28.798041083000044],
              [121.21444746200007, 28.80731842700004],
              [121.20801842500009, 28.80955638200004],
              [121.20101972700002, 28.809515692000048],
              [121.19003339900007, 28.811672268000052],
              [121.17359459700003, 28.81785716400009],
              [121.16285241000003, 28.825344143000052],
              [121.15772545700008, 28.83148834800005],
              [121.15577233200008, 28.837551174000055],
              [121.15211022200003, 28.84251536700009],
              [121.14234459700003, 28.845851955000057],
              [121.14234459700003, 28.839585679000038],
              [121.15967858200008, 28.81354401200008],
              [121.17188561300009, 28.80695221600007],
              [121.19345136800007, 28.804836330000057],
              [121.20606530000009, 28.79905833500004],
              [121.21827233200008, 28.78579336100006],
              [121.22738691500001, 28.770738023000035],
              [121.23121178500003, 28.760158596000053],
              [121.24081464900007, 28.752752997000073],
              [121.28589928500003, 28.73826732000009],
              [121.29932701900009, 28.72288646000004],
              [121.29867597700002, 28.701239325000074],
              [121.28646894600001, 28.692694403000075],
              [121.27035566500001, 28.687445380000042],
              [121.25839277400007, 28.675116278000075],
              [121.32764733200008, 28.69204336100006],
              [121.36500084700003, 28.69603099200009],
              [121.38135826900009, 28.68195221600007],
              [121.41382897200003, 28.696600653000075],
              [121.45484459700003, 28.689520575000074],
              [121.49000084700003, 28.665716864000046],
              [121.51012813400007, 28.65705930900009],
              [121.52555624000001, 28.62465465100007],
              [121.53036950800004, 28.599478876000035],
              [121.538433274, 28.571445577000077],
              [121.54943924500003, 28.551010215000076],
              [121.5731598220001, 28.52513372800007],
              [121.58161920600003, 28.504690259000085],
              [121.55087324300007, 28.50214264500005],
              [121.53492272200003, 28.50340403900009],
              [121.52100670700008, 28.50104401200008],
              [121.51156660200002, 28.489488023000035],
              [121.52125084700003, 28.490708726000037],
              [121.54492634100006, 28.49247389800007],
              [121.58460110400006, 28.48910241300007],
              [121.607742701, 28.477202856000076],
              [121.60036092900009, 28.46542510900008],
              [121.584439428, 28.454214643000057],
              [121.58377693300008, 28.44294618400005],
              [121.59287430900008, 28.43110620500005],
              [121.60746340000003, 28.42031875300006],
              [121.61588832000007, 28.397214387000076],
              [121.63226304600005, 28.379445683000085],
              [121.6285250090001, 28.36390183700007],
              [121.63153166500001, 28.35584295600006],
              [121.63404381600003, 28.34723541900007],
              [121.64087975400003, 28.349676825000074],
              [121.64771569100003, 28.348456122000073],
              [121.65634199300007, 28.33930084800005],
              [121.64169355600006, 28.32184479400007],
              [121.62134850400003, 28.285101630000042],
              [121.60792076900009, 28.270453192000048],
              [121.58554121200007, 28.25682200700004],
              [121.57813561300009, 28.260321356000077],
              [121.58057701900009, 28.300848700000074],
              [121.567488561, 28.30449500700007],
              [121.54149122500007, 28.321786815000053],
              [121.521960691, 28.326868963000038],
              [121.49998648600001, 28.332673020000072],
              [121.47308608900005, 28.330602852000084],
              [121.45639082100001, 28.318833726000037],
              [121.44776451900009, 28.31590403900009],
              [121.44125410200002, 28.311712958000044],
              [121.43726647200003, 28.305609442000048],
              [121.43604576900009, 28.29710521000004],
              [121.42977949300007, 28.29710521000004],
              [121.42066491000003, 28.30418528900009],
              [121.40894616000003, 28.30491771000004],
              [121.39893639400009, 28.298488674000055],
              [121.39551842500009, 28.284084377000056],
              [121.40137780000009, 28.27610911700009],
              [121.41146894600001, 28.273911851000037],
              [121.41879316500001, 28.26972077000005],
              [121.41602623800009, 28.25617096600007],
              [121.40805097700002, 28.24628327000005],
              [121.39893639400009, 28.243841864000046],
              [121.38803144600001, 28.242661851000037],
              [121.37452233200008, 28.236273505000042],
              [121.36483808700007, 28.225816148000035],
              [121.36109459700003, 28.21474844000005],
              [121.35889733200008, 28.20221588700008],
              [121.35401451900009, 28.187892971000053],
              [121.36866295700008, 28.19204336100006],
              [121.37452233200008, 28.195257880000042],
              [121.37671959700003, 28.184149481000077],
              [121.37403405000009, 28.17259349200009],
              [121.36817467500009, 28.16201406500005],
              [121.36085045700008, 28.15375397300005],
              [121.35141035200002, 28.146551825000074],
              [121.34579511800007, 28.14516836100006],
              [121.34009850400003, 28.146429755000042],
              [121.33008873800009, 28.14752838700008],
              [121.32618248800009, 28.15180084800005],
              [121.30933678500003, 28.17487213700008],
              [121.297211134, 28.17645905200004],
              [121.28785241000003, 28.180894273000035],
              [121.2751843420001, 28.208199163000074],
              [121.26169450400005, 28.225790679000056],
              [121.225165393, 28.238862571000084],
              [121.24887129000001, 28.27020905200004],
              [121.23682701900009, 28.30609772300005],
              [121.20313561300009, 28.331854559000078],
              [121.21029707100001, 28.34373607000009],
              [121.21753991000003, 28.352362372000073],
              [121.23047936300009, 28.348089911000045],
              [121.24415123800009, 28.34910716400009],
              [121.256195509, 28.355169989000046],
              [121.26465905000009, 28.366034247000073],
              [121.23096764400009, 28.359076239000046],
              [121.21412194100003, 28.360581773000035],
              [121.18409264400009, 28.382147528000075],
              [121.16895592500009, 28.384833075000074],
              [121.16163170700008, 28.377508856000077],
              [121.16895592500009, 28.359767971000053],
              [121.14429772200003, 28.343573309000078],
              [121.1302500380001, 28.305554447000077],
              [121.08847089900007, 28.29319896000004],
              [121.07211347700002, 28.29169342700004],
              [121.06666100400003, 28.311428127000056],
              [121.05909264400009, 28.311428127000056],
              [121.03492272200003, 28.30817291900007],
              [121.02499433700007, 28.30459219000005],
              [121.03956139400009, 28.28534577000005],
              [121.05811608200008, 28.27993398600006],
              [121.07894941500001, 28.278143622000073],
              [121.12180321300002, 28.28436223600005],
              [121.13009527200006, 28.265928751000047],
              [121.12475305600003, 28.235520137000037],
              [121.11946677900005, 28.218936170000063],
              [121.10894349800003, 28.199610238000048],
              [121.10052737800004, 28.184894263000047],
              [121.08583632600005, 28.166503859000045],
              [121.05338456700008, 28.14816311700008],
              [121.03137613800004, 28.12610665300008],
              [121.00937821800005, 28.103132635000065],
              [121.00201713000001, 28.08564236600006],
              [121.00088550300006, 28.050635666000062],
              [120.99351229800004, 28.02577909100006],
              [120.98093608400006, 28.005536972000073],
              [120.96522777500002, 27.98714491700008],
              [120.92139733200008, 27.981675523000035],
              [120.89844811300009, 27.992661851000037],
              [120.87997480600006, 27.99872467700004],
              [120.855804884, 27.99673086100006],
              [120.81959069100003, 27.98924388200004],
              [120.80079186300009, 27.993394273000035],
              [120.78109785200002, 28.002386786000045],
              [120.76270592500009, 28.01430898600006],
              [120.74756920700008, 28.027085679000038],
              [120.73104902400007, 28.03583405200004],
              [120.70753014400009, 28.04120514500005],
              [120.66195722700002, 28.04450104400007],
              [120.62094160200002, 28.039943752000056],
              [120.60604902400007, 28.042222398000035],
              [120.590179884, 28.054388739000046],
              [120.58497155000009, 28.095526434000078],
              [120.57699629000001, 28.115627346000053],
              [120.55958092500009, 28.11277903900009],
              [120.57447350400003, 28.100002346000053],
              [120.58017011800007, 28.089789130000042],
              [120.58008873800009, 28.046128648000035],
              [120.58204186300009, 28.034328518000052],
              [120.58895918100006, 28.026678778000075],
              [120.60425866000003, 28.023993231000077],
              [120.65894616000003, 28.023993231000077],
              [120.67359459700003, 28.02171458500004],
              [120.70728600400003, 28.009711005000042],
              [120.73853600400003, 27.98309967700004],
              [120.75058027400007, 27.97557200700004],
              [120.83529707100001, 27.955959377000056],
              [120.84725996200007, 27.948960679000038],
              [120.85425866000003, 27.93463776200008],
              [120.863761748, 27.91810565600008],
              [120.86261188600008, 27.902874352000083],
              [120.868363681, 27.882559233000052],
              [120.85227198200005, 27.858191886000043],
              [120.82700426300005, 27.849049252000043],
              [120.80748625600006, 27.834826693000082],
              [120.796018258, 27.805369744000075],
              [120.76963001400009, 27.772849369000085],
              [120.740960051, 27.73320273300004],
              [120.722614496, 27.715909536000083],
              [120.70425489400009, 27.71283855100006],
              [120.68726647200003, 27.726711330000057],
              [120.652679884, 27.753241278000075],
              [120.63526451900009, 27.763332424000055],
              [120.63672936300009, 27.745835679000038],
              [120.64527428500003, 27.73427969000005],
              [120.67245527400007, 27.711493231000077],
              [120.67359459700003, 27.704250393000052],
              [120.68018054900006, 27.686379299000066],
              [120.669861212, 27.677213023000036],
              [120.66757717300004, 27.66806019900008],
              [120.67310631600003, 27.65961334800005],
              [120.67562910200002, 27.65965403900009],
              [120.66648375600005, 27.625357910000048],
              [120.63559004000001, 27.608710028000075],
              [120.61833143800004, 27.59372542600005],
              [120.60687424700006, 27.581487783000057],
              [120.59657442500009, 27.570282778000035],
              [120.605784975, 27.549958836000087],
              [120.61384852800006, 27.529633207000074],
              [120.61845908400005, 27.516421152000078],
              [120.63338728600002, 27.507312262000085],
              [120.65211022200003, 27.50336334800005],
              [120.66195722700002, 27.503241278000075],
              [120.67684980600006, 27.494614976000037],
              [120.681976759, 27.481594143000052],
              [120.678070509, 27.466457424000055],
              [120.66561933700007, 27.451727606000077],
              [120.65601647200003, 27.44627513200004],
              [120.65048261800007, 27.446112372000073],
              [120.64649498800009, 27.444484768000052],
              [120.63770592500009, 27.424302476000037],
              [120.63624108200008, 27.41600169500009],
              [120.63941491000003, 27.408270575000074],
              [120.64893639400009, 27.400213934000078],
              [120.63941491000003, 27.384426174000055],
              [120.63526451900009, 27.379706122000073],
              [120.62256920700008, 27.38035716400009],
              [120.55958092500009, 27.402085679000038],
              [120.54590905000009, 27.403265692000048],
              [120.54493248800009, 27.385199286000045],
              [120.53964277400007, 27.36522044500009],
              [120.52735436300009, 27.34979889500005],
              [120.50489342500009, 27.344956773000035],
              [120.50489342500009, 27.338771877000056],
              [120.51718183700007, 27.337225653000075],
              [120.53419030000009, 27.333197333000044],
              [120.54745527400007, 27.32758209800005],
              [120.54932701900009, 27.32103099200009],
              [120.54615319100003, 27.31549713700008],
              [120.545258009, 27.30849844000005],
              [120.54590905000009, 27.29401276200008],
              [120.54395592500009, 27.285956122000073],
              [120.539398634, 27.28188711100006],
              [120.53467858200008, 27.27960846600007],
              [120.531586134, 27.276678778000075],
              [120.52597089900007, 27.272650458000044],
              [120.52149498800009, 27.26829661700009],
              [120.51783287900003, 27.263006903000075],
              [120.52003014400009, 27.26170482000009],
              [120.52271569100003, 27.25381094000005],
              [120.52597089900007, 27.238836981000077],
              [120.52100670700008, 27.22955963700008],
              [120.512054884, 27.22361888200004],
              [120.508148634, 27.216009833000044],
              [120.51783287900003, 27.201605536000045],
              [120.49903405000009, 27.197211005000042],
              [120.48145592500009, 27.186346747000073],
              [120.46835371200007, 27.182196356000077],
              [120.46338951900009, 27.19790273600006],
              [120.45972741000003, 27.220445054000038],
              [120.45028730600006, 27.22329336100006],
              [120.43702233200008, 27.21946849200009],
              [120.42172285200002, 27.22207265800006],
              [120.41871178500003, 27.20966217700004],
              [120.41920006600003, 27.206366278000075],
              [120.42042076900009, 27.19790273600006],
              [120.42920983200008, 27.173651434000078],
              [120.40674889400009, 27.18423086100006],
              [120.37623131600003, 27.236273505000042],
              [120.34725996200007, 27.24941640800006],
              [120.33326256600003, 27.247300523000035],
              [120.31788170700008, 27.24323151200008],
              [120.303070509, 27.242254950000074],
              [120.29200280000009, 27.24941640800006],
              [120.28809655000009, 27.264471747000073],
              [120.295258009, 27.276271877000056],
              [120.30762780000009, 27.284816799000055],
              [120.31934655000009, 27.290350653000075],
              [120.31112714900007, 27.293890692000048],
              [120.31006920700008, 27.295314846000053],
              [120.31031334700003, 27.294175523000035],
              [120.30640709700003, 27.290350653000075],
              [120.29883873800009, 27.297796942000048],
              [120.30575605600006, 27.300604559000078],
              [120.30909264400009, 27.303941148000035],
              [120.31185957100001, 27.317694403000075],
              [120.29151451900009, 27.30890534100007],
              [120.28516686300009, 27.304022528000075],
              [120.28077233200008, 27.311753648000035],
              [120.27613366000003, 27.31671784100007],
              [120.264008009, 27.32444896000004],
              [120.26571699300007, 27.316351630000042],
              [120.265961134, 27.31191640800006],
              [120.26710045700008, 27.30857982000009],
              [120.27149498800009, 27.304022528000075],
              [120.25855553500003, 27.299994208000044],
              [120.24830162900003, 27.303534247000073],
              [120.23788496200007, 27.309149481000077],
              [120.22372480600006, 27.311468817000048],
              [120.22730553500003, 27.303941148000035],
              [120.23072350400003, 27.29832591400009],
              [120.23560631600003, 27.29401276200008],
              [120.24366295700008, 27.290350653000075],
              [120.24366295700008, 27.28351471600007],
              [120.22567793100006, 27.26862213700008],
              [120.21924889400009, 27.27094147300005],
              [120.21298261800007, 27.283026434000078],
              [120.19581139400009, 27.297796942000048],
              [120.19214928500003, 27.287665106000077],
              [120.19312584700003, 27.27806224200009],
              [120.19556725400003, 27.26976146000004],
              [120.19581139400009, 27.263006903000075],
              [120.19141686300009, 27.25604889500005],
              [120.17530358200008, 27.238836981000077],
              [120.17554772200003, 27.228949286000045],
              [120.17750084700003, 27.221502997000073],
              [120.18238366000003, 27.216864325000074],
              [120.19239342500009, 27.215277411000045],
              [120.20191491000003, 27.21784088700008],
              [120.205414259, 27.223863023000035],
              [120.20663496200007, 27.23045482000009],
              [120.20948326900009, 27.23509349200009],
              [120.23934980600006, 27.251125393000052],
              [120.25660241000003, 27.25690338700008],
              [120.264008009, 27.252834377000056],
              [120.27003014400009, 27.239447333000044],
              [120.29761803500003, 27.22679271000004],
              [120.30640709700003, 27.215277411000045],
              [120.31910241000003, 27.225897528000075],
              [120.33358808700007, 27.23509349200009],
              [120.33358808700007, 27.228908596000053],
              [120.33985436300009, 27.228908596000053],
              [120.34131920700008, 27.23305898600006],
              [120.34278405000009, 27.23582591400009],
              [120.34725996200007, 27.242580471000053],
              [120.36483808700007, 27.225083726000037],
              [120.36548912900003, 27.20962148600006],
              [120.34725996200007, 27.180487372000073],
              [120.36988366000003, 27.18748607000009],
              [120.38624108200008, 27.179510809000078],
              [120.40186608200008, 27.165228583000044],
              [120.42172285200002, 27.153143622000073],
              [120.42172285200002, 27.146958726000037],
              [120.406586134, 27.146429755000042],
              [120.38461347700002, 27.14984772300005],
              [120.37387129000001, 27.146958726000037],
              [120.40796959700003, 27.139553127000056],
              [120.40796959700003, 27.13271719000005],
              [120.38135826900009, 27.12523021000004],
              [120.37387129000001, 27.13271719000005],
              [120.36703535200002, 27.12523021000004],
              [120.38135826900009, 27.11904531500005],
              [120.38135826900009, 27.112250067000048],
              [120.37387129000001, 27.112250067000048],
              [120.37387129000001, 27.106024481000077],
              [120.39503014400009, 27.106024481000077],
              [120.37753339900007, 27.098578192000048],
              [120.35792076900009, 27.09837474200009],
              [120.28272545700008, 27.11229075700004],
              [120.27491295700008, 27.115627346000053],
              [120.262054884, 27.12995026200008],
              [120.25513756600003, 27.13304271000004],
              [120.24366295700008, 27.13271719000005],
              [120.24716230600006, 27.121649481000077],
              [120.25245201900009, 27.11395905200004],
              [120.25839277400007, 27.107082424000055],
              [120.264008009, 27.098578192000048],
              [120.27833092500009, 27.063788153000075],
              [120.27149498800009, 27.057562567000048],
              [120.25782311300009, 27.072658596000053],
              [120.24520918100006, 27.065334377000056],
              [120.23218834700003, 27.05068594000005],
              [120.21631920700008, 27.04393138200004],
              [120.21631920700008, 27.03709544500009],
              [120.24154707100001, 27.034002997000073],
              [120.25562584700003, 27.017523505000042],
              [120.25521894600001, 26.99705638200004],
              [120.23739668100006, 26.98187897300005],
              [120.22999108200008, 26.98932526200008],
              [120.21607506600003, 26.984076239000046],
              [120.19320722700002, 26.981350002000056],
              [120.14869225400003, 26.98187897300005],
              [120.18702233200008, 26.96352773600006],
              [120.199554884, 26.961371161000045],
              [120.21387780000009, 26.963812567000048],
              [120.22592207100001, 26.967352606000077],
              [120.23568769600001, 26.96637604400007],
              [120.24366295700008, 26.955145575000074],
              [120.23934980600006, 26.952337958000044],
              [120.234711134, 26.94562409100007],
              [120.22999108200008, 26.94090403900009],
              [120.23739668100006, 26.92723216400009],
              [120.22860761800007, 26.923000393000052],
              [120.22413170700008, 26.91868724200009],
              [120.219086134, 26.91543203300006],
              [120.20948326900009, 26.91356028900009],
              [120.20077558700007, 26.91543203300006],
              [120.16846764400009, 26.92723216400009],
              [120.14722741000003, 26.929022528000075],
              [120.12574303500003, 26.92731354400007],
              [120.113617384, 26.918768622000073],
              [120.12069746200007, 26.89988841400009],
              [120.10962975400003, 26.894354559000078],
              [120.10279381600003, 26.89008209800005],
              [120.09555097700002, 26.887274481000077],
              [120.08326256600003, 26.88629791900007],
              [120.07911217500009, 26.888373114000046],
              [120.07349694100003, 26.893052476000037],
              [120.06568444100003, 26.89785390800006],
              [120.05575605600006, 26.89988841400009],
              [120.03199303500003, 26.89988841400009],
              [120.05526777400007, 26.88939036700009],
              [120.04420006600003, 26.876695054000038],
              [120.02515709700003, 26.860174872000073],
              [120.02450605600006, 26.83787669500009],
              [120.03370201900009, 26.829738674000055],
              [120.04761803500003, 26.82322825700004],
              [120.06299889400009, 26.818915106000077],
              [120.07626386800007, 26.81736888200004],
              [120.08505293100006, 26.813706773000035],
              [120.09652754000001, 26.805894273000035],
              [120.11085045700008, 26.79873281500005],
              [120.12818444100003, 26.796942450000074],
              [120.11963951900009, 26.78416575700004],
              [120.10694420700008, 26.77179596600007],
              [120.09774824300007, 26.75849030200004],
              [120.10018964900007, 26.74290599200009],
              [120.11239668100006, 26.73574453300006],
              [120.12875410200002, 26.73505280200004],
              [120.14283287900003, 26.732814846000053],
              [120.14869225400003, 26.721177476000037],
              [120.14356530000009, 26.710109768000052],
              [120.13192793100006, 26.70722077000005],
              [120.11850019600001, 26.706366278000075],
              [120.10767662900003, 26.701320705000057],
              [120.10206139400009, 26.689154364000046],
              [120.10360761800007, 26.67527903900009],
              [120.11044355600006, 26.660630601000037],
              [120.12069746200007, 26.64606354400007],
              [120.13436933700007, 26.653509833000044],
              [120.13436933700007, 26.64606354400007],
              [120.09896894600001, 26.62836334800005],
              [120.09034264400009, 26.622219143000052],
              [120.080414259, 26.61741771000004],
              [120.07520592500009, 26.621486721000053],
              [120.076508009, 26.630113023000035],
              [120.08668053500003, 26.639227606000077],
              [120.07968183700007, 26.64606354400007],
              [120.02784264400009, 26.615301825000074],
              [120.01490319100003, 26.611273505000042],
              [119.95997155000009, 26.611273505000042],
              [119.94874108200008, 26.60614655200004],
              [119.94117272200003, 26.59332916900007],
              [119.93702233200008, 26.576727606000077],
              [119.93563886800007, 26.56045156500005],
              [119.88428795700008, 26.523179429000038],
              [119.84717858200008, 26.52362702000005],
              [119.83570397200003, 26.531398830000057],
              [119.83261152400007, 26.550482489000046],
              [119.83594811300009, 26.56150950700004],
              [119.84164472700002, 26.56240469000005],
              [119.84815514400009, 26.56073639500005],
              [119.85377037900003, 26.564113674000055],
              [119.85482832100001, 26.571926174000055],
              [119.85206139400009, 26.591009833000044],
              [119.85377037900003, 26.59829336100006],
              [119.86850019600001, 26.61005280200004],
              [119.88843834700003, 26.617132880000042],
              [119.92896569100003, 26.62563711100006],
              [119.94483483200008, 26.632025458000044],
              [119.96851647200003, 26.64793528900009],
              [119.98414147200003, 26.653509833000044],
              [119.98202558700007, 26.658148505000042],
              [119.97877037900003, 26.669623114000046],
              [119.97681725400003, 26.67401764500005],
              [119.98633873800009, 26.679632880000042],
              [120.00025475400003, 26.70770905200004],
              [120.01148522200003, 26.721177476000037],
              [120.01229902400007, 26.71906159100007],
              [120.01783287900003, 26.71702708500004],
              [120.02816816500001, 26.714992580000057],
              [120.03231855600006, 26.716620184000078],
              [120.03199303500003, 26.720404364000046],
              [120.03052819100003, 26.72492096600007],
              [120.03199303500003, 26.728583075000074],
              [120.07764733200008, 26.785589911000045],
              [120.07968183700007, 26.796942450000074],
              [120.06747480600006, 26.800482489000046],
              [120.01490319100003, 26.79002513200004],
              [119.94629967500009, 26.796942450000074],
              [119.92514082100001, 26.792181708000044],
              [119.92367597700002, 26.78123607000009],
              [119.93563886800007, 26.759019273000035],
              [119.92408287900003, 26.732489325000074],
              [119.90186608200008, 26.710109768000052],
              [119.88803144600001, 26.687241929000038],
              [119.90162194100003, 26.65973541900007],
              [119.87964928500003, 26.65534088700008],
              [119.85694420700008, 26.653509833000044],
              [119.85377037900003, 26.68768952000005],
              [119.85059655000009, 26.689520575000074],
              [119.82919355600006, 26.714992580000057],
              [119.81959069100003, 26.711371161000045],
              [119.803070509, 26.693793036000045],
              [119.79175866000003, 26.68768952000005],
              [119.79151451900009, 26.704779364000046],
              [119.80225670700008, 26.766791083000044],
              [119.81153405000009, 26.775783596000053],
              [119.84009850400003, 26.79002513200004],
              [119.82837975400003, 26.79564036700009],
              [119.81576582100001, 26.79759349200009],
              [119.80323326900009, 26.795721747000073],
              [119.79175866000003, 26.79002513200004],
              [119.79737389400009, 26.81639232000009],
              [119.81503339900007, 26.82562897300005],
              [119.83480879000001, 26.832505601000037],
              [119.84628339900007, 26.85219961100006],
              [119.81983483200008, 26.849269924000055],
              [119.79835045700008, 26.84137604400007],
              [119.78199303500003, 26.828517971000053],
              [119.77059980600006, 26.81053294500009],
              [119.76522871200007, 26.794094143000052],
              [119.76587975400003, 26.784002997000073],
              [119.76880944100003, 26.77440013200004],
              [119.77059980600006, 26.759019273000035],
              [119.76644941500001, 26.744940497000073],
              [119.756195509, 26.73773834800005],
              [119.74301191500001, 26.737127997000073],
              [119.73023522200003, 26.74290599200009],
              [119.73023522200003, 26.74909088700008],
              [119.73267662900003, 26.763413804000038],
              [119.72608483200008, 26.78652578300006],
              [119.71200605600006, 26.807928778000075],
              [119.69239342500009, 26.81736888200004],
              [119.68580162900003, 26.81199778900009],
              [119.68018639400009, 26.799627997000073],
              [119.67628014400009, 26.78587474200009],
              [119.67505944100003, 26.77643463700008],
              [119.67798912900003, 26.76312897300005],
              [119.68384850400003, 26.75421784100007],
              [119.71029707100001, 26.72988515800006],
              [119.72022545700008, 26.72451406500005],
              [119.72738691500001, 26.717922268000052],
              [119.73023522200003, 26.704738674000055],
              [119.724945509, 26.697821356000077],
              [119.71314537900003, 26.69985586100006],
              [119.69613691500001, 26.708197333000044],
              [119.68043053500003, 26.721828518000052],
              [119.66382897200003, 26.74054596600007],
              [119.64600670700008, 26.75332265800006],
              [119.62655683700007, 26.74909088700008],
              [119.62037194100003, 26.765570380000042],
              [119.62265058700007, 26.777167059000078],
              [119.62183678500003, 26.786769924000055],
              [119.60604902400007, 26.796942450000074],
              [119.59774824300007, 26.79710521000004],
              [119.58456464900007, 26.794623114000046],
              [119.57553144600001, 26.788031317000048],
              [119.57943769600001, 26.77643463700008],
              [119.57154381600003, 26.766546942000048],
              [119.55762780000009, 26.75877513200004],
              [119.55209394600001, 26.74909088700008],
              [119.55030358200008, 26.737209377000056],
              [119.55152428500003, 26.725165106000077],
              [119.55469811300009, 26.71482982000009],
              [119.558929884, 26.708197333000044],
              [119.57081139400009, 26.703273830000057],
              [119.58375084700003, 26.703924872000073],
              [119.59595787900003, 26.70331452000005],
              [119.60604902400007, 26.694525458000044],
              [119.60824629000001, 26.683539130000042],
              [119.60645592500009, 26.66990794500009],
              [119.59986412900003, 26.64606354400007],
              [119.56812584700003, 26.664536851000037],
              [119.558929884, 26.666571356000077],
              [119.54444420700008, 26.662502346000053],
              [119.54110761800007, 26.656317450000074],
              [119.54542076900009, 26.63617584800005],
              [119.55420983200008, 26.615179755000042],
              [119.59237714900007, 26.59088776200008],
              [119.59986412900003, 26.570379950000074],
              [119.60604902400007, 26.570379950000074],
              [119.61890709700003, 26.587836005000042],
              [119.63778730600006, 26.598822333000044],
              [119.65796959700003, 26.60765208500004],
              [119.67505944100003, 26.618801174000055],
              [119.68751061300009, 26.611273505000042],
              [119.70093834700003, 26.608587958000044],
              [119.73023522200003, 26.611273505000042],
              [119.72274824300007, 26.611273505000042],
              [119.73519941500001, 26.61196523600006],
              [119.74219811300009, 26.608628648000035],
              [119.74293053500003, 26.60175202000005],
              [119.73642011800007, 26.591457424000055],
              [119.74862714900007, 26.587958075000074],
              [119.77173912900003, 26.58388906500005],
              [119.78492272200003, 26.577826239000046],
              [119.78223717500009, 26.56476471600007],
              [119.78272545700008, 26.55963776200008],
              [119.78492272200003, 26.550482489000046],
              [119.77418053500003, 26.559515692000048],
              [119.77059980600006, 26.564113674000055],
              [119.76172936300009, 26.550726630000042],
              [119.76587975400003, 26.534369208000044],
              [119.77914472700002, 26.520697333000044],
              [119.79859459700003, 26.515773830000057],
              [119.795258009, 26.51162344000005],
              [119.79346764400009, 26.508205471000053],
              [119.79061933700007, 26.505194403000075],
              [119.78492272200003, 26.502020575000074],
              [119.79428144600001, 26.49713776200008],
              [119.80225670700008, 26.489447333000044],
              [119.81226647200003, 26.47479889500005],
              [119.81771894600001, 26.462144273000035],
              [119.81885826900009, 26.453192450000074],
              [119.816742384, 26.44472890800006],
              [119.81226647200003, 26.43378327000005],
              [119.80884850400003, 26.43305084800005],
              [119.79574629000001, 26.43427155200004],
              [119.79175866000003, 26.43378327000005],
              [119.79110761800007, 26.42991771000004],
              [119.79249108200008, 26.41665273600006],
              [119.79175866000003, 26.413316148000035],
              [119.77206464900007, 26.406724351000037],
              [119.76197350400003, 26.407456773000035],
              [119.75204511800007, 26.431463934000078],
              [119.73764082100001, 26.44367096600007],
              [119.71876061300009, 26.45184967700004],
              [119.69922936300009, 26.454901434000078],
              [119.689789259, 26.459458726000037],
              [119.66456139400009, 26.492132880000042],
              [119.65365644600001, 26.49803294500009],
              [119.64698326900009, 26.49404531500005],
              [119.640961134, 26.482163804000038],
              [119.63575280000009, 26.479437567000048],
              [119.62549889400009, 26.47093333500004],
              [119.62037194100003, 26.467962958000044],
              [119.60572350400003, 26.474351304000038],
              [119.59986412900003, 26.47479889500005],
              [119.57960045700008, 26.47089264500005],
              [119.57129967500009, 26.465725002000056],
              [119.56641686300009, 26.454901434000078],
              [119.57309004000001, 26.43781159100007],
              [119.594086134, 26.43357982000009],
              [119.61630293100006, 26.43740469000005],
              [119.62655683700007, 26.44432200700004],
              [119.63086998800009, 26.44871653900009],
              [119.63998457100001, 26.44440338700008],
              [119.64844811300009, 26.437445380000042],
              [119.65430748800009, 26.429022528000075],
              [119.65552819100003, 26.355617580000057],
              [119.66529381600003, 26.34015534100007],
              [119.68873131600003, 26.337591864000046],
              [119.68661543100006, 26.33307526200008],
              [119.68384850400003, 26.32168203300006],
              [119.68189537900003, 26.31712474200009],
              [119.69629967500009, 26.316839911000045],
              [119.73568769600001, 26.322211005000042],
              [119.74708092500009, 26.32762278900009],
              [119.748383009, 26.35887278900009],
              [119.75440514400009, 26.37205638200004],
              [119.77059980600006, 26.364935614000046],
              [119.78012129000001, 26.37498607000009],
              [119.78467858200008, 26.386379299000055],
              [119.78736412900003, 26.397406317000048],
              [119.79175866000003, 26.40648021000004],
              [119.79769941500001, 26.411322333000044],
              [119.82577558700007, 26.426947333000044],
              [119.83480879000001, 26.41209544500009],
              [119.84628339900007, 26.402411200000074],
              [119.85132897200003, 26.39280833500004],
              [119.84009850400003, 26.378566799000055],
              [119.855804884, 26.37763092700004],
              [119.88013756600003, 26.363104559000078],
              [119.89478600400003, 26.358710028000075],
              [119.90845787900003, 26.360500393000052],
              [119.93482506600003, 26.37055084800005],
              [119.94996178500003, 26.372300523000035],
              [119.94996178500003, 26.364935614000046],
              [119.88819420700008, 26.318833726000037],
              [119.87745201900009, 26.313381252000056],
              [119.85474694100003, 26.32754140800006],
              [119.82675214900007, 26.32835521000004],
              [119.801117384, 26.317572333000044],
              [119.78492272200003, 26.296616929000038],
              [119.79086347700002, 26.29555898600006],
              [119.80543053500003, 26.29043203300006],
              [119.79273522200003, 26.284084377000056],
              [119.78467858200008, 26.28709544500009],
              [119.77662194100003, 26.29328034100007],
              [119.76441491000003, 26.296616929000038],
              [119.75342858200008, 26.29441966400009],
              [119.73267662900003, 26.28506094000005],
              [119.71933027400007, 26.282945054000038],
              [119.69459069100003, 26.282945054000038],
              [119.67359459700003, 26.280503648000035],
              [119.65430748800009, 26.272406317000048],
              [119.63412519600001, 26.255072333000044],
              [119.65170332100001, 26.250067450000074],
              [119.66822350400003, 26.242010809000078],
              [119.66480553500003, 26.231634833000044],
              [119.66822350400003, 26.221502997000073],
              [119.65243574300007, 26.217596747000073],
              [119.63697350400003, 26.21165599200009],
              [119.62501061300009, 26.202948309000078],
              [119.62037194100003, 26.19049713700008],
              [119.61353600400003, 26.182196356000077],
              [119.60010826900009, 26.176336981000077],
              [119.59180748800009, 26.166408596000053],
              [119.59986412900003, 26.145819403000075],
              [119.56112714900007, 26.12498607000009],
              [119.53736412900003, 26.096828518000052],
              [119.51832116000003, 26.064886786000045],
              [119.49374433700007, 26.032863674000055],
              [119.47315514400009, 25.99713776200008],
              [119.45850670700008, 25.982489325000074],
              [119.43555748800009, 25.981350002000056],
              [119.43173261800007, 25.985296942000048],
              [119.42147871200007, 26.002386786000045],
              [119.41504967500009, 26.00926341400009],
              [119.40487714900007, 26.01386139500005],
              [119.38282311300009, 26.01862213700008],
              [119.373383009, 26.022284247000073],
              [119.34335371200007, 26.04205963700008],
              [119.32691491000003, 26.048041083000044],
              [119.27711022200003, 26.05292389500005],
              [119.26124108200008, 26.06053294500009],
              [119.23316491000003, 26.08779531500005],
              [119.21583092500009, 26.100083726000037],
              [119.20093834700003, 26.104681708000044],
              [119.16114342500009, 26.11163971600007],
              [119.15162194100003, 26.115708726000037],
              [119.12020918100006, 26.135931708000044],
              [119.10360761800007, 26.143133856000077],
              [119.09351647200003, 26.145819403000075],
              [119.09351647200003, 26.139593817000048],
              [119.11597741000003, 26.123195705000057],
              [119.13648522200003, 26.10293203300006],
              [119.15731855600006, 26.090765692000048],
              [119.18148847700002, 26.09861888200004],
              [119.19516035200002, 26.087591864000046],
              [119.20069420700008, 26.075913804000038],
              [119.20899498800009, 26.043402411000045],
              [119.21737714900007, 26.028957424000055],
              [119.23731530000009, 26.006252346000053],
              [119.24301191500001, 25.995021877000056],
              [119.24683678500003, 25.967230536000045],
              [119.25497480600006, 25.963283596000053],
              [119.29615319100003, 25.956976630000042],
              [119.32984459700003, 25.944281317000048],
              [119.34669030000009, 25.940375067000048],
              [119.37753339900007, 25.94139232000009],
              [119.40975996200007, 25.94985586100006],
              [119.44092858200008, 25.963812567000048],
              [119.49000084700003, 25.994208075000074],
              [119.49683678500003, 26.001776434000078],
              [119.50001061300009, 26.010199286000045],
              [119.50180097700002, 26.02920156500005],
              [119.504242384, 26.035956122000073],
              [119.51905358200008, 26.04450104400007],
              [119.55429121200007, 26.04564036700009],
              [119.56641686300009, 26.05023834800005],
              [119.61939537900003, 26.023504950000074],
              [119.64844811300009, 26.015448309000078],
              [119.67505944100003, 26.022284247000073],
              [119.69540449300007, 26.00263092700004],
              [119.70069420700008, 25.99518463700008],
              [119.70240319100003, 25.98505280200004],
              [119.69898522200003, 25.97256094000005],
              [119.67505944100003, 25.92609284100007],
              [119.66553795700008, 25.915350653000075],
              [119.65430748800009, 25.90692780200004],
              [119.64039147200003, 25.90135325700004],
              [119.62354576900009, 25.89940013200004],
              [119.61646569100003, 25.892645575000074],
              [119.59986412900003, 25.844183661000045],
              [119.58407636800007, 25.87693919500009],
              [119.57422936300009, 25.884914455000057],
              [119.56641686300009, 25.87205638200004],
              [119.57789147200003, 25.86237213700008],
              [119.57911217500009, 25.84125397300005],
              [119.58301842500009, 25.82021719000005],
              [119.60303795700008, 25.810614325000074],
              [119.60792076900009, 25.805161851000037],
              [119.60840905000009, 25.792669989000046],
              [119.60604902400007, 25.76902903900009],
              [119.60987389400009, 25.76715729400007],
              [119.61670983200008, 25.76471588700008],
              [119.62086022200003, 25.760321356000077],
              [119.61670983200008, 25.75226471600007],
              [119.59644616000003, 25.73151276200008],
              [119.59376061300009, 25.721869208000044],
              [119.59302819100003, 25.693182684000078],
              [119.58993574300007, 25.687160549000055],
              [119.58716881600003, 25.685695705000057],
              [119.584320509, 25.68260325700004],
              [119.57992597700002, 25.67999909100007],
              [119.572601759, 25.67967357000009],
              [119.56763756600003, 25.68195221600007],
              [119.56430097700002, 25.68968333500004],
              [119.53541100400003, 25.705877997000073],
              [119.52279707100001, 25.70579661700009],
              [119.51734459700003, 25.69017161700009],
              [119.50058027400007, 25.68968333500004],
              [119.48707116000003, 25.687323309000078],
              [119.47706139400009, 25.67967357000009],
              [119.46949303500003, 25.68357982000009],
              [119.46363366000003, 25.685288804000038],
              [119.44906660200002, 25.687160549000055],
              [119.45590254000001, 25.663723049000055],
              [119.45972741000003, 25.632879950000074],
              [119.46705162900003, 25.61391836100006],
              [119.48324629000001, 25.62567780200004],
              [119.47934004000001, 25.60154857000009],
              [119.48104902400007, 25.580471096000053],
              [119.49244225400003, 25.56476471600007],
              [119.51734459700003, 25.556789455000057],
              [119.52206464900007, 25.56150950700004],
              [119.52670332100001, 25.57099030200004],
              [119.53443444100003, 25.575873114000046],
              [119.54883873800009, 25.56704336100006],
              [119.55844160200002, 25.563788153000075],
              [119.56812584700003, 25.56903717700004],
              [119.57569420700008, 25.577785549000055],
              [119.57943769600001, 25.58466217700004],
              [119.56836998800009, 25.547430731000077],
              [119.57227623800009, 25.53343333500004],
              [119.59310957100001, 25.52948639500005],
              [119.58741295700008, 25.521918036000045],
              [119.58301842500009, 25.517320054000038],
              [119.57691491000003, 25.515326239000046],
              [119.56641686300009, 25.51581452000005],
              [119.58163496200007, 25.50926341400009],
              [119.58985436300009, 25.507879950000074],
              [119.59986412900003, 25.508368231000077],
              [119.58741295700008, 25.49872467700004],
              [119.58163496200007, 25.496161200000074],
              [119.572601759, 25.494696356000077],
              [119.572601759, 25.48786041900007],
              [119.59848066500001, 25.492743231000077],
              [119.60360761800007, 25.491156317000048],
              [119.59986412900003, 25.481024481000077],
              [119.59986412900003, 25.47483958500004],
              [119.61142011800007, 25.47410716400009],
              [119.62240644600001, 25.46942780200004],
              [119.62802168100006, 25.461371161000045],
              [119.62354576900009, 25.450344143000052],
              [119.61402428500003, 25.438788153000075],
              [119.61670983200008, 25.437241929000038],
              [119.625336134, 25.438055731000077],
              [119.63412519600001, 25.433254299000055],
              [119.64527428500003, 25.41046784100007],
              [119.64600670700008, 25.39256419500009],
              [119.63729902400007, 25.37799713700008],
              [119.62037194100003, 25.364976304000038],
              [119.63778730600006, 25.36359284100007],
              [119.64559980600006, 25.36155833500004],
              [119.65455162900003, 25.35814036700009],
              [119.60287519600001, 25.346136786000045],
              [119.57943769600001, 25.34446849200009],
              [119.58301842500009, 25.35301341400009],
              [119.58790123800009, 25.36078522300005],
              [119.59359785200002, 25.36709219000005],
              [119.59986412900003, 25.371161200000074],
              [119.58871504000001, 25.401312567000048],
              [119.57797285200002, 25.41868724200009],
              [119.58253014400009, 25.425604559000078],
              [119.58985436300009, 25.43183014500005],
              [119.59310957100001, 25.43943919500009],
              [119.58969160200002, 25.44326406500005],
              [119.57626386800007, 25.462836005000042],
              [119.57601972700002, 25.467352606000077],
              [119.56836998800009, 25.46625397300005],
              [119.56153405000009, 25.463283596000053],
              [119.55600019600001, 25.458929755000042],
              [119.55209394600001, 25.45376211100006],
              [119.54818769600001, 25.456976630000042],
              [119.54542076900009, 25.458644924000055],
              [119.53858483200008, 25.46116771000004],
              [119.53589928500003, 25.44993724200009],
              [119.53443444100003, 25.43378327000005],
              [119.53598066500001, 25.419134833000044],
              [119.54200280000009, 25.41278717700004],
              [119.55616295700008, 25.41046784100007],
              [119.55819746200007, 25.40460846600007],
              [119.55209394600001, 25.38886139500005],
              [119.54444420700008, 25.37718333500004],
              [119.52588951900009, 25.37409088700008],
              [119.50326582100001, 25.373928127000056],
              [119.48324629000001, 25.371161200000074],
              [119.49122155000009, 25.383205471000053],
              [119.49781334700003, 25.39940013200004],
              [119.50253339900007, 25.41620514500005],
              [119.504242384, 25.42987702000005],
              [119.50204511800007, 25.433986721000053],
              [119.49683678500003, 25.436753648000035],
              [119.49219811300009, 25.440375067000048],
              [119.49073326900009, 25.446926174000055],
              [119.49366295700008, 25.454250393000052],
              [119.50294030000009, 25.46246979400007],
              [119.50546308700007, 25.472316799000055],
              [119.50733483200008, 25.474432684000078],
              [119.50489342500009, 25.47492096600007],
              [119.46615644600001, 25.47483958500004],
              [119.45826256600003, 25.46629466400009],
              [119.45321699300007, 25.449774481000077],
              [119.44703209700003, 25.438788153000075],
              [119.43555748800009, 25.446926174000055],
              [119.43311608200008, 25.459540106000077],
              [119.44556725400003, 25.49013906500005],
              [119.44906660200002, 25.50527578300006],
              [119.44190514400009, 25.509507554000038],
              [119.36597741000003, 25.520697333000044],
              [119.35653730600006, 25.52692291900007],
              [119.35287519600001, 25.53974030200004],
              [119.35604902400007, 25.550726630000042],
              [119.38086998800009, 25.59088776200008],
              [119.36890709700003, 25.584906317000048],
              [119.36475670700008, 25.582180080000057],
              [119.36036217500009, 25.577297268000052],
              [119.35287519600001, 25.58466217700004],
              [119.35629316500001, 25.600043036000045],
              [119.34302819100003, 25.609198309000078],
              [119.322601759, 25.611029364000046],
              [119.30518639400009, 25.60455963700008],
              [119.32138105600006, 25.58734772300005],
              [119.31055748800009, 25.577866929000038],
              [119.27784264400009, 25.570461330000057],
              [119.27198326900009, 25.557521877000056],
              [119.26880944100003, 25.52692291900007],
              [119.26075280000009, 25.512111721000053],
              [119.23780358200008, 25.481756903000075],
              [119.22934004000001, 25.47483958500004],
              [119.21509850400003, 25.47028229400007],
              [119.18336022200003, 25.464992580000057],
              [119.17164147200003, 25.457464911000045],
              [119.16138756600003, 25.448919989000046],
              [119.12867272200003, 25.42999909100007],
              [119.11670983200008, 25.42641836100006],
              [119.10254967500009, 25.420314846000053],
              [119.10962975400003, 25.406805731000077],
              [119.15699303500003, 25.362616278000075],
              [119.16529381600003, 25.349554755000042],
              [119.16846764400009, 25.333929755000042],
              [119.17318769600001, 25.325140692000048],
              [119.18311608200008, 25.329413153000075],
              [119.19239342500009, 25.34202708500004],
              [119.19532311300009, 25.35814036700009],
              [119.20337975400003, 25.35814036700009],
              [119.22315514400009, 25.31659577000005],
              [119.201508009, 25.306341864000046],
              [119.191742384, 25.29954661700009],
              [119.18148847700002, 25.28925202000005],
              [119.19320722700002, 25.27496979400007],
              [119.19678795700008, 25.263332424000055],
              [119.20126386800007, 25.259711005000042],
              [119.21631920700008, 25.269354559000078],
              [119.22584069100003, 25.279689846000053],
              [119.234711134, 25.294867255000042],
              [119.24122155000009, 25.312567450000074],
              [119.24301191500001, 25.330226955000057],
              [119.25416100400003, 25.322821356000077],
              [119.26514733200008, 25.317572333000044],
              [119.27369225400003, 25.31858958500004],
              [119.27784264400009, 25.330226955000057],
              [119.28866621200007, 25.325425523000035],
              [119.293304884, 25.321966864000046],
              [119.29835045700008, 25.31659577000005],
              [119.291351759, 25.31659577000005],
              [119.29696699300007, 25.307196356000077],
              [119.31885826900009, 25.279364325000074],
              [119.32422936300009, 25.275091864000046],
              [119.33578535200002, 25.272284247000073],
              [119.34750410200002, 25.26776764500005],
              [119.35287519600001, 25.25849030200004],
              [119.34424889400009, 25.24237702000005],
              [119.32374108200008, 25.237982489000046],
              [119.28126061300009, 25.241441148000035],
              [119.27247155000009, 25.231756903000075],
              [119.28882897200003, 25.189113674000055],
              [119.28126061300009, 25.179388739000046],
              [119.25562625300006, 25.17589713600006],
              [119.2427534310001, 25.189987132000056],
              [119.22937574000002, 25.193215206000048],
              [119.21265709700003, 25.18622467700004],
              [119.19288170700008, 25.18231842700004],
              [119.17562910200002, 25.17649974200009],
              [119.16467866300002, 25.19157374000008],
              [119.15335906500002, 25.206954893000045],
              [119.14197462600009, 25.220978417000083],
              [119.11609619800004, 25.213781835000077],
              [119.10179393100009, 25.196634419000077],
              [119.1041801340001, 25.182947837000086],
              [119.11425057600002, 25.173056235000047],
              [119.11988366000003, 25.160711981000077],
              [119.12484785200002, 25.155503648000035],
              [119.129242384, 25.14866771000004],
              [119.13379967500009, 25.138413804000038],
              [119.14657636800007, 25.143744208000044],
              [119.15308678500003, 25.13971588700008],
              [119.14991295700008, 25.13157786700009],
              [119.13379967500009, 25.124741929000038],
              [119.11670983200008, 25.126613674000055],
              [119.10352623800009, 25.133246161000045],
              [119.09327233200008, 25.135646877000056],
              [119.08545983200008, 25.124741929000038],
              [119.09034264400009, 25.121242580000057],
              [119.09310957100001, 25.118068752000056],
              [119.09571373800009, 25.11473216400009],
              [119.09913170700008, 25.111151434000078],
              [119.08944746200007, 25.113674221000053],
              [119.064789259, 25.124741929000038],
              [119.07398522200003, 25.145656643000052],
              [119.07919355600006, 25.152085679000038],
              [119.06470787900003, 25.162543036000045],
              [119.05323326900009, 25.15761953300006],
              [119.04590905000009, 25.143052476000037],
              [119.04444420700008, 25.124741929000038],
              [119.02906334700003, 25.14052969000005],
              [119.03402754000001, 25.158677476000037],
              [119.05860436300009, 25.18622467700004],
              [119.06910241000003, 25.203680731000077],
              [119.06885826900009, 25.216742255000042],
              [119.05738366000003, 25.225002346000053],
              [119.03475996200007, 25.227769273000035],
              [118.98731530000009, 25.22223541900007],
              [118.96933027400007, 25.226385809000078],
              [118.97999108200008, 25.24485911700009],
              [119.00001061300009, 25.254055080000057],
              [119.02494595300004, 25.25928888800007],
              [119.02729761500007, 25.278237969000088],
              [118.98365319100003, 25.283026434000078],
              [118.91846764400009, 25.26439036700009],
              [118.90780683700007, 25.25849030200004],
              [118.89649498800009, 25.257513739000046],
              [118.87558027400007, 25.243841864000046],
              [118.86483808700007, 25.22797272300005],
              [118.88404381600003, 25.220363674000055],
              [118.91114342500009, 25.217230536000045],
              [118.91382897200003, 25.208685614000046],
              [118.90927168100006, 25.195705471000053],
              [118.91529381600003, 25.179388739000046],
              [118.92090905000009, 25.187933661000045],
              [118.93295332100001, 25.194566148000035],
              [118.94825280000009, 25.19717031500005],
              [118.96314537900003, 25.19367096600007],
              [118.97461998800009, 25.182562567000048],
              [118.97217858200008, 25.17206452000005],
              [118.95557701900009, 25.152085679000038],
              [118.94898522200003, 25.13694896000004],
              [118.94906660200002, 25.118963934000078],
              [118.94727623800009, 25.11318594000005],
              [118.94296308700007, 25.10883209800005],
              [118.93515058700007, 25.104315497000073],
              [118.92139733200008, 25.101385809000078],
              [118.90316816500001, 25.102484442000048],
              [118.88559004000001, 25.10614655200004],
              [118.86768996700005, 25.100408375000086],
              [118.85767662900003, 25.098049221000053],
              [118.84896894600001, 25.08661530200004],
              [118.84913170700008, 25.07379791900007],
              [118.86011803500003, 25.05654531500005],
              [118.87794030000009, 25.040716864000046],
              [118.89576256600003, 25.03351471600007],
              [118.93515058700007, 25.022365627000056],
              [118.92831464900007, 25.014878648000035],
              [118.94068444100003, 25.006659247000073],
              [118.95370527400007, 25.00299713700008],
              [118.96705162900003, 25.00454336100006],
              [118.97999108200008, 25.011786200000074],
              [118.99048912900003, 25.040187893000052],
              [118.99732506600003, 25.053534247000073],
              [119.00416100400003, 25.05023834800005],
              [119.00342858200008, 25.04047272300005],
              [118.99952233200008, 25.02407461100006],
              [118.99341881600003, 25.008734442000048],
              [118.986664259, 25.001898505000042],
              [118.98324629000001, 24.99510325700004],
              [118.98731530000009, 24.979722398000035],
              [118.99732506600003, 24.95343659100007],
              [119.01319420700008, 24.958197333000044],
              [119.01767011800007, 24.960272528000075],
              [119.00904381600003, 24.947333075000074],
              [118.99268639400009, 24.93695709800005],
              [118.97706139400009, 24.934027411000045],
              [118.96998131600003, 24.94354889500005],
              [118.96371504000001, 24.954413153000075],
              [118.94849694100003, 24.956773179000038],
              [118.91163170700008, 24.95343659100007],
              [118.90113366000003, 24.93781159100007],
              [118.90992272200003, 24.907171942000048],
              [118.93417402400007, 24.886053778000075],
              [118.96998131600003, 24.898871161000045],
              [118.97323652400007, 24.893784898000035],
              [118.97388756600003, 24.891913153000075],
              [118.97250410200002, 24.89012278900009],
              [118.96998131600003, 24.885199286000045],
              [118.972992384, 24.883734442000048],
              [118.974945509, 24.88385651200008],
              [118.97584069100003, 24.88271719000005],
              [118.97616621200007, 24.877752997000073],
              [118.95199629000001, 24.870754299000055],
              [118.92440839900007, 24.869940497000073],
              [118.89795983200008, 24.875799872000073],
              [118.87720787900003, 24.888617255000042],
              [118.86670983200008, 24.891017971000053],
              [118.83765709700003, 24.880560614000046],
              [118.82593834700003, 24.877752997000073],
              [118.81275475400003, 24.881659247000073],
              [118.80274498800009, 24.88808828300006],
              [118.79208418100006, 24.891099351000037],
              [118.77759850400003, 24.885199286000045],
              [118.78012129000001, 24.86782461100006],
              [118.76197350400003, 24.857977606000077],
              [118.73633873800009, 24.851385809000078],
              [118.71607506600003, 24.843573309000078],
              [118.70606530000009, 24.846625067000048],
              [118.69979902400007, 24.85154857000009],
              [118.69809004000001, 24.859523830000057],
              [118.70175214900007, 24.871527411000045],
              [118.70777428500003, 24.87726471600007],
              [118.72518964900007, 24.88279857000009],
              [118.72974694100003, 24.885199286000045],
              [118.72950280000009, 24.900539455000057],
              [118.72046959700003, 24.916896877000056],
              [118.70753014400009, 24.93121979400007],
              [118.69556725400003, 24.94041575700004],
              [118.69752037900003, 24.906805731000077],
              [118.69556725400003, 24.898871161000045],
              [118.68881269600001, 24.895738023000035],
              [118.68482506600003, 24.90330638200004],
              [118.68433678500003, 24.91547272300005],
              [118.68808027400007, 24.926174221000053],
              [118.68270918100006, 24.930975653000075],
              [118.67725670700008, 24.93740469000005],
              [118.66773522200003, 24.95343659100007],
              [118.66163170700008, 24.94086334800005],
              [118.64405358200008, 24.92413971600007],
              [118.64039147200003, 24.91559479400007],
              [118.64747155000009, 24.90851471600007],
              [118.66211998800009, 24.898382880000042],
              [118.67343183700007, 24.88662344000005],
              [118.67115319100003, 24.874660549000055],
              [118.65121504000001, 24.866888739000046],
              [118.62411543100006, 24.86782461100006],
              [118.59579511800007, 24.874741929000038],
              [118.57203209700003, 24.885199286000045],
              [118.61280358200008, 24.85578034100007],
              [118.61988366000003, 24.843573309000078],
              [118.62061608200008, 24.829291083000044],
              [118.61801191500001, 24.817531643000052],
              [118.61793053500003, 24.80532461100006],
              [118.63257897200003, 24.77724844000005],
              [118.63795006600003, 24.77212148600006],
              [118.64039147200003, 24.77875397300005],
              [118.64380944100003, 24.78221263200004],
              [118.65162194100003, 24.782538153000075],
              [118.66065514400009, 24.78188711100006],
              [118.66773522200003, 24.782171942000048],
              [118.68653405000009, 24.792792059000078],
              [118.69752037900003, 24.801662502000056],
              [118.70175214900007, 24.81004466400009],
              [118.71102949300007, 24.80487702000005],
              [118.71509850400003, 24.79832591400009],
              [118.71631920700008, 24.789943752000056],
              [118.71607506600003, 24.77875397300005],
              [118.71998131600003, 24.769354559000078],
              [118.72877037900003, 24.769476630000042],
              [118.74341881600003, 24.775336005000042],
              [118.75953209700003, 24.76776764500005],
              [118.76295006600003, 24.76268138200004],
              [118.76392662900003, 24.751695054000038],
              [118.74854576900009, 24.725165106000077],
              [118.74683678500003, 24.72068919500009],
              [118.73202558700007, 24.716457424000055],
              [118.72022545700008, 24.705552476000037],
              [118.69874108200008, 24.67601146000004],
              [118.68539472700002, 24.666489976000037],
              [118.67579186300009, 24.67145416900007],
              [118.66651451900009, 24.68301015800006],
              [118.65406334700003, 24.693426825000074],
              [118.64210045700008, 24.67869700700004],
              [118.63599694100003, 24.663763739000046],
              [118.63388105600006, 24.647284247000073],
              [118.63355553500003, 24.627875067000048],
              [118.64022871200007, 24.616929429000038],
              [118.65381920700008, 24.616400458000044],
              [118.66415449300007, 24.612250067000048],
              [118.66146894600001, 24.590318101000037],
              [118.64657636800007, 24.568426825000074],
              [118.62045332100001, 24.545477606000077],
              [118.59083092500009, 24.52806224200009],
              [118.56519616000003, 24.522691148000035],
              [118.56128991000003, 24.520697333000044],
              [118.55722089900007, 24.517238674000055],
              [118.55396569100003, 24.518052476000037],
              [118.55160566500001, 24.528957424000055],
              [118.55087324300007, 24.53701406500005],
              [118.55136152400007, 24.54596588700008],
              [118.55445397200003, 24.553208726000037],
              [118.56153405000009, 24.55621979400007],
              [118.57813561300009, 24.560207424000055],
              [118.57113691500001, 24.56899648600006],
              [118.50123131600003, 24.60814036700009],
              [118.48609459700003, 24.61082591400009],
              [118.47486412900003, 24.61432526200008],
              [118.44532311300009, 24.628973700000074],
              [118.428070509, 24.631333726000037],
              [118.43270918100006, 24.64472077000005],
              [118.43466230600006, 24.659002997000073],
              [118.43490644600001, 24.68964264500005],
              [118.43124433700007, 24.699693101000037],
              [118.42261803500003, 24.69285716400009],
              [118.41146894600001, 24.680121161000045],
              [118.40088951900009, 24.672308661000045],
              [118.42188561300009, 24.62449778900009],
              [118.40479576900009, 24.606634833000044],
              [118.37989342500009, 24.590236721000053],
              [118.35165449300007, 24.58234284100007],
              [118.32504316500001, 24.590318101000037],
              [118.31739342500009, 24.58698151200008],
              [118.30713951900009, 24.588324286000045],
              [118.28402754000001, 24.597805080000057],
              [118.27979576900009, 24.58470286700009],
              [118.27295983200008, 24.57440827000005],
              [118.26319420700008, 24.570379950000074],
              [118.24984785200002, 24.576117255000042],
              [118.24179121200007, 24.543768622000073],
              [118.21900475400003, 24.541449286000045],
              [118.19434655000009, 24.556463934000078],
              [118.18116295700008, 24.576117255000042],
              [118.18165123800009, 24.597805080000057],
              [118.19166100400003, 24.600897528000075],
              [118.20508873800009, 24.59870026200008],
              [118.21583092500009, 24.603989976000037],
              [118.215179884, 24.61481354400007],
              [118.20370527400007, 24.621527411000045],
              [118.187836134, 24.624660549000055],
              [118.17432701900009, 24.62449778900009],
              [118.18384850400003, 24.64276764500005],
              [118.18759199300007, 24.657375393000052],
              [118.18140709700003, 24.672756252000056],
              [118.160492384, 24.693426825000074],
              [118.15748131600003, 24.662665106000077],
              [118.15088951900009, 24.658636786000045],
              [118.14527428500003, 24.658636786000045],
              [118.14144941500001, 24.65696849200009],
              [118.13746178500003, 24.63377513200004],
              [118.13095136800007, 24.620062567000048],
              [118.12216230600006, 24.607855536000045],
              [118.11280358200008, 24.597805080000057],
              [118.11036217500009, 24.584051825000074],
              [118.10336347700002, 24.584784247000073],
              [118.09229576900009, 24.597805080000057],
              [118.04444420700008, 24.617661851000037],
              [118.03695722700002, 24.597805080000057],
              [118.04476972700002, 24.575995184000078],
              [118.03736412900003, 24.560614325000074],
              [118.02108808700007, 24.55499909100007],
              [118.00294030000009, 24.562445380000042],
              [118.00928795700008, 24.58071523600006],
              [117.99244225400003, 24.571478583000044],
              [117.97486412900003, 24.55272044500009],
              [117.97877037900003, 24.54254791900007],
              [118.02076256600003, 24.53656647300005],
              [118.04403730600006, 24.528265692000048],
              [118.05811608200008, 24.51585521000004],
              [118.04428144600001, 24.49803294500009],
              [118.03671308700007, 24.49087148600006],
              [118.02711022200003, 24.487941799000055],
              [118.01392662900003, 24.487616278000075],
              [118.00936933700007, 24.485541083000044],
              [118.00692793100006, 24.48045482000009],
              [117.99952233200008, 24.470851955000057],
              [118.00757897200003, 24.465725002000056],
              [118.02027428500003, 24.45465729400007],
              [118.02173912900003, 24.445746161000045],
              [117.99610436300009, 24.446966864000046],
              [117.91187584700003, 24.478949286000045],
              [117.86768639400009, 24.489569403000075],
              [117.82593834700003, 24.48045482000009],
              [117.84628339900007, 24.475083726000037],
              [117.86622155000009, 24.473578192000048],
              [117.88485761800007, 24.46865469000005],
              [117.90113366000003, 24.453192450000074],
              [117.81568444100003, 24.471625067000048],
              [117.79127037900003, 24.46747467700004],
              [117.79127037900003, 24.460638739000046],
              [117.87460371200007, 24.396307684000078],
              [117.90731855600006, 24.384914455000057],
              [117.98934980600006, 24.39476146000004],
              [118.01954186300009, 24.406195380000042],
              [118.03012129000001, 24.41282786700009],
              [118.04297936300009, 24.406683661000045],
              [118.04745527400007, 24.39907461100006],
              [118.04688561300009, 24.38963450700004],
              [118.04078209700003, 24.365627346000053],
              [118.03573652400007, 24.361029364000046],
              [118.03003991000003, 24.35814036700009],
              [118.02393639400009, 24.350775458000044],
              [118.01587975400003, 24.32684967700004],
              [118.02418053500003, 24.323553778000075],
              [118.03736412900003, 24.331284898000035],
              [118.04444420700008, 24.34052155200004],
              [118.05298912900003, 24.346909898000035],
              [118.07178795700008, 24.348863023000035],
              [118.09058678500003, 24.341457424000055],
              [118.09913170700008, 24.31972890800006],
              [118.10230553500003, 24.314276434000078],
              [118.11646569100003, 24.304510809000078],
              [118.11963951900009, 24.299261786000045],
              [118.12061608200008, 24.27952708500004],
              [118.12265058700007, 24.270738023000035],
              [118.12647545700008, 24.26203034100007],
              [118.10873457100001, 24.261053778000075],
              [118.08472741000003, 24.24909088700008],
              [118.07178795700008, 24.25458405200004],
              [118.05933678500003, 24.24551015800006],
              [118.03834069100003, 24.22020091400009],
              [118.02393639400009, 24.206732489000046],
              [118.01620527400007, 24.20311107000009],
              [117.996429884, 24.197414455000057],
              [117.98926842500009, 24.193101304000038],
              [117.98642011800007, 24.187160549000055],
              [117.98251386800007, 24.169175523000035],
              [117.97877037900003, 24.16209544500009],
              [117.96786543100006, 24.159816799000055],
              [117.96265709700003, 24.17381419500009],
              [117.95850670700008, 24.203070380000042],
              [117.94361412900003, 24.212591864000046],
              [117.93213951900009, 24.207953192000048],
              [117.92090905000009, 24.19668203300006],
              [117.90731855600006, 24.18626536700009],
              [117.93238366000003, 24.178290106000077],
              [117.93775475400003, 24.16168854400007],
              [117.93051191500001, 24.141099351000037],
              [117.90137780000009, 24.09861888200004],
              [117.89576256600003, 24.08661530200004],
              [117.89364668100006, 24.07330963700008],
              [117.89559980600006, 24.060980536000045],
              [117.89869225400003, 24.050523179000038],
              [117.89942467500009, 24.040187893000052],
              [117.89364668100006, 24.02802155200004],
              [117.86231530000009, 24.035223700000074],
              [117.83912194100003, 24.02362702000005],
              [117.79810631600003, 23.980210679000038],
              [117.77198326900009, 23.958929755000042],
              [117.76547285200002, 23.947333075000074],
              [117.76327558700007, 23.929348049000055],
              [117.75863691500001, 23.91547272300005],
              [117.74805748800009, 23.907538153000075],
              [117.73658287900003, 23.90810781500005],
              [117.72925866000003, 23.91937897300005],
              [117.73788496200007, 23.950506903000075],
              [117.791351759, 24.00153229400007],
              [117.79810631600003, 24.02179596600007],
              [117.78646894600001, 24.028143622000073],
              [117.76172936300009, 24.014837958000044],
              [117.75709069100003, 24.02488841400009],
              [117.76978600400003, 24.031317450000074],
              [117.77613366000003, 24.03729889500005],
              [117.77418053500003, 24.045396226000037],
              [117.77027428500003, 24.05145905200004],
              [117.76327558700007, 24.070257880000042],
              [117.75709069100003, 24.070257880000042],
              [117.75001061300009, 24.03729889500005],
              [117.72413170700008, 24.033758856000077],
              [117.69223066500001, 24.046535549000055],
              [117.66708418100006, 24.06273021000004],
              [117.67099043100006, 24.048000393000052],
              [117.67969811300009, 24.03904857000009],
              [117.69223066500001, 24.035223700000074],
              [117.70875084700003, 24.03546784100007],
              [117.68848717500009, 23.99750397300005],
              [117.68726647200003, 23.979071356000077],
              [117.69507897200003, 23.953558661000045],
              [117.67156489500007, 23.931411491000063],
              [117.64863267600003, 23.90923358200007],
              [117.63359979200004, 23.87415807900004],
              [117.62553554500005, 23.840153334000036],
              [117.6260078030001, 23.81223288800004],
              [117.63926948000005, 23.794102300000077],
              [117.61939537900003, 23.77480703300006],
              [117.61255944100003, 23.76268138200004],
              [117.5916687880001, 23.73706444600009],
              [117.58952473800002, 23.756154105000064],
              [117.58746244400004, 23.777780118000067],
              [117.60201234700003, 23.798949107000055],
              [117.60010826900009, 23.83397044500009],
              [117.59815514400009, 23.852443752000056],
              [117.59205162900003, 23.87099844000005],
              [117.582367384, 23.88930898600006],
              [117.57105553500003, 23.903265692000048],
              [117.55673261800007, 23.913234768000052],
              [117.53736412900003, 23.91937897300005],
              [117.47461998800009, 23.92096588700008],
              [117.45484459700003, 23.925604559000078],
              [117.43018639400009, 23.943752346000053],
              [117.41659589900007, 23.94684479400007],
              [117.40707441500001, 23.93305084800005],
              [117.40967858200008, 23.913397528000075],
              [117.42709394600001, 23.91038646000004],
              [117.44979902400007, 23.91347890800006],
              [117.46851647200003, 23.911932684000078],
              [117.49959628800002, 23.87407223200006],
              [117.490072768, 23.832578709000074],
              [117.46347744400009, 23.788287134000086],
              [117.43433140800005, 23.77592209700009],
              [117.38241621200007, 23.79523346600007],
              [117.36890709700003, 23.792629299000055],
              [117.36093183700007, 23.785956122000073],
              [117.35458418100006, 23.777411200000074],
              [117.34555097700002, 23.76854075700004],
              [117.31910241000003, 23.76162344000005],
              [117.30396569100003, 23.77558014500005],
              [117.29257246200007, 23.789496161000045],
              [117.27735436300009, 23.78221263200004],
              [117.29232832100001, 23.762152411000045],
              [117.28573652400007, 23.74677155200004],
              [117.27192081500004, 23.721306450000043],
              [117.27624182700004, 23.687743259000058],
              [117.26796469200008, 23.679791608000073],
              [117.26364898600002, 23.655424769000035],
              [117.2791221110001, 23.636267573000055],
              [117.25709264900001, 23.615616376000048],
              [117.23896432000004, 23.605472819000056],
              [117.23596388500005, 23.62431050300006],
              [117.23553754, 23.639819411000076],
              [117.24408975600011, 23.657548493000036],
              [117.23560631600003, 23.67145416900007],
              [117.22950280000009, 23.69281647300005],
              [117.22518964900007, 23.684719143000052],
              [117.20850670700008, 23.664943752000056],
              [117.21718120000003, 23.652511357000037],
              [117.22041024000009, 23.640201411000078],
              [117.21920130500007, 23.629627879000054],
              [117.185883009, 23.621039130000042],
              [117.17465254000001, 23.616359768000052],
              [117.1508298120001, 23.60686733500006],
              [117.12846022200006, 23.572353777000046],
              [117.09946427700004, 23.55430956500004],
              [117.084227758, 23.55060551300005],
              [117.07840664300011, 23.564611083000045],
              [117.08046765200004, 23.574346566000088],
              [117.08355969400009, 23.588949683000067],
              [117.0760033680001, 23.604627399000037],
              [117.07918982300009, 23.622489485000074],
              [117.077881123, 23.63882981000006],
              [117.06841298800009, 23.65127271500006],
              [117.05779791000009, 23.653964983000037],
              [117.04444420700008, 23.65566640800006],
              [117.03427168100006, 23.661322333000044],
              [117.02344811300009, 23.658677476000037],
              [117.01832116000003, 23.64789459800005],
              [117.009501784, 23.64454238600007],
              [116.98535568500006, 23.640228473000036],
              [116.96507212100005, 23.615437651000036],
              [116.95070523000004, 23.610883295000065],
              [116.92758222700002, 23.624741929000038],
              [116.91757246200007, 23.637925523000035],
              [116.94092858200008, 23.658677476000037],
              [116.92750084700003, 23.664496161000045],
              [116.91651451900009, 23.66274648600006],
              [116.90894616000003, 23.65460846600007],
              [116.90609785200002, 23.64130280200004],
              [116.900726759, 23.63426341400009],
              [116.87745201900009, 23.618353583000044],
              [116.87208092500009, 23.60687897300005],
              [116.87427819100003, 23.59861888200004],
              [116.87916100400003, 23.593573309000078],
              [116.88404381600003, 23.58661530200004],
              [116.88624108200008, 23.573065497000073],
              [116.88331139400009, 23.55963776200008],
              [116.87549889400009, 23.54706452000005],
              [116.85499108200008, 23.52488841400009],
              [116.84970136800007, 23.51129791900007],
              [116.85425866000003, 23.497381903000075],
              [116.87262115300007, 23.473806531000037],
              [116.86662820400011, 23.450232931000073],
              [116.77322445100003, 23.34943237200008],
              [116.75294030000009, 23.35024648600006],
              [116.74656684900003, 23.34920666000005],
              [116.73241003700002, 23.35113160900005],
              [116.71298926300005, 23.355628883000065],
              [116.69288170700008, 23.359930731000077],
              [116.68075605600006, 23.35700104400007],
              [116.65784363400007, 23.35445209100004],
              [116.62191816500001, 23.36912669500009],
              [116.56893964900007, 23.391017971000053],
              [116.55787194100003, 23.40176015800006],
              [116.55347741000003, 23.41425202000005],
              [116.54322350400003, 23.421210028000075],
              [116.53174889400009, 23.42255280200004],
              [116.52320397200003, 23.418524481000077],
              [116.52173912900003, 23.41120026200008],
              [116.52320397200003, 23.377508856000077],
              [116.53321373800009, 23.361883856000077],
              [116.55225670700008, 23.341498114000046],
              [116.57300866000003, 23.32367584800005],
              [116.58798261800007, 23.316107489000046],
              [116.60840905000009, 23.320461330000057],
              [116.64188900700003, 23.31883540800004],
              [116.66097618700007, 23.337223022000046],
              [116.69124035800007, 23.338976648000084],
              [116.70941427800005, 23.31976964900008],
              [116.72707447100004, 23.316115909000075],
              [116.73011154700009, 23.330753946000073],
              [116.74863483000001, 23.326288333000036],
              [116.76563084100007, 23.297350702000074],
              [116.76852783200002, 23.272821140000076],
              [116.77711022200003, 23.240383205000057],
              [116.78617904300006, 23.235722800000076],
              [116.79426890800005, 23.23962214700009],
              [116.804822489, 23.236122461000036],
              [116.78394616000003, 23.21238841400009],
              [116.75416100400003, 23.23338450700004],
              [116.73129316500001, 23.25771719000005],
              [116.70557701900009, 23.276597398000035],
              [116.66724694100003, 23.281317450000074],
              [116.67920983200008, 23.27138906500005],
              [116.69507897200003, 23.265692450000074],
              [116.70899498800009, 23.25853099200009],
              [116.71509850400003, 23.243801174000055],
              [116.70550223000009, 23.23834402700004],
              [116.68930798100007, 23.22973059900005],
              [116.67116605600006, 23.214638817000036],
              [116.66174784000009, 23.193648388000042],
              [116.64675495900008, 23.162991383000076],
              [116.6370210230001, 23.16401789400004],
              [116.62929588000009, 23.17396980300009],
              [116.61521596500006, 23.178349308000065],
              [116.61377172000005, 23.190607423000074],
              [116.61675443900003, 23.202770202000067],
              [116.61814794100007, 23.221479117000058],
              [116.61151014100005, 23.238729609000075],
              [116.58858539900007, 23.244933802000048],
              [116.56997645400008, 23.246972843000037],
              [116.51685631600003, 23.235174872000073],
              [116.50888105600006, 23.234116929000038],
              [116.50928795700008, 23.21637604400007],
              [116.52698753700008, 23.200621073000036],
              [116.54142873, 23.21010457200009],
              [116.55315787300003, 23.21637335400004],
              [116.56397545700008, 23.22296784100007],
              [116.574554884, 23.22410716400009],
              [116.6029491600001, 23.21773845200005],
              [116.604504249, 23.209556543000076],
              [116.60149581500002, 23.196580792000077],
              [116.56991582300009, 23.17769187500005],
              [116.54512080800009, 23.144775094000067],
              [116.53364811400002, 23.10913453800009],
              [116.5516555910001, 23.086724106000077],
              [116.54849613500005, 23.066401898000038],
              [116.55484606100003, 23.036094399000035],
              [116.56325009500006, 23.01877372100006],
              [116.54785154900003, 23.00603914600009],
              [116.52193572500005, 22.99841091500008],
              [116.51847389200009, 22.967455536000045],
              [116.494687913, 22.93935241300005],
              [116.4585096620001, 22.947419938000053],
              [116.42629040700001, 22.937425476000044],
              [116.37960727900008, 22.92898441300008],
              [116.35303795700008, 22.938055731000077],
              [116.338251151, 22.951857250000046],
              [116.29848707000008, 22.963246737000077],
              [116.28906383900005, 22.978943018000052],
              [116.26225996800008, 22.973737028000073],
              [116.234711134, 22.980414130000042],
              [116.21363366000003, 22.982814846000053],
              [116.20101972700002, 22.973456122000073],
              [116.23487389400009, 22.960272528000075],
              [116.252289259, 22.959051825000074],
              [116.26937910200002, 22.966620184000078],
              [116.2814583920001, 22.957857275000038],
              [116.246181352, 22.931590004000043],
              [116.2210090860001, 22.919009820000042],
              [116.21456253200006, 22.90852205300007],
              [116.20008802000007, 22.89655534600007],
              [116.17098930300006, 22.86446526900005],
              [116.1449099130001, 22.847822500000063],
              [116.12965056100006, 22.83913479800009],
              [116.11356126700002, 22.83291023700008],
              [116.09568990500009, 22.825900457000046],
              [116.08467166600008, 22.84976535000004],
              [116.09125331300004, 22.868409860000042],
              [116.12372104000008, 22.89472923900007],
              [116.08700605600006, 22.90656159100007],
              [116.04210490800006, 22.932918286000074],
              [116.04188078800007, 22.92232107700005],
              [116.07129967500009, 22.897772528000075],
              [116.0872538220001, 22.889693668000064],
              [116.07617780700002, 22.867871480000076],
              [116.053772235, 22.855228638000085],
              [116.04786217500009, 22.85179271000004],
              [116.037445509, 22.850897528000075],
              [116.02610749200005, 22.845127110000078],
              [116.01179603500009, 22.83804350300005],
              [115.99671759400007, 22.836684122000065],
              [115.96607506600003, 22.817206122000073],
              [115.95801360200005, 22.804743209000037],
              [115.93948765200003, 22.80751586200006],
              [115.93326333900006, 22.805993707000084],
              [115.90373753900008, 22.789376442000048],
              [115.88349730700008, 22.794618575000072],
              [115.85488226100006, 22.778790126000047],
              [115.84321232500008, 22.770024884000065],
              [115.82595611500005, 22.746643521000067],
              [115.810029869, 22.746090775000084],
              [115.79781189200003, 22.75444957600007],
              [115.79545956600009, 22.769988070000068],
              [115.79048384700002, 22.78720037000005],
              [115.78803850300005, 22.79784174100007],
              [115.79501386800007, 22.80027903900009],
              [115.79940839900007, 22.794663804000038],
              [115.80136152400007, 22.786851304000038],
              [115.80648847700002, 22.778265692000048],
              [115.81356855600006, 22.776271877000056],
              [115.81470787900003, 22.78611888200004],
              [115.81275475400003, 22.79954661700009],
              [115.80990644600001, 22.808335679000038],
              [115.80477949300007, 22.81509023600006],
              [115.79843183700007, 22.819525458000044],
              [115.79037519600001, 22.821926174000055],
              [115.7850551350001, 22.825677925000036],
              [115.7763443450001, 22.832345699000086],
              [115.76323712500005, 22.841487071000074],
              [115.736869609, 22.85167302800005],
              [115.6970355850001, 22.85067112200005],
              [115.7035808390001, 22.86932319400006],
              [115.68426622900006, 22.877779098000076],
              [115.68246504000001, 22.88816966400009],
              [115.69263756600003, 22.900091864000046],
              [115.70517011800007, 22.907375393000052],
              [115.71387780000009, 22.90452708500004],
              [115.72128339900007, 22.90452708500004],
              [115.72754967500009, 22.922756252000056],
              [115.73373457100001, 22.93187083500004],
              [115.73031660200002, 22.93423086100006],
              [115.69198652400007, 22.929022528000075],
              [115.68311608200008, 22.924261786000045],
              [115.66659589900007, 22.90452708500004],
              [115.65333092500009, 22.893744208000044],
              [115.63941491000003, 22.88934967700004],
              [115.58399498800009, 22.88031647300005],
              [115.57789147200003, 22.87726471600007],
              [115.57406660200002, 22.87173086100006],
              [115.56495201900009, 22.853257554000038],
              [115.56055748800009, 22.849310614000046],
              [115.53988691500001, 22.85293203300006],
              [115.53296959700003, 22.86204661700009],
              [115.53663170700008, 22.874335028000075],
              [115.54688561300009, 22.887152411000045],
              [115.54761803500003, 22.895412502000056],
              [115.53378339900007, 22.898260809000078],
              [115.50562584700003, 22.897772528000075],
              [115.49634850400003, 22.90306224200009],
              [115.46827233200008, 22.92649974200009],
              [115.45093834700003, 22.93187083500004],
              [115.44239342500009, 22.92967357000009],
              [115.43832441500001, 22.920355536000045],
              [115.43018639400009, 22.91819896000004],
              [115.42383873800009, 22.918768622000073],
              [115.40601647200003, 22.925034898000035],
              [115.41854902400007, 22.90770091400009],
              [115.42725670700008, 22.90062083500004],
              [115.43702233200008, 22.897772528000075],
              [115.44613691500001, 22.89996979400007],
              [115.455414259, 22.90973541900007],
              [115.46420332100001, 22.91201406500005],
              [115.48300214900007, 22.90184153900009],
              [115.49610436300009, 22.88031647300005],
              [115.49415123800009, 22.86078522300005],
              [115.46802819100003, 22.856756903000075],
              [115.46802819100003, 22.849310614000046],
              [115.47860761800007, 22.847479559000078],
              [115.50562584700003, 22.849310614000046],
              [115.51514733200008, 22.847316799000055],
              [115.53036543100006, 22.838324286000045],
              [115.54004967500009, 22.83624909100007],
              [115.55941816500001, 22.836086330000057],
              [115.56592858200008, 22.837958075000074],
              [115.57789147200003, 22.84316640800006],
              [115.58692467500009, 22.849351304000038],
              [115.59335371200007, 22.856390692000048],
              [115.60059655000009, 22.861883856000077],
              [115.61207116000003, 22.86359284100007],
              [115.59131920700008, 22.847479559000078],
              [115.55624428600004, 22.807435384000087],
              [115.53896582800007, 22.788904414000058],
              [115.5270169690001, 22.767042406000087],
              [115.52393639400009, 22.74176666900007],
              [115.55558818200006, 22.71437029300006],
              [115.56575300400004, 22.73708086000005],
              [115.56732101300008, 22.747281344000044],
              [115.58619225400003, 22.74510325700004],
              [115.59009850400003, 22.737209377000056],
              [115.58090254000001, 22.72333405200004],
              [115.56251061300009, 22.705633856000077],
              [115.56421959700003, 22.684881903000075],
              [115.57521894800004, 22.66833597200008],
              [115.53615557400008, 22.668123388000083],
              [115.52209550200007, 22.67650328700006],
              [115.49119293900003, 22.687586813000053],
              [115.46481812900004, 22.701034142000083],
              [115.43826484100009, 22.700598507000052],
              [115.42126350300009, 22.690235633000043],
              [115.39429772200003, 22.68968333500004],
              [115.373508023, 22.694177267000043],
              [115.3612720430001, 22.70413735900007],
              [115.3482051950001, 22.717368990000068],
              [115.33847089900007, 22.73309967700004],
              [115.35067793100006, 22.746893622000073],
              [115.35840905000009, 22.74868398600006],
              [115.38892662900003, 22.746893622000073],
              [115.39755293100006, 22.74876536700009],
              [115.40975996200007, 22.757879950000074],
              [115.424133428, 22.761993113000074],
              [115.422372548, 22.77179740300005],
              [115.411208225, 22.788267543000075],
              [115.38624108200008, 22.782904364000046],
              [115.37476689900006, 22.77328464100009],
              [115.36399407500005, 22.76364478000005],
              [115.33057039700009, 22.78854041900007],
              [115.28914445700002, 22.791553391000036],
              [115.25108133600008, 22.787980248000054],
              [115.23339092700007, 22.788208507000036],
              [115.23276710300001, 22.805339609000043],
              [115.25856378500009, 22.82046302300006],
              [115.3030404210001, 22.83861373400009],
              [115.32016035200002, 22.850531317000048],
              [115.32479902400007, 22.85956452000005],
              [115.31373131600003, 22.86359284100007],
              [115.30941816500001, 22.86937083500004],
              [115.31055748800009, 22.882473049000055],
              [115.31714928500003, 22.90452708500004],
              [115.30380293100006, 22.90302155200004],
              [115.29224694100003, 22.895331122000073],
              [115.27222741000003, 22.873846747000073],
              [115.25595136800007, 22.84784577000005],
              [115.24561608200008, 22.83535390800006],
              [115.23145592500009, 22.83006419500009],
              [115.21729394500005, 22.83489118300008],
              [115.19601300300008, 22.83189769200004],
              [115.17294355600006, 22.821193752000056],
              [115.17440728100007, 22.80689202600007],
              [115.18027057300003, 22.784805971000083],
              [115.15827282300006, 22.792417197000077],
              [115.15056624700003, 22.809633511000072],
              [115.13287802700006, 22.811453821000043],
              [115.111664259, 22.80215078300006],
              [115.10108483200008, 22.800116278000075],
              [115.06547548000003, 22.795984798000063],
              [115.05030358200008, 22.781683661000045],
              [115.04566491000003, 22.775864976000037],
              [115.04102623800009, 22.76162344000005],
              [115.03663170700008, 22.753729559000078],
              [115.02232988000003, 22.743512898000063],
              [115.01782843800004, 22.737044052000044],
              [115.02208124900005, 22.726391530000058],
              [115.03079380000008, 22.717322203000037],
              [115.028903474, 22.708376584000064],
              [115.0182774220001, 22.706868644000053],
              [115.008513472, 22.703720144000044],
              [114.99877219200005, 22.70220144700005],
              [114.99252068300007, 22.69738089100008],
              [114.98534174000008, 22.689309001000083],
              [114.98002977300007, 22.688554022000062],
              [114.97125781200009, 22.69273518500006],
              [114.95983548000004, 22.696134337000046],
              [114.95467022500009, 22.703544178000072],
              [114.95658369400007, 22.715740246000053],
              [114.95237039800008, 22.72883282500004],
              [114.94581139400009, 22.742254950000074],
              [114.94166100400003, 22.753851630000042],
              [114.92676842500009, 22.76117584800005],
              [114.91675866000003, 22.74404531500005],
              [114.90311007700006, 22.74892445000006],
              [114.88905903200009, 22.76374773400005],
              [114.87671936700008, 22.767957236000086],
              [114.86252380000008, 22.76321563500005],
              [114.87037907000001, 22.753348498000037],
              [114.88187326500008, 22.747523043000058],
              [114.886216794, 22.73607469300009],
              [114.87814452500004, 22.729637968000077],
              [114.88073575600004, 22.72146994400009],
              [114.89044712900011, 22.714054656000087],
              [114.90285798600007, 22.713934062000078],
              [114.90999580100004, 22.723615477000067],
              [114.92672625500006, 22.716930079000065],
              [114.937229043, 22.709491557000035],
              [114.94668867200005, 22.69632868800005],
              [114.95530177500007, 22.684793556000045],
              [114.96662940100009, 22.67648694400009],
              [114.95045006600003, 22.664984442000048],
              [114.93873131600003, 22.65729401200008],
              [114.92489668100006, 22.63865794500009],
              [114.90193762400008, 22.598056881000048],
              [114.90521329800004, 22.578440025000077],
              [114.91911854600005, 22.56115516400007],
              [114.8959664250001, 22.547524404000058],
              [114.88364080000008, 22.550915623000037],
              [114.88021450300005, 22.559112545000062],
              [114.88923391500009, 22.57289383200009],
              [114.88682041100003, 22.59087178300007],
              [114.86581619100002, 22.601744611000072],
              [114.83222895100005, 22.602076657000055],
              [114.806416431, 22.592508912000085],
              [114.77460903400004, 22.597692709000057],
              [114.75414529800003, 22.589714066000056],
              [114.743775851, 22.60940429200008],
              [114.74224181900001, 22.627380042000084],
              [114.74248302600006, 22.646963523000068],
              [114.73745015700001, 22.66904582500007],
              [114.74998970200011, 22.678724066000086],
              [114.75377792100005, 22.693385353000053],
              [114.7388790220001, 22.71064696700006],
              [114.74195106600007, 22.73265274000005],
              [114.752545241, 22.749661867000043],
              [114.7785513130001, 22.76245281100006],
              [114.79542076900009, 22.769924221000053],
              [114.80201256600003, 22.773382880000042],
              [114.81324303500003, 22.77484772300005],
              [114.81763756600003, 22.779120184000078],
              [114.82125206600006, 22.790560097000082],
              [114.81695432000004, 22.800389479000046],
              [114.80727862600008, 22.80538264000006],
              [114.798465985, 22.80873580800005],
              [114.79273522200003, 22.810939846000053],
              [114.78475996200007, 22.81586334800005],
              [114.77523847700002, 22.81582265800006],
              [114.76978600400003, 22.81045156500005],
              [114.76246178500003, 22.791083075000074],
              [114.75489342500009, 22.781683661000045],
              [114.73414147200003, 22.775783596000053],
              [114.7167323330001, 22.790803400000073],
              [114.69548075400007, 22.792641588000038],
              [114.68381192600009, 22.781332801000076],
              [114.66421875200001, 22.774175831000036],
              [114.64548395700001, 22.76700589400008],
              [114.63778730600006, 22.755072333000044],
              [114.61719811300009, 22.750067450000074],
              [114.6025462990001, 22.740457636000087],
              [114.57937799500007, 22.73331058900004],
              [114.56332441500001, 22.73273346600007],
              [114.56498603500006, 22.717915753000057],
              [114.57109590700009, 22.702354350000064],
              [114.55233808700007, 22.694525458000044],
              [114.54224694100003, 22.69529857000009],
              [114.53248131600003, 22.69953034100007],
              [114.52206464900007, 22.705959377000056],
              [114.52378006100002, 22.687213932000077],
              [114.51710045700008, 22.67641836100006],
              [114.50592603700011, 22.663688963000084],
              [114.4995758450001, 22.653113887000075],
              [114.50660702000005, 22.64652286900008],
              [114.53490558700003, 22.644647692000035],
              [114.52341051100007, 22.64556316100004],
              [114.5482164760001, 22.64454053600008],
              [114.56251061300009, 22.64834219000005],
              [114.57325280000009, 22.654445705000057],
              [114.58253014400009, 22.65525950700004],
              [114.59034264400009, 22.643866278000075],
              [114.57764733200008, 22.635891018000052],
              [114.560883009, 22.60879140800006],
              [114.54664147200003, 22.60293203300006],
              [114.52914472700002, 22.59833405200004],
              [114.51392662900003, 22.58734772300005],
              [114.50220787900003, 22.573919989000046],
              [114.49537194100003, 22.56195709800005],
              [114.50204511800007, 22.550848700000074],
              [114.50928795700008, 22.54954661700009],
              [114.51815839900007, 22.552801825000074],
              [114.52955162900003, 22.555121161000045],
              [114.52979576900009, 22.55735911700009],
              [114.53248131600003, 22.562323309000078],
              [114.53711998800009, 22.567206122000073],
              [114.54322350400003, 22.56940338700008],
              [114.547211134, 22.56708405200004],
              [114.55477949300007, 22.55731842700004],
              [114.55990644600001, 22.555121161000045],
              [114.57276451900009, 22.55145905200004],
              [114.59327233200008, 22.541896877000056],
              [114.61158287900003, 22.52871328300006],
              [114.61768639400009, 22.514146226000037],
              [114.60751386800007, 22.504380601000037],
              [114.58765709700003, 22.49559153900009],
              [114.57053206300009, 22.48429125800004],
              [114.54216235700005, 22.47799288500005],
              [114.52966684100011, 22.468285095000056],
              [114.5158162140001, 22.45264280300006],
              [114.50155683700007, 22.452093817000048],
              [114.49219811300009, 22.46397532800006],
              [114.49114017000011, 22.464626369000086],
              [114.48511803500003, 22.46832916900007],
              [114.48446699300007, 22.474351304000038],
              [114.48324629000001, 22.48456452000005],
              [114.47722415500004, 22.489528713000084],
              [114.47681725400003, 22.489894924000055],
              [114.4769800140001, 22.49042389500005],
              [114.48015384200005, 22.500148830000057],
              [114.47641035200002, 22.509426174000055],
              [114.48454837300005, 22.51699453300006],
              [114.48698978000004, 22.521918036000045],
              [114.48511803500003, 22.534409898000035],
              [114.47958418100006, 22.53933340100008],
              [114.47958418100006, 22.546210028000075],
              [114.47120201900009, 22.551703192000048],
              [114.46216881600003, 22.561753648000035],
              [114.45573978000004, 22.57050202000005],
              [114.44695071700005, 22.571559963000084],
              [114.44532311300009, 22.57176341400009],
              [114.44035892000011, 22.56867096600007],
              [114.43677819100003, 22.577378648000035],
              [114.43734785200002, 22.579372463000084],
              [114.43848717500009, 22.582953192000048],
              [114.433034701, 22.591091213000084],
              [114.42432701900009, 22.601670640000066],
              [114.41423587300005, 22.604803778000075],
              [114.40870201900009, 22.61163971600007],
              [114.39576256600003, 22.61351146000004],
              [114.39559980600006, 22.61351146000004],
              [114.38013756600003, 22.61033763200004],
              [114.36068769600001, 22.604803778000075],
              [114.3402612640001, 22.59788646000004],
              [114.32911217500009, 22.60500722900008],
              [114.328461134, 22.60545482000009],
              [114.3280542330001, 22.604763088000084],
              [114.324554884, 22.598537502000056],
              [114.31723066500001, 22.60232168200008],
              [114.31714928500003, 22.602362372000073],
              [114.31690514400009, 22.60219961100006],
              [114.30534915500004, 22.594183661000045],
              [114.30713951900009, 22.58543528900009],
              [114.302175326, 22.582953192000048],
              [114.27621504000001, 22.587958075000074],
              [114.26962324300007, 22.582953192000048],
              [114.24968509200005, 22.57050202000005],
              [114.23829186300009, 22.559922593000067],
              [114.22982832100001, 22.555812893000052],
              [114.22071373800009, 22.555121161000088],
              [114.19988163300002, 22.55619537400004],
              [114.18303511600004, 22.55619537400004],
              [114.17321740100016, 22.56394603200009],
              [114.16195113200001, 22.560536194000022],
              [114.15388960900015, 22.55185455400006],
              [114.14872196500005, 22.538108623000042],
              [114.13817997200016, 22.539348857000064],
              [114.12887821400005, 22.538108623000042],
              [114.11709598800013, 22.527566630000067],
              [114.113995402, 22.528806864],
              [114.108414347, 22.534387919000025],
              [114.09146447800009, 22.534387919000025],
              [114.082367384, 22.52936432500003],
              [114.07911217500009, 22.52757396000004],
              [114.07968183700007, 22.52374909100007],
              [114.06723066500001, 22.521918036000045],
              [114.05844160200002, 22.51699453300006],
              [114.05526777400007, 22.50694407800006],
              [114.04200280000009, 22.506781317000048],
              [114.03874759200005, 22.510565497000073],
              [114.03809655000009, 22.511379299000055],
              [114.03581790500004, 22.513820705000057],
              [114.035492384, 22.514146226000037],
              [114.03541100400003, 22.514227606000077],
              [114.01856530000009, 22.52256907800006],
              [113.99927819100003, 22.530625718000067],
              [113.98747806100005, 22.53184642100007],
              [113.98438561300009, 22.533718166000085],
              [113.9706323580001, 22.533718166000085],
              [113.96379642000011, 22.538112697000088],
              [113.96029707100001, 22.528469143000052],
              [113.951938777, 22.523841151000056],
              [113.94890085200007, 22.51119979000009],
              [113.94881613900009, 22.50034809500005],
              [113.9477577780001, 22.490406454000038],
              [113.93580162900003, 22.48891836100006],
              [113.92505944100003, 22.48704661700009],
              [113.91529381600003, 22.488674221000053],
              [113.91342207100001, 22.487616278000075],
              [113.91032962300005, 22.48582591400009],
              [113.90967858200008, 22.47764720300006],
              [113.89034489800008, 22.452712399000063],
              [113.88147873500009, 22.47333294000009],
              [113.874362862, 22.478184272000078],
              [113.86787329700007, 22.49482860200004],
              [113.86615533000008, 22.511493140000084],
              [113.88184655000009, 22.514146226000037],
              [113.89389082100001, 22.521144924000055],
              [113.87989342500009, 22.53668854400007],
              [113.84376061300009, 22.56195709800005],
              [113.83383222700002, 22.571926174000055],
              [113.82235761800007, 22.587225653000075],
              [113.812836134, 22.604396877000056],
              [113.79915745100004, 22.631001061000063],
              [113.793568, 22.661614499000052],
              [113.77293351100002, 22.672447513000066],
              [113.76465905000009, 22.734808661000045],
              [113.75806725400003, 22.75340403900009],
              [113.74439537900003, 22.76117584800005],
              [113.71216881600003, 22.763332424000055],
              [113.69971764400009, 22.76117584800005],
              [113.69507897200003, 22.757473049000055],
              [113.69117272200003, 22.751613674000055],
              [113.68458092500009, 22.746893622000073],
              [113.67237389400009, 22.746893622000073],
              [113.65357506600003, 22.758734442000048],
              [113.65626061300009, 22.77684153900009],
              [113.66260826900009, 22.798081773000035],
              [113.65528405000009, 22.819240627000056],
              [113.64356530000009, 22.83417389500005],
              [113.63257897200003, 22.85309479400007],
              [113.61719811300009, 22.890285549000055],
              [113.61085045700008, 22.87636953300006],
              [113.61011803500003, 22.86204661700009],
              [113.61288496200007, 22.84837474200009],
              [113.61719811300009, 22.83624909100007],
              [113.60556074300007, 22.84723541900007],
              [113.60230553500003, 22.866359768000052],
              [113.60499108200008, 22.887518622000073],
              [113.61036217500009, 22.90452708500004],
              [113.60287519600001, 22.897650458000044],
              [113.597992384, 22.88963450700004],
              [113.596039259, 22.880560614000046],
              [113.59229576900009, 22.889064846000053],
              [113.61133873800009, 22.93378327000005],
              [113.61719811300009, 22.95604075700004],
              [113.61915123800009, 22.979396877000056],
              [113.62435957100001, 22.999212958000044],
              [113.63819420700008, 23.034898179000038],
              [113.63070722700002, 23.034898179000038],
              [113.61670983200008, 23.007879950000074],
              [113.61207116000003, 22.994696356000077],
              [113.60914147200003, 22.96287669500009],
              [113.60181725400003, 22.930609442000048],
              [113.59669030000009, 22.91819896000004],
              [113.59498131600003, 22.92959219000005],
              [113.59506269600001, 22.94476959800005],
              [113.597992384, 22.96051666900007],
              [113.60409589900007, 22.973456122000073],
              [113.60263105600006, 22.98773834800005],
              [113.60507246200007, 23.00141022300005],
              [113.61719811300009, 23.034898179000038],
              [113.59921308700007, 23.00922272300005],
              [113.58668053500003, 22.953558661000045],
              [113.57618248800009, 22.938706773000035],
              [113.58204186300009, 22.957464911000045],
              [113.58383222700002, 22.978461005000042],
              [113.58301842500009, 23.021226304000038],
              [113.56421959700003, 22.996893622000073],
              [113.55396569100003, 22.987616278000075],
              [113.54200280000009, 22.98651764500005],
              [113.53272545700008, 22.995754299000055],
              [113.52881920700008, 23.01080963700008],
              [113.52833092500009, 23.038031317000048],
              [113.53638756600003, 23.06313711100006],
              [113.55640709700003, 23.084133205000057],
              [113.58212324300007, 23.098456122000073],
              [113.63721764400009, 23.109116929000038],
              [113.69198652400007, 23.132554429000038],
              [113.72022545700008, 23.137925523000035],
              [113.73145592500009, 23.13385651200008],
              [113.74423261800007, 23.12604401200008],
              [113.75806725400003, 23.121568101000037],
              [113.78443444100003, 23.131740627000056],
              [113.80087324300007, 23.12840403900009],
              [113.83008873800009, 23.11749909100007],
              [113.81324303500003, 23.129787502000056],
              [113.79794355600006, 23.13434479400007],
              [113.76107832100001, 23.137925523000035],
              [113.74537194100003, 23.143011786000045],
              [113.71981855600006, 23.15534088700008],
              [113.70313561300009, 23.15778229400007],
              [113.67392011800007, 23.150458075000074],
              [113.62647545700008, 23.117987372000073],
              [113.59327233200008, 23.110663153000075],
              [113.58765709700003, 23.10610586100006],
              [113.55087324300007, 23.08787669500009],
              [113.54200280000009, 23.086411851000037],
              [113.53687584700003, 23.075018622000073],
              [113.52466881600003, 23.06659577000005],
              [113.50912519600001, 23.062160549000055],
              [113.49423261800007, 23.06281159100007],
              [113.44516035200002, 23.08934153900009],
              [113.41749108200008, 23.096991278000075],
              [113.39869225400003, 23.083319403000075],
              [113.41928144600001, 23.06549713700008],
              [113.45142662900003, 23.062323309000078],
              [113.48121178500003, 23.05149974200009],
              [113.50231200100006, 23.02042368800005],
              [113.50384399300003, 22.989832793000062],
              [113.49123164100001, 22.953952883000056],
              [113.48096764400009, 22.935695705000057],
              [113.48422285200002, 22.929348049000055],
              [113.48397871200007, 22.924261786000045],
              [113.47372480600006, 22.91819896000004],
              [113.46786543100006, 22.91901276200008],
              [113.44638105600006, 22.92845286700009],
              [113.42994225400003, 22.931341864000046],
              [113.33651777400007, 22.897772528000075],
              [113.30762780000009, 22.89411041900007],
              [113.21298261800007, 22.91201406500005],
              [113.21298261800007, 22.90452708500004],
              [113.23487389400009, 22.899644273000035],
              [113.25806725400003, 22.897772528000075],
              [113.26392662900003, 22.894598700000074],
              [113.28305097700002, 22.88043854400007],
              [113.29224694100003, 22.87726471600007],
              [113.31259199300007, 22.881008205000057],
              [113.33204186300009, 22.887518622000073],
              [113.35043379000001, 22.88971588700008],
              [113.36793053500003, 22.880682684000078],
              [113.42587324300007, 22.81582265800006],
              [113.44003339900007, 22.80414459800005],
              [113.49423261800007, 22.77484772300005],
              [113.46338951900009, 22.76239655200004],
              [113.45191491000003, 22.755113023000035],
              [113.43954511800007, 22.739447333000044],
              [113.42603600400003, 22.74941640800006],
              [113.37753339900007, 22.767401434000078],
              [113.39503014400009, 22.748195705000057],
              [113.45362389400009, 22.725734768000052],
              [113.46631920700008, 22.716498114000046],
              [113.47632897200003, 22.69985586100006],
              [113.516277435, 22.67141756600006],
              [113.55304258400008, 22.63847230300007],
              [113.56384382800002, 22.614443708000067],
              [113.59916999500001, 22.575179846000083],
              [113.59473803000003, 22.523389661000067],
              [113.56251061300009, 22.480414130000042],
              [113.54635483700008, 22.43758548800008],
              [113.5515710730001, 22.395836745000054],
              [113.55811608200008, 22.38076406500005],
              [113.58163496200007, 22.37132396000004],
              [113.61036217500009, 22.37018463700008],
              [113.59945722700002, 22.350531317000048],
              [113.59725996200007, 22.341538804000038],
              [113.59669030000009, 22.32575104400007],
              [113.59229576900009, 22.316148179000038],
              [113.58301842500009, 22.309515692000048],
              [113.57357832100001, 22.300726630000042],
              [113.57470248900006, 22.28483152700005],
              [113.57720985200001, 22.266637463000052],
              [113.58374784400007, 22.26345862700009],
              [113.58998673000008, 22.253415329000063],
              [113.58765470100002, 22.237882255000045],
              [113.56119560400009, 22.233730112000046],
              [113.55285748400001, 22.21900641500008],
              [113.53858483200008, 22.22174713700008],
              [113.52295983200008, 22.213039455000057],
              [113.52947024800005, 22.202866929000038],
              [113.52987714900007, 22.20225657800006],
              [113.52808678500003, 22.19993724200009],
              [113.52149498800009, 22.19131094000005],
              [113.49722991400006, 22.17164050200006],
              [113.48374549000005, 22.155142169000044],
              [113.45921374300008, 22.158004487000085],
              [113.42562910200002, 22.18622467700004],
              [113.41903730600006, 22.208807684000078],
              [113.41187584700003, 22.225531317000048],
              [113.36451256600003, 22.26776764500005],
              [113.36231530000009, 22.27496979400007],
              [113.36019941500001, 22.29315827000005],
              [113.35702558700007, 22.301906643000052],
              [113.35157311300009, 22.308335679000038],
              [113.30323326900009, 22.34365469000005],
              [113.27637780000009, 22.37205638200004],
              [113.25562584700003, 22.40387604400007],
              [113.24268639400009, 22.457464911000045],
              [113.23194420700008, 22.479071356000077],
              [113.17758222700002, 22.564113674000055],
              [113.16529381600003, 22.57558828300006],
              [113.15845787900003, 22.506740627000056],
              [113.16016686300009, 22.487616278000075],
              [113.16561933700007, 22.47874583500004],
              [113.18921959700003, 22.462591864000046],
              [113.22730553500003, 22.42527903900009],
              [113.30298912900003, 22.309759833000044],
              [113.31815839500007, 22.289166392000084],
              [113.32850605300007, 22.268475656000078],
              [113.35401451900009, 22.24355703300006],
              [113.36451256600003, 22.230129299000055],
              [113.40197053000009, 22.179574118000062],
              [113.36255944100003, 22.17145416900007],
              [113.35084069100003, 22.171535549000055],
              [113.32545006600003, 22.183661200000074],
              [113.31299889400009, 22.18577708500004],
              [113.30274498800009, 22.183294989000046],
              [113.29794355600006, 22.17682526200008],
              [113.29468834700003, 22.16787344000005],
              [113.28565514400009, 22.153265692000048],
              [113.28223717500009, 22.145412502000056],
              [113.27816816500001, 22.14052969000005],
              [113.27352949300007, 22.138373114000046],
              [113.26343834700003, 22.13703034100007],
              [113.25098717500009, 22.115668036000045],
              [113.24659264400009, 22.103461005000042],
              [113.25586998800009, 22.08266836100006],
              [113.25497480600006, 22.071112372000073],
              [113.25123131600003, 22.06073639500005],
              [113.24716230600006, 22.05426666900007],
              [113.23056074300007, 22.04315827000005],
              [113.21412194100003, 22.045314846000053],
              [113.19469215800007, 22.04639504700009],
              [113.17831417500008, 22.040914172000043],
              [113.15746661600008, 22.024699645000055],
              [113.13962991200003, 22.036851782000042],
              [113.11885684100002, 22.065838498000062],
              [113.11060631600003, 22.09918854400007],
              [113.11532636800007, 22.11347077000005],
              [113.12452233200008, 22.13108958500004],
              [113.11824435300002, 22.14374555800009],
              [113.12745201900009, 22.160956122000073],
              [113.11915123800009, 22.171942450000074],
              [113.11329186300009, 22.18740469000005],
              [113.11036217500009, 22.20416901200008],
              [113.11060631600003, 22.219305731000077],
              [113.08505293100006, 22.207586981000077],
              [113.07729033400005, 22.14726667700006],
              [113.05789313000002, 22.12109389400007],
              [113.02661394800009, 22.143212451000068],
              [113.02063776900002, 22.125977567000064],
              [113.0221102810001, 22.101146484000083],
              [113.01762046700003, 22.08184254300005],
              [113.01610515000004, 22.057711938000068],
              [113.018304285, 22.034950080000044],
              [113.01828600200008, 22.02115791600005],
              [113.022729088, 22.002534256000047],
              [113.021213375, 21.984604708000063],
              [113.01896882200003, 21.97702006800006],
              [113.02119483900003, 21.97219124700007],
              [113.02861834200007, 21.961148361000085],
              [113.025620043, 21.949425357000052],
              [113.016675856, 21.94253333800009],
              [113.00147545700008, 21.938706773000035],
              [112.99472089900007, 21.938421942000048],
              [112.98934980600006, 21.937323309000078],
              [112.98707116000003, 21.928534247000073],
              [112.98593183700007, 21.92055898600006],
              [112.98096764400009, 21.907171942000048],
              [112.97958418100006, 21.901190497000073],
              [112.97266686300009, 21.89207591400009],
              [112.95708123400004, 21.87565345900009],
              [112.92877957200005, 21.86529893100004],
              [112.91158606600004, 21.85629082400004],
              [112.87940514400009, 21.87518952000005],
              [112.87110436300009, 21.893744208000044],
              [112.85897871200007, 21.932521877000056],
              [112.85157311300009, 21.94830963700008],
              [112.84083092500009, 21.96092357000009],
              [112.82601972700002, 21.966131903000075],
              [112.814789259, 21.96157461100006],
              [112.80770918100006, 21.952826239000046],
              [112.80038496200007, 21.94717031500005],
              [112.78858483200008, 21.95180898600006],
              [112.74374433700007, 21.93195221600007],
              [112.74024498800009, 21.925441799000055],
              [112.73764082100001, 21.896877346000053],
              [112.73047936300009, 21.890326239000046],
              [112.70606530000009, 21.891791083000044],
              [112.70045006600003, 21.890326239000046],
              [112.69629967500009, 21.88580963700008],
              [112.69092858200008, 21.875148830000057],
              [112.68555748800009, 21.86985911700009],
              [112.64511152400007, 21.849351304000038],
              [112.64755293100006, 21.822658596000053],
              [112.63306725400003, 21.795803127000056],
              [112.60800214900007, 21.775091864000046],
              [112.57911217500009, 21.766831773000035],
              [112.55087324300007, 21.77285390800006],
              [112.44320722700002, 21.82843659100007],
              [112.42603600400003, 21.84516022300005],
              [112.41504967500009, 21.868475653000075],
              [112.41114342500009, 21.901190497000073],
              [112.424164259, 21.917792059000078],
              [112.48145592500009, 21.944647528000075],
              [112.49366295700008, 21.966131903000075],
              [112.48617597700002, 21.966131903000075],
              [112.46884199300007, 21.955959377000056],
              [112.43628991000003, 21.94562409100007],
              [112.40479576900009, 21.94285716400009],
              [112.39063561300009, 21.955511786000045],
              [112.38843834700003, 21.96312083500004],
              [112.37850996200007, 21.97687409100007],
              [112.37631269600001, 21.98655833500004],
              [112.37720787900003, 21.994574286000045],
              [112.38168379000001, 22.006740627000056],
              [112.39283287900003, 22.056301174000055],
              [112.39747155000009, 22.068508205000057],
              [112.37818444100003, 22.058417059000078],
              [112.36483808700007, 22.034491278000075],
              [112.35751386800007, 22.00535716400009],
              [112.35653730600006, 21.979722398000035],
              [112.37012780000009, 21.938788153000075],
              [112.38770592500009, 21.908758856000077],
              [112.39063561300009, 21.901190497000073],
              [112.38778730600006, 21.876166083000044],
              [112.38843834700003, 21.862250067000048],
              [112.39405358200008, 21.856268622000073],
              [112.39795983200008, 21.85057200700004],
              [112.40113366000003, 21.83746979400007],
              [112.40430748800009, 21.81150950700004],
              [112.40211022200003, 21.80141836100006],
              [112.39283287900003, 21.78514232000009],
              [112.38795006600003, 21.75608958500004],
              [112.38143964900007, 21.748521226000037],
              [112.37256920700008, 21.742621161000045],
              [112.36329186300009, 21.733343817000048],
              [112.33212324300007, 21.72406647300005],
              [112.28622480600006, 21.708807684000078],
              [112.24488366000003, 21.70652903900009],
              [112.22681725400003, 21.729641018000052],
              [112.21664472700002, 21.735541083000044],
              [112.19686933700007, 21.742336330000057],
              [112.18238366000003, 21.75299713700008],
              [112.18897545700008, 21.77057526200008],
              [112.19898522200003, 21.786810614000046],
              [112.20313561300009, 21.806708075000074],
              [112.20093834700003, 21.826727606000077],
              [112.19263756600003, 21.84316640800006],
              [112.18222089900007, 21.823146877000056],
              [112.17269941500001, 21.81443919500009],
              [112.08554121200007, 21.796087958000044],
              [112.047211134, 21.794989325000074],
              [112.02816816500001, 21.797349351000037],
              [112.01303144600001, 21.804388739000046],
              [112.00709069100003, 21.81867096600007],
              [112.01295006600003, 21.83462148600006],
              [112.03736412900003, 21.862494208000044],
              [112.04127037900003, 21.88418203300006],
              [112.03443444100003, 21.88418203300006],
              [112.01880944100003, 21.859808661000045],
              [111.99317467500003, 21.83417389500005],
              [111.96924889400003, 21.824042059000078],
              [111.95167076900003, 21.864976304000038],
              [111.93409264400003, 21.890448309000078],
              [111.91187584700003, 21.91356028900009],
              [111.89039147200003, 21.925116278000075],
              [111.88892662900003, 21.89911530200004],
              [111.89063561300003, 21.86737702000005],
              [111.89576256600003, 21.837062893000052],
              [111.90406334700003, 21.815252997000073],
              [111.92066491000003, 21.800034898000035],
              [111.94638105600006, 21.78587474200009],
              [111.97510826900003, 21.776190497000073],
              [112.00025475400003, 21.774318752000056],
              [111.99195397200003, 21.763820705000057],
              [111.91456139400003, 21.71906159100007],
              [111.90577233200003, 21.71588776200008],
              [111.90406334700003, 21.708807684000078],
              [111.90414472700007, 21.701727606000077],
              [111.90064537900003, 21.698553778000075],
              [111.89576256600003, 21.695868231000077],
              [111.88428795700003, 21.682847398000035],
              [111.87671959700003, 21.678127346000053],
              [111.86793053500003, 21.676703192000048],
              [111.83887780000003, 21.678127346000053],
              [111.83692467500003, 21.685288804000038],
              [111.84229576900003, 21.699042059000078],
              [111.85377037900003, 21.707424221000053],
              [111.86988366000003, 21.698553778000075],
              [111.87671959700003, 21.698553778000075],
              [111.87533613400007, 21.70970286700009],
              [111.86947675900007, 21.716742255000042],
              [111.86060631600003, 21.721502997000073],
              [111.84937584700003, 21.725816148000035],
              [111.83619225400003, 21.71698639500005],
              [111.82935631600003, 21.72870514500005],
              [111.82894941500007, 21.749212958000044],
              [111.83505293100006, 21.766831773000035],
              [111.82227623800003, 21.752101955000057],
              [111.80689537900003, 21.743312893000052],
              [111.79395592500003, 21.744533596000053],
              [111.78793379000007, 21.75999583500004],
              [111.76978600400003, 21.753607489000046],
              [111.75790449300007, 21.75332265800006],
              [111.72584069100003, 21.766831773000035],
              [111.72120201900003, 21.762640692000048],
              [111.70093834700003, 21.768377997000073],
              [111.67807050900007, 21.78115469000005],
              [111.69556725400003, 21.761419989000046],
              [111.76059004000007, 21.725816148000035],
              [111.77247155000003, 21.705471096000053],
              [111.77963300900007, 21.675441799000055],
              [111.77369225400003, 21.650132554000038],
              [111.74691816500007, 21.64394765800006],
              [111.76034589900007, 21.64020416900007],
              [111.77247155000003, 21.635199286000045],
              [111.78207441500007, 21.62759023600006],
              [111.78793379000007, 21.616034247000073],
              [111.74813886800007, 21.614447333000044],
              [111.72836347700007, 21.616359768000052],
              [111.71290123800003, 21.623439846000053],
              [111.69044030000003, 21.60382721600007],
              [111.66578209700003, 21.558661200000074],
              [111.65137780000003, 21.54092031500005],
              [111.64047285200007, 21.533148505000042],
              [111.63046308700007, 21.529852606000077],
              [111.61972089900007, 21.533026434000078],
              [111.60645592500003, 21.544623114000046],
              [111.60092207100007, 21.55414459800005],
              [111.59652754000007, 21.56549713700008],
              [111.59107506600003, 21.57575104400007],
              [111.58187910200007, 21.581854559000078],
              [111.58082116000003, 21.56834544500009],
              [111.58204186300003, 21.555487372000073],
              [111.58643639400003, 21.543768622000073],
              [111.59555097700007, 21.534084377000056],
              [111.57772871200007, 21.53001536700009],
              [111.55665123800003, 21.522365627000056],
              [111.53785241000003, 21.520453192000048],
              [111.52719160200007, 21.534084377000056],
              [111.52100670700003, 21.534084377000056],
              [111.51661217500003, 21.524562893000052],
              [111.50448652400007, 21.51821523600006],
              [111.48934980600006, 21.51471588700008],
              [111.47608483200003, 21.513617255000042],
              [111.46810957100007, 21.51825592700004],
              [111.46713300900007, 21.529445705000057],
              [111.47266686300003, 21.55459219000005],
              [111.45533287900003, 21.551174221000053],
              [111.44410241000003, 21.563625393000052],
              [111.43222089900007, 21.60297272300005],
              [111.42432701900003, 21.590277411000045],
              [111.41211998800003, 21.576320705000057],
              [111.41114342500003, 21.56826406500005],
              [111.41553795700003, 21.55768463700008],
              [111.43091881600003, 21.54401276200008],
              [111.43799889400003, 21.534084377000056],
              [111.38778730600006, 21.541449286000045],
              [111.36280358200003, 21.54120514500005],
              [111.34970136800007, 21.526678778000075],
              [111.36304772200003, 21.532416083000044],
              [111.37647545700003, 21.53270091400009],
              [111.40430748800003, 21.526678778000075],
              [111.39356530000003, 21.519680080000057],
              [111.36280358200003, 21.506781317000048],
              [111.35645592500003, 21.501288153000075],
              [111.34433027400007, 21.487494208000044],
              [111.29249108200003, 21.45062897300005],
              [111.26734459700003, 21.43935781500005],
              [111.25294030000003, 21.44472890800006],
              [111.26905358200003, 21.45213450700004],
              [111.28028405000003, 21.465318101000037],
              [111.30128014400003, 21.499335028000075],
              [111.27979576900003, 21.506293036000045],
              [111.25562584700003, 21.517279364000046],
              [111.23218834700003, 21.524562893000052],
              [111.21265709700003, 21.520453192000048],
              [111.20630944100003, 21.532049872000073],
              [111.19239342500003, 21.531195380000042],
              [111.15796959700003, 21.520453192000048],
              [111.15796959700003, 21.513617255000042],
              [111.17164147200003, 21.513617255000042],
              [111.16757246200007, 21.508612372000073],
              [111.16496829500005, 21.506008205000057],
              [111.17164147200003, 21.499335028000075],
              [111.18417402400007, 21.50576406500005],
              [111.19882246200007, 21.50779857000009],
              [111.21363366000003, 21.505682684000078],
              [111.22632897200003, 21.499335028000075],
              [111.18458092500003, 21.485663153000075],
              [111.16163170700003, 21.476385809000078],
              [111.14364668100006, 21.46580638200004],
              [111.13404381600003, 21.471625067000048],
              [111.11988366000003, 21.47337474200009],
              [111.08838951900003, 21.47264232000009],
              [111.08838951900003, 21.480129299000055],
              [111.12997480600006, 21.493109442000048],
              [111.12997480600006, 21.499335028000075],
              [111.12671959700003, 21.50259023600006],
              [111.12378991000003, 21.506781317000048],
              [111.11670983200003, 21.50096263200004],
              [111.10767662900003, 21.495794989000046],
              [111.09791100400003, 21.492661851000037],
              [111.08838951900003, 21.493109442000048],
              [111.07935631600003, 21.497870184000078],
              [111.07846113400007, 21.502875067000048],
              [111.07935631600003, 21.50812409100007],
              [111.07545006600003, 21.513617255000042],
              [111.03443444100003, 21.53148021000004],
              [111.02759850400003, 21.54092031500005],
              [111.02328535200007, 21.527818101000037],
              [111.01172936300003, 21.521185614000046],
              [110.98593183700007, 21.513617255000042],
              [110.99569746200007, 21.507635809000078],
              [111.00220787900003, 21.489935614000046],
              [111.01392662900003, 21.485663153000075],
              [111.00131269600007, 21.46287669500009],
              [110.99244225400003, 21.45498281500005],
              [110.97974694100003, 21.45213450700004],
              [110.97974694100003, 21.44472890800006],
              [110.99537194100003, 21.44529857000009],
              [111.00814863400007, 21.44989655200004],
              [111.01693769600007, 21.45807526200008],
              [111.02011152400007, 21.469224351000037],
              [111.02686608200003, 21.479315497000073],
              [111.04224694100003, 21.48456452000005],
              [111.05860436300003, 21.48309967700004],
              [111.06861412900003, 21.47264232000009],
              [111.04371178500003, 21.46938711100006],
              [111.02491295700003, 21.45652903900009],
              [110.99293053500003, 21.42487213700008],
              [110.96591230600006, 21.432847398000035],
              [110.94117272200003, 21.42206452000005],
              [110.91724694100003, 21.405910549000055],
              [110.89332116000003, 21.39752838700008],
              [110.88965905000003, 21.39549388200004],
              [110.87728925900007, 21.38613515800006],
              [110.86988366000003, 21.383246161000045],
              [110.86939537900003, 21.384711005000042],
              [110.85230553500003, 21.389146226000037],
              [110.82982828900003, 21.39221832900006],
              [110.80616295700003, 21.401597398000035],
              [110.79053795700003, 21.40375397300005],
              [110.76815839900007, 21.39752838700008],
              [110.74398847700007, 21.382554429000038],
              [110.70484459700003, 21.348537502000056],
              [110.69003339900007, 21.331000067000048],
              [110.67628014400003, 21.30963776200008],
              [110.66488691500007, 21.285630601000037],
              [110.65707441500007, 21.26040273600006],
              [110.65088951900003, 21.26040273600006],
              [110.65479576900003, 21.314601955000057],
              [110.66285241000003, 21.337225653000075],
              [110.67758222700007, 21.348537502000056],
              [110.66456139400003, 21.34837474200009],
              [110.65552819100003, 21.34275950700004],
              [110.64893639400003, 21.333319403000075],
              [110.64332116000003, 21.32184479400007],
              [110.64185631600003, 21.33730703300006],
              [110.63575280000003, 21.34642161700009],
              [110.63184655000003, 21.35537344000005],
              [110.63648522200003, 21.370266018000052],
              [110.64478600400003, 21.37457916900007],
              [110.67164147200003, 21.381293036000045],
              [110.69239342500003, 21.39915599200009],
              [110.72461998800003, 21.403143622000073],
              [110.75538170700003, 21.413397528000075],
              [110.76636803500003, 21.44472890800006],
              [110.76002037900003, 21.44472890800006],
              [110.72730553500003, 21.418890692000048],
              [110.63559004000007, 21.38104889500005],
              [110.61670983200003, 21.345404364000046],
              [110.61573326900003, 21.301214911000045],
              [110.61972089900007, 21.290757554000038],
              [110.64332116000003, 21.25291575700004],
              [110.63648522200003, 21.230169989000046],
              [110.61695397200003, 21.229681708000044],
              [110.57520592500003, 21.24673086100006],
              [110.57715905000003, 21.240383205000057],
              [110.58017011800007, 21.23460521000004],
              [110.58407636800007, 21.229681708000044],
              [110.58871504000007, 21.22557200700004],
              [110.48145592500003, 21.217189846000053],
              [110.46322675900007, 21.212144273000035],
              [110.44760175900007, 21.203599351000037],
              [110.43116295700003, 21.191473700000074],
              [110.42432701900003, 21.191473700000074],
              [110.42701256600003, 21.206000067000048],
              [110.43555748800003, 21.226304429000038],
              [110.43734785200007, 21.23924388200004],
              [110.43344160200007, 21.251288153000075],
              [110.42701256600003, 21.261542059000078],
              [110.42579186300003, 21.269232489000046],
              [110.43734785200007, 21.273382880000042],
              [110.43580162900003, 21.27920156500005],
              [110.43311608200003, 21.282863674000055],
              [110.42929121200007, 21.28534577000005],
              [110.42432701900003, 21.287665106000077],
              [110.42733808700007, 21.28856028900009],
              [110.42994225400003, 21.28847890800006],
              [110.43148847700007, 21.289496161000045],
              [110.43116295700003, 21.293890692000048],
              [110.43734785200007, 21.293890692000048],
              [110.44629967500003, 21.289984442000048],
              [110.45663496200007, 21.28774648600006],
              [110.46631920700003, 21.28343333500004],
              [110.47266686300003, 21.273382880000042],
              [110.47885175900007, 21.273382880000042],
              [110.48031660200007, 21.281683661000045],
              [110.48218834700003, 21.28656647300005],
              [110.48633873800003, 21.293890692000048],
              [110.48633873800003, 21.301336981000077],
              [110.47885175900007, 21.301336981000077],
              [110.47315514400003, 21.295477606000077],
              [110.46607506600003, 21.296087958000044],
              [110.45704186300003, 21.299302476000037],
              [110.44483483200003, 21.301336981000077],
              [110.44483483200003, 21.307562567000048],
              [110.48633873800003, 21.328680731000077],
              [110.48633873800003, 21.33551666900007],
              [110.47803795700003, 21.336371161000045],
              [110.47266686300003, 21.334906317000048],
              [110.46876061300003, 21.33201732000009],
              [110.46534264400003, 21.328680731000077],
              [110.46534264400003, 21.348537502000056],
              [110.45118248800003, 21.331976630000042],
              [110.44190514400003, 21.31435781500005],
              [110.43392988400007, 21.30878327000005],
              [110.42432701900003, 21.328680731000077],
              [110.42392011800007, 21.341620184000078],
              [110.43734785200007, 21.39752838700008],
              [110.43116295700003, 21.39752838700008],
              [110.41952558700007, 21.377427476000037],
              [110.40097089900007, 21.38703034100007],
              [110.36898847700007, 21.42487213700008],
              [110.37867272200003, 21.43748607000009],
              [110.38314863400007, 21.441473700000074],
              [110.38949629000007, 21.44472890800006],
              [110.38949629000007, 21.45213450700004],
              [110.35849043100006, 21.43573639500005],
              [110.37208092500003, 21.40302155200004],
              [110.39437910200007, 21.36399974200009],
              [110.38949629000007, 21.328680731000077],
              [110.38583418100006, 21.33148834800005],
              [110.37647545700003, 21.33551666900007],
              [110.38266035200007, 21.32184479400007],
              [110.36817467500003, 21.325344143000052],
              [110.34498131600003, 21.33885325700004],
              [110.32813561300003, 21.342271226000037],
              [110.32813561300003, 21.33551666900007],
              [110.34140058700007, 21.330023505000042],
              [110.35670006600003, 21.319159247000073],
              [110.36630293100006, 21.30609772300005],
              [110.36280358200003, 21.293890692000048],
              [110.36280358200003, 21.287665106000077],
              [110.37378991000003, 21.280585028000075],
              [110.38485761800007, 21.27106354400007],
              [110.39340254000007, 21.26040273600006],
              [110.39698326900003, 21.249823309000078],
              [110.39901777400007, 21.24555084800005],
              [110.40821373800003, 21.238023179000038],
              [110.41065514400003, 21.232367255000042],
              [110.40992272200003, 21.223781643000052],
              [110.40748131600003, 21.21698639500005],
              [110.40455162900003, 21.212062893000052],
              [110.40316816500007, 21.20848216400009],
              [110.40235436300003, 21.19367096600007],
              [110.39942467500003, 21.176581122000073],
              [110.39405358200003, 21.162543036000045],
              [110.38607832100007, 21.156724351000037],
              [110.37533613400007, 21.15265534100007],
              [110.34742272200003, 21.133205471000053],
              [110.33375084700003, 21.116359768000052],
              [110.31527754000007, 21.10765208500004],
              [110.28028405000003, 21.09589264500005],
              [110.26929772200003, 21.089178778000075],
              [110.22177168100006, 21.03266022300005],
              [110.21884199300007, 21.02757396000004],
              [110.21021569100003, 21.03457265800006],
              [110.20557701900003, 21.049383856000077],
              [110.20386803500003, 21.066961981000077],
              [110.20460045700003, 21.08222077000005],
              [110.19556725400003, 21.07127513200004],
              [110.19068444100003, 21.059068101000037],
              [110.18409264400003, 21.03384023600006],
              [110.17782636800007, 21.020086981000077],
              [110.15674889400003, 20.986029364000046],
              [110.14307701900003, 20.992254950000074],
              [110.14307701900003, 20.986029364000046],
              [110.15479576900003, 20.97728099200009],
              [110.15512129000007, 20.96198151200008],
              [110.15097089900007, 20.943182684000078],
              [110.14926191500007, 20.923976955000057],
              [110.15414472700007, 20.90643952000005],
              [110.17164147200003, 20.877020575000074],
              [110.17725670700003, 20.862494208000044],
              [110.16724694100003, 20.872992255000042],
              [110.16415449300007, 20.876776434000078],
              [110.15674889400003, 20.876776434000078],
              [110.16065514400003, 20.86790599200009],
              [110.16187584700003, 20.862209377000056],
              [110.16065514400003, 20.856675523000035],
              [110.15674889400003, 20.848863023000035],
              [110.16073652400007, 20.84784577000005],
              [110.16293379000007, 20.84788646000004],
              [110.16391035200007, 20.84674713700008],
              [110.16415449300007, 20.84202708500004],
              [110.16871178500003, 20.842678127000056],
              [110.16944420700003, 20.84393952000005],
              [110.16879316500007, 20.846096096000053],
              [110.17042076900003, 20.848863023000035],
              [110.17750084700003, 20.847479559000078],
              [110.18018639400003, 20.84601471600007],
              [110.18336022200003, 20.846096096000053],
              [110.19149824300007, 20.848863023000035],
              [110.19149824300007, 20.83584219000005],
              [110.21168053500003, 20.84052155200004],
              [110.28711998800003, 20.84202708500004],
              [110.30079186300003, 20.852118231000077],
              [110.31967207100007, 20.859930731000077],
              [110.33578535200007, 20.85883209800005],
              [110.34180748800003, 20.84202708500004],
              [110.34864342500003, 20.848863023000035],
              [110.35523522200003, 20.839667059000078],
              [110.36109459700003, 20.835882880000042],
              [110.36581464900007, 20.83856842700004],
              [110.36898847700007, 20.848863023000035],
              [110.38624108200003, 20.825995184000078],
              [110.40267988400007, 20.79010651200008],
              [110.40943444100003, 20.75096263200004],
              [110.39698326900003, 20.718491929000038],
              [110.38355553500003, 20.713446356000077],
              [110.36898847700007, 20.719671942000048],
              [110.35645592500003, 20.73232656500005],
              [110.34864342500003, 20.74640534100007],
              [110.34725996200007, 20.761786200000074],
              [110.34815514400003, 20.80304596600007],
              [110.34180748800003, 20.821519273000035],
              [110.33375084700003, 20.80573151200008],
              [110.32862389400003, 20.799750067000048],
              [110.32129967500003, 20.794256903000075],
              [110.33301842500003, 20.77875397300005],
              [110.33212324300007, 20.76788971600007],
              [110.32252037900003, 20.75995514500005],
              [110.30762780000003, 20.753241278000075],
              [110.31446373800003, 20.74640534100007],
              [110.31063886800007, 20.745062567000048],
              [110.30884850400003, 20.74510325700004],
              [110.30811608200003, 20.743963934000078],
              [110.30762780000003, 20.73895905200004],
              [110.33749433700007, 20.725816148000035],
              [110.32943769600007, 20.70722077000005],
              [110.30884850400003, 20.683986721000053],
              [110.30079186300003, 20.657049872000073],
              [110.30770918100006, 20.66038646000004],
              [110.31348717500003, 20.664862372000073],
              [110.31796308700007, 20.67059967700004],
              [110.32129967500003, 20.677557684000078],
              [110.32813561300003, 20.677557684000078],
              [110.32960045700003, 20.664455471000053],
              [110.32837975400003, 20.65265534100007],
              [110.32374108200003, 20.643052476000037],
              [110.31446373800003, 20.636542059000078],
              [110.32593834700003, 20.63076406500005],
              [110.33936608200003, 20.63153717700004],
              [110.35214277400007, 20.636542059000078],
              [110.36280358200003, 20.643377997000073],
              [110.36280358200003, 20.622300523000035],
              [110.37183678500003, 20.63434479400007],
              [110.38062584700003, 20.63377513200004],
              [110.38917076900003, 20.625921942000048],
              [110.39698326900003, 20.616115627000056],
              [110.39193769600007, 20.606756903000075],
              [110.39747155000003, 20.595445054000038],
              [110.40853925900007, 20.58592357000009],
              [110.42514082100007, 20.58006419500009],
              [110.44296308700007, 20.570868231000077],
              [110.45167076900003, 20.567694403000075],
              [110.45801842500003, 20.56736888200004],
              [110.47266686300003, 20.56858958500004],
              [110.47885175900007, 20.567694403000075],
              [110.49520918100006, 20.553168036000045],
              [110.51148522200003, 20.527899481000077],
              [110.53419030000003, 20.478257554000038],
              [110.51539147200003, 20.434759833000044],
              [110.50228925900007, 20.41274648600006],
              [110.48267662900003, 20.403225002000056],
              [110.47535241000003, 20.397650458000044],
              [110.45850670700003, 20.362250067000048],
              [110.40683027400007, 20.305161851000037],
              [110.39999433700007, 20.30076732000009],
              [110.37671959700003, 20.305243231000077],
              [110.36207116000003, 20.30487702000005],
              [110.35547936300003, 20.297349351000037],
              [110.34433027400007, 20.279242255000042],
              [110.31967207100007, 20.26972077000005],
              [110.29403730600006, 20.262925523000035],
              [110.28028405000003, 20.25299713700008],
              [110.26563561300003, 20.264146226000037],
              [110.25635826900003, 20.269354559000078],
              [110.24561608200003, 20.27342357000009],
              [110.23715254000007, 20.27496979400007],
              [110.20801842500003, 20.27342357000009],
              [110.19662519600007, 20.27024974200009],
              [110.19263756600003, 20.26325104400007],
              [110.19117272200003, 20.25617096600007],
              [110.18775475400003, 20.25299713700008],
              [110.12753339900007, 20.247992255000042],
              [110.10962975400003, 20.25299713700008],
              [110.09310957100007, 20.27057526200008],
              [110.08570397200003, 20.27342357000009],
              [110.07764733200003, 20.274562893000052],
              [110.06983483200003, 20.277777411000045],
              [110.06373131600003, 20.283026434000078],
              [110.06112714900007, 20.290228583000044],
              [110.05762780000003, 20.29637278900009],
              [110.04892011800007, 20.30023834800005],
              [110.03785241000003, 20.301703192000048],
              [110.02711022200003, 20.30076732000009],
              [110.02157636800007, 20.297023830000057],
              [110.01181074300007, 20.283677476000037],
              [110.00595136800007, 20.28034088700008],
              [110.00098717500003, 20.28082916900007],
              [109.99520918100006, 20.28278229400007],
              [109.99146569100003, 20.284979559000078],
              [109.99227949300007, 20.28652578300006],
              [109.96583092500003, 20.280951239000046],
              [109.95093834700003, 20.27216217700004],
              [109.94442793100006, 20.25608958500004],
              [109.94141686300003, 20.25185781500005],
              [109.93392988400007, 20.24412669500009],
              [109.92489668100006, 20.23826732000009],
              [109.91724694100003, 20.23932526200008],
              [109.91456139400003, 20.248480536000045],
              [109.91724694100003, 20.25995514500005],
              [109.92172285200007, 20.269680080000057],
              [109.92408287900003, 20.27342357000009],
              [109.92855879000007, 20.294582424000055],
              [109.93091881600003, 20.31781647300005],
              [109.92872155000003, 20.32636139500005],
              [109.91944420700003, 20.342230536000045],
              [109.91724694100003, 20.35228099200009],
              [109.88575280000003, 20.366359768000052],
              [109.87411543100006, 20.376288153000075],
              [109.88990319100003, 20.38271719000005],
              [109.86280358200003, 20.406317450000074],
              [109.86573326900003, 20.41006094000005],
              [109.87891686300003, 20.41087474200009],
              [109.88803144600007, 20.41404857000009],
              [109.89380944100003, 20.420477606000077],
              [109.89608808700007, 20.43109772300005],
              [109.90357506600003, 20.43109772300005],
              [109.91488691500007, 20.41864655200004],
              [109.94581139400003, 20.395738023000035],
              [109.95809980600006, 20.38271719000005],
              [109.97486412900003, 20.354641018000052],
              [109.98243248800003, 20.35154857000009],
              [109.98544355600006, 20.37213776200008],
              [109.99244225400003, 20.38495514500005],
              [110.00611412900003, 20.401190497000073],
              [110.01547285200007, 20.418402411000045],
              [110.00977623800003, 20.43423086100006],
              [109.98397871200007, 20.453192450000074],
              [109.97225996200007, 20.464544989000046],
              [109.96493574300007, 20.478257554000038],
              [109.96298261800007, 20.471991278000075],
              [109.96045983200003, 20.46625397300005],
              [109.95850670700003, 20.459906317000048],
              [109.95809980600006, 20.451605536000045],
              [109.94361412900003, 20.460679429000038],
              [109.93921959700003, 20.473863023000035],
              [109.93751061300003, 20.48965078300006],
              [109.93091881600003, 20.506252346000053],
              [109.92994225400003, 20.47138092700004],
              [109.92701256600003, 20.454901434000078],
              [109.91724694100003, 20.44476959800005],
              [109.91480553500003, 20.45701732000009],
              [109.90951582100007, 20.471177476000037],
              [109.90292402400007, 20.484198309000078],
              [109.89608808700007, 20.492580471000053],
              [109.88282311300003, 20.497748114000046],
              [109.84970136800007, 20.500921942000048],
              [109.83521569100003, 20.506252346000053],
              [109.82748457100007, 20.511460679000038],
              [109.82211347700007, 20.516546942000048],
              [109.81959069100003, 20.523504950000074],
              [109.82105553500003, 20.534125067000048],
              [109.82569420700003, 20.542792059000078],
              [109.83179772200003, 20.544582424000055],
              [109.83749433700007, 20.54437897300005],
              [109.84140058700007, 20.54718659100007],
              [109.84376061300003, 20.557074286000045],
              [109.84522545700003, 20.58112213700008],
              [109.84823652400007, 20.595648505000042],
              [109.84140058700007, 20.595648505000042],
              [109.82772871200007, 20.554632880000042],
              [109.82105553500003, 20.554632880000042],
              [109.81885826900003, 20.589097398000035],
              [109.80201256600003, 20.61627838700008],
              [109.77588951900003, 20.631333726000037],
              [109.74586022200003, 20.629787502000056],
              [109.75171959700003, 20.645412502000056],
              [109.75025475400003, 20.66046784100007],
              [109.75155683700007, 20.67373281500005],
              [109.76571699300007, 20.684393622000073],
              [109.77515709700003, 20.68618398600006],
              [109.77979576900003, 20.683539130000042],
              [109.78524824300007, 20.67959219000005],
              [109.79712975400003, 20.677557684000078],
              [109.80591881600003, 20.679510809000078],
              [109.81275475400003, 20.684515692000048],
              [109.82772871200007, 20.69798411700009],
              [109.83065839900007, 20.69367096600007],
              [109.83700605600006, 20.689154364000046],
              [109.84140058700007, 20.684393622000073],
              [109.84424889400003, 20.68968333500004],
              [109.84888756600003, 20.69627513200004],
              [109.85409589900007, 20.70184967700004],
              [109.85873457100007, 20.704250393000052],
              [109.86190839900007, 20.708156643000052],
              [109.86044355600006, 20.71548086100006],
              [109.85474694100003, 20.719916083000044],
              [109.82943769600007, 20.707912502000056],
              [109.81397545700003, 20.70844147300005],
              [109.80103600400003, 20.706284898000035],
              [109.79371178500003, 20.691148179000038],
              [109.78687584700003, 20.691148179000038],
              [109.76026451900003, 20.72996653900009],
              [109.75643964900007, 20.749701239000046],
              [109.77320397200003, 20.766913153000075],
              [109.76343834700003, 20.776556708000044],
              [109.75814863400007, 20.792792059000078],
              [109.76026451900003, 20.807806708000044],
              [109.77320397200003, 20.814113674000055],
              [109.77320397200003, 20.821519273000035],
              [109.75204511800007, 20.84202708500004],
              [109.75204511800007, 20.848863023000035],
              [109.75953209700003, 20.848863023000035],
              [109.75953209700003, 20.85504791900007],
              [109.75302168100006, 20.863714911000045],
              [109.74537194100003, 20.867661851000037],
              [109.73780358200003, 20.865383205000057],
              [109.73153730600006, 20.85504791900007],
              [109.73902428500003, 20.807847398000035],
              [109.72836347700007, 20.81513092700004],
              [109.71387780000003, 20.833685614000046],
              [109.70435631600003, 20.84202708500004],
              [109.70679772200003, 20.831854559000078],
              [109.71786543100006, 20.807847398000035],
              [109.68946373800003, 20.83539459800005],
              [109.66561933700007, 20.880926825000074],
              [109.66122480600006, 20.927557684000078],
              [109.69125410200007, 20.958726304000038],
              [109.67896569100003, 20.973863023000035],
              [109.68067467500003, 20.99445221600007],
              [109.69752037900003, 21.04059479400007],
              [109.70077558700007, 21.03856028900009],
              [109.70850670700003, 21.03587474200009],
              [109.71168053500003, 21.03384023600006],
              [109.70980879000007, 21.057196356000077],
              [109.69996178500003, 21.08299388200004],
              [109.68555748800003, 21.106594143000052],
              [109.67017662900003, 21.12323639500005],
              [109.67660566500007, 21.138495184000078],
              [109.69589277400007, 21.17011139500005],
              [109.70435631600003, 21.17845286700009],
              [109.72022545700003, 21.183417059000078],
              [109.72836347700007, 21.177883205000057],
              [109.73642011800007, 21.16901276200008],
              [109.75204511800007, 21.164129950000074],
              [109.74667402400007, 21.17967357000009],
              [109.75489342500003, 21.19293854400007],
              [109.76710045700003, 21.20453522300005],
              [109.77320397200003, 21.215399481000077],
              [109.77027428500003, 21.271307684000078],
              [109.76571699300007, 21.28082916900007],
              [109.76571699300007, 21.287665106000077],
              [109.77352949300007, 21.299709377000056],
              [109.77393639400003, 21.31867096600007],
              [109.76571699300007, 21.355943101000037],
              [109.77637780000003, 21.353664455000057],
              [109.78370201900003, 21.34829336100006],
              [109.78736412900003, 21.339911200000074],
              [109.78687584700003, 21.328680731000077],
              [109.79981530000003, 21.332912502000056],
              [109.80347741000003, 21.34121328300006],
              [109.80396569100003, 21.350043036000045],
              [109.80738366000003, 21.355943101000037],
              [109.81625410200007, 21.357570705000057],
              [109.84140058700007, 21.355943101000037],
              [109.92408287900003, 21.36277903900009],
              [109.92408287900003, 21.370266018000052],
              [109.90479576900003, 21.390692450000074],
              [109.91757246200007, 21.413804429000038],
              [109.94052168100006, 21.437201239000046],
              [109.95126386800007, 21.45840078300006],
              [109.93344160200007, 21.45380280200004],
              [109.92457116000003, 21.46503327000005],
              [109.92725670700003, 21.479803778000075],
              [109.94442793100006, 21.485663153000075],
              [109.94442793100006, 21.493109442000048],
              [109.91797936300003, 21.489406643000052],
              [109.88697350400003, 21.48151276200008],
              [109.85897871200007, 21.482814846000053],
              [109.84140058700007, 21.506781317000048],
              [109.82772871200007, 21.493109442000048],
              [109.82772871200007, 21.485663153000075],
              [109.83521569100003, 21.485663153000075],
              [109.83521569100003, 21.480129299000055],
              [109.82691491000003, 21.470526434000078],
              [109.82374108200003, 21.46503327000005],
              [109.82105553500003, 21.45840078300006],
              [109.81421959700003, 21.45840078300006],
              [109.80274498800003, 21.47333405200004],
              [109.79908287900003, 21.498602606000077],
              [109.80054772200003, 21.55459219000005],
              [109.78329511800007, 21.54637278900009],
              [109.77011152400007, 21.551581122000073],
              [109.76514733200003, 21.563381252000056],
              [109.77320397200003, 21.575100002000056],
              [109.77320397200003, 21.581854559000078],
              [109.74805748800003, 21.57493724200009],
              [109.74805748800003, 21.574611721000053],
              [109.74781334700003, 21.54523346600007],
              [109.76026451900003, 21.51162344000005],
              [109.77320397200003, 21.493109442000048],
              [109.77320397200003, 21.485663153000075],
              [109.76571699300007, 21.485663153000075],
              [109.76571699300007, 21.493109442000048],
              [109.75953209700003, 21.493109442000048],
              [109.74146569100003, 21.47402578300006],
              [109.70858808700007, 21.483303127000056],
              [109.64966881600003, 21.520453192000048],
              [109.65992272200003, 21.52806224200009],
              [109.66822350400003, 21.55963776200008],
              [109.67701256600003, 21.575100002000056],
              [109.67335045700003, 21.582098700000074],
              [109.67172285200007, 21.596625067000048],
              [109.67017662900003, 21.60297272300005],
              [109.67367597700007, 21.606390692000048],
              [109.67676842500003, 21.61005280200004],
              [109.67798912900003, 21.615301825000074],
              [109.67701256600003, 21.623439846000053],
              [109.65878339900007, 21.614935614000046],
              [109.63721764400003, 21.601629950000074],
              [109.62525475400003, 21.58539459800005],
              [109.63599694100003, 21.56826406500005],
              [109.62891686300003, 21.566839911000045],
              [109.62232506600003, 21.56781647300005],
              [109.61581464900007, 21.570705471000053],
              [109.60800214900007, 21.575100002000056],
              [109.60800214900007, 21.581854559000078],
              [109.61280358200003, 21.589789130000042],
              [109.61353600400003, 21.601223049000055],
              [109.61085045700003, 21.61151764500005],
              [109.60499108200003, 21.616034247000073],
              [109.60303795700003, 21.62059153900009],
              [109.61548912900003, 21.650132554000038],
              [109.59449303500003, 21.63418203300006],
              [109.58529707100007, 21.63084544500009],
              [109.58139082100007, 21.64020416900007],
              [109.57992597700007, 21.650458075000074],
              [109.57593834700003, 21.659369208000044],
              [109.56942793100006, 21.666489976000037],
              [109.56088300900007, 21.67129140800006],
              [109.56421959700003, 21.691229559000078],
              [109.56771894600007, 21.698553778000075],
              [109.56080162900003, 21.70726146000004],
              [109.56788170700003, 21.719956773000035],
              [109.58155358200003, 21.732367255000042],
              [109.59449303500003, 21.740179755000042],
              [109.59449303500003, 21.74640534100007],
              [109.58334394600007, 21.744533596000053],
              [109.57496178500003, 21.74567291900007],
              [109.56942793100006, 21.75063711100006],
              [109.56771894600007, 21.75999583500004],
              [109.49268639400003, 21.698553778000075],
              [109.49805748800003, 21.695379950000074],
              [109.50098717500003, 21.691880601000037],
              [109.50326582100007, 21.688381252000056],
              [109.50619550900007, 21.68496328300006],
              [109.50302168100006, 21.684515692000048],
              [109.49594160200007, 21.68500397300005],
              [109.49268639400003, 21.68496328300006],
              [109.49268639400003, 21.678127346000053],
              [109.49927819100003, 21.680161851000037],
              [109.51343834700003, 21.68268463700008],
              [109.51986738400007, 21.68496328300006],
              [109.52100670700003, 21.665757554000038],
              [109.50635826900003, 21.65766022300005],
              [109.48471113400007, 21.658026434000078],
              [109.46469160200007, 21.664455471000053],
              [109.46469160200007, 21.65761953300006],
              [109.52987714900007, 21.635687567000048],
              [109.54053795700003, 21.626898505000042],
              [109.54322350400003, 21.619574286000045],
              [109.57276451900003, 21.581732489000046],
              [109.57105553500003, 21.576239325000074],
              [109.56495201900003, 21.572739976000037],
              [109.56088300900007, 21.56826406500005],
              [109.56226647200003, 21.536932684000078],
              [109.56088300900007, 21.526678778000075],
              [109.55697675900007, 21.521551825000074],
              [109.54330488400007, 21.508246161000045],
              [109.54053795700003, 21.503078518000052],
              [109.53077233200003, 21.49164459800005],
              [109.48585045700003, 21.474310614000046],
              [109.47217858200003, 21.46580638200004],
              [109.46688886800007, 21.47483958500004],
              [109.46583092500003, 21.482896226000037],
              [109.46786543100006, 21.49087148600006],
              [109.47217858200003, 21.499335028000075],
              [109.46387780000003, 21.492987372000073],
              [109.45460045700003, 21.48183828300006],
              [109.44727623800003, 21.47011953300006],
              [109.44418379000007, 21.462103583000044],
              [109.43824303500003, 21.45506419500009],
              [109.42440839900007, 21.452378648000035],
              [109.34376061300003, 21.453517971000053],
              [109.33521569100003, 21.458156643000052],
              [109.32081139400003, 21.480129299000055],
              [109.31552168100006, 21.459051825000074],
              [109.29892011800007, 21.44326406500005],
              [109.27759850400003, 21.43699778900009],
              [109.25863691500007, 21.44472890800006],
              [109.25375410200007, 21.440334377000056],
              [109.25025475400003, 21.438299872000073],
              [109.24765058700007, 21.43626536700009],
              [109.24496504000007, 21.43162669500009],
              [109.23878014400003, 21.43162669500009],
              [109.23715254000007, 21.458685614000046],
              [109.23878014400003, 21.485663153000075],
              [109.22706139400003, 21.47223541900007],
              [109.21973717500003, 21.44912344000005],
              [109.21461022200003, 21.41742584800005],
              [109.17196699300007, 21.41754791900007],
              [109.15707441500007, 21.423529364000046],
              [109.14942467500003, 21.43854401200008],
              [109.14429772200003, 21.427557684000078],
              [109.14462324300007, 21.41795482000009],
              [109.14893639400003, 21.409979559000078],
              [109.15626061300003, 21.40375397300005],
              [109.13868248800003, 21.401597398000035],
              [109.09644616000003, 21.42519765800006],
              [109.07740319100003, 21.43162669500009],
              [109.05014082100007, 21.437160549000055],
              [109.03980553500003, 21.45026276200008],
              [109.04371178500003, 21.46625397300005],
              [109.06006920700003, 21.480129299000055],
              [109.08253014400003, 21.486029364000046],
              [109.10987389400003, 21.489569403000075],
              [109.13282311300003, 21.495917059000078],
              [109.14258873800003, 21.510199286000045],
              [109.14210045700003, 21.55345286700009],
              [109.13575280000003, 21.60297272300005],
              [109.12891686300003, 21.60297272300005],
              [109.12435957100007, 21.590969143000052],
              [109.11605879000007, 21.59056224200009],
              [109.10718834700003, 21.59796784100007],
              [109.10108483200003, 21.609198309000078],
              [109.09481855600006, 21.609198309000078],
              [109.08741295700003, 21.599554755000042],
              [109.07764733200003, 21.596991278000075],
              [109.06967207100007, 21.60224030200004],
              [109.06674238400007, 21.616034247000073],
              [109.06006920700003, 21.616034247000073],
              [109.05665123800003, 21.61155833500004],
              [109.04639733200003, 21.60297272300005],
              [109.04981530000003, 21.614081122000073],
              [109.05469811300003, 21.62205638200004],
              [109.06674238400007, 21.636542059000078],
              [109.06674238400007, 21.64394765800006],
              [109.04843183700007, 21.63690827000005],
              [109.01376386800007, 21.615383205000057],
              [108.99244225400003, 21.609198309000078],
              [108.97022545700003, 21.606350002000056],
              [108.95899498800003, 21.606594143000052],
              [108.94459069100003, 21.609198309000078],
              [108.92798912900003, 21.615057684000078],
              [108.92074629000007, 21.622015692000048],
              [108.90650475400003, 21.650824286000045],
              [108.90170332100007, 21.665187893000052],
              [108.89747155000003, 21.67129140800006],
              [108.89161217500003, 21.672674872000073],
              [108.87549889400003, 21.67015208500004],
              [108.86947675900007, 21.67129140800006],
              [108.85726972700007, 21.683417059000078],
              [108.85523522200003, 21.68496328300006],
              [108.85523522200003, 21.694281317000048],
              [108.86036217500003, 21.69790273600006],
              [108.86646569100003, 21.70018138200004],
              [108.86947675900007, 21.70538971600007],
              [108.86426842500003, 21.73187897300005],
              [108.86142011800007, 21.733343817000048],
              [108.86548912900003, 21.73973216400009],
              [108.86744225400003, 21.741400458000044],
              [108.86996504000007, 21.742336330000057],
              [108.87574303500003, 21.74640534100007],
              [108.88599694100003, 21.750433661000045],
              [108.91659589900007, 21.75381094000005],
              [108.92237389400003, 21.762884833000044],
              [108.92408287900003, 21.766831773000035],
              [108.91684004000007, 21.76434967700004],
              [108.90430748800003, 21.76276276200008],
              [108.89747155000003, 21.75999583500004],
              [108.90308678500003, 21.774318752000056],
              [108.89380944100003, 21.771551825000074],
              [108.88632246200007, 21.76715729400007],
              [108.88062584700003, 21.76117584800005],
              [108.87574303500003, 21.75381094000005],
              [108.86947675900007, 21.75381094000005],
              [108.86142011800007, 21.75999583500004],
              [108.86142011800007, 21.766831773000035],
              [108.86695397200003, 21.77415599200009],
              [108.87574303500003, 21.80097077000005],
              [108.86947675900007, 21.80097077000005],
              [108.85824629000007, 21.78729889500005],
              [108.85523522200003, 21.78115469000005],
              [108.84986412900003, 21.79169342700004],
              [108.85067793100006, 21.800523179000038],
              [108.85523522200003, 21.80817291900007],
              [108.86142011800007, 21.815252997000073],
              [108.84083092500003, 21.81159088700008],
              [108.80136152400007, 21.81834544500009],
              [108.77955162900003, 21.815252997000073],
              [108.78891035200007, 21.810939846000053],
              [108.82105553500003, 21.80097077000005],
              [108.81739342500003, 21.796576239000046],
              [108.81625410200007, 21.793361721000053],
              [108.81592858200003, 21.789007880000042],
              [108.81421959700003, 21.78115469000005],
              [108.83261152400007, 21.78384023600006],
              [108.84253991000003, 21.768052476000037],
              [108.84351647200003, 21.745021877000056],
              [108.83472741000003, 21.725816148000035],
              [108.82894941500007, 21.720038153000075],
              [108.82211347700007, 21.71503327000005],
              [108.81666100400003, 21.71637604400007],
              [108.81421959700003, 21.729641018000052],
              [108.81405683700007, 21.741115627000056],
              [108.81210371200007, 21.752427476000037],
              [108.80591881600003, 21.75844961100006],
              [108.79306074300007, 21.75381094000005],
              [108.79859459700003, 21.74827708500004],
              [108.80054772200003, 21.74481842700004],
              [108.79989668100006, 21.733343817000048],
              [108.79664147200003, 21.73696523600006],
              [108.79517662900003, 21.737982489000046],
              [108.79281660200007, 21.738430080000057],
              [108.78687584700003, 21.740179755000042],
              [108.79306074300007, 21.733343817000048],
              [108.78980553500003, 21.72915273600006],
              [108.78638756600003, 21.727850653000075],
              [108.78296959700003, 21.727443752000056],
              [108.77955162900003, 21.725816148000035],
              [108.79989668100006, 21.725816148000035],
              [108.79989668100006, 21.71906159100007],
              [108.79306074300007, 21.71906159100007],
              [108.79306074300007, 21.712836005000042],
              [108.81666100400003, 21.699693101000037],
              [108.83432050900007, 21.68573639500005],
              [108.83863366000003, 21.668036200000074],
              [108.82105553500003, 21.64394765800006],
              [108.84237714900007, 21.64638906500005],
              [108.85181725400003, 21.64598216400009],
              [108.86142011800007, 21.64394765800006],
              [108.84994550900007, 21.62596263200004],
              [108.83399498800003, 21.62799713700008],
              [108.81544030000003, 21.637925523000035],
              [108.79647871200007, 21.64394765800006],
              [108.78736412900003, 21.641424872000073],
              [108.78207441500007, 21.63548411700009],
              [108.77808678500003, 21.628729559000078],
              [108.77271569100003, 21.623439846000053],
              [108.76278730600006, 21.62055084800005],
              [108.74594160200007, 21.620266018000052],
              [108.73853600400003, 21.616034247000073],
              [108.74537194100003, 21.60297272300005],
              [108.73349043100006, 21.61273834800005],
              [108.73129316500007, 21.629461981000077],
              [108.72754967500003, 21.64476146000004],
              [108.71119225400003, 21.650132554000038],
              [108.71119225400003, 21.65761953300006],
              [108.73316491000003, 21.66242096600007],
              [108.74032636800007, 21.66014232000009],
              [108.74537194100003, 21.650132554000038],
              [108.75155683700007, 21.650132554000038],
              [108.75155683700007, 21.69171784100007],
              [108.74244225400003, 21.684149481000077],
              [108.74024498800003, 21.67999909100007],
              [108.73853600400003, 21.67129140800006],
              [108.73170006600003, 21.67129140800006],
              [108.71265709700003, 21.688421942000048],
              [108.71542402400007, 21.709133205000057],
              [108.72470136800007, 21.729722398000035],
              [108.72486412900003, 21.74640534100007],
              [108.71786543100006, 21.74315013200004],
              [108.71119225400003, 21.74640534100007],
              [108.70045006600003, 21.722479559000078],
              [108.69410241000003, 21.712144273000035],
              [108.68319746200007, 21.70538971600007],
              [108.67457116000003, 21.715399481000077],
              [108.65430748800003, 21.723537502000056],
              [108.64918053500003, 21.733343817000048],
              [108.65878339900007, 21.733221747000073],
              [108.66700280000003, 21.734849351000037],
              [108.68319746200007, 21.740179755000042],
              [108.68319746200007, 21.74640534100007],
              [108.66537519600007, 21.75185781500005],
              [108.65259850400003, 21.74998607000009],
              [108.64633222700007, 21.75136953300006],
              [108.64918053500003, 21.766831773000035],
              [108.65560957100007, 21.778225002000056],
              [108.66480553500003, 21.787176825000074],
              [108.67310631600003, 21.798000393000052],
              [108.67701256600003, 21.815252997000073],
              [108.66968834700003, 21.815252997000073],
              [108.66700280000003, 21.809515692000048],
              [108.66016686300003, 21.801336981000077],
              [108.65601647200003, 21.79482656500005],
              [108.64975019600007, 21.814154364000046],
              [108.64918053500003, 21.822088934000078],
              [108.64234459700003, 21.822088934000078],
              [108.64307701900003, 21.809393622000073],
              [108.64218183700007, 21.79686107000009],
              [108.63965905000003, 21.784979559000078],
              [108.63550866000003, 21.774318752000056],
              [108.62867272200003, 21.774318752000056],
              [108.62330162900003, 21.78351471600007],
              [108.62183678500003, 21.787909247000073],
              [108.61500084700003, 21.787909247000073],
              [108.62501061300003, 21.76780833500004],
              [108.62916100400003, 21.75608958500004],
              [108.62867272200003, 21.74640534100007],
              [108.59449303500003, 21.740179755000042],
              [108.59376061300003, 21.754828192000048],
              [108.59750410200007, 21.766546942000048],
              [108.60751386800007, 21.787909247000073],
              [108.58057701900003, 21.781317450000074],
              [108.56942793100006, 21.79437897300005],
              [108.57138105600006, 21.81281159100007],
              [108.58423912900003, 21.822088934000078],
              [108.60059655000003, 21.830633856000077],
              [108.62208092500003, 21.87107982000009],
              [108.63550866000003, 21.88418203300006],
              [108.63550866000003, 21.890326239000046],
              [108.62256920700003, 21.896226304000038],
              [108.59449303500003, 21.917669989000046],
              [108.59408613400007, 21.91120026200008],
              [108.59229576900003, 21.906805731000077],
              [108.58969160200007, 21.902899481000077],
              [108.58765709700003, 21.89785390800006],
              [108.58334394600007, 21.900539455000057],
              [108.57960045700003, 21.90180084800005],
              [108.56714928500003, 21.90460846600007],
              [108.57089277400007, 21.901271877000056],
              [108.57398522200003, 21.89996979400007],
              [108.57699629000007, 21.899359442000048],
              [108.58082116000003, 21.89785390800006],
              [108.57032311300003, 21.893377997000073],
              [108.56031334700003, 21.89549388200004],
              [108.55372155000003, 21.90375397300005],
              [108.55298912900003, 21.917669989000046],
              [108.55811608200003, 21.923651434000078],
              [108.56690514400003, 21.927801825000074],
              [108.57382246200007, 21.93545156500005],
              [108.57333418100006, 21.95180898600006],
              [108.56714928500003, 21.95180898600006],
              [108.56698652400007, 21.948553778000075],
              [108.56739342500003, 21.941961981000077],
              [108.56714928500003, 21.938788153000075],
              [108.55982506600003, 21.938788153000075],
              [108.55836022200003, 21.942572333000044],
              [108.55298912900003, 21.95180898600006],
              [108.55054772200003, 21.93545156500005],
              [108.54566491000003, 21.92381419500009],
              [108.53768964900007, 21.914496161000045],
              [108.52564537900003, 21.90460846600007],
              [108.52149498800003, 21.906724351000037],
              [108.50513756600003, 21.91083405200004],
              [108.50513756600003, 21.90460846600007],
              [108.51075280000003, 21.901597398000035],
              [108.51319420700003, 21.898504950000074],
              [108.51539147200003, 21.894924221000053],
              [108.51880944100003, 21.890326239000046],
              [108.50171959700003, 21.88580963700008],
              [108.48487389400003, 21.877101955000057],
              [108.47836347700007, 21.866400458000044],
              [108.49146569100003, 21.856268622000073],
              [108.46314537900003, 21.862982489000046],
              [108.46070397200003, 21.887111721000053],
              [108.47779381600003, 21.945013739000046],
              [108.47022545700003, 21.940252997000073],
              [108.46469160200007, 21.93431224200009],
              [108.46070397200003, 21.926947333000044],
              [108.45801842500003, 21.917669989000046],
              [108.45728600400003, 21.888332424000055],
              [108.44874108200003, 21.865790106000077],
              [108.45565839900007, 21.848781643000052],
              [108.46957441500007, 21.832953192000048],
              [108.48462975400003, 21.822088934000078],
              [108.48153730600006, 21.821478583000044],
              [108.47095787900003, 21.822088934000078],
              [108.47201582100007, 21.817531643000052],
              [108.47388756600003, 21.81443919500009],
              [108.47608483200003, 21.811712958000044],
              [108.47779381600003, 21.807806708000044],
              [108.48829186300003, 21.81476471600007],
              [108.49708092500003, 21.809027411000045],
              [108.50294030000003, 21.79759349200009],
              [108.50513756600003, 21.787909247000073],
              [108.50196373800003, 21.776678778000075],
              [108.49610436300003, 21.76825592700004],
              [108.49130293100006, 21.75771719000005],
              [108.49146569100003, 21.740179755000042],
              [108.48218834700003, 21.74359772300005],
              [108.47592207100007, 21.74433014500005],
              [108.47046959700003, 21.743068752000056],
              [108.46347089900007, 21.740179755000042],
              [108.47543379000007, 21.736761786000045],
              [108.48682701900003, 21.73187897300005],
              [108.49691816500007, 21.725897528000075],
              [108.50513756600003, 21.71906159100007],
              [108.50513756600003, 21.712836005000042],
              [108.49146569100003, 21.712836005000042],
              [108.49170983200003, 21.708685614000046],
              [108.49390709700003, 21.705877997000073],
              [108.49504642000005, 21.705633856000077],
              [108.49765058700007, 21.70538971600007],
              [108.49634850400003, 21.704779364000046],
              [108.49382571700005, 21.70538971600007],
              [108.47779381600003, 21.70538971600007],
              [108.47779381600003, 21.698553778000075],
              [108.48642011800007, 21.69725169500009],
              [108.49634850400003, 21.69293854400007],
              [108.50513756600003, 21.69171784100007],
              [108.50513756600003, 21.68496328300006],
              [108.50147545700003, 21.68036530200004],
              [108.50082441500007, 21.68032461100006],
              [108.50228925900007, 21.67914459800005],
              [108.50513756600003, 21.67129140800006],
              [108.51303144600007, 21.70018138200004],
              [108.52011152400007, 21.712632554000038],
              [108.53305097700007, 21.71906159100007],
              [108.53052819100003, 21.710191148000035],
              [108.52597089900007, 21.70538971600007],
              [108.52149498800003, 21.702297268000052],
              [108.51880944100003, 21.698553778000075],
              [108.51791425900007, 21.689276434000078],
              [108.52076256600003, 21.680568752000056],
              [108.51880944100003, 21.67129140800006],
              [108.52401777400007, 21.675604559000078],
              [108.52792402400007, 21.677679755000042],
              [108.53101647200003, 21.67987702000005],
              [108.53305097700007, 21.68496328300006],
              [108.53711998800003, 21.685370184000078],
              [108.53858483200003, 21.684027411000045],
              [108.53931725400003, 21.678127346000053],
              [108.54224694100003, 21.68382396000004],
              [108.55298912900003, 21.698553778000075],
              [108.55982506600003, 21.698553778000075],
              [108.56544030000003, 21.678534247000073],
              [108.55722089900007, 21.671616929000038],
              [108.54517662900003, 21.666083075000074],
              [108.53931725400003, 21.650132554000038],
              [108.54883873800003, 21.656195380000042],
              [108.55298912900003, 21.65761953300006],
              [108.54688561300003, 21.643052476000037],
              [108.53598066500007, 21.638006903000075],
              [108.52344811300003, 21.63930898600006],
              [108.51197350400003, 21.64394765800006],
              [108.51197350400003, 21.636542059000078],
              [108.51734459700003, 21.63495514500005],
              [108.52100670700003, 21.63300202000005],
              [108.52540123800003, 21.63117096600007],
              [108.53305097700007, 21.63031647300005],
              [108.53052819100003, 21.62051015800006],
              [108.52686608200003, 21.61424388200004],
              [108.52100670700003, 21.61078522300005],
              [108.51197350400003, 21.609198309000078],
              [108.51661217500003, 21.59918854400007],
              [108.51880944100003, 21.595526434000078],
              [108.49048912900003, 21.583685614000046],
              [108.48121178500003, 21.581854559000078],
              [108.48007246200007, 21.587836005000042],
              [108.48178144600007, 21.59951406500005],
              [108.48910566500007, 21.60761139500005],
              [108.50513756600003, 21.60297272300005],
              [108.50513756600003, 21.609198309000078],
              [108.49146569100003, 21.623439846000053],
              [108.47852623800003, 21.60614655200004],
              [108.47177168100006, 21.600490627000056],
              [108.46347089900007, 21.595526434000078],
              [108.46998131600003, 21.58690013200004],
              [108.47120201900003, 21.581203518000052],
              [108.46713300900007, 21.57754140800006],
              [108.45801842500003, 21.575100002000056],
              [108.45801842500003, 21.56826406500005],
              [108.46102949300007, 21.56785716400009],
              [108.47095787900003, 21.56826406500005],
              [108.47095787900003, 21.56199778900009],
              [108.42001386800007, 21.55687083500004],
              [108.40211022200003, 21.559800523000035],
              [108.38965905000003, 21.575100002000056],
              [108.39063561300003, 21.595363674000055],
              [108.40674889400003, 21.60024648600006],
              [108.42090905000003, 21.594224351000037],
              [108.41635175900007, 21.581854559000078],
              [108.43189537900003, 21.583238023000035],
              [108.43873131600003, 21.594183661000045],
              [108.44369550900007, 21.623439846000053],
              [108.43751061300003, 21.623439846000053],
              [108.43246504000007, 21.618109442000048],
              [108.42758222700007, 21.61668528900009],
              [108.42237389400003, 21.61871979400007],
              [108.41635175900007, 21.623439846000053],
              [108.41635175900007, 21.63031647300005],
              [108.42123457100007, 21.635158596000053],
              [108.42733808700007, 21.639146226000037],
              [108.43482506600003, 21.64215729400007],
              [108.44369550900007, 21.64394765800006],
              [108.44141686300003, 21.652085679000038],
              [108.44809004000007, 21.65810781500005],
              [108.45948326900003, 21.66209544500009],
              [108.47095787900003, 21.664455471000053],
              [108.47095787900003, 21.67129140800006],
              [108.42343183700007, 21.663275458000044],
              [108.40967858200003, 21.664455471000053],
              [108.42359459700003, 21.679388739000046],
              [108.42701256600003, 21.68773021000004],
              [108.42383873800003, 21.698553778000075],
              [108.42090905000003, 21.693182684000078],
              [108.41358483200003, 21.684800523000035],
              [108.40967858200003, 21.678127346000053],
              [108.40805097700007, 21.683294989000046],
              [108.40699303500003, 21.683294989000046],
              [108.40333092500003, 21.68496328300006],
              [108.39795983200003, 21.67283763200004],
              [108.38599694100003, 21.67291901200008],
              [108.33765709700003, 21.69745514500005],
              [108.33594811300003, 21.706854559000078],
              [108.34131920700003, 21.725816148000035],
              [108.32154381600003, 21.70966217700004],
              [108.31137129000007, 21.681708075000074],
              [108.31275475400003, 21.65184153900009],
              [108.32764733200003, 21.63031647300005],
              [108.30648847700007, 21.63031647300005],
              [108.31112714900007, 21.619940497000073],
              [108.31397545700003, 21.616034247000073],
              [108.30640709700003, 21.61273834800005],
              [108.30079186300003, 21.607245184000078],
              [108.29664147200003, 21.599432684000078],
              [108.29346764400003, 21.58930084800005],
              [108.30909264400003, 21.58893463700008],
              [108.31397545700003, 21.58930084800005],
              [108.31397545700003, 21.581854559000078],
              [108.30713951900003, 21.57811107000009],
              [108.28956139400003, 21.56403229400007],
              [108.28598066500007, 21.558294989000046],
              [108.28378339900007, 21.544745184000078],
              [108.27784264400003, 21.54010651200008],
              [108.26913496200007, 21.53864166900007],
              [108.25863691500007, 21.534084377000056],
              [108.22641035200007, 21.50800202000005],
              [108.21102949300007, 21.50063711100006],
              [108.21029707100007, 21.513617255000042],
              [108.21933027400007, 21.529364325000074],
              [108.24496504000007, 21.56435781500005],
              [108.25196373800003, 21.581854559000078],
              [108.25277754000007, 21.58852773600006],
              [108.25253339900007, 21.59528229400007],
              [108.24935957100007, 21.60309479400007],
              [108.24170983200003, 21.612616278000075],
              [108.22681725400003, 21.625555731000077],
              [108.22787519600007, 21.632066148000035],
              [108.23829186300003, 21.64394765800006],
              [108.21688886800007, 21.63540273600006],
              [108.21029707100007, 21.63031647300005],
              [108.20980879000007, 21.63349030200004],
              [108.21029707100007, 21.64394765800006],
              [108.20606530000003, 21.64256419500009],
              [108.20093834700003, 21.638617255000042],
              [108.19727623800003, 21.636542059000078],
              [108.20468183700007, 21.631008205000057],
              [108.20883222700007, 21.623928127000056],
              [108.20883222700007, 21.61619700700004],
              [108.20411217500003, 21.609198309000078],
              [108.20411217500003, 21.60297272300005],
              [108.21029707100007, 21.60297272300005],
              [108.17636152400007, 21.57575104400007],
              [108.15796959700003, 21.571519273000035],
              [108.13526451900003, 21.581854559000078],
              [108.12842858200003, 21.575100002000056],
              [108.13233483200003, 21.565375067000048],
              [108.12826582100007, 21.56273021000004],
              [108.12094160200007, 21.56631094000005],
              [108.11475670700003, 21.575100002000056],
              [108.10580488400007, 21.559068101000037],
              [108.09278405000003, 21.558661200000074],
              [108.07846113400007, 21.56321849200009],
              [108.06625410200007, 21.56199778900009],
              [108.07699629000007, 21.545477606000077],
              [108.07105553500003, 21.53656647300005],
              [108.05689537900003, 21.536037502000056],
              [108.03199303500003, 21.551906643000052],
              [108.01710045700003, 21.555243231000077],
              [108.00228925900007, 21.55426666900007],
              [107.99122155000003, 21.54840729400007],
              [108.02735436300003, 21.52334219000005],
              [108.03956139400003, 21.520453192000048],
              [108.01864668100006, 21.51894765800006],
              [108.01124108200003, 21.50653717700004],
              [108.01368248800003, 21.49241771000004],
              [108.02222741000003, 21.485663153000075],
              [108.03622480600006, 21.488226630000042],
              [108.04761803500003, 21.49315013200004],
              [108.06104576900003, 21.496161200000074],
              [108.08057701900003, 21.493109442000048],
              [108.08057701900003, 21.485663153000075],
              [108.04322350400003, 21.481634833000044],
              [108.01661217500003, 21.470363674000055],
              [107.97071373800003, 21.43162669500009],
              [107.96387780000003, 21.43162669500009],
              [107.96534264400003, 21.447333075000074],
              [107.97266686300003, 21.460272528000075],
              [107.99122155000003, 21.480129299000055],
              [107.99122155000003, 21.485663153000075],
              [107.94419112200012, 21.53077992800003],
              [107.93096195500004, 21.53424224800007],
              [107.89613204000005, 21.569433899000032],
              [107.86771000200014, 21.589225973000012],
              [107.8554626880001, 21.60033640600004],
              [107.84445560700004, 21.617492981000098],
              [107.83985640500009, 21.629895325000078],
              [107.83236332200005, 21.639352112000054],
              [107.81164107300003, 21.647827047000035],
              [107.77789636300002, 21.65599192300006],
              [107.76011967000011, 21.658214010000066],
              [107.74482344600005, 21.657542217000085],
              [107.72942386900007, 21.651961161000074],
              [107.69025313300011, 21.624727682000056],
              [107.67185632300004, 21.617648011000043],
              [107.61320357300008, 21.605607402000075],
              [107.59284305800008, 21.605607402000075],
              [107.55098514800011, 21.610826721000095],
              [107.53305342600004, 21.608656311000104],
              [107.52654219600004, 21.603281963000043],
              [107.51827396700003, 21.587365621000018],
              [107.5098507080001, 21.5817845670001],
              [107.50132409700007, 21.581526184000026],
              [107.49119551600006, 21.584110006000046],
              [107.4737805580001, 21.590569560000077],
              [107.46101648000013, 21.596357320000052],
              [107.45703739400005, 21.631497294],
              [107.44592696200004, 21.646948547000093],
              [107.42603153500005, 21.652064514000088],
              [107.40996016500009, 21.645398255000075],
              [107.38288171400012, 21.618888245000065],
              [107.34815515200006, 21.599354553000083],
              [107.33357556600009, 21.61250876000007],
              [107.32965498900006, 21.616046041000104],
              [107.30319665500008, 21.688703105000045],
              [107.27265588400007, 21.7183137010001],
              [107.24387211100003, 21.715161438000038],
              [107.21214278200011, 21.705239563000035],
              [107.17235192900011, 21.71505808500011],
              [107.09483728100003, 21.77898183200007],
              [107.06584680200007, 21.795828349000047],
              [107.02373051000012, 21.804096578],
              [107.00290490800006, 21.81055613200006],
              [106.98910730000011, 21.824250387000077],
              [106.98714359500008, 21.844817607000053],
              [106.99753055800011, 21.860837301000018],
              [107.01184493000011, 21.875565084000115],
              [107.02114668800004, 21.89225657100006],
              [107.0202165130001, 21.91292714400008],
              [107.00936446200012, 21.927448222000024],
              [106.99189782700006, 21.935354716000077],
              [106.97122725400004, 21.935819804000076],
              [106.95376062100013, 21.928998515000032],
              [106.93774092600006, 21.920006816000082],
              [106.92037764500003, 21.916957906000064],
              [106.89882857300012, 21.927758280000106],
              [106.88539270000012, 21.943312887000033],
              [106.87686608900003, 21.957317200000134],
              [106.86477380400004, 21.968065898000063],
              [106.84053755700006, 21.97359527600007],
              [106.79909305900009, 21.972613423],
              [106.78152307100004, 21.975042216000062],
              [106.76100752800005, 21.98506744400008],
              [106.75614994400013, 21.989511617000076],
              [106.74834680200013, 21.999950257000123],
              [106.74255904200004, 22.003877666000093],
              [106.72876143400009, 22.00832183900009],
              [106.72235355700013, 22.00697825100012],
              [106.6897457280001, 21.97287180600007],
              [106.67460453300009, 21.962174785000045],
              [106.65894657500013, 21.962794901000038],
              [106.65310713700012, 21.968892720000085],
              [106.64959314000009, 21.977574362000027],
              [106.6481462000001, 21.98703114900009],
              [106.64819787700009, 21.99550608300011],
              [106.66788659700006, 22.042686666000023],
              [106.67300256400006, 22.066096090000073],
              [106.6721757410001, 22.09250274700007],
              [106.67005700700003, 22.096636861],
              [106.66132369000007, 22.10655873700007],
              [106.65868819200006, 22.111933085000047],
              [106.65837813400009, 22.12009796200006],
              [106.66147871900012, 22.136324361000064],
              [106.66132369000007, 22.14355906200005],
              [106.65610437100003, 22.155134583000077],
              [106.64866296500003, 22.16505645800008],
              [106.64235843900008, 22.17611521400009],
              [106.63967126500006, 22.190894674],
              [106.6518152270001, 22.205622457000104],
              [106.66054854300006, 22.213425598000114],
              [106.66292565900011, 22.223295797],
              [106.63967126500006, 22.29667633100003],
              [106.63378015100005, 22.309440410000022],
              [106.61729537000008, 22.32277292900004],
              [106.57745284100008, 22.324581604000016],
              [106.55533532700008, 22.331971334000045],
              [106.54179610200009, 22.345097148],
              [106.53652510600006, 22.360548401000088],
              [106.53450972500008, 22.39754872600004],
              [106.53302821800008, 22.403444519000075],
              [106.52691329000004, 22.427779440000066],
              [106.52691329000004, 22.438269755000093],
              [106.53032393400008, 22.449276836000095],
              [106.54138269100008, 22.464263001000077],
              [106.5458785400001, 22.472531230000115],
              [106.56877120000013, 22.574592183000064],
              [106.57714278200007, 22.59531443300007],
              [106.58799483200005, 22.607768453000077],
              [106.60763187700007, 22.609990540000055],
              [106.6195174560001, 22.597329814000133],
              [106.63005944800005, 22.58012156200006],
              [106.64633752500009, 22.56880442300009],
              [106.66788659700006, 22.569114482000074],
              [106.68018558800009, 22.57944976800006],
              [106.69770389900003, 22.630867818000056],
              [106.70509362800004, 22.646112366000082],
              [106.72659102400007, 22.67727325500006],
              [106.73553104700011, 22.695411682000085],
              [106.73956180800013, 22.726779277],
              [106.74664148000005, 22.744349263000075],
              [106.75847538300007, 22.75421946200005],
              [106.79149662300011, 22.77212534600004],
              [106.79873132300008, 22.784372660000045],
              [106.78984297700009, 22.797188416000026],
              [106.76844893400005, 22.79922963500009],
              [106.74509118700013, 22.797188416000026],
              [106.73036340400012, 22.797627665000064],
              [106.7310351970001, 22.800108134000126],
              [106.71491215100014, 22.826101379000093],
              [106.68514652500005, 22.848218893000094],
              [106.67439782700012, 22.861473897000096],
              [106.66747318500012, 22.86752004000003],
              [106.65682784000006, 22.869974670000104],
              [106.64793949400013, 22.86697743800009],
              [106.63987797000004, 22.853386536000087],
              [106.63274662300012, 22.849614156000072],
              [106.61037072800013, 22.852869771000073],
              [106.59915694200009, 22.864987895000056],
              [106.59171553500005, 22.880878398000064],
              [106.58169030800013, 22.89527028400009],
              [106.56696252400013, 22.9037710570001],
              [106.51693973800013, 22.915424093000055],
              [106.50117842600014, 22.921702780000075],
              [106.48779423100012, 22.925423483000074],
              [106.47797570900013, 22.91960988400008],
              [106.47373824100009, 22.89710479700007],
              [106.4579769290001, 22.888965759000072],
              [106.31566003400013, 22.8537999470001],
              [106.29638472500011, 22.851112773000082],
              [106.27659265200003, 22.851035258000067],
              [106.25540531400009, 22.85465260900004],
              [106.23401127200003, 22.86385101300006],
              [106.22708663000009, 22.87555572600003],
              [106.22300419100009, 22.912375183000037],
              [106.20238529400007, 22.946998393000044],
              [106.1700358490001, 22.96601532000001],
              [106.13210534700005, 22.975007019000046],
              [106.07758671000005, 22.981027324000067],
              [105.99924524000005, 22.97536875400006],
              [105.98999515800006, 22.970614523000066],
              [105.97397546400009, 22.939892884000088],
              [105.96121138500013, 22.932399801000074],
              [105.94482995600009, 22.927697246],
              [105.9132039800001, 22.92438995400009],
              [105.90369551600003, 22.9255009970001],
              [105.88664229400007, 22.929764303000056],
              [105.87599694900007, 22.928265687000035],
              [105.87010583500006, 22.923098043000053],
              [105.86659183800003, 22.91506235800007],
              [105.86225101700006, 22.907750143000058],
              [105.85387943500007, 22.904649556000024],
              [105.83568933100003, 22.917232768000062],
              [105.77936202000012, 22.976118062000054],
              [105.76613285400003, 22.99516082800004],
              [105.7660295010001, 22.99516082800004],
              [105.76582279400003, 22.99531585700005],
              [105.76582279400003, 22.995470886000092],
              [105.75471236200013, 23.005676982000082],
              [105.74324019400012, 23.01079294800006],
              [105.73161299700007, 23.014229431],
              [105.71967574100012, 23.01960378100007],
              [105.70071049000006, 23.037819722],
              [105.69032352700003, 23.043969218000072],
              [105.66495039900013, 23.04337493900003],
              [105.63683841900007, 23.051333110000073],
              [105.56599003100007, 23.054097799000132],
              [105.55157230700013, 23.05967885400004],
              [105.53968672700012, 23.075466003000045],
              [105.53529423100008, 23.094095358000104],
              [105.53523999500004, 23.0990127780001],
              [105.53482914300008, 23.136263327000066],
              [105.52826623600009, 23.1555127970001],
              [105.52132535800013, 23.163147762000037],
              [105.5171558020001, 23.167734273000107],
              [105.47385095200013, 23.194502665000087],
              [105.46434248900005, 23.206000672000116],
              [105.4439819750001, 23.24514556900006],
              [105.43085616100012, 23.267805685],
              [105.4258952240001, 23.273205872000077],
              [105.41447473200009, 23.278476868],
              [105.40667159100008, 23.277469177000043],
              [105.3991268310001, 23.274885356000127],
              [105.38951501500003, 23.275427958000066],
              [105.37571740700014, 23.281499939000028],
              [105.35964603700006, 23.291551005000045],
              [105.34403975500004, 23.30418589300008],
              [105.33225752800013, 23.317957662000126],
              [105.32435103400007, 23.336742045000037],
              [105.32006189000003, 23.35433787],
              [105.3121553960001, 23.36581003900004],
              [105.29365523300004, 23.366275127000065],
              [105.28006433200005, 23.358782044000023],
              [105.24554447500009, 23.330179138000048],
              [105.23593265800008, 23.31979217600012],
              [105.22766442900013, 23.300646057000037],
              [105.22389205000007, 23.281706645000085],
              [105.21753584900006, 23.26535105500004],
              [105.20089603700006, 23.25400807700005],
              [105.1895788980001, 23.252199402000073],
              [105.18244755100005, 23.254421488000062],
              [105.17660811400003, 23.257754619000067],
              [105.16896000200006, 23.259434103000032],
              [105.16580773900012, 23.26057098400004],
              [105.1584180100001, 23.26576446600005],
              [105.15562748200006, 23.266849670000042],
              [105.15035648600013, 23.264756775000066],
              [105.1477726650001, 23.260881043000026],
              [105.14591231300011, 23.256695252000085],
              [105.14239831500004, 23.25374969500008],
              [105.06105961100008, 23.23245900500008],
              [105.04664188700013, 23.22682627400006],
              [105.01568770300003, 23.206827494000024],
              [104.98142622900014, 23.19036855100005],
              [104.9452010500001, 23.159827779000054],
              [104.93507246900003, 23.15427256300005],
              [104.9210164800001, 23.15577117900007],
              [104.8947648520001, 23.170343933000126],
              [104.8808638920001, 23.171713359000094],
              [104.87006351800005, 23.16354848200008],
              [104.86675622600006, 23.14946665500004],
              [104.86551599200004, 23.133472799000103],
              [104.86127852400006, 23.119597677000044],
              [104.8359053960001, 23.099753926000048],
              [104.81146244300004, 23.09618825300008],
              [104.79792321800005, 23.085568746],
              [104.82701704900006, 22.954284770000115],
              [104.82794722500012, 22.934156799000036],
              [104.82360640500013, 22.92413157200012],
              [104.77420373600012, 22.89622629800003],
              [104.76288659700003, 22.884728292000105],
              [104.72821171100003, 22.839098002000114],
              [104.71534427900013, 22.82708323200005],
              [104.70077152500005, 22.818246562000056],
              [104.6832015390001, 22.812174581000093],
              [104.66273767200005, 22.810934346000053],
              [104.6290446380001, 22.82077870700003],
              [104.60982100500007, 22.823000794000038],
              [104.60444665500012, 22.820210266000075],
              [104.59426639800012, 22.80902231800006],
              [104.58842696200003, 22.80685190900006],
              [104.57922855600003, 22.808867290000094],
              [104.57447432400005, 22.812277934000022],
              [104.57049524000007, 22.816257019000105],
              [104.56465580200006, 22.819951884000105],
              [104.56124515800008, 22.824396057000016],
              [104.56269209900006, 22.82984792100011],
              [104.56238203900006, 22.834395447000034],
              [104.55354537000005, 22.836049093],
              [104.55121993000012, 22.832845154000026],
              [104.5333398840001, 22.8143966680001],
              [104.46864099200008, 22.764864807000052],
              [104.44900394700005, 22.745176087000104],
              [104.36191128100012, 22.69253554600006],
              [104.35546960500005, 22.68864206900004],
              [104.34017338100011, 22.68636830600012],
              [104.32523889200013, 22.692517802000097],
              [104.30441328900008, 22.704661764],
              [104.24948124200006, 22.728329570000128],
              [104.23682051600008, 22.74207550100006],
              [104.22968916800005, 22.761945089000065],
              [104.22875899300004, 22.783442485000094],
              [104.23309981300008, 22.80481069000011],
              [104.24116133700011, 22.824396057000016],
              [104.21325606300007, 22.8250161750001],
              [104.12819665500007, 22.796826681000127],
              [104.09905114800006, 22.794604594000035],
              [104.08685551000008, 22.791555685],
              [104.07331628500009, 22.78266733900007],
              [104.06597823100009, 22.77401153600003],
              [104.05404097500013, 22.753754374000025],
              [104.04473921800013, 22.745176087000104],
              [104.02381026300003, 22.719182841000034],
              [104.01394006400005, 22.691019185000087],
              [104.00748051000011, 22.630247701000073],
              [104.0033980710001, 22.614951477000105],
              [103.99006555200009, 22.58534088100008],
              [103.98556970200013, 22.57025136400007],
              [103.98556970200013, 22.554541728000103],
              [103.98737837800013, 22.540175680000104],
              [103.9853629970001, 22.527153219000056],
              [103.97399418100008, 22.515267639000044],
              [103.95952478000004, 22.507102763000105],
              [103.95094649200013, 22.516456197000068],
              [103.94071455900007, 22.52467275],
              [103.92541833500007, 22.528238424000065],
              [103.91704675300014, 22.533251038000017],
              [103.90278405800007, 22.55857249000009],
              [103.89461918200004, 22.56921783500009],
              [103.88867639200004, 22.571749980000064],
              [103.87265669800007, 22.573610332000086],
              [103.86681726100005, 22.575419007000065],
              [103.84418298400004, 22.599293519000057],
              [103.8363281660001, 22.60275583900001],
              [103.82966190600007, 22.609163717000044],
              [103.80966312700014, 22.638722636000082],
              [103.80532230700004, 22.647404277000035],
              [103.79421187400004, 22.659444886000088],
              [103.72641239500012, 22.716288961000046],
              [103.65850956200006, 22.79320933000004],
              [103.64693404200005, 22.799048768000134],
              [103.60383589700012, 22.776026917000067],
              [103.59003829000005, 22.76801707],
              [103.58254520700012, 22.755795593000087],
              [103.57680912300009, 22.740835267000122],
              [103.56833418800005, 22.724970602000027],
              [103.5471468500001, 22.70068267900011],
              [103.54456302900013, 22.691019185000087],
              [103.54992302200003, 22.64866216800003],
              [103.55091923000003, 22.640789694000134],
              [103.54621667500004, 22.631436259000097],
              [103.5142806400001, 22.587356262000114],
              [103.5036352950001, 22.581413473000012],
              [103.48544519000006, 22.584100647000028],
              [103.47314620000003, 22.59164540600007],
              [103.44751469000005, 22.61825876900012],
              [103.41092777500012, 22.674741109000067],
              [103.40431319200013, 22.68879709900007],
              [103.4023494870001, 22.706522115],
              [103.40400313400005, 22.723885397000018],
              [103.4017293710001, 22.737838033000102],
              [103.38751835200003, 22.745176087000104],
              [103.37894006300013, 22.756777446000044],
              [103.36875980700006, 22.767138570000057],
              [103.35708093300008, 22.776026917000067],
              [103.34416182500007, 22.782977397000067],
              [103.32157922400012, 22.790392965000095],
              [103.30964196800011, 22.78793833400003],
              [103.2699544680001, 22.723265279000046],
              [103.25248783400008, 22.67856516500011],
              [103.2448913980001, 22.66869496700012],
              [103.22840661600003, 22.655827536000018],
              [103.16846195500011, 22.626475321000058],
              [103.14174524000009, 22.60704498300008],
              [103.13001469000005, 22.57795115100005],
              [103.13259851100008, 22.569786276000045],
              [103.14469079600008, 22.55578196300003],
              [103.14572432500006, 22.54555002900007],
              [103.14200362100013, 22.537798564000056],
              [103.09125736500005, 22.50508738200007],
              [103.07441084800007, 22.49816274000007],
              [103.05828780100006, 22.495475566000053],
              [103.04418013600008, 22.486483867000018],
              [103.04485192900006, 22.4728929650001],
              [103.04908939600011, 22.45682159400006],
              [103.04505863500009, 22.440543518000126],
              [103.02903894100007, 22.43015655500001],
              [103.00893680900009, 22.43031158500004],
              [102.9890930580001, 22.437597962000027],
              [102.95653690600005, 22.45971547400005],
              [102.9195882570001, 22.469223938000127],
              [102.90258671100008, 22.47723378500008],
              [102.89369836400004, 22.487362366000056],
              [102.85928186100011, 22.550510966],
              [102.85313236500014, 22.568442689000065],
              [102.8451741940001, 22.585237529000054],
              [102.83184167500008, 22.599706930000067],
              [102.81339318800013, 22.608698629000017],
              [102.77122522000008, 22.617793681000094],
              [102.75189823400007, 22.625286764000023],
              [102.69272871900006, 22.6705036420001],
              [102.67216149900008, 22.67835845900005],
              [102.63226729400003, 22.684973043000056],
              [102.61247522000008, 22.691587626000043],
              [102.60611901900012, 22.696703593000038],
              [102.59118453000008, 22.712568258000132],
              [102.58668868000007, 22.716082256000092],
              [102.5761983650001, 22.713808493000087],
              [102.57035892700003, 22.70709055600004],
              [102.56575972500008, 22.699545797],
              [102.55836999500008, 22.694946595000047],
              [102.53578739400012, 22.695825094],
              [102.52891442900005, 22.707814026000037],
              [102.52633060700003, 22.72595245400008],
              [102.51578861500008, 22.745176087000104],
              [102.49434289600009, 22.76039479600003],
              [102.46778121000006, 22.76858551000005],
              [102.44271814000012, 22.765174866000038],
              [102.42561324100006, 22.745305278000032],
              [102.42561324100006, 22.745176087000104],
              [102.41522627800009, 22.7098294070001],
              [102.4072681070001, 22.693447978000037],
              [102.39496911700007, 22.680528870000032],
              [102.38463383000004, 22.677738343000087],
              [102.37316166200003, 22.67835845900005],
              [102.36272302300011, 22.677428283],
              [102.35585005700005, 22.669935201000058],
              [102.35626346800007, 22.658721415000016],
              [102.3633431400001, 22.65143503800003],
              [102.37269657400003, 22.64575063100007],
              [102.37858768800004, 22.639084371000067],
              [102.38246342000008, 22.63081614200003],
              [102.38432377100008, 22.628852437000077],
              [102.37688236500003, 22.615571595000077],
              [102.25254886900007, 22.495475566000053],
              [102.24252364200004, 22.477182109000083],
              [102.23663252800003, 22.443437398000114],
              [102.23130985600011, 22.426332500000072],
              [102.2180290120001, 22.410674540000016],
              [102.20355961100006, 22.41248321500011],
              [102.18655806500004, 22.421061503000132],
              [102.16454390500007, 22.425505676000043],
              [102.14702559400007, 22.421061503000132],
              [102.12883549000003, 22.410881246000073],
              [102.11865523300008, 22.39754872600004],
              [102.10734543400008, 22.39754872600004],
              [102.10062015800008, 22.405765280000068],
              [102.0999483650001, 22.414860331000042],
              [102.09534916200005, 22.423128561000098],
              [102.08553064000006, 22.429123027000017],
              [102.07591882300005, 22.432430319000034],
              [102.01457889800008, 22.446072896000132],
              [101.9949935300001, 22.4474164840001],
              [101.97421960500003, 22.445142720000078],
              [101.95287723800004, 22.436874491000125],
              [101.90936568200004, 22.435892639000073],
              [101.89164066600011, 22.42969146700007],
              [101.88151208500005, 22.412173157000026],
              [101.87727461800011, 22.39186431900002],
              [101.86792118300008, 22.378841858000058],
              [101.84259973100006, 22.38333770800007],
              [101.81779504400004, 22.406333720000035],
              [101.7848771570001, 22.472221171000044],
              [101.75505985600012, 22.49552724300007],
              [101.7506156820001, 22.496044007000094],
              [101.74177901200011, 22.496044007000094],
              [101.7131502680001, 22.491548157000082],
              [101.68912072800009, 22.478887431000047],
              [101.66865686100004, 22.46229929700003],
              [101.65454919500007, 22.446124573000034],
              [101.64509240800004, 22.42421376500009],
              [101.64416223200004, 22.4040082800001],
              [101.64571252500008, 22.384526266000094],
              [101.64369714400004, 22.364682516000116],
              [101.64111332200014, 22.363287252000035],
              [101.62369836500011, 22.346647441000115],
              [101.6225098060001, 22.342358297000047],
              [101.61987430900007, 22.32644195500002],
              [101.60612837700012, 22.284842427000015],
              [101.60121911700008, 22.27698761000009],
              [101.58798995000012, 22.27135487900007],
              [101.5757426350001, 22.27311187800005],
              [101.56370202700009, 22.276780905000024],
              [101.55098962400007, 22.276677552000095],
              [101.54065433700003, 22.271458232000086],
              [101.5317143150001, 22.263396708000087],
              [101.51574629800007, 22.245361634000105],
              [101.51822676600005, 22.22820505800003],
              [101.54902592000013, 22.19353017200011],
              [101.56153161700013, 22.17611521400009],
              [101.56695764200009, 22.149346822000027],
              [101.5618416750001, 22.13007151300006],
              [101.55502038600014, 22.112398173000074],
              [101.55543379800014, 22.090332337000078],
              [101.56494226100006, 22.069506734000115],
              [101.59217574100006, 22.02811391300007],
              [101.60039229400007, 22.007495016000078],
              [101.60680017100003, 21.96760081000012],
              [101.61630863500011, 21.953648173000133],
              [101.6381160890001, 21.940884094000054],
              [101.67366947500005, 21.931375631],
              [101.68059411600007, 21.9226423140001],
              [101.68245446800006, 21.91483917300009],
              [101.68307458600003, 21.907139384000104],
              [101.68586511300009, 21.898612773000067],
              [101.70870609600007, 21.869570618000083],
              [101.72126346900012, 21.844352519000054],
              [101.72617272900004, 21.837272848000012],
              [101.7510807700001, 21.81613718700008],
              [101.75154585800004, 21.806370341000033],
              [101.73165043200004, 21.75050811800004],
              [101.72798140500004, 21.7326797490001],
              [101.72854984500009, 21.717538554000086],
              [101.73278731300013, 21.71144073500004],
              [101.74911706500006, 21.698056539000092],
              [101.75480147300004, 21.689788310000054],
              [101.75562829600005, 21.68002146400009],
              [101.75232100500006, 21.659144186000034],
              [101.75593835500013, 21.648653870000075],
              [101.77082116700007, 21.638835348],
              [101.78952803600004, 21.634029440000077],
              [101.80384240700005, 21.62591623900009],
              [101.8061678470001, 21.60596913700006],
              [101.79355879700006, 21.588244121000045],
              [101.77268151900006, 21.582508036],
              [101.75092574100006, 21.57966583300002],
              [101.73619795800005, 21.570880839000026],
              [101.73475101700006, 21.554396057000062],
              [101.74823856600005, 21.514501852000123],
              [101.74425948100009, 21.495588277000067],
              [101.72968672700011, 21.474245911000068],
              [101.7255526130001, 21.37538889600002],
              [101.71557906100008, 21.338181865000095],
              [101.71511397300003, 21.321128642000062],
              [101.72250370300003, 21.30423044800007],
              [101.73650801600007, 21.292293193000134],
              [101.7885461840001, 21.274206442000022],
              [101.80115523300003, 21.267075094000077],
              [101.81226566600003, 21.25813507100007],
              [101.82022383600008, 21.247283020000012],
              [101.82373783400004, 21.234467265000134],
              [101.8228076580001, 21.224131979000035],
              [101.82149033400009, 21.221071138000084],
              [101.81929366100013, 21.215967102000022],
              [101.81329919500013, 21.209559225000064],
              [101.80523767100004, 21.204494934000095],
              [101.79603926600004, 21.20294464100006],
              [101.77356001800013, 21.207388815000073],
              [101.76007246900008, 21.19596832300006],
              [101.7635864660001, 21.18465118400009],
              [101.77020105000003, 21.170440166000034],
              [101.76845334900003, 21.16044957700005],
              [101.76673872900005, 21.150648092000054],
              [101.75599003200006, 21.143258362000054],
              [101.73748986800013, 21.137573954000104],
              [101.71790450000009, 21.134473369000048],
              [101.70426192200011, 21.135093485000127],
              [101.68829390500014, 21.145842183000056],
              [101.67015547700004, 21.17705474900002],
              [101.65511763500012, 21.18919871100003],
              [101.63594567900003, 21.189457092000097],
              [101.59651656100004, 21.173385722000134],
              [101.58178877800003, 21.175659485000054],
              [101.57724125200008, 21.18516794800003],
              [101.58096195500008, 21.194728089000037],
              [101.58664636300006, 21.204236552000012],
              [101.58819665600004, 21.21333160400009],
              [101.58395918800011, 21.2243903600001],
              [101.57967004400012, 21.227594299000074],
              [101.57290043100011, 21.228162740000116],
              [101.53910404500004, 21.23885976100003],
              [101.51760664900007, 21.242632141000044],
              [101.49512740100005, 21.2428388470001],
              [101.38149092600008, 21.22247833200008],
              [101.36226729400005, 21.215812073000066],
              [101.31389815300014, 21.184754537000018],
              [101.29271081600007, 21.176072897000054],
              [101.27529585800005, 21.174109192000046],
              [101.25974125100004, 21.179483541000096],
              [101.24434167500004, 21.192867737000128],
              [101.23478153500014, 21.206251933000075],
              [101.22036381100003, 21.23369211800012],
              [101.20899499500013, 21.245526021000032],
              [101.21907189900008, 21.28247467100006],
              [101.22036381100003, 21.296272278000018],
              [101.2184001060001, 21.29994130500002],
              [101.20951176000005, 21.308674622000083],
              [101.20744470200003, 21.31482411700007],
              [101.22284427900007, 21.33508127800006],
              [101.23478153500014, 21.363658345000132],
              [101.23312788900006, 21.371719869000017],
              [101.23080244900007, 21.371771546000033],
              [101.22646163000007, 21.370893046],
              [101.20796146700013, 21.38350209600013],
              [101.17912601800003, 21.39817820200001],
              [101.17142622900013, 21.403397522000134],
              [101.16827396700006, 21.424533183000065],
              [101.18775598100007, 21.505871887000083],
              [101.18656742400003, 21.53532745400007],
              [101.17452681500004, 21.551657206000115],
              [101.15902388500007, 21.5526907350001],
              [101.15421797700003, 21.568038635000065],
              [101.1577319750001, 21.586228740000095],
              [101.16765384900009, 21.600181376000094],
              [101.17385502100007, 21.611911926000076],
              [101.16672367300004, 21.623280742000063],
              [101.1688424080001, 21.637853496000034],
              [101.1614526780001, 21.65836903900002],
              [101.14925704000007, 21.676765849],
              [101.13633793100007, 21.684724019000058],
              [101.12765629100005, 21.695162659000104],
              [101.12486576400005, 21.74415191700011],
              [101.11887129800004, 21.759809876000062],
              [101.08280114800004, 21.766734518000064],
              [101.06869348200013, 21.76203196200008],
              [101.05530928600007, 21.754538880000027],
              [101.04290694200012, 21.745392152000065],
              [100.99278080300007, 21.71144073500004],
              [100.97428064000007, 21.704154358000054],
              [100.87749068200003, 21.677334290000047],
              [100.83490930200009, 21.657542217000085],
              [100.79703047700008, 21.626122946000052],
              [100.75661950700004, 21.569847310000043],
              [100.70396122300008, 21.51641387900004],
              [100.66153487100007, 21.49553660100007],
              [100.66132816600003, 21.495329896],
              [100.64577356000007, 21.479878642000116],
              [100.62174401800007, 21.469078268000075],
              [100.57182458500012, 21.45507395500006],
              [100.5459863690001, 21.453006897000094],
              [100.49710046400003, 21.4617918900001],
              [100.4742594810001, 21.45683095300005],
              [100.45668949400005, 21.455022278000044],
              [100.44346032800013, 21.463497213000053],
              [100.43426192300012, 21.478380026000096],
              [100.42930098500005, 21.495381572000028],
              [100.39912194900006, 21.518894348000018],
              [100.38367069500009, 21.527834371000054],
              [100.36325850400004, 21.53176178000011],
              [100.34196781400004, 21.53036651700002],
              [100.32651656100006, 21.524268698000057],
              [100.31463098200004, 21.512951559],
              [100.30248702000011, 21.49553660100007],
              [100.30228031400009, 21.495329896],
              [100.28951623500012, 21.483134258000078],
              [100.27520186400011, 21.475176087000037],
              [100.24409265100007, 21.464530742000036],
              [100.23024336800012, 21.45683095300005],
              [100.19789392100012, 21.433214824000046],
              [100.18714522300007, 21.427892151],
              [100.16249556500009, 21.43636708600009],
              [100.12833744300008, 21.482359110000075],
              [100.1077702230001, 21.49553660100007],
              [100.09727990800008, 21.508300680000033],
              [100.08999353000007, 21.528919577000025],
              [100.08606612200003, 21.550933737000022],
              [100.08560103400009, 21.567573548000027],
              [100.08864994300012, 21.581836243000012],
              [100.0948511150001, 21.59883778900003],
              [100.10394616700006, 21.615632629000103],
              [100.11572839400009, 21.629481914000067],
              [100.12611535700012, 21.6348562620001],
              [100.13619226100013, 21.63681996700005],
              [100.14373702000006, 21.640023906000025],
              [100.14632084200008, 21.649222310000127],
              [100.14280684400012, 21.654906718000078],
              [100.13515873200004, 21.662348124000076],
              [100.12053430200007, 21.673665263000075],
              [100.08234541900003, 21.684465638000106],
              [99.99671757100003, 21.686119283000053],
              [99.96069909700003, 21.70477447500012],
              [99.95026045800012, 21.72115590400007],
              [99.93920170100012, 21.77701812800005],
              [99.92209680200006, 21.812261455000012],
              [99.91796268700006, 21.8291596480001],
              [99.92018477400006, 21.852000631000024],
              [99.95527307100008, 21.924554342000036],
              [99.96566003400011, 21.963001608000084],
              [99.95046716400009, 21.995351054000068],
              [99.9398218180001, 22.005893046000025],
              [99.93434411600009, 22.018863831000047],
              [99.93491255700013, 22.03250640900005],
              [99.94240564000006, 22.04552886900011],
              [99.86685469600008, 22.057879537000062],
              [99.84783776900008, 22.055037333000072],
              [99.84230839000008, 22.047027486],
              [99.84173995000003, 22.027080384000087],
              [99.83367842700005, 22.01948394800003],
              [99.82101770100007, 22.017778626000066],
              [99.81342126500004, 22.022997946000075],
              [99.80747847600003, 22.03095611600004],
              [99.79988204000006, 22.037467347000117],
              [99.73916223200007, 22.066767884000072],
              [99.72365930200004, 22.07059194000003],
              [99.70381555200004, 22.061238505000077],
              [99.69379032400013, 22.046924133000076],
              [99.68386844900004, 22.039017639000022],
              [99.66381799300007, 22.04873280900007],
              [99.65927046800005, 22.054572245000045],
              [99.65007206200005, 22.071935527000065],
              [99.64221724500004, 22.079945374000047],
              [99.63353560400009, 22.084751282000056],
              [99.53896773300005, 22.106713766000027],
              [99.50506799400006, 22.103354798000012],
              [99.49039188700004, 22.104336650000064],
              [99.43861210200009, 22.12423207600007],
              [99.42496952300007, 22.12242340100009],
              [99.36492150900006, 22.098858948],
              [99.32998824100008, 22.095551656000097],
              [99.25288700400006, 22.102786357000056],
              [99.2122693280001, 22.112449849000072],
              [99.16638065600006, 22.13208689400001],
              [99.14446984900007, 22.153532613000053],
              [99.17506229700007, 22.168673808000065],
              [99.15935266100013, 22.184693502000115],
              [99.16638065600006, 22.204640605000023],
              [99.1993502200001, 22.245258281000062],
              [99.20617150900006, 22.261329651000025],
              [99.21836714700004, 22.310008851000063],
              [99.22570520000005, 22.321222637000105],
              [99.24368859900005, 22.34122141600004],
              [99.2483394780001, 22.353675435000028],
              [99.24637577300007, 22.365922750000053],
              [99.24058801300009, 22.372950745000068],
              [99.23738407400003, 22.38013376900001],
              [99.24306848200007, 22.39315623000006],
              [99.28275598100004, 22.411914775000056],
              [99.3450777590001, 22.472841288],
              [99.35344934100004, 22.484106751000056],
              [99.35779016200013, 22.495475566000053],
              [99.35634322100003, 22.50617258700005],
              [99.34662805200003, 22.523070781000044],
              [99.34414758300005, 22.533251038000017],
              [99.34704146400003, 22.55335317000008],
              [99.35737675000013, 22.587097881000048],
              [99.35499963400008, 22.60854360000006],
              [99.30787072800007, 22.719596252000045],
              [99.30797408000012, 22.745176087000104],
              [99.31696578000003, 22.754116109000037],
              [99.32719771300003, 22.76049814900007],
              [99.33846317600006, 22.764916484000068],
              [99.3506588140001, 22.76814626100004],
              [99.3590303960001, 22.77489003500007],
              [99.37887414600004, 22.813233948000075],
              [99.40357548100008, 22.841061707000065],
              [99.41442753200005, 22.856900533000058],
              [99.416908, 22.874341330000092],
              [99.41122359200006, 22.919248149000097],
              [99.41339400300006, 22.930746155000023],
              [99.42993046000004, 22.936740622000045],
              [99.48450077400008, 22.910256450000063],
              [99.51529992700006, 22.90880951000007],
              [99.53803755700011, 22.92643117300004],
              [99.53462691200008, 22.949323832000076],
              [99.49876346900004, 22.99516082800004],
              [99.49039188700004, 23.0120073450001],
              [99.49163212100012, 23.028207906000105],
              [99.49504276500005, 23.043478292000046],
              [99.49307906100012, 23.057379252000132],
              [99.47819624900006, 23.0657508340001],
              [99.40326542100007, 23.068334656],
              [99.38104455600006, 23.08164133800001],
              [99.35096887200007, 23.11926178000003],
              [99.33381229700012, 23.129622904000044],
              [99.31407189900006, 23.126470642000086],
              [99.30218632100014, 23.112595520000028],
              [99.29402144400012, 23.096782532000034],
              [99.28482303900012, 23.088152568000098],
              [99.26673628800012, 23.08386342400003],
              [99.25743452900008, 23.07921254500006],
              [99.23614384000007, 23.062314352000058],
              [99.22487837700004, 23.056888327000095],
              [99.21661014900008, 23.057379252000132],
              [99.20958215400009, 23.061539206000063],
              [99.20214074800003, 23.067275289000023],
              [99.19966027900006, 23.073838196000096],
              [99.1993502200001, 23.09226084400011],
              [99.1941825770001, 23.09577484200007],
              [99.18488081900006, 23.0948446660001],
              [99.18271040800005, 23.095206401],
              [99.17867964700008, 23.09642079700005],
              [99.16400354000007, 23.09768687000009],
              [99.1386820890001, 23.105205790000028],
              [99.13000044800003, 23.10623931900001],
              [99.09217329900008, 23.101510926000017],
              [99.0749133710001, 23.10166595500006],
              [99.05506962100009, 23.109598287000026],
              [99.0392566330001, 23.127142436000085],
              [99.03315881300006, 23.146417745000022],
              [99.02644087800013, 23.160447897000026],
              [99.00938765500007, 23.162153218000086],
              [98.99037072800013, 23.160034485000025],
              [98.9707336840001, 23.162204895000016],
              [98.93342330000013, 23.172152608000104],
              [98.85900923700012, 23.179387309000063],
              [98.86014611800005, 23.212279358000032],
              [98.91068566900009, 23.297597148000094],
              [98.89652632700012, 23.323280335000064],
              [98.86045617700012, 23.322375997000037],
              [98.85342818200007, 23.3248823040001],
              [98.85322147600004, 23.334985047000046],
              [98.86210982300008, 23.340591940000067],
              [98.87378869600013, 23.344571025000064],
              [98.88185022000005, 23.34968699200006],
              [98.89011844900006, 23.3679029340001],
              [98.89228886000006, 23.386894023000067],
              [98.88960168400013, 23.406789449000073],
              [98.87554569500003, 23.44642527300003],
              [98.86397017400009, 23.46660491900012],
              [98.84888065700005, 23.480402527000066],
              [98.83007043500004, 23.480014954000055],
              [98.80981327300003, 23.474098002000048],
              [98.7999947510001, 23.48073842400005],
              [98.78087447100006, 23.532854106000016],
              [98.78438846900013, 23.54703928700006],
              [98.7962740480001, 23.557917175000043],
              [98.84329960100007, 23.5840137740001],
              [98.85022424400012, 23.590628357000114],
              [98.85735559100004, 23.604348450000046],
              [98.85601200400009, 23.610007020000083],
              [98.84960412600009, 23.614735413000076],
              [98.80795292200003, 23.67579111800005],
              [98.80030481000006, 23.69271514900005],
              [98.79906457500005, 23.743228862000066],
              [98.79317346200003, 23.758473409000104],
              [98.77787723800009, 23.76929962100006],
              [98.73839644400005, 23.77555247000005],
              [98.70832076000005, 23.78469919800004],
              [98.68496301300013, 23.784802551000084],
              [98.67566125500008, 23.787386373000075],
              [98.66367232300013, 23.796946513000066],
              [98.66356897000003, 23.803070171000044],
              [98.66832320200012, 23.808702902000064],
              [98.67142378700004, 23.816738587000046],
              [98.66418908700007, 23.89037750200005],
              [98.66480920400005, 23.9033741250001],
              [98.67297408100006, 23.928308004000073],
              [98.6745243740001, 23.936886292000096],
              [98.6657393800001, 23.953216045000133],
              [98.65881473800005, 23.961122539000073],
              [98.66325891200012, 23.969545797000066],
              [98.67989872200008, 23.976263733000096],
              [98.69922570900007, 23.981560568000035],
              [98.71679569500009, 23.988407695],
              [98.76557824800005, 24.02706166600008],
              [98.85621871000006, 24.083802388000024],
              [98.87347863800005, 24.11449819000005],
              [98.86696740800011, 24.143256124000075],
              [98.86572717300004, 24.145684917000025],
              [98.85528853400012, 24.13896698000009],
              [98.8180815020001, 24.12896759100009],
              [98.7161755780001, 24.12134531700012],
              [98.68175907400007, 24.106875916],
              [98.64041792900014, 24.100752258000014],
              [98.61251265500005, 24.087548930000125],
              [98.59711307800006, 24.083078919000016],
              [98.58522749900004, 24.075715027000015],
              [98.57024133400006, 24.08209706600006],
              [98.54305953000005, 24.093956807000083],
              [98.50326867700005, 24.121267802000077],
              [98.47453658000006, 24.127830709000065],
              [98.43495243300009, 24.130259501000026],
              [98.39557499200009, 24.128063253000036],
              [98.37872847500012, 24.122404684000102],
              [98.3473092050001, 24.10493804900007],
              [98.33066939300005, 24.099486186000078],
              [98.2932556560001, 24.10013214100006],
              [98.21915165200005, 24.117366231000048],
              [98.18153120900013, 24.118658142000086],
              [98.10505009000008, 24.101527405000027],
              [97.88997277800013, 24.022617493],
              [97.87664025900011, 24.014400940000044],
              [97.83633264200006, 23.971767883000084],
              [97.81783247900012, 23.95815114400007],
              [97.8040865480001, 23.954507955000068],
              [97.78951379400013, 23.95313853],
              [97.76780969300012, 23.946472270000086],
              [97.74817264900008, 23.93406992600002],
              [97.69680627400004, 23.887121887000077],
              [97.67696252500014, 23.878698629000084],
              [97.65567183400009, 23.87254913300002],
              [97.64734483100005, 23.868524415000067],
              [97.63706831900004, 23.86355743500006],
              [97.62466597500003, 23.846710918],
              [97.61970503700007, 23.865986226000032],
              [97.61546757000013, 23.875132955000097],
              [97.60988651500003, 23.88314280200008],
              [97.5726794840001, 23.907559916000125],
              [97.53299198400003, 23.92370880200012],
              [97.51645552600013, 23.942829081000113],
              [97.70765832500007, 24.12529856400009],
              [97.72006066900008, 24.1474419150001],
              [97.72305790200005, 24.171264751000066],
              [97.71871708200007, 24.181548361000083],
              [97.70455774000004, 24.19924753800008],
              [97.70156050600013, 24.210926412000063],
              [97.70466109300008, 24.221726786000076],
              [97.71117232300003, 24.228470561000037],
              [97.71851037600004, 24.233974101000015],
              [97.72409143100003, 24.241518860000056],
              [97.71840702300011, 24.277666524],
              [97.64450972500003, 24.302393698000103],
              [97.63820520100012, 24.328102722],
              [97.65360477700011, 24.338722229000084],
              [97.67427535100012, 24.340840963000048],
              [97.68957157400007, 24.346473694000068],
              [97.68833134000005, 24.36771270800004],
              [97.68099328600005, 24.377763774000087],
              [97.66259647700014, 24.390062765000025],
              [97.65732548000011, 24.402000020000074],
              [97.6554651290001, 24.412076925000108],
              [97.65226119000005, 24.422722270000108],
              [97.6473002520001, 24.432334086000097],
              [97.6398588460001, 24.439284567000087],
              [97.62435591600007, 24.442281799000014],
              [97.60068811000014, 24.44192006400003],
              [97.51955611200009, 24.430783794],
              [97.51325158700007, 24.438586935],
              [97.51387170400005, 24.46168629900008],
              [97.53857303900003, 24.597259420000015],
              [97.53278527800006, 24.723324077000072],
              [97.53609257000005, 24.745028178000084],
              [97.5361959230001, 24.745079854],
              [97.60399540200012, 24.78644683900002],
              [97.6425460210001, 24.816780904000055],
              [97.66394006400003, 24.829777527000104],
              [97.68595422400011, 24.833524068000102],
              [97.72657190000012, 24.826289368000047],
              [97.74848270700011, 24.826470235],
              [97.76522587100004, 24.834660950000043],
              [97.77297733600005, 24.85468556800008],
              [97.76098840300006, 24.870291850000015],
              [97.72409143100003, 24.897215272000025],
              [97.70827844300004, 24.927290955],
              [97.70331750500003, 24.960415548000086],
              [97.70517785700014, 25.02883514400007],
              [97.69959680200009, 25.065008647000113],
              [97.7036275640001, 25.073922831000047],
              [97.72161096200006, 25.079271342000098],
              [97.73752730300009, 25.090510967000043],
              [97.7540637620001, 25.11355865500009],
              [97.77700809800012, 25.15862050400004],
              [97.80098596300013, 25.237633769000112],
              [97.82362023900009, 25.26161163300013],
              [97.86031050700007, 25.244093323000058],
              [97.87178267400009, 25.227660217],
              [97.87881066900007, 25.213552551000063],
              [97.88893925000013, 25.205646057000124],
              [97.90991988100006, 25.20755808500006],
              [97.93079716000011, 25.218513489000102],
              [97.97627242100009, 25.27225697900012],
              [97.99239546700005, 25.28248891200009],
              [98.03352990700012, 25.301299134000104],
              [98.04489872300013, 25.311944479000104],
              [98.06257206300012, 25.35431915300002],
              [98.0756978760001, 25.376074932000037],
              [98.08996057100006, 25.385945129],
              [98.10835738100008, 25.388890686000096],
              [98.11207808500006, 25.396228739000023],
              [98.11021773300007, 25.410439759000056],
              [98.11197473100003, 25.448473613000104],
              [98.10887414600012, 25.458240459000066],
              [98.10474003100006, 25.466973775000028],
              [98.09946903500003, 25.493328756],
              [98.09977909300005, 25.50004669200011],
              [98.10463667800013, 25.506764628000056],
              [98.12303348900014, 25.522215882000054],
              [98.13419559800008, 25.534618225000102],
              [98.13936324100007, 25.550224508000056],
              [98.13843306500013, 25.598955384000092],
              [98.1400867110001, 25.611461080000097],
              [98.15021529100005, 25.613063050000036],
              [98.23238081900007, 25.586553040000027],
              [98.24716027900007, 25.579163310000112],
              [98.2766158450001, 25.552446594000045],
              [98.28943160000006, 25.550379538000087],
              [98.31206587700012, 25.55745920800011],
              [98.3326330970001, 25.566967672000104],
              [98.34710249800003, 25.577819723000047],
              [98.35723107900009, 25.592754212],
              [98.36984012900012, 25.636782532000055],
              [98.37521447800009, 25.649288229000078],
              [98.41324833200008, 25.69207631400009],
              [98.41634891800004, 25.700189514],
              [98.41665897600012, 25.712591859000057],
              [98.41872603400009, 25.724219056000024],
              [98.42472050000003, 25.730833639000124],
              [98.43226525900008, 25.736104635000046],
              [98.43929325400006, 25.7435977170001],
              [98.45262577300008, 25.777962545000022],
              [98.46130741400009, 25.79465403300007],
              [98.47453658000006, 25.80576446500008],
              [98.49810103400006, 25.830724183000072],
              [98.50946984900003, 25.838062236000056],
              [98.52683313100005, 25.838785706000053],
              [98.53954553200003, 25.833721415000085],
              [98.56238651600012, 25.816358135000073],
              [98.59091190600009, 25.806384583000053],
              [98.60031701600013, 25.801733704000085],
              [98.61003218700006, 25.800596822000088],
              [98.62605188000003, 25.806487936000067],
              [98.6778316650001, 25.843281555000075],
              [98.68485966000003, 25.853100078000054],
              [98.69023400900005, 25.86555409700013],
              [98.69240441900007, 25.87898997100008],
              [98.68982059800004, 25.8915990200001],
              [98.68465295400006, 25.897593486000048],
              [98.67235396300009, 25.90183095400009],
              [98.66728967300003, 25.905758362000043],
              [98.65809126800013, 25.925033671000094],
              [98.62532841000012, 25.969992168000104],
              [98.61623335800004, 25.979397278000064],
              [98.6042444260001, 25.982497864],
              [98.59246219900007, 25.98074086500013],
              [98.5824369720001, 25.98229115900004],
              [98.57540897700005, 25.99510691300013],
              [98.57716597500013, 26.01732778000006],
              [98.5726184500001, 26.035569560000013],
              [98.5538082280001, 26.071071269000058],
              [98.54729699800004, 26.088279521000047],
              [98.54553999900003, 26.105642803000066],
              [98.55019087800008, 26.12078399700006],
              [98.5630066330001, 26.131222636000118],
              [98.60217736800013, 26.13995595300007],
              [98.61933394400012, 26.145743714000062],
              [98.62574182200012, 26.144348450000066],
              [98.62429488100014, 26.108485006000038],
              [98.63080611200013, 26.096909485000097],
              [98.64444869000005, 26.097891337000064],
              [98.68082889800013, 26.12496978800003],
              [98.68672001200008, 26.133238017000068],
              [98.68651330600005, 26.15411529600003],
              [98.69240441900007, 26.159954732000116],
              [98.70025923700007, 26.16532908200007],
              [98.7055302330001, 26.174940898000088],
              [98.70149947100003, 26.191167298],
              [98.67700484200009, 26.239329733000076],
              [98.66821984900008, 26.248218079000097],
              [98.64816939300005, 26.244807434000066],
              [98.6421749270001, 26.25452260400003],
              [98.64455204300003, 26.271575827000035],
              [98.64951298000011, 26.290592753000013],
              [98.65778120900006, 26.31162506100013],
              [98.6976754150001, 26.35405141200006],
              [98.70739058400011, 26.371052959000068],
              [98.7134884030001, 26.389449768000063],
              [98.7172091060001, 26.408725077000028],
              [98.72113651600006, 26.538898011000086],
              [98.72795780400003, 26.57259104500004],
              [98.74852502400012, 26.6059740190001],
              [98.7555530190001, 26.625042623000084],
              [98.75069543500007, 26.646126607000028],
              [98.74707808400012, 26.655738424000035],
              [98.74676802600004, 26.664420064000083],
              [98.74738814300008, 26.672688293000036],
              [98.74645796800013, 26.681059876000106],
              [98.73198856700003, 26.71351267500002],
              [98.73436568300014, 26.73428660100008],
              [98.74924849500007, 26.77144195600006],
              [98.75038537600011, 26.792009176000064],
              [98.74242720500013, 26.81040598600005],
              [98.71813928200004, 26.842497050000063],
              [98.71452193200008, 26.862030741000083],
              [98.71865604700008, 26.872676087000073],
              [98.73312544800012, 26.88792063400011],
              [98.73632938600008, 26.89825592100003],
              [98.73570927000003, 26.907299296000062],
              [98.71266158100008, 26.995149231000042],
              [98.72061975100013, 27.013959452000066],
              [98.73167850700003, 27.031064352],
              [98.73777632600007, 27.048686015],
              [98.73136844900006, 27.068788147000063],
              [98.71648563700012, 27.082482402000082],
              [98.70273970500006, 27.086823222000064],
              [98.69137089100008, 27.092404276000067],
              [98.68268925000012, 27.110077617000073],
              [98.67256066900006, 27.17560333200008],
              [98.67359419800005, 27.207901103000054],
              [98.68020878100003, 27.237046611000082],
              [98.70418664600004, 27.304174296000028],
              [98.70770064400011, 27.337247213000083],
              [98.69736535700008, 27.368924866],
              [98.69106083200006, 27.373162334000043],
              [98.6837227790001, 27.37362742200007],
              [98.67731490100005, 27.376107890000057],
              [98.67442102100006, 27.3865982060001],
              [98.66832320200012, 27.475249126000094],
              [98.67111372900007, 27.516151022000102],
              [98.68175907400007, 27.55648447700007],
              [98.67927860500009, 27.57733591800003],
              [98.67421431500003, 27.586120911000123],
              [98.6657393800001, 27.597076315],
              [98.65592085800006, 27.60676564500004],
              [98.6472392170001, 27.611726583000078],
              [98.63504357900007, 27.611054789],
              [98.62584517500005, 27.6055512490001],
              [98.61654341700006, 27.59841990200006],
              [98.60455448400006, 27.59273549400011],
              [98.5784062090001, 27.59172780400003],
              [98.56435022000005, 27.603535869000055],
              [98.54336958800008, 27.642525737000042],
              [98.5221822520001, 27.656297506000087],
              [98.4923132730001, 27.643430074],
              [98.47453658000006, 27.65717600500004],
              [98.42224003100006, 27.680895487000058],
              [98.4102510990001, 27.68425445600009],
              [98.40001916500012, 27.675727844000065],
              [98.3974353430001, 27.656814270000027],
              [98.39815881400011, 27.619813945000075],
              [98.39288781700009, 27.587154440000106],
              [98.38327600100007, 27.55578684500007],
              [98.36394901500012, 27.532170716000067],
              [98.32860233600007, 27.52286895700003],
              [98.29470259600009, 27.536614889000063],
              [98.27568566900004, 27.570101217000072],
              [98.25439497900004, 27.648132629000074],
              [98.23806522600012, 27.680223694000077],
              [98.20437219300004, 27.727300924000062],
              [98.20178837100013, 27.736551005000095],
              [98.21150354000008, 27.760322164000044],
              [98.20840295400006, 27.766161601000036],
              [98.20209842900005, 27.7712517290001],
              [98.1978609620001, 27.780631002000078],
              [98.19848107900003, 27.800448914000057],
              [98.20065148900005, 27.813600565000016],
              [98.19662072800003, 27.823186544000023],
              [98.16241092900003, 27.842849427000075],
              [98.14577111900013, 27.860729472000045],
              [98.1400867110001, 27.878557841000074],
              [98.1567265220001, 27.889203187000064],
              [98.17667362500003, 27.898117371000083],
              [98.17729374200007, 27.91292266900011],
              [98.16582157400006, 27.92969167100007],
              [98.14897505700009, 27.944548645000012],
              [98.11352502500006, 27.96170522100006],
              [98.10711714700011, 27.973074036000057],
              [98.11848596200014, 27.99472646100004],
              [98.12251672400004, 28.015448710000058],
              [98.1279944260001, 28.105469056000018],
              [98.12696089700012, 28.124279277000042],
              [98.11869266800005, 28.140789897000033],
              [98.1150022760001, 28.14388835700008],
              [98.04861942600013, 28.199623515000027],
              [98.03135949800003, 28.208330994000065],
              [97.9910518800001, 28.214015401000026],
              [97.98485070800012, 28.2242214970001],
              [97.99384240800003, 28.25254018200009],
              [97.9929122320001, 28.26892161100004],
              [97.97875288900013, 28.280600484],
              [97.9447497970001, 28.29884226500006],
              [97.8975175380001, 28.35532460500012],
              [97.85907027200005, 28.370129903000034],
              [97.79726525900003, 28.34392995200001],
              [97.76532922400008, 28.352430725000133],
              [97.74000777200007, 28.38260976200003],
              [97.69959680200009, 28.48802968300008],
              [97.67045129400009, 28.511284079000077],
              [97.6410990810001, 28.498364970000083],
              [97.61360721800003, 28.481983541000133],
              [97.58993941300008, 28.49469594300008],
              [97.56751184100011, 28.525495097000046],
              [97.54622115100011, 28.53846588100008],
              [97.52772098800011, 28.52952585900006],
              [97.51397505800009, 28.49469594300008],
              [97.50301965300008, 28.47772023600008],
              [97.48813684100003, 28.44193430600005],
              [97.47459761600004, 28.426198832000082],
              [97.47149703000014, 28.414959209000116],
              [97.46570927000005, 28.40669097900006],
              [97.45010298700004, 28.39191152000005],
              [97.44534875500011, 28.382971497000128],
              [97.4467956950001, 28.374005636000092],
              [97.45020634000014, 28.364858907],
              [97.45237674900005, 28.355479635000066],
              [97.45237674900005, 28.317678324000084],
              [97.44782922400009, 28.29760203100004],
              [97.43666711400004, 28.286414083000082],
              [97.41672001200004, 28.286052348000098],
              [97.3982198490001, 28.28889455200006],
              [97.38437056500004, 28.284837952000075],
              [97.3778593350001, 28.26359893900009],
              [97.36959110600003, 28.25347035700004],
              [97.33383101400011, 28.235254415],
              [97.32349572800013, 28.217477723000073],
              [97.2852551680001, 28.235667827],
              [97.22965132700011, 28.274606018000085],
              [97.22076298000007, 28.28339101200008],
              [97.21053104700013, 28.308092346000066],
              [97.20277958200012, 28.31155466700004],
              [97.19327111900003, 28.311399638000083],
              [97.18272912600008, 28.31499115000007],
              [97.11554976400004, 28.366564230000066],
              [97.07844608600004, 28.3751425170001],
              [97.03297082600005, 28.357029928000074],
              [96.9974174400001, 28.337082825000053],
              [96.96579146400012, 28.330468242000066],
              [96.93395878200005, 28.336617737000026],
              [96.89788863200005, 28.354704489000042],
              [96.71692392905247, 28.436539447625634],
              [96.60442611830537, 28.444534241434948],
              [96.5615177204665, 28.44729288316006],
              [96.51238244700005, 28.428808492000073],
              [96.49522587100006, 28.42147043900009],
              [96.44112658162652, 28.39541577691665],
              [96.36964414401973, 28.378115826943503],
              [96.30185249373439, 28.420710938634112],
              [96.33645875408492, 28.47966681390912],
              [96.40901887262294, 28.558928647938785],
              [96.50237514126326, 28.644476217418358],
              [96.50104350465409, 28.687631303142155],
              [96.59800971353144, 28.709910398443995],
              [96.59258426900004, 28.757884013000094],
              [96.57666792800006, 28.808526917000066],
              [96.52375126100003, 28.864414979000045],
              [96.51083215400013, 28.885524801000074],
              [96.50039351400005, 28.929243062000054],
              [96.49222863800003, 28.94800160700005],
              [96.47465865100008, 28.962057597000054],
              [96.46008589700011, 28.963349507000103],
              [96.45212772700006, 28.970377502000034],
              [96.45119755100012, 28.98138458300012],
              [96.45760542900013, 28.99458791100001],
              [96.36656829155606, 29.036536563468914],
              [96.29465549772947, 28.99232448388489],
              [96.24858762565306, 28.945343306324006],
              [96.19532275757172, 28.941105845485463],
              [96.17595371463305, 29.017353609711428],
              [96.17462528500005, 29.108844503000043],
              [96.1835136310001, 29.123778992000027],
              [96.19364221300003, 29.13693064400009],
              [96.21007531700008, 29.145767314000082],
              [96.31642541500008, 29.171863912000063],
              [96.32748417200008, 29.180442200000087],
              [96.34236698400014, 29.21064707500001],
              [96.36686161300008, 29.24421091700013],
              [96.36624149600004, 29.257233379000056],
              [96.34991174300006, 29.274234924],
              [96.33709598900009, 29.27971262700008],
              [96.32324670400004, 29.275010071000096],
              [96.30412642400006, 29.261212464000053],
              [96.26784956900008, 29.24173044900006],
              [96.23529341600005, 29.241213684000016],
              [96.20542443800014, 29.256949158000097],
              [96.17627893100013, 29.28645640100011],
              [96.16604699800013, 29.303173726000054],
              [96.15095747900011, 29.35407501200008],
              [96.14196578000008, 29.368466899000097],
              [96.07453626532634, 29.369285607240855],
              [96.01413548284108, 29.364252208700393],
              [95.95373470035588, 29.35921881015993],
              [95.86313352662813, 29.32398502037684],
              [95.79594038900007, 29.352886455000046],
              [95.77640669800007, 29.345548401000073],
              [95.74478072100004, 29.340432435000068],
              [95.7473653601981, 29.27365103497256],
              [95.71716496895556, 29.218283651027733],
              [95.64669738938943, 29.22835044810863],
              [95.59233524600006, 29.249688619000025],
              [95.58168990100006, 29.24746653300012],
              [95.57290490800006, 29.247259827000065],
              [95.56442997300007, 29.2456061810001],
              [95.55378462800007, 29.239043275000128],
              [95.55068404100012, 29.230284119000046],
              [95.55202762800008, 29.220129700000072],
              [95.55016727700007, 29.212481588000017],
              [95.51533736200014, 29.209432679000074],
              [95.51192671700011, 29.19754709900006],
              [95.52267541500004, 29.161192729000064],
              [95.52143518100007, 29.13786082000003],
              [95.51130660000013, 29.131788839000095],
              [95.48757683710141, 29.068994487006023],
              [95.42982403198397, 29.046524645630395],
              [95.36740605062847, 29.03649616327051],
              [95.2815531820001, 29.052672221000094],
              [95.22491581200012, 29.05936431900001],
              [95.21633752500009, 29.06499705000003],
              [95.21406376100009, 29.07308441200003],
              [95.21282352700013, 29.08186940500012],
              [95.2078625900001, 29.089595032000105],
              [95.19969771300003, 29.094245911000073],
              [95.19153283800006, 29.096829733000092],
              [95.11691206900008, 29.108095195000047],
              [95.09903202400011, 29.113779603000083],
              [95.04766564900007, 29.140806377000033],
              [94.98906457600003, 29.15398386700012],
              [94.89129276600005, 29.160495097000094],
              [94.85408573500007, 29.17000356000007],
              [94.81543176300005, 29.16886667900006],
              [94.79879195200004, 29.1664378870001],
              [94.77657108500011, 29.16669626900007],
              [94.76148156800008, 29.174706116000053],
              [94.76768273900007, 29.21385101300008],
              [94.75641727800013, 29.230516663000017],
              [94.70422408000013, 29.284699402000044],
              [94.66846399000013, 29.306610209000084],
              [94.6304301350001, 29.319451803000064],
              [94.59994104000009, 29.316635437000016],
              [94.5826811120001, 29.302915345000073],
              [94.52862756400003, 29.2312401330001],
              [94.51477828000009, 29.22105987600004],
              [94.49824182200007, 29.21522043900005],
              [94.47498742700003, 29.210802104000052],
              [94.42238081900007, 29.210492045000066],
              [94.39643925000013, 29.207081400000035],
              [94.37287479700012, 29.19630686500001],
              [94.36253951000009, 29.185325623000026],
              [94.34631311100009, 29.1590739950001],
              [94.33577111900013, 29.149617208000038],
              [94.32378218600007, 29.146025696000052],
              [94.28750533100003, 29.147937724000073],
              [94.27078578096348, 29.097929973215642],
              [94.30904814105469, 29.059667613124404],
              [94.34731050114596, 29.024348511501685],
              [94.29138859024334, 28.977256376004746],
              [94.2501829716835, 28.933107498976327],
              [94.17365825150097, 28.930164240507835],
              [94.1353958914097, 28.897788397353693],
              [94.07947398050715, 28.883072105010925],
              [94.02684940600011, 28.864182435000075],
              [94.01144982900013, 28.85302032500003],
              [93.99201949100012, 28.844648743000064],
              [93.99313607399837, 28.80188742309345],
              [93.9815905577272, 28.768130860141966],
              [93.96109345404737, 28.72994349590268],
              [93.92778566056765, 28.68275160171495],
              [93.86307969177443, 28.704870831024095],
              [93.78174379684887, 28.68050383781251],
              [93.72247522000009, 28.696647441000053],
              [93.70552535000007, 28.69189320900007],
              [93.66490848182954, 28.690238755807428],
              [93.64341027900008, 28.680240174000105],
              [93.62553023300006, 28.67235951800005],
              [93.60713342300005, 28.672204488000105],
              [93.55173628800009, 28.67894826200005],
              [93.44621301300003, 28.671894430000023],
              [93.35543239724171, 28.624065359777703],
              [93.31717003715039, 28.603462550497838],
              [93.30284340070244, 28.556921073348917],
              [93.2869721652333, 28.520517242676647],
              [93.25906765301328, 28.496023260000364],
              [93.21883846222534, 28.457435846387227],
              [93.1862858334245, 28.431995228097378],
              [93.21807344565363, 28.39464655767386],
              [93.20782489381371, 28.340539283245555],
              [93.12982812476821, 28.325961566073488],
              [93.04639880818196, 28.302097099545048],
              [92.97492395000006, 28.28230580700007],
              [92.96035119600003, 28.270213521000088],
              [92.92200728300008, 28.25863800100005],
              [92.90381717900004, 28.2496979780001],
              [92.88955448400009, 28.23582285600004],
              [92.8653699140001, 28.20520457000002],
              [92.85028039600013, 28.19194956500003],
              [92.8347774660001, 28.183526306000132],
              [92.81989465400005, 28.17926300100008],
              [92.80532190000008, 28.17802276700003],
              [92.79023238100007, 28.178901266000068],
              [92.78537479700009, 28.183293762000076],
              [92.78289432800011, 28.190941874000046],
              [92.77917362500011, 28.195902812],
              [92.7700785720001, 28.192182108000097],
              [92.70786014900011, 28.155414328000106],
              [92.67861128800007, 28.133064270000105],
              [92.65484012900009, 28.105830790000127],
              [92.63727014200003, 28.071982728000123],
              [92.63892378800006, 28.057487488000092],
              [92.65422001100012, 28.052087301000128],
              [92.68925663200014, 28.048314921],
              [92.70134891800006, 28.037824606000058],
              [92.70134891800006, 28.025241394000133],
              [92.73639150917766, 27.98590893651867],
              [92.71077012957788, 27.949702392409918],
              [92.68367428669768, 27.910450219011963],
              [92.63646812873851, 27.89536981004999],
              [92.59291178341888, 27.868193283595886],
              [92.57497681769904, 27.847806414432647],
              [92.51815087726021, 27.839468002981643],
              [92.47510949800005, 27.846595968000074],
              [92.43903934800005, 27.823289897000066],
              [92.42756717900005, 27.82117116400009],
              [92.41733524600005, 27.828948466],
              [92.40441613800004, 27.85383066900006],
              [92.39284061800004, 27.85602691700005],
              [92.38105839100012, 27.842461853000074],
              [92.37558068800013, 27.821119487000075],
              [92.36793257700003, 27.80383372000007],
              [92.35005253100007, 27.802541809000033],
              [92.33982059800013, 27.815564270000053],
              [92.33465295400003, 27.83127390600002],
              [92.32917525300013, 27.832927552000072],
              [92.31728967300006, 27.80367869100003],
              [92.30385380100006, 27.786160380000055],
              [92.28876428200005, 27.793085022000056],
              [92.27522505700006, 27.81168853700011],
              [92.25827518700004, 27.848197937000023],
              [92.24918013500007, 27.862641500000038],
              [92.23956831900006, 27.865276998000056],
              [92.1262935790001, 27.81272206600009],
              [92.10615954418942, 27.786080717238843],
              [92.06487820550117, 27.76172129397611],
              [91.98889765320416, 27.76939841380579],
              [91.96800093766346, 27.746278233869482],
              [91.95224735500011, 27.724820455],
              [91.90873579900006, 27.731900126000127],
              [91.86491418500009, 27.72998809800002],
              [91.85637335954294, 27.764539482011514],
              [91.82658872441321, 27.807627271770244],
              [91.72987134422583, 27.804136158001306],
              [91.68013149075769, 27.849823277598603],
              [91.6283394780001, 27.852693787000035],
              [91.6371244710001, 27.87724009300011],
              [91.64890669800008, 27.897213033000057],
              [91.65283410700005, 27.91674672500004],
              [91.63795129500011, 27.93974273700009],
              [91.62172489400012, 27.950723979000074],
              [91.6006409100001, 27.959276429000013],
              [91.57862675000007, 27.96470245400009],
              [91.53749231000012, 27.969353333000058],
              [91.49749475100003, 27.98408111600004],
              [91.4609078370001, 27.98436533600004],
              [91.44643843600005, 27.986354879000075],
              [91.43648287100012, 27.989375107000015],
              [91.41884322100009, 27.99472646100004],
              [91.34143192600004, 28.03056406700007],
              [91.3095992430001, 28.056402283000082],
              [91.29016890500003, 28.0914130660001],
              [91.26970503800004, 28.072861227000075],
              [91.24614058500003, 28.071465963],
              [91.2206124270001, 28.07487660700012],
              [91.19467085800005, 28.07058746400004],
              [91.17586063600004, 28.057487488000092],
              [91.13379602000003, 28.01410512300002],
              [91.11963667900005, 27.994881490000083],
              [91.11942997200003, 27.99472646100004],
              [91.09255822800003, 27.97167877200006],
              [91.05194055200008, 27.96279042600007],
              [91.00884240800008, 27.966769512000056],
              [90.97514937400013, 27.982091573],
              [90.96057662000004, 27.99472646100004],
              [90.90952030400007, 28.032656963000036],
              [90.85091923100009, 28.044025777000044],
              [90.78870080600007, 28.047488098000073],
              [90.75527753600005, 28.055173215000096],
              [90.7268957930001, 28.06169911800005],
              [90.6839010010001, 28.087072245000044],
              [90.66746789600012, 28.090327860000016],
              [90.65103479000004, 28.086994731000104],
              [90.62188928300003, 28.0729645790001],
              [90.59739465400008, 28.07058746400004],
              [90.57527714000008, 28.06583323200006],
              [90.51006148300007, 28.074101461000012],
              [90.49259484900011, 28.074411519000094],
              [90.4752315670001, 28.07234446300002],
              [90.48566935150171, 28.12465735277827],
              [90.51529856561535, 28.154286566892026],
              [90.54821991463052, 28.157578701793526],
              [90.56797272403975, 28.19050005080878],
              [90.59760193815339, 28.200376455513336],
              [90.58772553344886, 28.233297804528476],
              [90.54821991463052, 28.246466344134532],
              [90.50542216091083, 28.249758479036117],
              [90.45604013738802, 28.282679828051258],
              [90.41653451856979, 28.282679828051258],
              [90.38690530445604, 28.2991405025589],
              [90.35398395544087, 28.2991405025589],
              [90.32950402800009, 28.25579579700006],
              [90.29147017500009, 28.261351014000084],
              [90.2618041781983, 28.2991405025589],
              [90.2618041781983, 28.335353986475624],
              [90.22559069428155, 28.358398930786237],
              [90.1992536150695, 28.34852252608168],
              [90.1762086707588, 28.325477581771068],
              [90.15316372644816, 28.322185446869483],
              [90.12353451233452, 28.335353986475624],
              [90.07086035391018, 28.34523039118018],
              [89.99045495700005, 28.32062388100009],
              [89.97159305900004, 28.318040060000087],
              [89.95252445500006, 28.30824737600004],
              [89.91613001353875, 28.31560117706651],
              [89.88131433100011, 28.29752451600011],
              [89.87361454300003, 28.300599263000052],
              [89.86291752100004, 28.295793356000033],
              [89.85402917500011, 28.28726674400012],
              [89.83862959800013, 28.267913921000073],
              [89.82974125100003, 28.259154765000076],
              [89.79604821800007, 28.240189515000054],
              [89.78085534700011, 28.228769023000027],
              [89.77362064600004, 28.21277516700009],
              [89.75584395400011, 28.184378967000058],
              [89.71781010000007, 28.169082744000022],
              [89.59781742400008, 28.149807434000067],
              [89.57942061400007, 28.144639791000074],
              [89.56148889100012, 28.134640401000055],
              [89.51503177900008, 28.081904602000023],
              [89.49534305900005, 28.06800364200005],
              [89.47534428000012, 28.061337382000133],
              [89.45880782100011, 28.04779815700006],
              [89.44454512600004, 28.031184184000054],
              [89.42118737800007, 27.99472646100004],
              [89.42098067200004, 27.99472646100004],
              [89.41736367800007, 27.988654027000038],
              [89.37013106300003, 27.90935699500004],
              [89.33602461800007, 27.8690752160001],
              [89.29948938000013, 27.844244690000053],
              [89.25871667500007, 27.827553203000022],
              [89.22492028800008, 27.807812806000058],
              [89.21659020133723, 27.77114152368786],
              [89.19820315021519, 27.730581852095057],
              [89.15602109175876, 27.665686377546805],
              [89.1273589238333, 27.627289888438966],
              [89.12465494572706, 27.614851589150547],
              [89.11948401016275, 27.61820054938572],
              [89.10956515172722, 27.62225826420017],
              [89.1058645948479, 27.62295211861509],
              [89.10235143650146, 27.623610835805025],
              [89.09153086366274, 27.62586512181302],
              [89.06402857436444, 27.615946263377637],
              [89.05095371551772, 27.60828169095022],
              [89.0396822854774, 27.594305117700188],
              [89.03337028465484, 27.57897597284547],
              [89.01623771099366, 27.57581997243416],
              [89.00271199494523, 27.560490827579358],
              [89.00496628095334, 27.549670254740633],
              [88.99279313650976, 27.53749711029714],
              [88.97836570605818, 27.53028339507135],
              [88.97295541963888, 27.517659393426257],
              [88.97520970564693, 27.506838820587532],
              [88.98004625332288, 27.497980380569217],
              [88.98296649296316, 27.49263177875116],
              [88.96620182870481, 27.478030296977792],
              [88.95754909876507, 27.456939267749547],
              [88.95105955131027, 27.433144260415148],
              [88.96401118394226, 27.392923642327176],
              [88.98117510746783, 27.35463488984705],
              [88.99701872918376, 27.33086945727318],
              [88.97193299480028, 27.312385231937938],
              [88.95080816584573, 27.32822885365387],
              [88.91516001698494, 27.33086945727318],
              [88.89233077000011, 27.315543111000082],
              [88.86463220200005, 27.332389628000087],
              [88.85202315300006, 27.342363180000078],
              [88.8308358160001, 27.36732289600006],
              [88.8198287350001, 27.37362742200007],
              [88.80820153800005, 27.378381653000062],
              [88.79538578300009, 27.385926412000018],
              [88.77357832900003, 27.408509013000057],
              [88.75978072200007, 27.435070699000065],
              [88.75435469600012, 27.464216207000092],
              [88.75719689900006, 27.49496368400004],
              [88.75755863400008, 27.511448466000033],
              [88.74164229300004, 27.531679789000023],
              [88.7410221770001, 27.545709941000027],
              [88.74815352400003, 27.560127666000042],
              [88.76737715600007, 27.586198425000035],
              [88.78308679200012, 27.622036031000064],
              [88.80566939300007, 27.655108948000063],
              [88.85388350400007, 27.843676249000097],
              [88.85507206300008, 27.859179179000094],
              [88.85155806500012, 27.877162577],
              [88.84277307100012, 27.892407125000133],
              [88.81889856000004, 27.91519643200003],
              [88.81068200700014, 27.927857158000066],
              [88.80975183200007, 27.9444969690001],
              [88.81967370600006, 27.977337342000013],
              [88.81771000200013, 27.99472646100004],
              [88.81771000200013, 27.994881490000083],
              [88.8175032960001, 27.994881490000083],
              [88.80293054200013, 28.011004537000062],
              [88.78014123500003, 28.028341980000064],
              [88.73564782700004, 28.055265402000074],
              [88.7101196700001, 28.061983337000115],
              [88.65203536000013, 28.069398906000018],
              [88.63167484600007, 28.083351542000017],
              [88.61048750800012, 28.105830790000127],
              [88.59400272600004, 28.106605937000026],
              [88.55281660900005, 28.078054708000067],
              [88.53080245000007, 28.0590119430001],
              [88.5171598720001, 28.039581604000105],
              [88.50207035300008, 28.02888458300002],
              [88.47540531400011, 28.036248474000033],
              [88.45576827000008, 28.03152008100004],
              [88.39990604700012, 27.994881490000083],
              [88.39985437100012, 27.99472646100004],
              [88.39975101800007, 27.99472646100004],
              [88.37877038600004, 27.982634176000047],
              [88.19785119700003, 27.95829457600003],
              [88.17485518400008, 27.94976796500002],
              [88.16296960500006, 27.946899923000032],
              [88.15118737800003, 27.947209982000018],
              [88.12669274900009, 27.950439759000105],
              [88.11573734600012, 27.947261658000045],
              [88.09992435700008, 27.928322246000093],
              [88.09749556500003, 27.904008484000073],
              [88.10488529500003, 27.8797205610001],
              [88.11821781400005, 27.860884501000058],
              [88.09573856600008, 27.86532867500007],
              [88.05279545100012, 27.88651601100004],
              [88.02995446800008, 27.893337301000074],
              [88.01812056500006, 27.892148743000078],
              [87.99181726100005, 27.882640280000075],
              [87.9784330650001, 27.880521545000093],
              [87.96639245600011, 27.8827436320001],
              [87.9452051190001, 27.892303772],
              [87.93455977400009, 27.895301006000025],
              [87.85611495000006, 27.898608297000024],
              [87.83668461200006, 27.908323467000073],
              [87.82588423700014, 27.906566467000076],
              [87.81415368700004, 27.890960185000054],
              [87.79865075700013, 27.863468323000077],
              [87.77984053500012, 27.839438782000045],
              [87.75637943500004, 27.82037017900005],
              [87.72682051600003, 27.807761129000042],
              [87.70046553600008, 27.80564239500005],
              [87.67852882500011, 27.813351022000077],
              [87.65995121300006, 27.819879252000035],
              [87.63607670100009, 27.82365163200005],
              [87.62109053600011, 27.81954335600004],
              [87.58998132300013, 27.804608867000084],
              [87.57334151200013, 27.805022278000095],
              [87.56507328300006, 27.810861715000087],
              [87.55980228700014, 27.819078268000013],
              [87.5559782310001, 27.827088115],
              [87.55132735200004, 27.83189402300009],
              [87.53158695500008, 27.836803284000027],
              [87.51453373200013, 27.835201314000088],
              [87.47556970200009, 27.82670054200007],
              [87.38678959100014, 27.804402161000027],
              [87.36911625200014, 27.803937073],
              [87.36911625200014, 27.819078268000013],
              [87.38069177200009, 27.83582143200006],
              [87.38534265100003, 27.849412334000064],
              [87.36384525500011, 27.855251770000038],
              [87.33583662900008, 27.846363424000018],
              [87.31392582200004, 27.8285867310001],
              [87.29051639800008, 27.816081035000096],
              [87.23289717600005, 27.829723613000013],
              [87.18199589000011, 27.82450429300009],
              [87.15579593900009, 27.825796204000042],
              [87.11652185100013, 27.84458058700004],
              [87.06200321500012, 27.9084268190001],
              [87.03053226700013, 27.938089091000037],
              [87.0056759040001, 27.951499126],
              [86.98872603400008, 27.952480978000054],
              [86.98209267100003, 27.950674405000072],
              [86.97022587100014, 27.947442525],
              [86.94035689300006, 27.943101705000018],
              [86.91472538200009, 27.945117086000053],
              [86.89307295800012, 27.954186300000018],
              [86.87689823400012, 27.970645243],
              [86.86816491700012, 27.99472646100004],
              [86.86816491700012, 27.994881490000083],
              [86.84046634900011, 28.014776917000077],
              [86.76997969600006, 28.01208974300006],
              [86.73980065900014, 28.02149485300002],
              [86.7322042240001, 28.03495656300008],
              [86.73597660400003, 28.064851380000093],
              [86.73173913600004, 28.07691782600007],
              [86.71768314700006, 28.088260804000058],
              [86.69964807100013, 28.098751119],
              [86.68006270300003, 28.105727437],
              [86.66197595200009, 28.106838481000082],
              [86.64947025600003, 28.101179911000074],
              [86.62714603700005, 28.08348073300006],
              [86.6123149010001, 28.080276794000085],
              [86.59686364700013, 28.086503805000078],
              [86.58311771700005, 28.098027649000088],
              [86.56952681500007, 28.106605937000026],
              [86.55355879700005, 28.104151306000077],
              [86.54415368700006, 28.09301503600004],
              [86.54125980600003, 28.078209738000012],
              [86.54074304200009, 28.06216420600005],
              [86.53836592600004, 28.047178040000077],
              [86.5309245200001, 28.03369049100003],
              [86.52229455600013, 28.02371694000003],
              [86.51619673700009, 28.012244771],
              [86.51645511900006, 27.99472646100004],
              [86.51676433500006, 27.971432200000024],
              [86.51046065300005, 27.952429301000038],
              [86.49692142700007, 27.937882385000094],
              [86.47547570800003, 27.927598775],
              [86.43883711700005, 27.91085561100006],
              [86.42529789200012, 27.909925435],
              [86.40571252400008, 27.917005107000122],
              [86.37196781400013, 27.941964824000095],
              [86.36297611500004, 27.946098938000105],
              [86.35367435800003, 27.944807028000085],
              [86.34561283400006, 27.940931295000027],
              [86.33755131000004, 27.93803741500004],
              [86.3277327880001, 27.93969106100009],
              [86.31822432400003, 27.945788880000052],
              [86.29465987200012, 27.97237640400006],
              [86.27807173600007, 27.98369354300003],
              [86.25900313300014, 27.987646790000028],
              [86.23853926600003, 27.98955881800005],
              [86.21838545700007, 27.99472646100004],
              [86.21792037000006, 27.99493316600008],
              [86.21776534000003, 27.99498484300001],
              [86.20303755700013, 28.00258127900007],
              [86.19600956200009, 28.01457021100002],
              [86.18913659700013, 28.043612366000033],
              [86.18185022000006, 28.054877828000073],
              [86.17446049000006, 28.062448425000028],
              [86.17223840400004, 28.071827698000092],
              [86.18076501500008, 28.088751729000094],
              [86.18717289300008, 28.108698832000087],
              [86.18603601100011, 28.133529358000047],
              [86.17601078300004, 28.15301137300004],
              [86.1559603280001, 28.156525371],
              [86.06873050900003, 28.07676279700003],
              [86.07017745000013, 28.066711731000098],
              [86.0815462650001, 28.0516997270001],
              [86.08469852700006, 28.04387074800009],
              [86.08392338100003, 28.038548076000055],
              [86.07953088400006, 28.021649882000062],
              [86.07953088400006, 28.013329977000083],
              [86.07761885600013, 28.00694793700005],
              [86.07916914900005, 28.001134339000075],
              [86.08929772900012, 27.994881490000083],
              [86.08940108300004, 27.994881490000083],
              [86.08940108300004, 27.99472646100004],
              [86.09813439900012, 27.985631409000078],
              [86.09803104700006, 27.977518209000053],
              [86.09508549000009, 27.968888245000116],
              [86.09560225500013, 27.957855326000114],
              [86.10056319200004, 27.950233053000048],
              [86.10717777500008, 27.9442385870001],
              [86.11224206500003, 27.93726226900013],
              [86.11286218300012, 27.926797791000084],
              [86.10717777500008, 27.922844544],
              [86.07565515100009, 27.894784241000067],
              [86.06170251500009, 27.889048157000033],
              [86.05459969400005, 27.888013072],
              [86.0514189050001, 27.887549540000023],
              [86.02645918800005, 27.88992665600007],
              [85.98026045800009, 27.88517242400006],
              [85.9626904700001, 27.891373596000065],
              [85.95121830300008, 27.916229961000013],
              [85.95183841900007, 27.936797181000102],
              [85.95628259300008, 27.956873474000062],
              [85.95659265100005, 27.9762262980001],
              [85.94398360200012, 27.99472646100004],
              [85.9089469810001, 28.022425029000075],
              [85.8983016360001, 28.03601593000006],
              [85.89044681900009, 28.059192810000056],
              [85.88982670100012, 28.071259257000023],
              [85.89106693500014, 28.080896912000057],
              [85.88910323100004, 28.090276184000103],
              [85.87173995000006, 28.110920919000094],
              [85.86703739500012, 28.13293508],
              [85.86336836800012, 28.14334788000012],
              [85.84827885000004, 28.158928325000048],
              [85.82688480700011, 28.170478007],
              [85.78275313300003, 28.188099671000074],
              [85.7566048590001, 28.203240866],
              [85.7344873450001, 28.221534323000057],
              [85.71557377100004, 28.243367615000082],
              [85.69976078300004, 28.269102478],
              [85.6980037840001, 28.31344085700003],
              [85.69293949400003, 28.33522247300006],
              [85.67914188700007, 28.332897034000027],
              [85.67598962500011, 28.32473215800009],
              [85.67619633000004, 28.315120341000082],
              [85.67505944900006, 28.306387024000017],
              [85.66813480600007, 28.30054758800013],
              [85.6469474700001, 28.293700460000068],
              [85.6390926520001, 28.287886862000093],
              [85.61180749500005, 28.251144918000094],
              [85.59894006300004, 28.25083486000004],
              [85.58550419100004, 28.263185526000072],
              [85.56529870600014, 28.27538116400008],
              [85.54369795800005, 28.28039377900005],
              [85.5206502690001, 28.282925924000054],
              [85.49755090300005, 28.282615865000068],
              [85.47569177300011, 28.279101868000012],
              [85.4466496170001, 28.29215016700006],
              [85.43156010000007, 28.297059428000082],
              [85.41523034700003, 28.2964393110001],
              [85.40138106300009, 28.288791199000045],
              [85.37781661000008, 28.265976054000035],
              [85.36257206200014, 28.259671529000016],
              [85.3453638100001, 28.261247660000052],
              [85.33482181800008, 28.268689067000068],
              [85.32572676600006, 28.277396546000134],
              [85.31260095200008, 28.282770895000098],
              [85.30102543200013, 28.28106557200003],
              [85.27312015800004, 28.269825949000094],
              [85.25958093300005, 28.266932068000088],
              [85.24340620900006, 28.267913921000073],
              [85.22392419500005, 28.2716863000001],
              [85.20573409100012, 28.278275045000086],
              [85.1735913490001, 28.30431996600005],
              [85.15457442200005, 28.30085764600001],
              [85.13416223200011, 28.291969300000105],
              [85.10940922100008, 28.292253520000074],
              [85.08739506100005, 28.304113261000097],
              [85.08021203600003, 28.318789368000083],
              [85.0818671020001, 28.331702005000082],
              [85.08568973800004, 28.361525777000097],
              [85.08568973800004, 28.38100779200009],
              [85.07757653800013, 28.435681457000058],
              [85.08367435700006, 28.44552581800012],
              [85.10946089700008, 28.45929758700005],
              [85.11555871600012, 28.4727334600001],
              [85.11566206800006, 28.491492005000012],
              [85.11721236200009, 28.4973314410001],
              [85.1231551510001, 28.504591980000058],
              [85.14036340400008, 28.510922343000075],
              [85.14764978100004, 28.515831604000127],
              [85.15374760000003, 28.52490081800009],
              [85.1569515380001, 28.533143209000045],
              [85.16801029400006, 28.583191833000043],
              [85.16098230000006, 28.59499989900003],
              [85.11188968900012, 28.6088233440001],
              [85.07504439300004, 28.6316643280001],
              [85.05494226100006, 28.63869232200001],
              [85.03210127800014, 28.634067281000043],
              [85.02527998900013, 28.62840871200011],
              [85.01876875900012, 28.619856262],
              [85.00915694200012, 28.60254465700008],
              [85.00249068200003, 28.594431458000074],
              [84.99406742400004, 28.5908141070001],
              [84.9847656660001, 28.588592021000082],
              [84.95494836400007, 28.57430348700011],
              [84.94895389800007, 28.568283183000077],
              [84.93644820200007, 28.544770406000097],
              [84.92849003100008, 28.53846588100008],
              [84.91872318600014, 28.535675354000105],
              [84.90787113500011, 28.537018942000074],
              [84.89143802900003, 28.541773173000067],
              [84.87929406700005, 28.54363352400007],
              [84.82394860900007, 28.540532939000045],
              [84.81195967600013, 28.54197987900004],
              [84.79914392100005, 28.54663075800009],
              [84.78178064000014, 28.558903910000126],
              [84.75563236500005, 28.58541392100004],
              [84.73661543800006, 28.594173075000114],
              [84.69083011900005, 28.596136780000037],
              [84.67775598100008, 28.604405009000075],
              [84.68297530100011, 28.65075876900009],
              [84.67114139800009, 28.658949483000114],
              [84.65227950100007, 28.66238596600006],
              [84.63264245600004, 28.668793844000092],
              [84.62582116700008, 28.676080221000078],
              [84.61620935100007, 28.693650207000033],
              [84.6072176510001, 28.69819773400006],
              [84.55182051600008, 28.7063884490001],
              [84.53197676600007, 28.712692973000017],
              [84.51564701300003, 28.721400452000083],
              [84.49859379100008, 28.72786000600003],
              [84.4757528080001, 28.727291565000073],
              [84.45084476800014, 28.73388031000006],
              [84.43782230700009, 28.753336487000055],
              [84.42273278800008, 28.79917348300002],
              [84.41430953000008, 28.808268534],
              [84.39307051600014, 28.82433990500006],
              [84.37658573500005, 28.848834534],
              [84.36630212500006, 28.85674102800006],
              [84.3540031330001, 28.861288554000097],
              [84.28599694900004, 28.873742574000076],
              [84.23514733900004, 28.900020040000115],
              [84.2252905100001, 28.914115306],
              [84.20672530100012, 28.940663554000068],
              [84.2314266360001, 29.025981343000026],
              [84.22057458500007, 29.03890045200005],
              [84.19819869000008, 29.045308329000093],
              [84.17546106000009, 29.05740061400006],
              [84.16972497600005, 29.08892323900004],
              [84.16621097900008, 29.098457540000126],
              [84.16011316000004, 29.105485535000028],
              [84.13799564600004, 29.124657492000054],
              [84.13225956200006, 29.143803609000045],
              [84.14171634900003, 29.160262554000028],
              [84.15520389800008, 29.175946351000093],
              [84.16166345300007, 29.19253448500008],
              [84.15546228100004, 29.206642151000025],
              [84.14197473200011, 29.208269959000077],
              [84.12600671400008, 29.2062545780001],
              [84.11236413600005, 29.20909678200009],
              [84.10533614100007, 29.219922994000044],
              [84.09913496900009, 29.247001445000095],
              [84.08972985800011, 29.256613261],
              [84.07205651900011, 29.256974996000096],
              [84.05303959200006, 29.25036041300011],
              [84.0352112220001, 29.24762156200005],
              [84.02151696800007, 29.25976552300007],
              [84.01252526900004, 29.270204163000088],
              [84.00089807100005, 29.27252960200012],
              [83.98823734600012, 29.269532369],
              [83.97583500200005, 29.263744609000028],
              [83.97325118100008, 29.277025452000046],
              [83.96725671400003, 29.284699402000044],
              [83.9579549560001, 29.289040222000025],
              [83.94555261300013, 29.291830750000074],
              [83.93315026800008, 29.291779073000058],
              [83.91439172400004, 29.28940195700001],
              [83.88343754100003, 29.282012228],
              [83.87739139900003, 29.276767070000076],
              [83.86886478700012, 29.263434550000042],
              [83.86163008600005, 29.26020477300007],
              [83.83785892700007, 29.254003601000093],
              [83.79321049000004, 29.23475413100006],
              [83.77062788900008, 29.232247824000083],
              [83.74535811400006, 29.234469910000072],
              [83.71972660300008, 29.233591411000035],
              [83.6954903570001, 29.22617584200013],
              [83.67507816600005, 29.208760885000103],
              [83.66774011200005, 29.192327780000127],
              [83.66339929300005, 29.174809469000067],
              [83.65600956200007, 29.160779318000053],
              [83.65499238900003, 29.160413575000078],
              [83.63926639800013, 29.15475901300003],
              [83.62443526200008, 29.155456645000115],
              [83.58381758700006, 29.16214874300003],
              [83.57203536000003, 29.168401592000023],
              [83.56139001500003, 29.176230570000072],
              [83.53596521000003, 29.179227804000064],
              [83.52371789500012, 29.183594462000073],
              [83.51705163600008, 29.19170766200007],
              [83.51457116700004, 29.201810405000018],
              [83.51250410900008, 29.223488668000087],
              [83.50299564700009, 29.26103159600011],
              [83.49338383000008, 29.276146952000104],
              [83.47581384300008, 29.28692148900005],
              [83.44821862800012, 29.29676584900001],
              [83.4372115480001, 29.30524078400002],
              [83.42816817300007, 29.33345611600008],
              [83.41778120900005, 29.340897523000095],
              [83.40501713000009, 29.3464785770001],
              [83.39313155100012, 29.35624542300006],
              [83.38827396600004, 29.37022389700006],
              [83.38941084800013, 29.382445374],
              [83.38724043800005, 29.393504130000096],
              [83.35700972500013, 29.415363261000024],
              [83.35520105000012, 29.427972310000072],
              [83.35778487100004, 29.44275177100006],
              [83.35520105000012, 29.460735168000056],
              [83.32796757000006, 29.48502309200005],
              [83.26394047000014, 29.47300832100008],
              [83.24719730600009, 29.49473826100011],
              [83.24874760000012, 29.506572164000104],
              [83.25401859500005, 29.513290101000038],
              [83.25990970900006, 29.518767802000028],
              [83.26332035400009, 29.52708770800008],
              [83.26083988500011, 29.542048035000064],
              [83.25257165600004, 29.555199687000126],
              [83.22931726100012, 29.575947774000056],
              [83.22187585400007, 29.579823507000114],
              [83.2049259850001, 29.58491363600011],
              [83.19717452000009, 29.58909942700005],
              [83.19448734600007, 29.59364695300006],
              [83.19086999600006, 29.606901957000062],
              [83.18725264500011, 29.612095439000072],
              [83.17355839100009, 29.62126800500009],
              [83.16208622200014, 29.625169576000033],
              [83.15004561400008, 29.62563466400006],
              [83.12668786600005, 29.623412577000053],
              [83.10028120900006, 29.617676493000104],
              [83.09335656700006, 29.615144349000033],
              [83.08844730700014, 29.604421488000085],
              [83.08555342600005, 29.59039133800009],
              [83.07955896000004, 29.579642640000074],
              [83.06493453000007, 29.57878997800013],
              [83.05449589000011, 29.586050517],
              [83.04090498800014, 29.610286764000094],
              [83.03289514200009, 29.620467021000067],
              [82.9758960370001, 29.664030253000092],
              [82.96432051600004, 29.665890605000087],
              [82.9420996500001, 29.6629450490001],
              [82.93191939300004, 29.664185283000037],
              [82.92370284000009, 29.669662984000027],
              [82.90913008600012, 29.684623312],
              [82.89972497600007, 29.688421529000024],
              [82.88008793200004, 29.68110931400004],
              [82.8574536540001, 29.666200664000073],
              [82.83657637600004, 29.65979278600004],
              [82.82236535700014, 29.67795705200008],
              [82.81554406800012, 29.690126851000073],
              [82.80515710500009, 29.695966289000083],
              [82.7930648200001, 29.699506124000052],
              [82.78107588700004, 29.705113017000073],
              [82.77012048400007, 29.71415639300001],
              [82.75151696800003, 29.73932281500005],
              [82.69095218900003, 29.780741476000017],
              [82.68175378500007, 29.797717183000103],
              [82.68464766500006, 29.809706116000072],
              [82.68919519100007, 29.81957631400006],
              [82.68898848500004, 29.827741191000072],
              [82.67730961100006, 29.834407451000075],
              [82.66697432500013, 29.83502756700007],
              [82.64640710500004, 29.82934316100001],
              [82.63586511200009, 29.829033101000036],
              [82.61850183100006, 29.839833476000067],
              [82.54181400500005, 29.923239238000022],
              [82.52424401900004, 29.932385966000098],
              [82.47582320100008, 29.945511780000075],
              [82.4570646570001, 29.9540900680001],
              [82.43892622900006, 29.965768942000082],
              [82.4228548590001, 29.979669902000055],
              [82.40978072100006, 29.99460439100001],
              [82.39443282100007, 30.00313100200013],
              [82.37913659700013, 30.00323435500006],
              [82.36373702000003, 30.001167298],
              [82.34730391400007, 30.003441061000032],
              [82.33908736200004, 30.009228821000093],
              [82.32715010600009, 30.025713603000057],
              [82.31888187700014, 30.031811422000132],
              [82.2965059820001, 30.036824036],
              [82.27599043800012, 30.036927388000024],
              [82.25573327600011, 30.039666240000074],
              [82.21067142800007, 30.064419251000075],
              [82.19217126400014, 30.06147369400007],
              [82.17423954300006, 30.055479228000067],
              [82.15382735200012, 30.058166402],
              [82.14452559400007, 30.069431865000055],
              [82.13522383600014, 30.08974070200007],
              [82.12871260600008, 30.110773010000074],
              [82.1275757250001, 30.124363912000078],
              [82.15098514800013, 30.162242737000057],
              [82.15568770300013, 30.181363017000066],
              [82.14039148000006, 30.194023743000102],
              [82.11424320500004, 30.202188619000125],
              [82.09589807100008, 30.21345408200007],
              [82.0849943450001, 30.2308173630001],
              [82.08210046400012, 30.25732737300011],
              [82.09321089700006, 30.31473988900011],
              [82.08876672400004, 30.330087789000075],
              [82.07321211800013, 30.337219137000105],
              [82.04985437000005, 30.339234518000055],
              [82.00763472500006, 30.336805726000094],
              [81.99817793800014, 30.33406687500006],
              [81.98846276900008, 30.329777731],
              [81.97885095300006, 30.326832174000074],
              [81.96903243000008, 30.32827911400007],
              [81.96210778900013, 30.333653463000033],
              [81.95011885600007, 30.348381246000045],
              [81.94123050900004, 30.353962301000067],
              [81.92149011200007, 30.35737294600007],
              [81.88717696200007, 30.35499583000005],
              [81.84438887500005, 30.371170553000027],
              [81.82278812700008, 30.368173320000025],
              [81.80149743700008, 30.36130035400005],
              [81.77901818800007, 30.35804473900008],
              [81.7573657640001, 30.362902324000075],
              [81.63571944200004, 30.410961406000055],
              [81.61401534000004, 30.416904195000072],
              [81.59158776800007, 30.414268697000054],
              [81.58507653800007, 30.408119202000066],
              [81.58197595200005, 30.399437561000113],
              [81.57670495600007, 30.390962626000103],
              [81.56326908400007, 30.385588277000053],
              [81.54425215700007, 30.38264272100004],
              [81.53681075100008, 30.378560283000056],
              [81.53195316600005, 30.370343730000016],
              [81.52068770400007, 30.33194814000008],
              [81.5093705650001, 30.328382467000026],
              [81.48306726100009, 30.331896464000053],
              [81.46281010000007, 30.34135325100003],
              [81.4261198320001, 30.372514140000092],
              [81.40741296400012, 30.37918040000001],
              [81.38751753800011, 30.37390940300007],
              [81.3848820400001, 30.360938619000066],
              [81.38725915500004, 30.345125631000045],
              [81.38214318800004, 30.3312763470001],
              [81.37154952000009, 30.3169102990001],
              [81.36803552300012, 30.30104563400009],
              [81.36901737500006, 30.26606068900007],
              [81.3705159910001, 30.257275696000093],
              [81.37692386900011, 30.241204325000027],
              [81.37785404500005, 30.232626038],
              [81.37439172400013, 30.223117574000113],
              [81.36183435100014, 30.20477244100003],
              [81.35728682500007, 30.173559876000056],
              [81.35005212400011, 30.157230123000105],
              [81.33826989700003, 30.143535868000086],
              [81.3224052330001, 30.133769023000028],
              [81.30953780200008, 30.132063701000064],
              [81.29325972600009, 30.132838847000087],
              [81.27770511900007, 30.131856995000092],
              [81.26695642100003, 30.125087382000075],
              [81.26633630400005, 30.117749329000063],
              [81.27450118000007, 30.10219472300004],
              [81.27594812100006, 30.09537343300009],
              [81.27202071100004, 30.07992218],
              [81.2679026460001, 30.07205300500003],
              [81.2668013920001, 30.06994862900008],
              [81.25708622300004, 30.063540752000037],
              [81.2395162360001, 30.058786520000055],
              [81.22571862800004, 30.050466614000086],
              [81.22726892100007, 30.022457987000095],
              [81.21683028200005, 30.008195292000025],
              [81.19450606300006, 30.004474589],
              [81.14810062700013, 30.02323313400008],
              [81.12458785000007, 30.02276804700007],
              [81.09776778200006, 30.01692860900009],
              [81.08484867400006, 30.026178690000094],
              [81.08445364600004, 30.027875774000094],
              [81.07420332800007, 30.071912334000032],
              [81.06660689300008, 30.08715688100007],
              [81.04366255800005, 30.12022979700005],
              [81.0308984780001, 30.152734274000082],
              [81.01942631000009, 30.172267965000074],
              [81.00650720200008, 30.188907776000107],
              [80.99601688700011, 30.19696930000002],
              [81.00330326400012, 30.212730611000083],
              [80.99627526900008, 30.226889954000043],
              [80.97601810700007, 30.255208638000042],
              [80.94377201300011, 30.270143128000072],
              [80.86698083500005, 30.28848826100007],
              [80.78166304500007, 30.320992737],
              [80.76719364400003, 30.331431376000026],
              [80.75499800600005, 30.345797425000043],
              [80.73536096200007, 30.378198547000054],
              [80.72306197200004, 30.392047832000102],
              [80.69474328600006, 30.41173655200005],
              [80.59635136000003, 30.45979563500002],
              [80.57526737500012, 30.466255188000062],
              [80.55997115100007, 30.465118306000065],
              [80.54508833800008, 30.461035869000042],
              [80.52514123600008, 30.458607076000092],
              [80.5082947190001, 30.46232777900009],
              [80.47542850700006, 30.48046620700002],
              [80.42499230900006, 30.49782948800005],
              [80.32587691200013, 30.54650868700007],
              [80.2528064380001, 30.565008851000087],
              [80.21621952300006, 30.566817526000094],
              [80.17983931500004, 30.559479472000092],
              [80.18841760200007, 30.576997783000067],
              [80.19782271300005, 30.591363831000066],
              [80.20330041600005, 30.60634999600005],
              [80.19988977100013, 30.62588368700004],
              [80.19058801300008, 30.637975973000025],
              [80.17725549300008, 30.649861552000047],
              [80.16692020700003, 30.661902161000043],
              [80.16661014800007, 30.674407858000038],
              [80.1729146730001, 30.67916208900003],
              [80.18200972500006, 30.680040589000058],
              [80.19172489400012, 30.679678853000055],
              [80.19988977100013, 30.68071238200004],
              [80.20702111900005, 30.68613840700003],
              [80.23141239400007, 30.724947408000062],
              [80.22459110500012, 30.734094137000042],
              [80.19606571500009, 30.748098450000057],
              [80.16929732200009, 30.78525380400005],
              [80.15710168400011, 30.793160299000093],
              [80.14066858000012, 30.79321197500009],
              [80.10924930900006, 30.778122458],
              [80.09219608500007, 30.774505107000024],
              [80.06253381400006, 30.784788717000097],
              [80.04444706200007, 30.80669952400008],
              [80.02863407400008, 30.830780742000016],
              [80.00558638600012, 30.847265524000093],
              [79.93489302600011, 30.872535299000063],
              [79.91936951600007, 30.88118194500005],
              [79.91463535600008, 30.88381888700009],
              [79.90316369700008, 30.89020863900005],
              [79.8804260660001, 30.912842916],
              [79.86285607900004, 30.941523336],
              [79.85035038300003, 30.954494120000035],
              [79.83350386600006, 30.96152211500005],
              [79.76064009600009, 30.977231751000105],
              [79.73903934800012, 30.979247131000065],
              [79.68849979700008, 30.96741322900003],
              [79.64819217900003, 30.965759583000093],
              [79.63031213400006, 30.962503967000103],
              [79.58948775300007, 30.94023142500005],
              [79.57780887900009, 30.938371074000045],
              [79.56592329900008, 30.942453512000057],
              [79.54421919800006, 30.947414449000107],
              [79.5296464440001, 30.953563945000084],
              [79.51269657400007, 30.966172994000104],
              [79.4976070560001, 30.981210836000074],
              [79.48820194600006, 30.99449167900009],
              [79.48685835800006, 31.00022776300004],
              [79.4842745360001, 31.005447083000078],
              [79.48076053900013, 31.01004628500003],
              [79.47641971900003, 31.014025371000102],
              [79.46164025900003, 31.02110504200003],
              [79.4463440350001, 31.023792216000047],
              [79.43073775300013, 31.023172099000092],
              [79.414408, 31.02038157100013],
              [79.40159224500013, 31.02363718700012],
              [79.3949776610001, 31.036711324000052],
              [79.38836307800011, 31.069474182000064],
              [79.38259259500006, 31.07833466600009],
              [79.37234338400009, 31.094072165000043],
              [79.3670479880583, 31.111559061766084],
              [79.31941711251294, 31.142279974197177],
              [79.30216249530298, 31.163450395319558],
              [79.30320907773682, 31.183103768324315],
              [79.29807839147153, 31.203242202430214],
              [79.28832134985049, 31.225473994629226],
              [79.2783162706794, 31.240043992036647],
              [79.2528602604927, 31.24543676949139],
              [79.24843045010522, 31.256703749478504],
              [79.26202358591979, 31.27851309060668],
              [79.25411000876994, 31.29900573432724],
              [79.2392392007286, 31.311723913427898],
              [79.23831863759511, 31.3296556045226],
              [79.20762798854088, 31.351372703987124],
              [79.19244185390846, 31.369789449823315],
              [79.17921754805144, 31.393795999286],
              [79.15769333967592, 31.414925750622956],
              [79.13139720595568, 31.438433157420082],
              [79.07799043411131, 31.461664353726974],
              [79.07021024772884, 31.461381390199218],
              [79.04993667283924, 31.422952683719416],
              [79.01552948833853, 31.383397147758455],
              [78.98880090300014, 31.34325592100005],
              [78.95955204300003, 31.325117493000036],
              [78.94028174400734, 31.301576298907094],
              [78.92100839989331, 31.269685496828163],
              [78.88697183608144, 31.28417089736905],
              [78.86198693800009, 31.291476135],
              [78.84865441900007, 31.29090769500003],
              [78.82198938000005, 31.29369822200009],
              [78.79604781100005, 31.288117167000067],
              [78.78447229000005, 31.288272197000097],
              [78.75315637200003, 31.30196645100004],
              [78.74509484900005, 31.308115947000104],
              [78.74085738200006, 31.317727763000036],
              [78.73848026600012, 31.334987691000023],
              [78.74550826100005, 31.373538310000086],
              [78.7600810140001, 31.412037252000047],
              [78.76256148300007, 31.44511016900013],
              [78.73300256300007, 31.467744446000083],
              [78.69538212100014, 31.488104961000104],
              [78.69951623500003, 31.51001576800006],
              [78.79697798700005, 31.578848775000054],
              [78.81403120900006, 31.59502349900005],
              [78.81888879400009, 31.607374166000014],
              [78.79532434100008, 31.633780823000095],
              [78.75811731000005, 31.666595358],
              [78.73982385300008, 31.666026917000053],
              [78.7313489180001, 31.668042298],
              [78.72401086500008, 31.67331329300005],
              [78.71842981000009, 31.680599671000024],
              [78.71047164000004, 31.698169658],
              [78.69806929500004, 31.71103709000009],
              [78.69321171100006, 31.71853017200003],
              [78.69259159400008, 31.728400370000102],
              [78.69517541500005, 31.737960511],
              [78.69558882600006, 31.746693827000072],
              [78.67088749200008, 31.770516663000038],
              [78.67409143000003, 31.786949768000014],
              [78.7003430580001, 31.821676331000035],
              [78.70664758300006, 31.840796611000044],
              [78.71419234300004, 31.88301625600012],
              [78.72018680900004, 31.902911682000124],
              [78.7419942630001, 31.945338033000056],
              [78.74457808500011, 31.964199931000067],
              [78.73382938700007, 31.984663798000028],
              [78.72215051300009, 31.99458567300003],
              [78.67832889800007, 32.01675486300006],
              [78.64928674300012, 32.036443583],
              [78.55182499200004, 32.15039011700007],
              [78.53497847500006, 32.18134429900006],
              [78.51306766800008, 32.2075700890001],
              [78.47648075400014, 32.22441660600008],
              [78.46901739200007, 32.226532615000096],
              [78.46854076900007, 32.22666774700009],
              [78.45798059100014, 32.229661764000085],
              [78.45632694500006, 32.24211578400009],
              [78.46139123600005, 32.26015085900009],
              [78.46273482300012, 32.28180328400008],
              [78.43886031100004, 32.37329640700004],
              [78.43596643100005, 32.377973125],
              [78.43451949100006, 32.38376088500006],
              [78.43637984200006, 32.39616322900004],
              [78.44144413200013, 32.40494822200013],
              [78.44816206900003, 32.41065846800008],
              [78.45219283000006, 32.41678212500004],
              [78.44878218600013, 32.42678151500006],
              [78.40919803900005, 32.4766234340001],
              [78.3809827070001, 32.528041484000084],
              [78.38480676200004, 32.54754933700006],
              [78.40816451000006, 32.55837555],
              [78.44754195200011, 32.566256205000045],
              [78.58985884700007, 32.569925232000045],
              [78.63016646300008, 32.57801259400004],
              [78.64773645100007, 32.58597076500011],
              [78.66489302600013, 32.59901906300006],
              [78.69445194500008, 32.629663188000066],
              [78.7132621670001, 32.637518006],
              [78.73682661900011, 32.629844056000124],
              [78.75098596200013, 32.61279083300009],
              [78.74912561100012, 32.5958668010001],
              [78.74065067600003, 32.578684387000024],
              [78.73496626800011, 32.56064931300004],
              [78.73692997300003, 32.54579233800008],
              [78.75470666500013, 32.493805847000075],
              [78.77144982900012, 32.461663106000046],
              [78.85568241400006, 32.40045237300011],
              [78.88152063000013, 32.37626780200013],
              [78.9112862550001, 32.35474456800007],
              [78.94342899600014, 32.346372986000105],
              [78.97619185400004, 32.36161753300006],
              [78.98983443200012, 32.364098003000024],
              [79.01474247300007, 32.373994039000095],
              [79.02817834500007, 32.377094626000044],
              [79.03965051300008, 32.37598358100006],
              [79.0663155520001, 32.37006663100006],
              [79.07530725100014, 32.370790100000036],
              [79.0917403570001, 32.39055633500003],
              [79.10290246600005, 32.449855042000124],
              [79.11292769400006, 32.47238596700005],
              [79.13287479700011, 32.4854601040001],
              [79.16140018800013, 32.496467184],
              [79.19116581200012, 32.504270325],
              [79.21524703000006, 32.507913513000105],
              [79.23560754400012, 32.504296163000035],
              [79.28741156145267, 32.53257939116813],
              [79.32046626650504, 32.59226722135526],
              [79.37947682579494, 32.57644972217696],
              [79.40682034478317, 32.52968335070614],
              [79.44349727169374, 32.53477259180094],
              [79.47211298523796, 32.56547177661887],
              [79.51574063362341, 32.608119744630585],
              [79.53120131304826, 32.648316794003655],
              [79.57617012539868, 32.6706463645242],
              [79.62067291506752, 32.72872513425561],
              [79.61391341067542, 32.76503545442273],
              [79.56409288128151, 32.793927891059354],
              [79.4710886681076, 32.908959488689504],
              [79.41408948759245, 32.9720529162554],
              [79.3784615590933, 32.97888079862581],
              [79.33358605900014, 32.99429209500006],
              [79.33978723100012, 33.013257345000014],
              [79.39927298712544, 33.026877543090805],
              [79.38106298759733, 33.06176785943445],
              [79.3731702070001, 33.11214019800006],
              [79.42347470306436, 33.15782502934888],
              [79.45609607657275, 33.25039903388836],
              [79.42008441515759, 33.27516911050025],
              [79.34030669939472, 33.27513188662732],
              [79.26006124250934, 33.29177628972042],
              [79.15021349475705, 33.29255492117272],
              [79.12503824122189, 33.29020260316764],
              [79.09802822725385, 33.28765466454805],
              [79.07504815721146, 33.29574255484219],
              [79.05327756453967, 33.307872984457326],
              [79.02304063027336, 33.31798038693261],
              [78.99344870739196, 33.330781826020484],
              [78.96498571648198, 33.344254148471954],
              [78.91769413200012, 33.386257833000045],
            ],
          ],
          [
            [
              [111.01050866000003, 19.68378327000005],
              [111.01636803500003, 19.67804596600007],
              [111.03467858200003, 19.642238674000055],
              [111.02035566500007, 19.635972398000035],
              [111.00912519600007, 19.641750393000052],
              [110.99333743600005, 19.643011786000045],
              [110.97730553500003, 19.640773830000057],
              [110.96583092500003, 19.635972398000035],
              [110.91358483200003, 19.583685614000046],
              [110.88770592500003, 19.550604559000078],
              [110.87647545700003, 19.53978099200009],
              [110.85865319100003, 19.534816799000055],
              [110.84278405000003, 19.539943752000056],
              [110.82984459700003, 19.552069403000075],
              [110.82178795700003, 19.56777578300006],
              [110.81853274800005, 19.591050523000035],
              [110.82569420700003, 19.603257554000038],
              [110.84115644600007, 19.607977606000077],
              [110.86264082100007, 19.608710028000075],
              [110.84766686300003, 19.62246328300006],
              [110.82642662900003, 19.62177155200004],
              [110.80632571700005, 19.61273834800005],
              [110.79444420700003, 19.601263739000046],
              [110.80355879000007, 19.589178778000075],
              [110.81299889400003, 19.563381252000056],
              [110.82178795700003, 19.55410390800006],
              [110.80738366000003, 19.530585028000075],
              [110.80250084700003, 19.517401434000078],
              [110.80062910200007, 19.495428778000075],
              [110.79623457100007, 19.48460521000004],
              [110.78549238400007, 19.471909898000035],
              [110.77230879000007, 19.46165599200009],
              [110.76026451900003, 19.457912502000056],
              [110.76026451900003, 19.451646226000037],
              [110.76449629000007, 19.44082265800006],
              [110.75757897200003, 19.430894273000035],
              [110.74512780000003, 19.422674872000073],
              [110.73243248800003, 19.416937567000048],
              [110.72437584700003, 19.415961005000042],
              [110.70622806100005, 19.41828034100007],
              [110.69825280000003, 19.416937567000048],
              [110.69499759200005, 19.411810614000046],
              [110.68580162900003, 19.393052476000037],
              [110.68148847700007, 19.38898346600007],
              [110.66968834700003, 19.381740627000056],
              [110.67066491000003, 19.365057684000078],
              [110.67603600400003, 19.34674713700008],
              [110.67790774800005, 19.334377346000053],
              [110.66602623800003, 19.31976959800005],
              [110.64136803500003, 19.312445380000042],
              [110.63672936300003, 19.296535549000055],
              [110.63266035200007, 19.264471747000073],
              [110.62159264400003, 19.23065827000005],
              [110.60629316500007, 19.19985586100006],
              [110.58904056100005, 19.176703192000048],
              [110.58033287900003, 19.155178127000056],
              [110.57585696700005, 19.157049872000073],
              [110.56861412900003, 19.16307200700004],
              [110.54908287900003, 19.15176015800006],
              [110.54444420700003, 19.150051174000055],
              [110.51010175900007, 19.150051174000055],
              [110.50220787900003, 19.153143622000073],
              [110.49691816500007, 19.159898179000038],
              [110.49048912900003, 19.166571356000077],
              [110.47917728000004, 19.169256903000075],
              [110.47917728000004, 19.16307200700004],
              [110.48975670700003, 19.15298086100006],
              [110.49756920700003, 19.141546942000048],
              [110.50733483200003, 19.13222890800006],
              [110.52418053500003, 19.12832265800006],
              [110.53565514400003, 19.13222890800006],
              [110.54151451900003, 19.138617255000042],
              [110.54623457100007, 19.139878648000035],
              [110.55494225400003, 19.12832265800006],
              [110.55681399800005, 19.120021877000056],
              [110.55494225400003, 19.08734772300005],
              [110.56234785200007, 19.102362372000073],
              [110.57545006600003, 19.150051174000055],
              [110.58228600400003, 19.150051174000055],
              [110.56999759200005, 19.100897528000075],
              [110.56723066500007, 19.065578518000052],
              [110.56324303500003, 19.05565013200004],
              [110.54753665500004, 19.040187893000052],
              [110.53077233200003, 19.018377997000073],
              [110.51807701900003, 18.993475653000075],
              [110.50993899800005, 18.96434153900009],
              [110.50709069100003, 18.93032461100006],
              [110.50806725400003, 18.92218659100007],
              [110.51238040500004, 18.91351959800005],
              [110.51335696700005, 18.906398830000057],
              [110.50912519600007, 18.897772528000075],
              [110.50001061300003, 18.895738023000035],
              [110.49089603000004, 18.895656643000052],
              [110.48658287900003, 18.89248281500005],
              [110.48389733200003, 18.887193101000037],
              [110.47771243600005, 18.885239976000037],
              [110.47046959700003, 18.88426341400009],
              [110.46558678500003, 18.88190338700008],
              [110.46314537900003, 18.875148830000057],
              [110.46127363400007, 18.856024481000077],
              [110.45875084700003, 18.84833405200004],
              [110.45435631600003, 18.84446849200009],
              [110.44109134200005, 18.836493231000077],
              [110.43458092500003, 18.83038971600007],
              [110.43148847700007, 18.821478583000044],
              [110.43580162900003, 18.814154364000046],
              [110.44190514400003, 18.808254299000055],
              [110.44507897200003, 18.803656317000048],
              [110.45093834700003, 18.80499909100007],
              [110.46501712300005, 18.804510809000078],
              [110.48080488400007, 18.80097077000005],
              [110.49284915500004, 18.793117580000057],
              [110.50082441500007, 18.80292389500005],
              [110.50245201900003, 18.81122467700004],
              [110.49968509200005, 18.837551174000055],
              [110.49341881600003, 18.862616278000075],
              [110.49366295700003, 18.87604401200008],
              [110.50342858200003, 18.88190338700008],
              [110.51002037900003, 18.86859772300005],
              [110.53443444100003, 18.785630601000037],
              [110.51905358200003, 18.78310781500005],
              [110.50717207100007, 18.78351471600007],
              [110.49854576900003, 18.781642971000053],
              [110.49284915500004, 18.772040106000077],
              [110.48658287900003, 18.772040106000077],
              [110.46900475400003, 18.777167059000078],
              [110.45036868600005, 18.75653717700004],
              [110.42457116000003, 18.70376211100006],
              [110.43100019600007, 18.69245026200008],
              [110.42676842500003, 18.680894273000035],
              [110.41602623800003, 18.67055898600006],
              [110.40349368600005, 18.66278717700004],
              [110.38868248800003, 18.675034898000092],
              [110.34449303500003, 18.664618231000077],
              [110.33521569100003, 18.67332591400009],
              [110.34538821700005, 18.680853583000044],
              [110.36866295700003, 18.685939846000053],
              [110.41089928500003, 18.69013092700004],
              [110.41089928500003, 18.69749583500004],
              [110.40349368600005, 18.70376211100006],
              [110.39722741000003, 18.70376211100006],
              [110.38013756600003, 18.69049713700008],
              [110.32732181100005, 18.679348049000055],
              [110.30787194100003, 18.66278717700004],
              [110.30103600400003, 18.66278717700004],
              [110.27084394600007, 18.66815827000005],
              [110.22722415500004, 18.64215729400007],
              [110.15699303500003, 18.58079661700009],
              [110.12110436300003, 18.555812893000052],
              [110.10328209700003, 18.53937409100007],
              [110.08814537900003, 18.504339911000045],
              [110.07064863400007, 18.502020575000074],
              [110.03419030000003, 18.51194896000004],
              [110.03419030000003, 18.50576406500005],
              [110.04615319100003, 18.495917059000078],
              [110.07406660200007, 18.489081122000073],
              [110.08253014400003, 18.477769273000092],
              [110.08130944100003, 18.464544989000046],
              [110.06983483200003, 18.426988023000092],
              [110.06820722700007, 18.40892161700009],
              [110.06137129000007, 18.40892161700009],
              [110.06072024800005, 18.42959219000005],
              [110.05323326900003, 18.440619208000044],
              [110.04460696700005, 18.44013092700004],
              [110.04029381600003, 18.42597077000005],
              [110.04444420700003, 18.411363023000092],
              [110.05111738400007, 18.399644273000092],
              [110.05258222700007, 18.39020416900007],
              [110.04029381600003, 18.38226959800005],
              [110.02621504000007, 18.380601304000038],
              [109.99512780000003, 18.38231028900009],
              [109.96859785200007, 18.389837958000044],
              [109.96859785200007, 18.405503648000092],
              [109.97592207100007, 18.406642971000053],
              [109.98707116000003, 18.403998114000046],
              [110.00033613400007, 18.40302155200004],
              [110.01368248800003, 18.40892161700009],
              [110.01986738400007, 18.417669989000046],
              [110.02344811300003, 18.429388739000046],
              [110.02393639400003, 18.441229559000078],
              [110.02051842500003, 18.450506903000075],
              [110.01734459700003, 18.444973049000055],
              [110.00928795700003, 18.434800523000092],
              [110.00619550900007, 18.429388739000046],
              [110.00318444100003, 18.43357982000009],
              [109.99252363400007, 18.443060614000046],
              [109.99236087300005, 18.43964264500005],
              [109.99284915500004, 18.432766018000052],
              [109.99252363400007, 18.429388739000046],
              [109.98194420700003, 18.435492255000042],
              [109.97738691500007, 18.431463934000078],
              [109.97364342500003, 18.423081773000092],
              [109.96517988400007, 18.41632721600007],
              [109.95801842500003, 18.41437409100007],
              [109.95411217500003, 18.41425202000005],
              [109.94874108200003, 18.415228583000044],
              [109.91537519600007, 18.416815497000073],
              [109.89828535200007, 18.41425202000005],
              [109.88209069100003, 18.407538153000075],
              [109.83545983200003, 18.38226959800005],
              [109.82520592500003, 18.385891018000052],
              [109.82154381600003, 18.39166901200008],
              [109.81959069100003, 18.397772528000075],
              [109.81446373800003, 18.402085679000038],
              [109.79566491000003, 18.405178127000056],
              [109.77621504000007, 18.404038804000038],
              [109.75904381600003, 18.40037669500009],
              [109.74610436300003, 18.39590078300006],
              [109.75001061300003, 18.373602606000077],
              [109.72657311300003, 18.30377838700008],
              [109.73178144600007, 18.27301666900007],
              [109.71778405000003, 18.273098049000055],
              [109.71338951900003, 18.279852606000077],
              [109.71159915500004, 18.287990627000056],
              [109.70460045700003, 18.292222398000092],
              [109.69678795700003, 18.289862372000073],
              [109.67042076900003, 18.27301666900007],
              [109.67042076900003, 18.265570380000042],
              [109.68620853000004, 18.267645575000074],
              [109.69402103000004, 18.26715729400007],
              [109.71192467500003, 18.258734442000048],
              [109.71778405000003, 18.25844961100006],
              [109.73454837300005, 18.25999583500004],
              [109.73926842500003, 18.258734442000048],
              [109.74146569100003, 18.250799872000073],
              [109.73853600400003, 18.24323151200008],
              [109.73178144600007, 18.234198309000078],
              [109.72803795700003, 18.224676825000074],
              [109.71900475400003, 18.21482982000009],
              [109.70875084700003, 18.20722077000005],
              [109.70118248800003, 18.20408763200004],
              [109.69068444100003, 18.20917389500005],
              [109.68433678500003, 18.221136786000045],
              [109.67725670700003, 18.245062567000048],
              [109.66374759200005, 18.237616278000075],
              [109.62907962300005, 18.227362372000073],
              [109.62191816500007, 18.220851955000057],
              [109.61915123800003, 18.217271226000037],
              [109.60613040500004, 18.20888906500005],
              [109.60206139400003, 18.20408763200004],
              [109.60352623800003, 18.19879791900007],
              [109.61304772200003, 18.18305084800005],
              [109.61573326900003, 18.176174221000053],
              [109.60132897200003, 18.18121979400007],
              [109.58765709700003, 18.181586005000042],
              [109.57601972700007, 18.177476304000038],
              [109.56804446700005, 18.16933828300006],
              [109.56120853000004, 18.16933828300006],
              [109.56251061300003, 18.176988023000092],
              [109.56804446700005, 18.193182684000078],
              [109.56576582100007, 18.20136139500005],
              [109.56120853000004, 18.20579661700009],
              [109.55648847700007, 18.20921458500004],
              [109.55445397200003, 18.214056708000044],
              [109.55323326900003, 18.217678127000056],
              [109.54859459700003, 18.217678127000056],
              [109.54761803500003, 18.220851955000057],
              [109.54965254000007, 18.225531317000048],
              [109.55445397200003, 18.22882721600007],
              [109.55909264400003, 18.230536200000074],
              [109.56120853000004, 18.23078034100007],
              [109.56332441500007, 18.238023179000038],
              [109.56625410200007, 18.242987372000073],
              [109.56657962300005, 18.248846747000073],
              [109.56120853000004, 18.258734442000048],
              [109.55225670700003, 18.24477773600006],
              [109.53882897200003, 18.236761786000045],
              [109.52955162900003, 18.227687893000052],
              [109.53394616000003, 18.21035390800006],
              [109.51075280000003, 18.21360911700009],
              [109.47868899800005, 18.192694403000075],
              [109.46501712300005, 18.20408763200004],
              [109.47803795700003, 18.21279531500005],
              [109.48471113400007, 18.221502997000073],
              [109.49268639400003, 18.22809479400007],
              [109.50961347700007, 18.23078034100007],
              [109.51026451900003, 18.23859284100007],
              [109.50652103000004, 18.252752997000073],
              [109.50017337300005, 18.259507554000038],
              [109.49293053500003, 18.245062567000048],
              [109.48072350400003, 18.264797268000052],
              [109.46273847700007, 18.279689846000053],
              [109.43995201900003, 18.28896719000005],
              [109.33350670700003, 18.30426666900007],
              [109.21810957100007, 18.30565013200004],
              [109.19060306100005, 18.299709377000056],
              [109.17310631600003, 18.28815338700008],
              [109.16260826900003, 18.28782786700009],
              [109.14966881600003, 18.299709377000056],
              [109.14389082100007, 18.314154364000046],
              [109.14234459700003, 18.328680731000077],
              [109.13949629000007, 18.340725002000056],
              [109.12916100400003, 18.347479559000078],
              [109.13599694100003, 18.361151434000078],
              [109.12208092500003, 18.358221747000073],
              [109.11117597700007, 18.361273505000042],
              [109.10157311300003, 18.366034247000073],
              [109.09164472700007, 18.36859772300005],
              [109.00074303500003, 18.36717357000009],
              [108.99089603000004, 18.36871979400007],
              [108.97901451900003, 18.374823309000078],
              [108.96778405000003, 18.384466864000046],
              [108.96094811300003, 18.393866278000075],
              [108.95281009200005, 18.402289130000042],
              [108.93734785200007, 18.40892161700009],
              [108.88591556100005, 18.426662502000056],
              [108.87598717500003, 18.43317291900007],
              [108.86866295700003, 18.443833726000037],
              [108.83106530000003, 18.468695380000042],
              [108.79558353000004, 18.48655833500004],
              [108.77556399800005, 18.493068752000056],
              [108.75513756600003, 18.496975002000056],
              [108.71070397200003, 18.499660549000055],
              [108.69499759200005, 18.504828192000048],
              [108.68490644600007, 18.51520416900007],
              [108.67725670700003, 18.532416083000044],
              [108.67408287900003, 18.554836330000057],
              [108.67945397200003, 18.57225169500009],
              [108.68718509200005, 18.587836005000042],
              [108.69092858200003, 18.604722398000092],
              [108.69711347700007, 18.683294989000046],
              [108.69361412900003, 18.719875393000052],
              [108.68336022200003, 18.75617096600007],
              [108.66814212300005, 18.78864166900007],
              [108.64942467500003, 18.813625393000052],
              [108.63697350400003, 18.825100002000056],
              [108.62745201900003, 18.835882880000042],
              [108.62387129000007, 18.84918854400007],
              [108.62891686300003, 18.86823151200008],
              [108.64722741000003, 18.903225002000056],
              [108.65381920700003, 18.921047268000052],
              [108.65626061300003, 18.94399648600006],
              [108.65357506600003, 18.96434153900009],
              [108.65040123800003, 18.973578192000048],
              [108.64600670700003, 18.977484442000048],
              [108.64258873800003, 18.982814846000053],
              [108.64258873800003, 19.018459377000056],
              [108.61524498800003, 19.101629950000074],
              [108.62907962300005, 19.11090729400007],
              [108.64429772200003, 19.124172268000052],
              [108.65691165500004, 19.139797268000052],
              [108.66309655000003, 19.15623607000009],
              [108.67896569100003, 19.152044989000046],
              [108.68344160200007, 19.150051174000055],
              [108.68344160200007, 19.15623607000009],
              [108.67603600400003, 19.162176825000074],
              [108.67188561300003, 19.173000393000052],
              [108.66993248800003, 19.19407786700009],
              [108.66391035200007, 19.20962148600006],
              [108.65007571700005, 19.21279531500005],
              [108.63428795700003, 19.212551174000055],
              [108.62208092500003, 19.217718817000048],
              [108.62175540500004, 19.22809479400007],
              [108.63070722700007, 19.237982489000046],
              [108.63795006600003, 19.248968817000048],
              [108.62696373800003, 19.27496979400007],
              [108.63168379000007, 19.286281643000052],
              [108.64112389400003, 19.29490794500009],
              [108.64942467500003, 19.299627997000073],
              [108.64730879000007, 19.303534247000073],
              [108.64478600400003, 19.310370184000078],
              [108.64966881600003, 19.31122467700004],
              [108.66260826900003, 19.309719143000052],
              [108.66456139400003, 19.314276434000078],
              [108.66309655000003, 19.32050202000005],
              [108.66684004000007, 19.32518138200004],
              [108.67725670700003, 19.32758209800005],
              [108.67725670700003, 19.334377346000053],
              [108.66928144600007, 19.34373607000009],
              [108.67253665500004, 19.351263739000046],
              [108.67953535200007, 19.35809967700004],
              [108.68344160200007, 19.36542389500005],
              [108.68653405000003, 19.377875067000048],
              [108.69434655000003, 19.38031647300005],
              [108.71452884200005, 19.375921942000048],
              [108.72917728000004, 19.37799713700008],
              [108.75220787900003, 19.38694896000004],
              [108.76295006600003, 19.38898346600007],
              [108.77068118600005, 19.394354559000078],
              [108.79029381600003, 19.423163153000075],
              [108.79818769600007, 19.425848700000074],
              [108.81788170700003, 19.439195054000038],
              [108.82748457100007, 19.444240627000056],
              [108.86980228000004, 19.457912502000056],
              [108.90333092500003, 19.493353583000044],
              [108.92448978000004, 19.506252346000053],
              [108.93734785200007, 19.492010809000078],
              [108.94483483200003, 19.492010809000078],
              [108.94483483200003, 19.498846747000073],
              [108.94076582100007, 19.514105536000045],
              [108.95655358200003, 19.53461334800005],
              [108.99268639400003, 19.56777578300006],
              [109.00220787900003, 19.587225653000075],
              [109.00847415500004, 19.59707265800006],
              [109.01587975400003, 19.601263739000046],
              [109.06706790500004, 19.608710028000075],
              [109.07886803500003, 19.61273834800005],
              [109.10336347700007, 19.626288153000075],
              [109.11841881600003, 19.63117096600007],
              [109.12891686300003, 19.64020416900007],
              [109.13257897200003, 19.642238674000055],
              [109.13355553500003, 19.643377997000073],
              [109.15650475400003, 19.649644273000035],
              [109.19206790500004, 19.67845286700009],
              [109.20582116000003, 19.698431708000044],
              [109.20492597700007, 19.718573309000078],
              [109.21119225400003, 19.72479889500005],
              [109.21851647200003, 19.72296784100007],
              [109.24398847700007, 19.72992584800005],
              [109.25896243600005, 19.731634833000044],
              [109.27271569100003, 19.729396877000056],
              [109.28321373800003, 19.72479889500005],
              [109.30046634200005, 19.71112702000005],
              [109.30738366000003, 19.71112702000005],
              [109.29818769600007, 19.72679271000004],
              [109.28158613400007, 19.74433014500005],
              [109.27466881600003, 19.75722890800006],
              [109.29420006600003, 19.759507554000038],
              [109.29420006600003, 19.765692450000074],
              [109.28679446700005, 19.765692450000074],
              [109.28679446700005, 19.773179429000038],
              [109.29574629000007, 19.774644273000035],
              [109.30046634200005, 19.77684153900009],
              [109.30738366000003, 19.786851304000038],
              [109.29737389400003, 19.786851304000038],
              [109.28923587300005, 19.787909247000073],
              [109.28150475400003, 19.790187893000052],
              [109.27320397200003, 19.79364655200004],
              [109.26099694100003, 19.77871328300006],
              [109.23560631600003, 19.76235586100006],
              [109.21013431100005, 19.749741929000038],
              [109.19752037900003, 19.745835679000038],
              [109.18132571700005, 19.735988674000055],
              [109.17481530000003, 19.73037344000005],
              [109.17017662900003, 19.72479889500005],
              [109.16334069100003, 19.72479889500005],
              [109.16724694100003, 19.742743231000077],
              [109.16334069100003, 19.790269273000035],
              [109.16684004000007, 19.805487372000073],
              [109.17554772200003, 19.81403229400007],
              [109.18677819100003, 19.820013739000046],
              [109.19752037900003, 19.827826239000046],
              [109.20093834700003, 19.832586981000077],
              [109.20736738400007, 19.843573309000078],
              [109.21119225400003, 19.84829336100006],
              [109.21949303500003, 19.854681708000044],
              [109.22486412900003, 19.855536200000074],
              [109.22950280000003, 19.85537344000005],
              [109.23560631600003, 19.85883209800005],
              [109.24870853000004, 19.868841864000046],
              [109.25171959700003, 19.874701239000046],
              [109.25269616000003, 19.885891018000052],
              [109.25513756600003, 19.89834219000005],
              [109.26156660200007, 19.900824286000045],
              [109.27051842500003, 19.900091864000046],
              [109.28003991000003, 19.902899481000077],
              [109.30372155000003, 19.921698309000078],
              [109.31137129000007, 19.91950104400007],
              [109.31421959700003, 19.89984772300005],
              [109.32129967500003, 19.89203522300005],
              [109.33790123800003, 19.889878648000035],
              [109.36882571700005, 19.88930898600006],
              [109.39576256600003, 19.869533596000053],
              [109.41260826900003, 19.861395575000074],
              [109.42750084700003, 19.865383205000057],
              [109.44361412900003, 19.872992255000042],
              [109.45533287900003, 19.864935614000046],
              [109.46265709700003, 19.849310614000046],
              [109.46501712300005, 19.834051825000074],
              [109.47242272200003, 19.834051825000074],
              [109.47950280000003, 19.844183661000045],
              [109.49398847700007, 19.850165106000077],
              [109.51140384200005, 19.85504791900007],
              [109.52702884200005, 19.86196523600006],
              [109.53296959700003, 19.85260651200008],
              [109.54509524800005, 19.85374583500004],
              [109.56177819100003, 19.85740794500009],
              [109.58171634200005, 19.85569896000004],
              [109.58171634200005, 19.86196523600006],
              [109.52930748800003, 19.875474351000037],
              [109.52019290500004, 19.882473049000055],
              [109.51563561300003, 19.905218817000048],
              [109.52540123800003, 19.911851304000038],
              [109.55445397200003, 19.91034577000005],
              [109.55746504000007, 19.917303778000075],
              [109.55225670700003, 19.927476304000038],
              [109.54460696700005, 19.933335679000038],
              [109.54078209700003, 19.92715078300006],
              [109.53736412900003, 19.92446523600006],
              [109.53093509200005, 19.930121161000045],
              [109.52588951900003, 19.940375067000048],
              [109.52702884200005, 19.95136139500005],
              [109.58139082100007, 19.984808661000045],
              [109.59571373800003, 19.99315013200004],
              [109.61166425900007, 19.997870184000078],
              [109.62631269600007, 19.99795156500005],
              [109.63624108200003, 19.992336330000057],
              [109.64258873800003, 19.992336330000057],
              [109.65211022200003, 20.00218333500004],
              [109.66814212300005, 20.00690338700008],
              [109.68669681100005, 20.007879950000074],
              [109.70460045700003, 20.00657786700009],
              [109.71290123800003, 20.01007721600007],
              [109.71900475400003, 20.010646877000056],
              [109.72559655000003, 20.00657786700009],
              [109.72836347700007, 19.997870184000078],
              [109.71989993600005, 19.985296942000048],
              [109.72559655000003, 19.978664455000057],
              [109.72559655000003, 19.971828518000052],
              [109.72217858200003, 19.966131903000075],
              [109.71810957100007, 19.957505601000037],
              [109.72559655000003, 19.957505601000037],
              [109.73755944100003, 19.97809479400007],
              [109.76368248800003, 19.974351304000038],
              [109.80762780000003, 19.95136139500005],
              [109.81055748800003, 19.96552155200004],
              [109.81169681100005, 19.98183828300006],
              [109.81592858200003, 19.99119700700004],
              [109.82797285200007, 19.984849351000037],
              [109.83513431100005, 19.97333405200004],
              [109.83855228000004, 19.95844147300005],
              [109.83838951900003, 19.94326406500005],
              [109.83545983200003, 19.930853583000044],
              [109.85466556100005, 19.941351630000042],
              [109.87037194100003, 19.95335521000004],
              [109.88038170700003, 19.967596747000073],
              [109.88331139400003, 19.984849351000037],
              [109.89527428500003, 19.985174872000073],
              [109.91480553500003, 19.99022044500009],
              [109.92090905000003, 19.98859284100007],
              [109.92660566500007, 19.984320380000042],
              [109.92945397200003, 19.986151434000078],
              [109.93132571700005, 19.99013906500005],
              [109.93458092500003, 19.992336330000057],
              [109.94263756600003, 19.99091217700004],
              [109.94336998800003, 19.987453518000052],
              [109.94223066500007, 19.982896226000037],
              [109.94467207100007, 19.978664455000057],
              [109.95720462300005, 19.967271226000037],
              [109.97242272200003, 19.948187567000048],
              [109.97559655000003, 19.93227773600006],
              [109.95150800900007, 19.930853583000044],
              [109.95997155000003, 19.917792059000078],
              [109.97380618600005, 19.90892161700009],
              [109.99008222700007, 19.905951239000046],
              [110.00619550900007, 19.91034577000005],
              [110.00619550900007, 19.916571356000077],
              [109.99219811300003, 19.92536041900007],
              [110.00123131600003, 19.932847398000035],
              [110.01465905000003, 19.94086334800005],
              [110.01368248800003, 19.957505601000037],
              [110.05030358200003, 19.97406647300005],
              [110.06820722700007, 19.978664455000057],
              [110.07634524800005, 19.97915273600006],
              [110.08961022200003, 19.97809479400007],
              [110.10254967500003, 19.973944403000075],
              [110.10987389400003, 19.964992580000057],
              [110.12273196700005, 19.974310614000046],
              [110.13689212300005, 19.99673086100006],
              [110.14958743600005, 20.00657786700009],
              [110.13884524800005, 20.00263092700004],
              [110.12330162900003, 19.98969147300005],
              [110.11548912900003, 19.984849351000037],
              [110.10499108200003, 19.982977606000077],
              [110.06820722700007, 19.984849351000037],
              [110.11491946700005, 20.00193919500009],
              [110.12973066500007, 20.01276276200008],
              [110.13746178500003, 20.024359442000048],
              [110.14966881600003, 20.055812893000052],
              [110.15699303500003, 20.06736888200004],
              [110.17115319100003, 20.06077708500004],
              [110.20866946700005, 20.04950592700004],
              [110.22217858200003, 20.04751211100006],
              [110.23259524800005, 20.04450104400007],
              [110.24512780000003, 20.038316148000035],
              [110.26099694100003, 20.033148505000042],
              [110.28052819100003, 20.033270575000074],
              [110.29517662900003, 20.03937409100007],
              [110.31690514400003, 20.05735911700009],
              [110.32496178500003, 20.06122467700004],
              [110.34473717500003, 20.05805084800005],
              [110.35889733200003, 20.04979075700004],
              [110.36898847700007, 20.03864166900007],
              [110.37671959700003, 20.02643463700008],
              [110.37671959700003, 20.02020905200004],
              [110.36817467500003, 20.00779857000009],
              [110.37517337300005, 19.99677155200004],
              [110.39722741000003, 19.978664455000057],
              [110.40251712300005, 19.96434153900009],
              [110.40650475400003, 19.935939846000053],
              [110.41089928500003, 19.92340729400007],
              [110.41773522200003, 19.92340729400007],
              [110.41439863400007, 19.932074286000045],
              [110.41334069100003, 19.93431224200009],
              [110.41089928500003, 19.93768952000005],
              [110.41089928500003, 19.943915106000077],
              [110.41773522200003, 19.943915106000077],
              [110.41773522200003, 19.95136139500005],
              [110.41456139400003, 19.95799388200004],
              [110.40943444100003, 19.98004791900007],
              [110.40707441500007, 19.984849351000037],
              [110.39714603000004, 19.98704661700009],
              [110.39063561300003, 19.993068752000056],
              [110.38648522200003, 20.001898505000042],
              [110.38298587300005, 20.01276276200008],
              [110.38331139400003, 20.014146226000037],
              [110.37818444100003, 20.039862372000073],
              [110.37671959700003, 20.043850002000056],
              [110.37501061300003, 20.063625393000052],
              [110.37647545700003, 20.071966864000046],
              [110.38298587300005, 20.08104075700004],
              [110.42457116000003, 20.04751211100006],
              [110.43116295700003, 20.050604559000078],
              [110.47022545700003, 20.031805731000077],
              [110.49594160200007, 20.023504950000074],
              [110.52759850400003, 20.02020905200004],
              [110.52759850400003, 20.01276276200008],
              [110.52076256600003, 20.01276276200008],
              [110.52076256600003, 20.00657786700009],
              [110.53565514400003, 19.99957916900007],
              [110.55054772200003, 19.98847077000005],
              [110.56413821700005, 19.984523830000057],
              [110.57545006600003, 19.999172268000052],
              [110.58033287900003, 19.979722398000035],
              [110.59864342500003, 19.94399648600006],
              [110.60271243600005, 19.92715078300006],
              [110.60580488400007, 19.923163153000075],
              [110.61296634200005, 19.925726630000042],
              [110.61988366000003, 19.93235911700009],
              [110.62322024800005, 19.940741278000075],
              [110.62134850400003, 19.950018622000073],
              [110.61841881600003, 19.95722077000005],
              [110.61784915500004, 19.96393463700008],
              [110.62322024800005, 19.971828518000052],
              [110.60914147200003, 19.989894924000055],
              [110.60645592500003, 20.007635809000078],
              [110.60092207100007, 20.02106354400007],
              [110.57886803500003, 20.02643463700008],
              [110.57081139400003, 20.03066640800006],
              [110.57016035200007, 20.040269273000035],
              [110.57227623800003, 20.050726630000042],
              [110.57203209700003, 20.057521877000056],
              [110.56617272200003, 20.069525458000044],
              [110.56934655000003, 20.079779364000046],
              [110.59310957100007, 20.10732656500005],
              [110.60417728000004, 20.11082591400009],
              [110.64014733200003, 20.108343817000048],
              [110.65202884200005, 20.117010809000078],
              [110.67074629000007, 20.15497467700004],
              [110.67790774800005, 20.16356028900009],
              [110.68506920700003, 20.15330638200004],
              [110.71094811300003, 20.07518138200004],
              [110.72445722700007, 20.06386953300006],
              [110.75277754000007, 20.04751211100006],
              [110.77466881600003, 20.02020905200004],
              [110.78834069100003, 20.01040273600006],
              [110.86988366000003, 19.997015692000048],
              [110.89014733200003, 19.999172268000052],
              [110.89307701900003, 20.001654364000046],
              [110.89380944100003, 20.004380601000037],
              [110.89633222700007, 20.00458405200004],
              [110.90430748800003, 19.999172268000052],
              [110.92066491000003, 20.01203034100007],
              [110.93458092500003, 19.995062567000048],
              [110.97706139400003, 19.86587148600006],
              [110.98316491000003, 19.807766018000052],
              [110.99683678500003, 19.749172268000052],
              [111.00001061300003, 19.72166575700004],
              [110.99439537900003, 19.694281317000048],
              [110.99659264400003, 19.68659088700008],
              [111.01050866000003, 19.68378327000005],
            ],
          ],
          [
            [
              [111.96265709700003, 21.65761953300006],
              [111.98951256600003, 21.65778229400007],
              [111.99984785200007, 21.653998114000046],
              [112.00733483200008, 21.64394765800006],
              [112.00733483200008, 21.636542059000078],
              [111.99984785200007, 21.621161200000074],
              [111.98145592500003, 21.61204661700009],
              [111.92904707100007, 21.60187409100007],
              [111.91976972700007, 21.60187409100007],
              [111.90967858200003, 21.600531317000048],
              [111.89747155000003, 21.595526434000078],
              [111.88819420700003, 21.58893463700008],
              [111.87110436300003, 21.57322825700004],
              [111.86329186300003, 21.56826406500005],
              [111.82243899800005, 21.56199778900009],
              [111.80933678500003, 21.56549713700008],
              [111.81006920700003, 21.56834544500009],
              [111.81690514400003, 21.57135651200008],
              [111.82243899800005, 21.575100002000056],
              [111.84205162900003, 21.60683828300006],
              [111.84506269600007, 21.623968817000048],
              [111.83529707100007, 21.64394765800006],
              [111.84717858200003, 21.647406317000048],
              [111.88379967500003, 21.650132554000038],
              [111.89600670700003, 21.653957424000055],
              [111.91586347700007, 21.66274648600006],
              [111.92823326900003, 21.664455471000053],
              [111.93140709700003, 21.66229889500005],
              [111.93433678500003, 21.657456773000035],
              [111.93848717500003, 21.65257396000004],
              [111.94516035200007, 21.650132554000038],
              [111.95093834700003, 21.65110911700009],
              [111.95582116000003, 21.656398830000057],
              [111.96265709700003, 21.65761953300006],
            ],
          ],
          [
            [
              [112.64535566500001, 21.712836005000042],
              [112.65455162900003, 21.698472398000035],
              [112.65137780000009, 21.688299872000073],
              [112.64332116000003, 21.678168036000045],
              [112.63795006600003, 21.664455471000053],
              [112.64991295700008, 21.649318752000056],
              [112.65040123800009, 21.640448309000078],
              [112.62378991000003, 21.633286851000037],
              [112.61646569100003, 21.619208075000074],
              [112.60718834700003, 21.616034247000073],
              [112.57992597700002, 21.61554596600007],
              [112.56714928500003, 21.617621161000045],
              [112.55591881600003, 21.623439846000053],
              [112.54908287900003, 21.616400458000044],
              [112.53923587300005, 21.598944403000075],
              [112.53492272200003, 21.595526434000078],
              [112.52540123800009, 21.598863023000035],
              [112.51929772200003, 21.606675523000035],
              [112.51823978000004, 21.61676666900007],
              [112.52426191500001, 21.626898505000042],
              [112.55982506600003, 21.648382880000042],
              [112.56788170700008, 21.660630601000037],
              [112.55591881600003, 21.678127346000053],
              [112.57781009200005, 21.68301015800006],
              [112.62012780000009, 21.70449453300006],
              [112.64535566500001, 21.712836005000042],
            ],
          ],
          [
            [
              [112.84400475400003, 21.774318752000056],
              [112.86255944100003, 21.76943594000005],
              [112.86817467500009, 21.757554429000038],
              [112.86255944100003, 21.74559153900009],
              [112.83179772200003, 21.73590729400007],
              [112.82056725400003, 21.726507880000042],
              [112.81251061300009, 21.71710846600007],
              [112.79753665500004, 21.705877997000073],
              [112.80046634200005, 21.68976471600007],
              [112.80713951900009, 21.67129140800006],
              [112.81055748800009, 21.65761953300006],
              [112.80323326900009, 21.63816966400009],
              [112.79444420700008, 21.623114325000074],
              [112.79346764400009, 21.608221747000073],
              [112.81055748800009, 21.58930084800005],
              [112.79965254000001, 21.57908763200004],
              [112.79021243600005, 21.57758209800005],
              [112.76490319100003, 21.581854559000078],
              [112.76148522200003, 21.583685614000046],
              [112.75831139400009, 21.58808014500005],
              [112.75611412900003, 21.59373607000009],
              [112.75367272200003, 21.607367255000042],
              [112.74968509200005, 21.60879140800006],
              [112.74390709700003, 21.60879140800006],
              [112.73715254000001, 21.612616278000075],
              [112.73438561300009, 21.628729559000078],
              [112.76758873800009, 21.66347890800006],
              [112.77442467500009, 21.69171784100007],
              [112.75961347700002, 21.686346747000073],
              [112.736664259, 21.68109772300005],
              [112.71558678500003, 21.680243231000077],
              [112.70622806100005, 21.688381252000056],
              [112.71168053500003, 21.70254140800006],
              [112.72437584700003, 21.71580638200004],
              [112.74781334700003, 21.733343817000048],
              [112.76490319100003, 21.731756903000075],
              [112.77751712300005, 21.772650458000044],
              [112.79566491000003, 21.766831773000035],
              [112.80762780000009, 21.772772528000075],
              [112.82113691500001, 21.77480703300006],
              [112.85027103000004, 21.774318752000056],
              [112.84400475400003, 21.774318752000056],
            ],
          ],
          [
            [
              [113.39144941500001, 22.02753327000005],
              [113.39893639400009, 22.021918036000045],
              [113.40162194100003, 22.018459377000056],
              [113.402679884, 22.01434967700004],
              [113.40577233200008, 22.007025458000044],
              [113.32349694100003, 22.01194896000004],
              [113.30941816500001, 22.02411530200004],
              [113.34359785200002, 22.068508205000057],
              [113.35279381600003, 22.073146877000056],
              [113.36329186300009, 22.075995184000078],
              [113.37273196700005, 22.080145575000074],
              [113.37777754000001, 22.089016018000052],
              [113.38266035200002, 22.089585679000038],
              [113.38404381600003, 22.08812083500004],
              [113.38404381600003, 22.08539459800005],
              [113.38526451900009, 22.082180080000057],
              [113.38721764400009, 22.078192450000074],
              [113.38990319100003, 22.074693101000037],
              [113.39356530000009, 22.071600653000075],
              [113.39893639400009, 22.068508205000057],
              [113.41260826900009, 22.075995184000078],
              [113.41032962300005, 22.06354401200008],
              [113.39144941500001, 22.02753327000005],
            ],
          ],
          [
            [
              [113.36475670700008, 22.157904364000046],
              [113.35401451900009, 22.13084544500009],
              [113.33619225400003, 22.100490627000056],
              [113.31364993600005, 22.07640208500004],
              [113.28907311300009, 22.068508205000057],
              [113.27914472700002, 22.074693101000037],
              [113.26880944100003, 22.088324286000045],
              [113.26417076900009, 22.10492584800005],
              [113.27173912900003, 22.120021877000056],
              [113.27914472700002, 22.123195705000057],
              [113.28972415500004, 22.125474351000037],
              [113.29867597700002, 22.128566799000055],
              [113.30274498800009, 22.133978583000044],
              [113.30420983200008, 22.141831773000035],
              [113.30844160200002, 22.14862702000005],
              [113.31495201900009, 22.153998114000046],
              [113.32309004000001, 22.157904364000046],
              [113.32797285200002, 22.145819403000075],
              [113.33545983200008, 22.148871161000045],
              [113.34717858200008, 22.15643952000005],
              [113.36475670700008, 22.157904364000046],
            ],
          ],
          [
            [
              [113.59351647200003, 22.784816799000055],
              [113.60287519600001, 22.77244700700004],
              [113.60279381600003, 22.762640692000048],
              [113.59457441500001, 22.75608958500004],
              [113.57984459700003, 22.753729559000078],
              [113.55827884200005, 22.757879950000074],
              [113.54460696700005, 22.768784898000035],
              [113.53565514400009, 22.784328518000052],
              [113.52857506600003, 22.80215078300006],
              [113.52116946700005, 22.787909247000073],
              [113.50611412900003, 22.798041083000044],
              [113.49529056100005, 22.81386953300006],
              [113.480804884, 22.849310614000046],
              [113.47396894600001, 22.849310614000046],
              [113.47315514400009, 22.825384833000044],
              [113.45590254000001, 22.83075592700004],
              [113.43409264400009, 22.84906647300005],
              [113.40211022200003, 22.882879950000074],
              [113.39616946700005, 22.898098049000055],
              [113.40512129000001, 22.90810781500005],
              [113.43295332100001, 22.91201406500005],
              [113.47559655000009, 22.90070221600007],
              [113.48780358200008, 22.89280833500004],
              [113.52702884200005, 22.846625067000048],
              [113.54672285200002, 22.834865627000056],
              [113.57300866000003, 22.83006419500009],
              [113.57642662900003, 22.823919989000046],
              [113.58765709700003, 22.794623114000046],
              [113.59351647200003, 22.784816799000055],
            ],
          ],
          [
            [
              [117.07154381600003, 23.473089911000045],
              [117.090327731, 23.461077402000058],
              [117.10214777500005, 23.467993079000053],
              [117.108944737, 23.48229427600006],
              [117.12585215700005, 23.48269187300008],
              [117.12256920700008, 23.46552155200004],
              [117.1340905190001, 23.460469009000064],
              [117.14179358900003, 23.449653305000083],
              [117.137366714, 23.41956471000009],
              [117.12878132000003, 23.39936918400008],
              [117.10694420700008, 23.403550523000035],
              [117.08287717300004, 23.411144377000085],
              [117.04889680300005, 23.404709558000036],
              [117.02393639400009, 23.414536851000037],
              [117.01544726200007, 23.416249271000083],
              [117.004008645, 23.41975883300006],
              [116.9924451500001, 23.41921278300009],
              [116.96934496400002, 23.418945631000042],
              [116.94809769200003, 23.421805245000087],
              [116.942989291, 23.43006217900006],
              [116.95311006600002, 23.442087018000052],
              [116.96763467800008, 23.453148053000064],
              [116.98218834700003, 23.459458726000037],
              [116.98878014400009, 23.455633856000077],
              [116.99390709700003, 23.44830963700008],
              [117.00025475400003, 23.441555080000057],
              [117.01002037900003, 23.43895091400009],
              [117.01742597700002, 23.441880601000037],
              [117.02685730100006, 23.44385463000009],
              [117.03757899000004, 23.446900552000045],
              [117.0443484320001, 23.464467225000078],
              [117.0490833, 23.474083690000043],
              [117.06299889400009, 23.478461005000042],
              [117.07081139400009, 23.47532786700009],
              [117.07154381600003, 23.473089911000045],
            ],
          ],
          [
            [
              [117.46890066700007, 23.75309046400008],
              [117.50416100400003, 23.74990469000005],
              [117.52666076500009, 23.74010690500006],
              [117.51619127600009, 23.716277715000047],
              [117.49594160200002, 23.72016022300005],
              [117.48415604000002, 23.71079304400007],
              [117.47654291000003, 23.689431710000065],
              [117.47983528300006, 23.662678062000055],
              [117.46721918500009, 23.657933737000064],
              [117.44483483200008, 23.664943752000056],
              [117.43266955400009, 23.660117014000036],
              [117.42114944500008, 23.64646441900004],
              [117.41776554900002, 23.627465821000044],
              [117.41537519600001, 23.608221747000073],
              [117.42383873800009, 23.601996161000045],
              [117.431558644, 23.582630235000067],
              [117.37446006000005, 23.57265430500007],
              [117.320482728, 23.574015926000072],
              [117.33781909800007, 23.596462572000064],
              [117.36912531100006, 23.62235712800009],
              [117.39372806100005, 23.67918528900009],
              [117.38672936300009, 23.684881903000075],
              [117.37549889400009, 23.689398505000042],
              [117.36394290500004, 23.691473700000074],
              [117.35613040500004, 23.689398505000042],
              [117.34644616000003, 23.684759833000044],
              [117.34050540500004, 23.68895091400009],
              [117.34245853000004, 23.699652411000045],
              [117.37668889000008, 23.72886530900007],
              [117.37566165500004, 23.747300523000035],
              [117.379242384, 23.74681224200009],
              [117.37273196700005, 23.766750393000052],
              [117.38591556100005, 23.77415599200009],
              [117.40430748800009, 23.77415599200009],
              [117.41358483200008, 23.77167389500005],
              [117.41976972700002, 23.754299221000053],
              [117.43482506600003, 23.75071849200009],
              [117.44778172300005, 23.74225160700007],
              [117.46890066700007, 23.75309046400008],
            ],
          ],
          [
            [
              [119.30543053500003, 26.035956122000073],
              [119.36980228000004, 26.014227606000077],
              [119.40121504000001, 25.996039130000042],
              [119.40495853000004, 25.97793203300006],
              [119.39063561300009, 25.96698639500005],
              [119.38111412900003, 25.96698639500005],
              [119.37159264400009, 25.971584377000056],
              [119.34595787900003, 25.976385809000078],
              [119.31202233200008, 25.986761786000045],
              [119.30201256600003, 25.991848049000055],
              [119.29053795700008, 25.995266018000052],
              [119.27328535200002, 25.99713776200008],
              [119.25757897200003, 26.00145091400009],
              [119.25074303500003, 26.01239655200004],
              [119.24683678500003, 26.026556708000044],
              [119.23755944100003, 26.037583726000037],
              [119.22673587300005, 26.047674872000073],
              [119.21778405000009, 26.059027411000045],
              [119.20923912900003, 26.098578192000048],
              [119.22120201900009, 26.089544989000046],
              [119.24333743600005, 26.057074286000045],
              [119.25757897200003, 26.04755280200004],
              [119.27222741000003, 26.04205963700008],
              [119.30543053500003, 26.035956122000073],
            ],
          ],
          [
            [
              [121.25553061200003, 28.140000892000046],
              [121.26453571900004, 28.121594912000035],
              [121.2853524200001, 28.101945631000035],
              [121.27914472700002, 28.08543528900009],
              [121.26783287900003, 28.084540106000077],
              [121.25709069100003, 28.085150458000044],
              [121.24724368600005, 28.08779531500005],
              [121.23812910200002, 28.092922268000052],
              [121.23568769600001, 28.08551666900007],
              [121.23365319100003, 28.082424221000053],
              [121.23389733200008, 28.07908763200004],
              [121.23812910200002, 28.071193752000056],
              [121.23145592500009, 28.065008856000077],
              [121.21924889400009, 28.06785716400009],
              [121.2185124, 28.05846334900008],
              [121.20244170800004, 28.05475387100006],
              [121.186400477, 28.043700183000055],
              [121.16689887200005, 28.043081974000074],
              [121.15157280200003, 28.041232470000068],
              [121.14673393800001, 28.057810957000072],
              [121.15523523500008, 28.07136814200004],
              [121.15235145600002, 28.078073949000043],
              [121.14275149800005, 28.082586981000077],
              [121.13746178500003, 28.094183661000045],
              [121.13062584700003, 28.103461005000042],
              [121.1323291980001, 28.11431429600009],
              [121.1273592980001, 28.126556316000062],
              [121.12037194100003, 28.135687567000048],
              [121.12501061300009, 28.14008209800005],
              [121.13493899800005, 28.143052476000037],
              [121.16528325500008, 28.150533523000036],
              [121.18753112400009, 28.168901841000036],
              [121.20406983500004, 28.189707446000057],
              [121.2089755720001, 28.20013198500004],
              [121.21094811300009, 28.20897044500009],
              [121.2305876040001, 28.219732518000058],
              [121.25640250600009, 28.21479830900006],
              [121.26889341600008, 28.193941892000055],
              [121.27024056900007, 28.18229047300008],
              [121.26183975900005, 28.168809099000043],
              [121.25553061200003, 28.140000892000046],
            ],
          ],
          [
            [
              [122.23878014400009, 30.31313711100006],
              [122.20386803500003, 30.291408596000053],
              [122.20386803500003, 30.285142320000034],
              [122.22380618600005, 30.27887604400007],
              [122.23194420700008, 30.277736721000053],
              [122.21957441500001, 30.270453192000048],
              [122.21705162900003, 30.262518622000073],
              [122.21753991000003, 30.25458405200004],
              [122.21452884200005, 30.247300523000035],
              [122.20232181100005, 30.241929429000038],
              [122.18799889400009, 30.24363841400009],
              [122.17408287900003, 30.247992255000042],
              [122.13770592500009, 30.25462474200009],
              [122.11402428500003, 30.26508209800005],
              [122.07357832100001, 30.291408596000053],
              [122.08399498800009, 30.302435614000046],
              [122.08790123800009, 30.30565013200004],
              [122.09571373800009, 30.310695705000057],
              [122.10417728000004, 30.314154364000046],
              [122.12208092500009, 30.319281317000048],
              [122.14722741000003, 30.321478583000044],
              [122.15284264400009, 30.322699286000045],
              [122.16602623800009, 30.331691799000055],
              [122.19467207100001, 30.33856842700004],
              [122.21143639400009, 30.346625067000048],
              [122.22510826900009, 30.33234284100007],
              [122.21876061300009, 30.32607656500005],
              [122.22046959700003, 30.320705471000053],
              [122.22787519600001, 30.316351630000042],
              [122.23878014400009, 30.31313711100006],
            ],
          ],
          [
            [
              [122.39893639400009, 30.45648834800005],
              [122.41098066500001, 30.45213450700004],
              [122.41651451900009, 30.44159577000005],
              [122.42310631600003, 30.414943752000056],
              [122.40406334700003, 30.41864655200004],
              [122.36378014400009, 30.433417059000078],
              [122.347992384, 30.435980536000045],
              [122.30600019600001, 30.423163153000075],
              [122.28541100400003, 30.42206452000005],
              [122.27279707100001, 30.435980536000045],
              [122.27735436300009, 30.436712958000044],
              [122.28711998800009, 30.442206122000073],
              [122.27800540500004, 30.445746161000045],
              [122.273773634, 30.45136139500005],
              [122.27279707100001, 30.45929596600007],
              [122.27279707100001, 30.46946849200009],
              [122.27662194100003, 30.479803778000075],
              [122.28003991000003, 30.48261139500005],
              [122.28711998800009, 30.48314036700009],
              [122.29078209700003, 30.47166575700004],
              [122.29948978000004, 30.47134023600006],
              [122.31128991000003, 30.472642320000034],
              [122.33741295700008, 30.45848216400009],
              [122.34880618600005, 30.460638739000046],
              [122.36915123800009, 30.476996161000045],
              [122.36850019600001, 30.46320221600007],
              [122.37468509200005, 30.45734284100007],
              [122.38542728000004, 30.456203518000052],
              [122.39893639400009, 30.45648834800005],
            ],
          ],
          [
            [
              [121.83773847700002, 31.375148830000057],
              [121.85377037900003, 31.372992255000042],
              [121.86784915500004, 31.36619700700004],
              [121.87794030000009, 31.354315497000073],
              [121.88184655000009, 31.33661530200004],
              [121.87745201900009, 31.319647528000075],
              [121.86622155000009, 31.30418528900009],
              [121.85108483200008, 31.29393138200004],
              [121.83472741000003, 31.29254791900007],
              [121.82341556100005, 31.302394924000055],
              [121.81324303500003, 31.320786851000037],
              [121.79420006600003, 31.368801174000055],
              [121.80445397200003, 31.374701239000046],
              [121.83773847700002, 31.375148830000057],
            ],
          ],
          [
            [
              [119.88070722700002, 32.12518952000005],
              [119.90137780000009, 32.082464911000045],
              [119.90186608200008, 32.07339101800005],
              [119.89031009200005, 32.075384833000044],
              [119.85873457100001, 32.101548570000034],
              [119.84351647200003, 32.10814036700009],
              [119.81519616000003, 32.115220445000034],
              [119.80486087300005, 32.120306708000044],
              [119.79517662900003, 32.12055084800005],
              [119.79200280000009, 32.12177155200004],
              [119.78711998800009, 32.12958405200004],
              [119.78834069100003, 32.13361237200007],
              [119.79127037900003, 32.13686758000006],
              [119.79200280000009, 32.142279364000046],
              [119.79102623800009, 32.16547272300005],
              [119.79883873800009, 32.17869700700004],
              [119.80990644600001, 32.189113674000055],
              [119.81934655000009, 32.20376211100006],
              [119.78931725400003, 32.21149323100008],
              [119.74984785200002, 32.22801341400009],
              [119.71949303500003, 32.24957916900007],
              [119.71615644600001, 32.272650458000044],
              [119.75082441500001, 32.29311758000006],
              [119.78532962300005, 32.29169342700004],
              [119.81430097700002, 32.27558014500005],
              [119.83285566500001, 32.25214264500005],
              [119.87501061300009, 32.15521881700005],
              [119.88070722700002, 32.12518952000005],
            ],
          ],
          [
            [
              [122.32129967500009, 39.16596100500004],
              [122.33057701900009, 39.180121161000045],
              [122.35482832100001, 39.19562409100007],
              [122.38257897200003, 39.208319403000075],
              [122.40259850400003, 39.21381256700005],
              [122.392914259, 39.20380280200004],
              [122.38990319100003, 39.19354889500005],
              [122.38892662900003, 39.18707916900007],
              [122.39747155000009, 39.16583893400008],
              [122.40259850400003, 39.15912506700005],
              [122.38892662900003, 39.152329820000034],
              [122.37631269600001, 39.160589911000045],
              [122.35523522200003, 39.151556708000044],
              [122.33399498800009, 39.14630768400008],
              [122.32129967500009, 39.16596100500004],
            ],
          ],
          [
            [
              [122.63599694100003, 39.23427969000005],
              [122.66211998800009, 39.23273346600007],
              [122.71859785200002, 39.241888739000046],
              [122.74195397200003, 39.23607005400004],
              [122.73951256600003, 39.22223541900007],
              [122.72559655000009, 39.21002838700008],
              [122.69068444100003, 39.19330475500004],
              [122.69214928500003, 39.20140208500004],
              [122.69255618600005, 39.20766836100006],
              [122.693695509, 39.213771877000056],
              [122.69752037900003, 39.22125885600008],
              [122.68360436300009, 39.224310614000046],
              [122.63599694100003, 39.22801341400009],
              [122.63599694100003, 39.23427969000005],
            ],
          ],
          [
            [
              [122.68441816500001, 39.26219310100004],
              [122.64307701900009, 39.255072333000044],
              [122.58619225400003, 39.25800202000005],
              [122.53345787900003, 39.27167389500005],
              [122.50505618600005, 39.296942450000074],
              [122.53663170700008, 39.298041083000044],
              [122.54656009200005, 39.296942450000074],
              [122.58472741000003, 39.284369208000044],
              [122.64389082100001, 39.278509833000044],
              [122.66325931100005, 39.27220286700009],
              [122.68441816500001, 39.26219310100004],
            ],
          ],
          [
            [
              [121.42253665500004, 39.47451406500005],
              [121.44239342500009, 39.462876695000034],
              [121.45045006600003, 39.45026276200008],
              [121.44312584700003, 39.44114817900004],
              [121.41627037900003, 39.440334377000056],
              [121.41627037900003, 39.43353913000004],
              [121.42554772200003, 39.430121161000045],
              [121.431976759, 39.424261786000045],
              [121.43555748800009, 39.41620514500005],
              [121.43604576900009, 39.409816799000055],
              [121.43360436300009, 39.38580963700008],
              [121.42172285200002, 39.37368398600006],
              [121.40349368600005, 39.37059153900009],
              [121.35320071700005, 39.37319570500006],
              [121.33692467500009, 39.377386786000045],
              [121.33611087300005, 39.38735586100006],
              [121.35425866000003, 39.40619538000004],
              [121.37175540500004, 39.41754791900007],
              [121.37964928500003, 39.42487213700008],
              [121.38160241000003, 39.43353913000004],
              [121.37525475400003, 39.44236888200004],
              [121.36426842500009, 39.44546133000006],
              [121.351898634, 39.44428131700005],
              [121.34058678500003, 39.440334377000056],
              [121.32732181100005, 39.42763906500005],
              [121.31332441500001, 39.40843333500004],
              [121.29615319100003, 39.39142487200007],
              [121.27295983200008, 39.38507721600007],
              [121.26441491000003, 39.38690827000005],
              [121.25945071700005, 39.391506252000056],
              [121.25757897200003, 39.399644273000035],
              [121.25863691500001, 39.41242096600007],
              [121.26172936300009, 39.427801825000074],
              [121.26587975400003, 39.433579820000034],
              [121.29476972700002, 39.443345445000034],
              [121.30290774800005, 39.44521719000005],
              [121.31104576900009, 39.44794342700004],
              [121.32016035200002, 39.454006252000056],
              [121.32471764400009, 39.46076080900008],
              [121.32732181100005, 39.468451239000046],
              [121.33130944100003, 39.475775458000044],
              [121.34058678500003, 39.481350002000056],
              [121.35254967500009, 39.482407945000034],
              [121.38843834700003, 39.47451406500005],
              [121.41325931100005, 39.47650788000004],
              [121.42253665500004, 39.47451406500005],
            ],
          ],
          [
            [
              [122.96436608200008, 39.51544830900008],
              [122.96802819100003, 39.541083075000074],
              [122.98975670700008, 39.54950592700004],
              [123.01758873800009, 39.54450104400007],
              [123.04004967500009, 39.529730536000045],
              [123.02995853000004, 39.507879950000074],
              [123.00570722700002, 39.497300523000035],
              [122.97974694100003, 39.499335028000075],
              [122.96436608200008, 39.51544830900008],
            ],
          ],
          [
            [
              [110.59587649800005, 20.958726304000038],
              [110.60613040500004, 20.95384349200009],
              [110.61793053500003, 20.952378648000035],
              [110.62794030000003, 20.94863515800006],
              [110.63249759200005, 20.936672268000052],
              [110.63038170700003, 20.92576732000009],
              [110.62452233200003, 20.915187893000052],
              [110.60954837300005, 20.897284247000073],
              [110.58920332100007, 20.88349030200004],
              [110.57569420700003, 20.888820705000057],
              [110.56348717500003, 20.903469143000052],
              [110.54753665500004, 20.917710679000038],
              [110.57488040500004, 20.94745514500005],
              [110.58961022200003, 20.959377346000053],
              [110.60271243600005, 20.964911200000074],
              [110.59587649800005, 20.958726304000038],
            ],
          ],
          [
            [
              [110.54753665500004, 21.037258205000057],
              [110.54379316500007, 21.022772528000075],
              [110.52686608200003, 20.989203192000048],
              [110.52076256600003, 20.972357489000046],
              [110.52222741000003, 20.962591864000046],
              [110.52564537900003, 20.95107656500005],
              [110.52605228000004, 20.94159577000005],
              [110.51693769600007, 20.937648830000057],
              [110.50798587300005, 20.940375067000048],
              [110.50269616000003, 20.94749583500004],
              [110.50017337300005, 20.957505601000037],
              [110.49968509200005, 20.96865469000005],
              [110.49301191500007, 20.97797272300005],
              [110.47689863400007, 20.99042389500005],
              [110.45769290500004, 21.001206773000035],
              [110.44141686300003, 21.00584544500009],
              [110.36304772200003, 21.00584544500009],
              [110.33366946700005, 20.99628327000005],
              [110.29867597700007, 20.98065827000005],
              [110.26661217500003, 20.97264232000009],
              [110.24586022200003, 20.986029364000046],
              [110.26189212300005, 20.992987372000073],
              [110.26539147200003, 21.004339911000045],
              [110.25928795700003, 21.01699453300006],
              [110.24586022200003, 21.02757396000004],
              [110.26482181100005, 21.03310781500005],
              [110.27507571700005, 21.034328518000052],
              [110.28736412900003, 21.03384023600006],
              [110.28736412900003, 21.04059479400007],
              [110.27637780000003, 21.041164455000057],
              [110.27068118600005, 21.044867255000042],
              [110.26954186300003, 21.051581122000073],
              [110.27312259200005, 21.061102606000077],
              [110.29021243600005, 21.05426666900007],
              [110.30990644600007, 21.05292389500005],
              [110.32691491000003, 21.057440497000073],
              [110.33521569100003, 21.06858958500004],
              [110.32211347700007, 21.06403229400007],
              [110.30795332100007, 21.06085846600007],
              [110.29542076900003, 21.063055731000077],
              [110.28736412900003, 21.07444896000004],
              [110.34262129000007, 21.074652411000045],
              [110.37134850400003, 21.080959377000056],
              [110.38982181100005, 21.09589264500005],
              [110.40040123800003, 21.06391022300005],
              [110.40821373800003, 21.04824453300006],
              [110.41773522200003, 21.04059479400007],
              [110.42318769600007, 21.05141836100006],
              [110.43213951900003, 21.05727773600006],
              [110.44410241000003, 21.05996328300006],
              [110.45875084700003, 21.061102606000077],
              [110.45191491000003, 21.061102606000077],
              [110.47282962300005, 21.061672268000052],
              [110.48406009200005, 21.06785716400009],
              [110.49293053500003, 21.075995184000078],
              [110.50709069100003, 21.08222077000005],
              [110.52637780000003, 21.082098700000074],
              [110.53882897200003, 21.073065497000073],
              [110.54558353000004, 21.05735911700009],
              [110.54753665500004, 21.037258205000057],
            ],
          ],
          [
            [
              [110.61695397200003, 21.191473700000074],
              [110.59945722700007, 21.178290106000077],
              [110.57691491000003, 21.130926825000074],
              [110.56519616000003, 21.112616278000075],
              [110.54322350400003, 21.10496653900009],
              [110.52068118600005, 21.111802476000037],
              [110.50586998800003, 21.12685781500005],
              [110.50709069100003, 21.143703518000052],
              [110.49659264400003, 21.146307684000078],
              [110.48902428500003, 21.150091864000046],
              [110.48357181100005, 21.15582916900007],
              [110.47917728000004, 21.164129950000074],
              [110.47291100400003, 21.164129950000074],
              [110.47917728000004, 21.150458075000074],
              [110.46143639400003, 21.15106842700004],
              [110.44947350400003, 21.15623607000009],
              [110.44532311300003, 21.165676174000055],
              [110.45191491000003, 21.17845286700009],
              [110.44336998800003, 21.177883205000057],
              [110.42611738400007, 21.17910390800006],
              [110.41773522200003, 21.17845286700009],
              [110.41773522200003, 21.18463776200008],
              [110.43433678500003, 21.18659088700008],
              [110.44483483200003, 21.193793036000045],
              [110.45264733200003, 21.20148346600007],
              [110.46216881600003, 21.205145575000074],
              [110.48780358200003, 21.208644924000055],
              [110.49984785200007, 21.206284898000035],
              [110.49626712300005, 21.19521719000005],
              [110.47095787900003, 21.19367096600007],
              [110.46338951900003, 21.190741278000075],
              [110.47917728000004, 21.18463776200008],
              [110.49293053500003, 21.18390534100007],
              [110.50416100400003, 21.18768952000005],
              [110.52637780000003, 21.200832424000055],
              [110.53223717500003, 21.20331452000005],
              [110.53785241000003, 21.20449453300006],
              [110.54322350400003, 21.20416901200008],
              [110.54965254000007, 21.202460028000075],
              [110.56617272200003, 21.19334544500009],
              [110.56861412900003, 21.191473700000074],
              [110.55543053500003, 21.17682526200008],
              [110.55005944100003, 21.168443101000037],
              [110.54753665500004, 21.156724351000037],
              [110.55494225400003, 21.156724351000037],
              [110.57732181100005, 21.19098541900007],
              [110.59400475400003, 21.202785549000055],
              [110.61695397200003, 21.198919989000046],
              [110.61695397200003, 21.191473700000074],
            ],
          ],
          [
            [
              [118.09253991000003, 24.55621979400007],
              [118.11207116000003, 24.54559967700004],
              [118.13786868600005, 24.53652578300006],
              [118.16309655000009, 24.53196849200009],
              [118.18140709700003, 24.535101630000042],
              [118.18230228000004, 24.522650458000044],
              [118.18930097700002, 24.503078518000052],
              [118.18873131600003, 24.49412669500009],
              [118.18083743600005, 24.48346588700008],
              [118.17164147200003, 24.478461005000042],
              [118.16391035200002, 24.471909898000035],
              [118.16081790500004, 24.45693594000005],
              [118.15381920700008, 24.43707916900007],
              [118.13648522200003, 24.42926666900007],
              [118.11402428500003, 24.430609442000048],
              [118.09205162900003, 24.43846263200004],
              [118.08106530000009, 24.44521719000005],
              [118.07341556100005, 24.45270416900007],
              [118.06999759200005, 24.460272528000075],
              [118.07203209700003, 24.46747467700004],
              [118.08155358200008, 24.472601630000042],
              [118.09343509200005, 24.474676825000074],
              [118.10303795700008, 24.47988515800006],
              [118.10621178500003, 24.49412669500009],
              [118.08228600400003, 24.48232656500005],
              [118.07471764400009, 24.48395416900007],
              [118.07203209700003, 24.497870184000078],
              [118.07520592500009, 24.512152411000045],
              [118.08936608200008, 24.538397528000075],
              [118.09253991000003, 24.55621979400007],
            ],
          ],
          [
            [
              [119.84652754000001, 25.536322333000044],
              [119.83448326900009, 25.54913971600007],
              [119.81861412900003, 25.545803127000056],
              [119.80469811300009, 25.53261953300006],
              [119.79883873800009, 25.51581452000005],
              [119.80640709700003, 25.495835679000038],
              [119.83969160200002, 25.47915273600006],
              [119.84652754000001, 25.46116771000004],
              [119.82105553500003, 25.46751536700009],
              [119.79460696700005, 25.463039455000057],
              [119.77198326900009, 25.45058828300006],
              [119.75782311300009, 25.433254299000055],
              [119.75733483200008, 25.42133209800005],
              [119.76002037900003, 25.410630601000037],
              [119.75733483200008, 25.40493398600006],
              [119.73991946700005, 25.40778229400007],
              [119.72217858200008, 25.413804429000038],
              [119.70386803500003, 25.423570054000038],
              [119.69304446700005, 25.437648830000057],
              [119.69776451900009, 25.45661041900007],
              [119.70101972700002, 25.45994700700004],
              [119.70899498800009, 25.465643622000073],
              [119.71176191500001, 25.469549872000073],
              [119.71225019600001, 25.473578192000048],
              [119.71225019600001, 25.480210679000038],
              [119.71159915500004, 25.48623281500005],
              [119.70997155000009, 25.48786041900007],
              [119.69988040500004, 25.48232656500005],
              [119.68921959700003, 25.48045482000009],
              [119.67847741000003, 25.48232656500005],
              [119.66846764400009, 25.48786041900007],
              [119.67774498800009, 25.501206773000035],
              [119.68620853000004, 25.50771719000005],
              [119.69605553500003, 25.50934479400007],
              [119.74854576900009, 25.50259023600006],
              [119.76636803500003, 25.506252346000053],
              [119.77833092500009, 25.522040106000077],
              [119.75879967500009, 25.53074778900009],
              [119.72632897200003, 25.525132554000038],
              [119.71615644600001, 25.536322333000044],
              [119.71762129000001, 25.54490794500009],
              [119.73047936300009, 25.581000067000048],
              [119.72706139400009, 25.59088776200008],
              [119.71876061300009, 25.59125397300005],
              [119.70923912900003, 25.585598049000055],
              [119.70264733200008, 25.577297268000052],
              [119.69271894600001, 25.594224351000037],
              [119.69874108200008, 25.612616278000075],
              [119.71363366000003, 25.630601304000038],
              [119.73047936300009, 25.646144924000055],
              [119.74545332100001, 25.64907461100006],
              [119.75049889400009, 25.65298086100006],
              [119.76351972700002, 25.659491278000075],
              [119.78174889400009, 25.65916575700004],
              [119.77702884200005, 25.652085679000038],
              [119.77588951900009, 25.63572825700004],
              [119.78028405000009, 25.61741771000004],
              [119.79200280000009, 25.60455963700008],
              [119.80372155000009, 25.61074453300006],
              [119.81348717500009, 25.60883209800005],
              [119.82292728000004, 25.601385809000078],
              [119.83285566500001, 25.59088776200008],
              [119.81690514400009, 25.579820054000038],
              [119.83008873800009, 25.572007554000038],
              [119.85515384200005, 25.56513092700004],
              [119.87452233200008, 25.556789455000057],
              [119.86247806100005, 25.54629140800006],
              [119.84652754000001, 25.536322333000044],
            ],
          ],
          [
            [
              [121.95753014400009, 29.119533596000053],
              [121.95883222700002, 29.10805898600006],
              [121.95834394600001, 29.10187409100007],
              [121.93531334700003, 29.062892971000053],
              [121.92514082100001, 29.063055731000077],
              [121.91228274800005, 29.07135651200008],
              [121.88868248800009, 29.072333075000074],
              [121.90015709700003, 29.09373607000009],
              [121.88843834700003, 29.110296942000048],
              [121.87159264400009, 29.126613674000055],
              [121.86817467500009, 29.147406317000048],
              [121.88135826900009, 29.160305080000057],
              [121.90333092500009, 29.166571356000077],
              [121.92660566500001, 29.16673411700009],
              [121.94320722700002, 29.16111888200004],
              [121.95191491000003, 29.152289130000042],
              [121.955414259, 29.143500067000048],
              [121.95753014400009, 29.119533596000053],
            ],
          ],
          [
            [
              [122.14323978000004, 29.73338450700004],
              [122.17701256600003, 29.69684479400007],
              [122.18685957100001, 29.67340729400007],
              [122.16293379000001, 29.65452708500004],
              [122.16976972700002, 29.675034898000035],
              [122.16521243600005, 29.673163153000075],
              [122.14942467500009, 29.668850002000056],
              [122.14942467500009, 29.68183014500005],
              [122.13892662900003, 29.67259349200009],
              [122.13257897200003, 29.668890692000048],
              [122.12745201900009, 29.66901276200008],
              [122.12501061300009, 29.67324453300006],
              [122.12305748800009, 29.686468817000048],
              [122.12110436300009, 29.69171784100007],
              [122.11524498800009, 29.698391018000052],
              [122.10873457100001, 29.704006252000056],
              [122.10368899800005, 29.71051666900007],
              [122.10157311300009, 29.71971263200004],
              [122.09278405000009, 29.725775458000044],
              [122.07390384200005, 29.724432684000078],
              [122.05681399800005, 29.71979401200008],
              [122.053070509, 29.716009833000044],
              [122.04509524800005, 29.71698639500005],
              [122.04004967500009, 29.71637604400007],
              [122.03646894600001, 29.71747467700004],
              [122.03337649800005, 29.723456122000073],
              [122.03288821700005, 29.730943101000037],
              [122.03532962300005, 29.739976304000038],
              [122.03931725400003, 29.74754466400009],
              [122.04322350400003, 29.750799872000073],
              [122.04859459700003, 29.75608958500004],
              [122.05665123800009, 29.76780833500004],
              [122.06820722700002, 29.77952708500004],
              [122.08448326900009, 29.784898179000038],
              [122.097992384, 29.786851304000038],
              [122.10743248800009, 29.789618231000077],
              [122.11475670700008, 29.78851959800005],
              [122.12208092500009, 29.77871328300006],
              [122.12378991000003, 29.77090078300006],
              [122.12094160200002, 29.75779857000009],
              [122.12208092500009, 29.750799872000073],
              [122.12647545700008, 29.745062567000048],
              [122.14031009200005, 29.73460521000004],
              [122.14323978000004, 29.73338450700004],
            ],
          ],
          [
            [
              [122.39519290500004, 29.883612372000073],
              [122.39226321700005, 29.87641022300005],
              [122.38672936300009, 29.87067291900007],
              [122.38282311300009, 29.86473216400009],
              [122.38591556100005, 29.85687897300005],
              [122.39405358200008, 29.84788646000004],
              [122.39551842500009, 29.842678127000056],
              [122.39519290500004, 29.833319403000075],
              [122.38477623800009, 29.835191148000035],
              [122.37720787900003, 29.83893463700008],
              [122.36540774800005, 29.849758205000057],
              [122.35710696700005, 29.861721096000053],
              [122.35922285200002, 29.86977773600006],
              [122.36548912900003, 29.876288153000075],
              [122.36915123800009, 29.883612372000073],
              [122.36736087300005, 29.89590078300006],
              [122.36207116000003, 29.90448639500005],
              [122.353851759, 29.910589911000045],
              [122.33350670700008, 29.92059967700004],
              [122.32520592500009, 29.927883205000057],
              [122.32056725400003, 29.937241929000038],
              [122.32203209700003, 29.948431708000044],
              [122.32545006600003, 29.953924872000073],
              [122.33008873800009, 29.958238023000035],
              [122.33545983200008, 29.961330471000053],
              [122.34180748800009, 29.963039455000057],
              [122.34644616000003, 29.94940827000005],
              [122.35914147200003, 29.94627513200004],
              [122.38892662900003, 29.94879791900007],
              [122.40064537900003, 29.952948309000078],
              [122.40674889400009, 29.95270416900007],
              [122.40943444100003, 29.945705471000053],
              [122.40902754000001, 29.936672268000052],
              [122.40748131600003, 29.930609442000048],
              [122.40316816500001, 29.926255601000037],
              [122.39519290500004, 29.92206452000005],
              [122.40967858200008, 29.91120026200008],
              [122.40805097700002, 29.89984772300005],
              [122.39519290500004, 29.883612372000073],
            ],
          ],
          [
            [
              [121.88184655000009, 30.07636139500005],
              [121.88526451900009, 30.06118398600006],
              [121.89307701900009, 30.05621979400007],
              [121.90211022200003, 30.053534247000073],
              [121.90919030000009, 30.044989325000074],
              [121.910492384, 30.02411530200004],
              [121.90333092500009, 30.001776434000078],
              [121.88965905000009, 29.98395416900007],
              [121.87159264400009, 29.976711330000057],
              [121.86011803500003, 29.97809479400007],
              [121.84742272200003, 29.982123114000046],
              [121.83619225400003, 29.988674221000053],
              [121.82886803500003, 29.99750397300005],
              [121.82740319100003, 30.00421784100007],
              [121.82911217500009, 30.009100653000075],
              [121.83220462300005, 30.013657945000034],
              [121.83513431100005, 30.01943594000005],
              [121.83594811300009, 30.02570221600007],
              [121.83448326900009, 30.03856028900009],
              [121.83472741000003, 30.044989325000074],
              [121.83741295700008, 30.055894273000035],
              [121.84766686300009, 30.083156643000052],
              [121.85303795700008, 30.087144273000035],
              [121.86475670700008, 30.085923570000034],
              [121.87647545700008, 30.08161041900007],
              [121.88184655000009, 30.07636139500005],
            ],
          ],
          [
            [
              [122.32748457100001, 30.02448151200008],
              [122.32667076900009, 30.01080963700008],
              [122.32097415500004, 30.005926825000074],
              [122.31324303500003, 30.00348541900007],
              [122.306976759, 29.997219143000052],
              [122.30298912900003, 29.986314195000034],
              [122.30103600400003, 29.975897528000075],
              [122.30014082100001, 29.952460028000075],
              [122.29363040500004, 29.93378327000005],
              [122.27784264400009, 29.939927476000037],
              [122.24561608200008, 29.969875393000052],
              [122.22917728000004, 29.978664455000057],
              [122.18474368600005, 29.99445221600007],
              [122.14421634200005, 30.000392971000053],
              [122.09896894600001, 30.014471747000073],
              [122.07740319100003, 30.017645575000074],
              [122.06527754000001, 30.01593659100007],
              [122.04883873800009, 30.00739166900007],
              [122.03467858200008, 30.002020575000074],
              [122.03052819100003, 29.999335028000075],
              [122.025726759, 29.997259833000044],
              [122.01905358200008, 29.997219143000052],
              [122.01050866000003, 30.00031159100007],
              [122.00961347700002, 30.004339911000045],
              [122.01172936300009, 30.00844961100006],
              [122.01221764400009, 30.011419989000046],
              [122.01124108200008, 30.01508209800005],
              [122.01351972700002, 30.025824286000045],
              [122.01221764400009, 30.03192780200004],
              [122.00879967500009, 30.03339264500005],
              [121.99545332100001, 30.03656647300005],
              [121.99170983200008, 30.03807200700004],
              [121.97681725400003, 30.053656317000048],
              [121.97339928500003, 30.05996328300006],
              [121.97185306100005, 30.067694403000075],
              [121.97380618600005, 30.07257721600007],
              [121.97730553500003, 30.077337958000044],
              [121.98031660200002, 30.08462148600006],
              [121.980804884, 30.09007396000004],
              [121.97803795700008, 30.107082424000055],
              [121.96550540500004, 30.129706122000073],
              [121.96314537900003, 30.142401434000078],
              [121.97461998800009, 30.14801666900007],
              [122.08741295700008, 30.14752838700008],
              [122.10328209700003, 30.143703518000052],
              [122.11744225400003, 30.135931708000044],
              [122.13233483200008, 30.12376536700009],
              [122.14079837300005, 30.12132396000004],
              [122.16480553500003, 30.12051015800006],
              [122.16976972700002, 30.117254950000074],
              [122.17359459700003, 30.10224030200004],
              [122.18246504000001, 30.098578192000048],
              [122.193695509, 30.09979889500005],
              [122.20386803500003, 30.099554755000042],
              [122.22934004000001, 30.091620184000078],
              [122.23878014400009, 30.08661530200004],
              [122.24537194100003, 30.080145575000074],
              [122.24968509200005, 30.073431708000044],
              [122.25611412900003, 30.068182684000078],
              [122.26954186300009, 30.066066799000055],
              [122.28956139400009, 30.067328192000048],
              [122.29712975400003, 30.062567450000074],
              [122.30014082100001, 30.04873281500005],
              [122.30420983200008, 30.04197825700004],
              [122.32252037900003, 30.03192780200004],
              [122.32748457100001, 30.02448151200008],
            ],
          ],
          [
            [
              [121.844075352, 31.60794696800008],
              [121.91896634, 31.578462856000044],
              [121.98008567500005, 31.540295811000078],
              [121.98659839600009, 31.503897262000066],
              [121.97785060400008, 31.477771002000054],
              [121.9128896950001, 31.45633220700006],
              [121.8513735040001, 31.439178905000063],
              [121.81732579100003, 31.446650375000047],
              [121.78335209000011, 31.465686100000084],
              [121.73023522200003, 31.484767971000053],
              [121.710167576, 31.495077027000036],
              [121.68462982400001, 31.506807045000073],
              [121.61468863000005, 31.52158167500005],
              [121.57154381600003, 31.529364325000074],
              [121.54134135200002, 31.55378512900006],
              [121.51745636400005, 31.56839191100005],
              [121.48462975400003, 31.579901434000078],
              [121.40461395300008, 31.61371463900008],
              [121.37552303300004, 31.634133802000065],
              [121.34473717500009, 31.64130280200004],
              [121.31446373800009, 31.655585028000075],
              [121.30290774800005, 31.67145416900007],
              [121.28589928500003, 31.704046942000048],
              [121.22451110300005, 31.737666620000084],
              [121.20557825800006, 31.756618803000038],
              [121.18663053400007, 31.77411598200007],
              [121.1762876040001, 31.784322892000034],
              [121.181443091, 31.79598035300006],
              [121.19516035200002, 31.805243231000077],
              [121.21930074500006, 31.829472772000088],
              [121.26406453300001, 31.84107679400006],
              [121.322563521, 31.82933065800006],
              [121.36208870500002, 31.817608154000084],
              [121.3861331710001, 31.811735768000062],
              [121.4238850380001, 31.795639063000067],
              [121.47530402100006, 31.770769919000088],
              [121.50096557900008, 31.750328782000054],
              [121.5351758160001, 31.728409827000064],
              [121.57109123000009, 31.713752432000035],
              [121.60524304800003, 31.691824392000058],
              [121.62570177100008, 31.675756153000066],
              [121.64105310100001, 31.66552035400008],
              [121.6632225950001, 31.652351670000087],
              [121.72122670200008, 31.63031279100005],
              [121.844075352, 31.60794696800008],
            ],
          ],
          [
            [
              [111.19654381600003, 15.77537669500009],
              [111.19410241000003, 15.77610911700009],
              [111.19288170700003, 15.778225002000056],
              [111.19629967500003, 15.785711981000077],
              [111.19939212300005, 15.789211330000057],
              [111.20753014400003, 15.78929271000004],
              [111.20850670700003, 15.786281643000052],
              [111.20753014400003, 15.782171942000048],
              [111.20460045700003, 15.779242255000042],
              [111.19654381600003, 15.77537669500009],
            ],
          ],
          [
            [
              [111.76335696700005, 16.043443101000037],
              [111.75310306100005, 16.044663804000038],
              [111.75342858200003, 16.047430731000077],
              [111.76140384200005, 16.048651434000078],
              [111.76587975400003, 16.045314846000053],
              [111.76335696700005, 16.043443101000037],
            ],
          ],
          [
            [
              [109.10092207100007, 21.021185614000046],
              [109.09595787900003, 21.022040106000077],
              [109.09050540500004, 21.041937567000048],
              [109.09986412900003, 21.060695705000057],
              [109.12273196700005, 21.06541575700004],
              [109.13624108200003, 21.05101146000004],
              [109.12769616000003, 21.032171942000048],
              [109.11255944100003, 21.027085679000038],
              [109.10523522200003, 21.02448151200008],
              [109.10092207100007, 21.021185614000046],
            ],
          ],
          [
            [
              [120.748383009, 37.938706773000035],
              [120.75733483200008, 37.92267487200007],
              [120.75879967500009, 37.907538153000075],
              [120.75456790500004, 37.89667389500005],
              [120.74659264400009, 37.89789459800005],
              [120.73698978000004, 37.90460846600007],
              [120.72632897200003, 37.90884023600006],
              [120.72242272200003, 37.91909414300005],
              [120.72706139400009, 37.94765859600005],
              [120.73454837300005, 37.94765859600005],
              [120.748383009, 37.938706773000035],
            ],
          ],
          [
            [
              [120.60678144600001, 37.97988515800006],
              [120.61898847700002, 37.98114655200004],
              [120.62582441500001, 37.97256094000005],
              [120.62566165500004, 37.958685614000046],
              [120.62289472700002, 37.94879791900007],
              [120.61841881600003, 37.94700755400004],
              [120.61548912900003, 37.94830963700008],
              [120.60938561300009, 37.95502350500004],
              [120.601898634, 37.96930573100008],
              [120.60678144600001, 37.97988515800006],
            ],
          ],
          [
            [
              [120.72006269600001, 37.98094310100004],
              [120.72730553500003, 37.96942780200004],
              [120.72046959700003, 37.96401601800005],
              [120.70915774800005, 37.96576569200005],
              [120.70053144600001, 37.96987539300005],
              [120.69499759200005, 37.974676825000074],
              [120.69092858200008, 37.98143138200004],
              [120.68824303500003, 37.985256252000056],
              [120.69019616000003, 37.99062734600005],
              [120.70411217500009, 37.98965078300006],
              [120.72006269600001, 37.98094310100004],
            ],
          ],
          [
            [
              [120.76042728000004, 38.17047760600008],
              [120.77271569100003, 38.16543203300006],
              [120.77328535200002, 38.15973541900007],
              [120.76124108200008, 38.15802643400008],
              [120.75456790500004, 38.158189195000034],
              [120.74659264400009, 38.16185130400004],
              [120.73878014400009, 38.17560455900008],
              [120.74268639400009, 38.187567450000074],
              [120.76042728000004, 38.17047760600008],
            ],
          ],
          [
            [
              [120.80648847700002, 38.28823476800005],
              [120.80005944100003, 38.28750234600005],
              [120.79997806100005, 38.29389069200005],
              [120.80274498800009, 38.29840729400007],
              [120.80738366000003, 38.30487702000005],
              [120.81983483200008, 38.313666083000044],
              [120.83375084700003, 38.312567450000074],
              [120.83619225400003, 38.30426666900007],
              [120.82837975400003, 38.298814195000034],
              [120.82439212300005, 38.29832591400009],
              [120.82048587300005, 38.29751211100006],
              [120.81332441500001, 38.29376862200007],
              [120.80648847700002, 38.28823476800005],
            ],
          ],
          [
            [
              [120.91423587300005, 38.384100653000075],
              [120.90756269600001, 38.38515859600005],
              [120.90691165500004, 38.392564195000034],
              [120.91781660200002, 38.39545319200005],
              [120.92457116000003, 38.38686758000006],
              [120.92318769600001, 38.383246161000045],
              [120.91724694100003, 38.384426174000055],
              [120.91423587300005, 38.384100653000075],
            ],
          ],
          [
            [
              [123.18067467500009, 39.09194570500006],
              [123.18482506600003, 39.08612702000005],
              [123.19581139400009, 39.065334377000056],
              [123.19556725400003, 39.052069403000075],
              [123.18523196700005, 39.042303778000075],
              [123.17253665500004, 39.03367747600004],
              [123.16065514400009, 39.02924225500004],
              [123.14991295700008, 39.03656647300005],
              [123.14519290500004, 39.04328034100007],
              [123.14812259200005, 39.056341864000046],
              [123.15308678500003, 39.06232330900008],
              [123.16488691500001, 39.06049225500004],
              [123.16472415500004, 39.066392320000034],
              [123.15919030000009, 39.07168203300006],
              [123.15088951900009, 39.073431708000044],
              [123.14332116000003, 39.075832424000055],
              [123.14356530000009, 39.08087799700007],
              [123.16814212300005, 39.08392975500004],
              [123.17628014400009, 39.08999258000006],
              [123.18067467500009, 39.09194570500006],
            ],
          ],
          [
            [
              [111.60010826900003, 16.527289130000042],
              [111.59986412900003, 16.527492580000057],
              [111.60084069100003, 16.53196849200009],
              [111.60287519600007, 16.533351955000057],
              [111.60572350400003, 16.53351471600007],
              [111.60816491000003, 16.531805731000077],
              [111.60962975400003, 16.528265692000048],
              [111.60889733200003, 16.52724844000005],
              [111.60629316500007, 16.524237372000073],
              [111.60279381600003, 16.524644273000092],
              [111.60010826900003, 16.527289130000042],
            ],
          ],
          [
            [
              [112.73503665500004, 16.657945054000038],
              [112.73015384200005, 16.660223700000074],
              [112.72527103000004, 16.66620514500005],
              [112.72624759200005, 16.66901276200008],
              [112.72877037900003, 16.669256903000075],
              [112.73340905000009, 16.666083075000074],
              [112.73682701900009, 16.660223700000074],
              [112.73503665500004, 16.657945054000038],
            ],
          ],
          [
            [
              [112.33318118600005, 16.825018622000073],
              [112.32715905000009, 16.829738674000055],
              [112.32593834700003, 16.833238023000092],
              [112.32789147200003, 16.837103583000044],
              [112.33057701900009, 16.837632554000038],
              [112.33545983200008, 16.832586981000077],
              [112.33725019600001, 16.82843659100007],
              [112.33318118600005, 16.825018622000073],
            ],
          ],
          [
            [
              [112.33366946700005, 16.933254299000055],
              [112.33668053500003, 16.932114976000037],
              [112.33708743600005, 16.932033596000053],
              [112.33757571700005, 16.931341864000046],
              [112.34107506600003, 16.926988023000092],
              [112.34050540500004, 16.923570054000038],
              [112.33545983200008, 16.92381419500009],
              [112.33366946700005, 16.92641836100006],
              [112.33366946700005, 16.933254299000055],
            ],
          ],
          [
            [
              [110.47136478000004, 20.647365627000056],
              [110.47632897200003, 20.63157786700009],
              [110.47803795700003, 20.61078522300005],
              [110.47584069100003, 20.59593333500004],
              [110.47120201900003, 20.592596747000073],
              [110.46485436300003, 20.590765692000048],
              [110.45728600400003, 20.586859442000048],
              [110.45167076900003, 20.589178778000075],
              [110.44809004000007, 20.596258856000077],
              [110.43921959700003, 20.629461981000077],
              [110.43580162900003, 20.638495184000078],
              [110.42660566500007, 20.64288971600007],
              [110.41765384200005, 20.654771226000037],
              [110.42204837300005, 20.662258205000057],
              [110.43002363400007, 20.66201406500005],
              [110.43336022200003, 20.663763739000046],
              [110.43336022200003, 20.66742584800005],
              [110.43702233200003, 20.667914130000042],
              [110.44263756600003, 20.66351959800005],
              [110.44752037900003, 20.658351955000057],
              [110.46273847700007, 20.654771226000037],
              [110.47136478000004, 20.647365627000056],
            ],
          ],
          [
            [
              [113.27800540500004, 21.925034898000035],
              [113.28093509200005, 21.92283763200004],
              [113.28565514400009, 21.918117580000057],
              [113.28370201900009, 21.91351959800005],
              [113.27865644600001, 21.907375393000052],
              [113.27515709700003, 21.89752838700008],
              [113.26775149800005, 21.886460679000038],
              [113.25847415500004, 21.88043854400007],
              [113.25074303500003, 21.883205471000053],
              [113.23462975400003, 21.893459377000056],
              [113.22974694100003, 21.89874909100007],
              [113.22584069100003, 21.900824286000045],
              [113.22169030000009, 21.914129950000074],
              [113.23170006600003, 21.934475002000056],
              [113.24773196700005, 21.943182684000078],
              [113.25766035200002, 21.946600653000075],
              [113.26783287900003, 21.943304755000042],
              [113.27515709700003, 21.93154531500005],
              [113.27800540500004, 21.925034898000035],
            ],
          ],
          [
            [
              [113.77174662900006, 22.000343410000085],
              [113.77592108400006, 21.985858782000037],
              [113.76447678300008, 21.96681792700008],
              [113.74820564800007, 21.97278847000007],
              [113.73905611400005, 21.985972906000086],
              [113.73627928000008, 21.997162124000056],
              [113.74550153700011, 21.99779525400004],
              [113.7568592660001, 22.00039040000007],
              [113.77174662900006, 22.000343410000085],
            ],
          ],
          [
            [
              [114.30681399800005, 22.057196356000077],
              [114.30534915500004, 22.05027903900009],
              [114.30250084700003, 22.044867255000042],
              [114.22242272200003, 22.02167389500005],
              [114.20671634200005, 22.025783596000053],
              [114.21680748800009, 22.032171942000048],
              [114.27165774800005, 22.050523179000038],
              [114.28296959700003, 22.052557684000078],
              [114.29297936300009, 22.057806708000044],
              [114.29542076900009, 22.06281159100007],
              [114.29859459700003, 22.06712474200009],
              [114.30420983200008, 22.069281317000048],
              [114.31006920700008, 22.06858958500004],
              [114.30933678500003, 22.062567450000074],
              [114.30681399800005, 22.057196356000077],
            ],
          ],
          [
            [
              [113.47348066500001, 22.098537502000056],
              [113.46599368600005, 22.101507880000042],
              [113.46485436300009, 22.10814036700009],
              [113.47152754000001, 22.114081122000073],
              [113.51889082100001, 22.12726471600007],
              [113.52711022200003, 22.125881252000056],
              [113.53272545700008, 22.120306708000044],
              [113.53093509200005, 22.112941799000055],
              [113.52711022200003, 22.10610586100006],
              [113.53256269600001, 22.095363674000055],
              [113.54761803500003, 22.092596747000073],
              [113.53891035200002, 22.082098700000074],
              [113.484711134, 22.07135651200008],
              [113.47022545700008, 22.07762278900009],
              [113.47396894600001, 22.08812083500004],
              [113.47348066500001, 22.098537502000056],
            ],
          ],
          [
            [
              [113.6233788830001, 22.43987218600006],
              [113.6348832110001, 22.43804473600005],
              [113.64959548400009, 22.43856570300005],
              [113.65786970800002, 22.43202334500006],
              [113.6578245720001, 22.423751330000073],
              [113.65329326100004, 22.41372844400007],
              [113.642421958, 22.411420603000067],
              [113.64234696300002, 22.400189681000086],
              [113.63144949100001, 22.396102116000066],
              [113.62118666100002, 22.39141902700004],
              [113.61227218300007, 22.397961588000044],
              [113.61044137500005, 22.41333744600007],
              [113.61181578900005, 22.430470252000077],
              [113.6233788830001, 22.43987218600006],
            ],
          ],
          [
            [
              [113.54675920200009, 22.74188415100008],
              [113.5595046740001, 22.734999722000055],
              [113.563707368, 22.72030299800008],
              [113.57320394300007, 22.70069774500007],
              [113.5753217350001, 22.698734278000074],
              [113.603939094, 22.684951690000048],
              [113.6356865240001, 22.656474951000064],
              [113.64510971700008, 22.625115360000052],
              [113.64183151700001, 22.601623679000056],
              [113.6280148190001, 22.595784940000044],
              [113.6026095740001, 22.611521289000052],
              [113.56242715100007, 22.65568324900005],
              [113.52533118000008, 22.68318207300007],
              [113.49136813500002, 22.70577385200005],
              [113.47651141600011, 22.719514324000045],
              [113.47653944900003, 22.731267681000077],
              [113.50208046400007, 22.736111940000058],
              [113.52550121900003, 22.744872770000086],
              [113.54675920200009, 22.74188415100008],
            ],
          ],
          [
            [
              [113.52920975100005, 22.96035383800006],
              [113.529185923, 22.948594041000035],
              [113.54513977500005, 22.937762314000054],
              [113.55359928200005, 22.911280871000088],
              [113.553541515, 22.885811368000077],
              [113.545013691, 22.879960560000086],
              [113.52375724500007, 22.89667912200008],
              [113.50995973500005, 22.921216480000055],
              [113.50575350000008, 22.951609447000067],
              [113.51537583800007, 22.969220349000068],
              [113.52920975100005, 22.96035383800006],
            ],
          ],
          [
            [
              [116.99561608200008, 23.56354401200008],
              [117.00513756600003, 23.562933661000045],
              [117.00928795700008, 23.55499909100007],
              [117.00367272200003, 23.546210028000075],
              [116.99586022200003, 23.53851959800005],
              [116.99293053500003, 23.53388092700004],
              [116.98780358200008, 23.52411530200004],
              [116.97095787900003, 23.51463450700004],
              [116.95093834700003, 23.517401434000078],
              [116.93726647200003, 23.526271877000056],
              [116.93604576900009, 23.535549221000053],
              [116.94654381600003, 23.539455471000053],
              [116.95777428500003, 23.54490794500009],
              [116.96753991000003, 23.554348049000055],
              [116.97437584700003, 23.559393622000073],
              [116.97852623800009, 23.55927155200004],
              [116.98585045700008, 23.56045156500005],
              [116.99561608200008, 23.56354401200008],
            ],
          ],
          [
            [
              [119.55103600400003, 25.209458726000037],
              [119.56104576900009, 25.208644924000055],
              [119.56755618600005, 25.204901434000078],
              [119.56324303500003, 25.19879791900007],
              [119.55339603000004, 25.195257880000042],
              [119.54818769600001, 25.185980536000045],
              [119.54867597700002, 25.172430731000077],
              [119.54216556100005, 25.165350653000075],
              [119.52898196700005, 25.165350653000075],
              [119.51734459700003, 25.17145416900007],
              [119.51091556100005, 25.18231842700004],
              [119.51295006600003, 25.19139232000009],
              [119.51270592500009, 25.19879791900007],
              [119.50326582100001, 25.20380280200004],
              [119.49293053500003, 25.200506903000075],
              [119.48894290500004, 25.19627513200004],
              [119.46119225400003, 25.20331452000005],
              [119.44947350400003, 25.21434153900009],
              [119.44467207100001, 25.229071356000077],
              [119.44654381600003, 25.235988674000055],
              [119.45435631600003, 25.23847077000005],
              [119.45818118600005, 25.241115627000056],
              [119.47038821700005, 25.25218333500004],
              [119.47608483200008, 25.250555731000077],
              [119.48145592500009, 25.245021877000056],
              [119.486664259, 25.24485911700009],
              [119.49170983200008, 25.241400458000044],
              [119.496429884, 25.231350002000056],
              [119.50261478000004, 25.22101471600007],
              [119.51197350400003, 25.213446356000077],
              [119.52279707100001, 25.20844147300005],
              [119.53402754000001, 25.20722077000005],
              [119.54346764400009, 25.209377346000053],
              [119.55103600400003, 25.209458726000037],
            ],
          ],
          [
            [
              [119.34652754000001, 25.56671784100007],
              [119.34595787900003, 25.561102606000077],
              [119.35206139400009, 25.55223216400009],
              [119.34913170700008, 25.54401276200008],
              [119.34359785200002, 25.515366929000038],
              [119.33472741000003, 25.48969147300005],
              [119.33057701900009, 25.467352606000077],
              [119.33480879000001, 25.44989655200004],
              [119.33497155000009, 25.437974351000037],
              [119.32601972700002, 25.433986721000053],
              [119.31373131600003, 25.42991771000004],
              [119.30258222700002, 25.42291901200008],
              [119.29688561300009, 25.42291901200008],
              [119.28834069100003, 25.44367096600007],
              [119.28565514400009, 25.454738674000055],
              [119.281586134, 25.463812567000048],
              [119.28150475400003, 25.482896226000037],
              [119.30372155000009, 25.53774648600006],
              [119.305023634, 25.543361721000053],
              [119.30746504000001, 25.546820380000042],
              [119.31031334700003, 25.548651434000078],
              [119.31820722700002, 25.557074286000045],
              [119.32129967500009, 25.56122467700004],
              [119.33171634200005, 25.57127513200004],
              [119.34327233200008, 25.57330963700008],
              [119.34652754000001, 25.56671784100007],
            ],
          ],
          [
            [
              [119.62696373800009, 26.107896226000037],
              [119.63892662900003, 26.08856842700004],
              [119.64405358200008, 26.07843659100007],
              [119.63884524800005, 26.07050202000005],
              [119.62037194100003, 26.064195054000038],
              [119.56527754000001, 26.080471096000053],
              [119.55396569100003, 26.095648505000042],
              [119.57488040500004, 26.119533596000053],
              [119.59937584700003, 26.128119208000044],
              [119.61312910200002, 26.121161200000074],
              [119.62696373800009, 26.107896226000037],
            ],
          ],
          [
            [
              [120.32683353000004, 26.93968333500004],
              [120.31853274800005, 26.948594468000067],
              [120.3202417330001, 26.958197333000044],
              [120.3221948580001, 26.962103583000044],
              [120.32618248800009, 26.961778062000064],
              [120.33708743600005, 26.970038153000075],
              [120.34489993600005, 26.971950588000084],
              [120.35092207100001, 26.971177476000037],
              [120.35531660200002, 26.968858140000066],
              [120.35751386800007, 26.966050523000035],
              [120.36304772200003, 26.963039455000057],
              [120.36890709700003, 26.95567454600007],
              [120.37387129000001, 26.94358958500004],
              [120.37769616000003, 26.939846096000053],
              [120.384206576, 26.937974351000037],
              [120.38567142000011, 26.935166734000063],
              [120.35254967500009, 26.923773505000042],
              [120.32683353000004, 26.93968333500004],
            ],
          ],
          [
            [
              [121.07400226300001, 27.479483886000082],
              [121.08314306, 27.47301855900008],
              [121.09433796400003, 27.466534876000082],
              [121.10347872300008, 27.460070019000057],
              [121.10336493, 27.451879507000058],
              [121.09312375500008, 27.45289444100007],
              [121.07471580200001, 27.456721832000085],
              [121.06648675400004, 27.454983920000075],
              [121.06945127100005, 27.44676176900009],
              [121.07651703400006, 27.438498163000077],
              [121.06726355500007, 27.43677010400006],
              [121.05915926700004, 27.444133394000062],
              [121.05008762500006, 27.456055828000046],
              [121.04610864400001, 27.465199494000046],
              [121.05340295400003, 27.47332001700005],
              [121.07400226300001, 27.479483886000082],
            ],
          ],
          [
            [
              [121.18165123800009, 27.86465078300006],
              [121.18848717500009, 27.863714911000045],
              [121.18970787900003, 27.855292059000078],
              [121.18930097700002, 27.84829336100006],
              [121.18751061300009, 27.84593333500004],
              [121.18539472700002, 27.843817450000074],
              [121.18034915500004, 27.842271226000037],
              [121.17505944100003, 27.843695380000042],
              [121.17302493600005, 27.841009833000044],
              [121.17481530000009, 27.825873114000046],
              [121.17123457100001, 27.818793036000045],
              [121.16000410200002, 27.818508205000057],
              [121.14747155000009, 27.824367580000057],
              [121.13843834700003, 27.82485586100006],
              [121.13005618600005, 27.82050202000005],
              [121.11638431100005, 27.81781647300005],
              [121.097992384, 27.81781647300005],
              [121.096039259, 27.827866929000038],
              [121.11402428500003, 27.844142971000053],
              [121.13306725400003, 27.84715403900009],
              [121.14918053500003, 27.845770575000074],
              [121.15674889400009, 27.848781643000052],
              [121.15259850400003, 27.852769273000035],
              [121.15365644600001, 27.85643138200004],
              [121.15870201900009, 27.85814036700009],
              [121.16797936300009, 27.85968659100007],
              [121.18165123800009, 27.86465078300006],
            ],
          ],
          [
            [
              [121.04932701900009, 27.950873114000046],
              [121.04468834700003, 27.951971747000073],
              [121.04021243600005, 27.957953192000048],
              [121.04517662900003, 27.96747467700004],
              [121.064789259, 27.98143138200004],
              [121.07016035200002, 27.982896226000037],
              [121.07569420700008, 27.981390692000048],
              [121.08082116000003, 27.98065827000005],
              [121.11133873800009, 27.98379140800006],
              [121.12745201900009, 27.977484442000048],
              [121.13965905000009, 27.965765692000048],
              [121.13917076900009, 27.956976630000042],
              [121.12582441500001, 27.95136139500005],
              [121.10328209700003, 27.946193752000056],
              [121.09294681100005, 27.947739976000037],
              [121.08334394600001, 27.954738674000055],
              [121.07178795700008, 27.95726146000004],
              [121.04932701900009, 27.950873114000046],
            ],
          ],
          [
            [
              [121.86215254000001, 29.12958405200004],
              [121.86459394600001, 29.123846747000073],
              [121.86736087300005, 29.115790106000077],
              [121.86101321700005, 29.10683828300006],
              [121.85352623800009, 29.09756094000005],
              [121.84205162900003, 29.095038153000075],
              [121.83725019600001, 29.09979889500005],
              [121.82667076900009, 29.107977606000077],
              [121.81446373800009, 29.115383205000057],
              [121.80250084700003, 29.11863841400009],
              [121.79273522200003, 29.11855703300006],
              [121.78581790500004, 29.119696356000077],
              [121.78272545700008, 29.124660549000055],
              [121.783539259, 29.132879950000074],
              [121.78598066500001, 29.143744208000044],
              [121.78980553500003, 29.14984772300005],
              [121.79623457100001, 29.14940013200004],
              [121.84392337300005, 29.141913153000075],
              [121.85678144600001, 29.13426341400009],
              [121.86215254000001, 29.12958405200004],
            ],
          ],
          [
            [
              [122.30469811300009, 29.81745026200008],
              [122.31218509200005, 29.79515208500004],
              [122.31470787900003, 29.783677476000037],
              [122.30836022200003, 29.776271877000056],
              [122.29558353000004, 29.779120184000078],
              [122.27247155000009, 29.792141018000052],
              [122.26539147200003, 29.798000393000052],
              [122.25131269600001, 29.80609772300005],
              [122.23755944100003, 29.82379791900007],
              [122.23267662900003, 29.827826239000046],
              [122.23170006600003, 29.83624909100007],
              [122.24773196700005, 29.846096096000053],
              [122.27116946700005, 29.846828518000052],
              [122.28419030000009, 29.84284088700008],
              [122.31202233200008, 29.829046942000048],
              [122.31039472700002, 29.824611721000053],
              [122.30469811300009, 29.81745026200008],
            ],
          ],
          [
            [
              [121.97217858200008, 29.94476959800005],
              [121.98682701900009, 29.92987702000005],
              [121.99350019600001, 29.918850002000056],
              [121.99244225400003, 29.908270575000074],
              [121.97413170700008, 29.89984772300005],
              [121.94613691500001, 29.903957424000055],
              [121.93360436300009, 29.92133209800005],
              [121.94092858200008, 29.93768952000005],
              [121.95191491000003, 29.948065497000073],
              [121.95997155000009, 29.953192450000074],
              [121.96648196700005, 29.951727606000077],
              [121.97022545700008, 29.94684479400007],
              [121.97217858200008, 29.94476959800005],
            ],
          ],
          [
            [
              [122.34571373800009, 30.241929429000038],
              [122.32911217500009, 30.239081122000073],
              [122.31568444100003, 30.240301825000074],
              [122.30534915500004, 30.24013906500005],
              [122.29476972700002, 30.236721096000053],
              [122.28337649800005, 30.235256252000056],
              [122.27759850400003, 30.235541083000044],
              [122.27833092500009, 30.240627346000053],
              [122.287445509, 30.247788804000038],
              [122.30250084700003, 30.252101955000057],
              [122.31299889400009, 30.25995514500005],
              [122.31861412900003, 30.268377997000073],
              [122.32398522200003, 30.27216217700004],
              [122.33187910200002, 30.27366771000004],
              [122.34205162900003, 30.27362702000005],
              [122.38257897200003, 30.277167059000078],
              [122.39991295700008, 30.274603583000044],
              [122.40772545700008, 30.26593659100007],
              [122.41065514400009, 30.254706122000073],
              [122.408539259, 30.243963934000078],
              [122.39584394600001, 30.239447333000044],
              [122.38453209700003, 30.250148830000057],
              [122.38355553500003, 30.261542059000078],
              [122.38062584700003, 30.263739325000074],
              [122.37501061300009, 30.262152411000045],
              [122.35718834700003, 30.247748114000046],
              [122.34571373800009, 30.241929429000038],
            ],
          ],
          [
            [
              [122.52930748800009, 30.720770575000074],
              [122.52637780000009, 30.714178778000075],
              [122.53109785200002, 30.704413153000075],
              [122.52475019600001, 30.70180898600006],
              [122.49317467500009, 30.703111070000034],
              [122.48731530000009, 30.70184967700004],
              [122.47437584700003, 30.70258209800005],
              [122.46656334700003, 30.69912344000005],
              [122.46306399800005, 30.69635651200008],
              [122.46070397200003, 30.69403717700004],
              [122.45525149800005, 30.69399648600006],
              [122.44516035200002, 30.69676341400009],
              [122.431976759, 30.69798411700009],
              [122.42725670700008, 30.703924872000073],
              [122.43262780000009, 30.714829820000034],
              [122.43474368600005, 30.727118231000077],
              [122.42920983200008, 30.738023179000038],
              [122.42994225400003, 30.743068752000056],
              [122.44076582100001, 30.741034247000073],
              [122.45801842500009, 30.73065827000005],
              [122.47291100400003, 30.717230536000045],
              [122.48438561300009, 30.714667059000078],
              [122.49634850400003, 30.716782945000034],
              [122.50196373800009, 30.71898021000004],
              [122.50961347700002, 30.721177476000037],
              [122.52458743600005, 30.723578192000048],
              [122.52930748800009, 30.720770575000074],
            ],
          ],
          [
            [
              [121.76238040500004, 31.37376536700009],
              [121.77418053500003, 31.359198309000078],
              [121.78223717500009, 31.341782945000034],
              [121.78003991000003, 31.32518138200004],
              [121.76636803500003, 31.32062409100007],
              [121.75163821700005, 31.330511786000045],
              [121.72046959700003, 31.35773346600007],
              [121.59880618600005, 31.42914459800005],
              [121.58448326900009, 31.441392320000034],
              [121.59115644600001, 31.445868231000077],
              [121.60254967500009, 31.444240627000056],
              [121.61817467500009, 31.443793036000045],
              [121.69125410200002, 31.419175523000035],
              [121.72559655000009, 31.402736721000053],
              [121.74594160200002, 31.388495184000078],
              [121.76238040500004, 31.37376536700009],
            ],
          ],
          [
            [
              [118.6327429910001, 39.07458077300004],
              [118.64867241500008, 39.05585067800007],
              [118.64873628100008, 39.04465116700004],
              [118.59432056600008, 38.97219739900004],
              [118.51430835400004, 38.919445031000066],
              [118.50269895000008, 38.919027758000084],
              [118.48027591300001, 38.934819522000055],
              [118.49090040700003, 38.94318689100004],
              [118.4706979660001, 38.970550754000044],
              [118.4694771400001, 39.00631855200004],
              [118.47848274500006, 39.04285781300007],
              [118.48819315800006, 39.05049224800007],
              [118.52638107400003, 39.046693882000056],
              [118.559717761, 39.00312515400009],
              [118.57781186700004, 39.00861929800004],
              [118.61019559500005, 39.034034371000075],
              [118.62871121300009, 39.04855385900004],
              [118.61463708200006, 39.06764896700008],
              [118.6327429910001, 39.07458077300004],
            ],
          ],
          [
            [
              [111.68026777400007, 16.578151760000083],
              [111.67888431100005, 16.58112213700008],
              [111.68165123800003, 16.580186265000066],
              [111.68026777400007, 16.578151760000083],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Israel',
        iso3: 'ISR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.24835085700005, 31.211448958000076],
            [34.26439904800014, 31.224193420000105],
            [34.315868775000126, 31.25690460200009],
            [34.350905396000144, 31.289254049000093],
            [34.35379927600013, 31.306358948000124],
            [34.345531046000076, 31.340723776000075],
            [34.345841105000034, 31.357725322000093],
            [34.36733850100012, 31.392813619000023],
            [34.48040653500004, 31.485624492000042],
            [34.495496054000114, 31.49440948500002],
            [34.495702759000096, 31.49440948500002],
            [34.52825891100014, 31.520144348000102],
            [34.55603162304264, 31.539825147238453],
            [34.5201259753058, 31.55832657598094],
            [34.48120412500009, 31.58314132300005],
            [34.48951256600009, 31.600409247000073],
            [34.51392662900008, 31.62714264500005],
            [34.60271243600005, 31.757757880000042],
            [34.60962975400008, 31.76552969000005],
            [34.665944858000046, 31.873887437000064],
            [34.69320722700007, 31.92645905200004],
            [34.711924675000034, 31.951605536000045],
            [34.74333743600005, 32.03986237200007],
            [34.74398847700007, 32.044623114000046],
            [34.74268639400009, 32.05560944200005],
            [34.74333743600005, 32.06037018400008],
            [34.75700931100005, 32.06659577000005],
            [34.83765709700009, 32.28070709800005],
            [34.87322024800005, 32.43032461100006],
            [34.90414472700007, 32.560614325000074],
            [34.90984134200005, 32.57025788000004],
            [34.91586347700007, 32.614894924000055],
            [34.920909050000034, 32.628241278000075],
            [34.91911868600005, 32.64297109600005],
            [34.942067905000044, 32.72451406500005],
            [34.94752037900008, 32.814154364000046],
            [34.95557701900009, 32.83437734600005],
            [34.97046959700009, 32.84137604400007],
            [34.983164910000085, 32.838771877000056],
            [35.00342858200008, 32.82754140800006],
            [35.01872806100005, 32.82501862200007],
            [35.027679884000065, 32.826605536000045],
            [35.06275475400008, 32.85834381700005],
            [35.067067905000044, 32.866848049000055],
            [35.07553144600007, 32.893093166000085],
            [35.07960045700008, 32.90582916900007],
            [35.07781009200005, 32.91787344000005],
            [35.065440300000034, 32.923081773000035],
            [35.07154381600009, 32.937933661000045],
            [35.078461134000065, 32.99884674700007],
            [35.09197024800005, 33.03119538000004],
            [35.09620201900009, 33.05036041900007],
            [35.092133009000065, 33.067694403000075],
            [35.096446160000085, 33.07135651200008],
            [35.10181725400008, 33.07762278900009],
            [35.106455925000034, 33.08075592700004],
            [35.099619988000086, 33.087591864000046],
            [35.104258660000085, 33.08852773600006],
            [35.10523522200009, 33.089016018000095],
            [35.18527307200014, 33.083976542000116],
            [35.189613891000135, 33.08552683600006],
            [35.200672648000136, 33.092735698000084],
            [35.20718387900007, 33.09480275500006],
            [35.21317834500013, 33.094441020000076],
            [35.227337687000045, 33.09136627200003],
            [35.234469035000075, 33.090927023000106],
            [35.27146936000014, 33.101184794000105],
            [35.28366499800006, 33.101184794000105],
            [35.28882469800004, 33.09920123000002],
            [35.294620402000135, 33.09697316500005],
            [35.305782511000075, 33.0893767300001],
            [35.315704387000096, 33.07922231000002],
            [35.32262902800005, 33.06736256900011],
            [35.3319307860001, 33.057156474000024],
            [35.34515995300006, 33.055580342],
            [35.401590617000124, 33.067931010000066],
            [35.449442993000105, 33.08521677700007],
            [35.48013879400014, 33.08738718700006],
            [35.485099731000105, 33.10260589600007],
            [35.503703247000146, 33.13061452300009],
            [35.51228153500011, 33.14740936300005],
            [35.517655884000135, 33.17288584400008],
            [35.520033, 33.22218516100007],
            [35.52778446500008, 33.244250997000066],
            [35.536879516000056, 33.25786773700007],
            [35.542770630000064, 33.27153615300007],
            [35.54948856600009, 33.281018779000064],
            [35.56116744000008, 33.28212982200007],
            [35.56695520000005, 33.27618703200004],
            [35.58504195100005, 33.25220916800002],
            [35.59775435400013, 33.24435435],
            [35.59785770700006, 33.24438018800002],
            [35.59806441300009, 33.244250997000066],
            [35.603852173000064, 33.24009104400004],
            [35.603892448000124, 33.24032262300001],
            [35.604575643000146, 33.244250997000066],
            [35.604575643000146, 33.24435435],
            [35.61806025391335, 33.25612453217926],
            [35.62006514098466, 33.2695358369402],
            [35.63109201987685, 33.27456454531765],
            [35.65214333412559, 33.27665975499792],
            [35.66048954300004, 33.289261169],
            [35.69852339700009, 33.32266998300007],
            [35.716196737000075, 33.32672658300008],
            [35.729425903000106, 33.32781178800006],
            [35.74368859900005, 33.331170757000095],
            [35.75753788200012, 33.33631256100007],
            [35.76942346200008, 33.34264292400009],
            [35.78575321500011, 33.35788747200006],
            [35.80570031700012, 33.39134796200004],
            [35.8210998940001, 33.4067217],
            [35.82244348100005, 33.40137319000006],
            [35.8169657790001, 33.39519785600008],
            [35.81541548700005, 33.378868104000034],
            [35.812314901000036, 33.37336456300004],
            [35.809937785000045, 33.36003204400002],
            [35.79350467900008, 33.34992930200009],
            [35.78575321500011, 33.34287546800006],
            [35.76384240700014, 33.33440053300005],
            [35.80208296700005, 33.312489726000095],
            [35.76859663900012, 33.272698873000095],
            [35.77562463400005, 33.264895732000085],
            [35.80363326000014, 33.248462626],
            [35.80766402200004, 33.20172129400002],
            [35.83019494600006, 33.189990743000024],
            [35.83339888500012, 33.16112945600007],
            [35.82244348100005, 33.14156992600006],
            [35.81148807800008, 33.12676462900005],
            [35.81148807800008, 33.111907654],
            [35.84890181500003, 33.0986784870001],
            [35.84580122900013, 33.08542348200011],
            [35.859030395000104, 32.99020965600003],
            [35.86461145000004, 32.977729797000066],
            [35.88807255000012, 32.944941101000055],
            [35.874016561000076, 32.9223326620001],
            [35.866885213000046, 32.920782369000065],
            [35.8497286380001, 32.895822653],
            [35.83804976400012, 32.86603118900011],
            [35.841873820000046, 32.85357716900002],
            [35.834225708000076, 32.82794565800005],
            [35.78420292100009, 32.777948710000075],
            [35.75759034900011, 32.7443468580001],
            [35.75743453000007, 32.74428151400012],
            [35.740174601000035, 32.740534973000095],
            [35.68519087700008, 32.711234437000044],
            [35.65201460800006, 32.68617136600004],
            [35.64022553738743, 32.68099938753657],
            [35.635994913000104, 32.67914337200004],
            [35.612333850000084, 32.68153519700003],
            [35.611757849000156, 32.681900396000074],
            [35.61222375500006, 32.68154632600009],
            [35.593826945000046, 32.670358378000046],
            [35.578737427000135, 32.653434347000044],
            [35.56984908000004, 32.64676808700004],
            [35.56271773300011, 32.64421010400004],
            [35.560547323000094, 32.64090281200005],
            [35.56003055800005, 32.632686260000085],
            [35.564061320000064, 32.62547739700004],
            [35.572536255000045, 32.6212399300001],
            [35.572536255000045, 32.6150129200001],
            [35.5656116130001, 32.6150129200001],
            [35.5656116130001, 32.60754567500008],
            [35.57129602100014, 32.59855397500003],
            [35.57439660600005, 32.572767436000035],
            [35.5799776610001, 32.560390930000054],
            [35.575843546000044, 32.55496490500009],
            [35.57439660600005, 32.55439646400002],
            [35.57387984200011, 32.55674774200007],
            [35.572536255000045, 32.560390930000054],
            [35.57015913900011, 32.556825257000085],
            [35.5656116130001, 32.54610239700007],
            [35.55941044100007, 32.55294952400003],
            [35.56282108600004, 32.53202056900004],
            [35.5656116130001, 32.525586853],
            [35.55196903500007, 32.525586853],
            [35.55196903500007, 32.518817241000065],
            [35.557240031000106, 32.51933400500009],
            [35.561374145000116, 32.51917897600005],
            [35.568505493000146, 32.51026479100004],
            [35.57057255000012, 32.50602732400007],
            [35.5799776610001, 32.497733256000046],
            [35.5799776610001, 32.49148040800013],
            [35.57098596200012, 32.489206645000124],
            [35.56499149500013, 32.48390981100009],
            [35.56127079200007, 32.47708852200013],
            [35.55941044100007, 32.47039642300011],
            [35.563131144000124, 32.468174337],
            [35.56540490700013, 32.4663139850001],
            [35.568092082000135, 32.464970398000034],
            [35.572536255000045, 32.464195252000124],
            [35.572536255000045, 32.456728007],
            [35.56623173000014, 32.453110657000096],
            [35.55941044100007, 32.450526835000105],
            [35.5656116130001, 32.44370554600006],
            [35.55196903500007, 32.436212464000036],
            [35.554139445000146, 32.434455465000056],
            [35.55620650200012, 32.43479136200004],
            [35.55786014900008, 32.43411956800004],
            [35.55941044100007, 32.429442851000076],
            [35.55196903500007, 32.429442851000076],
            [35.55196903500007, 32.4232416790001],
            [35.558170207000046, 32.41799652200008],
            [35.5591003830001, 32.41396575900008],
            [35.55486291500006, 32.41117523200002],
            [35.54514774600011, 32.40957326300007],
            [35.549591919000136, 32.398540345000086],
            [35.55196903500007, 32.395284730000085],
            [35.556826620000095, 32.39091807100003],
            [35.560960734000105, 32.384716899000026],
            [35.48013879400014, 32.40241607700004],
            [35.456677694000064, 32.40760955900005],
            [35.4328031820001, 32.40825551400012],
            [35.406861613000046, 32.41479258200009],
            [35.40138391100004, 32.44001068100006],
            [35.40179732200005, 32.47096486400007],
            [35.39290897600006, 32.494477641000046],
            [35.363143351000076, 32.510109762000084],
            [35.333377726000094, 32.513081157],
            [35.27043583200009, 32.5104714970001],
            [35.25224572700006, 32.51594919800009],
            [35.22372033700009, 32.5358963020001],
            [35.210359354000104, 32.54186756300008],
            [35.208630819000064, 32.54264007600004],
            [35.19075077300005, 32.54170990000007],
            [35.17679813700005, 32.53269236300004],
            [35.15168339100012, 32.507913513000105],
            [35.12067753100007, 32.491325379],
            [35.09070520000006, 32.479233094],
            [35.06435021900006, 32.46313588500003],
            [35.04471317500014, 32.43411956800004],
            [35.03273030100007, 32.382200261],
            [35.02879683500004, 32.3651573690001],
            [35.02156213400008, 32.34459014900004],
            [35.017841431000136, 32.34221303300008],
            [35.00450891100013, 32.33805308100004],
            [35.00068485500009, 32.33572764100002],
            [34.99655074100008, 32.32304107700007],
            [34.99303674300012, 32.291570130000125],
            [34.98993615800009, 32.27847015400006],
            [35.00244185400004, 32.275137024000045],
            [35.00936649600004, 32.26764394200002],
            [35.01112349400012, 32.257101949000045],
            [35.007609497000146, 32.2443895470001],
            [35.00027144400008, 32.23201304100003],
            [34.96141076700013, 32.20157562300007],
            [34.95822330582358, 32.18645363045635],
            [34.962679791807936, 32.173461604710205],
            [34.97703957997975, 32.1499874406388],
            [34.98694288216721, 32.12399113499929],
            [34.98421701084124, 32.08958361084446],
            [35.00724465165151, 32.02077152583946],
            [34.99677472719839, 32.01110178021516],
            [34.99882684479217, 31.993898551394192],
            [34.99783651457342, 31.97877904177158],
            [34.986695299612464, 31.96722773780952],
            [35.00122306167178, 31.949619417757166],
            [35.00773425979007, 31.944921688320456],
            [35.003775781991884, 31.939211220250588],
            [35.005423668052636, 31.933768662276883],
            [35.016354414099006, 31.926586339499224],
            [35.02990173545989, 31.924429537678243],
            [35.03900623439571, 31.908637388228463],
            [35.03432307590251, 31.86111376156243],
            [35.03010737541427, 31.857008176316018],
            [35.00657193123988, 31.85605625462859],
            [34.99853999394228, 31.85383506580684],
            [34.98976089968676, 31.845584467487935],
            [34.97874033455748, 31.837333131148576],
            [34.97743280988113, 31.833365879853396],
            [34.98031000921158, 31.831317034297474],
            [35.0015502528937, 31.82849879550057],
            [35.01293905040928, 31.829340206405917],
            [35.027492326061555, 31.83273110381888],
            [35.04561994762791, 31.848269923804395],
            [35.056018414924736, 31.853317192495687],
            [35.064436221784085, 31.854578966507752],
            [35.076320184409035, 31.854158377088712],
            [35.08809135909317, 31.84813175230039],
            [35.097584992734284, 31.83126576331115],
            [35.11247153739717, 31.82396262820474],
            [35.12139184230946, 31.824845228008584],
            [35.13695695173535, 31.814292935900568],
            [35.17392202283814, 31.807550771183468],
            [35.18616702598708, 31.80873980807748],
            [35.18576751928955, 31.814117330260267],
            [35.18222691604592, 31.819917869686943],
            [35.183586507691466, 31.82511638377876],
            [35.18993126870403, 31.826656628037277],
            [35.19664425245393, 31.82644003274123],
            [35.21327092528594, 31.818762604584293],
            [35.21576350996944, 31.82011041246549],
            [35.216131732706785, 31.823744582100367],
            [35.216131732706785, 31.839146097064116],
            [35.21295935220051, 31.85339020994335],
            [35.20933377447905, 31.86339827053575],
            [35.20480180232722, 31.871096039388476],
            [35.20525499954241, 31.87725379154405],
            [35.21205295777014, 31.88148700742971],
            [35.22202329650416, 31.87917800469737],
            [35.226555268655986, 31.867247235326715],
            [35.22564887422563, 31.857239592580218],
            [35.22746166308636, 31.85031058813598],
            [35.233353226883736, 31.842611083719227],
            [35.24476813174114, 31.845137554448442],
            [35.24997989971574, 31.84436758974702],
            [35.25374710156695, 31.841456102626626],
            [35.25723105515867, 31.83859264964343],
            [35.25156608996888, 31.831277206618136],
            [35.253605477437205, 31.829351993651873],
            [35.26017683705735, 31.828774421931502],
            [35.26493540781677, 31.826271569381866],
            [35.26063003427254, 31.818762604584293],
            [35.25587146351312, 31.81221582933348],
            [35.2588172454118, 31.800661564506292],
            [35.25995023844976, 31.792572719394943],
            [35.26289602034845, 31.789683674577983],
            [35.25813744958903, 31.783712695845484],
            [35.25269908300684, 31.769650480944406],
            [35.253152280222025, 31.762522240590513],
            [35.25972363984217, 31.75693485754255],
            [35.26281104587061, 31.748625409902317],
            [35.25812211123563, 31.74242272742502],
            [35.25247248439925, 31.73805086062665],
            [35.24921512941513, 31.723572128157603],
            [35.24431493452596, 31.719355765808675],
            [35.242417171187384, 31.710850177021946],
            [35.2379701735134, 31.7093321003689],
            [35.23139881389324, 31.71260918714107],
            [35.227999834779375, 31.71742822200035],
            [35.22414765845033, 31.71916301323139],
            [35.21938908769091, 31.71511511652747],
            [35.20525499954241, 31.723186640137577],
            [35.17942275827699, 31.720102678259998],
            [35.16673323625188, 31.73205245894607],
            [35.154355287312185, 31.733425621318556],
            [35.148952051469365, 31.737348981376908],
            [35.12574182100008, 31.73310292500007],
            [35.11423122540017, 31.71768528609657],
            [35.09338724710549, 31.702415748165066],
            [35.0592262826781, 31.676796684755633],
            [34.97360640500011, 31.630370178000064],
            [34.95531294800014, 31.611870016000054],
            [34.95317554300004, 31.608319958000024],
            [34.93732954900008, 31.58200103800003],
            [34.93288537600006, 31.554922588000053],
            [34.93247196500005, 31.52696563700006],
            [34.926787557000125, 31.49440948500002],
            [34.88172570800015, 31.429865621000076],
            [34.86715295400012, 31.39643097],
            [34.878831827000056, 31.362841289000087],
            [34.90094934100006, 31.34847524000007],
            [34.92740767400005, 31.3449095670001],
            [34.95489953600014, 31.348630270000015],
            [34.98032434100014, 31.356175029000056],
            [35.04016564900013, 31.36320302400007],
            [35.16491255700009, 31.362272848000103],
            [35.22330692500009, 31.381031393000015],
            [35.3323441980001, 31.458804423000046],
            [35.39011844900011, 31.487071432000036],
            [35.45812463400006, 31.491929016000043],
            [35.45853804500007, 31.491618958000075],
            [35.4571275560001, 31.43352439400003],
            [35.456884400000035, 31.42350942000006],
            [35.452853637000146, 31.40082346600009],
            [35.435076945000105, 31.36061920200008],
            [35.416473429000064, 31.331835429000066],
            [35.42391483500006, 31.324600728000078],
            [35.42226119000014, 31.302999980000024],
            [35.40820520000011, 31.282019349],
            [35.395699504000106, 31.257679749000104],
            [35.40117720600011, 31.230291239000067],
            [35.41068566900009, 31.204608053000086],
            [35.42133101400009, 31.184505921000024],
            [35.43621382700013, 31.15954620400005],
            [35.44324182100013, 31.13220937100003],
            [35.438487590000136, 31.103735657000087],
            [35.39156538900011, 31.023947246],
            [35.385157511000045, 30.994646708000047],
            [35.38526086400009, 30.96327911400003],
            [35.374098755000034, 30.945140686000073],
            [35.34711028400005, 30.92270963500006],
            [35.33492802000012, 30.912584534000032],
            [35.32221561700004, 30.88995025600009],
            [35.319528442000035, 30.867315979000054],
            [35.320045206000145, 30.844940084000072],
            [35.31663456200005, 30.82282257100006],
            [35.31084680200007, 30.813314107000068],
            [35.29389693200005, 30.80018829300009],
            [35.28614546700004, 30.792333476000053],
            [35.27953088400005, 30.780241191000087],
            [35.276120239000136, 30.76897572800003],
            [35.27157271300007, 30.74370595300006],
            [35.26388190400013, 30.719966986000102],
            [35.2638212490001, 30.71977976500004],
            [35.205323527000076, 30.617098694000063],
            [35.162122029000045, 30.494677226000093],
            [35.15736779700006, 30.47085439100003],
            [35.140004517000136, 30.43018503800006],
            [35.140004517000136, 30.40615549700003],
            [35.1449654540001, 30.39587188700004],
            [35.1593315020001, 30.37561472600005],
            [35.162122029000045, 30.361403707000065],
            [35.15995162000007, 30.347502747000092],
            [35.154473918000065, 30.336754049],
            [35.147755981000046, 30.32647043900009],
            [35.14176151500004, 30.313964743],
            [35.13235640500005, 30.26187489800013],
            [35.12522505700014, 30.244666647000074],
            [35.12481164500008, 30.216089579000098],
            [35.14527551200007, 30.154904684000073],
            [35.14527551200007, 30.123382060000026],
            [35.129049113000065, 30.08974070200007],
            [35.086261027000035, 30.034033509000025],
            [35.074685506000094, 29.99460439100001],
            [35.07406538900011, 29.982563782000042],
            [35.07034468600011, 29.97372711200005],
            [35.065383748000045, 29.965975647000036],
            [35.06145634000012, 29.9573456830001],
            [35.05411828600012, 29.923394267000063],
            [35.053188110000065, 29.86262278200006],
            [35.04895064200008, 29.842313945000043],
            [35.00254520700008, 29.733095805000076],
            [34.995103801000084, 29.70816192700009],
            [34.98983280400006, 29.651963807000115],
            [34.98032434100014, 29.627004090000028],
            [34.966991822000125, 29.608116354000103],
            [34.959860474000095, 29.586205547000063],
            [34.95557701900009, 29.558986721000053],
            [34.95134524800005, 29.54564036700009],
            [34.94499759200005, 29.536851304000038],
            [34.927744988000086, 29.518011786000045],
            [34.91976972700007, 29.50739166900007],
            [34.91578209700009, 29.50023021000004],
            [34.914073113000086, 29.493801174000055],
            [34.910817905000044, 29.489935614000046],
            [34.903005405000044, 29.48969147300005],
            [34.89372806100005, 29.49054596600007],
            [34.886729362000096, 29.490057684000064],
            [34.87810835800008, 29.5042984010001],
            [34.855267375000096, 29.545717062000065],
            [34.84823938000005, 29.569643250000055],
            [34.85009973200005, 29.638760478000037],
            [34.82436486800009, 29.7416999310001],
            [34.78519413300012, 29.83569936100004],
            [34.74137251800005, 29.94024078400004],
            [34.73506799300009, 29.994552714000108],
            [34.73558475800007, 30.000702210000085],
            [34.7349646400001, 30.006696676],
            [34.73320764200008, 30.012587789000108],
            [34.73041711400003, 30.018168844000016],
            [34.69165979000013, 30.11454539],
            [34.63264530400011, 30.262029928000075],
            [34.599469035000084, 30.344505513000072],
            [34.58841027900007, 30.358819886000063],
            [34.53383996600013, 30.400212708000126],
            [34.52691532400007, 30.409617818000086],
            [34.52474491400005, 30.421141662000096],
            [34.52650191200013, 30.438711650000087],
            [34.536010376000036, 30.468580628],
            [34.536217081000075, 30.482171530000088],
            [34.52629520700009, 30.49457387300005],
            [34.51037886600005, 30.513332418000047],
            [34.50438440000005, 30.530333965000082],
            [34.50221398900004, 30.571675110000015],
            [34.48040653500004, 30.651205139000027],
            [34.4188082280001, 30.79129994700007],
            [34.36785526600005, 30.90741689100004],
            [34.32951135300004, 30.99449167900009],
            [34.29798872900005, 31.078775940000085],
            [34.258611287000065, 31.184144186000125],
            [34.24835085700005, 31.211448958000076],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Palestine',
        iso3: 'PSE',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [34.48120412500009, 31.58314132300005],
              [34.5201259753058, 31.55832657598094],
              [34.55603162304264, 31.539825147238453],
              [34.52825891100014, 31.520144348000102],
              [34.495702759000096, 31.49440948500002],
              [34.495496054000114, 31.49440948500002],
              [34.48040653500004, 31.485624492000042],
              [34.36733850100012, 31.392813619000023],
              [34.345841105000034, 31.357725322000093],
              [34.345531046000076, 31.340723776000075],
              [34.35379927600013, 31.306358948000124],
              [34.350905396000144, 31.289254049000093],
              [34.315868775000126, 31.25690460200009],
              [34.26439904800014, 31.224193420000105],
              [34.24835085700005, 31.211448958000076],
              [34.23039595600011, 31.259230041000123],
              [34.22460819500009, 31.275714824000104],
              [34.200269441306034, 31.314266688845734],
              [34.222666863000086, 31.326646226000037],
              [34.236664259000065, 31.342352606000077],
              [34.28142337300005, 31.376695054000038],
              [34.30160566500007, 31.40770091400009],
              [34.348399285000085, 31.437648830000057],
              [34.368174675000034, 31.46816640800006],
              [34.443369988000086, 31.53457265800006],
              [34.47877037900008, 31.578273830000057],
              [34.48120412500009, 31.58314132300005],
            ],
          ],
          [
            [
              [34.986695299612464, 31.96722773780952],
              [34.99783651457342, 31.97877904177158],
              [34.99882684479217, 31.993898551394192],
              [34.99677472719839, 32.01110178021516],
              [35.00724465165151, 32.02077152583946],
              [34.98421701084124, 32.08958361084446],
              [34.98694288216721, 32.12399113499929],
              [34.97703957997975, 32.1499874406388],
              [34.962679791807936, 32.173461604710205],
              [34.95822330582358, 32.18645363045635],
              [34.96141076700013, 32.20157562300007],
              [35.00027144400008, 32.23201304100003],
              [35.007609497000146, 32.2443895470001],
              [35.01112349400012, 32.257101949000045],
              [35.00936649600004, 32.26764394200002],
              [35.00244185400004, 32.275137024000045],
              [34.98993615800009, 32.27847015400006],
              [34.99303674300012, 32.291570130000125],
              [34.99655074100008, 32.32304107700007],
              [35.00068485500009, 32.33572764100002],
              [35.00450891100013, 32.33805308100004],
              [35.017841431000136, 32.34221303300008],
              [35.02156213400008, 32.34459014900004],
              [35.02879683500004, 32.3651573690001],
              [35.03273030100007, 32.382200261],
              [35.04471317500014, 32.43411956800004],
              [35.06435021900006, 32.46313588500003],
              [35.09070520000006, 32.479233094],
              [35.12067753100007, 32.491325379],
              [35.15168339100012, 32.507913513000105],
              [35.17679813700005, 32.53269236300004],
              [35.19075077300005, 32.54170990000007],
              [35.208630819000064, 32.54264007600004],
              [35.210359354000104, 32.54186756300008],
              [35.22372033700009, 32.5358963020001],
              [35.25224572700006, 32.51594919800009],
              [35.27043583200009, 32.5104714970001],
              [35.333377726000094, 32.513081157],
              [35.363143351000076, 32.510109762000084],
              [35.39290897600006, 32.494477641000046],
              [35.40179732200005, 32.47096486400007],
              [35.40138391100004, 32.44001068100006],
              [35.406861613000046, 32.41479258200009],
              [35.4328031820001, 32.40825551400012],
              [35.456677694000064, 32.40760955900005],
              [35.48013879400014, 32.40241607700004],
              [35.560960734000105, 32.384716899000026],
              [35.563957967000135, 32.37704294900006],
              [35.5656116130001, 32.367947896000075],
              [35.55941044100007, 32.367947896000075],
              [35.55941044100007, 32.37482086200005],
              [35.55196903500007, 32.37482086200005],
              [35.55196903500007, 32.367947896000075],
              [35.557343384000035, 32.35820688900013],
              [35.556516560000034, 32.32820872000006],
              [35.5656116130001, 32.31335174500005],
              [35.56116744000008, 32.30169871100007],
              [35.56085738100006, 32.28263010700009],
              [35.56457808400012, 32.263587342],
              [35.572536255000045, 32.25190846800005],
              [35.56757531800008, 32.24950551400009],
              [35.56375126100005, 32.24681833900006],
              [35.561064087000034, 32.24314931200006],
              [35.55941044100007, 32.23759409600005],
              [35.572536255000045, 32.23759409600005],
              [35.55956241700005, 32.19037087200006],
              [35.55517297300014, 32.17439382],
              [35.55941044100007, 32.162534079000054],
              [35.55941044100007, 32.15509267200004],
              [35.5512455650001, 32.15152699800008],
              [35.546698038000045, 32.14703114900006],
              [35.546698038000045, 32.141605123000076],
              [35.55196903500007, 32.13519724500013],
              [35.53522587100014, 32.11080596900011],
              [35.53460575300005, 32.099230449000046],
              [35.54514774600011, 32.086828105000095],
              [35.528301229000135, 32.075097555000085],
              [35.52282352700007, 32.0578376270001],
              [35.524683879000065, 32.01169057200006],
              [35.535535929000105, 31.988229473],
              [35.53770634000011, 31.977584127000014],
              [35.53832645600005, 31.963941549000097],
              [35.53998010300012, 31.955621643000043],
              [35.54587121600014, 31.944562887000032],
              [35.54514774600011, 31.936604716000076],
              [35.5406002200001, 31.932005514000124],
              [35.53367557700011, 31.930300192000047],
              [35.527474406000124, 31.92735463500007],
              [35.524683879000065, 31.919241435000046],
              [35.54907515400009, 31.839194641000105],
              [35.53832645600005, 31.826740621000013],
              [35.53832645600005, 31.8192992150001],
              [35.55941044100007, 31.765349019000055],
              [35.527577758000064, 31.73506663000002],
              [35.50247856700008, 31.685360389000024],
              [35.48013879400014, 31.64111887600008],
              [35.46422245300005, 31.568565165000066],
              [35.45874475100004, 31.49440948500002],
              [35.45905481000011, 31.4928075160001],
              [35.45915816300004, 31.49187734000013],
              [35.45874475100004, 31.49156728100006],
              [35.45812463400006, 31.491929016000043],
              [35.39011844900011, 31.487071432000036],
              [35.3323441980001, 31.458804423000046],
              [35.22330692500009, 31.381031393000015],
              [35.16491255700009, 31.362272848000103],
              [35.04016564900013, 31.36320302400007],
              [34.98032434100014, 31.356175029000056],
              [34.95489953600014, 31.348630270000015],
              [34.92740767400005, 31.3449095670001],
              [34.90094934100006, 31.34847524000007],
              [34.878831827000056, 31.362841289000087],
              [34.86715295400012, 31.39643097],
              [34.88172570800015, 31.429865621000076],
              [34.926787557000125, 31.49440948500002],
              [34.93247196500005, 31.52696563700006],
              [34.93288537600006, 31.554922588000053],
              [34.93732954900008, 31.58200103800003],
              [34.95317554300004, 31.608319958000024],
              [34.95531294800014, 31.611870016000054],
              [34.97360640500011, 31.630370178000064],
              [35.0592262826781, 31.676796684755633],
              [35.09338724710549, 31.702415748165066],
              [35.11423122540017, 31.71768528609657],
              [35.12574182100008, 31.73310292500007],
              [35.148952051469365, 31.737348981376908],
              [35.154355287312185, 31.733425621318556],
              [35.16673323625188, 31.73205245894607],
              [35.17942275827699, 31.720102678259998],
              [35.20525499954241, 31.723186640137577],
              [35.21938908769091, 31.71511511652747],
              [35.22414765845033, 31.71916301323139],
              [35.227999834779375, 31.71742822200035],
              [35.23139881389324, 31.71260918714107],
              [35.2379701735134, 31.7093321003689],
              [35.242417171187384, 31.710850177021946],
              [35.24431493452596, 31.719355765808675],
              [35.24921512941513, 31.723572128157603],
              [35.25247248439925, 31.73805086062665],
              [35.25812211123563, 31.74242272742502],
              [35.26281104587061, 31.748625409902317],
              [35.25972363984217, 31.75693485754255],
              [35.253152280222025, 31.762522240590513],
              [35.25269908300684, 31.769650480944406],
              [35.25813744958903, 31.783712695845484],
              [35.26289602034845, 31.789683674577983],
              [35.25995023844976, 31.792572719394943],
              [35.2588172454118, 31.800661564506292],
              [35.25587146351312, 31.81221582933348],
              [35.26063003427254, 31.818762604584293],
              [35.26493540781677, 31.826271569381866],
              [35.26017683705735, 31.828774421931502],
              [35.253605477437205, 31.829351993651873],
              [35.25156608996888, 31.831277206618136],
              [35.25723105515867, 31.83859264964343],
              [35.25374710156695, 31.841456102626626],
              [35.24997989971574, 31.84436758974702],
              [35.24476813174114, 31.845137554448442],
              [35.233353226883736, 31.842611083719227],
              [35.22746166308636, 31.85031058813598],
              [35.22564887422563, 31.857239592580218],
              [35.226555268655986, 31.867247235326715],
              [35.22202329650416, 31.87917800469737],
              [35.21205295777014, 31.88148700742971],
              [35.20525499954241, 31.87725379154405],
              [35.20480180232722, 31.871096039388476],
              [35.20933377447905, 31.86339827053575],
              [35.21295935220051, 31.85339020994335],
              [35.216131732706785, 31.839146097064116],
              [35.216131732706785, 31.823744582100367],
              [35.21576350996944, 31.82011041246549],
              [35.21327092528594, 31.818762604584293],
              [35.19664425245393, 31.82644003274123],
              [35.18993126870403, 31.826656628037277],
              [35.183586507691466, 31.82511638377876],
              [35.18222691604592, 31.819917869686943],
              [35.18576751928955, 31.814117330260267],
              [35.18616702598708, 31.80873980807748],
              [35.17392202283814, 31.807550771183468],
              [35.13695695173535, 31.814292935900568],
              [35.12139184230946, 31.824845228008584],
              [35.11247153739717, 31.82396262820474],
              [35.097584992734284, 31.83126576331115],
              [35.08809135909317, 31.84813175230039],
              [35.076320184409035, 31.854158377088712],
              [35.064436221784085, 31.854578966507752],
              [35.056018414924736, 31.853317192495687],
              [35.04561994762791, 31.848269923804395],
              [35.027492326061555, 31.83273110381888],
              [35.01293905040928, 31.829340206405917],
              [35.0015502528937, 31.82849879550057],
              [34.98031000921158, 31.831317034297474],
              [34.97743280988113, 31.833365879853396],
              [34.97874033455748, 31.837333131148576],
              [34.98976089968676, 31.845584467487935],
              [34.99853999394228, 31.85383506580684],
              [35.00657193123988, 31.85605625462859],
              [35.03010737541427, 31.857008176316018],
              [35.03432307590251, 31.86111376156243],
              [35.03900623439571, 31.908637388228463],
              [35.02990173545989, 31.924429537678243],
              [35.016354414099006, 31.926586339499224],
              [35.005423668052636, 31.933768662276883],
              [35.003775781991884, 31.939211220250588],
              [35.00773425979007, 31.944921688320456],
              [35.00122306167178, 31.949619417757166],
              [34.986695299612464, 31.96722773780952],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Lebanon',
        iso3: 'LBN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [35.10523522200009, 33.089016018000095],
            [35.10523522200009, 33.09064362200007],
            [35.106455925000034, 33.095038153000075],
            [35.101898634000065, 33.09446849200009],
            [35.10043379000007, 33.095689195000034],
            [35.10043379000007, 33.09821198100008],
            [35.099619988000086, 33.101263739000046],
            [35.105804884000065, 33.11245351800005],
            [35.11475670700008, 33.12372467700004],
            [35.12549889400009, 33.132513739000046],
            [35.14763431100005, 33.140326239000046],
            [35.15479576900009, 33.15029531500005],
            [35.16098066500007, 33.16168854400007],
            [35.16781660200007, 33.17015208500004],
            [35.16179446700005, 33.176947333000044],
            [35.16781660200007, 33.17788320500006],
            [35.17107181100005, 33.17658112200007],
            [35.17465254000007, 33.17015208500004],
            [35.20476321700005, 33.22479889500005],
            [35.20915774800005, 33.25462474200009],
            [35.18832441500007, 33.28001536700009],
            [35.209727410000085, 33.293402411000045],
            [35.22478274800005, 33.31199778900009],
            [35.24366295700008, 33.35569896000004],
            [35.246104363000086, 33.36888255400004],
            [35.246755405000044, 33.395819403000075],
            [35.25049889400009, 33.40973541900007],
            [35.26872806100005, 33.43260325700004],
            [35.27507571700005, 33.444973049000055],
            [35.27100670700008, 33.45750560100004],
            [35.323008660000085, 33.49091217700004],
            [35.34913170700008, 33.51386139500005],
            [35.360362175000034, 33.54344310100004],
            [35.36247806100005, 33.556341864000046],
            [35.40064537900008, 33.64313385600008],
            [35.39437910200007, 33.64996979400007],
            [35.40992272200009, 33.66128164300005],
            [35.42164147200009, 33.702337958000044],
            [35.438487175000034, 33.711371161000045],
            [35.437836134000065, 33.72337474200009],
            [35.477305535000085, 33.803900458000044],
            [35.48129316500007, 33.82367584800005],
            [35.48300214900007, 33.86517975500004],
            [35.48324629000007, 33.87246328300006],
            [35.47999108200008, 33.88426341400009],
            [35.47380618600005, 33.893866278000075],
            [35.47046959700009, 33.90208567900004],
            [35.47584069100009, 33.90997955900008],
            [35.48658287900008, 33.912990627000056],
            [35.49976647200009, 33.91120026200008],
            [35.51124108200008, 33.90704987200007],
            [35.51734459700009, 33.90253327000005],
            [35.524180535000085, 33.90253327000005],
            [35.533864780000044, 33.90704987200007],
            [35.54810631600009, 33.90619538000004],
            [35.55746504000007, 33.90566640800006],
            [35.57203209700009, 33.90997955900008],
            [35.57837975400008, 33.91669342700004],
            [35.587901238000086, 33.93659088700008],
            [35.59310957100007, 33.94476959800005],
            [35.59343509200005, 33.948919989000046],
            [35.59197024800005, 33.950425523000035],
            [35.58570397200009, 33.95091380400004],
            [35.59424889400009, 33.95929596600007],
            [35.60629316500007, 33.98322174700007],
            [35.61353600400008, 33.99315013200004],
            [35.620127800000034, 33.99510325700004],
            [35.636729363000086, 33.995306708000044],
            [35.64087975400008, 33.99941640800006],
            [35.64039147200009, 34.00853099200009],
            [35.635752800000034, 34.01325104400007],
            [35.63038170700008, 34.01609935100004],
            [35.62720787900008, 34.01984284100007],
            [35.626963738000086, 34.044256903000075],
            [35.643321160000085, 34.08808014500005],
            [35.64771569100009, 34.119126695000034],
            [35.644541863000086, 34.130845445000034],
            [35.63038170700008, 34.15281810100004],
            [35.62720787900008, 34.16693756700005],
            [35.62720787900008, 34.20111725500004],
            [35.63038170700008, 34.20844147300005],
            [35.644541863000086, 34.21698639500005],
            [35.64771569100009, 34.22215403900009],
            [35.64828535200007, 34.253607489000046],
            [35.653005405000044, 34.284857489000046],
            [35.66521243600005, 34.31134674700007],
            [35.68873131600009, 34.32831452000005],
            [35.705821160000085, 34.31659577000005],
            [35.72217858200008, 34.33746979400007],
            [35.737315300000034, 34.369208075000074],
            [35.750743035000085, 34.38979726800005],
            [35.80616295700008, 34.41498444200005],
            [35.82357832100007, 34.43451569200005],
            [35.805430535000085, 34.458685614000046],
            [35.805430535000085, 34.464911200000074],
            [35.82398522200009, 34.46084219000005],
            [35.903330925000034, 34.47797272300005],
            [35.95679772200009, 34.52008698100008],
            [35.97291100400008, 34.52977122600004],
            [35.983164910000085, 34.53864166900007],
            [35.98878014400009, 34.552720445000034],
            [35.98959394600007, 34.599676825000074],
            [35.98682701900009, 34.620794989000046],
            [35.98064212300005, 34.63849518400008],
            [35.969899655243296, 34.649848955419216],
            [35.98264042200009, 34.650237529],
            [35.991425415000094, 34.648222148000045],
            [35.99876346800005, 34.645379944000055],
            [36.01623010300011, 34.633649394000074],
            [36.03793420400012, 34.628430075000054],
            [36.06077518800004, 34.62791331000001],
            [36.08723352100009, 34.631013896000056],
            [36.112139913000135, 34.62953226600003],
            [36.15585982200014, 34.626931458000044],
            [36.16020064300005, 34.62806833900005],
            [36.17218957500006, 34.634062806000074],
            [36.17828739400005, 34.63530304000004],
            [36.183351684000115, 34.63349436500003],
            [36.19513391100014, 34.62620798800005],
            [36.201231730000075, 34.62445098900007],
            [36.261589803000106, 34.62724151600004],
            [36.27151167800008, 34.63096221900004],
            [36.28071008300009, 34.63912709600005],
            [36.28443078600009, 34.64832550100006],
            [36.2848441970001, 34.667910868],
            [36.288151489000086, 34.675558981000066],
            [36.30892541500015, 34.68754791300002],
            [36.323808228000075, 34.67948638900013],
            [36.34737268000009, 34.64413971000003],
            [36.367526489000056, 34.62920522100008],
            [36.391194296000094, 34.62248728400006],
            [36.41599898300012, 34.62290069700005],
            [36.44018355300011, 34.62936025],
            [36.43625614400014, 34.59783762600004],
            [36.42912479600011, 34.593186747000075],
            [36.41847945100011, 34.60031809500002],
            [36.4036999920001, 34.603832092000076],
            [36.3889205320001, 34.59623565700009],
            [36.38685347500012, 34.58424672400007],
            [36.388093709000145, 34.569518942000045],
            [36.383546183000135, 34.553809306000076],
            [36.364012492000086, 34.54109690400013],
            [36.33662398200005, 34.52884959],
            [36.319880818000115, 34.514121806],
            [36.329851247000136, 34.49860331600003],
            [36.332696574000124, 34.49417470300007],
            [36.33538374800014, 34.4934770710001],
            [36.338174276000075, 34.49329620400003],
            [36.34096480300013, 34.4934770710001],
            [36.34365197700009, 34.49417470300007],
            [36.363082316000146, 34.499032288000095],
            [36.392331177000074, 34.5001433310001],
            [36.419719686000064, 34.49833465600001],
            [36.43346561700008, 34.49432973300013],
            [36.43346561700008, 34.49417470300007],
            [36.43987349400004, 34.47745737700005],
            [36.44979536900013, 34.464538269000045],
            [36.46323124200006, 34.4552365120001],
            [36.48018111100009, 34.44913869300005],
            [36.49465051200008, 34.434255880000094],
            [36.501885213000094, 34.43030263300004],
            [36.50922326700004, 34.43242136700009],
            [36.525139608000075, 34.42293874100004],
            [36.53061730900009, 34.41417958600006],
            [36.52979048700007, 34.40309499100003],
            [36.5262764900001, 34.38668772400008],
            [36.52358931400005, 34.37978892000011],
            [36.51997196400009, 34.375060527000116],
            [36.516768026000136, 34.36986704500002],
            [36.51594120300007, 34.361650493000084],
            [36.51862837700014, 34.353640645],
            [36.52358931400005, 34.34588918100009],
            [36.54519006300012, 34.32072275900005],
            [36.55583540800012, 34.31108510400013],
            [36.562966756000094, 34.30850128200002],
            [36.57030480900005, 34.30896637000005],
            [36.57681604000004, 34.30767445900001],
            [36.581983683000146, 34.299897156],
            [36.579916626000056, 34.286900533000065],
            [36.57030480900005, 34.27586761500005],
            [36.56276005100011, 34.26294850700005],
            [36.567514282000104, 34.244138285000034],
            [36.57402551200005, 34.229746399000035],
            [36.59821008300014, 34.209850972000126],
            [36.60355389100005, 34.20010086600003],
            [36.604101196000045, 34.1991022750001],
            [36.5758858640001, 34.17326405900009],
            [36.552734823000094, 34.14099212700002],
            [36.50798303200014, 34.10918528300009],
            [36.488449341000035, 34.08864390100008],
            [36.48266158000007, 34.074510397000054],
            [36.480697876000136, 34.062754008000056],
            [36.47522017400013, 34.05350392700005],
            [36.45889042200008, 34.046708476],
            [36.445144490000075, 34.04614003600004],
            [36.423647095000035, 34.05280629500005],
            [36.41217492700008, 34.05363311800009],
            [36.39109094300005, 34.044718933000055],
            [36.35781132000011, 34.00955312100011],
            [36.31802046700011, 33.98051096600001],
            [36.302310832000046, 33.96438791900003],
            [36.288564901000086, 33.94650787400006],
            [36.2671708580001, 33.91038604800006],
            [36.26892785600006, 33.90676869800008],
            [36.27533573400012, 33.89720855700007],
            [36.28164025900014, 33.89111073800002],
            [36.31109582500005, 33.87199045800013],
            [36.35036991400011, 33.866409404000095],
            [36.3676298420001, 33.8575468960001],
            [36.369593547000136, 33.83700551400004],
            [36.35750126200014, 33.82377634700002],
            [36.33827762900012, 33.82119252600002],
            [36.300553833000095, 33.82868560800007],
            [36.2491874590001, 33.84974375400007],
            [36.23182417800007, 33.85253428100005],
            [36.21663130700006, 33.847754212000055],
            [36.20267867000007, 33.83829742400006],
            [36.18655562300012, 33.83021006300008],
            [36.16567834500012, 33.82979665200007],
            [36.15761682100015, 33.83405995700012],
            [36.144904419000056, 33.84741831500004],
            [36.13828983600007, 33.850622253000026],
            [36.10242639100005, 33.83227712100005],
            [36.085063111000125, 33.826050110000054],
            [36.06645959400004, 33.82199351100006],
            [36.05043990100012, 33.81643829400004],
            [36.040518026000086, 33.80561208100009],
            [36.027082154000084, 33.784295553],
            [35.99400923600007, 33.760705262],
            [35.98026330600004, 33.74354868600004],
            [35.97416548700011, 33.732154032000025],
            [35.95587203000014, 33.71812388100004],
            [35.94843062300009, 33.70920969600009],
            [35.9469836830001, 33.70083811400012],
            [35.949877564000076, 33.682699687000095],
            [35.94719038900007, 33.67308787100008],
            [35.942436157000145, 33.66921213800005],
            [35.92941369700014, 33.665078024000096],
            [35.92538293400014, 33.66166737900009],
            [35.9215588780001, 33.64029917400008],
            [35.93478804500006, 33.633400371],
            [35.956905558000074, 33.629938050000064],
            [35.98026330600004, 33.61900848400008],
            [35.99452600100011, 33.61570119200009],
            [36.012922811000124, 33.608027242],
            [36.02966597500006, 33.59764027900009],
            [36.03845096800006, 33.58634897900002],
            [36.03524702900006, 33.56779714000008],
            [36.01984745300007, 33.55263010600005],
            [35.999280233000036, 33.54126129200007],
            [35.98026330600004, 33.53394907700009],
            [35.95680220500009, 33.53420745800004],
            [35.93323775200008, 33.52782542000001],
            [35.921868937000056, 33.51457041400003],
            [35.935408163000034, 33.4942615770001],
            [35.91949182100012, 33.46235138000013],
            [35.88848596200012, 33.44041473400007],
            [35.870089152000105, 33.431242167000065],
            [35.845116087000065, 33.418742463000044],
            [35.8210998940001, 33.4067217],
            [35.80570031700012, 33.39134796200004],
            [35.78575321500011, 33.35788747200006],
            [35.76942346200008, 33.34264292400009],
            [35.75753788200012, 33.33631256100007],
            [35.74368859900005, 33.331170757000095],
            [35.729425903000106, 33.32781178800006],
            [35.716196737000075, 33.32672658300008],
            [35.69852339700009, 33.32266998300007],
            [35.66048954300004, 33.289261169],
            [35.65214333412559, 33.27665975499792],
            [35.63109201987685, 33.27456454531765],
            [35.62006514098466, 33.2695358369402],
            [35.61806025391335, 33.25612453217926],
            [35.604575643000146, 33.24435435],
            [35.604575643000146, 33.244250997000066],
            [35.603892448000124, 33.24032262300001],
            [35.603852173000064, 33.24009104400004],
            [35.59806441300009, 33.244250997000066],
            [35.59785770700006, 33.24438018800002],
            [35.59775435400013, 33.24435435],
            [35.58504195100005, 33.25220916800002],
            [35.56695520000005, 33.27618703200004],
            [35.56116744000008, 33.28212982200007],
            [35.54948856600009, 33.281018779000064],
            [35.542770630000064, 33.27153615300007],
            [35.536879516000056, 33.25786773700007],
            [35.52778446500008, 33.244250997000066],
            [35.520033, 33.22218516100007],
            [35.517655884000135, 33.17288584400008],
            [35.51228153500011, 33.14740936300005],
            [35.503703247000146, 33.13061452300009],
            [35.485099731000105, 33.10260589600007],
            [35.48013879400014, 33.08738718700006],
            [35.449442993000105, 33.08521677700007],
            [35.401590617000124, 33.067931010000066],
            [35.34515995300006, 33.055580342],
            [35.3319307860001, 33.057156474000024],
            [35.32262902800005, 33.06736256900011],
            [35.315704387000096, 33.07922231000002],
            [35.305782511000075, 33.0893767300001],
            [35.294620402000135, 33.09697316500005],
            [35.28882469800004, 33.09920123000002],
            [35.28366499800006, 33.101184794000105],
            [35.27146936000014, 33.101184794000105],
            [35.234469035000075, 33.090927023000106],
            [35.227337687000045, 33.09136627200003],
            [35.21317834500013, 33.094441020000076],
            [35.20718387900007, 33.09480275500006],
            [35.200672648000136, 33.092735698000084],
            [35.189613891000135, 33.08552683600006],
            [35.18527307200014, 33.083976542000116],
            [35.10523522200009, 33.089016018000095],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Syria',
        iso3: 'SYR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [35.75759034900011, 32.7443468580001],
            [35.78420292100009, 32.777948710000075],
            [35.834225708000076, 32.82794565800005],
            [35.841873820000046, 32.85357716900002],
            [35.83804976400012, 32.86603118900011],
            [35.8497286380001, 32.895822653],
            [35.866885213000046, 32.920782369000065],
            [35.874016561000076, 32.9223326620001],
            [35.88807255000012, 32.944941101000055],
            [35.86461145000004, 32.977729797000066],
            [35.859030395000104, 32.99020965600003],
            [35.84580122900013, 33.08542348200011],
            [35.84890181500003, 33.0986784870001],
            [35.81148807800008, 33.111907654],
            [35.81148807800008, 33.12676462900005],
            [35.82244348100005, 33.14156992600006],
            [35.83339888500012, 33.16112945600007],
            [35.83019494600006, 33.189990743000024],
            [35.80766402200004, 33.20172129400002],
            [35.80363326000014, 33.248462626],
            [35.77562463400005, 33.264895732000085],
            [35.76859663900012, 33.272698873000095],
            [35.80208296700005, 33.312489726000095],
            [35.76384240700014, 33.33440053300005],
            [35.78575321500011, 33.34287546800006],
            [35.79350467900008, 33.34992930200009],
            [35.809937785000045, 33.36003204400002],
            [35.812314901000036, 33.37336456300004],
            [35.81541548700005, 33.378868104000034],
            [35.8169657790001, 33.39519785600008],
            [35.82244348100005, 33.40137319000006],
            [35.8210998940001, 33.4067217],
            [35.845116087000065, 33.418742463000044],
            [35.870089152000105, 33.431242167000065],
            [35.88848596200012, 33.44041473400007],
            [35.91949182100012, 33.46235138000013],
            [35.935408163000034, 33.4942615770001],
            [35.921868937000056, 33.51457041400003],
            [35.93323775200008, 33.52782542000001],
            [35.95680220500009, 33.53420745800004],
            [35.98026330600004, 33.53394907700009],
            [35.999280233000036, 33.54126129200007],
            [36.01984745300007, 33.55263010600005],
            [36.03524702900006, 33.56779714000008],
            [36.03845096800006, 33.58634897900002],
            [36.02966597500006, 33.59764027900009],
            [36.012922811000124, 33.608027242],
            [35.99452600100011, 33.61570119200009],
            [35.98026330600004, 33.61900848400008],
            [35.956905558000074, 33.629938050000064],
            [35.93478804500006, 33.633400371],
            [35.9215588780001, 33.64029917400008],
            [35.92538293400014, 33.66166737900009],
            [35.92941369700014, 33.665078024000096],
            [35.942436157000145, 33.66921213800005],
            [35.94719038900007, 33.67308787100008],
            [35.949877564000076, 33.682699687000095],
            [35.9469836830001, 33.70083811400012],
            [35.94843062300009, 33.70920969600009],
            [35.95587203000014, 33.71812388100004],
            [35.97416548700011, 33.732154032000025],
            [35.98026330600004, 33.74354868600004],
            [35.99400923600007, 33.760705262],
            [36.027082154000084, 33.784295553],
            [36.040518026000086, 33.80561208100009],
            [36.05043990100012, 33.81643829400004],
            [36.06645959400004, 33.82199351100006],
            [36.085063111000125, 33.826050110000054],
            [36.10242639100005, 33.83227712100005],
            [36.13828983600007, 33.850622253000026],
            [36.144904419000056, 33.84741831500004],
            [36.15761682100015, 33.83405995700012],
            [36.16567834500012, 33.82979665200007],
            [36.18655562300012, 33.83021006300008],
            [36.20267867000007, 33.83829742400006],
            [36.21663130700006, 33.847754212000055],
            [36.23182417800007, 33.85253428100005],
            [36.2491874590001, 33.84974375400007],
            [36.300553833000095, 33.82868560800007],
            [36.33827762900012, 33.82119252600002],
            [36.35750126200014, 33.82377634700002],
            [36.369593547000136, 33.83700551400004],
            [36.3676298420001, 33.8575468960001],
            [36.35036991400011, 33.866409404000095],
            [36.31109582500005, 33.87199045800013],
            [36.28164025900014, 33.89111073800002],
            [36.27533573400012, 33.89720855700007],
            [36.26892785600006, 33.90676869800008],
            [36.2671708580001, 33.91038604800006],
            [36.288564901000086, 33.94650787400006],
            [36.302310832000046, 33.96438791900003],
            [36.31802046700011, 33.98051096600001],
            [36.35781132000011, 34.00955312100011],
            [36.39109094300005, 34.044718933000055],
            [36.41217492700008, 34.05363311800009],
            [36.423647095000035, 34.05280629500005],
            [36.445144490000075, 34.04614003600004],
            [36.45889042200008, 34.046708476],
            [36.47522017400013, 34.05350392700005],
            [36.480697876000136, 34.062754008000056],
            [36.48266158000007, 34.074510397000054],
            [36.488449341000035, 34.08864390100008],
            [36.50798303200014, 34.10918528300009],
            [36.552734823000094, 34.14099212700002],
            [36.5758858640001, 34.17326405900009],
            [36.604101196000045, 34.1991022750001],
            [36.60355389100005, 34.20010086600003],
            [36.59821008300014, 34.209850972000126],
            [36.57402551200005, 34.229746399000035],
            [36.567514282000104, 34.244138285000034],
            [36.56276005100011, 34.26294850700005],
            [36.57030480900005, 34.27586761500005],
            [36.579916626000056, 34.286900533000065],
            [36.581983683000146, 34.299897156],
            [36.57681604000004, 34.30767445900001],
            [36.57030480900005, 34.30896637000005],
            [36.562966756000094, 34.30850128200002],
            [36.55583540800012, 34.31108510400013],
            [36.54519006300012, 34.32072275900005],
            [36.52358931400005, 34.34588918100009],
            [36.51862837700014, 34.353640645],
            [36.51594120300007, 34.361650493000084],
            [36.516768026000136, 34.36986704500002],
            [36.51997196400009, 34.375060527000116],
            [36.52358931400005, 34.37978892000011],
            [36.5262764900001, 34.38668772400008],
            [36.52979048700007, 34.40309499100003],
            [36.53061730900009, 34.41417958600006],
            [36.525139608000075, 34.42293874100004],
            [36.50922326700004, 34.43242136700009],
            [36.501885213000094, 34.43030263300004],
            [36.49465051200008, 34.434255880000094],
            [36.48018111100009, 34.44913869300005],
            [36.46323124200006, 34.4552365120001],
            [36.44979536900013, 34.464538269000045],
            [36.43987349400004, 34.47745737700005],
            [36.43346561700008, 34.49417470300007],
            [36.43346561700008, 34.49432973300013],
            [36.419719686000064, 34.49833465600001],
            [36.392331177000074, 34.5001433310001],
            [36.363082316000146, 34.499032288000095],
            [36.34365197700009, 34.49417470300007],
            [36.34096480300013, 34.4934770710001],
            [36.338174276000075, 34.49329620400003],
            [36.33538374800014, 34.4934770710001],
            [36.332696574000124, 34.49417470300007],
            [36.329851247000136, 34.49860331600003],
            [36.319880818000115, 34.514121806],
            [36.33662398200005, 34.52884959],
            [36.364012492000086, 34.54109690400013],
            [36.383546183000135, 34.553809306000076],
            [36.388093709000145, 34.569518942000045],
            [36.38685347500012, 34.58424672400007],
            [36.3889205320001, 34.59623565700009],
            [36.4036999920001, 34.603832092000076],
            [36.41847945100011, 34.60031809500002],
            [36.42912479600011, 34.593186747000075],
            [36.43625614400014, 34.59783762600004],
            [36.44018355300011, 34.62936025],
            [36.41599898300012, 34.62290069700005],
            [36.391194296000094, 34.62248728400006],
            [36.367526489000056, 34.62920522100008],
            [36.34737268000009, 34.64413971000003],
            [36.323808228000075, 34.67948638900013],
            [36.30892541500015, 34.68754791300002],
            [36.288151489000086, 34.675558981000066],
            [36.2848441970001, 34.667910868],
            [36.28443078600009, 34.64832550100006],
            [36.28071008300009, 34.63912709600005],
            [36.27151167800008, 34.63096221900004],
            [36.261589803000106, 34.62724151600004],
            [36.201231730000075, 34.62445098900007],
            [36.19513391100014, 34.62620798800005],
            [36.183351684000115, 34.63349436500003],
            [36.17828739400005, 34.63530304000004],
            [36.17218957500006, 34.634062806000074],
            [36.16020064300005, 34.62806833900005],
            [36.15585982200014, 34.626931458000044],
            [36.112139913000135, 34.62953226600003],
            [36.08723352100009, 34.631013896000056],
            [36.06077518800004, 34.62791331000001],
            [36.03793420400012, 34.628430075000054],
            [36.01623010300011, 34.633649394000074],
            [35.99876346800005, 34.645379944000055],
            [35.991425415000094, 34.648222148000045],
            [35.98264042200009, 34.650237529],
            [35.969899655243296, 34.649848955419216],
            [35.96566816500007, 34.66844310100004],
            [35.94743899800005, 34.69953034100007],
            [35.94092858200008, 34.726223049000055],
            [35.93116295700008, 34.74095286700009],
            [35.92896569100009, 34.74982330900008],
            [35.92896569100009, 34.790716864000046],
            [35.92603600400008, 34.796942450000074],
            [35.90845787900008, 34.82176341400009],
            [35.90455162900008, 34.83177317900004],
            [35.899099155000044, 34.852769273000035],
            [35.86687259200005, 34.92422109600005],
            [35.87289472700007, 34.92690664300005],
            [35.87354576900009, 34.931626695000034],
            [35.879567905000044, 34.93805573100008],
            [35.88135826900009, 34.944973049000055],
            [35.879567905000044, 34.95189036700009],
            [35.87354576900009, 34.958319403000075],
            [35.87354576900009, 34.96515534100007],
            [35.87859134200005, 34.96954987200007],
            [35.878916863000086, 34.97016022300005],
            [35.87663821700005, 34.97166575700004],
            [35.87354576900009, 34.97882721600007],
            [35.881602410000085, 34.99286530200004],
            [35.887380405000044, 35.00018952000005],
            [35.89535566500007, 35.00678131700005],
            [35.90056399800005, 35.021918036000045],
            [35.89730879000007, 35.03656647300005],
            [35.89144941500007, 35.04995351800005],
            [35.88786868600005, 35.06134674700007],
            [35.88786868600005, 35.10919830900008],
            [35.89421634200005, 35.121079820000034],
            [35.94125410200007, 35.180568752000056],
            [35.96241295700008, 35.19794342700004],
            [35.95329837300005, 35.22479889500005],
            [35.91529381600009, 35.28790924700007],
            [35.92896569100009, 35.321478583000044],
            [35.92408287900008, 35.33852773600006],
            [35.916677280000044, 35.40330638200004],
            [35.918955925000034, 35.417669989000046],
            [35.908864780000044, 35.42572663000004],
            [35.86060631600009, 35.47907135600008],
            [35.84009850400008, 35.48737213700008],
            [35.830088738000086, 35.493475653000075],
            [35.82585696700005, 35.50332265800006],
            [35.818369988000086, 35.50893789300005],
            [35.80225670700008, 35.50690338700008],
            [35.78679446700005, 35.50218333500004],
            [35.781260613000086, 35.49957916900007],
            [35.770518425000034, 35.50421784100007],
            [35.77198326900009, 35.51544830900008],
            [35.77711022200009, 35.52912018400008],
            [35.778086785000085, 35.54116445500006],
            [35.77198326900009, 35.54633209800005],
            [35.737071160000085, 35.56167226800005],
            [35.73878014400009, 35.56659577000005],
            [35.740896030000044, 35.57648346600007],
            [35.74333743600005, 35.582098700000074],
            [35.737071160000085, 35.582098700000074],
            [35.723399285000085, 35.57591380400004],
            [35.723399285000085, 35.582098700000074],
            [35.74341881600009, 35.587958075000074],
            [35.76335696700005, 35.59829336100006],
            [35.77849368600005, 35.61273834800005],
            [35.78435306100005, 35.630560614000046],
            [35.78207441500007, 35.64175039300005],
            [35.77320397200009, 35.655462958000044],
            [35.77116946700005, 35.66779205900008],
            [35.77662194100009, 35.675116278000075],
            [35.80005944100009, 35.68146393400008],
            [35.838552280000044, 35.74209219000005],
            [35.84034264400009, 35.74746328300006],
            [35.84009850400008, 35.770819403000075],
            [35.835948113000086, 35.78998444200005],
            [35.82536868600005, 35.81346263200004],
            [35.81185957100007, 35.83539459800005],
            [35.79859459700009, 35.849676825000074],
            [35.84685306100005, 35.84723541900007],
            [35.87086022200009, 35.85179271000004],
            [35.88103274800005, 35.86668528900009],
            [35.88526451900009, 35.885972398000035],
            [35.911305418925394, 35.9177504327608],
            [35.92083540900012, 35.91512156200007],
            [35.94057580600014, 35.91837717700004],
            [35.96072961500005, 35.92437164300007],
            [35.98026330600004, 35.92685211200005],
            [35.992769002000045, 35.91527659100011],
            [35.99307906000013, 35.9023574830001],
            [35.990081828000086, 35.889283346000056],
            [35.992355591000035, 35.8773460900001],
            [36.0039311110001, 35.86918121400008],
            [36.01943404100007, 35.86618398100008],
            [36.050749959000086, 35.865408834000064],
            [36.08030887900014, 35.85419504800011],
            [36.13849654100005, 35.81977854500006],
            [36.15530755700013, 35.8222320440001],
            [36.15761682100015, 35.82256907200012],
            [36.16877893100008, 35.85207631500005],
            [36.174876749000134, 35.92266632100011],
            [36.1968909090001, 35.95170847600009],
            [36.22903365100012, 35.96116526300007],
            [36.25311486800007, 35.95563588500006],
            [36.269031209000104, 35.95873647100011],
            [36.2774027910001, 35.99403147400001],
            [36.277506144000085, 35.99418650400004],
            [36.29734989400009, 36.00074941100003],
            [36.33672733500009, 35.98824371300013],
            [36.35801802600008, 35.9939797980001],
            [36.355537557000105, 36.022401835000025],
            [36.358638143000064, 36.16699249300008],
            [36.36049849400007, 36.181668600000094],
            [36.366286255000034, 36.18921335800003],
            [36.37445113100006, 36.19587961900005],
            [36.37579471900011, 36.204509583000075],
            [36.36142867000012, 36.21815216],
            [36.373004191000064, 36.227608948000054],
            [36.3856132410001, 36.21546498600007],
            [36.39811893700005, 36.2082302860001],
            [36.41186486800012, 36.20445790700008],
            [36.43925337700006, 36.20140899700006],
            [36.44524784300006, 36.19991038000005],
            [36.45072554500007, 36.19991038000005],
            [36.45920048000005, 36.20311432000001],
            [36.463954712000145, 36.20879872600007],
            [36.46529829900004, 36.2159300740001],
            [36.46891564900011, 36.222389628000045],
            [36.48018111100009, 36.22554189100002],
            [36.498577922000095, 36.22786733100004],
            [36.574438925000095, 36.21835886700005],
            [36.593455851000044, 36.218100485],
            [36.664252563000105, 36.22900421100006],
            [36.67004032400007, 36.237324117000114],
            [36.66911014800013, 36.259855042000126],
            [36.665492798000116, 36.27401438400007],
            [36.65846480300013, 36.29049916600006],
            [36.64876116200014, 36.30571856100006],
            [36.64864628100014, 36.30589874300004],
            [36.637070761000075, 36.3168024700001],
            [36.62074100700005, 36.32202179000002],
            [36.58777144400011, 36.32481231700008],
            [36.57764286300005, 36.33287384100008],
            [36.58219038900006, 36.33308054700002],
            [36.58777144400011, 36.342123922000084],
            [36.594282674000056, 36.357110087000066],
            [36.59448938000014, 36.36594675700006],
            [36.593352498000115, 36.3734915160001],
            [36.59056197100006, 36.380364482000076],
            [36.585704386000145, 36.387030742],
            [36.58084680200011, 36.38987294500005],
            [36.56503381400012, 36.39560903000002],
            [36.55800581900013, 36.400621643000065],
            [36.552734823000094, 36.40816640300004],
            [36.53382124800004, 36.462478333],
            [36.531237427000065, 36.47901479100007],
            [36.53547489400012, 36.49400095600005],
            [36.565343872000085, 36.532499899000115],
            [36.56999475100008, 36.57570139600004],
            [36.569271281000056, 36.62014312700002],
            [36.58281050700003, 36.662414449000025],
            [36.594696085000066, 36.685823873000075],
            [36.59810673000004, 36.7054609180001],
            [36.59893355300005, 36.72478790300006],
            [36.60327437400014, 36.74695709300006],
            [36.6156767170001, 36.7665941370001],
            [36.632006469000146, 36.78431915300003],
            [36.64327193200006, 36.803646139000065],
            [36.63986128800008, 36.828089091000024],
            [36.64916304600007, 36.82855417900005],
            [36.65856815600006, 36.82752065100006],
            [36.65956262500009, 36.827243022000104],
            [36.84367313700005, 36.77584421800013],
            [36.9068217360001, 36.772588603000045],
            [36.92594201700007, 36.76897125300006],
            [36.94588912000012, 36.76266672800004],
            [36.96469934100014, 36.75383005800005],
            [36.980098918000124, 36.74225453700011],
            [37.010588012000085, 36.71951690700003],
            [37.01844283100013, 36.70664947500002],
            [37.01947635900012, 36.685823873000075],
            [37.01079471800006, 36.65373280900006],
            [37.014515422000045, 36.64226064100002],
            [37.03332564300007, 36.628721415000044],
            [37.05306604000015, 36.619936422000066],
            [37.06236779800014, 36.62210683200006],
            [37.07011926300004, 36.63151194300009],
            [37.08562219300006, 36.64417266900004],
            [37.10443241400009, 36.6509939570001],
            [37.120968872000105, 36.64990875300002],
            [37.13740197700014, 36.64587799100012],
            [37.15610884600005, 36.64391428700007],
            [37.219670858000086, 36.657143453000074],
            [37.24189172400014, 36.65859039300007],
            [37.40446578000012, 36.63445750000001],
            [37.44611698400013, 36.63419911700005],
            [37.59339481600006, 36.71052520800008],
            [37.654062948000046, 36.73212595700004],
            [37.819737589000056, 36.76054799400008],
            [37.98003788200009, 36.81966583300003],
            [38.00794315600007, 36.82576365100009],
            [38.026005169000086, 36.83500562500005],
            [38.12297489400004, 36.88462310800007],
            [38.19005090300004, 36.90552622500006],
            [38.22426070200004, 36.90839426700005],
            [38.28988977000006, 36.9017021690001],
            [38.47995568900012, 36.85573598200004],
            [38.52935835800014, 36.833721822000044],
            [38.635191663000114, 36.744039459000064],
            [38.66413049400006, 36.71951690700003],
            [38.7250053300001, 36.69393707300007],
            [38.79538863100004, 36.686650696000086],
            [38.95796268700008, 36.692903545],
            [38.97997684800009, 36.698174540000124],
            [39.032170044000054, 36.70117177400003],
            [39.18585575300011, 36.65952056900004],
            [39.23959924300004, 36.661277567000084],
            [39.441707633000135, 36.69237269400004],
            [39.76525191300004, 36.742151184000065],
            [39.97981246000006, 36.80695343100008],
            [40.07923791500008, 36.854857483],
            [40.115204712000036, 36.864727682000066],
            [40.152721802000144, 36.870360413000114],
            [40.190135539000096, 36.88441640300003],
            [40.261409006000065, 36.9227846830001],
            [40.3937406820001, 36.99402211500011],
            [40.413894491000065, 37.004021505000125],
            [40.435185180000076, 37.01061025000011],
            [40.45699263500012, 37.014124247000055],
            [40.4798336180001, 37.01515777600004],
            [40.52572229000009, 37.02588063600005],
            [40.65946089700009, 37.085256857],
            [40.70896691900009, 37.10047556600004],
            [40.89644901500009, 37.12269643200007],
            [41.13509078000004, 37.08424916600002],
            [41.179739217000076, 37.06962473600005],
            [41.201339966000035, 37.06497385700008],
            [41.47977258300011, 37.07556752600006],
            [41.89636506700003, 37.15428342000003],
            [42.00924930900004, 37.175613099000046],
            [42.052967570000135, 37.19664540600006],
            [42.12831180900008, 37.25328277600006],
            [42.17854130000006, 37.306302795000065],
            [42.193010701000105, 37.31322743700004],
            [42.21120080500003, 37.324906311000106],
            [42.222569621000105, 37.313950908000024],
            [42.22380985500007, 37.302375387],
            [42.222156209000104, 37.292401835000064],
            [42.22318973800009, 37.288138530000126],
            [42.23683231600012, 37.2863040160001],
            [42.26721805900007, 37.27452179000004],
            [42.27290246500007, 37.276743877000015],
            [42.27920699100008, 37.28227325500002],
            [42.285821574000124, 37.28656239900009],
            [42.2920227460001, 37.28506378200008],
            [42.29636356600008, 37.27968943300003],
            [42.301427856000146, 37.26992258700007],
            [42.30576867700012, 37.26454823900009],
            [42.33987512200008, 37.24263743100006],
            [42.34669641200014, 37.239769389000074],
            [42.353207642000086, 37.2270311490001],
            [42.33532759600007, 37.17116892500003],
            [42.34669641200014, 37.158430685000084],
            [42.354551229000094, 37.15241038100005],
            [42.35651493400013, 37.13827687600009],
            [42.35723840300011, 37.1099840290001],
            [42.36364628100006, 37.098150127000096],
            [42.3711910400001, 37.08794403100002],
            [42.376875448000135, 37.07675608300009],
            [42.377185506000046, 37.06223500600005],
            [42.376805724000064, 37.06200061900006],
            [42.34586958800014, 37.0429080200001],
            [42.28189416500004, 36.994125468000036],
            [42.28189416500004, 36.99402211500011],
            [42.28158410700007, 36.99397043900008],
            [42.17843794800012, 36.90531952000002],
            [41.97855350700013, 36.73362457300006],
            [41.84378137300007, 36.6178693640001],
            [41.81732303900009, 36.599730937000075],
            [41.789934530000096, 36.58929229700003],
            [41.47977258300011, 36.5361172490001],
            [41.41486698400007, 36.52738393200012],
            [41.38541141700006, 36.51637685100003],
            [41.365360962000125, 36.49415598600008],
            [41.365360962000125, 36.49405263300007],
            [41.36525760900008, 36.49400095600005],
            [41.36525760900008, 36.493897603000036],
            [41.27699426200007, 36.35478464800012],
            [41.268829387000096, 36.32796458000003],
            [41.23658329300014, 36.07702382400005],
            [41.236686645000134, 36.06033233700002],
            [41.240614054000105, 36.043020732000016],
            [41.26624556500008, 35.994289856000066],
            [41.26634891800012, 35.99434153200009],
            [41.26634891800012, 35.99423818000007],
            [41.34365686100011, 35.85765737000004],
            [41.35450891100004, 35.82556630400002],
            [41.359263143000135, 35.79275177100003],
            [41.363500610000074, 35.65524078400004],
            [41.35802290900011, 35.62392486600005],
            [41.34220992100012, 35.593694153000044],
            [41.30845783400008, 35.55224762500008],
            [41.26128462700012, 35.494320374000026],
            [41.26128462700012, 35.49416534400008],
            [41.26118127400008, 35.49416534400008],
            [41.261077921000094, 35.49416534400008],
            [41.25187951700008, 35.46408966100002],
            [41.24309452300008, 35.366524557],
            [41.201339966000035, 35.243017884000054],
            [41.1915214440001, 35.18214304600009],
            [41.19232585700013, 35.15890443700006],
            [41.198032674000046, 34.994040833],
            [41.20650760900014, 34.81932281500012],
            [41.204233846000136, 34.79312286400001],
            [41.19565555800011, 34.76847320600011],
            [41.02398645100004, 34.49432973300013],
            [41.02398645100004, 34.49417470300007],
            [40.988019653000094, 34.42851979600003],
            [40.9652820230001, 34.401854757000095],
            [40.93603316300005, 34.3860676070001],
            [40.690466756000035, 34.33149729400007],
            [40.54380904100009, 34.25798757000011],
            [40.43322147600014, 34.202538757000056],
            [40.32263391100008, 34.14716746],
            [40.212046346000136, 34.09179616300004],
            [40.17311082500004, 34.07228291700004],
            [40.101458781000076, 34.03637318900009],
            [39.99087121600007, 33.98097605400004],
            [39.88038700300012, 33.9256047570001],
            [39.76969608500008, 33.87023346000005],
            [39.65921187400005, 33.8148104860001],
            [39.548624308000115, 33.759490865000075],
            [39.438036743000055, 33.70409373000011],
            [39.32744917800011, 33.64872243200007],
            [39.21686161300005, 33.59332529700002],
            [39.1062740480001, 33.53792816100007],
            [38.99568648300004, 33.482479350000105],
            [38.8850989180001, 33.427108053000055],
            [38.77451135200005, 33.3716850790001],
            [38.52956506300012, 33.244250997000066],
            [38.31574206300013, 33.13118006300009],
            [38.23087528500014, 33.08630198200005],
            [38.056725708000045, 32.99434377000007],
            [37.92939497900005, 32.925329896],
            [37.75803592900007, 32.8325190230001],
            [37.586676880000084, 32.73983734200003],
            [37.49460567400013, 32.690055623],
            [37.41521447800005, 32.647129822000025],
            [37.244062134000046, 32.55439646400002],
            [37.13337121600006, 32.49458099400009],
            [37.133164510000086, 32.49452931800006],
            [36.980098918000124, 32.4100383510001],
            [36.819385213000146, 32.31678822900007],
            [36.80656945800007, 32.31304168700005],
            [36.79251346800004, 32.313532614000096],
            [36.72864139800009, 32.32779530900005],
            [36.70693729600009, 32.328337911000105],
            [36.68957401500006, 32.319656271000056],
            [36.65350386500006, 32.34285898800006],
            [36.51668392700009, 32.357014182000015],
            [36.48018111100009, 32.360790711000035],
            [36.463954712000145, 32.36939483700006],
            [36.40762740000008, 32.374226583000066],
            [36.387887004000106, 32.37931671200006],
            [36.373107544000106, 32.386422221000075],
            [36.2852576090001, 32.45693471300005],
            [36.22076542100007, 32.49458099400009],
            [36.18820926900014, 32.522279561000104],
            [36.17735721800011, 32.52731801400007],
            [36.17218957500006, 32.52592275000008],
            [36.16082076000009, 32.51721527100004],
            [36.15585982200014, 32.51519989100008],
            [36.149865356000134, 32.51613006700005],
            [36.139530070000035, 32.51954071000007],
            [36.13322554600012, 32.52010915100003],
            [36.096225220000065, 32.51587168400006],
            [36.081905549000055, 32.51626477300009],
            [36.06987023900007, 32.51659515400006],
            [36.06625288900011, 32.517318624000055],
            [36.06604618300014, 32.52160776800012],
            [36.060465128000146, 32.53326080300009],
            [36.0154032800001, 32.59116424600002],
            [36.00599816900012, 32.60790741000007],
            [36.00527469900004, 32.62669179300006],
            [36.00827193200007, 32.6437191780001],
            [36.003621053000074, 32.65508799200008],
            [35.98026330600004, 32.656612448000104],
            [35.96579390500011, 32.6543645230001],
            [35.955355265000094, 32.65743927100003],
            [35.94657027200009, 32.66444142700003],
            [35.937475219000135, 32.67400156700002],
            [35.941195922000134, 32.673536479000106],
            [35.94439986200007, 32.67761891700012],
            [35.94574344900008, 32.68410431000008],
            [35.94419315600004, 32.690770569000094],
            [35.94036910000011, 32.69250172900006],
            [35.927449992000106, 32.69237253900012],
            [35.92248905400004, 32.693767802000096],
            [35.90522912600005, 32.70857310000012],
            [35.89572066300008, 32.71327565600011],
            [35.78823368400009, 32.73441131700004],
            [35.779035278000094, 32.74428151400012],
            [35.77913863100008, 32.74451405800009],
            [35.77490116400014, 32.74727874800003],
            [35.769733520000045, 32.74805389400005],
            [35.76384240700014, 32.74696869000006],
            [35.75759034900011, 32.7443468580001],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'South Korea',
        iso3: 'KOR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [128.36491946700005, 38.624335028000075],
              [128.39478358100007, 38.57807413300013],
              [128.4414168630001, 38.50580475500004],
              [128.45069420700008, 38.47410716400009],
              [128.47445722700002, 38.42609284100007],
              [128.56275475400003, 38.28896719000005],
              [128.63160241000003, 38.144964911000045],
              [128.64283287900003, 38.12929922100005],
              [128.6787215500001, 38.09430573100008],
              [128.69247480600006, 38.06492747600004],
              [128.85914147200003, 37.87677643400008],
              [128.9238387380001, 37.80231354400007],
              [129.001312696, 37.734361070000034],
              [129.01229902400007, 37.72724030200004],
              [129.06421959700003, 37.67885976800005],
              [129.0669051440001, 37.65843333500004],
              [129.06714928500003, 37.63385651200008],
              [129.07333418100006, 37.61302317900004],
              [129.108734571, 37.59739817900004],
              [129.11898847700002, 37.58063385600008],
              [129.14820397200003, 37.505113023000035],
              [129.16122480600006, 37.487616278000075],
              [129.17684980600006, 37.480169989000046],
              [129.1899520190001, 37.46938711100006],
              [129.23544355600006, 37.39826080900008],
              [129.26278730600006, 37.37091705900008],
              [129.27222741000003, 37.35586172100005],
              [129.2758895190001, 37.339911200000074],
              [129.28280683700007, 37.32444896000004],
              [129.3310653000001, 37.28217194200005],
              [129.34644616000003, 37.24750397300005],
              [129.36011803500003, 37.17177969000005],
              [129.3789168630001, 37.130113023000035],
              [129.4301863940001, 37.07306549700007],
              [129.4340926440001, 37.06110260600008],
              [129.4282332690001, 37.04954661700009],
              [129.4189559250001, 37.03851959800005],
              [129.4130965500001, 37.02773672100005],
              [129.41268964900007, 37.01805247600004],
              [129.4199324880001, 36.986761786000045],
              [129.4287215500001, 36.89740631700005],
              [129.4379988940001, 36.85614655200004],
              [129.4712020190001, 36.77187734600005],
              [129.47388756600003, 36.73061758000006],
              [129.46347089900007, 36.69245026200008],
              [129.44092858200008, 36.65778229400007],
              [129.42261803500003, 36.61664459800005],
              [129.4228621750001, 36.61497630400004],
              [129.42798912900003, 36.57566966400009],
              [129.44166100400003, 36.53465403900009],
              [129.44711347700002, 36.49331289300005],
              [129.44092858200008, 36.40794505400004],
              [129.43482506600003, 36.38959381700005],
              [129.40390058700007, 36.359442450000074],
              [129.39185631600003, 36.34247467700004],
              [129.38656660200002, 36.322699286000045],
              [129.38233483200008, 36.20184967700004],
              [129.3857528000001, 36.18545156500005],
              [129.39185631600003, 36.17633698100008],
              [129.39852949300007, 36.17267487200007],
              [129.40390058700007, 36.167629299000055],
              [129.40967858200008, 36.13361237200007],
              [129.41708418100006, 36.10757070500006],
              [129.425140821, 36.10301341400009],
              [129.430511915, 36.09739817900004],
              [129.4267684250001, 36.08177317900004],
              [129.41871178500003, 36.07298411700009],
              [129.40829511800007, 36.06891510600008],
              [129.3984481130001, 36.06631094000005],
              [129.38178266800003, 36.05517462200004],
              [129.38085871700002, 36.041486844000076],
              [129.4019370430001, 36.02566008400004],
              [129.41708062100008, 36.01191268600007],
              [129.43305147500007, 35.99610773200004],
              [129.45333141000003, 35.99328736800004],
              [129.4790145190001, 36.00958893400008],
              [129.54257246200007, 36.06590403900009],
              [129.554794958, 36.082477915000084],
              [129.5712996750001, 36.07184479400007],
              [129.57496178500003, 36.054673570000034],
              [129.5820418630001, 36.036810614000046],
              [129.587250196, 36.016913153000075],
              [129.5716437530001, 35.99712436400006],
              [129.53558955300002, 35.93903563200007],
              [129.53283905500007, 35.91301291100007],
              [129.52213431000007, 35.84455221300004],
              [129.49621649900007, 35.78507393500007],
              [129.49765058700007, 35.74787018400008],
              [129.471125895, 35.68322229800009],
              [129.4515757040001, 35.65180228300005],
              [129.44305339200002, 35.63609001100008],
              [129.451375761, 35.61824332300006],
              [129.4605899080001, 35.60929422300006],
              [129.46727514100007, 35.599667569000076],
              [129.463487901, 35.577883359000054],
              [129.4613512840001, 35.55206138500006],
              [129.45460045700008, 35.51325104400007],
              [129.44442793100006, 35.49681224200009],
              [129.42798912900003, 35.47874583500004],
              [129.41285241000003, 35.47207265800006],
              [129.4062606130001, 35.48969147300005],
              [129.4004012380001, 35.51264069200005],
              [129.38746178500003, 35.52985260600008],
              [129.3735457690001, 35.53278229400007],
              [129.3652449880001, 35.51325104400007],
              [129.3789168630001, 35.51068756700005],
              [129.387054884, 35.50226471600007],
              [129.390961134, 35.489935614000046],
              [129.39185631600003, 35.47573476800005],
              [129.38746178500003, 35.46230703300006],
              [129.37720787900003, 35.45917389500005],
              [129.3657332690001, 35.458319403000075],
              [129.357758009, 35.45180898600006],
              [129.35922285200002, 35.444647528000075],
              [129.36050348000003, 35.42605606700005],
              [129.3645813290001, 35.40687005700005],
              [129.35526191400004, 35.394571780000035],
              [129.34678727000005, 35.38227253800005],
              [129.35512974900007, 35.37266731900007],
              [129.3618139900001, 35.367171831000064],
              [129.36044355600006, 35.353583075000074],
              [129.33987502900004, 35.348074232000045],
              [129.32051321000006, 35.33854547200008],
              [129.29271986900005, 35.316049089000046],
              [129.26920554700007, 35.31676652800007],
              [129.26412629100003, 35.30242761400007],
              [129.26240016100007, 35.283988745000045],
              [129.256484172, 35.27442152200007],
              [129.24973457400006, 35.266227746000084],
              [129.25538170700008, 35.25259023600006],
              [129.25570722700002, 35.246975002000056],
              [129.24439034400007, 35.22821804000006],
              [129.22847902700005, 35.20053055300008],
              [129.21069260600007, 35.183001370000056],
              [129.20108409400007, 35.16662808600006],
              [129.1943465500001, 35.155503648000035],
              [129.17889555300007, 35.155757452000046],
              [129.1674798470001, 35.15616830700009],
              [129.15341230600006, 35.154282945000034],
              [129.1430770190001, 35.15477122600004],
              [129.132204581, 35.150766444000055],
              [129.12025714900005, 35.149616723000065],
              [129.11929663500007, 35.13556719800005],
              [129.127280508, 35.12582503400006],
              [129.12860118100002, 35.11414797000009],
              [129.12347008100005, 35.10084547300005],
              [129.101078185, 35.09227615300006],
              [129.08296636300008, 35.10518478100005],
              [129.071998054, 35.11261736900008],
              [129.06384042000002, 35.120847092000076],
              [129.03762722700003, 35.09783422800007],
              [129.025689682, 35.079502249000086],
              [129.021861854, 35.05998310700005],
              [129.01375367600008, 35.05530728900004],
              [129.00895713300008, 35.06513447800006],
              [128.99702610500003, 35.075728095000045],
              [128.9980147340001, 35.06628118800006],
              [129.0004015300001, 35.04595001800004],
              [128.9927699440001, 35.045962659000054],
              [128.98940545900007, 35.05269402400006],
              [128.98511156000006, 35.05428378000005],
              [128.97486412900003, 35.04865143400008],
              [128.96512461700001, 35.04364879600007],
              [128.95844737900006, 35.05038704700007],
              [128.95036040000002, 35.07291301300006],
              [128.9537036060001, 35.09320167000004],
              [128.96134093800003, 35.11895463700006],
              [128.9627776430001, 35.13338599100007],
              [128.95800991400006, 35.13689688300008],
              [128.94894401700003, 35.12597467100005],
              [128.91841959300007, 35.08188205300007],
              [128.90459292600008, 35.08109865000006],
              [128.90363532100002, 35.10139002500006],
              [128.90458592900006, 35.120509920000075],
              [128.89792560800004, 35.12130533000004],
              [128.88925214900007, 35.105454820000034],
              [128.8821860700001, 35.08148477700007],
              [128.85740242600002, 35.08382307900007],
              [128.791555442, 35.08295320800005],
              [128.78777325400006, 35.10131859300009],
              [128.78107691500009, 35.11106214600005],
              [128.771988319, 35.08331323900006],
              [128.7619708850001, 35.07939238800009],
              [128.73868948900008, 35.08798762200007],
              [128.72779381600003, 35.104722398000035],
              [128.7158309250001, 35.10586172100005],
              [128.70045006600003, 35.096136786000045],
              [128.70045006600003, 35.139878648000035],
              [128.6962996750001, 35.14350006700005],
              [128.68775475400003, 35.140611070000034],
              [128.680511915, 35.13141510600008],
              [128.67994225400003, 35.11595286700009],
              [128.6640731130001, 35.12612539300005],
              [128.651703321, 35.14077383000006],
              [128.638031446, 35.14984772300005],
              [128.61793053500003, 35.14325592700004],
              [128.62232506600003, 35.15737539300005],
              [128.61402428500003, 35.177435614000046],
              [128.61793053500003, 35.184881903000075],
              [128.6079207690001, 35.21116771000004],
              [128.6020613940001, 35.21393463700008],
              [128.59058678500003, 35.20538971600007],
              [128.5781356130001, 35.18935781500005],
              [128.57789147200003, 35.17865631700005],
              [128.59058678500003, 35.15696849200009],
              [128.5976668630001, 35.130519924000055],
              [128.60181725400003, 35.12124258000006],
              [128.6103621750001, 35.10919830900008],
              [128.62704511800007, 35.09076569200005],
              [128.62948652400007, 35.08148834800005],
              [128.62476647200003, 35.06818268400008],
              [128.63266035200002, 35.067287502000056],
              [128.6450301440001, 35.06289297100005],
              [128.65211022200003, 35.06134674700007],
              [128.64332116000003, 35.05654531500005],
              [128.63453209700003, 35.05463288000004],
              [128.6142684250001, 35.05459219000005],
              [128.60360761800007, 35.056626695000034],
              [128.6005965500001, 35.06191640800006],
              [128.6001082690001, 35.06858958500004],
              [128.59677168100006, 35.07501862200007],
              [128.58716881600003, 35.083319403000075],
              [128.58033287900003, 35.087876695000034],
              [128.5263778000001, 35.10346100500004],
              [128.51124108200008, 35.10423411700009],
              [128.47811933700007, 35.09906647300005],
              [128.469086134, 35.095404364000046],
              [128.4697371750001, 35.08836497600004],
              [128.481293165, 35.07501862200007],
              [128.46273847700002, 35.071966864000046],
              [128.42847741000003, 35.057806708000044],
              [128.3891707690001, 35.04901764500005],
              [128.38404381600003, 35.036363023000035],
              [128.38209069100003, 35.02260976800005],
              [128.371429884, 35.01357656500005],
              [128.371429884, 35.00678131700005],
              [128.4712020190001, 35.05023834800005],
              [128.48812910200002, 35.05117422100005],
              [128.491547071, 35.03359609600005],
              [128.49756920700008, 35.020697333000044],
              [128.49960371200007, 35.00922272300005],
              [128.491547071, 34.99591705900008],
              [128.47877037900003, 34.99005768400008],
              [128.45923912900003, 34.98737213700008],
              [128.43970787900003, 34.98810455900008],
              [128.4267684250001, 34.99249909100007],
              [128.42001386800007, 34.98273346600007],
              [128.42465254, 34.97801341400009],
              [128.43368574300007, 34.97370026200008],
              [128.4404403000001, 34.96515534100007],
              [128.4414168630001, 34.95994700700004],
              [128.441742384, 34.952460028000075],
              [128.4404403000001, 34.931626695000034],
              [128.432953321, 34.890692450000074],
              [128.44214928500003, 34.88349030200004],
              [128.45093834700003, 34.88589101800005],
              [128.457855665, 34.893866278000075],
              [128.4609481130001, 34.90371328300006],
              [128.47445722700002, 34.890692450000074],
              [128.46054121200007, 34.87018463700008],
              [128.43531334700003, 34.84316640800006],
              [128.41292953100003, 34.837635083000066],
              [128.38288272, 34.839289670000085],
              [128.38339652600007, 34.85458744400006],
              [128.402679884, 34.854803778000075],
              [128.41089928500003, 34.85602448100008],
              [128.41586347700002, 34.86273834800005],
              [128.35377037900003, 34.868475653000075],
              [128.3408309250001, 34.872707424000055],
              [128.326508009, 34.88906484600005],
              [128.32447350400003, 34.89728424700007],
              [128.33472741000003, 34.90257396000004],
              [128.357758009, 34.90989817900004],
              [128.33505293100006, 34.947333075000074],
              [128.318695509, 34.93406810100004],
              [128.30225670700008, 34.90802643400008],
              [128.27906334700003, 34.90680573100008],
              [128.25790449300007, 34.93016185100004],
              [128.24683678500003, 34.935980536000045],
              [128.22413170700008, 34.93789297100005],
              [128.21412194100003, 34.932928778000075],
              [128.20858808700007, 34.92084381700005],
              [128.20655358200008, 34.905503648000035],
              [128.2070418630001, 34.890692450000074],
              [128.185883009, 34.89362213700008],
              [128.13941491000003, 34.891913153000075],
              [128.1211043630001, 34.90029531500005],
              [128.11898847700002, 34.90570709800005],
              [128.11874433700007, 34.920355536000045],
              [128.1176863940001, 34.92422109600005],
              [128.11304772200003, 34.92519765800006],
              [128.101898634, 34.923529364000046],
              [128.08749433700007, 34.92625560100004],
              [128.06397545700008, 34.92792389500005],
              [128.0556746750001, 34.931626695000034],
              [128.05103600400003, 34.93964264500005],
              [128.05152428500003, 34.94749583500004],
              [128.054047071, 34.95502350500004],
              [128.0556746750001, 34.96173737200007],
              [128.054047071, 35.03583405200004],
              [128.0556746750001, 35.047756252000056],
              [128.0586043630001, 35.05329010600008],
              [128.06373131600003, 35.060614325000074],
              [128.06812584700003, 35.07021719000005],
              [128.0693465500001, 35.082464911000045],
              [128.0537215500001, 35.06712474200009],
              [128.04086347700002, 35.04922109600005],
              [128.02499433700007, 35.03579336100006],
              [128.0009871750001, 35.034084377000056],
              [128.01929772200003, 34.99868398600006],
              [128.0068465500001, 34.99176666900007],
              [127.97974694100003, 34.992254950000074],
              [127.95386803500003, 34.97882721600007],
              [127.94336998800009, 35.002834377000056],
              [127.93702233200008, 35.01264069200005],
              [127.92579186300009, 35.01976146000004],
              [127.92286217500009, 34.987534898000035],
              [127.91211998800009, 34.96206289300005],
              [127.89120527400007, 34.94668203300006],
              [127.86451256600003, 34.94472890800006],
              [127.853851759, 34.94818756700005],
              [127.84433027400007, 34.95018138200004],
              [127.83643639400009, 34.94944896000004],
              [127.83033287900003, 34.94472890800006],
              [127.81544030000009, 34.95482005400004],
              [127.805023634, 34.957139390000066],
              [127.79843183700007, 34.958644924000055],
              [127.75790449300007, 34.958319403000075],
              [127.74439537900003, 34.960191148000035],
              [127.73902428500003, 34.965277411000045],
              [127.73658287900003, 34.97288646000004],
              [127.73072350400003, 34.98257070500006],
              [127.71924889400009, 34.99005768400008],
              [127.71656334700003, 34.98236725500004],
              [127.71827233200008, 34.970404364000046],
              [127.72046959700003, 34.96515534100007],
              [127.713226759, 34.94672272300005],
              [127.70923912900003, 34.94041575700004],
              [127.69996178500003, 34.931626695000034],
              [127.66211998800009, 34.90680573100008],
              [127.64112389400009, 34.89911530200004],
              [127.62606855600006, 34.90973541900007],
              [127.60718834700003, 34.94131094000005],
              [127.59156334700003, 34.94643789300005],
              [127.58065839900007, 34.933661200000074],
              [127.57528730600006, 34.91364166900007],
              [127.57642662900003, 34.896918036000045],
              [127.58570397200003, 34.87921784100007],
              [127.60116621200007, 34.856350002000056],
              [127.61890709700003, 34.83641185100004],
              [127.63477623800009, 34.82802969000005],
              [127.64600670700008, 34.816066799000055],
              [127.65650475400003, 34.81191640800006],
              [127.66895592500009, 34.818345445000034],
              [127.69996178500003, 34.84227122600004],
              [127.72144616000003, 34.844631252000056],
              [127.73975670700008, 34.84170156500005],
              [127.75684655000009, 34.84080638200004],
              [127.77564537900003, 34.84906647300005],
              [127.77450605600006, 34.829331773000035],
              [127.77125084700003, 34.815334377000056],
              [127.76132246200007, 34.78705475500004],
              [127.74984785200002, 34.73712799700007],
              [127.74154707100001, 34.72557200700004],
              [127.70639082100001, 34.71588776200008],
              [127.67855879000001, 34.72736237200007],
              [127.65626061300009, 34.73126862200007],
              [127.63795006600003, 34.69822825700004],
              [127.63209069100003, 34.70140208500004],
              [127.63062584700003, 34.70111725500004],
              [127.629242384, 34.699286200000074],
              [127.62427819100003, 34.69822825700004],
              [127.63209069100003, 34.68504466400009],
              [127.63795006600003, 34.67096588700008],
              [127.64527428500003, 34.626288153000075],
              [127.64071699300007, 34.61798737200007],
              [127.63038170700008, 34.622707424000055],
              [127.61402428500003, 34.63686758000006],
              [127.59009850400003, 34.63930898600006],
              [127.57227623800009, 34.64740631700005],
              [127.56080162900003, 34.662176825000074],
              [127.55591881600003, 34.68455638200004],
              [127.56202233200008, 34.70571523600006],
              [127.57504316500001, 34.726548570000034],
              [127.58448326900009, 34.74624258000006],
              [127.57984459700003, 34.76312897300005],
              [127.57178795700008, 34.77252838700008],
              [127.55591881600003, 34.80072663000004],
              [127.55176842500009, 34.80292389500005],
              [127.54615319100003, 34.80304596600007],
              [127.54029381600003, 34.80377838700008],
              [127.53541100400003, 34.80809153900009],
              [127.53492272200003, 34.81321849200009],
              [127.53663170700008, 34.819240627000056],
              [127.53956139400009, 34.82306549700007],
              [127.52442467500009, 34.849269924000055],
              [127.521820509, 34.859035549000055],
              [127.52271569100003, 34.864935614000046],
              [127.52711022200003, 34.874701239000046],
              [127.52808678500003, 34.87982819200005],
              [127.52588951900009, 34.88544342700004],
              [127.52125084700003, 34.889837958000044],
              [127.51661217500009, 34.89109935100004],
              [127.51441491000003, 34.88694896000004],
              [127.51099694100003, 34.88471100500004],
              [127.49390709700003, 34.84906647300005],
              [127.48731530000009, 34.841498114000046],
              [127.48389733200008, 34.839544989000046],
              [127.47877037900003, 34.839056708000044],
              [127.44467207100001, 34.82916901200008],
              [127.42481530000009, 34.82713450700004],
              [127.38160241000003, 34.82802969000005],
              [127.36532636800007, 34.82404205900008],
              [127.37850996200007, 34.81513092700004],
              [127.40430748800009, 34.805853583000044],
              [127.42554772200003, 34.80072663000004],
              [127.42554772200003, 34.79441966400009],
              [127.38306725400003, 34.783270575000074],
              [127.36158287900003, 34.77334219000005],
              [127.35792076900009, 34.75971100500004],
              [127.36646569100003, 34.753973700000074],
              [127.38526451900009, 34.760199286000045],
              [127.39527428500003, 34.75665924700007],
              [127.40235436300009, 34.74713776200008],
              [127.40023847700002, 34.74363841400009],
              [127.394867384, 34.74249909100007],
              [127.39210045700008, 34.73981354400007],
              [127.40601647200003, 34.70001862200007],
              [127.43490644600001, 34.67869700700004],
              [127.46615644600001, 34.662176825000074],
              [127.48755944100003, 34.63686758000006],
              [127.47730553500003, 34.63816966400009],
              [127.45972741000003, 34.63825104400007],
              [127.45224043100006, 34.63686758000006],
              [127.49520918100006, 34.62323639500005],
              [127.50075946700008, 34.61216386700005],
              [127.50358985000003, 34.59132477300005],
              [127.4944402210001, 34.58377660800005],
              [127.48414147200003, 34.57656484600005],
              [127.46461022200003, 34.577337958000044],
              [127.45224043100006, 34.57477448100008],
              [127.40674889400009, 34.59813060100004],
              [127.39210045700008, 34.60203685100004],
              [127.37916100400003, 34.60000234600005],
              [127.36304772200003, 34.59389883000006],
              [127.34937584700003, 34.58584219000005],
              [127.34359785200002, 34.578192450000074],
              [127.34595787900003, 34.57501862200007],
              [127.35792076900009, 34.55426666900007],
              [127.37194040400004, 34.55173335900008],
              [127.3804082690001, 34.54710467500007],
              [127.41841862600006, 34.55528036900006],
              [127.43921959700003, 34.540676174000055],
              [127.391788013, 34.50477960100005],
              [127.37494096800003, 34.485036569000044],
              [127.35661839400007, 34.49196473000006],
              [127.32780172800005, 34.47392946100007],
              [127.33082116000003, 34.45648834800005],
              [127.34359785200002, 34.445013739000046],
              [127.315925504, 34.44490102000009],
              [127.27508180100006, 34.48945330000004],
              [127.26099694100003, 34.513332424000055],
              [127.22348066500001, 34.54682038000004],
              [127.21200605600006, 34.54466380400004],
              [127.17237389400009, 34.52757396000004],
              [127.17636152400007, 34.51732005400004],
              [127.17920983200008, 34.513332424000055],
              [127.16293379000001, 34.51797109600005],
              [127.14722741000003, 34.52049388200004],
              [127.13379967500009, 34.52631256700005],
              [127.12452233200008, 34.540676174000055],
              [127.12330162900003, 34.55536530200004],
              [127.12964928500003, 34.56391022300005],
              [127.15186608200008, 34.57477448100008],
              [127.15902754000001, 34.58002350500004],
              [127.17920983200008, 34.60203685100004],
              [127.19166100400003, 34.62360260600008],
              [127.19882246200007, 34.63100820500006],
              [127.21338951900009, 34.63686758000006],
              [127.21241295700008, 34.62018463700008],
              [127.20753014400009, 34.60398997600004],
              [127.19288170700008, 34.57477448100008],
              [127.22217858200008, 34.57636139500005],
              [127.24667402400007, 34.58372630400004],
              [127.26132246200007, 34.60040924700007],
              [127.26099694100003, 34.62995026200008],
              [127.25513756600003, 34.641506252000056],
              [127.24740644600001, 34.648098049000055],
              [127.24146569100003, 34.65582916900007],
              [127.240570509, 34.67096588700008],
              [127.24594160200002, 34.678900458000044],
              [127.27475019600001, 34.705145575000074],
              [127.28516686300009, 34.70062897300005],
              [127.29200280000009, 34.694525458000044],
              [127.29371178500003, 34.686712958000044],
              [127.28842207100001, 34.67719147300005],
              [127.29444420700008, 34.664129950000074],
              [127.30298912900003, 34.65501536700009],
              [127.31446373800009, 34.65192291900007],
              [127.32992597700002, 34.656683661000045],
              [127.33643639400009, 34.66364166900007],
              [127.35010826900009, 34.68781159100007],
              [127.35792076900009, 34.69822825700004],
              [127.34400475400003, 34.715277411000045],
              [127.33863366000003, 34.73309967700004],
              [127.33155358200008, 34.74115631700005],
              [127.31259199300007, 34.72898997600004],
              [127.29078209700003, 34.72138092700004],
              [127.27271569100003, 34.73379140800006],
              [127.24805748800009, 34.76654694200005],
              [127.23389733200008, 34.74823639500005],
              [127.21371504000001, 34.70555247600004],
              [127.19971764400009, 34.691473700000074],
              [127.18531334700003, 34.68667226800005],
              [127.17310631600003, 34.687201239000046],
              [127.14804121200007, 34.691473700000074],
              [127.13624108200008, 34.68805573100008],
              [127.12525475400003, 34.679754950000074],
              [127.10718834700003, 34.66010163000004],
              [127.09913170700008, 34.65448639500005],
              [127.06251061300009, 34.63686758000006],
              [127.04273522200003, 34.62445709800005],
              [127.03003991000003, 34.618353583000044],
              [127.01783287900003, 34.61570872600004],
              [127.01026451900009, 34.612494208000044],
              [127.00855553500003, 34.60423411700009],
              [127.00904381600003, 34.59320709800005],
              [127.00717207100001, 34.58152903900009],
              [127.00058027400007, 34.57330963700008],
              [126.99130293100006, 34.56435781500005],
              [126.986664259, 34.55369700700004],
              [126.99415123800009, 34.540676174000055],
              [126.93897545700008, 34.49591705900008],
              [126.94076582100001, 34.45457591400009],
              [126.93140709700003, 34.447699286000045],
              [126.90479576900009, 34.458685614000046],
              [126.89600670700008, 34.44993724200009],
              [126.89185631600003, 34.44013092700004],
              [126.89234459700003, 34.429388739000046],
              [126.89795983200008, 34.41771067900004],
              [126.88502037900003, 34.421087958000044],
              [126.85702558700007, 34.437567450000074],
              [126.81861412900003, 34.44684479400007],
              [126.80982506600003, 34.451239325000074],
              [126.80201256600003, 34.470404364000046],
              [126.80616295700008, 34.52106354400007],
              [126.80233808700007, 34.540676174000055],
              [126.80787194100003, 34.553168036000045],
              [126.80665123800009, 34.56854889500005],
              [126.80005944100003, 34.582017320000034],
              [126.78866621200007, 34.589056708000044],
              [126.77784264400009, 34.58649323100008],
              [126.76693769600001, 34.57802969000005],
              [126.75855553500003, 34.56720612200007],
              [126.75521894600001, 34.55768463700008],
              [126.75928795700008, 34.543850002000056],
              [126.76563561300009, 34.53180573100008],
              [126.765961134, 34.52338288000004],
              [126.73511803500003, 34.514878648000035],
              [126.73910566500001, 34.50267161700009],
              [126.76148522200003, 34.47919342700004],
              [126.72315514400009, 34.46084219000005],
              [126.70875084700003, 34.44989655200004],
              [126.72364342500009, 34.445013739000046],
              [126.72706139400009, 34.44277578300006],
              [126.72803795700008, 34.43789297100005],
              [126.726898634, 34.43301015800006],
              [126.72364342500009, 34.43081289300005],
              [126.71753991000003, 34.43183014500005],
              [126.70826256600003, 34.43646881700005],
              [126.70337975400003, 34.437567450000074],
              [126.69019616000003, 34.43593984600005],
              [126.68751061300009, 34.431341864000046],
              [126.68734785200002, 34.423895575000074],
              [126.68222089900007, 34.41400788000004],
              [126.67440839900007, 34.40965403900009],
              [126.64478600400003, 34.40346914300005],
              [126.63363691500001, 34.395697333000044],
              [126.62964928500003, 34.38922760600008],
              [126.60531660200002, 34.32168203300006],
              [126.60328209700003, 34.31199778900009],
              [126.60328209700003, 34.300441799000055],
              [126.57886803500003, 34.304754950000074],
              [126.53280683700007, 34.292222398000035],
              [126.52125084700003, 34.294175523000035],
              [126.519867384, 34.305975653000075],
              [126.52930748800009, 34.33002350500004],
              [126.52743574300007, 34.34137604400007],
              [126.51832116000003, 34.34784577000005],
              [126.50570722700002, 34.34992096600007],
              [126.47958418100006, 34.348822333000044],
              [126.47958418100006, 34.35504791900007],
              [126.48487389400009, 34.36082591400009],
              [126.48658287900003, 34.36481354400007],
              [126.48853600400003, 34.380560614000046],
              [126.49195397200003, 34.38108958500004],
              [126.496429884, 34.37986888200004],
              [126.50074303500003, 34.38231028900009],
              [126.51490319100003, 34.403550523000035],
              [126.51758873800009, 34.413763739000046],
              [126.51376386800007, 34.42397695500006],
              [126.50879967500009, 34.42723216400009],
              [126.50147545700008, 34.429348049000055],
              [126.48658287900003, 34.43081289300005],
              [126.47584069100003, 34.433254299000055],
              [126.47437584700003, 34.438666083000044],
              [126.47730553500003, 34.44358958500004],
              [126.47958418100006, 34.445013739000046],
              [126.47999108200008, 34.45783112200007],
              [126.48373457100001, 34.47016022300005],
              [126.48194420700008, 34.47675202000005],
              [126.46591230600006, 34.472357489000046],
              [126.47030683700007, 34.49648672100005],
              [126.49024498800009, 34.50861237200007],
              [126.51685631600003, 34.51284414300005],
              [126.54175866000003, 34.513332424000055],
              [126.53720136800007, 34.52106354400007],
              [126.53101647200003, 34.527004299000055],
              [126.52320397200003, 34.53115469000005],
              [126.51376386800007, 34.53384023600006],
              [126.52955162900003, 34.542954820000034],
              [126.53931725400003, 34.553615627000056],
              [126.53964277400007, 34.56297435100004],
              [126.52743574300007, 34.56854889500005],
              [126.52295983200008, 34.56708405200004],
              [126.51392662900003, 34.557806708000044],
              [126.50757897200003, 34.55426666900007],
              [126.49927819100003, 34.554348049000055],
              [126.48633873800009, 34.56093984600005],
              [126.47958418100006, 34.56110260600008],
              [126.47348066500001, 34.55654531500005],
              [126.46933027400007, 34.549709377000056],
              [126.46591230600006, 34.540676174000055],
              [126.45704186300009, 34.539048570000034],
              [126.44849694100003, 34.53929271000004],
              [126.43873131600003, 34.540676174000055],
              [126.41732832100001, 34.540350653000075],
              [126.40560957100001, 34.53864166900007],
              [126.39087975400003, 34.53384023600006],
              [126.389008009, 34.549709377000056],
              [126.38046308700007, 34.55890534100007],
              [126.35670006600003, 34.56854889500005],
              [126.35702558700007, 34.57172272300005],
              [126.35206139400009, 34.579779364000046],
              [126.346039259, 34.58462148600006],
              [126.34302819100003, 34.578192450000074],
              [126.34009850400003, 34.57436758000006],
              [126.33301842500009, 34.57099030200004],
              [126.32496178500003, 34.569647528000075],
              [126.31861412900003, 34.57168203300006],
              [126.29786217500009, 34.58803945500006],
              [126.295258009, 34.589056708000044],
              [126.29184004000001, 34.59910716400009],
              [126.29354902400007, 34.601996161000045],
              [126.29761803500003, 34.60333893400008],
              [126.30152428500003, 34.60887278900009],
              [126.30551191500001, 34.60419342700004],
              [126.31552168100006, 34.60407135600008],
              [126.32276451900009, 34.60887278900009],
              [126.31861412900003, 34.619126695000034],
              [126.29184004000001, 34.62995026200008],
              [126.27108808700007, 34.64248281500005],
              [126.26937910200002, 34.67129140800006],
              [126.27808678500003, 34.70331452000005],
              [126.28858483200008, 34.72557200700004],
              [126.28964277400007, 34.73314036700009],
              [126.28882897200003, 34.74241771000004],
              [126.29029381600003, 34.75023021000004],
              [126.29843183700007, 34.75348541900007],
              [126.30591881600003, 34.75287506700005],
              [126.31373131600003, 34.75104401200008],
              [126.31959069100003, 34.747748114000046],
              [126.32618248800009, 34.73582591400009],
              [126.35670006600003, 34.69822825700004],
              [126.34717858200008, 34.68789297100005],
              [126.34424889400009, 34.67788320500006],
              [126.34595787900003, 34.667669989000046],
              [126.34921308700007, 34.656683661000045],
              [126.36988366000003, 34.60887278900009],
              [126.38233483200008, 34.602728583000044],
              [126.43189537900003, 34.59589264500005],
              [126.45313561300009, 34.58380768400008],
              [126.46461022200003, 34.58466217700004],
              [126.47274824300007, 34.60203685100004],
              [126.46151777400007, 34.60065338700008],
              [126.45557701900009, 34.60309479400007],
              [126.4349971470001, 34.60678590300006],
              [126.4252993120001, 34.61927176900008],
              [126.41256654200004, 34.62976606800004],
              [126.41610761800007, 34.65273672100005],
              [126.40290177500003, 34.65074783000006],
              [126.396519011, 34.636604222000074],
              [126.3861337410001, 34.63583540500008],
              [126.379854787, 34.65450554200004],
              [126.37677542400002, 34.67947015200008],
              [126.38437937200001, 34.693698786000084],
              [126.37861288900001, 34.711182163000046],
              [126.405969475, 34.71340801300005],
              [126.4478811570001, 34.705878563000056],
              [126.45333635200006, 34.69788382400009],
              [126.45069420700008, 34.684881903000075],
              [126.45093834700003, 34.680853583000044],
              [126.45053144600001, 34.676988023000035],
              [126.45289147200003, 34.67096588700008],
              [126.46330599400005, 34.66542139300009],
              [126.46936248600002, 34.658674345000065],
              [126.482399784, 34.65166988900006],
              [126.500345465, 34.64581857600007],
              [126.51119327000004, 34.637154827000074],
              [126.52512592100004, 34.62890229200008],
              [126.53571133000003, 34.62317762500004],
              [126.54004967500009, 34.62759023600006],
              [126.51911134500006, 34.65036980700006],
              [126.53155606200005, 34.65259658800005],
              [126.55003784200005, 34.643830033000086],
              [126.57387257900007, 34.63311135300006],
              [126.6027010030001, 34.62553248100005],
              [126.62362714900007, 34.62995026200008],
              [126.60254967500009, 34.632879950000074],
              [126.58545983200008, 34.641791083000044],
              [126.55543053500003, 34.66351959800005],
              [126.56275475400003, 34.67096588700008],
              [126.54110761800007, 34.68398672100005],
              [126.50839277400007, 34.71849192900004],
              [126.49024498800009, 34.72557200700004],
              [126.46534264400009, 34.729681708000044],
              [126.43576744100005, 34.72810539400007],
              [126.41537519600001, 34.73899974200009],
              [126.3901786020001, 34.733397455000045],
              [126.36705994600004, 34.73966441200008],
              [126.36401690800005, 34.74916010800007],
              [126.37831687300002, 34.76388770600005],
              [126.39232840700004, 34.76860745200008],
              [126.422127907, 34.764783571000066],
              [126.46014859900004, 34.77875539200005],
              [126.50586998800009, 34.75104401200008],
              [126.52125084700003, 34.75348541900007],
              [126.52515709700003, 34.751288153000075],
              [126.52759850400003, 34.749253648000035],
              [126.53028405000009, 34.74750397300005],
              [126.53492272200003, 34.74603913000004],
              [126.53052819100003, 34.765285549000055],
              [126.53248131600003, 34.782863674000055],
              [126.54444420700008, 34.79572174700007],
              [126.56893964900007, 34.80072663000004],
              [126.61475670700008, 34.78945547100005],
              [126.63819420700008, 34.78803131700005],
              [126.63111412900003, 34.80072663000004],
              [126.64657636800007, 34.80711497600004],
              [126.65487714900007, 34.80853913000004],
              [126.66529381600003, 34.80809153900009],
              [126.65040123800009, 34.82217031500005],
              [126.62769616000003, 34.82558828300006],
              [126.57577558700007, 34.82176341400009],
              [126.57968183700007, 34.83144765800006],
              [126.57837975400003, 34.83803945500006],
              [126.57577558700007, 34.84487539300005],
              [126.57577558700007, 34.85529205900008],
              [126.57943769600001, 34.86188385600008],
              [126.58472741000003, 34.86676666900007],
              [126.58912194100003, 34.87287018400008],
              [126.58944746200007, 34.883246161000045],
              [126.58139082100001, 34.89801666900007],
              [126.56763756600003, 34.90143463700008],
              [126.55274498800009, 34.895697333000044],
              [126.54175866000003, 34.883246161000045],
              [126.54053795700008, 34.87494538000004],
              [126.54712975400003, 34.85809967700004],
              [126.54859459700003, 34.84906647300005],
              [126.54688561300009, 34.847723700000074],
              [126.53492272200003, 34.82802969000005],
              [126.52369225400003, 34.79393138200004],
              [126.51327558700007, 34.78229401200008],
              [126.49341881600003, 34.78082916900007],
              [126.49341881600003, 34.78314850500004],
              [126.48715254000001, 34.78705475500004],
              [126.49122155000009, 34.79238515800006],
              [126.49659264400009, 34.802801825000074],
              [126.50074303500003, 34.80809153900009],
              [126.48715254000001, 34.813788153000075],
              [126.47803795700008, 34.81045156500005],
              [126.46924889400009, 34.80410390800006],
              [126.45606530000009, 34.80072663000004],
              [126.42945397200003, 34.80560944200005],
              [126.42099043100006, 34.80231354400007],
              [126.41931790800004, 34.79198817900004],
              [126.40560957100001, 34.792181708000044],
              [126.38404381600003, 34.786322333000044],
              [126.37354576900009, 34.790716864000046],
              [126.37012780000009, 34.80133698100008],
              [126.377289259, 34.81126536700009],
              [126.39771569100003, 34.82802969000005],
              [126.40512129000001, 34.837225653000075],
              [126.40927168100006, 34.84446849200009],
              [126.41098066500001, 34.851263739000046],
              [126.41138756600003, 34.859035549000055],
              [126.40870201900009, 34.87396881700005],
              [126.41211998800009, 34.88133372600004],
              [126.42505944100003, 34.890692450000074],
              [126.41260826900009, 34.89874909100007],
              [126.40170332100001, 34.91547272300005],
              [126.39576256600003, 34.93504466400009],
              [126.39771569100003, 34.95148346600007],
              [126.41163170700008, 34.96198151200008],
              [126.43051191500001, 34.97260163000004],
              [126.43637129000001, 34.98139069200005],
              [126.41138756600003, 34.98627350500004],
              [126.39999433700007, 34.98456452000005],
              [126.39332116000003, 34.979803778000075],
              [126.38795006600003, 34.97483958500004],
              [126.38038170700008, 34.97260163000004],
              [126.37061608200008, 34.96849192900004],
              [126.37208092500009, 34.95872630400004],
              [126.37696373800009, 34.947251695000034],
              [126.377289259, 34.93789297100005],
              [126.36329186300009, 34.927435614000046],
              [126.34522545700008, 34.92641836100006],
              [126.32772871200007, 34.93109772300005],
              [126.31519616000003, 34.93789297100005],
              [126.32471764400009, 34.94326406500005],
              [126.32886803500003, 34.94472890800006],
              [126.32007897200003, 34.94989655200004],
              [126.31259199300007, 34.95612213700008],
              [126.30640709700003, 34.96356842700004],
              [126.30152428500003, 34.97260163000004],
              [126.31299889400009, 34.977443752000056],
              [126.32422936300009, 34.97695547100005],
              [126.34921308700007, 34.97260163000004],
              [126.34620201900009, 34.99408600500004],
              [126.37411543100006, 35.016831773000035],
              [126.36670983200008, 35.03778717700004],
              [126.338226759, 35.07013580900008],
              [126.320648634, 35.083319403000075],
              [126.30152428500003, 35.08869049700007],
              [126.30941816500001, 35.06622955900008],
              [126.30250084700003, 35.05337148600006],
              [126.28834069100003, 35.05296458500004],
              [126.27418053500003, 35.06818268400008],
              [126.283539259, 35.07884349200009],
              [126.25782311300009, 35.10683828300006],
              [126.254242384, 35.12343984600005],
              [126.26864668100006, 35.137152411000045],
              [126.28907311300009, 35.13939036700009],
              [126.30722089900007, 35.13178131700005],
              [126.31519616000003, 35.11595286700009],
              [126.32789147200003, 35.12262604400007],
              [126.33497155000009, 35.134100653000075],
              [126.34302819100003, 35.15696849200009],
              [126.35010826900009, 35.14557526200008],
              [126.35141035200002, 35.135972398000035],
              [126.34872480600006, 35.11749909100007],
              [126.34424889400009, 35.10814036700009],
              [126.34302819100003, 35.10236237200007],
              [126.34498131600003, 35.09642161700009],
              [126.34896894600001, 35.09642161700009],
              [126.35360761800007, 35.09784577000005],
              [126.35670006600003, 35.096136786000045],
              [126.36068769600001, 35.08295319200005],
              [126.361664259, 35.07729726800005],
              [126.36532636800007, 35.07404205900008],
              [126.377289259, 35.06818268400008],
              [126.38697350400003, 35.06537506700005],
              [126.40381920700008, 35.064886786000045],
              [126.41138756600003, 35.06134674700007],
              [126.40560957100001, 35.04995351800005],
              [126.40723717500009, 35.03896719000005],
              [126.414398634, 35.02875397300005],
              [126.42505944100003, 35.01976146000004],
              [126.45028730600006, 35.06659577000005],
              [126.45289147200003, 35.082464911000045],
              [126.45240319100003, 35.10028717700004],
              [126.44752037900003, 35.106675523000035],
              [126.42872155000009, 35.110541083000044],
              [126.42074629000001, 35.11420319200005],
              [126.41415449300007, 35.11969635600008],
              [126.40390058700007, 35.14215729400007],
              [126.37110436300009, 35.173529364000046],
              [126.36353600400003, 35.18797435100004],
              [126.36573326900009, 35.19285716400009],
              [126.37037194100003, 35.196966864000046],
              [126.37509199300007, 35.202378648000035],
              [126.377289259, 35.21161530200004],
              [126.36670983200008, 35.21771881700005],
              [126.36158287900003, 35.22565338700008],
              [126.36353600400003, 35.239488023000035],
              [126.35067793100006, 35.23533763200004],
              [126.33741295700008, 35.233587958000044],
              [126.308929884, 35.233303127000056],
              [126.32007897200003, 35.244574286000045],
              [126.33838951900009, 35.248032945000034],
              [126.35914147200003, 35.24896881700005],
              [126.377289259, 35.25259023600006],
              [126.37134850400003, 35.25446198100008],
              [126.36817467500009, 35.256740627000056],
              [126.36451256600003, 35.25873444200005],
              [126.35670006600003, 35.25999583500004],
              [126.36158287900003, 35.26902903900009],
              [126.36744225400003, 35.274318752000056],
              [126.37387129000001, 35.27838776200008],
              [126.38038170700008, 35.28416575700004],
              [126.38379967500009, 35.29173411700009],
              [126.38217207100001, 35.29828522300005],
              [126.37899824300007, 35.30459219000005],
              [126.377289259, 35.31150950700004],
              [126.38070722700002, 35.32709381700005],
              [126.38941491000003, 35.34247467700004],
              [126.41138756600003, 35.36985911700009],
              [126.41724694100003, 35.364894924000055],
              [126.43189537900003, 35.34935130400004],
              [126.449554884, 35.344956773000035],
              [126.45850670700008, 35.34544505400004],
              [126.45606530000009, 35.352769273000035],
              [126.42310631600003, 35.38336823100008],
              [126.41822350400003, 35.39402903900009],
              [126.42554772200003, 35.417669989000046],
              [126.44271894600001, 35.446926174000055],
              [126.46981423500006, 35.49852640700004],
              [126.492663279, 35.525333007000086],
              [126.52528299100004, 35.534857697000064],
              [126.562449969, 35.541087444000084],
              [126.59423270100001, 35.54248771200008],
              [126.60889429500003, 35.552056091000054],
              [126.62297749100003, 35.56861206000008],
              [126.64288939900007, 35.57277499300005],
              [126.66073652400007, 35.55646393400008],
              [126.67904707100001, 35.53803131700005],
              [126.69247480600006, 35.534369208000044],
              [126.67945397200003, 35.57172272300005],
              [126.67017662900003, 35.58869049700007],
              [126.65503991000003, 35.595770575000074],
              [126.51315778100002, 35.57689651800007],
              [126.46373599600008, 35.60197285700008],
              [126.46674363400007, 35.62887469100008],
              [126.46755899100003, 35.63963844700004],
              [126.49097741000003, 35.64911530200004],
              [126.5114156950001, 35.66553251100004],
              [126.53033472200002, 35.68316430500005],
              [126.56034574700004, 35.697391795000044],
              [126.5971677010001, 35.713890194000044],
              [126.62513225000009, 35.745625835000055],
              [126.62938900800009, 35.77548057900009],
              [126.64475472000004, 35.78290180400006],
              [126.6561167210001, 35.78873572100008],
              [126.66215366800009, 35.79299834500006],
              [126.69802294700003, 35.79593945900007],
              [126.73312722800006, 35.792415051000035],
              [126.75538170700008, 35.77846914300005],
              [126.77133222700002, 35.77521393400008],
              [126.78199303500003, 35.76023997600004],
              [126.78614342500009, 35.76837799700007],
              [126.78956139400009, 35.77968984600005],
              [126.79102623800009, 35.791449286000045],
              [126.77766824800005, 35.800092446000065],
              [126.76846474400008, 35.805555327000036],
              [126.74934413200003, 35.813257440000086],
              [126.72762228500005, 35.825278498000046],
              [126.70997155000009, 35.836004950000074],
              [126.70069420700008, 35.839829820000034],
              [126.70337975400003, 35.84845612200007],
              [126.71168053500003, 35.85773346600007],
              [126.71998131600003, 35.863267320000034],
              [126.72909589900007, 35.86497630400004],
              [126.78492272200003, 35.86204661700009],
              [126.79712975400003, 35.86286041900007],
              [126.80616295700008, 35.86668528900009],
              [126.81226647200003, 35.87567780200004],
              [126.81454511800007, 35.88304271000004],
              [126.81934655000009, 35.88812897300005],
              [126.83309980600006, 35.89004140800006],
              [126.83749433700007, 35.89329661700009],
              [126.83228600400003, 35.90062083500004],
              [126.82162519600001, 35.90814850500004],
              [126.80982506600003, 35.91168854400007],
              [126.80665123800009, 35.90965403900009],
              [126.73316491000003, 35.88556549700007],
              [126.70850670700008, 35.88458893400008],
              [126.660090996, 35.88715780100006],
              [126.61228893200007, 35.89022422000005],
              [126.61183815100003, 35.90743966800005],
              [126.60880930300004, 35.931126764000055],
              [126.59957573500003, 35.93765363000006],
              [126.56973974000005, 35.94595198400009],
              [126.52573565800003, 35.940358909000054],
              [126.5214167360001, 35.97052000300005],
              [126.61204597100004, 35.978430089000085],
              [126.66133514700005, 35.98339864800005],
              [126.71119225400003, 35.98578522300005],
              [126.72730553500003, 35.99363841400009],
              [126.744476759, 35.989569403000075],
              [126.76547285200002, 35.99827708500004],
              [126.80233808700007, 36.02094147300005],
              [126.84913170700008, 36.036037502000056],
              [126.86890709700003, 36.04751211100006],
              [126.87069746200007, 36.06195709800005],
              [126.81210371200007, 36.047308661000045],
              [126.79151451900009, 36.042181708000044],
              [126.77133222700002, 36.030910549000055],
              [126.75440514400009, 36.01772695500006],
              [126.73568769600001, 36.01044342700004],
              [126.71338951900009, 36.00739166900007],
              [126.69247480600006, 35.99990469000005],
              [126.67725670700008, 36.005926825000074],
              [126.67212975400003, 36.012884833000044],
              [126.67050214900007, 36.02204010600008],
              [126.66529381600003, 36.03461334800005],
              [126.65699303500003, 36.04547760600008],
              [126.64014733200008, 36.06342194200005],
              [126.63111412900003, 36.07558828300006],
              [126.64503014400009, 36.08470286700009],
              [126.63851972700002, 36.09096914300005],
              [126.62484785200002, 36.09560781500005],
              [126.61232836700003, 36.09899244200005],
              [126.58944746200007, 36.13080475500004],
              [126.57186865200003, 36.13697874200005],
              [126.55857335600001, 36.13076369800007],
              [126.55228153900009, 36.13080877800007],
              [126.55176768800004, 36.14182264700008],
              [126.52917225600004, 36.153514132000055],
              [126.50964758000009, 36.15102477900007],
              [126.50357948600004, 36.13219012500008],
              [126.50025475400003, 36.12571849200009],
              [126.49341881600003, 36.13080475500004],
              [126.49740117200008, 36.16001868200004],
              [126.531356813, 36.17393972800005],
              [126.56134123800007, 36.18158844000004],
              [126.60328209700003, 36.17182038000004],
              [126.58847089900007, 36.19159577000005],
              [126.58008873800009, 36.19936758000006],
              [126.56893964900007, 36.205959377000056],
              [126.56226647200003, 36.20722077000005],
              [126.55429121200007, 36.20343659100007],
              [126.54859459700003, 36.205959377000056],
              [126.54110761800007, 36.212551174000055],
              [126.53492272200003, 36.219631252000056],
              [126.55591881600003, 36.26626211100006],
              [126.56796308700007, 36.286810614000046],
              [126.58261152400007, 36.29466380400004],
              [126.57154381600003, 36.30560944200005],
              [126.52906334700003, 36.316107489000046],
              [126.51376386800007, 36.32265859600005],
              [126.52881920700008, 36.33388906500005],
              [126.57333418100006, 36.34259674700007],
              [126.58261152400007, 36.35301341400009],
              [126.57618248800009, 36.36627838700008],
              [126.56039472700002, 36.36961497600004],
              [126.52743574300007, 36.36977773600006],
              [126.52059980600006, 36.37360260600008],
              [126.50879967500009, 36.385199286000045],
              [126.50074303500003, 36.39093659100007],
              [126.50074303500003, 36.397691148000035],
              [126.51376386800007, 36.397691148000035],
              [126.49877937600002, 36.420105859000046],
              [126.5168953000001, 36.428187147000074],
              [126.53753659200004, 36.433220901000084],
              [126.55677759000002, 36.45582983400004],
              [126.597959919, 36.46507264600007],
              [126.61744225400003, 36.47345612200007],
              [126.55909264400009, 36.47345612200007],
              [126.54501386800007, 36.46698639500005],
              [126.52344811300009, 36.441107489000046],
              [126.50757897200003, 36.438666083000044],
              [126.49765058700007, 36.44839101800005],
              [126.48853600400003, 36.466864325000074],
              [126.482758009, 36.48582591400009],
              [126.48340905000009, 36.49701569200005],
              [126.504242384, 36.51666901200008],
              [126.51392662900003, 36.52879466400009],
              [126.51075280000009, 36.53424713700008],
              [126.4915798940001, 36.52866968700005],
              [126.48292076900009, 36.535223700000074],
              [126.47507125300001, 36.53941443800005],
              [126.47032852100006, 36.54019879300006],
              [126.46568460600008, 36.54938739600004],
              [126.47005864200003, 36.557766204000075],
              [126.46921750700005, 36.566933745000085],
              [126.4641820280001, 36.58412088400007],
              [126.45809519600004, 36.59140682000009],
              [126.45765695400007, 36.595595665000076],
              [126.47145646900003, 36.59629146000009],
              [126.49145308100003, 36.60376195500004],
              [126.51231193700005, 36.603209348000064],
              [126.51386797300006, 36.61539162100007],
              [126.519867384, 36.626166083000044],
              [126.511710376, 36.634848333000036],
              [126.49985528800005, 36.63683581500004],
              [126.48379869000007, 36.64960341400007],
              [126.49395599600007, 36.661316129000056],
              [126.50803023500009, 36.67041328400006],
              [126.49851049800009, 36.684273433000044],
              [126.474535156, 36.687885090000066],
              [126.4696868320001, 36.70458703700007],
              [126.477349172, 36.71688812300005],
              [126.50074303500003, 36.71987539300005],
              [126.48731530000009, 36.73216380400004],
              [126.48267662900003, 36.738348700000074],
              [126.47958418100006, 36.74713776200008],
              [126.47120201900009, 36.741400458000044],
              [126.45704186300009, 36.72898997600004],
              [126.44117272200003, 36.723537502000056],
              [126.43799889400009, 36.716457424000055],
              [126.43856855600006, 36.709418036000045],
              [126.44563611300009, 36.70072162800005],
              [126.44688039700009, 36.683761865000065],
              [126.4395134880001, 36.66426528100004],
              [126.443907384, 36.638081079000074],
              [126.43328998600009, 36.61572651200004],
              [126.42423834400006, 36.60658137000007],
              [126.40572781000003, 36.61819575800007],
              [126.38639103700007, 36.618887706000066],
              [126.36714982900003, 36.62906549500008],
              [126.371968767, 36.68307773200007],
              [126.3779087690001, 36.702581756000086],
              [126.36642243100005, 36.70697153900005],
              [126.36988366000003, 36.73232656500005],
              [126.35914147200003, 36.74266185100004],
              [126.34302819100003, 36.74038320500006],
              [126.33399498800009, 36.72736237200007],
              [126.33155358200008, 36.711371161000045],
              [126.32431074300007, 36.699652411000045],
              [126.30152428500003, 36.69936758000006],
              [126.310883009, 36.68398672100005],
              [126.32911217500009, 36.660589911000045],
              [126.33570397200003, 36.64411041900007],
              [126.32471764400009, 36.63662344000005],
              [126.32618248800009, 36.62836334800005],
              [126.34302819100003, 36.61001211100006],
              [126.32772871200007, 36.60757070500006],
              [126.314789259, 36.601629950000074],
              [126.30396569100003, 36.593085028000075],
              [126.295258009, 36.58270905200004],
              [126.29542076900009, 36.59003327000005],
              [126.29428144600001, 36.59747955900008],
              [126.29200280000009, 36.60423411700009],
              [126.28858483200008, 36.61001211100006],
              [126.30233808700007, 36.634426174000055],
              [126.27295983200008, 36.673163153000075],
              [126.28174889400009, 36.692572333000044],
              [126.27418053500003, 36.71987539300005],
              [126.25570722700002, 36.71157461100006],
              [126.22925866000003, 36.68471914300005],
              [126.20972741000003, 36.678900458000044],
              [126.19825280000009, 36.677069403000075],
              [126.18799889400009, 36.673814195000034],
              [126.17774498800009, 36.67324453300006],
              [126.16561933700007, 36.678900458000044],
              [126.16268964900007, 36.68353913000004],
              [126.158539259, 36.69285716400009],
              [126.15699303500003, 36.702053127000056],
              [126.16187584700003, 36.70620351800005],
              [126.20313561300009, 36.70587799700007],
              [126.21363366000003, 36.71161530200004],
              [126.21338951900009, 36.72671133000006],
              [126.20264733200008, 36.74241771000004],
              [126.18726647200003, 36.748480536000045],
              [126.17115319100003, 36.75226471600007],
              [126.15821373800009, 36.76080963700008],
              [126.15308678500003, 36.74884674700007],
              [126.15015709700003, 36.723944403000075],
              [126.14454186300009, 36.71238841400009],
              [126.13282311300009, 36.70384349200009],
              [126.12891686300009, 36.71190013200004],
              [126.13013756600003, 36.73696523600006],
              [126.12818444100003, 36.76129791900007],
              [126.13095136800007, 36.76805247600004],
              [126.156586134, 36.794175523000035],
              [126.16163170700008, 36.80329010600008],
              [126.16561933700007, 36.816066799000055],
              [126.16879316500001, 36.80638255400004],
              [126.17310631600003, 36.79767487200007],
              [126.17847741000003, 36.78945547100005],
              [126.18539472700002, 36.781317450000074],
              [126.19068444100003, 36.78530508000006],
              [126.19727623800009, 36.78489817900004],
              [126.20484459700003, 36.78278229400007],
              [126.21338951900009, 36.781317450000074],
              [126.20289147200003, 36.79319896000004],
              [126.19223066500001, 36.808579820000034],
              [126.22071373800009, 36.80174388200004],
              [126.23243248800009, 36.80418528900009],
              [126.24000084700003, 36.816066799000055],
              [126.21444746200007, 36.81753164300005],
              [126.19874108200008, 36.82322825700004],
              [126.19686933700007, 36.83567942900004],
              [126.21338951900009, 36.85700104400007],
              [126.19076582100001, 36.87201569200005],
              [126.19223066500001, 36.885931708000044],
              [126.20948326900009, 36.89716217700004],
              [126.23389733200008, 36.90420156500005],
              [126.22754967500009, 36.879787502000056],
              [126.22999108200008, 36.873032945000034],
              [126.24374433700007, 36.87067291900007],
              [126.26856530000009, 36.87103913000004],
              [126.27523847700002, 36.87474192900004],
              [126.28174889400009, 36.88373444200005],
              [126.283539259, 36.906236070000034],
              [126.28101647200003, 36.93646881700005],
              [126.28565514400009, 36.96112702000005],
              [126.308929884, 36.966864325000074],
              [126.30591881600003, 36.95307038000004],
              [126.30665123800009, 36.93146393400008],
              [126.31104576900009, 36.90957265800006],
              [126.32349694100003, 36.883246161000045],
              [126.31739342500009, 36.87396881700005],
              [126.30762780000009, 36.865668036000045],
              [126.30152428500003, 36.85700104400007],
              [126.30184980600006, 36.84780508000006],
              [126.30811608200008, 36.83307526200008],
              [126.308929884, 36.82908763200004],
              [126.30347741000003, 36.82436758000006],
              [126.285492384, 36.81492747600004],
              [126.28174889400009, 36.81232330900008],
              [126.28272545700008, 36.80369700700004],
              [126.28598066500001, 36.794582424000055],
              [126.29127037900003, 36.78925202000005],
              [126.29843183700007, 36.791896877000056],
              [126.31527754000001, 36.804348049000055],
              [126.32789147200003, 36.80463288000004],
              [126.35670006600003, 36.788763739000046],
              [126.33602949300007, 36.824652411000045],
              [126.32870527400007, 36.846991278000075],
              [126.33936608200008, 36.85700104400007],
              [126.35547936300009, 36.84048086100006],
              [126.36532636800007, 36.83535390800006],
              [126.36988366000003, 36.84617747600004],
              [126.37411543100006, 36.84955475500004],
              [126.38453209700003, 36.85293203300006],
              [126.40455162900003, 36.85700104400007],
              [126.40455162900003, 36.86322663000004],
              [126.39657636800007, 36.86420319200005],
              [126.377289259, 36.87067291900007],
              [126.377289259, 36.87689850500004],
              [126.40137780000009, 36.88141510600008],
              [126.41553795700008, 36.89984772300005],
              [126.41920006600003, 36.922308661000045],
              [126.41138756600003, 36.93891022300005],
              [126.402679884, 36.94122955900008],
              [126.37647545700008, 36.94159577000005],
              [126.36353600400003, 36.94578685100004],
              [126.353851759, 36.95522695500006],
              [126.35067793100006, 36.964504299000055],
              [126.35547936300009, 36.96775950700004],
              [126.36988366000003, 36.959418036000045],
              [126.37647545700008, 36.97492096600007],
              [126.36939537900003, 36.98411692900004],
              [126.35401451900009, 36.98786041900007],
              [126.33570397200003, 36.986761786000045],
              [126.34310957100001, 36.99445221600007],
              [126.35303795700008, 36.999986070000034],
              [126.36378014400009, 37.00145091400009],
              [126.37354576900009, 36.99701569200005],
              [126.38306725400003, 36.99115631700005],
              [126.39144941500001, 36.98981354400007],
              [126.39527428500003, 36.99290599200009],
              [126.39087975400003, 37.000433661000045],
              [126.39087975400003, 37.007879950000074],
              [126.42774498800009, 37.00836823100008],
              [126.44540449300007, 37.00340403900009],
              [126.45289147200003, 36.99017975500004],
              [126.44784589900007, 36.98200104400007],
              [126.43824303500003, 36.97333405200004],
              [126.43238366000003, 36.96198151200008],
              [126.43873131600003, 36.94578685100004],
              [126.44752037900003, 36.952826239000046],
              [126.45883222700002, 36.95774974200009],
              [126.46859785200002, 36.95758698100008],
              [126.47274824300007, 36.949204820000034],
              [126.47388756600003, 36.94220612200007],
              [126.47852623800009, 36.93585846600007],
              [126.47958418100006, 36.929022528000075],
              [126.47779381600003, 36.92641836100006],
              [126.46876061300009, 36.91779205900008],
              [126.46591230600006, 36.91160716400009],
              [126.46591230600006, 36.86692942900004],
              [126.46924889400009, 36.85398997600004],
              [126.47657311300009, 36.844916083000044],
              [126.48389733200008, 36.841498114000046],
              [126.48715254000001, 36.84617747600004],
              [126.49122155000009, 36.871079820000034],
              [126.50953209700003, 36.918850002000056],
              [126.51376386800007, 36.94236888200004],
              [126.51913496200007, 36.94790273600006],
              [126.53126061300009, 36.94131094000005],
              [126.54859459700003, 36.92593008000006],
              [126.55567467500009, 36.91510651200008],
              [126.56080162900003, 36.90509674700007],
              [126.56836998800009, 36.898504950000074],
              [126.58261152400007, 36.89801666900007],
              [126.58261152400007, 36.90420156500005],
              [126.57545006600003, 36.911810614000046],
              [126.566742384, 36.93219635600008],
              [126.55909264400009, 36.94236888200004],
              [126.49781334700003, 36.994208075000074],
              [126.49341881600003, 36.99701569200005],
              [126.49683678500003, 37.007798570000034],
              [126.50538170700008, 37.00657786700009],
              [126.51563561300009, 36.99884674700007],
              [126.531586134, 36.98289622600004],
              [126.54004967500009, 36.97687409100007],
              [126.55030358200008, 36.97313060100004],
              [126.56275475400003, 36.973089911000045],
              [126.57211347700002, 36.97748444200005],
              [126.57300866000003, 36.984361070000034],
              [126.56617272200003, 36.99079010600008],
              [126.55201256600003, 36.99359772300005],
              [126.53296959700003, 37.00092194200005],
              [126.51225445700004, 37.016430340000056],
              [126.50292077300003, 37.039520921000076],
              [126.50074303500003, 37.05499909100007],
              [126.51905358200008, 37.05540599200009],
              [126.53500410200002, 37.049261786000045],
              [126.54932701900009, 37.03921133000006],
              [126.56934144700006, 37.02777751600007],
              [126.58845236900004, 37.01722113300008],
              [126.59629238700006, 37.01082778700004],
              [126.61146668700007, 37.00256009700007],
              [126.626094867, 36.99610446500009],
              [126.63609541000005, 36.982453124000074],
              [126.63138267900001, 36.968930852000085],
              [126.62167402400007, 36.95978424700007],
              [126.62362714900007, 36.95262278900009],
              [126.63355553500003, 36.93740469000005],
              [126.63477623800009, 36.92804596600007],
              [126.63111412900003, 36.91160716400009],
              [126.64210045700008, 36.91771067900004],
              [126.64649498800009, 36.925116278000075],
              [126.64918053500003, 36.93341705900008],
              [126.645375457, 36.957953220000036],
              [126.64944896100008, 36.96605646100005],
              [126.65579253700002, 36.97459363300004],
              [126.66504315300006, 36.988524572000074],
              [126.681544454, 36.99470406900008],
              [126.69703209700003, 36.99481842700004],
              [126.71434831600004, 36.993042063000075],
              [126.73351239400006, 36.98743087200006],
              [126.75776694600006, 36.982219859000054],
              [126.77515709700003, 36.973089911000045],
              [126.79623457100001, 36.95575592700004],
              [126.79769941500001, 36.93439362200007],
              [126.78199303500003, 36.89118073100008],
              [126.79395592500009, 36.89752838700008],
              [126.81275475400003, 36.91693756700005],
              [126.82300866000003, 36.91844310100004],
              [126.83017011800007, 36.910223700000074],
              [126.834320509, 36.89549388200004],
              [126.83651777400007, 36.86692942900004],
              [126.83545983200008, 36.86082591400009],
              [126.83082116000003, 36.84723541900007],
              [126.82984459700003, 36.83934153900009],
              [126.83179772200003, 36.83112213700008],
              [126.84066816500001, 36.81915924700007],
              [126.84913170700008, 36.78803131700005],
              [126.84628339900007, 36.77912018400008],
              [126.82984459700003, 36.775091864000046],
              [126.83285566500001, 36.76666901200008],
              [126.83676191500001, 36.760931708000044],
              [126.84253991000003, 36.757025458000044],
              [126.85084069100003, 36.753973700000074],
              [126.85670006600003, 36.77643463700008],
              [126.86654707100001, 36.78978099200009],
              [126.87159264400009, 36.804022528000075],
              [126.86329186300009, 36.82908763200004],
              [126.88355553500003, 36.82436758000006],
              [126.90479576900009, 36.822251695000034],
              [126.87045332100001, 36.852769273000035],
              [126.86019941500001, 36.869574286000045],
              [126.88062584700003, 36.87689850500004],
              [126.89901777400007, 36.879339911000045],
              [126.94247480600006, 36.89337799700007],
              [126.97445722700002, 36.91290924700007],
              [126.98951256600003, 36.91860586100006],
              [127.000336134, 36.92837148600006],
              [127.00717207100001, 36.95262278900009],
              [127.00521894600001, 36.95693594000005],
              [126.99594160200002, 36.96478913000004],
              [126.99415123800009, 36.966864325000074],
              [126.99952233200008, 36.97089264500005],
              [127.00489342500009, 36.97142161700009],
              [127.01002037900003, 36.97125885600008],
              [127.02393639400009, 36.977443752000056],
              [127.03280683700007, 36.978501695000034],
              [127.039398634, 36.98200104400007],
              [127.04200280000009, 36.99359772300005],
              [126.98218834700003, 36.980169989000046],
              [126.97315514400009, 36.969956773000035],
              [126.97632897200003, 36.93903229400007],
              [126.969086134, 36.93203359600005],
              [126.94581139400009, 36.92593008000006],
              [126.91268964900007, 36.92963288000004],
              [126.873383009, 36.94798411700009],
              [126.83790123800009, 36.975897528000075],
              [126.82440967100001, 37.00261617600006],
              [126.88428795700008, 37.007879950000074],
              [126.88428795700008, 37.014105536000045],
              [126.88013756600003, 37.015692450000074],
              [126.87069746200007, 37.021470445000034],
              [126.88192793100006, 37.022650458000044],
              [126.89258873800009, 37.02216217700004],
              [126.90235436300009, 37.01947663000004],
              [126.91098066500001, 37.014105536000045],
              [126.90674889400009, 37.03314850500004],
              [126.89307701900009, 37.050116278000075],
              [126.883148634, 37.069566148000035],
              [126.89047285200002, 37.09593333500004],
              [126.87916100400003, 37.10000234600005],
              [126.87045332100001, 37.09076569200005],
              [126.86508222700002, 37.07485586100006],
              [126.86329186300009, 37.05878327000005],
              [126.85865319100003, 37.04132721600007],
              [126.84913170700008, 37.03729889500005],
              [126.83969160200002, 37.04486725500004],
              [126.82056725400003, 37.04169342700004],
              [126.80128014400009, 37.03774648600006],
              [126.75521894600001, 37.048814195000034],
              [126.75552653200009, 37.06014106400005],
              [126.75119053500009, 37.07009237300008],
              [126.75481395200006, 37.08355618400009],
              [126.75285886400002, 37.100687967000056],
              [126.76445101400009, 37.11765780400009],
              [126.77826835000008, 37.13280400600007],
              [126.79418169300004, 37.13892030000005],
              [126.8112099, 37.144120531000056],
              [126.83651777400007, 37.14443594000005],
              [126.86353600400003, 37.15029531500005],
              [126.86915123800009, 37.15696849200009],
              [126.87069746200007, 37.175482489000046],
              [126.86451256600003, 37.17910390800006],
              [126.85059655000009, 37.173041083000044],
              [126.82984459700003, 37.15867747600004],
              [126.81690514400009, 37.16079336100006],
              [126.80738366000003, 37.165269273000035],
              [126.80225670700008, 37.173163153000075],
              [126.80233808700007, 37.18537018400008],
              [126.77857506600003, 37.17568594000005],
              [126.75928795700008, 37.16469961100006],
              [126.72364342500009, 37.13385651200008],
              [126.71444746200007, 37.12799713700008],
              [126.70289147200003, 37.124701239000046],
              [126.69214928500003, 37.124986070000034],
              [126.68563886800007, 37.130113023000035],
              [126.68604576900009, 37.13930898600006],
              [126.69214928500003, 37.14826080900008],
              [126.70687910200002, 37.16486237200007],
              [126.67774498800009, 37.159491278000075],
              [126.66846764400009, 37.161810614000046],
              [126.66529381600003, 37.175482489000046],
              [126.67066491000003, 37.185614325000074],
              [126.68287194100003, 37.19135163000004],
              [126.69678795700008, 37.19513580900008],
              [126.70687910200002, 37.199652411000045],
              [126.71900475400003, 37.212876695000034],
              [126.71583092500009, 37.21629466400009],
              [126.68905683700007, 37.213324286000045],
              [126.68018639400009, 37.217678127000056],
              [126.67318769600001, 37.22842031500005],
              [126.66651451900009, 37.241848049000055],
              [126.65845787900003, 37.25429922100005],
              [126.66293379000001, 37.25531647300005],
              [126.66578209700003, 37.25690338700008],
              [126.67212975400003, 37.261704820000034],
              [126.67945397200003, 37.25722890800006],
              [126.69052168100006, 37.25771719000005],
              [126.70997155000009, 37.261704820000034],
              [126.72584069100003, 37.25820547100005],
              [126.73910566500001, 37.251654364000046],
              [126.75220787900003, 37.24827708500004],
              [126.76758873800009, 37.25429922100005],
              [126.76636803500003, 37.24315013200004],
              [126.76758873800009, 37.23232656500005],
              [126.77247155000009, 37.223944403000075],
              [126.78199303500003, 37.22016022300005],
              [126.79249108200008, 37.22345612200007],
              [126.79737389400009, 37.232855536000045],
              [126.80233808700007, 37.25429922100005],
              [126.81918379000001, 37.27440013200004],
              [126.83301842500009, 37.27285390800006],
              [126.84864342500009, 37.265326239000046],
              [126.87069746200007, 37.26788971600007],
              [126.86597741000003, 37.27606842700004],
              [126.85987389400009, 37.282131252000056],
              [126.85214277400007, 37.28620026200008],
              [126.84278405000009, 37.288397528000075],
              [126.82889134800007, 37.287984005000055],
              [126.8225444740001, 37.29560677300009],
              [126.8076026970001, 37.29776593100007],
              [126.79555963000007, 37.294724614000074],
              [126.783573079, 37.295267564000085],
              [126.76464317200009, 37.29826674600008],
              [126.73331008900004, 37.30617043500007],
              [126.68979271900002, 37.332486420000066],
              [126.68748790400002, 37.344027753000034],
              [126.70686509900008, 37.366468577000035],
              [126.72004509100009, 37.37705338200004],
              [126.717162389, 37.38383877600006],
              [126.664750292, 37.38916822900006],
              [126.64034014200001, 37.36438956600006],
              [126.61508749300003, 37.37974492700005],
              [126.62538212000004, 37.39791834500005],
              [126.63862853900002, 37.41379056200009],
              [126.63030839400005, 37.42501279800007],
              [126.61240549000001, 37.43274063700005],
              [126.59598521600003, 37.43965658900004],
              [126.59829071400009, 37.457927538000035],
              [126.59501803700005, 37.47227345500005],
              [126.60476098200002, 37.48569654000005],
              [126.63344429000006, 37.492570852000085],
              [126.64202197400004, 37.49606221200008],
              [126.64416298100002, 37.50438517100008],
              [126.63067522600011, 37.50730105300005],
              [126.627025162, 37.49859465700007],
              [126.60645123400002, 37.49681174700004],
              [126.60110577300009, 37.50680210400009],
              [126.59890451700005, 37.52510653300004],
              [126.60379237200004, 37.54929667300007],
              [126.598906704, 37.55808773500007],
              [126.59110467000005, 37.57287000800005],
              [126.58225004500002, 37.58448345700009],
              [126.57193454900005, 37.59849457000007],
              [126.560514625, 37.60735331500007],
              [126.56028577100005, 37.62084737200007],
              [126.55616295700008, 37.64101797100005],
              [126.54542076900009, 37.67251211100006],
              [126.53101647200003, 37.75470612200007],
              [126.53492272200003, 37.76821523600006],
              [126.54818769600001, 37.77016836100006],
              [126.60328209700003, 37.75454336100006],
              [126.62086022200003, 37.75755442900004],
              [126.63550866000003, 37.763006903000075],
              [126.64852949300007, 37.76504140800006],
              [126.66187584700003, 37.75796133000006],
              [126.66684004000001, 37.746161200000074],
              [126.66879316500001, 37.727728583000044],
              [126.66732832100001, 37.70880768400008],
              [126.66187584700003, 37.69586823100008],
              [126.66146894600001, 37.67243073100008],
              [126.69214928500003, 37.652044989000046],
              [126.73104902400007, 37.63906484600005],
              [126.75521894600001, 37.637884833000044],
              [126.73642011800007, 37.65330638200004],
              [126.67880293100006, 37.68626536700009],
              [126.69556725400003, 37.72174713700008],
              [126.70053144600001, 37.74298737200007],
              [126.69629967500009, 37.75796133000006],
              [126.68685957100001, 37.77362702000005],
              [126.68604469700011, 37.78218270500007],
              [126.68490644600001, 37.79360586100006],
              [126.68946373800009, 37.813666083000044],
              [126.69996178500003, 37.82965729400007],
              [126.69247480600006, 37.837103583000044],
              [126.68262780000009, 37.836004950000074],
              [126.6674589270001, 37.827810161000016],
              [126.66051639800008, 37.913810934000125],
              [126.66578739500011, 37.9376337690001],
              [126.67782800300006, 37.94458424900007],
              [126.69632816600011, 37.9461862190001],
              [126.72211470600013, 37.953937683000035],
              [126.76190555800014, 37.97900075300002],
              [126.84732670200003, 38.082017721000014],
              [126.86479333500006, 38.09602203400003],
              [126.90334395400015, 38.119586487000035],
              [126.91982873600006, 38.13459849100009],
              [126.94013424700006, 38.17417257100003],
              [126.95372847500005, 38.20066681000007],
              [126.96606463600006, 38.21303801600003],
              [126.97191857900009, 38.21890859000011],
              [127.02674727400006, 38.25446197600009],
              [127.09046431500008, 38.2858554080001],
              [127.15748864800003, 38.30722361300012],
              [127.22198083500012, 38.3127013150001],
              [127.25381351800007, 38.31003997800006],
              [127.377113485, 38.31851491300007],
              [127.47193973800006, 38.295906474000034],
              [127.5020670990001, 38.298076884000025],
              [127.56082320200011, 38.31208119700004],
              [127.75373132300001, 38.32536204100005],
              [127.76194787700007, 38.32096954300006],
              [127.7747119550001, 38.306448466000106],
              [127.78701094600007, 38.29668162000006],
              [127.80075687700008, 38.2939169320001],
              [127.86685103400015, 38.30484649700007],
              [127.97175419200005, 38.30004058900006],
              [128.03986372900016, 38.30427805600003],
              [128.1084900310001, 38.323501689000025],
              [128.17236210200014, 38.35595448900004],
              [128.22558882700002, 38.399776103000065],
              [128.24873986800003, 38.42576934800012],
              [128.26806685400004, 38.45351959300005],
              [128.2810893150001, 38.484370423000044],
              [128.28543013600006, 38.51984629300007],
              [128.27695520100008, 38.55405609100008],
              [128.27478479, 38.57149688700012],
              [128.2810893150001, 38.58441599600003],
              [128.30837447200008, 38.601340027000035],
              [128.36491946700005, 38.624335028000075],
            ],
          ],
          [
            [
              [126.40541386500001, 36.458835528000066],
              [126.41293379000001, 36.440334377000056],
              [126.42644290500004, 36.42357005400004],
              [126.43213951900009, 36.40794505400004],
              [126.42261803500003, 36.41152578300006],
              [126.37818444100003, 36.409491278000075],
              [126.36378014400009, 36.411363023000035],
              [126.36105280800007, 36.42632098100006],
              [126.36587392800004, 36.43164458400008],
              [126.37355578800009, 36.43733670200004],
              [126.37761478000004, 36.446193752000056],
              [126.35377037900003, 36.43406810100004],
              [126.34262129000001, 36.438381252000056],
              [126.34571373800009, 36.45331452000005],
              [126.36378014400009, 36.47345612200007],
              [126.35694420700008, 36.47964101800005],
              [126.34327233200008, 36.46662018400008],
              [126.33864029100005, 36.47561102900005],
              [126.32814310100002, 36.47108949500006],
              [126.33360616900006, 36.49509332900004],
              [126.32976321700005, 36.53172435100004],
              [126.32515322400002, 36.55386421500009],
              [126.31481811200001, 36.58178686300005],
              [126.32346290300006, 36.590890510000065],
              [126.34118120200003, 36.60413360200005],
              [126.3602436000001, 36.609360123000044],
              [126.37354576900009, 36.592230536000045],
              [126.375336134, 36.58608633000006],
              [126.370993698, 36.57875429600006],
              [126.36336739900003, 36.573839777000046],
              [126.36426630900007, 36.56697022900005],
              [126.38111412900003, 36.53628164300005],
              [126.38379967500009, 36.52651601800005],
              [126.37940514400009, 36.51837799700007],
              [126.38456565000001, 36.511198198000045],
              [126.39590957400003, 36.505792186000065],
              [126.40479576900009, 36.49331289300005],
              [126.38379967500009, 36.49331289300005],
              [126.38379967500009, 36.48712799700007],
              [126.39063561300009, 36.486029364000046],
              [126.40479576900009, 36.47964101800005],
              [126.40369050900006, 36.473343568000075],
              [126.40268670300009, 36.468391678000046],
              [126.40541386500001, 36.458835528000066],
            ],
          ],
          [
            [
              [126.295258009, 37.80247630400004],
              [126.31495201900009, 37.802720445000034],
              [126.33326256600003, 37.800441799000055],
              [126.34253991000003, 37.79214101800005],
              [126.33594811300009, 37.77440013200004],
              [126.31820722700002, 37.76227448100008],
              [126.29623457100001, 37.76113515800006],
              [126.25456790500004, 37.76821523600006],
              [126.24537194100003, 37.76536692900004],
              [126.23414147200003, 37.760646877000056],
              [126.22445722700002, 37.76044342700004],
              [126.22046959700003, 37.77130768400008],
              [126.22266686300009, 37.774725653000075],
              [126.23414147200003, 37.80231354400007],
              [126.246429884, 37.811753648000035],
              [126.26050866000003, 37.81476471600007],
              [126.27654056100005, 37.81150950700004],
              [126.295258009, 37.80247630400004],
            ],
          ],
          [
            [
              [126.94605553500003, 33.47801341400009],
              [126.95362389400009, 33.46503327000005],
              [126.94898522200003, 33.460598049000055],
              [126.93930097700002, 33.458238023000035],
              [126.93238366000003, 33.45132070500006],
              [126.93287194100003, 33.44550202000005],
              [126.93921959700003, 33.43626536700009],
              [126.93921959700003, 33.430853583000044],
              [126.93580162900003, 33.425482489000046],
              [126.92725670700008, 33.416083075000074],
              [126.92554772200003, 33.41315338700008],
              [126.90750666100007, 33.39572509800007],
              [126.8735300400001, 33.37304551400007],
              [126.86299236000002, 33.354141206000065],
              [126.84795550900003, 33.33206531500008],
              [126.8472391360001, 33.323217852000084],
              [126.84058678500003, 33.310207424000055],
              [126.81592858200008, 33.307806708000044],
              [126.80640709700003, 33.303615627000056],
              [126.78014100500002, 33.30555029000004],
              [126.74179256500008, 33.28020847200008],
              [126.64072332900002, 33.26466618400008],
              [126.60691886200004, 33.24061045800005],
              [126.56552749000002, 33.23290783600004],
              [126.52120889500009, 33.23661779000008],
              [126.47056220500008, 33.228713895000055],
              [126.42845775900003, 33.23930930200004],
              [126.33342729600008, 33.238169044000074],
              [126.30379021400006, 33.22655937400009],
              [126.28614342500009, 33.200384833000044],
              [126.27003014400009, 33.19757721600007],
              [126.25391686300009, 33.20404694200005],
              [126.23115058600001, 33.23492299600008],
              [126.20082394300005, 33.24355202400005],
              [126.17139733200008, 33.26935455900008],
              [126.16114342500009, 33.300767320000034],
              [126.17896569100003, 33.341457424000055],
              [126.19581139400009, 33.36668528900009],
              [126.20622806100005, 33.37555573100008],
              [126.24097741000003, 33.39276764500005],
              [126.27066067500004, 33.435873541000035],
              [126.297949248, 33.441714895000075],
              [126.31056732700006, 33.46447646100006],
              [126.35736028600002, 33.47796084100008],
              [126.45938010300006, 33.50238055700004],
              [126.4849345880001, 33.52075755100009],
              [126.58243391300005, 33.52928356800004],
              [126.64879765800003, 33.553426278000074],
              [126.664691543, 33.54967581000005],
              [126.74550521600008, 33.56055637400004],
              [126.79236033000007, 33.56379690500006],
              [126.82336637100002, 33.55943982600007],
              [126.83521569100003, 33.544582424000055],
              [126.849945509, 33.53497955900008],
              [126.89820397200003, 33.51898834800005],
              [126.91285241000003, 33.50657786700009],
              [126.92269941500001, 33.476629950000074],
              [126.93238366000003, 33.464911200000074],
              [126.93702233200008, 33.46946849200009],
              [126.94336998800009, 33.473822333000044],
              [126.94605553500003, 33.47801341400009],
            ],
          ],
          [
            [
              [127.17302493600005, 34.483710028000075],
              [127.20427493600005, 34.486761786000045],
              [127.22055097700002, 34.48574453300006],
              [127.23422285200002, 34.48029205900008],
              [127.24512780000009, 34.464056708000044],
              [127.24187259200005, 34.44546133000006],
              [127.22868899800005, 34.43024323100008],
              [127.21021569100003, 34.42397695500006],
              [127.16895592500009, 34.41771067900004],
              [127.15300540500004, 34.419582424000055],
              [127.14128665500004, 34.42430247600004],
              [127.11736087300005, 34.437567450000074],
              [127.11736087300005, 34.445013739000046],
              [127.12281334700003, 34.45058828300006],
              [127.12378991000003, 34.45522695500006],
              [127.11988366000003, 34.45970286700009],
              [127.11052493600005, 34.464911200000074],
              [127.12435957100001, 34.47333405200004],
              [127.14031009200005, 34.47870514500005],
              [127.17302493600005, 34.483710028000075],
            ],
          ],
          [
            [
              [126.38005618600005, 34.49843984600005],
              [126.38160241000003, 34.48468659100007],
              [126.37891686300009, 34.46930573100008],
              [126.37354576900009, 34.454413153000075],
              [126.353851759, 34.419582424000055],
              [126.34587649800005, 34.40900299700007],
              [126.33594811300009, 34.40346914300005],
              [126.33423912900003, 34.40656159100007],
              [126.31714928500003, 34.419907945000034],
              [126.30925540500004, 34.42397695500006],
              [126.30925540500004, 34.41771067900004],
              [126.30518639400009, 34.401678778000075],
              [126.20997155000009, 34.35879140800006],
              [126.19849694100003, 34.355536200000074],
              [126.15642337300005, 34.35260651200008],
              [126.14478600400003, 34.35504791900007],
              [126.14258873800009, 34.36375560100004],
              [126.14820397200003, 34.371079820000034],
              [126.15560957100001, 34.37718333500004],
              [126.15845787900003, 34.38231028900009],
              [126.15308678500003, 34.38849518400008],
              [126.12427819100003, 34.40346914300005],
              [126.12427819100003, 34.38231028900009],
              [126.10328209700003, 34.402777411000045],
              [126.11573326900009, 34.43618398600006],
              [126.14421634200005, 34.46320221600007],
              [126.17212975400003, 34.464911200000074],
              [126.18116295700008, 34.48651764500005],
              [126.18702233200008, 34.494208075000074],
              [126.19629967500009, 34.50275299700007],
              [126.20704186300009, 34.50763580900008],
              [126.21656334700003, 34.508978583000044],
              [126.22380618600005, 34.51341380400004],
              [126.22657311300009, 34.52757396000004],
              [126.23829186300009, 34.515692450000074],
              [126.25416100400003, 34.51434967700004],
              [126.26832116000003, 34.52204010600008],
              [126.27442467500009, 34.53725820500006],
              [126.26677493600005, 34.54975006700005],
              [126.24105879000001, 34.566473700000074],
              [126.24773196700005, 34.57477448100008],
              [126.26392662900003, 34.57575104400007],
              [126.28044681100005, 34.56830475500004],
              [126.29476972700002, 34.55890534100007],
              [126.30543053500003, 34.55426666900007],
              [126.30787194100003, 34.55145905200004],
              [126.31080162900003, 34.54515208500004],
              [126.31560306100005, 34.538275458000044],
              [126.32227623800009, 34.53384023600006],
              [126.32683353000004, 34.53506094000005],
              [126.34945722700002, 34.54682038000004],
              [126.35035241000003, 34.53815338700008],
              [126.38005618600005, 34.49843984600005],
            ],
          ],
          [
            [
              [127.78207441500001, 34.68455638200004],
              [127.79249108200008, 34.68235911700009],
              [127.80160566500001, 34.67047760600008],
              [127.80876712300005, 34.65582916900007],
              [127.81723066500001, 34.63076406500005],
              [127.81812584700003, 34.61615631700005],
              [127.81511478000004, 34.60195547100005],
              [127.80787194100003, 34.58820221600007],
              [127.79786217500009, 34.579738674000055],
              [127.78663170700008, 34.579006252000056],
              [127.77540123800009, 34.583970445000034],
              [127.74000084700003, 34.61367422100005],
              [127.73585045700008, 34.62523021000004],
              [127.74187259200005, 34.64362213700008],
              [127.74626712300005, 34.648423570000034],
              [127.76498457100001, 34.66010163000004],
              [127.76832116000003, 34.666083075000074],
              [127.77588951900009, 34.691473700000074],
              [127.76075280000009, 34.704738674000055],
              [127.76254316500001, 34.71283600500004],
              [127.77344811300009, 34.71698639500005],
              [127.78589928500003, 34.71816640800006],
              [127.79664147200003, 34.714178778000075],
              [127.79932701900009, 34.70482005400004],
              [127.79420006600003, 34.693793036000045],
              [127.78207441500001, 34.68455638200004],
            ],
          ],
          [
            [
              [125.98902428500003, 34.713324286000045],
              [126.00098717500009, 34.704413153000075],
              [126.00407962300005, 34.70026276200008],
              [126.00538170700008, 34.692613023000035],
              [126.00318444100003, 34.684759833000044],
              [125.99903405000009, 34.677435614000046],
              [125.98389733200008, 34.66063060100004],
              [125.976898634, 34.65639883000006],
              [125.96998131600003, 34.655910549000055],
              [125.95972741000003, 34.656683661000045],
              [125.95964603000004, 34.659816799000055],
              [125.94516035200002, 34.66681549700007],
              [125.92945397200003, 34.672308661000045],
              [125.92505944100003, 34.67096588700008],
              [125.91602623800009, 34.68764883000006],
              [125.92286217500009, 34.695379950000074],
              [125.95240319100003, 34.705145575000074],
              [125.97055097700002, 34.72565338700008],
              [125.97673587300005, 34.72825755400004],
              [125.98047936300009, 34.726223049000055],
              [125.98902428500003, 34.713324286000045],
            ],
          ],
          [
            [
              [126.00717207100001, 34.780951239000046],
              [126.00757897200003, 34.75971100500004],
              [126.00294030000009, 34.76146067900004],
              [125.99154707100001, 34.764105536000045],
              [125.98650149800005, 34.76654694200005],
              [125.97787519600001, 34.757147528000075],
              [125.96420332100001, 34.757066148000035],
              [125.95167076900009, 34.75926341400009],
              [125.94613691500001, 34.75665924700007],
              [125.94410241000003, 34.74323151200008],
              [125.93873131600003, 34.73143138200004],
              [125.930023634, 34.72260163000004],
              [125.91814212300005, 34.71816640800006],
              [125.90642337300005, 34.71930573100008],
              [125.89779707100001, 34.72601959800005],
              [125.89258873800009, 34.73663971600007],
              [125.89087975400003, 34.74982330900008],
              [125.89389082100001, 34.76227448100008],
              [125.90186608200008, 34.77106354400007],
              [125.91285241000003, 34.77692291900007],
              [125.92505944100003, 34.78082916900007],
              [125.93864993600005, 34.77651601800005],
              [125.95655358200008, 34.779730536000045],
              [125.98926842500009, 34.79002513200004],
              [125.99594160200002, 34.79075755400004],
              [126.00074303500003, 34.79010651200008],
              [126.00440514400009, 34.787176825000074],
              [126.00717207100001, 34.780951239000046],
            ],
          ],
          [
            [
              [126.05600019600001, 34.91364166900007],
              [126.06031334700003, 34.92690664300005],
              [126.07007897200003, 34.928900458000044],
              [126.08122806100005, 34.92259349200009],
              [126.08912194100003, 34.911322333000044],
              [126.09148196700005, 34.896918036000045],
              [126.08838951900009, 34.88296133000006],
              [126.08073978000004, 34.87099844000005],
              [126.06910241000003, 34.86273834800005],
              [126.05469811300009, 34.85919830900008],
              [126.04639733200008, 34.86180247600004],
              [126.03988691500001, 34.866441148000035],
              [126.03142337300005, 34.86896393400008],
              [125.99878991000003, 34.862941799000055],
              [125.98650149800005, 34.86273834800005],
              [125.98650149800005, 34.86896393400008],
              [125.99634850400003, 34.87604401200008],
              [126.01433353000004, 34.899644273000035],
              [126.02800540500004, 34.90989817900004],
              [126.03443444100003, 34.90957265800006],
              [126.04395592500009, 34.907416083000044],
              [126.05225670700008, 34.907538153000075],
              [126.05600019600001, 34.91364166900007],
            ],
          ],
          [
            [
              [128.06959069100003, 34.81500885600008],
              [128.0747176440001, 34.80365631700005],
              [128.07178795700008, 34.79364655200004],
              [128.06625410200002, 34.78302643400008],
              [128.063324415, 34.769964911000045],
              [128.06609134200005, 34.749335028000075],
              [128.06527754, 34.737534898000035],
              [128.0595809250001, 34.732407945000034],
              [128.051605665, 34.72870514500005],
              [128.06006920700008, 34.70840078300006],
              [128.05591881600003, 34.69822825700004],
              [128.04053795700008, 34.69586823100008],
              [128.0258895190001, 34.703111070000034],
              [128.010101759, 34.70880768400008],
              [127.99154707100001, 34.70172760600008],
              [127.97527103000004, 34.69993724200009],
              [127.96534264400009, 34.71930573100008],
              [127.95411217500009, 34.75971100500004],
              [127.93767337300005, 34.76703522300005],
              [127.92457116000003, 34.75958893400008],
              [127.91570071700005, 34.74274323100008],
              [127.91236412900003, 34.721869208000044],
              [127.90626061300009, 34.71308014500005],
              [127.89210045700008, 34.71271393400008],
              [127.87712649800005, 34.71694570500006],
              [127.86801191500001, 34.721869208000044],
              [127.86182701900009, 34.73086172100005],
              [127.86036217500009, 34.738267320000034],
              [127.86011803500003, 34.74701569200005],
              [127.85792076900009, 34.75971100500004],
              [127.83033287900003, 34.83356354400007],
              [127.82667076900009, 34.85138580900008],
              [127.82935631600003, 34.86896393400008],
              [127.84083092500009, 34.88694896000004],
              [127.84848066500001, 34.89154694200005],
              [127.85629316500001, 34.89272695500006],
              [127.86231530000009, 34.89606354400007],
              [127.86703535200002, 34.91815827000005],
              [127.87289472700002, 34.92446523600006],
              [127.88892662900003, 34.934759833000044],
              [127.90211022200003, 34.94000885600008],
              [127.91724694100003, 34.93618398600006],
              [127.93051191500001, 34.92645905200004],
              [127.93824303500003, 34.91396719000005],
              [127.93685957100001, 34.900824286000045],
              [127.928070509, 34.88825104400007],
              [127.90560957100001, 34.86896393400008],
              [127.90967858200008, 34.86204661700009],
              [127.91431725400003, 34.84454987200007],
              [127.91993248800009, 34.83543528900009],
              [127.92847741000003, 34.83055247600004],
              [127.94988040500004, 34.824652411000045],
              [127.96192467500009, 34.80695221600007],
              [127.98129316500001, 34.809759833000044],
              [128.0058699880001, 34.817694403000075],
              [128.02906334700003, 34.82176341400009],
              [128.06275475400003, 34.81712474200009],
              [128.06959069100003, 34.81500885600008],
            ],
          ],
          [
            [
              [128.7485457690001, 34.86896393400008],
              [128.747406446, 34.857123114000046],
              [128.74293053500003, 34.84454987200007],
              [128.73414147200003, 34.837551174000055],
              [128.72055097700002, 34.84227122600004],
              [128.72608483200008, 34.82884349200009],
              [128.73902428500003, 34.80621979400007],
              [128.74170983200008, 34.790716864000046],
              [128.73406009200005, 34.78823476800005],
              [128.71656334700003, 34.79319896000004],
              [128.6977645190001, 34.80133698100008],
              [128.68637129, 34.80809153900009],
              [128.68327884200005, 34.794134833000044],
              [128.6801863940001, 34.78656647300005],
              [128.66285241000003, 34.769964911000045],
              [128.6572371750001, 34.75698476800005],
              [128.66911868600005, 34.74949778900009],
              [128.6855574880001, 34.743841864000046],
              [128.6938582690001, 34.73615143400008],
              [128.6782332690001, 34.72483958500004],
              [128.605804884, 34.706366278000075],
              [128.5839949880001, 34.705145575000074],
              [128.6181746750001, 34.72557200700004],
              [128.6040145190001, 34.73110586100006],
              [128.5986434250001, 34.73997630400004],
              [128.59945722700002, 34.75189850500004],
              [128.6045028000001, 34.76654694200005],
              [128.57349694100003, 34.75348541900007],
              [128.56430097700002, 34.75873444200005],
              [128.55982506600003, 34.77024974200009],
              [128.56039472700002, 34.78180573100008],
              [128.56666100400003, 34.78705475500004],
              [128.59156334700003, 34.79120514500005],
              [128.5986434250001, 34.80223216400009],
              [128.59913170700008, 34.81781647300005],
              [128.6045028000001, 34.83543528900009],
              [128.5908309250001, 34.84227122600004],
              [128.5805770190001, 34.83185455900008],
              [128.54468834700003, 34.818793036000045],
              [128.52881920700008, 34.80809153900009],
              [128.51742597700002, 34.82265859600005],
              [128.50318444100003, 34.83551666900007],
              [128.491547071, 34.84992096600007],
              [128.48845462300005, 34.86896393400008],
              [128.49488366000003, 34.88043854400007],
              [128.50806725400003, 34.89101797100005],
              [128.52328535200002, 34.89915599200009],
              [128.53630618600005, 34.90371328300006],
              [128.57374108200008, 34.91006094000005],
              [128.5839949880001, 34.90989817900004],
              [128.60043379, 34.90420156500005],
              [128.61353600400003, 34.89716217700004],
              [128.6269637380001, 34.89175039300005],
              [128.6455184250001, 34.890692450000074],
              [128.6455184250001, 34.896918036000045],
              [128.6269637380001, 34.90692780200004],
              [128.61638431100005, 34.921861070000034],
              [128.611664259, 34.93891022300005],
              [128.61060631600003, 34.95490143400008],
              [128.62378991000003, 34.953558661000045],
              [128.6938582690001, 34.98627350500004],
              [128.68189537900003, 35.00462474200009],
              [128.6875106130001, 35.02285390800006],
              [128.70289147200003, 35.03294505400004],
              [128.72055097700002, 35.02724844000005],
              [128.724945509, 35.01894765800006],
              [128.72527103000004, 35.00926341400009],
              [128.7187606130001, 34.97215403900009],
              [128.7192488940001, 34.96629466400009],
              [128.72388756600003, 34.95453522300005],
              [128.72999108200008, 34.94513580900008],
              [128.7343856130001, 34.93545156500005],
              [128.73414147200003, 34.922308661000045],
              [128.73015384200005, 34.91038646000004],
              [128.71436608200008, 34.87641022300005],
              [128.73462975400003, 34.88226959800005],
              [128.74431399800005, 34.88776276200008],
              [128.74756920700008, 34.88580963700008],
              [128.7485457690001, 34.86896393400008],
            ],
          ],
          [
            [
              [126.11060631600003, 35.05117422100005],
              [126.10523522200003, 35.050034898000035],
              [126.07862389400009, 35.055853583000044],
              [126.06910241000003, 35.05459219000005],
              [126.06544030000009, 35.05683014500005],
              [126.06299889400009, 35.059027411000045],
              [126.06039472700002, 35.06073639500005],
              [126.05600019600001, 35.06134674700007],
              [126.06381269600001, 35.093085028000075],
              [126.06910241000003, 35.10236237200007],
              [126.07601972700002, 35.10561758000006],
              [126.08790123800009, 35.10887278900009],
              [126.09888756600003, 35.113267320000034],
              [126.10377037900003, 35.11969635600008],
              [126.11133873800009, 35.13328685100004],
              [126.12940514400009, 35.14288971600007],
              [126.14991295700008, 35.14687734600005],
              [126.16521243600005, 35.14350006700005],
              [126.13477623800009, 35.128973700000074],
              [126.12777754000001, 35.12055084800005],
              [126.12696373800009, 35.110541083000044],
              [126.13135826900009, 35.10024648600006],
              [126.14478600400003, 35.082464911000045],
              [126.13404381600003, 35.07880280200004],
              [126.12281334700003, 35.06981028900009],
              [126.11426842500009, 35.05931224200009],
              [126.11060631600003, 35.05117422100005],
            ],
          ],
          [
            [
              [126.5633032070001, 37.514443293000056],
              [126.56723032800005, 37.511231283000086],
              [126.57114036500002, 37.50634849700003],
              [126.57644010500007, 37.50237048000008],
              [126.58057893500006, 37.49562711800007],
              [126.58306593700001, 37.49038382800006],
              [126.57762572900003, 37.48858484800007],
              [126.56918379000001, 37.483587958000044],
              [126.56576582100001, 37.47996653900009],
              [126.54829135400007, 37.47663722100009],
              [126.54055947100005, 37.47765700500008],
              [126.5299325850001, 37.473683142000084],
              [126.50657213500006, 37.46556815100007],
              [126.49398436600006, 37.45658508300005],
              [126.487012499, 37.44679561400005],
              [126.443412653, 37.420625381000036],
              [126.43359457200006, 37.42240582100004],
              [126.424434238, 37.42156943400005],
              [126.420460596, 37.42235552600005],
              [126.41627803000006, 37.434554709000054],
              [126.4083669470001, 37.43853694300009],
              [126.40472699200006, 37.43536792800006],
              [126.40142731800006, 37.434469826000054],
              [126.40028854700006, 37.436530282000035],
              [126.4019919430001, 37.44005329500004],
              [126.39949220300002, 37.444921322000084],
              [126.39341183300007, 37.44554542000009],
              [126.389386113, 37.44131625300008],
              [126.38320006100003, 37.43745498900006],
              [126.375731449, 37.44013673500007],
              [126.36497292700005, 37.44229130500008],
              [126.37132709600007, 37.44731116400004],
              [126.36911461900002, 37.45273648400007],
              [126.35817777300008, 37.46101202500006],
              [126.35551114100008, 37.46622280000008],
              [126.35934227900009, 37.473629767000034],
              [126.36529165600007, 37.47506439700004],
              [126.37356753400002, 37.471642951000035],
              [126.41888511500008, 37.49686137800006],
              [126.45132674600006, 37.49968200400008],
              [126.47337965000008, 37.499256839000054],
              [126.49370873300006, 37.50778105200004],
              [126.50066081700004, 37.53018525900006],
              [126.51483014900009, 37.53434720000007],
              [126.52637780000009, 37.525091864000046],
              [126.53199303500003, 37.52334219000005],
              [126.53777103000004, 37.520738023000035],
              [126.54346764400009, 37.518866278000075],
              [126.54908287900003, 37.51862213700008],
              [126.55511086400008, 37.51768395600004],
              [126.5633032070001, 37.514443293000056],
            ],
          ],
          [
            [
              [130.90357506600003, 37.54584381700005],
              [130.92066491000003, 37.535589911000045],
              [130.91944420700008, 37.510199286000045],
              [130.90837649800005, 37.48191966400009],
              [130.89673912900003, 37.46312083500004],
              [130.87769616000003, 37.455511786000045],
              [130.85222415500004, 37.45945872600004],
              [130.827484571, 37.47125885600008],
              [130.8110457690001, 37.48700592700004],
              [130.80583743600005, 37.50739166900007],
              [130.81430097700002, 37.52260976800005],
              [130.83228600400003, 37.532131252000056],
              [130.86784915500004, 37.53693268400008],
              [130.8916121750001, 37.54389069200005],
              [130.90357506600003, 37.54584381700005],
            ],
          ],
          [
            [
              [126.35670006600003, 37.69513580900008],
              [126.36915123800009, 37.68732330900008],
              [126.37875410200002, 37.67869700700004],
              [126.38070722700002, 37.669175523000035],
              [126.37012780000009, 37.65835195500006],
              [126.34986412900003, 37.65737539300005],
              [126.28199303500003, 37.699286200000074],
              [126.29078209700003, 37.70563385600008],
              [126.29493248800009, 37.71356842700004],
              [126.30062910200002, 37.73236725500004],
              [126.30372155000009, 37.737209377000056],
              [126.30860436300009, 37.74233633000006],
              [126.31421959700003, 37.746079820000034],
              [126.31999759200005, 37.74721914300005],
              [126.32374108200008, 37.74555084800005],
              [126.32618248800009, 37.74249909100007],
              [126.32764733200008, 37.738267320000034],
              [126.33073978000004, 37.719956773000035],
              [126.33187910200002, 37.716498114000046],
              [126.33668053500003, 37.70990631700005],
              [126.34302819100003, 37.704291083000044],
              [126.35670006600003, 37.69513580900008],
            ],
          ],
          [
            [
              [126.50782311300009, 37.596869208000044],
              [126.50017337300005, 37.59617747600004],
              [126.49415123800009, 37.59837474200009],
              [126.48365319100003, 37.607407945000034],
              [126.47608483200008, 37.61107005400004],
              [126.47071373800009, 37.60956452000005],
              [126.46656334700003, 37.60618724200009],
              [126.46273847700002, 37.60431549700007],
              [126.41016686300009, 37.60203685100004],
              [126.39063561300009, 37.60927969000005],
              [126.37012780000009, 37.63104889500005],
              [126.40088951900009, 37.63743724200009],
              [126.40821373800009, 37.64130280200004],
              [126.41667728000004, 37.65184153900009],
              [126.41553795700008, 37.656683661000045],
              [126.40992272200003, 37.65973541900007],
              [126.40479576900009, 37.66518789300005],
              [126.36915123800009, 37.71906159100007],
              [126.36695397200003, 37.72724030200004],
              [126.37061608200008, 37.737982489000046],
              [126.36963951900009, 37.78534577000005],
              [126.37378991000003, 37.796128648000035],
              [126.38347415500004, 37.79901764500005],
              [126.40707441500001, 37.82070547100005],
              [126.42530358200008, 37.82444896000004],
              [126.44125410200002, 37.815334377000056],
              [126.45630944100003, 37.801214911000045],
              [126.47144616000003, 37.790228583000044],
              [126.50359134200005, 37.777411200000074],
              [126.51636803500003, 37.767238674000055],
              [126.52149498800009, 37.751166083000044],
              [126.52035566500001, 37.74310944200005],
              [126.51514733200008, 37.72955963700008],
              [126.514008009, 37.723537502000056],
              [126.51628665500004, 37.716782945000034],
              [126.52556399800005, 37.70327383000006],
              [126.527679884, 37.69586823100008],
              [126.53093509200005, 37.65989817900004],
              [126.527679884, 37.65151601800005],
              [126.53321373800009, 37.646144924000055],
              [126.53882897200003, 37.63544342700004],
              [126.54200280000009, 37.63104889500005],
              [126.52906334700003, 37.62490469000005],
              [126.51783287900003, 37.60382721600007],
              [126.50782311300009, 37.596869208000044],
            ],
          ],
          [
            [
              [124.73267662900003, 37.980454820000034],
              [124.74366295700008, 37.96967194200005],
              [124.74203535200002, 37.95502350500004],
              [124.72820071700005, 37.94700755400004],
              [124.70875084700003, 37.956284898000035],
              [124.68327884200005, 37.95453522300005],
              [124.67798912900003, 37.95254140800006],
              [124.67839603000004, 37.94204336100006],
              [124.68816165500004, 37.93817780200004],
              [124.69988040500004, 37.93650950700004],
              [124.70533287900003, 37.93268463700008],
              [124.68490644600001, 37.919989325000074],
              [124.64405358200008, 37.92450592700004],
              [124.613617384, 37.94505442900004],
              [124.62403405000009, 37.980454820000034],
              [124.64942467500009, 37.97329336100006],
              [124.70492597700002, 37.98867422100005],
              [124.73267662900003, 37.980454820000034],
            ],
          ],
          [
            [
              [127.30909264400009, 34.02008698100008],
              [127.31495201900009, 34.01577383000006],
              [127.32211347700002, 34.014105536000045],
              [127.32471764400009, 34.01068756700005],
              [127.32349694100003, 34.00576406500005],
              [127.30933678500003, 34.01146067900004],
              [127.29566491000003, 34.014105536000045],
              [127.29322350400003, 34.017238674000055],
              [127.28980553500003, 34.02407461100006],
              [127.28760826900009, 34.032416083000044],
              [127.28386478000004, 34.03461334800005],
              [127.28077233200008, 34.03778717700004],
              [127.27833092500009, 34.044623114000046],
              [127.27979576900009, 34.04865143400008],
              [127.27930748800009, 34.05329010600008],
              [127.28003991000003, 34.05744049700007],
              [127.28321373800009, 34.058294989000046],
              [127.28687584700003, 34.05727773600006],
              [127.29151451900009, 34.05849844000005],
              [127.29420006600003, 34.06110260600008],
              [127.29566491000003, 34.06146881700005],
              [127.29810631600003, 34.05719635600008],
              [127.29468834700003, 34.04791901200008],
              [127.29639733200008, 34.03758372600004],
              [127.30909264400009, 34.02008698100008],
            ],
          ],
          [
            [
              [127.53191165500004, 34.45058828300006],
              [127.53638756600003, 34.440659898000035],
              [127.53638756600003, 34.434759833000044],
              [127.52881920700008, 34.42804596600007],
              [127.51059004000001, 34.41828034100007],
              [127.49463951900009, 34.41425202000005],
              [127.48894290500004, 34.41693756700005],
              [127.48853600400003, 34.425482489000046],
              [127.48178144600001, 34.431341864000046],
              [127.47169030000009, 34.434027411000045],
              [127.46705162900003, 34.43919505400004],
              [127.46973717500009, 34.44318268400008],
              [127.45883222700002, 34.448919989000046],
              [127.45215905000009, 34.45302969000005],
              [127.45573978000004, 34.46051666900007],
              [127.45508873800009, 34.466131903000075],
              [127.45337975400003, 34.47060781500005],
              [127.45826256600003, 34.47288646000004],
              [127.46534264400009, 34.470363674000055],
              [127.47282962300005, 34.466782945000034],
              [127.48682701900009, 34.46385325700004],
              [127.48707116000003, 34.46124909100007],
              [127.49170983200008, 34.462225653000075],
              [127.50074303500003, 34.469631252000056],
              [127.50993899800005, 34.470038153000075],
              [127.53191165500004, 34.45058828300006],
            ],
          ],
          [
            [
              [127.78296959700003, 34.50698476800005],
              [127.78956139400009, 34.503973700000074],
              [127.79395592500009, 34.49823639500005],
              [127.79175866000003, 34.49201080900008],
              [127.77930748800009, 34.48847077000005],
              [127.77116946700005, 34.48818594000005],
              [127.76905358200008, 34.489935614000046],
              [127.76579837300005, 34.49396393400008],
              [127.75652103000004, 34.49823639500005],
              [127.74195397200003, 34.50226471600007],
              [127.73218834700003, 34.50849030200004],
              [127.72771243600005, 34.51699453300006],
              [127.72282962300005, 34.52317942900004],
              [127.71461022200003, 34.52684153900009],
              [127.70753014400009, 34.53388092700004],
              [127.71290123800009, 34.54242584800005],
              [127.72974694100003, 34.54905833500004],
              [127.74805748800009, 34.55109284100007],
              [127.76107832100001, 34.54311758000006],
              [127.77621504000001, 34.518784898000035],
              [127.77442467500009, 34.511786200000074],
              [127.77491295700008, 34.50820547100005],
              [127.78296959700003, 34.50698476800005],
            ],
          ],
          [
            [
              [126.10010826900009, 34.59674713700008],
              [126.10238691500001, 34.59487539300005],
              [126.10425866000003, 34.58978913000004],
              [126.10336347700002, 34.579413153000075],
              [126.10027103000004, 34.56830475500004],
              [126.09937584700003, 34.558661200000074],
              [126.09376061300009, 34.55365631700005],
              [126.08570397200003, 34.54873281500005],
              [126.07732181100005, 34.542181708000044],
              [126.05762780000009, 34.532538153000075],
              [126.04672285200002, 34.53115469000005],
              [126.03516686300009, 34.53392161700009],
              [126.031586134, 34.539048570000034],
              [126.03736412900003, 34.540716864000046],
              [126.04346764400009, 34.54096100500004],
              [126.04851321700005, 34.54515208500004],
              [126.05445397200003, 34.548895575000074],
              [126.05347741000003, 34.55231354400007],
              [126.03126061300009, 34.55638255400004],
              [126.03663170700008, 34.56167226800005],
              [126.05046634200005, 34.56342194200005],
              [126.06495201900009, 34.563788153000075],
              [126.07634524800005, 34.57099030200004],
              [126.08130944100003, 34.58075592700004],
              [126.07642662900003, 34.59076569200005],
              [126.06641686300009, 34.60398997600004],
              [126.06006920700008, 34.620794989000046],
              [126.06763756600003, 34.62547435100004],
              [126.07984459700003, 34.61737702000005],
              [126.08708743600005, 34.61115143400008],
              [126.09937584700003, 34.605454820000034],
              [126.10010826900009, 34.59674713700008],
            ],
          ],
          [
            [
              [126.03809655000009, 34.56948476800005],
              [126.02857506600003, 34.56586334800005],
              [126.02051842500009, 34.57143789300005],
              [126.01661217500009, 34.60614655200004],
              [126.02019290500004, 34.625433661000045],
              [126.02857506600003, 34.63422272300005],
              [126.041351759, 34.61115143400008],
              [126.05201256600003, 34.59833405200004],
              [126.06039472700002, 34.58429596600007],
              [126.05762780000009, 34.57257721600007],
              [126.04859459700003, 34.57005442900004],
              [126.03809655000009, 34.56948476800005],
            ],
          ],
          [
            [
              [125.44581139400009, 34.68846263200004],
              [125.45728600400003, 34.69090403900009],
              [125.45923912900003, 34.686835028000075],
              [125.45045006600003, 34.679673570000034],
              [125.44581139400009, 34.675116278000075],
              [125.44320722700002, 34.66941966400009],
              [125.42741946700005, 34.65424225500004],
              [125.42432701900009, 34.64720286700009],
              [125.41773522200003, 34.63812897300005],
              [125.41260826900009, 34.63231028900009],
              [125.408539259, 34.628607489000046],
              [125.398773634, 34.63198476800005],
              [125.39234459700003, 34.64630768400008],
              [125.39340254000001, 34.65965403900009],
              [125.39893639400009, 34.67182038000004],
              [125.40560957100001, 34.68256256700005],
              [125.41285241000003, 34.69196198100008],
              [125.42123457100001, 34.69708893400008],
              [125.42945397200003, 34.698431708000044],
              [125.433929884, 34.69554271000004],
              [125.43726647200003, 34.68829987200007],
              [125.44581139400009, 34.68846263200004],
            ],
          ],
          [
            [
              [126.17408287900003, 34.73281484600005],
              [126.17750084700003, 34.72406647300005],
              [126.17790774800005, 34.71336497600004],
              [126.17212975400003, 34.70380280200004],
              [126.15943444100003, 34.702785549000055],
              [126.14771569100003, 34.71234772300005],
              [126.13843834700003, 34.72345612200007],
              [126.12769616000003, 34.72357819200005],
              [126.12232506600003, 34.719631252000056],
              [126.11882571700005, 34.71824778900009],
              [126.11133873800009, 34.71771881700005],
              [126.10425866000003, 34.721991278000075],
              [126.10254967500009, 34.730536200000074],
              [126.09343509200005, 34.74428945500006],
              [126.07374108200008, 34.761379299000055],
              [126.06959069100003, 34.76968008000006],
              [126.07927493600005, 34.767564195000034],
              [126.08716881600003, 34.76752350500004],
              [126.09457441500001, 34.77065664300005],
              [126.10523522200003, 34.771551825000074],
              [126.11784915500004, 34.769964911000045],
              [126.12720787900003, 34.76654694200005],
              [126.133148634, 34.76121653900009],
              [126.14193769600001, 34.75755442900004],
              [126.15381920700008, 34.75690338700008],
              [126.16358483200008, 34.75495026200008],
              [126.170258009, 34.74994538000004],
              [126.17383873800009, 34.74445221600007],
              [126.17310631600003, 34.739447333000044],
              [126.17408287900003, 34.73281484600005],
            ],
          ],
          [
            [
              [126.16871178500003, 34.792303778000075],
              [126.16553795700008, 34.78969961100006],
              [126.16211998800009, 34.783270575000074],
              [126.16423587300005, 34.76976146000004],
              [126.15821373800009, 34.76447174700007],
              [126.14625084700003, 34.76186758000006],
              [126.13461347700002, 34.76732005400004],
              [126.12159264400009, 34.77651601800005],
              [126.10482832100001, 34.78164297100005],
              [126.09253991000003, 34.78758372600004],
              [126.10238691500001, 34.79437897300005],
              [126.127289259, 34.797756252000056],
              [126.14185631600003, 34.80296458500004],
              [126.14942467500009, 34.80809153900009],
              [126.15902754000001, 34.80459219000005],
              [126.16627037900003, 34.79645416900007],
              [126.16871178500003, 34.792303778000075],
            ],
          ],
          [
            [
              [126.07943769600001, 34.82265859600005],
              [126.07105553500003, 34.83218008000006],
              [126.06413821700005, 34.84259674700007],
              [126.06714928500003, 34.85053131700005],
              [126.08179772200003, 34.85659414300005],
              [126.09376061300009, 34.85761139500005],
              [126.10328209700003, 34.853176174000055],
              [126.11255944100003, 34.85342031500005],
              [126.11524498800009, 34.859442450000074],
              [126.11329186300009, 34.871161200000074],
              [126.12281334700003, 34.87881094000005],
              [126.13591556100005, 34.878607489000046],
              [126.14226321700005, 34.87913646000004],
              [126.14722741000003, 34.87685781500005],
              [126.15202884200005, 34.871161200000074],
              [126.15308678500003, 34.86497630400004],
              [126.13965905000009, 34.85789622600004],
              [126.14454186300009, 34.84235260600008],
              [126.14210045700008, 34.832912502000056],
              [126.13502037900003, 34.829291083000044],
              [126.12517337300005, 34.82965729400007],
              [126.11890709700003, 34.82379791900007],
              [126.11915123800009, 34.81264883000006],
              [126.11589603000004, 34.80312734600005],
              [126.10523522200003, 34.798163153000075],
              [126.09620201900009, 34.79877350500004],
              [126.09400475400003, 34.804673570000034],
              [126.09441165500004, 34.808661200000074],
              [126.07943769600001, 34.82265859600005],
            ],
          ],
          [
            [
              [128.0727645190001, 34.84511953300006],
              [128.07683353000004, 34.84247467700004],
              [128.082367384, 34.835598049000055],
              [128.07178795700008, 34.83340078300006],
              [128.02654056100005, 34.84320709800005],
              [128.00180097700002, 34.83665599200009],
              [127.98731530000009, 34.83808014500005],
              [127.97242272200003, 34.84552643400008],
              [127.96363366000003, 34.85976797100005],
              [127.97046959700003, 34.87518952000005],
              [127.98414147200003, 34.88971588700008],
              [127.99284915500004, 34.90338776200008],
              [128.0019637380001, 34.91303131700005],
              [128.01783287900003, 34.91657135600008],
              [128.02295983200008, 34.905503648000035],
              [128.015961134, 34.88934967700004],
              [128.01246178500003, 34.87832265800006],
              [128.01343834700003, 34.869126695000034],
              [128.01872806100005, 34.86615631700005],
              [128.02458743600005, 34.877020575000074],
              [128.03630618600005, 34.892279364000046],
              [128.0459090500001, 34.89362213700008],
              [128.0488387380001, 34.88662344000005],
              [128.05396569100003, 34.88263580900008],
              [128.058929884, 34.88035716400009],
              [128.06120853000004, 34.868353583000044],
              [128.0669051440001, 34.85175202000005],
              [128.0727645190001, 34.84511953300006],
            ],
          ],
          [
            [
              [126.246429884, 34.91624583500004],
              [126.23755944100003, 34.91307200700004],
              [126.22535241000003, 34.913397528000075],
              [126.22038821700005, 34.92243073100008],
              [126.22242272200003, 34.93195221600007],
              [126.23023522200003, 34.93545156500005],
              [126.24732506600003, 34.93545156500005],
              [126.25318444100003, 34.93349844000005],
              [126.25342858200008, 34.92918528900009],
              [126.25017337300005, 34.918850002000056],
              [126.246429884, 34.91624583500004],
            ],
          ],
          [
            [
              [126.17839603000004, 35.048488674000055],
              [126.18091881600003, 35.04401276200008],
              [126.18189537900003, 35.03888580900008],
              [126.18165123800009, 35.02912018400008],
              [126.17741946700005, 35.02594635600008],
              [126.17237389400009, 35.02362702000005],
              [126.16700280000009, 35.02529531500005],
              [126.15805097700002, 35.03343333500004],
              [126.15398196700005, 35.03571198100008],
              [126.14861087300005, 35.03351471600007],
              [126.14380944100003, 35.03392161700009],
              [126.14234459700003, 35.038275458000044],
              [126.13851972700002, 35.03986237200007],
              [126.13355553500003, 35.03974030200004],
              [126.13217207100001, 35.04193756700005],
              [126.13941491000003, 35.04645416900007],
              [126.13656660200002, 35.047756252000056],
              [126.13209069100003, 35.04710521000004],
              [126.12777754000001, 35.048163153000075],
              [126.12964928500003, 35.05267975500004],
              [126.13738040500004, 35.05687083500004],
              [126.14380944100003, 35.05768463700008],
              [126.15251712300005, 35.054388739000046],
              [126.16529381600003, 35.05524323100008],
              [126.174164259, 35.053168036000045],
              [126.17839603000004, 35.048488674000055],
            ],
          ],
          [
            [
              [128.8427840500001, 35.02187734600005],
              [128.8383895190001, 35.001206773000035],
              [128.83179772200003, 34.993801174000055],
              [128.8266707690001, 34.99237702000005],
              [128.8242293630001, 34.99673086100006],
              [128.8193465500001, 35.01422760600008],
              [128.81177819100003, 35.020738023000035],
              [128.8090926440001, 35.02586497600004],
              [128.81031334700003, 35.03294505400004],
              [128.80689537900003, 35.04124583500004],
              [128.801605665, 35.04913971600007],
              [128.80437259200005, 35.056341864000046],
              [128.8149520190001, 35.06126536700009],
              [128.82642662900003, 35.06224192900004],
              [128.8364363940001, 35.059800523000035],
              [128.84327233200008, 35.04718659100007],
              [128.8427840500001, 35.02187734600005],
            ],
          ],
          [
            [
              [126.25806725400003, 35.57062409100007],
              [126.25367272200003, 35.57436758000006],
              [126.25049889400009, 35.580959377000056],
              [126.25245201900009, 35.58730703300006],
              [126.26295006600003, 35.591782945000034],
              [126.26148522200003, 35.593410549000055],
              [126.25652103000004, 35.59601471600007],
              [126.25896243600005, 35.59837474200009],
              [126.26449629000001, 35.600897528000075],
              [126.26823978000004, 35.60521067900004],
              [126.27426191500001, 35.60602448100008],
              [126.27784264400009, 35.60736725500004],
              [126.27613366000003, 35.61286041900007],
              [126.28044681100005, 35.61269765800006],
              [126.29175866000003, 35.611029364000046],
              [126.29932701900009, 35.61603424700007],
              [126.30298912900003, 35.61933014500005],
              [126.30730228000004, 35.61664459800005],
              [126.30941816500001, 35.610663153000075],
              [126.30567467500009, 35.603216864000046],
              [126.28728274800005, 35.590277411000045],
              [126.27491295700008, 35.57904694200005],
              [126.26710045700008, 35.57412344000005],
              [126.26384524800005, 35.57168203300006],
              [126.25806725400003, 35.57062409100007],
            ],
          ],
          [
            [
              [126.09986412900003, 37.22801341400009],
              [126.09278405000009, 37.22483958500004],
              [126.08863366000003, 37.22597890800006],
              [126.08871504000001, 37.22955963700008],
              [126.09180748800009, 37.24591705900008],
              [126.09742272200003, 37.259426174000055],
              [126.10474694100003, 37.26752350500004],
              [126.11280358200008, 37.26308828300006],
              [126.11980228000004, 37.253607489000046],
              [126.12696373800009, 37.248928127000056],
              [126.15162194100003, 37.23859284100007],
              [126.15919030000009, 37.23191966400009],
              [126.15503991000003, 37.22573476800005],
              [126.14234459700003, 37.21539948100008],
              [126.13331139400009, 37.21234772300005],
              [126.12159264400009, 37.210923570000034],
              [126.111664259, 37.214544989000046],
              [126.10515384200005, 37.22357819200005],
              [126.10254967500009, 37.22866445500006],
              [126.09986412900003, 37.22801341400009],
            ],
          ],
          [
            [
              [126.48406009200005, 37.278998114000046],
              [126.49439537900003, 37.273504950000074],
              [126.49830162900003, 37.261419989000046],
              [126.49390709700003, 37.25726959800005],
              [126.48316491000003, 37.254339911000045],
              [126.47901451900009, 37.247748114000046],
              [126.47820071700005, 37.24160390800006],
              [126.46949303500003, 37.23346588700008],
              [126.45818118600005, 37.23126862200007],
              [126.45045006600003, 37.23582591400009],
              [126.44223066500001, 37.23517487200007],
              [126.43572024800005, 37.23843008000006],
              [126.43344160200002, 37.25104401200008],
              [126.43531334700003, 37.26398346600007],
              [126.44353274800005, 37.273098049000055],
              [126.46119225400003, 37.280585028000075],
              [126.48406009200005, 37.278998114000046],
            ],
          ],
          [
            [
              [126.61394290500004, 37.255194403000075],
              [126.61638431100005, 37.25055573100008],
              [126.61882571700005, 37.24201080900008],
              [126.61353600400003, 37.23281484600005],
              [126.56251061300009, 37.200384833000044],
              [126.53931725400003, 37.19806549700007],
              [126.53956139400009, 37.203111070000034],
              [126.55046634200005, 37.214911200000074],
              [126.55193118600005, 37.22166575700004],
              [126.54737389400009, 37.22748444200005],
              [126.56039472700002, 37.23932526200008],
              [126.56080162900003, 37.251288153000075],
              [126.55543053500003, 37.266058661000045],
              [126.54802493600005, 37.27631256700005],
              [126.54078209700003, 37.28294505400004],
              [126.54297936300009, 37.28497955900008],
              [126.55941816500001, 37.278631903000075],
              [126.57349694100003, 37.28847890800006],
              [126.57667076900009, 37.28766510600008],
              [126.57374108200008, 37.278998114000046],
              [126.57789147200003, 37.271144924000055],
              [126.58961022200003, 37.26577383000006],
              [126.60865319100003, 37.259426174000055],
              [126.61394290500004, 37.255194403000075],
            ],
          ],
          [
            [
              [125.68824303500003, 37.67926666900007],
              [125.69922936300009, 37.67812734600005],
              [125.70622806100005, 37.672308661000045],
              [125.70313561300009, 37.661444403000075],
              [125.69361412900003, 37.653957424000055],
              [125.687836134, 37.65176015800006],
              [125.68458092500009, 37.65729401200008],
              [125.67920983200008, 37.66966380400004],
              [125.68043053500003, 37.67829010600008],
              [125.68824303500003, 37.67926666900007],
            ],
          ],
          [
            [
              [124.71648196700005, 37.846909898000035],
              [124.72445722700002, 37.84365469000005],
              [124.72584069100003, 37.83738841400009],
              [124.72136478000004, 37.82843659100007],
              [124.71827233200008, 37.81818268400008],
              [124.71420332100001, 37.80955638200004],
              [124.70679772200003, 37.806341864000046],
              [124.69898522200003, 37.80687083500004],
              [124.69239342500009, 37.80499909100007],
              [124.68726647200003, 37.800767320000034],
              [124.68458092500009, 37.799994208000044],
              [124.68458092500009, 37.80263906500005],
              [124.68474368600005, 37.803941148000035],
              [124.68148847700002, 37.80882396000004],
              [124.67351321700005, 37.81704336100006],
              [124.67652428500003, 37.82489655200004],
              [124.69336998800009, 37.83551666900007],
              [124.70411217500009, 37.84438711100006],
              [124.70915774800005, 37.84756094000005],
              [124.71648196700005, 37.846909898000035],
            ],
          ],
          [
            [
              [125.12769616000003, 34.04857005400004],
              [125.12281334700003, 34.05117422100005],
              [125.10328209700003, 34.066066799000055],
              [125.092133009, 34.07176341400009],
              [125.08969160200002, 34.07953522300005],
              [125.09457441500001, 34.09007396000004],
              [125.10222415500004, 34.09593333500004],
              [125.11329186300009, 34.09284088700008],
              [125.12208092500009, 34.08380768400008],
              [125.13640384200005, 34.05927155200004],
              [125.13738040500004, 34.05133698100008],
              [125.13428795700008, 34.046861070000034],
              [125.12989342500009, 34.04755280200004],
              [125.12769616000003, 34.04857005400004],
            ],
          ],
          [
            [
              [126.59896894600001, 34.16864655200004],
              [126.60767662900003, 34.16559479400007],
              [126.61597741000003, 34.15696849200009],
              [126.61353600400003, 34.15253327000005],
              [126.60938561300009, 34.15566640800006],
              [126.605804884, 34.15615469000005],
              [126.60401451900009, 34.15224844000005],
              [126.60027103000004, 34.15346914300005],
              [126.59115644600001, 34.15761953300006],
              [126.58179772200003, 34.157416083000044],
              [126.57642662900003, 34.15306224200009],
              [126.57300866000003, 34.147691148000035],
              [126.56185957100001, 34.14142487200007],
              [126.55193118600005, 34.133978583000044],
              [126.53687584700003, 34.12645091400009],
              [126.51775149800005, 34.12714264500005],
              [126.50709069100003, 34.13886139500005],
              [126.50635826900009, 34.153998114000046],
              [126.51514733200008, 34.168850002000056],
              [126.53288821700005, 34.17910390800006],
              [126.54810631600003, 34.17910390800006],
              [126.56788170700008, 34.16864655200004],
              [126.57374108200008, 34.168036200000074],
              [126.58204186300009, 34.17015208500004],
              [126.59327233200008, 34.169989325000074],
              [126.59896894600001, 34.16864655200004],
            ],
          ],
          [
            [
              [126.67204837300005, 34.15326569200005],
              [126.67603600400003, 34.15143463700008],
              [126.67945397200003, 34.146551825000074],
              [126.67628014400009, 34.14354075700004],
              [126.67188561300009, 34.14297109600005],
              [126.67042076900009, 34.13703034100007],
              [126.67042076900009, 34.126939195000034],
              [126.66537519600001, 34.11908600500004],
              [126.65552819100003, 34.116848049000055],
              [126.65040123800009, 34.11937083500004],
              [126.64861087300005, 34.12400950700004],
              [126.64380944100003, 34.12718333500004],
              [126.63868248800009, 34.128119208000044],
              [126.63648522200003, 34.14154694200005],
              [126.64283287900003, 34.16461823100008],
              [126.64503014400009, 34.17747630400004],
              [126.63843834700003, 34.18256256700005],
              [126.63648522200003, 34.187160549000055],
              [126.64478600400003, 34.19375234600005],
              [126.64527428500003, 34.19717031500005],
              [126.65381920700008, 34.19708893400008],
              [126.67074629000001, 34.189886786000045],
              [126.67310631600003, 34.180121161000045],
              [126.66358483200008, 34.17332591400009],
              [126.66187584700003, 34.165716864000046],
              [126.67204837300005, 34.15326569200005],
            ],
          ],
          [
            [
              [126.90935306100005, 34.197699286000045],
              [126.91895592500009, 34.19049713700008],
              [126.92497806100005, 34.184881903000075],
              [126.92237389400009, 34.17234935100004],
              [126.91993248800009, 34.16697825700004],
              [126.91358483200008, 34.15766022300005],
              [126.90186608200008, 34.152411200000074],
              [126.88697350400003, 34.15135325700004],
              [126.87598717500009, 34.15607330900008],
              [126.86695397200003, 34.16282786700009],
              [126.86036217500009, 34.162176825000074],
              [126.85694420700008, 34.15717194200005],
              [126.85320071700005, 34.15900299700007],
              [126.84913170700008, 34.17438385600008],
              [126.85531660200002, 34.184759833000044],
              [126.85694420700008, 34.19428131700005],
              [126.86085045700008, 34.20184967700004],
              [126.86793053500003, 34.207464911000045],
              [126.88217207100001, 34.21328359600005],
              [126.89926191500001, 34.20966217700004],
              [126.90935306100005, 34.197699286000045],
            ],
          ],
          [
            [
              [126.61215254000001, 34.21816640800006],
              [126.61622155000009, 34.21328359600005],
              [126.61703535200002, 34.20453522300005],
              [126.61011803500003, 34.19969310100004],
              [126.60661868600005, 34.18829987200007],
              [126.59205162900003, 34.18764883000006],
              [126.58399498800009, 34.18626536700009],
              [126.58887780000009, 34.17910390800006],
              [126.58383222700002, 34.17560455900008],
              [126.56861412900003, 34.179022528000075],
              [126.56072024800005, 34.18512604400007],
              [126.55876712300005, 34.189154364000046],
              [126.55453535200002, 34.19041575700004],
              [126.54981530000009, 34.19122955900008],
              [126.54883873800009, 34.194566148000035],
              [126.55396569100003, 34.20652903900009],
              [126.55689537900003, 34.211004950000074],
              [126.55730228000004, 34.214056708000044],
              [126.55534915500004, 34.216457424000055],
              [126.55616295700008, 34.21865469000005],
              [126.55982506600003, 34.22016022300005],
              [126.56218509200005, 34.222316799000055],
              [126.56153405000009, 34.22516510600008],
              [126.55640709700003, 34.232123114000046],
              [126.55974368600005, 34.23452383000006],
              [126.56763756600003, 34.232407945000034],
              [126.57536868600005, 34.228949286000045],
              [126.59620201900009, 34.22601959800005],
              [126.60694420700008, 34.22138092700004],
              [126.61215254000001, 34.21816640800006],
            ],
          ],
          [
            [
              [126.08871504000001, 34.307928778000075],
              [126.08773847700002, 34.29682038000004],
              [126.08936608200008, 34.28961823100008],
              [126.08464603000004, 34.28388092700004],
              [126.07496178500003, 34.282863674000055],
              [126.06934655000009, 34.278998114000046],
              [126.06495201900009, 34.28070709800005],
              [126.06080162900003, 34.28607819200005],
              [126.05738366000003, 34.28595612200007],
              [126.05567467500009, 34.28099192900004],
              [126.04932701900009, 34.28021881700005],
              [126.02865644600001, 34.28733958500004],
              [126.02165774800005, 34.29564036700009],
              [126.02100670700008, 34.30109284100007],
              [126.02523847700002, 34.305853583000044],
              [126.025726759, 34.31077708500004],
              [126.03321373800009, 34.314886786000045],
              [126.06763756600003, 34.30890534100007],
              [126.08204186300009, 34.31073639500005],
              [126.08871504000001, 34.307928778000075],
            ],
          ],
          [
            [
              [126.853851759, 34.30853913000004],
              [126.84961998800009, 34.30491771000004],
              [126.84058678500003, 34.30337148600006],
              [126.83570397200003, 34.30914948100008],
              [126.83366946700005, 34.316839911000045],
              [126.82829837300005, 34.32290273600006],
              [126.82056725400003, 34.32562897300005],
              [126.81031334700003, 34.32436758000006],
              [126.79835045700008, 34.32086823100008],
              [126.78874759200005, 34.32094961100006],
              [126.78492272200003, 34.32257721600007],
              [126.78109785200002, 34.324652411000045],
              [126.75896243600005, 34.33274974200009],
              [126.75757897200003, 34.33612702000005],
              [126.76783287900003, 34.337225653000075],
              [126.77784264400009, 34.33966705900008],
              [126.78223717500009, 34.341782945000034],
              [126.78589928500003, 34.34324778900009],
              [126.79379316500001, 34.342230536000045],
              [126.80290774800005, 34.33869049700007],
              [126.81397545700008, 34.34251536700009],
              [126.82748457100001, 34.351629950000074],
              [126.83765709700003, 34.35374583500004],
              [126.84351647200003, 34.350043036000045],
              [126.85075931100005, 34.34845612200007],
              [126.85499108200008, 34.34870026200008],
              [126.85922285200002, 34.34935130400004],
              [126.87037194100003, 34.34837474200009],
              [126.88453209700003, 34.34552643400008],
              [126.89332116000003, 34.34125397300005],
              [126.89136803500003, 34.33392975500004],
              [126.88559004000001, 34.32831452000005],
              [126.88404381600003, 34.32489655200004],
              [126.88306725400003, 34.31793854400007],
              [126.87680097700002, 34.31224192900004],
              [126.86817467500009, 34.31362539300005],
              [126.85889733200008, 34.312201239000046],
              [126.853851759, 34.30853913000004],
            ],
          ],
          [
            [
              [127.09156334700003, 34.344916083000044],
              [127.09498131600003, 34.34247467700004],
              [127.09693444100003, 34.33779531500005],
              [127.09083092500009, 34.33673737200007],
              [127.082367384, 34.340277411000045],
              [127.07243899800005, 34.34210846600007],
              [127.06527754000001, 34.33978913000004],
              [127.06788170700008, 34.33706289300005],
              [127.07398522200003, 34.33417389500005],
              [127.066742384, 34.328192450000074],
              [127.04908287900003, 34.31671784100007],
              [127.03882897200003, 34.31289297100005],
              [127.03785241000003, 34.32172272300005],
              [127.04281660200002, 34.32794830900008],
              [127.049164259, 34.33144765800006],
              [127.04558353000004, 34.33543528900009],
              [127.02369225400003, 34.339178778000075],
              [127.02662194100003, 34.34316640800006],
              [127.02426191500001, 34.34821198100008],
              [127.01758873800009, 34.351548570000034],
              [127.00082441500001, 34.352850653000075],
              [126.99431399800005, 34.354681708000044],
              [126.99146569100003, 34.35626862200007],
              [126.99382571700005, 34.35814036700009],
              [127.00123131600003, 34.359361070000034],
              [127.00700931100005, 34.362616278000075],
              [127.01628665500004, 34.37189362200007],
              [127.02621504000001, 34.37872955900008],
              [127.02540123800009, 34.38133372600004],
              [127.02857506600003, 34.38043854400007],
              [127.03565514400009, 34.37474192900004],
              [127.04216556100005, 34.36668528900009],
              [127.04590905000009, 34.35765208500004],
              [127.05372155000009, 34.354803778000075],
              [127.06739342500009, 34.35838450700004],
              [127.07740319100003, 34.35932038000004],
              [127.08204186300009, 34.35594310100004],
              [127.08545983200008, 34.35138580900008],
              [127.09156334700003, 34.344916083000044],
            ],
          ],
          [
            [
              [126.76392662900003, 34.30923086100006],
              [126.76587975400003, 34.30304596600007],
              [126.77149498800009, 34.291896877000056],
              [126.76807701900009, 34.28921133000006],
              [126.76319420700008, 34.28978099200009],
              [126.75831139400009, 34.29092031500005],
              [126.74935957100001, 34.294134833000044],
              [126.74170983200008, 34.29824453300006],
              [126.73747806100005, 34.29755280200004],
              [126.73650149800005, 34.29169342700004],
              [126.73170006600003, 34.28937409100007],
              [126.72291100400003, 34.29271067900004],
              [126.70777428500003, 34.29564036700009],
              [126.68897545700008, 34.30109284100007],
              [126.68881269600001, 34.30756256700005],
              [126.69809004000001, 34.31342194200005],
              [126.695648634, 34.32078685100004],
              [126.68702233200008, 34.322699286000045],
              [126.67660566500001, 34.32046133000006],
              [126.66358483200008, 34.323431708000044],
              [126.65186608200008, 34.329779364000046],
              [126.644867384, 34.337103583000044],
              [126.64193769600001, 34.34796784100007],
              [126.640961134, 34.36033763200004],
              [126.64177493600005, 34.37295156500005],
              [126.64576256600003, 34.38556549700007],
              [126.65365644600001, 34.39520905200004],
              [126.664398634, 34.39948151200008],
              [126.67017662900003, 34.40058014500005],
              [126.68775475400003, 34.402044989000046],
              [126.69922936300009, 34.39891185100004],
              [126.70997155000009, 34.39288971600007],
              [126.72185306100005, 34.381293036000045],
              [126.73113040500004, 34.36200592700004],
              [126.73389733200008, 34.34617747600004],
              [126.73707116000003, 34.33885325700004],
              [126.742523634, 34.33274974200009],
              [126.74561608200008, 34.324204820000034],
              [126.76392662900003, 34.30923086100006],
            ],
          ],
          [
            [
              [126.76246178500003, 34.38296133000006],
              [126.75757897200003, 34.383246161000045],
              [126.75318444100003, 34.38694896000004],
              [126.75684655000009, 34.39288971600007],
              [126.76148522200003, 34.39874909100007],
              [126.76840254000001, 34.411363023000035],
              [126.78248131600003, 34.42674388200004],
              [126.80225670700008, 34.43577708500004],
              [126.82300866000003, 34.43984609600005],
              [126.83545983200008, 34.43805573100008],
              [126.840179884, 34.432074286000045],
              [126.84099368600005, 34.425482489000046],
              [126.83578535200002, 34.42104726800005],
              [126.83659915500004, 34.41864655200004],
              [126.84587649800005, 34.41396719000005],
              [126.85352623800009, 34.40688711100006],
              [126.86019941500001, 34.398871161000045],
              [126.86109459700003, 34.39276764500005],
              [126.85377037900003, 34.39175039300005],
              [126.83326256600003, 34.39695872600004],
              [126.82471764400009, 34.39520905200004],
              [126.81967207100001, 34.38906484600005],
              [126.793304884, 34.378892320000034],
              [126.78402754000001, 34.36859772300005],
              [126.78109785200002, 34.357855536000045],
              [126.775726759, 34.354722398000035],
              [126.76921634200005, 34.360988674000055],
              [126.76937910200002, 34.37132396000004],
              [126.76726321700005, 34.38003164300005],
              [126.76246178500003, 34.38296133000006],
            ],
          ],
          [
            [
              [128.29460696700005, 34.639553127000056],
              [128.29712975400003, 34.63731517100007],
              [128.29566491000003, 34.63198476800005],
              [128.286062045, 34.62221914300005],
              [128.2817488940001, 34.61985911700009],
              [128.2753198580001, 34.61908600500004],
              [128.26587975400003, 34.62083567900004],
              [128.25806725400003, 34.61989980700008],
              [128.247406446, 34.61554596600007],
              [128.2421981130001, 34.61151764500005],
              [128.2362573580001, 34.61045970300006],
              [128.235280795, 34.61420319200005],
              [128.2387801440001, 34.62059153900009],
              [128.23780358200008, 34.62575918200008],
              [128.2334090500001, 34.62938060100004],
              [128.22966556100005, 34.630072333000044],
              [128.22527103000004, 34.63283926000008],
              [128.22567793100006, 34.63784414300005],
              [128.22836347700002, 34.64240143400008],
              [128.22877037900003, 34.64785390800006],
              [128.232758009, 34.65102773600006],
              [128.23951256600003, 34.652411200000074],
              [128.27116946700005, 34.63849518400008],
              [128.27125084700003, 34.63231028900009],
              [128.2758081390001, 34.63190338700008],
              [128.29460696700005, 34.639553127000056],
            ],
          ],
          [
            [
              [128.385829703, 34.82012484100005],
              [128.39536618600005, 34.82334816200006],
              [128.41076357000009, 34.826521822000075],
              [128.4282260330001, 34.82744842200009],
              [128.43799723000006, 34.81957166400008],
              [128.44063484600008, 34.806735409000055],
              [128.43533376200003, 34.79870949600007],
              [128.4389764760001, 34.793902942000045],
              [128.4346356110001, 34.78788231100009],
              [128.42457204700008, 34.79122027400007],
              [128.420597445, 34.78923582600004],
              [128.42088569200007, 34.78672006900007],
              [128.4291006840001, 34.78539672000005],
              [128.4373320310001, 34.77980895600007],
              [128.43329431000006, 34.77378415800007],
              [128.423082744, 34.76325254900007],
              [128.40653355100005, 34.76309813600005],
              [128.39928054900008, 34.77071573100005],
              [128.39536287600004, 34.77854018900007],
              [128.3869898480001, 34.77880380000005],
              [128.38895679200004, 34.785362821000035],
              [128.38620598800003, 34.79191741400007],
              [128.3733046430001, 34.79349119800008],
              [128.368702331, 34.79653684500005],
              [128.37827168600006, 34.80278985800004],
              [128.38008923000007, 34.81040434100004],
              [128.37041622000004, 34.816686261000086],
              [128.35239543, 34.82180417700005],
              [128.34097425000004, 34.81884407400008],
              [128.334192486, 34.819132496000066],
              [128.33204884400004, 34.82570246700004],
              [128.3400934, 34.83297286200008],
              [128.35183084900007, 34.83542157800008],
              [128.36724685800004, 34.83027402200008],
              [128.37901285600003, 34.822870451000085],
              [128.385829703, 34.82012484100005],
            ],
          ],
          [
            [
              [128.23991946700005, 34.83616771000004],
              [128.2548934250001, 34.82241445500006],
              [128.26050866000003, 34.81464264500005],
              [128.25652103000004, 34.80927155200004],
              [128.24577884200005, 34.80927155200004],
              [128.2407332690001, 34.807074286000045],
              [128.24146569100003, 34.799994208000044],
              [128.23845462300005, 34.796942450000074],
              [128.2290145190001, 34.79913971600007],
              [128.2231551440001, 34.80149974200009],
              [128.21216881600003, 34.807806708000044],
              [128.20582116000003, 34.815619208000044],
              [128.2070418630001, 34.82103099200009],
              [128.2138778000001, 34.83022695500006],
              [128.22730553500003, 34.83856842700004],
              [128.23991946700005, 34.83616771000004],
            ],
          ],
          [
            [
              [126.34066816500001, 34.86408112200007],
              [126.35962975400003, 34.858587958000044],
              [126.361664259, 34.83738841400009],
              [126.34205162900003, 34.82249583500004],
              [126.33130944100003, 34.825832424000055],
              [126.33765709700003, 34.831732489000046],
              [126.34083092500009, 34.83746979400007],
              [126.338226759, 34.841457424000055],
              [126.31031334700003, 34.85407135600008],
              [126.30616295700008, 34.855902411000045],
              [126.27662194100003, 34.85195547100005],
              [126.26351972700002, 34.84666575700004],
              [126.24870853000004, 34.84471263200004],
              [126.23682701900009, 34.84804922100005],
              [126.23072350400003, 34.85455963700008],
              [126.23609459700003, 34.859808661000045],
              [126.25196373800009, 34.860663153000075],
              [126.27230879000001, 34.86676666900007],
              [126.27588951900009, 34.87051015800006],
              [126.27914472700002, 34.87327708500004],
              [126.28012129000001, 34.87750885600008],
              [126.29265384200005, 34.88068268400008],
              [126.29712975400003, 34.88690827000005],
              [126.29761803500003, 34.894232489000046],
              [126.28980553500003, 34.90302155200004],
              [126.28646894600001, 34.91290924700007],
              [126.29737389400009, 34.91754791900007],
              [126.31470787900003, 34.914129950000074],
              [126.33253014400009, 34.90672435100004],
              [126.34522545700008, 34.89622630400004],
              [126.34392337300005, 34.890326239000046],
              [126.33521569100003, 34.88939036700009],
              [126.31999759200005, 34.88108958500004],
              [126.31812584700003, 34.87645091400009],
              [126.318695509, 34.87055084800005],
              [126.32007897200003, 34.86587148600006],
              [126.326508009, 34.86420319200005],
              [126.34066816500001, 34.86408112200007],
            ],
          ],
          [
            [
              [126.23422285200002, 35.04706452000005],
              [126.23609459700003, 35.051947333000044],
              [126.22925866000003, 35.05365631700005],
              [126.20362389400009, 35.05719635600008],
              [126.19792728000004, 35.06126536700009],
              [126.18913821700005, 35.06195709800005],
              [126.18482506600003, 35.06268952000005],
              [126.18051191500001, 35.06590403900009],
              [126.17481530000009, 35.06826406500005],
              [126.16944420700008, 35.07367584800005],
              [126.15870201900009, 35.09422435100004],
              [126.16480553500003, 35.10228099200009],
              [126.17750084700003, 35.10578034100007],
              [126.18921959700003, 35.10224030200004],
              [126.19857832100001, 35.09711334800005],
              [126.20704186300009, 35.09951406500005],
              [126.21664472700002, 35.10366445500006],
              [126.22282962300005, 35.10114166900007],
              [126.224945509, 35.09674713700008],
              [126.22982832100001, 35.096909898000035],
              [126.23601321700005, 35.09837474200009],
              [126.23853600400003, 35.091864325000074],
              [126.23161868600005, 35.08612702000005],
              [126.22242272200003, 35.085638739000046],
              [126.21851647200003, 35.08193594000005],
              [126.21851647200003, 35.076605536000045],
              [126.22950280000009, 35.06732819200005],
              [126.23878014400009, 35.06386953300006],
              [126.24919681100005, 35.06329987200007],
              [126.25513756600003, 35.05638255400004],
              [126.258148634, 35.04751211100006],
              [126.26319420700008, 35.041896877000056],
              [126.26498457100001, 35.03424713700008],
              [126.26107832100001, 35.02456289300005],
              [126.25717207100001, 35.02195872600004],
              [126.25456790500004, 35.025091864000046],
              [126.24293053500003, 35.02728913000004],
              [126.23804772200003, 35.032416083000044],
              [126.23406009200005, 35.038316148000035],
              [126.23422285200002, 35.04706452000005],
            ],
          ],
          [
            [
              [131.8610417440001, 37.244006186000036],
              [131.86252188600008, 37.243104377000066],
              [131.86170437700002, 37.24160561000008],
              [131.86014777700007, 37.24239861400008],
              [131.8610417440001, 37.244006186000036],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'North Korea',
        iso3: 'PRK',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [128.36491946700005, 38.624335028000075],
              [128.30837447200008, 38.601340027000035],
              [128.2810893150001, 38.58441599600003],
              [128.27478479, 38.57149688700012],
              [128.27695520100008, 38.55405609100008],
              [128.28543013600006, 38.51984629300007],
              [128.2810893150001, 38.484370423000044],
              [128.26806685400004, 38.45351959300005],
              [128.24873986800003, 38.42576934800012],
              [128.22558882700002, 38.399776103000065],
              [128.17236210200014, 38.35595448900004],
              [128.1084900310001, 38.323501689000025],
              [128.03986372900016, 38.30427805600003],
              [127.97175419200005, 38.30004058900006],
              [127.86685103400015, 38.30484649700007],
              [127.80075687700008, 38.2939169320001],
              [127.78701094600007, 38.29668162000006],
              [127.7747119550001, 38.306448466000106],
              [127.76194787700007, 38.32096954300006],
              [127.75373132300001, 38.32536204100005],
              [127.56082320200011, 38.31208119700004],
              [127.5020670990001, 38.298076884000025],
              [127.47193973800006, 38.295906474000034],
              [127.377113485, 38.31851491300007],
              [127.25381351800007, 38.31003997800006],
              [127.22198083500012, 38.3127013150001],
              [127.15748864800003, 38.30722361300012],
              [127.09046431500008, 38.2858554080001],
              [127.02674727400006, 38.25446197600009],
              [126.97191857900009, 38.21890859000011],
              [126.96606463600006, 38.21303801600003],
              [126.95372847500005, 38.20066681000007],
              [126.94013424700006, 38.17417257100003],
              [126.91982873600006, 38.13459849100009],
              [126.90334395400015, 38.119586487000035],
              [126.86479333500006, 38.09602203400003],
              [126.84732670200003, 38.082017721000014],
              [126.76190555800014, 37.97900075300002],
              [126.72211470600013, 37.953937683000035],
              [126.69632816600011, 37.9461862190001],
              [126.67782800300006, 37.94458424900007],
              [126.66578739500011, 37.9376337690001],
              [126.66051639800008, 37.913810934000125],
              [126.6674589270001, 37.827810161000016],
              [126.66700280000009, 37.82758209800005],
              [126.65577233200008, 37.814520575000074],
              [126.65162194100003, 37.799261786000045],
              [126.64210045700008, 37.79800039300005],
              [126.62077884200005, 37.78770579600007],
              [126.59327233200008, 37.77440013200004],
              [126.57618248800009, 37.77753327000005],
              [126.43661543100006, 37.84837474200009],
              [126.42847741000003, 37.85419342700004],
              [126.40430748800009, 37.887152411000045],
              [126.39771569100003, 37.89175039300005],
              [126.37867272200003, 37.88959381700005],
              [126.35800214900007, 37.88434479400007],
              [126.27955162900003, 37.851263739000046],
              [126.25953209700003, 37.84544505400004],
              [126.23690839900007, 37.84332916900007],
              [126.19996178500003, 37.84422435100004],
              [126.17847741000003, 37.84052155200004],
              [126.15821373800009, 37.82965729400007],
              [126.14918053500003, 37.82217031500005],
              [126.14771569100003, 37.81903717700004],
              [126.14975019600001, 37.81525299700007],
              [126.15284264400009, 37.799709377000056],
              [126.15967858200008, 37.77887604400007],
              [126.16537519600001, 37.76825592700004],
              [126.16431725400003, 37.75462474200009],
              [126.16122480600006, 37.740668036000045],
              [126.15821373800009, 37.73346588700008],
              [126.11036217500009, 37.74091217700004],
              [126.09693444100003, 37.78139883000006],
              [126.08692467500009, 37.80036041900007],
              [126.07211347700002, 37.799261786000045],
              [126.062836134, 37.80223216400009],
              [126.05860436300009, 37.82469310100004],
              [126.05575605600006, 37.87059153900009],
              [126.02613366000003, 37.85366445500006],
              [126.01278730600006, 37.85431549700007],
              [126.00733483200008, 37.874335028000075],
              [126.00074303500003, 37.88556549700007],
              [125.98593183700007, 37.89838288000004],
              [125.96981855600006, 37.90867747600004],
              [125.95948326900009, 37.912176825000074],
              [125.94410241000003, 37.90192291900007],
              [125.95053144600001, 37.88934967700004],
              [125.96461022200003, 37.87864817900004],
              [125.97250410200002, 37.874335028000075],
              [125.97445722700002, 37.864162502000056],
              [125.98365319100003, 37.837103583000044],
              [125.98617597700002, 37.82282135600008],
              [125.97787519600001, 37.829331773000035],
              [125.967133009, 37.83543528900009],
              [125.95590254000001, 37.84031810100004],
              [125.94589277400007, 37.84332916900007],
              [125.93336022200003, 37.844631252000056],
              [125.92701256600003, 37.84398021000004],
              [125.92164147200003, 37.84487539300005],
              [125.91163170700008, 37.850775458000044],
              [125.89551842500009, 37.86481354400007],
              [125.84546959700003, 37.92649974200009],
              [125.84107506600003, 37.93634674700007],
              [125.83497155000009, 37.94354889500005],
              [125.81128991000003, 37.94757721600007],
              [125.80518639400009, 37.95156484600005],
              [125.80250084700003, 37.95892975500004],
              [125.80176842500009, 37.97020091400009],
              [125.80396569100003, 37.98895905200004],
              [125.79932701900009, 37.99290599200009],
              [125.78419030000009, 37.99408600500004],
              [125.773773634, 37.996079820000034],
              [125.75635826900009, 38.005072333000044],
              [125.74659264400009, 38.00775788000004],
              [125.70517011800007, 38.00934479400007],
              [125.68734785200002, 38.01227448100008],
              [125.64730879000001, 38.02728913000004],
              [125.62216230600006, 38.03192780200004],
              [125.59693444100003, 38.03221263200004],
              [125.57894941500001, 38.02513255400004],
              [125.57821699300007, 38.009019273000035],
              [125.59652754000001, 37.992254950000074],
              [125.621429884, 37.97898997600004],
              [125.64071699300007, 37.97361888200004],
              [125.67538496200007, 37.97760651200008],
              [125.68531334700003, 37.97211334800005],
              [125.67831464900007, 37.95254140800006],
              [125.68881269600001, 37.95604075700004],
              [125.69898522200003, 37.958197333000044],
              [125.70883222700002, 37.95742422100005],
              [125.71933027400007, 37.95254140800006],
              [125.70753014400009, 37.93976471600007],
              [125.69882246200007, 37.92523834800005],
              [125.71753991000003, 37.92527903900009],
              [125.72518964900007, 37.92747630400004],
              [125.73292076900009, 37.93268463700008],
              [125.73975670700008, 37.92523834800005],
              [125.72779381600003, 37.91592031500005],
              [125.71534264400009, 37.908270575000074],
              [125.701508009, 37.90249258000006],
              [125.68506920700008, 37.89858633000006],
              [125.66895592500009, 37.89915599200009],
              [125.65707441500001, 37.90582916900007],
              [125.64551842500009, 37.91547272300005],
              [125.63062584700003, 37.92523834800005],
              [125.62745201900009, 37.90216705900008],
              [125.63681074300007, 37.87864817900004],
              [125.64120527400007, 37.85639069200005],
              [125.62305748800009, 37.837103583000044],
              [125.63778730600006, 37.82534414300005],
              [125.64413496200007, 37.82282135600008],
              [125.64014733200008, 37.81342194200005],
              [125.63355553500003, 37.80955638200004],
              [125.61353600400003, 37.80914948100008],
              [125.60922285200002, 37.806301174000055],
              [125.61109459700003, 37.79975006700005],
              [125.61695397200003, 37.788723049000055],
              [125.62037194100003, 37.77411530200004],
              [125.62012780000009, 37.765326239000046],
              [125.61353600400003, 37.761379299000055],
              [125.60279381600003, 37.761786200000074],
              [125.59302819100003, 37.76361725500004],
              [125.58399498800009, 37.76752350500004],
              [125.57520592500009, 37.77440013200004],
              [125.57935631600003, 37.776678778000075],
              [125.58008873800009, 37.77765534100007],
              [125.580414259, 37.77879466400009],
              [125.58277428500003, 37.78188711100006],
              [125.57056725400003, 37.787095445000034],
              [125.55958092500009, 37.78774648600006],
              [125.55160566500001, 37.78270091400009],
              [125.54859459700003, 37.77130768400008],
              [125.54184004000001, 37.77045319200005],
              [125.52890058700007, 37.77252838700008],
              [125.52051842500009, 37.780178127000056],
              [125.52759850400003, 37.796128648000035],
              [125.50350996200007, 37.77879466400009],
              [125.49097741000003, 37.75405508000006],
              [125.47461998800009, 37.73118724200009],
              [125.43873131600003, 37.71979401200008],
              [125.40365644600001, 37.71906159100007],
              [125.38526451900009, 37.71637604400007],
              [125.377289259, 37.710150458000044],
              [125.37265058700007, 37.69354889500005],
              [125.36158287900003, 37.68008047100005],
              [125.34750410200002, 37.67560455900008],
              [125.33505293100006, 37.68626536700009],
              [125.34864342500009, 37.737982489000046],
              [125.36378014400009, 37.76089101800005],
              [125.39039147200003, 37.75454336100006],
              [125.44491621200007, 37.77440013200004],
              [125.42945397200003, 37.78156159100007],
              [125.39511152400007, 37.77643463700008],
              [125.377289259, 37.78188711100006],
              [125.38990319100003, 37.796128648000035],
              [125.41098066500001, 37.80939362200007],
              [125.43490644600001, 37.81903717700004],
              [125.45582116000003, 37.82282135600008],
              [125.50513756600003, 37.81317780200004],
              [125.52418053500003, 37.81781647300005],
              [125.52759850400003, 37.84332916900007],
              [125.51083418100006, 37.83771393400008],
              [125.49732506600003, 37.83966705900008],
              [125.486664259, 37.84707265800006],
              [125.47909589900007, 37.85761139500005],
              [125.50863691500001, 37.88373444200005],
              [125.510101759, 37.89427317900004],
              [125.48316491000003, 37.89858633000006],
              [125.46387780000009, 37.90412018400008],
              [125.45508873800009, 37.91461823100008],
              [125.445648634, 37.92039622600004],
              [125.42440839900007, 37.912176825000074],
              [125.42750084700003, 37.90835195500006],
              [125.430023634, 37.902004299000055],
              [125.43189537900003, 37.89858633000006],
              [125.40626061300009, 37.89862702000005],
              [125.39454186300009, 37.89667389500005],
              [125.38355553500003, 37.89175039300005],
              [125.40284264400009, 37.88556549700007],
              [125.42798912900003, 37.87449778900009],
              [125.44629967500009, 37.86001211100006],
              [125.44491621200007, 37.84332916900007],
              [125.42628014400009, 37.85602448100008],
              [125.39966881600003, 37.86546458500004],
              [125.37183678500003, 37.869126695000034],
              [125.34937584700003, 37.86440664300005],
              [125.35401451900009, 37.85700104400007],
              [125.36036217500009, 37.85106028900009],
              [125.36801191500001, 37.84662506700005],
              [125.377289259, 37.84332916900007],
              [125.34595787900003, 37.82257721600007],
              [125.32667076900009, 37.81297435100004],
              [125.30836022200003, 37.80914948100008],
              [125.30909264400009, 37.81110260600008],
              [125.30811608200008, 37.81549713700008],
              [125.30543053500003, 37.82021719000005],
              [125.30103600400003, 37.82282135600008],
              [125.23951256600003, 37.82282135600008],
              [125.25171959700003, 37.83783600500004],
              [125.29493248800009, 37.85984935100004],
              [125.30836022200003, 37.87807851800005],
              [125.30062910200002, 37.89520905200004],
              [125.25709069100003, 37.91461823100008],
              [125.26002037900003, 37.93268463700008],
              [125.24008222700002, 37.92959219000005],
              [125.22852623800009, 37.915228583000044],
              [125.21957441500001, 37.89671458500004],
              [125.20850670700008, 37.88117096600007],
              [125.19312584700003, 37.87177155200004],
              [125.17660566500001, 37.867621161000045],
              [125.15821373800009, 37.86758047100005],
              [125.10035241000003, 37.875067450000074],
              [125.08936608200008, 37.87807851800005],
              [125.06210371200007, 37.896144924000055],
              [125.05152428500003, 37.89858633000006],
              [125.02938886800007, 37.900091864000046],
              [125.01319420700008, 37.90599192900004],
              [125.00660241000003, 37.91844310100004],
              [125.01351972700002, 37.939520575000074],
              [124.98902428500003, 37.927435614000046],
              [124.97950280000009, 37.92523834800005],
              [124.98365319100003, 37.94232819200005],
              [124.99219811300009, 37.95294830900008],
              [125.00546308700007, 37.95844147300005],
              [125.02418053500003, 37.96002838700008],
              [125.03663170700008, 37.96360911700009],
              [125.06202233200008, 37.978583075000074],
              [125.07569420700008, 37.980454820000034],
              [125.08961022200003, 37.975816148000035],
              [125.11597741000003, 37.96271393400008],
              [125.13379967500009, 37.96002838700008],
              [125.14991295700008, 37.96076080900008],
              [125.16382897200003, 37.963771877000056],
              [125.17538496200007, 37.969916083000044],
              [125.18490644600001, 37.980454820000034],
              [125.17750084700003, 37.987941799000055],
              [125.16651451900009, 37.98126862200007],
              [125.15528405000009, 37.97996653900009],
              [125.14429772200003, 37.98346588700008],
              [125.12330162900003, 37.99843984600005],
              [125.11850019600001, 37.99945709800005],
              [125.11532636800007, 38.002386786000045],
              [125.109711134, 38.015285549000055],
              [125.10670006600003, 38.03461334800005],
              [125.11622155000009, 38.04193756700005],
              [125.15756269600001, 38.04254791900007],
              [125.20167076900009, 38.04938385600008],
              [125.213226759, 38.04572174700007],
              [125.21729576900009, 38.037176825000074],
              [125.21957441500001, 38.02781810100004],
              [125.22518964900007, 38.02142975500004],
              [125.24634850400003, 38.02008698100008],
              [125.25318444100003, 38.053941148000035],
              [125.27369225400003, 38.06240469000005],
              [125.26490319100003, 38.07794830900008],
              [125.24830162900003, 38.08380768400008],
              [125.20850670700008, 38.08348216400009],
              [125.19044030000009, 38.08576080900008],
              [125.15585371200007, 38.09552643400008],
              [125.14063561300009, 38.09780508000006],
              [125.12452233200008, 38.09511953300006],
              [125.07569420700008, 38.07607656500005],
              [125.02735436300009, 38.06899648600006],
              [125.01351972700002, 38.06240469000005],
              [124.937836134, 38.09780508000006],
              [124.90487714900007, 38.12482330900008],
              [124.88526451900009, 38.13165924700007],
              [124.87647545700008, 38.11395905200004],
              [124.86548912900003, 38.107082424000055],
              [124.84009850400003, 38.101996161000045],
              [124.79379316500001, 38.09780508000006],
              [124.67709394600001, 38.11538320500006],
              [124.66724694100003, 38.12571849200009],
              [124.67359459700003, 38.13719310100004],
              [124.69776451900009, 38.144964911000045],
              [124.74512780000009, 38.14793528900009],
              [124.76514733200008, 38.15607330900008],
              [124.77328535200002, 38.17597077000005],
              [124.78003991000003, 38.178615627000056],
              [124.82178795700008, 38.18593984600005],
              [124.82911217500009, 38.193793036000045],
              [124.84546959700003, 38.218410549000055],
              [124.85596764400009, 38.22695547100005],
              [124.87916100400003, 38.23065827000005],
              [124.89527428500003, 38.22150299700007],
              [124.92090905000009, 38.18935781500005],
              [124.93100019600001, 38.19293854400007],
              [124.99301191500001, 38.22695547100005],
              [124.96762129000001, 38.23533763200004],
              [124.91504967500009, 38.22907135600008],
              [124.88656660200002, 38.244574286000045],
              [124.87232506600003, 38.25763580900008],
              [124.87012780000009, 38.26544830900008],
              [124.86963951900009, 38.282131252000056],
              [124.87973066500001, 38.34520091400009],
              [124.88388105600006, 38.35529205900008],
              [124.92798912900003, 38.409084377000056],
              [124.93506920700008, 38.42059967700004],
              [124.94727623800009, 38.450506903000075],
              [124.95899498800009, 38.46088288000004],
              [124.96656334700003, 38.46336497600004],
              [124.97217858200008, 38.462144273000035],
              [124.97486412900003, 38.455145575000074],
              [124.97266686300009, 38.44037506700005],
              [124.98519941500001, 38.45136139500005],
              [125.00204511800007, 38.47361888200004],
              [125.01636803500003, 38.49795156500005],
              [125.02100670700008, 38.514878648000035],
              [125.01474043100006, 38.52496979400007],
              [124.99683678500003, 38.53587474200009],
              [124.99301191500001, 38.54588450700004],
              [124.99488366000003, 38.55768463700008],
              [124.99708092500009, 38.56614817900004],
              [124.99569746200007, 38.57404205900008],
              [124.9808656990001, 38.58415720100004],
              [124.98394855600009, 38.59194167600003],
              [124.99774737500002, 38.59252162100006],
              [125.01768591000007, 38.58352329600007],
              [125.02920047300006, 38.589495285000055],
              [125.03762506700002, 38.59127144900009],
              [125.04296633600006, 38.581682956000066],
              [125.05824114500001, 38.568467928000075],
              [125.07974441700003, 38.583988530000056],
              [125.10276941300003, 38.59352342600005],
              [125.12800864000008, 38.58028144200006],
              [125.13453209700003, 38.59125397300005],
              [125.13404381600003, 38.61001211100006],
              [125.13721764400009, 38.62474192900004],
              [125.12606855600006, 38.633246161000045],
              [125.11841881600003, 38.64516836100006],
              [125.11654707100001, 38.65721263200004],
              [125.123383009, 38.66632721600007],
              [125.13755966000008, 38.66233230700004],
              [125.148228539, 38.64612822300006],
              [125.15659989900007, 38.631726627000035],
              [125.17962270700002, 38.63465513600005],
              [125.18349645, 38.64243174400008],
              [125.17819758300004, 38.65682617900006],
              [125.1797965070001, 38.67000248100004],
              [125.18899038100005, 38.66697903000005],
              [125.193545234, 38.657378649000066],
              [125.20348540400005, 38.652553381000075],
              [125.22038123100003, 38.656092424000065],
              [125.23573354900009, 38.65783722300006],
              [125.25961350900002, 38.669738521000056],
              [125.26729528800001, 38.67031000600008],
              [125.27798275600003, 38.66307753800004],
              [125.30103600400003, 38.65680573100008],
              [125.31132433100004, 38.66501670200006],
              [125.31979146600008, 38.66858445200006],
              [125.33060514700003, 38.67874746700005],
              [125.34601622600007, 38.68707909500006],
              [125.369108353, 38.69476077500008],
              [125.39722741000003, 38.69367096600007],
              [125.40674889400009, 38.69285716400009],
              [125.42969811300009, 38.687486070000034],
              [125.44190514400009, 38.68622467700004],
              [125.44442793100006, 38.689520575000074],
              [125.44613691500001, 38.69672272300005],
              [125.45101972700002, 38.704006252000056],
              [125.46265709700003, 38.70726146000004],
              [125.50709069100003, 38.68622467700004],
              [125.51181074300007, 38.67670319200005],
              [125.51465905000009, 38.657863674000055],
              [125.52076256600003, 38.65265534100007],
              [125.53272545700008, 38.65412018400008],
              [125.53793379000001, 38.66364166900007],
              [125.54078209700003, 38.674261786000045],
              [125.54517662900003, 38.679388739000046],
              [125.55518639400009, 38.676662502000056],
              [125.56495201900009, 38.67011139500005],
              [125.57235761800007, 38.66229889500005],
              [125.57520592500009, 38.65574778900009],
              [125.58594811300009, 38.641913153000075],
              [125.61036217500009, 38.63108958500004],
              [125.63795006600003, 38.62641022300005],
              [125.65780683700007, 38.63100820500006],
              [125.64852949300007, 38.63849518400008],
              [125.63681074300007, 38.653998114000046],
              [125.63062584700003, 38.65888092700004],
              [125.61988366000003, 38.661444403000075],
              [125.59961998800009, 38.66225820500006],
              [125.58895918100006, 38.66632721600007],
              [125.54371178500003, 38.71112702000005],
              [125.52759850400003, 38.72093333500004],
              [125.51474043100006, 38.72280508000006],
              [125.49097741000003, 38.72288646000004],
              [125.47909589900007, 38.727728583000044],
              [125.47291100400003, 38.73432038000004],
              [125.44703209700003, 38.771551825000074],
              [125.44800866000003, 38.77619049700007],
              [125.44776451900009, 38.77724844000005],
              [125.43873131600003, 38.77558014500005],
              [125.435883009, 38.77130768400008],
              [125.43213951900009, 38.76308828300006],
              [125.42457116000003, 38.755926825000074],
              [125.41089928500003, 38.755072333000044],
              [125.42001386800007, 38.75018952000005],
              [125.42782636800007, 38.744126695000034],
              [125.43417402400007, 38.736761786000045],
              [125.41931328300006, 38.72926491900006],
              [125.38924406500007, 38.717449085000055],
              [125.37312844300004, 38.72054103700009],
              [125.36304772200003, 38.73456452000005],
              [125.35621178500003, 38.73456452000005],
              [125.35035241000003, 38.72125885600008],
              [125.34107506600003, 38.71747467700004],
              [125.31454511800007, 38.72093333500004],
              [125.31275475400003, 38.723863023000035],
              [125.31031334700003, 38.729803778000075],
              [125.30640709700003, 38.73460521000004],
              [125.30103600400003, 38.73456452000005],
              [125.29590905000009, 38.72846100500004],
              [125.29794355600006, 38.72211334800005],
              [125.30347741000003, 38.71674225500004],
              [125.30836022200003, 38.71352773600006],
              [125.30836022200003, 38.70726146000004],
              [125.29371178500003, 38.703192450000074],
              [125.277679884, 38.70331452000005],
              [125.26246178500003, 38.707912502000056],
              [125.24976647200003, 38.717230536000045],
              [125.24350019600001, 38.72833893400008],
              [125.24691816500001, 38.73672109600005],
              [125.26685631600003, 38.755072333000044],
              [125.25977623800009, 38.75828685100004],
              [125.25318444100003, 38.76251862200007],
              [125.25782311300009, 38.771918036000045],
              [125.25269616000003, 38.78359609600005],
              [125.24097741000003, 38.79311758000006],
              [125.22518964900007, 38.796087958000044],
              [125.23047936300009, 38.771918036000045],
              [125.21655678700006, 38.73971680000005],
              [125.188119798, 38.73860758200004],
              [125.17666381900005, 38.75122800100007],
              [125.17211143100008, 38.76322957000008],
              [125.15677039000002, 38.76926729200005],
              [125.14527391700005, 38.777087866000045],
              [125.13721764400009, 38.80353424700007],
              [125.14332116000003, 38.820379950000074],
              [125.14755293100006, 38.837144273000035],
              [125.150726759, 38.87457916900007],
              [125.151966217, 38.891528975000085],
              [125.1636271540001, 38.91546040500003],
              [125.17298086200003, 38.93879952100008],
              [125.19002722000005, 38.95851982600004],
              [125.20090124600006, 38.97526244800008],
              [125.19864306900001, 38.986056348000034],
              [125.21216881600003, 39.00153229400007],
              [125.23336837900001, 39.029886770000076],
              [125.2520020290001, 39.049638677000075],
              [125.26002037900003, 39.06635163000004],
              [125.27080255200008, 39.08060612500009],
              [125.29110761800007, 39.08047109600005],
              [125.31600996200007, 39.07953522300005],
              [125.33505293100006, 39.08344147300005],
              [125.28407024400008, 39.089556418000086],
              [125.2866942820001, 39.09704642300005],
              [125.29061152600002, 39.104530787000044],
              [125.2903347780001, 39.11128125700009],
              [125.28617909400009, 39.117048880000084],
              [125.28815316700002, 39.123542083000075],
              [125.28736412900003, 39.13182200700004],
              [125.28915449300007, 39.13906484600005],
              [125.293304884, 39.14354075700004],
              [125.29444420700008, 39.147365627000056],
              [125.28736412900003, 39.152329820000034],
              [125.29672285200002, 39.16152578300006],
              [125.30713951900009, 39.16543203300006],
              [125.33204186300009, 39.16596100500004],
              [125.34351647200003, 39.16889069200005],
              [125.34009850400003, 39.17601146000004],
              [125.33204186300009, 39.18496328300006],
              [125.32886803500003, 39.19330475500004],
              [125.34359785200002, 39.212876695000034],
              [125.36508222700002, 39.22089264500005],
              [125.389008009, 39.22028229400007],
              [125.41089928500003, 39.21381256700005],
              [125.40487714900007, 39.228949286000045],
              [125.39600670700008, 39.23655833500004],
              [125.39356530000009, 39.245794989000046],
              [125.43189537900003, 39.30072663000004],
              [125.44491621200007, 39.310614325000074],
              [125.42920983200008, 39.31224192900004],
              [125.41627037900003, 39.32025788000004],
              [125.41114342500009, 39.33348216400009],
              [125.41822350400003, 39.35097890800006],
              [125.41342207100001, 39.35443756700005],
              [125.404633009, 39.36465078300006],
              [125.41480553500003, 39.36200592700004],
              [125.41895592500009, 39.360541083000044],
              [125.42440839900007, 39.357123114000046],
              [125.445648634, 39.36692942900004],
              [125.45419355600006, 39.374335028000075],
              [125.45923912900003, 39.38507721600007],
              [125.43848717500009, 39.38499583500004],
              [125.37647545700008, 39.39252350500004],
              [125.35702558700007, 39.39874909100007],
              [125.35995527400007, 39.41315338700008],
              [125.38355553500003, 39.440334377000056],
              [125.37256920700008, 39.44098541900007],
              [125.36182701900009, 39.43992747600004],
              [125.35165449300007, 39.43740469000005],
              [125.34253991000003, 39.43353913000004],
              [125.346039259, 39.45962148600006],
              [125.36036217500009, 39.474676825000074],
              [125.37940514400009, 39.48627350500004],
              [125.39722741000003, 39.50177643400008],
              [125.40259850400003, 39.513739325000074],
              [125.406586134, 39.52749258000006],
              [125.41366621200007, 39.538723049000055],
              [125.44198652400007, 39.54755280200004],
              [125.45028730600006, 39.557928778000075],
              [125.45175214900007, 39.57127513200004],
              [125.44491621200007, 39.58437734600005],
              [125.42969811300009, 39.575384833000044],
              [125.32569420700008, 39.533189195000034],
              [125.30355879000001, 39.52728913000004],
              [125.29493248800009, 39.52301666900007],
              [125.28598066500001, 39.521185614000046],
              [125.27711022200003, 39.52602773600006],
              [125.25074303500003, 39.551214911000045],
              [125.24634850400003, 39.553615627000056],
              [125.23707116000003, 39.56289297100005],
              [125.21957441500001, 39.566473700000074],
              [125.21029707100001, 39.57306549700007],
              [125.22518964900007, 39.59121328300006],
              [125.15756269600001, 39.59121328300006],
              [125.16098066500001, 39.585191148000035],
              [125.16781660200002, 39.56976959800005],
              [125.17123457100001, 39.56386953300006],
              [125.12680097700002, 39.56386953300006],
              [125.11695397200003, 39.56586334800005],
              [125.11426842500009, 39.57094961100006],
              [125.11353600400003, 39.57758209800005],
              [125.109711134, 39.58437734600005],
              [125.10377037900003, 39.59247467700004],
              [125.10165449300007, 39.59870026200008],
              [125.09750410200002, 39.602728583000044],
              [125.08554121200007, 39.60419342700004],
              [125.07007897200003, 39.60150788000004],
              [125.06031334700003, 39.60114166900007],
              [125.04769941500001, 39.60419342700004],
              [125.04004967500009, 39.60854726800005],
              [125.01807701900009, 39.62400950700004],
              [125.01351972700002, 39.62872955900008],
              [125.01059004000001, 39.63532135600008],
              [125.00326582100001, 39.63686758000006],
              [124.99439537900003, 39.63690827000005],
              [124.98633873800009, 39.63898346600007],
              [124.95826256600003, 39.66201406500005],
              [124.94727623800009, 39.662990627000056],
              [124.937836134, 39.645819403000075],
              [124.92652428500003, 39.65298086100006],
              [124.91309655000009, 39.656236070000034],
              [124.90162194100003, 39.66205475500004],
              [124.89267011800007, 39.69196198100008],
              [124.88160241000003, 39.70416901200008],
              [124.86630293100006, 39.71385325700004],
              [124.84913170700008, 39.72150299700007],
              [124.83358808700007, 39.72597890800006],
              [124.81128991000003, 39.72833893400008],
              [124.803070509, 39.730454820000034],
              [124.799164259, 39.73981354400007],
              [124.77064966, 39.74181142100008],
              [124.76039012900003, 39.748007778000044],
              [124.75643964900007, 39.77065664300005],
              [124.74610436300009, 39.78294505400004],
              [124.74024498800009, 39.77216217700004],
              [124.73951256600003, 39.76211172100005],
              [124.74293053500003, 39.75299713700008],
              [124.74952233200008, 39.74506256700005],
              [124.75473066500001, 39.733710028000075],
              [124.75025475400003, 39.722357489000046],
              [124.75002107500006, 39.70989247400007],
              [124.74418696600003, 39.70130795300008],
              [124.74462405300005, 39.69135615600004],
              [124.75711508900008, 39.687905913000066],
              [124.75304515100004, 39.672458745000085],
              [124.74053231200003, 39.671791548000044],
              [124.72980457000006, 39.66529252400005],
              [124.73424385800001, 39.654996174000075],
              [124.74390709700003, 39.64435455900008],
              [124.73513749100005, 39.641587568000034],
              [124.71641220400011, 39.647127675000036],
              [124.69501666400004, 39.637539814000036],
              [124.67492862800009, 39.622069139000075],
              [124.6490628140001, 39.61212080700005],
              [124.6405747230001, 39.59460383000004],
              [124.63745219100008, 39.59048344900009],
              [124.62378991000003, 39.59796784100007],
              [124.62411543100006, 39.60219961100006],
              [124.625336134, 39.605169989000046],
              [124.62940514400009, 39.61163971600007],
              [124.62191816500001, 39.61310455900008],
              [124.61866295700008, 39.61473216400009],
              [124.61573326900009, 39.61786530200004],
              [124.610803014, 39.62865050000005],
              [124.62857395600008, 39.64474758800009],
              [124.63214883400008, 39.662945980000075],
              [124.64509531300007, 39.66946608400008],
              [124.64991295700008, 39.683661200000074],
              [124.64698326900009, 39.69757721600007],
              [124.63990319100003, 39.69806549700007],
              [124.63143964900007, 39.69391510600008],
              [124.62378991000003, 39.69354889500005],
              [124.61988366000003, 39.69794342700004],
              [124.61337324300007, 39.70978424700007],
              [124.60946699300007, 39.71466705900008],
              [124.60035241000003, 39.71930573100008],
              [124.59156334700003, 39.72085195500006],
              [124.58480879000001, 39.72357819200005],
              [124.58228600400003, 39.731756903000075],
              [124.58326256600003, 39.74054596600007],
              [124.58790123800009, 39.756293036000045],
              [124.58912194100003, 39.76585521000004],
              [124.58472741000003, 39.77094147300005],
              [124.56600996200007, 39.77887604400007],
              [124.56161543100006, 39.78668854400007],
              [124.56544030000009, 39.80711497600004],
              [124.56405683700007, 39.81427643400008],
              [124.55494225400003, 39.81708405200004],
              [124.51978600400003, 39.818060614000046],
              [124.43441816500001, 39.83075592700004],
              [124.430023634, 39.829331773000035],
              [124.42636152400007, 39.82648346600007],
              [124.42261803500003, 39.824204820000034],
              [124.41773522200003, 39.82453034100007],
              [124.41366621200007, 39.827826239000046],
              [124.40975996200007, 39.835923570000034],
              [124.40723717500009, 39.837591864000046],
              [124.40357506600003, 39.841498114000046],
              [124.39918053500003, 39.859808661000045],
              [124.39657636800007, 39.86554596600007],
              [124.38965905000009, 39.86786530200004],
              [124.36255944100003, 39.87173086100006],
              [124.34888756600003, 39.89280833500004],
              [124.34180748800009, 39.89996979400007],
              [124.33480879000001, 39.905585028000075],
              [124.32797285200002, 39.90973541900007],
              [124.32154381600003, 39.91266510600008],
              [124.33212324300007, 39.925116278000075],
              [124.34571373800009, 39.93024323100008],
              [124.35938561300009, 39.93353913000004],
              [124.36996504000001, 39.94000885600008],
              [124.37606855600006, 39.95408763200004],
              [124.38306725400003, 40.00267161700009],
              [124.40577233200008, 40.027777411000045],
              [124.43409264400009, 40.02456289300005],
              [124.46583092500009, 40.015285549000055],
              [124.49960371200007, 40.02252838700008],
              [124.47925866000003, 40.03074778900009],
              [124.43287194100003, 40.03278229400007],
              [124.41024824300007, 40.03620026200008],
              [124.39144941500001, 40.04828522300005],
              [124.38436933700007, 40.064886786000045],
              [124.38038170700008, 40.08266836100006],
              [124.36996504000001, 40.098293361000074],
              [124.38556482000007, 40.110472718000054],
              [124.528191773, 40.21413564100003],
              [124.53237756400006, 40.21599599200003],
              [124.54302290900006, 40.21764963800008],
              [124.54865564000016, 40.22090525300008],
              [124.55020593300009, 40.22472930900001],
              [124.55175622600012, 40.23620147800004],
              [124.55485681100004, 40.24142079700006],
              [124.5708765060001, 40.252427877000045],
              [124.61118412300004, 40.272168275000084],
              [124.627203817, 40.28612091100008],
              [124.6426033940001, 40.29428578700002],
              [124.6930395920001, 40.30281239800003],
              [124.71246993, 40.31030548100007],
              [124.72296024600013, 40.32668691000002],
              [124.73128015200007, 40.34973459900009],
              [124.7412020270001, 40.37035349600008],
              [124.756808309, 40.37919016600007],
              [124.77985599800002, 40.383479310000055],
              [124.80083662900006, 40.39407297800004],
              [124.84987756400011, 40.431590068000034],
              [124.88382898000015, 40.46554148400004],
              [124.8906502690001, 40.477892152],
              [124.89550785400002, 40.48362823500007],
              [124.90563643400009, 40.47649688800003],
              [124.91514489800011, 40.46585154200004],
              [124.9179354260001, 40.46109731000003],
              [124.92589359600004, 40.45789337200007],
              [124.93529870600003, 40.45556793200002],
              [124.9595866300001, 40.453655904000115],
              [124.98661340400008, 40.45737660700003],
              [125.00661218300002, 40.45613637300009],
              [125.02630090400015, 40.45737660700003],
              [125.04128706900013, 40.46109731000003],
              [125.04629968300009, 40.47107086200005],
              [125.03885827700003, 40.48347320600003],
              [125.02769616800003, 40.49587555000009],
              [125.01529382300015, 40.508277894000045],
              [125.01529382300015, 40.521972148000074],
              [125.02511234500003, 40.534374492000055],
              [125.05002038600009, 40.54181589800005],
              [125.07358484000008, 40.54801707000006],
              [125.08965620900005, 40.55551015200008],
              [125.11461592700005, 40.564140117000036],
              [125.13306441200007, 40.572873433],
              [125.1530631930001, 40.58398386700013],
              [125.181536907, 40.593957418000045],
              [125.21641849800011, 40.60263905900008],
              [125.24241174300005, 40.611320699000046],
              [125.25610599800007, 40.615041402000074],
              [125.26483931500007, 40.62248280900009],
              [125.27098881000012, 40.63245636000009],
              [125.2771899820001, 40.64361847000002],
              [125.2933130290001, 40.64857940700007],
              [125.30819584200003, 40.64981964200011],
              [125.323182008, 40.64485870400007],
              [125.33666955600006, 40.641138001000044],
              [125.35604821800013, 40.646047262000096],
              [125.36359297700011, 40.64671905500008],
              [125.3724813230001, 40.64392852800002],
              [125.38457360900009, 40.63509185800011],
              [125.3908781340001, 40.63245636000009],
              [125.41325402900009, 40.63178456600009],
              [125.41712976200006, 40.63927764900005],
              [125.41495935100016, 40.651938375000086],
              [125.41515982600004, 40.652684880000024],
              [125.41888676000013, 40.66656280600007],
              [125.42632816600013, 40.67116200800011],
              [125.44369144800015, 40.668733215000046],
              [125.4529932050001, 40.6733840940001],
              [125.45630049700009, 40.67968862000002],
              [125.45692061400007, 40.69369293300004],
              [125.45981449400006, 40.70134104400002],
              [125.46906457500006, 40.71291656600006],
              [125.478779745, 40.718756002000035],
              [125.49164717600001, 40.72092641300013],
              [125.53309167500004, 40.72180491200008],
              [125.5464758710001, 40.72593902600009],
              [125.55334883600005, 40.73710113600002],
              [125.55536421800002, 40.758753561],
              [125.56006677300007, 40.77833892900013],
              [125.57174564700006, 40.78490183600012],
              [125.58652510600007, 40.78185292600007],
              [125.60032271400013, 40.772706198],
              [125.60812585500003, 40.76417958600008],
              [125.60993453000003, 40.761285706000095],
              [125.6686906330001, 40.76216420500005],
              [125.68264327000009, 40.76888214100005],
              [125.67334151200015, 40.78407501200009],
              [125.64481612100008, 40.810585023],
              [125.68321171100001, 40.847895407000024],
              [125.70408969200008, 40.85919462500003],
              [125.70641442900006, 40.860452779000056],
              [125.73700687700006, 40.86520701100004],
              [125.74589522300005, 40.86815256800013],
              [125.75075280800002, 40.87476715100003],
              [125.75473189300016, 40.88169179400002],
              [125.76093306500007, 40.885670878],
              [125.77080326400005, 40.88623931900004],
              [125.7791748460001, 40.884637349000016],
              [125.82196293100003, 40.86975453700008],
              [125.83167810100008, 40.870839743000076],
              [125.87270918800004, 40.8926988730001],
              [125.8852148850001, 40.89750478200001],
              [125.90154463700003, 40.899313457000105],
              [125.91229333500007, 40.894145813000094],
              [125.924023885, 40.88406890900005],
              [125.93616784700015, 40.87740264900005],
              [125.94960371900004, 40.88257029300006],
              [125.96427982600011, 40.89130361000012],
              [125.99507898000007, 40.894145813000094],
              [126.00784305900004, 40.899313457000105],
              [126.01533614200008, 40.909131979000065],
              [126.01001346900006, 40.91388621100005],
              [125.99662927300011, 40.91491973900004],
              [125.9805579020001, 40.91362782800009],
              [125.99203007100004, 40.92835561200009],
              [126.00954838100012, 40.93269643100008],
              [126.028565308, 40.93528025300007],
              [126.04551517800007, 40.94468536400002],
              [126.06582401600008, 40.96861155300003],
              [126.07197351100007, 40.980600485000096],
              [126.06928633600006, 40.989385478000074],
              [126.07564253800007, 40.99708526700006],
              [126.08370406100005, 41.00251129200005],
              [126.093367554, 41.00623199500005],
              [126.1040645760001, 41.009177552000054],
              [126.10132572500004, 41.02209665900007],
              [126.1115059820001, 41.032431946000074],
              [126.12644047100008, 41.04323232000009],
              [126.13817102100006, 41.056978252000036],
              [126.123753297, 41.07553009100009],
              [126.14742110200007, 41.09227325500002],
              [126.26069584200002, 41.143122864000034],
              [126.27475183200016, 41.15257965100001],
              [126.28436364800007, 41.16410349500005],
              [126.30953007000011, 41.20782175700002],
              [126.32100223900005, 41.21888051400002],
              [126.34616866100015, 41.237690735000044],
              [126.35733077000009, 41.249421285000025],
              [126.38058516500013, 41.29081410700006],
              [126.3914888920001, 41.3034231570001],
              [126.44089156100011, 41.34838165300003],
              [126.47251753800009, 41.36652008100005],
              [126.50130131100002, 41.36610666900013],
              [126.49820072500006, 41.361765849000065],
              [126.49649540200011, 41.35804514600004],
              [126.49375655100005, 41.35478953000005],
              [126.487658732, 41.351792298000035],
              [126.487658732, 41.344402568000035],
              [126.52212691200009, 41.351947327000076],
              [126.52212691200009, 41.377630514000074],
              [126.50827762900008, 41.40915313700013],
              [126.50130131100002, 41.434371236000075],
              [126.50760583500005, 41.44723866900007],
              [126.54222904500006, 41.488993225000016],
              [126.55876550300002, 41.53415842800008],
              [126.57726566600007, 41.561805318],
              [126.58088301700002, 41.575241191000046],
              [126.57726566600007, 41.58831532900011],
              [126.56651696800014, 41.60193206800001],
              [126.56703373200008, 41.61415354400013],
              [126.6020703530001, 41.64205881800011],
              [126.61788334200008, 41.6659333300001],
              [126.63395471200016, 41.66862050400003],
              [126.66930139200008, 41.66712188700002],
              [126.680101766, 41.67190195700003],
              [126.71224450800003, 41.694174500000074],
              [126.72795414300009, 41.70125417100009],
              [126.71415653500003, 41.70990997400004],
              [126.6996354580001, 41.7164212040001],
              [126.68712976100011, 41.72401763900008],
              [126.67948164900014, 41.735980733000034],
              [126.69658654800008, 41.74122589200006],
              [126.712502889, 41.74122589200006],
              [126.727282349, 41.73691090900009],
              [126.74154504400008, 41.729185282000074],
              [126.7713623460001, 41.70448394800006],
              [126.78862227400009, 41.695905661000054],
              [126.79627038600006, 41.70494903600009],
              [126.8088794360001, 41.729831238000045],
              [126.86479333500006, 41.747272034],
              [126.8774540610001, 41.773549500000044],
              [126.88711755400004, 41.78491831500013],
              [126.90851159700003, 41.79615793900008],
              [126.92980228700003, 41.80104136200002],
              [126.93962080900008, 41.7937291460001],
              [126.94065433800006, 41.771766663000065],
              [126.94613204000007, 41.76618560800004],
              [126.95858606000007, 41.7668057260001],
              [126.98116866100008, 41.763317566000055],
              [126.99963111400012, 41.752049230000026],
              [127.03315515200012, 41.731588237000025],
              [127.04266361600003, 41.73264760400012],
              [127.0467977300001, 41.71923756900007],
              [127.06834680200006, 41.693580221],
              [127.07661503100013, 41.68079030300002],
              [127.059613485, 41.68223724400012],
              [127.04896814000011, 41.67774139400011],
              [127.04545414300009, 41.66800038700005],
              [127.04943322800005, 41.653427633],
              [127.05899336800013, 41.643299052000046],
              [127.07403121000004, 41.635702616000074],
              [127.10467533400004, 41.6261683150001],
              [127.10188480700009, 41.62229258300003],
              [127.09723392800004, 41.612448222000054],
              [127.11397709200008, 41.610355327],
              [127.1660669360001, 41.59495575000001],
              [127.17970951300003, 41.58516306600005],
              [127.1578503830001, 41.57860015900006],
              [127.1365080160001, 41.56924672500013],
              [127.118007853, 41.55575917600005],
              [127.10467533400004, 41.53741404300008],
              [127.11196171100005, 41.53663889600007],
              [127.12085005700015, 41.53477854400005],
              [127.12823978800014, 41.531574605000074],
              [127.1346476650001, 41.5220144660001],
              [127.14239912900013, 41.523926494000094],
              [127.1559383550001, 41.53054107700011],
              [127.16513676, 41.528525696000074],
              [127.1703560790001, 41.523926494000094],
              [127.174335165, 41.51927561400005],
              [127.17970951300003, 41.51695017500002],
              [127.187254273, 41.52149770200005],
              [127.20032841000005, 41.54206492200005],
              [127.20709802300007, 41.5459406530001],
              [127.22198083500012, 41.54077301000008],
              [127.24451176000002, 41.52800893200002],
              [127.2583093670001, 41.52547678600003],
              [127.2674560960001, 41.52733713800005],
              [127.27469079600007, 41.530437725000084],
              [127.28146040900009, 41.53105784100005],
              [127.28895349200002, 41.52547678600003],
              [127.28978031500003, 41.518552145000044],
              [127.28357914200006, 41.51219594400003],
              [127.27515588400007, 41.50733835900009],
              [127.26905806500014, 41.50496124300007],
              [127.28636967, 41.49901845300003],
              [127.30512821500014, 41.49467763300005],
              [127.34424727400005, 41.491318665000065],
              [127.35370406100003, 41.49271392800004],
              [127.37111901900005, 41.49808827800008],
              [127.3789738370001, 41.49881174700009],
              [127.38848230000008, 41.49602122000003],
              [127.39592370700007, 41.491370341000064],
              [127.40134973200009, 41.486822815000025],
              [127.40512211100008, 41.484497376],
              [127.42734297800013, 41.483102112000026],
              [127.44305261300008, 41.48801137300005],
              [127.45710860200012, 41.49472930900008],
              [127.47411014900001, 41.49881174700009],
              [127.49100834100005, 41.49540110300005],
              [127.508474976, 41.488166402],
              [127.52583825700009, 41.48434234600005],
              [127.5428914790001, 41.491318665000065],
              [127.5447518310001, 41.46889109300007],
              [127.55880782100013, 41.45824574800007],
              [127.59751346900015, 41.4503392540001],
              [127.63068973900016, 41.43287262000008],
              [127.63833785000014, 41.42987538700005],
              [127.64707116800002, 41.4329759730001],
              [127.65812992400004, 41.446566874],
              [127.66267745000005, 41.446980286],
              [127.69027266500007, 41.438970439000045],
              [127.78463383000008, 41.43690338200007],
              [127.8103686930001, 41.44356964100008],
              [127.82886885700009, 41.433957825000064],
              [127.84886763600008, 41.431322327000046],
              [127.86514571200007, 41.43742014600009],
              [127.8718636480001, 41.453749899000044],
              [127.881475464, 41.460881246000085],
              [127.903592978, 41.46625559500005],
              [127.94421065300008, 41.470854798000076],
              [127.97423466100014, 41.4503392540001],
              [127.98446659400008, 41.4540082810001],
              [127.99273482300015, 41.461139629000044],
              [128.0014164630001, 41.470854798000076],
              [128.01237186700007, 41.46010610000006],
              [128.0130953370001, 41.44227773000004],
              [128.01154504500005, 41.42434600900005],
              [128.01516239500006, 41.413287252000046],
              [128.02384403500002, 41.41147857700007],
              [128.03366255700007, 41.41375234000007],
              [128.0506124270001, 41.42072865800007],
              [128.04689172400003, 41.3987661740001],
              [128.06415165200013, 41.38843088800009],
              [128.08812951700008, 41.38889597600003],
              [128.10394250500008, 41.399592998000045],
              [128.11820520100002, 41.39344350200007],
              [128.10394250500008, 41.37912913000007],
              [128.146110474, 41.37633860300009],
              [128.1856946210001, 41.40445058200005],
              [128.28760054600008, 41.54470041900005],
              [128.30300012200007, 41.58340606700007],
              [128.28325972500016, 41.605058492000055],
              [128.281399373, 41.62299021500003],
              [128.26899703000004, 41.64337656600007],
              [128.2509102790001, 41.66011973100002],
              [128.2241418870001, 41.66944732700004],
              [128.18600467900006, 41.69290842700012],
              [128.15913293500006, 41.71182200100007],
              [128.15489546700007, 41.733758647000016],
              [128.144250123, 41.75471344100002],
              [128.09701786300008, 41.822616272000076],
              [128.09102339800006, 41.84173655200006],
              [128.05764042200008, 41.849849752000054],
              [128.04782190000003, 41.863983256000026],
              [128.0399670820001, 41.87958953900004],
              [128.02043339100015, 41.96506235800008],
              [128.02146691900015, 41.979815979000065],
              [128.03459273300012, 41.993742778000055],
              [128.05464318900016, 41.99831614200009],
              [128.10053186000005, 41.99909128900002],
              [128.2619690350001, 42.032861837],
              [128.36377160700016, 42.02647979700005],
              [128.38712935400008, 42.02069203800009],
              [128.40759322100007, 42.008341370000025],
              [128.45399865800005, 42.01033091200007],
              [128.4883118090001, 41.9975151580001],
              [128.502367799, 41.996094055000086],
              [128.54370894400006, 42.00805714900007],
              [128.55332076100007, 42.00663604800006],
              [128.56437951700008, 42.00079661100007],
              [128.573681275, 42.00431060900003],
              [128.587737264, 42.019994406000095],
              [128.5975557870001, 42.02712575300005],
              [128.60789107300002, 42.03017466300007],
              [128.68251184100006, 42.025730489000054],
              [128.70928023300013, 42.03017466300007],
              [128.720959107, 42.047589621],
              [128.81707727100002, 42.043868918000086],
              [128.883171897, 42.03040885700007],
              [128.9034802650001, 42.02627309200001],
              [128.94006718000003, 42.03536814400006],
              [128.95484663900004, 42.075236511000114],
              [128.96383833800007, 42.08851735500012],
              [128.98502567600008, 42.092909852],
              [129.00890018800015, 42.09508026200008],
              [129.02657352700015, 42.10187571200005],
              [129.0533419200001, 42.122856344000056],
              [129.0634705, 42.13608551100005],
              [129.06471073400013, 42.153758850000045],
              [129.08848189400015, 42.14319102000006],
              [129.1055351160001, 42.14210581500008],
              [129.119797812, 42.14936635300005],
              [129.14801314300013, 42.173705953000066],
              [129.1776754160001, 42.19344635000003],
              [129.1963822840001, 42.209181824],
              [129.2042371020001, 42.214323629],
              [129.2111617430001, 42.219956360000126],
              [129.21426232900006, 42.225692444000074],
              [129.2093013920001, 42.23468414400013],
              [129.18687382000007, 42.236027731],
              [129.18077600100003, 42.24310740200012],
              [129.18335982300005, 42.25455373200002],
              [129.1921448170001, 42.259850566000054],
              [129.20289351500003, 42.26274444600004],
              [129.2111617430001, 42.267007752000026],
              [129.21477909300006, 42.27563771600005],
              [129.214158977, 42.28369923900006],
              [129.21612268100006, 42.29106313100006],
              [129.22800826000008, 42.29772939100006],
              [129.220670207, 42.30367218000008],
              [129.212401977, 42.30775461800009],
              [129.20372033700005, 42.31015757300004],
              [129.193901815, 42.31077769000011],
              [129.193901815, 42.31824493400005],
              [129.22614790900008, 42.31814158100009],
              [129.23627648900003, 42.32387766600006],
              [129.24227095600014, 42.33873464],
              [129.2403072520001, 42.34403147400003],
              [129.23420943300005, 42.34656361900004],
              [129.22862837800005, 42.35020680800001],
              [129.22800826000008, 42.35919850700007],
              [129.2311088460001, 42.367647603000066],
              [129.23606978400005, 42.374365540000085],
              [129.2430977790001, 42.378706361000056],
              [129.296634562, 42.387232971000074],
              [129.30376591000004, 42.389584249],
              [129.30707320200008, 42.407619324],
              [129.31544478400014, 42.42232126900011],
              [129.32650354000015, 42.42676544200002],
              [129.33787235600005, 42.414414775000054],
              [129.35213505000002, 42.42061594700006],
              [129.34376346800002, 42.42922007300008],
              [129.33859582500014, 42.43836680100007],
              [129.34014611800006, 42.4454723110001],
              [129.35213505000002, 42.44795277900006],
              [129.3630904540001, 42.445007223000076],
              [129.3720821540001, 42.43255320200008],
              [129.38624149600008, 42.42810902900008],
              [129.3954399010001, 42.43020192500005],
              [129.40618859900007, 42.435963847000025],
              [129.418797649, 42.44105397600002],
              [129.43409387200006, 42.44110565300012],
              [129.48246301300003, 42.410719910000054],
              [129.48887089100003, 42.40255503400003],
              [129.5170862230001, 42.39095367400007],
              [129.52339074700006, 42.38338307700003],
              [129.52680139200004, 42.37307362900013],
              [129.53517297400003, 42.36955963100009],
              [129.5453015550001, 42.37131663000007],
              [129.5541899010001, 42.37687184700006],
              [129.55946089700006, 42.3870004270001],
              [129.56028772000008, 42.39679311200008],
              [129.56318160000006, 42.40410532700007],
              [129.58767622900012, 42.411365866000025],
              [129.59449751800008, 42.42221791700008],
              [129.5956344, 42.435602112000126],
              [129.59170699100002, 42.44795277900006],
              [129.63346154900006, 42.44542063400009],
              [129.6711853440001, 42.43792755200006],
              [129.70332808500012, 42.44237172400007],
              [129.72885624200006, 42.47585805300007],
              [129.73361047400016, 42.511799011000036],
              [129.73144006400008, 42.550918071000055],
              [129.73650435400015, 42.58515370700006],
              [129.76306604000007, 42.606237692],
              [129.76306604000007, 42.61238718700007],
              [129.7462195230001, 42.615513611],
              [129.74156864400004, 42.62900116000007],
              [129.751077108, 42.642927958000044],
              [129.77670861800004, 42.647191264000114],
              [129.77226444600007, 42.66166066500004],
              [129.7793957930001, 42.67039398200002],
              [129.78756066900013, 42.67685353600008],
              [129.78652714100014, 42.68473419200011],
              [129.77453820900007, 42.693338318000045],
              [129.76440962700013, 42.6968523150001],
              [129.757588339, 42.70364776600006],
              [129.75562463400001, 42.722277120000015],
              [129.7572782800001, 42.73470530200008],
              [129.76130904200016, 42.74604827900008],
              [129.7735046800001, 42.76695139600004],
              [129.78952437400005, 42.79247955300009],
              [129.79500207600006, 42.80648386600008],
              [129.79903283700003, 42.83666290300009],
              [129.8341728110001, 42.907485454000025],
              [129.84151086400004, 42.91779490200004],
              [129.84667850800008, 42.92823354100007],
              [129.84760868300015, 42.95128123000005],
              [129.85174279800003, 42.96190073600012],
              [129.86311161300006, 42.968980408000036],
              [129.89329065000004, 42.97153839100004],
              [129.90703658100006, 42.976137593],
              [129.89773482300006, 42.978747253000094],
              [129.89008671100015, 42.982803854000096],
              [129.88409224500003, 42.98851409900006],
              [129.879751425, 42.9960330200001],
              [129.89070682800002, 42.999417827000016],
              [129.90920699100008, 43.00843536400005],
              [129.9206791590001, 43.010269878000074],
              [129.93411503100003, 43.00840952600005],
              [129.94155643700003, 43.00362945600007],
              [129.97173547400007, 42.97373464000013],
              [129.9813472900001, 42.96673248400005],
              [129.9957133380001, 42.96190073600012],
              [130.00821903500008, 42.96055714900005],
              [130.047286418, 42.96190073600012],
              [130.09431197200007, 42.976938578],
              [130.12149377400016, 42.98184784000004],
              [130.13358606000014, 42.97272695000005],
              [130.130485474, 42.95947194500006],
              [130.12252730300014, 42.94332306000008],
              [130.11157190000006, 42.92906036400008],
              [130.09875614500004, 42.92151560500004],
              [130.1404073490001, 42.90712371900004],
              [130.19384078000007, 42.90820892300003],
              [130.2390059820001, 42.902240296000016],
              [130.256472616, 42.8668936160001],
              [130.24220992100004, 42.782015076000036],
              [130.24303674300006, 42.743361105000034],
              [130.2626737870001, 42.7086087040001],
              [130.3171407480001, 42.66739674900002],
              [130.32478885900008, 42.650291850000045],
              [130.3930017500001, 42.606237692],
              [130.40395715400007, 42.6040672810001],
              [130.41274214700007, 42.604635722000054],
              [130.4204936120001, 42.60427398700004],
              [130.42772831200006, 42.59936472700012],
              [130.43000207500006, 42.59148407000008],
              [130.4263847250001, 42.5721054080001],
              [130.43124231000002, 42.561511739000125],
              [130.452533, 42.54934194000002],
              [130.46793257700006, 42.554897156000024],
              [130.47103316300002, 42.56975413000008],
              [130.4551168220001, 42.58515370700006],
              [130.46782922400007, 42.6003982540001],
              [130.484158976, 42.61001007100002],
              [130.5014189050001, 42.610785217000014],
              [130.516508423, 42.59936472700012],
              [130.5195056560001, 42.58859019000009],
              [130.52519006400013, 42.549238587],
              [130.53077111900006, 42.53048004200009],
              [130.5426566980001, 42.51053293900007],
              [130.5445170490001, 42.50629547200002],
              [130.546067343, 42.49528839100013],
              [130.54989139900016, 42.49037913100001],
              [130.55474898300008, 42.48761444100005],
              [130.55877974500004, 42.4827051810001],
              [130.57562626200001, 42.44573069300007],
              [130.58740848900004, 42.432010600000055],
              [130.60590865100005, 42.42061594700006],
              [130.6285429290001, 42.414802348000066],
              [130.6458028570001, 42.400875549],
              [130.65665490700007, 42.383253886],
              [130.66058231600005, 42.35919850700007],
              [130.66027225800013, 42.3339287320001],
              [130.662752726, 42.32057037400007],
              [130.67288130800006, 42.31113942500009],
              [130.69996178500003, 42.29511139500005],
              [130.695556806, 42.28900141200006],
              [130.66712883500009, 42.28309217300006],
              [130.63157671200008, 42.27439706800004],
              [130.616620711, 42.272318290000044],
              [130.60382311, 42.26326024000008],
              [130.59754438100003, 42.262780245000044],
              [130.598480665, 42.280951239000046],
              [130.5976668630001, 42.29193756700005],
              [130.59498131600003, 42.298163153000075],
              [130.5820418630001, 42.307928778000075],
              [130.56936639700007, 42.31525907200006],
              [130.5405013520001, 42.31837065700006],
              [130.5190525490001, 42.327602855000066],
              [130.5101895030001, 42.33577952100006],
              [130.48068389600007, 42.33975211600006],
              [130.46565258500004, 42.33475247000007],
              [130.46939604800002, 42.32207471500004],
              [130.45645952900009, 42.311768735000044],
              [130.44009806300005, 42.30912830600005],
              [130.43183884000007, 42.31812457600006],
              [130.41915868400008, 42.32439825900008],
              [130.40744972100003, 42.324577343000044],
              [130.40699303500003, 42.315741278000075],
              [130.40585371200007, 42.30711497600004],
              [130.39399883200008, 42.299952343000086],
              [130.38415748600005, 42.291194579000035],
              [130.38632246200007, 42.27765534100007],
              [130.38624108200008, 42.27065664300005],
              [130.3911238940001, 42.264105536000045],
              [130.399261915, 42.26316966400009],
              [130.40585371200007, 42.26080963700008],
              [130.40601647200003, 42.24957916900007],
              [130.4008895190001, 42.24249909100007],
              [130.39332116000003, 42.24408600500004],
              [130.37818188000006, 42.257854715000065],
              [130.3679918690001, 42.25568678900004],
              [130.360655178, 42.243663939000044],
              [130.36983713100005, 42.23201097700007],
              [130.35882866500003, 42.22927234200006],
              [130.35150542300005, 42.216082705000076],
              [130.33505739600002, 42.213999164000086],
              [130.33064466300004, 42.191508042000066],
              [130.3187699140001, 42.18473039200006],
              [130.30702563300008, 42.18315395900004],
              [130.30815993200008, 42.197594767000055],
              [130.31563515800008, 42.21888303900005],
              [130.307417578, 42.23629503800004],
              [130.29418223200003, 42.23704468100004],
              [130.25136340200004, 42.20529093600004],
              [130.2289856120001, 42.18245195500003],
              [130.21493574300007, 42.17462799700007],
              [130.20227391700007, 42.17355132400007],
              [130.20428617100004, 42.159644194000066],
              [130.19931074300007, 42.10130442900004],
              [130.1938582690001, 42.10097890800006],
              [130.18531334700003, 42.10390859600005],
              [130.17392011800007, 42.09878164300005],
              [130.16024824300007, 42.08510976800005],
              [130.16358483200008, 42.08348216400009],
              [130.16659589900007, 42.07709381700005],
              [130.1594319830001, 42.07283755200007],
              [130.15010820100008, 42.074103465000064],
              [130.13319825000008, 42.08471868200007],
              [130.12006878, 42.090081352000084],
              [130.09277164500008, 42.08981062400005],
              [130.07304050900007, 42.07845867200007],
              [130.0679550100001, 42.05941382700007],
              [130.067014707, 42.05189864700009],
              [130.05222157100002, 42.050364513000034],
              [130.04971177100003, 42.042287515000055],
              [130.04490766100002, 42.03597565800004],
              [130.03646983500005, 42.01162370600008],
              [130.033879253, 41.995513988000084],
              [130.02681671900007, 41.992699522000066],
              [130.01495011500003, 42.014403703000085],
              [130.00288397100007, 42.01091176300008],
              [130.00129707400004, 41.99046615000009],
              [129.98218834700003, 41.98265208500004],
              [129.98902428500003, 41.978176174000055],
              [129.9941512380001, 41.97304922100005],
              [130.00269616000003, 41.962225653000075],
              [129.99293053500003, 41.95978424700007],
              [129.98560631600003, 41.95526764500005],
              [129.97486412900003, 41.94163646000004],
              [129.97828209700003, 41.943793036000045],
              [129.97567793100006, 41.93398672100005],
              [129.971039259, 41.92206452000005],
              [129.96859785200002, 41.91746653900009],
              [129.96469160200002, 41.89874909100007],
              [129.954437696, 41.89203522300005],
              [129.94678708800006, 41.89493518300009],
              [129.93739352300008, 41.903897810000046],
              [129.91362039900002, 41.91119524800007],
              [129.89674003200003, 41.904262980000055],
              [129.89039147200003, 41.88300202000005],
              [129.88339277400007, 41.857407945000034],
              [129.88453209700003, 41.82416413000004],
              [129.86965230500005, 41.79145665300007],
              [129.85517127100002, 41.78179188000007],
              [129.8524602230001, 41.76492342800009],
              [129.8428127210001, 41.75878307800008],
              [129.82654599800003, 41.77844638800008],
              [129.81331498300005, 41.77773323300005],
              [129.77475988900005, 41.75941719500008],
              [129.76278730600006, 41.73102448100008],
              [129.74976647200003, 41.69627513200004],
              [129.741360546, 41.68401763900005],
              [129.715018611, 41.67533690000005],
              [129.6908225640001, 41.64971577300008],
              [129.6831849990001, 41.617720114000065],
              [129.669408878, 41.57595944900004],
              [129.64879790700002, 41.549402728000075],
              [129.6606551440001, 41.52594635600008],
              [129.65772304300003, 41.509238682000046],
              [129.65272983900002, 41.49412400400007],
              [129.6594031620001, 41.464647435000074],
              [129.6816777570001, 41.44308426500004],
              [129.70166987900006, 41.42866567100003],
              [129.71460278400002, 41.419646010000065],
              [129.7360557290001, 41.42128622800004],
              [129.7441507960001, 41.406962770000064],
              [129.7581839720001, 41.39259418000006],
              [129.76929772200003, 41.38617584800005],
              [129.77564537900003, 41.38548411700003],
              [129.79110761800007, 41.38776276200008],
              [129.79664147200003, 41.38617584800005],
              [129.80616295700008, 41.37604401200008],
              [129.8051863940001, 41.37278880400004],
              [129.79989668100006, 41.36859772300005],
              [129.79664147200003, 41.355454820000034],
              [129.79468834700003, 41.35228099200003],
              [129.78687584700003, 41.330064195000034],
              [129.7861434250001, 41.32477448100008],
              [129.770355665, 41.31513092700004],
              [129.759125196, 41.29287344000005],
              [129.719574415, 41.16693756700005],
              [129.7119246750001, 41.12262604400007],
              [129.72828209700003, 41.085150458000044],
              [129.722015821, 41.07184479400007],
              [129.71981855600006, 41.05621979400007],
              [129.72079511800007, 41.02366771000004],
              [129.72828209700003, 40.97870514500005],
              [129.73251386800007, 40.96893952000005],
              [129.750824415, 40.95172760600008],
              [129.76489138300008, 40.94441440600008],
              [129.755574368, 40.93896967200004],
              [129.74922940500005, 40.91701046800006],
              [129.75299654700007, 40.90993974300005],
              [129.73427207300006, 40.89110180800009],
              [129.73734311300007, 40.87145578500008],
              [129.7252188340001, 40.847817701000054],
              [129.71655794700007, 40.834585581000056],
              [129.70608701000003, 40.83566146800007],
              [129.6983567100001, 40.84560622300006],
              [129.6845596290001, 40.84182943600007],
              [129.66285241000003, 40.838771877000056],
              [129.6439220860001, 40.84161846200004],
              [129.626166796, 40.83831245500005],
              [129.60980304500004, 40.84092948700004],
              [129.5979675540001, 40.83854114300004],
              [129.57177252600002, 40.83971629700005],
              [129.55394109300005, 40.82893169000005],
              [129.55105095300007, 40.810117421000086],
              [129.531997338, 40.80727731200005],
              [129.51808142200002, 40.79546708200007],
              [129.50624007600004, 40.79207435600006],
              [129.47652919900008, 40.79387779800004],
              [129.42695414600007, 40.78129564300008],
              [129.38918690000003, 40.76075956100004],
              [129.3516865790001, 40.74534319300005],
              [129.3397564720001, 40.73443021400004],
              [129.3278297280001, 40.71812813200006],
              [129.31121036700006, 40.68747198900007],
              [129.3032332690001, 40.67365143400008],
              [129.29615319100003, 40.67625560100004],
              [129.28663170700008, 40.683579820000034],
              [129.27791677000005, 40.69803721400007],
              [129.27013756500003, 40.70798012800009],
              [129.2531567970001, 40.709131856000056],
              [129.233482084, 40.70571354900005],
              [129.2177031010001, 40.69635326300005],
              [129.2123927670001, 40.68595193600004],
              [129.20642642100006, 40.67554645700005],
              [129.2063864270001, 40.67008890900007],
              [129.20699478900008, 40.66363163400007],
              [129.2017090270001, 40.65620715300008],
              [129.2003622960001, 40.65075309000008],
              [129.1977645190001, 40.638006903000075],
              [129.1933699880001, 40.63263580900008],
              [129.19052168100006, 40.62250397300005],
              [129.18704974700006, 40.61653527100009],
              [129.17916533900006, 40.60959949800008],
              [129.17455523, 40.603660165000065],
              [129.17367597700002, 40.593451239000046],
              [129.17261803500003, 40.56891510600008],
              [129.16123496800003, 40.56554866300007],
              [129.15531158300007, 40.556634590000044],
              [129.150899083, 40.54589673600009],
              [129.1150655240001, 40.511164886000074],
              [129.07756443800008, 40.47256500300006],
              [129.03011562100005, 40.47397022500007],
              [128.975812174, 40.45993303800009],
              [128.899755131, 40.398164928000085],
              [128.8605320050001, 40.37184836700004],
              [128.8305335010001, 40.367387326000085],
              [128.8135672310001, 40.35497991900007],
              [128.78097427500006, 40.34702548300004],
              [128.76404237400004, 40.34653026500007],
              [128.75200487400002, 40.335095472000035],
              [128.72164470500002, 40.338947061000056],
              [128.68780752700002, 40.331196581000086],
              [128.66966869500004, 40.310770897000054],
              [128.6566554310001, 40.31076253100008],
              [128.655340282, 40.32017698400006],
              [128.63648864200002, 40.31321656500006],
              [128.61894776000008, 40.29733080700004],
              [128.61644650800008, 40.27144281200009],
              [128.6287917410001, 40.266008756000076],
              [128.65672182800006, 40.25714038800004],
              [128.66062985200006, 40.24772150600006],
              [128.66777968400004, 40.24030859800007],
              [128.66259900900002, 40.225413382000056],
              [128.6645613940001, 40.201239325000074],
              [128.65093108100007, 40.19714769700005],
              [128.64184730600005, 40.19069285100005],
              [128.63471320600001, 40.18423881700005],
              [128.6288752810001, 40.180265716000065],
              [128.62173228900008, 40.180755529000066],
              [128.608102916, 40.18570198900005],
              [128.5886112190001, 40.186672799000064],
              [128.57760718600002, 40.180211410000084],
              [128.54319885000007, 40.16676701200004],
              [128.53609346200005, 40.15137544600009],
              [128.52768092400004, 40.143423720000044],
              [128.510189157, 40.135455971000056],
              [128.47979942000006, 40.134748641000044],
              [128.4662663250001, 40.124373526000056],
              [128.448562992, 40.10950008800006],
              [128.434946029, 40.104001888000084],
              [128.41138756600003, 40.09638092700004],
              [128.3918439050001, 40.09957747700008],
              [128.364764841, 40.096890115000065],
              [128.33776517800004, 40.06704791100009],
              [128.32775258900006, 40.02821641100007],
              [128.302093946, 40.03343333500004],
              [128.280132052, 40.06547653600006],
              [128.2634436310001, 40.07710499800004],
              [128.23632157100008, 40.06790429300008],
              [128.22783723700002, 40.05620603700004],
              [128.2343856130001, 40.029364325000074],
              [128.2251082690001, 40.02757396000004],
              [128.20321699300007, 40.02960846600007],
              [128.1933699880001, 40.029364325000074],
              [128.18238366000003, 40.02610911700009],
              [128.16431725400003, 40.01797109600005],
              [128.15512129, 40.01630280200004],
              [128.146820509, 40.01829661700009],
              [128.1435653000001, 40.02285390800006],
              [128.13941491000003, 40.027329820000034],
              [128.0068465500001, 40.04515208500004],
              [128.002289259, 40.04047272300005],
              [128.0009871750001, 40.02594635600008],
              [127.99781334700003, 40.020412502000056],
              [127.98975670700008, 40.014837958000044],
              [127.97982832100001, 40.01056549700007],
              [127.97055097700002, 40.00885651200008],
              [127.96371504000001, 40.00409577000005],
              [127.94727623800009, 39.981634833000044],
              [127.94003339900007, 39.97475820500006],
              [127.93026777400007, 39.971909898000035],
              [127.90665933500009, 39.983942366000065],
              [127.89103838900007, 39.96122529000007],
              [127.89126291000002, 39.94383111700006],
              [127.88404381600003, 39.90208567900004],
              [127.87460371200007, 39.89280833500004],
              [127.78183027400007, 39.88540273600006],
              [127.79639733200008, 39.87563711100006],
              [127.79403730600006, 39.865668036000045],
              [127.7624384720001, 39.85353432000005],
              [127.72738250700002, 39.85718861400005],
              [127.69574959500005, 39.84820085000007],
              [127.67962851700008, 39.816438696000034],
              [127.66329100900009, 39.80680065900009],
              [127.6486994060001, 39.82089715600006],
              [127.62374852100004, 39.83093531800006],
              [127.60718834700003, 39.810248114000046],
              [127.59302819100003, 39.80621979400007],
              [127.57601972700002, 39.79629140800006],
              [127.56185957100001, 39.78400299700007],
              [127.54940839900007, 39.761053778000075],
              [127.52084394600001, 39.746975002000056],
              [127.51441491000003, 39.73859284100007],
              [127.51246178500003, 39.73110586100006],
              [127.50375410200002, 39.71552155200004],
              [127.50131269600001, 39.70722077000005],
              [127.50171959700003, 39.698472398000035],
              [127.50635826900009, 39.68378327000005],
              [127.50855553500003, 39.66006094000005],
              [127.51221764400009, 39.64948151200008],
              [127.51856530000009, 39.64484284100007],
              [127.52808678500003, 39.645819403000075],
              [127.55274498800009, 39.636786200000074],
              [127.57032311300009, 39.61786530200004],
              [127.574554884, 39.595038153000075],
              [127.53676992700002, 39.552012464000086],
              [127.520439312, 39.51046513300008],
              [127.53541100400003, 39.44375234600005],
              [127.56299889400009, 39.343736070000034],
              [127.56210371200007, 39.31622955900008],
              [127.55445397200003, 39.305975653000075],
              [127.54346764400009, 39.301947333000044],
              [127.53183027400007, 39.305121161000045],
              [127.521820509, 39.31622955900008],
              [127.52059980600006, 39.329413153000075],
              [127.52694746200007, 39.34422435100004],
              [127.54224694100003, 39.37148672100005],
              [127.50757897200003, 39.40924713700008],
              [127.50399824300007, 39.42283763200004],
              [127.49512780000009, 39.43341705900008],
              [127.48292076900009, 39.43699778900009],
              [127.46998131600003, 39.429754950000074],
              [127.44044030000009, 39.407863674000055],
              [127.43808027400007, 39.405178127000056],
              [127.43100019600001, 39.39728424700007],
              [127.42554772200003, 39.39252350500004],
              [127.37842858200008, 39.37885163000004],
              [127.37842858200008, 39.37148672100005],
              [127.38990319100003, 39.36701080900008],
              [127.41407311300009, 39.36180247600004],
              [127.42554772200003, 39.357123114000046],
              [127.437836134, 39.36424388200004],
              [127.45386803500003, 39.36798737200007],
              [127.46753991000003, 39.36383698100008],
              [127.47339928500003, 39.34756094000005],
              [127.46680748800009, 39.34015534100007],
              [127.43539472700002, 39.33478424700007],
              [127.42554772200003, 39.33047109600005],
              [127.420258009, 39.336371161000045],
              [127.41456139400009, 39.34064362200007],
              [127.40829511800007, 39.34324778900009],
              [127.40137780000009, 39.34414297100005],
              [127.39193769600001, 39.341864325000074],
              [127.39267011800007, 39.33641185100004],
              [127.39698326900009, 39.32965729400007],
              [127.39828535200002, 39.32367584800005],
              [127.38672936300009, 39.29718659100007],
              [127.37842858200008, 39.26898834800005],
              [127.3720298830001, 39.24042604300007],
              [127.38290449300007, 39.221991278000075],
              [127.39340254000001, 39.20172760600008],
              [127.408539259, 39.19330475500004],
              [127.42017662900003, 39.18919505400004],
              [127.44125410200002, 39.17084381700005],
              [127.45224043100006, 39.16596100500004],
              [127.47193444100003, 39.16828034100007],
              [127.47608483200008, 39.177069403000075],
              [127.47364342500009, 39.187160549000055],
              [127.47339928500003, 39.19330475500004],
              [127.49130293100006, 39.19489166900007],
              [127.51172936300009, 39.15643952000005],
              [127.53174889400009, 39.146144924000055],
              [127.60694420700008, 39.152044989000046],
              [127.63168379000001, 39.146144924000055],
              [127.64307701900009, 39.13857656500005],
              [127.65170332100001, 39.12929922100005],
              [127.66138756600003, 39.12148672100005],
              [127.67562910200002, 39.11815013200004],
              [127.74415123800009, 39.11859772300005],
              [127.75928795700008, 39.11701080900008],
              [127.76962324300007, 39.10919830900008],
              [127.79257246200007, 39.07754140800006],
              [127.82374108200008, 39.043036200000074],
              [127.83033287900003, 39.032863674000055],
              [127.83651777400007, 39.01850006700005],
              [127.85157311300009, 39.00141022300005],
              [127.88550866000003, 38.97418854400007],
              [127.88868248800009, 38.961371161000045],
              [127.892914259, 38.957464911000045],
              [127.90219160200002, 38.96393463700008],
              [127.90870201900009, 38.96718984600005],
              [127.91431725400003, 38.964178778000075],
              [127.91822350400003, 38.95774974200009],
              [127.92147871200007, 38.94232819200005],
              [127.92628014400009, 38.934475002000056],
              [127.93384850400003, 38.92865631700005],
              [127.94361412900003, 38.92641836100006],
              [127.96176191500001, 38.91791413000004],
              [127.99545332100001, 38.87531159100007],
              [128.0146590500001, 38.85814036700009],
              [128.091156446, 38.843736070000034],
              [128.21021569100003, 38.727728583000044],
              [128.2251082690001, 38.73232656500005],
              [128.270355665, 38.751654364000046],
              [128.28280683700007, 38.755072333000044],
              [128.31324303500003, 38.717230536000045],
              [128.32105553500003, 38.71141185100004],
              [128.33814537900003, 38.703558661000045],
              [128.3476668630001, 38.69672272300005],
              [128.35962975400003, 38.67865631700005],
              [128.35995512000005, 38.67536197700012],
              [128.3613387380001, 38.66071198100008],
              [128.3603621750001, 38.64276764500005],
              [128.364593946, 38.62474192900004],
              [128.36491946700005, 38.624335028000075],
            ],
          ],
          [
            [
              [124.92674098600003, 39.60478642900006],
              [124.92222659900006, 39.59828886200006],
              [124.909673601, 39.593553532000044],
              [124.92025365200004, 39.57227815400006],
              [124.93360925600007, 39.55054304500004],
              [124.9120923160001, 39.54080307800007],
              [124.88318229400011, 39.52747023900008],
              [124.861664259, 39.50763580900008],
              [124.84265555800005, 39.50516249800006],
              [124.81856313900005, 39.495444054000075],
              [124.83692719500004, 39.52093903000008],
              [124.84981631800008, 39.516533791000086],
              [124.85697023600005, 39.52789893900007],
              [124.84277262900002, 39.53842577900008],
              [124.84500731600008, 39.54317623500009],
              [124.85658815600004, 39.54422793900005],
              [124.8570495560001, 39.548302525000054],
              [124.8597383010001, 39.553138689000036],
              [124.85440967, 39.55657703300005],
              [124.85447530500005, 39.57375418600009],
              [124.87052236500006, 39.580933634000075],
              [124.869706328, 39.59565681500004],
              [124.88176886300005, 39.60386948800004],
              [124.88047098200002, 39.612454772000035],
              [124.89919306000002, 39.61412435300008],
              [124.92674098600003, 39.60478642900006],
            ],
          ],
          [
            [
              [124.88347415500004, 38.528550523000035],
              [124.90040123800009, 38.50531647300005],
              [124.90398196700005, 38.49437083500004],
              [124.86109459700003, 38.50385163000004],
              [124.84083092500009, 38.51068756700005],
              [124.82203209700003, 38.522365627000056],
              [124.79948978000004, 38.50849030200004],
              [124.79029381600003, 38.51740143400008],
              [124.79444420700008, 38.53392161700009],
              [124.83220462300005, 38.55304596600007],
              [124.84424889400009, 38.55516185100004],
              [124.84937584700003, 38.54588450700004],
              [124.86573326900009, 38.54148997600004],
              [124.87720787900003, 38.536322333000044],
              [124.88347415500004, 38.528550523000035],
            ],
          ],
          [
            [
              [125.32878665500004, 37.76666901200008],
              [125.33773847700002, 37.76870351800005],
              [125.31275475400003, 37.741400458000044],
              [125.29574629000001, 37.72760651200008],
              [125.26937910200002, 37.714097398000035],
              [125.26099694100003, 37.70742422100005],
              [125.24683678500003, 37.69985586100006],
              [125.22632897200003, 37.69635651200008],
              [125.22055097700002, 37.70376211100006],
              [125.25017337300005, 37.731675523000035],
              [125.26433353000004, 37.737209377000056],
              [125.27458743600005, 37.73383209800005],
              [125.27711022200003, 37.74046458500004],
              [125.27947024800005, 37.74941640800006],
              [125.28484134200005, 37.74949778900009],
              [125.287445509, 37.75067780200004],
              [125.28874759200005, 37.75364817900004],
              [125.29273522200003, 37.75543854400007],
              [125.29932701900009, 37.75617096600007],
              [125.32878665500004, 37.76666901200008],
            ],
          ],
          [
            [
              [125.14771569100003, 37.785589911000045],
              [125.14283287900003, 37.794134833000044],
              [125.14136803500003, 37.79950592700004],
              [125.14649498800009, 37.80223216400009],
              [125.16618899800005, 37.813706773000035],
              [125.18384850400003, 37.81883372600004],
              [125.18848717500009, 37.81907786700009],
              [125.19141686300009, 37.81549713700008],
              [125.19288170700008, 37.81110260600008],
              [125.19027754000001, 37.809027411000045],
              [125.18506920700008, 37.80817291900007],
              [125.17172285200002, 37.79718659100007],
              [125.15626061300009, 37.78668854400007],
              [125.14771569100003, 37.785589911000045],
            ],
          ],
          [
            [
              [125.03044681100005, 37.83616771000004],
              [125.04078209700003, 37.83445872600004],
              [125.04460696700005, 37.82461172100005],
              [125.04175866000003, 37.817287502000056],
              [125.03956139400009, 37.817613023000035],
              [125.03638756600003, 37.81745026200008],
              [125.02564537900003, 37.808294989000046],
              [125.01587975400003, 37.80565013200004],
              [125.00505618600005, 37.805568752000056],
              [124.99773196700005, 37.80841705900008],
              [124.99781334700003, 37.81305573100008],
              [125.00261478000004, 37.81541575700004],
              [125.00684655000009, 37.81928131700005],
              [125.01197350400003, 37.82184479400007],
              [125.01905358200008, 37.820298570000034],
              [125.02540123800009, 37.81785716400009],
              [125.02849368600005, 37.81883372600004],
              [125.02947024800005, 37.82298411700009],
              [125.03012129000001, 37.825100002000056],
              [125.02784264400009, 37.83002350500004],
              [125.03044681100005, 37.83616771000004],
            ],
          ],
          [
            [
              [124.68767337300005, 39.52716705900008],
              [124.69361973900004, 39.53507889100007],
              [124.70470809100004, 39.53707637000008],
              [124.70777906, 39.53039912400004],
              [124.7077464250001, 39.519317028000046],
              [124.70484459700003, 39.50873444200005],
              [124.69776451900009, 39.50259023600006],
              [124.68458684400002, 39.50324259200005],
              [124.68014891200005, 39.507725708000066],
              [124.68376890000002, 39.51609442100005],
              [124.68197362300009, 39.52117962300008],
              [124.68767337300005, 39.52716705900008],
            ],
          ],
          [
            [
              [124.68702233200008, 39.54474518400008],
              [124.67554772200003, 39.53851959800005],
              [124.66163170700008, 39.538397528000075],
              [124.64478600400003, 39.54767487200007],
              [124.60352623800009, 39.53851959800005],
              [124.60035241000003, 39.53620026200008],
              [124.59587649800005, 39.53790924700007],
              [124.59742272200003, 39.544582424000055],
              [124.60466556100005, 39.549261786000045],
              [124.61426842500009, 39.55341217700004],
              [124.63086998800009, 39.56509023600006],
              [124.63502037900003, 39.56395091400009],
              [124.648773634, 39.56525299700007],
              [124.67383873800009, 39.57062409100007],
              [124.69125410200002, 39.569647528000075],
              [124.69809004000001, 39.56289297100005],
              [124.695648634, 39.55377838700008],
              [124.68702233200008, 39.54474518400008],
            ],
          ],
          [
            [
              [124.596039259, 39.43024323100008],
              [124.59310957100001, 39.43903229400007],
              [124.59286543100006, 39.44680410400008],
              [124.60173587300005, 39.449326890000066],
              [124.61255944100003, 39.457139390000066],
              [124.61443118600005, 39.449204820000034],
              [124.61508222700002, 39.44749583500004],
              [124.61784915500004, 39.44428131700005],
              [124.6190698580001, 39.43301015800006],
              [124.60661868600005, 39.42804596600007],
              [124.60206139400009, 39.427394924000055],
              [124.596039259, 39.43024323100008],
            ],
          ],
          [
            [
              [124.21465084700003, 39.80724202500005],
              [124.21927271100003, 39.81092158300004],
              [124.21757453200007, 39.81486426400005],
              [124.22027210100009, 39.81526030100008],
              [124.22311598300007, 39.81678833500007],
              [124.22099393600001, 39.81897397200004],
              [124.22342567800001, 39.81998717400006],
              [124.22706541500008, 39.82129830300005],
              [124.23001748700005, 39.82117193800008],
              [124.231895818, 39.81919856300004],
              [124.23443281900006, 39.817628324000054],
              [124.23586068300006, 39.813481668000065],
              [124.23988654900006, 39.81262262000007],
              [124.23958636300006, 39.80983080200008],
              [124.23956104000001, 39.80765715500007],
              [124.24278750000008, 39.80732139500009],
              [124.24275057200009, 39.80463284100006],
              [124.24162706000004, 39.80185608100004],
              [124.23783526200009, 39.80096738200007],
              [124.23525982000001, 39.79838581100006],
              [124.23039032100007, 39.79826061700004],
              [124.22739722100005, 39.794640480000055],
              [124.22601537000003, 39.79142286700005],
              [124.22318937200009, 39.79155672300004],
              [124.22120143400002, 39.79383960200005],
              [124.2160984090001, 39.794711222000046],
              [124.21166218600001, 39.79515740800008],
              [124.21153335300005, 39.79557264600004],
              [124.21131598900001, 39.799505011000065],
              [124.21258842700001, 39.80404919600005],
              [124.21465084700003, 39.80724202500005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bhutan',
        iso3: 'BTN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [90.4752315670001, 28.07234446300002],
            [90.49259484900011, 28.074411519000094],
            [90.51006148300007, 28.074101461000012],
            [90.57527714000008, 28.06583323200006],
            [90.59739465400008, 28.07058746400004],
            [90.62188928300003, 28.0729645790001],
            [90.65103479000004, 28.086994731000104],
            [90.66746789600012, 28.090327860000016],
            [90.6839010010001, 28.087072245000044],
            [90.7268957930001, 28.06169911800005],
            [90.75527753600005, 28.055173215000096],
            [90.78870080600007, 28.047488098000073],
            [90.85091923100009, 28.044025777000044],
            [90.90952030400007, 28.032656963000036],
            [90.96057662000004, 27.99472646100004],
            [90.97514937400013, 27.982091573],
            [91.00884240800008, 27.966769512000056],
            [91.05194055200008, 27.96279042600007],
            [91.09255822800003, 27.97167877200006],
            [91.11942997200003, 27.99472646100004],
            [91.11963667900005, 27.994881490000083],
            [91.13379602000003, 28.01410512300002],
            [91.17586063600004, 28.057487488000092],
            [91.19467085800005, 28.07058746400004],
            [91.2206124270001, 28.07487660700012],
            [91.24614058500003, 28.071465963],
            [91.26970503800004, 28.072861227000075],
            [91.29016890500003, 28.0914130660001],
            [91.3095992430001, 28.056402283000082],
            [91.34143192600004, 28.03056406700007],
            [91.41884322100009, 27.99472646100004],
            [91.43648287100012, 27.989375107000015],
            [91.44643843600005, 27.986354879000075],
            [91.4609078370001, 27.98436533600004],
            [91.49749475100003, 27.98408111600004],
            [91.53749231000012, 27.969353333000058],
            [91.57862675000007, 27.96470245400009],
            [91.6006409100001, 27.959276429000013],
            [91.62172489400012, 27.950723979000074],
            [91.63795129500011, 27.93974273700009],
            [91.65283410700005, 27.91674672500004],
            [91.64890669800008, 27.897213033000057],
            [91.6371244710001, 27.87724009300011],
            [91.6283394780001, 27.852693787000035],
            [91.56435452404213, 27.85137236654151],
            [91.5660232169979, 27.821073950502466],
            [91.60533558693375, 27.810658168996827],
            [91.63576961127859, 27.78252481766623],
            [91.6349570594208, 27.746570816190285],
            [91.62668583200013, 27.716423035000034],
            [91.57986698400003, 27.65797699000005],
            [91.57325240100005, 27.619710592000033],
            [91.59505985500004, 27.54638173400012],
            [91.60446496600008, 27.53214487700005],
            [91.63288700400005, 27.51165517200009],
            [91.6416719980001, 27.49496368400004],
            [91.65738163300011, 27.479150696000048],
            [91.6802226160001, 27.47284617100003],
            [91.70492395000008, 27.468763733000046],
            [91.72704146300003, 27.46000457700005],
            [91.72709172100008, 27.45994159900009],
            [91.77955453390229, 27.45647526576099],
            [91.8162322069483, 27.4613571100768],
            [91.8565776472989, 27.46623873822671],
            [91.90059085495413, 27.459729852655357],
            [91.96330611200011, 27.468918763000076],
            [91.97508833800003, 27.472432760000018],
            [92.02359761663678, 27.446779847112282],
            [92.08484908100013, 27.30422597300013],
            [92.08877648900011, 27.292340394000078],
            [92.08185184800004, 27.2751321410001],
            [92.05063928300012, 27.25141265900008],
            [92.03678999800007, 27.236478170000012],
            [92.03317264800012, 27.227434794000047],
            [92.02996871000005, 27.208469544000096],
            [92.02707482900013, 27.199839580000074],
            [92.02149377500012, 27.19182973300009],
            [92.00847131400008, 27.179479065000024],
            [92.00578806200014, 27.1761123430001],
            [92.00299361200007, 27.172606100000067],
            [91.99586226400004, 27.158033346000096],
            [91.99079797400009, 27.140773418000023],
            [91.9879040940001, 27.122273255],
            [91.98769738800013, 27.104031474000024],
            [91.99989302600005, 27.071526998000095],
            [92.04970910700007, 27.026826885000062],
            [92.06696903500006, 26.994942526000088],
            [92.06696903500006, 26.994839172000056],
            [92.08391890500008, 26.937323303000127],
            [92.08037091600005, 26.921570891000087],
            [92.07275679500003, 26.88776560500007],
            [92.03585982200013, 26.85484771800013],
            [91.97508833800003, 26.84663116500009],
            [91.9574149980001, 26.85427927700006],
            [91.92568566900007, 26.878670553000106],
            [91.90821903500006, 26.885181784000068],
            [91.89312951700003, 26.881357727000122],
            [91.89550663300008, 26.868283590000075],
            [91.89550663300008, 26.853504131000065],
            [91.87400923700005, 26.84430572500007],
            [91.88589481600008, 26.830869853000095],
            [91.88692834500006, 26.814436747000045],
            [91.8786601160001, 26.80301625600005],
            [91.8630538330001, 26.80477325500003],
            [91.8524084880001, 26.818519185000056],
            [91.8495146080001, 26.834745586000068],
            [91.84393355300006, 26.849370015000133],
            [91.82512333200009, 26.858465068],
            [91.79525435400006, 26.853504131000065],
            [91.73158898900004, 26.816193746000025],
            [91.70213342300013, 26.803481344000076],
            [91.6537642830001, 26.797951965000053],
            [91.63795129500011, 26.798985494000036],
            [91.5937162680001, 26.81076772100006],
            [91.5756295170001, 26.81014760300009],
            [91.53935266200011, 26.798830465000023],
            [91.52064579300003, 26.79759023000007],
            [91.50741662600007, 26.80802887],
            [91.4844722900001, 26.852728984000052],
            [91.47506717900006, 26.86554473900013],
            [91.46059777800014, 26.869368795000057],
            [91.42018680900003, 26.871539205000047],
            [91.4063375240001, 26.869523824000012],
            [91.38845747900012, 26.858465068],
            [91.37812219300008, 26.84280710800006],
            [91.37006066900011, 26.824668681000034],
            [91.35838179600006, 26.806168519],
            [91.34556604000005, 26.79469635000008],
            [91.33006311000014, 26.785497945000074],
            [91.31321659300005, 26.77867665700002],
            [91.29657678200005, 26.77459421800002],
            [91.27600956200007, 26.77407745400008],
            [91.26195357300003, 26.779038392000032],
            [91.23249800600013, 26.795161438000022],
            [91.19818485600013, 26.80234446200005],
            [91.12707808500011, 26.800897522000056],
            [91.09193811100005, 26.80477325500003],
            [91.06206913300014, 26.804566549000057],
            [91.01278080700007, 26.784348086000065],
            [91.00739546800008, 26.78213897700006],
            [90.94449258000003, 26.778869550000096],
            [90.71707727100011, 26.767049459000063],
            [90.58778283800007, 26.78007192000011],
            [90.4752315670001, 26.832420146000047],
            [90.38262740100004, 26.891796367000055],
            [90.34883101400004, 26.89665395100009],
            [90.32857385300014, 26.890659485000057],
            [90.31420780500014, 26.88037587500007],
            [90.30087528500013, 26.868283590000075],
            [90.28444218000004, 26.857069804000034],
            [90.26599369300004, 26.851592103000044],
            [90.22914839700013, 26.852884013000093],
            [90.21090661700009, 26.85148875000003],
            [90.17742028900005, 26.832058410000045],
            [90.15220218900004, 26.771752014000057],
            [90.12719079600004, 26.75139150000011],
            [90.0891569420001, 26.741728008000095],
            [89.97526208500005, 26.73185780900009],
            [89.91211348500008, 26.716716614000077],
            [89.89040938400007, 26.714856262000083],
            [89.88028080200013, 26.71625152600008],
            [89.85992028800013, 26.7218842570001],
            [89.85870063400006, 26.722056524000052],
            [89.85077355900012, 26.72317616800005],
            [89.84700118000012, 26.724829814000103],
            [89.83904301000013, 26.731237691000032],
            [89.83496057100012, 26.73154775000002],
            [89.82974125100003, 26.727620341000048],
            [89.82767419500004, 26.722452698000055],
            [89.82726078300004, 26.7179051720001],
            [89.8267440190001, 26.715683085000094],
            [89.8267956950001, 26.71351267500002],
            [89.82524540200006, 26.70767323900013],
            [89.82209314000005, 26.70100697900004],
            [89.81728723200013, 26.6962010700001],
            [89.81366988200006, 26.696149394000102],
            [89.80405806500005, 26.699766744000087],
            [89.80007898000014, 26.700490214000084],
            [89.76028812700014, 26.700180156],
            [89.75466966300013, 26.700988568000113],
            [89.73873905400006, 26.703280742000047],
            [89.68515059500004, 26.72457143100003],
            [89.66323978700007, 26.725501607000083],
            [89.6283065180001, 26.71253082300005],
            [89.60980635600004, 26.712220765000083],
            [89.59750736500013, 26.720954081000045],
            [89.61347538300004, 26.748549296000036],
            [89.61135664900007, 26.76596425400008],
            [89.5860868740001, 26.784051005],
            [89.54650272600003, 26.79753855400004],
            [89.50541996200008, 26.80368804900003],
            [89.44289148000007, 26.797021789000027],
            [89.40733809400012, 26.81340321900005],
            [89.36889455700003, 26.837358593000076],
            [89.34165734900012, 26.854330953000087],
            [89.3001611730001, 26.844409078000083],
            [89.28636356600009, 26.84497751900004],
            [89.27359948700007, 26.84389231400006],
            [89.26295414200013, 26.836347555000103],
            [89.25261885600008, 26.826787415000084],
            [89.24083662900011, 26.819759420000096],
            [89.21282800300008, 26.813041484000067],
            [89.18461267100014, 26.81056101500009],
            [89.12807865500008, 26.813454895000078],
            [89.0965043540001, 26.821413066000034],
            [89.08244836400007, 26.836037496000117],
            [89.07433516500004, 26.856398010000035],
            [89.06069258700006, 26.88146108000005],
            [89.04487959900007, 26.897119039000117],
            [89.02157352700004, 26.912673645000027],
            [88.99661381100003, 26.92275054900007],
            [88.97532312000004, 26.921717021000077],
            [88.96581465700007, 26.915464173000103],
            [88.95454919500008, 26.91262196900003],
            [88.94276696800011, 26.913707174000123],
            [88.9323283280001, 26.9192365520001],
            [88.92530033400004, 26.929365133000076],
            [88.9254036860001, 26.939028626],
            [88.92695398000012, 26.94941558800012],
            [88.92447351100003, 26.96166290300006],
            [88.90664514100007, 26.98109324200003],
            [88.8864396570001, 26.978974508000064],
            [88.86711267100003, 26.964246725000052],
            [88.85171309400005, 26.94543650400003],
            [88.84561527500011, 26.994839172000056],
            [88.84561527500011, 26.994942526000088],
            [88.84561527500011, 27.04956451400004],
            [88.84080936700008, 27.075247701000094],
            [88.82763187700004, 27.097881979000064],
            [88.80525598100013, 27.11302317300006],
            [88.74257246900004, 27.142737122000042],
            [88.73308231500005, 27.148972387000114],
            [88.73006677200004, 27.150953674000064],
            [88.7384383540001, 27.17978912300002],
            [88.75435469600012, 27.21260365800002],
            [88.77585209100005, 27.240870667000095],
            [88.80117354300006, 27.256425273000033],
            [88.86142826300011, 27.270377910000022],
            [88.87611560500005, 27.28048567900005],
            [88.88463098200003, 27.286345927000056],
            [88.89233077000011, 27.315543111000082],
            [88.91516001698494, 27.33086945727318],
            [88.95080816584573, 27.32822885365387],
            [88.97193299480028, 27.312385231937938],
            [88.99701872918376, 27.33086945727318],
            [88.98117510746783, 27.35463488984705],
            [88.96401118394226, 27.392923642327176],
            [88.95105955131027, 27.433144260415148],
            [88.95754909876507, 27.456939267749547],
            [88.96620182870481, 27.478030296977792],
            [88.98296649296316, 27.49263177875116],
            [88.98004625332288, 27.497980380569217],
            [88.97520970564693, 27.506838820587532],
            [88.97295541963888, 27.517659393426257],
            [88.97836570605818, 27.53028339507135],
            [88.99279313650976, 27.53749711029714],
            [89.00496628095334, 27.549670254740633],
            [89.00271199494523, 27.560490827579358],
            [89.01623771099366, 27.57581997243416],
            [89.03337028465484, 27.57897597284547],
            [89.0396822854774, 27.594305117700188],
            [89.05095371551772, 27.60828169095022],
            [89.06402857436444, 27.615946263377637],
            [89.09153086366274, 27.62586512181302],
            [89.10235143650146, 27.623610835805025],
            [89.1058645948479, 27.62295211861509],
            [89.10956515172722, 27.62225826420017],
            [89.11948401016275, 27.61820054938572],
            [89.12465494572706, 27.614851589150547],
            [89.1273589238333, 27.627289888438966],
            [89.15602109175876, 27.665686377546805],
            [89.19820315021519, 27.730581852095057],
            [89.21659020133723, 27.77114152368786],
            [89.22492028800008, 27.807812806000058],
            [89.25871667500007, 27.827553203000022],
            [89.29948938000013, 27.844244690000053],
            [89.33602461800007, 27.8690752160001],
            [89.37013106300003, 27.90935699500004],
            [89.41736367800007, 27.988654027000038],
            [89.42098067200004, 27.99472646100004],
            [89.42118737800007, 27.99472646100004],
            [89.44454512600004, 28.031184184000054],
            [89.45880782100011, 28.04779815700006],
            [89.47534428000012, 28.061337382000133],
            [89.49534305900005, 28.06800364200005],
            [89.51503177900008, 28.081904602000023],
            [89.56148889100012, 28.134640401000055],
            [89.57942061400007, 28.144639791000074],
            [89.59781742400008, 28.149807434000067],
            [89.71781010000007, 28.169082744000022],
            [89.75584395400011, 28.184378967000058],
            [89.77362064600004, 28.21277516700009],
            [89.78085534700011, 28.228769023000027],
            [89.79604821800007, 28.240189515000054],
            [89.82974125100003, 28.259154765000076],
            [89.83862959800013, 28.267913921000073],
            [89.85402917500011, 28.28726674400012],
            [89.86291752100004, 28.295793356000033],
            [89.87361454300003, 28.300599263000052],
            [89.88131433100011, 28.29752451600011],
            [89.91613001353875, 28.31560117706651],
            [89.95252445500006, 28.30824737600004],
            [89.97159305900004, 28.318040060000087],
            [89.99045495700005, 28.32062388100009],
            [90.07086035391018, 28.34523039118018],
            [90.12353451233452, 28.335353986475624],
            [90.15316372644816, 28.322185446869483],
            [90.1762086707588, 28.325477581771068],
            [90.1992536150695, 28.34852252608168],
            [90.22559069428155, 28.358398930786237],
            [90.2618041781983, 28.335353986475624],
            [90.2618041781983, 28.2991405025589],
            [90.29147017500009, 28.261351014000084],
            [90.32950402800009, 28.25579579700006],
            [90.35398395544087, 28.2991405025589],
            [90.38690530445604, 28.2991405025589],
            [90.41653451856979, 28.282679828051258],
            [90.45604013738802, 28.282679828051258],
            [90.50542216091083, 28.249758479036117],
            [90.54821991463052, 28.246466344134532],
            [90.58772553344886, 28.233297804528476],
            [90.59760193815339, 28.200376455513336],
            [90.56797272403975, 28.19050005080878],
            [90.54821991463052, 28.157578701793526],
            [90.51529856561535, 28.154286566892026],
            [90.48566935150171, 28.12465735277827],
            [90.4752315670001, 28.07234446300002],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Oman',
        iso3: 'OMN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [56.26062458100006, 25.3310754190001],
              [56.29068832500013, 25.327543033000026],
              [56.30936870900007, 25.301327936000106],
              [56.349122903000136, 25.29402458100013],
              [56.34437541900007, 25.26652793600003],
              [56.31642574400007, 25.253354775000034],
              [56.29314974300013, 25.24584638800009],
              [56.28176314300009, 25.23691029900003],
              [56.25220422400008, 25.217634990000093],
              [56.235771118000116, 25.21117543500013],
              [56.21995813000012, 25.21525787400013],
              [56.20762458100006, 25.22083516000002],
              [56.20612290300005, 25.230596063000107],
              [56.208375419000106, 25.25537374200003],
              [56.23512625800004, 25.26747593300003],
              [56.24488716200011, 25.27798767600008],
              [56.238880452000046, 25.286246902000087],
              [56.23566776500007, 25.29628651900005],
              [56.23362458100013, 25.312526258],
              [56.26062458100006, 25.3310754190001],
            ],
            [
              [56.26302625800014, 25.24922290300013],
              [56.28297899300014, 25.255476134000062],
              [56.288327936000144, 25.271926258000022],
              [56.27381171300004, 25.28128926500004],
              [56.265075419000084, 25.281175419000036],
              [56.259578304000115, 25.27598189200002],
              [56.26302625800014, 25.24922290300013],
            ],
          ],
          [
            [
              [56.07739667277616, 26.06104817532254],
              [56.07748457100007, 26.061346747000073],
              [56.082041863000086, 26.070705471000053],
              [56.09148196700005, 26.10651276200008],
              [56.15772545700008, 26.20107656500005],
              [56.18181399800005, 26.24599844000005],
              [56.19190514400003, 26.255072333000044],
              [56.20826256600009, 26.26308828300006],
              [56.20915774800005, 26.257554429000038],
              [56.20826256600009, 26.24404531500005],
              [56.21989993600005, 26.227728583000044],
              [56.216807488000086, 26.22211334800005],
              [56.21241295700008, 26.207831122000073],
              [56.21989993600005, 26.207831122000073],
              [56.229502800000034, 26.21678294500009],
              [56.25554446700005, 26.218085028000075],
              [56.260752800000034, 26.22459544500009],
              [56.26685631600009, 26.227484442000048],
              [56.279958530000044, 26.223089911000045],
              [56.29184004000007, 26.211859442000048],
              [56.294932488000086, 26.194240627000056],
              [56.30193118600005, 26.20530833500004],
              [56.30884850400008, 26.204738674000055],
              [56.317393425000034, 26.20062897300005],
              [56.329112175000034, 26.20107656500005],
              [56.35629316500007, 26.219142971000053],
              [56.36695397200003, 26.221502997000073],
              [56.397471550000034, 26.21385325700004],
              [56.40414472700007, 26.21474844000005],
              [56.406911655000044, 26.223130601000037],
              [56.402354363000086, 26.232082424000055],
              [56.394541863000086, 26.239162502000056],
              [56.387380405000044, 26.242010809000078],
              [56.367849155000044, 26.244086005000042],
              [56.35572350400008, 26.243394273000035],
              [56.34685306100005, 26.23859284100007],
              [56.34115644600007, 26.23232656500005],
              [56.33130944100009, 26.223456122000073],
              [56.31959069100009, 26.217922268000052],
              [56.30844160200007, 26.221502997000073],
              [56.30827884200005, 26.23261139500005],
              [56.31592858200008, 26.274644273000035],
              [56.31592858200008, 26.29043203300006],
              [56.34522545700008, 26.269232489000046],
              [56.358409050000034, 26.264960028000075],
              [56.36378014400003, 26.27952708500004],
              [56.35906009200005, 26.28733958500004],
              [56.34782962300005, 26.297430731000077],
              [56.333994988000086, 26.30613841400009],
              [56.322276238000086, 26.30963776200008],
              [56.326508009000065, 26.318915106000077],
              [56.332041863000086, 26.320746161000045],
              [56.33814537900008, 26.320705471000053],
              [56.34400475400008, 26.323919989000046],
              [56.35629316500007, 26.337591864000046],
              [56.36182701900003, 26.34951406500005],
              [56.36052493600005, 26.37128327000005],
              [56.36378014400003, 26.385972398000035],
              [56.36996504000007, 26.385972398000035],
              [56.38363691500007, 26.358710028000075],
              [56.399099155000044, 26.36790599200009],
              [56.40414472700007, 26.372300523000035],
              [56.41163170700008, 26.364935614000046],
              [56.406911655000044, 26.357367255000042],
              [56.40650475400008, 26.354803778000075],
              [56.40870201900003, 26.352362372000073],
              [56.41163170700008, 26.345038153000075],
              [56.42107181100005, 26.352118231000077],
              [56.42693118600005, 26.34959544500009],
              [56.43189537900008, 26.342962958000044],
              [56.43897545700008, 26.337591864000046],
              [56.46216881600009, 26.331854559000078],
              [56.47437584700003, 26.33079661700009],
              [56.487315300000034, 26.331366278000075],
              [56.48519941500007, 26.335882880000042],
              [56.48178144600007, 26.347357489000046],
              [56.47982832100007, 26.35187409100007],
              [56.500987175000034, 26.358710028000075],
              [56.51107832100007, 26.33348216400009],
              [56.50896243600005, 26.32371653900009],
              [56.49496504000007, 26.322739976000037],
              [56.46957441500007, 26.323919989000046],
              [56.45281009200005, 26.31834544500009],
              [56.422862175000034, 26.294623114000046],
              [56.406260613000086, 26.284898179000038],
              [56.40748131600009, 26.284857489000046],
              [56.407237175000034, 26.279120184000078],
              [56.39861087300005, 26.268703518000052],
              [56.420909050000034, 26.24762604400007],
              [56.432302280000044, 26.239447333000044],
              [56.44581139400003, 26.235174872000073],
              [56.45492597700007, 26.23932526200008],
              [56.46534264400003, 26.247259833000044],
              [56.47624759200005, 26.249172268000052],
              [56.487315300000034, 26.235174872000073],
              [56.468760613000086, 26.205511786000045],
              [56.459646030000044, 26.202093817000048],
              [56.45329837300005, 26.221502997000073],
              [56.44304446700005, 26.220445054000038],
              [56.431976759000065, 26.221502997000073],
              [56.43580162900008, 26.21161530200004],
              [56.43685957100007, 26.20526764500005],
              [56.43539472700007, 26.200140692000048],
              [56.431976759000065, 26.194240627000056],
              [56.44459069100009, 26.18235911700009],
              [56.459727410000085, 26.174261786000045],
              [56.47291100400008, 26.164007880000042],
              [56.47982832100007, 26.145819403000075],
              [56.46810957100007, 26.14598216400009],
              [56.457367384000065, 26.14842357000009],
              [56.44776451900003, 26.153143622000073],
              [56.43897545700008, 26.160101630000042],
              [56.424571160000085, 26.15379466400009],
              [56.412445509000065, 26.15843333500004],
              [56.404958530000044, 26.17059967700004],
              [56.40414472700007, 26.186753648000035],
              [56.39828535200007, 26.183417059000078],
              [56.383148634000065, 26.176988023000035],
              [56.37745201900003, 26.17373281500005],
              [56.376963738000086, 26.184393622000073],
              [56.378916863000086, 26.192531643000052],
              [56.38363691500007, 26.198065497000073],
              [56.39112389400003, 26.20107656500005],
              [56.36841881600009, 26.20453522300005],
              [56.34359785200007, 26.19139232000009],
              [56.328786655000044, 26.17283763200004],
              [56.335948113000086, 26.160101630000042],
              [56.33090254000007, 26.149318752000056],
              [56.32976321700005, 26.137111721000053],
              [56.33171634200005, 26.124212958000044],
              [56.335948113000086, 26.11163971600007],
              [56.344737175000034, 26.13182200700004],
              [56.35303795700008, 26.142645575000074],
              [56.36378014400003, 26.145819403000075],
              [56.370127800000034, 26.139471747000073],
              [56.371104363000086, 26.127834377000056],
              [56.36833743600005, 26.114894924000055],
              [56.36378014400003, 26.10488515800006],
              [56.38331139400003, 26.097479559000078],
              [56.472992384000065, 26.09861888200004],
              [56.46436608200008, 26.08535390800006],
              [56.449229363000086, 26.073553778000075],
              [56.418304884000065, 26.057074286000045],
              [56.38917076900003, 26.04710521000004],
              [56.38013756600009, 26.038234768000052],
              [56.38363691500007, 26.022284247000073],
              [56.408864780000044, 26.034369208000044],
              [56.422862175000034, 26.023138739000046],
              [56.42335045700008, 26.00462474200009],
              [56.400401238000086, 25.99046458500004],
              [56.405039910000085, 25.98045482000009],
              [56.418304884000065, 25.96393463700008],
              [56.42212975400008, 25.95661041900007],
              [56.43116295700008, 25.95270416900007],
              [56.45329837300005, 25.94717031500005],
              [56.44548587300005, 25.94245026200008],
              [56.44263756600009, 25.939276434000078],
              [56.43897545700008, 25.92609284100007],
              [56.424164259000065, 25.93317291900007],
              [56.40788821700005, 25.93740469000005],
              [56.393321160000085, 25.93585846600007],
              [56.38363691500007, 25.92609284100007],
              [56.399424675000034, 25.90232982000009],
              [56.392588738000086, 25.88043854400007],
              [56.37614993600005, 25.85927969000005],
              [56.36378014400003, 25.837958075000074],
              [56.36264082100007, 25.830633856000077],
              [56.36378014400003, 25.80687083500004],
              [56.34400475400008, 25.789536851000037],
              [56.32740319100009, 25.76239655200004],
              [56.31625410200007, 25.74957916900007],
              [56.301768425000034, 25.74176666900007],
              [56.301768425000034, 25.762884833000044],
              [56.28793379000007, 25.74160390800006],
              [56.273773634000065, 25.709133205000057],
              [56.266612175000034, 25.67259349200009],
              [56.273773634000065, 25.63930898600006],
              [56.27905523484418, 25.627445697852735],
              [56.23752811700007, 25.616577047000064],
              [56.221508423000046, 25.61383819600003],
              [56.20579878700005, 25.6177656040001],
              [56.19877079200006, 25.625258687000027],
              [56.18884891800013, 25.64541249600002],
              [56.1798572190001, 25.652078756000023],
              [56.15639611800003, 25.655902812000065],
              [56.1524960590001, 25.65796117700002],
              [56.150815064000085, 25.65884836900007],
              [56.14513065600005, 25.67083730100002],
              [56.14037642400007, 25.71553741500007],
              [56.141203248000124, 25.732693991000033],
              [56.15195194500012, 25.743132629000073],
              [56.16487105300013, 25.752176005000123],
              [56.1720024010001, 25.765250143000074],
              [56.167351522000104, 25.777704163000053],
              [56.144097127000066, 25.805919495000026],
              [56.1396529540001, 25.82297271700007],
              [56.14451053900012, 25.83790720600011],
              [56.163837524000144, 25.862453512000073],
              [56.170555461000106, 25.876819560000072],
              [56.174689575000116, 25.966529846000057],
              [56.18130415900009, 25.99624379500004],
              [56.18347456900011, 26.014537252000096],
              [56.178410278000115, 26.035001119000057],
              [56.16270064300005, 26.073551737000045],
              [56.15133182800014, 26.074791972000085],
              [56.10058557100007, 26.062854716000047],
              [56.07739667277616, 26.06104817532254],
            ],
          ],
          [
            [
              [56.38331139400003, 24.978216864000046],
              [56.40544681100005, 24.897284247000073],
              [56.46957441500007, 24.775336005000042],
              [56.48031660200007, 24.76512278900009],
              [56.48682701900003, 24.741848049000055],
              [56.49350019600007, 24.70018138200004],
              [56.61117597700007, 24.49632396000004],
              [56.63559004000007, 24.47138092700004],
              [56.692149285000085, 24.42523834800005],
              [56.801442905000044, 24.30296458500004],
              [56.82309004000007, 24.271144924000055],
              [56.83228600400008, 24.252508856000077],
              [56.84107506600009, 24.223822333000044],
              [56.939463738000086, 24.11591217700004],
              [57.05827884200005, 24.023098049000055],
              [57.15154056100005, 23.953558661000045],
              [57.184255405000044, 23.93427155200004],
              [57.32634524800005, 23.884019273000035],
              [57.50961347700007, 23.839097398000035],
              [57.58643639400003, 23.807440497000073],
              [57.645192905000044, 23.79043203300006],
              [57.68677819100009, 23.783351955000057],
              [57.709727410000085, 23.78221263200004],
              [57.777354363000086, 23.785956122000073],
              [57.79574629000007, 23.78221263200004],
              [57.82439212300005, 23.74762604400007],
              [57.834971550000034, 23.740057684000078],
              [57.85922285200007, 23.734076239000046],
              [57.887705925000034, 23.720851955000057],
              [57.912771030000044, 23.71784088700008],
              [58.04314212300005, 23.724554755000042],
              [58.08676191500007, 23.72211334800005],
              [58.131602410000085, 23.713324286000045],
              [58.19320722700007, 23.68935781500005],
              [58.21029707100007, 23.685980536000045],
              [58.22738691500007, 23.67914459800005],
              [58.26417076900003, 23.64484284100007],
              [58.28239993600005, 23.631415106000077],
              [58.31723066500007, 23.620917059000078],
              [58.36353600400008, 23.61554596600007],
              [58.41195722700007, 23.61619700700004],
              [58.45297285200007, 23.623968817000048],
              [58.47486412900008, 23.63153717700004],
              [58.48365319100009, 23.63812897300005],
              [58.490896030000044, 23.65656159100007],
              [58.49952233200008, 23.65688711100006],
              [58.518565300000034, 23.65192291900007],
              [58.56137129000007, 23.65110911700009],
              [58.58415774800005, 23.646958726000037],
              [58.604502800000034, 23.637600002000056],
              [58.613291863000086, 23.625067450000074],
              [58.63331139400003, 23.585272528000075],
              [58.64210045700008, 23.57680898600006],
              [58.647146030000044, 23.57489655200004],
              [58.65154056100005, 23.57054271000004],
              [58.65552819100009, 23.565741278000075],
              [58.65902754000007, 23.56248607000009],
              [58.66130618600005, 23.56313711100006],
              [58.66684004000007, 23.56391022300005],
              [58.67400149800005, 23.56395091400009],
              [58.680349155000044, 23.56248607000009],
              [58.69459069100009, 23.55141836100006],
              [58.70240319100009, 23.54295482000009],
              [58.70687910200007, 23.53514232000009],
              [58.71436608200008, 23.53514232000009],
              [58.72055097700007, 23.54881419500009],
              [58.72291100400008, 23.543402411000045],
              [58.724945509000065, 23.54010651200008],
              [58.72681725400008, 23.536078192000048],
              [58.72803795700008, 23.52838776200008],
              [58.73487389400003, 23.52838776200008],
              [58.73601321700005, 23.53266022300005],
              [58.740977410000085, 23.54205963700008],
              [58.74634850400008, 23.537665106000077],
              [58.74952233200008, 23.536444403000075],
              [58.762054884000065, 23.54205963700008],
              [58.786143425000034, 23.512111721000053],
              [58.792979363000086, 23.49567291900007],
              [58.789398634000065, 23.480617580000057],
              [58.79737389400003, 23.46678294500009],
              [58.807627800000034, 23.421128648000035],
              [58.82056725400008, 23.40176015800006],
              [58.87916100400008, 23.351263739000046],
              [58.91521243600005, 23.336086330000057],
              [58.92945397200003, 23.318101304000038],
              [58.94654381600009, 23.275091864000046],
              [58.95622806100005, 23.259426174000055],
              [58.98650149800005, 23.232489325000074],
              [59.00171959700003, 23.21238841400009],
              [59.010101759000065, 23.15330638200004],
              [59.07374108200008, 23.09324778900009],
              [59.07789147200003, 23.085150458000044],
              [59.08366946700005, 23.05536530200004],
              [59.087901238000086, 23.04840729400007],
              [59.092539910000085, 23.04364655200004],
              [59.12045332100007, 23.022772528000075],
              [59.17367597700007, 22.993963934000078],
              [59.20753014400003, 22.970363674000055],
              [59.23226972700007, 22.943019924000055],
              [59.250010613000086, 22.91201406500005],
              [59.286143425000034, 22.82648346600007],
              [59.289805535000085, 22.81207916900007],
              [59.297536655000044, 22.792710679000038],
              [59.31568444100009, 22.77948639500005],
              [59.35181725400008, 22.76117584800005],
              [59.391612175000034, 22.70221588700008],
              [59.397227410000085, 22.686102606000077],
              [59.41065514400003, 22.670843817000048],
              [59.45248457100007, 22.634100653000075],
              [59.48389733200008, 22.618841864000046],
              [59.506846550000034, 22.600083726000037],
              [59.52979576900003, 22.58787669500009],
              [59.535492384000065, 22.58307526200008],
              [59.53646894600007, 22.57257721600007],
              [59.53044681100005, 22.570054429000038],
              [59.52198326900003, 22.57217031500005],
              [59.515635613000086, 22.57558828300006],
              [59.51579837300005, 22.56150950700004],
              [59.52312259200005, 22.555121161000045],
              [59.535166863000086, 22.553859768000052],
              [59.549815300000034, 22.555121161000045],
              [59.62680097700007, 22.579820054000038],
              [59.65349368600005, 22.56972890800006],
              [59.69385826900003, 22.541449286000045],
              [59.699961785000085, 22.54092031500005],
              [59.71566816500007, 22.542914130000042],
              [59.72120201900003, 22.541449286000045],
              [59.72396894600007, 22.536810614000046],
              [59.72584069100009, 22.52610911700009],
              [59.728526238000086, 22.52098216400009],
              [59.72836347700007, 22.518133856000077],
              [59.727224155000044, 22.51357656500005],
              [59.72803795700008, 22.507635809000078],
              [59.734711134000065, 22.500474351000037],
              [59.73975670700008, 22.497788804000038],
              [59.746104363000086, 22.49559153900009],
              [59.75277754000007, 22.494208075000074],
              [59.75896243600005, 22.49363841400009],
              [59.76254316500007, 22.498602606000077],
              [59.75603274800005, 22.509426174000055],
              [59.74154707100007, 22.524725653000075],
              [59.74577884200005, 22.538234768000052],
              [59.75635826900003, 22.53847890800006],
              [59.776377800000034, 22.541449286000045],
              [59.80323326900003, 22.53473541900007],
              [59.824880405000044, 22.50885651200008],
              [59.83936608200008, 22.47528717700004],
              [59.84457441500007, 22.445257880000042],
              [59.824880405000044, 22.281398830000057],
              [59.81177819100009, 22.23737213700008],
              [59.791758660000085, 22.198065497000073],
              [59.734711134000065, 22.123114325000074],
              [59.70492597700007, 22.099554755000042],
              [59.688161655000044, 22.08270905200004],
              [59.680674675000034, 22.06509023600006],
              [59.67798912900008, 22.041896877000056],
              [59.65967858200008, 21.99404531500005],
              [59.655039910000085, 21.945746161000045],
              [59.645274285000085, 21.925848700000074],
              [59.60564212300005, 21.910223700000074],
              [59.59343509200005, 21.89276764500005],
              [59.57699629000007, 21.856268622000073],
              [59.49789472700007, 21.756333726000037],
              [59.46762129000007, 21.666408596000053],
              [59.44857832100007, 21.62490469000005],
              [59.35499108200008, 21.485663153000075],
              [59.34750410200007, 21.453558661000045],
              [59.34424889400003, 21.44472890800006],
              [59.33619225400008, 21.43773021000004],
              [59.195323113000086, 21.37909577000005],
              [59.16627037900008, 21.36277903900009],
              [59.05437259200005, 21.277085679000038],
              [58.91920006600009, 21.143703518000052],
              [58.87810306100005, 21.083807684000078],
              [58.867930535000085, 21.074774481000077],
              [58.854258660000085, 21.065619208000044],
              [58.838552280000044, 21.04450104400007],
              [58.80787194100009, 20.990790106000077],
              [58.80445397200003, 20.981594143000052],
              [58.80193118600005, 20.946234442000048],
              [58.798838738000086, 20.936021226000037],
              [58.792979363000086, 20.927394924000055],
              [58.73487389400003, 20.88300202000005],
              [58.739024285000085, 20.862250067000048],
              [58.72217858200008, 20.848049221000053],
              [58.680349155000044, 20.82835521000004],
              [58.68148847700007, 20.82648346600007],
              [58.673838738000086, 20.80817291900007],
              [58.67269941500007, 20.807847398000035],
              [58.66578209700003, 20.801581122000073],
              [58.66130618600005, 20.79633209800005],
              [58.65902754000007, 20.790838934000078],
              [58.66146894600007, 20.781642971000053],
              [58.66765384200005, 20.772284247000073],
              [58.676442905000044, 20.76439036700009],
              [58.686534050000034, 20.759466864000046],
              [58.70134524800005, 20.766017971000053],
              [58.71810957100007, 20.78082916900007],
              [58.72934004000007, 20.786810614000046],
              [58.72803795700008, 20.766913153000075],
              [58.71810957100007, 20.753648179000038],
              [58.699880405000044, 20.740790106000077],
              [58.68181399800005, 20.73590729400007],
              [58.67269941500007, 20.74640534100007],
              [58.66651451900003, 20.74640534100007],
              [58.660899285000085, 20.73232656500005],
              [58.653330925000034, 20.70526764500005],
              [58.64535566500007, 20.691148179000038],
              [58.637461785000085, 20.684393622000073],
              [58.61540774800005, 20.672430731000077],
              [58.604502800000034, 20.663275458000044],
              [58.591807488000086, 20.64394765800006],
              [58.580821160000085, 20.618475653000075],
              [58.573252800000034, 20.590643622000073],
              [58.57048587300005, 20.564276434000078],
              [58.54509524800005, 20.516424872000073],
              [58.531260613000086, 20.481390692000048],
              [58.53248131600009, 20.465277411000045],
              [58.52686608200008, 20.45770905200004],
              [58.521494988000086, 20.424383856000077],
              [58.518565300000034, 20.416815497000073],
              [58.510427280000044, 20.415228583000044],
              [58.497080925000034, 20.41079336100006],
              [58.48357181100005, 20.40420156500005],
              [58.47413170700008, 20.39638906500005],
              [58.467458530000044, 20.369533596000053],
              [58.44581139400003, 20.358628648000035],
              [58.41765384200005, 20.35960521000004],
              [58.391612175000034, 20.368475653000075],
              [58.37256920700008, 20.377386786000045],
              [58.35914147200003, 20.38157786700009],
              [58.32642662900008, 20.38271719000005],
              [58.31381269600007, 20.380804755000042],
              [58.290049675000034, 20.37140534100007],
              [58.27556399800005, 20.368475653000075],
              [58.27865644600007, 20.377386786000045],
              [58.28451582100007, 20.381984768000052],
              [58.279633009000065, 20.384833075000074],
              [58.244151238000086, 20.394232489000046],
              [58.22429446700005, 20.39638906500005],
              [58.20289147200003, 20.404730536000045],
              [58.20053144600007, 20.424383856000077],
              [58.21338951900003, 20.465277411000045],
              [58.213226759000065, 20.45270416900007],
              [58.21729576900003, 20.441555080000057],
              [58.22478274800005, 20.43183014500005],
              [58.23462975400008, 20.423651434000078],
              [58.23845462300005, 20.443833726000037],
              [58.22828209700003, 20.488836981000077],
              [58.23804772200003, 20.50934479400007],
              [58.25131269600007, 20.52920156500005],
              [58.26156660200007, 20.55809153900009],
              [58.26417076900003, 20.587632554000038],
              [58.25513756600009, 20.60927969000005],
              [58.23487389400003, 20.615668036000045],
              [58.205739780000044, 20.613348700000074],
              [58.17628014400003, 20.604722398000035],
              [58.14421634200005, 20.585191148000035],
              [58.103526238000086, 20.575140692000048],
              [58.090830925000034, 20.566839911000045],
              [58.08448326900003, 20.55805084800005],
              [58.06723066500007, 20.511053778000075],
              [58.06657962300005, 20.499823309000078],
              [58.07309004000007, 20.489162502000056],
              [58.07585696700005, 20.48004791900007],
              [58.06763756600009, 20.472479559000078],
              [58.055349155000044, 20.467230536000045],
              [58.03077233200008, 20.46190013200004],
              [58.012461785000085, 20.45343659100007],
              [57.99439537900008, 20.442287502000056],
              [57.970713738000086, 20.421210028000075],
              [57.96208743600005, 20.41087474200009],
              [57.955821160000085, 20.399562893000052],
              [57.95337975400008, 20.386419989000046],
              [57.95655358200008, 20.37693919500009],
              [57.970713738000086, 20.361883856000077],
              [57.97388756600009, 20.35228099200009],
              [57.96656334700003, 20.330226955000057],
              [57.94874108200008, 20.317572333000044],
              [57.905039910000085, 20.30076732000009],
              [57.88843834700003, 20.290716864000046],
              [57.87045332100007, 20.277044989000046],
              [57.856130405000044, 20.260646877000056],
              [57.850352410000085, 20.24241771000004],
              [57.84489993600005, 20.23118724200009],
              [57.83350670700008, 20.21832916900007],
              [57.82374108200008, 20.20107656500005],
              [57.823008660000085, 20.176662502000056],
              [57.84197024800005, 20.136053778000075],
              [57.847992384000065, 20.111761786000045],
              [57.83171634200005, 20.075344143000052],
              [57.81625410200007, 20.020738023000035],
              [57.81568444100009, 20.00657786700009],
              [57.81364993600005, 19.976996161000045],
              [57.79037519600007, 19.92401764500005],
              [57.77369225400008, 19.86786530200004],
              [57.762054884000065, 19.842962958000044],
              [57.69890384200005, 19.754380601000037],
              [57.68921959700003, 19.728176174000055],
              [57.693369988000086, 19.69745514500005],
              [57.70045006600009, 19.685980536000045],
              [57.70923912900008, 19.67674388200004],
              [57.716807488000086, 19.666815497000073],
              [57.71998131600009, 19.65306224200009],
              [57.72055097700007, 19.62262604400007],
              [57.71892337300005, 19.607977606000077],
              [57.713877800000034, 19.595038153000075],
              [57.70655358200008, 19.568833726000037],
              [57.70443769600007, 19.54873281500005],
              [57.71176191500007, 19.52948639500005],
              [57.76026451900003, 19.45408763200004],
              [57.76783287900008, 19.437445380000042],
              [57.77393639400003, 19.40965403900009],
              [57.773773634000065, 19.382879950000074],
              [57.76905358200008, 19.35761139500005],
              [57.75220787900008, 19.31159088700008],
              [57.74830162900008, 19.29100169500009],
              [57.750661655000044, 19.268052476000037],
              [57.77084394600007, 19.216945705000057],
              [57.78052819100009, 19.201117255000042],
              [57.805674675000034, 19.173000393000052],
              [57.81185957100007, 19.15688711100006],
              [57.80298912900008, 19.11513906500005],
              [57.80201256600009, 19.09479401200008],
              [57.839854363000086, 19.02997467700004],
              [57.84009850400008, 19.015326239000046],
              [57.81568444100009, 18.99176666900007],
              [57.801117384000065, 18.98065827000005],
              [57.79712975400008, 18.97923411700009],
              [57.752289259000065, 18.973049221000053],
              [57.74732506600009, 18.96784088700008],
              [57.742849155000044, 18.961859442000048],
              [57.73194420700008, 18.95380280200004],
              [57.719411655000044, 18.946926174000055],
              [57.709727410000085, 18.94399648600006],
              [57.50147545700008, 18.953680731000077],
              [57.445323113000086, 18.945339260000083],
              [57.20753014400003, 18.909979559000078],
              [57.08375084700003, 18.87636953300006],
              [56.915049675000034, 18.810288804000038],
              [56.850352410000085, 18.76581452000005],
              [56.80779056100005, 18.74559153900009],
              [56.78467858200008, 18.728583075000074],
              [56.77475019600007, 18.707180080000057],
              [56.76644941500007, 18.69684479400007],
              [56.65967858200008, 18.595363674000055],
              [56.64112389400003, 18.55927155200004],
              [56.63689212300005, 18.51194896000004],
              [56.64340254000007, 18.47919342700004],
              [56.64429772200003, 18.467596747000073],
              [56.64112389400003, 18.454901434000078],
              [56.62663821700005, 18.43585846600007],
              [56.62126712300005, 18.419582424000055],
              [56.612315300000034, 18.399603583000044],
              [56.60962975400008, 18.389064846000053],
              [56.60962975400008, 18.347479559000078],
              [56.600596550000034, 18.30540599200009],
              [56.548838738000086, 18.189846096000053],
              [56.56373131600009, 18.17023346600007],
              [56.561289910000085, 18.149237372000073],
              [56.547211134000065, 18.129706122000073],
              [56.52759850400008, 18.11469147300005],
              [56.48414147200003, 18.096502997000073],
              [56.46257571700005, 18.084418036000045],
              [56.431976759000065, 18.032171942000048],
              [56.42562910200007, 18.027411200000074],
              [56.41130618600005, 18.023179429000038],
              [56.40414472700007, 18.01911041900007],
              [56.35767662900008, 17.96979401200008],
              [56.35499108200008, 17.96230703300006],
              [56.35629316500007, 17.940008856000077],
              [56.34489993600005, 17.93781159100007],
              [56.188487175000034, 17.957098700000074],
              [56.16822350400008, 17.95408763200004],
              [56.13835696700005, 17.940578518000052],
              [56.116221550000034, 17.93659088700008],
              [56.03109785200007, 17.943426825000074],
              [56.010752800000034, 17.940375067000048],
              [55.946055535000085, 17.91547272300005],
              [55.90943444100009, 17.906642971000053],
              [55.65349368600005, 17.895331122000073],
              [55.55290774800005, 17.870266018000052],
              [55.53052819100009, 17.868312893000052],
              [55.522471550000034, 17.866441148000092],
              [55.51734459700003, 17.862250067000048],
              [55.51286868600005, 17.857489325000074],
              [55.506602410000085, 17.853989976000037],
              [55.488291863000086, 17.853461005000042],
              [55.48682701900003, 17.853989976000037],
              [55.45394941500007, 17.845404364000046],
              [55.44516035200007, 17.841009833000044],
              [55.431651238000086, 17.824652411000045],
              [55.41732832100007, 17.785223700000074],
              [55.40796959700003, 17.768703518000052],
              [55.39307701900003, 17.75214264500005],
              [55.388682488000086, 17.744289455000057],
              [55.373383009000065, 17.70331452000005],
              [55.369476759000065, 17.69635651200008],
              [55.35572350400008, 17.681586005000042],
              [55.26319420700008, 17.60773346600007],
              [55.235036655000044, 17.55882396000004],
              [55.22820071700005, 17.538763739000046],
              [55.22543379000007, 17.515448309000078],
              [55.229502800000034, 17.48859284100007],
              [55.24008222700007, 17.475165106000077],
              [55.273773634000065, 17.457424221000053],
              [55.29322350400008, 17.43768952000005],
              [55.300791863000086, 17.416815497000073],
              [55.301117384000065, 17.371161200000074],
              [55.29420006600009, 17.352118231000077],
              [55.25342858200008, 17.29913971600007],
              [55.25123131600009, 17.289984442000048],
              [55.24952233200008, 17.27610911700009],
              [55.250661655000044, 17.263617255000042],
              [55.256846550000034, 17.258205471000053],
              [55.26482181100005, 17.254787502000056],
              [55.26514733200008, 17.24705638200004],
              [55.26026451900003, 17.23427969000005],
              [55.25473066500007, 17.22870514500005],
              [55.228526238000086, 17.216131903000075],
              [55.21924889400003, 17.21039459800005],
              [55.21314537900008, 17.202093817000048],
              [55.209320509000065, 17.19354889500005],
              [55.205088738000086, 17.176214911000045],
              [55.19548587300005, 17.16083405200004],
              [55.19874108200008, 17.15574778900009],
              [55.18921959700003, 17.14476146000004],
              [55.158864780000044, 17.13580963700008],
              [55.143565300000034, 17.127834377000056],
              [55.13843834700003, 17.118882554000038],
              [55.13298587300005, 17.10504791900007],
              [55.12476647200003, 17.09247467700004],
              [55.11255944100009, 17.086859442000048],
              [55.07178795700008, 17.042181708000044],
              [55.02686608200008, 17.01113515800006],
              [55.02068118600005, 17.01113515800006],
              [55.01091556100005, 17.026271877000056],
              [54.99919681100005, 17.019680080000057],
              [54.986989780000044, 17.00535716400009],
              [54.975352410000085, 16.99746328300006],
              [54.959646030000044, 16.99485911700009],
              [54.94507897200003, 16.989976304000038],
              [54.93132571700005, 16.987127997000073],
              [54.917002800000034, 16.990668036000045],
              [54.901377800000034, 16.97492096600007],
              [54.882823113000086, 16.96906159100007],
              [54.841807488000086, 16.96393463700008],
              [54.80844160200007, 16.95148346600007],
              [54.79184004000007, 16.95140208500004],
              [54.78052819100009, 16.96393463700008],
              [54.76905358200008, 16.957912502000056],
              [54.750743035000085, 16.96051666900007],
              [54.73943118600005, 16.95648834800005],
              [54.70533287900008, 16.97760651200008],
              [54.697927280000044, 16.97016022300005],
              [54.689789259000065, 16.98932526200008],
              [54.68531334700003, 17.00690338700008],
              [54.67408287900008, 17.01976146000004],
              [54.633148634000065, 17.02692291900007],
              [54.60434004000007, 17.036322333000044],
              [54.59205162900008, 17.03847890800006],
              [54.58033287900008, 17.03733958500004],
              [54.55974368600005, 17.03270091400009],
              [54.54769941500007, 17.031642971000053],
              [54.512380405000044, 17.038397528000075],
              [54.49927819100009, 17.03847890800006],
              [54.48853600400008, 17.035589911000045],
              [54.46762129000007, 17.026678778000075],
              [54.461680535000085, 17.02480703300006],
              [54.41456139400003, 17.03782786700009],
              [54.38998457100007, 17.039455471000053],
              [54.369476759000065, 17.02480703300006],
              [54.360118035000085, 17.02960846600007],
              [54.350352410000085, 17.031683661000045],
              [54.164073113000086, 17.01113515800006],
              [54.084971550000034, 17.01113515800006],
              [54.06755618600005, 17.006740627000056],
              [54.023448113000086, 16.98533763200004],
              [54.012705925000034, 16.97760651200008],
              [54.00896243600005, 16.96865469000005],
              [54.00928795700008, 16.96092357000009],
              [54.01140384200005, 16.953680731000077],
              [54.012705925000034, 16.94599030200004],
              [54.00945071700005, 16.937445380000042],
              [53.99537194100009, 16.92536041900007],
              [53.992198113000086, 16.919256903000075],
              [53.981130405000044, 16.908758856000077],
              [53.95590254000007, 16.90387604400007],
              [53.910166863000086, 16.901271877000056],
              [53.850352410000085, 16.889146226000037],
              [53.830739780000044, 16.887640692000048],
              [53.81267337300005, 16.881781317000048],
              [53.792002800000034, 16.870306708000044],
              [53.77133222700007, 16.862616278000075],
              [53.75318444100009, 16.867743231000077],
              [53.73462975400008, 16.85614655200004],
              [53.709320509000065, 16.836004950000074],
              [53.68702233200008, 16.813625393000052],
              [53.67750084700003, 16.79511139500005],
              [53.66928144600007, 16.784084377000056],
              [53.65056399800005, 16.773179429000038],
              [53.61540774800005, 16.757879950000074],
              [53.582692905000044, 16.749945380000042],
              [53.42302493600005, 16.74681224200009],
              [53.338633660000085, 16.734808661000045],
              [53.17530358200008, 16.684515692000048],
              [53.09034264400003, 16.642401434000078],
              [53.027904908000096, 16.777478333000133],
              [52.96527307200006, 16.912922262000038],
              [52.902744588000076, 17.0482628380001],
              [52.840319458000124, 17.183706767],
              [52.80156213400011, 17.26742258700007],
              [52.79102014100005, 17.281220195000103],
              [52.7738635660001, 17.287111308000092],
              [52.736243124000055, 17.28917836500007],
              [52.721463664000055, 17.298170065000093],
              [52.723013957000035, 17.29868682900006],
              [52.72828495300007, 17.299358622000042],
              [52.73014530500012, 17.299875387000085],
              [52.6984159750001, 17.371447246000017],
              [52.65562788900007, 17.467978821000045],
              [52.61283980300004, 17.56456207300009],
              [52.57020674700004, 17.66109364800012],
              [52.52741866000014, 17.75762522400005],
              [52.484527222000054, 17.85415679900008],
              [52.44173913600014, 17.9506366990001],
              [52.39900272600005, 18.047271627000057],
              [52.35616296400008, 18.14377736400006],
              [52.31332320200005, 18.240283102000078],
              [52.27069014500006, 18.336866353000048],
              [52.2277987060001, 18.433423767000065],
              [52.18501062000007, 18.529929504000094],
              [52.142325887000084, 18.626512757000043],
              [52.099537801000054, 18.72304433200007],
              [52.05674971500014, 18.819627584],
              [52.01396162900011, 18.91615916000002],
              [51.985688749000076, 18.97973180600009],
              [51.97861495000012, 18.99563751300012],
              [52.08992598400005, 19.03263783800007],
              [52.26107832800005, 19.089688620000075],
              [52.43212731900013, 19.14673940100009],
              [52.60312463300011, 19.203790181000088],
              [52.77438033000004, 19.260789286000076],
              [52.945532674000106, 19.31786590600008],
              [53.11658166500007, 19.374916687000066],
              [53.28783736200012, 19.431941630000082],
              [53.45888635300008, 19.48899241100007],
              [53.6300386960001, 19.545991516000058],
              [53.80108768700006, 19.60306813600006],
              [53.97224003100007, 19.660118917000077],
              [54.14349572800012, 19.717143860000064],
              [54.314648072000125, 19.77419464100005],
              [54.485593710000046, 19.83119374600004],
              [54.65674605300006, 19.888192851000028],
              [54.82789839600008, 19.94526947100006],
              [54.97838016800006, 19.995421448000073],
              [55.01052290900009, 20.092004700000118],
              [55.017137492000074, 20.11174509700008],
              [55.03574100800006, 20.167555644000046],
              [55.06447310400006, 20.254268697],
              [55.10188684100012, 20.366845805000096],
              [55.146225219000144, 20.499990133000054],
              [55.19552453600005, 20.648559875000032],
              [55.2483378500001, 20.8074132280001],
              [55.30290816200005, 20.971485901000065],
              [55.344623599000045, 21.096908734000053],
              [55.35747847500005, 21.13555857300007],
              [55.410188436000055, 21.29446360300004],
              [55.45959110500013, 21.443033346],
              [55.50382613100004, 21.57615183600008],
              [55.541239868000105, 21.68865142800003],
              [55.570075318000136, 21.775416158000027],
              [55.58857548000003, 21.831226705000077],
              [55.595190064000064, 21.851018779000057],
              [55.60017139700011, 21.866059974000038],
              [55.63756473800004, 21.978969625000033],
              [55.63704797300011, 22.001913961000056],
              [55.62671268700012, 22.0237730920001],
              [55.573589315000106, 22.1059386190001],
              [55.49276737500014, 22.230788880000134],
              [55.41204878800011, 22.35569081700008],
              [55.3311234950001, 22.48059275400003],
              [55.250404907000075, 22.605494690000043],
              [55.1868428950001, 22.703576559000098],
              [55.19759159300014, 22.84945912700003],
              [55.19128706900011, 22.995367534000067],
              [55.19128706900011, 22.995470886000092],
              [55.19480106600008, 23.02508148200006],
              [55.22591027900012, 23.121251322000077],
              [55.32109826600009, 23.27509206100008],
              [55.343215780000094, 23.33627695700001],
              [55.36409305800004, 23.436012472000087],
              [55.37525516700009, 23.469343771000055],
              [55.39396203600006, 23.495181986000077],
              [55.39416874200003, 23.49528534000011],
              [55.431479126000056, 23.532931620000042],
              [55.445328409000126, 23.5522586070001],
              [55.4782979740001, 23.676359559],
              [55.487393025000074, 23.693257752000093],
              [55.534108520000075, 23.756768087000054],
              [55.53834598800012, 23.770048930000073],
              [55.53514204900006, 23.845884094000056],
              [55.530594523000104, 23.8746678670001],
              [55.51457482900014, 23.896604512000053],
              [55.4782979740001, 23.916577454000063],
              [55.46155481000005, 23.93055592900008],
              [55.45276981600006, 23.94856516600008],
              [55.45680057800007, 23.96316375800005],
              [55.49979537000013, 23.970605164000048],
              [55.54227339700009, 23.985436299000085],
              [55.56170373500004, 23.995228984000036],
              [55.59105594900012, 24.010008443000075],
              [55.61834110500013, 24.02013702500001],
              [55.64686649600009, 24.025020447000045],
              [55.68004276500011, 24.02427113900005],
              [55.71259891800014, 24.01923268700007],
              [55.72799849500012, 24.019594421000065],
              [55.7444316000001, 24.025278829000015],
              [55.76241499800011, 24.02814687100009],
              [55.78845992000004, 24.009569194000036],
              [55.807063436000135, 24.00747629900006],
              [55.92354211400004, 24.051142883000054],
              [55.98679406800005, 24.065379740000097],
              [55.99785282400006, 24.081270244000038],
              [55.96074914600007, 24.142429301000035],
              [55.9489669190001, 24.184829814000054],
              [55.93315393100005, 24.220719096000025],
              [55.90318160000004, 24.232242940000035],
              [55.847164348000035, 24.21141733800009],
              [55.83031783100006, 24.21227],
              [55.767685995000136, 24.22487904900005],
              [55.75569706200008, 24.230330912000042],
              [55.754146770000034, 24.245472107000055],
              [55.762104940000086, 24.262964579000098],
              [55.80096561700009, 24.326268209000077],
              [55.80737349500009, 24.34078928700005],
              [55.81088749200006, 24.389235941],
              [55.80861372900006, 24.397633362000093],
              [55.801068969000085, 24.406470032000087],
              [55.78101851400004, 24.418872376000067],
              [55.77461063700008, 24.425900371000054],
              [55.771406698000135, 24.441093242000093],
              [55.77368046100014, 24.495250143000092],
              [55.76117476400003, 24.537443949000064],
              [55.75983117700008, 24.558527934],
              [55.76995975800014, 24.572403056000056],
              [55.78401574700007, 24.586329855000045],
              [55.790216919000045, 24.619867859000053],
              [55.818225546000065, 24.64338063600006],
              [55.81491825400013, 24.662733460000098],
              [55.79998138500008, 24.693258293000028],
              [55.794764445000055, 24.703919577000093],
              [55.792697388000136, 24.722290548],
              [55.79703820800012, 24.759549255000124],
              [55.79703820800012, 24.778359477000024],
              [55.78866662600012, 24.855202332000104],
              [55.79910526500004, 24.886104838],
              [55.82938765500006, 24.921167298000043],
              [55.85782570100008, 24.944850718000012],
              [55.862150513000074, 24.948452454000048],
              [55.89698042800006, 24.968606262000023],
              [55.93542769400011, 24.9777271520001],
              [55.975872913000046, 24.972112462000055],
              [55.978422486000056, 24.971758525000084],
              [56.005604289000075, 24.956178080000043],
              [56.016973104000044, 24.926619162000108],
              [56.02525223400011, 24.882562365000084],
              [56.02927209500007, 24.861170959000034],
              [56.00529423000006, 24.87698394800013],
              [55.992375122000055, 24.88300425200005],
              [55.978422486000056, 24.886104838],
              [55.96085249800012, 24.881247254000087],
              [55.95764855900012, 24.868664042000077],
              [55.96477990700009, 24.85385874400005],
              [56.002090291000115, 24.82300791400006],
              [56.03154585800013, 24.754149068000046],
              [56.06213830600012, 24.731773173000065],
              [56.07626952200013, 24.729972135000097],
              [56.077951294000115, 24.72975779200003],
              [56.09913863200006, 24.730507100000025],
              [56.118258912000044, 24.735416362000066],
              [56.12725061000003, 24.745699972000054],
              [56.13334842900008, 24.762830709000113],
              [56.15484582500011, 24.786705221000105],
              [56.17117557700004, 24.823989766000025],
              [56.17136626700011, 24.82406878500008],
              [56.18626509600006, 24.83024261500013],
              [56.22367883300012, 24.834480083000088],
              [56.241662232000124, 24.842438253000054],
              [56.2746828060001, 24.871949287000106],
              [56.2803162030001, 24.87698394800013],
              [56.30832482900013, 24.89517405200006],
              [56.31359582600004, 24.905070089000063],
              [56.31427759700006, 24.911962176000102],
              [56.316053243000056, 24.929912347000098],
              [56.319280233000086, 24.962534282000078],
              [56.32445085900008, 24.967938686000124],
              [56.32899540200003, 24.972688701000024],
              [56.38331139400003, 24.978216864000046],
            ],
          ],
          [
            [
              [55.83619225400008, 17.49091217700004],
              [55.83244876400005, 17.500392971000053],
              [55.83171634200005, 17.50226471600007],
              [55.83171634200005, 17.502346096000053],
              [55.83708743600005, 17.51007721600007],
              [55.84880618600005, 17.515285549000055],
              [55.86296634200005, 17.518866278000075],
              [55.88306725400008, 17.507147528000075],
              [55.89087975400008, 17.50458405200004],
              [55.89079837300005, 17.50454336100006],
              [55.87582441500007, 17.495917059000078],
              [55.845713738000086, 17.49607982000009],
              [55.836273634000065, 17.49095286700009],
              [55.83619225400008, 17.49091217700004],
            ],
          ],
          [
            [
              [56.055349155000044, 17.559800523000092],
              [56.055349155000044, 17.559719143000052],
              [56.05819746200007, 17.545843817000048],
              [56.05844160200007, 17.54433828300006],
              [56.06788170700008, 17.53221263200004],
              [56.081065300000034, 17.52362702000005],
              [56.09555097700007, 17.518866278000075],
              [56.06381269600007, 17.49957916900007],
              [56.046885613000086, 17.493353583000044],
              [56.03109785200007, 17.49091217700004],
              [55.98682701900003, 17.49290599200009],
              [55.97282962300005, 17.49835846600007],
              [55.96420332100007, 17.519924221000053],
              [55.990570509000065, 17.53538646000004],
              [56.02881920700008, 17.547674872000073],
              [56.055349155000044, 17.559800523000092],
            ],
          ],
          [
            [
              [58.906260613000086, 20.626003322000088],
              [58.90837649800005, 20.604722398000035],
              [58.91431725400008, 20.587836005000042],
              [58.94507897200003, 20.535223700000074],
              [58.95394941500007, 20.519924221000053],
              [58.95004316500007, 20.508937893000052],
              [58.94117272200003, 20.500921942000048],
              [58.90284264400003, 20.47410716400009],
              [58.862315300000034, 20.452785549000055],
              [58.844086134000065, 20.437323309000078],
              [58.82016035200007, 20.40302155200004],
              [58.80827884200005, 20.37958405200004],
              [58.79664147200003, 20.33152903900009],
              [58.78760826900003, 20.314520575000074],
              [58.78760826900003, 20.31443919500009],
              [58.78760826900003, 20.303290106000077],
              [58.787771030000044, 20.302394924000055],
              [58.78931725400008, 20.29319896000004],
              [58.789398634000065, 20.28652578300006],
              [58.785166863000086, 20.27952708500004],
              [58.75147545700008, 20.24803294500009],
              [58.733409050000034, 20.224554755000042],
              [58.72429446700005, 20.21515534100007],
              [58.71534264400003, 20.212103583000044],
              [58.70264733200008, 20.21043528900009],
              [58.69125410200007, 20.20774974200009],
              [58.686534050000034, 20.20148346600007],
              [58.68311608200008, 20.19090403900009],
              [58.674571160000085, 20.179510809000078],
              [58.66358483200008, 20.17137278900009],
              [58.652354363000086, 20.170477606000077],
              [58.65219160200007, 20.170477606000077],
              [58.64698326900003, 20.17967357000009],
              [58.642588738000086, 20.187241929000038],
              [58.637461785000085, 20.218451239000046],
              [58.63648522200003, 20.249701239000046],
              [58.638682488000086, 20.266628322000088],
              [58.63835696700005, 20.26784902600008],
              [58.63591556100005, 20.277004299000055],
              [58.642914259000065, 20.35610586100006],
              [58.64820397200003, 20.368841864000046],
              [58.65902754000007, 20.38271719000005],
              [58.66456139400003, 20.387844143000052],
              [58.682383660000085, 20.40062083500004],
              [58.68995201900003, 20.403225002000056],
              [58.69190514400003, 20.405178127000056],
              [58.69385826900003, 20.407171942000048],
              [58.698252800000034, 20.42568594000005],
              [58.70069420700008, 20.43109772300005],
              [58.71762129000007, 20.43699778900009],
              [58.73422285200007, 20.437648830000057],
              [58.75123131600009, 20.44013092700004],
              [58.76889082100007, 20.451605536000045],
              [58.77711022200003, 20.462184963000084],
              [58.78077233200008, 20.46698639500005],
              [58.78451582100007, 20.479396877000056],
              [58.785166863000086, 20.481634833000044],
              [58.789398634000065, 20.519924221000053],
              [58.795583530000044, 20.538397528000075],
              [58.80486087300005, 20.55345286700009],
              [58.85287519600007, 20.613348700000074],
              [58.87134850400008, 20.649603583000044],
              [58.88257897200003, 20.682521877000056],
              [58.891286655000044, 20.694281317000048],
              [58.906260613000086, 20.69798411700009],
              [58.918304884000065, 20.681463934000078],
              [58.918304884000065, 20.681341864000046],
              [58.917002800000034, 20.66425202000005],
              [58.910166863000086, 20.64594147300005],
              [58.906260613000086, 20.626003322000088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Uzbekistan',
        iso3: 'UZB',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [71.7855196540001, 39.98970489500006],
              [71.78975712100004, 39.97931793200003],
              [71.7671228430001, 39.915445862000084],
              [71.7573043210001, 39.90309519400002],
              [71.74180139100008, 39.9007697550001],
              [71.71616988100004, 39.90676422100002],
              [71.69684289600008, 39.91384389200003],
              [71.67534550000005, 39.92578114900009],
              [71.66552697800006, 39.940198873],
              [71.68175337800005, 39.95508168600004],
              [71.7068681230001, 39.95611521400012],
              [71.72412805200008, 39.96267812100011],
              [71.7606116130001, 39.98371042900003],
              [71.7855196540001, 39.98970489500006],
            ],
          ],
          [
            [
              [70.95895511900011, 40.23837188800012],
              [70.93833622200009, 40.23992218100004],
              [70.84971114100011, 40.23377268500006],
              [70.70718754100005, 40.20018300400004],
              [70.66429610200004, 40.197495829],
              [70.62212813300005, 40.199562887000084],
              [70.5818205160001, 40.221732077000084],
              [70.56394047000003, 40.26421010400004],
              [70.55060795100013, 40.3104605110001],
              [70.52404626500004, 40.343740133000054],
              [70.50192875200008, 40.35081980400007],
              [70.48291182500003, 40.34926951100006],
              [70.46410160300013, 40.344825338000035],
              [70.44219079600009, 40.343326721000025],
              [70.4212101650001, 40.3479776],
              [70.37139408300004, 40.36492747000001],
              [70.38493330900013, 40.39970570900006],
              [70.38214278100008, 40.4039431770001],
              [70.37356449400005, 40.411797994000054],
              [70.37139408300004, 40.41334828800005],
              [70.37196252400008, 40.41298655200005],
              [70.3587850340001, 40.42771433600005],
              [70.35702803500004, 40.430401510000095],
              [70.35542606700011, 40.43510406500006],
              [70.35382409700009, 40.45613637300009],
              [70.36963708500008, 40.47551503600006],
              [70.39935103400006, 40.49019114200003],
              [70.46818404100014, 40.50249013300008],
              [70.47779585800004, 40.50548736600008],
              [70.48787276200011, 40.51556427000013],
              [70.51195398000004, 40.54677683500002],
              [70.52549320500003, 40.55711212200002],
              [70.53944584200008, 40.56186635400012],
              [70.55422530100003, 40.565018616000074],
              [70.56931482000005, 40.570444642000055],
              [70.58207889900007, 40.578764547],
              [70.61716719600014, 40.61194081700002],
              [70.67793868100006, 40.64992299400005],
              [70.6929248460001, 40.660413310000095],
              [70.70723921700011, 40.668991598000034],
              [70.71566247600009, 40.67214386000008],
              [70.73209558100007, 40.67498606400004],
              [70.73550622500005, 40.678861797000096],
              [70.73715987200012, 40.68356435200009],
              [70.74067386900009, 40.68769846700009],
              [70.75617679800007, 40.69513987300003],
              [70.75629278600007, 40.695578051000055],
              [70.75850223800012, 40.703924866000094],
              [70.76713220300007, 40.737617900000075],
              [70.72889164300005, 40.75446441700005],
              [70.63742435700004, 40.770587463000126],
              [70.62176639900008, 40.78598704000011],
              [70.6193376060001, 40.80319529300009],
              [70.62874271700008, 40.81585601800002],
              [70.64868981900008, 40.81750966400007],
              [70.68346805900012, 40.79451365200002],
              [70.7031567790001, 40.78893259700003],
              [70.70512048300003, 40.807432760000026],
              [70.69685225400008, 40.81621775400002],
              [70.51443444800003, 40.97259063700001],
              [70.48291182500003, 40.993519592],
              [70.47975956300007, 40.99646514900009],
              [70.47722741700011, 40.99982411700002],
              [70.45800635800003, 41.01573663300009],
              [70.44570479300012, 41.0259207160001],
              [70.40115970900013, 41.039976705000115],
              [70.36353926600003, 41.032431946000074],
              [70.33589237400008, 40.926960348000094],
              [70.28039188600013, 40.87771270800003],
              [70.20799320500004, 40.844588115000036],
              [70.10422692900005, 40.813323873000044],
              [70.00965905700008, 40.75803009000002],
              [69.82532922400009, 40.71400177000005],
              [69.80331506400012, 40.705630188000086],
              [69.78352299000011, 40.69296946200005],
              [69.74156172700003, 40.652455139000025],
              [69.71768721500013, 40.63628041700004],
              [69.69091882300006, 40.630027568000045],
              [69.6601196690001, 40.638709208000094],
              [69.64751062000005, 40.64744252600006],
              [69.63717533300007, 40.65793284100003],
              [69.6188818760001, 40.68165232400007],
              [69.60782312000009, 40.6917809050001],
              [69.58260502100012, 40.704389954000035],
              [69.57082279400004, 40.712451478000034],
              [69.53185876500004, 40.75859853100006],
              [69.5092244870001, 40.77466990200013],
              [69.4772884520001, 40.77704701800009],
              [69.46168217000007, 40.78433339500005],
              [69.44917647400007, 40.794461975],
              [69.43584395300013, 40.80267852900003],
              [69.41775720300012, 40.80422882100005],
              [69.38525272600009, 40.79611562200007],
              [69.36928470900006, 40.789397685000026],
              [69.3550736900001, 40.78035430900009],
              [69.32959720800005, 40.75534291600009],
              [69.31419763200012, 40.729297995000096],
              [69.30716963700007, 40.69932566400006],
              [69.30660119700013, 40.66253204400006],
              [69.31347416200009, 40.60935699500003],
              [69.30934004800008, 40.59581776900005],
              [69.29497399900009, 40.58915151000012],
              [69.23425419100005, 40.58527577800008],
              [69.19844242400006, 40.566517233000084],
              [69.19802901200012, 40.545846660000066],
              [69.23823327700006, 40.493963521000055],
              [69.2383366300001, 40.493963521000055],
              [69.2597306720001, 40.437636211000054],
              [69.26944584200004, 40.41980784100012],
              [69.29549076300003, 40.38394439800008],
              [69.30634281400006, 40.36497914700003],
              [69.31269901600007, 40.3428099580001],
              [69.30530928500008, 40.293820699],
              [69.27311486800005, 40.28958323100004],
              [69.23461592700005, 40.300848694000095],
              [69.20836429900004, 40.298316549],
              [69.21249841300005, 40.26875763000008],
              [69.28525883000003, 40.21863149000005],
              [69.28525883000003, 40.19496368500002],
              [69.24769006400004, 40.18173451800003],
              [69.19792565900008, 40.18297475200008],
              [69.10800866700009, 40.20364532500007],
              [69.07363981700007, 40.216940714000046],
              [69.04201786300013, 40.229173483000025],
              [69.01922855600003, 40.23206736300001],
              [68.85655114800005, 40.21274037700006],
              [68.83665572100006, 40.20643585200004],
              [68.80187748200007, 40.19113962800007],
              [68.77846805900003, 40.188762512000054],
              [68.7205387780001, 40.196513978000056],
              [68.69831791200005, 40.19496368500002],
              [68.64273231300007, 40.18369149800013],
              [68.60199304200006, 40.17542999300012],
              [68.58111576400012, 40.16421620800007],
              [68.60695398000013, 40.14230540000001],
              [68.65170577000009, 40.12075632800007],
              [68.68705245000007, 40.11031768800002],
              [68.69654498000011, 40.11173935200007],
              [68.9306551520001, 40.14680125000005],
              [68.97726729300007, 40.12101471000004],
              [68.98377852400012, 40.107010397000025],
              [68.98698246200007, 40.09171417300006],
              [68.98543217000008, 40.07714141900003],
              [68.97726729300007, 40.06489410400009],
              [68.95452966300007, 40.0620519000001],
              [68.88176924700008, 40.070836894000095],
              [68.86151208500007, 40.06582428000003],
              [68.82606205300004, 40.04205312100008],
              [68.81314294400005, 40.03890085900012],
              [68.79040531400005, 40.07016510100003],
              [68.7746956790001, 40.07988027000006],
              [68.76172489400011, 40.06148345900006],
              [68.76384362800007, 40.05249176100001],
              [68.7816203210001, 40.04153635700003],
              [68.78503096600014, 40.03393992100008],
              [68.78291223200006, 40.013424377],
              [68.78441084800005, 40.00401926700003],
              [68.78937178500007, 39.9939940390001],
              [68.87742842600011, 39.90056305000003],
              [68.88078739500014, 39.8783421830001],
              [68.83825769100008, 39.86464793000006],
              [68.81536503100006, 39.89188140900008],
              [68.80012048300011, 39.93513458300002],
              [68.77975996900011, 39.96944773300005],
              [68.75888269000012, 39.98055816700007],
              [68.75200972500005, 39.97275502500004],
              [68.75557539900012, 39.95404815700006],
              [68.76523889200013, 39.93244740900009],
              [68.78761478700011, 39.89575714100003],
              [68.78735640500014, 39.881701152000105],
              [68.77521244300004, 39.862529195],
              [68.77144006400005, 39.86051381400004],
              [68.76094974800009, 39.859118550000076],
              [68.75753910300006, 39.85751658200003],
              [68.75040775600013, 39.84247874000006],
              [68.75061446100005, 39.841083476000065],
              [68.75051110800013, 39.83607086200003],
              [68.74834069800005, 39.82614898700011],
              [68.74162276200013, 39.81963775700005],
              [68.72818689000007, 39.824960429],
              [68.70152185100005, 39.858446757000095],
              [68.68508874500009, 39.868006897000086],
              [68.65108565300011, 39.84470082600005],
              [68.63775313400009, 39.848938294],
              [68.62617761200005, 39.84961008800009],
              [68.61584232600006, 39.82811269200006],
              [68.60581709800005, 39.66688222300003],
              [68.60033939700014, 39.64285268200011],
              [68.58700687700014, 39.62316396100006],
              [68.56292566000008, 39.60357859300005],
              [68.5202409260001, 39.58254628500002],
              [68.50670170100011, 39.56756012000007],
              [68.51015830600011, 39.56141135100005],
              [68.51726770800008, 39.54876482000013],
              [68.51745039900004, 39.54843984000006],
              [68.49771000100003, 39.54141184500004],
              [68.43626672400006, 39.52880279600002],
              [68.38660567200009, 39.52518544600004],
              [68.33756473800014, 39.527924296],
              [68.25586429900005, 39.55055857400005],
              [68.10620935100008, 39.554124248],
              [67.76452478000004, 39.622595520000104],
              [67.71760258000006, 39.62337066700012],
              [67.68044722500008, 39.61412058600011],
              [67.58737797100008, 39.5626508590001],
              [67.50743453000007, 39.55293569000007],
              [67.48764245600012, 39.53800120000004],
              [67.49456709800006, 39.493714498000074],
              [67.49115645400008, 39.49009714800009],
              [67.48702233900013, 39.487151591],
              [67.48237146000008, 39.485291239],
              [67.47741052200013, 39.48441274000005],
              [67.45167565900005, 39.487151591],
              [67.43648278800003, 39.485704651],
              [67.42728438300009, 39.47660959900004],
              [67.41477868600003, 39.43811065700008],
              [67.4081641030001, 39.39790639300007],
              [67.40707889900011, 39.36100942000003],
              [67.39441817300008, 39.327368063000094],
              [67.38687341300005, 39.29419179300008],
              [67.38025883000012, 39.29233144100006],
              [67.37126713000009, 39.29450185100005],
              [67.36062178500009, 39.291763],
              [67.35121667500005, 39.285251770000045],
              [67.34646244300006, 39.28080759700005],
              [67.34439538600009, 39.27383127900005],
              [67.34269006300013, 39.259568583000075],
              [67.3500372960001, 39.22005794600007],
              [67.35007979400012, 39.21982940700006],
              [67.37819177300008, 39.19949473100006],
              [67.49901127100009, 39.16598256400003],
              [67.5803499760001, 39.163605449],
              [67.61983077000014, 39.15125478100005],
              [67.62417159000012, 39.147379049000094],
              [67.63212976100004, 39.13621693900005],
              [67.6377108150001, 39.13154022300007],
              [67.64453210500005, 39.13061004700005],
              [67.66117191600006, 39.13337473600008],
              [67.66757979300007, 39.131772767000044],
              [67.67658139500008, 39.119821488000085],
              [67.67672652200008, 39.11962880500006],
              [67.67858687400008, 39.10593455000013],
              [67.66721805800012, 39.02836822600004],
              [67.67218541700004, 39.00399232200006],
              [67.67223067200007, 39.00377024400008],
              [67.6732541990001, 39.00297802200008],
              [67.69052412900004, 38.989610901000034],
              [67.81837162300008, 38.97341034000003],
              [67.84524336700008, 38.973772075000014],
              [67.92115604700007, 38.99379669200006],
              [67.92125940000011, 38.993874207],
              [67.92151778200008, 38.993874207],
              [67.93485030200009, 38.999067689000086],
              [67.94890629000014, 39.0020132450001],
              [67.96327233900013, 39.00190989200006],
              [67.9801188560001, 38.997388205000036],
              [67.98797367400005, 38.99377085400006],
              [68.00337325100014, 38.982117819000095],
              [68.01980635600012, 38.97968902600003],
              [68.03644616700012, 38.9843915820001],
              [68.05308597900006, 38.9939517210001],
              [68.06094079600007, 38.99552785300004],
              [68.06910567200009, 38.99609629300009],
              [68.0772705490001, 38.99552785300004],
              [68.08507369000006, 38.9939517210001],
              [68.08528039600009, 38.9939517210001],
              [68.08543542500013, 38.99379669200006],
              [68.0856421310001, 38.99377085400006],
              [68.10093835400005, 38.97927561500002],
              [68.1346830650001, 38.92098459900008],
              [68.15338640700008, 38.899402540000054],
              [68.16372522000012, 38.88747243300007],
              [68.17369877100003, 38.86731862400008],
              [68.17256189000011, 38.845278626000024],
              [68.16367354300007, 38.82863881400009],
              [68.15127120000011, 38.81512542800003],
              [68.13597497600006, 38.80450592100003],
              [68.11902510600004, 38.7967027800001],
              [68.09561568300012, 38.79293040000009],
              [68.07789066600009, 38.793395488],
              [68.06672855600004, 38.78796946200005],
              [68.06331791200012, 38.766317038000054],
              [68.06631514500003, 38.756214295000106],
              [68.07220625900004, 38.747351786000095],
              [68.07665043100013, 38.73810170500009],
              [68.07592696200004, 38.72686208100002],
              [68.07075931800006, 38.72073842400006],
              [68.04548954300009, 38.70670827300005],
              [68.03763472500003, 38.69164459200006],
              [68.0403219000001, 38.67335113500009],
              [68.05370609500011, 38.635937398000024],
              [68.05587650600012, 38.61573191400005],
              [68.05251753800007, 38.558267721000036],
              [68.0551530350001, 38.536305237000064],
              [68.06259444200003, 38.52307607000007],
              [68.08688236500012, 38.49403391500006],
              [68.09256677300004, 38.47878936800002],
              [68.09463383000013, 38.44698252400009],
              [68.09804447400006, 38.432435608000034],
              [68.10755293800014, 38.41827626600009],
              [68.14672367300011, 38.38874318500005],
              [68.18372399900005, 38.33549062100009],
              [68.20082889800011, 38.32169301400005],
              [68.25266036000005, 38.298748678000024],
              [68.33203536000013, 38.24298980700006],
              [68.35621993000012, 38.212604065],
              [68.36066410300003, 38.17405344700002],
              [68.34433435000005, 38.115452372],
              [68.31952966300014, 38.060210266000084],
              [68.28056563300004, 38.01323639000013],
              [68.26857670100009, 37.99419362400006],
              [68.26847334800004, 37.994116110000036],
              [68.26847334800004, 37.99398691800009],
              [68.26836999500006, 37.99390940400009],
              [68.26826664200013, 37.99383188900005],
              [68.26077355900009, 37.97677866600013],
              [68.25622603400012, 37.96155995700009],
              [68.24873295100008, 37.948950907000054],
              [68.23802450700003, 37.94271605600004],
              [68.23302331600013, 37.93980417900009],
              [68.21772709100009, 37.936083476000064],
              [68.17111495000012, 37.931070863000016],
              [68.13995406100014, 37.92269928000003],
              [68.12222904500004, 37.90833323200003],
              [68.07964766500004, 37.806272279],
              [68.05019209800014, 37.76040944400005],
              [67.97732832900004, 37.67974253400003],
              [67.92337813300009, 37.638788961],
              [67.8718567300001, 37.58680247000008],
              [67.8292236740001, 37.52794301400009],
              [67.80121504700008, 37.466448060000076],
              [67.79733931500004, 37.42443512000004],
              [67.81718306500005, 37.34542185500008],
              [67.82064538600008, 37.30330556300005],
              [67.81542606600004, 37.267338766000066],
              [67.80395389900013, 37.233439026000056],
              [67.78509200100012, 37.20357004800003],
              [67.78054447500011, 37.18886810300005],
              [67.77599694800006, 37.207549134000104],
              [67.76426639800007, 37.220881653000035],
              [67.74659305800009, 37.22940826500006],
              [67.72587080900013, 37.23354237900007],
              [67.69016239400014, 37.23225046800003],
              [67.6775016680001, 37.23354237900007],
              [67.6664429120001, 37.238012391],
              [67.64463545700005, 37.251215719000086],
              [67.63316329000014, 37.25405792300005],
              [67.62179447400007, 37.25292104100005],
              [67.60272587100008, 37.248270162],
              [67.59228723100006, 37.2471849570001],
              [67.58603438300014, 37.24261159300006],
              [67.57993656400009, 37.23266388000006],
              [67.57218509900008, 37.22315541600007],
              [67.56138472500004, 37.21989980100007],
              [67.54500329600012, 37.231526998000035],
              [67.52614139800005, 37.27289398200007],
              [67.50314538600014, 37.281963196000035],
              [67.48237146000008, 37.277363993000094],
              [67.46397465000007, 37.266279398000066],
              [67.43110843900007, 37.239769389000074],
              [67.41126468900006, 37.22790964800005],
              [67.39116255700009, 37.219589742],
              [67.36951013200013, 37.21468048100006],
              [67.3452222090001, 37.213026836000026],
              [67.31959069800007, 37.208427633000056],
              [67.2814534910001, 37.18866139800009],
              [67.25912927200011, 37.18514740000005],
              [67.23675337700013, 37.19240793900009],
              [67.22528121000005, 37.20770416300006],
              [67.21799483200004, 37.2262560030001],
              [67.20796960500013, 37.243464254000074],
              [67.18781579600005, 37.2582437140001],
              [67.1434774170001, 37.271860453],
              [67.12332360900012, 37.281963196000035],
              [67.11391849800009, 37.29718190500007],
              [67.09738203900008, 37.34059010800006],
              [67.08508304900005, 37.34963348400002],
              [67.06410241700013, 37.35456858300007],
              [67.02410485800004, 37.3774870810001],
              [67.00591475400012, 37.38438588500007],
              [66.95764896600008, 37.385212708],
              [66.86576827000005, 37.36792694100011],
              [66.73497522000008, 37.36330190000005],
              [66.72443322700013, 37.360149638000095],
              [66.7047445070001, 37.34653289900008],
              [66.6940991620001, 37.34340647400005],
              [66.66702071100013, 37.344310811000085],
              [66.65467004400006, 37.34614532500008],
              [66.58857588700005, 37.368469543000046],
              [66.5645980220001, 37.37069163100004],
              [66.53901818900005, 37.3690896610001],
              [66.51958785000011, 37.36418040000008],
              [66.49483483900008, 37.37942494800002],
              [66.49700524900004, 37.397744242],
              [66.51209476800005, 37.414823303000034],
              [66.53080163600004, 37.43014536600002],
              [66.54661462400014, 37.45079010000002],
              [66.54268721500006, 37.466758118000044],
              [66.52682255100007, 37.48037485800005],
              [66.5071338300001, 37.493836568000106],
              [66.49349125100008, 37.522206929000035],
              [66.49721195400008, 37.55788950600002],
              [66.51912276300004, 37.625249736000015],
              [66.5229468180001, 37.66504058900004],
              [66.51498864700005, 37.743485413000045],
              [66.5188127030001, 37.782707825],
              [66.55364261900013, 37.83200714200008],
              [66.6090397540001, 37.88918711400002],
              [66.64578169800006, 37.94590199800005],
              [66.63652367000003, 37.966593133000075],
              [66.62433597800003, 37.99383188900005],
              [66.62423262600004, 37.993883566000065],
              [66.62402592000007, 37.99401275700011],
              [66.59038456200011, 38.01297800700006],
              [66.55415938400006, 38.02685312900003],
              [66.5159188230001, 38.03509552000007],
              [66.43943770400011, 38.03545725500008],
              [66.40832849200007, 38.04284698500008],
              [66.30693933100008, 38.080389914000065],
              [66.26043054200005, 38.126743673000064],
              [66.23107832900007, 38.14878367200005],
              [66.19841882400004, 38.160720927000014],
              [66.13356490000007, 38.17529368100007],
              [66.07160485800006, 38.21454193200013],
              [66.04349287900004, 38.2261949670001],
              [65.97745039900008, 38.234566549000064],
              [65.87668135600012, 38.272962138000096],
              [65.84288496900012, 38.27533925400006],
              [65.81435957800005, 38.26619252600007],
              [65.76599043800013, 38.23554840100003],
              [65.74020389800012, 38.22407623400004],
              [65.67162927300006, 38.21968373600002],
              [65.60413985200006, 38.237408753000054],
              [65.43960209100004, 38.32494862900002],
              [65.34017663600014, 38.37781362],
              [65.2053011480001, 38.44964386000002],
              [65.11083663000011, 38.51726247200007],
              [64.97771813900005, 38.61226959200009],
              [64.9105387780001, 38.64534250900009],
              [64.7633642990001, 38.68601186100004],
              [64.63489668800008, 38.744147848000026],
              [64.42431522600009, 38.88295074500003],
              [64.3675663030001, 38.94037404600006],
              [64.33734379100014, 38.97095570900005],
              [64.3135726320001, 38.98247955300009],
              [64.28339359600011, 38.97968902600003],
              [64.20598230000007, 38.9494583140001],
              [64.18014408400006, 38.94511749300004],
              [64.15058516400012, 38.9494583140001],
              [64.12061283400004, 38.96167978900003],
              [63.95969242400014, 39.05136423800009],
              [63.820062703000076, 39.129137268000036],
              [63.7092684320001, 39.190890605],
              [63.64849694800006, 39.23951812800003],
              [63.54100996900007, 39.356100159],
              [63.47755131000014, 39.40291900700002],
              [63.33864506000009, 39.47945180300012],
              [63.008949423000104, 39.661094462000065],
              [62.84647871900006, 39.750598043000096],
              [62.71015629100003, 39.8257355760001],
              [62.59316084800014, 39.89022776300003],
              [62.53538659700007, 39.934979553000076],
              [62.52458622200004, 39.93973378500009],
              [62.4528076580001, 40.00923858600005],
              [62.44195560700007, 40.03595530200003],
              [62.424385620000066, 40.09212758400007],
              [62.42159509200013, 40.115071920000034],
              [62.42578088300007, 40.13667266900008],
              [62.434100790000116, 40.154811097],
              [62.43968184400006, 40.172897848000034],
              [62.43575443500009, 40.194188538],
              [62.405058635000046, 40.245244853000074],
              [62.400976196000045, 40.265605368000124],
              [62.400201050000135, 40.292115377000115],
              [62.396532023000134, 40.31201080300012],
              [62.38831547100011, 40.33014923200007],
              [62.36258060800009, 40.369681702],
              [62.35637943500012, 40.38818186500002],
              [62.353278850000095, 40.430401510000095],
              [62.34361535600004, 40.439393209000045],
              [62.260933065000074, 40.4757217410001],
              [62.21344242400005, 40.486573792000044],
              [62.19184167500009, 40.49902781200005],
              [62.187061257000096, 40.50551552200001],
              [62.185330445000034, 40.507864482000045],
              [62.17726892100006, 40.53065378900003],
              [62.171377808000045, 40.53995554700005],
              [62.13417077600013, 40.577834372000055],
              [62.120683227000086, 40.59897003200008],
              [62.100064331000056, 40.660413310000095],
              [62.08869551600009, 40.674365947000084],
              [62.055725952000046, 40.70175445600002],
              [62.044770549000134, 40.71498362200002],
              [62.03681237800009, 40.73632598900012],
              [62.02534021000008, 40.78195627900003],
              [61.993869263000136, 40.86587880400002],
              [61.98270715300009, 40.885670878],
              [61.99025191200013, 40.89316396100013],
              [61.9853943280001, 40.90789174500013],
              [61.98270715300009, 40.978430075000105],
              [61.97929650900005, 40.99884226500005],
              [61.97082157400007, 41.01543039900004],
              [61.8974410400001, 41.10880971300013],
              [61.87790734900011, 41.12498443600002],
              [61.65435510300006, 41.249421285000025],
              [61.56733199100012, 41.27779164700003],
              [61.47007694500007, 41.297170309000094],
              [61.43317997200006, 41.30032257100005],
              [61.41075240100008, 41.2920026660001],
              [61.397213175000104, 41.27097035800007],
              [61.387498006000044, 41.23577870700002],
              [61.3630033770001, 41.22518503900004],
              [61.343986450000045, 41.19381744400003],
              [61.315874471000086, 41.170459697000084],
              [61.28135461400012, 41.157282207],
              [61.24321740800008, 41.15630035400004],
              [61.202599731000134, 41.16880605100003],
              [61.099660279000034, 41.22409983300004],
              [61.08188358600012, 41.22451324500007],
              [61.02276574700005, 41.21686513300007],
              [61.01718469200006, 41.22596018500006],
              [61.01408410700009, 41.23490020800007],
              [61.010260051000046, 41.23722564700002],
              [61.00431806800003, 41.229533188000104],
              [60.991139771000064, 41.21247263600007],
              [60.984628540000074, 41.20699493500008],
              [60.97801395700009, 41.20280914400006],
              [60.930264933000046, 41.24022288000002],
              [60.86029504400011, 41.2529869590001],
              [60.65886031100007, 41.243788554],
              [60.53814416500006, 41.213247782000096],
              [60.478096151000045, 41.21211090200008],
              [60.443266235000124, 41.21965566000004],
              [60.414534140000114, 41.23526194300008],
              [60.36027388600007, 41.276344706000046],
              [60.29991581200005, 41.309831035000045],
              [60.20369429600004, 41.34708974200005],
              [60.09424361200007, 41.3895160930001],
              [60.066131633000055, 41.4104967250001],
              [60.05920699100005, 41.43416453100012],
              [60.07171268700006, 41.51436635400002],
              [60.07956750500006, 41.53147125200006],
              [60.09258996600005, 41.545475566000064],
              [60.10964318900005, 41.556792704000046],
              [60.1509843340001, 41.57234731100006],
              [60.16473026500012, 41.58495636],
              [60.15563521300004, 41.60332733200009],
              [60.08907596900008, 41.67412404400004],
              [60.05827681500011, 41.718591614],
              [60.049181763000036, 41.753499044000094],
              [60.07491662600012, 41.78104258300006],
              [60.102408488000094, 41.795279440000044],
              [60.13372440600011, 41.797294821],
              [60.171344849000036, 41.78840647400007],
              [60.205864705000124, 41.77202504500012],
              [60.225398397000106, 41.76546213800013],
              [60.2411080330001, 41.76706410700008],
              [60.25268355300011, 41.7800607300001],
              [60.250823202000106, 41.79427175000008],
              [60.2411080330001, 41.80806935700012],
              [60.228912395000066, 41.819619039000045],
              [60.214856405000035, 41.82858490000008],
              [60.16752079300011, 41.84959137],
              [60.15253462700008, 41.86119272900005],
              [60.14114411600008, 41.874221484000074],
              [60.11822147700008, 41.90044097900001],
              [60.08876591000006, 41.91935455300005],
              [59.983656046000135, 41.949042663000014],
              [59.93177290800014, 41.94764740000004],
              [59.91751021300007, 41.952427471000036],
              [59.90645145700006, 41.96661265100009],
              [59.90800174900005, 41.979815979000065],
              [59.919267212000136, 41.98966034000004],
              [59.936940551000134, 41.993484395000095],
              [59.93725061100014, 41.99340688100007],
              [59.937560669000106, 41.99340688100007],
              [59.937870727000075, 41.99340688100007],
              [59.99719527200011, 42.01061513300006],
              [59.99409468600004, 42.05009592800006],
              [59.97445764200012, 42.09924021500002],
              [59.983656046000135, 42.14559397400002],
              [60.0000891520001, 42.15450815900006],
              [60.020553020000136, 42.16078684500006],
              [60.03698612400012, 42.16970102900008],
              [60.04039676900004, 42.18647003200003],
              [60.02820113100012, 42.19951833200007],
              [60.005050090000054, 42.20977610300007],
              [59.9607117110001, 42.22272104900007],
              [59.925675090000084, 42.246285502],
              [59.897873169000036, 42.278531596000036],
              [59.866350545000046, 42.30421478300012],
              [59.82097863800004, 42.30798716200006],
              [59.776330200000075, 42.303956401000065],
              [59.689513794000106, 42.30979583800003],
              [59.47815718600009, 42.28563710600007],
              [59.426480754000124, 42.286773987000075],
              [59.401469360000135, 42.29390533500002],
              [59.36157515400009, 42.325789694],
              [59.33811405500012, 42.331809998000026],
              [59.287161093000066, 42.33594411300005],
              [59.25842899600008, 42.347545471],
              [59.24519982900006, 42.36534800300002],
              [59.233314250000035, 42.44172576900009],
              [59.22380578600007, 42.460871888000085],
              [59.20964644400004, 42.47771840500006],
              [59.146084432000066, 42.526759339000094],
              [59.12200321500012, 42.53799896200003],
              [59.09647505700008, 42.5359835820001],
              [59.067432902000064, 42.52557078000005],
              [59.038597453000136, 42.51973134400008],
              [59.00924523900005, 42.51846527100004],
              [58.96470015500006, 42.524382223000046],
              [58.89442020700005, 42.547843323],
              [58.8274475500001, 42.593757833],
              [58.61226688700003, 42.780852356000125],
              [58.58787561100007, 42.79118764300004],
              [58.56937544700014, 42.768501689000075],
              [58.55573287000004, 42.68359731],
              [58.534545532000095, 42.65450348000009],
              [58.49320438600006, 42.64546010400004],
              [58.44183801300011, 42.647837220000085],
              [58.3905749920001, 42.65667389],
              [58.28267460200004, 42.68891998300005],
              [58.258283325000036, 42.689514262],
              [58.239576457000055, 42.68514760400002],
              [58.186556437000036, 42.66119557800003],
              [58.148832642000116, 42.64899993900009],
              [58.13064253700014, 42.63884552000003],
              [58.12134078000014, 42.62424692800006],
              [58.12702518700007, 42.60499745700004],
              [58.14573205600004, 42.59256927600008],
              [58.27099572800006, 42.54903188100003],
              [58.30623905400006, 42.528671367000115],
              [58.33703820800014, 42.49371226],
              [58.363703247000046, 42.44707428000005],
              [58.43791060400014, 42.35769989000006],
              [58.47821822100008, 42.32232737200003],
              [58.4895870360001, 42.31452423100002],
              [58.49413456200011, 42.30571339900003],
              [58.49062056500014, 42.29757436100003],
              [58.47821822100008, 42.291993307],
              [58.41393273900013, 42.28475860700003],
              [58.397602987000084, 42.287859192000084],
              [58.38582076000006, 42.30132090300005],
              [58.38613081800008, 42.31684967100004],
              [58.39150516800004, 42.333980408000016],
              [58.39491581300007, 42.35224802700007],
              [58.38468387900008, 42.38782725100005],
              [58.358949016000054, 42.41340708500009],
              [58.32504927600007, 42.43185557],
              [58.22572717300011, 42.46658213300013],
              [58.203816366000126, 42.46950185100003],
              [58.18572961400014, 42.467253927000016],
              [58.14945275900004, 42.455678406000075],
              [58.13322636000004, 42.45456736200008],
              [58.11720666500008, 42.46151784300007],
              [58.0943656820001, 42.48671010400001],
              [58.07989628100006, 42.49730377200008],
              [58.060879354000065, 42.50226470900013],
              [58.038245077000056, 42.50278147400006],
              [58.016024210000126, 42.49970672600004],
              [57.99773075300004, 42.493428040000126],
              [57.98708540800004, 42.48342865000002],
              [57.978300415000035, 42.471775615000055],
              [57.95277225800004, 42.450071513000054],
              [57.925590454000144, 42.44110565300012],
              [57.908640584000125, 42.43043446900002],
              [57.91432499200005, 42.40395029700004],
              [57.93571903500009, 42.369818014000046],
              [57.93747603300005, 42.35423757000011],
              [57.92879439300003, 42.33093149800008],
              [57.888073364000036, 42.261581727000035],
              [57.873707316000036, 42.24964447000009],
              [57.83546675700006, 42.2404460660001],
              [57.82730188000005, 42.22737192800004],
              [57.834536581000066, 42.21163645400007],
              [57.847352336000085, 42.200913595000046],
              [57.850452922000045, 42.19143096900008],
              [57.82843876200013, 42.17954539000006],
              [57.80921512900011, 42.1763931280001],
              [57.740898885000036, 42.17874440500013],
              [57.72157189900008, 42.175333761],
              [57.666278117000104, 42.1551024380001],
              [57.61976932800013, 42.14817779600013],
              [57.47827925600012, 42.16652293000003],
              [57.38226444500003, 42.16362904900002],
              [57.28821333800005, 42.129419251000044],
              [57.207804810000084, 42.07055979400003],
              [57.15292443900012, 41.993742778000055],
              [57.15292443900012, 41.993484395000095],
              [57.11551070200005, 41.95209157300006],
              [57.074376261000054, 41.9287855030001],
              [56.97836145000008, 41.89511830600007],
              [56.95014611800008, 41.86605031400008],
              [56.94983605900012, 41.8274996950001],
              [56.97195357300012, 41.748538106000055],
              [56.969473104000144, 41.71089182500002],
              [56.96161828600003, 41.678723247000065],
              [56.96048140500011, 41.6472006230001],
              [56.97836145000008, 41.61146637000009],
              [57.00058231600008, 41.58402618400005],
              [57.01205448400003, 41.55782623300003],
              [57.01577518700003, 41.52899078400007],
              [57.01505171700012, 41.49364410400007],
              [57.01959924300007, 41.46594553700005],
              [57.03303511500013, 41.43824696900005],
              [57.05225874800004, 41.41359731100003],
              [57.07416955500008, 41.394993795000076],
              [57.08832889800004, 41.387294007],
              [57.103625122000096, 41.38160959900004],
              [57.15375126100014, 41.37235951800004],
              [57.1613993740001, 41.36796702100004],
              [57.15922896300003, 41.36114573200008],
              [57.14796350100005, 41.35106882700005],
              [57.12667281100005, 41.339596660000026],
              [57.08006066900009, 41.322026672000064],
              [57.060320272000126, 41.30492177400002],
              [57.02952111800005, 41.262598776000104],
              [57.01019413200004, 41.254123841000094],
              [56.8879276940001, 41.27334747400003],
              [56.793463176000046, 41.2883336390001],
              [56.5700142820001, 41.29748036700009],
              [56.53372131600014, 41.29896879500005],
              [56.32682499200013, 41.30745391900008],
              [56.14068648300008, 41.315153707],
              [55.978422486000056, 41.32171661400007],
              [55.97821577900004, 41.55126332600004],
              [55.978009074000056, 41.780680848000074],
              [55.97790572100013, 42.01015004500003],
              [55.9776990150001, 42.239619243000064],
              [55.977595663000045, 42.46908844000002],
              [55.97738895700007, 42.698531799000065],
              [55.97728560400009, 42.9280009970001],
              [55.977078898000116, 43.157470194000055],
              [55.97697554500007, 43.386913555],
              [55.976768839000044, 43.616382752000035],
              [55.976665487000105, 43.845851950000096],
              [55.97645878100013, 44.075295309000026],
              [55.97635542800003, 44.30484202100011],
              [55.97614872300005, 44.53428538100006],
              [55.97604537000012, 44.7637804160001],
              [55.97583866300005, 44.99327545200005],
              [55.97583866300005, 44.99337880400007],
              [55.97583866300005, 44.993482157000116],
              [55.97583866300005, 44.993585511000035],
              [55.97583866300005, 44.99374054],
              [55.97583866300005, 44.99389556900003],
              [55.97583866300005, 44.99405059800007],
              [55.97583866300005, 44.9942056280001],
              [55.97583866300005, 44.99430898000004],
              [55.97583866300005, 44.99441233300006],
              [55.97594201700008, 44.99446401000007],
              [55.97604537000012, 44.994567363],
              [55.97604537000012, 44.99467071600013],
              [55.97604537000012, 44.99477406800007],
              [55.97614872300005, 44.994825745000085],
              [55.97614872300005, 44.99498077400001],
              [55.97614872300005, 44.995084127000055],
              [55.976252075000104, 44.99513580400007],
              [55.97635542800003, 44.995239156000096],
              [55.97645878100013, 44.995342509000025],
              [55.97656213400006, 44.99539418600004],
              [55.976665487000105, 44.99544586200004],
              [55.976768839000044, 44.995497539000056],
              [55.976768839000044, 44.9956008920001],
              [55.976872192000144, 44.9956008920001],
              [55.97697554500007, 44.99570424400012],
              [55.977078898000116, 44.995755920000036],
              [55.977182251000045, 44.99580759700005],
              [55.97728560400009, 44.99585927300005],
              [55.97738895700007, 44.99585927300005],
              [55.977492310000116, 44.99591095000007],
              [55.977595663000045, 44.99591095000007],
              [55.9776990150001, 44.995962627],
              [55.977802368000084, 44.9960659800001],
              [55.97790572100013, 44.9960659800001],
              [55.978009074000056, 44.9960659800001],
              [55.9781124270001, 44.996169332000036],
              [55.97821577900004, 44.996169332000036],
              [55.97831913200014, 44.99622100800006],
              [55.978422486000056, 44.99622100800006],
              [56.07206018100004, 45.01756337500005],
              [56.16580122900007, 45.038802389000026],
              [56.25943892500004, 45.06009307900011],
              [56.35338667900004, 45.08143544500011],
              [56.44712772600013, 45.1027261360001],
              [56.5408687740001, 45.12401682600007],
              [56.63450647000013, 45.145307515000056],
              [56.70760971000004, 45.1619108980001],
              [56.7282475180001, 45.166598206000046],
              [56.822091919000115, 45.18788889600005],
              [56.91572961400004, 45.209127910000106],
              [57.009470663000116, 45.23041859900009],
              [57.103211710000096, 45.251760967000095],
              [57.1970561120001, 45.27299998000005],
              [57.29079716000007, 45.29434234700007],
              [57.38453820800004, 45.31563303700004],
              [57.47827925600012, 45.33692372600002],
              [57.603232870000056, 45.36389882500005],
              [57.728186483000115, 45.390925599000084],
              [57.853243449000104, 45.417900696000046],
              [57.978300415000035, 45.44492747000008],
              [58.03607466600005, 45.457071431000074],
              [58.09384891800005, 45.46911204100006],
              [58.15162316900006, 45.481204326000025],
              [58.2096041260001, 45.493348288000035],
              [58.26975549300005, 45.505543926000044],
              [58.33001021400014, 45.51784291600008],
              [58.39026493400007, 45.53014190700013],
              [58.45041630100013, 45.54238922200007],
              [58.53144494700007, 45.558718974],
              [58.55490604600004, 45.55716868100008],
              [58.582191203000036, 45.54869374600007],
              [58.65898238200009, 45.512261861000056],
              [58.68078983600003, 45.50182322300013],
              [58.74311161300005, 45.4722643030001],
              [58.840470011000036, 45.42601389600013],
              [58.96790409400006, 45.36544911700007],
              [59.05513216600008, 45.32402317500005],
              [59.12034956900004, 45.29305043500001],
              [59.29243208800011, 45.21124664300008],
              [59.47939742000011, 45.12246653200005],
              [59.67576786300009, 45.029138896000106],
              [59.876582479000035, 44.93379587800008],
              [60.07667362400008, 44.83865956600006],
              [60.27087365700004, 44.746468812],
              [60.45401493300011, 44.659445699000045],
              [60.621136516000035, 44.58007070000009],
              [60.76686405500004, 44.51082428000008],
              [60.88623661300005, 44.45413523400008],
              [60.97398319500007, 44.41243235300003],
              [61.03630497200004, 44.382821758],
              [61.06214318900004, 44.36199615500003],
              [61.080229940000095, 44.33548614500005],
              [61.0866378180001, 44.31119822200013],
              [61.0931490480001, 44.259418437000065],
              [61.10286421700005, 44.23606069000003],
              [61.1616719970001, 44.168106181000056],
              [61.276393677000044, 44.07886098200002],
              [61.33117069500014, 44.036176249],
              [61.38605106600005, 43.99343984000008],
              [61.456124308000085, 43.93517466300007],
              [61.513485148000086, 43.887244772000045],
              [61.571052694000116, 43.83928904300011],
              [61.62851688600006, 43.791359152],
              [61.685981079000044, 43.74342926100006],
              [61.74210168400003, 43.69653289900002],
              [61.798325643000055, 43.649584860000076],
              [61.85454960200008, 43.60268849700013],
              [61.91067020700012, 43.55581797300009],
              [61.985704386000066, 43.493341166],
              [62.00596154800007, 43.486984965],
              [62.026115357000094, 43.48062876500005],
              [62.02832051600012, 43.48092238300002],
              [62.110916382000084, 43.49192006500003],
              [62.14605635600009, 43.496674297000126],
              [62.18140303500007, 43.50142852900011],
              [62.216749716000095, 43.5061569220001],
              [62.25188968900011, 43.51085947700007],
              [62.3084237060001, 43.51840423600002],
              [62.3648543700001, 43.52600067100009],
              [62.42128503400005, 43.53359710700006],
              [62.477715698000054, 43.541116029000094],
              [62.56897627800009, 43.55189056400012],
              [62.660236857000086, 43.56271677600007],
              [62.75149743700007, 43.573491313],
              [62.842861369000104, 43.58429168800002],
              [62.93412194900009, 43.595066223000046],
              [63.02538252800008, 43.60584076],
              [63.11664310700007, 43.61661529600009],
              [63.2080070400001, 43.627467347000064],
              [63.36034916200009, 43.61741628100002],
              [63.512691284000084, 43.607261861000055],
              [63.66513676000011, 43.59728831000005],
              [63.81737552900006, 43.587237244000036],
              [63.95592004400004, 43.57806467800005],
              [64.0946712650001, 43.56891794900004],
              [64.23316410300004, 43.55971954400006],
              [64.37165694200007, 43.55059865400007],
              [64.42674401800014, 43.547032979],
              [64.44421065300008, 43.550676168000095],
              [64.46157393400011, 43.55431935700007],
              [64.56213627200003, 43.594807842000094],
              [64.65835778800005, 43.633591003000035],
              [64.75762821400014, 43.67361440000009],
              [64.85503829000004, 43.71291432800008],
              [64.8730733640001, 43.717823588],
              [64.89100508600006, 43.72278452500005],
              [64.90702478100013, 43.72097585000007],
              [64.92294112200005, 43.71911549900007],
              [64.93958093300006, 43.70828928700011],
              [64.95653080300008, 43.69735972100004],
              [65.06422448700005, 43.59555715000009],
              [65.17191817200012, 43.493677063000106],
              [65.22173425300014, 43.455281474000074],
              [65.27144698100005, 43.417015076000084],
              [65.37448978700007, 43.36991200800007],
              [65.47737756300012, 43.32280894000009],
              [65.49716963700007, 43.310019023],
              [65.51691003400003, 43.29722910600013],
              [65.60186608900005, 43.169019877],
              [65.6561263430001, 43.087216085000065],
              [65.73105717000004, 42.97422556600007],
              [65.79523929800007, 42.8772030650001],
              [65.80402429200007, 42.876479594],
              [65.81260258000009, 42.87575612400012],
              [65.9569348550001, 42.93301361100008],
              [66.10126713100004, 42.99032277500005],
              [66.07971805900007, 42.74194000300007],
              [66.05816898600011, 42.49360890700008],
              [66.05568851700014, 42.467253927000016],
              [66.05320804800004, 42.440873109000066],
              [66.0481437580001, 42.4322689830001],
              [66.04318282100013, 42.42366485600009],
              [66.03140059400005, 42.420254212000046],
              [66.01961836700013, 42.416843567000015],
              [66.01672448700003, 42.40994476300004],
              [66.01372725400006, 42.40302012100007],
              [66.01315936400005, 42.37286994600005],
              [66.01005822800005, 42.20822581000003],
              [66.00649255300004, 42.01343149900002],
              [66.00752608200014, 42.00805714900007],
              [66.00866296400005, 42.002656962000074],
              [66.01290043200004, 42.00007314100007],
              [66.01724125100009, 41.99761851],
              [66.13764733900013, 41.997230937000026],
              [66.24735640500012, 41.996920878000125],
              [66.35660038200007, 41.99663665800004],
              [66.47736820500012, 41.99622324700003],
              [66.48119226100005, 41.99663665800004],
              [66.48480961100012, 41.997024231000054],
              [66.48863366700004, 41.996895040000126],
              [66.49240604700009, 41.996791687],
              [66.49576501500013, 41.99617157100003],
              [66.49917565900006, 41.99560313000008],
              [66.50165612800004, 41.99451792400008],
              [66.50413659700007, 41.993484395000095],
              [66.5214482020001, 41.86710968000007],
              [66.53886315900013, 41.74076080400003],
              [66.57069584100009, 41.617305807],
              [66.60263187700014, 41.49379913400013],
              [66.6455233150001, 41.3464696250001],
              [66.68820804900008, 41.19919179300008],
              [66.71073897400004, 41.178624573],
              [66.73295983900005, 41.1580573530001],
              [66.75789044400011, 41.15314013600003],
              [66.77409427900005, 41.149944153],
              [66.81528039600005, 41.14188263000001],
              [66.93139733900006, 41.14715362600005],
              [67.02896244300007, 41.151494446000115],
              [67.17479333500012, 41.158109029000016],
              [67.28171187400005, 41.16296661400004],
              [67.40930098500013, 41.168702698000104],
              [67.4905363360001, 41.172423402],
              [67.62024418200014, 41.17836619100002],
              [67.74814335100007, 41.184102275000086],
              [67.75956384300008, 41.18167348300001],
              [67.7709326580001, 41.17929636700008],
              [67.79201664200008, 41.17097646100011],
              [67.81299727400011, 41.16270823200007],
              [67.82395267800007, 41.15976267600006],
              [67.83490808100004, 41.15686879500008],
              [67.8445198980001, 41.15790232400006],
              [67.85413171400006, 41.158987528000054],
              [67.88307051600003, 41.173456929000096],
              [67.91200931800012, 41.187978007000126],
              [67.92467004400004, 41.19417917900002],
              [67.93743412300012, 41.20038035100002],
              [67.94353194200005, 41.18611765500013],
              [67.94947473100007, 41.17190663700008],
              [67.95076664200013, 41.171234843],
              [67.95190352400004, 41.1705630500001],
              [67.95541752200012, 41.164981995000076],
              [67.95893151900009, 41.15945261600008],
              [67.98094567900006, 41.1374901330001],
              [68.00306319200007, 41.115631002000086],
              [68.00812748200013, 41.106742656000065],
              [68.01319177300007, 41.097854309000056],
              [68.01711918200004, 41.0785273230001],
              [68.02114994300007, 41.05914866200003],
              [68.02766117400006, 41.0509321090001],
              [68.03437911000009, 41.04271555600006],
              [68.0403219000001, 41.04643625900006],
              [68.04636804200004, 41.050208639000104],
              [68.05277592000004, 41.05253407800002],
              [68.05908044500006, 41.05475616500003],
              [68.06517826400005, 41.05408437100006],
              [68.07137943500004, 41.053309224000046],
              [68.0768571370001, 41.0479865520001],
              [68.08212813300014, 41.04271555600006],
              [68.08905277600013, 41.05392934200002],
              [68.09597741700009, 41.06514312800006],
              [68.10662276200009, 41.065918274000055],
              [68.11737146000013, 41.066745097000094],
              [68.11933516500005, 41.056099752000094],
              [68.12119551600006, 41.04550608300012],
              [68.1212988690001, 41.04436920200003],
              [68.12145389800014, 41.04328399700002],
              [68.12016198700007, 41.038684795000066],
              [68.11892175300005, 41.03403391600001],
              [68.12367598500003, 41.032845357000085],
              [68.12848189300013, 41.03165680000005],
              [68.12998051000005, 41.03062327100007],
              [68.13132409700012, 41.0296414190001],
              [68.1198519290001, 41.02323354100007],
              [68.10822473200011, 41.016825663000034],
              [68.10403894100011, 41.015223694],
              [68.09969812000008, 41.01362172400006],
              [68.10378055800004, 41.011916403],
              [68.10786299600005, 41.010262757000035],
              [68.11034346500008, 41.0078856410001],
              [68.11266890500013, 41.00550852500005],
              [68.11675134300003, 40.99966908800006],
              [68.12088545700004, 40.99382965200009],
              [68.12078210500005, 40.9795152790001],
              [68.12057539900007, 40.96530426100013],
              [68.11571781500004, 40.948509420000065],
              [68.11075687700009, 40.93166290300009],
              [68.1033154700001, 40.91533315100004],
              [68.09597741700009, 40.898951722],
              [68.08822595200007, 40.88592926100007],
              [68.08057784100004, 40.87295847600005],
              [68.07515181500014, 40.86639556900006],
              [68.0695190830001, 40.85983266200007],
              [68.06212935400009, 40.85352813800007],
              [68.05473962400009, 40.847223612000036],
              [68.04652307200007, 40.8422626750001],
              [68.03820316500008, 40.83719838500012],
              [68.02063317900013, 40.83115224300009],
              [68.00306319200007, 40.82515777700006],
              [67.99861901900005, 40.82205719000011],
              [67.99407149300004, 40.818956605000054],
              [67.99252120000011, 40.81502919500009],
              [67.99091923100013, 40.81110178700003],
              [67.99422652200013, 40.80934478800005],
              [67.99748213700013, 40.80753611300007],
              [68.01732588700014, 40.80428049700008],
              [68.0370662840001, 40.801076559000094],
              [68.05225915500012, 40.79451365200002],
              [68.06750370300006, 40.78800242100006],
              [68.11323734600006, 40.75353424100008],
              [68.15891931200008, 40.71911773700005],
              [68.19240564000012, 40.69901560500007],
              [68.22609867300014, 40.678861797000096],
              [68.2664965780001, 40.66270263500006],
              [68.34392093900004, 40.631732890000094],
              [68.46174320500006, 40.58465566000011],
              [68.46339685100014, 40.5871878060001],
              [68.46505049600006, 40.58971995000009],
              [68.47114831500005, 40.59447418200007],
              [68.47734948800013, 40.59922841400005],
              [68.48489424700006, 40.598918356000084],
              [68.49243900600004, 40.5986082970001],
              [68.49631473800008, 40.60212229500006],
              [68.49988041200004, 40.605636292],
              [68.50267094000009, 40.609977112000095],
              [68.50546146700003, 40.614317933000066],
              [68.51011234600014, 40.61674672400004],
              [68.51481490100008, 40.61912384000006],
              [68.52055098400007, 40.61834869400006],
              [68.52633874500003, 40.61757354800004],
              [68.54633752400008, 40.61002878900008],
              [68.56623295100007, 40.60248402900005],
              [68.57966882300013, 40.600933736000044],
              [68.59300134300014, 40.59948679600005],
              [68.6035433350001, 40.60429270400003],
              [68.61424035700009, 40.60909861300006],
              [68.61739261900004, 40.615661520000046],
              [68.62038985200007, 40.622224427],
              [68.61067468300013, 40.626100159000075],
              [68.60111454300005, 40.630027568000045],
              [68.61325850400004, 40.64516876300006],
              [68.62545414200008, 40.660413310000095],
              [68.62638431800013, 40.66377227800011],
              [68.62741784700012, 40.66713124700003],
              [68.62312870300013, 40.67271230100003],
              [68.61883955900004, 40.67824167900004],
              [68.61542891400012, 40.6844428510001],
              [68.61212162300012, 40.69054067100008],
              [68.61036462400006, 40.69694854800012],
              [68.60850427200006, 40.70335642500005],
              [68.6090210370001, 40.709609274000044],
              [68.60943444800012, 40.71581044500003],
              [68.59692875200011, 40.718084209000054],
              [68.58421634900003, 40.72035797200009],
              [68.57935876500005, 40.72242502800013],
              [68.57460453300013, 40.7244920860001],
              [68.57047041900012, 40.728471171000066],
              [68.56633630300007, 40.73250193300008],
              [68.56302901200007, 40.7418036910001],
              [68.55977339700013, 40.75131215500009],
              [68.55465743000013, 40.79317006500007],
              [68.54969649300006, 40.83502797400003],
              [68.55145349100007, 40.84272776300013],
              [68.55341719600011, 40.85042755100001],
              [68.55615604600013, 40.8529080200001],
              [68.55899825000012, 40.85549184200009],
              [68.56209883600013, 40.857352194],
              [68.56540612800006, 40.85916086900009],
              [68.56871341900006, 40.86484527700013],
              [68.57186568200012, 40.87047800800006],
              [68.5725374760001, 40.87528391500008],
              [68.57315759300013, 40.8801415],
              [68.57181400600007, 40.891355286000035],
              [68.57057377100006, 40.90251739500006],
              [68.5706771240001, 40.90799509700007],
              [68.57088383000013, 40.913524475000074],
              [68.5730025630001, 40.912542624000096],
              [68.57532800300004, 40.91161244800004],
              [68.57997888200009, 40.910217184000075],
              [68.58473311400007, 40.90882192],
              [68.5869035230001, 40.90768503900007],
              [68.5891772870001, 40.90659983300007],
              [68.5946549890001, 40.91838206000007],
              [68.60013269000007, 40.93006093400005],
              [68.61398197400013, 40.93729563500001],
              [68.62793461100006, 40.944530335000096],
              [68.6495244510001, 40.95169060200003],
              [68.6586304120001, 40.95471059200004],
              [68.68937788900013, 40.964942525000126],
              [68.69955814600007, 40.9743993120001],
              [68.70953169800009, 40.983752747000054],
              [68.72787683100006, 41.02380198200002],
              [68.74627364100007, 41.063799541],
              [68.75986454200006, 41.07553009100009],
              [68.77376550300005, 41.08726064100007],
              [68.80818200700008, 41.09868113200007],
              [68.84244348200014, 41.11010162400008],
              [68.85489750200009, 41.1263797000001],
              [68.86735152200009, 41.142554423],
              [68.87365604700011, 41.14906565400007],
              [68.8802189540001, 41.1555252080001],
              [68.89050256400009, 41.158109029000016],
              [68.90083785000007, 41.160641175000094],
              [68.92223189300012, 41.16275990800007],
              [68.94378096500003, 41.16487864200006],
              [68.96171268700004, 41.17159657800009],
              [68.97974776200004, 41.17821116100008],
              [68.99700769100014, 41.18709950800009],
              [69.01406091300004, 41.19603953100004],
              [69.02258752400007, 41.20239573100004],
              [69.03121748900008, 41.20875193300007],
              [69.03514489700007, 41.21448801800004],
              [69.03917566000007, 41.220275777000026],
              [69.04692712400009, 41.267869771000036],
              [69.0547819410001, 41.315412090000066],
              [69.05436853000009, 41.32362864200009],
              [69.05395511900008, 41.33189687100004],
              [69.05250817900009, 41.33778798500005],
              [69.05116459100003, 41.34362742100002],
              [69.04971765100004, 41.345436096000114],
              [69.04832238800003, 41.34724477200011],
              [69.04599694800004, 41.34853668300006],
              [69.04351648000005, 41.34988027000013],
              [69.03886560000007, 41.35432444200002],
              [69.03426639800006, 41.35871694000012],
              [69.0329744870001, 41.362851054000046],
              [69.0315792240001, 41.366985168000056],
              [69.03390466300004, 41.370499166000016],
              [69.03617842600005, 41.37401316300007],
              [69.04031254000006, 41.376648662],
              [69.04444665500012, 41.37918080700008],
              [69.06754602100006, 41.38775909500002],
              [69.09064538600006, 41.39628570600003],
              [69.1000504970001, 41.398507793000036],
              [69.10945560700009, 41.40067820200004],
              [69.11880904100008, 41.39793935200008],
              [69.12805912300013, 41.39514882400003],
              [69.13312341300008, 41.405535787000034],
              [69.13818770400007, 41.41592275100005],
              [69.15038334200011, 41.42496612600003],
              [69.16268233300013, 41.434061178],
              [69.18986413600004, 41.44708363900013],
              [69.21714929200004, 41.460054423000045],
              [69.22531416900006, 41.461398010000025],
              [69.23332401500011, 41.462638245000065],
              [69.24815515200004, 41.458555806000064],
              [69.26293461100005, 41.454576722000056],
              [69.27027266400006, 41.45535186800008],
              [69.27755904200006, 41.4561786900001],
              [69.29683435100009, 41.465480449000026],
              [69.31616133600005, 41.47483388300007],
              [69.32355106600005, 41.47638417600008],
              [69.33114750200008, 41.47793446900003],
              [69.36080977400007, 41.473800355],
              [69.3906787520001, 41.469717916],
              [69.39646651200013, 41.4723534140001],
              [69.40235762600014, 41.47483388300007],
              [69.40173750800005, 41.480001526000066],
              [69.40111739100013, 41.48516916900009],
              [69.39274580900013, 41.49674469100002],
              [69.38447758000007, 41.50821685800004],
              [69.38272058100011, 41.513487854000076],
              [69.38080855300007, 41.518810526000024],
              [69.38737146000005, 41.53188466400006],
              [69.39377933800012, 41.54495880200004],
              [69.40711185800006, 41.55224517900011],
              [69.42034102400004, 41.559531555],
              [69.44881473800007, 41.566352845000054],
              [69.4772884520001, 41.57312245700008],
              [69.52818973800004, 41.60319814100005],
              [69.57898767100005, 41.63337717700004],
              [69.59319868900008, 41.64583119800004],
              [69.60756473800012, 41.65828521800002],
              [69.6159879970001, 41.663271993000066],
              [69.62456628400014, 41.668310446000035],
              [69.69200402800004, 41.682392273000076],
              [69.75944177300005, 41.696448263],
              [69.81514896700008, 41.69805023200003],
              [69.87085616000013, 41.69957468700004],
              [69.89173344000011, 41.70621510900004],
              [69.91240401200014, 41.712855530000056],
              [69.92764856000008, 41.7263172410001],
              [69.94289310700003, 41.73972727500005],
              [69.9497143970001, 41.747452902000035],
              [69.95653568500012, 41.75517852800006],
              [69.96428715000013, 41.75990692200013],
              [69.97203861500003, 41.764583639000094],
              [69.99999556500012, 41.77233510400002],
              [70.02795251500004, 41.779983216000076],
              [70.06944869000012, 41.8029275520001],
              [70.11109989400012, 41.82597524000009],
              [70.12365726700006, 41.83705983500009],
              [70.13636966900009, 41.848092753000074],
              [70.17037276200011, 41.89199188300002],
              [70.20416914900011, 41.935813497000126],
              [70.21140385000007, 41.941394552000034],
              [70.21858687300005, 41.94692393000004],
              [70.22711348500013, 41.95064463300007],
              [70.23579512600008, 41.95428782200004],
              [70.24489017700006, 41.95671661400009],
              [70.25388187700008, 41.95911956800005],
              [70.26215010600004, 41.96232350700002],
              [70.2703149830001, 41.96555328400011],
              [70.27667118300008, 41.97087595600006],
              [70.28297570900014, 41.97625030600001],
              [70.28674808800014, 41.984983623000076],
              [70.29026208500011, 41.99376861600008],
              [70.30266442900006, 42.014129131000104],
              [70.31506677300013, 42.034592998000065],
              [70.33635746200014, 42.04841644300002],
              [70.3579065350001, 42.06223988900008],
              [70.40674076400006, 42.07800120100005],
              [70.45541996300005, 42.09373667400003],
              [70.46275801600007, 42.09265146900013],
              [70.47019942200006, 42.09161794000006],
              [70.47939782700007, 42.08670868000003],
              [70.48849287900003, 42.081876933],
              [70.49650272700012, 42.07513315900009],
              [70.50446089700011, 42.06846689900006],
              [70.50823327700004, 42.061981506],
              [70.51185062700011, 42.05541859900002],
              [70.51536462400014, 42.04603932700006],
              [70.5188786220001, 42.036685893000126],
              [70.52663008600013, 42.03082061800005],
              [70.5342265220001, 42.02498118100006],
              [70.54482019000005, 42.0218547570001],
              [70.55525883000007, 42.01870249400004],
              [70.56709273300004, 42.01751393700003],
              [70.57902998900005, 42.01624786400008],
              [70.59453291800008, 42.0218547570001],
              [70.61024255300003, 42.02740997300002],
              [70.62083622300014, 42.04216359500002],
              [70.63148156800008, 42.05686554000003],
              [70.64073164900003, 42.07513315900009],
              [70.64982670100011, 42.09340077700004],
              [70.66145389800005, 42.10967885300006],
              [70.67318444900013, 42.1259827680001],
              [70.68724043800006, 42.138462627000095],
              [70.70114139800006, 42.15094248500007],
              [70.70641239500009, 42.1576345830001],
              [70.71183842000005, 42.16432668100002],
              [70.71586918100013, 42.17365427600005],
              [70.71989994300003, 42.18290435900006],
              [70.72713464300011, 42.19013905900003],
              [70.73426599100003, 42.19729624400007],
              [70.7462549230001, 42.19765798000007],
              [70.75814050300005, 42.19801971500006],
              [70.78139489700004, 42.19321380600006],
              [70.80454594000014, 42.18843373700007],
              [70.82345951300005, 42.19050079300003],
              [70.8423730880001, 42.19254201300008],
              [70.86118330900013, 42.19969919900002],
              [70.87999353000004, 42.206933899],
              [70.91389327000013, 42.2275527960001],
              [70.94779300900007, 42.24814585400007],
              [70.96960046400005, 42.26346791600004],
              [71.01404219500006, 42.28770416300004],
              [71.04577152600007, 42.290959778000015],
              [71.07760420700004, 42.281167094000054],
              [71.21785404400003, 42.206365458000036],
              [71.24986822800008, 42.19838531500004],
              [71.25320072500006, 42.19755462700003],
              [71.23821455900008, 42.16024424300009],
              [71.20100752700006, 42.1407880660001],
              [71.11842858900013, 42.122908020000054],
              [70.97714522300004, 42.04423065200008],
              [70.93590743100003, 42.03686676100007],
              [70.88671146700005, 42.03849456800002],
              [70.84547367400006, 42.03035553000011],
              [70.82805871600004, 41.993742778000055],
              [70.82511316000011, 41.936330262000055],
              [70.81400272600013, 41.91953542100002],
              [70.77932784100005, 41.90966522300003],
              [70.67969567900013, 41.901112773000094],
              [70.64894820200004, 41.887392680000076],
              [70.55009118700008, 41.82406321200007],
              [70.50647627700005, 41.78559010800011],
              [70.47722741700011, 41.738435365],
              [70.4536629640001, 41.71208038400003],
              [70.42348392800011, 41.69691335100002],
              [70.39082442200004, 41.68505361000008],
              [70.33118981900003, 41.649629415000064],
              [70.16928755700013, 41.578341777],
              [70.1482552490001, 41.552451884000064],
              [70.16654870600007, 41.52020579000002],
              [70.20344567900008, 41.50563303700004],
              [70.34441898600011, 41.49379913400013],
              [70.34452233900004, 41.493695781],
              [70.34472904500012, 41.49364410400007],
              [70.34493575000005, 41.493489075000056],
              [70.38224613400007, 41.47643585200011],
              [70.39898929800006, 41.464963685],
              [70.41361372900013, 41.450700989000026],
              [70.43805668200014, 41.41607777900002],
              [70.45319787600005, 41.405484111000035],
              [70.47078170900005, 41.40487907600006],
              [70.47722741700011, 41.40465728800011],
              [70.51133386200007, 41.41447581000007],
              [70.63380700700003, 41.46749582900007],
              [70.66781009900006, 41.471371562000044],
              [70.68672367400012, 41.462483216000024],
              [70.7035701910001, 41.4454816690001],
              [70.75969079600003, 41.37251454700008],
              [70.76919925900012, 41.35210235600003],
              [70.77105961100006, 41.33101837200009],
              [70.75628015200004, 41.269626771000034],
              [70.75803715000012, 41.25216013600006],
              [70.77043949400007, 41.238517558000055],
              [70.78656254100014, 41.240429586000076],
              [70.80599288000013, 41.24745758100009],
              [70.82852380300005, 41.24911122700006],
              [70.84774743600008, 41.243065084000094],
              [70.86573083500008, 41.23319488600002],
              [70.88216394100004, 41.220482483000055],
              [70.89596154800006, 41.206116435000055],
              [70.91420332900003, 41.19304229700002],
              [70.93415043100003, 41.19144032800007],
              [70.97714522300004, 41.19634958900009],
              [71.02468754100005, 41.18978668200002],
              [71.04701176000003, 41.182035218000024],
              [71.06757898000012, 41.16973622600007],
              [71.08576908400005, 41.16203643900009],
              [71.12307946800007, 41.15821238200006],
              [71.13909916200004, 41.14839386000007],
              [71.16442061400011, 41.11619944300013],
              [71.18013024900006, 41.10813791900004],
              [71.18994877100005, 41.12746490500008],
              [71.18788171400007, 41.148445537],
              [71.18302412900005, 41.16637725900007],
              [71.18571130400011, 41.18022654300002],
              [71.20638187700013, 41.188753154000054],
              [71.23015303600005, 41.187254537000044],
              [71.24152185100007, 41.17516225200005],
              [71.2538208410001, 41.1374901330001],
              [71.26338098200011, 41.12348582000003],
              [71.27614506100008, 41.11315053300011],
              [71.2894775800001, 41.113874004000095],
              [71.30022627800008, 41.1330459600001],
              [71.32523767100008, 41.15733388300002],
              [71.3936572670001, 41.1127371220001],
              [71.41608483900006, 41.12736155200007],
              [71.42145918800014, 41.16208811500009],
              [71.41257084200004, 41.3346873980001],
              [71.41877201400013, 41.34739980100004],
              [71.43246626800004, 41.344815980000035],
              [71.48062870300004, 41.3107612110001],
              [71.52383020100007, 41.29665354500007],
              [71.55793664600003, 41.30171783500005],
              [71.58553186100005, 41.323525289000074],
              [71.61881148300006, 41.37778554300009],
              [71.63307417800007, 41.411323547],
              [71.63741499900004, 41.43127065100005],
              [71.63369429600004, 41.44961578400002],
              [71.6055823160001, 41.47684926400002],
              [71.59555708800008, 41.493489075000056],
              [71.59555708800008, 41.493695781],
              [71.59545373600014, 41.493747457000026],
              [71.61529748500004, 41.53214304600006],
              [71.6273897700001, 41.54320180300006],
              [71.64950728400004, 41.54991973900006],
              [71.67141809100008, 41.547387594000085],
              [71.68413049400004, 41.53405507500007],
              [71.68940148900003, 41.51462473500008],
              [71.68950484200008, 41.49379913400013],
              [71.67110803300011, 41.437626852000065],
              [71.67193485500013, 41.425482890000055],
              [71.6814433190001, 41.42284739200004],
              [71.68733443200011, 41.43101226800006],
              [71.69146854700011, 41.44191599600002],
              [71.69611942500006, 41.447445374000026],
              [71.7068681230001, 41.44408640500002],
              [71.71224247300006, 41.42801503600005],
              [71.7216475830001, 41.42475942000006],
              [71.72970910600003, 41.43008209200012],
              [71.7304325770001, 41.45116607700005],
              [71.73684045400006, 41.455403544],
              [71.74521203600011, 41.452819723000076],
              [71.7531702070001, 41.44729034400008],
              [71.84701460800005, 41.341818746000044],
              [71.86303430200013, 41.312208150000075],
              [71.8688220630001, 41.27923858700002],
              [71.86634159400012, 41.236605530000034],
              [71.87161259000004, 41.1944892370001],
              [71.89765751200014, 41.18492909800001],
              [71.97703251100012, 41.195212708],
              [72.00121708100005, 41.180019836000056],
              [72.01651330600004, 41.16353505500008],
              [72.03377323400014, 41.15661041300011],
              [72.06364221200005, 41.17020131400001],
              [72.08524296100012, 41.18487742100008],
              [72.10849735500011, 41.196401266000024],
              [72.13288863200006, 41.19929514600001],
              [72.15841678900011, 41.187874654],
              [72.16988895700013, 41.16865102200008],
              [72.17464318800012, 41.14141754200007],
              [72.17640018800006, 41.112892151000025],
              [72.18559859200008, 41.06064727800005],
              [72.18559859200008, 41.04106191100003],
              [72.17877730300012, 41.02318186500007],
              [72.16513472500003, 40.99935903000009],
              [72.1954864970001, 41.00635779100007],
              [72.2529846600001, 41.01961619100008],
              [72.28977828000006, 41.02354360000005],
              [72.29732303900005, 41.028142802],
              [72.30879520700006, 41.05444610600004],
              [72.3140662030001, 41.061680807000116],
              [72.33235966000007, 41.072842917000045],
              [72.34569217900008, 41.06596995000008],
              [72.37432092300014, 41.03196685800005],
              [72.39519820100014, 41.02204498300004],
              [72.42351688700012, 41.01574045900013],
              [72.47674361200006, 41.011813049000054],
              [72.48191125500006, 41.00881581700004],
              [72.48470178200006, 41.00468170200013],
              [72.4852185470001, 40.99956573500005],
              [72.48356490100014, 40.993519592],
              [72.48335819500005, 40.97057525600006],
              [72.5014449460001, 40.963495586000036],
              [72.52624963400012, 40.962203674000094],
              [72.54557662000008, 40.95651926700005],
              [72.58846805900004, 40.90582468700008],
              [72.61947391800004, 40.88008982400008],
              [72.65823124200011, 40.867170716000075],
              [72.70122603400006, 40.863243307000104],
              [72.83010705600009, 40.8720799770001],
              [72.86865767400008, 40.86412180600003],
              [72.87299849400006, 40.834821269000074],
              [72.87031132000004, 40.81818145800007],
              [72.88312707500012, 40.81962839800006],
              [72.92942915800006, 40.84417470300012],
              [73.00342981000006, 40.87016794800009],
              [73.01944950400014, 40.86189972000004],
              [73.03329878700009, 40.847223612000036],
              [73.0535559490001, 40.836319886000084],
              [73.11246708200008, 40.839162090000045],
              [73.1350415550001, 40.83527384400004],
              [73.1432919940001, 40.83385278200005],
              [73.14336958900003, 40.83383941700002],
              [73.14864058400013, 40.81368560800003],
              [73.11804813700013, 40.78293813100008],
              [73.07060917100006, 40.76247426400003],
              [72.97676477100003, 40.73606760700004],
              [72.89098189300012, 40.6950881960001],
              [72.81894494700003, 40.681083883],
              [72.78390832600013, 40.6696633910001],
              [72.76003381400005, 40.64175811800003],
              [72.74835494000007, 40.57509552100002],
              [72.71920943200007, 40.564863586000044],
              [72.68241581200004, 40.57767934200011],
              [72.66422570800012, 40.57778269500004],
              [72.6564742430001, 40.56114288300002],
              [72.65513065600004, 40.546363424],
              [72.6504797770001, 40.53215240500005],
              [72.64086796100008, 40.51985341400008],
              [72.6254683840001, 40.51049998000006],
              [72.58578088400003, 40.50874298200007],
              [72.51529423000005, 40.545639954000094],
              [72.47674361200006, 40.549567363000065],
              [72.44790816300014, 40.560471090000036],
              [72.41483524600005, 40.58987498000003],
              [72.38155562400004, 40.612147522000086],
              [72.35189335100006, 40.60196726500003],
              [72.34850925500012, 40.58550825700003],
              [72.34848270600014, 40.585379131000096],
              [72.36992827500006, 40.557930855000095],
              [72.3700834550001, 40.55773223900009],
              [72.36998010200006, 40.539852194000034],
              [72.36326216700013, 40.52357411800001],
              [72.36346700700005, 40.512410315000025],
              [72.36346887200011, 40.51230865500004],
              [72.37225386600011, 40.503265279000075],
              [72.4155850520001, 40.47932995800004],
              [72.41566206900006, 40.47928741500009],
              [72.4200279160001, 40.47102654600012],
              [72.42609577400009, 40.45954520700003],
              [72.42620406100013, 40.459340312000066],
              [72.4251705320001, 40.4359825640001],
              [72.41442183400005, 40.410712789000044],
              [72.3940613200001, 40.38942209900007],
              [72.3704968670001, 40.385649720000046],
              [72.34341841600008, 40.39340118400004],
              [72.28430057800011, 40.419859518000024],
              [72.2696244710001, 40.42404530900008],
              [72.22435591700008, 40.422443339000026],
              [72.21164351400006, 40.4255956010001],
              [72.21176846300011, 40.425836195],
              [72.21650109900008, 40.43494903600002],
              [72.22807662000014, 40.43753285800004],
              [72.24512984200004, 40.438721415000046],
              [72.25959924400007, 40.44239044200005],
              [72.2636300050001, 40.45251902300002],
              [72.26341527500006, 40.45265116500012],
              [72.25422489400012, 40.45830678300008],
              [72.23593143700003, 40.45990875300002],
              [72.2283278000001, 40.4596060840001],
              [72.18270471200009, 40.45779001900003],
              [72.16585819500011, 40.45443105100013],
              [72.09929895000005, 40.42637074800008],
              [72.09010054500004, 40.416035462000096],
              [72.0841060790001, 40.39738027000003],
              [72.06963667800005, 40.369423320000024],
              [72.04317834500006, 40.349321188000076],
              [71.95667199800005, 40.315679831000026],
              [71.95109094300005, 40.301520488000065],
              [71.9582222900001, 40.286534322000094],
              [71.97703251100012, 40.276095683000065],
              [72.00597131300009, 40.26576039600006],
              [72.01323892900012, 40.26207235200009],
              [72.01982059800014, 40.258732401000046],
              [72.02540165300013, 40.25087758400012],
              [72.01889042200008, 40.240025533000065],
              [72.00483443200005, 40.23728668200003],
              [71.98902144300007, 40.23930206300007],
              [71.97703251100012, 40.24307444300008],
              [71.96917769400005, 40.24441803000006],
              [71.96338993300009, 40.243746236000064],
              [71.95181441300014, 40.240904033],
              [71.91233361900004, 40.243436178000096],
              [71.87295617700005, 40.250774231],
              [71.83647261600004, 40.249172262000044],
              [71.8054667560001, 40.22529775000005],
              [71.78675988800012, 40.193516744000036],
              [71.77590783700003, 40.17992584300005],
              [71.75978479000008, 40.16809193900012],
              [71.70717818200006, 40.14426910400006],
              [71.69332889800012, 40.1411168420001],
              [71.67307173600011, 40.147886455000034],
              [71.66687056500012, 40.16313100200007],
              [71.66718062300004, 40.20416208900012],
              [71.6601526290001, 40.22447092700004],
              [71.64599328600008, 40.247105204],
              [71.62831994600003, 40.258887431000076],
              [71.6101298420001, 40.2463817350001],
              [71.60403202300006, 40.22726145500009],
              [71.60165490700012, 40.20994985],
              [71.59297326700005, 40.19842600500006],
              [71.56827193200013, 40.196565653000064],
              [71.52124637800006, 40.20374867800011],
              [71.49840539600007, 40.21051829100004],
              [71.47711470600007, 40.22080190100006],
              [71.45892460200014, 40.234134420000075],
              [71.4509664310001, 40.248913879000085],
              [71.44135461400003, 40.260902812000054],
              [71.39655114800007, 40.271548157000026],
              [71.36513187600013, 40.294130758000065],
              [71.34492639200005, 40.295215963000075],
              [71.31355879800003, 40.29268381800007],
              [71.29707401600007, 40.293820699],
              [71.28322473200006, 40.29841990200005],
              [71.27283776900009, 40.30772166000007],
              [71.26394942300004, 40.31821197500001],
              [71.2538208410001, 40.3244131470001],
              [71.23955814600004, 40.3211058560001],
              [71.22395186300008, 40.302864075000045],
              [71.21511519400008, 40.28074656200003],
              [71.20100752700006, 40.26384836900003],
              [71.16938155100007, 40.26141957700007],
              [71.05321293200012, 40.27423533100007],
              [70.99512862200004, 40.26658722000009],
              [70.95895511900011, 40.23837188800012],
            ],
            [
              [70.56590417500007, 41.01837595600004],
              [70.54978112800012, 41.015223694],
              [70.5614600020001, 40.99460479800008],
              [70.56249353100009, 40.99377797500007],
              [70.57913334200009, 40.98085886600005],
              [70.60838220200003, 40.950938212000025],
              [70.62522871900012, 40.938690898000104],
              [70.64507246900013, 40.93517690000006],
              [70.64341882300005, 40.9522818],
              [70.63049971500004, 40.97641469400004],
              [70.61665043200009, 40.993519592],
              [70.5934477130001, 41.00938425700009],
              [70.56590417500007, 41.01837595600004],
            ],
          ],
          [
            [
              [71.17692631000011, 40.042001445000054],
              [71.18188724800007, 40.04339670800003],
              [71.19294600500007, 40.050269674],
              [71.19821700000011, 40.05259511300004],
              [71.22374515800004, 40.057866109000074],
              [71.23635420800008, 40.05605743400007],
              [71.24400231900006, 40.046755677000064],
              [71.23728438300003, 40.031097717000094],
              [71.19098230000003, 40.00624135400004],
              [71.1747042240001, 39.9939940390001],
              [71.17702966300004, 39.96815582300009],
              [71.22105798400008, 39.931723938000104],
              [71.21909427900005, 39.90092478500013],
              [71.2084489340001, 39.88878082300003],
              [71.1945996500001, 39.884801738000064],
              [71.16100996900008, 39.884233297],
              [71.11367435700004, 39.87446645200005],
              [71.09889489800008, 39.87549998000013],
              [71.08721602400004, 39.88381988600007],
              [71.08478723100006, 39.89482696600008],
              [71.07998132300008, 39.903405254000106],
              [71.06096439600003, 39.904128723],
              [71.04980228700009, 39.89797922800004],
              [71.03605635600013, 39.887540589000096],
              [71.0218970140001, 39.88082265200008],
              [71.00928796400007, 39.8857319130001],
              [71.0076343180001, 39.9111567180001],
              [71.05037072800013, 39.96288482700005],
              [71.04582320100008, 39.992030335],
              [71.03429935700007, 39.999110006000095],
              [71.0076343180001, 40.003502503],
              [70.99450850400007, 40.00887685200006],
              [70.98313969000009, 40.02138254800006],
              [70.95843835400007, 40.06308542900008],
              [70.95296065300005, 40.07920847600006],
              [70.95404585800014, 40.09579661100007],
              [70.95988529400006, 40.11341827400007],
              [70.97714522300004, 40.144579163000046],
              [71.00856449400004, 40.15775665300002],
              [71.03119877200004, 40.14690460300007],
              [71.04794193500004, 40.12251332600003],
              [71.06173954200011, 40.09517649300001],
              [71.07884444200005, 40.078640036000124],
              [71.10597456900013, 40.064945781000105],
              [71.16204349800006, 40.046910706000105],
              [71.1654541420001, 40.04463694300007],
              [71.16938155100007, 40.042828267000075],
              [71.17692631000011, 40.042001445000054],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Kazakhstan',
        iso3: 'KAZ',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [87.32379602100013, 49.08527374300009],
              [87.20065108200009, 49.10873484300005],
              [87.16199711100006, 49.122790832000064],
              [87.11631514500004, 49.12976715100008],
              [86.97544519000007, 49.092405090000014],
              [86.94655806500003, 49.094472148000065],
              [86.88733687400003, 49.10682281600005],
              [86.85948327600005, 49.10532419900004],
              [86.8381925860001, 49.09385203],
              [86.81617842600008, 49.05845367500008],
              [86.79891849800003, 49.04222727500009],
              [86.76005782100003, 49.020109762000075],
              [86.74352136300007, 49.007707419],
              [86.7275016690001, 48.99034413700009],
              [86.71385909000003, 48.969931946000045],
              [86.70941491700012, 48.954222311000066],
              [86.71158532800007, 48.93706573500002],
              [86.71804488100014, 48.912519430000046],
              [86.7418677170001, 48.87872304400007],
              [86.77370039900006, 48.85851755800006],
              [86.78946171100006, 48.83913889600011],
              [86.7646570230001, 48.80761627300005],
              [86.74610518400004, 48.79283681200012],
              [86.7391805420001, 48.78353505500009],
              [86.74052413000004, 48.77170115200009],
              [86.75189294500012, 48.72917144900002],
              [86.75199629700006, 48.7154255170001],
              [86.74450321400013, 48.70353993700006],
              [86.66900394700014, 48.63424184200004],
              [86.62109989400011, 48.603158468000075],
              [86.60554528900008, 48.590110169000056],
              [86.59355635600014, 48.574142151],
              [86.57515954600012, 48.539829001000086],
              [86.56508264200005, 48.527323303000074],
              [86.54642745000012, 48.51722056100003],
              [86.43062056500014, 48.48587880500013],
              [86.33383060700004, 48.49040049300005],
              [86.30737227400004, 48.48308827700005],
              [86.28628829000013, 48.46970408200012],
              [86.24670414200006, 48.437354635000034],
              [86.19203047700012, 48.41823435500005],
              [86.00599532100006, 48.42955149400002],
              [85.78368330900008, 48.40758901000005],
              [85.7474064540001, 48.390096538000094],
              [85.71867435700011, 48.3588322960001],
              [85.58638269000005, 48.14124867700009],
              [85.56178470900005, 48.03066111300005],
              [85.5471086020001, 47.9929889940001],
              [85.52871179300007, 47.96660817500005],
              [85.51780806500011, 47.944645692000066],
              [85.51537927200008, 47.92028025300006],
              [85.59542606600013, 47.62407094400005],
              [85.59578780100003, 47.59089467400004],
              [85.57997481300004, 47.523766989000094],
              [85.58457401500004, 47.493097026000086],
              [85.58457401500004, 47.492941997000045],
              [85.60023197500004, 47.46320221000006],
              [85.67035689300008, 47.38434397400003],
              [85.67888350400011, 47.363828431000044],
              [85.67402592000008, 47.34429474000005],
              [85.66720463000013, 47.326052959],
              [85.67020186400003, 47.30905141200007],
              [85.67898685700004, 47.29070627900008],
              [85.67898685700004, 47.274893290000094],
              [85.66839318900003, 47.2418720510001],
              [85.66441410300007, 47.22130483100004],
              [85.65965987200008, 47.20652537000011],
              [85.64730920400012, 47.197895407000075],
              [85.6016272380001, 47.19443308500003],
              [85.57749434400006, 47.189162089],
              [85.55682377100004, 47.17874928800008],
              [85.5471086020001, 47.16203196300002],
              [85.5442663980001, 47.143221741],
              [85.53863366700006, 47.127925517000065],
              [85.52974532000007, 47.11428293900006],
              [85.51687788900006, 47.10030446400005],
              [85.50809289600011, 47.08252777100002],
              [85.50576745700005, 47.06389841700006],
              [85.49863610900013, 47.051831971000084],
              [85.43212854000006, 47.05312388100005],
              [85.30371260600003, 47.039403789000104],
              [85.24614506000012, 47.04441640200007],
              [85.2258362230001, 47.041574199000095],
              [85.20511397300004, 47.03371938100007],
              [85.19152307100006, 47.02328074100002],
              [85.16739017800012, 46.9929983520001],
              [85.14599613500008, 46.97808970200005],
              [85.07716312700012, 46.943311463],
              [85.04822432500004, 46.92070302400005],
              [85.03535689300003, 46.9149669400001],
              [84.99039839700004, 46.90768056300003],
              [84.97577396700007, 46.90199615500008],
              [84.95939253800009, 46.89088572300004],
              [84.93680993700008, 46.86101674500013],
              [84.91603601100013, 46.85055226600009],
              [84.84017500900012, 46.8391317750001],
              [84.76710453300007, 46.81807362900007],
              [84.73961267100009, 46.81476633700008],
              [84.71976892100008, 46.82130340600004],
              [84.71553145400003, 46.8351785280001],
              [84.72441980000008, 46.85026804700003],
              [84.7385791420001, 46.86615854900005],
              [84.74958622300011, 46.88246246400006],
              [84.75160160300004, 46.9179900110001],
              [84.73165450100004, 46.94775563600011],
              [84.6992017010001, 46.97023488400002],
              [84.6635449630001, 46.98385162400011],
              [84.6160026450001, 46.98628041700006],
              [84.5210213630001, 46.969795634],
              [84.4757528080001, 46.97524749800006],
              [84.42180261300012, 46.99310170500003],
              [84.4058862710001, 46.99423858700003],
              [84.38934981300014, 46.993153382000045],
              [84.38862634300011, 46.9929983520001],
              [84.26584314000007, 47.000129700000045],
              [84.15907963100005, 46.99325673500006],
              [84.15871789600004, 46.993153382000045],
              [84.15814945500011, 46.99310170500003],
              [84.15783939700003, 46.9929983520001],
              [84.09396732600004, 46.96741851900005],
              [84.06962772600014, 46.96442128500003],
              [83.99919274900003, 46.97431732200003],
              [83.90534834800013, 46.97395558700002],
              [83.52449304200013, 47.067102357000024],
              [83.35339237500006, 47.1449787400001],
              [83.3141699630001, 47.15794952400002],
              [83.22197920800005, 47.171902161],
              [83.20192875200007, 47.1803512580001],
              [83.15035567200005, 47.21153798500008],
              [83.12637780800009, 47.21758412700002],
              [83.09909265200014, 47.2197028610001],
              [83.07160079000005, 47.21851430300008],
              [83.04689945500007, 47.21466440800002],
              [83.02147465000007, 47.20590525400006],
              [83.01351648000008, 47.19458811500006],
              [83.01517012600004, 47.15438385100005],
              [83.01217289300013, 47.14265330000005],
              [83.0013208420001, 47.12136261000008],
              [82.99822025600014, 47.11025217700005],
              [82.99946049000005, 47.10004608200008],
              [83.00628177900012, 47.08061574300011],
              [83.00545495600011, 47.06978953100007],
              [82.99015873200005, 47.03216908800003],
              [82.98550785300006, 47.01253204300009],
              [82.98835005700005, 46.9929983520001],
              [82.99336267100011, 46.97560923300007],
              [82.99181237800008, 46.958736878000096],
              [82.98550785300006, 46.942510478000074],
              [82.83895349200009, 46.732445781000095],
              [82.74743452900009, 46.49333892800003],
              [82.70785038300005, 46.43416941400007],
              [82.70128747600006, 46.416857809000064],
              [82.68929854400011, 46.362545878],
              [82.67436405500013, 46.33112660700006],
              [82.60785648600006, 46.25521392900005],
              [82.56827233900003, 46.196509501],
              [82.54186568200004, 46.13150054900002],
              [82.5158724370001, 45.99311106400002],
              [82.48894901500006, 45.90169545500008],
              [82.47582320100008, 45.873170065000025],
              [82.44750451700008, 45.82542104100007],
              [82.37221195500007, 45.73416046200005],
              [82.33603845300013, 45.63514841700005],
              [82.30461918200007, 45.58285186800005],
              [82.29713742600012, 45.554544911000036],
              [82.29149336800003, 45.53319081700006],
              [82.3274601650001, 45.493348288000035],
              [82.32761519400003, 45.493348288000035],
              [82.32777022300007, 45.49329661100002],
              [82.36265181500005, 45.481204326000025],
              [82.51303023300011, 45.46575307300013],
              [82.61571130400011, 45.43541900700008],
              [82.63198938000005, 45.41583363900007],
              [82.63638187700013, 45.37888499000003],
              [82.63384973100005, 45.33935251900009],
              [82.61457442300008, 45.24855702700002],
              [82.58522220800012, 45.176830140000035],
              [82.53974694900006, 45.12365509100009],
              [82.47582320100008, 45.11569692000002],
              [82.42745406100005, 45.137245993000064],
              [82.3418262130001, 45.204890442000064],
              [82.29459395300006, 45.22819651300007],
              [82.24529463800008, 45.231813863000056],
              [82.19175785300013, 45.22220204700007],
              [82.00045170100003, 45.153524069000085],
              [81.95011885600007, 45.144480693000034],
              [81.91012129800009, 45.15801991800002],
              [81.89100101800011, 45.173729554],
              [81.87534305800006, 45.18106760700009],
              [81.80728519700006, 45.18871571900006],
              [81.79364261900014, 45.19564036100003],
              [81.78847497600003, 45.209127910000106],
              [81.78733809400012, 45.232330628000014],
              [81.78144698100004, 45.266643779000034],
              [81.76516890500011, 45.3077265430001],
              [81.73927901200005, 45.33806060800005],
              [81.70475915500009, 45.33986928300003],
              [81.66522668500005, 45.347982483000024],
              [81.62259362800006, 45.33433990500002],
              [81.54203007000007, 45.293308818000085],
              [81.1441732180001, 45.204683736],
              [81.06252445500007, 45.172230937000066],
              [81.02190677900006, 45.161637268],
              [80.97601810700007, 45.16106882800004],
              [80.85385502200012, 45.12649729500005],
              [80.82755171700006, 45.12577382400006],
              [80.74569624800012, 45.14427398800008],
              [80.69712040200011, 45.14365387000002],
              [80.53682010900008, 45.10107249000005],
              [80.46757369000005, 45.10629181000006],
              [80.44535282400011, 45.104224752],
              [80.42509566300009, 45.09213246700001],
              [80.40638879400012, 45.05663075800008],
              [80.39005904100009, 45.045778707000025],
              [80.36504764900008, 45.04319488600002],
              [80.29053023300014, 45.04624379500005],
              [80.21901005100011, 45.02603831000006],
              [80.14759322100008, 45.034461569000044],
              [80.10335819500006, 45.03218780500002],
              [80.06170699100005, 45.01895863900005],
              [80.02377649000005, 44.99327545200005],
              [79.92466109300005, 44.931677144000034],
              [79.87815230300009, 44.91472727500012],
              [79.8582052000001, 44.90372019500002],
              [79.84301232900003, 44.873489482000096],
              [79.86864384000012, 44.84935658800005],
              [79.99173710100007, 44.79364939400001],
              [80.03938277200012, 44.790497132000056],
              [80.21828658100003, 44.81809234600006],
              [80.24474491400008, 44.81597361300008],
              [80.26324507600003, 44.80935902900008],
              [80.31450809800003, 44.78031687400009],
              [80.47615197800008, 44.7354100540001],
              [80.49227502400004, 44.72796864800007],
              [80.49744266800008, 44.714946187000024],
              [80.49196496600007, 44.70171702100005],
              [80.47615197800008, 44.69365549800004],
              [80.4111430260001, 44.6828034470001],
              [80.37631311000007, 44.67127960300006],
              [80.35584924300008, 44.652882793000074],
              [80.35450565600013, 44.64177236000005],
              [80.35915653500007, 44.63257395400005],
              [80.37724328600012, 44.615314026000064],
              [80.38375451700006, 44.60280833000006],
              [80.37993046100013, 44.59133616200005],
              [80.36453088400003, 44.56968373700006],
              [80.33786584500012, 44.49402944000009],
              [80.33042443900007, 44.45305002900007],
              [80.33290490700006, 44.417393291000096],
              [80.37300581900007, 44.270218812000095],
              [80.3732125250001, 44.23099640000005],
              [80.34603072100003, 44.15890777600005],
              [80.3388993740001, 44.1214940390001],
              [80.3451005450001, 44.103097229000085],
              [80.35977665200005, 44.08929962200004],
              [80.39233280400009, 44.065476787000065],
              [80.40380497300004, 44.048940328000086],
              [80.41000614400008, 44.03193878200007],
              [80.41238326000007, 44.01359364900007],
              [80.41269331900014, 43.993336487000064],
              [80.41269331900014, 43.99323313400005],
              [80.42313195800006, 43.97214914900012],
              [80.4398751220001, 43.948998108000026],
              [80.47615197800008, 43.910240784000095],
              [80.59443933150015, 43.68455688500008],
              [80.71272668500006, 43.45887298600006],
              [80.71014286300004, 43.42585174600008],
              [80.69422652200012, 43.39471669600003],
              [80.64286014800007, 43.326219585],
              [80.65846643100008, 43.31063914000008],
              [80.69598352100007, 43.303275249000066],
              [80.73546431500012, 43.28888336200005],
              [80.74848677600005, 43.27516326900003],
              [80.75582482900006, 43.25761912000006],
              [80.75913212100005, 43.23824045900001],
              [80.75995894400006, 43.218784282000016],
              [80.76522994000004, 43.199948223],
              [80.78817427600006, 43.16824473100009],
              [80.7934452720001, 43.14946034800009],
              [80.78786421700005, 43.12804046700005],
              [80.77339481600012, 43.11292511000006],
              [80.75344771400012, 43.10403676400004],
              [80.73153690600009, 43.10109120700004],
              [80.71076298000014, 43.10478607200004],
              [80.66001672300013, 43.13282053600007],
              [80.61846887200005, 43.13426747700005],
              [80.57588749200005, 43.119410502],
              [80.49785607900009, 43.076183166000064],
              [80.41021285000005, 43.048665467],
              [80.36814823400005, 43.028459982000086],
              [80.3551257740001, 43.00058054600002],
              [80.37383264200008, 42.975181580000125],
              [80.40773238100007, 42.95469187400006],
              [80.47615197800008, 42.93027476000013],
              [80.52193729700014, 42.92544301400001],
              [80.54291792800012, 42.91665802100003],
              [80.55449344900006, 42.898933004000114],
              [80.54860233600004, 42.87846913600005],
              [80.52669152900012, 42.86839223300011],
              [80.47615197800008, 42.863896383000096],
              [80.4004976810001, 42.84301910400002],
              [80.38168746000008, 42.83141774600007],
              [80.33393843600004, 42.81707753600007],
              [80.3167818610001, 42.81560475700006],
              [80.28174524000013, 42.822736105],
              [80.2648987230001, 42.82366628000007],
              [80.24825891100005, 42.81619903600004],
              [80.22748498600004, 42.79098093700007],
              [80.20536747200009, 42.73108795200001],
              [80.18893436700006, 42.701580709],
              [80.15245080500011, 42.660368755],
              [80.14376916500004, 42.64476247200004],
              [80.14004846200004, 42.62295501800013],
              [80.14542281100012, 42.60711619100003],
              [80.1534843340001, 42.591535747000094],
              [80.16237268100014, 42.55239084900005],
              [80.1737414960001, 42.53691375800004],
              [80.20009647600006, 42.50838836700008],
              [80.21053511600007, 42.49084421900004],
              [80.21208540900011, 42.478751933000055],
              [80.20629764800003, 42.46596201600006],
              [80.19472212700003, 42.44629913400003],
              [80.19616906800007, 42.434594422000046],
              [80.21869999200004, 42.354935201],
              [80.22552128100006, 42.33901886100007],
              [80.23554650900007, 42.32457529700007],
              [80.24949914600006, 42.30995086700007],
              [80.26841272000013, 42.23796559700013],
              [80.26045454900009, 42.2164940390001],
              [80.24908573500005, 42.20489268000004],
              [80.21032841000005, 42.18951894100006],
              [80.16661014800007, 42.208716736000085],
              [80.13653446400008, 42.23886993500007],
              [80.11007613100008, 42.273338115000044],
              [80.07700321500005, 42.30576507600004],
              [80.01209761600006, 42.349509176000126],
              [79.97396040800004, 42.39147043900003],
              [79.96011112500008, 42.403511048],
              [79.91794315600009, 42.42444000300007],
              [79.69645796700013, 42.4598383590001],
              [79.652533, 42.46105275500004],
              [79.57191776500008, 42.44952891100009],
              [79.47641971900003, 42.453973084000026],
              [79.42567346200013, 42.46960520400005],
              [79.39838830600013, 42.496942038000086],
              [79.35301639800008, 42.57729889000002],
              [79.3212870690001, 42.602181092000066],
              [79.24211877400006, 42.62977630600007],
              [79.20635868400007, 42.65646718300003],
              [79.1921993410001, 42.67483815600012],
              [79.18186405500012, 42.693596700000015],
              [79.17607629400004, 42.71393137600005],
              [79.1751461180001, 42.737030742000016],
              [79.18083052600014, 42.77552968400009],
              [79.17338911900009, 42.78563242600002],
              [79.1482743740001, 42.79098093700007],
              [79.10879357900006, 42.78534820600005],
              [79.03086551900009, 42.756151022000026],
              [78.99293501800008, 42.757132874],
              [78.95428104700005, 42.76842417400006],
              [78.88813521300011, 42.77121470100009],
              [78.80793339000013, 42.795580140000126],
              [78.68711389200007, 42.804597677000075],
              [78.66995731600014, 42.81116058400006],
              [78.63543745900006, 42.83247711200006],
              [78.59430301900005, 42.85022796600008],
              [78.49611779800006, 42.87560109500008],
              [78.4295585540001, 42.88066538500006],
              [78.38553023300005, 42.878236593000096],
              [78.36465295400006, 42.87252634700003],
              [78.32837609900008, 42.855292257000045],
              [78.31121952300003, 42.850512187000064],
              [78.29013553900012, 42.851442363],
              [78.2491044520001, 42.862397767000076],
              [78.22977746600003, 42.865007427000094],
              [78.18357873600007, 42.86014984200007],
              [78.13789677000005, 42.861984355000075],
              [78.0306164960001, 42.85467214000009],
              [77.98617476400005, 42.860201518000096],
              [77.9293306890001, 42.88500620600003],
              [77.90700647000011, 42.89128489200003],
              [77.88385542800012, 42.89322275800005],
              [77.86122115100005, 42.890819804],
              [77.85222945200013, 42.88795176300003],
              [77.83558964000014, 42.8798385620001],
              [77.80995813000004, 42.871286113000096],
              [77.79817590300007, 42.8775131230001],
              [77.79166467300007, 42.883042501],
              [77.78753055800007, 42.88970876100011],
              [77.78122603400004, 42.895625713000115],
              [77.71383996600014, 42.90758880700007],
              [77.64779748500007, 42.90950083400007],
              [77.62692020700013, 42.906555278000084],
              [77.57441695100005, 42.8878484100001],
              [77.55777714100003, 42.88813263000007],
              [77.53845015500008, 42.8962716680001],
              [77.52098352100012, 42.90691701300007],
              [77.50155318200007, 42.91453928600005],
              [77.46176232900007, 42.91438425800003],
              [77.43396040900006, 42.921412252000025],
              [77.41856083200008, 42.922239075000036],
              [77.40326460700004, 42.91975860600006],
              [77.36088993300012, 42.90453989700005],
              [77.32812707500005, 42.89756357900005],
              [77.22963179500005, 42.909810893000056],
              [77.21189028200013, 42.90994368900003],
              [77.19511193900007, 42.910069275000026],
              [77.17867883300005, 42.91319569900007],
              [77.16369266800007, 42.921980693000066],
              [77.13506392400006, 42.95174631800005],
              [77.12400516800005, 42.95890350400002],
              [77.08989872300003, 42.968153585000024],
              [76.97641727700005, 42.98220957500003],
              [76.95688358600006, 42.98851409900006],
              [76.93734989400008, 42.98603363100007],
              [76.89766239400006, 42.97453562500006],
              [76.85342736900003, 42.97412221300003],
              [76.83348026600004, 42.971745097000095],
              [76.81415328000008, 42.96148732500011],
              [76.79296594200014, 42.94306467700001],
              [76.78521447800011, 42.93965403300008],
              [76.77953007000008, 42.93929229700008],
              [76.76133996600004, 42.94205698700004],
              [76.75389856000004, 42.94076507600006],
              [76.75162479700009, 42.93709604900009],
              [76.75038456200008, 42.93257436200004],
              [76.74625044800013, 42.92887949700004],
              [76.70790653500012, 42.9136607870001],
              [76.68878625500014, 42.9103276580001],
              [76.64434452300003, 42.91112864200004],
              [76.6058972570001, 42.898493754000086],
              [76.58501997900004, 42.894798889000086],
              [76.55876835100008, 42.89820953400003],
              [76.50688521300009, 42.91448761000005],
              [76.48053023300014, 42.916968079000114],
              [76.4619267170001, 42.91099945100008],
              [76.43205773900007, 42.889579570000066],
              [76.41407434100006, 42.885497131000065],
              [76.40446252400005, 42.88924367300008],
              [76.39330041500006, 42.90526336700013],
              [76.38296512800014, 42.910069275000026],
              [76.37097619600007, 42.90960418700011],
              [76.35113244700005, 42.90288625100008],
              [76.34048710100006, 42.90167185500006],
              [76.25449751800011, 42.921153870000055],
              [76.16375370300005, 42.921153870000055],
              [76.09057987500006, 42.93427968400003],
              [76.06453495300008, 42.933969626000035],
              [75.99911259000004, 42.917639873],
              [75.97658166500008, 42.918725077],
              [75.89803348800007, 42.935700785],
              [75.85896610600014, 42.939809062],
              [75.80705856000009, 42.93677099500009],
              [75.79716109300006, 42.936191712000024],
              [75.78207157400004, 42.933323670000064],
              [75.77059940600003, 42.92564971900008],
              [75.73824996000008, 42.861570944000064],
              [75.72760461500008, 42.84867767400006],
              [75.70383345500011, 42.83048757000002],
              [75.67530806500014, 42.815372213],
              [75.64616255700014, 42.806096294000085],
              [75.62042769400006, 42.80529530900007],
              [75.55593550600014, 42.825216574000066],
              [75.53598840400008, 42.82702524900007],
              [75.49661096200009, 42.82392466300003],
              [75.27119836400004, 42.84575795500005],
              [75.20463911900009, 42.845189515000115],
              [75.1785941980001, 42.849659526000025],
              [75.11813277200008, 42.87653127100002],
              [75.09425826100005, 42.89030304000006],
              [75.06614628100004, 42.902602031000114],
              [75.00537479700012, 42.916399638000044],
              [74.9768494060001, 42.926476543],
              [74.94853072100005, 42.944847514000074],
              [74.86285119700011, 42.97582753500011],
              [74.74874963400009, 42.99001271600007],
              [74.71391971800006, 42.999882914000054],
              [74.61129032400004, 43.05817393000008],
              [74.59702762900008, 43.07034373000009],
              [74.57201623500009, 43.10220225000005],
              [74.55816695200014, 43.11504384400003],
              [74.53925337700008, 43.122898661000065],
              [74.49822229000011, 43.131115215000094],
              [74.46277225800009, 43.14863352500005],
              [74.42060428900004, 43.151837464000025],
              [74.40055383300012, 43.15953725200002],
              [74.34877404800011, 43.19103403700008],
              [74.32004195200011, 43.20165354500007],
              [74.28696903500014, 43.207208761000075],
              [74.25865035000004, 43.2157612110001],
              [74.2076973880001, 43.24979014100005],
              [74.17875858500014, 43.26170155800007],
              [74.20604374200013, 43.23410634400007],
              [74.21658573400003, 43.21692393000011],
              [74.21389856000008, 43.20263539700004],
              [74.19736210200006, 43.19578826900006],
              [74.03985233600008, 43.18186147100009],
              [74.02145552600007, 43.186305644000086],
              [73.98538537600007, 43.21167877200007],
              [73.96533492000003, 43.21692393000011],
              [73.93505253100011, 43.19971567900005],
              [73.90166955600006, 43.13096018500006],
              [73.86425581900005, 43.11610321000002],
              [73.82281132000008, 43.11731760700006],
              [73.80555139200004, 43.11473378500004],
              [73.63408899000012, 43.062463074000036],
              [73.58665002400005, 43.04228342700007],
              [73.5709403890001, 43.03192230300006],
              [73.55967492700012, 43.01729787200007],
              [73.52174442500012, 42.936165873000036],
              [73.50117720500003, 42.90934580500003],
              [73.49301233000011, 42.89495391900003],
              [73.48949833200004, 42.87782318100007],
              [73.49197880100013, 42.86100250300011],
              [73.50427779100005, 42.82759369000003],
              [73.50706831900004, 42.809403585000084],
              [73.50355432100008, 42.79408152300003],
              [73.47688928200012, 42.750880025000086],
              [73.42386926300014, 42.66277170900004],
              [73.4127071530001, 42.62732167600011],
              [73.41001997900014, 42.58964955600008],
              [73.41756473800012, 42.55616322900006],
              [73.4329643150001, 42.52484731100007],
              [73.50507740900008, 42.42155711600013],
              [73.50551802600012, 42.42092600500003],
              [73.5051046150001, 42.40294260700004],
              [73.47688928200012, 42.3990668740001],
              [73.41746138500008, 42.41705027300007],
              [73.32620080600009, 42.42867747000004],
              [73.31441858000011, 42.441570740000046],
              [73.31338505100013, 42.463171488000015],
              [73.31658898900008, 42.49371226],
              [73.30139611900006, 42.50707061800004],
              [73.27834843000011, 42.51340098100006],
              [73.20682824700003, 42.517173361000076],
              [73.1890515550001, 42.52076487300006],
              [73.17272180200007, 42.527844544000075],
              [73.15267134600003, 42.53921335900007],
              [73.11505090300011, 42.550840556000125],
              [73.07060917100006, 42.55192576100002],
              [72.94234826700011, 42.536035259000116],
              [72.90834517400003, 42.536965435000056],
              [72.87454878800008, 42.54399342900008],
              [72.84075240100009, 42.555698141000065],
              [72.81522424400004, 42.57303558300005],
              [72.78060103400014, 42.62044871000005],
              [72.7569332270001, 42.640214946000114],
              [72.72582401500006, 42.652875672000064],
              [72.5838171800001, 42.67827463800005],
              [72.51178023300008, 42.67755116800005],
              [72.47674361200006, 42.68256378200003],
              [72.35840458200005, 42.741397400000025],
              [72.2923621010001, 42.76106028300005],
              [72.16410119700004, 42.765091044000044],
              [72.1488049730001, 42.7619904590001],
              [72.11996952300007, 42.751810201000026],
              [72.10488000500004, 42.75033742300003],
              [72.07273726400012, 42.75718455],
              [71.95698205600007, 42.804597677000075],
              [71.89538374900013, 42.81604400700009],
              [71.87884729000012, 42.82134084100004],
              [71.8632410080001, 42.82904063000002],
              [71.84773807800008, 42.83405324300007],
              [71.83140832600003, 42.831572774],
              [71.7966817630001, 42.82229685500009],
              [71.72640181500003, 42.81966135700007],
              [71.69353560400009, 42.81180653900013],
              [71.58356815600007, 42.759639181000054],
              [71.56630822800008, 42.75723622700009],
              [71.55380253100003, 42.76090525300002],
              [71.5143217370001, 42.785709941000036],
              [71.50419315600004, 42.78961151200009],
              [71.49365116400008, 42.78891388000001],
              [71.47711470600007, 42.783539531000045],
              [71.42884891800014, 42.795580140000126],
              [71.40461267100005, 42.79488250800004],
              [71.38693933200005, 42.78307444300013],
              [71.37629398600006, 42.76832082200012],
              [71.36306482000009, 42.75410980300005],
              [71.34756189000007, 42.74284434000002],
              [71.32978519700004, 42.737030742000016],
              [71.30849450700003, 42.740105489000044],
              [71.28472334800011, 42.7483995570001],
              [71.26250248200006, 42.75356720000012],
              [71.24544925900005, 42.74713348400006],
              [71.22384851100014, 42.717936300000034],
              [71.21144616700008, 42.705223898000085],
              [71.19521976800007, 42.697239889000016],
              [71.15754764800005, 42.68793813100008],
              [71.14902103700013, 42.67793874100006],
              [71.14643721500005, 42.65685475700003],
              [71.14809086100007, 42.61739980100002],
              [71.14276818900004, 42.60254282600009],
              [71.12700687700004, 42.59060557100004],
              [71.04065555900007, 42.58052866600009],
              [71.00319014500008, 42.563527121000064],
              [71.01269860800011, 42.52603586800008],
              [71.02272383700011, 42.51644989000009],
              [71.05755375100006, 42.49360890700008],
              [71.05755375100006, 42.493505555000056],
              [71.0576571040001, 42.49340220200013],
              [71.05786381100006, 42.49340220200013],
              [71.06628706900005, 42.48213674000006],
              [71.06416833500009, 42.47032867500006],
              [71.05471154800011, 42.46038096100004],
              [71.04101729400008, 42.45479990600005],
              [71.02473921800004, 42.455962626000044],
              [70.97714522300004, 42.478751933000055],
              [70.96195235200008, 42.468106588000055],
              [70.94758630400008, 42.451285909],
              [70.93611413600007, 42.431623026000054],
              [70.9299129640001, 42.41229604100009],
              [70.9317733150001, 42.40149566700005],
              [70.93735437100014, 42.39477773000003],
              [70.93983483900007, 42.38782725100005],
              [70.93270349100004, 42.37620005300009],
              [70.90035404500009, 42.346744487000066],
              [70.88882503300005, 42.33857531100007],
              [70.86480066000013, 42.32155222600004],
              [70.85265669800003, 42.30607513500003],
              [70.8581344000001, 42.29106313100006],
              [70.89782189900006, 42.261607564000045],
              [70.91864750200006, 42.25336517300009],
              [70.94779300900007, 42.24814585400007],
              [70.91389327000013, 42.2275527960001],
              [70.87999353000004, 42.206933899],
              [70.86118330900013, 42.19969919900002],
              [70.8423730880001, 42.19254201300008],
              [70.82345951300005, 42.19050079300003],
              [70.80454594000014, 42.18843373700007],
              [70.78139489700004, 42.19321380600006],
              [70.75814050300005, 42.19801971500006],
              [70.7462549230001, 42.19765798000007],
              [70.73426599100003, 42.19729624400007],
              [70.72713464300011, 42.19013905900003],
              [70.71989994300003, 42.18290435900006],
              [70.71586918100013, 42.17365427600005],
              [70.71183842000005, 42.16432668100002],
              [70.70641239500009, 42.1576345830001],
              [70.70114139800006, 42.15094248500007],
              [70.68724043800006, 42.138462627000095],
              [70.67318444900013, 42.1259827680001],
              [70.66145389800005, 42.10967885300006],
              [70.64982670100011, 42.09340077700004],
              [70.64073164900003, 42.07513315900009],
              [70.63148156800008, 42.05686554000003],
              [70.62083622300014, 42.04216359500002],
              [70.61024255300003, 42.02740997300002],
              [70.59453291800008, 42.0218547570001],
              [70.57902998900005, 42.01624786400008],
              [70.56709273300004, 42.01751393700003],
              [70.55525883000007, 42.01870249400004],
              [70.54482019000005, 42.0218547570001],
              [70.5342265220001, 42.02498118100006],
              [70.52663008600013, 42.03082061800005],
              [70.5188786220001, 42.036685893000126],
              [70.51536462400014, 42.04603932700006],
              [70.51185062700011, 42.05541859900002],
              [70.50823327700004, 42.061981506],
              [70.50446089700011, 42.06846689900006],
              [70.49650272700012, 42.07513315900009],
              [70.48849287900003, 42.081876933],
              [70.47939782700007, 42.08670868000003],
              [70.47019942200006, 42.09161794000006],
              [70.46275801600007, 42.09265146900013],
              [70.45541996300005, 42.09373667400003],
              [70.40674076400006, 42.07800120100005],
              [70.3579065350001, 42.06223988900008],
              [70.33635746200014, 42.04841644300002],
              [70.31506677300013, 42.034592998000065],
              [70.30266442900006, 42.014129131000104],
              [70.29026208500011, 41.99376861600008],
              [70.28674808800014, 41.984983623000076],
              [70.28297570900014, 41.97625030600001],
              [70.27667118300008, 41.97087595600006],
              [70.2703149830001, 41.96555328400011],
              [70.26215010600004, 41.96232350700002],
              [70.25388187700008, 41.95911956800005],
              [70.24489017700006, 41.95671661400009],
              [70.23579512600008, 41.95428782200004],
              [70.22711348500013, 41.95064463300007],
              [70.21858687300005, 41.94692393000004],
              [70.21140385000007, 41.941394552000034],
              [70.20416914900011, 41.935813497000126],
              [70.17037276200011, 41.89199188300002],
              [70.13636966900009, 41.848092753000074],
              [70.12365726700006, 41.83705983500009],
              [70.11109989400012, 41.82597524000009],
              [70.06944869000012, 41.8029275520001],
              [70.02795251500004, 41.779983216000076],
              [69.99999556500012, 41.77233510400002],
              [69.97203861500003, 41.764583639000094],
              [69.96428715000013, 41.75990692200013],
              [69.95653568500012, 41.75517852800006],
              [69.9497143970001, 41.747452902000035],
              [69.94289310700003, 41.73972727500005],
              [69.92764856000008, 41.7263172410001],
              [69.91240401200014, 41.712855530000056],
              [69.89173344000011, 41.70621510900004],
              [69.87085616000013, 41.69957468700004],
              [69.81514896700008, 41.69805023200003],
              [69.75944177300005, 41.696448263],
              [69.69200402800004, 41.682392273000076],
              [69.62456628400014, 41.668310446000035],
              [69.6159879970001, 41.663271993000066],
              [69.60756473800012, 41.65828521800002],
              [69.59319868900008, 41.64583119800004],
              [69.57898767100005, 41.63337717700004],
              [69.52818973800004, 41.60319814100005],
              [69.4772884520001, 41.57312245700008],
              [69.44881473800007, 41.566352845000054],
              [69.42034102400004, 41.559531555],
              [69.40711185800006, 41.55224517900011],
              [69.39377933800012, 41.54495880200004],
              [69.38737146000005, 41.53188466400006],
              [69.38080855300007, 41.518810526000024],
              [69.38272058100011, 41.513487854000076],
              [69.38447758000007, 41.50821685800004],
              [69.39274580900013, 41.49674469100002],
              [69.40111739100013, 41.48516916900009],
              [69.40173750800005, 41.480001526000066],
              [69.40235762600014, 41.47483388300007],
              [69.39646651200013, 41.4723534140001],
              [69.3906787520001, 41.469717916],
              [69.36080977400007, 41.473800355],
              [69.33114750200008, 41.47793446900003],
              [69.32355106600005, 41.47638417600008],
              [69.31616133600005, 41.47483388300007],
              [69.29683435100009, 41.465480449000026],
              [69.27755904200006, 41.4561786900001],
              [69.27027266400006, 41.45535186800008],
              [69.26293461100005, 41.454576722000056],
              [69.24815515200004, 41.458555806000064],
              [69.23332401500011, 41.462638245000065],
              [69.22531416900006, 41.461398010000025],
              [69.21714929200004, 41.460054423000045],
              [69.18986413600004, 41.44708363900013],
              [69.16268233300013, 41.434061178],
              [69.15038334200011, 41.42496612600003],
              [69.13818770400007, 41.41592275100005],
              [69.13312341300008, 41.405535787000034],
              [69.12805912300013, 41.39514882400003],
              [69.11880904100008, 41.39793935200008],
              [69.10945560700009, 41.40067820200004],
              [69.1000504970001, 41.398507793000036],
              [69.09064538600006, 41.39628570600003],
              [69.06754602100006, 41.38775909500002],
              [69.04444665500012, 41.37918080700008],
              [69.04031254000006, 41.376648662],
              [69.03617842600005, 41.37401316300007],
              [69.03390466300004, 41.370499166000016],
              [69.0315792240001, 41.366985168000056],
              [69.0329744870001, 41.362851054000046],
              [69.03426639800006, 41.35871694000012],
              [69.03886560000007, 41.35432444200002],
              [69.04351648000005, 41.34988027000013],
              [69.04599694800004, 41.34853668300006],
              [69.04832238800003, 41.34724477200011],
              [69.04971765100004, 41.345436096000114],
              [69.05116459100003, 41.34362742100002],
              [69.05250817900009, 41.33778798500005],
              [69.05395511900008, 41.33189687100004],
              [69.05436853000009, 41.32362864200009],
              [69.0547819410001, 41.315412090000066],
              [69.04692712400009, 41.267869771000036],
              [69.03917566000007, 41.220275777000026],
              [69.03514489700007, 41.21448801800004],
              [69.03121748900008, 41.20875193300007],
              [69.02258752400007, 41.20239573100004],
              [69.01406091300004, 41.19603953100004],
              [68.99700769100014, 41.18709950800009],
              [68.97974776200004, 41.17821116100008],
              [68.96171268700004, 41.17159657800009],
              [68.94378096500003, 41.16487864200006],
              [68.92223189300012, 41.16275990800007],
              [68.90083785000007, 41.160641175000094],
              [68.89050256400009, 41.158109029000016],
              [68.8802189540001, 41.1555252080001],
              [68.87365604700011, 41.14906565400007],
              [68.86735152200009, 41.142554423],
              [68.85489750200009, 41.1263797000001],
              [68.84244348200014, 41.11010162400008],
              [68.80818200700008, 41.09868113200007],
              [68.77376550300005, 41.08726064100007],
              [68.75986454200006, 41.07553009100009],
              [68.74627364100007, 41.063799541],
              [68.72787683100006, 41.02380198200002],
              [68.70953169800009, 40.983752747000054],
              [68.69955814600007, 40.9743993120001],
              [68.68937788900013, 40.964942525000126],
              [68.6586304120001, 40.95471059200004],
              [68.6495244510001, 40.95169060200003],
              [68.62793461100006, 40.944530335000096],
              [68.61398197400013, 40.93729563500001],
              [68.60013269000007, 40.93006093400005],
              [68.5946549890001, 40.91838206000007],
              [68.5891772870001, 40.90659983300007],
              [68.5869035230001, 40.90768503900007],
              [68.58473311400007, 40.90882192],
              [68.57997888200009, 40.910217184000075],
              [68.57532800300004, 40.91161244800004],
              [68.5730025630001, 40.912542624000096],
              [68.57088383000013, 40.913524475000074],
              [68.5706771240001, 40.90799509700007],
              [68.57057377100006, 40.90251739500006],
              [68.57181400600007, 40.891355286000035],
              [68.57315759300013, 40.8801415],
              [68.5725374760001, 40.87528391500008],
              [68.57186568200012, 40.87047800800006],
              [68.56871341900006, 40.86484527700013],
              [68.56540612800006, 40.85916086900009],
              [68.56209883600013, 40.857352194],
              [68.55899825000012, 40.85549184200009],
              [68.55615604600013, 40.8529080200001],
              [68.55341719600011, 40.85042755100001],
              [68.55145349100007, 40.84272776300013],
              [68.54969649300006, 40.83502797400003],
              [68.55465743000013, 40.79317006500007],
              [68.55977339700013, 40.75131215500009],
              [68.56302901200007, 40.7418036910001],
              [68.56633630300007, 40.73250193300008],
              [68.57047041900012, 40.728471171000066],
              [68.57460453300013, 40.7244920860001],
              [68.57935876500005, 40.72242502800013],
              [68.58421634900003, 40.72035797200009],
              [68.59692875200011, 40.718084209000054],
              [68.60943444800012, 40.71581044500003],
              [68.6090210370001, 40.709609274000044],
              [68.60850427200006, 40.70335642500005],
              [68.61036462400006, 40.69694854800012],
              [68.61212162300012, 40.69054067100008],
              [68.61542891400012, 40.6844428510001],
              [68.61883955900004, 40.67824167900004],
              [68.62312870300013, 40.67271230100003],
              [68.62741784700012, 40.66713124700003],
              [68.62638431800013, 40.66377227800011],
              [68.62545414200008, 40.660413310000095],
              [68.61325850400004, 40.64516876300006],
              [68.60111454300005, 40.630027568000045],
              [68.61067468300013, 40.626100159000075],
              [68.62038985200007, 40.622224427],
              [68.61739261900004, 40.615661520000046],
              [68.61424035700009, 40.60909861300006],
              [68.6035433350001, 40.60429270400003],
              [68.59300134300014, 40.59948679600005],
              [68.57966882300013, 40.600933736000044],
              [68.56623295100007, 40.60248402900005],
              [68.54633752400008, 40.61002878900008],
              [68.52633874500003, 40.61757354800004],
              [68.52055098400007, 40.61834869400006],
              [68.51481490100008, 40.61912384000006],
              [68.51011234600014, 40.61674672400004],
              [68.50546146700003, 40.614317933000066],
              [68.50267094000009, 40.609977112000095],
              [68.49988041200004, 40.605636292],
              [68.49631473800008, 40.60212229500006],
              [68.49243900600004, 40.5986082970001],
              [68.48489424700006, 40.598918356000084],
              [68.47734948800013, 40.59922841400005],
              [68.47114831500005, 40.59447418200007],
              [68.46505049600006, 40.58971995000009],
              [68.46339685100014, 40.5871878060001],
              [68.46174320500006, 40.58465566000011],
              [68.34392093900004, 40.631732890000094],
              [68.2664965780001, 40.66270263500006],
              [68.22609867300014, 40.678861797000096],
              [68.19240564000012, 40.69901560500007],
              [68.15891931200008, 40.71911773700005],
              [68.11323734600006, 40.75353424100008],
              [68.06750370300006, 40.78800242100006],
              [68.05225915500012, 40.79451365200002],
              [68.0370662840001, 40.801076559000094],
              [68.01732588700014, 40.80428049700008],
              [67.99748213700013, 40.80753611300007],
              [67.99422652200013, 40.80934478800005],
              [67.99091923100013, 40.81110178700003],
              [67.99252120000011, 40.81502919500009],
              [67.99407149300004, 40.818956605000054],
              [67.99861901900005, 40.82205719000011],
              [68.00306319200007, 40.82515777700006],
              [68.02063317900013, 40.83115224300009],
              [68.03820316500008, 40.83719838500012],
              [68.04652307200007, 40.8422626750001],
              [68.05473962400009, 40.847223612000036],
              [68.06212935400009, 40.85352813800007],
              [68.0695190830001, 40.85983266200007],
              [68.07515181500014, 40.86639556900006],
              [68.08057784100004, 40.87295847600005],
              [68.08822595200007, 40.88592926100007],
              [68.09597741700009, 40.898951722],
              [68.1033154700001, 40.91533315100004],
              [68.11075687700009, 40.93166290300009],
              [68.11571781500004, 40.948509420000065],
              [68.12057539900007, 40.96530426100013],
              [68.12078210500005, 40.9795152790001],
              [68.12088545700004, 40.99382965200009],
              [68.11675134300003, 40.99966908800006],
              [68.11266890500013, 41.00550852500005],
              [68.11034346500008, 41.0078856410001],
              [68.10786299600005, 41.010262757000035],
              [68.10378055800004, 41.011916403],
              [68.09969812000008, 41.01362172400006],
              [68.10403894100011, 41.015223694],
              [68.10822473200011, 41.016825663000034],
              [68.1198519290001, 41.02323354100007],
              [68.13132409700012, 41.0296414190001],
              [68.12998051000005, 41.03062327100007],
              [68.12848189300013, 41.03165680000005],
              [68.12367598500003, 41.032845357000085],
              [68.11892175300005, 41.03403391600001],
              [68.12016198700007, 41.038684795000066],
              [68.12145389800014, 41.04328399700002],
              [68.1212988690001, 41.04436920200003],
              [68.12119551600006, 41.04550608300012],
              [68.11933516500005, 41.056099752000094],
              [68.11737146000013, 41.066745097000094],
              [68.10662276200009, 41.065918274000055],
              [68.09597741700009, 41.06514312800006],
              [68.08905277600013, 41.05392934200002],
              [68.08212813300014, 41.04271555600006],
              [68.0768571370001, 41.0479865520001],
              [68.07137943500004, 41.053309224000046],
              [68.06517826400005, 41.05408437100006],
              [68.05908044500006, 41.05475616500003],
              [68.05277592000004, 41.05253407800002],
              [68.04636804200004, 41.050208639000104],
              [68.0403219000001, 41.04643625900006],
              [68.03437911000009, 41.04271555600006],
              [68.02766117400006, 41.0509321090001],
              [68.02114994300007, 41.05914866200003],
              [68.01711918200004, 41.0785273230001],
              [68.01319177300007, 41.097854309000056],
              [68.00812748200013, 41.106742656000065],
              [68.00306319200007, 41.115631002000086],
              [67.98094567900006, 41.1374901330001],
              [67.95893151900009, 41.15945261600008],
              [67.95541752200012, 41.164981995000076],
              [67.95190352400004, 41.1705630500001],
              [67.95076664200013, 41.171234843],
              [67.94947473100007, 41.17190663700008],
              [67.94353194200005, 41.18611765500013],
              [67.93743412300012, 41.20038035100002],
              [67.92467004400004, 41.19417917900002],
              [67.91200931800012, 41.187978007000126],
              [67.88307051600003, 41.173456929000096],
              [67.85413171400006, 41.158987528000054],
              [67.8445198980001, 41.15790232400006],
              [67.83490808100004, 41.15686879500008],
              [67.82395267800007, 41.15976267600006],
              [67.81299727400011, 41.16270823200007],
              [67.79201664200008, 41.17097646100011],
              [67.7709326580001, 41.17929636700008],
              [67.75956384300008, 41.18167348300001],
              [67.74814335100007, 41.184102275000086],
              [67.62024418200014, 41.17836619100002],
              [67.4905363360001, 41.172423402],
              [67.40930098500013, 41.168702698000104],
              [67.28171187400005, 41.16296661400004],
              [67.17479333500012, 41.158109029000016],
              [67.02896244300007, 41.151494446000115],
              [66.93139733900006, 41.14715362600005],
              [66.81528039600005, 41.14188263000001],
              [66.77409427900005, 41.149944153],
              [66.75789044400011, 41.15314013600003],
              [66.73295983900005, 41.1580573530001],
              [66.71073897400004, 41.178624573],
              [66.68820804900008, 41.19919179300008],
              [66.6455233150001, 41.3464696250001],
              [66.60263187700014, 41.49379913400013],
              [66.57069584100009, 41.617305807],
              [66.53886315900013, 41.74076080400003],
              [66.5214482020001, 41.86710968000007],
              [66.50413659700007, 41.993484395000095],
              [66.50165612800004, 41.99451792400008],
              [66.49917565900006, 41.99560313000008],
              [66.49576501500013, 41.99617157100003],
              [66.49240604700009, 41.996791687],
              [66.48863366700004, 41.996895040000126],
              [66.48480961100012, 41.997024231000054],
              [66.48119226100005, 41.99663665800004],
              [66.47736820500012, 41.99622324700003],
              [66.35660038200007, 41.99663665800004],
              [66.24735640500012, 41.996920878000125],
              [66.13764733900013, 41.997230937000026],
              [66.01724125100009, 41.99761851],
              [66.01290043200004, 42.00007314100007],
              [66.00866296400005, 42.002656962000074],
              [66.00752608200014, 42.00805714900007],
              [66.00649255300004, 42.01343149900002],
              [66.01005822800005, 42.20822581000003],
              [66.01315936400005, 42.37286994600005],
              [66.01372725400006, 42.40302012100007],
              [66.01672448700003, 42.40994476300004],
              [66.01961836700013, 42.416843567000015],
              [66.03140059400005, 42.420254212000046],
              [66.04318282100013, 42.42366485600009],
              [66.0481437580001, 42.4322689830001],
              [66.05320804800004, 42.440873109000066],
              [66.05568851700014, 42.467253927000016],
              [66.05816898600011, 42.49360890700008],
              [66.07971805900007, 42.74194000300007],
              [66.10126713100004, 42.99032277500005],
              [65.9569348550001, 42.93301361100008],
              [65.81260258000009, 42.87575612400012],
              [65.80402429200007, 42.876479594],
              [65.79523929800007, 42.8772030650001],
              [65.73105717000004, 42.97422556600007],
              [65.6561263430001, 43.087216085000065],
              [65.60186608900005, 43.169019877],
              [65.51691003400003, 43.29722910600013],
              [65.49716963700007, 43.310019023],
              [65.47737756300012, 43.32280894000009],
              [65.37448978700007, 43.36991200800007],
              [65.27144698100005, 43.417015076000084],
              [65.22173425300014, 43.455281474000074],
              [65.17191817200012, 43.493677063000106],
              [65.06422448700005, 43.59555715000009],
              [64.95653080300008, 43.69735972100004],
              [64.93958093300006, 43.70828928700011],
              [64.92294112200005, 43.71911549900007],
              [64.90702478100013, 43.72097585000007],
              [64.89100508600006, 43.72278452500005],
              [64.8730733640001, 43.717823588],
              [64.85503829000004, 43.71291432800008],
              [64.75762821400014, 43.67361440000009],
              [64.65835778800005, 43.633591003000035],
              [64.56213627200003, 43.594807842000094],
              [64.46157393400011, 43.55431935700007],
              [64.44421065300008, 43.550676168000095],
              [64.42674401800014, 43.547032979],
              [64.37165694200007, 43.55059865400007],
              [64.23316410300004, 43.55971954400006],
              [64.0946712650001, 43.56891794900004],
              [63.95592004400004, 43.57806467800005],
              [63.81737552900006, 43.587237244000036],
              [63.66513676000011, 43.59728831000005],
              [63.512691284000084, 43.607261861000055],
              [63.36034916200009, 43.61741628100002],
              [63.2080070400001, 43.627467347000064],
              [63.11664310700007, 43.61661529600009],
              [63.02538252800008, 43.60584076],
              [62.93412194900009, 43.595066223000046],
              [62.842861369000104, 43.58429168800002],
              [62.75149743700007, 43.573491313],
              [62.660236857000086, 43.56271677600007],
              [62.56897627800009, 43.55189056400012],
              [62.477715698000054, 43.541116029000094],
              [62.42128503400005, 43.53359710700006],
              [62.3648543700001, 43.52600067100009],
              [62.3084237060001, 43.51840423600002],
              [62.25188968900011, 43.51085947700007],
              [62.216749716000095, 43.5061569220001],
              [62.18140303500007, 43.50142852900011],
              [62.14605635600009, 43.496674297000126],
              [62.110916382000084, 43.49192006500003],
              [62.02832051600012, 43.48092238300002],
              [62.026115357000094, 43.48062876500005],
              [62.00596154800007, 43.486984965],
              [61.985704386000066, 43.493341166],
              [61.91067020700012, 43.55581797300009],
              [61.85454960200008, 43.60268849700013],
              [61.798325643000055, 43.649584860000076],
              [61.74210168400003, 43.69653289900002],
              [61.685981079000044, 43.74342926100006],
              [61.62851688600006, 43.791359152],
              [61.571052694000116, 43.83928904300011],
              [61.513485148000086, 43.887244772000045],
              [61.456124308000085, 43.93517466300007],
              [61.38605106600005, 43.99343984000008],
              [61.33117069500014, 44.036176249],
              [61.276393677000044, 44.07886098200002],
              [61.1616719970001, 44.168106181000056],
              [61.10286421700005, 44.23606069000003],
              [61.0931490480001, 44.259418437000065],
              [61.0866378180001, 44.31119822200013],
              [61.080229940000095, 44.33548614500005],
              [61.06214318900004, 44.36199615500003],
              [61.03630497200004, 44.382821758],
              [60.97398319500007, 44.41243235300003],
              [60.88623661300005, 44.45413523400008],
              [60.76686405500004, 44.51082428000008],
              [60.621136516000035, 44.58007070000009],
              [60.45401493300011, 44.659445699000045],
              [60.27087365700004, 44.746468812],
              [60.07667362400008, 44.83865956600006],
              [59.876582479000035, 44.93379587800008],
              [59.67576786300009, 45.029138896000106],
              [59.47939742000011, 45.12246653200005],
              [59.29243208800011, 45.21124664300008],
              [59.12034956900004, 45.29305043500001],
              [59.05513216600008, 45.32402317500005],
              [58.96790409400006, 45.36544911700007],
              [58.840470011000036, 45.42601389600013],
              [58.74311161300005, 45.4722643030001],
              [58.68078983600003, 45.50182322300013],
              [58.65898238200009, 45.512261861000056],
              [58.582191203000036, 45.54869374600007],
              [58.55490604600004, 45.55716868100008],
              [58.53144494700007, 45.558718974],
              [58.45041630100013, 45.54238922200007],
              [58.39026493400007, 45.53014190700013],
              [58.33001021400014, 45.51784291600008],
              [58.26975549300005, 45.505543926000044],
              [58.2096041260001, 45.493348288000035],
              [58.15162316900006, 45.481204326000025],
              [58.09384891800005, 45.46911204100006],
              [58.03607466600005, 45.457071431000074],
              [57.978300415000035, 45.44492747000008],
              [57.853243449000104, 45.417900696000046],
              [57.728186483000115, 45.390925599000084],
              [57.603232870000056, 45.36389882500005],
              [57.47827925600012, 45.33692372600002],
              [57.38453820800004, 45.31563303700004],
              [57.29079716000007, 45.29434234700007],
              [57.1970561120001, 45.27299998000005],
              [57.103211710000096, 45.251760967000095],
              [57.009470663000116, 45.23041859900009],
              [56.91572961400004, 45.209127910000106],
              [56.822091919000115, 45.18788889600005],
              [56.7282475180001, 45.166598206000046],
              [56.70760971000004, 45.1619108980001],
              [56.63450647000013, 45.145307515000056],
              [56.5408687740001, 45.12401682600007],
              [56.44712772600013, 45.1027261360001],
              [56.35338667900004, 45.08143544500011],
              [56.25943892500004, 45.06009307900011],
              [56.16580122900007, 45.038802389000026],
              [56.07206018100004, 45.01756337500005],
              [55.978422486000056, 44.99622100800006],
              [55.97831913200014, 44.99622100800006],
              [55.97821577900004, 44.996169332000036],
              [55.9781124270001, 44.996169332000036],
              [55.978009074000056, 44.9960659800001],
              [55.97790572100013, 44.9960659800001],
              [55.977802368000084, 44.9960659800001],
              [55.9776990150001, 44.995962627],
              [55.977595663000045, 44.99591095000007],
              [55.977492310000116, 44.99591095000007],
              [55.97738895700007, 44.99585927300005],
              [55.97728560400009, 44.99585927300005],
              [55.977182251000045, 44.99580759700005],
              [55.977078898000116, 44.995755920000036],
              [55.97697554500007, 44.99570424400012],
              [55.976872192000144, 44.9956008920001],
              [55.976768839000044, 44.9956008920001],
              [55.976768839000044, 44.995497539000056],
              [55.976665487000105, 44.99544586200004],
              [55.97656213400006, 44.99539418600004],
              [55.97645878100013, 44.995342509000025],
              [55.97635542800003, 44.995239156000096],
              [55.976252075000104, 44.99513580400007],
              [55.97614872300005, 44.995084127000055],
              [55.97614872300005, 44.99498077400001],
              [55.97614872300005, 44.994825745000085],
              [55.97604537000012, 44.99477406800007],
              [55.97604537000012, 44.99467071600013],
              [55.97604537000012, 44.994567363],
              [55.97594201700008, 44.99446401000007],
              [55.97583866300005, 44.99441233300006],
              [55.97583866300005, 44.99430898000004],
              [55.97583866300005, 44.9942056280001],
              [55.97583866300005, 44.99405059800007],
              [55.97583866300005, 44.99389556900003],
              [55.97583866300005, 44.99374054],
              [55.97583866300005, 44.993585511000035],
              [55.97583866300005, 44.993482157000116],
              [55.97583866300005, 44.99337880400007],
              [55.97583866300005, 44.99327545200005],
              [55.97604537000012, 44.7637804160001],
              [55.97614872300005, 44.53428538100006],
              [55.97635542800003, 44.30484202100011],
              [55.97645878100013, 44.075295309000026],
              [55.976665487000105, 43.845851950000096],
              [55.976768839000044, 43.616382752000035],
              [55.97697554500007, 43.386913555],
              [55.977078898000116, 43.157470194000055],
              [55.97728560400009, 42.9280009970001],
              [55.97738895700007, 42.698531799000065],
              [55.977595663000045, 42.46908844000002],
              [55.9776990150001, 42.239619243000064],
              [55.97790572100013, 42.01015004500003],
              [55.978009074000056, 41.780680848000074],
              [55.97821577900004, 41.55126332600004],
              [55.978422486000056, 41.32171661400007],
              [55.91010624200004, 41.32662587600002],
              [55.876619914000116, 41.324507141000126],
              [55.78732303900006, 41.291692607000115],
              [55.6944088140001, 41.281564026000055],
              [55.63549768100012, 41.264355774000094],
              [55.509303834000036, 41.258878073000105],
              [55.4782979740001, 41.266784567000045],
              [55.45028934800007, 41.27887685200004],
              [55.42951542100013, 41.29081410700006],
              [55.41266890400004, 41.307919007000024],
              [55.38466027800007, 41.35856191000009],
              [55.372567993000075, 41.3755634570001],
              [55.35675500500008, 41.38905100500007],
              [55.294123169000045, 41.421503805000086],
              [55.25918990100007, 41.44465484600006],
              [55.228390748000095, 41.47281850200004],
              [55.16493208800006, 41.557464498000016],
              [55.10002648900013, 41.644151714000074],
              [55.05475793500011, 41.69001454700013],
              [54.95068160000005, 41.7955636600001],
              [54.94024296100008, 41.8135987350001],
              [54.934971964000056, 41.83372670600009],
              [54.93641890400005, 41.855275778000035],
              [54.940553019000106, 41.87271657400008],
              [54.940759725000134, 41.88961476700008],
              [54.930837850000046, 41.909225973],
              [54.90706669100007, 41.93214447100003],
              [54.73829146300011, 42.04820973700005],
              [54.61964237500007, 42.107198385000075],
              [54.51897668400005, 42.1572728470001],
              [54.35051151600004, 42.24091115300003],
              [54.19527551300007, 42.318064067000094],
              [54.12261844900013, 42.337597758000086],
              [54.04717085800013, 42.3454008990001],
              [53.807598917000064, 42.31307729100003],
              [53.654429972000116, 42.292484233000025],
              [53.47842004400013, 42.26866139800005],
              [53.412274210000135, 42.258171082],
              [53.1917191980001, 42.19303293900002],
              [53.135081828000125, 42.167840678000076],
              [52.97870894400012, 42.12662872300008],
              [52.764665161000096, 41.99376861600008],
              [52.764665161000096, 41.993587748000024],
              [52.76435510300007, 41.993484395000095],
              [52.631443319000084, 41.894239807000034],
              [52.47884281400013, 41.78034495100009],
              [52.43767061735559, 41.74887574142544],
              [52.43580162900008, 41.76854075700004],
              [52.44361412900008, 41.79092031500005],
              [52.48194420700008, 41.86395905200004],
              [52.490977410000085, 41.902044989000046],
              [52.48454837300005, 41.94163646000004],
              [52.47413170700008, 41.962591864000046],
              [52.46119225400008, 41.978949286000045],
              [52.45167076900003, 41.986314195000034],
              [52.44166100400008, 41.99237702000005],
              [52.43376712300005, 42.000433661000045],
              [52.43051191500007, 42.013739325000074],
              [52.43726647200003, 42.04783763200004],
              [52.43677819100009, 42.057806708000044],
              [52.43083743600005, 42.06712474200003],
              [52.40202884200005, 42.09251536700003],
              [52.413096550000034, 42.106675523000035],
              [52.422211134000065, 42.12531159100007],
              [52.428396030000044, 42.14545319200005],
              [52.43051191500007, 42.16388580900008],
              [52.436289910000085, 42.17987702000005],
              [52.45053144600007, 42.18781159100007],
              [52.46827233200008, 42.19310130400004],
              [52.48454837300005, 42.20172760600008],
              [52.533539259000065, 42.271918036000045],
              [52.58757571700005, 42.32684967700004],
              [52.594086134000065, 42.335272528000075],
              [52.59913170700008, 42.34471263200004],
              [52.60124759200005, 42.356350002000056],
              [52.60010826900003, 42.37767161700003],
              [52.60108483200008, 42.38861725500004],
              [52.60482832100007, 42.39667389500005],
              [52.63445071700005, 42.41864655200004],
              [52.64283287900008, 42.42829010600008],
              [52.64600670700008, 42.43650950700004],
              [52.647471550000034, 42.45359935100004],
              [52.64966881600009, 42.46185944200005],
              [52.66627037900008, 42.50177643400008],
              [52.67628014400003, 42.53847890800006],
              [52.676524285000085, 42.57453034100007],
              [52.66334069100009, 42.61269765800006],
              [52.63795006600009, 42.655503648000035],
              [52.61850019600007, 42.67841217700004],
              [52.57569420700008, 42.69863515800006],
              [52.56421959700003, 42.72089264500005],
              [52.56381269600007, 42.742254950000074],
              [52.57447350400008, 42.74982330900008],
              [52.58155358200008, 42.73924388200004],
              [52.58912194100009, 42.71824778900009],
              [52.60043379000007, 42.69765859600005],
              [52.61890709700003, 42.68842194200005],
              [52.62810306100005, 42.68585846600007],
              [52.66334069100009, 42.66791413000004],
              [52.668304884000065, 42.66063060100004],
              [52.669932488000086, 42.65298086100006],
              [52.67172285200007, 42.647650458000044],
              [52.67693118600005, 42.64740631700005],
              [52.69092858200008, 42.610988674000055],
              [52.70093834700003, 42.59320709800005],
              [52.71045983200008, 42.58539459800005],
              [52.721446160000085, 42.59349192900004],
              [52.73259524800005, 42.61383698100008],
              [52.741221550000034, 42.637884833000044],
              [52.74463951900003, 42.65737539300005],
              [52.736338738000086, 42.70136139500005],
              [52.712901238000086, 42.73078034100007],
              [52.676524285000085, 42.74664948100008],
              [52.62916100400008, 42.74982330900008],
              [52.625010613000086, 42.774725653000075],
              [52.574229363000086, 42.798529364000046],
              [52.47087649800005, 42.826239325000074],
              [52.371836785000085, 42.83242422100005],
              [52.357432488000086, 42.831732489000046],
              [52.34506269600007, 42.829413153000075],
              [52.33318118600005, 42.82518138200004],
              [52.320648634000065, 42.81875234600005],
              [52.315114780000044, 42.81297435100004],
              [52.30420983200008, 42.79564036700003],
              [52.299571160000085, 42.79083893400008],
              [52.27295983200008, 42.79877350500004],
              [52.20630944100009, 42.866115627000056],
              [52.16920006600009, 42.88703034100007],
              [52.145518425000034, 42.88849518400008],
              [52.05836022200003, 42.87848541900007],
              [51.99170983200008, 42.85968659100007],
              [51.955088738000086, 42.84064362200007],
              [51.93279056100005, 42.83494700700004],
              [51.912445509000065, 42.84235260600008],
              [51.853851759000065, 42.893784898000035],
              [51.839854363000086, 42.909369208000044],
              [51.81788170700008, 42.94114817900004],
              [51.80258222700007, 42.958685614000046],
              [51.79273522200003, 42.97418854400007],
              [51.78239993600005, 43.011379299000055],
              [51.77198326900003, 43.03099192900004],
              [51.72445722700007, 43.07050202000005],
              [51.71143639400003, 43.09088776200008],
              [51.69849694100009, 43.09430573100008],
              [51.68441816500007, 43.09609609600005],
              [51.675791863000086, 43.09992096600007],
              [51.67074629000007, 43.11273834800005],
              [51.673838738000086, 43.121161200000074],
              [51.679698113000086, 43.12909577000005],
              [51.68311608200008, 43.14085521000004],
              [51.67937259200005, 43.15973541900007],
              [51.66773522200003, 43.179754950000074],
              [51.651052280000044, 43.191392320000034],
              [51.612315300000034, 43.177069403000075],
              [51.563243035000085, 43.17918528900009],
              [51.539805535000085, 43.174994208000044],
              [51.531911655000044, 43.16937897300005],
              [51.52564537900008, 43.16258372600004],
              [51.51872806100005, 43.15692780200004],
              [51.508555535000085, 43.15448639500005],
              [51.49586022200003, 43.15680573100008],
              [51.47282962300005, 43.16657135600008],
              [51.46029707100007, 43.168850002000056],
              [51.367849155000044, 43.15448639500005],
              [51.275726759000065, 43.15448639500005],
              [51.262705925000034, 43.16461823100008],
              [51.266286655000044, 43.187567450000074],
              [51.30241946700005, 43.26898834800005],
              [51.312836134000065, 43.31118398600006],
              [51.31959069100009, 43.44253164300005],
              [51.31470787900008, 43.46246979400007],
              [51.283213738000086, 43.50836823100008],
              [51.27857506600009, 43.517645575000074],
              [51.27670332100007, 43.52716705900008],
              [51.275401238000086, 43.54979075700004],
              [51.27295983200008, 43.558579820000034],
              [51.25766035200007, 43.572251695000034],
              [51.21810957100007, 43.59332916900007],
              [51.21021569100009, 43.61009349200003],
              [51.20687910200007, 43.62445709800005],
              [51.19849694100009, 43.626166083000044],
              [51.18734785200007, 43.62250397300005],
              [51.176117384000065, 43.62067291900007],
              [51.16342207100007, 43.622707424000055],
              [51.15601647200003, 43.62482330900008],
              [51.14185631600009, 43.63373444200005],
              [51.11500084700003, 43.66083405200004],
              [51.02312259200005, 43.80097077000005],
              [51.01490319100009, 43.81854889500005],
              [51.01156660200007, 43.836004950000074],
              [51.00863691500007, 43.84560781500005],
              [51.001963738000086, 43.85419342700004],
              [50.99496504000007, 43.86147695500006],
              [50.99105879000007, 43.86709219000005],
              [50.99040774800005, 43.876939195000034],
              [50.992849155000044, 43.89858633000006],
              [50.99105879000007, 43.90810781500005],
              [50.98324629000007, 43.91901276200008],
              [50.95329837300005, 43.938788153000075],
              [50.94678795700008, 43.94721100500004],
              [50.93873131600009, 43.965725002000056],
              [50.92359459700003, 43.98305898600006],
              [50.91130618600005, 44.002386786000045],
              [50.90170332100007, 44.011053778000075],
              [50.891368035000085, 44.01544830900008],
              [50.86882571700005, 44.02033112200007],
              [50.86085045700008, 44.025376695000034],
              [50.85279381600009, 44.038763739000046],
              [50.85368899800005, 44.04755280200004],
              [50.858164910000085, 44.05621979400007],
              [50.86085045700008, 44.06940338700008],
              [50.85718834700003, 44.152777411000045],
              [50.85279381600009, 44.17340729400007],
              [50.84717858200008, 44.18927643400008],
              [50.82162519600007, 44.21503327000005],
              [50.781260613000086, 44.23590729400007],
              [50.696299675000034, 44.26434967700004],
              [50.34457441500007, 44.31126536700003],
              [50.29908287900008, 44.32636139500005],
              [50.277679884000065, 44.33649323100008],
              [50.25521894600007, 44.35101959800005],
              [50.23747806100005, 44.36933014500005],
              [50.23015384200005, 44.39093659100007],
              [50.23682701900003, 44.435980536000045],
              [50.23755944100009, 44.45774974200003],
              [50.23015384200005, 44.476629950000074],
              [50.23755944100009, 44.484076239000046],
              [50.227549675000034, 44.50218333500004],
              [50.22217858200008, 44.534816799000055],
              [50.224619988000086, 44.567694403000075],
              [50.23755944100009, 44.58649323100008],
              [50.25407962300005, 44.557521877000056],
              [50.268321160000085, 44.57054271000004],
              [50.27849368600005, 44.59837474200003],
              [50.28174889400003, 44.61375560100004],
              [50.29273522200003, 44.61896393400008],
              [50.295258009000065, 44.63117096600007],
              [50.29542076900003, 44.644964911000045],
              [50.29908287900008, 44.65534088700008],
              [50.311208530000044, 44.66233958500004],
              [50.32016035200007, 44.65989817900004],
              [50.328868035000085, 44.65326569200005],
              [50.34001712300005, 44.64789459800005],
              [50.49781334700003, 44.62579987200007],
              [50.54542076900003, 44.62742747600004],
              [50.59229576900003, 44.63971588700008],
              [50.61695397200003, 44.63971588700008],
              [50.62745201900003, 44.62400950700004],
              [50.64275149800005, 44.620794989000046],
              [50.730479363000086, 44.62055084800005],
              [50.74561608200008, 44.60919830900008],
              [50.756846550000034, 44.60504791900007],
              [50.768321160000085, 44.61033763200004],
              [50.775401238000086, 44.62055084800005],
              [50.77906334700003, 44.62807851800005],
              [50.784190300000034, 44.63271719000005],
              [50.795909050000034, 44.63426341400009],
              [50.84791100400008, 44.632798570000034],
              [50.87289472700007, 44.62885163000004],
              [50.894867384000065, 44.62055084800005],
              [50.930349155000044, 44.596909898000035],
              [50.96045983200008, 44.56972890800006],
              [50.97006269600007, 44.56537506700005],
              [50.994476759000065, 44.56826406500005],
              [51.00473066500007, 44.56598541900007],
              [51.01124108200008, 44.55801015800006],
              [51.00863691500007, 44.55145905200004],
              [51.000743035000085, 44.54702383000006],
              [50.99105879000007, 44.54547760600008],
              [51.00733483200008, 44.52879466400009],
              [51.03345787900008, 44.51581452000005],
              [51.11459394600007, 44.48847077000005],
              [51.143321160000085, 44.48476797100005],
              [51.172618035000085, 44.485581773000035],
              [51.20281009200005, 44.49091217700004],
              [51.225271030000044, 44.49974192900004],
              [51.27857506600009, 44.53864166900007],
              [51.28101647200003, 44.54120514500005],
              [51.28272545700008, 44.54474518400008],
              [51.28565514400003, 44.54857005400004],
              [51.29224694100009, 44.55231354400007],
              [51.299164259000065, 44.55365631700005],
              [51.32349694100009, 44.55231354400007],
              [51.338633660000085, 44.554022528000075],
              [51.366221550000034, 44.560207424000055],
              [51.381521030000044, 44.559759833000044],
              [51.373789910000085, 44.52773672100005],
              [51.40251712300005, 44.52142975500004],
              [51.47095787900008, 44.53188711100006],
              [51.53793379000007, 44.50934479400007],
              [51.56031334700003, 44.511379299000055],
              [51.57390384200005, 44.52391185100004],
              [51.568695509000065, 44.53774648600006],
              [51.55437259200005, 44.550482489000046],
              [51.539805535000085, 44.559759833000044],
              [51.479502800000034, 44.58315664300005],
              [51.43897545700008, 44.61005280200004],
              [51.41553795700008, 44.61212799700007],
              [51.367849155000044, 44.600775458000044],
              [51.319346550000034, 44.59638092700004],
              [51.29184004000007, 44.614488023000035],
              [51.25798587300005, 44.68891022300005],
              [51.234385613000086, 44.71906159100007],
              [51.20093834700003, 44.74091217700004],
              [51.12086022200003, 44.77826569200005],
              [51.11060631600009, 44.78546784100007],
              [51.10377037900008, 44.79205963700008],
              [51.096039259000065, 44.796861070000034],
              [51.06023196700005, 44.80023834800005],
              [51.049571160000085, 44.80345286700003],
              [51.04517662900008, 44.80963776200008],
              [51.034190300000034, 44.81785716400009],
              [50.970713738000086, 44.84715403900009],
              [50.96241295700008, 44.86367422100005],
              [50.959971550000034, 44.88646067900004],
              [50.965505405000044, 44.906683661000045],
              [50.980804884000065, 44.91543203300006],
              [50.98975670700008, 44.91893138200004],
              [50.99382571700005, 44.92715078300006],
              [50.99398847700007, 44.93646881700005],
              [50.99105879000007, 44.943345445000034],
              [50.97966556100005, 44.94871653900009],
              [50.96599368600005, 44.94944896000004],
              [50.95435631600009, 44.95221588700008],
              [50.949554884000065, 44.96381256700005],
              [50.959320509000065, 44.97882721600007],
              [50.98218834700003, 44.989488023000035],
              [51.008555535000085, 44.99583567900004],
              [51.028330925000034, 44.99799225500004],
              [51.05355879000007, 44.995428778000075],
              [51.065196160000085, 44.99701569200005],
              [51.07935631600009, 45.00482819200005],
              [51.086273634000065, 45.01146067900004],
              [51.09782962300005, 45.02529531500005],
              [51.10718834700003, 45.03217194200005],
              [51.15023847700007, 45.053615627000056],
              [51.174571160000085, 45.062201239000046],
              [51.19654381600009, 45.065619208000044],
              [51.213552280000044, 45.05756256700005],
              [51.23161868600005, 45.040676174000055],
              [51.25114993600005, 45.02606842700004],
              [51.27295983200008, 45.024644273000035],
              [51.28174889400003, 45.037543036000045],
              [51.27491295700008, 45.05683014500005],
              [51.260752800000034, 45.076605536000045],
              [51.24781334700003, 45.09048086100006],
              [51.24341881600009, 45.10106028900009],
              [51.24773196700005, 45.112982489000046],
              [51.25440514400003, 45.124660549000055],
              [51.25798587300005, 45.13450755400004],
              [51.256521030000044, 45.14130280200004],
              [51.24830162900008, 45.156683661000045],
              [51.24439537900008, 45.161810614000046],
              [51.25123131600009, 45.175482489000046],
              [51.26319420700008, 45.192572333000044],
              [51.293630405000044, 45.225490627000056],
              [51.299571160000085, 45.24095286700003],
              [51.309255405000044, 45.25731028900009],
              [51.397227410000085, 45.33258698100008],
              [51.40609785200007, 45.34857819200005],
              [51.40951582100007, 45.37103913000004],
              [51.41570071700005, 45.389960028000075],
              [51.42994225400008, 45.380926825000074],
              [51.45671634200005, 45.34739817900004],
              [51.49390709700003, 45.33470286700003],
              [51.543711785000085, 45.33490631700005],
              [51.59294681100005, 45.34471263200004],
              [51.627940300000034, 45.36107005400004],
              [51.65870201900003, 45.38532135600008],
              [51.66773522200003, 45.389553127000056],
              [51.690196160000085, 45.38861725500004],
              [51.699961785000085, 45.39207591400009],
              [51.714854363000086, 45.40965403900009],
              [51.72641035200007, 45.429388739000046],
              [51.73951256600009, 45.44684479400007],
              [51.75831139400003, 45.45726146000004],
              [51.77035566500007, 45.44773997600004],
              [51.78142337300005, 45.43423086100006],
              [51.78931725400008, 45.41933828300006],
              [51.79249108200008, 45.405462958000044],
              [51.87842858200008, 45.39520905200004],
              [51.89429772200003, 45.39085521000004],
              [51.92115319100009, 45.37164948100008],
              [51.940114780000044, 45.36733633000006],
              [51.957774285000085, 45.37164948100008],
              [51.99008222700007, 45.39085521000004],
              [52.008799675000034, 45.39520905200004],
              [52.03142337300005, 45.393011786000045],
              [52.07203209700003, 45.38361237200007],
              [52.094086134000065, 45.38153717700004],
              [52.403086785000085, 45.409409898000035],
              [52.44581139400003, 45.40058014500005],
              [52.51929772200003, 45.40888092700004],
              [52.56666100400008, 45.40070221600007],
              [52.73519941500007, 45.34784577000005],
              [52.83513431100005, 45.33665599200003],
              [52.88502037900008, 45.31830475500004],
              [52.90967858200008, 45.31268952000005],
              [53.00220787900008, 45.32013580900008],
              [53.02849368600005, 45.316473700000074],
              [53.08334394600007, 45.301662502000056],
              [53.10824629000007, 45.29962799700007],
              [53.129242384000065, 45.30487702000005],
              [53.170909050000034, 45.32249583500004],
              [53.194346550000034, 45.32636139500005],
              [53.20045006600009, 45.32843659100007],
              [53.21241295700008, 45.33803945500006],
              [53.21810957100007, 45.34056224200003],
              [53.242849155000044, 45.33539459800005],
              [53.24545332100007, 45.33380768400008],
              [53.25220787900008, 45.33698151200008],
              [53.26124108200008, 45.34284088700008],
              [53.26734459700003, 45.350897528000075],
              [53.26587975400008, 45.36107005400004],
              [53.24756920700008, 45.36969635600008],
              [53.142914259000065, 45.383978583000044],
              [53.13453209700003, 45.38959381700005],
              [53.12867272200003, 45.39638906500005],
              [53.12191816500007, 45.402044989000046],
              [53.112071160000085, 45.40615469000005],
              [53.08171634200005, 45.40888092700004],
              [53.03565514400003, 45.41876862200007],
              [52.90967858200008, 45.46344635600008],
              [52.885101759000065, 45.46747467700004],
              [52.875743035000085, 45.471136786000045],
              [52.85726972700007, 45.488714911000045],
              [52.85010826900003, 45.494208075000074],
              [52.84066816500007, 45.497259833000044],
              [52.80420983200008, 45.50104401200008],
              [52.75521894600007, 45.516791083000044],
              [52.73845462300005, 45.52558014500005],
              [52.74341881600009, 45.538316148000035],
              [52.73804772200003, 45.546942450000074],
              [52.73194420700008, 45.55414459800005],
              [52.73462975400008, 45.56281159100007],
              [52.74268639400003, 45.573431708000044],
              [52.74301191500007, 45.58079661700003],
              [52.740244988000086, 45.58783600500004],
              [52.73845462300005, 45.59723541900007],
              [52.74000084700003, 45.62083567900004],
              [52.74561608200008, 45.63914622600004],
              [52.75709069100009, 45.65106842700004],
              [52.77588951900003, 45.65525950700004],
              [52.79224694100009, 45.66290924700007],
              [52.80388431100005, 45.68073151200008],
              [52.820323113000086, 45.71735260600008],
              [52.85873457100007, 45.764837958000044],
              [52.87549889400003, 45.77879466400009],
              [52.88624108200008, 45.78367747600004],
              [52.910899285000085, 45.79051341400009],
              [52.919932488000086, 45.796128648000035],
              [52.95435631600009, 45.83030833500004],
              [52.967458530000044, 45.84780508000006],
              [52.98658287900008, 45.88613515800006],
              [53.00220787900008, 45.90607330900008],
              [53.031260613000086, 45.927394924000055],
              [53.040049675000034, 45.93646881700005],
              [53.04476972700007, 45.94505442900004],
              [53.05396569100009, 45.967230536000045],
              [53.06039472700007, 45.97801341400009],
              [53.08179772200003, 46.005113023000035],
              [53.086599155000044, 46.02049388200004],
              [53.08171634200005, 46.03880442900004],
              [53.08171634200005, 46.03266022300005],
              [53.07699629000007, 46.04783763200004],
              [53.082367384000065, 46.06073639500005],
              [53.10523522200003, 46.08388906500005],
              [53.11378014400003, 46.09784577000005],
              [53.11841881600009, 46.11432526200008],
              [53.127614780000044, 46.183294989000046],
              [53.15674889400003, 46.27228424700007],
              [53.15674889400003, 46.34170156500005],
              [53.12826582100007, 46.39394765800006],
              [53.08285566500007, 46.43496328300006],
              [53.03256269600007, 46.47089264500005],
              [53.05323326900003, 46.46869538000004],
              [53.08318118600005, 46.45014069200005],
              [53.10206139400003, 46.44354889500005],
              [53.10206139400003, 46.45099518400008],
              [53.08415774800005, 46.460150458000044],
              [53.07545006600009, 46.47565338700008],
              [53.07504316500007, 46.494208075000074],
              [53.08171634200005, 46.51243724200003],
              [53.063243035000085, 46.505845445000034],
              [53.04078209700003, 46.49017975500004],
              [53.01783287900008, 46.47866445500006],
              [52.998383009000065, 46.48456452000005],
              [52.99659264400003, 46.504787502000056],
              [53.00961347700007, 46.531683661000045],
              [53.040049675000034, 46.573919989000046],
              [53.041758660000085, 46.55536530200004],
              [53.05420983200008, 46.54559967700004],
              [53.07178795700008, 46.54474518400008],
              [53.087901238000086, 46.55341217700004],
              [53.095713738000086, 46.568345445000034],
              [53.10010826900003, 46.605129299000055],
              [53.10824629000007, 46.62173086100006],
              [53.11768639400003, 46.60150788000004],
              [53.125743035000085, 46.606634833000044],
              [53.13363691500007, 46.622707424000055],
              [53.14242597700007, 46.63532135600008],
              [53.15202884200005, 46.63768138200004],
              [53.17497806100005, 46.63495514500005],
              [53.18409264400003, 46.63532135600008],
              [53.19581139400003, 46.639837958000044],
              [53.20053144600007, 46.64329661700003],
              [53.20460045700008, 46.65582916900007],
              [53.207774285000085, 46.695013739000046],
              [53.188161655000044, 46.718003648000035],
              [53.156911655000044, 46.72890859600005],
              [53.125743035000085, 46.73159414300005],
              [53.105804884000065, 46.73725006700005],
              [53.09945722700007, 46.75112539300005],
              [53.10206139400003, 46.78310781500005],
              [53.08350670700008, 46.85325755400004],
              [53.064789259000065, 46.87946198100008],
              [53.06039472700007, 46.89232005400004],
              [53.05193118600005, 46.898423570000034],
              [53.00904381600009, 46.89484284100007],
              [52.992198113000086, 46.89545319200005],
              [52.97413170700008, 46.90843333500004],
              [52.935557488000086, 46.948919989000046],
              [52.919932488000086, 46.957464911000045],
              [52.875010613000086, 46.95677317900004],
              [52.78272545700008, 46.94383372600004],
              [52.72738691500007, 46.95001862200007],
              [52.61475670700008, 46.95001862200007],
              [52.59034264400003, 46.954413153000075],
              [52.57154381600009, 46.962225653000075],
              [52.53695722700007, 46.98883698100008],
              [52.51937910200007, 46.994208075000074],
              [52.45590254000007, 47.001166083000044],
              [52.43677819100009, 46.99909088700008],
              [52.42725670700008, 46.99017975500004],
              [52.42335045700008, 46.97907135600008],
              [52.42310631600009, 46.95380280200004],
              [52.41928144600007, 46.94399648600006],
              [52.374034050000034, 46.903631903000075],
              [52.35718834700003, 46.89362213700008],
              [52.26221764400003, 46.87010325700004],
              [52.235036655000044, 46.86888255400004],
              [52.201833530000044, 46.88544342700004],
              [52.18881269600007, 46.88377513200004],
              [52.180674675000034, 46.87555573100008],
              [52.18287194100009, 46.86188385600008],
              [52.189463738000086, 46.858710028000075],
              [52.215830925000034, 46.851629950000074],
              [52.22437584700003, 46.84829336100006],
              [52.23064212300005, 46.84194570500006],
              [52.237315300000034, 46.83234284100007],
              [52.24268639400003, 46.821193752000056],
              [52.244883660000085, 46.81004466400009],
              [52.238942905000044, 46.80683014500005],
              [52.11255944100009, 46.81273021000004],
              [52.087901238000086, 46.82094961100006],
              [52.078135613000086, 46.82575104400007],
              [52.07178795700008, 46.83002350500004],
              [52.068369988000086, 46.83738841400009],
              [52.067393425000034, 46.85138580900008],
              [52.06185957100007, 46.850043036000045],
              [52.049571160000085, 46.85687897300005],
              [52.01726321700005, 46.88068268400008],
              [52.00700931100005, 46.88507721600007],
              [52.000010613000086, 46.89057038000004],
              [51.99789472700007, 46.90289948100008],
              [52.00359134200005, 46.90961334800005],
              [52.01449629000007, 46.917222398000035],
              [52.022471550000034, 46.926214911000045],
              [52.01889082100007, 46.93699778900009],
              [51.999034050000034, 46.94098541900007],
              [51.981211785000085, 46.92332591400009],
              [51.96070397200003, 46.88580963700008],
              [51.941416863000086, 46.87995026200008],
              [51.90967858200008, 46.88108958500004],
              [51.87671959700003, 46.88694896000004],
              [51.853851759000065, 46.89545319200005],
              [51.885427280000044, 46.92446523600006],
              [51.895518425000034, 46.93081289300005],
              [51.874034050000034, 46.935614325000074],
              [51.849619988000086, 46.92820872600004],
              [51.80600019600007, 46.909084377000056],
              [51.78492272200003, 46.90912506700005],
              [51.763682488000086, 46.915716864000046],
              [51.74390709700003, 46.92682526200008],
              [51.72771243600005, 46.94041575700004],
              [51.68921959700003, 46.96149323100008],
              [51.675791863000086, 46.978583075000074],
              [51.696055535000085, 47.021185614000046],
              [51.694021030000044, 47.04173411700003],
              [51.68018639400003, 47.05703359600005],
              [51.655284050000034, 47.059881903000075],
              [51.635752800000034, 47.04877350500004],
              [51.62680097700007, 47.029282945000034],
              [51.621104363000086, 47.00739166900007],
              [51.61101321700005, 46.98883698100008],
              [51.59229576900003, 46.98725006700005],
              [51.57203209700003, 47.00482819200005],
              [51.54607181100005, 47.04002513200004],
              [51.52719160200007, 47.05296458500004],
              [51.502614780000044, 47.06134674700007],
              [51.437836134000065, 47.06915924700007],
              [51.381846550000034, 47.083685614000046],
              [51.25359134200005, 47.10297272300005],
              [51.21257571700005, 47.12091705900008],
              [51.18702233200008, 47.116888739000046],
              [51.14185631600009, 47.09467194200005],
              [51.10271243600005, 47.08047109600005],
              [50.970713738000086, 47.059881903000075],
              [50.951914910000085, 47.05219147300005],
              [50.922862175000034, 47.02496979400007],
              [50.90544681100005, 47.01894765800006],
              [50.89079837300005, 47.02228424700007],
              [50.86833743600005, 47.036769924000055],
              [50.857432488000086, 47.04002513200004],
              [50.84652754000007, 47.036769924000055],
              [50.840586785000085, 47.02948639500005],
              [50.83952884200005, 47.02228424700007],
              [50.843760613000086, 47.01894765800006],
              [50.83814537900008, 47.00991445500006],
              [50.757823113000086, 46.91551341400009],
              [50.740570509000065, 46.90615469000005],
              [50.730479363000086, 46.92332591400009],
              [50.73389733200008, 46.93496328300006],
              [50.75318444100009, 46.955064195000034],
              [50.757823113000086, 46.968003648000035],
              [50.75212649800005, 46.974676825000074],
              [50.73951256600009, 46.96922435100004],
              [50.703786655000044, 46.942694403000075],
              [50.67823326900003, 46.93268463700008],
              [50.651377800000034, 46.92829010600008],
              [50.63111412900008, 46.93390534100007],
              [50.61605879000007, 46.935614325000074],
              [50.610362175000034, 46.915269273000035],
              [50.60694420700008, 46.86810944200005],
              [50.598643425000034, 46.852443752000056],
              [50.58545983200008, 46.837225653000075],
              [50.569102410000085, 46.82904694200005],
              [50.55160566500007, 46.83462148600006],
              [50.56983483200008, 46.85236237200007],
              [50.580821160000085, 46.867621161000045],
              [50.578135613000086, 46.87836334800005],
              [50.555430535000085, 46.88239166900007],
              [50.52133222700007, 46.874660549000055],
              [50.514414910000085, 46.87181224200003],
              [50.50277754000007, 46.86359284100007],
              [50.49366295700008, 46.86579010600008],
              [50.48617597700007, 46.87201569200005],
              [50.45337975400008, 46.89175039300005],
              [50.44304446700005, 46.89545319200005],
              [50.43474368600005, 46.89687734600005],
              [50.43018639400003, 46.89671458500004],
              [50.42514082100007, 46.89272695500006],
              [50.41578209700003, 46.88239166900007],
              [50.38363691500007, 46.81777578300006],
              [50.36736087300005, 46.806626695000034],
              [50.372080925000034, 46.81932200700004],
              [50.37427819100009, 46.85443756700005],
              [50.36085045700008, 46.84650299700007],
              [50.35303795700008, 46.834865627000056],
              [50.34734134200005, 46.82282135600008],
              [50.34001712300005, 46.81346263200004],
              [50.333018425000034, 46.81102122600004],
              [50.31413821700005, 46.80931224200003],
              [50.30591881600009, 46.806626695000034],
              [50.29867597700007, 46.801947333000044],
              [50.29420006600009, 46.79791901200008],
              [50.25147545700008, 46.74241771000004],
              [50.23096764400003, 46.72601959800005],
              [50.21314537900008, 46.728176174000055],
              [50.21314537900008, 46.73773834800005],
              [50.21989993600005, 46.75018952000005],
              [50.22315514400003, 46.761053778000075],
              [50.21314537900008, 46.765692450000074],
              [50.20036868600005, 46.76308828300006],
              [50.16879316500007, 46.74909088700008],
              [50.07935631600009, 46.68378327000005],
              [50.050791863000086, 46.649603583000044],
              [50.03402754000007, 46.63515859600005],
              [50.01417076900003, 46.62913646000004],
              [49.976573113000086, 46.63222890800006],
              [49.96265709700003, 46.62913646000004],
              [49.95281009200005, 46.62368398600006],
              [49.93718509200005, 46.60789622600004],
              [49.92855879000007, 46.601263739000046],
              [49.893321160000085, 46.59076569200005],
              [49.88233483200008, 46.575873114000046],
              [49.86850019600007, 46.57558828300006],
              [49.83969160200007, 46.58075592700004],
              [49.82545006600009, 46.571478583000044],
              [49.823252800000034, 46.55329010600008],
              [49.817393425000034, 46.54043203300006],
              [49.79184004000007, 46.54726797100005],
              [49.77955162900008, 46.561835028000075],
              [49.77133222700007, 46.56708405200004],
              [49.76091556100005, 46.563381252000056],
              [49.76091556100005, 46.54173411700003],
              [49.75749759200005, 46.531683661000045],
              [49.74732506600009, 46.536322333000044],
              [49.72681725400008, 46.55459219000005],
              [49.713633660000085, 46.561428127000056],
              [49.70264733200008, 46.560248114000046],
              [49.70085696700005, 46.55247630400004],
              [49.70435631600009, 46.52716705900008],
              [49.70264733200008, 46.51927317900004],
              [49.637705925000034, 46.577337958000044],
              [49.62256920700008, 46.58283112200007],
              [49.61963951900003, 46.563788153000075],
              [49.62680097700007, 46.51927317900004],
              [49.608083530000044, 46.527004299000055],
              [49.597666863000086, 46.521144924000055],
              [49.59001712300005, 46.50922272300005],
              [49.57894941500007, 46.49884674700007],
              [49.570648634000065, 46.521918036000045],
              [49.55787194100009, 46.534369208000044],
              [49.498057488000086, 46.552801825000074],
              [49.480804884000065, 46.560614325000074],
              [49.469737175000034, 46.573553778000075],
              [49.469086134000065, 46.59438711100006],
              [49.46924889400009, 46.56264883000006],
              [49.47234134200005, 46.54661692900004],
              [49.48617597700007, 46.53465403900009],
              [49.49659264400009, 46.509019273000035],
              [49.50407962300005, 46.49884674700007],
              [49.492849155000044, 46.49957916900007],
              [49.475596550000034, 46.50495026200008],
              [49.46566816500007, 46.506293036000045],
              [49.45679772200003, 46.50958893400008],
              [49.45753014400009, 46.517279364000046],
              [49.461680535000085, 46.52619049700007],
              [49.46225019600007, 46.53294505400004],
              [49.45826256600009, 46.536769924000055],
              [49.438487175000034, 46.55036041900007],
              [49.42896569100009, 46.55487702000005],
              [49.42367597700007, 46.55052317900004],
              [49.42164147200003, 46.54352448100008],
              [49.42139733200008, 46.53974030200004],
              [49.38949629000007, 46.54401276200008],
              [49.353851759000065, 46.55353424700007],
              [49.323008660000085, 46.568060614000046],
              [49.305349155000044, 46.587591864000046],
              [49.31299889400009, 46.56207916900007],
              [49.37859134200005, 46.510199286000045],
              [49.39421634200005, 46.47833893400008],
              [49.37452233200008, 46.484076239000046],
              [49.33757571700005, 46.485256252000056],
              [49.33326256600009, 46.48456452000005],
              [49.31918379000007, 46.497259833000044],
              [49.309580925000034, 46.51227448100008],
              [49.297862175000034, 46.52374909100007],
              [49.278086785000085, 46.525458075000074],
              [49.278086785000085, 46.51927317900004],
              [49.29468834700003, 46.50800202000005],
              [49.297618035000085, 46.48688385600008],
              [49.30355879000007, 46.466457424000055],
              [49.32943769600007, 46.45722077000005],
              [49.36687259200005, 46.42987702000005],
              [49.37086022200003, 46.42088450700004],
              [49.37273196700005, 46.41038646000004],
              [49.371429884000065, 46.39935944200005],
              [49.36687259200005, 46.38898346600007],
              [49.32569420700008, 46.41034577000005],
              [49.30632571700005, 46.423895575000074],
              [49.291758660000085, 46.43740469000005],
              [49.27784264400009, 46.45380280200004],
              [49.266286655000044, 46.464056708000044],
              [49.250336134000065, 46.46938711100006],
              [49.223399285000085, 46.47089264500005],
              [49.23462975400008, 46.46474844000005],
              [49.243174675000034, 46.45856354400007],
              [49.248789910000085, 46.449204820000034],
              [49.250743035000085, 46.433661200000074],
              [49.25538170700008, 46.42413971600007],
              [49.291758660000085, 46.39642975500004],
              [49.287852410000085, 46.39472077000005],
              [49.278086785000085, 46.38898346600007],
              [49.26384524800005, 46.396144924000055],
              [49.18490644600007, 46.41380442900004],
              [49.17359459700003, 46.41351959800005],
              [49.16822350400008, 46.409409898000035],
              [49.17042076900009, 46.39911530200004],
              [49.178396030000044, 46.39280833500004],
              [49.18897545700008, 46.38971588700008],
              [49.199229363000086, 46.38898346600007],
              [49.215830925000034, 46.38031647300005],
              [49.22217858200008, 46.36127350500004],
              [49.22388756600009, 46.34227122600004],
              [49.22641035200007, 46.333685614000046],
              [49.22706139400009, 46.32794830900008],
              [49.22713051952735, 46.32787918423311],
              [49.03316166200011, 46.40489471500011],
              [48.959884481000074, 46.44525400900007],
              [48.91797489400011, 46.47432200200008],
              [48.89704593900012, 46.48217681900009],
              [48.868727254000135, 46.48235768600004],
              [48.844129273000135, 46.478533630000115],
              [48.819634643000086, 46.4792571010001],
              [48.758553101000075, 46.513131002000094],
              [48.732921590000046, 46.53403411900008],
              [48.70501631700006, 46.55044138600006],
              [48.665225464000116, 46.55718516100008],
              [48.57324141500004, 46.55827036600009],
              [48.53939335100006, 46.567959697],
              [48.56300948100005, 46.59131744500006],
              [48.5468864340001, 46.599275615000025],
              [48.541925497000136, 46.61325409000001],
              [48.539238322000074, 46.62795603400009],
              [48.530039917000124, 46.63818796800008],
              [48.49345300300007, 46.65348419300004],
              [48.474022665000064, 46.659220276],
              [48.455109090000064, 46.660796407000035],
              [48.47908695500007, 46.68345652300009],
              [48.50575199400009, 46.73260081000005],
              [48.55670495600003, 46.76174631800005],
              [48.618199910000044, 46.77042795800013],
              [48.67659427900014, 46.75802561500005],
              [48.697264852000046, 46.74508066800003],
              [48.71266442800004, 46.728776754000094],
              [48.739536174000136, 46.690562033000035],
              [48.76403080200009, 46.68283640600002],
              [48.91688968900013, 46.70257680300007],
              [48.948102255000094, 46.7199400840001],
              [49.00628991700012, 46.76911021000005],
              [48.697264852000046, 47.100976258000046],
              [48.546162964000075, 47.369435323000076],
              [48.53582767800009, 47.39349070200011],
              [48.525078980000046, 47.41023386600007],
              [48.510299520000046, 47.417442729000115],
              [48.47319584200005, 47.42041412400003],
              [48.43753910300006, 47.42919911700001],
              [48.41108077000007, 47.44576141400002],
              [48.36095463100014, 47.492941997000045],
              [48.36059289600007, 47.493097026000086],
              [48.17435103400004, 47.71285105400007],
              [48.11249434400014, 47.74850779300006],
              [48.04448815900008, 47.76969512900003],
              [47.64973189300014, 47.765586854],
              [47.435326375000045, 47.834394023000115],
              [47.412175334000096, 47.83586680100011],
              [47.394191935000094, 47.82679758700006],
              [47.38881758700012, 47.811914775],
              [47.38943770300011, 47.75155670200009],
              [47.38292647300011, 47.705357971000055],
              [47.37424483300009, 47.685824280000034],
              [47.359672078000074, 47.68334381100006],
              [47.17446374500008, 47.770521953000056],
              [47.14056400600009, 47.79266530400007],
              [47.12382084200004, 47.80803904200006],
              [47.11948002100013, 47.81976959200004],
              [47.12516442900011, 47.83209442100009],
              [47.13829024300014, 47.84958689400004],
              [47.145214885000144, 47.85578806600002],
              [47.15172611500009, 47.859095357000015],
              [47.15673872900004, 47.86317779500003],
              [47.15865075700009, 47.87154937800001],
              [47.1553434650001, 47.87744049100009],
              [47.121650431000035, 47.91544850700002],
              [47.0511637780001, 47.974643860000114],
              [47.0442391360001, 47.986219381000055],
              [47.05839847900006, 47.99448761000009],
              [47.13705000800013, 48.02725046800002],
              [47.17818444800008, 48.05179677400007],
              [47.19203373200014, 48.071795553000115],
              [47.17394698000004, 48.08419789700007],
              [47.11948002100013, 48.088280335],
              [47.103563680000036, 48.101199443],
              [47.10408044400003, 48.119234518],
              [47.111573527000076, 48.136236064000016],
              [47.11648278800004, 48.153857727000016],
              [47.10883467600007, 48.17398569800007],
              [47.10263350400004, 48.180290222000096],
              [47.0803092860001, 48.19597401900005],
              [47.07524499600004, 48.20512074800003],
              [47.081549520000124, 48.21183868400006],
              [47.091988159000095, 48.217316387000054],
              [47.09860274300007, 48.22258738200007],
              [47.11214196800006, 48.24155263300004],
              [47.112120535000145, 48.24220453800005],
              [47.111831909000045, 48.2509835820001],
              [47.09891280100004, 48.265375468000016],
              [47.078293905000066, 48.27534902000012],
              [46.97923018400013, 48.29395253600008],
              [46.72927128100014, 48.352088522000074],
              [46.47931237800009, 48.41022450800007],
              [46.47858890800012, 48.41022450800007],
              [46.47827884900005, 48.410560405000055],
              [46.47858890800012, 48.41115468400001],
              [46.47931237800009, 48.41185231600009],
              [46.620191910000074, 48.669596618000085],
              [46.75381758600008, 48.914069723000054],
              [46.77800215700006, 48.936032207000025],
              [46.812935425000035, 48.95375722300004],
              [46.88807295700008, 48.98052561500002],
              [46.9110172930001, 48.99282460500005],
              [46.930034220000096, 49.004038391],
              [46.97923018400013, 49.047291565000066],
              [47.020881388000134, 49.09684926400003],
              [47.04000166800006, 49.150334371000056],
              [47.02863285300003, 49.20149403900005],
              [46.97923018400013, 49.24428212500008],
              [46.830712118000065, 49.31833445300002],
              [46.77510827700007, 49.332545472000064],
              [46.83750756900014, 49.57643239400004],
              [46.89990686100009, 49.820319316000095],
              [46.92259281400004, 49.86135040300006],
              [46.95855961100011, 49.88413970900005],
              [47.17735762500007, 49.94718495800008],
              [47.2455705160001, 49.992350159000054],
              [47.30871911600008, 50.04480173800009],
              [47.32856286700007, 50.07296539300005],
              [47.327632691000076, 50.10929392600012],
              [47.27306237800008, 50.15843821300005],
              [47.265104207000036, 50.18634348600004],
              [47.276266317000136, 50.19988271100003],
              [47.31264652500005, 50.22241363600004],
              [47.32231001800005, 50.237399801000024],
              [47.316987345000086, 50.25290273000003],
              [47.30318973800007, 50.26349639900012],
              [47.29476648000008, 50.27543365500004],
              [47.30567020700005, 50.29486399400004],
              [47.322878459000094, 50.304475810000056],
              [47.39222823000006, 50.323234355000054],
              [47.40628422000009, 50.33424143500004],
              [47.43446043500006, 50.37652808400004],
              [47.43889205000005, 50.383179017000046],
              [47.469794555000135, 50.411756084],
              [47.51149743600007, 50.43692250600013],
              [47.55692102100011, 50.452580465],
              [47.59929569500008, 50.4526838180001],
              [47.62466882300009, 50.440798238000085],
              [47.68998783300003, 50.38633127900009],
              [47.73494633000007, 50.37005320300007],
              [47.74910567200004, 50.36023468100008],
              [47.76026778200014, 50.347160543000044],
              [47.76693404200006, 50.33718699200004],
              [47.77649418100003, 50.32979726200004],
              [47.79597619700007, 50.32478464800006],
              [47.80822351000006, 50.31992706300004],
              [47.85452559400005, 50.28504547200008],
              [47.87405928600009, 50.266441956],
              [47.91343672700009, 50.24385935500008],
              [47.9536409910001, 50.204895325000095],
              [47.99322513900006, 50.18179596000003],
              [48.0003564860001, 50.16970367400002],
              [48.00505904100004, 50.15600942000002],
              [48.01224206600011, 50.14210846000013],
              [48.02474776200012, 50.13125640900007],
              [48.074563843000135, 50.10526316300012],
              [48.096371297000076, 50.07854644800007],
              [48.10598311300009, 50.05064117400006],
              [48.11249434400014, 50.02196075500008],
              [48.125310099000046, 49.992970277000026],
              [48.132234741000104, 49.9837201940001],
              [48.14236332200005, 49.96377309200007],
              [48.14928796400005, 49.954936422000074],
              [48.16086348500011, 49.946461487000064],
              [48.200447632000134, 49.92501576800005],
              [48.21987797100013, 49.901502991000044],
              [48.2271126710001, 49.879488831000074],
              [48.23930830900008, 49.86476104800006],
              [48.27403487200013, 49.8630557260001],
              [48.30287032100006, 49.866724752000025],
              [48.31217207800012, 49.86357248900005],
              [48.35950769100009, 49.8339618940001],
              [48.41759200100006, 49.811689351000055],
              [48.42989099100009, 49.809673971],
              [48.44281010000009, 49.81499664300004],
              [48.46585778800005, 49.83582224600009],
              [48.47908695500007, 49.84316029900002],
              [48.683518921000086, 49.89545684800002],
              [48.78459802200007, 49.93338735000002],
              [48.862009318000105, 49.992918600000095],
              [48.87818404100011, 50.01002349900004],
              [48.88567712400004, 50.01989369700003],
              [48.88588383000007, 50.03043568900007],
              [48.8741016030001, 50.06981313100009],
              [48.865523315000075, 50.08619456000004],
              [48.851829061000046, 50.09725331600005],
              [48.782841024000106, 50.111464335],
              [48.780980672000055, 50.13756093400009],
              [48.78904219600008, 50.173010966000035],
              [48.77095544500014, 50.211044820000055],
              [48.728890829000136, 50.26540842800004],
              [48.70129561400012, 50.33460317000002],
              [48.67442386900012, 50.478470358000024],
              [48.67866133600006, 50.54854360000006],
              [48.67339034000014, 50.57954946000008],
              [48.64848230000007, 50.60156361900006],
              [48.597425985000086, 50.608023174000024],
              [48.57293135600014, 50.61685984400002],
              [48.56828047700009, 50.63654856400008],
              [48.58399011300014, 50.64962270200003],
              [48.60879480000011, 50.64791737900005],
              [48.739587850000134, 50.597532858000065],
              [48.78625166900014, 50.59060821600009],
              [48.83043501800012, 50.596034241000055],
              [49.01269779400013, 50.683419088],
              [49.102408081000135, 50.757988180000055],
              [49.14405928500014, 50.7817076620001],
              [49.28368900600009, 50.803721823],
              [49.369420207000076, 50.82676951200007],
              [49.40843591400005, 50.848266907],
              [49.423732137000115, 50.88206329300009],
              [49.405490357000076, 50.91353424100002],
              [49.37153894100004, 50.93942413400008],
              [49.34735437000006, 50.96428049700002],
              [49.35913659700009, 50.99265085900002],
              [49.38332116700013, 51.019393413],
              [49.39272627700012, 51.03419871100003],
              [49.40104618300006, 51.067090760000056],
              [49.41060632300014, 51.08553924600007],
              [49.423112020000076, 51.10199819000003],
              [49.43654789200008, 51.112333476000046],
              [49.460112345000084, 51.11615753200009],
              [49.53974572800013, 51.100783794],
              [49.77905928600006, 51.10217905700007],
              [49.79590580300004, 51.1095687870001],
              [49.84282800300008, 51.15067738900005],
              [49.98685022000012, 51.22981984500008],
              [50.02875980600004, 51.242997336000045],
              [50.207456909000086, 51.26594167100008],
              [50.325382528000034, 51.30345876100007],
              [50.34228072100012, 51.312734681000094],
              [50.34894698000011, 51.32260487900008],
              [50.347448365000105, 51.33523976700012],
              [50.34042037000012, 51.35286143100011],
              [50.33757816600013, 51.372033387],
              [50.34672489400003, 51.381205953000105],
              [50.361866089000046, 51.38738128700008],
              [50.376232137000045, 51.397018942],
              [50.372924845000114, 51.40104970300008],
              [50.36444991000013, 51.40691497799999],
              [50.3595923260001, 51.41332285600002],
              [50.36744714400004, 51.41895558700007],
              [50.37964278200013, 51.42115183600005],
              [50.43922570800004, 51.423012187000054],
              [50.45746748800008, 51.42688792000011],
              [50.47105839000011, 51.4361121620001],
              [50.47896488400005, 51.45373382600009],
              [50.502684366000096, 51.45613678000005],
              [50.51834232600004, 51.459754130000036],
              [50.527230672000144, 51.47008941700004],
              [50.531364787000086, 51.49269785600008],
              [50.52216638200008, 51.55075632800008],
              [50.52537032100014, 51.56558746400002],
              [50.5428369550001, 51.5773696910001],
              [50.56185388200004, 51.5806511440001],
              [50.57570316600004, 51.58842844700011],
              [50.57761519400003, 51.61336232500007],
              [50.58169763200004, 51.63529897100004],
              [50.59983606000009, 51.634730530000084],
              [50.639265177000084, 51.61617869100006],
              [50.685773967000046, 51.6156360880001],
              [50.69419722500004, 51.61116607700008],
              [50.675025269000116, 51.59439707500003],
              [50.65869551600008, 51.57618113200009],
              [50.67089115400006, 51.56752533000012],
              [50.69652266500003, 51.56558746400002],
              [50.71998376500011, 51.567421977],
              [50.76432214400006, 51.578661601000064],
              [50.790677124000126, 51.59729095500002],
              [50.794501180000054, 51.625971375000105],
              [50.74737227400004, 51.709041240000076],
              [50.7441683350001, 51.74237253900013],
              [50.76700931800008, 51.75939992300006],
              [50.82085616100005, 51.75255279600002],
              [50.83925297000013, 51.74552480100009],
              [50.857753133000074, 51.735292868],
              [50.8736694750001, 51.721882833000066],
              [50.88431481900005, 51.70555308100002],
              [50.90074792500013, 51.687130433000036],
              [50.92544926000005, 51.679689026000105],
              [51.16977543100012, 51.66948293100002],
              [51.19023929800011, 51.67410797200007],
              [51.21256351800008, 51.68175608300005],
              [51.233854207000036, 51.68547678600008],
              [51.25183760600004, 51.67852630700007],
              [51.276228881000065, 51.65160288500006],
              [51.28842452000009, 51.642869568],
              [51.30847497500014, 51.63705597000002],
              [51.352503296000066, 51.636229147000094],
              [51.37193363500006, 51.62958872500009],
              [51.38195886200009, 51.609796652000014],
              [51.38113203900008, 51.58705902100003],
              [51.373173869000084, 51.57160776800005],
              [51.358962850000125, 51.56147918699999],
              [51.33917077700005, 51.55501963300013],
              [51.24165734800005, 51.543702494000044],
              [51.2365413820001, 51.53589935300003],
              [51.24780684400014, 51.521094055],
              [51.2638265380001, 51.504893494],
              [51.27302494300011, 51.49287872300003],
              [51.27302494300011, 51.49259450400005],
              [51.304237508000085, 51.471639710000076],
              [51.3794783940001, 51.46709218400004],
              [51.461850626000114, 51.47528289900005],
              [51.51497399900012, 51.49269785600008],
              [51.532078898000066, 51.508407492000075],
              [51.5447396240001, 51.524117127000025],
              [51.559829143000115, 51.53458160400008],
              [51.58432377100007, 51.534917501000066],
              [51.609955281000055, 51.527734477000095],
              [51.620497274000115, 51.51869110200006],
              [51.62297774300009, 51.50424753800003],
              [51.62442468200004, 51.48101898200012],
              [51.64736901800012, 51.45122751900003],
              [51.6933093670001, 51.4540955610001],
              [51.74431400600014, 51.473448385000054],
              [51.782296184000074, 51.49285288500003],
              [51.782967977000055, 51.52982737200007],
              [51.7677751060001, 51.562977804000084],
              [51.76472619600008, 51.59331187000002],
              [51.82017500900014, 51.632973532],
              [51.85087080900007, 51.661653951000105],
              [51.86916426600004, 51.67307444300009],
              [51.89675948100006, 51.679740703],
              [51.92476810700009, 51.67826792400011],
              [51.95251835100004, 51.67095570900004],
              [51.97861495000012, 51.66036204000004],
              [52.00455651900006, 51.65485850000006],
              [52.03525231900011, 51.65240387000007],
              [52.065948120000144, 51.653437399000055],
              [52.09178633600004, 51.65870839500009],
              [52.111009969000065, 51.67030975300004],
              [52.13333418800005, 51.70203908300006],
              [52.14801029400013, 51.71606923500009],
              [52.174106893000044, 51.72524180100008],
              [52.230175822000035, 51.72245127400002],
              [52.258184448000065, 51.724208273],
              [52.2795784920001, 51.73534454400003],
              [52.292239218000134, 51.765626933000064],
              [52.307793823000054, 51.77454111700008],
              [52.33487227300009, 51.76371490500013],
              [52.352132202000064, 51.730202739000035],
              [52.36458622300006, 51.69028269500008],
              [52.37766036000005, 51.660103659000086],
              [52.44452966300008, 51.58018605600007],
              [52.47243493700006, 51.51502207500006],
              [52.47884281400013, 51.504867656],
              [52.4902116290001, 51.49259450400005],
              [52.505817912000055, 51.478874410000046],
              [52.52498986900014, 51.46753143300005],
              [52.545815470000036, 51.459521586000065],
              [52.553670288000035, 51.457971294000046],
              [52.57506433100008, 51.467143861000054],
              [52.66368941300004, 51.463448995000036],
              [52.66854699700008, 51.455129090000085],
              [52.67981245900012, 51.45900482200004],
              [52.69231815600011, 51.4684357710001],
              [52.70089644300003, 51.47675567700007],
              [52.7094747320001, 51.48207835],
              [52.721463664000055, 51.48515309700004],
              [52.745544882000104, 51.48701344900006],
              [52.7525728760001, 51.4904757690001],
              [52.757327108000084, 51.49794301400003],
              [52.764665161000096, 51.505255229000014],
              [52.77975468000005, 51.50812327100009],
              [52.789676554000096, 51.50476430300007],
              [52.81096724500014, 51.49073415200006],
              [52.82068241400009, 51.48701344900006],
              [52.87628625500008, 51.49008819600009],
              [52.89654341700003, 51.48528228800008],
              [52.88279748500008, 51.467143861000054],
              [52.90336470500006, 51.46499928900006],
              [52.92920292200006, 51.455361634000056],
              [52.94429244000008, 51.45288116500008],
              [52.95979536900012, 51.45585256000008],
              [52.973231242000054, 51.463604025000095],
              [52.98584029200009, 51.47269907700006],
              [52.99886275300008, 51.48019215900008],
              [53.03710331200011, 51.48972646099999],
              [53.15719934100014, 51.48701344900006],
              [53.14862105300011, 51.50476430300007],
              [53.15327193200005, 51.51267079700001],
              [53.16577762900005, 51.514556987000034],
              [53.18107385300004, 51.514298605000064],
              [53.19047896400008, 51.51248993000006],
              [53.19512984200014, 51.50804575700006],
              [53.19864383900011, 51.50243886300005],
              [53.20494836500012, 51.49721954400012],
              [53.21414676900008, 51.494764913000054],
              [53.22055464600004, 51.49647023500002],
              [53.226032349000036, 51.49949330700004],
              [53.232233520000136, 51.50068186500006],
              [53.307371053000054, 51.49383473800002],
              [53.32235721900008, 51.495333354000095],
              [53.34633508300004, 51.503033142],
              [53.36690230300013, 51.49360219400005],
              [53.36948612500004, 51.4938864140001],
              [53.40731327300011, 51.48417124500007],
              [53.419198852000136, 51.47489532500005],
              [53.43966272000006, 51.45115000400001],
              [53.45340865100013, 51.44189992300009],
              [53.555417928000054, 51.41551910400004],
              [53.59748254400006, 51.39717397100004],
              [53.610298300000125, 51.38841481500005],
              [53.617946411000105, 51.37213673900003],
              [53.60936812400007, 51.364101054000045],
              [53.574434855000106, 51.3532231650001],
              [53.59324507700012, 51.33911549900007],
              [53.59314172300009, 51.32260487900008],
              [53.58859419800007, 51.305344951000095],
              [53.59407189900014, 51.28942861000006],
              [53.627971639000066, 51.267776184000084],
              [53.642544393000094, 51.255425517000035],
              [53.64936568200005, 51.237338766],
              [53.67386031100011, 51.21987213200008],
              [53.857725057000096, 51.18460296700009],
              [53.90898807800011, 51.19044240300006],
              [53.9358598230001, 51.185610657000055],
              [53.974720500000046, 51.16649037700007],
              [53.99404748600011, 51.153390401000095],
              [54.01761193800013, 51.119077251000064],
              [54.03983280500006, 51.11036977200011],
              [54.09192264800009, 51.1052279660001],
              [54.11155969200013, 51.09600372400011],
              [54.120137980000095, 51.08117258700007],
              [54.12995650300013, 51.042337749000026],
              [54.138328085000126, 51.028643494],
              [54.14566613800008, 51.01965179400007],
              [54.14907678200012, 51.00965240500004],
              [54.14535607900012, 50.99265085900002],
              [54.1765686440001, 50.967897848000106],
              [54.19403527900005, 50.95818267800006],
              [54.23351607300009, 50.94309316100005],
              [54.24767541500012, 50.931000876000084],
              [54.26028446500004, 50.91740997400008],
              [54.275787395000066, 50.90428416000002],
              [54.30007531800004, 50.89472401900012],
              [54.38100061100005, 50.88542226200009],
              [54.39164595600005, 50.88051300100007],
              [54.40993941300013, 50.86873077400007],
              [54.419654582000135, 50.86449330700002],
              [54.464303019000056, 50.85803375300004],
              [54.47856571500006, 50.85348622700012],
              [54.48590376800007, 50.84511464400005],
              [54.48786747200006, 50.83555450500005],
              [54.48528365100009, 50.8254259240001],
              [54.47856571500006, 50.81571075400005],
              [54.42192834500008, 50.76868520100008],
              [54.41438358600004, 50.74847971600009],
              [54.41241988100006, 50.704037984000095],
              [54.40714888600007, 50.68481435100007],
              [54.38534143000004, 50.63944244400007],
              [54.379760376000036, 50.61944366500002],
              [54.383584432000134, 50.59990997300012],
              [54.39950077300006, 50.578670959000036],
              [54.43577762800004, 50.547510071],
              [54.455724732000135, 50.535521139000124],
              [54.47856571500006, 50.52596099900002],
              [54.499442993000116, 50.5232738240001],
              [54.54551683900013, 50.53051930800005],
              [54.55070601400007, 50.53133534800007],
              [54.591427042000134, 50.54234242800008],
              [54.64754764800006, 50.57324493400007],
              [54.6762797450001, 50.60254547100003],
              [54.67359257000004, 50.63432647700007],
              [54.639072713000076, 50.706983541000014],
              [54.638659301000075, 50.72801584900013],
              [54.65095829300009, 50.765636291000035],
              [54.65023482300012, 50.78630686500007],
              [54.645377238000094, 50.79266306600009],
              [54.63018436700014, 50.80367014600007],
              [54.62687707600014, 50.81157664000004],
              [54.62987430800007, 50.820309957000106],
              [54.645997356000066, 50.83772491500004],
              [54.65178511500011, 50.846251526000046],
              [54.638245890000064, 50.88573232000009],
              [54.58367557800011, 50.9056794240001],
              [54.52600467900004, 50.91642812100012],
              [54.502956991000076, 50.928262024000034],
              [54.51587609900008, 50.93725372300007],
              [54.534686320000105, 50.94360992500002],
              [54.54595178300008, 50.95327341800002],
              [54.52528120900007, 50.991100566000014],
              [54.53375614500004, 51.003244527],
              [54.55266971800006, 51.01016916900009],
              [54.638245890000064, 51.02768748000004],
              [54.66222375500007, 51.02789418500002],
              [54.685788208000076, 51.02355336600003],
              [54.706872192000105, 51.01629282700004],
              [54.746249634000094, 50.99296091700002],
              [54.811671997000076, 50.97239369700013],
              [54.83120568800007, 50.95931956000008],
              [54.861281372000064, 50.933894755000054],
              [54.894250936000105, 50.912397359000025],
              [55.047729940000124, 50.88423370400007],
              [55.063232870000036, 50.86216786700008],
              [55.0613725180001, 50.82268707300004],
              [55.08400679500005, 50.796900534000045],
              [55.305388631000085, 50.664970602],
              [55.329366496000034, 50.655152080000036],
              [55.34776330600005, 50.651379700000106],
              [55.366056763000074, 50.652464906],
              [55.41597619600003, 50.66140492700002],
              [55.442331177000085, 50.661663310000094],
              [55.46775598100004, 50.656960755000014],
              [55.49111372900006, 50.6458503220001],
              [55.505686483000034, 50.63024403900006],
              [55.51374800600013, 50.61401764000006],
              [55.524289998000086, 50.60068512000002],
              [55.570385376000104, 50.58833445300006],
              [55.5861983640001, 50.57841257800008],
              [55.61679081300014, 50.549938864000055],
              [55.659992310000064, 50.53004343700003],
              [55.694305461000056, 50.5387767540001],
              [55.76489546800008, 50.58683583600008],
              [55.93232710800004, 50.64652211500008],
              [56.078881470000056, 50.724760234000044],
              [56.10006880700013, 50.74785959900002],
              [56.13737919100009, 50.86878245100006],
              [56.14750777200004, 50.89229522700005],
              [56.15835982300007, 50.90552439400007],
              [56.174896281000144, 50.90867665600011],
              [56.258198690000086, 50.88449208600004],
              [56.28858443200005, 50.880306295000096],
              [56.315456177000044, 50.883820293000056],
              [56.33571333800006, 50.895860901000034],
              [56.343878215000075, 50.91141550800005],
              [56.35049279800006, 50.94800242100008],
              [56.364962199000104, 50.95787262000009],
              [56.415811808000115, 50.96267852800007],
              [56.43203820800005, 50.976217754000075],
              [56.43193485600011, 50.98980865500006],
              [56.42035933400007, 51.01864410399999],
              [56.42118615800007, 51.03352691700003],
              [56.43069462100004, 51.04543833400008],
              [56.44650760900004, 51.0565746060001],
              [56.47834029100011, 51.07303354900007],
              [56.508002564000094, 51.06626393700013],
              [56.59657596800014, 50.984020895000086],
              [56.61662642400006, 50.97833648700005],
              [56.68835331200006, 50.96913808200004],
              [56.70747359200004, 50.970429993],
              [56.70964400200006, 50.98159210200002],
              [56.70271936000006, 50.99818023700003],
              [56.68246219900004, 51.03052968400003],
              [56.68029178900008, 51.04977915500005],
              [56.69455448400004, 51.06349924700008],
              [56.716051880000066, 51.07246510800012],
              [56.735585572000105, 51.0775810760001],
              [56.76008020000006, 51.08024241100013],
              [56.776306600000055, 51.07597910600008],
              [56.81361698400008, 51.057039694000125],
              [56.83862837700008, 51.051406962],
              [56.86508671100006, 51.0517686970001],
              [56.891234986000086, 51.0565746060001],
              [56.915832967000085, 51.06417104100005],
              [56.941051066000114, 51.06833099400008],
              [57.025180298000066, 51.06267242500006],
              [57.07241255700012, 51.069726257000056],
              [57.13793827300003, 51.09587453200008],
              [57.15447473200004, 51.09995697100008],
              [57.16822066200007, 51.093781637000106],
              [57.181243123000115, 51.0734986370001],
              [57.18992476400007, 51.0348446660001],
              [57.1974695240001, 51.017352194000054],
              [57.21359257000006, 51.01011749300007],
              [57.237157023000066, 51.00949737600011],
              [57.256277303000104, 51.006035055000055],
              [57.27291711400011, 50.99745676700003],
              [57.28852339700006, 50.98123036700012],
              [57.29761844900008, 50.9649522910001],
              [57.31012414600008, 50.92934722900013],
              [57.318909139000084, 50.913224183000054],
              [57.334308716000066, 50.89741119400004],
              [57.35270552600008, 50.88599070300005],
              [57.41812788900006, 50.862374573000025],
              [57.44303592900013, 50.857775370000084],
              [57.46763391200011, 50.85849884100007],
              [57.49140507000004, 50.866870423000066],
              [57.508871704000114, 50.88128814700006],
              [57.519930461000115, 50.89658437100003],
              [57.53284956900012, 50.90996856800005],
              [57.55589725800007, 50.91875356100006],
              [57.596204875000126, 50.91570465100001],
              [57.68922245300013, 50.89673940100006],
              [57.72239872300014, 50.90872833300004],
              [57.73728153500008, 50.938235576000054],
              [57.73790165200006, 50.97089508100002],
              [57.728186483000115, 51.03709259100002],
              [57.73438765500009, 51.0738862110001],
              [57.7528878170001, 51.097476502000106],
              [57.76880415800014, 51.11967153000005],
              [57.79619266800006, 51.12326304200012],
              [57.841771281000035, 51.10579640700006],
              [57.85768762200007, 51.10339345400011],
              [57.91225793400008, 51.10339345400011],
              [57.92507369000009, 51.0996469120001],
              [57.934065389000125, 51.09396250400006],
              [57.95008508300009, 51.07920888300005],
              [57.96021366400004, 51.07747772300009],
              [57.988428996000096, 51.08742543600009],
              [58.001658162000126, 51.089776713000035],
              [58.07731245900004, 51.09794159000005],
              [58.0841337490001, 51.09662384000008],
              [58.0887846280001, 51.09192128500008],
              [58.08971480400004, 51.085616761],
              [58.08961145000012, 51.07962229500005],
              [58.09095503800006, 51.07610829700009],
              [58.113692667000066, 51.065178732000035],
              [58.14056441300005, 51.05665212000012],
              [58.16764286300008, 51.0551793420001],
              [58.19058719900005, 51.06554046600003],
              [58.20236942600013, 51.0834463500001],
              [58.211464477000106, 51.104943746000046],
              [58.22376346900006, 51.123133851],
              [58.24526086500009, 51.13073028600006],
              [58.26810184700008, 51.13455434200007],
              [58.30840946500007, 51.1500314340001],
              [58.32339563000011, 51.14194407100008],
              [58.35357466600004, 51.12199696900008],
              [58.3659770110001, 51.10892283200012],
              [58.369284302000096, 51.09507354800006],
              [58.37083459500013, 51.08192189500009],
              [58.37796594300005, 51.070656433000025],
              [58.398016398000095, 51.06370595400004],
              [58.52048954300005, 51.061948954000044],
              [58.563484334000066, 51.049262390000095],
              [58.595006959000045, 51.023372498000086],
              [58.60265507000008, 50.98123036700012],
              [58.59635054600011, 50.96247182200004],
              [58.58529178800006, 50.947795716000044],
              [58.570822387000135, 50.93596181300002],
              [58.5543892820001, 50.92541982100006],
              [58.54653446400005, 50.91193227100008],
              [58.55015181500005, 50.89327707900013],
              [58.559970337000095, 50.8751903280001],
              [58.57144250500011, 50.86351145500005],
              [58.5904594320001, 50.86108266200007],
              [58.64099898300003, 50.86340810100002],
              [58.65123091600009, 50.85327952100006],
              [58.643892863000076, 50.81467722600006],
              [58.64668339000008, 50.801293030000025],
              [58.664356730000065, 50.789924215000056],
              [58.689781535000066, 50.78837392200002],
              [58.71954716000005, 50.793489889000014],
              [58.74776249200005, 50.79509185800005],
              [58.768433065000124, 50.78268951500009],
              [58.78507287600007, 50.7497199510001],
              [58.79396122300005, 50.73767934200005],
              [58.811531209000066, 50.72548370400004],
              [58.88677209500008, 50.688948466000014],
              [58.925942830000054, 50.678148092000086],
              [59.19745080600012, 50.66274851600009],
              [59.219361613000046, 50.658356018000106],
              [59.23569136600008, 50.64461008700006],
              [59.246956828000066, 50.62962392200008],
              [59.25904911300006, 50.620373840000084],
              [59.27331180800013, 50.615981344],
              [59.29077844300008, 50.61546458000005],
              [59.386483195000096, 50.630347392],
              [59.437642863000065, 50.6311225380001],
              [59.47815718600009, 50.61437937400005],
              [59.49810428900008, 50.599703267000066],
              [59.55102095500007, 50.58600901300004],
              [59.56342330000007, 50.57985951800008],
              [59.56042606600005, 50.553814596000095],
              [59.53531132000012, 50.54657989500002],
              [59.47815718600009, 50.55241933300003],
              [59.451698853000096, 50.53727813800002],
              [59.45076867700004, 50.52229197200002],
              [59.466271606000134, 50.507357483000064],
              [59.522805623000124, 50.47464630200007],
              [59.55505171700008, 50.484361471000014],
              [59.58771122300004, 50.50616892600006],
              [59.62223107900013, 50.524100647000026],
              [59.67308068900013, 50.52952667300009],
              [59.725480591000064, 50.52766632200009],
              [59.77467655500004, 50.53371246400003],
              [59.81570764200006, 50.56290964800006],
              [59.85921919800012, 50.622544251000065],
              [59.87203495300008, 50.635980123000124],
              [59.90397098800008, 50.66026804700003],
              [59.91513309700008, 50.673807272],
              [59.91957727100004, 50.69091217000003],
              [59.91389286300006, 50.726000468000066],
              [59.91461633300008, 50.74589589500009],
              [59.920197388000076, 50.763052470000034],
              [59.962158651000095, 50.829508362000084],
              [59.96908329300004, 50.837363180000025],
              [59.97807499200013, 50.84377105700007],
              [60.02127648900006, 50.85405466700006],
              [60.08328820800011, 50.85715525400012],
              [60.13620487500009, 50.844494528000084],
              [60.15212121600007, 50.80770090700007],
              [60.15480839000014, 50.77090728800009],
              [60.17671919700007, 50.74217519200006],
              [60.20948205500008, 50.719747620000064],
              [60.24544885200004, 50.70197092800005],
              [60.300432577000095, 50.68465932300005],
              [60.718494914000075, 50.65267161100006],
              [60.818333781000035, 50.66290354400003],
              [61.09521610550007, 50.72269317600008],
              [61.37209843000005, 50.78248280800004],
              [61.40403446500005, 50.80258494100009],
              [61.42687544800003, 50.83307403600007],
              [61.441758260000086, 50.874983622000045],
              [61.45674442600006, 50.96500396800012],
              [61.465426066000134, 50.99265085900002],
              [61.51317509000012, 51.159514059000074],
              [61.534155721000104, 51.2060745240001],
              [61.56733199100012, 51.233876445000064],
              [61.61105025300009, 51.24925018300006],
              [61.66365686000012, 51.25839691200004],
              [61.646258531000115, 51.263192932000024],
              [61.59317020700013, 51.2778272500001],
              [61.56299117000003, 51.29552642900002],
              [61.53870324700006, 51.32317332000004],
              [61.49839563000006, 51.40053293900006],
              [61.47803511500007, 51.42115183600005],
              [61.47379764800013, 51.42580271400003],
              [61.437624146000076, 51.43223643000006],
              [61.393699179000066, 51.44983225600005],
              [61.35618208800014, 51.459650778000096],
              [61.34212609900004, 51.45843638200007],
              [61.31835494000006, 51.453449606000035],
              [61.30491906800012, 51.45288116500008],
              [61.29148319500007, 51.45502573700007],
              [61.257170044000134, 51.467143861000054],
              [61.23298547400009, 51.47055450500007],
              [61.16404911300003, 51.467143861000054],
              [61.141518188000134, 51.46918508],
              [61.101830688000064, 51.47815094000005],
              [61.081470175000106, 51.48019215900008],
              [61.04850061000013, 51.478900249000034],
              [61.038061971000104, 51.48019215900008],
              [61.02938033000004, 51.48267262800006],
              [61.023282511000104, 51.48551483200005],
              [61.01894169100012, 51.488667094],
              [61.015220988000124, 51.49207773900012],
              [61.01067346200006, 51.49623769100005],
              [61.00395552600014, 51.50068186500006],
              [60.9709859620001, 51.5156163540001],
              [60.958997030000035, 51.52486643500005],
              [60.944630981000046, 51.54437428800013],
              [60.937396281000076, 51.55687998500004],
              [60.934399048000046, 51.565820008000074],
              [60.933468872000105, 51.59842783600003],
              [60.937396281000076, 51.61116607700008],
              [60.92106652900014, 51.611476136000064],
              [60.51509647600011, 51.61790985100002],
              [60.50579471800012, 51.6197702030001],
              [60.4999036050001, 51.62710825700002],
              [60.498456665000106, 51.637159323000034],
              [60.49535608000008, 51.64625437400012],
              [60.48471073400009, 51.651034445],
              [60.375880167000105, 51.66253245100005],
              [60.35510624200003, 51.67142079700007],
              [60.35603641800003, 51.69227223700001],
              [60.37153934800011, 51.70516550700002],
              [60.41835819500005, 51.71935068800006],
              [60.437375122000105, 51.72839406400003],
              [60.44119917800003, 51.73622304300007],
              [60.44016565000004, 51.75394806000007],
              [60.44585005700009, 51.76004587900003],
              [60.465797160000136, 51.76919260700002],
              [60.47551232900008, 51.776194764000124],
              [60.479749797000125, 51.78425628700002],
              [60.45205122900006, 51.80546946300008],
              [60.27449100700005, 51.832832134000014],
              [60.171964966000075, 51.88037445100012],
              [60.138065226000094, 51.888875224000046],
              [60.12648970600014, 51.87910837800008],
              [60.11780806400009, 51.86355377200006],
              [60.092279907000034, 51.85476877900008],
              [60.06075728400009, 51.858670349000036],
              [60.04008671100007, 51.87120188400003],
              [59.99461145000009, 51.9362883510001],
              [59.9857231040001, 51.95228220700007],
              [59.98727339700008, 51.968844504000074],
              [60.00318973800012, 51.992512309000105],
              [60.02977585700012, 51.992610475000035],
              [60.20276412000004, 51.99274485300005],
              [60.347664836000035, 52.08961232500009],
              [60.42579960100005, 52.12958404600003],
              [60.506518189000076, 52.15164988200003],
              [60.562432088000094, 52.15033213300008],
              [60.61813928200013, 52.14294240300008],
              [60.672192830000085, 52.144337667000045],
              [60.72283573400006, 52.16958160500009],
              [60.76293664500008, 52.210199280000055],
              [60.78123010300004, 52.220612081000084],
              [60.876728150000076, 52.24590769500004],
              [60.89667525200008, 52.25469268900004],
              [60.947421508000104, 52.289729310000055],
              [60.96581831900011, 52.29957367000013],
              [61.008503052000094, 52.314999085000025],
              [61.03992232300004, 52.334997864000044],
              [60.97801395700009, 52.387604472000035],
              [60.96137414600008, 52.40197052000006],
              [60.955896443000086, 52.419824728],
              [60.95145227100011, 52.4610883590001],
              [60.944630981000046, 52.479071757],
              [60.93646610500008, 52.48858022100008],
              [60.92396040900013, 52.49374786400007],
              [60.83135624200014, 52.51315236400005],
              [60.81492313700011, 52.521911520000046],
              [60.80996219900004, 52.53842214000012],
              [60.814406372000064, 52.585861105],
              [60.81347619600007, 52.60549814900004],
              [60.80841190600012, 52.62118194600002],
              [60.80314091000008, 52.627744853000095],
              [60.793115682000064, 52.62880422000008],
              [60.74164595600007, 52.62536773700005],
              [60.724489380000136, 52.626220398000086],
              [60.71167362500012, 52.63224070300002],
              [60.70609257000012, 52.64056060800009],
              [60.704128866000076, 52.64717519200006],
              [60.69968469200006, 52.652756246000095],
              [60.68666223100013, 52.658053081000034],
              [60.67684370900008, 52.66358245900004],
              [60.672606242000086, 52.67216074700006],
              [60.672192830000085, 52.682625224],
              [60.67353641700009, 52.69386484800005],
              [60.696170695000035, 52.73492177400003],
              [60.73864872200005, 52.75094146800008],
              [60.78743127500013, 52.75791778600005],
              [60.829082479000135, 52.771637879000096],
              [60.843035116000124, 52.78404022200006],
              [60.86690962800003, 52.81225555400003],
              [60.8848930260001, 52.82525217700005],
              [61.05842248500005, 52.92217132600008],
              [60.97543013500007, 52.970462952],
              [60.974603312000056, 52.97123809800003],
              [60.97543013500007, 52.9715481570001],
              [61.052428020000036, 52.971858216],
              [61.08860152200003, 52.97805938800006],
              [61.12229455500011, 52.99247711200009],
              [61.12239790900014, 52.99247711200009],
              [61.12260461500006, 52.99263214200003],
              [61.12270796700011, 52.99265798000003],
              [61.15578088400008, 53.00968536400008],
              [61.1903007410001, 53.01314768500002],
              [61.22492395100011, 53.00640391100008],
              [61.25872033700006, 52.99265798000003],
              [61.28734908000007, 52.985164897000104],
              [61.318458293000106, 52.98250356000007],
              [61.34936079900007, 52.98490651500005],
              [61.37664595500013, 52.99265798000003],
              [61.42429162600007, 53.017359314000046],
              [61.448269491000076, 53.02141591400006],
              [61.47803511500007, 53.012346700000094],
              [61.51462203000011, 52.992554626000114],
              [61.57425663200007, 52.95583852100005],
              [61.60557255000003, 52.948319601],
              [61.6364750570001, 52.960101828000106],
              [61.655905396000094, 52.970876363000016],
              [61.67533573400004, 52.97361521400008],
              [61.717813761000116, 52.969946187000076],
              [61.81982303900014, 52.97824025500002],
              [61.85651330500008, 52.97015289400012],
              [61.92255578600003, 52.93816518200005],
              [61.95924605400012, 52.93493540500005],
              [62.034848674000045, 52.95271209800008],
              [62.07267582200012, 52.96958445300008],
              [62.094173218000094, 52.99247711200009],
              [62.094173218000094, 52.99265798000003],
              [62.11365523300009, 53.04187978100002],
              [62.11603234900008, 53.06459157300007],
              [62.10802250100005, 53.08856943800002],
              [62.08321781400008, 53.113296611000024],
              [62.05066166200004, 53.124768779000036],
              [61.83511926300008, 53.15112376000009],
              [61.764219198000035, 53.16946889200007],
              [61.70510135900014, 53.203497823000035],
              [61.66427697800009, 53.23889617900004],
              [61.643089640000085, 53.24334035300005],
              [61.54728153500008, 53.211455994000076],
              [61.51431197200009, 53.208665467000046],
              [61.47803511500007, 53.21512502100008],
              [61.379849894000074, 53.26186635400008],
              [61.34481327300006, 53.27010874500003],
              [61.24952193200005, 53.269695333000115],
              [61.20290979000009, 53.27643910700006],
              [61.16270552600008, 53.299150899000026],
              [61.14275842300009, 53.3230254110001],
              [61.13366337100007, 53.34814015800002],
              [61.13717736800004, 53.37312571300002],
              [61.15598758900006, 53.39669016500004],
              [61.200946086000044, 53.43622263700006],
              [61.20983443200009, 53.44981353800004],
              [61.21427860500012, 53.46185414700004],
              [61.21820601400009, 53.4926533000001],
              [61.23525923700009, 53.503040264000035],
              [61.261097453000104, 53.506657614000105],
              [61.28765913900014, 53.50319529200006],
              [61.30708947800008, 53.4926533000001],
              [61.32838016700009, 53.47074249300003],
              [61.35349491400012, 53.44981353800004],
              [61.38160689300014, 53.43611928400013],
              [61.41230269400012, 53.43575754900003],
              [61.43731408700012, 53.446506247000045],
              [61.488473755000086, 53.479320780000066],
              [61.51472538300004, 53.49249827100006],
              [61.55534305900005, 53.50572743800005],
              [61.52836796100013, 53.57166656500006],
              [61.516792440000074, 53.58572255500009],
              [61.50304650900006, 53.58897817000006],
              [61.390288534000035, 53.588513082000034],
              [61.361246379000136, 53.58257029200003],
              [61.31608117700006, 53.545208232000064],
              [61.28073449700014, 53.542417704000016],
              [61.14038130700004, 53.56272654300004],
              [61.12146773300009, 53.56980621400005],
              [61.11454309100009, 53.5762140910001],
              [61.10338098200009, 53.59249216700003],
              [61.096352987000046, 53.59921010400005],
              [61.04664025900013, 53.608460185000055],
              [60.90732059700008, 53.61362782800008],
              [60.88024214700005, 53.632799785000074],
              [60.90473677600011, 53.65708770800008],
              [61.00757287600004, 53.63574534200008],
              [61.0427128500001, 53.65424550400009],
              [61.04488326000006, 53.666699524000094],
              [61.04395308400012, 53.67920522100009],
              [61.044779907000134, 53.6914008590001],
              [61.052221313000075, 53.70328643800012],
              [61.06793094900013, 53.708919169000055],
              [61.10689497900012, 53.7124331670001],
              [61.11567997200012, 53.723646953000056],
              [61.12746219900009, 53.747159729000046],
              [61.151750122000124, 53.76524648100006],
              [61.17872522000005, 53.780852763],
              [61.19908573400005, 53.79713083900002],
              [61.20197961500014, 53.819610087000044],
              [61.177174927000124, 53.83283925400012],
              [61.142448364000074, 53.841882630000086],
              [61.1149565020001, 53.852321269000115],
              [61.095216105000134, 53.87014963800006],
              [61.08498417200008, 53.87531728100008],
              [61.06524377400012, 53.87846954300004],
              [60.999614706000045, 53.87939971900006],
              [60.97801395700009, 53.882603659000054],
              [60.97139937300011, 53.89299062100007],
              [60.96943566900006, 53.90425608300002],
              [60.97181278500011, 53.915831604000076],
              [60.97801395700009, 53.92668365500002],
              [60.996100708000085, 53.94141143900002],
              [61.017391398000086, 53.94895619800006],
              [61.06379683400013, 53.95531239900002],
              [61.096352987000046, 53.95624257400006],
              [61.14523889100013, 53.950144755000096],
              [61.15185347500005, 53.945442200000016],
              [61.15557417800005, 53.938414205000115],
              [61.16301558400005, 53.928492330000026],
              [61.17624475100007, 53.916503398000046],
              [61.192884562000074, 53.90709828700001],
              [61.210764608000034, 53.90766672800005],
              [61.22730106700004, 53.92590850900011],
              [61.23050500500011, 53.94306508400008],
              [61.22513065600003, 53.960221660000045],
              [61.204770142000086, 53.99257110600003],
              [61.20125614400007, 53.998358867],
              [61.193504680000046, 54.018254293],
              [61.249831990000075, 54.02073476200009],
              [61.274843384000064, 54.0285379030001],
              [61.293343546000074, 54.046056214000046],
              [61.311533650000115, 54.059853821],
              [61.33768192500014, 54.06316111300002],
              [61.41767704200004, 54.05597808900005],
              [61.43317997200006, 54.04745147800004],
              [61.46191206900005, 54.01112294600007],
              [61.47855188000011, 54.00290639300003],
              [61.55275923600004, 53.992519430000115],
              [61.55616988100007, 53.96094513000013],
              [61.563921346000086, 53.951746725000035],
              [61.581801392000045, 53.94766428600012],
              [61.60050826000014, 53.950248108000025],
              [61.61105025300009, 53.959549866000046],
              [61.61642460100006, 53.97417429700003],
              [61.619938599000136, 53.99257110600003],
              [61.71533329200014, 53.99257110600003],
              [61.728562459000045, 53.98528473000006],
              [61.74210168400003, 53.981564026000044],
              [61.755020793000085, 53.98326934800009],
              [61.77703495300011, 53.999909160000115],
              [61.79129764800007, 54.00078765900007],
              [61.80638716700008, 53.99753204400007],
              [61.82054650900011, 53.99257110600003],
              [61.828091268000094, 53.973244121000064],
              [61.8299516190001, 53.960376689000086],
              [61.836152791000075, 53.95112660800005],
              [61.85640995300008, 53.94270334900007],
              [61.89165328000013, 53.93624379500004],
              [62.00363610900007, 53.93200632800007],
              [62.003326050000055, 53.99231272400006],
              [62.002395874000115, 53.99830719000009],
              [62.00260258000009, 54.017375794000074],
              [62.41270674600008, 54.02662587500008],
              [62.43348067200009, 54.02466217100006],
              [62.44614139800012, 54.01453359],
              [62.444022664000045, 53.99231272400006],
              [62.44381595900006, 53.99231272400006],
              [62.39958093300004, 53.974484355000115],
              [62.386610148000045, 53.961306865000026],
              [62.38996911600003, 53.94156646700007],
              [62.40815922000007, 53.924719950000096],
              [62.45668339000008, 53.90921702100009],
              [62.477715698000054, 53.89516103200005],
              [62.487379192000105, 53.88596262600005],
              [62.49890303600006, 53.877797750000056],
              [62.51161543800009, 53.872630107000035],
              [62.525258016000066, 53.87185496100004],
              [62.541226033000044, 53.87666086800003],
              [62.54510176600007, 53.883688863000046],
              [62.53662683100009, 53.91495310500004],
              [62.53176924700006, 53.922497864],
              [62.53176924700006, 53.93035268100003],
              [62.54365482600008, 53.943013407000066],
              [62.58654626400005, 53.96983347600006],
              [62.569389689000104, 53.987816874000046],
              [62.56318851700007, 53.992519430000115],
              [62.55057946700009, 54.02683258100005],
              [62.580965210000045, 54.053600973000115],
              [62.62912764500004, 54.07117096000009],
              [62.670262085000104, 54.07773386700008],
              [62.757181844000115, 54.081092835000064],
              [62.81206221500014, 54.094993795000065],
              [62.83133752500004, 54.09272003200003],
              [62.875210816000106, 54.079542542000056],
              [62.90239261900007, 54.078457337000074],
              [62.98548832200004, 54.09287506200009],
              [63.08465539600007, 54.08564036100002],
              [63.11219893400005, 54.093701884],
              [63.127443481000114, 54.110445048000045],
              [63.12532474800014, 54.12486277300006],
              [63.11602299000003, 54.13969390900009],
              [63.110028523000096, 54.15798736600006],
              [63.1237744550001, 54.174110413000065],
              [63.15674401900009, 54.18005320300007],
              [63.21627526900005, 54.1787096150001],
              [63.32859195700007, 54.16311007500009],
              [63.3316170650001, 54.16268992100005],
              [63.368307333000075, 54.16284495100008],
              [63.396781047000104, 54.170596415],
              [63.44969771400008, 54.196124573000034],
              [63.47755131000014, 54.20397939100006],
              [63.54493737800004, 54.20645986000004],
              [63.70864831600005, 54.25043650400009],
              [63.74399499500004, 54.248731181000025],
              [63.77350223800005, 54.23968780600008],
              [63.85602950000009, 54.2018606570001],
              [63.88362471500005, 54.19741648400007],
              [63.897473999000056, 54.1941608690001],
              [63.90801599100007, 54.20749338800003],
              [63.94036543800007, 54.21529653000003],
              [63.976642293000054, 54.218862203000114],
              [64.00785485900013, 54.228680725000075],
              [64.02542484600008, 54.255242411],
              [63.99369551600006, 54.28040883400003],
              [63.978967733000104, 54.296480205000094],
              [63.98036299600005, 54.30371490600005],
              [63.9882178150001, 54.30784902000009],
              [63.99596927900012, 54.31549713100007],
              [64.00449589100003, 54.319734599000114],
              [64.02325443600012, 54.30759063700002],
              [64.03514001500014, 54.303973287000034],
              [64.04805912300003, 54.30268137700007],
              [64.05953129100004, 54.30371490600005],
              [64.06800622600008, 54.30769399000006],
              [64.08433597800013, 54.320199687000056],
              [64.09374108900005, 54.32417877300013],
              [64.10810713700005, 54.324747214000084],
              [64.1520321050001, 54.317357483000066],
              [64.1766300860001, 54.32050974600013],
              [64.22530928500004, 54.33461741100005],
              [64.25585005700003, 54.338648174000056],
              [64.27621057100004, 54.344384258000034],
              [64.28230839000008, 54.34805328400002],
              [64.29403894000006, 54.35337595600005],
              [64.30856001800004, 54.35182566400003],
              [64.33382979300012, 54.34464264000009],
              [64.4325317790001, 54.351515605000046],
              [64.4445723880001, 54.35466786800002],
              [64.45428755700004, 54.36169586200002],
              [64.46178063900004, 54.36877553300003],
              [64.46705163600006, 54.37197947200012],
              [64.47898889200013, 54.370894267000025],
              [64.50007287600005, 54.36619171200003],
              [64.51139001500013, 54.36510650700005],
              [64.53650476000007, 54.36862050400002],
              [64.57851770100007, 54.38557037300011],
              [64.59148848500013, 54.37854237900008],
              [64.65267338100011, 54.347123109000066],
              [64.68429935700004, 54.33611602800006],
              [64.72016280100007, 54.33384226500006],
              [64.78455163600006, 54.35322092800003],
              [64.84723514900008, 54.383916728000045],
              [64.91064213100003, 54.40272695000006],
              [64.97771813900005, 54.38660390200009],
              [65.05709314000012, 54.32386871300004],
              [65.07145918800012, 54.314877015],
              [65.08541182500011, 54.30857249000009],
              [65.10019128400012, 54.30547190400004],
              [65.11745121300004, 54.3064020800001],
              [65.12447920700004, 54.30893422400008],
              [65.13646814000009, 54.3163756310001],
              [65.14370284000006, 54.317615866000054],
              [65.17377852400011, 54.31017445900004],
              [65.18421716400007, 54.31043284100009],
              [65.21294925900014, 54.343040670000065],
              [65.18132328300004, 54.449132385000084],
              [65.20225223800014, 54.47254180900005],
              [65.19946171100008, 54.487786357000076],
              [65.19806644700003, 54.4922822060001],
              [65.19816980000013, 54.51615671800009],
              [65.21429284700014, 54.52788726900006],
              [65.34157190000008, 54.56147694900001],
              [65.37035567200013, 54.56245880200008],
              [65.42750980600005, 54.55279530900005],
              [65.44900720200008, 54.55661936400007],
              [65.45619022700004, 54.577858378000045],
              [65.44487308800007, 54.614186910000015],
              [65.4497823480001, 54.62746775400002],
              [65.47737756300012, 54.63268707300004],
              [65.57458093200012, 54.62545237200008],
              [65.71297041800011, 54.597185364],
              [65.74397627800005, 54.600854391],
              [65.7703312590001, 54.6173908490001],
              [65.79833988500013, 54.64813832700004],
              [65.82696862800009, 54.6726846320001],
              [65.85942142800013, 54.68575876900006],
              [65.93280196100005, 54.70255360900005],
              [65.95187056500004, 54.69366526300011],
              [65.96065555800004, 54.627984518000076],
              [65.97745039900008, 54.611706442000056],
              [66.09777630500014, 54.63715821400008],
              [66.44651737500004, 54.710925191000015],
              [66.50992435700005, 54.716712952000066],
              [66.63766849800004, 54.71366404200005],
              [66.70030033400008, 54.71924509700007],
              [66.72241784700009, 54.727203268000025],
              [66.76045170100014, 54.75092275000007],
              [66.78179406800012, 54.75820912700006],
              [66.97733768700004, 54.76368682900004],
              [67.00818851700012, 54.767924296],
              [67.06699629700012, 54.7875096640001],
              [67.0985189210001, 54.79200551400005],
              [67.1739665120001, 54.79138539700007],
              [67.2133439530001, 54.797173157000046],
              [67.23954390500012, 54.812934469000126],
              [67.26005944800005, 54.83691233400005],
              [67.28393396000007, 54.85329376300008],
              [67.3113224700001, 54.8599083460001],
              [67.37793339000012, 54.84905629500004],
              [67.44299401900008, 54.85701446600011],
              [67.62272465000012, 54.85386220300005],
              [67.69848230000008, 54.86791819200006],
              [67.75791019700006, 54.8978388470001],
              [67.79754602000008, 54.937164612000075],
              [67.81733809400009, 54.95215077700006],
              [67.8467936610001, 54.963933004000054],
              [67.88224369300013, 54.970444235000016],
              [67.91314620000014, 54.96915232400006],
              [68.00967777500006, 54.943004049000066],
              [68.16605065900012, 54.956129863000044],
              [68.18362064600012, 54.96713694300003],
              [68.19090702400007, 54.99256174800003],
              [68.21307621200003, 54.99845286100005],
              [68.22180953000009, 55.00775461800005],
              [68.22599532100014, 55.02088043200003],
              [68.23478031400003, 55.03850209500011],
              [68.25374556500009, 55.045891826000016],
              [68.28159916200013, 55.04713206000007],
              [68.30423343900009, 55.052609762000046],
              [68.30816084800006, 55.07281524700004],
              [68.22811405400012, 55.10159901900006],
              [68.19054528800007, 55.125370179000114],
              [68.20697839300004, 55.154153951000026],
              [68.18475752800003, 55.167279765],
              [68.17710941600006, 55.17053538000009],
              [68.24087813300008, 55.19115427700008],
              [68.26237552900011, 55.19404815700007],
              [68.27705163500008, 55.190844218],
              [68.28986739100009, 55.18526316300007],
              [68.30578373200012, 55.18138743100003],
              [68.32573083500012, 55.181955872000074],
              [68.3767871500001, 55.19508168500006],
              [68.40117842600011, 55.19471995100007],
              [68.47734948800013, 55.182834372000045],
              [68.54411543800006, 55.19689036100006],
              [68.56716312700013, 55.197562154000124],
              [68.59362146000012, 55.19358307000006],
              [68.6053003340001, 55.19559845],
              [68.61584232600006, 55.205468648000064],
              [68.61821944100006, 55.2154422],
              [68.61284509300003, 55.23471751000004],
              [68.61367191600004, 55.243089092],
              [68.62989831500005, 55.2548713180001],
              [68.67640710500012, 55.273216451000096],
              [68.68369348100009, 55.28861602800008],
              [68.6808512770001, 55.309803365000036],
              [68.68234989400014, 55.327166647000055],
              [68.68891280100007, 55.34328969300002],
              [68.70059167500006, 55.36049794600011],
              [68.72250248200004, 55.352798157],
              [68.73423368500005, 55.351714066000014],
              [68.82259973100014, 55.343548076],
              [68.8460091550001, 55.336778463000044],
              [68.86678308200004, 55.325668030000045],
              [68.90316329000012, 55.290838115000085],
              [68.92280033400004, 55.27636871400004],
              [68.94564131700014, 55.27037424700002],
              [68.97060103400014, 55.27864247700005],
              [68.98088464400013, 55.29145823200004],
              [68.98326175900007, 55.3085631310001],
              [68.97726729300007, 55.34670033800005],
              [68.95235925300005, 55.355898743000054],
              [68.93230879700013, 55.360808004],
              [68.91783939600009, 55.37093658500005],
              [68.90657393400005, 55.4050430300001],
              [68.90243981900011, 55.41248443600004],
              [68.90243981900011, 55.41951243100003],
              [68.91112146000006, 55.42736724800007],
              [68.92729618300007, 55.4337234500001],
              [68.9431608480001, 55.43455027300003],
              [69.12258142100012, 55.397860006000045],
              [69.14779952000009, 55.378222962],
              [69.16454268400014, 55.347423808000045],
              [69.18614343200011, 55.32577138300006],
              [69.22624434500011, 55.33357452400007],
              [69.31027022300003, 55.38147857700001],
              [69.33455814700005, 55.385147604000096],
              [69.4772884520001, 55.34943918900008],
              [69.67386560100005, 55.3340396120001],
              [69.80228153500013, 55.29207834900011],
              [69.83044519100008, 55.276575419],
              [69.91168054200006, 55.21161814400004],
              [69.94030928600012, 55.20024932900007],
              [70.01999434400005, 55.19534006800002],
              [70.05864831600007, 55.18702016300007],
              [70.19703780100008, 55.13348337800004],
              [70.21367761300007, 55.13198476100011],
              [70.23135095200007, 55.141493225],
              [70.26401045700004, 55.17342926100007],
              [70.28462935400006, 55.183196106000125],
              [70.37263431800005, 55.20055938800006],
              [70.38245284100003, 55.206243796000095],
              [70.38529504400003, 55.21394358300007],
              [70.38576013200003, 55.22241851800008],
              [70.38808557200008, 55.230273336000025],
              [70.40002282700004, 55.24593129500006],
              [70.44115726700011, 55.28334503300003],
              [70.46007084200005, 55.28742747100006],
              [70.46858559900005, 55.28546209800005],
              [70.53887740100004, 55.2692373660001],
              [70.56125329600013, 55.269599101],
              [70.58440433800013, 55.27316477500007],
              [70.60652185000004, 55.28050282900007],
              [70.62543542500009, 55.29249176100002],
              [70.66574304200003, 55.30918324800005],
              [70.7212435300001, 55.313110657000024],
              [70.77757084100011, 55.30701283800006],
              [70.82035892800013, 55.294145406000084],
              [70.80454594000014, 55.281536357000036],
              [70.78893965700007, 55.26546498700007],
              [70.78211836800006, 55.248463440000066],
              [70.79317712400007, 55.2331672160001],
              [70.86190677900004, 55.18056060800011],
              [70.96009200100008, 55.10557810500005],
              [70.97714522300004, 55.07798289000003],
              [70.97786869300012, 55.06573557600011],
              [70.97714522300004, 55.05338490900006],
              [70.97745528200011, 55.05157623300006],
              [70.97745528200011, 55.04790720600006],
              [70.97714522300004, 55.046098531000084],
              [70.9733211680001, 55.018451640000066],
              [70.9692387290001, 55.005067444000034],
              [70.96339929200008, 54.99225168900004],
              [70.95699141500006, 54.973493144000045],
              [70.97445804800009, 54.94693145800004],
              [70.96644820100005, 54.934942526000086],
              [70.95513106300007, 54.9232636520001],
              [70.9474829510001, 54.90605540000003],
              [70.94593265800006, 54.88791697300009],
              [70.95327071100013, 54.87349924700008],
              [70.98996097800011, 54.84864288400003],
              [70.99719567900007, 54.83484527600008],
              [70.99409509300006, 54.80750844400005],
              [71.00598067300007, 54.77422882100011],
              [71.04701176000003, 54.74906239900007],
              [71.09724125100007, 54.73304270500002],
              [71.13692875200013, 54.7270482390001],
              [71.18033695500003, 54.727358297000066],
              [71.20069746900009, 54.72399932900005],
              [71.21878422000009, 54.7141808060001],
              [71.25278731300011, 54.682399801000045],
              [71.26467289200014, 54.661729228000056],
              [71.2648795980001, 54.63919830400003],
              [71.25232222500011, 54.62534901900007],
              [71.23015303600005, 54.61754587800003],
              [71.17904504400008, 54.608709209000025],
              [71.14757409700013, 54.59144928000005],
              [71.14121789500012, 54.563750712000015],
              [71.14824589000011, 54.49248891300006],
              [71.14592045100011, 54.48618438700005],
              [71.14519698100008, 54.48060333300002],
              [71.14685062600006, 54.47615916000002],
              [71.1669010820001, 54.46272328700006],
              [71.17103519800008, 54.450992737],
              [71.16591923000004, 54.41704132100007],
              [71.16865808200009, 54.41094350200011],
              [71.17609948800009, 54.407584534000094],
              [71.19346276900012, 54.40401886000002],
              [71.19801029500013, 54.399523011],
              [71.19811364800006, 54.39166819300006],
              [71.19568485500008, 54.37451161700001],
              [71.19583988500005, 54.360817362],
              [71.19062056500013, 54.318184307000095],
              [71.1344482830001, 54.311569723],
              [71.11625817900011, 54.311724752000046],
              [71.09687951700005, 54.31565216100002],
              [71.05982751500011, 54.32795115200004],
              [71.039467, 54.33208526700007],
              [71.00339685000006, 54.33311879500006],
              [70.98003910300014, 54.32505727200005],
              [70.97084069800013, 54.30500681600002],
              [70.97714522300004, 54.27012522400004],
              [71.03879520700008, 54.267593079000065],
              [71.0520760500001, 54.26320058200007],
              [71.05724369300009, 54.247129212000075],
              [71.05636519400014, 54.22340972900004],
              [71.05155928500005, 54.20031036400006],
              [71.04396285000007, 54.18594431600006],
              [71.08235843900013, 54.174265442],
              [71.09744795700004, 54.1650670370001],
              [71.11300256400006, 54.15023590100007],
              [71.1436983640001, 54.113700664000035],
              [71.16126835100005, 54.101970113000064],
              [71.18230065900008, 54.10155670200005],
              [71.21806075100011, 54.116284486000055],
              [71.24575931800013, 54.13576650000003],
              [71.29629886900005, 54.188993225],
              [71.32058679300013, 54.20103383400006],
              [71.34973230000008, 54.19767486600004],
              [71.3815649820001, 54.18883819600005],
              [71.41298425300005, 54.18444570000007],
              [71.44352502500004, 54.18511749300005],
              [71.45313684100006, 54.18134511300012],
              [71.46243859900011, 54.171526591000045],
              [71.46832971200007, 54.15840077700007],
              [71.47711470600007, 54.10966990200005],
              [71.49912886600004, 54.11158193000007],
              [71.54935835800012, 54.12698150700005],
              [71.57354292800005, 54.12920359300004],
              [71.58418827400004, 54.125896302000044],
              [71.60465214100003, 54.113700664000035],
              [71.61498742700013, 54.109514873000094],
              [71.63235070900004, 54.10713775700005],
              [71.64723352100009, 54.10858469700004],
              [71.68061649600008, 54.119075013],
              [71.7087284750001, 54.13220082700006],
              [71.71730676300012, 54.14646352200005],
              [71.71224247300006, 54.19069854700005],
              [71.71544641200012, 54.210749003],
              [71.72536828700004, 54.229094137000075],
              [71.74138798000007, 54.24242665700011],
              [71.76247196500003, 54.247645976000044],
              [71.95801558500006, 54.23596710200006],
              [71.9836470950001, 54.23157460600005],
              [72.00245731700011, 54.225631816000046],
              [72.01868371600011, 54.214986471000046],
              [72.07697473100006, 54.14832387300005],
              [72.09950565600008, 54.131890768000076],
              [72.12885786900006, 54.126051331],
              [72.15510949700007, 54.12837677100002],
              [72.17764042200008, 54.1359732050001],
              [72.1904561770001, 54.15199290000005],
              [72.18735559100014, 54.1794330850001],
              [72.16999230900012, 54.19684804300003],
              [72.1422937420001, 54.20330759700009],
              [72.11149458800014, 54.20620147700008],
              [72.08513960800008, 54.21312611900005],
              [72.06674279800006, 54.222376201000074],
              [72.06539921100011, 54.228008932000094],
              [72.06570926900008, 54.240979717000116],
              [72.06756962100008, 54.25110829700007],
              [72.07211714700014, 54.262735494000125],
              [72.07800826000005, 54.273897603000066],
              [72.09867883300006, 54.300510966],
              [72.10301965400004, 54.311569723],
              [72.0947514240001, 54.3207681280001],
              [72.07129032400013, 54.333222148000075],
              [72.03842411300008, 54.34603790300007],
              [72.0270552980001, 54.35533966100009],
              [72.02467818200006, 54.37094594400013],
              [72.04317834500006, 54.378025615000055],
              [72.15180220500008, 54.36825876900009],
              [72.18477177000005, 54.3568382780001],
              [72.22187544700012, 54.333222148000075],
              [72.25277795400012, 54.303456523000094],
              [72.26745406100014, 54.273484192000055],
              [72.27871952400005, 54.262735494000125],
              [72.32440149000007, 54.25348541300012],
              [72.33711389200005, 54.236535543000016],
              [72.3329797770001, 54.22377146500004],
              [72.29856327300007, 54.17839955700002],
              [72.3880668540001, 54.15762563100007],
              [72.48294478400004, 54.135611471000075],
              [72.48439172400003, 54.13245920900003],
              [72.4820146080001, 54.128325094],
              [72.47674361200006, 54.12367421500004],
              [72.46671838400005, 54.10992828400002],
              [72.45421268700005, 54.10713775700005],
              [72.43974328600012, 54.10889475500004],
              [72.42320682800005, 54.10868805000008],
              [72.41927941900008, 54.10532908200007],
              [72.41194136600006, 54.09277170900005],
              [72.40791060400005, 54.08956777000007],
              [72.39850549300013, 54.089671123000116],
              [72.3682231040001, 54.096337382000016],
              [72.35840458200005, 54.092978414000115],
              [72.35685428800008, 54.08176462800007],
              [72.35995487500014, 54.068638815],
              [72.36357222500004, 54.05954376300012],
              [72.38186568200013, 54.04300730400003],
              [72.40512007600012, 54.030656637000064],
              [72.4186593020001, 54.016032207000094],
              [72.40780725100007, 53.992519430000115],
              [72.40780725100007, 53.99231272400006],
              [72.38310591600003, 53.95644928100002],
              [72.37277063000005, 53.93624379500004],
              [72.37297733600008, 53.92006907100004],
              [72.3922009690001, 53.90823516900009],
              [72.42341353400008, 53.903480937000026],
              [72.45555627400012, 53.90534128900002],
              [72.47674361200006, 53.913402812000115],
              [72.5180847580001, 53.94322011400003],
              [72.54392297400005, 53.97076365200009],
              [72.55684208200006, 53.97722320600006],
              [72.57213830600011, 53.97644806000004],
              [72.67373417100009, 53.95050649000008],
              [72.70019250500008, 53.957637838000025],
              [72.69481815600005, 53.99257110600003],
              [72.67559452300003, 54.02166493800003],
              [72.65616418500014, 54.042542216000086],
              [72.63177290800007, 54.053911031],
              [72.59714969900011, 54.05458282500008],
              [72.50940311700003, 54.04357574500007],
              [72.50309859300006, 54.050862122000055],
              [72.50878299900006, 54.068742167000025],
              [72.51922163900014, 54.08822418300012],
              [72.52738651600004, 54.10005808500004],
              [72.57306848200005, 54.12868682900002],
              [72.62422814900003, 54.13499135400012],
              [72.75734664000004, 54.125999655000086],
              [72.88550419100005, 54.11731801400002],
              [72.9420382080001, 54.121762187000044],
              [72.95681766800004, 54.11752472000008],
              [72.96839318900004, 54.104140524000044],
              [72.97356083200009, 54.086518860000055],
              [72.97676477100003, 54.04770985900011],
              [73.02368697100007, 54.03396392900008],
              [73.03526249200013, 54.02057973200003],
              [73.04435754400009, 53.99231272400006],
              [73.0627543540001, 53.97908355700007],
              [73.19070520000008, 53.96161692300002],
              [73.36030725100005, 53.938414205000115],
              [73.37394982900014, 53.940946351],
              [73.3793241780001, 53.9486978150001],
              [73.38128788300014, 53.960221660000045],
              [73.38428511500007, 53.97029856400006],
              [73.3927600510001, 53.97401926700009],
              [73.42407596800007, 53.97262400400011],
              [73.43348107900005, 53.97066029900007],
              [73.44598677600004, 53.963890687000045],
              [73.4690344650001, 53.94730255200004],
              [73.48164351400004, 53.945390523000114],
              [73.50593143700013, 53.949731344000085],
              [73.51802372200012, 53.956035868000086],
              [73.52153772000014, 53.96874827100005],
              [73.51988407400012, 53.99231272400006],
              [73.51988407400012, 53.99241607700007],
              [73.52825565600006, 54.01070953400004],
              [73.58685673000008, 54.01944285100002],
              [73.60442671700008, 54.03468739800006],
              [73.60091272000011, 54.046934713],
              [73.59192102100008, 54.05773508800003],
              [73.58851037600004, 54.06615834600002],
              [73.6015328370001, 54.07122263600009],
              [73.65434615000004, 54.07850901300007],
              [73.67046919800003, 54.07592519200007],
              [73.67170943200006, 54.072359518],
              [73.67491337100012, 54.05158559200005],
              [73.68493859900008, 54.048433330000094],
              [73.74064579300011, 54.0579417930001],
              [73.69713423700006, 53.90084543900009],
              [73.68287154100011, 53.874128724000045],
              [73.66168420500014, 53.86084788000004],
              [73.6342956950001, 53.85743723500009],
              [73.48526086400011, 53.87485219300005],
              [73.45590865100013, 53.87366363600002],
              [73.43182743300008, 53.86544708300009],
              [73.41095015500008, 53.85025421200005],
              [73.39120975700007, 53.82824005200008],
              [73.43782190000013, 53.808499654000016],
              [73.34738814300005, 53.787622376000044],
              [73.33116174300005, 53.77516835500005],
              [73.30656376200005, 53.685664775000035],
              [73.26377567600014, 53.68101389600007],
              [73.24475874900014, 53.67481272400009],
              [73.22966923000007, 53.6624103810001],
              [73.22036747300012, 53.64308339500006],
              [73.22491499800009, 53.62985422800007],
              [73.25881473800007, 53.606289775000064],
              [73.23059940600012, 53.57233835900006],
              [73.39120975700007, 53.52024851500009],
              [73.34718143800006, 53.45937367800006],
              [73.41095015500008, 53.43002146500008],
              [73.42407596800007, 53.43255360900007],
              [73.45069726800006, 53.44855956200003],
              [73.52360477700012, 53.492394918000016],
              [73.52370813000005, 53.492394918000016],
              [73.52370813000005, 53.49249827100006],
              [73.54654911300014, 53.50691599500006],
              [73.5552307530001, 53.5147708140001],
              [73.56349898300004, 53.5254678350001],
              [73.57259403500012, 53.54319285100003],
              [73.57600467900005, 53.55316640200003],
              [73.58251591000004, 53.55864410500003],
              [73.60039595600006, 53.56288157200008],
              [73.60794071500004, 53.56334666000002],
              [73.63191857900006, 53.560866191000045],
              [73.64070357300005, 53.563243307000064],
              [73.6431840410001, 53.570219625000064],
              [73.64411421700004, 53.5791596480001],
              [73.65103885900004, 53.59476593000004],
              [73.65124556500012, 53.60277577700002],
              [73.65289921100003, 53.60918365600007],
              [73.65982385300003, 53.6115607710001],
              [73.73651167900005, 53.60975209600009],
              [73.7532548420001, 53.60701324500006],
              [73.78777469900007, 53.59507598900002],
              [73.80327762900004, 53.59838328100004],
              [73.87273075400009, 53.632127991000075],
              [73.90415002500004, 53.6391559850001],
              [73.93670617700008, 53.639517721000104],
              [73.97670373600005, 53.63517690100012],
              [74.04357303900008, 53.629957581],
              [74.05804244000012, 53.624583232000035],
              [74.06300337700009, 53.60871856800013],
              [74.06145308400005, 53.589494935000104],
              [74.06279667200005, 53.573216858000094],
              [74.07685266100003, 53.56618886400007],
              [74.10765181500011, 53.56510365900009],
              [74.11871057200011, 53.569547831000094],
              [74.13721073400006, 53.593939107000026],
              [74.14795943200005, 53.59802154500004],
              [74.21389856000008, 53.59703969400006],
              [74.22330367000012, 53.5946109020001],
              [74.23529260200007, 53.58189849900005],
              [74.24159712700009, 53.56779083300002],
              [74.25048547400013, 53.55678375300003],
              [74.27032922400008, 53.55321807900005],
              [74.26309452300006, 53.53022206600009],
              [74.26960575400011, 53.51523590200013],
              [74.30598596200008, 53.49260162400007],
              [74.30608931500012, 53.492394918000016],
              [74.30619266800005, 53.492394918000016],
              [74.35890262900006, 53.466143291],
              [74.38835819500008, 53.462215882000024],
              [74.40913212100014, 53.477563782000104],
              [74.45688114400008, 53.56975453700004],
              [74.45543420400008, 53.577402650000025],
              [74.44458215400005, 53.58582590800002],
              [74.42659875500004, 53.59636790000006],
              [74.42081099500007, 53.603085837],
              [74.42969934100012, 53.65357371100002],
              [74.43848433500011, 53.67341746000001],
              [74.4534705000001, 53.684992981000065],
              [74.61645796700003, 53.6807038380001],
              [74.62679325400006, 53.687318420000096],
              [74.64446659400005, 53.734602356000025],
              [74.65449182200007, 53.748399964000086],
              [74.66296675600012, 53.754962871000075],
              [74.67464563000004, 53.75708160400005],
              [74.72528853400013, 53.7591486620001],
              [74.73490035000003, 53.765194804000046],
              [74.74337528500013, 53.77945749900003],
              [74.75433068900008, 53.808499654000016],
              [74.76218550600004, 53.82255564400005],
              [74.77200402800014, 53.830875549],
              [74.80621382700014, 53.83769683900006],
              [74.8884827070001, 53.83635325200008],
              [74.92393273900012, 53.830978903000116],
              [75.0008272710001, 53.806484273000066],
              [75.02790572200007, 53.80793121300006],
              [75.15771691900011, 53.865085348],
              [75.27750289000005, 53.91769195600007],
              [75.43397912600005, 53.98652496400008],
              [75.36070194600006, 54.05954376300012],
              [75.42922489400007, 54.09008453400013],
              [75.46436486900012, 54.10057485000006],
              [75.4998149010001, 54.10233184800005],
              [75.60316776600007, 54.09452870700004],
              [75.64037479600006, 54.098869528000094],
              [75.69123357400014, 54.113138241000044],
              [75.7519958900001, 54.13018544600003],
              [75.86527063000005, 54.16206980500009],
              [76.04190067500008, 54.211730855000084],
              [76.18380415900003, 54.2515733850001],
              [76.17191857900008, 54.27467275100007],
              [76.1697481700001, 54.2913642380001],
              [76.17708622300006, 54.30676381500008],
              [76.1939327400001, 54.32562571300012],
              [76.21481001800004, 54.342213847000025],
              [76.23424035700003, 54.347433167000034],
              [76.43309126800006, 54.31658233700007],
              [76.47649947100012, 54.32314524400006],
              [76.5400614830001, 54.351102193000045],
              [76.56186893800003, 54.356269837000056],
              [76.5771651610001, 54.35678660100008],
              [76.60775760900003, 54.35456451500009],
              [76.62305383300009, 54.35590810200004],
              [76.64093387800011, 54.36650177000003],
              [76.64527469900008, 54.38381337500003],
              [76.64568811000004, 54.403708802000025],
              [76.65178592900008, 54.422312317],
              [76.67276656100006, 54.43647166000004],
              [76.70129195100003, 54.44024403900006],
              [76.75720585200008, 54.43709177700002],
              [76.78211389100005, 54.43946889300004],
              [76.85239384000005, 54.46117299500004],
              [76.87234094200011, 54.46468699200001],
              [76.8959053960001, 54.463860169000085],
              [76.91047815000007, 54.45461008800005],
              [76.90355350800007, 54.432595927000094],
              [76.88567346200011, 54.42277740500002],
              [76.80474816900005, 54.41011667900007],
              [76.78676477000005, 54.402830302],
              [76.76464725800014, 54.39053131200005],
              [76.75296838400004, 54.376682027000086],
              [76.76609419800013, 54.36458974200009],
              [76.81580692500012, 54.355598044000075],
              [76.83420373600012, 54.345676168000054],
              [76.8431954350001, 54.32231842100002],
              [76.8377177320001, 54.29689361600002],
              [76.82087121600011, 54.277618306000065],
              [76.80009729000005, 54.260668437000064],
              [76.78232059800013, 54.24237498000009],
              [76.77022831300013, 54.21312611900005],
              [76.76247684700013, 54.20263580400011],
              [76.75121138500009, 54.19400583900007],
              [76.72619999200009, 54.18020823200003],
              [76.71627811700012, 54.170854798000065],
              [76.66460168500004, 54.13406117800007],
              [76.60383020100005, 54.13535308900002],
              [76.47649947100012, 54.16403350800003],
              [76.41262740100007, 54.16568715500007],
              [76.39361047400013, 54.161759745],
              [76.37666060400011, 54.15426666300006],
              [76.3743868410001, 54.147755432000096],
              [76.47649947100012, 54.04202545200006],
              [76.48259729000011, 54.03013987300004],
              [76.49520633900005, 53.99231272400006],
              [76.5256954350001, 53.961306865000026],
              [76.61096154800009, 53.920637512000084],
              [76.73384810400006, 53.86203643900005],
              [76.91926314300014, 53.77361806300003],
              [77.10467818200004, 53.685148011000095],
              [77.29009322200011, 53.596729635000074],
              [77.47550826000008, 53.508259583000026],
              [77.61276086400005, 53.442785544000046],
              [77.73389042200006, 53.361498515000065],
              [77.78465673900013, 53.3274404750001],
              [77.8668022060001, 53.27233083200004],
              [77.97635624200007, 53.16851287900003],
              [78.04384566300007, 53.096915182000075],
              [78.1519527590001, 52.9821676640001],
              [78.26005985500007, 52.8673943080001],
              [78.36827030500007, 52.75264679000013],
              [78.47648075400014, 52.63792511100006],
              [78.6179708250001, 52.47661712700004],
              [78.75956425000004, 52.315257467],
              [78.90126102700009, 52.15392364500006],
              [79.0427510990001, 51.992512309000105],
              [79.04285445100004, 51.992512309000105],
              [79.04295780400008, 51.992512309000105],
              [79.14972131400009, 51.867584534000045],
              [79.25638147000006, 51.742553406000084],
              [79.30432255000011, 51.68637826000004],
              [79.36304162600004, 51.617573955000026],
              [79.46980513500006, 51.49259450400005],
              [79.55920536300005, 51.37249847500003],
              [79.6485022380001, 51.25242828400012],
              [79.73800581900014, 51.1324356090001],
              [79.82730269400008, 51.0123912560001],
              [79.87360477700014, 50.95017283200009],
              [79.92693485500007, 50.87849762000012],
              [79.95525354000006, 50.82599436400004],
              [79.9665190020001, 50.810181376000045],
              [79.9900834560001, 50.78811554000005],
              [80.02129602100007, 50.766876526],
              [80.05498905500014, 50.75287221300009],
              [80.08599491400008, 50.75214874300009],
              [80.03111454300006, 50.80878611300007],
              [80.01540490800011, 50.83948191300003],
              [80.0493046470001, 50.852349345],
              [80.06697798700009, 50.84661326100006],
              [80.1016011960001, 50.82155019200003],
              [80.1191711840001, 50.814935608000056],
              [80.14273563600005, 50.81710601800005],
              [80.15451786300008, 50.82723460000007],
              [80.16816044100011, 50.85984242800005],
              [80.18128625500003, 50.87565541600004],
              [80.19544559700012, 50.882321676000046],
              [80.2348230390001, 50.8932254030001],
              [80.24371138500004, 50.898651429],
              [80.25818078600014, 50.91131215500003],
              [80.26727583900004, 50.915652975000015],
              [80.27957482900007, 50.917151591],
              [80.32039921100005, 50.91410268200009],
              [80.36019006400005, 50.919218649000086],
              [80.40287479700004, 50.93373972600001],
              [80.43904829900009, 50.95813100300005],
              [80.45940881400003, 50.99265085900002],
              [80.46312951700014, 51.00784373000006],
              [80.46498986900014, 51.02577545200002],
              [80.46447310400009, 51.04370717400009],
              [80.46106245900006, 51.05895172200003],
              [80.45165734900013, 51.0734986370001],
              [80.42406213400011, 51.09210215200004],
              [80.41052290800013, 51.10484039400011],
              [80.40711226500014, 51.11721689900007],
              [80.40762902800003, 51.135742900000096],
              [80.41341678900005, 51.16842824300009],
              [80.42199507700008, 51.18757436200009],
              [80.43439742000004, 51.200622660000036],
              [80.45207076000014, 51.207934876000124],
              [80.47615197800008, 51.20964019800009],
              [80.56131473900012, 51.20209543900005],
              [80.59924523900014, 51.20855499300008],
              [80.6124744060001, 51.233876445000064],
              [80.61412805200007, 51.24966359500006],
              [80.62146610500014, 51.26454640700011],
              [80.63242150900004, 51.27795644100006],
              [80.64503055900008, 51.28924774200003],
              [80.66456425000007, 51.300151469000085],
              [80.68275435400011, 51.30201182000009],
              [80.81659631300005, 51.261006572000056],
              [80.84253788300003, 51.257518413000085],
              [80.8545268150001, 51.26462392200004],
              [80.86408695500006, 51.27583770800008],
              [80.88248376500007, 51.28485524500012],
              [80.90573816000011, 51.28356333500007],
              [80.9142130950001, 51.270179138000046],
              [80.91628015100008, 51.235375061000084],
              [80.92423832200012, 51.216073914000035],
              [80.93607222500003, 51.20568695100012],
              [80.97601810700007, 51.191088359000034],
              [81.02211348500003, 51.17739410400013],
              [81.04485111500009, 51.17351837200006],
              [81.07012089000006, 51.17199391700005],
              [81.09833622300005, 51.19090749100009],
              [81.11285730000009, 51.19594594400006],
              [81.13275272600009, 51.194473165000076],
              [81.1520280360001, 51.186540833000024],
              [81.15864261900003, 51.174267681000075],
              [81.15595544400009, 51.1574211640001],
              [81.14717045100008, 51.13594960600007],
              [81.08050785400007, 51.03086558000011],
              [81.05404952000009, 50.96986155200004],
              [81.05151737500012, 50.9557022100001],
              [81.05828698700003, 50.94707224500006],
              [81.07792403100007, 50.9406643680001],
              [81.10438236500005, 50.93668528200003],
              [81.15884932500006, 50.938235576000054],
              [81.27744673600012, 50.96267852800007],
              [81.40079838100013, 50.95911285400011],
              [81.40121179300013, 50.922991028000084],
              [81.41609460500007, 50.88965972900006],
              [81.43950402900003, 50.859687398000105],
              [81.46611739100007, 50.83374583000004],
              [81.44472334900013, 50.81338531500002],
              [81.4261198320001, 50.788167216000076],
              [81.41878177900008, 50.76248402900008],
              [81.43108077000005, 50.74072825200007],
              [81.46022627700006, 50.730341289000066],
              [81.67411503100004, 50.736025696000084],
              [81.69721439600005, 50.74501739600005],
              [81.72573978700007, 50.77462799100009],
              [81.74413659700008, 50.784911601],
              [81.76346358300003, 50.784343160000034],
              [81.8008773200001, 50.76785837900006],
              [81.82242639100008, 50.76573964500007],
              [81.89503177900008, 50.77421458000008],
              [81.94536462400009, 50.7692019660001],
              [81.99032312000008, 50.75964182500012],
              [82.01254398700013, 50.750133363000046],
              [82.07310876500009, 50.71566518100006],
              [82.09553633600007, 50.708120423000125],
              [82.14731612100013, 50.70160919200005],
              [82.17367110200007, 50.70305613200004],
              [82.19878584800011, 50.708792216000106],
              [82.21661421700009, 50.71943756100008],
              [82.23630293800011, 50.734475403],
              [82.25573327600011, 50.74522410100009],
              [82.27314823400013, 50.743053691000014],
              [82.28839278200007, 50.73742096000008],
              [82.30115686000005, 50.74093495700005],
              [82.31366255700004, 50.747756247],
              [82.32839034000006, 50.752097066000076],
              [82.34120609500013, 50.75028839100007],
              [82.35133467600008, 50.74553415900009],
              [82.36249678600012, 50.742123515000046],
              [82.40828210500007, 50.74837636300005],
              [82.43029626500004, 50.74114166300008],
              [82.47582320100008, 50.71401153600003],
              [82.6042391360001, 50.769046936000066],
              [82.6727620850001, 50.7897691860001],
              [82.69803186100006, 50.81095652300006],
              [82.69999556500011, 50.880978089000095],
              [82.7264538980001, 50.90071848500004],
              [82.76453942900014, 50.906661276000065],
              [82.84412113400009, 50.891726787000025],
              [82.9758960370001, 50.881908265000035],
              [83.02147465000007, 50.891778464000126],
              [83.05785485800004, 50.917151591],
              [83.08607019100003, 50.952549948000026],
              [83.10756758700006, 50.99265085900002],
              [83.11738610900011, 50.99456288700004],
              [83.12741133600014, 50.995234680000024],
              [83.13753991700008, 50.99466623900007],
              [83.1632747810001, 50.988465068],
              [83.17960453300003, 50.98727651000006],
              [83.19593428600007, 50.98877512600008],
              [83.21205733200003, 50.99265085900002],
              [83.32378177900011, 51.00241770500007],
              [83.43395593300005, 50.99265085900002],
              [83.46201623500014, 50.964332174000035],
              [83.47700240100005, 50.953376771000066],
              [83.49834476800004, 50.9454186],
              [83.60975915500012, 50.93203440300006],
              [83.63265181500003, 50.92479970300009],
              [83.69058109500014, 50.89183013900005],
              [83.71280196200007, 50.88221832300012],
              [83.73264571100009, 50.87963450200003],
              [83.77817264800007, 50.87942779600006],
              [83.80044519000012, 50.87565541600004],
              [83.82049564600004, 50.86800730400007],
              [83.83827233900007, 50.85627675400006],
              [83.86969161000013, 50.821395162],
              [83.88281742400011, 50.81199005100005],
              [83.92198815900014, 50.80072458900007],
              [83.9505652260001, 50.78041575200005],
              [83.94973840400007, 50.71788726900006],
              [83.97583500200005, 50.6863646450001],
              [84.0885972750001, 50.634612502000024],
              [84.10171879100005, 50.62859039400011],
              [84.13303470900007, 50.600788473000065],
              [84.14233646700012, 50.581513163000025],
              [84.14502364100014, 50.5660619100001],
              [84.15122481300011, 50.552574361000055],
              [84.18595137600005, 50.527976380000084],
              [84.19561486800006, 50.511439921],
              [84.19794030800011, 50.493146464000105],
              [84.17675297000005, 50.43914459300005],
              [84.19184248900007, 50.40772532200002],
              [84.21840417500005, 50.37770131400005],
              [84.23938480600009, 50.34462839800007],
              [84.24186527500007, 50.321890768000074],
              [84.23948815900008, 50.299308167000035],
              [84.23964318900005, 50.2782241820001],
              [84.24997847600014, 50.259930725000046],
              [84.26181237800006, 50.25362620100013],
              [84.29157800400003, 50.248045146000024],
              [84.30439375800012, 50.243239238000015],
              [84.31214522400006, 50.23636627200004],
              [84.32434086100005, 50.219623109000096],
              [84.33136885600004, 50.21347361300012],
              [84.36878259300005, 50.21181996700007],
              [84.40526615400006, 50.230836894000035],
              [84.44076786300008, 50.24463450100008],
              [84.4757528080001, 50.227064515],
              [84.50458825700014, 50.2045852670001],
              [84.53569746900007, 50.190942688000106],
              [84.5692871500001, 50.18551666300003],
              [84.60597741700008, 50.18742869100005],
              [84.64199589100008, 50.18489654600005],
              [84.66669722500006, 50.17001373300012],
              [84.68938317800013, 50.151048482000064],
              [84.72028568500014, 50.13663075800004],
              [84.73811405400005, 50.1353905240001],
              [84.77320235200011, 50.13833608100002],
              [84.79066898600007, 50.132755026],
              [84.8015210370001, 50.12376332700005],
              [84.82611901900009, 50.08671132400006],
              [84.83867639200008, 50.08082021100007],
              [84.85588464400007, 50.08485097300006],
              [84.87376468900004, 50.09244740900003],
              [84.8879757090001, 50.0967365530001],
              [84.91024825100004, 50.09508290600006],
              [84.97577396700007, 50.075187480000054],
              [84.98672937000003, 50.066970927000014],
              [85.02011234600008, 50.03307118800011],
              [85.02832889800004, 50.020513815000086],
              [85.02543501800005, 50.004080709000036],
              [85.00936364800009, 49.99782786100003],
              [84.96471521000007, 49.992763570000065],
              [84.96461185800013, 49.992763570000065],
              [84.96218306500003, 49.99188507100011],
              [84.95479333600014, 49.99048980800005],
              [84.95065922000003, 49.93328399700009],
              [84.95458662900012, 49.906929017000024],
              [84.97577396700007, 49.89400990800003],
              [85.03261804200008, 49.88496653300005],
              [85.05628584800013, 49.873339336000086],
              [85.07075524900006, 49.85023997000003],
              [85.07592289200005, 49.81391143900005],
              [85.08171065300013, 49.80001047800009],
              [85.0981437580001, 49.78218210900003],
              [85.16325606300006, 49.73396799800004],
              [85.18511519400005, 49.70502919600007],
              [85.19503706900014, 49.625654195000024],
              [85.2236141360001, 49.59573354100009],
              [85.26309493000014, 49.581522522000014],
              [85.3027824300001, 49.590100811000056],
              [85.3203524170001, 49.599454245000075],
              [85.3420565190001, 49.608187562000055],
              [85.3642257090001, 49.61413035100007],
              [85.38401778200006, 49.61568064400008],
              [85.4072721760001, 49.60963450200005],
              [85.45099043800008, 49.5884471640001],
              [85.47569177300011, 49.58307281600004],
              [85.5132088630001, 49.585346579000046],
              [85.5312956140001, 49.58911895800007],
              [85.5492790130001, 49.59526845300006],
              [85.58080163600005, 49.613355205000076],
              [85.59718306500008, 49.619297994000064],
              [85.61485640400008, 49.61712758400007],
              [85.62844730600011, 49.6064822390001],
              [85.64229659100005, 49.57749176100002],
              [85.65619755100005, 49.564934387],
              [85.67330244900006, 49.56043853800007],
              [85.69004561400004, 49.56291900700005],
              [85.72575402800004, 49.57304758700012],
              [85.7474064540001, 49.57299591100009],
              [85.76471805900013, 49.56684641500003],
              [85.77954919500013, 49.5560460410001],
              [85.79443200700007, 49.54183502300005],
              [85.80921146700013, 49.53651235000008],
              [85.82750492300005, 49.54100820000009],
              [85.8607845460001, 49.557492981000095],
              [85.88073164900004, 49.56328074200006],
              [85.89985192900014, 49.564055888000055],
              [85.94057295700009, 49.55961171500006],
              [85.94212325000012, 49.55108510400005],
              [85.93189131700012, 49.51005401700009],
              [85.93142622900012, 49.492845765000126],
              [85.94625736500012, 49.4813735960001],
              [85.96300052900011, 49.47858306900004],
              [85.98005375200012, 49.48287221300011],
              [85.99581506300012, 49.492794088000025],
              [85.99597009300004, 49.492794088000025],
              [86.02754439300003, 49.51563507100012],
              [86.0704875080001, 49.52628041600009],
              [86.11151859600005, 49.520182597000044],
              [86.1366850180001, 49.493000794000054],
              [86.17725101700012, 49.463338522000086],
              [86.21425134300006, 49.496153057000114],
              [86.24639408400009, 49.55005157500007],
              [86.27212894700006, 49.58364125600009],
              [86.32948978700006, 49.61025461800001],
              [86.39181156400008, 49.624982402000015],
              [86.45826745600004, 49.66565175400008],
              [86.47547570800003, 49.67081939700007],
              [86.48178023300005, 49.676917217000025],
              [86.48296879100008, 49.68627065100007],
              [86.47966149900009, 49.69727773000007],
              [86.47273685700009, 49.70833648800006],
              [86.51971073400006, 49.726836650000095],
              [86.52441328900005, 49.729523824000026],
              [86.53743575000004, 49.73944569900003],
              [86.54560062700006, 49.742649638],
              [86.5522152100001, 49.74233958000009],
              [86.5582096760001, 49.74146108100008],
              [86.5651343180001, 49.74270131500002],
              [86.58492639200006, 49.76006459600002],
              [86.59536503100003, 49.78089019800008],
              [86.61019616700014, 49.79551462800005],
              [86.6424422610001, 49.793860983000016],
              [86.68492028800006, 49.778203024000064],
              [86.70021651200011, 49.77773793600004],
              [86.7308089600001, 49.78254384400013],
              [86.7483789470001, 49.782957255000056],
              [86.75892094000005, 49.778616435000075],
              [86.75959273300003, 49.76771270800002],
              [86.7525647380001, 49.756033834000036],
              [86.74341801000003, 49.744716696000054],
              [86.73763024900006, 49.73500152600012],
              [86.74052413000004, 49.722754212],
              [86.75147953300012, 49.71169545500008],
              [86.77587080900014, 49.69500396800005],
              [86.75561364800006, 49.68151641900009],
              [86.73649336800014, 49.67190460300007],
              [86.71613285300003, 49.66678863500009],
              [86.66771203700006, 49.6642564910001],
              [86.64709314000004, 49.653662822000015],
              [86.61112634300008, 49.62022817000003],
              [86.59598514800007, 49.601883036000046],
              [86.59179935700013, 49.58720693000005],
              [86.59934411600011, 49.57351267500003],
              [86.61856774900008, 49.557958069],
              [86.64254561400003, 49.54746775400007],
              [86.66414636200011, 49.54741607700005],
              [86.70951827000005, 49.55449574900008],
              [86.73256595900006, 49.55067169200002],
              [86.80243249500006, 49.52224965500001],
              [86.82434330300003, 49.509227194000076],
              [86.82289636300004, 49.492794088000025],
              [86.81426639800009, 49.47295033800002],
              [86.81400801600012, 49.45000600200008],
              [86.82899418200009, 49.43331451500005],
              [86.8544189860001, 49.42127390600008],
              [86.90547530100008, 49.404685771000075],
              [86.93307051600004, 49.39011301700002],
              [86.93079675300004, 49.38055287700011],
              [86.91565555800014, 49.369959209000044],
              [86.90506189000007, 49.35192413400004],
              [86.91302006100011, 49.33869496700005],
              [86.93332889800013, 49.324277242000036],
              [87.0001465250001, 49.28908559200006],
              [87.01254886900006, 49.28071401000007],
              [87.01688969000003, 49.272755840000016],
              [87.01714807100012, 49.25864817400007],
              [87.02453780100012, 49.24893300400005],
              [87.03663008600012, 49.242731832000075],
              [87.05037601700013, 49.23890777600012],
              [87.0760075280001, 49.23689239500008],
              [87.16044681800014, 49.24200836200008],
              [87.19031579700004, 49.237822571000024],
              [87.21796268700007, 49.22981272400004],
              [87.27175785300011, 49.20511138900004],
              [87.28767419400003, 49.18433746400008],
              [87.30818973800007, 49.113850810000045],
              [87.32379602100013, 49.08527374300009],
            ],
            [
              [63.3839136150001, 45.56582448300013],
              [63.4435482180001, 45.567969055],
              [63.50147749800004, 45.57422190400011],
              [63.55739139800005, 45.58437632300006],
              [63.610928182000066, 45.59825144500003],
              [63.66188114500011, 45.61561472600006],
              [63.70994022600007, 45.63628529900008],
              [63.75489872300011, 45.66000478100001],
              [63.79634322100014, 45.68664398300005],
              [63.833963664000066, 45.71594451900002],
              [63.86755334500003, 45.747699687000036],
              [63.89669885200004, 45.78170278000009],
              [63.92129683500008, 45.81777293000009],
              [63.940933879000056, 45.85570343000008],
              [63.955299927000056, 45.89518422500002],
              [63.96408492000012, 45.93616363500006],
              [63.96713383000008, 45.978331604000104],
              [63.96408492000012, 46.020499573000066],
              [63.955299927000056, 46.06142730700007],
              [63.940933879000056, 46.100985616000045],
              [63.92129683500008, 46.13889028000004],
              [63.89669885200004, 46.17496042900002],
              [63.86755334500003, 46.208963522000076],
              [63.833963664000066, 46.240718689000104],
              [63.79634322100014, 46.27001922700005],
              [63.75489872300011, 46.29665842700008],
              [63.70994022600007, 46.320377909000044],
              [63.66188114500011, 46.34104848300005],
              [63.610928182000066, 46.35841176400008],
              [63.55739139800005, 46.37226104700004],
              [63.50147749900003, 46.382441305],
              [63.4435482180001, 46.38869415300009],
              [63.3839136150001, 46.390838725],
              [63.32427901200009, 46.38869415300009],
              [63.26634973200004, 46.382441305],
              [63.210487508000085, 46.37226104700004],
              [63.15689904800013, 46.35841176400008],
              [63.105946086000074, 46.34104848300005],
              [63.05783532700008, 46.320377909000044],
              [63.01292850700008, 46.29665842700008],
              [62.97148400900005, 46.27001922700005],
              [62.93386356600013, 46.240718689000104],
              [62.900273885000104, 46.208963522000076],
              [62.87102502500005, 46.17496042900002],
              [62.84647871900006, 46.13889028000004],
              [62.82689335100014, 46.100985616000045],
              [62.81252730300014, 46.06142730700007],
              [62.80363895700003, 46.020499573000066],
              [62.800641723000126, 45.978331604000104],
              [62.80363895700003, 45.93616363500006],
              [62.81252730300014, 45.89518422500002],
              [62.82689335100014, 45.85570343000008],
              [62.84647871900006, 45.81777293000009],
              [62.87102502500005, 45.78170278000009],
              [62.900273885000104, 45.747699687000036],
              [62.93386356600013, 45.71594451900002],
              [62.97148400900005, 45.68664398300005],
              [63.01292850700008, 45.66000478100001],
              [63.05783532700008, 45.63628529900008],
              [63.105946086000074, 45.61561472600006],
              [63.15689904800013, 45.59825144500003],
              [63.210487508000085, 45.58437632300006],
              [63.26634973200004, 45.57422190400011],
              [63.32427901200009, 45.567969055],
              [63.3839136150001, 45.56582448300013],
            ],
          ],
          [
            [
              [50.26026451900003, 45.00991445500006],
              [50.26775149800005, 45.03388092700004],
              [50.27173912900008, 45.056341864000046],
              [50.27711022200003, 45.071519273000035],
              [50.28891035200007, 45.07835521000004],
              [50.30062910200007, 45.080064195000034],
              [50.30591881600009, 45.07990143400008],
              [50.310883009000065, 45.08055247600004],
              [50.32976321700005, 45.07990143400008],
              [50.33814537900008, 45.08242422100005],
              [50.34392337300005, 45.086004950000074],
              [50.348399285000085, 45.08490631700005],
              [50.35368899800005, 45.07306549700007],
              [50.344411655000044, 45.05231354400007],
              [50.33773847700007, 45.04291413000004],
              [50.32976321700005, 45.03896719000005],
              [50.32634524800005, 45.03310781500005],
              [50.33318118600005, 44.994574286000045],
              [50.324554884000065, 44.97321198100008],
              [50.30445397200003, 44.959418036000045],
              [50.28150475400008, 44.955511786000045],
              [50.264414910000085, 44.96381256700005],
              [50.256602410000085, 44.985988674000055],
              [50.26026451900003, 45.00991445500006],
            ],
          ],
          [
            [
              [50.170258009000065, 44.830145575000074],
              [50.14307701900003, 44.81785716400009],
              [50.11150149800005, 44.820379950000074],
              [50.07935631600009, 44.83348216400009],
              [50.06397545700008, 44.84414297100005],
              [50.059336785000085, 44.85309479400007],
              [50.05795332100007, 44.86432526200008],
              [50.05201256600009, 44.881293036000045],
              [50.04184004000007, 44.89492422100005],
              [50.00416100400008, 44.922308661000045],
              [49.98609459700003, 44.94676341400009],
              [49.98617597700007, 44.968003648000035],
              [50.04184004000007, 45.057521877000056],
              [50.05201256600009, 45.065619208000044],
              [50.06763756600009, 45.071478583000044],
              [50.11345462300005, 45.07990143400008],
              [50.11215254000007, 45.062486070000034],
              [50.05355879000007, 45.038763739000046],
              [50.03842207100007, 45.01471588700008],
              [50.035166863000086, 45.000881252000056],
              [50.02100670700008, 44.975775458000044],
              [50.01783287900008, 44.960150458000044],
              [50.02116946700005, 44.94403717700004],
              [50.029958530000044, 44.930853583000044],
              [50.04281660200007, 44.92446523600006],
              [50.05827884200005, 44.92910390800006],
              [50.05844160200007, 44.903998114000046],
              [50.06202233200008, 44.87986888200004],
              [50.07341556100005, 44.861761786000045],
              [50.096690300000034, 44.85464101800005],
              [50.10759524800005, 44.85175202000005],
              [50.11638431100005, 44.845770575000074],
              [50.12647545700008, 44.84064362200007],
              [50.141368035000085, 44.840277411000045],
              [50.17400149800005, 44.85838450700004],
              [50.18921959700003, 44.86147695500006],
              [50.170258009000065, 44.830145575000074],
            ],
          ],
          [
            [
              [50.74366295700008, 44.88613515800006],
              [50.757823113000086, 44.87055084800005],
              [50.760752800000034, 44.864935614000046],
              [50.73951256600009, 44.868353583000044],
              [50.72632897200003, 44.86591217700004],
              [50.71273847700007, 44.85993073100008],
              [50.69776451900003, 44.857855536000045],
              [50.69361412900008, 44.86420319200005],
              [50.701914910000085, 44.87449778900009],
              [50.701914910000085, 44.880560614000046],
              [50.69190514400003, 44.88312409100007],
              [50.68873131600009, 44.88914622600004],
              [50.69320722700007, 44.89907461100006],
              [50.686534050000034, 44.91168854400007],
              [50.64079837300005, 44.933294989000046],
              [50.62623131600009, 44.95107656500005],
              [50.627940300000034, 44.96702708500004],
              [50.635752800000034, 44.96743398600006],
              [50.643321160000085, 44.95294830900008],
              [50.65951582100007, 44.93895091400009],
              [50.67798912900008, 44.935614325000074],
              [50.69263756600009, 44.940619208000044],
              [50.70199629000007, 44.94818756700005],
              [50.708018425000034, 44.954413153000075],
              [50.71371504000007, 44.95380280200004],
              [50.71656334700003, 44.94672272300005],
              [50.720713738000086, 44.94163646000004],
              [50.72803795700008, 44.940619208000044],
              [50.73462975400008, 44.92991771000004],
              [50.736989780000044, 44.90766022300005],
              [50.73682701900003, 44.89590078300006],
              [50.74366295700008, 44.88613515800006],
            ],
          ],
          [
            [
              [52.69288170700008, 45.45970286700003],
              [52.69906660200007, 45.441473700000074],
              [52.70264733200008, 45.425482489000046],
              [52.70248457100007, 45.40521881700005],
              [52.67709394600007, 45.39695872600004],
              [52.627940300000034, 45.410223700000074],
              [52.588552280000044, 45.432806708000044],
              [52.561289910000085, 45.45652903900009],
              [52.55201256600009, 45.47833893400008],
              [52.56625410200007, 45.49355703300006],
              [52.582774285000085, 45.50210195500006],
              [52.59351647200003, 45.508978583000044],
              [52.59791100400008, 45.516791083000044],
              [52.59498131600009, 45.523504950000074],
              [52.599945509000065, 45.52749258000006],
              [52.635508660000085, 45.52562083500004],
              [52.655039910000085, 45.52138906500005],
              [52.67302493600005, 45.50385163000004],
              [52.68734785200007, 45.47500234600005],
              [52.69288170700008, 45.45970286700003],
            ],
          ],
          [
            [
              [49.82243899800005, 46.31395091400009],
              [49.83838951900003, 46.28587474200003],
              [49.84131920700008, 46.26284414300005],
              [49.82154381600009, 46.21751536700003],
              [49.804698113000086, 46.21051666900007],
              [49.781911655000044, 46.22418854400007],
              [49.76693769600007, 46.24778880400004],
              [49.72095787900008, 46.33812083500004],
              [49.71998131600009, 46.356756903000075],
              [49.750010613000086, 46.357489325000074],
              [49.79216556100005, 46.339056708000044],
              [49.81169681100005, 46.32648346600007],
              [49.82243899800005, 46.31395091400009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Tajikistan',
        iso3: 'TJK',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [70.56590417500007, 41.01837595600004],
              [70.5934477130001, 41.00938425700009],
              [70.61665043200009, 40.993519592],
              [70.63049971500004, 40.97641469400004],
              [70.64341882300005, 40.9522818],
              [70.64507246900013, 40.93517690000006],
              [70.62522871900012, 40.938690898000104],
              [70.60838220200003, 40.950938212000025],
              [70.57913334200009, 40.98085886600005],
              [70.56249353100009, 40.99377797500007],
              [70.5614600020001, 40.99460479800008],
              [70.54978112800012, 41.015223694],
              [70.56590417500007, 41.01837595600004],
            ],
          ],
          [
            [
              [70.95895511900011, 40.23837188800012],
              [70.97952233900008, 40.21408396400001],
              [70.96288252800014, 40.189692688],
              [70.92929284700011, 40.17062408500003],
              [70.89854537000008, 40.162614238000046],
              [70.84516361500005, 40.171812642000035],
              [70.83183109500004, 40.16819529200005],
              [70.82490645300004, 40.16354441300008],
              [70.80671634900011, 40.15615468400007],
              [70.80604455600013, 40.157653301],
              [70.80268558800003, 40.16013376900007],
              [70.79772465000008, 40.16194244400005],
              [70.79214359500008, 40.161374004],
              [70.78873295100004, 40.15899688800006],
              [70.78253177900007, 40.15258901000003],
              [70.74346439600004, 40.12711252900009],
              [70.72982181900005, 40.120704651000054],
              [70.66594974800006, 40.10416819300006],
              [70.63943973800008, 40.08494456000004],
              [70.63473718300008, 40.05931305000006],
              [70.63597741700005, 40.028513896],
              [70.62739913000007, 39.993890686],
              [70.61396325700014, 39.97575225900006],
              [70.59659997600005, 39.96195465100003],
              [70.57660119600007, 39.95223948200008],
              [70.55505212400004, 39.94624501600005],
              [70.5125740960001, 39.94515981000005],
              [70.50089522300004, 39.9405606080001],
              [70.49417728700013, 39.93167226200008],
              [70.48596073400006, 39.90960642500009],
              [70.47722741700011, 39.90092478500013],
              [70.45562666800004, 39.90681589800003],
              [70.44803023300005, 39.919993388000094],
              [70.45087243600005, 39.937408346000055],
              [70.46022587100009, 39.95611521400012],
              [70.47319665600008, 39.97011952800004],
              [70.48849287900003, 39.978542786000034],
              [70.50502933800004, 39.98510569300002],
              [70.52094567900008, 39.993735657000045],
              [70.53562178600009, 40.01595652300007],
              [70.52549320500003, 40.033681539],
              [70.50213545800005, 40.04598053000005],
              [70.47722741700011, 40.05202667300007],
              [70.39764571100005, 40.06122507800008],
              [70.35950850500012, 40.07404083300007],
              [70.32426517700003, 40.07750315400001],
              [70.30628177900007, 40.084789531000084],
              [70.29026208500011, 40.09817372700003],
              [70.2778080650001, 40.11207468700009],
              [70.26349369300004, 40.12427032500001],
              [70.24153120900007, 40.13274526000002],
              [70.21853519700011, 40.1341405240001],
              [70.16882246900008, 40.13166005500004],
              [70.14717004400012, 40.136982727000074],
              [70.00459476700007, 40.20876129100007],
              [69.96955814600005, 40.211603495000034],
              [69.57547367300009, 40.103599752],
              [69.55883386200009, 40.1017394],
              [69.54302087400009, 40.103082987000064],
              [69.53661299600003, 40.10788889600006],
              [69.52607100400007, 40.12318511900013],
              [69.51800948100009, 40.12509714800005],
              [69.51346195500014, 40.120704651000054],
              [69.5092244870001, 40.10344472300007],
              [69.50633060700011, 40.096933493000094],
              [69.48571171000009, 40.07373077400008],
              [69.46964034100012, 40.05099314400009],
              [69.46312911000007, 40.02541331000005],
              [69.47119063300005, 39.993683981000046],
              [69.47511804200013, 39.98774119100001],
              [69.4772884520001, 39.98159169500006],
              [69.47811527600004, 39.975028788000074],
              [69.4772884520001, 39.96815582300009],
              [69.50043949400009, 39.93570302400009],
              [69.50157637500013, 39.92247385700007],
              [69.40535485800007, 39.89611887600002],
              [69.35729577600011, 39.95947418300004],
              [69.32784021000009, 39.984743958000095],
              [69.31399092600003, 39.986914368],
              [69.31032190000013, 39.984795635000026],
              [69.31006351700006, 39.97864613900005],
              [69.30567102100008, 39.96862091100003],
              [69.28644738800006, 39.93575470000009],
              [69.24071374600004, 39.82893951400008],
              [69.22955163500012, 39.79054392500005],
              [69.22629602000012, 39.751011455000096],
              [69.23332401500011, 39.73266632100011],
              [69.24836185700008, 39.719385478],
              [69.26593184500007, 39.70775828000005],
              [69.28009118600005, 39.69427073200008],
              [69.28753259300004, 39.67778595],
              [69.29114994400004, 39.658872376000076],
              [69.2861890050001, 39.53970652300008],
              [69.30034834800006, 39.51562530500006],
              [69.33972579000005, 39.528079326000025],
              [69.34592696100003, 39.535365703000096],
              [69.34840743000007, 39.54316884300003],
              [69.35202478000008, 39.54962839800008],
              [69.36163659700009, 39.55288401400007],
              [69.36721765200008, 39.54993845700007],
              [69.39145389800007, 39.53050811800007],
              [69.41217614800013, 39.525030416],
              [69.45527429200013, 39.53045644200007],
              [69.4772884520001, 39.53040476500006],
              [69.49609867300012, 39.53257517500005],
              [69.51439213100008, 39.53758778900003],
              [69.53144535400014, 39.545649313000084],
              [69.56493168200012, 39.56812856100002],
              [69.58229496300004, 39.57355458600007],
              [69.66942142700003, 39.57779205300004],
              [69.71034916200006, 39.57407135000004],
              [69.74982995600004, 39.56383941700004],
              [69.79158451400008, 39.54539093100003],
              [69.83044519100008, 39.53624420200005],
              [69.90775313300009, 39.548491516000084],
              [69.94862919100007, 39.54508087200004],
              [69.97875655100006, 39.53443552700004],
              [69.98712813400005, 39.53960317000006],
              [70.00273441600007, 39.55686309800005],
              [70.01968428600009, 39.56859364900005],
              [70.0403548590001, 39.5736062620001],
              [70.06226566600003, 39.573451234000046],
              [70.08272953300013, 39.569782206000056],
              [70.11626753700011, 39.55464101200003],
              [70.13244226100011, 39.55004181],
              [70.14897871900013, 39.55427927700005],
              [70.15735030100006, 39.563891093000066],
              [70.18520389800005, 39.61034820600007],
              [70.20065515200014, 39.61949493400006],
              [70.21026696800004, 39.60972808900003],
              [70.21481449400011, 39.591124573000045],
              [70.21502120000014, 39.57407135000004],
              [70.20437585500008, 39.53815623000007],
              [70.20602950000011, 39.52410024000004],
              [70.22328942900009, 39.519087627],
              [70.24106612100013, 39.522394918000074],
              [70.33025964300009, 39.573089498000044],
              [70.34317875200009, 39.57686187700007],
              [70.35346236200007, 39.575931702000034],
              [70.37428796400013, 39.571022441000096],
              [70.38431319200004, 39.570867411000066],
              [70.39041101100008, 39.57401967400001],
              [70.39537194800005, 39.579497376000106],
              [70.40146976700004, 39.58476837100004],
              [70.41108158400004, 39.58745554700006],
              [70.42761804200012, 39.59009104400006],
              [70.45996748900012, 39.599547832000056],
              [70.47722741700011, 39.60120147700009],
              [70.49097334900006, 39.59686065700002],
              [70.51350427200003, 39.58151275600004],
              [70.52611332200007, 39.57562164300005],
              [70.54357995600003, 39.57427805600007],
              [70.58027022300007, 39.579549053],
              [70.59784021000007, 39.57779205300004],
              [70.62212813300005, 39.56352935800005],
              [70.63597741700005, 39.54249705000005],
              [70.65559843200009, 39.49466447300007],
              [70.65592452000004, 39.49386952800005],
              [70.65597619700009, 39.493714498000074],
              [70.66672489500007, 39.48689320900003],
              [70.69013431800005, 39.479193420000044],
              [70.69974613500005, 39.472165426000046],
              [70.7054305420001, 39.45852284800013],
              [70.70305342600005, 39.44472524000007],
              [70.69860925300003, 39.43139272100005],
              [70.6980924880001, 39.41899037700007],
              [70.71328536000004, 39.398423157000096],
              [70.73974369300004, 39.38622751900009],
              [70.77012943500006, 39.38209340400006],
              [70.79762129700003, 39.38534902000005],
              [70.82805871600004, 39.39857818700004],
              [70.8400993250001, 39.40142039000001],
              [70.85529219600011, 39.401730449000084],
              [70.86418054200004, 39.40059356700009],
              [70.87224206600013, 39.40297068300005],
              [70.88448938000005, 39.413874410000105],
              [70.90335127800006, 39.420850729000094],
              [70.9251587330001, 39.41294423400005],
              [70.94980839100009, 39.40074859600013],
              [70.97714522300004, 39.39490916000004],
              [71.00928796400007, 39.4076215620001],
              [71.02758142100004, 39.435216776000104],
              [71.04230920400005, 39.46787628200006],
              [71.06292810100013, 39.495626526000095],
              [71.09589766400012, 39.51236969000006],
              [71.13744551600007, 39.52115468400005],
              [71.17997521900014, 39.52301503600005],
              [71.23692264900012, 39.51448842400005],
              [71.2492733150001, 39.514385071],
              [71.26007369000013, 39.52063792000011],
              [71.29195804900007, 39.54895660400008],
              [71.30591068500007, 39.55717315700004],
              [71.34058557200007, 39.57169423400008],
              [71.34787194800003, 39.57624176100002],
              [71.3616178800001, 39.587558899000086],
              [71.36854252100005, 39.59148630800006],
              [71.37830936700004, 39.59417348200007],
              [71.40673140400014, 39.59815256800006],
              [71.44125126100005, 39.610658264000065],
              [71.45954471800007, 39.61210520500005],
              [71.4930310470001, 39.59624054000004],
              [71.50965448300008, 39.58499810000002],
              [71.51091109200007, 39.58414825500007],
              [71.52538049300011, 39.56916209000009],
              [71.53137496000011, 39.553090719000025],
              [71.52600061000004, 39.53815623000007],
              [71.50057580600014, 39.5092174280001],
              [71.49210087100005, 39.493662821000086],
              [71.51287479700011, 39.45883290700003],
              [71.55431929500014, 39.44415679900003],
              [71.60279178900004, 39.44234812400005],
              [71.70459436100009, 39.45898793600004],
              [71.7244381110001, 39.45940134800007],
              [71.74025109900009, 39.44834259000005],
              [71.74924279800013, 39.425501607000044],
              [71.75182662000003, 39.39966339100003],
              [71.74810591700003, 39.379561259000084],
              [71.73663374800009, 39.3645750940001],
              [71.72319787600014, 39.35398142500013],
              [71.71296594200004, 39.341527405000036],
              [71.71089888500012, 39.32096018500006],
              [71.71834029200011, 39.30106475800004],
              [71.73291304500009, 39.28509674100009],
              [71.75120650200006, 39.27424469000006],
              [71.77043013500008, 39.269542135000066],
              [71.80701704900008, 39.27284942700008],
              [71.84350061100014, 39.28504506500009],
              [71.94230594900006, 39.33904693600006],
              [71.95915246600003, 39.345868226000036],
              [71.99646285000006, 39.35186269200004],
              [72.03149947200012, 39.366693828000066],
              [72.0497929280001, 39.36886423700007],
              [72.06694950400004, 39.358477275000055],
              [72.07811161300009, 39.33661814400001],
              [72.0841060790001, 39.31124501600003],
              [72.08575972500006, 39.29010935500007],
              [72.0947514240001, 39.27507151300007],
              [72.11552535000004, 39.2681468710001],
              [72.15862349500014, 39.262617493],
              [72.16709842900013, 39.25874176100005],
              [72.18239465400012, 39.249336650000075],
              [72.20327193200006, 39.24081003800008],
              [72.20637251800014, 39.23460886700009],
              [72.20647587100007, 39.22688324000008],
              [72.20916304500008, 39.21729726200009],
              [72.21856815600012, 39.20088999400012],
              [72.22866824500005, 39.18950214400006],
              [72.22890344200005, 39.18923695900007],
              [72.24027225800012, 39.18990875300004],
              [72.28140669800013, 39.25972361300002],
              [72.3042476810001, 39.31357045600005],
              [72.3163399660001, 39.32881500300009],
              [72.33411665900013, 39.33382761600005],
              [72.35592411300007, 39.336101379000056],
              [72.39323449800008, 39.35082916300006],
              [72.41070113100005, 39.35134592700011],
              [72.44356734200005, 39.34478302000012],
              [72.46041385900014, 39.34411122600004],
              [72.47674361200006, 39.34612660800009],
              [72.50805953000008, 39.3719648240001],
              [72.51901493300005, 39.3756855270001],
              [72.53410445100008, 39.372326559],
              [72.55942590300003, 39.35956248000004],
              [72.57575565600007, 39.35930409800007],
              [72.58702111800005, 39.36488515300009],
              [72.60614139800003, 39.383488668000055],
              [72.61637333200014, 39.39041331000003],
              [72.63373661300005, 39.39449574800004],
              [72.6504797770001, 39.39377227800013],
              [72.83527469900008, 39.35620351100003],
              [72.85046757000003, 39.356720276000075],
              [72.89366906800007, 39.36390330000002],
              [72.91433964100008, 39.362714742],
              [72.97676477100003, 39.35222442700005],
              [72.99433475800004, 39.347831929000066],
              [73.00932092300008, 39.34860707700007],
              [73.05841353300013, 39.36881256100004],
              [73.0711259360001, 39.37072458900006],
              [73.08342492700012, 39.36783071000009],
              [73.10099491400007, 39.36116445000006],
              [73.13603153500003, 39.353464661000075],
              [73.16786421700004, 39.355376689000096],
              [73.26935673000014, 39.382558492000086],
              [73.32640751100013, 39.390878398000055],
              [73.33333215300013, 39.40111033100003],
              [73.33550256400008, 39.41516632100006],
              [73.34315067500006, 39.430669251000054],
              [73.36764530500005, 39.44379506500003],
              [73.47688928200012, 39.46477569600002],
              [73.51223596200003, 39.467411194000036],
              [73.60432336400004, 39.459608053000025],
              [73.63264204900014, 39.44834259000005],
              [73.63191857900006, 39.42880889900006],
              [73.64256392500005, 39.371758118000045],
              [73.64380415900007, 39.351294251000084],
              [73.64132369000009, 39.335274557000034],
              [73.61011112500012, 39.26545969700008],
              [73.60225630700006, 39.235771587],
              [73.60783736200011, 39.20732371000007],
              [73.63140181500012, 39.17510345400002],
              [73.67377649000014, 39.14262481700008],
              [73.68297489400004, 39.12874969600004],
              [73.69186324100014, 39.09446238200012],
              [73.69816776600004, 39.07841685000004],
              [73.7093298750001, 39.065471904000034],
              [73.76865441900003, 39.02991851900008],
              [73.80162398300007, 39.00144480400003],
              [73.81599003200006, 38.99377085400006],
              [73.82611861200013, 38.97689849900006],
              [73.82911584500005, 38.960155335000124],
              [73.82394820200011, 38.944936626000086],
              [73.80958215300012, 38.93266347300006],
              [73.78787805200011, 38.92708241900003],
              [73.7399223220001, 38.926927389000085],
              [73.71718469300004, 38.91858164500012],
              [73.70292199700003, 38.90703196200009],
              [73.68896936000004, 38.891089783000055],
              [73.68080448400013, 38.87297719300004],
              [73.68369836500011, 38.85494211900003],
              [73.6957906500001, 38.840110983],
              [73.72493615700012, 38.814556987000046],
              [73.73589156100007, 38.8004234830001],
              [73.73899214700003, 38.781096497000064],
              [73.73268762200013, 38.737171530000026],
              [73.73640832600006, 38.72166860000003],
              [73.7722717690001, 38.67461720800013],
              [73.77909305800006, 38.66019948300003],
              [73.78860152200014, 38.6185741180001],
              [73.79738651500008, 38.60283864400013],
              [73.81640344300007, 38.58658640600002],
              [73.83356001800013, 38.57795644200006],
              [73.86973352100006, 38.56679433200004],
              [73.8870968010001, 38.55904286700003],
              [73.91727583900007, 38.53708038400008],
              [73.93288212100003, 38.52966481500006],
              [74.02889693200012, 38.52723602400009],
              [74.04553674300013, 38.530414124000046],
              [74.05876591000003, 38.54702809700008],
              [74.05080773900005, 38.5626602170001],
              [74.03809533700013, 38.57922251400002],
              [74.03726851400006, 38.598471986000035],
              [74.04491662600009, 38.603458761000084],
              [74.08439742000007, 38.61402659100007],
              [74.09142541500012, 38.6204344690001],
              [74.09287235500011, 38.62875437500007],
              [74.09266565000013, 38.63769439800011],
              [74.09504276600006, 38.6457559200001],
              [74.1090987550001, 38.66229237900008],
              [74.12336145000006, 38.66947540300005],
              [74.14041467300012, 38.66921702100008],
              [74.20201298100005, 38.65231882700009],
              [74.22144331900012, 38.64970916800006],
              [74.24376753700011, 38.650200094000084],
              [74.31342736800013, 38.66921702100008],
              [74.33420129400008, 38.66699493400007],
              [74.47662154100004, 38.61206288700005],
              [74.64612023900008, 38.561109925],
              [74.66431034400006, 38.54901763900001],
              [74.67960656800011, 38.53490997400009],
              [74.69645308500009, 38.523980408000014],
              [74.71908736100005, 38.521525777000036],
              [74.74203169700007, 38.52307607000007],
              [74.76032515500003, 38.5199754850001],
              [74.77634484900011, 38.510673727],
              [74.7921578370001, 38.49403391500006],
              [74.79226119000003, 38.49385304800002],
              [74.80125289000006, 38.482820130000036],
              [74.80848759000014, 38.477652486000025],
              [74.82616092900014, 38.46964263900004],
              [74.83287886600004, 38.463648173000095],
              [74.83577274600003, 38.45517323800003],
              [74.8371163330001, 38.44574229000004],
              [74.84435103300007, 38.417242737000024],
              [74.84414432800014, 38.39776072200003],
              [74.83825321400013, 38.37941558800013],
              [74.82667769400007, 38.36321502700012],
              [74.78430302000004, 38.32567209900013],
              [74.77479455600007, 38.30962656700005],
              [74.77107385300008, 38.29153981600005],
              [74.77128055900005, 38.19627431200006],
              [74.79071089700011, 38.08144928000006],
              [74.80993453000013, 38.053208110000085],
              [74.88042118300007, 38.021659648000124],
              [74.89282352800006, 37.99401275700011],
              [74.88879276500006, 37.93091583300007],
              [74.89116988100011, 37.90425079400002],
              [74.8907564700001, 37.89771372500006],
              [74.89396040800005, 37.89226186200007],
              [74.90522587100008, 37.8869391890001],
              [74.91370080600012, 37.880841370000056],
              [74.91163374800004, 37.87376169900004],
              [74.89458052600014, 37.85210927400006],
              [74.88734582500007, 37.848931173],
              [74.88321171100006, 37.8438668830001],
              [74.88610559100005, 37.830560202000086],
              [74.89116988100011, 37.823041280000055],
              [74.89840458200007, 37.817589416000075],
              [74.94925419100008, 37.79531687400002],
              [74.96144982900012, 37.78547251500005],
              [74.9651705330001, 37.76746327800005],
              [74.96175988800007, 37.758084005000015],
              [74.95442183500006, 37.7477228800001],
              [74.93860884700007, 37.730824687],
              [74.93189091000005, 37.72157460600009],
              [74.92879032400003, 37.712427877],
              [74.92692997300009, 37.703591207],
              [74.92362268100004, 37.69532297800005],
              [74.91091027900006, 37.68023346000005],
              [74.89706099500012, 37.6675727340001],
              [74.88610559100005, 37.653465068000074],
              [74.88217818200008, 37.63442230300011],
              [74.89189335200007, 37.59920481400003],
              [74.91504439300007, 37.5707311],
              [74.94522343000006, 37.54856191000009],
              [75.03586389200012, 37.50639394100001],
              [75.05343387900007, 37.493836568000106],
              [75.10397343000011, 37.44060984300005],
              [75.13249882000008, 37.418492330000035],
              [75.16412479700006, 37.40063812300009],
              [75.1152388920001, 37.387796529000084],
              [75.09177779200007, 37.378443095000065],
              [75.0795821530001, 37.361234843],
              [75.07710168400013, 37.32420867900002],
              [75.06842004400005, 37.312142233000046],
              [74.9754024660001, 37.28428863500007],
              [74.95152795400008, 37.281291403000054],
              [74.93292443900003, 37.27250640900006],
              [74.92372603400014, 37.25519480500007],
              [74.91266727700014, 37.23899424300008],
              [74.89230676300008, 37.231113587000024],
              [74.86264449100014, 37.244601135],
              [74.81685917200008, 37.30692291300004],
              [74.78854048700003, 37.3311591600001],
              [74.66038293500009, 37.39397186300006],
              [74.63144413300012, 37.38107859300008],
              [74.52984826700003, 37.37575592100002],
              [74.52116662600008, 37.375600891],
              [74.51269169100004, 37.37722869900004],
              [74.47662154100004, 37.386091208000025],
              [74.45481408700005, 37.393635966],
              [74.43590051300009, 37.39234405500004],
              [74.41833052600003, 37.38919179300008],
              [74.38939172400006, 37.39340342200002],
              [74.37812626200008, 37.39376515800002],
              [74.36820438600012, 37.396374818000126],
              [74.35363163200003, 37.41590850900003],
              [74.3438131100001, 37.420998637000125],
              [74.33244429600006, 37.42035268100004],
              [74.32086877400013, 37.413893128],
              [74.31559777900003, 37.42691558800003],
              [74.30381555200012, 37.400173035000066],
              [74.2794242760001, 37.39751169900005],
              [74.25038212100009, 37.403687032],
              [74.22392378800009, 37.403351136000126],
              [74.2076973880001, 37.38991526300008],
              [74.20604374200013, 37.35565378900007],
              [74.18764693200006, 37.338393861000085],
              [74.16325565700004, 37.330073954000014],
              [74.05215132600011, 37.31224558600006],
              [73.97670373600005, 37.290283102],
              [73.95561975100003, 37.286769104000044],
              [73.89929244000007, 37.26547841500006],
              [73.85640100100005, 37.2615768430001],
              [73.83624719200009, 37.25674509700009],
              [73.79821333900014, 37.22852976500012],
              [73.78395064300014, 37.225894267000015],
              [73.76865441900003, 37.2288915000001],
              [73.74612349500006, 37.23054514600007],
              [73.7362016190001, 37.22765126600008],
              [73.7199752200001, 37.21754852400004],
              [73.70922652200005, 37.21700592000009],
              [73.70240523300009, 37.22116587400002],
              [73.6880391840001, 37.236901347000085],
              [73.68049442500006, 37.24245656300009],
              [73.65992720500009, 37.24374847500006],
              [73.6176558840001, 37.233180644000086],
              [73.60163619000014, 37.24088043200008],
              [73.59729536900005, 37.26180938700007],
              [73.60990441900009, 37.2813947560001],
              [73.63098840300012, 37.29599334800007],
              [73.65196903500009, 37.3020653280001],
              [73.69041630000004, 37.30521759100007],
              [73.70498905400012, 37.31095367400012],
              [73.7222489830001, 37.32245168100003],
              [73.73909550000008, 37.33834218400007],
              [73.74571008300006, 37.3528632620001],
              [73.74591678900003, 37.39490203900003],
              [73.74705367000013, 37.40311859200007],
              [73.75346154800008, 37.428388367000125],
              [73.71780481000008, 37.43182485000007],
              [73.67449995900012, 37.431049703000056],
              [73.60504683500005, 37.44577748700006],
              [73.48526086400011, 37.48096913700003],
              [73.44061242700008, 37.47993560800005],
              [73.37839400300004, 37.452547099000085],
              [73.36185754400009, 37.45639699400003],
              [73.34501102700011, 37.46448435500004],
              [73.32123986800013, 37.467016500000014],
              [73.29633182800006, 37.464949443000066],
              [73.27607466700005, 37.45947174100006],
              [73.26026167900005, 37.450040792000024],
              [73.21147912600009, 37.408260396000045],
              [73.20062707500006, 37.40417795900005],
              [73.1790263260001, 37.410740866000125],
              [73.17024133300004, 37.408260396000045],
              [73.13210412600006, 37.38438588500007],
              [73.11639449000006, 37.36906382300002],
              [73.09923791500012, 37.33986663800006],
              [73.0877657480001, 37.32606903100013],
              [73.06750858600009, 37.31506195100003],
              [72.99557499200006, 37.309300029000056],
              [72.92426151500007, 37.27483184900011],
              [72.90224735600009, 37.253799541],
              [72.87744266800007, 37.246874898],
              [72.8305204670001, 37.239769389000074],
              [72.7907296140001, 37.22026153600008],
              [72.7609639900001, 37.18749867800007],
              [72.71435184800004, 37.1099840290001],
              [72.67270064300004, 37.05760996500008],
              [72.66660282400005, 37.03833465600006],
              [72.65771447800006, 37.02882619200007],
              [72.50867964700006, 37.011075338000055],
              [72.47498661300011, 36.99748443600005],
              [72.40594689900013, 37.007664693000024],
              [72.36098840400012, 37.0002749640001],
              [72.25980594900005, 36.96730540000006],
              [72.22032515500013, 36.94554962200003],
              [72.21040328000004, 36.93660959900011],
              [72.19593387900011, 36.91898793600002],
              [72.1868388260001, 36.91139150000005],
              [72.15283573400006, 36.8957077030001],
              [72.12668746000008, 36.87273752900005],
              [71.83657596900014, 36.69915639200009],
              [71.79761193900003, 36.68608225500013],
              [71.74851932800004, 36.678640849000104],
              [71.69994348200004, 36.678640849000104],
              [71.65302128100006, 36.6870124310001],
              [71.61106001800005, 36.70484080000004],
              [71.57736698400004, 36.733262838000044],
              [71.56393111200009, 36.75067779600009],
              [71.55287235600008, 36.76959137000004],
              [71.5453275960001, 36.79000356100006],
              [71.53850630700003, 36.83609893800009],
              [71.52848107900013, 36.85614939400004],
              [71.47174035600011, 36.93004669200012],
              [71.46305871600003, 36.94808176700012],
              [71.45995813000013, 36.9697858680001],
              [71.45995813000013, 37.01073944100004],
              [71.45644413300005, 37.022547506000066],
              [71.43918420400007, 37.044096578],
              [71.43318973800012, 37.054741924],
              [71.43112268100009, 37.06698923700013],
              [71.43318973800012, 37.12734731100004],
              [71.44104455600007, 37.168430074000085],
              [71.44683231600004, 37.1835971070001],
              [71.45375695800004, 37.19261464500006],
              [71.45013960700004, 37.21667002400001],
              [71.48703658000005, 37.2670545460001],
              [71.48786340400011, 37.29498565700008],
              [71.49385787000011, 37.30754303],
              [71.49654504400007, 37.32852366200008],
              [71.49468469200013, 37.37069163100004],
              [71.4871399330001, 37.409087219000085],
              [71.49024052000004, 37.42337575300006],
              [71.50150598200008, 37.44577748700006],
              [71.51122115100003, 37.485878398000054],
              [71.49716516100011, 37.56654530900006],
              [71.50150598200008, 37.61034108500006],
              [71.5051233320001, 37.61599965500001],
              [71.51721561700009, 37.6292288210001],
              [71.52207320200012, 37.63762624100006],
              [71.52476037600013, 37.647728984000125],
              [71.52951460800011, 37.678579814],
              [71.54088342300008, 37.709714865000066],
              [71.54253706900005, 37.719559225000054],
              [71.54026330600004, 37.7305146290001],
              [71.53116825400008, 37.751753642],
              [71.52951460800011, 37.76113291500003],
              [71.53778283700007, 37.779038798],
              [71.57467981000008, 37.798004049000056],
              [71.59028609300003, 37.81572906500007],
              [71.59421350100007, 37.83376414000007],
              [71.59504032400014, 37.85753529900002],
              [71.59338667800006, 37.879342753000046],
              [71.59028609300003, 37.89143503800004],
              [71.59772749900003, 37.89835968100003],
              [71.56734175700007, 37.928073629],
              [71.53705936700004, 37.94445505800006],
              [71.50119592300013, 37.946212057000125],
              [71.37918786600005, 37.91293243400007],
              [71.36099776200012, 37.902028707000014],
              [71.34115401300005, 37.893295390000034],
              [71.31975996900013, 37.90058176700002],
              [71.28182946800013, 37.924998881000064],
              [71.27118412300013, 37.92618743900009],
              [71.26353601100004, 37.92435292600008],
              [71.25826501500012, 37.92647165900006],
              [71.25454431200012, 37.93928741500004],
              [71.25578454600003, 37.94988108300002],
              [71.26591312700009, 37.97254119900008],
              [71.27263106300012, 37.997991842],
              [71.3023966880001, 38.04233022100003],
              [71.31603926600013, 38.083283793000064],
              [71.33453942900013, 38.11167999300007],
              [71.34094730600009, 38.14092885400002],
              [71.35908573400008, 38.184104513000065],
              [71.36451176000008, 38.20681630500003],
              [71.35815555800013, 38.25125803700011],
              [71.3343843990001, 38.280661927],
              [71.3001229250001, 38.29869700100009],
              [71.2176990160001, 38.32582712800006],
              [71.15594567900013, 38.37621165000006],
              [71.11739506000004, 38.39863922100004],
              [71.08938643400012, 38.409853007],
              [71.07698409100004, 38.41217844700013],
              [71.0649434820001, 38.41181671200003],
              [71.05714034000005, 38.40902618400007],
              [71.04980228700009, 38.408664450000074],
              [71.039467, 38.41533070900009],
              [71.03295577000011, 38.42365061500006],
              [71.02458418800012, 38.441918233000095],
              [71.0186413990001, 38.44982472700006],
              [71.00856449400004, 38.45858388300003],
              [70.99822920700007, 38.46566355400007],
              [70.98680871600004, 38.470908712],
              [70.97404463700008, 38.47367340200013],
              [70.95073856600004, 38.47305328400007],
              [70.94345218900008, 38.46594777500003],
              [70.94675948100007, 38.443235983000065],
              [70.93621748900011, 38.433004049000075],
              [70.91223962400011, 38.43765492800004],
              [70.87100183100011, 38.45320953400007],
              [70.85932295700013, 38.45165924100006],
              [70.85358687400009, 38.44742177400009],
              [70.84981449400004, 38.442822571000065],
              [70.84304488100008, 38.44016123500005],
              [70.83410485800005, 38.44060048400006],
              [70.81798181200008, 38.444992981000055],
              [70.80888675900013, 38.446362407000024],
              [70.77726078300003, 38.44646575900005],
              [70.76108606000014, 38.443520203000034],
              [70.75421309400008, 38.43646637000002],
              [70.74181075100006, 38.4194389850001],
              [70.68331302900009, 38.41458140100009],
              [70.66486454300008, 38.405408834000085],
              [70.66486454300008, 38.39863922100004],
              [70.68475996900008, 38.386650289],
              [70.6766984460001, 38.374919739000106],
              [70.64135176600007, 38.35419748900007],
              [70.63210168500007, 38.35011505200008],
              [70.60931237800008, 38.35120025700006],
              [70.60001062000003, 38.34706614200003],
              [70.5957731520001, 38.338177796000124],
              [70.59556644700007, 38.327790833],
              [70.59670332800005, 38.31758473700002],
              [70.59659997600005, 38.30918731800004],
              [70.58306075100006, 38.27508087200009],
              [70.57303552300004, 38.271050110000076],
              [70.55939294400014, 38.268182068],
              [70.5471973060001, 38.26265269],
              [70.5379472250001, 38.238054708000035],
              [70.50854333500013, 38.19250193300003],
              [70.48260176600007, 38.137363180000065],
              [70.4703027750001, 38.12051666300009],
              [70.46007084200005, 38.11224843400005],
              [70.42596439700009, 38.10064707400009],
              [70.4153707270001, 38.09452341800004],
              [70.37118737800006, 38.05829823800006],
              [70.32628055800006, 38.011272685],
              [70.31796065300011, 38.006311748000044],
              [70.29858315700005, 37.99813427900007],
              [70.29377608300007, 37.99610565200008],
              [70.28871179200007, 37.99080881800005],
              [70.28375085500005, 37.981868795000096],
              [70.27269209900004, 37.9781739300001],
              [70.26090987200013, 37.97646860800005],
              [70.25393355300014, 37.97339386],
              [70.25041955600005, 37.964143779],
              [70.25016117400008, 37.955617167000085],
              [70.25367517100005, 37.947400615000035],
              [70.26152998900011, 37.93928741500004],
              [70.23812056500003, 37.932362773000065],
              [70.21471114100007, 37.92926218700002],
              [70.19223189300004, 37.93287953800011],
              [70.17212976100012, 37.946082866],
              [70.16050256400013, 37.92065806100008],
              [70.16520511900012, 37.88991058400002],
              [70.17915775600011, 37.86079091400002],
              [70.19600427300009, 37.83991363600005],
              [70.20747644000011, 37.835624492000065],
              [70.24034265200004, 37.827562968000095],
              [70.24716394000006, 37.8191655480001],
              [70.24985111500013, 37.80487701500003],
              [70.25651737500004, 37.79180287800007],
              [70.26556075100007, 37.78120920800008],
              [70.2751208900001, 37.77418121300009],
              [70.26959151200009, 37.76263153100005],
              [70.2717619230001, 37.748704733000054],
              [70.28189050300011, 37.719559225000054],
              [70.28307906100014, 37.70483144200004],
              [70.28054691600005, 37.69604644800005],
              [70.27703291800003, 37.687984925000066],
              [70.2751208900001, 37.67547922800007],
              [70.26256351700005, 37.6608806360001],
              [70.25770593300007, 37.65809010800005],
              [70.25357181800013, 37.65457611100008],
              [70.25388187700008, 37.646592102000014],
              [70.25522546400009, 37.63747121200005],
              [70.25393355300014, 37.63080495200002],
              [70.24830082200009, 37.62333770800008],
              [70.24607873600007, 37.62127065000003],
              [70.24096276900008, 37.6171365360001],
              [70.23765547700003, 37.61811838800007],
              [70.21843184500005, 37.617446595],
              [70.21646814000013, 37.6171365360001],
              [70.2019470620001, 37.587991029000094],
              [70.19941491700013, 37.57928355000003],
              [70.1926969810001, 37.57602793400004],
              [70.15786706500012, 37.54143056200003],
              [70.12913496900012, 37.53228383400007],
              [70.09905928600006, 37.536572978000024],
              [70.06919030800003, 37.545202942000074],
              [70.04169844600005, 37.54884613100005],
              [70.04800297000008, 37.54143056200003],
              [70.01689375800004, 37.54597808900009],
              [70.00759200100009, 37.54884613100005],
              [70.00418746200006, 37.55137051900003],
              [69.99849694800014, 37.555589905],
              [69.9946728920001, 37.56225616500011],
              [69.9895052490001, 37.567320455000086],
              [69.9765861410001, 37.569335836000036],
              [69.95539880400008, 37.575485331],
              [69.94454675300005, 37.58969635000007],
              [69.93524499600005, 37.60566436800009],
              [69.91881189000009, 37.6171365360001],
              [69.89524743600009, 37.618170065000086],
              [69.85328617400006, 37.60122019400008],
              [69.83292565900013, 37.59667266900006],
              [69.82300378500014, 37.59295196600003],
              [69.81266849800005, 37.58584645600011],
              [69.80222985800009, 37.58150563600013],
              [69.79184289500006, 37.58610483800008],
              [69.78445316600005, 37.590419820000065],
              [69.76223230000005, 37.59579416900003],
              [69.75427413000006, 37.59667266900006],
              [69.72957279500014, 37.594088848000055],
              [69.68730147300005, 37.579593608000025],
              [69.66497725500011, 37.57615712500008],
              [69.52865482600009, 37.58602732400006],
              [69.50865604600006, 37.57897349000005],
              [69.49144779500006, 37.536986390000024],
              [69.46974369400004, 37.52013987300005],
              [69.4254053140001, 37.49424998000002],
              [69.42178796400003, 37.489495748000124],
              [69.41558679200006, 37.47750681600006],
              [69.41171106000007, 37.47252004000002],
              [69.40401127100012, 37.46686147100009],
              [69.38964522300012, 37.45879994700009],
              [69.38447758000007, 37.453270569],
              [69.37837976100013, 37.43740590500006],
              [69.37631270300005, 37.41885406500005],
              [69.37703617400007, 37.38066518200007],
              [69.37894820200006, 37.377125346000085],
              [69.38830163600005, 37.37510996600004],
              [69.39119551600004, 37.37069163100004],
              [69.39088545700014, 37.36531728100009],
              [69.38850834100009, 37.36376698800008],
              [69.38582116700007, 37.36314687200009],
              [69.38447758000007, 37.360149638000095],
              [69.38489099100008, 37.35089955700006],
              [69.38644128500005, 37.341520284000026],
              [69.38943851700003, 37.33291615800009],
              [69.39460616000014, 37.32606903100013],
              [69.40308109500006, 37.31116038000006],
              [69.40969567900004, 37.276743877000015],
              [69.41791223100006, 37.26767466200006],
              [69.40985070800008, 37.24566050300008],
              [69.4268522540001, 37.239459331],
              [69.44519738800011, 37.23641042100006],
              [69.44214847900008, 37.223620504000095],
              [69.40773197400011, 37.17747345000005],
              [69.39119551600004, 37.16465769400007],
              [69.35083622300004, 37.144142151],
              [69.33476485200009, 37.129052633000086],
              [69.32391280200005, 37.12099111000002],
              [69.31207889800004, 37.11747711200006],
              [69.30861667800008, 37.1168820430001],
              [69.28562056500004, 37.11292958600002],
              [69.26577681500004, 37.10541066600008],
              [69.24567468300006, 37.103886210000056],
              [69.15100345900004, 37.15504587800005],
              [69.14573246300012, 37.15695790700006],
              [69.1236149500001, 37.1692052210001],
              [69.11431319200011, 37.17747345000005],
              [69.09643314600004, 37.213026836000026],
              [69.07839807200014, 37.225170797000104],
              [69.05560876500004, 37.23710805300006],
              [69.03576501500004, 37.25157745400007],
              [69.02103723200014, 37.28795766300006],
              [69.00548262600012, 37.30552764900004],
              [68.98522546400011, 37.32035878500007],
              [68.96543339100003, 37.32914377800007],
              [68.89716882400006, 37.33596506800002],
              [68.89365482600004, 37.33715362500003],
              [68.88786706600007, 37.3381354780001],
              [68.88507653800008, 37.334828186000024],
              [68.89029585800012, 37.32294260700009],
              [68.89675541200006, 37.31648305300003],
              [68.91298181200006, 37.30676788300009],
              [68.91763269100005, 37.3024270640001],
              [68.92114668800008, 37.28795766300006],
              [68.91582401600004, 37.27906931600005],
              [68.90471358200006, 37.27669220000011],
              [68.89029585800012, 37.281963196000035],
              [68.8770150150001, 37.29609670100008],
              [68.86802331600006, 37.312142233000046],
              [68.85675785300003, 37.324906311000106],
              [68.83582889800005, 37.32914377800007],
              [68.81381473800013, 37.323407695000085],
              [68.81019738800006, 37.31209055600003],
              [68.8220312900001, 37.281963196000035],
              [68.82461511300005, 37.260620830000036],
              [68.82037764500012, 37.2509056600001],
              [68.80849206500011, 37.2516291300001],
              [68.77128503400007, 37.27072357200008],
              [68.75960616100008, 37.27524526000012],
              [68.74653202300004, 37.276227112000086],
              [68.72591312700007, 37.27452179000004],
              [68.68694909600009, 37.27901764000005],
              [68.66886234500004, 37.278294169000034],
              [68.65754520700006, 37.26767466200006],
              [68.66266117300006, 37.26372141500009],
              [68.66545170100005, 37.259380595000025],
              [68.67123946100008, 37.2471849570001],
              [68.64860518400013, 37.244368591000026],
              [68.63640954600004, 37.229925029000086],
              [68.6307768150001, 37.21382782000002],
              [68.62690108300006, 37.206257222000076],
              [68.60881433200012, 37.204086813000075],
              [68.57140059500006, 37.19470754100003],
              [68.55145349100007, 37.19261464500006],
              [68.54654423000011, 37.188222148000065],
              [68.5327466230001, 37.16899851500004],
              [68.52385827600006, 37.16465769400007],
              [68.5133162840001, 37.16398590100009],
              [68.46577396700008, 37.15535593700004],
              [68.40371057100003, 37.151635234000125],
              [68.41802494300009, 37.12827748600007],
              [68.4114620360001, 37.11336883600005],
              [68.39187666900011, 37.105436503000064],
              [68.36583174600014, 37.103214417000075],
              [68.34609135000005, 37.106909281000085],
              [68.32666101100006, 37.113032939000036],
              [68.3072823490001, 37.11422149700006],
              [68.28831709800005, 37.103214417000075],
              [68.28077233900012, 37.086652121000085],
              [68.28159916200013, 37.066472473000076],
              [68.28831709800005, 37.02440785700007],
              [68.27777510600009, 37.01006764800006],
              [68.25374556500009, 37.010222677000016],
              [68.21255944800009, 37.02125559500011],
              [68.18641117300007, 37.018310038000024],
              [68.16796268800005, 37.00608856200007],
              [68.15199467000014, 36.992781881000056],
              [68.13339115400004, 36.986529032000064],
              [68.12109216300013, 36.98027618500008],
              [68.05494633000006, 36.93464589400007],
              [68.04471439600007, 36.92921986900011],
              [68.03272546400012, 36.925240784000025],
              [68.02481969200005, 36.92551846600007],
              [68.02021976800012, 36.92568003400005],
              [68.01112471500005, 36.93087351600006],
              [68.00606042500004, 36.93867665700007],
              [68.00202966300009, 36.94748748800005],
              [67.99619022600007, 36.95578155500003],
              [67.96182539900013, 36.989939677000095],
              [67.95293705300014, 36.99624420200011],
              [67.9292692460001, 37.00624359200013],
              [67.91841719600006, 37.01381418900009],
              [67.90250085500014, 37.03438140900006],
              [67.89195886200008, 37.05202891100008],
              [67.87810957900012, 37.06443125400004],
              [67.8328927010001, 37.07308705700008],
              [67.80803633700009, 37.083241476000055],
              [67.7853503820001, 37.09654815700007],
              [67.77305139200007, 37.1099840290001],
              [67.77196618700009, 37.124970195000074],
              [67.78054447500011, 37.18886810300005],
              [67.78509200100012, 37.20357004800003],
              [67.80395389900013, 37.233439026000056],
              [67.81542606600004, 37.267338766000066],
              [67.82064538600008, 37.30330556300005],
              [67.81718306500005, 37.34542185500008],
              [67.79733931500004, 37.42443512000004],
              [67.80121504700008, 37.466448060000076],
              [67.8292236740001, 37.52794301400009],
              [67.8718567300001, 37.58680247000008],
              [67.92337813300009, 37.638788961],
              [67.97732832900004, 37.67974253400003],
              [68.05019209800014, 37.76040944400005],
              [68.07964766500004, 37.806272279],
              [68.12222904500004, 37.90833323200003],
              [68.13995406100014, 37.92269928000003],
              [68.17111495000012, 37.931070863000016],
              [68.21772709100009, 37.936083476000064],
              [68.23302331600013, 37.93980417900009],
              [68.23802450700003, 37.94271605600004],
              [68.24873295100008, 37.948950907000054],
              [68.25622603400012, 37.96155995700009],
              [68.26077355900009, 37.97677866600013],
              [68.26826664200013, 37.99383188900005],
              [68.26836999500006, 37.99390940400009],
              [68.26847334800004, 37.99398691800009],
              [68.26847334800004, 37.994116110000036],
              [68.26857670100009, 37.99419362400006],
              [68.28056563300004, 38.01323639000013],
              [68.31952966300014, 38.060210266000084],
              [68.34433435000005, 38.115452372],
              [68.36066410300003, 38.17405344700002],
              [68.35621993000012, 38.212604065],
              [68.33203536000013, 38.24298980700006],
              [68.25266036000005, 38.298748678000024],
              [68.20082889800011, 38.32169301400005],
              [68.18372399900005, 38.33549062100009],
              [68.14672367300011, 38.38874318500005],
              [68.10755293800014, 38.41827626600009],
              [68.09804447400006, 38.432435608000034],
              [68.09463383000013, 38.44698252400009],
              [68.09256677300004, 38.47878936800002],
              [68.08688236500012, 38.49403391500006],
              [68.06259444200003, 38.52307607000007],
              [68.0551530350001, 38.536305237000064],
              [68.05251753800007, 38.558267721000036],
              [68.05587650600012, 38.61573191400005],
              [68.05370609500011, 38.635937398000024],
              [68.0403219000001, 38.67335113500009],
              [68.03763472500003, 38.69164459200006],
              [68.04548954300009, 38.70670827300005],
              [68.07075931800006, 38.72073842400006],
              [68.07592696200004, 38.72686208100002],
              [68.07665043100013, 38.73810170500009],
              [68.07220625900004, 38.747351786000095],
              [68.06631514500003, 38.756214295000106],
              [68.06331791200012, 38.766317038000054],
              [68.06672855600004, 38.78796946200005],
              [68.07789066600009, 38.793395488],
              [68.09561568300012, 38.79293040000009],
              [68.11902510600004, 38.7967027800001],
              [68.13597497600006, 38.80450592100003],
              [68.15127120000011, 38.81512542800003],
              [68.16367354300007, 38.82863881400009],
              [68.17256189000011, 38.845278626000024],
              [68.17369877100003, 38.86731862400008],
              [68.16372522000012, 38.88747243300007],
              [68.15338640700008, 38.899402540000054],
              [68.1346830650001, 38.92098459900008],
              [68.10093835400005, 38.97927561500002],
              [68.0856421310001, 38.99377085400006],
              [68.08543542500013, 38.99379669200006],
              [68.08528039600009, 38.9939517210001],
              [68.08507369000006, 38.9939517210001],
              [68.0772705490001, 38.99552785300004],
              [68.06910567200009, 38.99609629300009],
              [68.06094079600007, 38.99552785300004],
              [68.05308597900006, 38.9939517210001],
              [68.03644616700012, 38.9843915820001],
              [68.01980635600012, 38.97968902600003],
              [68.00337325100014, 38.982117819000095],
              [67.98797367400005, 38.99377085400006],
              [67.9801188560001, 38.997388205000036],
              [67.96327233900013, 39.00190989200006],
              [67.94890629000014, 39.0020132450001],
              [67.93485030200009, 38.999067689000086],
              [67.92151778200008, 38.993874207],
              [67.92125940000011, 38.993874207],
              [67.92115604700007, 38.99379669200006],
              [67.84524336700008, 38.973772075000014],
              [67.81837162300008, 38.97341034000003],
              [67.69052412900004, 38.989610901000034],
              [67.6732541990001, 39.00297802200008],
              [67.67223067200007, 39.00377024400008],
              [67.67218541700004, 39.00399232200006],
              [67.66721805800012, 39.02836822600004],
              [67.67858687400008, 39.10593455000013],
              [67.67672652200008, 39.11962880500006],
              [67.67658139500008, 39.119821488000085],
              [67.66757979300007, 39.131772767000044],
              [67.66117191600006, 39.13337473600008],
              [67.64453210500005, 39.13061004700005],
              [67.6377108150001, 39.13154022300007],
              [67.63212976100004, 39.13621693900005],
              [67.62417159000012, 39.147379049000094],
              [67.61983077000014, 39.15125478100005],
              [67.5803499760001, 39.163605449],
              [67.49901127100009, 39.16598256400003],
              [67.37819177300008, 39.19949473100006],
              [67.35007979400012, 39.21982940700006],
              [67.3500372960001, 39.22005794600007],
              [67.34269006300013, 39.259568583000075],
              [67.34439538600009, 39.27383127900005],
              [67.34646244300006, 39.28080759700005],
              [67.35121667500005, 39.285251770000045],
              [67.36062178500009, 39.291763],
              [67.37126713000009, 39.29450185100005],
              [67.38025883000012, 39.29233144100006],
              [67.38687341300005, 39.29419179300008],
              [67.39441817300008, 39.327368063000094],
              [67.40707889900011, 39.36100942000003],
              [67.4081641030001, 39.39790639300007],
              [67.41477868600003, 39.43811065700008],
              [67.42728438300009, 39.47660959900004],
              [67.43648278800003, 39.485704651],
              [67.45167565900005, 39.487151591],
              [67.47741052200013, 39.48441274000005],
              [67.48237146000008, 39.485291239],
              [67.48702233900013, 39.487151591],
              [67.49115645400008, 39.49009714800009],
              [67.49456709800006, 39.493714498000074],
              [67.48764245600012, 39.53800120000004],
              [67.50743453000007, 39.55293569000007],
              [67.58737797100008, 39.5626508590001],
              [67.68044722500008, 39.61412058600011],
              [67.71760258000006, 39.62337066700012],
              [67.76452478000004, 39.622595520000104],
              [68.10620935100008, 39.554124248],
              [68.25586429900005, 39.55055857400005],
              [68.33756473800014, 39.527924296],
              [68.38660567200009, 39.52518544600004],
              [68.43626672400006, 39.52880279600002],
              [68.49771000100003, 39.54141184500004],
              [68.51745039900004, 39.54843984000006],
              [68.51726770800008, 39.54876482000013],
              [68.51015830600011, 39.56141135100005],
              [68.50670170100011, 39.56756012000007],
              [68.5202409260001, 39.58254628500002],
              [68.56292566000008, 39.60357859300005],
              [68.58700687700014, 39.62316396100006],
              [68.60033939700014, 39.64285268200011],
              [68.60581709800005, 39.66688222300003],
              [68.61584232600006, 39.82811269200006],
              [68.62617761200005, 39.84961008800009],
              [68.63775313400009, 39.848938294],
              [68.65108565300011, 39.84470082600005],
              [68.68508874500009, 39.868006897000086],
              [68.70152185100005, 39.858446757000095],
              [68.72818689000007, 39.824960429],
              [68.74162276200013, 39.81963775700005],
              [68.74834069800005, 39.82614898700011],
              [68.75051110800013, 39.83607086200003],
              [68.75061446100005, 39.841083476000065],
              [68.75040775600013, 39.84247874000006],
              [68.75753910300006, 39.85751658200003],
              [68.76094974800009, 39.859118550000076],
              [68.77144006400005, 39.86051381400004],
              [68.77521244300004, 39.862529195],
              [68.78735640500014, 39.881701152000105],
              [68.78761478700011, 39.89575714100003],
              [68.76523889200013, 39.93244740900009],
              [68.75557539900012, 39.95404815700006],
              [68.75200972500005, 39.97275502500004],
              [68.75888269000012, 39.98055816700007],
              [68.77975996900011, 39.96944773300005],
              [68.80012048300011, 39.93513458300002],
              [68.81536503100006, 39.89188140900008],
              [68.83825769100008, 39.86464793000006],
              [68.88078739500014, 39.8783421830001],
              [68.87742842600011, 39.90056305000003],
              [68.78937178500007, 39.9939940390001],
              [68.78441084800005, 40.00401926700003],
              [68.78291223200006, 40.013424377],
              [68.78503096600014, 40.03393992100008],
              [68.7816203210001, 40.04153635700003],
              [68.76384362800007, 40.05249176100001],
              [68.76172489400011, 40.06148345900006],
              [68.7746956790001, 40.07988027000006],
              [68.79040531400005, 40.07016510100003],
              [68.81314294400005, 40.03890085900012],
              [68.82606205300004, 40.04205312100008],
              [68.86151208500007, 40.06582428000003],
              [68.88176924700008, 40.070836894000095],
              [68.95452966300007, 40.0620519000001],
              [68.97726729300007, 40.06489410400009],
              [68.98543217000008, 40.07714141900003],
              [68.98698246200007, 40.09171417300006],
              [68.98377852400012, 40.107010397000025],
              [68.97726729300007, 40.12101471000004],
              [68.9306551520001, 40.14680125000005],
              [68.69654498000011, 40.11173935200007],
              [68.68705245000007, 40.11031768800002],
              [68.65170577000009, 40.12075632800007],
              [68.60695398000013, 40.14230540000001],
              [68.58111576400012, 40.16421620800007],
              [68.60199304200006, 40.17542999300012],
              [68.64273231300007, 40.18369149800013],
              [68.69831791200005, 40.19496368500002],
              [68.7205387780001, 40.196513978000056],
              [68.77846805900003, 40.188762512000054],
              [68.80187748200007, 40.19113962800007],
              [68.83665572100006, 40.20643585200004],
              [68.85655114800005, 40.21274037700006],
              [69.01922855600003, 40.23206736300001],
              [69.04201786300013, 40.229173483000025],
              [69.07363981700007, 40.216940714000046],
              [69.10800866700009, 40.20364532500007],
              [69.19792565900008, 40.18297475200008],
              [69.24769006400004, 40.18173451800003],
              [69.28525883000003, 40.19496368500002],
              [69.28525883000003, 40.21863149000005],
              [69.21249841300005, 40.26875763000008],
              [69.20836429900004, 40.298316549],
              [69.23461592700005, 40.300848694000095],
              [69.27311486800005, 40.28958323100004],
              [69.30530928500008, 40.293820699],
              [69.31269901600007, 40.3428099580001],
              [69.30634281400006, 40.36497914700003],
              [69.29549076300003, 40.38394439800008],
              [69.26944584200004, 40.41980784100012],
              [69.2597306720001, 40.437636211000054],
              [69.2383366300001, 40.493963521000055],
              [69.23823327700006, 40.493963521000055],
              [69.19802901200012, 40.545846660000066],
              [69.19844242400006, 40.566517233000084],
              [69.23425419100005, 40.58527577800008],
              [69.29497399900009, 40.58915151000012],
              [69.30934004800008, 40.59581776900005],
              [69.31347416200009, 40.60935699500003],
              [69.30660119700013, 40.66253204400006],
              [69.30716963700007, 40.69932566400006],
              [69.31419763200012, 40.729297995000096],
              [69.32959720800005, 40.75534291600009],
              [69.3550736900001, 40.78035430900009],
              [69.36928470900006, 40.789397685000026],
              [69.38525272600009, 40.79611562200007],
              [69.41775720300012, 40.80422882100005],
              [69.43584395300013, 40.80267852900003],
              [69.44917647400007, 40.794461975],
              [69.46168217000007, 40.78433339500005],
              [69.4772884520001, 40.77704701800009],
              [69.5092244870001, 40.77466990200013],
              [69.53185876500004, 40.75859853100006],
              [69.57082279400004, 40.712451478000034],
              [69.58260502100012, 40.704389954000035],
              [69.60782312000009, 40.6917809050001],
              [69.6188818760001, 40.68165232400007],
              [69.63717533300007, 40.65793284100003],
              [69.64751062000005, 40.64744252600006],
              [69.6601196690001, 40.638709208000094],
              [69.69091882300006, 40.630027568000045],
              [69.71768721500013, 40.63628041700004],
              [69.74156172700003, 40.652455139000025],
              [69.78352299000011, 40.69296946200005],
              [69.80331506400012, 40.705630188000086],
              [69.82532922400009, 40.71400177000005],
              [70.00965905700008, 40.75803009000002],
              [70.10422692900005, 40.813323873000044],
              [70.20799320500004, 40.844588115000036],
              [70.28039188600013, 40.87771270800003],
              [70.33589237400008, 40.926960348000094],
              [70.36353926600003, 41.032431946000074],
              [70.40115970900013, 41.039976705000115],
              [70.44570479300012, 41.0259207160001],
              [70.45800635800003, 41.01573663300009],
              [70.47722741700011, 40.99982411700002],
              [70.47975956300007, 40.99646514900009],
              [70.48291182500003, 40.993519592],
              [70.51443444800003, 40.97259063700001],
              [70.69685225400008, 40.81621775400002],
              [70.70512048300003, 40.807432760000026],
              [70.7031567790001, 40.78893259700003],
              [70.68346805900012, 40.79451365200002],
              [70.64868981900008, 40.81750966400007],
              [70.62874271700008, 40.81585601800002],
              [70.6193376060001, 40.80319529300009],
              [70.62176639900008, 40.78598704000011],
              [70.63742435700004, 40.770587463000126],
              [70.72889164300005, 40.75446441700005],
              [70.76713220300007, 40.737617900000075],
              [70.75850223800012, 40.703924866000094],
              [70.75629278600007, 40.695578051000055],
              [70.75617679800007, 40.69513987300003],
              [70.74067386900009, 40.68769846700009],
              [70.73715987200012, 40.68356435200009],
              [70.73550622500005, 40.678861797000096],
              [70.73209558100007, 40.67498606400004],
              [70.71566247600009, 40.67214386000008],
              [70.70723921700011, 40.668991598000034],
              [70.6929248460001, 40.660413310000095],
              [70.67793868100006, 40.64992299400005],
              [70.61716719600014, 40.61194081700002],
              [70.58207889900007, 40.578764547],
              [70.56931482000005, 40.570444642000055],
              [70.55422530100003, 40.565018616000074],
              [70.53944584200008, 40.56186635400012],
              [70.52549320500003, 40.55711212200002],
              [70.51195398000004, 40.54677683500002],
              [70.48787276200011, 40.51556427000013],
              [70.47779585800004, 40.50548736600008],
              [70.46818404100014, 40.50249013300008],
              [70.39935103400006, 40.49019114200003],
              [70.36963708500008, 40.47551503600006],
              [70.35382409700009, 40.45613637300009],
              [70.35542606700011, 40.43510406500006],
              [70.35702803500004, 40.430401510000095],
              [70.3587850340001, 40.42771433600005],
              [70.37196252400008, 40.41298655200005],
              [70.37139408300004, 40.41334828800005],
              [70.37356449400005, 40.411797994000054],
              [70.38214278100008, 40.4039431770001],
              [70.38493330900013, 40.39970570900006],
              [70.37139408300004, 40.36492747000001],
              [70.4212101650001, 40.3479776],
              [70.44219079600009, 40.343326721000025],
              [70.46410160300013, 40.344825338000035],
              [70.48291182500003, 40.34926951100006],
              [70.50192875200008, 40.35081980400007],
              [70.52404626500004, 40.343740133000054],
              [70.55060795100013, 40.3104605110001],
              [70.56394047000003, 40.26421010400004],
              [70.5818205160001, 40.221732077000084],
              [70.62212813300005, 40.199562887000084],
              [70.66429610200004, 40.197495829],
              [70.70718754100005, 40.20018300400004],
              [70.84971114100011, 40.23377268500006],
              [70.93833622200009, 40.23992218100004],
              [70.95895511900011, 40.23837188800012],
            ],
          ],
          [
            [
              [70.49872481300014, 39.881907858000076],
              [70.61990604700009, 39.85069529200008],
              [70.65499434500009, 39.84976511600003],
              [70.68662032100008, 39.860875550000046],
              [70.69891931200004, 39.858446757000095],
              [70.70641239500009, 39.839998271000084],
              [70.70481042500012, 39.82206654900001],
              [70.69452681500013, 39.814831848000054],
              [70.66160892800008, 39.80981923500006],
              [70.63298018400013, 39.798450419000076],
              [70.58161381100007, 39.76656606000002],
              [70.5758777260001, 39.77008005800009],
              [70.54730065900003, 39.80764882500007],
              [70.53737878400005, 39.817312317000116],
              [70.50347904500012, 39.835502421000044],
              [70.49014652500011, 39.85017852900005],
              [70.48260176600007, 39.866766663000064],
              [70.48373864800004, 39.882217916000045],
              [70.49872481300014, 39.881907858000076],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Mongolia',
        iso3: 'MNG',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [116.68427779200016, 49.8232648730001],
            [116.47292118300004, 49.51646189400013],
            [116.45772831300008, 49.492794088000025],
            [116.24776696850012, 49.18146942150007],
            [116.0378056240001, 48.87014475500003],
            [116.03356815600006, 48.8523680630001],
            [116.04762414600009, 48.81769317600008],
            [116.0480375570001, 48.79976145500011],
            [116.02819380800008, 48.76746368500004],
            [115.8004040940001, 48.53037221300009],
            [115.7912056890001, 48.51383575400011],
            [115.78655481000015, 48.49301015300007],
            [115.78655481000015, 48.47301137400002],
            [115.80929244000004, 48.27395375600004],
            [115.7999906820001, 48.242327779000036],
            [115.77084517400016, 48.22408599900008],
            [115.536440878, 48.14915517200002],
            [115.51422001100008, 48.131636862000065],
            [115.51453007100014, 48.12210256000007],
            [115.54584598900016, 47.9929889940001],
            [115.56186568200008, 47.93319936200005],
            [115.57571496600008, 47.90973826100007],
            [115.59989953600012, 47.88741404300002],
            [115.8527006430001, 47.7055646780001],
            [115.91450565600013, 47.68391225200013],
            [115.97290002500006, 47.709052837000044],
            [116.08431441300007, 47.80692799900005],
            [116.18156945800007, 47.84958689400004],
            [116.24389123600008, 47.86289357500006],
            [116.42889286300016, 47.835143331000026],
            [116.49968957600004, 47.83635772800004],
            [116.75166386000006, 47.8741331990001],
            [116.82204716000001, 47.876303609],
            [116.8532597250001, 47.87211781800006],
            [116.97283899000007, 47.83764963800009],
            [117.04735640500013, 47.819459534000046],
            [117.06968062300007, 47.810157776000025],
            [117.31710738200002, 47.654069112000016],
            [117.360825643, 47.65086517400003],
            [117.39989302600009, 47.685669251],
            [117.43647994000003, 47.730498556000086],
            [117.4728601490001, 47.75724111000004],
            [117.52722375500002, 47.78648997000009],
            [117.74168095000005, 47.97758941700003],
            [117.76689904900002, 47.993144023000056],
            [117.815164836, 48.00482289600002],
            [117.97277795400015, 47.99789825500004],
            [117.9971692310001, 47.9999911500001],
            [118.06403853400008, 48.01957651800002],
            [118.12253625600016, 48.027508851000064],
            [118.18248091600003, 48.02820648200007],
            [118.20625207600011, 48.02329722100005],
            [118.25431115800006, 48.00285919200009],
            [118.28004602100015, 47.998130799000094],
            [118.47279911300012, 47.98944915800003],
            [118.5422522390001, 47.966246440000035],
            [118.60524580900011, 47.91467336100003],
            [118.71330122900008, 47.793621318000035],
            [118.76740645400008, 47.75615590400004],
            [118.97261356700011, 47.695126038000055],
            [119.05958500200006, 47.67347361300007],
            [119.08345951400014, 47.66156219500006],
            [119.09694706300002, 47.646601868000076],
            [119.1042334390001, 47.627739970000064],
            [119.11653243, 47.55603892000006],
            [119.12211348500006, 47.53895985900003],
            [119.13389571200003, 47.527539368000035],
            [119.15756351700009, 47.51766917000005],
            [119.25104618300008, 47.492941997000045],
            [119.29104374300005, 47.48438954700002],
            [119.3101123460001, 47.47609548000007],
            [119.31776045700008, 47.46211700400006],
            [119.31259281500002, 47.452246807000066],
            [119.2888216550001, 47.4291474410001],
            [119.28189701300005, 47.41485890700001],
            [119.32065433800005, 47.407029928],
            [119.47599369300008, 47.30920644200002],
            [119.49066980000009, 47.29716583200003],
            [119.50389896700005, 47.27918243500007],
            [119.51299401900013, 47.262671815000076],
            [119.52508630400013, 47.25081207400005],
            [119.58735640500004, 47.238358053000056],
            [119.6294210210001, 47.21608551100012],
            [119.69995935100013, 47.15952565500005],
            [119.7288981530001, 47.12864898700006],
            [119.75396122200004, 47.094439189000056],
            [119.76052412900009, 47.07459543900008],
            [119.7617126880001, 47.01547760000001],
            [119.7649683030001, 47.003824565000045],
            [119.76729374300015, 46.998114319000095],
            [119.7701359460001, 46.9929983520001],
            [119.78429528800007, 46.978322246000104],
            [119.81741988100015, 46.954912822000054],
            [119.83168257700004, 46.94214874300009],
            [119.83685022000014, 46.93357045500004],
            [119.83969242400008, 46.9256639610001],
            [119.84351648000006, 46.918170878000055],
            [119.85230147400006, 46.91072947200006],
            [119.86294681800013, 46.909024150000064],
            [119.87922489400006, 46.908145651000055],
            [119.89291914900008, 46.90551015200002],
            [119.89643314600005, 46.898585510000046],
            [119.8904386800001, 46.88825022400003],
            [119.88496097900008, 46.88091217100005],
            [119.88144698100007, 46.87285064700005],
            [119.88124027600009, 46.8605516570001],
            [119.88310062700009, 46.85543569000002],
            [119.88682133000009, 46.851456604000035],
            [119.89162723900012, 46.84848521000002],
            [119.89679488200011, 46.84646982800008],
            [119.9028927010001, 46.84241322800007],
            [119.90211755400009, 46.837348938],
            [119.89891361500008, 46.831251119000044],
            [119.89798343900014, 46.82437815400009],
            [119.89865523300006, 46.80205393500002],
            [119.88589115400015, 46.77006622300003],
            [119.88310062700009, 46.7530130010001],
            [119.8871830650001, 46.744279683000016],
            [119.9033577890001, 46.726399639000064],
            [119.90702681500011, 46.71831227600005],
            [119.90418461200011, 46.708933004000116],
            [119.89798343900014, 46.701646627000045],
            [119.890335327, 46.69477366100007],
            [119.87266198700007, 46.6732245890001],
            [119.85442020700009, 46.65965952600003],
            [119.8344214280001, 46.65095204700005],
            [119.81726485200011, 46.651623841000045],
            [119.79628422100012, 46.6588327030001],
            [119.78222823100009, 46.65562876400013],
            [119.770032593, 46.64356231700005],
            [119.75442631000016, 46.62439036100004],
            [119.74026696800001, 46.61325409000001],
            [119.7196480720001, 46.602712098000055],
            [119.69778894000007, 46.59488311800003],
            [119.68011560100007, 46.591627503000055],
            [119.65877323500007, 46.596175029000065],
            [119.62347823100004, 46.61632883700004],
            [119.60218754100009, 46.61968780600007],
            [119.57588423700014, 46.61917104100003],
            [119.50126346900004, 46.62800771100002],
            [119.45294600400013, 46.627490947000084],
            [119.36328739400005, 46.61304738400007],
            [119.31693363500005, 46.61167795800007],
            [119.06237552900012, 46.660951437000065],
            [119.036950724, 46.66872874000008],
            [119.01405806500009, 46.68330149400005],
            [118.98491255800008, 46.72453928700004],
            [118.96723921700004, 46.74045562800008],
            [118.94703373300007, 46.73714833700008],
            [118.92207401600001, 46.715495911000104],
            [118.90708785000004, 46.70939809200003],
            [118.89055139200002, 46.71353220600007],
            [118.87964766500016, 46.7273298140001],
            [118.87520349100015, 46.74396962500005],
            [118.86745202700007, 46.75833567300005],
            [118.84652307200008, 46.76549285900008],
            [118.81624068200006, 46.75818064400009],
            [118.79221114100011, 46.737768453000044],
            [118.75381555200016, 46.691156311000086],
            [118.7200708420001, 46.67673858700006],
            [118.68462080900008, 46.68345652300009],
            [118.64741377800016, 46.697719218000074],
            [118.60937992400005, 46.705780742000044],
            [118.59516890500004, 46.70304189100001],
            [118.567728719, 46.68973521],
            [118.55196740800005, 46.68575612400012],
            [118.47279911300012, 46.685678610000096],
            [118.43517867100002, 46.691156311000086],
            [118.37120324800003, 46.713971457000085],
            [118.3355465090001, 46.72216217100002],
            [118.3008199460001, 46.72484934500004],
            [118.26898726400015, 46.72293731700002],
            [118.2382914640001, 46.71539255800006],
            [118.20604537000014, 46.70092315700005],
            [118.16904504400009, 46.67849558500005],
            [118.1555058190001, 46.67456817600008],
            [118.10196903500008, 46.67306956000006],
            [118.08388228300015, 46.66826365200005],
            [118.00554081200005, 46.62697418200004],
            [117.97277795400015, 46.62340850900007],
            [117.92378869700013, 46.61519195600003],
            [117.90063765500014, 46.60759552100008],
            [117.8783134360001, 46.59638173500004],
            [117.85929650900005, 46.58028452600006],
            [117.83273482300001, 46.54279327400006],
            [117.81702518700001, 46.527471212000094],
            [117.79759484900006, 46.52026235000004],
            [117.69620568900012, 46.512252503000084],
            [117.67336470600003, 46.5160248830001],
            [117.62520227100003, 46.53566192700005],
            [117.6075289310001, 46.550544739000074],
            [117.582000773, 46.59198923800004],
            [117.5681514900001, 46.60353892000008],
            [117.55626591000009, 46.601601055000046],
            [117.51006718000014, 46.57847585100008],
            [117.50179895100007, 46.57726145500003],
            [117.49177372200006, 46.57909596800003],
            [117.4728601490001, 46.584677022000065],
            [117.39379520700004, 46.57137034100005],
            [117.41012496000008, 46.53979604100006],
            [117.41250207600001, 46.52462900900004],
            [117.40547408100014, 46.51080556300009],
            [117.36919722500016, 46.47569142700003],
            [117.35751835100007, 46.448406271000025],
            [117.3530741780001, 46.37949574800011],
            [117.33746789500003, 46.357274882000056],
            [117.30170780500009, 46.35014353500013],
            [116.95785282500009, 46.366421611000064],
            [116.83165897700007, 46.38636871400006],
            [116.81460575400007, 46.38673044800008],
            [116.80458052600017, 46.38290639300003],
            [116.78484012900009, 46.365904847000095],
            [116.72200158700002, 46.3286978150001],
            [116.70732548100005, 46.324227804000074],
            [116.64521040900007, 46.31846588100002],
            [116.60355920500001, 46.30931915300003],
            [116.58195926300004, 46.29801243800004],
            [116.56831587800008, 46.29087066600003],
            [116.5482654220001, 46.25929636700003],
            [116.53958378100003, 46.241209616000035],
            [116.5251143800001, 46.22679189100002],
            [116.3571659750001, 46.10555898100007],
            [116.21319543500016, 45.908155009000026],
            [116.20709761600011, 45.88086985300002],
            [116.22094690000006, 45.84976064100006],
            [116.24213423700013, 45.82691965800005],
            [116.25164270100004, 45.80325185200003],
            [116.23035201000005, 45.76976552300003],
            [116.16989058400009, 45.70909739200006],
            [116.14394901600014, 45.69462799100002],
            [116.09485640500009, 45.676541240000105],
            [116.07873335800002, 45.67338897800006],
            [116.06333378100015, 45.673337301000046],
            [116.0119674070001, 45.678556620000066],
            [116.00214888500005, 45.67555938800005],
            [115.98282190000009, 45.65964304600003],
            [115.76733117700013, 45.53014190700013],
            [115.69240035000007, 45.468957011],
            [115.66738895700007, 45.4542809040001],
            [115.63783003800006, 45.44435903000003],
            [115.47298221900013, 45.41278472900005],
            [115.33727990800008, 45.394697978000025],
            [115.12633671100008, 45.394439596000055],
            [114.93885461400009, 45.37376902300004],
            [114.90526493300001, 45.377748108000034],
            [114.73731652900005, 45.425032044000076],
            [114.70331343600003, 45.42715077700005],
            [114.669310344, 45.42280995800006],
            [114.53371138500006, 45.38549957300002],
            [114.52378951000003, 45.38028025400011],
            [114.51944869000016, 45.370926820000065],
            [114.51169722500003, 45.32550323500003],
            [114.50229211400011, 45.30323069300006],
            [114.47304325400006, 45.259202373],
            [114.41888635300006, 45.20147979700003],
            [114.21176721200004, 45.06216013600006],
            [114.1636047770001, 45.04014597600009],
            [114.14934208200009, 45.030069072000046],
            [114.13921350100014, 45.019165344],
            [114.12040327900007, 44.99322377600005],
            [114.08929406800007, 44.961752828],
            [114.05529097500005, 44.94056549100013],
            [114.01705041600007, 44.927284648000025],
            [113.97312544800002, 44.91932647700007],
            [113.9138009030001, 44.91545074500003],
            [113.88930627500014, 44.90826772100006],
            [113.83762984200013, 44.8679084270001],
            [113.73562056500009, 44.815921936000066],
            [113.67247196500006, 44.7681729130001],
            [113.63505822800005, 44.74626210500004],
            [113.60477583900007, 44.73969919900007],
            [113.5324288330001, 44.745280253000075],
            [113.5171326090001, 44.74951772100003],
            [113.48891727800009, 44.76626088500008],
            [113.47320764200009, 44.770705058],
            [113.10485803200004, 44.794372864000096],
            [113.0169047440001, 44.82108958000008],
            [112.97318648300012, 44.82124460900012],
            [112.74849735600009, 44.865272930000074],
            [112.6142419840001, 44.90883616100011],
            [112.58602665200016, 44.923822327],
            [112.56452925600001, 44.94392445900006],
            [112.52391158100016, 44.99327545200005],
            [112.44133264200002, 45.05239329000001],
            [112.412807251, 45.06603586900003],
            [112.37963098200015, 45.07073842400011],
            [112.10760624200014, 45.0673794560001],
            [112.01148807900006, 45.087481588000045],
            [111.98463721200005, 45.08715413800006],
            [111.9733508710001, 45.08701650000002],
            [111.95826135200008, 45.08453603100004],
            [111.94792606700008, 45.07771474200008],
            [111.9385209560001, 45.068981426000036],
            [111.92673872900008, 45.06091990200004],
            [111.90627486200003, 45.054150289000106],
            [111.86317671800003, 45.04629547100005],
            [111.84333296700004, 45.03952585900002],
            [111.78648889200008, 45.0085716760001],
            [111.76065067600007, 44.98929636700008],
            [111.73853316300006, 44.96630035400004],
            [111.55136112500003, 44.693190410000014],
            [111.54102583800011, 44.66823069300004],
            [111.54009566300005, 44.652210998000086],
            [111.54443648300003, 44.61810455300012],
            [111.54381636600004, 44.60125803600003],
            [111.53823531100005, 44.58342966800011],
            [111.53017378700008, 44.57061391200001],
            [111.50898645100011, 44.546584371000094],
            [111.48376835200003, 44.50643178300008],
            [111.47322635900008, 44.495321350000054],
            [111.47084924300003, 44.49330596900002],
            [111.44687137900013, 44.475891012],
            [111.42413374800003, 44.44803741500003],
            [111.4063570560001, 44.41646311500004],
            [111.39705529800011, 44.38736928300004],
            [111.39643518100013, 44.346596578000046],
            [111.41059452300004, 44.32608103500009],
            [111.47322635900008, 44.29884755400006],
            [111.4905896410001, 44.28262115500006],
            [111.49813440000008, 44.26443105100013],
            [111.50371545400009, 44.22572540300011],
            [111.51942508900004, 44.1885700480001],
            [111.54381636600004, 44.15673736600006],
            [111.63445682800011, 44.06594187500009],
            [111.66814986200006, 44.04134389200003],
            [111.78070113100011, 43.986205139000035],
            [111.81139693300008, 43.96429433200008],
            [111.83878544100003, 43.938792013000054],
            [111.93056278500006, 43.820142924000024],
            [111.94430871600008, 43.78637237600013],
            [111.94792606700008, 43.75696848600005],
            [111.94513553900003, 43.72386973100005],
            [111.93335331300011, 43.696636251000044],
            [111.91040897700009, 43.684983216],
            [111.8932524010001, 43.68260610000003],
            [111.84581343600013, 43.66692230300008],
            [111.77263960800013, 43.669299419000126],
            [111.75382938700005, 43.66320160000008],
            [111.59724979700007, 43.52339101200009],
            [111.56769087700008, 43.50253957200003],
            [111.5350313720001, 43.4907315060001],
            [111.42868127500009, 43.48393605600005],
            [111.40139611900008, 43.475512797000064],
            [111.33855757600008, 43.43817657500004],
            [111.09609175600013, 43.3666563930001],
            [110.97341190700007, 43.31560007800003],
            [110.93372440600012, 43.28777231900007],
            [110.79698856600004, 43.14891774500005],
            [110.68009647600007, 43.05765716600003],
            [110.66573042800007, 43.03740000500004],
            [110.64102909400009, 42.98779062900006],
            [110.60816288300003, 42.944666647000034],
            [110.56671838400007, 42.91056020200007],
            [110.47339074700011, 42.85490468400006],
            [110.44941288300004, 42.83733469600007],
            [110.42481490100005, 42.78524485300004],
            [110.4067281500001, 42.7686050410001],
            [110.13987105300009, 42.68261545800003],
            [110.10566125500003, 42.66667327900011],
            [110.09315555900008, 42.65786244700011],
            [110.0842672120001, 42.650059306000074],
            [110.07486210100006, 42.64352223800002],
            [110.06018599400005, 42.63835459500011],
            [110.04271936100002, 42.635951640000044],
            [109.98732222500007, 42.6364684040001],
            [109.91270145700008, 42.62882029300003],
            [109.66734175700003, 42.54898020400013],
            [109.51830692600004, 42.46733144200003],
            [109.51034875500005, 42.46474762000004],
            [109.50487105400009, 42.4649284880001],
            [109.50001346900007, 42.463326518000045],
            [109.49381229700009, 42.45521331800005],
            [109.49009159400003, 42.451285909],
            [109.48513065600008, 42.44929636700003],
            [109.32855106700009, 42.440485535000036],
            [109.28028527900005, 42.428315735000055],
            [109.25341353400006, 42.42593862000008],
            [108.99446293200009, 42.44952891100009],
            [108.96128666200008, 42.44753936800005],
            [108.86268803000007, 42.40885955900005],
            [108.82852990800012, 42.400048727000055],
            [108.7968522540001, 42.398369243],
            [108.53645471300007, 42.43511118600007],
            [108.3197754310001, 42.43255320200008],
            [108.23476770000008, 42.450071513000054],
            [108.17735518400008, 42.45430898100001],
            [108.04968016700008, 42.4391196050001],
            [107.62239638400007, 42.38828605600007],
            [107.19511260100012, 42.337452507000066],
            [106.76782881800005, 42.286618958000076],
            [106.31821801850009, 42.14005167650008],
            [105.86860721900007, 41.993484395000095],
            [105.47385095200013, 41.840341289],
            [105.40274418100012, 41.811531678000065],
            [105.35819909700007, 41.78584849100007],
            [105.3445565190001, 41.781120097],
            [105.32595300400004, 41.77670176200009],
            [105.27448327700006, 41.75546274900002],
            [105.2182593180001, 41.748434754000115],
            [105.20089603700006, 41.743473816000076],
            [105.01480920400007, 41.596144308000035],
            [104.97382979400004, 41.586144918000016],
            [104.93543420400005, 41.622421774000074],
            [104.91367842700004, 41.63833811500008],
            [104.8923360600001, 41.64477183000004],
            [104.60124271700005, 41.64544362400004],
            [104.50491784700006, 41.65655405700004],
            [104.49799320500006, 41.66577830000004],
            [104.50078373200012, 41.8705978390001],
            [104.11088505050014, 41.813081970000084],
            [103.72098636900006, 41.75556610100004],
            [103.6914274500001, 41.75923512800004],
            [103.3981120205001, 41.87641143800009],
            [103.10479659100014, 41.993587748000024],
            [103.10438317900014, 41.99363942500004],
            [103.07348067300012, 42.0045173140001],
            [102.72704187066677, 42.064548103],
            [102.38060306833341, 42.12457889200003],
            [102.03416426600012, 42.184609681000026],
            [101.97421960500003, 42.20788991400006],
            [101.88647302300012, 42.27801483200001],
            [101.73537113500004, 42.461156108000054],
            [101.63759932500005, 42.51544220000001],
            [101.52494470200008, 42.53745636000009],
            [101.41073978700013, 42.54487192900011],
            [101.21871016400007, 42.529834087000026],
            [100.81813168633346, 42.578728604333335],
            [100.41755320866673, 42.62762312166676],
            [100.01697473100006, 42.67651763900007],
            [99.97155114800012, 42.6762850950001],
            [99.62190342900004, 42.59744260600006],
            [99.47447554500013, 42.56419891400007],
            [99.06835470250013, 42.603910327000065],
            [98.66223386000013, 42.643621740000086],
            [98.25611301750013, 42.68333315300008],
            [97.84999217500012, 42.72304456600001],
            [97.52163164700005, 42.755152400000085],
            [97.19327111900003, 42.78726023400007],
            [97.19067973400013, 42.78706149200006],
            [96.83266919250008, 42.75960440550007],
            [96.47465865100008, 42.732147319],
            [96.37926395700003, 42.72054596000005],
            [96.36633990100006, 42.722922619000045],
            [96.35776656100012, 42.72449920700002],
            [96.35063521400008, 42.740906474000084],
            [96.33719934100003, 42.86648020500009],
            [96.33068811000004, 42.88970876100011],
            [96.31869917800009, 42.910069275000026],
            [96.29430790200007, 42.93327199400004],
            [95.90849165900005, 43.21454681400006],
            [95.87438521400009, 43.247102966000014],
            [95.85495487500009, 43.28454254200007],
            [95.84544641200011, 43.32647796600007],
            [95.84141564900011, 43.37252166800009],
            [95.83283736200008, 43.40890187600006],
            [95.69248417200004, 43.63054209400009],
            [95.5892346600001, 43.86949391800003],
            [95.53528446500013, 43.957679748000075],
            [95.51027307200013, 43.979125468000106],
            [95.47492639200004, 43.986618551000035],
            [95.42273319500003, 43.9886339320001],
            [95.32754520700007, 44.0066690070001],
            [95.31896691900005, 44.01710764600004],
            [95.31876021300013, 44.040723776000036],
            [95.3282686770001, 44.09823964500008],
            [95.32144738800014, 44.14841746000009],
            [95.3226876220001, 44.15823598200008],
            [95.32713179500007, 44.16831288700011],
            [95.34056766800012, 44.18753652000002],
            [95.34749231000012, 44.21492502900007],
            [95.35968794800004, 44.231823222000074],
            [95.38924686800004, 44.26076202400013],
            [95.39772180200009, 44.280502422],
            [95.37942834500006, 44.2871170050001],
            [95.03681359900003, 44.25497426400007],
            [94.99381880800013, 44.259418437000065],
            [94.90576216700009, 44.294248352000025],
            [94.72086389200007, 44.33579620400012],
            [94.69822961400013, 44.343495992],
            [94.68396692000005, 44.356621806000064],
            [94.67259810400003, 44.373778382000026],
            [94.65719852700005, 44.388816224000024],
            [94.58805546100007, 44.43610015900008],
            [94.46031132000007, 44.49330596900002],
            [94.43013228400008, 44.504468079000034],
            [94.36636356600013, 44.50431305000011],
            [94.33845829300003, 44.51211619100012],
            [94.32192183400008, 44.52803253200004],
            [94.29546350100009, 44.57138905800012],
            [94.27748010200008, 44.58957916300007],
            [94.19500451700009, 44.65432973300007],
            [94.18187870300011, 44.66084096300004],
            [94.16534224500003, 44.66585357700008],
            [94.14901249200005, 44.66719716400006],
            [94.1037439370001, 44.651642558000034],
            [94.05857873600013, 44.65128082300005],
            [93.97506962100005, 44.659962464],
            [93.92742395000005, 44.672933248000035],
            [93.87450728300007, 44.71422271800013],
            [93.71400028500011, 44.874574687000106],
            [93.68826542200009, 44.89105946900007],
            [93.52527795500004, 44.95126251300003],
            [93.42058150300005, 44.955086568000084],
            [93.39991093000003, 44.96056427100008],
            [93.36136031100006, 44.978392640000024],
            [93.34099979700005, 44.984852194000055],
            [93.31722863800007, 44.98588572200005],
            [93.2689628500001, 44.98009796200007],
            [93.24415816300012, 44.98154490200007],
            [93.1657133380001, 45.00764150000005],
            [93.13915165200007, 45.009863587000055],
            [93.07594097800006, 45.00519247600003],
            [93.05243859900003, 45.00345570900002],
            [93.03311161400006, 45.00764150000005],
            [93.01388798100004, 45.009295146000014],
            [92.99445764100005, 45.008364970000045],
            [92.97492395000006, 45.00469594300007],
            [92.94505497300014, 45.00583282500007],
            [92.91621952400004, 45.01456614200005],
            [92.86102909400012, 45.037872213000085],
            [92.84759322200006, 45.0391124480001],
            [92.81421024600013, 45.033893128],
            [92.79891402200013, 45.0331696570001],
            [92.75271529200012, 45.0379755660001],
            [92.63851037600006, 45.01559967100012],
            [92.57205448400003, 45.01301584900001],
            [92.47510949800005, 44.9974612430001],
            [92.45898645000011, 44.9979263310001],
            [92.41382124900014, 45.01125885000003],
            [92.3964579680001, 45.013119202000055],
            [92.34736535700006, 45.00764150000005],
            [92.33103560400014, 45.00784820600002],
            [92.28535363800012, 45.01952708000009],
            [92.26788700400004, 45.01952708000009],
            [92.21889774600004, 45.010121969000025],
            [92.19367964700012, 45.01451446500003],
            [92.10841353400014, 45.05818105100009],
            [92.07565067500013, 45.06887807300011],
            [92.04299117000005, 45.074820862000095],
            [92.00940149000013, 45.07621612600009],
            [91.97508833800003, 45.0733739220001],
            [91.91907108600009, 45.06557078100009],
            [91.74698856600003, 45.072443746000076],
            [91.72466434700004, 45.07073842400011],
            [91.68363326000014, 45.061178284],
            [91.66296268700012, 45.05952463800007],
            [91.56395064300011, 45.07714630100004],
            [91.55227176900013, 45.07533762600006],
            [91.5432800700001, 45.071823629],
            [91.53397831200004, 45.071100159000096],
            [91.52178267400006, 45.07745636100013],
            [91.45605025300006, 45.13745269800005],
            [91.43848026500012, 45.146134339000085],
            [91.41687951700004, 45.14566925100006],
            [91.3997229410001, 45.13688425700006],
            [91.38359989500009, 45.12422353100003],
            [91.3665466710001, 45.114249980000025],
            [91.34670292200008, 45.113733216000085],
            [91.24913781800007, 45.129701233000034],
            [91.18433557100008, 45.15383412700008],
            [91.1697628170001, 45.16354929600003],
            [91.14774865700014, 45.187217103000066],
            [91.13503625500005, 45.19786244700005],
            [91.10134322100004, 45.21067820300003],
            [91.0567981370001, 45.2175511680001],
            [91.01132287600007, 45.21894643200007],
            [90.97514937400013, 45.214863994000055],
            [90.9054895430001, 45.18597686800011],
            [90.87324344900003, 45.18618357400008],
            [90.85763716600007, 45.21507069900012],
            [90.86032434100014, 45.23165883500003],
            [90.86590539600013, 45.2425625610001],
            [90.86662886600004, 45.25356964200007],
            [90.85443322800012, 45.27062286400012],
            [90.83717329900003, 45.28002797500007],
            [90.79655562400012, 45.29284373000006],
            [90.79097456900007, 45.30431589800007],
            [90.79045780500013, 45.337698873000036],
            [90.77805546000008, 45.36529408800003],
            [90.76255253200009, 45.391597392000094],
            [90.75325077400004, 45.420949606000065],
            [90.73795454900005, 45.44172353100002],
            [90.67232548100003, 45.47567494800002],
            [90.65113814300008, 45.493141581000074],
            [90.69661340400006, 45.73002634700005],
            [90.71077274600009, 45.75219553700005],
            [90.91923547300013, 45.95006459600002],
            [90.97514937400013, 45.98732330400004],
            [90.98620813000014, 45.99311106400002],
            [91.00243452900003, 46.02184316000002],
            [91.00543176300005, 46.068093567000076],
            [90.99592329900008, 46.113723857000096],
            [90.97514937400013, 46.140543925000074],
            [90.94879439300007, 46.168294170000124],
            [90.89918501800008, 46.28167226200013],
            [90.89618778500005, 46.30203277600005],
            [90.90600630700004, 46.3173031620001],
            [90.93577193200014, 46.343864848000024],
            [90.97514937400013, 46.41654775000008],
            [90.9861047770001, 46.43525461900005],
            [91.00140100200014, 46.47504547100006],
            [91.01411340300012, 46.49318390000009],
            [91.03561079900004, 46.529073181000044],
            [91.04532596900009, 46.55108734100013],
            [91.04749637900005, 46.56640940400008],
            [91.03251021300008, 46.57992279100007],
            [91.01132287600007, 46.58532297800012],
            [90.99592329900008, 46.59462473600006],
            [90.99809371000003, 46.62025624700003],
            [91.01173628700008, 46.66294097900003],
            [91.01429189300012, 46.689843915000026],
            [91.01556034300012, 46.70319692000005],
            [91.00481164500007, 46.74042979000008],
            [90.97514937400013, 46.774148661000126],
            [90.93938928200009, 46.79884999700003],
            [90.92533329300011, 46.81313853000002],
            [90.91995894400003, 46.83362823500009],
            [90.92274947100009, 46.84158640600005],
            [90.93442834500007, 46.856830953],
            [90.9364954020001, 46.864427389000056],
            [90.9327746990001, 46.87478851400009],
            [90.92585005700005, 46.88065378900008],
            [90.91768518100008, 46.88540802000007],
            [90.91014042200004, 46.89238433800007],
            [90.90032190000011, 46.910677795000126],
            [90.89370731600008, 46.92817026800007],
            [90.88512902800005, 46.94473256400009],
            [90.86983280400011, 46.96033884700002],
            [90.8494722910001, 46.973206279000024],
            [90.82818160000011, 46.98230133100007],
            [90.80554732300004, 46.98684885700003],
            [90.7818795170001, 46.98633209200007],
            [90.74239872300006, 46.99186147100009],
            [90.71211633400003, 47.0147024540001],
            [90.46872033700004, 47.30892222100003],
            [90.4663432210001, 47.31633778900006],
            [90.46851363200005, 47.32352081300009],
            [90.4752315670001, 47.33029042600005],
            [90.48556685400007, 47.34491485600002],
            [90.49001102800008, 47.361838888000094],
            [90.48722050000003, 47.378194479000044],
            [90.4752315670001, 47.39108774900005],
            [90.44815311700012, 47.40403269500008],
            [90.44174523900011, 47.430542705000065],
            [90.44360559100011, 47.462788798000034],
            [90.44122847500006, 47.49304535000006],
            [90.42727583800007, 47.50655873600003],
            [90.3946163330001, 47.524671326000046],
            [90.38159387300004, 47.53839141900009],
            [90.35203495300004, 47.58831085200005],
            [90.33849572800005, 47.60278025400008],
            [90.32743697200004, 47.62303741500007],
            [90.33746219900007, 47.63699005100007],
            [90.34955448400007, 47.6477904260001],
            [90.34480025200003, 47.65864247700004],
            [90.32350956200008, 47.67016632100008],
            [90.30211552000003, 47.67851206500005],
            [90.20971805800013, 47.69574615600003],
            [90.16341597500008, 47.71000885000011],
            [90.11995609500008, 47.73013682100007],
            [90.08285241700008, 47.75610422800004],
            [90.07065677900005, 47.76985015900006],
            [90.05877119900003, 47.78951304100012],
            [90.05215661700004, 47.81070037900007],
            [90.05598067200009, 47.82891632100002],
            [90.06435225400003, 47.85062042200012],
            [90.05985640500012, 47.868810527000065],
            [90.04461185800011, 47.87976593100005],
            [90.00249556500006, 47.880386048],
            [89.96316980000006, 47.88865427700004],
            [89.9466850180001, 47.883176575000064],
            [89.93903690700012, 47.8708517460001],
            [89.93764164300012, 47.85754506400009],
            [89.93443770300007, 47.84426422200009],
            [89.92136356600008, 47.83209442100009],
            [89.88906579600012, 47.82431711900007],
            [89.78354252100007, 47.81850352],
            [89.75129642700011, 47.82431711900007],
            [89.7402376710001, 47.836151021],
            [89.73114261900014, 47.86475392700005],
            [89.72339115400013, 47.878163961],
            [89.70726810700012, 47.889041851000044],
            [89.67202478100006, 47.89408030200012],
            [89.65528161700013, 47.89981638600007],
            [89.64391280100011, 47.912761333],
            [89.63616133700003, 47.92958201100008],
            [89.62737634300004, 47.94394806000007],
            [89.61342370600005, 47.94958079100009],
            [89.59657718900007, 47.95257802400003],
            [89.58324467000006, 47.962034811000095],
            [89.57564823400008, 47.97603912400008],
            [89.57621667500013, 47.99288564100006],
            [89.57187585500003, 48.02045501700006],
            [89.54180017100009, 48.031022848000035],
            [89.50366296400011, 48.02998931900005],
            [89.47534428000012, 48.022961325000054],
            [89.42542484500007, 48.02164357600007],
            [89.40919844600006, 48.023116354000095],
            [89.36920088700009, 48.038154195000075],
            [89.35426639900004, 48.03877431300005],
            [89.33426761900006, 48.0323664350001],
            [89.28569177200006, 48.00559804300012],
            [89.26858687400005, 47.993144023000056],
            [89.24398889200006, 47.98022491500002],
            [89.21871911700009, 47.97696930000005],
            [89.16714603700007, 47.983997295000066],
            [89.07469690000005, 47.98425567600002],
            [89.04591312600013, 47.99288564100006],
            [89.04580977400008, 47.9929889940001],
            [89.04555139200005, 47.9929889940001],
            [88.9323283280001, 48.09696197500004],
            [88.91682539900006, 48.105953675000094],
            [88.88928186100009, 48.11091461200003],
            [88.83145593300009, 48.10515269000008],
            [88.8054110110001, 48.105953675000094],
            [88.7753353270001, 48.120552267000065],
            [88.70918949400004, 48.16636342400001],
            [88.68066410300008, 48.173029683000024],
            [88.65544600500004, 48.17116933200002],
            [88.63580896000008, 48.17584604900007],
            [88.59622481300005, 48.197679342000114],
            [88.58077356000007, 48.21199371400009],
            [88.57348718300005, 48.229718730000016],
            [88.56883630400011, 48.24920074500001],
            [88.56123986800003, 48.268269349],
            [88.5587594000001, 48.288087261000086],
            [88.57297041800012, 48.325320130000094],
            [88.56511560100012, 48.34299347000008],
            [88.50269047100005, 48.392551168000054],
            [88.47912601700006, 48.400147604000026],
            [88.45912723800012, 48.398132223000076],
            [88.43964522400012, 48.39371388800008],
            [88.4167008880001, 48.39410146100009],
            [88.38342126500004, 48.40867421500003],
            [88.33210656800009, 48.45399444600007],
            [88.30487308800008, 48.46900645000004],
            [88.23562666800007, 48.493191020000026],
            [88.21784997600014, 48.494999695],
            [88.18348514900003, 48.49275177],
            [88.16596683800003, 48.49373362200005],
            [88.14829349800004, 48.49936635300007],
            [88.11573734600012, 48.51649709100003],
            [88.08824548300004, 48.52608306900005],
            [88.07181237900005, 48.5387954720001],
            [88.06251062000013, 48.542877910000115],
            [88.05196862800005, 48.543187968],
            [88.02830082200006, 48.539622294000125],
            [88.01662194900007, 48.53980316200007],
            [87.98303226800004, 48.55233469700006],
            [87.95181970200008, 48.5752015180001],
            [87.94282800400003, 48.599489441000074],
            [87.97548750900012, 48.61651682600002],
            [87.98964685000004, 48.624164937],
            [87.99781172700006, 48.63517201800009],
            [88.00339278200005, 48.64599823000002],
            [88.01016239400013, 48.653413799000035],
            [88.05501753800007, 48.67341257800008],
            [88.06385420800012, 48.68261098200007],
            [88.05941003400011, 48.70808746400009],
            [88.03377852400013, 48.729119772],
            [87.97548750900012, 48.755991516],
            [87.95243982000005, 48.761107483],
            [87.90758467600006, 48.758833720000084],
            [87.84169722500013, 48.77934926400006],
            [87.82107832900004, 48.7882892870001],
            [87.80588545800003, 48.800588278000035],
            [87.8021647540001, 48.80957997700007],
            [87.80051110900007, 48.830302226000086],
            [87.79606693600005, 48.83975901300006],
            [87.78748864800014, 48.84658030200002],
            [87.77673995000009, 48.851179505000076],
            [87.75472579000012, 48.85727732300005],
            [87.73787927300003, 48.86936960900003],
            [87.73570886300013, 48.88673289000003],
            [87.74361535700007, 48.90518137700006],
            [87.7568961990001, 48.92037424700008],
            [87.83585778800006, 48.9459024050001],
            [87.87259973200014, 48.968019918000024],
            [87.87223799700013, 49.004090068000025],
            [87.85694177200008, 49.01561391300005],
            [87.83782149300009, 49.02041982000007],
            [87.82190515100007, 49.028739726000126],
            [87.81596236200005, 49.050598857000054],
            [87.82107832900004, 49.071837870000124],
            [87.82965661700007, 49.085997213000084],
            [87.83554773000009, 49.100724997000086],
            [87.83244714400013, 49.12387603800006],
            [87.81808109500014, 49.15400339800006],
            [87.81632409700006, 49.16583730100008],
            [87.83699467000008, 49.15999786400009],
            [87.85518477400012, 49.15896433500011],
            [87.95678064000003, 49.1688862110001],
            [87.97548750900012, 49.17581085200008],
            [87.99295414200003, 49.19172719400011],
            [88.02974776300005, 49.215550029000084],
            [88.10850264500004, 49.24743438800003],
            [88.14395267700007, 49.270740459000066],
            [88.14839685100009, 49.296578675],
            [88.12917321800006, 49.32593088800006],
            [88.11553064000003, 49.35657501200008],
            [88.13578780200004, 49.38608225500012],
            [88.14560632400003, 49.39719268800003],
            [88.1617293700001, 49.430110576000075],
            [88.17475183100004, 49.4438565060001],
            [88.19996993000007, 49.45434682200006],
            [88.37877038600004, 49.47579254200009],
            [88.40192142700005, 49.47584421800009],
            [88.45111739100014, 49.46514719700009],
            [88.47540531400011, 49.46364858],
            [88.53876062100005, 49.46654246100006],
            [88.55782922400005, 49.471089986000024],
            [88.59973881000008, 49.48891835600004],
            [88.61415653500012, 49.492794088000025],
            [88.61575850500009, 49.49294911700004],
            [88.63353519700007, 49.491243795000074],
            [88.6486763910001, 49.48359568300002],
            [88.67466963800007, 49.45982452400004],
            [88.69565026900005, 49.44695709300005],
            [88.71942142800003, 49.44292633000005],
            [88.87062666800011, 49.436001689000065],
            [88.87532922300011, 49.44178945000006],
            [88.85486535600012, 49.47388051400007],
            [88.85615726700007, 49.51150095700008],
            [88.85874108900009, 49.527365622],
            [88.86819787700006, 49.53811431900003],
            [88.88892012500008, 49.54167999300007],
            [88.90835046400008, 49.535943909000125],
            [88.91909916200007, 49.523179831000064],
            [88.92695398000012, 49.50741851800008],
            [88.93759932500012, 49.492845765000126],
            [88.94757287600004, 49.48282053700008],
            [88.95470422400007, 49.47186513300004],
            [88.96266239500011, 49.46214996300007],
            [88.97532312000004, 49.45584543900007],
            [89.0140804450001, 49.460547995000056],
            [89.16073816000005, 49.502715963000085],
            [89.19525801600008, 49.521526184000024],
            [89.21561853000003, 49.54545237300003],
            [89.20156254000011, 49.570618795000044],
            [89.17820479300008, 49.59847239200012],
            [89.18735152200009, 49.62198516800002],
            [89.21644535400009, 49.63449086600009],
            [89.25220544400008, 49.629426575000124],
            [89.31070316600005, 49.593149720000085],
            [89.33943526200011, 49.58079905200002],
            [89.37193973800004, 49.581677552000045],
            [89.39782963100004, 49.59898915700005],
            [89.41860355600011, 49.62420725600002],
            [89.44159956900006, 49.64358591700007],
            [89.47534428000012, 49.643430888000026],
            [89.52030277500012, 49.66317128500002],
            [89.61631758600004, 49.68544382800006],
            [89.68230839100005, 49.70833648800006],
            [89.70241052300008, 49.719963685000025],
            [89.71264245600008, 49.735156555000046],
            [89.70153202400007, 49.75313995400005],
            [89.68370365400011, 49.76114980100003],
            [89.63895186400009, 49.775464173],
            [89.6264461670001, 49.788021546000024],
            [89.62737634300004, 49.796806539],
            [89.64194909700007, 49.808123678000086],
            [89.64355106700003, 49.8188723760001],
            [89.63895186400009, 49.82481516500012],
            [89.62107181800013, 49.83504709900011],
            [89.61533573400004, 49.84192006500005],
            [89.61528405800004, 49.8545291140001],
            [89.62107181800013, 49.89333811500005],
            [89.62386234600007, 49.90269154900007],
            [89.63321098500006, 49.907939134000046],
            [89.66768396000009, 49.927289531000056],
            [89.72070398000005, 49.939743551000035],
            [89.86643151900006, 49.942740784000065],
            [89.92017500800006, 49.95085398400006],
            [89.96942264900008, 49.967080384000084],
            [89.99624271700003, 49.992763570000065],
            [89.99709068900006, 50.003663546000055],
            [89.99872318600012, 50.024647929000096],
            [90.0049243580001, 50.05074452800001],
            [90.02053064000006, 50.07074330700003],
            [90.0512264410001, 50.08417917900009],
            [90.18243290200013, 50.10247263600006],
            [90.22294722500004, 50.1144098920001],
            [90.34387007600009, 50.174664612000086],
            [90.36392053300006, 50.17978057900005],
            [90.40495162000008, 50.18262278300004],
            [90.42500207600006, 50.186911927],
            [90.4752315670001, 50.21461049400004],
            [90.51894982900006, 50.218382874000056],
            [90.60493941300012, 50.20598053],
            [90.64845096900007, 50.20665232300006],
            [90.66643436700014, 50.210373026000084],
            [90.6839010010001, 50.216212464000066],
            [90.69971398900009, 50.2251524870001],
            [90.7126330970001, 50.237968241000075],
            [90.71738732900008, 50.25202423100008],
            [90.71759403500005, 50.28075632800001],
            [90.72658573500007, 50.29186676100004],
            [90.76244917800005, 50.30571604400008],
            [90.83996382700008, 50.32080556300009],
            [90.87706750500007, 50.33935740200012],
            [90.94858768800003, 50.39749338800003],
            [90.97514937400013, 50.41392649400008],
            [91.01204634600003, 50.42529530900008],
            [91.12976525900012, 50.42617380800003],
            [91.16335494000003, 50.43278839200009],
            [91.26009322100003, 50.4665847780001],
            [91.2975069580001, 50.46637807300003],
            [91.3821529540001, 50.45495758100013],
            [91.41574263500013, 50.46136545800006],
            [91.43248579900006, 50.478056946000024],
            [91.44003055800005, 50.498572490000086],
            [91.45036584500014, 50.519088033000045],
            [91.47506717900006, 50.53598622700004],
            [91.57573287000008, 50.56197947200012],
            [91.60270796700013, 50.57960113500009],
            [91.65314416500013, 50.64006256100002],
            [91.67960249900011, 50.656547343000014],
            [91.74977909300009, 50.68409088200009],
            [91.82419315600004, 50.70155751600005],
            [91.8999508060001, 50.70724192300007],
            [92.06273156800012, 50.686312968],
            [92.15884973100003, 50.689103495000055],
            [92.24277225800006, 50.72000600200006],
            [92.29444869000008, 50.791267803000025],
            [92.2970325120001, 50.80987131800008],
            [92.29744592300011, 50.82759633400009],
            [92.30168339100004, 50.84335764600006],
            [92.31522261600003, 50.85586334200006],
            [92.33547977700005, 50.863614808000065],
            [92.36090458200005, 50.86836904000005],
            [92.3845723880001, 50.865578512000084],
            [92.39986861200003, 50.85059234700013],
            [92.41898889200013, 50.81173167000007],
            [92.44327681500005, 50.78630686500007],
            [92.47490279200014, 50.77049387600006],
            [92.5164506430001, 50.76062367800007],
            [92.55458785000008, 50.7430020150001],
            [92.61184533700003, 50.68765655500006],
            [92.64977583900003, 50.674065653000056],
            [92.67189335100005, 50.675615947],
            [92.69525109900007, 50.6819204720001],
            [92.71736861200009, 50.69215240500007],
            [92.73524865800005, 50.70522654300002],
            [92.74661747300013, 50.721452942000056],
            [92.75343876200009, 50.75468088800007],
            [92.76026005000006, 50.77075225900005],
            [92.79612349500007, 50.788012187000035],
            [92.85772180200013, 50.79550527000005],
            [92.92107710800013, 50.79245636000003],
            [92.9616947830001, 50.77788360600006],
            [92.97399377400012, 50.74217519200006],
            [92.97337365700014, 50.69437449200008],
            [92.99187382000008, 50.65479034500002],
            [93.00293257600009, 50.63484324100001],
            [93.01140751200006, 50.62331939700009],
            [93.02287968000007, 50.61629140300006],
            [93.04262007600005, 50.60988352500003],
            [93.10494185400012, 50.59882476800003],
            [93.13915165200007, 50.599444886000086],
            [93.18834761600004, 50.59980662],
            [93.4215116790001, 50.60936676100009],
            [93.5363367110001, 50.584717103000074],
            [93.88696130400001, 50.57497609500005],
            [94.23758589700003, 50.56523508700009],
            [94.25866988200005, 50.557535299],
            [94.27334598800007, 50.54477122000013],
            [94.2782035730001, 50.529216614000106],
            [94.27975386500003, 50.49268137600008],
            [94.31975142500005, 50.429016012],
            [94.32750288900007, 50.40436635300007],
            [94.33225712100005, 50.30101348900011],
            [94.34434940600005, 50.24918202700012],
            [94.35447798700011, 50.223602193000076],
            [94.36853397600004, 50.20272491500002],
            [94.39178837100013, 50.185568340000046],
            [94.47498742700003, 50.162262268000106],
            [94.49173059100008, 50.152288717],
            [94.49855188000004, 50.139524638000026],
            [94.50227258300009, 50.1250552370001],
            [94.50909387300004, 50.10986236600006],
            [94.52087609900013, 50.09777008100009],
            [94.56397424300013, 50.07100168900011],
            [94.5744128830001, 50.05854766900002],
            [94.59229292900011, 50.02981557300002],
            [94.60345503800005, 50.01973866800007],
            [94.62453902200008, 50.015191142000035],
            [94.65099735500007, 50.01782664000005],
            [94.74639204900006, 50.040357564],
            [94.92157515500008, 50.04588694300007],
            [94.95371789500012, 50.04061594700006],
            [94.98058964100005, 50.024751282000054],
            [95.00405074100007, 49.992763570000065],
            [95.02162072800007, 49.96981923400001],
            [95.0283386640001, 49.96341135700008],
            [95.07639774600005, 49.945531311000124],
            [95.35472701000009, 49.947701721],
            [95.39978885900013, 49.938865051],
            [95.44516076700006, 49.91442209900008],
            [95.46169722600007, 49.90263987300007],
            [95.47720096200004, 49.894083165000055],
            [95.48061079900009, 49.89220123300002],
            [95.50066125500013, 49.88672353200003],
            [95.52060835800006, 49.88961741200002],
            [95.53714481600014, 49.90072784500005],
            [95.56318973800012, 49.92759958900005],
            [95.58396366400007, 49.9366946410001],
            [95.6804952390001, 49.94599639900004],
            [95.72142297400012, 49.95850209600003],
            [95.75894006400011, 49.99307362900005],
            [95.78767216000011, 50.01172882100009],
            [95.82787642400012, 50.020152079000084],
            [95.86704716000008, 50.01498443600009],
            [95.89216190700012, 49.992918600000095],
            [95.89216190700012, 49.992763570000065],
            [95.90446089700004, 49.96480662100005],
            [95.92265100100008, 49.94460113600006],
            [95.94631880700013, 49.93850331600002],
            [95.97484419800008, 49.9524559530001],
            [95.98569624800012, 49.96496165000009],
            [95.99830529800005, 49.97591705300006],
            [96.01194787600014, 49.985218811],
            [96.02662398300004, 49.99281524700005],
            [96.04099003100004, 49.99793121400005],
            [96.05597619600013, 49.998809713000085],
            [96.07106571500003, 49.99674265600002],
            [96.08594852700008, 49.992918600000095],
            [96.08605188000007, 49.99286692400007],
            [96.08625858600004, 49.99281524700005],
            [96.08636193900008, 49.992763570000065],
            [96.23560347500012, 49.9492003380001],
            [96.2811820880001, 49.92625600200007],
            [96.32335005700008, 49.89788564100006],
            [96.34629439300011, 49.88858388300004],
            [96.37285607900003, 49.886051737000045],
            [96.39910770700004, 49.891736145],
            [96.44882043500007, 49.91395701200004],
            [96.47465865100008, 49.92165679900005],
            [96.50328739400004, 49.922121887000046],
            [96.52385461400013, 49.91576568700005],
            [96.53925419100011, 49.901864726000056],
            [96.55300012300006, 49.87985056600006],
            [96.56808964000004, 49.86176381400007],
            [96.5851428630001, 49.85752634700002],
            [96.60436649600013, 49.86290069600007],
            [96.62596724500008, 49.87339101100012],
            [96.68022749900013, 49.909719544],
            [96.70193160000014, 49.91375030500008],
            [96.96920210800005, 49.88667185500013],
            [97.00589237500003, 49.86527781200003],
            [97.04227258300011, 49.82321319600008],
            [97.05725874900008, 49.81272288000004],
            [97.08526964300012, 49.805838275000085],
            [97.10015018700011, 49.80218088800008],
            [97.11989058500006, 49.793654277000044],
            [97.12898563600004, 49.775825908000016],
            [97.1529635010001, 49.75024607400006],
            [97.20505334500012, 49.734071351000054],
            [97.26231083200008, 49.7261131800001],
            [97.30168827400007, 49.72554473900006],
            [97.34333947800008, 49.73417470300008],
            [97.39077844200011, 49.74947092800004],
            [97.47459761600004, 49.78869334000011],
            [97.5427071530001, 49.822748108000056],
            [97.57360966000005, 49.847501119000086],
            [97.58125777200013, 49.877938538000066],
            [97.57174930800005, 49.89674875900006],
            [97.56317102000003, 49.90894439700007],
            [97.56658166500006, 49.9167992150001],
            [97.64223596200003, 49.930028381000014],
            [97.73359989500005, 49.95834706700002],
            [97.7563375250001, 49.96149932900006],
            [97.77752486200006, 49.956176656000096],
            [97.81070113200008, 49.931165263000096],
            [97.8299247650001, 49.92331044600009],
            [97.84739139800007, 49.93008005800003],
            [97.87457320200014, 49.95395457000011],
            [97.90619917800012, 49.97307485],
            [98.04799930800004, 50.02304596000009],
            [98.10556685400007, 50.06387034100008],
            [98.26245650200013, 50.283805237000124],
            [98.26927779200008, 50.29941152000008],
            [98.27227502400012, 50.318996888000086],
            [98.27010461500004, 50.335946758],
            [98.26183638600008, 50.36746938100005],
            [98.26628055800006, 50.40069732700009],
            [98.29821659400005, 50.46012522400004],
            [98.3005937100001, 50.492784729],
            [98.30069706200004, 50.49283640600002],
            [98.30069706200004, 50.492939759000066],
            [98.29346236200007, 50.518622946000036],
            [98.27537561100013, 50.53769154900003],
            [98.25129439300008, 50.550558981],
            [98.22555953000011, 50.55763865200002],
            [98.16334110500003, 50.56466664600005],
            [98.13595259600004, 50.57097117100007],
            [98.06009159300004, 50.60890167300006],
            [98.03849084500007, 50.622957663000065],
            [98.02329797400006, 50.64202626600006],
            [97.97451542100009, 50.723158264000105],
            [97.94402632700013, 50.77447296200005],
            [97.94743697100006, 50.795970358],
            [97.99022505800008, 50.835606181000045],
            [97.98464400300003, 50.84692332000013],
            [97.95301802600005, 50.86283966100005],
            [97.9387553310001, 50.87441518200011],
            [97.92966027800003, 50.88661082000003],
            [97.91942834500003, 50.89741119400004],
            [97.87198938000006, 50.917099915],
            [97.83571252400009, 50.94071604500003],
            [97.80853072100007, 50.97048166900002],
            [97.8063603110001, 51.00112579400003],
            [97.87012902900005, 51.08680531800012],
            [97.88563195800003, 51.12011077900006],
            [97.89472701000011, 51.15385548900012],
            [97.90030806500005, 51.16842824300009],
            [97.92904016200004, 51.21504038500005],
            [97.93172733600005, 51.230414124000035],
            [97.9281099860001, 51.251472270000065],
            [97.91632775900007, 51.2858887740001],
            [97.91570764200003, 51.30061655700011],
            [97.92283899000006, 51.31847076500004],
            [97.93379439300003, 51.33177744600006],
            [97.96221643100006, 51.355445252],
            [97.97451542100009, 51.36859690300007],
            [98.02061080000004, 51.435181986000075],
            [98.03973108000014, 51.457299500000076],
            [98.05089318900013, 51.46642039000007],
            [98.06670617700013, 51.46926259400003],
            [98.1113546150001, 51.48471384700012],
            [98.13781294800009, 51.485876567000034],
            [98.22039188600007, 51.475205383000045],
            [98.2299003500001, 51.49287872300003],
            [98.23382775900006, 51.51652069100005],
            [98.22431929600009, 51.56000640900008],
            [98.22824670400013, 51.583415833000046],
            [98.23868534400009, 51.601476746000046],
            [98.26338667800007, 51.63519561800011],
            [98.27351525900013, 51.65483266200006],
            [98.33221968600009, 51.7183171600001],
            [98.42503055800012, 51.746222433000085],
            [98.61871382700014, 51.780664775000034],
            [98.6513733320001, 51.79748545300002],
            [98.68268925000012, 51.819473776000066],
            [98.71111128700005, 51.84510528600005],
            [98.77663700400012, 51.93011301700004],
            [98.79172652200003, 51.977500306000124],
            [98.80020145700013, 51.99274485300005],
            [98.83854537000008, 52.02527516700009],
            [98.84650354100012, 52.039331157000035],
            [98.84888065700005, 52.056306865000025],
            [98.84960412600009, 52.09012909000002],
            [98.85559859200009, 52.10669138600012],
            [98.88639774600006, 52.12855051700005],
            [98.92763553900005, 52.12958404600003],
            [98.93765156300003, 52.12468748800008],
            [98.96246545500003, 52.11255666100003],
            [98.9744543870001, 52.080388082000084],
            [98.99471154800011, 52.05829640700007],
            [99.02509729100007, 52.045532329000096],
            [99.19873010300012, 52.00659413700002],
            [99.23283654800008, 51.99424347000006],
            [99.25598759000007, 51.97791371700002],
            [99.27469445800006, 51.95949106900012],
            [99.29536503100007, 51.9435488890001],
            [99.32389042200003, 51.93422129400007],
            [99.55684777900012, 51.89145904600004],
            [99.67932092300009, 51.88866851900009],
            [99.70965498900006, 51.880581156000076],
            [99.78396569900013, 51.837612203],
            [99.8486645910001, 51.78934641500008],
            [99.91791101100011, 51.74947804800006],
            [100.00596765200004, 51.731727193000054],
            [100.09826175900014, 51.7386518360001],
            [100.21029626500007, 51.72622365400004],
            [100.51089807200003, 51.72689544700002],
            [100.57110111500003, 51.704803772000034],
            [100.63890059500005, 51.69203969300007],
            [101.06946862800004, 51.553443502],
            [101.11701094600005, 51.52783783000005],
            [101.1587655030001, 51.52122324600005],
            [101.2007267670001, 51.52091318800005],
            [101.24155114700005, 51.5151771040001],
            [101.27968835500013, 51.49259450400005],
            [101.31544844600006, 51.463604025000095],
            [101.35017500800006, 51.4504523720001],
            [101.3877954510001, 51.45055572500006],
            [101.48205326400011, 51.47287994400001],
            [101.52639164300007, 51.4758255010001],
            [101.56985152200008, 51.47008941700004],
            [101.64369714400004, 51.45009063800002],
            [101.69661381100013, 51.45244191500005],
            [101.72369226100005, 51.45058156300006],
            [101.74219242400011, 51.4448454800001],
            [101.79531579600012, 51.41939483700007],
            [101.82177413000011, 51.413581239000095],
            [101.9018726000001, 51.41706939800004],
            [101.92068282100007, 51.41303863500006],
            [101.95561609000009, 51.39378916500003],
            [101.97421960500003, 51.38722625800004],
            [102.05121748900007, 51.383608908000056],
            [102.07467858900003, 51.37482391400006],
            [102.09126672400004, 51.3646436560001],
            [102.1838708900001, 51.323896790000035],
            [102.19337935400011, 51.307205303],
            [102.17927168800009, 51.28643137600004],
            [102.13529504400003, 51.2402843230001],
            [102.1337964270001, 51.23085337400006],
            [102.13968754100011, 51.22093149900006],
            [102.14764571200004, 51.20263804200009],
            [102.15002282800003, 51.18540395100008],
            [102.14878259300008, 51.16878997800008],
            [102.1421680090001, 51.13483856200007],
            [102.14650883000007, 51.09763153100006],
            [102.16537072800008, 51.057556458000064],
            [102.19198409100011, 51.02058197000012],
            [102.21937259900005, 50.99265085900002],
            [102.22965620900004, 50.979266663],
            [102.23105147300004, 50.964900615],
            [102.22557377100003, 50.95074127200003],
            [102.21523848500004, 50.93818389900012],
            [102.23947473100003, 50.912294007000085],
            [102.23187829600005, 50.884750469000025],
            [102.21275801600007, 50.85674184200009],
            [102.20304284700012, 50.82935333300007],
            [102.21678877800014, 50.798864237000075],
            [102.24567590400011, 50.77876210500001],
            [102.30753259300008, 50.748221334],
            [102.32939172400006, 50.71881744500003],
            [102.32024499500005, 50.69613149000007],
            [102.29683557200008, 50.67494415300011],
            [102.2759066160001, 50.65019114200008],
            [102.27156579700005, 50.62094228100004],
            [102.28241784700009, 50.59060821600009],
            [102.30293339000008, 50.563891500000025],
            [102.32763472600004, 50.54554636600004],
            [102.37269657400003, 50.53366078800012],
            [102.47186364800007, 50.52492747000004],
            [102.51310144100006, 50.50368845700008],
            [102.58658532800013, 50.41527008100006],
            [102.6177978930001, 50.399302063],
            [102.6195294150001, 50.399009150000026],
            [102.76259525600005, 50.37480743500005],
            [102.8871354580001, 50.3149661260001],
            [102.92739139800011, 50.302977193000046],
            [102.97410689300011, 50.295639140000034],
            [103.13001469000005, 50.309126689000024],
            [103.20168990100007, 50.296982727000014],
            [103.24018884300011, 50.2443761200001],
            [103.25310795100012, 50.21497223000004],
            [103.27677575700005, 50.197557272],
            [103.30659305800003, 50.19042592400005],
            [103.40710371900008, 50.19729888900012],
            [103.43872969600005, 50.192596334000044],
            [103.47397302300004, 50.18200266500007],
            [103.53391768400013, 50.153787334000086],
            [103.60140710400009, 50.13353017200011],
            [103.66806970300007, 50.131204733000075],
            [103.78527185100012, 50.1861367800001],
            [103.84542321800006, 50.18468984000002],
            [103.97399418100008, 50.14872304300003],
            [104.0395198980001, 50.14117828400008],
            [104.12168542500012, 50.14825795500009],
            [104.19811486900011, 50.17001373300012],
            [104.24746586100008, 50.20660064800005],
            [104.26896325700005, 50.2288731900001],
            [104.32136316000009, 50.25429799400011],
            [104.34950155100006, 50.27186822],
            [104.37722538200006, 50.28917958600009],
            [104.40580245000012, 50.300548401000086],
            [104.4741186930001, 50.313260803000034],
            [104.57695479300003, 50.309488424],
            [104.61044112100012, 50.31419097900009],
            [104.63245528200008, 50.32375111900008],
            [104.67188440000012, 50.34829742400005],
            [104.69705082200005, 50.35320668600009],
            [104.78955163600011, 50.35263824500002],
            [104.81849043800003, 50.35832265300009],
            [104.8790035400001, 50.383902486000025],
            [104.90158614100005, 50.38979360000003],
            [104.93424564700013, 50.39325592100006],
            [105.0501042080001, 50.383489075000014],
            [105.07821618700012, 50.385142721000065],
            [105.10575972600003, 50.390051982],
            [105.13133955900008, 50.39806182900007],
            [105.24073856600006, 50.45800649100006],
            [105.27846236200003, 50.4725792440001],
            [105.32864017800006, 50.476454977000074],
            [105.63937056500009, 50.42193634100006],
            [105.77925866800007, 50.42891265900006],
            [105.80654382300003, 50.42436513300002],
            [105.85470625800008, 50.41092926000006],
            [105.90421228000014, 50.40379791300005],
            [105.95805912300006, 50.403591207000076],
            [105.98487919200005, 50.399767151000034],
            [106.03893273900007, 50.37139679000002],
            [106.04327356000005, 50.36478220600013],
            [106.04327356000005, 50.355532125000124],
            [106.04446211800007, 50.346023661000046],
            [106.04818282100007, 50.33811716700008],
            [106.05593428600008, 50.33356964200006],
            [106.13530928600005, 50.327110088],
            [106.16094079600009, 50.31961700500007],
            [106.20119673700003, 50.299721578000046],
            [106.22228072100006, 50.29238352500006],
            [106.24486332200013, 50.29026479100007],
            [106.43978682500006, 50.32793691000002],
            [106.54820398000004, 50.335791728000046],
            [106.65651778200004, 50.32700673500007],
            [106.74617639200011, 50.30742136700006],
            [106.78829268400006, 50.291505026000024],
            [106.93644901600004, 50.209132792000034],
            [106.97365604700013, 50.19636871300007],
            [106.9826994230001, 50.187118632000065],
            [106.99799564600005, 50.149808248000014],
            [107.00605717000013, 50.140196432000025],
            [107.0262109790001, 50.12572703100007],
            [107.03360070800011, 50.118802388000105],
            [107.03923343900004, 50.10826039700002],
            [107.04843184400005, 50.08464426700003],
            [107.05711348500012, 50.074102275000044],
            [107.07029097500009, 50.0662474570001],
            [107.10072839300005, 50.05679067000004],
            [107.11462935500003, 50.05048614600004],
            [107.16449711100006, 50.018860169000035],
            [107.19219567900012, 50.00604441400007],
            [107.22490686100008, 49.997052715],
            [107.25487919200003, 49.998913066000014],
            [107.28040734900009, 50.00759470600009],
            [107.30485030200003, 50.01002349900004],
            [107.3640714930001, 49.97612376000002],
            [107.72932051600003, 49.97193796900008],
            [107.74460414500004, 49.967352880000064],
            [107.7505078530001, 49.965581767000074],
            [107.78693973800011, 49.948218486000044],
            [107.8079203690001, 49.94387766600006],
            [107.83918461100006, 49.94656484000011],
            [107.85096683800009, 49.946048076000054],
            [107.89819909700003, 49.935506084000096],
            [107.94651656100007, 49.93349070300006],
            [107.95649011200004, 49.923362122000086],
            [107.95261438000011, 49.89747222900006],
            [107.9443978270001, 49.880419006000025],
            [107.93550948100005, 49.86662139900007],
            [107.9300317790001, 49.851428528000056],
            [107.9323572190001, 49.830292868000114],
            [107.95003055800004, 49.78249216800002],
            [107.95576664300006, 49.745543518],
            [107.95483646700012, 49.73277943900011],
            [107.94935876500011, 49.72063547800012],
            [107.92682784100003, 49.68286000600004],
            [107.92744795800007, 49.67004425100008],
            [107.93948856700007, 49.66322296200012],
            [107.9628979900001, 49.66110422800004],
            [108.00279219600003, 49.66317128500002],
            [108.01581465700008, 49.65572987900008],
            [108.00754642800013, 49.633612366000065],
            [108.00527266500012, 49.61779937700008],
            [108.01571130400004, 49.60224477200005],
            [108.03266117300006, 49.589325663000025],
            [108.10619673700006, 49.554340719000024],
            [108.12645389900007, 49.54715769400006],
            [108.20991133600012, 49.54023305300008],
            [108.2363696700001, 49.532481588000095],
            [108.25052901200007, 49.52240468300006],
            [108.2595207110001, 49.50964060500009],
            [108.26727217600012, 49.495842997000025],
            [108.2771423750001, 49.482510478],
            [108.33486495000005, 49.43636342400008],
            [108.47366784700006, 49.356419983000066],
            [108.53805668100006, 49.32742950500007],
            [108.5699726530001, 49.325718884000125],
            [108.6084399830001, 49.32365712600004],
            [108.75106693500004, 49.341175436000114],
            [108.85896732600008, 49.34055531800006],
            [108.93048750800011, 49.348823548],
            [109.03296187300003, 49.32789459300001],
            [109.05802494400007, 49.32908315100012],
            [109.16060266100004, 49.34665313700002],
            [109.28669315600007, 49.338539938000096],
            [109.31191125500004, 49.332545472000064],
            [109.33630253100006, 49.32334706600007],
            [109.39097619600011, 49.309291077000054],
            [109.41123335800012, 49.30319325800009],
            [109.45071415200005, 49.30593210900004],
            [109.46208296700013, 49.30045440700006],
            [109.46570031700003, 49.29445994100011],
            [109.46983443300007, 49.276631572000085],
            [109.4743819580001, 49.26913848900004],
            [109.49184859200005, 49.262782288000025],
            [109.51623986800007, 49.25590932300004],
            [109.72852665200003, 49.266451315000026],
            [109.78495731600009, 49.2513617960001],
            [109.8177201740001, 49.22774566700009],
            [109.83218957500003, 49.226867168000055],
            [109.9131148680001, 49.21368967700006],
            [110.1814189050001, 49.1619615690001],
            [110.22503381400003, 49.165372213000055],
            [110.26833866400011, 49.17705108600002],
            [110.30936975100008, 49.19586130800003],
            [110.34543990100008, 49.22061431900006],
            [110.36104618400009, 49.23461863200005],
            [110.37117476400005, 49.24174998000008],
            [110.38223352000006, 49.24004465800003],
            [110.43328983600003, 49.20263092100008],
            [110.45127323500003, 49.19456939800007],
            [110.50822066300009, 49.18433746400008],
            [110.60361535700008, 49.145321757],
            [110.64495650200013, 49.13674347000007],
            [110.68805464700006, 49.13452138300006],
            [110.73135949700003, 49.13767364600001],
            [110.84101688700008, 49.16242665700004],
            [110.96555708800003, 49.20738515200007],
            [111.13856978400008, 49.29156606000002],
            [111.27354862500005, 49.32283030200004],
            [111.29173872900009, 49.330788472000094],
            [111.32098759000013, 49.355334778000056],
            [111.33845422400009, 49.36473988900012],
            [111.36274214800005, 49.36763376900011],
            [111.38506636600005, 49.36225942000003],
            [111.42961145100003, 49.34639475500002],
            [111.4545194910001, 49.34308746400002],
            [111.47911747300009, 49.34334584600002],
            [111.50350874800012, 49.34706654900002],
            [111.6164734300001, 49.38644399000002],
            [111.66101851400003, 49.39636586500011],
            [112.03019494700004, 49.41186879500002],
            [112.12640515100009, 49.43994041000009],
            [112.43223758900007, 49.5291742970001],
            [112.47326867800012, 49.53413523400003],
            [112.58426965400008, 49.52633209300002],
            [112.67139611900012, 49.49594635000007],
            [112.70147180200001, 49.491295472],
            [112.73371789600009, 49.492794088000025],
            [112.77712609900004, 49.50137237500003],
            [112.86807662000007, 49.531654766000074],
            [112.92616093000004, 49.56653635700003],
            [112.94734826700011, 49.57609649700005],
            [112.96977583800003, 49.583021139000024],
            [112.9928235270001, 49.58715525400005],
            [113.0436731370001, 49.588602194000046],
            [113.06082971200016, 49.59599192300006],
            [113.07157841000009, 49.617747701000056],
            [113.07416223200005, 49.65335276300003],
            [113.07715946500008, 49.669010722000095],
            [113.087494751, 49.68740753200008],
            [113.15674117000003, 49.777376201000024],
            [113.18268274000008, 49.80197418200002],
            [113.21244836500006, 49.82202463800006],
            [113.41553674400012, 49.92238027000003],
            [113.44230513500008, 49.946048076000054],
            [113.45853153600001, 49.95726186200001],
            [113.51041467300001, 49.981033020000055],
            [113.52788130700003, 49.99281524700005],
            [113.57966109200004, 50.01994537400013],
            [113.7522603760001, 50.07859812400007],
            [113.77313765500008, 50.081647034000085],
            [113.81582238800002, 50.07689280200002],
            [113.83680301900006, 50.07694447900012],
            [113.84982548000005, 50.08071685800006],
            [113.97312544800002, 50.16050527000003],
            [113.99327925600011, 50.16867014600005],
            [114.03513716700007, 50.17693837500009],
            [114.05529097500005, 50.18381134000005],
            [114.11823287000004, 50.22437734000009],
            [114.2000883390001, 50.25621002200005],
            [114.28628462800009, 50.27688059500004],
            [114.33300012300003, 50.27233306900011],
            [114.42498417200011, 50.24184397400002],
            [114.47304325400006, 50.234040833],
            [114.65969852800009, 50.251404114000124],
            [114.75374963400014, 50.236211243000085],
            [114.99735233600012, 50.144330547000024],
            [115.01523238200008, 50.13285837800002],
            [115.02804813700004, 50.119887594],
            [115.04964888500001, 50.09084543900009],
            [115.06339481700007, 50.077512920000075],
            [115.21015588400013, 49.971679586000036],
            [115.36869917900003, 49.895405172],
            [115.38781945900013, 49.891064352000015],
            [115.45014123500005, 49.89142608700011],
            [115.47298221900013, 49.88708526600003],
            [115.50853560400003, 49.88677520800006],
            [115.578195434, 49.8936481730001],
            [115.68340865100004, 49.87768015600007],
            [115.71627486200015, 49.877783509000025],
            [115.75089807200004, 49.88496653300005],
            [116.05361861200004, 49.9984479780001],
            [116.135370728, 50.01441599600004],
            [116.21763960800007, 50.01384755500008],
            [116.30052860600011, 49.992970277000026],
            [116.57544722500006, 49.92176015300005],
            [116.61720178200005, 49.89731720000002],
            [116.65337528500004, 49.86383087200004],
            [116.68427779200016, 49.8232648730001],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Vietnam',
        iso3: 'VNM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [107.52039270000006, 14.704581605000016],
              [107.52225305200005, 14.71868927000014],
              [107.51465661700013, 14.728223572000047],
              [107.50442468300014, 14.736285095000127],
              [107.49806848200012, 14.74594858900005],
              [107.50928226700006, 14.758635152000096],
              [107.5043213300001, 14.773182068000054],
              [107.49429610200008, 14.78876251300008],
              [107.49088545800004, 14.804239604000088],
              [107.49884362900013, 14.817649638000134],
              [107.54059818500008, 14.856846212000079],
              [107.55532596900008, 14.876199036000045],
              [107.55816817300013, 14.886715190000103],
              [107.54964156100004, 14.895267640000029],
              [107.4894901940001, 14.940303650000061],
              [107.4737805580001, 14.948235982000114],
              [107.46194665600007, 14.956814270000052],
              [107.45393680900003, 14.96787302600005],
              [107.44990604700013, 14.98110219300014],
              [107.45140466300012, 14.995933329000081],
              [107.44468672700003, 15.011823833000093],
              [107.44556522700003, 15.02538889600008],
              [107.45507369000012, 15.03412221300006],
              [107.4737805580001, 15.035750021000098],
              [107.50238603900004, 15.044037437000028],
              [107.51899743600012, 15.048849996000058],
              [107.5352238370001, 15.05040028900008],
              [107.56261234600004, 15.045801087000115],
              [107.57801192200003, 15.047248027000109],
              [107.58907067900003, 15.058177592000092],
              [107.59000085500008, 15.068900452],
              [107.58080245000008, 15.086935527],
              [107.58049239100012, 15.096754049000069],
              [107.58498824100013, 15.10429880800011],
              [107.59919926000009, 15.114789124000069],
              [107.60540043200007, 15.120602722000058],
              [107.61578739400011, 15.1355113730001],
              [107.6213167730001, 15.154528300000067],
              [107.62359053600011, 15.187239482000052],
              [107.62725956300011, 15.196515402000074],
              [107.63671635000009, 15.205067851000095],
              [107.6426074630001, 15.20245819100009],
              [107.64746504800007, 15.197652283000082],
              [107.65397627800007, 15.199564311000103],
              [107.65681848200006, 15.205687969000067],
              [107.66436324000011, 15.25315277100006],
              [107.66410485900013, 15.268552348000057],
              [107.65759362800003, 15.282427470000115],
              [107.6430725510001, 15.297852885000111],
              [107.59847578900008, 15.33061574300011],
              [107.58659021000005, 15.343353984000075],
              [107.57987227400014, 15.361234030000034],
              [107.57770186400006, 15.399629619000066],
              [107.57635973700013, 15.403053568000118],
              [107.57315433800011, 15.411230977000116],
              [107.55558435100005, 15.415752665000042],
              [107.51264123600009, 15.409422302000024],
              [107.49393436700007, 15.42004180900011],
              [107.48964522300002, 15.437921855000056],
              [107.49016198700008, 15.46151214600009],
              [107.48747481300012, 15.481407572000094],
              [107.4737805580001, 15.488254700000041],
              [107.46654585800013, 15.48435312900007],
              [107.4608097740001, 15.484378967000097],
              [107.45646895400012, 15.488332214000067],
              [107.45336836800004, 15.49590281200004],
              [107.44789066600009, 15.508124288000047],
              [107.44298140500013, 15.509209494000046],
              [107.43796879100006, 15.505592143000044],
              [107.4321293540001, 15.503886821],
              [107.41223392800009, 15.508796082000018],
              [107.40505090300013, 15.508589376000074],
              [107.3949740000001, 15.501483867000033],
              [107.3886694740001, 15.492518005000093],
              [107.38164147900005, 15.488538920000039],
              [107.36934248900013, 15.496057841000052],
              [107.31642582200004, 15.588739523000058],
              [107.30355839000003, 15.599746603000042],
              [107.2654211840001, 15.61866017700008],
              [107.24872969600005, 15.631088358000042],
              [107.23911787900005, 15.645118510000074],
              [107.23457035300004, 15.660931498000068],
              [107.23002282800007, 15.702401836000135],
              [107.2256820070001, 15.716819560000047],
              [107.21529504400007, 15.727516581000046],
              [107.16025964400012, 15.75872914600005],
              [107.14878747600011, 15.773456930000052],
              [107.1501827400001, 15.794282532000082],
              [107.1752458090001, 15.848542786000039],
              [107.18625288900006, 15.859394837000096],
              [107.19860355700013, 15.862082011000027],
              [107.20883549000013, 15.859136454000023],
              [107.21808557100013, 15.854795634000041],
              [107.22723230000003, 15.853297018000134],
              [107.23565555900012, 15.855519104000038],
              [107.30505700700007, 15.899134013],
              [107.32293705300003, 15.905851950000013],
              [107.36107425900008, 15.912311504000073],
              [107.37554366000012, 15.9190811160001],
              [107.39063317900013, 15.935824280000062],
              [107.41802168800007, 15.983573303000028],
              [107.43269779500014, 15.995923971000067],
              [107.44473840300003, 16.0099799610001],
              [107.44354984600011, 16.018919984000135],
              [107.43672855600005, 16.0268781540001],
              [107.4321293540001, 16.038298645000097],
              [107.43329211500003, 16.0554609980001],
              [107.43342126500005, 16.057367248000062],
              [107.43564335200006, 16.068839417000092],
              [107.43104414900012, 16.0736970010001],
              [107.41151045700008, 16.07307688400006],
              [107.35590661600008, 16.059279276],
              [107.32686446200012, 16.056075338000127],
              [107.29895918800003, 16.06418853800004],
              [107.27591150000006, 16.084032288000017],
              [107.23880782100008, 16.12981760600006],
              [107.21281457600003, 16.146664123000036],
              [107.19715661600003, 16.15100494400012],
              [107.18320398000009, 16.153227030000025],
              [107.1696647550001, 16.156896057000026],
              [107.15436853100005, 16.166042786],
              [107.14201786300009, 16.176998189000088],
              [107.13599030600005, 16.18478378400006],
              [107.13333622300013, 16.188211975000044],
              [107.12749678600011, 16.200976054000094],
              [107.11685144100005, 16.25461619000008],
              [107.10827315300003, 16.267483623000075],
              [107.08910119600012, 16.28107452400006],
              [107.07060103400005, 16.290014547000098],
              [107.06798023900012, 16.290809443000043],
              [107.05339278200006, 16.295233866],
              [107.01432539900009, 16.29941965700006],
              [106.98021895400012, 16.298334453000038],
              [106.96729984600012, 16.299884745000057],
              [106.95655114800007, 16.307067769000028],
              [106.9540706790001, 16.313837383000063],
              [106.95066003400007, 16.33631663100006],
              [106.94600915500013, 16.346135153000134],
              [106.93949792500013, 16.351716207000052],
              [106.91500329600007, 16.3647386680001],
              [106.89774336800008, 16.37853627500003],
              [106.88844161000009, 16.390886943000098],
              [106.8762976490001, 16.41801707000006],
              [106.87283532700013, 16.41734527600009],
              [106.86653080200011, 16.414037984000075],
              [106.85986454300013, 16.411815898000086],
              [106.85588545700011, 16.414658102000047],
              [106.85588545700011, 16.420342509000093],
              [106.85821089700005, 16.424631653000077],
              [106.86136315900012, 16.42788726900004],
              [106.86260339400013, 16.430574443000083],
              [106.86684086200012, 16.46385406500012],
              [106.86405033400013, 16.504058330000035],
              [106.84668705300004, 16.530051575000115],
              [106.82286421800006, 16.530981751000056],
              [106.80141849800003, 16.496100159],
              [106.79733606000013, 16.479460347000057],
              [106.78612227400009, 16.469125061000042],
              [106.75914717600006, 16.452485250000038],
              [106.7545996500001, 16.4442686980001],
              [106.75439294400013, 16.436568909000115],
              [106.75253259300013, 16.429024150000046],
              [106.75151087800009, 16.428268290000048],
              [106.74240401200007, 16.421531067000032],
              [106.73248213700009, 16.417551982000035],
              [106.72571252500006, 16.417138571000024],
              [106.72256026200012, 16.421634420000046],
              [106.72266361500004, 16.432486471000104],
              [106.69289799000006, 16.42788726900004],
              [106.67067712400012, 16.44442372600004],
              [106.65517419500009, 16.470830384000024],
              [106.6411698820001, 16.510362854000064],
              [106.63967126500006, 16.52178334600005],
              [106.64432214400006, 16.575320129000104],
              [106.6401880300001, 16.586637268000075],
              [106.62494348100006, 16.59351023400005],
              [106.61155928600004, 16.59459543900006],
              [106.59140547700008, 16.60245025600007],
              [106.57244022700013, 16.613560689000096],
              [106.54975427300013, 16.637796936000072],
              [106.54065922100006, 16.65913930300009],
              [106.53507816600006, 16.683530579000106],
              [106.53355047300005, 16.95063806000003],
              [106.5334245200001, 16.97266021700007],
              [106.5245361740001, 16.989248353000065],
              [106.49683760600004, 16.963926901],
              [106.47373824100009, 16.97069651300005],
              [106.4565299890001, 16.973590393000038],
              [106.43720300300009, 16.98046335800008],
              [106.42025313300007, 16.988679912000023],
              [106.41136478700002, 16.99570790700004],
              [106.41136478700002, 16.995811259000064],
              [106.40883264200005, 17.005371399000055],
              [106.40401984100004, 17.014641771000058],
              [106.38712854000005, 17.047177633000032],
              [106.38790368700006, 17.051673482000027],
              [106.39436324100012, 17.062215474000098],
              [106.39493168100006, 17.068003235000063],
              [106.38464807100007, 17.085366516000093],
              [106.33653731300012, 17.128568014000038],
              [106.30635827700013, 17.17652374300006],
              [106.30082889900012, 17.19156158500006],
              [106.30165572100003, 17.202000224000088],
              [106.30976892200005, 17.21791656500001],
              [106.31054406800007, 17.227114970000102],
              [106.30697839400005, 17.232954407000094],
              [106.29312911000011, 17.246907043000093],
              [106.28796146600013, 17.253780010000057],
              [106.28568770400011, 17.265975647000076],
              [106.28666955600005, 17.27656931600005],
              [106.28455082300007, 17.28478586800007],
              [106.27261356600013, 17.28985015900004],
              [106.2599528400001, 17.289230042000085],
              [106.2547851970001, 17.283183899000036],
              [106.25235640500006, 17.2745539350001],
              [106.24791223200003, 17.26623402900013],
              [106.23339115400006, 17.25197133400006],
              [106.22181563400005, 17.244891663000132],
              [106.20729455600008, 17.2462869270001],
              [106.18543542500004, 17.257397360000127],
              [106.01929569500004, 17.394494934000093],
              [105.93232426000009, 17.495729065000077],
              [105.93216923100005, 17.495729065000077],
              [105.91113692300013, 17.51681305000001],
              [105.84602461800006, 17.597996725000073],
              [105.81987634300003, 17.62156117800008],
              [105.7874235430001, 17.642076722000056],
              [105.73528202400007, 17.664039205000037],
              [105.72308638500004, 17.67349599300009],
              [105.71383630400004, 17.68946400900002],
              [105.7012272550001, 17.7276012170001],
              [105.69202884900011, 17.744085999000063],
              [105.66980798400004, 17.77307647700006],
              [105.64396976700004, 17.820102031000104],
              [105.60521244300003, 17.854260153],
              [105.59415368700007, 17.888108215],
              [105.60603926600004, 17.96412424800006],
              [105.60343050400013, 17.96918391700011],
              [105.58981286600005, 17.995595194000103],
              [105.58981286600005, 17.995750224000048],
              [105.5661450610001, 18.008255920000053],
              [105.55932377100004, 18.015335592000056],
              [105.55555139200004, 18.02515411400013],
              [105.55188236500004, 18.047943420000124],
              [105.54650801700006, 18.058950501000126],
              [105.53813643500007, 18.066727804000024],
              [105.52066980000012, 18.07590037100003],
              [105.51250492300011, 18.082825013],
              [105.49607181900006, 18.118145854000105],
              [105.49198938000006, 18.12106557200009],
              [105.48062056500004, 18.123649394],
              [105.4760213620001, 18.127318421],
              [105.47684818600004, 18.12964386000003],
              [105.47912194900005, 18.13349375400007],
              [105.48118900500003, 18.13871307400008],
              [105.48087894700012, 18.14481089300004],
              [105.47281742300004, 18.17199269700005],
              [105.4667196040001, 18.180958558000057],
              [105.45142338100004, 18.192714946000066],
              [105.43137292500006, 18.200543925000076],
              [105.41003055900006, 18.201887512000056],
              [105.39199548300007, 18.19421356200006],
              [105.3861043710001, 18.184937642000065],
              [105.38155684500003, 18.162768453000027],
              [105.37747440600003, 18.155688782000098],
              [105.36832767800013, 18.149952698000035],
              [105.36553715000008, 18.151037903000045],
              [105.36331506400006, 18.15522369400007],
              [105.35592533400006, 18.15873769100004],
              [105.34011234500008, 18.1626392620001],
              [105.32187056500004, 18.170080669000114],
              [105.3055924890001, 18.1810619110001],
              [105.29505049700003, 18.195608826000054],
              [105.29437870300006, 18.206951803000024],
              [105.30083825700012, 18.23092966700004],
              [105.29928796500008, 18.242040100000068],
              [105.29251835100007, 18.252737122000084],
              [105.28802250200005, 18.253408916000055],
              [105.28311324100008, 18.250179138000064],
              [105.25691977000008, 18.24746373600003],
              [105.24647465100003, 18.24638092100004],
              [105.23593265800008, 18.249455669000085],
              [105.22926639800005, 18.255320944000076],
              [105.2204814050001, 18.270798035000084],
              [105.21474532100012, 18.2778518680001],
              [105.16616947400013, 18.30679067000007],
              [105.15666101100004, 18.319838969],
              [105.15598921700007, 18.340638733000063],
              [105.16224206600003, 18.353893738000053],
              [105.16286218300013, 18.366011861000047],
              [105.14544722500011, 18.383168437],
              [105.11397627800005, 18.405130920000076],
              [105.09077356000012, 18.42652496300009],
              [105.07997318600007, 18.454352722000053],
              [105.08524418200005, 18.495771383000104],
              [105.10048872900006, 18.551168519000058],
              [105.11361454300004, 18.580830790000036],
              [105.12813562100007, 18.598917542000024],
              [105.1403312590001, 18.600467834000042],
              [105.15206180900009, 18.59679880800006],
              [105.16208703600012, 18.598194072000027],
              [105.16947676600012, 18.61485972100006],
              [105.16947676600012, 18.61832716700009],
              [105.16947676600012, 18.630569356000038],
              [105.16286218300013, 18.63899261500002],
              [105.14110640500013, 18.65307444300005],
              [105.1126843670001, 18.698342998000058],
              [105.10028202300003, 18.702063701000057],
              [105.08865482600004, 18.700565084000047],
              [105.07697595200005, 18.697516175000104],
              [105.06457360900004, 18.696637675000076],
              [105.04033736200012, 18.70500925800006],
              [104.99015954600009, 18.733017884000063],
              [104.97382979400004, 18.73606679300009],
              [104.95687992400013, 18.731674297],
              [104.93724287900011, 18.73115753200007],
              [104.91972456900004, 18.735575867000065],
              [104.90923425300008, 18.7456786100001],
              [104.89936405400005, 18.770612488000083],
              [104.87290572100005, 18.777976380000084],
              [104.81538985200012, 18.77366139700011],
              [104.80164392100005, 18.775134176],
              [104.76288659700003, 18.786451314000075],
              [104.72195886300011, 18.792006531000098],
              [104.71027998900007, 18.796088969000024],
              [104.70252852400006, 18.80247100800004],
              [104.69084965000008, 18.819317525000102],
              [104.68557865500003, 18.824769389],
              [104.67565677900006, 18.828205872000026],
              [104.65632979300011, 18.829704489000036],
              [104.64620121300004, 18.832546692],
              [104.63121504700007, 18.842365215000072],
              [104.60398156700006, 18.868694357000024],
              [104.58966719600005, 18.879107157000064],
              [104.55607751500003, 18.896470439000083],
              [104.54429528800006, 18.906805725000098],
              [104.50987878500007, 18.95636342400006],
              [104.49768314700009, 18.967990621000112],
              [104.48093998200005, 18.97770579000006],
              [104.46212976100003, 18.982408346000042],
              [104.4310722250001, 18.979333598],
              [104.41324385600007, 18.983105977000022],
              [104.40073815900013, 18.99227854400003],
              [104.37200606400006, 19.033568014000124],
              [104.35515954700008, 19.047882385000023],
              [104.33913985200013, 19.055194601000025],
              [104.32198327700013, 19.060465597000032],
              [104.30286299700003, 19.068656312000073],
              [104.28725671400008, 19.08049021400008],
              [104.27433760600007, 19.0934609990001],
              [104.25991988100009, 19.104054668000074],
              [104.25960326300009, 19.104129804000067],
              [104.23955936700003, 19.108886414],
              [104.21062056500011, 19.100747376000086],
              [104.2018355720001, 19.10917063400008],
              [104.20173221900006, 19.127050680000124],
              [104.19811486900011, 19.14694610600013],
              [104.18783125900012, 19.15658376100005],
              [104.1477303470001, 19.182887065],
              [104.03672937000005, 19.23024851500007],
              [104.01616215000007, 19.23487355500002],
              [103.99518151900003, 19.233840027000056],
              [103.97399418100008, 19.225287577000117],
              [103.97275394700006, 19.225287577000117],
              [103.94314335100012, 19.245596415000037],
              [103.91797692900008, 19.258153788000058],
              [103.91094893400009, 19.263011373000083],
              [103.90588464400008, 19.27003936800007],
              [103.89265547700012, 19.293888041000073],
              [103.87673913600008, 19.295800069000066],
              [103.85854903200004, 19.295334981000067],
              [103.8484204510001, 19.299908346000095],
              [103.85674035700004, 19.317194112],
              [103.87002120000005, 19.32688344300003],
              [103.90588464400008, 19.34179209400007],
              [103.92128422100006, 19.352773336000055],
              [103.94102461800003, 19.38135040300004],
              [103.95280684400012, 19.39096221900003],
              [103.97399418100008, 19.395664775000014],
              [103.99668013600007, 19.406930237000083],
              [104.02039961800011, 19.414991761000053],
              [104.03512740100012, 19.416671244000028],
              [104.03827966400007, 19.412924703],
              [104.03879642800013, 19.41338979100003],
              [104.04654789300008, 19.427497457000058],
              [104.04990686100012, 19.43747100800006],
              [104.05404097500013, 19.460570374000056],
              [104.06050052900008, 19.471293234000072],
              [104.07052575800003, 19.477029317000117],
              [104.08127445500003, 19.479303080000037],
              [104.0899560960001, 19.483669739000035],
              [104.09414188700003, 19.49552948000006],
              [104.09398685700012, 19.495581157000075],
              [104.0825146890001, 19.509301250000092],
              [104.0792590740001, 19.52570851600005],
              [104.07796716400003, 19.542890930000013],
              [104.07155928500009, 19.559143169000023],
              [104.06019047100011, 19.568160706000086],
              [104.02892623000014, 19.586040752000045],
              [104.0173507080001, 19.600406800000044],
              [103.99766198800012, 19.652522482],
              [103.99518151900003, 19.664898987000058],
              [104.00096927900012, 19.68073781300008],
              [104.01027103700005, 19.684561869],
              [104.02174320500006, 19.681435445000048],
              [104.06969893400009, 19.6580260220001],
              [104.08871586200007, 19.651902364000037],
              [104.10923140500006, 19.65487375900004],
              [104.1171895760001, 19.660997417000104],
              [104.12447595200007, 19.67590606700007],
              [104.13124556500003, 19.682443136000032],
              [104.13630985600003, 19.687455750000098],
              [104.15816898600013, 19.687739970000067],
              [104.20020338600006, 19.698586072000055],
              [104.22896569900007, 19.706007589000038],
              [104.24214318800006, 19.695181376000093],
              [104.27702478100014, 19.683890076000026],
              [104.29526656100006, 19.65487375900004],
              [104.34187870300013, 19.683011577000073],
              [104.36001713100006, 19.687455750000098],
              [104.38006758600005, 19.685285340000107],
              [104.39174646000009, 19.676836243000096],
              [104.40125492400006, 19.66443389900003],
              [104.41541426700013, 19.650817159000056],
              [104.42378584800008, 19.645778707000076],
              [104.4491073000001, 19.635159200000075],
              [104.50584802300011, 19.602809753000102],
              [104.52279789300013, 19.59937327100006],
              [104.54615564000005, 19.601931254000064],
              [104.55483728000013, 19.605445252000024],
              [104.57023685700011, 19.615289612000097],
              [104.57922855600003, 19.61802846300013],
              [104.58780684400006, 19.615961406000068],
              [104.60496342000005, 19.606478780000103],
              [104.61426517700005, 19.60743479500006],
              [104.62305017100005, 19.618080139000043],
              [104.65477950100006, 19.697971904000056],
              [104.66304773000013, 19.711226908000057],
              [104.67596683800014, 19.72468861900002],
              [104.69167647400008, 19.735463155000033],
              [104.70418217000008, 19.738692932000035],
              [104.71777307200006, 19.74019154900013],
              [104.73673832200012, 19.745669251000024],
              [104.76071618700007, 19.766520691000082],
              [104.78521081600013, 19.77693349200011],
              [104.8050028890001, 19.7908861290001],
              [104.81507979400004, 19.82240875300006],
              [104.8168884690001, 19.83899688700008],
              [104.81663008600003, 19.84809194000003],
              [104.80924035700014, 19.853672994000064],
              [104.79027510600008, 19.859667460000097],
              [104.76071618700007, 19.861450297000076],
              [104.75554854400013, 19.86700551300008],
              [104.76180139200005, 19.885505677000097],
              [104.78066328900007, 19.90808827800005],
              [104.83533695500012, 19.93888743100011],
              [104.85791955600007, 19.955217184000063],
              [104.86716963700007, 19.969143982000034],
              [104.86902998900007, 19.977748108000057],
              [104.8738358970001, 19.982657369000023],
              [104.89290450100009, 19.98549957300007],
              [104.9224634200001, 19.982243958000097],
              [104.93569258700012, 19.98415598600012],
              [104.94568809100014, 19.992373264000022],
              [104.94949019400013, 19.995498963],
              [104.95321089700008, 20.009270732000047],
              [104.95145389900006, 20.021518046000054],
              [104.94830163600011, 20.033662008000064],
              [104.9464412850001, 20.05218800900009],
              [104.94365075700006, 20.06094716400007],
              [104.94396081600013, 20.067096659000057],
              [104.9474748130001, 20.069525452],
              [104.96116906800012, 20.072109274000113],
              [104.96442468300012, 20.076088359],
              [104.95687992400013, 20.09179799400006],
              [104.91838098200009, 20.11572418200005],
              [104.90489343200005, 20.134637757000107],
              [104.90344649300005, 20.157091166],
              [104.90897587100005, 20.1678140260001],
              [104.90799401900006, 20.175332947000058],
              [104.81916223200005, 20.22098907500005],
              [104.77880293800007, 20.21902537000004],
              [104.7335860600001, 20.204762675000055],
              [104.69084965000008, 20.1965461220001],
              [104.65705326400007, 20.212695007000022],
              [104.65302250200011, 20.225794983000057],
              [104.65198897400012, 20.24610382100009],
              [104.65353926600005, 20.266464336000112],
              [104.6573633220001, 20.2796159870001],
              [104.66583825700008, 20.28571380600006],
              [104.67410648600003, 20.28530039500005],
              [104.68185795100004, 20.28747080500004],
              [104.68862756400006, 20.301035869000103],
              [104.68929935800003, 20.310001729000035],
              [104.68769738800012, 20.321706442000036],
              [104.68464847900009, 20.33304941900009],
              [104.68092777600009, 20.34098175000007],
              [104.66640669800012, 20.3517821250001],
              [104.62842452000012, 20.365812277000103],
              [104.61230147300012, 20.376741842000072],
              [104.58935713800008, 20.40681752600004],
              [104.57550785300003, 20.414052226000123],
              [104.43236413600005, 20.411054992000103],
              [104.39153975500005, 20.42066680900011],
              [104.35981042500003, 20.439735413000093],
              [104.36642500900012, 20.45849395800009],
              [104.4236824950001, 20.49544260700013],
              [104.42378584800008, 20.49544260700013],
              [104.44497318500004, 20.53461334200007],
              [104.46967452100006, 20.51616485700005],
              [104.4958227950001, 20.511927389],
              [104.52073083500005, 20.519265442000105],
              [104.54264164200009, 20.53569854800007],
              [104.60723718300005, 20.619052632000106],
              [104.61407088800007, 20.642615605000074],
              [104.6151953530001, 20.646492819000073],
              [104.60072595200006, 20.660548808],
              [104.54388187700005, 20.678738912000128],
              [104.49230879700013, 20.702096660000066],
              [104.47566898600007, 20.718219706000056],
              [104.46616052300004, 20.74963897700009],
              [104.45262129700006, 20.763591614000077],
              [104.43215743000007, 20.765762024000068],
              [104.4093164470001, 20.76519358400013],
              [104.38905928600008, 20.770981343000088],
              [104.38166955600008, 20.778371074000106],
              [104.37334965100013, 20.795734354000032],
              [104.36797530100006, 20.80312408500002],
              [104.36032719000008, 20.80808502200007],
              [104.34466923000008, 20.813666077000093],
              [104.33634932500007, 20.819040426000058],
              [104.3232235110001, 20.833871562000084],
              [104.30720381700013, 20.864619039000033],
              [104.29526656100006, 20.879811910000072],
              [104.28787683200005, 20.885754700000078],
              [104.27893680900007, 20.891542460000053],
              [104.2690666100001, 20.89619333900002],
              [104.26002323400013, 20.89893219100007],
              [104.25056644700004, 20.898260397000072],
              [104.22803552300013, 20.892317607000066],
              [104.22105920500013, 20.89200754800008],
              [104.21754520700006, 20.897020162000032],
              [104.20710656700004, 20.917639059000052],
              [104.20126713100007, 20.925442200000063],
              [104.19387740100012, 20.92988637300006],
              [104.1654036870001, 20.939756571000046],
              [104.1547583410001, 20.941255188000056],
              [104.13207238800004, 20.941668600000085],
              [104.12261560100006, 20.943167216000077],
              [104.11424401900013, 20.94704294900005],
              [104.09915450000011, 20.95768829400002],
              [104.09228153500004, 20.961202291000077],
              [104.05667647300004, 20.95882517500003],
              [104.01058109600012, 20.90807891900006],
              [103.97399418100008, 20.902342834000095],
              [103.96231530800003, 20.902704570000097],
              [103.95218672700008, 20.900275778000022],
              [103.93213627200004, 20.89180084300004],
              [103.85860070800004, 20.869579976000082],
              [103.85048750800013, 20.86477406900009],
              [103.83575972500006, 20.852268371],
              [103.82681970200008, 20.847669169000127],
              [103.81669112200007, 20.84689402300002],
              [103.79643396000006, 20.849529521000036],
              [103.78532352700012, 20.84596384700008],
              [103.77555668200006, 20.834905091000067],
              [103.76516971900008, 20.816249899000084],
              [103.75674646000004, 20.795992737000077],
              [103.75302575700005, 20.779869690000012],
              [103.75519616700007, 20.75940582300005],
              [103.7586068120001, 20.749742330000018],
              [103.75457605000008, 20.74292104100006],
              [103.73437056500006, 20.730932109000022],
              [103.72201989700005, 20.726849671000096],
              [103.71344161000007, 20.72576446500001],
              [103.70724043800004, 20.72183705700006],
              [103.70238285300007, 20.70871124300008],
              [103.70362308800003, 20.699254456000105],
              [103.71375166900009, 20.679824117000024],
              [103.71426843300003, 20.67171091800013],
              [103.70848067200006, 20.666749980000063],
              [103.69762862100009, 20.66153066100007],
              [103.6854329840001, 20.657654928000014],
              [103.67633793200014, 20.6565180460001],
              [103.66538252800007, 20.65827504500008],
              [103.66114506000008, 20.66075551400006],
              [103.65794112100014, 20.664734599000028],
              [103.6360303140001, 20.682821350000054],
              [103.59737634300006, 20.722353821000084],
              [103.57794600500006, 20.73289581300004],
              [103.51614099200009, 20.745349833000134],
              [103.5160893150001, 20.745556539000077],
              [103.50596073500003, 20.745969951000106],
              [103.49733077000008, 20.74834706700004],
              [103.48937260000014, 20.75248118100008],
              [103.48162113500013, 20.75790720600004],
              [103.47087243700008, 20.770877991000063],
              [103.45257898000011, 20.804312643000046],
              [103.44043501800013, 20.81573313500006],
              [103.42658573400007, 20.820694072000023],
              [103.42131473900014, 20.81811025000009],
              [103.41826582900012, 20.8118057250001],
              [103.41123783400008, 20.805604553000094],
              [103.39087732000007, 20.794752503000055],
              [103.38911460100013, 20.794288275000028],
              [103.3637988690001, 20.787621155000025],
              [103.3583211670001, 20.78772450800004],
              [103.34767582200004, 20.78906809500002],
              [103.31982222500005, 20.7978530890001],
              [103.2633915610001, 20.82637847900004],
              [103.24711348500011, 20.83071930000004],
              [103.23812178600014, 20.829892476000012],
              [103.22582913700012, 20.826412811000054],
              [103.21858809400004, 20.824363098],
              [103.20690922000006, 20.824569804000063],
              [103.19709069800012, 20.827825420000053],
              [103.18365482600007, 20.837075501000058],
              [103.17523156800007, 20.841209615000068],
              [103.16505131100007, 20.843690084000045],
              [103.14696456000007, 20.846015524000094],
              [103.13637089000008, 20.8504596960001],
              [103.13001469000005, 20.85490387],
              [103.11528690600005, 20.868391419000076],
              [103.08670983900004, 20.9019811000001],
              [103.0682096760001, 20.931281636000065],
              [103.03710046400005, 20.9954637660001],
              [103.0145178630001, 21.04052561500005],
              [102.99916996300004, 21.05737213200011],
              [102.97410689300011, 21.067655742000014],
              [102.95948246300003, 21.065795390000105],
              [102.95157596900009, 21.06899932900008],
              [102.9468217370001, 21.075872294000035],
              [102.94217085800005, 21.084863994000088],
              [102.93529789200005, 21.102382304000045],
              [102.92588454400004, 21.140639764000113],
              [102.92563440000004, 21.141656392000115],
              [102.91442061400011, 21.15839955600005],
              [102.90418868000012, 21.164187317000128],
              [102.89592045100005, 21.164549052000027],
              [102.88909916200004, 21.16640940300003],
              [102.88300134300005, 21.176434632000067],
              [102.88300134300005, 21.186098124000083],
              [102.89178633700004, 21.205993551000077],
              [102.89297489400008, 21.21508860300007],
              [102.88785892800007, 21.226922506000065],
              [102.87814375900007, 21.237619527000092],
              [102.86512129800008, 21.24619781600002],
              [102.85018680900004, 21.251675517000095],
              [102.82817264900007, 21.252450663000033],
              [102.80915572100008, 21.25059031200003],
              [102.80130090300008, 21.254827779000053],
              [102.81277307200008, 21.273896383000036],
              [102.82915450100012, 21.2858853150001],
              [102.86300256400006, 21.29379181000006],
              [102.87519820200004, 21.30531565400007],
              [102.87881555200005, 21.322162171000045],
              [102.87964237500006, 21.36789581300009],
              [102.88382816600011, 21.38835968000005],
              [102.91679773000004, 21.438640849000095],
              [102.91803796400006, 21.45011301700002],
              [102.90418868000012, 21.45269683900004],
              [102.88475834200005, 21.444066874000086],
              [102.86475956200013, 21.432181295000063],
              [102.8496700450001, 21.425411682000018],
              [102.89499027600004, 21.4952782190001],
              [102.91659102400007, 21.51357167600007],
              [102.95410811400006, 21.55728993800004],
              [102.97410689300011, 21.57532501200005],
              [102.97493371600007, 21.57816721600001],
              [102.97529545100014, 21.581009420000086],
              [102.97493371600007, 21.583903300000074],
              [102.97410689300011, 21.586693827000133],
              [102.96413334200008, 21.608604635000077],
              [102.96082605000004, 21.632840881000064],
              [102.96175622600009, 21.701518860000036],
              [102.95989587400004, 21.713042705000063],
              [102.95602014200011, 21.723946431000016],
              [102.94780358900005, 21.737123922000094],
              [102.94263594600005, 21.7389842730001],
              [102.93700321500006, 21.735056865000033],
              [102.86450118000005, 21.705652975000064],
              [102.84718957500013, 21.70446441700004],
              [102.83514896700007, 21.716453349000076],
              [102.83189335200007, 21.73578033500003],
              [102.8349422610001, 21.775622864000056],
              [102.82646732600011, 21.821304830000074],
              [102.80672692900004, 21.8360842900001],
              [102.78915694200009, 21.82032297800002],
              [102.78667647300011, 21.739914449000068],
              [102.77468754100005, 21.707875061000053],
              [102.75215661600004, 21.680899964000034],
              [102.72115075700009, 21.661676331000095],
              [102.71029870600006, 21.659299215000047],
              [102.65743371600007, 21.658420716000123],
              [102.6534546310001, 21.656301982000045],
              [102.65066410300005, 21.657800598000065],
              [102.64332605000004, 21.668032532000026],
              [102.6368148200001, 21.683638815000066],
              [102.63190555900013, 21.706273092000018],
              [102.62978682500005, 21.729114075000027],
              [102.63459273300009, 21.787766826000066],
              [102.62513594600011, 21.828642883000057],
              [102.59102950100004, 21.901351624000128],
              [102.56023034700007, 21.925432841000074],
              [102.51589196800012, 21.939178772],
              [102.47806482000004, 21.957575583],
              [102.46638594600006, 21.995351054000068],
              [102.46731612200011, 21.999226786000023],
              [102.46907312000008, 22.00284413700011],
              [102.4712435300001, 22.005996399000068],
              [102.47408573400008, 22.008890280000045],
              [102.48287072800014, 22.02139597600005],
              [102.46762618000008, 22.03400502500007],
              [102.44261478700008, 22.047440898000033],
              [102.42215091900005, 22.062220358000033],
              [102.41522627800009, 22.0734858200001],
              [102.4054077560001, 22.098290508000034],
              [102.39879317200013, 22.108884176000018],
              [102.38943973800008, 22.11710072800004],
              [102.35807214400006, 22.13472239200003],
              [102.2864486090001, 22.20004140300007],
              [102.22624556500011, 22.228411764],
              [102.20697025600009, 22.245413310000018],
              [102.20056237800003, 22.265463766000053],
              [102.18619633000003, 22.27838287400006],
              [102.16888472500005, 22.289648336000127],
              [102.15436364700008, 22.30468617800001],
              [102.15281335500009, 22.310835673000085],
              [102.15612064700008, 22.32266957600011],
              [102.15612064700008, 22.32809560200006],
              [102.15286503100009, 22.33248809800007],
              [102.14418339000014, 22.33858591700003],
              [102.14139286300008, 22.342151591000103],
              [102.13136763600005, 22.373725891000063],
              [102.12542484500011, 22.383647766000067],
              [102.11865523300008, 22.39754872600004],
              [102.12883549000003, 22.410881246000073],
              [102.14702559400007, 22.421061503000132],
              [102.16454390500007, 22.425505676000043],
              [102.18655806500004, 22.421061503000132],
              [102.20355961100006, 22.41248321500011],
              [102.2180290120001, 22.410674540000016],
              [102.23130985600011, 22.426332500000072],
              [102.23663252800003, 22.443437398000114],
              [102.24252364200004, 22.477182109000083],
              [102.25254886900007, 22.495475566000053],
              [102.37688236500003, 22.615571595000077],
              [102.38432377100008, 22.628852437000077],
              [102.38246342000008, 22.63081614200003],
              [102.37858768800004, 22.639084371000067],
              [102.37269657400003, 22.64575063100007],
              [102.3633431400001, 22.65143503800003],
              [102.35626346800007, 22.658721415000016],
              [102.35585005700005, 22.669935201000058],
              [102.36272302300011, 22.677428283],
              [102.37316166200003, 22.67835845900005],
              [102.38463383000004, 22.677738343000087],
              [102.39496911700007, 22.680528870000032],
              [102.4072681070001, 22.693447978000037],
              [102.41522627800009, 22.7098294070001],
              [102.42561324100006, 22.745176087000104],
              [102.42561324100006, 22.745305278000032],
              [102.44271814000012, 22.765174866000038],
              [102.46778121000006, 22.76858551000005],
              [102.49434289600009, 22.76039479600003],
              [102.51578861500008, 22.745176087000104],
              [102.52633060700003, 22.72595245400008],
              [102.52891442900005, 22.707814026000037],
              [102.53578739400012, 22.695825094],
              [102.55836999500008, 22.694946595000047],
              [102.56575972500008, 22.699545797],
              [102.57035892700003, 22.70709055600004],
              [102.5761983650001, 22.713808493000087],
              [102.58668868000007, 22.716082256000092],
              [102.59118453000008, 22.712568258000132],
              [102.60611901900012, 22.696703593000038],
              [102.61247522000008, 22.691587626000043],
              [102.63226729400003, 22.684973043000056],
              [102.67216149900008, 22.67835845900005],
              [102.69272871900006, 22.6705036420001],
              [102.75189823400007, 22.625286764000023],
              [102.77122522000008, 22.617793681000094],
              [102.81339318800013, 22.608698629000017],
              [102.83184167500008, 22.599706930000067],
              [102.8451741940001, 22.585237529000054],
              [102.85313236500014, 22.568442689000065],
              [102.85928186100011, 22.550510966],
              [102.89369836400004, 22.487362366000056],
              [102.90258671100008, 22.47723378500008],
              [102.9195882570001, 22.469223938000127],
              [102.95653690600005, 22.45971547400005],
              [102.9890930580001, 22.437597962000027],
              [103.00893680900009, 22.43031158500004],
              [103.02903894100007, 22.43015655500001],
              [103.04505863500009, 22.440543518000126],
              [103.04908939600011, 22.45682159400006],
              [103.04485192900006, 22.4728929650001],
              [103.04418013600008, 22.486483867000018],
              [103.05828780100006, 22.495475566000053],
              [103.07441084800007, 22.49816274000007],
              [103.09125736500005, 22.50508738200007],
              [103.14200362100013, 22.537798564000056],
              [103.14572432500006, 22.54555002900007],
              [103.14469079600008, 22.55578196300003],
              [103.13259851100008, 22.569786276000045],
              [103.13001469000005, 22.57795115100005],
              [103.14174524000009, 22.60704498300008],
              [103.16846195500011, 22.626475321000058],
              [103.22840661600003, 22.655827536000018],
              [103.2448913980001, 22.66869496700012],
              [103.25248783400008, 22.67856516500011],
              [103.2699544680001, 22.723265279000046],
              [103.30964196800011, 22.78793833400003],
              [103.32157922400012, 22.790392965000095],
              [103.34416182500007, 22.782977397000067],
              [103.35708093300008, 22.776026917000067],
              [103.36875980700006, 22.767138570000057],
              [103.37894006300013, 22.756777446000044],
              [103.38751835200003, 22.745176087000104],
              [103.4017293710001, 22.737838033000102],
              [103.40400313400005, 22.723885397000018],
              [103.4023494870001, 22.706522115],
              [103.40431319200013, 22.68879709900007],
              [103.41092777500012, 22.674741109000067],
              [103.44751469000005, 22.61825876900012],
              [103.47314620000003, 22.59164540600007],
              [103.48544519000006, 22.584100647000028],
              [103.5036352950001, 22.581413473000012],
              [103.5142806400001, 22.587356262000114],
              [103.54621667500004, 22.631436259000097],
              [103.55091923000003, 22.640789694000134],
              [103.54992302200003, 22.64866216800003],
              [103.54456302900013, 22.691019185000087],
              [103.5471468500001, 22.70068267900011],
              [103.56833418800005, 22.724970602000027],
              [103.57680912300009, 22.740835267000122],
              [103.58254520700012, 22.755795593000087],
              [103.59003829000005, 22.76801707],
              [103.60383589700012, 22.776026917000067],
              [103.64693404200005, 22.799048768000134],
              [103.65850956200006, 22.79320933000004],
              [103.72641239500012, 22.716288961000046],
              [103.79421187400004, 22.659444886000088],
              [103.80532230700004, 22.647404277000035],
              [103.80966312700014, 22.638722636000082],
              [103.82966190600007, 22.609163717000044],
              [103.8363281660001, 22.60275583900001],
              [103.84418298400004, 22.599293519000057],
              [103.86681726100005, 22.575419007000065],
              [103.87265669800007, 22.573610332000086],
              [103.88867639200004, 22.571749980000064],
              [103.89461918200004, 22.56921783500009],
              [103.90278405800007, 22.55857249000009],
              [103.91704675300014, 22.533251038000017],
              [103.92541833500007, 22.528238424000065],
              [103.94071455900007, 22.52467275],
              [103.95094649200013, 22.516456197000068],
              [103.95952478000004, 22.507102763000105],
              [103.97399418100008, 22.515267639000044],
              [103.9853629970001, 22.527153219000056],
              [103.98737837800013, 22.540175680000104],
              [103.98556970200013, 22.554541728000103],
              [103.98556970200013, 22.57025136400007],
              [103.99006555200009, 22.58534088100008],
              [104.0033980710001, 22.614951477000105],
              [104.00748051000011, 22.630247701000073],
              [104.01394006400005, 22.691019185000087],
              [104.02381026300003, 22.719182841000034],
              [104.04473921800013, 22.745176087000104],
              [104.05404097500013, 22.753754374000025],
              [104.06597823100009, 22.77401153600003],
              [104.07331628500009, 22.78266733900007],
              [104.08685551000008, 22.791555685],
              [104.09905114800006, 22.794604594000035],
              [104.12819665500007, 22.796826681000127],
              [104.21325606300007, 22.8250161750001],
              [104.24116133700011, 22.824396057000016],
              [104.23309981300008, 22.80481069000011],
              [104.22875899300004, 22.783442485000094],
              [104.22968916800005, 22.761945089000065],
              [104.23682051600008, 22.74207550100006],
              [104.24948124200006, 22.728329570000128],
              [104.30441328900008, 22.704661764],
              [104.32523889200013, 22.692517802000097],
              [104.34017338100011, 22.68636830600012],
              [104.35546960500005, 22.68864206900004],
              [104.36191128100012, 22.69253554600006],
              [104.44900394700005, 22.745176087000104],
              [104.46864099200008, 22.764864807000052],
              [104.5333398840001, 22.8143966680001],
              [104.55121993000012, 22.832845154000026],
              [104.55354537000005, 22.836049093],
              [104.56238203900006, 22.834395447000034],
              [104.56269209900006, 22.82984792100011],
              [104.56124515800008, 22.824396057000016],
              [104.56465580200006, 22.819951884000105],
              [104.57049524000007, 22.816257019000105],
              [104.57447432400005, 22.812277934000022],
              [104.57922855600003, 22.808867290000094],
              [104.58842696200003, 22.80685190900006],
              [104.59426639800012, 22.80902231800006],
              [104.60444665500012, 22.820210266000075],
              [104.60982100500007, 22.823000794000038],
              [104.6290446380001, 22.82077870700003],
              [104.66273767200005, 22.810934346000053],
              [104.6832015390001, 22.812174581000093],
              [104.70077152500005, 22.818246562000056],
              [104.71534427900013, 22.82708323200005],
              [104.72821171100003, 22.839098002000114],
              [104.76288659700003, 22.884728292000105],
              [104.77420373600012, 22.89622629800003],
              [104.82360640500013, 22.92413157200012],
              [104.82794722500012, 22.934156799000036],
              [104.82701704900006, 22.954284770000115],
              [104.79792321800005, 23.085568746],
              [104.81146244300004, 23.09618825300008],
              [104.8359053960001, 23.099753926000048],
              [104.86127852400006, 23.119597677000044],
              [104.86551599200004, 23.133472799000103],
              [104.86675622600006, 23.14946665500004],
              [104.87006351800005, 23.16354848200008],
              [104.8808638920001, 23.171713359000094],
              [104.8947648520001, 23.170343933000126],
              [104.9210164800001, 23.15577117900007],
              [104.93507246900003, 23.15427256300005],
              [104.9452010500001, 23.159827779000054],
              [104.98142622900014, 23.19036855100005],
              [105.01568770300003, 23.206827494000024],
              [105.04664188700013, 23.22682627400006],
              [105.06105961100008, 23.23245900500008],
              [105.14239831500004, 23.25374969500008],
              [105.14591231300011, 23.256695252000085],
              [105.1477726650001, 23.260881043000026],
              [105.15035648600013, 23.264756775000066],
              [105.15562748200006, 23.266849670000042],
              [105.1584180100001, 23.26576446600005],
              [105.16580773900012, 23.26057098400004],
              [105.16896000200006, 23.259434103000032],
              [105.17660811400003, 23.257754619000067],
              [105.18244755100005, 23.254421488000062],
              [105.1895788980001, 23.252199402000073],
              [105.20089603700006, 23.25400807700005],
              [105.21753584900006, 23.26535105500004],
              [105.22389205000007, 23.281706645000085],
              [105.22766442900013, 23.300646057000037],
              [105.23593265800008, 23.31979217600012],
              [105.24554447500009, 23.330179138000048],
              [105.28006433200005, 23.358782044000023],
              [105.29365523300004, 23.366275127000065],
              [105.3121553960001, 23.36581003900004],
              [105.32006189000003, 23.35433787],
              [105.32435103400007, 23.336742045000037],
              [105.33225752800013, 23.317957662000126],
              [105.34403975500004, 23.30418589300008],
              [105.35964603700006, 23.291551005000045],
              [105.37571740700014, 23.281499939000028],
              [105.38951501500003, 23.275427958000066],
              [105.3991268310001, 23.274885356000127],
              [105.40667159100008, 23.277469177000043],
              [105.41447473200009, 23.278476868],
              [105.4258952240001, 23.273205872000077],
              [105.43085616100012, 23.267805685],
              [105.4439819750001, 23.24514556900006],
              [105.46434248900005, 23.206000672000116],
              [105.47385095200013, 23.194502665000087],
              [105.5171558020001, 23.167734273000107],
              [105.52132535800013, 23.163147762000037],
              [105.52826623600009, 23.1555127970001],
              [105.53482914300008, 23.136263327000066],
              [105.53523999500004, 23.0990127780001],
              [105.53529423100008, 23.094095358000104],
              [105.53968672700012, 23.075466003000045],
              [105.55157230700013, 23.05967885400004],
              [105.56599003100007, 23.054097799000132],
              [105.63683841900007, 23.051333110000073],
              [105.66495039900013, 23.04337493900003],
              [105.69032352700003, 23.043969218000072],
              [105.70071049000006, 23.037819722],
              [105.71967574100012, 23.01960378100007],
              [105.73161299700007, 23.014229431],
              [105.74324019400012, 23.01079294800006],
              [105.75471236200013, 23.005676982000082],
              [105.76582279400003, 22.995470886000092],
              [105.76582279400003, 22.99531585700005],
              [105.7660295010001, 22.99516082800004],
              [105.76613285400003, 22.99516082800004],
              [105.77936202000012, 22.976118062000054],
              [105.83568933100003, 22.917232768000062],
              [105.85387943500007, 22.904649556000024],
              [105.86225101700006, 22.907750143000058],
              [105.86659183800003, 22.91506235800007],
              [105.87010583500006, 22.923098043000053],
              [105.87599694900007, 22.928265687000035],
              [105.88664229400007, 22.929764303000056],
              [105.90369551600003, 22.9255009970001],
              [105.9132039800001, 22.92438995400009],
              [105.94482995600009, 22.927697246],
              [105.96121138500013, 22.932399801000074],
              [105.97397546400009, 22.939892884000088],
              [105.98999515800006, 22.970614523000066],
              [105.99924524000005, 22.97536875400006],
              [106.07758671000005, 22.981027324000067],
              [106.13210534700005, 22.975007019000046],
              [106.1700358490001, 22.96601532000001],
              [106.20238529400007, 22.946998393000044],
              [106.22300419100009, 22.912375183000037],
              [106.22708663000009, 22.87555572600003],
              [106.23401127200003, 22.86385101300006],
              [106.25540531400009, 22.85465260900004],
              [106.27659265200003, 22.851035258000067],
              [106.29638472500011, 22.851112773000082],
              [106.31566003400013, 22.8537999470001],
              [106.4579769290001, 22.888965759000072],
              [106.47373824100009, 22.89710479700007],
              [106.47797570900013, 22.91960988400008],
              [106.48779423100012, 22.925423483000074],
              [106.50117842600014, 22.921702780000075],
              [106.51693973800013, 22.915424093000055],
              [106.56696252400013, 22.9037710570001],
              [106.58169030800013, 22.89527028400009],
              [106.59171553500005, 22.880878398000064],
              [106.59915694200009, 22.864987895000056],
              [106.61037072800013, 22.852869771000073],
              [106.63274662300012, 22.849614156000072],
              [106.63987797000004, 22.853386536000087],
              [106.64793949400013, 22.86697743800009],
              [106.65682784000006, 22.869974670000104],
              [106.66747318500012, 22.86752004000003],
              [106.67439782700012, 22.861473897000096],
              [106.68514652500005, 22.848218893000094],
              [106.71491215100014, 22.826101379000093],
              [106.7310351970001, 22.800108134000126],
              [106.73036340400012, 22.797627665000064],
              [106.74509118700013, 22.797188416000026],
              [106.76844893400005, 22.79922963500009],
              [106.78984297700009, 22.797188416000026],
              [106.79873132300008, 22.784372660000045],
              [106.79149662300011, 22.77212534600004],
              [106.75847538300007, 22.75421946200005],
              [106.74664148000005, 22.744349263000075],
              [106.73956180800013, 22.726779277],
              [106.73553104700011, 22.695411682000085],
              [106.72659102400007, 22.67727325500006],
              [106.70509362800004, 22.646112366000082],
              [106.69770389900003, 22.630867818000056],
              [106.68018558800009, 22.57944976800006],
              [106.66788659700006, 22.569114482000074],
              [106.64633752500009, 22.56880442300009],
              [106.63005944800005, 22.58012156200006],
              [106.6195174560001, 22.597329814000133],
              [106.60763187700007, 22.609990540000055],
              [106.58799483200005, 22.607768453000077],
              [106.57714278200007, 22.59531443300007],
              [106.56877120000013, 22.574592183000064],
              [106.5458785400001, 22.472531230000115],
              [106.54138269100008, 22.464263001000077],
              [106.53032393400008, 22.449276836000095],
              [106.52691329000004, 22.438269755000093],
              [106.52691329000004, 22.427779440000066],
              [106.53302821800008, 22.403444519000075],
              [106.53450972500008, 22.39754872600004],
              [106.53652510600006, 22.360548401000088],
              [106.54179610200009, 22.345097148],
              [106.55533532700008, 22.331971334000045],
              [106.57745284100008, 22.324581604000016],
              [106.61729537000008, 22.32277292900004],
              [106.63378015100005, 22.309440410000022],
              [106.63967126500006, 22.29667633100003],
              [106.66292565900011, 22.223295797],
              [106.66054854300006, 22.213425598000114],
              [106.6518152270001, 22.205622457000104],
              [106.63967126500006, 22.190894674],
              [106.64235843900008, 22.17611521400009],
              [106.64866296500003, 22.16505645800008],
              [106.65610437100003, 22.155134583000077],
              [106.66132369000007, 22.14355906200005],
              [106.66147871900012, 22.136324361000064],
              [106.65837813400009, 22.12009796200006],
              [106.65868819200006, 22.111933085000047],
              [106.66132369000007, 22.10655873700007],
              [106.67005700700003, 22.096636861],
              [106.6721757410001, 22.09250274700007],
              [106.67300256400006, 22.066096090000073],
              [106.66788659700006, 22.042686666000023],
              [106.64819787700009, 21.99550608300011],
              [106.6481462000001, 21.98703114900009],
              [106.64959314000009, 21.977574362000027],
              [106.65310713700012, 21.968892720000085],
              [106.65894657500013, 21.962794901000038],
              [106.67460453300009, 21.962174785000045],
              [106.6897457280001, 21.97287180600007],
              [106.72235355700013, 22.00697825100012],
              [106.72876143400009, 22.00832183900009],
              [106.74255904200004, 22.003877666000093],
              [106.74834680200013, 21.999950257000123],
              [106.75614994400013, 21.989511617000076],
              [106.76100752800005, 21.98506744400008],
              [106.78152307100004, 21.975042216000062],
              [106.79909305900009, 21.972613423],
              [106.84053755700006, 21.97359527600007],
              [106.86477380400004, 21.968065898000063],
              [106.87686608900003, 21.957317200000134],
              [106.88539270000012, 21.943312887000033],
              [106.89882857300012, 21.927758280000106],
              [106.92037764500003, 21.916957906000064],
              [106.93774092600006, 21.920006816000082],
              [106.95376062100013, 21.928998515000032],
              [106.97122725400004, 21.935819804000076],
              [106.99189782700006, 21.935354716000077],
              [107.00936446200012, 21.927448222000024],
              [107.0202165130001, 21.91292714400008],
              [107.02114668800004, 21.89225657100006],
              [107.01184493000011, 21.875565084000115],
              [106.99753055800011, 21.860837301000018],
              [106.98714359500008, 21.844817607000053],
              [106.98910730000011, 21.824250387000077],
              [107.00290490800006, 21.81055613200006],
              [107.02373051000012, 21.804096578],
              [107.06584680200007, 21.795828349000047],
              [107.09483728100003, 21.77898183200007],
              [107.17235192900011, 21.71505808500011],
              [107.21214278200011, 21.705239563000035],
              [107.24387211100003, 21.715161438000038],
              [107.27265588400007, 21.7183137010001],
              [107.30319665500008, 21.688703105000045],
              [107.32965498900006, 21.616046041000104],
              [107.33357556600009, 21.61250876000007],
              [107.34815515200006, 21.599354553000083],
              [107.38288171400012, 21.618888245000065],
              [107.40996016500009, 21.645398255000075],
              [107.42603153500005, 21.652064514000088],
              [107.44592696200004, 21.646948547000093],
              [107.45703739400005, 21.631497294],
              [107.46101648000013, 21.596357320000052],
              [107.4737805580001, 21.590569560000077],
              [107.49119551600006, 21.584110006000046],
              [107.50132409700007, 21.581526184000026],
              [107.5098507080001, 21.5817845670001],
              [107.51827396700003, 21.587365621000018],
              [107.52654219600004, 21.603281963000043],
              [107.53305342600004, 21.608656311000104],
              [107.55098514800011, 21.610826721000095],
              [107.59284305800008, 21.605607402000075],
              [107.61320357300008, 21.605607402000075],
              [107.67185632300004, 21.617648011000043],
              [107.69025313300011, 21.624727682000056],
              [107.72942386900007, 21.651961161000074],
              [107.74482344600005, 21.657542217000085],
              [107.76011967000011, 21.658214010000066],
              [107.77789636300002, 21.65599192300006],
              [107.81164107300003, 21.647827047000035],
              [107.83236332200005, 21.639352112000054],
              [107.83985640500009, 21.629895325000078],
              [107.84445560700004, 21.617492981000098],
              [107.8554626880001, 21.60033640600004],
              [107.86771000200014, 21.589225973000012],
              [107.89613204000005, 21.569433899000032],
              [107.93096195500004, 21.53424224800007],
              [107.94419112200012, 21.53077992800003],
              [107.99122155000003, 21.485663153000075],
              [107.96998131600003, 21.475775458000044],
              [107.94857832100007, 21.45498281500005],
              [107.92969811300003, 21.442613023000035],
              [107.91602623800003, 21.45840078300006],
              [107.91627037900003, 21.46824778900009],
              [107.92123457100007, 21.47479889500005],
              [107.92701256600003, 21.479315497000073],
              [107.92969811300003, 21.482855536000045],
              [107.92855879000007, 21.49054596600007],
              [107.92603600400003, 21.495917059000078],
              [107.92343183700007, 21.499945380000042],
              [107.92221113400007, 21.503078518000052],
              [107.91871178500003, 21.517523505000042],
              [107.90967858200003, 21.526516018000052],
              [107.89673912900003, 21.53156159100007],
              [107.88192793100006, 21.534084377000056],
              [107.88379967500003, 21.52676015800006],
              [107.88266035200007, 21.52252838700008],
              [107.87509199300007, 21.513617255000042],
              [107.86841881600003, 21.513617255000042],
              [107.86280358200003, 21.530218817000048],
              [107.85596764400003, 21.52094147300005],
              [107.84791100400003, 21.493109442000048],
              [107.83594811300003, 21.488348700000074],
              [107.82886803500003, 21.494940497000073],
              [107.82593834700003, 21.508978583000044],
              [107.82667076900003, 21.526678778000075],
              [107.82056725400003, 21.526678778000075],
              [107.81299889400003, 21.520453192000048],
              [107.81299889400003, 21.513617255000042],
              [107.81739342500003, 21.50934479400007],
              [107.81893964900007, 21.506252346000053],
              [107.82056725400003, 21.493109442000048],
              [107.81299889400003, 21.493109442000048],
              [107.80689537900003, 21.506781317000048],
              [107.80005944100003, 21.499335028000075],
              [107.79623457100007, 21.519476630000042],
              [107.78345787900003, 21.524318752000056],
              [107.76685631600003, 21.52020905200004],
              [107.75220787900003, 21.513617255000042],
              [107.75220787900003, 21.506781317000048],
              [107.76832116000003, 21.50690338700008],
              [107.78036543100006, 21.503078518000052],
              [107.78858483200003, 21.49445221600007],
              [107.79257246200007, 21.480129299000055],
              [107.77890058700007, 21.485663153000075],
              [107.78109785200007, 21.47915273600006],
              [107.78394616000003, 21.464911200000074],
              [107.78638756600003, 21.45840078300006],
              [107.77564537900003, 21.45856354400007],
              [107.76758873800003, 21.45571523600006],
              [107.76181074300007, 21.45075104400007],
              [107.75855553500003, 21.44472890800006],
              [107.76522871200007, 21.43854401200008],
              [107.74854576900003, 21.41120026200008],
              [107.73031660200007, 21.411810614000046],
              [107.72144616000003, 21.41087474200009],
              [107.71737714900007, 21.407456773000035],
              [107.71151777400007, 21.398911851000037],
              [107.69809004000007, 21.398382880000042],
              [107.68417402400007, 21.403265692000048],
              [107.67652428500003, 21.41120026200008],
              [107.66903730600006, 21.41120026200008],
              [107.66602623800003, 21.406805731000077],
              [107.66285241000003, 21.40375397300005],
              [107.66285241000003, 21.39752838700008],
              [107.66944420700003, 21.38544342700004],
              [107.66342207100007, 21.378078518000052],
              [107.65023847700007, 21.37685781500005],
              [107.63502037900003, 21.383246161000045],
              [107.63729902400007, 21.377752997000073],
              [107.63721764400003, 21.375433661000045],
              [107.63778730600006, 21.37372467700004],
              [107.64234459700003, 21.370266018000052],
              [107.64234459700003, 21.36277903900009],
              [107.63412519600007, 21.358587958000044],
              [107.63119550900007, 21.35447825700004],
              [107.63388105600006, 21.349351304000038],
              [107.64234459700003, 21.342271226000037],
              [107.63575280000003, 21.34137604400007],
              [107.62134850400003, 21.33551666900007],
              [107.62533613400007, 21.333726304000038],
              [107.62671959700003, 21.33388906500005],
              [107.62720787900003, 21.333156643000052],
              [107.62875410200007, 21.328680731000077],
              [107.62411543100006, 21.33071523600006],
              [107.60816491000003, 21.33551666900007],
              [107.60352623800003, 21.310492255000042],
              [107.59921308700007, 21.298773505000042],
              [107.59058678500003, 21.293890692000048],
              [107.57374108200003, 21.294745184000078],
              [107.56226647200003, 21.298041083000044],
              [107.55404707100007, 21.304510809000078],
              [107.54688561300003, 21.315008856000077],
              [107.54257246200007, 21.326564846000053],
              [107.54037519600007, 21.33734772300005],
              [107.53516686300003, 21.345363674000055],
              [107.52230879000007, 21.348537502000056],
              [107.52198326900003, 21.344305731000077],
              [107.52597089900007, 21.334418036000045],
              [107.52881920700003, 21.32322825700004],
              [107.52515709700003, 21.315008856000077],
              [107.52515709700003, 21.307562567000048],
              [107.53744550900007, 21.301947333000044],
              [107.52662194100003, 21.298773505000042],
              [107.50448652400007, 21.29840729400007],
              [107.48414147200003, 21.301336981000077],
              [107.48178144600007, 21.301336981000077],
              [107.47217858200003, 21.30369700700004],
              [107.46168053500003, 21.30927155200004],
              [107.45679772200003, 21.31834544500009],
              [107.45093834700003, 21.32050202000005],
              [107.41529381600003, 21.328680731000077],
              [107.40902754000007, 21.315008856000077],
              [107.41602623800003, 21.308539130000042],
              [107.44312584700003, 21.293890692000048],
              [107.44312584700003, 21.287665106000077],
              [107.42359459700003, 21.27960846600007],
              [107.39161217500003, 21.280422268000052],
              [107.36744225400003, 21.273382880000042],
              [107.36744225400003, 21.26658763200004],
              [107.37330162900003, 21.258978583000044],
              [107.37086022200003, 21.25336334800005],
              [107.36483808700007, 21.24762604400007],
              [107.36060631600003, 21.23924388200004],
              [107.35889733200003, 21.203070380000042],
              [107.35434004000007, 21.191473700000074],
              [107.36207116000003, 21.185614325000074],
              [107.37069746200007, 21.18162669500009],
              [107.37964928500003, 21.180975653000075],
              [107.38843834700003, 21.18463776200008],
              [107.38233483200003, 21.139797268000052],
              [107.37549889400003, 21.116156317000048],
              [107.36060631600003, 21.102118231000077],
              [107.36630293100006, 21.093491929000038],
              [107.36744225400003, 21.08787669500009],
              [107.36353600400003, 21.084418036000045],
              [107.35434004000007, 21.08222077000005],
              [107.35824629000007, 21.067328192000048],
              [107.36036217500003, 21.052435614000046],
              [107.36434980600006, 21.040350653000075],
              [107.37427819100003, 21.03384023600006],
              [107.37427819100003, 21.02757396000004],
              [107.35767662900003, 21.01520416900007],
              [107.34774824300007, 21.00995514500005],
              [107.33383222700007, 21.00584544500009],
              [107.31104576900003, 21.00527578300006],
              [107.29232832100007, 21.00462474200009],
              [107.27955162900003, 20.999701239000046],
              [107.26644941500007, 21.004299221000053],
              [107.24529056100005, 21.003078518000052],
              [107.22413170700003, 20.99823639500005],
              [107.21119225400003, 20.992254950000074],
              [107.21631920700003, 20.99022044500009],
              [107.21957441500007, 20.988226630000042],
              [107.22380618600005, 20.98663971600007],
              [107.23113040500004, 20.986029364000046],
              [107.23113040500004, 20.97919342700004],
              [107.21485436300003, 20.97524648600006],
              [107.19336998800003, 20.95270416900007],
              [107.19703209700003, 20.937648830000057],
              [107.18189537900003, 20.936753648000035],
              [107.17090905000003, 20.93357982000009],
              [107.16089928500003, 20.932440497000073],
              [107.14918053500003, 20.937648830000057],
              [107.14918053500003, 20.930812893000052],
              [107.13379967500003, 20.94481028900009],
              [107.08497155000003, 20.95140208500004],
              [107.06609134200005, 20.958726304000038],
              [107.06609134200005, 20.964911200000074],
              [107.09522545700003, 21.000474351000037],
              [107.14918053500003, 21.03384023600006],
              [107.14918053500003, 21.04059479400007],
              [107.13599694100003, 21.03974030200004],
              [107.12305748800003, 21.037258205000057],
              [107.11117597700007, 21.03310781500005],
              [107.10132897200003, 21.02757396000004],
              [107.09685306100005, 21.02106354400007],
              [107.09538821700005, 21.014064846000053],
              [107.09245853000004, 21.008246161000045],
              [107.08375084700003, 21.00584544500009],
              [107.07976321700005, 21.009100653000075],
              [107.08106530000003, 21.01630280200004],
              [107.08472741000003, 21.02366771000004],
              [107.08716881600003, 21.02757396000004],
              [107.08277428500003, 21.030178127000056],
              [107.08236738400007, 21.030991929000038],
              [107.08033287900003, 21.03384023600006],
              [107.07227623800003, 21.01707591400009],
              [107.06324303500003, 21.00934479400007],
              [107.05762780000003, 21.01386139500005],
              [107.05982506600003, 21.03384023600006],
              [107.05298912900003, 21.03384023600006],
              [107.05347741000003, 21.02301666900007],
              [107.05250084700003, 21.01365794500009],
              [107.05014082100007, 21.005926825000074],
              [107.04615319100003, 20.999701239000046],
              [107.04688561300003, 21.01398346600007],
              [107.04460696700005, 21.025091864000046],
              [107.03793379000007, 21.032171942000048],
              [107.02564537900003, 21.03384023600006],
              [107.02564537900003, 21.02757396000004],
              [107.02914472700007, 21.024562893000052],
              [107.03467858200003, 21.01780833500004],
              [107.03931725400003, 21.013373114000046],
              [107.03614342500003, 21.013006903000075],
              [107.02564537900003, 21.013373114000046],
              [107.03931725400003, 20.999701239000046],
              [107.02515709700003, 20.999823309000078],
              [107.01563561300003, 21.004339911000045],
              [106.99781334700003, 21.02016836100006],
              [106.99545332100007, 21.006415106000077],
              [107.02084394600007, 20.986395575000074],
              [107.02564537900003, 20.972357489000046],
              [107.01677493600005, 20.95766836100006],
              [107.00098717500003, 20.95107656500005],
              [106.98210696700005, 20.94993724200009],
              [106.96363366000003, 20.951239325000074],
              [106.94695071700005, 20.954291083000044],
              [106.93189537900003, 20.959418036000045],
              [106.91920006600003, 20.965765692000048],
              [106.90894616000003, 20.972357489000046],
              [106.88461347700007, 20.99323151200008],
              [106.87338300900007, 20.99713776200008],
              [106.86744225400003, 20.986029364000046],
              [106.86353600400003, 20.99160390800006],
              [106.86019941500007, 20.993109442000048],
              [106.85377037900003, 20.992254950000074],
              [106.88282311300003, 20.96051666900007],
              [106.89527428500003, 20.951239325000074],
              [106.91635175900007, 20.941107489000046],
              [106.92204837300005, 20.937648830000057],
              [106.92611738400007, 20.930975653000075],
              [106.92823326900003, 20.922756252000056],
              [106.93238366000003, 20.915187893000052],
              [106.94312584700003, 20.910305080000057],
              [106.94312584700003, 20.903509833000044],
              [106.91724694100003, 20.904038804000038],
              [106.90170332100007, 20.907863674000055],
              [106.89144941500007, 20.918036200000074],
              [106.88160241000003, 20.937648830000057],
              [106.87427819100003, 20.937648830000057],
              [106.87549889400003, 20.92869700700004],
              [106.87842858200003, 20.921210028000075],
              [106.88233483200003, 20.91510651200008],
              [106.88795006600003, 20.910305080000057],
              [106.86793053500003, 20.88271719000005],
              [106.85987389400003, 20.88939036700009],
              [106.85222415500004, 20.909979559000078],
              [106.83326256600003, 20.923976955000057],
              [106.83668053500003, 20.92914459800005],
              [106.83545983200003, 20.930609442000048],
              [106.83326256600003, 20.937648830000057],
              [106.82642662900003, 20.937648830000057],
              [106.80600019600007, 20.932074286000045],
              [106.78321373800003, 20.942572333000044],
              [106.77247155000003, 20.957424221000053],
              [106.78882897200003, 20.964911200000074],
              [106.80689537900003, 20.966009833000044],
              [106.81690514400003, 20.96946849200009],
              [106.82064863400007, 20.97601959800005],
              [106.81959069100003, 20.986029364000046],
              [106.81283613400007, 20.990627346000053],
              [106.80241946700005, 20.99518463700008],
              [106.79867597700007, 21.00193919500009],
              [106.81218509200005, 21.013373114000046],
              [106.80567467500003, 21.01984284100007],
              [106.79810631600003, 21.02480703300006],
              [106.78931725400003, 21.02753327000005],
              [106.77857506600003, 21.02757396000004],
              [106.78077233200003, 21.02411530200004],
              [106.78321373800003, 21.01666901200008],
              [106.78541100400003, 21.013373114000046],
              [106.76238040500004, 21.015326239000046],
              [106.74610436300003, 21.024562893000052],
              [106.73080488400007, 21.029852606000077],
              [106.71029707100007, 21.02016836100006],
              [106.71029707100007, 21.013373114000046],
              [106.71778405000003, 21.013373114000046],
              [106.71778405000003, 21.00584544500009],
              [106.68034915500004, 21.020453192000048],
              [106.65870201900003, 21.02484772300005],
              [106.64210045700003, 21.02016836100006],
              [106.65072675900007, 21.018011786000045],
              [106.65267988400007, 21.017523505000042],
              [106.68295332100007, 21.00584544500009],
              [106.68295332100007, 20.999701239000046],
              [106.67628014400003, 21.001898505000042],
              [106.65577233200003, 21.00584544500009],
              [106.65577233200003, 20.999701239000046],
              [106.66553795700003, 20.99054596600007],
              [106.66911868600005, 20.97996653900009],
              [106.67107181100005, 20.96906159100007],
              [106.67628014400003, 20.958726304000038],
              [106.68669681100005, 20.95270416900007],
              [106.71192467500003, 20.951564846000053],
              [106.73373457100007, 20.942206122000073],
              [106.74610436300003, 20.942328192000048],
              [106.75513756600003, 20.93854401200008],
              [106.75879967500003, 20.920843817000048],
              [106.75668379000007, 20.907904364000046],
              [106.74724368600005, 20.89472077000005],
              [106.74447675900007, 20.88300202000005],
              [106.73829186300003, 20.88300202000005],
              [106.71778405000003, 20.903509833000044],
              [106.69996178500003, 20.882757880000042],
              [106.70753014400003, 20.870754299000055],
              [106.72689863400007, 20.861395575000074],
              [106.74447675900007, 20.848863023000035],
              [106.75294030000003, 20.82575104400007],
              [106.74919681100005, 20.804348049000055],
              [106.73658287900003, 20.794989325000074],
              [106.71778405000003, 20.807847398000035],
              [106.72461998800003, 20.79002513200004],
              [106.73845462300005, 20.76972077000005],
              [106.75562584700003, 20.751206773000035],
              [106.77247155000003, 20.73895905200004],
              [106.77857506600003, 20.74640534100007],
              [106.78882897200003, 20.730536200000074],
              [106.80591881600003, 20.677557684000078],
              [106.78516686300003, 20.692287502000056],
              [106.77613366000003, 20.701117255000042],
              [106.77247155000003, 20.707953192000048],
              [106.76710045700003, 20.713446356000077],
              [106.75562584700003, 20.70929596600007],
              [106.74488366000003, 20.701971747000073],
              [106.74146569100003, 20.69798411700009],
              [106.73267662900003, 20.696600653000075],
              [106.72559655000003, 20.693752346000053],
              [106.71697024800005, 20.69131094000005],
              [106.70411217500003, 20.691148179000038],
              [106.67554772200003, 20.69863515800006],
              [106.66260826900003, 20.69798411700009],
              [106.66260826900003, 20.691148179000038],
              [106.68751061300003, 20.681341864000046],
              [106.70289147200003, 20.671576239000046],
              [106.70313561300003, 20.65965403900009],
              [106.68295332100007, 20.643377997000073],
              [106.66968834700003, 20.636460679000038],
              [106.65406334700003, 20.630804755000042],
              [106.63754316500007, 20.628078518000052],
              [106.62094160200007, 20.629787502000056],
              [106.61231530000003, 20.63548411700009],
              [106.59815514400003, 20.655096747000073],
              [106.58676191500007, 20.663275458000044],
              [106.59262129000007, 20.648098049000055],
              [106.59359785200007, 20.64671458500004],
              [106.59937584700003, 20.638413804000038],
              [106.61426842500003, 20.622300523000035],
              [106.61939537900003, 20.61859772300005],
              [106.62403405000003, 20.618801174000055],
              [106.62720787900003, 20.61660390800006],
              [106.62842858200003, 20.605861721000053],
              [106.62745201900003, 20.600083726000037],
              [106.62476647200003, 20.594631252000056],
              [106.62134850400003, 20.590399481000077],
              [106.60474694100003, 20.584418036000045],
              [106.58253014400003, 20.56517161700009],
              [106.51856530000003, 20.540961005000042],
              [106.53614342500003, 20.531642971000053],
              [106.55062910200007, 20.532416083000044],
              [106.57992597700007, 20.54718659100007],
              [106.57992597700007, 20.540961005000042],
              [106.56771894600007, 20.52488841400009],
              [106.57488040500004, 20.51072825700004],
              [106.58448326900003, 20.496039130000042],
              [106.57992597700007, 20.478257554000038],
              [106.57374108200003, 20.477118231000077],
              [106.54542076900003, 20.467596747000073],
              [106.54249108200003, 20.465277411000045],
              [106.53695722700007, 20.462062893000052],
              [106.52979576900003, 20.454413153000075],
              [106.52320397200003, 20.44521719000005],
              [106.51856530000003, 20.437323309000078],
              [106.52475019600007, 20.437323309000078],
              [106.53809655000003, 20.446234442000048],
              [106.56169681100005, 20.45506419500009],
              [106.58423912900003, 20.457831122000073],
              [106.59424889400003, 20.448187567000048],
              [106.59058678500003, 20.404730536000045],
              [106.58415774800005, 20.38182200700004],
              [106.57309004000007, 20.368475653000075],
              [106.56804446700005, 20.378078518000052],
              [106.56641686300003, 20.38271719000005],
              [106.56674238400007, 20.37889232000009],
              [106.56568444100003, 20.37645091400009],
              [106.56332441500007, 20.375474351000037],
              [106.55958092500003, 20.375921942000048],
              [106.57764733200003, 20.35895416900007],
              [106.57977615200008, 20.350215994000052],
              [106.58376585600007, 20.337974617000043],
              [106.58548873800004, 20.32229206900007],
              [106.58847454900007, 20.303275170000063],
              [106.59259316400005, 20.275410718000046],
              [106.58165895500008, 20.26417738400005],
              [106.55958092500003, 20.28652578300006],
              [106.54997806100005, 20.298976955000057],
              [106.53695722700007, 20.309149481000077],
              [106.52165774800005, 20.31346263200004],
              [106.50440514400003, 20.308254299000055],
              [106.49805748800003, 20.308254299000055],
              [106.50294030000003, 20.300523179000038],
              [106.50489342500003, 20.297430731000077],
              [106.51295006600003, 20.29441966400009],
              [106.52051842500003, 20.29840729400007],
              [106.52475019600007, 20.308254299000055],
              [106.54851321700005, 20.291449286000045],
              [106.55274498800003, 20.28652578300006],
              [106.55600019600007, 20.277736721000053],
              [106.56630784100003, 20.261077346000036],
              [106.57232505600007, 20.24667693500004],
              [106.56961489300005, 20.231993895000073],
              [106.55426760200004, 20.22465383100007],
              [106.54102661100006, 20.226066152000044],
              [106.52929125100007, 20.22239346300006],
              [106.50491461700005, 20.21702498600007],
              [106.47315514400003, 20.21515534100007],
              [106.46021569100003, 20.21198151200008],
              [106.39503014400003, 20.20457591400009],
              [106.39503014400003, 20.21198151200008],
              [106.40186608200003, 20.21198151200008],
              [106.40186608200003, 20.21820709800005],
              [106.39470462300005, 20.21751536700009],
              [106.39014733200003, 20.21629466400009],
              [106.38070722700007, 20.21198151200008],
              [106.38070722700007, 20.20457591400009],
              [106.38795006600003, 20.19749583500004],
              [106.38111412900003, 20.19208405200004],
              [106.36019941500007, 20.184068101000037],
              [106.35328209700003, 20.17682526200008],
              [106.34034264400003, 20.14996979400007],
              [106.30551191500007, 20.108587958000044],
              [106.28370201900003, 20.094631252000056],
              [106.25928795700003, 20.06126536700009],
              [106.23617597700007, 20.048000393000052],
              [106.21192467500003, 20.021185614000046],
              [106.19703209700003, 20.01276276200008],
              [106.20639082100007, 20.034979559000078],
              [106.21070397200003, 20.04010651200008],
              [106.20329837300005, 20.04751211100006],
              [106.19597415500004, 20.03343333500004],
              [106.18409264400003, 20.003607489000046],
              [106.17603600400003, 19.992336330000057],
              [106.16089928500003, 19.984076239000046],
              [106.12403405000003, 19.975002346000053],
              [106.10710696700005, 19.964992580000057],
              [106.10141035200007, 19.97996653900009],
              [106.10450280000003, 19.995917059000078],
              [106.11085045700003, 20.013413804000038],
              [106.11451256600003, 20.033270575000074],
              [106.10710696700005, 20.033270575000074],
              [106.10401451900003, 20.017238674000055],
              [106.08887780000003, 19.973863023000035],
              [106.08350670700003, 19.964992580000057],
              [106.06885826900003, 19.968491929000038],
              [106.05274498800003, 19.97728099200009],
              [106.03907311300003, 19.988430080000057],
              [106.03191165500004, 19.999172268000052],
              [106.02515709700003, 19.999172268000052],
              [106.01978600400003, 19.986029364000046],
              [106.00831139400003, 19.973456122000073],
              [105.96436608200003, 19.935288804000038],
              [105.95557701900003, 19.925482489000046],
              [105.94947350400003, 19.91034577000005],
              [105.94947350400003, 19.900824286000045],
              [105.95655358200003, 19.885199286000045],
              [105.95679772200003, 19.87563711100006],
              [105.93580162900003, 19.84829336100006],
              [105.93213951900003, 19.83344147300005],
              [105.93230228000004, 19.80540599200009],
              [105.92888431100005, 19.79364655200004],
              [105.92579186300003, 19.797430731000077],
              [105.91529381600003, 19.80731842700004],
              [105.90894616000003, 19.79686107000009],
              [105.89470462300005, 19.78729889500005],
              [105.86744225400003, 19.773179429000038],
              [105.87370853000004, 19.765692450000074],
              [105.88697350400003, 19.771633205000057],
              [105.91553795700003, 19.77448151200008],
              [105.92888431100005, 19.78001536700009],
              [105.92335045700003, 19.766791083000044],
              [105.90544681100005, 19.743801174000055],
              [105.90162194100003, 19.728216864000046],
              [105.89527428500003, 19.72134023600006],
              [105.88111412900003, 19.72215403900009],
              [105.86695397200003, 19.721096096000053],
              [105.86060631600003, 19.70799388200004],
              [105.85596764400003, 19.69163646000004],
              [105.83350670700003, 19.658148505000042],
              [105.82593834700003, 19.642238674000055],
              [105.82406660200007, 19.626613674000055],
              [105.82390384200005, 19.598944403000075],
              [105.81902103000004, 19.587591864000046],
              [105.81755618600005, 19.61001211100006],
              [105.80388431100005, 19.613023179000038],
              [105.79086347700007, 19.603461005000042],
              [105.79175866000003, 19.587591864000046],
              [105.79574629000007, 19.594549872000073],
              [105.80298912900003, 19.60293203300006],
              [105.80543053500003, 19.608710028000075],
              [105.81055748800003, 19.59959544500009],
              [105.81316165500004, 19.58974844000005],
              [105.81373131600003, 19.579046942000048],
              [105.81470787900003, 19.57440827000005],
              [105.81902103000004, 19.573919989000046],
              [105.81934655000003, 19.53668854400007],
              [105.80811608200003, 19.460760809000078],
              [105.81275475400003, 19.423163153000075],
              [105.79859459700003, 19.430568752000056],
              [105.78492272200003, 19.403265692000048],
              [105.77125084700003, 19.409491278000075],
              [105.77125084700003, 19.403265692000048],
              [105.78256269600007, 19.394354559000078],
              [105.78687584700003, 19.38304271000004],
              [105.79175866000003, 19.35488515800006],
              [105.81006920700003, 19.321478583000044],
              [105.81275475400003, 19.307033596000053],
              [105.79175866000003, 19.320705471000053],
              [105.79420006600003, 19.310939846000053],
              [105.79859459700003, 19.299627997000073],
              [105.80591881600003, 19.30215078300006],
              [105.81080162900003, 19.299627997000073],
              [105.80876712300005, 19.280178127000056],
              [105.80624433700007, 19.274318752000056],
              [105.80543053500003, 19.272284247000073],
              [105.79753665500004, 19.267320054000038],
              [105.78858483200003, 19.266831773000035],
              [105.78101647200003, 19.264878648000035],
              [105.77230879000007, 19.235988674000055],
              [105.75953209700003, 19.23533763200004],
              [105.74577884200005, 19.237250067000048],
              [105.74341881600003, 19.23191966400009],
              [105.73121178500003, 19.17023346600007],
              [105.72982832100007, 19.13385651200008],
              [105.73707116000003, 19.10846588700008],
              [105.71176191500007, 19.096625067000048],
              [105.70199629000007, 19.09048086100006],
              [105.69556725400003, 19.08112213700008],
              [105.66830488400007, 19.089544989000046],
              [105.64380944100003, 19.065375067000048],
              [105.62484785200007, 19.028469143000052],
              [105.61426842500003, 18.998602606000077],
              [105.61329186300003, 18.985541083000044],
              [105.61866295700003, 18.976304429000038],
              [105.62110436300003, 18.96784088700008],
              [105.62224368600005, 18.95453522300005],
              [105.62964928500003, 18.922308661000045],
              [105.63477623800003, 18.909816799000055],
              [105.64828535200007, 18.892726955000057],
              [105.66993248800003, 18.874945380000042],
              [105.69450931100005, 18.86078522300005],
              [105.71664472700007, 18.85455963700008],
              [105.71664472700007, 18.84833405200004],
              [105.70289147200003, 18.834133205000057],
              [105.69874108200003, 18.843003648000035],
              [105.69288170700003, 18.849554755000042],
              [105.68490644600007, 18.853461005000042],
              [105.67505944100003, 18.85455963700008],
              [105.68580162900003, 18.831284898000035],
              [105.68873131600003, 18.826646226000037],
              [105.69532311300003, 18.824693101000037],
              [105.71265709700003, 18.826320705000057],
              [105.72006269600007, 18.823553778000075],
              [105.74097741000003, 18.801581122000073],
              [105.75196373800003, 18.786322333000044],
              [105.75757897200003, 18.772040106000077],
              [105.74268639400003, 18.73078034100007],
              [105.74708092500003, 18.724269924000055],
              [105.75611412900003, 18.715969143000052],
              [105.75766035200007, 18.696966864000046],
              [105.75473066500007, 18.676255601000037],
              [105.75074303500003, 18.66278717700004],
              [105.77003014400003, 18.671576239000046],
              [105.76986738400007, 18.695054429000038],
              [105.76677493600005, 18.755601304000038],
              [105.76441491000003, 18.758978583000044],
              [105.78345787900003, 18.747259833000044],
              [105.78972415500004, 18.71873607000009],
              [105.79086347700007, 18.68968333500004],
              [105.79517662900003, 18.67645905200004],
              [105.80201256600003, 18.66543203300006],
              [105.82593834700003, 18.593898830000057],
              [105.87924238400007, 18.510931708000044],
              [105.91529381600003, 18.473089911000045],
              [105.94947350400003, 18.47101471600007],
              [105.95215905000003, 18.452378648000092],
              [105.95883222700007, 18.432562567000048],
              [105.96778405000003, 18.41474030200004],
              [105.97730553500003, 18.402085679000038],
              [106.00049889400003, 18.38540273600006],
              [106.00806725400003, 18.37848541900007],
              [106.04574629000007, 18.33226146000004],
              [106.09815514400003, 18.29002513200004],
              [106.11011803500003, 18.275539455000057],
              [106.11215254000007, 18.262884833000044],
              [106.09343509200005, 18.258734442000048],
              [106.10328209700003, 18.25153229400007],
              [106.12012780000003, 18.254828192000048],
              [106.14177493600005, 18.261786200000074],
              [106.16578209700003, 18.265570380000042],
              [106.18116295700003, 18.259711005000042],
              [106.23365319100003, 18.220851955000057],
              [106.24057050900007, 18.21710846600007],
              [106.26221764400003, 18.209458726000037],
              [106.27084394600007, 18.20408763200004],
              [106.29883873800003, 18.16933828300006],
              [106.33228600400003, 18.14520905200004],
              [106.34603925900007, 18.13271719000005],
              [106.35401451900003, 18.11469147300005],
              [106.34669030000003, 18.11469147300005],
              [106.33692467500003, 18.12067291900007],
              [106.32406660200007, 18.118068752000056],
              [106.31251061300003, 18.110174872000073],
              [106.30632571700005, 18.100490627000056],
              [106.31934655000003, 18.094224351000037],
              [106.32374108200003, 18.097357489000046],
              [106.32740319100003, 18.098781643000052],
              [106.34034264400003, 18.100490627000056],
              [106.33448326900003, 18.08860911700009],
              [106.33643639400003, 18.079006252000056],
              [106.34669030000003, 18.059475002000056],
              [106.34693444100003, 18.07184479400007],
              [106.34986412900003, 18.083644924000055],
              [106.35450280000003, 18.09365469000005],
              [106.36019941500007, 18.100490627000056],
              [106.37077884200005, 18.105617580000057],
              [106.37728925900007, 18.103461005000042],
              [106.38412519600007, 18.09983958500004],
              [106.39503014400003, 18.100490627000056],
              [106.40349368600005, 18.10618724200009],
              [106.42237389400003, 18.12836334800005],
              [106.43482506600003, 18.123521226000037],
              [106.43336022200003, 18.11326732000009],
              [106.42237389400003, 18.094224351000037],
              [106.42774498800003, 18.07290273600006],
              [106.43897545700003, 18.051988023000092],
              [106.51856530000003, 17.95701732000009],
              [106.52475019600007, 17.949611721000053],
              [106.52475019600007, 17.943426825000074],
              [106.50407962300005, 17.93065013200004],
              [106.48438561300003, 17.91547272300005],
              [106.47429446700005, 17.902899481000077],
              [106.46607506600003, 17.89020416900007],
              [106.45508873800003, 17.88182200700004],
              [106.43604576900003, 17.881984768000052],
              [106.43604576900003, 17.87449778900009],
              [106.44703209700003, 17.87213776200008],
              [106.45101972700007, 17.865708726000037],
              [106.44947350400003, 17.856634833000044],
              [106.44288170700003, 17.846584377000056],
              [106.45183353000004, 17.828192450000074],
              [106.46070397200003, 17.799383856000077],
              [106.47006269600007, 17.748195705000057],
              [106.47510826900003, 17.73700592700004],
              [106.49537194100003, 17.717962958000044],
              [106.49805748800003, 17.710638739000046],
              [106.48951256600003, 17.70258209800005],
              [106.47852623800003, 17.703517971000053],
              [106.44874108200003, 17.716009833000044],
              [106.43555748800003, 17.739447333000044],
              [106.42579186300003, 17.74477773600006],
              [106.41065514400003, 17.747015692000048],
              [106.37452233200003, 17.765285549000055],
              [106.30665123800003, 17.771918036000045],
              [106.29200280000003, 17.778265692000048],
              [106.28516686300003, 17.77212148600006],
              [106.29948978000004, 17.762274481000077],
              [106.32276451900003, 17.75348541900007],
              [106.34693444100003, 17.747219143000052],
              [106.38062584700003, 17.743394273000092],
              [106.42920983200003, 17.73114655200004],
              [106.42920983200003, 17.72370026200008],
              [106.42237389400003, 17.72370026200008],
              [106.40259850400003, 17.73151276200008],
              [106.38306725400003, 17.719183661000045],
              [106.37964928500003, 17.69879791900007],
              [106.40870201900003, 17.682766018000052],
              [106.40300540500004, 17.69481028900009],
              [106.40023847700007, 17.699164130000042],
              [106.39503014400003, 17.703192450000074],
              [106.41749108200003, 17.712958075000074],
              [106.44996178500003, 17.708644924000055],
              [106.48226972700007, 17.696437893000052],
              [106.50440514400003, 17.682766018000052],
              [106.51490319100003, 17.66990794500009],
              [106.53907311300003, 17.627508856000077],
              [106.56592858200003, 17.598049221000053],
              [106.61475670700003, 17.518703518000052],
              [106.62598717500003, 17.48663971600007],
              [106.63461347700007, 17.470404364000046],
              [106.63843834700003, 17.468898830000057],
              [106.65821373800003, 17.45376211100006],
              [106.65919030000003, 17.44993724200009],
              [106.66358483200003, 17.44725169500009],
              [106.67628014400003, 17.429510809000078],
              [106.76392662900003, 17.33551666900007],
              [106.94662519600007, 17.20538971600007],
              [107.00749759200005, 17.162217515000066],
              [107.11182701900003, 17.088283596000053],
              [107.12720787900003, 17.059759833000044],
              [107.12126712300005, 17.01854075700004],
              [107.13257897200003, 17.009833075000074],
              [107.18653405000003, 16.934393622000073],
              [107.20069420700003, 16.926255601000037],
              [107.20386803500003, 16.919256903000075],
              [107.20069420700003, 16.91429271000004],
              [107.19361412900003, 16.911078192000048],
              [107.18653405000003, 16.90656159100007],
              [107.18336022200003, 16.898138739000046],
              [107.17741946700005, 16.89394765800006],
              [107.14177493600005, 16.87457916900007],
              [107.14177493600005, 16.867743231000077],
              [107.16724694100003, 16.867621161000045],
              [107.17896569100003, 16.869533596000053],
              [107.19019616000003, 16.87457916900007],
              [107.19141686300003, 16.87921784100007],
              [107.18995201900003, 16.88617584800005],
              [107.18946373800003, 16.892320054000038],
              [107.20753014400003, 16.90497467700004],
              [107.21648196700005, 16.907945054000038],
              [107.22339928500003, 16.90135325700004],
              [107.22934004000007, 16.892238674000055],
              [107.23454837300005, 16.887640692000048],
              [107.24927819100003, 16.880031643000052],
              [107.37867272200003, 16.773382880000042],
              [107.41163170700003, 16.750026760000083],
              [107.49781334700003, 16.68903229400007],
              [107.60466556100005, 16.59568919500009],
              [107.63526451900003, 16.587225653000075],
              [107.63526451900003, 16.579779364000046],
              [107.59603925900007, 16.59052155200004],
              [107.47364342500003, 16.653143622000073],
              [107.44336998800003, 16.64801666900007],
              [107.51978600400003, 16.60643138200004],
              [107.54395592500003, 16.60057200700004],
              [107.55494225400003, 16.596625067000048],
              [107.56397545700003, 16.58270905200004],
              [107.57455488400007, 16.580023505000042],
              [107.58619225400003, 16.581691799000055],
              [107.59424889400003, 16.587225653000075],
              [107.60157311300003, 16.576564846000053],
              [107.61109459700003, 16.569281317000048],
              [107.63526451900003, 16.55927155200004],
              [107.63526451900003, 16.55182526200008],
              [107.62452233200003, 16.557114976000037],
              [107.62159264400003, 16.55927155200004],
              [107.61459394600007, 16.55927155200004],
              [107.61247806100005, 16.555894273000092],
              [107.61085045700003, 16.55263906500005],
              [107.60840905000003, 16.544989325000074],
              [107.62305748800003, 16.54441966400009],
              [107.63672936300003, 16.54588450700004],
              [107.66309655000003, 16.55182526200008],
              [107.65699303500003, 16.545477606000077],
              [107.65259850400003, 16.538723049000055],
              [107.64975019600007, 16.530910549000055],
              [107.64893639400003, 16.521429755000042],
              [107.65259850400003, 16.52244700700004],
              [107.65984134200005, 16.51312897300005],
              [107.66529381600003, 16.50185781500005],
              [107.66309655000003, 16.497219143000052],
              [107.67286217500003, 16.497259833000044],
              [107.67798912900003, 16.50136953300006],
              [107.68165123800003, 16.50771719000005],
              [107.68669681100005, 16.514593817000048],
              [107.69711347700007, 16.520086981000077],
              [107.70313561300003, 16.51439036700009],
              [107.70720462300005, 16.50454336100006],
              [107.71143639400003, 16.497219143000052],
              [107.74952233200003, 16.47223541900007],
              [107.75879967500003, 16.46308014500005],
              [107.78174889400003, 16.427557684000078],
              [107.79997806100005, 16.415716864000046],
              [107.82162519600007, 16.387518622000073],
              [107.84115644600007, 16.379787502000056],
              [107.83887780000003, 16.37685781500005],
              [107.83350670700003, 16.374212958000044],
              [107.82691491000003, 16.37368398600006],
              [107.82048587300005, 16.37653229400007],
              [107.81421959700003, 16.38117096600007],
              [107.80689537900003, 16.38544342700004],
              [107.79656009200005, 16.38735586100006],
              [107.79444420700003, 16.37921784100007],
              [107.80713951900003, 16.322739976000037],
              [107.81226647200003, 16.31317780200004],
              [107.82406660200007, 16.304836330000057],
              [107.84815514400003, 16.29169342700004],
              [107.85499108200003, 16.29169342700004],
              [107.86402428500003, 16.297796942000048],
              [107.87256920700003, 16.29588450700004],
              [107.87891686300003, 16.28856028900009],
              [107.88217207100007, 16.27806224200009],
              [107.89136803500003, 16.28416575700004],
              [107.89649498800003, 16.27806224200009],
              [107.93311608200003, 16.30540599200009],
              [107.93751061300003, 16.31207916900007],
              [107.93091881600003, 16.343410549000055],
              [107.92994225400003, 16.353216864000046],
              [107.94516035200007, 16.35683828300006],
              [107.99040774800005, 16.324774481000077],
              [108.01197350400003, 16.31903717700004],
              [108.02051842500003, 16.32518138200004],
              [108.02515709700003, 16.334377346000053],
              [108.03101647200003, 16.342718817000048],
              [108.04297936300003, 16.34638092700004],
              [108.04379316500007, 16.339911200000074],
              [108.05347741000003, 16.30540599200009],
              [108.06177819100003, 16.288234768000052],
              [108.09449303500003, 16.23651764500005],
              [108.06592858200003, 16.25722890800006],
              [108.05201256600003, 16.262111721000053],
              [108.04607181100005, 16.247381903000075],
              [108.05396569100003, 16.235988674000055],
              [108.07195071700005, 16.228949286000045],
              [108.09066816500007, 16.22687409100007],
              [108.10132897200003, 16.230292059000078],
              [108.10816491000003, 16.230292059000078],
              [108.12631269600007, 16.222479559000078],
              [108.15121504000007, 16.21698639500005],
              [108.17872155000003, 16.21474844000005],
              [108.20435631600003, 16.21670156500005],
              [108.20012454500005, 16.21157461100006],
              [108.18921959700003, 16.198472398000092],
              [108.15447024800005, 16.170843817000048],
              [108.14226321700005, 16.148382880000042],
              [108.14283287900003, 16.11937083500004],
              [108.15992272200003, 16.10374583500004],
              [108.18197675900007, 16.09137604400007],
              [108.19752037900003, 16.072007554000038],
              [108.21306399800005, 16.086818752000056],
              [108.22095787900003, 16.091620184000078],
              [108.22828209700003, 16.08974844000005],
              [108.23666425900007, 16.055121161000045],
              [108.23853600400003, 16.05219147300005],
              [108.23324629000007, 16.03709544500009],
              [108.22291100400003, 16.02289459800005],
              [108.21013431100005, 16.01129791900007],
              [108.19752037900003, 16.003729559000078],
              [108.21631920700003, 16.009466864000046],
              [108.23462975400003, 16.019354559000078],
              [108.24984785200007, 16.023260809000078],
              [108.25896243600005, 16.010565497000073],
              [108.24919681100005, 16.06191640800006],
              [108.24195397200003, 16.07575104400007],
              [108.24089603000004, 16.09052155200004],
              [108.24773196700005, 16.108710028000075],
              [108.24732506600003, 16.12323639500005],
              [108.22486412900003, 16.12726471600007],
              [108.22486412900003, 16.134711005000042],
              [108.23275800900007, 16.140326239000046],
              [108.23861738400007, 16.14671458500004],
              [108.24268639400003, 16.153957424000055],
              [108.24537194100003, 16.16201406500005],
              [108.25269616000003, 16.15892161700009],
              [108.25416100400003, 16.156642971000053],
              [108.25489342500003, 16.15696849200009],
              [108.25896243600005, 16.16201406500005],
              [108.26579837300005, 16.16201406500005],
              [108.27458743600005, 16.153469143000052],
              [108.28630618600005, 16.14451732000009],
              [108.30054772200003, 16.137518622000073],
              [108.31739342500003, 16.134711005000042],
              [108.31820722700007, 16.139553127000056],
              [108.32447350400003, 16.148871161000045],
              [108.33139082100007, 16.15534088700008],
              [108.33472741000003, 16.151516018000052],
              [108.33659915500004, 16.147772528000075],
              [108.34839928500003, 16.134711005000042],
              [108.33716881600003, 16.125392971000053],
              [108.32618248800003, 16.11904531500005],
              [108.31763756600003, 16.111761786000045],
              [108.31421959700003, 16.09992096600007],
              [108.30494225400003, 16.107163804000038],
              [108.27955162900003, 16.102036851000037],
              [108.26579837300005, 16.10740794500009],
              [108.25855553500003, 16.07099030200004],
              [108.26531009200005, 16.03156159100007],
              [108.27914472700007, 15.995672919000071],
              [108.28231855600006, 15.990057684000078],
              [108.29371178500003, 15.969631252000056],
              [108.30591881600003, 15.955226955000057],
              [108.35865319100003, 15.915432033000059],
              [108.37427819100003, 15.908270575000074],
              [108.38819420700003, 15.898382880000042],
              [108.39616946700005, 15.88084544500009],
              [108.38526451900003, 15.87889232000009],
              [108.37712649800005, 15.874212958000044],
              [108.37517337300005, 15.86945221600007],
              [108.38249759200005, 15.86717357000009],
              [108.38835696700005, 15.87055084800005],
              [108.39535566500007, 15.87726471600007],
              [108.40267988400007, 15.882391669000071],
              [108.40992272200003, 15.88084544500009],
              [108.41480553500003, 15.86741771000004],
              [108.42408287900003, 15.80573151200008],
              [108.45533287900003, 15.747015692000048],
              [108.61866295700003, 15.529242255000042],
              [108.64625084700003, 15.513861395000049],
              [108.68344160200007, 15.517767645000049],
              [108.67448978000004, 15.489406643000052],
              [108.66773522200003, 15.48265208500004],
              [108.65626061300003, 15.496649481000077],
              [108.64454186300003, 15.493109442000048],
              [108.62940514400003, 15.486517645000049],
              [108.62094160200007, 15.474758205000057],
              [108.62891686300003, 15.45571523600006],
              [108.65251712300005, 15.438788153000075],
              [108.66846764400003, 15.447821356000077],
              [108.69092858200003, 15.490423895000049],
              [108.69711347700007, 15.490423895000049],
              [108.70264733200003, 15.469916083000044],
              [108.70394941500007, 15.445135809000078],
              [108.70948326900003, 15.437689520000049],
              [108.73340905000003, 15.417914130000042],
              [108.73878014400003, 15.411322333000044],
              [108.74350019600007, 15.40729401200008],
              [108.76156660200007, 15.396551825000074],
              [108.76596113400007, 15.393866278000075],
              [108.77295983200003, 15.386786200000074],
              [108.77458743600005, 15.375067450000074],
              [108.77328535200007, 15.36318594000005],
              [108.77361087300005, 15.351263739000046],
              [108.77979576900003, 15.339585679000038],
              [108.77613366000003, 15.334458726000037],
              [108.77475019600007, 15.331366278000075],
              [108.77295983200003, 15.325344143000052],
              [108.77979576900003, 15.325344143000052],
              [108.78126061300003, 15.331000067000048],
              [108.78711998800003, 15.345851955000057],
              [108.79411868600005, 15.344671942000048],
              [108.80225670700003, 15.344305731000077],
              [108.82129967500003, 15.345851955000057],
              [108.82129967500003, 15.352687893000052],
              [108.79623457100007, 15.356390692000048],
              [108.78858483200003, 15.374172268000052],
              [108.79558353000004, 15.395086981000077],
              [108.81446373800003, 15.407904364000046],
              [108.81446373800003, 15.414740302000041],
              [108.80844160200007, 15.417669989000046],
              [108.80567467500003, 15.42055898600006],
              [108.80014082100007, 15.429022528000075],
              [108.80795332100007, 15.42523834800005],
              [108.81470787900003, 15.423570054000038],
              [108.82081139400003, 15.424750067000048],
              [108.82748457100007, 15.429022528000075],
              [108.83269290500004, 15.413885809000078],
              [108.83904056100005, 15.374335028000075],
              [108.84546959700003, 15.36627838700008],
              [108.85328209700003, 15.362616278000075],
              [108.87745201900003, 15.34398021000004],
              [108.88282311300003, 15.33616771000004],
              [108.88103274800005, 15.29913971600007],
              [108.88656660200007, 15.28620026200008],
              [108.91211998800003, 15.263495184000078],
              [108.92432701900003, 15.256415106000077],
              [108.93213951900003, 15.253973700000074],
              [108.94548587300005, 15.25291575700004],
              [108.95167076900003, 15.25023021000004],
              [108.94361412900003, 15.236883856000077],
              [108.93295332100007, 15.22719961100006],
              [108.91976972700007, 15.22211334800005],
              [108.90333092500003, 15.22288646000004],
              [108.90333092500003, 15.21548086100006],
              [108.91334069100003, 15.216376044000071],
              [108.91960696700005, 15.215236721000053],
              [108.92286217500003, 15.210760809000078],
              [108.92432701900003, 15.20180898600006],
              [108.91000410200007, 15.20929596600007],
              [108.90544681100005, 15.197943427000041],
              [108.90235436300003, 15.168646552000041],
              [108.89771569100003, 15.153998114000046],
              [108.88160241000003, 15.160630601000037],
              [108.86817467500003, 15.159654039000088],
              [108.86247806100005, 15.152492580000057],
              [108.86980228000004, 15.140366929000038],
              [108.87598717500003, 15.140366929000038],
              [108.88412519600007, 15.143947658000059],
              [108.89226321700005, 15.14134349200009],
              [108.89747155000003, 15.133205471000053],
              [108.89771569100003, 15.11985911700009],
              [108.90333092500003, 15.11985911700009],
              [108.90381920700003, 15.128159898000092],
              [108.90528405000003, 15.134344794000071],
              [108.91000410200007, 15.146633205000057],
              [108.91920006600003, 15.057806708000044],
              [108.94263756600003, 14.97955963700008],
              [109.00562584700003, 14.838771877000056],
              [108.98552493600005, 14.836615302000041],
              [108.99024498800003, 14.830633856000077],
              [109.01246178500003, 14.821966864000046],
              [109.01677493600005, 14.813055731000077],
              [109.03695722700007, 14.783636786000045],
              [109.04346764400003, 14.777289130000042],
              [109.08082116000003, 14.72947825700004],
              [109.08611087300005, 14.715318101000037],
              [109.09506269600007, 14.66742584800005],
              [109.08668053500003, 14.67133209800005],
              [109.08057701900003, 14.677476304000038],
              [109.07642662900003, 14.685614325000074],
              [109.07732181100005, 14.672471421000068],
              [109.08179772200003, 14.606390692000048],
              [109.08708743600005, 14.596096096000053],
              [109.08822675900007, 14.589260158000059],
              [109.08611087300005, 14.585272528000075],
              [109.07667076900003, 14.585679429000038],
              [109.07105553500003, 14.575100002000056],
              [109.06446373800003, 14.570379950000074],
              [109.06104576900003, 14.563706773000092],
              [109.06706790500004, 14.550726630000042],
              [109.07357832100007, 14.570502020000049],
              [109.07447350400003, 14.578599351000037],
              [109.10816491000003, 14.488714911000045],
              [109.12574303500003, 14.465399481000077],
              [109.13021894600007, 14.451605536000045],
              [109.12916100400003, 14.397406317000048],
              [109.13119550900007, 14.38344961100006],
              [109.13648522200003, 14.366848049000055],
              [109.14966881600003, 14.338446356000077],
              [109.18140709700003, 14.304754950000074],
              [109.19060306100005, 14.29124583500004],
              [109.19459069100003, 14.277492580000057],
              [109.20118248800003, 14.236029364000046],
              [109.19092858200003, 14.220526434000078],
              [109.20525149800005, 14.186102606000077],
              [109.23902428500003, 14.133002020000049],
              [109.22022545700003, 14.135239976000037],
              [109.21265709700003, 14.144680080000057],
              [109.20777428500003, 14.15696849200009],
              [109.19752037900003, 14.167792059000078],
              [109.17448978000004, 14.172064520000049],
              [109.17261803500003, 14.15656159100007],
              [109.18409264400003, 14.136297919000071],
              [109.21509850400003, 14.119574286000045],
              [109.22543379000007, 14.103989976000037],
              [109.25269616000003, 14.032619533000059],
              [109.26636803500003, 13.920721747000073],
              [109.27515709700003, 13.906724351000037],
              [109.30160566500007, 13.88580963700008],
              [109.30738366000003, 13.876369533000059],
              [109.30046634200005, 13.797796942000048],
              [109.30396569100003, 13.759263414000088],
              [109.29574629000007, 13.755601304000038],
              [109.26978600400003, 13.755601304000038],
              [109.26742597700007, 13.766302802000041],
              [109.27320397200003, 13.82453034100007],
              [109.25953209700003, 13.87400950700004],
              [109.25147545700003, 13.89093659100007],
              [109.23902428500003, 13.879787502000056],
              [109.23617597700007, 13.869614976000037],
              [109.23218834700003, 13.831976630000042],
              [109.22185306100005, 13.81321849200009],
              [109.22071373800003, 13.806138414000088],
              [109.23218834700003, 13.81085846600007],
              [109.23951256600003, 13.787665106000077],
              [109.24610436300003, 13.77960846600007],
              [109.25896243600005, 13.77732982000009],
              [109.24781334700003, 13.765448309000078],
              [109.23536217500003, 13.75608958500004],
              [109.22624759200005, 13.74359772300005],
              [109.22478274800005, 13.72211334800005],
              [109.23682701900003, 13.699611721000053],
              [109.23707116000003, 13.698594468000067],
              [109.23902428500003, 13.69139232000009],
              [109.23902428500003, 13.663763739000046],
              [109.24138431100005, 13.644029039000088],
              [109.24756920700003, 13.622707424000055],
              [109.25717207100007, 13.605617580000057],
              [109.26978600400003, 13.598578192000048],
              [109.27051842500003, 13.594183661000045],
              [109.28248131600003, 13.585150458000044],
              [109.29574629000007, 13.577704169000071],
              [109.30046634200005, 13.57811107000009],
              [109.30388431100005, 13.568793036000045],
              [109.30347741000003, 13.562201239000046],
              [109.29810631600003, 13.55849844000005],
              [109.28679446700005, 13.55760325700004],
              [109.28679446700005, 13.55076732000009],
              [109.29118899800005, 13.546576239000046],
              [109.29273522200003, 13.543524481000077],
              [109.29420006600003, 13.53034088700008],
              [109.28565514400003, 13.539007880000042],
              [109.26343834700003, 13.577053127000056],
              [109.25294030000003, 13.601629950000074],
              [109.22608483200003, 13.63190338700008],
              [109.21851647200003, 13.646958726000037],
              [109.21119225400003, 13.646958726000037],
              [109.21013431100005, 13.630804755000042],
              [109.21558678500003, 13.62368398600006],
              [109.22413170700003, 13.619533596000053],
              [109.23218834700003, 13.612250067000048],
              [109.23715254000007, 13.601385809000078],
              [109.24122155000003, 13.581529039000088],
              [109.24529056100005, 13.571234442000048],
              [109.25831139400003, 13.559759833000044],
              [109.26742597700007, 13.55467357000009],
              [109.26636803500003, 13.54873281500005],
              [109.26246178500003, 13.54393138200004],
              [109.25896243600005, 13.544623114000046],
              [109.26587975400003, 13.533880927000041],
              [109.28679446700005, 13.50922272300005],
              [109.29420006600003, 13.50922272300005],
              [109.29802493600005, 13.51471588700008],
              [109.30176842500003, 13.517523505000042],
              [109.31421959700003, 13.52289459800005],
              [109.31080162900003, 13.51312897300005],
              [109.30225670700003, 13.501532294000071],
              [109.30046634200005, 13.492743231000077],
              [109.30372155000003, 13.479885158000059],
              [109.31218509200005, 13.471625067000048],
              [109.32325280000003, 13.46979401200008],
              [109.33464603000004, 13.475734768000052],
              [109.33969160200007, 13.46548086100006],
              [109.33130944100003, 13.452093817000048],
              [109.33464603000004, 13.440904039000088],
              [109.32496178500003, 13.422308661000045],
              [109.31853274800005, 13.413763739000046],
              [109.30738366000003, 13.406805731000077],
              [109.29916425900007, 13.417466539000088],
              [109.27751712300005, 13.421616929000038],
              [109.27320397200003, 13.431057033000059],
              [109.27808678500003, 13.437933661000045],
              [109.28858483200003, 13.442206122000073],
              [109.29818769600007, 13.448431708000044],
              [109.30046634200005, 13.461371161000045],
              [109.29444420700003, 13.468166408000059],
              [109.26254316500007, 13.48932526200008],
              [109.25294030000003, 13.488674221000053],
              [109.24512780000003, 13.485174872000073],
              [109.23853600400003, 13.476752020000049],
              [109.23218834700003, 13.461371161000045],
              [109.23755944100003, 13.453192450000074],
              [109.23511803500003, 13.445379950000074],
              [109.23462975400003, 13.437079169000071],
              [109.24529056100005, 13.427232164000088],
              [109.23755944100003, 13.420070705000057],
              [109.23414147200003, 13.41006094000005],
              [109.23218834700003, 13.393133856000077],
              [109.24935957100007, 13.384711005000042],
              [109.26636803500003, 13.361802476000037],
              [109.28003991000003, 13.352769273000092],
              [109.29102623800003, 13.363104559000078],
              [109.29932701900003, 13.36469147300005],
              [109.30738366000003, 13.352769273000092],
              [109.30884850400003, 13.341457424000055],
              [109.30567467500003, 13.33388906500005],
              [109.29802493600005, 13.330267645000049],
              [109.28679446700005, 13.33104075700004],
              [109.28679446700005, 13.324896552000041],
              [109.29175866000003, 13.320379950000074],
              [109.29428144600007, 13.314642645000049],
              [109.29509524800005, 13.30727773600006],
              [109.29420006600003, 13.297552802000041],
              [109.28931725400003, 13.301174221000053],
              [109.27808678500003, 13.30687083500004],
              [109.27320397200003, 13.310614325000074],
              [109.26856530000003, 13.30182526200008],
              [109.26636803500003, 13.301214911000045],
              [109.25896243600005, 13.297552802000041],
              [109.27263431100005, 13.263251044000071],
              [109.28150475400003, 13.248968817000048],
              [109.29420006600003, 13.235500393000052],
              [109.29273522200003, 13.266791083000044],
              [109.29623457100007, 13.278876044000071],
              [109.30738366000003, 13.283880927000041],
              [109.30738366000003, 13.29010651200008],
              [109.30298912900003, 13.297796942000048],
              [109.30372155000003, 13.303168036000045],
              [109.30795332100007, 13.30377838700008],
              [109.31421959700003, 13.297552802000041],
              [109.31812584700003, 13.288885809000078],
              [109.32007897200003, 13.27952708500004],
              [109.32105553500003, 13.259019273000092],
              [109.31885826900003, 13.25141022300005],
              [109.30738366000003, 13.228664455000057],
              [109.30762780000003, 13.21865469000005],
              [109.31421959700003, 13.197943427000041],
              [109.31177819100003, 13.181708075000074],
              [109.30697675900007, 13.16632721600007],
              [109.30420983200003, 13.15062083500004],
              [109.30738366000003, 13.13304271000004],
              [109.31560306100005, 13.11945221600007],
              [109.32536868600005, 13.10687897300005],
              [109.33139082100007, 13.093573309000078],
              [109.32837975400003, 13.084662177000041],
              [109.34115644600007, 13.076605536000045],
              [109.34945722700007, 13.06826406500005],
              [109.37012780000003, 13.031805731000077],
              [109.39665774800005, 13.002752997000073],
              [109.41635175900007, 12.97174713700008],
              [109.45826256600003, 12.92405833500004],
              [109.46501712300005, 12.913316148000092],
              [109.46729576900003, 12.897691148000092],
              [109.46631920700003, 12.878973700000074],
              [109.46290123800003, 12.862127997000073],
              [109.45818118600005, 12.85187409100007],
              [109.45362389400003, 12.84992096600007],
              [109.43588300900007, 12.844875393000052],
              [109.43091881600003, 12.845119533000059],
              [109.42839603000004, 12.852118231000077],
              [109.43360436300003, 12.856838283000059],
              [109.44076582100007, 12.860663153000075],
              [109.44450931100005, 12.864935614000046],
              [109.44678795700003, 12.86904531500005],
              [109.45004316500007, 12.873236395000049],
              [109.44898522200003, 12.876695054000038],
              [109.43824303500003, 12.878607489000046],
              [109.41724694100003, 12.864935614000046],
              [109.41407311300003, 12.859767971000053],
              [109.40788821700005, 12.844142971000053],
              [109.40349368600005, 12.83820221600007],
              [109.39527428500003, 12.834906317000048],
              [109.38656660200007, 12.834418036000045],
              [109.38461347700007, 12.83397044500009],
              [109.37769616000003, 12.832424221000053],
              [109.36882571700005, 12.824611721000053],
              [109.37549889400003, 12.816351630000042],
              [109.37647545700003, 12.804348049000055],
              [109.37566165500004, 12.790350653000075],
              [109.37623131600003, 12.776190497000073],
              [109.42074629000007, 12.69131094000005],
              [109.43620853000004, 12.674221096000053],
              [109.45134524800005, 12.673773505000042],
              [109.46949303500003, 12.660345770000049],
              [109.47242272200003, 12.656398830000057],
              [109.46998131600003, 12.648627020000049],
              [109.46412194100003, 12.645900783000059],
              [109.45728600400003, 12.644110419000071],
              [109.45134524800005, 12.63898346600007],
              [109.44898522200003, 12.62409088700008],
              [109.45240319100003, 12.583238023000092],
              [109.45134524800005, 12.570746161000045],
              [109.44027754000007, 12.564601955000057],
              [109.42994225400003, 12.575873114000046],
              [109.41724694100003, 12.60545482000009],
              [109.41334069100003, 12.610256252000056],
              [109.40886478000004, 12.613104559000078],
              [109.40512129000007, 12.617987372000073],
              [109.40349368600005, 12.62881094000005],
              [109.40658613400007, 12.630682684000078],
              [109.42408287900003, 12.646429755000042],
              [109.42408287900003, 12.65265534100007],
              [109.40349368600005, 12.687445380000042],
              [109.40162194100003, 12.67796458500004],
              [109.39600670700003, 12.673081773000092],
              [109.38738040500004, 12.67186107000009],
              [109.37623131600003, 12.673773505000042],
              [109.38013756600003, 12.664862372000073],
              [109.38152103000004, 12.656398830000057],
              [109.38013756600003, 12.64789459800005],
              [109.37623131600003, 12.63898346600007],
              [109.37037194100003, 12.649115302000041],
              [109.36353600400003, 12.65623607000009],
              [109.35425866000003, 12.66006094000005],
              [109.34205162900003, 12.660101630000042],
              [109.36011803500003, 12.685288804000038],
              [109.36255944100003, 12.69049713700008],
              [109.36687259200005, 12.693426825000074],
              [109.37623131600003, 12.696926174000055],
              [109.38559004000007, 12.702460028000075],
              [109.38990319100003, 12.711615302000041],
              [109.38640384200005, 12.72752513200004],
              [109.36890709700003, 12.75023021000004],
              [109.36255944100003, 12.762518622000073],
              [109.36255944100003, 12.792914130000042],
              [109.35889733200003, 12.797308661000045],
              [109.34782962300005, 12.79482656500005],
              [109.34441165500004, 12.788641669000071],
              [109.34310957100007, 12.780747789000088],
              [109.33838951900003, 12.773098049000055],
              [109.30396569100003, 12.750881252000056],
              [109.29420006600003, 12.742010809000078],
              [109.26954186300003, 12.712307033000059],
              [109.25538170700003, 12.69912344000005],
              [109.24219811300003, 12.69358958500004],
              [109.23357181100005, 12.687079169000071],
              [109.20492597700007, 12.646429755000042],
              [109.20460045700003, 12.636908270000049],
              [109.20801842500003, 12.598049221000053],
              [109.20045006600003, 12.59125397300005],
              [109.20134524800005, 12.575913804000038],
              [109.20492597700007, 12.559719143000052],
              [109.20492597700007, 12.55023834800005],
              [109.20777428500003, 12.549221096000053],
              [109.21021569100003, 12.549261786000045],
              [109.21159915500004, 12.548041083000044],
              [109.21119225400003, 12.543402411000045],
              [109.21851647200003, 12.543402411000045],
              [109.22193444100003, 12.553615627000056],
              [109.22364342500003, 12.565252997000073],
              [109.22787519600007, 12.57453034100007],
              [109.23902428500003, 12.57758209800005],
              [109.23902428500003, 12.583726304000038],
              [109.23218834700003, 12.583726304000038],
              [109.23218834700003, 12.59125397300005],
              [109.24903405000003, 12.585516669000071],
              [109.24708092500003, 12.571966864000046],
              [109.23780358200003, 12.55540599200009],
              [109.23218834700003, 12.540350653000075],
              [109.23715254000007, 12.522284247000073],
              [109.24935957100007, 12.509507554000038],
              [109.29835045700003, 12.47797272300005],
              [109.30355879000007, 12.469631252000056],
              [109.29346764400003, 12.449042059000078],
              [109.29428144600007, 12.439032294000071],
              [109.29851321700005, 12.430812893000052],
              [109.30396569100003, 12.427394924000055],
              [109.31869550900007, 12.42218659100007],
              [109.33668053500003, 12.41014232000009],
              [109.34595787900003, 12.396307684000078],
              [109.33464603000004, 12.38572825700004],
              [109.34205162900003, 12.37889232000009],
              [109.33464603000004, 12.37213776200008],
              [109.32252037900003, 12.386053778000075],
              [109.31568444100003, 12.376898505000042],
              [109.30909264400003, 12.360052802000041],
              [109.29737389400003, 12.35101959800005],
              [109.28239993600005, 12.355943101000037],
              [109.27222741000003, 12.367743231000077],
              [109.25896243600005, 12.39256419500009],
              [109.21550540500004, 12.44017161700009],
              [109.18506920700003, 12.458929755000042],
              [109.15650475400003, 12.454657294000071],
              [109.16138756600003, 12.448797919000071],
              [109.16684004000007, 12.437974351000037],
              [109.17017662900003, 12.433539130000042],
              [109.15984134200005, 12.437933661000045],
              [109.15650475400003, 12.440375067000048],
              [109.14966881600003, 12.440375067000048],
              [109.15463300900007, 12.426906643000052],
              [109.17042076900003, 12.41038646000004],
              [109.17693118600005, 12.39940013200004],
              [109.19629967500003, 12.402777411000045],
              [109.20655358200003, 12.387152411000045],
              [109.21045983200003, 12.36318594000005],
              [109.21119225400003, 12.341376044000071],
              [109.21412194100003, 12.332912502000056],
              [109.22120201900003, 12.32249583500004],
              [109.22925866000003, 12.313706773000092],
              [109.24203535200007, 12.30540599200009],
              [109.24219811300003, 12.296576239000046],
              [109.23633873800003, 12.291083075000074],
              [109.22478274800005, 12.296372789000088],
              [109.21851647200003, 12.296372789000088],
              [109.21469160200007, 12.28978099200009],
              [109.20492597700007, 12.262884833000044],
              [109.18238366000003, 12.272609768000052],
              [109.17693118600005, 12.276516018000052],
              [109.18246504000007, 12.26780833500004],
              [109.19157962300005, 12.26040273600006],
              [109.21119225400003, 12.248602606000077],
              [109.20484459700003, 12.23338450700004],
              [109.20899498800003, 12.22166575700004],
              [109.21762129000007, 12.211493231000077],
              [109.22478274800005, 12.200832424000055],
              [109.19849694100003, 12.207953192000048],
              [109.18824303500003, 12.205755927000041],
              [109.18433678500003, 12.19399648600006],
              [109.19092858200003, 12.20018138200004],
              [109.19060306100005, 12.200832424000055],
              [109.20435631600003, 12.193793036000045],
              [109.20964603000004, 12.186021226000037],
              [109.21119225400003, 12.17283763200004],
              [109.21306399800005, 12.16600169500009],
              [109.21265709700003, 12.162665106000077],
              [109.21420332100007, 12.158596096000053],
              [109.22169030000003, 12.149603583000044],
              [109.22681725400003, 12.137884833000044],
              [109.22266686300003, 12.129055080000057],
              [109.21119225400003, 12.11823151200008],
              [109.20997155000003, 12.10968659100007],
              [109.21387780000003, 12.068101304000038],
              [109.22055097700007, 12.050604559000078],
              [109.24919681100005, 11.997381903000075],
              [109.25831139400003, 11.986761786000045],
              [109.28679446700005, 11.96743398600006],
              [109.28679446700005, 11.96116771000004],
              [109.28345787900003, 11.943508205000057],
              [109.28345787900003, 11.940130927000041],
              [109.26636803500003, 11.926459052000041],
              [109.26587975400003, 11.909898179000038],
              [109.27084394600007, 11.895005601000037],
              [109.28077233200003, 11.883937893000052],
              [109.29420006600003, 11.878648179000038],
              [109.29420006600003, 11.871242580000057],
              [109.27784264400003, 11.864813544000071],
              [109.26140384200005, 11.865708726000037],
              [109.24756920700003, 11.87295156500005],
              [109.23902428500003, 11.885443427000041],
              [109.23560631600003, 11.883368231000077],
              [109.22828209700003, 11.880804755000042],
              [109.22478274800005, 11.878648179000038],
              [109.21656334700003, 11.90884023600006],
              [109.22266686300003, 11.981634833000044],
              [109.21119225400003, 12.015814520000049],
              [109.21851647200003, 12.015814520000049],
              [109.19581139400003, 12.074896552000041],
              [109.18620853000004, 12.117743231000077],
              [109.17676842500003, 12.129461981000077],
              [109.16334069100003, 12.112005927000041],
              [109.17603600400003, 12.088568427000041],
              [109.18067467500003, 12.08470286700009],
              [109.18213951900003, 12.08104075700004],
              [109.17693118600005, 12.05304596600007],
              [109.18238366000003, 12.04287344000005],
              [109.20582116000003, 12.021633205000057],
              [109.21119225400003, 12.005601304000038],
              [109.20818118600005, 11.976629950000074],
              [109.19874108200003, 11.948146877000056],
              [109.18181399800005, 11.921698309000078],
              [109.15650475400003, 11.899115302000041],
              [109.13721764400003, 11.896063544000071],
              [109.12582441500007, 11.86359284100007],
              [109.13160241000003, 11.830023505000042],
              [109.16334069100003, 11.824042059000078],
              [109.16822350400003, 11.833197333000044],
              [109.18287194100003, 11.853013414000088],
              [109.19792728000004, 11.86945221600007],
              [109.20492597700007, 11.868109442000048],
              [109.20093834700003, 11.85382721600007],
              [109.19410241000003, 11.841131903000075],
              [109.19288170700003, 11.827541408000059],
              [109.20492597700007, 11.810370184000078],
              [109.20386803500003, 11.788682359000063],
              [109.20362389400003, 11.784572658000059],
              [109.24293053500003, 11.735663153000075],
              [109.23218834700003, 11.714178778000075],
              [109.22478274800005, 11.721625067000048],
              [109.21778405000003, 11.714097398000092],
              [109.20899498800003, 11.69367096600007],
              [109.19125410200007, 11.671942450000074],
              [109.18881269600007, 11.663234768000052],
              [109.18832441500007, 11.65330638200004],
              [109.18433678500003, 11.638495184000078],
              [109.17855879000007, 11.631659247000073],
              [109.16041100400003, 11.616441148000092],
              [109.15650475400003, 11.608343817000048],
              [109.15406334700003, 11.596991278000075],
              [109.14828535200007, 11.586086330000057],
              [109.13599694100003, 11.57021719000005],
              [109.12916100400003, 11.57021719000005],
              [109.11719811300003, 11.580267645000049],
              [109.10254967500003, 11.58104075700004],
              [109.08570397200003, 11.579779364000046],
              [109.06706790500004, 11.583807684000078],
              [109.05567467500003, 11.596625067000048],
              [109.04810631600003, 11.631333726000037],
              [109.04346764400003, 11.638495184000078],
              [109.02027428500003, 11.63279857000009],
              [109.02173912900003, 11.620306708000044],
              [109.03321373800003, 11.60765208500004],
              [109.04037519600007, 11.601507880000042],
              [109.03834069100003, 11.587713934000078],
              [109.03467858200003, 11.57412344000005],
              [109.03402754000007, 11.55955638200004],
              [109.04037519600007, 11.54287344000005],
              [109.01929772200003, 11.542303778000075],
              [109.01246178500003, 11.54287344000005],
              [109.02784264400003, 11.51748281500005],
              [109.02833092500003, 11.474269924000055],
              [109.01929772200003, 11.406317450000074],
              [109.02247155000003, 11.367621161000045],
              [109.01807701900003, 11.355902411000045],
              [109.00562584700003, 11.34365469000005],
              [108.98072350400003, 11.323716539000088],
              [108.96607506600003, 11.31476471600007],
              [108.95167076900003, 11.310126044000071],
              [108.93336022200003, 11.31118398600006],
              [108.88965905000003, 11.330633856000077],
              [108.87387129000007, 11.33388906500005],
              [108.85613040500004, 11.33397044500009],
              [108.83806399800005, 11.330755927000041],
              [108.82129967500003, 11.323716539000088],
              [108.78785241000003, 11.30068594000005],
              [108.77515709700003, 11.288478908000059],
              [108.76612389400003, 11.275946356000077],
              [108.75782311300003, 11.25779857000009],
              [108.74561608200003, 11.207098700000074],
              [108.73804772200003, 11.18968333500004],
              [108.72934004000007, 11.18154531500005],
              [108.71745853000004, 11.179185289000088],
              [108.70053144600007, 11.17914459800005],
              [108.69044030000003, 11.181463934000078],
              [108.66920006600003, 11.191229559000078],
              [108.65626061300003, 11.19281647300005],
              [108.64625084700003, 11.19049713700008],
              [108.62598717500003, 11.181789455000057],
              [108.61524498800003, 11.17914459800005],
              [108.57740319100003, 11.17914459800005],
              [108.57162519600007, 11.17601146000004],
              [108.55941816500007, 11.16242096600007],
              [108.53126061300003, 11.153265692000048],
              [108.51400800900007, 11.138739325000074],
              [108.50033613400007, 11.120835679000038],
              [108.49170983200003, 11.104681708000044],
              [108.48194420700003, 11.064032294000071],
              [108.47234134200005, 11.053168036000045],
              [108.44703209700003, 11.04946523600006],
              [108.43913821700005, 11.046698309000078],
              [108.40357506600003, 11.028957424000055],
              [108.39307701900003, 11.027085679000038],
              [108.37631269600007, 11.026271877000056],
              [108.36882571700005, 11.022772528000075],
              [108.36280358200003, 11.009711005000042],
              [108.34986412900003, 10.96385325700004],
              [108.34498131600003, 10.953802802000041],
              [108.32520592500003, 10.951564846000053],
              [108.31544030000003, 10.94432200700004],
              [108.30005944100003, 10.91282786700009],
              [108.29371178500003, 10.91282786700009],
              [108.28532962300005, 10.94334544500009],
              [108.25863691500007, 10.95180898600006],
              [108.13502037900003, 10.927679755000042],
              [108.10645592500003, 10.918158270000049],
              [108.09449303500003, 10.902004299000055],
              [108.08912194100003, 10.89203522300005],
              [108.06568444100003, 10.867987372000073],
              [108.06031334700003, 10.854193427000041],
              [108.05713951900003, 10.84210846600007],
              [108.04297936300003, 10.81391022300005],
              [108.03541100400003, 10.772772528000075],
              [107.99830162900003, 10.699367580000057],
              [107.99146569100003, 10.699367580000057],
              [107.98064212300005, 10.70579661700009],
              [107.93628991000003, 10.718695380000042],
              [107.91944420700003, 10.721096096000053],
              [107.89820397200003, 10.719956773000092],
              [107.88233483200003, 10.716986395000049],
              [107.82390384200005, 10.69236888200004],
              [107.78223717500003, 10.657782294000071],
              [107.76832116000003, 10.650213934000078],
              [107.73129316500007, 10.637884833000044],
              [107.66627037900003, 10.60374583500004],
              [107.64454186300003, 10.60065338700008],
              [107.62134850400003, 10.592596747000073],
              [107.58651777400007, 10.573513088000084],
              [107.58057701900003, 10.570257880000042],
              [107.57048587300005, 10.562241929000038],
              [107.54420006600003, 10.53620026200008],
              [107.53907311300003, 10.525580145000049],
              [107.53052819100003, 10.512925523000092],
              [107.51140384200005, 10.501654364000046],
              [107.44752037900003, 10.473334052000041],
              [107.42953535200007, 10.468451239000046],
              [107.38461347700007, 10.462836005000042],
              [107.34498131600003, 10.450425523000092],
              [107.33415774800005, 10.453558661000045],
              [107.32601972700007, 10.44245026200008],
              [107.29664147200003, 10.415716864000046],
              [107.27198326900003, 10.378485419000071],
              [107.25440514400003, 10.37889232000009],
              [107.21631920700003, 10.401556708000044],
              [107.19019616000003, 10.405178127000056],
              [107.19499759200005, 10.41404857000009],
              [107.20313561300003, 10.417222398000092],
              [107.21168053500003, 10.41937897300005],
              [107.21753991000003, 10.425604559000078],
              [107.21697024800005, 10.434475002000056],
              [107.21192467500003, 10.443548895000049],
              [107.20541425900007, 10.450669664000088],
              [107.20045006600003, 10.453558661000045],
              [107.19564863400007, 10.45701732000009],
              [107.17595462300005, 10.477443752000056],
              [107.17123457100007, 10.47646719000005],
              [107.16089928500003, 10.476507880000042],
              [107.14942467500003, 10.477932033000059],
              [107.14177493600005, 10.480861721000053],
              [107.14177493600005, 10.466620184000078],
              [107.13550866000003, 10.466620184000078],
              [107.12273196700005, 10.480210679000038],
              [107.10279381600003, 10.489935614000046],
              [107.08179772200003, 10.491603908000059],
              [107.06609134200005, 10.480861721000053],
              [107.05982506600003, 10.480861721000053],
              [107.06267337300005, 10.489569403000075],
              [107.06324303500003, 10.495062567000048],
              [107.05982506600003, 10.508205471000053],
              [107.05046634200005, 10.488470770000049],
              [107.04322350400003, 10.479803778000075],
              [107.03191165500004, 10.47406647300005],
              [107.02621504000007, 10.493109442000048],
              [107.02564537900003, 10.501369533000059],
              [107.01099694100003, 10.49412669500009],
              [107.00359134200005, 10.48859284100007],
              [106.99781334700003, 10.480861721000053],
              [106.99146569100003, 10.480861721000053],
              [106.99439537900003, 10.496649481000077],
              [107.00416100400003, 10.504706122000073],
              [107.01417076900003, 10.508693752000056],
              [107.01596113400007, 10.509426174000055],
              [107.02564537900003, 10.515041408000059],
              [107.03272545700003, 10.525946356000077],
              [107.03419030000003, 10.53587474200009],
              [107.03191165500004, 10.607489325000074],
              [107.02898196700005, 10.613836981000077],
              [107.01579837300005, 10.627752997000073],
              [107.01140384200005, 10.637884833000044],
              [107.01465905000003, 10.63548411700009],
              [107.02564537900003, 10.631048895000049],
              [107.02531985800005, 10.635280666000085],
              [107.02369225400003, 10.656317450000074],
              [107.01319420700003, 10.672674872000073],
              [106.98414147200003, 10.699367580000057],
              [106.97974694100003, 10.684759833000044],
              [106.99008222700007, 10.673570054000038],
              [107.00424238400007, 10.664252020000049],
              [107.01140384200005, 10.65525950700004],
              [107.00261478000004, 10.630438544000071],
              [107.00245201900003, 10.61709219000005],
              [107.01482181100005, 10.61123281500005],
              [107.02507571700005, 10.603908596000053],
              [107.02271569100003, 10.587591864000046],
              [107.01140384200005, 10.56281159100007],
              [107.01441491000003, 10.555487372000073],
              [107.02133222700007, 10.550116278000075],
              [107.02686608200003, 10.544175523000092],
              [107.02564537900003, 10.53546784100007],
              [107.01905358200003, 10.533880927000041],
              [107.00977623800003, 10.53896719000005],
              [106.99781334700003, 10.54913971600007],
              [107.00513756600003, 10.555975653000075],
              [106.99146569100003, 10.570257880000042],
              [106.99146569100003, 10.57648346600007],
              [106.99634850400003, 10.585191148000092],
              [106.99822024800005, 10.597235419000071],
              [106.99781334700003, 10.62490469000005],
              [106.99146569100003, 10.62490469000005],
              [106.98487389400003, 10.596828518000052],
              [106.98414147200003, 10.566880601000037],
              [106.99195397200003, 10.54010651200008],
              [107.01140384200005, 10.521877346000053],
              [107.00359134200005, 10.517767645000049],
              [106.99439537900003, 10.512884833000044],
              [106.97217858200003, 10.474269924000055],
              [106.96363366000003, 10.466620184000078],
              [106.95720462300005, 10.47166575700004],
              [106.95866946700005, 10.48045482000009],
              [106.96265709700003, 10.491034247000073],
              [106.96363366000003, 10.501369533000059],
              [106.95932050900007, 10.511867580000057],
              [106.95460045700003, 10.516506252000056],
              [106.94898522200003, 10.52057526200008],
              [106.94312584700003, 10.52928294500009],
              [106.93775475400003, 10.54873281500005],
              [106.93824303500003, 10.56663646000004],
              [106.94312584700003, 10.60065338700008],
              [106.89055423300005, 10.644639390000066],
              [106.88160241000003, 10.652167059000078],
              [106.86776777400007, 10.645209052000041],
              [106.84864342500003, 10.635565497000073],
              [106.82862389400003, 10.630275783000059],
              [106.81959069100003, 10.641302802000041],
              [106.81421959700003, 10.652167059000078],
              [106.80128014400003, 10.666937567000048],
              [106.79354902400007, 10.673529364000046],
              [106.78581790500004, 10.680121161000045],
              [106.77247155000003, 10.686346747000073],
              [106.76815839900007, 10.68467845300006],
              [106.76726321700005, 10.68431224200009],
              [106.74756920700003, 10.673651434000078],
              [106.74146569100003, 10.669256903000075],
              [106.73682701900003, 10.658148505000042],
              [106.74366295700003, 10.651516018000052],
              [106.75367272200003, 10.64679596600007],
              [106.75879967500003, 10.641302802000041],
              [106.76099694100003, 10.631537177000041],
              [106.77247155000003, 10.60374583500004],
              [106.76905358200003, 10.592271226000037],
              [106.76392662900003, 10.58665599200009],
              [106.75782311300003, 10.582709052000041],
              [106.75196373800003, 10.57648346600007],
              [106.74610436300003, 10.560370184000078],
              [106.74406985800005, 10.552232164000088],
              [106.74097741000003, 10.539984442000048],
              [106.73340905000003, 10.52244700700004],
              [106.72087649800005, 10.515041408000059],
              [106.68881269600007, 10.503648179000038],
              [106.67237389400003, 10.50421784100007],
              [106.66260826900003, 10.521877346000053],
              [106.65577233200003, 10.521877346000053],
              [106.65919030000003, 10.507066148000092],
              [106.66244550900007, 10.501125393000052],
              [106.66871178500003, 10.494533596000053],
              [106.65772545700003, 10.492132880000042],
              [106.64649498800003, 10.48663971600007],
              [106.63803144600007, 10.478989976000037],
              [106.63038170700003, 10.458685614000046],
              [106.62012780000003, 10.452622789000088],
              [106.60678144600007, 10.447658596000053],
              [106.59424889400003, 10.439276434000078],
              [106.59489993600005, 10.456000067000048],
              [106.59213300900007, 10.468695380000042],
              [106.58716881600003, 10.47882721600007],
              [106.57992597700007, 10.48773834800005],
              [106.58187910200007, 10.452785549000055],
              [106.58676191500007, 10.438706773000092],
              [106.59742272200003, 10.43305084800005],
              [106.61540774800005, 10.43659088700008],
              [106.63005618600005, 10.445786851000037],
              [106.64136803500003, 10.458929755000042],
              [106.64893639400003, 10.47406647300005],
              [106.65577233200003, 10.47406647300005],
              [106.66065514400003, 10.460109768000052],
              [106.66293379000007, 10.443915106000077],
              [106.67017662900003, 10.432562567000048],
              [106.68978925900007, 10.43305084800005],
              [106.69800866000003, 10.440985419000071],
              [106.71363366000003, 10.468085028000075],
              [106.72413170700003, 10.47406647300005],
              [106.74105879000007, 10.468003648000092],
              [106.75171959700003, 10.453517971000053],
              [106.75977623800003, 10.436346747000073],
              [106.76905358200003, 10.42251211100006],
              [106.78199303500003, 10.407782294000071],
              [106.78809655000003, 10.393133856000077],
              [106.79542076900003, 10.306830145000049],
              [106.79078209700003, 10.284857489000046],
              [106.77556399800005, 10.27537669500009],
              [106.75603274800005, 10.277167059000078],
              [106.70411217500003, 10.28904857000009],
              [106.59831790500004, 10.28851959800005],
              [106.52523847700007, 10.302557684000078],
              [106.48755944100003, 10.30272044500009],
              [106.46802819100003, 10.307318427000041],
              [106.45232181100005, 10.316148179000038],
              [106.43767337300005, 10.321844794000071],
              [106.42237389400003, 10.316961981000077],
              [106.48031660200007, 10.280829169000071],
              [106.72087649800005, 10.199693101000037],
              [106.72624759200005, 10.196478583000044],
              [106.74236087300005, 10.18235911700009],
              [106.74830162900003, 10.179185289000088],
              [106.75359134200005, 10.177069403000075],
              [106.75831139400003, 10.172349351000037],
              [106.76514733200003, 10.167669989000046],
              [106.77556399800005, 10.165513414000088],
              [106.78565514400003, 10.164943752000056],
              [106.79314212300005, 10.162502346000053],
              [106.79761803500003, 10.15721263200004],
              [106.79908287900003, 10.148138739000046],
              [106.79712975400003, 10.125392971000053],
              [106.79127037900003, 10.110174872000073],
              [106.73707116000003, 10.05414459800005],
              [106.72087649800005, 10.04490794500009],
              [106.70411217500003, 10.048895575000074],
              [106.70923912900003, 10.05662669500009],
              [106.71029707100007, 10.06586334800005],
              [106.70834394600007, 10.07526276200008],
              [106.70411217500003, 10.083644924000055],
              [106.69662519600007, 10.083644924000055],
              [106.69214928500003, 10.066595770000049],
              [106.68978925900007, 10.062567450000074],
              [106.67676842500003, 10.049221096000053],
              [106.67115319100003, 10.04100169500009],
              [106.66871178500003, 10.032416083000044],
              [106.67253665500004, 10.029486395000049],
              [106.67953535200007, 10.020982164000088],
              [106.68409264400003, 10.01203034100007],
              [106.67953535200007, 10.007961330000057],
              [106.66423587300005, 10.00608958500004],
              [106.66081790500004, 10.001450914000088],
              [106.66098066500007, 9.99485911700009],
              [106.65398196700005, 9.98501211100006],
              [106.65154056100005, 9.97752513200004],
              [106.64893639400003, 9.974351304000038],
              [106.64486738400007, 9.97337474200009],
              [106.60743248800003, 9.97483958500004],
              [106.59107506600003, 9.98078034100007],
              [106.57691491000003, 9.991034247000073],
              [106.56299889400003, 10.004461981000077],
              [106.54786217500003, 10.015366929000038],
              [106.49805748800003, 10.035834052000041],
              [106.46892337300005, 10.058986721000053],
              [106.44336998800003, 10.089544989000046],
              [106.35987389400003, 10.22068919500009],
              [106.33122806100005, 10.249497789000088],
              [106.29200280000003, 10.26170482000009],
              [106.29737389400003, 10.255926825000074],
              [106.30274498800003, 10.253322658000059],
              [106.30787194100003, 10.25141022300005],
              [106.33790123800003, 10.228094794000071],
              [106.34937584700003, 10.21482982000009],
              [106.35816491000003, 10.176581122000073],
              [106.36850019600007, 10.155910549000055],
              [106.46168053500003, 10.035711981000077],
              [106.48438561300003, 10.015326239000046],
              [106.56153405000003, 9.97915273600006],
              [106.61426842500003, 9.939032294000071],
              [106.67058353000004, 9.909409898000092],
              [106.68637129000007, 9.905462958000044],
              [106.69629967500003, 9.896551825000074],
              [106.69320722700007, 9.87641022300005],
              [106.68246504000007, 9.855129299000055],
              [106.66871178500003, 9.84284088700008],
              [106.66871178500003, 9.85024648600006],
              [106.67505944100003, 9.857611395000049],
              [106.67644290500004, 9.866766669000071],
              [106.67408287900003, 9.876125393000052],
              [106.66871178500003, 9.883734442000048],
              [106.66260826900003, 9.883734442000048],
              [106.65788821700005, 9.84861888200004],
              [106.63786868600005, 9.825995184000078],
              [106.61133873800003, 9.81704336100006],
              [106.58676191500007, 9.822943427000041],
              [106.56332441500007, 9.84178294500009],
              [106.50440514400003, 9.905462958000044],
              [106.47974694100003, 9.923976955000057],
              [106.39503014400003, 9.974351304000038],
              [106.14486738400007, 10.228583075000074],
              [106.13648522200003, 10.234564520000049],
              [106.12728925900007, 10.239447333000044],
              [106.12134850400003, 10.240668036000045],
              [106.11817467500003, 10.238104559000078],
              [106.11329186300003, 10.23427969000005],
              [106.11784915500004, 10.22923411700009],
              [106.12745201900003, 10.224798895000049],
              [106.13502037900003, 10.22016022300005],
              [106.15788821700005, 10.195379950000074],
              [106.16602623800003, 10.18109772300005],
              [106.17286217500003, 10.14752838700008],
              [106.18213951900003, 10.13304271000004],
              [106.19336998800003, 10.120266018000052],
              [106.21509850400003, 10.100287177000041],
              [106.24642988400007, 10.077460028000075],
              [106.28321373800003, 10.05068594000005],
              [106.29200280000003, 10.04205963700008],
              [106.29818769600007, 10.033270575000074],
              [106.30665123800003, 10.01666901200008],
              [106.31251061300003, 10.007961330000057],
              [106.36361738400007, 9.960109768000052],
              [106.36931399800005, 9.95693594000005],
              [106.38892662900003, 9.932806708000044],
              [106.47575931100005, 9.861802476000037],
              [106.50098717500003, 9.834051825000074],
              [106.51856530000003, 9.80182526200008],
              [106.52751712300005, 9.762193101000037],
              [106.53785241000003, 9.751166083000044],
              [106.56299889400003, 9.747219143000052],
              [106.57496178500003, 9.739081122000073],
              [106.57984459700003, 9.720363674000055],
              [106.58057701900003, 9.699693101000037],
              [106.57553144600007, 9.648627020000049],
              [106.56316165500004, 9.61432526200008],
              [106.54371178500003, 9.58502838700008],
              [106.51856530000003, 9.562892971000053],
              [106.49724368600005, 9.549994208000044],
              [106.48487389400003, 9.54710521000004],
              [106.47348066500007, 9.551988023000092],
              [106.46436608200003, 9.554754950000074],
              [106.45394941500007, 9.550523179000038],
              [106.43946373800003, 9.541164455000057],
              [106.39820397200003, 9.54205963700008],
              [106.38502037900003, 9.54828522300005],
              [106.33716881600003, 9.58470286700009],
              [106.25033613400007, 9.63117096600007],
              [106.06470787900003, 9.804266669000071],
              [105.97046959700003, 9.920843817000048],
              [105.93287194100003, 9.95538971600007],
              [105.90406334700003, 9.97646719000005],
              [105.86947675900007, 9.98533763200004],
              [105.83806399800005, 10.005031643000052],
              [105.81902103000004, 10.007961330000057],
              [105.83838951900003, 9.979437567000048],
              [105.90211022200003, 9.916693427000041],
              [106.07349694100003, 9.74795156500005],
              [106.07976321700005, 9.73078034100007],
              [106.08350670700003, 9.713080145000049],
              [106.09294681100005, 9.692938544000071],
              [106.19703209700003, 9.541164455000057],
              [106.20362389400003, 9.526841539000088],
              [106.20777428500003, 9.511460679000038],
              [106.21070397200003, 9.470038153000075],
              [106.20582116000003, 9.45734284100007],
              [106.16920006600003, 9.41819896000004],
              [106.17888431100005, 9.40843333500004],
              [106.18783613400007, 9.404486395000049],
              [106.19459069100003, 9.398993231000077],
              [106.19703209700003, 9.384711005000042],
              [106.19336998800003, 9.369330145000049],
              [106.18392988400007, 9.362209377000056],
              [106.15544681100005, 9.356838283000059],
              [106.01823978000004, 9.315252997000073],
              [105.86825605600006, 9.254706122000073],
              [105.75993899800005, 9.21092357000009],
              [105.53874759200005, 9.129339911000045],
              [105.51417076900003, 9.108587958000044],
              [105.47022545700003, 9.06195709800005],
              [105.44361412900003, 9.041489976000037],
              [105.43295332100007, 9.02830638200004],
              [105.42855879000007, 9.01072825700004],
              [105.42603600400003, 9.008002020000049],
              [105.41325931100005, 9.004706122000073],
              [105.40821373800003, 9.000555731000077],
              [105.40739993600005, 8.995917059000078],
              [105.40894616000003, 8.984767971000053],
              [105.40821373800003, 8.980047919000071],
              [105.33397583200008, 8.83969882200006],
              [105.31512603100003, 8.812237350000089],
              [105.29318429700004, 8.787854650000043],
              [105.25881984900008, 8.760465236000073],
              [105.21675151500006, 8.75451042900005],
              [105.18403084100004, 8.740881653000088],
              [105.15440735000004, 8.705858188000093],
              [105.12635954300004, 8.660141341000042],
              [105.10147229000006, 8.634275390000084],
              [105.03472808500004, 8.616218361000051],
              [104.85621178500003, 8.565578518000052],
              [104.83277428500003, 8.569159247000073],
              [104.82691491000003, 8.572658596000053],
              [104.82203209700003, 8.57713450700004],
              [104.81478925900007, 8.58112213700008],
              [104.75220787900008, 8.590765692000048],
              [104.72852623800003, 8.59951406500005],
              [104.72291100400008, 8.602687893000052],
              [104.72022545700003, 8.613755601000037],
              [104.72803795700003, 8.616359768000052],
              [104.74008222700007, 8.61204661700009],
              [104.75930129400007, 8.615620453000076],
              [104.80844160200007, 8.647650458000044],
              [104.81910241000003, 8.654038804000038],
              [104.82813561300003, 8.65656159100007],
              [104.83513431100005, 8.66046784100007],
              [104.83904056100005, 8.67096588700008],
              [104.83415774800005, 8.680975653000075],
              [104.82374108200003, 8.686224677000041],
              [104.81950931100005, 8.69086334800005],
              [104.83277428500003, 8.698879299000055],
              [104.84555097700007, 8.698146877000056],
              [104.91163170700003, 8.685207424000055],
              [104.92579186300003, 8.688381252000056],
              [104.94239342500003, 8.696437893000052],
              [104.95639082100007, 8.707424221000053],
              [104.96314537900008, 8.71938711100006],
              [104.93930097700007, 8.70807526200008],
              [104.90748131600003, 8.699611721000053],
              [104.87614993600005, 8.69920482000009],
              [104.85328209700003, 8.712551174000055],
              [104.84839928500003, 8.723578192000048],
              [104.85279381600003, 8.729193427000041],
              [104.86426842500003, 8.731756903000075],
              [104.88062584700003, 8.733628648000092],
              [104.90479576900003, 8.733628648000092],
              [104.91211998800003, 8.73533763200004],
              [104.92896569100003, 8.747300523000092],
              [104.92896569100003, 8.753485419000071],
              [104.91911868600005, 8.770453192000048],
              [104.91627037900008, 8.79047272300005],
              [104.92156009200005, 8.80931224200009],
              [104.85792076900003, 8.781439520000049],
              [104.81666100400008, 8.771307684000078],
              [104.79167462400005, 8.78406215700005],
              [104.77459454000007, 8.817867266000064],
              [104.78540149400004, 8.856102424000085],
              [104.79624328400007, 8.891231306000066],
              [104.81171701700003, 8.937049451000064],
              [104.80861189400008, 8.975284591000047],
              [104.80707275100008, 9.045571369000072],
              [104.81104576900003, 9.132635809000078],
              [104.81910241000003, 9.192938544000071],
              [104.82553144600007, 9.340033270000049],
              [104.82607212100004, 9.400965572000075],
              [104.83277428500003, 9.514471747000073],
              [104.83562259200005, 9.556219794000071],
              [104.85655764800003, 9.738036916000055],
              [104.87231897200007, 9.793017359000089],
              [104.89278923400008, 9.85109514000004],
              [104.93942915700006, 9.849564634000046],
              [104.96998131600003, 9.853664455000057],
              [104.97689863400007, 9.871242580000057],
              [104.99333743600005, 9.88812897300005],
              [105.05486087300005, 9.933417059000078],
              [105.07667076900003, 9.943426825000074],
              [105.08668053500003, 9.935939846000053],
              [105.08936608200003, 9.919867255000042],
              [105.11329186300003, 9.857082424000055],
              [105.11312910200007, 9.871039130000042],
              [105.10710696700005, 9.908596096000053],
              [105.10710696700005, 9.952704169000071],
              [105.10043379000007, 9.974107164000088],
              [105.08765709700003, 9.99673086100006],
              [105.04265384200005, 10.055080471000053],
              [105.00326582100007, 10.09210846600007],
              [104.98365319100003, 10.103461005000042],
              [104.96387780000003, 10.105861721000053],
              [104.92432701900003, 10.096258856000077],
              [104.90105228000004, 10.097316799000055],
              [104.86890709700003, 10.116115627000056],
              [104.84538821700005, 10.14720286700009],
              [104.82545006600003, 10.180853583000044],
              [104.80486087300005, 10.207098700000074],
              [104.77198326900003, 10.226629950000074],
              [104.73853600400008, 10.231390692000048],
              [104.70736738400007, 10.222316799000055],
              [104.68132571700005, 10.199693101000037],
              [104.67790774800005, 10.19009023600006],
              [104.67807050900007, 10.181341864000046],
              [104.67562910200007, 10.17487213700008],
              [104.66456139400003, 10.172349351000037],
              [104.65837649800005, 10.168036200000074],
              [104.65414472700007, 10.148830471000053],
              [104.65088951900003, 10.144476630000042],
              [104.61597741000003, 10.146429755000042],
              [104.61304772200003, 10.144476630000042],
              [104.60767662900008, 10.153509833000044],
              [104.60971113400007, 10.159979559000078],
              [104.61353600400008, 10.167385158000059],
              [104.61304772200003, 10.179185289000088],
              [104.60873457100007, 10.185736395000049],
              [104.59546959700003, 10.200873114000046],
              [104.59253991000003, 10.210272528000075],
              [104.59253991000003, 10.237534898000092],
              [104.58887780000003, 10.260891018000052],
              [104.57935631600003, 10.27484772300005],
              [104.55152428500003, 10.29588450700004],
              [104.54737389400003, 10.289455471000053],
              [104.54615319100003, 10.286688544000071],
              [104.54542076900003, 10.28221263200004],
              [104.53736412900008, 10.28221263200004],
              [104.53589928500003, 10.30955638200004],
              [104.52588951900003, 10.32884349200009],
              [104.50375410200007, 10.357367255000042],
              [104.49903405000003, 10.370591539000088],
              [104.50196373800003, 10.37295156500005],
              [104.50912519600007, 10.372707424000055],
              [104.51742597700007, 10.378485419000071],
              [104.52507571700005, 10.389837958000044],
              [104.53003991000003, 10.399603583000044],
              [104.53052819100003, 10.409084377000056],
              [104.52491295700003, 10.419419664000088],
              [104.51742597700007, 10.419419664000088],
              [104.50945071700005, 10.403998114000046],
              [104.49903405000003, 10.391831773000092],
              [104.48585045700003, 10.383286851000037],
              [104.46957441500007, 10.378485419000071],
              [104.45362389400003, 10.379828192000048],
              [104.45313561300003, 10.390692450000074],
              [104.45582116000003, 10.407171942000048],
              [104.45134524800005, 10.419663804000024],
              [104.46957116700003, 10.415773620000024],
              [104.4837305100001, 10.418047383000044],
              [104.49427250200006, 10.427736715000066],
              [104.5359753830001, 10.487991435000126],
              [104.54429528800006, 10.50377858500012],
              [104.55401045700006, 10.518325500000074],
              [104.56682621300007, 10.528066508000038],
              [104.58253584800013, 10.531528829000067],
              [104.62553064000014, 10.533363342000072],
              [104.70063406700007, 10.524230557000081],
              [104.72442453000014, 10.521337570000071],
              [104.7738420010001, 10.515328268000061],
              [104.81880049700004, 10.517188619000066],
              [104.85440555800011, 10.531322123000109],
              [104.87853845300009, 10.55597178100001],
              [104.91972456900004, 10.618009338000064],
              [104.93135176600003, 10.630695902000113],
              [104.94432255100003, 10.641625469000076],
              [105.04245609600008, 10.690821431000046],
              [105.06674401900011, 10.713946635000127],
              [105.06622725400007, 10.746425272000053],
              [105.03046716400013, 10.81164093100007],
              [105.01480920400007, 10.849209696000088],
              [105.01139856000009, 10.883832906000094],
              [105.01785811400003, 10.899594218000075],
              [105.02907190000008, 10.914089457000017],
              [105.03854802900003, 10.922582214000073],
              [105.0427661540001, 10.926362610000055],
              [105.05578861600003, 10.935457662000118],
              [105.07790612800005, 10.946903992000031],
              [105.08374556500013, 10.942614848000062],
              [105.08607100500006, 10.929514873000102],
              [105.09754317200009, 10.914347840000076],
              [105.11175419200003, 10.909567769000077],
              [105.20914500700007, 10.891647006000127],
              [105.25329593900011, 10.883522848000013],
              [105.2686955160001, 10.873652649000121],
              [105.30300866800007, 10.844016215000067],
              [105.31789148000013, 10.838848572000074],
              [105.32750329600003, 10.848279520000034],
              [105.35726892200006, 10.907965800000056],
              [105.39788659700008, 10.954577942000114],
              [105.41049564700012, 10.963001201000097],
              [105.41504317300013, 10.960727438000077],
              [105.44336185700013, 10.952975972000075],
              [105.46578942900004, 10.941839702000053],
              [105.47385095200013, 10.940909526000098],
              [105.52360324500012, 10.951293531000132],
              [105.61723995200003, 10.970836832000145],
              [105.63218754100012, 10.973956605000083],
              [105.65492517100012, 10.98429189000008],
              [105.67378706900013, 10.996254984000132],
              [105.6740454510001, 10.996410014000077],
              [105.69729984600013, 11.010233460000038],
              [105.72613529500006, 11.018372498000048],
              [105.75290368700013, 11.015607808000098],
              [105.76969852700012, 10.996461691000093],
              [105.7874235430001, 10.96597259500001],
              [105.82142663600007, 10.919670512000039],
              [105.82855798300011, 10.904503479000098],
              [105.84003015200011, 10.869699402000052],
              [105.84752323500004, 10.855410868000064],
              [105.8610107830001, 10.839313660000087],
              [105.87868412300003, 10.828074036000132],
              [105.89935469600005, 10.828384094000029],
              [105.90865645400004, 10.838383484000047],
              [105.92049035700006, 10.858149719000025],
              [105.92984379100011, 10.880060526000065],
              [105.93134240700005, 10.896364441000088],
              [105.9646737060001, 10.869596049000023],
              [105.97397546400009, 10.858821513000095],
              [105.99257897900009, 10.837815043000091],
              [106.01790043100004, 10.81980580600009],
              [106.04570235300008, 10.805853170000105],
              [106.07221236200007, 10.796861470000067],
              [106.1288497320001, 10.791357931000064],
              [106.15504968300007, 10.784846701000092],
              [106.17732222500007, 10.766863302000019],
              [106.15158736200004, 10.862981466000122],
              [106.12693770400006, 10.90899932900004],
              [106.12182173700006, 10.925225729000132],
              [106.1234237060001, 10.92744781500005],
              [106.12466394100005, 10.953182678000132],
              [106.12249353000004, 10.955508118000068],
              [106.12817793800008, 10.965714214000045],
              [106.13143355300008, 10.969279887000098],
              [106.14910689300007, 10.971295268000063],
              [106.17038952300004, 10.970602023000069],
              [106.18083622300003, 10.97026173900008],
              [106.18786421700003, 10.976307882000114],
              [106.1766504310001, 10.99620330800012],
              [106.16032067900005, 11.053512472000094],
              [106.14874515800011, 11.070720724000068],
              [106.13086511200004, 11.084234111000043],
              [106.11350183200011, 11.086921285000074],
              [106.09810225500013, 11.077903748000026],
              [106.08663008600013, 11.056328837000066],
              [106.07650150600006, 11.077025249000087],
              [106.06306563300012, 11.093329163000107],
              [106.02813236500003, 11.122655538000075],
              [106.01314620000005, 11.139269511000094],
              [105.98875492400003, 11.176967469000132],
              [105.97397546400009, 11.190377503000079],
              [105.92043868100006, 11.203322449000098],
              [105.89987146100009, 11.218592835000052],
              [105.88943282100013, 11.246239726000056],
              [105.88943282100013, 11.2463947560001],
              [105.88674564700011, 11.267943828000057],
              [105.87351648000003, 11.275901998000023],
              [105.85718672700006, 11.279958598000121],
              [105.84442264800009, 11.289880473000025],
              [105.84344079600004, 11.304091492000083],
              [105.85997725500005, 11.379306539000112],
              [105.87103601100006, 11.413283793000048],
              [105.87382653800012, 11.428244121000105],
              [105.87217289300003, 11.443462830000044],
              [105.85666996300012, 11.496276144000092],
              [105.85884037300013, 11.522321066000075],
              [105.85780684500003, 11.535627747000092],
              [105.85320764200009, 11.546867371000047],
              [105.84214888500009, 11.554954732000041],
              [105.81553552300005, 11.559760640000135],
              [105.80333988500013, 11.56622019400001],
              [105.79317921600011, 11.582883693000028],
              [105.79042077700012, 11.587407532000057],
              [105.79341800900005, 11.607302958000062],
              [105.80489017800005, 11.624924622000051],
              [105.81801599200003, 11.638980612000069],
              [105.82098599000011, 11.641473529000095],
              [105.84085697500012, 11.658152568000077],
              [105.85791019700008, 11.661563212000104],
              [105.90550419200008, 11.644303284000017],
              [105.93408125800005, 11.642856343000119],
              [105.94617354400003, 11.657067363000081],
              [105.95526859600011, 11.67799631800007],
              [105.9830705170001, 11.70667673800007],
              [105.98875492400003, 11.718975729000107],
              [105.99128706900012, 11.732463278000068],
              [105.99211389200013, 11.746312561000124],
              [106.01541996200007, 11.770497131000099],
              [106.06120528100013, 11.76290069600013],
              [106.11319177300004, 11.747087707000048],
              [106.15463627200006, 11.746312561000124],
              [106.22362430900006, 11.724970195000125],
              [106.24320967600005, 11.714583232000109],
              [106.25075443600008, 11.706056620000098],
              [106.26512048400008, 11.683990783000098],
              [106.27411218300006, 11.676807760000145],
              [106.28734135000013, 11.674585673000138],
              [106.34366866100004, 11.68905507500007],
              [106.35431400500005, 11.690140279000076],
              [106.36418420400003, 11.688538310000041],
              [106.37808516400003, 11.68383575500006],
              [106.40009932400011, 11.668539530000103],
              [106.41281172700013, 11.661769918000061],
              [106.42583418800007, 11.662079976000143],
              [106.43503259300007, 11.677272848000072],
              [106.43458746300013, 11.678428127000089],
              [106.42609257100003, 11.70047556600008],
              [106.39885909000003, 11.746312561000124],
              [106.39777388500005, 11.762125549000118],
              [106.40314823400013, 11.775871481000067],
              [106.41136478700002, 11.789152323000067],
              [106.41828942900003, 11.803415019000056],
              [106.41963301700008, 11.812044983000092],
              [106.42025313300007, 11.83095855700013],
              [106.42139001500004, 11.837573141000036],
              [106.43616947400011, 11.861189270000054],
              [106.43875329700006, 11.863721416000132],
              [106.43312056500014, 11.88837107300013],
              [106.40350996900003, 11.942889709000042],
              [106.39541619700003, 11.965807400000088],
              [106.39400150500012, 11.969813131000066],
              [106.41746260600007, 11.9758592740001],
              [106.42914148000006, 11.976841126000068],
              [106.44206058800006, 11.97487742100013],
              [106.45105228700004, 11.968469544000087],
              [106.45513472600004, 11.959736226000118],
              [106.46050907400007, 11.952914938000063],
              [106.47373824100009, 11.952088115000052],
              [106.50453739500006, 11.973378804000035],
              [106.55244144700009, 11.972810364000068],
              [106.63858606000008, 11.9611314900001],
              [106.63062788900004, 11.976169332000083],
              [106.68049564600005, 11.96505889900007],
              [106.70157963000003, 11.970794983000118],
              [106.72111332300011, 11.996374817000074],
              [106.7327921960001, 12.028879293000017],
              [106.74922530100014, 12.05234039300008],
              [106.77196293200012, 12.065827942000055],
              [106.79056193400004, 12.067408857000117],
              [106.80296879100007, 12.068463440000059],
              [106.87929488100008, 12.06272735600001],
              [106.91629520700013, 12.06691314700005],
              [106.95339888600012, 12.081072490000082],
              [106.97768680900003, 12.097247213000088],
              [107.04600305200006, 12.164374899000023],
              [107.07757735200005, 12.202770487000052],
              [107.10424239100013, 12.221218974000067],
              [107.11623132300008, 12.232122702000126],
              [107.1229492600001, 12.246230367000067],
              [107.15250817900011, 12.27702952100013],
              [107.21188440000003, 12.305709941000117],
              [107.22782438100006, 12.310591880000104],
              [107.27616988100004, 12.32539866100008],
              [107.32019820200009, 12.329222718000025],
              [107.34381433100009, 12.315115051000078],
              [107.37378666200004, 12.269433086000063],
              [107.39301029500007, 12.252844950000068],
              [107.41585127800005, 12.254085185000093],
              [107.44964766500004, 12.299043681000114],
              [107.4737805580001, 12.315373434000051],
              [107.49956709800011, 12.32581207300008],
              [107.51429488200012, 12.34384714800008],
              [107.52225305200005, 12.36658477800006],
              [107.52726566600006, 12.391131083000033],
              [107.55666955600003, 12.472676494000083],
              [107.55677290900007, 12.496085917000059],
              [107.55666955600003, 12.49624094700009],
              [107.54964156100004, 12.509211731000022],
              [107.55176029500012, 12.520063782000065],
              [107.5579614670001, 12.530864156000092],
              [107.56343916800006, 12.543628235000071],
              [107.56695316600013, 12.573910624000092],
              [107.56509281500013, 12.606415100000035],
              [107.54008142100002, 12.716692607000084],
              [107.53775598100009, 12.746561585000109],
              [107.53863448100003, 12.773433329000099],
              [107.53594730600003, 12.799633280000123],
              [107.5223564050001, 12.827486878000087],
              [107.49429610200008, 12.85875111900009],
              [107.48737146000008, 12.8705591840001],
              [107.48334069900011, 12.885571188000071],
              [107.47961999600011, 12.915879415000106],
              [107.46835453300014, 12.941097514000063],
              [107.46608077000013, 12.952182109000077],
              [107.46783776900008, 12.96303416000012],
              [107.4737805580001, 12.972878520000094],
              [107.47894820200003, 12.976857605000077],
              [107.48137699400007, 12.982257793000144],
              [107.4810669360001, 12.988769023000117],
              [107.47858646700013, 12.996081238000102],
              [107.46298018400006, 13.007320862000057],
              [107.46039636300009, 13.02160939600013],
              [107.56159684900007, 13.262014078000107],
              [107.57490707500011, 13.293632905000038],
              [107.60695072400011, 13.369753520000131],
              [107.61051639900006, 13.400371806000052],
              [107.60431522700009, 13.498531190000023],
              [107.59692549700009, 13.535066426000057],
              [107.51429488200012, 13.692550354000048],
              [107.49672489400007, 13.717044984000097],
              [107.4737805580001, 13.741642965000082],
              [107.47176517800006, 13.746087138000078],
              [107.46225671400009, 13.761202495000092],
              [107.44323978700004, 13.783475037000045],
              [107.43817549600004, 13.798487040000026],
              [107.43853723200004, 13.808951517000068],
              [107.4449967860001, 13.830448913000097],
              [107.44623702000013, 13.839388936000134],
              [107.4353849690001, 13.869697164000073],
              [107.43982914300011, 13.886466167000037],
              [107.44530684400007, 13.897809143000103],
              [107.44804569500013, 13.909307150000132],
              [107.44598789700012, 13.921635563000024],
              [107.44515181500003, 13.926644592000045],
              [107.43104414900012, 13.955996806000115],
              [107.43011397400005, 13.965169373000023],
              [107.43135420800007, 13.974703674000096],
              [107.4307340900001, 13.984470520000059],
              [107.42448124200013, 13.994056498000063],
              [107.40902998900003, 13.999921773000054],
              [107.37156457600003, 13.99627858500007],
              [107.35456302900013, 14.002402242000116],
              [107.34314253800011, 14.020618185000075],
              [107.34350427300012, 14.04092702200009],
              [107.34686324100005, 14.061675110000039],
              [107.34474450700003, 14.081312154000074],
              [107.33363407400003, 14.098546245000051],
              [107.32417728700005, 14.10808054600004],
              [107.31993981900013, 14.119836934000134],
              [107.32474572800004, 14.14386647600007],
              [107.35859379100003, 14.23861521500001],
              [107.3636064050001, 14.273832703000082],
              [107.36376143500013, 14.283237814000131],
              [107.36091923100003, 14.293288880000063],
              [107.35213423700009, 14.312590027000098],
              [107.34991215000014, 14.321555888000134],
              [107.35177250200007, 14.341968079000083],
              [107.35900720300003, 14.360287374000066],
              [107.37941939300009, 14.395453186000026],
              [107.38226159700014, 14.404574076000102],
              [107.38381189000006, 14.413617452000054],
              [107.38691247600008, 14.421911520000023],
              [107.39487064600007, 14.429094544000066],
              [107.40778975400008, 14.433047791000135],
              [107.41362919100004, 14.428732809000067],
              [107.41734989500009, 14.42206654900005],
              [107.42380944800004, 14.418965963000105],
              [107.44313643400011, 14.423668519000088],
              [107.45574548400003, 14.433874613000057],
              [107.46473718300007, 14.449041646000083],
              [107.47672611500013, 14.475241597000092],
              [107.48044681800013, 14.4888583380001],
              [107.48137699400007, 14.495963847000041],
              [107.48571781500004, 14.509528911000118],
              [107.50008386300004, 14.529760234000022],
              [107.50525150600004, 14.541025696000077],
              [107.50644006300007, 14.556864522000083],
              [107.50256433200013, 14.586604309000066],
              [107.50401127200013, 14.602107239000077],
              [107.52726566600006, 14.65282765700006],
              [107.53243331000004, 14.677942403000074],
              [107.52039270000006, 14.704581605000016],
            ],
          ],
          [
            [
              [106.21070397200003, 9.620917059000078],
              [106.22339928500003, 9.60846588700008],
              [106.27930748800003, 9.59568919500009],
              [106.29200280000003, 9.586411851000037],
              [106.29070071700005, 9.561428127000056],
              [106.28443444100003, 9.54368724200009],
              [106.27003014400003, 9.534491278000075],
              [106.24415123800003, 9.534979559000078],
              [106.24415123800003, 9.541164455000057],
              [106.24919681100005, 9.560126044000071],
              [106.23414147200003, 9.581366278000075],
              [106.21241295700003, 9.599758205000057],
              [106.19703209700003, 9.610052802000041],
              [106.18962649800005, 9.60382721600007],
              [106.20460045700003, 9.585272528000075],
              [106.22144616000003, 9.57249583500004],
              [106.22657311300003, 9.56517161700009],
              [106.20704186300003, 9.562892971000053],
              [106.19662519600007, 9.571682033000059],
              [106.16236412900003, 9.624335028000075],
              [106.13738040500004, 9.654364325000074],
              [106.12598717500003, 9.672430731000077],
              [106.12134850400003, 9.689154364000046],
              [106.11768639400003, 9.71092357000009],
              [106.10873457100007, 9.726629950000074],
              [106.08716881600003, 9.75462474200009],
              [106.09343509200005, 9.760891018000052],
              [106.09571373800003, 9.75576406500005],
              [106.09896894600007, 9.75267161700009],
              [106.10710696700005, 9.747219143000052],
              [106.15544681100005, 9.678941148000092],
              [106.20337975400003, 9.632147528000075],
              [106.21070397200003, 9.620917059000078],
            ],
          ],
          [
            [
              [106.72413170700003, 10.26862213700008],
              [106.74683678500003, 10.263169664000088],
              [106.75554446700005, 10.257554429000038],
              [106.75879967500003, 10.24437083500004],
              [106.75245201900003, 10.236070054000038],
              [106.73829186300003, 10.22915273600006],
              [106.72413170700003, 10.226507880000042],
              [106.71778405000003, 10.231024481000077],
              [106.70932050900007, 10.24359772300005],
              [106.68995201900003, 10.251776434000078],
              [106.55958092500003, 10.27537669500009],
              [106.51172936300003, 10.29588450700004],
              [106.52711022200003, 10.29710521000004],
              [106.56088300900007, 10.282863674000055],
              [106.58790123800003, 10.276922919000071],
              [106.70281009200005, 10.275580145000049],
              [106.72413170700003, 10.26862213700008],
            ],
          ],
          [
            [
              [107.17204837300005, 10.464585679000038],
              [107.20264733200003, 10.438055731000077],
              [107.21119225400003, 10.425604559000078],
              [107.20557701900003, 10.428168036000045],
              [107.20281009200005, 10.428900458000044],
              [107.20069420700003, 10.429877020000049],
              [107.19703209700003, 10.43305084800005],
              [107.19019616000003, 10.43305084800005],
              [107.18775475400003, 10.42064036700009],
              [107.18051191500007, 10.415432033000059],
              [107.17310631600003, 10.41111888200004],
              [107.16586347700007, 10.391099351000037],
              [107.15674889400003, 10.38548411700009],
              [107.13550866000003, 10.378485419000071],
              [107.12159264400003, 10.365912177000041],
              [107.10059655000003, 10.335150458000044],
              [107.08716881600003, 10.323187567000048],
              [107.07374108200003, 10.372626044000071],
              [107.07935631600003, 10.391017971000053],
              [107.11988366000003, 10.401312567000048],
              [107.14966881600003, 10.416571356000077],
              [107.15601647200003, 10.42251211100006],
              [107.15674889400003, 10.432847398000092],
              [107.15943444100003, 10.44562409100007],
              [107.16423587300005, 10.45734284100007],
              [107.17204837300005, 10.464585679000038],
            ],
          ],
          [
            [
              [106.93628991000003, 10.439276434000078],
              [106.95777428500003, 10.425604559000078],
              [106.96892337300005, 10.416408596000053],
              [106.97730553500003, 10.405178127000056],
              [106.92847741000003, 10.393500067000048],
              [106.90853925900007, 10.384711005000042],
              [106.89527428500003, 10.37099844000005],
              [106.88795006600003, 10.37099844000005],
              [106.88795006600003, 10.389227606000077],
              [106.88314863400007, 10.403021552000041],
              [106.87745201900003, 10.41437409100007],
              [106.87427819100003, 10.425604559000078],
              [106.87696373800003, 10.443833726000037],
              [106.89234459700003, 10.465277411000045],
              [106.89527428500003, 10.480861721000053],
              [106.88795006600003, 10.480861721000053],
              [106.88795006600003, 10.466620184000078],
              [106.87940514400003, 10.490057684000078],
              [106.88835696700005, 10.50486888200004],
              [106.90674889400003, 10.51430898600006],
              [106.92750084700003, 10.521185614000046],
              [106.94809004000007, 10.507025458000044],
              [106.94336998800003, 10.476629950000074],
              [106.92204837300005, 10.425604559000078],
              [106.92945397200003, 10.425604559000078],
              [106.93628991000003, 10.439276434000078],
            ],
          ],
          [
            [
              [106.90894616000003, 10.532375393000052],
              [106.90308678500003, 10.521877346000053],
              [106.88990319100003, 10.525458075000074],
              [106.87574303500003, 10.535101630000042],
              [106.86744225400003, 10.54295482000009],
              [106.86597741000003, 10.54596588700008],
              [106.85596764400003, 10.561712958000044],
              [106.85377037900003, 10.56281159100007],
              [106.85596764400003, 10.571763414000088],
              [106.86524498800003, 10.579779364000046],
              [106.86744225400003, 10.58698151200008],
              [106.87126712300005, 10.60765208500004],
              [106.86793053500003, 10.617132880000042],
              [106.85377037900003, 10.62490469000005],
              [106.85377037900003, 10.631048895000049],
              [106.86475670700003, 10.633978583000044],
              [106.87769616000003, 10.635565497000073],
              [106.88795006600003, 10.634466864000046],
              [106.88965905000003, 10.62726471600007],
              [106.91285241000003, 10.61204661700009],
              [106.91781660200007, 10.60374583500004],
              [106.92221113400007, 10.601263739000046],
              [106.92701256600003, 10.599351304000038],
              [106.92945397200003, 10.59756094000005],
              [106.93018639400003, 10.59007396000004],
              [106.92741946700005, 10.586127020000049],
              [106.92383873800003, 10.583563544000071],
              [106.92204837300005, 10.580226955000057],
              [106.92457116000003, 10.569240627000056],
              [106.92888431100005, 10.558335679000038],
              [106.92969811300003, 10.54905833500004],
              [106.92204837300005, 10.54295482000009],
              [106.91675866000003, 10.546291408000059],
              [106.91098066500007, 10.555975653000075],
              [106.90211022200003, 10.57648346600007],
              [106.89527428500003, 10.57648346600007],
              [106.89779707100007, 10.564032294000071],
              [106.90699303500003, 10.545721747000073],
              [106.90894616000003, 10.532375393000052],
            ],
          ],
          [
            [
              [109.32837975400003, 12.221258856000077],
              [109.33627363400007, 12.217962958000044],
              [109.34213300900007, 12.21320221600007],
              [109.34620201900003, 12.207424221000053],
              [109.34888756600003, 12.200832424000055],
              [109.34441165500004, 12.196966864000046],
              [109.33350670700003, 12.189601955000057],
              [109.32837975400003, 12.187160549000055],
              [109.32300866000003, 12.193752346000053],
              [109.31657962300005, 12.19749583500004],
              [109.30909264400003, 12.197739976000037],
              [109.30046634200005, 12.19399648600006],
              [109.30339603000004, 12.191880601000037],
              [109.30469811300003, 12.19204336100006],
              [109.30567467500003, 12.19139232000009],
              [109.30738366000003, 12.187160549000055],
              [109.28760826900003, 12.188950914000088],
              [109.26929772200003, 12.19867584800005],
              [109.25456790500004, 12.211127020000049],
              [109.24529056100005, 12.221258856000077],
              [109.24529056100005, 12.228094794000071],
              [109.25196373800003, 12.22601959800005],
              [109.26636803500003, 12.223537502000056],
              [109.27320397200003, 12.221258856000077],
              [109.27279707100007, 12.224798895000049],
              [109.27320397200003, 12.235541083000044],
              [109.29151451900003, 12.228338934000078],
              [109.32837975400003, 12.221258856000077],
            ],
          ],
          [
            [
              [106.66260826900003, 8.739813544000071],
              [106.63917076900003, 8.737453518000052],
              [106.63949629000007, 8.72646719000005],
              [106.64966881600003, 8.711859442000048],
              [106.65577233200003, 8.698879299000055],
              [106.64307701900003, 8.703802802000041],
              [106.63257897200003, 8.703273830000057],
              [106.62256920700003, 8.700506903000075],
              [106.61109459700003, 8.698879299000055],
              [106.60230553500003, 8.694728908000059],
              [106.60043379000007, 8.684963283000059],
              [106.60108483200003, 8.673651434000078],
              [106.60043379000007, 8.664740302000041],
              [106.60132897200003, 8.66014232000009],
              [106.60303795700003, 8.65570709800005],
              [106.59929446700005, 8.652411200000074],
              [106.58334394600007, 8.651068427000041],
              [106.57837975400003, 8.655462958000044],
              [106.56275475400003, 8.675726630000042],
              [106.55958092500003, 8.681830145000049],
              [106.57097415500004, 8.705959377000056],
              [106.59799238400007, 8.73232656500005],
              [106.63062584700003, 8.754584052000041],
              [106.65837649800005, 8.76666901200008],
              [106.66260826900003, 8.76508209800005],
              [106.66602623800003, 8.763169664000088],
              [106.66822350400003, 8.759711005000042],
              [106.66871178500003, 8.753485419000071],
              [106.66586347700007, 8.752875067000048],
              [106.65577233200003, 8.753485419000071],
              [106.66081790500004, 8.747381903000075],
              [106.66179446700005, 8.74445221600007],
              [106.66260826900003, 8.739813544000071],
            ],
          ],
          [
            [
              [106.49805748800003, 9.891180731000077],
              [106.53101647200003, 9.857977606000077],
              [106.54411868600005, 9.838039455000057],
              [106.53565514400003, 9.82916901200008],
              [106.52100670700003, 9.837713934000078],
              [106.49683678500003, 9.87523021000004],
              [106.46851647200003, 9.890285549000055],
              [106.42237389400003, 9.932806708000044],
              [106.42237389400003, 9.939032294000071],
              [106.42693118600005, 9.936102606000077],
              [106.44288170700003, 9.932806708000044],
              [106.48601321700005, 9.90265534100007],
              [106.49805748800003, 9.891180731000077],
            ],
          ],
          [
            [
              [104.08204186300003, 10.37099844000005],
              [104.08545983200003, 10.353949286000045],
              [104.08545983200003, 10.248114325000074],
              [104.04664147200003, 10.151068427000041],
              [104.03345787900008, 10.09601471600007],
              [104.05128014400003, 10.06932200700004],
              [104.04395592500003, 10.048163153000075],
              [104.04420006600003, 10.036078192000048],
              [104.04802493600005, 10.02529531500005],
              [104.05128014400003, 10.007961330000057],
              [104.03484134200005, 10.016750393000052],
              [104.03093509200005, 10.021551825000074],
              [104.01059004000007, 10.030462958000044],
              [103.99724368600005, 10.07453034100007],
              [103.98365319100003, 10.158758856000077],
              [103.95704186300003, 10.233791408000059],
              [103.93718509200005, 10.266058661000045],
              [103.90845787900008, 10.28904857000009],
              [103.87029056100005, 10.308091539000088],
              [103.85743248800003, 10.320868231000077],
              [103.84945722700007, 10.360541083000044],
              [103.84603925900007, 10.371283270000049],
              [103.85132897200003, 10.374212958000044],
              [103.91423587300005, 10.36522044500009],
              [103.93376712300005, 10.366359768000052],
              [103.94214928500003, 10.374741929000038],
              [103.94434655000003, 10.379461981000077],
              [103.95508873800003, 10.394964911000045],
              [103.95923912900008, 10.39834219000005],
              [103.96810957100007, 10.40232982000009],
              [103.97144616000003, 10.411932684000078],
              [103.97299238400007, 10.423325914000088],
              [103.97624759200005, 10.43305084800005],
              [103.98340905000003, 10.442206122000073],
              [103.99317467500003, 10.450100002000056],
              [104.00473066500007, 10.450995184000078],
              [104.01710045700003, 10.439276434000078],
              [104.00977623800003, 10.446112372000073],
              [104.08204186300003, 10.37099844000005],
            ],
          ],
          [
            [
              [106.87427819100003, 10.46039459800005],
              [106.85808353000004, 10.46430084800005],
              [106.84449303500003, 10.469916083000044],
              [106.83228600400003, 10.472398179000038],
              [106.81959069100003, 10.466620184000078],
              [106.82520592500003, 10.46385325700004],
              [106.82667076900003, 10.463812567000048],
              [106.82813561300003, 10.465236721000053],
              [106.83326256600003, 10.466620184000078],
              [106.84864342500003, 10.452541408000059],
              [106.85962975400003, 10.431789455000057],
              [106.85889733200003, 10.41307200700004],
              [106.84009850400003, 10.405178127000056],
              [106.81641686300003, 10.41469961100006],
              [106.79167728000004, 10.437160549000055],
              [106.77068118600005, 10.46430084800005],
              [106.75879967500003, 10.48773834800005],
              [106.75513756600003, 10.503607489000046],
              [106.75473066500007, 10.515570380000042],
              [106.75879967500003, 10.54295482000009],
              [106.75749759200005, 10.543524481000077],
              [106.75513756600003, 10.550523179000038],
              [106.75196373800003, 10.566555080000057],
              [106.75538170700003, 10.569647528000075],
              [106.77214603000004, 10.57225169500009],
              [106.77857506600003, 10.57648346600007],
              [106.78589928500003, 10.601385809000078],
              [106.77881920700003, 10.62445709800005],
              [106.75196373800003, 10.665838934000078],
              [106.77475019600007, 10.666083075000074],
              [106.78419030000003, 10.662909247000073],
              [106.79314212300005, 10.654445705000057],
              [106.80225670700003, 10.63971588700008],
              [106.80811608200003, 10.633612372000073],
              [106.83529707100007, 10.62604401200008],
              [106.84782962300005, 10.613836981000077],
              [106.85377037900003, 10.59837474200009],
              [106.85377037900003, 10.583929755000042],
              [106.84669030000003, 10.577541408000059],
              [106.84205162900003, 10.570746161000045],
              [106.84009850400003, 10.559393622000073],
              [106.84245853000004, 10.555080471000053],
              [106.85352623800003, 10.539007880000042],
              [106.85743248800003, 10.53546784100007],
              [106.86768639400003, 10.528957424000055],
              [106.87183678500003, 10.515204169000071],
              [106.86443118600005, 10.50299713700008],
              [106.84009850400003, 10.501369533000059],
              [106.84009850400003, 10.494533596000053],
              [106.85596764400003, 10.493801174000055],
              [106.86394290500004, 10.48696523600006],
              [106.87427819100003, 10.466620184000078],
              [106.87427819100003, 10.46039459800005],
            ],
          ],
          [
            [
              [107.08033287900003, 20.800441799000055],
              [107.08521569100003, 20.79718659100007],
              [107.08814537900003, 20.79441966400009],
              [107.09400475400003, 20.78742096600007],
              [107.08220462300005, 20.78937409100007],
              [107.07504316500007, 20.796047268000052],
              [107.06609134200005, 20.814113674000055],
              [107.06251061300003, 20.805609442000048],
              [107.06283613400007, 20.79828522300005],
              [107.06666100400003, 20.792141018000052],
              [107.07349694100003, 20.78742096600007],
              [107.07349694100003, 20.780585028000075],
              [107.06031334700003, 20.775946356000077],
              [107.05046634200005, 20.775946356000077],
              [107.04175866000003, 20.77993398600006],
              [107.03191165500004, 20.78742096600007],
              [107.03687584700003, 20.76626211100006],
              [107.06739342500003, 20.749741929000038],
              [107.07349694100003, 20.732163804000038],
              [107.06609134200005, 20.732163804000038],
              [107.06609134200005, 20.73895905200004],
              [107.05982506600003, 20.73895905200004],
              [107.05502363400007, 20.72166575700004],
              [107.04615319100003, 20.704250393000052],
              [107.04615319100003, 20.72597890800006],
              [107.03882897200003, 20.723456122000073],
              [107.03589928500003, 20.72166575700004],
              [107.03191165500004, 20.718491929000038],
              [107.03191165500004, 20.72597890800006],
              [107.02564537900003, 20.718491929000038],
              [107.02125084700003, 20.72361888200004],
              [107.01823978000004, 20.72597890800006],
              [107.01823978000004, 20.732163804000038],
              [107.03931725400003, 20.732163804000038],
              [107.03931725400003, 20.73895905200004],
              [107.03532962300005, 20.74119700700004],
              [107.03443444100003, 20.74217357000009],
              [107.03419030000003, 20.743353583000044],
              [107.03191165500004, 20.74640534100007],
              [107.02564537900003, 20.74640534100007],
              [107.02564537900003, 20.73895905200004],
              [107.01823978000004, 20.73895905200004],
              [107.01482181100005, 20.74359772300005],
              [107.00863691500007, 20.748928127000056],
              [107.00513756600003, 20.753241278000075],
              [106.99781334700003, 20.753241278000075],
              [107.00228925900007, 20.74249909100007],
              [107.00513756600003, 20.73895905200004],
              [107.00513756600003, 20.732163804000038],
              [106.98511803500003, 20.745266018000052],
              [106.96241295700003, 20.77496979400007],
              [106.94996178500003, 20.78742096600007],
              [106.92107181100005, 20.80459219000005],
              [106.90992272200003, 20.81854889500005],
              [106.91285241000003, 20.83690013200004],
              [106.93628991000003, 20.844671942000048],
              [106.94312584700003, 20.848863023000035],
              [106.94678795700003, 20.855536200000074],
              [106.94654381600003, 20.86286041900007],
              [106.94809004000007, 20.870266018000052],
              [106.95736738400007, 20.876776434000078],
              [106.94996178500003, 20.86933014500005],
              [106.96363366000003, 20.85610586100006],
              [106.99447675900007, 20.85175202000005],
              [107.00513756600003, 20.84202708500004],
              [107.01140384200005, 20.84202708500004],
              [107.01246178500003, 20.85879140800006],
              [107.02271569100003, 20.862250067000048],
              [107.03598066500007, 20.857367255000042],
              [107.04615319100003, 20.848863023000035],
              [107.04615319100003, 20.84202708500004],
              [107.04297936300003, 20.831366278000075],
              [107.05494225400003, 20.823919989000046],
              [107.07097415500004, 20.82029857000009],
              [107.08033287900003, 20.821519273000035],
              [107.08716881600003, 20.821519273000035],
              [107.09099368600005, 20.81476471600007],
              [107.09546959700003, 20.809027411000045],
              [107.10084069100003, 20.80426666900007],
              [107.10767662900003, 20.800441799000055],
              [107.08676191500007, 20.805121161000045],
              [107.08033287900003, 20.807847398000035],
              [107.08033287900003, 20.800441799000055],
            ],
          ],
          [
            [
              [106.84009850400003, 20.87986888200004],
              [106.84555097700007, 20.866034247000073],
              [106.88160241000003, 20.821519273000035],
              [106.88648522200003, 20.796128648000035],
              [106.87354576900003, 20.789536851000037],
              [106.85621178500003, 20.79287344000005],
              [106.84750410200007, 20.797308661000045],
              [106.84253991000003, 20.813625393000052],
              [106.82252037900003, 20.85350169500009],
              [106.81959069100003, 20.876776434000078],
              [106.81421959700003, 20.868109442000048],
              [106.81267337300005, 20.859320380000042],
              [106.81462649800005, 20.850531317000048],
              [106.81959069100003, 20.84202708500004],
              [106.81218509200005, 20.84202708500004],
              [106.79932701900003, 20.849676825000074],
              [106.78386478000004, 20.852362372000073],
              [106.77068118600005, 20.858587958000044],
              [106.76563561300003, 20.876776434000078],
              [106.77361087300005, 20.90497467700004],
              [106.78541100400003, 20.930812893000052],
              [106.82455488400007, 20.915187893000052],
              [106.83594811300003, 20.902411200000074],
              [106.84009850400003, 20.87986888200004],
            ],
          ],
          [
            [
              [107.52540123800003, 20.910305080000057],
              [107.54957116000003, 20.95612213700008],
              [107.55323326900003, 20.972357489000046],
              [107.55640709700003, 20.969183661000045],
              [107.55795332100007, 20.966050523000035],
              [107.55941816500007, 20.958726304000038],
              [107.55347741000003, 20.935939846000053],
              [107.54517662900003, 20.919134833000044],
              [107.49781334700003, 20.853176174000055],
              [107.49170983200003, 20.84202708500004],
              [107.48462975400003, 20.82172272300005],
              [107.47722415500004, 20.814520575000074],
              [107.46387780000003, 20.814113674000055],
              [107.48023522200003, 20.84951406500005],
              [107.48194420700003, 20.865383205000057],
              [107.47071373800003, 20.876776434000078],
              [107.47071373800003, 20.88300202000005],
              [107.49146569100003, 20.88377513200004],
              [107.50562584700003, 20.88739655200004],
              [107.51612389400003, 20.895656643000052],
              [107.52540123800003, 20.910305080000057],
            ],
          ],
          [
            [
              [107.74512780000003, 21.02016836100006],
              [107.75806725400003, 21.01658763200004],
              [107.79281660200007, 20.992254950000074],
              [107.79281660200007, 20.986029364000046],
              [107.78239993600005, 20.989935614000046],
              [107.77914472700007, 20.992254950000074],
              [107.77295983200003, 20.992254950000074],
              [107.77800540500004, 20.972601630000042],
              [107.77076256600003, 20.95722077000005],
              [107.75611412900003, 20.945705471000053],
              [107.73829186300003, 20.937648830000057],
              [107.75717207100007, 20.97101471600007],
              [107.75879967500003, 20.98261139500005],
              [107.75342858200003, 20.988674221000053],
              [107.74341881600003, 20.994086005000042],
              [107.73764082100007, 21.003241278000075],
              [107.74512780000003, 21.02016836100006],
            ],
          ],
          [
            [
              [107.53272545700003, 21.02016836100006],
              [107.54639733200003, 21.034898179000038],
              [107.55225670700003, 21.038234768000052],
              [107.55836022200003, 21.03473541900007],
              [107.55453535200007, 21.021551825000074],
              [107.53907311300003, 20.986029364000046],
              [107.52881920700003, 20.950913804000038],
              [107.52222741000003, 20.936428127000056],
              [107.51172936300003, 20.923976955000057],
              [107.49756920700003, 20.91632721600007],
              [107.48145592500003, 20.912543036000045],
              [107.45704186300003, 20.910305080000057],
              [107.41211998800003, 20.89948151200008],
              [107.39503014400003, 20.897284247000073],
              [107.39503014400003, 20.903509833000044],
              [107.42432701900003, 20.915350653000075],
              [107.45118248800003, 20.92999909100007],
              [107.47429446700005, 20.94672272300005],
              [107.49170983200003, 20.964911200000074],
              [107.48902428500003, 20.97606028900009],
              [107.49244225400003, 20.991441148000035],
              [107.50473066500007, 21.02016836100006],
              [107.50904381600003, 21.017401434000078],
              [107.51978600400003, 21.013373114000046],
              [107.52263431100005, 21.022284247000073],
              [107.53272545700003, 21.04059479400007],
              [107.53272545700003, 21.02016836100006],
            ],
          ],
          [
            [
              [107.62126712300005, 21.116034247000073],
              [107.62826582100007, 21.12018463700008],
              [107.63209069100003, 21.118841864000046],
              [107.63184655000003, 21.11196523600006],
              [107.59595787900003, 21.039129950000074],
              [107.58961022200003, 21.00812409100007],
              [107.57960045700003, 20.98314036700009],
              [107.55941816500007, 20.986029364000046],
              [107.57007897200003, 20.989935614000046],
              [107.57146243600005, 20.996161200000074],
              [107.56885826900003, 21.00495026200008],
              [107.56690514400003, 21.016750393000052],
              [107.57007897200003, 21.026678778000075],
              [107.58415774800005, 21.03969961100006],
              [107.58741295700003, 21.050930080000057],
              [107.58904056100005, 21.07330963700008],
              [107.59107506600003, 21.081773179000038],
              [107.59424889400003, 21.089056708000044],
              [107.59791100400003, 21.09398021000004],
              [107.62126712300005, 21.116034247000073],
            ],
          ],
          [
            [
              [107.58057701900003, 21.21198151200008],
              [107.60320071700005, 21.219305731000077],
              [107.60621178500003, 21.21743398600006],
              [107.60157311300003, 21.205145575000074],
              [107.59034264400003, 21.193060614000046],
              [107.55738366000003, 21.17177969000005],
              [107.54712975400003, 21.156724351000037],
              [107.53907311300003, 21.156724351000037],
              [107.52418053500003, 21.159979559000078],
              [107.50416100400003, 21.13971588700008],
              [107.47071373800003, 21.09589264500005],
              [107.45964603000004, 21.090236721000053],
              [107.43531334700003, 21.08144765800006],
              [107.42286217500003, 21.074774481000077],
              [107.38868248800003, 21.04751211100006],
              [107.37289472700007, 21.05955638200004],
              [107.37964928500003, 21.08193594000005],
              [107.39429772200003, 21.10683828300006],
              [107.40251712300005, 21.126613674000055],
              [107.40447024800005, 21.13812897300005],
              [107.41342207100007, 21.16632721600007],
              [107.41830488400007, 21.19668203300006],
              [107.42505944100003, 21.19676341400009],
              [107.43238366000003, 21.18854401200008],
              [107.43531334700003, 21.189276434000078],
              [107.43637129000007, 21.197739976000037],
              [107.44117272200003, 21.203273830000057],
              [107.45020592500003, 21.205145575000074],
              [107.44581139400003, 21.212062893000052],
              [107.44483483200003, 21.227484442000048],
              [107.44654381600003, 21.253159898000035],
              [107.44906660200007, 21.265326239000046],
              [107.45167076900003, 21.27147044500009],
              [107.45533287900003, 21.27570221600007],
              [107.45915774800005, 21.27724844000005],
              [107.46306399800005, 21.277411200000074],
              [107.46713300900007, 21.276516018000052],
              [107.47136478000004, 21.27448151200008],
              [107.48161868600005, 21.266791083000044],
              [107.50473066500007, 21.23924388200004],
              [107.51140384200005, 21.234808661000045],
              [107.51807701900003, 21.233587958000044],
              [107.52320397200003, 21.230861721000053],
              [107.52540123800003, 21.22215403900009],
              [107.52564537900003, 21.214016018000052],
              [107.52662194100003, 21.20799388200004],
              [107.52898196700005, 21.20331452000005],
              [107.53272545700003, 21.198919989000046],
              [107.53907311300003, 21.198919989000046],
              [107.54590905000003, 21.20270416900007],
              [107.58057701900003, 21.21198151200008],
            ],
          ],
          [
            [
              [107.81348717500003, 21.360500393000052],
              [107.81560306100005, 21.35809967700004],
              [107.81820722700007, 21.354071356000077],
              [107.81934655000003, 21.35024648600006],
              [107.81706790500004, 21.348537502000056],
              [107.80933678500003, 21.34715403900009],
              [107.71143639400003, 21.307562567000048],
              [107.71436608200003, 21.31012604400007],
              [107.72584069100003, 21.323472398000035],
              [107.78394616000003, 21.356350002000056],
              [107.80030358200003, 21.362453518000052],
              [107.81348717500003, 21.360500393000052],
            ],
          ],
          [
            [
              [107.86866295700003, 21.39008209800005],
              [107.99830162900003, 21.40375397300005],
              [107.99830162900003, 21.39752838700008],
              [107.95948326900003, 21.373846747000073],
              [107.94418379000007, 21.368109442000048],
              [107.93620853000004, 21.37641022300005],
              [107.92994225400003, 21.37641022300005],
              [107.92237389400003, 21.37262604400007],
              [107.85425866000003, 21.350409247000073],
              [107.84115644600007, 21.348537502000056],
              [107.84359785200007, 21.35883209800005],
              [107.84815514400003, 21.370266018000052],
              [107.85352623800003, 21.360256252000056],
              [107.85499108200003, 21.355943101000037],
              [107.85938561300003, 21.364081122000073],
              [107.86524498800003, 21.37010325700004],
              [107.87281334700003, 21.374212958000044],
              [107.85222415500004, 21.37531159100007],
              [107.82691491000003, 21.370266018000052],
              [107.82691491000003, 21.37641022300005],
              [107.86011803500003, 21.38621653900009],
              [107.86866295700003, 21.39008209800005],
            ],
          ],
          [
            [
              [108.94255618600005, 10.551947333000044],
              [108.95899498800003, 10.537543036000045],
              [108.96615644600007, 10.517645575000074],
              [108.96078535200007, 10.502875067000048],
              [108.94019616000003, 10.50421784100007],
              [108.93018639400003, 10.514553127000056],
              [108.92595462300005, 10.530218817000048],
              [108.92945397200003, 10.54482656500005],
              [108.94255618600005, 10.551947333000044],
            ],
          ],
          [
            [
              [109.39340254000007, 12.60187409100007],
              [109.40113366000003, 12.58274974200009],
              [109.40503991000003, 12.570786851000037],
              [109.40023847700007, 12.557928778000075],
              [109.38396243600005, 12.563055731000077],
              [109.34742272200003, 12.58820221600007],
              [109.34156334700003, 12.59634023600006],
              [109.33545983200003, 12.603257554000038],
              [109.32325280000003, 12.606390692000048],
              [109.31202233200003, 12.61432526200008],
              [109.32032311300003, 12.62799713700008],
              [109.34620201900003, 12.631048895000049],
              [109.36890709700003, 12.627752997000073],
              [109.38314863400007, 12.623724677000041],
              [109.39039147200003, 12.61351146000004],
              [109.39340254000007, 12.60187409100007],
            ],
          ],
          [
            [
              [107.36963951900003, 20.825913804000038],
              [107.38119550900007, 20.818915106000077],
              [107.38445071700005, 20.81281159100007],
              [107.38355553500003, 20.799302476000037],
              [107.38021894600007, 20.79755280200004],
              [107.37525475400003, 20.803941148000035],
              [107.36890709700003, 20.807196356000077],
              [107.36085045700003, 20.805894273000035],
              [107.35027103000004, 20.810939846000053],
              [107.34213300900007, 20.82843659100007],
              [107.34107506600003, 20.842596747000073],
              [107.34498131600003, 20.84251536700009],
              [107.35710696700005, 20.829331773000035],
              [107.36963951900003, 20.825913804000038],
            ],
          ],
          [
            [
              [107.38217207100007, 20.887884833000044],
              [107.39234459700003, 20.88467031500005],
              [107.39519290500004, 20.878566799000055],
              [107.39275149800005, 20.87457916900007],
              [107.38990319100003, 20.87177155200004],
              [107.38990319100003, 20.869533596000053],
              [107.38998457100007, 20.86741771000004],
              [107.38786868600005, 20.864976304000038],
              [107.37452233200003, 20.859320380000042],
              [107.36768639400003, 20.85838450700004],
              [107.36109459700003, 20.85968659100007],
              [107.35417728000004, 20.86473216400009],
              [107.34351647200003, 20.877346096000053],
              [107.34058678500003, 20.875392971000053],
              [107.33545983200003, 20.87693919500009],
              [107.33253014400003, 20.883286851000037],
              [107.33383222700007, 20.88825104400007],
              [107.33920332100007, 20.890366929000038],
              [107.34603925900007, 20.88816966400009],
              [107.35132897200003, 20.885931708000044],
              [107.35547936300003, 20.887111721000053],
              [107.36597741000003, 20.888413804000038],
              [107.38217207100007, 20.887884833000044],
            ],
          ],
          [
            [
              [107.82569420700003, 21.02496979400007],
              [107.84213300900007, 21.035589911000045],
              [107.85629316500007, 21.033270575000074],
              [107.85279381600003, 21.019924221000053],
              [107.84441165500004, 21.011867580000057],
              [107.82740319100003, 20.989081122000073],
              [107.81771894600007, 20.98826732000009],
              [107.81657962300005, 21.00584544500009],
              [107.82569420700003, 21.02496979400007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cambodia',
        iso3: 'KHM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [107.52039270000006, 14.704581605000016],
              [107.53243331000004, 14.677942403000074],
              [107.52726566600006, 14.65282765700006],
              [107.50401127200013, 14.602107239000077],
              [107.50256433200013, 14.586604309000066],
              [107.50644006300007, 14.556864522000083],
              [107.50525150600004, 14.541025696000077],
              [107.50008386300004, 14.529760234000022],
              [107.48571781500004, 14.509528911000118],
              [107.48137699400007, 14.495963847000041],
              [107.48044681800013, 14.4888583380001],
              [107.47672611500013, 14.475241597000092],
              [107.46473718300007, 14.449041646000083],
              [107.45574548400003, 14.433874613000057],
              [107.44313643400011, 14.423668519000088],
              [107.42380944800004, 14.418965963000105],
              [107.41734989500009, 14.42206654900005],
              [107.41362919100004, 14.428732809000067],
              [107.40778975400008, 14.433047791000135],
              [107.39487064600007, 14.429094544000066],
              [107.38691247600008, 14.421911520000023],
              [107.38381189000006, 14.413617452000054],
              [107.38226159700014, 14.404574076000102],
              [107.37941939300009, 14.395453186000026],
              [107.35900720300003, 14.360287374000066],
              [107.35177250200007, 14.341968079000083],
              [107.34991215000014, 14.321555888000134],
              [107.35213423700009, 14.312590027000098],
              [107.36091923100003, 14.293288880000063],
              [107.36376143500013, 14.283237814000131],
              [107.3636064050001, 14.273832703000082],
              [107.35859379100003, 14.23861521500001],
              [107.32474572800004, 14.14386647600007],
              [107.31993981900013, 14.119836934000134],
              [107.32417728700005, 14.10808054600004],
              [107.33363407400003, 14.098546245000051],
              [107.34474450700003, 14.081312154000074],
              [107.34686324100005, 14.061675110000039],
              [107.34350427300012, 14.04092702200009],
              [107.34314253800011, 14.020618185000075],
              [107.35456302900013, 14.002402242000116],
              [107.37156457600003, 13.99627858500007],
              [107.40902998900003, 13.999921773000054],
              [107.42448124200013, 13.994056498000063],
              [107.4307340900001, 13.984470520000059],
              [107.43135420800007, 13.974703674000096],
              [107.43011397400005, 13.965169373000023],
              [107.43104414900012, 13.955996806000115],
              [107.44515181500003, 13.926644592000045],
              [107.44598789700012, 13.921635563000024],
              [107.44804569500013, 13.909307150000132],
              [107.44530684400007, 13.897809143000103],
              [107.43982914300011, 13.886466167000037],
              [107.4353849690001, 13.869697164000073],
              [107.44623702000013, 13.839388936000134],
              [107.4449967860001, 13.830448913000097],
              [107.43853723200004, 13.808951517000068],
              [107.43817549600004, 13.798487040000026],
              [107.44323978700004, 13.783475037000045],
              [107.46225671400009, 13.761202495000092],
              [107.47176517800006, 13.746087138000078],
              [107.4737805580001, 13.741642965000082],
              [107.49672489400007, 13.717044984000097],
              [107.51429488200012, 13.692550354000048],
              [107.59692549700009, 13.535066426000057],
              [107.60431522700009, 13.498531190000023],
              [107.61051639900006, 13.400371806000052],
              [107.60695072400011, 13.369753520000131],
              [107.57490707500011, 13.293632905000038],
              [107.56159684900007, 13.262014078000107],
              [107.46039636300009, 13.02160939600013],
              [107.46298018400006, 13.007320862000057],
              [107.47858646700013, 12.996081238000102],
              [107.4810669360001, 12.988769023000117],
              [107.48137699400007, 12.982257793000144],
              [107.47894820200003, 12.976857605000077],
              [107.4737805580001, 12.972878520000094],
              [107.46783776900008, 12.96303416000012],
              [107.46608077000013, 12.952182109000077],
              [107.46835453300014, 12.941097514000063],
              [107.47961999600011, 12.915879415000106],
              [107.48334069900011, 12.885571188000071],
              [107.48737146000008, 12.8705591840001],
              [107.49429610200008, 12.85875111900009],
              [107.5223564050001, 12.827486878000087],
              [107.53594730600003, 12.799633280000123],
              [107.53863448100003, 12.773433329000099],
              [107.53775598100009, 12.746561585000109],
              [107.54008142100002, 12.716692607000084],
              [107.56509281500013, 12.606415100000035],
              [107.56695316600013, 12.573910624000092],
              [107.56343916800006, 12.543628235000071],
              [107.5579614670001, 12.530864156000092],
              [107.55176029500012, 12.520063782000065],
              [107.54964156100004, 12.509211731000022],
              [107.55666955600003, 12.49624094700009],
              [107.55677290900007, 12.496085917000059],
              [107.55666955600003, 12.472676494000083],
              [107.52726566600006, 12.391131083000033],
              [107.52225305200005, 12.36658477800006],
              [107.51429488200012, 12.34384714800008],
              [107.49956709800011, 12.32581207300008],
              [107.4737805580001, 12.315373434000051],
              [107.44964766500004, 12.299043681000114],
              [107.41585127800005, 12.254085185000093],
              [107.39301029500007, 12.252844950000068],
              [107.37378666200004, 12.269433086000063],
              [107.34381433100009, 12.315115051000078],
              [107.32019820200009, 12.329222718000025],
              [107.27616988100004, 12.32539866100008],
              [107.22782438100006, 12.310591880000104],
              [107.21188440000003, 12.305709941000117],
              [107.15250817900011, 12.27702952100013],
              [107.1229492600001, 12.246230367000067],
              [107.11623132300008, 12.232122702000126],
              [107.10424239100013, 12.221218974000067],
              [107.07757735200005, 12.202770487000052],
              [107.04600305200006, 12.164374899000023],
              [106.97768680900003, 12.097247213000088],
              [106.95339888600012, 12.081072490000082],
              [106.91629520700013, 12.06691314700005],
              [106.87929488100008, 12.06272735600001],
              [106.80296879100007, 12.068463440000059],
              [106.79056193400004, 12.067408857000117],
              [106.77196293200012, 12.065827942000055],
              [106.74922530100014, 12.05234039300008],
              [106.7327921960001, 12.028879293000017],
              [106.72111332300011, 11.996374817000074],
              [106.70157963000003, 11.970794983000118],
              [106.68049564600005, 11.96505889900007],
              [106.63062788900004, 11.976169332000083],
              [106.63858606000008, 11.9611314900001],
              [106.55244144700009, 11.972810364000068],
              [106.50453739500006, 11.973378804000035],
              [106.47373824100009, 11.952088115000052],
              [106.46050907400007, 11.952914938000063],
              [106.45513472600004, 11.959736226000118],
              [106.45105228700004, 11.968469544000087],
              [106.44206058800006, 11.97487742100013],
              [106.42914148000006, 11.976841126000068],
              [106.41746260600007, 11.9758592740001],
              [106.39400150500012, 11.969813131000066],
              [106.39541619700003, 11.965807400000088],
              [106.40350996900003, 11.942889709000042],
              [106.43312056500014, 11.88837107300013],
              [106.43875329700006, 11.863721416000132],
              [106.43616947400011, 11.861189270000054],
              [106.42139001500004, 11.837573141000036],
              [106.42025313300007, 11.83095855700013],
              [106.41963301700008, 11.812044983000092],
              [106.41828942900003, 11.803415019000056],
              [106.41136478700002, 11.789152323000067],
              [106.40314823400013, 11.775871481000067],
              [106.39777388500005, 11.762125549000118],
              [106.39885909000003, 11.746312561000124],
              [106.42609257100003, 11.70047556600008],
              [106.43458746300013, 11.678428127000089],
              [106.43503259300007, 11.677272848000072],
              [106.42583418800007, 11.662079976000143],
              [106.41281172700013, 11.661769918000061],
              [106.40009932400011, 11.668539530000103],
              [106.37808516400003, 11.68383575500006],
              [106.36418420400003, 11.688538310000041],
              [106.35431400500005, 11.690140279000076],
              [106.34366866100004, 11.68905507500007],
              [106.28734135000013, 11.674585673000138],
              [106.27411218300006, 11.676807760000145],
              [106.26512048400008, 11.683990783000098],
              [106.25075443600008, 11.706056620000098],
              [106.24320967600005, 11.714583232000109],
              [106.22362430900006, 11.724970195000125],
              [106.15463627200006, 11.746312561000124],
              [106.11319177300004, 11.747087707000048],
              [106.06120528100013, 11.76290069600013],
              [106.01541996200007, 11.770497131000099],
              [105.99211389200013, 11.746312561000124],
              [105.99128706900012, 11.732463278000068],
              [105.98875492400003, 11.718975729000107],
              [105.9830705170001, 11.70667673800007],
              [105.95526859600011, 11.67799631800007],
              [105.94617354400003, 11.657067363000081],
              [105.93408125800005, 11.642856343000119],
              [105.90550419200008, 11.644303284000017],
              [105.85791019700008, 11.661563212000104],
              [105.84085697500012, 11.658152568000077],
              [105.82098599000011, 11.641473529000095],
              [105.81801599200003, 11.638980612000069],
              [105.80489017800005, 11.624924622000051],
              [105.79341800900005, 11.607302958000062],
              [105.79042077700012, 11.587407532000057],
              [105.79317921600011, 11.582883693000028],
              [105.80333988500013, 11.56622019400001],
              [105.81553552300005, 11.559760640000135],
              [105.84214888500009, 11.554954732000041],
              [105.85320764200009, 11.546867371000047],
              [105.85780684500003, 11.535627747000092],
              [105.85884037300013, 11.522321066000075],
              [105.85666996300012, 11.496276144000092],
              [105.87217289300003, 11.443462830000044],
              [105.87382653800012, 11.428244121000105],
              [105.87103601100006, 11.413283793000048],
              [105.85997725500005, 11.379306539000112],
              [105.84344079600004, 11.304091492000083],
              [105.84442264800009, 11.289880473000025],
              [105.85718672700006, 11.279958598000121],
              [105.87351648000003, 11.275901998000023],
              [105.88674564700011, 11.267943828000057],
              [105.88943282100013, 11.2463947560001],
              [105.88943282100013, 11.246239726000056],
              [105.89987146100009, 11.218592835000052],
              [105.92043868100006, 11.203322449000098],
              [105.97397546400009, 11.190377503000079],
              [105.98875492400003, 11.176967469000132],
              [106.01314620000005, 11.139269511000094],
              [106.02813236500003, 11.122655538000075],
              [106.06306563300012, 11.093329163000107],
              [106.07650150600006, 11.077025249000087],
              [106.08663008600013, 11.056328837000066],
              [106.09810225500013, 11.077903748000026],
              [106.11350183200011, 11.086921285000074],
              [106.13086511200004, 11.084234111000043],
              [106.14874515800011, 11.070720724000068],
              [106.16032067900005, 11.053512472000094],
              [106.1766504310001, 10.99620330800012],
              [106.18786421700003, 10.976307882000114],
              [106.18083622300003, 10.97026173900008],
              [106.17038952300004, 10.970602023000069],
              [106.14910689300007, 10.971295268000063],
              [106.13143355300008, 10.969279887000098],
              [106.12817793800008, 10.965714214000045],
              [106.12249353000004, 10.955508118000068],
              [106.12466394100005, 10.953182678000132],
              [106.1234237060001, 10.92744781500005],
              [106.12182173700006, 10.925225729000132],
              [106.12693770400006, 10.90899932900004],
              [106.15158736200004, 10.862981466000122],
              [106.17732222500007, 10.766863302000019],
              [106.15504968300007, 10.784846701000092],
              [106.1288497320001, 10.791357931000064],
              [106.07221236200007, 10.796861470000067],
              [106.04570235300008, 10.805853170000105],
              [106.01790043100004, 10.81980580600009],
              [105.99257897900009, 10.837815043000091],
              [105.97397546400009, 10.858821513000095],
              [105.9646737060001, 10.869596049000023],
              [105.93134240700005, 10.896364441000088],
              [105.92984379100011, 10.880060526000065],
              [105.92049035700006, 10.858149719000025],
              [105.90865645400004, 10.838383484000047],
              [105.89935469600005, 10.828384094000029],
              [105.87868412300003, 10.828074036000132],
              [105.8610107830001, 10.839313660000087],
              [105.84752323500004, 10.855410868000064],
              [105.84003015200011, 10.869699402000052],
              [105.82855798300011, 10.904503479000098],
              [105.82142663600007, 10.919670512000039],
              [105.7874235430001, 10.96597259500001],
              [105.76969852700012, 10.996461691000093],
              [105.75290368700013, 11.015607808000098],
              [105.72613529500006, 11.018372498000048],
              [105.69729984600013, 11.010233460000038],
              [105.6740454510001, 10.996410014000077],
              [105.67378706900013, 10.996254984000132],
              [105.65492517100012, 10.98429189000008],
              [105.63218754100012, 10.973956605000083],
              [105.61723995200003, 10.970836832000145],
              [105.52360324500012, 10.951293531000132],
              [105.47385095200013, 10.940909526000098],
              [105.46578942900004, 10.941839702000053],
              [105.44336185700013, 10.952975972000075],
              [105.41504317300013, 10.960727438000077],
              [105.41049564700012, 10.963001201000097],
              [105.39788659700008, 10.954577942000114],
              [105.35726892200006, 10.907965800000056],
              [105.32750329600003, 10.848279520000034],
              [105.31789148000013, 10.838848572000074],
              [105.30300866800007, 10.844016215000067],
              [105.2686955160001, 10.873652649000121],
              [105.25329593900011, 10.883522848000013],
              [105.20914500700007, 10.891647006000127],
              [105.11175419200003, 10.909567769000077],
              [105.09754317200009, 10.914347840000076],
              [105.08607100500006, 10.929514873000102],
              [105.08374556500013, 10.942614848000062],
              [105.07790612800005, 10.946903992000031],
              [105.05578861600003, 10.935457662000118],
              [105.0427661540001, 10.926362610000055],
              [105.03854802900003, 10.922582214000073],
              [105.02907190000008, 10.914089457000017],
              [105.01785811400003, 10.899594218000075],
              [105.01139856000009, 10.883832906000094],
              [105.01480920400007, 10.849209696000088],
              [105.03046716400013, 10.81164093100007],
              [105.06622725400007, 10.746425272000053],
              [105.06674401900011, 10.713946635000127],
              [105.04245609600008, 10.690821431000046],
              [104.94432255100003, 10.641625469000076],
              [104.93135176600003, 10.630695902000113],
              [104.91972456900004, 10.618009338000064],
              [104.87853845300009, 10.55597178100001],
              [104.85440555800011, 10.531322123000109],
              [104.81880049700004, 10.517188619000066],
              [104.7738420010001, 10.515328268000061],
              [104.72442453000014, 10.521337570000071],
              [104.70063406700007, 10.524230557000081],
              [104.62553064000014, 10.533363342000072],
              [104.58253584800013, 10.531528829000067],
              [104.56682621300007, 10.528066508000038],
              [104.55401045700006, 10.518325500000074],
              [104.54429528800006, 10.50377858500012],
              [104.5359753830001, 10.487991435000126],
              [104.49427250200006, 10.427736715000066],
              [104.4837305100001, 10.418047383000044],
              [104.46957116700003, 10.415773620000024],
              [104.45134524800005, 10.419663804000024],
              [104.45134524800005, 10.41982656500005],
              [104.44922936300003, 10.425604559000078],
              [104.43238366000003, 10.44627513200004],
              [104.42204837300005, 10.452297268000052],
              [104.40756269600007, 10.446112372000073],
              [104.37232506600003, 10.482082424000055],
              [104.36312910200007, 10.48773834800005],
              [104.33253014400003, 10.48773834800005],
              [104.31560306100005, 10.48110586100006],
              [104.30616295700003, 10.478583075000074],
              [104.29769941500007, 10.480861721000053],
              [104.28980553500003, 10.49750397300005],
              [104.28630618600005, 10.54047272300005],
              [104.27418053500003, 10.54913971600007],
              [104.26856530000003, 10.552069403000075],
              [104.25660241000003, 10.565822658000059],
              [104.24984785200007, 10.570257880000042],
              [104.24268639400003, 10.569037177000041],
              [104.23658287900008, 10.564642645000049],
              [104.23031660200007, 10.56313711100006],
              [104.22266686300003, 10.570257880000042],
              [104.20704186300003, 10.549994208000044],
              [104.18116295700003, 10.54954661700009],
              [104.13013756600003, 10.56281159100007],
              [104.11312910200007, 10.560939846000053],
              [104.08904056100005, 10.554632880000042],
              [104.07178795700003, 10.555975653000075],
              [103.97608483200003, 10.582505601000037],
              [103.95923912900008, 10.583929755000042],
              [103.94556725400008, 10.58812083500004],
              [103.91797936300003, 10.61123281500005],
              [103.91627037900008, 10.61859772300005],
              [103.89429772200003, 10.658392645000049],
              [103.89128665500004, 10.659125067000048],
              [103.87696373800003, 10.658392645000049],
              [103.87338300900007, 10.66006094000005],
              [103.87370853000004, 10.66404857000009],
              [103.87468509200005, 10.668768622000073],
              [103.87378991000003, 10.672674872000073],
              [103.87086022200003, 10.678656317000048],
              [103.86915123800003, 10.693548895000049],
              [103.86638431100005, 10.699367580000057],
              [103.85889733200003, 10.67959219000005],
              [103.85971113400007, 10.65810781500005],
              [103.86638431100005, 10.621161200000074],
              [103.86280358200003, 10.60382721600007],
              [103.85425866000003, 10.586493231000077],
              [103.83228600400008, 10.555975653000075],
              [103.82056725400008, 10.54401276200008],
              [103.80787194100003, 10.537909247000073],
              [103.79102623800003, 10.53579336100006],
              [103.76710045700003, 10.53546784100007],
              [103.75416100400008, 10.53774648600006],
              [103.74822024800005, 10.543117580000057],
              [103.74390709700003, 10.54987213700008],
              [103.73609459700003, 10.555975653000075],
              [103.72608483200003, 10.558661200000074],
              [103.70932050900007, 10.55923086100006],
              [103.70191491000003, 10.56281159100007],
              [103.70191491000003, 10.555975653000075],
              [103.72315514400003, 10.544663804000038],
              [103.74195397200003, 10.526271877000056],
              [103.74708092500003, 10.508978583000044],
              [103.72608483200003, 10.501369533000059],
              [103.69320722700007, 10.503404039000088],
              [103.65577233200003, 10.49518463700008],
              [103.63738040500004, 10.494533596000053],
              [103.62387129000007, 10.500921942000048],
              [103.61719811300003, 10.515041408000059],
              [103.61540774800005, 10.529120184000078],
              [103.61622155000003, 10.53546784100007],
              [103.61312910200007, 10.538275458000044],
              [103.61060631600003, 10.551459052000041],
              [103.60629316500007, 10.555975653000075],
              [103.59839928500003, 10.55662669500009],
              [103.59400475400008, 10.553656317000048],
              [103.59066816500007, 10.550116278000075],
              [103.58578535200007, 10.54913971600007],
              [103.57943769600007, 10.550848700000074],
              [103.57007897200003, 10.555080471000053],
              [103.56153405000003, 10.562323309000078],
              [103.55355879000007, 10.585516669000071],
              [103.54379316500007, 10.596177476000037],
              [103.52369225400008, 10.61123281500005],
              [103.50709069100003, 10.60423411700009],
              [103.50196373800003, 10.617132880000042],
              [103.50684655000003, 10.635443427000041],
              [103.52003014400003, 10.644720770000049],
              [103.52808678500003, 10.652167059000078],
              [103.53834069100003, 10.669501044000071],
              [103.54712975400008, 10.688950914000088],
              [103.55103600400008, 10.703070380000042],
              [103.56739342500003, 10.726507880000042],
              [103.60596764400003, 10.737534898000092],
              [103.68417402400007, 10.740790106000077],
              [103.68490644600007, 10.740830796000068],
              [103.68873131600003, 10.74095286700009],
              [103.68873131600003, 10.742987372000073],
              [103.68873131600003, 10.747748114000046],
              [103.67562910200007, 10.751776434000078],
              [103.67221113400007, 10.757879950000074],
              [103.67807050900007, 10.801214911000045],
              [103.68140709700003, 10.80923086100006],
              [103.68970787900008, 10.816148179000038],
              [103.70142662900008, 10.822211005000042],
              [103.71338951900003, 10.830552476000037],
              [103.72242272200003, 10.844549872000073],
              [103.72437584700003, 10.856024481000077],
              [103.72242272200003, 10.89484284100007],
              [103.70736738400007, 10.930121161000045],
              [103.67855879000007, 10.980210679000038],
              [103.65951582100007, 11.029771226000037],
              [103.67457116000003, 11.063666083000044],
              [103.65544681100005, 11.07843659100007],
              [103.64584394600007, 11.08226146000004],
              [103.61622155000003, 11.085435289000088],
              [103.60401451900003, 11.090643622000073],
              [103.59522545700003, 11.09829336100006],
              [103.58350670700003, 11.134100653000075],
              [103.56185957100007, 11.15224844000005],
              [103.53296959700003, 11.16274648600006],
              [103.50269616000003, 11.166083075000074],
              [103.50489342500003, 11.162583726000037],
              [103.50521894600007, 11.161769924000055],
              [103.50611412900008, 11.161363023000092],
              [103.51002037900008, 11.15924713700008],
              [103.49642988400007, 11.138820705000057],
              [103.48902428500003, 11.138820705000057],
              [103.48438561300003, 11.145656643000052],
              [103.48121178500003, 11.148382880000042],
              [103.46851647200003, 11.15180084800005],
              [103.46851647200003, 11.145656643000052],
              [103.47445722700007, 11.133693752000056],
              [103.46827233200003, 11.118963934000078],
              [103.44800866000003, 11.090399481000077],
              [103.46827233200003, 11.099310614000046],
              [103.47022545700003, 11.089056708000044],
              [103.46273847700007, 11.070868231000077],
              [103.43726647200003, 11.025091864000046],
              [103.43083743600005, 11.00649648600006],
              [103.42807050900007, 10.98427969000005],
              [103.41700280000003, 10.95807526200008],
              [103.41456139400003, 10.94635651200008],
              [103.41529381600003, 10.936753648000092],
              [103.42017662900008, 10.92096588700008],
              [103.42123457100007, 10.909125067000048],
              [103.41570071700005, 10.894110419000071],
              [103.40211022200003, 10.884344794000071],
              [103.38599694100003, 10.880926825000074],
              [103.37289472700007, 10.884955145000049],
              [103.36866295700003, 10.880194403000075],
              [103.36402428500003, 10.87693919500009],
              [103.35230553500003, 10.871893622000073],
              [103.34408613400007, 10.895453192000048],
              [103.32309004000007, 10.909572658000059],
              [103.29810631600003, 10.919989325000074],
              [103.27735436300003, 10.93268463700008],
              [103.23633873800003, 10.908148505000042],
              [103.21900475400008, 10.89248281500005],
              [103.22266686300003, 10.878119208000044],
              [103.20875084700003, 10.878566799000055],
              [103.19678795700003, 10.876532294000071],
              [103.18751061300003, 10.87181224200009],
              [103.18116295700003, 10.864447333000044],
              [103.16179446700005, 10.87400950700004],
              [103.13868248800003, 10.87641022300005],
              [103.12671959700003, 10.881293036000045],
              [103.14014733200003, 10.898586330000057],
              [103.10938561300003, 10.922308661000045],
              [103.10189863400007, 10.925930080000057],
              [103.09555097700007, 10.933986721000053],
              [103.10027103000004, 10.95115794500009],
              [103.10840905000003, 10.96702708500004],
              [103.11280358200003, 10.970892645000049],
              [103.11060631600003, 11.001898505000042],
              [103.10084069100003, 11.053127346000053],
              [103.09848066500007, 11.080471096000053],
              [103.10181725400008, 11.089911200000074],
              [103.10873457100007, 11.100409247000073],
              [103.11597741000003, 11.113836981000077],
              [103.11898847700007, 11.131984768000052],
              [103.11768639400003, 11.149115302000041],
              [103.11361738400007, 11.161078192000048],
              [103.09848066500007, 11.18659088700008],
              [103.09620201900003, 11.194240627000056],
              [103.09506269600007, 11.202622789000088],
              [103.09327233200003, 11.21084219000005],
              [103.08863366000003, 11.217678127000056],
              [103.08204186300003, 11.21938711100006],
              [103.06226647200003, 11.21971263200004],
              [103.05762780000003, 11.220770575000074],
              [103.05958092500003, 11.231838283000059],
              [103.07105553500003, 11.23859284100007],
              [103.07927493600005, 11.24518463700008],
              [103.07129967500003, 11.255519924000055],
              [103.07129967500003, 11.261664130000042],
              [103.07886803500003, 11.273504950000074],
              [103.10564212300005, 11.29905833500004],
              [103.13404381600003, 11.316148179000038],
              [103.14698326900003, 11.302679755000042],
              [103.15316816500007, 11.302679755000042],
              [103.15211022200003, 11.318101304000038],
              [103.14242597700007, 11.343573309000078],
              [103.14014733200003, 11.357896226000037],
              [103.12574303500003, 11.35228099200009],
              [103.11915123800003, 11.348863023000092],
              [103.11280358200003, 11.34365469000005],
              [103.10027103000004, 11.356024481000077],
              [103.09652754000007, 11.36717357000009],
              [103.09595787900008, 11.380357164000088],
              [103.09229576900003, 11.398871161000045],
              [103.08578535200007, 11.413804429000038],
              [103.07097415500004, 11.434515692000048],
              [103.06446373800003, 11.44725169500009],
              [103.07276451900003, 11.444810289000088],
              [103.07569420700003, 11.44432200700004],
              [103.07667076900003, 11.441839911000045],
              [103.07878665500004, 11.433010158000059],
              [103.08497155000003, 11.433010158000059],
              [103.09131920700003, 11.44399648600006],
              [103.10157311300003, 11.45258209800005],
              [103.11451256600003, 11.458238023000092],
              [103.12989342500003, 11.460353908000059],
              [103.14332116000003, 11.454820054000038],
              [103.15919030000003, 11.43109772300005],
              [103.17432701900003, 11.426174221000053],
              [103.14275149800005, 11.485052802000041],
              [103.13331139400003, 11.49445221600007],
              [103.13786868600005, 11.505275783000059],
              [103.14014733200003, 11.508734442000048],
              [103.13331139400003, 11.508734442000048],
              [103.13103274800005, 11.505072333000044],
              [103.12647545700003, 11.49445221600007],
              [103.13062584700003, 11.486517645000049],
              [103.12867272200003, 11.477484442000048],
              [103.12208092500003, 11.47016022300005],
              [103.11280358200003, 11.46775950700004],
              [103.10287519600007, 11.47264232000009],
              [103.09107506600003, 11.49054596600007],
              [103.06446373800003, 11.503607489000046],
              [103.05730228000004, 11.525213934000078],
              [103.05632571700005, 11.550279039000088],
              [103.05762780000003, 11.57021719000005],
              [103.05079186300003, 11.563381252000056],
              [103.05404707100007, 11.583807684000078],
              [103.05762780000003, 11.59125397300005],
              [103.04835045700003, 11.591620184000078],
              [103.04330488400007, 11.594305731000077],
              [103.03711998800003, 11.60492584800005],
              [103.03744550900007, 11.570257880000042],
              [103.03565514400003, 11.554632880000042],
              [103.03028405000003, 11.54287344000005],
              [103.02344811300003, 11.54287344000005],
              [103.01270592500003, 11.546372789000088],
              [102.99854576900003, 11.543158270000049],
              [102.98462975400008, 11.536322333000044],
              [102.97510826900003, 11.529242255000042],
              [102.95460045700003, 11.557114976000037],
              [102.97510826900003, 11.57021719000005],
              [102.98023522200003, 11.563788153000075],
              [102.99545332100007, 11.549709377000056],
              [103.00294030000003, 11.549709377000056],
              [102.99935957100007, 11.55955638200004],
              [102.98845462300005, 11.572699286000045],
              [102.98243248800003, 11.583807684000078],
              [102.98243248800003, 11.624823309000078],
              [102.99382571700005, 11.63572825700004],
              [103.00782311300003, 11.63117096600007],
              [103.02442467500003, 11.623480536000045],
              [103.04330488400007, 11.624823309000078],
              [103.04330488400007, 11.63226959800005],
              [103.03101647200003, 11.63117096600007],
              [103.02100670700003, 11.633978583000044],
              [103.01351972700007, 11.63939036700009],
              [103.00912519600007, 11.645900783000059],
              [103.00912519600007, 11.652736721000053],
              [103.01677493600005, 11.652736721000053],
              [103.01677493600005, 11.659572658000059],
              [103.00619550900007, 11.65501536700009],
              [103.00294030000003, 11.652736721000053],
              [102.99545332100007, 11.652736721000053],
              [102.99431399800005, 11.660101630000042],
              [102.98926842500003, 11.673244533000059],
              [102.98243248800003, 11.673244533000059],
              [102.98243248800003, 11.652736721000053],
              [102.97510826900003, 11.659572658000059],
              [102.97510826900003, 11.638495184000078],
              [102.96876061300003, 11.638495184000078],
              [102.97038821700005, 11.666205145000049],
              [102.97584069100003, 11.687323309000078],
              [102.98633873800003, 11.702866929000038],
              [103.00294030000003, 11.714178778000075],
              [103.01286868600005, 11.718573309000078],
              [103.02165774800005, 11.720526434000078],
              [103.03028405000003, 11.718491929000038],
              [103.04029381600003, 11.711086330000057],
              [103.05258222700007, 11.705511786000045],
              [103.06666100400008, 11.708197333000044],
              [103.07878665500004, 11.716457424000055],
              [103.08497155000003, 11.727850653000075],
              [103.07878665500004, 11.727850653000075],
              [103.06983483200003, 11.71515534100007],
              [103.05600019600007, 11.716131903000075],
              [103.04135175900007, 11.724676825000074],
              [103.03028405000003, 11.73468659100007],
              [103.02344811300003, 11.73468659100007],
              [102.98243248800003, 11.714178778000075],
              [102.97681725400008, 11.720363674000055],
              [102.96973717500003, 11.732855536000045],
              [102.96387780000003, 11.74713776200008],
              [102.96143639400003, 11.75853099200009],
              [102.95606530000003, 11.766913153000075],
              [102.93262780000003, 11.779120184000078],
              [102.89926191500007, 11.830267645000049],
              [102.89307701900003, 11.830267645000049],
              [102.90788821700005, 11.797552802000041],
              [102.95679772200003, 11.74681224200009],
              [102.96876061300003, 11.714178778000075],
              [102.96656334700003, 11.697455145000049],
              [102.95484459700003, 11.66787344000005],
              [102.95460045700003, 11.652736721000053],
              [102.96501712300005, 11.609930731000077],
              [102.96371504000007, 11.592352606000077],
              [102.95460045700003, 11.57021719000005],
              [102.95264733200003, 11.582953192000048],
              [102.94312584700003, 11.600978908000059],
              [102.94092858200003, 11.615179755000042],
              [102.93726647200003, 11.62173086100006],
              [102.91968834700003, 11.638373114000046],
              [102.91358483200003, 11.645900783000059],
              [102.9287866620001, 11.668694560000048],
              [102.9251176350001, 11.725797018000065],
              [102.91380049600014, 11.765536194000063],
              [102.88517175300007, 11.807704163000025],
              [102.84300378500012, 11.866046855000064],
              [102.79711511200003, 11.952966614000076],
              [102.78714156100011, 12.00262766600008],
              [102.77107019100004, 12.037354228000112],
              [102.76501241200003, 12.044563616000119],
              [102.75122644000004, 12.06097035800012],
              [102.69996342000013, 12.138743388000066],
              [102.69221195500012, 12.178482564000149],
              [102.71505293800004, 12.342193502000043],
              [102.72006555200011, 12.36121042900001],
              [102.73065922000006, 12.380072327000036],
              [102.75649743700006, 12.40224151700005],
              [102.76512740100003, 12.41634918200009],
              [102.76375089600003, 12.42526146900012],
              [102.76207849100012, 12.436089579000054],
              [102.7506063240001, 12.449008688000063],
              [102.71841190600003, 12.465906880000148],
              [102.70482100500004, 12.480324606000067],
              [102.70213383000004, 12.488127747000092],
              [102.70048018400007, 12.50487091100004],
              [102.69675948100007, 12.513087464000066],
              [102.68973148600003, 12.519702047000067],
              [102.66482344600007, 12.534223124000022],
              [102.58854903100007, 12.609825745000052],
              [102.55862837700005, 12.631219788000067],
              [102.50178430200009, 12.649771627000106],
              [102.4958771100001, 12.65415246400002],
              [102.48638472500011, 12.661192119000106],
              [102.47925337700008, 12.677108460000042],
              [102.47666955600005, 12.698450826000041],
              [102.47796146700011, 12.719638164000088],
              [102.4827156990001, 12.735218608000125],
              [102.49519613400014, 12.746029849000067],
              [102.49527307200003, 12.746096497000082],
              [102.50555668200013, 12.777774150000084],
              [102.50664188700011, 12.78751515700013],
              [102.50431644800005, 12.799736633000052],
              [102.50049239100014, 12.806506246000097],
              [102.49553145300007, 12.812681580000074],
              [102.48974369400003, 12.823094381000104],
              [102.48333581500009, 12.843790792000036],
              [102.47920170100014, 12.882108867000042],
              [102.47408573400008, 12.905259908000033],
              [102.4678845630001, 12.916344503000047],
              [102.46483565300014, 12.927532451000076],
              [102.46628259300013, 12.937919414000092],
              [102.4775997320001, 12.949934184000071],
              [102.47889164300005, 12.953629049000071],
              [102.4775997320001, 12.957298075000068],
              [102.46907312000008, 12.96523040800011],
              [102.46721276900007, 12.969467876000067],
              [102.46881473900004, 12.973395284000048],
              [102.47408573400008, 12.976960958000106],
              [102.48137211200003, 12.980552470000077],
              [102.48664310700008, 12.98478993700013],
              [102.48974369400003, 12.989957581000041],
              [102.49009677200013, 12.995187554000054],
              [102.49015710500004, 12.996081238000102],
              [102.47315555800003, 13.006132304000033],
              [102.4631820080001, 13.01928395600001],
              [102.44726566600008, 13.05080658000007],
              [102.40189375900013, 13.10299977700005],
              [102.38205000800014, 13.136615295000084],
              [102.32918681200005, 13.272628953000066],
              [102.32820316600004, 13.275159811000037],
              [102.32706628500011, 13.34543975900003],
              [102.3336291920001, 13.406262919000056],
              [102.32939172400006, 13.481865540000086],
              [102.32952834600007, 13.484602854000087],
              [102.33011519400003, 13.496360779000042],
              [102.32939172400006, 13.504344788000097],
              [102.32551599100009, 13.513439840000075],
              [102.31476729300005, 13.530338033000064],
              [102.3134237060001, 13.541009217000067],
              [102.33223392800011, 13.564599508000072],
              [102.37130131000004, 13.568914490000054],
              [102.45222660300004, 13.56217071600011],
              [102.5132047940001, 13.567157491000074],
              [102.53253177900012, 13.573823751000077],
              [102.57955733300014, 13.600488790000028],
              [102.59774743700007, 13.605449728000067],
              [102.56250411000008, 13.628032329000106],
              [102.54105839100004, 13.648599549000096],
              [102.54235030100011, 13.669709371000039],
              [102.57438969000003, 13.693893941000098],
              [102.67495202700013, 13.741901347000052],
              [102.69861983300007, 13.76179677400006],
              [102.70265059400009, 13.771201884000106],
              [102.70399418100004, 13.791769104000096],
              [102.70647465000008, 13.80194936100007],
              [102.7112805590001, 13.810398458000066],
              [102.72910892800007, 13.832154236000065],
              [102.73717045100005, 13.84959503200011],
              [102.75437870400003, 13.904113668000022],
              [102.77282718900005, 13.936075541],
              [102.7974251710001, 13.960001729000098],
              [102.85499271600008, 14.00400421200007],
              [102.86977217700007, 14.020618185000075],
              [102.87333785000004, 14.033408102000053],
              [102.8728727620001, 14.048368429000021],
              [102.87623173100013, 14.071312765000059],
              [102.88325972500013, 14.086944885],
              [102.90408532700008, 14.115987040000093],
              [102.91126835200004, 14.132110088000076],
              [102.91369714400008, 14.15177297000011],
              [102.91392961400004, 14.164946285000013],
              [102.9140072020001, 14.16934295600008],
              [102.91860640500005, 14.185491842000076],
              [102.93405765800003, 14.200968934000073],
              [102.95090417500012, 14.20864288400007],
              [102.98780114800013, 14.219004008000084],
              [103.00485437100008, 14.228770854000032],
              [103.01692961100008, 14.238872481000072],
              [103.08500451700007, 14.295821025000052],
              [103.11802575700011, 14.31323598200008],
              [103.13823124200013, 14.319747213000056],
              [103.1985893150001, 14.32850636800012],
              [103.24327762700005, 14.341931315000068],
              [103.27367517100004, 14.35106313100006],
              [103.34137129800013, 14.350908101000115],
              [103.36286869400004, 14.353466085000022],
              [103.38023197500007, 14.361062520000075],
              [103.40808557200012, 14.380802918000128],
              [103.42250329600006, 14.384833679000039],
              [103.42622399900006, 14.382508240000107],
              [103.43149499600008, 14.377521464000054],
              [103.4392464600001, 14.372870585000086],
              [103.44968510000012, 14.371578674000133],
              [103.45702315300014, 14.374420878000109],
              [103.4948503010001, 14.399949036000052],
              [103.53340092000008, 14.419069316000048],
              [103.55024743700005, 14.421859844000096],
              [103.56812748200014, 14.41594289200009],
              [103.58161503200006, 14.407416280000078],
              [103.59613610900004, 14.404341533000135],
              [103.61680668100013, 14.414547628000022],
              [103.62290450000012, 14.42247996000006],
              [103.62445479400003, 14.430567322000059],
              [103.62745202700006, 14.437802023000117],
              [103.63706384300013, 14.443279724000107],
              [103.64719242300009, 14.443977356000104],
              [103.65716597500011, 14.441160991000046],
              [103.66538252800007, 14.435941671000123],
              [103.67148034700011, 14.429559631000089],
              [103.67385746300005, 14.419327698000103],
              [103.67168705300008, 14.39560821600007],
              [103.67489099100004, 14.38648732500009],
              [103.68222904400011, 14.38380015100006],
              [103.71654219600003, 14.381526387000036],
              [103.7752466230001, 14.366979472000082],
              [103.79421187400004, 14.364834900000105],
              [103.80728601100009, 14.365997620000115],
              [103.81550256400004, 14.36796132400005],
              [103.82402917500013, 14.368038839000079],
              [103.83844690000006, 14.36338796000011],
              [103.8492472740001, 14.357083436000096],
              [103.85916914900008, 14.349616191000067],
              [103.87033125800014, 14.343259990000135],
              [103.88516239400008, 14.340417786000074],
              [103.90278405800007, 14.34243316700011],
              [103.90800337700006, 14.348324280000028],
              [103.91053552300014, 14.356256612000067],
              [103.91983728100007, 14.36457651800012],
              [103.97399418100008, 14.367289530000065],
              [104.00138269100006, 14.345068665000042],
              [104.03595422400014, 14.35258758500008],
              [104.0450640150001, 14.356968011000049],
              [104.04572418600009, 14.357285453000117],
              [104.0737296960001, 14.370751852000112],
              [104.11021325700011, 14.380441183000045],
              [104.11615604700012, 14.377469788000042],
              [104.12127201400011, 14.371475321000105],
              [104.12835168500004, 14.366359355000029],
              [104.14090905800003, 14.365997620000115],
              [104.14845381700007, 14.3696149700001],
              [104.17325850500004, 14.396021627000081],
              [104.17480879700008, 14.401344299000115],
              [104.17703088400009, 14.404212342000093],
              [104.18566084800011, 14.403979798000137],
              [104.18256026200004, 14.400362448000052],
              [104.18349043800004, 14.391422425000115],
              [104.18917484600007, 14.38230153400005],
              [104.20126713100007, 14.377986552000081],
              [104.21914717700008, 14.382869975000105],
              [104.23237634300011, 14.393127747000094],
              [104.24746586100008, 14.40108591700006],
              [104.27123702000006, 14.399070536000096],
              [104.32539392100006, 14.377624817000083],
              [104.43918542500006, 14.361424255000074],
              [104.44600671400013, 14.358685404000127],
              [104.45262129700006, 14.356928406000051],
              [104.45850831800004, 14.357042243000066],
              [104.4619747320001, 14.357109273000106],
              [104.4675041100001, 14.360080668000109],
              [104.47391198800011, 14.36568756100013],
              [104.48197351100004, 14.37121694000004],
              [104.49261885600004, 14.374007467000098],
              [104.51080896100007, 14.370545145000051],
              [104.52651859600013, 14.363542989000052],
              [104.54284834800006, 14.360390727000095],
              [104.56279545100006, 14.368478089000092],
              [104.57385420800006, 14.380544536000073],
              [104.58346602400007, 14.39581492100011],
              [104.59462813300013, 14.410000102000069],
              [104.61044112100012, 14.418965963000105],
              [104.62656416900012, 14.419276021000087],
              [104.65136885600003, 14.408914897000074],
              [104.66837040200005, 14.40963836700007],
              [104.67472660400011, 14.414650981000136],
              [104.68464847900009, 14.430567322000059],
              [104.69286503100011, 14.433977966000086],
              [104.70102990800012, 14.430076396000032],
              [104.70619755100006, 14.41224802700009],
              [104.71286381000004, 14.406847839000108],
              [104.72795332900006, 14.409948426000057],
              [104.75792566000007, 14.433047791000135],
              [104.77167159000004, 14.439869080000094],
              [104.78825972500005, 14.438215434000128],
              [104.80185062700014, 14.430076396000032],
              [104.81507979400004, 14.419844462000057],
              [104.83140954700008, 14.411757101000148],
              [104.83848921800006, 14.411447042000063],
              [104.85735111500003, 14.414134217000097],
              [104.86654952000004, 14.413772481000095],
              [104.8742493090001, 14.41056854200012],
              [104.89021732600003, 14.40023325600012],
              [104.89817549700012, 14.396280009000051],
              [104.91562096700005, 14.39321676200008],
              [104.95512292500007, 14.386280619000033],
              [104.97382979400004, 14.380647888000098],
              [104.97873905400007, 14.368503927000091],
              [104.97899743700009, 14.354964701000114],
              [104.9742948820001, 14.309644470000109],
              [104.97594852700013, 14.301117859000087],
              [105.00772953300009, 14.243834534000115],
              [105.02535119700008, 14.224378358000138],
              [105.04731368100005, 14.214068909000048],
              [105.10141890500012, 14.230527852000108],
              [105.13221805800009, 14.280705668000053],
              [105.15500736500007, 14.330470073000072],
              [105.18430790300005, 14.345740458000108],
              [105.18425622600012, 14.314166158000134],
              [105.18797692900006, 14.291015117000143],
              [105.19743371600003, 14.270292867000109],
              [105.25691328900007, 14.182442932000043],
              [105.27531010000007, 14.164821269000058],
              [105.28218306500003, 14.161255595000085],
              [105.29660078900014, 14.156837260000088],
              [105.30393884300003, 14.152393087000078],
              [105.32946700100007, 14.117563171000114],
              [105.33778690600013, 14.10999257400006],
              [105.34786381100008, 14.10606516500009],
              [105.36409021000009, 14.104049785000143],
              [105.39246057100007, 14.103739726000057],
              [105.42217452000006, 14.107873840000082],
              [105.45007979400003, 14.117149760000103],
              [105.47385095200013, 14.132523499000087],
              [105.49049076400013, 14.13691599500008],
              [105.50527022300014, 14.14505503300009],
              [105.53317549600013, 14.164330343000117],
              [105.54123702000004, 14.159188538000123],
              [105.54893680800012, 14.153116557000075],
              [105.55555139200004, 14.146088562000074],
              [105.56139082900012, 14.138156230000021],
              [105.57653202300003, 14.144021505000097],
              [105.59456709800003, 14.136347554000025],
              [105.60986332200008, 14.120741272000075],
              [105.61725305200008, 14.102990417000058],
              [105.63291101100003, 14.11402333600006],
              [105.64314294500014, 14.113454895000103],
              [105.6532715250001, 14.107047017000056],
              [105.66934289600005, 14.100406596000056],
              [105.68365726700011, 14.098856303000034],
              [105.70515466300009, 14.10200856500009],
              [105.71600671400012, 14.101543477000064],
              [105.74401534000003, 14.086944885],
              [105.75889815300008, 14.06247609500005],
              [105.77016361500011, 14.034700012000101],
              [105.78711348500013, 14.010153707000129],
              [105.8730513920001, 13.936850688000021],
              [105.89558060100006, 13.924798655000075],
              [105.89966475400013, 13.922613831000135],
              [105.92457279500007, 13.917110291000057],
              [105.94917077600007, 13.919590760000034],
              [105.97397546400009, 13.929280091000066],
              [105.9974365650001, 13.928298239000085],
              [106.04921634900006, 13.915456645000106],
              [106.06916345200005, 13.916541850000101],
              [106.08383955900007, 13.934008484000046],
              [106.08197920800006, 13.980956523000103],
              [106.09407149300006, 13.996175232000041],
              [106.10848921700006, 14.010360413000086],
              [106.12642093900013, 14.022013449000056],
              [106.14207889800008, 14.035010071000087],
              [106.14946862900007, 14.053561911000116],
              [106.14455936700006, 14.072397970000054],
              [106.13127852400004, 14.08699656200011],
              [106.11525883000007, 14.100303243000027],
              [106.10171960500003, 14.11516021800007],
              [106.0761914470001, 14.17451060000009],
              [106.06058516500013, 14.191848043000093],
              [106.02627201300004, 14.213035380000065],
              [106.01247440600008, 14.225773621000116],
              [106.00405114800009, 14.245927430000094],
              [106.00797855600013, 14.270757955000136],
              [106.00451623600003, 14.28998158800006],
              [105.99340580300009, 14.305949606000098],
              [105.97397546400009, 14.321297506000079],
              [105.96916955600011, 14.33202036500009],
              [105.96782596800006, 14.343363343000064],
              [105.96942793800008, 14.354861348000085],
              [105.97397546400009, 14.36584259000007],
              [105.99412927300006, 14.36240610700014],
              [106.03815759300005, 14.347652486000129],
              [106.05541752200003, 14.348427633000142],
              [106.05810469600004, 14.353104350000109],
              [106.06058516500013, 14.36883982400009],
              [106.06353072100012, 14.372922261000099],
              [106.06864668800011, 14.373439026000128],
              [106.07944706200004, 14.372715556000045],
              [106.09500166800007, 14.3736457320001],
              [106.11903121000012, 14.369511618000075],
              [106.15411950700013, 14.367547913000038],
              [106.17323978700006, 14.369666646000027],
              [106.18915612900008, 14.378890890000022],
              [106.20393558800009, 14.399897360000125],
              [106.21065352400012, 14.421394756000069],
              [106.22078210500007, 14.473484599000116],
              [106.23008386200007, 14.490460307000134],
              [106.23597497600008, 14.484362488000073],
              [106.29674646000012, 14.447878926000072],
              [106.30646163000006, 14.445475973000015],
              [106.32015588400009, 14.444494120000044],
              [106.33343672700005, 14.448111470000129],
              [106.33999907000009, 14.448987947000077],
              [106.39379480000008, 14.456172994000028],
              [106.41921960500008, 14.466456604000115],
              [106.42950321500007, 14.485964457000108],
              [106.43348230000004, 14.486636251000093],
              [106.44082035300005, 14.492630717000026],
              [106.44516117400013, 14.499477845000087],
              [106.43358565300008, 14.505704855000076],
              [106.43265547700003, 14.512422790000102],
              [106.4343091230001, 14.519605815000148],
              [106.43647953400006, 14.523817444000102],
              [106.44578129100012, 14.529088440000038],
              [106.45668501800009, 14.527899882000014],
              [106.46944909700005, 14.524695944000129],
              [106.48484867400003, 14.523817444000102],
              [106.48484867400003, 14.530018616000078],
              [106.47751062100014, 14.532602438000083],
              [106.47316980000005, 14.537485861000022],
              [106.47094771400003, 14.544643046000061],
              [106.47058597900013, 14.554254862000064],
              [106.47223962400011, 14.56407338400004],
              [106.47714888600012, 14.566889751000105],
              [106.48376346800012, 14.56748402900007],
              [106.49104984600007, 14.570998027000115],
              [106.51249556500011, 14.590350851000082],
              [106.51843835500006, 14.585002340000116],
              [106.53099572800005, 14.56595957500005],
              [106.53497481300013, 14.553247172000098],
              [106.54024580900006, 14.521672873000114],
              [106.54375980700013, 14.51211273200002],
              [106.55244144700009, 14.506945089000112],
              [106.57538578300012, 14.502009990000076],
              [106.5856693930001, 14.495963847000041],
              [106.60535811400007, 14.46663747100007],
              [106.62204929000006, 14.457593943000091],
              [106.63440026900003, 14.450901998000091],
              [106.70716068500013, 14.429301250000023],
              [106.7115015060001, 14.425838928000076],
              [106.71925297100012, 14.41788075800011],
              [106.72390385000006, 14.411602071000104],
              [106.73165531400008, 14.396719259000065],
              [106.7666919350001, 14.348324280000028],
              [106.79299524000004, 14.322589417000117],
              [106.80689620000004, 14.312925924000098],
              [106.8208488360001, 14.30757741400005],
              [106.83583500200007, 14.307060649000107],
              [106.87459232600003, 14.328351339000093],
              [106.87929488100008, 14.332692159000075],
              [106.88508264200004, 14.335534363000136],
              [106.89567631000006, 14.33630950900006],
              [106.90477136300012, 14.333312277000047],
              [106.9234782310001, 14.321917623000047],
              [106.93360681200005, 14.320160624000067],
              [106.94611250800006, 14.323519592000082],
              [106.94972985800013, 14.32866139800008],
              [106.95014327000013, 14.334862569000066],
              [106.96109867400003, 14.360390727000095],
              [106.97365604700013, 14.363026225000112],
              [106.97794519100006, 14.36542917900006],
              [106.99737552900007, 14.395143128000129],
              [107.02657271300012, 14.430231425000073],
              [107.02724450800008, 14.435269877000039],
              [107.03034509300005, 14.436096701000068],
              [107.04295414300003, 14.430722351000014],
              [107.05933557200012, 14.418035787000065],
              [107.06786218300005, 14.406124370000029],
              [107.07855920500003, 14.400775859000063],
              [107.10078007000004, 14.40762298600012],
              [107.13142419500008, 14.42754425000004],
              [107.15870935100003, 14.45152211500006],
              [107.16682255100011, 14.467154236000098],
              [107.17245528200004, 14.484259136000048],
              [107.18056848200013, 14.496170553000084],
              [107.19550297100011, 14.496118877000072],
              [107.19560632300005, 14.496067200000056],
              [107.19581302900008, 14.495963847000041],
              [107.19596805900005, 14.495963847000041],
              [107.21121260600006, 14.493457540000051],
              [107.21973921800009, 14.497979228000077],
              [107.23028120900005, 14.518262228000083],
              [107.23239994400012, 14.538312683000044],
              [107.23389855900012, 14.544927267000034],
              [107.23787764500003, 14.549810690000058],
              [107.24945316600008, 14.556631978000027],
              [107.25451745600003, 14.560972799000098],
              [107.27219079600013, 14.585364075000115],
              [107.28728031400004, 14.598515727000091],
              [107.30567712400006, 14.597223816000053],
              [107.33270389800009, 14.578232727000085],
              [107.35156579700009, 14.561618754000065],
              [107.36138431900008, 14.557923889000065],
              [107.38014286400005, 14.55404815700011],
              [107.40344893500003, 14.543893738000051],
              [107.41492110200011, 14.543428650000124],
              [107.42784021000011, 14.553712260000026],
              [107.43094079600007, 14.561386210000109],
              [107.43094079600007, 14.569886983000117],
              [107.42975223800005, 14.578336080000014],
              [107.43032067900009, 14.586242574000067],
              [107.43326623600012, 14.594329936000065],
              [107.44044926000004, 14.60391591400007],
              [107.44380822800008, 14.609548645000089],
              [107.45176639800013, 14.632182923000045],
              [107.45822595200008, 14.638797506000046],
              [107.4737805580001, 14.646264750000071],
              [107.50690515100013, 14.693445333000085],
              [107.52039270000006, 14.704581605000016],
            ],
          ],
          [
            [
              [103.78443444100003, 10.515041408000059],
              [103.79859459700003, 10.505438544000071],
              [103.80591881600003, 10.484320380000042],
              [103.80486087300005, 10.46320221600007],
              [103.79468834700003, 10.453558661000045],
              [103.77833092500003, 10.453802802000041],
              [103.76384524800005, 10.456529039000088],
              [103.75196373800003, 10.464585679000038],
              [103.74341881600003, 10.480861721000053],
              [103.75171959700003, 10.48314036700009],
              [103.75586998800003, 10.485988674000055],
              [103.76392662900008, 10.494533596000053],
              [103.75733483200003, 10.50649648600006],
              [103.76042728000004, 10.513820705000057],
              [103.77027428500003, 10.51658763200004],
              [103.78443444100003, 10.515041408000059],
            ],
          ],
          [
            [
              [103.29712975400008, 10.731024481000077],
              [103.30144290500004, 10.72719961100006],
              [103.31006920700003, 10.725897528000075],
              [103.31755618600005, 10.721096096000053],
              [103.31820722700007, 10.706773179000038],
              [103.30502363400007, 10.70221588700008],
              [103.29322350400008, 10.696600653000075],
              [103.28370201900003, 10.687648830000057],
              [103.27735436300003, 10.672674872000073],
              [103.26872806100005, 10.679632880000042],
              [103.26417076900003, 10.691229559000078],
              [103.26172936300003, 10.702053127000056],
              [103.26002037900008, 10.706773179000038],
              [103.26075280000003, 10.709173895000049],
              [103.22885175900007, 10.721096096000053],
              [103.21363366000003, 10.733343817000048],
              [103.20191491000003, 10.747626044000071],
              [103.19849694100003, 10.76235586100006],
              [103.20834394600007, 10.77570221600007],
              [103.22852623800003, 10.78266022300005],
              [103.24512780000003, 10.77798086100006],
              [103.25879967500003, 10.766791083000044],
              [103.27051842500003, 10.754584052000041],
              [103.27271569100003, 10.751288153000075],
              [103.27466881600003, 10.744330145000049],
              [103.27735436300003, 10.74095286700009],
              [103.28296959700003, 10.739406643000052],
              [103.28939863400007, 10.739894924000055],
              [103.29493248800003, 10.738430080000057],
              [103.29712975400008, 10.731024481000077],
            ],
          ],
          [
            [
              [103.03711998800003, 11.357896226000037],
              [103.04175866000003, 11.34666575700004],
              [103.04688561300003, 11.33812083500004],
              [103.04867597700007, 11.330877997000073],
              [103.04330488400007, 11.323716539000088],
              [103.04859459700003, 11.310126044000071],
              [103.04786217500003, 11.291449286000045],
              [103.04330488400007, 11.27342357000009],
              [103.03711998800003, 11.261664130000042],
              [103.02344811300003, 11.255194403000075],
              [103.00757897200003, 11.255072333000044],
              [102.99805748800003, 11.260199286000045],
              [103.00294030000003, 11.269110419000071],
              [102.99195397200003, 11.28001536700009],
              [102.98853600400008, 11.300930080000057],
              [102.98926842500003, 11.337388414000088],
              [102.98170006600003, 11.380113023000092],
              [102.98145592500003, 11.404689846000053],
              [102.98926842500003, 11.426174221000053],
              [102.99089603000004, 11.421820380000042],
              [102.99366295700003, 11.41705963700008],
              [102.99545332100007, 11.412543036000045],
              [103.00668379000007, 11.422064520000049],
              [103.01636803500003, 11.423081773000092],
              [103.02418053500003, 11.417181708000044],
              [103.03663170700003, 11.391994533000059],
              [103.03728274800005, 11.38117096600007],
              [103.03614342500003, 11.370835679000038],
              [103.03711998800003, 11.357896226000037],
            ],
          ],
          [
            [
              [103.03028405000003, 11.501898505000042],
              [103.03532962300005, 11.49249909100007],
              [103.04656009200005, 11.476060289000088],
              [103.05079186300003, 11.46775950700004],
              [103.05079186300003, 11.460353908000059],
              [103.04615319100003, 11.453314520000049],
              [103.03492272200003, 11.431708075000074],
              [103.03028405000003, 11.426174221000053],
              [103.02035566500007, 11.426947333000044],
              [103.01954186300003, 11.43695709800005],
              [103.02344811300003, 11.460353908000059],
              [103.01441491000003, 11.47654857000009],
              [103.00131269600007, 11.495266018000052],
              [102.99586022200003, 11.513739325000074],
              [103.00912519600007, 11.529242255000042],
              [103.02637780000003, 11.519110419000071],
              [103.03028405000003, 11.515570380000042],
              [103.03248131600003, 11.51040273600006],
              [103.03239993600005, 11.505560614000046],
              [103.03126061300003, 11.50226471600007],
              [103.03028405000003, 11.501898505000042],
            ],
          ],
          [
            [
              [103.33415774800005, 10.583929755000042],
              [103.33594811300003, 10.58344147300005],
              [103.33887780000003, 10.579779364000046],
              [103.33887780000003, 10.572414455000057],
              [103.33464603000004, 10.564601955000057],
              [103.33008873800003, 10.553534247000073],
              [103.32349694100003, 10.54515208500004],
              [103.31275475400008, 10.551662502000056],
              [103.29216556100005, 10.583156643000052],
              [103.28516686300003, 10.59906647300005],
              [103.28907311300003, 10.61273834800005],
              [103.30250084700003, 10.618109442000048],
              [103.31381269600007, 10.61945221600007],
              [103.31950931100005, 10.617336330000057],
              [103.32154381600003, 10.61033763200004],
              [103.31185957100007, 10.596625067000048],
              [103.31120853000004, 10.59202708500004],
              [103.31080162900008, 10.58698151200008],
              [103.31251061300003, 10.57908763200004],
              [103.31755618600005, 10.574408270000049],
              [103.32471764400003, 10.573879299000055],
              [103.33155358200003, 10.57953522300005],
              [103.33415774800005, 10.583929755000042],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'United Arab Emirates',
        iso3: 'ARE',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [56.27905523484418, 25.627445697852735],
              [56.30030358200008, 25.616156317000048],
              [56.323252800000034, 25.607814846000053],
              [56.34001712300005, 25.60455963700008],
              [56.347992384000065, 25.593085028000075],
              [56.36996504000007, 25.52570221600007],
              [56.36378014400003, 25.433254299000055],
              [56.36500084700003, 25.423163153000075],
              [56.36833743600005, 25.396307684000078],
              [56.36695397200003, 25.38886139500005],
              [56.35922285200007, 25.37641022300005],
              [56.36019941500007, 25.367254950000074],
              [56.36996504000007, 25.351304429000038],
              [56.37468509200005, 25.34121328300006],
              [56.37916100400008, 25.33462148600006],
              [56.38249759200005, 25.32684967700004],
              [56.38298587300005, 25.32127513200004],
              [56.38363691500007, 25.31346263200004],
              [56.38266035200007, 25.30223216400009],
              [56.37842858200008, 25.28261953300006],
              [56.37525475400008, 25.252752997000073],
              [56.365977410000085, 25.20921458500004],
              [56.36223392000005, 25.06826406500005],
              [56.361989780000044, 25.05727773600006],
              [56.38331139400003, 24.978216864000046],
              [56.32899540200003, 24.972688701000024],
              [56.32445085900008, 24.967938686000124],
              [56.319280233000086, 24.962534282000078],
              [56.316053243000056, 24.929912347000098],
              [56.31427759700006, 24.911962176000102],
              [56.31359582600004, 24.905070089000063],
              [56.30832482900013, 24.89517405200006],
              [56.2803162030001, 24.87698394800013],
              [56.2746828060001, 24.871949287000106],
              [56.241662232000124, 24.842438253000054],
              [56.22367883300012, 24.834480083000088],
              [56.18626509600006, 24.83024261500013],
              [56.17136626700011, 24.82406878500008],
              [56.17117557700004, 24.823989766000025],
              [56.15484582500011, 24.786705221000105],
              [56.13334842900008, 24.762830709000113],
              [56.12725061000003, 24.745699972000054],
              [56.118258912000044, 24.735416362000066],
              [56.09913863200006, 24.730507100000025],
              [56.077951294000115, 24.72975779200003],
              [56.07626952200013, 24.729972135000097],
              [56.06213830600012, 24.731773173000065],
              [56.03154585800013, 24.754149068000046],
              [56.002090291000115, 24.82300791400006],
              [55.96477990700009, 24.85385874400005],
              [55.95764855900012, 24.868664042000077],
              [55.96085249800012, 24.881247254000087],
              [55.978422486000056, 24.886104838],
              [55.992375122000055, 24.88300425200005],
              [56.00529423000006, 24.87698394800013],
              [56.02927209500007, 24.861170959000034],
              [56.02525223400011, 24.882562365000084],
              [56.016973104000044, 24.926619162000108],
              [56.005604289000075, 24.956178080000043],
              [55.978422486000056, 24.971758525000084],
              [55.975872913000046, 24.972112462000055],
              [55.93542769400011, 24.9777271520001],
              [55.89698042800006, 24.968606262000023],
              [55.862150513000074, 24.948452454000048],
              [55.85782570100008, 24.944850718000012],
              [55.82938765500006, 24.921167298000043],
              [55.79910526500004, 24.886104838],
              [55.78866662600012, 24.855202332000104],
              [55.79703820800012, 24.778359477000024],
              [55.79703820800012, 24.759549255000124],
              [55.792697388000136, 24.722290548],
              [55.794764445000055, 24.703919577000093],
              [55.79998138500008, 24.693258293000028],
              [55.81491825400013, 24.662733460000098],
              [55.818225546000065, 24.64338063600006],
              [55.790216919000045, 24.619867859000053],
              [55.78401574700007, 24.586329855000045],
              [55.76995975800014, 24.572403056000056],
              [55.75983117700008, 24.558527934],
              [55.76117476400003, 24.537443949000064],
              [55.77368046100014, 24.495250143000092],
              [55.771406698000135, 24.441093242000093],
              [55.77461063700008, 24.425900371000054],
              [55.78101851400004, 24.418872376000067],
              [55.801068969000085, 24.406470032000087],
              [55.80861372900006, 24.397633362000093],
              [55.81088749200006, 24.389235941],
              [55.80737349500009, 24.34078928700005],
              [55.80096561700009, 24.326268209000077],
              [55.762104940000086, 24.262964579000098],
              [55.754146770000034, 24.245472107000055],
              [55.75569706200008, 24.230330912000042],
              [55.767685995000136, 24.22487904900005],
              [55.83031783100006, 24.21227],
              [55.847164348000035, 24.21141733800009],
              [55.90318160000004, 24.232242940000035],
              [55.93315393100005, 24.220719096000025],
              [55.9489669190001, 24.184829814000054],
              [55.96074914600007, 24.142429301000035],
              [55.99785282400006, 24.081270244000038],
              [55.98679406800005, 24.065379740000097],
              [55.92354211400004, 24.051142883000054],
              [55.807063436000135, 24.00747629900006],
              [55.78845992000004, 24.009569194000036],
              [55.76241499800011, 24.02814687100009],
              [55.7444316000001, 24.025278829000015],
              [55.72799849500012, 24.019594421000065],
              [55.71259891800014, 24.01923268700007],
              [55.68004276500011, 24.02427113900005],
              [55.64686649600009, 24.025020447000045],
              [55.61834110500013, 24.02013702500001],
              [55.59105594900012, 24.010008443000075],
              [55.56170373500004, 23.995228984000036],
              [55.54227339700009, 23.985436299000085],
              [55.49979537000013, 23.970605164000048],
              [55.45680057800007, 23.96316375800005],
              [55.45276981600006, 23.94856516600008],
              [55.46155481000005, 23.93055592900008],
              [55.4782979740001, 23.916577454000063],
              [55.51457482900014, 23.896604512000053],
              [55.530594523000104, 23.8746678670001],
              [55.53514204900006, 23.845884094000056],
              [55.53834598800012, 23.770048930000073],
              [55.534108520000075, 23.756768087000054],
              [55.487393025000074, 23.693257752000093],
              [55.4782979740001, 23.676359559],
              [55.445328409000126, 23.5522586070001],
              [55.431479126000056, 23.532931620000042],
              [55.39416874200003, 23.49528534000011],
              [55.39396203600006, 23.495181986000077],
              [55.37525516700009, 23.469343771000055],
              [55.36409305800004, 23.436012472000087],
              [55.343215780000094, 23.33627695700001],
              [55.32109826600009, 23.27509206100008],
              [55.22591027900012, 23.121251322000077],
              [55.19480106600008, 23.02508148200006],
              [55.19128706900011, 22.995470886000092],
              [55.19128706900011, 22.995367534000067],
              [55.19759159300014, 22.84945912700003],
              [55.1868428950001, 22.703576559000098],
              [55.120387004000065, 22.623426412000114],
              [55.10529748500005, 22.620945943000052],
              [54.96856164600007, 22.637740784000115],
              [54.829448690000106, 22.654897360000078],
              [54.69033573400009, 22.671950582000093],
              [54.55132613100011, 22.68900380500004],
              [54.41241988100006, 22.7061603800001],
              [54.27330692600009, 22.723265279000046],
              [54.13429732200012, 22.74031850200008],
              [53.995287720000135, 22.757449240000128],
              [53.85607141100013, 22.774579977000073],
              [53.71706180800004, 22.791684876000133],
              [53.57805220600005, 22.80876393700008],
              [53.43893925000009, 22.825868835000037],
              [53.29992964700011, 22.842973735000058],
              [53.160920044000136, 22.860052796],
              [53.02180708900005, 22.877131857000066],
              [52.88279748500008, 22.894236756000097],
              [52.743787883000095, 22.911341654000054],
              [52.58307417800006, 22.93110789000012],
              [52.55847619600007, 22.93857513400006],
              [52.53847741700014, 22.954749858000056],
              [52.48483728100007, 23.018337708000033],
              [52.43264408400006, 23.080375265000086],
              [52.380502564000096, 23.142412822000026],
              [52.32830936600004, 23.20445037800009],
              [52.27627120000005, 23.26641042100003],
              [52.2240780030001, 23.328422140000058],
              [52.171988159000136, 23.390485535000025],
              [52.11979496300006, 23.452523092],
              [52.067705119000095, 23.51448313400003],
              [52.01551192300013, 23.576494853000085],
              [51.963422078000065, 23.638558248000052],
              [51.9112288820001, 23.700518290000062],
              [51.85903568500004, 23.76253000900003],
              [51.80684248900013, 23.82449005100007],
              [51.75475264500005, 23.886553446000036],
              [51.7025594480001, 23.94859100300006],
              [51.650469605000126, 24.010602723000105],
              [51.59352217700007, 24.07832468700012],
              [51.5785360110001, 24.1018374640001],
              [51.57316166200013, 24.127830709000065],
              [51.57522871900011, 24.191935324],
              [51.575538778000066, 24.217721863000108],
              [51.569346550000034, 24.256170966000113],
              [51.59066816500007, 24.284409898000035],
              [51.59164472700007, 24.328599351000037],
              [51.57398522200003, 24.364447333000044],
              [51.593760613000086, 24.384914455000057],
              [51.60238691500007, 24.36790599200009],
              [51.623789910000085, 24.33934153900009],
              [51.627940300000034, 24.31972890800006],
              [51.627940300000034, 24.26203034100007],
              [51.63445071700005, 24.22687409100007],
              [51.64869225400008, 24.218573309000078],
              [51.66293379000007, 24.232814846000053],
              [51.672618035000085, 24.27806224200009],
              [51.67937259200005, 24.265773830000057],
              [51.68930097700007, 24.23468659100007],
              [51.695974155000044, 24.224351304000038],
              [51.70069420700008, 24.221909898000035],
              [51.70980879000007, 24.221096096000053],
              [51.71827233200008, 24.223089911000045],
              [51.723643425000034, 24.227769273000035],
              [51.72486412900008, 24.232570705000057],
              [51.72087649800005, 24.23468659100007],
              [51.74008222700007, 24.27753327000005],
              [51.758799675000034, 24.29051341400009],
              [51.77947024800005, 24.26203034100007],
              [51.782237175000034, 24.240383205000057],
              [51.77198326900003, 24.176336981000077],
              [51.773448113000086, 24.153225002000056],
              [51.78565514400003, 24.10374583500004],
              [51.78679446700005, 24.093003648000035],
              [51.78565514400003, 24.05931224200009],
              [51.787771030000044, 24.048570054000038],
              [51.79712975400008, 24.028225002000056],
              [51.799164259000065, 24.018377997000073],
              [51.80941816500007, 24.00067780200004],
              [51.83326256600009, 23.994940497000073],
              [51.881846550000034, 23.993882554000038],
              [51.893565300000034, 23.990383205000057],
              [51.90251712300005, 23.985663153000075],
              [51.91968834700003, 23.970363674000055],
              [51.928721550000034, 23.96474844000005],
              [51.93637129000007, 23.96474844000005],
              [51.93913821700005, 23.969183661000045],
              [51.93336022200003, 23.977118231000077],
              [51.93140709700003, 23.987982489000046],
              [51.95289147200003, 23.99091217700004],
              [52.01002037900008, 23.98786041900007],
              [52.01693769600007, 23.98969147300005],
              [52.02393639400003, 23.98786041900007],
              [52.03638756600009, 23.977118231000077],
              [52.067393425000034, 23.963446356000077],
              [52.07569420700008, 23.963812567000048],
              [52.117930535000085, 23.97089264500005],
              [52.13559004000007, 23.966538804000038],
              [52.145518425000034, 23.971991278000075],
              [52.15552819100009, 23.966538804000038],
              [52.17107181100005, 23.97337474200009],
              [52.188243035000085, 23.974269924000055],
              [52.20630944100009, 23.973130601000037],
              [52.22437584700003, 23.97402578300006],
              [52.240977410000085, 23.979641018000052],
              [52.27906334700003, 24.00136953300006],
              [52.295909050000034, 24.003729559000078],
              [52.32781009200005, 24.003851630000042],
              [52.34107506600009, 24.007513739000046],
              [52.352549675000034, 24.01634349200009],
              [52.36475670700008, 24.027899481000077],
              [52.37810306100005, 24.037990627000056],
              [52.39234459700003, 24.042303778000075],
              [52.408864780000044, 24.04523346600007],
              [52.428070509000065, 24.05263906500005],
              [52.44418379000007, 24.06268952000005],
              [52.45093834700003, 24.07330963700008],
              [52.45655358200008, 24.08466217700004],
              [52.486989780000044, 24.096625067000048],
              [52.50180097700007, 24.107489325000074],
              [52.51498457100007, 24.11981842700004],
              [52.53248131600009, 24.13182200700004],
              [52.55005944100009, 24.141058661000045],
              [52.56364993600005, 24.14472077000005],
              [52.574554884000065, 24.152085679000038],
              [52.57764733200008, 24.16901276200008],
              [52.57797285200007, 24.187445380000042],
              [52.580739780000044, 24.199367580000057],
              [52.600271030000044, 24.209540106000077],
              [52.61841881600009, 24.203680731000077],
              [52.63412519600007, 24.189886786000045],
              [52.67009524800005, 24.14472077000005],
              [52.68132571700005, 24.14081452000005],
              [52.68539472700007, 24.143459377000056],
              [52.68864993600005, 24.148586330000057],
              [52.69743899800005, 24.152167059000078],
              [52.72006269600007, 24.151516018000052],
              [52.76099694100009, 24.14061107000009],
              [52.78272545700008, 24.137884833000044],
              [52.79542076900003, 24.139878648000035],
              [52.81690514400003, 24.149318752000056],
              [52.82764733200008, 24.152167059000078],
              [52.83920332100007, 24.152004299000055],
              [52.84782962300005, 24.149603583000044],
              [52.85474694100009, 24.14667389500005],
              [52.861989780000044, 24.14472077000005],
              [52.94711347700007, 24.137884833000044],
              [52.95671634200005, 24.13963450700004],
              [52.992198113000086, 24.152167059000078],
              [52.99691816500007, 24.155910549000055],
              [52.99830162900008, 24.161363023000035],
              [52.99976647200003, 24.165676174000055],
              [53.005869988000086, 24.165838934000078],
              [53.01099694100009, 24.16278717700004],
              [53.01482181100005, 24.15843333500004],
              [53.017588738000086, 24.154364325000074],
              [53.019541863000086, 24.152167059000078],
              [53.048838738000086, 24.12995026200008],
              [53.06723066500007, 24.121893622000073],
              [53.10718834700003, 24.137884833000044],
              [53.127696160000085, 24.130682684000078],
              [53.146494988000086, 24.12132396000004],
              [53.16342207100007, 24.124823309000078],
              [53.14966881600009, 24.13222890800006],
              [53.14576256600009, 24.141750393000052],
              [53.14535566500007, 24.15306224200009],
              [53.14242597700007, 24.165838934000078],
              [53.16529381600009, 24.170314846000053],
              [53.19157962300005, 24.159409898000035],
              [53.215586785000085, 24.141546942000048],
              [53.23178144600007, 24.124823309000078],
              [53.24561608200008, 24.10415273600006],
              [53.25375410200007, 24.098781643000052],
              [53.30909264400003, 24.095770575000074],
              [53.43702233200008, 24.11981842700004],
              [53.44581139400003, 24.11981842700004],
              [53.45460045700008, 24.114406643000052],
              [53.46827233200008, 24.10032786700009],
              [53.47877037900008, 24.093695380000042],
              [53.49301191500007, 24.090643622000073],
              [53.507823113000086, 24.091538804000038],
              [53.51929772200003, 24.096869208000044],
              [53.537445509000065, 24.08429596600007],
              [53.54818769600007, 24.07876211100006],
              [53.557383660000085, 24.07640208500004],
              [53.561534050000034, 24.07257721600007],
              [53.57439212300005, 24.054388739000046],
              [53.58130944100009, 24.048529364000046],
              [53.58961022200003, 24.04706452000005],
              [53.60108483200008, 24.04718659100007],
              [53.612071160000085, 24.048976955000057],
              [53.62916100400008, 24.057033596000053],
              [53.639414910000085, 24.054754950000074],
              [53.64893639400003, 24.05036041900007],
              [53.656993035000085, 24.048529364000046],
              [53.687836134000065, 24.06207916900007],
              [53.69459069100009, 24.066473700000074],
              [53.70281009200005, 24.07050202000005],
              [53.71241295700008, 24.068833726000037],
              [53.72242272200003, 24.06509023600006],
              [53.73210696700005, 24.06273021000004],
              [53.85377037900008, 24.06199778900009],
              [53.878916863000086, 24.064846096000053],
              [53.88982181100005, 24.07330963700008],
              [53.951182488000086, 24.10374583500004],
              [54.014333530000044, 24.11326732000009],
              [54.034190300000034, 24.122748114000046],
              [54.05518639400003, 24.12641022300005],
              [54.08155358200008, 24.137884833000044],
              [54.112071160000085, 24.141791083000044],
              [54.12256920700008, 24.14472077000005],
              [54.135427280000044, 24.152044989000046],
              [54.15365644600007, 24.165269273000035],
              [54.17009524800005, 24.18109772300005],
              [54.17709394600007, 24.196193752000056],
              [54.18702233200008, 24.203599351000037],
              [54.25277754000007, 24.221096096000053],
              [54.30591881600009, 24.256781317000048],
              [54.31495201900003, 24.258246161000045],
              [54.323008660000085, 24.270656643000052],
              [54.34197024800005, 24.26976146000004],
              [54.38257897200003, 24.25458405200004],
              [54.39014733200008, 24.26585521000004],
              [54.42725670700008, 24.292141018000052],
              [54.445974155000044, 24.316148179000038],
              [54.48560631600009, 24.388332424000055],
              [54.47999108200008, 24.413397528000075],
              [54.483164910000085, 24.425116278000075],
              [54.49927819100009, 24.43268463700008],
              [54.49000084700003, 24.438381252000056],
              [54.48560631600009, 24.439520575000074],
              [54.48560631600009, 24.446966864000046],
              [54.50114993600005, 24.44562409100007],
              [54.525726759000065, 24.435207424000055],
              [54.54029381600009, 24.43268463700008],
              [54.533946160000085, 24.445257880000042],
              [54.51685631600009, 24.46238841400009],
              [54.51343834700003, 24.474310614000046],
              [54.528330925000034, 24.467962958000044],
              [54.54428144600007, 24.46356842700004],
              [54.558604363000086, 24.45770905200004],
              [54.56812584700003, 24.446966864000046],
              [54.57439212300005, 24.446966864000046],
              [54.571299675000034, 24.47333405200004],
              [54.55250084700003, 24.481634833000044],
              [54.526052280000044, 24.482855536000045],
              [54.49927819100009, 24.487941799000055],
              [54.44068444100009, 24.523911851000037],
              [54.41732832100007, 24.528957424000055],
              [54.41732832100007, 24.535101630000042],
              [54.42937259200005, 24.538275458000044],
              [54.44166100400008, 24.545721747000073],
              [54.451914910000085, 24.55654531500005],
              [54.45362389400003, 24.55019765800006],
              [54.457041863000086, 24.541896877000056],
              [54.46509850400008, 24.535101630000042],
              [54.46241295700008, 24.545355536000045],
              [54.465830925000034, 24.554348049000055],
              [54.47877037900008, 24.56989166900007],
              [54.48560631600009, 24.56989166900007],
              [54.49350019600007, 24.542303778000075],
              [54.51286868600005, 24.515285549000055],
              [54.537445509000065, 24.498439846000053],
              [54.561289910000085, 24.501613674000055],
              [54.55518639400003, 24.50458405200004],
              [54.54029381600009, 24.51585521000004],
              [54.551768425000034, 24.515326239000046],
              [54.573252800000034, 24.508978583000044],
              [54.58179772200003, 24.50844961100006],
              [54.58513431100005, 24.51194896000004],
              [54.593760613000086, 24.525824286000045],
              [54.59888756600009, 24.528957424000055],
              [54.63640384200005, 24.597805080000057],
              [54.619802280000044, 24.604315497000073],
              [54.61215254000007, 24.613226630000042],
              [54.615896030000044, 24.621161200000074],
              [54.63298587300005, 24.62449778900009],
              [54.64340254000007, 24.630560614000046],
              [54.64633222700007, 24.644232489000046],
              [54.65211022200003, 24.65839264500005],
              [54.670583530000044, 24.666083075000074],
              [54.670583530000044, 24.672308661000045],
              [54.66187584700003, 24.678127346000053],
              [54.65772545700008, 24.688381252000056],
              [54.65479576900003, 24.700995184000078],
              [54.65015709700003, 24.71385325700004],
              [54.65552819100009, 24.721096096000053],
              [54.64828535200007, 24.72532786700009],
              [54.64047285200007, 24.73261139500005],
              [54.643321160000085, 24.74868398600006],
              [54.65251712300005, 24.75800202000005],
              [54.69166100400008, 24.782171942000048],
              [54.69654381600009, 24.788885809000078],
              [54.70134524800005, 24.79828522300005],
              [54.707041863000086, 24.803900458000044],
              [54.73780358200008, 24.79092031500005],
              [54.73943118600005, 24.789618231000077],
              [54.75416100400008, 24.79242584800005],
              [54.768565300000034, 24.80145905200004],
              [54.77361087300005, 24.81476471600007],
              [54.76002037900008, 24.830552476000037],
              [54.86882571700005, 24.88865794500009],
              [54.91773522200003, 24.92088450700004],
              [54.94809004000007, 24.946437893000052],
              [54.96810957100007, 24.958644924000055],
              [54.992849155000044, 24.966009833000044],
              [54.99496504000007, 24.96666087400007],
              [54.99935957100007, 24.967962958000044],
              [55.003347201000054, 24.969142971000053],
              [55.005869988000086, 24.969916083000044],
              [55.010752800000034, 24.972601630000042],
              [55.014008009000065, 24.974351304000038],
              [55.01579837300005, 24.97532786700009],
              [55.01799563900005, 24.976507880000042],
              [55.022227410000085, 24.97882721600007],
              [55.04997806100005, 24.993394273000035],
              [55.04460696700005, 25.01390208500004],
              [55.07764733200008, 25.02024974200009],
              [55.08228600400008, 25.016831773000035],
              [55.156911655000044, 25.09674713700008],
              [55.25904381600009, 25.215277411000045],
              [55.26417076900003, 25.23118724200009],
              [55.26335696700005, 25.244940497000073],
              [55.28239993600005, 25.260687567000048],
              [55.29835045700008, 25.25849030200004],
              [55.31332441500007, 25.23891836100006],
              [55.318369988000086, 25.22528717700004],
              [55.31421959700003, 25.212062893000052],
              [55.301117384000065, 25.19367096600007],
              [55.328868035000085, 25.20148346600007],
              [55.33423912900008, 25.219224351000037],
              [55.326508009000065, 25.24119700700004],
              [55.30640709700003, 25.275051174000055],
              [55.303721550000034, 25.283026434000078],
              [55.309255405000044, 25.29173411700009],
              [55.33936608200008, 25.321437893000052],
              [55.34815514400003, 25.324774481000077],
              [55.363291863000086, 25.324042059000078],
              [55.35865319100009, 25.33657461100006],
              [55.359385613000086, 25.348578192000048],
              [55.36548912900008, 25.358587958000044],
              [55.376963738000086, 25.364976304000038],
              [55.387054884000065, 25.357082424000055],
              [55.407237175000034, 25.372748114000046],
              [55.43897545700008, 25.41278717700004],
              [55.44516035200007, 25.41278717700004],
              [55.449554884000065, 25.40062083500004],
              [55.45533287900008, 25.39988841400009],
              [55.46119225400008, 25.407375393000052],
              [55.46566816500007, 25.419623114000046],
              [55.47250410200007, 25.41278717700004],
              [55.48609459700003, 25.44993724200009],
              [55.49561608200008, 25.466131903000075],
              [55.506602410000085, 25.47483958500004],
              [55.494151238000086, 25.48078034100007],
              [55.50049889400003, 25.492987372000073],
              [55.51335696700005, 25.50885651200008],
              [55.520274285000085, 25.52570221600007],
              [55.52466881600009, 25.542629299000055],
              [55.53565514400003, 25.56240469000005],
              [55.55103600400008, 25.578599351000037],
              [55.56812584700003, 25.58466217700004],
              [55.559580925000034, 25.568304755000042],
              [55.54859459700003, 25.55487702000005],
              [55.54224694100009, 25.54254791900007],
              [55.54818769600007, 25.52948639500005],
              [55.56373131600009, 25.52374909100007],
              [55.58334394600007, 25.52684153900009],
              [55.60515384200005, 25.532945054000038],
              [55.62631269600007, 25.536322333000044],
              [55.63257897200003, 25.544175523000035],
              [55.64812259200005, 25.583156643000052],
              [55.656911655000044, 25.597723700000074],
              [55.68344160200007, 25.623521226000037],
              [55.69947350400008, 25.634711005000042],
              [55.73389733200008, 25.64679596600007],
              [55.75953209700003, 25.67967357000009],
              [55.770518425000034, 25.687160549000055],
              [55.77955162900008, 25.688421942000048],
              [55.79224694100009, 25.69204336100006],
              [55.803477410000085, 25.697414455000057],
              [55.80836022200003, 25.70416901200008],
              [55.812836134000065, 25.70652903900009],
              [55.842458530000044, 25.713812567000048],
              [55.87810306100005, 25.740057684000078],
              [55.93246504000007, 25.802557684000078],
              [55.959727410000085, 25.82367584800005],
              [55.953786655000044, 25.814601955000057],
              [55.94743899800005, 25.794094143000052],
              [55.93718509200005, 25.776678778000075],
              [55.94125410200007, 25.770697333000044],
              [55.94849694100009, 25.76894765800006],
              [55.95232181100005, 25.77212148600006],
              [55.95443769600007, 25.78709544500009],
              [55.96371504000007, 25.815375067000048],
              [55.96599368600005, 25.83421458500004],
              [55.97234134200005, 25.84284088700008],
              [56.014414910000085, 25.878851630000042],
              [56.02320397200003, 25.889227606000077],
              [56.03077233200008, 25.900864976000037],
              [56.03687584700003, 25.91510651200008],
              [56.041026238000086, 25.933539130000042],
              [56.034190300000034, 25.933539130000042],
              [56.03060957100007, 25.924261786000045],
              [56.02466881600009, 25.916449286000045],
              [56.01693769600007, 25.91046784100007],
              [56.00757897200003, 25.90688711100006],
              [56.03370201900003, 25.946437893000052],
              [56.055349155000044, 25.988755601000037],
              [56.073252800000034, 26.05231354400007],
              [56.07739667277616, 26.06104817532254],
              [56.10058557100007, 26.062854716000047],
              [56.15133182800014, 26.074791972000085],
              [56.16270064300005, 26.073551737000045],
              [56.178410278000115, 26.035001119000057],
              [56.18347456900011, 26.014537252000096],
              [56.18130415900009, 25.99624379500004],
              [56.174689575000116, 25.966529846000057],
              [56.170555461000106, 25.876819560000072],
              [56.163837524000144, 25.862453512000073],
              [56.14451053900012, 25.83790720600011],
              [56.1396529540001, 25.82297271700007],
              [56.144097127000066, 25.805919495000026],
              [56.167351522000104, 25.777704163000053],
              [56.1720024010001, 25.765250143000074],
              [56.16487105300013, 25.752176005000123],
              [56.15195194500012, 25.743132629000073],
              [56.141203248000124, 25.732693991000033],
              [56.14037642400007, 25.71553741500007],
              [56.14513065600005, 25.67083730100002],
              [56.150815064000085, 25.65884836900007],
              [56.1524960590001, 25.65796117700002],
              [56.15639611800003, 25.655902812000065],
              [56.1798572190001, 25.652078756000023],
              [56.18884891800013, 25.64541249600002],
              [56.19877079200006, 25.625258687000027],
              [56.20579878700005, 25.6177656040001],
              [56.221508423000046, 25.61383819600003],
              [56.23752811700007, 25.616577047000064],
              [56.27905523484418, 25.627445697852735],
            ],
            [
              [56.26062458100006, 25.3310754190001],
              [56.23362458100013, 25.312526258],
              [56.23566776500007, 25.29628651900005],
              [56.238880452000046, 25.286246902000087],
              [56.24488716200011, 25.27798767600008],
              [56.23512625800004, 25.26747593300003],
              [56.208375419000106, 25.25537374200003],
              [56.20612290300005, 25.230596063000107],
              [56.20762458100006, 25.22083516000002],
              [56.21995813000012, 25.21525787400013],
              [56.235771118000116, 25.21117543500013],
              [56.25220422400008, 25.217634990000093],
              [56.28176314300009, 25.23691029900003],
              [56.29314974300013, 25.24584638800009],
              [56.31642574400007, 25.253354775000034],
              [56.34437541900007, 25.26652793600003],
              [56.349122903000136, 25.29402458100013],
              [56.30936870900007, 25.301327936000106],
              [56.29068832500013, 25.327543033000026],
              [56.26062458100006, 25.3310754190001],
            ],
          ],
          [
            [
              [56.26302625800014, 25.24922290300013],
              [56.259578304000115, 25.27598189200002],
              [56.265075419000084, 25.281175419000036],
              [56.27381171300004, 25.28128926500004],
              [56.288327936000144, 25.271926258000022],
              [56.28297899300014, 25.255476134000062],
              [56.26302625800014, 25.24922290300013],
            ],
          ],
          [
            [
              [53.656993035000085, 24.15839264500005],
              [53.63949629000007, 24.16046784100007],
              [53.62818444100009, 24.164211330000057],
              [53.62777754000007, 24.171942450000074],
              [53.643321160000085, 24.18626536700009],
              [53.654633009000065, 24.192613023000035],
              [53.65609785200007, 24.193426825000074],
              [53.65609785200007, 24.193508205000057],
              [53.680674675000034, 24.20184967700004],
              [53.69117272200003, 24.206732489000046],
              [53.71021569100009, 24.222316799000055],
              [53.715830925000034, 24.22569407800006],
              [53.72282962300005, 24.22988515800006],
              [53.72714277400007, 24.23114655200004],
              [53.738942905000044, 24.23468659100007],
              [53.74830162900008, 24.234442450000074],
              [53.76295006600009, 24.22870514500005],
              [53.76514733200008, 24.228257554000038],
              [53.770274285000085, 24.22724030200004],
              [53.77711022200003, 24.22988515800006],
              [53.80103600400008, 24.247748114000046],
              [53.82862389400003, 24.25844961100006],
              [53.83961022200003, 24.26434967700004],
              [53.84815514400003, 24.275051174000055],
              [53.853526238000086, 24.26268138200004],
              [53.852305535000085, 24.25975169500009],
              [53.84815514400003, 24.25458405200004],
              [53.858409050000034, 24.239203192000048],
              [53.86304772200003, 24.23468659100007],
              [53.888601108000046, 24.219956773000035],
              [53.89234459700003, 24.21784088700008],
              [53.92660566500007, 24.211371161000045],
              [53.933929884000065, 24.208644924000055],
              [53.95460045700008, 24.200995184000078],
              [53.964854363000086, 24.17259349200009],
              [53.95101972700007, 24.149725653000075],
              [53.92042076900003, 24.139837958000044],
              [53.88461347700007, 24.141180731000077],
              [53.85499108200008, 24.152167059000078],
              [53.85710696700005, 24.161444403000075],
              [53.84937584700003, 24.174221096000053],
              [53.83741295700008, 24.177435614000046],
              [53.82699629000007, 24.15839264500005],
              [53.83448326900003, 24.152167059000078],
              [53.807302280000044, 24.135972398000035],
              [53.77466881600009, 24.130113023000035],
              [53.74146569100009, 24.13349030200004],
              [53.711599155000044, 24.14472077000005],
              [53.694346550000034, 24.153591213000084],
              [53.69418379000007, 24.153631903000075],
              [53.684255405000044, 24.156724351000037],
              [53.656993035000085, 24.15839264500005],
            ],
          ],
          [
            [
              [54.19076582100007, 24.22724030200004],
              [54.18083743600005, 24.245062567000048],
              [54.15935306100005, 24.25381094000005],
              [54.13412519600007, 24.26040273600006],
              [54.11255944100009, 24.27167389500005],
              [54.101573113000086, 24.297674872000073],
              [54.101573113000086, 24.297756252000056],
              [54.115244988000086, 24.318508205000057],
              [54.13697350400008, 24.32689036700009],
              [54.14210045700008, 24.322699286000045],
              [54.150401238000086, 24.31598541900007],
              [54.17587324300007, 24.29014720300006],
              [54.18832441500007, 24.277492580000057],
              [54.19890384200005, 24.253119208000044],
              [54.19882246200007, 24.253078518000052],
              [54.19076582100007, 24.22724030200004],
            ],
          ],
          [
            [
              [52.57447350400008, 24.34393952000005],
              [52.58716881600009, 24.360500393000052],
              [52.61109459700003, 24.37323639500005],
              [52.63446116300008, 24.366599714000074],
              [52.64537473000007, 24.35071896800008],
              [52.65085483100006, 24.324899146000064],
              [52.648773634000065, 24.309515692000048],
              [52.62720787900008, 24.283596096000053],
              [52.60865319100009, 24.26825592700004],
              [52.592154254000036, 24.25336780100008],
              [52.579064850000066, 24.266259262000062],
              [52.56813929600008, 24.283127345000082],
              [52.55610432700007, 24.306946332000052],
              [52.55823936400009, 24.326812872000062],
              [52.57447350400008, 24.34393952000005],
            ],
          ],
          [
            [
              [53.32275916400005, 24.26269063700005],
              [53.308666446000075, 24.278623028000084],
              [53.29450434800003, 24.279666903000077],
              [53.276007993000064, 24.288666325000065],
              [53.26614240500004, 24.273809505000088],
              [53.228001436000056, 24.278897356000073],
              [53.213837538000064, 24.280925668000066],
              [53.19271894600007, 24.277004299000055],
              [53.18913821700005, 24.275864976000037],
              [53.186534050000034, 24.275946356000077],
              [53.18409264400003, 24.28123607000009],
              [53.184580925000034, 24.28701406500005],
              [53.18767337300005, 24.294256903000075],
              [53.19125410200007, 24.30036041900007],
              [53.194346550000034, 24.30296458500004],
              [53.23178144600007, 24.29555898600006],
              [53.24187259200005, 24.297796942000048],
              [53.267588738000086, 24.308254299000055],
              [53.27271569100009, 24.312567450000074],
              [53.278086785000085, 24.316148179000038],
              [53.31104605000007, 24.328245655000046],
              [53.32960659200006, 24.336115326000083],
              [53.33832707000005, 24.33608049500009],
              [53.34806495400005, 24.320161759000086],
              [53.357849316000056, 24.315160629000047],
              [53.36670983200008, 24.319240627000056],
              [53.36890709700003, 24.330145575000074],
              [53.36768639400003, 24.34088776200008],
              [53.36158287900008, 24.350734768000052],
              [53.399099155000044, 24.40143463700008],
              [53.416758660000085, 24.41282786700009],
              [53.41765384200005, 24.407049872000073],
              [53.42212975400008, 24.39716217700004],
              [53.42359459700003, 24.391750393000052],
              [53.44678795700008, 24.37995026200008],
              [53.44703209700003, 24.379828192000048],
              [53.440440300000034, 24.34125397300005],
              [53.42763211100004, 24.328759424000054],
              [53.38833985400004, 24.31205650000004],
              [53.36977300500007, 24.30121764000006],
              [53.345792875000086, 24.29833507300009],
              [53.331589241000074, 24.288463065000087],
              [53.33154168500005, 24.277545987000053],
              [53.32275916400005, 24.26269063700005],
            ],
          ],
          [
            [
              [54.38257897200003, 24.439520575000074],
              [54.33480879000007, 24.453192450000074],
              [54.33480879000007, 24.46893952000005],
              [54.375336134000065, 24.503607489000046],
              [54.389414910000085, 24.522691148000035],
              [54.39625084700003, 24.522691148000035],
              [54.389414910000085, 24.501572984000063],
              [54.39665774800005, 24.48346588700008],
              [54.41431725400008, 24.47060781500005],
              [54.45142662900008, 24.453192450000074],
              [54.469737175000034, 24.436468817000048],
              [54.47055097700007, 24.425034898000035],
              [54.45671634200005, 24.420803127000056],
              [54.430430535000085, 24.42523834800005],
              [54.38257897200003, 24.439520575000074],
            ],
          ],
          [
            [
              [54.266368035000085, 24.29450104400007],
              [54.25733483200008, 24.28774648600006],
              [54.24781334700003, 24.28318919500009],
              [54.239268425000034, 24.281195380000042],
              [54.22828209700003, 24.281398830000057],
              [54.22217858200008, 24.284491278000075],
              [54.205088738000086, 24.30292389500005],
              [54.192393425000034, 24.311102606000077],
              [54.18311608200008, 24.315008856000077],
              [54.17945397200003, 24.321437893000052],
              [54.184580925000034, 24.337062893000052],
              [54.19190514400003, 24.346177476000037],
              [54.203786655000044, 24.35374583500004],
              [54.21802819100009, 24.357977606000077],
              [54.232432488000086, 24.357570705000057],
              [54.241221550000034, 24.340765692000048],
              [54.25114993600005, 24.326564846000053],
              [54.273448113000086, 24.30292389500005],
              [54.266368035000085, 24.29450104400007],
            ],
          ],
          [
            [
              [54.32585696700005, 24.37303294500009],
              [54.33529707100007, 24.36399974200009],
              [54.33611087300005, 24.35032786700009],
              [54.32545006600009, 24.32127513200004],
              [54.308929884000065, 24.31386953300006],
              [54.281586134000065, 24.357489325000074],
              [54.27906334700003, 24.364447333000044],
              [54.286143425000034, 24.36554596600007],
              [54.297211134000065, 24.36286041900007],
              [54.30689537900008, 24.357245184000078],
              [54.31137129000007, 24.355292059000078],
              [54.31267337300005, 24.359849351000037],
              [54.30990644600007, 24.365179755000042],
              [54.29517662900008, 24.37523021000004],
              [54.292002800000034, 24.384507554000038],
              [54.30486087300005, 24.385931708000044],
              [54.32585696700005, 24.37303294500009],
            ],
          ],
          [
            [
              [52.30974368600005, 24.539496161000045],
              [52.33256469400004, 24.52541405800008],
              [52.33923842200005, 24.501552021000066],
              [52.32622365200007, 24.480646086000036],
              [52.314227638000034, 24.475650742000084],
              [52.29965254000007, 24.482896226000037],
              [52.29444420700008, 24.48899974200009],
              [52.28956139400003, 24.49160390800006],
              [52.283213738000086, 24.497015692000048],
              [52.28233756000009, 24.510402430000056],
              [52.291027503000066, 24.521363981000036],
              [52.29862101000003, 24.53331740100009],
              [52.30974368600005, 24.539496161000045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Georgia',
        iso3: 'GEO',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [41.551194863000035, 42.406457421000084],
            [41.50017337300005, 42.64057038000004],
            [41.482758009000065, 42.68024323100008],
            [41.457367384000065, 42.71369049700007],
            [41.42432701900009, 42.739894924000055],
            [41.383474155000044, 42.75726959800005],
            [41.307302280000044, 42.767645575000074],
            [41.291026238000086, 42.77435944200005],
            [41.27491295700008, 42.78530508000006],
            [41.250743035000085, 42.79523346600007],
            [41.225352410000085, 42.80231354400007],
            [41.20533287900008, 42.80442942900004],
            [41.193695509000065, 42.80190664300005],
            [41.17359459700003, 42.79279205900008],
            [41.160899285000085, 42.79083893400008],
            [41.15023847700007, 42.79564036700003],
            [41.10474694100009, 42.846584377000056],
            [41.08179772200003, 42.90814850500004],
            [41.04029381600009, 42.96133047100005],
            [41.02312259200005, 42.98997630400004],
            [40.998383009000065, 42.989447333000044],
            [40.958994988000086, 42.97638580900008],
            [40.93376712300005, 42.98273346600007],
            [40.90398196700005, 43.01634349200003],
            [40.88656660200007, 43.02415599200003],
            [40.88624108200008, 43.029282945000034],
            [40.86280358200008, 43.05898672100005],
            [40.85596764400009, 43.06305573100008],
            [40.78305097700007, 43.08417389500005],
            [40.68287194100009, 43.09430573100008],
            [40.63624108200008, 43.09247467700004],
            [40.60401451900009, 43.08649323100008],
            [40.591807488000086, 43.085638739000046],
            [40.57992597700007, 43.08881256700005],
            [40.56072024800005, 43.10297272300005],
            [40.55054772200003, 43.10610586100006],
            [40.54607181100005, 43.10883209800005],
            [40.52898196700005, 43.122259833000044],
            [40.520192905000044, 43.12726471600007],
            [40.51026451900009, 43.12995026200008],
            [40.478526238000086, 43.134019273000035],
            [40.39828535200007, 43.16233958500004],
            [40.36117597700007, 43.16547272300005],
            [40.33513431100005, 43.14085521000004],
            [40.32504316500007, 43.14883047100005],
            [40.31031334700003, 43.17572663000004],
            [40.30103600400008, 43.188666083000044],
            [40.278330925000034, 43.205511786000045],
            [40.26840254000007, 43.21637604400007],
            [40.27279707100007, 43.24799225500004],
            [40.25717207100007, 43.277411200000074],
            [40.23519941500007, 43.30442942900004],
            [40.219086134000065, 43.31903717700004],
            [40.188243035000085, 43.32957591400009],
            [40.133474155000044, 43.34162018400008],
            [40.10132897200003, 43.36517975500004],
            [40.086924675000034, 43.370306708000044],
            [40.04078209700003, 43.37579987200007],
            [40.009776238000086, 43.38515859600005],
            [39.985976355436605, 43.38898960974838],
            [39.991284627000084, 43.40631805500006],
            [40.05918746000009, 43.53519907700009],
            [40.07283003800012, 43.551063742000096],
            [40.096704549000094, 43.56263926200005],
            [40.164297323000085, 43.57584259000002],
            [40.2331303310001, 43.575765076000025],
            [40.4798336180001, 43.50874074300002],
            [40.51962447100004, 43.50517506900003],
            [40.550837036000075, 43.51124705100007],
            [40.61553592900009, 43.53584503200007],
            [40.65191613800005, 43.53897145600011],
            [40.68106164500006, 43.52806772900006],
            [40.689965576000134, 43.523129317],
            [40.740179484000066, 43.495279033000045],
            [40.8427055250001, 43.46938914000002],
            [40.87495161900006, 43.45564320900006],
            [41.01179081300006, 43.37541554800008],
            [41.04248661300011, 43.369834494000045],
            [41.146666300000106, 43.379859721000074],
            [41.18077274600006, 43.37469207800008],
            [41.21312219300006, 43.36278066000004],
            [41.243921346000036, 43.344202982000084],
            [41.27875126100008, 43.333195903],
            [41.35027144300011, 43.34335032200006],
            [41.380657185000075, 43.334772034000125],
            [41.38975223800014, 43.324875997000035],
            [41.40380822800006, 43.301518250000086],
            [41.41310998500006, 43.291286317000115],
            [41.427579386000104, 43.283198954000014],
            [41.47977258300011, 43.27123586100008],
            [41.50612756400005, 43.25978953100007],
            [41.550569295000116, 43.22627736500006],
            [41.57754439300004, 43.21529612300007],
            [41.61413130700009, 43.21302236000004],
            [41.68740848800013, 43.220205383000106],
            [41.7237886960001, 43.21723398900009],
            [41.78890100100011, 43.20356557300009],
            [41.82032027200012, 43.20124013300004],
            [41.88998010300014, 43.2070278930001],
            [41.91933231600012, 43.205942689000025],
            [41.94827111800009, 43.20007741300013],
            [41.97969038900004, 43.18865692100003],
            [42.01131636500014, 43.18186147100009],
            [42.04335575400012, 43.18056956000002],
            [42.07529178900012, 43.1852721150001],
            [42.15433396100008, 43.217497744000056],
            [42.15983443200008, 43.21974029600007],
            [42.185362590000125, 43.22547638000013],
            [42.354551229000094, 43.236018372],
            [42.36256010000005, 43.23519446400006],
            [42.42286747300005, 43.22899037700007],
            [42.47971154800007, 43.200904236000056],
            [42.506066529000066, 43.18155141200002],
            [42.53490197800011, 43.16506663000003],
            [42.59588016700013, 43.14002939900011],
            [42.615207153000085, 43.13698049],
            [42.629366496000046, 43.14126963400007],
            [42.65623824000005, 43.159795634],
            [42.67360152200007, 43.16589345300004],
            [42.70491744000009, 43.16643605600008],
            [42.75152958100006, 43.17695221000004],
            [42.791320434000056, 43.176177063000054],
            [42.829767700000104, 43.16876149500003],
            [42.85767297300009, 43.155454814],
            [42.88578495300004, 43.13584360800009],
            [42.91482710800011, 43.121942648000086],
            [43.0000932210001, 43.09866241500008],
            [43.000196574000086, 43.08535573300007],
            [42.992548462000116, 43.06881927600007],
            [42.98975793500006, 43.052670390000074],
            [42.998852986000145, 43.04220591300013],
            [43.04825565600004, 43.016961975000086],
            [43.15558760600004, 42.942392884000114],
            [43.17522846100013, 42.93447107200005],
            [43.19434493000006, 42.926760763000075],
            [43.38617831300007, 42.8868823560001],
            [43.47959883700008, 42.867462057000054],
            [43.517425985000045, 42.860459900000066],
            [43.586258992000126, 42.835629374000106],
            [43.603002157000105, 42.824803162000066],
            [43.64434330200004, 42.788577983000025],
            [43.66284346600014, 42.779844666000045],
            [43.75596439600014, 42.763127340000025],
            [43.782525649000036, 42.7532129830001],
            [43.800612834000106, 42.74646169000009],
            [43.8117749430001, 42.71726450700005],
            [43.78872725400004, 42.693079936000075],
            [43.75379398600006, 42.67465728800006],
            [43.725682007000046, 42.65440012700007],
            [43.722581421000086, 42.624867045000045],
            [43.751106812000046, 42.598744609000036],
            [43.79616866000009, 42.58983042400003],
            [43.84500288900006, 42.587039897000054],
            [43.8853621830001, 42.579210918000044],
            [43.90816053600014, 42.566282989000015],
            [43.92081221600006, 42.55910878600007],
            [43.93972578900008, 42.55220998200009],
            [43.95843265800005, 42.55440623],
            [43.973212118000106, 42.5639922080001],
            [43.998016805000134, 42.589365336000085],
            [44.01150435400007, 42.60032074000007],
            [44.05506758600012, 42.615306905000054],
            [44.15082401600006, 42.61866587400006],
            [44.185803459000056, 42.62650810100003],
            [44.197384481000086, 42.6291045120001],
            [44.21135073000005, 42.63963427100002],
            [44.2301473390001, 42.653805848],
            [44.24864750100011, 42.681995342000064],
            [44.272005249000074, 42.70238169400001],
            [44.36068200700004, 42.703751119000074],
            [44.401403035000044, 42.71351796500004],
            [44.47922774300008, 42.7442912800001],
            [44.50811486800012, 42.7502857460001],
            [44.55829268400004, 42.75310211300008],
            [44.60097741700014, 42.74912302700001],
            [44.638758823000046, 42.740148766000075],
            [44.6424219160001, 42.73927866700002],
            [44.679422242000044, 42.723672384000096],
            [44.69502852400012, 42.71421559700012],
            [44.72448409000003, 42.691038717000126],
            [44.736369670000045, 42.67755116800005],
            [44.761071004000144, 42.6192343150001],
            [44.77347334800004, 42.60964833700011],
            [44.78231001700004, 42.61665049300011],
            [44.79848474100004, 42.671737569000086],
            [44.827423543000066, 42.71796213800003],
            [44.833676392000086, 42.734085185000126],
            [44.859359579000056, 42.759509990000126],
            [44.90297448700011, 42.753076274000065],
            [45.01211511300005, 42.69530202300008],
            [45.02978845200005, 42.68876495400009],
            [45.04808190900013, 42.68589691200013],
            [45.066995483000085, 42.68845489500002],
            [45.07601819100012, 42.691411917],
            [45.103892456000096, 42.700547180000015],
            [45.12296106000008, 42.70227834100008],
            [45.15536218200009, 42.69326080400002],
            [45.18419763200012, 42.67483815600012],
            [45.28269291200007, 42.586393941],
            [45.29364831500004, 42.572906393000025],
            [45.30157131900006, 42.55984209600008],
            [45.3125618900001, 42.54171966500006],
            [45.322690470000055, 42.53011830700011],
            [45.35597009300011, 42.51996388800005],
            [45.398551473000055, 42.524382223000046],
            [45.47927006000009, 42.54233978300003],
            [45.53683760600012, 42.541357931000064],
            [45.620656779000115, 42.53037668900008],
            [45.69868819200008, 42.50758738200007],
            [45.73961592600011, 42.47146555600007],
            [45.73950628500012, 42.470646785],
            [45.736411987000054, 42.44753936800005],
            [45.62138024900008, 42.22447804800005],
            [45.631405477000044, 42.201171977000016],
            [45.66158451300004, 42.18670257600009],
            [45.70178877800004, 42.1727499390001],
            [45.81160119600008, 42.115492452000055],
            [45.881364380000036, 42.10203074200008],
            [45.89516198700011, 42.09187632300002],
            [45.923480672000096, 42.039631450000044],
            [45.9341260170001, 42.0284951790001],
            [45.94756188900004, 42.02291412400008],
            [45.966372111000055, 42.02206146300007],
            [45.973503459000085, 42.02415435800013],
            [45.98673262600005, 42.03190582300003],
            [45.99515588400004, 42.03345611600007],
            [46.0016154380001, 42.03097564800008],
            [46.018358602000035, 42.02004608200009],
            [46.026730184000144, 42.01679046700012],
            [46.04481693500014, 42.01772064200007],
            [46.05845951300006, 42.02033030200009],
            [46.06827803500005, 42.015317688000025],
            [46.07499597200007, 41.993484395000095],
            [46.09918054200011, 41.9850611370001],
            [46.129876343000035, 41.98449269700005],
            [46.1885807700001, 41.993536072000026],
            [46.18889082800007, 41.99363942500004],
            [46.189200887000084, 41.99376861600008],
            [46.197675822000065, 41.995499776000045],
            [46.2061507570001, 41.996094055000086],
            [46.214574015000096, 41.995499776000045],
            [46.224340861000144, 41.993484395000095],
            [46.250489136000056, 41.977723084],
            [46.294155721000095, 41.93862986300009],
            [46.322629435000124, 41.92901804700007],
            [46.38205733300009, 41.925245667000056],
            [46.40655196100005, 41.915039571000065],
            [46.43089156100007, 41.890441590000094],
            [46.39275435400009, 41.831685486000126],
            [46.37130863500005, 41.805692241000074],
            [46.3283138430001, 41.7664181520001],
            [46.31374108900013, 41.75665130600005],
            [46.29777307100005, 41.75081187000005],
            [46.27694747000004, 41.74931325300004],
            [46.23012862200011, 41.75732310000002],
            [46.208321167000065, 41.755514425000044],
            [46.188994182000044, 41.74014068600006],
            [46.179537394000135, 41.705879212000056],
            [46.18000248200008, 41.65515879300007],
            [46.19276656100004, 41.61017445900005],
            [46.21968998200009, 41.593302104000074],
            [46.22847497500004, 41.59872812900004],
            [46.23343591300011, 41.60795237300003],
            [46.240050497000084, 41.6154971320001],
            [46.25389978000004, 41.615910543],
            [46.2561735430001, 41.610329489],
            [46.2783944090001, 41.578393453],
            [46.27987105800008, 41.57117159000005],
            [46.28785119600008, 41.53214304600006],
            [46.29673954200007, 41.51038726800003],
            [46.31394779400006, 41.493747457000026],
            [46.3662443450001, 41.46656565400012],
            [46.377923218000035, 41.462483216000024],
            [46.398283732000095, 41.458710836000094],
            [46.44510258000008, 41.42594797800008],
            [46.542460978000065, 41.394993795000076],
            [46.591553589000114, 41.372927959],
            [46.6073665780001, 41.3450226850001],
            [46.62286950700013, 41.349621887000055],
            [46.62984053200012, 41.34613637500006],
            [46.63103438300004, 41.34553944900004],
            [46.63775232000006, 41.336961162000094],
            [46.65707930500008, 41.320631409000086],
            [46.68849857600014, 41.284354553000114],
            [46.69480310100005, 41.26978179900006],
            [46.6917025140001, 41.26854156500012],
            [46.68343428600008, 41.26947174100006],
            [46.67464929200008, 41.26166860000005],
            [46.672685588000036, 41.253968811000064],
            [46.671600382000065, 41.23645050100002],
            [46.66948164900009, 41.22988759400003],
            [46.66359053500008, 41.2235313930001],
            [46.65036136900005, 41.214177958000064],
            [46.6444702550001, 41.20797678600006],
            [46.63475508600004, 41.18105336500004],
            [46.62948409000012, 41.14674021400002],
            [46.621112508000124, 41.1145974730001],
            [46.615538650000076, 41.10866593400003],
            [46.6017855230001, 41.0940302530001],
            [46.58214847900007, 41.09165313700005],
            [46.56313155100008, 41.09558054600002],
            [46.543546183000046, 41.097027487000034],
            [46.52241052200009, 41.087002258],
            [46.51114506000005, 41.07098256500005],
            [46.50556400500005, 41.05527292900008],
            [46.49677901200005, 41.044834290000054],
            [46.47491988100012, 41.04411082000006],
            [46.45698815900005, 41.05243072500009],
            [46.42903120900013, 41.08095611600005],
            [46.412649780000095, 41.09185984300002],
            [46.35311853100012, 41.106535950000094],
            [46.33234460400007, 41.115889384000056],
            [46.27343347200008, 41.15630035400004],
            [46.244391317000066, 41.18374054000007],
            [46.22857832800008, 41.19541941300007],
            [46.21059493000007, 41.20017364500005],
            [46.13540572100004, 41.19991526300008],
            [46.1131331790001, 41.19603953100004],
            [46.08760799100014, 41.18365905100008],
            [46.06135339400004, 41.17092478500008],
            [46.04161299600008, 41.16544708300002],
            [46.017428426000095, 41.16379343700005],
            [45.969162638000114, 41.168289286000075],
            [45.82074792500009, 41.20880361000009],
            [45.77033685200013, 41.2321019030001],
            [45.751088094000124, 41.24099802700003],
            [45.70974694800009, 41.2677147430001],
            [45.685872436000125, 41.29624013300004],
            [45.708093303000055, 41.317117412000115],
            [45.73103763900008, 41.323266907000075],
            [45.74530033400009, 41.329158020000094],
            [45.74406010000013, 41.33535919200007],
            [45.7207023520001, 41.342387187000085],
            [45.65559004700009, 41.352360739000105],
            [45.51182621300012, 41.394580383000076],
            [45.47927006000009, 41.417679749000044],
            [45.46480065900005, 41.43018544500005],
            [45.45002120000004, 41.432200827000074],
            [45.41694828300007, 41.42460439100002],
            [45.39679447500009, 41.423260804000066],
            [45.38123986800014, 41.4255862430001],
            [45.33309559700007, 41.444352456],
            [45.3144222410001, 41.45163116500008],
            [45.28171106000008, 41.452923075000015],
            [45.24961999600009, 41.44449981700002],
            [45.097833500000036, 41.3499188090001],
            [45.0023999440001, 41.290452373000065],
            [44.98999759900005, 41.28445790700006],
            [44.9673633220001, 41.26900665300006],
            [44.95516768400006, 41.26270212800004],
            [44.917237183000054, 41.261771952000075],
            [44.820705607000036, 41.27334747400003],
            [44.80127526900009, 41.2585163370001],
            [44.80954349800004, 41.24440867200006],
            [44.84706058800003, 41.23076609400006],
            [44.85382048600013, 41.22351397000007],
            [44.85770593300009, 41.21934560200005],
            [44.847784057000126, 41.208906962000114],
            [44.82153243000005, 41.2062197880001],
            [44.67492639100004, 41.2084935510001],
            [44.633120158000054, 41.22105092400001],
            [44.6128629960001, 41.22311798100007],
            [44.59136560100012, 41.21577992800009],
            [44.578446493000115, 41.20280914400006],
            [44.566250855000135, 41.18694447900005],
            [44.55152307100013, 41.177022604000044],
            [44.531007528000146, 41.18146677700007],
            [44.52552982600014, 41.18906321200002],
            [44.52191247600007, 41.19929514600001],
            [44.51664148000003, 41.20683990500005],
            [44.5058927820001, 41.20658152300008],
            [44.499381551000056, 41.20280914400006],
            [44.47922774300008, 41.18580759700005],
            [44.45493982000005, 41.180484924],
            [44.432460571000036, 41.18167348300001],
            [44.41060144100004, 41.18771962500007],
            [44.35727136300005, 41.212162578000104],
            [44.3449206950001, 41.213247782000096],
            [44.333086792000074, 41.21035390200011],
            [44.32492191600005, 41.20482452400002],
            [44.31773889100009, 41.1985716760001],
            [44.308488810000085, 41.19381744400003],
            [44.28497603400007, 41.190871887000114],
            [44.26647587100007, 41.19619456000005],
            [44.218106731000034, 41.221567688000064],
            [44.19097660400007, 41.230042623000074],
            [44.18033125800014, 41.22993927000003],
            [44.168445679000115, 41.2235830690001],
            [44.16586185700004, 41.21614166300007],
            [44.16519006400006, 41.20766672800009],
            [44.16007409700006, 41.197899882000044],
            [44.144364461000066, 41.18606597900002],
            [44.124727417000145, 41.17805613200004],
            [44.103643432000126, 41.17516225200005],
            [44.0612687580001, 41.184153951],
            [44.041321655000104, 41.18255198200005],
            [44.00111739100004, 41.16885772700003],
            [43.978186390000076, 41.16461706200009],
            [43.97775529000012, 41.16453733800007],
            [43.955848837000076, 41.160486145000064],
            [43.863244670000086, 41.158987528000054],
            [43.82035323100007, 41.14549998000008],
            [43.773741089000055, 41.11449412100008],
            [43.754155721000075, 41.10824127200006],
            [43.729712769000116, 41.10669097900005],
            [43.566621948000034, 41.12405426100007],
            [43.524143921000075, 41.12281402600003],
            [43.47014204900012, 41.10617421500011],
            [43.46032352700013, 41.10452056900006],
            [43.45045332800004, 41.10467559900009],
            [43.44042810000013, 41.10658762600012],
            [43.451796916000035, 41.13258087200008],
            [43.43758589700013, 41.15619700100008],
            [43.41055912200011, 41.17516225200005],
            [43.38327396700009, 41.18720286100002],
            [43.351751343000046, 41.19361073800006],
            [43.322605835000104, 41.19206044600004],
            [43.23062178500004, 41.172630107000074],
            [43.2162040610001, 41.1805366010001],
            [43.19222619600009, 41.224978333000095],
            [43.17202071200006, 41.24234161400001],
            [43.15233199100004, 41.2441502890001],
            [43.13031783000008, 41.2422899380001],
            [43.10313602700006, 41.24880116800007],
            [43.15724125100007, 41.26973012300006],
            [43.171865682000146, 41.279341940000066],
            [43.185353231000136, 41.293811341],
            [43.18400964400007, 41.2989789840001],
            [43.154760783000086, 41.30187286400009],
            [43.12390995300012, 41.31293162100009],
            [43.075644165000085, 41.34486765600006],
            [43.00205692500003, 41.38269480500004],
            [42.987587524000105, 41.394683736],
            [42.95771854600008, 41.43700673400009],
            [42.94996708200006, 41.44367299400001],
            [42.941078736000065, 41.44630849300002],
            [42.93622115100004, 41.450235901],
            [42.93219038900014, 41.45478342700004],
            [42.926092570000094, 41.459072571],
            [42.89663700400007, 41.46656565400012],
            [42.88898889100011, 41.46997629800005],
            [42.880720662000044, 41.48124176100002],
            [42.87513960800004, 41.493695781],
            [42.86800826000007, 41.50020701100006],
            [42.85457238800012, 41.49379913400013],
            [42.829974406000076, 41.47250844400004],
            [42.81116418500005, 41.477159323000095],
            [42.79214725700007, 41.492868958000074],
            [42.766515747000085, 41.504341125000096],
            [42.77488732900008, 41.51426300100009],
            [42.794627726000044, 41.52682037400008],
            [42.80268925000013, 41.53410675100007],
            [42.80682336400008, 41.54299509700009],
            [42.80889042200005, 41.55291697200009],
            [42.812197714000035, 41.56299387700004],
            [42.819949178000115, 41.57234731100006],
            [42.80093225100006, 41.579220276000044],
            [42.660992472000146, 41.588263652000094],
            [42.610556274000146, 41.58505971300012],
            [42.59091354100008, 41.58016907300002],
            [42.586647575000086, 41.579106935000084],
            [42.585234822000075, 41.57875518800002],
            [42.565184367000086, 41.56712799100005],
            [42.55495243300004, 41.55033315100009],
            [42.54554732300005, 41.50961212200012],
            [42.53552209500003, 41.493489075000056],
            [42.513817993000146, 41.47622914700004],
            [42.48384566200008, 41.442174377000086],
            [42.463071737000064, 41.43183909200009],
            [42.451032576000046, 41.43137035400012],
            [42.437853638000036, 41.43085723900002],
            [42.26246382700003, 41.482326966000116],
            [42.21326786300011, 41.48020823200004],
            [42.18928999800005, 41.48170684900005],
            [42.172650187000045, 41.493489075000056],
            [42.1583874910001, 41.49989695300009],
            [42.143194621000134, 41.50025868800007],
            [42.11177535000013, 41.493489075000056],
            [42.09751265500006, 41.49834665900006],
            [42.08345666500014, 41.50010365800004],
            [42.0694006760001, 41.49860504200002],
            [42.05493127500006, 41.493489075000056],
            [42.019584594000094, 41.48506581700006],
            [41.947961060000125, 41.50558136000002],
            [41.90775679600006, 41.493489075000056],
            [41.89401086400005, 41.48553090500009],
            [41.86269494600003, 41.45178619400009],
            [41.822594035000066, 41.42599965400011],
            [41.812982218000116, 41.421813863000054],
            [41.800786581000125, 41.425689596000026],
            [41.760995728000125, 41.45354319300007],
            [41.747766561000105, 41.45685048500009],
            [41.71851770100005, 41.45958933500013],
            [41.70683882700007, 41.463155009],
            [41.70260135900014, 41.46945953400011],
            [41.70280806500011, 41.477624411000036],
            [41.70394494700008, 41.48511749300006],
            [41.70260135900014, 41.48904490200003],
            [41.69495324700006, 41.48909657800006],
            [41.66983850100013, 41.48046661400009],
            [41.63996952400004, 41.47870961500003],
            [41.62725712100007, 41.48051829000012],
            [41.52076256600009, 41.51422760700008],
            [41.586273634000065, 41.602728583000044],
            [41.61573326900009, 41.63263580900008],
            [41.67603600400008, 41.662176825000074],
            [41.69288170700008, 41.692287502000056],
            [41.73975670700008, 41.74990469000005],
            [41.74236087300005, 41.76166413000004],
            [41.74244225400008, 41.770697333000044],
            [41.74390709700003, 41.778631903000075],
            [41.750010613000086, 41.78750234600005],
            [41.766286655000044, 41.80418528900009],
            [41.771820509000065, 41.812567450000074],
            [41.77393639400009, 41.821600653000075],
            [41.77393639400009, 41.90261465100008],
            [41.77393639400009, 41.90692780200004],
            [41.76197350400008, 41.96987539300005],
            [41.76026451900009, 41.99258047100005],
            [41.75570722700007, 42.00641510600008],
            [41.71526126400005, 42.05935293200008],
            [41.68490644600007, 42.098944403000075],
            [41.67432701900009, 42.105536200000074],
            [41.664073113000086, 42.11395905200004],
            [41.659190300000034, 42.13300202000005],
            [41.657237175000034, 42.16705963700008],
            [41.649180535000085, 42.212225653000075],
            [41.59620201900009, 42.34943268400008],
            [41.59229576900009, 42.35541413000004],
            [41.58521569100009, 42.36286041900007],
            [41.55836022200003, 42.382798570000034],
            [41.55486087300005, 42.389837958000044],
            [41.551194863000035, 42.406457421000084],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Azerbaijan',
        iso3: 'AZE',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [44.97945560700009, 41.08204132100006],
              [45.01888472500008, 41.074909973],
              [45.02999515800013, 41.04628123000005],
              [45.01573246300006, 41.02323354100007],
              [44.97945560700009, 41.03263865200002],
              [44.966949910000096, 41.044834290000054],
              [44.960697062000065, 41.05992380800005],
              [44.963952678000055, 41.07377309200011],
              [44.97945560700009, 41.08204132100006],
            ],
          ],
          [
            [
              [45.0023999440001, 41.290452373000065],
              [45.097833500000036, 41.3499188090001],
              [45.24961999600009, 41.44449981700002],
              [45.28171106000008, 41.452923075000015],
              [45.3144222410001, 41.45163116500008],
              [45.33309559700007, 41.444352456],
              [45.38123986800014, 41.4255862430001],
              [45.39679447500009, 41.423260804000066],
              [45.41694828300007, 41.42460439100002],
              [45.45002120000004, 41.432200827000074],
              [45.46480065900005, 41.43018544500005],
              [45.47927006000009, 41.417679749000044],
              [45.51182621300012, 41.394580383000076],
              [45.65559004700009, 41.352360739000105],
              [45.7207023520001, 41.342387187000085],
              [45.74406010000013, 41.33535919200007],
              [45.74530033400009, 41.329158020000094],
              [45.73103763900008, 41.323266907000075],
              [45.708093303000055, 41.317117412000115],
              [45.685872436000125, 41.29624013300004],
              [45.70974694800009, 41.2677147430001],
              [45.751088094000124, 41.24099802700003],
              [45.77033685200013, 41.2321019030001],
              [45.82074792500009, 41.20880361000009],
              [45.969162638000114, 41.168289286000075],
              [46.017428426000095, 41.16379343700005],
              [46.04161299600008, 41.16544708300002],
              [46.06135339400004, 41.17092478500008],
              [46.08760799100014, 41.18365905100008],
              [46.1131331790001, 41.19603953100004],
              [46.13540572100004, 41.19991526300008],
              [46.21059493000007, 41.20017364500005],
              [46.22857832800008, 41.19541941300007],
              [46.244391317000066, 41.18374054000007],
              [46.27343347200008, 41.15630035400004],
              [46.33234460400007, 41.115889384000056],
              [46.35311853100012, 41.106535950000094],
              [46.412649780000095, 41.09185984300002],
              [46.42903120900013, 41.08095611600005],
              [46.45698815900005, 41.05243072500009],
              [46.47491988100012, 41.04411082000006],
              [46.49677901200005, 41.044834290000054],
              [46.50556400500005, 41.05527292900008],
              [46.51114506000005, 41.07098256500005],
              [46.52241052200009, 41.087002258],
              [46.543546183000046, 41.097027487000034],
              [46.56313155100008, 41.09558054600002],
              [46.58214847900007, 41.09165313700005],
              [46.6017855230001, 41.0940302530001],
              [46.615538650000076, 41.10866593400003],
              [46.621112508000124, 41.1145974730001],
              [46.62948409000012, 41.14674021400002],
              [46.63475508600004, 41.18105336500004],
              [46.6444702550001, 41.20797678600006],
              [46.65036136900005, 41.214177958000064],
              [46.66359053500008, 41.2235313930001],
              [46.66948164900009, 41.22988759400003],
              [46.671600382000065, 41.23645050100002],
              [46.672685588000036, 41.253968811000064],
              [46.67464929200008, 41.26166860000005],
              [46.68343428600008, 41.26947174100006],
              [46.6917025140001, 41.26854156500012],
              [46.69480310100005, 41.26978179900006],
              [46.68849857600014, 41.284354553000114],
              [46.65707930500008, 41.320631409000086],
              [46.63775232000006, 41.336961162000094],
              [46.63103438300004, 41.34553944900004],
              [46.62984053200012, 41.34613637500006],
              [46.62286950700013, 41.349621887000055],
              [46.6073665780001, 41.3450226850001],
              [46.591553589000114, 41.372927959],
              [46.542460978000065, 41.394993795000076],
              [46.44510258000008, 41.42594797800008],
              [46.398283732000095, 41.458710836000094],
              [46.377923218000035, 41.462483216000024],
              [46.3662443450001, 41.46656565400012],
              [46.31394779400006, 41.493747457000026],
              [46.29673954200007, 41.51038726800003],
              [46.28785119600008, 41.53214304600006],
              [46.27987105800008, 41.57117159000005],
              [46.2783944090001, 41.578393453],
              [46.2561735430001, 41.610329489],
              [46.25389978000004, 41.615910543],
              [46.240050497000084, 41.6154971320001],
              [46.23343591300011, 41.60795237300003],
              [46.22847497500004, 41.59872812900004],
              [46.21968998200009, 41.593302104000074],
              [46.19276656100004, 41.61017445900005],
              [46.18000248200008, 41.65515879300007],
              [46.179537394000135, 41.705879212000056],
              [46.188994182000044, 41.74014068600006],
              [46.208321167000065, 41.755514425000044],
              [46.23012862200011, 41.75732310000002],
              [46.27694747000004, 41.74931325300004],
              [46.29777307100005, 41.75081187000005],
              [46.31374108900013, 41.75665130600005],
              [46.3283138430001, 41.7664181520001],
              [46.37130863500005, 41.805692241000074],
              [46.39275435400009, 41.831685486000126],
              [46.43089156100007, 41.890441590000094],
              [46.45233728000005, 41.88617828400005],
              [46.47931237800009, 41.887005107000064],
              [46.525511109000036, 41.88230255200007],
              [46.543546183000046, 41.874292705000116],
              [46.549127238000096, 41.85537913000006],
              [46.54432133000006, 41.81476145400005],
              [46.549850708000065, 41.79775990900002],
              [46.5675757250001, 41.78667531400002],
              [46.586592651000046, 41.786778667000036],
              [46.603955933000066, 41.795176087000115],
              [46.636512085000106, 41.816518453000114],
              [46.65707930500008, 41.82199615500009],
              [46.697490275000064, 41.8282231650001],
              [46.70955494600008, 41.83506555700011],
              [46.71557702600012, 41.838480937000085],
              [46.732423543000095, 41.85140004500009],
              [46.740795125000034, 41.85124501600005],
              [46.745032593000076, 41.84013458300002],
              [46.754024292000054, 41.800886332000076],
              [46.759398641000075, 41.78729543100006],
              [46.76911381100007, 41.77571991000012],
              [46.83479455600008, 41.730244650000074],
              [46.85189945400003, 41.72233815500003],
              [46.86450850400007, 41.7196768190001],
              [46.890553426000054, 41.71709299700008],
              [46.90223230000004, 41.7127521770001],
              [46.90688317900009, 41.70693857800005],
              [46.91225752700012, 41.68861928300005],
              [46.915978230000064, 41.68094533300008],
              [46.92951745600004, 41.667225240000036],
              [46.97923018400013, 41.63549591100012],
              [47.00393151800006, 41.60542022700007],
              [47.012613160000114, 41.575499573000016],
              [47.02703088400011, 41.556947734000076],
              [47.02826236300007, 41.557074659000094],
              [47.06914717700005, 41.561288555000075],
              [47.08826745600004, 41.56697296100002],
              [47.107491089000064, 41.56991851800011],
              [47.12557784000012, 41.56630116800004],
              [47.14139082800011, 41.55240020800004],
              [47.14872888100007, 41.535088603000034],
              [47.15224287900014, 41.51813873300004],
              [47.15932255100006, 41.503514303000074],
              [47.17699589000006, 41.493489075000056],
              [47.17924955000012, 41.49173237600009],
              [47.18707279400013, 41.485634257000115],
              [47.19182702600011, 41.47669423500007],
              [47.1951343180001, 41.46697906500013],
              [47.200508667000065, 41.45685048500009],
              [47.23146285000007, 41.42754994800002],
              [47.23905928500005, 41.41571604400009],
              [47.24277998800005, 41.39127309200008],
              [47.24091963700005, 41.338924866000056],
              [47.250841512000136, 41.31603220600003],
              [47.26841149900008, 41.30280304000003],
              [47.34447920800005, 41.26823150700004],
              [47.36729171000013, 41.261789438],
              [47.37558842000004, 41.25944651300004],
              [47.47914799000006, 41.251953430000114],
              [47.5009554450001, 41.246320699000094],
              [47.52917077600006, 41.216555074],
              [47.54730920500009, 41.20565134700003],
              [47.567773072000136, 41.2054963180001],
              [47.60317142700006, 41.22327301100002],
              [47.62249841300013, 41.229060771],
              [47.64254886900005, 41.2272520960001],
              [47.694888843000115, 41.207134021000044],
              [47.72455936700004, 41.19572947200005],
              [47.74373132300008, 41.19268056200009],
              [47.81349103700006, 41.19738775300003],
              [47.82873905400004, 41.19841664700006],
              [47.87111372900006, 41.20818349200003],
              [47.894626506000066, 41.21929392500003],
              [47.89886397300012, 41.229060771],
              [47.89379968200012, 41.24187652600007],
              [47.8892521570001, 41.26244374600007],
              [47.89214603700009, 41.28326934800002],
              [47.90144779500008, 41.29298451800007],
              [47.91478031400004, 41.30021921800004],
              [47.92945642100011, 41.313551738000044],
              [47.937931356000036, 41.331741842],
              [47.94268558800013, 41.34739980100004],
              [47.95322758000009, 41.35577138300003],
              [47.97916914900014, 41.35241241500002],
              [48.001648397000054, 41.36207590800005],
              [48.03456628400005, 41.43364776700007],
              [48.05353153500005, 41.461294658],
              [48.08655277500009, 41.47664255800005],
              [48.20184289500014, 41.493489075000056],
              [48.23135013800004, 41.50547800700009],
              [48.28369836400009, 41.53953277600006],
              [48.370153035000044, 41.5801504520001],
              [48.39304569500007, 41.59888315900007],
              [48.41325118000009, 41.627615255000094],
              [48.455419149000136, 41.714405823000064],
              [48.46221094500004, 41.720992372000055],
              [48.530660035000096, 41.787372946000076],
              [48.57894941500007, 41.84528229400007],
              [48.58936608200008, 41.83836497600004],
              [48.620127800000034, 41.82440827000005],
              [48.65544681100005, 41.80060455900008],
              [48.74366295700008, 41.70892975500004],
              [48.77784264400009, 41.68301015800006],
              [48.79184004000007, 41.66742584800005],
              [48.797618035000085, 41.64313385600008],
              [48.865896030000044, 41.58539459800005],
              [48.90406334700003, 41.52338288000004],
              [48.92432701900009, 41.51780833500004],
              [48.94117272200003, 41.50462474200003],
              [48.953868035000085, 41.48908112200007],
              [48.96216881600009, 41.47614166900007],
              [48.985362175000034, 41.450506903000075],
              [48.98943118600005, 41.444525458000044],
              [48.994476759000065, 41.44041575700004],
              [49.01921634200005, 41.434759833000044],
              [49.02759850400008, 41.43121979400007],
              [49.04249108200008, 41.41437409100007],
              [49.07862389400009, 41.357530015000066],
              [49.10889733200008, 41.309759833000044],
              [49.123383009000065, 41.29368724200003],
              [49.13591556100005, 41.27496979400007],
              [49.14193769600007, 41.253159898000035],
              [49.154307488000086, 41.166449286000045],
              [49.16065514400009, 41.148098049000055],
              [49.17164147200003, 41.14036692900004],
              [49.178477410000085, 41.12885163000004],
              [49.19548587300005, 41.05727773600006],
              [49.243174675000034, 40.99721914300005],
              [49.36312910200007, 40.894232489000046],
              [49.373057488000086, 40.882798570000034],
              [49.38200931100005, 40.86664459800005],
              [49.40316816500007, 40.852728583000044],
              [49.44874108200008, 40.831284898000035],
              [49.471039259000065, 40.83576080900008],
              [49.48991946700005, 40.823146877000056],
              [49.507823113000086, 40.80621979400007],
              [49.52784264400009, 40.79779694200005],
              [49.53882897200003, 40.78807200700004],
              [49.53435306100005, 40.76618073100008],
              [49.51693769600007, 40.72890859600005],
              [49.51099694100009, 40.70954010600008],
              [49.50953209700003, 40.69904205900008],
              [49.510752800000034, 40.687933661000045],
              [49.51490319100009, 40.68158600500004],
              [49.528330925000034, 40.668850002000056],
              [49.531260613000086, 40.663723049000055],
              [49.531911655000044, 40.66286855700008],
              [49.53891035200007, 40.653998114000046],
              [49.556651238000086, 40.64118073100008],
              [49.576182488000086, 40.62995026200008],
              [49.58961022200003, 40.62518952000005],
              [49.63306725400008, 40.62319570500006],
              [49.65259850400008, 40.619208075000074],
              [49.66846764400003, 40.612209377000056],
              [49.704112175000034, 40.58808014500005],
              [49.72380618600005, 40.58075592700004],
              [49.77393639400003, 40.57562897300005],
              [49.816742384000065, 40.56537506700005],
              [49.84034264400003, 40.563788153000075],
              [49.85865319100009, 40.56663646000004],
              [49.91423587300005, 40.58429596600007],
              [49.938161655000044, 40.58746979400007],
              [50.05201256600009, 40.58429596600007],
              [50.06039472700007, 40.57794830900008],
              [50.064789259000065, 40.57094961100006],
              [50.06804446700005, 40.563706773000035],
              [50.07252037900008, 40.55695221600007],
              [50.09034264400003, 40.540228583000044],
              [50.109385613000086, 40.52708567900004],
              [50.129649285000085, 40.518459377000056],
              [50.22006269600007, 40.50364817900004],
              [50.23755944100009, 40.496161200000074],
              [50.24854576900003, 40.48118724200009],
              [50.260752800000034, 40.45807526200008],
              [50.27588951900003, 40.43659088700008],
              [50.295664910000085, 40.42723216400009],
              [50.317393425000034, 40.421210028000075],
              [50.335948113000086, 40.405951239000046],
              [50.350596550000034, 40.38589101800005],
              [50.36052493600005, 40.36517975500004],
              [50.37077884200005, 40.28261953300006],
              [50.377696160000085, 40.27440013200004],
              [50.38599694100009, 40.25568268400008],
              [50.39112389400003, 40.23501211100006],
              [50.38786868600005, 40.221136786000045],
              [50.36866295700008, 40.249701239000046],
              [50.34791100400008, 40.27440013200004],
              [50.32309004000007, 40.296576239000046],
              [50.27369225400008, 40.327337958000044],
              [50.252614780000044, 40.33633047100005],
              [50.22999108200008, 40.34275950700004],
              [50.18531334700003, 40.34747955900008],
              [50.14771569100009, 40.35691966400009],
              [50.127696160000085, 40.35895416900007],
              [50.11646569100009, 40.35797760600008],
              [50.10287519600007, 40.35342031500005],
              [50.09359785200007, 40.35150788000004],
              [50.05518639400003, 40.35150788000004],
              [50.03760826900003, 40.345770575000074],
              [50.00375410200007, 40.324204820000034],
              [49.98373457100007, 40.324204820000034],
              [49.976573113000086, 40.32904694200005],
              [49.96371504000007, 40.34479401200008],
              [49.955821160000085, 40.35150788000004],
              [49.945323113000086, 40.354722398000035],
              [49.91960696700005, 40.35814036700009],
              [49.89340254000007, 40.36904531500005],
              [49.87354576900003, 40.360581773000035],
              [49.84034264400003, 40.33783600500004],
              [49.84717858200008, 40.314154364000046],
              [49.819021030000044, 40.29205963700008],
              [49.778330925000034, 40.275824286000045],
              [49.711924675000034, 40.26434967700004],
              [49.65365644600007, 40.23843008000006],
              [49.577159050000034, 40.21674225500004],
              [49.559255405000044, 40.206691799000055],
              [49.52084394600007, 40.17422109600005],
              [49.50359134200005, 40.164943752000056],
              [49.492523634000065, 40.153998114000046],
              [49.49040774800005, 40.13239166900007],
              [49.49586022200003, 40.10521067900004],
              [49.49659264400009, 40.09454987200007],
              [49.44263756600009, 40.07843659100007],
              [49.432627800000034, 40.06297435100004],
              [49.43506920700008, 40.04279205900008],
              [49.44874108200008, 40.02252838700008],
              [49.457692905000044, 40.01504140800006],
              [49.47193444100009, 40.00649648600006],
              [49.47974694100009, 39.99896881700005],
              [49.48389733200008, 39.98867422100005],
              [49.47828209700003, 39.98232656500005],
              [49.46827233200008, 39.97736237200007],
              [49.45069420700008, 39.964829820000034],
              [49.44288170700008, 39.96185944200005],
              [49.43539472700007, 39.95766836100006],
              [49.42823326900009, 39.94745514500005],
              [49.42367597700007, 39.93549225500004],
              [49.42310631600009, 39.92649974200009],
              [49.42823326900009, 39.90643952000005],
              [49.43970787900008, 39.88499583500004],
              [49.44312584700003, 39.87335846600007],
              [49.438487175000034, 39.861761786000045],
              [49.429698113000086, 39.85431549700007],
              [49.42204837300005, 39.84943268400008],
              [49.41651451900009, 39.843736070000034],
              [49.41456139400009, 39.83417389500005],
              [49.416351759000065, 39.82859935100004],
              [49.41968834700003, 39.82330963700008],
              [49.42237389400009, 39.81732819200005],
              [49.42139733200008, 39.810248114000046],
              [49.41716556100005, 39.805853583000044],
              [49.40088951900009, 39.79661692900004],
              [49.39478600400008, 39.782456773000035],
              [49.395192905000044, 39.77619049700007],
              [49.40088951900009, 39.76927317900004],
              [49.39633222700007, 39.75617096600007],
              [49.40202884200005, 39.74249909100007],
              [49.424815300000034, 39.718085028000075],
              [49.42359459700003, 39.70954010600008],
              [49.40984134200005, 39.70136139500005],
              [49.38396243600005, 39.69013092700004],
              [49.35873457100007, 39.66657135600008],
              [49.33725019600007, 39.64642975500004],
              [49.31804446700005, 39.62140534100007],
              [49.319021030000044, 39.60419342700004],
              [49.307383660000085, 39.587591864000046],
              [49.29712975400008, 39.56557851800005],
              [49.28923587300005, 39.54238515800006],
              [49.28492272200003, 39.52220286700009],
              [49.285817905000044, 39.49518463700008],
              [49.29574629000007, 39.47671133000006],
              [49.38884524800005, 39.41079336100006],
              [49.40088951900009, 39.39935944200005],
              [49.408946160000085, 39.386419989000046],
              [49.40805097700007, 39.382025458000044],
              [49.40357506600009, 39.37848541900007],
              [49.39730879000007, 39.34516022300005],
              [49.39869225400008, 39.335150458000044],
              [49.40707441500007, 39.32367584800005],
              [49.39478600400008, 39.32868073100008],
              [49.38559004000007, 39.33494700700004],
              [49.37867272200003, 39.34247467700004],
              [49.373057488000086, 39.35097890800006],
              [49.36687259200005, 39.35097890800006],
              [49.37061608200008, 39.33616771000004],
              [49.37907962300005, 39.31981028900009],
              [49.391368035000085, 39.30548737200007],
              [49.40707441500007, 39.296942450000074],
              [49.40707441500007, 39.289496161000045],
              [49.38453209700003, 39.29368724200009],
              [49.37037194100009, 39.305853583000044],
              [49.35767662900008, 39.32013580900008],
              [49.30640709700003, 39.34650299700007],
              [49.27312259200005, 39.33657461100006],
              [49.24732506600009, 39.31069570500006],
              [49.237071160000085, 39.278957424000055],
              [49.23780358200008, 39.16950104400007],
              [49.234304233000046, 39.156358140000066],
              [49.22966556100005, 39.138657945000034],
              [49.215586785000085, 39.106350002000056],
              [49.21078535200007, 39.09076569200005],
              [49.20785566500007, 39.05540599200009],
              [49.20329837300005, 39.03412506700005],
              [49.19385826900009, 39.01634349200009],
              [49.11882571700005, 38.97532786700009],
              [49.07927493600005, 38.963324286000045],
              [49.051524285000085, 38.98102448100008],
              [49.054698113000086, 38.99274323100008],
              [49.05437259200005, 39.00079987200007],
              [49.05583743600005, 39.007513739000046],
              [49.065196160000085, 39.01512278900009],
              [49.110118035000085, 39.02195872600004],
              [49.12549889400009, 39.02814362200007],
              [49.138682488000086, 39.04344310100004],
              [49.146820509000065, 39.06342194200005],
              [49.14771569100009, 39.08344147300005],
              [49.13640384200005, 39.10228099200009],
              [49.11638431100005, 39.11029694200005],
              [49.06861412900008, 39.111395575000074],
              [49.06861412900008, 39.120306708000044],
              [49.06275475400008, 39.161322333000044],
              [49.058929884000065, 39.17279694200005],
              [49.04118899800005, 39.18439362200007],
              [49.022227410000085, 39.18821849200009],
              [48.979502800000034, 39.18707916900007],
              [48.96762129000007, 39.18382396000004],
              [48.96176191500007, 39.175848700000074],
              [48.95785566500007, 39.165676174000055],
              [48.949554884000065, 39.151271877000056],
              [48.94874108200008, 39.146185614000046],
              [48.94906660200007, 39.13532135600008],
              [48.94695071700005, 39.12750885600008],
              [48.942149285000085, 39.12539297100005],
              [48.93726647200003, 39.125433661000045],
              [48.93482506600009, 39.12441640800006],
              [48.93295332100007, 39.07770416900007],
              [48.93637129000007, 39.05312734600005],
              [48.95264733200008, 39.03164297100005],
              [48.94857832100007, 39.00722890800006],
              [48.92172285200007, 38.93545156500005],
              [48.91822350400008, 38.928941148000035],
              [48.89869225400008, 38.89305247600004],
              [48.89625084700003, 38.890733140000066],
              [48.867930535000085, 38.86383698100008],
              [48.83179772200003, 38.871161200000074],
              [48.83253014400009, 38.835638739000046],
              [48.834727410000085, 38.81928131700005],
              [48.83920332100007, 38.80353424700007],
              [48.86312910200007, 38.75665924700007],
              [48.86850019600007, 38.60248444200005],
              [48.87427819100009, 38.43423086100006],
              [48.87427819100009, 38.43406810100004],
              [48.8097127690001, 38.44463124600004],
              [48.77772505700011, 38.4448121140001],
              [48.75534916200013, 38.435226136],
              [48.73560876500005, 38.41956817600003],
              [48.710287313000094, 38.40711415600005],
              [48.68320886200013, 38.398019104000085],
              [48.65912764500007, 38.392644755000035],
              [48.61296215100003, 38.39564644300005],
              [48.60786462400006, 38.39597788500002],
              [48.57592858900006, 38.42036916100007],
              [48.54864343200006, 38.45625844400011],
              [48.53564125500009, 38.46915404600013],
              [48.5108162840001, 38.49377553400011],
              [48.49593347200005, 38.510311991],
              [48.47908695500007, 38.52475555500011],
              [48.462653849000105, 38.544935201],
              [48.44663415500014, 38.55640737000003],
              [48.433715047000135, 38.5699724330001],
              [48.426738729000135, 38.596456604000096],
              [48.415266561000124, 38.61810903000007],
              [48.391753784000116, 38.61810903000007],
              [48.34105920400003, 38.599583029000044],
              [48.31031172700011, 38.600151470000085],
              [48.29222497600006, 38.61356150300004],
              [48.27651534000012, 38.6317774460001],
              [48.22804284700004, 38.662189026000064],
              [48.226182495000046, 38.67908721900004],
              [48.230316609000056, 38.69862091100005],
              [48.22563499700004, 38.713193254000075],
              [48.222978556000044, 38.72146189400006],
              [48.21036950700005, 38.72975596100012],
              [48.07797448700006, 38.780941467000034],
              [48.012965535000035, 38.82155914300007],
              [47.99312178600013, 38.85008453400012],
              [47.99074467000008, 38.8912189740001],
              [48.000046428000076, 38.902587789000066],
              [48.05244633000012, 38.92790924100005],
              [48.05534021000011, 38.93436879500011],
              [48.05513350400008, 38.94191355400007],
              [48.05854414900011, 38.94837310800001],
              [48.24318404200005, 38.973875428000056],
              [48.28437015800006, 38.99379669200006],
              [48.284473510000055, 38.99400339800012],
              [48.28462854000014, 38.99400339800012],
              [48.29367191600005, 39.00459706700009],
              [48.301423380000074, 39.017464498],
              [48.30159039500006, 39.01794599900005],
              [48.3062809650001, 39.031468811000096],
              [48.30679773000014, 39.045395610000085],
              [48.30147505700012, 39.05803049700002],
              [48.27129602100007, 39.10831166600006],
              [48.2562581790001, 39.119783834000074],
              [48.19910404500007, 39.1382323210001],
              [48.14215661600008, 39.18120127400009],
              [48.11776534000006, 39.208047180000065],
              [48.10432946800012, 39.23484141100006],
              [48.106189820000054, 39.26918040000008],
              [48.124586629000135, 39.29760243800011],
              [48.153525432000094, 39.31904815700004],
              [48.18721846500006, 39.33258738200003],
              [48.249850301000095, 39.342354228000076],
              [48.30245690900006, 39.36989776600005],
              [48.328405484000086, 39.37632977800003],
              [48.33894047100006, 39.3789411420001],
              [48.31671960400013, 39.41516632100006],
              [48.2886076260001, 39.445035299000054],
              [48.220084676000056, 39.49402455700006],
              [48.05203291900011, 39.65008738300007],
              [47.99074467000008, 39.69427073200008],
              [47.97141768400013, 39.704554342000066],
              [47.9577081540001, 39.707256220000076],
              [47.957258341000056, 39.70734486900004],
              [47.945682820000115, 39.693960674],
              [47.935244182000076, 39.686519267000065],
              [47.92294519100005, 39.684142151000046],
              [47.84687748200008, 39.685279032000054],
              [47.82310632300005, 39.68031809500009],
              [47.80377933800008, 39.66993113200006],
              [47.78821212300005, 39.65765063500005],
              [47.74528161600006, 39.62378407800013],
              [47.62498028300013, 39.571410740000076],
              [47.606995484000095, 39.56358103500007],
              [47.55407881700012, 39.52198150700006],
              [47.54115970900011, 39.515160217000115],
              [47.51873213700014, 39.513196514000086],
              [47.448762247000104, 39.49469635000007],
              [47.40690433800006, 39.47681630400008],
              [47.37424483300009, 39.45557729100004],
              [47.32453210400007, 39.40596791600005],
              [47.32441724900008, 39.40587667600006],
              [47.29135583500005, 39.37961293500008],
              [47.261319552000145, 39.36638355600006],
              [47.24970463000011, 39.3612678030001],
              [47.150072469000065, 39.331140442000034],
              [47.10222009300014, 39.30840281200004],
              [47.09250492400008, 39.2998245240001],
              [47.08909427900011, 39.28985097200008],
              [47.052920776000065, 39.244944153000105],
              [47.03607425900009, 39.2070136520001],
              [47.030906616000095, 39.19959808400007],
              [47.02046797700012, 39.18996042900007],
              [47.01362785800012, 39.186956287],
              [46.95375370300013, 39.16065989200008],
              [46.941609741000036, 39.158902894000036],
              [46.926623576000054, 39.16205515600008],
              [46.89871830200008, 39.17174448700011],
              [46.88300866700007, 39.17140859000001],
              [46.86639147700009, 39.165444753000045],
              [46.86616215000004, 39.16536244800007],
              [46.85096927900008, 39.15549224900009],
              [46.837378378000096, 39.143244934000066],
              [46.81169519000014, 39.108518372000034],
              [46.80601078300009, 39.102394715000074],
              [46.798052613000095, 39.097382101],
              [46.78151615400009, 39.090379944000105],
              [46.77376469000012, 39.08536733000004],
              [46.76162072800008, 39.07058787100003],
              [46.74482588800004, 39.04025380400007],
              [46.72839278200007, 39.02795481400004],
              [46.670411825000144, 39.00490712500009],
              [46.65217004400006, 38.99294403100002],
              [46.63883752400005, 38.97948232000006],
              [46.610673869000095, 38.93400706000001],
              [46.599201701000084, 38.91969268800004],
              [46.58535241700014, 38.90770375600006],
              [46.56984948700011, 38.89773020400007],
              [46.55372644000005, 38.8898237100001],
              [46.53207401600014, 38.88300242100006],
              [46.514038940000034, 38.882175599000036],
              [46.47931237800009, 38.93938140900006],
              [46.475074911000036, 38.95106028200006],
              [46.4740930590001, 38.963230083000056],
              [46.47579838000007, 38.97560658800002],
              [46.47931237800009, 38.98775055000003],
              [46.48075931800008, 38.990618591],
              [46.48148278800011, 38.99377085400006],
              [46.49460860200014, 39.02552602200008],
              [46.49750248200013, 39.053534648],
              [46.491921428000126, 39.081905009000096],
              [46.47931237800009, 39.11477122000012],
              [46.45512780700005, 39.12993825300005],
              [46.42184818600009, 39.14464019800003],
              [46.39626835100006, 39.16443227200001],
              [46.395286499000065, 39.195179749000076],
              [46.41833418800013, 39.21192291300012],
              [46.453370809000035, 39.20840891600007],
              [46.51414229300008, 39.18443105100006],
              [46.5264412840001, 39.18582631500003],
              [46.57279504400009, 39.211509501000094],
              [46.59382735200012, 39.212129619000066],
              [46.602612346000114, 39.215488587],
              [46.59914138200014, 39.22248710700005],
              [46.59785811400013, 39.2250745650001],
              [46.59114017700011, 39.23106903100002],
              [46.58452559400007, 39.235771587],
              [46.54184086100008, 39.25905181900002],
              [46.51765629100004, 39.278843893],
              [46.5079411210001, 39.29357167500011],
              [46.502670126000055, 39.30948801700005],
              [46.495280395000066, 39.32400909400009],
              [46.47931237800009, 39.33424102800005],
              [46.40737878500005, 39.35914906800012],
              [46.374615927000036, 39.37883778900009],
              [46.360869995000144, 39.41025706],
              [46.373995809000064, 39.435991924000106],
              [46.40572513800004, 39.45118479400013],
              [46.47895196100012, 39.46182942400007],
              [46.47931237800009, 39.46188181600003],
              [46.49140466300008, 39.46642934200007],
              [46.49822595200004, 39.47376739500008],
              [46.498587687000054, 39.48312083000012],
              [46.4917147220001, 39.493662821000086],
              [46.492024780000065, 39.510199280000066],
              [46.50370365400005, 39.51846750900002],
              [46.51827640800008, 39.52544382700002],
              [46.527268107000054, 39.53815623000007],
              [46.52427087400014, 39.55464101200003],
              [46.5120235600001, 39.56756012000007],
              [46.495435425000096, 39.575931702000034],
              [46.47931237800009, 39.578670553000066],
              [46.416163778000055, 39.57401967400001],
              [46.39642338100009, 39.57665517200003],
              [46.38143721500012, 39.58502675400008],
              [46.35787276200011, 39.6096764120001],
              [46.34371342000014, 39.61861643500002],
              [46.30950362200008, 39.62052846300004],
              [46.24118737800012, 39.593501689],
              [46.20646081500007, 39.58792063500009],
              [46.18423995000012, 39.59324330700004],
              [46.16956384200006, 39.604095358000066],
              [46.146102743000085, 39.63846018500003],
              [46.13168501800004, 39.65215443900003],
              [46.11447676600005, 39.65964752200007],
              [46.07654626400006, 39.66812245700008],
              [46.04512699400004, 39.68755279600005],
              [46.006576375000066, 39.74791086800006],
              [45.97923954300012, 39.76847808800004],
              [45.916142619000084, 39.78315419500002],
              [45.88318764400009, 39.79614787100009],
              [45.86188236500004, 39.80454823800004],
              [45.81682051600012, 39.839171448000045],
              [45.80917744400011, 39.851261672000035],
              [45.764420613000084, 39.92206044600006],
              [45.74276818900006, 39.94050893100008],
              [45.71543135600007, 39.9508958950001],
              [45.61114831500004, 39.959164123000065],
              [45.57941898600012, 39.97017120400004],
              [45.577583441000115, 39.98398292600011],
              [45.57626672400005, 39.993890686],
              [45.639570353000124, 40.02541331000005],
              [45.803901408000115, 40.00448435500006],
              [45.873767944000065, 40.009755351000095],
              [45.88720381700011, 40.01843699200005],
              [45.89402510600007, 40.02908233700005],
              [45.9058073330001, 40.07507436100006],
              [45.9095280360001, 40.082670797],
              [45.93169722500011, 40.09755360900006],
              [45.9507658280001, 40.11719065400008],
              [45.96296146600008, 40.14168528300006],
              [45.98109989500006, 40.2059707640001],
              [45.98177168800004, 40.21191355500012],
              [45.98109989500006, 40.21780466700004],
              [45.97923954300012, 40.22359242800009],
              [45.953556356000036, 40.249585673000055],
              [45.93919030700005, 40.26028269500007],
              [45.924617553000076, 40.26617380800006],
              [45.902706746000035, 40.2651402800001],
              [45.88850421200004, 40.26195695300005],
              [45.88172611500005, 40.26043772400003],
              [45.86167565900007, 40.26126454700004],
              [45.81915164500009, 40.297141013],
              [45.818370809000044, 40.297799785000066],
              [45.585413452000125, 40.39872385700009],
              [45.52619226100012, 40.441046855000096],
              [45.49384281400006, 40.493653463000086],
              [45.48541955600007, 40.505280660000054],
              [45.46469730600012, 40.51571930000007],
              [45.455447225000114, 40.52362579400004],
              [45.45084802200006, 40.534374492000055],
              [45.44857426000004, 40.55649200400005],
              [45.44464685000008, 40.566362203000025],
              [45.427231893000055, 40.58295033800003],
              [45.407026408000036, 40.59509430000004],
              [45.387802775000125, 40.60951202400007],
              [45.373540080000055, 40.63271474200006],
              [45.37358518600007, 40.651298383000054],
              [45.37364343200011, 40.675296122000034],
              [45.39880985500014, 40.708937480000074],
              [45.43792891500004, 40.73338043300002],
              [45.47833511100009, 40.74818305300009],
              [45.555854533000115, 40.77658193000006],
              [45.582209513000066, 40.799371237000045],
              [45.600968058000035, 40.84055735300005],
              [45.59915938300014, 40.862674866000035],
              [45.581796102000055, 40.869651184000034],
              [45.55823164800006, 40.87094309600009],
              [45.5378711350001, 40.875904033000054],
              [45.52205814600012, 40.88815134700006],
              [45.47927006000009, 40.92990590400011],
              [45.452811727000096, 40.9463906860001],
              [45.44284278300012, 40.94838019700002],
              [45.42873050900005, 40.9511965950001],
              [45.41643151900013, 40.961325175000056],
              [45.42521651200008, 40.99367462200003],
              [45.419118693000144, 41.01734242800008],
              [45.39152347800007, 41.015068665000044],
              [45.38194794700013, 41.011448110000075],
              [45.33535119600009, 40.99382965200009],
              [45.3125618900001, 40.99662017900003],
              [45.268740275000084, 41.010262757000035],
              [45.22161136900007, 41.01444854800009],
              [45.20517826400004, 41.02488718700003],
              [45.18967533400007, 41.03754791300007],
              [45.16921146700014, 41.047159730000075],
              [45.136551962000055, 41.07289459300007],
              [45.12001550300005, 41.07961252900007],
              [45.11712162300006, 41.06142242500006],
              [45.111023804000126, 41.04953684500002],
              [45.09169681800006, 41.051035461000126],
              [45.0700443930001, 41.06209421900003],
              [45.057176961000096, 41.07878570600006],
              [45.067822307000085, 41.110928447],
              [45.16673099800005, 41.10777618500005],
              [45.2010441490001, 41.126741435],
              [45.199752238000144, 41.14265777600012],
              [45.18678145300004, 41.15686879500008],
              [45.13443322800009, 41.187874654],
              [45.117328329000145, 41.19206044600004],
              [45.0520093180001, 41.19211212100005],
              [45.034852742000055, 41.19769317600007],
              [45.02932336400005, 41.21009552000005],
              [45.039400268000065, 41.23117950500007],
              [45.0023999440001, 41.290452373000065],
            ],
            [
              [45.51368656500006, 40.60196726500003],
              [45.54717289200005, 40.621552633000036],
              [45.56071211800008, 40.64764923100002],
              [45.53466719600004, 40.658914693000085],
              [45.520197795000115, 40.660413310000095],
              [45.50557336400004, 40.66020660400004],
              [45.491775757000084, 40.657106018],
              [45.47927006000009, 40.65023305300012],
              [45.47337894700007, 40.64031117800003],
              [45.47131188900005, 40.6298725380001],
              [45.47327559400014, 40.61943390000006],
              [45.47927006000009, 40.609822083000054],
              [45.51368656500006, 40.60196726500003],
            ],
          ],
          [
            [
              [46.135870809000096, 38.863701274],
              [46.12605228600012, 38.862667745000024],
              [46.06796797700014, 38.87411407500004],
              [46.00182214300008, 38.89747182200007],
              [45.791085653000096, 38.93209503200008],
              [45.76807409200012, 38.93912990300005],
              [45.71687829600006, 38.954780986000046],
              [45.627788127000144, 38.95550445600004],
              [45.57084069800004, 38.966382345000014],
              [45.54314213100014, 38.967131653000095],
              [45.53556486900004, 38.96845289800008],
              [45.530843140000115, 38.969276225],
              [45.51027592000008, 38.97865549700005],
              [45.494529008000086, 38.98191651900002],
              [45.48257735200008, 38.9843915820001],
              [45.45983972200008, 38.99312489800006],
              [45.43860070800014, 39.00423533100009],
              [45.42707686400013, 39.01488067700008],
              [45.42526818900012, 39.025629375],
              [45.42821374500011, 39.0341043100001],
              [45.43229618400011, 39.04247589200007],
              [45.434518270000126, 39.052785340000085],
              [45.42971236100004, 39.05947743700001],
              [45.405837850000125, 39.067874858],
              [45.39638106300009, 39.07332672200006],
              [45.391316772000096, 39.081749980000055],
              [45.38346195500014, 39.103247376000084],
              [45.379327840000144, 39.11115387000005],
              [45.36992272900005, 39.11895701100006],
              [45.36062097200005, 39.12322031600003],
              [45.351939331000096, 39.12831044500011],
              [45.345273071000065, 39.13843902600006],
              [45.353903035000144, 39.15319264700007],
              [45.3482186280001, 39.163915507000084],
              [45.334886108000035, 39.170426738000046],
              [45.32093347200009, 39.17259714800004],
              [45.3111149500001, 39.17629201300004],
              [45.311321656000075, 39.18484446200007],
              [45.31390547700005, 39.19424957300002],
              [45.3111149500001, 39.20052826000004],
              [45.301709839000125, 39.20138092100005],
              [45.29261478700005, 39.198616231000116],
              [45.285690144000114, 39.194921367000106],
              [45.283106323000084, 39.19306101500008],
              [45.178926636000085, 39.21982940700006],
              [45.15272668500006, 39.21352488300006],
              [45.146267131000116, 39.228666077000085],
              [45.1358284910001, 39.2784821580001],
              [45.128903849000096, 39.28928253200006],
              [45.12037723800006, 39.29889434800005],
              [45.11434974800005, 39.30934967600005],
              [45.09603763800004, 39.341113994000025],
              [45.08797611500006, 39.35072581000004],
              [45.078726033000066, 39.35475657200003],
              [45.06864912900011, 39.36421335900009],
              [45.060484253000084, 39.374600322000035],
              [45.057176961000096, 39.381731670000065],
              [45.05169925900009, 39.38684763600004],
              [45.01562910900009, 39.40596791600005],
              [45.01211511300005, 39.40948191300002],
              [45.00994470200004, 39.41402944000005],
              [45.00637902800008, 39.41795684800009],
              [44.99857588700007, 39.41961049500004],
              [44.98772383600004, 39.419352112000084],
              [44.98250451700011, 39.420178935000095],
              [44.95702803600011, 39.434493307000096],
              [44.953307333000055, 39.44162465500004],
              [44.96162723800006, 39.45376861600003],
              [44.940698283000074, 39.468082988000035],
              [44.92839929200011, 39.488236796000095],
              [44.89842696100004, 39.58435496000003],
              [44.88643802900003, 39.60595570900007],
              [44.86535404500006, 39.61758290600004],
              [44.86928145300004, 39.62052846300004],
              [44.87227868700006, 39.62507598900008],
              [44.84923099700012, 39.62559275300002],
              [44.827836955000066, 39.628796692],
              [44.8239530730001, 39.630540026000105],
              [44.80964685100014, 39.636961569],
              [44.80699282900008, 39.639901712000025],
              [44.79574589100008, 39.6523611460001],
              [44.78432539900007, 39.69023997000009],
              [44.77455855300013, 39.702797343],
              [44.80292891400012, 39.71240915900002],
              [44.84933435100004, 39.718920390000065],
              [44.893052612000076, 39.71840362600004],
              [44.927159058000086, 39.72470815100006],
              [44.953215052000076, 39.735965352000036],
              [44.959095093000144, 39.7385057580001],
              [44.99599206500005, 39.76046824200007],
              [45.03350915500005, 39.77039011600006],
              [45.06751224800013, 39.75721262600008],
              [45.07499903900003, 39.749820272000036],
              [45.14125451600006, 39.6844005330001],
              [45.15153812600005, 39.66770904600007],
              [45.15587894700013, 39.64920888300004],
              [45.154225301000054, 39.625851136000094],
              [45.14440677900012, 39.589832663000024],
              [45.14833418800009, 39.57525990900005],
              [45.16791955500008, 39.56554473900009],
              [45.204764852000096, 39.57231435200005],
              [45.23318689000013, 39.592726542],
              [45.25995528200008, 39.59970286],
              [45.26619102100011, 39.59291812800005],
              [45.29106449400007, 39.565854798000075],
              [45.30289839700009, 39.54508087200004],
              [45.31297530100011, 39.53381540900007],
              [45.32754805500008, 39.52926788300006],
              [45.37488366700012, 39.52585723900002],
              [45.39235030100008, 39.51877756800009],
              [45.42393727800004, 39.49382694200007],
              [45.42407963000011, 39.493714498000074],
              [45.43482832800004, 39.48885691400007],
              [45.44609379000008, 39.48751332600001],
              [45.457462606000036, 39.48927032500008],
              [45.46862471500009, 39.493662821000086],
              [45.47927006000009, 39.497176819000046],
              [45.55967858900004, 39.53681264300009],
              [45.58644698100011, 39.54539093100003],
              [45.70906573600007, 39.56842210300006],
              [45.714656210000044, 39.56947214800006],
              [45.73785892700005, 39.569782206000056],
              [45.76545414200007, 39.561565654000034],
              [45.788088420000065, 39.54895660400008],
              [45.79708011900004, 39.53634755500006],
              [45.79728682500007, 39.51939768500007],
              [45.79403121000013, 39.49397288100006],
              [45.79403121000013, 39.49386952800005],
              [45.80307458500005, 39.44818756200003],
              [45.79863041200008, 39.432426249000045],
              [45.764989054000125, 39.38948313400006],
              [45.7586328540001, 39.36948435500004],
              [45.76437068000013, 39.359142100000085],
              [45.76700443600009, 39.354394836000026],
              [45.823745158000065, 39.34307769800007],
              [45.8443123780001, 39.330055237000025],
              [45.86332930600014, 39.31403554300006],
              [45.88720381700011, 39.29966949500006],
              [45.90178842600011, 39.29412397600005],
              [45.95882735200007, 39.27243601500005],
              [45.97923954300012, 39.25729482000004],
              [45.98580245000011, 39.24944000300012],
              [45.988076213000056, 39.24189524400008],
              [45.98600915500009, 39.23468638100012],
              [45.97923954300012, 39.22794260700009],
              [45.95510664900007, 39.203241273000074],
              [45.94900883000014, 39.17779063000005],
              [45.9581038820001, 39.15151316300002],
              [45.97923954300012, 39.12443471300004],
              [46.005232788000114, 39.095444234000084],
              [46.02548995000012, 39.06376658100008],
              [46.07757979300004, 38.95049184200009],
              [46.135870809000096, 38.863701274],
            ],
          ],
          [
            [
              [45.20993249500003, 40.96799143500006],
              [45.18678145300004, 40.97083363900005],
              [45.17716963700008, 40.99382965200009],
              [45.180270223000036, 40.99641347300009],
              [45.18378422000012, 40.99791208900008],
              [45.18771162900009, 40.99837717700002],
              [45.19184574400009, 40.99780873600007],
              [45.22047448700005, 40.97905019100007],
              [45.20993249500003, 40.96799143500006],
            ],
          ],
          [
            [
              [50.61890709700003, 40.299994208000044],
              [50.60010826900003, 40.30369700700004],
              [50.58757571700005, 40.30060455900008],
              [50.57276451900003, 40.31004466400009],
              [50.56299889400003, 40.32485586100006],
              [50.56527754000007, 40.33783600500004],
              [50.57829837300005, 40.33002350500004],
              [50.587901238000086, 40.33234284100007],
              [50.596690300000034, 40.33746979400007],
              [50.60694420700008, 40.33783600500004],
              [50.62126712300005, 40.32607656500005],
              [50.625743035000085, 40.31037018400008],
              [50.61890709700003, 40.299994208000044],
            ],
          ],
          [
            [
              [50.38843834700003, 40.401678778000075],
              [50.37354576900003, 40.39907461100006],
              [50.35368899800005, 40.39988841400009],
              [50.35865319100009, 40.42422109600005],
              [50.32601972700007, 40.45807526200008],
              [50.32642662900008, 40.48187897300005],
              [50.338633660000085, 40.47687409100007],
              [50.35368899800005, 40.48065827000005],
              [50.36052493600005, 40.47443268400008],
              [50.36280358200008, 40.453558661000045],
              [50.37256920700008, 40.442572333000044],
              [50.38502037900008, 40.43398672100005],
              [50.395274285000085, 40.42039622600004],
              [50.39625084700003, 40.40851471600007],
              [50.38843834700003, 40.401678778000075],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Turkey',
        iso3: 'TUR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [43.44042810000013, 41.10658762600012],
              [43.43629398600007, 41.08322987900006],
              [43.444562216000065, 41.05144887300004],
              [43.460478557000044, 41.02287180600008],
              [43.47959883700008, 41.00912587500004],
              [43.52238692200007, 41.00447499600007],
              [43.56543339000007, 40.98814524400005],
              [43.6048625090001, 40.963340556],
              [43.63617842600013, 40.93352325500008],
              [43.64765059400014, 40.91388621100005],
              [43.65193973800007, 40.894765931000066],
              [43.654161824000084, 40.874715475000116],
              [43.65953617400004, 40.85197784400013],
              [43.66976810700004, 40.83213409500006],
              [43.711315959000046, 40.78164622100003],
              [43.72061771700004, 40.762887676000034],
              [43.72413171400012, 40.746351217000054],
              [43.729351033000114, 40.677104797000126],
              [43.72640547700013, 40.668991598000034],
              [43.70563155100007, 40.64077626600006],
              [43.699533732000134, 40.634575094000056],
              [43.707181844000104, 40.61194081700002],
              [43.664807169000085, 40.57406199200004],
              [43.65147465000007, 40.55339141900002],
              [43.65250817900005, 40.5294135540001],
              [43.646462037000106, 40.533030905000075],
              [43.64201786300009, 40.534374492000055],
              [43.63757369000007, 40.53514963800005],
              [43.631475871000134, 40.5368549600001],
              [43.63462813300009, 40.532772522000116],
              [43.63628177900006, 40.529775289],
              [43.63896895400006, 40.52259226500006],
              [43.61530114700014, 40.520421855000066],
              [43.593700399000056, 40.50900136300005],
              [43.55949060100005, 40.477892152],
              [43.56362471500012, 40.464714661000116],
              [43.58486372800007, 40.44657623400009],
              [43.62532637500004, 40.42016957600002],
              [43.62532637500004, 40.41334828800005],
              [43.62446300100004, 40.411137485000026],
              [43.609565064000094, 40.372988994000096],
              [43.60103845200007, 40.36182688400005],
              [43.59421716300011, 40.34544545500002],
              [43.6044490970001, 40.329787496000066],
              [43.631475871000134, 40.31030548100007],
              [43.67596927900013, 40.26596710200003],
              [43.690347590000044, 40.24044318800007],
              [43.69136885600011, 40.2386302690001],
              [43.67307539900014, 40.22772654300003],
              [43.68372074400014, 40.21010487900004],
              [43.714933309000116, 40.180649313000046],
              [43.72139286300006, 40.16938385100006],
              [43.71162601700013, 40.15646474200007],
              [43.66635746300011, 40.14891998300003],
              [43.65250817900005, 40.13899810900001],
              [43.66542728700006, 40.11016265900007],
              [43.71121260600012, 40.09073232100009],
              [43.80278324400007, 40.07073354100008],
              [43.91213057400006, 40.024328105000066],
              [44.032433309000055, 40.00861847],
              [44.04834965000009, 40.012855937000054],
              [44.08312788900014, 40.03161448200005],
              [44.10447025600013, 40.03595530200003],
              [44.114288778000116, 40.03393992100008],
              [44.12700118000009, 40.0244831350001],
              [44.135476115000074, 40.022312724000116],
              [44.1459147540001, 40.02339792900001],
              [44.16637862100009, 40.028048808000065],
              [44.19500736500004, 40.03078765900001],
              [44.25526208500008, 40.04339670800003],
              [44.28905847200008, 40.04339670800003],
              [44.32564538600013, 40.03466339200007],
              [44.38092555300011, 40.00980379300002],
              [44.46434493000004, 39.97228993700013],
              [44.52217085800004, 39.93353261300008],
              [44.54785404500012, 39.9114667760001],
              [44.55911950700005, 39.89689402300003],
              [44.563770386000044, 39.881701152000105],
              [44.56749108900004, 39.873019512000056],
              [44.57596602400014, 39.866353251000035],
              [44.59105554200005, 39.85782664000003],
              [44.594156128000066, 39.848059794000065],
              [44.59446618600009, 39.83679433200011],
              [44.59818688900009, 39.83100657200005],
              [44.61151940900004, 39.83731109600005],
              [44.647692911000036, 39.805116679],
              [44.66619307500008, 39.79638336200013],
              [44.671257365000145, 39.795866598000075],
              [44.682419474000085, 39.797210185000054],
              [44.68717370600007, 39.79638336200013],
              [44.69203129100009, 39.79302439400003],
              [44.697767374000136, 39.7852729290001],
              [44.75910730000004, 39.723106181000034],
              [44.77455855300013, 39.702797343],
              [44.78432539900007, 39.69023997000009],
              [44.79574589100008, 39.6523611460001],
              [44.80699282900008, 39.639901712000025],
              [44.725724325000044, 39.68533070900004],
              [44.70629398600005, 39.6980431110001],
              [44.646504354000115, 39.71954050700005],
              [44.632810099000096, 39.73163279200013],
              [44.60583500200005, 39.76315541600009],
              [44.59043542500007, 39.771526998000084],
              [44.56573409000009, 39.765894267000036],
              [44.45948734500013, 39.69845652300002],
              [44.45504317300009, 39.68713938400005],
              [44.460210816000085, 39.65447987900008],
              [44.45825019400007, 39.64252008900003],
              [44.45762699400012, 39.63871856700008],
              [44.45168420400006, 39.625851136000094],
              [44.41855961100009, 39.574329733000084],
              [44.41401208500014, 39.560893860000036],
              [44.412048381000034, 39.54446075500009],
              [44.41401208500014, 39.53035308900006],
              [44.417422729000066, 39.51748565700005],
              [44.41680261200008, 39.50554840100001],
              [44.40682906100011, 39.493714498000074],
              [44.406674031000136, 39.493662821000086],
              [44.401713094000115, 39.471338603],
              [44.40522709100014, 39.452476705],
              [44.40481368000013, 39.43438995400008],
              [44.3879671630001, 39.41449452800008],
              [44.36874353000013, 39.40359080000009],
              [44.316963745000066, 39.38529734300003],
              [44.2949495850001, 39.38121490500002],
              [44.26952478100009, 39.38286855100007],
              [44.200433390000114, 39.40948191300002],
              [44.176507203000085, 39.41154897100007],
              [44.1222469490001, 39.400438538000046],
              [44.0991992590001, 39.398474833000094],
              [44.07697839400009, 39.40059356700009],
              [44.06137211100014, 39.4002835080001],
              [44.04638594600004, 39.39604604100005],
              [44.02602543200004, 39.38617584200007],
              [44.01486332200011, 39.37408355700008],
              [44.02096114100004, 39.36199127200008],
              [44.047212768000065, 39.33791005500005],
              [44.04739541400011, 39.33751363000003],
              [44.05176029500012, 39.328039857000064],
              [44.05765140800014, 39.3068008420001],
              [44.06943363500011, 39.287008769000025],
              [44.06922692900008, 39.279567362000094],
              [44.066746460000104, 39.2729527800001],
              [44.067159872000104, 39.26401275700009],
              [44.070570516000146, 39.25548614500006],
              [44.08266280100014, 39.23566823400007],
              [44.08348962400004, 39.22683156400008],
              [44.076564982000036, 39.208693136000036],
              [44.07770186400006, 39.2000631720001],
              [44.10354008000007, 39.18463775700012],
              [44.148085164000065, 39.16644765200006],
              [44.18663578300004, 39.14513112500008],
              [44.194800659000066, 39.1205331420001],
              [44.174956909000116, 39.090224915000064],
              [44.16989261900011, 39.074360250000055],
              [44.17914270000006, 39.03493113200004],
              [44.16953088400004, 39.0230455530001],
              [44.153356160000044, 39.01255523700006],
              [44.13919681800007, 38.9939517210001],
              [44.13919681800007, 38.99377085400006],
              [44.14467452000008, 38.98682037400006],
              [44.1477751060001, 38.98005076100013],
              [44.15196089700004, 38.964625346000034],
              [44.1580070390001, 38.95746816100008],
              [44.16710209200005, 38.95199045800008],
              [44.174646851000034, 38.94576344800002],
              [44.175370321000116, 38.93669423500005],
              [44.17485355600007, 38.92837432900008],
              [44.17816084800006, 38.920700379],
              [44.18250166900003, 38.91312978100005],
              [44.19211348500005, 38.89075388600007],
              [44.20575606300008, 38.87566436800007],
              [44.221982462000085, 38.86344289200004],
              [44.275002482000104, 38.84357330300004],
              [44.279808391000074, 38.81422109000006],
              [44.25267826400011, 38.74182240800009],
              [44.24864750100011, 38.72182362900007],
              [44.250507853000045, 38.70921458000005],
              [44.255468791000055, 38.697277323],
              [44.26048140500012, 38.6792422490001],
              [44.25608890800004, 38.671955871000094],
              [44.247407267000085, 38.66508290600005],
              [44.24430668200006, 38.65895924900009],
              [44.25681237800012, 38.65392079700011],
              [44.27489912900006, 38.64937327100007],
              [44.282547242000135, 38.645394185],
              [44.28988529500003, 38.63888295500003],
              [44.29701664300006, 38.622320659000124],
              [44.2968099360001, 38.60162424800011],
              [44.29215905800004, 38.56204010100005],
              [44.301357462000055, 38.51119049100002],
              [44.300168905000135, 38.49403391500006],
              [44.2875081790001, 38.453726298000035],
              [44.287404826000056, 38.44194407200011],
              [44.29050541200007, 38.416596781000024],
              [44.28988529500003, 38.407372539000036],
              [44.286578003000045, 38.39099111000006],
              [44.289523560000134, 38.38225779200009],
              [44.298670288000096, 38.377193502000026],
              [44.3133980720001, 38.37181915400005],
              [44.3633691820001, 38.36461029100009],
              [44.39633874500004, 38.379673971],
              [44.40905114700007, 38.38179270400006],
              [44.42465743000014, 38.37703847200008],
              [44.43881677200011, 38.367555847000105],
              [44.45111576300013, 38.35404246100005],
              [44.458763876000035, 38.33833282500005],
              [44.459177287000045, 38.322416484000044],
              [44.43674971500013, 38.2969400030001],
              [44.40057621200009, 38.27466746000006],
              [44.37241255700013, 38.24950103800002],
              [44.376701701000115, 38.201545309],
              [44.373239380000086, 38.18211497000003],
              [44.3670898850001, 38.16247792600008],
              [44.36057865400005, 38.147853496000025],
              [44.35313724800011, 38.13999867800008],
              [44.33536055500008, 38.13405588800005],
              [44.32709232500014, 38.12839731900003],
              [44.325697062000074, 38.11968984000005],
              [44.33381026200004, 38.100879618000036],
              [44.32828088400004, 38.09462677100005],
              [44.30900557400014, 38.08723704000003],
              [44.29587976100004, 38.0790204880001],
              [44.286578003000045, 38.066308085000045],
              [44.27830977400009, 38.04532745400006],
              [44.26952478100009, 38.030005391000074],
              [44.24539188600005, 38.00837880500002],
              [44.236141805000045, 37.99401275700011],
              [44.236038452000116, 37.99383188900005],
              [44.22756351700008, 37.98099029600006],
              [44.221465698000145, 37.96882049600008],
              [44.21965702300014, 37.95608225500011],
              [44.22466963700009, 37.94200042800007],
              [44.225496460000045, 37.92931386300005],
              [44.21671146700004, 37.91859100400002],
              [44.20637618000012, 37.90833323200003],
              [44.205006186000105, 37.904767947],
              [44.20208703600008, 37.8971711220001],
              [44.21960534600004, 37.87531199200005],
              [44.25443526200007, 37.87084198000004],
              [44.31923750800007, 37.87686228500009],
              [44.33122644100007, 37.8739684050001],
              [44.36714156100004, 37.860222473000064],
              [44.37794193600007, 37.8541246540001],
              [44.383833049000145, 37.84497792600011],
              [44.387553752000144, 37.83340240500006],
              [44.39323815900008, 37.821077576000036],
              [44.40440026900012, 37.80973459900004],
              [44.412100057000146, 37.807719218],
              [44.41897302300009, 37.80968292200002],
              [44.42548425300009, 37.81076812800002],
              [44.433029012000134, 37.80611724900005],
              [44.4337524820001, 37.8011046350001],
              [44.42977339700013, 37.78513661800007],
              [44.42910160300005, 37.779142152000034],
              [44.43643965600006, 37.76779917400005],
              [44.450495646000036, 37.76663645400002],
              [44.466515340000115, 37.77113230400006],
              [44.47922774300008, 37.776868388000096],
              [44.50646122300009, 37.77934885700007],
              [44.53441817200007, 37.76919443800004],
              [44.55937788900013, 37.75201202500007],
              [44.596119833000046, 37.71638112400008],
              [44.59839359500006, 37.70702768900013],
              [44.58816166200006, 37.6939793910001],
              [44.553538452000055, 37.67181020100007],
              [44.5452702230001, 37.663025208000064],
              [44.54087772600013, 37.63271698000004],
              [44.56097985800005, 37.61465606800003],
              [44.58351078300012, 37.601091004000054],
              [44.58743819100005, 37.58401194300011],
              [44.57834314000007, 37.563909811000045],
              [44.57183190900014, 37.53920847600004],
              [44.56991988100003, 37.514403788],
              [44.575242554000056, 37.49399159800005],
              [44.575242554000056, 37.493836568000106],
              [44.57927331600007, 37.47696421400012],
              [44.56594079600012, 37.447172750000036],
              [44.57214196800004, 37.430791321000086],
              [44.58557784000004, 37.4246676640001],
              [44.62278487200007, 37.421902975000066],
              [44.63818444800006, 37.41260121700013],
              [44.65224043800009, 37.38402415000006],
              [44.66164554900013, 37.37565256800009],
              [44.69802575700004, 37.38004506500009],
              [44.70712080900006, 37.370950013000126],
              [44.71301192300007, 37.35679067000008],
              [44.72138350400007, 37.34327728300009],
              [44.7789510500001, 37.31379587800008],
              [44.801585327000055, 37.29268605600005],
              [44.79848474100004, 37.26031077100005],
              [44.786754191000114, 37.24811513300004],
              [44.77295658300005, 37.241681417000095],
              [44.7605025630001, 37.2332323210001],
              [44.7535262450001, 37.21532643600004],
              [44.75673018400005, 37.195198466000065],
              [44.76613529500014, 37.17814524400005],
              [44.772336467000116, 37.161247051000046],
              [44.76613529500014, 37.14192006500009],
              [44.75383630300007, 37.15915415500008],
              [44.73378584800014, 37.16724151700008],
              [44.628934367000056, 37.17902374300006],
              [44.61027917500007, 37.17835194900009],
              [44.578239787000086, 37.16641469400004],
              [44.539379110000084, 37.143677063000055],
              [44.503412313000126, 37.11662445100002],
              [44.47922774300008, 37.09200063100003],
              [44.45442305500012, 37.07634267200008],
              [44.428068074000066, 37.06476715100003],
              [44.34311202000009, 37.04244293300006],
              [44.33515384900011, 37.031151632],
              [44.33163985200008, 37.015467835000024],
              [44.316136922000055, 36.994125468000036],
              [44.316136922000055, 36.99402211500011],
              [44.31598189300013, 36.99397043900008],
              [44.315878540000085, 36.99397043900008],
              [44.30662845900008, 36.97722727500003],
              [44.2972233480001, 36.969940898000075],
              [44.28482100400004, 36.96916575200005],
              [44.243273153000075, 36.977769878000075],
              [44.23428145400004, 36.98366099100009],
              [44.22777022300005, 36.994125468000036],
              [44.18746260600011, 37.0669375610001],
              [44.180021200000056, 37.087608134000035],
              [44.18064131700004, 37.108924662000035],
              [44.18921960400007, 37.12920766200004],
              [44.20596276900011, 37.14662262000006],
              [44.21877852400007, 37.15261708600009],
              [44.230199016000086, 37.154322408000056],
              [44.24012089000007, 37.15796559700006],
              [44.24833744300014, 37.169670309000125],
              [44.24962935400009, 37.17943715500009],
              [44.248544148000065, 37.191917013000065],
              [44.243531535000045, 37.21382782000002],
              [44.23500492300013, 37.23677215600007],
              [44.2231710210001, 37.25405792300005],
              [44.20689294500005, 37.26751963300002],
              [44.18446537300008, 37.27917266800007],
              [44.088037150000105, 37.31116038000006],
              [44.06902473600013, 37.31372658800005],
              [44.03558557100013, 37.31824005200009],
              [43.99036869300005, 37.31250396800003],
              [43.95378177900011, 37.28746673600004],
              [43.924171183000055, 37.25307607000009],
              [43.89363041200005, 37.22491241400003],
              [43.839990276000094, 37.21710927300002],
              [43.82200687700009, 37.202381491000025],
              [43.809397827000055, 37.19969431500009],
              [43.8020597740001, 37.20357004800003],
              [43.78056237800013, 37.22036488900001],
              [43.77064050300004, 37.225842590000084],
              [43.746921021000105, 37.230648499],
              [43.720824423000124, 37.23261220300013],
              [43.618298381000045, 37.226979472],
              [43.59421716300011, 37.22945994100009],
              [43.56889571200014, 37.2377023320001],
              [43.55060225500006, 37.248735250000024],
              [43.542437378000045, 37.25230092400007],
              [43.52951827000004, 37.2539028930001],
              [43.517115926000145, 37.25230092400007],
              [43.492414591000056, 37.24475616500003],
              [43.47959883700008, 37.24336090100006],
              [43.463269084000046, 37.248683574],
              [43.416760295000074, 37.27917266800007],
              [43.376039266000134, 37.295528260000125],
              [43.36250521500011, 37.30390815200006],
              [43.33614506100008, 37.320229594000054],
              [43.32415612800014, 37.32221913700009],
              [43.305655965000085, 37.319971212000056],
              [43.296870972000136, 37.316741435],
              [43.28751753800009, 37.309144999000026],
              [43.27862919100005, 37.30774973600005],
              [43.27030928500011, 37.308679911000084],
              [43.26338464300011, 37.31069529300005],
              [43.1319714760001, 37.36725514700002],
              [43.114814901000045, 37.37113088000008],
              [43.08370568900011, 37.36883127900005],
              [43.043501424000056, 37.360252991000024],
              [43.00515751200004, 37.34725636800009],
              [42.97962935400011, 37.3318309540001],
              [42.93704797300006, 37.32015208000011],
              [42.89674035700011, 37.324906311000106],
              [42.81405806500004, 37.34681711900005],
              [42.80547977700007, 37.35185557000004],
              [42.801138956000045, 37.3690896610001],
              [42.79245731600008, 37.374334819000055],
              [42.78046838400007, 37.37549753800006],
              [42.77158003700009, 37.374903260000096],
              [42.722177368000075, 37.358909404000045],
              [42.715666138000074, 37.35529205300007],
              [42.70946496500011, 37.34717885400006],
              [42.707397909000065, 37.34015085900005],
              [42.70615767400011, 37.333226217000075],
              [42.70233361900006, 37.32534556100002],
              [42.57696659400011, 37.17923044900003],
              [42.56466760200004, 37.15204864500005],
              [42.56125695800006, 37.14662262000006],
              [42.54523726400009, 37.140886536000025],
              [42.45914432800009, 37.129311015000056],
              [42.401886841000135, 37.114143982000044],
              [42.35723840300011, 37.1099840290001],
              [42.35651493400013, 37.13827687600009],
              [42.354551229000094, 37.15241038100005],
              [42.34669641200014, 37.158430685000084],
              [42.33532759600007, 37.17116892500003],
              [42.353207642000086, 37.2270311490001],
              [42.34669641200014, 37.239769389000074],
              [42.33987512200008, 37.24263743100006],
              [42.30576867700012, 37.26454823900009],
              [42.301427856000146, 37.26992258700007],
              [42.29636356600008, 37.27968943300003],
              [42.2920227460001, 37.28506378200008],
              [42.285821574000124, 37.28656239900009],
              [42.27920699100008, 37.28227325500002],
              [42.27290246500007, 37.276743877000015],
              [42.26721805900007, 37.27452179000004],
              [42.23683231600012, 37.2863040160001],
              [42.22318973800009, 37.288138530000126],
              [42.222156209000104, 37.292401835000064],
              [42.22380985500007, 37.302375387],
              [42.222569621000105, 37.313950908000024],
              [42.21120080500003, 37.324906311000106],
              [42.193010701000105, 37.31322743700004],
              [42.17854130000006, 37.306302795000065],
              [42.12831180900008, 37.25328277600006],
              [42.052967570000135, 37.19664540600006],
              [42.00924930900004, 37.175613099000046],
              [41.89636506700003, 37.15428342000003],
              [41.47977258300011, 37.07556752600006],
              [41.201339966000035, 37.06497385700008],
              [41.179739217000076, 37.06962473600005],
              [41.13509078000004, 37.08424916600002],
              [40.89644901500009, 37.12269643200007],
              [40.70896691900009, 37.10047556600004],
              [40.65946089700009, 37.085256857],
              [40.52572229000009, 37.02588063600005],
              [40.4798336180001, 37.01515777600004],
              [40.45699263500012, 37.014124247000055],
              [40.435185180000076, 37.01061025000011],
              [40.413894491000065, 37.004021505000125],
              [40.3937406820001, 36.99402211500011],
              [40.261409006000065, 36.9227846830001],
              [40.190135539000096, 36.88441640300003],
              [40.152721802000144, 36.870360413000114],
              [40.115204712000036, 36.864727682000066],
              [40.07923791500008, 36.854857483],
              [39.97981246000006, 36.80695343100008],
              [39.76525191300004, 36.742151184000065],
              [39.441707633000135, 36.69237269400004],
              [39.23959924300004, 36.661277567000084],
              [39.18585575300011, 36.65952056900004],
              [39.032170044000054, 36.70117177400003],
              [38.97997684800009, 36.698174540000124],
              [38.95796268700008, 36.692903545],
              [38.79538863100004, 36.686650696000086],
              [38.7250053300001, 36.69393707300007],
              [38.66413049400006, 36.71951690700003],
              [38.635191663000114, 36.744039459000064],
              [38.52935835800014, 36.833721822000044],
              [38.47995568900012, 36.85573598200004],
              [38.28988977000006, 36.9017021690001],
              [38.22426070200004, 36.90839426700005],
              [38.19005090300004, 36.90552622500006],
              [38.12297489400004, 36.88462310800007],
              [38.026005169000086, 36.83500562500005],
              [38.00794315600007, 36.82576365100009],
              [37.98003788200009, 36.81966583300003],
              [37.819737589000056, 36.76054799400008],
              [37.654062948000046, 36.73212595700004],
              [37.59339481600006, 36.71052520800008],
              [37.44611698400013, 36.63419911700005],
              [37.40446578000012, 36.63445750000001],
              [37.24189172400014, 36.65859039300007],
              [37.219670858000086, 36.657143453000074],
              [37.15610884600005, 36.64391428700007],
              [37.13740197700014, 36.64587799100012],
              [37.120968872000105, 36.64990875300002],
              [37.10443241400009, 36.6509939570001],
              [37.08562219300006, 36.64417266900004],
              [37.07011926300004, 36.63151194300009],
              [37.06236779800014, 36.62210683200006],
              [37.05306604000015, 36.619936422000066],
              [37.03332564300007, 36.628721415000044],
              [37.014515422000045, 36.64226064100002],
              [37.01079471800006, 36.65373280900006],
              [37.01947635900012, 36.685823873000075],
              [37.01844283100013, 36.70664947500002],
              [37.010588012000085, 36.71951690700003],
              [36.980098918000124, 36.74225453700011],
              [36.96469934100014, 36.75383005800005],
              [36.94588912000012, 36.76266672800004],
              [36.92594201700007, 36.76897125300006],
              [36.9068217360001, 36.772588603000045],
              [36.84367313700005, 36.77584421800013],
              [36.65956262500009, 36.827243022000104],
              [36.65856815600006, 36.82752065100006],
              [36.64916304600007, 36.82855417900005],
              [36.63986128800008, 36.828089091000024],
              [36.64327193200006, 36.803646139000065],
              [36.632006469000146, 36.78431915300003],
              [36.6156767170001, 36.7665941370001],
              [36.60327437400014, 36.74695709300006],
              [36.59893355300005, 36.72478790300006],
              [36.59810673000004, 36.7054609180001],
              [36.594696085000066, 36.685823873000075],
              [36.58281050700003, 36.662414449000025],
              [36.569271281000056, 36.62014312700002],
              [36.56999475100008, 36.57570139600004],
              [36.565343872000085, 36.532499899000115],
              [36.53547489400012, 36.49400095600005],
              [36.531237427000065, 36.47901479100007],
              [36.53382124800004, 36.462478333],
              [36.552734823000094, 36.40816640300004],
              [36.55800581900013, 36.400621643000065],
              [36.56503381400012, 36.39560903000002],
              [36.58084680200011, 36.38987294500005],
              [36.585704386000145, 36.387030742],
              [36.59056197100006, 36.380364482000076],
              [36.593352498000115, 36.3734915160001],
              [36.59448938000014, 36.36594675700006],
              [36.594282674000056, 36.357110087000066],
              [36.58777144400011, 36.342123922000084],
              [36.58219038900006, 36.33308054700002],
              [36.57764286300005, 36.33287384100008],
              [36.58777144400011, 36.32481231700008],
              [36.62074100700005, 36.32202179000002],
              [36.637070761000075, 36.3168024700001],
              [36.64864628100014, 36.30589874300004],
              [36.64876116200014, 36.30571856100006],
              [36.65846480300013, 36.29049916600006],
              [36.665492798000116, 36.27401438400007],
              [36.66911014800013, 36.259855042000126],
              [36.67004032400007, 36.237324117000114],
              [36.664252563000105, 36.22900421100006],
              [36.593455851000044, 36.218100485],
              [36.574438925000095, 36.21835886700005],
              [36.498577922000095, 36.22786733100004],
              [36.48018111100009, 36.22554189100002],
              [36.46891564900011, 36.222389628000045],
              [36.46529829900004, 36.2159300740001],
              [36.463954712000145, 36.20879872600007],
              [36.45920048000005, 36.20311432000001],
              [36.45072554500007, 36.19991038000005],
              [36.44524784300006, 36.19991038000005],
              [36.43925337700006, 36.20140899700006],
              [36.41186486800012, 36.20445790700008],
              [36.39811893700005, 36.2082302860001],
              [36.3856132410001, 36.21546498600007],
              [36.373004191000064, 36.227608948000054],
              [36.36142867000012, 36.21815216],
              [36.37579471900011, 36.204509583000075],
              [36.37445113100006, 36.19587961900005],
              [36.366286255000034, 36.18921335800003],
              [36.36049849400007, 36.181668600000094],
              [36.358638143000064, 36.16699249300008],
              [36.355537557000105, 36.022401835000025],
              [36.35801802600008, 35.9939797980001],
              [36.33672733500009, 35.98824371300013],
              [36.29734989400009, 36.00074941100003],
              [36.277506144000085, 35.99418650400004],
              [36.2774027910001, 35.99403147400001],
              [36.269031209000104, 35.95873647100011],
              [36.25311486800007, 35.95563588500006],
              [36.22903365100012, 35.96116526300007],
              [36.1968909090001, 35.95170847600009],
              [36.174876749000134, 35.92266632100011],
              [36.16877893100008, 35.85207631500005],
              [36.15761682100015, 35.82256907200012],
              [36.15530755700013, 35.8222320440001],
              [36.13849654100005, 35.81977854500006],
              [36.08030887900014, 35.85419504800011],
              [36.050749959000086, 35.865408834000064],
              [36.01943404100007, 35.86618398100008],
              [36.0039311110001, 35.86918121400008],
              [35.992355591000035, 35.8773460900001],
              [35.990081828000086, 35.889283346000056],
              [35.99307906000013, 35.9023574830001],
              [35.992769002000045, 35.91527659100011],
              [35.98026330600004, 35.92685211200005],
              [35.96072961500005, 35.92437164300007],
              [35.94057580600014, 35.91837717700004],
              [35.92083540900012, 35.91512156200007],
              [35.911305418925394, 35.9177504327608],
              [35.91138756600009, 35.91787344000005],
              [35.92269941500007, 35.93158600500004],
              [35.96607506600009, 35.99363841400009],
              [35.97673587300005, 36.00096263200004],
              [35.97543379000007, 36.01850006700005],
              [35.94841556100005, 36.08783600500004],
              [35.87826582100007, 36.182074286000045],
              [35.86451256600009, 36.19684479400007],
              [35.852224155000044, 36.21352773600006],
              [35.84099368600005, 36.24453359600005],
              [35.826914910000085, 36.25755442900004],
              [35.81080162900008, 36.269598700000074],
              [35.79859459700009, 36.281683661000045],
              [35.78736412900008, 36.30426666900007],
              [35.78874759200005, 36.32025788000004],
              [35.81592858200008, 36.35301341400009],
              [35.82447350400008, 36.36107005400004],
              [35.83423912900008, 36.36627838700008],
              [35.84498131600009, 36.36896393400008],
              [35.85678144600007, 36.36977773600006],
              [35.86182701900009, 36.37352122600004],
              [35.87354576900009, 36.397691148000035],
              [35.881846550000034, 36.40468984600005],
              [35.899424675000034, 36.41229889500005],
              [35.90845787900008, 36.41815827000005],
              [35.91325931100005, 36.42719147300005],
              [35.918711785000085, 36.44818756700005],
              [35.93083743600005, 36.45457591400009],
              [35.935557488000086, 36.45945872600004],
              [35.942393425000034, 36.46434153900009],
              [35.98178144600007, 36.47565338700008],
              [35.990244988000086, 36.47964101800005],
              [36.037445509000065, 36.527044989000046],
              [36.044932488000086, 36.53766510600008],
              [36.055430535000085, 36.538275458000044],
              [36.16293379000007, 36.593410549000055],
              [36.178721550000034, 36.59634023600006],
              [36.18913821700005, 36.60398997600004],
              [36.201182488000086, 36.621975002000056],
              [36.21119225400008, 36.64240143400008],
              [36.21615644600007, 36.65778229400007],
              [36.215586785000085, 36.67047760600008],
              [36.211599155000044, 36.67991771000004],
              [36.20655358200008, 36.688706773000035],
              [36.20248457100007, 36.69936758000006],
              [36.201914910000085, 36.706284898000035],
              [36.20248457100007, 36.769191799000055],
              [36.19874108200008, 36.78457265800006],
              [36.18897545700008, 36.80174388200004],
              [36.129893425000034, 36.86928945500006],
              [36.09546959700009, 36.89712148600006],
              [36.058604363000086, 36.91844310100004],
              [36.020274285000085, 36.92633698100008],
              [35.985036655000044, 36.91559479400007],
              [35.95085696700005, 36.89101797100005],
              [35.89380944100009, 36.83490631700005],
              [35.88013756600009, 36.82591380400004],
              [35.863617384000065, 36.822251695000034],
              [35.853851759000065, 36.81582265800006],
              [35.820648634000065, 36.785142320000034],
              [35.805430535000085, 36.775091864000046],
              [35.76710045700008, 36.76772695500006],
              [35.68409264400009, 36.76463450700004],
              [35.64771569100009, 36.753973700000074],
              [35.63624108200008, 36.74461497600004],
              [35.62452233200008, 36.72601959800005],
              [35.61353600400008, 36.71987539300005],
              [35.61744225400008, 36.72679271000004],
              [35.618174675000034, 36.731634833000044],
              [35.61500084700009, 36.735663153000075],
              [35.60670006600009, 36.74038320500006],
              [35.59685306100005, 36.72492096600007],
              [35.58228600400008, 36.71279531500005],
              [35.573008660000085, 36.70066966400009],
              [35.57943769600007, 36.68512604400007],
              [35.594493035000085, 36.70172760600008],
              [35.61687259200005, 36.69623444200005],
              [35.619802280000044, 36.71238841400009],
              [35.62549889400009, 36.710923570000034],
              [35.62916100400008, 36.708238023000035],
              [35.63168379000007, 36.704331773000035],
              [35.63404381600009, 36.69936758000006],
              [35.638682488000086, 36.706284898000035],
              [35.64047285200007, 36.71336497600004],
              [35.63917076900009, 36.720363674000055],
              [35.63404381600009, 36.72671133000006],
              [35.64812259200005, 36.73322174700007],
              [35.65381920700008, 36.72736237200007],
              [35.65739993600005, 36.71751536700009],
              [35.664805535000085, 36.71238841400009],
              [35.675791863000086, 36.71531810100004],
              [35.685557488000086, 36.720770575000074],
              [35.696055535000085, 36.723944403000075],
              [35.70915774800005, 36.71987539300005],
              [35.65015709700009, 36.69782135600008],
              [35.62256920700008, 36.68073151200008],
              [35.60670006600009, 36.65778229400007],
              [35.60865319100009, 36.64687734600005],
              [35.622080925000034, 36.65424225500004],
              [35.666758660000085, 36.69611237200007],
              [35.680023634000065, 36.70307038000004],
              [35.69556725400008, 36.70620351800005],
              [35.65796959700009, 36.67519765800006],
              [35.65219160200007, 36.66673411700009],
              [35.64372806100005, 36.648871161000045],
              [35.637461785000085, 36.64101797100005],
              [35.633148634000065, 36.630926825000074],
              [35.63298587300005, 36.61815013200004],
              [35.63135826900009, 36.60716380400004],
              [35.62354576900009, 36.60252513200004],
              [35.613942905000044, 36.60053131700005],
              [35.59880618600005, 36.591498114000046],
              [35.58936608200008, 36.589504299000055],
              [35.55713951900009, 36.58746979400007],
              [35.54468834700009, 36.589504299000055],
              [35.51335696700005, 36.612982489000046],
              [35.50367272200009, 36.616848049000055],
              [35.49000084700009, 36.61391836100006],
              [35.481211785000085, 36.60724518400008],
              [35.47868899800005, 36.598537502000056],
              [35.48853600400008, 36.59707265800006],
              [35.496836785000085, 36.59442780200004],
              [35.53101647200009, 36.58270905200004],
              [35.48878014400009, 36.59202708500004],
              [35.44548587300005, 36.59634023600006],
              [35.43718509200005, 36.59422435100004],
              [35.41325931100005, 36.583685614000046],
              [35.40805097700007, 36.579291083000044],
              [35.40447024800005, 36.571926174000055],
              [35.39535566500007, 36.567613023000035],
              [35.374034050000034, 36.56159088700008],
              [35.347992384000065, 36.54437897300005],
              [35.346039259000065, 36.541083075000074],
              [35.33578535200007, 36.54559967700004],
              [35.32016035200007, 36.56468333500004],
              [35.30884850400008, 36.56903717700004],
              [35.29468834700009, 36.57249583500004],
              [35.04184004000007, 36.69521719000005],
              [35.01417076900009, 36.70307038000004],
              [34.98226972700007, 36.720770575000074],
              [34.96241295700008, 36.72671133000006],
              [34.94646243600005, 36.72797272300005],
              [34.93327884200005, 36.72748444200005],
              [34.92986087300005, 36.72736237200007],
              [34.91391035200007, 36.724676825000074],
              [34.900401238000086, 36.71987539300005],
              [34.90259850400008, 36.72451406500005],
              [34.90788821700005, 36.74038320500006],
              [34.893565300000034, 36.74599844000005],
              [34.852549675000034, 36.781317450000074],
              [34.77076256600009, 36.816066799000055],
              [34.76498457100007, 36.808579820000034],
              [34.73585045700008, 36.82168203300006],
              [34.69288170700008, 36.81386953300006],
              [34.62671959700009, 36.788763739000046],
              [34.59652754000007, 36.78506094000005],
              [34.58513431100005, 36.781317450000074],
              [34.554698113000086, 36.767645575000074],
              [34.548838738000086, 36.763373114000046],
              [34.539073113000086, 36.744574286000045],
              [34.533864780000044, 36.74038320500006],
              [34.50318444100009, 36.72671133000006],
              [34.41521243600005, 36.66290924700007],
              [34.30746504000007, 36.608587958000044],
              [34.27621504000007, 36.58698151200008],
              [34.190440300000034, 36.49852122600004],
              [34.181651238000086, 36.48338450700004],
              [34.177744988000086, 36.47337474200009],
              [34.16822350400008, 36.46694570500006],
              [34.147471550000034, 36.45917389500005],
              [34.111989780000044, 36.42959219000005],
              [34.07732181100005, 36.41388580900008],
              [34.074880405000044, 36.38727448100008],
              [34.07992597700007, 36.355536200000074],
              [34.07789147200009, 36.32884349200009],
              [34.05779056100005, 36.31590403900009],
              [34.02719160200007, 36.31077708500004],
              [33.99976647200009, 36.30292389500005],
              [33.989268425000034, 36.281683661000045],
              [33.994802280000044, 36.283270575000074],
              [33.99830162900008, 36.286037502000056],
              [33.99586022200009, 36.27952708500004],
              [33.97706139400009, 36.259426174000055],
              [33.968760613000086, 36.24689362200007],
              [33.965179884000065, 36.23236725500004],
              [33.96436608200008, 36.22052643400008],
              [33.958994988000086, 36.21356842700004],
              [33.941416863000086, 36.21336497600004],
              [33.941416863000086, 36.219631252000056],
              [33.95093834700009, 36.23769765800006],
              [33.945974155000044, 36.26520416900007],
              [33.93091881600009, 36.29047272300005],
              [33.91041100400008, 36.30149974200009],
              [33.895274285000085, 36.305568752000056],
              [33.883148634000065, 36.312486070000034],
              [33.871104363000086, 36.314886786000045],
              [33.855479363000086, 36.30491771000004],
              [33.83765709700009, 36.28042226800005],
              [33.82789147200009, 36.27171458500004],
              [33.81104576900009, 36.26740143400008],
              [33.818695509000065, 36.26577383000006],
              [33.82178795700008, 36.26398346600007],
              [33.82471764400009, 36.25991445500006],
              [33.81373131600009, 36.251654364000046],
              [33.79908287900008, 36.23065827000005],
              [33.78687584700009, 36.22638580900008],
              [33.77702884200005, 36.225043036000045],
              [33.742849155000044, 36.21336497600004],
              [33.73560631600009, 36.20872630400004],
              [33.70525149800005, 36.181708075000074],
              [33.70036868600005, 36.171128648000035],
              [33.69385826900009, 36.14411041900007],
              [33.688243035000085, 36.13703034100007],
              [33.68531334700009, 36.14321523600006],
              [33.66032962300005, 36.17487213700008],
              [33.656586134000065, 36.188666083000044],
              [33.647227410000085, 36.192572333000044],
              [33.63412519600007, 36.190334377000056],
              [33.619883660000085, 36.18545156500005],
              [33.59652754000007, 36.16876862200007],
              [33.57406660200007, 36.14476146000004],
              [33.55225670700008, 36.12750885600008],
              [33.53052819100009, 36.13080475500004],
              [33.54420006600009, 36.13703034100007],
              [33.54420006600009, 36.14447663000004],
              [33.52100670700008, 36.14663320500006],
              [33.47828209700009, 36.155951239000046],
              [33.45826256600009, 36.15814850500004],
              [33.43669681100005, 36.15468984600005],
              [33.401133660000085, 36.139837958000044],
              [33.38648522200009, 36.13703034100007],
              [33.34782962300005, 36.14789459800005],
              [33.326833530000044, 36.150091864000046],
              [33.30836022200009, 36.13222890800006],
              [33.28646894600007, 36.12995026200008],
              [33.24195397200009, 36.13080475500004],
              [33.21241295700008, 36.12409088700008],
              [33.20093834700009, 36.12335846600007],
              [33.18864993600005, 36.12579987200007],
              [33.16724694100009, 36.13495514500005],
              [33.156911655000044, 36.13703034100007],
              [33.13404381600009, 36.13178131700005],
              [33.121429884000065, 36.11908600500004],
              [33.11215254000007, 36.10342031500005],
              [33.098643425000034, 36.08926015800006],
              [33.08773847700007, 36.08283112200007],
              [33.08375084700009, 36.08274974200009],
              [33.080414259000065, 36.08588288000004],
              [33.07113691500007, 36.08926015800006],
              [33.05836022200009, 36.09064362200007],
              [33.02686608200008, 36.08926015800006],
              [32.96045983200008, 36.10268789300005],
              [32.94092858200008, 36.103501695000034],
              [32.87671959700009, 36.07514069200005],
              [32.865244988000086, 36.07184479400007],
              [32.85670006600009, 36.060980536000045],
              [32.803721550000034, 36.02716705900008],
              [32.76059004000007, 36.02948639500005],
              [32.670664910000085, 36.04669830900008],
              [32.63233483200008, 36.06195709800005],
              [32.57178795700008, 36.09398021000004],
              [32.56788170700008, 36.09609609600005],
              [32.53142337300005, 36.098822333000044],
              [32.51343834700009, 36.10301341400009],
              [32.43726647200009, 36.138657945000034],
              [32.42701256600009, 36.14760976800005],
              [32.41960696700005, 36.159491278000075],
              [32.40202884200005, 36.16551341400009],
              [32.381521030000044, 36.17015208500004],
              [32.36548912900008, 36.17796458500004],
              [32.318695509000065, 36.228583075000074],
              [32.31031334700009, 36.22947825700004],
              [32.30591881600009, 36.23456452000005],
              [32.28728274800005, 36.24481842700004],
              [32.28296959700009, 36.25063711100006],
              [32.27898196700005, 36.27903880400004],
              [32.276133660000085, 36.28782786700009],
              [32.252696160000085, 36.315334377000056],
              [32.192149285000085, 36.35838450700004],
              [32.17994225400008, 36.387152411000045],
              [32.178396030000044, 36.39533112200007],
              [32.17432701900009, 36.402411200000074],
              [32.162852410000085, 36.41478099200009],
              [32.15162194100009, 36.43032461100006],
              [32.148448113000086, 36.433661200000074],
              [32.13502037900008, 36.43821849200009],
              [32.13209069100009, 36.438666083000044],
              [32.11451256600009, 36.46967194200005],
              [32.10206139400009, 36.48615143400008],
              [32.08716881600009, 36.49331289300005],
              [32.026052280000044, 36.54344310100004],
              [32.01880944100009, 36.546535549000055],
              [32.01002037900008, 36.547756252000056],
              [31.998708530000044, 36.54791901200008],
              [31.987803582000083, 36.54995351800005],
              [31.98015384200005, 36.554388739000046],
              [31.974131707000083, 36.55898672100005],
              [31.968272332000083, 36.56159088700008],
              [31.928070509000065, 36.560248114000046],
              [31.90796959700009, 36.56264883000006],
              [31.899424675000034, 36.57245514500005],
              [31.88803144600007, 36.58112213700008],
              [31.862478061000047, 36.58869049700007],
              [31.834646030000044, 36.59235260600008],
              [31.816742384000065, 36.589504299000055],
              [31.807383660000085, 36.59682851800005],
              [31.769053582000083, 36.61001211100006],
              [31.74935957100007, 36.63226959800005],
              [31.736582879000082, 36.642279364000046],
              [31.72429446700005, 36.64101797100005],
              [31.703461134000065, 36.64362213700008],
              [31.627614780000044, 36.67084381700005],
              [31.61068769600007, 36.68203359600005],
              [31.59620201900009, 36.69570547100005],
              [31.40756269600007, 36.76341380400004],
              [31.37859134200005, 36.767645575000074],
              [31.37631269600007, 36.79193756700005],
              [31.340830925000034, 36.808579820000034],
              [30.939707879000082, 36.85700104400007],
              [30.77588951900009, 36.84955475500004],
              [30.748057488000086, 36.85565827000005],
              [30.726898634000065, 36.86587148600006],
              [30.686534050000034, 36.89118073100008],
              [30.62859134200005, 36.85956452000005],
              [30.601735873000052, 36.83812083500004],
              [30.58765709700009, 36.807074286000045],
              [30.574473504000082, 36.78953685100004],
              [30.569834832000083, 36.781317450000074],
              [30.569834832000083, 36.75055573100008],
              [30.564626498000052, 36.717962958000044],
              [30.56576582100007, 36.70018138200004],
              [30.57667076900009, 36.68512604400007],
              [30.57667076900009, 36.678900458000044],
              [30.56885826900009, 36.67059967700004],
              [30.562673373000052, 36.662543036000045],
              [30.55836022200009, 36.652329820000034],
              [30.556162957000083, 36.637884833000044],
              [30.557871941000087, 36.61961497600004],
              [30.56381269600007, 36.60932038000004],
              [30.571055535000085, 36.60114166900007],
              [30.57667076900009, 36.589504299000055],
              [30.583506707000083, 36.59634023600006],
              [30.581065300000034, 36.57518138200004],
              [30.567230665000068, 36.53986237200007],
              [30.569834832000083, 36.52802155200004],
              [30.535980665000068, 36.505194403000075],
              [30.52084394600007, 36.48973216400009],
              [30.508799675000034, 36.454291083000044],
              [30.486989780000044, 36.426947333000044],
              [30.48796634200005, 36.41815827000005],
              [30.474619988000086, 36.401597398000035],
              [30.47632897200009, 36.38422272300005],
              [30.487152540000068, 36.37026601800005],
              [30.50163821700005, 36.36359284100007],
              [30.494151238000086, 36.349310614000046],
              [30.519867384000065, 36.341864325000074],
              [30.50562584700009, 36.327378648000035],
              [30.478770379000082, 36.308579820000034],
              [30.466807488000086, 36.28782786700009],
              [30.473643425000034, 36.28782786700009],
              [30.47820071700005, 36.292303778000075],
              [30.478851759000065, 36.29193756700005],
              [30.480642123000052, 36.28953685100004],
              [30.48796634200005, 36.28782786700009],
              [30.477793816000087, 36.27948639500005],
              [30.463877800000034, 36.271144924000055],
              [30.45167076900009, 36.261786200000074],
              [30.44076582100007, 36.23932526200008],
              [30.42741946700005, 36.22638580900008],
              [30.398610873000052, 36.205959377000056],
              [30.400401238000086, 36.248114325000074],
              [30.396006707000083, 36.26552969000005],
              [30.384287957000083, 36.27423737200007],
              [30.360524936000047, 36.26862213700008],
              [30.254567905000044, 36.308294989000046],
              [30.23373457100007, 36.30890534100007],
              [30.158539259000065, 36.29865143400008],
              [30.149261915000068, 36.28986237200007],
              [30.145518425000034, 36.27513255400004],
              [30.144704623000052, 36.254339911000045],
              [30.13843834700009, 36.254339911000045],
              [30.13721764400009, 36.260646877000056],
              [30.131032748000052, 36.27423737200007],
              [30.12476647200009, 36.255072333000044],
              [30.12476647200009, 36.24689362200007],
              [30.110606316000087, 36.254339911000045],
              [30.11109459700009, 36.24721914300005],
              [30.110606316000087, 36.24005768400008],
              [30.073008660000085, 36.24689362200007],
              [30.065603061000047, 36.24994538000004],
              [30.057871941000087, 36.25560130400004],
              [30.04818769600007, 36.25877513200004],
              [30.03484134200005, 36.254339911000045],
              [30.055918816000087, 36.254339911000045],
              [30.055918816000087, 36.24689362200007],
              [29.988454623000052, 36.21775950700004],
              [29.973399285000085, 36.219631252000056],
              [29.961273634000065, 36.21385325700004],
              [29.950043165000068, 36.21442291900007],
              [29.938324415000068, 36.217678127000056],
              [29.92554772200009, 36.219631252000056],
              [29.91651451900009, 36.21906159100007],
              [29.911631707000083, 36.21702708500004],
              [29.89820397200009, 36.205959377000056],
              [29.88135826900009, 36.198431708000044],
              [29.844004754000082, 36.191392320000034],
              [29.830088738000086, 36.18545156500005],
              [29.83334394600007, 36.184475002000056],
              [29.836110873000052, 36.18427155200004],
              [29.83757571700005, 36.182847398000035],
              [29.836924675000034, 36.17796458500004],
              [29.827321811000047, 36.17804596600007],
              [29.802582227000073, 36.17182038000004],
              [29.802582227000073, 36.16498444200005],
              [29.823090040000068, 36.16498444200005],
              [29.809580925000034, 36.153998114000046],
              [29.795258009000065, 36.14520905200004],
              [29.779551629000082, 36.13934967700004],
              [29.761729363000086, 36.13703034100007],
              [29.761729363000086, 36.14447663000004],
              [29.76726321700005, 36.147772528000075],
              [29.770192905000044, 36.150824286000045],
              [29.772227410000085, 36.15420156500005],
              [29.775401238000086, 36.15814850500004],
              [29.762380405000044, 36.15656159100007],
              [29.759287957000083, 36.15501536700009],
              [29.754893425000034, 36.15070221600007],
              [29.743418816000087, 36.16095612200007],
              [29.731455925000034, 36.16425202000005],
              [29.71924889400009, 36.16266510600008],
              [29.707041863000086, 36.15814850500004],
              [29.703868035000085, 36.15444570500006],
              [29.703135613000086, 36.14996979400007],
              [29.699961785000085, 36.146144924000055],
              [29.689300977000073, 36.14447663000004],
              [29.688731316000087, 36.14126211100006],
              [29.67237389400009, 36.12335846600007],
              [29.668223504000082, 36.143784898000035],
              [29.633962436000047, 36.15704987200007],
              [29.623871290000068, 36.17796458500004],
              [29.637380405000044, 36.17243073100008],
              [29.643239780000044, 36.17792389500005],
              [29.642100457000083, 36.18695709800005],
              [29.63453209700009, 36.19163646000004],
              [29.583506707000083, 36.18545156500005],
              [29.583506707000083, 36.19163646000004],
              [29.592539910000085, 36.19578685100004],
              [29.602305535000085, 36.19867584800005],
              [29.61296634200005, 36.19985586100006],
              [29.623871290000068, 36.19912344000005],
              [29.602224155000044, 36.207017320000034],
              [29.521494988000086, 36.205959377000056],
              [29.494476759000065, 36.211004950000074],
              [29.43213951900009, 36.24005768400008],
              [29.42042076900009, 36.23061758000006],
              [29.415212436000047, 36.23973216400009],
              [29.411631707000083, 36.26740143400008],
              [29.405772332000083, 36.26015859600005],
              [29.401866082000083, 36.261786200000074],
              [29.39812259200005, 36.26618073100008],
              [29.391856316000087, 36.26740143400008],
              [29.381602410000085, 36.26390208500004],
              [29.377614780000044, 36.26162344000005],
              [29.375254754000082, 36.25885651200008],
              [29.369965040000068, 36.254339911000045],
              [29.36491946700005, 36.24827708500004],
              [29.361338738000086, 36.241522528000075],
              [29.35710696700005, 36.235663153000075],
              [29.349619988000086, 36.23261139500005],
              [29.340830925000034, 36.23737213700008],
              [29.334727410000085, 36.247707424000055],
              [29.329356316000087, 36.25409577000005],
              [29.322276238000086, 36.24689362200007],
              [29.261241082000083, 36.29356517100007],
              [29.256683790000068, 36.29702383000006],
              [29.24781334700009, 36.311712958000044],
              [29.234629754000082, 36.324286200000074],
              [29.174978061000047, 36.339829820000034],
              [29.158457879000082, 36.356756903000075],
              [29.144704623000052, 36.349310614000046],
              [29.140798373000052, 36.36245351800005],
              [29.141774936000047, 36.36542389500005],
              [29.144704623000052, 36.36977773600006],
              [29.144704623000052, 36.37718333500004],
              [29.11687259200005, 36.37718333500004],
              [29.124278191000087, 36.38344961100006],
              [29.112803582000083, 36.38939036700009],
              [29.106211785000085, 36.39085521000004],
              [29.096364780000044, 36.39093659100007],
              [29.101410352000073, 36.40021393400008],
              [29.10906009200005, 36.40648021000004],
              [29.11890709700009, 36.41010163000004],
              [29.130381707000083, 36.411363023000035],
              [29.129893425000034, 36.41596100500004],
              [29.129161004000082, 36.416896877000056],
              [29.127696160000085, 36.41681549700007],
              [29.124278191000087, 36.41815827000005],
              [29.130137566000087, 36.43650950700004],
              [29.124196811000047, 36.45359935100004],
              [29.111338738000086, 36.466782945000034],
              [29.096364780000044, 36.47345612200007],
              [29.096364780000044, 36.47964101800005],
              [29.109548373000052, 36.48851146000004],
              [29.115570509000065, 36.49135976800005],
              [29.124278191000087, 36.49331289300005],
              [29.124278191000087, 36.50079987200007],
              [29.120290561000047, 36.53563060100004],
              [29.11491946700005, 36.55267975500004],
              [29.103770379000082, 36.54791901200008],
              [29.096364780000044, 36.54791901200008],
              [29.084320509000065, 36.560248114000046],
              [29.036387566000087, 36.54531484600005],
              [29.014414910000085, 36.54791901200008],
              [29.032725457000083, 36.55182526200008],
              [29.03687584700009, 36.56146881700005],
              [29.031423373000052, 36.57477448100008],
              [29.020518425000034, 36.589504299000055],
              [29.026133660000085, 36.59625885600008],
              [29.035004102000073, 36.61469147300005],
              [29.041758660000085, 36.624253648000035],
              [29.055837436000047, 36.61424388200004],
              [29.068207227000073, 36.623928127000056],
              [29.080902540000068, 36.63861725500004],
              [29.096364780000044, 36.64411041900007],
              [29.096364780000044, 36.637884833000044],
              [29.090586785000085, 36.62710195500006],
              [29.098806186000047, 36.62360260600008],
              [29.110606316000087, 36.62636953300006],
              [29.11687259200005, 36.63422272300005],
              [29.114512566000087, 36.64313385600008],
              [29.109222852000073, 36.652004299000055],
              [29.102386915000068, 36.65961334800005],
              [29.096364780000044, 36.665228583000044],
              [29.034190300000034, 36.70099518400008],
              [28.956309441000087, 36.72752513200004],
              [28.946136915000068, 36.73696523600006],
              [28.938975457000083, 36.751288153000075],
              [28.922699415000068, 36.74135976800005],
              [28.904144727000073, 36.72304922100005],
              [28.890879754000082, 36.71238841400009],
              [28.890879754000082, 36.70620351800005],
              [28.897715691000087, 36.70620351800005],
              [28.897715691000087, 36.69936758000006],
              [28.878916863000086, 36.69806549700007],
              [28.87086022200009, 36.69623444200005],
              [28.863536004000082, 36.692572333000044],
              [28.860036655000044, 36.68423086100006],
              [28.86264082100007, 36.675116278000075],
              [28.862478061000047, 36.66791413000004],
              [28.849945509000065, 36.665228583000044],
              [28.854991082000083, 36.65664297100005],
              [28.85792076900009, 36.65375397300005],
              [28.863536004000082, 36.65094635600008],
              [28.85678144600007, 36.64411041900007],
              [28.86687259200005, 36.63491445500006],
              [28.870371941000087, 36.630519924000055],
              [28.87663821700005, 36.630519924000055],
              [28.882334832000083, 36.640611070000034],
              [28.88803144600007, 36.648423570000034],
              [28.890147332000083, 36.65761953300006],
              [28.884043816000087, 36.67145416900007],
              [28.90170332100007, 36.658270575000074],
              [28.895355665000068, 36.64142487200007],
              [28.878428582000083, 36.62592194200005],
              [28.863536004000082, 36.616848049000055],
              [28.86963951900009, 36.606634833000044],
              [28.85873457100007, 36.60130442900004],
              [28.84156334700009, 36.60016510600008],
              [28.828868035000085, 36.60252513200004],
              [28.818614129000082, 36.61172109600005],
              [28.818614129000082, 36.620794989000046],
              [28.827159050000034, 36.62775299700007],
              [28.842539910000085, 36.630519924000055],
              [28.842539910000085, 36.637884833000044],
              [28.825450066000087, 36.64472077000005],
              [28.815196160000085, 36.65180084800005],
              [28.805023634000065, 36.65525950700004],
              [28.787852410000085, 36.65094635600008],
              [28.782725457000083, 36.677394924000055],
              [28.746348504000082, 36.697699286000045],
              [28.70167076900009, 36.705064195000034],
              [28.671722852000073, 36.692572333000044],
              [28.664886915000068, 36.692572333000044],
              [28.65992272200009, 36.711004950000074],
              [28.649180535000085, 36.71832916900007],
              [28.635915561000047, 36.714504299000055],
              [28.623383009000065, 36.69936758000006],
              [28.616221550000034, 36.705959377000056],
              [28.603526238000086, 36.73354726800005],
              [28.612559441000087, 36.74713776200008],
              [28.616709832000083, 36.76699453300006],
              [28.614105665000068, 36.78534577000005],
              [28.603526238000086, 36.794989325000074],
              [28.603037957000083, 36.79962799700007],
              [28.604502800000034, 36.800848700000074],
              [28.60718834700009, 36.800848700000074],
              [28.610362175000034, 36.80174388200004],
              [28.608409050000034, 36.804754950000074],
              [28.606293165000068, 36.80687083500004],
              [28.606211785000085, 36.81012604400007],
              [28.610362175000034, 36.816066799000055],
              [28.603526238000086, 36.816066799000055],
              [28.598887566000087, 36.80687083500004],
              [28.59742272200009, 36.80255768400008],
              [28.596690300000034, 36.794989325000074],
              [28.591075066000087, 36.79901764500005],
              [28.590993686000047, 36.80019765800006],
              [28.588552280000044, 36.80801015800006],
              [28.57585696700005, 36.819525458000044],
              [28.546153191000087, 36.823431708000044],
              [28.524424675000034, 36.81329987200007],
              [28.52784264400009, 36.788763739000046],
              [28.517751498000052, 36.79564036700009],
              [28.507985873000052, 36.79767487200007],
              [28.497894727000073, 36.798488674000055],
              [28.48682701900009, 36.80174388200004],
              [28.50049889400009, 36.808579820000034],
              [28.50049889400009, 36.816066799000055],
              [28.478037957000083, 36.81598541900007],
              [28.463877800000034, 36.81875234600005],
              [28.456065300000034, 36.82851797100005],
              [28.452647332000083, 36.84955475500004],
              [28.45948326900009, 36.84910716400009],
              [28.464121941000087, 36.84992096600007],
              [28.466319207000083, 36.85333893400008],
              [28.465179884000065, 36.859361070000034],
              [28.46257571700005, 36.86204661700009],
              [28.460134311000047, 36.86375560100004],
              [28.458832227000073, 36.86692942900004],
              [28.45671634200005, 36.87750885600008],
              [28.451996290000068, 36.88361237200007],
              [28.447438998000052, 36.88304271000004],
              [28.445160352000073, 36.87376536700009],
              [28.436208530000044, 36.86473216400009],
              [28.416188998000052, 36.85968659100007],
              [28.38721764400009, 36.85700104400007],
              [28.37671959700009, 36.85443756700005],
              [28.37745201900009, 36.84837474200009],
              [28.383799675000034, 36.84137604400007],
              [28.390635613000086, 36.835923570000034],
              [28.396739129000082, 36.83539459800005],
              [28.405121290000068, 36.837551174000055],
              [28.414724155000044, 36.837103583000044],
              [28.424815300000034, 36.82908763200004],
              [28.414235873000052, 36.81460195500006],
              [28.406504754000082, 36.79975006700005],
              [28.396006707000083, 36.789496161000045],
              [28.376963738000086, 36.788763739000046],
              [28.324961785000085, 36.81012604400007],
              [28.31495201900009, 36.816066799000055],
              [28.308767123000052, 36.816066799000055],
              [28.312836134000065, 36.80036041900007],
              [28.31495201900009, 36.794989325000074],
              [28.288584832000083, 36.79368724200009],
              [28.278168165000068, 36.79645416900007],
              [28.27393639400009, 36.80516185100004],
              [28.278330925000034, 36.814154364000046],
              [28.288910352000073, 36.818426825000074],
              [28.31495201900009, 36.822251695000034],
              [28.31495201900009, 36.82908763200004],
              [28.302744988000086, 36.83567942900004],
              [28.288584832000083, 36.84589264500005],
              [28.27312259200005, 36.851996161000045],
              [28.25717207100007, 36.84617747600004],
              [28.243174675000034, 36.829779364000046],
              [28.236664259000065, 36.81321849200009],
              [28.239512566000087, 36.798814195000034],
              [28.253428582000083, 36.788763739000046],
              [28.248871290000068, 36.766831773000035],
              [28.288584832000083, 36.74258047100005],
              [28.295095248000052, 36.71987539300005],
              [28.283050977000073, 36.726629950000074],
              [28.26726321700005, 36.730902411000045],
              [28.253103061000047, 36.727850653000075],
              [28.24659264400009, 36.71238841400009],
              [28.24000084700009, 36.71548086100006],
              [28.233571811000047, 36.71987539300005],
              [28.233246290000068, 36.71503327000005],
              [28.231944207000083, 36.71185944200005],
              [28.229502800000034, 36.70929596600007],
              [28.225433790000068, 36.70620351800005],
              [28.230316602000073, 36.704738674000055],
              [28.231618686000047, 36.70457591400009],
              [28.233571811000047, 36.69936758000006],
              [28.181895379000082, 36.68463776200008],
              [28.162282748000052, 36.67267487200007],
              [28.14429772200009, 36.65094635600008],
              [28.130707227000073, 36.628973700000074],
              [28.111501498000052, 36.60419342700004],
              [28.088145379000082, 36.589056708000044],
              [28.061696811000047, 36.59634023600006],
              [28.057871941000087, 36.58999258000006],
              [28.055023634000065, 36.58657461100006],
              [28.050629102000073, 36.58466217700004],
              [28.041840040000068, 36.58270905200004],
              [28.043955925000034, 36.57949453300006],
              [28.046153191000087, 36.57249583500004],
              [28.048024936000047, 36.56903717700004],
              [28.035899285000085, 36.56476471600007],
              [28.02588951900009, 36.563706773000035],
              [28.018321160000085, 36.56704336100006],
              [28.013845248000052, 36.575873114000046],
              [28.00367272200009, 36.56191640800006],
              [27.990896030000044, 36.559759833000044],
              [27.977712436000047, 36.565741278000075],
              [27.966075066000087, 36.575873114000046],
              [27.968028191000087, 36.57892487200007],
              [27.970876498000052, 36.58641185100004],
              [27.972911004000082, 36.589504299000055],
              [27.967621290000068, 36.59259674700007],
              [27.96461022200009, 36.59564850500004],
              [27.959239129000082, 36.60252513200004],
              [28.034434441000087, 36.60252513200004],
              [28.053965691000087, 36.60960521000004],
              [28.065440300000034, 36.61953359600005],
              [28.075368686000047, 36.63125234600005],
              [28.08961022200009, 36.64411041900007],
              [28.07593834700009, 36.65778229400007],
              [28.056651238000086, 36.643011786000045],
              [28.048024936000047, 36.637884833000044],
              [28.048024936000047, 36.64411041900007],
              [28.057790561000047, 36.652777411000045],
              [28.061208530000044, 36.66474030200004],
              [28.05795332100007, 36.676662502000056],
              [28.048024936000047, 36.68512604400007],
              [28.037933790000068, 36.690619208000044],
              [28.035329623000052, 36.687567450000074],
              [28.034434441000087, 36.67519765800006],
              [28.029633009000065, 36.670355536000045],
              [28.01889082100007, 36.67133209800005],
              [28.007334832000083, 36.67519765800006],
              [28.000173373000052, 36.678900458000044],
              [27.991465691000087, 36.675848700000074],
              [27.98015384200005, 36.675848700000074],
              [27.970225457000083, 36.67983633000006],
              [27.966075066000087, 36.688788153000075],
              [27.97120201900009, 36.69253164300005],
              [28.007009311000047, 36.69936758000006],
              [28.000173373000052, 36.70620351800005],
              [28.021332227000073, 36.705064195000034],
              [28.027517123000052, 36.70620351800005],
              [28.032237175000034, 36.70921458500004],
              [28.038259311000047, 36.714056708000044],
              [28.042491082000083, 36.718451239000046],
              [28.041840040000068, 36.71987539300005],
              [28.07976321700005, 36.72207265800006],
              [28.08961022200009, 36.72671133000006],
              [28.085948113000086, 36.710598049000055],
              [28.100596550000034, 36.70962148600006],
              [28.116384311000047, 36.718817450000074],
              [28.11687259200005, 36.73354726800005],
              [28.107432488000086, 36.73920319200005],
              [28.08765709700009, 36.74087148600006],
              [28.082204623000052, 36.74713776200008],
              [28.084157748000052, 36.75372955900008],
              [28.091644727000073, 36.75934479400007],
              [28.10328209700009, 36.767645575000074],
              [28.110036655000044, 36.775091864000046],
              [28.113454623000052, 36.76821523600006],
              [28.117523634000065, 36.76386139500005],
              [28.13054446700005, 36.753973700000074],
              [28.125254754000082, 36.77130768400008],
              [28.123708530000044, 36.791896877000056],
              [28.118418816000087, 36.80060455900008],
              [28.106700066000087, 36.80296458500004],
              [28.094981316000087, 36.80141836100006],
              [28.086273634000065, 36.79669830900008],
              [28.069102410000085, 36.775091864000046],
              [28.047211134000065, 36.763332424000055],
              [28.039317254000082, 36.76447174700007],
              [28.034434441000087, 36.775091864000046],
              [28.019704623000052, 36.76312897300005],
              [27.980723504000082, 36.75381094000005],
              [27.966075066000087, 36.74713776200008],
              [27.959239129000082, 36.74713776200008],
              [27.954112175000034, 36.75958893400008],
              [27.94467207100007, 36.75625234600005],
              [27.932302280000044, 36.74656810100004],
              [27.91765384200005, 36.74038320500006],
              [27.912445509000065, 36.75413646000004],
              [27.905446811000047, 36.75287506700005],
              [27.897715691000087, 36.745347398000035],
              [27.89031009200005, 36.74038320500006],
              [27.883148634000065, 36.743841864000046],
              [27.876800977000073, 36.75079987200007],
              [27.870371941000087, 36.75259023600006],
              [27.86304772200009, 36.74038320500006],
              [27.856211785000085, 36.74038320500006],
              [27.843760613000086, 36.748928127000056],
              [27.826182488000086, 36.757473049000055],
              [27.806488477000073, 36.76080963700008],
              [27.787852410000085, 36.753973700000074],
              [27.787852410000085, 36.76080963700008],
              [27.776052280000044, 36.755926825000074],
              [27.764496290000068, 36.75649648600006],
              [27.75171959700009, 36.75922272300005],
              [27.73609459700009, 36.76080963700008],
              [27.719411655000044, 36.75625234600005],
              [27.698496941000087, 36.73419830900008],
              [27.684255405000044, 36.72671133000006],
              [27.684255405000044, 36.71987539300005],
              [27.68685957100007, 36.71112702000005],
              [27.673106316000087, 36.67963288000004],
              [27.671153191000087, 36.65778229400007],
              [27.637950066000087, 36.67133209800005],
              [27.619883660000085, 36.67645905200004],
              [27.603037957000083, 36.678900458000044],
              [27.585134311000047, 36.677069403000075],
              [27.570323113000086, 36.673814195000034],
              [27.559743686000047, 36.67462799700007],
              [27.554535352000073, 36.68512604400007],
              [27.486338738000086, 36.665228583000044],
              [27.481944207000083, 36.65835195500006],
              [27.477712436000047, 36.65346914300005],
              [27.472666863000086, 36.65094635600008],
              [27.468028191000087, 36.65298086100006],
              [27.455739780000044, 36.66290924700007],
              [27.448415561000047, 36.665228583000044],
              [27.425629102000073, 36.66864655200004],
              [27.41578209700009, 36.66901276200008],
              [27.404307488000086, 36.665228583000044],
              [27.40202884200005, 36.67747630400004],
              [27.394053582000083, 36.68414948100008],
              [27.382985873000052, 36.684759833000044],
              [27.370290561000047, 36.678900458000044],
              [27.370616082000083, 36.68317291900007],
              [27.369151238000086, 36.684475002000056],
              [27.366384311000047, 36.684475002000056],
              [27.362803582000083, 36.68512604400007],
              [27.368662957000083, 36.69135163000004],
              [27.368662957000083, 36.69741445500006],
              [27.364024285000085, 36.70258209800005],
              [27.355804884000065, 36.70620351800005],
              [27.355804884000065, 36.71238841400009],
              [27.368337436000047, 36.708238023000035],
              [27.384776238000086, 36.70502350500004],
              [27.401621941000087, 36.704738674000055],
              [27.414317254000082, 36.70929596600007],
              [27.423106316000087, 36.71967194200005],
              [27.427256707000083, 36.735663153000075],
              [27.438487175000034, 36.74713776200008],
              [27.449554884000065, 36.753973700000074],
              [27.458832227000073, 36.75568268400008],
              [27.483164910000085, 36.753973700000074],
              [27.556651238000086, 36.76268138200004],
              [27.592458530000044, 36.76080963700008],
              [27.611501498000052, 36.765326239000046],
              [27.61695397200009, 36.77619049700007],
              [27.617849155000044, 36.78961823100008],
              [27.623383009000065, 36.80174388200004],
              [27.645355665000068, 36.80646393400008],
              [27.69117272200009, 36.78432851800005],
              [27.705414259000065, 36.788763739000046],
              [27.72120201900009, 36.781683661000045],
              [27.735199415000068, 36.782416083000044],
              [27.748220248000052, 36.784409898000035],
              [27.760020379000082, 36.781317450000074],
              [27.78565514400009, 36.80109284100007],
              [27.799082879000082, 36.806626695000034],
              [27.88648522200009, 36.80882396000004],
              [27.897146030000044, 36.81232330900008],
              [27.90365644600007, 36.80581289300005],
              [27.91968834700009, 36.799709377000056],
              [27.93995201900009, 36.79564036700009],
              [27.959239129000082, 36.794989325000074],
              [27.994151238000086, 36.79840729400007],
              [28.010508660000085, 36.79433828300006],
              [28.027517123000052, 36.781317450000074],
              [28.030772332000083, 36.79173411700009],
              [28.03687584700009, 36.79734935100004],
              [28.055430535000085, 36.808579820000034],
              [28.049082879000082, 36.82062409100007],
              [28.03956139400009, 36.82664622600004],
              [28.025726759000065, 36.82880280200004],
              [28.007009311000047, 36.82908763200004],
              [28.013845248000052, 36.835923570000034],
              [28.023285352000073, 36.833238023000035],
              [28.024587436000047, 36.839097398000035],
              [28.018728061000047, 36.84861888200004],
              [28.007009311000047, 36.85700104400007],
              [28.011566602000073, 36.85765208500004],
              [28.014496290000068, 36.859076239000046],
              [28.01734459700009, 36.86107005400004],
              [28.02125084700009, 36.86322663000004],
              [28.02865644600007, 36.86017487200007],
              [28.036306186000047, 36.862616278000075],
              [28.044932488000086, 36.867254950000074],
              [28.055430535000085, 36.87067291900007],
              [28.055430535000085, 36.87689850500004],
              [28.035492384000065, 36.89337799700007],
              [28.027517123000052, 36.90253327000005],
              [28.02125084700009, 36.91160716400009],
              [28.034434441000087, 36.90420156500005],
              [28.041840040000068, 36.91160716400009],
              [28.035899285000085, 36.91461823100008],
              [28.033213738000086, 36.917669989000046],
              [28.031097852000073, 36.92133209800005],
              [28.027517123000052, 36.92593008000006],
              [28.035899285000085, 36.925441799000055],
              [28.05323326900009, 36.92649974200009],
              [28.061696811000047, 36.92593008000006],
              [28.061696811000047, 36.93211497600004],
              [28.041840040000068, 36.93211497600004],
              [28.041840040000068, 36.93891022300005],
              [28.065440300000034, 36.93927643400008],
              [28.075043165000068, 36.93740469000005],
              [28.082204623000052, 36.93211497600004],
              [28.088552280000044, 36.93667226800005],
              [28.09351647200009, 36.93789297100005],
              [28.09815514400009, 36.93622467700004],
              [28.10328209700009, 36.93211497600004],
              [28.110036655000044, 36.93211497600004],
              [28.120127800000034, 36.93768952000005],
              [28.14193769600007, 36.92869700700004],
              [28.15170332100007, 36.93211497600004],
              [28.157237175000034, 36.93211497600004],
              [28.159190300000034, 36.92462799700007],
              [28.165293816000087, 36.91160716400009],
              [28.168142123000052, 36.91681549700007],
              [28.16846764400009, 36.91889069200005],
              [28.167165561000047, 36.920803127000056],
              [28.165293816000087, 36.92593008000006],
              [28.16846764400009, 36.93016185100004],
              [28.168142123000052, 36.93341705900008],
              [28.164235873000052, 36.93618398600006],
              [28.157237175000034, 36.93891022300005],
              [28.157237175000034, 36.94578685100004],
              [28.16651451900009, 36.946926174000055],
              [28.174489780000044, 36.94599030200004],
              [28.180674675000034, 36.94330475500004],
              [28.18523196700005, 36.93891022300005],
              [28.205088738000086, 36.96629466400009],
              [28.212412957000083, 36.973089911000045],
              [28.212412957000083, 36.980536200000074],
              [28.19890384200005, 36.980536200000074],
              [28.206879102000073, 36.99017975500004],
              [28.212412957000083, 37.000433661000045],
              [28.228526238000086, 36.99054596600007],
              [28.24463951900009, 36.98818594000005],
              [28.253103061000047, 36.99371979400007],
              [28.24659264400009, 37.007879950000074],
              [28.300059441000087, 37.02496979400007],
              [28.329600457000083, 37.030462958000044],
              [28.329356316000087, 37.036769924000055],
              [28.32276451900009, 37.043850002000056],
              [28.31495201900009, 37.048814195000034],
              [28.304698113000086, 37.050848700000074],
              [28.17432701900009, 37.035142320000034],
              [28.126231316000087, 37.03587474200009],
              [28.107269727000073, 37.032131252000056],
              [28.110036655000044, 37.021470445000034],
              [28.110036655000044, 37.014105536000045],
              [28.092946811000047, 37.02142975500004],
              [27.986582879000082, 37.035142320000034],
              [27.975596550000034, 37.03229401200008],
              [27.963145379000082, 37.02358633000006],
              [27.951833530000044, 37.021470445000034],
              [27.940928582000083, 37.02220286700009],
              [27.911387566000087, 37.02773672100005],
              [27.886241082000083, 37.02619049700007],
              [27.804698113000086, 37.00458405200004],
              [27.794118686000047, 37.007879950000074],
              [27.787852410000085, 37.007879950000074],
              [27.786387566000087, 37.003566799000055],
              [27.780446811000047, 36.99359772300005],
              [27.772959832000083, 36.99583567900004],
              [27.762868686000047, 36.997300523000035],
              [27.751231316000087, 36.99689362200007],
              [27.739512566000087, 36.99359772300005],
              [27.719737175000034, 37.005194403000075],
              [27.687673373000052, 37.00543854400007],
              [27.655772332000083, 36.996527411000045],
              [27.63648522200009, 36.980536200000074],
              [27.618011915000068, 36.98924388200004],
              [27.59034264400009, 36.99827708500004],
              [27.567149285000085, 36.99664948100008],
              [27.562022332000083, 36.973089911000045],
              [27.53874759200005, 36.98672109600005],
              [27.528330925000034, 36.99127838700008],
              [27.51417076900009, 36.99359772300005],
              [27.48373457100007, 36.99079010600008],
              [27.472666863000086, 36.99359772300005],
              [27.462738477000073, 37.00112539300005],
              [27.444834832000083, 37.02252838700008],
              [27.438487175000034, 37.02773672100005],
              [27.42351321700005, 37.02716705900008],
              [27.408050977000073, 37.016831773000035],
              [27.402354363000086, 37.023871161000045],
              [27.404307488000086, 37.02773672100005],
              [27.396820509000065, 37.02773672100005],
              [27.394786004000082, 37.01829661700009],
              [27.38331139400009, 36.99359772300005],
              [27.37940514400009, 36.99896881700005],
              [27.378916863000086, 37.00071849200009],
              [27.38062584700009, 37.00242747600004],
              [27.38331139400009, 37.007879950000074],
              [27.38184655000009, 37.008978583000044],
              [27.37989342500009, 37.00918203300006],
              [27.37794030000009, 37.010199286000045],
              [27.376475457000083, 37.014105536000045],
              [27.380869988000086, 37.01797109600005],
              [27.381683790000068, 37.01894765800006],
              [27.37989342500009, 37.02090078300006],
              [27.376475457000083, 37.02773672100005],
              [27.367442254000082, 37.022772528000075],
              [27.340993686000047, 37.018459377000056],
              [27.32862389400009, 37.014105536000045],
              [27.32862389400009, 37.007879950000074],
              [27.332692905000044, 36.99705638200004],
              [27.326508009000065, 36.985988674000055],
              [27.314626498000052, 36.97711823100008],
              [27.300629102000073, 36.973089911000045],
              [27.305430535000085, 36.96328359600005],
              [27.308116082000083, 36.959418036000045],
              [27.299001498000052, 36.96149323100008],
              [27.29395592500009, 36.96161530200004],
              [27.286957227000073, 36.959418036000045],
              [27.28093509200005, 36.966864325000074],
              [27.263194207000083, 36.96336497600004],
              [27.252696160000085, 36.97833893400008],
              [27.24740644600007, 37.00023021000004],
              [27.246104363000086, 37.01776764500005],
              [27.24122155000009, 37.034369208000044],
              [27.232432488000086, 37.047308661000045],
              [27.228770379000082, 37.061835028000075],
              [27.239105665000068, 37.08295319200005],
              [27.24773196700005, 37.08344147300005],
              [27.26417076900009, 37.08901601800005],
              [27.281911655000044, 37.09833405200004],
              [27.294444207000083, 37.11029694200005],
              [27.287445509000065, 37.11542389500005],
              [27.27906334700009, 37.11758047100005],
              [27.27003014400009, 37.11603424700007],
              [27.260427280000044, 37.11029694200005],
              [27.256602410000085, 37.11367422100005],
              [27.25489342500009, 37.116522528000075],
              [27.25294030000009, 37.12396881700005],
              [27.260427280000044, 37.11774323100008],
              [27.271657748000052, 37.12885163000004],
              [27.302989129000082, 37.119574286000045],
              [27.321787957000083, 37.12396881700005],
              [27.32129967500009, 37.13108958500004],
              [27.323496941000087, 37.13886139500005],
              [27.32471764400009, 37.14785390800006],
              [27.321787957000083, 37.15867747600004],
              [27.33253014400009, 37.15619538000004],
              [27.33961022200009, 37.15053945500006],
              [27.343028191000087, 37.141791083000044],
              [27.34229576900009, 37.130113023000035],
              [27.34896894600007, 37.130113023000035],
              [27.354258660000085, 37.14085521000004],
              [27.361582879000082, 37.14862702000005],
              [27.369313998000052, 37.15070221600007],
              [27.376475457000083, 37.14443594000005],
              [27.37940514400009, 37.14667389500005],
              [27.38054446700005, 37.148098049000055],
              [27.381114129000082, 37.14948151200008],
              [27.38331139400009, 37.15184153900009],
              [27.382985873000052, 37.13471100500004],
              [27.386566602000073, 37.130072333000044],
              [27.393809441000087, 37.13080475500004],
              [27.404307488000086, 37.130113023000035],
              [27.412445509000065, 37.12567780200004],
              [27.418223504000082, 37.12124258000006],
              [27.42546634200005, 37.11961497600004],
              [27.438487175000034, 37.12396881700005],
              [27.436208530000044, 37.12124258000006],
              [27.43490644600007, 37.120347398000035],
              [27.43336022200009, 37.11969635600008],
              [27.43100019600007, 37.11774323100008],
              [27.445567254000082, 37.096991278000075],
              [27.459808790000068, 37.089504299000055],
              [27.47510826900009, 37.09251536700009],
              [27.50131269600007, 37.107489325000074],
              [27.522227410000085, 37.11497630400004],
              [27.53101647200009, 37.12083567900004],
              [27.54151451900009, 37.12596263200004],
              [27.565114780000044, 37.12563711100006],
              [27.57553144600007, 37.130113023000035],
              [27.57553144600007, 37.137600002000056],
              [27.562347852000073, 37.13580963700008],
              [27.55909264400009, 37.13434479400007],
              [27.554535352000073, 37.130113023000035],
              [27.547211134000065, 37.161810614000046],
              [27.53956139400009, 37.17829010600008],
              [27.52784264400009, 37.18537018400008],
              [27.52784264400009, 37.19281647300005],
              [27.57471764400009, 37.201157945000034],
              [27.58765709700009, 37.19879791900007],
              [27.57553144600007, 37.17853424700007],
              [27.586680535000085, 37.18146393400008],
              [27.594737175000034, 37.18593984600005],
              [27.60987389400009, 37.199652411000045],
              [27.59424889400009, 37.204291083000044],
              [27.588552280000044, 37.21112702000005],
              [27.589366082000083, 37.23069896000004],
              [27.591644727000073, 37.23505280200004],
              [27.604258660000085, 37.242254950000074],
              [27.60987389400009, 37.24746328300006],
              [27.612803582000083, 37.25462474200009],
              [27.614024285000085, 37.26752350500004],
              [27.615977410000085, 37.274725653000075],
              [27.603770379000082, 37.28148021000004],
              [27.603037957000083, 37.28217194200005],
              [27.594411655000044, 37.28384023600006],
              [27.592051629000082, 37.28107330900008],
              [27.59156334700009, 37.277004299000055],
              [27.589366082000083, 37.274725653000075],
              [27.564789259000065, 37.27553945500006],
              [27.55323326900009, 37.27293528900009],
              [27.548350457000083, 37.264837958000044],
              [27.543223504000082, 37.24982330900008],
              [27.530528191000087, 37.236314195000034],
              [27.514659050000034, 37.22931549700007],
              [27.500010613000086, 37.23383209800005],
              [27.517751498000052, 37.24599844000005],
              [27.519867384000065, 37.259100653000075],
              [27.508799675000034, 37.26805247600004],
              [27.486338738000086, 37.26788971600007],
              [27.483164910000085, 37.264105536000045],
              [27.473643425000034, 37.25641510600008],
              [27.463633660000085, 37.252020575000074],
              [27.458832227000073, 37.25800202000005],
              [27.46143639400009, 37.26752350500004],
              [27.467946811000047, 37.277004299000055],
              [27.486338738000086, 37.29523346600007],
              [27.485118035000085, 37.30304596600007],
              [27.49000084700009, 37.313788153000075],
              [27.491384311000047, 37.327337958000044],
              [27.48015384200005, 37.34369538000004],
              [27.472666863000086, 37.34369538000004],
              [27.46851647200009, 37.315619208000044],
              [27.446136915000068, 37.30560944200005],
              [27.418304884000065, 37.309475002000056],
              [27.396820509000065, 37.323146877000056],
              [27.388682488000086, 37.34528229400007],
              [27.396739129000082, 37.36562734600005],
              [27.415212436000047, 37.38165924700007],
              [27.438487175000034, 37.39081452000005],
              [27.426524285000085, 37.405951239000046],
              [27.40723717500009, 37.41274648600006],
              [27.403493686000047, 37.41258372600004],
              [27.386566602000073, 37.41205475500004],
              [27.370290561000047, 37.40509674700007],
              [27.361175977000073, 37.39215729400007],
              [27.35645592500009, 37.37913646000004],
              [27.34620201900009, 37.37059153900009],
              [27.321787957000083, 37.37091705900008],
              [27.321787957000083, 37.36351146000004],
              [27.33643639400009, 37.35569896000004],
              [27.330332879000082, 37.351629950000074],
              [27.271494988000086, 37.34857819200005],
              [27.257660352000073, 37.34454987200007],
              [27.246104363000086, 37.33616771000004],
              [27.23878014400009, 37.34389883000006],
              [27.231700066000087, 37.348089911000045],
              [27.224945509000065, 37.34821198100008],
              [27.218760613000086, 37.34369538000004],
              [27.217051629000082, 37.35097890800006],
              [27.215586785000085, 37.35415273600006],
              [27.21192467500009, 37.35732656500005],
              [27.20411217500009, 37.35293203300006],
              [27.201345248000052, 37.35228099200009],
              [27.19857832100007, 37.35419342700004],
              [27.19076582100007, 37.35732656500005],
              [27.200694207000083, 37.366522528000075],
              [27.20753014400009, 37.37641022300005],
              [27.20948326900009, 37.38694896000004],
              [27.205088738000086, 37.39826080900008],
              [27.22038821700005, 37.403998114000046],
              [27.22624759200005, 37.40509674700007],
              [27.22624759200005, 37.41193268400008],
              [27.217458530000044, 37.431301174000055],
              [27.222504102000073, 37.47675202000005],
              [27.205088738000086, 37.472723700000074],
              [27.199392123000052, 37.478583075000074],
              [27.192637566000087, 37.47866445500006],
              [27.18531334700009, 37.47410716400009],
              [27.177744988000086, 37.46653880400004],
              [27.181895379000082, 37.48334381700005],
              [27.187836134000065, 37.49827708500004],
              [27.19044030000009, 37.51268138200004],
              [27.18458092500009, 37.52802155200004],
              [27.188243035000085, 37.534491278000075],
              [27.184255405000044, 37.538763739000046],
              [27.180430535000085, 37.544582424000055],
              [27.18458092500009, 37.555894273000035],
              [27.200368686000047, 37.54755280200004],
              [27.209320509000065, 37.56329987200007],
              [27.212168816000087, 37.585598049000055],
              [27.208506707000083, 37.596869208000044],
              [27.19385826900009, 37.60101959800005],
              [27.136241082000083, 37.63104889500005],
              [27.048838738000086, 37.65013255400004],
              [27.01148522200009, 37.665716864000046],
              [27.020762566000087, 37.68626536700009],
              [27.038340691000087, 37.69013092700004],
              [27.105479363000086, 37.68626536700009],
              [27.127207879000082, 37.68854401200008],
              [27.213145379000082, 37.71344635600008],
              [27.226410352000073, 37.72093333500004],
              [27.249522332000083, 37.74433014500005],
              [27.256602410000085, 37.75950755400004],
              [27.260508660000085, 37.78196849200009],
              [27.261566602000073, 37.80353424700007],
              [27.260427280000044, 37.81598541900007],
              [27.252696160000085, 37.82526276200008],
              [27.243337436000047, 37.83380768400008],
              [27.237152540000068, 37.84544505400004],
              [27.239105665000068, 37.86440664300005],
              [27.242523634000065, 37.868068752000056],
              [27.25554446700005, 37.87710195500006],
              [27.260427280000044, 37.88422272300005],
              [27.26343834700009, 37.89350006700005],
              [27.26539147200009, 37.901678778000075],
              [27.26465905000009, 37.909816799000055],
              [27.260427280000044, 37.91901276200008],
              [27.27475019600007, 37.929022528000075],
              [27.266286655000044, 37.95136139500005],
              [27.239105665000068, 37.987941799000055],
              [27.214040561000047, 37.98094310100004],
              [27.17750084700009, 37.98094310100004],
              [27.14112389400009, 37.986029364000046],
              [27.116384311000047, 37.99408600500004],
              [27.111175977000073, 37.999701239000046],
              [27.107595248000052, 38.006740627000056],
              [27.101898634000065, 38.01268138200004],
              [27.091807488000086, 38.015285549000055],
              [27.08375084700009, 38.01557038000004],
              [27.07593834700009, 38.01703522300005],
              [27.070160352000073, 38.02000560100004],
              [27.067881707000083, 38.02513255400004],
              [27.064707879000082, 38.04059479400007],
              [27.055918816000087, 38.04572174700007],
              [27.02702884200005, 38.04938385600008],
              [26.975433790000068, 38.06525299700007],
              [26.949229363000086, 38.06736888200004],
              [26.91773522200009, 38.06240469000005],
              [26.90007571700005, 38.05678945500006],
              [26.893402540000068, 38.05621979400007],
              [26.888519727000073, 38.05288320500006],
              [26.885590040000068, 38.04559967700004],
              [26.881521030000044, 38.038397528000075],
              [26.873057488000086, 38.03510163000004],
              [26.86491946700005, 38.040350653000075],
              [26.842051629000082, 38.07607656500005],
              [26.84742272200009, 38.088771877000056],
              [26.846446160000085, 38.10342031500005],
              [26.84156334700009, 38.11823151200008],
              [26.835215691000087, 38.131293036000045],
              [26.825043165000068, 38.144964911000045],
              [26.802989129000082, 38.16242096600007],
              [26.793630405000044, 38.17226797100005],
              [26.776052280000044, 38.165228583000044],
              [26.771494988000086, 38.17747630400004],
              [26.773692254000082, 38.207017320000034],
              [26.76026451900009, 38.21674225500004],
              [26.74463951900009, 38.21564362200007],
              [26.727305535000085, 38.210272528000075],
              [26.708262566000087, 38.207017320000034],
              [26.645762566000087, 38.206732489000046],
              [26.635915561000047, 38.20359935100004],
              [26.622894727000073, 38.138739325000074],
              [26.61817467500009, 38.141506252000056],
              [26.61768639400009, 38.14232005400004],
              [26.615489129000082, 38.144964911000045],
              [26.609222852000073, 38.144964911000045],
              [26.612152540000068, 38.13076406500005],
              [26.612152540000068, 38.11786530200004],
              [26.60710696700005, 38.108303127000056],
              [26.594981316000087, 38.103949286000045],
              [26.588633660000085, 38.10822174700007],
              [26.576833530000044, 38.13271719000005],
              [26.567637566000087, 38.144964911000045],
              [26.567149285000085, 38.12396881700005],
              [26.556895379000082, 38.122300523000035],
              [26.543304884000065, 38.130519924000055],
              [26.523773634000065, 38.14740631700005],
              [26.51734459700009, 38.15566640800006],
              [26.515472852000073, 38.165716864000046],
              [26.51929772200009, 38.179673570000034],
              [26.491709832000083, 38.17401764500005],
              [26.46656334700009, 38.190619208000044],
              [26.442230665000068, 38.21198151200008],
              [26.417491082000083, 38.22064850500004],
              [26.422048373000052, 38.204779364000046],
              [26.424164259000065, 38.20018138200004],
              [26.417491082000083, 38.20018138200004],
              [26.412119988000086, 38.206366278000075],
              [26.390147332000083, 38.223822333000044],
              [26.391856316000087, 38.234035549000055],
              [26.394541863000086, 38.24286530200004],
              [26.394867384000065, 38.251654364000046],
              [26.390147332000083, 38.26166413000004],
              [26.38331139400009, 38.26166413000004],
              [26.375010613000086, 38.234808661000045],
              [26.35401451900009, 38.22825755400004],
              [26.32862389400009, 38.23505280200004],
              [26.296071811000047, 38.25657786700009],
              [26.286631707000083, 38.261053778000075],
              [26.234629754000082, 38.27383047100005],
              [26.233083530000044, 38.28025950700004],
              [26.23878014400009, 38.295803127000056],
              [26.26539147200009, 38.28668854400007],
              [26.27637780000009, 38.300482489000046],
              [26.285899285000085, 38.31867096600007],
              [26.30762780000009, 38.32306549700007],
              [26.30762780000009, 38.330511786000045],
              [26.288910352000073, 38.34064362200007],
              [26.28614342500009, 38.35895416900007],
              [26.294118686000047, 38.36985911700009],
              [26.30762780000009, 38.357855536000045],
              [26.309336785000085, 38.36713288000004],
              [26.311778191000087, 38.371161200000074],
              [26.315684441000087, 38.373480536000045],
              [26.321136915000068, 38.37767161700009],
              [26.32520592500009, 38.36554596600007],
              [26.32593834700009, 38.35492584800005],
              [26.32276451900009, 38.34552643400008],
              [26.314300977000073, 38.33673737200007],
              [26.31934655000009, 38.333644924000055],
              [26.324473504000082, 38.331732489000046],
              [26.33057701900009, 38.33075592700004],
              [26.338633660000085, 38.330511786000045],
              [26.346364780000044, 38.32880280200004],
              [26.348317905000044, 38.32477448100008],
              [26.349782748000052, 38.32013580900008],
              [26.356130405000044, 38.31688060100004],
              [26.370616082000083, 38.316066799000055],
              [26.385020379000082, 38.318426825000074],
              [26.391856316000087, 38.32501862200007],
              [26.38331139400009, 38.33673737200007],
              [26.38331139400009, 38.34357330900008],
              [26.39893639400009, 38.33551666900007],
              [26.40528405000009, 38.33535390800006],
              [26.417491082000083, 38.33673737200007],
              [26.429209832000083, 38.34076569200005],
              [26.454600457000083, 38.354803778000075],
              [26.462168816000087, 38.357855536000045],
              [26.47592207100007, 38.366888739000046],
              [26.47706139400009, 38.38686758000006],
              [26.468028191000087, 38.40761953300006],
              [26.451508009000065, 38.41868724200009],
              [26.451508009000065, 38.42609284100007],
              [26.476898634000065, 38.41669342700004],
              [26.489105665000068, 38.40619538000004],
              [26.497894727000073, 38.40729401200008],
              [26.51303144600007, 38.432928778000075],
              [26.498871290000068, 38.43964264500005],
              [26.47429446700005, 38.45734284100007],
              [26.453868035000085, 38.46320221600007],
              [26.44076582100007, 38.47280508000006],
              [26.43100019600007, 38.473944403000075],
              [26.422048373000052, 38.46971263200004],
              [26.414235873000052, 38.456284898000035],
              [26.40723717500009, 38.45343659100007],
              [26.387868686000047, 38.45425039300005],
              [26.388194207000083, 38.45844147300005],
              [26.397227410000085, 38.46869538000004],
              [26.403819207000083, 38.487534898000035],
              [26.399912957000083, 38.49957916900007],
              [26.36963951900009, 38.53534577000005],
              [26.375824415000068, 38.528550523000035],
              [26.373057488000086, 38.540716864000046],
              [26.36068769600007, 38.57094961100006],
              [26.35914147200009, 38.57697174700007],
              [26.360118035000085, 38.58356354400007],
              [26.34864342500009, 38.62132396000004],
              [26.34896894600007, 38.63548411700009],
              [26.351084832000083, 38.65021393400008],
              [26.356293165000068, 38.66168854400007],
              [26.365977410000085, 38.66632721600007],
              [26.381032748000052, 38.66836172100005],
              [26.403005405000044, 38.67731354400007],
              [26.414073113000086, 38.679388739000046],
              [26.440603061000047, 38.67767975500004],
              [26.465586785000085, 38.67267487200007],
              [26.48764082100007, 38.66429271000004],
              [26.50562584700009, 38.65265534100007],
              [26.53956139400009, 38.62368398600006],
              [26.555837436000047, 38.60541413000004],
              [26.560801629000082, 38.59003327000005],
              [26.583994988000086, 38.56093984600005],
              [26.609222852000073, 38.53534577000005],
              [26.618011915000068, 38.528631903000075],
              [26.62476647200009, 38.524644273000035],
              [26.630381707000083, 38.519232489000046],
              [26.635915561000047, 38.50804271000004],
              [26.637950066000087, 38.49701569200005],
              [26.637461785000085, 38.487209377000056],
              [26.63803144600007, 38.477728583000044],
              [26.643321160000085, 38.46771881700005],
              [26.636729363000086, 38.46344635600008],
              [26.633148634000065, 38.46190013200004],
              [26.629161004000082, 38.46088288000004],
              [26.621348504000082, 38.46662018400008],
              [26.610850457000083, 38.468410549000055],
              [26.59929446700005, 38.46637604400007],
              [26.588145379000082, 38.46088288000004],
              [26.60523522200009, 38.45380280200004],
              [26.604991082000083, 38.44476959800005],
              [26.596364780000044, 38.43317291900007],
              [26.588145379000082, 38.41868724200009],
              [26.61182701900009, 38.41624583500004],
              [26.62208092500009, 38.40534088700008],
              [26.62826582100007, 38.39008209800005],
              [26.63965905000009, 38.37457916900007],
              [26.657074415000068, 38.32880280200004],
              [26.673106316000087, 38.30719635600008],
              [26.694590691000087, 38.31317780200004],
              [26.699961785000085, 38.32575104400007],
              [26.693614129000082, 38.33437734600005],
              [26.67750084700009, 38.34357330900008],
              [26.670664910000085, 38.38515859600005],
              [26.675954623000052, 38.402329820000034],
              [26.68726647200009, 38.41974518400008],
              [26.702403191000087, 38.43016185100004],
              [26.719086134000065, 38.42609284100007],
              [26.719086134000065, 38.432928778000075],
              [26.725352410000085, 38.432928778000075],
              [26.736664259000065, 38.42291901200008],
              [26.748220248000052, 38.40468984600005],
              [26.766856316000087, 38.36408112200007],
              [26.771494988000086, 38.366115627000056],
              [26.78296959700009, 38.36937083500004],
              [26.787364129000082, 38.371527411000045],
              [26.795095248000052, 38.358628648000035],
              [26.809825066000087, 38.36005280200004],
              [26.827647332000083, 38.367254950000074],
              [26.84546959700009, 38.371527411000045],
              [26.924571160000085, 38.37767161700009],
              [26.973806186000047, 38.396185614000046],
              [26.989756707000083, 38.398871161000045],
              [26.994476759000065, 38.40078359600005],
              [27.00749759200005, 38.40973541900007],
              [27.01335696700005, 38.41250234600005],
              [27.023610873000052, 38.412095445000034],
              [27.03296959700009, 38.40900299700007],
              [27.042491082000083, 38.40761953300006],
              [27.05437259200005, 38.41250234600005],
              [27.055837436000047, 38.40851471600007],
              [27.061208530000044, 38.41250234600005],
              [27.088633660000085, 38.40224844000005],
              [27.11182701900009, 38.41400788000004],
              [27.135427280000044, 38.433661200000074],
              [27.164235873000052, 38.446600653000075],
              [27.164235873000052, 38.45343659100007],
              [27.154470248000052, 38.459418036000045],
              [27.15015709700009, 38.45872630400004],
              [27.14307701900009, 38.45343659100007],
              [27.136241082000083, 38.46088288000004],
              [27.11695397200009, 38.45392487200007],
              [27.08334394600007, 38.456732489000046],
              [27.07471764400009, 38.45343659100007],
              [27.049082879000082, 38.46320221600007],
              [27.022308790000068, 38.46246979400007],
              [26.959646030000044, 38.44196198100008],
              [26.938649936000047, 38.43423086100006],
              [26.935394727000073, 38.434881903000075],
              [26.94507897200009, 38.446600653000075],
              [26.927907748000052, 38.45604075700004],
              [26.897634311000047, 38.49469635600008],
              [26.884043816000087, 38.501206773000035],
              [26.859222852000073, 38.507473049000055],
              [26.84929446700005, 38.51239655200004],
              [26.826914910000085, 38.52619049700007],
              [26.814707879000082, 38.54279205900008],
              [26.829274936000047, 38.531317450000074],
              [26.84701582100007, 38.520697333000044],
              [26.874196811000047, 38.507473049000055],
              [26.889821811000047, 38.50804271000004],
              [26.889821811000047, 38.514878648000035],
              [26.877777540000068, 38.52635325700004],
              [26.865082227000073, 38.53554922100005],
              [26.85124759200005, 38.54291413000004],
              [26.835215691000087, 38.54901764500005],
              [26.839366082000083, 38.56077708500004],
              [26.844574415000068, 38.58543528900009],
              [26.848887566000087, 38.59739817900004],
              [26.834239129000082, 38.60822174700007],
              [26.825043165000068, 38.604803778000075],
              [26.813731316000087, 38.597642320000034],
              [26.793630405000044, 38.59739817900004],
              [26.798106316000087, 38.60773346600007],
              [26.801036004000082, 38.61172109600005],
              [26.779307488000086, 38.61774323100008],
              [26.76693769600007, 38.61904531500005],
              [26.753184441000087, 38.61790599200009],
              [26.755137566000087, 38.62254466400009],
              [26.75757897200009, 38.63377513200004],
              [26.75945071700005, 38.63841380400004],
              [26.746429884000065, 38.638657945000034],
              [26.736989780000044, 38.64248281500005],
              [26.719086134000065, 38.65265534100007],
              [26.726084832000083, 38.65900299700007],
              [26.733653191000087, 38.66364166900007],
              [26.742442254000082, 38.66624583500004],
              [26.753184441000087, 38.66632721600007],
              [26.733164910000085, 38.68964264500005],
              [26.725840691000087, 38.70270416900007],
              [26.719086134000065, 38.72093333500004],
              [26.737559441000087, 38.73078034100007],
              [26.788910352000073, 38.73940664300005],
              [26.818207227000073, 38.75543854400007],
              [26.823741082000083, 38.75372955900008],
              [26.82748457100007, 38.75018952000005],
              [26.828949415000068, 38.74827708500004],
              [26.83057701900009, 38.747259833000044],
              [26.841807488000086, 38.74583567900004],
              [26.851573113000086, 38.74567291900007],
              [26.874522332000083, 38.737534898000035],
              [26.888519727000073, 38.734035549000055],
              [26.903493686000047, 38.73456452000005],
              [26.897227410000085, 38.74827708500004],
              [26.907074415000068, 38.75364817900004],
              [26.915293816000087, 38.75995514500005],
              [26.923024936000047, 38.762152411000045],
              [26.93140709700009, 38.755072333000044],
              [26.934418165000068, 38.762884833000044],
              [26.935069207000083, 38.77045319200005],
              [26.933848504000082, 38.778957424000055],
              [26.93140709700009, 38.78925202000005],
              [26.924571160000085, 38.78172435100004],
              [26.904470248000052, 38.809759833000044],
              [26.897227410000085, 38.81655508000006],
              [26.937673373000052, 38.83022695500006],
              [26.94385826900009, 38.80874258000006],
              [26.960785352000073, 38.80613841400009],
              [26.971446160000085, 38.81915924700007],
              [26.95875084700009, 38.84446849200009],
              [26.975352410000085, 38.84861888200004],
              [26.990896030000044, 38.85504791900007],
              [27.003916863000086, 38.86286041900007],
              [27.01335696700005, 38.871161200000074],
              [27.033539259000065, 38.86050039300005],
              [27.055023634000065, 38.871079820000034],
              [27.062673373000052, 38.88686758000006],
              [27.041270379000082, 38.89166901200008],
              [27.057871941000087, 38.91852448100008],
              [27.057790561000047, 38.929754950000074],
              [27.041270379000082, 38.94009023600006],
              [27.024099155000044, 38.928168036000045],
              [27.012868686000047, 38.92206452000005],
              [27.001231316000087, 38.91986725500004],
              [26.982595248000052, 38.919623114000046],
              [26.97754967500009, 38.922756252000056],
              [26.967539910000085, 38.93691640800006],
              [26.962412957000083, 38.94009023600006],
              [26.949961785000085, 38.93699778900009],
              [26.941661004000082, 38.93187083500004],
              [26.934255405000044, 38.930894273000035],
              [26.924571160000085, 38.94009023600006],
              [26.91342207100007, 38.93195221600007],
              [26.879161004000082, 38.91620514500005],
              [26.86622155000009, 38.913397528000075],
              [26.855642123000052, 38.91754791900007],
              [26.840098504000082, 38.93585846600007],
              [26.82520592500009, 38.94009023600006],
              [26.806488477000073, 38.95014069200005],
              [26.797211134000065, 38.97313060100004],
              [26.799164259000065, 38.99835846600007],
              [26.814707879000082, 39.01512278900009],
              [26.814707879000082, 39.02195872600004],
              [26.80958092500009, 39.021551825000074],
              [26.793630405000044, 39.02195872600004],
              [26.80640709700009, 39.03388092700004],
              [26.82911217500009, 39.04734935100004],
              [26.85401451900009, 39.05841705900008],
              [26.873057488000086, 39.062933661000045],
              [26.883148634000065, 39.071600653000075],
              [26.875254754000082, 39.09088776200008],
              [26.851898634000065, 39.12128327000005],
              [26.823741082000083, 39.14907461100006],
              [26.809825066000087, 39.157456773000035],
              [26.778737826000054, 39.170030015000066],
              [26.77116946700005, 39.173081773000035],
              [26.75163821700005, 39.18463776200008],
              [26.737803582000083, 39.19721100500004],
              [26.739024285000085, 39.20758698100008],
              [26.73096764400009, 39.22760651200008],
              [26.726573113000086, 39.24750397300005],
              [26.718760613000086, 39.262884833000044],
              [26.701426629000082, 39.26898834800005],
              [26.65333092500009, 39.266913153000075],
              [26.629079623000052, 39.26837799700007],
              [26.609222852000073, 39.27521393400008],
              [26.619313998000052, 39.28314850500004],
              [26.625173373000052, 39.30329010600008],
              [26.63257897200009, 39.31342194200005],
              [26.64551842500009, 39.317572333000044],
              [26.65479576900009, 39.31321849200009],
              [26.653819207000083, 39.30646393400008],
              [26.635915561000047, 39.303168036000045],
              [26.635915561000047, 39.296942450000074],
              [26.646739129000082, 39.297308661000045],
              [26.65601647200009, 39.294256903000075],
              [26.663910352000073, 39.28900788000004],
              [26.670664910000085, 39.28266022300005],
              [26.664805535000085, 39.298081773000035],
              [26.670258009000065, 39.305975653000075],
              [26.681162957000083, 39.310614325000074],
              [26.69117272200009, 39.31622955900008],
              [26.70875084700009, 39.33690013200004],
              [26.814707879000082, 39.39935944200005],
              [26.805430535000085, 39.40509674700007],
              [26.801036004000082, 39.40619538000004],
              [26.801036004000082, 39.41242096600007],
              [26.802582227000073, 39.419175523000035],
              [26.802744988000086, 39.425116278000075],
              [26.801036004000082, 39.43353913000004],
              [26.837412957000083, 39.435614325000074],
              [26.850840691000087, 39.43976471600007],
              [26.86304772200009, 39.44717031500005],
              [26.85206139400009, 39.461818752000056],
              [26.867930535000085, 39.47150299700007],
              [26.925954623000052, 39.48582591400009],
              [26.929860873000052, 39.48773834800005],
              [26.929698113000086, 39.491441148000035],
              [26.93140709700009, 39.50177643400008],
              [26.94507897200009, 39.53961823100008],
              [26.94385826900009, 39.560980536000045],
              [26.937673373000052, 39.57477448100008],
              [26.922211134000065, 39.58218008000006],
              [26.893402540000068, 39.58437734600005],
              [26.87045332100007, 39.57684967700004],
              [26.85206139400009, 39.563381252000056],
              [26.832855665000068, 39.55683014500005],
              [26.807871941000087, 39.57070547100005],
              [26.667246941000087, 39.550848700000074],
              [26.45679772200009, 39.521185614000046],
              [26.434255405000044, 39.51398346600007],
              [26.424164259000065, 39.505194403000075],
              [26.413910352000073, 39.50531647300005],
              [26.369965040000068, 39.48578522300005],
              [26.362152540000068, 39.481350002000056],
              [26.35010826900009, 39.481350002000056],
              [26.29737389400009, 39.488714911000045],
              [26.286631707000083, 39.487616278000075],
              [26.273610873000052, 39.482407945000034],
              [26.262950066000087, 39.481350002000056],
              [26.253916863000086, 39.47284577000005],
              [26.252289259000065, 39.470770575000074],
              [26.249278191000087, 39.46564362200007],
              [26.242523634000065, 39.46759674700007],
              [26.23178144600007, 39.47451406500005],
              [26.15284264400009, 39.45921458500004],
              [26.11296634200005, 39.45917389500005],
              [26.074229363000086, 39.47451406500005],
              [26.06999759200005, 39.49628327000005],
              [26.094981316000087, 39.54857005400004],
              [26.11068769600007, 39.59788646000004],
              [26.14820397200009, 39.62604401200008],
              [26.15674889400009, 39.64923737200007],
              [26.163584832000083, 39.70416901200008],
              [26.159353061000047, 39.714911200000074],
              [26.140635613000086, 39.74274323100008],
              [26.13640384200005, 39.75568268400008],
              [26.137868686000047, 39.764553127000056],
              [26.142100457000083, 39.76788971600007],
              [26.146739129000082, 39.77020905200004],
              [26.149912957000083, 39.77610911700009],
              [26.149912957000083, 39.799994208000044],
              [26.154958530000044, 39.826157945000034],
              [26.15170332100007, 39.835150458000044],
              [26.13640384200005, 39.837591864000046],
              [26.141856316000087, 39.84902578300006],
              [26.15674889400009, 39.89899323100008],
              [26.15601647200009, 39.90509674700007],
              [26.150645379000082, 39.924709377000056],
              [26.149912957000083, 39.93378327000005],
              [26.152598504000082, 39.942613023000035],
              [26.161631707000083, 39.95620351800005],
              [26.163584832000083, 39.964544989000046],
              [26.16765384200005, 39.97357819200005],
              [26.188649936000047, 40.00177643400008],
              [26.19776451900009, 40.00885651200008],
              [26.251149936000047, 39.99485911700009],
              [26.26693769600007, 40.00307851800005],
              [26.300303582000083, 40.01439036700009],
              [26.31104576900009, 40.01947663000004],
              [26.35320071700005, 40.05215078300006],
              [26.362152540000068, 40.06346263200004],
              [26.36500084700009, 40.07176341400009],
              [26.36622155000009, 40.08462148600006],
              [26.36963951900009, 40.09080638200004],
              [26.370371941000087, 40.09471263200004],
              [26.369476759000065, 40.09918854400007],
              [26.369395379000082, 40.10293203300006],
              [26.37281334700009, 40.10447825700004],
              [26.38379967500009, 40.10415273600006],
              [26.389008009000065, 40.105169989000046],
              [26.393239780000044, 40.10822174700007],
              [26.399587436000047, 40.12083567900004],
              [26.403493686000047, 40.13898346600007],
              [26.403005405000044, 40.157904364000046],
              [26.396332227000073, 40.172756252000056],
              [26.40284264400009, 40.18744538000004],
              [26.40796959700009, 40.19367096600007],
              [26.414886915000068, 40.19489166900007],
              [26.427582227000073, 40.19448476800005],
              [26.441416863000086, 40.196600653000075],
              [26.467539910000085, 40.20600006700005],
              [26.500743035000085, 40.212958075000074],
              [26.519379102000073, 40.22516510600008],
              [26.563649936000047, 40.27016836100006],
              [26.572520379000082, 40.27456289300005],
              [26.58139082100007, 40.277004299000055],
              [26.594981316000087, 40.28261953300006],
              [26.607595248000052, 40.29043203300006],
              [26.71461022200009, 40.390611070000034],
              [26.735606316000087, 40.403550523000035],
              [26.77670332100007, 40.405503648000035],
              [26.86304772200009, 40.39988841400009],
              [26.897227410000085, 40.40615469000005],
              [26.908213738000086, 40.40371328300006],
              [26.934418165000068, 40.39248281500005],
              [26.991465691000087, 40.38861725500004],
              [27.01335696700005, 40.39248281500005],
              [27.041270379000082, 40.40961334800005],
              [27.06576582100007, 40.43353913000004],
              [27.096364780000044, 40.45229726800005],
              [27.14307701900009, 40.45392487200007],
              [27.177012566000087, 40.44879791900007],
              [27.21534264400009, 40.447699286000045],
              [27.237559441000087, 40.45184967700004],
              [27.271494988000086, 40.46784088700008],
              [27.286957227000073, 40.46820709800005],
              [27.303396030000044, 40.45844147300005],
              [27.313731316000087, 40.44407786700009],
              [27.32862389400009, 40.41356028900009],
              [27.31495201900009, 40.40615469000005],
              [27.308116082000083, 40.40615469000005],
              [27.303558790000068, 40.41046784100007],
              [27.30323326900009, 40.41095612200007],
              [27.30176842500009, 40.40900299700007],
              [27.294444207000083, 40.40615469000005],
              [27.33757571700005, 40.370306708000044],
              [27.392914259000065, 40.34210846600007],
              [27.452321811000047, 40.32200755400004],
              [27.523285352000073, 40.30878327000005],
              [27.55128014400009, 40.30882396000004],
              [27.562022332000083, 40.31049225500004],
              [27.59701582100007, 40.32831452000005],
              [27.61296634200005, 40.33100006700005],
              [27.640879754000082, 40.32611725500004],
              [27.665049675000034, 40.31745026200008],
              [27.68799889400009, 40.313788153000075],
              [27.71225019600007, 40.324204820000034],
              [27.732595248000052, 40.317287502000056],
              [27.762705925000034, 40.31537506700005],
              [27.789805535000085, 40.32046133000006],
              [27.813243035000085, 40.34711334800005],
              [27.867360873000052, 40.36888255400004],
              [27.883555535000085, 40.38629791900007],
              [27.865244988000086, 40.386786200000074],
              [27.815277540000068, 40.39988841400009],
              [27.80054772200009, 40.393011786000045],
              [27.791758660000085, 40.39288971600007],
              [27.787852410000085, 40.40302155200004],
              [27.785817905000044, 40.41290924700007],
              [27.780121290000068, 40.415716864000046],
              [27.773448113000086, 40.41648997600004],
              [27.767425977000073, 40.42039622600004],
              [27.760752800000034, 40.42841217700004],
              [27.75635826900009, 40.43260325700004],
              [27.754079623000052, 40.43829987200007],
              [27.753184441000087, 40.450832424000055],
              [27.750173373000052, 40.45758698100008],
              [27.74268639400009, 40.459051825000074],
              [27.73373457100007, 40.459051825000074],
              [27.725840691000087, 40.461371161000045],
              [27.693207227000073, 40.48627350500004],
              [27.684255405000044, 40.496161200000074],
              [27.684255405000044, 40.50234609600005],
              [27.696299675000034, 40.50641510600008],
              [27.706065300000034, 40.51190827000005],
              [27.72242272200009, 40.526271877000056],
              [27.733164910000085, 40.530585028000075],
              [27.74195397200009, 40.52631256700005],
              [27.750173373000052, 40.524725653000075],
              [27.760020379000082, 40.53705475500004],
              [27.77906334700009, 40.51825592700004],
              [27.780446811000047, 40.515326239000046],
              [27.789398634000065, 40.51422760600008],
              [27.792246941000087, 40.51703522300005],
              [27.795176629000082, 40.52090078300006],
              [27.804698113000086, 40.522772528000075],
              [27.969899936000047, 40.50299713700008],
              [28.01417076900009, 40.49115631700005],
              [28.034434441000087, 40.47443268400008],
              [28.016774936000047, 40.45107656500005],
              [27.929942254000082, 40.41693756700005],
              [27.90398196700005, 40.39988841400009],
              [27.908457879000082, 40.374212958000044],
              [27.94467207100007, 40.36603424700007],
              [28.027517123000052, 40.37201569200005],
              [28.111989780000044, 40.39606354400007],
              [28.347992384000065, 40.40403880400004],
              [28.400401238000086, 40.39740631700005],
              [28.48682701900009, 40.39988841400009],
              [28.476084832000083, 40.39793528900009],
              [28.467539910000085, 40.39435455900008],
              [28.461680535000085, 40.388373114000046],
              [28.458832227000073, 40.37946198100008],
              [28.499522332000083, 40.39109935100004],
              [28.54542076900009, 40.39130280200004],
              [28.592784050000034, 40.38190338700008],
              [28.637705925000034, 40.36517975500004],
              [28.643809441000087, 40.37124258000006],
              [28.647471550000034, 40.370021877000056],
              [28.651215040000068, 40.36635976800005],
              [28.658050977000073, 40.36517975500004],
              [28.666840040000068, 40.36810944200005],
              [28.67741946700005, 40.37604401200008],
              [28.685394727000073, 40.37946198100008],
              [28.74187259200005, 40.386419989000046],
              [28.757090691000087, 40.396185614000046],
              [28.77198326900009, 40.40253327000005],
              [28.791270379000082, 40.400458075000074],
              [28.825450066000087, 40.39248281500005],
              [28.855642123000052, 40.39118073100008],
              [28.884043816000087, 40.38629791900007],
              [28.897959832000083, 40.38133372600004],
              [28.921397332000083, 40.370021877000056],
              [28.938731316000087, 40.36517975500004],
              [28.956553582000083, 40.36318594000005],
              [29.033946160000085, 40.364447333000044],
              [29.051605665000068, 40.36733633000006],
              [29.065684441000087, 40.37571849200009],
              [29.07390384200005, 40.388657945000034],
              [29.082692905000044, 40.415676174000055],
              [29.090098504000082, 40.42723216400009],
              [29.102793816000087, 40.423041083000044],
              [29.118988477000073, 40.42365143400008],
              [29.13640384200005, 40.42788320500006],
              [29.151540561000047, 40.43406810100004],
              [29.133555535000085, 40.45075104400007],
              [29.111501498000052, 40.466131903000075],
              [29.087901238000086, 40.47748444200005],
              [29.065684441000087, 40.48187897300005],
              [29.010996941000087, 40.48187897300005],
              [29.00245201900009, 40.47866445500006],
              [28.980316602000073, 40.464544989000046],
              [28.969493035000085, 40.461371161000045],
              [28.916677280000044, 40.47089264500005],
              [28.828461134000065, 40.513006903000075],
              [28.774180535000085, 40.522772528000075],
              [28.79265384200005, 40.55329010600008],
              [28.826833530000044, 40.57062409100007],
              [28.897715691000087, 40.59174225500004],
              [28.927744988000086, 40.60643138200004],
              [28.97006269600007, 40.63947174700007],
              [28.986338738000086, 40.64476146000004],
              [29.281586134000065, 40.66592031500005],
              [29.323252800000034, 40.67674388200004],
              [29.36378014400009, 40.69415924700007],
              [29.38453209700009, 40.70648834800005],
              [29.391856316000087, 40.70783112200007],
              [29.399180535000085, 40.70258209800005],
              [29.407237175000034, 40.69310130400004],
              [29.416840040000068, 40.686753648000035],
              [29.428721550000034, 40.69098541900007],
              [29.437754754000082, 40.69546133000006],
              [29.450368686000047, 40.69936758000006],
              [29.46143639400009, 40.70416901200008],
              [29.46615644600007, 40.71149323100008],
              [29.47006269600007, 40.71893952000005],
              [29.479258660000085, 40.72406647300005],
              [29.490570509000065, 40.72724030200004],
              [29.501149936000047, 40.72890859600005],
              [29.511241082000083, 40.72748444200005],
              [29.527517123000052, 40.72150299700007],
              [29.542246941000087, 40.70966217700004],
              [29.548838738000086, 40.69098541900007],
              [29.55990644600007, 40.691066799000055],
              [29.75326582100007, 40.72455475500004],
              [29.867198113000086, 40.72890859600005],
              [29.903575066000087, 40.71625397300005],
              [29.924164259000065, 40.716457424000055],
              [29.939300977000073, 40.73505280200004],
              [29.929209832000083, 40.75804271000004],
              [29.890147332000083, 40.76349518400008],
              [29.809418165000068, 40.755560614000046],
              [29.80250084700009, 40.75385163000004],
              [29.795258009000065, 40.75112539300005],
              [29.786631707000083, 40.74884674700007],
              [29.775401238000086, 40.74872467700004],
              [29.763845248000052, 40.75275299700007],
              [29.74382571700005, 40.766791083000044],
              [29.737559441000087, 40.76984284100007],
              [29.721527540000068, 40.77204010600008],
              [29.686534050000034, 40.78156159100007],
              [29.666188998000052, 40.78351471600007],
              [29.428721550000034, 40.77606842700004],
              [29.410166863000086, 40.77122630400004],
              [29.39429772200009, 40.76211172100005],
              [29.377777540000068, 40.75653717700004],
              [29.356944207000083, 40.76239655200004],
              [29.348480665000068, 40.77094147300005],
              [29.34424889400009, 40.78021881700005],
              [29.33952884200005, 40.78758372600004],
              [29.329112175000034, 40.790350653000075],
              [29.333018425000034, 40.79242584800005],
              [29.33562259200005, 40.79450104400007],
              [29.338633660000085, 40.79637278900009],
              [29.34343509200005, 40.79779694200005],
              [29.33952884200005, 40.807806708000044],
              [29.33334394600007, 40.81484609600005],
              [29.325205925000034, 40.82005442900004],
              [29.315440300000034, 40.82444896000004],
              [29.31104576900009, 40.81818268400008],
              [29.301768425000034, 40.82444896000004],
              [29.29346764400009, 40.81867096600007],
              [29.281586134000065, 40.81537506700005],
              [29.254567905000044, 40.81077708500004],
              [29.254567905000044, 40.81704336100006],
              [29.26417076900009, 40.81793854400007],
              [29.270762566000087, 40.82184479400007],
              [29.274099155000044, 40.82884349200009],
              [29.274587436000047, 40.838771877000056],
              [29.284190300000034, 40.83392975500004],
              [29.288259311000047, 40.831284898000035],
              [29.28760826900009, 40.835598049000055],
              [29.28842207100007, 40.83779531500005],
              [29.291026238000086, 40.83856842700004],
              [29.294932488000086, 40.838771877000056],
              [29.283864780000044, 40.851629950000074],
              [29.263926629000082, 40.86977773600006],
              [29.25367272200009, 40.87547435100004],
              [29.240977410000085, 40.88255442900004],
              [29.22046959700009, 40.87970612200007],
              [29.201345248000052, 40.89394765800006],
              [29.144786004000082, 40.914129950000074],
              [29.124278191000087, 40.92690664300005],
              [29.103526238000086, 40.94672272300005],
              [29.083181186000047, 40.95966217700004],
              [29.028086785000085, 40.982123114000046],
              [29.032074415000068, 40.984035549000055],
              [29.03288821700005, 40.98456452000005],
              [29.03288821700005, 40.985663153000075],
              [29.03484134200005, 40.989569403000075],
              [29.023285352000073, 40.993353583000044],
              [29.018321160000085, 41.003892320000034],
              [29.014659050000034, 41.01752350500004],
              [29.00757897200009, 41.030503648000035],
              [29.026052280000044, 41.038275458000044],
              [29.046153191000087, 41.05548737200007],
              [29.062347852000073, 41.07632070500006],
              [29.076182488000086, 41.11440664300005],
              [29.088145379000082, 41.12885163000004],
              [29.090586785000085, 41.14093659100007],
              [29.069102410000085, 41.152777411000045],
              [29.092621290000068, 41.18036530200004],
              [29.130056186000047, 41.21190013200004],
              [29.16968834700009, 41.23309967700004],
              [29.199961785000085, 41.22919342700004],
              [29.206228061000047, 41.22919342700004],
              [29.21615644600007, 41.23940664300005],
              [29.23178144600007, 41.24070872600004],
              [29.41960696700005, 41.21430084800005],
              [29.61882571700005, 41.178900458000044],
              [29.884613477000073, 41.14899323100008],
              [30.136892123000052, 41.143784898000035],
              [30.165212436000047, 41.14663320500006],
              [30.180023634000065, 41.151556708000044],
              [30.203461134000065, 41.164496161000045],
              [30.217051629000082, 41.16714101800005],
              [30.226410352000073, 41.17291901200008],
              [30.233653191000087, 41.184475002000056],
              [30.240489129000082, 41.19232819200005],
              [30.248301629000082, 41.187567450000074],
              [30.259043816000087, 41.195746161000045],
              [30.27125084700009, 41.21116771000004],
              [30.282481316000087, 41.21552155200004],
              [30.295583530000044, 41.20742422100005],
              [30.336680535000085, 41.200832424000055],
              [30.369965040000068, 41.181341864000046],
              [30.699229363000086, 41.121527411000045],
              [30.732432488000086, 41.09943268400008],
              [30.748057488000086, 41.09198639500005],
              [30.833262566000087, 41.07990143400008],
              [31.090586785000085, 41.085150458000044],
              [31.115244988000086, 41.09601471600007],
              [31.12476647200009, 41.09813060100004],
              [31.137054884000065, 41.09760163000004],
              [31.158457879000082, 41.093085028000075],
              [31.169444207000083, 41.09198639500005],
              [31.210459832000083, 41.09813060100004],
              [31.21648196700005, 41.09723541900007],
              [31.226084832000083, 41.092962958000044],
              [31.231211785000085, 41.09198639500005],
              [31.23878014400009, 41.09369538000004],
              [31.240977410000085, 41.097723700000074],
              [31.242930535000085, 41.10236237200007],
              [31.248871290000068, 41.10565827000005],
              [31.290212436000047, 41.11786530200004],
              [31.32357832100007, 41.13385651200008],
              [31.37859134200005, 41.17450592700004],
              [31.392751498000052, 41.18842194200005],
              [31.401052280000044, 41.20209381700005],
              [31.405039910000085, 41.21816640800006],
              [31.40601647200009, 41.23940664300005],
              [31.408050977000073, 41.24835846600007],
              [31.417491082000083, 41.26829661700003],
              [31.41960696700005, 41.28034088700008],
              [31.415049675000034, 41.28587474200003],
              [31.39616946700005, 41.29547760600008],
              [31.392832879000082, 41.30365631700005],
              [31.403575066000087, 41.316473700000074],
              [31.42514082100007, 41.32257721600007],
              [31.471039259000065, 41.32477448100008],
              [31.476573113000086, 41.329006252000056],
              [31.49268639400009, 41.347723700000074],
              [31.498301629000082, 41.35203685100004],
              [31.508555535000085, 41.35382721600007],
              [31.658946160000085, 41.39793528900009],
              [31.87159264400009, 41.50458405200004],
              [31.993337436000047, 41.54950592700004],
              [32.029633009000065, 41.571193752000056],
              [32.039398634000065, 41.57558828300006],
              [32.13412519600007, 41.59943268400008],
              [32.16187584700009, 41.61200592700004],
              [32.178396030000044, 41.63690827000005],
              [32.24341881600009, 41.69293854400007],
              [32.24822024800005, 41.69806549700007],
              [32.26335696700005, 41.72016022300005],
              [32.29704837300005, 41.72736237200007],
              [32.35181725400008, 41.72943756700005],
              [32.35368899800005, 41.73574453300006],
              [32.36182701900009, 41.73786041900007],
              [32.37232506600009, 41.74249909100007],
              [32.37435957100007, 41.74941640800006],
              [32.37720787900008, 41.75405508000006],
              [32.38257897200009, 41.75608958500004],
              [32.38721764400009, 41.75385163000004],
              [32.39625084700009, 41.74428945500006],
              [32.39966881600009, 41.74249909100007],
              [32.41724694100009, 41.748928127000056],
              [32.439463738000086, 41.76752350500004],
              [32.45427493600005, 41.77724844000005],
              [32.52320397200009, 41.80451080900008],
              [32.53484134200005, 41.81073639500005],
              [32.54835045700008, 41.815741278000075],
              [32.562836134000065, 41.81688060100004],
              [32.57781009200005, 41.81134674700007],
              [32.58936608200008, 41.82697174700007],
              [32.61255944100009, 41.839544989000046],
              [32.639659050000034, 41.84389883000006],
              [32.663096550000034, 41.83494700700004],
              [32.67920983200008, 41.83633047100005],
              [32.74040774800005, 41.853176174000055],
              [32.75538170700008, 41.85911692900004],
              [32.770274285000085, 41.85797760600008],
              [32.79851321700005, 41.85968659100007],
              [32.82748457100007, 41.86469147300005],
              [32.84457441500007, 41.87278880400004],
              [32.85564212300005, 41.86831289300005],
              [32.926117384000065, 41.88182200700004],
              [32.961924675000034, 41.89411041900007],
              [33.00806725400008, 41.917303778000075],
              [33.16553795700008, 41.95697663000004],
              [33.32447350400008, 42.01902903900009],
              [33.36085045700008, 42.02065664300005],
              [33.434336785000085, 42.010646877000056],
              [33.54053795700008, 42.010646877000056],
              [33.563243035000085, 42.00771719000005],
              [33.61345462300005, 41.99371979400007],
              [33.827159050000034, 41.97768789300005],
              [33.84522545700008, 41.98265208500004],
              [33.87354576900009, 41.97443268400008],
              [34.00359134200005, 41.98265208500004],
              [34.33130944100009, 41.94794342700004],
              [34.44548587300005, 41.97284577000005],
              [34.48267662900008, 41.97524648600006],
              [34.498708530000044, 41.971909898000035],
              [34.52702884200005, 41.960638739000046],
              [34.56177819100009, 41.95184967700004],
              [34.69418379000007, 41.94594961100006],
              [34.74634850400008, 41.950384833000044],
              [34.79859459700009, 41.962225653000075],
              [34.815114780000044, 41.96914297100005],
              [34.85287519600007, 41.991522528000075],
              [34.889008009000065, 42.007798570000034],
              [34.91879316500007, 42.03554922100005],
              [34.94190514400009, 42.06928131700005],
              [34.94809004000007, 42.09878164300005],
              [34.96208743600005, 42.095038153000075],
              [34.99073326900009, 42.091131903000075],
              [35.00342858200008, 42.08510976800005],
              [35.005869988000086, 42.09137604400007],
              [35.010101759000065, 42.09275950700004],
              [35.01612389400009, 42.09218984600005],
              [35.02393639400009, 42.09251536700003],
              [35.03109785200007, 42.08063385600008],
              [35.04184004000007, 42.07208893400008],
              [35.048838738000086, 42.06513092700004],
              [35.04444420700008, 42.057806708000044],
              [35.04444420700008, 42.05158112200007],
              [35.08155358200008, 42.02920156500005],
              [35.104502800000034, 42.02187734600005],
              [35.133799675000034, 42.02362702000005],
              [35.14421634200005, 42.028509833000044],
              [35.16041100400008, 42.04148997600004],
              [35.17123457100007, 42.044134833000044],
              [35.186208530000044, 42.04246653900009],
              [35.19581139400009, 42.03807200700004],
              [35.21631920700008, 42.02362702000005],
              [35.21631920700008, 42.016791083000044],
              [35.16260826900009, 42.02171458500004],
              [35.13754316500007, 42.019517320000034],
              [35.11670983200008, 42.00690338700008],
              [35.107432488000086, 41.99168528900009],
              [35.09880618600005, 41.96971263200004],
              [35.09302819100009, 41.94668203300006],
              [35.092133009000065, 41.92804596600007],
              [35.098643425000034, 41.91266510600008],
              [35.125743035000085, 41.87531159100007],
              [35.15577233200008, 41.845689195000034],
              [35.20948326900009, 41.81134674700007],
              [35.20948326900009, 41.80451080900008],
              [35.19581139400009, 41.80451080900008],
              [35.20199629000007, 41.791449286000045],
              [35.21176191500007, 41.775376695000034],
              [35.22478274800005, 41.76186758000006],
              [35.25359134200005, 41.75063711100006],
              [35.28256269600007, 41.72418854400007],
              [35.29818769600007, 41.71515534100007],
              [35.35767662900008, 41.69684479400007],
              [35.401052280000044, 41.69155508000006],
              [35.41732832100007, 41.68341705900008],
              [35.44906660200007, 41.66054922100005],
              [35.48585045700008, 41.64508698100008],
              [35.53012129000007, 41.63426341400009],
              [35.57667076900009, 41.62970612200007],
              [35.619802280000044, 41.63263580900008],
              [35.64087975400008, 41.63930898600006],
              [35.678721550000034, 41.65692780200004],
              [35.740570509000065, 41.66498444200005],
              [35.84620201900009, 41.69871653900009],
              [35.870127800000034, 41.70148346600007],
              [35.89380944100009, 41.707464911000045],
              [35.93482506600009, 41.732407945000034],
              [35.95679772200009, 41.73627350500004],
              [35.95679772200009, 41.72943756700005],
              [35.95248457100007, 41.72329336100006],
              [35.94678795700008, 41.717230536000045],
              [35.93897545700008, 41.712103583000044],
              [35.92896569100009, 41.70892975500004],
              [35.93051191500007, 41.69383372600004],
              [35.91163170700008, 41.66278717700004],
              [35.91529381600009, 41.64622630400004],
              [35.92269941500007, 41.64622630400004],
              [35.924815300000034, 41.67023346600007],
              [35.934336785000085, 41.69212474200003],
              [35.947927280000044, 41.71002838700008],
              [35.96241295700008, 41.721991278000075],
              [35.97291100400008, 41.728583075000074],
              [35.97787519600007, 41.729681708000044],
              [36.038096550000034, 41.68781159100007],
              [36.038096550000034, 41.70148346600007],
              [36.044932488000086, 41.70148346600007],
              [36.12045332100007, 41.62775299700007],
              [36.13445071700005, 41.59906647300005],
              [36.13445071700005, 41.55817291900007],
              [36.13103274800005, 41.54824453300006],
              [36.12232506600009, 41.53180573100008],
              [36.12077884200005, 41.527044989000046],
              [36.11996504000007, 41.49433014500005],
              [36.123789910000085, 41.47915273600006],
              [36.13445071700005, 41.46190013200004],
              [36.17888431100005, 41.419989325000074],
              [36.20476321700005, 41.40648021000004],
              [36.23682701900009, 41.35887278900009],
              [36.25326582100007, 41.348822333000044],
              [36.303396030000044, 41.32851797100005],
              [36.33187910200007, 41.32318756700005],
              [36.33725019600007, 41.31854889500005],
              [36.339854363000086, 41.31093984600005],
              [36.340505405000044, 41.30052317900004],
              [36.343760613000086, 41.288723049000055],
              [36.352224155000044, 41.283636786000045],
              [36.363291863000086, 41.28107330900008],
              [36.37452233200008, 41.277004299000055],
              [36.38013756600009, 41.27216217700004],
              [36.39014733200008, 41.26032135600008],
              [36.39503014400009, 41.25641510600008],
              [36.405039910000085, 41.253607489000046],
              [36.423838738000086, 41.25169505400004],
              [36.43246504000007, 41.24624258000006],
              [36.45101972700007, 41.24042389500005],
              [36.47608483200008, 41.24494049700007],
              [36.517914259000065, 41.26264069200005],
              [36.57081139400009, 41.29791901200008],
              [36.57935631600009, 41.30731842700004],
              [36.58253014400009, 41.31708405200004],
              [36.596690300000034, 41.335272528000075],
              [36.59986412900008, 41.341498114000046],
              [36.601898634000065, 41.343736070000034],
              [36.60865319100009, 41.364935614000046],
              [36.60670006600009, 41.36627838700008],
              [36.619883660000085, 41.375067450000074],
              [36.633555535000085, 41.37409088700008],
              [36.65015709700009, 41.36928945500006],
              [36.67172285200007, 41.36627838700008],
              [36.75806725400008, 41.36627838700008],
              [36.836680535000085, 41.350775458000044],
              [36.98487389400009, 41.29450104400007],
              [37.01531009200005, 41.274603583000044],
              [37.031911655000044, 41.24282461100006],
              [37.033864780000044, 41.19879791900007],
              [37.039724155000044, 41.18154531500005],
              [37.05640709700009, 41.17450592700004],
              [37.07748457100007, 41.17084381700005],
              [37.11573326900009, 41.15314362200007],
              [37.135508660000085, 41.14663320500006],
              [37.26343834700009, 41.14785390800006],
              [37.29932701900009, 41.14036692900004],
              [37.32243899800005, 41.12409088700008],
              [37.33350670700008, 41.11933014500005],
              [37.354502800000034, 41.11424388200004],
              [37.377940300000034, 41.112494208000044],
              [37.39535566500007, 41.10846588700008],
              [37.41944420700008, 41.087591864000046],
              [37.436534050000034, 41.07770416900007],
              [37.477549675000034, 41.06777578300006],
              [37.48129316500007, 41.062201239000046],
              [37.50473066500007, 41.04291413000004],
              [37.52475019600007, 41.037176825000074],
              [37.56470787900008, 41.04047272300005],
              [37.58057701900009, 41.036769924000055],
              [37.58643639400009, 41.042222398000035],
              [37.60043379000007, 41.04633209800005],
              [37.60792076900009, 41.050441799000055],
              [37.615244988000086, 41.05853913000004],
              [37.62826582100007, 41.085150458000044],
              [37.64014733200008, 41.101548570000034],
              [37.655039910000085, 41.117621161000045],
              [37.67204837300005, 41.13125234600005],
              [37.689789259000065, 41.14036692900004],
              [37.69849694100009, 41.12409088700008],
              [37.71509850400008, 41.11473216400009],
              [37.73422285200007, 41.11465078300006],
              [37.75123131600009, 41.12612539300005],
              [37.75806725400008, 41.11933014500005],
              [37.783864780000044, 41.12262604400007],
              [37.785166863000086, 41.06000397300005],
              [37.802744988000086, 41.04291413000004],
              [37.854258660000085, 41.02366771000004],
              [37.867930535000085, 41.01557038000004],
              [37.87826582100007, 41.00560130400004],
              [37.89576256600009, 40.982123114000046],
              [37.93474368600005, 40.99510325700004],
              [37.98170006600009, 40.990220445000034],
              [38.102224155000044, 40.95970286700003],
              [38.16130618600005, 40.95209381700005],
              [38.20142662900008, 40.94135163000004],
              [38.22413170700008, 40.94114817900004],
              [38.268321160000085, 40.950384833000044],
              [38.28736412900008, 40.94721100500004],
              [38.33090254000007, 40.91787344000005],
              [38.35124759200005, 40.91787344000005],
              [38.389333530000044, 40.92690664300005],
              [38.426768425000034, 40.91864655200004],
              [38.45232181100005, 40.91673411700003],
              [38.46371504000007, 40.92377350500004],
              [38.539398634000065, 40.92690664300005],
              [38.55486087300005, 40.93500397300005],
              [38.59156334700003, 40.962551174000055],
              [38.60474694100009, 40.968451239000046],
              [38.637054884000065, 40.97601959800005],
              [38.64926191500007, 40.97528717700004],
              [38.65544681100005, 40.97109609600005],
              [38.670909050000034, 40.95453522300005],
              [38.67790774800005, 40.94863515800006],
              [38.68775475400008, 40.95270416900007],
              [38.707041863000086, 40.95286692900004],
              [38.71762129000007, 40.954779364000046],
              [38.724619988000086, 40.95917389500005],
              [38.733083530000044, 40.966131903000075],
              [38.74333743600005, 40.97247955900008],
              [38.75513756600009, 40.97528717700004],
              [38.775401238000086, 40.993353583000044],
              [38.77906334700003, 40.999212958000044],
              [38.78370201900009, 41.00177643400008],
              [38.80591881600009, 41.00775788000004],
              [38.87582441500007, 41.01894765800006],
              [38.89234459700003, 41.02708567900004],
              [38.90837649800005, 41.03766510600008],
              [38.92750084700003, 41.042629299000055],
              [39.041758660000085, 41.043402411000045],
              [39.12232506600009, 41.05727773600006],
              [39.131195509000065, 41.06146881700005],
              [39.15650475400008, 41.07770416900007],
              [39.168304884000065, 41.079738674000055],
              [39.201182488000086, 41.07770416900007],
              [39.21998131600009, 41.07290273600006],
              [39.250743035000085, 41.05304596600007],
              [39.27320397200003, 41.050441799000055],
              [39.290049675000034, 41.05483633000006],
              [39.31723066500007, 41.068060614000046],
              [39.33741295700008, 41.07086823100008],
              [39.34913170700008, 41.07396067900004],
              [39.40284264400009, 41.09813060100004],
              [39.408864780000044, 41.102443752000056],
              [39.412445509000065, 41.10651276200008],
              [39.41822350400008, 41.11001211100006],
              [39.43018639400009, 41.112494208000044],
              [39.492930535000085, 41.10101959800005],
              [39.50717207100007, 41.09007396000004],
              [39.53256269600007, 41.06464264500005],
              [39.59205162900008, 41.025091864000046],
              [39.63005618600005, 41.00849030200004],
              [39.66968834700003, 41.00263092700004],
              [39.689789259000065, 41.007473049000055],
              [39.71013431100005, 41.01504140800006],
              [39.72999108200008, 41.01715729400007],
              [39.75709069100009, 41.00234609600005],
              [39.768321160000085, 41.00141022300005],
              [39.79021243600005, 41.00263092700004],
              [39.799164259000065, 41.00031159100007],
              [39.85873457100007, 40.96426015800006],
              [39.87647545700008, 40.95783112200007],
              [39.89568118600005, 40.954779364000046],
              [39.91187584700003, 40.963771877000056],
              [39.974945509000065, 40.98029205900008],
              [39.99935957100007, 40.982123114000046],
              [40.05681399800005, 40.94135163000004],
              [40.08570397200003, 40.92645905200004],
              [40.125987175000034, 40.92064036700003],
              [40.14275149800005, 40.92279694200005],
              [40.172536655000044, 40.93219635600008],
              [40.19556725400008, 40.93634674700007],
              [40.231455925000034, 40.94684479400007],
              [40.254649285000085, 40.958685614000046],
              [40.30103600400008, 40.968451239000046],
              [40.464854363000086, 41.050441799000055],
              [40.49968509200005, 41.038763739000046],
              [40.52914472700007, 41.03628164300005],
              [40.557383660000085, 41.04246653900009],
              [40.58838951900009, 41.05727773600006],
              [40.62614993600005, 41.08218008000006],
              [40.639659050000034, 41.085150458000044],
              [40.670664910000085, 41.087958075000074],
              [40.685883009000065, 41.09198639500005],
              [40.698252800000034, 41.09813060100004],
              [40.75757897200003, 41.15835195500006],
              [40.82748457100007, 41.19794342700004],
              [40.838877800000034, 41.201239325000074],
              [40.85401451900009, 41.199286200000074],
              [40.896820509000065, 41.187567450000074],
              [40.92204837300005, 41.190619208000044],
              [40.95980879000007, 41.210638739000046],
              [40.97608483200008, 41.21552155200004],
              [40.997080925000034, 41.21771881700005],
              [41.020274285000085, 41.22370026200008],
              [41.04273522200003, 41.232489325000074],
              [41.06137129000007, 41.24282461100006],
              [41.10084069100009, 41.27415599200003],
              [41.12134850400008, 41.28554922100005],
              [41.14665774800005, 41.28998444200005],
              [41.172618035000085, 41.29124583500004],
              [41.19076582100007, 41.29572174700007],
              [41.28500410200007, 41.35382721600007],
              [41.31031334700003, 41.36078522300005],
              [41.33179772200003, 41.36969635600008],
              [41.342539910000085, 41.37250397300005],
              [41.37745201900009, 41.37604401200008],
              [41.39039147200003, 41.379339911000045],
              [41.408946160000085, 41.390326239000046],
              [41.424164259000065, 41.407863674000055],
              [41.434336785000085, 41.42914459800005],
              [41.438161655000044, 41.45136139500005],
              [41.44857832100007, 41.456244208000044],
              [41.50709069100009, 41.495428778000075],
              [41.52076256600009, 41.51422760700008],
              [41.62725712100007, 41.48051829000012],
              [41.63996952400004, 41.47870961500003],
              [41.66983850100013, 41.48046661400009],
              [41.69495324700006, 41.48909657800006],
              [41.70260135900014, 41.48904490200003],
              [41.70394494700008, 41.48511749300006],
              [41.70280806500011, 41.477624411000036],
              [41.70260135900014, 41.46945953400011],
              [41.70683882700007, 41.463155009],
              [41.71851770100005, 41.45958933500013],
              [41.747766561000105, 41.45685048500009],
              [41.760995728000125, 41.45354319300007],
              [41.800786581000125, 41.425689596000026],
              [41.812982218000116, 41.421813863000054],
              [41.822594035000066, 41.42599965400011],
              [41.86269494600003, 41.45178619400009],
              [41.89401086400005, 41.48553090500009],
              [41.90775679600006, 41.493489075000056],
              [41.947961060000125, 41.50558136000002],
              [42.019584594000094, 41.48506581700006],
              [42.05493127500006, 41.493489075000056],
              [42.0694006760001, 41.49860504200002],
              [42.08345666500014, 41.50010365800004],
              [42.09751265500006, 41.49834665900006],
              [42.11177535000013, 41.493489075000056],
              [42.143194621000134, 41.50025868800007],
              [42.1583874910001, 41.49989695300009],
              [42.172650187000045, 41.493489075000056],
              [42.18928999800005, 41.48170684900005],
              [42.21326786300011, 41.48020823200004],
              [42.26246382700003, 41.482326966000116],
              [42.437853638000036, 41.43085723900002],
              [42.451032576000046, 41.43137035400012],
              [42.463071737000064, 41.43183909200009],
              [42.48384566200008, 41.442174377000086],
              [42.513817993000146, 41.47622914700004],
              [42.53552209500003, 41.493489075000056],
              [42.54554732300005, 41.50961212200012],
              [42.55495243300004, 41.55033315100009],
              [42.565184367000086, 41.56712799100005],
              [42.585234822000075, 41.57875518800002],
              [42.586647575000086, 41.579106935000084],
              [42.59091354100008, 41.58016907300002],
              [42.610556274000146, 41.58505971300012],
              [42.660992472000146, 41.588263652000094],
              [42.80093225100006, 41.579220276000044],
              [42.819949178000115, 41.57234731100006],
              [42.812197714000035, 41.56299387700004],
              [42.80889042200005, 41.55291697200009],
              [42.80682336400008, 41.54299509700009],
              [42.80268925000013, 41.53410675100007],
              [42.794627726000044, 41.52682037400008],
              [42.77488732900008, 41.51426300100009],
              [42.766515747000085, 41.504341125000096],
              [42.79214725700007, 41.492868958000074],
              [42.81116418500005, 41.477159323000095],
              [42.829974406000076, 41.47250844400004],
              [42.85457238800012, 41.49379913400013],
              [42.86800826000007, 41.50020701100006],
              [42.87513960800004, 41.493695781],
              [42.880720662000044, 41.48124176100002],
              [42.88898889100011, 41.46997629800005],
              [42.89663700400007, 41.46656565400012],
              [42.926092570000094, 41.459072571],
              [42.93219038900014, 41.45478342700004],
              [42.93622115100004, 41.450235901],
              [42.941078736000065, 41.44630849300002],
              [42.94996708200006, 41.44367299400001],
              [42.95771854600008, 41.43700673400009],
              [42.987587524000105, 41.394683736],
              [43.00205692500003, 41.38269480500004],
              [43.075644165000085, 41.34486765600006],
              [43.12390995300012, 41.31293162100009],
              [43.154760783000086, 41.30187286400009],
              [43.18400964400007, 41.2989789840001],
              [43.185353231000136, 41.293811341],
              [43.171865682000146, 41.279341940000066],
              [43.15724125100007, 41.26973012300006],
              [43.10313602700006, 41.24880116800007],
              [43.13031783000008, 41.2422899380001],
              [43.15233199100004, 41.2441502890001],
              [43.17202071200006, 41.24234161400001],
              [43.19222619600009, 41.224978333000095],
              [43.2162040610001, 41.1805366010001],
              [43.23062178500004, 41.172630107000074],
              [43.322605835000104, 41.19206044600004],
              [43.351751343000046, 41.19361073800006],
              [43.38327396700009, 41.18720286100002],
              [43.41055912200011, 41.17516225200005],
              [43.43758589700013, 41.15619700100008],
              [43.451796916000035, 41.13258087200008],
              [43.44042810000013, 41.10658762600012],
            ],
          ],
          [
            [
              [28.016774936000047, 41.97256094000005],
              [28.03060957100007, 41.92454661700003],
              [28.03093509200005, 41.913763739000046],
              [28.035899285000085, 41.91120026200008],
              [28.04232832100007, 41.90485260600008],
              [28.04656009200005, 41.89712148600006],
              [28.044932488000086, 41.89020416900007],
              [28.035817905000044, 41.88589101800005],
              [28.025645379000082, 41.88735586100006],
              [28.007009311000047, 41.89329661700003],
              [27.990570509000065, 41.89276764500005],
              [27.977549675000034, 41.88735586100006],
              [27.969086134000065, 41.87376536700003],
              [27.966075066000087, 41.848944403000075],
              [27.97201582100007, 41.822251695000034],
              [27.98682701900009, 41.804022528000075],
              [28.004893425000034, 41.78856028900009],
              [28.02125084700009, 41.770412502000056],
              [28.040212436000047, 41.72540924700007],
              [28.051768425000034, 41.71206289300005],
              [28.07007897200009, 41.69940827000005],
              [28.078461134000065, 41.69196198100008],
              [28.083262566000087, 41.68154531500005],
              [28.085785352000073, 41.679754950000074],
              [28.08838951900009, 41.67690664300005],
              [28.08961022200009, 41.670803127000056],
              [28.087087436000047, 41.66705963700008],
              [28.081553582000083, 41.66738515800006],
              [28.07667076900009, 41.66681549700007],
              [28.07593834700009, 41.66054922100005],
              [28.08334394600007, 41.64492422100005],
              [28.097178582000083, 41.62669505400004],
              [28.113291863000086, 41.61155833500004],
              [28.141856316000087, 41.598944403000075],
              [28.156504754000082, 41.58437734600005],
              [28.177744988000086, 41.55817291900007],
              [28.232758009000065, 41.51898834800005],
              [28.384287957000083, 41.44745514500005],
              [28.600840691000087, 41.37750885600008],
              [28.908457879000082, 41.26654694200005],
              [29.00757897200009, 41.249660549000055],
              [29.012868686000047, 41.248114325000074],
              [29.015147332000083, 41.245794989000046],
              [29.017832879000082, 41.24371979400007],
              [29.024261915000068, 41.24282461100006],
              [29.031993035000085, 41.24494049700007],
              [29.038259311000047, 41.254339911000045],
              [29.045176629000082, 41.25641510600008],
              [29.068695509000065, 41.25372955900008],
              [29.093923373000052, 41.24640534100007],
              [29.109222852000073, 41.23529694200005],
              [29.099864129000082, 41.21039459800005],
              [29.086761915000068, 41.19188060100004],
              [29.069346550000034, 41.174709377000056],
              [29.052256707000083, 41.16714101800005],
              [29.04078209700009, 41.16429271000004],
              [29.043304884000065, 41.15766022300005],
              [29.051442905000044, 41.14984772300005],
              [29.057383660000085, 41.14154694200005],
              [29.063731316000087, 41.134466864000046],
              [29.065684441000087, 41.13296133000006],
              [29.070648634000065, 41.130194403000075],
              [29.068695509000065, 41.12445709800005],
              [29.064463738000086, 41.119574286000045],
              [29.06226647200009, 41.11933014500005],
              [29.058604363000086, 41.099595445000034],
              [29.051524285000085, 41.08177317900004],
              [29.042165561000047, 41.06635163000004],
              [29.031504754000082, 41.05385976800005],
              [29.023285352000073, 41.048814195000034],
              [29.00554446700005, 41.04450104400007],
              [28.997325066000087, 41.03986237200007],
              [28.989512566000087, 41.03107330900008],
              [28.98804772200009, 41.02578359600005],
              [28.988536004000082, 41.02163320500006],
              [28.98959394600007, 41.01707591400009],
              [28.992523634000065, 41.013657945000034],
              [28.992360873000052, 41.00820547100005],
              [28.986501498000052, 41.00263092700004],
              [28.981944207000083, 41.001654364000046],
              [28.960459832000083, 41.00299713700008],
              [28.951833530000044, 41.00861237200007],
              [28.946136915000068, 41.009466864000046],
              [28.940440300000034, 41.00682200700004],
              [28.931651238000086, 40.997748114000046],
              [28.928396030000044, 40.995794989000046],
              [28.917491082000083, 40.99359772300005],
              [28.899261915000068, 40.98427969000005],
              [28.859548373000052, 40.97801341400009],
              [28.849945509000065, 40.97528717700004],
              [28.84424889400009, 40.971909898000035],
              [28.840017123000052, 40.967678127000056],
              [28.83375084700009, 40.96393463700008],
              [28.82203209700009, 40.96161530200004],
              [28.797618035000085, 40.962551174000055],
              [28.785980665000068, 40.96564362200007],
              [28.78101647200009, 40.971869208000044],
              [28.770192905000044, 40.97931549700007],
              [28.745290561000047, 40.980169989000046],
              [28.625254754000082, 40.968410549000055],
              [28.595225457000083, 40.97797272300005],
              [28.603526238000086, 41.009466864000046],
              [28.591807488000086, 41.018866278000075],
              [28.584808790000068, 41.02204010600008],
              [28.57553144600007, 41.02366771000004],
              [28.58253014400009, 41.04637278900009],
              [28.572438998000052, 41.066473700000074],
              [28.551931186000047, 41.080511786000045],
              [28.52784264400009, 41.085150458000044],
              [28.53288821700005, 41.07062409100007],
              [28.554535352000073, 41.05365631700005],
              [28.562510613000086, 41.036769924000055],
              [28.562836134000065, 41.026678778000075],
              [28.56031334700009, 41.01227448100008],
              [28.553558790000068, 40.99835846600007],
              [28.541351759000065, 40.989569403000075],
              [28.512461785000085, 40.99266185100004],
              [28.46070397200009, 41.032863674000055],
              [28.43531334700009, 41.04291413000004],
              [28.402191602000073, 41.047308661000045],
              [28.332774285000085, 41.06655508000006],
              [28.298106316000087, 41.07086823100008],
              [28.264008009000065, 41.07086823100008],
              [28.255869988000086, 41.07318756700005],
              [28.244965040000068, 41.08295319200005],
              [28.236664259000065, 41.085150458000044],
              [28.199473504000082, 41.078558661000045],
              [28.181651238000086, 41.07770416900007],
              [28.17473392000005, 41.08083730700008],
              [28.165293816000087, 41.085150458000044],
              [28.117442254000082, 41.07123444200005],
              [28.110036655000044, 41.06777578300006],
              [28.100271030000044, 41.06781647300005],
              [28.044932488000086, 41.050441799000055],
              [28.030121290000068, 41.04759349200003],
              [28.01303144600007, 41.040716864000046],
              [27.997325066000087, 41.03204987200007],
              [27.986582879000082, 41.02366771000004],
              [27.964366082000083, 40.99628327000005],
              [27.957774285000085, 40.983303127000056],
              [27.959239129000082, 40.97528717700004],
              [27.941254102000073, 40.97109609600005],
              [27.86068769600007, 40.97846100500004],
              [27.845713738000086, 40.98607005400004],
              [27.831553582000083, 40.99510325700004],
              [27.815277540000068, 41.00263092700004],
              [27.776133660000085, 41.010972398000035],
              [27.737803582000083, 41.01264069200005],
              [27.524180535000085, 40.98920319200005],
              [27.493174675000034, 40.97528717700004],
              [27.471690300000034, 40.941839911000045],
              [27.446543816000087, 40.86172109600005],
              [27.424815300000034, 40.831284898000035],
              [27.330821160000085, 40.760972398000035],
              [27.287933790000068, 40.703558661000045],
              [27.19825280000009, 40.65314362200007],
              [27.19271894600007, 40.64834219000005],
              [27.182302280000044, 40.636379299000055],
              [27.177744988000086, 40.63263580900008],
              [27.16700280000009, 40.62986888200004],
              [27.142832879000082, 40.627386786000045],
              [27.115244988000086, 40.613714911000045],
              [27.068614129000082, 40.61440664300005],
              [27.047536655000044, 40.612209377000056],
              [27.03060957100007, 40.601548570000034],
              [27.001475457000083, 40.570298570000034],
              [26.989756707000083, 40.563788153000075],
              [26.963552280000044, 40.56102122600004],
              [26.949880405000044, 40.55955638200004],
              [26.911631707000083, 40.55072663000004],
              [26.853688998000052, 40.523138739000046],
              [26.838633660000085, 40.51227448100008],
              [26.821055535000085, 40.503119208000044],
              [26.75945071700005, 40.496161200000074],
              [26.74073326900009, 40.48745351800005],
              [26.70834394600007, 40.465725002000056],
              [26.694590691000087, 40.461371161000045],
              [26.68336022200009, 40.45547109600005],
              [26.67432701900009, 40.42568594000005],
              [26.66382897200009, 40.41356028900009],
              [26.631521030000044, 40.400051174000055],
              [26.624847852000073, 40.39248281500005],
              [26.622894727000073, 40.37571849200009],
              [26.616709832000083, 40.35952383000006],
              [26.601573113000086, 40.346136786000045],
              [26.546722852000073, 40.30756256700005],
              [26.539724155000044, 40.30369700700004],
              [26.510427280000044, 40.298163153000075],
              [26.497243686000047, 40.289943752000056],
              [26.476084832000083, 40.27338288000004],
              [26.475840691000087, 40.269598700000074],
              [26.470876498000052, 40.26585521000004],
              [26.44467207100007, 40.24164459800005],
              [26.426524285000085, 40.23029205900008],
              [26.40365644600007, 40.21942780200004],
              [26.37989342500009, 40.21133047100005],
              [26.35914147200009, 40.20815664300005],
              [26.345550977000073, 40.19977448100008],
              [26.348806186000047, 40.181341864000046],
              [26.361338738000086, 40.16258372600004],
              [26.375824415000068, 40.153509833000044],
              [26.327972852000073, 40.11871979400007],
              [26.31299889400009, 40.11005280200004],
              [26.27312259200005, 40.09259674700007],
              [26.242930535000085, 40.07078685100004],
              [26.230642123000052, 40.064886786000045],
              [26.177582227000073, 40.05072663000004],
              [26.16700280000009, 40.04987213700008],
              [26.157481316000087, 40.05532461100006],
              [26.160004102000073, 40.06720612200007],
              [26.167979363000086, 40.07916901200008],
              [26.173838738000086, 40.08462148600006],
              [26.190196160000085, 40.09422435100004],
              [26.201426629000082, 40.115301825000074],
              [26.209239129000082, 40.136419989000046],
              [26.214691602000073, 40.14606354400007],
              [26.259776238000086, 40.19448476800005],
              [26.27198326900009, 40.23041413000004],
              [26.26693769600007, 40.25775788000004],
              [26.247894727000073, 40.27912018400008],
              [26.21810957100007, 40.296861070000034],
              [26.228526238000086, 40.30345286700009],
              [26.23178144600007, 40.31012604400007],
              [26.227386915000068, 40.315334377000056],
              [26.214691602000073, 40.31736888200004],
              [26.20997155000009, 40.321926174000055],
              [26.219086134000065, 40.33144765800006],
              [26.23218834700009, 40.34003327000005],
              [26.23878014400009, 40.34153880400004],
              [26.250173373000052, 40.34951406500005],
              [26.301442905000044, 40.36469147300005],
              [26.321136915000068, 40.36517975500004],
              [26.336110873000052, 40.38532135600008],
              [26.38575280000009, 40.409857489000046],
              [26.432790561000047, 40.43984609600005],
              [26.491709832000083, 40.45652903900009],
              [26.535899285000085, 40.48550039300005],
              [26.564463738000086, 40.49945709800005],
              [26.595550977000073, 40.51040273600006],
              [26.622894727000073, 40.515326239000046],
              [26.669769727000073, 40.51080963700008],
              [26.683767123000052, 40.515326239000046],
              [26.697276238000086, 40.52643463700008],
              [26.718272332000083, 40.55149974200009],
              [26.732758009000065, 40.563788153000075],
              [26.756195509000065, 40.55483633000006],
              [26.788259311000047, 40.562933661000045],
              [26.816661004000082, 40.580959377000056],
              [26.828949415000068, 40.601996161000045],
              [26.798350457000083, 40.651556708000044],
              [26.79037519600007, 40.660589911000045],
              [26.780528191000087, 40.659369208000044],
              [26.71420332100007, 40.65131256700005],
              [26.69076582100007, 40.642564195000034],
              [26.67750084700009, 40.63947174700007],
              [26.609222852000073, 40.63947174700007],
              [26.582041863000086, 40.63300202000005],
              [26.50562584700009, 40.59857819200005],
              [26.47706139400009, 40.61310455900008],
              [26.461192254000082, 40.617621161000045],
              [26.44467207100007, 40.61904531500005],
              [26.43100019600007, 40.61517975500004],
              [26.415293816000087, 40.60822174700007],
              [26.39975019600007, 40.60415273600006],
              [26.373057488000086, 40.614447333000044],
              [26.356130405000044, 40.61302317900004],
              [26.302582227000073, 40.60114166900007],
              [26.117360873000052, 40.601996161000045],
              [26.091319207000083, 40.60541413000004],
              [26.076914910000085, 40.61180247600004],
              [26.068532748000052, 40.62710195500006],
              [26.06226647200009, 40.645412502000056],
              [26.05372155000009, 40.660589911000045],
              [26.060883009000065, 40.675848700000074],
              [26.058116082000083, 40.697699286000045],
              [26.048106316000087, 40.719631252000056],
              [26.033213738000086, 40.73505280200004],
              [26.040863477000073, 40.73663971600007],
              [26.04395592500009, 40.73847077000005],
              [26.08159102400009, 40.73555084200011],
              [26.11228682500004, 40.746971334000094],
              [26.134507690000078, 40.76712514300009],
              [26.142982625000087, 40.79379018200002],
              [26.158278849000055, 40.81218699100002],
              [26.212022338000054, 40.84743031900011],
              [26.20509769700007, 40.85838572200008],
              [26.205821167000067, 40.865000305000066],
              [26.208715047000055, 40.86841095000001],
              [26.218636922000144, 40.871976623000066],
              [26.215122925000088, 40.87285512300009],
              [26.212539103000097, 40.87311350500009],
              [26.211195516000117, 40.874715475000116],
              [26.211918986000114, 40.87946970600011],
              [26.220910685000064, 40.88133005800002],
              [26.22525150500013, 40.88360382100002],
              [26.226285034000114, 40.88882314000004],
              [26.2261816810001, 40.899313457000105],
              [26.23114261900014, 40.88980499300003],
              [26.232382853000075, 40.885670878],
              [26.23920414200012, 40.885670878],
              [26.246335490000064, 40.89145863900008],
              [26.252226603000082, 40.90055369100004],
              [26.260391480000095, 40.920449118000036],
              [26.266489299000057, 40.920449118000036],
              [26.270003295000095, 40.91481638600003],
              [26.275170939000105, 40.91026886000007],
              [26.28219893400012, 40.907219951000044],
              [26.290673869000102, 40.906134745000045],
              [26.30400638900005, 40.90902862600005],
              [26.303282918000036, 40.91548818000008],
              [26.297288452000117, 40.922412821000066],
              [26.294394572000044, 40.92665028900002],
              [26.30648685700001, 40.93600372300007],
              [26.335012247000066, 40.94623565700006],
              [26.34906823700007, 40.95455556300003],
              [26.359093465000115, 40.96468414300007],
              [26.356199585000127, 40.96814646500009],
              [26.346484416000067, 40.97171213800006],
              [26.33604577600005, 40.98189239500003],
              [26.33315189600006, 40.99072906500005],
              [26.33594242300012, 40.997136943000086],
              [26.344624064000072, 41.00106435200006],
              [26.359610230000044, 41.00240793900009],
              [26.368085164000064, 41.00773061200006],
              [26.37500980700011, 41.01946116200004],
              [26.37418298300011, 41.03114003500012],
              [26.347621297000074, 41.04095855800007],
              [26.33904301000007, 41.051552226000055],
              [26.32509037300008, 41.074083151000096],
              [26.32240319800013, 41.088552552000024],
              [26.33945642100008, 41.11449412100008],
              [26.33232507300005, 41.11904164700009],
              [26.317338908000067, 41.12229726200009],
              [26.317338908000067, 41.130462138],
              [26.33604577600005, 41.15257965100001],
              [26.32416019700011, 41.1698912560001],
              [26.321059611000067, 41.18761627200003],
              [26.32550378500008, 41.20699493500008],
              [26.33604577600005, 41.228905742000066],
              [26.320542846000137, 41.24621734700007],
              [26.331704956000067, 41.254123841000094],
              [26.395060262000072, 41.258981425000016],
              [26.412113484000116, 41.265699361000046],
              [26.438468465000085, 41.283579407],
              [26.466373738000044, 41.297170309000094],
              [26.471954793000066, 41.30192454000009],
              [26.474435262000043, 41.3063687140001],
              [26.478776083000128, 41.30962432900007],
              [26.489318074000096, 41.31086456300004],
              [26.540167684000096, 41.351792298000035],
              [26.550606323000125, 41.34176707000002],
              [26.56962325000009, 41.333602194],
              [26.591120646000064, 41.32931305000004],
              [26.609724162000106, 41.33070831300002],
              [26.62264327000011, 41.34037180600005],
              [26.631738321000086, 41.3575283820001],
              [26.6365959070001, 41.378457337000086],
              [26.636389201000043, 41.399592998000045],
              [26.632151734000104, 41.41974680600002],
              [26.615925333000092, 41.468529358000055],
              [26.610964396000043, 41.50573638900006],
              [26.606106811000103, 41.523047994000066],
              [26.59546146600013, 41.53741404300008],
              [26.60166263900001, 41.54733591700007],
              [26.597838582000065, 41.57327748700003],
              [26.60228275500009, 41.58516306600005],
              [26.598562052000062, 41.590847473000096],
              [26.596288289000142, 41.5975395710001],
              [26.595254760000074, 41.604955139000126],
              [26.59546146600013, 41.612448222000054],
              [26.576444540000068, 41.59100250300004],
              [26.566522664000075, 41.598753967000036],
              [26.521150757000044, 41.61642730800004],
              [26.46441003400011, 41.648518372000055],
              [26.473195028000106, 41.661127421000074],
              [26.47619226000012, 41.675726013000045],
              [26.460379272000125, 41.67877492300009],
              [26.442809286000056, 41.68445933100013],
              [26.404362020000093, 41.691823222000025],
              [26.377386923000074, 41.71063344300005],
              [26.359610230000044, 41.714896749],
              [26.333358602000118, 41.713036397000096],
              [26.323230021000143, 41.723681743000085],
              [26.316305379000084, 41.743758036000045],
              [26.320026082000084, 41.76546213800013],
              [26.334185425000044, 41.789543355],
              [26.37552657100008, 41.81662180600004],
              [26.4783626710001, 41.81328867600003],
              [26.526111694000093, 41.8242440800001],
              [26.539547567000028, 41.83799001100006],
              [26.547815796000094, 41.856283468000115],
              [26.55205326300012, 41.87444773400004],
              [26.552894853000026, 41.88164332500007],
              [26.553603557000145, 41.88770273900006],
              [26.554740438000067, 41.89294789700007],
              [26.55897790500012, 41.901732890000076],
              [26.55980472800013, 41.9073397830001],
              [26.556807495000044, 41.910750427000025],
              [26.54471521000005, 41.91643483500006],
              [26.54295821100007, 41.92036224400003],
              [26.547092326000097, 41.926899312],
              [26.553293497000084, 41.93157603000007],
              [26.560631552000075, 41.935684306],
              [26.589467, 41.95875783400005],
              [26.605693400000092, 41.96741363600002],
              [26.62357344600008, 41.96904144400004],
              [26.717572876000105, 41.95731089300007],
              [26.736744833000103, 41.95896453900012],
              [26.746976766000103, 41.9644939170001],
              [26.76857751500006, 41.98077199400005],
              [26.780566447000126, 41.98343332900005],
              [26.78991988100006, 41.97994517000002],
              [26.808420044000087, 41.967878724000045],
              [26.81942712400007, 41.96565663600005],
              [26.82769535300011, 41.96878306100008],
              [26.837899181000097, 41.975219503000076],
              [26.850019572000093, 41.98286488900003],
              [26.86076826900012, 41.98790334100006],
              [26.871723674000094, 41.988135885000034],
              [26.881128784000055, 41.985526225000044],
              [26.89032718900006, 41.985422873000104],
              [26.901075887000076, 41.993484395000095],
              [26.911462850000078, 41.996791687],
              [26.930221395000075, 41.99451792400008],
              [26.93890303500004, 41.99622324700003],
              [26.950065144000064, 42.006170960000034],
              [26.958230021000105, 42.018237406000125],
              [26.967170044000113, 42.0284951790001],
              [26.981071004000086, 42.032861837],
              [27.000397990000067, 42.04280955000009],
              [27.022618856000094, 42.07389292400005],
              [27.046545044000084, 42.0829363000001],
              [27.047903041000097, 42.08291964900006],
              [27.065510294000035, 42.08270375600004],
              [27.083700398000076, 42.07841461200006],
              [27.100650268000095, 42.071102397000075],
              [27.116049845000077, 42.06182647800007],
              [27.127211954000103, 42.06257578600007],
              [27.149587849000085, 42.06182647800007],
              [27.17382409700008, 42.05707224600006],
              [27.17816491700006, 42.058364156000025],
              [27.178991740000072, 42.06187815400007],
              [27.181575561000074, 42.065883077000066],
              [27.203796427000015, 42.08812978100009],
              [27.216405477000137, 42.09562286400005],
              [27.238212931000078, 42.09792246500008],
              [27.2733529060001, 42.091747132000094],
              [27.305288940000082, 42.07758778900005],
              [27.33247074400009, 42.057433981000074],
              [27.374845418000092, 42.00870310500004],
              [27.39685957800006, 41.98932444300006],
              [27.420837443000096, 41.97371816000002],
              [27.494321330000048, 41.94284149200003],
              [27.50946252400007, 41.93317799900011],
              [27.533182007000107, 41.908063253000094],
              [27.54641117300011, 41.90116444900009],
              [27.56274092600006, 41.90643544500004],
              [27.548891642000086, 41.910879619000056],
              [27.55126875800002, 41.913101705000045],
              [27.55746993000011, 41.91550465900009],
              [27.560673869000084, 41.9176750700001],
              [27.557935018000137, 41.91907033400007],
              [27.55488610800012, 41.920336405000015],
              [27.55209558100006, 41.921835022000025],
              [27.55075199400008, 41.92421213800007],
              [27.572197713, 41.92984486900009],
              [27.582377970000067, 41.93488332200006],
              [27.59054284700011, 41.942893169000044],
              [27.598087606000064, 41.93860402500009],
              [27.60335860200007, 41.93862986300009],
              [27.60687259900004, 41.943513285],
              [27.609301392000106, 41.95348683700003],
              [27.68707442200011, 41.968602193000024],
              [27.723971395000063, 41.96759450300006],
              [27.776164592000043, 41.94612294500003],
              [27.78980717000013, 41.9426864630001],
              [27.802829631000066, 41.943074036],
              [27.81533532700007, 41.946794739000026],
              [27.818280884000075, 41.952866720000046],
              [27.802726278000137, 41.96004974400002],
              [27.804896687000053, 41.96989410400009],
              [27.80494836400007, 41.98343332900005],
              [27.807997274000087, 41.993484395000095],
              [27.81192468200004, 41.99469879200002],
              [27.815955445000043, 41.99513804200005],
              [27.819934529000108, 41.99469879200002],
              [27.824016968000137, 41.993484395000095],
              [27.843033895000104, 41.995758159],
              [27.85223230000011, 41.99544810000002],
              [27.876933634000096, 41.99071970700005],
              [27.903391968000108, 41.98105621300003],
              [27.91703454600011, 41.97790395100007],
              [27.965920451000102, 41.982141419000115],
              [27.981009969000098, 41.978524069000045],
              [28.016774936000047, 41.97256094000005],
            ],
          ],
          [
            [
              [26.060557488000086, 39.837591864000046],
              [26.07715905000009, 39.84467194200005],
              [26.08301842500009, 39.83494700700004],
              [26.08171634200005, 39.799994208000044],
              [26.074961785000085, 39.78489817900004],
              [26.05909264400009, 39.78607819200005],
              [26.026540561000047, 39.80341217700004],
              [25.99708092500009, 39.814154364000046],
              [25.983653191000087, 39.82208893400008],
              [25.978037957000083, 39.83417389500005],
              [25.98601321700005, 39.842230536000045],
              [26.004242384000065, 39.84520091400009],
              [26.04004967500009, 39.845038153000075],
              [26.04623457100007, 39.84406159100007],
              [26.051117384000065, 39.84406159100007],
              [26.055511915000068, 39.84271881700005],
              [26.060557488000086, 39.837591864000046],
            ],
          ],
          [
            [
              [26.01221764400009, 40.16657135600008],
              [26.01221764400009, 40.14606354400007],
              [25.990244988000086, 40.13690827000005],
              [25.96778405000009, 40.13076406500005],
              [25.900401238000086, 40.122748114000046],
              [25.856293165000068, 40.107855536000045],
              [25.765961134000065, 40.09715403900009],
              [25.745290561000047, 40.09829336100006],
              [25.72120201900009, 40.104803778000075],
              [25.709320509000065, 40.10993073100008],
              [25.704356316000087, 40.115301825000074],
              [25.663259311000047, 40.126166083000044],
              [25.663259311000047, 40.13239166900007],
              [25.686208530000044, 40.16083405200004],
              [25.719004754000082, 40.187201239000046],
              [25.759043816000087, 40.206732489000046],
              [25.826914910000085, 40.21662018400008],
              [25.913340691000087, 40.24127838700008],
              [25.925954623000052, 40.24282461100006],
              [25.938243035000085, 40.24164459800005],
              [25.94467207100007, 40.23700592700004],
              [25.950043165000068, 40.22964101800005],
              [25.957855665000068, 40.223089911000045],
              [25.971853061000047, 40.221136786000045],
              [25.971853061000047, 40.21434153900009],
              [25.96924889400009, 40.20600006700005],
              [25.96729576900009, 40.19326406500005],
              [25.967539910000085, 40.18060944200005],
              [25.971853061000047, 40.172756252000056],
              [25.963063998000052, 40.157131252000056],
              [25.972911004000082, 40.153225002000056],
              [25.990977410000085, 40.157456773000035],
              [26.005869988000086, 40.16657135600008],
              [26.01221764400009, 40.16657135600008],
            ],
          ],
          [
            [
              [27.65756269600007, 40.65314362200007],
              [27.673350457000083, 40.65643952000005],
              [27.702403191000087, 40.65302155200004],
              [27.727793816000087, 40.642645575000074],
              [27.732676629000082, 40.62518952000005],
              [27.71420332100007, 40.61469147300005],
              [27.676442905000044, 40.61017487200007],
              [27.65756269600007, 40.60541413000004],
              [27.624522332000083, 40.58307526200008],
              [27.604746941000087, 40.57680898600006],
              [27.58253014400009, 40.58429596600007],
              [27.571543816000087, 40.58466217700004],
              [27.551768425000034, 40.591050523000035],
              [27.535980665000068, 40.601996161000045],
              [27.538910352000073, 40.62335846600007],
              [27.532074415000068, 40.63068268400008],
              [27.526377800000034, 40.639105536000045],
              [27.53101647200009, 40.650091864000046],
              [27.53882897200009, 40.65692780200004],
              [27.545909050000034, 40.66034577000005],
              [27.551524285000085, 40.65770091400009],
              [27.554535352000073, 40.646918036000045],
              [27.57943769600007, 40.65648021000004],
              [27.60523522200009, 40.663275458000044],
              [27.63135826900009, 40.66347890800006],
              [27.65756269600007, 40.65314362200007],
            ],
          ],
          [
            [
              [27.645192905000044, 40.459865627000056],
              [27.653086785000085, 40.46039459800005],
              [27.656993035000085, 40.45750560100004],
              [27.656586134000065, 40.44944896000004],
              [27.645681186000047, 40.44782135600008],
              [27.631521030000044, 40.45376211100006],
              [27.61491946700005, 40.456732489000046],
              [27.596364780000044, 40.45799388200004],
              [27.582041863000086, 40.46552155200004],
              [27.579925977000073, 40.476548570000034],
              [27.590830925000034, 40.48387278900009],
              [27.599131707000083, 40.496527411000045],
              [27.607269727000073, 40.50543854400007],
              [27.640472852000073, 40.494126695000034],
              [27.642100457000083, 40.48725006700005],
              [27.636729363000086, 40.47833893400008],
              [27.635101759000065, 40.466782945000034],
              [27.645192905000044, 40.459865627000056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Laos',
        iso3: 'LAO',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [102.11865523300008, 22.39754872600004],
            [102.12542484500011, 22.383647766000067],
            [102.13136763600005, 22.373725891000063],
            [102.14139286300008, 22.342151591000103],
            [102.14418339000014, 22.33858591700003],
            [102.15286503100009, 22.33248809800007],
            [102.15612064700008, 22.32809560200006],
            [102.15612064700008, 22.32266957600011],
            [102.15281335500009, 22.310835673000085],
            [102.15436364700008, 22.30468617800001],
            [102.16888472500005, 22.289648336000127],
            [102.18619633000003, 22.27838287400006],
            [102.20056237800003, 22.265463766000053],
            [102.20697025600009, 22.245413310000018],
            [102.22624556500011, 22.228411764],
            [102.2864486090001, 22.20004140300007],
            [102.35807214400006, 22.13472239200003],
            [102.38943973800008, 22.11710072800004],
            [102.39879317200013, 22.108884176000018],
            [102.4054077560001, 22.098290508000034],
            [102.41522627800009, 22.0734858200001],
            [102.42215091900005, 22.062220358000033],
            [102.44261478700008, 22.047440898000033],
            [102.46762618000008, 22.03400502500007],
            [102.48287072800014, 22.02139597600005],
            [102.47408573400008, 22.008890280000045],
            [102.4712435300001, 22.005996399000068],
            [102.46907312000008, 22.00284413700011],
            [102.46731612200011, 21.999226786000023],
            [102.46638594600006, 21.995351054000068],
            [102.47806482000004, 21.957575583],
            [102.51589196800012, 21.939178772],
            [102.56023034700007, 21.925432841000074],
            [102.59102950100004, 21.901351624000128],
            [102.62513594600011, 21.828642883000057],
            [102.63459273300009, 21.787766826000066],
            [102.62978682500005, 21.729114075000027],
            [102.63190555900013, 21.706273092000018],
            [102.6368148200001, 21.683638815000066],
            [102.64332605000004, 21.668032532000026],
            [102.65066410300005, 21.657800598000065],
            [102.6534546310001, 21.656301982000045],
            [102.65743371600007, 21.658420716000123],
            [102.71029870600006, 21.659299215000047],
            [102.72115075700009, 21.661676331000095],
            [102.75215661600004, 21.680899964000034],
            [102.77468754100005, 21.707875061000053],
            [102.78667647300011, 21.739914449000068],
            [102.78915694200009, 21.82032297800002],
            [102.80672692900004, 21.8360842900001],
            [102.82646732600011, 21.821304830000074],
            [102.8349422610001, 21.775622864000056],
            [102.83189335200007, 21.73578033500003],
            [102.83514896700007, 21.716453349000076],
            [102.84718957500013, 21.70446441700004],
            [102.86450118000005, 21.705652975000064],
            [102.93700321500006, 21.735056865000033],
            [102.94263594600005, 21.7389842730001],
            [102.94780358900005, 21.737123922000094],
            [102.95602014200011, 21.723946431000016],
            [102.95989587400004, 21.713042705000063],
            [102.96175622600009, 21.701518860000036],
            [102.96082605000004, 21.632840881000064],
            [102.96413334200008, 21.608604635000077],
            [102.97410689300011, 21.586693827000133],
            [102.97493371600007, 21.583903300000074],
            [102.97529545100014, 21.581009420000086],
            [102.97493371600007, 21.57816721600001],
            [102.97410689300011, 21.57532501200005],
            [102.95410811400006, 21.55728993800004],
            [102.91659102400007, 21.51357167600007],
            [102.89499027600004, 21.4952782190001],
            [102.8496700450001, 21.425411682000018],
            [102.86475956200013, 21.432181295000063],
            [102.88475834200005, 21.444066874000086],
            [102.90418868000012, 21.45269683900004],
            [102.91803796400006, 21.45011301700002],
            [102.91679773000004, 21.438640849000095],
            [102.88382816600011, 21.38835968000005],
            [102.87964237500006, 21.36789581300009],
            [102.87881555200005, 21.322162171000045],
            [102.87519820200004, 21.30531565400007],
            [102.86300256400006, 21.29379181000006],
            [102.82915450100012, 21.2858853150001],
            [102.81277307200008, 21.273896383000036],
            [102.80130090300008, 21.254827779000053],
            [102.80915572100008, 21.25059031200003],
            [102.82817264900007, 21.252450663000033],
            [102.85018680900004, 21.251675517000095],
            [102.86512129800008, 21.24619781600002],
            [102.87814375900007, 21.237619527000092],
            [102.88785892800007, 21.226922506000065],
            [102.89297489400008, 21.21508860300007],
            [102.89178633700004, 21.205993551000077],
            [102.88300134300005, 21.186098124000083],
            [102.88300134300005, 21.176434632000067],
            [102.88909916200004, 21.16640940300003],
            [102.89592045100005, 21.164549052000027],
            [102.90418868000012, 21.164187317000128],
            [102.91442061400011, 21.15839955600005],
            [102.92563440000004, 21.141656392000115],
            [102.92588454400004, 21.140639764000113],
            [102.93529789200005, 21.102382304000045],
            [102.94217085800005, 21.084863994000088],
            [102.9468217370001, 21.075872294000035],
            [102.95157596900009, 21.06899932900008],
            [102.95948246300003, 21.065795390000105],
            [102.97410689300011, 21.067655742000014],
            [102.99916996300004, 21.05737213200011],
            [103.0145178630001, 21.04052561500005],
            [103.03710046400005, 20.9954637660001],
            [103.0682096760001, 20.931281636000065],
            [103.08670983900004, 20.9019811000001],
            [103.11528690600005, 20.868391419000076],
            [103.13001469000005, 20.85490387],
            [103.13637089000008, 20.8504596960001],
            [103.14696456000007, 20.846015524000094],
            [103.16505131100007, 20.843690084000045],
            [103.17523156800007, 20.841209615000068],
            [103.18365482600007, 20.837075501000058],
            [103.19709069800012, 20.827825420000053],
            [103.20690922000006, 20.824569804000063],
            [103.21858809400004, 20.824363098],
            [103.22582913700012, 20.826412811000054],
            [103.23812178600014, 20.829892476000012],
            [103.24711348500011, 20.83071930000004],
            [103.2633915610001, 20.82637847900004],
            [103.31982222500005, 20.7978530890001],
            [103.34767582200004, 20.78906809500002],
            [103.3583211670001, 20.78772450800004],
            [103.3637988690001, 20.787621155000025],
            [103.38911460100013, 20.794288275000028],
            [103.39087732000007, 20.794752503000055],
            [103.41123783400008, 20.805604553000094],
            [103.41826582900012, 20.8118057250001],
            [103.42131473900014, 20.81811025000009],
            [103.42658573400007, 20.820694072000023],
            [103.44043501800013, 20.81573313500006],
            [103.45257898000011, 20.804312643000046],
            [103.47087243700008, 20.770877991000063],
            [103.48162113500013, 20.75790720600004],
            [103.48937260000014, 20.75248118100008],
            [103.49733077000008, 20.74834706700004],
            [103.50596073500003, 20.745969951000106],
            [103.5160893150001, 20.745556539000077],
            [103.51614099200009, 20.745349833000134],
            [103.57794600500006, 20.73289581300004],
            [103.59737634300006, 20.722353821000084],
            [103.6360303140001, 20.682821350000054],
            [103.65794112100014, 20.664734599000028],
            [103.66114506000008, 20.66075551400006],
            [103.66538252800007, 20.65827504500008],
            [103.67633793200014, 20.6565180460001],
            [103.6854329840001, 20.657654928000014],
            [103.69762862100009, 20.66153066100007],
            [103.70848067200006, 20.666749980000063],
            [103.71426843300003, 20.67171091800013],
            [103.71375166900009, 20.679824117000024],
            [103.70362308800003, 20.699254456000105],
            [103.70238285300007, 20.70871124300008],
            [103.70724043800004, 20.72183705700006],
            [103.71344161000007, 20.72576446500001],
            [103.72201989700005, 20.726849671000096],
            [103.73437056500006, 20.730932109000022],
            [103.75457605000008, 20.74292104100006],
            [103.7586068120001, 20.749742330000018],
            [103.75519616700007, 20.75940582300005],
            [103.75302575700005, 20.779869690000012],
            [103.75674646000004, 20.795992737000077],
            [103.76516971900008, 20.816249899000084],
            [103.77555668200006, 20.834905091000067],
            [103.78532352700012, 20.84596384700008],
            [103.79643396000006, 20.849529521000036],
            [103.81669112200007, 20.84689402300002],
            [103.82681970200008, 20.847669169000127],
            [103.83575972500006, 20.852268371],
            [103.85048750800013, 20.86477406900009],
            [103.85860070800004, 20.869579976000082],
            [103.93213627200004, 20.89180084300004],
            [103.95218672700008, 20.900275778000022],
            [103.96231530800003, 20.902704570000097],
            [103.97399418100008, 20.902342834000095],
            [104.01058109600012, 20.90807891900006],
            [104.05667647300004, 20.95882517500003],
            [104.09228153500004, 20.961202291000077],
            [104.09915450000011, 20.95768829400002],
            [104.11424401900013, 20.94704294900005],
            [104.12261560100006, 20.943167216000077],
            [104.13207238800004, 20.941668600000085],
            [104.1547583410001, 20.941255188000056],
            [104.1654036870001, 20.939756571000046],
            [104.19387740100012, 20.92988637300006],
            [104.20126713100007, 20.925442200000063],
            [104.20710656700004, 20.917639059000052],
            [104.21754520700006, 20.897020162000032],
            [104.22105920500013, 20.89200754800008],
            [104.22803552300013, 20.892317607000066],
            [104.25056644700004, 20.898260397000072],
            [104.26002323400013, 20.89893219100007],
            [104.2690666100001, 20.89619333900002],
            [104.27893680900007, 20.891542460000053],
            [104.28787683200005, 20.885754700000078],
            [104.29526656100006, 20.879811910000072],
            [104.30720381700013, 20.864619039000033],
            [104.3232235110001, 20.833871562000084],
            [104.33634932500007, 20.819040426000058],
            [104.34466923000008, 20.813666077000093],
            [104.36032719000008, 20.80808502200007],
            [104.36797530100006, 20.80312408500002],
            [104.37334965100013, 20.795734354000032],
            [104.38166955600008, 20.778371074000106],
            [104.38905928600008, 20.770981343000088],
            [104.4093164470001, 20.76519358400013],
            [104.43215743000007, 20.765762024000068],
            [104.45262129700006, 20.763591614000077],
            [104.46616052300004, 20.74963897700009],
            [104.47566898600007, 20.718219706000056],
            [104.49230879700013, 20.702096660000066],
            [104.54388187700005, 20.678738912000128],
            [104.60072595200006, 20.660548808],
            [104.6151953530001, 20.646492819000073],
            [104.61407088800007, 20.642615605000074],
            [104.60723718300005, 20.619052632000106],
            [104.54264164200009, 20.53569854800007],
            [104.52073083500005, 20.519265442000105],
            [104.4958227950001, 20.511927389],
            [104.46967452100006, 20.51616485700005],
            [104.44497318500004, 20.53461334200007],
            [104.42378584800008, 20.49544260700013],
            [104.4236824950001, 20.49544260700013],
            [104.36642500900012, 20.45849395800009],
            [104.35981042500003, 20.439735413000093],
            [104.39153975500005, 20.42066680900011],
            [104.43236413600005, 20.411054992000103],
            [104.57550785300003, 20.414052226000123],
            [104.58935713800008, 20.40681752600004],
            [104.61230147300012, 20.376741842000072],
            [104.62842452000012, 20.365812277000103],
            [104.66640669800012, 20.3517821250001],
            [104.68092777600009, 20.34098175000007],
            [104.68464847900009, 20.33304941900009],
            [104.68769738800012, 20.321706442000036],
            [104.68929935800003, 20.310001729000035],
            [104.68862756400006, 20.301035869000103],
            [104.68185795100004, 20.28747080500004],
            [104.67410648600003, 20.28530039500005],
            [104.66583825700008, 20.28571380600006],
            [104.6573633220001, 20.2796159870001],
            [104.65353926600005, 20.266464336000112],
            [104.65198897400012, 20.24610382100009],
            [104.65302250200011, 20.225794983000057],
            [104.65705326400007, 20.212695007000022],
            [104.69084965000008, 20.1965461220001],
            [104.7335860600001, 20.204762675000055],
            [104.77880293800007, 20.21902537000004],
            [104.81916223200005, 20.22098907500005],
            [104.90799401900006, 20.175332947000058],
            [104.90897587100005, 20.1678140260001],
            [104.90344649300005, 20.157091166],
            [104.90489343200005, 20.134637757000107],
            [104.91838098200009, 20.11572418200005],
            [104.95687992400013, 20.09179799400006],
            [104.96442468300012, 20.076088359],
            [104.96116906800012, 20.072109274000113],
            [104.9474748130001, 20.069525452],
            [104.94396081600013, 20.067096659000057],
            [104.94365075700006, 20.06094716400007],
            [104.9464412850001, 20.05218800900009],
            [104.94830163600011, 20.033662008000064],
            [104.95145389900006, 20.021518046000054],
            [104.95321089700008, 20.009270732000047],
            [104.94949019400013, 19.995498963],
            [104.94568809100014, 19.992373264000022],
            [104.93569258700012, 19.98415598600012],
            [104.9224634200001, 19.982243958000097],
            [104.89290450100009, 19.98549957300007],
            [104.8738358970001, 19.982657369000023],
            [104.86902998900007, 19.977748108000057],
            [104.86716963700007, 19.969143982000034],
            [104.85791955600007, 19.955217184000063],
            [104.83533695500012, 19.93888743100011],
            [104.78066328900007, 19.90808827800005],
            [104.76180139200005, 19.885505677000097],
            [104.75554854400013, 19.86700551300008],
            [104.76071618700007, 19.861450297000076],
            [104.79027510600008, 19.859667460000097],
            [104.80924035700014, 19.853672994000064],
            [104.81663008600003, 19.84809194000003],
            [104.8168884690001, 19.83899688700008],
            [104.81507979400004, 19.82240875300006],
            [104.8050028890001, 19.7908861290001],
            [104.78521081600013, 19.77693349200011],
            [104.76071618700007, 19.766520691000082],
            [104.73673832200012, 19.745669251000024],
            [104.71777307200006, 19.74019154900013],
            [104.70418217000008, 19.738692932000035],
            [104.69167647400008, 19.735463155000033],
            [104.67596683800014, 19.72468861900002],
            [104.66304773000013, 19.711226908000057],
            [104.65477950100006, 19.697971904000056],
            [104.62305017100005, 19.618080139000043],
            [104.61426517700005, 19.60743479500006],
            [104.60496342000005, 19.606478780000103],
            [104.58780684400006, 19.615961406000068],
            [104.57922855600003, 19.61802846300013],
            [104.57023685700011, 19.615289612000097],
            [104.55483728000013, 19.605445252000024],
            [104.54615564000005, 19.601931254000064],
            [104.52279789300013, 19.59937327100006],
            [104.50584802300011, 19.602809753000102],
            [104.4491073000001, 19.635159200000075],
            [104.42378584800008, 19.645778707000076],
            [104.41541426700013, 19.650817159000056],
            [104.40125492400006, 19.66443389900003],
            [104.39174646000009, 19.676836243000096],
            [104.38006758600005, 19.685285340000107],
            [104.36001713100006, 19.687455750000098],
            [104.34187870300013, 19.683011577000073],
            [104.29526656100006, 19.65487375900004],
            [104.27702478100014, 19.683890076000026],
            [104.24214318800006, 19.695181376000093],
            [104.22896569900007, 19.706007589000038],
            [104.20020338600006, 19.698586072000055],
            [104.15816898600013, 19.687739970000067],
            [104.13630985600003, 19.687455750000098],
            [104.13124556500003, 19.682443136000032],
            [104.12447595200007, 19.67590606700007],
            [104.1171895760001, 19.660997417000104],
            [104.10923140500006, 19.65487375900004],
            [104.08871586200007, 19.651902364000037],
            [104.06969893400009, 19.6580260220001],
            [104.02174320500006, 19.681435445000048],
            [104.01027103700005, 19.684561869],
            [104.00096927900012, 19.68073781300008],
            [103.99518151900003, 19.664898987000058],
            [103.99766198800012, 19.652522482],
            [104.0173507080001, 19.600406800000044],
            [104.02892623000014, 19.586040752000045],
            [104.06019047100011, 19.568160706000086],
            [104.07155928500009, 19.559143169000023],
            [104.07796716400003, 19.542890930000013],
            [104.0792590740001, 19.52570851600005],
            [104.0825146890001, 19.509301250000092],
            [104.09398685700012, 19.495581157000075],
            [104.09414188700003, 19.49552948000006],
            [104.0899560960001, 19.483669739000035],
            [104.08127445500003, 19.479303080000037],
            [104.07052575800003, 19.477029317000117],
            [104.06050052900008, 19.471293234000072],
            [104.05404097500013, 19.460570374000056],
            [104.04990686100012, 19.43747100800006],
            [104.04654789300008, 19.427497457000058],
            [104.03879642800013, 19.41338979100003],
            [104.03827966400007, 19.412924703],
            [104.03512740100012, 19.416671244000028],
            [104.02039961800011, 19.414991761000053],
            [103.99668013600007, 19.406930237000083],
            [103.97399418100008, 19.395664775000014],
            [103.95280684400012, 19.39096221900003],
            [103.94102461800003, 19.38135040300004],
            [103.92128422100006, 19.352773336000055],
            [103.90588464400008, 19.34179209400007],
            [103.87002120000005, 19.32688344300003],
            [103.85674035700004, 19.317194112],
            [103.8484204510001, 19.299908346000095],
            [103.85854903200004, 19.295334981000067],
            [103.87673913600008, 19.295800069000066],
            [103.89265547700012, 19.293888041000073],
            [103.90588464400008, 19.27003936800007],
            [103.91094893400009, 19.263011373000083],
            [103.91797692900008, 19.258153788000058],
            [103.94314335100012, 19.245596415000037],
            [103.97275394700006, 19.225287577000117],
            [103.97399418100008, 19.225287577000117],
            [103.99518151900003, 19.233840027000056],
            [104.01616215000007, 19.23487355500002],
            [104.03672937000005, 19.23024851500007],
            [104.1477303470001, 19.182887065],
            [104.18783125900012, 19.15658376100005],
            [104.19811486900011, 19.14694610600013],
            [104.20173221900006, 19.127050680000124],
            [104.2018355720001, 19.10917063400008],
            [104.21062056500011, 19.100747376000086],
            [104.23955936700003, 19.108886414],
            [104.25960326300009, 19.104129804000067],
            [104.25991988100009, 19.104054668000074],
            [104.27433760600007, 19.0934609990001],
            [104.28725671400008, 19.08049021400008],
            [104.30286299700003, 19.068656312000073],
            [104.32198327700013, 19.060465597000032],
            [104.33913985200013, 19.055194601000025],
            [104.35515954700008, 19.047882385000023],
            [104.37200606400006, 19.033568014000124],
            [104.40073815900013, 18.99227854400003],
            [104.41324385600007, 18.983105977000022],
            [104.4310722250001, 18.979333598],
            [104.46212976100003, 18.982408346000042],
            [104.48093998200005, 18.97770579000006],
            [104.49768314700009, 18.967990621000112],
            [104.50987878500007, 18.95636342400006],
            [104.54429528800006, 18.906805725000098],
            [104.55607751500003, 18.896470439000083],
            [104.58966719600005, 18.879107157000064],
            [104.60398156700006, 18.868694357000024],
            [104.63121504700007, 18.842365215000072],
            [104.64620121300004, 18.832546692],
            [104.65632979300011, 18.829704489000036],
            [104.67565677900006, 18.828205872000026],
            [104.68557865500003, 18.824769389],
            [104.69084965000008, 18.819317525000102],
            [104.70252852400006, 18.80247100800004],
            [104.71027998900007, 18.796088969000024],
            [104.72195886300011, 18.792006531000098],
            [104.76288659700003, 18.786451314000075],
            [104.80164392100005, 18.775134176],
            [104.81538985200012, 18.77366139700011],
            [104.87290572100005, 18.777976380000084],
            [104.89936405400005, 18.770612488000083],
            [104.90923425300008, 18.7456786100001],
            [104.91972456900004, 18.735575867000065],
            [104.93724287900011, 18.73115753200007],
            [104.95687992400013, 18.731674297],
            [104.97382979400004, 18.73606679300009],
            [104.99015954600009, 18.733017884000063],
            [105.04033736200012, 18.70500925800006],
            [105.06457360900004, 18.696637675000076],
            [105.07697595200005, 18.697516175000104],
            [105.08865482600004, 18.700565084000047],
            [105.10028202300003, 18.702063701000057],
            [105.1126843670001, 18.698342998000058],
            [105.14110640500013, 18.65307444300005],
            [105.16286218300013, 18.63899261500002],
            [105.16947676600012, 18.630569356000038],
            [105.16947676600012, 18.61832716700009],
            [105.16947676600012, 18.61485972100006],
            [105.16208703600012, 18.598194072000027],
            [105.15206180900009, 18.59679880800006],
            [105.1403312590001, 18.600467834000042],
            [105.12813562100007, 18.598917542000024],
            [105.11361454300004, 18.580830790000036],
            [105.10048872900006, 18.551168519000058],
            [105.08524418200005, 18.495771383000104],
            [105.07997318600007, 18.454352722000053],
            [105.09077356000012, 18.42652496300009],
            [105.11397627800005, 18.405130920000076],
            [105.14544722500011, 18.383168437],
            [105.16286218300013, 18.366011861000047],
            [105.16224206600003, 18.353893738000053],
            [105.15598921700007, 18.340638733000063],
            [105.15666101100004, 18.319838969],
            [105.16616947400013, 18.30679067000007],
            [105.21474532100012, 18.2778518680001],
            [105.2204814050001, 18.270798035000084],
            [105.22926639800005, 18.255320944000076],
            [105.23593265800008, 18.249455669000085],
            [105.24647465100003, 18.24638092100004],
            [105.25691977000008, 18.24746373600003],
            [105.28311324100008, 18.250179138000064],
            [105.28802250200005, 18.253408916000055],
            [105.29251835100007, 18.252737122000084],
            [105.29928796500008, 18.242040100000068],
            [105.30083825700012, 18.23092966700004],
            [105.29437870300006, 18.206951803000024],
            [105.29505049700003, 18.195608826000054],
            [105.3055924890001, 18.1810619110001],
            [105.32187056500004, 18.170080669000114],
            [105.34011234500008, 18.1626392620001],
            [105.35592533400006, 18.15873769100004],
            [105.36331506400006, 18.15522369400007],
            [105.36553715000008, 18.151037903000045],
            [105.36832767800013, 18.149952698000035],
            [105.37747440600003, 18.155688782000098],
            [105.38155684500003, 18.162768453000027],
            [105.3861043710001, 18.184937642000065],
            [105.39199548300007, 18.19421356200006],
            [105.41003055900006, 18.201887512000056],
            [105.43137292500006, 18.200543925000076],
            [105.45142338100004, 18.192714946000066],
            [105.4667196040001, 18.180958558000057],
            [105.47281742300004, 18.17199269700005],
            [105.48087894700012, 18.14481089300004],
            [105.48118900500003, 18.13871307400008],
            [105.47912194900005, 18.13349375400007],
            [105.47684818600004, 18.12964386000003],
            [105.4760213620001, 18.127318421],
            [105.48062056500004, 18.123649394],
            [105.49198938000006, 18.12106557200009],
            [105.49607181900006, 18.118145854000105],
            [105.51250492300011, 18.082825013],
            [105.52066980000012, 18.07590037100003],
            [105.53813643500007, 18.066727804000024],
            [105.54650801700006, 18.058950501000126],
            [105.55188236500004, 18.047943420000124],
            [105.55555139200004, 18.02515411400013],
            [105.55932377100004, 18.015335592000056],
            [105.5661450610001, 18.008255920000053],
            [105.58981286600005, 17.995750224000048],
            [105.58981286600005, 17.995595194000103],
            [105.60343050400013, 17.96918391700011],
            [105.60603926600004, 17.96412424800006],
            [105.59415368700007, 17.888108215],
            [105.60521244300003, 17.854260153],
            [105.64396976700004, 17.820102031000104],
            [105.66980798400004, 17.77307647700006],
            [105.69202884900011, 17.744085999000063],
            [105.7012272550001, 17.7276012170001],
            [105.71383630400004, 17.68946400900002],
            [105.72308638500004, 17.67349599300009],
            [105.73528202400007, 17.664039205000037],
            [105.7874235430001, 17.642076722000056],
            [105.81987634300003, 17.62156117800008],
            [105.84602461800006, 17.597996725000073],
            [105.91113692300013, 17.51681305000001],
            [105.93216923100005, 17.495729065000077],
            [105.93232426000009, 17.495729065000077],
            [106.01929569500004, 17.394494934000093],
            [106.18543542500004, 17.257397360000127],
            [106.20729455600008, 17.2462869270001],
            [106.22181563400005, 17.244891663000132],
            [106.23339115400006, 17.25197133400006],
            [106.24791223200003, 17.26623402900013],
            [106.25235640500006, 17.2745539350001],
            [106.2547851970001, 17.283183899000036],
            [106.2599528400001, 17.289230042000085],
            [106.27261356600013, 17.28985015900004],
            [106.28455082300007, 17.28478586800007],
            [106.28666955600005, 17.27656931600005],
            [106.28568770400011, 17.265975647000076],
            [106.28796146600013, 17.253780010000057],
            [106.29312911000011, 17.246907043000093],
            [106.30697839400005, 17.232954407000094],
            [106.31054406800007, 17.227114970000102],
            [106.30976892200005, 17.21791656500001],
            [106.30165572100003, 17.202000224000088],
            [106.30082889900012, 17.19156158500006],
            [106.30635827700013, 17.17652374300006],
            [106.33653731300012, 17.128568014000038],
            [106.38464807100007, 17.085366516000093],
            [106.39493168100006, 17.068003235000063],
            [106.39436324100012, 17.062215474000098],
            [106.38790368700006, 17.051673482000027],
            [106.38712854000005, 17.047177633000032],
            [106.40401984100004, 17.014641771000058],
            [106.40883264200005, 17.005371399000055],
            [106.41136478700002, 16.995811259000064],
            [106.41136478700002, 16.99570790700004],
            [106.42025313300007, 16.988679912000023],
            [106.43720300300009, 16.98046335800008],
            [106.4565299890001, 16.973590393000038],
            [106.47373824100009, 16.97069651300005],
            [106.49683760600004, 16.963926901],
            [106.5245361740001, 16.989248353000065],
            [106.5334245200001, 16.97266021700007],
            [106.53355047300005, 16.95063806000003],
            [106.53507816600006, 16.683530579000106],
            [106.54065922100006, 16.65913930300009],
            [106.54975427300013, 16.637796936000072],
            [106.57244022700013, 16.613560689000096],
            [106.59140547700008, 16.60245025600007],
            [106.61155928600004, 16.59459543900006],
            [106.62494348100006, 16.59351023400005],
            [106.6401880300001, 16.586637268000075],
            [106.64432214400006, 16.575320129000104],
            [106.63967126500006, 16.52178334600005],
            [106.6411698820001, 16.510362854000064],
            [106.65517419500009, 16.470830384000024],
            [106.67067712400012, 16.44442372600004],
            [106.69289799000006, 16.42788726900004],
            [106.72266361500004, 16.432486471000104],
            [106.72256026200012, 16.421634420000046],
            [106.72571252500006, 16.417138571000024],
            [106.73248213700009, 16.417551982000035],
            [106.74240401200007, 16.421531067000032],
            [106.75151087800009, 16.428268290000048],
            [106.75253259300013, 16.429024150000046],
            [106.75439294400013, 16.436568909000115],
            [106.7545996500001, 16.4442686980001],
            [106.75914717600006, 16.452485250000038],
            [106.78612227400009, 16.469125061000042],
            [106.79733606000013, 16.479460347000057],
            [106.80141849800003, 16.496100159],
            [106.82286421800006, 16.530981751000056],
            [106.84668705300004, 16.530051575000115],
            [106.86405033400013, 16.504058330000035],
            [106.86684086200012, 16.46385406500012],
            [106.86260339400013, 16.430574443000083],
            [106.86136315900012, 16.42788726900004],
            [106.85821089700005, 16.424631653000077],
            [106.85588545700011, 16.420342509000093],
            [106.85588545700011, 16.414658102000047],
            [106.85986454300013, 16.411815898000086],
            [106.86653080200011, 16.414037984000075],
            [106.87283532700013, 16.41734527600009],
            [106.8762976490001, 16.41801707000006],
            [106.88844161000009, 16.390886943000098],
            [106.89774336800008, 16.37853627500003],
            [106.91500329600007, 16.3647386680001],
            [106.93949792500013, 16.351716207000052],
            [106.94600915500013, 16.346135153000134],
            [106.95066003400007, 16.33631663100006],
            [106.9540706790001, 16.313837383000063],
            [106.95655114800007, 16.307067769000028],
            [106.96729984600012, 16.299884745000057],
            [106.98021895400012, 16.298334453000038],
            [107.01432539900009, 16.29941965700006],
            [107.05339278200006, 16.295233866],
            [107.06798023900012, 16.290809443000043],
            [107.07060103400005, 16.290014547000098],
            [107.08910119600012, 16.28107452400006],
            [107.10827315300003, 16.267483623000075],
            [107.11685144100005, 16.25461619000008],
            [107.12749678600011, 16.200976054000094],
            [107.13333622300013, 16.188211975000044],
            [107.13599030600005, 16.18478378400006],
            [107.14201786300009, 16.176998189000088],
            [107.15436853100005, 16.166042786],
            [107.1696647550001, 16.156896057000026],
            [107.18320398000009, 16.153227030000025],
            [107.19715661600003, 16.15100494400012],
            [107.21281457600003, 16.146664123000036],
            [107.23880782100008, 16.12981760600006],
            [107.27591150000006, 16.084032288000017],
            [107.29895918800003, 16.06418853800004],
            [107.32686446200012, 16.056075338000127],
            [107.35590661600008, 16.059279276],
            [107.41151045700008, 16.07307688400006],
            [107.43104414900012, 16.0736970010001],
            [107.43564335200006, 16.068839417000092],
            [107.43342126500005, 16.057367248000062],
            [107.43329211500003, 16.0554609980001],
            [107.4321293540001, 16.038298645000097],
            [107.43672855600005, 16.0268781540001],
            [107.44354984600011, 16.018919984000135],
            [107.44473840300003, 16.0099799610001],
            [107.43269779500014, 15.995923971000067],
            [107.41802168800007, 15.983573303000028],
            [107.39063317900013, 15.935824280000062],
            [107.37554366000012, 15.9190811160001],
            [107.36107425900008, 15.912311504000073],
            [107.32293705300003, 15.905851950000013],
            [107.30505700700007, 15.899134013],
            [107.23565555900012, 15.855519104000038],
            [107.22723230000003, 15.853297018000134],
            [107.21808557100013, 15.854795634000041],
            [107.20883549000013, 15.859136454000023],
            [107.19860355700013, 15.862082011000027],
            [107.18625288900006, 15.859394837000096],
            [107.1752458090001, 15.848542786000039],
            [107.1501827400001, 15.794282532000082],
            [107.14878747600011, 15.773456930000052],
            [107.16025964400012, 15.75872914600005],
            [107.21529504400007, 15.727516581000046],
            [107.2256820070001, 15.716819560000047],
            [107.23002282800007, 15.702401836000135],
            [107.23457035300004, 15.660931498000068],
            [107.23911787900005, 15.645118510000074],
            [107.24872969600005, 15.631088358000042],
            [107.2654211840001, 15.61866017700008],
            [107.30355839000003, 15.599746603000042],
            [107.31642582200004, 15.588739523000058],
            [107.36934248900013, 15.496057841000052],
            [107.38164147900005, 15.488538920000039],
            [107.3886694740001, 15.492518005000093],
            [107.3949740000001, 15.501483867000033],
            [107.40505090300013, 15.508589376000074],
            [107.41223392800009, 15.508796082000018],
            [107.4321293540001, 15.503886821],
            [107.43796879100006, 15.505592143000044],
            [107.44298140500013, 15.509209494000046],
            [107.44789066600009, 15.508124288000047],
            [107.45336836800004, 15.49590281200004],
            [107.45646895400012, 15.488332214000067],
            [107.4608097740001, 15.484378967000097],
            [107.46654585800013, 15.48435312900007],
            [107.4737805580001, 15.488254700000041],
            [107.48747481300012, 15.481407572000094],
            [107.49016198700008, 15.46151214600009],
            [107.48964522300002, 15.437921855000056],
            [107.49393436700007, 15.42004180900011],
            [107.51264123600009, 15.409422302000024],
            [107.55558435100005, 15.415752665000042],
            [107.57315433800011, 15.411230977000116],
            [107.57635973700013, 15.403053568000118],
            [107.57770186400006, 15.399629619000066],
            [107.57987227400014, 15.361234030000034],
            [107.58659021000005, 15.343353984000075],
            [107.59847578900008, 15.33061574300011],
            [107.6430725510001, 15.297852885000111],
            [107.65759362800003, 15.282427470000115],
            [107.66410485900013, 15.268552348000057],
            [107.66436324000011, 15.25315277100006],
            [107.65681848200006, 15.205687969000067],
            [107.65397627800007, 15.199564311000103],
            [107.64746504800007, 15.197652283000082],
            [107.6426074630001, 15.20245819100009],
            [107.63671635000009, 15.205067851000095],
            [107.62725956300011, 15.196515402000074],
            [107.62359053600011, 15.187239482000052],
            [107.6213167730001, 15.154528300000067],
            [107.61578739400011, 15.1355113730001],
            [107.60540043200007, 15.120602722000058],
            [107.59919926000009, 15.114789124000069],
            [107.58498824100013, 15.10429880800011],
            [107.58049239100012, 15.096754049000069],
            [107.58080245000008, 15.086935527],
            [107.59000085500008, 15.068900452],
            [107.58907067900003, 15.058177592000092],
            [107.57801192200003, 15.047248027000109],
            [107.56261234600004, 15.045801087000115],
            [107.5352238370001, 15.05040028900008],
            [107.51899743600012, 15.048849996000058],
            [107.50238603900004, 15.044037437000028],
            [107.4737805580001, 15.035750021000098],
            [107.45507369000012, 15.03412221300006],
            [107.44556522700003, 15.02538889600008],
            [107.44468672700003, 15.011823833000093],
            [107.45140466300012, 14.995933329000081],
            [107.44990604700013, 14.98110219300014],
            [107.45393680900003, 14.96787302600005],
            [107.46194665600007, 14.956814270000052],
            [107.4737805580001, 14.948235982000114],
            [107.4894901940001, 14.940303650000061],
            [107.54964156100004, 14.895267640000029],
            [107.55816817300013, 14.886715190000103],
            [107.55532596900008, 14.876199036000045],
            [107.54059818500008, 14.856846212000079],
            [107.49884362900013, 14.817649638000134],
            [107.49088545800004, 14.804239604000088],
            [107.49429610200008, 14.78876251300008],
            [107.5043213300001, 14.773182068000054],
            [107.50928226700006, 14.758635152000096],
            [107.49806848200012, 14.74594858900005],
            [107.50442468300014, 14.736285095000127],
            [107.51465661700013, 14.728223572000047],
            [107.52225305200005, 14.71868927000014],
            [107.52039270000006, 14.704581605000016],
            [107.50690515100013, 14.693445333000085],
            [107.4737805580001, 14.646264750000071],
            [107.45822595200008, 14.638797506000046],
            [107.45176639800013, 14.632182923000045],
            [107.44380822800008, 14.609548645000089],
            [107.44044926000004, 14.60391591400007],
            [107.43326623600012, 14.594329936000065],
            [107.43032067900009, 14.586242574000067],
            [107.42975223800005, 14.578336080000014],
            [107.43094079600007, 14.569886983000117],
            [107.43094079600007, 14.561386210000109],
            [107.42784021000011, 14.553712260000026],
            [107.41492110200011, 14.543428650000124],
            [107.40344893500003, 14.543893738000051],
            [107.38014286400005, 14.55404815700011],
            [107.36138431900008, 14.557923889000065],
            [107.35156579700009, 14.561618754000065],
            [107.33270389800009, 14.578232727000085],
            [107.30567712400006, 14.597223816000053],
            [107.28728031400004, 14.598515727000091],
            [107.27219079600013, 14.585364075000115],
            [107.25451745600003, 14.560972799000098],
            [107.24945316600008, 14.556631978000027],
            [107.23787764500003, 14.549810690000058],
            [107.23389855900012, 14.544927267000034],
            [107.23239994400012, 14.538312683000044],
            [107.23028120900005, 14.518262228000083],
            [107.21973921800009, 14.497979228000077],
            [107.21121260600006, 14.493457540000051],
            [107.19596805900005, 14.495963847000041],
            [107.19581302900008, 14.495963847000041],
            [107.19560632300005, 14.496067200000056],
            [107.19550297100011, 14.496118877000072],
            [107.18056848200013, 14.496170553000084],
            [107.17245528200004, 14.484259136000048],
            [107.16682255100011, 14.467154236000098],
            [107.15870935100003, 14.45152211500006],
            [107.13142419500008, 14.42754425000004],
            [107.10078007000004, 14.40762298600012],
            [107.07855920500003, 14.400775859000063],
            [107.06786218300005, 14.406124370000029],
            [107.05933557200012, 14.418035787000065],
            [107.04295414300003, 14.430722351000014],
            [107.03034509300005, 14.436096701000068],
            [107.02724450800008, 14.435269877000039],
            [107.02657271300012, 14.430231425000073],
            [106.99737552900007, 14.395143128000129],
            [106.97794519100006, 14.36542917900006],
            [106.97365604700013, 14.363026225000112],
            [106.96109867400003, 14.360390727000095],
            [106.95014327000013, 14.334862569000066],
            [106.94972985800013, 14.32866139800008],
            [106.94611250800006, 14.323519592000082],
            [106.93360681200005, 14.320160624000067],
            [106.9234782310001, 14.321917623000047],
            [106.90477136300012, 14.333312277000047],
            [106.89567631000006, 14.33630950900006],
            [106.88508264200004, 14.335534363000136],
            [106.87929488100008, 14.332692159000075],
            [106.87459232600003, 14.328351339000093],
            [106.83583500200007, 14.307060649000107],
            [106.8208488360001, 14.30757741400005],
            [106.80689620000004, 14.312925924000098],
            [106.79299524000004, 14.322589417000117],
            [106.7666919350001, 14.348324280000028],
            [106.73165531400008, 14.396719259000065],
            [106.72390385000006, 14.411602071000104],
            [106.71925297100012, 14.41788075800011],
            [106.7115015060001, 14.425838928000076],
            [106.70716068500013, 14.429301250000023],
            [106.63440026900003, 14.450901998000091],
            [106.62204929000006, 14.457593943000091],
            [106.60535811400007, 14.46663747100007],
            [106.5856693930001, 14.495963847000041],
            [106.57538578300012, 14.502009990000076],
            [106.55244144700009, 14.506945089000112],
            [106.54375980700013, 14.51211273200002],
            [106.54024580900006, 14.521672873000114],
            [106.53497481300013, 14.553247172000098],
            [106.53099572800005, 14.56595957500005],
            [106.51843835500006, 14.585002340000116],
            [106.51249556500011, 14.590350851000082],
            [106.49104984600007, 14.570998027000115],
            [106.48376346800012, 14.56748402900007],
            [106.47714888600012, 14.566889751000105],
            [106.47223962400011, 14.56407338400004],
            [106.47058597900013, 14.554254862000064],
            [106.47094771400003, 14.544643046000061],
            [106.47316980000005, 14.537485861000022],
            [106.47751062100014, 14.532602438000083],
            [106.48484867400003, 14.530018616000078],
            [106.48484867400003, 14.523817444000102],
            [106.46944909700005, 14.524695944000129],
            [106.45668501800009, 14.527899882000014],
            [106.44578129100012, 14.529088440000038],
            [106.43647953400006, 14.523817444000102],
            [106.4343091230001, 14.519605815000148],
            [106.43265547700003, 14.512422790000102],
            [106.43358565300008, 14.505704855000076],
            [106.44516117400013, 14.499477845000087],
            [106.44082035300005, 14.492630717000026],
            [106.43348230000004, 14.486636251000093],
            [106.42950321500007, 14.485964457000108],
            [106.41921960500008, 14.466456604000115],
            [106.39379480000008, 14.456172994000028],
            [106.33999907000009, 14.448987947000077],
            [106.33343672700005, 14.448111470000129],
            [106.32015588400009, 14.444494120000044],
            [106.30646163000006, 14.445475973000015],
            [106.29674646000012, 14.447878926000072],
            [106.23597497600008, 14.484362488000073],
            [106.23008386200007, 14.490460307000134],
            [106.22078210500007, 14.473484599000116],
            [106.21065352400012, 14.421394756000069],
            [106.20393558800009, 14.399897360000125],
            [106.18915612900008, 14.378890890000022],
            [106.17323978700006, 14.369666646000027],
            [106.15411950700013, 14.367547913000038],
            [106.11903121000012, 14.369511618000075],
            [106.09500166800007, 14.3736457320001],
            [106.07944706200004, 14.372715556000045],
            [106.06864668800011, 14.373439026000128],
            [106.06353072100012, 14.372922261000099],
            [106.06058516500013, 14.36883982400009],
            [106.05810469600004, 14.353104350000109],
            [106.05541752200003, 14.348427633000142],
            [106.03815759300005, 14.347652486000129],
            [105.99412927300006, 14.36240610700014],
            [105.97397546400009, 14.36584259000007],
            [105.96942793800008, 14.354861348000085],
            [105.96782596800006, 14.343363343000064],
            [105.96916955600011, 14.33202036500009],
            [105.97397546400009, 14.321297506000079],
            [105.99340580300009, 14.305949606000098],
            [106.00451623600003, 14.28998158800006],
            [106.00797855600013, 14.270757955000136],
            [106.00405114800009, 14.245927430000094],
            [106.01247440600008, 14.225773621000116],
            [106.02627201300004, 14.213035380000065],
            [106.06058516500013, 14.191848043000093],
            [106.0761914470001, 14.17451060000009],
            [106.10171960500003, 14.11516021800007],
            [106.11525883000007, 14.100303243000027],
            [106.13127852400004, 14.08699656200011],
            [106.14455936700006, 14.072397970000054],
            [106.14946862900007, 14.053561911000116],
            [106.14207889800008, 14.035010071000087],
            [106.12642093900013, 14.022013449000056],
            [106.10848921700006, 14.010360413000086],
            [106.09407149300006, 13.996175232000041],
            [106.08197920800006, 13.980956523000103],
            [106.08383955900007, 13.934008484000046],
            [106.06916345200005, 13.916541850000101],
            [106.04921634900006, 13.915456645000106],
            [105.9974365650001, 13.928298239000085],
            [105.97397546400009, 13.929280091000066],
            [105.94917077600007, 13.919590760000034],
            [105.92457279500007, 13.917110291000057],
            [105.89966475400013, 13.922613831000135],
            [105.89558060100006, 13.924798655000075],
            [105.8730513920001, 13.936850688000021],
            [105.78711348500013, 14.010153707000129],
            [105.77016361500011, 14.034700012000101],
            [105.75889815300008, 14.06247609500005],
            [105.74401534000003, 14.086944885],
            [105.71600671400012, 14.101543477000064],
            [105.70515466300009, 14.10200856500009],
            [105.68365726700011, 14.098856303000034],
            [105.66934289600005, 14.100406596000056],
            [105.6532715250001, 14.107047017000056],
            [105.64314294500014, 14.113454895000103],
            [105.63291101100003, 14.11402333600006],
            [105.61725305200008, 14.102990417000058],
            [105.60986332200008, 14.120741272000075],
            [105.59456709800003, 14.136347554000025],
            [105.57653202300003, 14.144021505000097],
            [105.56139082900012, 14.138156230000021],
            [105.55555139200004, 14.146088562000074],
            [105.54893680800012, 14.153116557000075],
            [105.54123702000004, 14.159188538000123],
            [105.53317549600013, 14.164330343000117],
            [105.50527022300014, 14.14505503300009],
            [105.49049076400013, 14.13691599500008],
            [105.47385095200013, 14.132523499000087],
            [105.45007979400003, 14.117149760000103],
            [105.42217452000006, 14.107873840000082],
            [105.39246057100007, 14.103739726000057],
            [105.36409021000009, 14.104049785000143],
            [105.34786381100008, 14.10606516500009],
            [105.33778690600013, 14.10999257400006],
            [105.32946700100007, 14.117563171000114],
            [105.30393884300003, 14.152393087000078],
            [105.29660078900014, 14.156837260000088],
            [105.28218306500003, 14.161255595000085],
            [105.27531010000007, 14.164821269000058],
            [105.25691328900007, 14.182442932000043],
            [105.19743371600003, 14.270292867000109],
            [105.18797692900006, 14.291015117000143],
            [105.18425622600012, 14.314166158000134],
            [105.18430790300005, 14.345740458000108],
            [105.19820886300005, 14.345223694000069],
            [105.25045373600011, 14.35718678800012],
            [105.26859216300005, 14.364369812000078],
            [105.27572351100008, 14.372095439000077],
            [105.28771244300003, 14.39328277600012],
            [105.29474043800013, 14.399070536000096],
            [105.30466231300005, 14.398192037000072],
            [105.32223230000011, 14.386383972000061],
            [105.33509973200012, 14.385712178000077],
            [105.3408358160001, 14.390104675000075],
            [105.35964603700006, 14.408268942000106],
            [105.36765588400004, 14.414547628000022],
            [105.3792314050001, 14.418242493000022],
            [105.40568973800009, 14.423048401000116],
            [105.41597334800008, 14.428164368000111],
            [105.42031416900005, 14.435218201000026],
            [105.42889245600003, 14.45816253600006],
            [105.43385339400004, 14.467929383000111],
            [105.44036462500003, 14.475344950000121],
            [105.46367069500013, 14.495963847000041],
            [105.49545170100009, 14.53712412500002],
            [105.50754398600009, 14.56404754700013],
            [105.51012780800005, 14.593580627000051],
            [105.49576175900006, 14.659881490000075],
            [105.49736372900003, 14.69042226200007],
            [105.5051151940001, 14.736362610000057],
            [105.50154952000003, 14.74594858900005],
            [105.49069746900011, 14.763802796000107],
            [105.48914717600007, 14.786333720000115],
            [105.49384973100007, 14.808993836000084],
            [105.50154952000003, 14.82733897000007],
            [105.50620039900008, 14.830413717000098],
            [105.52004968300008, 14.833462626000127],
            [105.52439050300006, 14.837235006000057],
            [105.52408044500004, 14.842531840000092],
            [105.51694909700012, 14.856536153],
            [105.51586389200003, 14.87167734800002],
            [105.51777592000013, 14.877671814000053],
            [105.52191003400009, 14.87870534300012],
            [105.53761967000003, 14.878033549000051],
            [105.5430456950001, 14.880100607000102],
            [105.55064213100007, 14.90229563400004],
            [105.53415734900011, 14.93402496400006],
            [105.54392419400006, 14.953093567000039],
            [105.58356001800013, 14.977588196000085],
            [105.59306848200004, 14.990791525000077],
            [105.56645511900007, 14.995933329000081],
            [105.56635176600003, 14.995933329000081],
            [105.5661450610001, 14.995933329000081],
            [105.55353601100006, 15.005338440000031],
            [105.52428715000013, 15.04595611600007],
            [105.52284021000003, 15.050038554000082],
            [105.5231502690001, 15.061174825000094],
            [105.52087650600009, 15.066135763000148],
            [105.51653568600011, 15.067143453000114],
            [105.50356490100006, 15.064895528000108],
            [105.49829390500008, 15.066135763000148],
            [105.47385095200013, 15.090630391000104],
            [105.45194014500004, 15.094764506000033],
            [105.44362024000003, 15.111352641000039],
            [105.44377526900013, 15.133806050000132],
            [105.4477026780001, 15.155303446000076],
            [105.45442061400013, 15.17553477000007],
            [105.46310225400009, 15.189435730000056],
            [105.50392663600007, 15.231061096000062],
            [105.53157352800008, 15.25289438900009],
            [105.56025394700009, 15.27092946400009],
            [105.56397465000009, 15.27253143300004],
            [105.56480147400003, 15.299454854000132],
            [105.56149418200005, 15.320900574000078],
            [105.55803186100007, 15.32513804100003],
            [105.53854984600008, 15.321520691000046],
            [105.5193778900001, 15.32105560300002],
            [105.49901737500005, 15.32467295300009],
            [105.4833077400001, 15.334517314000067],
            [105.47746830200009, 15.352810771000051],
            [105.48625329700008, 15.37490244600005],
            [105.50620039900008, 15.387589009000095],
            [105.5528125410001, 15.402032573000028],
            [105.58836592600005, 15.423788350000038],
            [105.59224347300005, 15.427546297000106],
            [105.60428226700003, 15.439213766000123],
            [105.61038008700012, 15.457171326],
            [105.61203373200004, 15.499468486000083],
            [105.61627119900004, 15.521275940000024],
            [105.64086918200007, 15.583313497000077],
            [105.65099776200003, 15.634602356000116],
            [105.64092085800013, 15.681989645000087],
            [105.6129122320001, 15.7214704390001],
            [105.56852217700003, 15.749375712000088],
            [105.52542403200005, 15.763483378000032],
            [105.50340987200013, 15.766170552000048],
            [105.46237878500011, 15.762811585000051],
            [105.44796106000007, 15.764878642],
            [105.43566206900005, 15.771648255000045],
            [105.42300134300012, 15.78389556900008],
            [105.41204593900011, 15.79976023400009],
            [105.37256514500007, 15.882132467000062],
            [105.36062788900006, 15.919391175000086],
            [105.36248824000006, 15.954789531000088],
            [105.38651778200011, 15.980782776000055],
            [105.40739506000006, 15.98889597600008],
            [105.4181437580001, 15.994735412000054],
            [105.42393151900006, 16.00212514300007],
            [105.42323184100007, 16.005040467000057],
            [105.42207116700007, 16.009876608000084],
            [105.41447473200009, 16.015199280000033],
            [105.40491459200007, 16.018816630000103],
            [105.28853926700009, 16.04739369800008],
            [105.24740482700008, 16.04915069600004],
            [105.23722456900003, 16.050804341000102],
            [105.10697900800011, 16.095853281000032],
            [105.0793013920001, 16.105426331000032],
            [105.05811405500003, 16.121187643000027],
            [105.04245609600008, 16.141444804000017],
            [105.03258589700005, 16.165267639000078],
            [105.0288651940001, 16.191467590000016],
            [105.02974369300006, 16.236012675000026],
            [105.02638472500013, 16.257665100000096],
            [105.0154809980001, 16.27673370400008],
            [105.00741947400007, 16.28355499200005],
            [104.98802829000005, 16.293963496000075],
            [104.97930749500006, 16.298644511000035],
            [104.97150435400005, 16.30432891900007],
            [104.95207401600004, 16.324431051000133],
            [104.94406416900006, 16.33083892800009],
            [104.9172957770001, 16.345566712000092],
            [104.9080456960001, 16.353369853000103],
            [104.90158614100005, 16.362464905000067],
            [104.8970386150001, 16.372748515000055],
            [104.88773685700005, 16.403909404000032],
            [104.87946862800004, 16.421841126000103],
            [104.86892663600008, 16.43842926000012],
            [104.85549076300009, 16.454087220000062],
            [104.83885095300008, 16.467729797000075],
            [104.78273034700004, 16.497082012000064],
            [104.76516036000004, 16.51134470600003],
            [104.7545150150001, 16.528914693],
            [104.74950240100003, 16.549326884000052],
            [104.7484171960001, 16.57190948500009],
            [104.75301639800006, 16.61480092400005],
            [104.76371342000004, 16.65676218700004],
            [104.77756270400005, 16.694020894000047],
            [104.77900964400004, 16.704872945000105],
            [104.77833785000013, 16.71582834900009],
            [104.7567887780001, 16.798458964000034],
            [104.75632369000004, 16.80987945500003],
            [104.75791005200006, 16.81889463600008],
            [104.75844242400012, 16.8219200650001],
            [104.7652120360001, 16.844657695000095],
            [104.76707238800009, 16.856129862],
            [104.7664005950001, 16.868170472000074],
            [104.76288659700003, 16.879074198000055],
            [104.75301639800006, 16.899848125000076],
            [104.74965743100006, 16.910803528000073],
            [104.74634039700004, 16.943531594000106],
            [104.74035567200013, 17.00258087200008],
            [104.74531661000009, 17.02480173800005],
            [104.8099121510001, 17.171666158000036],
            [104.81445967600007, 17.194042053000103],
            [104.8183354090001, 17.24024078400008],
            [104.8164233810001, 17.30008209300003],
            [104.81998905500006, 17.348916321],
            [104.8193172610001, 17.3610602830001],
            [104.8164233810001, 17.37279083300008],
            [104.79270389800013, 17.42348541300005],
            [104.78893151900013, 17.42896311500006],
            [104.78164514200006, 17.43526763900006],
            [104.76464359600004, 17.44441436800004],
            [104.7567887780001, 17.449943746000045],
            [104.74965743100006, 17.458160299000085],
            [104.73425785400008, 17.486892395],
            [104.71451745700011, 17.515262756000098],
            [104.70263187700004, 17.527303365000066],
            [104.65508955900003, 17.55608713800008],
            [104.63638269100005, 17.562443339000097],
            [104.48119836500013, 17.6404230750001],
            [104.45200118000008, 17.66595123300003],
            [104.42228723200009, 17.69979929600005],
            [104.41784305900006, 17.707602438000052],
            [104.41164188700003, 17.727394511000043],
            [104.40890303600008, 17.73369903600006],
            [104.40487227400007, 17.739951884000035],
            [104.3902995200001, 17.757160137000128],
            [104.36776859600008, 17.800568340000027],
            [104.35262740100006, 17.81932688500011],
            [104.2875667720001, 17.85674062100007],
            [104.28198161000012, 17.86148801000003],
            [104.27826501500004, 17.86464711600003],
            [104.27030684400012, 17.874000550000076],
            [104.26431237800006, 17.884645895000048],
            [104.2551139740001, 17.91497996],
            [104.21087894700008, 18.008617656000055],
            [104.2033288720001, 18.018643666000045],
            [104.19811486900011, 18.025567525000056],
            [104.13568973800005, 18.079672750000057],
            [104.1223572190001, 18.09527903200008],
            [104.11093672700008, 18.114554342000034],
            [104.06840702300013, 18.215400900000034],
            [104.01864261900005, 18.29911672000007],
            [104.00003910300006, 18.318443705000035],
            [103.97544112200006, 18.33066518200006],
            [103.95125655200013, 18.332990622000082],
            [103.92929406800005, 18.327590434000015],
            [103.91001875800004, 18.315317281000077],
            [103.8936890060001, 18.297256368000077],
            [103.88950321500005, 18.291158550000105],
            [103.88593754100009, 18.28699859600009],
            [103.8812866620001, 18.284414775000087],
            [103.87394860800003, 18.283226217000063],
            [103.85777388600013, 18.286481832000035],
            [103.84898889200014, 18.296352031000126],
            [103.84221927900006, 18.30911611000009],
            [103.83209069900005, 18.320665792000042],
            [103.81725956200012, 18.330355123000075],
            [103.80139489700008, 18.338261617000015],
            [103.78460005700003, 18.343894348000035],
            [103.76718510000012, 18.346684875],
            [103.70910079000004, 18.349707947000027],
            [103.69556156500005, 18.353221945000072],
            [103.63861413600006, 18.377949117000085],
            [103.6299324950001, 18.383220113000036],
            [103.62135420800007, 18.390764873000066],
            [103.60714318900011, 18.400402527],
            [103.54880049700006, 18.415414530000064],
            [103.52316898700008, 18.417688293000097],
            [103.49774418100009, 18.423734436000032],
            [103.48911421800005, 18.42443206800003],
            [103.47479984500006, 18.422158305000025],
            [103.46994226100003, 18.421977437000052],
            [103.45154545100013, 18.425310568000057],
            [103.39676843300003, 18.441407777000038],
            [103.38663985200003, 18.441459452000046],
            [103.30685144100005, 18.42567230300007],
            [103.28256351700003, 18.41556956],
            [103.26075606300003, 18.400195821000054],
            [103.24406457600008, 18.380067851000078],
            [103.23398767100014, 18.355779928000075],
            [103.23367761200006, 18.349268698000103],
            [103.23533125900008, 18.34526377400003],
            [103.23801843300004, 18.341568909],
            [103.24018884300011, 18.335987854000095],
            [103.24866377800004, 18.33262888600008],
            [103.29041833600007, 18.305137024000103],
            [103.29651615500012, 18.296894633000065],
            [103.29537927300004, 18.287773743000102],
            [103.28633589700007, 18.280332336000058],
            [103.27352014200005, 18.27606903100012],
            [103.23672652300007, 18.26999705000007],
            [103.21491906700004, 18.262297262000075],
            [103.1852051190001, 18.257749736000036],
            [103.17673018400006, 18.25485585600005],
            [103.16820357300008, 18.249765727000053],
            [103.15729984600011, 18.237027487000105],
            [103.15089196800005, 18.22149871900008],
            [103.14510420800008, 18.18801239],
            [103.13859297700003, 18.1667217],
            [103.12665572100008, 18.151864726000056],
            [103.11006758700006, 18.14181366000004],
            [103.08908695500008, 18.134785665000024],
            [103.08940378200009, 18.135222668000026],
            [103.09008680900013, 18.136164775000097],
            [103.09058557100008, 18.136852723000075],
            [103.09275598200009, 18.141193542000067],
            [103.09213261000008, 18.140881856000036],
            [103.08770263200012, 18.138666867],
            [103.07994022600008, 18.134785665000024],
            [103.07131026200005, 18.125561422000104],
            [103.06634932500009, 18.112254740000097],
            [103.06479903100006, 18.094038798000057],
            [103.07306726100012, 18.03551523900005],
            [103.0682096760001, 18.025774231000113],
            [103.05828780100006, 18.019263001000027],
            [103.04939945500007, 18.005000305000053],
            [103.03792728700006, 17.99068593400007],
            [103.0204606530001, 17.98422638000001],
            [103.0038208420001, 17.988567200000105],
            [102.97291833500009, 18.007739156000113],
            [102.95493493600003, 18.012131653],
            [102.9386051840001, 18.008927714000023],
            [102.85271895400012, 17.972030742000086],
            [102.83804284700005, 17.96376251300005],
            [102.83189335200007, 17.95311716700006],
            [102.77406742300008, 17.922731425],
            [102.73737715700003, 17.890433655000024],
            [102.72218428500008, 17.881803691000087],
            [102.68673425300005, 17.87353546200005],
            [102.67298832300003, 17.865370585000036],
            [102.66761397300013, 17.850074362000058],
            [102.6733500570001, 17.831780904000098],
            [102.68291019700007, 17.817363180000072],
            [102.68291019700007, 17.810076802000097],
            [102.66079268400011, 17.81286733000006],
            [102.60942631100005, 17.837000224000022],
            [102.59526696800009, 17.840824280000064],
            [102.59557702600006, 17.850074362000058],
            [102.61232019100004, 17.915290019000096],
            [102.59960778900006, 17.955184225000025],
            [102.56751672400003, 17.970842183000073],
            [102.48204390500013, 17.971152243000077],
            [102.44550866700007, 17.977766826000064],
            [102.41222904500006, 17.994199931000125],
            [102.38515059500008, 18.016059062000053],
            [102.36639205000012, 18.038796692000048],
            [102.33652307200009, 18.037039694000057],
            [102.30670577000006, 18.051457418000084],
            [102.25657963100008, 18.094038798000057],
            [102.23311853100006, 18.12416615800005],
            [102.22557377100003, 18.128196920000036],
            [102.22180139200003, 18.13160756400005],
            [102.19157067900011, 18.152071432000028],
            [102.18211389200013, 18.169228007000086],
            [102.17839318900013, 18.18597117100005],
            [102.17193363500007, 18.20028554300002],
            [102.15353682500006, 18.210104065000095],
            [102.10738518700009, 18.212376684],
            [102.07850264500007, 18.213798930000095],
            [102.07126794400011, 18.20850209600006],
            [102.05552696700005, 18.192344575000064],
            [101.90430139200004, 18.037117208],
            [101.88378584800006, 18.03083852200008],
            [101.84518355300008, 18.052129211000064],
            [101.80606449400005, 18.062386983000053],
            [101.79665938400012, 18.073574931000095],
            [101.7904065350001, 18.073574931000095],
            [101.77392175300014, 18.058562927000096],
            [101.76575687700011, 18.040321147000057],
            [101.75692020700012, 17.9978172820001],
            [101.73258060800009, 17.93203318300003],
            [101.72906661000013, 17.91218943300005],
            [101.63620406100011, 17.89482615200002],
            [101.61987430900007, 17.884645895000048],
            [101.61114099200012, 17.865525615000067],
            [101.60039229400007, 17.854363506000126],
            [101.57755131000005, 17.86810943600007],
            [101.57755131000005, 17.85291656500003],
            [101.57507084200012, 17.83979075200007],
            [101.57052331500006, 17.828887024000025],
            [101.56401208500006, 17.820308736000086],
            [101.5455048450001, 17.813671657000086],
            [101.53403975500004, 17.809560038000072],
            [101.5562606200001, 17.792145081000044],
            [101.53652022300014, 17.77912262000008],
            [101.50272383700013, 17.765376689000064],
            [101.48298344000005, 17.745791321000027],
            [101.4790043540001, 17.737988180000016],
            [101.47419844600006, 17.7305984500001],
            [101.47042606700006, 17.722588603000034],
            [101.46830733200011, 17.720366516000027],
            [101.45910892800009, 17.739486796000037],
            [101.45735192900003, 17.745791321000027],
            [101.45606001800007, 17.750183818000025],
            [101.45347619700004, 17.751010641000065],
            [101.44980717000004, 17.749253642000085],
            [101.44525964400003, 17.745791321000027],
            [101.43203047700013, 17.733595683000104],
            [101.41699263500004, 17.73235544900008],
            [101.40185144000003, 17.73375071300005],
            [101.38800215700007, 17.729306539000063],
            [101.38190433800003, 17.72072825200003],
            [101.38836389200009, 17.717782695000025],
            [101.39875085500006, 17.717162577000053],
            [101.40402185100004, 17.71556060900012],
            [101.40309167500004, 17.709462789000057],
            [101.40159305900005, 17.706672262],
            [101.38376468900003, 17.684916484],
            [101.37746016500012, 17.68264272100008],
            [101.36986372900003, 17.683159485000104],
            [101.35730635600004, 17.679025371000094],
            [101.24702885000005, 17.59215728800008],
            [101.22863204000004, 17.56848948200006],
            [101.20852990800012, 17.531282451000052],
            [101.2021737070001, 17.523169250000038],
            [101.19028812700003, 17.51872507800003],
            [101.17695560800013, 17.51639963800001],
            [101.16672367300004, 17.510611878000034],
            [101.16424320500005, 17.495780742000093],
            [101.14718998200004, 17.472474671000057],
            [101.14181563400007, 17.46715199800012],
            [101.1323071700001, 17.461674296000027],
            [101.12889652500007, 17.461157532000087],
            [101.12465905700003, 17.46394805900006],
            [101.09603031500012, 17.47526519800003],
            [101.06616133700004, 17.492215067000032],
            [101.04931482000006, 17.495729065000077],
            [101.03546553500007, 17.51262725900007],
            [101.01903243000004, 17.526631572000085],
            [101.00084232600005, 17.538207092000036],
            [100.98151534100003, 17.54761220300007],
            [100.93773837900005, 17.55548637100013],
            [100.90193363500009, 17.561926575000072],
            [100.88601729400006, 17.573760478000096],
            [100.8856555590001, 17.59587799100011],
            [100.89945316600011, 17.616961976000127],
            [100.93293949400004, 17.65453074100013],
            [100.95381677300009, 17.69979929600005],
            [100.95587773300008, 17.707531771000063],
            [100.96068973800004, 17.725585836000036],
            [100.95872603300012, 17.745791321000027],
            [100.95640059400012, 17.755919902000088],
            [100.95857100500007, 17.7641364550001],
            [100.9648755290001, 17.770596009000073],
            [100.97428064000007, 17.775505269000107],
            [100.97521081600013, 17.77762400400009],
            [100.9755208740001, 17.77979441300006],
            [100.97521081600013, 17.781913148000044],
            [100.97428064000007, 17.783980204],
            [100.96771773300009, 17.791008199000103],
            [100.96518558800005, 17.797622783000023],
            [100.9670459400001, 17.803823955],
            [100.97428064000007, 17.809249980000075],
            [100.99479618300012, 17.817724915000085],
            [101.00027388600012, 17.83048899400005],
            [100.99712162300006, 17.864595439000098],
            [101.00084232600005, 17.884800924],
            [101.00828373200011, 17.895239563000032],
            [101.03980635600004, 17.912034403000106],
            [101.06616133700004, 17.933996887000077],
            [101.08197432500003, 17.958336487000068],
            [101.09489343300004, 17.98438140800006],
            [101.11230839100006, 18.01130483000007],
            [101.12543420500003, 18.021330058],
            [101.15752526900013, 18.0404503380001],
            [101.16517338100005, 18.05342112300012],
            [101.1620727940001, 18.06745127400002],
            [101.14496789600003, 18.104735820000073],
            [101.14160892800004, 18.12395945300007],
            [101.14563969000011, 18.14194285100008],
            [101.16052250200005, 18.179511617000074],
            [101.16279626500005, 18.195298768000058],
            [101.15928226700004, 18.204057922000047],
            [101.15277103700004, 18.209070537000017],
            [101.14553633700007, 18.212997945000083],
            [101.13964522300006, 18.218708192000022],
            [101.13173872900012, 18.238861999],
            [101.12837976100013, 18.245734965000068],
            [101.12796634900013, 18.28095245400003],
            [101.13013676000003, 18.291158550000105],
            [101.13540775500013, 18.298393250000075],
            [101.15240930200014, 18.316376649000077],
            [101.15540653500005, 18.32288787900005],
            [101.14553633700007, 18.336246237000054],
            [101.08228438300011, 18.36420318600007],
            [101.0740887660001, 18.371613107000044],
            [101.05102014200003, 18.39247019400004],
            [101.0370158290001, 18.410453593000042],
            [101.03029789200008, 18.42779103600013],
            [101.03562056500004, 18.44784149200008],
            [101.06471439700005, 18.476418559000038],
            [101.07194909700007, 18.49566803000009],
            [101.07380944800008, 18.50577077200002],
            [101.07789188700008, 18.510421651000073],
            [101.14207401500005, 18.544295552000094],
            [101.15535485900006, 18.556723734000073],
            [101.1591272390001, 18.56770497600006],
            [101.15814538600011, 18.5899775190001],
            [101.16088423700006, 18.59979604100006],
            [101.16775720200013, 18.60635894800005],
            [101.18532719000007, 18.612534282000027],
            [101.19411218300007, 18.61679758700008],
            [101.22191410300013, 18.64204152500004],
            [101.23472985900003, 18.65844879100011],
            [101.24010420700006, 18.673641663000026],
            [101.23478153500014, 18.689480489000047],
            [101.21126875800013, 18.71190806100013],
            [101.20584273300005, 18.73007232700006],
            [101.2092017010001, 18.74632456500008],
            [101.2239811610001, 18.77854482000005],
            [101.22863204000004, 18.795623881000083],
            [101.22330936700013, 18.85549102800006],
            [101.22491133700004, 18.874766337000082],
            [101.23292118400013, 18.892723897000067],
            [101.25726078300005, 18.919492289000047],
            [101.26728601100007, 18.934452617000105],
            [101.27700118000013, 18.967060445000058],
            [101.28392582300006, 18.981478170000074],
            [101.32640385000013, 19.020545553000076],
            [101.31787723800011, 19.05013031100013],
            [101.29116052300003, 19.07899159700007],
            [101.24744226100006, 19.115785218000056],
            [101.23571171100008, 19.12811004700002],
            [101.22914880400009, 19.14358713800003],
            [101.22677168800004, 19.167151591000035],
            [101.22987227400012, 19.225804342000075],
            [101.20951176000005, 19.30941680900007],
            [101.2092533770001, 19.315592143000046],
            [101.21090702300006, 19.320630595000026],
            [101.21126875800013, 19.32636667900009],
            [101.2077547610001, 19.33468658400004],
            [101.20196700100013, 19.338665670000026],
            [101.18501713100011, 19.34199880000004],
            [101.17845422400012, 19.346623841000095],
            [101.17235640500007, 19.376389465000088],
            [101.17778243100003, 19.41721384700007],
            [101.19287194800006, 19.45279307100013],
            [101.21529952000003, 19.46635813500002],
            [101.23824385600005, 19.472300924000038],
            [101.25173140500004, 19.49444427500005],
            [101.25695072400003, 19.522788798000065],
            [101.25488366700012, 19.547154236000083],
            [101.25105961100007, 19.56030588800006],
            [101.24620202600005, 19.57027943900006],
            [101.23824385600005, 19.578185933],
            [101.22501469000008, 19.5852139280001],
            [101.20796146700013, 19.5895547490001],
            [101.19731612200007, 19.586867574000067],
            [101.18832442200011, 19.580743917000106],
            [101.17685225500009, 19.574749451000073],
            [101.15266768400011, 19.56836741100004],
            [101.12465905700003, 19.565111796000068],
            [101.09582360900009, 19.567282207000048],
            [101.06822839400007, 19.577126567000036],
            [101.02430342600013, 19.602861430000118],
            [101.00254764900012, 19.610612895000102],
            [100.97428064000007, 19.61348093700009],
            [100.8856555590001, 19.612447408000023],
            [100.87981612100009, 19.61358429000002],
            [100.87459680200004, 19.61291249600005],
            [100.86503666200008, 19.607150574000073],
            [100.86121260600004, 19.602603048000034],
            [100.84901696800011, 19.582526754000085],
            [100.80845096900009, 19.536534729],
            [100.76261397300004, 19.495477804000032],
            [100.75300215700003, 19.482429504],
            [100.74550907500009, 19.4850133260001],
            [100.7381710200001, 19.495038554000118],
            [100.72923099800005, 19.504650371000125],
            [100.71476159700006, 19.51245351200005],
            [100.63326786300007, 19.5421674600001],
            [100.60701623600005, 19.54092722600008],
            [100.58598392800013, 19.525966899000124],
            [100.57475787800007, 19.508347404000048],
            [100.56665694200012, 19.495632833000073],
            [100.5492936600001, 19.494547628000092],
            [100.52061324100009, 19.502609152000062],
            [100.49182946800005, 19.514468893000085],
            [100.4742594810001, 19.524985047000044],
            [100.46196049000014, 19.537103170000037],
            [100.45896325700005, 19.55183095300005],
            [100.45896325700005, 19.568057353000043],
            [100.45555261300012, 19.584671326000077],
            [100.44749108900004, 19.597771302000027],
            [100.42707889800005, 19.62180084200007],
            [100.41886234600003, 19.634358215000063],
            [100.41291955600013, 19.651566467000052],
            [100.41049076300004, 19.684251811000124],
            [100.4072351480001, 19.699935608000075],
            [100.40046553600013, 19.711640320000058],
            [100.39004815800007, 19.7243870490001],
            [100.38382572400013, 19.732000835000107],
            [100.37917484500008, 19.745669251000024],
            [100.38351566600005, 19.763859355000065],
            [100.40765850600013, 19.794257080000122],
            [100.42051599100012, 19.810445659000024],
            [100.43141971900008, 19.83827341700008],
            [100.43844771400006, 19.84721344000009],
            [100.44625085500007, 19.852122701000027],
            [100.46562951600004, 19.85977081300011],
            [100.4742594810001, 19.865351868000047],
            [100.48397465000005, 19.8806997680001],
            [100.48795373600012, 19.896977844000034],
            [100.49265629100012, 19.93165273000004],
            [100.51854618300013, 19.995498963],
            [100.54335087100009, 20.06657989500009],
            [100.55058557200005, 20.106525777000073],
            [100.54867354400011, 20.158021342000055],
            [100.54650313300004, 20.16791737900003],
            [100.54195560700009, 20.166728821000035],
            [100.53668461100006, 20.1534738160001],
            [100.52924320500006, 20.149727275000103],
            [100.51281010000008, 20.155282491000023],
            [100.49637699400012, 20.164868469000012],
            [100.48893558800006, 20.173343404000022],
            [100.48562829600007, 20.1787694290001],
            [100.46878178000003, 20.18571991000009],
            [100.46103031400003, 20.19070668600004],
            [100.45730961100008, 20.196391093000088],
            [100.45214196800009, 20.210240377000034],
            [100.44733606000005, 20.218043518000073],
            [100.42160119700009, 20.250186260000092],
            [100.36439538600013, 20.36896453900006],
            [100.34434493000009, 20.389971009000064],
            [100.30651778200013, 20.399686178000096],
            [100.27024092600004, 20.391831361000087],
            [100.24037194800013, 20.3728144330001],
            [100.2206832280001, 20.34899159700005],
            [100.20915938300004, 20.312998963000055],
            [100.20719567900005, 20.31113861100006],
            [100.20171797700004, 20.31031178800002],
            [100.17949711200009, 20.302482809000097],
            [100.17639652500009, 20.300622457000102],
            [100.16709476700004, 20.292612610000035],
            [100.16771488500012, 20.25362274200002],
            [100.15252201300007, 20.23915334100009],
            [100.13464196800004, 20.239101665000092],
            [100.11660689300004, 20.24801584900011],
            [100.10296431500012, 20.263596293000134],
            [100.09727990800008, 20.283233337000084],
            [100.09929528800012, 20.317804870000074],
            [100.09764164300009, 20.334935608000123],
            [100.0970732020001, 20.348371481000058],
            [100.09981205300005, 20.362220764000128],
            [100.11112919100003, 20.37482981400005],
            [100.12094771400007, 20.38878245000005],
            [100.12523685800005, 20.40640411400004],
            [100.12740726700014, 20.42784983400007],
            [100.13665734900007, 20.459217427000098],
            [100.14926639800007, 20.548100891000033],
            [100.16006677300004, 20.582672424000023],
            [100.17293420500005, 20.609079082],
            [100.17293420500005, 20.62210154200004],
            [100.18016890500007, 20.63817291300002],
            [100.20233809500013, 20.667938538],
            [100.20719567900005, 20.680754293000078],
            [100.21132979400005, 20.69739410400011],
            [100.22161340400004, 20.709589743000024],
            [100.24874353000013, 20.73196563800009],
            [100.27453007000003, 20.761989645000043],
            [100.29018802900009, 20.77501210600009],
            [100.32966882300008, 20.786019185000086],
            [100.34196781400004, 20.799506734000047],
            [100.35111454300005, 20.81531972300006],
            [100.36480879700014, 20.828187154000133],
            [100.38367069500009, 20.831701151000104],
            [100.47084883600007, 20.818265279000045],
            [100.51337854000013, 20.80699981700009],
            [100.53668461100006, 20.80767161100006],
            [100.56903405800006, 20.817800191000018],
            [100.59890303500003, 20.833458151000073],
            [100.60777574500003, 20.83988093300009],
            [100.6266016030001, 20.853508606000034],
            [100.65212976100003, 20.876607971000098],
            [100.65212976100003, 20.882757467000076],
            [100.62308760600013, 20.88854522700005],
            [100.53420414300007, 20.873920797000054],
            [100.51570397900014, 20.886478170000075],
            [100.51782271400003, 20.90632192000008],
            [100.52707279500004, 20.946939596],
            [100.52924320500006, 20.968436992000036],
            [100.53327396700013, 20.973449605000027],
            [100.5519808360001, 20.98533518500004],
            [100.55725183100003, 20.992001445000042],
            [100.55575321500004, 20.99985626300007],
            [100.54345422400007, 21.027399801000072],
            [100.56185103400009, 21.03509958900007],
            [100.60675785300009, 21.043936259000063],
            [100.62551639800012, 21.054116517000026],
            [100.63755700700005, 21.06967112200006],
            [100.68938846900005, 21.159329732000018],
            [100.72106612200014, 21.28066599600008],
            [100.72256473800007, 21.29270660400006],
            [100.72199629800008, 21.303662008000046],
            [100.72540694200012, 21.311671855],
            [100.73837772700006, 21.314772441000045],
            [100.7477311610001, 21.314255676000116],
            [100.75667118400003, 21.312447001000024],
            [100.76499108900009, 21.309191386000023],
            [100.77258752500006, 21.30423044800007],
            [100.79196618700013, 21.297357483000027],
            [100.81460046400008, 21.300199687000074],
            [100.85134240700006, 21.314772441000045],
            [100.86245284000006, 21.323299052000053],
            [100.89604252200007, 21.355751851],
            [100.90994348200007, 21.36009267200005],
            [101.00342614800007, 21.40598134400004],
            [101.14315922100013, 21.513416647000028],
            [101.15711185700013, 21.519669495000116],
            [101.16114261900003, 21.53470733600001],
            [101.15902388500007, 21.5526907350001],
            [101.17452681500004, 21.551657206000115],
            [101.18656742400003, 21.53532745400007],
            [101.18775598100007, 21.505871887000083],
            [101.16827396700006, 21.424533183000065],
            [101.17142622900013, 21.403397522000134],
            [101.17912601800003, 21.39817820200001],
            [101.20796146700013, 21.38350209600013],
            [101.22646163000007, 21.370893046],
            [101.23080244900007, 21.371771546000033],
            [101.23312788900006, 21.371719869000017],
            [101.23478153500014, 21.363658345000132],
            [101.22284427900007, 21.33508127800006],
            [101.20744470200003, 21.31482411700007],
            [101.20951176000005, 21.308674622000083],
            [101.2184001060001, 21.29994130500002],
            [101.22036381100003, 21.296272278000018],
            [101.21907189900008, 21.28247467100006],
            [101.20899499500013, 21.245526021000032],
            [101.22036381100003, 21.23369211800012],
            [101.23478153500014, 21.206251933000075],
            [101.24434167500004, 21.192867737000128],
            [101.25974125100004, 21.179483541000096],
            [101.27529585800005, 21.174109192000046],
            [101.29271081600007, 21.176072897000054],
            [101.31389815300014, 21.184754537000018],
            [101.36226729400005, 21.215812073000066],
            [101.38149092600008, 21.22247833200008],
            [101.49512740100005, 21.2428388470001],
            [101.51760664900007, 21.242632141000044],
            [101.53910404500004, 21.23885976100003],
            [101.57290043100011, 21.228162740000116],
            [101.57967004400012, 21.227594299000074],
            [101.58395918800011, 21.2243903600001],
            [101.58819665600004, 21.21333160400009],
            [101.58664636300006, 21.204236552000012],
            [101.58096195500008, 21.194728089000037],
            [101.57724125200008, 21.18516794800003],
            [101.58178877800003, 21.175659485000054],
            [101.59651656100004, 21.173385722000134],
            [101.63594567900003, 21.189457092000097],
            [101.65511763500012, 21.18919871100003],
            [101.67015547700004, 21.17705474900002],
            [101.68829390500014, 21.145842183000056],
            [101.70426192200011, 21.135093485000127],
            [101.71790450000009, 21.134473369000048],
            [101.73748986800013, 21.137573954000104],
            [101.75599003200006, 21.143258362000054],
            [101.76673872900005, 21.150648092000054],
            [101.76845334900003, 21.16044957700005],
            [101.77020105000003, 21.170440166000034],
            [101.7635864660001, 21.18465118400009],
            [101.76007246900008, 21.19596832300006],
            [101.77356001800013, 21.207388815000073],
            [101.79603926600004, 21.20294464100006],
            [101.80523767100004, 21.204494934000095],
            [101.81329919500013, 21.209559225000064],
            [101.81929366100013, 21.215967102000022],
            [101.82149033400009, 21.221071138000084],
            [101.8228076580001, 21.224131979000035],
            [101.82373783400004, 21.234467265000134],
            [101.82022383600008, 21.247283020000012],
            [101.81226566600003, 21.25813507100007],
            [101.80115523300003, 21.267075094000077],
            [101.7885461840001, 21.274206442000022],
            [101.73650801600007, 21.292293193000134],
            [101.72250370300003, 21.30423044800007],
            [101.71511397300003, 21.321128642000062],
            [101.71557906100008, 21.338181865000095],
            [101.7255526130001, 21.37538889600002],
            [101.72968672700011, 21.474245911000068],
            [101.74425948100009, 21.495588277000067],
            [101.74823856600005, 21.514501852000123],
            [101.73475101700006, 21.554396057000062],
            [101.73619795800005, 21.570880839000026],
            [101.75092574100006, 21.57966583300002],
            [101.77268151900006, 21.582508036],
            [101.79355879700006, 21.588244121000045],
            [101.8061678470001, 21.60596913700006],
            [101.80384240700005, 21.62591623900009],
            [101.78952803600004, 21.634029440000077],
            [101.77082116700007, 21.638835348],
            [101.75593835500013, 21.648653870000075],
            [101.75232100500006, 21.659144186000034],
            [101.75562829600005, 21.68002146400009],
            [101.75480147300004, 21.689788310000054],
            [101.74911706500006, 21.698056539000092],
            [101.73278731300013, 21.71144073500004],
            [101.72854984500009, 21.717538554000086],
            [101.72798140500004, 21.7326797490001],
            [101.73165043200004, 21.75050811800004],
            [101.75154585800004, 21.806370341000033],
            [101.7510807700001, 21.81613718700008],
            [101.72617272900004, 21.837272848000012],
            [101.72126346900012, 21.844352519000054],
            [101.70870609600007, 21.869570618000083],
            [101.68586511300009, 21.898612773000067],
            [101.68307458600003, 21.907139384000104],
            [101.68245446800006, 21.91483917300009],
            [101.68059411600007, 21.9226423140001],
            [101.67366947500005, 21.931375631],
            [101.6381160890001, 21.940884094000054],
            [101.61630863500011, 21.953648173000133],
            [101.60680017100003, 21.96760081000012],
            [101.60039229400007, 22.007495016000078],
            [101.59217574100006, 22.02811391300007],
            [101.56494226100006, 22.069506734000115],
            [101.55543379800014, 22.090332337000078],
            [101.55502038600014, 22.112398173000074],
            [101.5618416750001, 22.13007151300006],
            [101.56695764200009, 22.149346822000027],
            [101.56153161700013, 22.17611521400009],
            [101.54902592000013, 22.19353017200011],
            [101.51822676600005, 22.22820505800003],
            [101.51574629800007, 22.245361634000105],
            [101.5317143150001, 22.263396708000087],
            [101.54065433700003, 22.271458232000086],
            [101.55098962400007, 22.276677552000095],
            [101.56370202700009, 22.276780905000024],
            [101.5757426350001, 22.27311187800005],
            [101.58798995000012, 22.27135487900007],
            [101.60121911700008, 22.27698761000009],
            [101.60612837700012, 22.284842427000015],
            [101.61987430900007, 22.32644195500002],
            [101.6225098060001, 22.342358297000047],
            [101.62369836500011, 22.346647441000115],
            [101.64111332200014, 22.363287252000035],
            [101.64369714400004, 22.364682516000116],
            [101.64571252500008, 22.384526266000094],
            [101.64416223200004, 22.4040082800001],
            [101.64509240800004, 22.42421376500009],
            [101.65454919500007, 22.446124573000034],
            [101.66865686100004, 22.46229929700003],
            [101.68912072800009, 22.478887431000047],
            [101.7131502680001, 22.491548157000082],
            [101.74177901200011, 22.496044007000094],
            [101.7506156820001, 22.496044007000094],
            [101.75505985600012, 22.49552724300007],
            [101.7848771570001, 22.472221171000044],
            [101.81779504400004, 22.406333720000035],
            [101.84259973100006, 22.38333770800007],
            [101.86792118300008, 22.378841858000058],
            [101.87727461800011, 22.39186431900002],
            [101.88151208500005, 22.412173157000026],
            [101.89164066600011, 22.42969146700007],
            [101.90936568200004, 22.435892639000073],
            [101.95287723800004, 22.436874491000125],
            [101.97421960500003, 22.445142720000078],
            [101.9949935300001, 22.4474164840001],
            [102.01457889800008, 22.446072896000132],
            [102.07591882300005, 22.432430319000034],
            [102.08553064000006, 22.429123027000017],
            [102.09534916200005, 22.423128561000098],
            [102.0999483650001, 22.414860331000042],
            [102.10062015800008, 22.405765280000068],
            [102.10734543400008, 22.39754872600004],
            [102.11865523300008, 22.39754872600004],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Kyrgyzstan',
        iso3: 'KGZ',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [80.21032841000005, 42.18951894100006],
            [80.21652958200013, 42.174403585000064],
            [80.21983687300013, 42.14187327100011],
            [80.22459110500012, 42.12556935700009],
            [80.23513309800006, 42.110944926000016],
            [80.24743208800004, 42.09841339100011],
            [80.2565271410001, 42.084357401],
            [80.2575606690001, 42.06526296],
            [80.23120568900003, 42.03368866000001],
            [80.18190637200013, 42.02097625800006],
            [79.93086226400004, 42.023275859000094],
            [79.87949589000004, 42.01319895500005],
            [79.84290897700004, 42.00183013900006],
            [79.82678592900004, 41.992244161000045],
            [79.81283329300004, 41.977619731000075],
            [79.80384159300007, 41.959998068000104],
            [79.79257613100003, 41.922816874],
            [79.78327437300004, 41.90509185800006],
            [79.7475142830001, 41.879744568],
            [79.70296919800012, 41.87493866000007],
            [79.65573693800008, 41.87584299800004],
            [79.61098514800011, 41.867626445],
            [79.5546578370001, 41.83760243700003],
            [79.4898555910001, 41.81925730500005],
            [79.41099735600005, 41.77858795200011],
            [79.39084354700009, 41.7726968380001],
            [79.36738244600014, 41.77238678000002],
            [79.30413049300012, 41.78755381300003],
            [79.28232303900012, 41.78349721300013],
            [79.26485640400006, 41.77450551300008],
            [79.21752079300012, 41.74122589200006],
            [79.19592004400005, 41.72952117900006],
            [79.17452600100012, 41.722622375000086],
            [79.12791385900005, 41.71430247000005],
            [79.08874312300003, 41.70254608200004],
            [78.97619185400004, 41.641800435000036],
            [78.91583378100012, 41.63317047200009],
            [78.89743697200004, 41.626271668000115],
            [78.80731327300003, 41.57844513000002],
            [78.67212772700003, 41.53844757100005],
            [78.65827844200004, 41.532453105000045],
            [78.64504927600007, 41.523719788000065],
            [78.6374011640001, 41.51286773700009],
            [78.62913293500003, 41.48795969600003],
            [78.61921106000005, 41.47808949900006],
            [78.58396773300007, 41.46599721300008],
            [78.51038049400006, 41.454421692000025],
            [78.41756962100004, 41.400471497000055],
            [78.3776754160001, 41.38662221300011],
            [78.35989872300007, 41.37752716100003],
            [78.3434656170001, 41.36202423100012],
            [78.3393315030001, 41.34404083200003],
            [78.35690148900005, 41.30554189100006],
            [78.35969201700004, 41.28745513900007],
            [78.34946008300005, 41.27040191700003],
            [78.33147668500004, 41.258723043000046],
            [78.29158247900011, 41.24079132100009],
            [78.27535608000011, 41.22885406500005],
            [78.25034468600012, 41.200535380000034],
            [78.23133511000003, 41.172855896],
            [78.20445601400013, 41.133717753],
            [78.19050337700014, 41.11774973600005],
            [78.17603397600004, 41.10550242200013],
            [78.07495487500006, 41.03951161700009],
            [78.05717818200003, 41.034343974000095],
            [78.03650761000011, 41.036100973000075],
            [77.99764693200007, 41.049795227000075],
            [77.86669885300006, 41.06405792200006],
            [77.83104211400007, 41.06297271800007],
            [77.79755578600009, 41.05470448800013],
            [77.66557417800004, 41.001271058],
            [77.65027795400005, 40.997136943000086],
            [77.63177779200004, 40.99579335500003],
            [77.58072147700005, 40.997705383000024],
            [77.5035168870001, 40.98106557200002],
            [77.4748881430001, 40.98204742500009],
            [77.44522587100005, 40.99367462200003],
            [77.38879520600011, 41.01165802100003],
            [77.33298466000014, 41.020649719000076],
            [77.30115197800012, 41.01930613200001],
            [77.24317102100014, 41.005663554000094],
            [77.11883752500006, 41.01165802100003],
            [77.08855513500004, 41.019564515000084],
            [77.03501835100008, 41.0403384400001],
            [77.00773319500007, 41.04421417300007],
            [76.90014286300004, 41.02576568600007],
            [76.86097212800013, 41.01320831300005],
            [76.83492720500004, 40.993519592],
            [76.82087121600011, 40.97780995700002],
            [76.7839742430001, 40.957139384000115],
            [76.76681766800004, 40.94468536400002],
            [76.75741255700007, 40.9257717900001],
            [76.76092655500014, 40.90659983300007],
            [76.76836796100014, 40.887014465000064],
            [76.77084843000011, 40.86711903900006],
            [76.76247684700013, 40.84701690700008],
            [76.74687056500011, 40.83445953400009],
            [76.70728641800014, 40.817613017],
            [76.67421350100005, 40.795443828000074],
            [76.6478585210001, 40.76485138000005],
            [76.63080529800004, 40.728884583000095],
            [76.62419071400006, 40.62754709900007],
            [76.62078007100013, 40.611320699000046],
            [76.60941125500005, 40.59710968000009],
            [76.55639123500004, 40.565690410000045],
            [76.53117313600012, 40.534994609000094],
            [76.49892704300004, 40.46461130800007],
            [76.47649947100012, 40.436137594000044],
            [76.44911096200008, 40.41551869700005],
            [76.36198449700004, 40.3719037880001],
            [76.33015181500008, 40.34808095300012],
            [76.31351200400007, 40.343326721000025],
            [76.29935266100011, 40.35567738900009],
            [76.28333296800014, 40.41727569600003],
            [76.27341109200006, 40.434122213000094],
            [76.24416223100013, 40.44120188400002],
            [76.21543013500008, 40.416552226000036],
            [76.18504439300006, 40.384202779000034],
            [76.1513513590001, 40.36813140900007],
            [76.13254113800008, 40.371542053],
            [76.09523075400006, 40.387355042000095],
            [76.07611047400007, 40.39195424400005],
            [76.05161584500007, 40.39019724500007],
            [75.96242232300006, 40.35733103400004],
            [75.94929650900008, 40.343068339000055],
            [75.93803104600005, 40.326221822],
            [75.92149458900013, 40.30911692400004],
            [75.90185754400011, 40.29888499000005],
            [75.88046350100007, 40.29526763900007],
            [75.85855269300004, 40.29635284500007],
            [75.79375044800014, 40.30891021800009],
            [75.77204634600014, 40.310150452000116],
            [75.75054895000011, 40.308341777000024],
            [75.70445357300008, 40.2931489060001],
            [75.68181929600013, 40.291701966000105],
            [75.66486942600011, 40.305706279],
            [75.65629113800009, 40.323069560000036],
            [75.64016809100008, 40.36730458600006],
            [75.63830774000007, 40.38611480800007],
            [75.64636926200006, 40.40533844],
            [75.65959842900008, 40.41908437100001],
            [75.66931359800003, 40.43236521400003],
            [75.66693648300009, 40.450245260000074],
            [75.65722131300004, 40.46109731000003],
            [75.62900598200008, 40.48130279500002],
            [75.61794722500008, 40.493963521000055],
            [75.61081587700005, 40.51287709600011],
            [75.60564823400011, 40.56941111300007],
            [75.58766483600004, 40.61194081700002],
            [75.55986291500011, 40.632869772],
            [75.5237927660001, 40.63317983000009],
            [75.48183150200009, 40.614111227000095],
            [75.2632401940001, 40.48016591500003],
            [75.25331831900007, 40.47598012400009],
            [75.2415360930001, 40.47406809500005],
            [75.22923710200007, 40.47034739200005],
            [75.22396610500004, 40.46244089800008],
            [75.22014204900006, 40.45298411100002],
            [75.21249393800008, 40.44471588200007],
            [75.19389042200004, 40.44125356100004],
            [75.17528690600011, 40.44812652600011],
            [75.15658003700008, 40.45815175400013],
            [75.13807987500007, 40.463887838000076],
            [75.11317183400013, 40.46078725200006],
            [75.06438928300008, 40.44383738200004],
            [75.03906783100007, 40.441098531000094],
            [75.00237756300004, 40.44729970300007],
            [74.96610070800006, 40.45928863500005],
            [74.87918094900004, 40.50507395400008],
            [74.85644331900005, 40.513187154],
            [74.83535933500013, 40.51163686100007],
            [74.83231214200009, 40.508116118000075],
            [74.82006311000009, 40.493963521000055],
            [74.81603234900007, 40.48367991100007],
            [74.81510217300013, 40.4801142380001],
            [74.80704064900004, 40.46176910400003],
            [74.79463830600008, 40.44073679600011],
            [74.78740360500012, 40.42073801700006],
            [74.79463830600008, 40.40554514600005],
            [74.84166385900005, 40.37205881800004],
            [74.85385949700009, 40.35882965100005],
            [74.8621277260001, 40.32617014600008],
            [74.83091516100012, 40.31991729800008],
            [74.74668257600013, 40.33650543200007],
            [74.72466841600004, 40.33753896100005],
            [74.70575484200003, 40.331286113000075],
            [74.65438846900008, 40.291546936000074],
            [74.63764530500004, 40.28198679700007],
            [74.59868127500005, 40.26617380800006],
            [74.5654016520001, 40.246950176000055],
            [74.47662154100004, 40.17243276],
            [74.36985803300007, 40.105821839],
            [74.33378788300007, 40.09372955300002],
            [74.30288537600006, 40.090060527000034],
            [74.27229292800013, 40.09383290600006],
            [74.23787642400009, 40.103909811000094],
            [74.20314986200003, 40.10985260000008],
            [74.16759647600009, 40.10639027900005],
            [74.13286991400008, 40.09533152300004],
            [74.10124393700005, 40.07884674100008],
            [74.06951460800013, 40.067787985000066],
            [74.00398889100006, 40.06081166600008],
            [73.97670373600005, 40.04360341400009],
            [73.96636844900013, 40.033268128000074],
            [73.95789351400003, 40.02143422500008],
            [73.95210575300007, 40.008256734],
            [73.94972863700008, 39.993683981000046],
            [73.94404423100008, 39.970067851000024],
            [73.9273010660001, 39.95332468700006],
            [73.90756066900013, 39.93787343400008],
            [73.89319462100013, 39.9181330360001],
            [73.88544315600012, 39.876533508000094],
            [73.88068892400014, 39.865009664000084],
            [73.87293746000006, 39.85684478800006],
            [73.84410201000009, 39.83808624300006],
            [73.83200972500003, 39.823720195000064],
            [73.82301802600006, 39.805685120000064],
            [73.81857385300009, 39.78604807600003],
            [73.81981408700011, 39.766721090000075],
            [73.82952925700005, 39.74698069200009],
            [73.84306848200004, 39.740366110000096],
            [73.85991499900007, 39.73716217000005],
            [73.87934533700007, 39.72791208900013],
            [73.89350468000004, 39.71039377900006],
            [73.89960249900008, 39.68946482300008],
            [73.90425337800013, 39.646470032000096],
            [73.92678430200004, 39.592881572000024],
            [73.92161665900005, 39.582132874000095],
            [73.89929244000007, 39.571539206000026],
            [73.88306604000007, 39.56120391900002],
            [73.87045699100008, 39.546786194],
            [73.85919152800011, 39.5242552700001],
            [73.84802941900006, 39.489735413000105],
            [73.83831425000005, 39.47567942400009],
            [73.82074426200006, 39.46818634100005],
            [73.63264204900014, 39.44834259000005],
            [73.60432336400004, 39.459608053000025],
            [73.51223596200003, 39.467411194000036],
            [73.47688928200012, 39.46477569600002],
            [73.36764530500005, 39.44379506500003],
            [73.34315067500006, 39.430669251000054],
            [73.33550256400008, 39.41516632100006],
            [73.33333215300013, 39.40111033100003],
            [73.32640751100013, 39.390878398000055],
            [73.26935673000014, 39.382558492000086],
            [73.16786421700004, 39.355376689000096],
            [73.13603153500003, 39.353464661000075],
            [73.10099491400007, 39.36116445000006],
            [73.08342492700012, 39.36783071000009],
            [73.0711259360001, 39.37072458900006],
            [73.05841353300013, 39.36881256100004],
            [73.00932092300008, 39.34860707700007],
            [72.99433475800004, 39.347831929000066],
            [72.97676477100003, 39.35222442700005],
            [72.91433964100008, 39.362714742],
            [72.89366906800007, 39.36390330000002],
            [72.85046757000003, 39.356720276000075],
            [72.83527469900008, 39.35620351100003],
            [72.6504797770001, 39.39377227800013],
            [72.63373661300005, 39.39449574800004],
            [72.61637333200014, 39.39041331000003],
            [72.60614139800003, 39.383488668000055],
            [72.58702111800005, 39.36488515300009],
            [72.57575565600007, 39.35930409800007],
            [72.55942590300003, 39.35956248000004],
            [72.53410445100008, 39.372326559],
            [72.51901493300005, 39.3756855270001],
            [72.50805953000008, 39.3719648240001],
            [72.47674361200006, 39.34612660800009],
            [72.46041385900014, 39.34411122600004],
            [72.44356734200005, 39.34478302000012],
            [72.41070113100005, 39.35134592700011],
            [72.39323449800008, 39.35082916300006],
            [72.35592411300007, 39.336101379000056],
            [72.33411665900013, 39.33382761600005],
            [72.3163399660001, 39.32881500300009],
            [72.3042476810001, 39.31357045600005],
            [72.28140669800013, 39.25972361300002],
            [72.24027225800012, 39.18990875300004],
            [72.22890344200005, 39.18923695900007],
            [72.22866824500005, 39.18950214400006],
            [72.21856815600012, 39.20088999400012],
            [72.20916304500008, 39.21729726200009],
            [72.20647587100007, 39.22688324000008],
            [72.20637251800014, 39.23460886700009],
            [72.20327193200006, 39.24081003800008],
            [72.18239465400012, 39.249336650000075],
            [72.16709842900013, 39.25874176100005],
            [72.15862349500014, 39.262617493],
            [72.11552535000004, 39.2681468710001],
            [72.0947514240001, 39.27507151300007],
            [72.08575972500006, 39.29010935500007],
            [72.0841060790001, 39.31124501600003],
            [72.07811161300009, 39.33661814400001],
            [72.06694950400004, 39.358477275000055],
            [72.0497929280001, 39.36886423700007],
            [72.03149947200012, 39.366693828000066],
            [71.99646285000006, 39.35186269200004],
            [71.95915246600003, 39.345868226000036],
            [71.94230594900006, 39.33904693600006],
            [71.84350061100014, 39.28504506500009],
            [71.80701704900008, 39.27284942700008],
            [71.77043013500008, 39.269542135000066],
            [71.75120650200006, 39.27424469000006],
            [71.73291304500009, 39.28509674100009],
            [71.71834029200011, 39.30106475800004],
            [71.71089888500012, 39.32096018500006],
            [71.71296594200004, 39.341527405000036],
            [71.72319787600014, 39.35398142500013],
            [71.73663374800009, 39.3645750940001],
            [71.74810591700003, 39.379561259000084],
            [71.75182662000003, 39.39966339100003],
            [71.74924279800013, 39.425501607000044],
            [71.74025109900009, 39.44834259000005],
            [71.7244381110001, 39.45940134800007],
            [71.70459436100009, 39.45898793600004],
            [71.60279178900004, 39.44234812400005],
            [71.55431929500014, 39.44415679900003],
            [71.51287479700011, 39.45883290700003],
            [71.49210087100005, 39.493662821000086],
            [71.50057580600014, 39.5092174280001],
            [71.52600061000004, 39.53815623000007],
            [71.53137496000011, 39.553090719000025],
            [71.52538049300011, 39.56916209000009],
            [71.51091109200007, 39.58414825500007],
            [71.50965448300008, 39.58499810000002],
            [71.4930310470001, 39.59624054000004],
            [71.45954471800007, 39.61210520500005],
            [71.44125126100005, 39.610658264000065],
            [71.40673140400014, 39.59815256800006],
            [71.37830936700004, 39.59417348200007],
            [71.36854252100005, 39.59148630800006],
            [71.3616178800001, 39.587558899000086],
            [71.34787194800003, 39.57624176100002],
            [71.34058557200007, 39.57169423400008],
            [71.30591068500007, 39.55717315700004],
            [71.29195804900007, 39.54895660400008],
            [71.26007369000013, 39.52063792000011],
            [71.2492733150001, 39.514385071],
            [71.23692264900012, 39.51448842400005],
            [71.17997521900014, 39.52301503600005],
            [71.13744551600007, 39.52115468400005],
            [71.09589766400012, 39.51236969000006],
            [71.06292810100013, 39.495626526000095],
            [71.04230920400005, 39.46787628200006],
            [71.02758142100004, 39.435216776000104],
            [71.00928796400007, 39.4076215620001],
            [70.97714522300004, 39.39490916000004],
            [70.94980839100009, 39.40074859600013],
            [70.9251587330001, 39.41294423400005],
            [70.90335127800006, 39.420850729000094],
            [70.88448938000005, 39.413874410000105],
            [70.87224206600013, 39.40297068300005],
            [70.86418054200004, 39.40059356700009],
            [70.85529219600011, 39.401730449000084],
            [70.8400993250001, 39.40142039000001],
            [70.82805871600004, 39.39857818700004],
            [70.79762129700003, 39.38534902000005],
            [70.77012943500006, 39.38209340400006],
            [70.73974369300004, 39.38622751900009],
            [70.71328536000004, 39.398423157000096],
            [70.6980924880001, 39.41899037700007],
            [70.69860925300003, 39.43139272100005],
            [70.70305342600005, 39.44472524000007],
            [70.7054305420001, 39.45852284800013],
            [70.69974613500005, 39.472165426000046],
            [70.69013431800005, 39.479193420000044],
            [70.66672489500007, 39.48689320900003],
            [70.65597619700009, 39.493714498000074],
            [70.65592452000004, 39.49386952800005],
            [70.65559843200009, 39.49466447300007],
            [70.63597741700005, 39.54249705000005],
            [70.62212813300005, 39.56352935800005],
            [70.59784021000007, 39.57779205300004],
            [70.58027022300007, 39.579549053],
            [70.54357995600003, 39.57427805600007],
            [70.52611332200007, 39.57562164300005],
            [70.51350427200003, 39.58151275600004],
            [70.49097334900006, 39.59686065700002],
            [70.47722741700011, 39.60120147700009],
            [70.45996748900012, 39.599547832000056],
            [70.42761804200012, 39.59009104400006],
            [70.41108158400004, 39.58745554700006],
            [70.40146976700004, 39.58476837100004],
            [70.39537194800005, 39.579497376000106],
            [70.39041101100008, 39.57401967400001],
            [70.38431319200004, 39.570867411000066],
            [70.37428796400013, 39.571022441000096],
            [70.35346236200007, 39.575931702000034],
            [70.34317875200009, 39.57686187700007],
            [70.33025964300009, 39.573089498000044],
            [70.24106612100013, 39.522394918000074],
            [70.22328942900009, 39.519087627],
            [70.20602950000011, 39.52410024000004],
            [70.20437585500008, 39.53815623000007],
            [70.21502120000014, 39.57407135000004],
            [70.21481449400011, 39.591124573000045],
            [70.21026696800004, 39.60972808900003],
            [70.20065515200014, 39.61949493400006],
            [70.18520389800005, 39.61034820600007],
            [70.15735030100006, 39.563891093000066],
            [70.14897871900013, 39.55427927700005],
            [70.13244226100011, 39.55004181],
            [70.11626753700011, 39.55464101200003],
            [70.08272953300013, 39.569782206000056],
            [70.06226566600003, 39.573451234000046],
            [70.0403548590001, 39.5736062620001],
            [70.01968428600009, 39.56859364900005],
            [70.00273441600007, 39.55686309800005],
            [69.98712813400005, 39.53960317000006],
            [69.97875655100006, 39.53443552700004],
            [69.94862919100007, 39.54508087200004],
            [69.90775313300009, 39.548491516000084],
            [69.83044519100008, 39.53624420200005],
            [69.79158451400008, 39.54539093100003],
            [69.74982995600004, 39.56383941700004],
            [69.71034916200006, 39.57407135000004],
            [69.66942142700003, 39.57779205300004],
            [69.58229496300004, 39.57355458600007],
            [69.56493168200012, 39.56812856100002],
            [69.53144535400014, 39.545649313000084],
            [69.51439213100008, 39.53758778900003],
            [69.49609867300012, 39.53257517500005],
            [69.4772884520001, 39.53040476500006],
            [69.45527429200013, 39.53045644200007],
            [69.41217614800013, 39.525030416],
            [69.39145389800007, 39.53050811800007],
            [69.36721765200008, 39.54993845700007],
            [69.36163659700009, 39.55288401400007],
            [69.35202478000008, 39.54962839800008],
            [69.34840743000007, 39.54316884300003],
            [69.34592696100003, 39.535365703000096],
            [69.33972579000005, 39.528079326000025],
            [69.30034834800006, 39.51562530500006],
            [69.2861890050001, 39.53970652300008],
            [69.29114994400004, 39.658872376000076],
            [69.28753259300004, 39.67778595],
            [69.28009118600005, 39.69427073200008],
            [69.26593184500007, 39.70775828000005],
            [69.24836185700008, 39.719385478],
            [69.23332401500011, 39.73266632100011],
            [69.22629602000012, 39.751011455000096],
            [69.22955163500012, 39.79054392500005],
            [69.24071374600004, 39.82893951400008],
            [69.28644738800006, 39.93575470000009],
            [69.30567102100008, 39.96862091100003],
            [69.31006351700006, 39.97864613900005],
            [69.31032190000013, 39.984795635000026],
            [69.31399092600003, 39.986914368],
            [69.32784021000009, 39.984743958000095],
            [69.35729577600011, 39.95947418300004],
            [69.40535485800007, 39.89611887600002],
            [69.50157637500013, 39.92247385700007],
            [69.50043949400009, 39.93570302400009],
            [69.4772884520001, 39.96815582300009],
            [69.47811527600004, 39.975028788000074],
            [69.4772884520001, 39.98159169500006],
            [69.47511804200013, 39.98774119100001],
            [69.47119063300005, 39.993683981000046],
            [69.46312911000007, 40.02541331000005],
            [69.46964034100012, 40.05099314400009],
            [69.48571171000009, 40.07373077400008],
            [69.50633060700011, 40.096933493000094],
            [69.5092244870001, 40.10344472300007],
            [69.51346195500014, 40.120704651000054],
            [69.51800948100009, 40.12509714800005],
            [69.52607100400007, 40.12318511900013],
            [69.53661299600003, 40.10788889600006],
            [69.54302087400009, 40.103082987000064],
            [69.55883386200009, 40.1017394],
            [69.57547367300009, 40.103599752],
            [69.96955814600005, 40.211603495000034],
            [70.00459476700007, 40.20876129100007],
            [70.14717004400012, 40.136982727000074],
            [70.16882246900008, 40.13166005500004],
            [70.21853519700011, 40.1341405240001],
            [70.24153120900007, 40.13274526000002],
            [70.26349369300004, 40.12427032500001],
            [70.2778080650001, 40.11207468700009],
            [70.29026208500011, 40.09817372700003],
            [70.30628177900007, 40.084789531000084],
            [70.32426517700003, 40.07750315400001],
            [70.35950850500012, 40.07404083300007],
            [70.39764571100005, 40.06122507800008],
            [70.47722741700011, 40.05202667300007],
            [70.50213545800005, 40.04598053000005],
            [70.52549320500003, 40.033681539],
            [70.53562178600009, 40.01595652300007],
            [70.52094567900008, 39.993735657000045],
            [70.50502933800004, 39.98510569300002],
            [70.48849287900003, 39.978542786000034],
            [70.47319665600008, 39.97011952800004],
            [70.46022587100009, 39.95611521400012],
            [70.45087243600005, 39.937408346000055],
            [70.44803023300005, 39.919993388000094],
            [70.45562666800004, 39.90681589800003],
            [70.47722741700011, 39.90092478500013],
            [70.48596073400006, 39.90960642500009],
            [70.49417728700013, 39.93167226200008],
            [70.50089522300004, 39.9405606080001],
            [70.5125740960001, 39.94515981000005],
            [70.55505212400004, 39.94624501600005],
            [70.57660119600007, 39.95223948200008],
            [70.59659997600005, 39.96195465100003],
            [70.61396325700014, 39.97575225900006],
            [70.62739913000007, 39.993890686],
            [70.63597741700005, 40.028513896],
            [70.63473718300008, 40.05931305000006],
            [70.63943973800008, 40.08494456000004],
            [70.66594974800006, 40.10416819300006],
            [70.72982181900005, 40.120704651000054],
            [70.74346439600004, 40.12711252900009],
            [70.78253177900007, 40.15258901000003],
            [70.78873295100004, 40.15899688800006],
            [70.79214359500008, 40.161374004],
            [70.79772465000008, 40.16194244400005],
            [70.80268558800003, 40.16013376900007],
            [70.80604455600013, 40.157653301],
            [70.80671634900011, 40.15615468400007],
            [70.82490645300004, 40.16354441300008],
            [70.83183109500004, 40.16819529200005],
            [70.84516361500005, 40.171812642000035],
            [70.89854537000008, 40.162614238000046],
            [70.92929284700011, 40.17062408500003],
            [70.96288252800014, 40.189692688],
            [70.97952233900008, 40.21408396400001],
            [70.95895511900011, 40.23837188800012],
            [70.99512862200004, 40.26658722000009],
            [71.05321293200012, 40.27423533100007],
            [71.16938155100007, 40.26141957700007],
            [71.20100752700006, 40.26384836900003],
            [71.21511519400008, 40.28074656200003],
            [71.22395186300008, 40.302864075000045],
            [71.23955814600004, 40.3211058560001],
            [71.2538208410001, 40.3244131470001],
            [71.26394942300004, 40.31821197500001],
            [71.27283776900009, 40.30772166000007],
            [71.28322473200006, 40.29841990200005],
            [71.29707401600007, 40.293820699],
            [71.31355879800003, 40.29268381800007],
            [71.34492639200005, 40.295215963000075],
            [71.36513187600013, 40.294130758000065],
            [71.39655114800007, 40.271548157000026],
            [71.44135461400003, 40.260902812000054],
            [71.4509664310001, 40.248913879000085],
            [71.45892460200014, 40.234134420000075],
            [71.47711470600007, 40.22080190100006],
            [71.49840539600007, 40.21051829100004],
            [71.52124637800006, 40.20374867800011],
            [71.56827193200013, 40.196565653000064],
            [71.59297326700005, 40.19842600500006],
            [71.60165490700012, 40.20994985],
            [71.60403202300006, 40.22726145500009],
            [71.6101298420001, 40.2463817350001],
            [71.62831994600003, 40.258887431000076],
            [71.64599328600008, 40.247105204],
            [71.6601526290001, 40.22447092700004],
            [71.66718062300004, 40.20416208900012],
            [71.66687056500012, 40.16313100200007],
            [71.67307173600011, 40.147886455000034],
            [71.69332889800012, 40.1411168420001],
            [71.70717818200006, 40.14426910400006],
            [71.75978479000008, 40.16809193900012],
            [71.77590783700003, 40.17992584300005],
            [71.78675988800012, 40.193516744000036],
            [71.8054667560001, 40.22529775000005],
            [71.83647261600004, 40.249172262000044],
            [71.87295617700005, 40.250774231],
            [71.91233361900004, 40.243436178000096],
            [71.95181441300014, 40.240904033],
            [71.96338993300009, 40.243746236000064],
            [71.96917769400005, 40.24441803000006],
            [71.97703251100012, 40.24307444300008],
            [71.98902144300007, 40.23930206300007],
            [72.00483443200005, 40.23728668200003],
            [72.01889042200008, 40.240025533000065],
            [72.02540165300013, 40.25087758400012],
            [72.01982059800014, 40.258732401000046],
            [72.01323892900012, 40.26207235200009],
            [72.00597131300009, 40.26576039600006],
            [71.97703251100012, 40.276095683000065],
            [71.9582222900001, 40.286534322000094],
            [71.95109094300005, 40.301520488000065],
            [71.95667199800005, 40.315679831000026],
            [72.04317834500006, 40.349321188000076],
            [72.06963667800005, 40.369423320000024],
            [72.0841060790001, 40.39738027000003],
            [72.09010054500004, 40.416035462000096],
            [72.09929895000005, 40.42637074800008],
            [72.16585819500011, 40.45443105100013],
            [72.18270471200009, 40.45779001900003],
            [72.2283278000001, 40.4596060840001],
            [72.23593143700003, 40.45990875300002],
            [72.25422489400012, 40.45830678300008],
            [72.26341527500006, 40.45265116500012],
            [72.2636300050001, 40.45251902300002],
            [72.25959924400007, 40.44239044200005],
            [72.24512984200004, 40.438721415000046],
            [72.22807662000014, 40.43753285800004],
            [72.21650109900008, 40.43494903600002],
            [72.21176846300011, 40.425836195],
            [72.21164351400006, 40.4255956010001],
            [72.22435591700008, 40.422443339000026],
            [72.2696244710001, 40.42404530900008],
            [72.28430057800011, 40.419859518000024],
            [72.34341841600008, 40.39340118400004],
            [72.3704968670001, 40.385649720000046],
            [72.3940613200001, 40.38942209900007],
            [72.41442183400005, 40.410712789000044],
            [72.4251705320001, 40.4359825640001],
            [72.42620406100013, 40.459340312000066],
            [72.42609577400009, 40.45954520700003],
            [72.4200279160001, 40.47102654600012],
            [72.41566206900006, 40.47928741500009],
            [72.4155850520001, 40.47932995800004],
            [72.37225386600011, 40.503265279000075],
            [72.36346887200011, 40.51230865500004],
            [72.36346700700005, 40.512410315000025],
            [72.36326216700013, 40.52357411800001],
            [72.36998010200006, 40.539852194000034],
            [72.3700834550001, 40.55773223900009],
            [72.36992827500006, 40.557930855000095],
            [72.34848270600014, 40.585379131000096],
            [72.34850925500012, 40.58550825700003],
            [72.35189335100006, 40.60196726500003],
            [72.38155562400004, 40.612147522000086],
            [72.41483524600005, 40.58987498000003],
            [72.44790816300014, 40.560471090000036],
            [72.47674361200006, 40.549567363000065],
            [72.51529423000005, 40.545639954000094],
            [72.58578088400003, 40.50874298200007],
            [72.6254683840001, 40.51049998000006],
            [72.64086796100008, 40.51985341400008],
            [72.6504797770001, 40.53215240500005],
            [72.65513065600004, 40.546363424],
            [72.6564742430001, 40.56114288300002],
            [72.66422570800012, 40.57778269500004],
            [72.68241581200004, 40.57767934200011],
            [72.71920943200007, 40.564863586000044],
            [72.74835494000007, 40.57509552100002],
            [72.76003381400005, 40.64175811800003],
            [72.78390832600013, 40.6696633910001],
            [72.81894494700003, 40.681083883],
            [72.89098189300012, 40.6950881960001],
            [72.97676477100003, 40.73606760700004],
            [73.07060917100006, 40.76247426400003],
            [73.11804813700013, 40.78293813100008],
            [73.14864058400013, 40.81368560800003],
            [73.14336958900003, 40.83383941700002],
            [73.1432919940001, 40.83385278200005],
            [73.1350415550001, 40.83527384400004],
            [73.11246708200008, 40.839162090000045],
            [73.0535559490001, 40.836319886000084],
            [73.03329878700009, 40.847223612000036],
            [73.01944950400014, 40.86189972000004],
            [73.00342981000006, 40.87016794800009],
            [72.92942915800006, 40.84417470300012],
            [72.88312707500012, 40.81962839800006],
            [72.87031132000004, 40.81818145800007],
            [72.87299849400006, 40.834821269000074],
            [72.86865767400008, 40.86412180600003],
            [72.83010705600009, 40.8720799770001],
            [72.70122603400006, 40.863243307000104],
            [72.65823124200011, 40.867170716000075],
            [72.61947391800004, 40.88008982400008],
            [72.58846805900004, 40.90582468700008],
            [72.54557662000008, 40.95651926700005],
            [72.52624963400012, 40.962203674000094],
            [72.5014449460001, 40.963495586000036],
            [72.48335819500005, 40.97057525600006],
            [72.48356490100014, 40.993519592],
            [72.4852185470001, 40.99956573500005],
            [72.48470178200006, 41.00468170200013],
            [72.48191125500006, 41.00881581700004],
            [72.47674361200006, 41.011813049000054],
            [72.42351688700012, 41.01574045900013],
            [72.39519820100014, 41.02204498300004],
            [72.37432092300014, 41.03196685800005],
            [72.34569217900008, 41.06596995000008],
            [72.33235966000007, 41.072842917000045],
            [72.3140662030001, 41.061680807000116],
            [72.30879520700006, 41.05444610600004],
            [72.29732303900005, 41.028142802],
            [72.28977828000006, 41.02354360000005],
            [72.2529846600001, 41.01961619100008],
            [72.1954864970001, 41.00635779100007],
            [72.16513472500003, 40.99935903000009],
            [72.17877730300012, 41.02318186500007],
            [72.18559859200008, 41.04106191100003],
            [72.18559859200008, 41.06064727800005],
            [72.17640018800006, 41.112892151000025],
            [72.17464318800012, 41.14141754200007],
            [72.16988895700013, 41.16865102200008],
            [72.15841678900011, 41.187874654],
            [72.13288863200006, 41.19929514600001],
            [72.10849735500011, 41.196401266000024],
            [72.08524296100012, 41.18487742100008],
            [72.06364221200005, 41.17020131400001],
            [72.03377323400014, 41.15661041300011],
            [72.01651330600004, 41.16353505500008],
            [72.00121708100005, 41.180019836000056],
            [71.97703251100012, 41.195212708],
            [71.89765751200014, 41.18492909800001],
            [71.87161259000004, 41.1944892370001],
            [71.86634159400012, 41.236605530000034],
            [71.8688220630001, 41.27923858700002],
            [71.86303430200013, 41.312208150000075],
            [71.84701460800005, 41.341818746000044],
            [71.7531702070001, 41.44729034400008],
            [71.74521203600011, 41.452819723000076],
            [71.73684045400006, 41.455403544],
            [71.7304325770001, 41.45116607700005],
            [71.72970910600003, 41.43008209200012],
            [71.7216475830001, 41.42475942000006],
            [71.71224247300006, 41.42801503600005],
            [71.7068681230001, 41.44408640500002],
            [71.69611942500006, 41.447445374000026],
            [71.69146854700011, 41.44191599600002],
            [71.68733443200011, 41.43101226800006],
            [71.6814433190001, 41.42284739200004],
            [71.67193485500013, 41.425482890000055],
            [71.67110803300011, 41.437626852000065],
            [71.68950484200008, 41.49379913400013],
            [71.68940148900003, 41.51462473500008],
            [71.68413049400004, 41.53405507500007],
            [71.67141809100008, 41.547387594000085],
            [71.64950728400004, 41.54991973900006],
            [71.6273897700001, 41.54320180300006],
            [71.61529748500004, 41.53214304600006],
            [71.59545373600014, 41.493747457000026],
            [71.59555708800008, 41.493695781],
            [71.59555708800008, 41.493489075000056],
            [71.6055823160001, 41.47684926400002],
            [71.63369429600004, 41.44961578400002],
            [71.63741499900004, 41.43127065100005],
            [71.63307417800007, 41.411323547],
            [71.61881148300006, 41.37778554300009],
            [71.58553186100005, 41.323525289000074],
            [71.55793664600003, 41.30171783500005],
            [71.52383020100007, 41.29665354500007],
            [71.48062870300004, 41.3107612110001],
            [71.43246626800004, 41.344815980000035],
            [71.41877201400013, 41.34739980100004],
            [71.41257084200004, 41.3346873980001],
            [71.42145918800014, 41.16208811500009],
            [71.41608483900006, 41.12736155200007],
            [71.3936572670001, 41.1127371220001],
            [71.32523767100008, 41.15733388300002],
            [71.30022627800008, 41.1330459600001],
            [71.2894775800001, 41.113874004000095],
            [71.27614506100008, 41.11315053300011],
            [71.26338098200011, 41.12348582000003],
            [71.2538208410001, 41.1374901330001],
            [71.24152185100007, 41.17516225200005],
            [71.23015303600005, 41.187254537000044],
            [71.20638187700013, 41.188753154000054],
            [71.18571130400011, 41.18022654300002],
            [71.18302412900005, 41.16637725900007],
            [71.18788171400007, 41.148445537],
            [71.18994877100005, 41.12746490500008],
            [71.18013024900006, 41.10813791900004],
            [71.16442061400011, 41.11619944300013],
            [71.13909916200004, 41.14839386000007],
            [71.12307946800007, 41.15821238200006],
            [71.08576908400005, 41.16203643900009],
            [71.06757898000012, 41.16973622600007],
            [71.04701176000003, 41.182035218000024],
            [71.02468754100005, 41.18978668200002],
            [70.97714522300004, 41.19634958900009],
            [70.93415043100003, 41.19144032800007],
            [70.91420332900003, 41.19304229700002],
            [70.89596154800006, 41.206116435000055],
            [70.88216394100004, 41.220482483000055],
            [70.86573083500008, 41.23319488600002],
            [70.84774743600008, 41.243065084000094],
            [70.82852380300005, 41.24911122700006],
            [70.80599288000013, 41.24745758100009],
            [70.78656254100014, 41.240429586000076],
            [70.77043949400007, 41.238517558000055],
            [70.75803715000012, 41.25216013600006],
            [70.75628015200004, 41.269626771000034],
            [70.77105961100006, 41.33101837200009],
            [70.76919925900012, 41.35210235600003],
            [70.75969079600003, 41.37251454700008],
            [70.7035701910001, 41.4454816690001],
            [70.68672367400012, 41.462483216000024],
            [70.66781009900006, 41.471371562000044],
            [70.63380700700003, 41.46749582900007],
            [70.51133386200007, 41.41447581000007],
            [70.47722741700011, 41.40465728800011],
            [70.47078170900005, 41.40487907600006],
            [70.45319787600005, 41.405484111000035],
            [70.43805668200014, 41.41607777900002],
            [70.41361372900013, 41.450700989000026],
            [70.39898929800006, 41.464963685],
            [70.38224613400007, 41.47643585200011],
            [70.34493575000005, 41.493489075000056],
            [70.34472904500012, 41.49364410400007],
            [70.34452233900004, 41.493695781],
            [70.34441898600011, 41.49379913400013],
            [70.20344567900008, 41.50563303700004],
            [70.16654870600007, 41.52020579000002],
            [70.1482552490001, 41.552451884000064],
            [70.16928755700013, 41.578341777],
            [70.33118981900003, 41.649629415000064],
            [70.39082442200004, 41.68505361000008],
            [70.42348392800011, 41.69691335100002],
            [70.4536629640001, 41.71208038400003],
            [70.47722741700011, 41.738435365],
            [70.50647627700005, 41.78559010800011],
            [70.55009118700008, 41.82406321200007],
            [70.64894820200004, 41.887392680000076],
            [70.67969567900013, 41.901112773000094],
            [70.77932784100005, 41.90966522300003],
            [70.81400272600013, 41.91953542100002],
            [70.82511316000011, 41.936330262000055],
            [70.82805871600004, 41.993742778000055],
            [70.84547367400006, 42.03035553000011],
            [70.88671146700005, 42.03849456800002],
            [70.93590743100003, 42.03686676100007],
            [70.97714522300004, 42.04423065200008],
            [71.11842858900013, 42.122908020000054],
            [71.20100752700006, 42.1407880660001],
            [71.23821455900008, 42.16024424300009],
            [71.25320072500006, 42.19755462700003],
            [71.24986822800008, 42.19838531500004],
            [71.21785404400003, 42.206365458000036],
            [71.07760420700004, 42.281167094000054],
            [71.04577152600007, 42.290959778000015],
            [71.01404219500006, 42.28770416300004],
            [70.96960046400005, 42.26346791600004],
            [70.94779300900007, 42.24814585400007],
            [70.91864750200006, 42.25336517300009],
            [70.89782189900006, 42.261607564000045],
            [70.8581344000001, 42.29106313100006],
            [70.85265669800003, 42.30607513500003],
            [70.86480066000013, 42.32155222600004],
            [70.88882503300005, 42.33857531100007],
            [70.90035404500009, 42.346744487000066],
            [70.93270349100004, 42.37620005300009],
            [70.93983483900007, 42.38782725100005],
            [70.93735437100014, 42.39477773000003],
            [70.9317733150001, 42.40149566700005],
            [70.9299129640001, 42.41229604100009],
            [70.93611413600007, 42.431623026000054],
            [70.94758630400008, 42.451285909],
            [70.96195235200008, 42.468106588000055],
            [70.97714522300004, 42.478751933000055],
            [71.02473921800004, 42.455962626000044],
            [71.04101729400008, 42.45479990600005],
            [71.05471154800011, 42.46038096100004],
            [71.06416833500009, 42.47032867500006],
            [71.06628706900005, 42.48213674000006],
            [71.05786381100006, 42.49340220200013],
            [71.0576571040001, 42.49340220200013],
            [71.05755375100006, 42.493505555000056],
            [71.05755375100006, 42.49360890700008],
            [71.02272383700011, 42.51644989000009],
            [71.01269860800011, 42.52603586800008],
            [71.00319014500008, 42.563527121000064],
            [71.04065555900007, 42.58052866600009],
            [71.12700687700004, 42.59060557100004],
            [71.14276818900004, 42.60254282600009],
            [71.14809086100007, 42.61739980100002],
            [71.14643721500005, 42.65685475700003],
            [71.14902103700013, 42.67793874100006],
            [71.15754764800005, 42.68793813100008],
            [71.19521976800007, 42.697239889000016],
            [71.21144616700008, 42.705223898000085],
            [71.22384851100014, 42.717936300000034],
            [71.24544925900005, 42.74713348400006],
            [71.26250248200006, 42.75356720000012],
            [71.28472334800011, 42.7483995570001],
            [71.30849450700003, 42.740105489000044],
            [71.32978519700004, 42.737030742000016],
            [71.34756189000007, 42.74284434000002],
            [71.36306482000009, 42.75410980300005],
            [71.37629398600006, 42.76832082200012],
            [71.38693933200005, 42.78307444300013],
            [71.40461267100005, 42.79488250800004],
            [71.42884891800014, 42.795580140000126],
            [71.47711470600007, 42.783539531000045],
            [71.49365116400008, 42.78891388000001],
            [71.50419315600004, 42.78961151200009],
            [71.5143217370001, 42.785709941000036],
            [71.55380253100003, 42.76090525300002],
            [71.56630822800008, 42.75723622700009],
            [71.58356815600007, 42.759639181000054],
            [71.69353560400009, 42.81180653900013],
            [71.72640181500003, 42.81966135700007],
            [71.7966817630001, 42.82229685500009],
            [71.83140832600003, 42.831572774],
            [71.84773807800008, 42.83405324300007],
            [71.8632410080001, 42.82904063000002],
            [71.87884729000012, 42.82134084100004],
            [71.89538374900013, 42.81604400700009],
            [71.95698205600007, 42.804597677000075],
            [72.07273726400012, 42.75718455],
            [72.10488000500004, 42.75033742300003],
            [72.11996952300007, 42.751810201000026],
            [72.1488049730001, 42.7619904590001],
            [72.16410119700004, 42.765091044000044],
            [72.2923621010001, 42.76106028300005],
            [72.35840458200005, 42.741397400000025],
            [72.47674361200006, 42.68256378200003],
            [72.51178023300008, 42.67755116800005],
            [72.5838171800001, 42.67827463800005],
            [72.72582401500006, 42.652875672000064],
            [72.7569332270001, 42.640214946000114],
            [72.78060103400014, 42.62044871000005],
            [72.81522424400004, 42.57303558300005],
            [72.84075240100009, 42.555698141000065],
            [72.87454878800008, 42.54399342900008],
            [72.90834517400003, 42.536965435000056],
            [72.94234826700011, 42.536035259000116],
            [73.07060917100006, 42.55192576100002],
            [73.11505090300011, 42.550840556000125],
            [73.15267134600003, 42.53921335900007],
            [73.17272180200007, 42.527844544000075],
            [73.1890515550001, 42.52076487300006],
            [73.20682824700003, 42.517173361000076],
            [73.27834843000011, 42.51340098100006],
            [73.30139611900006, 42.50707061800004],
            [73.31658898900008, 42.49371226],
            [73.31338505100013, 42.463171488000015],
            [73.31441858000011, 42.441570740000046],
            [73.32620080600009, 42.42867747000004],
            [73.41746138500008, 42.41705027300007],
            [73.47688928200012, 42.3990668740001],
            [73.5051046150001, 42.40294260700004],
            [73.50551802600012, 42.42092600500003],
            [73.50507740900008, 42.42155711600013],
            [73.4329643150001, 42.52484731100007],
            [73.41756473800012, 42.55616322900006],
            [73.41001997900014, 42.58964955600008],
            [73.4127071530001, 42.62732167600011],
            [73.42386926300014, 42.66277170900004],
            [73.47688928200012, 42.750880025000086],
            [73.50355432100008, 42.79408152300003],
            [73.50706831900004, 42.809403585000084],
            [73.50427779100005, 42.82759369000003],
            [73.49197880100013, 42.86100250300011],
            [73.48949833200004, 42.87782318100007],
            [73.49301233000011, 42.89495391900003],
            [73.50117720500003, 42.90934580500003],
            [73.52174442500012, 42.936165873000036],
            [73.55967492700012, 43.01729787200007],
            [73.5709403890001, 43.03192230300006],
            [73.58665002400005, 43.04228342700007],
            [73.63408899000012, 43.062463074000036],
            [73.80555139200004, 43.11473378500004],
            [73.82281132000008, 43.11731760700006],
            [73.86425581900005, 43.11610321000002],
            [73.90166955600006, 43.13096018500006],
            [73.93505253100011, 43.19971567900005],
            [73.96533492000003, 43.21692393000011],
            [73.98538537600007, 43.21167877200007],
            [74.02145552600007, 43.186305644000086],
            [74.03985233600008, 43.18186147100009],
            [74.19736210200006, 43.19578826900006],
            [74.21389856000008, 43.20263539700004],
            [74.21658573400003, 43.21692393000011],
            [74.20604374200013, 43.23410634400007],
            [74.17875858500014, 43.26170155800007],
            [74.2076973880001, 43.24979014100005],
            [74.25865035000004, 43.2157612110001],
            [74.28696903500014, 43.207208761000075],
            [74.32004195200011, 43.20165354500007],
            [74.34877404800011, 43.19103403700008],
            [74.40055383300012, 43.15953725200002],
            [74.42060428900004, 43.151837464000025],
            [74.46277225800009, 43.14863352500005],
            [74.49822229000011, 43.131115215000094],
            [74.53925337700008, 43.122898661000065],
            [74.55816695200014, 43.11504384400003],
            [74.57201623500009, 43.10220225000005],
            [74.59702762900008, 43.07034373000009],
            [74.61129032400004, 43.05817393000008],
            [74.71391971800006, 42.999882914000054],
            [74.74874963400009, 42.99001271600007],
            [74.86285119700011, 42.97582753500011],
            [74.94853072100005, 42.944847514000074],
            [74.9768494060001, 42.926476543],
            [75.00537479700012, 42.916399638000044],
            [75.06614628100004, 42.902602031000114],
            [75.09425826100005, 42.89030304000006],
            [75.11813277200008, 42.87653127100002],
            [75.1785941980001, 42.849659526000025],
            [75.20463911900009, 42.845189515000115],
            [75.27119836400004, 42.84575795500005],
            [75.49661096200009, 42.82392466300003],
            [75.53598840400008, 42.82702524900007],
            [75.55593550600014, 42.825216574000066],
            [75.62042769400006, 42.80529530900007],
            [75.64616255700014, 42.806096294000085],
            [75.67530806500014, 42.815372213],
            [75.70383345500011, 42.83048757000002],
            [75.72760461500008, 42.84867767400006],
            [75.73824996000008, 42.861570944000064],
            [75.77059940600003, 42.92564971900008],
            [75.78207157400004, 42.933323670000064],
            [75.79716109300006, 42.936191712000024],
            [75.80705856000009, 42.93677099500009],
            [75.85896610600014, 42.939809062],
            [75.89803348800007, 42.935700785],
            [75.97658166500008, 42.918725077],
            [75.99911259000004, 42.917639873],
            [76.06453495300008, 42.933969626000035],
            [76.09057987500006, 42.93427968400003],
            [76.16375370300005, 42.921153870000055],
            [76.25449751800011, 42.921153870000055],
            [76.34048710100006, 42.90167185500006],
            [76.35113244700005, 42.90288625100008],
            [76.37097619600007, 42.90960418700011],
            [76.38296512800014, 42.910069275000026],
            [76.39330041500006, 42.90526336700013],
            [76.40446252400005, 42.88924367300008],
            [76.41407434100006, 42.885497131000065],
            [76.43205773900007, 42.889579570000066],
            [76.4619267170001, 42.91099945100008],
            [76.48053023300014, 42.916968079000114],
            [76.50688521300009, 42.91448761000005],
            [76.55876835100008, 42.89820953400003],
            [76.58501997900004, 42.894798889000086],
            [76.6058972570001, 42.898493754000086],
            [76.64434452300003, 42.91112864200004],
            [76.68878625500014, 42.9103276580001],
            [76.70790653500012, 42.9136607870001],
            [76.74625044800013, 42.92887949700004],
            [76.75038456200008, 42.93257436200004],
            [76.75162479700009, 42.93709604900009],
            [76.75389856000004, 42.94076507600006],
            [76.76133996600004, 42.94205698700004],
            [76.77953007000008, 42.93929229700008],
            [76.78521447800011, 42.93965403300008],
            [76.79296594200014, 42.94306467700001],
            [76.81415328000008, 42.96148732500011],
            [76.83348026600004, 42.971745097000095],
            [76.85342736900003, 42.97412221300003],
            [76.89766239400006, 42.97453562500006],
            [76.93734989400008, 42.98603363100007],
            [76.95688358600006, 42.98851409900006],
            [76.97641727700005, 42.98220957500003],
            [77.08989872300003, 42.968153585000024],
            [77.12400516800005, 42.95890350400002],
            [77.13506392400006, 42.95174631800005],
            [77.16369266800007, 42.921980693000066],
            [77.17867883300005, 42.91319569900007],
            [77.19511193900007, 42.910069275000026],
            [77.21189028200013, 42.90994368900003],
            [77.22963179500005, 42.909810893000056],
            [77.32812707500005, 42.89756357900005],
            [77.36088993300012, 42.90453989700005],
            [77.40326460700004, 42.91975860600006],
            [77.41856083200008, 42.922239075000036],
            [77.43396040900006, 42.921412252000025],
            [77.46176232900007, 42.91438425800003],
            [77.50155318200007, 42.91453928600005],
            [77.52098352100012, 42.90691701300007],
            [77.53845015500008, 42.8962716680001],
            [77.55777714100003, 42.88813263000007],
            [77.57441695100005, 42.8878484100001],
            [77.62692020700013, 42.906555278000084],
            [77.64779748500007, 42.90950083400007],
            [77.71383996600014, 42.90758880700007],
            [77.78122603400004, 42.895625713000115],
            [77.78753055800007, 42.88970876100011],
            [77.79166467300007, 42.883042501],
            [77.79817590300007, 42.8775131230001],
            [77.80995813000004, 42.871286113000096],
            [77.83558964000014, 42.8798385620001],
            [77.85222945200013, 42.88795176300003],
            [77.86122115100005, 42.890819804],
            [77.88385542800012, 42.89322275800005],
            [77.90700647000011, 42.89128489200003],
            [77.9293306890001, 42.88500620600003],
            [77.98617476400005, 42.860201518000096],
            [78.0306164960001, 42.85467214000009],
            [78.13789677000005, 42.861984355000075],
            [78.18357873600007, 42.86014984200007],
            [78.22977746600003, 42.865007427000094],
            [78.2491044520001, 42.862397767000076],
            [78.29013553900012, 42.851442363],
            [78.31121952300003, 42.850512187000064],
            [78.32837609900008, 42.855292257000045],
            [78.36465295400006, 42.87252634700003],
            [78.38553023300005, 42.878236593000096],
            [78.4295585540001, 42.88066538500006],
            [78.49611779800006, 42.87560109500008],
            [78.59430301900005, 42.85022796600008],
            [78.63543745900006, 42.83247711200006],
            [78.66995731600014, 42.81116058400006],
            [78.68711389200007, 42.804597677000075],
            [78.80793339000013, 42.795580140000126],
            [78.88813521300011, 42.77121470100009],
            [78.95428104700005, 42.76842417400006],
            [78.99293501800008, 42.757132874],
            [79.03086551900009, 42.756151022000026],
            [79.10879357900006, 42.78534820600005],
            [79.1482743740001, 42.79098093700007],
            [79.17338911900009, 42.78563242600002],
            [79.18083052600014, 42.77552968400009],
            [79.1751461180001, 42.737030742000016],
            [79.17607629400004, 42.71393137600005],
            [79.18186405500012, 42.693596700000015],
            [79.1921993410001, 42.67483815600012],
            [79.20635868400007, 42.65646718300003],
            [79.24211877400006, 42.62977630600007],
            [79.3212870690001, 42.602181092000066],
            [79.35301639800008, 42.57729889000002],
            [79.39838830600013, 42.496942038000086],
            [79.42567346200013, 42.46960520400005],
            [79.47641971900003, 42.453973084000026],
            [79.57191776500008, 42.44952891100009],
            [79.652533, 42.46105275500004],
            [79.69645796700013, 42.4598383590001],
            [79.91794315600009, 42.42444000300007],
            [79.96011112500008, 42.403511048],
            [79.97396040800004, 42.39147043900003],
            [80.01209761600006, 42.349509176000126],
            [80.07700321500005, 42.30576507600004],
            [80.11007613100008, 42.273338115000044],
            [80.13653446400008, 42.23886993500007],
            [80.16661014800007, 42.208716736000085],
            [80.21032841000005, 42.18951894100006],
          ],
          [
            [71.7855196540001, 39.98970489500006],
            [71.7606116130001, 39.98371042900003],
            [71.72412805200008, 39.96267812100011],
            [71.7068681230001, 39.95611521400012],
            [71.68175337800005, 39.95508168600004],
            [71.66552697800006, 39.940198873],
            [71.67534550000005, 39.92578114900009],
            [71.69684289600008, 39.91384389200003],
            [71.71616988100004, 39.90676422100002],
            [71.74180139100008, 39.9007697550001],
            [71.7573043210001, 39.90309519400002],
            [71.7671228430001, 39.915445862000084],
            [71.78975712100004, 39.97931793200003],
            [71.7855196540001, 39.98970489500006],
          ],
          [
            [71.17692631000011, 40.042001445000054],
            [71.16938155100007, 40.042828267000075],
            [71.1654541420001, 40.04463694300007],
            [71.16204349800006, 40.046910706000105],
            [71.10597456900013, 40.064945781000105],
            [71.07884444200005, 40.078640036000124],
            [71.06173954200011, 40.09517649300001],
            [71.04794193500004, 40.12251332600003],
            [71.03119877200004, 40.14690460300007],
            [71.00856449400004, 40.15775665300002],
            [70.97714522300004, 40.144579163000046],
            [70.95988529400006, 40.11341827400007],
            [70.95404585800014, 40.09579661100007],
            [70.95296065300005, 40.07920847600006],
            [70.95843835400007, 40.06308542900008],
            [70.98313969000009, 40.02138254800006],
            [70.99450850400007, 40.00887685200006],
            [71.0076343180001, 40.003502503],
            [71.03429935700007, 39.999110006000095],
            [71.04582320100008, 39.992030335],
            [71.05037072800013, 39.96288482700005],
            [71.0076343180001, 39.9111567180001],
            [71.00928796400007, 39.8857319130001],
            [71.0218970140001, 39.88082265200008],
            [71.03605635600013, 39.887540589000096],
            [71.04980228700009, 39.89797922800004],
            [71.06096439600003, 39.904128723],
            [71.07998132300008, 39.903405254000106],
            [71.08478723100006, 39.89482696600008],
            [71.08721602400004, 39.88381988600007],
            [71.09889489800008, 39.87549998000013],
            [71.11367435700004, 39.87446645200005],
            [71.16100996900008, 39.884233297],
            [71.1945996500001, 39.884801738000064],
            [71.2084489340001, 39.88878082300003],
            [71.21909427900005, 39.90092478500013],
            [71.22105798400008, 39.931723938000104],
            [71.17702966300004, 39.96815582300009],
            [71.1747042240001, 39.9939940390001],
            [71.19098230000003, 40.00624135400004],
            [71.23728438300003, 40.031097717000094],
            [71.24400231900006, 40.046755677000064],
            [71.23635420800008, 40.05605743400007],
            [71.22374515800004, 40.057866109000074],
            [71.19821700000011, 40.05259511300004],
            [71.19294600500007, 40.050269674],
            [71.18188724800007, 40.04339670800003],
            [71.17692631000011, 40.042001445000054],
          ],
          [
            [70.49872481300014, 39.881907858000076],
            [70.48373864800004, 39.882217916000045],
            [70.48260176600007, 39.866766663000064],
            [70.49014652500011, 39.85017852900005],
            [70.50347904500012, 39.835502421000044],
            [70.53737878400005, 39.817312317000116],
            [70.54730065900003, 39.80764882500007],
            [70.5758777260001, 39.77008005800009],
            [70.58161381100007, 39.76656606000002],
            [70.63298018400013, 39.798450419000076],
            [70.66160892800008, 39.80981923500006],
            [70.69452681500013, 39.814831848000054],
            [70.70481042500012, 39.82206654900001],
            [70.70641239500009, 39.839998271000084],
            [70.69891931200004, 39.858446757000095],
            [70.68662032100008, 39.860875550000046],
            [70.65499434500009, 39.84976511600003],
            [70.61990604700009, 39.85069529200008],
            [70.49872481300014, 39.881907858000076],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Armenia',
        iso3: 'ARM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [45.0023999440001, 41.290452373000065],
              [45.039400268000065, 41.23117950500007],
              [45.02932336400005, 41.21009552000005],
              [45.034852742000055, 41.19769317600007],
              [45.0520093180001, 41.19211212100005],
              [45.117328329000145, 41.19206044600004],
              [45.13443322800009, 41.187874654],
              [45.18678145300004, 41.15686879500008],
              [45.199752238000144, 41.14265777600012],
              [45.2010441490001, 41.126741435],
              [45.16673099800005, 41.10777618500005],
              [45.067822307000085, 41.110928447],
              [45.057176961000096, 41.07878570600006],
              [45.0700443930001, 41.06209421900003],
              [45.09169681800006, 41.051035461000126],
              [45.111023804000126, 41.04953684500002],
              [45.11712162300006, 41.06142242500006],
              [45.12001550300005, 41.07961252900007],
              [45.136551962000055, 41.07289459300007],
              [45.16921146700014, 41.047159730000075],
              [45.18967533400007, 41.03754791300007],
              [45.20517826400004, 41.02488718700003],
              [45.22161136900007, 41.01444854800009],
              [45.268740275000084, 41.010262757000035],
              [45.3125618900001, 40.99662017900003],
              [45.33535119600009, 40.99382965200009],
              [45.38194794700013, 41.011448110000075],
              [45.39152347800007, 41.015068665000044],
              [45.419118693000144, 41.01734242800008],
              [45.42521651200008, 40.99367462200003],
              [45.41643151900013, 40.961325175000056],
              [45.42873050900005, 40.9511965950001],
              [45.44284278300012, 40.94838019700002],
              [45.452811727000096, 40.9463906860001],
              [45.47927006000009, 40.92990590400011],
              [45.52205814600012, 40.88815134700006],
              [45.5378711350001, 40.875904033000054],
              [45.55823164800006, 40.87094309600009],
              [45.581796102000055, 40.869651184000034],
              [45.59915938300014, 40.862674866000035],
              [45.600968058000035, 40.84055735300005],
              [45.582209513000066, 40.799371237000045],
              [45.555854533000115, 40.77658193000006],
              [45.47833511100009, 40.74818305300009],
              [45.43792891500004, 40.73338043300002],
              [45.39880985500014, 40.708937480000074],
              [45.37364343200011, 40.675296122000034],
              [45.37358518600007, 40.651298383000054],
              [45.373540080000055, 40.63271474200006],
              [45.387802775000125, 40.60951202400007],
              [45.407026408000036, 40.59509430000004],
              [45.427231893000055, 40.58295033800003],
              [45.44464685000008, 40.566362203000025],
              [45.44857426000004, 40.55649200400005],
              [45.45084802200006, 40.534374492000055],
              [45.455447225000114, 40.52362579400004],
              [45.46469730600012, 40.51571930000007],
              [45.48541955600007, 40.505280660000054],
              [45.49384281400006, 40.493653463000086],
              [45.52619226100012, 40.441046855000096],
              [45.585413452000125, 40.39872385700009],
              [45.818370809000044, 40.297799785000066],
              [45.81915164500009, 40.297141013],
              [45.86167565900007, 40.26126454700004],
              [45.88172611500005, 40.26043772400003],
              [45.88850421200004, 40.26195695300005],
              [45.902706746000035, 40.2651402800001],
              [45.924617553000076, 40.26617380800006],
              [45.93919030700005, 40.26028269500007],
              [45.953556356000036, 40.249585673000055],
              [45.97923954300012, 40.22359242800009],
              [45.98109989500006, 40.21780466700004],
              [45.98177168800004, 40.21191355500012],
              [45.98109989500006, 40.2059707640001],
              [45.96296146600008, 40.14168528300006],
              [45.9507658280001, 40.11719065400008],
              [45.93169722500011, 40.09755360900006],
              [45.9095280360001, 40.082670797],
              [45.9058073330001, 40.07507436100006],
              [45.89402510600007, 40.02908233700005],
              [45.88720381700011, 40.01843699200005],
              [45.873767944000065, 40.009755351000095],
              [45.803901408000115, 40.00448435500006],
              [45.639570353000124, 40.02541331000005],
              [45.57626672400005, 39.993890686],
              [45.577583441000115, 39.98398292600011],
              [45.57941898600012, 39.97017120400004],
              [45.61114831500004, 39.959164123000065],
              [45.71543135600007, 39.9508958950001],
              [45.74276818900006, 39.94050893100008],
              [45.764420613000084, 39.92206044600006],
              [45.80917744400011, 39.851261672000035],
              [45.81682051600012, 39.839171448000045],
              [45.86188236500004, 39.80454823800004],
              [45.88318764400009, 39.79614787100009],
              [45.916142619000084, 39.78315419500002],
              [45.97923954300012, 39.76847808800004],
              [46.006576375000066, 39.74791086800006],
              [46.04512699400004, 39.68755279600005],
              [46.07654626400006, 39.66812245700008],
              [46.11447676600005, 39.65964752200007],
              [46.13168501800004, 39.65215443900003],
              [46.146102743000085, 39.63846018500003],
              [46.16956384200006, 39.604095358000066],
              [46.18423995000012, 39.59324330700004],
              [46.20646081500007, 39.58792063500009],
              [46.24118737800012, 39.593501689],
              [46.30950362200008, 39.62052846300004],
              [46.34371342000014, 39.61861643500002],
              [46.35787276200011, 39.6096764120001],
              [46.38143721500012, 39.58502675400008],
              [46.39642338100009, 39.57665517200003],
              [46.416163778000055, 39.57401967400001],
              [46.47931237800009, 39.578670553000066],
              [46.495435425000096, 39.575931702000034],
              [46.5120235600001, 39.56756012000007],
              [46.52427087400014, 39.55464101200003],
              [46.527268107000054, 39.53815623000007],
              [46.51827640800008, 39.52544382700002],
              [46.50370365400005, 39.51846750900002],
              [46.492024780000065, 39.510199280000066],
              [46.4917147220001, 39.493662821000086],
              [46.498587687000054, 39.48312083000012],
              [46.49822595200004, 39.47376739500008],
              [46.49140466300008, 39.46642934200007],
              [46.47931237800009, 39.46188181600003],
              [46.47895196100012, 39.46182942400007],
              [46.40572513800004, 39.45118479400013],
              [46.373995809000064, 39.435991924000106],
              [46.360869995000144, 39.41025706],
              [46.374615927000036, 39.37883778900009],
              [46.40737878500005, 39.35914906800012],
              [46.47931237800009, 39.33424102800005],
              [46.495280395000066, 39.32400909400009],
              [46.502670126000055, 39.30948801700005],
              [46.5079411210001, 39.29357167500011],
              [46.51765629100004, 39.278843893],
              [46.54184086100008, 39.25905181900002],
              [46.58452559400007, 39.235771587],
              [46.59114017700011, 39.23106903100002],
              [46.59785811400013, 39.2250745650001],
              [46.59914138200014, 39.22248710700005],
              [46.602612346000114, 39.215488587],
              [46.59382735200012, 39.212129619000066],
              [46.57279504400009, 39.211509501000094],
              [46.5264412840001, 39.18582631500003],
              [46.51414229300008, 39.18443105100006],
              [46.453370809000035, 39.20840891600007],
              [46.41833418800013, 39.21192291300012],
              [46.395286499000065, 39.195179749000076],
              [46.39626835100006, 39.16443227200001],
              [46.42184818600009, 39.14464019800003],
              [46.45512780700005, 39.12993825300005],
              [46.47931237800009, 39.11477122000012],
              [46.491921428000126, 39.081905009000096],
              [46.49750248200013, 39.053534648],
              [46.49460860200014, 39.02552602200008],
              [46.48148278800011, 38.99377085400006],
              [46.48075931800008, 38.990618591],
              [46.47931237800009, 38.98775055000003],
              [46.47579838000007, 38.97560658800002],
              [46.4740930590001, 38.963230083000056],
              [46.475074911000036, 38.95106028200006],
              [46.47931237800009, 38.93938140900006],
              [46.514038940000034, 38.882175599000036],
              [46.496055542000136, 38.886077169000075],
              [46.39187585500014, 38.92235402400006],
              [46.37823327700005, 38.924705303000096],
              [46.36758793200005, 38.9236200970001],
              [46.34335168500007, 38.91747060200002],
              [46.304542684000126, 38.916256205000096],
              [46.29131351700005, 38.913930766000064],
              [46.27193485500004, 38.90656687400006],
              [46.21994836500005, 38.877162984000066],
              [46.2024817300001, 38.87054840100008],
              [46.135870809000096, 38.863701274],
              [46.07757979300004, 38.95049184200009],
              [46.02548995000012, 39.06376658100008],
              [46.005232788000114, 39.095444234000084],
              [45.97923954300012, 39.12443471300004],
              [45.9581038820001, 39.15151316300002],
              [45.94900883000014, 39.17779063000005],
              [45.95510664900007, 39.203241273000074],
              [45.97923954300012, 39.22794260700009],
              [45.98600915500009, 39.23468638100012],
              [45.988076213000056, 39.24189524400008],
              [45.98580245000011, 39.24944000300012],
              [45.97923954300012, 39.25729482000004],
              [45.95882735200007, 39.27243601500005],
              [45.90178842600011, 39.29412397600005],
              [45.88720381700011, 39.29966949500006],
              [45.86332930600014, 39.31403554300006],
              [45.8443123780001, 39.330055237000025],
              [45.823745158000065, 39.34307769800007],
              [45.76700443600009, 39.354394836000026],
              [45.76437068000013, 39.359142100000085],
              [45.7586328540001, 39.36948435500004],
              [45.764989054000125, 39.38948313400006],
              [45.79863041200008, 39.432426249000045],
              [45.80307458500005, 39.44818756200003],
              [45.79403121000013, 39.49386952800005],
              [45.79403121000013, 39.49397288100006],
              [45.79728682500007, 39.51939768500007],
              [45.79708011900004, 39.53634755500006],
              [45.788088420000065, 39.54895660400008],
              [45.76545414200007, 39.561565654000034],
              [45.73785892700005, 39.569782206000056],
              [45.714656210000044, 39.56947214800006],
              [45.70906573600007, 39.56842210300006],
              [45.58644698100011, 39.54539093100003],
              [45.55967858900004, 39.53681264300009],
              [45.47927006000009, 39.497176819000046],
              [45.46862471500009, 39.493662821000086],
              [45.457462606000036, 39.48927032500008],
              [45.44609379000008, 39.48751332600001],
              [45.43482832800004, 39.48885691400007],
              [45.42407963000011, 39.493714498000074],
              [45.42393727800004, 39.49382694200007],
              [45.39235030100008, 39.51877756800009],
              [45.37488366700012, 39.52585723900002],
              [45.32754805500008, 39.52926788300006],
              [45.31297530100011, 39.53381540900007],
              [45.30289839700009, 39.54508087200004],
              [45.29106449400007, 39.565854798000075],
              [45.26619102100011, 39.59291812800005],
              [45.25995528200008, 39.59970286],
              [45.23318689000013, 39.592726542],
              [45.204764852000096, 39.57231435200005],
              [45.16791955500008, 39.56554473900009],
              [45.14833418800009, 39.57525990900005],
              [45.14440677900012, 39.589832663000024],
              [45.154225301000054, 39.625851136000094],
              [45.15587894700013, 39.64920888300004],
              [45.15153812600005, 39.66770904600007],
              [45.14125451600006, 39.6844005330001],
              [45.07499903900003, 39.749820272000036],
              [45.06751224800013, 39.75721262600008],
              [45.03350915500005, 39.77039011600006],
              [44.99599206500005, 39.76046824200007],
              [44.959095093000144, 39.7385057580001],
              [44.953215052000076, 39.735965352000036],
              [44.927159058000086, 39.72470815100006],
              [44.893052612000076, 39.71840362600004],
              [44.84933435100004, 39.718920390000065],
              [44.80292891400012, 39.71240915900002],
              [44.77455855300013, 39.702797343],
              [44.75910730000004, 39.723106181000034],
              [44.697767374000136, 39.7852729290001],
              [44.69203129100009, 39.79302439400003],
              [44.68717370600007, 39.79638336200013],
              [44.682419474000085, 39.797210185000054],
              [44.671257365000145, 39.795866598000075],
              [44.66619307500008, 39.79638336200013],
              [44.647692911000036, 39.805116679],
              [44.61151940900004, 39.83731109600005],
              [44.59818688900009, 39.83100657200005],
              [44.59446618600009, 39.83679433200011],
              [44.594156128000066, 39.848059794000065],
              [44.59105554200005, 39.85782664000003],
              [44.57596602400014, 39.866353251000035],
              [44.56749108900004, 39.873019512000056],
              [44.563770386000044, 39.881701152000105],
              [44.55911950700005, 39.89689402300003],
              [44.54785404500012, 39.9114667760001],
              [44.52217085800004, 39.93353261300008],
              [44.46434493000004, 39.97228993700013],
              [44.38092555300011, 40.00980379300002],
              [44.32564538600013, 40.03466339200007],
              [44.28905847200008, 40.04339670800003],
              [44.25526208500008, 40.04339670800003],
              [44.19500736500004, 40.03078765900001],
              [44.16637862100009, 40.028048808000065],
              [44.1459147540001, 40.02339792900001],
              [44.135476115000074, 40.022312724000116],
              [44.12700118000009, 40.0244831350001],
              [44.114288778000116, 40.03393992100008],
              [44.10447025600013, 40.03595530200003],
              [44.08312788900014, 40.03161448200005],
              [44.04834965000009, 40.012855937000054],
              [44.032433309000055, 40.00861847],
              [43.91213057400006, 40.024328105000066],
              [43.80278324400007, 40.07073354100008],
              [43.71121260600012, 40.09073232100009],
              [43.66542728700006, 40.11016265900007],
              [43.65250817900005, 40.13899810900001],
              [43.66635746300011, 40.14891998300003],
              [43.71162601700013, 40.15646474200007],
              [43.72139286300006, 40.16938385100006],
              [43.714933309000116, 40.180649313000046],
              [43.68372074400014, 40.21010487900004],
              [43.67307539900014, 40.22772654300003],
              [43.69136885600011, 40.2386302690001],
              [43.690347590000044, 40.24044318800007],
              [43.67596927900013, 40.26596710200003],
              [43.631475871000134, 40.31030548100007],
              [43.6044490970001, 40.329787496000066],
              [43.59421716300011, 40.34544545500002],
              [43.60103845200007, 40.36182688400005],
              [43.609565064000094, 40.372988994000096],
              [43.62446300100004, 40.411137485000026],
              [43.62532637500004, 40.41334828800005],
              [43.62532637500004, 40.42016957600002],
              [43.58486372800007, 40.44657623400009],
              [43.56362471500012, 40.464714661000116],
              [43.55949060100005, 40.477892152],
              [43.593700399000056, 40.50900136300005],
              [43.61530114700014, 40.520421855000066],
              [43.63896895400006, 40.52259226500006],
              [43.63628177900006, 40.529775289],
              [43.63462813300009, 40.532772522000116],
              [43.631475871000134, 40.5368549600001],
              [43.63757369000007, 40.53514963800005],
              [43.64201786300009, 40.534374492000055],
              [43.646462037000106, 40.533030905000075],
              [43.65250817900005, 40.5294135540001],
              [43.65147465000007, 40.55339141900002],
              [43.664807169000085, 40.57406199200004],
              [43.707181844000104, 40.61194081700002],
              [43.699533732000134, 40.634575094000056],
              [43.70563155100007, 40.64077626600006],
              [43.72640547700013, 40.668991598000034],
              [43.729351033000114, 40.677104797000126],
              [43.72413171400012, 40.746351217000054],
              [43.72061771700004, 40.762887676000034],
              [43.711315959000046, 40.78164622100003],
              [43.66976810700004, 40.83213409500006],
              [43.65953617400004, 40.85197784400013],
              [43.654161824000084, 40.874715475000116],
              [43.65193973800007, 40.894765931000066],
              [43.64765059400014, 40.91388621100005],
              [43.63617842600013, 40.93352325500008],
              [43.6048625090001, 40.963340556],
              [43.56543339000007, 40.98814524400005],
              [43.52238692200007, 41.00447499600007],
              [43.47959883700008, 41.00912587500004],
              [43.460478557000044, 41.02287180600008],
              [43.444562216000065, 41.05144887300004],
              [43.43629398600007, 41.08322987900006],
              [43.44042810000013, 41.10658762600012],
              [43.45045332800004, 41.10467559900009],
              [43.46032352700013, 41.10452056900006],
              [43.47014204900012, 41.10617421500011],
              [43.524143921000075, 41.12281402600003],
              [43.566621948000034, 41.12405426100007],
              [43.729712769000116, 41.10669097900005],
              [43.754155721000075, 41.10824127200006],
              [43.773741089000055, 41.11449412100008],
              [43.82035323100007, 41.14549998000008],
              [43.863244670000086, 41.158987528000054],
              [43.955848837000076, 41.160486145000064],
              [43.97775529000012, 41.16453733800007],
              [43.978186390000076, 41.16461706200009],
              [44.00111739100004, 41.16885772700003],
              [44.041321655000104, 41.18255198200005],
              [44.0612687580001, 41.184153951],
              [44.103643432000126, 41.17516225200005],
              [44.124727417000145, 41.17805613200004],
              [44.144364461000066, 41.18606597900002],
              [44.16007409700006, 41.197899882000044],
              [44.16519006400006, 41.20766672800009],
              [44.16586185700004, 41.21614166300007],
              [44.168445679000115, 41.2235830690001],
              [44.18033125800014, 41.22993927000003],
              [44.19097660400007, 41.230042623000074],
              [44.218106731000034, 41.221567688000064],
              [44.26647587100007, 41.19619456000005],
              [44.28497603400007, 41.190871887000114],
              [44.308488810000085, 41.19381744400003],
              [44.31773889100009, 41.1985716760001],
              [44.32492191600005, 41.20482452400002],
              [44.333086792000074, 41.21035390200011],
              [44.3449206950001, 41.213247782000096],
              [44.35727136300005, 41.212162578000104],
              [44.41060144100004, 41.18771962500007],
              [44.432460571000036, 41.18167348300001],
              [44.45493982000005, 41.180484924],
              [44.47922774300008, 41.18580759700005],
              [44.499381551000056, 41.20280914400006],
              [44.5058927820001, 41.20658152300008],
              [44.51664148000003, 41.20683990500005],
              [44.52191247600007, 41.19929514600001],
              [44.52552982600014, 41.18906321200002],
              [44.531007528000146, 41.18146677700007],
              [44.55152307100013, 41.177022604000044],
              [44.566250855000135, 41.18694447900005],
              [44.578446493000115, 41.20280914400006],
              [44.59136560100012, 41.21577992800009],
              [44.6128629960001, 41.22311798100007],
              [44.633120158000054, 41.22105092400001],
              [44.67492639100004, 41.2084935510001],
              [44.82153243000005, 41.2062197880001],
              [44.847784057000126, 41.208906962000114],
              [44.85770593300009, 41.21934560200005],
              [44.85382048600013, 41.22351397000007],
              [44.84706058800003, 41.23076609400006],
              [44.80954349800004, 41.24440867200006],
              [44.80127526900009, 41.2585163370001],
              [44.820705607000036, 41.27334747400003],
              [44.917237183000054, 41.261771952000075],
              [44.95516768400006, 41.26270212800004],
              [44.9673633220001, 41.26900665300006],
              [44.98999759900005, 41.28445790700006],
              [45.0023999440001, 41.290452373000065],
            ],
            [
              [44.97945560700009, 41.08204132100006],
              [44.963952678000055, 41.07377309200011],
              [44.960697062000065, 41.05992380800005],
              [44.966949910000096, 41.044834290000054],
              [44.97945560700009, 41.03263865200002],
              [45.01573246300006, 41.02323354100007],
              [45.02999515800013, 41.04628123000005],
              [45.01888472500008, 41.074909973],
              [44.97945560700009, 41.08204132100006],
            ],
            [
              [45.20993249500003, 40.96799143500006],
              [45.22047448700005, 40.97905019100007],
              [45.19184574400009, 40.99780873600007],
              [45.18771162900009, 40.99837717700002],
              [45.18378422000012, 40.99791208900008],
              [45.180270223000036, 40.99641347300009],
              [45.17716963700008, 40.99382965200009],
              [45.18678145300004, 40.97083363900005],
              [45.20993249500003, 40.96799143500006],
            ],
          ],
          [
            [
              [45.51368656500006, 40.60196726500003],
              [45.47927006000009, 40.609822083000054],
              [45.47327559400014, 40.61943390000006],
              [45.47131188900005, 40.6298725380001],
              [45.47337894700007, 40.64031117800003],
              [45.47927006000009, 40.65023305300012],
              [45.491775757000084, 40.657106018],
              [45.50557336400004, 40.66020660400004],
              [45.520197795000115, 40.660413310000095],
              [45.53466719600004, 40.658914693000085],
              [45.56071211800008, 40.64764923100002],
              [45.54717289200005, 40.621552633000036],
              [45.51368656500006, 40.60196726500003],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Iraq',
        iso3: 'IRQ',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [44.76613529500014, 37.14192006500009],
            [44.75254439300005, 37.11313629200008],
            [44.75269942200009, 37.10331777],
            [44.76065759300013, 37.085644429000084],
            [44.76654870600004, 37.07895233200007],
            [44.77362837700008, 37.07634267200008],
            [44.781121460000065, 37.07448232000006],
            [44.78835616100008, 37.07024485300012],
            [44.79223189300012, 37.06373362200004],
            [44.79729618300007, 37.04848907500009],
            [44.801895386000126, 37.04352813800007],
            [44.81119714400006, 37.0419261680001],
            [44.830937540000036, 37.04683542900007],
            [44.840601034000144, 37.04719716500004],
            [44.847577352000144, 37.044044901000106],
            [44.858946167000056, 37.03412302700009],
            [44.88075362200004, 37.024924622000086],
            [44.88736820500014, 37.01593292300005],
            [44.88571455900012, 37.00508087200011],
            [44.87475915600004, 36.99402211500011],
            [44.869178101000045, 36.967357076000056],
            [44.87486250800009, 36.94965789800004],
            [44.88406091300004, 36.93335398400002],
            [44.88881514500014, 36.91092641200002],
            [44.883440796000116, 36.886845195],
            [44.869643189000044, 36.86896514900003],
            [44.834141480000085, 36.83403188100003],
            [44.8233927820001, 36.809330547000016],
            [44.83124760000004, 36.791915589],
            [44.85119470200004, 36.781218567000096],
            [44.87723962400008, 36.7764643360001],
            [44.908245483000144, 36.77785959900008],
            [44.92271488400007, 36.77589589500003],
            [44.93522058100007, 36.767110901000066],
            [44.94441898600007, 36.758274231000044],
            [44.95475427200006, 36.75233144200003],
            [44.96643314600004, 36.749334209000025],
            [44.97945560700009, 36.74902415000004],
            [44.99619877100014, 36.74168609600004],
            [45.01097823100014, 36.725563050000076],
            [45.035266154000055, 36.68959625300009],
            [45.045911499000056, 36.668047181000034],
            [45.04430953000008, 36.649340312000064],
            [45.02487919100014, 36.61316680900002],
            [45.01418216900004, 36.57900868700004],
            [45.013251994000086, 36.5579247030001],
            [45.010254761000056, 36.556012676000094],
            [44.997852417000104, 36.55208526600002],
            [44.99340824400008, 36.54965647400006],
            [44.991392863000044, 36.53374013300005],
            [45.005913940000084, 36.518702291000054],
            [45.00952466600006, 36.516195910000064],
            [45.02534427900014, 36.50521474200009],
            [45.03816003400004, 36.49400095600005],
            [45.0390902100001, 36.47984161400011],
            [45.04549808700011, 36.47162506100007],
            [45.05407637500008, 36.464958801000066],
            [45.06208622300005, 36.45534698500005],
            [45.066892131000145, 36.442376201000016],
            [45.068545776000065, 36.43250600200004],
            [45.07226647900012, 36.423410950000076],
            [45.08373864800012, 36.41281728100007],
            [45.1108170980001, 36.402533671000086],
            [45.1399626060001, 36.40439402300011],
            [45.1959798580001, 36.42242909700009],
            [45.221301310000115, 36.42093048200009],
            [45.23887129800005, 36.40299875900003],
            [45.24961999600009, 36.377935690000115],
            [45.25447758000013, 36.35478464800012],
            [45.2570097250001, 36.311686503000104],
            [45.263934367000104, 36.294271546000076],
            [45.28269291200007, 36.27489288400001],
            [45.258508342000084, 36.26223215800006],
            [45.26419274900013, 36.25019154900009],
            [45.282796265000115, 36.23840932200001],
            [45.29736901800004, 36.226730449000044],
            [45.30201989800014, 36.2075584920001],
            [45.29953942900005, 36.16141143800009],
            [45.30460371900011, 36.140379130000056],
            [45.33560957900005, 36.10771962500009],
            [45.348321980000094, 36.08751414000001],
            [45.344187866000084, 36.06746368500005],
            [45.33188887600005, 36.05159902000004],
            [45.319589885000084, 36.031031800000065],
            [45.31369877100008, 36.010412903000045],
            [45.32021000200007, 35.994289856000066],
            [45.32021000200007, 35.994134827000025],
            [45.32031335400012, 35.99403147400001],
            [45.320520060000035, 35.9939797980001],
            [45.33809004700004, 35.979303691],
            [45.359587443000066, 35.97687489900004],
            [45.38180830900012, 35.982972718],
            [45.401548707000075, 35.9939797980001],
            [45.40185876500004, 35.99403147400001],
            [45.401962118000085, 35.99408315100003],
            [45.402168823000125, 35.99423818000007],
            [45.41994551600004, 35.99826894200005],
            [45.453121785000064, 36.011653137000096],
            [45.47927006000009, 36.01201487200008],
            [45.50142367600006, 36.005434777000104],
            [45.53998986800008, 35.9939797980001],
            [45.576938517000144, 35.96622955300005],
            [45.58985762600014, 35.95961497100005],
            [45.617039429000044, 35.95542918000011],
            [45.64685673000014, 35.933208313000065],
            [45.693210490000126, 35.879878235],
            [45.718738648000055, 35.82830515600007],
            [45.73103763900008, 35.815127666000095],
            [45.74902103700009, 35.81099355100007],
            [45.786744832000124, 35.82024363300009],
            [45.797906942000054, 35.81838328100007],
            [45.8141850180001, 35.809339905000016],
            [45.83475223800008, 35.81052846300004],
            [45.85407922300004, 35.81833160400005],
            [45.87831547000013, 35.83522979800004],
            [45.888495728000066, 35.83486806300006],
            [45.898779338000054, 35.832180888000025],
            [45.9091146240001, 35.83130238900007],
            [45.941257365000126, 35.84034576500004],
            [46.00492273000003, 35.8379686490001],
            [46.02497318600007, 35.84329132100005],
            [46.04430017100009, 35.85228302000009],
            [46.060423218000096, 35.85724395800004],
            [46.07695967600006, 35.85698557500005],
            [46.10775883000014, 35.84742543600008],
            [46.11504520700004, 35.846443584],
            [46.11985111500013, 35.84287790900002],
            [46.124812052000095, 35.822465719],
            [46.129101196000136, 35.81554107700002],
            [46.135199015000126, 35.8100116990001],
            [46.143363891000035, 35.8045339960001],
            [46.163517700000114, 35.79750600200002],
            [46.18496341900004, 35.798177796000076],
            [46.22744144700005, 35.80572255500003],
            [46.246406698000044, 35.81140696300007],
            [46.26351159600006, 35.82112213200013],
            [46.28139164200013, 35.82830515600007],
            [46.30299239100009, 35.826548157],
            [46.31963220200004, 35.81688466400006],
            [46.327073608000035, 35.80350046900013],
            [46.3250582280001, 35.78784250900007],
            [46.31337935400012, 35.77151275700005],
            [46.29751469000013, 35.75988555900007],
            [46.26712894700006, 35.744124248],
            [46.25348636900014, 35.727742819000056],
            [46.237880086000075, 35.71554718100005],
            [46.21700280800013, 35.71358347600001],
            [46.17772871900007, 35.7153921510001],
            [46.12760258000014, 35.69368805],
            [46.107035360000054, 35.68981231700003],
            [46.03706547100006, 35.69156931600013],
            [46.016498251000144, 35.68572987900005],
            [46.00378584800012, 35.67425771100001],
            [45.99587935400007, 35.658393046000114],
            [45.99236535600011, 35.64087473600004],
            [45.99231368000011, 35.62438995400008],
            [46.002028850000045, 35.58594268800003],
            [45.99923832200005, 35.57214508100007],
            [45.96869755000006, 35.57974151600003],
            [45.96389164200008, 35.57974151600003],
            [45.959344116000125, 35.57870798800006],
            [45.96802575700008, 35.55850250300007],
            [45.97923954300012, 35.539485575000086],
            [45.9831152750001, 35.53529978400006],
            [45.984562215000096, 35.53106231700009],
            [45.98321862800009, 35.52697987900011],
            [45.97923954300012, 35.523000794000026],
            [45.971333048000076, 35.51803985600007],
            [45.966062053000144, 35.511476949],
            [45.96358158400005, 35.5034154260001],
            [45.963994995000064, 35.49416534400008],
            [45.97701745600011, 35.46532989500004],
            [46.0409928790001, 35.3815623980001],
            [46.096286662000125, 35.34115142900002],
            [46.12016117300004, 35.31851715100005],
            [46.12739587400006, 35.289061584000066],
            [46.125285441000074, 35.2849893410001],
            [46.12005782000011, 35.27490224300003],
            [46.10765547700004, 35.26275828100002],
            [46.0987671310001, 35.25004587900007],
            [46.10145430500006, 35.234284566000085],
            [46.11540694200005, 35.226326396],
            [46.154164266000066, 35.226636455000104],
            [46.169253784000034, 35.216249492000074],
            [46.16548140500004, 35.18994618700013],
            [46.143828979000034, 35.15961212200007],
            [46.13039310700009, 35.13139679000001],
            [46.15106368000011, 35.11160471600003],
            [46.143105510000055, 35.099512431000065],
            [46.132356812000126, 35.094758199000054],
            [46.11995446800006, 35.092742818000104],
            [46.09452966300006, 35.08581817600013],
            [46.0766496170001, 35.089693909000076],
            [46.066572714000074, 35.08881541000004],
            [46.03975264500008, 35.07553456600003],
            [46.025076538000064, 35.064269104000076],
            [46.00921187300008, 35.06091013600006],
            [45.97923954300012, 35.07155548200005],
            [45.966372111000055, 35.07072865800005],
            [45.95603682400014, 35.074242656000095],
            [45.93495284000011, 35.08545644200005],
            [45.9201733810001, 35.08964223300008],
            [45.91319706200011, 35.087316793000056],
            [45.89939945400005, 35.06860992500005],
            [45.89836592700004, 35.06390736900009],
            [45.9011564540001, 35.05160837800004],
            [45.899089396000136, 35.046905823000074],
            [45.89309493000013, 35.04437367800007],
            [45.87903894100003, 35.04323679600007],
            [45.872476034000044, 35.04142812100007],
            [45.86188236500004, 35.032798157000045],
            [45.85702478000013, 35.0212743120001],
            [45.856818074000046, 35.0080451460001],
            [45.85971195500014, 34.9944025680001],
            [45.85971195500014, 34.99424753800007],
            [45.868962036000084, 34.968357646000115],
            [45.86632653800007, 34.949547425],
            [45.85785160300014, 34.93130564400006],
            [45.85020349200005, 34.90681101500009],
            [45.83501062000005, 34.89017120400008],
            [45.808035523000115, 34.89787099200008],
            [45.79620242700008, 34.90306366600004],
            [45.77826989800013, 34.9108934530001],
            [45.75511885600014, 34.909963277000045],
            [45.74850427200005, 34.89073964500004],
            [45.750467977000085, 34.86536651700003],
            [45.74540368700008, 34.84097524000002],
            [45.71770511900007, 34.825110576],
            [45.689231405000044, 34.82263010700002],
            [45.676570679000065, 34.81828928700004],
            [45.66675215600014, 34.806920472000044],
            [45.66359989400007, 34.7949315390001],
            [45.66592533400012, 34.77472605400003],
            [45.66282474800005, 34.7632538860001],
            [45.635022827000114, 34.73695058300005],
            [45.627374715000144, 34.720827535000055],
            [45.64225752800007, 34.706874899000084],
            [45.65052575700014, 34.702999166000026],
            [45.65951745600006, 34.69721140600005],
            [45.66685551000006, 34.68997670500009],
            [45.6703695060001, 34.68181182900007],
            [45.67347009300005, 34.67116648400007],
            [45.67837935400007, 34.66512034100002],
            [45.68349532000008, 34.66021108000008],
            [45.687629435000076, 34.65323476200008],
            [45.69078169800014, 34.63432118800007],
            [45.69124678600008, 34.61551096600006],
            [45.694450724000035, 34.59856109700006],
            [45.70561283400008, 34.58559031200012],
            [45.70855839100011, 34.579079081000046],
            [45.70830000800004, 34.56838206000005],
            [45.70561283400008, 34.55773671500005],
            [45.70153039600007, 34.5512771610001],
            [45.69558760500007, 34.55024363200003],
            [45.67357344600009, 34.556651510000066],
            [45.60484379100012, 34.56114736000008],
            [45.5739412850001, 34.56729685500004],
            [45.539628133000065, 34.58223134400002],
            [45.50066410300008, 34.59168813100008],
            [45.49652998800008, 34.56424794500002],
            [45.50484989500012, 34.52378529900004],
            [45.50345463100007, 34.49417470300007],
            [45.498700399000086, 34.48624237000003],
            [45.49301599100011, 34.47900767000006],
            [45.48650476100005, 34.47272898400006],
            [45.47927006000009, 34.46725128200008],
            [45.42676680500011, 34.45751027500002],
            [45.417051635000064, 34.44435862300004],
            [45.44795414200007, 34.362089743000084],
            [45.46076989800008, 34.34046315500002],
            [45.47927006000009, 34.32914601700004],
            [45.49921716400013, 34.34240102200003],
            [45.521541382000066, 34.34250437400006],
            [45.542211955000084, 34.331600647000116],
            [45.55755985500008, 34.31196360300008],
            [45.56303755700014, 34.28927764900003],
            [45.56102217600011, 34.26460215300001],
            [45.54768965700009, 34.216491395000034],
            [45.54272871900014, 34.20747385700007],
            [45.528672730000096, 34.18856028300006],
            [45.52665734900006, 34.179310202000025],
            [45.53146325700004, 34.16791554800004],
            [45.53880131000005, 34.159233907000086],
            [45.544537395000134, 34.150629781000035],
            [45.544537395000134, 34.139493510000094],
            [45.53435713700014, 34.128202210000055],
            [45.49394616700005, 34.10068450900006],
            [45.47927006000009, 34.08763621100012],
            [45.45487878400007, 34.069859518],
            [45.44361332200009, 34.04766449000006],
            [45.435190064000096, 34.02213633200002],
            [45.41994551600004, 33.99436025000007],
            [45.41994551600004, 33.994256898000046],
            [45.419738811000116, 33.994256898000046],
            [45.41147058100006, 33.9871513880001],
            [45.401755412000114, 33.98162200900002],
            [45.38036136900013, 33.97356048600004],
            [45.401031942000145, 33.94945343000008],
            [45.423717895000095, 33.93878224700008],
            [45.44971114100014, 33.9373869840001],
            [45.47927006000009, 33.94118520100004],
            [45.48175052900007, 33.94087514300004],
            [45.48392093900014, 33.940048320000116],
            [45.485781290000034, 33.938653056000035],
            [45.574768107000125, 33.80393259700004],
            [45.58820397900007, 33.79150441500006],
            [45.60360355600005, 33.78072987900005],
            [45.616729370000144, 33.76868927000005],
            [45.62391239400006, 33.75207529700005],
            [45.628201539000145, 33.73184397400006],
            [45.63512618000004, 33.71417063400004],
            [45.64515140800006, 33.69791839600005],
            [45.65879398600009, 33.68169199700013],
            [45.6739868570001, 33.669031271000094],
            [45.7211157640001, 33.640764262000104],
            [45.724629623000055, 33.633036413000085],
            [45.72798872900006, 33.625648905],
            [45.72773034700009, 33.59009552000005],
            [45.73455163600005, 33.58311920200005],
            [45.752018270000065, 33.58676239000003],
            [45.768451376000144, 33.59590911900001],
            [45.79754520600005, 33.61931854200007],
            [45.81578698700014, 33.625803935000036],
            [45.86436283300009, 33.626424053],
            [45.8859635820001, 33.63091990200003],
            [45.88203617400012, 33.60019826300008],
            [45.89970951400011, 33.58516042100008],
            [45.92089685000008, 33.57299062100007],
            [45.927924845000064, 33.55087310800009],
            [45.915625855000144, 33.53580942800009],
            [45.86818689000006, 33.511573182000106],
            [45.85258060800004, 33.49436493000003],
            [45.8697371830001, 33.482117615],
            [45.89939945400005, 33.47630401700012],
            [45.92968184500006, 33.479507955000074],
            [45.94818200700007, 33.4942615770001],
            [45.953142944000035, 33.49658701600002],
            [45.95815555900009, 33.49738800100006],
            [45.963271525000096, 33.49656117700003],
            [45.96448744700007, 33.49599121400003],
            [45.96823246200006, 33.494235738],
            [45.97138472500012, 33.49276296000009],
            [45.97443363500014, 33.490799255000056],
            [46.00802331500006, 33.45565928100011],
            [46.01939213100013, 33.43839935300012],
            [46.027453654000055, 33.41951161700008],
            [46.030502564000074, 33.39920278000007],
            [46.031071005000115, 33.38251129100003],
            [46.03623864800011, 33.367938538000075],
            [46.06972497600009, 33.340860088000014],
            [46.109515829000145, 33.29370534300001],
            [46.1413485110001, 33.27210459400003],
            [46.15530114800009, 33.26021901500009],
            [46.164189494000084, 33.24334665900004],
            [46.16439619900012, 33.23306304900002],
            [46.15835005700012, 33.2138652550001],
            [46.15767826400008, 33.20567454100008],
            [46.16212243600012, 33.19637278300006],
            [46.17369795700006, 33.190223287],
            [46.17431807400004, 33.18117991100003],
            [46.16718672600007, 33.16833831800004],
            [46.15344079600004, 33.15425649100011],
            [46.12646569900005, 33.13177724200001],
            [46.10538171400009, 33.11839304700008],
            [46.089155314000095, 33.11568003400005],
            [46.07241215000005, 33.11676523900003],
            [46.05039799000008, 33.115111593000066],
            [46.03029585700011, 33.10568064400012],
            [46.02931400500006, 33.09351084400002],
            [46.04326664300004, 33.08345977800009],
            [46.08719161000005, 33.07922231000002],
            [46.10600183100007, 33.072504375],
            [46.120419556000115, 33.061678162000064],
            [46.12615563900005, 33.047983908000035],
            [46.11948938000006, 33.03100819900003],
            [46.10465824400012, 33.01806325300002],
            [46.08801843300006, 33.006720276000024],
            [46.075719442000036, 32.9944988000001],
            [46.075719442000036, 32.99434377000007],
            [46.09701013200004, 32.95432037400009],
            [46.15555952900013, 32.94835174600006],
            [46.27343347200008, 32.95948801700008],
            [46.37962854000011, 32.93176361100005],
            [46.47931237800009, 32.89179189000002],
            [46.50732100500011, 32.86802073200003],
            [46.60061305900007, 32.8225414760001],
            [46.60442102100012, 32.82068512000008],
            [46.65036136900005, 32.78936920200006],
            [46.71588708500008, 32.756012065],
            [46.75733158400004, 32.716195374000094],
            [47.05839847900006, 32.494477641000046],
            [47.0586051840001, 32.494477641000046],
            [47.05865686000004, 32.49440012700002],
            [47.09059289600009, 32.47455637600005],
            [47.12103031500004, 32.46104298900006],
            [47.15255293800004, 32.45517771400007],
            [47.18779626500009, 32.458381653000046],
            [47.205469605000076, 32.464040222000065],
            [47.251254924000136, 32.4854601040001],
            [47.265310913000064, 32.484684957000084],
            [47.32194828300004, 32.468226013000034],
            [47.343342326000084, 32.45869171200003],
            [47.35610640500005, 32.44618601500012],
            [47.36732019100009, 32.43076060000003],
            [47.384115031000135, 32.4125704960001],
            [47.41083174700009, 32.395284730000085],
            [47.416412801000035, 32.38797251400011],
            [47.41796309400013, 32.376422831000085],
            [47.41434574400006, 32.369859925000085],
            [47.408764689000066, 32.36433054600009],
            [47.39997969600006, 32.345778708000054],
            [47.395948934000046, 32.34198048900002],
            [47.39579390500012, 32.33701955200006],
            [47.402460165000036, 32.3235061650001],
            [47.4070593670001, 32.317770081000035],
            [47.43687666800008, 32.2936888630001],
            [47.441579224000066, 32.288185323],
            [47.44535160300006, 32.28263010700009],
            [47.46302494300011, 32.26183034300003],
            [47.46943282000012, 32.25612009700008],
            [47.47914799000006, 32.25206349800008],
            [47.48452233900014, 32.23935109500003],
            [47.50400435400013, 32.2267420460001],
            [47.50922367300012, 32.213797099000075],
            [47.507673380000085, 32.199844463000105],
            [47.50235070800005, 32.190129294000045],
            [47.496407918000045, 32.18134429900006],
            [47.492480510000064, 32.17049224900002],
            [47.49041345200004, 32.15653961200003],
            [47.491343628000095, 32.14863311800009],
            [47.498164917000054, 32.14413726800005],
            [47.51382287600006, 32.14031321200012],
            [47.52669030800007, 32.13338857000004],
            [47.53475183100005, 32.123156637000065],
            [47.5436401770001, 32.11457834900004],
            [47.558729696000114, 32.11297638000009],
            [47.578056682000124, 32.10615509000003],
            [47.580232356000124, 32.103495196000054],
            [47.59500655200014, 32.085432842],
            [47.617795858000136, 32.041869609000074],
            [47.63314375800013, 32.02693512000012],
            [47.668077026000105, 32.01241404300008],
            [47.67794722500008, 31.994689026000046],
            [47.67794722500008, 31.99453399700012],
            [47.68264978000008, 31.97691233400012],
            [47.71840987200005, 31.92234202100009],
            [47.725231161000124, 31.914332174000023],
            [47.743317912000066, 31.904255269000075],
            [47.750966024000036, 31.898209127000044],
            [47.75654707900014, 31.88916575100008],
            [47.761714722000136, 31.871647441000036],
            [47.765280395000104, 31.86410268200008],
            [47.78135176600006, 31.848858134000025],
            [47.8207808840001, 31.823588359000055],
            [47.83447513800013, 31.805708313000096],
            [47.837265666000064, 31.784469300000026],
            [47.83132287600006, 31.761835022000085],
            [47.678929077000134, 31.407851461000106],
            [47.67644317400004, 31.236517019000033],
            [47.67293461100013, 30.994698385000063],
            [48.001545044000125, 30.994646708000047],
            [48.01224206600011, 30.989065653000026],
            [48.01544600400007, 30.976249899000052],
            [48.01203535900004, 30.494522196000062],
            [48.013585653000064, 30.463878072000014],
            [48.11941898600014, 30.45080393500008],
            [48.13058109600007, 30.447496643000065],
            [48.14091638200006, 30.44191558900006],
            [48.15765954600005, 30.42630930600002],
            [48.170475301000124, 30.406672261000082],
            [48.179467, 30.384864807000056],
            [48.187683553000056, 30.34083648700009],
            [48.19207605000008, 30.3312763470001],
            [48.200085897000065, 30.323938293000097],
            [48.211196330000064, 30.31964915000013],
            [48.222978556000044, 30.31809885700001],
            [48.23507084100004, 30.31851226800002],
            [48.27165775600008, 30.323834941000072],
            [48.28426680500013, 30.323318177000132],
            [48.296359090000124, 30.31975250200007],
            [48.30571252500005, 30.312827861000088],
            [48.32602136200006, 30.283475647],
            [48.35816410300009, 30.251797995000103],
            [48.39702478100014, 30.220998841000025],
            [48.40358768800013, 30.212523906000044],
            [48.408703654000135, 30.20234364900007],
            [48.41061568200007, 30.19154327500003],
            [48.40803186000005, 30.18089792900004],
            [48.40074548400008, 30.172267965000074],
            [48.39113366700008, 30.16477488200006],
            [48.383278849000135, 30.15645497700008],
            [48.38110844000005, 30.145344544000082],
            [48.38307214300005, 30.13841990100009],
            [48.39557784100009, 30.115217184000088],
            [48.415524943000094, 30.09563181600008],
            [48.42120935100013, 30.085348206000063],
            [48.423948202000076, 30.0836428840001],
            [48.442189982000116, 30.03393015600001],
            [48.44425704000008, 30.020907695000076],
            [48.45314538600013, 30.001425679000064],
            [48.45779626500007, 29.994862772000076],
            [48.46430749600006, 29.98912668900003],
            [48.478156779000074, 29.97961822500004],
            [48.49303959100007, 29.971763408000115],
            [48.523993775000065, 29.964115295000042],
            [48.53101647200003, 29.961330471000053],
            [48.53077233200008, 29.960760809000078],
            [48.53077233200008, 29.956203518000052],
            [48.55494225400008, 29.95648834800005],
            [48.559255405000044, 29.946600653000075],
            [48.546885613000086, 29.934719143000052],
            [48.520518425000034, 29.928900458000044],
            [48.41187584700003, 29.938421942000048],
            [48.33545983200008, 29.961411851000037],
            [48.299571160000085, 29.984523830000057],
            [48.264659050000034, 29.993963934000078],
            [48.20923912900008, 30.02448151200008],
            [48.16578209700003, 30.037543036000045],
            [48.119151238000086, 30.044989325000074],
            [48.07634524800005, 30.04564036700009],
            [48.03825931100005, 30.036851304000038],
            [47.96900475400008, 30.004055080000057],
            [47.961924675000034, 30.03034088700008],
            [47.95850670700008, 30.060614325000074],
            [47.95167076900009, 30.088324286000045],
            [47.93482506600009, 30.107082424000055],
            [47.94711347700007, 30.07453034100007],
            [47.94849694100009, 30.062323309000078],
            [47.946055535000085, 30.049383856000077],
            [47.941742384000065, 30.037258205000057],
            [47.94092858200008, 30.026516018000052],
            [47.94849694100009, 30.017645575000074],
            [47.948008660000085, 29.994045315000037],
            [47.7314323330001, 30.088552145000037],
            [47.67417484500004, 30.09821563700008],
            [47.41579268400005, 30.09821563700008],
            [47.35822513800008, 30.09211781800012],
            [47.19709802300014, 30.034240214000093],
            [47.1446981200001, 30.003337707000085],
            [47.110488322000094, 29.960911357000057],
            [47.02542891400009, 29.77213735000008],
            [46.988842, 29.712657776000114],
            [46.98367435700004, 29.698291728000115],
            [46.97985030100011, 29.668061015],
            [46.977369832000136, 29.65798411100006],
            [46.95783614100014, 29.620441183000068],
            [46.88311202000011, 29.512514954000025],
            [46.85344974800006, 29.444560446000068],
            [46.83856693500013, 29.42497507800006],
            [46.7744881590001, 29.363531799000057],
            [46.71185632300006, 29.27139272],
            [46.56146814800013, 29.12416650900009],
            [46.53243575000005, 29.095744527000093],
            [46.48861413600014, 29.08757965200006],
            [46.44489587400005, 29.079414775000046],
            [46.427322320000144, 29.076143103000064],
            [46.40117761300007, 29.07127573700005],
            [46.35745935000011, 29.063136699000026],
            [46.25214278200008, 29.07145660400009],
            [46.175920044000065, 29.077476909000026],
            [46.09969730700004, 29.083574728000073],
            [46.02362959800007, 29.089595032000105],
            [45.94735518400006, 29.09564117400005],
            [45.84493249500014, 29.103754374000076],
            [45.74240645300006, 29.111867575000062],
            [45.63988041200014, 29.120032450000096],
            [45.537406047000104, 29.128119812000094],
            [45.43493168100014, 29.13620717400009],
            [45.332405640000104, 29.144372050000086],
            [45.22998295100007, 29.152459412],
            [45.1274569090001, 29.160624288000022],
            [45.04782352700005, 29.166902975000127],
            [44.96829349800004, 29.17325917600006],
            [44.88871179200004, 29.17951202400006],
            [44.80892338100006, 29.185894064000095],
            [44.7174560950001, 29.193102926000037],
            [44.710893188000114, 29.195273336000028],
            [44.70464034100013, 29.19749542200013],
            [44.69823246200008, 29.199717510000042],
            [44.69182458500012, 29.201836243000017],
            [44.61487837800013, 29.25607065900006],
            [44.51974206500006, 29.323327535000132],
            [44.424295695000126, 29.390532736000083],
            [44.32895267700013, 29.45778961300006],
            [44.23366133600007, 29.52499481200003],
            [44.11914636200004, 29.60581675200008],
            [44.00463138800012, 29.68661285400013],
            [43.89006473800009, 29.76738311800007],
            [43.82401296300009, 29.8139798590001],
            [43.77549808800006, 29.848205058000033],
            [43.66098311400003, 29.929026998],
            [43.54636478700007, 30.00979726200005],
            [43.431746460000056, 30.0905675260001],
            [43.31723148600014, 30.17133778900005],
            [43.229071493000106, 30.23350453700003],
            [43.14096317500014, 30.295671285000125],
            [43.052906535000034, 30.35778635700008],
            [42.96474654100007, 30.42000478200002],
            [42.85901656000004, 30.494522196000062],
            [42.858913208000104, 30.49457387300005],
            [42.85880985500006, 30.494625549000077],
            [42.858706502000075, 30.494677226000093],
            [42.78341257900007, 30.55104503200006],
            [42.76393192600011, 30.56562896700008],
            [42.669157349000045, 30.63668406200007],
            [42.574486125000135, 30.70763580300006],
            [42.47971154800007, 30.778639222000052],
            [42.395168905000105, 30.841581116000057],
            [42.31072961400008, 30.904523010000062],
            [42.22629032400005, 30.967464905000057],
            [42.14164432800004, 31.03040680000005],
            [42.07539514200005, 31.079861145000095],
            [41.98620162000009, 31.12528472900003],
            [41.89855839000006, 31.16998484300008],
            [41.81070845500011, 31.21468495800012],
            [41.723065226000074, 31.259385071000068],
            [41.635421997000094, 31.304033508000103],
            [41.547572062000086, 31.348733623000058],
            [41.45982548000006, 31.39343373600009],
            [41.37218225100008, 31.43813385000003],
            [41.28453902200005, 31.48283396400008],
            [41.196689087000095, 31.527585755000032],
            [41.10904585800006, 31.572285868000094],
            [41.02129927500005, 31.61693430600012],
            [40.93355269400007, 31.661634420000055],
            [40.84590946500009, 31.706334534000106],
            [40.758162882000136, 31.75108632400007],
            [40.67031294700007, 31.795683086000068],
            [40.58266971900014, 31.84043487600003],
            [40.4798336180001, 31.89283477800008],
            [40.424126424000065, 31.920533345000095],
            [40.37027958200014, 31.93846506800007],
            [40.02931848200012, 31.99437896700006],
            [40.029111776000036, 31.994430644000076],
            [40.02900842300011, 31.994482320000103],
            [40.02880171700008, 31.994482320000103],
            [39.94859989400004, 32.00610951700007],
            [39.7509892170001, 32.034893291000074],
            [39.553275187000054, 32.06372874000003],
            [39.355561157000125, 32.09256418900004],
            [39.157743774000096, 32.12134796200006],
            [39.15495324700004, 32.120572815000045],
            [39.152162719000046, 32.119745992000034],
            [39.149268840000104, 32.11891916900002],
            [39.14637496000012, 32.118144023000085],
            [39.14616825300004, 32.125843811],
            [39.26647098800004, 32.21286692300005],
            [39.29199914500009, 32.244518738000025],
            [39.27112186700009, 32.31195648200007],
            [39.25634240700009, 32.342678121000105],
            [39.23577518700006, 32.35285837800008],
            [39.04632938700013, 32.30849416100001],
            [39.03620080600007, 32.31335174500005],
            [39.02875939900014, 32.328337911000105],
            [38.97997684800009, 32.472101746000064],
            [38.97863326000004, 32.47372955400003],
            [38.978219849000084, 32.47496978800005],
            [38.97863326000004, 32.47569325800005],
            [38.97997684800009, 32.476054993000034],
            [39.05718143800004, 32.49659637400002],
            [38.99000207500012, 32.705575867],
            [38.942769816000066, 32.85233693400009],
            [38.89719120300009, 32.99434377000007],
            [38.862567993000084, 33.10071970600008],
            [38.821020142000066, 33.22903228800003],
            [38.77451135200005, 33.3716850790001],
            [38.8850989180001, 33.427108053000055],
            [38.99568648300004, 33.482479350000105],
            [39.1062740480001, 33.53792816100007],
            [39.21686161300005, 33.59332529700002],
            [39.32744917800011, 33.64872243200007],
            [39.438036743000055, 33.70409373000011],
            [39.548624308000115, 33.759490865000075],
            [39.65921187400005, 33.8148104860001],
            [39.76969608500008, 33.87023346000005],
            [39.88038700300012, 33.9256047570001],
            [39.99087121600007, 33.98097605400004],
            [40.101458781000076, 34.03637318900009],
            [40.17311082500004, 34.07228291700004],
            [40.212046346000136, 34.09179616300004],
            [40.32263391100008, 34.14716746],
            [40.43322147600014, 34.202538757000056],
            [40.54380904100009, 34.25798757000011],
            [40.690466756000035, 34.33149729400007],
            [40.93603316300005, 34.3860676070001],
            [40.9652820230001, 34.401854757000095],
            [40.988019653000094, 34.42851979600003],
            [41.02398645100004, 34.49417470300007],
            [41.02398645100004, 34.49432973300013],
            [41.19565555800011, 34.76847320600011],
            [41.204233846000136, 34.79312286400001],
            [41.20650760900014, 34.81932281500012],
            [41.198032674000046, 34.994040833],
            [41.19232585700013, 35.15890443700006],
            [41.1915214440001, 35.18214304600009],
            [41.201339966000035, 35.243017884000054],
            [41.24309452300008, 35.366524557],
            [41.25187951700008, 35.46408966100002],
            [41.261077921000094, 35.49416534400008],
            [41.26118127400008, 35.49416534400008],
            [41.26128462700012, 35.49416534400008],
            [41.26128462700012, 35.494320374000026],
            [41.30845783400008, 35.55224762500008],
            [41.34220992100012, 35.593694153000044],
            [41.35802290900011, 35.62392486600005],
            [41.363500610000074, 35.65524078400004],
            [41.359263143000135, 35.79275177100003],
            [41.35450891100004, 35.82556630400002],
            [41.34365686100011, 35.85765737000004],
            [41.26634891800012, 35.99423818000007],
            [41.26634891800012, 35.99434153200009],
            [41.26624556500008, 35.994289856000066],
            [41.240614054000105, 36.043020732000016],
            [41.236686645000134, 36.06033233700002],
            [41.23658329300014, 36.07702382400005],
            [41.268829387000096, 36.32796458000003],
            [41.27699426200007, 36.35478464800012],
            [41.36525760900008, 36.493897603000036],
            [41.36525760900008, 36.49400095600005],
            [41.365360962000125, 36.49405263300007],
            [41.365360962000125, 36.49415598600008],
            [41.38541141700006, 36.51637685100003],
            [41.41486698400007, 36.52738393200012],
            [41.47977258300011, 36.5361172490001],
            [41.789934530000096, 36.58929229700003],
            [41.81732303900009, 36.599730937000075],
            [41.84378137300007, 36.6178693640001],
            [41.97855350700013, 36.73362457300006],
            [42.17843794800012, 36.90531952000002],
            [42.28158410700007, 36.99397043900008],
            [42.28189416500004, 36.99402211500011],
            [42.28189416500004, 36.994125468000036],
            [42.34586958800014, 37.0429080200001],
            [42.376805724000064, 37.06200061900006],
            [42.377185506000046, 37.06223500600005],
            [42.376875448000135, 37.07675608300009],
            [42.3711910400001, 37.08794403100002],
            [42.36364628100006, 37.098150127000096],
            [42.35723840300011, 37.1099840290001],
            [42.401886841000135, 37.114143982000044],
            [42.45914432800009, 37.129311015000056],
            [42.54523726400009, 37.140886536000025],
            [42.56125695800006, 37.14662262000006],
            [42.56466760200004, 37.15204864500005],
            [42.57696659400011, 37.17923044900003],
            [42.70233361900006, 37.32534556100002],
            [42.70615767400011, 37.333226217000075],
            [42.707397909000065, 37.34015085900005],
            [42.70946496500011, 37.34717885400006],
            [42.715666138000074, 37.35529205300007],
            [42.722177368000075, 37.358909404000045],
            [42.77158003700009, 37.374903260000096],
            [42.78046838400007, 37.37549753800006],
            [42.79245731600008, 37.374334819000055],
            [42.801138956000045, 37.3690896610001],
            [42.80547977700007, 37.35185557000004],
            [42.81405806500004, 37.34681711900005],
            [42.89674035700011, 37.324906311000106],
            [42.93704797300006, 37.32015208000011],
            [42.97962935400011, 37.3318309540001],
            [43.00515751200004, 37.34725636800009],
            [43.043501424000056, 37.360252991000024],
            [43.08370568900011, 37.36883127900005],
            [43.114814901000045, 37.37113088000008],
            [43.1319714760001, 37.36725514700002],
            [43.26338464300011, 37.31069529300005],
            [43.27030928500011, 37.308679911000084],
            [43.27862919100005, 37.30774973600005],
            [43.28751753800009, 37.309144999000026],
            [43.296870972000136, 37.316741435],
            [43.305655965000085, 37.319971212000056],
            [43.32415612800014, 37.32221913700009],
            [43.33614506100008, 37.320229594000054],
            [43.36250521500011, 37.30390815200006],
            [43.376039266000134, 37.295528260000125],
            [43.416760295000074, 37.27917266800007],
            [43.463269084000046, 37.248683574],
            [43.47959883700008, 37.24336090100006],
            [43.492414591000056, 37.24475616500003],
            [43.517115926000145, 37.25230092400007],
            [43.52951827000004, 37.2539028930001],
            [43.542437378000045, 37.25230092400007],
            [43.55060225500006, 37.248735250000024],
            [43.56889571200014, 37.2377023320001],
            [43.59421716300011, 37.22945994100009],
            [43.618298381000045, 37.226979472],
            [43.720824423000124, 37.23261220300013],
            [43.746921021000105, 37.230648499],
            [43.77064050300004, 37.225842590000084],
            [43.78056237800013, 37.22036488900001],
            [43.8020597740001, 37.20357004800003],
            [43.809397827000055, 37.19969431500009],
            [43.82200687700009, 37.202381491000025],
            [43.839990276000094, 37.21710927300002],
            [43.89363041200005, 37.22491241400003],
            [43.924171183000055, 37.25307607000009],
            [43.95378177900011, 37.28746673600004],
            [43.99036869300005, 37.31250396800003],
            [44.03558557100013, 37.31824005200009],
            [44.06902473600013, 37.31372658800005],
            [44.088037150000105, 37.31116038000006],
            [44.18446537300008, 37.27917266800007],
            [44.20689294500005, 37.26751963300002],
            [44.2231710210001, 37.25405792300005],
            [44.23500492300013, 37.23677215600007],
            [44.243531535000045, 37.21382782000002],
            [44.248544148000065, 37.191917013000065],
            [44.24962935400009, 37.17943715500009],
            [44.24833744300014, 37.169670309000125],
            [44.24012089000007, 37.15796559700006],
            [44.230199016000086, 37.154322408000056],
            [44.21877852400007, 37.15261708600009],
            [44.20596276900011, 37.14662262000006],
            [44.18921960400007, 37.12920766200004],
            [44.18064131700004, 37.108924662000035],
            [44.180021200000056, 37.087608134000035],
            [44.18746260600011, 37.0669375610001],
            [44.22777022300005, 36.994125468000036],
            [44.23428145400004, 36.98366099100009],
            [44.243273153000075, 36.977769878000075],
            [44.28482100400004, 36.96916575200005],
            [44.2972233480001, 36.969940898000075],
            [44.30662845900008, 36.97722727500003],
            [44.315878540000085, 36.99397043900008],
            [44.31598189300013, 36.99397043900008],
            [44.316136922000055, 36.99402211500011],
            [44.316136922000055, 36.994125468000036],
            [44.33163985200008, 37.015467835000024],
            [44.33515384900011, 37.031151632],
            [44.34311202000009, 37.04244293300006],
            [44.428068074000066, 37.06476715100003],
            [44.45442305500012, 37.07634267200008],
            [44.47922774300008, 37.09200063100003],
            [44.503412313000126, 37.11662445100002],
            [44.539379110000084, 37.143677063000055],
            [44.578239787000086, 37.16641469400004],
            [44.61027917500007, 37.17835194900009],
            [44.628934367000056, 37.17902374300006],
            [44.73378584800014, 37.16724151700008],
            [44.75383630300007, 37.15915415500008],
            [44.76613529500014, 37.14192006500009],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Iran',
        iso3: 'IRN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [44.80699282900008, 39.639901712000025],
              [44.80964685100014, 39.636961569],
              [44.8239530730001, 39.630540026000105],
              [44.827836955000066, 39.628796692],
              [44.84923099700012, 39.62559275300002],
              [44.87227868700006, 39.62507598900008],
              [44.86928145300004, 39.62052846300004],
              [44.86535404500006, 39.61758290600004],
              [44.88643802900003, 39.60595570900007],
              [44.89842696100004, 39.58435496000003],
              [44.92839929200011, 39.488236796000095],
              [44.940698283000074, 39.468082988000035],
              [44.96162723800006, 39.45376861600003],
              [44.953307333000055, 39.44162465500004],
              [44.95702803600011, 39.434493307000096],
              [44.98250451700011, 39.420178935000095],
              [44.98772383600004, 39.419352112000084],
              [44.99857588700007, 39.41961049500004],
              [45.00637902800008, 39.41795684800009],
              [45.00994470200004, 39.41402944000005],
              [45.01211511300005, 39.40948191300002],
              [45.01562910900009, 39.40596791600005],
              [45.05169925900009, 39.38684763600004],
              [45.057176961000096, 39.381731670000065],
              [45.060484253000084, 39.374600322000035],
              [45.06864912900011, 39.36421335900009],
              [45.078726033000066, 39.35475657200003],
              [45.08797611500006, 39.35072581000004],
              [45.09603763800004, 39.341113994000025],
              [45.11434974800005, 39.30934967600005],
              [45.12037723800006, 39.29889434800005],
              [45.128903849000096, 39.28928253200006],
              [45.1358284910001, 39.2784821580001],
              [45.146267131000116, 39.228666077000085],
              [45.15272668500006, 39.21352488300006],
              [45.178926636000085, 39.21982940700006],
              [45.283106323000084, 39.19306101500008],
              [45.285690144000114, 39.194921367000106],
              [45.29261478700005, 39.198616231000116],
              [45.301709839000125, 39.20138092100005],
              [45.3111149500001, 39.20052826000004],
              [45.31390547700005, 39.19424957300002],
              [45.311321656000075, 39.18484446200007],
              [45.3111149500001, 39.17629201300004],
              [45.32093347200009, 39.17259714800004],
              [45.334886108000035, 39.170426738000046],
              [45.3482186280001, 39.163915507000084],
              [45.353903035000144, 39.15319264700007],
              [45.345273071000065, 39.13843902600006],
              [45.351939331000096, 39.12831044500011],
              [45.36062097200005, 39.12322031600003],
              [45.36992272900005, 39.11895701100006],
              [45.379327840000144, 39.11115387000005],
              [45.38346195500014, 39.103247376000084],
              [45.391316772000096, 39.081749980000055],
              [45.39638106300009, 39.07332672200006],
              [45.405837850000125, 39.067874858],
              [45.42971236100004, 39.05947743700001],
              [45.434518270000126, 39.052785340000085],
              [45.43229618400011, 39.04247589200007],
              [45.42821374500011, 39.0341043100001],
              [45.42526818900012, 39.025629375],
              [45.42707686400013, 39.01488067700008],
              [45.43860070800014, 39.00423533100009],
              [45.45983972200008, 38.99312489800006],
              [45.48257735200008, 38.9843915820001],
              [45.494529008000086, 38.98191651900002],
              [45.51027592000008, 38.97865549700005],
              [45.530843140000115, 38.969276225],
              [45.53556486900004, 38.96845289800008],
              [45.54314213100014, 38.967131653000095],
              [45.57084069800004, 38.966382345000014],
              [45.627788127000144, 38.95550445600004],
              [45.71687829600006, 38.954780986000046],
              [45.76807409200012, 38.93912990300005],
              [45.791085653000096, 38.93209503200008],
              [46.00182214300008, 38.89747182200007],
              [46.06796797700014, 38.87411407500004],
              [46.12605228600012, 38.862667745000024],
              [46.135870809000096, 38.863701274],
              [46.2024817300001, 38.87054840100008],
              [46.21994836500005, 38.877162984000066],
              [46.27193485500004, 38.90656687400006],
              [46.29131351700005, 38.913930766000064],
              [46.304542684000126, 38.916256205000096],
              [46.34335168500007, 38.91747060200002],
              [46.36758793200005, 38.9236200970001],
              [46.37823327700005, 38.924705303000096],
              [46.39187585500014, 38.92235402400006],
              [46.496055542000136, 38.886077169000075],
              [46.514038940000034, 38.882175599000036],
              [46.53207401600014, 38.88300242100006],
              [46.55372644000005, 38.8898237100001],
              [46.56984948700011, 38.89773020400007],
              [46.58535241700014, 38.90770375600006],
              [46.599201701000084, 38.91969268800004],
              [46.610673869000095, 38.93400706000001],
              [46.63883752400005, 38.97948232000006],
              [46.65217004400006, 38.99294403100002],
              [46.670411825000144, 39.00490712500009],
              [46.72839278200007, 39.02795481400004],
              [46.74482588800004, 39.04025380400007],
              [46.76162072800008, 39.07058787100003],
              [46.77376469000012, 39.08536733000004],
              [46.78151615400009, 39.090379944000105],
              [46.798052613000095, 39.097382101],
              [46.80601078300009, 39.102394715000074],
              [46.81169519000014, 39.108518372000034],
              [46.837378378000096, 39.143244934000066],
              [46.85096927900008, 39.15549224900009],
              [46.86616215000004, 39.16536244800007],
              [46.86639147700009, 39.165444753000045],
              [46.88300866700007, 39.17140859000001],
              [46.89871830200008, 39.17174448700011],
              [46.926623576000054, 39.16205515600008],
              [46.941609741000036, 39.158902894000036],
              [46.95375370300013, 39.16065989200008],
              [47.01362785800012, 39.186956287],
              [47.02046797700012, 39.18996042900007],
              [47.030906616000095, 39.19959808400007],
              [47.03607425900009, 39.2070136520001],
              [47.052920776000065, 39.244944153000105],
              [47.08909427900011, 39.28985097200008],
              [47.09250492400008, 39.2998245240001],
              [47.10222009300014, 39.30840281200004],
              [47.150072469000065, 39.331140442000034],
              [47.24970463000011, 39.3612678030001],
              [47.261319552000145, 39.36638355600006],
              [47.29135583500005, 39.37961293500008],
              [47.32441724900008, 39.40587667600006],
              [47.32453210400007, 39.40596791600005],
              [47.37424483300009, 39.45557729100004],
              [47.40690433800006, 39.47681630400008],
              [47.448762247000104, 39.49469635000007],
              [47.51873213700014, 39.513196514000086],
              [47.54115970900011, 39.515160217000115],
              [47.55407881700012, 39.52198150700006],
              [47.606995484000095, 39.56358103500007],
              [47.62498028300013, 39.571410740000076],
              [47.74528161600006, 39.62378407800013],
              [47.78821212300005, 39.65765063500005],
              [47.80377933800008, 39.66993113200006],
              [47.82310632300005, 39.68031809500009],
              [47.84687748200008, 39.685279032000054],
              [47.92294519100005, 39.684142151000046],
              [47.935244182000076, 39.686519267000065],
              [47.945682820000115, 39.693960674],
              [47.957258341000056, 39.70734486900004],
              [47.9577081540001, 39.707256220000076],
              [47.97141768400013, 39.704554342000066],
              [47.99074467000008, 39.69427073200008],
              [48.05203291900011, 39.65008738300007],
              [48.220084676000056, 39.49402455700006],
              [48.2886076260001, 39.445035299000054],
              [48.31671960400013, 39.41516632100006],
              [48.33894047100006, 39.3789411420001],
              [48.328405484000086, 39.37632977800003],
              [48.30245690900006, 39.36989776600005],
              [48.249850301000095, 39.342354228000076],
              [48.18721846500006, 39.33258738200003],
              [48.153525432000094, 39.31904815700004],
              [48.124586629000135, 39.29760243800011],
              [48.106189820000054, 39.26918040000008],
              [48.10432946800012, 39.23484141100006],
              [48.11776534000006, 39.208047180000065],
              [48.14215661600008, 39.18120127400009],
              [48.19910404500007, 39.1382323210001],
              [48.2562581790001, 39.119783834000074],
              [48.27129602100007, 39.10831166600006],
              [48.30147505700012, 39.05803049700002],
              [48.30679773000014, 39.045395610000085],
              [48.3062809650001, 39.031468811000096],
              [48.30159039500006, 39.01794599900005],
              [48.301423380000074, 39.017464498],
              [48.29367191600005, 39.00459706700009],
              [48.28462854000014, 38.99400339800012],
              [48.284473510000055, 38.99400339800012],
              [48.28437015800006, 38.99379669200006],
              [48.24318404200005, 38.973875428000056],
              [48.05854414900011, 38.94837310800001],
              [48.05513350400008, 38.94191355400007],
              [48.05534021000011, 38.93436879500011],
              [48.05244633000012, 38.92790924100005],
              [48.000046428000076, 38.902587789000066],
              [47.99074467000008, 38.8912189740001],
              [47.99312178600013, 38.85008453400012],
              [48.012965535000035, 38.82155914300007],
              [48.07797448700006, 38.780941467000034],
              [48.21036950700005, 38.72975596100012],
              [48.222978556000044, 38.72146189400006],
              [48.22563499700004, 38.713193254000075],
              [48.230316609000056, 38.69862091100005],
              [48.226182495000046, 38.67908721900004],
              [48.22804284700004, 38.662189026000064],
              [48.27651534000012, 38.6317774460001],
              [48.29222497600006, 38.61356150300004],
              [48.31031172700011, 38.600151470000085],
              [48.34105920400003, 38.599583029000044],
              [48.391753784000116, 38.61810903000007],
              [48.415266561000124, 38.61810903000007],
              [48.426738729000135, 38.596456604000096],
              [48.433715047000135, 38.5699724330001],
              [48.44663415500014, 38.55640737000003],
              [48.462653849000105, 38.544935201],
              [48.47908695500007, 38.52475555500011],
              [48.49593347200005, 38.510311991],
              [48.5108162840001, 38.49377553400011],
              [48.53564125500009, 38.46915404600013],
              [48.54864343200006, 38.45625844400011],
              [48.57592858900006, 38.42036916100007],
              [48.60786462400006, 38.39597788500002],
              [48.61296215100003, 38.39564644300005],
              [48.65912764500007, 38.392644755000035],
              [48.68320886200013, 38.398019104000085],
              [48.710287313000094, 38.40711415600005],
              [48.73560876500005, 38.41956817600003],
              [48.75534916200013, 38.435226136],
              [48.77772505700011, 38.4448121140001],
              [48.8097127690001, 38.44463124600004],
              [48.87427819100009, 38.43406810100004],
              [48.87720787900008, 38.34617747600004],
              [48.865896030000044, 38.31688060100004],
              [48.87289472700007, 38.29555898600006],
              [48.87484785200007, 38.24274323100008],
              [48.89372806100005, 38.20579661700009],
              [48.90772545700008, 38.08348216400009],
              [48.94906660200007, 37.966864325000074],
              [48.94117272200003, 37.94773997600004],
              [48.940196160000085, 37.924994208000044],
              [48.94450931100005, 37.90338776200008],
              [48.952159050000034, 37.888006903000075],
              [48.98747806100005, 37.84247467700004],
              [48.98780358200008, 37.832098700000074],
              [48.984711134000065, 37.82318756700005],
              [48.983164910000085, 37.81598541900007],
              [48.99366295700008, 37.77676015800006],
              [49.01449629000007, 37.739162502000056],
              [49.065196160000085, 37.67885976800005],
              [49.13249759200005, 37.62335846600007],
              [49.20557701900009, 37.581691799000055],
              [49.36687259200005, 37.514960028000075],
              [49.441742384000065, 37.49485911700009],
              [49.826182488000086, 37.453558661000045],
              [49.86744225400008, 37.45856354400007],
              [49.90154056100005, 37.46971263200004],
              [49.93376712300005, 37.47443268400008],
              [49.969493035000085, 37.45970286700009],
              [49.959971550000034, 37.45848216400009],
              [49.94890384200005, 37.460923570000034],
              [49.94312584700003, 37.46161530200004],
              [49.93531334700003, 37.453558661000045],
              [50.01872806100005, 37.427720445000034],
              [50.148773634000065, 37.40387604400007],
              [50.195648634000065, 37.38934967700004],
              [50.227305535000085, 37.36542389500005],
              [50.223317905000044, 37.329331773000035],
              [50.23210696700005, 37.31541575700004],
              [50.245127800000034, 37.279282945000034],
              [50.254242384000065, 37.264837958000044],
              [50.26872806100005, 37.24689362200007],
              [50.29224694100009, 37.19281647300005],
              [50.322276238000086, 37.15326569200005],
              [50.35718834700003, 37.12653229400007],
              [50.42945397200003, 37.08295319200005],
              [50.478851759000065, 37.03497955900008],
              [50.49398847700007, 37.02773672100005],
              [50.51343834700003, 37.02326080900008],
              [50.624034050000034, 36.96328359600005],
              [50.64478600400008, 36.959418036000045],
              [50.65870201900003, 36.954331773000035],
              [50.688243035000085, 36.92869700700004],
              [50.703135613000086, 36.91844310100004],
              [50.86085045700008, 36.84955475500004],
              [51.00473066500007, 36.767645575000074],
              [51.088633660000085, 36.73700592700004],
              [51.367849155000044, 36.692572333000044],
              [51.54607181100005, 36.65094635600008],
              [51.73096764400003, 36.624253648000035],
              [51.90902754000007, 36.58270905200004],
              [52.094086134000065, 36.60252513200004],
              [52.258555535000085, 36.65094635600008],
              [52.43051191500007, 36.68512604400007],
              [52.60865319100009, 36.71238841400009],
              [52.779307488000086, 36.74038320500006],
              [52.95053144600007, 36.781317450000074],
              [53.11573326900003, 36.822251695000034],
              [53.447601759000065, 36.88190338700008],
              [53.49236087300005, 36.887884833000044],
              [53.88591556100005, 36.90582916900007],
              [53.957774285000085, 36.919623114000046],
              [54.006521030000044, 36.95262278900009],
              [54.004242384000065, 36.91461823100008],
              [53.947601759000065, 36.89874909100007],
              [53.87647545700008, 36.89166901200008],
              [53.830739780000044, 36.88027578300006],
              [53.81820722700007, 36.87523021000004],
              [53.80388431100005, 36.877020575000074],
              [53.77711022200003, 36.88373444200005],
              [53.762054884000065, 36.88182200700004],
              [53.734385613000086, 36.87323639500005],
              [53.71900475400008, 36.87067291900007],
              [53.66041100400008, 36.87689850500004],
              [53.60914147200003, 36.87689850500004],
              [53.61695397200003, 36.865668036000045],
              [53.63103274800005, 36.86196523600006],
              [53.66382897200003, 36.86322663000004],
              [53.64389082100007, 36.85781484600005],
              [53.63599694100009, 36.85700104400007],
              [53.660166863000086, 36.83120351800005],
              [53.70101972700007, 36.81659577000005],
              [53.856455925000034, 36.80548737200007],
              [53.872080925000034, 36.79840729400007],
              [53.88917076900003, 36.79360586100006],
              [54.014333530000044, 36.82111237200007],
              [54.02621504000007, 36.82908763200004],
              [54.03305097700007, 36.845770575000074],
              [54.033539259000065, 36.94912344000005],
              [54.028086785000085, 36.96621328300006],
              [54.01335696700005, 36.973089911000045],
              [53.99439537900008, 36.97915273600006],
              [53.99724368600005, 36.99371979400007],
              [54.02003014400003, 37.02773672100005],
              [53.99626712300005, 37.05731842700004],
              [53.98031660200007, 37.09406159100007],
              [53.958018425000034, 37.17853424700007],
              [53.927744988000086, 37.243801174000055],
              [53.92318769600007, 37.25800202000005],
              [53.91374759200005, 37.34275950700004],
              [54.18659387300005, 37.323743591],
              [54.206437622000124, 37.324596253000024],
              [54.22452437300012, 37.3307457480001],
              [54.243024536000064, 37.344956767000056],
              [54.26152469900006, 37.35482696500004],
              [54.28333215400011, 37.35565378900007],
              [54.30637984200007, 37.353224996],
              [54.32849735500008, 37.353276673000025],
              [54.36415409400007, 37.36268178400006],
              [54.53334273300004, 37.440816549000104],
              [54.555977010000106, 37.44360707700007],
              [54.616851847000135, 37.433013407000075],
              [54.638969361000136, 37.43327179000006],
              [54.65395552600012, 37.43890452100008],
              [54.67855350800011, 37.45998850500011],
              [54.69829390500007, 37.46629303000013],
              [54.710799601000076, 37.47569814100008],
              [54.75834191900009, 37.50055450500004],
              [54.783663371000046, 37.51745269800004],
              [54.78831425000004, 37.52463572200007],
              [54.79141483600006, 37.53993194600004],
              [54.80505741300004, 37.56504669200005],
              [54.808158000000105, 37.57928355000003],
              [54.80939823400013, 37.60333892900006],
              [54.808158000000105, 37.61034108500006],
              [54.80361047300005, 37.616929831000064],
              [54.79182824800006, 37.62535308900006],
              [54.78831425000004, 37.63080495200002],
              [54.78728072100006, 37.65186309800005],
              [54.80371382600009, 37.68292063400007],
              [54.808158000000105, 37.70281606100009],
              [54.81363570200011, 37.718629049000086],
              [54.82665816200006, 37.73526886000009],
              [54.85663049300007, 37.76113291500003],
              [55.00680220600009, 37.84309173600009],
              [55.05351770100009, 37.884407043000024],
              [55.0613725180001, 37.89484568300007],
              [55.066643514000134, 37.90843658500005],
              [55.07873579900013, 37.913707581],
              [55.092791789000046, 37.91554209400009],
              [55.10354048700009, 37.91879770900006],
              [55.110775187000115, 37.92647165900006],
              [55.12173059100013, 37.94471344000003],
              [55.13030887800005, 37.952309876000086],
              [55.14963586400006, 37.95747751900008],
              [55.20741011500007, 37.96615916000003],
              [55.21970910600004, 37.969983215000084],
              [55.228804159000106, 37.98579620400007],
              [55.25050826000012, 37.995408020000085],
              [55.29608687400008, 38.007551982000095],
              [55.30745568800006, 38.00879221600003],
              [55.32812626100008, 38.02212473600004],
              [55.3487968340001, 38.03049631800012],
              [55.42310754400012, 38.075894063000064],
              [55.44739546700009, 38.083671367000065],
              [55.51095747900007, 38.085841776000066],
              [55.708671509000055, 38.118656311000066],
              [55.738437134000094, 38.11860463500007],
              [55.800345500000105, 38.10780426000012],
              [55.83941288200003, 38.08992421500007],
              [55.854088989000104, 38.0859968060001],
              [55.90504195200003, 38.085583395000086],
              [55.92188846900012, 38.08144928000006],
              [55.949070272000085, 38.07008046500009],
              [55.963022909000074, 38.0665147910001],
              [55.978422486000056, 38.065894674000035],
              [56.12146285000006, 38.086461894000124],
              [56.16187382000004, 38.08237945600003],
              [56.1667406250001, 38.08079215000005],
              [56.19784061700011, 38.07064890600013],
              [56.214067017000104, 38.06884023100004],
              [56.299746541000104, 38.080234884000035],
              [56.315456177000044, 38.08945912700004],
              [56.32548140400007, 38.105220439000036],
              [56.32899540200003, 38.12377227800006],
              [56.32424117000005, 38.14113555900009],
              [56.29705936700003, 38.16578521700008],
              [56.30336389200005, 38.1794277960001],
              [56.3664091390001, 38.22552317400003],
              [56.40010217300005, 38.244126689000055],
              [56.43648238100013, 38.25508209200005],
              [56.528156372000126, 38.25740753200007],
              [56.545209595000074, 38.254100240000085],
              [56.55916223100007, 38.247382304000055],
              [56.57177128100011, 38.23950164800003],
              [56.585207154000045, 38.234566549000064],
              [56.60133020000012, 38.2368661500001],
              [56.6815320230001, 38.26461639400013],
              [56.72938439900014, 38.271050110000076],
              [56.73899621600003, 38.26960317],
              [56.77816695200005, 38.24448842400007],
              [56.812376750000055, 38.22895965600004],
              [56.82787967900009, 38.22495473300005],
              [56.97836145000008, 38.202733866000116],
              [57.018048950000036, 38.189814759000015],
              [57.038409465000086, 38.18728261300002],
              [57.056496216000085, 38.19524078400009],
              [57.070448852000084, 38.20505930600005],
              [57.102798299000085, 38.22200917600007],
              [57.1146838790001, 38.232111918],
              [57.13483768800006, 38.259732971000105],
              [57.13791423900011, 38.262364232000024],
              [57.14661991300011, 38.26980987600005],
              [57.16398319500007, 38.276476136000056],
              [57.174938599000086, 38.27756134000005],
              [57.185894002000055, 38.276476136000056],
              [57.20728804600009, 38.27074005200011],
              [57.2183468020001, 38.26508148200007],
              [57.221137329000044, 38.2585960900001],
              [57.221550741000044, 38.25115468400007],
              [57.2257882080001, 38.24236969100009],
              [57.24883589700005, 38.211518861000016],
              [57.26692264800005, 38.176895651],
              [57.27860152200003, 38.162943014000106],
              [57.31136438000004, 38.1350119020001],
              [57.3229399010001, 38.10511708600011],
              [57.344333943000095, 38.081061707000075],
              [57.34929488100005, 38.06356923400001],
              [57.34681441200007, 38.046929424],
              [57.32707401500011, 37.994116110000036],
              [57.352395467000065, 37.967528585000096],
              [57.49626265400008, 37.92231170700002],
              [57.51207564300006, 37.924068705000096],
              [57.52768192500014, 37.927841085000026],
              [57.54463179500004, 37.9299856570001],
              [57.56137495900009, 37.92822865900003],
              [57.612327922000134, 37.91660146100007],
              [57.661110474000054, 37.917428284],
              [57.676096639000036, 37.920477193000025],
              [57.69118615700006, 37.92027048800007],
              [57.70462203000011, 37.913707581],
              [57.717127727000104, 37.90507761600004],
              [57.72994348100008, 37.898643900000096],
              [57.734827150000115, 37.89827166900004],
              [57.73841841600006, 37.89799794500003],
              [57.75474816900004, 37.90102101600006],
              [57.76301639900004, 37.899393209],
              [57.77004439300009, 37.8938896690001],
              [57.779139445000055, 37.87877431200009],
              [57.78503055900006, 37.8725731410001],
              [57.80001672300011, 37.86763804200008],
              [57.81644982900008, 37.86864573200005],
              [57.833296346000054, 37.87174631800009],
              [57.84952274600005, 37.87272817000006],
              [57.884145955000065, 37.86533844000006],
              [58.04093225100007, 37.80570383800004],
              [58.1068713790001, 37.793430685000104],
              [58.14056441300005, 37.791131083],
              [58.156687459000125, 37.788185527000095],
              [58.1735339760001, 37.78162262000011],
              [58.18118208800007, 37.77485300700006],
              [58.181285441000114, 37.767928366],
              [58.17911503100004, 37.76077117900003],
              [58.17994185400005, 37.753045553000035],
              [58.19575484200004, 37.72963612900007],
              [58.19926883900007, 37.722194723000044],
              [58.20185266200008, 37.7039529420001],
              [58.20195601400013, 37.69010365800004],
              [58.20681359900004, 37.67873484300004],
              [58.223866822000105, 37.66746938100009],
              [58.24092004400012, 37.662327576000095],
              [58.3188481040001, 37.65305165600007],
              [58.33145715300003, 37.64829742500008],
              [58.357812134000085, 37.6333112600001],
              [58.371764770000084, 37.63036570300001],
              [58.46230188000004, 37.63749705100004],
              [58.47966516100007, 37.644111634000055],
              [58.49310103400012, 37.660673931000034],
              [58.502299439000126, 37.67739125600009],
              [58.51428837100008, 37.691473084],
              [58.52979130000011, 37.70038726800003],
              [58.549324992000095, 37.70157582700004],
              [58.56565474400014, 37.69485789000002],
              [58.6158842370001, 37.65951121100004],
              [58.65908573400014, 37.64540354500009],
              [58.681720011000095, 37.64271637000006],
              [58.70425093600011, 37.64462839700009],
              [58.71293257600007, 37.64881418900002],
              [58.71923710200008, 37.654782817000054],
              [58.72636844900012, 37.65938201900009],
              [58.73773726400009, 37.65940785800008],
              [58.75902795500008, 37.65615224300011],
              [58.76925988800008, 37.65679819800009],
              [58.779801880000036, 37.65964040200005],
              [58.79313440000004, 37.672843730000054],
              [58.79561486800014, 37.68772654200008],
              [58.80109257000004, 37.69465118400008],
              [58.861037231000125, 37.66808949800004],
              [58.93865523300008, 37.653930156000015],
              [58.97813602700012, 37.639512431000085],
              [58.992192017000036, 37.63145090800002],
              [59.00552453600005, 37.628014425000075],
              [59.034566691000066, 37.62452626500003],
              [59.04562544700008, 37.61961700500008],
              [59.078284953000036, 37.59274525900007],
              [59.21171350100008, 37.51631581700012],
              [59.23310754400012, 37.51471384700007],
              [59.28922814900005, 37.535177715000046],
              [59.31227583800012, 37.53034596700003],
              [59.33232629400004, 37.515127259000096],
              [59.35165328000011, 37.493836568000106],
              [59.35630415900005, 37.4806332400001],
              [59.35320357200004, 37.45843821300009],
              [59.359198039000034, 37.44750864700002],
              [59.36198856700008, 37.43921458000007],
              [59.357854451000094, 37.43027455700003],
              [59.35165328000011, 37.42043019700007],
              [59.34834598800012, 37.40929392500003],
              [59.35072310400005, 37.38836497000004],
              [59.37036014900008, 37.31942860900001],
              [59.38203902200007, 37.30568267900007],
              [59.44467085800005, 37.26418650300012],
              [59.463481079000076, 37.24744333900007],
              [59.46937219300008, 37.24069956500004],
              [59.46813195800007, 37.23584198100009],
              [59.46451460800006, 37.23245717400009],
              [59.463067667000075, 37.22971832300006],
              [59.46182743300005, 37.22300038700003],
              [59.458830200000136, 37.214757996000074],
              [59.461724080000124, 37.20760081000013],
              [59.47815718600009, 37.2041384890001],
              [59.484668416000034, 37.19876414000005],
              [59.49272994000006, 37.19359649600004],
              [59.50120487500004, 37.19021169000011],
              [59.50947310400011, 37.189824117000015],
              [59.54120243300008, 37.19984934500003],
              [59.55598189300014, 37.197782288000056],
              [59.57272505700007, 37.18339040200006],
              [59.57985640400011, 37.16780995800012],
              [59.58461063600009, 37.14889638300009],
              [59.591535278000094, 37.132334086000085],
              [59.60497115100014, 37.12388499000009],
              [59.61447961400012, 37.12548695900004],
              [59.62150760900005, 37.131507264000064],
              [59.63318648300009, 37.146260885000075],
              [59.64259159300008, 37.150239970000044],
              [59.653236938000134, 37.149671529],
              [59.797207479000065, 37.112206116000024],
              [59.862836548000075, 37.067816061000045],
              [59.89952681500006, 37.05055613200007],
              [59.981588989000045, 37.038825583000076],
              [60.01920943200008, 37.02580312100004],
              [60.048871704000135, 36.99402211500011],
              [60.08638879400013, 36.93002085400012],
              [60.132587525000076, 36.87340932200003],
              [60.23852421100008, 36.769746399000056],
              [60.25960819500011, 36.74240956700005],
              [60.28865035000007, 36.681069641000065],
              [60.3092175700001, 36.65197581000008],
              [60.34229048700007, 36.637144674000055],
              [60.50124719200005, 36.63947011300006],
              [60.64108361800004, 36.641485495000026],
              [60.8544039300001, 36.64463775700007],
              [60.97294966700014, 36.64634307900003],
              [61.075475708000056, 36.64779001900003],
              [61.12518843600009, 36.640762024000125],
              [61.16580611200004, 36.636317851000015],
              [61.173970988000065, 36.602314759000066],
              [61.182239217000074, 36.586915181000094],
              [61.18595992000007, 36.57766510000009],
              [61.18761356700014, 36.56510772700007],
              [61.186166626000045, 36.55280873600013],
              [61.182239217000074, 36.541646627],
              [61.17686486900004, 36.53203481100009],
              [61.170663697000066, 36.52443837500003],
              [61.16632287600004, 36.51384470700013],
              [61.16797652200012, 36.50180409800008],
              [61.173970988000065, 36.4868179330001],
              [61.15247359200009, 36.406306051000016],
              [61.14668583200012, 36.3572651170001],
              [61.16094852800012, 36.328636373],
              [61.15774458800013, 36.32465728800004],
              [61.15619429600008, 36.32186676100007],
              [61.153507121000075, 36.314942118000104],
              [61.16311893700009, 36.311583151],
              [61.17107710800008, 36.306415508000086],
              [61.17727828000005, 36.30036936500004],
              [61.18141239400006, 36.29447825100003],
              [61.185443156000076, 36.28398793600009],
              [61.18720015400004, 36.27354929600004],
              [61.18761356700014, 36.25034657900004],
              [61.19092085800014, 36.2406314090001],
              [61.20549361100012, 36.22109771700009],
              [61.220479777000094, 36.158930969000025],
              [61.22306359900006, 36.12880361000002],
              [61.22471724400003, 36.123687643000025],
              [61.2227535400001, 36.117538148000065],
              [61.21221154800014, 36.10637603800002],
              [61.20725061100006, 36.09950307200005],
              [61.20415002400006, 36.090563049000124],
              [61.20239302600004, 36.08074452700005],
              [61.20197961500014, 36.07159779900009],
              [61.19815555800011, 36.06079742400006],
              [61.18968062300013, 36.055784811000066],
              [61.18027551300014, 36.052787577000075],
              [61.173970988000065, 36.048033345000064],
              [61.17107710800008, 36.0359410600001],
              [61.174591105000104, 36.015838928000036],
              [61.173970988000065, 36.006485494000074],
              [61.16177535000014, 35.99594350200003],
              [61.14141483500009, 35.98235260000003],
              [61.12983931500014, 35.97051869700003],
              [61.1435852460001, 35.96550608300005],
              [61.16807987400006, 35.96235382100009],
              [61.188337036000064, 35.953568828000115],
              [61.20580367100007, 35.94049469000005],
              [61.221823364000045, 35.92452667300002],
              [61.232158651000134, 35.91067738900004],
              [61.24104699700007, 35.89388254800009],
              [61.24735152200009, 35.876209208],
              [61.25189904800004, 35.840397441000064],
              [61.25551639800011, 35.825359599000066],
              [61.256136515000094, 35.80913320000006],
              [61.249728638000136, 35.786705628000064],
              [61.256136515000094, 35.77936757400006],
              [61.25634322100012, 35.769497375000086],
              [61.249728638000136, 35.74577789300004],
              [61.24900516800005, 35.740196839000035],
              [61.249728638000136, 35.72247182200003],
              [61.246731405000105, 35.71549550400003],
              [61.233088826000085, 35.70459177700006],
              [61.22916141800005, 35.69859731100003],
              [61.23174523900013, 35.671880595000076],
              [61.24538781800004, 35.649297995000026],
              [61.26967574100013, 35.61849884000007],
              [61.27701379400014, 35.60919708200005],
              [61.28755578700003, 35.56826934900003],
              [61.290036255000075, 35.548063863000024],
              [61.2838350830001, 35.527289938000095],
              [61.27050256300009, 35.508428040000055],
              [61.24704146300007, 35.48507029300002],
              [61.23598270700006, 35.46584666000008],
              [61.22730106700004, 35.434479065000076],
              [61.221823364000045, 35.424247132000076],
              [61.20084273300006, 35.40114776600011],
              [61.19505497300008, 35.39008901000001],
              [61.19040409400009, 35.369573466000034],
              [61.19505497300008, 35.31810374000004],
              [61.1870968020001, 35.30037872300004],
              [61.167873169000075, 35.29138702400009],
              [61.14399865700011, 35.2880797320001],
              [61.12270796700011, 35.28766632100009],
              [61.10834191900011, 35.27795115200003],
              [61.102450806000036, 35.256660462000056],
              [61.10162398300008, 35.23531809500007],
              [61.10234745300011, 35.22560292600012],
              [61.1079285080001, 35.22126210500004],
              [61.112786093000125, 35.211650289000104],
              [61.112372681000124, 35.2020384720001],
              [61.10234745300011, 35.19769765300005],
              [61.096352987000046, 35.193201802000104],
              [61.10152063000004, 35.183228252],
              [61.13707401600004, 35.143902487000034],
              [61.1398645430001, 35.13966501900008],
              [61.137900838000064, 35.12829620400008],
              [61.135213664000105, 35.11940785700007],
              [61.13676395600004, 35.11119130500002],
              [61.1473059490001, 35.10209625200007],
              [61.12312137900011, 35.07419097900008],
              [61.11588667800004, 35.059876608000096],
              [61.109892212000034, 35.01853546200006],
              [61.09531945800006, 34.981018372000065],
              [61.092012166000075, 34.961484680000055],
              [61.08891158100005, 34.951924541000054],
              [61.07475223800009, 34.93311431900004],
              [61.071548299000085, 34.92055694600013],
              [61.07258182800007, 34.91032501300005],
              [61.07702600100009, 34.8917214960001],
              [61.07774947200011, 34.88303985600005],
              [61.073408651000136, 34.84769317700004],
              [61.06545048000004, 34.81472361300008],
              [61.034754680000106, 34.806248678000074],
              [61.02907027200007, 34.789712220000084],
              [61.009639933000074, 34.76098012300007],
              [60.97801395700009, 34.740619609000035],
              [60.95992720600009, 34.72320465100002],
              [60.958686971000134, 34.69958852100008],
              [60.961994263000065, 34.67375030600006],
              [60.95796350100005, 34.64941070600007],
              [60.94752486200014, 34.637990214000055],
              [60.93584598800004, 34.63566477500002],
              [60.922823527000105, 34.63654327400006],
              [60.90887089000012, 34.63468292200007],
              [60.89543501800006, 34.62832672200004],
              [60.88892378800011, 34.62166046200012],
              [60.88385949700012, 34.61370229100005],
              [60.83848759000011, 34.57091420500002],
              [60.818953898000075, 34.55990712500004],
              [60.79404585800012, 34.55411936500006],
              [60.739268840000136, 34.5480215460001],
              [60.714360799000076, 34.53742787700013],
              [60.69968469200006, 34.51639556900001],
              [60.71033003800005, 34.515129497000075],
              [60.718908325000086, 34.51115041100009],
              [60.725316203000034, 34.50427744600002],
              [60.73389449000007, 34.48042877200005],
              [60.74278283700011, 34.47345245400005],
              [60.76727746600005, 34.46415069600003],
              [60.77936975100005, 34.45508148200007],
              [60.78908492000005, 34.4434801230001],
              [60.804897908000044, 34.41748687800005],
              [60.879105266000124, 34.33764679000005],
              [60.890474080000104, 34.31891408300005],
              [60.815956665000044, 34.31527089500007],
              [60.714360799000076, 34.310129089000085],
              [60.64366744000006, 34.30664093000003],
              [60.65059208200006, 34.285350241000046],
              [60.634985799000106, 34.271216736],
              [60.58744348200008, 34.25026194300001],
              [60.552406861000065, 34.22005706800009],
              [60.520884237000075, 34.18613149],
              [60.49277225700007, 34.139028422000095],
              [60.48677779100012, 34.09427663200002],
              [60.48846068000012, 34.08092732000004],
              [60.499386841000046, 33.994256898000046],
              [60.52801558500005, 33.841449687000036],
              [60.52584517400004, 33.80214976000006],
              [60.494942668000135, 33.74411712600009],
              [60.48688114500004, 33.711380107000096],
              [60.51178918500011, 33.638387146000056],
              [60.574834432000046, 33.5877959190001],
              [60.65555301900008, 33.55989064500004],
              [60.73389449000007, 33.55485219400005],
              [60.807378377000134, 33.558159486000065],
              [60.84603234800005, 33.5557823700001],
              [60.879622030000064, 33.5487026980001],
              [60.8951249590001, 33.54113210100003],
              [60.911971476000076, 33.52844553600009],
              [60.92085982200007, 33.51410532600009],
              [60.91978829300007, 33.51257051900011],
              [60.91207482900006, 33.50152211600006],
              [60.89729537000005, 33.49702626500006],
              [60.84985640500008, 33.49436493000003],
              [60.832183065000095, 33.484494731000055],
              [60.82928918400006, 33.47012868200004],
              [60.832803182000134, 33.45346303400002],
              [60.83466353400007, 33.436254781000045],
              [60.829082479000135, 33.416281841000014],
              [60.81864384000011, 33.40488718700003],
              [60.785880981000105, 33.387782288000054],
              [60.75704553300005, 33.36633656800005],
              [60.71901167800013, 33.32303171900007],
              [60.67033247900008, 33.26771209800005],
              [60.61596887300004, 33.20619130500002],
              [60.56759973100009, 33.151285096000024],
              [60.56150191200004, 33.137306621],
              [60.56294885300014, 33.05826751800005],
              [60.57752160700011, 32.99434377000007],
              [60.606150350000064, 32.91235911000008],
              [60.640050090000045, 32.815517477000085],
              [60.674880005000034, 32.715601095000025],
              [60.71167362500012, 32.61031036400003],
              [60.75229130100007, 32.49458099400009],
              [60.79631962100012, 32.3559072880001],
              [60.830322713000044, 32.24888539700002],
              [60.828255656000124, 32.167443339],
              [60.814819783000075, 32.08786163300006],
              [60.80882531700013, 32.07117014600003],
              [60.782677043000035, 32.042541402000055],
              [60.774925578000136, 32.02719350200009],
              [60.778336222000064, 32.02104400600011],
              [60.786707804000116, 32.0169098920001],
              [60.792598918000124, 32.01127716100005],
              [60.7840206300001, 31.989263],
              [60.786087688000066, 31.978979390000077],
              [60.79104862500009, 31.969160868000117],
              [60.79497603400006, 31.958463847000118],
              [60.796733032000134, 31.93675974600002],
              [60.789291626000136, 31.874954733000024],
              [60.7914620360001, 31.82653391600006],
              [60.8053113200001, 31.733981426000113],
              [60.792598918000124, 31.660084127000047],
              [60.79497603400006, 31.63667470400007],
              [60.80996219900004, 31.588357239000047],
              [60.821744425000134, 31.494667868000093],
              [60.855024048000075, 31.482730611000065],
              [60.95599979700012, 31.47006988500003],
              [61.12353479000012, 31.449089254000015],
              [61.125148649000096, 31.448887156000083],
              [61.29479048700006, 31.427643535000087],
              [61.490850871000134, 31.403097229000096],
              [61.60625863000013, 31.38874128800005],
              [61.66117639100014, 31.381909892000053],
              [61.6869112550001, 31.373176575000073],
              [61.70654829900013, 31.359844055000067],
              [61.74230839100005, 31.32088002500008],
              [61.74923303200006, 31.30237986300004],
              [61.74230839100005, 31.259436748000084],
              [61.74272180200006, 31.23954132100006],
              [61.75243697100012, 31.21912913000004],
              [61.779205363000074, 31.18109527600008],
              [61.78768029800011, 31.158616029000072],
              [61.789333944000134, 31.129315491000042],
              [61.79181441300011, 31.118928528000097],
              [61.80928104600008, 31.08714752200008],
              [61.82147668400006, 31.054488017],
              [61.826334269000085, 31.034592591],
              [61.82643762200013, 31.014955546000053],
              [61.81930627500009, 30.99392323800005],
              [61.800185995000106, 30.961418762],
              [61.80452681500009, 30.949739888000025],
              [61.80835087000008, 30.881423646000073],
              [61.80235640400008, 30.878529765000096],
              [61.79987593600009, 30.87150177000008],
              [61.7984289960001, 30.85346669500008],
              [61.79977258300005, 30.852381491000088],
              [61.80225305200014, 30.847058818000036],
              [61.785199829000135, 30.831400859000084],
              [61.702620891000095, 30.745514628000038],
              [61.57622033700005, 30.61389475500009],
              [61.461705363000135, 30.494522196000062],
              [61.38036665800013, 30.410289612000057],
              [61.272156210000105, 30.29830678300003],
              [61.21562219300006, 30.23970570900012],
              [61.13304325300004, 30.1542845660001],
              [60.9784273680001, 29.994397685000067],
              [60.97811731000013, 29.994139303000097],
              [60.90215295400009, 29.9168830360001],
              [60.844378703000075, 29.858178610000053],
              [60.92509729000011, 29.77497955400004],
              [60.97801395700009, 29.72061594700007],
              [61.04333296700014, 29.652428895000057],
              [61.11867720500004, 29.573984070000037],
              [61.19691532400009, 29.49228363000013],
              [61.279184205000035, 29.406629944000073],
              [61.29871789600014, 29.392651469000057],
              [61.31980188000006, 29.3853909300001],
              [61.33737186700006, 29.374383850000086],
              [61.34657027200012, 29.349062398000015],
              [61.34470992000013, 29.329528707000108],
              [61.332824341000105, 29.29449208600009],
              [61.332824341000105, 29.274906718000082],
              [61.34233280500007, 29.254520366000023],
              [61.37416548600004, 29.2238504030001],
              [61.386981242000104, 29.206642151000025],
              [61.39008182800006, 29.19542836500007],
              [61.39276900300007, 29.170468648000096],
              [61.39793664600012, 29.1590739950001],
              [61.40858199100006, 29.148557841000056],
              [61.41767704200004, 29.145663961000068],
              [61.42687544800003, 29.144630433000074],
              [61.43772749800013, 29.139617818000104],
              [61.44795943200006, 29.12540680000005],
              [61.45323042800004, 29.108379416000034],
              [61.46087854000007, 29.09388417600009],
              [61.47803511500007, 29.087476298000055],
              [61.48775028500012, 29.080655009000097],
              [61.490644165000106, 29.072025045000046],
              [61.487233521000064, 29.062929993000083],
              [61.47803511500007, 29.05432586700003],
              [61.4708004150001, 29.047866313000085],
              [61.46800988800004, 29.04174265600001],
              [61.470283651000045, 29.035903219000133],
              [61.47803511500007, 29.03065806100001],
              [61.49095422400006, 29.025490418000103],
              [61.50211633300012, 29.01771311500009],
              [61.51090132700011, 29.007377828000088],
              [61.5531726480001, 28.922137553000127],
              [61.558960409000065, 28.902733053000063],
              [61.56133752500011, 28.885938212000084],
              [61.566505168000106, 28.870977886000034],
              [61.59534061700003, 28.842685039000045],
              [61.623969361000036, 28.787649638000076],
              [61.653011516000106, 28.756333720000057],
              [61.75615767400012, 28.673961487],
              [61.79770552600013, 28.626574199000018],
              [61.861164184000074, 28.57476857500005],
              [61.89279016100005, 28.542599997000096],
              [61.91129032400005, 28.533737488],
              [61.97113163200004, 28.518983866000085],
              [62.01882897900009, 28.49469594300008],
              [62.049111369000116, 28.486324361000115],
              [62.11556726100008, 28.481363424000065],
              [62.14750329600014, 28.475265605000104],
              [62.23070235200004, 28.442451071000093],
              [62.36278731300007, 28.41888661700007],
              [62.39053755700007, 28.406122539000123],
              [62.40216475400007, 28.39410776800004],
              [62.41074304200009, 28.380697734000094],
              [62.42097497600008, 28.368553772000027],
              [62.437201375000086, 28.360440572000087],
              [62.45384118600009, 28.355686341000094],
              [62.46427982600005, 28.34982106600002],
              [62.47120446800011, 28.33969248500007],
              [62.477715698000054, 28.322303365000053],
              [62.49228845200014, 28.300702616000066],
              [62.555437052000116, 28.240318706000053],
              [62.57564253800007, 28.229027405000082],
              [62.73930179900003, 28.258327942000065],
              [62.7615226640001, 28.246442362000025],
              [62.76638024900012, 28.21148325700004],
              [62.75170414200011, 28.10872467100002],
              [62.735684448000086, 27.99498484300001],
              [62.754184611000085, 27.925841777000116],
              [62.780281209000066, 27.829723613000013],
              [62.786379029000045, 27.770269878000065],
              [62.79469893400011, 27.6894737760001],
              [62.79971154800006, 27.63927012200007],
              [62.80932336500007, 27.547053528],
              [62.814697713000044, 27.49496368400004],
              [62.808599894000054, 27.453364156000035],
              [62.75604496300008, 27.348099263000037],
              [62.77568200700006, 27.326911927000097],
              [62.78064294400008, 27.31605987600004],
              [62.778782593000074, 27.299833476000046],
              [62.774131714000134, 27.285519104000045],
              [62.768085571000086, 27.274356995000105],
              [62.7582153730001, 27.2676907350001],
              [62.74235070800006, 27.266812236000064],
              [62.78560388200003, 27.23249908500013],
              [62.800641723000126, 27.22516103100004],
              [62.808548218000055, 27.2253677370001],
              [62.82229414900007, 27.23249908500013],
              [62.829322144000116, 27.23363596600005],
              [62.8373836670001, 27.23125885000009],
              [62.86084476800005, 27.219631653000036],
              [62.89241906700005, 27.21348215700006],
              [62.91960087100006, 27.214877421000054],
              [62.97784021000007, 27.22516103100004],
              [63.00378177900012, 27.22877838200013],
              [63.056181682000044, 27.243196106000042],
              [63.08274336800008, 27.244384664000066],
              [63.099434855000084, 27.242834372000047],
              [63.11230228700009, 27.243196106000042],
              [63.166975953000076, 27.258699036000067],
              [63.17710453300003, 27.25844065400007],
              [63.1895585530001, 27.2544615690001],
              [63.21544844600004, 27.23322255500004],
              [63.22681726100012, 27.226969706000133],
              [63.25151859600004, 27.218959860000055],
              [63.26061364700007, 27.213792217000062],
              [63.27125899300006, 27.203405253000128],
              [63.28557336400007, 27.184646708000045],
              [63.31962813300004, 27.117312317000042],
              [63.30241988100005, 27.12335846000009],
              [63.28056075100011, 27.123203430000032],
              [63.260923707000075, 27.11560699500008],
              [63.24996830200013, 27.099535624000012],
              [63.24624759900007, 27.08945872000008],
              [63.23560225500012, 27.075867819000067],
              [63.23136478700013, 27.06584259000006],
              [63.22991784700014, 27.05406036400005],
              [63.23498213700003, 26.941147359000084],
              [63.243973836000066, 26.922440491000074],
              [63.25647953300006, 26.906162415000054],
              [63.264851115000056, 26.890039368000075],
              [63.261647176000054, 26.87174591100002],
              [63.24666101100013, 26.859550273000096],
              [63.20604333500006, 26.85371083600002],
              [63.1895585530001, 26.846011048000022],
              [63.18227217600008, 26.830249735000038],
              [63.17431400600003, 26.685038961000075],
              [63.163772013000084, 26.645093078000045],
              [63.141344441000115, 26.625404359000086],
              [63.13126753800003, 26.625817770000097],
              [63.123464397000134, 26.629435120000082],
              [63.11622969600006, 26.634034322000034],
              [63.10759973200004, 26.637599996000105],
              [63.09803959100003, 26.63837514300009],
              [63.06889408300003, 26.632535706000013],
              [63.02941329000009, 26.633517558000094],
              [62.990449259000115, 26.63889190700006],
              [62.900015503000134, 26.640907287000104],
              [62.82167403100004, 26.642612610000057],
              [62.753564494000045, 26.644162903000066],
              [62.74271244300007, 26.641320699000104],
              [62.7350643310001, 26.632225647000027],
              [62.72472904500012, 26.6151207490001],
              [62.71801110800004, 26.610521545000054],
              [62.71056970200004, 26.60690419500007],
              [62.70193973800008, 26.60401031500008],
              [62.67103723200012, 26.597705791000052],
              [62.66251062000009, 26.598274232],
              [62.65134851100004, 26.603183492000042],
              [62.64059981300005, 26.60514719700008],
              [62.632021525000084, 26.600392965000097],
              [62.62411503100003, 26.59295155900007],
              [62.61579512600008, 26.58711212200008],
              [62.595331259000034, 26.580704244000046],
              [62.42800297100007, 26.564787903000095],
              [62.418494507000105, 26.56230743500005],
              [62.41063968900005, 26.556829732000054],
              [62.40247481300014, 26.543807271],
              [62.39668705300005, 26.539053039000024],
              [62.386351766000075, 26.536624248000052],
              [62.365267782000046, 26.53750274700009],
              [62.35586267100007, 26.536624248000052],
              [62.347594442000116, 26.533316956000064],
              [62.33467533300012, 26.524842021000055],
              [62.32651045800009, 26.52065623000003],
              [62.306976766000105, 26.51367991200003],
              [62.29829512500004, 26.508770650000102],
              [62.29199060100012, 26.501225891000033],
              [62.29013024900013, 26.492440898000055],
              [62.293127482000045, 26.485877991000066],
              [62.29695153800009, 26.480245260000046],
              [62.297881714000084, 26.47404408800007],
              [62.28754642700011, 26.456629131000042],
              [62.25612715600005, 26.428930563],
              [62.24899580900012, 26.41652821900003],
              [62.25447351100013, 26.39358388300009],
              [62.26424035600007, 26.375187073000106],
              [62.26511885600013, 26.360976054000034],
              [62.24341475500012, 26.35064076700003],
              [62.20589766500012, 26.355343323000014],
              [62.16145593300007, 26.36950266500004],
              [62.12383549000003, 26.373998515000082],
              [62.10688562000013, 26.34971059100006],
              [62.10326827000006, 26.32511261000009],
              [62.094173218000094, 26.314829000000103],
              [62.05278039500013, 26.308576151000082],
              [62.03226485200014, 26.302891745000053],
              [62.0136613360001, 26.29462351500011],
              [61.97774621600013, 26.27317779500008],
              [61.85713342300005, 26.24237864200002],
              [61.83294885300006, 26.2253770950001],
              [61.818376099000034, 26.198453675000067],
              [61.80990116400005, 26.167447815000045],
              [61.800702759000046, 26.106624655000033],
              [61.79274458800006, 26.052829489000104],
              [61.78323612500009, 25.990611064000106],
              [61.77062707500005, 25.907412008],
              [61.76008508300009, 25.83759714800003],
              [61.75450402900009, 25.819975485000057],
              [61.73931115700003, 25.803283997],
              [61.721947876000115, 25.799666646000034],
              [61.702620891000095, 25.800080058000034],
              [61.68143355300003, 25.795480855000093],
              [61.66034956900012, 25.769177552000045],
              [61.66531050600014, 25.732383932000047],
              [61.67636926300014, 25.692799785000076],
              [61.67347538300004, 25.658279928000113],
              [61.667170858000134, 25.650476786000084],
              [61.65249475100006, 25.637299297000098],
              [61.646603638000045, 25.62768748000009],
              [61.64319299300013, 25.61332143200009],
              [61.63905887900012, 25.554927063000022],
              [61.63306441200007, 25.46929921500005],
              [61.62603641800007, 25.36977040600003],
              [61.62004195100013, 25.285486145000036],
              [61.588226759000065, 25.202093817000048],
              [61.58187910200007, 25.21670156500005],
              [61.57976321700005, 25.23346588700008],
              [61.56234785200007, 25.24481842700004],
              [61.559255405000044, 25.25096263200004],
              [61.55445397200003, 25.25409577000005],
              [61.54468834700003, 25.24827708500004],
              [61.54184004000007, 25.242580471000053],
              [61.54037519600007, 25.226507880000042],
              [61.53728274800005, 25.220363674000055],
              [61.54281660200007, 25.215643622000073],
              [61.552744988000086, 25.20506419500009],
              [61.55836022200003, 25.200506903000075],
              [61.53695722700007, 25.20270416900007],
              [61.52076256600003, 25.208644924000055],
              [61.504242384000065, 25.208807684000078],
              [61.48259524800005, 25.19367096600007],
              [61.506195509000065, 25.186835028000075],
              [61.515961134000065, 25.18187083500004],
              [61.524180535000085, 25.173163153000075],
              [61.51880944100003, 25.16351959800005],
              [61.50318444100003, 25.14524974200009],
              [61.49854576900003, 25.13467031500005],
              [61.49854576900003, 25.129380601000037],
              [61.49740644600007, 25.125433661000045],
              [61.48951256600003, 25.11859772300005],
              [61.47510826900003, 25.11163971600007],
              [61.420583530000044, 25.096869208000044],
              [61.43506920700008, 25.087713934000078],
              [61.41171650300004, 25.059408165000036],
              [61.24353001500003, 25.111885812000082],
              [61.18506823800004, 25.123249171000055],
              [61.185475634000056, 25.139607500000068],
              [61.17026860900006, 25.164440118000073],
              [61.03060957100007, 25.209784247000073],
              [60.86670983200008, 25.23460521000004],
              [60.72771243600005, 25.26439036700009],
              [60.633474155000044, 25.27496979400007],
              [60.61695397200003, 25.28318919500009],
              [60.63233483200008, 25.296087958000044],
              [60.608164910000085, 25.32758209800005],
              [60.60499108200008, 25.341050523000035],
              [60.60474694100009, 25.39716217700004],
              [60.601573113000086, 25.405951239000046],
              [60.565196160000085, 25.438625393000052],
              [60.54965254000007, 25.446926174000055],
              [60.53207441500007, 25.448919989000046],
              [60.51417076900003, 25.447333075000074],
              [60.445648634000065, 25.428168036000045],
              [60.428477410000085, 25.419623114000046],
              [60.418955925000034, 25.405991929000038],
              [60.403330925000034, 25.38886139500005],
              [60.395274285000085, 25.377875067000048],
              [60.39503014400003, 25.37132396000004],
              [60.39812259200005, 25.364976304000038],
              [60.40202884200005, 25.344671942000048],
              [60.406911655000044, 25.341945705000057],
              [60.41374759200005, 25.34129466400009],
              [60.424815300000034, 25.336371161000045],
              [60.43344160200007, 25.336493231000077],
              [60.43767337300005, 25.333929755000042],
              [60.44166100400008, 25.32758209800005],
              [60.45220669400004, 25.31738461100008],
              [60.44125410200007, 25.318793036000045],
              [60.44109134200005, 25.31659577000005],
              [60.47006285100008, 25.303086656000062],
              [60.46724586900007, 25.29027590600009],
              [60.45564507600005, 25.292790076000074],
              [60.42352348400004, 25.304964792000078],
              [60.382823113000086, 25.320257880000042],
              [60.36255944100009, 25.330552476000037],
              [60.31922334500007, 25.329851431000066],
              [60.29029381600009, 25.351304429000038],
              [60.29965254000007, 25.367254950000074],
              [60.30396569100009, 25.371161200000074],
              [60.289398634000065, 25.37718333500004],
              [60.27125084700003, 25.37958405200004],
              [60.235036655000044, 25.37799713700008],
              [60.207367384000065, 25.373114325000074],
              [60.201508009000065, 25.371161200000074],
              [60.19255618600005, 25.36200592700004],
              [60.19255618600005, 25.35614655200004],
              [60.19507897200003, 25.351223049000055],
              [60.21597377000006, 25.338280241000064],
              [60.20920955000008, 25.319688555000084],
              [60.181976759000065, 25.31989166900007],
              [60.16187584700003, 25.331976630000042],
              [60.15088951900003, 25.335272528000075],
              [60.11670983200008, 25.33982982000009],
              [60.10889733200008, 25.34511953300006],
              [60.09791100400008, 25.35814036700009],
              [60.08203819300007, 25.365949817000057],
              [60.04532534300006, 25.363858323000045],
              [59.994423416000075, 25.356849768000075],
              [59.94082283800003, 25.354911352000045],
              [59.90380595600004, 25.32986334900005],
              [59.861696244000086, 25.34305680300008],
              [59.819865493000066, 25.379201443000056],
              [59.77487302600008, 25.389868583000066],
              [59.65913449300007, 25.38336122900006],
              [59.61399704300004, 25.38377666000008],
              [59.53798983300004, 25.399749989000043],
              [59.49044337100008, 25.443466614000045],
              [59.45390175600005, 25.461607493000088],
              [59.39728810300005, 25.451845653000078],
              [59.27914472700007, 25.434719143000052],
              [59.251068556000064, 25.43073151200008],
              [59.195323113000086, 25.42291901200008],
              [59.13835696700005, 25.398504950000074],
              [59.117198113000086, 25.394191799000055],
              [59.10873457100007, 25.395697333000044],
              [59.10132897200003, 25.40224844000005],
              [59.094086134000065, 25.406398830000057],
              [59.08545983200008, 25.40460846600007],
              [59.076182488000086, 25.40070221600007],
              [59.06690514400003, 25.398504950000074],
              [59.043955925000034, 25.399603583000044],
              [59.024180535000085, 25.403225002000056],
              [59.00733483200008, 25.40973541900007],
              [58.99431399800005, 25.419623114000046],
              [58.94809004000007, 25.48651764500005],
              [58.92351321700005, 25.513373114000046],
              [58.88445071700005, 25.52948639500005],
              [58.849619988000086, 25.52879466400009],
              [58.84034264400003, 25.532904364000046],
              [58.83415774800005, 25.54238515800006],
              [58.83057701900003, 25.55231354400007],
              [58.825205925000034, 25.560370184000078],
              [58.81373131600009, 25.563625393000052],
              [58.72803795700008, 25.563625393000052],
              [58.54639733200008, 25.59365469000005],
              [58.48414147200003, 25.58466217700004],
              [58.43051191500007, 25.587958075000074],
              [58.41179446700005, 25.59601471600007],
              [58.418955925000034, 25.61200592700004],
              [58.389659050000034, 25.610296942000048],
              [58.35759524800005, 25.60455963700008],
              [58.344086134000065, 25.598130601000037],
              [58.321055535000085, 25.58079661700009],
              [58.30591881600009, 25.577297268000052],
              [58.29900149800005, 25.579820054000038],
              [58.295583530000044, 25.58388906500005],
              [58.29070071700005, 25.583726304000038],
              [58.27898196700005, 25.573879299000055],
              [58.27100670700008, 25.56867096600007],
              [58.260752800000034, 25.565741278000075],
              [58.251963738000086, 25.566839911000045],
              [58.24830162900008, 25.573879299000055],
              [58.24244225400008, 25.571437893000052],
              [58.20728600400008, 25.549302476000037],
              [58.17042076900003, 25.544094143000052],
              [58.13786868600005, 25.54979075700004],
              [58.106211785000085, 25.55890534100007],
              [58.07309004000007, 25.563625393000052],
              [58.04623457100007, 25.57493724200009],
              [58.024180535000085, 25.60187409100007],
              [57.99431399800005, 25.65916575700004],
              [57.963226759000065, 25.693182684000078],
              [57.92530358200008, 25.701320705000057],
              [57.88404381600009, 25.69163646000004],
              [57.84351647200003, 25.67283763200004],
              [57.80941816500007, 25.647772528000075],
              [57.787445509000065, 25.63544342700004],
              [57.77173912900008, 25.635565497000073],
              [57.77588951900003, 25.67967357000009],
              [57.77979576900003, 25.691148179000038],
              [57.78248131600009, 25.696112372000073],
              [57.78305097700007, 25.699774481000077],
              [57.78150475400008, 25.707586981000077],
              [57.77125084700003, 25.73045482000009],
              [57.75562584700003, 25.742743231000077],
              [57.734711134000065, 25.747707424000055],
              [57.709727410000085, 25.748521226000037],
              [57.68718509200005, 25.74640534100007],
              [57.631846550000034, 25.734930731000077],
              [57.61963951900003, 25.73700592700004],
              [57.59880618600005, 25.74640534100007],
              [57.58716881600009, 25.748521226000037],
              [57.57569420700008, 25.74750397300005],
              [57.55583743600005, 25.74282461100006],
              [57.545583530000044, 25.74176666900007],
              [57.52068118600005, 25.74355703300006],
              [57.45248457100007, 25.762884833000044],
              [57.459971550000034, 25.76902903900009],
              [57.326182488000086, 25.777004299000055],
              [57.311534050000034, 25.784125067000048],
              [57.30437259200005, 25.799750067000048],
              [57.29867597700007, 25.84870026200008],
              [57.274424675000034, 25.89940013200004],
              [57.26197350400008, 25.939886786000045],
              [57.25359134200005, 25.95897044500009],
              [57.24366295700008, 25.96702708500004],
              [57.24203535200007, 25.97089264500005],
              [57.219737175000034, 25.995021877000056],
              [57.21534264400003, 25.995835679000038],
              [57.20264733200008, 25.993882554000038],
              [57.19857832100007, 25.995021877000056],
              [57.19678795700008, 25.999172268000052],
              [57.194102410000085, 26.010972398000035],
              [57.18051191500007, 26.04686107000009],
              [57.176524285000085, 26.06354401200008],
              [57.166758660000085, 26.08299388200004],
              [57.16456139400003, 26.094916083000044],
              [57.170909050000034, 26.115627346000053],
              [57.20199629000007, 26.146226304000038],
              [57.212901238000086, 26.16624583500004],
              [57.199229363000086, 26.198187567000048],
              [57.13306725400008, 26.263739325000074],
              [57.13843834700003, 26.29043203300006],
              [57.13103274800005, 26.296616929000038],
              [57.12525475400008, 26.341864325000074],
              [57.118174675000034, 26.36432526200008],
              [57.10710696700005, 26.38226959800005],
              [57.087901238000086, 26.398993231000077],
              [57.08318118600005, 26.40648021000004],
              [57.08033287900008, 26.415350653000075],
              [57.07667076900003, 26.43821849200009],
              [57.07634524800005, 26.44745514500005],
              [57.09343509200005, 26.572211005000042],
              [57.09001712300005, 26.618801174000055],
              [57.02491295700008, 26.85097890800006],
              [57.01124108200008, 26.868882554000038],
              [56.977305535000085, 26.895331122000073],
              [56.965179884000065, 26.91111888200004],
              [56.96648196700005, 26.92723216400009],
              [56.93572024800005, 26.94554271000004],
              [56.92554772200003, 26.955145575000074],
              [56.940114780000044, 26.954291083000044],
              [56.95101972700007, 26.958156643000052],
              [56.96111087300005, 26.96385325700004],
              [56.973317905000044, 26.968817450000074],
              [56.964854363000086, 26.97565338700008],
              [56.963552280000044, 26.98505280200004],
              [56.96705162900008, 26.99481842700004],
              [56.973317905000044, 27.00299713700008],
              [56.94255618600005, 26.991115627000056],
              [56.932383660000085, 26.98932526200008],
              [56.92310631600009, 26.991400458000044],
              [56.91724694100009, 26.99607982000009],
              [56.913096550000034, 27.000799872000073],
              [56.908213738000086, 27.00299713700008],
              [56.903086785000085, 27.006415106000077],
              [56.89779707100007, 27.013006903000075],
              [56.89087975400008, 27.01703522300005],
              [56.87134850400008, 27.00844961100006],
              [56.86548912900008, 27.011867580000057],
              [56.86296634200005, 27.020086981000077],
              [56.86345462300005, 27.03025950700004],
              [56.850596550000034, 27.02765534100007],
              [56.843760613000086, 27.032904364000046],
              [56.844086134000065, 27.040228583000044],
              [56.853526238000086, 27.04393138200004],
              [56.858409050000034, 27.047430731000077],
              [56.875987175000034, 27.064398505000042],
              [56.88461347700007, 27.07062409100007],
              [56.88461347700007, 27.078070380000042],
              [56.85531660200007, 27.081691799000055],
              [56.83139082100007, 27.096136786000045],
              [56.815196160000085, 27.117010809000078],
              [56.80884850400008, 27.139553127000056],
              [56.797211134000065, 27.129339911000045],
              [56.78443444100009, 27.12531159100007],
              [56.75733483200008, 27.12523021000004],
              [56.74236087300005, 27.12958405200004],
              [56.733083530000044, 27.139227606000077],
              [56.725596550000034, 27.148830471000053],
              [56.71607506600009, 27.153143622000073],
              [56.612315300000034, 27.154242255000042],
              [56.58969160200007, 27.160630601000037],
              [56.58285566500007, 27.153143622000073],
              [56.558604363000086, 27.165187893000052],
              [56.52857506600009, 27.170721747000073],
              [56.46615644600007, 27.173651434000078],
              [56.436534050000034, 27.178859768000052],
              [56.38412519600007, 27.19749583500004],
              [56.35303795700008, 27.201605536000045],
              [56.29118899800005, 27.198472398000035],
              [56.25961347700007, 27.191229559000078],
              [56.23658287900008, 27.177069403000075],
              [56.215179884000065, 27.16787344000005],
              [56.15015709700003, 27.165350653000075],
              [56.123708530000044, 27.160630601000037],
              [56.115570509000065, 27.15574778900009],
              [56.09888756600009, 27.141017971000053],
              [56.09555097700007, 27.13613515800006],
              [56.09351647200003, 27.125555731000077],
              [56.08814537900008, 27.122219143000052],
              [56.080414259000065, 27.120754299000055],
              [56.07178795700008, 27.115627346000053],
              [56.05453535200007, 27.10260651200008],
              [55.987315300000034, 27.066351630000042],
              [55.96314537900008, 27.048041083000044],
              [55.96273847700007, 27.04393138200004],
              [55.95753014400003, 27.040757554000038],
              [55.93930097700007, 27.026678778000075],
              [55.928396030000044, 27.02342357000009],
              [55.883799675000034, 27.018744208000044],
              [55.842458530000044, 27.00975169500009],
              [55.83179772200003, 27.008734442000048],
              [55.79835045700008, 27.00975169500009],
              [55.78728274800005, 27.00771719000005],
              [55.772471550000034, 26.99827708500004],
              [55.763682488000086, 26.996161200000074],
              [55.72632897200003, 26.996161200000074],
              [55.69483483200008, 27.002752997000073],
              [55.68482506600009, 27.00299713700008],
              [55.66586347700007, 26.995428778000075],
              [55.63233483200008, 26.96751536700009],
              [55.61963951900003, 26.961371161000045],
              [55.60857181100005, 26.953680731000077],
              [55.55445397200003, 26.89988841400009],
              [55.56885826900003, 26.904120184000078],
              [55.57504316500007, 26.907171942000048],
              [55.582367384000065, 26.91356028900009],
              [55.58643639400003, 26.889064846000053],
              [55.580414259000065, 26.859116929000038],
              [55.56853274800005, 26.83079661700009],
              [55.55445397200003, 26.81053294500009],
              [55.52173912900008, 26.78457265800006],
              [55.48406009200005, 26.767523505000042],
              [55.44223066500007, 26.759914455000057],
              [55.39730879000007, 26.762152411000045],
              [55.316742384000065, 26.78709544500009],
              [55.27084394600007, 26.79254791900007],
              [55.23292076900003, 26.77643463700008],
              [55.221039259000065, 26.75739166900007],
              [55.215586785000085, 26.739488023000035],
              [55.20590254000007, 26.726385809000078],
              [55.181651238000086, 26.721177476000037],
              [55.162119988000086, 26.719142971000053],
              [55.118174675000034, 26.707586981000077],
              [55.10328209700003, 26.701320705000057],
              [55.03793379000007, 26.648911851000037],
              [55.02686608200008, 26.642645575000074],
              [54.930674675000034, 26.572658596000053],
              [54.82203209700003, 26.515773830000057],
              [54.815196160000085, 26.51044342700004],
              [54.808929884000065, 26.503851630000042],
              [54.801524285000085, 26.49823639500005],
              [54.791026238000086, 26.495835679000038],
              [54.77849368600005, 26.497870184000078],
              [54.76156660200007, 26.50682200700004],
              [54.74968509200005, 26.508937893000052],
              [54.66382897200003, 26.502020575000074],
              [54.61996504000007, 26.508246161000045],
              [54.60287519600007, 26.530991929000038],
              [54.590586785000085, 26.55996328300006],
              [54.561289910000085, 26.58466217700004],
              [54.516612175000034, 26.59251536700009],
              [54.42562910200007, 26.58934153900009],
              [54.389414910000085, 26.605129299000055],
              [54.371429884000065, 26.63084544500009],
              [54.35661868600005, 26.66282786700009],
              [54.33773847700007, 26.693426825000074],
              [54.30811608200008, 26.714992580000057],
              [54.28687584700003, 26.71865469000005],
              [54.26685631600009, 26.715765692000048],
              [54.24756920700008, 26.71084219000005],
              [54.17139733200008, 26.70612213700008],
              [54.150401238000086, 26.708197333000044],
              [54.08171634200005, 26.72614166900007],
              [54.064463738000086, 26.728583075000074],
              [54.053721550000034, 26.731634833000044],
              [54.03451582100007, 26.745306708000044],
              [54.02621504000007, 26.74909088700008],
              [54.01579837300005, 26.74945709800005],
              [53.995127800000034, 26.74559153900009],
              [53.92937259200005, 26.718003648000035],
              [53.883474155000044, 26.71234772300005],
              [53.842784050000034, 26.702093817000048],
              [53.82081139400003, 26.701320705000057],
              [53.776133660000085, 26.71426015800006],
              [53.75171959700003, 26.716050523000035],
              [53.72828209700003, 26.704738674000055],
              [53.71607506600009, 26.70856354400007],
              [53.66382897200003, 26.74909088700008],
              [53.588633660000085, 26.788763739000046],
              [53.49154707100007, 26.854315497000073],
              [53.477224155000044, 26.87010325700004],
              [53.471446160000085, 26.88963450700004],
              [53.469086134000065, 26.937201239000046],
              [53.46111087300005, 26.957098700000074],
              [53.444102410000085, 26.97565338700008],
              [53.412119988000086, 26.99355703300006],
              [53.07203209700003, 27.096869208000044],
              [53.05014082100007, 27.098578192000048],
              [53.02865644600007, 27.104071356000077],
              [53.01531009200005, 27.117336330000057],
              [53.00473066500007, 27.133246161000045],
              [52.992198113000086, 27.146958726000037],
              [52.932627800000034, 27.16034577000005],
              [52.92335045700008, 27.17023346600007],
              [52.914724155000044, 27.191961981000077],
              [52.89429772200003, 27.203070380000042],
              [52.848317905000044, 27.215277411000045],
              [52.76775149800005, 27.279730536000045],
              [52.73218834700003, 27.301336981000077],
              [52.678802931000064, 27.322373765000066],
              [52.60132897200003, 27.35293203300006],
              [52.580739780000044, 27.372259833000044],
              [52.579112175000034, 27.39276764500005],
              [52.588552280000044, 27.405503648000035],
              [52.60523522200003, 27.412054755000042],
              [52.62614993600005, 27.413885809000078],
              [52.644867384000065, 27.413316148000035],
              [52.66651451900003, 27.415350653000075],
              [52.67896569100009, 27.42527903900009],
              [52.67009524800005, 27.44863515800006],
              [52.65414472700007, 27.460882880000042],
              [52.61353600400008, 27.474676825000074],
              [52.598399285000085, 27.48582591400009],
              [52.590505405000044, 27.497748114000046],
              [52.57447350400008, 27.530585028000075],
              [52.56763756600009, 27.540716864000046],
              [52.492523634000065, 27.609442450000074],
              [52.459646030000044, 27.632635809000078],
              [52.42310631600009, 27.646633205000057],
              [52.244883660000085, 27.681382554000038],
              [52.20720462300005, 27.69822825700004],
              [52.08920332100007, 27.795396226000037],
              [52.05258222700007, 27.81736888200004],
              [52.01124108200008, 27.83270905200004],
              [51.96371504000007, 27.838446356000077],
              [51.89429772200003, 27.830877997000073],
              [51.87842858200008, 27.83535390800006],
              [51.85962975400008, 27.84589264500005],
              [51.823864455000034, 27.84359672700009],
              [51.78529543700006, 27.835453504000043],
              [51.72279946300006, 27.82511659800008],
              [51.68344287800005, 27.830580873000088],
              [51.59693444100009, 27.84666575700004],
              [51.58513431100005, 27.849310614000046],
              [51.580088738000086, 27.85578034100007],
              [51.578868035000085, 27.865301825000074],
              [51.57553144600007, 27.872788804000038],
              [51.570323113000086, 27.87763092700004],
              [51.539135154000064, 27.88162735900005],
              [51.49642378500005, 27.893040839000037],
              [51.47509621100005, 27.91347959300009],
              [51.45207725200004, 27.947514573000035],
              [51.428156011000056, 27.961147005000043],
              [51.420405207000044, 27.933200948000035],
              [51.39987550200004, 27.93171314700004],
              [51.38027113800007, 27.991418381000074],
              [51.36061041900007, 28.016378363000058],
              [51.34522163500009, 28.052668550000078],
              [51.307529834000036, 28.107132148000062],
              [51.29036926500004, 28.121519294000052],
              [51.26975927800004, 28.140453578000063],
              [51.26482181100005, 28.160549221000053],
              [51.28687584700003, 28.21430084800005],
              [51.28532962300005, 28.24091217700004],
              [51.26482181100005, 28.270453192000048],
              [51.22999108200008, 28.29840729400007],
              [51.21762129000007, 28.311428127000056],
              [51.182383660000085, 28.359767971000053],
              [51.149424675000034, 28.39052969000005],
              [51.14185631600009, 28.400783596000053],
              [51.080739780000044, 28.53392161700009],
              [51.07252037900008, 28.565252997000073],
              [51.07154381600009, 28.692694403000075],
              [51.05884850400008, 28.73590729400007],
              [51.03638756600009, 28.77252838700008],
              [51.01091556100005, 28.79913971600007],
              [50.97868899800005, 28.81663646000004],
              [50.936534050000034, 28.825344143000052],
              [50.89600670700008, 28.827337958000044],
              [50.87614993600005, 28.83201732000009],
              [50.86768639400003, 28.842678127000056],
              [50.860036655000044, 28.862453518000052],
              [50.81299889400003, 28.91469961100006],
              [50.80486087300005, 28.93357982000009],
              [50.798838738000086, 28.96112702000005],
              [50.80258222700007, 28.98582591400009],
              [50.823252800000034, 28.996649481000077],
              [50.842784050000034, 28.990668036000045],
              [50.86247806100005, 28.97614166900007],
              [50.878916863000086, 28.95799388200004],
              [50.888682488000086, 28.94139232000009],
              [50.89926191500007, 28.94944896000004],
              [50.89795983200008, 28.956732489000046],
              [50.89340254000007, 28.96503327000005],
              [50.894867384000065, 28.97614166900007],
              [50.90202884200005, 28.98338450700004],
              [50.922211134000065, 28.999212958000044],
              [50.92896569100009, 29.00967031500005],
              [50.932383660000085, 29.03148021000004],
              [50.92994225400008, 29.054632880000042],
              [50.92017662900008, 29.06903717700004],
              [50.90170332100007, 29.064886786000045],
              [50.893321160000085, 29.093898830000057],
              [50.88656660200007, 29.104071356000077],
              [50.87435957100007, 29.11326732000009],
              [50.86833743600005, 29.11204661700009],
              [50.85914147200003, 29.107814846000053],
              [50.85084069100009, 29.10545482000009],
              [50.84717858200008, 29.109930731000077],
              [50.84595787900008, 29.12685781500005],
              [50.84400475400008, 29.135199286000045],
              [50.84034264400003, 29.14061107000009],
              [50.816416863000086, 29.144191799000055],
              [50.738291863000086, 29.14008209800005],
              [50.72022545700008, 29.137193101000037],
              [50.693695509000065, 29.123439846000053],
              [50.66586347700007, 29.12641022300005],
              [50.64380944100009, 29.143459377000056],
              [50.63493899800005, 29.17133209800005],
              [50.63306725400008, 29.19550202000005],
              [50.635752800000034, 29.20770905200004],
              [50.64478600400008, 29.21979401200008],
              [50.65186608200008, 29.233343817000048],
              [50.65837649800005, 29.249945380000042],
              [50.66749108200008, 29.25726959800005],
              [50.682627800000034, 29.243068752000056],
              [50.68702233200008, 29.28388092700004],
              [50.689463738000086, 29.290838934000078],
              [50.67986087300005, 29.29364655200004],
              [50.67359459700003, 29.299627997000073],
              [50.66146894600007, 29.318793036000045],
              [50.668630405000044, 29.34332916900007],
              [50.66822350400008, 29.38226959800005],
              [50.663096550000034, 29.421942450000074],
              [50.655284050000034, 29.44912344000005],
              [50.64210045700008, 29.46979401200008],
              [50.62273196700005, 29.493068752000056],
              [50.607432488000086, 29.49949778900009],
              [50.60694420700008, 29.469631252000056],
              [50.60108483200008, 29.48065827000005],
              [50.57276451900003, 29.518011786000045],
              [50.52003014400003, 29.555975653000075],
              [50.51140384200005, 29.568915106000077],
              [50.504567905000044, 29.586086330000057],
              [50.48878014400003, 29.60537344000005],
              [50.456065300000034, 29.634100653000075],
              [50.39698326900003, 29.654730536000045],
              [50.38786868600005, 29.66510651200008],
              [50.381602410000085, 29.68500397300005],
              [50.36703535200007, 29.70408763200004],
              [50.34001712300005, 29.730292059000078],
              [50.31332441500007, 29.76398346600007],
              [50.267914259000065, 29.836371161000045],
              [50.24382571700005, 29.866848049000055],
              [50.22510826900003, 29.88117096600007],
              [50.18384850400008, 29.903143622000073],
              [50.144867384000065, 29.938055731000077],
              [50.141368035000085, 29.942572333000044],
              [50.13843834700003, 29.95465729400007],
              [50.13754316500007, 29.97296784100007],
              [50.13396243600005, 29.983547268000052],
              [50.14966881600009, 29.985174872000073],
              [50.153330925000034, 29.991034247000073],
              [50.147471550000034, 29.99823639500005],
              [50.13396243600005, 30.004055080000057],
              [50.14478600400008, 30.037909247000073],
              [50.121836785000085, 30.094549872000073],
              [50.127696160000085, 30.12067291900007],
              [50.113617384000065, 30.13031647300005],
              [50.09791100400008, 30.148504950000074],
              [50.084727410000085, 30.168890692000048],
              [50.07935631600009, 30.185248114000046],
              [50.07341556100005, 30.195746161000045],
              [50.05884850400008, 30.20457591400009],
              [50.05062910200007, 30.20734284100007],
              [50.024099155000044, 30.21625397300005],
              [49.988291863000086, 30.219916083000044],
              [49.95101972700007, 30.21503327000005],
              [49.91456139400003, 30.203924872000073],
              [49.60075931100005, 30.030096747000073],
              [49.564463738000086, 30.016831773000035],
              [49.532237175000034, 30.02293528900009],
              [49.50407962300005, 30.058661200000074],
              [49.50163821700005, 30.07489655200004],
              [49.50123131600009, 30.120062567000048],
              [49.49341881600009, 30.13743724200009],
              [49.48617597700007, 30.14638906500005],
              [49.48365319100009, 30.15180084800005],
              [49.47982832100007, 30.156073309000078],
              [49.469086134000065, 30.16168854400007],
              [49.459320509000065, 30.165187893000052],
              [49.449880405000044, 30.167181708000044],
              [49.42823326900009, 30.168524481000077],
              [49.41765384200005, 30.16746653900009],
              [49.39600670700008, 30.16278717700004],
              [49.38396243600005, 30.16168854400007],
              [49.37281334700003, 30.163763739000046],
              [49.358409050000034, 30.173163153000075],
              [49.349945509000065, 30.17527903900009],
              [49.32927493600005, 30.172267971000053],
              [49.29184004000007, 30.15851471600007],
              [49.27125084700003, 30.154852606000077],
              [49.245127800000034, 30.15648021000004],
              [49.23568769600007, 30.16510651200008],
              [49.237071160000085, 30.206366278000075],
              [49.23406009200005, 30.209418036000045],
              [49.22022545700008, 30.217922268000052],
              [49.21599368600005, 30.223781643000052],
              [49.215505405000044, 30.22919342700004],
              [49.21599368600005, 30.244208075000074],
              [49.217539910000085, 30.251776434000078],
              [49.221690300000034, 30.258205471000053],
              [49.22120201900009, 30.264553127000056],
              [49.20915774800005, 30.271470445000034],
              [49.20337975400008, 30.254461981000077],
              [49.19288170700008, 30.23773834800005],
              [49.178477410000085, 30.225897528000075],
              [49.16138756600009, 30.223781643000052],
              [49.143321160000085, 30.233547268000052],
              [49.134776238000086, 30.24632396000004],
              [49.124034050000034, 30.256415106000077],
              [49.10670006600009, 30.257798570000034],
              [49.08350670700008, 30.264837958000044],
              [49.01734459700003, 30.29828522300005],
              [49.00367272200003, 30.309393622000073],
              [48.997080925000034, 30.341620184000078],
              [48.979502800000034, 30.361761786000045],
              [48.95329837300005, 30.373521226000037],
              [48.92115319100009, 30.38076406500005],
              [48.93181399800005, 30.39716217700004],
              [48.94857832100007, 30.40106842700004],
              [48.98943118600005, 30.395005601000037],
              [49.010752800000034, 30.39594147300005],
              [49.043711785000085, 30.40566640800006],
              [49.06202233200008, 30.40810781500005],
              [49.082367384000065, 30.40379466400009],
              [49.123383009000065, 30.38507721600007],
              [49.137461785000085, 30.38076406500005],
              [49.15967858200008, 30.378851630000042],
              [49.176442905000044, 30.372748114000046],
              [49.18995201900009, 30.362209377000056],
              [49.20289147200003, 30.346625067000048],
              [49.20875084700003, 30.36009349200009],
              [49.22771243600005, 30.389227606000077],
              [49.25717207100007, 30.421861070000034],
              [49.26286868600005, 30.432562567000048],
              [49.26384524800005, 30.449652411000045],
              [49.243174675000034, 30.44603099200009],
              [49.22828209700003, 30.454413153000075],
              [49.21900475400008, 30.46979401200008],
              [49.21119225400008, 30.506333726000037],
              [49.19939212300005, 30.501613674000055],
              [49.18384850400008, 30.48704661700009],
              [49.16822350400008, 30.476996161000045],
              [49.16968834700003, 30.48973216400009],
              [49.17115319100009, 30.493109442000048],
              [49.17505944100009, 30.49746328300006],
              [49.166758660000085, 30.50877513200004],
              [49.158213738000086, 30.506984768000052],
              [49.14795983200008, 30.500392971000053],
              [49.13404381600009, 30.49746328300006],
              [49.12810306100005, 30.501125393000052],
              [49.11695397200003, 30.514878648000035],
              [49.110118035000085, 30.517971096000053],
              [49.10377037900008, 30.516831773000035],
              [49.094411655000044, 30.512193101000037],
              [49.08936608200008, 30.51113515800006],
              [49.069346550000034, 30.513820705000057],
              [49.05128014400009, 30.518377997000073],
              [49.03435306100005, 30.519273179000038],
              [49.01734459700003, 30.51113515800006],
              [48.981455925000034, 30.515611070000034],
              [48.95297285200007, 30.50018952000005],
              [48.945648634000065, 30.479722398000035],
              [48.972666863000086, 30.46946849200009],
              [49.00440514400009, 30.464016018000052],
              [49.02947024800005, 30.45026276200008],
              [49.03728274800005, 30.432521877000056],
              [49.01734459700003, 30.414943752000056],
              [49.00049889400009, 30.415187893000052],
              [48.94646243600005, 30.421576239000046],
              [48.93482506600009, 30.41864655200004],
              [48.88013756600009, 30.37457916900007],
              [48.87614993600005, 30.37010325700004],
              [48.86736087300005, 30.35809967700004],
              [48.862315300000034, 30.34560781500005],
              [48.873708530000044, 30.33665599200009],
              [48.86963951900009, 30.32949453300006],
              [48.86304772200003, 30.321519273000035],
              [48.85962975400008, 30.316229559000078],
              [48.86703535200007, 30.294745184000078],
              [48.88453209700003, 30.279364325000074],
              [48.90479576900009, 30.266017971000053],
              [48.92115319100009, 30.250433661000045],
              [48.92953535200007, 30.23265208500004],
              [48.93604576900009, 30.210109768000052],
              [48.94166100400008, 30.16510651200008],
              [48.93970787900008, 30.15253327000005],
              [48.93083743600005, 30.131984768000052],
              [48.92798912900008, 30.12067291900007],
              [48.92855879000007, 30.11005280200004],
              [48.934255405000044, 30.091009833000044],
              [48.93482506600009, 30.079738674000055],
              [48.92855879000007, 30.06000397300005],
              [48.91529381600009, 30.042181708000044],
              [48.897227410000085, 30.029445705000057],
              [48.87671959700003, 30.02448151200008],
              [48.80884850400008, 30.03143952000005],
              [48.791351759000065, 30.02448151200008],
              [48.77198326900009, 30.032375393000052],
              [48.70199629000007, 30.03192780200004],
              [48.65951582100007, 30.05223216400009],
              [48.643321160000085, 30.05540599200009],
              [48.640635613000086, 30.03807200700004],
              [48.645518425000034, 30.02610911700009],
              [48.658946160000085, 30.00726959800005],
              [48.66163170700008, 29.993475653000075],
              [48.65870201900009, 29.983628648000035],
              [48.651377800000034, 29.975002346000053],
              [48.64234459700003, 29.967962958000044],
              [48.633799675000034, 29.963039455000057],
              [48.61085045700008, 29.957017320000034],
              [48.537445509000065, 29.963039455000057],
              [48.537445509000065, 29.969875393000052],
              [48.53207441500007, 29.963812567000048],
              [48.53101647200003, 29.961330471000053],
              [48.523993775000065, 29.964115295000042],
              [48.49303959100007, 29.971763408000115],
              [48.478156779000074, 29.97961822500004],
              [48.46430749600006, 29.98912668900003],
              [48.45779626500007, 29.994862772000076],
              [48.45314538600013, 30.001425679000064],
              [48.44425704000008, 30.020907695000076],
              [48.442189982000116, 30.03393015600001],
              [48.423948202000076, 30.0836428840001],
              [48.42120935100013, 30.085348206000063],
              [48.415524943000094, 30.09563181600008],
              [48.39557784100009, 30.115217184000088],
              [48.38307214300005, 30.13841990100009],
              [48.38110844000005, 30.145344544000082],
              [48.383278849000135, 30.15645497700008],
              [48.39113366700008, 30.16477488200006],
              [48.40074548400008, 30.172267965000074],
              [48.40803186000005, 30.18089792900004],
              [48.41061568200007, 30.19154327500003],
              [48.408703654000135, 30.20234364900007],
              [48.40358768800013, 30.212523906000044],
              [48.39702478100014, 30.220998841000025],
              [48.35816410300009, 30.251797995000103],
              [48.32602136200006, 30.283475647],
              [48.30571252500005, 30.312827861000088],
              [48.296359090000124, 30.31975250200007],
              [48.28426680500013, 30.323318177000132],
              [48.27165775600008, 30.323834941000072],
              [48.23507084100004, 30.31851226800002],
              [48.222978556000044, 30.31809885700001],
              [48.211196330000064, 30.31964915000013],
              [48.200085897000065, 30.323938293000097],
              [48.19207605000008, 30.3312763470001],
              [48.187683553000056, 30.34083648700009],
              [48.179467, 30.384864807000056],
              [48.170475301000124, 30.406672261000082],
              [48.15765954600005, 30.42630930600002],
              [48.14091638200006, 30.44191558900006],
              [48.13058109600007, 30.447496643000065],
              [48.11941898600014, 30.45080393500008],
              [48.013585653000064, 30.463878072000014],
              [48.01203535900004, 30.494522196000062],
              [48.01544600400007, 30.976249899000052],
              [48.01224206600011, 30.989065653000026],
              [48.001545044000125, 30.994646708000047],
              [47.67293461100013, 30.994698385000063],
              [47.67644317400004, 31.236517019000033],
              [47.678929077000134, 31.407851461000106],
              [47.83132287600006, 31.761835022000085],
              [47.837265666000064, 31.784469300000026],
              [47.83447513800013, 31.805708313000096],
              [47.8207808840001, 31.823588359000055],
              [47.78135176600006, 31.848858134000025],
              [47.765280395000104, 31.86410268200008],
              [47.761714722000136, 31.871647441000036],
              [47.75654707900014, 31.88916575100008],
              [47.750966024000036, 31.898209127000044],
              [47.743317912000066, 31.904255269000075],
              [47.725231161000124, 31.914332174000023],
              [47.71840987200005, 31.92234202100009],
              [47.68264978000008, 31.97691233400012],
              [47.67794722500008, 31.99453399700012],
              [47.67794722500008, 31.994689026000046],
              [47.668077026000105, 32.01241404300008],
              [47.63314375800013, 32.02693512000012],
              [47.617795858000136, 32.041869609000074],
              [47.59500655200014, 32.085432842],
              [47.580232356000124, 32.103495196000054],
              [47.578056682000124, 32.10615509000003],
              [47.558729696000114, 32.11297638000009],
              [47.5436401770001, 32.11457834900004],
              [47.53475183100005, 32.123156637000065],
              [47.52669030800007, 32.13338857000004],
              [47.51382287600006, 32.14031321200012],
              [47.498164917000054, 32.14413726800005],
              [47.491343628000095, 32.14863311800009],
              [47.49041345200004, 32.15653961200003],
              [47.492480510000064, 32.17049224900002],
              [47.496407918000045, 32.18134429900006],
              [47.50235070800005, 32.190129294000045],
              [47.507673380000085, 32.199844463000105],
              [47.50922367300012, 32.213797099000075],
              [47.50400435400013, 32.2267420460001],
              [47.48452233900014, 32.23935109500003],
              [47.47914799000006, 32.25206349800008],
              [47.46943282000012, 32.25612009700008],
              [47.46302494300011, 32.26183034300003],
              [47.44535160300006, 32.28263010700009],
              [47.441579224000066, 32.288185323],
              [47.43687666800008, 32.2936888630001],
              [47.4070593670001, 32.317770081000035],
              [47.402460165000036, 32.3235061650001],
              [47.39579390500012, 32.33701955200006],
              [47.395948934000046, 32.34198048900002],
              [47.39997969600006, 32.345778708000054],
              [47.408764689000066, 32.36433054600009],
              [47.41434574400006, 32.369859925000085],
              [47.41796309400013, 32.376422831000085],
              [47.416412801000035, 32.38797251400011],
              [47.41083174700009, 32.395284730000085],
              [47.384115031000135, 32.4125704960001],
              [47.36732019100009, 32.43076060000003],
              [47.35610640500005, 32.44618601500012],
              [47.343342326000084, 32.45869171200003],
              [47.32194828300004, 32.468226013000034],
              [47.265310913000064, 32.484684957000084],
              [47.251254924000136, 32.4854601040001],
              [47.205469605000076, 32.464040222000065],
              [47.18779626500009, 32.458381653000046],
              [47.15255293800004, 32.45517771400007],
              [47.12103031500004, 32.46104298900006],
              [47.09059289600009, 32.47455637600005],
              [47.05865686000004, 32.49440012700002],
              [47.0586051840001, 32.494477641000046],
              [47.05839847900006, 32.494477641000046],
              [46.75733158400004, 32.716195374000094],
              [46.71588708500008, 32.756012065],
              [46.65036136900005, 32.78936920200006],
              [46.60442102100012, 32.82068512000008],
              [46.60061305900007, 32.8225414760001],
              [46.50732100500011, 32.86802073200003],
              [46.47931237800009, 32.89179189000002],
              [46.37962854000011, 32.93176361100005],
              [46.27343347200008, 32.95948801700008],
              [46.15555952900013, 32.94835174600006],
              [46.09701013200004, 32.95432037400009],
              [46.075719442000036, 32.99434377000007],
              [46.075719442000036, 32.9944988000001],
              [46.08801843300006, 33.006720276000024],
              [46.10465824400012, 33.01806325300002],
              [46.11948938000006, 33.03100819900003],
              [46.12615563900005, 33.047983908000035],
              [46.120419556000115, 33.061678162000064],
              [46.10600183100007, 33.072504375],
              [46.08719161000005, 33.07922231000002],
              [46.04326664300004, 33.08345977800009],
              [46.02931400500006, 33.09351084400002],
              [46.03029585700011, 33.10568064400012],
              [46.05039799000008, 33.115111593000066],
              [46.07241215000005, 33.11676523900003],
              [46.089155314000095, 33.11568003400005],
              [46.10538171400009, 33.11839304700008],
              [46.12646569900005, 33.13177724200001],
              [46.15344079600004, 33.15425649100011],
              [46.16718672600007, 33.16833831800004],
              [46.17431807400004, 33.18117991100003],
              [46.17369795700006, 33.190223287],
              [46.16212243600012, 33.19637278300006],
              [46.15767826400008, 33.20567454100008],
              [46.15835005700012, 33.2138652550001],
              [46.16439619900012, 33.23306304900002],
              [46.164189494000084, 33.24334665900004],
              [46.15530114800009, 33.26021901500009],
              [46.1413485110001, 33.27210459400003],
              [46.109515829000145, 33.29370534300001],
              [46.06972497600009, 33.340860088000014],
              [46.03623864800011, 33.367938538000075],
              [46.031071005000115, 33.38251129100003],
              [46.030502564000074, 33.39920278000007],
              [46.027453654000055, 33.41951161700008],
              [46.01939213100013, 33.43839935300012],
              [46.00802331500006, 33.45565928100011],
              [45.97443363500014, 33.490799255000056],
              [45.97138472500012, 33.49276296000009],
              [45.96823246200006, 33.494235738],
              [45.96448744700007, 33.49599121400003],
              [45.963271525000096, 33.49656117700003],
              [45.95815555900009, 33.49738800100006],
              [45.953142944000035, 33.49658701600002],
              [45.94818200700007, 33.4942615770001],
              [45.92968184500006, 33.479507955000074],
              [45.89939945400005, 33.47630401700012],
              [45.8697371830001, 33.482117615],
              [45.85258060800004, 33.49436493000003],
              [45.86818689000006, 33.511573182000106],
              [45.915625855000144, 33.53580942800009],
              [45.927924845000064, 33.55087310800009],
              [45.92089685000008, 33.57299062100007],
              [45.89970951400011, 33.58516042100008],
              [45.88203617400012, 33.60019826300008],
              [45.8859635820001, 33.63091990200003],
              [45.86436283300009, 33.626424053],
              [45.81578698700014, 33.625803935000036],
              [45.79754520600005, 33.61931854200007],
              [45.768451376000144, 33.59590911900001],
              [45.752018270000065, 33.58676239000003],
              [45.73455163600005, 33.58311920200005],
              [45.72773034700009, 33.59009552000005],
              [45.72798872900006, 33.625648905],
              [45.724629623000055, 33.633036413000085],
              [45.7211157640001, 33.640764262000104],
              [45.6739868570001, 33.669031271000094],
              [45.65879398600009, 33.68169199700013],
              [45.64515140800006, 33.69791839600005],
              [45.63512618000004, 33.71417063400004],
              [45.628201539000145, 33.73184397400006],
              [45.62391239400006, 33.75207529700005],
              [45.616729370000144, 33.76868927000005],
              [45.60360355600005, 33.78072987900005],
              [45.58820397900007, 33.79150441500006],
              [45.574768107000125, 33.80393259700004],
              [45.485781290000034, 33.938653056000035],
              [45.48392093900014, 33.940048320000116],
              [45.48175052900007, 33.94087514300004],
              [45.47927006000009, 33.94118520100004],
              [45.44971114100014, 33.9373869840001],
              [45.423717895000095, 33.93878224700008],
              [45.401031942000145, 33.94945343000008],
              [45.38036136900013, 33.97356048600004],
              [45.401755412000114, 33.98162200900002],
              [45.41147058100006, 33.9871513880001],
              [45.419738811000116, 33.994256898000046],
              [45.41994551600004, 33.994256898000046],
              [45.41994551600004, 33.99436025000007],
              [45.435190064000096, 34.02213633200002],
              [45.44361332200009, 34.04766449000006],
              [45.45487878400007, 34.069859518],
              [45.47927006000009, 34.08763621100012],
              [45.49394616700005, 34.10068450900006],
              [45.53435713700014, 34.128202210000055],
              [45.544537395000134, 34.139493510000094],
              [45.544537395000134, 34.150629781000035],
              [45.53880131000005, 34.159233907000086],
              [45.53146325700004, 34.16791554800004],
              [45.52665734900006, 34.179310202000025],
              [45.528672730000096, 34.18856028300006],
              [45.54272871900014, 34.20747385700007],
              [45.54768965700009, 34.216491395000034],
              [45.56102217600011, 34.26460215300001],
              [45.56303755700014, 34.28927764900003],
              [45.55755985500008, 34.31196360300008],
              [45.542211955000084, 34.331600647000116],
              [45.521541382000066, 34.34250437400006],
              [45.49921716400013, 34.34240102200003],
              [45.47927006000009, 34.32914601700004],
              [45.46076989800008, 34.34046315500002],
              [45.44795414200007, 34.362089743000084],
              [45.417051635000064, 34.44435862300004],
              [45.42676680500011, 34.45751027500002],
              [45.47927006000009, 34.46725128200008],
              [45.48650476100005, 34.47272898400006],
              [45.49301599100011, 34.47900767000006],
              [45.498700399000086, 34.48624237000003],
              [45.50345463100007, 34.49417470300007],
              [45.50484989500012, 34.52378529900004],
              [45.49652998800008, 34.56424794500002],
              [45.50066410300008, 34.59168813100008],
              [45.539628133000065, 34.58223134400002],
              [45.5739412850001, 34.56729685500004],
              [45.60484379100012, 34.56114736000008],
              [45.67357344600009, 34.556651510000066],
              [45.69558760500007, 34.55024363200003],
              [45.70153039600007, 34.5512771610001],
              [45.70561283400008, 34.55773671500005],
              [45.70830000800004, 34.56838206000005],
              [45.70855839100011, 34.579079081000046],
              [45.70561283400008, 34.58559031200012],
              [45.694450724000035, 34.59856109700006],
              [45.69124678600008, 34.61551096600006],
              [45.69078169800014, 34.63432118800007],
              [45.687629435000076, 34.65323476200008],
              [45.68349532000008, 34.66021108000008],
              [45.67837935400007, 34.66512034100002],
              [45.67347009300005, 34.67116648400007],
              [45.6703695060001, 34.68181182900007],
              [45.66685551000006, 34.68997670500009],
              [45.65951745600006, 34.69721140600005],
              [45.65052575700014, 34.702999166000026],
              [45.64225752800007, 34.706874899000084],
              [45.627374715000144, 34.720827535000055],
              [45.635022827000114, 34.73695058300005],
              [45.66282474800005, 34.7632538860001],
              [45.66592533400012, 34.77472605400003],
              [45.66359989400007, 34.7949315390001],
              [45.66675215600014, 34.806920472000044],
              [45.676570679000065, 34.81828928700004],
              [45.689231405000044, 34.82263010700002],
              [45.71770511900007, 34.825110576],
              [45.74540368700008, 34.84097524000002],
              [45.750467977000085, 34.86536651700003],
              [45.74850427200005, 34.89073964500004],
              [45.75511885600014, 34.909963277000045],
              [45.77826989800013, 34.9108934530001],
              [45.79620242700008, 34.90306366600004],
              [45.808035523000115, 34.89787099200008],
              [45.83501062000005, 34.89017120400008],
              [45.85020349200005, 34.90681101500009],
              [45.85785160300014, 34.93130564400006],
              [45.86632653800007, 34.949547425],
              [45.868962036000084, 34.968357646000115],
              [45.85971195500014, 34.99424753800007],
              [45.85971195500014, 34.9944025680001],
              [45.856818074000046, 35.0080451460001],
              [45.85702478000013, 35.0212743120001],
              [45.86188236500004, 35.032798157000045],
              [45.872476034000044, 35.04142812100007],
              [45.87903894100003, 35.04323679600007],
              [45.89309493000013, 35.04437367800007],
              [45.899089396000136, 35.046905823000074],
              [45.9011564540001, 35.05160837800004],
              [45.89836592700004, 35.06390736900009],
              [45.89939945400005, 35.06860992500005],
              [45.91319706200011, 35.087316793000056],
              [45.9201733810001, 35.08964223300008],
              [45.93495284000011, 35.08545644200005],
              [45.95603682400014, 35.074242656000095],
              [45.966372111000055, 35.07072865800005],
              [45.97923954300012, 35.07155548200005],
              [46.00921187300008, 35.06091013600006],
              [46.025076538000064, 35.064269104000076],
              [46.03975264500008, 35.07553456600003],
              [46.066572714000074, 35.08881541000004],
              [46.0766496170001, 35.089693909000076],
              [46.09452966300006, 35.08581817600013],
              [46.11995446800006, 35.092742818000104],
              [46.132356812000126, 35.094758199000054],
              [46.143105510000055, 35.099512431000065],
              [46.15106368000011, 35.11160471600003],
              [46.13039310700009, 35.13139679000001],
              [46.143828979000034, 35.15961212200007],
              [46.16548140500004, 35.18994618700013],
              [46.169253784000034, 35.216249492000074],
              [46.154164266000066, 35.226636455000104],
              [46.11540694200005, 35.226326396],
              [46.10145430500006, 35.234284566000085],
              [46.0987671310001, 35.25004587900007],
              [46.10765547700004, 35.26275828100002],
              [46.12005782000011, 35.27490224300003],
              [46.125285441000074, 35.2849893410001],
              [46.12739587400006, 35.289061584000066],
              [46.12016117300004, 35.31851715100005],
              [46.096286662000125, 35.34115142900002],
              [46.0409928790001, 35.3815623980001],
              [45.97701745600011, 35.46532989500004],
              [45.963994995000064, 35.49416534400008],
              [45.96358158400005, 35.5034154260001],
              [45.966062053000144, 35.511476949],
              [45.971333048000076, 35.51803985600007],
              [45.97923954300012, 35.523000794000026],
              [45.98321862800009, 35.52697987900011],
              [45.984562215000096, 35.53106231700009],
              [45.9831152750001, 35.53529978400006],
              [45.97923954300012, 35.539485575000086],
              [45.96802575700008, 35.55850250300007],
              [45.959344116000125, 35.57870798800006],
              [45.96389164200008, 35.57974151600003],
              [45.96869755000006, 35.57974151600003],
              [45.99923832200005, 35.57214508100007],
              [46.002028850000045, 35.58594268800003],
              [45.99231368000011, 35.62438995400008],
              [45.99236535600011, 35.64087473600004],
              [45.99587935400007, 35.658393046000114],
              [46.00378584800012, 35.67425771100001],
              [46.016498251000144, 35.68572987900005],
              [46.03706547100006, 35.69156931600013],
              [46.107035360000054, 35.68981231700003],
              [46.12760258000014, 35.69368805],
              [46.17772871900007, 35.7153921510001],
              [46.21700280800013, 35.71358347600001],
              [46.237880086000075, 35.71554718100005],
              [46.25348636900014, 35.727742819000056],
              [46.26712894700006, 35.744124248],
              [46.29751469000013, 35.75988555900007],
              [46.31337935400012, 35.77151275700005],
              [46.3250582280001, 35.78784250900007],
              [46.327073608000035, 35.80350046900013],
              [46.31963220200004, 35.81688466400006],
              [46.30299239100009, 35.826548157],
              [46.28139164200013, 35.82830515600007],
              [46.26351159600006, 35.82112213200013],
              [46.246406698000044, 35.81140696300007],
              [46.22744144700005, 35.80572255500003],
              [46.18496341900004, 35.798177796000076],
              [46.163517700000114, 35.79750600200002],
              [46.143363891000035, 35.8045339960001],
              [46.135199015000126, 35.8100116990001],
              [46.129101196000136, 35.81554107700002],
              [46.124812052000095, 35.822465719],
              [46.11985111500013, 35.84287790900002],
              [46.11504520700004, 35.846443584],
              [46.10775883000014, 35.84742543600008],
              [46.07695967600006, 35.85698557500005],
              [46.060423218000096, 35.85724395800004],
              [46.04430017100009, 35.85228302000009],
              [46.02497318600007, 35.84329132100005],
              [46.00492273000003, 35.8379686490001],
              [45.941257365000126, 35.84034576500004],
              [45.9091146240001, 35.83130238900007],
              [45.898779338000054, 35.832180888000025],
              [45.888495728000066, 35.83486806300006],
              [45.87831547000013, 35.83522979800004],
              [45.85407922300004, 35.81833160400005],
              [45.83475223800008, 35.81052846300004],
              [45.8141850180001, 35.809339905000016],
              [45.797906942000054, 35.81838328100007],
              [45.786744832000124, 35.82024363300009],
              [45.74902103700009, 35.81099355100007],
              [45.73103763900008, 35.815127666000095],
              [45.718738648000055, 35.82830515600007],
              [45.693210490000126, 35.879878235],
              [45.64685673000014, 35.933208313000065],
              [45.617039429000044, 35.95542918000011],
              [45.58985762600014, 35.95961497100005],
              [45.576938517000144, 35.96622955300005],
              [45.53998986800008, 35.9939797980001],
              [45.50142367600006, 36.005434777000104],
              [45.47927006000009, 36.01201487200008],
              [45.453121785000064, 36.011653137000096],
              [45.41994551600004, 35.99826894200005],
              [45.402168823000125, 35.99423818000007],
              [45.401962118000085, 35.99408315100003],
              [45.40185876500004, 35.99403147400001],
              [45.401548707000075, 35.9939797980001],
              [45.38180830900012, 35.982972718],
              [45.359587443000066, 35.97687489900004],
              [45.33809004700004, 35.979303691],
              [45.320520060000035, 35.9939797980001],
              [45.32031335400012, 35.99403147400001],
              [45.32021000200007, 35.994134827000025],
              [45.32021000200007, 35.994289856000066],
              [45.31369877100008, 36.010412903000045],
              [45.319589885000084, 36.031031800000065],
              [45.33188887600005, 36.05159902000004],
              [45.344187866000084, 36.06746368500005],
              [45.348321980000094, 36.08751414000001],
              [45.33560957900005, 36.10771962500009],
              [45.30460371900011, 36.140379130000056],
              [45.29953942900005, 36.16141143800009],
              [45.30201989800014, 36.2075584920001],
              [45.29736901800004, 36.226730449000044],
              [45.282796265000115, 36.23840932200001],
              [45.26419274900013, 36.25019154900009],
              [45.258508342000084, 36.26223215800006],
              [45.28269291200007, 36.27489288400001],
              [45.263934367000104, 36.294271546000076],
              [45.2570097250001, 36.311686503000104],
              [45.25447758000013, 36.35478464800012],
              [45.24961999600009, 36.377935690000115],
              [45.23887129800005, 36.40299875900003],
              [45.221301310000115, 36.42093048200009],
              [45.1959798580001, 36.42242909700009],
              [45.1399626060001, 36.40439402300011],
              [45.1108170980001, 36.402533671000086],
              [45.08373864800012, 36.41281728100007],
              [45.07226647900012, 36.423410950000076],
              [45.068545776000065, 36.43250600200004],
              [45.066892131000145, 36.442376201000016],
              [45.06208622300005, 36.45534698500005],
              [45.05407637500008, 36.464958801000066],
              [45.04549808700011, 36.47162506100007],
              [45.0390902100001, 36.47984161400011],
              [45.03816003400004, 36.49400095600005],
              [45.02534427900014, 36.50521474200009],
              [45.00952466600006, 36.516195910000064],
              [45.005913940000084, 36.518702291000054],
              [44.991392863000044, 36.53374013300005],
              [44.99340824400008, 36.54965647400006],
              [44.997852417000104, 36.55208526600002],
              [45.010254761000056, 36.556012676000094],
              [45.013251994000086, 36.5579247030001],
              [45.01418216900004, 36.57900868700004],
              [45.02487919100014, 36.61316680900002],
              [45.04430953000008, 36.649340312000064],
              [45.045911499000056, 36.668047181000034],
              [45.035266154000055, 36.68959625300009],
              [45.01097823100014, 36.725563050000076],
              [44.99619877100014, 36.74168609600004],
              [44.97945560700009, 36.74902415000004],
              [44.96643314600004, 36.749334209000025],
              [44.95475427200006, 36.75233144200003],
              [44.94441898600007, 36.758274231000044],
              [44.93522058100007, 36.767110901000066],
              [44.92271488400007, 36.77589589500003],
              [44.908245483000144, 36.77785959900008],
              [44.87723962400008, 36.7764643360001],
              [44.85119470200004, 36.781218567000096],
              [44.83124760000004, 36.791915589],
              [44.8233927820001, 36.809330547000016],
              [44.834141480000085, 36.83403188100003],
              [44.869643189000044, 36.86896514900003],
              [44.883440796000116, 36.886845195],
              [44.88881514500014, 36.91092641200002],
              [44.88406091300004, 36.93335398400002],
              [44.87486250800009, 36.94965789800004],
              [44.869178101000045, 36.967357076000056],
              [44.87475915600004, 36.99402211500011],
              [44.88571455900012, 37.00508087200011],
              [44.88736820500014, 37.01593292300005],
              [44.88075362200004, 37.024924622000086],
              [44.858946167000056, 37.03412302700009],
              [44.847577352000144, 37.044044901000106],
              [44.840601034000144, 37.04719716500004],
              [44.830937540000036, 37.04683542900007],
              [44.81119714400006, 37.0419261680001],
              [44.801895386000126, 37.04352813800007],
              [44.79729618300007, 37.04848907500009],
              [44.79223189300012, 37.06373362200004],
              [44.78835616100008, 37.07024485300012],
              [44.781121460000065, 37.07448232000006],
              [44.77362837700008, 37.07634267200008],
              [44.76654870600004, 37.07895233200007],
              [44.76065759300013, 37.085644429000084],
              [44.75269942200009, 37.10331777],
              [44.75254439300005, 37.11313629200008],
              [44.76613529500014, 37.14192006500009],
              [44.772336467000116, 37.161247051000046],
              [44.76613529500014, 37.17814524400005],
              [44.75673018400005, 37.195198466000065],
              [44.7535262450001, 37.21532643600004],
              [44.7605025630001, 37.2332323210001],
              [44.77295658300005, 37.241681417000095],
              [44.786754191000114, 37.24811513300004],
              [44.79848474100004, 37.26031077100005],
              [44.801585327000055, 37.29268605600005],
              [44.7789510500001, 37.31379587800008],
              [44.72138350400007, 37.34327728300009],
              [44.71301192300007, 37.35679067000008],
              [44.70712080900006, 37.370950013000126],
              [44.69802575700004, 37.38004506500009],
              [44.66164554900013, 37.37565256800009],
              [44.65224043800009, 37.38402415000006],
              [44.63818444800006, 37.41260121700013],
              [44.62278487200007, 37.421902975000066],
              [44.58557784000004, 37.4246676640001],
              [44.57214196800004, 37.430791321000086],
              [44.56594079600012, 37.447172750000036],
              [44.57927331600007, 37.47696421400012],
              [44.575242554000056, 37.493836568000106],
              [44.575242554000056, 37.49399159800005],
              [44.56991988100003, 37.514403788],
              [44.57183190900014, 37.53920847600004],
              [44.57834314000007, 37.563909811000045],
              [44.58743819100005, 37.58401194300011],
              [44.58351078300012, 37.601091004000054],
              [44.56097985800005, 37.61465606800003],
              [44.54087772600013, 37.63271698000004],
              [44.5452702230001, 37.663025208000064],
              [44.553538452000055, 37.67181020100007],
              [44.58816166200006, 37.6939793910001],
              [44.59839359500006, 37.70702768900013],
              [44.596119833000046, 37.71638112400008],
              [44.55937788900013, 37.75201202500007],
              [44.53441817200007, 37.76919443800004],
              [44.50646122300009, 37.77934885700007],
              [44.47922774300008, 37.776868388000096],
              [44.466515340000115, 37.77113230400006],
              [44.450495646000036, 37.76663645400002],
              [44.43643965600006, 37.76779917400005],
              [44.42910160300005, 37.779142152000034],
              [44.42977339700013, 37.78513661800007],
              [44.4337524820001, 37.8011046350001],
              [44.433029012000134, 37.80611724900005],
              [44.42548425300009, 37.81076812800002],
              [44.41897302300009, 37.80968292200002],
              [44.412100057000146, 37.807719218],
              [44.40440026900012, 37.80973459900004],
              [44.39323815900008, 37.821077576000036],
              [44.387553752000144, 37.83340240500006],
              [44.383833049000145, 37.84497792600011],
              [44.37794193600007, 37.8541246540001],
              [44.36714156100004, 37.860222473000064],
              [44.33122644100007, 37.8739684050001],
              [44.31923750800007, 37.87686228500009],
              [44.25443526200007, 37.87084198000004],
              [44.21960534600004, 37.87531199200005],
              [44.20208703600008, 37.8971711220001],
              [44.205006186000105, 37.904767947],
              [44.20637618000012, 37.90833323200003],
              [44.21671146700004, 37.91859100400002],
              [44.225496460000045, 37.92931386300005],
              [44.22466963700009, 37.94200042800007],
              [44.21965702300014, 37.95608225500011],
              [44.221465698000145, 37.96882049600008],
              [44.22756351700008, 37.98099029600006],
              [44.236038452000116, 37.99383188900005],
              [44.236141805000045, 37.99401275700011],
              [44.24539188600005, 38.00837880500002],
              [44.26952478100009, 38.030005391000074],
              [44.27830977400009, 38.04532745400006],
              [44.286578003000045, 38.066308085000045],
              [44.29587976100004, 38.0790204880001],
              [44.30900557400014, 38.08723704000003],
              [44.32828088400004, 38.09462677100005],
              [44.33381026200004, 38.100879618000036],
              [44.325697062000074, 38.11968984000005],
              [44.32709232500014, 38.12839731900003],
              [44.33536055500008, 38.13405588800005],
              [44.35313724800011, 38.13999867800008],
              [44.36057865400005, 38.147853496000025],
              [44.3670898850001, 38.16247792600008],
              [44.373239380000086, 38.18211497000003],
              [44.376701701000115, 38.201545309],
              [44.37241255700013, 38.24950103800002],
              [44.40057621200009, 38.27466746000006],
              [44.43674971500013, 38.2969400030001],
              [44.459177287000045, 38.322416484000044],
              [44.458763876000035, 38.33833282500005],
              [44.45111576300013, 38.35404246100005],
              [44.43881677200011, 38.367555847000105],
              [44.42465743000014, 38.37703847200008],
              [44.40905114700007, 38.38179270400006],
              [44.39633874500004, 38.379673971],
              [44.3633691820001, 38.36461029100009],
              [44.3133980720001, 38.37181915400005],
              [44.298670288000096, 38.377193502000026],
              [44.289523560000134, 38.38225779200009],
              [44.286578003000045, 38.39099111000006],
              [44.28988529500003, 38.407372539000036],
              [44.29050541200007, 38.416596781000024],
              [44.287404826000056, 38.44194407200011],
              [44.2875081790001, 38.453726298000035],
              [44.300168905000135, 38.49403391500006],
              [44.301357462000055, 38.51119049100002],
              [44.29215905800004, 38.56204010100005],
              [44.2968099360001, 38.60162424800011],
              [44.29701664300006, 38.622320659000124],
              [44.28988529500003, 38.63888295500003],
              [44.282547242000135, 38.645394185],
              [44.27489912900006, 38.64937327100007],
              [44.25681237800012, 38.65392079700011],
              [44.24430668200006, 38.65895924900009],
              [44.247407267000085, 38.66508290600005],
              [44.25608890800004, 38.671955871000094],
              [44.26048140500012, 38.6792422490001],
              [44.255468791000055, 38.697277323],
              [44.250507853000045, 38.70921458000005],
              [44.24864750100011, 38.72182362900007],
              [44.25267826400011, 38.74182240800009],
              [44.279808391000074, 38.81422109000006],
              [44.275002482000104, 38.84357330300004],
              [44.221982462000085, 38.86344289200004],
              [44.20575606300008, 38.87566436800007],
              [44.19211348500005, 38.89075388600007],
              [44.18250166900003, 38.91312978100005],
              [44.17816084800006, 38.920700379],
              [44.17485355600007, 38.92837432900008],
              [44.175370321000116, 38.93669423500005],
              [44.174646851000034, 38.94576344800002],
              [44.16710209200005, 38.95199045800008],
              [44.1580070390001, 38.95746816100008],
              [44.15196089700004, 38.964625346000034],
              [44.1477751060001, 38.98005076100013],
              [44.14467452000008, 38.98682037400006],
              [44.13919681800007, 38.99377085400006],
              [44.13919681800007, 38.9939517210001],
              [44.153356160000044, 39.01255523700006],
              [44.16953088400004, 39.0230455530001],
              [44.17914270000006, 39.03493113200004],
              [44.16989261900011, 39.074360250000055],
              [44.174956909000116, 39.090224915000064],
              [44.194800659000066, 39.1205331420001],
              [44.18663578300004, 39.14513112500008],
              [44.148085164000065, 39.16644765200006],
              [44.10354008000007, 39.18463775700012],
              [44.07770186400006, 39.2000631720001],
              [44.076564982000036, 39.208693136000036],
              [44.08348962400004, 39.22683156400008],
              [44.08266280100014, 39.23566823400007],
              [44.070570516000146, 39.25548614500006],
              [44.067159872000104, 39.26401275700009],
              [44.066746460000104, 39.2729527800001],
              [44.06922692900008, 39.279567362000094],
              [44.06943363500011, 39.287008769000025],
              [44.05765140800014, 39.3068008420001],
              [44.05176029500012, 39.328039857000064],
              [44.04739541400011, 39.33751363000003],
              [44.047212768000065, 39.33791005500005],
              [44.02096114100004, 39.36199127200008],
              [44.01486332200011, 39.37408355700008],
              [44.02602543200004, 39.38617584200007],
              [44.04638594600004, 39.39604604100005],
              [44.06137211100014, 39.4002835080001],
              [44.07697839400009, 39.40059356700009],
              [44.0991992590001, 39.398474833000094],
              [44.1222469490001, 39.400438538000046],
              [44.176507203000085, 39.41154897100007],
              [44.200433390000114, 39.40948191300002],
              [44.26952478100009, 39.38286855100007],
              [44.2949495850001, 39.38121490500002],
              [44.316963745000066, 39.38529734300003],
              [44.36874353000013, 39.40359080000009],
              [44.3879671630001, 39.41449452800008],
              [44.40481368000013, 39.43438995400008],
              [44.40522709100014, 39.452476705],
              [44.401713094000115, 39.471338603],
              [44.406674031000136, 39.493662821000086],
              [44.40682906100011, 39.493714498000074],
              [44.41680261200008, 39.50554840100001],
              [44.417422729000066, 39.51748565700005],
              [44.41401208500014, 39.53035308900006],
              [44.412048381000034, 39.54446075500009],
              [44.41401208500014, 39.560893860000036],
              [44.41855961100009, 39.574329733000084],
              [44.45168420400006, 39.625851136000094],
              [44.45762699400012, 39.63871856700008],
              [44.45825019400007, 39.64252008900003],
              [44.460210816000085, 39.65447987900008],
              [44.45504317300009, 39.68713938400005],
              [44.45948734500013, 39.69845652300002],
              [44.56573409000009, 39.765894267000036],
              [44.59043542500007, 39.771526998000084],
              [44.60583500200005, 39.76315541600009],
              [44.632810099000096, 39.73163279200013],
              [44.646504354000115, 39.71954050700005],
              [44.70629398600005, 39.6980431110001],
              [44.725724325000044, 39.68533070900004],
              [44.80699282900008, 39.639901712000025],
            ],
          ],
          [
            [
              [54.526377800000034, 26.30963776200008],
              [54.533213738000086, 26.306789455000057],
              [54.53891035200007, 26.30272044500009],
              [54.543711785000085, 26.297349351000037],
              [54.54737389400003, 26.29043203300006],
              [54.526377800000034, 26.25193919500009],
              [54.52100670700008, 26.25096263200004],
              [54.50928795700008, 26.25421784100007],
              [54.49756920700008, 26.259711005000042],
              [54.492198113000086, 26.265570380000042],
              [54.490896030000044, 26.27871328300006],
              [54.48853600400008, 26.288723049000055],
              [54.48812910200007, 26.298041083000044],
              [54.492198113000086, 26.30963776200008],
              [54.498383009000065, 26.31736888200004],
              [54.506846550000034, 26.321234442000048],
              [54.51644941500007, 26.31940338700008],
              [54.526377800000034, 26.30963776200008],
            ],
          ],
          [
            [
              [54.03687584700003, 26.488430080000057],
              [53.96306399800005, 26.49217357000009],
              [53.955414259000065, 26.492580471000053],
              [53.92310631600009, 26.50653717700004],
              [53.90284264400003, 26.53620026200008],
              [53.912852410000085, 26.55019765800006],
              [53.92758222700007, 26.56012604400007],
              [53.94548587300005, 26.56509023600006],
              [53.964854363000086, 26.564113674000055],
              [53.98170006600009, 26.55890534100007],
              [54.01880944100009, 26.555568752000056],
              [54.03305097700007, 26.550441799000055],
              [54.03492272200003, 26.546128648000035],
              [54.035817905000044, 26.54401276200008],
              [54.035817905000044, 26.543890692000048],
              [54.03541100400008, 26.534857489000046],
              [54.03557376400005, 26.533718166000085],
              [54.03646894600007, 26.52676015800006],
              [54.03663170700008, 26.526678778000075],
              [54.043711785000085, 26.523179429000038],
              [54.047943556000064, 26.51976146000004],
              [54.05046634200005, 26.51776764500005],
              [54.05136152400007, 26.51203034100007],
              [54.05241946700005, 26.505804755000042],
              [54.05014082100007, 26.499823309000078],
              [54.04802493600005, 26.493841864000046],
              [54.03687584700003, 26.488430080000057],
            ],
          ],
          [
            [
              [53.317149285000085, 26.799994208000044],
              [53.29908287900008, 26.790716864000046],
              [53.27979576900003, 26.790676174000055],
              [53.22282962300005, 26.79954661700009],
              [53.20525149800005, 26.80621979400007],
              [53.203135613000086, 26.807440497000073],
              [53.189789259000065, 26.81517161700009],
              [53.15845787900008, 26.83856842700004],
              [53.149424675000034, 26.84788646000004],
              [53.153330925000034, 26.85219961100006],
              [53.160492384000065, 26.85370514500005],
              [53.16846764400003, 26.856350002000056],
              [53.178070509000065, 26.85687897300005],
              [53.262461785000085, 26.833644924000055],
              [53.33741295700008, 26.828680731000077],
              [53.36068769600007, 26.82050202000005],
              [53.373789910000085, 26.809800523000035],
              [53.38200931100005, 26.803127346000053],
              [53.367523634000065, 26.799627997000073],
              [53.329112175000034, 26.802557684000078],
              [53.317149285000085, 26.799994208000044],
            ],
          ],
          [
            [
              [56.322276238000086, 26.834418036000045],
              [56.326833530000044, 26.861070054000038],
              [56.34115644600007, 26.879339911000045],
              [56.36654707100007, 26.889797268000052],
              [56.40414472700007, 26.893052476000037],
              [56.409190300000034, 26.862250067000048],
              [56.37916100400008, 26.838690497000073],
              [56.34099368600005, 26.82762278900009],
              [56.322276238000086, 26.834418036000045],
            ],
          ],
          [
            [
              [56.21241295700008, 27.00299713700008],
              [56.23210696700005, 26.99876536700009],
              [56.25766035200007, 26.988714911000045],
              [56.27361087300005, 26.977769273000035],
              [56.27947024800005, 26.973822333000044],
              [56.287445509000065, 26.955145575000074],
              [56.27133222700007, 26.946966864000046],
              [56.25521894600007, 26.938788153000075],
              [56.19353274800005, 26.92454661700009],
              [56.17139733200008, 26.906805731000077],
              [56.14869225400008, 26.86200592700004],
              [56.13721764400003, 26.844671942000048],
              [56.09587649800005, 26.80687083500004],
              [56.08936608200008, 26.793524481000077],
              [56.080821160000085, 26.78534577000005],
              [56.04281660200007, 26.768133856000077],
              [56.034190300000034, 26.759019273000035],
              [56.02564537900008, 26.75409577000005],
              [55.97641035200007, 26.71157461100006],
              [55.94703209700003, 26.69627513200004],
              [55.92400149800005, 26.705023505000042],
              [55.90219160200007, 26.72483958500004],
              [55.87663821700005, 26.74290599200009],
              [55.80982506600009, 26.712062893000052],
              [55.79127037900008, 26.69790273600006],
              [55.77271569100009, 26.688381252000056],
              [55.75131269600007, 26.68854401200008],
              [55.705821160000085, 26.694525458000044],
              [55.685557488000086, 26.69049713700008],
              [55.66423587300005, 26.68154531500005],
              [55.610362175000034, 26.646918036000045],
              [55.55445397200003, 26.62563711100006],
              [55.520518425000034, 26.603257554000038],
              [55.502940300000034, 26.594875393000052],
              [55.44117272200003, 26.58860911700009],
              [55.39730879000007, 26.577826239000046],
              [55.37875410200007, 26.567287502000056],
              [55.36955813900005, 26.564113674000055],
              [55.369476759000065, 26.564113674000055],
              [55.36654707100007, 26.564601955000057],
              [55.36109459700003, 26.565619208000044],
              [55.34978274800005, 26.56899648600006],
              [55.33961022200003, 26.56899648600006],
              [55.33529707100007, 26.56045156500005],
              [55.330739780000044, 26.553615627000056],
              [55.31983483200008, 26.54828522300005],
              [55.307627800000034, 26.54490794500009],
              [55.29843183700007, 26.54364655200004],
              [55.29835045700008, 26.54364655200004],
              [55.29411868600005, 26.54629140800006],
              [55.29053795700008, 26.548488674000055],
              [55.28541100400008, 26.55996328300006],
              [55.28060957100007, 26.58466217700004],
              [55.28736412900008, 26.60228099200009],
              [55.28923587300005, 26.61359284100007],
              [55.28402754000007, 26.618801174000055],
              [55.273773634000065, 26.64980703300006],
              [55.28467858200008, 26.660223700000074],
              [55.33187910200007, 26.645331122000073],
              [55.342784050000034, 26.64980703300006],
              [55.34896894600007, 26.648220119000086],
              [55.351898634000065, 26.64744700700004],
              [55.35198001400005, 26.647487697000088],
              [55.40479576900003, 26.67401764500005],
              [55.53842207100007, 26.712958075000074],
              [55.55787194100009, 26.714992580000057],
              [55.57048587300005, 26.71938711100006],
              [55.57406660200007, 26.720648505000042],
              [55.574229363000086, 26.72068919500009],
              [55.62045332100007, 26.74607982000009],
              [55.64039147200003, 26.760565497000073],
              [55.705821160000085, 26.783270575000074],
              [55.71607506600009, 26.78392161700009],
              [55.73682701900003, 26.782416083000044],
              [55.746836785000085, 26.783270575000074],
              [55.75416100400008, 26.786078192000048],
              [55.76449629000007, 26.793890692000048],
              [55.774180535000085, 26.796942450000074],
              [55.77116946700005, 26.803656317000048],
              [55.76677493600005, 26.81053294500009],
              [55.78207441500007, 26.82615794500009],
              [55.78565514400003, 26.844956773000035],
              [55.78101647200003, 26.88963450700004],
              [55.77320397200003, 26.906724351000037],
              [55.75611412900008, 26.92133209800005],
              [55.73943118600005, 26.932928778000075],
              [55.73259524800005, 26.94090403900009],
              [55.75798587300005, 26.954046942000048],
              [55.89771569100009, 26.906805731000077],
              [55.935557488000086, 26.91478099200009],
              [56.041026238000086, 26.97565338700008],
              [56.17318769600007, 27.002346096000053],
              [56.21241295700008, 27.00299713700008],
            ],
          ],
          [
            [
              [56.472992384000065, 27.106024481000077],
              [56.48357181100005, 27.099758205000057],
              [56.495127800000034, 27.095770575000074],
              [56.504649285000085, 27.08893463700008],
              [56.50513756600009, 27.08698151200008],
              [56.508474155000044, 27.074367580000057],
              [56.50473066500007, 27.061672268000052],
              [56.49529056100005, 27.05231354400007],
              [56.48812910200007, 27.04913971600007],
              [56.48178144600007, 27.04633209800005],
              [56.46615644600007, 27.04393138200004],
              [56.434580925000034, 27.054836330000057],
              [56.43685957100007, 27.080023505000042],
              [56.455414259000065, 27.102769273000035],
              [56.472992384000065, 27.106024481000077],
            ],
          ],
          [
            [
              [50.305817485000034, 29.271275468000056],
              [50.323841402000085, 29.26417686800005],
              [50.33465062100004, 29.25866085800004],
              [50.33011126700006, 29.241368485000066],
              [50.333018425000034, 29.22402578300006],
              [50.32642662900008, 29.208929755000042],
              [50.316530654000076, 29.20757212400008],
              [50.30662970700007, 29.21544575000007],
              [50.29674842700007, 29.23747338000004],
              [50.29046626400009, 29.25713773700005],
              [50.28326707800005, 29.26893936600004],
              [50.295000712000046, 29.275218408000057],
              [50.305817485000034, 29.271275468000056],
            ],
          ],
          [
            [
              [54.54656009200005, 25.92649974200009],
              [54.55160566500007, 25.917710679000038],
              [54.55323326900003, 25.89984772300005],
              [54.54322350400008, 25.893052476000037],
              [54.529633009000065, 25.89598216400009],
              [54.513682488000086, 25.90265534100007],
              [54.509776238000086, 25.913763739000046],
              [54.52279707100007, 25.92011139500005],
              [54.54656009200005, 25.92649974200009],
            ],
          ],
          [
            [
              [55.89429772200003, 26.679429429000038],
              [55.90202884200005, 26.668850002000056],
              [55.90398196700005, 26.64524974200009],
              [55.889659050000034, 26.62376536700009],
              [55.86931399800005, 26.613023179000038],
              [55.85320071700005, 26.621039130000042],
              [55.855479363000086, 26.64411041900007],
              [55.86833743600005, 26.666449286000045],
              [55.88453209700003, 26.677679755000042],
              [55.89429772200003, 26.679429429000038],
            ],
          ],
          [
            [
              [53.639414910000085, 26.688788153000075],
              [53.65121504000007, 26.68382396000004],
              [53.659190300000034, 26.668850002000056],
              [53.64625084700003, 26.657171942000048],
              [53.62867272200003, 26.659328518000052],
              [53.61117597700007, 26.667303778000075],
              [53.60124759200005, 26.67959219000005],
              [53.60922285200007, 26.69049713700008],
              [53.62916100400008, 26.691107489000046],
              [53.639414910000085, 26.688788153000075],
            ],
          ],
          [
            [
              [55.04867597700019, 25.885768947000088],
              [55.04989668100012, 25.876084703000174],
              [55.05437259200016, 25.86461009300001],
              [55.04647871200001, 25.85838450700004],
              [55.03825931100005, 25.857733466000127],
              [55.032644076000054, 25.854641018000052],
              [55.02304121200007, 25.862860419000015],
              [55.018402540000125, 25.859605210000097],
              [55.01897220100011, 25.86574941600003],
              [55.015635613000086, 25.871852932000024],
              [55.01205488400018, 25.88161855700008],
              [55.02645918100012, 25.888739325000017],
              [55.04371178500014, 25.892889716000184],
              [55.04867597700019, 25.885768947000088],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Qatar',
        iso3: 'QAT',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [50.80787194100009, 24.746649481000077],
            [50.82667076900003, 24.74868398600006],
            [50.85279381600009, 24.770005601000037],
            [50.85962975400008, 24.79559967700004],
            [50.85108483200008, 24.89081452000005],
            [50.842784050000034, 24.916083075000074],
            [50.79997806100005, 24.988755601000037],
            [50.79664147200003, 25.003607489000046],
            [50.807383660000085, 25.031642971000053],
            [50.80974368600005, 25.051214911000045],
            [50.808604363000086, 25.069159247000073],
            [50.80241946700005, 25.076971747000073],
            [50.775726759000065, 25.091864325000074],
            [50.76840254000007, 25.125799872000073],
            [50.76693769600007, 25.162583726000037],
            [50.757823113000086, 25.18622467700004],
            [50.76498457100007, 25.204291083000044],
            [50.76343834700003, 25.22528717700004],
            [50.75904381600009, 25.24750397300005],
            [50.757823113000086, 25.269354559000078],
            [50.76579837300005, 25.323553778000075],
            [50.76514733200008, 25.34446849200009],
            [50.750987175000034, 25.419623114000046],
            [50.762461785000085, 25.462713934000078],
            [50.76384524800005, 25.48240794500009],
            [50.750987175000034, 25.494696356000077],
            [50.778005405000044, 25.527044989000046],
            [50.79709279414772, 25.529896327302865],
            [50.80848396792361, 25.51723946755188],
            [50.811648182861354, 25.49888702091296],
            [50.82050798468704, 25.491292905062373],
            [50.82048587300005, 25.471828518000052],
            [50.84717858200008, 25.467352606000077],
            [50.83130944100009, 25.50779857000009],
            [50.82789147200003, 25.525051174000055],
            [50.82667076900003, 25.543117580000057],
            [50.82862389400003, 25.554348049000055],
            [50.83220462300005, 25.566148179000038],
            [50.83285566500007, 25.578517971000053],
            [50.82667076900003, 25.59088776200008],
            [50.81853274800005, 25.595770575000074],
            [50.79656009200005, 25.59959544500009],
            [50.78500410200007, 25.60455963700008],
            [50.79639733200008, 25.617254950000074],
            [50.809580925000034, 25.62059153900009],
            [50.82349694100009, 25.62213776200008],
            [50.836924675000034, 25.62881094000005],
            [50.840179884000065, 25.634507554000038],
            [50.84652754000007, 25.64984772300005],
            [50.850596550000034, 25.65298086100006],
            [50.85718834700003, 25.650824286000045],
            [50.86353600400008, 25.641424872000073],
            [50.87094160200007, 25.63930898600006],
            [50.87614993600005, 25.631781317000048],
            [50.87427819100009, 25.614935614000046],
            [50.86768639400003, 25.587836005000042],
            [50.86768639400003, 25.56704336100006],
            [50.86866295700008, 25.55955638200004],
            [50.87671959700003, 25.54059479400007],
            [50.881521030000044, 25.53514232000009],
            [50.888682488000086, 25.52948639500005],
            [50.89869225400008, 25.53221263200004],
            [50.900726759000065, 25.534857489000046],
            [50.90007571700005, 25.53974030200004],
            [50.90414472700007, 25.56313711100006],
            [50.90479576900003, 25.587062893000052],
            [50.909190300000034, 25.597723700000074],
            [50.920583530000044, 25.608343817000048],
            [50.92750084700003, 25.605169989000046],
            [50.93572024800005, 25.59833405200004],
            [50.949554884000065, 25.597723700000074],
            [50.95590254000007, 25.604681708000044],
            [50.96989993600005, 25.63385651200008],
            [50.977549675000034, 25.646144924000055],
            [50.949880405000044, 25.636460679000038],
            [50.92432701900003, 25.63231028900009],
            [50.90316816500007, 25.64012278900009],
            [50.888682488000086, 25.66665273600006],
            [50.88754316500007, 25.680894273000035],
            [50.894867384000065, 25.72809479400007],
            [50.89730879000007, 25.732570705000057],
            [50.906993035000085, 25.739935614000046],
            [50.909190300000034, 25.74510325700004],
            [50.90796959700003, 25.749253648000035],
            [50.90284264400003, 25.75527578300006],
            [50.90170332100007, 25.759466864000046],
            [50.90170332100007, 25.789536851000037],
            [50.91553795700008, 25.786444403000075],
            [50.920258009000065, 25.79437897300005],
            [50.92359459700003, 25.805161851000037],
            [50.93287194100009, 25.810614325000074],
            [50.93970787900008, 25.807196356000077],
            [50.94556725400008, 25.798488674000055],
            [50.949229363000086, 25.78701406500005],
            [50.949554884000065, 25.77529531500005],
            [50.96371504000007, 25.78388092700004],
            [50.972992384000065, 25.79751211100006],
            [50.97592207100007, 25.813788153000075],
            [50.970713738000086, 25.830511786000045],
            [50.963877800000034, 25.82367584800005],
            [50.94939212300005, 25.837958075000074],
            [50.951182488000086, 25.85927969000005],
            [50.977305535000085, 25.916449286000045],
            [50.981455925000034, 25.93585846600007],
            [50.98422285200007, 25.981350002000056],
            [50.992523634000065, 25.975734768000052],
            [50.99561608200008, 25.97284577000005],
            [50.99854576900003, 25.96702708500004],
            [51.00473066500007, 25.96702708500004],
            [51.027354363000086, 26.02692291900007],
            [51.04737389400003, 26.05304596600007],
            [51.07593834700003, 26.06391022300005],
            [51.09107506600009, 26.066961981000077],
            [51.133148634000065, 26.082098700000074],
            [51.14185631600009, 26.08779531500005],
            [51.147227410000085, 26.10309479400007],
            [51.170583530000044, 26.12457916900007],
            [51.176117384000065, 26.139593817000048],
            [51.194346550000034, 26.13353099200009],
            [51.214854363000086, 26.13934967700004],
            [51.25123131600009, 26.160101630000042],
            [51.330739780000044, 26.121161200000074],
            [51.34685306100005, 26.10488515800006],
            [51.34848066500007, 26.085638739000046],
            [51.346364780000044, 26.060695705000057],
            [51.34717858200008, 26.039007880000042],
            [51.35767662900008, 26.029730536000045],
            [51.37663821700005, 26.02289459800005],
            [51.38249759200005, 26.00617096600007],
            [51.383474155000044, 25.985581773000035],
            [51.38843834700003, 25.96702708500004],
            [51.40398196700005, 25.95408763200004],
            [51.41651451900003, 25.952093817000048],
            [51.42432701900003, 25.950873114000046],
            [51.467539910000085, 25.954046942000048],
            [51.49195397200003, 25.95189036700009],
            [51.51197350400008, 25.946112372000073],
            [51.52947024800005, 25.937323309000078],
            [51.54607181100005, 25.92609284100007],
            [51.55941816500007, 25.913763739000046],
            [51.570323113000086, 25.898382880000042],
            [51.57748457100007, 25.88084544500009],
            [51.594737175000034, 25.771877346000053],
            [51.594493035000085, 25.758246161000045],
            [51.59156334700003, 25.746649481000077],
            [51.58350670700008, 25.74176666900007],
            [51.57764733200008, 25.745062567000048],
            [51.57203209700003, 25.759507554000038],
            [51.56332441500007, 25.762884833000044],
            [51.555430535000085, 25.758693752000056],
            [51.54835045700008, 25.748846747000073],
            [51.54460696700005, 25.73737213700008],
            [51.54607181100005, 25.72809479400007],
            [51.555023634000065, 25.720648505000042],
            [51.56364993600005, 25.721625067000048],
            [51.570323113000086, 25.727484442000048],
            [51.57398522200003, 25.734930731000077],
            [51.59009850400008, 25.71190013200004],
            [51.576833530000044, 25.688666083000044],
            [51.55681399800005, 25.68162669500009],
            [51.55290774800005, 25.707586981000077],
            [51.53931725400008, 25.703924872000073],
            [51.50513756600009, 25.687160549000055],
            [51.51970462300005, 25.681708075000074],
            [51.53492272200003, 25.67324453300006],
            [51.54712975400008, 25.66315338700008],
            [51.55290774800005, 25.65298086100006],
            [51.549489780000044, 25.63117096600007],
            [51.535899285000085, 25.622381903000075],
            [51.51880944100009, 25.61871979400007],
            [51.50513756600009, 25.61200592700004],
            [51.49830162900008, 25.61591217700004],
            [51.49138431100005, 25.61823151200008],
            [51.49366295700008, 25.56582265800006],
            [51.49154707100007, 25.55064524900007],
            [51.49138431100005, 25.549302476000037],
            [51.48585045700008, 25.54051341400009],
            [51.477549675000034, 25.531073309000078],
            [51.47193444100009, 25.52138906500005],
            [51.47429446700005, 25.512111721000053],
            [51.51099694100009, 25.454291083000044],
            [51.51693769600007, 25.44017161700009],
            [51.51880944100009, 25.426214911000045],
            [51.51571699300007, 25.382839260000083],
            [51.51197350400008, 25.330226955000057],
            [51.51319420700008, 25.308254299000055],
            [51.51880944100009, 25.29706452000005],
            [51.531260613000086, 25.292181708000044],
            [51.59001712300005, 25.283758856000077],
            [51.59913170700008, 25.27488841400009],
            [51.60759524800005, 25.255113023000035],
            [51.61109459700003, 25.237534898000035],
            [51.61459394600007, 25.21979401200008],
            [51.61654707100007, 25.137193101000037],
            [51.60572350400008, 25.03424713700008],
            [51.61101321700005, 25.022365627000056],
            [51.602305535000085, 25.013820705000057],
            [51.586924675000034, 24.95343659100007],
            [51.57406660200007, 24.934393622000073],
            [51.539398634000065, 24.898871161000045],
            [51.52881920700008, 24.87441640800006],
            [51.52084394600007, 24.87059153900009],
            [51.511729363000086, 24.86786530200004],
            [51.50513756600009, 24.864081122000073],
            [51.50025475400008, 24.85537344000005],
            [51.47421308700007, 24.764471747000073],
            [51.47282962300005, 24.759426174000055],
            [51.467539910000085, 24.74868398600006],
            [51.455821160000085, 24.740668036000045],
            [51.45036868600005, 24.72166575700004],
            [51.44361412900008, 24.679754950000074],
            [51.430430535000085, 24.664496161000045],
            [51.38998457100007, 24.64248281500005],
            [51.381521030000044, 24.63507721600007],
            [51.37614993600005, 24.611883856000077],
            [51.36353600400008, 24.59634023600006],
            [51.34978274800005, 24.583807684000078],
            [51.340586785000085, 24.56989166900007],
            [51.32894941500007, 24.584784247000073],
            [51.332692905000044, 24.598863023000035],
            [51.34164472700007, 24.61469147300005],
            [51.34685306100005, 24.63507721600007],
            [51.33912194100009, 24.646185614000046],
            [51.32113691500007, 24.648179429000038],
            [51.28598066500007, 24.645005601000037],
            [51.28443444100009, 24.662502346000053],
            [51.278086785000085, 24.662990627000056],
            [51.267914259000065, 24.656195380000042],
            [51.254567905000044, 24.65180084800005],
            [51.236989780000044, 24.650051174000055],
            [51.22095787900008, 24.644232489000046],
            [51.21257571700005, 24.633693752000056],
            [51.214854363000086, 24.62718333500004],
            [51.21525829500007, 24.625850361000076],
            [51.14745121300007, 24.57627878900003],
            [51.095464722000145, 24.560181580000048],
            [51.03887902800005, 24.559871521000062],
            [50.97888269100008, 24.567726339],
            [50.92860152200012, 24.587208354],
            [50.881007528000055, 24.63640431800006],
            [50.80787194100009, 24.746649481000077],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Saudi Arabia',
        iso3: 'SAU',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [50.80787194100009, 24.746649481000077],
              [50.881007528000055, 24.63640431800006],
              [50.92860152200012, 24.587208354],
              [50.97888269100008, 24.567726339],
              [51.03887902800005, 24.559871521000062],
              [51.095464722000145, 24.560181580000048],
              [51.14745121300007, 24.57627878900003],
              [51.21525829500007, 24.625850361000076],
              [51.21762129000007, 24.617661851000037],
              [51.26880944100009, 24.62449778900009],
              [51.27816816500007, 24.618882554000038],
              [51.28638756600009, 24.60838450700004],
              [51.29517662900008, 24.60260651200008],
              [51.30640709700003, 24.61082591400009],
              [51.30746504000007, 24.60309479400007],
              [51.30632571700005, 24.59406159100007],
              [51.30241946700005, 24.58661530200004],
              [51.295909050000034, 24.58356354400007],
              [51.29029381600009, 24.578517971000053],
              [51.29224694100009, 24.56781647300005],
              [51.296885613000086, 24.55809153900009],
              [51.299571160000085, 24.55621979400007],
              [51.29656009200005, 24.521918036000045],
              [51.30241946700005, 24.51715729400007],
              [51.32007897200003, 24.522691148000035],
              [51.33366946700005, 24.532049872000073],
              [51.36109459700003, 24.576117255000042],
              [51.37517337300005, 24.589097398000035],
              [51.38795006600009, 24.59707265800006],
              [51.39584394600007, 24.608343817000048],
              [51.395274285000085, 24.631333726000037],
              [51.41000410200007, 24.624335028000075],
              [51.428396030000044, 24.622870184000078],
              [51.44385826900003, 24.619696356000077],
              [51.45045006600009, 24.60740794500009],
              [51.45533287900008, 24.594183661000045],
              [51.467539910000085, 24.592352606000077],
              [51.483083530000044, 24.592189846000053],
              [51.49830162900008, 24.58356354400007],
              [51.49830162900008, 24.576117255000042],
              [51.48210696700005, 24.569240627000056],
              [51.46143639400003, 24.56346263200004],
              [51.443695509000065, 24.554754950000074],
              [51.436208530000044, 24.538804429000038],
              [51.432302280000044, 24.538763739000046],
              [51.40951582100007, 24.51585521000004],
              [51.40479576900003, 24.507757880000042],
              [51.39975019600007, 24.494574286000045],
              [51.395274285000085, 24.487941799000055],
              [51.33619225400008, 24.44794342700004],
              [51.326914910000085, 24.436102606000077],
              [51.324229363000086, 24.431301174000055],
              [51.31137129000007, 24.414862372000073],
              [51.30640709700003, 24.405991929000038],
              [51.30437259200005, 24.396185614000046],
              [51.30225670700008, 24.37400950700004],
              [51.299571160000085, 24.364447333000044],
              [51.29908287900008, 24.358710028000075],
              [51.29997806100005, 24.351996161000045],
              [51.29965254000007, 24.34634023600006],
              [51.295909050000034, 24.34393952000005],
              [51.285166863000086, 24.34446849200009],
              [51.28044681100005, 24.343573309000078],
              [51.27857506600009, 24.34052155200004],
              [51.27784264400003, 24.31899648600006],
              [51.27881920700008, 24.307766018000052],
              [51.282237175000034, 24.30296458500004],
              [51.34498131600009, 24.297796942000048],
              [51.367849155000044, 24.30296458500004],
              [51.38013756600009, 24.30996328300006],
              [51.38851972700007, 24.316555080000057],
              [51.39779707100007, 24.321519273000035],
              [51.412852410000085, 24.323472398000035],
              [51.47901451900003, 24.31085846600007],
              [51.49691816500007, 24.29828522300005],
              [51.526133660000085, 24.26825592700004],
              [51.569346550000034, 24.256170966000113],
              [51.575538778000066, 24.217721863000108],
              [51.57522871900011, 24.191935324],
              [51.57316166200013, 24.127830709000065],
              [51.5785360110001, 24.1018374640001],
              [51.59352217700007, 24.07832468700012],
              [51.650469605000126, 24.010602723000105],
              [51.7025594480001, 23.94859100300006],
              [51.75475264500005, 23.886553446000036],
              [51.80684248900013, 23.82449005100007],
              [51.85903568500004, 23.76253000900003],
              [51.9112288820001, 23.700518290000062],
              [51.963422078000065, 23.638558248000052],
              [52.01551192300013, 23.576494853000085],
              [52.067705119000095, 23.51448313400003],
              [52.11979496300006, 23.452523092],
              [52.171988159000136, 23.390485535000025],
              [52.2240780030001, 23.328422140000058],
              [52.27627120000005, 23.26641042100003],
              [52.32830936600004, 23.20445037800009],
              [52.380502564000096, 23.142412822000026],
              [52.43264408400006, 23.080375265000086],
              [52.48483728100007, 23.018337708000033],
              [52.53847741700014, 22.954749858000056],
              [52.55847619600007, 22.93857513400006],
              [52.58307417800006, 22.93110789000012],
              [52.743787883000095, 22.911341654000054],
              [52.88279748500008, 22.894236756000097],
              [53.02180708900005, 22.877131857000066],
              [53.160920044000136, 22.860052796],
              [53.29992964700011, 22.842973735000058],
              [53.43893925000009, 22.825868835000037],
              [53.57805220600005, 22.80876393700008],
              [53.71706180800004, 22.791684876000133],
              [53.85607141100013, 22.774579977000073],
              [53.995287720000135, 22.757449240000128],
              [54.13429732200012, 22.74031850200008],
              [54.27330692600009, 22.723265279000046],
              [54.41241988100006, 22.7061603800001],
              [54.55132613100011, 22.68900380500004],
              [54.69033573400009, 22.671950582000093],
              [54.829448690000106, 22.654897360000078],
              [54.96856164600007, 22.637740784000115],
              [55.10529748500005, 22.620945943000052],
              [55.120387004000065, 22.623426412000114],
              [55.1868428950001, 22.703576559000098],
              [55.250404907000075, 22.605494690000043],
              [55.3311234950001, 22.48059275400003],
              [55.41204878800011, 22.35569081700008],
              [55.49276737500014, 22.230788880000134],
              [55.573589315000106, 22.1059386190001],
              [55.62671268700012, 22.0237730920001],
              [55.63704797300011, 22.001913961000056],
              [55.63756473800004, 21.978969625000033],
              [55.60017139700011, 21.866059974000038],
              [55.595190064000064, 21.851018779000057],
              [55.58857548000003, 21.831226705000077],
              [55.570075318000136, 21.775416158000027],
              [55.541239868000105, 21.68865142800003],
              [55.50382613100004, 21.57615183600008],
              [55.45959110500013, 21.443033346],
              [55.410188436000055, 21.29446360300004],
              [55.35747847500005, 21.13555857300007],
              [55.344623599000045, 21.096908734000053],
              [55.30290816200005, 20.971485901000065],
              [55.2483378500001, 20.8074132280001],
              [55.19552453600005, 20.648559875000032],
              [55.146225219000144, 20.499990133000054],
              [55.10188684100012, 20.366845805000096],
              [55.06447310400006, 20.254268697],
              [55.03574100800006, 20.167555644000046],
              [55.017137492000074, 20.11174509700008],
              [55.01052290900009, 20.092004700000118],
              [54.97838016800006, 19.995421448000073],
              [54.82789839600008, 19.94526947100006],
              [54.65674605300006, 19.888192851000028],
              [54.485593710000046, 19.83119374600004],
              [54.314648072000125, 19.77419464100005],
              [54.14349572800012, 19.717143860000064],
              [53.97224003100007, 19.660118917000077],
              [53.80108768700006, 19.60306813600006],
              [53.6300386960001, 19.545991516000058],
              [53.45888635300008, 19.48899241100007],
              [53.28783736200012, 19.431941630000082],
              [53.11658166500007, 19.374916687000066],
              [52.945532674000106, 19.31786590600008],
              [52.77438033000004, 19.260789286000076],
              [52.60312463300011, 19.203790181000088],
              [52.43212731900013, 19.14673940100009],
              [52.26107832800005, 19.089688620000075],
              [52.08992598400005, 19.03263783800007],
              [51.97861495000012, 18.99563751300012],
              [51.82069177300008, 18.97437266100006],
              [51.66049483200004, 18.9528235880001],
              [51.50029789200005, 18.93124867800013],
              [51.340100952000114, 18.909699606000075],
              [51.179904012000065, 18.88815053300003],
              [51.01981042500006, 18.86657562200007],
              [50.85971683800011, 18.845026551],
              [50.699364869000135, 18.82352915500006],
              [50.53932295700014, 18.801902567000084],
              [50.37912601800008, 18.78035349500003],
              [50.21892907800009, 18.758856099000084],
              [50.05873213700005, 18.73725535100003],
              [49.898535197000115, 18.71570627900006],
              [49.73844161000005, 18.694157207],
              [49.57824466900013, 18.672608134000043],
              [49.41804772900008, 18.6510590620001],
              [49.257850790000134, 18.629509989000056],
              [49.128814738000074, 18.612095032000113],
              [49.03584883700012, 18.579719747000112],
              [48.991303752000135, 18.55788645400007],
              [48.84753991700006, 18.48770986000001],
              [48.675974162000045, 18.404019877000067],
              [48.484357951000106, 18.310408020000054],
              [48.31258549000012, 18.22658884700006],
              [48.184427937000066, 18.16393117300005],
              [48.16194869000009, 18.148919169000052],
              [48.084382365000124, 18.05590159100008],
              [47.99358687400013, 17.947587789000053],
              [47.83550866700011, 17.758193664000103],
              [47.68626713000003, 17.579651591000086],
              [47.589012085000036, 17.46327626500006],
              [47.57211389200012, 17.432322083000074],
              [47.524829956000076, 17.307575175000053],
              [47.4579606530001, 17.13089345300007],
              [47.428568591000044, 17.09310365900005],
              [47.427574911000136, 17.09182607000004],
              [47.3135767010001, 17.027902324000067],
              [47.19089685000006, 16.958914286000024],
              [47.161337931000105, 16.947442119000115],
              [47.128781779000064, 16.943049621000014],
              [46.997026374000086, 16.948514131000067],
              [46.98300256400006, 16.949095764000063],
              [46.97034183800014, 16.956847229000076],
              [46.88579919400007, 17.0695535280001],
              [46.811798543000066, 17.168462219000062],
              [46.747203003000095, 17.25476186100012],
              [46.7100993250001, 17.275380758000026],
              [46.48789066500012, 17.245976868000028],
              [46.322629435000124, 17.224066060000084],
              [46.07995690900009, 17.247992249000063],
              [45.89082116700013, 17.266647441000046],
              [45.64230920400007, 17.291090394],
              [45.43038415500013, 17.312019348000078],
              [45.3847021900001, 17.32648874900009],
              [45.222128133000126, 17.417387594],
              [45.1653874110001, 17.428394674000103],
              [44.99733565200006, 17.4295315560001],
              [44.972466368000084, 17.42969619600005],
              [44.84902429200014, 17.430513407000078],
              [44.64645267700013, 17.431805319000105],
              [44.62464522300007, 17.42720611600008],
              [44.56196171100004, 17.404468486],
              [44.53379805500009, 17.40286651700005],
              [44.46517175300005, 17.416457418000064],
              [44.404141887000094, 17.41873118100007],
              [44.30735192900005, 17.40896433600001],
              [44.23056075000011, 17.391859436000075],
              [44.211543824000046, 17.390619202000025],
              [44.169375855000055, 17.40234975200012],
              [44.14901534000006, 17.40483022000008],
              [44.13428755700005, 17.394701640000036],
              [44.11966312600009, 17.36994862900012],
              [44.10447025600013, 17.351965231000023],
              [44.085349976000145, 17.343438619000025],
              [44.059356730000104, 17.347055969000095],
              [44.02096114100004, 17.366021220000036],
              [44.00390791800004, 17.367829896000032],
              [43.98230717000007, 17.356822815000058],
              [43.967114299000116, 17.33956288700007],
              [43.95429854300005, 17.32002919600005],
              [43.938692260000096, 17.305198060000023],
              [43.91512780800008, 17.301839091000105],
              [43.903293905000055, 17.30431956000008],
              [43.89735111500005, 17.3073684700001],
              [43.89404382300006, 17.312174378000023],
              [43.89006473800009, 17.32018422500009],
              [43.89264856000011, 17.340079651000096],
              [43.89264856000011, 17.351035055000082],
              [43.88670577000005, 17.3536705530001],
              [43.863244670000086, 17.346952616000053],
              [43.84577803500014, 17.346177470000057],
              [43.80619388800011, 17.34958811500009],
              [43.768780151000044, 17.34550567600006],
              [43.750641724000104, 17.345660706000032],
              [43.730642945000056, 17.35243031900005],
              [43.689301799000134, 17.383849589000093],
              [43.61953861500007, 17.458832093000055],
              [43.57706058700006, 17.482964986000027],
              [43.50336999500013, 17.51345408100009],
              [43.487143596000124, 17.517484843000105],
              [43.4531405030001, 17.518776754000058],
              [43.434950399000115, 17.52285919200007],
              [43.412884562000045, 17.519965312000082],
              [43.391025431000116, 17.5119554650001],
              [43.30307214300012, 17.459038798000037],
              [43.21594567900013, 17.387208557000108],
              [43.16788659700006, 17.330519511000105],
              [43.16504439300007, 17.32592030800005],
              [43.222198527000046, 17.307833557000052],
              [43.24183557100008, 17.293415833000026],
              [43.252170858000056, 17.271970114000098],
              [43.2486051840001, 17.251919658000034],
              [43.22617761200013, 17.241274312000044],
              [43.20333663000008, 17.23631337500011],
              [43.1768782960001, 17.225513001000067],
              [43.15615604700008, 17.209700013000074],
              [43.150058228000034, 17.18995961500009],
              [43.15098840400009, 17.166860251000045],
              [43.14530399600005, 17.146551412000022],
              [43.12432336500012, 17.10696726500005],
              [43.118432251000115, 17.086245016000035],
              [43.12246301300013, 17.070121969000056],
              [43.13031783000008, 17.053482157000033],
              [43.13600223800012, 17.031416321000037],
              [43.135898885000074, 17.00960886700001],
              [43.13155806500009, 16.9904369100001],
              [43.115435018000085, 16.951834616000028],
              [43.10871708200011, 16.92697825200007],
              [43.11264449100014, 16.91002838200005],
              [43.13372847500011, 16.871012675000046],
              [43.14582076000005, 16.83447743800012],
              [43.157344604000116, 16.825382385000054],
              [43.1944482830001, 16.81546051000005],
              [43.20473189300009, 16.807709046000056],
              [43.211501505000115, 16.796856995],
              [43.212845092000066, 16.783886210000063],
              [43.20860762500013, 16.77339589400013],
              [43.201062867000076, 16.768124899],
              [43.19186446100008, 16.764249166000056],
              [43.182872762000045, 16.757996317000035],
              [43.168506714000046, 16.737222392000106],
              [43.17067712400012, 16.72347646100006],
              [43.179772176000085, 16.708231914000024],
              [43.185678910000036, 16.684847057000056],
              [43.186076701000104, 16.683272196000033],
              [43.17997888200006, 16.66461700400008],
              [43.16292565900011, 16.661516419000023],
              [43.1227730710001, 16.673298646000134],
              [43.09776167800004, 16.677794495000043],
              [43.084945923000134, 16.672575175000034],
              [43.079984986000056, 16.658829244000103],
              [43.078641398000116, 16.637693584000047],
              [43.074610636000045, 16.618780009000105],
              [43.04877242000009, 16.55346099900008],
              [43.0362667230001, 16.536304424000022],
              [43.01466597500013, 16.520698141000068],
              [42.970947713000044, 16.495790100000093],
              [42.95627160600009, 16.49072581000003],
              [42.917410929000084, 16.483801168000056],
              [42.90676558400014, 16.479356995000032],
              [42.9029415280001, 16.46628285700008],
              [42.905628703000104, 16.451089986000042],
              [42.90676558400014, 16.434915263000065],
              [42.898187297000106, 16.4188955690001],
              [42.87245243400008, 16.401635641000027],
              [42.837312459000145, 16.387217916000097],
              [42.78948001400005, 16.37095774900007],
              [42.788096550000034, 16.37368398600006],
              [42.78825931100005, 16.409857489000046],
              [42.781260613000086, 16.42023346600007],
              [42.794932488000086, 16.452826239000046],
              [42.78825931100005, 16.471869208000044],
              [42.73975670700008, 16.524562893000052],
              [42.72868899800005, 16.54718659100007],
              [42.724945509000065, 16.566351630000042],
              [42.72592207100007, 16.610174872000073],
              [42.73764082100007, 16.652818101000037],
              [42.737315300000034, 16.671128648000092],
              [42.71924889400009, 16.67536041900007],
              [42.72592207100007, 16.682806708000044],
              [42.713877800000034, 16.69367096600007],
              [42.703868035000085, 16.709051825000074],
              [42.701508009000065, 16.72333405200004],
              [42.71241295700008, 16.730617580000057],
              [42.70630944100009, 16.740627346000053],
              [42.67823326900009, 16.76471588700008],
              [42.671885613000086, 16.771918036000045],
              [42.659190300000034, 16.789984442000048],
              [42.635752800000034, 16.81517161700009],
              [42.628916863000086, 16.81989166900007],
              [42.59693444100009, 16.836818752000056],
              [42.586924675000034, 16.837958075000074],
              [42.57585696700005, 16.83234284100007],
              [42.541758660000085, 16.87799713700008],
              [42.555674675000034, 16.92206452000005],
              [42.54851321700005, 16.93813711100006],
              [42.54859459700003, 16.987250067000048],
              [42.54420006600009, 17.004339911000045],
              [42.53451582100007, 17.010321356000077],
              [42.52491295700008, 17.014960028000075],
              [42.52068118600005, 17.028225002000056],
              [42.512705925000034, 17.03701406500005],
              [42.494476759000065, 17.038397528000075],
              [42.47396894600007, 17.037258205000057],
              [42.459727410000085, 17.03847890800006],
              [42.44752037900008, 17.04901764500005],
              [42.437510613000086, 17.06513092700004],
              [42.42505944100009, 17.093085028000075],
              [42.420583530000044, 17.10773346600007],
              [42.41553795700008, 17.14203522300005],
              [42.410817905000044, 17.15574778900009],
              [42.40170332100007, 17.16351959800005],
              [42.35670006600009, 17.182440497000073],
              [42.35922285200007, 17.165187893000052],
              [42.36646569100009, 17.149318752000056],
              [42.38404381600009, 17.12099844000005],
              [42.36378014400009, 17.108710028000075],
              [42.37387129000007, 17.04328034100007],
              [42.36296634200005, 17.02480703300006],
              [42.35726972700007, 17.04559967700004],
              [42.35670006600009, 17.114162502000056],
              [42.352549675000034, 17.13467031500005],
              [42.33912194100009, 17.173570054000038],
              [42.32162519600007, 17.30927155200004],
              [42.315196160000085, 17.333238023000092],
              [42.31072024800005, 17.35097890800006],
              [42.31666100400008, 17.400824286000045],
              [42.315196160000085, 17.42206452000005],
              [42.30787194100009, 17.44432200700004],
              [42.301524285000085, 17.453599351000037],
              [42.291677280000044, 17.457424221000053],
              [42.28142337300005, 17.457912502000056],
              [42.27361087300005, 17.45994700700004],
              [42.268565300000034, 17.46482982000009],
              [42.26677493600005, 17.473578192000048],
              [42.26059004000007, 17.48505280200004],
              [42.15284264400009, 17.57379791900007],
              [42.14380944100009, 17.576605536000045],
              [42.14087975400008, 17.571193752000056],
              [42.13404381600009, 17.579820054000038],
              [42.12330162900008, 17.600775458000044],
              [42.103526238000086, 17.627508856000077],
              [42.097666863000086, 17.644354559000078],
              [42.09351647200003, 17.652085679000038],
              [42.08619225400008, 17.655422268000052],
              [42.063487175000034, 17.650864976000037],
              [42.05323326900009, 17.653225002000056],
              [42.048838738000086, 17.665676174000055],
              [42.04379316500007, 17.674302476000037],
              [42.00049889400009, 17.71747467700004],
              [41.998708530000044, 17.71548086100006],
              [41.99244225400008, 17.712713934000078],
              [41.98487389400009, 17.710638739000046],
              [41.97934004000007, 17.710638739000046],
              [41.969737175000034, 17.71979401200008],
              [41.93897545700008, 17.761867580000057],
              [41.928721550000034, 17.76715729400007],
              [41.869476759000065, 17.82050202000005],
              [41.84782962300005, 17.81195709800005],
              [41.81039472700007, 17.83690013200004],
              [41.78760826900009, 17.83356354400007],
              [41.778330925000034, 17.859808661000045],
              [41.760752800000034, 17.87653229400007],
              [41.739268425000034, 17.890692450000074],
              [41.71924889400009, 17.90924713700008],
              [41.67725670700008, 17.960598049000055],
              [41.670909050000034, 17.97752513200004],
              [41.67237389400009, 17.99013906500005],
              [41.67530358200008, 18.001288153000075],
              [41.67367597700007, 18.00926341400009],
              [41.660899285000085, 18.01235586100006],
              [41.65357506600009, 18.015326239000046],
              [41.65211022200003, 18.022650458000044],
              [41.65259850400008, 18.03143952000005],
              [41.651052280000044, 18.039007880000042],
              [41.60889733200008, 18.07518138200004],
              [41.59351647200003, 18.09589264500005],
              [41.602549675000034, 18.11469147300005],
              [41.58513431100005, 18.13540273600006],
              [41.57797285200007, 18.14638906500005],
              [41.575205925000034, 18.159409898000092],
              [41.57081139400009, 18.165187893000052],
              [41.56202233200008, 18.16815827000005],
              [41.55640709700003, 18.174302476000037],
              [41.56104576900009, 18.189846096000053],
              [41.54070071700005, 18.191880601000037],
              [41.52133222700007, 18.19668203300006],
              [41.524180535000085, 18.200995184000078],
              [41.525726759000065, 18.204291083000044],
              [41.528086785000085, 18.207180080000057],
              [41.53370201900009, 18.21035390800006],
              [41.52751712300005, 18.222316799000055],
              [41.518565300000034, 18.22797272300005],
              [41.50717207100007, 18.228257554000038],
              [41.49333743600005, 18.223944403000075],
              [41.49976647200003, 18.233343817000048],
              [41.504649285000085, 18.242987372000073],
              [41.50562584700003, 18.251776434000078],
              [41.50017337300005, 18.258734442000048],
              [41.50635826900009, 18.27220286700009],
              [41.50049889400009, 18.278998114000046],
              [41.48764082100007, 18.28082916900007],
              [41.47217858200008, 18.27920156500005],
              [41.475352410000085, 18.29287344000005],
              [41.47201582100007, 18.31195709800005],
              [41.46461022200003, 18.330959377000056],
              [41.455414259000065, 18.34406159100007],
              [41.45085696700005, 18.356024481000077],
              [41.44467207100007, 18.39398834800005],
              [41.44190514400009, 18.402085679000038],
              [41.43970787900008, 18.410589911000045],
              [41.438161655000044, 18.464178778000075],
              [41.43580162900008, 18.469956773000092],
              [41.43295332100007, 18.474269924000055],
              [41.428396030000044, 18.47687409100007],
              [41.42107181100005, 18.477769273000092],
              [41.41578209700003, 18.48151276200008],
              [41.41391035200007, 18.489976304000038],
              [41.41334069100009, 18.499335028000075],
              [41.41146894600007, 18.50576406500005],
              [41.37525475400008, 18.52948639500005],
              [41.369802280000044, 18.53583405200004],
              [41.368174675000034, 18.54629140800006],
              [41.363291863000086, 18.558661200000074],
              [41.35572350400008, 18.56903717700004],
              [41.340179884000065, 18.57562897300005],
              [41.334320509000065, 18.580552476000037],
              [41.32984459700003, 18.58543528900009],
              [41.32829837300005, 18.587632554000038],
              [41.32211347700007, 18.585638739000046],
              [41.31169681100005, 18.575344143000052],
              [41.30779056100005, 18.573431708000044],
              [41.296885613000086, 18.577337958000044],
              [41.285817905000044, 18.583807684000078],
              [41.275401238000086, 18.59202708500004],
              [41.26734459700003, 18.601304429000038],
              [41.240570509000065, 18.657945054000038],
              [41.229258660000085, 18.67332591400009],
              [41.21656334700003, 18.686346747000073],
              [41.21021569100009, 18.69794342700004],
              [41.20923912900008, 18.71161530200004],
              [41.21216881600009, 18.731024481000077],
              [41.23601321700005, 18.796616929000038],
              [41.23951256600009, 18.81704336100006],
              [41.242523634000065, 18.82489655200004],
              [41.24781334700003, 18.82843659100007],
              [41.249034050000034, 18.83417389500005],
              [41.23951256600009, 18.84833405200004],
              [41.235362175000034, 18.84910716400009],
              [41.213226759000065, 18.86041901200008],
              [41.21216881600009, 18.86200592700004],
              [41.17123457100007, 18.871649481000077],
              [41.160899285000085, 18.90298086100006],
              [41.16032962300005, 18.90888092700004],
              [41.140961134000065, 18.933294989000046],
              [41.13648522200003, 18.93650950700004],
              [41.135752800000034, 18.946926174000055],
              [41.13721764400009, 18.95770905200004],
              [41.143321160000085, 18.977484442000048],
              [41.14820397200003, 18.98847077000005],
              [41.153086785000085, 18.996039130000042],
              [41.15674889400009, 19.003851630000042],
              [41.158864780000044, 19.02216217700004],
              [41.16374759200005, 19.04295482000009],
              [41.176524285000085, 19.06736888200004],
              [41.16781660200007, 19.08222077000005],
              [41.149424675000034, 19.09373607000009],
              [41.129649285000085, 19.101629950000074],
              [41.08643639400009, 19.11359284100007],
              [41.06861412900008, 19.125392971000053],
              [41.05836022200003, 19.15298086100006],
              [41.04420006600009, 19.17413971600007],
              [41.04021243600005, 19.183539130000042],
              [41.04070071700005, 19.194647528000075],
              [41.04818769600007, 19.217718817000048],
              [41.047536655000044, 19.227443752000056],
              [41.041677280000044, 19.245754299000055],
              [41.04021243600005, 19.25584544500009],
              [41.036143425000034, 19.264553127000056],
              [41.01783287900008, 19.273993231000077],
              [41.01351972700007, 19.282863674000055],
              [41.00912519600007, 19.304022528000075],
              [40.99830162900008, 19.314927476000037],
              [40.98292076900009, 19.322699286000045],
              [40.95590254000007, 19.34332916900007],
              [40.957692905000044, 19.34642161700009],
              [40.958994988000086, 19.358587958000044],
              [40.95671634200005, 19.36863841400009],
              [40.94695071700005, 19.38418203300006],
              [40.94467207100007, 19.392726955000057],
              [40.94312584700003, 19.40330638200004],
              [40.93767337300005, 19.41937897300005],
              [40.93832441500007, 19.430568752000056],
              [40.94507897200003, 19.440659898000035],
              [40.95435631600009, 19.44867584800005],
              [40.95923912900008, 19.456000067000048],
              [40.952159050000034, 19.464056708000044],
              [40.95460045700008, 19.47479889500005],
              [40.95248457100007, 19.485256252000056],
              [40.94695071700005, 19.49371979400007],
              [40.94467207100007, 19.505682684000078],
              [40.85914147200003, 19.534491278000075],
              [40.83545983200008, 19.546616929000038],
              [40.78467858200008, 19.59634023600006],
              [40.760427280000044, 19.608710028000075],
              [40.760427280000044, 19.614935614000046],
              [40.77125084700003, 19.61351146000004],
              [40.79444420700008, 19.601263739000046],
              [40.80062910200007, 19.642238674000055],
              [40.79802493600005, 19.692328192000048],
              [40.79086347700007, 19.714056708000044],
              [40.744883660000085, 19.777004299000055],
              [40.72543379000007, 19.78925202000005],
              [40.67400149800005, 19.794989325000074],
              [40.65406334700003, 19.79433828300006],
              [40.64503014400009, 19.78473541900007],
              [40.656586134000065, 19.759507554000038],
              [40.641612175000034, 19.771226304000038],
              [40.62867272200003, 19.792141018000052],
              [40.62037194100009, 19.81207916900007],
              [40.619476759000065, 19.82099030200004],
              [40.60515384200005, 19.82953522300005],
              [40.564463738000086, 19.885891018000052],
              [40.533539259000065, 19.903998114000046],
              [40.52702884200005, 19.91034577000005],
              [40.528005405000044, 19.91754791900007],
              [40.54053795700008, 19.943915106000077],
              [40.53451582100007, 19.961818752000056],
              [40.52263431100005, 19.972479559000078],
              [40.492198113000086, 19.984849351000037],
              [40.45460045700008, 20.00657786700009],
              [40.44556725400008, 20.009711005000042],
              [40.43637129000007, 20.02334219000005],
              [40.42758222700007, 20.02643463700008],
              [40.41846764400009, 20.031195380000042],
              [40.393565300000034, 20.064276434000078],
              [40.385508660000085, 20.068101304000038],
              [40.36085045700008, 20.073919989000046],
              [40.352224155000044, 20.07485586100006],
              [40.33375084700003, 20.07953522300005],
              [40.313487175000034, 20.090725002000056],
              [40.26783287900008, 20.12531159100007],
              [40.23210696700005, 20.16356028900009],
              [40.23878014400009, 20.17804596600007],
              [40.22185306100005, 20.18903229400007],
              [40.195648634000065, 20.19599030200004],
              [40.164805535000085, 20.200384833000044],
              [40.158946160000085, 20.20538971600007],
              [40.14958743600005, 20.21820709800005],
              [40.13396243600005, 20.23151276200008],
              [40.125010613000086, 20.241115627000056],
              [40.125987175000034, 20.24555084800005],
              [40.115570509000065, 20.251654364000046],
              [40.08383222700007, 20.279242255000042],
              [40.06763756600009, 20.28652578300006],
              [40.04517662900008, 20.28611888200004],
              [40.02035566500007, 20.282049872000073],
              [40.000336134000065, 20.275132554000038],
              [39.99195397200003, 20.26666901200008],
              [39.96802819100009, 20.275091864000046],
              [39.92530358200008, 20.299383856000077],
              [39.903086785000085, 20.308254299000055],
              [39.904307488000086, 20.29555898600006],
              [39.910166863000086, 20.28847890800006],
              [39.918304884000065, 20.28351471600007],
              [39.92660566500007, 20.27684153900009],
              [39.93140709700003, 20.274725653000075],
              [39.94109134200005, 20.26854075700004],
              [39.94711347700007, 20.262152411000045],
              [39.94068444100009, 20.25918203300006],
              [39.92318769600007, 20.26357656500005],
              [39.82536868600005, 20.320054429000038],
              [39.811289910000085, 20.33148834800005],
              [39.79818769600007, 20.33738841400009],
              [39.778330925000034, 20.342718817000048],
              [39.760101759000065, 20.350816148000035],
              [39.74463951900009, 20.38117096600007],
              [39.72738691500007, 20.396918036000045],
              [39.67359459700003, 20.43622467700004],
              [39.646494988000086, 20.46157461100006],
              [39.58708743600005, 20.55215078300006],
              [39.567393425000034, 20.567694403000075],
              [39.567393425000034, 20.575140692000048],
              [39.57740319100009, 20.57453034100007],
              [39.58529707100007, 20.575873114000046],
              [39.59107506600009, 20.58026764500005],
              [39.594737175000034, 20.588771877000056],
              [39.57935631600009, 20.59137604400007],
              [39.56666100400008, 20.59829336100006],
              [39.54346764400009, 20.619208075000074],
              [39.53695722700007, 20.63027578300006],
              [39.53101647200003, 20.659491278000075],
              [39.526377800000034, 20.670721747000073],
              [39.492930535000085, 20.706244208000044],
              [39.48991946700005, 20.72288646000004],
              [39.50603274800005, 20.74640534100007],
              [39.471364780000044, 20.757473049000055],
              [39.45753014400009, 20.759466864000046],
              [39.459971550000034, 20.751654364000046],
              [39.46461022200003, 20.746039130000042],
              [39.470713738000086, 20.742010809000078],
              [39.47787519600007, 20.73895905200004],
              [39.45826256600009, 20.74485911700009],
              [39.436289910000085, 20.756659247000073],
              [39.42318769600007, 20.77171458500004],
              [39.43018639400009, 20.78742096600007],
              [39.420909050000034, 20.79169342700004],
              [39.416758660000085, 20.797756252000056],
              [39.41765384200005, 20.80532461100006],
              [39.42335045700008, 20.814113674000055],
              [39.427744988000086, 20.806382554000038],
              [39.43539472700007, 20.80076732000009],
              [39.44556725400008, 20.79686107000009],
              [39.45753014400009, 20.794256903000075],
              [39.45264733200008, 20.80613841400009],
              [39.451182488000086, 20.81159088700008],
              [39.45069420700008, 20.81781647300005],
              [39.44874108200008, 20.827297268000052],
              [39.444021030000044, 20.82762278900009],
              [39.43726647200003, 20.82575104400007],
              [39.43018639400009, 20.82835521000004],
              [39.416758660000085, 20.846502997000073],
              [39.41130618600005, 20.846869208000044],
              [39.40967858200008, 20.82835521000004],
              [39.38835696700005, 20.841131903000075],
              [39.359711134000065, 20.862616278000075],
              [39.33912194100009, 20.88743724200009],
              [39.340830925000034, 20.910305080000057],
              [39.34498131600009, 20.905178127000056],
              [39.352549675000034, 20.898911851000037],
              [39.35962975400008, 20.89671458500004],
              [39.36182701900009, 20.903509833000044],
              [39.358409050000034, 20.915350653000075],
              [39.35279381600009, 20.919867255000042],
              [39.34546959700003, 20.92218659100007],
              [39.33741295700008, 20.927394924000055],
              [39.32781009200005, 20.93183014500005],
              [39.317393425000034, 20.930121161000045],
              [39.30681399800005, 20.92609284100007],
              [39.29712975400008, 20.923976955000057],
              [39.296885613000086, 20.92796458500004],
              [39.26872806100005, 20.968573309000078],
              [39.262380405000044, 20.98305898600006],
              [39.25953209700003, 20.999823309000078],
              [39.25896243600005, 21.023871161000045],
              [39.25570722700007, 21.032945054000038],
              [39.24203535200007, 21.04169342700004],
              [39.239024285000085, 21.050930080000057],
              [39.23780358200008, 21.062892971000053],
              [39.23406009200005, 21.067206122000073],
              [39.227549675000034, 21.069281317000048],
              [39.18539472700007, 21.09723541900007],
              [39.17432701900009, 21.10887278900009],
              [39.167979363000086, 21.13629791900007],
              [39.15870201900009, 21.155910549000055],
              [39.15650475400008, 21.16754791900007],
              [39.15870201900009, 21.17259349200009],
              [39.16822350400008, 21.185288804000038],
              [39.17017662900008, 21.191473700000074],
              [39.16325931100005, 21.205877997000073],
              [39.125743035000085, 21.26040273600006],
              [39.111989780000044, 21.26821523600006],
              [39.080739780000044, 21.315008856000077],
              [39.15992272200003, 21.379828192000048],
              [39.17107181100005, 21.404120184000078],
              [39.17237389400009, 21.436021226000037],
              [39.164724155000044, 21.464911200000074],
              [39.14966881600009, 21.480129299000055],
              [39.14966881600009, 21.485663153000075],
              [39.16041100400008, 21.49445221600007],
              [39.158946160000085, 21.50779857000009],
              [39.14275149800005, 21.54092031500005],
              [39.13005618600005, 21.519598700000074],
              [39.119802280000044, 21.516913153000075],
              [39.110362175000034, 21.528143622000073],
              [39.10124759200005, 21.54840729400007],
              [39.10865319100009, 21.55459219000005],
              [39.09229576900009, 21.576564846000053],
              [39.08871504000007, 21.605861721000053],
              [39.090179884000065, 21.63703034100007],
              [39.08814537900008, 21.664455471000053],
              [39.07740319100009, 21.691555080000057],
              [39.07935631600009, 21.706366278000075],
              [39.09815514400009, 21.712836005000042],
              [39.103526238000086, 21.718573309000078],
              [39.10857181100005, 21.732123114000046],
              [39.10906009200005, 21.747788804000038],
              [39.10124759200005, 21.75999583500004],
              [39.09359785200007, 21.739162502000056],
              [39.08838951900009, 21.73045482000009],
              [39.080739780000044, 21.725816148000035],
              [39.066742384000065, 21.72524648600006],
              [39.063487175000034, 21.73004791900007],
              [39.06373131600009, 21.737941799000055],
              [39.06031334700003, 21.74640534100007],
              [39.05388431100005, 21.75185781500005],
              [39.049489780000044, 21.754828192000048],
              [39.04542076900009, 21.758734442000048],
              [39.04037519600007, 21.766831773000035],
              [39.03736412900008, 21.77606842700004],
              [39.035899285000085, 21.792629299000055],
              [39.03296959700003, 21.80097077000005],
              [39.03101647200003, 21.80145905200004],
              [39.01929772200003, 21.807806708000044],
              [39.01726321700005, 21.81118398600006],
              [39.01449629000007, 21.818752346000053],
              [39.012461785000085, 21.822088934000078],
              [38.97855432500006, 21.862073697000085],
              [38.94959847900009, 21.92191576400006],
              [38.931253534000064, 22.006073186000037],
              [38.93265475700008, 22.025186310000038],
              [38.959144423000055, 22.03444348700009],
              [38.98621367900006, 22.00223902500005],
              [39.005692933000034, 22.00200529300008],
              [39.01002037900008, 22.02411530200004],
              [39.01002037900008, 22.04360586100006],
              [39.012461785000085, 22.05426666900007],
              [39.016612175000034, 22.05809153900009],
              [39.030039910000085, 22.06708405200004],
              [39.03296959700003, 22.072211005000042],
              [39.03500410200007, 22.091131903000075],
              [39.04444420700008, 22.130804755000042],
              [39.04664147200003, 22.15106842700004],
              [39.04037519600007, 22.15106842700004],
              [39.026133660000085, 22.116888739000046],
              [39.01929772200003, 22.13157786700009],
              [39.02271569100009, 22.14248281500005],
              [39.029307488000086, 22.153225002000056],
              [39.03296959700003, 22.167792059000078],
              [39.03296959700003, 22.208807684000078],
              [39.04037519600007, 22.23578522300005],
              [39.073252800000034, 22.271144924000055],
              [39.08350670700008, 22.31354401200008],
              [39.090586785000085, 22.323391018000052],
              [39.099619988000086, 22.331732489000046],
              [39.10865319100009, 22.342230536000045],
              [39.12232506600009, 22.37018463700008],
              [39.13949629000007, 22.386379299000055],
              [39.14275149800005, 22.39061107000009],
              [39.14275149800005, 22.403225002000056],
              [39.137380405000044, 22.41469961100006],
              [39.127614780000044, 22.421210028000075],
              [39.11491946700005, 22.41860586100006],
              [39.108164910000085, 22.40892161700009],
              [39.10124759200005, 22.38043854400007],
              [39.094800219000035, 22.370183421000036],
              [39.07025641900009, 22.365827894000063],
              [39.06922670900008, 22.394489659000044],
              [39.08207109300008, 22.436284990000047],
              [39.07421966900006, 22.49097271900007],
              [39.08151739400006, 22.54679248900004],
              [39.07398774200004, 22.574175402000037],
              [39.06625410200007, 22.587551174000055],
              [39.03858483200008, 22.622707424000055],
              [39.012461785000085, 22.678656317000048],
              [38.99301191500007, 22.70856354400007],
              [38.98568769600007, 22.724269924000055],
              [38.988291863000086, 22.736395575000074],
              [39.014659050000034, 22.758978583000044],
              [39.01303144600007, 22.766791083000044],
              [38.96501712300005, 22.81631094000005],
              [38.94548587300005, 22.831203518000052],
              [38.93677819100009, 22.82636139500005],
              [38.940440300000034, 22.820786851000037],
              [38.958018425000034, 22.803615627000056],
              [38.96469160200007, 22.794663804000038],
              [38.96794681100005, 22.784002997000073],
              [38.96900475400008, 22.773830471000053],
              [38.971446160000085, 22.76386139500005],
              [38.97828209700003, 22.753729559000078],
              [38.97087649800005, 22.746893622000073],
              [38.95771438100007, 22.77496076200009],
              [38.929852287000074, 22.815017770000054],
              [38.90259850400008, 22.84316640800006],
              [38.85100059000007, 22.92972075600005],
              [38.85117546400005, 22.943275422000056],
              [38.88040650100004, 22.928493952000053],
              [38.912852410000085, 22.86196523600006],
              [38.93051191500007, 22.856756903000075],
              [38.941416863000086, 22.850531317000048],
              [38.95101972700007, 22.851955471000053],
              [38.95883222700007, 22.859116929000038],
              [38.96469160200007, 22.870428778000075],
              [38.95427493600005, 22.88190338700008],
              [38.93734785200007, 22.91209544500009],
              [38.92693118600005, 22.91819896000004],
              [38.91960696700005, 22.921087958000044],
              [38.91146894600007, 22.92845286700009],
              [38.905284050000034, 22.93846263200004],
              [38.90259850400008, 22.949286200000074],
              [38.89389082100007, 22.96515534100007],
              [38.87387129000007, 22.972805080000057],
              [38.85108483200008, 22.97797272300005],
              [38.834320509000065, 22.98651764500005],
              [38.81421959700003, 22.98273346600007],
              [38.799571160000085, 22.99868398600006],
              [38.77906334700003, 23.041164455000057],
              [38.79021243600005, 23.051336981000077],
              [38.79867597700007, 23.06464264500005],
              [38.80437259200005, 23.079250393000052],
              [38.80640709700003, 23.09324778900009],
              [38.80392843100009, 23.121855529000072],
              [38.79921347900006, 23.13726338200007],
              [38.79835045700008, 23.149603583000044],
              [38.786659789000055, 23.15455787400009],
              [38.777619307000066, 23.139292135000062],
              [38.76511526500008, 23.161100557000054],
              [38.74768917300008, 23.18295727800006],
              [38.729258660000085, 23.21625397300005],
              [38.71143639400009, 23.23574453300006],
              [38.70394941500007, 23.257757880000042],
              [38.69171252700005, 23.27295952600008],
              [38.68891790100008, 23.286540050000042],
              [38.68025380600005, 23.303794764000088],
              [38.68041692600008, 23.31825116600004],
              [38.672868503000075, 23.34815117100004],
              [38.65933113700004, 23.37179030200008],
              [38.64653728900004, 23.400725524000052],
              [38.64087028600005, 23.44007399700007],
              [38.63711273700005, 23.468168984000044],
              [38.63124424800009, 23.490047428000082],
              [38.628916863000086, 23.507879950000074],
              [38.61215254000007, 23.524318752000056],
              [38.60474694100009, 23.53538646000004],
              [38.601573113000086, 23.551947333000044],
              [38.60017530600004, 23.568248511000036],
              [38.57789147200003, 23.55662669500009],
              [38.56804446700005, 23.56248607000009],
              [38.55990644600007, 23.56248607000009],
              [38.560883009000065, 23.545721747000073],
              [38.570323113000086, 23.536932684000078],
              [38.59546959700003, 23.52838776200008],
              [38.59546959700003, 23.52147044500009],
              [38.56202233200008, 23.524359442000048],
              [38.54006446300008, 23.543245398000067],
              [38.539222830000085, 23.591868839000085],
              [38.49484935700008, 23.64463486200009],
              [38.471364780000044, 23.713324286000045],
              [38.46436608200008, 23.736070054000038],
              [38.459971550000034, 23.76080963700008],
              [38.45264733200008, 23.784002997000073],
              [38.43702233200008, 23.802069403000075],
              [38.42709394600007, 23.806708075000074],
              [38.41627037900008, 23.80890534100007],
              [38.39957121300006, 23.81408620700006],
              [38.39012566900004, 23.824131459000057],
              [38.38549339700006, 23.83850427200008],
              [38.37748125200005, 23.856017265000048],
              [38.36534836300007, 23.870447907000084],
              [38.34888756600009, 23.87518952000005],
              [38.332707166000034, 23.87942637900005],
              [38.319133398000076, 23.88638546100009],
              [38.309336785000085, 23.893377997000073],
              [38.299562672000036, 23.910221565000086],
              [38.28333768500005, 23.927799915000037],
              [38.275401238000086, 23.93382396000004],
              [38.25890596700009, 23.944818549000047],
              [38.23846904800007, 23.95058265600005],
              [38.22208975700005, 23.95257446800008],
              [38.198281499000075, 23.967097788000046],
              [38.185356339000066, 23.97592867900005],
              [38.16564072500006, 23.99292314300004],
              [38.14663597200007, 24.01490851200009],
              [38.12617906500009, 24.029427566000038],
              [38.10911714800005, 24.043891753000082],
              [38.07913530500008, 24.07038824300008],
              [38.07106917800007, 24.074080047000052],
              [38.062880567000036, 24.076005536000082],
              [38.053968085000065, 24.07232347000007],
              [38.04572859800004, 24.06738998500009],
              [38.02320397200009, 24.08161041900007],
              [38.00757897200009, 24.093085028000075],
              [37.96641641100007, 24.117093681000085],
              [37.93532070500004, 24.13900708200009],
              [37.941123676000075, 24.15095057800005],
              [37.95842061500008, 24.16207568100009],
              [37.98307204000008, 24.165664268000057],
              [37.97325955900004, 24.174709232000055],
              [37.95845664800004, 24.170308712000065],
              [37.93953008300008, 24.16144128700006],
              [37.93219972600008, 24.17421058900004],
              [37.943772151000076, 24.191356149000057],
              [37.94794950600004, 24.207046837000064],
              [37.937292170000035, 24.210850201000085],
              [37.93069002000004, 24.203406003000055],
              [37.91836605700007, 24.201232148000088],
              [37.91257654200007, 24.191538110000067],
              [37.91829870000004, 24.186266984000042],
              [37.921541611000066, 24.17726751500004],
              [37.923125610000056, 24.16453423200005],
              [37.92390540300005, 24.155547158000047],
              [37.91813257900009, 24.149593191000065],
              [37.89601011900004, 24.157208384000057],
              [37.86563419300006, 24.149887982000052],
              [37.82016035200007, 24.181708075000074],
              [37.80640709700009, 24.19326406500005],
              [37.76758871000004, 24.221393093000074],
              [37.75866125300007, 24.241611566000074],
              [37.74558528100005, 24.24988380600007],
              [37.72840703700007, 24.25742188600009],
              [37.710413337000034, 24.26645665800004],
              [37.695712462000074, 24.27921334100006],
              [37.676090858000066, 24.291235741000037],
              [37.65232182500006, 24.290565549000064],
              [37.640961134000065, 24.29169342700004],
              [37.625987175000034, 24.28143952000005],
              [37.62273501300007, 24.26823743300008],
              [37.62839438100008, 24.248039917000085],
              [37.585775443000045, 24.246661567000046],
              [37.57517404100008, 24.261636525000085],
              [37.545706341000084, 24.274411057000066],
              [37.52272027400005, 24.267731705000074],
              [37.50063561300004, 24.28870003800006],
              [37.486750150000034, 24.311147272000085],
              [37.46466137900006, 24.339587711000036],
              [37.429403437000076, 24.36730693600009],
              [37.41795838400009, 24.400965959000075],
              [37.427853860000084, 24.421132041000078],
              [37.435246120000045, 24.418874462000076],
              [37.45495441700007, 24.406870578000053],
              [37.46320812400006, 24.42254629200005],
              [37.45666895900007, 24.441248732000076],
              [37.31922951900009, 24.62423884800006],
              [37.25766035200007, 24.702337958000044],
              [37.228526238000086, 24.73769765800006],
              [37.22706139400009, 24.765366929000038],
              [37.230479363000086, 24.772691148000035],
              [37.23129316500007, 24.78261953300006],
              [37.23031660200007, 24.79254791900007],
              [37.22706139400009, 24.79954661700009],
              [37.219737175000034, 24.802801825000074],
              [37.20679772200009, 24.79100169500009],
              [37.196299675000034, 24.789618231000077],
              [37.178721550000034, 24.799383856000077],
              [37.16578209700009, 24.81549713700008],
              [37.14861087300005, 24.85101959800005],
              [37.17408287900008, 24.85057200700004],
              [37.19654381600009, 24.84723541900007],
              [37.21892337300005, 24.846625067000048],
              [37.244151238000086, 24.854437567000048],
              [37.256602410000085, 24.871242580000057],
              [37.25806725400008, 24.92177969000005],
              [37.279958530000044, 24.964097398000035],
              [37.27702884200005, 24.98663971600007],
              [37.257823113000086, 25.028550523000035],
              [37.25147545700008, 25.052557684000078],
              [37.257823113000086, 25.111476955000057],
              [37.25603274800005, 25.134100653000075],
              [37.250743035000085, 25.155462958000044],
              [37.242198113000086, 25.17527903900009],
              [37.230479363000086, 25.19367096600007],
              [37.211680535000085, 25.21426015800006],
              [37.200205925000034, 25.22418854400007],
              [37.189463738000086, 25.23118724200009],
              [37.180023634000065, 25.239081122000073],
              [37.170664910000085, 25.25779857000009],
              [37.16228274800005, 25.265692450000074],
              [37.14234459700009, 25.279771226000037],
              [37.12256920700008, 25.29954661700009],
              [37.10531660200007, 25.32217031500005],
              [37.09327233200008, 25.34446849200009],
              [37.09099368600005, 25.354396877000056],
              [37.088877800000034, 25.376776434000078],
              [37.08643639400009, 25.38544342700004],
              [37.07984459700009, 25.394598700000074],
              [37.06462649800005, 25.40973541900007],
              [37.05982506600009, 25.419623114000046],
              [37.07740319100009, 25.43105703300006],
              [37.06267337300005, 25.453680731000077],
              [37.018239780000044, 25.494696356000077],
              [37.01059004000007, 25.50739166900007],
              [36.994476759000065, 25.549953518000052],
              [36.989268425000034, 25.55695221600007],
              [36.975596550000034, 25.56513092700004],
              [36.97038821700005, 25.570461330000057],
              [36.96900475400008, 25.57615794500009],
              [36.96998131600009, 25.58856842700004],
              [36.96697024800005, 25.594305731000077],
              [36.95826256600009, 25.606350002000056],
              [36.944102410000085, 25.635199286000045],
              [36.936289910000085, 25.646144924000055],
              [36.92351321700005, 25.654771226000037],
              [36.89429772200009, 25.66559479400007],
              [36.881602410000085, 25.67283763200004],
              [36.84229576900009, 25.729803778000075],
              [36.817393425000034, 25.757961330000057],
              [36.795664910000085, 25.759466864000046],
              [36.793711785000085, 25.74827708500004],
              [36.80046634200005, 25.736721096000053],
              [36.80396569100009, 25.72679271000004],
              [36.79224694100009, 25.72060781500005],
              [36.77955162900008, 25.72406647300005],
              [36.74887129000007, 25.743882554000038],
              [36.73389733200008, 25.748521226000037],
              [36.724945509000065, 25.75389232000009],
              [36.70232181100005, 25.77997467700004],
              [36.696055535000085, 25.789536851000037],
              [36.69483483200008, 25.79559967700004],
              [36.696055535000085, 25.81712474200009],
              [36.69385826900009, 25.82290273600006],
              [36.68181399800005, 25.82558828300006],
              [36.67562910200007, 25.830511786000045],
              [36.66342207100007, 25.85565827000005],
              [36.662119988000086, 25.87909577000005],
              [36.67164147200009, 25.90143463700008],
              [36.69263756600009, 25.92328522300005],
              [36.705821160000085, 25.943752346000053],
              [36.70948326900009, 25.971136786000045],
              [36.70557701900009, 25.999335028000075],
              [36.696055535000085, 26.022284247000073],
              [36.67237389400009, 26.04523346600007],
              [36.640635613000086, 26.060207424000055],
              [36.60564212300005, 26.06826406500005],
              [36.57252037900008, 26.070705471000053],
              [36.53663170700008, 26.082424221000053],
              [36.512705925000034, 26.110988674000055],
              [36.449229363000086, 26.246893622000073],
              [36.42628014400009, 26.281805731000077],
              [36.382823113000086, 26.334540106000077],
              [36.308929884000065, 26.49823639500005],
              [36.22982832100007, 26.625555731000077],
              [36.18213951900009, 26.680243231000077],
              [36.12419681100005, 26.72675202000005],
              [36.097666863000086, 26.753973700000074],
              [36.08187910200007, 26.797267971000053],
              [36.051768425000034, 26.844671942000048],
              [36.031993035000085, 26.906805731000077],
              [36.01392662900008, 26.90232982000009],
              [36.00025475400008, 26.91351959800005],
              [35.97673587300005, 26.947739976000037],
              [35.91187584700009, 26.99957916900007],
              [35.83171634200005, 27.092718817000048],
              [35.803070509000065, 27.14207591400009],
              [35.799815300000034, 27.150091864000046],
              [35.79859459700009, 27.159979559000078],
              [35.800791863000086, 27.16815827000005],
              [35.810557488000086, 27.182440497000073],
              [35.812836134000065, 27.191066799000055],
              [35.80795332100007, 27.203070380000042],
              [35.78402754000007, 27.235500393000052],
              [35.699961785000085, 27.324774481000077],
              [35.65259850400008, 27.35382721600007],
              [35.64039147200009, 27.36347077000005],
              [35.61670983200008, 27.38963450700004],
              [35.589854363000086, 27.428900458000044],
              [35.559580925000034, 27.455633856000077],
              [35.521494988000086, 27.518459377000056],
              [35.510508660000085, 27.544175523000035],
              [35.506846550000034, 27.56443919500009],
              [35.506195509000065, 27.600531317000048],
              [35.50025475400008, 27.61933014500005],
              [35.49195397200009, 27.63239166900007],
              [35.458994988000086, 27.663397528000075],
              [35.44076582100007, 27.690252997000073],
              [35.415049675000034, 27.75136953300006],
              [35.39437910200007, 27.777004299000055],
              [35.38493899800005, 27.78261953300006],
              [35.36475670700008, 27.78969961100006],
              [35.35694420700008, 27.79437897300005],
              [35.35132897200009, 27.80141836100006],
              [35.34685306100005, 27.815008856000077],
              [35.33676191500007, 27.833685614000046],
              [35.332367384000065, 27.862209377000056],
              [35.32276451900009, 27.876288153000075],
              [35.27100670700008, 27.927801825000074],
              [35.25521894600007, 27.952785549000055],
              [35.24561608200008, 27.96234772300005],
              [35.22999108200008, 27.96873607000009],
              [35.18148847700007, 28.00291575700004],
              [35.18148847700007, 27.996039130000042],
              [35.17465254000007, 27.996039130000042],
              [35.16358483200008, 28.00934479400007],
              [35.176524285000085, 28.019476630000042],
              [35.19906660200007, 28.028225002000056],
              [35.21631920700008, 28.037665106000077],
              [35.226898634000065, 28.033148505000042],
              [35.22584069100009, 28.038763739000046],
              [35.21631920700008, 28.054388739000046],
              [35.21029707100007, 28.056586005000042],
              [35.182627800000034, 28.06191640800006],
              [35.17465254000007, 28.065008856000077],
              [35.16781660200007, 28.065008856000077],
              [35.16781660200007, 28.05817291900007],
              [35.16179446700005, 28.05817291900007],
              [35.15772545700008, 28.06435781500005],
              [35.15186608200008, 28.07103099200009],
              [35.14478600400008, 28.07640208500004],
              [35.13721764400009, 28.078599351000037],
              [35.11939537900008, 28.077948309000078],
              [35.110362175000034, 28.078924872000073],
              [35.098643425000034, 28.08974844000005],
              [35.05193118600005, 28.119574286000045],
              [35.042002800000034, 28.113023179000038],
              [35.030284050000034, 28.11347077000005],
              [35.01970462300005, 28.11347077000005],
              [35.022471550000034, 28.107855536000045],
              [35.02621504000007, 28.10297272300005],
              [35.03077233200008, 28.09910716400009],
              [35.02068118600005, 28.10374583500004],
              [35.00953209700009, 28.110541083000044],
              [34.99789472700007, 28.114203192000048],
              [34.98601321700005, 28.109320380000042],
              [34.97584069100009, 28.10342031500005],
              [34.94548587300005, 28.095363674000055],
              [34.93726647200009, 28.09125397300005],
              [34.93132571700005, 28.086004950000074],
              [34.927744988000086, 28.078599351000037],
              [34.920909050000034, 28.078599351000037],
              [34.920909050000034, 28.08543528900009],
              [34.914073113000086, 28.08543528900009],
              [34.90088951900009, 28.08226146000004],
              [34.88062584700009, 28.085638739000046],
              [34.86019941500007, 28.08539459800005],
              [34.846446160000085, 28.071193752000056],
              [34.843760613000086, 28.076320705000057],
              [34.84294681100005, 28.07640208500004],
              [34.838877800000034, 28.078599351000037],
              [34.838877800000034, 28.08543528900009],
              [34.846446160000085, 28.08543528900009],
              [34.846446160000085, 28.092922268000052],
              [34.84262129000007, 28.09983958500004],
              [34.847666863000086, 28.105536200000074],
              [34.85694420700008, 28.109849351000037],
              [34.866221550000034, 28.11277903900009],
              [34.85670006600009, 28.116441148000035],
              [34.84701582100007, 28.117621161000045],
              [34.83676191500007, 28.11627838700008],
              [34.82536868600005, 28.11277903900009],
              [34.82536868600005, 28.105902411000045],
              [34.832774285000085, 28.105902411000045],
              [34.832774285000085, 28.09910716400009],
              [34.82162519600007, 28.095770575000074],
              [34.81430097700007, 28.08893463700008],
              [34.80486087300005, 28.071193752000056],
              [34.801768425000034, 28.075384833000044],
              [34.79867597700007, 28.07680898600006],
              [34.795258009000065, 28.077297268000052],
              [34.791758660000085, 28.078599351000037],
              [34.79574629000007, 28.08462148600006],
              [34.80160566500007, 28.090399481000077],
              [34.80941816500007, 28.095404364000046],
              [34.819102410000085, 28.09910716400009],
              [34.81853274800005, 28.10293203300006],
              [34.818369988000086, 28.107123114000046],
              [34.819102410000085, 28.11277903900009],
              [34.80494225400008, 28.113348700000074],
              [34.793711785000085, 28.111070054000038],
              [34.78646894600007, 28.104722398000035],
              [34.78443444100009, 28.092922268000052],
              [34.77898196700005, 28.095770575000074],
              [34.777354363000086, 28.096177476000037],
              [34.77588951900009, 28.094956773000035],
              [34.77076256600009, 28.092922268000052],
              [34.77035566500007, 28.096136786000045],
              [34.77084394600007, 28.102728583000044],
              [34.77076256600009, 28.105902411000045],
              [34.76498457100007, 28.105902411000045],
              [34.76498457100007, 28.09910716400009],
              [34.75700931100005, 28.09910716400009],
              [34.751963738000086, 28.10761139500005],
              [34.74732506600009, 28.11200592700004],
              [34.74244225400008, 28.11155833500004],
              [34.73658287900008, 28.105902411000045],
              [34.72738691500007, 28.112127997000073],
              [34.72510826900009, 28.115057684000078],
              [34.71892337300005, 28.12303294500009],
              [34.71534264400009, 28.12763092700004],
              [34.70923912900008, 28.14008209800005],
              [34.70630944100009, 28.137600002000056],
              [34.70248457100007, 28.13499583500004],
              [34.69849694100009, 28.13153717700004],
              [34.69499759200005, 28.12645091400009],
              [34.681976759000065, 28.135158596000053],
              [34.678396030000044, 28.13076406500005],
              [34.677744988000086, 28.120794989000046],
              [34.674571160000085, 28.11277903900009],
              [34.667002800000034, 28.108710028000075],
              [34.65357506600009, 28.103583075000074],
              [34.647146030000044, 28.09910716400009],
              [34.647146030000044, 28.092922268000052],
              [34.668304884000065, 28.078599351000037],
              [34.668304884000065, 28.071193752000056],
              [34.66179446700005, 28.070786851000037],
              [34.658946160000085, 28.069159247000073],
              [34.65748131600009, 28.066961981000077],
              [34.655284050000034, 28.065008856000077],
              [34.647146030000044, 28.071193752000056],
              [34.64234459700009, 28.05459219000005],
              [34.64144941500007, 28.04169342700004],
              [34.63502037900008, 28.033270575000074],
              [34.61304772200009, 28.030218817000048],
              [34.61475670700008, 28.034979559000078],
              [34.61573326900009, 28.035711981000077],
              [34.61736087300005, 28.03546784100007],
              [34.62045332100007, 28.037665106000077],
              [34.61304772200009, 28.04450104400007],
              [34.60865319100009, 28.05882396000004],
              [34.60670006600009, 28.07184479400007],
              [34.606211785000085, 28.09601471600007],
              [34.59888756600009, 28.103257554000038],
              [34.57439212300005, 28.09406159100007],
              [34.578868035000085, 28.105902411000045],
              [34.57276451900009, 28.11277903900009],
              [34.58741295700008, 28.13182200700004],
              [34.59693444100009, 28.13890208500004],
              [34.60564212300005, 28.14256419500009],
              [34.606211785000085, 28.14752838700008],
              [34.61247806100005, 28.150336005000042],
              [34.62094160200007, 28.157375393000052],
              [34.62671959700009, 28.160549221000053],
              [34.62045332100007, 28.16738515800006],
              [34.623383009000065, 28.172674872000073],
              [34.62712649800005, 28.176662502000056],
              [34.63249759200005, 28.179388739000046],
              [34.64031009200005, 28.18105703300006],
              [34.64031009200005, 28.17641836100006],
              [34.63803144600007, 28.175441799000055],
              [34.63526451900009, 28.175726630000042],
              [34.633474155000044, 28.17487213700008],
              [34.64340254000007, 28.17023346600007],
              [34.65170332100007, 28.167792059000078],
              [34.65772545700008, 28.17055898600006],
              [34.660899285000085, 28.18105703300006],
              [34.655284050000034, 28.18105703300006],
              [34.655284050000034, 28.187892971000053],
              [34.64812259200005, 28.194240627000056],
              [34.64958743600005, 28.200873114000046],
              [34.657237175000034, 28.206284898000035],
              [34.668304884000065, 28.20897044500009],
              [34.668304884000065, 28.215765692000048],
              [34.66488691500007, 28.22451406500005],
              [34.674571160000085, 28.270453192000048],
              [34.678396030000044, 28.268459377000056],
              [34.68531334700009, 28.26593659100007],
              [34.68873131600009, 28.263617255000042],
              [34.688243035000085, 28.266791083000044],
              [34.68873131600009, 28.277289130000042],
              [34.68295332100007, 28.273830471000053],
              [34.680430535000085, 28.27167389500005],
              [34.674571160000085, 28.27724844000005],
              [34.69467207100007, 28.29441966400009],
              [34.71501712300005, 28.327460028000075],
              [34.730479363000086, 28.36359284100007],
              [34.74105879000007, 28.410589911000045],
              [34.76059004000007, 28.43659088700008],
              [34.767914259000065, 28.466457424000055],
              [34.77507571700005, 28.483343817000048],
              [34.803774704000034, 28.527132798000082],
              [34.79617273000008, 28.572185020000063],
              [34.79343208500006, 28.61943434500006],
              [34.77846952400006, 28.66450008000004],
              [34.796885613000086, 28.725816148000035],
              [34.80982506600009, 28.757961330000057],
              [34.82536868600005, 28.784369208000044],
              [34.82536868600005, 28.79059479400007],
              [34.819102410000085, 28.79059479400007],
              [34.83611087300005, 28.816473700000074],
              [34.838552280000044, 28.828558661000045],
              [34.832774285000085, 28.839585679000038],
              [34.832774285000085, 28.845851955000057],
              [34.844086134000065, 28.87641022300005],
              [34.84197024800005, 28.88963450700004],
              [34.82536868600005, 28.894232489000046],
              [34.82536868600005, 28.90037669500009],
              [34.84009850400008, 28.922430731000077],
              [34.85629316500007, 28.963812567000048],
              [34.86378014400009, 29.006252346000053],
              [34.852549675000034, 29.031398830000057],
              [34.852549675000034, 29.045070705000057],
              [34.864024285000085, 29.063666083000044],
              [34.87354576900009, 29.085272528000075],
              [34.893565300000034, 29.174750067000048],
              [34.89820397200009, 29.18773021000004],
              [34.90935306100005, 29.210150458000044],
              [34.90788821700005, 29.21637604400007],
              [34.90935306100005, 29.23065827000005],
              [34.918955925000034, 29.239081122000073],
              [34.942067905000044, 29.250474351000037],
              [34.93523196700005, 29.267279364000046],
              [34.932627800000034, 29.28925202000005],
              [34.93637129000007, 29.303859768000052],
              [34.94809004000007, 29.29828522300005],
              [34.949229363000086, 29.30149974200009],
              [34.94939212300005, 29.30426666900007],
              [34.95069420700008, 29.30573151200008],
              [34.95557701900009, 29.305121161000045],
              [34.948008660000085, 29.319973049000055],
              [34.945323113000086, 29.33690013200004],
              [34.9493851167955, 29.351685826515777],
              [35.060319458000095, 29.334696350000016],
              [35.179071899000064, 29.316661275000016],
              [35.33461796000012, 29.293148499000026],
              [35.47362756400008, 29.272064515000082],
              [35.622042277000105, 29.249688619000025],
              [35.740250622000076, 29.231730714000022],
              [35.79722538200008, 29.223075257000076],
              [35.912463827000124, 29.205686137000058],
              [36.016436808000094, 29.189950664],
              [36.04382531800013, 29.190880840000133],
              [36.06945682800006, 29.20002756800004],
              [36.17797733600008, 29.278369039000026],
              [36.28370731600006, 29.354850159000094],
              [36.3999792890001, 29.43890187600003],
              [36.47708052600012, 29.494609070000067],
              [36.54126265500008, 29.589409485000104],
              [36.603584432000105, 29.681471049000052],
              [36.64957645700008, 29.74939972],
              [36.704870239000115, 29.831151836000103],
              [36.72874475100008, 29.853527731000085],
              [36.756236613000056, 29.865516663000037],
              [36.84294966600004, 29.881226299],
              [36.93193648300013, 29.897245992000066],
              [37.075803670000084, 29.923290915000038],
              [37.21853397600006, 29.94912913000006],
              [37.352375936000044, 29.973313701000038],
              [37.47019820100007, 29.994552714000108],
              [37.4916955970001, 30.011192526000016],
              [37.5361373290001, 30.105295309],
              [37.56921024600007, 30.17495513900012],
              [37.60517704200004, 30.250712789000104],
              [37.63452925600012, 30.31277618400007],
              [37.647551718000045, 30.330862936000088],
              [37.67070275900005, 30.34760610000002],
              [37.77932662000006, 30.40041941400007],
              [37.900146118000066, 30.45907216400012],
              [37.97331994700005, 30.494522196000062],
              [37.98003788200009, 30.49808787100001],
              [37.980968058000144, 30.49839792900009],
              [37.98138146900004, 30.498811340000103],
              [37.98107141100007, 30.4994831340001],
              [37.93156538900013, 30.54966095000013],
              [37.82190800000012, 30.66086863200006],
              [37.71204390500009, 30.772024638000048],
              [37.60228316200005, 30.88323232100005],
              [37.49262577300004, 30.99449167900009],
              [37.4894218340001, 30.997695618000066],
              [37.48632124900007, 31.00089955700004],
              [37.48311730900008, 31.004103495000024],
              [37.48001672400005, 31.007255758000056],
              [37.34989546700007, 31.128230286000033],
              [37.221722009000075, 31.247292129000115],
              [37.21977421100013, 31.24910146100008],
              [37.08965295400009, 31.370075989000057],
              [36.959531698000035, 31.490998840000103],
              [36.99791151900007, 31.500813955000055],
              [37.207268514000134, 31.554354147000097],
              [37.45500533100005, 31.617709452000028],
              [37.70274214700004, 31.68111643500005],
              [37.76141217300011, 31.696120493000095],
              [37.95047896300008, 31.744471741000055],
              [37.98652246000006, 31.753358384000123],
              [38.175374796000085, 31.799920552000046],
              [38.40016727700004, 31.8553693650001],
              [38.624856405000116, 31.91086985300008],
              [38.84975223800012, 31.966318664000042],
              [38.96333703600004, 31.99437896700006],
              [38.963440389000084, 31.99432729100006],
              [38.963440389000084, 31.994482320000103],
              [38.99806359900009, 32.00693634100007],
              [39.11681604000006, 32.10289947500006],
              [39.13624637800007, 32.115353496000054],
              [39.14637496000012, 32.118144023000085],
              [39.149268840000104, 32.11891916900002],
              [39.152162719000046, 32.119745992000034],
              [39.15495324700004, 32.120572815000045],
              [39.157743774000096, 32.12134796200006],
              [39.355561157000125, 32.09256418900004],
              [39.553275187000054, 32.06372874000003],
              [39.7509892170001, 32.034893291000074],
              [39.94859989400004, 32.00610951700007],
              [40.02880171700008, 31.994482320000103],
              [40.02900842300011, 31.994482320000103],
              [40.029111776000036, 31.994430644000076],
              [40.02931848200012, 31.99437896700006],
              [40.37027958200014, 31.93846506800007],
              [40.424126424000065, 31.920533345000095],
              [40.4798336180001, 31.89283477800008],
              [40.58266971900014, 31.84043487600003],
              [40.67031294700007, 31.795683086000068],
              [40.758162882000136, 31.75108632400007],
              [40.84590946500009, 31.706334534000106],
              [40.93355269400007, 31.661634420000055],
              [41.02129927500005, 31.61693430600012],
              [41.10904585800006, 31.572285868000094],
              [41.196689087000095, 31.527585755000032],
              [41.28453902200005, 31.48283396400008],
              [41.37218225100008, 31.43813385000003],
              [41.45982548000006, 31.39343373600009],
              [41.547572062000086, 31.348733623000058],
              [41.635421997000094, 31.304033508000103],
              [41.723065226000074, 31.259385071000068],
              [41.81070845500011, 31.21468495800012],
              [41.89855839000006, 31.16998484300008],
              [41.98620162000009, 31.12528472900003],
              [42.07539514200005, 31.079861145000095],
              [42.14164432800004, 31.03040680000005],
              [42.22629032400005, 30.967464905000057],
              [42.31072961400008, 30.904523010000062],
              [42.395168905000105, 30.841581116000057],
              [42.47971154800007, 30.778639222000052],
              [42.574486125000135, 30.70763580300006],
              [42.669157349000045, 30.63668406200007],
              [42.76393192600011, 30.56562896700008],
              [42.78341257900007, 30.55104503200006],
              [42.858706502000075, 30.494677226000093],
              [42.85880985500006, 30.494625549000077],
              [42.858913208000104, 30.49457387300005],
              [42.85901656000004, 30.494522196000062],
              [42.96474654100007, 30.42000478200002],
              [43.052906535000034, 30.35778635700008],
              [43.14096317500014, 30.295671285000125],
              [43.229071493000106, 30.23350453700003],
              [43.31723148600014, 30.17133778900005],
              [43.431746460000056, 30.0905675260001],
              [43.54636478700007, 30.00979726200005],
              [43.66098311400003, 29.929026998],
              [43.77549808800006, 29.848205058000033],
              [43.82401296300009, 29.8139798590001],
              [43.89006473800009, 29.76738311800007],
              [44.00463138800012, 29.68661285400013],
              [44.11914636200004, 29.60581675200008],
              [44.23366133600007, 29.52499481200003],
              [44.32895267700013, 29.45778961300006],
              [44.424295695000126, 29.390532736000083],
              [44.51974206500006, 29.323327535000132],
              [44.61487837800013, 29.25607065900006],
              [44.69182458500012, 29.201836243000017],
              [44.69823246200008, 29.199717510000042],
              [44.70464034100013, 29.19749542200013],
              [44.710893188000114, 29.195273336000028],
              [44.7174560950001, 29.193102926000037],
              [44.80892338100006, 29.185894064000095],
              [44.88871179200004, 29.17951202400006],
              [44.96829349800004, 29.17325917600006],
              [45.04782352700005, 29.166902975000127],
              [45.1274569090001, 29.160624288000022],
              [45.22998295100007, 29.152459412],
              [45.332405640000104, 29.144372050000086],
              [45.43493168100014, 29.13620717400009],
              [45.537406047000104, 29.128119812000094],
              [45.63988041200014, 29.120032450000096],
              [45.74240645300006, 29.111867575000062],
              [45.84493249500014, 29.103754374000076],
              [45.94735518400006, 29.09564117400005],
              [46.02362959800007, 29.089595032000105],
              [46.09969730700004, 29.083574728000073],
              [46.175920044000065, 29.077476909000026],
              [46.25214278200008, 29.07145660400009],
              [46.35745935000011, 29.063136699000026],
              [46.40117761300007, 29.07127573700005],
              [46.427322320000144, 29.076143103000064],
              [46.44489587400005, 29.079414775000046],
              [46.48861413600014, 29.08757965200006],
              [46.53243575000005, 29.095744527000093],
              [46.644160197000076, 29.0836264040001],
              [46.75578129100012, 29.07153411900002],
              [46.86735070800006, 29.059415996000027],
              [46.97923018400013, 29.047220358000104],
              [47.078758992000076, 29.035748190000092],
              [47.17839115400005, 29.024224345000064],
              [47.27802331600009, 29.012700501000026],
              [47.37755212400009, 29.0012024950001],
              [47.43336267100011, 28.994717102000052],
              [47.43346602400004, 28.994717102000052],
              [47.433982788000094, 28.994613750000028],
              [47.43408614100014, 28.99458791100001],
              [47.44632323400009, 28.97624273900003],
              [47.49449589100004, 28.904024963],
              [47.54994470200012, 28.77059641600006],
              [47.55459558100006, 28.74537831700009],
              [47.5584196370001, 28.69147979800006],
              [47.56803145300012, 28.660990702000063],
              [47.58167403200014, 28.63148345900005],
              [47.596815227000036, 28.6088233440001],
              [47.618157593000035, 28.59148590100007],
              [47.64110192900006, 28.577249044000027],
              [47.65980879700004, 28.560040792000038],
              [47.668128703000036, 28.53350494400003],
              [47.72182051600009, 28.533970032000056],
              [47.89958744300009, 28.53562367800002],
              [48.077406046000135, 28.537277324000044],
              [48.255224650000116, 28.538879293],
              [48.432781227000135, 28.540479723000075],
              [48.45639082100007, 28.518459377000056],
              [48.468760613000086, 28.510646877000056],
              [48.49463951900009, 28.500148830000057],
              [48.49854576900009, 28.49290599200009],
              [48.50766035200007, 28.449164130000042],
              [48.507823113000086, 28.415716864000046],
              [48.499034050000034, 28.393377997000073],
              [48.47608483200008, 28.400783596000053],
              [48.47120201900009, 28.394191799000055],
              [48.46998131600009, 28.39130280200004],
              [48.468760613000086, 28.387111721000053],
              [48.488291863000086, 28.385891018000052],
              [48.504893425000034, 28.38963450700004],
              [48.51734459700003, 28.398993231000077],
              [48.52393639400009, 28.414455471000053],
              [48.535492384000065, 28.40761953300006],
              [48.53492272200003, 28.39866771000004],
              [48.52393639400009, 28.38031647300005],
              [48.51783287900008, 28.35419342700004],
              [48.51710045700008, 28.34243398600006],
              [48.522227410000085, 28.318833726000037],
              [48.53492272200003, 28.29881419500009],
              [48.61841881600009, 28.217271226000037],
              [48.62354576900009, 28.20526764500005],
              [48.60914147200003, 28.186102606000077],
              [48.60173587300005, 28.16738515800006],
              [48.60084069100009, 28.147772528000075],
              [48.606455925000034, 28.12645091400009],
              [48.61646569100009, 28.110541083000044],
              [48.64812259200005, 28.071966864000046],
              [48.65479576900009, 28.06159088700008],
              [48.653330925000034, 28.04987213700008],
              [48.65211022200003, 28.046087958000044],
              [48.66781660200007, 28.037665106000077],
              [48.70199629000007, 28.023993231000077],
              [48.712901238000086, 28.02289459800005],
              [48.747080925000034, 28.023993231000077],
              [48.755869988000086, 28.02171458500004],
              [48.77588951900009, 28.01194896000004],
              [48.78793379000007, 28.009711005000042],
              [48.792002800000034, 28.007025458000044],
              [48.79151451900009, 28.000799872000073],
              [48.78825931100005, 27.993882554000038],
              [48.78451582100007, 27.98924388200004],
              [48.778086785000085, 27.98663971600007],
              [48.77133222700007, 27.98700592700004],
              [48.764008009000065, 27.98924388200004],
              [48.746836785000085, 27.981634833000044],
              [48.74236087300005, 27.97524648600006],
              [48.74366295700008, 27.961330471000053],
              [48.75326582100007, 27.94798411700009],
              [48.77328535200007, 27.929754950000074],
              [48.79623457100007, 27.91364166900007],
              [48.81470787900008, 27.906683661000045],
              [48.815196160000085, 27.90224844000005],
              [48.83765709700003, 27.872300523000035],
              [48.877940300000034, 27.836818752000056],
              [48.88266035200007, 27.826727606000077],
              [48.873789910000085, 27.806586005000042],
              [48.87256920700008, 27.793890692000048],
              [48.873383009000065, 27.782131252000056],
              [48.87671959700003, 27.777004299000055],
              [48.87452233200008, 27.769924221000053],
              [48.86548912900008, 27.754055080000057],
              [48.85279381600009, 27.737494208000044],
              [48.83920332100007, 27.728583075000074],
              [48.84620201900009, 27.740301825000074],
              [48.847666863000086, 27.74872467700004],
              [48.84546959700003, 27.773260809000078],
              [48.84848066500007, 27.78729889500005],
              [48.854258660000085, 27.795355536000045],
              [48.85759524800005, 27.803534247000073],
              [48.85287519600007, 27.81793854400007],
              [48.83806399800005, 27.804022528000075],
              [48.82178795700008, 27.766831773000035],
              [48.805023634000065, 27.75649648600006],
              [48.82341556100005, 27.799627997000073],
              [48.82553144600007, 27.811102606000077],
              [48.82056725400008, 27.830023505000042],
              [48.812510613000086, 27.828599351000037],
              [48.80404707100007, 27.815008856000077],
              [48.785166863000086, 27.744696356000077],
              [48.78451582100007, 27.728583075000074],
              [48.782237175000034, 27.72614166900007],
              [48.77881920700008, 27.719549872000073],
              [48.780039910000085, 27.714097398000035],
              [48.791351759000065, 27.714911200000074],
              [48.796885613000086, 27.71971263200004],
              [48.80396569100009, 27.736476955000057],
              [48.811289910000085, 27.74282461100006],
              [48.811289910000085, 27.698187567000048],
              [48.81527754000007, 27.687567450000074],
              [48.824554884000065, 27.68895091400009],
              [48.833994988000086, 27.69745514500005],
              [48.83920332100007, 27.70807526200008],
              [48.84620201900009, 27.697088934000078],
              [48.84734134200005, 27.68382396000004],
              [48.84546959700003, 27.667141018000052],
              [48.858083530000044, 27.66282786700009],
              [48.86768639400009, 27.667792059000078],
              [48.875010613000086, 27.677476304000038],
              [48.88013756600009, 27.687567450000074],
              [48.88054446700005, 27.670314846000053],
              [48.87842858200008, 27.664211330000057],
              [48.87330162900008, 27.65965403900009],
              [48.87818444100009, 27.65058014500005],
              [48.87712649800005, 27.644476630000042],
              [48.87061608200008, 27.641180731000077],
              [48.85962975400008, 27.640448309000078],
              [48.869802280000044, 27.61855703300006],
              [48.87330162900008, 27.612494208000044],
              [48.84896894600007, 27.62335846600007],
              [48.838877800000034, 27.623195705000057],
              [48.83179772200003, 27.612494208000044],
              [48.85279381600009, 27.604641018000052],
              [48.87077884200005, 27.605617580000057],
              [48.884776238000086, 27.615057684000078],
              [48.89380944100009, 27.632961330000057],
              [48.90064537900008, 27.632961330000057],
              [48.90748131600009, 27.61871979400007],
              [48.895274285000085, 27.60773346600007],
              [48.89112389400009, 27.58812083500004],
              [48.89673912900008, 27.572007554000038],
              [48.91431725400008, 27.571519273000035],
              [48.92164147200003, 27.57884349200009],
              [48.91724694100009, 27.58584219000005],
              [48.90951582100007, 27.592678127000056],
              [48.90748131600009, 27.599432684000078],
              [48.91529381600009, 27.608628648000035],
              [48.92603600400008, 27.613836981000077],
              [48.94906660200007, 27.61871979400007],
              [48.96851647200003, 27.620347398000035],
              [48.98170006600009, 27.614569403000075],
              [49.01734459700003, 27.585191148000035],
              [49.05420983200008, 27.56826406500005],
              [49.06397545700008, 27.556341864000046],
              [49.04468834700003, 27.544175523000035],
              [49.058929884000065, 27.53815338700008],
              [49.07162519600007, 27.539496161000045],
              [49.07764733200008, 27.546535549000055],
              [49.07203209700003, 27.557847398000035],
              [49.088877800000034, 27.55109284100007],
              [49.10629316500007, 27.54686107000009],
              [49.14429772200003, 27.544175523000035],
              [49.152679884000065, 27.54633209800005],
              [49.17042076900009, 27.55573151200008],
              [49.178477410000085, 27.557847398000035],
              [49.18897545700008, 27.556708075000074],
              [49.20875084700003, 27.551581122000073],
              [49.21957441500007, 27.550441799000055],
              [49.23975670700008, 27.54511139500005],
              [49.25513756600009, 27.532375393000052],
              [49.278086785000085, 27.503241278000075],
              [49.28532962300005, 27.49762604400007],
              [49.29249108200008, 27.49412669500009],
              [49.29908287900008, 27.489894924000055],
              [49.305349155000044, 27.482123114000046],
              [49.30787194100009, 27.47451406500005],
              [49.30982506600009, 27.456691799000055],
              [49.31275475400008, 27.44863515800006],
              [49.30014082100007, 27.448065497000073],
              [49.29265384200005, 27.452948309000078],
              [49.28988691500007, 27.46234772300005],
              [49.291758660000085, 27.47532786700009],
              [49.28492272200003, 27.47532786700009],
              [49.26392662900008, 27.452866929000038],
              [49.20883222700007, 27.45807526200008],
              [49.18921959700003, 27.441148179000038],
              [49.18189537900008, 27.441148179000038],
              [49.17505944100009, 27.458319403000075],
              [49.15772545700008, 27.45848216400009],
              [49.119802280000044, 27.441148179000038],
              [49.12810306100005, 27.43691640800006],
              [49.15007571700005, 27.431341864000046],
              [49.16138756600009, 27.426906643000052],
              [49.170258009000065, 27.421047268000052],
              [49.176117384000065, 27.415838934000078],
              [49.18311608200008, 27.41111888200004],
              [49.19548587300005, 27.40643952000005],
              [49.20199629000007, 27.39866771000004],
              [49.207041863000086, 27.39516836100006],
              [49.21257571700005, 27.39679596600007],
              [49.229502800000034, 27.411810614000046],
              [49.22966556100005, 27.413885809000078],
              [49.235036655000044, 27.41815827000005],
              [49.237315300000034, 27.423976955000057],
              [49.240244988000086, 27.42719147300005],
              [49.24691816500007, 27.423773505000042],
              [49.254567905000044, 27.417792059000078],
              [49.26384524800005, 27.413885809000078],
              [49.256846550000034, 27.400051174000055],
              [49.24732506600009, 27.393133856000077],
              [49.23747806100005, 27.38812897300005],
              [49.22966556100005, 27.379706122000073],
              [49.22673587300005, 27.36871979400007],
              [49.22608483200008, 27.34275950700004],
              [49.223399285000085, 27.331284898000035],
              [49.23406009200005, 27.33388906500005],
              [49.24577884200005, 27.33942291900007],
              [49.25733483200008, 27.346909898000035],
              [49.26742597700007, 27.355210679000038],
              [49.27881920700008, 27.35879140800006],
              [49.29216556100005, 27.35545482000009],
              [49.31275475400008, 27.344956773000035],
              [49.30486087300005, 27.325506903000075],
              [49.30787194100009, 27.306301174000055],
              [49.315114780000044, 27.286810614000046],
              [49.319021030000044, 27.266424872000073],
              [49.317067905000044, 27.22370026200008],
              [49.322601759000065, 27.20571523600006],
              [49.33952884200005, 27.207831122000073],
              [49.33838951900009, 27.189601955000057],
              [49.34522545700008, 27.182806708000044],
              [49.35596764400009, 27.18500397300005],
              [49.36687259200005, 27.194159247000073],
              [49.36182701900009, 27.209133205000057],
              [49.37086022200003, 27.21873607000009],
              [49.38640384200005, 27.219631252000056],
              [49.40088951900009, 27.207831122000073],
              [49.40707441500007, 27.215277411000045],
              [49.41236412900008, 27.204006252000056],
              [49.40943444100009, 27.193915106000077],
              [49.40398196700005, 27.183294989000046],
              [49.40088951900009, 27.17023346600007],
              [49.397471550000034, 27.162583726000037],
              [49.38884524800005, 27.159328518000052],
              [49.377696160000085, 27.15916575700004],
              [49.36687259200005, 27.160630601000037],
              [49.37484785200007, 27.14907461100006],
              [49.399099155000044, 27.14472077000005],
              [49.40707441500007, 27.13271719000005],
              [49.41716556100005, 27.13812897300005],
              [49.42359459700003, 27.14647044500009],
              [49.43506920700008, 27.166815497000073],
              [49.435883009000065, 27.16233958500004],
              [49.43677819100009, 27.161769924000055],
              [49.438487175000034, 27.162054755000042],
              [49.44190514400009, 27.160630601000037],
              [49.43189537900008, 27.14276764500005],
              [49.440196160000085, 27.139797268000052],
              [49.46566816500007, 27.146958726000037],
              [49.48129316500007, 27.14443594000005],
              [49.50831139400009, 27.133978583000044],
              [49.524424675000034, 27.13271719000005],
              [49.49732506600009, 27.159084377000056],
              [49.48910566500007, 27.174750067000048],
              [49.50407962300005, 27.187933661000045],
              [49.51644941500007, 27.188381252000056],
              [49.526133660000085, 27.182806708000044],
              [49.53492272200003, 27.176174221000053],
              [49.544932488000086, 27.173651434000078],
              [49.552744988000086, 27.17674388200004],
              [49.57211347700007, 27.194159247000073],
              [49.56861412900008, 27.178290106000077],
              [49.55941816500007, 27.153998114000046],
              [49.558604363000086, 27.139553127000056],
              [49.56462649800005, 27.11668528900009],
              [49.57007897200003, 27.104071356000077],
              [49.57553144600007, 27.098578192000048],
              [49.59424889400009, 27.090725002000056],
              [49.61247806100005, 27.071966864000046],
              [49.67017662900008, 26.99091217700004],
              [49.69947350400008, 26.958238023000035],
              [49.70826256600009, 26.95213450700004],
              [49.736664259000065, 26.94090403900009],
              [49.74586022200003, 26.93427155200004],
              [49.760508660000085, 26.92064036700009],
              [49.77084394600007, 26.91356028900009],
              [49.833018425000034, 26.888006903000075],
              [49.871836785000085, 26.862494208000044],
              [49.89405358200008, 26.860296942000048],
              [49.91724694100009, 26.861476955000057],
              [49.942149285000085, 26.858343817000048],
              [49.972992384000065, 26.842352606000077],
              [50.001963738000086, 26.816961981000077],
              [50.05201256600009, 26.755926825000074],
              [50.069102410000085, 26.728583075000074],
              [50.14193769600007, 26.681341864000046],
              [50.15845787900008, 26.664862372000073],
              [50.16187584700003, 26.639227606000077],
              [50.11670983200008, 26.67536041900007],
              [50.092539910000085, 26.689113674000055],
              [50.037852410000085, 26.69521719000005],
              [50.02369225400008, 26.69953034100007],
              [50.014008009000065, 26.710760809000078],
              [50.00635826900003, 26.74762604400007],
              [49.99756920700008, 26.741359768000052],
              [49.98845462300005, 26.724432684000078],
              [49.98373457100007, 26.708197333000044],
              [49.98292076900003, 26.695705471000053],
              [49.98324629000007, 26.683742580000057],
              [49.98650149800005, 26.672756252000056],
              [49.99366295700008, 26.66315338700008],
              [50.00367272200003, 26.653631903000075],
              [50.00635826900003, 26.648586330000057],
              [50.00220787900008, 26.58738841400009],
              [50.00367272200003, 26.570705471000053],
              [50.03060957100007, 26.494614976000037],
              [50.04184004000007, 26.478461005000042],
              [50.05827884200005, 26.46393463700008],
              [50.076508009000065, 26.45376211100006],
              [50.16228274800005, 26.427069403000075],
              [50.19157962300005, 26.403550523000035],
              [50.20923912900008, 26.369533596000053],
              [50.21656334700003, 26.323919989000046],
              [50.21599368600005, 26.21507396000004],
              [50.21225019600007, 26.19131094000005],
              [50.20199629000007, 26.17137278900009],
              [50.182383660000085, 26.160101630000042],
              [50.18189537900008, 26.175482489000046],
              [50.17408287900008, 26.18073151200008],
              [50.16342207100007, 26.17723216400009],
              [50.15455162900008, 26.16624583500004],
              [50.16098066500007, 26.141099351000037],
              [50.15837649800005, 26.102484442000048],
              [50.150401238000086, 26.06321849200009],
              [50.141368035000085, 26.035956122000073],
              [50.12582441500007, 26.04645416900007],
              [50.121429884000065, 26.06073639500005],
              [50.121836785000085, 26.07648346600007],
              [50.12029056100005, 26.09121328300006],
              [50.113291863000086, 26.103257554000038],
              [50.10434004000007, 26.11123281500005],
              [50.09489993600005, 26.117621161000045],
              [50.08676191500007, 26.12531159100007],
              [50.08130944100009, 26.12909577000005],
              [50.07667076900003, 26.12909577000005],
              [50.07357832100007, 26.13153717700004],
              [50.07162519600007, 26.15924713700008],
              [50.06959069100009, 26.165961005000042],
              [50.06568444100009, 26.17373281500005],
              [50.05787194100009, 26.18357982000009],
              [50.045664910000085, 26.194525458000044],
              [50.03239993600005, 26.20107656500005],
              [50.02100670700008, 26.197658596000053],
              [49.994883660000085, 26.152167059000078],
              [49.98682701900003, 26.145819403000075],
              [49.97584069100009, 26.139593817000048],
              [49.98096764400003, 26.126125393000052],
              [49.99154707100007, 26.113104559000078],
              [49.99732506600009, 26.108221747000073],
              [49.99952233200008, 26.100897528000075],
              [50.008799675000034, 26.086493231000077],
              [50.010427280000044, 26.07689036700009],
              [50.00709069100009, 26.07440827000005],
              [50.00017337300005, 26.07217031500005],
              [49.993174675000034, 26.068060614000046],
              [49.99000084700003, 26.06045156500005],
              [49.99236087300005, 26.04588450700004],
              [49.996104363000086, 26.031724351000037],
              [49.99691816500007, 26.017279364000046],
              [49.99000084700003, 26.001776434000078],
              [50.006846550000034, 25.996527411000045],
              [50.02100670700008, 26.004461981000077],
              [50.02816816500007, 26.019476630000042],
              [50.024099155000044, 26.035956122000073],
              [50.03370201900003, 26.033351955000057],
              [50.04053795700008, 26.028265692000048],
              [50.05201256600009, 26.015448309000078],
              [50.057383660000085, 26.01316966400009],
              [50.06169681100005, 26.014146226000037],
              [50.06462649800005, 26.013373114000046],
              [50.06568444100009, 26.005519924000055],
              [50.06576582100007, 25.99945709800005],
              [50.06690514400003, 25.99628327000005],
              [50.06983483200008, 25.99510325700004],
              [50.07593834700003, 25.995021877000056],
              [50.10132897200003, 25.989488023000035],
              [50.11150149800005, 25.97601959800005],
              [50.11670983200008, 25.958238023000035],
              [50.127696160000085, 25.940375067000048],
              [50.127696160000085, 25.933539130000042],
              [50.107758009000065, 25.91474030200004],
              [50.11833743600005, 25.86786530200004],
              [50.14193769600007, 25.816107489000046],
              [50.16187584700003, 25.78270091400009],
              [50.22201582100007, 25.717352606000077],
              [50.24724368600005, 25.679429429000038],
              [50.25749759200005, 25.63190338700008],
              [50.25123131600009, 25.63190338700008],
              [50.23373457100007, 25.679510809000078],
              [50.22673587300005, 25.687160549000055],
              [50.21461022200003, 25.68964264500005],
              [50.199961785000085, 25.695868231000077],
              [50.187510613000086, 25.703558661000045],
              [50.17497806100005, 25.720445054000038],
              [50.159190300000034, 25.731756903000075],
              [50.14470462300005, 25.733343817000048],
              [50.141368035000085, 25.713812567000048],
              [50.14869225400008, 25.69985586100006],
              [50.17432701900003, 25.68301015800006],
              [50.182383660000085, 25.67283763200004],
              [50.18767337300005, 25.682928778000075],
              [50.18921959700003, 25.687160549000055],
              [50.196055535000085, 25.687160549000055],
              [50.23406009200005, 25.615179755000042],
              [50.347992384000065, 25.482123114000046],
              [50.37427819100009, 25.46116771000004],
              [50.37134850400008, 25.47451406500005],
              [50.36475670700008, 25.490057684000078],
              [50.361989780000044, 25.50299713700008],
              [50.37077884200005, 25.508368231000077],
              [50.38135826900003, 25.512884833000044],
              [50.38591556100005, 25.510646877000056],
              [50.38998457100007, 25.488674221000053],
              [50.39503014400003, 25.483303127000056],
              [50.39991295700008, 25.48037344000005],
              [50.40211022200003, 25.47797272300005],
              [50.410166863000086, 25.464097398000035],
              [50.428721550000034, 25.456203518000052],
              [50.462901238000086, 25.446926174000055],
              [50.47152754000007, 25.437201239000046],
              [50.490896030000044, 25.392279364000046],
              [50.483409050000034, 25.38544342700004],
              [50.49561608200008, 25.370062567000048],
              [50.50912519600007, 25.343573309000078],
              [50.52035566500007, 25.31476471600007],
              [50.52507571700005, 25.292669989000046],
              [50.52393639400003, 25.280218817000048],
              [50.51872806100005, 25.25800202000005],
              [50.517588738000086, 25.24485911700009],
              [50.51978600400008, 25.232123114000046],
              [50.524424675000034, 25.223089911000045],
              [50.52906334700003, 25.21629466400009],
              [50.53467858200008, 25.199042059000078],
              [50.54908287900008, 25.17479075700004],
              [50.55160566500007, 25.159491278000075],
              [50.54542076900003, 25.11859772300005],
              [50.553477410000085, 25.077948309000078],
              [50.56218509200005, 25.054836330000057],
              [50.57276451900003, 25.04287344000005],
              [50.580414259000065, 25.062160549000055],
              [50.60629316500007, 25.042710679000038],
              [50.633474155000044, 25.011419989000046],
              [50.64478600400008, 24.995062567000048],
              [50.66163170700008, 24.97996653900009],
              [50.68140709700003, 24.913885809000078],
              [50.70655358200008, 24.898871161000045],
              [50.72641035200007, 24.881659247000073],
              [50.735036655000044, 24.843410549000055],
              [50.737315300000034, 24.782171942000048],
              [50.74146569100009, 24.77057526200008],
              [50.750010613000086, 24.753119208000044],
              [50.76059004000007, 24.736395575000074],
              [50.77133222700007, 24.726955471000053],
              [50.786143425000034, 24.72724030200004],
              [50.80787194100009, 24.746649481000077],
            ],
          ],
          [
            [
              [42.186438243000055, 16.705528152000056],
              [42.186307027000055, 16.691396420000046],
              [42.18346073400005, 16.673433531000057],
              [42.17655634000005, 16.65164449300005],
              [42.17908486400006, 16.63491230200009],
              [42.18819908800003, 16.60526423600004],
              [42.17823326900009, 16.585109768000052],
              [42.17855879000007, 16.58348216400009],
              [42.15583609500004, 16.584976657000084],
              [42.127975468000045, 16.617356664000056],
              [42.105253032000064, 16.625256996000076],
              [42.08381525800007, 16.62671821300006],
              [42.07317025800006, 16.635801359000084],
              [42.10142829800009, 16.64713787700009],
              [42.117632950000086, 16.659855355000047],
              [42.11111395800003, 16.680469840000058],
              [42.08575343600006, 16.69352480200007],
              [42.06024241600005, 16.68987766500004],
              [42.030721493000044, 16.687540826000088],
              [42.010559829000044, 16.68255677400009],
              [41.99169372300008, 16.67241918800005],
              [41.975531756000066, 16.66355330400006],
              [41.955457497000054, 16.67011498100004],
              [41.932834471000035, 16.690844841000057],
              [41.91686308200008, 16.70509918500005],
              [41.89408681900005, 16.71039431400004],
              [41.86739567700005, 16.72856856100009],
              [41.84336807700004, 16.746720162000088],
              [41.83142067000006, 16.767353533000062],
              [41.824940756000046, 16.79823732400007],
              [41.80756137700007, 16.809920011000088],
              [41.790088870000034, 16.81003735900009],
              [41.77816816500007, 16.81268952000005],
              [41.78077233200008, 16.81932200700004],
              [41.779560067000034, 16.840951974000063],
              [41.764899048000075, 16.85904389600006],
              [41.755613940000046, 16.87838716600004],
              [41.75708464000007, 16.89637230200009],
              [41.771856779000075, 16.892413942000076],
              [41.77718151800008, 16.884665710000036],
              [41.78921825800006, 16.875586224000074],
              [41.828084353000065, 16.858607997000092],
              [41.849424303000035, 16.835329512000044],
              [41.86005957500004, 16.821122307000053],
              [41.86391631300006, 16.796687312000074],
              [41.863291863000086, 16.78514232000009],
              [41.881137126000056, 16.765737512000044],
              [41.89846671200007, 16.751483694000058],
              [41.90514277300008, 16.747581489000083],
              [41.941390702000035, 16.75116873400009],
              [41.95332058100007, 16.73309822500005],
              [41.973427291000064, 16.73166136000009],
              [41.99359951300005, 16.737930600000084],
              [42.01104810600009, 16.739080266000087],
              [42.02302002200008, 16.72742691600007],
              [42.02292053800005, 16.715867236000065],
              [42.03499040500009, 16.715772981000043],
              [42.06460613100006, 16.72838234200009],
              [42.03648754900007, 16.733744209000065],
              [42.02173912900008, 16.755804755000042],
              [42.033864780000044, 16.773830471000053],
              [42.041351759000065, 16.80231354400007],
              [42.047862175000034, 16.81207916900007],
              [42.06218509200005, 16.814195054000038],
              [42.06853274800005, 16.811753648000092],
              [42.076508009000065, 16.808661200000074],
              [42.10407567300007, 16.792283229000077],
              [42.10526674300007, 16.775576501000046],
              [42.11849352300004, 16.754916152000078],
              [42.11654707100007, 16.744167385000083],
              [42.14116511100008, 16.74059594600004],
              [42.147694339000054, 16.721272629000055],
              [42.186438243000055, 16.705528152000056],
            ],
          ],
          [
            [
              [41.91889266000004, 16.791154850000055],
              [41.904222599000036, 16.80282074300004],
              [41.88959525900009, 16.82091177700005],
              [41.86431311000007, 16.85192683100007],
              [41.84302971300008, 16.880346701000065],
              [41.834971550000034, 16.89166901200008],
              [41.834971550000034, 16.891750393000052],
              [41.84620201900009, 16.901271877000056],
              [41.87037194100009, 16.90265534100007],
              [41.88795006600009, 16.90778229400007],
              [41.90088951900009, 16.918361721000053],
              [41.91098066500007, 16.936021226000037],
              [41.92123457100007, 16.935207424000055],
              [41.92310631600009, 16.93504466400009],
              [41.928477410000085, 16.954901434000078],
              [41.920909050000034, 16.978949286000045],
              [41.90748131600009, 16.984808661000045],
              [41.89405358200008, 16.990668036000045],
              [41.88111412900008, 16.99168528900009],
              [41.85857181100005, 16.99640534100007],
              [41.84620201900009, 16.99746328300006],
              [41.843760613000086, 17.001898505000042],
              [41.85141035200007, 17.009914455000057],
              [41.86085045700008, 17.013617255000042],
              [41.863291863000086, 17.00495026200008],
              [41.89568118600005, 17.001898505000042],
              [41.92115319100009, 16.992010809000078],
              [41.938161655000044, 16.97288646000004],
              [41.93905683700007, 16.968817450000074],
              [41.94516035200007, 16.942287502000056],
              [41.945467515000075, 16.923272154000074],
              [41.939919297000074, 16.901473192000083],
              [41.94380161000004, 16.883458605000044],
              [41.97596302900007, 16.875504874000057],
              [41.98518076900007, 16.853596289000052],
              [41.944102410000085, 16.85301341400009],
              [41.932302280000044, 16.838364976000037],
              [41.938161655000044, 16.82135651200008],
              [41.96265709700003, 16.81313711100006],
              [41.976573113000086, 16.80499909100007],
              [41.99544167000005, 16.79700153600004],
              [42.001958466000076, 16.772556369000085],
              [42.00184477500005, 16.760987471000078],
              [41.97246962500009, 16.77790981600009],
              [41.93632268600004, 16.78845577800007],
              [41.91889266000004, 16.791154850000055],
            ],
          ],
          [
            [
              [49.565440300000034, 27.35175202000005],
              [49.58513431100005, 27.344305731000077],
              [49.63843834700003, 27.330633856000077],
              [49.68881269600007, 27.317694403000075],
              [49.67042076900003, 27.311428127000056],
              [49.65512129000007, 27.314601955000057],
              [49.64039147200003, 27.32099030200004],
              [49.623789910000085, 27.32444896000004],
              [49.60726972700007, 27.32245514500005],
              [49.591807488000086, 27.316799221000053],
              [49.57764733200008, 27.308294989000046],
              [49.565440300000034, 27.297796942000048],
              [49.55746504000007, 27.305487372000073],
              [49.55640709700003, 27.304836330000057],
              [49.551768425000034, 27.304022528000075],
              [49.543630405000044, 27.30927155200004],
              [49.53825931100005, 27.311428127000056],
              [49.538096550000034, 27.311468817000048],
              [49.538096550000034, 27.317694403000075],
              [49.551442905000044, 27.322821356000077],
              [49.55404707100007, 27.328273830000057],
              [49.549815300000034, 27.334458726000037],
              [49.54550214900007, 27.338324286000045],
              [49.54151451900009, 27.341864325000074],
              [49.531260613000086, 27.346177476000037],
              [49.520274285000085, 27.344631252000056],
              [49.50961347700007, 27.34088776200008],
              [49.50025475400008, 27.338771877000056],
              [49.48755944100009, 27.334133205000057],
              [49.474945509000065, 27.322333075000074],
              [49.463877800000034, 27.30662669500009],
              [49.45622806100005, 27.290350653000075],
              [49.45362389400009, 27.31639232000009],
              [49.47217858200008, 27.34202708500004],
              [49.50123131600009, 27.360541083000044],
              [49.531260613000086, 27.36546458500004],
              [49.54249108200008, 27.363714911000045],
              [49.55103600400008, 27.36005280200004],
              [49.565440300000034, 27.35175202000005],
            ],
          ],
          [
            [
              [37.02686608200008, 25.419623114000046],
              [37.03736412900008, 25.411810614000046],
              [37.04232832100007, 25.407375393000052],
              [37.040049675000034, 25.40643952000005],
              [37.03565514400009, 25.40818919500009],
              [37.028086785000085, 25.409328518000052],
              [37.02719160200007, 25.405178127000056],
              [37.031260613000086, 25.39874909100007],
              [37.02328535200007, 25.39984772300005],
              [37.00359134200005, 25.41152578300006],
              [36.99854576900009, 25.422430731000077],
              [37.00025475400008, 25.42918528900009],
              [36.990570509000065, 25.430121161000045],
              [36.97828209700009, 25.426947333000044],
              [36.971446160000085, 25.435288804000038],
              [36.96656334700009, 25.448960679000038],
              [36.95753014400009, 25.448960679000038],
              [36.94654381600009, 25.441880601000037],
              [36.944346550000034, 25.44879791900007],
              [36.951833530000044, 25.46751536700009],
              [36.96143639400009, 25.477769273000035],
              [36.973643425000034, 25.477850653000075],
              [36.98747806100005, 25.47601959800005],
              [36.99927819100009, 25.46942780200004],
              [37.00896243600005, 25.44985586100006],
              [37.01539147200009, 25.45058828300006],
              [37.017588738000086, 25.45770905200004],
              [37.02173912900008, 25.452785549000055],
              [37.02686608200008, 25.419623114000046],
            ],
          ],
          [
            [
              [36.942149285000085, 25.418361721000053],
              [36.95834394600007, 25.41901276200008],
              [36.96143639400009, 25.414496161000045],
              [36.94312584700009, 25.405503648000035],
              [36.93539472700007, 25.39996979400007],
              [36.924815300000034, 25.389105536000045],
              [36.914805535000085, 25.370917059000078],
              [36.89975019600007, 25.361029364000046],
              [36.87867272200009, 25.37372467700004],
              [36.859711134000065, 25.39288971600007],
              [36.84148196700005, 25.405951239000046],
              [36.80128014400009, 25.44489166900007],
              [36.79867597700007, 25.447414455000057],
              [36.79509524800005, 25.453273830000057],
              [36.79509524800005, 25.456976630000042],
              [36.79704837300005, 25.45661041900007],
              [36.79908287900008, 25.458685614000046],
              [36.797211134000065, 25.464504299000055],
              [36.78760826900009, 25.474432684000078],
              [36.776133660000085, 25.489162502000056],
              [36.77654056100005, 25.49640534100007],
              [36.787119988000086, 25.494086005000042],
              [36.796885613000086, 25.48655833500004],
              [36.815196160000085, 25.46588776200008],
              [36.82374108200008, 25.459865627000056],
              [36.84205162900008, 25.45075104400007],
              [36.87712649800005, 25.43695709800005],
              [36.89389082100007, 25.432928778000075],
              [36.90642337300005, 25.43162669500009],
              [36.91570071700005, 25.426703192000048],
              [36.920258009000065, 25.419582424000055],
              [36.899424675000034, 25.418850002000056],
              [36.89633222700007, 25.405951239000046],
              [36.904307488000086, 25.39411041900007],
              [36.91627037900008, 25.396877346000053],
              [36.928477410000085, 25.409125067000048],
              [36.942149285000085, 25.418361721000053],
            ],
          ],
          [
            [
              [36.84937584700009, 25.533026434000078],
              [36.839854363000086, 25.53583405200004],
              [36.82699629000007, 25.54718659100007],
              [36.82894941500007, 25.561346747000073],
              [36.84131920700008, 25.570013739000046],
              [36.85564212300005, 25.568304755000042],
              [36.86654707100007, 25.557521877000056],
              [36.86605879000007, 25.54588450700004],
              [36.855479363000086, 25.53668854400007],
              [36.84937584700009, 25.533026434000078],
            ],
          ],
          [
            [
              [36.79021243600005, 25.497870184000078],
              [36.78060957100007, 25.504380601000037],
              [36.77588951900009, 25.505519924000055],
              [36.77133222700007, 25.507066148000035],
              [36.765961134000065, 25.514227606000077],
              [36.76539147200009, 25.524237372000073],
              [36.756521030000044, 25.527004299000055],
              [36.742523634000065, 25.52920156500005],
              [36.73991946700005, 25.53270091400009],
              [36.74398847700007, 25.53143952000005],
              [36.742930535000085, 25.53587474200009],
              [36.734385613000086, 25.546616929000038],
              [36.71924889400009, 25.55565013200004],
              [36.70134524800005, 25.55467357000009],
              [36.69320722700007, 25.55019765800006],
              [36.68881269600007, 25.54637278900009],
              [36.68116295700008, 25.544134833000044],
              [36.68140709700009, 25.55345286700009],
              [36.69125410200007, 25.567206122000073],
              [36.70679772200009, 25.571234442000048],
              [36.725596550000034, 25.56517161700009],
              [36.77507571700005, 25.53538646000004],
              [36.78060957100007, 25.527736721000053],
              [36.785817905000044, 25.516017971000053],
              [36.80103600400008, 25.507635809000078],
              [36.81666100400008, 25.502386786000045],
              [36.83904056100005, 25.489935614000046],
              [36.87452233200008, 25.463324286000045],
              [36.88331139400009, 25.454331773000035],
              [36.881846550000034, 25.45075104400007],
              [36.877940300000034, 25.447699286000045],
              [36.87916100400008, 25.44334544500009],
              [36.873789910000085, 25.44594961100006],
              [36.858409050000034, 25.456854559000078],
              [36.84506269600007, 25.46442291900007],
              [36.83480879000007, 25.466742255000042],
              [36.830739780000044, 25.473089911000045],
              [36.82545006600009, 25.484116929000038],
              [36.81617272200009, 25.48826732000009],
              [36.80974368600005, 25.48578522300005],
              [36.80062910200007, 25.48847077000005],
              [36.79021243600005, 25.497870184000078],
            ],
          ],
          [
            [
              [36.900726759000065, 25.549302476000037],
              [36.899424675000034, 25.577785549000055],
              [36.89812259200005, 25.584051825000074],
              [36.89820397200009, 25.595445054000038],
              [36.904633009000065, 25.603176174000055],
              [36.914398634000065, 25.606634833000044],
              [36.92302493600005, 25.602850653000075],
              [36.927744988000086, 25.593085028000075],
              [36.928396030000044, 25.583807684000078],
              [36.925791863000086, 25.576564846000053],
              [36.92115319100009, 25.576239325000074],
              [36.915049675000034, 25.580552476000037],
              [36.91391035200007, 25.57880280200004],
              [36.91651451900009, 25.571437893000052],
              [36.91586347700007, 25.568019924000055],
              [36.91358483200008, 25.569159247000073],
              [36.92042076900009, 25.555121161000045],
              [36.92758222700007, 25.528509833000044],
              [36.92318769600007, 25.51943594000005],
              [36.91195722700007, 25.534979559000078],
              [36.90544681100005, 25.539129950000074],
              [36.900726759000065, 25.549302476000037],
            ],
          ],
          [
            [
              [36.68311608200008, 25.572333075000074],
              [36.681976759000065, 25.566351630000042],
              [36.67603600400008, 25.554754950000074],
              [36.66765384200005, 25.549750067000048],
              [36.66098066500007, 25.552801825000074],
              [36.64779707100007, 25.561468817000048],
              [36.56771894600007, 25.598456122000073],
              [36.54607181100005, 25.603216864000046],
              [36.539398634000065, 25.589178778000075],
              [36.52947024800005, 25.593817450000074],
              [36.510508660000085, 25.61041901200008],
              [36.49773196700005, 25.623968817000048],
              [36.49146569100009, 25.645086981000077],
              [36.49968509200005, 25.662543036000045],
              [36.524424675000034, 25.68577708500004],
              [36.53532962300005, 25.698146877000056],
              [36.543630405000044, 25.702866929000038],
              [36.545258009000065, 25.696478583000044],
              [36.539398634000065, 25.68496328300006],
              [36.52263431100005, 25.662176825000074],
              [36.52393639400009, 25.652899481000077],
              [36.53101647200009, 25.644598700000074],
              [36.53793379000007, 25.639837958000044],
              [36.543955925000034, 25.63963450700004],
              [36.548838738000086, 25.637844143000052],
              [36.55396569100009, 25.631333726000037],
              [36.56202233200008, 25.62718333500004],
              [36.570323113000086, 25.62445709800005],
              [36.59620201900009, 25.60024648600006],
              [36.609385613000086, 25.591538804000038],
              [36.62289472700007, 25.59052155200004],
              [36.63111412900008, 25.59243398600006],
              [36.633799675000034, 25.589992580000057],
              [36.63453209700009, 25.582912502000056],
              [36.63795006600009, 25.574611721000053],
              [36.647146030000044, 25.57094961100006],
              [36.65593509200005, 25.57184479400007],
              [36.65739993600005, 25.57257721600007],
              [36.65414472700007, 25.57371653900009],
              [36.65479576900009, 25.578070380000042],
              [36.65943444100009, 25.582098700000074],
              [36.66773522200009, 25.581000067000048],
              [36.68311608200008, 25.572333075000074],
            ],
          ],
          [
            [
              [36.54428144600007, 25.731350002000056],
              [36.54273522200009, 25.73932526200008],
              [36.540049675000034, 25.76048411700009],
              [36.54249108200008, 25.801947333000044],
              [36.55844160200007, 25.836371161000045],
              [36.58366946700005, 25.857896226000037],
              [36.590830925000034, 25.860541083000044],
              [36.57748457100007, 25.848578192000048],
              [36.56657962300005, 25.83299388200004],
              [36.55836022200009, 25.81582265800006],
              [36.555430535000085, 25.79633209800005],
              [36.56413821700005, 25.77879466400009],
              [36.58326256600009, 25.762274481000077],
              [36.590830925000034, 25.75934479400007],
              [36.59782962300005, 25.758368231000077],
              [36.59734134200005, 25.751695054000038],
              [36.58871504000007, 25.73851146000004],
              [36.58545983200008, 25.725490627000056],
              [36.586680535000085, 25.71979401200008],
              [36.58838951900009, 25.71426015800006],
              [36.596039259000065, 25.70888906500005],
              [36.60759524800005, 25.71124909100007],
              [36.61109459700009, 25.709458726000037],
              [36.60564212300005, 25.701117255000042],
              [36.59555097700007, 25.696600653000075],
              [36.583018425000034, 25.69867584800005],
              [36.56299889400009, 25.713283596000053],
              [36.551768425000034, 25.71979401200008],
              [36.54428144600007, 25.731350002000056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Pakistan',
        iso3: 'PAK',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [75.98108273200012, 36.445443571000084],
              [75.98743371600006, 36.42118886300007],
              [75.96862349500003, 36.34181386400009],
              [75.96883020000013, 36.30197133400007],
              [75.97658166500008, 36.286985169],
              [76.00169641100013, 36.261457011000076],
              [76.01192834500011, 36.24812449100004],
              [76.01440881400009, 36.23039947500003],
              [76.00159305800008, 36.222131246000075],
              [75.98340295400004, 36.215413310000045],
              [75.97007043500014, 36.202339172],
              [75.96914025900008, 36.19169382800003],
              [75.97740848800004, 36.17376210500005],
              [75.97658166500008, 36.162755026000056],
              [75.97151737500013, 36.15500356100004],
              [75.96417932100013, 36.14983591800005],
              [75.91456994700007, 36.12389434800009],
              [75.9014441330001, 36.113610738],
              [75.89431278500007, 36.09738433900007],
              [75.8999971930001, 36.06348459900006],
              [75.92232141100004, 36.03165191700002],
              [75.95301721200008, 36.00726064100009],
              [75.98433313000004, 35.995633444000035],
              [76.06143436700006, 35.99160268200005],
              [76.08995975700003, 35.97811513300009],
              [76.11466109200012, 35.941786601],
              [76.12375614400008, 35.9034943650001],
              [76.1277869060001, 35.86210154200005],
              [76.13812219200008, 35.82665151000002],
              [76.16602746600006, 35.806239319000085],
              [76.18979862500004, 35.804999084000045],
              [76.23713423600003, 35.815489401],
              [76.26038863200012, 35.817814840000025],
              [76.28054244000009, 35.81424916700006],
              [76.29656213400006, 35.809494935000075],
              [76.31196171000005, 35.8096499630001],
              [76.34885868300006, 35.830992330000086],
              [76.36642867100005, 35.83088897700007],
              [76.38410201000005, 35.828201803000056],
              [76.4031189370001, 35.830992330000086],
              [76.41035363800006, 35.836831767],
              [76.42244592300005, 35.85429840100004],
              [76.43205773900007, 35.860499573000126],
              [76.4429097900001, 35.86329010100009],
              [76.45396854700004, 35.86478871700008],
              [76.47649947100012, 35.86525380500011],
              [76.50016727800005, 35.871506653000026],
              [76.53716760300011, 35.90251251300005],
              [76.5554610590001, 35.89786163400008],
              [76.56527958200007, 35.86546051100008],
              [76.5511202400001, 35.78401845300003],
              [76.57075728400014, 35.75125559500013],
              [76.60424361200006, 35.73570098900011],
              [76.67669397000003, 35.71379018200007],
              [76.70904341700003, 35.694049785000104],
              [76.73291792900011, 35.66660959900004],
              [76.74542362500011, 35.6550340780001],
              [76.76340702300007, 35.64707590700003],
              [76.77735074100008, 35.6461117140001],
              [76.91316086450013, 35.37827685550006],
              [77.04897098800006, 35.110441997000024],
              [77.04242614700007, 35.10701374400007],
              [77.02313277200005, 35.08633494100006],
              [77.02706018000003, 35.062098694],
              [77.03522505700005, 35.034503479000094],
              [77.02861047400006, 35.00339426700013],
              [77.01310754400004, 34.986392721000115],
              [76.95295617700009, 34.9465501910001],
              [76.93383589700011, 34.9288768520001],
              [76.92112349500013, 34.92071197500006],
              [76.90593062300013, 34.92314076800004],
              [76.87957564300007, 34.93709340400004],
              [76.85260054600013, 34.94334625300003],
              [76.81704716000007, 34.94076243100004],
              [76.78201053900005, 34.93089223300005],
              [76.75761926300004, 34.91513092000007],
              [76.74955773900012, 34.892083232000104],
              [76.75327844200007, 34.83833974300008],
              [76.74387333200008, 34.819271138000104],
              [76.6526127520001, 34.74697581000008],
              [76.63959029100005, 34.74113637400008],
              [76.55318729700008, 34.72584014900012],
              [76.53582401500006, 34.72620188500012],
              [76.51990767400014, 34.73111114500007],
              [76.47649947100012, 34.75777618400009],
              [76.43815555800012, 34.76289215100009],
              [76.39991499800004, 34.750748190000095],
              [76.26204227700009, 34.68465403200004],
              [76.15496870900006, 34.66165802100009],
              [76.12179244000009, 34.66088287400008],
              [76.05833378100004, 34.6834137980001],
              [76.02340051300013, 34.6771609500001],
              [76.00748417200003, 34.66512034100002],
              [75.98671024600009, 34.63602651000012],
              [75.97337772700013, 34.622332256],
              [75.9662463790001, 34.61907664000002],
              [75.93927128100006, 34.612048646000105],
              [75.87395227000013, 34.57137929300005],
              [75.81617801900012, 34.52166656500005],
              [75.79581750500012, 34.50792063500002],
              [75.77711063700013, 34.503812358000104],
              [75.73483931500004, 34.5086182670001],
              [75.7136519770001, 34.50851491300007],
              [75.65556766800006, 34.49696523100003],
              [75.61164270100005, 34.49836049400001],
              [75.34809289600013, 34.55721995100003],
              [75.30695845600007, 34.57401479100007],
              [75.26747766100004, 34.59830271400007],
              [75.25135461500008, 34.6130821740001],
              [75.23688521300005, 34.631892395000094],
              [75.22454384500014, 34.63862163200007],
              [75.21290734900003, 34.644966532000055],
              [75.1763204350001, 34.645379944000055],
              [75.11100142400005, 34.633649394000074],
              [75.01777714000008, 34.62972198500002],
              [74.66493046100004, 34.68832306000003],
              [74.41212935400006, 34.76449412100003],
              [74.34887740000005, 34.773434143000046],
              [74.28583215300011, 34.76888661700012],
              [74.22175337700008, 34.747750956000075],
              [74.14682255100007, 34.70186228500002],
              [74.12088098100008, 34.690855204000016],
              [73.96223433500012, 34.668169251000066],
              [73.9485917560001, 34.662743225000085],
              [73.91934289500006, 34.64253774100008],
              [73.91748254400005, 34.619283346000074],
              [73.9254407140001, 34.59339345400004],
              [73.92595747900003, 34.56497141500002],
              [73.91097131300006, 34.54497263600008],
              [73.86311893800007, 34.517067363000095],
              [73.84699589000007, 34.49432973300013],
              [73.84699589000007, 34.49417470300007],
              [73.84554895000008, 34.456476746000035],
              [73.84038130700009, 34.44441029900007],
              [73.83159631300009, 34.436400452000086],
              [73.80679162600006, 34.425160828000045],
              [73.7962496340001, 34.418546244000126],
              [73.77981652900013, 34.396066996000016],
              [73.77485559100006, 34.37095225000009],
              [73.78271040900012, 34.34681935700006],
              [73.80420780500009, 34.327492371000076],
              [73.82911584500005, 34.315348409000094],
              [73.85330041500009, 34.30741607700004],
              [73.8790352790001, 34.30428965300008],
              [73.90745731600003, 34.30679596000006],
              [73.93773970500013, 34.30421213800007],
              [73.95437951700006, 34.287184753000034],
              [73.97670373600005, 34.237549540000046],
              [73.99055301900012, 34.21850677500008],
              [73.99830448400007, 34.19680267400007],
              [73.99541060400009, 34.17644215900005],
              [73.97670373600005, 34.16155934700002],
              [73.91686242700007, 34.13525604200005],
              [73.89329797400006, 34.11474049900009],
              [73.88440962700014, 34.08419972800009],
              [73.89371138500007, 34.054304911000074],
              [73.91624231000003, 34.027949931000094],
              [73.94580122900004, 34.00978566500008],
              [73.97670373600005, 34.00459218300007],
              [74.04501997900007, 34.01942332000009],
              [74.06527714000009, 34.01833811500008],
              [74.11840051300004, 34.002525127000084],
              [74.15426395700007, 34.004101258000034],
              [74.19209110500003, 34.01185272200003],
              [74.22836796100012, 34.01288625100001],
              [74.25968387800003, 33.99438608900009],
              [74.27229292800013, 33.96213999500013],
              [74.26247440600008, 33.92994557800007],
              [74.23953007000006, 33.9010067760001],
              [74.21255497200013, 33.878424174000074],
              [74.17751835100012, 33.8575468960001],
              [74.14227502400013, 33.844240215000085],
              [74.03458134000005, 33.82860809300006],
              [74.01132694600005, 33.81046966600012],
              [73.97670373600005, 33.75892242500002],
              [73.9707092700001, 33.747062683000095],
              [73.96616174300004, 33.73453114800007],
              [73.96306115700014, 33.72156036400007],
              [73.96078739500012, 33.692285665],
              [73.96306115700014, 33.67675689700009],
              [73.96833215400005, 33.662080790000104],
              [73.97670373600005, 33.648386536000075],
              [74.02424605300007, 33.614254252000094],
              [74.08811812300007, 33.58528961300003],
              [74.14155155500004, 33.54937449100008],
              [74.15777795400004, 33.494235738],
              [74.13628055800007, 33.418013],
              [74.10548140500003, 33.345200907],
              [74.09597294100013, 33.32848358200006],
              [74.08512089100009, 33.31432424000009],
              [74.07199507700011, 33.30228363100004],
              [74.05535526500012, 33.29202585900005],
              [74.01783817600011, 33.279494324000055],
              [74.00171512900005, 33.270166728],
              [73.99179325300014, 33.252570903000034],
              [73.98848596200014, 33.20862009700009],
              [74.00233524600009, 33.17769175200009],
              [74.02941369700005, 33.154153137],
              [74.06579390500013, 33.132604065000024],
              [74.0984534100001, 33.10482798300008],
              [74.15385054600006, 33.040180766000034],
              [74.19085087100012, 33.022094015],
              [74.28397180200011, 33.008813171],
              [74.31125695800011, 32.99429209500006],
              [74.32200565600004, 32.972045390000105],
              [74.32448612500013, 32.92140248600005],
              [74.33668176300006, 32.870139466000026],
              [74.33378788300007, 32.849262187000036],
              [74.3229358320001, 32.83052948000007],
              [74.31698854100006, 32.823067314000085],
              [74.31593865300005, 32.82175000200009],
              [74.30650272600013, 32.809910584000065],
              [74.31632124800012, 32.79107452400005],
              [74.32934370900006, 32.776424256000055],
              [74.34619022600003, 32.766889954000064],
              [74.36768762200006, 32.76353098600005],
              [74.38639449100003, 32.76776845400009],
              [74.41895064300007, 32.78461497100007],
              [74.43869104000004, 32.78598439500006],
              [74.45533085200009, 32.778594666000046],
              [74.4844763590001, 32.75353159600003],
              [74.50090946500006, 32.7460126750001],
              [74.52095992000011, 32.745289205000105],
              [74.57377323400004, 32.75254974400006],
              [74.59341027800008, 32.75787241600001],
              [74.6140808510001, 32.770403951000034],
              [74.62203902200008, 32.7854159540001],
              [74.62627648900013, 32.80265004500008],
              [74.63588830500004, 32.822080384000074],
              [74.65356164600013, 32.83742828400004],
              [74.67175175000006, 32.84058054600008],
              [74.68529097500004, 32.831227112000036],
              [74.68911503100009, 32.808825378000066],
              [74.68229374200013, 32.787327983000026],
              [74.65697229000006, 32.745340882],
              [74.64973759000009, 32.723145854000066],
              [74.6501510010001, 32.701235047000026],
              [74.65728234900007, 32.66059153300007],
              [74.65604211400012, 32.64067026800008],
              [74.64798059100013, 32.623617046000035],
              [74.63692183400013, 32.6062537640001],
              [74.62958378100012, 32.58808949800009],
              [74.63258101400004, 32.568168233000065],
              [74.6625533450001, 32.4983792120001],
              [74.68932173700006, 32.47135243800007],
              [74.72497847500006, 32.460810445],
              [74.7635290930001, 32.462670797],
              [74.79939253800006, 32.47267018700002],
              [74.83814986200008, 32.47486643500012],
              [74.9069828690001, 32.445178324000054],
              [74.94842736900006, 32.44876983600004],
              [74.99069869000004, 32.463368429000084],
              [75.02366825400009, 32.46626230900007],
              [75.05488081900006, 32.455539450000074],
              [75.09219120300008, 32.42933949800006],
              [75.12598759000008, 32.41174367300006],
              [75.19616418500004, 32.397300110000046],
              [75.23016727700008, 32.3801952110001],
              [75.29840293600006, 32.332426605000094],
              [75.32690555900007, 32.312473246000096],
              [75.35295048000006, 32.28438710600007],
              [75.35904829900011, 32.2616753140001],
              [75.34860966000008, 32.24201243200007],
              [75.31657027200009, 32.21074818900006],
              [75.30840539500008, 32.19390167300007],
              [75.29807011000014, 32.15979522700012],
              [75.29465946500005, 32.14889150000006],
              [75.26334354700003, 32.1509068810001],
              [75.24990767500009, 32.14889150000006],
              [75.22644657400008, 32.1420702110001],
              [75.19575077300004, 32.128634339000044],
              [75.17311649600009, 32.10972076500009],
              [75.17415002500007, 32.086828105000095],
              [75.16133426900012, 32.0879649860001],
              [75.13838993300004, 32.093494364],
              [75.12981164600012, 32.09023874900002],
              [75.11895959500009, 32.08104034500012],
              [75.11027795400014, 32.07762970000009],
              [75.10211307800012, 32.07809478800003],
              [75.04082482900009, 32.097990215000024],
              [75.0226347250001, 32.094682923000036],
              [75.03017948400009, 32.066415914000046],
              [75.02015425600013, 32.06584747300009],
              [74.99555627500007, 32.06739776600001],
              [74.98615116400009, 32.06321197500007],
              [74.97850305200012, 32.05339345300011],
              [74.97405887900004, 32.04497019500012],
              [74.96785770700012, 32.037890523],
              [74.95566206900014, 32.03220611600004],
              [74.93137414600011, 32.02982900100001],
              [74.9088432210001, 32.031896057000054],
              [74.88910282400013, 32.02889882500004],
              [74.8731864830001, 32.01169057200006],
              [74.82864139800012, 32.02543650300002],
              [74.81127811700009, 32.00373240100002],
              [74.80249312400008, 31.968850810000035],
              [74.78368290200007, 31.942857565000068],
              [74.76301232900005, 31.938981832000124],
              [74.69841678900013, 31.950247295000068],
              [74.6699947510001, 31.90415191600006],
              [74.65717899600014, 31.89567698200004],
              [74.64105594900013, 31.890561015000074],
              [74.56560835800013, 31.840538229000074],
              [74.55041548700012, 31.826999004000086],
              [74.5408036710001, 31.810875956000118],
              [74.53739302600007, 31.78891347300005],
              [74.53697961400007, 31.775735982000057],
              [74.53511926300007, 31.77113678000002],
              [74.5307784420001, 31.767829488000118],
              [74.52302697800008, 31.75847605400007],
              [74.52116662600008, 31.753773499000104],
              [74.5182727460001, 31.741836243000066],
              [74.51620568800013, 31.73739207000004],
              [74.51331180900013, 31.735118307000036],
              [74.50545699000008, 31.732017721],
              [74.50328658000012, 31.730570781],
              [74.49264123600011, 31.714551087000032],
              [74.48943729700005, 31.711192118000028],
              [74.49946252400008, 31.699874980000047],
              [74.55558313000012, 31.61223175100004],
              [74.58452193200009, 31.517508851000102],
              [74.61459761600014, 31.47782135100003],
              [74.61718143700006, 31.45890777600009],
              [74.61191044200012, 31.44020090800008],
              [74.60002486200011, 31.42412953700004],
              [74.58369510900008, 31.40655955000007],
              [74.57160282400008, 31.389247945000065],
              [74.53222538200009, 31.303206685000063],
              [74.52530074100008, 31.28021067300004],
              [74.52509403500005, 31.235407206000062],
              [74.50907434100009, 31.19566803000005],
              [74.50638716600014, 31.17541086900006],
              [74.50959110600013, 31.156083883000107],
              [74.51486210100006, 31.14182118700002],
              [74.52354374200013, 31.129315491000042],
              [74.5367729080001, 31.11515614900007],
              [74.55310266100014, 31.108954977000096],
              [74.59692427600004, 31.115776266000054],
              [74.61697473200007, 31.115259501000097],
              [74.63196089700006, 31.107508037000102],
              [74.65025435400014, 31.093141989000102],
              [74.65883264100006, 31.083788554000066],
              [74.60095503700006, 31.056606751000075],
              [74.57945764200008, 31.042705791000103],
              [74.56426477100007, 31.025032450000097],
              [74.56405806500004, 31.00436187800007],
              [74.54876184100004, 30.99216624000006],
              [74.53480920500004, 30.976249899000052],
              [74.51930627500008, 30.962452291000076],
              [74.49946252400008, 30.95650950100007],
              [74.47724165900013, 30.95609609000006],
              [74.45853479000004, 30.953408916000043],
              [74.44158492000014, 30.946174215000056],
              [74.42432499200004, 30.932324931],
              [74.41336958800008, 30.915065003],
              [74.40913212100014, 30.901009013000092],
              [74.40127730300009, 30.89310251900004],
              [74.37967655500012, 30.89449778300012],
              [74.35363163200003, 30.90111236600002],
              [74.34246952300003, 30.90193918900006],
              [74.32975712100006, 30.899613750000114],
              [74.3192151290001, 30.893412578000024],
              [74.31074019400006, 30.8844725550001],
              [74.30402225700004, 30.874033915000055],
              [74.31136031100004, 30.855947164000057],
              [74.30019820200005, 30.838170471000026],
              [74.27994104000004, 30.824682923000054],
              [74.26020064300008, 30.81941192600003],
              [74.2566866460001, 30.815277812000105],
              [74.26578169800007, 30.795434062000098],
              [74.26671187300013, 30.788354391000084],
              [74.25916711400009, 30.781016337],
              [74.24407759700006, 30.771249491000034],
              [74.23570601500012, 30.764118144000108],
              [74.21513879500003, 30.737453105000057],
              [74.19880904200005, 30.72499908400006],
              [74.19116093000008, 30.717040914],
              [74.18464969900003, 30.69683543000012],
              [74.17007694500006, 30.687171936000098],
              [74.16676965300007, 30.679110413],
              [74.16366906800005, 30.664899394000045],
              [74.15571089700006, 30.65957672100008],
              [74.13266320800011, 30.655494283000095],
              [74.11147587100004, 30.646244202000062],
              [74.09586958900013, 30.6371491500001],
              [74.08222701000011, 30.62588368700004],
              [74.0674475510001, 30.610535787000074],
              [74.05711226400007, 30.59157053700001],
              [74.0582491450001, 30.574465637000074],
              [74.06145308400005, 30.555603740000052],
              [74.05752567600007, 30.531367493000047],
              [74.04408980400012, 30.5186550910001],
              [74.00440230300006, 30.508939922000067],
              [73.99603072100007, 30.500981751],
              [73.98982955000008, 30.487804261000022],
              [73.93908329300012, 30.42605092400005],
              [73.92926477000003, 30.419074606000052],
              [73.91665572100004, 30.41716257800003],
              [73.89991255700005, 30.42212351500008],
              [73.90208296700007, 30.41561228400009],
              [73.90425337800013, 30.401452942000063],
              [73.90611372900014, 30.394838359000076],
              [73.88761356600014, 30.396543681000125],
              [73.86766646300009, 30.387448629000048],
              [73.85175012200006, 30.372669169000048],
              [73.84523889200011, 30.35695953400007],
              [73.84234501100013, 30.352980448],
              [73.89164432800004, 30.329777731],
              [73.91190148900012, 30.303784485000037],
              [73.9346391200001, 30.261048076000108],
              [73.94890181500006, 30.217278138000026],
              [73.94683102300007, 30.204076838000034],
              [73.94435428900005, 30.18828765900004],
              [73.7782662350001, 30.067313131000063],
              [73.73971561700006, 30.04845123300005],
              [73.55781457500012, 30.01253611300008],
              [73.38521529100012, 29.942307841000016],
              [73.37033247900007, 29.927321676000034],
              [73.32744104000011, 29.80521026600006],
              [73.28475630700012, 29.683744813000047],
              [73.23287316900013, 29.536596171000085],
              [73.1779927980001, 29.44344940200007],
              [73.1289001880001, 29.360302023000074],
              [73.05086877500008, 29.22821706100008],
              [72.98865035000006, 29.154629822000075],
              [72.96291548700009, 29.116828512000026],
              [72.93035933400012, 29.047685445000027],
              [72.91816369600014, 29.032854310000104],
              [72.90152388500007, 29.02262237600003],
              [72.77253951000006, 28.963349507000103],
              [72.65854130100007, 28.9110012820001],
              [72.52562951600004, 28.8499197390001],
              [72.3821757400001, 28.784006450000092],
              [72.35458052600006, 28.767185771000115],
              [72.2802698160001, 28.687164816000077],
              [72.25649865700012, 28.64559112500008],
              [72.1977942310001, 28.444879863000054],
              [72.17764042200008, 28.397053325000044],
              [72.14994185400008, 28.353774313000102],
              [72.11097782400009, 28.317626648000058],
              [71.98819462100005, 28.228097230000046],
              [71.90830285600003, 28.13557057700011],
              [71.89693404100007, 28.115545959000073],
              [71.89155969300009, 28.09709747400005],
              [71.87998417200004, 27.974908550000052],
              [71.87440311700004, 27.959689840000024],
              [71.86086389200005, 27.95020721500005],
              [71.70139042200003, 27.906773173000133],
              [71.56072717300009, 27.868532614000046],
              [71.47711470600007, 27.862434794000094],
              [71.39779138200004, 27.8683775840001],
              [71.31144006300008, 27.861711324000098],
              [71.22632897900013, 27.84535573400005],
              [71.15067468300009, 27.82241139800003],
              [71.02758142100004, 27.76804779000004],
              [70.91378991700003, 27.717818299],
              [70.83157271300007, 27.70146270700006],
              [70.76175785300012, 27.709782613000115],
              [70.71039147900007, 27.741150207000132],
              [70.67173750800004, 27.791095480000095],
              [70.64073164900003, 27.85478668200001],
              [70.63763106300007, 27.874217021000092],
              [70.64161014800004, 27.91126902200007],
              [70.63318688900006, 27.93162953700009],
              [70.62119795800004, 27.944135234],
              [70.59287927300011, 27.964495748000033],
              [70.55980635600014, 27.99844716400004],
              [70.53489831600007, 28.015965474000026],
              [70.50678633700005, 28.028962097000132],
              [70.47722741700011, 28.0372561650001],
              [70.45624678600012, 28.039788310000077],
              [70.43691980000006, 28.03534413700008],
              [70.39826582900014, 28.021649882000062],
              [70.35950850500012, 28.01632721],
              [70.34193851700013, 28.01146962500009],
              [70.32385176600013, 28.000436707000077],
              [70.2677311600001, 27.945272116000083],
              [70.19900150500013, 27.900959575000073],
              [70.18902784200009, 27.891790496000098],
              [70.10195316600004, 27.81174021400001],
              [70.09068770400006, 27.793550110000083],
              [70.01689375800004, 27.60059031200005],
              [69.99353601100006, 27.57108306900004],
              [69.90806319200004, 27.49728912400009],
              [69.84801517700004, 27.41036936500005],
              [69.73060632300013, 27.31032379200009],
              [69.6661141350001, 27.270016174000133],
              [69.57557702600013, 27.18841908800006],
              [69.53444258600013, 27.125580546],
              [69.50757084200012, 27.050081279000082],
              [69.48597009300005, 26.926832988000072],
              [69.46509281400012, 26.807770487000127],
              [69.47284427900007, 26.766584371000036],
              [69.50416019700003, 26.735165101000106],
              [69.65939620000006, 26.67770090800009],
              [69.70022058100005, 26.652999573000088],
              [69.77225752700014, 26.595070292000045],
              [69.81556237800004, 26.580290833000035],
              [70.05606449400005, 26.589075826000013],
              [70.09368493700009, 26.58039418600005],
              [70.12960005700006, 26.56251414000009],
              [70.15807377100009, 26.53011301700009],
              [70.16293135500013, 26.493319397000093],
              [70.15698856600011, 26.410947164],
              [70.16050256400013, 26.371311340000048],
              [70.15714359600014, 26.353999736000034],
              [70.14794519100013, 26.33322581],
              [70.14246748900013, 26.313692118000077],
              [70.14401778200005, 26.29431345700003],
              [70.15161421800013, 26.25405751600009],
              [70.14691166200004, 26.217418925000047],
              [70.1320288500001, 26.180470276000094],
              [70.07828536000011, 26.09964833600013],
              [70.07389286300008, 26.083111878000054],
              [70.07291101100003, 26.047455139000064],
              [70.06428104700012, 25.995520325000044],
              [70.06464278200008, 25.98032745400012],
              [70.08324629700007, 25.92994293300002],
              [70.11497562700009, 25.881728821000124],
              [70.15424971500005, 25.839405823000035],
              [70.19559086200007, 25.806953024],
              [70.2139876710001, 25.786334127000103],
              [70.23445153800003, 25.73098866800005],
              [70.24923099800003, 25.70768259700013],
              [70.26457889800014, 25.697295634000014],
              [70.30369795700005, 25.684583232000065],
              [70.3601286220001, 25.673472799000038],
              [70.47722741700011, 25.676315003000113],
              [70.51665653500004, 25.68385976200007],
              [70.55443200700006, 25.698794251000024],
              [70.59225915600007, 25.70881947900004],
              [70.63230839000005, 25.701378073000015],
              [70.65385746300007, 25.67445465100009],
              [70.65747481300008, 25.633630270000097],
              [70.65282393400008, 25.545883687000057],
              [70.64662276300004, 25.431368713000055],
              [70.65447758000005, 25.396590475000025],
              [70.67039392100008, 25.37555816700008],
              [70.7104948330001, 25.335870667],
              [70.71855635600008, 25.310807597000107],
              [70.72310388200003, 25.287294820000014],
              [70.73488610900012, 25.267347717000078],
              [70.7683724370001, 25.233086243000074],
              [70.83141768400003, 25.183321839000072],
              [70.84857425900009, 25.163323060000025],
              [70.85989139800006, 25.139448548000033],
              [70.89332605000004, 25.00188588500005],
              [70.91523685700008, 24.946617941000042],
              [70.94303877700008, 24.894063009000078],
              [71.00319014500008, 24.80820261700005],
              [71.03693485500008, 24.72074025500008],
              [71.05663232900014, 24.69281974700006],
              [71.06385827700007, 24.682577209],
              [71.04334273300003, 24.66906382300003],
              [70.97714522300004, 24.63968577100006],
              [70.96277917500004, 24.61578542100007],
              [70.95482100400005, 24.584521180000067],
              [70.95776656100008, 24.55602162700002],
              [70.97714522300004, 24.540389506000068],
              [70.98086592600004, 24.53473093700005],
              [70.98189945500013, 24.528529765000044],
              [70.98050419100014, 24.52188934400006],
              [70.97714522300004, 24.515068054],
              [70.9747681070001, 24.49496592200002],
              [70.97321781400007, 24.487240295000035],
              [70.97311446100014, 24.479643860000053],
              [70.97435469500005, 24.472202453000037],
              [70.97714522300004, 24.464941915000068],
              [71.00008955900006, 24.4529013060001],
              [71.04008711800003, 24.446777649000026],
              [71.07502038600012, 24.436416525000126],
              [71.08277185000014, 24.411508484000066],
              [71.07305668100008, 24.402103374],
              [71.02510095200006, 24.386290385],
              [71.01435225500006, 24.375205790000095],
              [71.00711755400005, 24.363966167000044],
              [70.99667891500013, 24.356602275000043],
              [70.97714522300004, 24.357248230000025],
              [70.9553377690001, 24.365904033000064],
              [70.93632084200004, 24.367195943000112],
              [70.91771732600006, 24.361718242000038],
              [70.85653243000007, 24.323813578000042],
              [70.84092614800011, 24.30583018000003],
              [70.84454349800012, 24.288286031000084],
              [70.85756595900006, 24.27167205800005],
              [70.85146813900008, 24.26487660700012],
              [70.83410485800005, 24.261285095000048],
              [70.81358931500012, 24.254463807],
              [70.77602054900007, 24.23668711400005],
              [70.75545332900009, 24.231441956000126],
              [70.62150801600012, 24.241157125000072],
              [70.5847143960001, 24.25790028900012],
              [70.56766117400008, 24.272808940000075],
              [70.56021976700004, 24.28725250300009],
              [70.55536218300011, 24.327017518],
              [70.54564701400011, 24.362183330000065],
              [70.54647383700012, 24.373138733000033],
              [70.55195153800008, 24.379365744000026],
              [70.56921146600007, 24.38988189800007],
              [70.57520593200013, 24.400036316000026],
              [70.5629069420001, 24.424091695000058],
              [70.52094567900008, 24.424918519000087],
              [70.41635258000008, 24.401948344000047],
              [70.37077396700005, 24.372363587],
              [70.35320397900011, 24.366265768000048],
              [70.29853031400006, 24.363423564000087],
              [70.27909997600005, 24.35507782000012],
              [70.24256473800006, 24.33060902900006],
              [70.22277266400005, 24.326707459000104],
              [70.20220544400007, 24.32557057800001],
              [70.14458622300003, 24.30789723700009],
              [70.10970463000012, 24.30490000400009],
              [70.09787072800003, 24.29882802300004],
              [70.08717370700003, 24.28254994700002],
              [70.06298913600006, 24.2203056850001],
              [70.05213708500008, 24.202063904000042],
              [70.01596358300009, 24.17405527800004],
              [69.97203861500003, 24.16521860800013],
              [69.76905358900007, 24.162557272000114],
              [69.7145866300001, 24.16857757600006],
              [69.67055830900011, 24.188705546],
              [69.59232019000007, 24.264618226000053],
              [69.56307133000013, 24.276762187000045],
              [69.28081465700012, 24.283738506000034],
              [69.20624556500007, 24.258572083],
              [69.16671309400004, 24.253171896000126],
              [69.1482129310001, 24.25666005500007],
              [69.09188562000008, 24.28190399200004],
              [69.06770105000004, 24.288441061000114],
              [69.04847741700007, 24.285237121000037],
              [69.00780806500006, 24.264566549000037],
              [68.98078129100008, 24.25539398200003],
              [68.9626428630001, 24.257228495000035],
              [68.94869022600011, 24.270276795000072],
              [68.92941491800013, 24.302367859000086],
              [68.92197351100003, 24.310506897000025],
              [68.91318851700004, 24.317250671000053],
              [68.9041968190001, 24.32058380200006],
              [68.89029585800012, 24.31947275900005],
              [68.88507653800008, 24.313555807000043],
              [68.88326786300013, 24.30536509200003],
              [68.88011560100006, 24.29735524500005],
              [68.84890303600008, 24.24402516700006],
              [68.83877445500013, 24.23645457],
              [68.81965417500004, 24.250303853000062],
              [68.81381473800013, 24.308439840000048],
              [68.79919030800005, 24.32908457400005],
              [68.74730716900007, 24.331177470000043],
              [68.72591312700007, 24.289216207000024],
              [68.72555139200006, 24.208911032000103],
              [68.72508630400011, 24.10405955000003],
              [68.72446618700008, 23.965179139000085],
              [68.64643477400006, 23.965695903000025],
              [68.54783614100006, 23.966316020000093],
              [68.43156416900007, 23.967142843000104],
              [68.38546879000006, 23.960424907000075],
              [68.35363610900009, 23.939289246000058],
              [68.35384281400007, 23.947169902],
              [68.35239587400008, 23.95654917400013],
              [68.34888187700011, 23.964610698000044],
              [68.34262902800003, 23.9685639450001],
              [68.33043339000011, 23.966574402000063],
              [68.32986494900007, 23.95815114400007],
              [68.33368900500011, 23.948048401000037],
              [68.33503259300005, 23.940994568000107],
              [68.32598921800007, 23.92779123900003],
              [68.31405196100013, 23.91590566100008],
              [68.30040938300004, 23.910505473000043],
              [68.28619836500008, 23.91637074800012],
              [68.2800488690001, 23.92572418300007],
              [68.27767175300005, 23.933501486000083],
              [68.27400272600005, 23.93768727700011],
              [68.26392582200003, 23.935930277000026],
              [68.25493412300011, 23.929108989000085],
              [68.25266036000005, 23.920091452000023],
              [68.2530737720001, 23.911228943000125],
              [68.25193689000008, 23.904821066000082],
              [68.25374556500009, 23.902779847000133],
              [68.25793135600009, 23.89947255500003],
              [68.26036014800007, 23.89554514600006],
              [68.2567944750001, 23.891927796000076],
              [68.25286706500003, 23.891695252000105],
              [68.24304854300004, 23.893426412000096],
              [68.23994795800013, 23.893116353],
              [68.23291996300009, 23.889111430000114],
              [68.21503991700007, 23.881747539000017],
              [68.20728845300005, 23.877019145000034],
              [68.18351729300008, 23.843300273000054],
              [68.18303470100005, 23.84210846600007],
              [68.18311608200008, 23.843451239000046],
              [68.15748131600003, 23.905096747000073],
              [68.15642337300005, 23.87400950700004],
              [68.15748131600003, 23.864162502000056],
              [68.16016686300009, 23.857855536000045],
              [68.16871178500008, 23.84479401200008],
              [68.17058353000004, 23.839911200000074],
              [68.16675866000008, 23.820013739000046],
              [68.14869225400008, 23.780910549000055],
              [68.14332116000008, 23.76113515800006],
              [68.14421634200005, 23.74315013200004],
              [68.15479576900003, 23.71430084800005],
              [68.15748131600003, 23.696234442000048],
              [68.14909915500004, 23.694525458000044],
              [68.13038170700008, 23.708197333000044],
              [68.10222415500004, 23.73383209800005],
              [68.09888756600003, 23.70929596600007],
              [68.08171634200005, 23.708685614000046],
              [68.06275475400008, 23.723130601000037],
              [68.05388431100005, 23.74371979400007],
              [68.05697675900007, 23.75096263200004],
              [68.07105553500008, 23.760646877000056],
              [68.07439212300005, 23.764837958000044],
              [68.07325280000003, 23.78343333500004],
              [68.07439212300005, 23.788397528000075],
              [68.08171634200005, 23.80565013200004],
              [68.08822675900007, 23.809515692000048],
              [68.10222415500004, 23.809515692000048],
              [68.10222415500004, 23.815741278000075],
              [68.08838951900003, 23.82607656500005],
              [68.07252037900008, 23.841864325000074],
              [68.05941816500007, 23.861883856000077],
              [68.05388431100005, 23.88467031500005],
              [68.06169681100005, 23.911281643000052],
              [68.06373131600003, 23.923163153000075],
              [68.04769941500007, 23.921210028000075],
              [68.02418053500008, 23.935248114000046],
              [68.01351972700007, 23.939276434000078],
              [68.04151451900003, 23.85224030200004],
              [68.05388431100005, 23.829413153000075],
              [68.03565514400003, 23.79242584800005],
              [68.02442467500003, 23.774603583000044],
              [68.01351972700007, 23.76854075700004],
              [68.00798587300005, 23.774237372000073],
              [68.00342858200008, 23.785305080000057],
              [68.00033613400007, 23.797308661000045],
              [67.99927819100003, 23.805812893000052],
              [67.99415123800009, 23.81118398600006],
              [67.98316491000008, 23.80963776200008],
              [67.97339928500008, 23.805243231000077],
              [67.97193444100003, 23.802069403000075],
              [67.96192467500003, 23.80467357000009],
              [67.95085696700005, 23.80890534100007],
              [67.94166100400008, 23.81586334800005],
              [67.93775475400008, 23.826320705000057],
              [67.93425540500004, 23.83299388200004],
              [67.92603600400008, 23.834051825000074],
              [67.91675866000008, 23.833644924000055],
              [67.90992272200003, 23.83624909100007],
              [67.90463300900007, 23.846258856000077],
              [67.90593509200005, 23.85927969000005],
              [67.89991295700008, 23.867580471000053],
              [67.89193769600007, 23.869574286000045],
              [67.88347415500004, 23.86481354400007],
              [67.86890709700003, 23.850490627000056],
              [67.86451256600003, 23.865790106000077],
              [67.86329186300009, 23.902818101000037],
              [67.85523522200003, 23.911932684000078],
              [67.84913170700008, 23.889471747000073],
              [67.83904056100005, 23.823391018000052],
              [67.83171634200005, 23.809515692000048],
              [67.80258222700007, 23.81281159100007],
              [67.77320397200003, 23.821112372000073],
              [67.71859785200007, 23.843695380000042],
              [67.73072350400008, 23.835598049000055],
              [67.74105879000007, 23.823065497000073],
              [67.74366295700008, 23.80878327000005],
              [67.73226972700007, 23.79523346600007],
              [67.71566816500007, 23.79169342700004],
              [67.69361412900008, 23.793443101000037],
              [67.65658613400007, 23.802069403000075],
              [67.64649498800009, 23.802883205000057],
              [67.63770592500003, 23.80174388200004],
              [67.63160241000008, 23.80345286700009],
              [67.62924238400007, 23.812648830000057],
              [67.63070722700007, 23.824774481000077],
              [67.63428795700008, 23.83307526200008],
              [67.63884524800005, 23.840643622000073],
              [67.64291425900007, 23.850490627000056],
              [67.65105228000004, 23.907049872000073],
              [67.65658613400007, 23.91937897300005],
              [67.65658613400007, 23.925604559000078],
              [67.65202884200005, 23.92527903900009],
              [67.65105228000004, 23.926906643000052],
              [67.65121504000007, 23.929754950000074],
              [67.65040123800009, 23.93305084800005],
              [67.63803144600007, 23.91592031500005],
              [67.63738040500004, 23.874253648000035],
              [67.62924238400007, 23.856675523000035],
              [67.61451256600003, 23.850083726000037],
              [67.59961998800009, 23.85423411700009],
              [67.58936608200008, 23.866522528000075],
              [67.58838951900003, 23.88467031500005],
              [67.57455488400007, 23.87177155200004],
              [67.56609134200005, 23.87645091400009],
              [67.55811608200008, 23.88865794500009],
              [67.54664147200003, 23.898260809000078],
              [67.53256269600007, 23.89915599200009],
              [67.53012129000007, 23.89126211100006],
              [67.53589928500008, 23.880031643000052],
              [67.54664147200003, 23.87099844000005],
              [67.49105879000007, 23.88312409100007],
              [67.47852623800009, 23.891506252000056],
              [67.48804772200003, 23.893052476000037],
              [67.49529056100005, 23.892279364000046],
              [67.50261478000004, 23.89288971600007],
              [67.51254316500007, 23.898260809000078],
              [67.52051842500003, 23.907049872000073],
              [67.53223717500003, 23.92914459800005],
              [67.54053795700008, 23.939276434000078],
              [67.53052819100003, 23.935492255000042],
              [67.51986738400007, 23.928290106000077],
              [67.50904381600003, 23.92324453300006],
              [67.49887129000007, 23.925604559000078],
              [67.49691816500007, 23.935614325000074],
              [67.49976647200003, 23.951646226000037],
              [67.50635826900003, 23.97402578300006],
              [67.46363366000008, 23.98200104400007],
              [67.45118248800009, 23.98769765800006],
              [67.46810957100007, 24.021958726000037],
              [67.47820071700005, 24.032416083000044],
              [67.49219811300009, 24.02802155200004],
              [67.51986738400007, 24.045070705000057],
              [67.52979576900003, 24.05491771000004],
              [67.53305097700007, 24.070257880000042],
              [67.50977623800009, 24.052069403000075],
              [67.48910566500007, 24.05410390800006],
              [67.46729576900003, 24.064154364000046],
              [67.44068444100003, 24.070257880000042],
              [67.38355553500008, 24.066799221000053],
              [67.35401451900003, 24.070868231000077],
              [67.34131920700008, 24.086371161000045],
              [67.33708743600005, 24.118963934000078],
              [67.32642662900008, 24.143784898000035],
              [67.30030358200008, 24.18626536700009],
              [67.29558353000004, 24.19920482000009],
              [67.29330488400007, 24.212225653000075],
              [67.29232832100007, 24.261867580000057],
              [67.28842207100007, 24.269964911000045],
              [67.27914472700007, 24.28123607000009],
              [67.28386478000004, 24.287909247000073],
              [67.28931725400008, 24.298651434000078],
              [67.29281660200007, 24.30296458500004],
              [67.28598066500007, 24.32957591400009],
              [67.30591881600003, 24.34284088700008],
              [67.33643639400003, 24.34642161700009],
              [67.36247806100005, 24.34393952000005],
              [67.34253991000008, 24.35382721600007],
              [67.32536868600005, 24.35761139500005],
              [67.28296959700003, 24.35761139500005],
              [67.27165774800005, 24.369086005000042],
              [67.27361087300005, 24.395086981000077],
              [67.28663170700008, 24.439520575000074],
              [67.28052819100003, 24.43231842700004],
              [67.27361087300005, 24.426947333000044],
              [67.25879967500003, 24.419094143000052],
              [67.25684655000003, 24.444973049000055],
              [67.24683678500008, 24.467962958000044],
              [67.23072350400008, 24.488836981000077],
              [67.21094811300009, 24.50844961100006],
              [67.23080488400007, 24.525091864000046],
              [67.22673587300005, 24.532375393000052],
              [67.20411217500003, 24.535101630000042],
              [67.19459069100003, 24.547267971000053],
              [67.18864993600005, 24.561346747000073],
              [67.18523196700005, 24.576117255000042],
              [67.18360436300009, 24.590318101000037],
              [67.19947350400008, 24.584784247000073],
              [67.21810957100007, 24.582424221000053],
              [67.23666425900007, 24.58397044500009],
              [67.25261478000004, 24.590318101000037],
              [67.22388756600003, 24.607163804000038],
              [67.20899498800009, 24.613755601000037],
              [67.19044030000003, 24.617661851000037],
              [67.17269941500007, 24.61587148600006],
              [67.15992272200003, 24.612250067000048],
              [67.15211022200003, 24.615708726000037],
              [67.14958743600005, 24.63507721600007],
              [67.15699303500008, 24.662909247000073],
              [67.17554772200003, 24.688706773000035],
              [67.19996178500008, 24.710638739000046],
              [67.22461998800009, 24.726955471000053],
              [67.25294030000003, 24.740383205000057],
              [67.25554446700005, 24.747992255000042],
              [67.24512780000003, 24.761664130000042],
              [67.23267662900008, 24.770738023000035],
              [67.22380618600005, 24.76972077000005],
              [67.21265709700003, 24.76471588700008],
              [67.17603600400008, 24.75771719000005],
              [67.16732832100007, 24.760158596000053],
              [67.16163170700008, 24.781398830000057],
              [67.15601647200003, 24.791571356000077],
              [67.14820397200003, 24.79979075700004],
              [67.13965905000003, 24.803290106000077],
              [67.12183678500008, 24.801214911000045],
              [67.11109459700003, 24.797756252000056],
              [67.09994550900007, 24.79706452000005],
              [67.08122806100005, 24.803290106000077],
              [67.07374108200008, 24.795803127000056],
              [67.08253014400003, 24.77415599200009],
              [67.06373131600003, 24.781683661000045],
              [67.02295983200008, 24.81004466400009],
              [67.00505618600005, 24.81354401200008],
              [66.98731530000003, 24.822211005000042],
              [66.97299238400007, 24.833156643000052],
              [66.96509850400008, 24.843573309000078],
              [66.95769290500004, 24.843573309000078],
              [66.95785566500007, 24.825425523000035],
              [66.96021569100003, 24.81781647300005],
              [66.96509850400008, 24.81004466400009],
              [66.94117272200003, 24.812567450000074],
              [66.92188561300009, 24.824286200000074],
              [66.90333092500003, 24.839178778000075],
              [66.88209069100003, 24.85101959800005],
              [66.85377037900008, 24.85224030200004],
              [66.82732181100005, 24.844142971000053],
              [66.80250084700003, 24.839544989000046],
              [66.77963300900007, 24.85101959800005],
              [66.76929772200003, 24.84723541900007],
              [66.71631920700008, 24.841538804000038],
              [66.69141686300009, 24.832586981000077],
              [66.67969811300009, 24.830552476000037],
              [66.65414472700007, 24.839178778000075],
              [66.65674889400003, 24.858710028000075],
              [66.67701256600003, 24.87954336100006],
              [66.70443769600007, 24.89203522300005],
              [66.70443769600007, 24.898871161000045],
              [66.68132571700005, 24.910549221000053],
              [66.68132571700005, 24.948879299000055],
              [66.69703209700003, 25.025458075000074],
              [66.69955488400007, 25.085272528000075],
              [66.70443769600007, 25.104315497000073],
              [66.71355228000004, 25.120754299000055],
              [66.73226972700007, 25.14325592700004],
              [66.73796634200005, 25.159491278000075],
              [66.73715254000007, 25.18109772300005],
              [66.72144616000008, 25.212591864000046],
              [66.71753991000008, 25.23118724200009],
              [66.71021569100003, 25.23924388200004],
              [66.67408287900008, 25.26902903900009],
              [66.65951582100007, 25.27558014500005],
              [66.64828535200007, 25.28318919500009],
              [66.59522545700008, 25.330226955000057],
              [66.56072024800005, 25.349676825000074],
              [66.54786217500003, 25.365627346000053],
              [66.55372155000003, 25.38544342700004],
              [66.57927493600005, 25.379380601000037],
              [66.59115644600007, 25.399603583000044],
              [66.58708743600005, 25.426214911000045],
              [66.56421959700003, 25.43943919500009],
              [66.55054772200003, 25.457098700000074],
              [66.54167728000004, 25.49217357000009],
              [66.53101647200003, 25.518133856000077],
              [66.51270592500003, 25.508368231000077],
              [66.51059004000007, 25.512925523000035],
              [66.50733483200008, 25.51756419500009],
              [66.50586998800009, 25.522040106000077],
              [66.49284915500004, 25.518052476000037],
              [66.48658287900008, 25.52562083500004],
              [66.48292076900003, 25.538234768000052],
              [66.47787519600007, 25.549302476000037],
              [66.44410241000008, 25.582505601000037],
              [66.43702233200008, 25.597723700000074],
              [66.41211998800009, 25.59056224200009],
              [66.38770592500003, 25.59243398600006],
              [66.37256920700008, 25.603908596000053],
              [66.37549889400003, 25.62567780200004],
              [66.35865319100003, 25.614488023000035],
              [66.33855228000004, 25.60809967700004],
              [66.30323326900003, 25.60455963700008],
              [66.29127037900008, 25.605943101000037],
              [66.27051842500003, 25.61163971600007],
              [66.25814863400007, 25.61200592700004],
              [66.25424238400007, 25.60960521000004],
              [66.24838300900007, 25.604681708000044],
              [66.23975670700008, 25.59992096600007],
              [66.20394941500007, 25.59320709800005],
              [66.18344160200007, 25.58161041900007],
              [66.16716556100005, 25.566066799000055],
              [66.15577233200008, 25.549302476000037],
              [66.13738040500004, 25.513820705000057],
              [66.13160241000008, 25.508368231000077],
              [66.12086022200003, 25.50458405200004],
              [66.10962975400008, 25.495428778000075],
              [66.09994550900007, 25.48436107000009],
              [66.09441165500004, 25.47483958500004],
              [66.12110436300009, 25.475165106000077],
              [66.20045006600003, 25.48786041900007],
              [66.21306399800005, 25.491359768000052],
              [66.22364342500003, 25.49949778900009],
              [66.23845462300005, 25.51581452000005],
              [66.24154707100007, 25.518459377000056],
              [66.24512780000003, 25.520412502000056],
              [66.24968509200005, 25.521633205000057],
              [66.25513756600003, 25.522040106000077],
              [66.25879967500003, 25.52484772300005],
              [66.25831139400003, 25.531398830000057],
              [66.25684655000003, 25.53847890800006],
              [66.25814863400007, 25.543117580000057],
              [66.27914472700007, 25.549994208000044],
              [66.30933678500008, 25.554022528000075],
              [66.33643639400003, 25.55337148600006],
              [66.34831790500004, 25.546210028000075],
              [66.35271243600005, 25.535549221000053],
              [66.36353600400008, 25.53034088700008],
              [66.37696373800009, 25.527044989000046],
              [66.38851972700007, 25.522040106000077],
              [66.39714603000004, 25.512884833000044],
              [66.41195722700007, 25.491115627000056],
              [66.42318769600007, 25.481024481000077],
              [66.43726647200003, 25.49127838700008],
              [66.45622806100005, 25.496039130000042],
              [66.47584069100003, 25.493312893000052],
              [66.49219811300009, 25.481024481000077],
              [66.45753014400003, 25.45376211100006],
              [66.49789472700007, 25.430487372000073],
              [66.51156660200007, 25.414211330000057],
              [66.49838300900007, 25.398504950000074],
              [66.48389733200008, 25.400539455000057],
              [66.46550540500004, 25.41160716400009],
              [66.43702233200008, 25.433254299000055],
              [66.35954837300005, 25.465236721000053],
              [66.31185957100007, 25.47492096600007],
              [66.27865644600007, 25.467352606000077],
              [66.25180097700007, 25.47288646000004],
              [66.21949303500008, 25.464911200000074],
              [66.18702233200008, 25.452948309000078],
              [66.15919030000003, 25.446926174000055],
              [66.06902103000004, 25.446234442000048],
              [66.00464928500008, 25.429632880000042],
              [65.92448978000004, 25.41860586100006],
              [65.88152103000004, 25.419623114000046],
              [65.85840905000003, 25.41754791900007],
              [65.82398522200003, 25.40224844000005],
              [65.80030358200008, 25.395819403000075],
              [65.76539147200003, 25.37799713700008],
              [65.72437584700003, 25.371161200000074],
              [65.67164147200003, 25.347398179000038],
              [65.65211022200003, 25.34446849200009],
              [65.62973066500007, 25.346909898000035],
              [65.48812910200007, 25.38312409100007],
              [65.46778405000003, 25.38544342700004],
              [65.44605553500008, 25.381008205000057],
              [65.42286217500003, 25.372381903000075],
              [65.40072675900007, 25.36668528900009],
              [65.38233483200008, 25.371161200000074],
              [65.38697350400008, 25.37641022300005],
              [65.39535566500007, 25.392279364000046],
              [65.36280358200008, 25.390570380000042],
              [65.33619225400008, 25.385321356000077],
              [65.31324303500008, 25.37685781500005],
              [65.29232832100007, 25.364976304000038],
              [65.25977623800009, 25.38043854400007],
              [65.23226972700007, 25.37067291900007],
              [65.21111087300005, 25.34784577000005],
              [65.18799889400003, 25.311021226000037],
              [65.18018639400003, 25.303656317000048],
              [65.17017662900008, 25.29946523600006],
              [65.15528405000003, 25.296087958000044],
              [65.14340254000007, 25.29588450700004],
              [65.11801191500007, 25.301947333000044],
              [65.08961022200003, 25.305568752000056],
              [65.05884850400008, 25.314520575000074],
              [65.04200280000003, 25.31659577000005],
              [64.98064212300005, 25.31659577000005],
              [64.92066491000008, 25.327053127000056],
              [64.88965905000003, 25.32835521000004],
              [64.86109459700003, 25.31659577000005],
              [64.83912194100003, 25.325344143000052],
              [64.80730228000004, 25.328517971000053],
              [64.74439537900008, 25.324042059000078],
              [64.71851647200003, 25.314398505000042],
              [64.69597415500004, 25.29759349200009],
              [64.67855879000007, 25.27680084800005],
              [64.66863040500004, 25.255113023000035],
              [64.66277103000004, 25.229071356000077],
              [64.66334069100003, 25.21702708500004],
              [64.66863040500004, 25.206732489000046],
              [64.67986087300005, 25.20148346600007],
              [64.69629967500003, 25.197088934000078],
              [64.70915774800005, 25.190659898000035],
              [64.71021569100003, 25.179388739000046],
              [64.70232181100005, 25.17877838700008],
              [64.65503991000008, 25.165716864000046],
              [64.64063561300009, 25.166571356000077],
              [64.61524498800009, 25.173163153000075],
              [64.60035241000008, 25.173163153000075],
              [64.62696373800009, 25.21161530200004],
              [64.62769616000008, 25.228461005000042],
              [64.61060631600003, 25.251695054000038],
              [64.59302819100003, 25.26129791900007],
              [64.56544030000003, 25.27024974200009],
              [64.53711998800009, 25.275864976000037],
              [64.51840254000007, 25.27558014500005],
              [64.50660241000008, 25.266913153000075],
              [64.49203535200007, 25.24567291900007],
              [64.48023522200003, 25.241441148000035],
              [64.46753991000008, 25.240383205000057],
              [64.44800866000008, 25.23574453300006],
              [64.43930097700007, 25.23460521000004],
              [64.41749108200008, 25.24091217700004],
              [64.38282311300009, 25.27147044500009],
              [64.36068769600007, 25.283026434000078],
              [64.31820722700007, 25.292303778000075],
              [64.27507571700005, 25.296087958000044],
              [64.26579837300005, 25.298651434000078],
              [64.25277754000007, 25.31159088700008],
              [64.24463951900003, 25.31659577000005],
              [64.18392988400007, 25.31867096600007],
              [64.09449303500008, 25.335882880000042],
              [64.09473717500003, 25.34992096600007],
              [64.10368899800005, 25.36786530200004],
              [64.10694420700008, 25.38544342700004],
              [64.10173587300005, 25.39085521000004],
              [64.09229576900003, 25.39598216400009],
              [64.08350670700008, 25.403509833000044],
              [64.07960045700008, 25.41620514500005],
              [64.08375084700003, 25.42674388200004],
              [64.09376061300009, 25.431789455000057],
              [64.10621178500008, 25.433254299000055],
              [64.11744225400008, 25.433254299000055],
              [64.14087975400008, 25.428859768000052],
              [64.15088951900003, 25.432114976000037],
              [64.15528405000003, 25.446926174000055],
              [64.15072675900007, 25.45140208500004],
              [64.14063561300009, 25.45335521000004],
              [64.12728925900007, 25.45376211100006],
              [64.08155358200008, 25.443752346000053],
              [64.05648847700007, 25.44171784100007],
              [64.04542076900003, 25.450344143000052],
              [63.98959394600007, 25.425441799000055],
              [63.976573113000086, 25.41278717700004],
              [63.99138431100005, 25.41665273600006],
              [63.997080925000034, 25.419623114000046],
              [64.00424238400007, 25.402044989000046],
              [64.01172936300009, 25.397284247000073],
              [64.02149498800009, 25.402736721000053],
              [64.03516686300009, 25.41620514500005],
              [64.04883873800009, 25.416489976000037],
              [64.06169681100005, 25.39915599200009],
              [64.07960045700008, 25.364976304000038],
              [64.06674238400007, 25.346258856000077],
              [64.05974368600005, 25.344549872000073],
              [64.04200280000003, 25.34446849200009],
              [64.00489342500003, 25.339016018000052],
              [63.987071160000085, 25.338324286000045],
              [63.969737175000034, 25.34446849200009],
              [63.944102410000085, 25.334906317000048],
              [63.906586134000065, 25.34121328300006],
              [63.80494225400008, 25.37498607000009],
              [63.73780358200008, 25.385321356000077],
              [63.669932488000086, 25.383612372000073],
              [63.60466556100005, 25.37441640800006],
              [63.57252037900008, 25.364976304000038],
              [63.55437259200005, 25.35618724200009],
              [63.53760826900003, 25.34446849200009],
              [63.510508660000085, 25.31659577000005],
              [63.49577884200005, 25.291408596000053],
              [63.48519941500007, 25.284328518000052],
              [63.469493035000085, 25.28925202000005],
              [63.47413170700008, 25.273138739000046],
              [63.48170006600003, 25.260158596000053],
              [63.51197350400008, 25.226711330000057],
              [63.51685631600003, 25.223578192000048],
              [63.51872806100005, 25.220851955000057],
              [63.517914259000065, 25.214178778000075],
              [63.51539147200003, 25.206854559000078],
              [63.511729363000086, 25.20026276200008],
              [63.506602410000085, 25.19550202000005],
              [63.50049889400003, 25.19367096600007],
              [63.468760613000086, 25.199042059000078],
              [63.411143425000034, 25.222479559000078],
              [63.376963738000086, 25.227769273000035],
              [63.30811608200008, 25.220363674000055],
              [63.291351759000065, 25.222805080000057],
              [63.244151238000086, 25.241441148000035],
              [63.178477410000085, 25.25804271000004],
              [63.14405358200008, 25.260931708000044],
              [63.11312910200007, 25.255113023000035],
              [63.05095462300005, 25.22418854400007],
              [63.02784264400003, 25.220363674000055],
              [62.942393425000034, 25.227769273000035],
              [62.770518425000034, 25.26190827000005],
              [62.60495896500004, 25.26599690200004],
              [62.52747944100008, 25.264187572000083],
              [62.477178930000036, 25.259063576000074],
              [62.46501712300005, 25.237250067000048],
              [62.46762129000007, 25.223537502000056],
              [62.48943118600005, 25.214178778000075],
              [62.469493035000085, 25.206732489000046],
              [62.444346550000034, 25.21393463700008],
              [62.41382897200003, 25.20652903900009],
              [62.38526451900003, 25.19245026200008],
              [62.365896030000044, 25.179388739000046],
              [62.35474694100003, 25.16941966400009],
              [62.34310957100007, 25.155462958000044],
              [62.33619225400008, 25.139837958000044],
              [62.33912194100003, 25.124741929000038],
              [62.35199035100004, 25.112829499000043],
              [62.37322237900008, 25.10839416300007],
              [62.38724312900007, 25.101574720000087],
              [62.38105164800004, 25.08757219800009],
              [62.33971332200008, 25.08739930900009],
              [62.289953773000036, 25.090016208000065],
              [62.25605540600009, 25.098627452000073],
              [62.280284050000034, 25.11660390800006],
              [62.283946160000085, 25.119940497000073],
              [62.287771030000044, 25.122259833000044],
              [62.29078209700003, 25.124741929000038],
              [62.29932701900003, 25.12881094000005],
              [62.30827884200005, 25.128159898000035],
              [62.31527754000007, 25.130194403000075],
              [62.31812584700003, 25.141831773000035],
              [62.303977272000054, 25.166923435000058],
              [62.297479277000036, 25.185132715000066],
              [62.27518383900008, 25.199890460000063],
              [62.254221821000044, 25.21203210100009],
              [62.22579194300005, 25.214054004000047],
              [62.19180886300006, 25.220080670000073],
              [62.145192905000044, 25.218410549000055],
              [62.10271243600005, 25.205145575000074],
              [62.08003090800008, 25.197152448000054],
              [62.06804520900005, 25.17814229000004],
              [62.05898864100004, 25.161635844000045],
              [62.07309004000007, 25.15058014500005],
              [62.07782756900008, 25.127713096000036],
              [62.08890159400005, 25.11842151600007],
              [62.09717858200008, 25.107123114000046],
              [62.075551112000085, 25.10074857500007],
              [62.03584065600006, 25.10304351800005],
              [61.989109995000035, 25.108073561000083],
              [61.92949774600004, 25.109562888000085],
              [61.88111412900008, 25.10301341400009],
              [61.869883660000085, 25.08388906500005],
              [61.86638431100005, 25.075425523000035],
              [61.857432488000086, 25.066839911000045],
              [61.84734134200005, 25.037909247000073],
              [61.83521569100003, 25.038397528000075],
              [61.81485303300008, 25.026179956000078],
              [61.79047766500008, 25.01776278500006],
              [61.75486833000008, 25.013467337000066],
              [61.729551205000064, 25.02178265300006],
              [61.720064069000045, 25.037436401000036],
              [61.72575931100005, 25.05890534100007],
              [61.73585045700008, 25.069525458000044],
              [61.728526238000086, 25.08307526200008],
              [61.732432488000086, 25.091620184000078],
              [61.74952233200008, 25.104315497000073],
              [61.76002037900008, 25.115383205000057],
              [61.762705925000034, 25.121975002000056],
              [61.76384524800005, 25.13499583500004],
              [61.76677493600005, 25.145656643000052],
              [61.78012129000007, 25.162543036000045],
              [61.78370201900003, 25.173163153000075],
              [61.78305097700007, 25.187974351000037],
              [61.77955162900008, 25.191066799000055],
              [61.77369225400008, 25.188421942000048],
              [61.76685631600003, 25.18622467700004],
              [61.76392662900008, 25.18427155200004],
              [61.75513756600003, 25.175604559000078],
              [61.74952233200008, 25.173163153000075],
              [61.74431399800005, 25.174953518000052],
              [61.731130405000044, 25.184068101000037],
              [61.725352410000085, 25.18622467700004],
              [61.713633660000085, 25.188055731000077],
              [61.70753014400003, 25.192206122000073],
              [61.70248457100007, 25.197007554000038],
              [61.69418379000007, 25.200506903000075],
              [61.68279056100005, 25.201646226000037],
              [61.65015709700003, 25.200506903000075],
              [61.63412519600007, 25.203924872000073],
              [61.62419681100005, 25.204413153000075],
              [61.61247806100005, 25.200506903000075],
              [61.588226759000065, 25.202093817000048],
              [61.62004195100013, 25.285486145000036],
              [61.62603641800007, 25.36977040600003],
              [61.63306441200007, 25.46929921500005],
              [61.63905887900012, 25.554927063000022],
              [61.64319299300013, 25.61332143200009],
              [61.646603638000045, 25.62768748000009],
              [61.65249475100006, 25.637299297000098],
              [61.667170858000134, 25.650476786000084],
              [61.67347538300004, 25.658279928000113],
              [61.67636926300014, 25.692799785000076],
              [61.66531050600014, 25.732383932000047],
              [61.66034956900012, 25.769177552000045],
              [61.68143355300003, 25.795480855000093],
              [61.702620891000095, 25.800080058000034],
              [61.721947876000115, 25.799666646000034],
              [61.73931115700003, 25.803283997],
              [61.75450402900009, 25.819975485000057],
              [61.76008508300009, 25.83759714800003],
              [61.77062707500005, 25.907412008],
              [61.78323612500009, 25.990611064000106],
              [61.79274458800006, 26.052829489000104],
              [61.800702759000046, 26.106624655000033],
              [61.80990116400005, 26.167447815000045],
              [61.818376099000034, 26.198453675000067],
              [61.83294885300006, 26.2253770950001],
              [61.85713342300005, 26.24237864200002],
              [61.97774621600013, 26.27317779500008],
              [62.0136613360001, 26.29462351500011],
              [62.03226485200014, 26.302891745000053],
              [62.05278039500013, 26.308576151000082],
              [62.094173218000094, 26.314829000000103],
              [62.10326827000006, 26.32511261000009],
              [62.10688562000013, 26.34971059100006],
              [62.12383549000003, 26.373998515000082],
              [62.16145593300007, 26.36950266500004],
              [62.20589766500012, 26.355343323000014],
              [62.24341475500012, 26.35064076700003],
              [62.26511885600013, 26.360976054000034],
              [62.26424035600007, 26.375187073000106],
              [62.25447351100013, 26.39358388300009],
              [62.24899580900012, 26.41652821900003],
              [62.25612715600005, 26.428930563],
              [62.28754642700011, 26.456629131000042],
              [62.297881714000084, 26.47404408800007],
              [62.29695153800009, 26.480245260000046],
              [62.293127482000045, 26.485877991000066],
              [62.29013024900013, 26.492440898000055],
              [62.29199060100012, 26.501225891000033],
              [62.29829512500004, 26.508770650000102],
              [62.306976766000105, 26.51367991200003],
              [62.32651045800009, 26.52065623000003],
              [62.33467533300012, 26.524842021000055],
              [62.347594442000116, 26.533316956000064],
              [62.35586267100007, 26.536624248000052],
              [62.365267782000046, 26.53750274700009],
              [62.386351766000075, 26.536624248000052],
              [62.39668705300005, 26.539053039000024],
              [62.40247481300014, 26.543807271],
              [62.41063968900005, 26.556829732000054],
              [62.418494507000105, 26.56230743500005],
              [62.42800297100007, 26.564787903000095],
              [62.595331259000034, 26.580704244000046],
              [62.61579512600008, 26.58711212200008],
              [62.62411503100003, 26.59295155900007],
              [62.632021525000084, 26.600392965000097],
              [62.64059981300005, 26.60514719700008],
              [62.65134851100004, 26.603183492000042],
              [62.66251062000009, 26.598274232],
              [62.67103723200012, 26.597705791000052],
              [62.70193973800008, 26.60401031500008],
              [62.71056970200004, 26.60690419500007],
              [62.71801110800004, 26.610521545000054],
              [62.72472904500012, 26.6151207490001],
              [62.7350643310001, 26.632225647000027],
              [62.74271244300007, 26.641320699000104],
              [62.753564494000045, 26.644162903000066],
              [62.82167403100004, 26.642612610000057],
              [62.900015503000134, 26.640907287000104],
              [62.990449259000115, 26.63889190700006],
              [63.02941329000009, 26.633517558000094],
              [63.06889408300003, 26.632535706000013],
              [63.09803959100003, 26.63837514300009],
              [63.10759973200004, 26.637599996000105],
              [63.11622969600006, 26.634034322000034],
              [63.123464397000134, 26.629435120000082],
              [63.13126753800003, 26.625817770000097],
              [63.141344441000115, 26.625404359000086],
              [63.163772013000084, 26.645093078000045],
              [63.17431400600003, 26.685038961000075],
              [63.18227217600008, 26.830249735000038],
              [63.1895585530001, 26.846011048000022],
              [63.20604333500006, 26.85371083600002],
              [63.24666101100013, 26.859550273000096],
              [63.261647176000054, 26.87174591100002],
              [63.264851115000056, 26.890039368000075],
              [63.25647953300006, 26.906162415000054],
              [63.243973836000066, 26.922440491000074],
              [63.23498213700003, 26.941147359000084],
              [63.22991784700014, 27.05406036400005],
              [63.23136478700013, 27.06584259000006],
              [63.23560225500012, 27.075867819000067],
              [63.24624759900007, 27.08945872000008],
              [63.24996830200013, 27.099535624000012],
              [63.260923707000075, 27.11560699500008],
              [63.28056075100011, 27.123203430000032],
              [63.30241988100005, 27.12335846000009],
              [63.31962813300004, 27.117312317000042],
              [63.28557336400007, 27.184646708000045],
              [63.27125899300006, 27.203405253000128],
              [63.26061364700007, 27.213792217000062],
              [63.25151859600004, 27.218959860000055],
              [63.22681726100012, 27.226969706000133],
              [63.21544844600004, 27.23322255500004],
              [63.1895585530001, 27.2544615690001],
              [63.17710453300003, 27.25844065400007],
              [63.166975953000076, 27.258699036000067],
              [63.11230228700009, 27.243196106000042],
              [63.099434855000084, 27.242834372000047],
              [63.08274336800008, 27.244384664000066],
              [63.056181682000044, 27.243196106000042],
              [63.00378177900012, 27.22877838200013],
              [62.97784021000007, 27.22516103100004],
              [62.91960087100006, 27.214877421000054],
              [62.89241906700005, 27.21348215700006],
              [62.86084476800005, 27.219631653000036],
              [62.8373836670001, 27.23125885000009],
              [62.829322144000116, 27.23363596600005],
              [62.82229414900007, 27.23249908500013],
              [62.808548218000055, 27.2253677370001],
              [62.800641723000126, 27.22516103100004],
              [62.78560388200003, 27.23249908500013],
              [62.74235070800006, 27.266812236000064],
              [62.7582153730001, 27.2676907350001],
              [62.768085571000086, 27.274356995000105],
              [62.774131714000134, 27.285519104000045],
              [62.778782593000074, 27.299833476000046],
              [62.78064294400008, 27.31605987600004],
              [62.77568200700006, 27.326911927000097],
              [62.75604496300008, 27.348099263000037],
              [62.808599894000054, 27.453364156000035],
              [62.814697713000044, 27.49496368400004],
              [62.80932336500007, 27.547053528],
              [62.79971154800006, 27.63927012200007],
              [62.79469893400011, 27.6894737760001],
              [62.786379029000045, 27.770269878000065],
              [62.780281209000066, 27.829723613000013],
              [62.754184611000085, 27.925841777000116],
              [62.735684448000086, 27.99498484300001],
              [62.75170414200011, 28.10872467100002],
              [62.76638024900012, 28.21148325700004],
              [62.7615226640001, 28.246442362000025],
              [62.73930179900003, 28.258327942000065],
              [62.57564253800007, 28.229027405000082],
              [62.555437052000116, 28.240318706000053],
              [62.49228845200014, 28.300702616000066],
              [62.477715698000054, 28.322303365000053],
              [62.47120446800011, 28.33969248500007],
              [62.46427982600005, 28.34982106600002],
              [62.45384118600009, 28.355686341000094],
              [62.437201375000086, 28.360440572000087],
              [62.42097497600008, 28.368553772000027],
              [62.41074304200009, 28.380697734000094],
              [62.40216475400007, 28.39410776800004],
              [62.39053755700007, 28.406122539000123],
              [62.36278731300007, 28.41888661700007],
              [62.23070235200004, 28.442451071000093],
              [62.14750329600014, 28.475265605000104],
              [62.11556726100008, 28.481363424000065],
              [62.049111369000116, 28.486324361000115],
              [62.01882897900009, 28.49469594300008],
              [61.97113163200004, 28.518983866000085],
              [61.91129032400005, 28.533737488],
              [61.89279016100005, 28.542599997000096],
              [61.861164184000074, 28.57476857500005],
              [61.79770552600013, 28.626574199000018],
              [61.75615767400012, 28.673961487],
              [61.653011516000106, 28.756333720000057],
              [61.623969361000036, 28.787649638000076],
              [61.59534061700003, 28.842685039000045],
              [61.566505168000106, 28.870977886000034],
              [61.56133752500011, 28.885938212000084],
              [61.558960409000065, 28.902733053000063],
              [61.5531726480001, 28.922137553000127],
              [61.51090132700011, 29.007377828000088],
              [61.50211633300012, 29.01771311500009],
              [61.49095422400006, 29.025490418000103],
              [61.47803511500007, 29.03065806100001],
              [61.470283651000045, 29.035903219000133],
              [61.46800988800004, 29.04174265600001],
              [61.4708004150001, 29.047866313000085],
              [61.47803511500007, 29.05432586700003],
              [61.487233521000064, 29.062929993000083],
              [61.490644165000106, 29.072025045000046],
              [61.48775028500012, 29.080655009000097],
              [61.47803511500007, 29.087476298000055],
              [61.46087854000007, 29.09388417600009],
              [61.45323042800004, 29.108379416000034],
              [61.44795943200006, 29.12540680000005],
              [61.43772749800013, 29.139617818000104],
              [61.42687544800003, 29.144630433000074],
              [61.41767704200004, 29.145663961000068],
              [61.40858199100006, 29.148557841000056],
              [61.39793664600012, 29.1590739950001],
              [61.39276900300007, 29.170468648000096],
              [61.39008182800006, 29.19542836500007],
              [61.386981242000104, 29.206642151000025],
              [61.37416548600004, 29.2238504030001],
              [61.34233280500007, 29.254520366000023],
              [61.332824341000105, 29.274906718000082],
              [61.332824341000105, 29.29449208600009],
              [61.34470992000013, 29.329528707000108],
              [61.34657027200012, 29.349062398000015],
              [61.33737186700006, 29.374383850000086],
              [61.31980188000006, 29.3853909300001],
              [61.29871789600014, 29.392651469000057],
              [61.279184205000035, 29.406629944000073],
              [61.19691532400009, 29.49228363000013],
              [61.11867720500004, 29.573984070000037],
              [61.04333296700014, 29.652428895000057],
              [60.97801395700009, 29.72061594700007],
              [60.92509729000011, 29.77497955400004],
              [60.844378703000075, 29.858178610000053],
              [60.87600467900006, 29.845517884000017],
              [60.947421508000104, 29.825519104000065],
              [61.03062056400012, 29.80216135700003],
              [61.11402632700003, 29.77872609400005],
              [61.197225383000045, 29.755342509000016],
              [61.28042443900006, 29.732010600000066],
              [61.36372684800011, 29.708627015000033],
              [61.446925904000125, 29.685320944000082],
              [61.53022831200013, 29.661859843000016],
              [61.61342736800003, 29.638502096000067],
              [61.696626424000044, 29.61519602500003],
              [61.7799288330001, 29.591786601000067],
              [61.86323124200004, 29.568351339000102],
              [61.94653365100004, 29.545045268000067],
              [62.02962935400012, 29.521635844000016],
              [62.11298344000005, 29.49822642100004],
              [62.196285848000116, 29.474920349000016],
              [62.27943322800007, 29.45148508700005],
              [62.37446618600012, 29.424871725000017],
              [62.47750899300013, 29.40781850200007],
              [62.602581132000125, 29.418069628000055],
              [62.63134973200005, 29.420427551],
              [62.68039066600005, 29.424458313000102],
              [62.72937992400006, 29.428489075000087],
              [62.77842085800006, 29.4325198370001],
              [62.82746179200012, 29.436602275],
              [62.87645105000013, 29.44058136000008],
              [62.92554366000007, 29.444637960000094],
              [62.97453291800008, 29.448642883000062],
              [63.02362552900013, 29.452673645000075],
              [63.072614787000134, 29.456756084000077],
              [63.12160404500014, 29.460786845000072],
              [63.170696656000075, 29.46476593100006],
              [63.21968591300009, 29.468796692000055],
              [63.2686751710001, 29.472879130000067],
              [63.31776778200003, 29.47690989200005],
              [63.36680871600004, 29.480940654000065],
              [63.415953003000084, 29.48497141500006],
              [63.56860518400009, 29.497477112000055],
              [63.78791996300009, 29.460580140000033],
              [63.97199141400006, 29.429574280000097],
              [64.08609297700008, 29.386605326000037],
              [64.11337813400007, 29.39629465800006],
              [64.1497583420001, 29.45846140600004],
              [64.17259932500008, 29.48429962200005],
              [64.20773929900014, 29.49998341900003],
              [64.47769698100007, 29.570366720000052],
              [64.49947701700006, 29.57020296000009],
              [64.68388594600003, 29.568816427000044],
              [64.8203117270001, 29.567886251000076],
              [64.98660648600014, 29.54155710900004],
              [65.03637089000006, 29.540161845000043],
              [65.18142663600008, 29.57711049400008],
              [65.23951094500006, 29.591838278000083],
              [65.29759525600008, 29.60664357600011],
              [65.35578291900009, 29.62142303500012],
              [65.41366052300009, 29.63617665600013],
              [65.47174483200007, 29.650956116000046],
              [65.52972578900005, 29.665735576000074],
              [65.58781009900008, 29.6805667120001],
              [65.64584273300005, 29.695346171000025],
              [65.70403039500007, 29.710151469000024],
              [65.76206302900005, 29.724905091000053],
              [65.82014733900013, 29.739736226000062],
              [65.87823164900004, 29.754489848000063],
              [65.93610925300004, 29.769295146],
              [65.99429691500006, 29.78402293],
              [66.05238122600014, 29.798854065000043],
              [66.1104655360001, 29.813633525000043],
              [66.19562829600005, 29.835337627000044],
              [66.27521000100006, 29.88515370700007],
              [66.30177168800009, 29.915694479000067],
              [66.3224422610001, 29.946545309000058],
              [66.32843672700005, 29.94954254100007],
              [66.3368083090001, 29.952023010000048],
              [66.34052901300004, 29.956570536000086],
              [66.33236413600008, 29.966079],
              [66.30156498200006, 29.98674957300007],
              [66.26043054200005, 30.023129781000065],
              [66.22523889100012, 30.044420471000066],
              [66.2192961020001, 30.057856344000086],
              [66.22172489400003, 30.07372100900001],
              [66.23634932500005, 30.111599834000103],
              [66.30089318800009, 30.22559804300009],
              [66.30528568500006, 30.24477],
              [66.30301192200005, 30.30528310100003],
              [66.32182214400007, 30.437368063000022],
              [66.31939335100009, 30.45783193000007],
              [66.31376062000004, 30.47829579700003],
              [66.30611250800007, 30.49111155200002],
              [66.28192793800008, 30.518138326000056],
              [66.26492639100007, 30.55782582600004],
              [66.26797530100004, 30.601389059000084],
              [66.36626387600012, 30.92286814400005],
              [66.3753589270001, 30.93671742800008],
              [66.39230879700011, 30.944623922000048],
              [66.52749434500004, 30.968343405],
              [66.55002526800007, 30.97697336800003],
              [66.64397302200007, 31.060172424000044],
              [66.6630933030001, 31.083116760000067],
              [66.69699304200009, 31.19582305900009],
              [66.72128096500006, 31.21029246000002],
              [66.75952152500008, 31.21478831000006],
              [66.7853080650001, 31.231789856000077],
              [66.80861413600013, 31.2547341920001],
              [66.83848311300005, 31.277006734000068],
              [66.90592085800006, 31.305532125000113],
              [66.94328291800008, 31.31473053000009],
              [67.00209069800007, 31.315867411000013],
              [67.01681848200008, 31.309149475000098],
              [67.02389815300012, 31.295300191000123],
              [67.0259652100001, 31.27302764900007],
              [67.02343306500006, 31.264862773000047],
              [67.01790368600007, 31.25871327700007],
              [67.0138729250001, 31.25266713500004],
              [67.01526818900004, 31.244657288000056],
              [67.02286462400014, 31.23938629200005],
              [67.03526696800009, 31.235923971000076],
              [67.05821130400005, 31.23235829700012],
              [67.07846846500013, 31.232048238000047],
              [67.11686405500006, 31.240316468000074],
              [67.13675948100007, 31.241091614000098],
              [67.15670658300007, 31.235923971000076],
              [67.19319014500007, 31.21850901300006],
              [67.2137573650001, 31.212256165000056],
              [67.23029382300007, 31.21060251900012],
              [67.28217696100006, 31.212772929],
              [67.3462040610001, 31.207760315000044],
              [67.36460087100005, 31.210705872000048],
              [67.43389896600013, 31.236079],
              [67.49332686400004, 31.242951965000103],
              [67.53022383600006, 31.256646220000036],
              [67.58365726700009, 31.26522450800006],
              [67.60215743000003, 31.27111562100005],
              [67.66592614800004, 31.306255595],
              [67.6789486080001, 31.316590882000114],
              [67.69279789200004, 31.32522084600005],
              [67.70902429200004, 31.329303284000062],
              [67.74943526200013, 31.328011373000024],
              [67.76473148600007, 31.334057516000044],
              [67.77506677200012, 31.352764384000054],
              [67.77036421700012, 31.39467397100013],
              [67.73429406800011, 31.40475087500006],
              [67.65114668800004, 31.395294088000085],
              [67.63140629100008, 31.400099996],
              [67.61145918800014, 31.410797018000025],
              [67.59698978700004, 31.42567983000005],
              [67.59109867400014, 31.46479888900008],
              [67.57807621300009, 31.482110494000082],
              [67.56340010600007, 31.497251689000095],
              [67.55611372900012, 31.51218617800005],
              [67.56898116000008, 31.529859517000048],
              [67.60050378400007, 31.53047963500002],
              [67.66546106000004, 31.518128967000067],
              [67.69631189000012, 31.5208161420001],
              [67.72669763200008, 31.531409811000074],
              [67.74828016400005, 31.54439209300007],
              [67.78116459100005, 31.564172669000087],
              [67.8427112230001, 31.623497213000107],
              [67.87066817200008, 31.635176087000062],
              [67.8843107510001, 31.635641175],
              [67.91469649300006, 31.63135203100005],
              [67.95521081600003, 31.633212382000053],
              [67.96606286700012, 31.63822499600009],
              [67.97732832900004, 31.651867574],
              [67.99407149300004, 31.663443095000062],
              [68.04657474800007, 31.688402812000035],
              [68.05225915500012, 31.69543080700005],
              [68.0555664470001, 31.716566468000096],
              [68.06047570800007, 31.72555816700013],
              [68.09349694800011, 31.751551412000097],
              [68.09834042600005, 31.7591236090001],
              [68.10450402900011, 31.768759664000058],
              [68.12574304200007, 31.81149607400009],
              [68.13855879800008, 31.824673564000065],
              [68.15912601800005, 31.825913798],
              [68.18475752800003, 31.81821401000009],
              [68.2068233650001, 31.807878723],
              [68.23229984500006, 31.790153707000073],
              [68.24263513200003, 31.77692454100007],
              [68.25503747500011, 31.766382548000124],
              [68.27694828300008, 31.763592021000065],
              [68.31653243000011, 31.765193991],
              [68.35606490100008, 31.762506816000055],
              [68.4609680590001, 31.73046742800007],
              [68.49802006100003, 31.72524810800006],
              [68.51517663600009, 31.729950663000025],
              [68.5368290610001, 31.741009420000026],
              [68.5497998460001, 31.75351511700002],
              [68.54060144100009, 31.762506816000055],
              [68.52127445500014, 31.76478057900009],
              [68.4614331460001, 31.763592021000065],
              [68.43957401600005, 31.766589254000067],
              [68.42221073400003, 31.773152161000056],
              [68.41874841300012, 31.783022360000032],
              [68.43817875200006, 31.79604482100008],
              [68.48148360200014, 31.81568186500003],
              [68.50509973100009, 31.82265818300003],
              [68.52747562700006, 31.8229682420001],
              [68.56106530800008, 31.811806132000058],
              [68.61945967600013, 31.78348744800006],
              [68.67578698700004, 31.774702453000074],
              [68.68829268400003, 31.768604634000027],
              [68.69490726700013, 31.756357321000095],
              [68.69790450100004, 31.715946350000124],
              [68.70544926000008, 31.701270244000042],
              [68.7311841230001, 31.67553538100013],
              [68.77727950000013, 31.618587952000055],
              [68.80384118600011, 31.60256825800012],
              [68.84352868600013, 31.60649566600007],
              [68.90698734600005, 31.634297588000024],
              [68.94099043800009, 31.64365102200007],
              [68.97726729300007, 31.64148061100009],
              [69.00403568500013, 31.651092428000098],
              [69.04010583500013, 31.673106588000067],
              [69.07162845800008, 31.697859599000097],
              [69.08475427200005, 31.715791321000083],
              [69.1000504970001, 31.724007874],
              [69.11431319200011, 31.737753804000036],
              [69.22376387600013, 31.881931051000024],
              [69.2509456790001, 31.907045797000038],
              [69.29884973100013, 31.937689922000075],
              [69.30115729900007, 31.94128170100008],
              [69.30479252100014, 31.94694000300008],
              [69.30215702300012, 31.959910787000112],
              [69.27063440000006, 32.035978495000066],
              [69.25104903100004, 32.13064972000008],
              [69.25187585500004, 32.152250469000066],
              [69.25952396600013, 32.19452179000005],
              [69.25998905400007, 32.23681894900004],
              [69.26696537200007, 32.27958119700007],
              [69.2681022540001, 32.30133697600006],
              [69.26443322800009, 32.32236928400009],
              [69.23854333500003, 32.37828318300008],
              [69.22800134300007, 32.42130381300008],
              [69.23285892700011, 32.462670797],
              [69.25156579600008, 32.500549621000104],
              [69.28195153800004, 32.53279571500006],
              [69.30210534700012, 32.54377695700005],
              [69.34354984600009, 32.55605011000007],
              [69.36122318600007, 32.56847829300007],
              [69.41393314600009, 32.63547678700006],
              [69.42602543100008, 32.65508799200008],
              [69.42912601700004, 32.66736114600012],
              [69.41910079000007, 32.70045990000001],
              [69.41724043800008, 32.71800404900007],
              [69.41465661600012, 32.725574646000055],
              [69.40773197400011, 32.729941305000025],
              [69.39915368700008, 32.732964376000055],
              [69.39042036900008, 32.737899476000095],
              [69.38323734600004, 32.744462383000084],
              [69.37806970300005, 32.7523172],
              [69.37631270300005, 32.77187672900003],
              [69.38716475400014, 32.785338440000075],
              [69.42106449400012, 32.80680999800002],
              [69.44555912300007, 32.83567128500006],
              [69.47144901600012, 32.85223358200007],
              [69.4772884520001, 32.856832785],
              [69.48721032700013, 32.88587493900009],
              [69.46850345900003, 32.99429209500006],
              [69.47812524800008, 33.011350078000035],
              [69.48772709200006, 33.028372701000094],
              [69.51418542500005, 33.05669138600011],
              [69.5475167240001, 33.07501068200007],
              [69.58777266400011, 33.079532370000024],
              [69.60833988500013, 33.079067282],
              [69.64068933100003, 33.084234925000075],
              [69.65019779400006, 33.081857809000056],
              [69.65877608200003, 33.07842132600011],
              [69.66776778200006, 33.07700022400003],
              [69.68600956200004, 33.080772604000046],
              [69.73298343900007, 33.1092979940001],
              [69.77184411600012, 33.114775696],
              [69.83871342000003, 33.086663717000064],
              [69.88093306500008, 33.089247539000056],
              [69.95581221600014, 33.127694805000104],
              [69.96573409000013, 33.12940012600005],
              [69.9947245680001, 33.1273330690001],
              [70.00686853000008, 33.13180308000001],
              [70.0145166420001, 33.140768942000065],
              [70.04800297000008, 33.194073181000036],
              [70.05978519700005, 33.19805226700002],
              [70.08365970900007, 33.19128265400006],
              [70.10536381100007, 33.18980987600007],
              [70.12479414900014, 33.199034119000075],
              [70.29444787600005, 33.31894928000007],
              [70.30157922400008, 33.3517896530001],
              [70.28571455900004, 33.38287302700003],
              [70.23300459800004, 33.43261159300006],
              [70.22783695500004, 33.439949646000045],
              [70.22044722500004, 33.45602101700011],
              [70.21336755400011, 33.46134368900006],
              [70.18546228000014, 33.46896596300003],
              [70.17760746300007, 33.47341013600003],
              [70.16375817900013, 33.488654683000064],
              [70.15497318500013, 33.50661224400007],
              [70.15135583500006, 33.52586171500009],
              [70.15300948100008, 33.5447494510001],
              [70.17347334800007, 33.60787221300008],
              [70.17409346600004, 33.632108459000065],
              [70.17021773300007, 33.638671366000025],
              [70.16251794400011, 33.64324473100008],
              [70.1459814860001, 33.64988515200007],
              [70.13688643400013, 33.65629303000013],
              [70.13254561300005, 33.66143483500012],
              [70.12655114700004, 33.67696360300003],
              [70.11812788900005, 33.71652191200009],
              [70.10815433800013, 33.72729644800002],
              [70.06557295800013, 33.7210177620001],
              [70.01182946800003, 33.74031890900007],
              [69.99647814300005, 33.74209099500003],
              [69.97265873300012, 33.74484059700008],
              [69.9575175380001, 33.75269541500002],
              [69.94723392800012, 33.77197072400004],
              [69.94010258000009, 33.79147857700006],
              [69.93131758600009, 33.80643890400002],
              [69.9075464280001, 33.835610250000045],
              [69.89876143400005, 33.85150075300005],
              [69.8854289140001, 33.889457093000075],
              [69.87648889100006, 33.902557068000036],
              [69.84718835500013, 33.92694834400005],
              [69.84109053600014, 33.941805319000096],
              [69.85421634900013, 33.95635223400005],
              [69.87199304200004, 33.97151926700006],
              [69.87385339400004, 33.98632456500009],
              [69.87044274900012, 34.00133656800007],
              [69.87261316000013, 34.017227071],
              [69.88925297100013, 34.031205546000095],
              [69.91602136300008, 34.03887949700008],
              [69.96909305800006, 34.04572662300005],
              [70.00283776900011, 34.043788758000105],
              [70.21884525600007, 33.98069183400007],
              [70.27558597800004, 33.97617014600003],
              [70.30989912900003, 33.9616749070001],
              [70.3281925870001, 33.957282410000104],
              [70.40896285000014, 33.95441436800003],
              [70.49149011200006, 33.93960907000009],
              [70.52197920700007, 33.93870473200006],
              [70.65618290200013, 33.9547502650001],
              [70.79131677300006, 33.95356170700008],
              [70.86221683700012, 33.964775492000044],
              [70.87999353000004, 33.994256898000046],
              [70.88433435100012, 34.00704681500012],
              [70.89430790300014, 34.00937225400007],
              [70.92123132300014, 34.00224090600001],
              [70.93973148600008, 34.00092315700006],
              [70.95399418200003, 34.00482472700013],
              [70.96572473200013, 34.013816427000066],
              [70.97714522300004, 34.02740732800005],
              [70.99771244300013, 34.03332428000006],
              [71.04670170100013, 34.041876729000094],
              [71.06261804200005, 34.05425323500005],
              [71.0672689210001, 34.073011780000044],
              [71.06385827700007, 34.08892812100008],
              [71.0627730710001, 34.10530955000003],
              [71.07388350400004, 34.12525665300005],
              [71.10178877800007, 34.15181833900006],
              [71.1080933020001, 34.165228373],
              [71.1094885660001, 34.18920623800001],
              [71.10654301000011, 34.20938588500009],
              [71.09687951700005, 34.244344991],
              [71.09708622300013, 34.26245758100002],
              [71.12638675900007, 34.33222076400007],
              [71.12204593900009, 34.35681874600006],
              [71.05093916900006, 34.3897883100001],
              [71.01982995600014, 34.41443796900002],
              [70.99151127200014, 34.4430667110001],
              [70.97084069800013, 34.4688790900001],
              [70.96122888200011, 34.48761179600008],
              [70.95564782700006, 34.51001353],
              [70.95699141500006, 34.53200185200005],
              [70.96867028900004, 34.549726868000064],
              [70.98335594700012, 34.55525610700006],
              [70.9858268640001, 34.55618642200004],
              [71.00696252500012, 34.55634145100008],
              [71.04752852400014, 34.55112213200006],
              [71.06582198100011, 34.558460185000044],
              [71.07657067900004, 34.578510641],
              [71.07987797100003, 34.60290191600002],
              [71.07626062000014, 34.623624166000056],
              [71.06876753700004, 34.64594838500001],
              [71.0701628010001, 34.661244609000065],
              [71.08060144100006, 34.67292348300005],
              [71.15093306500006, 34.72031077100003],
              [71.18953536000004, 34.73705393500008],
              [71.20307458500014, 34.748164368000076],
              [71.2556295170001, 34.81022776300004],
              [71.27082238800011, 34.84428253200009],
              [71.2894775800001, 34.87503000900007],
              [71.32492761200012, 34.89756093400008],
              [71.44523879700012, 34.937756748000126],
              [71.45995813000013, 34.94267445900003],
              [71.46956994700014, 34.94970245400005],
              [71.47670129500005, 34.96029612300002],
              [71.48538293500013, 34.98349884100013],
              [71.49334110500007, 34.994040833],
              [71.49334110500007, 34.994144185000025],
              [71.49344445800011, 34.994144185000025],
              [71.50429650900014, 35.000603739000084],
              [71.51132450400007, 35.00871693900008],
              [71.51297815000004, 35.01812205000003],
              [71.50750044800003, 35.028198954000075],
              [71.50894738800014, 35.07202056900009],
              [71.53499231000012, 35.098582256],
              [71.6041353760001, 35.13816640200007],
              [71.62925012200003, 35.17010243800003],
              [71.6379317630001, 35.189687806000066],
              [71.63369429600004, 35.20312367800001],
              [71.60320520000005, 35.22338084000002],
              [71.5478080640001, 35.27562571200009],
              [71.52982466700007, 35.30089548800008],
              [71.53158166500009, 35.327922262000115],
              [71.56227746600013, 35.360581767],
              [71.61106001800005, 35.39546335900006],
              [71.62087854000004, 35.41013946500006],
              [71.62242883300007, 35.42962148100004],
              [71.61395389800003, 35.443212382000056],
              [71.60072473100007, 35.45545969600006],
              [71.59342197900014, 35.46419378800003],
              [71.58780562400005, 35.47091095000006],
              [71.58170780500006, 35.49313181600009],
              [71.58604862500005, 35.51209706600007],
              [71.59286991400012, 35.530183817000065],
              [71.5934900310001, 35.54935577400009],
              [71.58418827400004, 35.56418691100002],
              [71.56785852100012, 35.57421213800005],
              [71.51277144300008, 35.596277975000035],
              [71.49272098800003, 35.60955881800005],
              [71.48331587700005, 35.62656036400007],
              [71.4959249260001, 35.64661082000002],
              [71.51401167800009, 35.66557607100005],
              [71.51979943800006, 35.68376617500009],
              [71.51535526600009, 35.70149119100002],
              [71.50274621600005, 35.719061178000075],
              [71.49613163300006, 35.72459055600008],
              [71.48135217300012, 35.73409902000007],
              [71.47556441300003, 35.74102366100006],
              [71.47112024000006, 35.752289124000114],
              [71.47101688700013, 35.76133250000008],
              [71.47205041500007, 35.76996246300003],
              [71.47091353400009, 35.77993601500013],
              [71.46440230300004, 35.79471547400006],
              [71.43101932800005, 35.84370473300005],
              [71.41670495600005, 35.858845927000075],
              [71.37133304900004, 35.88514923100011],
              [71.36068770400004, 35.900290426000126],
              [71.35639856000006, 35.933053284000025],
              [71.34156742400006, 35.9472643030001],
              [71.31252526900005, 35.957392883000054],
              [71.28430993600011, 35.96245717400002],
              [71.25743819200011, 35.9715522260001],
              [71.23191003400007, 35.9939797980001],
              [71.21785404400003, 36.00271311400006],
              [71.18188724800007, 36.018836162000056],
              [71.17093184400011, 36.02700103700006],
              [71.16991342200004, 36.03080174600002],
              [71.16591923000004, 36.04570790600003],
              [71.17537601700008, 36.06115915900004],
              [71.20762211100003, 36.087617493000025],
              [71.21263472600003, 36.09681589800003],
              [71.2176990160001, 36.118054912],
              [71.22307336400007, 36.1253929650001],
              [71.26229577600003, 36.14611521500002],
              [71.29268151800005, 36.15789744100003],
              [71.30208662900003, 36.1633234670001],
              [71.30901127100009, 36.17272857700006],
              [71.31397220900004, 36.19401926700003],
              [71.31913985200003, 36.200582174000104],
              [71.38244348100005, 36.21856557300002],
              [71.40275232000005, 36.23138132700008],
              [71.47907841000011, 36.30052439400008],
              [71.49582157400005, 36.30961944600004],
              [71.51463179500007, 36.315200501000064],
              [71.53891971800005, 36.319282939000075],
              [71.55835005700004, 36.3278612270001],
              [71.55266565000011, 36.340987041000076],
              [71.54222701000009, 36.35638661800006],
              [71.5471879480001, 36.371631165000096],
              [71.57230269400003, 36.39168162000006],
              [71.58036421700012, 36.40232696500003],
              [71.58873579900012, 36.418450013000026],
              [71.60072473100007, 36.4493008430001],
              [71.61043990000007, 36.45793080600005],
              [71.6291467690001, 36.459532776000074],
              [71.64930057800007, 36.45276316300006],
              [71.7068681230001, 36.42144724500004],
              [71.73632369000012, 36.3959190880001],
              [71.75099979700008, 36.3911131790001],
              [71.76691613800011, 36.39183665000009],
              [71.78262577300006, 36.39653920500005],
              [71.794408, 36.40759796200008],
              [71.7915141200001, 36.421292216],
              [71.77456425000008, 36.448422343000075],
              [71.77322066200014, 36.48004832000005],
              [71.79378788200012, 36.49074534100005],
              [71.85859012900005, 36.49415598600008],
              [71.87471317600011, 36.49906524600003],
              [71.88763228300013, 36.508005269000066],
              [71.89972456900011, 36.51834055600007],
              [71.91347050000013, 36.527590637000074],
              [71.96090946500004, 36.54960479700004],
              [71.97703251100012, 36.56304067000009],
              [71.99780643800005, 36.57244578000005],
              [72.03883752500008, 36.580455627000035],
              [72.0549605710001, 36.592857972],
              [72.05630415900004, 36.601901347000066],
              [72.05217004400004, 36.610376282000075],
              [72.05041304500014, 36.61864451200002],
              [72.0590946860001, 36.627119446],
              [72.07087691200007, 36.63228708900003],
              [72.09609501100005, 36.6389016720001],
              [72.15417932100013, 36.64546457900009],
              [72.17164595600008, 36.653629456000104],
              [72.16461796100009, 36.67006256200007],
              [72.14963179600011, 36.6893378700001],
              [72.15345585200004, 36.702101949000095],
              [72.16968225100004, 36.711352031],
              [72.2136072190001, 36.726441549000086],
              [72.3019739180001, 36.74271962500002],
              [72.34620894400013, 36.7448900350001],
              [72.38734338400008, 36.75579376200007],
              [72.43312870300014, 36.75341664600005],
              [72.45410933400012, 36.757964173000076],
              [72.51674117000005, 36.80059722900005],
              [72.56521366400011, 36.820596008000095],
              [72.6296024990001, 36.83294667600005],
              [72.69585168500004, 36.836719055000074],
              [72.77936079900007, 36.82679718000007],
              [72.86772749800014, 36.830414531000045],
              [72.89687300600013, 36.83697743700013],
              [72.92105757600012, 36.847364400000046],
              [72.94586226400014, 36.85222198500007],
              [72.97676477100003, 36.842093404000124],
              [72.99051070200005, 36.84157664100009],
              [73.00229292800009, 36.846124166000024],
              [73.0262707930001, 36.85945668500004],
              [73.0424971920001, 36.86426259400004],
              [73.19184208200005, 36.87702667300003],
              [73.2234680580001, 36.874339498],
              [73.25271691900014, 36.868034973000064],
              [73.26749637900014, 36.86653635700007],
              [73.28186242700014, 36.867983297000066],
              [73.33178186100008, 36.882090963000095],
              [73.37973759000005, 36.87924875900002],
              [73.44588342300011, 36.88648346000009],
              [73.47688928200012, 36.88286610900009],
              [73.50934208200005, 36.878680318000065],
              [73.64008345600007, 36.89663787800005],
              [73.70948256500003, 36.89422106100001],
              [73.71112830200013, 36.894163748000054],
              [73.71133490400007, 36.89415655300009],
              [73.71184199100009, 36.89413889400005],
              [73.77289188700007, 36.8920128380001],
              [73.83407678300006, 36.88286610900009],
              [73.86508264200012, 36.8725824990001],
              [73.94693811000013, 36.83087961800008],
              [73.97670373600005, 36.82483347600005],
              [74.00636600700011, 36.81573842400006],
              [74.03530480900014, 36.81558339400003],
              [74.0943192950001, 36.831241354000085],
              [74.10393111200011, 36.841318258000015],
              [74.10878869600003, 36.875631409000036],
              [74.11529992700008, 36.889532369],
              [74.12966597500008, 36.89842071600013],
              [74.14599572800012, 36.9017021690001],
              [74.21172815000011, 36.89513926200003],
              [74.23570601500012, 36.902167257000045],
              [74.28459191900009, 36.93423248300006],
              [74.36810103300007, 36.97676218700012],
              [74.39404260300012, 36.99402211500011],
              [74.43559045400013, 37.0032205210001],
              [74.45698449700012, 37.004383240000024],
              [74.47662154100004, 36.999318950000045],
              [74.4803422440001, 36.996915995000094],
              [74.48364953600009, 36.99397043900008],
              [74.50173628700009, 36.97242136700005],
              [74.52137333100012, 36.95849456800006],
              [74.53739302600007, 36.96224110900006],
              [74.54421431500003, 36.99402211500011],
              [74.54814172400012, 37.00164439000007],
              [74.54927860600003, 37.00893076600006],
              [74.54741825400009, 37.01567454000009],
              [74.54235396300004, 37.021669006000124],
              [74.56178430200009, 37.029678854000096],
              [74.62606978300005, 37.04275299100006],
              [74.66244999200006, 37.05448354100004],
              [74.67795292100004, 37.051693014000065],
              [74.69221561700004, 37.03588002600007],
              [74.71919071500008, 37.01644968700002],
              [74.79257124800012, 37.01515777600004],
              [74.82430057800013, 36.994125468000036],
              [74.8245072840001, 36.994125468000036],
              [74.8532393800001, 36.95898549400009],
              [74.86088749200007, 36.94689320900001],
              [74.86677860500009, 36.91655914300007],
              [74.87235966000009, 36.907102356000095],
              [74.88579553300013, 36.91144317600008],
              [74.89199670400012, 36.92097747800007],
              [74.90078169800012, 36.949916280000124],
              [74.91049686700006, 36.96255116800005],
              [74.9249662680001, 36.970871074000016],
              [74.94232955000007, 36.97699473100009],
              [74.9768494060001, 36.98428110800005],
              [75.01446984800009, 36.98448781300003],
              [75.10014937300008, 36.994125468000036],
              [75.11854618400008, 36.99123158800005],
              [75.13280887900004, 36.98469451900006],
              [75.16123091600008, 36.9642048140001],
              [75.19513065600006, 36.948882752000046],
              [75.31346968600013, 36.92875478100008],
              [75.35129683500008, 36.91578399700005],
              [75.37796187400005, 36.894286601000104],
              [75.39449833200007, 36.86426259400004],
              [75.40142297300014, 36.8258670040001],
              [75.40338667800006, 36.784784241000054],
              [75.41051802600003, 36.747318827000086],
              [75.43191206900013, 36.72292755100004],
              [75.49258020000008, 36.72070546500005],
              [75.49888472500004, 36.727630107000024],
              [75.50188195800013, 36.73796539300004],
              [75.50797977700006, 36.74762888700006],
              [75.5705082610001, 36.766749166000054],
              [75.64977990700004, 36.75403676400002],
              [75.72874149600005, 36.723185934000114],
              [75.79054650900008, 36.687839254000025],
              [75.84976770000003, 36.64474111],
              [75.87477909400013, 36.61947133400004],
              [75.97658166500008, 36.46263336200012],
              [75.9768113990001, 36.461755995000075],
              [75.98108273200012, 36.445443571000084],
            ],
          ],
          [
            [
              [67.37549889400003, 24.06273021000004],
              [67.39039147200003, 24.049261786000045],
              [67.41325931100005, 24.048773505000042],
              [67.45801842500003, 24.06273021000004],
              [67.47779381600003, 24.051214911000045],
              [67.48536217500003, 24.048529364000046],
              [67.48528079500005, 24.048488674000055],
              [67.46517988400007, 24.04059479400007],
              [67.46078535200007, 24.026678778000075],
              [67.45394941500007, 24.013413804000038],
              [67.42693118600005, 24.007513739000046],
              [67.40943444100003, 24.013495184000078],
              [67.39340254000007, 24.02806224200009],
              [67.38542728000004, 24.040187893000052],
              [67.38152103000004, 24.046210028000075],
              [67.37549889400003, 24.06273021000004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Thailand',
        iso3: 'THA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [102.91358483200003, 11.645900783000059],
              [102.90601647200003, 11.666205145000049],
              [102.90870201900003, 11.717962958000044],
              [102.90674889400003, 11.741441148000092],
              [102.89332116000003, 11.769680080000057],
              [102.82545006600003, 11.85814036700009],
              [102.78345787900008, 11.892279364000046],
              [102.77702884200005, 11.902533270000049],
              [102.77702884200005, 11.96743398600006],
              [102.76693769600007, 12.011786200000074],
              [102.74968509200005, 12.040269273000092],
              [102.63184655000003, 12.152044989000046],
              [102.63013756600003, 12.161363023000092],
              [102.65357506600003, 12.15916575700004],
              [102.64136803500003, 12.175482489000046],
              [102.60450280000003, 12.203924872000073],
              [102.60572350400008, 12.214422919000071],
              [102.60572350400008, 12.221258856000077],
              [102.58936608200003, 12.212225653000075],
              [102.57390384200005, 12.208726304000038],
              [102.56185957100007, 12.202093817000048],
              [102.55730228000004, 12.183742580000057],
              [102.57162519600007, 12.090969143000052],
              [102.58399498800003, 12.067328192000048],
              [102.58594811300003, 12.060248114000046],
              [102.58236738400007, 12.049261786000045],
              [102.57398522200003, 12.049261786000045],
              [102.56348717500003, 12.053859768000052],
              [102.55388431100005, 12.056789455000057],
              [102.55014082100007, 12.06118398600006],
              [102.55103600400008, 12.08274974200009],
              [102.55046634200005, 12.090969143000052],
              [102.53223717500003, 12.11359284100007],
              [102.50424238400007, 12.133368231000077],
              [102.47364342500003, 12.148993231000077],
              [102.36622155000003, 12.186021226000037],
              [102.35035241000003, 12.195705471000053],
              [102.33619225400008, 12.19757721600007],
              [102.32447350400008, 12.18032461100006],
              [102.31836998800003, 12.18032461100006],
              [102.29590905000003, 12.190008856000077],
              [102.29037519600007, 12.19399648600006],
              [102.28646894600007, 12.202541408000059],
              [102.28711998800003, 12.210191148000092],
              [102.28939863400007, 12.216620184000078],
              [102.29037519600007, 12.221258856000077],
              [102.28345787900008, 12.241359768000052],
              [102.26539147200003, 12.27147044500009],
              [102.26319420700003, 12.289536851000037],
              [102.29004967500003, 12.282904364000046],
              [102.31519616000003, 12.29124583500004],
              [102.33627363400007, 12.307440497000073],
              [102.35189863400007, 12.32367584800005],
              [102.35987389400003, 12.347072658000059],
              [102.35206139400003, 12.367254950000074],
              [102.33725019600007, 12.376125393000052],
              [102.32447350400008, 12.365301825000074],
              [102.33253014400003, 12.361883856000077],
              [102.33838951900003, 12.357163804000038],
              [102.34245853000004, 12.351304429000038],
              [102.34506269600007, 12.34479401200008],
              [102.33073978000004, 12.327826239000046],
              [102.31023196700005, 12.316229559000078],
              [102.29167728000004, 12.318060614000046],
              [102.28353925900007, 12.341376044000071],
              [102.28614342500003, 12.385687567000048],
              [102.29224694100003, 12.40688711100006],
              [102.30404707100007, 12.427394924000055],
              [102.29786217500003, 12.427394924000055],
              [102.29151451900003, 12.419582424000055],
              [102.27670332100007, 12.39256419500009],
              [102.27003014400003, 12.39256419500009],
              [102.26587975400008, 12.404771226000037],
              [102.26351972700007, 12.417303778000075],
              [102.26441491000003, 12.429429429000038],
              [102.27003014400003, 12.440375067000048],
              [102.25847415500004, 12.43187083500004],
              [102.24244225400008, 12.426255601000037],
              [102.22828209700003, 12.42772044500009],
              [102.22217858200003, 12.440375067000048],
              [102.20573978000004, 12.43577708500004],
              [102.20101972700007, 12.433539130000042],
              [102.21062259200005, 12.427679755000042],
              [102.21436608200003, 12.419623114000046],
              [102.21338951900003, 12.409979559000078],
              [102.20850670700003, 12.39940013200004],
              [102.21461022200003, 12.39940013200004],
              [102.23585045700003, 12.413723049000055],
              [102.24252363400007, 12.402777411000045],
              [102.24708092500003, 12.393011786000045],
              [102.24781334700003, 12.383205471000053],
              [102.24268639400003, 12.37213776200008],
              [102.26303144600007, 12.357001044000071],
              [102.27344811300003, 12.32615794500009],
              [102.26482181100005, 12.306219794000071],
              [102.22828209700003, 12.32367584800005],
              [102.16684004000007, 12.38572825700004],
              [102.13689212300005, 12.401760158000059],
              [102.12435957100007, 12.410549221000053],
              [102.12598717500003, 12.41990794500009],
              [102.10987389400003, 12.440904039000088],
              [102.08716881600003, 12.46474844000005],
              [102.07195071700005, 12.48851146000004],
              [102.07813561300003, 12.509263414000088],
              [102.08179772200003, 12.501125393000052],
              [102.08594811300003, 12.49835846600007],
              [102.09148196700005, 12.497626044000071],
              [102.09864342500003, 12.495591539000088],
              [102.08545983200003, 12.504339911000045],
              [102.09213300900007, 12.51268138200004],
              [102.10564212300005, 12.52289459800005],
              [102.11231530000003, 12.537258205000057],
              [102.10474694100003, 12.537258205000057],
              [102.09945722700007, 12.527411200000074],
              [102.09294681100005, 12.523382880000042],
              [102.08545983200003, 12.524359442000048],
              [102.07813561300003, 12.529730536000045],
              [102.08822675900007, 12.538723049000055],
              [102.09327233200003, 12.541449286000045],
              [102.09864342500003, 12.543402411000045],
              [102.04786217500003, 12.542303778000075],
              [102.04330488400007, 12.550523179000038],
              [102.06446373800003, 12.570746161000045],
              [102.02222741000003, 12.568548895000049],
              [102.00928795700003, 12.564520575000074],
              [102.00928795700003, 12.557074286000045],
              [102.02247155000003, 12.547756252000056],
              [102.03150475400008, 12.534125067000048],
              [102.04322350400008, 12.523504950000074],
              [102.06446373800003, 12.522935289000088],
              [102.05958092500003, 12.51048411700009],
              [102.05746504000007, 12.497219143000052],
              [102.05697675900007, 12.468329169000071],
              [102.02247155000003, 12.51951732000009],
              [102.00896243600005, 12.534084377000056],
              [101.99219811300003, 12.53978099200009],
              [101.97348066500007, 12.541449286000045],
              [101.96078535200007, 12.537258205000057],
              [101.96078535200007, 12.580633856000077],
              [101.95883222700007, 12.59125397300005],
              [101.95435631600003, 12.601304429000038],
              [101.94988040500004, 12.606350002000056],
              [101.94776451900003, 12.601752020000049],
              [101.94597415500004, 12.59568919500009],
              [101.93702233200003, 12.589178778000075],
              [101.93425540500004, 12.583726304000038],
              [101.94727623800003, 12.540716864000046],
              [101.94776451900003, 12.529730536000045],
              [101.91407311300003, 12.555121161000045],
              [101.89958743600005, 12.569728908000059],
              [101.89258873800003, 12.583726304000038],
              [101.91309655000003, 12.57758209800005],
              [101.90943444100003, 12.594224351000037],
              [101.90259850400008, 12.59788646000004],
              [101.89429772200003, 12.596502997000073],
              [101.88575280000003, 12.598049221000053],
              [101.87761478000004, 12.605536200000074],
              [101.87354576900003, 12.613023179000038],
              [101.87045332100007, 12.621568101000037],
              [101.86524498800003, 12.632147528000075],
              [101.84880618600005, 12.65452708500004],
              [101.83025149800005, 12.672796942000048],
              [101.80836022200003, 12.687933661000045],
              [101.78272545700003, 12.701117255000042],
              [101.76612389400003, 12.705877997000073],
              [101.70443769600007, 12.707912502000056],
              [101.68637129000007, 12.70213450700004],
              [101.67595462300005, 12.688625393000052],
              [101.66846764400003, 12.672796942000048],
              [101.65984134200005, 12.660101630000042],
              [101.64234459700003, 12.65135325700004],
              [101.62208092500003, 12.649644273000092],
              [101.58106530000003, 12.65265534100007],
              [101.57349694100003, 12.649807033000059],
              [101.57203209700003, 12.64329661700009],
              [101.57260175900007, 12.636419989000046],
              [101.57105553500003, 12.632147528000075],
              [101.56641686300003, 12.631293036000045],
              [101.55543053500003, 12.632391669000071],
              [101.53907311300003, 12.631740627000056],
              [101.50904381600003, 12.63898346600007],
              [101.46509850400008, 12.632310289000088],
              [101.44288170700003, 12.624823309000078],
              [101.43327884200005, 12.615423895000049],
              [101.42888431100005, 12.596869208000044],
              [101.41814212300005, 12.595648505000042],
              [101.39291425900007, 12.611721096000053],
              [101.32349694100003, 12.642157294000071],
              [101.24887129000007, 12.660101630000042],
              [101.08773847700007, 12.680609442000048],
              [101.06666100400008, 12.676255601000037],
              [101.03207441500007, 12.65696849200009],
              [100.98861738400007, 12.649359442000048],
              [100.97803795700003, 12.639593817000048],
              [100.97771243600005, 12.639227606000077],
              [100.97445722700007, 12.622219143000052],
              [100.97445722700007, 12.598049221000053],
              [100.92611738400007, 12.61912669500009],
              [100.92611738400007, 12.625392971000053],
              [100.94076582100007, 12.636379299000055],
              [100.93458092500003, 12.652899481000077],
              [100.91765384200005, 12.662583726000037],
              [100.89958743600005, 12.65265534100007],
              [100.88868248800003, 12.658758856000077],
              [100.87989342500003, 12.658148505000042],
              [100.87061608200003, 12.654730536000045],
              [100.85792076900003, 12.65265534100007],
              [100.86264082100007, 12.655991929000038],
              [100.86687259200005, 12.660305080000057],
              [100.86988366000003, 12.66600169500009],
              [100.87142988400007, 12.673773505000042],
              [100.85108483200003, 12.673773505000042],
              [100.85450280000003, 12.67967357000009],
              [100.86133873800003, 12.695135809000078],
              [100.86459394600007, 12.701117255000042],
              [100.85629316500007, 12.70140208500004],
              [100.83741295700003, 12.707912502000056],
              [100.85482832100007, 12.75226471600007],
              [100.86793053500003, 12.771144924000055],
              [100.88591556100005, 12.762518622000073],
              [100.89210045700003, 12.762518622000073],
              [100.89918053500003, 12.773504950000074],
              [100.90788821700005, 12.782538153000075],
              [100.91570071700005, 12.793646552000041],
              [100.91993248800003, 12.810939846000053],
              [100.91846764400003, 12.826320705000057],
              [100.91325931100005, 12.840399481000077],
              [100.90609785200007, 12.853216864000046],
              [100.86866295700003, 12.90623607000009],
              [100.86459394600007, 12.919582424000055],
              [100.86817467500003, 12.929022528000075],
              [100.87549889400003, 12.934759833000044],
              [100.88404381600003, 12.940008856000077],
              [100.89210045700003, 12.948065497000073],
              [100.89454186300003, 12.955511786000045],
              [100.89673912900008, 12.973863023000092],
              [100.89958743600005, 12.982245184000078],
              [100.90821373800003, 12.977443752000056],
              [100.91879316500007, 12.98240794500009],
              [100.92839603000004, 12.99249909100007],
              [100.93360436300003, 13.002752997000073],
              [100.93311608200003, 13.02643463700008],
              [100.92310631600003, 13.042792059000078],
              [100.91138756600003, 13.057033596000053],
              [100.90577233200003, 13.074408270000049],
              [100.90154056100005, 13.080633856000077],
              [100.89210045700003, 13.083482164000088],
              [100.88282311300003, 13.087836005000042],
              [100.87826582100007, 13.098334052000041],
              [100.89958743600005, 13.12563711100006],
              [100.91578209700003, 13.154852606000077],
              [100.93702233200003, 13.183986721000053],
              [100.94516035200007, 13.200913804000038],
              [100.94450931100005, 13.220038153000075],
              [100.93360436300003, 13.256008205000057],
              [100.92896569100003, 13.26561107000009],
              [100.91537519600007, 13.287054755000042],
              [100.91244550900007, 13.293850002000056],
              [100.91472415500004, 13.304388739000046],
              [100.91928144600007, 13.31077708500004],
              [100.92400149800005, 13.315619208000044],
              [100.93238366000003, 13.33812083500004],
              [100.94711347700007, 13.344427802000041],
              [100.96534264400003, 13.348537502000056],
              [100.98129316500007, 13.359035549000055],
              [100.98536217500003, 13.37303294500009],
              [100.98715254000007, 13.396144924000055],
              [100.98511803500003, 13.417710679000038],
              [100.97087649800005, 13.437201239000046],
              [100.97836347700007, 13.45888906500005],
              [100.99577884200005, 13.48932526200008],
              [100.99577884200005, 13.496161200000074],
              [100.98389733200003, 13.487982489000046],
              [100.97388756600003, 13.47882721600007],
              [100.96338951900003, 13.471380927000041],
              [100.95069420700003, 13.468247789000088],
              [100.88892662900008, 13.468247789000088],
              [100.86402428500003, 13.471502997000073],
              [100.81397545700003, 13.486029364000046],
              [100.77133222700007, 13.491156317000048],
              [100.74976647200003, 13.49990469000005],
              [100.67986087300005, 13.50922272300005],
              [100.64966881600003, 13.52024974200009],
              [100.61019941500007, 13.54751211100006],
              [100.59205162900008, 13.554510809000078],
              [100.58961022200003, 13.56195709800005],
              [100.59156334700003, 13.571519273000092],
              [100.59669030000003, 13.58266836100006],
              [100.59888756600003, 13.596502997000073],
              [100.59782962300005, 13.612250067000048],
              [100.58692467500003, 13.59202708500004],
              [100.58318118600005, 13.575995184000078],
              [100.58423912900008, 13.533677476000037],
              [100.57585696700005, 13.519598700000074],
              [100.55591881600003, 13.510891018000052],
              [100.42994225400008, 13.48932526200008],
              [100.38111412900008, 13.491522528000075],
              [100.35645592500003, 13.48969147300005],
              [100.33716881600003, 13.48187897300005],
              [100.28988691500007, 13.505031643000052],
              [100.27507571700005, 13.51666901200008],
              [100.26498457100007, 13.497544664000088],
              [100.25326582100007, 13.48578522300005],
              [100.23715254000007, 13.477362372000073],
              [100.15040123800003, 13.444037177000041],
              [100.11304772200003, 13.43659088700008],
              [100.08895918100006, 13.425970770000049],
              [100.06934655000003, 13.417385158000059],
              [100.05307050900007, 13.413031317000048],
              [100.03882897200003, 13.402736721000053],
              [100.03126061300003, 13.382025458000044],
              [100.02165774800005, 13.366603908000059],
              [100.00131269600007, 13.372015692000048],
              [100.01563561300003, 13.36587148600006],
              [100.01392662900008, 13.34837474200009],
              [100.00619550900007, 13.332831122000073],
              [99.99366295700003, 13.32172272300005],
              [99.97738691500007, 13.31736888200004],
              [99.96273847700007, 13.309881903000075],
              [99.96070397200003, 13.29242584800005],
              [99.96086673300005, 13.291571356000077],
              [99.96713300900007, 13.259019273000092],
              [99.99854576900003, 13.218085028000075],
              [100.05648847700007, 13.170314846000053],
              [100.05982506600003, 13.165676174000055],
              [100.06674238400007, 13.160101630000042],
              [100.07398522200003, 13.152777411000045],
              [100.07699629000007, 13.142726955000057],
              [100.07781009200005, 13.13377513200004],
              [100.08773847700007, 13.096177476000037],
              [100.10434004000007, 13.057318427000041],
              [100.10189863400007, 13.039862372000073],
              [100.09302819100003, 13.023993231000077],
              [100.06006920700003, 12.980292059000078],
              [100.05298912900008, 12.966131903000075],
              [100.04297936300003, 12.93382396000004],
              [100.02930748800003, 12.861802476000037],
              [100.02393639400003, 12.847072658000059],
              [99.98764082100007, 12.79047272300005],
              [99.97429446700005, 12.751206773000092],
              [99.96501712300005, 12.710150458000044],
              [99.96045983200003, 12.667914130000042],
              [99.96078535200007, 12.63617584800005],
              [99.96094811300003, 12.625392971000053],
              [99.97803795700003, 12.56077708500004],
              [99.98080488400007, 12.540350653000075],
              [99.97706139400003, 12.47687409100007],
              [99.98080488400007, 12.454657294000071],
              [100.01099694100003, 12.383246161000045],
              [100.01221764400003, 12.368719794000071],
              [100.00367272200003, 12.353949286000045],
              [99.98170006600003, 12.27993398600006],
              [99.98275800900007, 12.270453192000048],
              [99.99170983200003, 12.259466864000046],
              [100.00171959700003, 12.25031159100007],
              [100.00928795700003, 12.241115627000056],
              [100.01392662900008, 12.23069896000004],
              [100.01710045700003, 12.210109768000052],
              [100.01970462300005, 12.20221588700008],
              [100.02003014400003, 12.192694403000075],
              [100.01563561300003, 12.18032461100006],
              [100.01042728000004, 12.174953518000052],
              [99.99431399800005, 12.162583726000037],
              [99.98764082100007, 12.153021552000041],
              [99.98145592500003, 12.11717357000009],
              [99.97738691500007, 12.108303127000056],
              [99.95533287900008, 12.07249583500004],
              [99.85531660200007, 11.968410549000055],
              [99.83122806100005, 11.924709377000056],
              [99.82325280000003, 11.878648179000038],
              [99.83692467500003, 11.843451239000046],
              [99.83375084700003, 11.837713934000078],
              [99.81959069100003, 11.836371161000045],
              [99.81251061300003, 11.832098700000074],
              [99.80982506600003, 11.824611721000053],
              [99.80958092500003, 11.81346263200004],
              [99.81706790500004, 11.775580145000049],
              [99.81495201900003, 11.769680080000057],
              [99.81177819100003, 11.762274481000077],
              [99.81104576900003, 11.753078518000052],
              [99.81706790500004, 11.741441148000092],
              [99.78044681100005, 11.737250067000048],
              [99.75180097700007, 11.709865627000056],
              [99.67058353000004, 11.577866929000038],
              [99.66553795700003, 11.566799221000053],
              [99.66130618600005, 11.55101146000004],
              [99.64185631600003, 11.523260809000078],
              [99.63754316500007, 11.50531647300005],
              [99.63607832100007, 11.481838283000059],
              [99.63200931100005, 11.460638739000046],
              [99.62574303500003, 11.44049713700008],
              [99.59994550900007, 11.38422272300005],
              [99.59734134200005, 11.374945380000042],
              [99.59294681100005, 11.364203192000048],
              [99.57374108200003, 11.34406159100007],
              [99.56934655000003, 11.33397044500009],
              [99.56625410200007, 11.276312567000048],
              [99.56934655000003, 11.255519924000055],
              [99.58619225400008, 11.21385325700004],
              [99.58619225400008, 11.195135809000078],
              [99.56934655000003, 11.17914459800005],
              [99.56202233200003, 11.198919989000046],
              [99.54615319100003, 11.198431708000044],
              [99.52857506600003, 11.186835028000075],
              [99.51531009200005, 11.17291901200008],
              [99.50814863400007, 11.162176825000074],
              [99.50131269600007, 11.14874909100007],
              [99.49634850400008, 11.132879950000074],
              [99.49415123800003, 11.114569403000075],
              [99.49756920700003, 11.093085028000075],
              [99.51205488400007, 11.05695221600007],
              [99.51531009200005, 11.039211330000057],
              [99.51246178500003, 11.019232489000046],
              [99.50342858200003, 10.99705638200004],
              [99.49870853000004, 10.985296942000048],
              [99.49415123800003, 10.967474677000041],
              [99.49610436300003, 10.944240627000056],
              [99.51156660200007, 10.902411200000074],
              [99.51531009200005, 10.881537177000041],
              [99.51156660200007, 10.866359768000052],
              [99.50326582100007, 10.866848049000055],
              [99.49586022200003, 10.873846747000073],
              [99.49415123800003, 10.878119208000044],
              [99.47535241000003, 10.878851630000042],
              [99.46119225400008, 10.877427476000037],
              [99.45167076900003, 10.87531159100007],
              [99.44320722700007, 10.870347398000092],
              [99.43970787900008, 10.861029364000046],
              [99.43970787900008, 10.820054429000038],
              [99.43506920700003, 10.80182526200008],
              [99.37501061300003, 10.71198151200008],
              [99.37134850400008, 10.703070380000042],
              [99.37370853000004, 10.692572333000044],
              [99.37671959700003, 10.685492255000042],
              [99.37435957100007, 10.681382554000038],
              [99.36109459700003, 10.680121161000045],
              [99.34351647200003, 10.675360419000071],
              [99.32715905000003, 10.663275458000044],
              [99.31316165500004, 10.647365627000056],
              [99.30241946700005, 10.631048895000049],
              [99.29615319100003, 10.610907294000071],
              [99.28825931100005, 10.562933661000045],
              [99.27816816500007, 10.546047268000052],
              [99.26726321700005, 10.541693427000041],
              [99.25473066500007, 10.539943752000056],
              [99.24463951900003, 10.53514232000009],
              [99.24040774800005, 10.521877346000053],
              [99.24268639400003, 10.514471747000073],
              [99.24903405000003, 10.50999583500004],
              [99.25798587300005, 10.508002020000049],
              [99.26832116000003, 10.508205471000053],
              [99.26099694100003, 10.494818427000041],
              [99.25171959700003, 10.483954169000071],
              [99.24382571700005, 10.472357489000046],
              [99.24040774800005, 10.456976630000042],
              [99.24675540500004, 10.443915106000077],
              [99.27767988400007, 10.423570054000038],
              [99.28874759200005, 10.41201406500005],
              [99.29053795700003, 10.399237372000073],
              [99.28931725400008, 10.38084544500009],
              [99.28500410200007, 10.364488023000092],
              [99.27816816500007, 10.357367255000042],
              [99.26384524800005, 10.35732656500005],
              [99.25635826900003, 10.356146552000041],
              [99.23414147200003, 10.343695380000042],
              [99.23072350400008, 10.35651276200008],
              [99.22339928500003, 10.365383205000057],
              [99.21306399800005, 10.37205638200004],
              [99.20004316500007, 10.378485419000071],
              [99.18474368600005, 10.371283270000049],
              [99.17164147200003, 10.370266018000052],
              [99.16065514400003, 10.367987372000073],
              [99.15162194100003, 10.357367255000042],
              [99.15137780000003, 10.34634023600006],
              [99.15845787900008, 10.30272044500009],
              [99.16895592500003, 10.28774648600006],
              [99.20630944100003, 10.254339911000045],
              [99.22461998800003, 10.232367255000042],
              [99.23609459700003, 10.229315497000073],
              [99.25464928500003, 10.234442450000074],
              [99.24170983200003, 10.214504299000055],
              [99.20134524800005, 10.210638739000046],
              [99.19255618600005, 10.19627513200004],
              [99.18677819100003, 10.172430731000077],
              [99.15992272200003, 10.128322658000059],
              [99.15162194100003, 10.103461005000042],
              [99.15349368600005, 10.075832424000055],
              [99.16309655000003, 10.05768463700008],
              [99.17400149800005, 10.042914130000042],
              [99.17888431100005, 10.02529531500005],
              [99.17579186300003, 10.013495184000078],
              [99.16163170700003, 10.003322658000059],
              [99.15845787900008, 9.99054596600007],
              [99.16529381600003, 9.946478583000044],
              [99.16529381600003, 9.867621161000045],
              [99.16675866000003, 9.86469147300005],
              [99.16993248800003, 9.861802476000037],
              [99.17237389400003, 9.85740794500009],
              [99.17212975400008, 9.85024648600006],
              [99.16830488400007, 9.84446849200009],
              [99.15577233200003, 9.834784247000073],
              [99.15162194100003, 9.82916901200008],
              [99.14820397200003, 9.819240627000056],
              [99.14616946700005, 9.809719143000052],
              [99.14494876400005, 9.79124583500004],
              [99.14478600400008, 9.788234768000052],
              [99.14795983200003, 9.767401434000078],
              [99.16195722700007, 9.727118231000077],
              [99.16724694100003, 9.68813711100006],
              [99.17286217500003, 9.665228583000044],
              [99.18140709700003, 9.643255927000041],
              [99.21208743600005, 9.597723700000074],
              [99.21778405000003, 9.582180080000057],
              [99.21998131600003, 9.559149481000077],
              [99.22315514400003, 9.542629299000055],
              [99.26531009200005, 9.466009833000044],
              [99.32357832100007, 9.391546942000048],
              [99.31568444100003, 9.389593817000048],
              [99.31072024800005, 9.389837958000044],
              [99.30600019600007, 9.39085521000004],
              [99.29900149800005, 9.391546942000048],
              [99.29078209700003, 9.39008209800005],
              [99.29004967500003, 9.386419989000046],
              [99.29127037900008, 9.381781317000048],
              [99.28874759200005, 9.37726471600007],
              [99.26384524800005, 9.363755601000037],
              [99.25464928500003, 9.356838283000059],
              [99.23552493600005, 9.336330471000053],
              [99.23023522200003, 9.31976959800005],
              [99.23414147200003, 9.278265692000048],
              [99.25505618600005, 9.232489325000074],
              [99.30176842500003, 9.222601630000042],
              [99.35075931100005, 9.219183661000045],
              [99.37818444100003, 9.192938544000071],
              [99.41098066500007, 9.19635651200008],
              [99.44385826900003, 9.195990302000041],
              [99.47478274800005, 9.200995184000078],
              [99.50171959700003, 9.220282294000071],
              [99.50928795700003, 9.235500393000052],
              [99.51441491000003, 9.253241278000075],
              [99.52149498800003, 9.269924221000053],
              [99.53581790500004, 9.281683661000045],
              [99.54818769600007, 9.283148505000042],
              [99.59351647200003, 9.27484772300005],
              [99.61011803500003, 9.27798086100006],
              [99.62354576900003, 9.284816799000055],
              [99.63379967500003, 9.29165273600006],
              [99.64128665500004, 9.294745184000078],
              [99.67237389400003, 9.30219147300005],
              [99.68913821700005, 9.31391022300005],
              [99.68946373800003, 9.31586334800005],
              [99.72730553500003, 9.313706773000092],
              [99.73373457100007, 9.312160549000055],
              [99.73951256600003, 9.320502020000049],
              [99.75277754000007, 9.31976959800005],
              [99.77182050900007, 9.312282619000086],
              [99.78158613400007, 9.308417059000078],
              [99.78687584700003, 9.31281159100007],
              [99.79769941500007, 9.31834544500009],
              [99.80339603000004, 9.322658596000053],
              [99.81544030000003, 9.31118398600006],
              [99.85352623800003, 9.294663804000038],
              [99.85450280000003, 9.285101630000042],
              [99.85303795700003, 9.273993231000077],
              [99.85962975400008, 9.257757880000042],
              [99.87777754000007, 9.22646719000005],
              [99.88599694100003, 9.233303127000056],
              [99.88648522200003, 9.157904364000046],
              [99.89144941500007, 9.138332424000055],
              [99.89958743600005, 9.12531159100007],
              [99.90870201900003, 9.114081122000073],
              [99.91627037900008, 9.101996161000045],
              [99.91944420700003, 9.086493231000077],
              [99.91944420700003, 9.038397528000075],
              [99.92164147200003, 9.028225002000056],
              [99.93132571700005, 9.011867580000057],
              [99.93311608200003, 9.000555731000077],
              [99.93116295700003, 8.999823309000078],
              [99.92652428500003, 8.994533596000053],
              [99.92188561300003, 8.987127997000073],
              [99.91944420700003, 8.980047919000071],
              [99.91944420700003, 8.95579661700009],
              [99.93116295700003, 8.878973700000074],
              [99.92628014400003, 8.863348700000074],
              [99.93921959700003, 8.832464911000045],
              [99.95923912900008, 8.637640692000048],
              [99.96713300900007, 8.605658270000049],
              [99.98414147200003, 8.579413153000075],
              [100.04078209700003, 8.54555898600006],
              [100.04965254000007, 8.530951239000046],
              [100.05372155000003, 8.51365794500009],
              [100.07593834700003, 8.470404364000046],
              [100.09213300900007, 8.446437893000052],
              [100.09848066500007, 8.426459052000041],
              [100.10434004000007, 8.417669989000046],
              [100.11198978000004, 8.41315338700008],
              [100.13404381600003, 8.40375397300005],
              [100.13851972700007, 8.400946356000077],
              [100.14421634200005, 8.388820705000057],
              [100.15756269600007, 8.38572825700004],
              [100.17351321700005, 8.389349677000041],
              [100.18628991000003, 8.39720286700009],
              [100.17709394600007, 8.426214911000045],
              [100.17505944100003, 8.466457424000055],
              [100.16480553500003, 8.501369533000059],
              [100.13111412900008, 8.514553127000056],
              [100.15064537900008, 8.522935289000088],
              [100.18083743600005, 8.501206773000092],
              [100.20834394600007, 8.469671942000048],
              [100.22046959700003, 8.448716539000088],
              [100.27149498800003, 8.317084052000041],
              [100.30290774800005, 8.118557033000059],
              [100.34245853000004, 7.938788153000075],
              [100.36736087300005, 7.825588283000059],
              [100.44019616000003, 7.476996161000045],
              [100.50062712400006, 7.333994596000082],
              [100.55440086900006, 7.249833509000041],
              [100.56720549100004, 7.22949262800006],
              [100.57460007300006, 7.209153209000078],
              [100.57398522200003, 7.194973049000055],
              [100.54813921600004, 7.197050183000044],
              [100.53553353000007, 7.210047007000071],
              [100.49963009900006, 7.242325281000092],
              [100.48023522200003, 7.253892320000091],
              [100.47242272200003, 7.258856512000079],
              [100.44433725400006, 7.257817382000042],
              [100.42554772200003, 7.267564195000091],
              [100.43897545700003, 7.294134833000044],
              [100.42907310000004, 7.326386839000065],
              [100.42231851700006, 7.36997402500009],
              [100.40812190500003, 7.378690254000048],
              [100.41000410200007, 7.458319403000075],
              [100.40601647200003, 7.52765534100007],
              [100.38950791600007, 7.566181028000074],
              [100.35892713700008, 7.57861028800005],
              [100.32556391400004, 7.574479835000091],
              [100.30298912900008, 7.540676174000055],
              [100.29574629000007, 7.523586330000057],
              [100.28956139400003, 7.51821523600006],
              [100.27881920700003, 7.523911851000094],
              [100.27263431100005, 7.531073309000078],
              [100.26970462300005, 7.537502346000053],
              [100.26880944100003, 7.545477606000077],
              [100.26880944100003, 7.557440497000073],
              [100.27556399800005, 7.576971747000073],
              [100.30958092500003, 7.597723700000074],
              [100.32349694100003, 7.616400458000044],
              [100.32699629000007, 7.655218817000048],
              [100.32056725400008, 7.707953192000048],
              [100.30697675900007, 7.757879950000074],
              [100.28874759200005, 7.788316148000092],
              [100.26970462300005, 7.795396226000037],
              [100.25049889400003, 7.791978257000039],
              [100.23096764400003, 7.784816799000055],
              [100.21062259200005, 7.780910549000055],
              [100.20085696700005, 7.772324937000064],
              [100.15642337300005, 7.733384507000039],
              [100.14478600400008, 7.719427802000041],
              [100.14291425900007, 7.700018622000073],
              [100.15463300900007, 7.615790106000077],
              [100.17261803500003, 7.568019924000055],
              [100.17920983200003, 7.531195380000042],
              [100.18539472700007, 7.514227606000077],
              [100.19654381600003, 7.507147528000075],
              [100.19922936300003, 7.503810940000051],
              [100.22046959700003, 7.486029364000046],
              [100.22510826900003, 7.479478257000039],
              [100.22779381600003, 7.474595445000091],
              [100.26050866000003, 7.393622137000079],
              [100.27881920700003, 7.362209377000056],
              [100.30298912900008, 7.342678127000056],
              [100.32488040500004, 7.339789130000042],
              [100.34978274800005, 7.33930084800005],
              [100.37012780000003, 7.332709052000041],
              [100.37867272200003, 7.311346747000073],
              [100.37875410200007, 7.309800523000092],
              [100.37940514400003, 7.287665106000077],
              [100.38119550900007, 7.27570221600007],
              [100.38493899800005, 7.266302802000041],
              [100.39380944100003, 7.25853099200009],
              [100.40795767400004, 7.258301914000072],
              [100.41765772700006, 7.25348936000006],
              [100.42687237100006, 7.245308942000065],
              [100.41065514400003, 7.237005927000041],
              [100.40186608200003, 7.233547268000052],
              [100.39519290500004, 7.228664455000057],
              [100.39234459700003, 7.222560940000051],
              [100.39551842500003, 7.211330471000053],
              [100.40259850400008, 7.203192450000074],
              [100.41086040400006, 7.198636690000058],
              [100.42443640400006, 7.171205698000051],
              [100.43655983500008, 7.160134853000045],
              [100.45062495500008, 7.155316541000047],
              [100.46614621000003, 7.157237053000074],
              [100.47778577700007, 7.146162532000062],
              [100.48603135600007, 7.139901052000084],
              [100.49480228000004, 7.136623440000051],
              [100.519988, 7.135553009000091],
              [100.53163022300004, 7.13747383000009],
              [100.55586937000004, 7.144694505000075],
              [100.58082116000003, 7.167629299000055],
              [100.58863366000003, 7.179592190000051],
              [100.58570128300005, 7.207170551000047],
              [100.58541961600008, 7.224401972000067],
              [100.61109459700003, 7.192613023000092],
              [100.76514733200003, 6.98314036700009],
              [100.78443444100003, 6.96710846600007],
              [100.81123879700004, 6.95742781000007],
              [100.82734686500004, 6.951698926000063],
              [100.84994550900007, 6.962062893000052],
              [100.86647424600005, 6.947088590000078],
              [100.89636616000007, 6.91963471400004],
              [100.94810813400005, 6.880730520000043],
              [100.99757308100004, 6.856675229000075],
              [101.02670332100007, 6.856350002000056],
              [101.06804446700005, 6.85773346600007],
              [101.19141686300003, 6.861883856000077],
              [101.23152531000005, 6.880323212000064],
              [101.24426659600005, 6.902029121000055],
              [101.27773147400006, 6.89625619800006],
              [101.29156196900004, 6.884794559000056],
              [101.31006920700003, 6.880357164000088],
              [101.31714928500003, 6.875921942000048],
              [101.31918379000007, 6.877997137000079],
              [101.35132897200003, 6.875921942000048],
              [101.34358280900005, 6.896142525000073],
              [101.32829837300005, 6.917873440000051],
              [101.26254316500007, 6.94476959800005],
              [101.29173116800007, 6.954572005000045],
              [101.32081139400003, 6.949286200000074],
              [101.34669030000003, 6.928615627000056],
              [101.38520969600006, 6.905220335000081],
              [101.41944420700003, 6.894476630000042],
              [101.43685957100007, 6.890204169000071],
              [101.45191491000003, 6.888413804000038],
              [101.47120201900003, 6.884019273000092],
              [101.48804772200003, 6.878322658000059],
              [101.49537194100003, 6.87250397300005],
              [101.52295983200003, 6.860825914000088],
              [101.55738366000003, 6.841782945000091],
              [101.56625410200007, 6.832220770000049],
              [101.66830488400007, 6.658636786000045],
              [101.72348066500007, 6.574408270000049],
              [101.77165774800005, 6.50071849200009],
              [101.80836022200003, 6.464544989000046],
              [101.90870201900003, 6.401922919000071],
              [102.02003014400003, 6.29564036700009],
              [102.07276451900003, 6.257757880000042],
              [102.07309004000007, 6.257513739000046],
              [102.06665583400007, 6.204748336000051],
              [102.07126794400011, 6.126655579000044],
              [102.06000248200007, 6.094797058000083],
              [102.03344079600004, 6.068390402000105],
              [101.95938846900003, 6.011598002000071],
              [101.93473881000011, 5.98172902400006],
              [101.91975264500013, 5.940258687000082],
              [101.91928755700013, 5.897573955000084],
              [101.91293135600012, 5.85930755600009],
              [101.88032352800013, 5.831040548000104],
              [101.86921309400003, 5.823857524000061],
              [101.86425215700007, 5.815408427000065],
              [101.86084151200004, 5.806494242000042],
              [101.8547436930001, 5.797657573000052],
              [101.82549483300005, 5.779829203000091],
              [101.82022383600008, 5.773731384000129],
              [101.81226566600003, 5.752544047000086],
              [101.80048343900006, 5.739909159000149],
              [101.78415368600008, 5.738100484000057],
              [101.76286299700013, 5.74954681400007],
              [101.75418135600006, 5.760269674000085],
              [101.74787683100004, 5.772387797000079],
              [101.74002201400003, 5.782361349000084],
              [101.72679284700013, 5.786469625000095],
              [101.71475223800013, 5.782903951000037],
              [101.6975667000001, 5.767138300000056],
              [101.69661381100013, 5.766264140000104],
              [101.68669193600005, 5.761199849000135],
              [101.66591800900005, 5.765592346000034],
              [101.65036340400013, 5.782645569000067],
              [101.63077803600004, 5.8284050500001],
              [101.63129480000009, 5.837370911000036],
              [101.63439538600011, 5.847344462000137],
              [101.63408532700004, 5.855586853000077],
              [101.62457686400006, 5.859410909000118],
              [101.61289799000008, 5.861348775000053],
              [101.60514652500007, 5.866103007000049],
              [101.5997721760001, 5.874061178000105],
              [101.59512129800004, 5.885352478000073],
              [101.57930831000004, 5.906333109000073],
              [101.55791426600013, 5.911345724000043],
              [101.53465987100003, 5.906023051000091],
              [101.50020142500006, 5.892693601000047],
              [101.39265303600013, 5.851091004000068],
              [101.35756473800006, 5.8284050500001],
              [101.31896244400008, 5.810085755000031],
              [101.27968835500013, 5.803031921000098],
              [101.2489925540001, 5.786986389000049],
              [101.23664188700013, 5.741666158000029],
              [101.23359297700011, 5.719419454000089],
              [101.22501469000008, 5.699213969000098],
              [101.21230228700011, 5.681514791000083],
              [101.19685103400013, 5.666812846000084],
              [101.1499805090001, 5.638649190000137],
              [101.12217858900004, 5.629890035000059],
              [101.1054354260001, 5.637641500000072],
              [101.0939632570001, 5.662652893000057],
              [101.07877038600003, 5.687767640000089],
              [101.05980513500009, 5.709575094000101],
              [101.03732588700007, 5.724587097000082],
              [101.02740401200009, 5.726550802000119],
              [101.00838708500004, 5.725672302000078],
              [100.99862023900005, 5.729548035000036],
              [100.99174727400009, 5.737480367000089],
              [100.98001672400011, 5.760993144000082],
              [100.97242665500005, 5.772852627000077],
              [100.96720096800004, 5.781017762000118],
              [100.96528894000011, 5.792412415000115],
              [100.96771773300009, 5.804117126000094],
              [100.97428064000007, 5.815305075000126],
              [101.0153117270001, 5.898349101000093],
              [101.03184818500011, 5.908916931000078],
              [101.05293217000013, 5.913102722000104],
              [101.07112227400006, 5.919846497000051],
              [101.07877038600003, 5.93816579200012],
              [101.08042403200011, 5.957027690000047],
              [101.0874520270001, 5.98968719500003],
              [101.08900232000013, 6.046608785000089],
              [101.09427331500007, 6.085753683000121],
              [101.08714196800003, 6.105597433000113],
              [101.06853845200004, 6.119550069000098],
              [101.05251875900012, 6.134562073000083],
              [101.05344893400007, 6.157609761000046],
              [101.06688480700012, 6.174327088000084],
              [101.08001062000005, 6.18034739200003],
              [101.08915734900006, 6.188848165000124],
              [101.09101770000007, 6.213161926000041],
              [101.08827884900012, 6.233522441000076],
              [101.08166426600013, 6.246467387000081],
              [101.0689518640001, 6.250859883000075],
              [101.02306319200011, 6.240989685000102],
              [101.0064750570001, 6.246364034000067],
              [100.97428064000007, 6.272615662000092],
              [100.95516036000004, 6.268636576000105],
              [100.92890873200014, 6.240627950000103],
              [100.91009851100011, 6.235796204000081],
              [100.86844730700011, 6.24615732800001],
              [100.85511478700005, 6.247914328000078],
              [100.84281579600014, 6.243935242000092],
              [100.83733809400013, 6.237191467000073],
              [100.83299727400009, 6.236674703000034],
              [100.82457401500005, 6.251480001000047],
              [100.82214522400011, 6.259877422000031],
              [100.82152510600014, 6.288764547000085],
              [100.82338545800008, 6.297678731000104],
              [100.82373221800003, 6.298604273000123],
              [100.8268994550001, 6.307058004000055],
              [100.82901818900007, 6.316256409000047],
              [100.82710616100007, 6.324550477000102],
              [100.81516890500012, 6.344833476000105],
              [100.81072473200004, 6.355763041000088],
              [100.80845096900009, 6.367261048000017],
              [100.80560876500004, 6.414803365000125],
              [100.79630700700011, 6.433949484000038],
              [100.77325931800004, 6.447307841000054],
              [100.76189050400006, 6.448961487000105],
              [100.75160689400013, 6.44880645700006],
              [100.74230513500004, 6.45012420700003],
              [100.73388187700004, 6.456377055000118],
              [100.7311947020001, 6.464722799000086],
              [100.73150476100011, 6.487021179000052],
              [100.72995446800007, 6.493196513000029],
              [100.71284956900013, 6.493041484000088],
              [100.64840905700004, 6.447152812000112],
              [100.63068404100011, 6.444775696000065],
              [100.6126489670001, 6.449168193000062],
              [100.5784391680001, 6.464257711000059],
              [100.51740930200003, 6.481905213000061],
              [100.49916752200005, 6.490302633000042],
              [100.46723148600006, 6.513221131000066],
              [100.45234867400006, 6.516864319000149],
              [100.42651045700012, 6.51389292500005],
              [100.40966394000003, 6.51526234900011],
              [100.38739139900008, 6.522083639000073],
              [100.37765899000004, 6.526754413000091],
              [100.34878910300012, 6.54060963900011],
              [100.32920373500008, 6.557766215000072],
              [100.3178865970001, 6.576705628000113],
              [100.28078291900005, 6.688921000000107],
              [100.27396163000009, 6.696259053000091],
              [100.2633162840001, 6.700005595000022],
              [100.25174076400003, 6.701090801000106],
              [100.24264571200007, 6.700263977000091],
              [100.22750451700006, 6.690833028000029],
              [100.22750451700006, 6.688869324000095],
              [100.21236332200004, 6.689179383000081],
              [100.20378503500012, 6.693881938000061],
              [100.1992002020001, 6.69941363900007],
              [100.1966536870001, 6.702486064000084],
              [100.18755863400008, 6.707963766000077],
              [100.17329593900013, 6.703416240000138],
              [100.16683638600006, 6.695122172000083],
              [100.16404585800012, 6.683727519000087],
              [100.16275394700006, 6.661119080000049],
              [100.15608768800013, 6.620578919000124],
              [100.15717289200006, 6.603525696000105],
              [100.1651827390001, 6.580322978000098],
              [100.16719812000008, 6.566137797000053],
              [100.16120365400013, 6.557456156000086],
              [100.15241866100007, 6.54998891200006],
              [100.14570072500004, 6.539524435000104],
              [100.1448222250001, 6.530584412000081],
              [100.14807784100009, 6.513221131000066],
              [100.1484912520001, 6.504487814000086],
              [100.14435713700004, 6.479579773000125],
              [100.1355721440001, 6.457720643000087],
              [100.12728925900007, 6.442287502000056],
              [100.11996504000007, 6.463120835000041],
              [100.10816491000003, 6.479559637000079],
              [100.09009850400008, 6.484849351000094],
              [100.10230553500003, 6.517075914000088],
              [100.10352623800003, 6.533189195000091],
              [100.09351647200003, 6.540106512000079],
              [100.08057701900003, 6.536810614000046],
              [100.07292728000004, 6.528509833000044],
              [100.06332441500007, 6.50657786700009],
              [100.02995853000004, 6.534654039000088],
              [100.00131269600007, 6.567450262000079],
              [99.99789472700007, 6.576117255000042],
              [99.99512780000003, 6.587713934000078],
              [99.99122155000003, 6.597845770000049],
              [99.98414147200003, 6.60219961100006],
              [99.97144616000003, 6.595607815000051],
              [99.96412194100003, 6.593736070000091],
              [99.96094811300003, 6.598456122000073],
              [99.96314537900008, 6.605698960000041],
              [99.97217858200003, 6.617865302000041],
              [99.97396894600007, 6.622707424000055],
              [99.97152754000007, 6.632757880000042],
              [99.96290123800003, 6.649562893000052],
              [99.96094811300003, 6.660549221000053],
              [99.95655358200003, 6.664007880000042],
              [99.94703209700003, 6.663397528000075],
              [99.93734785200007, 6.664740302000041],
              [99.93311608200003, 6.674221096000053],
              [99.92847741000003, 6.692613023000092],
              [99.91749108200003, 6.705267645000049],
              [99.89144941500007, 6.725043036000045],
              [99.86752363400007, 6.762600002000056],
              [99.85173587300005, 6.776434637000079],
              [99.83375084700003, 6.770086981000077],
              [99.82488040500004, 6.769598700000074],
              [99.81763756600003, 6.782619533000059],
              [99.80958092500003, 6.808294989000046],
              [99.80250084700003, 6.817531643000052],
              [99.79721113400007, 6.821682033000059],
              [99.71070397200003, 6.85415273600006],
              [99.68580162900008, 6.877346096000053],
              [99.68604576900003, 6.917466539000088],
              [99.69044030000003, 6.935492255000042],
              [99.69581139400003, 6.937689520000049],
              [99.71021569100003, 6.937974351000094],
              [99.71387780000003, 6.942206122000073],
              [99.71290123800003, 6.951646226000094],
              [99.70720462300005, 6.961004950000074],
              [99.69629967500003, 6.965277411000045],
              [99.68091881600003, 6.973618882000039],
              [99.68213951900003, 6.992661851000094],
              [99.68620853000004, 7.013373114000046],
              [99.67920983200003, 7.026760158000059],
              [99.69548587300005, 7.059881903000075],
              [99.70573978000004, 7.075425523000092],
              [99.71680748800003, 7.081976630000042],
              [99.71998131600003, 7.08852773600006],
              [99.74805748800003, 7.126044012000079],
              [99.74057050900007, 7.137111721000053],
              [99.72339928500003, 7.131822007000039],
              [99.70484459700003, 7.121242580000057],
              [99.69288170700003, 7.116115627000056],
              [99.67758222700007, 7.123277085000041],
              [99.67188561300003, 7.13540273600006],
              [99.67237389400003, 7.170721747000073],
              [99.63754316500007, 7.150864976000094],
              [99.62110436300003, 7.13703034100007],
              [99.61410566500007, 7.136664130000042],
              [99.61085045700003, 7.150864976000094],
              [99.60352623800003, 7.150864976000094],
              [99.58399498800003, 7.156439520000049],
              [99.55787194100003, 7.197455145000049],
              [99.54004967500003, 7.244126695000091],
              [99.54542076900003, 7.266302802000041],
              [99.56674238400007, 7.278021552000041],
              [99.58521569100003, 7.306708075000074],
              [99.59839928500003, 7.342718817000048],
              [99.60352623800003, 7.376166083000044],
              [99.59734134200005, 7.376166083000044],
              [99.56902103000004, 7.322211005000042],
              [99.54957116000003, 7.301825262000079],
              [99.52466881600003, 7.311346747000073],
              [99.52051842500003, 7.326971747000073],
              [99.52540123800003, 7.370021877000056],
              [99.52149498800003, 7.383612372000073],
              [99.50814863400007, 7.384955145000049],
              [99.49781334700003, 7.370794989000046],
              [99.49097741000003, 7.35101959800005],
              [99.48804772200003, 7.335191148000092],
              [99.49219811300003, 7.299872137000079],
              [99.48829186300003, 7.285711981000077],
              [99.47071373800003, 7.279974677000041],
              [99.46021569100003, 7.282863674000055],
              [99.44516035200007, 7.28969961100006],
              [99.43181399800005, 7.297796942000048],
              [99.42603600400008, 7.304510809000078],
              [99.42066491000003, 7.307440497000073],
              [99.39234459700003, 7.312201239000046],
              [99.37818444100003, 7.32094961100006],
              [99.36589603000004, 7.336371161000045],
              [99.33659915500004, 7.383612372000073],
              [99.34587649800005, 7.400051174000055],
              [99.34742272200003, 7.423488674000055],
              [99.34400475400008, 7.468980210000041],
              [99.34180748800003, 7.475734768000052],
              [99.33187910200007, 7.491929429000038],
              [99.32984459700003, 7.503404039000088],
              [99.32520592500003, 7.504868882000039],
              [99.30339603000004, 7.50462474200009],
              [99.29558353000004, 7.507147528000075],
              [99.30884850400008, 7.528306382000039],
              [99.30738366000003, 7.550279039000088],
              [99.30005944100003, 7.575384833000044],
              [99.29273522200003, 7.620672919000071],
              [99.28589928500003, 7.621771552000041],
              [99.27702884200005, 7.61749909100007],
              [99.26832116000003, 7.616400458000044],
              [99.25953209700003, 7.620835679000038],
              [99.24976647200003, 7.627752997000073],
              [99.24675540500004, 7.634100653000075],
              [99.25806725400008, 7.636867580000057],
              [99.26221764400003, 7.643255927000041],
              [99.25570722700007, 7.657375393000052],
              [99.24366295700003, 7.671454169000071],
              [99.23047936300003, 7.677801825000074],
              [99.21436608200003, 7.67999909100007],
              [99.20622806100005, 7.685939846000053],
              [99.19255618600005, 7.705145575000074],
              [99.17261803500003, 7.719712632000039],
              [99.15308678500003, 7.730658270000049],
              [99.13754316500007, 7.744330145000049],
              [99.13054446700005, 7.767238674000055],
              [99.12427819100003, 7.767238674000055],
              [99.12191816500007, 7.73305898600006],
              [99.11215254000007, 7.705511786000045],
              [99.09148196700005, 7.691839911000045],
              [99.05600019600007, 7.698919989000046],
              [99.03321373800003, 7.722805080000057],
              [99.02767988400007, 7.788885809000078],
              [99.01441491000003, 7.815008856000077],
              [99.05600019600007, 7.847357489000046],
              [99.06226647200003, 7.859361070000091],
              [99.06413821700005, 7.878119208000044],
              [99.07032311300003, 7.907904364000046],
              [99.06959069100003, 7.924872137000079],
              [99.05030358200003, 7.905462958000044],
              [99.04070071700005, 7.901841539000088],
              [99.02808678500003, 7.90375397300005],
              [99.02295983200003, 7.909572658000059],
              [99.00757897200003, 7.935126044000071],
              [99.00025475400008, 7.942572333000044],
              [98.98414147200003, 7.947251695000091],
              [98.96778405000003, 7.956203518000052],
              [98.96045983200003, 7.976385809000078],
              [98.96159915500004, 7.986476955000057],
              [98.96338951900003, 7.992621161000045],
              [98.96387780000003, 7.998277085000041],
              [98.96045983200003, 8.006781317000048],
              [98.95346113400007, 8.015448309000078],
              [98.93734785200007, 8.024318752000056],
              [98.92945397200003, 8.030991929000038],
              [98.92367597700007, 8.041408596000053],
              [98.92212975400008, 8.048529364000046],
              [98.91797936300003, 8.051336981000077],
              [98.90528405000003, 8.048407294000071],
              [98.89893639400003, 8.042710679000038],
              [98.89161217500003, 8.024888414000088],
              [98.88819420700003, 8.021063544000071],
              [98.87281334700003, 8.016791083000044],
              [98.85792076900003, 8.00844961100006],
              [98.84359785200007, 8.002875067000048],
              [98.82943769600007, 8.006781317000048],
              [98.82455488400007, 8.014349677000041],
              [98.81771894600007, 8.03656647300005],
              [98.81275475400008, 8.044989325000074],
              [98.80030358200003, 8.052435614000046],
              [98.79468834700003, 8.048488674000055],
              [98.79200280000003, 8.040228583000044],
              [98.78858483200003, 8.034735419000071],
              [98.77556399800005, 8.02342357000009],
              [98.77027428500003, 8.02366771000004],
              [98.76807701900003, 8.03815338700008],
              [98.76539147200003, 8.04710521000004],
              [98.75245201900003, 8.060126044000071],
              [98.74740644600007, 8.06826406500005],
              [98.74512780000003, 8.087551174000055],
              [98.74740644600007, 8.136542059000078],
              [98.74390709700003, 8.149888414000088],
              [98.74740644600007, 8.18195221600007],
              [98.74740644600007, 8.19920482000009],
              [98.74415123800003, 8.214911200000074],
              [98.72706139400003, 8.253851630000042],
              [98.71273847700007, 8.225897528000075],
              [98.70655358200003, 8.225897528000075],
              [98.70313561300003, 8.298529364000046],
              [98.69629967500003, 8.30849844000005],
              [98.67725670700003, 8.303168036000045],
              [98.64820397200003, 8.284857489000046],
              [98.63754316500007, 8.287990627000056],
              [98.63086998800003, 8.287990627000056],
              [98.63086998800003, 8.28115469000005],
              [98.62403405000003, 8.28115469000005],
              [98.62208092500003, 8.29287344000005],
              [98.62623131600003, 8.346096096000053],
              [98.63160241000003, 8.354437567000048],
              [98.64795983200003, 8.366522528000075],
              [98.65544681100005, 8.37962474200009],
              [98.64210045700003, 8.385931708000044],
              [98.62061608200003, 8.390204169000071],
              [98.60352623800003, 8.39720286700009],
              [98.59888756600003, 8.37490469000005],
              [98.58513431100005, 8.368963934000078],
              [98.56755618600005, 8.367865302000041],
              [98.55201256600003, 8.36001211100006],
              [98.54175866000003, 8.349025783000059],
              [98.52605228000004, 8.336330471000053],
              [98.51042728000004, 8.33112213700008],
              [98.50049889400003, 8.34320709800005],
              [98.49366295700003, 8.34320709800005],
              [98.49195397200003, 8.331284898000092],
              [98.48666425900007, 8.324896552000041],
              [98.47982832100007, 8.325751044000071],
              [98.47315514400003, 8.335760809000078],
              [98.46631920700003, 8.335760809000078],
              [98.46631920700003, 8.322739976000037],
              [98.44564863400007, 8.325100002000056],
              [98.42823326900003, 8.316961981000077],
              [98.42221113400007, 8.306341864000046],
              [98.45313561300003, 8.29401276200008],
              [98.45679772200003, 8.277533270000049],
              [98.45655358200003, 8.258286851000037],
              [98.46265709700003, 8.243312893000052],
              [98.46290123800003, 8.216131903000075],
              [98.44613691500007, 8.175116278000075],
              [98.42497806100005, 8.14842357000009],
              [98.41163170700003, 8.164496161000045],
              [98.40552819100003, 8.164496161000045],
              [98.40479576900003, 8.155218817000048],
              [98.40202884200005, 8.148993231000077],
              [98.39128665500004, 8.136542059000078],
              [98.37525475400008, 8.150824286000045],
              [98.35694420700003, 8.18500397300005],
              [98.33122806100005, 8.195054429000038],
              [98.32813561300003, 8.202337958000044],
              [98.32398522200003, 8.20962148600006],
              [98.31251061300003, 8.21287669500009],
              [98.30152428500003, 8.21360911700009],
              [98.29330488400007, 8.21588776200008],
              [98.28687584700003, 8.219916083000044],
              [98.28142337300005, 8.225897528000075],
              [98.27759850400008, 8.240708726000037],
              [98.27759850400008, 8.28351471600007],
              [98.27149498800003, 8.29791901200008],
              [98.26238040500004, 8.31281159100007],
              [98.24203535200007, 8.40648021000004],
              [98.19947350400008, 8.534369208000044],
              [98.19800866000003, 8.556057033000059],
              [98.20297285200007, 8.573879299000055],
              [98.20972741000003, 8.58148834800005],
              [98.21314537900008, 8.57257721600007],
              [98.21566816500007, 8.55337148600006],
              [98.22315514400003, 8.540432033000059],
              [98.24732506600003, 8.514553127000056],
              [98.25310306100005, 8.534654039000088],
              [98.24431399800005, 8.54686107000009],
              [98.23015384200005, 8.556586005000042],
              [98.21998131600003, 8.569159247000073],
              [98.21949303500003, 8.57562897300005],
              [98.22217858200003, 8.580633856000077],
              [98.22527103000004, 8.584906317000048],
              [98.22681725400008, 8.589016018000052],
              [98.22624759200005, 8.60537344000005],
              [98.22681725400008, 8.61009349200009],
              [98.23804772200003, 8.641058661000045],
              [98.24048912900008, 8.651068427000041],
              [98.23853600400008, 8.673041083000044],
              [98.22282962300005, 8.712388414000088],
              [98.21998131600003, 8.726223049000055],
              [98.22413170700003, 8.73533763200004],
              [98.23121178500003, 8.74087148600006],
              [98.23959394600007, 8.745835679000038],
              [98.24732506600003, 8.753485419000071],
              [98.25074303500003, 8.759955145000049],
              [98.25277754000007, 8.766424872000073],
              [98.25652103000004, 8.828558661000045],
              [98.26156660200007, 8.85065338700008],
              [98.28353925900007, 8.884955145000049],
              [98.29273522200003, 8.924383856000077],
              [98.31218509200005, 8.951361395000049],
              [98.32488040500004, 8.97524648600006],
              [98.33301842500003, 8.980047919000071],
              [98.33676191500007, 8.97760651200008],
              [98.35157311300003, 8.973781643000052],
              [98.36402428500003, 8.973944403000075],
              [98.36060631600003, 8.98346588700008],
              [98.35808353000004, 8.99599844000005],
              [98.36784915500004, 9.00999583500004],
              [98.39128665500004, 9.035305080000057],
              [98.36133873800003, 9.023016669000071],
              [98.34245853000004, 9.01821523600006],
              [98.33269290500004, 9.026068427000041],
              [98.32984459700003, 9.052069403000075],
              [98.34205162900008, 9.062892971000053],
              [98.36597741000003, 9.06391022300005],
              [98.38200931100005, 9.071926174000055],
              [98.37077884200005, 9.103583075000074],
              [98.34148196700005, 9.141831773000092],
              [98.32837975400008, 9.16437409100007],
              [98.32300866000003, 9.189195054000038],
              [98.32227623800003, 9.209377346000053],
              [98.32691491000003, 9.203680731000077],
              [98.33969160200007, 9.199774481000077],
              [98.34782962300005, 9.202785549000055],
              [98.35580488400007, 9.209906317000048],
              [98.37077884200005, 9.22646719000005],
              [98.35230553500003, 9.235907294000071],
              [98.35189863400007, 9.251369533000059],
              [98.36109459700003, 9.26821523600006],
              [98.36402428500003, 9.281683661000045],
              [98.37598717500003, 9.298163153000075],
              [98.38331139400003, 9.316555080000057],
              [98.39714603000004, 9.37881094000005],
              [98.40503991000003, 9.396877346000053],
              [98.42546634200005, 9.432521877000056],
              [98.44320722700007, 9.520819403000075],
              [98.45720462300005, 9.548529364000046],
              [98.48682701900003, 9.52806224200009],
              [98.51986738400007, 9.55377838700008],
              [98.53109785200007, 9.566107489000046],
              [98.52849368600005, 9.575873114000046],
              [98.52084394600007, 9.57758209800005],
              [98.50171959700003, 9.575018622000073],
              [98.49366295700003, 9.575873114000046],
              [98.48959394600007, 9.58038971600007],
              [98.48585045700003, 9.59365469000005],
              [98.48340905000003, 9.596380927000041],
              [98.46338951900003, 9.604437567000048],
              [98.47169030000003, 9.621161200000074],
              [98.49024498800003, 9.634955145000049],
              [98.50049889400003, 9.634507554000038],
              [98.50269616000003, 9.638373114000046],
              [98.51197350400008, 9.650213934000078],
              [98.51417076900003, 9.654730536000045],
              [98.51148522200003, 9.662054755000042],
              [98.49366295700003, 9.685736395000049],
              [98.51002037900008, 9.68659088700008],
              [98.51319420700003, 9.694891669000071],
              [98.50660241000003, 9.705633856000077],
              [98.49366295700003, 9.713690497000073],
              [98.50049889400003, 9.719916083000044],
              [98.51563561300003, 9.710191148000092],
              [98.53142337300005, 9.703924872000073],
              [98.54395592500003, 9.70648834800005],
              [98.54900149800005, 9.72361888200004],
              [98.55323326900003, 9.72459544500009],
              [98.56128991000003, 9.73305898600006],
              [98.56576582100007, 9.742621161000045],
              [98.55925540500004, 9.747219143000052],
              [98.53874759200005, 9.747463283000059],
              [98.52979576900003, 9.749579169000071],
              [98.52100670700003, 9.75462474200009],
              [98.51644941500007, 9.747788804000038],
              [98.51531009200005, 9.744818427000041],
              [98.51417076900003, 9.740383205000057],
              [98.50798587300005, 9.740383205000057],
              [98.50912519600007, 9.748521226000037],
              [98.50879967500003, 9.770819403000075],
              [98.50798587300005, 9.774562893000052],
              [98.51636803500003, 9.782945054000038],
              [98.52418053500003, 9.784979559000078],
              [98.53223717500003, 9.785305080000057],
              [98.54151451900003, 9.788234768000052],
              [98.55543053500003, 9.798041083000044],
              [98.56617272200003, 9.81000397300005],
              [98.57496178500003, 9.824652411000045],
              [98.58301842500003, 9.84284088700008],
              [98.57496178500003, 9.835598049000055],
              [98.55844160200007, 9.815008856000077],
              [98.54900149800005, 9.809271552000041],
              [98.54004967500003, 9.810980536000045],
              [98.53467858200003, 9.818019924000055],
              [98.53028405000003, 9.825588283000059],
              [98.51270592500003, 9.836859442000048],
              [98.52076256600003, 9.854437567000048],
              [98.53687584700003, 9.87295156500005],
              [98.54900149800005, 9.883734442000048],
              [98.55355879000007, 9.876695054000038],
              [98.55990644600007, 9.87303294500009],
              [98.56739342500003, 9.873236395000049],
              [98.57618248800003, 9.87759023600006],
              [98.57048587300005, 9.88422272300005],
              [98.58545983200003, 9.894964911000045],
              [98.58985436300003, 9.905462958000044],
              [98.58643639400003, 9.909328518000052],
              [98.57886803500003, 9.911322333000044],
              [98.57162519600007, 9.91547272300005],
              [98.57357832100007, 9.92088450700004],
              [98.58383222700007, 9.93032461100006],
              [98.59197024800005, 9.942694403000075],
              [98.59986412900008, 9.948146877000056],
              [98.62208092500003, 9.947821356000077],
              [98.63086998800003, 9.952704169000071],
              [98.63314863400007, 9.962958075000074],
              [98.62354576900003, 9.967189846000053],
              [98.61255944100003, 9.965969143000052],
              [98.61036217500003, 9.960109768000052],
              [98.59961998800003, 9.973863023000092],
              [98.59978274800005, 9.98045482000009],
              [98.60352623800003, 9.99359772300005],
              [98.64795983200003, 10.06932200700004],
              [98.66228274800005, 10.085272528000075],
              [98.68962649800005, 10.162054755000042],
              [98.71290123800003, 10.205511786000045],
              [98.72046959700003, 10.227932033000059],
              [98.72535241000003, 10.251613674000055],
              [98.72706139400003, 10.272040106000077],
              [98.73080488400007, 10.29173411700009],
              [98.74626712300005, 10.329006252000056],
              [98.74740644600007, 10.350531317000048],
              [98.76640507000008, 10.411200257000075],
              [98.77653365100008, 10.462101543000102],
              [98.79038293500008, 10.500264588000078],
              [98.79131311100014, 10.520418396000053],
              [98.7772571210001, 10.583231100000106],
              [98.77074589100005, 10.593979798000134],
              [98.75152225800014, 10.61036122600008],
              [98.74790490800012, 10.623125305000059],
              [98.75679325400006, 10.66606842000003],
              [98.76671512800004, 10.688754375000087],
              [98.81095015500006, 10.746631979000114],
              [98.83007043500004, 10.763556010000102],
              [98.83957889800013, 10.766398214000077],
              [98.86086958900012, 10.76766428700003],
              [98.86820764200013, 10.76988637300012],
              [98.87533899000005, 10.778619690000099],
              [98.87919148800006, 10.788202779000045],
              [98.88360721800012, 10.799186910000088],
              [98.8920821530001, 10.808514506000037],
              [98.90541467400004, 10.814405619000127],
              [98.91471643100004, 10.812286886000052],
              [98.92329471800008, 10.808101095000026],
              [98.93404341600012, 10.80771352100001],
              [98.96970015500011, 10.823113098000093],
              [98.9744543870001, 10.824198303000088],
              [98.98189579300004, 10.832414856000113],
              [98.98613326000009, 10.840321350000067],
              [98.98985396400008, 10.860449321000132],
              [98.98975061000004, 10.875151266000032],
              [98.9817924400001, 10.895485942000064],
              [98.97962203000009, 10.90765574100007],
              [98.98024214700007, 10.918016867000077],
              [98.98261926300012, 10.928946432000146],
              [98.98665002500007, 10.93930755600006],
              [98.99233443300005, 10.947963359000113],
              [99.00153283700013, 10.957626851000043],
              [99.00556359900003, 10.95881541000007],
              [99.01062788900003, 10.956231588000065],
              [99.02334029100007, 10.954371236000057],
              [99.03470910700008, 10.95096059200003],
              [99.04525109800011, 10.94550872800005],
              [99.05506962100009, 10.94525034600008],
              [99.06364790900011, 10.95742014600009],
              [99.07253625500005, 10.987599182000082],
              [99.07687707600013, 10.996513367000105],
              [99.09320682800006, 11.012972311000084],
              [99.13310103300012, 11.033384501000029],
              [99.14094611700011, 11.039409961000047],
              [99.15170455000003, 11.047673035000102],
              [99.15821578000003, 11.057310689000118],
              [99.16762089100007, 11.077981262000051],
              [99.17506229700007, 11.087438050000102],
              [99.18488081900006, 11.092967428000108],
              [99.20617150900006, 11.100021260000034],
              [99.21299279800007, 11.108263652000076],
              [99.24327518800004, 11.197663880000064],
              [99.25619429500006, 11.21998809800003],
              [99.28844038900007, 11.258306173000037],
              [99.30053267400007, 11.280630392000106],
              [99.31572554600012, 11.320808817000028],
              [99.32637089100012, 11.336234233000113],
              [99.36430139200013, 11.37672271800011],
              [99.3705025640001, 11.39333669100003],
              [99.37205285600004, 11.410855001000087],
              [99.37763391100003, 11.435504660000078],
              [99.38703902200007, 11.451550192000042],
              [99.41587447100011, 11.480230611000124],
              [99.42817346200007, 11.49689626100006],
              [99.43737186700008, 11.516688334000051],
              [99.44109257000008, 11.533405661000089],
              [99.43923221800009, 11.573919983000096],
              [99.44057580600003, 11.597277731000133],
              [99.44977421100003, 11.613762513000026],
              [99.46610396300008, 11.623942770000085],
              [99.48915165300014, 11.628438619000107],
              [99.53069950400004, 11.630919088000084],
              [99.54258508300006, 11.640479228000075],
              [99.60687056500012, 11.725693665000037],
              [99.61534550000005, 11.74941314700007],
              [99.63002160600013, 11.815765686000105],
              [99.62795455000003, 11.825377503000112],
              [99.61100468000006, 11.830183411000121],
              [99.59178104700004, 11.842275696000101],
              [99.57379764900003, 11.8577269500001],
              [99.56139530500008, 11.872919820000035],
              [99.55405725100007, 11.895037334000051],
              [99.55736454300006, 11.915604554000126],
              [99.57286747300009, 11.95591217100008],
              [99.57400435400007, 11.976324361000124],
              [99.56697635900008, 11.993325908000145],
              [99.55333378100005, 12.005521545000065],
              [99.53431685400011, 12.011567688000099],
              [99.51840051300007, 12.025933737000102],
              [99.52170780500006, 12.053683980000045],
              [99.5376241460001, 12.100864563000073],
              [99.53927779100007, 12.112285055000072],
              [99.54351525900012, 12.12246531200013],
              [99.54578902200012, 12.131870422000091],
              [99.54165490700012, 12.140655416000072],
              [99.53286991400012, 12.144531148000041],
              [99.52263798000013, 12.144221090000144],
              [99.46631067000004, 12.126030986000103],
              [99.45225468000012, 12.129389953000029],
              [99.44884403500009, 12.147218323000061],
              [99.45411503200012, 12.15688181600008],
              [99.46383020100006, 12.164581604000077],
              [99.4719950760001, 12.173624980000042],
              [99.47375207600004, 12.18726755800013],
              [99.4701347250001, 12.197396139000091],
              [99.45938602700005, 12.217084860000043],
              [99.45556197200011, 12.227575175000098],
              [99.45473514800005, 12.238220521000088],
              [99.45711226400005, 12.25641062500003],
              [99.45442509000009, 12.267262675000083],
              [99.44760380100013, 12.278218079000055],
              [99.43220422400009, 12.296408183000096],
              [99.42672652200008, 12.308655498000121],
              [99.42341923000009, 12.327775777000028],
              [99.42062870300003, 12.383379619000038],
              [99.41401411900011, 12.405238749000063],
              [99.39127648900006, 12.445339660000059],
              [99.38703902200007, 12.465906880000148],
              [99.38951949100004, 12.475983785000082],
              [99.40026818900009, 12.497481181000126],
              [99.40419559700007, 12.508126526000112],
              [99.40708947800005, 12.530244039000124],
              [99.40729618400007, 12.551483052],
              [99.40474711600012, 12.566940859000113],
              [99.40326542100007, 12.575926005000042],
              [99.39375695800004, 12.589775289000016],
              [99.34445764200012, 12.616750387000124],
              [99.33339888500012, 12.625432027000087],
              [99.32358036300013, 12.635405579000107],
              [99.31717248600012, 12.645895894000148],
              [99.30973108000006, 12.65349233000012],
              [99.28626997900011, 12.660003560000092],
              [99.27686486900006, 12.6655846150001],
              [99.27345422400003, 12.67354278600007],
              [99.27118046100003, 12.693799947000073],
              [99.26673628800012, 12.702843323000124],
              [99.25629764800004, 12.709457906000125],
              [99.23345666600005, 12.713126933000112],
              [99.22446496600003, 12.717467753000093],
              [99.2141296800001, 12.73465016700007],
              [99.21319950400004, 12.752607727000054],
              [99.21443973800007, 12.771676331000037],
              [99.21071903500007, 12.792269389000126],
              [99.2030709230001, 12.80387074800008],
              [99.18322717300003, 12.82257761600006],
              [99.17526900200005, 12.833429667000104],
              [99.17185835800012, 12.843325704000094],
              [99.16844771400008, 12.874099019000056],
              [99.15532190000005, 12.904484762000024],
              [99.15315149000003, 12.913553975000085],
              [99.15418501800013, 12.926602275000036],
              [99.15790572100013, 12.93595570900007],
              [99.16307336400013, 12.944663188000035],
              [99.16731083200011, 12.956006165000105],
              [99.16483036400012, 12.975514018000112],
              [99.15108443200006, 12.994789327000149],
              [99.13248091700012, 13.01104156500007],
              [99.11532434100008, 13.021402689000084],
              [99.09320682800006, 13.038326722000079],
              [99.08834924300004, 13.058351339000112],
              [99.09382694500005, 13.080675558000081],
              [99.10250858600006, 13.104395040000043],
              [99.10529911300006, 13.129613139000085],
              [99.10219852800009, 13.151834005000111],
              [99.10209517500004, 13.171341858000119],
              [99.11408410700011, 13.188085022000067],
              [99.13320438600005, 13.195164693000095],
              [99.17278853400006, 13.19950551400008],
              [99.18647971700011, 13.211558644000107],
              [99.1872579350001, 13.212243754000042],
              [99.19015181500009, 13.229503682000114],
              [99.1860177000001, 13.249993388000092],
              [99.17340865100005, 13.287432963000072],
              [99.17278853400006, 13.300920512000033],
              [99.17692264900012, 13.310325622000079],
              [99.18271040800005, 13.318723043000062],
              [99.18694787600003, 13.329135844000092],
              [99.18694787600003, 13.33874766000011],
              [99.18364058400005, 13.357971293000034],
              [99.18880822800003, 13.407916565000093],
              [99.18787805200009, 13.427140198000117],
              [99.15201460800012, 13.581962790000091],
              [99.14953413900014, 13.66598866800011],
              [99.15284143100007, 13.688726298000091],
              [99.15253137200006, 13.714874573000102],
              [99.14677934200012, 13.723674124000055],
              [99.14126591000013, 13.73210866300009],
              [99.10881311000009, 13.762701111000098],
              [99.1011649990001, 13.778824158000077],
              [99.08979618300003, 13.826650696000073],
              [99.08948612500006, 13.84391062400006],
              [99.09186324100011, 13.855925395000028],
              [99.09217329900008, 13.863573507000098],
              [99.09000289000011, 13.870110575000083],
              [99.08483524600007, 13.878533834000066],
              [99.08028772000006, 13.881556905000096],
              [99.06633508300007, 13.885329285000111],
              [99.06106408800014, 13.888016459000141],
              [99.05713667800006, 13.89408844000009],
              [99.05207238800006, 13.909048767000058],
              [99.04762821400004, 13.914991557000079],
              [99.01620894400003, 13.937935893000102],
              [99.00711389200006, 13.949640605000084],
              [98.99698531100012, 13.971628926000065],
              [98.98478967300008, 13.990594178000023],
              [98.95295699100006, 14.028033752000084],
              [98.94758264100011, 14.046404724000084],
              [98.9453088790001, 14.069142355000068],
              [98.93528365100013, 14.085394592000071],
              [98.91771366400008, 14.096375834000057],
              [98.89373580000006, 14.103248800000117],
              [98.87234175600014, 14.112473043000122],
              [98.7536926680001, 14.200116272000045],
              [98.73105839100003, 14.223499858000096],
              [98.7069771730001, 14.269982809000041],
              [98.69736535700008, 14.271378073000108],
              [98.68558313000011, 14.26739898700012],
              [98.67039025900004, 14.267915751000075],
              [98.66356897000003, 14.272876688000025],
              [98.65075321400013, 14.289413147000104],
              [98.64424198400008, 14.29566599600011],
              [98.63690393100006, 14.29897328700011],
              [98.62150435400008, 14.30240977000004],
              [98.6144763590001, 14.305148621000086],
              [98.60145389800005, 14.313649394000095],
              [98.59318567000008, 14.321607564000061],
              [98.54771040900005, 14.377676493000095],
              [98.47815393100012, 14.516505229000103],
              [98.46513147000007, 14.523352356000075],
              [98.45283247900005, 14.528054911000055],
              [98.44549442600004, 14.542033386000057],
              [98.44001672400009, 14.566269633000033],
              [98.43133508300014, 14.587844543000088],
              [98.41820926900004, 14.607559103000057],
              [98.29749312300004, 14.721247254000048],
              [98.24333622200004, 14.80511810300004],
              [98.2353780520001, 14.824548442000022],
              [98.23878869700007, 14.839095358000066],
              [98.2390987550001, 14.844004618000099],
              [98.23589481600004, 14.850386658000033],
              [98.22514611800011, 14.858964946000057],
              [98.22214888500008, 14.864261780000092],
              [98.22039188600007, 14.88526825000011],
              [98.22163212100003, 14.92126088500008],
              [98.21491418500011, 14.943171692000135],
              [98.19507043400012, 14.977588196000085],
              [98.19114302600008, 14.988130188000056],
              [98.19122365500004, 14.99320983800007],
              [98.19134973100012, 15.00115264900009],
              [98.19569055200009, 15.010686951000082],
              [98.2011682530001, 15.01929107600003],
              [98.20437219300004, 15.029574687000107],
              [98.19899784400008, 15.051382142000136],
              [98.19879962500005, 15.051583013000055],
              [98.1680719040001, 15.082770575000012],
              [98.16044722500004, 15.106365865000086],
              [98.16499475100005, 15.125796204000068],
              [98.18576867700011, 15.160781149000073],
              [98.19072961500007, 15.179177958000068],
              [98.18468040900012, 15.193154550000088],
              [98.17791385900006, 15.208788554000108],
              [98.17790575900011, 15.20892075700003],
              [98.17719039000008, 15.22059661900002],
              [98.20769286000007, 15.219215764000083],
              [98.21543094900005, 15.218865458000053],
              [98.23289758300012, 15.226797791000095],
              [98.24767704300012, 15.240931295000053],
              [98.28302372200011, 15.289972229000071],
              [98.2951160070001, 15.292607728000078],
              [98.31785363800009, 15.288990377000104],
              [98.33604374200013, 15.282169088000046],
              [98.37025354100012, 15.261911926000053],
              [98.3852397060001, 15.256253357000105],
              [98.3922677000001, 15.258242900000141],
              [98.39474816900008, 15.264909160000059],
              [98.39474816900008, 15.280076193000085],
              [98.39206099500007, 15.285838115000047],
              [98.38606652900012, 15.290385640000082],
              [98.37996871000007, 15.293847962000115],
              [98.3774882410001, 15.296457622000034],
              [98.37883182800005, 15.301625265000041],
              [98.3812089440001, 15.306637879000093],
              [98.38368941300007, 15.31028106700009],
              [98.3848262940001, 15.311366272000086],
              [98.39361128800005, 15.316275533000109],
              [98.39908899000005, 15.321779074000105],
              [98.40032922400007, 15.330667420000026],
              [98.39619510900008, 15.347617289000127],
              [98.39691858000009, 15.355730489000038],
              [98.40342981000003, 15.360097148000122],
              [98.4393966070001, 15.367590230000062],
              [98.45541630000008, 15.373636373000096],
              [98.47453658000006, 15.383480734000074],
              [98.49500044800004, 15.374799093000107],
              [98.51546431500009, 15.363456116000037],
              [98.5302437740001, 15.347720642000056],
              [98.53355106600009, 15.325964865000046],
              [98.55990604700003, 15.355317078000027],
              [98.56900109900005, 15.402135926000142],
              [98.56714074700011, 15.452546285000054],
              [98.54367964700003, 15.601503601000033],
              [98.54574670400012, 15.658631897000035],
              [98.54405541500006, 15.675098034000072],
              [98.5402690030001, 15.711961975000023],
              [98.54305953000005, 15.735371399000073],
              [98.57437544800007, 15.835985413000017],
              [98.57664921100007, 15.854175517000058],
              [98.56931115800012, 15.896136780000077],
              [98.5685876870001, 15.920166321000082],
              [98.5806799720001, 15.95913035100007],
              [98.58378055900005, 15.976958720000127],
              [98.5769592690001, 15.996905823000063],
              [98.5500875250001, 16.034216207000085],
              [98.54698693800003, 16.047497050000104],
              [98.55587528500007, 16.055506897000058],
              [98.56765751100005, 16.05395660500004],
              [98.57995650300012, 16.048788961000056],
              [98.59008508300013, 16.045791728000026],
              [98.60310754400007, 16.045843404000053],
              [98.6115824790001, 16.04692861000005],
              [98.61912723800003, 16.051011048000063],
              [98.63018599400004, 16.060002747000098],
              [98.64413863200014, 16.079639791000133],
              [98.65033980300012, 16.099638570000067],
              [98.65871138500012, 16.116278381000072],
              [98.67958866400005, 16.126148580000077],
              [98.69715865100005, 16.126872051000063],
              [98.75844690000008, 16.119172262000077],
              [98.77033247900005, 16.113849589000026],
              [98.7760168860001, 16.106873270000037],
              [98.78304488100008, 16.102429098000115],
              [98.79844445800006, 16.104444479000065],
              [98.80722945200006, 16.110542298000027],
              [98.83079390500006, 16.135605367000025],
              [98.83544478300013, 16.14454539000006],
              [98.83472131400003, 16.167748108000055],
              [98.83668501900007, 16.189038799000045],
              [98.84309289600009, 16.208727519000107],
              [98.85559859200009, 16.22696929900006],
              [98.88371057200004, 16.258750305000078],
              [98.88867150900006, 16.27456329400009],
              [98.89342574100004, 16.319883525000094],
              [98.90334761600008, 16.363446757000034],
              [98.90252079300006, 16.381636862000093],
              [98.88526086500013, 16.406183167000066],
              [98.86210982300008, 16.420652568],
              [98.84340295400006, 16.438377584000094],
              [98.83957889800013, 16.47243235300006],
              [98.81870162000007, 16.45563751200008],
              [98.81043339100012, 16.439617819000134],
              [98.80206180900007, 16.398276673000012],
              [98.78862593600007, 16.37455719000006],
              [98.72826786400009, 16.32825510700009],
              [98.69839888600006, 16.284950256000016],
              [98.68237919200004, 16.273478089],
              [98.66325891200012, 16.286655579000083],
              [98.65695438600011, 16.301641744000037],
              [98.64238163200008, 16.37362701500011],
              [98.62946252500006, 16.402669170000095],
              [98.6282222910001, 16.413572896000048],
              [98.63824751800013, 16.434450176000027],
              [98.63979781100005, 16.44499216700008],
              [98.63163293400004, 16.463130595000038],
              [98.57044803900004, 16.54157541900004],
              [98.56424686700012, 16.55196238200007],
              [98.5640401610001, 16.562711080000085],
              [98.56734745300008, 16.57330474900006],
              [98.56776086400009, 16.582503154000065],
              [98.56579716000005, 16.591546529000098],
              [98.56155969200012, 16.60172678700009],
              [98.54709029100007, 16.620123596000084],
              [98.51226037600003, 16.64327463800008],
              [98.49841109200003, 16.66239491800006],
              [98.49138309700004, 16.689731750000092],
              [98.48631880700003, 16.700997213000065],
              [98.45665653500009, 16.72321807900009],
              [98.45469283100005, 16.74099477200012],
              [98.46254764800011, 16.760115052000017],
              [98.47453658000006, 16.776651509000104],
              [98.48921268700013, 16.780733948000105],
              [98.50543908700007, 16.790655823000023],
              [98.51753137200012, 16.803006490000072],
              [98.52052860500004, 16.8141169230001],
              [98.51319055200008, 16.82217844700007],
              [98.5033720300001, 16.826002503000026],
              [98.49438033100006, 16.831170146000105],
              [98.49003951000009, 16.8432107550001],
              [98.49251997900006, 16.85742177400006],
              [98.50058150300003, 16.86222768100005],
              [98.51195031700013, 16.859282125000064],
              [98.52455936700005, 16.85044545500007],
              [98.51598108000013, 16.878970846000115],
              [98.50946984900003, 16.89266510000003],
              [98.5000647380001, 16.898917949000023],
              [98.48445845500004, 16.905894267000022],
              [98.48073775200004, 16.92057037400012],
              [98.48042769400007, 16.937261862000057],
              [98.47453658000006, 16.950439352000032],
              [98.46368453000008, 16.963616841000103],
              [98.44673466000012, 16.996328023],
              [98.43619266800005, 17.01157257100003],
              [98.41789921100008, 17.029039205000075],
              [98.39991581200007, 17.040149638000102],
              [98.3797620040001, 17.045782370000026],
              [98.33066939300005, 17.04686757400013],
              [98.31330611100003, 17.05203521700004],
              [98.29966353400005, 17.06474762000009],
              [98.28622766100011, 17.08743357400006],
              [98.29015507000014, 17.090844218000072],
              [98.29532271400006, 17.09983591700002],
              [98.29439253800012, 17.107587382000034],
              [98.26834761600003, 17.107742411000075],
              [98.26617720500013, 17.116372376000115],
              [98.27082808400013, 17.127792867000025],
              [98.27899296100003, 17.13657786],
              [98.25625533100003, 17.151615702000086],
              [98.22101200400004, 17.200759990000037],
              [98.20178837100013, 17.215694479000106],
              [98.18618208800012, 17.224221090000114],
              [98.10060591700005, 17.302614238000032],
              [98.09264774600007, 17.31222605400002],
              [98.0904773360001, 17.32524851500007],
              [98.09409468600006, 17.346332500000088],
              [98.09471480300004, 17.358631490000036],
              [98.08872033700004, 17.37279083300008],
              [98.07683475700009, 17.38002553300005],
              [98.06226200400005, 17.38483144100006],
              [98.04872277900006, 17.391549378],
              [98.03549361200004, 17.40503692700004],
              [98.0285689700001, 17.418782858000085],
              [98.01823368400005, 17.44741160100007],
              [97.99611617000005, 17.480794576000036],
              [97.99167199800007, 17.495729065000077],
              [97.98278365100003, 17.505444234000024],
              [97.97224165900008, 17.511697083000044],
              [97.94857385300003, 17.522394104000043],
              [97.93379439300003, 17.531799215000078],
              [97.90799443000009, 17.55486551400007],
              [97.76894657400004, 17.679180399000032],
              [97.75933475800014, 17.691479391000072],
              [97.75313358600005, 17.705380351000045],
              [97.7517899990001, 17.718092753000107],
              [97.75158329300012, 17.729564922000023],
              [97.74961958800009, 17.73984853200001],
              [97.74104130100005, 17.750183818000025],
              [97.71685673100006, 17.76976918600006],
              [97.71117232300003, 17.78129303000007],
              [97.70652144400009, 17.79472890200013],
              [97.69649621600007, 17.80656280600006],
              [97.68399052000007, 17.81653635700006],
              [97.67613570200012, 17.830333964000104],
              [97.69908003800003, 17.83333119800001],
              [97.6855408130001, 17.880718486000077],
              [97.69184533700007, 17.89560129800013],
              [97.72006066900008, 17.943195293000073],
              [97.74755253100005, 17.960920309000088],
              [97.75085982300004, 17.963659160000034],
              [97.7540637620001, 17.969033508000095],
              [97.7517899990001, 17.980764058000076],
              [97.74724247300003, 17.992494609000076],
              [97.7440385330001, 17.9978172820001],
              [97.73980106600004, 18.002933248000105],
              [97.72522831300006, 18.0367554730001],
              [97.72212772600011, 18.04892527300008],
              [97.72006066900008, 18.05305938700012],
              [97.70641809100005, 18.059286398000026],
              [97.7021806240001, 18.061844381000114],
              [97.6977364500001, 18.060733338000105],
              [97.69422245300012, 18.061508484000015],
              [97.69277551300013, 18.070112610000066],
              [97.69370568900007, 18.075125224000104],
              [97.69804650900005, 18.084659525000106],
              [97.69908003800003, 18.090653992000043],
              [97.69680627400004, 18.101583558000087],
              [97.6875045160001, 18.11982533800007],
              [97.68533410700013, 18.13160756400005],
              [97.68533410700013, 18.140160014000074],
              [97.68430057800003, 18.146102804000108],
              [97.68037317000005, 18.15263987200008],
              [97.62900679600011, 18.220852763000025],
              [97.61794803900011, 18.241678365000055],
              [97.62073856600006, 18.25108347600012],
              [97.63572473200003, 18.25759470700008],
              [97.64326949100007, 18.273020121000073],
              [97.64378625500012, 18.291313578000043],
              [97.63758508300003, 18.306325582000042],
              [97.62466597500003, 18.313405253000056],
              [97.57381636600013, 18.333093974000107],
              [97.56244755100005, 18.330510153000105],
              [97.56058719900005, 18.328262227],
              [97.54198368400006, 18.280228983000043],
              [97.53764286300009, 18.272580872000063],
              [97.5283411050001, 18.265320333000076],
              [97.50808394400008, 18.27655995700006],
              [97.48648319500012, 18.292140401000083],
              [97.46653609200007, 18.311441549000037],
              [97.45258345600007, 18.333610738000047],
              [97.4467956950001, 18.35831207300005],
              [97.44648563700014, 18.381178894000058],
              [97.4430749920001, 18.403348084000086],
              [97.4176501880001, 18.441149394000078],
              [97.39460249900003, 18.487089742000038],
              [97.39046838400003, 18.50181752500005],
              [97.37909956900012, 18.520782776000104],
              [97.35760217300009, 18.539903056000085],
              [97.35140100100011, 18.551168519000058],
              [97.37289883000005, 18.548616618000025],
              [97.3801330980001, 18.547757874000027],
              [97.38891809100011, 18.54222849600002],
              [97.40938195800004, 18.51135182700004],
              [97.4121724850001, 18.503031921000073],
              [97.41661665900011, 18.496029765000074],
              [97.42746871000008, 18.489518535000016],
              [97.43811405500003, 18.48812327100002],
              [97.46281538900007, 18.492464091],
              [97.50953088400007, 18.491275533000092],
              [97.54839156100013, 18.509078064000036],
              [97.61794803900011, 18.553158061000104],
              [97.63737837800011, 18.559281718000065],
              [97.6902950440001, 18.55788645400007],
              [97.7379407140001, 18.570495504000107],
              [97.74279829900013, 18.569255270000085],
              [97.74569218000005, 18.571063945000063],
              [97.7517899990001, 18.582484437000076],
              [97.75974816900003, 18.622792054000016],
              [97.75261682100012, 18.663435567000064],
              [97.74124800600003, 18.703148906000067],
              [97.73628706900007, 18.74058848100013],
              [97.73577030500013, 18.76265431800003],
              [97.73266971900006, 18.78050852500006],
              [97.72037072800003, 18.817638041000052],
              [97.7194405520001, 18.82588043200009],
              [97.72336796100006, 18.8519770300001],
              [97.71913049400013, 18.864637756000022],
              [97.70858850100007, 18.875205587],
              [97.68440393100008, 18.892491353000096],
              [97.66187300600006, 18.913782044000087],
              [97.65784224500004, 18.925719299000022],
              [97.66807417800004, 18.93543446900007],
              [97.68905481000013, 18.949748841000044],
              [97.70331750500003, 18.964373271000042],
              [97.71044885300006, 18.979902039000038],
              [97.71696008300012, 19.018323466000098],
              [97.72781213400009, 19.037082011000095],
              [97.78992720500003, 19.082583109000055],
              [97.8040865480001, 19.097956848000123],
              [97.81080448500012, 19.112219543],
              [97.81514530400011, 19.190561015000085],
              [97.81256148300008, 19.208466899000044],
              [97.80522343000007, 19.227354635000083],
              [97.79633508300009, 19.236682231000103],
              [97.76967004500005, 19.25727528900002],
              [97.76408899000012, 19.266396179000097],
              [97.7680163980001, 19.277119040000102],
              [97.77731815600004, 19.27861765500002],
              [97.78868697100012, 19.277739156000067],
              [97.79829878700014, 19.281408183000067],
              [97.80615360600007, 19.3010969030001],
              [97.79705855300006, 19.318382671],
              [97.78310591700011, 19.337089539000104],
              [97.77669803900005, 19.361093242000024],
              [97.77514774600013, 19.371066793000026],
              [97.76770634000007, 19.390367941000065],
              [97.76708622200005, 19.39752512600002],
              [97.8003658450001, 19.440778300000076],
              [97.83354211500011, 19.468709412000052],
              [97.84212040300014, 19.479380595000052],
              [97.84873498500014, 19.493979187000022],
              [97.84811486900003, 19.499560242000044],
              [97.8442908130001, 19.50452118],
              [97.84098352100011, 19.51715606700013],
              [97.83891646300003, 19.537103170000037],
              [97.83984663900003, 19.555319113000095],
              [97.84863163300008, 19.567643942000032],
              [97.86912302100012, 19.570489968000075],
              [97.88583866400012, 19.572811585000053],
              [97.94805708900003, 19.60242218100008],
              [97.95611861200007, 19.60937266000009],
              [97.97069136600004, 19.62593495700007],
              [97.97947636000004, 19.633324686],
              [97.99043176300012, 19.63655446400007],
              [98.00014693200006, 19.6362960820001],
              [98.00831180900008, 19.639112447000073],
              [98.01358280500011, 19.651747335],
              [98.01389286300008, 19.669446513000096],
              [98.00562463400007, 19.705645854000053],
              [98.00459110500009, 19.723913473],
              [98.0179236240001, 19.78938751300008],
              [98.02453820800008, 19.802978414000094],
              [98.04562219200011, 19.807629293000062],
              [98.06060835800008, 19.7939092000001],
              [98.07290734900005, 19.777295227000096],
              [98.0859298100001, 19.773161112000068],
              [98.1113546150001, 19.777140198000055],
              [98.13223189300004, 19.766055603000055],
              [98.17202274600004, 19.73156158400009],
              [98.20592248500009, 19.721484681000035],
              [98.21326053900009, 19.717763978000036],
              [98.21791141800003, 19.707971293000057],
              [98.21667118300007, 19.687455750000098],
              [98.21915165200005, 19.676991272000052],
              [98.23754846200006, 19.66469228100003],
              [98.26276656200014, 19.669859924000022],
              [98.30731164500003, 19.689987895000073],
              [98.34761926300007, 19.690633851000072],
              [98.39443811100011, 19.6863447060001],
              [98.43960331200009, 19.687739970000067],
              [98.47453658000006, 19.70530995700004],
              [98.47780068600014, 19.70562927200008],
              [98.48879927600012, 19.706705220000018],
              [98.49758426900013, 19.7007107540001],
              [98.50512902900005, 19.69151235],
              [98.51546431500009, 19.683373312000086],
              [98.53262089000003, 19.675854390000055],
              [98.5365483000001, 19.677094625000066],
              [98.5379952400001, 19.683890076000026],
              [98.54833052600003, 19.69264923100009],
              [98.56827762900014, 19.69998728500009],
              [98.5907052010001, 19.704095561000102],
              [98.59835331300008, 19.709082336000066],
              [98.61540653500003, 19.7297787480001],
              [98.62377811700003, 19.737504375000086],
              [98.64134810500008, 19.744945781000112],
              [98.7301282150001, 19.757296448000076],
              [98.74924849500007, 19.763497620000052],
              [98.80784956900004, 19.806544088000052],
              [98.8379252530001, 19.793444112000103],
              [98.8518778890001, 19.78403900100004],
              [98.86448693900013, 19.773212789000084],
              [98.88371057200004, 19.745462545000052],
              [98.89931685400006, 19.748614808000113],
              [98.9350769450001, 19.77347117200007],
              [98.97383426900012, 19.788069764000042],
              [98.98768355400006, 19.799361064],
              [99.00091272000009, 19.821013489000094],
              [99.0087675370001, 19.84592153000004],
              [99.00763065600012, 19.864886780000106],
              [99.00266971900004, 19.883593649000076],
              [98.99936242700005, 19.90772654200005],
              [99.00142948400003, 19.917880961000023],
              [99.00618371600012, 19.924934795000027],
              [99.0109379480001, 19.930205790000045],
              [99.01352176900008, 19.934960022000055],
              [99.0127983000001, 19.944235942000077],
              [99.00701053900013, 19.962451884000117],
              [99.00587365800004, 19.972347921],
              [99.01682906100012, 20.041000061000048],
              [99.03646610500004, 20.075158183000028],
              [99.0734664310001, 20.101228943000123],
              [99.11749475100004, 20.117791240000102],
              [99.15842248500007, 20.12355316200008],
              [99.17774947100003, 20.121796163000013],
              [99.21898726500012, 20.110453187000033],
              [99.2364538980001, 20.10272756000002],
              [99.27531457500004, 20.072186788000025],
              [99.29567509000009, 20.062497457000106],
              [99.32120324700003, 20.066269837000036],
              [99.44140262900004, 20.10161651600002],
              [99.47447554500013, 20.128074850000118],
              [99.48749800600007, 20.141252340000094],
              [99.49928023300009, 20.14688507100003],
              [99.50873365500013, 20.15280450400006],
              [99.5103389890001, 20.153809713],
              [99.5205709230001, 20.17096628800006],
              [99.52584191900007, 20.196184387000116],
              [99.51891727700013, 20.212178243000054],
              [99.48625777200004, 20.245483704000023],
              [99.47499231000006, 20.303723043000033],
              [99.46641402200004, 20.322171530000062],
              [99.42962040200007, 20.358680929000073],
              [99.42062870300003, 20.37555328400005],
              [99.43995568900004, 20.382167867000064],
              [99.45411503200012, 20.377103577000085],
              [99.50289758300005, 20.34521921800011],
              [99.57968876200005, 20.321241354],
              [99.58930057800006, 20.320776266000067],
              [99.60759403500003, 20.32315338200003],
              [99.61803267400006, 20.3223782350001],
              [99.62702437400009, 20.31876088500003],
              [99.64221724500004, 20.30883901000003],
              [99.65193241400004, 20.30682362900008],
              [99.67125940000011, 20.310130920000077],
              [99.70841475500004, 20.325013733000034],
              [99.72908532700012, 20.32852773100008],
              [99.76959965100014, 20.328424377000047],
              [99.78716963700003, 20.334082947000084],
              [99.80401615400007, 20.34899159700005],
              [99.81300785400003, 20.36526967300007],
              [99.82634037300005, 20.401391500000088],
              [99.83770918800013, 20.41684275300007],
              [99.85569258600003, 20.428056539000025],
              [99.87791345300008, 20.43513621000004],
              [99.93248376500009, 20.442732646000096],
              [99.93713464400014, 20.44500640900013],
              [99.9420439050001, 20.44402455700005],
              [99.95237919200008, 20.436273092000064],
              [99.95878706900004, 20.42748809800007],
              [99.96111250900009, 20.417824606000053],
              [99.96472985900004, 20.408626201000047],
              [99.97434167500006, 20.400823059000018],
              [99.98591719600012, 20.38702545200006],
              [99.99671757100003, 20.3835114540001],
              [100.00844812100013, 20.38358896900003],
              [100.02291752200006, 20.380772603000068],
              [100.03614668800003, 20.373124492],
              [100.04265791800003, 20.364778748000035],
              [100.0476188560001, 20.355244446000043],
              [100.0554736740001, 20.34418569000003],
              [100.09929528800012, 20.317804870000074],
              [100.09727990800008, 20.283233337000084],
              [100.10296431500012, 20.263596293000134],
              [100.11660689300004, 20.24801584900011],
              [100.13464196800004, 20.239101665000092],
              [100.15252201300007, 20.23915334100009],
              [100.16771488500012, 20.25362274200002],
              [100.16709476700004, 20.292612610000035],
              [100.17639652500009, 20.300622457000102],
              [100.17949711200009, 20.302482809000097],
              [100.20171797700004, 20.31031178800002],
              [100.20719567900005, 20.31113861100006],
              [100.20915938300004, 20.312998963000055],
              [100.2206832280001, 20.34899159700005],
              [100.24037194800013, 20.3728144330001],
              [100.27024092600004, 20.391831361000087],
              [100.30651778200013, 20.399686178000096],
              [100.34434493000009, 20.389971009000064],
              [100.36439538600013, 20.36896453900006],
              [100.42160119700009, 20.250186260000092],
              [100.44733606000005, 20.218043518000073],
              [100.45214196800009, 20.210240377000034],
              [100.45730961100008, 20.196391093000088],
              [100.46103031400003, 20.19070668600004],
              [100.46878178000003, 20.18571991000009],
              [100.48562829600007, 20.1787694290001],
              [100.48893558800006, 20.173343404000022],
              [100.49637699400012, 20.164868469000012],
              [100.51281010000008, 20.155282491000023],
              [100.52924320500006, 20.149727275000103],
              [100.53668461100006, 20.1534738160001],
              [100.54195560700009, 20.166728821000035],
              [100.54650313300004, 20.16791737900003],
              [100.54867354400011, 20.158021342000055],
              [100.55058557200005, 20.106525777000073],
              [100.54335087100009, 20.06657989500009],
              [100.51854618300013, 19.995498963],
              [100.49265629100012, 19.93165273000004],
              [100.48795373600012, 19.896977844000034],
              [100.48397465000005, 19.8806997680001],
              [100.4742594810001, 19.865351868000047],
              [100.46562951600004, 19.85977081300011],
              [100.44625085500007, 19.852122701000027],
              [100.43844771400006, 19.84721344000009],
              [100.43141971900008, 19.83827341700008],
              [100.42051599100012, 19.810445659000024],
              [100.40765850600013, 19.794257080000122],
              [100.38351566600005, 19.763859355000065],
              [100.37917484500008, 19.745669251000024],
              [100.38382572400013, 19.732000835000107],
              [100.39004815800007, 19.7243870490001],
              [100.40046553600013, 19.711640320000058],
              [100.4072351480001, 19.699935608000075],
              [100.41049076300004, 19.684251811000124],
              [100.41291955600013, 19.651566467000052],
              [100.41886234600003, 19.634358215000063],
              [100.42707889800005, 19.62180084200007],
              [100.44749108900004, 19.597771302000027],
              [100.45555261300012, 19.584671326000077],
              [100.45896325700005, 19.568057353000043],
              [100.45896325700005, 19.55183095300005],
              [100.46196049000014, 19.537103170000037],
              [100.4742594810001, 19.524985047000044],
              [100.49182946800005, 19.514468893000085],
              [100.52061324100009, 19.502609152000062],
              [100.5492936600001, 19.494547628000092],
              [100.56665694200012, 19.495632833000073],
              [100.57475787800007, 19.508347404000048],
              [100.58598392800013, 19.525966899000124],
              [100.60701623600005, 19.54092722600008],
              [100.63326786300007, 19.5421674600001],
              [100.71476159700006, 19.51245351200005],
              [100.72923099800005, 19.504650371000125],
              [100.7381710200001, 19.495038554000118],
              [100.74550907500009, 19.4850133260001],
              [100.75300215700003, 19.482429504],
              [100.76261397300004, 19.495477804000032],
              [100.80845096900009, 19.536534729],
              [100.84901696800011, 19.582526754000085],
              [100.86121260600004, 19.602603048000034],
              [100.86503666200008, 19.607150574000073],
              [100.87459680200004, 19.61291249600005],
              [100.87981612100009, 19.61358429000002],
              [100.8856555590001, 19.612447408000023],
              [100.97428064000007, 19.61348093700009],
              [101.00254764900012, 19.610612895000102],
              [101.02430342600013, 19.602861430000118],
              [101.06822839400007, 19.577126567000036],
              [101.09582360900009, 19.567282207000048],
              [101.12465905700003, 19.565111796000068],
              [101.15266768400011, 19.56836741100004],
              [101.17685225500009, 19.574749451000073],
              [101.18832442200011, 19.580743917000106],
              [101.19731612200007, 19.586867574000067],
              [101.20796146700013, 19.5895547490001],
              [101.22501469000008, 19.5852139280001],
              [101.23824385600005, 19.578185933],
              [101.24620202600005, 19.57027943900006],
              [101.25105961100007, 19.56030588800006],
              [101.25488366700012, 19.547154236000083],
              [101.25695072400003, 19.522788798000065],
              [101.25173140500004, 19.49444427500005],
              [101.23824385600005, 19.472300924000038],
              [101.21529952000003, 19.46635813500002],
              [101.19287194800006, 19.45279307100013],
              [101.17778243100003, 19.41721384700007],
              [101.17235640500007, 19.376389465000088],
              [101.17845422400012, 19.346623841000095],
              [101.18501713100011, 19.34199880000004],
              [101.20196700100013, 19.338665670000026],
              [101.2077547610001, 19.33468658400004],
              [101.21126875800013, 19.32636667900009],
              [101.21090702300006, 19.320630595000026],
              [101.2092533770001, 19.315592143000046],
              [101.20951176000005, 19.30941680900007],
              [101.22987227400012, 19.225804342000075],
              [101.22677168800004, 19.167151591000035],
              [101.22914880400009, 19.14358713800003],
              [101.23571171100008, 19.12811004700002],
              [101.24744226100006, 19.115785218000056],
              [101.29116052300003, 19.07899159700007],
              [101.31787723800011, 19.05013031100013],
              [101.32640385000013, 19.020545553000076],
              [101.28392582300006, 18.981478170000074],
              [101.27700118000013, 18.967060445000058],
              [101.26728601100007, 18.934452617000105],
              [101.25726078300005, 18.919492289000047],
              [101.23292118400013, 18.892723897000067],
              [101.22491133700004, 18.874766337000082],
              [101.22330936700013, 18.85549102800006],
              [101.22863204000004, 18.795623881000083],
              [101.2239811610001, 18.77854482000005],
              [101.2092017010001, 18.74632456500008],
              [101.20584273300005, 18.73007232700006],
              [101.21126875800013, 18.71190806100013],
              [101.23478153500014, 18.689480489000047],
              [101.24010420700006, 18.673641663000026],
              [101.23472985900003, 18.65844879100011],
              [101.22191410300013, 18.64204152500004],
              [101.19411218300007, 18.61679758700008],
              [101.18532719000007, 18.612534282000027],
              [101.16775720200013, 18.60635894800005],
              [101.16088423700006, 18.59979604100006],
              [101.15814538600011, 18.5899775190001],
              [101.1591272390001, 18.56770497600006],
              [101.15535485900006, 18.556723734000073],
              [101.14207401500005, 18.544295552000094],
              [101.07789188700008, 18.510421651000073],
              [101.07380944800008, 18.50577077200002],
              [101.07194909700007, 18.49566803000009],
              [101.06471439700005, 18.476418559000038],
              [101.03562056500004, 18.44784149200008],
              [101.03029789200008, 18.42779103600013],
              [101.0370158290001, 18.410453593000042],
              [101.05102014200003, 18.39247019400004],
              [101.0740887660001, 18.371613107000044],
              [101.08228438300011, 18.36420318600007],
              [101.14553633700007, 18.336246237000054],
              [101.15540653500005, 18.32288787900005],
              [101.15240930200014, 18.316376649000077],
              [101.13540775500013, 18.298393250000075],
              [101.13013676000003, 18.291158550000105],
              [101.12796634900013, 18.28095245400003],
              [101.12837976100013, 18.245734965000068],
              [101.13173872900012, 18.238861999],
              [101.13964522300006, 18.218708192000022],
              [101.14553633700007, 18.212997945000083],
              [101.15277103700004, 18.209070537000017],
              [101.15928226700004, 18.204057922000047],
              [101.16279626500005, 18.195298768000058],
              [101.16052250200005, 18.179511617000074],
              [101.14563969000011, 18.14194285100008],
              [101.14160892800004, 18.12395945300007],
              [101.14496789600003, 18.104735820000073],
              [101.1620727940001, 18.06745127400002],
              [101.16517338100005, 18.05342112300012],
              [101.15752526900013, 18.0404503380001],
              [101.12543420500003, 18.021330058],
              [101.11230839100006, 18.01130483000007],
              [101.09489343300004, 17.98438140800006],
              [101.08197432500003, 17.958336487000068],
              [101.06616133700004, 17.933996887000077],
              [101.03980635600004, 17.912034403000106],
              [101.00828373200011, 17.895239563000032],
              [101.00084232600005, 17.884800924],
              [100.99712162300006, 17.864595439000098],
              [101.00027388600012, 17.83048899400005],
              [100.99479618300012, 17.817724915000085],
              [100.97428064000007, 17.809249980000075],
              [100.9670459400001, 17.803823955],
              [100.96518558800005, 17.797622783000023],
              [100.96771773300009, 17.791008199000103],
              [100.97428064000007, 17.783980204],
              [100.97521081600013, 17.781913148000044],
              [100.9755208740001, 17.77979441300006],
              [100.97521081600013, 17.77762400400009],
              [100.97428064000007, 17.775505269000107],
              [100.9648755290001, 17.770596009000073],
              [100.95857100500007, 17.7641364550001],
              [100.95640059400012, 17.755919902000088],
              [100.95872603300012, 17.745791321000027],
              [100.96068973800004, 17.725585836000036],
              [100.95587773300008, 17.707531771000063],
              [100.95381677300009, 17.69979929600005],
              [100.93293949400004, 17.65453074100013],
              [100.89945316600011, 17.616961976000127],
              [100.8856555590001, 17.59587799100011],
              [100.88601729400006, 17.573760478000096],
              [100.90193363500009, 17.561926575000072],
              [100.93773837900005, 17.55548637100013],
              [100.98151534100003, 17.54761220300007],
              [101.00084232600005, 17.538207092000036],
              [101.01903243000004, 17.526631572000085],
              [101.03546553500007, 17.51262725900007],
              [101.04931482000006, 17.495729065000077],
              [101.06616133700004, 17.492215067000032],
              [101.09603031500012, 17.47526519800003],
              [101.12465905700003, 17.46394805900006],
              [101.12889652500007, 17.461157532000087],
              [101.1323071700001, 17.461674296000027],
              [101.14181563400007, 17.46715199800012],
              [101.14718998200004, 17.472474671000057],
              [101.16424320500005, 17.495780742000093],
              [101.16672367300004, 17.510611878000034],
              [101.17695560800013, 17.51639963800001],
              [101.19028812700003, 17.51872507800003],
              [101.2021737070001, 17.523169250000038],
              [101.20852990800012, 17.531282451000052],
              [101.22863204000004, 17.56848948200006],
              [101.24702885000005, 17.59215728800008],
              [101.35730635600004, 17.679025371000094],
              [101.36986372900003, 17.683159485000104],
              [101.37746016500012, 17.68264272100008],
              [101.38376468900003, 17.684916484],
              [101.40159305900005, 17.706672262],
              [101.40309167500004, 17.709462789000057],
              [101.40402185100004, 17.71556060900012],
              [101.39875085500006, 17.717162577000053],
              [101.38836389200009, 17.717782695000025],
              [101.38190433800003, 17.72072825200003],
              [101.38800215700007, 17.729306539000063],
              [101.40185144000003, 17.73375071300005],
              [101.41699263500004, 17.73235544900008],
              [101.43203047700013, 17.733595683000104],
              [101.44525964400003, 17.745791321000027],
              [101.44980717000004, 17.749253642000085],
              [101.45347619700004, 17.751010641000065],
              [101.45606001800007, 17.750183818000025],
              [101.45735192900003, 17.745791321000027],
              [101.45910892800009, 17.739486796000037],
              [101.46830733200011, 17.720366516000027],
              [101.47042606700006, 17.722588603000034],
              [101.47419844600006, 17.7305984500001],
              [101.4790043540001, 17.737988180000016],
              [101.48298344000005, 17.745791321000027],
              [101.50272383700013, 17.765376689000064],
              [101.53652022300014, 17.77912262000008],
              [101.5562606200001, 17.792145081000044],
              [101.53403975500004, 17.809560038000072],
              [101.5455048450001, 17.813671657000086],
              [101.56401208500006, 17.820308736000086],
              [101.57052331500006, 17.828887024000025],
              [101.57507084200012, 17.83979075200007],
              [101.57755131000005, 17.85291656500003],
              [101.57755131000005, 17.86810943600007],
              [101.60039229400007, 17.854363506000126],
              [101.61114099200012, 17.865525615000067],
              [101.61987430900007, 17.884645895000048],
              [101.63620406100011, 17.89482615200002],
              [101.72906661000013, 17.91218943300005],
              [101.73258060800009, 17.93203318300003],
              [101.75692020700012, 17.9978172820001],
              [101.76575687700011, 18.040321147000057],
              [101.77392175300014, 18.058562927000096],
              [101.7904065350001, 18.073574931000095],
              [101.79665938400012, 18.073574931000095],
              [101.80606449400005, 18.062386983000053],
              [101.84518355300008, 18.052129211000064],
              [101.88378584800006, 18.03083852200008],
              [101.90430139200004, 18.037117208],
              [102.05552696700005, 18.192344575000064],
              [102.07126794400011, 18.20850209600006],
              [102.07850264500007, 18.213798930000095],
              [102.10738518700009, 18.212376684],
              [102.15353682500006, 18.210104065000095],
              [102.17193363500007, 18.20028554300002],
              [102.17839318900013, 18.18597117100005],
              [102.18211389200013, 18.169228007000086],
              [102.19157067900011, 18.152071432000028],
              [102.22180139200003, 18.13160756400005],
              [102.22557377100003, 18.128196920000036],
              [102.23311853100006, 18.12416615800005],
              [102.25657963100008, 18.094038798000057],
              [102.30670577000006, 18.051457418000084],
              [102.33652307200009, 18.037039694000057],
              [102.36639205000012, 18.038796692000048],
              [102.38515059500008, 18.016059062000053],
              [102.41222904500006, 17.994199931000125],
              [102.44550866700007, 17.977766826000064],
              [102.48204390500013, 17.971152243000077],
              [102.56751672400003, 17.970842183000073],
              [102.59960778900006, 17.955184225000025],
              [102.61232019100004, 17.915290019000096],
              [102.59557702600006, 17.850074362000058],
              [102.59526696800009, 17.840824280000064],
              [102.60942631100005, 17.837000224000022],
              [102.66079268400011, 17.81286733000006],
              [102.68291019700007, 17.810076802000097],
              [102.68291019700007, 17.817363180000072],
              [102.6733500570001, 17.831780904000098],
              [102.66761397300013, 17.850074362000058],
              [102.67298832300003, 17.865370585000036],
              [102.68673425300005, 17.87353546200005],
              [102.72218428500008, 17.881803691000087],
              [102.73737715700003, 17.890433655000024],
              [102.77406742300008, 17.922731425],
              [102.83189335200007, 17.95311716700006],
              [102.83804284700005, 17.96376251300005],
              [102.85271895400012, 17.972030742000086],
              [102.9386051840001, 18.008927714000023],
              [102.95493493600003, 18.012131653],
              [102.97291833500009, 18.007739156000113],
              [103.0038208420001, 17.988567200000105],
              [103.0204606530001, 17.98422638000001],
              [103.03792728700006, 17.99068593400007],
              [103.04939945500007, 18.005000305000053],
              [103.05828780100006, 18.019263001000027],
              [103.0682096760001, 18.025774231000113],
              [103.07306726100012, 18.03551523900005],
              [103.06479903100006, 18.094038798000057],
              [103.06634932500009, 18.112254740000097],
              [103.07131026200005, 18.125561422000104],
              [103.07994022600008, 18.134785665000024],
              [103.08770263200012, 18.138666867],
              [103.09213261000008, 18.140881856000036],
              [103.09275598200009, 18.141193542000067],
              [103.09058557100008, 18.136852723000075],
              [103.09008680900013, 18.136164775000097],
              [103.08940378200009, 18.135222668000026],
              [103.08908695500008, 18.134785665000024],
              [103.11006758700006, 18.14181366000004],
              [103.12665572100008, 18.151864726000056],
              [103.13859297700003, 18.1667217],
              [103.14510420800008, 18.18801239],
              [103.15089196800005, 18.22149871900008],
              [103.15729984600011, 18.237027487000105],
              [103.16820357300008, 18.249765727000053],
              [103.17673018400006, 18.25485585600005],
              [103.1852051190001, 18.257749736000036],
              [103.21491906700004, 18.262297262000075],
              [103.23672652300007, 18.26999705000007],
              [103.27352014200005, 18.27606903100012],
              [103.28633589700007, 18.280332336000058],
              [103.29537927300004, 18.287773743000102],
              [103.29651615500012, 18.296894633000065],
              [103.29041833600007, 18.305137024000103],
              [103.24866377800004, 18.33262888600008],
              [103.24018884300011, 18.335987854000095],
              [103.23801843300004, 18.341568909],
              [103.23533125900008, 18.34526377400003],
              [103.23367761200006, 18.349268698000103],
              [103.23398767100014, 18.355779928000075],
              [103.24406457600008, 18.380067851000078],
              [103.26075606300003, 18.400195821000054],
              [103.28256351700003, 18.41556956],
              [103.30685144100005, 18.42567230300007],
              [103.38663985200003, 18.441459452000046],
              [103.39676843300003, 18.441407777000038],
              [103.45154545100013, 18.425310568000057],
              [103.46994226100003, 18.421977437000052],
              [103.47479984500006, 18.422158305000025],
              [103.48911421800005, 18.42443206800003],
              [103.49774418100009, 18.423734436000032],
              [103.52316898700008, 18.417688293000097],
              [103.54880049700006, 18.415414530000064],
              [103.60714318900011, 18.400402527],
              [103.62135420800007, 18.390764873000066],
              [103.6299324950001, 18.383220113000036],
              [103.63861413600006, 18.377949117000085],
              [103.69556156500005, 18.353221945000072],
              [103.70910079000004, 18.349707947000027],
              [103.76718510000012, 18.346684875],
              [103.78460005700003, 18.343894348000035],
              [103.80139489700008, 18.338261617000015],
              [103.81725956200012, 18.330355123000075],
              [103.83209069900005, 18.320665792000042],
              [103.84221927900006, 18.30911611000009],
              [103.84898889200014, 18.296352031000126],
              [103.85777388600013, 18.286481832000035],
              [103.87394860800003, 18.283226217000063],
              [103.8812866620001, 18.284414775000087],
              [103.88593754100009, 18.28699859600009],
              [103.88950321500005, 18.291158550000105],
              [103.8936890060001, 18.297256368000077],
              [103.91001875800004, 18.315317281000077],
              [103.92929406800005, 18.327590434000015],
              [103.95125655200013, 18.332990622000082],
              [103.97544112200006, 18.33066518200006],
              [104.00003910300006, 18.318443705000035],
              [104.01864261900005, 18.29911672000007],
              [104.06840702300013, 18.215400900000034],
              [104.11093672700008, 18.114554342000034],
              [104.1223572190001, 18.09527903200008],
              [104.13568973800005, 18.079672750000057],
              [104.19811486900011, 18.025567525000056],
              [104.2033288720001, 18.018643666000045],
              [104.21087894700008, 18.008617656000055],
              [104.2551139740001, 17.91497996],
              [104.26431237800006, 17.884645895000048],
              [104.27030684400012, 17.874000550000076],
              [104.27826501500004, 17.86464711600003],
              [104.28198161000012, 17.86148801000003],
              [104.2875667720001, 17.85674062100007],
              [104.35262740100006, 17.81932688500011],
              [104.36776859600008, 17.800568340000027],
              [104.3902995200001, 17.757160137000128],
              [104.40487227400007, 17.739951884000035],
              [104.40890303600008, 17.73369903600006],
              [104.41164188700003, 17.727394511000043],
              [104.41784305900006, 17.707602438000052],
              [104.42228723200009, 17.69979929600005],
              [104.45200118000008, 17.66595123300003],
              [104.48119836500013, 17.6404230750001],
              [104.63638269100005, 17.562443339000097],
              [104.65508955900003, 17.55608713800008],
              [104.70263187700004, 17.527303365000066],
              [104.71451745700011, 17.515262756000098],
              [104.73425785400008, 17.486892395],
              [104.74965743100006, 17.458160299000085],
              [104.7567887780001, 17.449943746000045],
              [104.76464359600004, 17.44441436800004],
              [104.78164514200006, 17.43526763900006],
              [104.78893151900013, 17.42896311500006],
              [104.79270389800013, 17.42348541300005],
              [104.8164233810001, 17.37279083300008],
              [104.8193172610001, 17.3610602830001],
              [104.81998905500006, 17.348916321],
              [104.8164233810001, 17.30008209300003],
              [104.8183354090001, 17.24024078400008],
              [104.81445967600007, 17.194042053000103],
              [104.8099121510001, 17.171666158000036],
              [104.74531661000009, 17.02480173800005],
              [104.74035567200013, 17.00258087200008],
              [104.74634039700004, 16.943531594000106],
              [104.74965743100006, 16.910803528000073],
              [104.75301639800006, 16.899848125000076],
              [104.76288659700003, 16.879074198000055],
              [104.7664005950001, 16.868170472000074],
              [104.76707238800009, 16.856129862],
              [104.7652120360001, 16.844657695000095],
              [104.75844242400012, 16.8219200650001],
              [104.75791005200006, 16.81889463600008],
              [104.75632369000004, 16.80987945500003],
              [104.7567887780001, 16.798458964000034],
              [104.77833785000013, 16.71582834900009],
              [104.77900964400004, 16.704872945000105],
              [104.77756270400005, 16.694020894000047],
              [104.76371342000004, 16.65676218700004],
              [104.75301639800006, 16.61480092400005],
              [104.7484171960001, 16.57190948500009],
              [104.74950240100003, 16.549326884000052],
              [104.7545150150001, 16.528914693],
              [104.76516036000004, 16.51134470600003],
              [104.78273034700004, 16.497082012000064],
              [104.83885095300008, 16.467729797000075],
              [104.85549076300009, 16.454087220000062],
              [104.86892663600008, 16.43842926000012],
              [104.87946862800004, 16.421841126000103],
              [104.88773685700005, 16.403909404000032],
              [104.8970386150001, 16.372748515000055],
              [104.90158614100005, 16.362464905000067],
              [104.9080456960001, 16.353369853000103],
              [104.9172957770001, 16.345566712000092],
              [104.94406416900006, 16.33083892800009],
              [104.95207401600004, 16.324431051000133],
              [104.97150435400005, 16.30432891900007],
              [104.97930749500006, 16.298644511000035],
              [104.98802829000005, 16.293963496000075],
              [105.00741947400007, 16.28355499200005],
              [105.0154809980001, 16.27673370400008],
              [105.02638472500013, 16.257665100000096],
              [105.02974369300006, 16.236012675000026],
              [105.0288651940001, 16.191467590000016],
              [105.03258589700005, 16.165267639000078],
              [105.04245609600008, 16.141444804000017],
              [105.05811405500003, 16.121187643000027],
              [105.0793013920001, 16.105426331000032],
              [105.10697900800011, 16.095853281000032],
              [105.23722456900003, 16.050804341000102],
              [105.24740482700008, 16.04915069600004],
              [105.28853926700009, 16.04739369800008],
              [105.40491459200007, 16.018816630000103],
              [105.41447473200009, 16.015199280000033],
              [105.42207116700007, 16.009876608000084],
              [105.42323184100007, 16.005040467000057],
              [105.42393151900006, 16.00212514300007],
              [105.4181437580001, 15.994735412000054],
              [105.40739506000006, 15.98889597600008],
              [105.38651778200011, 15.980782776000055],
              [105.36248824000006, 15.954789531000088],
              [105.36062788900006, 15.919391175000086],
              [105.37256514500007, 15.882132467000062],
              [105.41204593900011, 15.79976023400009],
              [105.42300134300012, 15.78389556900008],
              [105.43566206900005, 15.771648255000045],
              [105.44796106000007, 15.764878642],
              [105.46237878500011, 15.762811585000051],
              [105.50340987200013, 15.766170552000048],
              [105.52542403200005, 15.763483378000032],
              [105.56852217700003, 15.749375712000088],
              [105.6129122320001, 15.7214704390001],
              [105.64092085800013, 15.681989645000087],
              [105.65099776200003, 15.634602356000116],
              [105.64086918200007, 15.583313497000077],
              [105.61627119900004, 15.521275940000024],
              [105.61203373200004, 15.499468486000083],
              [105.61038008700012, 15.457171326],
              [105.60428226700003, 15.439213766000123],
              [105.59224347300005, 15.427546297000106],
              [105.58836592600005, 15.423788350000038],
              [105.5528125410001, 15.402032573000028],
              [105.50620039900008, 15.387589009000095],
              [105.48625329700008, 15.37490244600005],
              [105.47746830200009, 15.352810771000051],
              [105.4833077400001, 15.334517314000067],
              [105.49901737500005, 15.32467295300009],
              [105.5193778900001, 15.32105560300002],
              [105.53854984600008, 15.321520691000046],
              [105.55803186100007, 15.32513804100003],
              [105.56149418200005, 15.320900574000078],
              [105.56480147400003, 15.299454854000132],
              [105.56397465000009, 15.27253143300004],
              [105.56025394700009, 15.27092946400009],
              [105.53157352800008, 15.25289438900009],
              [105.50392663600007, 15.231061096000062],
              [105.46310225400009, 15.189435730000056],
              [105.45442061400013, 15.17553477000007],
              [105.4477026780001, 15.155303446000076],
              [105.44377526900013, 15.133806050000132],
              [105.44362024000003, 15.111352641000039],
              [105.45194014500004, 15.094764506000033],
              [105.47385095200013, 15.090630391000104],
              [105.49829390500008, 15.066135763000148],
              [105.50356490100006, 15.064895528000108],
              [105.51653568600011, 15.067143453000114],
              [105.52087650600009, 15.066135763000148],
              [105.5231502690001, 15.061174825000094],
              [105.52284021000003, 15.050038554000082],
              [105.52428715000013, 15.04595611600007],
              [105.55353601100006, 15.005338440000031],
              [105.5661450610001, 14.995933329000081],
              [105.56635176600003, 14.995933329000081],
              [105.56645511900007, 14.995933329000081],
              [105.59306848200004, 14.990791525000077],
              [105.58356001800013, 14.977588196000085],
              [105.54392419400006, 14.953093567000039],
              [105.53415734900011, 14.93402496400006],
              [105.55064213100007, 14.90229563400004],
              [105.5430456950001, 14.880100607000102],
              [105.53761967000003, 14.878033549000051],
              [105.52191003400009, 14.87870534300012],
              [105.51777592000013, 14.877671814000053],
              [105.51586389200003, 14.87167734800002],
              [105.51694909700012, 14.856536153],
              [105.52408044500004, 14.842531840000092],
              [105.52439050300006, 14.837235006000057],
              [105.52004968300008, 14.833462626000127],
              [105.50620039900008, 14.830413717000098],
              [105.50154952000003, 14.82733897000007],
              [105.49384973100007, 14.808993836000084],
              [105.48914717600007, 14.786333720000115],
              [105.49069746900011, 14.763802796000107],
              [105.50154952000003, 14.74594858900005],
              [105.5051151940001, 14.736362610000057],
              [105.49736372900003, 14.69042226200007],
              [105.49576175900006, 14.659881490000075],
              [105.51012780800005, 14.593580627000051],
              [105.50754398600009, 14.56404754700013],
              [105.49545170100009, 14.53712412500002],
              [105.46367069500013, 14.495963847000041],
              [105.44036462500003, 14.475344950000121],
              [105.43385339400004, 14.467929383000111],
              [105.42889245600003, 14.45816253600006],
              [105.42031416900005, 14.435218201000026],
              [105.41597334800008, 14.428164368000111],
              [105.40568973800009, 14.423048401000116],
              [105.3792314050001, 14.418242493000022],
              [105.36765588400004, 14.414547628000022],
              [105.35964603700006, 14.408268942000106],
              [105.3408358160001, 14.390104675000075],
              [105.33509973200012, 14.385712178000077],
              [105.32223230000011, 14.386383972000061],
              [105.30466231300005, 14.398192037000072],
              [105.29474043800013, 14.399070536000096],
              [105.28771244300003, 14.39328277600012],
              [105.27572351100008, 14.372095439000077],
              [105.26859216300005, 14.364369812000078],
              [105.25045373600011, 14.35718678800012],
              [105.19820886300005, 14.345223694000069],
              [105.18430790300005, 14.345740458000108],
              [105.15500736500007, 14.330470073000072],
              [105.13221805800009, 14.280705668000053],
              [105.10141890500012, 14.230527852000108],
              [105.04731368100005, 14.214068909000048],
              [105.02535119700008, 14.224378358000138],
              [105.00772953300009, 14.243834534000115],
              [104.97594852700013, 14.301117859000087],
              [104.9742948820001, 14.309644470000109],
              [104.97899743700009, 14.354964701000114],
              [104.97873905400007, 14.368503927000091],
              [104.97382979400004, 14.380647888000098],
              [104.95512292500007, 14.386280619000033],
              [104.91562096700005, 14.39321676200008],
              [104.89817549700012, 14.396280009000051],
              [104.89021732600003, 14.40023325600012],
              [104.8742493090001, 14.41056854200012],
              [104.86654952000004, 14.413772481000095],
              [104.85735111500003, 14.414134217000097],
              [104.83848921800006, 14.411447042000063],
              [104.83140954700008, 14.411757101000148],
              [104.81507979400004, 14.419844462000057],
              [104.80185062700014, 14.430076396000032],
              [104.78825972500005, 14.438215434000128],
              [104.77167159000004, 14.439869080000094],
              [104.75792566000007, 14.433047791000135],
              [104.72795332900006, 14.409948426000057],
              [104.71286381000004, 14.406847839000108],
              [104.70619755100006, 14.41224802700009],
              [104.70102990800012, 14.430076396000032],
              [104.69286503100011, 14.433977966000086],
              [104.68464847900009, 14.430567322000059],
              [104.67472660400011, 14.414650981000136],
              [104.66837040200005, 14.40963836700007],
              [104.65136885600003, 14.408914897000074],
              [104.62656416900012, 14.419276021000087],
              [104.61044112100012, 14.418965963000105],
              [104.59462813300013, 14.410000102000069],
              [104.58346602400007, 14.39581492100011],
              [104.57385420800006, 14.380544536000073],
              [104.56279545100006, 14.368478089000092],
              [104.54284834800006, 14.360390727000095],
              [104.52651859600013, 14.363542989000052],
              [104.51080896100007, 14.370545145000051],
              [104.49261885600004, 14.374007467000098],
              [104.48197351100004, 14.37121694000004],
              [104.47391198800011, 14.36568756100013],
              [104.4675041100001, 14.360080668000109],
              [104.4619747320001, 14.357109273000106],
              [104.45850831800004, 14.357042243000066],
              [104.45262129700006, 14.356928406000051],
              [104.44600671400013, 14.358685404000127],
              [104.43918542500006, 14.361424255000074],
              [104.32539392100006, 14.377624817000083],
              [104.27123702000006, 14.399070536000096],
              [104.24746586100008, 14.40108591700006],
              [104.23237634300011, 14.393127747000094],
              [104.21914717700008, 14.382869975000105],
              [104.20126713100007, 14.377986552000081],
              [104.18917484600007, 14.38230153400005],
              [104.18349043800004, 14.391422425000115],
              [104.18256026200004, 14.400362448000052],
              [104.18566084800011, 14.403979798000137],
              [104.17703088400009, 14.404212342000093],
              [104.17480879700008, 14.401344299000115],
              [104.17325850500004, 14.396021627000081],
              [104.14845381700007, 14.3696149700001],
              [104.14090905800003, 14.365997620000115],
              [104.12835168500004, 14.366359355000029],
              [104.12127201400011, 14.371475321000105],
              [104.11615604700012, 14.377469788000042],
              [104.11021325700011, 14.380441183000045],
              [104.0737296960001, 14.370751852000112],
              [104.04572418600009, 14.357285453000117],
              [104.0450640150001, 14.356968011000049],
              [104.03595422400014, 14.35258758500008],
              [104.00138269100006, 14.345068665000042],
              [103.97399418100008, 14.367289530000065],
              [103.91983728100007, 14.36457651800012],
              [103.91053552300014, 14.356256612000067],
              [103.90800337700006, 14.348324280000028],
              [103.90278405800007, 14.34243316700011],
              [103.88516239400008, 14.340417786000074],
              [103.87033125800014, 14.343259990000135],
              [103.85916914900008, 14.349616191000067],
              [103.8492472740001, 14.357083436000096],
              [103.83844690000006, 14.36338796000011],
              [103.82402917500013, 14.368038839000079],
              [103.81550256400004, 14.36796132400005],
              [103.80728601100009, 14.365997620000115],
              [103.79421187400004, 14.364834900000105],
              [103.7752466230001, 14.366979472000082],
              [103.71654219600003, 14.381526387000036],
              [103.68222904400011, 14.38380015100006],
              [103.67489099100004, 14.38648732500009],
              [103.67168705300008, 14.39560821600007],
              [103.67385746300005, 14.419327698000103],
              [103.67148034700011, 14.429559631000089],
              [103.66538252800007, 14.435941671000123],
              [103.65716597500011, 14.441160991000046],
              [103.64719242300009, 14.443977356000104],
              [103.63706384300013, 14.443279724000107],
              [103.62745202700006, 14.437802023000117],
              [103.62445479400003, 14.430567322000059],
              [103.62290450000012, 14.42247996000006],
              [103.61680668100013, 14.414547628000022],
              [103.59613610900004, 14.404341533000135],
              [103.58161503200006, 14.407416280000078],
              [103.56812748200014, 14.41594289200009],
              [103.55024743700005, 14.421859844000096],
              [103.53340092000008, 14.419069316000048],
              [103.4948503010001, 14.399949036000052],
              [103.45702315300014, 14.374420878000109],
              [103.44968510000012, 14.371578674000133],
              [103.4392464600001, 14.372870585000086],
              [103.43149499600008, 14.377521464000054],
              [103.42622399900006, 14.382508240000107],
              [103.42250329600006, 14.384833679000039],
              [103.40808557200012, 14.380802918000128],
              [103.38023197500007, 14.361062520000075],
              [103.36286869400004, 14.353466085000022],
              [103.34137129800013, 14.350908101000115],
              [103.27367517100004, 14.35106313100006],
              [103.24327762700005, 14.341931315000068],
              [103.1985893150001, 14.32850636800012],
              [103.13823124200013, 14.319747213000056],
              [103.11802575700011, 14.31323598200008],
              [103.08500451700007, 14.295821025000052],
              [103.01692961100008, 14.238872481000072],
              [103.00485437100008, 14.228770854000032],
              [102.98780114800013, 14.219004008000084],
              [102.95090417500012, 14.20864288400007],
              [102.93405765800003, 14.200968934000073],
              [102.91860640500005, 14.185491842000076],
              [102.9140072020001, 14.16934295600008],
              [102.91392961400004, 14.164946285000013],
              [102.91369714400008, 14.15177297000011],
              [102.91126835200004, 14.132110088000076],
              [102.90408532700008, 14.115987040000093],
              [102.88325972500013, 14.086944885],
              [102.87623173100013, 14.071312765000059],
              [102.8728727620001, 14.048368429000021],
              [102.87333785000004, 14.033408102000053],
              [102.86977217700007, 14.020618185000075],
              [102.85499271600008, 14.00400421200007],
              [102.7974251710001, 13.960001729000098],
              [102.77282718900005, 13.936075541],
              [102.75437870400003, 13.904113668000022],
              [102.73717045100005, 13.84959503200011],
              [102.72910892800007, 13.832154236000065],
              [102.7112805590001, 13.810398458000066],
              [102.70647465000008, 13.80194936100007],
              [102.70399418100004, 13.791769104000096],
              [102.70265059400009, 13.771201884000106],
              [102.69861983300007, 13.76179677400006],
              [102.67495202700013, 13.741901347000052],
              [102.57438969000003, 13.693893941000098],
              [102.54235030100011, 13.669709371000039],
              [102.54105839100004, 13.648599549000096],
              [102.56250411000008, 13.628032329000106],
              [102.59774743700007, 13.605449728000067],
              [102.57955733300014, 13.600488790000028],
              [102.53253177900012, 13.573823751000077],
              [102.5132047940001, 13.567157491000074],
              [102.45222660300004, 13.56217071600011],
              [102.37130131000004, 13.568914490000054],
              [102.33223392800011, 13.564599508000072],
              [102.3134237060001, 13.541009217000067],
              [102.31476729300005, 13.530338033000064],
              [102.32551599100009, 13.513439840000075],
              [102.32939172400006, 13.504344788000097],
              [102.33011519400003, 13.496360779000042],
              [102.32952834600007, 13.484602854000087],
              [102.32939172400006, 13.481865540000086],
              [102.3336291920001, 13.406262919000056],
              [102.32706628500011, 13.34543975900003],
              [102.32820316600004, 13.275159811000037],
              [102.32918681200005, 13.272628953000066],
              [102.38205000800014, 13.136615295000084],
              [102.40189375900013, 13.10299977700005],
              [102.44726566600008, 13.05080658000007],
              [102.4631820080001, 13.01928395600001],
              [102.47315555800003, 13.006132304000033],
              [102.49015710500004, 12.996081238000102],
              [102.49009677200013, 12.995187554000054],
              [102.48974369400003, 12.989957581000041],
              [102.48664310700008, 12.98478993700013],
              [102.48137211200003, 12.980552470000077],
              [102.47408573400008, 12.976960958000106],
              [102.46881473900004, 12.973395284000048],
              [102.46721276900007, 12.969467876000067],
              [102.46907312000008, 12.96523040800011],
              [102.4775997320001, 12.957298075000068],
              [102.47889164300005, 12.953629049000071],
              [102.4775997320001, 12.949934184000071],
              [102.46628259300013, 12.937919414000092],
              [102.46483565300014, 12.927532451000076],
              [102.4678845630001, 12.916344503000047],
              [102.47408573400008, 12.905259908000033],
              [102.47920170100014, 12.882108867000042],
              [102.48333581500009, 12.843790792000036],
              [102.48974369400003, 12.823094381000104],
              [102.49553145300007, 12.812681580000074],
              [102.50049239100014, 12.806506246000097],
              [102.50431644800005, 12.799736633000052],
              [102.50664188700011, 12.78751515700013],
              [102.50555668200013, 12.777774150000084],
              [102.49527307200003, 12.746096497000082],
              [102.49519613400014, 12.746029849000067],
              [102.4827156990001, 12.735218608000125],
              [102.47796146700011, 12.719638164000088],
              [102.47666955600005, 12.698450826000041],
              [102.47925337700008, 12.677108460000042],
              [102.48638472500011, 12.661192119000106],
              [102.4958771100001, 12.65415246400002],
              [102.50178430200009, 12.649771627000106],
              [102.55862837700005, 12.631219788000067],
              [102.58854903100007, 12.609825745000052],
              [102.66482344600007, 12.534223124000022],
              [102.68973148600003, 12.519702047000067],
              [102.69675948100007, 12.513087464000066],
              [102.70048018400007, 12.50487091100004],
              [102.70213383000004, 12.488127747000092],
              [102.70482100500004, 12.480324606000067],
              [102.71841190600003, 12.465906880000148],
              [102.7506063240001, 12.449008688000063],
              [102.76207849100012, 12.436089579000054],
              [102.76375089600003, 12.42526146900012],
              [102.76512740100003, 12.41634918200009],
              [102.75649743700006, 12.40224151700005],
              [102.73065922000006, 12.380072327000036],
              [102.72006555200011, 12.36121042900001],
              [102.71505293800004, 12.342193502000043],
              [102.69221195500012, 12.178482564000149],
              [102.69996342000013, 12.138743388000066],
              [102.75122644000004, 12.06097035800012],
              [102.76501241200003, 12.044563616000119],
              [102.77107019100004, 12.037354228000112],
              [102.78714156100011, 12.00262766600008],
              [102.79711511200003, 11.952966614000076],
              [102.84300378500012, 11.866046855000064],
              [102.88517175300007, 11.807704163000025],
              [102.91380049600014, 11.765536194000063],
              [102.9251176350001, 11.725797018000065],
              [102.9287866620001, 11.668694560000048],
              [102.91358483200003, 11.645900783000059],
            ],
          ],
          [
            [
              [97.87183678500003, 9.379584052000041],
              [97.84001712300005, 9.40428294500009],
              [97.83529707100007, 9.412054755000042],
              [97.83773847700007, 9.419338283000059],
              [97.84359785200007, 9.424953518000052],
              [97.85084069100003, 9.42837148600006],
              [97.85726972700007, 9.42869700700004],
              [97.86841881600003, 9.420396226000037],
              [97.87468509200005, 9.40570709800005],
              [97.87614993600005, 9.390204169000071],
              [97.87183678500003, 9.379584052000041],
            ],
          ],
          [
            [
              [99.69874108200003, 9.542222398000092],
              [99.70346113400007, 9.521307684000078],
              [99.68148847700007, 9.512884833000044],
              [99.66814212300005, 9.519191799000055],
              [99.69874108200003, 9.542222398000092],
            ],
          ],
          [
            [
              [99.68425540500004, 9.620021877000056],
              [99.68043053500003, 9.612209377000056],
              [99.67807050900007, 9.61041901200008],
              [99.67676842500003, 9.614569403000075],
              [99.67530358200003, 9.62445709800005],
              [99.67823326900003, 9.62409088700008],
              [99.68018639400003, 9.622544664000088],
              [99.68181399800005, 9.620835679000038],
              [99.68425540500004, 9.620021877000056],
            ],
          ],
          [
            [
              [99.24781334700003, 6.57485586100006],
              [99.26026451900003, 6.565822658000059],
              [99.25757897200003, 6.560939846000053],
              [99.24732506600003, 6.557033596000053],
              [99.21729576900003, 6.536932684000078],
              [99.19483483200003, 6.533107815000051],
              [99.17400149800005, 6.539007880000042],
              [99.15845787900008, 6.554388739000046],
              [99.17644290500004, 6.550197658000059],
              [99.18604576900003, 6.559393622000073],
              [99.19556725400008, 6.571234442000048],
              [99.21371504000007, 6.57485586100006],
              [99.20630944100003, 6.57485586100006],
              [99.23926842500003, 6.57680898600006],
              [99.24781334700003, 6.57485586100006],
            ],
          ],
          [
            [
              [99.67237389400003, 6.516546942000048],
              [99.67212975400008, 6.507310289000088],
              [99.67042076900003, 6.501450914000088],
              [99.66627037900008, 6.497015692000048],
              [99.65870201900003, 6.492336330000057],
              [99.64682050900007, 6.509670315000051],
              [99.63414807500004, 6.552054746000067],
              [99.60027103000004, 6.58344147300005],
              [99.60303795700003, 6.596991278000075],
              [99.61394290500004, 6.60883209800005],
              [99.62387129000007, 6.622707424000055],
              [99.62598717500003, 6.632798570000091],
              [99.62354576900003, 6.651068427000041],
              [99.62387129000007, 6.657416083000044],
              [99.62924238400007, 6.663641669000071],
              [99.63640384200005, 6.666896877000056],
              [99.64242597700007, 6.67133209800005],
              [99.64503014400003, 6.681057033000059],
              [99.64649498800003, 6.699367580000057],
              [99.65064537900008, 6.717759507000039],
              [99.65699303500003, 6.723822333000044],
              [99.68051191500007, 6.672919012000079],
              [99.68028986000007, 6.62403914500004],
              [99.69604397700004, 6.587452689000088],
              [99.70443769600007, 6.558294989000046],
              [99.70329837300005, 6.54437897300005],
              [99.69971764400003, 6.533270575000074],
              [99.69263756600003, 6.528143622000073],
              [99.68360436300003, 6.526841539000088],
              [99.67579186300003, 6.524562893000052],
              [99.67237389400003, 6.516546942000048],
            ],
          ],
          [
            [
              [99.40544681100005, 7.266302802000041],
              [99.41911868600005, 7.25657786700009],
              [99.44581139400003, 7.250921942000048],
              [99.45386803500003, 7.23899974200009],
              [99.44060306100005, 7.240220445000091],
              [99.42823326900003, 7.23899974200009],
              [99.41724694100003, 7.235337632000039],
              [99.40886478000004, 7.229396877000056],
              [99.39429772200003, 7.205471096000053],
              [99.38331139400003, 7.19407786700009],
              [99.37818444100003, 7.20180898600006],
              [99.37777754000007, 7.252346096000053],
              [99.38550866000003, 7.275580145000049],
              [99.40544681100005, 7.266302802000041],
            ],
          ],
          [
            [
              [99.03492272200003, 7.644273179000038],
              [99.06568444100003, 7.615057684000078],
              [99.07585696700005, 7.608954169000071],
              [99.07593834700003, 7.573228257000039],
              [99.08611087300005, 7.536525783000059],
              [99.10141035200007, 7.503566799000055],
              [99.11744225400008, 7.479193427000041],
              [99.09994550900007, 7.467230536000045],
              [99.07715905000003, 7.480292059000078],
              [99.05713951900003, 7.504055080000057],
              [99.03126061300003, 7.561916408000059],
              [99.02808678500003, 7.57172272300005],
              [99.02906334700003, 7.60618724200009],
              [99.02711022200003, 7.622870184000078],
              [99.02068118600005, 7.636867580000057],
              [99.02320397200003, 7.639105536000045],
              [99.02442467500003, 7.639837958000044],
              [99.02564537900008, 7.64093659100007],
              [99.02808678500003, 7.644273179000038],
              [99.03492272200003, 7.644273179000038],
            ],
          ],
          [
            [
              [99.12427819100003, 7.657375393000052],
              [99.12745201900003, 7.644354559000078],
              [99.12745201900003, 7.625189520000049],
              [99.12403405000003, 7.606838283000059],
              [99.11744225400008, 7.595892645000049],
              [99.10873457100007, 7.594183661000045],
              [99.09986412900008, 7.596625067000048],
              [99.09302819100003, 7.601263739000046],
              [99.09017988400007, 7.605861721000053],
              [99.08765709700003, 7.61204661700009],
              [99.08187910200007, 7.616034247000073],
              [99.07520592500003, 7.619126695000091],
              [99.06959069100003, 7.622544664000088],
              [99.04460696700005, 7.663397528000075],
              [99.06706790500004, 7.675197658000059],
              [99.10450280000003, 7.66937897300005],
              [99.12427819100003, 7.657375393000052],
            ],
          ],
          [
            [
              [98.54053795700003, 8.10492584800005],
              [98.54037519600007, 8.105617580000057],
              [98.58692467500003, 8.079291083000044],
              [98.60238691500007, 8.06346263200004],
              [98.61036217500003, 8.034735419000071],
              [98.61182701900003, 7.92609284100007],
              [98.60352623800003, 7.90375397300005],
              [98.58822675900007, 7.90493398600006],
              [98.57732181100005, 7.919623114000046],
              [98.57081139400003, 7.939357815000051],
              [98.56755618600005, 7.963364976000037],
              [98.56283613400007, 7.978094794000071],
              [98.56324303500003, 7.986314195000091],
              [98.56804446700005, 7.993353583000044],
              [98.57455488400007, 7.994126695000091],
              [98.58041425900007, 7.996161200000074],
              [98.58301842500003, 8.006781317000048],
              [98.58228600400008, 8.015366929000038],
              [98.57960045700003, 8.024562893000052],
              [98.57439212300005, 8.031805731000077],
              [98.56592858200003, 8.034735419000071],
              [98.55486087300005, 8.036932684000078],
              [98.55111738400007, 8.042547919000071],
              [98.54981530000003, 8.050116278000075],
              [98.53687584700003, 8.071193752000056],
              [98.53101647200003, 8.088568427000041],
              [98.52816816500007, 8.107082424000055],
              [98.52849368600005, 8.123480536000045],
              [98.53296959700003, 8.11945221600007],
              [98.53630618600005, 8.11513906500005],
              [98.54053795700003, 8.10492584800005],
            ],
          ],
          [
            [
              [98.41863040500004, 7.90375397300005],
              [98.42188561300003, 7.908433335000041],
              [98.42798912900008, 7.913234768000052],
              [98.43165123800003, 7.91742584800005],
              [98.43962649800005, 7.901922919000071],
              [98.43978925900007, 7.886623440000051],
              [98.43181399800005, 7.874945380000042],
              [98.39966881600003, 7.864569403000075],
              [98.39535566500007, 7.850490627000056],
              [98.39812259200005, 7.815008856000077],
              [98.36231530000003, 7.832424221000053],
              [98.34392337300005, 7.832912502000056],
              [98.33611087300005, 7.81126536700009],
              [98.33253014400003, 7.785956122000073],
              [98.32309004000007, 7.77094147300005],
              [98.30909264400003, 7.767726955000057],
              [98.29184004000007, 7.777492580000057],
              [98.28663170700003, 7.791693427000041],
              [98.28142337300005, 7.855943101000037],
              [98.27767988400007, 7.863430080000057],
              [98.27295983200003, 7.870672919000071],
              [98.26905358200003, 7.879136460000041],
              [98.26775149800005, 7.89008209800005],
              [98.27198326900003, 7.893459377000056],
              [98.28003991000003, 7.896918036000045],
              [98.28532962300005, 7.90375397300005],
              [98.28142337300005, 7.91742584800005],
              [98.27572675900007, 7.921047268000052],
              [98.25798587300005, 7.92641836100006],
              [98.25416100400008, 7.928290106000077],
              [98.25863691500007, 7.938299872000073],
              [98.26758873800003, 7.946275132000039],
              [98.27409915500004, 7.953680731000077],
              [98.27149498800003, 7.962103583000044],
              [98.26596113400007, 7.973781643000052],
              [98.27003014400003, 7.983954169000071],
              [98.27759850400008, 7.993557033000059],
              [98.28142337300005, 8.003078518000052],
              [98.28044681100005, 8.014227606000077],
              [98.27613366000003, 8.03384023600006],
              [98.27442467500003, 8.06932200700004],
              [98.27515709700003, 8.075669664000088],
              [98.27759850400008, 8.083156643000052],
              [98.28532962300005, 8.098863023000092],
              [98.28825931100005, 8.109198309000078],
              [98.29021243600005, 8.130113023000092],
              [98.28891035200007, 8.15180084800005],
              [98.28142337300005, 8.191799221000053],
              [98.28598066500007, 8.191148179000038],
              [98.28907311300003, 8.18968333500004],
              [98.29566491000003, 8.184963283000059],
              [98.30290774800005, 8.188055731000077],
              [98.31153405000003, 8.18553294500009],
              [98.32081139400003, 8.179103908000059],
              [98.33008873800003, 8.170477606000077],
              [98.33570397200003, 8.156439520000049],
              [98.34351647200003, 8.109198309000078],
              [98.34961998800003, 8.109198309000078],
              [98.36011803500003, 8.118841864000046],
              [98.37370853000004, 8.110907294000071],
              [98.38917076900003, 8.095445054000038],
              [98.40552819100003, 8.082505601000037],
              [98.41285241000003, 8.094305731000077],
              [98.42261803500003, 8.099310614000046],
              [98.43213951900003, 8.09593333500004],
              [98.43913821700005, 8.082505601000037],
              [98.43848717500003, 8.065741278000075],
              [98.43189537900008, 8.04979075700004],
              [98.41863040500004, 8.027289130000042],
              [98.41773522200003, 8.019110419000071],
              [98.41993248800003, 8.00104401200008],
              [98.41863040500004, 7.993150132000039],
              [98.41431725400008, 7.98891836100006],
              [98.40821373800003, 7.985663153000075],
              [98.40219160200007, 7.981024481000077],
              [98.39812259200005, 7.972642320000091],
              [98.39747155000003, 7.955023505000042],
              [98.40154056100005, 7.935777085000041],
              [98.40894616000003, 7.917710679000038],
              [98.41863040500004, 7.90375397300005],
            ],
          ],
          [
            [
              [98.63754316500007, 8.171291408000059],
              [98.62142988400007, 8.10252513200004],
              [98.62086022200003, 8.089992580000057],
              [98.58765709700003, 8.101752020000049],
              [98.57960045700003, 8.106146552000041],
              [98.57007897200003, 8.118882554000038],
              [98.57471764400003, 8.12498607000009],
              [98.59669030000003, 8.13031647300005],
              [98.59229576900003, 8.14679596600007],
              [98.60181725400008, 8.16156647300005],
              [98.61589603000004, 8.176174221000053],
              [98.62403405000003, 8.191799221000053],
              [98.63209069100003, 8.18976471600007],
              [98.63575280000003, 8.18553294500009],
              [98.63705488400007, 8.179348049000055],
              [98.63754316500007, 8.171291408000059],
            ],
          ],
          [
            [
              [98.29566491000003, 9.14516836100006],
              [98.30787194100003, 9.133002020000049],
              [98.31739342500003, 9.117132880000042],
              [98.32276451900003, 9.09796784100007],
              [98.32300866000003, 9.076239325000074],
              [98.30201256600003, 9.055161851000037],
              [98.30933678500003, 9.048976955000057],
              [98.29444420700003, 9.041571356000077],
              [98.27418053500003, 9.035956122000073],
              [98.25424238400007, 9.036810614000046],
              [98.24048912900008, 9.048976955000057],
              [98.24000084700003, 9.062689520000049],
              [98.24838300900007, 9.143377997000073],
              [98.24822024800005, 9.150091864000046],
              [98.25082441500007, 9.154038804000038],
              [98.26091556100005, 9.158148505000042],
              [98.27328535200007, 9.159979559000078],
              [98.28223717500003, 9.156724351000037],
              [98.29566491000003, 9.14516836100006],
            ],
          ],
          [
            [
              [100.07016035200007, 9.586411851000037],
              [100.07585696700005, 9.58502838700008],
              [100.08594811300003, 9.57453034100007],
              [100.09066816500007, 9.560939846000053],
              [100.08008873800003, 9.549994208000044],
              [100.07178795700003, 9.521673895000049],
              [100.06861412900008, 9.489813544000071],
              [100.06088300900007, 9.463812567000048],
              [100.03199303500003, 9.45018138200004],
              [100.02963300900007, 9.443548895000049],
              [100.02881920700003, 9.435695705000057],
              [100.02588951900003, 9.42914459800005],
              [100.01929772200003, 9.425726630000042],
              [100.01156660200007, 9.425482489000046],
              [100.00359134200005, 9.426214911000045],
              [99.95630944100003, 9.421616929000038],
              [99.94662519600007, 9.41819896000004],
              [99.94076582100007, 9.43748607000009],
              [99.93669681100005, 9.474554755000042],
              [99.92628014400003, 9.493963934000078],
              [99.94117272200003, 9.511867580000057],
              [99.93962649800005, 9.53025950700004],
              [99.93116295700003, 9.548570054000038],
              [99.92628014400003, 9.565985419000071],
              [99.93628991000003, 9.577704169000071],
              [99.95948326900003, 9.580755927000041],
              [99.98471113400007, 9.579006252000056],
              [100.04371178500003, 9.564154364000046],
              [100.06234785200007, 9.56736888200004],
              [100.07016035200007, 9.586411851000037],
            ],
          ],
          [
            [
              [98.41163170700003, 9.76829661700009],
              [98.41781660200007, 9.74705638200004],
              [98.41667728000004, 9.73346588700008],
              [98.39812259200005, 9.706244208000044],
              [98.38493899800005, 9.727932033000059],
              [98.38965905000003, 9.74241771000004],
              [98.40211022200003, 9.75584544500009],
              [98.41163170700003, 9.774562893000052],
              [98.41163170700003, 9.76829661700009],
            ],
          ],
          [
            [
              [100.03541100400008, 9.795599677000041],
              [100.06723066500007, 9.77562083500004],
              [100.07927493600005, 9.74241771000004],
              [100.09009850400008, 9.665269273000092],
              [100.07862389400003, 9.67381419500009],
              [100.05404707100007, 9.68773021000004],
              [99.99919681100005, 9.710353908000059],
              [99.98764082100007, 9.719916083000044],
              [99.99333743600005, 9.731675523000092],
              [99.98991946700005, 9.74290599200009],
              [99.97055097700007, 9.764593817000048],
              [99.97071373800003, 9.771226304000038],
              [99.98357181100005, 9.791937567000048],
              [99.98764082100007, 9.80182526200008],
              [99.99789472700007, 9.797267971000053],
              [100.00782311300003, 9.796372789000088],
              [100.02613366000003, 9.797756252000056],
              [100.03541100400008, 9.795599677000041],
            ],
          ],
          [
            [
              [102.56413821700005, 11.707953192000048],
              [102.58961022200003, 11.71002838700008],
              [102.60596764400003, 11.684515692000048],
              [102.60816491000003, 11.64834219000005],
              [102.59156334700003, 11.61859772300005],
              [102.59156334700003, 11.611761786000045],
              [102.60572350400008, 11.611761786000045],
              [102.59717858200003, 11.598537502000056],
              [102.59457441500007, 11.58885325700004],
              [102.59831790500004, 11.563381252000056],
              [102.59156334700003, 11.563381252000056],
              [102.58472741000003, 11.568833726000037],
              [102.57699629000007, 11.58502838700008],
              [102.57162519600007, 11.59125397300005],
              [102.56218509200005, 11.595648505000042],
              [102.53003991000003, 11.60492584800005],
              [102.53793379000007, 11.615790106000077],
              [102.54249108200003, 11.620672919000071],
              [102.54420006600003, 11.62604401200008],
              [102.54371178500003, 11.638495184000078],
              [102.54078209700003, 11.64789459800005],
              [102.53093509200005, 11.670355536000045],
              [102.53003991000003, 11.680080471000053],
              [102.54981530000003, 11.752346096000053],
              [102.55518639400003, 11.759833075000074],
              [102.56413821700005, 11.755113023000092],
              [102.56836998800003, 11.74404531500005],
              [102.57081139400003, 11.732814846000053],
              [102.56999759200005, 11.72093333500004],
              [102.56413821700005, 11.707953192000048],
            ],
          ],
          [
            [
              [102.39966881600003, 12.043158270000049],
              [102.40650475400008, 12.036322333000044],
              [102.41700280000003, 12.017767645000049],
              [102.43213951900003, 12.000392971000053],
              [102.44312584700003, 11.983710028000075],
              [102.44117272200003, 11.96743398600006],
              [102.42750084700003, 11.961371161000045],
              [102.41098066500007, 11.971502997000073],
              [102.37916100400008, 12.002834377000056],
              [102.37598717500003, 11.991156317000048],
              [102.37794030000003, 11.979641018000052],
              [102.37614993600005, 11.970892645000049],
              [102.36215254000007, 11.96743398600006],
              [102.34913170700003, 11.968898830000057],
              [102.31088300900007, 11.98110586100006],
              [102.31088300900007, 11.97483958500004],
              [102.31381269600007, 11.971380927000041],
              [102.31836998800003, 11.96116771000004],
              [102.31226647200003, 11.966131903000075],
              [102.30640709700003, 11.96979401200008],
              [102.29948978000004, 11.972479559000078],
              [102.29037519600007, 11.97483958500004],
              [102.29037519600007, 11.98110586100006],
              [102.29411868600005, 11.994696356000077],
              [102.29420006600003, 12.056789455000057],
              [102.28467858200003, 12.066839911000045],
              [102.25635826900003, 12.13190338700008],
              [102.27003014400003, 12.13190338700008],
              [102.26596113400007, 12.13890208500004],
              [102.26172936300003, 12.14443594000005],
              [102.25635826900003, 12.148993231000077],
              [102.24952233200003, 12.153021552000041],
              [102.26628665500004, 12.152411200000074],
              [102.29322350400008, 12.145412502000056],
              [102.31088300900007, 12.146185614000046],
              [102.34278405000003, 12.123602606000077],
              [102.35523522200003, 12.11131419500009],
              [102.36622155000003, 12.097805080000057],
              [102.37810306100005, 12.071844794000071],
              [102.38656660200007, 12.058335679000038],
              [102.39966881600003, 12.049302476000037],
              [102.39966881600003, 12.043158270000049],
            ],
          ],
          [
            [
              [97.86996504000007, 9.42523834800005],
              [97.84961998800003, 9.44212474200009],
              [97.85328209700003, 9.461371161000045],
              [97.87183678500003, 9.473049221000053],
              [97.89527428500003, 9.467352606000077],
              [97.89942467500003, 9.461127020000049],
              [97.90015709700003, 9.453070380000042],
              [97.89820397200003, 9.444973049000055],
              [97.89478600400008, 9.438706773000092],
              [97.88697350400008, 9.43821849200009],
              [97.87720787900008, 9.442084052000041],
              [97.86988366000003, 9.440741278000075],
              [97.86996504000007, 9.42523834800005],
            ],
          ],
          [
            [
              [98.28842207100007, 9.004461981000077],
              [98.29908287900008, 8.997381903000075],
              [98.31088300900007, 8.978176174000055],
              [98.30697675900007, 8.957912502000056],
              [98.29395592500003, 8.93463776200008],
              [98.27051842500003, 8.87718333500004],
              [98.26156660200007, 8.878566799000055],
              [98.25310306100005, 8.897853908000059],
              [98.25098717500003, 8.918443101000037],
              [98.25570722700007, 8.93976471600007],
              [98.25586998800003, 8.966376044000071],
              [98.25220787900008, 8.997015692000048],
              [98.26091556100005, 9.012925523000092],
              [98.27930748800003, 9.009344794000071],
              [98.28842207100007, 9.004461981000077],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Kuwait',
        iso3: 'KWT',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [47.948008660000085, 29.994045315000037],
              [47.955088738000086, 29.97728099200009],
              [47.965505405000044, 29.962062893000052],
              [47.975271030000044, 29.942572333000044],
              [47.97974694100009, 29.92145416900007],
              [47.979502800000034, 29.88434479400007],
              [47.98267662900008, 29.860663153000075],
              [47.99561608200008, 29.82770416900007],
              [48.02173912900008, 29.779730536000045],
              [48.05241946700005, 29.742987372000073],
              [48.078868035000085, 29.743963934000078],
              [48.096039259000065, 29.699164130000042],
              [48.119151238000086, 29.65452708500004],
              [48.16130618600005, 29.601629950000074],
              [48.18091701600008, 29.562217471000054],
              [48.17675811700008, 29.54191647600004],
              [48.15451758000006, 29.53908982200005],
              [48.11353600400008, 29.554632880000042],
              [48.092539910000085, 29.56582265800006],
              [48.085948113000086, 29.575018622000073],
              [48.06634915600006, 29.57755565900004],
              [48.04192309600006, 29.582093152000084],
              [48.02385917100008, 29.584808654000085],
              [47.96553061700007, 29.57629785900008],
              [47.935977422000065, 29.554025210000077],
              [47.910619962000055, 29.531789182000068],
              [47.84925759500004, 29.50197937300004],
              [47.807042773000035, 29.46762180400009],
              [47.78495163400004, 29.437049468000055],
              [47.763865174000045, 29.41293262800008],
              [47.718386922000036, 29.394194793000054],
              [47.71420602300009, 29.378471112000057],
              [47.70471693300004, 29.363632791000043],
              [47.726999007000074, 29.36192636000004],
              [47.76414804400008, 29.367698819000054],
              [47.79174359600006, 29.372480608000046],
              [47.813998662000074, 29.37999364800004],
              [47.83730433900007, 29.387504962000037],
              [47.851151713000036, 29.38019801100006],
              [47.82261235700008, 29.363430721000043],
              [47.82269505000005, 29.351433494000048],
              [47.81643437300005, 29.337556391000078],
              [47.84092637800006, 29.32293074100005],
              [47.85790286900004, 29.32302910100009],
              [47.876954380000086, 29.328671430000043],
              [47.899184937000086, 29.33524906100007],
              [47.905386845000066, 29.359262786000045],
              [47.92020215200006, 29.364872086000048],
              [47.939325902000064, 29.359433137000053],
              [47.95937407200006, 29.372436838000056],
              [47.96988341200006, 29.38723870700005],
              [47.98574004100004, 29.393761228000074],
              [47.99301191500007, 29.387925523000035],
              [48.00839277400007, 29.369167385000083],
              [48.010508660000085, 29.366522528000075],
              [48.02523847700007, 29.35488515800006],
              [48.03541100400008, 29.35179271000004],
              [48.063273722000076, 29.34336817500008],
              [48.100266359000045, 29.34995411300008],
              [48.09305302100006, 29.305678752000063],
              [48.09207328700006, 29.287232887000073],
              [48.09537629600004, 29.257745843000066],
              [48.10613070200009, 29.21352475900005],
              [48.11465851100007, 29.19325583300008],
              [48.12844677900006, 29.173900279000065],
              [48.13380381300004, 29.153617354000062],
              [48.15845787900008, 29.017279364000046],
              [48.17603600400008, 28.98379140800006],
              [48.22592207100007, 28.91828034100007],
              [48.240977410000085, 28.90566640800006],
              [48.27947024800005, 28.89443594000005],
              [48.28239993600005, 28.879380601000037],
              [48.27816816500007, 28.85968659100007],
              [48.27686608200008, 28.839585679000038],
              [48.285166863000086, 28.81989166900007],
              [48.312510613000086, 28.785956122000073],
              [48.318369988000086, 28.773830471000053],
              [48.328786655000044, 28.75995514500005],
              [48.352305535000085, 28.751206773000035],
              [48.393565300000034, 28.743394273000035],
              [48.383799675000034, 28.72801341400009],
              [48.379649285000085, 28.71035390800006],
              [48.38070722700007, 28.69208405200004],
              [48.386729363000086, 28.675116278000075],
              [48.37159264400009, 28.684393622000073],
              [48.366221550000034, 28.688706773000035],
              [48.36500084700003, 28.680812893000052],
              [48.365977410000085, 28.675726630000042],
              [48.37045332100007, 28.671942450000074],
              [48.379893425000034, 28.667669989000046],
              [48.37240644600007, 28.65916575700004],
              [48.36768639400009, 28.656724351000037],
              [48.36378014400009, 28.658148505000042],
              [48.35954837300005, 28.661444403000075],
              [48.35271243600005, 28.661444403000075],
              [48.35181725400008, 28.64052969000005],
              [48.36101321700005, 28.635565497000073],
              [48.37468509200005, 28.64166901200008],
              [48.386729363000086, 28.653998114000046],
              [48.38949629000007, 28.643744208000044],
              [48.393565300000034, 28.595648505000042],
              [48.397146030000044, 28.583319403000075],
              [48.405284050000034, 28.56989166900007],
              [48.420909050000034, 28.551581122000073],
              [48.43246504000007, 28.540716864000046],
              [48.432781227000135, 28.540479723000075],
              [48.255224650000116, 28.538879293],
              [48.077406046000135, 28.537277324000044],
              [47.89958744300009, 28.53562367800002],
              [47.72182051600009, 28.533970032000056],
              [47.668128703000036, 28.53350494400003],
              [47.65980879700004, 28.560040792000038],
              [47.64110192900006, 28.577249044000027],
              [47.618157593000035, 28.59148590100007],
              [47.596815227000036, 28.6088233440001],
              [47.58167403200014, 28.63148345900005],
              [47.56803145300012, 28.660990702000063],
              [47.5584196370001, 28.69147979800006],
              [47.55459558100006, 28.74537831700009],
              [47.54994470200012, 28.77059641600006],
              [47.49449589100004, 28.904024963],
              [47.44632323400009, 28.97624273900003],
              [47.43408614100014, 28.99458791100001],
              [47.433982788000094, 28.994613750000028],
              [47.43346602400004, 28.994717102000052],
              [47.43336267100011, 28.994717102000052],
              [47.37755212400009, 29.0012024950001],
              [47.27802331600009, 29.012700501000026],
              [47.17839115400005, 29.024224345000064],
              [47.078758992000076, 29.035748190000092],
              [46.97923018400013, 29.047220358000104],
              [46.86735070800006, 29.059415996000027],
              [46.75578129100012, 29.07153411900002],
              [46.644160197000076, 29.0836264040001],
              [46.53243575000005, 29.095744527000093],
              [46.56146814800013, 29.12416650900009],
              [46.71185632300006, 29.27139272],
              [46.7744881590001, 29.363531799000057],
              [46.83856693500013, 29.42497507800006],
              [46.85344974800006, 29.444560446000068],
              [46.88311202000011, 29.512514954000025],
              [46.95783614100014, 29.620441183000068],
              [46.977369832000136, 29.65798411100006],
              [46.97985030100011, 29.668061015],
              [46.98367435700004, 29.698291728000115],
              [46.988842, 29.712657776000114],
              [47.02542891400009, 29.77213735000008],
              [47.110488322000094, 29.960911357000057],
              [47.1446981200001, 30.003337707000085],
              [47.19709802300014, 30.034240214000093],
              [47.35822513800008, 30.09211781800012],
              [47.41579268400005, 30.09821563700008],
              [47.67417484500004, 30.09821563700008],
              [47.7314323330001, 30.088552145000037],
              [47.948008660000085, 29.994045315000037],
            ],
          ],
          [
            [
              [48.338226759000065, 29.46279531500005],
              [48.353851759000065, 29.457424221000053],
              [48.361664259000065, 29.451605536000045],
              [48.37322024800005, 29.443060614000046],
              [48.38111412900008, 29.433986721000053],
              [48.389008009000065, 29.42487213700008],
              [48.39946355700005, 29.397639129000083],
              [48.39735632900005, 29.38749719900005],
              [48.38254118700007, 29.392089315000078],
              [48.373014450000085, 29.393918625000083],
              [48.36348230600004, 29.39943645900007],
              [48.335927283000046, 29.420592543000055],
              [48.31686726600009, 29.427013122000062],
              [48.29040357900004, 29.430649078000044],
              [48.269242148000046, 29.42968528600005],
              [48.27003014400009, 29.455877997000073],
              [48.27003014400009, 29.455959377000056],
              [48.28109785200007, 29.471096096000053],
              [48.29851321700005, 29.473130601000037],
              [48.338226759000065, 29.46279531500005],
            ],
          ],
          [
            [
              [48.35271243600005, 29.709784247000073],
              [48.33383222700007, 29.67926666900007],
              [48.303070509000065, 29.64520905200004],
              [48.266286655000044, 29.61595286700009],
              [48.22901451900009, 29.59992096600007],
              [48.22234134200005, 29.600531317000048],
              [48.18580162900008, 29.603949286000045],
              [48.16163170700008, 29.629706122000073],
              [48.12671959700003, 29.702337958000044],
              [48.08513431100005, 29.76780833500004],
              [48.07927493600005, 29.773911851000037],
              [48.07374108200008, 29.779689846000053],
              [48.053721550000034, 29.79002513200004],
              [48.04607181100005, 29.800482489000046],
              [48.065196160000085, 29.812201239000046],
              [48.076833530000044, 29.817572333000044],
              [48.09848066500007, 29.83071523600006],
              [48.10954837300005, 29.833319403000075],
              [48.113291863000086, 29.839097398000035],
              [48.119151238000086, 29.873602606000077],
              [48.10328209700003, 29.87913646000004],
              [48.09489993600005, 29.88031647300005],
              [48.08529707100007, 29.879909572000088],
              [48.08513431100005, 29.87986888200004],
              [48.09506269600007, 29.89472077000005],
              [48.10922285200007, 29.89362213700008],
              [48.133555535000085, 29.87986888200004],
              [48.144867384000065, 29.87832265800006],
              [48.15870201900009, 29.87921784100007],
              [48.16651451900009, 29.885931708000044],
              [48.160817905000044, 29.901556708000044],
              [48.17888431100005, 29.90851471600007],
              [48.193695509000065, 29.916449286000045],
              [48.19743899800005, 29.92536041900007],
              [48.18140709700003, 29.93508535400008],
              [48.18132571700005, 29.93512604400007],
              [48.169932488000086, 29.936468817000048],
              [48.15674889400009, 29.93113841400009],
              [48.147227410000085, 29.93512604400007],
              [48.14283287900008, 29.94171784100007],
              [48.14039147200003, 29.95221588700008],
              [48.139414910000085, 29.962836005000042],
              [48.14039147200003, 29.96979401200008],
              [48.14039147200003, 29.969875393000052],
              [48.12273196700005, 29.969671942000048],
              [48.12029056100005, 29.97142161700009],
              [48.11670983200008, 29.97406647300005],
              [48.12086022200003, 29.981390692000048],
              [48.133555535000085, 29.98969147300005],
              [48.14795983200008, 29.994940497000073],
              [48.162119988000086, 29.99567291900007],
              [48.175791863000086, 29.991888739000046],
              [48.18873131600009, 29.983547268000052],
              [48.344493035000085, 29.79059479400007],
              [48.35954837300005, 29.754461981000077],
              [48.35271243600005, 29.709784247000073],
            ],
          ],
          [
            [
              [48.078868035000085, 30.004055080000057],
              [48.07243899800005, 29.99872467700004],
              [48.06275475400008, 29.987453518000052],
              [48.05836022200003, 29.983547268000052],
              [48.03109785200007, 29.97101471600007],
              [48.02369225400008, 29.969875393000052],
              [48.016286655000044, 29.97370026200008],
              [48.010752800000034, 29.980454820000034],
              [48.00928795700008, 29.986883856000077],
              [48.02312259200005, 29.99518463700008],
              [48.043630405000044, 30.01902903900009],
              [48.054698113000086, 30.02448151200008],
              [48.093760613000086, 30.029282945000034],
              [48.09384199300007, 30.029282945000034],
              [48.10922285200007, 30.02798086100006],
              [48.106130405000044, 30.017645575000074],
              [48.078868035000085, 30.004055080000057],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Timor-Leste',
        iso3: 'TLS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [124.45053144600001, -9.180189710999912],
              [124.45150394800015, -9.200574238999877],
              [124.436621134, -9.255868021999902],
              [124.43181522700002, -9.29080128999989],
              [124.42793949400004, -9.299482929999954],
              [124.42478723200009, -9.303513691999854],
              [124.42091149900006, -9.30692433699997],
              [124.40168786600015, -9.331832376999941],
              [124.37187056500005, -9.357050475999898],
              [124.3626204840001, -9.362011413999937],
              [124.3580729580001, -9.362218118999905],
              [124.35455896000013, -9.364181823999928],
              [124.3478927000001, -9.374620462999872],
              [124.34541223200006, -9.404179381999896],
              [124.34174320500006, -9.41182749399988],
              [124.33207971200005, -9.425470071999882],
              [124.32861739100008, -9.433014831999927],
              [124.32882409700005, -9.439836119999896],
              [124.33337162300006, -9.457199401999901],
              [124.33233809500007, -9.466604511999961],
              [124.32355310100002, -9.480350443999896],
              [124.31006555200014, -9.488722025999962],
              [124.293064006, -9.49306284499994],
              [124.2738403730001, -9.494923196999949],
              [124.26159305900006, -9.49792042999988],
              [124.25751062100005, -9.501227721999967],
              [124.25658044500011, -9.499367370999963],
              [124.25337650600005, -9.486448261999954],
              [124.25337650600005, -9.48055714899995],
              [124.25689050300002, -9.462883808999948],
              [124.25751062100005, -9.455442402999921],
              [124.25399662300003, -9.438699238999973],
              [124.24686527500006, -9.421542662999911],
              [124.23715010600012, -9.405212910999879],
              [124.22578129100015, -9.391570332999962],
              [124.21069177300006, -9.378857930999914],
              [124.19746260600004, -9.373173522999878],
              [124.18361332300009, -9.37389699299996],
              [124.167231893, -9.380614928999904],
              [124.15379602100006, -9.391880391999862],
              [124.13374556500003, -9.419268899999906],
              [124.1210848390001, -9.42691701299988],
              [124.09028568500003, -9.421542662999911],
              [124.06269047, -9.397874856999891],
              [124.03003991000003, -9.341973565999922],
              [124.04835045700008, -9.337009372999944],
              [124.12916100400003, -9.304945570999905],
              [124.14673912900003, -9.302911065999922],
              [124.15935306100005, -9.296482028999947],
              [124.18132571700005, -9.26539478999996],
              [124.19076582100001, -9.25514088299991],
              [124.22120201900009, -9.24114348799992],
              [124.28777103000004, -9.22079843499995],
              [124.38575280000009, -9.202325127999927],
              [124.396820509, -9.196465752999927],
              [124.40528405000009, -9.18531666499996],
              [124.42514082100001, -9.181573174999926],
              [124.45020592500009, -9.180271091999941],
              [124.45053144600001, -9.180189710999912],
            ],
          ],
          [
            [
              [124.91950720683661, -8.962015500097579],
              [124.95378665500004, -8.94264088299991],
              [124.97478274800005, -8.922133070999905],
              [125.02320397200003, -8.849053643999923],
              [125.02759850400003, -8.83367278399993],
              [125.03687584700003, -8.824802341999941],
              [125.08171634200005, -8.80836353999996],
              [125.09644616000003, -8.79583098799992],
              [125.10035241000003, -8.77825286299992],
              [125.10645592500009, -8.68873463299991],
              [125.11500084700003, -8.665948174999926],
              [125.12794030000009, -8.645603122999944],
              [125.14429772200003, -8.631442966999941],
              [125.16431725400003, -8.62476978999996],
              [125.21013431100005, -8.617771091999941],
              [125.22925866000003, -8.60751718499995],
              [125.23731530000009, -8.60556405999995],
              [125.27393639400009, -8.610935153999947],
              [125.28516686300009, -8.607842705999929],
              [125.314789259, -8.590427341999941],
              [125.38103274800005, -8.571465752999927],
              [125.40113366000003, -8.56926848799992],
              [125.46697024800005, -8.573663018999923],
              [125.48747806100005, -8.56926848799992],
              [125.54151451900009, -8.54501718499995],
              [125.56592858200008, -8.542087497999944],
              [125.59180748800009, -8.549574476999908],
              [125.60352623800009, -8.54892343499995],
              [125.63086998800009, -8.52157968499995],
              [125.64926191500001, -8.529554945999905],
              [125.67888431100005, -8.530368747999944],
              [125.73316491000003, -8.52157968499995],
              [125.85059655000009, -8.483819268999923],
              [125.89771569100003, -8.481133721999925],
              [126.00220787900003, -8.499444268999923],
              [126.04224694100003, -8.51881275799991],
              [126.06910241000003, -8.52157968499995],
              [126.09107506600003, -8.517185153999947],
              [126.13347415500004, -8.50400155999995],
              [126.14185631600003, -8.50286223799992],
              [126.15503991000003, -8.501071872999944],
              [126.20004316500001, -8.500420830999929],
              [126.24024498800009, -8.494805596999925],
              [126.26091556100005, -8.484551690999922],
              [126.305023634, -8.453545830999929],
              [126.33692467500009, -8.444431247999944],
              [126.37012780000009, -8.425957940999922],
              [126.381195509, -8.424086195999905],
              [126.40113366000003, -8.423760674999926],
              [126.41163170700008, -8.419122002999927],
              [126.42969811300009, -8.432224216999941],
              [126.45093834700003, -8.44068775799991],
              [126.47396894600001, -8.445489190999922],
              [126.49732506600003, -8.44703541499996],
              [126.51197350400003, -8.45208098799992],
              [126.54883873800009, -8.486748955999929],
              [126.59009850400003, -8.472914320999905],
              [126.66684004000001, -8.436944268999923],
              [126.69312584700003, -8.429864190999922],
              [126.71208743600005, -8.416599216999941],
              [126.72022545700008, -8.412855726999908],
              [126.73129316500001, -8.412774346999925],
              [126.74830162900003, -8.41806405999995],
              [126.75554446700005, -8.419122002999927],
              [126.79932701900009, -8.410088799999926],
              [126.842133009, -8.391045830999929],
              [126.94459069100003, -8.318617445999905],
              [126.96705162900003, -8.309014580999929],
              [126.98389733200008, -8.312920830999929],
              [126.99927819100003, -8.324151299999926],
              [127.06959069100003, -8.357598565999922],
              [127.08887780000009, -8.362725518999923],
              [127.113617384, -8.36500416499996],
              [127.13795006600003, -8.362725518999923],
              [127.15552819100003, -8.354180596999925],
              [127.18628991000003, -8.332452080999929],
              [127.19312584700003, -8.32976653399993],
              [127.20606530000009, -8.332614841999941],
              [127.21094811300009, -8.339043877999927],
              [127.21363366000003, -8.347832940999922],
              [127.22038821700005, -8.357598565999922],
              [127.24154707100001, -8.370212497999944],
              [127.28687584700003, -8.382419528999947],
              [127.30600019600001, -8.395196221999925],
              [127.31324303500003, -8.415215752999927],
              [127.30323326900009, -8.432305596999925],
              [127.23015384200005, -8.486586195999905],
              [127.18433678500003, -8.532321872999944],
              [127.09262129000001, -8.603122653999947],
              [127.02800540500004, -8.665459893999923],
              [127.02116946700005, -8.675713799999926],
              [127.00928795700008, -8.67669036299992],
              [126.93921959700003, -8.692152601999908],
              [126.87484785200002, -8.738457940999922],
              [126.84620201900009, -8.752536716999941],
              [126.69418379000001, -8.76344166499996],
              [126.67237389400009, -8.768649997999944],
              [126.66065514400009, -8.774183851999908],
              [126.63135826900009, -8.79583098799992],
              [126.62403405000009, -8.799004815999922],
              [126.61548912900003, -8.80087655999995],
              [126.59351647200003, -8.80201588299991],
              [126.58326256600003, -8.805840752999927],
              [126.54411868600005, -8.850274346999925],
              [126.50782311300009, -8.91187916499996],
              [126.47242272200003, -8.942803643999923],
              [126.43018639400009, -8.954685153999947],
              [126.16586347700002, -8.98837655999995],
              [126.13795006600003, -8.999932549999926],
              [126.12191816500001, -9.006524346999925],
              [126.04753665500004, -9.057305596999925],
              [125.94711347700002, -9.125746351999908],
              [125.92847741000003, -9.131605726999908],
              [125.86963951900009, -9.122653903999947],
              [125.84986412900003, -9.124200127999927],
              [125.83871504000001, -9.130059502999927],
              [125.81690514400009, -9.14820728999996],
              [125.80518639400009, -9.15211353999996],
              [125.76368248800009, -9.15211353999996],
              [125.74268639400009, -9.157321872999944],
              [125.67855879000001, -9.19304778399993],
              [125.66016686300009, -9.193536065999922],
              [125.60938561300009, -9.186211846999925],
              [125.59302819100003, -9.189629815999922],
              [125.572601759, -9.205743096999925],
              [125.55209394600001, -9.217217705999929],
              [125.48796634200005, -9.240817966999941],
              [125.37875410200002, -9.28101978999996],
              [125.34278405000009, -9.302911065999922],
              [125.29127037900003, -9.34547291499996],
              [125.26368248800009, -9.357354424999926],
              [125.25147545700008, -9.371514580999929],
              [125.23292076900009, -9.399183851999908],
              [125.22201582100001, -9.41106536299992],
              [125.21111087300005, -9.41961028399993],
              [125.19662519600001, -9.42473723799992],
              [125.14991295700008, -9.428155205999929],
              [125.13054446700005, -9.433770440999922],
              [125.113617384, -9.444431247999944],
              [125.09644616000003, -9.461195570999905],
              [125.06161543100006, -9.485772393999923],
              [125.05093075400009, -9.42469684299995],
              [125.04629968300009, -9.409863788999942],
              [125.02376875800007, -9.3747238159999],
              [125.02278690600008, -9.367695820999884],
              [125.02480228700006, -9.351986184999916],
              [125.02340702400016, -9.345578307999887],
              [125.01787764500006, -9.338963724999886],
              [124.9966903080001, -9.325837910999908],
              [124.97281579600013, -9.304650572999947],
              [124.96599450700006, -9.293385111999896],
              [124.9601550700001, -9.276021829999877],
              [124.9541089280001, -9.241501973999988],
              [124.95793298400008, -9.21194305399996],
              [124.97446944200016, -9.191892598999914],
              [125.00723230100004, -9.186104837999949],
              [125.02769616800003, -9.186311543999906],
              [125.034517456, -9.188171895999915],
              [125.04144209800006, -9.193236185999893],
              [125.05337935400007, -9.206672057999938],
              [125.05968387900009, -9.21049611399988],
              [125.0739465740001, -9.211322936999906],
              [125.08257653800001, -9.20553517699993],
              [125.09146488400006, -9.196750182999935],
              [125.10696781400009, -9.188481953999897],
              [125.11792321800016, -9.187551777999943],
              [125.14252120000003, -9.189102070999866],
              [125.15063440000011, -9.185381367999952],
              [125.153890015, -9.17576955099993],
              [125.15265373200015, -9.170824418999956],
              [125.1512028410001, -9.165020852999916],
              [125.14696537300006, -9.154478861999863],
              [125.14500166900007, -9.145177103999927],
              [125.16200321400004, -9.082338561999947],
              [125.1623649500001, -9.06063446099995],
              [125.15399336800016, -9.040790709999953],
              [125.13942061400007, -9.024771015999917],
              [125.12133386200009, -9.011851907999898],
              [125.10252364200005, -9.00130991599994],
              [125.09528894100009, -8.994798684999878],
              [125.09151656100005, -8.988597513999892],
              [125.08681400600011, -8.98622039799993],
              [125.07647871900008, -8.990767923999968],
              [125.07301639900004, -8.996452331999919],
              [125.06857222500003, -9.015882669999897],
              [125.06531661000014, -9.023220723999898],
              [125.05182906100009, -9.035002949999893],
              [125.00444177300011, -9.055570169999967],
              [124.97891361500007, -9.072003274999943],
              [124.96589115400002, -9.077274271999968],
              [124.94785608000012, -9.07851450599992],
              [124.93302494300008, -9.07448374399992],
              [124.92129439300004, -9.065492044999885],
              [124.91297448700004, -9.05277964199992],
              [124.90791019700009, -9.037483418999955],
              [124.90915043100011, -9.020326842999907],
              [124.92248295100006, -8.986323750999958],
              [124.91950720683661, -8.962015500097579],
            ],
          ],
          [
            [
              [125.56934655000009, -8.196384372999944],
              [125.58025149800005, -8.17896900799991],
              [125.60515384200005, -8.153008721999925],
              [125.63249759200005, -8.135023695999905],
              [125.65064537900003, -8.142836195999905],
              [125.64210045700008, -8.17473723799992],
              [125.60352623800009, -8.26881275799991],
              [125.59669030000009, -8.299248955999929],
              [125.59229576900009, -8.307305596999925],
              [125.58301842500009, -8.314385674999926],
              [125.57357832100001, -8.31731536299992],
              [125.56934655000009, -8.312920830999929],
              [125.56275475400003, -8.309177341999941],
              [125.53052819100003, -8.299493096999925],
              [125.51758873800009, -8.292168877999927],
              [125.50709069100003, -8.280368747999944],
              [125.50367272200003, -8.27076588299991],
              [125.50635826900009, -8.26100025799991],
              [125.51417076900009, -8.24773528399993],
              [125.52662194100003, -8.235772393999923],
              [125.56202233200008, -8.209161065999922],
              [125.56934655000009, -8.196384372999944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Brunei',
        iso3: 'BRN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [115.14616946700005, 4.908514716000127],
              [115.14680057800001, 4.885620219000131],
              [115.15599898300002, 4.876292623000012],
              [115.16933150200015, 4.869988098000093],
              [115.18225061100014, 4.8612289430001],
              [115.20736535700007, 4.825598043000127],
              [115.27268436700001, 4.636772359000119],
              [115.2770251880001, 4.613052877000072],
              [115.27547489400001, 4.595741272000069],
              [115.26741337100009, 4.556208802000128],
              [115.26689660600005, 4.516857198000139],
              [115.27247766200009, 4.474663391000078],
              [115.28560347500002, 4.435363465000094],
              [115.30865116400003, 4.404693502000072],
              [115.34379113800003, 4.371672261000086],
              [115.35826053900007, 4.350278219000074],
              [115.36074100800016, 4.329555970000058],
              [115.34627160700012, 4.313768820000064],
              [115.32436080000008, 4.314595642000086],
              [115.30120975800008, 4.324698385000119],
              [115.28312300700014, 4.3367648320001],
              [115.27433801300009, 4.340020447000086],
              [115.25511438100006, 4.339245300000087],
              [115.24467574100004, 4.343663635000084],
              [115.22906945800008, 4.356763611000048],
              [115.22069787600009, 4.359760844000064],
              [115.19082889800006, 4.356763611000048],
              [115.16995162, 4.36125946000007],
              [115.11300419200006, 4.382369284000092],
              [115.09977502500016, 4.391231791000109],
              [115.09181685400006, 4.405416972000069],
              [115.07982792200005, 4.503963928000132],
              [115.06814904800007, 4.543367208000049],
              [115.0354895430001, 4.621243592000013],
              [115.02680790200009, 4.660026754000043],
              [115.022777141, 4.741365458000047],
              [115.02977835200011, 4.820641508000094],
              [115.04810631600003, 4.801825262000079],
              [115.06641686300009, 4.813544012000079],
              [115.08619225400003, 4.835638739000046],
              [115.10857181100005, 4.847479559000078],
              [115.13021894600001, 4.852036851000094],
              [115.13086998800009, 4.863714911000045],
              [115.12232506600003, 4.879380601000094],
              [115.11646569100003, 4.896063544000071],
              [115.11866295700008, 4.90375397300005],
              [115.12517337300005, 4.90766022300005],
              [115.13453209700003, 4.90884023600006],
              [115.14584394600001, 4.90851471600007],
              [115.14616946700005, 4.908514716000127],
            ],
          ],
          [
            [
              [114.98170006600003, 4.889064846000053],
              [114.95890507000007, 4.866293234000082],
              [114.95570113100007, 4.850919495000099],
              [114.95487430900005, 4.834202169000065],
              [114.94836307800011, 4.818931783000025],
              [114.93244673700008, 4.809139099000063],
              [114.91487675000008, 4.808725688000052],
              [114.89647994000012, 4.811826274000083],
              [114.87818648300004, 4.81280812600005],
              [114.85575891100007, 4.806658630000086],
              [114.83767216000001, 4.795315654000092],
              [114.80542606700016, 4.764568177000044],
              [114.78847619700008, 4.753896993000055],
              [114.7517859300001, 4.738523255000075],
              [114.743192034, 4.730585208000079],
              [114.74196740800005, 4.729454040000107],
              [114.74134729000008, 4.71294342000003],
              [114.748788697, 4.694391581000076],
              [114.76811568300002, 4.657494609000054],
              [114.773903442, 4.636824036000036],
              [114.77731408700004, 4.614654847000111],
              [114.78217167200006, 4.49778859500006],
              [114.78816613800007, 4.46120168000003],
              [114.80604618300003, 4.433322246000046],
              [114.82568322700007, 4.426190898000101],
              [114.840462688, 4.428619691000065],
              [114.847904094, 4.423736268000127],
              [114.84563033100011, 4.395107524000068],
              [114.83643192500011, 4.357228699000075],
              [114.82899051900006, 4.340485535000113],
              [114.81824182100007, 4.323458151000096],
              [114.79416325000005, 4.300239528000105],
              [114.78785607900011, 4.294157613000039],
              [114.78196496600009, 4.284933370000118],
              [114.78258508400006, 4.264417826000056],
              [114.81379764900015, 4.277104391000094],
              [114.81720829300008, 4.259663595000063],
              [114.809973592, 4.241292623000064],
              [114.78713260900008, 4.207212016000099],
              [114.78010461500008, 4.187755839000118],
              [114.77452356000009, 4.146466370000013],
              [114.76687544800006, 4.131816101000112],
              [114.674891398, 4.044069519000075],
              [114.6277624920001, 4.016681010000042],
              [114.58662805200004, 4.021435242000038],
              [114.58166711500007, 4.029341736000077],
              [114.57422570800014, 4.05414642300012],
              [114.5693681240001, 4.064404195000108],
              [114.56140995300007, 4.072026469000079],
              [114.54022261600011, 4.08693512000012],
              [114.47738407500003, 4.144967753000088],
              [114.46312137900014, 4.164139709000011],
              [114.4533028570001, 4.18369923900012],
              [114.43252893100015, 4.246925354000098],
              [114.41991988200004, 4.26012868300009],
              [114.4014197190001, 4.261213887000082],
              [114.36049198500007, 4.253875834000084],
              [114.31677372200011, 4.262505799000039],
              [114.28266727700014, 4.264908753000086],
              [114.27801639800015, 4.274055481000076],
              [114.27625940000007, 4.289015808000045],
              [114.27946333800008, 4.294881084000039],
              [114.29341597500007, 4.307050883000045],
              [114.29672326700006, 4.316662700000052],
              [114.2899019780001, 4.361311137000072],
              [114.27625940000007, 4.381852519000063],
              [114.27625940000007, 4.409731954000037],
              [114.268507935, 4.437740581000043],
              [114.26261682100011, 4.448721823000128],
              [114.25207483000014, 4.460349020000081],
              [114.24876753800004, 4.466886088000066],
              [114.24783736200004, 4.474766744000107],
              [114.24556359900015, 4.481433004000024],
              [114.23832889800008, 4.484223532000073],
              [114.22292932200003, 4.484636943000083],
              [114.216728149, 4.487660014000099],
              [114.20908003800002, 4.508149719000073],
              [114.19729781100006, 4.51582367000006],
              [114.17269983000006, 4.525228780000106],
              [114.1400403240001, 4.55065358500012],
              [114.11895634000007, 4.561634827000105],
              [114.06417932200009, 4.570032247000086],
              [113.99878991000003, 4.601141669000071],
              [114.25171959700003, 4.592678127000056],
              [114.32667076900009, 4.60687897300005],
              [114.39576256600003, 4.645738023000092],
              [114.494476759, 4.681260484000063],
              [114.52930748800009, 4.693793036000045],
              [114.55030358200008, 4.714422919000071],
              [114.56568444100003, 4.743353583000044],
              [114.60181725400003, 4.779974677000041],
              [114.72266686300009, 4.876044012000079],
              [114.7601831390001, 4.89874909100007],
              [114.92839603000004, 5.000555731000077],
              [115.05779056100005, 5.054103908000059],
              [115.08285566500001, 5.057196356000077],
              [115.10173587300005, 5.049872137000079],
              [115.10320071700005, 5.036851304000038],
              [115.08863366000003, 5.026597398000092],
              [115.05738366000003, 5.012640692000048],
              [115.04908287900003, 4.999172268000052],
              [115.03248131600003, 4.959418036000045],
              [115.02955162900003, 4.947455145000049],
              [115.02279707100001, 4.933742580000057],
              [114.99170983200008, 4.904974677000041],
              [114.98170006600003, 4.889064846000053],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Myanmar',
        iso3: 'MMR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [92.57587854000013, 21.977574362000027],
              [92.58383671100012, 21.98031321200007],
              [92.59127811700006, 21.98424062200006],
              [92.59799605400008, 21.989304912000122],
              [92.60388716700004, 21.995402731000084],
              [92.61525598200006, 22.0087869260001],
              [92.6275549720001, 22.012352600000085],
              [92.63985396300012, 22.013386129000068],
              [92.65091272000012, 22.019173890000033],
              [92.65835412600006, 22.032816468000036],
              [92.65835412600006, 22.04656239800009],
              [92.65608036300006, 22.060566711],
              [92.65618371600004, 22.075294495],
              [92.66207482900006, 22.094776510000074],
              [92.66455529800004, 22.093846334000133],
              [92.6695162360001, 22.092657777000014],
              [92.67396040900007, 22.0952415980001],
              [92.6746838790001, 22.105576884000115],
              [92.67106652800004, 22.133895569000018],
              [92.67396040900007, 22.147073059],
              [92.68377893100006, 22.154307760000066],
              [92.7080668540001, 22.14795155800003],
              [92.77162886600013, 22.104181621000052],
              [92.83612105300006, 22.046510722000065],
              [92.85389774600009, 22.024134827000083],
              [92.8620626230001, 21.995402731000084],
              [92.86702356000006, 21.966515605000026],
              [92.87746219900009, 21.95700714200005],
              [92.88924442500007, 21.966722311000083],
              [92.89864953600005, 21.995402731000084],
              [92.90619429500009, 22.01731353800004],
              [92.92097375600014, 22.02180938700006],
              [92.93740686000007, 22.013024394000055],
              [92.95032596900006, 21.995351054000068],
              [92.95559696500004, 21.98961497],
              [92.9616947830001, 21.98687611900006],
              [92.96810266200004, 21.98723785400007],
              [92.97492395000006, 21.990906881000072],
              [92.97709436100007, 21.993025615000036],
              [92.97895471200007, 21.995351054000068],
              [92.97988488800013, 22.00227569600004],
              [92.97957482900006, 22.009355367000083],
              [92.97792118400008, 22.016486715000028],
              [92.97492395000006, 22.02330800400007],
              [92.96841272000012, 22.03617543500006],
              [92.96531213400004, 22.049559632000083],
              [92.9671724860001, 22.06268544600006],
              [92.98546594300012, 22.095965068000012],
              [92.99518111200007, 22.103251445000083],
              [93.00748010300003, 22.1059386190001],
              [93.0254635010001, 22.1129149370001],
              [93.02256962100012, 22.120976461000097],
              [93.02391320800007, 22.18882761700003],
              [93.02236291600008, 22.19621734600004],
              [93.02453332500005, 22.201901754000076],
              [93.03641890500006, 22.206242575000076],
              [93.04582401500005, 22.20686269100004],
              [93.07248905400007, 22.202470195000032],
              [93.09057580600012, 22.197147522000094],
              [93.10432173700013, 22.187173970000075],
              [93.11951460800009, 22.180972799000088],
              [93.14173547400009, 22.18727732400002],
              [93.12313195800004, 22.218386536000068],
              [93.12354537000004, 22.230685527],
              [93.12478560400007, 22.23228749600004],
              [93.12974654200013, 22.23161570200007],
              [93.15145064300003, 22.24096913700002],
              [93.16126916500008, 22.24251943000003],
              [93.16902063000003, 22.246911927000028],
              [93.17367150900009, 22.259417623000033],
              [93.17429162700006, 22.26939117400012],
              [93.16592004400007, 22.38659332300007],
              [93.15351770000012, 22.427521057],
              [93.11786096200012, 22.46286773700008],
              [93.10959273300006, 22.479042460000088],
              [93.09915409300004, 22.511960347000027],
              [93.09822391800009, 22.535266419000052],
              [93.10907596900012, 22.57469553600008],
              [93.11052290900011, 22.596347962000053],
              [93.10442509000006, 22.61593332900007],
              [93.08189416500005, 22.652830302000027],
              [93.07393599400007, 22.671898905000077],
              [93.07083540900004, 22.69287953700008],
              [93.07951704900012, 22.772719626000068],
              [93.11238326000012, 22.799953105000085],
              [93.11589725800007, 22.79840281200005],
              [93.12530236800012, 22.821553854000044],
              [93.16106246000004, 22.86098297200006],
              [93.17553186100008, 22.881705220000086],
              [93.17739221200009, 22.900205384000017],
              [93.17108768700007, 22.92043670700012],
              [93.15114058400007, 22.95622263600005],
              [93.14318241400008, 22.97751332600002],
              [93.13822147700006, 23.005263570000054],
              [93.14008182800006, 23.031902771000105],
              [93.15238081900009, 23.049937846000105],
              [93.17708215400012, 23.058438619000114],
              [93.19651249200007, 23.053839417000077],
              [93.21211877500014, 23.03988678000006],
              [93.22555464700008, 23.020378927000067],
              [93.24653527900006, 23.00448842400006],
              [93.27278690600008, 23.005909526000053],
              [93.29883182800006, 23.01795013400003],
              [93.31826216700006, 23.033659770000085],
              [93.33335168500008, 23.05228912300005],
              [93.37489953600004, 23.129726257000087],
              [93.37520959500006, 23.142154439000066],
              [93.37303918400005, 23.15422088700005],
              [93.37272912600008, 23.169827169000072],
              [93.38079065000005, 23.237264913],
              [93.37644982900008, 23.279484559000068],
              [93.37789676900007, 23.29682200100008],
              [93.38420129400009, 23.313125916000033],
              [93.40373498600007, 23.338757426000072],
              [93.40724898300004, 23.34725819900008],
              [93.4077657470001, 23.35637908900007],
              [93.4059053960001, 23.367670390000043],
              [93.3998075770001, 23.426090597000027],
              [93.40022098800011, 23.454021709000088],
              [93.43236372900009, 23.647317404000106],
              [93.43029667200011, 23.6803386430001],
              [93.42595585100014, 23.69080312100003],
              [93.41231327300011, 23.708709005000102],
              [93.4063188070001, 23.719121806000132],
              [93.37479618400005, 23.739017232000023],
              [93.35825972500004, 23.85526336700012],
              [93.3591899010001, 23.89094594300012],
              [93.35598596200003, 23.906991475000083],
              [93.35185184800008, 23.913916117000056],
              [93.34596073400007, 23.918696188000055],
              [93.33758915200013, 23.928411357000087],
              [93.31609175600005, 23.961096700000084],
              [93.30813358600011, 23.977503968000022],
              [93.30296594200013, 23.995280660000063],
              [93.30110559100012, 24.016571350000035],
              [93.30255946900013, 24.035774655000083],
              [93.30296594200013, 24.041143494000025],
              [93.30968387900003, 24.063984477000034],
              [93.32218957500004, 24.080055847],
              [93.34854455600009, 24.088892517000104],
              [93.36828495300006, 24.078479716000075],
              [93.39650028500012, 24.03752614400004],
              [93.40652551300013, 24.025847270000057],
              [93.4391850180001, 23.995228984000036],
              [93.44559289600005, 23.98161224400006],
              [93.44900354000009, 23.96892568],
              [93.45665165200006, 23.959959819000076],
              [93.47484175700009, 23.957505189000088],
              [93.49571903500009, 23.959132996000037],
              [93.52682824700014, 23.97538523300007],
              [93.54346805900013, 23.980888774000064],
              [93.54997928900013, 23.978020732000076],
              [93.55525028500006, 23.97099273700006],
              [93.5613481040001, 23.965695903000025],
              [93.57106327400004, 23.968021343000046],
              [93.57695438700006, 23.97300811800001],
              [93.58181197200008, 23.979596863],
              [93.58563602700008, 23.98729665100008],
              [93.58801314300007, 23.995228984000036],
              [93.61240441900009, 24.00905243000001],
              [93.66046350100004, 24.011222839000098],
              [93.71110640500012, 24.005460917000036],
              [93.74304244000007, 23.995280660000063],
              [93.78283329300007, 23.94546457900013],
              [93.80371057200006, 23.936059469000057],
              [93.88318892500007, 23.94530955000009],
              [93.91233443200008, 23.93900502500007],
              [93.94054976400014, 23.928876445000114],
              [93.97506962100005, 23.920918274000044],
              [93.99791060400014, 23.916965027000074],
              [94.05506473800006, 23.88794871],
              [94.07108443200008, 23.876114808000082],
              [94.08534712700009, 23.857511292000126],
              [94.09971317600008, 23.842628479000084],
              [94.11686975100014, 23.84164662700003],
              [94.12885926700005, 23.853904873000076],
              [94.13185591700011, 23.856968689000084],
              [94.13505985500007, 23.877303365],
              [94.13361291500007, 23.899162496000045],
              [94.13505985500007, 23.919006246000052],
              [94.14487837800004, 23.93887583400003],
              [94.1902502850001, 23.995280660000063],
              [94.19386763500006, 24.00967254700008],
              [94.19913863200003, 24.048093974000025],
              [94.20368615700005, 24.05775746700003],
              [94.21412479700007, 24.069177959000044],
              [94.21846561700005, 24.086670431000087],
              [94.22218632100004, 24.122637228000073],
              [94.23396854600009, 24.160335185000108],
              [94.28275109900011, 24.26642690100003],
              [94.28688521300006, 24.283066712000064],
              [94.28998580000007, 24.316759746000017],
              [94.29536014800004, 24.332598572],
              [94.30280155400004, 24.341021831000106],
              [94.32367883300003, 24.35466440800009],
              [94.33070682800013, 24.36285512300013],
              [94.33174035600013, 24.371097514000084],
              [94.32832971200003, 24.388486634000103],
              [94.32874312400003, 24.39448110000002],
              [94.34000858600007, 24.40600494400006],
              [94.35220422300011, 24.413937277000016],
              [94.36119592300014, 24.425409444000124],
              [94.36367639200012, 24.46582041500001],
              [94.37039432800003, 24.47773183300005],
              [94.38186649600004, 24.486310120000084],
              [94.39705936700005, 24.495069275000063],
              [94.41080529800013, 24.54594472300009],
              [94.4184534100001, 24.56031077100009],
              [94.43023563600008, 24.570904439000074],
              [94.47498742700003, 24.597388611000056],
              [94.48707971200014, 24.620462138000036],
              [94.50795699100013, 24.689010925000062],
              [94.51632857300007, 24.704953105000087],
              [94.53100468000008, 24.70748525000006],
              [94.54340702300004, 24.70733022000003],
              [94.55570601400007, 24.70885467600006],
              [94.56945194600013, 24.716399434],
              [94.58154423100012, 24.73011952800003],
              [94.58950240100006, 24.747250264000073],
              [94.59322310400006, 24.765931295000044],
              [94.59322310400006, 24.7837855020001],
              [94.59901086400004, 24.813473612000067],
              [94.63911177600005, 24.862798767000058],
              [94.65482141100011, 24.889153748000027],
              [94.67352828000008, 24.974807434000112],
              [94.68975467900003, 24.99509043400012],
              [94.7085649010001, 25.025889587000094],
              [94.71383589700014, 25.068264262000085],
              [94.70680790300014, 25.10994130500002],
              [94.68913456300004, 25.138518372000092],
              [94.65327111800008, 25.15412465400003],
              [94.61296350100014, 25.1613593550001],
              [94.57689335200013, 25.173606670000126],
              [94.55332889800013, 25.20414744000003],
              [94.55012496000006, 25.245281881],
              [94.60800256400012, 25.394626770000073],
              [94.63053348800008, 25.427389629000075],
              [94.6503600370001, 25.446649705000098],
              [94.65947229000005, 25.45550160800012],
              [94.69202844200004, 25.476327210000065],
              [94.71114872200013, 25.482786764000124],
              [94.74577193200014, 25.486610820000053],
              [94.76437544800007, 25.49167511000003],
              [94.78235884600008, 25.504594219000055],
              [94.80799035600012, 25.542628072000085],
              [94.82235640500005, 25.559112854000077],
              [94.83103804600012, 25.56247182300008],
              [94.85077844300014, 25.56278188100005],
              [94.86028690600006, 25.567174378000047],
              [94.86101037600014, 25.571411846],
              [94.85294885300004, 25.58076528000005],
              [94.8534656170001, 25.58603627500007],
              [94.85749637900005, 25.589343567000085],
              [94.86803837100007, 25.59471791600005],
              [94.87165572100014, 25.59802520800004],
              [94.96146936100013, 25.717966207000032],
              [94.96901412000005, 25.725614319],
              [94.97862593600007, 25.72907664000006],
              [94.99991662700006, 25.731557109000036],
              [95.00880497300011, 25.73713816300004],
              [95.01531620300005, 25.755121562000014],
              [95.01345585200005, 25.777704163000053],
              [94.99319869000004, 25.88095367400011],
              [94.99402551300005, 25.90043569],
              [95.0006400960001, 25.922036438000063],
              [95.01200891200006, 25.93144154900004],
              [95.04942264900012, 25.943740540000064],
              [95.0658557540001, 25.953817444000023],
              [95.10823042800013, 25.99510691300013],
              [95.13954634600003, 26.02993682900008],
              [95.15122522000007, 26.04993560800004],
              [95.1500883380001, 26.070967916000043],
              [95.13747928900005, 26.082956848],
              [95.10171919800013, 26.09339548800004],
              [95.08817997300008, 26.10409250900004],
              [95.07836145100009, 26.171323548000103],
              [95.08239221200006, 26.179798483000113],
              [95.08973026500007, 26.187601624000123],
              [95.09448449700005, 26.195043030000065],
              [95.09076379400005, 26.202691142000035],
              [95.08280562300007, 26.20661855100009],
              [95.07453739500005, 26.208323873000055],
              [95.06637251800004, 26.2110110470001],
              [95.05872440600007, 26.217677307000102],
              [95.04632206200006, 26.24795969700004],
              [95.04177453600005, 26.287595520000096],
              [95.04363488800004, 26.327696432],
              [95.05045617700011, 26.359064026000013],
              [95.06420210800013, 26.392602031000123],
              [95.06606245900014, 26.407433167000065],
              [95.0617216390001, 26.426605123000073],
              [95.04260135900006, 26.459678040000043],
              [95.04063765500013, 26.47559438100008],
              [95.05438358600009, 26.494921367000032],
              [95.06988651600011, 26.506238506],
              [95.09923872900009, 26.536107484000027],
              [95.10957401600007, 26.55130035400005],
              [95.11494836400004, 26.562565816000117],
              [95.11618859900005, 26.56933542900005],
              [95.1158785400001, 26.575639954000067],
              [95.11908247900004, 26.604217021000025],
              [95.12280318300009, 26.611606751000025],
              [95.13262170500013, 26.620805155000127],
              [95.14140669800014, 26.624990946000068],
              [95.16342085800011, 26.62974517800005],
              [95.1732393800001, 26.63382761700008],
              [95.18161096200004, 26.641682435000106],
              [95.19556359900014, 26.660751038000072],
              [95.20486535700007, 26.66757232700003],
              [95.22326216700009, 26.67036285400009],
              [95.23907515500008, 26.649640605000073],
              [95.24693311800007, 26.64890392100004],
              [95.26057255100011, 26.647625224000123],
              [95.27896936100012, 26.65294789700006],
              [95.31596968600007, 26.66907094300005],
              [95.3926575110001, 26.691756898],
              [95.4106409100001, 26.701627096],
              [95.43999312400007, 26.73537180600006],
              [95.46273075300013, 26.777178040000123],
              [95.4898092040001, 26.810716044000046],
              [95.53135705600005, 26.820276185000026],
              [95.55440474400012, 26.816607157000035],
              [95.57476525900006, 26.81614207000011],
              [95.59130171700008, 26.823738505000065],
              [95.60339400200013, 26.844254049000043],
              [95.61331587700005, 26.867921855000063],
              [95.62427128100012, 26.880737610000054],
              [95.63998091600007, 26.88642201800009],
              [95.68607629400003, 26.89127960300003],
              [95.69930546100011, 26.896188863000063],
              [95.70922733600003, 26.907454326000035],
              [95.73496219900011, 26.947296855000033],
              [95.77795699100005, 26.995149231000042],
              [95.8049320880001, 27.00476104800005],
              [95.86146610500009, 27.014217835000025],
              [95.88885461500013, 27.0270335900001],
              [95.91644983000003, 27.051373189000017],
              [95.93836063700007, 27.079898580000062],
              [95.97484419800008, 27.142892151000083],
              [96.01318811100009, 27.190796204000023],
              [96.07416630100005, 27.22986358600012],
              [96.14258589700006, 27.25751047800013],
              [96.40778934700012, 27.29817983000008],
              [96.47465865100008, 27.29538930300002],
              [96.49005822700008, 27.290738424000054],
              [96.51093550700006, 27.292495422000044],
              [96.53181278500011, 27.298541565000065],
              [96.54731571500014, 27.306448059000033],
              [96.5674695240001, 27.328307191000064],
              [96.57604781100014, 27.34541208900002],
              [96.58689986200005, 27.353576966000034],
              [96.61418501800006, 27.34840932300004],
              [96.62317671800014, 27.34365509100003],
              [96.62927453600008, 27.338694153000077],
              [96.63640588400011, 27.335541891000034],
              [96.64901493300005, 27.336213685000118],
              [96.65924686700004, 27.341433004000024],
              [96.67588667900003, 27.357659404000046],
              [96.68725549300012, 27.361741842000058],
              [96.70523889200012, 27.360759989000073],
              [96.72415246600008, 27.35626414000005],
              [96.75887902800008, 27.341743063000123],
              [96.77634566300003, 27.330632630000096],
              [96.78916141700012, 27.31797190400006],
              [96.80993534400005, 27.285777487000118],
              [96.82171757000009, 27.273065084000066],
              [96.85375695800008, 27.248725485000037],
              [96.85964807200008, 27.240715637000065],
              [96.85127649000003, 27.221181946000073],
              [96.84176802600012, 27.204387106000084],
              [96.84269820200007, 27.188522441000075],
              [96.86533247900013, 27.1716242480001],
              [97.00299849500004, 27.11452179000007],
              [97.01188684100003, 27.107028707000055],
              [97.01891483600014, 27.098708802000075],
              [97.02676965400008, 27.091474101000117],
              [97.03803511600006, 27.087029928],
              [97.0478536380001, 27.087805074000116],
              [97.05882660700013, 27.092075635000057],
              [97.06697391800003, 27.095246480000057],
              [97.07720585100009, 27.09648671500007],
              [97.08991825400005, 27.09219757100003],
              [97.09797977800014, 27.085893046000095],
              [97.10604130000013, 27.08258575400002],
              [97.1191671140001, 27.08728831000009],
              [97.1228878170001, 27.093696188000123],
              [97.13301639900004, 27.119586080000047],
              [97.13477339700012, 27.12733754500006],
              [97.12929569600004, 27.137879537000018],
              [97.12082076100006, 27.143925680000066],
              [97.11172570800005, 27.14883494100009],
              [97.1043876550001, 27.15601796500006],
              [97.10170048100014, 27.165268046000065],
              [97.10128706900014, 27.183303121000066],
              [97.09549930900005, 27.19126129200002],
              [97.06790409400008, 27.21709950800006],
              [96.90512333200013, 27.408405660000128],
              [96.8813521730001, 27.44411407500003],
              [96.87701135200007, 27.463079325000095],
              [96.89024051900009, 27.492483215000064],
              [96.88848352100013, 27.507185160000077],
              [96.88465946500008, 27.515840963000116],
              [96.88104211500007, 27.534392802000056],
              [96.88031864400011, 27.543849589000033],
              [96.87732141200007, 27.553073832000038],
              [96.86615930200003, 27.56844757100002],
              [96.86202518800013, 27.57836944600011],
              [96.86212854000007, 27.599298401000098],
              [96.87019006400004, 27.61909047500008],
              [96.88352258400005, 27.636324565000066],
              [96.89974898300005, 27.649476217000128],
              [96.93953983600011, 27.6740225220001],
              [96.95700647000012, 27.68807851200002],
              [96.99090621000005, 27.72662913000009],
              [97.00403202400008, 27.73427724200006],
              [97.03617476400007, 27.742920068000032],
              [97.05054081200007, 27.746782939000056],
              [97.05674198400004, 27.746782939000056],
              [97.06035933400011, 27.750451965000067],
              [97.06201298100007, 27.763345235000074],
              [97.06532027200006, 27.773990581000064],
              [97.07234826700005, 27.779184062000084],
              [97.09219201700006, 27.785488587000074],
              [97.09818648300006, 27.791017965],
              [97.10604130000013, 27.805539043000024],
              [97.11244917900007, 27.809208069000036],
              [97.12319787600006, 27.812153625000022],
              [97.13177616400003, 27.816856181],
              [97.1821090090001, 27.857267151000073],
              [97.19802535100013, 27.87326100700004],
              [97.21094445800003, 27.88951324500006],
              [97.2229333900001, 27.899719341000022],
              [97.24122684700006, 27.907858379000047],
              [97.26065718600006, 27.912044170000073],
              [97.27636682200011, 27.910338847],
              [97.28804569500005, 27.8977556360001],
              [97.28866581300014, 27.88434560200004],
              [97.29290328000008, 27.877550151],
              [97.3149174400001, 27.884603983000105],
              [97.33352095600003, 27.894164124000028],
              [97.33817183500008, 27.90155385300004],
              [97.33631148300009, 27.91318105100008],
              [97.33569136600005, 27.93560862200006],
              [97.34003218600003, 27.951809184000084],
              [97.35677535000013, 27.98056711800008],
              [97.36225305200003, 27.994881490000083],
              [97.3551217050001, 28.02304514600003],
              [97.3065458580001, 28.0696572880001],
              [97.29290328000008, 28.095082092],
              [97.29889774600014, 28.12924021400009],
              [97.32866337100012, 28.190011699000095],
              [97.32349572800013, 28.217477723000073],
              [97.33383101400011, 28.235254415],
              [97.36959110600003, 28.25347035700004],
              [97.3778593350001, 28.26359893900009],
              [97.38437056500004, 28.284837952000075],
              [97.3982198490001, 28.28889455200006],
              [97.41672001200004, 28.286052348000098],
              [97.43666711400004, 28.286414083000082],
              [97.44782922400009, 28.29760203100004],
              [97.45237674900005, 28.317678324000084],
              [97.45237674900005, 28.355479635000066],
              [97.45020634000014, 28.364858907],
              [97.4467956950001, 28.374005636000092],
              [97.44534875500011, 28.382971497000128],
              [97.45010298700004, 28.39191152000005],
              [97.46570927000005, 28.40669097900006],
              [97.47149703000014, 28.414959209000116],
              [97.47459761600004, 28.426198832000082],
              [97.48813684100003, 28.44193430600005],
              [97.50301965300008, 28.47772023600008],
              [97.51397505800009, 28.49469594300008],
              [97.52772098800011, 28.52952585900006],
              [97.54622115100011, 28.53846588100008],
              [97.56751184100011, 28.525495097000046],
              [97.58993941300008, 28.49469594300008],
              [97.61360721800003, 28.481983541000133],
              [97.6410990810001, 28.498364970000083],
              [97.67045129400009, 28.511284079000077],
              [97.69959680200009, 28.48802968300008],
              [97.74000777200007, 28.38260976200003],
              [97.76532922400008, 28.352430725000133],
              [97.79726525900003, 28.34392995200001],
              [97.85907027200005, 28.370129903000034],
              [97.8975175380001, 28.35532460500012],
              [97.9447497970001, 28.29884226500006],
              [97.97875288900013, 28.280600484],
              [97.9929122320001, 28.26892161100004],
              [97.99384240800003, 28.25254018200009],
              [97.98485070800012, 28.2242214970001],
              [97.9910518800001, 28.214015401000026],
              [98.03135949800003, 28.208330994000065],
              [98.04861942600013, 28.199623515000027],
              [98.1150022760001, 28.14388835700008],
              [98.11869266800005, 28.140789897000033],
              [98.12696089700012, 28.124279277000042],
              [98.1279944260001, 28.105469056000018],
              [98.12251672400004, 28.015448710000058],
              [98.11848596200014, 27.99472646100004],
              [98.10711714700011, 27.973074036000057],
              [98.11352502500006, 27.96170522100006],
              [98.14897505700009, 27.944548645000012],
              [98.16582157400006, 27.92969167100007],
              [98.17729374200007, 27.91292266900011],
              [98.17667362500003, 27.898117371000083],
              [98.1567265220001, 27.889203187000064],
              [98.1400867110001, 27.878557841000074],
              [98.14577111900013, 27.860729472000045],
              [98.16241092900003, 27.842849427000075],
              [98.19662072800003, 27.823186544000023],
              [98.20065148900005, 27.813600565000016],
              [98.19848107900003, 27.800448914000057],
              [98.1978609620001, 27.780631002000078],
              [98.20209842900005, 27.7712517290001],
              [98.20840295400006, 27.766161601000036],
              [98.21150354000008, 27.760322164000044],
              [98.20178837100013, 27.736551005000095],
              [98.20437219300004, 27.727300924000062],
              [98.23806522600012, 27.680223694000077],
              [98.25439497900004, 27.648132629000074],
              [98.27568566900004, 27.570101217000072],
              [98.29470259600009, 27.536614889000063],
              [98.32860233600007, 27.52286895700003],
              [98.36394901500012, 27.532170716000067],
              [98.38327600100007, 27.55578684500007],
              [98.39288781700009, 27.587154440000106],
              [98.39815881400011, 27.619813945000075],
              [98.3974353430001, 27.656814270000027],
              [98.40001916500012, 27.675727844000065],
              [98.4102510990001, 27.68425445600009],
              [98.42224003100006, 27.680895487000058],
              [98.47453658000006, 27.65717600500004],
              [98.4923132730001, 27.643430074],
              [98.5221822520001, 27.656297506000087],
              [98.54336958800008, 27.642525737000042],
              [98.56435022000005, 27.603535869000055],
              [98.5784062090001, 27.59172780400003],
              [98.60455448400006, 27.59273549400011],
              [98.61654341700006, 27.59841990200006],
              [98.62584517500005, 27.6055512490001],
              [98.63504357900007, 27.611054789],
              [98.6472392170001, 27.611726583000078],
              [98.65592085800006, 27.60676564500004],
              [98.6657393800001, 27.597076315],
              [98.67421431500003, 27.586120911000123],
              [98.67927860500009, 27.57733591800003],
              [98.68175907400007, 27.55648447700007],
              [98.67111372900007, 27.516151022000102],
              [98.66832320200012, 27.475249126000094],
              [98.67442102100006, 27.3865982060001],
              [98.67731490100005, 27.376107890000057],
              [98.6837227790001, 27.37362742200007],
              [98.69106083200006, 27.373162334000043],
              [98.69736535700008, 27.368924866],
              [98.70770064400011, 27.337247213000083],
              [98.70418664600004, 27.304174296000028],
              [98.68020878100003, 27.237046611000082],
              [98.67359419800005, 27.207901103000054],
              [98.67256066900006, 27.17560333200008],
              [98.68268925000012, 27.110077617000073],
              [98.69137089100008, 27.092404276000067],
              [98.70273970500006, 27.086823222000064],
              [98.71648563700012, 27.082482402000082],
              [98.73136844900006, 27.068788147000063],
              [98.73777632600007, 27.048686015],
              [98.73167850700003, 27.031064352],
              [98.72061975100013, 27.013959452000066],
              [98.71266158100008, 26.995149231000042],
              [98.73570927000003, 26.907299296000062],
              [98.73632938600008, 26.89825592100003],
              [98.73312544800012, 26.88792063400011],
              [98.71865604700008, 26.872676087000073],
              [98.71452193200008, 26.862030741000083],
              [98.71813928200004, 26.842497050000063],
              [98.74242720500013, 26.81040598600005],
              [98.75038537600011, 26.792009176000064],
              [98.74924849500007, 26.77144195600006],
              [98.73436568300014, 26.73428660100008],
              [98.73198856700003, 26.71351267500002],
              [98.74645796800013, 26.681059876000106],
              [98.74738814300008, 26.672688293000036],
              [98.74676802600004, 26.664420064000083],
              [98.74707808400012, 26.655738424000035],
              [98.75069543500007, 26.646126607000028],
              [98.7555530190001, 26.625042623000084],
              [98.74852502400012, 26.6059740190001],
              [98.72795780400003, 26.57259104500004],
              [98.72113651600006, 26.538898011000086],
              [98.7172091060001, 26.408725077000028],
              [98.7134884030001, 26.389449768000063],
              [98.70739058400011, 26.371052959000068],
              [98.6976754150001, 26.35405141200006],
              [98.65778120900006, 26.31162506100013],
              [98.64951298000011, 26.290592753000013],
              [98.64455204300003, 26.271575827000035],
              [98.6421749270001, 26.25452260400003],
              [98.64816939300005, 26.244807434000066],
              [98.66821984900008, 26.248218079000097],
              [98.67700484200009, 26.239329733000076],
              [98.70149947100003, 26.191167298],
              [98.7055302330001, 26.174940898000088],
              [98.70025923700007, 26.16532908200007],
              [98.69240441900007, 26.159954732000116],
              [98.68651330600005, 26.15411529600003],
              [98.68672001200008, 26.133238017000068],
              [98.68082889800013, 26.12496978800003],
              [98.64444869000005, 26.097891337000064],
              [98.63080611200013, 26.096909485000097],
              [98.62429488100014, 26.108485006000038],
              [98.62574182200012, 26.144348450000066],
              [98.61933394400012, 26.145743714000062],
              [98.60217736800013, 26.13995595300007],
              [98.5630066330001, 26.131222636000118],
              [98.55019087800008, 26.12078399700006],
              [98.54553999900003, 26.105642803000066],
              [98.54729699800004, 26.088279521000047],
              [98.5538082280001, 26.071071269000058],
              [98.5726184500001, 26.035569560000013],
              [98.57716597500013, 26.01732778000006],
              [98.57540897700005, 25.99510691300013],
              [98.5824369720001, 25.98229115900004],
              [98.59246219900007, 25.98074086500013],
              [98.6042444260001, 25.982497864],
              [98.61623335800004, 25.979397278000064],
              [98.62532841000012, 25.969992168000104],
              [98.65809126800013, 25.925033671000094],
              [98.66728967300003, 25.905758362000043],
              [98.67235396300009, 25.90183095400009],
              [98.68465295400006, 25.897593486000048],
              [98.68982059800004, 25.8915990200001],
              [98.69240441900007, 25.87898997100008],
              [98.69023400900005, 25.86555409700013],
              [98.68485966000003, 25.853100078000054],
              [98.6778316650001, 25.843281555000075],
              [98.62605188000003, 25.806487936000067],
              [98.61003218700006, 25.800596822000088],
              [98.60031701600013, 25.801733704000085],
              [98.59091190600009, 25.806384583000053],
              [98.56238651600012, 25.816358135000073],
              [98.53954553200003, 25.833721415000085],
              [98.52683313100005, 25.838785706000053],
              [98.50946984900003, 25.838062236000056],
              [98.49810103400006, 25.830724183000072],
              [98.47453658000006, 25.80576446500008],
              [98.46130741400009, 25.79465403300007],
              [98.45262577300008, 25.777962545000022],
              [98.43929325400006, 25.7435977170001],
              [98.43226525900008, 25.736104635000046],
              [98.42472050000003, 25.730833639000124],
              [98.41872603400009, 25.724219056000024],
              [98.41665897600012, 25.712591859000057],
              [98.41634891800004, 25.700189514],
              [98.41324833200008, 25.69207631400009],
              [98.37521447800009, 25.649288229000078],
              [98.36984012900012, 25.636782532000055],
              [98.35723107900009, 25.592754212],
              [98.34710249800003, 25.577819723000047],
              [98.3326330970001, 25.566967672000104],
              [98.31206587700012, 25.55745920800011],
              [98.28943160000006, 25.550379538000087],
              [98.2766158450001, 25.552446594000045],
              [98.24716027900007, 25.579163310000112],
              [98.23238081900007, 25.586553040000027],
              [98.15021529100005, 25.613063050000036],
              [98.1400867110001, 25.611461080000097],
              [98.13843306500013, 25.598955384000092],
              [98.13936324100007, 25.550224508000056],
              [98.13419559800008, 25.534618225000102],
              [98.12303348900014, 25.522215882000054],
              [98.10463667800013, 25.506764628000056],
              [98.09977909300005, 25.50004669200011],
              [98.09946903500003, 25.493328756],
              [98.10474003100006, 25.466973775000028],
              [98.10887414600012, 25.458240459000066],
              [98.11197473100003, 25.448473613000104],
              [98.11021773300007, 25.410439759000056],
              [98.11207808500006, 25.396228739000023],
              [98.10835738100008, 25.388890686000096],
              [98.08996057100006, 25.385945129],
              [98.0756978760001, 25.376074932000037],
              [98.06257206300012, 25.35431915300002],
              [98.04489872300013, 25.311944479000104],
              [98.03352990700012, 25.301299134000104],
              [97.99239546700005, 25.28248891200009],
              [97.97627242100009, 25.27225697900012],
              [97.93079716000011, 25.218513489000102],
              [97.90991988100006, 25.20755808500006],
              [97.88893925000013, 25.205646057000124],
              [97.87881066900007, 25.213552551000063],
              [97.87178267400009, 25.227660217],
              [97.86031050700007, 25.244093323000058],
              [97.82362023900009, 25.26161163300013],
              [97.80098596300013, 25.237633769000112],
              [97.77700809800012, 25.15862050400004],
              [97.7540637620001, 25.11355865500009],
              [97.73752730300009, 25.090510967000043],
              [97.72161096200006, 25.079271342000098],
              [97.7036275640001, 25.073922831000047],
              [97.69959680200009, 25.065008647000113],
              [97.70517785700014, 25.02883514400007],
              [97.70331750500003, 24.960415548000086],
              [97.70827844300004, 24.927290955],
              [97.72409143100003, 24.897215272000025],
              [97.76098840300006, 24.870291850000015],
              [97.77297733600005, 24.85468556800008],
              [97.76522587100004, 24.834660950000043],
              [97.74848270700011, 24.826470235],
              [97.72657190000012, 24.826289368000047],
              [97.68595422400011, 24.833524068000102],
              [97.66394006400003, 24.829777527000104],
              [97.6425460210001, 24.816780904000055],
              [97.60399540200012, 24.78644683900002],
              [97.5361959230001, 24.745079854],
              [97.53609257000005, 24.745028178000084],
              [97.53278527800006, 24.723324077000072],
              [97.53857303900003, 24.597259420000015],
              [97.51387170400005, 24.46168629900008],
              [97.51325158700007, 24.438586935],
              [97.51955611200009, 24.430783794],
              [97.60068811000014, 24.44192006400003],
              [97.62435591600007, 24.442281799000014],
              [97.6398588460001, 24.439284567000087],
              [97.6473002520001, 24.432334086000097],
              [97.65226119000005, 24.422722270000108],
              [97.6554651290001, 24.412076925000108],
              [97.65732548000011, 24.402000020000074],
              [97.66259647700014, 24.390062765000025],
              [97.68099328600005, 24.377763774000087],
              [97.68833134000005, 24.36771270800004],
              [97.68957157400007, 24.346473694000068],
              [97.67427535100012, 24.340840963000048],
              [97.65360477700011, 24.338722229000084],
              [97.63820520100012, 24.328102722],
              [97.64450972500003, 24.302393698000103],
              [97.71840702300011, 24.277666524],
              [97.72409143100003, 24.241518860000056],
              [97.71851037600004, 24.233974101000015],
              [97.71117232300003, 24.228470561000037],
              [97.70466109300008, 24.221726786000076],
              [97.70156050600013, 24.210926412000063],
              [97.70455774000004, 24.19924753800008],
              [97.71871708200007, 24.181548361000083],
              [97.72305790200005, 24.171264751000066],
              [97.72006066900008, 24.1474419150001],
              [97.70765832500007, 24.12529856400009],
              [97.51645552600013, 23.942829081000113],
              [97.53299198400003, 23.92370880200012],
              [97.5726794840001, 23.907559916000125],
              [97.60988651500003, 23.88314280200008],
              [97.61546757000013, 23.875132955000097],
              [97.61970503700007, 23.865986226000032],
              [97.62466597500003, 23.846710918],
              [97.63706831900004, 23.86355743500006],
              [97.64734483100005, 23.868524415000067],
              [97.65567183400009, 23.87254913300002],
              [97.67696252500014, 23.878698629000084],
              [97.69680627400004, 23.887121887000077],
              [97.74817264900008, 23.93406992600002],
              [97.76780969300012, 23.946472270000086],
              [97.78951379400013, 23.95313853],
              [97.8040865480001, 23.954507955000068],
              [97.81783247900012, 23.95815114400007],
              [97.83633264200006, 23.971767883000084],
              [97.87664025900011, 24.014400940000044],
              [97.88997277800013, 24.022617493],
              [98.10505009000008, 24.101527405000027],
              [98.18153120900013, 24.118658142000086],
              [98.21915165200005, 24.117366231000048],
              [98.2932556560001, 24.10013214100006],
              [98.33066939300005, 24.099486186000078],
              [98.3473092050001, 24.10493804900007],
              [98.37872847500012, 24.122404684000102],
              [98.39557499200009, 24.128063253000036],
              [98.43495243300009, 24.130259501000026],
              [98.47453658000006, 24.127830709000065],
              [98.50326867700005, 24.121267802000077],
              [98.54305953000005, 24.093956807000083],
              [98.57024133400006, 24.08209706600006],
              [98.58522749900004, 24.075715027000015],
              [98.59711307800006, 24.083078919000016],
              [98.61251265500005, 24.087548930000125],
              [98.64041792900014, 24.100752258000014],
              [98.68175907400007, 24.106875916],
              [98.7161755780001, 24.12134531700012],
              [98.8180815020001, 24.12896759100009],
              [98.85528853400012, 24.13896698000009],
              [98.86572717300004, 24.145684917000025],
              [98.86696740800011, 24.143256124000075],
              [98.87347863800005, 24.11449819000005],
              [98.85621871000006, 24.083802388000024],
              [98.76557824800005, 24.02706166600008],
              [98.71679569500009, 23.988407695],
              [98.69922570900007, 23.981560568000035],
              [98.67989872200008, 23.976263733000096],
              [98.66325891200012, 23.969545797000066],
              [98.65881473800005, 23.961122539000073],
              [98.6657393800001, 23.953216045000133],
              [98.6745243740001, 23.936886292000096],
              [98.67297408100006, 23.928308004000073],
              [98.66480920400005, 23.9033741250001],
              [98.66418908700007, 23.89037750200005],
              [98.67142378700004, 23.816738587000046],
              [98.66832320200012, 23.808702902000064],
              [98.66356897000003, 23.803070171000044],
              [98.66367232300013, 23.796946513000066],
              [98.67566125500008, 23.787386373000075],
              [98.68496301300013, 23.784802551000084],
              [98.70832076000005, 23.78469919800004],
              [98.73839644400005, 23.77555247000005],
              [98.77787723800009, 23.76929962100006],
              [98.79317346200003, 23.758473409000104],
              [98.79906457500005, 23.743228862000066],
              [98.80030481000006, 23.69271514900005],
              [98.80795292200003, 23.67579111800005],
              [98.84960412600009, 23.614735413000076],
              [98.85601200400009, 23.610007020000083],
              [98.85735559100004, 23.604348450000046],
              [98.85022424400012, 23.590628357000114],
              [98.84329960100007, 23.5840137740001],
              [98.7962740480001, 23.557917175000043],
              [98.78438846900013, 23.54703928700006],
              [98.78087447100006, 23.532854106000016],
              [98.7999947510001, 23.48073842400005],
              [98.80981327300003, 23.474098002000048],
              [98.83007043500004, 23.480014954000055],
              [98.84888065700005, 23.480402527000066],
              [98.86397017400009, 23.46660491900012],
              [98.87554569500003, 23.44642527300003],
              [98.88960168400013, 23.406789449000073],
              [98.89228886000006, 23.386894023000067],
              [98.89011844900006, 23.3679029340001],
              [98.88185022000005, 23.34968699200006],
              [98.87378869600013, 23.344571025000064],
              [98.86210982300008, 23.340591940000067],
              [98.85322147600004, 23.334985047000046],
              [98.85342818200007, 23.3248823040001],
              [98.86045617700012, 23.322375997000037],
              [98.89652632700012, 23.323280335000064],
              [98.91068566900009, 23.297597148000094],
              [98.86014611800005, 23.212279358000032],
              [98.85900923700012, 23.179387309000063],
              [98.93342330000013, 23.172152608000104],
              [98.9707336840001, 23.162204895000016],
              [98.99037072800013, 23.160034485000025],
              [99.00938765500007, 23.162153218000086],
              [99.02644087800013, 23.160447897000026],
              [99.03315881300006, 23.146417745000022],
              [99.0392566330001, 23.127142436000085],
              [99.05506962100009, 23.109598287000026],
              [99.0749133710001, 23.10166595500006],
              [99.09217329900008, 23.101510926000017],
              [99.13000044800003, 23.10623931900001],
              [99.1386820890001, 23.105205790000028],
              [99.16400354000007, 23.09768687000009],
              [99.17867964700008, 23.09642079700005],
              [99.18271040800005, 23.095206401],
              [99.18488081900006, 23.0948446660001],
              [99.1941825770001, 23.09577484200007],
              [99.1993502200001, 23.09226084400011],
              [99.19966027900006, 23.073838196000096],
              [99.20214074800003, 23.067275289000023],
              [99.20958215400009, 23.061539206000063],
              [99.21661014900008, 23.057379252000132],
              [99.22487837700004, 23.056888327000095],
              [99.23614384000007, 23.062314352000058],
              [99.25743452900008, 23.07921254500006],
              [99.26673628800012, 23.08386342400003],
              [99.28482303900012, 23.088152568000098],
              [99.29402144400012, 23.096782532000034],
              [99.30218632100014, 23.112595520000028],
              [99.31407189900006, 23.126470642000086],
              [99.33381229700012, 23.129622904000044],
              [99.35096887200007, 23.11926178000003],
              [99.38104455600006, 23.08164133800001],
              [99.40326542100007, 23.068334656],
              [99.47819624900006, 23.0657508340001],
              [99.49307906100012, 23.057379252000132],
              [99.49504276500005, 23.043478292000046],
              [99.49163212100012, 23.028207906000105],
              [99.49039188700004, 23.0120073450001],
              [99.49876346900004, 22.99516082800004],
              [99.53462691200008, 22.949323832000076],
              [99.53803755700011, 22.92643117300004],
              [99.51529992700006, 22.90880951000007],
              [99.48450077400008, 22.910256450000063],
              [99.42993046000004, 22.936740622000045],
              [99.41339400300006, 22.930746155000023],
              [99.41122359200006, 22.919248149000097],
              [99.416908, 22.874341330000092],
              [99.41442753200005, 22.856900533000058],
              [99.40357548100008, 22.841061707000065],
              [99.37887414600004, 22.813233948000075],
              [99.3590303960001, 22.77489003500007],
              [99.3506588140001, 22.76814626100004],
              [99.33846317600006, 22.764916484000068],
              [99.32719771300003, 22.76049814900007],
              [99.31696578000003, 22.754116109000037],
              [99.30797408000012, 22.745176087000104],
              [99.30787072800007, 22.719596252000045],
              [99.35499963400008, 22.60854360000006],
              [99.35737675000013, 22.587097881000048],
              [99.34704146400003, 22.55335317000008],
              [99.34414758300005, 22.533251038000017],
              [99.34662805200003, 22.523070781000044],
              [99.35634322100003, 22.50617258700005],
              [99.35779016200013, 22.495475566000053],
              [99.35344934100004, 22.484106751000056],
              [99.3450777590001, 22.472841288],
              [99.28275598100004, 22.411914775000056],
              [99.24306848200007, 22.39315623000006],
              [99.23738407400003, 22.38013376900001],
              [99.24058801300009, 22.372950745000068],
              [99.24637577300007, 22.365922750000053],
              [99.2483394780001, 22.353675435000028],
              [99.24368859900005, 22.34122141600004],
              [99.22570520000005, 22.321222637000105],
              [99.21836714700004, 22.310008851000063],
              [99.20617150900006, 22.261329651000025],
              [99.1993502200001, 22.245258281000062],
              [99.16638065600006, 22.204640605000023],
              [99.15935266100013, 22.184693502000115],
              [99.17506229700007, 22.168673808000065],
              [99.14446984900007, 22.153532613000053],
              [99.16638065600006, 22.13208689400001],
              [99.2122693280001, 22.112449849000072],
              [99.25288700400006, 22.102786357000056],
              [99.32998824100008, 22.095551656000097],
              [99.36492150900006, 22.098858948],
              [99.42496952300007, 22.12242340100009],
              [99.43861210200009, 22.12423207600007],
              [99.49039188700004, 22.104336650000064],
              [99.50506799400006, 22.103354798000012],
              [99.53896773300005, 22.106713766000027],
              [99.63353560400009, 22.084751282000056],
              [99.64221724500004, 22.079945374000047],
              [99.65007206200005, 22.071935527000065],
              [99.65927046800005, 22.054572245000045],
              [99.66381799300007, 22.04873280900007],
              [99.68386844900004, 22.039017639000022],
              [99.69379032400013, 22.046924133000076],
              [99.70381555200004, 22.061238505000077],
              [99.72365930200004, 22.07059194000003],
              [99.73916223200007, 22.066767884000072],
              [99.79988204000006, 22.037467347000117],
              [99.80747847600003, 22.03095611600004],
              [99.81342126500004, 22.022997946000075],
              [99.82101770100007, 22.017778626000066],
              [99.83367842700005, 22.01948394800003],
              [99.84173995000003, 22.027080384000087],
              [99.84230839000008, 22.047027486],
              [99.84783776900008, 22.055037333000072],
              [99.86685469600008, 22.057879537000062],
              [99.94240564000006, 22.04552886900011],
              [99.93491255700013, 22.03250640900005],
              [99.93434411600009, 22.018863831000047],
              [99.9398218180001, 22.005893046000025],
              [99.95046716400009, 21.995351054000068],
              [99.96566003400011, 21.963001608000084],
              [99.95527307100008, 21.924554342000036],
              [99.92018477400006, 21.852000631000024],
              [99.91796268700006, 21.8291596480001],
              [99.92209680200006, 21.812261455000012],
              [99.93920170100012, 21.77701812800005],
              [99.95026045800012, 21.72115590400007],
              [99.96069909700003, 21.70477447500012],
              [99.99671757100003, 21.686119283000053],
              [100.08234541900003, 21.684465638000106],
              [100.12053430200007, 21.673665263000075],
              [100.13515873200004, 21.662348124000076],
              [100.14280684400012, 21.654906718000078],
              [100.14632084200008, 21.649222310000127],
              [100.14373702000006, 21.640023906000025],
              [100.13619226100013, 21.63681996700005],
              [100.12611535700012, 21.6348562620001],
              [100.11572839400009, 21.629481914000067],
              [100.10394616700006, 21.615632629000103],
              [100.0948511150001, 21.59883778900003],
              [100.08864994300012, 21.581836243000012],
              [100.08560103400009, 21.567573548000027],
              [100.08606612200003, 21.550933737000022],
              [100.08999353000007, 21.528919577000025],
              [100.09727990800008, 21.508300680000033],
              [100.1077702230001, 21.49553660100007],
              [100.12833744300008, 21.482359110000075],
              [100.16249556500009, 21.43636708600009],
              [100.18714522300007, 21.427892151],
              [100.19789392100012, 21.433214824000046],
              [100.23024336800012, 21.45683095300005],
              [100.24409265100007, 21.464530742000036],
              [100.27520186400011, 21.475176087000037],
              [100.28951623500012, 21.483134258000078],
              [100.30228031400009, 21.495329896],
              [100.30248702000011, 21.49553660100007],
              [100.31463098200004, 21.512951559],
              [100.32651656100006, 21.524268698000057],
              [100.34196781400004, 21.53036651700002],
              [100.36325850400004, 21.53176178000011],
              [100.38367069500009, 21.527834371000054],
              [100.39912194900006, 21.518894348000018],
              [100.42930098500005, 21.495381572000028],
              [100.43426192300012, 21.478380026000096],
              [100.44346032800013, 21.463497213000053],
              [100.45668949400005, 21.455022278000044],
              [100.4742594810001, 21.45683095300005],
              [100.49710046400003, 21.4617918900001],
              [100.5459863690001, 21.453006897000094],
              [100.57182458500012, 21.45507395500006],
              [100.62174401800007, 21.469078268000075],
              [100.64577356000007, 21.479878642000116],
              [100.66132816600003, 21.495329896],
              [100.66153487100007, 21.49553660100007],
              [100.70396122300008, 21.51641387900004],
              [100.75661950700004, 21.569847310000043],
              [100.79703047700008, 21.626122946000052],
              [100.83490930200009, 21.657542217000085],
              [100.87749068200003, 21.677334290000047],
              [100.97428064000007, 21.704154358000054],
              [100.99278080300007, 21.71144073500004],
              [101.04290694200012, 21.745392152000065],
              [101.05530928600007, 21.754538880000027],
              [101.06869348200013, 21.76203196200008],
              [101.08280114800004, 21.766734518000064],
              [101.11887129800004, 21.759809876000062],
              [101.12486576400005, 21.74415191700011],
              [101.12765629100005, 21.695162659000104],
              [101.13633793100007, 21.684724019000058],
              [101.14925704000007, 21.676765849],
              [101.1614526780001, 21.65836903900002],
              [101.1688424080001, 21.637853496000034],
              [101.16672367300004, 21.623280742000063],
              [101.17385502100007, 21.611911926000076],
              [101.16765384900009, 21.600181376000094],
              [101.1577319750001, 21.586228740000095],
              [101.15421797700003, 21.568038635000065],
              [101.15902388500007, 21.5526907350001],
              [101.16114261900003, 21.53470733600001],
              [101.15711185700013, 21.519669495000116],
              [101.14315922100013, 21.513416647000028],
              [101.00342614800007, 21.40598134400004],
              [100.90994348200007, 21.36009267200005],
              [100.89604252200007, 21.355751851],
              [100.86245284000006, 21.323299052000053],
              [100.85134240700006, 21.314772441000045],
              [100.81460046400008, 21.300199687000074],
              [100.79196618700013, 21.297357483000027],
              [100.77258752500006, 21.30423044800007],
              [100.76499108900009, 21.309191386000023],
              [100.75667118400003, 21.312447001000024],
              [100.7477311610001, 21.314255676000116],
              [100.73837772700006, 21.314772441000045],
              [100.72540694200012, 21.311671855],
              [100.72199629800008, 21.303662008000046],
              [100.72256473800007, 21.29270660400006],
              [100.72106612200014, 21.28066599600008],
              [100.68938846900005, 21.159329732000018],
              [100.63755700700005, 21.06967112200006],
              [100.62551639800012, 21.054116517000026],
              [100.60675785300009, 21.043936259000063],
              [100.56185103400009, 21.03509958900007],
              [100.54345422400007, 21.027399801000072],
              [100.55575321500004, 20.99985626300007],
              [100.55725183100003, 20.992001445000042],
              [100.5519808360001, 20.98533518500004],
              [100.53327396700013, 20.973449605000027],
              [100.52924320500006, 20.968436992000036],
              [100.52707279500004, 20.946939596],
              [100.51782271400003, 20.90632192000008],
              [100.51570397900014, 20.886478170000075],
              [100.53420414300007, 20.873920797000054],
              [100.62308760600013, 20.88854522700005],
              [100.65212976100003, 20.882757467000076],
              [100.65212976100003, 20.876607971000098],
              [100.6266016030001, 20.853508606000034],
              [100.60777574500003, 20.83988093300009],
              [100.59890303500003, 20.833458151000073],
              [100.56903405800006, 20.817800191000018],
              [100.53668461100006, 20.80767161100006],
              [100.51337854000013, 20.80699981700009],
              [100.47084883600007, 20.818265279000045],
              [100.38367069500009, 20.831701151000104],
              [100.36480879700014, 20.828187154000133],
              [100.35111454300005, 20.81531972300006],
              [100.34196781400004, 20.799506734000047],
              [100.32966882300008, 20.786019185000086],
              [100.29018802900009, 20.77501210600009],
              [100.27453007000003, 20.761989645000043],
              [100.24874353000013, 20.73196563800009],
              [100.22161340400004, 20.709589743000024],
              [100.21132979400005, 20.69739410400011],
              [100.20719567900005, 20.680754293000078],
              [100.20233809500013, 20.667938538],
              [100.18016890500007, 20.63817291300002],
              [100.17293420500005, 20.62210154200004],
              [100.17293420500005, 20.609079082],
              [100.16006677300004, 20.582672424000023],
              [100.14926639800007, 20.548100891000033],
              [100.13665734900007, 20.459217427000098],
              [100.12740726700014, 20.42784983400007],
              [100.12523685800005, 20.40640411400004],
              [100.12094771400007, 20.38878245000005],
              [100.11112919100003, 20.37482981400005],
              [100.09981205300005, 20.362220764000128],
              [100.0970732020001, 20.348371481000058],
              [100.09764164300009, 20.334935608000123],
              [100.09929528800012, 20.317804870000074],
              [100.0554736740001, 20.34418569000003],
              [100.0476188560001, 20.355244446000043],
              [100.04265791800003, 20.364778748000035],
              [100.03614668800003, 20.373124492],
              [100.02291752200006, 20.380772603000068],
              [100.00844812100013, 20.38358896900003],
              [99.99671757100003, 20.3835114540001],
              [99.98591719600012, 20.38702545200006],
              [99.97434167500006, 20.400823059000018],
              [99.96472985900004, 20.408626201000047],
              [99.96111250900009, 20.417824606000053],
              [99.95878706900004, 20.42748809800007],
              [99.95237919200008, 20.436273092000064],
              [99.9420439050001, 20.44402455700005],
              [99.93713464400014, 20.44500640900013],
              [99.93248376500009, 20.442732646000096],
              [99.87791345300008, 20.43513621000004],
              [99.85569258600003, 20.428056539000025],
              [99.83770918800013, 20.41684275300007],
              [99.82634037300005, 20.401391500000088],
              [99.81300785400003, 20.36526967300007],
              [99.80401615400007, 20.34899159700005],
              [99.78716963700003, 20.334082947000084],
              [99.76959965100014, 20.328424377000047],
              [99.72908532700012, 20.32852773100008],
              [99.70841475500004, 20.325013733000034],
              [99.67125940000011, 20.310130920000077],
              [99.65193241400004, 20.30682362900008],
              [99.64221724500004, 20.30883901000003],
              [99.62702437400009, 20.31876088500003],
              [99.61803267400006, 20.3223782350001],
              [99.60759403500003, 20.32315338200003],
              [99.58930057800006, 20.320776266000067],
              [99.57968876200005, 20.321241354],
              [99.50289758300005, 20.34521921800011],
              [99.45411503200012, 20.377103577000085],
              [99.43995568900004, 20.382167867000064],
              [99.42062870300003, 20.37555328400005],
              [99.42962040200007, 20.358680929000073],
              [99.46641402200004, 20.322171530000062],
              [99.47499231000006, 20.303723043000033],
              [99.48625777200004, 20.245483704000023],
              [99.51891727700013, 20.212178243000054],
              [99.52584191900007, 20.196184387000116],
              [99.5205709230001, 20.17096628800006],
              [99.5103389890001, 20.153809713],
              [99.50873365500013, 20.15280450400006],
              [99.49928023300009, 20.14688507100003],
              [99.48749800600007, 20.141252340000094],
              [99.47447554500013, 20.128074850000118],
              [99.44140262900004, 20.10161651600002],
              [99.32120324700003, 20.066269837000036],
              [99.29567509000009, 20.062497457000106],
              [99.27531457500004, 20.072186788000025],
              [99.2364538980001, 20.10272756000002],
              [99.21898726500012, 20.110453187000033],
              [99.17774947100003, 20.121796163000013],
              [99.15842248500007, 20.12355316200008],
              [99.11749475100004, 20.117791240000102],
              [99.0734664310001, 20.101228943000123],
              [99.03646610500004, 20.075158183000028],
              [99.01682906100012, 20.041000061000048],
              [99.00587365800004, 19.972347921],
              [99.00701053900013, 19.962451884000117],
              [99.0127983000001, 19.944235942000077],
              [99.01352176900008, 19.934960022000055],
              [99.0109379480001, 19.930205790000045],
              [99.00618371600012, 19.924934795000027],
              [99.00142948400003, 19.917880961000023],
              [98.99936242700005, 19.90772654200005],
              [99.00266971900004, 19.883593649000076],
              [99.00763065600012, 19.864886780000106],
              [99.0087675370001, 19.84592153000004],
              [99.00091272000009, 19.821013489000094],
              [98.98768355400006, 19.799361064],
              [98.97383426900012, 19.788069764000042],
              [98.9350769450001, 19.77347117200007],
              [98.89931685400006, 19.748614808000113],
              [98.88371057200004, 19.745462545000052],
              [98.86448693900013, 19.773212789000084],
              [98.8518778890001, 19.78403900100004],
              [98.8379252530001, 19.793444112000103],
              [98.80784956900004, 19.806544088000052],
              [98.74924849500007, 19.763497620000052],
              [98.7301282150001, 19.757296448000076],
              [98.64134810500008, 19.744945781000112],
              [98.62377811700003, 19.737504375000086],
              [98.61540653500003, 19.7297787480001],
              [98.59835331300008, 19.709082336000066],
              [98.5907052010001, 19.704095561000102],
              [98.56827762900014, 19.69998728500009],
              [98.54833052600003, 19.69264923100009],
              [98.5379952400001, 19.683890076000026],
              [98.5365483000001, 19.677094625000066],
              [98.53262089000003, 19.675854390000055],
              [98.51546431500009, 19.683373312000086],
              [98.50512902900005, 19.69151235],
              [98.49758426900013, 19.7007107540001],
              [98.48879927600012, 19.706705220000018],
              [98.47780068600014, 19.70562927200008],
              [98.47453658000006, 19.70530995700004],
              [98.43960331200009, 19.687739970000067],
              [98.39443811100011, 19.6863447060001],
              [98.34761926300007, 19.690633851000072],
              [98.30731164500003, 19.689987895000073],
              [98.26276656200014, 19.669859924000022],
              [98.23754846200006, 19.66469228100003],
              [98.21915165200005, 19.676991272000052],
              [98.21667118300007, 19.687455750000098],
              [98.21791141800003, 19.707971293000057],
              [98.21326053900009, 19.717763978000036],
              [98.20592248500009, 19.721484681000035],
              [98.17202274600004, 19.73156158400009],
              [98.13223189300004, 19.766055603000055],
              [98.1113546150001, 19.777140198000055],
              [98.0859298100001, 19.773161112000068],
              [98.07290734900005, 19.777295227000096],
              [98.06060835800008, 19.7939092000001],
              [98.04562219200011, 19.807629293000062],
              [98.02453820800008, 19.802978414000094],
              [98.0179236240001, 19.78938751300008],
              [98.00459110500009, 19.723913473],
              [98.00562463400007, 19.705645854000053],
              [98.01389286300008, 19.669446513000096],
              [98.01358280500011, 19.651747335],
              [98.00831180900008, 19.639112447000073],
              [98.00014693200006, 19.6362960820001],
              [97.99043176300012, 19.63655446400007],
              [97.97947636000004, 19.633324686],
              [97.97069136600004, 19.62593495700007],
              [97.95611861200007, 19.60937266000009],
              [97.94805708900003, 19.60242218100008],
              [97.88583866400012, 19.572811585000053],
              [97.86912302100012, 19.570489968000075],
              [97.84863163300008, 19.567643942000032],
              [97.83984663900003, 19.555319113000095],
              [97.83891646300003, 19.537103170000037],
              [97.84098352100011, 19.51715606700013],
              [97.8442908130001, 19.50452118],
              [97.84811486900003, 19.499560242000044],
              [97.84873498500014, 19.493979187000022],
              [97.84212040300014, 19.479380595000052],
              [97.83354211500011, 19.468709412000052],
              [97.8003658450001, 19.440778300000076],
              [97.76708622200005, 19.39752512600002],
              [97.76770634000007, 19.390367941000065],
              [97.77514774600013, 19.371066793000026],
              [97.77669803900005, 19.361093242000024],
              [97.78310591700011, 19.337089539000104],
              [97.79705855300006, 19.318382671],
              [97.80615360600007, 19.3010969030001],
              [97.79829878700014, 19.281408183000067],
              [97.78868697100012, 19.277739156000067],
              [97.77731815600004, 19.27861765500002],
              [97.7680163980001, 19.277119040000102],
              [97.76408899000012, 19.266396179000097],
              [97.76967004500005, 19.25727528900002],
              [97.79633508300009, 19.236682231000103],
              [97.80522343000007, 19.227354635000083],
              [97.81256148300008, 19.208466899000044],
              [97.81514530400011, 19.190561015000085],
              [97.81080448500012, 19.112219543],
              [97.8040865480001, 19.097956848000123],
              [97.78992720500003, 19.082583109000055],
              [97.72781213400009, 19.037082011000095],
              [97.71696008300012, 19.018323466000098],
              [97.71044885300006, 18.979902039000038],
              [97.70331750500003, 18.964373271000042],
              [97.68905481000013, 18.949748841000044],
              [97.66807417800004, 18.93543446900007],
              [97.65784224500004, 18.925719299000022],
              [97.66187300600006, 18.913782044000087],
              [97.68440393100008, 18.892491353000096],
              [97.70858850100007, 18.875205587],
              [97.71913049400013, 18.864637756000022],
              [97.72336796100006, 18.8519770300001],
              [97.7194405520001, 18.82588043200009],
              [97.72037072800003, 18.817638041000052],
              [97.73266971900006, 18.78050852500006],
              [97.73577030500013, 18.76265431800003],
              [97.73628706900007, 18.74058848100013],
              [97.74124800600003, 18.703148906000067],
              [97.75261682100012, 18.663435567000064],
              [97.75974816900003, 18.622792054000016],
              [97.7517899990001, 18.582484437000076],
              [97.74569218000005, 18.571063945000063],
              [97.74279829900013, 18.569255270000085],
              [97.7379407140001, 18.570495504000107],
              [97.6902950440001, 18.55788645400007],
              [97.63737837800011, 18.559281718000065],
              [97.61794803900011, 18.553158061000104],
              [97.54839156100013, 18.509078064000036],
              [97.50953088400007, 18.491275533000092],
              [97.46281538900007, 18.492464091],
              [97.43811405500003, 18.48812327100002],
              [97.42746871000008, 18.489518535000016],
              [97.41661665900011, 18.496029765000074],
              [97.4121724850001, 18.503031921000073],
              [97.40938195800004, 18.51135182700004],
              [97.38891809100011, 18.54222849600002],
              [97.3801330980001, 18.547757874000027],
              [97.37289883000005, 18.548616618000025],
              [97.35140100100011, 18.551168519000058],
              [97.35760217300009, 18.539903056000085],
              [97.37909956900012, 18.520782776000104],
              [97.39046838400003, 18.50181752500005],
              [97.39460249900003, 18.487089742000038],
              [97.4176501880001, 18.441149394000078],
              [97.4430749920001, 18.403348084000086],
              [97.44648563700014, 18.381178894000058],
              [97.4467956950001, 18.35831207300005],
              [97.45258345600007, 18.333610738000047],
              [97.46653609200007, 18.311441549000037],
              [97.48648319500012, 18.292140401000083],
              [97.50808394400008, 18.27655995700006],
              [97.5283411050001, 18.265320333000076],
              [97.53764286300009, 18.272580872000063],
              [97.54198368400006, 18.280228983000043],
              [97.56058719900005, 18.328262227],
              [97.56244755100005, 18.330510153000105],
              [97.57381636600013, 18.333093974000107],
              [97.62466597500003, 18.313405253000056],
              [97.63758508300003, 18.306325582000042],
              [97.64378625500012, 18.291313578000043],
              [97.64326949100007, 18.273020121000073],
              [97.63572473200003, 18.25759470700008],
              [97.62073856600006, 18.25108347600012],
              [97.61794803900011, 18.241678365000055],
              [97.62900679600011, 18.220852763000025],
              [97.68037317000005, 18.15263987200008],
              [97.68430057800003, 18.146102804000108],
              [97.68533410700013, 18.140160014000074],
              [97.68533410700013, 18.13160756400005],
              [97.6875045160001, 18.11982533800007],
              [97.69680627400004, 18.101583558000087],
              [97.69908003800003, 18.090653992000043],
              [97.69804650900005, 18.084659525000106],
              [97.69370568900007, 18.075125224000104],
              [97.69277551300013, 18.070112610000066],
              [97.69422245300012, 18.061508484000015],
              [97.6977364500001, 18.060733338000105],
              [97.7021806240001, 18.061844381000114],
              [97.70641809100005, 18.059286398000026],
              [97.72006066900008, 18.05305938700012],
              [97.72212772600011, 18.04892527300008],
              [97.72522831300006, 18.0367554730001],
              [97.73980106600004, 18.002933248000105],
              [97.7440385330001, 17.9978172820001],
              [97.74724247300003, 17.992494609000076],
              [97.7517899990001, 17.980764058000076],
              [97.7540637620001, 17.969033508000095],
              [97.75085982300004, 17.963659160000034],
              [97.74755253100005, 17.960920309000088],
              [97.72006066900008, 17.943195293000073],
              [97.69184533700007, 17.89560129800013],
              [97.6855408130001, 17.880718486000077],
              [97.69908003800003, 17.83333119800001],
              [97.67613570200012, 17.830333964000104],
              [97.68399052000007, 17.81653635700006],
              [97.69649621600007, 17.80656280600006],
              [97.70652144400009, 17.79472890200013],
              [97.71117232300003, 17.78129303000007],
              [97.71685673100006, 17.76976918600006],
              [97.74104130100005, 17.750183818000025],
              [97.74961958800009, 17.73984853200001],
              [97.75158329300012, 17.729564922000023],
              [97.7517899990001, 17.718092753000107],
              [97.75313358600005, 17.705380351000045],
              [97.75933475800014, 17.691479391000072],
              [97.76894657400004, 17.679180399000032],
              [97.90799443000009, 17.55486551400007],
              [97.93379439300003, 17.531799215000078],
              [97.94857385300003, 17.522394104000043],
              [97.97224165900008, 17.511697083000044],
              [97.98278365100003, 17.505444234000024],
              [97.99167199800007, 17.495729065000077],
              [97.99611617000005, 17.480794576000036],
              [98.01823368400005, 17.44741160100007],
              [98.0285689700001, 17.418782858000085],
              [98.03549361200004, 17.40503692700004],
              [98.04872277900006, 17.391549378],
              [98.06226200400005, 17.38483144100006],
              [98.07683475700009, 17.38002553300005],
              [98.08872033700004, 17.37279083300008],
              [98.09471480300004, 17.358631490000036],
              [98.09409468600006, 17.346332500000088],
              [98.0904773360001, 17.32524851500007],
              [98.09264774600007, 17.31222605400002],
              [98.10060591700005, 17.302614238000032],
              [98.18618208800012, 17.224221090000114],
              [98.20178837100013, 17.215694479000106],
              [98.22101200400004, 17.200759990000037],
              [98.25625533100003, 17.151615702000086],
              [98.27899296100003, 17.13657786],
              [98.27082808400013, 17.127792867000025],
              [98.26617720500013, 17.116372376000115],
              [98.26834761600003, 17.107742411000075],
              [98.29439253800012, 17.107587382000034],
              [98.29532271400006, 17.09983591700002],
              [98.29015507000014, 17.090844218000072],
              [98.28622766100011, 17.08743357400006],
              [98.29966353400005, 17.06474762000009],
              [98.31330611100003, 17.05203521700004],
              [98.33066939300005, 17.04686757400013],
              [98.3797620040001, 17.045782370000026],
              [98.39991581200007, 17.040149638000102],
              [98.41789921100008, 17.029039205000075],
              [98.43619266800005, 17.01157257100003],
              [98.44673466000012, 16.996328023],
              [98.46368453000008, 16.963616841000103],
              [98.47453658000006, 16.950439352000032],
              [98.48042769400007, 16.937261862000057],
              [98.48073775200004, 16.92057037400012],
              [98.48445845500004, 16.905894267000022],
              [98.5000647380001, 16.898917949000023],
              [98.50946984900003, 16.89266510000003],
              [98.51598108000013, 16.878970846000115],
              [98.52455936700005, 16.85044545500007],
              [98.51195031700013, 16.859282125000064],
              [98.50058150300003, 16.86222768100005],
              [98.49251997900006, 16.85742177400006],
              [98.49003951000009, 16.8432107550001],
              [98.49438033100006, 16.831170146000105],
              [98.5033720300001, 16.826002503000026],
              [98.51319055200008, 16.82217844700007],
              [98.52052860500004, 16.8141169230001],
              [98.51753137200012, 16.803006490000072],
              [98.50543908700007, 16.790655823000023],
              [98.48921268700013, 16.780733948000105],
              [98.47453658000006, 16.776651509000104],
              [98.46254764800011, 16.760115052000017],
              [98.45469283100005, 16.74099477200012],
              [98.45665653500009, 16.72321807900009],
              [98.48631880700003, 16.700997213000065],
              [98.49138309700004, 16.689731750000092],
              [98.49841109200003, 16.66239491800006],
              [98.51226037600003, 16.64327463800008],
              [98.54709029100007, 16.620123596000084],
              [98.56155969200012, 16.60172678700009],
              [98.56579716000005, 16.591546529000098],
              [98.56776086400009, 16.582503154000065],
              [98.56734745300008, 16.57330474900006],
              [98.5640401610001, 16.562711080000085],
              [98.56424686700012, 16.55196238200007],
              [98.57044803900004, 16.54157541900004],
              [98.63163293400004, 16.463130595000038],
              [98.63979781100005, 16.44499216700008],
              [98.63824751800013, 16.434450176000027],
              [98.6282222910001, 16.413572896000048],
              [98.62946252500006, 16.402669170000095],
              [98.64238163200008, 16.37362701500011],
              [98.65695438600011, 16.301641744000037],
              [98.66325891200012, 16.286655579000083],
              [98.68237919200004, 16.273478089],
              [98.69839888600006, 16.284950256000016],
              [98.72826786400009, 16.32825510700009],
              [98.78862593600007, 16.37455719000006],
              [98.80206180900007, 16.398276673000012],
              [98.81043339100012, 16.439617819000134],
              [98.81870162000007, 16.45563751200008],
              [98.83957889800013, 16.47243235300006],
              [98.84340295400006, 16.438377584000094],
              [98.86210982300008, 16.420652568],
              [98.88526086500013, 16.406183167000066],
              [98.90252079300006, 16.381636862000093],
              [98.90334761600008, 16.363446757000034],
              [98.89342574100004, 16.319883525000094],
              [98.88867150900006, 16.27456329400009],
              [98.88371057200004, 16.258750305000078],
              [98.85559859200009, 16.22696929900006],
              [98.84309289600009, 16.208727519000107],
              [98.83668501900007, 16.189038799000045],
              [98.83472131400003, 16.167748108000055],
              [98.83544478300013, 16.14454539000006],
              [98.83079390500006, 16.135605367000025],
              [98.80722945200006, 16.110542298000027],
              [98.79844445800006, 16.104444479000065],
              [98.78304488100008, 16.102429098000115],
              [98.7760168860001, 16.106873270000037],
              [98.77033247900005, 16.113849589000026],
              [98.75844690000008, 16.119172262000077],
              [98.69715865100005, 16.126872051000063],
              [98.67958866400005, 16.126148580000077],
              [98.65871138500012, 16.116278381000072],
              [98.65033980300012, 16.099638570000067],
              [98.64413863200014, 16.079639791000133],
              [98.63018599400004, 16.060002747000098],
              [98.61912723800003, 16.051011048000063],
              [98.6115824790001, 16.04692861000005],
              [98.60310754400007, 16.045843404000053],
              [98.59008508300013, 16.045791728000026],
              [98.57995650300012, 16.048788961000056],
              [98.56765751100005, 16.05395660500004],
              [98.55587528500007, 16.055506897000058],
              [98.54698693800003, 16.047497050000104],
              [98.5500875250001, 16.034216207000085],
              [98.5769592690001, 15.996905823000063],
              [98.58378055900005, 15.976958720000127],
              [98.5806799720001, 15.95913035100007],
              [98.5685876870001, 15.920166321000082],
              [98.56931115800012, 15.896136780000077],
              [98.57664921100007, 15.854175517000058],
              [98.57437544800007, 15.835985413000017],
              [98.54305953000005, 15.735371399000073],
              [98.5402690030001, 15.711961975000023],
              [98.54405541500006, 15.675098034000072],
              [98.54574670400012, 15.658631897000035],
              [98.54367964700003, 15.601503601000033],
              [98.56714074700011, 15.452546285000054],
              [98.56900109900005, 15.402135926000142],
              [98.55990604700003, 15.355317078000027],
              [98.53355106600009, 15.325964865000046],
              [98.5302437740001, 15.347720642000056],
              [98.51546431500009, 15.363456116000037],
              [98.49500044800004, 15.374799093000107],
              [98.47453658000006, 15.383480734000074],
              [98.45541630000008, 15.373636373000096],
              [98.4393966070001, 15.367590230000062],
              [98.40342981000003, 15.360097148000122],
              [98.39691858000009, 15.355730489000038],
              [98.39619510900008, 15.347617289000127],
              [98.40032922400007, 15.330667420000026],
              [98.39908899000005, 15.321779074000105],
              [98.39361128800005, 15.316275533000109],
              [98.3848262940001, 15.311366272000086],
              [98.38368941300007, 15.31028106700009],
              [98.3812089440001, 15.306637879000093],
              [98.37883182800005, 15.301625265000041],
              [98.3774882410001, 15.296457622000034],
              [98.37996871000007, 15.293847962000115],
              [98.38606652900012, 15.290385640000082],
              [98.39206099500007, 15.285838115000047],
              [98.39474816900008, 15.280076193000085],
              [98.39474816900008, 15.264909160000059],
              [98.3922677000001, 15.258242900000141],
              [98.3852397060001, 15.256253357000105],
              [98.37025354100012, 15.261911926000053],
              [98.33604374200013, 15.282169088000046],
              [98.31785363800009, 15.288990377000104],
              [98.2951160070001, 15.292607728000078],
              [98.28302372200011, 15.289972229000071],
              [98.24767704300012, 15.240931295000053],
              [98.23289758300012, 15.226797791000095],
              [98.21543094900005, 15.218865458000053],
              [98.20769286000007, 15.219215764000083],
              [98.17719039000008, 15.22059661900002],
              [98.17790575900011, 15.20892075700003],
              [98.17791385900006, 15.208788554000108],
              [98.18468040900012, 15.193154550000088],
              [98.19072961500007, 15.179177958000068],
              [98.18576867700011, 15.160781149000073],
              [98.16499475100005, 15.125796204000068],
              [98.16044722500004, 15.106365865000086],
              [98.1680719040001, 15.082770575000012],
              [98.19879962500005, 15.051583013000055],
              [98.19899784400008, 15.051382142000136],
              [98.20437219300004, 15.029574687000107],
              [98.2011682530001, 15.01929107600003],
              [98.19569055200009, 15.010686951000082],
              [98.19134973100012, 15.00115264900009],
              [98.19122365500004, 14.99320983800007],
              [98.19114302600008, 14.988130188000056],
              [98.19507043400012, 14.977588196000085],
              [98.21491418500011, 14.943171692000135],
              [98.22163212100003, 14.92126088500008],
              [98.22039188600007, 14.88526825000011],
              [98.22214888500008, 14.864261780000092],
              [98.22514611800011, 14.858964946000057],
              [98.23589481600004, 14.850386658000033],
              [98.2390987550001, 14.844004618000099],
              [98.23878869700007, 14.839095358000066],
              [98.2353780520001, 14.824548442000022],
              [98.24333622200004, 14.80511810300004],
              [98.29749312300004, 14.721247254000048],
              [98.41820926900004, 14.607559103000057],
              [98.43133508300014, 14.587844543000088],
              [98.44001672400009, 14.566269633000033],
              [98.44549442600004, 14.542033386000057],
              [98.45283247900005, 14.528054911000055],
              [98.46513147000007, 14.523352356000075],
              [98.47815393100012, 14.516505229000103],
              [98.54771040900005, 14.377676493000095],
              [98.59318567000008, 14.321607564000061],
              [98.60145389800005, 14.313649394000095],
              [98.6144763590001, 14.305148621000086],
              [98.62150435400008, 14.30240977000004],
              [98.63690393100006, 14.29897328700011],
              [98.64424198400008, 14.29566599600011],
              [98.65075321400013, 14.289413147000104],
              [98.66356897000003, 14.272876688000025],
              [98.67039025900004, 14.267915751000075],
              [98.68558313000011, 14.26739898700012],
              [98.69736535700008, 14.271378073000108],
              [98.7069771730001, 14.269982809000041],
              [98.73105839100003, 14.223499858000096],
              [98.7536926680001, 14.200116272000045],
              [98.87234175600014, 14.112473043000122],
              [98.89373580000006, 14.103248800000117],
              [98.91771366400008, 14.096375834000057],
              [98.93528365100013, 14.085394592000071],
              [98.9453088790001, 14.069142355000068],
              [98.94758264100011, 14.046404724000084],
              [98.95295699100006, 14.028033752000084],
              [98.98478967300008, 13.990594178000023],
              [98.99698531100012, 13.971628926000065],
              [99.00711389200006, 13.949640605000084],
              [99.01620894400003, 13.937935893000102],
              [99.04762821400004, 13.914991557000079],
              [99.05207238800006, 13.909048767000058],
              [99.05713667800006, 13.89408844000009],
              [99.06106408800014, 13.888016459000141],
              [99.06633508300007, 13.885329285000111],
              [99.08028772000006, 13.881556905000096],
              [99.08483524600007, 13.878533834000066],
              [99.09000289000011, 13.870110575000083],
              [99.09217329900008, 13.863573507000098],
              [99.09186324100011, 13.855925395000028],
              [99.08948612500006, 13.84391062400006],
              [99.08979618300003, 13.826650696000073],
              [99.1011649990001, 13.778824158000077],
              [99.10881311000009, 13.762701111000098],
              [99.14126591000013, 13.73210866300009],
              [99.14677934200012, 13.723674124000055],
              [99.15253137200006, 13.714874573000102],
              [99.15284143100007, 13.688726298000091],
              [99.14953413900014, 13.66598866800011],
              [99.15201460800012, 13.581962790000091],
              [99.18787805200009, 13.427140198000117],
              [99.18880822800003, 13.407916565000093],
              [99.18364058400005, 13.357971293000034],
              [99.18694787600003, 13.33874766000011],
              [99.18694787600003, 13.329135844000092],
              [99.18271040800005, 13.318723043000062],
              [99.17692264900012, 13.310325622000079],
              [99.17278853400006, 13.300920512000033],
              [99.17340865100005, 13.287432963000072],
              [99.1860177000001, 13.249993388000092],
              [99.19015181500009, 13.229503682000114],
              [99.1872579350001, 13.212243754000042],
              [99.18647971700011, 13.211558644000107],
              [99.17278853400006, 13.19950551400008],
              [99.13320438600005, 13.195164693000095],
              [99.11408410700011, 13.188085022000067],
              [99.10209517500004, 13.171341858000119],
              [99.10219852800009, 13.151834005000111],
              [99.10529911300006, 13.129613139000085],
              [99.10250858600006, 13.104395040000043],
              [99.09382694500005, 13.080675558000081],
              [99.08834924300004, 13.058351339000112],
              [99.09320682800006, 13.038326722000079],
              [99.11532434100008, 13.021402689000084],
              [99.13248091700012, 13.01104156500007],
              [99.15108443200006, 12.994789327000149],
              [99.16483036400012, 12.975514018000112],
              [99.16731083200011, 12.956006165000105],
              [99.16307336400013, 12.944663188000035],
              [99.15790572100013, 12.93595570900007],
              [99.15418501800013, 12.926602275000036],
              [99.15315149000003, 12.913553975000085],
              [99.15532190000005, 12.904484762000024],
              [99.16844771400008, 12.874099019000056],
              [99.17185835800012, 12.843325704000094],
              [99.17526900200005, 12.833429667000104],
              [99.18322717300003, 12.82257761600006],
              [99.2030709230001, 12.80387074800008],
              [99.21071903500007, 12.792269389000126],
              [99.21443973800007, 12.771676331000037],
              [99.21319950400004, 12.752607727000054],
              [99.2141296800001, 12.73465016700007],
              [99.22446496600003, 12.717467753000093],
              [99.23345666600005, 12.713126933000112],
              [99.25629764800004, 12.709457906000125],
              [99.26673628800012, 12.702843323000124],
              [99.27118046100003, 12.693799947000073],
              [99.27345422400003, 12.67354278600007],
              [99.27686486900006, 12.6655846150001],
              [99.28626997900011, 12.660003560000092],
              [99.30973108000006, 12.65349233000012],
              [99.31717248600012, 12.645895894000148],
              [99.32358036300013, 12.635405579000107],
              [99.33339888500012, 12.625432027000087],
              [99.34445764200012, 12.616750387000124],
              [99.39375695800004, 12.589775289000016],
              [99.40326542100007, 12.575926005000042],
              [99.40474711600012, 12.566940859000113],
              [99.40729618400007, 12.551483052],
              [99.40708947800005, 12.530244039000124],
              [99.40419559700007, 12.508126526000112],
              [99.40026818900009, 12.497481181000126],
              [99.38951949100004, 12.475983785000082],
              [99.38703902200007, 12.465906880000148],
              [99.39127648900006, 12.445339660000059],
              [99.41401411900011, 12.405238749000063],
              [99.42062870300003, 12.383379619000038],
              [99.42341923000009, 12.327775777000028],
              [99.42672652200008, 12.308655498000121],
              [99.43220422400009, 12.296408183000096],
              [99.44760380100013, 12.278218079000055],
              [99.45442509000009, 12.267262675000083],
              [99.45711226400005, 12.25641062500003],
              [99.45473514800005, 12.238220521000088],
              [99.45556197200011, 12.227575175000098],
              [99.45938602700005, 12.217084860000043],
              [99.4701347250001, 12.197396139000091],
              [99.47375207600004, 12.18726755800013],
              [99.4719950760001, 12.173624980000042],
              [99.46383020100006, 12.164581604000077],
              [99.45411503200012, 12.15688181600008],
              [99.44884403500009, 12.147218323000061],
              [99.45225468000012, 12.129389953000029],
              [99.46631067000004, 12.126030986000103],
              [99.52263798000013, 12.144221090000144],
              [99.53286991400012, 12.144531148000041],
              [99.54165490700012, 12.140655416000072],
              [99.54578902200012, 12.131870422000091],
              [99.54351525900012, 12.12246531200013],
              [99.53927779100007, 12.112285055000072],
              [99.5376241460001, 12.100864563000073],
              [99.52170780500006, 12.053683980000045],
              [99.51840051300007, 12.025933737000102],
              [99.53431685400011, 12.011567688000099],
              [99.55333378100005, 12.005521545000065],
              [99.56697635900008, 11.993325908000145],
              [99.57400435400007, 11.976324361000124],
              [99.57286747300009, 11.95591217100008],
              [99.55736454300006, 11.915604554000126],
              [99.55405725100007, 11.895037334000051],
              [99.56139530500008, 11.872919820000035],
              [99.57379764900003, 11.8577269500001],
              [99.59178104700004, 11.842275696000101],
              [99.61100468000006, 11.830183411000121],
              [99.62795455000003, 11.825377503000112],
              [99.63002160600013, 11.815765686000105],
              [99.61534550000005, 11.74941314700007],
              [99.60687056500012, 11.725693665000037],
              [99.54258508300006, 11.640479228000075],
              [99.53069950400004, 11.630919088000084],
              [99.48915165300014, 11.628438619000107],
              [99.46610396300008, 11.623942770000085],
              [99.44977421100003, 11.613762513000026],
              [99.44057580600003, 11.597277731000133],
              [99.43923221800009, 11.573919983000096],
              [99.44109257000008, 11.533405661000089],
              [99.43737186700008, 11.516688334000051],
              [99.42817346200007, 11.49689626100006],
              [99.41587447100011, 11.480230611000124],
              [99.38703902200007, 11.451550192000042],
              [99.37763391100003, 11.435504660000078],
              [99.37205285600004, 11.410855001000087],
              [99.3705025640001, 11.39333669100003],
              [99.36430139200013, 11.37672271800011],
              [99.32637089100012, 11.336234233000113],
              [99.31572554600012, 11.320808817000028],
              [99.30053267400007, 11.280630392000106],
              [99.28844038900007, 11.258306173000037],
              [99.25619429500006, 11.21998809800003],
              [99.24327518800004, 11.197663880000064],
              [99.21299279800007, 11.108263652000076],
              [99.20617150900006, 11.100021260000034],
              [99.18488081900006, 11.092967428000108],
              [99.17506229700007, 11.087438050000102],
              [99.16762089100007, 11.077981262000051],
              [99.15821578000003, 11.057310689000118],
              [99.15170455000003, 11.047673035000102],
              [99.14094611700011, 11.039409961000047],
              [99.13310103300012, 11.033384501000029],
              [99.09320682800006, 11.012972311000084],
              [99.07687707600013, 10.996513367000105],
              [99.07253625500005, 10.987599182000082],
              [99.06364790900011, 10.95742014600009],
              [99.05506962100009, 10.94525034600008],
              [99.04525109800011, 10.94550872800005],
              [99.03470910700008, 10.95096059200003],
              [99.02334029100007, 10.954371236000057],
              [99.01062788900003, 10.956231588000065],
              [99.00556359900003, 10.95881541000007],
              [99.00153283700013, 10.957626851000043],
              [98.99233443300005, 10.947963359000113],
              [98.98665002500007, 10.93930755600006],
              [98.98261926300012, 10.928946432000146],
              [98.98024214700007, 10.918016867000077],
              [98.97962203000009, 10.90765574100007],
              [98.9817924400001, 10.895485942000064],
              [98.98975061000004, 10.875151266000032],
              [98.98985396400008, 10.860449321000132],
              [98.98613326000009, 10.840321350000067],
              [98.98189579300004, 10.832414856000113],
              [98.9744543870001, 10.824198303000088],
              [98.96970015500011, 10.823113098000093],
              [98.93404341600012, 10.80771352100001],
              [98.92329471800008, 10.808101095000026],
              [98.91471643100004, 10.812286886000052],
              [98.90541467400004, 10.814405619000127],
              [98.8920821530001, 10.808514506000037],
              [98.88360721800012, 10.799186910000088],
              [98.87919148800006, 10.788202779000045],
              [98.87533899000005, 10.778619690000099],
              [98.86820764200013, 10.76988637300012],
              [98.86086958900012, 10.76766428700003],
              [98.83957889800013, 10.766398214000077],
              [98.83007043500004, 10.763556010000102],
              [98.81095015500006, 10.746631979000114],
              [98.76671512800004, 10.688754375000087],
              [98.75679325400006, 10.66606842000003],
              [98.74790490800012, 10.623125305000059],
              [98.75152225800014, 10.61036122600008],
              [98.77074589100005, 10.593979798000134],
              [98.7772571210001, 10.583231100000106],
              [98.79131311100014, 10.520418396000053],
              [98.79038293500008, 10.500264588000078],
              [98.77653365100008, 10.462101543000102],
              [98.76640507000008, 10.411200257000075],
              [98.74740644600007, 10.350531317000048],
              [98.73991946700005, 10.347357489000046],
              [98.73503665500004, 10.343085028000075],
              [98.73121178500003, 10.33734772300005],
              [98.71892337300005, 10.312567450000074],
              [98.70281009200005, 10.26276276200008],
              [98.69605553500003, 10.22370026200008],
              [98.68702233200003, 10.208400783000059],
              [98.66504967500003, 10.18545156500005],
              [98.64421634200005, 10.15501536700009],
              [98.58985436300003, 10.04205963700008],
              [98.56055748800003, 10.002142645000049],
              [98.54314212300005, 9.987453518000052],
              [98.53532962300005, 9.997381903000075],
              [98.53345787900008, 10.006740627000056],
              [98.52442467500003, 10.021063544000071],
              [98.52100670700003, 10.028998114000046],
              [98.52003014400003, 10.038885809000078],
              [98.52149498800003, 10.059393622000073],
              [98.52100670700003, 10.06932200700004],
              [98.51482181100005, 10.101507880000042],
              [98.51392662900008, 10.146918036000045],
              [98.49366295700003, 10.179185289000088],
              [98.49048912900008, 10.190619208000044],
              [98.48959394600007, 10.19790273600006],
              [98.49073326900003, 10.204331773000092],
              [98.50757897200003, 10.244940497000073],
              [98.51221764400003, 10.261419989000046],
              [98.51710045700003, 10.307440497000073],
              [98.52849368600005, 10.343247789000088],
              [98.52849368600005, 10.364203192000048],
              [98.51221764400003, 10.422796942000048],
              [98.49415123800003, 10.452460028000075],
              [98.49341881600003, 10.472723700000074],
              [98.50049889400003, 10.515041408000059],
              [98.49545332100007, 10.55687083500004],
              [98.46338951900003, 10.630031643000052],
              [98.45899498800003, 10.672674872000073],
              [98.45932050900007, 10.715399481000077],
              [98.46355228000004, 10.729437567000048],
              [98.47657311300003, 10.73468659100007],
              [98.49830162900008, 10.731594143000052],
              [98.51099694100003, 10.72288646000004],
              [98.52849368600005, 10.693101304000038],
              [98.53874759200005, 10.704413153000075],
              [98.53834069100003, 10.718695380000042],
              [98.53101647200003, 10.732163804000038],
              [98.52100670700003, 10.74095286700009],
              [98.53256269600007, 10.746771552000041],
              [98.54371178500003, 10.745062567000048],
              [98.55420983200003, 10.737982489000046],
              [98.56324303500003, 10.72728099200009],
              [98.56999759200005, 10.743109442000048],
              [98.57740319100003, 10.770412502000056],
              [98.58301842500003, 10.781927802000041],
              [98.59986412900008, 10.805487372000073],
              [98.60271243600005, 10.819484768000052],
              [98.59669030000003, 10.837144273000092],
              [98.60694420700003, 10.836371161000045],
              [98.61597741000003, 10.838446356000077],
              [98.62403405000003, 10.84320709800005],
              [98.63086998800003, 10.850816148000092],
              [98.62012780000003, 10.85455963700008],
              [98.59546959700003, 10.856838283000059],
              [98.58643639400003, 10.861029364000046],
              [98.58179772200003, 10.867254950000074],
              [98.57886803500003, 10.875189520000049],
              [98.58155358200003, 10.882025458000044],
              [98.61378014400003, 10.890285549000055],
              [98.62501061300003, 10.902004299000055],
              [98.63404381600003, 10.913723049000055],
              [98.64795983200003, 10.919094143000052],
              [98.65284264400003, 10.917181708000044],
              [98.66382897200003, 10.908270575000074],
              [98.67310631600003, 10.905462958000044],
              [98.67505944100003, 10.90851471600007],
              [98.68921959700003, 10.913397528000075],
              [98.70362389400003, 10.916164455000057],
              [98.70655358200003, 10.91282786700009],
              [98.71241295700003, 10.924383856000077],
              [98.71680748800003, 10.942206122000073],
              [98.71762129000007, 10.960679429000038],
              [98.71273847700007, 10.974310614000046],
              [98.72022545700003, 10.980536200000074],
              [98.71387780000003, 10.989976304000038],
              [98.69654381600003, 11.00259023600006],
              [98.69288170700003, 11.00844961100006],
              [98.69532311300003, 11.020086981000077],
              [98.70093834700003, 11.024969794000071],
              [98.70834394600007, 11.02765534100007],
              [98.71648196700005, 11.032375393000052],
              [98.72242272200003, 11.044867255000042],
              [98.71827233200003, 11.05882396000004],
              [98.71062259200005, 11.07607656500005],
              [98.70655358200003, 11.097845770000049],
              [98.68881269600007, 11.092474677000041],
              [98.67628014400003, 11.10057200700004],
              [98.65821373800003, 11.131984768000052],
              [98.70264733200003, 11.14362213700008],
              [98.72413170700003, 11.156195380000042],
              [98.73316491000003, 11.17601146000004],
              [98.73316491000003, 11.207098700000074],
              [98.74561608200003, 11.236029364000046],
              [98.75098717500003, 11.257066148000092],
              [98.75709069100003, 11.263373114000046],
              [98.75928795700003, 11.268947658000059],
              [98.74642988400007, 11.28587474200009],
              [98.72657311300003, 11.33344147300005],
              [98.72193444100003, 11.350083726000037],
              [98.72136478000004, 11.367254950000074],
              [98.72706139400003, 11.385199286000045],
              [98.70264733200003, 11.379055080000057],
              [98.69800866000003, 11.388006903000075],
              [98.70655358200003, 11.423081773000092],
              [98.71534264400003, 11.443182684000078],
              [98.73568769600007, 11.450140692000048],
              [98.77491295700003, 11.453517971000053],
              [98.76563561300003, 11.46743398600006],
              [98.76343834700003, 11.506252346000053],
              [98.75440514400003, 11.522406317000048],
              [98.74529056100005, 11.52484772300005],
              [98.72885175900007, 11.517645575000074],
              [98.72022545700003, 11.522406317000048],
              [98.71794681100005, 11.53188711100006],
              [98.72575931100005, 11.548407294000071],
              [98.72022545700003, 11.557114976000037],
              [98.73357181100005, 11.573431708000044],
              [98.73633873800003, 11.588771877000056],
              [98.73316491000003, 11.624823309000078],
              [98.73560631600003, 11.64203522300005],
              [98.74154707100007, 11.66502513200004],
              [98.75220787900008, 11.681708075000074],
              [98.76807701900003, 11.680080471000053],
              [98.78028405000003, 11.68650950700004],
              [98.78793379000007, 11.683335679000038],
              [98.79517662900008, 11.67682526200008],
              [98.80591881600003, 11.673244533000059],
              [98.81714928500003, 11.677394924000055],
              [98.81869550900007, 11.687201239000046],
              [98.81812584700003, 11.69867584800005],
              [98.82260175900007, 11.707953192000048],
              [98.83545983200003, 11.710109768000052],
              [98.85434004000007, 11.707098700000074],
              [98.87289472700007, 11.700913804000038],
              [98.88477623800003, 11.69367096600007],
              [98.89161217500003, 11.69367096600007],
              [98.87671959700003, 11.72264232000009],
              [98.80494225400008, 11.736517645000049],
              [98.78296959700003, 11.755113023000092],
              [98.79029381600003, 11.779689846000053],
              [98.81202233200003, 11.80263906500005],
              [98.82569420700003, 11.825873114000046],
              [98.80892988400007, 11.851304429000038],
              [98.81609134200005, 11.833807684000078],
              [98.81023196700005, 11.822007554000038],
              [98.80054772200003, 11.813788153000075],
              [98.79127037900008, 11.802476304000038],
              [98.76807701900003, 11.76194896000004],
              [98.76148522200003, 11.760891018000052],
              [98.74415123800003, 11.762518622000073],
              [98.74073326900003, 11.75853099200009],
              [98.73796634200005, 11.75649648600006],
              [98.72584069100003, 11.744330145000049],
              [98.72364342500003, 11.741441148000092],
              [98.71216881600003, 11.736517645000049],
              [98.70899498800003, 11.72451406500005],
              [98.70826256600003, 11.70994700700004],
              [98.70313561300003, 11.697455145000049],
              [98.69263756600003, 11.686753648000092],
              [98.68433678500003, 11.682806708000044],
              [98.67416425900007, 11.685248114000046],
              [98.64763431100005, 11.700506903000075],
              [98.61687259200005, 11.72370026200008],
              [98.61036217500003, 11.731268622000073],
              [98.60873457100007, 11.741400458000044],
              [98.60328209700003, 11.753607489000046],
              [98.60352623800003, 11.76194896000004],
              [98.60596764400003, 11.769191799000055],
              [98.61784915500004, 11.789252020000049],
              [98.62330162900008, 11.79328034100007],
              [98.62891686300003, 11.791937567000048],
              [98.63209069100003, 11.79287344000005],
              [98.63086998800003, 11.803615627000056],
              [98.60352623800003, 11.803615627000056],
              [98.61931399800005, 11.825873114000046],
              [98.62403405000003, 11.830267645000049],
              [98.63135826900003, 11.832098700000074],
              [98.64087975400008, 11.83226146000004],
              [98.64869225400008, 11.83148834800005],
              [98.65137780000003, 11.830267645000049],
              [98.66032962300005, 11.845200914000088],
              [98.66797936300003, 11.86359284100007],
              [98.68091881600003, 11.877346096000053],
              [98.70655358200003, 11.878648179000038],
              [98.69410241000003, 11.89288971600007],
              [98.67310631600003, 11.892075914000088],
              [98.63086998800003, 11.878648179000038],
              [98.54900149800005, 11.878648179000038],
              [98.55811608200003, 11.899115302000041],
              [98.57813561300003, 11.906683661000045],
              [98.62745201900003, 11.905951239000046],
              [98.64503014400003, 11.910223700000074],
              [98.66407311300003, 11.920355536000045],
              [98.67920983200003, 11.932806708000044],
              [98.69092858200003, 11.954331773000092],
              [98.70289147200003, 11.959051825000074],
              [98.71485436300003, 11.96116771000004],
              [98.72022545700003, 11.96430084800005],
              [98.72144616000003, 11.997788804000038],
              [98.72022545700003, 12.008368231000077],
              [98.71314537900008, 12.025213934000078],
              [98.70533287900008, 12.036851304000038],
              [98.70313561300003, 12.048081773000092],
              [98.71273847700007, 12.063625393000052],
              [98.66504967500003, 12.060248114000046],
              [98.65845787900008, 12.06712474200009],
              [98.64503014400003, 12.078070380000042],
              [98.63379967500003, 12.090318101000037],
              [98.63428795700003, 12.101141669000071],
              [98.64096113400007, 12.113674221000053],
              [98.63624108200003, 12.122544664000088],
              [98.62964928500003, 12.131984768000052],
              [98.63086998800003, 12.146185614000046],
              [98.63786868600005, 12.151068427000041],
              [98.65072675900007, 12.155096747000073],
              [98.67310631600003, 12.15916575700004],
              [98.67310631600003, 12.16665273600006],
              [98.65821373800003, 12.16665273600006],
              [98.66765384200005, 12.177679755000042],
              [98.69581139400003, 12.193101304000038],
              [98.70972741000003, 12.204250393000052],
              [98.71371504000007, 12.215765692000048],
              [98.71021569100003, 12.228013414000088],
              [98.70329837300005, 12.237779039000088],
              [98.69629967500003, 12.241766669000071],
              [98.66293379000007, 12.236802476000037],
              [98.64087975400008, 12.224554755000042],
              [98.62142988400007, 12.20897044500009],
              [98.59669030000003, 12.19399648600006],
              [98.58855228000004, 12.197699286000045],
              [98.57081139400003, 12.203517971000053],
              [98.56324303500003, 12.20766836100006],
              [98.54712975400008, 12.223456122000073],
              [98.53907311300003, 12.241766669000071],
              [98.54021243600005, 12.260972398000092],
              [98.55201256600003, 12.27960846600007],
              [98.56836998800003, 12.29092031500005],
              [98.58765709700003, 12.297064520000049],
              [98.67676842500003, 12.315252997000073],
              [98.69776451900003, 12.327948309000078],
              [98.70655358200003, 12.34788646000004],
              [98.69996178500003, 12.363959052000041],
              [98.68425540500004, 12.373236395000049],
              [98.65137780000003, 12.38572825700004],
              [98.62680097700007, 12.409572658000059],
              [98.62086022200003, 12.413723049000055],
              [98.60743248800003, 12.41828034100007],
              [98.60515384200005, 12.428941148000092],
              [98.61036217500003, 12.450913804000038],
              [98.61133873800003, 12.473049221000053],
              [98.61622155000003, 12.485744533000059],
              [98.62842858200003, 12.492132880000042],
              [98.65137780000003, 12.495591539000088],
              [98.68921959700003, 12.495591539000088],
              [98.70142662900008, 12.498724677000041],
              [98.70875084700003, 12.505560614000046],
              [98.70972741000003, 12.512396552000041],
              [98.70313561300003, 12.51552969000005],
              [98.69483483200003, 12.51703522300005],
              [98.68148847700007, 12.525580145000049],
              [98.67310631600003, 12.529730536000045],
              [98.66195722700007, 12.531317450000074],
              [98.65072675900007, 12.530951239000046],
              [98.63998457100007, 12.53188711100006],
              [98.63086998800003, 12.537258205000057],
              [98.62305748800003, 12.558172919000071],
              [98.63119550900007, 12.579331773000092],
              [98.64437910200007, 12.60065338700008],
              [98.65137780000003, 12.622259833000044],
              [98.65463300900007, 12.62571849200009],
              [98.66187584700003, 12.625474351000037],
              [98.66944420700003, 12.62445709800005],
              [98.67310631600003, 12.625392971000053],
              [98.67221113400007, 12.631740627000056],
              [98.66504967500003, 12.646429755000042],
              [98.66765384200005, 12.67479075700004],
              [98.67310631600003, 12.687445380000042],
              [98.68034915500004, 12.697007554000038],
              [98.68669681100005, 12.702826239000046],
              [98.69117272200003, 12.710435289000088],
              [98.69288170700003, 12.725287177000041],
              [98.68930097700007, 12.728094794000071],
              [98.66163170700003, 12.721584377000056],
              [98.64844811300003, 12.723334052000041],
              [98.64177493600005, 12.728094794000071],
              [98.64087975400008, 12.73468659100007],
              [98.64454186300003, 12.742010809000078],
              [98.65235436300003, 12.745428778000075],
              [98.66309655000003, 12.74510325700004],
              [98.67302493600005, 12.74681224200009],
              [98.67872155000003, 12.756293036000045],
              [98.67017662900008, 12.760931708000044],
              [98.62769616000003, 12.756252346000053],
              [98.61784915500004, 12.76626211100006],
              [98.61744225400008, 12.777411200000074],
              [98.61898847700007, 12.775091864000046],
              [98.62403405000003, 12.776190497000073],
              [98.63453209700003, 12.781195380000042],
              [98.64177493600005, 12.782416083000044],
              [98.64698326900003, 12.78579336100006],
              [98.65137780000003, 12.797308661000045],
              [98.63428795700003, 12.878607489000046],
              [98.62476647200003, 12.88422272300005],
              [98.60124759200005, 12.911037502000056],
              [98.58985436300003, 12.919582424000055],
              [98.60010826900003, 12.94163646000004],
              [98.60678144600007, 12.95062897300005],
              [98.61402428500003, 12.954291083000044],
              [98.61036217500003, 12.95962148600006],
              [98.59669030000003, 12.995917059000078],
              [98.58619225400008, 13.016506252000056],
              [98.58383222700007, 13.026597398000092],
              [98.58041425900007, 13.065375067000048],
              [98.58204186300003, 13.077053127000056],
              [98.58985436300003, 13.084662177000041],
              [98.58334394600007, 13.113959052000041],
              [98.57846113400007, 13.186753648000092],
              [98.56592858200003, 13.201361395000049],
              [98.55307050900007, 13.20807526200008],
              [98.50049889400003, 13.249172268000052],
              [98.49512780000003, 13.28546784100007],
              [98.48991946700005, 13.29783763200004],
              [98.47999108200003, 13.283880927000041],
              [98.47527103000004, 13.292914130000042],
              [98.47282962300005, 13.302923895000049],
              [98.47242272200003, 13.313625393000052],
              [98.47315514400003, 13.324896552000041],
              [98.46045983200003, 13.35578034100007],
              [98.46013431100005, 13.369330145000049],
              [98.47315514400003, 13.379461981000077],
              [98.47169030000003, 13.386419989000046],
              [98.47120201900003, 13.394191799000055],
              [98.47315514400003, 13.413031317000048],
              [98.46420332100007, 13.407700914000088],
              [98.45899498800003, 13.399969794000071],
              [98.45281009200005, 13.379461981000077],
              [98.45378665500004, 13.39638906500005],
              [98.45093834700003, 13.411363023000092],
              [98.44532311300003, 13.424302476000037],
              [98.43913821700005, 13.434759833000044],
              [98.43441816500007, 13.43846263200004],
              [98.42823326900003, 13.441799221000053],
              [98.42237389400003, 13.446600653000075],
              [98.41863040500004, 13.454575914000088],
              [98.41944420700003, 13.462225653000075],
              [98.42920983200003, 13.471177476000037],
              [98.43165123800003, 13.47874583500004],
              [98.42644290500004, 13.490057684000078],
              [98.40333092500003, 13.52244700700004],
              [98.39405358200003, 13.542792059000078],
              [98.38396243600005, 13.551906643000052],
              [98.37061608200003, 13.559515692000048],
              [98.35718834700003, 13.563869533000059],
              [98.36109459700003, 13.57615794500009],
              [98.35661868600005, 13.584865627000056],
              [98.33611087300005, 13.598578192000048],
              [98.33643639400003, 13.619818427000041],
              [98.29883873800003, 13.671047268000052],
              [98.28825931100005, 13.69476959800005],
              [98.29566491000003, 13.687974351000037],
              [98.30201256600003, 13.700995184000078],
              [98.27670332100007, 13.707180080000057],
              [98.25733483200003, 13.706366278000075],
              [98.24480228000004, 13.714056708000044],
              [98.24048912900008, 13.746039130000042],
              [98.25196373800003, 13.782538153000075],
              [98.25416100400008, 13.797796942000048],
              [98.25196373800003, 13.811672268000052],
              [98.24838300900007, 13.82453034100007],
              [98.24781334700003, 13.837591864000046],
              [98.25416100400008, 13.85179271000004],
              [98.24805748800003, 13.862779039000088],
              [98.23365319100003, 13.917303778000075],
              [98.23365319100003, 13.96165599200009],
              [98.23121178500003, 13.972479559000078],
              [98.22779381600003, 13.981268622000073],
              [98.22722415500004, 13.988959052000041],
              [98.23365319100003, 13.996486721000053],
              [98.23365319100003, 14.002630927000041],
              [98.22242272200003, 14.013088283000059],
              [98.20866946700005, 14.02960846600007],
              [98.19703209700003, 14.048163153000075],
              [98.19214928500003, 14.06468333500004],
              [98.18580162900008, 14.06468333500004],
              [98.18458092500003, 14.052557684000078],
              [98.18002363400007, 14.031642971000053],
              [98.17896569100003, 14.019720770000049],
              [98.18213951900003, 14.01430898600006],
              [98.19629967500003, 13.997870184000078],
              [98.19947350400008, 13.992743231000077],
              [98.19825280000003, 13.964911200000074],
              [98.19336998800003, 13.95180898600006],
              [98.18238366000003, 13.93781159100007],
              [98.18018639400003, 13.925034898000092],
              [98.19516035200007, 13.88694896000004],
              [98.19947350400008, 13.869208075000074],
              [98.19727623800003, 13.85032786700009],
              [98.18799889400003, 13.815130927000041],
              [98.17945397200003, 13.73240794500009],
              [98.19353274800005, 13.68626536700009],
              [98.19605553500003, 13.668361721000053],
              [98.19336998800003, 13.651556708000044],
              [98.18580162900008, 13.632757880000042],
              [98.18238366000003, 13.627101955000057],
              [98.17888431100005, 13.622626044000071],
              [98.17530358200003, 13.616603908000059],
              [98.17156009200005, 13.606024481000077],
              [98.16895592500003, 13.59398021000004],
              [98.16846764400003, 13.58429596600007],
              [98.17156009200005, 13.563869533000059],
              [98.18344160200007, 13.551703192000048],
              [98.18685957100007, 13.543850002000056],
              [98.17896569100003, 13.53709544500009],
              [98.17107181100005, 13.53782786700009],
              [98.16382897200003, 13.543524481000077],
              [98.15105228000004, 13.55760325700004],
              [98.14966881600003, 13.550116278000075],
              [98.14584394600007, 13.542914130000042],
              [98.14429772200003, 13.53709544500009],
              [98.14210045700003, 13.548081773000092],
              [98.14275149800005, 13.561712958000044],
              [98.14136803500003, 13.57322825700004],
              [98.13428795700003, 13.57811107000009],
              [98.12973066500007, 13.58234284100007],
              [98.13477623800003, 13.591742255000042],
              [98.14372806100005, 13.601263739000046],
              [98.15105228000004, 13.606024481000077],
              [98.14698326900003, 13.611151434000078],
              [98.14136803500003, 13.621161200000074],
              [98.13746178500003, 13.626532294000071],
              [98.15186608200003, 13.630357164000088],
              [98.15845787900008, 13.642320054000038],
              [98.15805097700007, 13.65818919500009],
              [98.15105228000004, 13.67373281500005],
              [98.16765384200005, 13.673163153000075],
              [98.16879316500007, 13.680812893000052],
              [98.16041100400008, 13.690252997000073],
              [98.14763431100005, 13.69476959800005],
              [98.12378991000003, 13.693508205000057],
              [98.11638431100005, 13.695054429000038],
              [98.10328209700003, 13.700995184000078],
              [98.10670006600003, 13.70701732000009],
              [98.11345462300005, 13.722805080000057],
              [98.11695397200003, 13.728949286000045],
              [98.09205162900008, 13.73969147300005],
              [98.08277428500003, 13.769964911000045],
              [98.08887780000003, 13.795111395000049],
              [98.11011803500003, 13.790350653000075],
              [98.10401451900003, 13.83470286700009],
              [98.10328209700003, 13.876369533000059],
              [98.10914147200003, 13.89248281500005],
              [98.11085045700003, 13.902167059000078],
              [98.10670006600003, 13.906439520000049],
              [98.10124759200005, 13.908026434000078],
              [98.09302819100003, 13.912176825000074],
              [98.08545983200003, 13.917914130000042],
              [98.08228600400008, 13.92446523600006],
              [98.07927493600005, 13.948065497000073],
              [98.06560306100005, 13.98932526200008],
              [98.06169681100005, 14.01007721600007],
              [98.06625410200007, 14.032700914000088],
              [98.08838951900003, 14.06346263200004],
              [98.09644616000003, 14.07835521000004],
              [98.09742272200003, 14.092189846000053],
              [98.10767662900008, 14.11001211100006],
              [98.11011803500003, 14.12303294500009],
              [98.10857181100005, 14.132635809000078],
              [98.09644616000003, 14.167792059000078],
              [98.11011803500003, 14.167792059000078],
              [98.10645592500003, 14.181219794000071],
              [98.10108483200003, 14.191839911000045],
              [98.09522545700003, 14.193793036000045],
              [98.08961022200003, 14.181382554000038],
              [98.04175866000003, 14.242865302000041],
              [98.01482181100005, 14.299505927000041],
              [97.99350019600007, 14.330511786000045],
              [97.98601321700005, 14.35260651200008],
              [97.98129316500007, 14.376450914000088],
              [97.97974694100003, 14.397406317000048],
              [97.98259524800005, 14.419256903000075],
              [97.99594160200007, 14.449693101000037],
              [98.00025475400008, 14.46873607000009],
              [97.99146569100003, 14.46002838700008],
              [97.98422285200007, 14.449652411000045],
              [97.97641035200007, 14.443752346000053],
              [97.96607506600003, 14.44830963700008],
              [97.96208743600005, 14.45774974200009],
              [97.95183353000004, 14.50291575700004],
              [97.92139733200003, 14.55768463700008],
              [97.91358483200003, 14.586737372000073],
              [97.92505944100003, 14.612779039000088],
              [97.90007571700005, 14.63031647300005],
              [97.88550866000003, 14.655951239000046],
              [97.88550866000003, 14.684068101000037],
              [97.90406334700003, 14.70897044500009],
              [97.94312584700003, 14.720200914000088],
              [97.96851647200003, 14.696519273000092],
              [97.99244225400008, 14.663723049000055],
              [98.02759850400008, 14.64752838700008],
              [97.99244225400008, 14.693101304000038],
              [97.98218834700003, 14.715277411000045],
              [98.00025475400008, 14.722072658000059],
              [97.98536217500003, 14.728176174000055],
              [97.97103925900007, 14.735907294000071],
              [97.96461022200003, 14.74705638200004],
              [97.97291100400008, 14.763617255000042],
              [97.96566816500007, 14.76951732000009],
              [97.95883222700007, 14.778509833000044],
              [97.95386803500003, 14.78774648600006],
              [97.95183353000004, 14.794338283000059],
              [97.94988040500004, 14.798895575000074],
              [97.94532311300003, 14.795314846000053],
              [97.93816165500004, 14.784735419000071],
              [97.93995201900003, 14.782416083000044],
              [97.94336998800003, 14.776678778000075],
              [97.94605553500003, 14.769680080000057],
              [97.94556725400008, 14.763617255000042],
              [97.93116295700003, 14.75218333500004],
              [97.91716556100005, 14.758612372000073],
              [97.90674889400003, 14.775946356000077],
              [97.90406334700003, 14.797756252000056],
              [97.89722741000003, 14.797756252000056],
              [97.89454186300003, 14.779689846000053],
              [97.90219160200007, 14.737697658000059],
              [97.89380944100003, 14.72947825700004],
              [97.88835696700005, 14.726955471000053],
              [97.88306725400008, 14.721502997000073],
              [97.87549889400003, 14.716742255000042],
              [97.86304772200003, 14.71580638200004],
              [97.85621178500003, 14.718491929000038],
              [97.85035241000003, 14.72361888200004],
              [97.84595787900008, 14.72992584800005],
              [97.84253991000003, 14.73631419500009],
              [97.81511478000004, 14.850816148000092],
              [97.79493248800003, 14.880153713000084],
              [97.79476972700007, 14.88031647300005],
              [97.80030358200003, 14.890326239000046],
              [97.80250084700003, 14.900946356000077],
              [97.80225670700003, 14.924709377000056],
              [97.80445397200003, 14.935980536000045],
              [97.81373131600003, 14.95018138200004],
              [97.81592858200003, 14.958807684000078],
              [97.81283613400007, 14.983343817000048],
              [97.80437259200005, 14.99868398600006],
              [97.79118899800005, 15.008734442000048],
              [97.77426191500007, 15.01748281500005],
              [97.77979576900003, 15.025783596000053],
              [97.78744550900007, 15.03070709800005],
              [97.79688561300003, 15.032456773000092],
              [97.80836022200003, 15.03115469000005],
              [97.80437259200005, 15.038234768000052],
              [97.79908287900008, 15.051459052000041],
              [97.79476972700007, 15.05849844000005],
              [97.80681399800005, 15.07526276200008],
              [97.81023196700005, 15.095119533000059],
              [97.80713951900003, 15.174953518000052],
              [97.81088300900007, 15.191148179000038],
              [97.82276451900003, 15.20929596600007],
              [97.79493248800003, 15.208807684000078],
              [97.78028405000003, 15.211493231000077],
              [97.76937910200007, 15.223334052000041],
              [97.74317467500003, 15.266831773000092],
              [97.74089603000004, 15.275580145000049],
              [97.74024498800003, 15.291815497000073],
              [97.74203535200007, 15.317938544000071],
              [97.73829186300003, 15.329006252000056],
              [97.72641035200007, 15.339585679000038],
              [97.72950280000003, 15.348944403000075],
              [97.73406009200005, 15.355292059000078],
              [97.74089603000004, 15.358954169000071],
              [97.75049889400003, 15.36009349200009],
              [97.76075280000003, 15.394232489000046],
              [97.76693769600007, 15.389349677000041],
              [97.77515709700003, 15.393133856000077],
              [97.79476972700007, 15.407904364000046],
              [97.78687584700003, 15.419419664000088],
              [97.76140384200005, 15.49054596600007],
              [97.76189212300005, 15.50389232000009],
              [97.77426191500007, 15.531398830000057],
              [97.76742597700007, 15.54401276200008],
              [97.74293053500003, 15.60447825700004],
              [97.74366295700003, 15.610256252000056],
              [97.74732506600003, 15.617743231000077],
              [97.74732506600003, 15.626166083000044],
              [97.74463951900003, 15.634426174000055],
              [97.74024498800003, 15.64126211100006],
              [97.74447675900007, 15.65070221600007],
              [97.74366295700003, 15.664862372000073],
              [97.73845462300005, 15.67991771000004],
              [97.73023522200003, 15.69212474200009],
              [97.72559655000003, 15.701320705000057],
              [97.72738691500007, 15.71002838700008],
              [97.73170006600003, 15.718410549000055],
              [97.73389733200003, 15.726304429000038],
              [97.73080488400007, 15.733954169000071],
              [97.71680748800003, 15.74945709800005],
              [97.71290123800003, 15.757310289000088],
              [97.71412194100003, 15.763373114000046],
              [97.72339928500003, 15.77179596600007],
              [97.72641035200007, 15.777818101000037],
              [97.72706139400003, 15.84320709800005],
              [97.72136478000004, 15.85618724200009],
              [97.70606530000003, 15.86033763200004],
              [97.71225019600007, 15.88768138200004],
              [97.69141686300003, 15.912298895000049],
              [97.63721764400003, 15.949164130000042],
              [97.60971113400007, 15.983872789000088],
              [97.58228600400008, 16.009100653000075],
              [97.57569420700003, 16.017401434000078],
              [97.57593834700003, 16.02216217700004],
              [97.56885826900003, 16.06240469000005],
              [97.56934655000003, 16.07257721600007],
              [97.57178795700003, 16.080023505000042],
              [97.57699629000007, 16.08470286700009],
              [97.58594811300003, 16.086330471000053],
              [97.60084069100003, 16.09247467700004],
              [97.61215254000007, 16.10740794500009],
              [97.61963951900003, 16.125433661000045],
              [97.63900800900007, 16.238348700000074],
              [97.64820397200003, 16.25922272300005],
              [97.65088951900003, 16.271307684000078],
              [97.64991295700003, 16.28384023600006],
              [97.64673912900008, 16.29328034100007],
              [97.63721764400003, 16.312201239000046],
              [97.62647545700003, 16.351629950000074],
              [97.62305748800003, 16.394476630000042],
              [97.62663821700005, 16.437567450000074],
              [97.63721764400003, 16.477362372000073],
              [97.65186608200003, 16.50722890800006],
              [97.67383873800003, 16.53343333500004],
              [97.70313561300003, 16.552069403000075],
              [97.74008222700007, 16.55923086100006],
              [97.74024498800003, 16.55927155200004],
              [97.73552493600005, 16.566799221000053],
              [97.72950280000003, 16.57249583500004],
              [97.72185306100005, 16.57684967700004],
              [97.71290123800003, 16.579779364000046],
              [97.70354251400005, 16.573553778000075],
              [97.65284264400003, 16.539862372000073],
              [97.63038170700003, 16.53196849200009],
              [97.61296634200005, 16.530585028000075],
              [97.54835045700003, 16.53815338700008],
              [97.52295983200003, 16.536444403000075],
              [97.49984785200007, 16.53196849200009],
              [97.49398847700007, 16.528998114000046],
              [97.48943118600005, 16.52448151200008],
              [97.48414147200003, 16.52020905200004],
              [97.47632897200003, 16.51829661700009],
              [97.47071373800003, 16.519232489000046],
              [97.45875084700003, 16.523382880000042],
              [97.45215905000003, 16.524562893000052],
              [97.42310631600003, 16.52342357000009],
              [97.40259850400008, 16.516913153000075],
              [97.38648522200003, 16.50389232000009],
              [97.37029056100005, 16.483547268000052],
              [97.33741295700003, 16.63157786700009],
              [97.33741295700003, 16.655503648000092],
              [97.32982822700006, 16.679846809000082],
              [97.31119371300008, 16.652366398000083],
              [97.28583595300006, 16.658921726000074],
              [97.25544480700006, 16.697868885000048],
              [97.24027599700003, 16.731900687000063],
              [97.23017297700005, 16.769141733000083],
              [97.23020911700007, 16.796646165000084],
              [97.24480228000004, 16.81745026200008],
              [97.23568769600007, 16.82953522300005],
              [97.23308353000004, 16.83982982000009],
              [97.23340905000003, 16.848944403000075],
              [97.24048912900008, 16.87457916900007],
              [97.23308353000004, 16.87457916900007],
              [97.22429446700005, 16.853257554000038],
              [97.22087649800005, 16.840643622000073],
              [97.21949303500003, 16.82615794500009],
              [97.20899498800003, 16.833197333000044],
              [97.20484459700003, 16.84520091400009],
              [97.20460045700003, 16.859808661000045],
              [97.20582116000003, 16.87457916900007],
              [97.21949303500003, 16.901271877000056],
              [97.21143639400003, 16.907863674000055],
              [97.20240319100003, 16.906805731000077],
              [97.19157962300005, 16.901271877000056],
              [97.18327884200005, 16.921535549000055],
              [97.18669681100005, 16.947007554000038],
              [97.19898522200003, 16.99746328300006],
              [97.19825280000003, 17.013495184000078],
              [97.19507897200003, 17.021877346000053],
              [97.17847741000003, 17.03847890800006],
              [97.17212975400008, 17.046576239000046],
              [97.16456139400003, 17.05931224200009],
              [97.15853925900007, 17.07371653900009],
              [97.15723717500003, 17.086859442000048],
              [97.17448978000004, 17.112494208000044],
              [97.20240319100003, 17.106024481000077],
              [97.23365319100003, 17.09516022300005],
              [97.26099694100003, 17.10732656500005],
              [97.22234134200005, 17.125433661000045],
              [97.20264733200003, 17.13157786700009],
              [97.18189537900008, 17.134019273000092],
              [97.15805097700007, 17.129299221000053],
              [97.14795983200003, 17.116888739000046],
              [97.14193769600007, 17.099351304000038],
              [97.13062584700003, 17.079413153000075],
              [97.11443118600005, 17.10032786700009],
              [97.10027103000004, 17.13377513200004],
              [97.09595787900008, 17.165757554000038],
              [97.10962975400008, 17.182440497000073],
              [97.10962975400008, 17.189276434000078],
              [97.08871504000007, 17.193508205000057],
              [97.08179772200003, 17.209784247000073],
              [97.07862389400003, 17.231350002000056],
              [97.06861412900008, 17.25136953300006],
              [97.04867597700007, 17.26080963700008],
              [97.02361087300005, 17.26748281500005],
              [97.00717207100007, 17.27806224200009],
              [97.01335696700005, 17.29913971600007],
              [96.90455162900008, 17.37531159100007],
              [96.89551842500003, 17.38467031500005],
              [96.88990319100003, 17.39472077000005],
              [96.88705488400007, 17.411851304000038],
              [96.88835696700005, 17.444281317000048],
              [96.88306725400008, 17.457424221000053],
              [96.87159264400003, 17.44171784100007],
              [96.86345462300005, 17.40338776200008],
              [96.85572350400008, 17.388495184000078],
              [96.85206139400003, 17.39402903900009],
              [96.84449303500003, 17.40265534100007],
              [96.84205162900008, 17.409002997000073],
              [96.83570397200003, 17.406195380000042],
              [96.82984459700003, 17.402411200000074],
              [96.82488040500004, 17.398382880000042],
              [96.82154381600003, 17.39472077000005],
              [96.82837975400008, 17.388495184000078],
              [96.85124759200005, 17.35956452000005],
              [96.88461347700007, 17.33885325700004],
              [96.91065514400003, 17.31708405200004],
              [96.91089928500003, 17.284857489000046],
              [96.89047285200007, 17.260931708000044],
              [96.86548912900008, 17.240301825000074],
              [96.84937584700003, 17.212958075000074],
              [96.85572350400008, 17.168768622000073],
              [96.89527428500003, 17.10154857000009],
              [96.91016686300003, 17.066839911000045],
              [96.91089928500003, 17.02480703300006],
              [96.90495853000004, 17.01040273600006],
              [96.88689212300005, 16.979396877000056],
              [96.87907962300005, 16.934719143000052],
              [96.86833743600005, 16.92841217700004],
              [96.83521569100003, 16.936021226000037],
              [96.83806399800005, 16.92645905200004],
              [96.84253991000003, 16.917669989000046],
              [96.84839928500003, 16.909328518000052],
              [96.85572350400008, 16.901271877000056],
              [96.84278405000003, 16.902492580000057],
              [96.82081139400003, 16.907538153000075],
              [96.80787194100003, 16.908677476000037],
              [96.80787194100003, 16.901271877000056],
              [96.82154381600003, 16.894354559000078],
              [96.83432050900007, 16.885239976000037],
              [96.84400475400008, 16.873928127000056],
              [96.84888756600003, 16.860296942000048],
              [96.84669030000003, 16.844916083000044],
              [96.83187910200007, 16.821926174000055],
              [96.82569420700003, 16.799383856000077],
              [96.81128991000003, 16.76471588700008],
              [96.79639733200003, 16.76235586100006],
              [96.78939863400007, 16.75608958500004],
              [96.79086347700007, 16.74746328300006],
              [96.80103600400008, 16.73737213700008],
              [96.78321373800003, 16.71234772300005],
              [96.76612389400003, 16.697088934000078],
              [96.72584069100003, 16.669134833000044],
              [96.71631920700003, 16.658351955000057],
              [96.69841556100005, 16.62995026200008],
              [96.67947338500005, 16.57486789400008],
              [96.64002680300007, 16.545373148000067],
              [96.61594293000007, 16.518004835000056],
              [96.55897956600006, 16.49689671300007],
              [96.49762682200003, 16.48418735200005],
              [96.43626064100005, 16.47776837400005],
              [96.40015709700003, 16.504055080000057],
              [96.37712649800005, 16.50812409100007],
              [96.35710696700005, 16.518500067000048],
              [96.28980553500003, 16.566839911000045],
              [96.27312259200005, 16.582098700000074],
              [96.26596113400007, 16.596828518000052],
              [96.26498457100007, 16.62177155200004],
              [96.26156660200007, 16.640692450000074],
              [96.25562584700003, 16.65729401200008],
              [96.23552493600005, 16.697821356000077],
              [96.22925866000003, 16.71873607000009],
              [96.22641035200007, 16.739406643000052],
              [96.22575931100005, 16.76129791900007],
              [96.23454837300005, 16.77692291900007],
              [96.27491295700003, 16.802679755000042],
              [96.28711998800003, 16.81313711100006],
              [96.25757897200003, 16.81590403900009],
              [96.20655358200003, 16.777492580000057],
              [96.17115319100003, 16.771551825000074],
              [96.17693118600005, 16.762274481000077],
              [96.19410241000003, 16.74315013200004],
              [96.19776451900003, 16.734035549000055],
              [96.20460045700003, 16.696478583000044],
              [96.21485436300003, 16.679632880000042],
              [96.24089603000004, 16.650132554000038],
              [96.24610436300003, 16.631293036000045],
              [96.24382571700005, 16.61945221600007],
              [96.23365319100003, 16.59788646000004],
              [96.23194420700003, 16.587225653000075],
              [96.23462975400008, 16.57636139500005],
              [96.24634850400008, 16.55487702000005],
              [96.29444420700003, 16.491522528000075],
              [96.31006920700003, 16.464585679000038],
              [96.32732181100005, 16.45343659100007],
              [96.33643639400003, 16.43943919500009],
              [96.32129967500003, 16.415269273000092],
              [96.30469811300003, 16.406398830000057],
              [96.28533551400005, 16.365993422000088],
              [96.22181790800005, 16.34478726900005],
              [96.16423587300005, 16.33270905200004],
              [96.14405358200003, 16.32489655200004],
              [96.11898847700007, 16.32176341400009],
              [96.09766686300003, 16.328558661000045],
              [96.08855228000004, 16.34979889500005],
              [96.07740319100003, 16.36082591400009],
              [96.00660241000003, 16.38735586100006],
              [96.06657962300005, 16.335638739000046],
              [96.06755618600005, 16.310248114000046],
              [96.01880944100003, 16.256740627000056],
              [95.97999108200003, 16.223130601000037],
              [95.96192467500003, 16.21670156500005],
              [95.94239342500003, 16.21906159100007],
              [95.94174238400007, 16.22654857000009],
              [95.94857832100007, 16.23932526200008],
              [95.95142662900008, 16.257635809000078],
              [95.93384850400008, 16.243109442000048],
              [95.92212975400008, 16.225409247000073],
              [95.90788821700005, 16.211737372000073],
              [95.88306725400008, 16.20917389500005],
              [95.88624108200003, 16.217678127000056],
              [95.88990319100003, 16.243963934000078],
              [95.81812584700003, 16.17601146000004],
              [95.79769941500007, 16.144924221000053],
              [95.77662194100003, 16.140692450000074],
              [95.75554446700005, 16.14524974200009],
              [95.74586022200003, 16.158351955000057],
              [95.74480228000004, 16.174627997000073],
              [95.74122155000003, 16.19481028900009],
              [95.73462975400008, 16.212836005000042],
              [95.72486412900008, 16.22284577000005],
              [95.73226972700007, 16.12726471600007],
              [95.72527103000004, 16.10643138200004],
              [95.69703209700003, 16.06598541900007],
              [95.69068444100003, 16.048488674000055],
              [95.69068444100003, 16.00067780200004],
              [95.68734785200007, 15.988226630000042],
              [95.66472415500004, 15.94920482000009],
              [95.52344811300003, 15.803656317000048],
              [95.46159915500004, 15.76072825700004],
              [95.43197675900007, 15.733628648000092],
              [95.41578209700003, 15.72296784100007],
              [95.39649498800003, 15.716376044000071],
              [95.37419681100005, 15.715033270000049],
              [95.31055748800003, 15.723211981000077],
              [95.29444420700003, 15.727850653000075],
              [95.28793379000007, 15.74013906500005],
              [95.28256269600007, 15.838324286000045],
              [95.29029381600003, 15.84674713700008],
              [95.30225670700003, 15.852484442000048],
              [95.31267337300005, 15.866522528000075],
              [95.31771894600007, 15.884182033000059],
              [95.31397545700003, 15.90070221600007],
              [95.33855228000004, 15.922023830000057],
              [95.35474694100003, 15.951361395000049],
              [95.36426842500003, 15.984564520000049],
              [95.36915123800003, 16.017401434000078],
              [95.36850019600007, 16.038804429000038],
              [95.36361738400007, 16.054510809000078],
              [95.34864342500003, 16.086330471000053],
              [95.34546959700003, 16.10496653900009],
              [95.34961998800003, 16.116929429000038],
              [95.35661868600005, 16.12913646000004],
              [95.36158287900008, 16.148382880000042],
              [95.35547936300003, 16.148382880000042],
              [95.34791100400008, 16.138820705000057],
              [95.33822675900007, 16.12986888200004],
              [95.33025149800005, 16.119940497000073],
              [95.32748457100007, 16.10740794500009],
              [95.33179772200003, 16.091050523000092],
              [95.34555097700007, 16.06085846600007],
              [95.34864342500003, 16.041571356000077],
              [95.34571373800003, 15.996486721000053],
              [95.34180748800003, 15.983872789000088],
              [95.31185957100007, 15.947088934000078],
              [95.29712975400008, 15.90298086100006],
              [95.27475019600007, 15.876450914000088],
              [95.25163821700005, 15.86823151200008],
              [95.23878014400003, 15.893947658000059],
              [95.24610436300003, 15.915228583000044],
              [95.26270592500003, 15.940904039000088],
              [95.27588951900003, 15.970648505000042],
              [95.27295983200003, 16.003729559000078],
              [95.23902428500003, 15.950344143000052],
              [95.22396894600007, 15.91860586100006],
              [95.21762129000007, 15.884263414000088],
              [95.22437584700003, 15.810126044000071],
              [95.21273847700007, 15.78656647300005],
              [95.17359459700003, 15.777818101000037],
              [95.14454186300003, 15.789129950000074],
              [95.12574303500003, 15.817613023000092],
              [95.11622155000003, 15.855292059000078],
              [95.11524498800003, 15.893947658000059],
              [95.13754316500007, 16.006659247000073],
              [95.12891686300003, 16.03851959800005],
              [95.10775800900007, 15.983872789000088],
              [95.09766686300003, 16.025132554000038],
              [95.11019941500007, 16.06745026200008],
              [95.13795006600003, 16.10032786700009],
              [95.17359459700003, 16.11359284100007],
              [95.20720462300005, 16.11155833500004],
              [95.21762129000007, 16.11359284100007],
              [95.22592207100007, 16.119940497000073],
              [95.22250410200007, 16.124172268000052],
              [95.21225019600007, 16.12653229400007],
              [95.20069420700003, 16.12726471600007],
              [95.19369550900007, 16.129380601000037],
              [95.18881269600007, 16.138820705000057],
              [95.18360436300003, 16.14093659100007],
              [95.17847741000003, 16.139960028000075],
              [95.16309655000003, 16.134711005000042],
              [95.15552819100003, 16.134019273000092],
              [95.14869225400008, 16.132025458000044],
              [95.14242597700007, 16.134833075000074],
              [95.13575280000003, 16.148382880000042],
              [95.12891686300003, 16.148382880000042],
              [95.12159264400003, 16.131659247000073],
              [95.09400475400008, 16.09365469000005],
              [95.07056725400008, 16.07485586100006],
              [95.06788170700003, 16.04832591400009],
              [95.07374108200003, 15.99750397300005],
              [95.07292728000004, 15.970648505000042],
              [95.05502363400007, 15.846136786000045],
              [95.04688561300003, 15.822088934000078],
              [95.03394616000003, 15.80573151200008],
              [95.02377363400007, 15.80219147300005],
              [95.00993899800005, 15.799302476000037],
              [94.99756920700003, 15.795314846000053],
              [94.99244225400008, 15.788397528000075],
              [94.99048912900008, 15.78123607000009],
              [94.98617597700007, 15.77334219000005],
              [94.98072350400008, 15.766831773000092],
              [94.97559655000003, 15.764146226000037],
              [94.94996178500003, 15.762640692000048],
              [94.93775475400008, 15.764146226000037],
              [94.90357506600003, 15.777818101000037],
              [94.85865319100003, 15.782619533000059],
              [94.84685306100005, 15.790594794000071],
              [94.85865319100003, 15.80882396000004],
              [94.86931399800005, 15.81549713700008],
              [94.88054446700005, 15.820379950000074],
              [94.89039147200003, 15.827053127000056],
              [94.89673912900008, 15.839260158000059],
              [94.89633222700007, 15.847398179000038],
              [94.89283287900008, 15.856634833000044],
              [94.88770592500003, 15.864203192000048],
              [94.88257897200003, 15.86717357000009],
              [94.86394290500004, 15.844142971000053],
              [94.85320071700005, 15.840277411000045],
              [94.84839928500003, 15.863755601000037],
              [94.85010826900003, 15.895453192000048],
              [94.84839928500003, 15.908148505000042],
              [94.83594811300003, 15.936672268000052],
              [94.83472741000003, 15.949164130000042],
              [94.83961022200003, 15.962062893000052],
              [94.85035241000003, 15.978094794000071],
              [94.86280358200003, 15.991766669000071],
              [94.87256920700003, 15.99750397300005],
              [94.88949629000007, 15.99945709800005],
              [94.90723717500003, 16.00604889500005],
              [94.92066491000003, 16.01862213700008],
              [94.92408287900008, 16.03851959800005],
              [94.88933353000004, 16.017401434000078],
              [94.88453209700003, 16.036037502000056],
              [94.88021894600007, 16.07998281500005],
              [94.86353600400008, 16.11237213700008],
              [94.86312910200007, 16.127752997000073],
              [94.86841881600003, 16.14203522300005],
              [94.88705488400007, 16.170803127000056],
              [94.90007571700005, 16.18378327000005],
              [94.91732832100007, 16.19236888200004],
              [94.94092858200003, 16.19554271000004],
              [94.95923912900008, 16.200873114000046],
              [94.97510826900003, 16.21434153900009],
              [94.98682701900003, 16.232245184000078],
              [94.99244225400008, 16.250799872000073],
              [94.98804772200003, 16.24437083500004],
              [94.97478274800005, 16.23151276200008],
              [94.97193444100003, 16.22654857000009],
              [94.96697024800005, 16.220404364000046],
              [94.94288170700003, 16.21637604400007],
              [94.92465254000007, 16.208807684000078],
              [94.90251712300005, 16.20962148600006],
              [94.89307701900003, 16.20575592700004],
              [94.86841881600003, 16.173895575000074],
              [94.86573326900003, 16.168890692000048],
              [94.85466556100005, 16.160223700000074],
              [94.84945722700007, 16.139797268000052],
              [94.84839928500003, 16.096502997000073],
              [94.85059655000003, 16.085760809000078],
              [94.85987389400003, 16.06541575700004],
              [94.86207116000003, 16.055609442000048],
              [94.86402428500003, 16.049627997000073],
              [94.86768639400003, 16.045314846000053],
              [94.86939537900008, 16.040961005000042],
              [94.85645592500003, 16.018500067000048],
              [94.85523522200003, 16.01398346600007],
              [94.84620201900003, 15.99998607000009],
              [94.78687584700003, 15.962144273000092],
              [94.77418053500003, 15.94334544500009],
              [94.74537194100003, 15.88084544500009],
              [94.73519941500007, 15.868394273000092],
              [94.72120201900003, 15.856675523000092],
              [94.70386803500003, 15.848456122000073],
              [94.68384850400008, 15.84674713700008],
              [94.65870201900003, 15.85447825700004],
              [94.64893639400003, 15.86859772300005],
              [94.64454186300003, 15.887111721000053],
              [94.63550866000003, 15.908148505000042],
              [94.63282311300003, 15.88971588700008],
              [94.62240644600007, 15.891546942000048],
              [94.61019941500007, 15.904974677000041],
              [94.60132897200003, 15.921210028000075],
              [94.62867272200003, 15.939154364000046],
              [94.66553795700003, 15.957912502000056],
              [94.70313561300003, 15.982367255000042],
              [94.73226972700007, 16.017401434000078],
              [94.74170983200003, 16.067287502000056],
              [94.74903405000003, 16.07566966400009],
              [94.75806725400008, 16.08344147300005],
              [94.76587975400008, 16.09316640800006],
              [94.76978600400008, 16.10228099200009],
              [94.77198326900003, 16.110988674000055],
              [94.77271569100003, 16.131008205000057],
              [94.77662194100003, 16.134914455000057],
              [94.78516686300003, 16.13963450700004],
              [94.79265384200005, 16.14789459800005],
              [94.79371178500003, 16.16201406500005],
              [94.77515709700003, 16.151556708000044],
              [94.76596113400007, 16.139471747000073],
              [94.75220787900008, 16.10740794500009],
              [94.72543379000007, 16.06391022300005],
              [94.71802819100003, 16.044663804000038],
              [94.70533287900008, 16.020656643000052],
              [94.68921959700003, 16.00731028900009],
              [94.67139733200003, 15.996568101000037],
              [94.61475670700003, 15.94367096600007],
              [94.58985436300003, 15.931586005000042],
              [94.56657962300005, 15.935492255000042],
              [94.56234785200007, 15.961859442000048],
              [94.58871504000007, 15.996242580000057],
              [94.64234459700003, 16.044663804000038],
              [94.66334069100003, 16.07998281500005],
              [94.67888431100005, 16.12128327000005],
              [94.68669681100005, 16.165350653000075],
              [94.68384850400008, 16.20917389500005],
              [94.66871178500003, 16.24087148600006],
              [94.66521243600005, 16.257635809000078],
              [94.67359459700003, 16.274725653000075],
              [94.68531334700003, 16.29197825700004],
              [94.70492597700007, 16.353216864000046],
              [94.71070397200003, 16.36033763200004],
              [94.72055097700007, 16.362127997000073],
              [94.73226972700007, 16.360663153000075],
              [94.73226972700007, 16.36749909100007],
              [94.72169030000003, 16.37848541900007],
              [94.70582116000003, 16.473089911000045],
              [94.70622806100005, 16.484442450000074],
              [94.71070397200003, 16.497219143000052],
              [94.71729576900003, 16.50291575700004],
              [94.72543379000007, 16.505113023000092],
              [94.73161868600005, 16.510199286000045],
              [94.73226972700007, 16.524562893000052],
              [94.69727623800003, 16.508368231000077],
              [94.68392988400007, 16.51080963700008],
              [94.67701256600003, 16.53196849200009],
              [94.67017662900008, 16.50967031500005],
              [94.68384850400008, 16.42206452000005],
              [94.68384850400008, 16.364081122000073],
              [94.67847741000003, 16.348537502000056],
              [94.65512129000007, 16.322699286000045],
              [94.64975019600007, 16.30882396000004],
              [94.64372806100005, 16.28351471600007],
              [94.62794030000003, 16.260199286000045],
              [94.60670006600003, 16.243109442000048],
              [94.58399498800003, 16.23651764500005],
              [94.58204186300003, 16.243475653000075],
              [94.59262129000007, 16.25922272300005],
              [94.61500084700003, 16.285549221000053],
              [94.63550866000003, 16.32648346600007],
              [94.62973066500007, 16.344183661000045],
              [94.61817467500003, 16.34202708500004],
              [94.60670006600003, 16.325995184000078],
              [94.59888756600003, 16.29364655200004],
              [94.59253991000003, 16.28351471600007],
              [94.58366946700005, 16.27484772300005],
              [94.57398522200003, 16.271307684000078],
              [94.56202233200003, 16.27374909100007],
              [94.55404707100007, 16.279730536000045],
              [94.54761803500003, 16.28656647300005],
              [94.53988691500007, 16.29169342700004],
              [94.52116946700005, 16.295477606000077],
              [94.51563561300003, 16.287258205000057],
              [94.51880944100003, 16.247381903000075],
              [94.51734459700003, 16.223944403000075],
              [94.51319420700003, 16.205145575000074],
              [94.50700931100005, 16.189601955000057],
              [94.45557701900003, 16.105617580000057],
              [94.42807050900007, 16.074164130000042],
              [94.39649498800003, 16.058986721000053],
              [94.37574303500003, 16.05605703300006],
              [94.36060631600003, 16.049261786000045],
              [94.35132897200003, 16.034369208000044],
              [94.34799238400007, 16.007147528000075],
              [94.34001712300005, 15.996242580000057],
              [94.32146243600005, 15.989935614000046],
              [94.30079186300003, 15.989732164000088],
              [94.28663170700003, 15.99750397300005],
              [94.26563561300003, 15.975083726000037],
              [94.25147545700003, 15.968451239000046],
              [94.23951256600003, 15.976304429000038],
              [94.21461022200003, 16.014797268000052],
              [94.20980879000007, 16.028998114000046],
              [94.20923912900008, 16.04450104400007],
              [94.21509850400008, 16.15766022300005],
              [94.23780358200003, 16.273138739000046],
              [94.23536217500003, 16.34837474200009],
              [94.23812910200007, 16.360663153000075],
              [94.24170983200003, 16.366034247000073],
              [94.25407962300005, 16.379461981000077],
              [94.25863691500007, 16.38735586100006],
              [94.27312259200005, 16.466498114000046],
              [94.26832116000003, 16.527492580000057],
              [94.27312259200005, 16.53815338700008],
              [94.30860436300003, 16.527777411000045],
              [94.33106530000003, 16.528631903000075],
              [94.34131920700003, 16.54840729400007],
              [94.34896894600007, 16.57811107000009],
              [94.34620201900003, 16.59243398600006],
              [94.32764733200003, 16.60024648600006],
              [94.32764733200003, 16.60643138200004],
              [94.35206139400003, 16.61859772300005],
              [94.36198978000004, 16.63548411700009],
              [94.36231530000003, 16.68585846600007],
              [94.36443118600005, 16.701117255000042],
              [94.37338300900007, 16.729315497000073],
              [94.37549889400003, 16.740790106000077],
              [94.37964928500003, 16.75535716400009],
              [94.39844811300003, 16.775783596000053],
              [94.40267988400007, 16.788275458000044],
              [94.40064537900008, 16.830633856000077],
              [94.39649498800003, 16.846625067000048],
              [94.38347415500004, 16.872015692000048],
              [94.37891686300003, 16.88694896000004],
              [94.38233483200003, 16.901271877000056],
              [94.39063561300003, 16.906642971000053],
              [94.40064537900008, 16.904445705000057],
              [94.41187584700003, 16.90070221600007],
              [94.42318769600007, 16.901271877000056],
              [94.43531334700003, 16.91014232000009],
              [94.46469160200007, 16.949652411000045],
              [94.44434655000003, 16.949652411000045],
              [94.45386803500003, 16.965236721000053],
              [94.45777428500003, 16.982896226000037],
              [94.45671634200005, 17.050604559000078],
              [94.45785566500007, 17.05955638200004],
              [94.46192467500003, 17.069647528000075],
              [94.47836347700007, 17.093085028000075],
              [94.48414147200003, 17.10569896000004],
              [94.48878014400003, 17.124212958000044],
              [94.48568769600007, 17.141017971000053],
              [94.45777428500003, 17.15375397300005],
              [94.45264733200003, 17.16620514500005],
              [94.45435631600003, 17.180080471000053],
              [94.46469160200007, 17.189276434000078],
              [94.51091556100005, 17.16901276200008],
              [94.51880944100003, 17.17251211100006],
              [94.52247155000003, 17.177801825000074],
              [94.53044681100005, 17.18195221600007],
              [94.53785241000003, 17.18740469000005],
              [94.53988691500007, 17.19672272300005],
              [94.53500410200007, 17.205145575000074],
              [94.52662194100003, 17.209418036000045],
              [94.51783287900008, 17.212551174000055],
              [94.51197350400008, 17.217189846000053],
              [94.50863691500007, 17.230129299000055],
              [94.51197350400008, 17.275213934000078],
              [94.51889082100007, 17.28815338700008],
              [94.53321373800003, 17.290350653000075],
              [94.54542076900003, 17.296087958000044],
              [94.54615319100003, 17.319647528000075],
              [94.55933678500003, 17.31631094000005],
              [94.57252037900008, 17.311102606000077],
              [94.58448326900003, 17.303290106000077],
              [94.59449303500003, 17.292303778000075],
              [94.57683353000004, 17.358343817000048],
              [94.56771894600007, 17.46287669500009],
              [94.56657962300005, 17.476629950000074],
              [94.57007897200003, 17.493963934000078],
              [94.57032311300003, 17.505194403000075],
              [94.56657962300005, 17.518866278000075],
              [94.55933678500003, 17.532904364000046],
              [94.55543053500003, 17.538397528000075],
              [94.55388431100005, 17.54360586100006],
              [94.55347741000003, 17.556382554000038],
              [94.56031334700003, 17.582098700000074],
              [94.57691491000003, 17.576239325000074],
              [94.59701582100007, 17.557766018000052],
              [94.61500084700003, 17.54555898600006],
              [94.60922285200007, 17.55955638200004],
              [94.59066816500007, 17.59324778900009],
              [94.59107506600003, 17.60419342700004],
              [94.59522545700003, 17.61546458500004],
              [94.58952884200005, 17.62641022300005],
              [94.57398522200003, 17.641791083000044],
              [94.56299889400003, 17.66168854400007],
              [94.55689537900008, 17.682440497000073],
              [94.55347741000003, 17.727362372000073],
              [94.54395592500003, 17.74803294500009],
              [94.50171959700003, 17.78660716400009],
              [94.49219811300003, 17.816799221000053],
              [94.48951256600003, 17.876206773000092],
              [94.48340905000003, 17.902289130000042],
              [94.44743899800005, 17.97333405200004],
              [94.44434655000003, 17.988104559000078],
              [94.45085696700005, 18.002427476000037],
              [94.48178144600007, 18.01520416900007],
              [94.49219811300003, 18.025946356000077],
              [94.49488366000003, 18.04881419500009],
              [94.49057050900007, 18.07249583500004],
              [94.48096764400003, 18.094224351000037],
              [94.46192467500003, 18.12177155200004],
              [94.46062259200005, 18.13279857000009],
              [94.46062259200005, 18.144191799000055],
              [94.45785566500007, 18.15570709800005],
              [94.45232181100005, 18.16510651200008],
              [94.44109134200005, 18.17641836100006],
              [94.43677819100003, 18.18235911700009],
              [94.43018639400003, 18.22215403900009],
              [94.42286217500003, 18.24249909100007],
              [94.40650475400008, 18.251288153000075],
              [94.36060631600003, 18.24607982000009],
              [94.34156334700003, 18.24750397300005],
              [94.32764733200003, 18.258734442000048],
              [94.32585696700005, 18.267726955000057],
              [94.32618248800003, 18.281642971000053],
              [94.32797285200007, 18.29511139500005],
              [94.33106530000003, 18.303127346000053],
              [94.33920332100007, 18.305975653000075],
              [94.35027103000004, 18.292914130000042],
              [94.36589603000004, 18.298570054000038],
              [94.37859134200005, 18.28709544500009],
              [94.38917076900003, 18.286037502000056],
              [94.39698326900003, 18.291449286000045],
              [94.40902754000007, 18.30882396000004],
              [94.41700280000003, 18.31395091400009],
              [94.40528405000003, 18.33030833500004],
              [94.39958743600005, 18.348211981000077],
              [94.38965905000003, 18.36269765800006],
              [94.36548912900008, 18.36859772300005],
              [94.35059655000003, 18.37523021000004],
              [94.34400475400008, 18.39126211100006],
              [94.33920332100007, 18.410223700000074],
              [94.33106530000003, 18.42597077000005],
              [94.27963300900007, 18.480210679000038],
              [94.25896243600005, 18.509019273000092],
              [94.24496504000007, 18.53925202000005],
              [94.25896243600005, 18.535711981000077],
              [94.26221764400003, 18.54511139500005],
              [94.25294030000003, 18.62799713700008],
              [94.24878991000003, 18.63886139500005],
              [94.14893639400003, 18.731024481000077],
              [94.14893639400003, 18.73851146000004],
              [94.15642337300005, 18.73851146000004],
              [94.17457116000003, 18.725043036000045],
              [94.21159915500004, 18.725531317000048],
              [94.27930748800003, 18.73851146000004],
              [94.26368248800003, 18.74551015800006],
              [94.25245201900003, 18.75214264500005],
              [94.22803795700003, 18.735541083000044],
              [94.21241295700003, 18.741848049000055],
              [94.18295332100007, 18.785630601000037],
              [94.15308678500003, 18.82103099200009],
              [94.14730879000007, 18.83982982000009],
              [94.14893639400003, 18.86823151200008],
              [94.13819420700003, 18.86009349200009],
              [94.13355553500003, 18.846502997000073],
              [94.13331139400003, 18.831854559000078],
              [94.13510175900007, 18.820461330000057],
              [94.11963951900003, 18.81663646000004],
              [94.09839928500003, 18.82172272300005],
              [94.07846113400007, 18.83307526200008],
              [94.06690514400003, 18.84833405200004],
              [94.05713951900003, 18.84373607000009],
              [94.05323326900003, 18.84088776200008],
              [94.03809655000003, 18.859116929000038],
              [94.03207441500007, 18.88857656500005],
              [94.03663170700003, 18.918036200000074],
              [94.05323326900003, 18.93650950700004],
              [94.04037519600007, 18.971177476000037],
              [94.03907311300003, 18.984930731000077],
              [94.04118899800005, 18.99762604400007],
              [94.05103600400008, 19.014593817000048],
              [94.05323326900003, 19.02216217700004],
              [94.06348717500003, 19.040187893000052],
              [94.06609134200005, 19.04287344000005],
              [94.06446373800003, 19.049383856000077],
              [94.06169681100005, 19.057074286000045],
              [94.06006920700003, 19.063706773000035],
              [94.08692467500003, 19.080511786000045],
              [94.09424889400003, 19.08734772300005],
              [94.08008873800003, 19.08734772300005],
              [94.05665123800003, 19.080959377000056],
              [94.04656009200005, 19.08112213700008],
              [94.03052819100003, 19.087958075000074],
              [94.02906334700003, 19.095404364000046],
              [94.03443444100003, 19.105861721000053],
              [94.03907311300003, 19.12205638200004],
              [94.03785241000003, 19.13226959800005],
              [94.03191165500004, 19.153998114000046],
              [94.03272545700003, 19.169256903000075],
              [94.03736412900008, 19.18187083500004],
              [94.05054772200003, 19.208319403000075],
              [94.05323326900003, 19.22138092700004],
              [94.04590905000003, 19.30467357000009],
              [94.04997806100005, 19.320705471000053],
              [94.05990644600007, 19.329901434000078],
              [94.06967207100007, 19.350897528000075],
              [94.07390384200005, 19.373846747000073],
              [94.06690514400003, 19.38898346600007],
              [94.05697675900007, 19.363348700000074],
              [94.03060957100007, 19.31590403900009],
              [94.02523847700007, 19.28656647300005],
              [94.03321373800003, 19.23509349200009],
              [94.03337649800005, 19.20453522300005],
              [94.02222741000003, 19.19098541900007],
              [94.01042728000004, 19.17999909100007],
              [93.99439537900008, 19.159084377000056],
              [93.97348066500007, 19.146307684000078],
              [93.94711347700007, 19.15965403900009],
              [93.94263756600003, 19.16990794500009],
              [93.94117272200003, 19.194973049000055],
              [93.93726647200003, 19.20465729400007],
              [93.92546634200005, 19.210272528000075],
              [93.91602623800003, 19.203924872000073],
              [93.91041100400008, 19.19098541900007],
              [93.90992272200003, 19.176703192000048],
              [93.91488691500007, 19.169582424000055],
              [93.94711347700007, 19.139146226000037],
              [93.95541425900007, 19.126898505000042],
              [93.95557701900003, 19.118312893000052],
              [93.95240319100003, 19.109849351000037],
              [93.95020592500003, 19.098211981000077],
              [93.95248457100007, 19.032049872000073],
              [93.95777428500003, 19.012193101000037],
              [93.96452884200005, 19.00104401200008],
              [93.98121178500003, 18.98065827000005],
              [93.98438561300003, 18.96784088700008],
              [93.98340905000003, 18.956691799000055],
              [93.97868899800005, 18.94159577000005],
              [93.97754967500003, 18.933417059000078],
              [93.97388756600003, 18.922796942000048],
              [93.95020592500003, 18.89549388200004],
              [93.94792728000004, 18.894232489000046],
              [93.93930097700007, 18.89052969000005],
              [93.93726647200003, 18.88934967700004],
              [93.93718509200005, 18.88377513200004],
              [93.93913821700005, 18.876206773000035],
              [93.94190514400003, 18.86985911700009],
              [93.94410241000003, 18.86823151200008],
              [93.93043053500003, 18.858628648000035],
              [93.92025800900007, 18.86737702000005],
              [93.90739993600005, 18.881781317000048],
              [93.86573326900003, 18.89549388200004],
              [93.81373131600003, 18.94399648600006],
              [93.79395592500003, 18.953924872000073],
              [93.75025475400008, 18.970404364000046],
              [93.73462975400008, 18.98118724200009],
              [93.72673587300005, 18.99176666900007],
              [93.72120201900003, 19.001288153000075],
              [93.71485436300003, 19.010199286000045],
              [93.70386803500003, 19.018459377000056],
              [93.69353274800005, 19.02057526200008],
              [93.68604576900003, 19.01821523600006],
              [93.67888431100005, 19.019598700000074],
              [93.66968834700003, 19.03270091400009],
              [93.66773522200003, 19.04393138200004],
              [93.67090905000003, 19.066880601000037],
              [93.66627037900008, 19.077378648000035],
              [93.66041100400008, 19.085760809000078],
              [93.65503991000003, 19.09707265800006],
              [93.65088951900003, 19.10879140800006],
              [93.64918053500003, 19.11863841400009],
              [93.64234459700003, 19.13422272300005],
              [93.60743248800003, 19.162258205000057],
              [93.59400475400008, 19.176703192000048],
              [93.56714928500003, 19.23110586100006],
              [93.55640709700003, 19.23818594000005],
              [93.49781334700003, 19.31391022300005],
              [93.48707116000003, 19.333726304000038],
              [93.48324629000007, 19.35065338700008],
              [93.48414147200003, 19.392726955000057],
              [93.49089603000004, 19.40761953300006],
              [93.50782311300003, 19.42259349200009],
              [93.53012129000007, 19.432074286000045],
              [93.55298912900008, 19.430568752000056],
              [93.56039472700007, 19.42381419500009],
              [93.56381269600007, 19.41474030200004],
              [93.56804446700005, 19.406724351000037],
              [93.57715905000003, 19.403265692000048],
              [93.61133873800003, 19.403265692000048],
              [93.63111412900008, 19.372300523000035],
              [93.63697350400008, 19.34906647300005],
              [93.62134850400008, 19.334377346000053],
              [93.66529381600003, 19.305609442000048],
              [93.68751061300003, 19.296698309000078],
              [93.71753991000003, 19.293402411000045],
              [93.72291100400008, 19.268459377000056],
              [93.75464928500003, 19.24713776200008],
              [93.79688561300003, 19.235174872000073],
              [93.83423912900008, 19.23818594000005],
              [93.86548912900008, 19.25409577000005],
              [93.92994225400008, 19.299750067000048],
              [93.95020592500003, 19.320705471000053],
              [93.95093834700003, 19.32526276200008],
              [93.94906660200007, 19.337591864000046],
              [93.95020592500003, 19.34178294500009],
              [93.95313561300003, 19.343451239000046],
              [93.96143639400003, 19.346136786000045],
              [93.96387780000003, 19.348049221000053],
              [93.98096764400003, 19.372259833000044],
              [93.98731530000003, 19.38670482000009],
              [93.98804772200003, 19.40493398600006],
              [93.98438561300003, 19.437445380000042],
              [93.99024498800003, 19.449652411000045],
              [93.99105879000007, 19.457180080000057],
              [93.98438561300003, 19.464056708000044],
              [93.97836347700007, 19.463771877000056],
              [93.94711347700007, 19.457912502000056],
              [93.92383873800003, 19.46238841400009],
              [93.91456139400003, 19.472805080000057],
              [93.91920006600003, 19.48427969000005],
              [93.93726647200003, 19.492010809000078],
              [93.92676842500003, 19.497015692000048],
              [93.91602623800003, 19.498928127000056],
              [93.89242597700007, 19.498846747000073],
              [93.88209069100003, 19.501898505000042],
              [93.85523522200003, 19.52680084800005],
              [93.81470787900008, 19.55304596600007],
              [93.79444420700008, 19.571234442000048],
              [93.78565514400003, 19.59129466400009],
              [93.77719160200007, 19.60309479400007],
              [93.73959394600007, 19.61749909100007],
              [93.73121178500003, 19.632554429000038],
              [93.73845462300005, 19.65135325700004],
              [93.75611412900008, 19.661078192000048],
              [93.77865644600007, 19.662502346000053],
              [93.80005944100003, 19.65648021000004],
              [93.79444420700008, 19.673570054000038],
              [93.80250084700003, 19.68886953300006],
              [93.81617272200003, 19.70335521000004],
              [93.82740319100003, 19.718573309000078],
              [93.81316165500004, 19.739488023000035],
              [93.80681399800005, 19.745835679000038],
              [93.79916425900007, 19.717718817000048],
              [93.78386478000004, 19.691107489000046],
              [93.76107832100007, 19.67487213700008],
              [93.73121178500003, 19.67763906500005],
              [93.72095787900008, 19.685288804000038],
              [93.71314537900008, 19.697658596000053],
              [93.70948326900003, 19.71352773600006],
              [93.71127363400007, 19.731634833000044],
              [93.71876061300003, 19.74359772300005],
              [93.74187259200005, 19.754055080000057],
              [93.75163821700005, 19.765692450000074],
              [93.72193444100003, 19.76898834800005],
              [93.70883222700007, 19.75381094000005],
              [93.70248457100007, 19.73436107000009],
              [93.69353274800005, 19.72479889500005],
              [93.64844811300003, 19.725165106000077],
              [93.63624108200008, 19.73501211100006],
              [93.63550866000003, 19.759507554000038],
              [93.62330162900008, 19.733587958000044],
              [93.61557050900007, 19.723863023000035],
              [93.60141035200007, 19.718573309000078],
              [93.60141035200007, 19.78343333500004],
              [93.60645592500003, 19.796128648000035],
              [93.66065514400003, 19.870835679000038],
              [93.67994225400008, 19.883368231000077],
              [93.70394941500007, 19.885199286000045],
              [93.73804772200003, 19.882473049000055],
              [93.72877037900008, 19.893784898000035],
              [93.72559655000003, 19.905585028000075],
              [93.73047936300003, 19.91429271000004],
              [93.74537194100003, 19.916571356000077],
              [93.74000084700003, 19.925116278000075],
              [93.73365319100003, 19.932114976000037],
              [93.72624759200005, 19.93659088700008],
              [93.71753991000003, 19.93768952000005],
              [93.71168053500003, 19.93382396000004],
              [93.71159915500004, 19.919663804000038],
              [93.70753014400003, 19.916571356000077],
              [93.65650475400008, 19.91620514500005],
              [93.64551842500003, 19.91347890800006],
              [93.63819420700008, 19.910305080000057],
              [93.62916100400008, 19.909491278000075],
              [93.61133873800003, 19.91034577000005],
              [93.60840905000003, 19.906642971000053],
              [93.60084069100003, 19.88857656500005],
              [93.59400475400008, 19.882473049000055],
              [93.58073978000004, 19.881333726000037],
              [93.56674238400007, 19.885931708000044],
              [93.55469811300003, 19.893866278000075],
              [93.54672285200007, 19.902899481000077],
              [93.55160566500007, 19.90574778900009],
              [93.55958092500003, 19.912909247000073],
              [93.56592858200008, 19.916571356000077],
              [93.52906334700003, 19.930080471000053],
              [93.51832116000003, 19.939601955000057],
              [93.53191165500004, 19.95136139500005],
              [93.51710045700008, 19.95856354400007],
              [93.51197350400008, 19.970445054000038],
              [93.51685631600003, 19.98118724200009],
              [93.53191165500004, 19.984849351000037],
              [93.52955162900008, 19.99217357000009],
              [93.52564537900008, 19.999172268000052],
              [93.51368248800003, 19.993068752000056],
              [93.50342858200008, 19.986273505000042],
              [93.49586022200003, 19.977362372000073],
              [93.49219811300003, 19.964992580000057],
              [93.48731530000003, 19.97020091400009],
              [93.47543379000007, 19.97955963700008],
              [93.47046959700003, 19.984849351000037],
              [93.46322675900007, 19.961818752000056],
              [93.45704186300003, 19.954250393000052],
              [93.44654381600003, 19.95136139500005],
              [93.43531334700003, 19.95538971600007],
              [93.42318769600007, 19.965318101000037],
              [93.41358483200008, 19.97752513200004],
              [93.40967858200008, 19.98859284100007],
              [93.40447024800005, 20.012925523000035],
              [93.38396243600005, 20.064398505000042],
              [93.38233483200008, 20.08852773600006],
              [93.37484785200007, 20.08852773600006],
              [93.37452233200008, 20.050604559000078],
              [93.37208092500003, 20.03082916900007],
              [93.36182701900003, 20.02643463700008],
              [93.35596764400003, 20.038397528000075],
              [93.34066816500007, 20.10219961100006],
              [93.33383222700007, 20.10219961100006],
              [93.32650800900007, 20.081284898000035],
              [93.31275475400008, 20.065375067000048],
              [93.29395592500003, 20.05418528900009],
              [93.27247155000003, 20.04751211100006],
              [93.24463951900003, 20.04987213700008],
              [93.21517988400007, 20.05931224200009],
              [93.19027754000007, 20.06443919500009],
              [93.17628014400003, 20.05369700700004],
              [93.16138756600003, 20.060614325000074],
              [93.14747155000003, 20.070013739000046],
              [93.13607832100007, 20.08152903900009],
              [93.12842858200008, 20.094671942000048],
              [93.12989342500003, 20.075100002000056],
              [93.13672936300003, 20.05923086100006],
              [93.15577233200008, 20.02643463700008],
              [93.17628014400003, 19.957505601000037],
              [93.23585045700008, 19.84723541900007],
              [93.23829186300003, 19.82099030200004],
              [93.21762129000007, 19.837103583000044],
              [93.20142662900008, 19.86277903900009],
              [93.17628014400003, 19.916571356000077],
              [93.16065514400003, 19.96625397300005],
              [93.14812259200005, 19.99433014500005],
              [93.13152103000004, 20.00657786700009],
              [93.10914147200003, 19.993801174000055],
              [93.10206139400003, 19.964097398000035],
              [93.10613040500004, 19.93065013200004],
              [93.12435957100007, 19.893866278000075],
              [93.12989342500003, 19.86237213700008],
              [93.13453209700003, 19.84829336100006],
              [93.14730879000007, 19.833034572000088],
              [93.15113366000003, 19.830145575000074],
              [93.15577233200008, 19.827826239000046],
              [93.15894616000003, 19.82367584800005],
              [93.16895592500003, 19.809393622000073],
              [93.16879316500007, 19.80731842700004],
              [93.14918053500003, 19.828924872000073],
              [93.13941491000003, 19.831691799000055],
              [93.13453209700003, 19.834051825000074],
              [93.12501061300003, 19.84666575700004],
              [93.11264082100007, 19.874335028000075],
              [93.05941816500007, 19.951117255000042],
              [93.05274498800003, 19.968410549000055],
              [93.04867597700007, 19.99481842700004],
              [93.03842207100007, 20.012925523000035],
              [93.01172936300003, 20.04010651200008],
              [92.99154707100007, 20.067531643000052],
              [92.98072350400008, 20.077948309000078],
              [92.97592207100007, 20.087836005000042],
              [92.97413170700008, 20.117254950000074],
              [92.97022545700008, 20.129461981000077],
              [92.98829186300003, 20.12498607000009],
              [93.04249108200008, 20.129461981000077],
              [93.05445397200003, 20.13475169500009],
              [93.06470787900008, 20.14712148600006],
              [93.08008873800003, 20.170477606000077],
              [93.08269290500004, 20.16502513200004],
              [93.08497155000003, 20.16111888200004],
              [93.08668053500003, 20.156805731000077],
              [93.08692467500003, 20.14996979400007],
              [93.09424889400003, 20.14996979400007],
              [93.11548912900008, 20.20262278900009],
              [93.12094160200007, 20.21198151200008],
              [93.12094160200007, 20.21820709800005],
              [93.08920332100007, 20.21035390800006],
              [93.04737389400003, 20.16795482000009],
              [93.01856530000003, 20.14996979400007],
              [92.99048912900008, 20.15493398600006],
              [92.98747806100005, 20.186672268000052],
              [93.00123131600003, 20.23932526200008],
              [93.01880944100003, 20.25649648600006],
              [93.04127037900008, 20.33201732000009],
              [93.05616295700008, 20.34918854400007],
              [93.08082116000003, 20.358547268000052],
              [93.09131920700008, 20.381008205000057],
              [93.10043379000007, 20.43109772300005],
              [93.08187910200007, 20.41697825700004],
              [93.07252037900008, 20.376613674000055],
              [93.05958092500003, 20.362250067000048],
              [93.04322350400008, 20.364935614000046],
              [93.03419030000003, 20.38422272300005],
              [93.03101647200003, 20.40965403900009],
              [93.03223717500003, 20.43109772300005],
              [93.07056725400008, 20.496161200000074],
              [93.08562259200005, 20.532945054000038],
              [93.07325280000003, 20.554632880000042],
              [93.06869550900007, 20.535711981000077],
              [93.06031334700003, 20.513373114000046],
              [93.04908287900008, 20.49176666900007],
              [93.03565514400003, 20.475165106000077],
              [93.02263431100005, 20.45254140800006],
              [93.02003014400003, 20.42401764500005],
              [93.02491295700008, 20.368475653000075],
              [93.01628665500004, 20.32485586100006],
              [92.99480228000004, 20.28660716400009],
              [92.93604576900003, 20.21198151200008],
              [92.89844811300003, 20.135687567000048],
              [92.89503014400003, 20.133246161000045],
              [92.88941491000003, 20.12799713700008],
              [92.88054446700005, 20.123195705000057],
              [92.86768639400003, 20.122015692000048],
              [92.86036217500003, 20.124945380000042],
              [92.85523522200003, 20.130601304000038],
              [92.84669030000003, 20.143133856000077],
              [92.78296959700003, 20.189846096000053],
              [92.77214603000004, 20.20148346600007],
              [92.77361087300005, 20.216742255000042],
              [92.77816816500007, 20.231634833000044],
              [92.78663170700008, 20.245917059000078],
              [92.79948978000004, 20.25918203300006],
              [92.86402428500003, 20.30076732000009],
              [92.90121504000007, 20.30805084800005],
              [92.94288170700008, 20.321234442000048],
              [92.93392988400007, 20.325913804000038],
              [92.92530358200008, 20.327826239000046],
              [92.90528405000003, 20.328070380000042],
              [92.89332116000003, 20.32953522300005],
              [92.88965905000003, 20.333644924000055],
              [92.88770592500003, 20.340277411000045],
              [92.88070722700007, 20.34918854400007],
              [92.85661868600005, 20.367621161000045],
              [92.84693444100003, 20.377346096000053],
              [92.84050540500004, 20.39012278900009],
              [92.83155358200008, 20.478949286000045],
              [92.82691491000003, 20.495062567000048],
              [92.81527754000007, 20.504706122000073],
              [92.79265384200005, 20.506252346000053],
              [92.79656009200005, 20.48383209800005],
              [92.78532962300005, 20.462958075000074],
              [92.76929772200003, 20.45506419500009],
              [92.75855553500003, 20.47211334800005],
              [92.77344811300003, 20.47728099200009],
              [92.77898196700005, 20.478257554000038],
              [92.75098717500003, 20.498521226000037],
              [92.74170983200008, 20.52928294500009],
              [92.73658287900008, 20.56313711100006],
              [92.72071373800003, 20.592230536000045],
              [92.69955488400007, 20.619533596000053],
              [92.66285241000003, 20.67918528900009],
              [92.63502037900008, 20.69798411700009],
              [92.65943444100003, 20.652818101000037],
              [92.70443769600007, 20.589056708000044],
              [92.70826256600003, 20.578680731000077],
              [92.71697024800005, 20.49998607000009],
              [92.73747806100005, 20.44476959800005],
              [92.73845462300005, 20.42837148600006],
              [92.73121178500003, 20.38271719000005],
              [92.73926842500003, 20.279689846000053],
              [92.73121178500003, 20.25918203300006],
              [92.72388756600003, 20.271429755000042],
              [92.70630944100003, 20.292914130000042],
              [92.69711347700007, 20.308254299000055],
              [92.65316816500007, 20.41828034100007],
              [92.63257897200003, 20.446600653000075],
              [92.53988691500007, 20.52753327000005],
              [92.52914472700007, 20.543402411000045],
              [92.52003014400003, 20.589667059000078],
              [92.50700931100005, 20.60927969000005],
              [92.47055097700007, 20.643377997000073],
              [92.46322675900007, 20.65387604400007],
              [92.45964603000004, 20.662583726000037],
              [92.45362389400003, 20.668524481000077],
              [92.43921959700003, 20.670721747000073],
              [92.42896569100003, 20.673895575000074],
              [92.40845787900008, 20.687974351000037],
              [92.39820397200003, 20.691148179000038],
              [92.38111412900008, 20.700140692000048],
              [92.37086022200003, 20.72134023600006],
              [92.36068769600007, 20.766913153000075],
              [92.30543053500003, 20.917710679000038],
              [92.28809655000003, 20.94358958500004],
              [92.28101647200003, 20.959418036000045],
              [92.27051842500003, 21.04901764500005],
              [92.26514733200008, 21.061102606000077],
              [92.22427209500012, 21.09318389900004],
              [92.21838098200004, 21.108635152000133],
              [92.21176639800012, 21.12351796500009],
              [92.18830529800005, 21.144085185000066],
              [92.18076053900012, 21.157882793000013],
              [92.17497277900003, 21.175607809000027],
              [92.17838342300007, 21.191265767000075],
              [92.18396447700007, 21.220876364000034],
              [92.18520471200003, 21.240410055000055],
              [92.17807336400006, 21.28014923100004],
              [92.17828007100013, 21.299734599000075],
              [92.1836544190001, 21.317201233],
              [92.21155969200004, 21.35487335200004],
              [92.22509891700014, 21.3974547320001],
              [92.23626102800006, 21.41709177700004],
              [92.25290083800007, 21.419520569000028],
              [92.2845268150001, 21.419055481000086],
              [92.32266402200014, 21.46189524300003],
              [92.35470341000007, 21.451818340000088],
              [92.36793257700003, 21.435436910000035],
              [92.37217004400003, 21.419055481000086],
              [92.37423710100006, 21.40231231800003],
              [92.38116174400005, 21.384794006000064],
              [92.38963667800004, 21.37652577800013],
              [92.40028202400003, 21.370996400000124],
              [92.42312300700013, 21.363658345000132],
              [92.46539432800012, 21.35983429],
              [92.49867395000007, 21.366603902000023],
              [92.52451216700007, 21.361126201000033],
              [92.54394250500008, 21.320921937000023],
              [92.55159061700004, 21.28051096600005],
              [92.55872196500007, 21.259840393000033],
              [92.57060754400004, 21.247283020000012],
              [92.59086470600005, 21.248884990000036],
              [92.61432580600007, 21.26314768500002],
              [92.63375614400007, 21.28221628900009],
              [92.64285119700003, 21.298442688000094],
              [92.64103990600012, 21.30858591800002],
              [92.63923384600008, 21.3186998500001],
              [92.60326704900007, 21.42008901000007],
              [92.59272505700005, 21.470163472000067],
              [92.59024458800008, 21.49553660100007],
              [92.57556848200005, 21.73397166000005],
              [92.59303511600012, 21.886933899000027],
              [92.59024458800008, 21.91716461200012],
              [92.57587854000013, 21.977574362000027],
            ],
          ],
          [
            [
              [98.05746504000007, 9.79686107000009],
              [98.03760826900003, 9.790716864000046],
              [98.01832116000003, 9.79490794500009],
              [98.00806725400008, 9.807440497000073],
              [98.01539147200003, 9.82640208500004],
              [98.03028405000003, 9.833400783000059],
              [98.04607181100005, 9.827948309000078],
              [98.05689537900008, 9.81435781500005],
              [98.05746504000007, 9.79686107000009],
            ],
          ],
          [
            [
              [98.22868899800005, 10.519964911000045],
              [98.22185306100005, 10.498114325000074],
              [98.20736738400007, 10.48346588700008],
              [98.19271894600007, 10.48240794500009],
              [98.18531334700003, 10.501166083000044],
              [98.18970787900008, 10.515570380000042],
              [98.20199629000007, 10.524318752000056],
              [98.21794681100005, 10.528550523000092],
              [98.23365319100003, 10.529364325000074],
              [98.23243248800003, 10.526922919000071],
              [98.22982832100007, 10.522406317000048],
              [98.22868899800005, 10.519964911000045],
            ],
          ],
          [
            [
              [98.42953535200007, 10.977728583000044],
              [98.43287194100003, 10.99359772300005],
              [98.44255618600005, 11.00299713700008],
              [98.45142662900008, 11.00193919500009],
              [98.45289147200003, 10.986273505000042],
              [98.44800866000003, 10.974310614000046],
              [98.44027754000007, 10.96556224200009],
              [98.43295332100007, 10.965033270000049],
              [98.42953535200007, 10.977728583000044],
            ],
          ],
          [
            [
              [97.46452884200005, 11.782456773000092],
              [97.45923912900008, 11.78620026200008],
              [97.44434655000003, 11.80023834800005],
              [97.46290123800003, 11.79979075700004],
              [97.47689863400007, 11.788234768000052],
              [97.47966556100005, 11.77798086100006],
              [97.46452884200005, 11.782456773000092],
            ],
          ],
          [
            [
              [97.83692467500003, 12.77244700700004],
              [97.83529707100007, 12.792792059000078],
              [97.84180748800003, 12.805812893000052],
              [97.85279381600003, 12.80654531500005],
              [97.86459394600007, 12.790228583000044],
              [97.86801191500007, 12.774807033000059],
              [97.86353600400008, 12.766831773000092],
              [97.85254967500003, 12.76626211100006],
              [97.83692467500003, 12.77244700700004],
            ],
          ],
          [
            [
              [98.29566491000003, 10.048895575000074],
              [98.28003991000003, 10.05101146000004],
              [98.27393639400003, 10.048041083000044],
              [98.27369225400008, 10.042181708000044],
              [98.27515709700003, 10.035834052000041],
              [98.28101647200003, 10.02838776200008],
              [98.28939863400007, 10.024318752000056],
              [98.29411868600005, 10.019110419000071],
              [98.28825931100005, 10.007961330000057],
              [98.26921634200005, 10.00259023600006],
              [98.25814863400007, 9.985988674000055],
              [98.25123131600003, 9.968329169000071],
              [98.24390709700003, 9.960109768000052],
              [98.22779381600003, 9.954006252000056],
              [98.19353274800005, 9.931463934000078],
              [98.17896569100003, 9.932806708000044],
              [98.17546634200005, 9.921454169000071],
              [98.17090905000003, 9.912258205000057],
              [98.16846764400003, 9.90460846600007],
              [98.17156009200005, 9.898098049000055],
              [98.14576256600003, 9.856838283000059],
              [98.13347415500004, 9.84560781500005],
              [98.13119550900007, 9.864488023000092],
              [98.12061608200003, 9.86131419500009],
              [98.11719811300003, 9.882025458000044],
              [98.11817467500003, 9.90851471600007],
              [98.12037194100003, 9.922552802000041],
              [98.12427819100003, 9.931382554000038],
              [98.12745201900003, 9.960109768000052],
              [98.14063561300003, 9.963283596000053],
              [98.14820397200003, 9.970363674000055],
              [98.15186608200003, 9.977443752000056],
              [98.15447024800005, 9.980617580000057],
              [98.16016686300003, 9.984116929000038],
              [98.16431725400008, 9.992254950000074],
              [98.16781660200007, 10.00141022300005],
              [98.17156009200005, 10.007961330000057],
              [98.17896569100003, 10.014105536000045],
              [98.20573978000004, 10.028998114000046],
              [98.23462975400008, 10.054185289000088],
              [98.25440514400003, 10.062689520000049],
              [98.27515709700003, 10.05565013200004],
              [98.27963300900007, 10.058661200000074],
              [98.28248131600003, 10.059393622000073],
              [98.29566491000003, 10.05565013200004],
              [98.29566491000003, 10.048895575000074],
            ],
          ],
          [
            [
              [98.18580162900008, 10.121161200000074],
              [98.18360436300003, 10.127020575000074],
              [98.17383873800003, 10.140122789000088],
              [98.17156009200005, 10.148138739000046],
              [98.17530358200003, 10.159409898000092],
              [98.18189537900008, 10.16860586100006],
              [98.18523196700005, 10.17682526200008],
              [98.17896569100003, 10.18545156500005],
              [98.17896569100003, 10.192857164000088],
              [98.19605553500003, 10.193182684000078],
              [98.22217858200003, 10.177923895000049],
              [98.24048912900008, 10.172349351000037],
              [98.24089603000004, 10.167792059000078],
              [98.23951256600003, 10.166489976000037],
              [98.23682701900003, 10.166408596000053],
              [98.23365319100003, 10.165513414000088],
              [98.23072350400008, 10.159572658000059],
              [98.22779381600003, 10.15525950700004],
              [98.22771243600005, 10.150824286000045],
              [98.23365319100003, 10.144476630000042],
              [98.21843509200005, 10.13617584800005],
              [98.20777428500003, 10.128648179000038],
              [98.20142662900008, 10.118068752000056],
              [98.19532311300003, 10.070502020000049],
              [98.18580162900008, 10.04205963700008],
              [98.18580162900008, 10.121161200000074],
            ],
          ],
          [
            [
              [97.91146894600007, 10.494533596000053],
              [97.90259850400008, 10.479315497000073],
              [97.90870201900003, 10.473456122000073],
              [97.91944420700003, 10.473089911000045],
              [97.92505944100003, 10.47406647300005],
              [97.93067467500003, 10.468166408000059],
              [97.93531334700003, 10.46116771000004],
              [97.94353274800005, 10.443793036000045],
              [97.93848717500003, 10.43781159100007],
              [97.93336022200003, 10.433742580000057],
              [97.92676842500003, 10.432033596000053],
              [97.91773522200003, 10.43305084800005],
              [97.92693118600005, 10.417181708000044],
              [97.93189537900008, 10.41201406500005],
              [97.91016686300003, 10.401922919000071],
              [97.89380944100003, 10.405991929000038],
              [97.88941491000003, 10.419989325000074],
              [97.90406334700003, 10.439276434000078],
              [97.89779707100007, 10.452093817000048],
              [97.89340254000007, 10.470770575000074],
              [97.89625084700003, 10.487534898000092],
              [97.91146894600007, 10.494533596000053],
            ],
          ],
          [
            [
              [98.49366295700003, 10.891099351000037],
              [98.51880944100003, 10.879095770000049],
              [98.54224694100003, 10.860052802000041],
              [98.55323326900003, 10.832831122000073],
              [98.54151451900003, 10.796210028000075],
              [98.52711022200003, 10.786932684000078],
              [98.50953209700003, 10.786607164000088],
              [98.49838300900007, 10.79360586100006],
              [98.50416100400008, 10.80609772300005],
              [98.51295006600003, 10.80955638200004],
              [98.52068118600005, 10.809271552000041],
              [98.52637780000003, 10.81085846600007],
              [98.52849368600005, 10.820054429000038],
              [98.52556399800005, 10.826849677000041],
              [98.51832116000003, 10.829494533000059],
              [98.50912519600007, 10.828314520000049],
              [98.50049889400003, 10.823472398000092],
              [98.50049889400003, 10.837144273000092],
              [98.49488366000003, 10.851263739000046],
              [98.49146569100003, 10.866685289000088],
              [98.49089603000004, 10.880804755000042],
              [98.49366295700003, 10.891099351000037],
            ],
          ],
          [
            [
              [97.89039147200003, 10.884955145000049],
              [97.89633222700007, 10.913275458000044],
              [97.91195722700007, 10.924261786000045],
              [97.93197675900007, 10.92405833500004],
              [97.95183353000004, 10.919094143000052],
              [97.94125410200007, 10.891546942000048],
              [97.92774498800003, 10.871975002000056],
              [97.90919030000003, 10.857245184000078],
              [97.88355553500003, 10.844549872000073],
              [97.89063561300003, 10.854722398000092],
              [97.89454186300003, 10.86424388200004],
              [97.89454186300003, 10.873968817000048],
              [97.89039147200003, 10.884955145000049],
            ],
          ],
          [
            [
              [98.26775149800005, 10.837144273000092],
              [98.27068118600005, 10.81867096600007],
              [98.27076256600003, 10.798895575000074],
              [98.27637780000003, 10.784491278000075],
              [98.29566491000003, 10.781927802000041],
              [98.28687584700003, 10.768947658000059],
              [98.28296959700003, 10.756537177000041],
              [98.28532962300005, 10.745062567000048],
              [98.29566491000003, 10.73468659100007],
              [98.29053795700003, 10.735256252000056],
              [98.28923587300005, 10.733587958000044],
              [98.28931725400008, 10.730617580000057],
              [98.28825931100005, 10.72728099200009],
              [98.27662194100003, 10.705145575000074],
              [98.26783287900008, 10.696519273000092],
              [98.25074303500003, 10.693101304000038],
              [98.23682701900003, 10.697333075000074],
              [98.23218834700003, 10.708319403000075],
              [98.23365319100003, 10.74095286700009],
              [98.23780358200003, 10.73818594000005],
              [98.24048912900008, 10.73468659100007],
              [98.25554446700005, 10.74640534100007],
              [98.25163821700005, 10.756008205000057],
              [98.23365319100003, 10.768255927000041],
              [98.23389733200003, 10.782863674000055],
              [98.24195397200003, 10.814398505000042],
              [98.24048912900008, 10.830959377000056],
              [98.23658287900008, 10.833644924000055],
              [98.22291100400008, 10.83779531500005],
              [98.21998131600003, 10.84088776200008],
              [98.21949303500003, 10.84983958500004],
              [98.21851647200003, 10.855617580000057],
              [98.21631920700003, 10.859849351000037],
              [98.19874108200003, 10.881659247000073],
              [98.17896569100003, 10.898586330000057],
              [98.17676842500003, 10.894029039000088],
              [98.17335045700003, 10.88930898600006],
              [98.17156009200005, 10.884955145000049],
              [98.16529381600003, 10.919094143000052],
              [98.15577233200003, 10.923976955000057],
              [98.14673912900008, 10.924505927000041],
              [98.14014733200003, 10.91990794500009],
              [98.13746178500003, 10.909125067000048],
              [98.13103274800005, 10.902899481000077],
              [98.10027103000004, 10.882025458000044],
              [98.08961022200003, 10.878119208000044],
              [98.07740319100003, 10.888088283000059],
              [98.08619225400008, 10.903957424000055],
              [98.11011803500003, 10.929348049000055],
              [98.11296634200005, 10.934027411000045],
              [98.12631269600007, 10.942206122000073],
              [98.13119550900007, 10.94635651200008],
              [98.13331139400003, 10.952948309000078],
              [98.13672936300003, 10.970648505000042],
              [98.14087975400008, 10.977443752000056],
              [98.15349368600005, 10.981146552000041],
              [98.17188561300003, 10.978664455000057],
              [98.19117272200003, 10.971177476000037],
              [98.20573978000004, 10.96002838700008],
              [98.21558678500003, 10.944525458000044],
              [98.22201582100007, 10.926662502000056],
              [98.22559655000003, 10.907416083000044],
              [98.22681725400008, 10.888088283000059],
              [98.23178144600007, 10.870266018000052],
              [98.24366295700003, 10.85927969000005],
              [98.25733483200003, 10.84992096600007],
              [98.26775149800005, 10.837144273000092],
            ],
          ],
          [
            [
              [98.52849368600005, 10.974310614000046],
              [98.51880944100003, 10.971096096000053],
              [98.51205488400007, 10.965236721000053],
              [98.50847415500004, 10.956854559000078],
              [98.50798587300005, 10.94635651200008],
              [98.48585045700003, 10.955877997000073],
              [98.47706139400003, 10.97370026200008],
              [98.47836347700007, 10.993353583000044],
              [98.48682701900003, 11.00844961100006],
              [98.50318444100003, 11.021144924000055],
              [98.50953209700003, 11.027736721000053],
              [98.51417076900003, 11.03579336100006],
              [98.51587975400008, 11.045355536000045],
              [98.51343834700003, 11.063055731000077],
              [98.51417076900003, 11.069891669000071],
              [98.52466881600003, 11.08665599200009],
              [98.53191165500004, 11.083807684000078],
              [98.53711998800003, 11.068915106000077],
              [98.54460696700005, 11.031195380000042],
              [98.54517662900008, 11.01593659100007],
              [98.54151451900003, 10.987982489000046],
              [98.54314212300005, 10.960109768000052],
              [98.54151451900003, 10.953802802000041],
              [98.53394616000003, 10.950832424000055],
              [98.53003991000003, 10.957180080000057],
              [98.52849368600005, 10.966945705000057],
              [98.52849368600005, 10.974310614000046],
            ],
          ],
          [
            [
              [98.27515709700003, 11.24803294500009],
              [98.28101647200003, 11.245835679000038],
              [98.29004967500003, 11.248114325000074],
              [98.29835045700003, 11.248602606000077],
              [98.30201256600003, 11.24119700700004],
              [98.29509524800005, 11.231146552000041],
              [98.27955162900008, 11.223211981000077],
              [98.24732506600003, 11.214504299000055],
              [98.24732506600003, 11.22752513200004],
              [98.24317467500003, 11.242987372000073],
              [98.23218834700003, 11.25381094000005],
              [98.22185306100005, 11.261908270000049],
              [98.21998131600003, 11.269110419000071],
              [98.23170006600003, 11.273911851000037],
              [98.25245201900003, 11.276068427000041],
              [98.28142337300005, 11.275946356000077],
              [98.27466881600003, 11.256293036000045],
              [98.27515709700003, 11.24803294500009],
            ],
          ],
          [
            [
              [98.27833092500003, 11.79979075700004],
              [98.29184004000007, 11.798895575000074],
              [98.30665123800003, 11.777411200000074],
              [98.31820722700007, 11.74998607000009],
              [98.32300866000003, 11.731268622000073],
              [98.32007897200003, 11.721909898000092],
              [98.31348717500003, 11.718695380000042],
              [98.30640709700003, 11.717474677000041],
              [98.30201256600003, 11.714178778000075],
              [98.30030358200003, 11.704779364000046],
              [98.30201256600003, 11.673244533000059],
              [98.29004967500003, 11.631659247000073],
              [98.28785241000003, 11.610907294000071],
              [98.29566491000003, 11.59125397300005],
              [98.28256269600007, 11.566351630000042],
              [98.28353925900007, 11.509426174000055],
              [98.27515709700003, 11.48078034100007],
              [98.26775149800005, 11.488226630000042],
              [98.26587975400008, 11.48305898600006],
              [98.26351972700007, 11.47882721600007],
              [98.26156660200007, 11.474188544000071],
              [98.26091556100005, 11.46775950700004],
              [98.25171959700003, 11.476507880000042],
              [98.23764082100007, 11.493801174000055],
              [98.23365319100003, 11.501898505000042],
              [98.22673587300005, 11.494289455000057],
              [98.22348066500007, 11.488836981000077],
              [98.22364342500003, 11.482977606000077],
              [98.22681725400008, 11.473944403000075],
              [98.21013431100005, 11.472723700000074],
              [98.20199629000007, 11.46625397300005],
              [98.20460045700003, 11.458482164000088],
              [98.21998131600003, 11.453517971000053],
              [98.21029707100007, 11.448919989000046],
              [98.19890384200005, 11.446478583000044],
              [98.18702233200003, 11.446437893000052],
              [98.17652428500003, 11.449164130000042],
              [98.16529381600003, 11.453517971000053],
              [98.16488691500007, 11.458482164000088],
              [98.16529381600003, 11.473944403000075],
              [98.17505944100003, 11.470892645000049],
              [98.18409264400003, 11.47264232000009],
              [98.19223066500007, 11.478664455000057],
              [98.19947350400008, 11.488226630000042],
              [98.19646243600005, 11.49705638200004],
              [98.19263756600003, 11.518011786000045],
              [98.18897545700003, 11.525824286000045],
              [98.18751061300003, 11.534979559000078],
              [98.19646243600005, 11.542385158000059],
              [98.20753014400003, 11.548407294000071],
              [98.21314537900008, 11.553412177000041],
              [98.21094811300003, 11.561468817000048],
              [98.20630944100003, 11.56476471600007],
              [98.20167076900003, 11.56907786700009],
              [98.19947350400008, 11.580471096000053],
              [98.20264733200003, 11.589178778000075],
              [98.21680748800003, 11.598944403000075],
              [98.22291100400008, 11.617580471000053],
              [98.22974694100003, 11.62099844000005],
              [98.23658287900008, 11.622259833000044],
              [98.24048912900008, 11.624823309000078],
              [98.24089603000004, 11.63617584800005],
              [98.23462975400008, 11.655585028000075],
              [98.23365319100003, 11.666408596000053],
              [98.23845462300005, 11.687079169000071],
              [98.26775149800005, 11.741441148000092],
              [98.27247155000003, 11.786078192000048],
              [98.27833092500003, 11.79979075700004],
            ],
          ],
          [
            [
              [98.53532962300005, 11.803615627000056],
              [98.54371178500003, 11.798976955000057],
              [98.54900149800005, 11.791571356000077],
              [98.55241946700005, 11.781642971000053],
              [98.55518639400003, 11.76943594000005],
              [98.55640709700003, 11.758734442000048],
              [98.55551191500007, 11.728094794000071],
              [98.54607181100005, 11.69920482000009],
              [98.54900149800005, 11.62173086100006],
              [98.54574629000007, 11.609035549000055],
              [98.53158613400007, 11.593329169000071],
              [98.52849368600005, 11.580471096000053],
              [98.52955162900008, 11.566799221000053],
              [98.53419030000003, 11.542629299000055],
              [98.53532962300005, 11.529242255000042],
              [98.52418053500003, 11.53701406500005],
              [98.50855553500003, 11.555894273000092],
              [98.50049889400003, 11.563381252000056],
              [98.48975670700003, 11.567206122000073],
              [98.47681725400008, 11.570257880000042],
              [98.46517988400007, 11.574896552000041],
              [98.45899498800003, 11.583807684000078],
              [98.44190514400003, 11.564113674000055],
              [98.43238366000003, 11.56671784100007],
              [98.42920983200003, 11.583156643000052],
              [98.43165123800003, 11.60492584800005],
              [98.42383873800003, 11.59906647300005],
              [98.41911868600005, 11.599554755000042],
              [98.41570071700005, 11.604437567000048],
              [98.41163170700003, 11.611761786000045],
              [98.41863040500004, 11.63226959800005],
              [98.41041100400008, 11.646063544000071],
              [98.39771569100003, 11.655462958000044],
              [98.39128665500004, 11.662990627000056],
              [98.37940514400003, 11.691107489000046],
              [98.38209069100003, 11.70416901200008],
              [98.40552819100003, 11.707953192000048],
              [98.39926191500007, 11.716131903000075],
              [98.38135826900003, 11.731350002000056],
              [98.37761478000004, 11.738023179000038],
              [98.37989342500003, 11.750921942000048],
              [98.38559004000007, 11.755519924000055],
              [98.39242597700007, 11.757310289000088],
              [98.39812259200005, 11.76194896000004],
              [98.40259850400008, 11.76390208500004],
              [98.41041100400008, 11.76862213700008],
              [98.41309655000003, 11.773382880000042],
              [98.40170332100007, 11.775580145000049],
              [98.39087975400008, 11.77537669500009],
              [98.38209069100003, 11.776190497000073],
              [98.37533613400007, 11.780096747000073],
              [98.37077884200005, 11.789252020000049],
              [98.39372806100005, 11.79401276200008],
              [98.43824303500003, 11.787054755000042],
              [98.45281009200005, 11.789252020000049],
              [98.44947350400008, 11.79328034100007],
              [98.44760175900007, 11.796087958000044],
              [98.44532311300003, 11.803615627000056],
              [98.45834394600007, 11.80337148600006],
              [98.48682701900003, 11.796087958000044],
              [98.49887129000007, 11.798041083000044],
              [98.52214603000004, 11.804754950000074],
              [98.53532962300005, 11.803615627000056],
            ],
          ],
          [
            [
              [98.05543053500003, 11.701117255000042],
              [98.06348717500003, 11.69725169500009],
              [98.06771894600007, 11.691066799000055],
              [98.06755618600005, 11.682928778000075],
              [98.06169681100005, 11.673244533000059],
              [98.07911217500003, 11.653794664000088],
              [98.08529707100007, 11.644924221000053],
              [98.08961022200003, 11.63226959800005],
              [98.06511478000004, 11.64638906500005],
              [98.05738366000003, 11.653143622000073],
              [98.05543053500003, 11.659572658000059],
              [98.04932701900003, 11.66469961100006],
              [98.03435306100005, 11.686835028000075],
              [98.01661217500003, 11.69749583500004],
              [98.01172936300003, 11.704738674000055],
              [98.02442467500003, 11.707953192000048],
              [98.02833092500003, 11.717189846000053],
              [98.02857506600003, 11.737005927000041],
              [98.02247155000003, 11.755804755000042],
              [98.00709069100003, 11.76194896000004],
              [98.01189212300005, 11.787258205000057],
              [97.99976647200003, 11.84178294500009],
              [98.01392662900008, 11.864976304000038],
              [98.01197350400008, 11.827378648000092],
              [98.01392662900008, 11.816595770000049],
              [98.01929772200003, 11.810492255000042],
              [98.04493248800003, 11.789252020000049],
              [98.05225670700003, 11.77602773600006],
              [98.05241946700005, 11.749416408000059],
              [98.05795332100007, 11.729071356000077],
              [98.08228600400008, 11.73468659100007],
              [98.08073978000004, 11.72264232000009],
              [98.07471764400003, 11.713364976000037],
              [98.06568444100003, 11.706366278000075],
              [98.05543053500003, 11.701117255000042],
            ],
          ],
          [
            [
              [97.66439863400007, 11.905951239000046],
              [97.67448978000004, 11.89744700700004],
              [97.67847741000003, 11.887884833000044],
              [97.67628014400003, 11.877834377000056],
              [97.66822350400008, 11.868109442000048],
              [97.66667728000004, 11.863430080000057],
              [97.67188561300003, 11.837713934000078],
              [97.66773522200003, 11.838283596000053],
              [97.65088951900003, 11.844549872000073],
              [97.64283287900008, 11.867661851000037],
              [97.64356530000003, 11.880357164000088],
              [97.66439863400007, 11.905951239000046],
            ],
          ],
          [
            [
              [98.25416100400008, 11.85814036700009],
              [98.25391686300003, 11.88385651200008],
              [98.25652103000004, 11.902533270000049],
              [98.26539147200003, 11.90851471600007],
              [98.28484134200005, 11.896063544000071],
              [98.28907311300003, 11.882391669000071],
              [98.28419030000003, 11.86546458500004],
              [98.27369225400008, 11.853338934000078],
              [98.26148522200003, 11.853908596000053],
              [98.25416100400008, 11.85814036700009],
            ],
          ],
          [
            [
              [98.26775149800005, 11.93390534100007],
              [98.26156660200007, 11.926174221000053],
              [98.25375410200007, 11.923081773000092],
              [98.24610436300003, 11.925441799000055],
              [98.22706139400003, 11.953924872000073],
              [98.23585045700003, 11.968329169000071],
              [98.25220787900008, 11.974758205000057],
              [98.26091556100005, 11.971136786000045],
              [98.26270592500003, 11.96165599200009],
              [98.26872806100005, 11.942287502000056],
              [98.26775149800005, 11.93390534100007],
            ],
          ],
          [
            [
              [98.60352623800003, 11.96743398600006],
              [98.64234459700003, 11.957505601000037],
              [98.65919030000003, 11.94867584800005],
              [98.65821373800003, 11.93390534100007],
              [98.65821373800003, 11.940130927000041],
              [98.63135826900003, 11.932114976000037],
              [98.57260175900007, 11.93162669500009],
              [98.55201256600003, 11.923325914000088],
              [98.53565514400003, 11.908880927000041],
              [98.51587975400008, 11.895900783000059],
              [98.49577884200005, 11.888495184000078],
              [98.47803795700003, 11.89093659100007],
              [98.46338951900003, 11.920803127000056],
              [98.45972741000003, 11.933661200000074],
              [98.45899498800003, 11.94757721600007],
              [98.46168053500003, 11.955511786000045],
              [98.47120201900003, 11.970282294000071],
              [98.47315514400003, 11.97797272300005],
              [98.47095787900008, 11.988104559000078],
              [98.46583092500003, 11.992661851000037],
              [98.45915774800005, 11.996161200000074],
              [98.44825280000003, 12.00771719000005],
              [98.44369550900007, 12.010687567000048],
              [98.44027754000007, 12.015366929000038],
              [98.43913821700005, 12.025783596000053],
              [98.43913821700005, 12.056789455000057],
              [98.43116295700003, 12.087632554000038],
              [98.43091881600003, 12.10065338700008],
              [98.43913821700005, 12.112005927000041],
              [98.44556725400008, 12.101385809000078],
              [98.47315514400003, 12.077297268000052],
              [98.49366295700003, 12.049302476000037],
              [98.50953209700003, 12.016791083000044],
              [98.51986738400007, 12.007025458000044],
              [98.54151451900003, 11.995306708000044],
              [98.55958092500003, 12.000799872000073],
              [98.57471764400003, 11.992987372000073],
              [98.60352623800003, 11.96743398600006],
            ],
          ],
          [
            [
              [98.09644616000003, 12.187160549000055],
              [98.10580488400007, 12.192206122000073],
              [98.11947675900007, 12.19757721600007],
              [98.13184655000003, 12.198553778000075],
              [98.13746178500003, 12.190578518000052],
              [98.14014733200003, 12.148382880000042],
              [98.13746178500003, 12.138739325000074],
              [98.12964928500003, 12.153713283000059],
              [98.11670983200003, 12.16547272300005],
              [98.10035241000003, 12.16901276200008],
              [98.08228600400008, 12.15916575700004],
              [98.07667076900003, 12.161932684000078],
              [98.07471764400003, 12.163397528000075],
              [98.07309004000007, 12.164943752000056],
              [98.05933678500003, 12.187974351000037],
              [98.03939863400007, 12.20734284100007],
              [98.03435306100005, 12.221258856000077],
              [98.03711998800003, 12.239406643000052],
              [98.04615319100003, 12.26203034100007],
              [98.05909264400003, 12.281398830000057],
              [98.07252037900008, 12.289536851000037],
              [98.09180748800003, 12.288641669000071],
              [98.10824629000007, 12.284654039000088],
              [98.11947675900007, 12.275580145000049],
              [98.12378991000003, 12.259466864000046],
              [98.12330162900008, 12.249660549000055],
              [98.11988366000003, 12.230129299000055],
              [98.11695397200003, 12.221258856000077],
              [98.11150149800005, 12.21393463700008],
              [98.10425866000003, 12.20734284100007],
              [98.09815514400003, 12.199286200000074],
              [98.09644616000003, 12.187160549000055],
            ],
          ],
          [
            [
              [98.06527754000007, 12.365301825000074],
              [98.06446373800003, 12.359808661000045],
              [98.04802493600005, 12.330511786000045],
              [98.03956139400003, 12.32249583500004],
              [98.02947024800005, 12.315985419000071],
              [98.01889082100007, 12.311672268000052],
              [98.01050866000003, 12.310044664000088],
              [98.00831139400003, 12.304388739000046],
              [98.00025475400008, 12.269029039000088],
              [97.99097741000003, 12.286525783000059],
              [97.98658287900008, 12.289536851000037],
              [97.98243248800003, 12.306382554000038],
              [97.96949303500003, 12.30805084800005],
              [97.95508873800003, 12.305487372000073],
              [97.94556725400008, 12.310044664000088],
              [97.94841556100005, 12.323797919000071],
              [97.96094811300003, 12.334377346000053],
              [97.97103925900007, 12.344875393000052],
              [97.96607506600003, 12.35846588700008],
              [97.95297285200007, 12.348944403000075],
              [97.94898522200003, 12.344305731000077],
              [97.94556725400008, 12.337958075000074],
              [97.93816165500004, 12.337958075000074],
              [97.93995201900003, 12.36627838700008],
              [97.95460045700003, 12.377752997000073],
              [97.97575931100005, 12.38385651200008],
              [98.00700931100005, 12.401597398000092],
              [98.01783287900008, 12.40265534100007],
              [98.02344811300003, 12.39874909100007],
              [98.01758873800003, 12.389146226000037],
              [98.00782311300003, 12.380113023000092],
              [98.00359134200005, 12.373724677000041],
              [98.00538170700003, 12.367336330000057],
              [98.01392662900008, 12.35846588700008],
              [98.02711022200003, 12.361029364000046],
              [98.03248131600003, 12.360541083000044],
              [98.04175866000003, 12.35846588700008],
              [98.04135175900007, 12.36912669500009],
              [98.04224694100003, 12.380275783000059],
              [98.04558353000004, 12.389064846000053],
              [98.06364993600005, 12.397772528000075],
              [98.06934655000003, 12.409369208000044],
              [98.07252037900008, 12.421210028000075],
              [98.07593834700003, 12.427394924000055],
              [98.09058678500003, 12.422308661000045],
              [98.10124759200005, 12.404771226000037],
              [98.10450280000003, 12.38304271000004],
              [98.09644616000003, 12.365301825000074],
              [98.08773847700007, 12.360052802000041],
              [98.08155358200003, 12.360581773000092],
              [98.07471764400003, 12.36351146000004],
              [98.06527754000007, 12.365301825000074],
            ],
          ],
          [
            [
              [98.51417076900003, 12.495591539000088],
              [98.51685631600003, 12.479437567000048],
              [98.51417076900003, 12.423651434000078],
              [98.50855553500003, 12.410305080000057],
              [98.49561608200003, 12.405829169000071],
              [98.48210696700005, 12.410589911000045],
              [98.47429446700005, 12.424994208000044],
              [98.48853600400008, 12.493312893000052],
              [98.49984785200007, 12.513088283000059],
              [98.51417076900003, 12.495591539000088],
            ],
          ],
          [
            [
              [98.25416100400008, 12.567613023000092],
              [98.25684655000003, 12.57420482000009],
              [98.26246178500003, 12.568793036000045],
              [98.26734459700003, 12.560248114000046],
              [98.26775149800005, 12.557074286000045],
              [98.28988691500007, 12.526312567000048],
              [98.28288821700005, 12.503851630000042],
              [98.26050866000003, 12.495266018000052],
              [98.23682701900003, 12.50608958500004],
              [98.23023522200003, 12.516994533000059],
              [98.22974694100003, 12.527411200000074],
              [98.23365319100003, 12.553656317000048],
              [98.23682701900003, 12.55687083500004],
              [98.24390709700003, 12.557806708000044],
              [98.25082441500007, 12.560207424000055],
              [98.25416100400008, 12.567613023000092],
            ],
          ],
          [
            [
              [97.82276451900003, 12.587469794000071],
              [97.82699629000007, 12.590725002000056],
              [97.83627363400007, 12.595404364000046],
              [97.84571373800003, 12.59796784100007],
              [97.84994550900007, 12.594631252000056],
              [97.85401451900003, 12.578192450000074],
              [97.86052493600005, 12.570013739000046],
              [97.86182701900003, 12.559800523000092],
              [97.84994550900007, 12.537258205000057],
              [97.84961998800003, 12.541815497000073],
              [97.84782962300005, 12.544419664000088],
              [97.84522545700003, 12.54677969000005],
              [97.84253991000003, 12.55023834800005],
              [97.84083092500003, 12.55687083500004],
              [97.83904056100005, 12.558010158000059],
              [97.83545983200003, 12.55805084800005],
              [97.82943769600007, 12.557074286000045],
              [97.82943769600007, 12.564520575000074],
              [97.83399498800003, 12.570746161000045],
              [97.83106530000003, 12.57420482000009],
              [97.82569420700003, 12.578599351000037],
              [97.82276451900003, 12.587469794000071],
            ],
          ],
          [
            [
              [98.46631920700003, 12.583726304000038],
              [98.47071373800003, 12.555975653000075],
              [98.47022545700003, 12.517523505000042],
              [98.46534264400003, 12.480658270000049],
              [98.45582116000003, 12.45774974200009],
              [98.39128665500004, 12.361517645000049],
              [98.34994550900007, 12.325913804000038],
              [98.30201256600003, 12.337958075000074],
              [98.31128991000003, 12.359767971000053],
              [98.31560306100005, 12.365301825000074],
              [98.31902103000004, 12.386379299000055],
              [98.33301842500003, 12.427394924000055],
              [98.33611087300005, 12.450913804000038],
              [98.33423912900008, 12.46002838700008],
              [98.32553144600007, 12.47406647300005],
              [98.32113691500007, 12.48704661700009],
              [98.31657962300005, 12.490423895000049],
              [98.31560306100005, 12.495591539000088],
              [98.31950931100005, 12.501450914000088],
              [98.32740319100003, 12.506740627000056],
              [98.33383222700007, 12.51235586100006],
              [98.33301842500003, 12.519232489000046],
              [98.31413821700005, 12.553290106000077],
              [98.30274498800003, 12.598578192000048],
              [98.30201256600003, 12.646307684000078],
              [98.31560306100005, 12.687445380000042],
              [98.33301842500003, 12.671210028000075],
              [98.38746178500003, 12.65766022300005],
              [98.40552819100003, 12.63898346600007],
              [98.40552819100003, 12.630031643000052],
              [98.39812259200005, 12.587469794000071],
              [98.40121504000007, 12.571682033000059],
              [98.42546634200005, 12.529730536000045],
              [98.42920983200003, 12.555487372000073],
              [98.43816165500004, 12.587388414000088],
              [98.45093834700003, 12.603989976000037],
              [98.46631920700003, 12.583726304000038],
            ],
          ],
          [
            [
              [98.29566491000003, 13.084662177000041],
              [98.30347741000003, 13.08299388200004],
              [98.31039472700007, 13.088039455000057],
              [98.31853274800005, 13.091376044000071],
              [98.32984459700003, 13.084662177000041],
              [98.33643639400003, 13.073879299000055],
              [98.33423912900008, 13.06712474200009],
              [98.32300866000003, 13.057318427000041],
              [98.31657962300005, 13.04881419500009],
              [98.31104576900003, 13.04482656500005],
              [98.30632571700005, 13.04010651200008],
              [98.30201256600003, 13.029445705000057],
              [98.30054772200003, 13.019964911000045],
              [98.30201256600003, 12.988470770000049],
              [98.31332441500007, 12.94594961100006],
              [98.31430097700007, 12.925523179000038],
              [98.30201256600003, 12.913316148000092],
              [98.30128014400003, 12.933539130000042],
              [98.28785241000003, 12.95734284100007],
              [98.28825931100005, 12.974798895000049],
              [98.28109785200007, 12.99412669500009],
              [98.26775149800005, 13.057318427000041],
              [98.24512780000003, 13.118719794000071],
              [98.24048912900008, 13.13930898600006],
              [98.23902428500003, 13.158758856000077],
              [98.24203535200007, 13.203924872000073],
              [98.24732506600003, 13.215033270000049],
              [98.26148522200003, 13.214341539000088],
              [98.26880944100003, 13.198919989000046],
              [98.28891035200007, 13.09870026200008],
              [98.29566491000003, 13.084662177000041],
            ],
          ],
          [
            [
              [97.93189537900008, 13.85927969000005],
              [97.93816165500004, 13.85179271000004],
              [97.93238366000003, 13.840399481000077],
              [97.92847741000003, 13.821112372000073],
              [97.92505944100003, 13.783596096000053],
              [97.91773522200003, 13.783596096000053],
              [97.91504967500003, 13.800116278000075],
              [97.91431725400008, 13.82843659100007],
              [97.91871178500003, 13.853257554000038],
              [97.93189537900008, 13.85927969000005],
            ],
          ],
          [
            [
              [93.39600670700008, 14.140448309000078],
              [93.40015709700003, 14.095648505000042],
              [93.39478600400008, 14.076361395000049],
              [93.37484785200007, 14.06468333500004],
              [93.38331139400003, 14.138373114000046],
              [93.38599694100003, 14.150864976000037],
              [93.39031009200005, 14.15375397300005],
              [93.39600670700008, 14.140448309000078],
            ],
          ],
          [
            [
              [93.67579186300003, 14.859198309000078],
              [93.68669681100005, 14.87205638200004],
              [93.69361412900008, 14.888861395000049],
              [93.70386803500003, 14.904445705000057],
              [93.72437584700003, 14.913804429000038],
              [93.72437584700003, 14.907619533000059],
              [93.71615644600007, 14.89008209800005],
              [93.70443769600007, 14.87099844000005],
              [93.69044030000003, 14.858099677000041],
              [93.67579186300003, 14.859198309000078],
            ],
          ],
          [
            [
              [97.66439863400007, 15.565578518000052],
              [97.67164147200003, 15.549994208000044],
              [97.67237389400003, 15.533351955000057],
              [97.66911868600005, 15.517401434000078],
              [97.66439863400007, 15.504095770000049],
              [97.65748131600003, 15.523871161000045],
              [97.65088951900003, 15.592230536000045],
              [97.65626061300003, 15.586330471000053],
              [97.66016686300003, 15.58038971600007],
              [97.66285241000003, 15.57367584800005],
              [97.66439863400007, 15.565578518000052],
            ],
          ],
          [
            [
              [94.82797285200007, 15.932033596000053],
              [94.82984459700003, 15.916449286000045],
              [94.83936608200003, 15.89008209800005],
              [94.84156334700003, 15.877427476000037],
              [94.83741295700003, 15.864406643000052],
              [94.81910241000003, 15.83470286700009],
              [94.80372155000003, 15.796576239000046],
              [94.77784264400003, 15.791571356000077],
              [94.74789472700007, 15.79946523600006],
              [94.72486412900008, 15.81195709800005],
              [94.72486412900008, 15.818793036000045],
              [94.74480228000004, 15.832709052000041],
              [94.75928795700003, 15.852240302000041],
              [94.78003991000003, 15.893947658000059],
              [94.80681399800005, 15.93109772300005],
              [94.82325280000003, 15.945786851000037],
              [94.82797285200007, 15.932155666000085],
              [94.82797285200007, 15.932033596000053],
            ],
          ],
          [
            [
              [94.66211998800003, 16.221869208000044],
              [94.66749108200003, 16.171942450000074],
              [94.65463300900007, 16.121975002000056],
              [94.62964928500003, 16.07518138200004],
              [94.57960045700003, 16.01325104400007],
              [94.56959069100003, 16.005194403000075],
              [94.55347741000003, 15.99750397300005],
              [94.49903405000003, 15.980169989000046],
              [94.48414147200003, 15.971258856000077],
              [94.47803795700003, 15.966131903000075],
              [94.47803795700003, 15.958156643000052],
              [94.47925866000003, 15.949042059000078],
              [94.47836347700007, 15.942328192000048],
              [94.46827233200003, 15.930161851000037],
              [94.44646243600005, 15.912909247000073],
              [94.43677819100003, 15.90070221600007],
              [94.44092858200003, 15.88540273600006],
              [94.43311608200003, 15.869614976000037],
              [94.41016686300003, 15.839260158000059],
              [94.40267988400007, 15.839260158000059],
              [94.40267988400007, 15.84674713700008],
              [94.41724694100003, 15.871771552000041],
              [94.40919030000003, 15.907456773000092],
              [94.38233483200003, 15.969631252000056],
              [94.38965905000003, 16.000921942000048],
              [94.41724694100003, 16.018459377000056],
              [94.45297285200007, 16.03388092700004],
              [94.48536217500003, 16.058986721000053],
              [94.49594160200007, 16.07558828300006],
              [94.51099694100003, 16.10765208500004],
              [94.51880944100003, 16.120428778000075],
              [94.54932701900003, 16.148993231000077],
              [94.61158287900008, 16.22174713700008],
              [94.64283287900008, 16.24551015800006],
              [94.66211998800003, 16.221869208000044],
            ],
          ],
          [
            [
              [97.58936608200003, 16.415269273000092],
              [97.58855228000004, 16.39984772300005],
              [97.59131920700003, 16.361151434000078],
              [97.58936608200003, 16.34015534100007],
              [97.58383222700007, 16.329046942000048],
              [97.57740319100003, 16.32094961100006],
              [97.57178795700003, 16.31207916900007],
              [97.56885826900003, 16.298570054000038],
              [97.57016035200007, 16.29002513200004],
              [97.56635441500003, 16.253719653000076],
              [97.57136418100004, 16.22269311900004],
              [97.54746101900008, 16.199927595000077],
              [97.51685669700004, 16.209823449000055],
              [97.51050866000003, 16.25421784100007],
              [97.49927819100003, 16.26951732000009],
              [97.45926940600003, 16.301362208000057],
              [97.46924889400003, 16.33270905200004],
              [97.48275800900007, 16.34202708500004],
              [97.48487389400003, 16.36391836100006],
              [97.48015384200005, 16.389105536000045],
              [97.47266686300003, 16.40843333500004],
              [97.46045983200003, 16.42597077000005],
              [97.45476321700005, 16.43691640800006],
              [97.45215905000003, 16.44940827000005],
              [97.45582116000003, 16.456203518000052],
              [97.46265709700003, 16.461004950000074],
              [97.46615644600007, 16.46702708500004],
              [97.45964603000004, 16.477362372000073],
              [97.46998131600003, 16.49046458500004],
              [97.48601321700005, 16.50096263200004],
              [97.50407962300005, 16.50800202000005],
              [97.52051842500003, 16.510891018000052],
              [97.56185957100007, 16.49237702000005],
              [97.58521569100003, 16.486029364000046],
              [97.60629316500007, 16.483547268000052],
              [97.60978629900006, 16.464152839000064],
              [97.61060631600003, 16.446234442000048],
              [97.58936608200003, 16.415269273000092],
            ],
          ],
          [
            [
              [93.74537194100003, 18.799994208000044],
              [93.74805748800003, 18.787909247000073],
              [93.75709069100003, 18.76520416900007],
              [93.75904381600003, 18.755560614000046],
              [93.75603274800005, 18.73151276200008],
              [93.74683678500003, 18.708807684000078],
              [93.73194420700008, 18.68968333500004],
              [93.71127363400007, 18.67645905200004],
              [93.69312584700003, 18.673773505000042],
              [93.66773522200003, 18.67487213700008],
              [93.64527428500003, 18.679348049000055],
              [93.63550866000003, 18.686672268000052],
              [93.63038170700008, 18.69920482000009],
              [93.61850019600007, 18.711493231000077],
              [93.59400475400008, 18.731024481000077],
              [93.49781334700003, 18.84088776200008],
              [93.49317467500003, 18.849310614000046],
              [93.48414147200003, 18.87498607000009],
              [93.57715905000003, 18.88190338700008],
              [93.59986412900008, 18.890448309000078],
              [93.61109459700003, 18.90525950700004],
              [93.62175540500004, 18.91034577000005],
              [93.64177493600005, 18.88934967700004],
              [93.66334069100003, 18.873195705000057],
              [93.67302493600005, 18.87051015800006],
              [93.68360436300003, 18.868963934000078],
              [93.70753014400003, 18.86823151200008],
              [93.74244225400008, 18.872300523000035],
              [93.74952233200008, 18.865179755000042],
              [93.75163821700005, 18.84088776200008],
              [93.74586022200003, 18.810980536000045],
              [93.74537194100003, 18.799994208000044],
            ],
          ],
          [
            [
              [93.97071373800003, 19.416937567000048],
              [93.97364342500003, 19.402736721000053],
              [93.97234134200005, 19.38182200700004],
              [93.96583092500003, 19.363023179000038],
              [93.95394941500007, 19.35488515800006],
              [93.94019616000003, 19.34861888200004],
              [93.91716556100005, 19.318304755000042],
              [93.90088951900003, 19.30540599200009],
              [93.89893639400003, 19.303290106000077],
              [93.89551842500003, 19.301174221000053],
              [93.88941491000003, 19.299627997000073],
              [93.88355553500003, 19.30149974200009],
              [93.88103274800005, 19.30687083500004],
              [93.87916100400008, 19.312201239000046],
              [93.87517337300005, 19.31391022300005],
              [93.86280358200008, 19.307766018000052],
              [93.86280358200008, 19.299750067000048],
              [93.86638431100005, 19.291083075000074],
              [93.86491946700005, 19.282863674000055],
              [93.85694420700008, 19.27887604400007],
              [93.84555097700007, 19.27802155200004],
              [93.82357832100007, 19.279120184000078],
              [93.80274498800003, 19.276678778000075],
              [93.79688561300003, 19.278509833000044],
              [93.78565514400003, 19.28656647300005],
              [93.77377363400007, 19.298773505000042],
              [93.74984785200007, 19.333319403000075],
              [93.74537194100003, 19.344916083000044],
              [93.74317467500003, 19.35545482000009],
              [93.73340905000003, 19.36786530200004],
              [93.73121178500003, 19.379055080000057],
              [93.72999108200008, 19.381740627000056],
              [93.72779381600003, 19.383734442000048],
              [93.72535241000003, 19.386867580000057],
              [93.72437584700003, 19.392726955000057],
              [93.72673587300005, 19.39667389500005],
              [93.73194420700008, 19.396429755000042],
              [93.73666425900007, 19.396958726000037],
              [93.73804772200003, 19.403265692000048],
              [93.73047936300003, 19.419256903000075],
              [93.71631920700008, 19.427394924000055],
              [93.68336022200003, 19.437445380000042],
              [93.66911868600005, 19.446478583000044],
              [93.65894616000003, 19.457505601000037],
              [93.64177493600005, 19.492010809000078],
              [93.65219160200007, 19.493312893000052],
              [93.65658613400007, 19.497381903000075],
              [93.65552819100003, 19.50409577000005],
              [93.64918053500003, 19.51312897300005],
              [93.68816165500004, 19.559475002000056],
              [93.69695071700005, 19.560288804000038],
              [93.70492597700007, 19.558294989000046],
              [93.72364342500003, 19.556382554000038],
              [93.73121178500003, 19.55410390800006],
              [93.74048912900008, 19.546698309000078],
              [93.74537194100003, 19.539211330000057],
              [93.74927819100003, 19.531317450000074],
              [93.75538170700008, 19.52301666900007],
              [93.80307050900007, 19.48737213700008],
              [93.81999759200005, 19.471502997000073],
              [93.83659915500004, 19.479396877000056],
              [93.85808353000004, 19.482489325000074],
              [93.88021894600007, 19.47919342700004],
              [93.89926191500007, 19.46775950700004],
              [93.91773522200003, 19.454006252000056],
              [93.95622806100005, 19.432521877000056],
              [93.97071373800003, 19.416937567000048],
            ],
          ],
          [
            [
              [93.50521894600007, 19.80731842700004],
              [93.51685631600003, 19.777167059000078],
              [93.51832116000003, 19.76194896000004],
              [93.51197350400008, 19.745835679000038],
              [93.45679772200003, 19.788763739000046],
              [93.44068444100003, 19.810939846000053],
              [93.40674889400003, 19.920477606000077],
              [93.40284264400003, 19.953070380000042],
              [93.42204837300005, 19.95136139500005],
              [93.44263756600003, 19.93813711100006],
              [93.45337975400008, 19.92845286700009],
              [93.46119225400008, 19.91950104400007],
              [93.46412194100003, 19.91347890800006],
              [93.47055097700007, 19.905218817000048],
              [93.48471113400007, 19.89716217700004],
              [93.49878991000003, 19.88703034100007],
              [93.50521894600007, 19.872219143000052],
              [93.50114993600005, 19.825384833000044],
              [93.50521894600007, 19.80731842700004],
            ],
          ],
          [
            [
              [92.96404056100005, 20.03668854400007],
              [92.96753991000003, 20.02220286700009],
              [93.01465905000003, 19.905585028000075],
              [93.02198326900003, 19.87018463700008],
              [93.02491295700008, 19.827826239000046],
              [93.01856530000003, 19.827826239000046],
              [93.01319420700008, 19.846502997000073],
              [93.00855553500003, 19.889878648000035],
              [93.00123131600003, 19.906642971000053],
              [92.98747806100005, 19.92519765800006],
              [92.92579186300003, 20.033758856000077],
              [92.92237389400003, 20.050604559000078],
              [92.91976972700007, 20.05573151200008],
              [92.91431725400008, 20.05963776200008],
              [92.90943444100003, 20.06509023600006],
              [92.90870201900003, 20.07485586100006],
              [92.91195722700007, 20.08470286700009],
              [92.91684004000007, 20.08893463700008],
              [92.92269941500007, 20.087632554000038],
              [92.92920983200008, 20.08104075700004],
              [92.94646243600005, 20.07050202000005],
              [92.95289147200003, 20.063055731000077],
              [92.95850670700008, 20.05487702000005],
              [92.96257571700005, 20.046087958000044],
              [92.96404056100005, 20.03668854400007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bangladesh',
        iso3: 'BGD',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [92.57587854000013, 21.977574362000027],
              [92.59024458800008, 21.91716461200012],
              [92.59303511600012, 21.886933899000027],
              [92.57556848200005, 21.73397166000005],
              [92.59024458800008, 21.49553660100007],
              [92.59272505700005, 21.470163472000067],
              [92.60326704900007, 21.42008901000007],
              [92.63923384600008, 21.3186998500001],
              [92.64103990600012, 21.30858591800002],
              [92.64285119700003, 21.298442688000094],
              [92.63375614400007, 21.28221628900009],
              [92.61432580600007, 21.26314768500002],
              [92.59086470600005, 21.248884990000036],
              [92.57060754400004, 21.247283020000012],
              [92.55872196500007, 21.259840393000033],
              [92.55159061700004, 21.28051096600005],
              [92.54394250500008, 21.320921937000023],
              [92.52451216700007, 21.361126201000033],
              [92.49867395000007, 21.366603902000023],
              [92.46539432800012, 21.35983429],
              [92.42312300700013, 21.363658345000132],
              [92.40028202400003, 21.370996400000124],
              [92.38963667800004, 21.37652577800013],
              [92.38116174400005, 21.384794006000064],
              [92.37423710100006, 21.40231231800003],
              [92.37217004400003, 21.419055481000086],
              [92.36793257700003, 21.435436910000035],
              [92.35470341000007, 21.451818340000088],
              [92.32266402200014, 21.46189524300003],
              [92.2845268150001, 21.419055481000086],
              [92.25290083800007, 21.419520569000028],
              [92.23626102800006, 21.41709177700004],
              [92.22509891700014, 21.3974547320001],
              [92.21155969200004, 21.35487335200004],
              [92.1836544190001, 21.317201233],
              [92.17828007100013, 21.299734599000075],
              [92.17807336400006, 21.28014923100004],
              [92.18520471200003, 21.240410055000055],
              [92.18396447700007, 21.220876364000034],
              [92.17838342300007, 21.191265767000075],
              [92.17497277900003, 21.175607809000027],
              [92.18076053900012, 21.157882793000013],
              [92.18830529800005, 21.144085185000066],
              [92.21176639800012, 21.12351796500009],
              [92.21838098200004, 21.108635152000133],
              [92.22427209500012, 21.09318389900004],
              [92.26514733200008, 21.061102606000077],
              [92.25855553500003, 21.02252838700008],
              [92.25709069100003, 20.98110586100006],
              [92.26148522200003, 20.940252997000073],
              [92.27198326900003, 20.903509833000044],
              [92.30062910200007, 20.86237213700008],
              [92.30543053500003, 20.851955471000053],
              [92.30762780000003, 20.833197333000044],
              [92.32593834700003, 20.780585028000075],
              [92.33326256600003, 20.767726955000057],
              [92.33627363400007, 20.757147528000075],
              [92.33399498800003, 20.74640534100007],
              [92.32553144600007, 20.738714911000045],
              [92.31934655000003, 20.742010809000078],
              [92.31421959700003, 20.749253648000035],
              [92.30909264400003, 20.753241278000075],
              [92.30103600400008, 20.762274481000077],
              [92.27808678500003, 20.814113674000055],
              [92.20972741000003, 20.930812893000052],
              [92.19288170700008, 20.99567291900007],
              [92.18628991000003, 21.00584544500009],
              [92.13412519600007, 21.04751211100006],
              [92.12435957100007, 21.06045156500005],
              [92.10808353000004, 21.089911200000074],
              [92.09685306100005, 21.105861721000053],
              [92.05250084700003, 21.154771226000037],
              [92.04542076900003, 21.17096588700008],
              [92.04395592500003, 21.19204336100006],
              [92.05225670700008, 21.256659247000073],
              [92.05046634200005, 21.280462958000044],
              [92.04525800900007, 21.29954661700009],
              [91.98975670700008, 21.394232489000046],
              [91.98047936300003, 21.40375397300005],
              [91.96941165500004, 21.40961334800005],
              [91.95972741000003, 21.423976955000057],
              [91.95297285200007, 21.441839911000045],
              [91.94971764400003, 21.45840078300006],
              [91.95590254000007, 21.45840078300006],
              [91.95801842500003, 21.455023505000042],
              [91.95883222700007, 21.454413153000075],
              [91.96013431100005, 21.454250393000052],
              [91.96338951900003, 21.45213450700004],
              [91.97087649800005, 21.470038153000075],
              [91.98292076900003, 21.488836981000077],
              [91.99903405000003, 21.49949778900009],
              [92.01791425900007, 21.493109442000048],
              [92.00538170700008, 21.504299221000053],
              [91.99537194100003, 21.522609768000052],
              [91.98975670700008, 21.543402411000045],
              [91.99000084700003, 21.56199778900009],
              [91.99854576900003, 21.573187567000048],
              [92.01246178500003, 21.58539459800005],
              [92.02214603000004, 21.599351304000038],
              [92.01791425900007, 21.616034247000073],
              [92.03296959700003, 21.63300202000005],
              [92.03581790500004, 21.640448309000078],
              [92.03174889400003, 21.650132554000038],
              [92.03777103000004, 21.65957265800006],
              [92.03589928500003, 21.66815827000005],
              [92.02857506600003, 21.67479075700004],
              [92.02279707100007, 21.67682526200008],
              [92.02556399800005, 21.687241929000038],
              [92.02930748800003, 21.696234442000048],
              [92.02930748800003, 21.704901434000078],
              [92.02540123800003, 21.712836005000042],
              [92.02393639400003, 21.70465729400007],
              [92.02214603000004, 21.701564846000053],
              [92.01791425900007, 21.698553778000075],
              [92.02540123800003, 21.698553778000075],
              [92.01238040500004, 21.664211330000057],
              [92.00074303500003, 21.64980703300006],
              [91.98389733200008, 21.650132554000038],
              [91.97608483200008, 21.662054755000042],
              [91.97885175900007, 21.67772044500009],
              [91.98422285200007, 21.693508205000057],
              [91.98389733200008, 21.70538971600007],
              [91.97706139400003, 21.70538971600007],
              [91.97193444100003, 21.68821849200009],
              [91.96265709700003, 21.689520575000074],
              [91.95362389400003, 21.70140208500004],
              [91.94971764400003, 21.715969143000052],
              [91.95297285200007, 21.738348700000074],
              [91.96192467500003, 21.743841864000046],
              [91.97478274800005, 21.746486721000053],
              [91.99000084700003, 21.75999583500004],
              [91.98389733200008, 21.766831773000035],
              [91.96729576900003, 21.75543854400007],
              [91.96029707100007, 21.763820705000057],
              [91.96656334700003, 21.77887604400007],
              [91.99000084700003, 21.787909247000073],
              [91.99000084700003, 21.79482656500005],
              [91.94369550900007, 21.791408596000053],
              [91.92408287900008, 21.785223700000074],
              [91.90870201900003, 21.78115469000005],
              [91.89926191500007, 21.789496161000045],
              [91.90088951900003, 21.813299872000073],
              [91.91138756600003, 21.83470286700009],
              [91.92937259200005, 21.84316640800006],
              [91.92164147200003, 21.85342031500005],
              [91.92554772200003, 21.86286041900007],
              [91.93628991000003, 21.870835679000038],
              [91.94971764400003, 21.876695054000038],
              [91.94971764400003, 21.88418203300006],
              [91.93921959700003, 21.88304271000004],
              [91.92994225400008, 21.878648179000038],
              [91.92212975400008, 21.871568101000037],
              [91.91570071700005, 21.862453518000052],
              [91.91032962300005, 21.87490469000005],
              [91.90560957100007, 21.89557526200008],
              [91.90121504000007, 21.935370184000078],
              [91.89820397200003, 21.94489166900007],
              [91.88404381600003, 21.960150458000044],
              [91.88086998800003, 21.969183661000045],
              [91.88086998800003, 22.007025458000044],
              [91.85523522200003, 22.109198309000078],
              [91.85352623800003, 22.14362213700008],
              [91.86394290500004, 22.139593817000048],
              [91.86719811300003, 22.13739655200004],
              [91.86207116000003, 22.15062083500004],
              [91.85328209700003, 22.14874909100007],
              [91.84603925900007, 22.135972398000035],
              [91.84603925900007, 22.116888739000046],
              [91.83985436300003, 22.116888739000046],
              [91.82911217500003, 22.134100653000075],
              [91.81934655000003, 22.155951239000046],
              [91.81299889400003, 22.18032461100006],
              [91.81202233200008, 22.205023505000042],
              [91.81690514400003, 22.22028229400007],
              [91.82585696700005, 22.23004791900007],
              [91.83472741000003, 22.237616278000075],
              [91.83985436300003, 22.246649481000077],
              [91.83838951900003, 22.26308828300006],
              [91.82984459700003, 22.271307684000078],
              [91.81918379000007, 22.275824286000045],
              [91.81202233200008, 22.281398830000057],
              [91.80884850400008, 22.306341864000046],
              [91.82650800900007, 22.31826406500005],
              [91.85238691500007, 22.325344143000052],
              [91.87403405000003, 22.336004950000074],
              [91.88493899800005, 22.35382721600007],
              [91.90805097700007, 22.424750067000048],
              [91.90186608200008, 22.42405833500004],
              [91.88770592500003, 22.424750067000048],
              [91.88550866000003, 22.40965403900009],
              [91.87574303500003, 22.37107982000009],
              [91.87745201900003, 22.363348700000074],
              [91.87045332100007, 22.35809967700004],
              [91.85914147200003, 22.346625067000048],
              [91.84400475400008, 22.33494700700004],
              [91.82634524800005, 22.32916901200008],
              [91.82325280000003, 22.324164130000042],
              [91.79859459700003, 22.31191640800006],
              [91.79135175900007, 22.301906643000052],
              [91.79395592500003, 22.286037502000056],
              [91.80453535200007, 22.278469143000052],
              [91.81723066500007, 22.27407461100006],
              [91.82634524800005, 22.26776764500005],
              [91.82593834700003, 22.248480536000045],
              [91.80892988400007, 22.236273505000042],
              [91.78711998800003, 22.237941799000055],
              [91.77165774800005, 22.260321356000077],
              [91.75440514400003, 22.374660549000055],
              [91.74366295700008, 22.411078192000048],
              [91.67603600400008, 22.53461334800005],
              [91.54810631600003, 22.700344143000052],
              [91.51636803500003, 22.712225653000075],
              [91.49870853000004, 22.72728099200009],
              [91.48462975400008, 22.74551015800006],
              [91.47681725400008, 22.76117584800005],
              [91.46900475400008, 22.757066148000035],
              [91.46241295700008, 22.76190827000005],
              [91.45801842500003, 22.772284247000073],
              [91.45630944100003, 22.784816799000055],
              [91.45834394600007, 22.79706452000005],
              [91.46778405000003, 22.80931224200009],
              [91.47396894600007, 22.838324286000045],
              [91.49000084700003, 22.880560614000046],
              [91.49048912900008, 22.90452708500004],
              [91.48308353000004, 22.90452708500004],
              [91.47966556100005, 22.885891018000052],
              [91.46241295700008, 22.83344147300005],
              [91.45248457100007, 22.822658596000053],
              [91.43043053500003, 22.81631094000005],
              [91.41675866000003, 22.799994208000044],
              [91.41163170700008, 22.777818101000037],
              [91.41472415500004, 22.753729559000078],
              [91.39966881600003, 22.76430898600006],
              [91.38502037900008, 22.770697333000044],
              [91.36833743600005, 22.773993231000077],
              [91.34644616000003, 22.77484772300005],
              [91.34644616000003, 22.767401434000078],
              [91.36744225400008, 22.761664130000042],
              [91.37012780000003, 22.75218333500004],
              [91.36011803500003, 22.743394273000035],
              [91.34262129000007, 22.739447333000044],
              [91.29078209700003, 22.738430080000057],
              [91.30884850400008, 22.73309967700004],
              [91.32504316500007, 22.72614166900007],
              [91.33277428500003, 22.72020091400009],
              [91.32992597700007, 22.70571523600006],
              [91.31739342500003, 22.697211005000042],
              [91.30054772200003, 22.69326406500005],
              [91.28443444100003, 22.692287502000056],
              [91.28345787900008, 22.69334544500009],
              [91.25277754000007, 22.699286200000074],
              [91.24838300900007, 22.69822825700004],
              [91.24480228000004, 22.698391018000052],
              [91.24341881600003, 22.70221588700008],
              [91.24390709700003, 22.71743398600006],
              [91.24341881600003, 22.72020091400009],
              [91.23121178500003, 22.724310614000046],
              [91.21607506600003, 22.72606028900009],
              [91.18189537900008, 22.72646719000005],
              [91.18189537900008, 22.72020091400009],
              [91.19459069100003, 22.70966217700004],
              [91.19922936300003, 22.69879791900007],
              [91.19214928500003, 22.69163646000004],
              [91.16895592500003, 22.692287502000056],
              [91.16895592500003, 22.684881903000075],
              [91.22689863400007, 22.671087958000044],
              [91.25342858200008, 22.660711981000077],
              [91.26449629000007, 22.64081452000005],
              [91.26107832100007, 22.627875067000048],
              [91.25310306100005, 22.613836981000077],
              [91.24156880000004, 22.575395765000053],
              [91.22136457600004, 22.55719260500007],
              [91.20274304600008, 22.543219639000085],
              [91.17656568400008, 22.53641941400008],
              [91.12734345800004, 22.527025948000073],
              [91.08920058200005, 22.544430256000055],
              [91.06957967100004, 22.571556869000062],
              [91.05860436300003, 22.61432526200008],
              [91.04867597700007, 22.626166083000044],
              [91.03793379000007, 22.643866278000075],
              [91.02670332100007, 22.674261786000045],
              [91.01832116000003, 22.68309153900009],
              [91.00375410200007, 22.678656317000048],
              [91.01872806100005, 22.664455471000053],
              [91.03223717500003, 22.636867580000057],
              [91.04021243600005, 22.60773346600007],
              [91.03793379000007, 22.58860911700009],
              [91.01758873800003, 22.579291083000044],
              [90.98511803500003, 22.574367580000057],
              [90.95492597700007, 22.575832424000055],
              [90.94174238400007, 22.585882880000042],
              [90.93555748800003, 22.599676825000074],
              [90.90821373800003, 22.61786530200004],
              [90.90202884200005, 22.627101955000057],
              [90.89877363400007, 22.63617584800005],
              [90.88412519600007, 22.65448639500005],
              [90.87647545700008, 22.682806708000044],
              [90.86548912900008, 22.687160549000055],
              [90.83594811300003, 22.684881903000075],
              [90.83130944100003, 22.690578518000052],
              [90.81950931100005, 22.72646719000005],
              [90.81177819100003, 22.732367255000042],
              [90.80258222700007, 22.736395575000074],
              [90.79493248800003, 22.741359768000052],
              [90.78834069100003, 22.75922272300005],
              [90.77418053500003, 22.77806224200009],
              [90.77100670700008, 22.784816799000055],
              [90.76954186300003, 22.795355536000045],
              [90.75733483200008, 22.822658596000053],
              [90.75001061300003, 22.856756903000075],
              [90.74195397200003, 22.874212958000044],
              [90.73292076900003, 22.889064846000053],
              [90.72559655000003, 22.90570709800005],
              [90.72266686300003, 22.92845286700009],
              [90.71745853000004, 22.940619208000044],
              [90.64014733200008, 23.038031317000048],
              [90.62940514400003, 23.064398505000042],
              [90.62712649800005, 23.075873114000046],
              [90.62720787900008, 23.08665599200009],
              [90.63868248800003, 23.14789459800005],
              [90.64014733200008, 23.18886953300006],
              [90.64584394600007, 23.21092357000009],
              [90.65707441500007, 23.23037344000005],
              [90.66521243600005, 23.24876536700009],
              [90.66114342500003, 23.267645575000074],
              [90.66732832100007, 23.267645575000074],
              [90.65088951900003, 23.30023834800005],
              [90.65015709700003, 23.31354401200008],
              [90.66114342500003, 23.32225169500009],
              [90.65772545700008, 23.32322825700004],
              [90.65479576900003, 23.32330963700008],
              [90.65316816500007, 23.324652411000045],
              [90.65365644600007, 23.329738674000055],
              [90.62842858200008, 23.321519273000035],
              [90.61133873800003, 23.34247467700004],
              [90.60173587300005, 23.37246328300006],
              [90.59913170700008, 23.391180731000077],
              [90.60027103000004, 23.44993724200009],
              [90.60873457100007, 23.472723700000074],
              [90.63331139400003, 23.486761786000045],
              [90.69157962300005, 23.486476955000057],
              [90.71501712300005, 23.49835846600007],
              [90.71583092500003, 23.53514232000009],
              [90.71119225400008, 23.54881419500009],
              [90.70557701900003, 23.554510809000078],
              [90.69581139400003, 23.555487372000073],
              [90.67823326900003, 23.555080471000053],
              [90.67546634200005, 23.550930080000057],
              [90.68433678500003, 23.54173411700009],
              [90.70215905000003, 23.52838776200008],
              [90.69532311300003, 23.507879950000074],
              [90.67774498800003, 23.517279364000046],
              [90.66675866000003, 23.51821523600006],
              [90.64747155000003, 23.507879950000074],
              [90.62208092500003, 23.500067450000074],
              [90.60775800900007, 23.491115627000056],
              [90.60336347700007, 23.494696356000077],
              [90.58814537900008, 23.53416575700004],
              [90.59205162900008, 23.56248607000009],
              [90.60816491000003, 23.585760809000078],
              [90.63331139400003, 23.596625067000048],
              [90.62712649800005, 23.603461005000042],
              [90.62533613400007, 23.599351304000038],
              [90.62525475400008, 23.59833405200004],
              [90.62403405000003, 23.598089911000045],
              [90.61963951900003, 23.596625067000048],
              [90.61198978000004, 23.60610586100006],
              [90.59546959700003, 23.604396877000056],
              [90.55876712300005, 23.590399481000077],
              [90.56446373800003, 23.57640208500004],
              [90.55941816500007, 23.56793854400007],
              [90.54721113400007, 23.563788153000075],
              [90.53150475400008, 23.56248607000009],
              [90.51465905000003, 23.563788153000075],
              [90.50171959700003, 23.56793854400007],
              [90.47632897200003, 23.582953192000048],
              [90.48438561300003, 23.56745026200008],
              [90.49838300900007, 23.55727773600006],
              [90.51498457100007, 23.55141836100006],
              [90.53150475400008, 23.54881419500009],
              [90.56869550900007, 23.54751211100006],
              [90.57683353000004, 23.539496161000045],
              [90.57894941500007, 23.44985586100006],
              [90.57593834700003, 23.43895091400009],
              [90.56812584700003, 23.432928778000075],
              [90.55990644600007, 23.418402411000045],
              [90.55372155000003, 23.40070221600007],
              [90.55193118600005, 23.38495514500005],
              [90.51832116000003, 23.398260809000078],
              [90.32243899800005, 23.433294989000046],
              [90.28443444100003, 23.446193752000056],
              [90.25033613400007, 23.466945705000057],
              [90.24935957100007, 23.45538971600007],
              [90.25879967500003, 23.444566148000035],
              [90.38851972700007, 23.372381903000075],
              [90.40414472700007, 23.36041901200008],
              [90.41342207100007, 23.34796784100007],
              [90.41968834700003, 23.335598049000055],
              [90.42847741000003, 23.326117255000042],
              [90.46021569100003, 23.31972890800006],
              [90.48796634200005, 23.30683014500005],
              [90.50359134200005, 23.30174388200004],
              [90.56910241000003, 23.294989325000074],
              [90.57732181100005, 23.288397528000075],
              [90.60661868600005, 23.247219143000052],
              [90.61085045700008, 23.23078034100007],
              [90.61451256600003, 23.195461330000057],
              [90.61036217500003, 23.20115794500009],
              [90.60271243600005, 23.211004950000074],
              [90.59351647200003, 23.219875393000052],
              [90.59839928500003, 23.200425523000035],
              [90.60287519600007, 23.14130280200004],
              [90.59913170700008, 23.11749909100007],
              [90.57195071700005, 23.081732489000046],
              [90.56560306100005, 23.075873114000046],
              [90.55372155000003, 23.078558661000045],
              [90.55128014400003, 23.08690013200004],
              [90.55591881600003, 23.096828518000052],
              [90.56560306100005, 23.10382721600007],
              [90.56560306100005, 23.110663153000075],
              [90.55876712300005, 23.110663153000075],
              [90.54761803500003, 23.09674713700008],
              [90.53663170700008, 23.086818752000056],
              [90.52279707100007, 23.080145575000074],
              [90.50359134200005, 23.075873114000046],
              [90.46607506600003, 23.07684967700004],
              [90.45362389400003, 23.072333075000074],
              [90.44890384200005, 23.05573151200008],
              [90.45012454500005, 23.049343166000085],
              [90.45435631600003, 23.02753327000005],
              [90.46827233200008, 22.99607982000009],
              [90.48698978000004, 22.966131903000075],
              [90.50700931100005, 22.94208405200004],
              [90.50928795700008, 22.93699778900009],
              [90.50757897200003, 22.92536041900007],
              [90.51042728000004, 22.91819896000004],
              [90.51295006600003, 22.91705963700008],
              [90.51685631600003, 22.916815497000073],
              [90.52100670700008, 22.915676174000055],
              [90.52409915500004, 22.91201406500005],
              [90.53598066500007, 22.90338776200008],
              [90.54004967500003, 22.896551825000074],
              [90.53492272200003, 22.887152411000045],
              [90.52003014400003, 22.880194403000075],
              [90.50513756600003, 22.881659247000073],
              [90.49048912900008, 22.885199286000045],
              [90.47632897200003, 22.884100653000075],
              [90.45720462300005, 22.861761786000045],
              [90.44809004000007, 22.82843659100007],
              [90.43604576900003, 22.800604559000078],
              [90.40796959700003, 22.794663804000038],
              [90.42400149800005, 22.781683661000045],
              [90.41993248800003, 22.76825592700004],
              [90.40642337300005, 22.76308828300006],
              [90.39429772200003, 22.77484772300005],
              [90.37256920700008, 22.761419989000046],
              [90.38721764400003, 22.751288153000075],
              [90.41578209700003, 22.74249909100007],
              [90.43523196700005, 22.733303127000056],
              [90.44459069100003, 22.751654364000046],
              [90.46168053500003, 22.748846747000073],
              [90.47901451900003, 22.73501211100006],
              [90.48991946700005, 22.72020091400009],
              [90.49293053500003, 22.709906317000048],
              [90.49675540500004, 22.678656317000048],
              [90.50896243600005, 22.646429755000042],
              [90.51270592500003, 22.611476955000057],
              [90.51002037900008, 22.60423411700009],
              [90.50017337300005, 22.592352606000077],
              [90.49138431100005, 22.587836005000042],
              [90.46859785200007, 22.58470286700009],
              [90.45923912900008, 22.579291083000044],
              [90.45346113400007, 22.564195054000038],
              [90.44214928500003, 22.508734442000048],
              [90.44206790500004, 22.49363841400009],
              [90.44499759200005, 22.50413646000004],
              [90.45118248800003, 22.510158596000053],
              [90.45801842500003, 22.51463450700004],
              [90.46265709700003, 22.52098216400009],
              [90.46355228000004, 22.53143952000005],
              [90.46045983200008, 22.551174221000053],
              [90.46265709700003, 22.56195709800005],
              [90.47250410200007, 22.57558828300006],
              [90.48731530000003, 22.583726304000038],
              [90.50513756600003, 22.58624909100007],
              [90.52409915500004, 22.58307526200008],
              [90.55974368600005, 22.562323309000078],
              [90.57781009200005, 22.533677476000037],
              [90.58969160200007, 22.500433661000045],
              [90.60661868600005, 22.465765692000048],
              [90.59131920700008, 22.470526434000078],
              [90.58619225400008, 22.473211981000077],
              [90.58643639400003, 22.45058828300006],
              [90.59359785200007, 22.43231842700004],
              [90.61345462300005, 22.396877346000053],
              [90.61841881600003, 22.376654364000046],
              [90.61931399800005, 22.355902411000045],
              [90.61345462300005, 22.314886786000045],
              [90.58155358200008, 22.238226630000042],
              [90.55795332100007, 22.20335521000004],
              [90.53834069100003, 22.198879299000055],
              [90.51172936300003, 22.185288804000038],
              [90.50114993600005, 22.176703192000048],
              [90.49675540500004, 22.167792059000078],
              [90.49439537900008, 22.154242255000042],
              [90.48829186300003, 22.138617255000042],
              [90.45964603000004, 22.091945705000057],
              [90.45004316500007, 22.08079661700009],
              [90.43864993600005, 22.075995184000078],
              [90.42546634200005, 22.07884349200009],
              [90.40845787900008, 22.08592357000009],
              [90.39380944100003, 22.09471263200004],
              [90.38746178500003, 22.10260651200008],
              [90.39323978000004, 22.127386786000045],
              [90.41749108200008, 22.175034898000035],
              [90.42164147200003, 22.198879299000055],
              [90.41000410200007, 22.22728099200009],
              [90.40796959700003, 22.24042389500005],
              [90.41407311300003, 22.27179596600007],
              [90.41089928500003, 22.28424713700008],
              [90.39429772200003, 22.288234768000052],
              [90.39869225400008, 22.26748281500005],
              [90.38868248800003, 22.223211981000077],
              [90.39087975400008, 22.208807684000078],
              [90.39909915500004, 22.20221588700008],
              [90.40552819100003, 22.19953034100007],
              [90.41049238400007, 22.195705471000053],
              [90.41423587300005, 22.18577708500004],
              [90.41285241000003, 22.17804596600007],
              [90.40821373800003, 22.171210028000075],
              [90.40056399800005, 22.16404857000009],
              [90.39918053500003, 22.16233958500004],
              [90.39714603000004, 22.160630601000037],
              [90.39519290500004, 22.15721263200004],
              [90.39258873800003, 22.143011786000045],
              [90.38868248800003, 22.143459377000056],
              [90.38379967500003, 22.145738023000035],
              [90.38005618600005, 22.14362213700008],
              [90.37712649800005, 22.133612372000073],
              [90.37378991000003, 22.10260651200008],
              [90.36988366000003, 22.08982982000009],
              [90.36573326900003, 22.081203518000052],
              [90.34742272200003, 22.05532461100006],
              [90.33472741000003, 22.041815497000073],
              [90.33220462300005, 22.03807200700004],
              [90.32789147200003, 22.02049388200004],
              [90.30860436300003, 21.984035549000055],
              [90.30437259200005, 21.965765692000048],
              [90.29997806100005, 21.927679755000042],
              [90.29070071700005, 21.890326239000046],
              [90.28288821700005, 21.870794989000046],
              [90.27271569100003, 21.85740794500009],
              [90.21762129000007, 21.81346263200004],
              [90.20378665500004, 21.80459219000005],
              [90.18482506600003, 21.80097077000005],
              [90.16439863400007, 21.80426666900007],
              [90.12680097700007, 21.818793036000045],
              [90.10906009200005, 21.822088934000078],
              [90.09294681100005, 21.83026764500005],
              [90.08855228000004, 21.84674713700008],
              [90.09538821700005, 21.859442450000074],
              [90.11247806100005, 21.856268622000073],
              [90.10499108200008, 21.870266018000052],
              [90.11085045700008, 21.880113023000035],
              [90.12086022200003, 21.88930898600006],
              [90.12623131600003, 21.901190497000073],
              [90.12452233200008, 21.90973541900007],
              [90.12183678500003, 21.915350653000075],
              [90.12134850400008, 21.921576239000046],
              [90.12623131600003, 21.93195221600007],
              [90.11622155000003, 21.91933828300006],
              [90.09848066500007, 21.878607489000046],
              [90.08887780000003, 21.86985911700009],
              [90.07935631600003, 21.866929429000038],
              [90.06690514400003, 21.85342031500005],
              [90.05787194100003, 21.849351304000038],
              [90.04932701900003, 21.85101959800005],
              [90.03630618600005, 21.861151434000078],
              [90.02442467500003, 21.862453518000052],
              [90.03126061300003, 21.889227606000077],
              [90.03394616000003, 21.94354889500005],
              [90.04493248800003, 21.966131903000075],
              [90.05420983200008, 21.97337474200009],
              [90.06576582100007, 21.97988515800006],
              [90.07715905000003, 21.987982489000046],
              [90.08578535200007, 22.00023021000004],
              [90.09058678500003, 22.015448309000078],
              [90.09253991000003, 22.02798086100006],
              [90.09595787900008, 22.04010651200008],
              [90.10564212300005, 22.05426666900007],
              [90.14673912900008, 22.089016018000052],
              [90.15162194100003, 22.094875393000052],
              [90.15886478000004, 22.10691966400009],
              [90.16407311300003, 22.113226630000042],
              [90.17286217500003, 22.117010809000078],
              [90.18181399800005, 22.11481354400007],
              [90.18970787900008, 22.11082591400009],
              [90.19507897200003, 22.109523830000057],
              [90.21615644600007, 22.12323639500005],
              [90.23170006600003, 22.145656643000052],
              [90.23910566500007, 22.172267971000053],
              [90.23609459700003, 22.198879299000055],
              [90.21827233200008, 22.15570709800005],
              [90.20582116000003, 22.132961330000057],
              [90.19166100400008, 22.123114325000074],
              [90.16480553500003, 22.11981842700004],
              [90.14828535200007, 22.11078522300005],
              [90.08887780000003, 22.051174221000053],
              [90.08179772200003, 22.04100169500009],
              [90.07374108200008, 22.019232489000046],
              [90.06104576900003, 22.000799872000073],
              [90.05795332100007, 21.99371979400007],
              [90.05241946700005, 21.98899974200009],
              [90.03809655000003, 21.98655833500004],
              [90.02816816500007, 21.988104559000078],
              [89.99634850400008, 22.00023021000004],
              [90.00212649800005, 22.014105536000045],
              [90.00318444100003, 22.029364325000074],
              [90.01075280000003, 22.04120514500005],
              [90.02019290500004, 22.04881419500009],
              [90.02898196700005, 22.05296458500004],
              [90.03541100400008, 22.059800523000035],
              [90.03809655000003, 22.075344143000052],
              [90.03467858200008, 22.105169989000046],
              [90.03907311300003, 22.11627838700008],
              [90.04273522200003, 22.131252346000053],
              [90.05209394600007, 22.141099351000037],
              [90.06324303500003, 22.145738023000035],
              [90.07260175900007, 22.152044989000046],
              [90.07837975400008, 22.16404857000009],
              [90.05258222700007, 22.155462958000044],
              [90.04004967500003, 22.13808828300006],
              [90.02442467500003, 22.089016018000052],
              [90.01539147200003, 22.077866929000038],
              [89.98853600400008, 22.05304596600007],
              [89.98275800900007, 22.044623114000046],
              [89.98519941500007, 21.99941640800006],
              [89.98275800900007, 21.98655833500004],
              [89.96778405000003, 21.974554755000042],
              [89.94971764400003, 21.980902411000045],
              [89.93441816500007, 21.997707424000055],
              [89.92823326900003, 22.017279364000046],
              [89.92628014400003, 22.027167059000078],
              [89.91749108200008, 22.04987213700008],
              [89.91456139400003, 22.061672268000052],
              [89.91236412900008, 22.135565497000073],
              [89.90308678500003, 22.176906643000052],
              [89.90088951900003, 22.201971747000073],
              [89.89828535200007, 22.21165599200009],
              [89.88550866000003, 22.230617580000057],
              [89.88038170700008, 22.24042389500005],
              [89.87663821700005, 22.25348541900007],
              [89.87533613400007, 22.26398346600007],
              [89.87680097700007, 22.274725653000075],
              [89.88038170700008, 22.288234768000052],
              [89.90015709700003, 22.333929755000042],
              [89.98275800900007, 22.445257880000042],
              [89.98829186300003, 22.45774974200009],
              [89.99195397200003, 22.469875393000052],
              [89.99789472700007, 22.480861721000053],
              [90.01010175900007, 22.49022044500009],
              [89.98275800900007, 22.473211981000077],
              [89.97950280000003, 22.470078843000067],
              [89.94743899800005, 22.43968333500004],
              [89.93360436300003, 22.423529364000046],
              [89.92823326900003, 22.40770091400009],
              [89.92042076900003, 22.391831773000035],
              [89.90308678500003, 22.396429755000042],
              [89.87289472700007, 22.41860586100006],
              [89.87484785200007, 22.397650458000044],
              [89.88054446700005, 22.380601304000038],
              [89.88412519600007, 22.36351146000004],
              [89.88038170700008, 22.342230536000045],
              [89.83871504000007, 22.26776764500005],
              [89.85084069100003, 22.246527411000045],
              [89.86133873800003, 22.211004950000074],
              [89.87289472700007, 22.14362213700008],
              [89.87427819100003, 22.10883209800005],
              [89.87134850400008, 22.091864325000074],
              [89.86296634200005, 22.079046942000048],
              [89.84620201900003, 22.07062409100007],
              [89.83155358200008, 22.071966864000046],
              [89.81617272200003, 22.075995184000078],
              [89.79721113400007, 22.075995184000078],
              [89.79721113400007, 22.068508205000057],
              [89.81836998800003, 22.06004466400009],
              [89.83594811300003, 22.04946523600006],
              [89.84791100400008, 22.03388092700004],
              [89.85238691500007, 22.01044342700004],
              [89.85108483200008, 22.000881252000056],
              [89.84595787900008, 21.982896226000037],
              [89.84620201900003, 21.972316799000055],
              [89.85027103000004, 21.96312083500004],
              [89.86378014400003, 21.943304755000042],
              [89.87183678500003, 21.924261786000045],
              [89.88160241000003, 21.912990627000056],
              [89.88721764400003, 21.900091864000046],
              [89.88038170700008, 21.88418203300006],
              [89.87322024800005, 21.88157786700009],
              [89.85092207100007, 21.877508856000077],
              [89.82520592500003, 21.856268622000073],
              [89.81959069100003, 21.849554755000042],
              [89.81763756600003, 21.844916083000044],
              [89.81421959700003, 21.84080638200004],
              [89.80469811300003, 21.835760809000078],
              [89.78638756600003, 21.828924872000073],
              [89.77572675900007, 21.82758209800005],
              [89.77116946700005, 21.83234284100007],
              [89.76587975400008, 21.84674713700008],
              [89.75342858200008, 21.843898830000057],
              [89.73845462300005, 21.834418036000045],
              [89.72584069100003, 21.828924872000073],
              [89.70915774800005, 21.83006419500009],
              [89.69044030000003, 21.833726304000038],
              [89.67335045700008, 21.84007396000004],
              [89.66130618600005, 21.849351304000038],
              [89.65691165500004, 21.857123114000046],
              [89.65316816500007, 21.867743231000077],
              [89.65259850400008, 21.878851630000042],
              [89.66334069100003, 21.896307684000078],
              [89.66130618600005, 21.90582916900007],
              [89.64698326900003, 21.925116278000075],
              [89.61898847700007, 21.86985911700009],
              [89.63038170700008, 21.85146719000005],
              [89.64975019600007, 21.82636139500005],
              [89.67204837300005, 21.80426666900007],
              [89.69206790500004, 21.79482656500005],
              [89.70069420700008, 21.784857489000046],
              [89.68995201900003, 21.76520416900007],
              [89.66822350400008, 21.750881252000056],
              [89.64356530000003, 21.75690338700008],
              [89.63152103000004, 21.764064846000053],
              [89.62037194100003, 21.76434967700004],
              [89.59546959700003, 21.75999583500004],
              [89.59278405000003, 21.754380601000037],
              [89.60377037900008, 21.727687893000052],
              [89.60596764400003, 21.71906159100007],
              [89.58692467500003, 21.700832424000055],
              [89.56568444100003, 21.713364976000037],
              [89.53711998800003, 21.75381094000005],
              [89.53891035200007, 21.77147044500009],
              [89.52735436300003, 21.81281159100007],
              [89.53028405000003, 21.835760809000078],
              [89.53834069100003, 21.84861888200004],
              [89.55689537900008, 21.868801174000055],
              [89.56446373800003, 21.88418203300006],
              [89.56763756600003, 21.90070221600007],
              [89.56348717500003, 21.973130601000037],
              [89.57129967500003, 22.03123607000009],
              [89.57667076900003, 22.051703192000048],
              [89.60059655000003, 22.09125397300005],
              [89.60596764400003, 22.113226630000042],
              [89.60254967500003, 22.134507554000038],
              [89.59376061300003, 22.155422268000052],
              [89.58139082100007, 22.17405833500004],
              [89.56788170700008, 22.18891022300005],
              [89.56723066500007, 22.202826239000046],
              [89.59791100400008, 22.240301825000074],
              [89.60596764400003, 22.25690338700008],
              [89.60710696700005, 22.278265692000048],
              [89.61060631600003, 22.298895575000074],
              [89.61695397200003, 22.318426825000074],
              [89.62647545700008, 22.336004950000074],
              [89.61548912900008, 22.328273830000057],
              [89.60621178500003, 22.315619208000044],
              [89.59245853000004, 22.288234768000052],
              [89.58082116000003, 22.27724844000005],
              [89.57715905000003, 22.268500067000048],
              [89.58619225400008, 22.245428778000075],
              [89.58033287900008, 22.236761786000045],
              [89.56104576900003, 22.223089911000045],
              [89.54916425900007, 22.20526764500005],
              [89.55030358200008, 22.19212474200009],
              [89.57129967500003, 22.157904364000046],
              [89.57634524800005, 22.14549388200004],
              [89.57878665500004, 22.135891018000052],
              [89.57935631600003, 22.113226630000042],
              [89.57699629000007, 22.101263739000046],
              [89.56674238400007, 22.082098700000074],
              [89.56446373800003, 22.072211005000042],
              [89.55648847700007, 22.00844961100006],
              [89.55144290500004, 21.99404531500005],
              [89.53288821700005, 21.98468659100007],
              [89.52475019600007, 22.000148830000057],
              [89.52344811300003, 22.044623114000046],
              [89.52613366000003, 22.055121161000045],
              [89.53646894600007, 22.075832424000055],
              [89.53711998800003, 22.089016018000052],
              [89.49203535200007, 22.188381252000056],
              [89.48943118600005, 22.208807684000078],
              [89.49415123800003, 22.253566799000055],
              [89.49301191500007, 22.273504950000074],
              [89.48316491000003, 22.295070705000057],
              [89.47575931100005, 22.295070705000057],
              [89.46745853000004, 22.228989976000037],
              [89.47575931100005, 22.10260651200008],
              [89.48316491000003, 22.10260651200008],
              [89.48406009200005, 22.11668528900009],
              [89.48878014400003, 22.12958405200004],
              [89.49415123800003, 22.136867580000057],
              [89.49683678500003, 22.133978583000044],
              [89.49822024800005, 22.12531159100007],
              [89.50171959700003, 22.113104559000078],
              [89.50684655000003, 22.10101959800005],
              [89.51295006600003, 22.09243398600006],
              [89.51832116000003, 22.081000067000048],
              [89.51742597700007, 22.066473700000074],
              [89.50912519600007, 22.04120514500005],
              [89.50416100400008, 22.03668854400007],
              [89.49187259200005, 22.03457265800006],
              [89.48943118600005, 22.03123607000009],
              [89.49040774800005, 22.023993231000077],
              [89.49268639400003, 22.019191799000055],
              [89.49683678500003, 22.01386139500005],
              [89.50049889400003, 22.00259023600006],
              [89.51270592500003, 21.97809479400007],
              [89.52003014400003, 21.969183661000045],
              [89.52182050900007, 21.96230703300006],
              [89.51254316500007, 21.909125067000048],
              [89.50228925900007, 21.89752838700008],
              [89.48910566500007, 21.888373114000046],
              [89.47575931100005, 21.876695054000038],
              [89.46461022200003, 21.859198309000078],
              [89.46363366000003, 21.845038153000075],
              [89.46705162900008, 21.828599351000037],
              [89.46949303500003, 21.804388739000046],
              [89.46583092500003, 21.781317450000074],
              [89.45622806100005, 21.76239655200004],
              [89.44271894600007, 21.746649481000077],
              [89.40642337300005, 21.717352606000077],
              [89.39519290500004, 21.71637604400007],
              [89.36963951900003, 21.743312893000052],
              [89.36426842500003, 21.758205471000053],
              [89.36280358200008, 21.78384023600006],
              [89.36589603000004, 21.828924872000073],
              [89.37126712300005, 21.84715403900009],
              [89.38428795700008, 21.877834377000056],
              [89.38697350400008, 21.901190497000073],
              [89.38266035200007, 21.92133209800005],
              [89.36402428500003, 21.95506419500009],
              [89.35962975400008, 21.972316799000055],
              [89.35222415500004, 21.972316799000055],
              [89.34595787900008, 21.95701732000009],
              [89.34880618600005, 21.944159247000073],
              [89.35523522200003, 21.93162669500009],
              [89.35962975400008, 21.917669989000046],
              [89.35962975400008, 21.901678778000075],
              [89.35596764400003, 21.892523505000042],
              [89.33912194100003, 21.876695054000038],
              [89.32886803500003, 21.86465078300006],
              [89.32260175900007, 21.854641018000052],
              [89.30616295700008, 21.817613023000035],
              [89.30128014400003, 21.809393622000073],
              [89.29623457100007, 21.809068101000037],
              [89.29070071700005, 21.822088934000078],
              [89.28394616000003, 21.822088934000078],
              [89.28443444100003, 21.796820380000042],
              [89.29468834700003, 21.75779857000009],
              [89.29070071700005, 21.733343817000048],
              [89.27369225400008, 21.69879791900007],
              [89.27662194100003, 21.687567450000074],
              [89.29753665500004, 21.678127346000053],
              [89.28589928500003, 21.66559479400007],
              [89.26872806100005, 21.653998114000046],
              [89.24870853000004, 21.64590078300006],
              [89.22925866000003, 21.64394765800006],
              [89.21045983200008, 21.654120184000078],
              [89.20443769600007, 21.672674872000073],
              [89.20826256600003, 21.690619208000044],
              [89.21859785200007, 21.698553778000075],
              [89.22071373800003, 21.709418036000045],
              [89.18970787900008, 21.79124583500004],
              [89.18824303500003, 21.799709377000056],
              [89.18767337300005, 21.81150950700004],
              [89.18336022200003, 21.815619208000044],
              [89.17408287900008, 21.81004466400009],
              [89.16456139400003, 21.80019765800006],
              [89.16041100400008, 21.79132721600007],
              [89.15455162900008, 21.786851304000038],
              [89.14128665500004, 21.790228583000044],
              [89.11939537900008, 21.80097077000005],
              [89.10906009200005, 21.809515692000048],
              [89.10466556100005, 21.81586334800005],
              [89.07992597700007, 21.897406317000048],
              [89.07781009200005, 21.91425202000005],
              [89.08041425900007, 21.934881903000075],
              [89.09107506600003, 21.97679271000004],
              [89.09148196700005, 22.00023021000004],
              [89.08423912900008, 22.021185614000046],
              [89.06202233200008, 22.04950592700004],
              [89.05738366000003, 22.06509023600006],
              [89.06348717500003, 22.111029364000046],
              [89.06039472700007, 22.12986888200004],
              [89.06069258700006, 22.130484925000076],
              [89.07815922000009, 22.150845439000122],
              [89.07619551700009, 22.175030009000082],
              [89.07071781400009, 22.194822083000062],
              [89.06229455500011, 22.21156524700011],
              [89.01862797100011, 22.26468861900004],
              [89.00911950700004, 22.285617575000046],
              [89.02353723100003, 22.294815979000035],
              [89.00694909700013, 22.32142934200006],
              [89.00152307100007, 22.333676656000094],
              [88.98958581600004, 22.386903382000057],
              [88.98948246300012, 22.396670227000115],
              [88.99216963700013, 22.406953837000103],
              [89.00074792500004, 22.420131328000068],
              [89.00250492300006, 22.427986145000105],
              [88.99837080900011, 22.45124053900004],
              [88.979974, 22.490928039000025],
              [88.97098230000006, 22.52792836500008],
              [88.95904504400005, 22.53681671100007],
              [88.9279875090001, 22.54813385000007],
              [88.95031172700004, 22.561983134000016],
              [88.95640954600003, 22.584979146000066],
              [88.95201704900012, 22.611902568000076],
              [88.9423535570001, 22.637482402000032],
              [88.93000288900004, 22.658618063000077],
              [88.92592045100014, 22.680838928000114],
              [88.92250980600011, 22.69370636000012],
              [88.91057255100009, 22.722593486000065],
              [88.90814375800011, 22.74078359000002],
              [88.91496504800006, 22.75440033000011],
              [88.92623051000004, 22.767035218000032],
              [88.9368758550001, 22.782331441000096],
              [88.94121667500008, 22.795663961000017],
              [88.94514408400005, 22.815094300000098],
              [88.94679773000013, 22.834524638000076],
              [88.94452396600008, 22.848012187000037],
              [88.93310347500011, 22.85811492900008],
              [88.90514652600007, 22.86643483500005],
              [88.89346765200008, 22.879638164000127],
              [88.87217696100004, 22.926767070000054],
              [88.86173832200006, 22.942399190000074],
              [88.84277307100012, 22.964568380000017],
              [88.83879398700009, 22.975808004000058],
              [88.83941410300014, 22.995367534000067],
              [88.84871586100007, 23.02384124800001],
              [88.85129968300004, 23.07513010700005],
              [88.86478723200014, 23.10027069100009],
              [88.91909916200007, 23.153859152000038],
              [88.94586755400007, 23.174348857000027],
              [88.95470422400007, 23.18380564400009],
              [88.95982019100006, 23.19445098900006],
              [88.9599752200001, 23.2026933800001],
              [88.95423913600013, 23.207421773000092],
              [88.92695398000012, 23.206517436000055],
              [88.91806563300008, 23.208584493],
              [88.90964237500003, 23.212434388000062],
              [88.83962080900011, 23.234810283000044],
              [88.82267093900009, 23.237962545000087],
              [88.80954512500011, 23.236050517000066],
              [88.80096683800008, 23.23075368300003],
              [88.79419722500006, 23.224965922000067],
              [88.78618737800008, 23.221529439000037],
              [88.77569706300011, 23.22163279200005],
              [88.71001631700005, 23.241218160000088],
              [88.69658044500011, 23.252354432000104],
              [88.68660689300003, 23.271603902000024],
              [88.68593510000005, 23.293308004000025],
              [88.69503015100008, 23.312609152000064],
              [88.71926639800006, 23.348291728000063],
              [88.76789392100011, 23.467276713],
              [88.77016768400011, 23.48882578600005],
              [88.7568351650001, 23.49879933700005],
              [88.74370935100012, 23.489316711000086],
              [88.73192712400004, 23.472625224000055],
              [88.71942142800003, 23.468103536000015],
              [88.70464196800003, 23.495181986000077],
              [88.69378991700006, 23.499807028000035],
              [88.66448938000008, 23.518307190000073],
              [88.64764286400003, 23.535076193000023],
              [88.62423344000007, 23.573859355000067],
              [88.6092472740001, 23.588793844000023],
              [88.60128910400005, 23.59034413700003],
              [88.58154870600009, 23.58832875600008],
              [88.57142012600013, 23.592333679000077],
              [88.56170495600009, 23.602023010000025],
              [88.5610848390001, 23.608611756000087],
              [88.56439213100009, 23.61620819100007],
              [88.56635583500014, 23.628739726000063],
              [88.56123986800003, 23.632486268],
              [88.55095625800004, 23.6344241340001],
              [88.54155114800011, 23.63876495400008],
              [88.54010420800012, 23.64995290100005],
              [88.56118819200003, 23.74100677500006],
              [88.55974125200004, 23.75028269500008],
              [88.55250655100008, 23.765423890000093],
              [88.55271325700005, 23.774984029],
              [88.55767419400007, 23.785681051000026],
              [88.57235030200007, 23.806894226000068],
              [88.57751794500007, 23.818521424000025],
              [88.57762129700012, 23.827616476000102],
              [88.5754508870001, 23.836556499000025],
              [88.57436568200012, 23.845625712000086],
              [88.57762129700012, 23.855160014000077],
              [88.59358931500003, 23.866916402000086],
              [88.61317468300007, 23.867846578000027],
              [88.63394860900007, 23.866141256000063],
              [88.65312056500011, 23.869784445000064],
              [88.66650476100006, 23.87949961400001],
              [88.70443526200006, 23.913709412000102],
              [88.71415043100006, 23.925155742000115],
              [88.71714766500003, 23.9431391400001],
              [88.71435713700004, 23.964403992000072],
              [88.70836267100003, 23.98355011000008],
              [88.70159305800007, 23.995280660000063],
              [88.7138403730001, 24.01468516100003],
              [88.72546757000009, 24.028896179000085],
              [88.72500248200004, 24.03837880500008],
              [88.70092126500009, 24.043649801000086],
              [88.69782067900007, 24.05625885000002],
              [88.67901045700006, 24.071219178],
              [88.67410119700003, 24.082639669000102],
              [88.67539310700005, 24.09183807400008],
              [88.68180098500011, 24.112663676000054],
              [88.68298954300013, 24.12429087300002],
              [88.67828698800014, 24.144651388000042],
              [88.67808028100006, 24.154289043000077],
              [88.68376468900004, 24.166536356000094],
              [88.69378991700006, 24.17532135100008],
              [88.71590743000007, 24.182917786000033],
              [88.73145573500011, 24.1897713150001],
              [88.73161706600013, 24.18984242800012],
              [88.73482100400008, 24.19842071500007],
              [88.74639652500014, 24.21407867500001],
              [88.74980717000005, 24.223251242000103],
              [88.74748173000006, 24.226971945000017],
              [88.74494958500009, 24.24337921200008],
              [88.74303755700004, 24.24753916500002],
              [88.73750817900003, 24.28709747300006],
              [88.71456384300012, 24.315416158000048],
              [88.68180098500011, 24.333890483000076],
              [88.66014856000004, 24.338257141000057],
              [88.64950321500004, 24.31536448200002],
              [88.63451705000006, 24.294125468000047],
              [88.61245121300004, 24.292885234000025],
              [88.56310021900003, 24.308207296000077],
              [88.49834965000008, 24.31097198500005],
              [88.47540531400011, 24.315467835000064],
              [88.40130131100011, 24.36941803000012],
              [88.13878503400008, 24.495250143000092],
              [88.10994958500004, 24.50098622700007],
              [88.10793420400006, 24.50796254500007],
              [88.0987874760001, 24.5224836230001],
              [88.09000248300003, 24.532999777000057],
              [88.08602339700013, 24.536720480000085],
              [88.08498986800004, 24.541733093000047],
              [88.08498986800004, 24.593874614000086],
              [88.08183760600008, 24.599869080000033],
              [88.06726485200005, 24.613666687000077],
              [88.05723962400003, 24.63410471600004],
              [88.04090987200004, 24.640435079000056],
              [88.02178959200006, 24.64560272200005],
              [88.02716394100014, 24.675730082000044],
              [88.0354321690001, 24.69381683400006],
              [88.04845463100014, 24.71120595300009],
              [88.05320886200013, 24.754975891000086],
              [88.06426761900013, 24.759161682000112],
              [88.07698002200004, 24.761177063000062],
              [88.0840080160001, 24.770452983000084],
              [88.08535160400004, 24.78401804600007],
              [88.08824548300004, 24.796136170000054],
              [88.09480839000008, 24.803112488000053],
              [88.10777917500013, 24.801097107000103],
              [88.11739099100004, 24.81926137300003],
              [88.13124027500004, 24.831767070000055],
              [88.14095544500003, 24.844582825000103],
              [88.13806156400005, 24.863496399000056],
              [88.12493575100012, 24.89814544700006],
              [88.12033654800007, 24.906775411000027],
              [88.11491052200006, 24.912020569000035],
              [88.11491052200006, 24.916413066000032],
              [88.16451989700005, 24.941114400000046],
              [88.1830200610001, 24.946979675000037],
              [88.20245039900004, 24.945300191000072],
              [88.21878015100009, 24.93514577200004],
              [88.23283614100012, 24.918273417000037],
              [88.24187951700009, 24.898765564000044],
              [88.24275801600004, 24.880601299000105],
              [88.25485030100009, 24.87995534300005],
              [88.29681156400011, 24.86969757100006],
              [88.31360640500009, 24.868302307000064],
              [88.32275313400004, 24.8746843470001],
              [88.34089156100009, 24.904139913],
              [88.37566980000014, 24.945610251000076],
              [88.38786543800006, 24.968761292000053],
              [88.39101770100007, 24.99509043400012],
              [88.41411706500008, 25.021522929000085],
              [88.42579593900007, 25.051056010000124],
              [88.43416752100012, 25.11665924100005],
              [88.4314803470001, 25.173038229000056],
              [88.44129886900004, 25.189729716],
              [88.47540531400011, 25.195104065000052],
              [88.49183842000008, 25.191124980000083],
              [88.5231543380001, 25.179807841000112],
              [88.5500260820001, 25.1731415820001],
              [88.55467696100004, 25.171126201000035],
              [88.55937951600004, 25.17076446600005],
              [88.57069665500012, 25.173244935000028],
              [88.57772465000005, 25.177482401000063],
              [88.59012699400012, 25.190143127000013],
              [88.59911869300004, 25.193140361000033],
              [88.6342586670001, 25.19226186200008],
              [88.66459273300012, 25.18688751200004],
              [88.72453739400004, 25.166475322000068],
              [88.78422367300004, 25.16094594400009],
              [88.79233687400006, 25.166578675000025],
              [88.80251713100012, 25.188127747000053],
              [88.8091317140001, 25.195259094],
              [88.81708988500009, 25.19680938700013],
              [88.82360111500003, 25.194845683],
              [88.83021569900012, 25.191331686000026],
              [88.89863529500013, 25.169317526000057],
              [88.92416345200007, 25.167870585000074],
              [88.90964237500003, 25.189161275000046],
              [88.92788415600006, 25.192726949000118],
              [88.93077803600005, 25.202648825000026],
              [88.9279875090001, 25.215929667000026],
              [88.9290727130001, 25.229417216000073],
              [88.93775435400005, 25.240165914],
              [88.97532312000004, 25.265228984000103],
              [88.98235111500009, 25.27489247700005],
              [88.98493493700005, 25.284969381000067],
              [88.98271285000004, 25.29447784400007],
              [88.97532312000004, 25.302642721000083],
              [88.92648889200007, 25.300472310000075],
              [88.90287276200007, 25.30341786700008],
              [88.88612959800014, 25.31907582600006],
              [88.88018680800008, 25.32346832300003],
              [88.85925785400013, 25.32470855700008],
              [88.84902592000003, 25.327189026000056],
              [88.84199792500004, 25.332821757000076],
              [88.81833011900011, 25.35964182600007],
              [88.81404097600006, 25.370390524000086],
              [88.81326582800011, 25.380054016000102],
              [88.81037194800012, 25.388425598000097],
              [88.79962325000014, 25.39560862300003],
              [88.79931319200006, 25.401706442000105],
              [88.81631473800007, 25.437208151000036],
              [88.81491947500007, 25.45860219300006],
              [88.80582442200011, 25.471676331000097],
              [88.79311202000014, 25.481959941000085],
              [88.78096805800004, 25.495189108000105],
              [88.77233809500012, 25.501958720000047],
              [88.74195235200006, 25.51275909400006],
              [88.74257246900004, 25.495189108000105],
              [88.73265059500011, 25.49100331700005],
              [88.72314213100003, 25.49141672800006],
              [88.71415043100006, 25.492811992000057],
              [88.70619226100013, 25.49167511000003],
              [88.69565026900005, 25.48361358600006],
              [88.68707198100003, 25.47389841700003],
              [88.67808028100006, 25.465888570000047],
              [88.66634973200013, 25.46289133800012],
              [88.64542077600004, 25.46733551000004],
              [88.61317468300007, 25.486404114000024],
              [88.59358931500003, 25.495085755000062],
              [88.55095625800004, 25.49648101800004],
              [88.53028568600013, 25.500201721000067],
              [88.52046716400008, 25.50929677400002],
              [88.51276737500007, 25.523714498000047],
              [88.48558557100012, 25.542628072000085],
              [88.47540531400011, 25.56257517600001],
              [88.43778487200012, 25.579835104],
              [88.42378055900008, 25.592237447000073],
              [88.41943973800011, 25.653784078000072],
              [88.39298140400012, 25.680759176000024],
              [88.32027266500006, 25.725252584000103],
              [88.25991459200009, 25.789021301000034],
              [88.22746179300003, 25.80426584900006],
              [88.18271000200008, 25.792431946000065],
              [88.16622522000011, 25.78364695300006],
              [88.14643314600005, 25.77574045800013],
              [88.12772627800007, 25.77491363500009],
              [88.11491052200006, 25.787264303000043],
              [88.1080375570001, 25.806281230000124],
              [88.10333500200005, 25.814807841000047],
              [88.08757369000006, 25.830982564000024],
              [88.08757369000006, 25.839974264000077],
              [88.08896895400005, 25.84865590400004],
              [88.08204431200005, 25.86384877600007],
              [88.07439620000008, 25.90813547800009],
              [88.07739343300005, 25.91278635700006],
              [88.08266442900003, 25.9159386190001],
              [88.08803877800005, 25.923224996],
              [88.10653894000012, 25.97996571900002],
              [88.12586592600007, 26.013400371],
              [88.1510323490001, 26.031332093000074],
              [88.15790531400006, 26.050452373000056],
              [88.15640669800007, 26.061407776000053],
              [88.15098067200006, 26.066988830000057],
              [88.14477950000008, 26.0705028280001],
              [88.14116215000013, 26.075463766000055],
              [88.13992191600005, 26.085333964000043],
              [88.14136885600004, 26.090501607000036],
              [88.14446944200012, 26.095875957000104],
              [88.15563155100006, 26.128483785000057],
              [88.16379642800007, 26.140472717000122],
              [88.19692102100004, 26.159644674000035],
              [88.20565433800004, 26.16641428700008],
              [88.21195886300006, 26.173752340000064],
              [88.21888350500012, 26.180160217000022],
              [88.22978723200009, 26.18403595000005],
              [88.25030277600007, 26.18801503500005],
              [88.30869714400012, 26.206101787000065],
              [88.32626713100012, 26.215920309000026],
              [88.33453536000013, 26.23080312100008],
              [88.33293339100004, 26.267235006000064],
              [88.33660241700011, 26.281807760000035],
              [88.35169193600012, 26.300979717000033],
              [88.36678145400003, 26.31343373600002],
              [88.41380700700006, 26.340202129000076],
              [88.42119673700012, 26.348728740000112],
              [88.4260026450001, 26.35792714500009],
              [88.43168705300013, 26.362216289000074],
              [88.44202233900006, 26.356118470000112],
              [88.44863692200005, 26.353431295000078],
              [88.4579903560001, 26.353017883000078],
              [88.46791223200006, 26.35405141200006],
              [88.47540531400011, 26.35580841100004],
              [88.49762618100004, 26.352707825],
              [88.49545577000009, 26.378080953000094],
              [88.47540531400011, 26.432031148000036],
              [88.46114261900004, 26.453890280000067],
              [88.43458093200013, 26.465155741000032],
              [88.37691003500004, 26.475335999000023],
              [88.35355228700013, 26.484586080000028],
              [88.34652429200008, 26.484017639000072],
              [88.34301029400007, 26.477196351000103],
              [88.34021976700006, 26.454148662000065],
              [88.33562056500006, 26.44820587200003],
              [88.32254642700008, 26.451771546000103],
              [88.31510502100008, 26.465052389],
              [88.31386478700006, 26.481537170000095],
              [88.31934248900012, 26.494921367000032],
              [88.33236495000006, 26.514661764],
              [88.35282881700005, 26.578688864000085],
              [88.36027022300004, 26.59310658800011],
              [88.37251753700008, 26.611606751000025],
              [88.38528161700003, 26.623544007000064],
              [88.39437666800012, 26.61801462800007],
              [88.39592696100004, 26.599566142000057],
              [88.39499678600009, 26.578378805000014],
              [88.39789066600008, 26.558690084000048],
              [88.41101648000011, 26.545099182000072],
              [88.44646651200009, 26.53553904300007],
              [88.46238285300007, 26.528821106000052],
              [88.47540531400011, 26.514971823000067],
              [88.48791101100011, 26.50577341800009],
              [88.49865970900004, 26.4948696900001],
              [88.50682458500006, 26.487634989000057],
              [88.52682336400011, 26.475387676000125],
              [88.54976770000013, 26.466654358000042],
              [88.55798425300009, 26.465724182000102],
              [88.57917159000004, 26.466034241000088],
              [88.59116052200005, 26.46122833300008],
              [88.59787845900007, 26.451461487000117],
              [88.60356286700005, 26.44019602500005],
              [88.6115210370001, 26.43084259100003],
              [88.62237308800007, 26.424538066000096],
              [88.63301843300013, 26.4200938930001],
              [88.65627282700007, 26.41513295500006],
              [88.65193200700008, 26.407071432000052],
              [88.64986495000005, 26.3983897910001],
              [88.6522420660001, 26.39151682600003],
              [88.66107873600009, 26.388881328000124],
              [88.66852014200009, 26.385729065000064],
              [88.66743493700011, 26.36815907800009],
              [88.67337772700012, 26.360717672000064],
              [88.69627038600004, 26.350279032000046],
              [88.70970625900009, 26.34061554],
              [88.71223840300007, 26.328264872000048],
              [88.70298832200007, 26.309661357],
              [88.69012089100005, 26.299842835000035],
              [88.65327559400004, 26.283099671000073],
              [88.64583418800004, 26.27601999900004],
              [88.6634041750001, 26.26444447900009],
              [88.74794681800006, 26.292504782000023],
              [88.78401696800006, 26.27994740900003],
              [88.79202681500004, 26.264599508000046],
              [88.7984863690001, 26.247649638000055],
              [88.80799483200008, 26.23343861900007],
              [88.82484134900005, 26.22656565400011],
              [88.84065433800009, 26.2320433550001],
              [88.85564050400012, 26.2651162720001],
              [88.8757943110001, 26.27736358600002],
              [88.90271773300003, 26.272919414000015],
              [88.94684940600013, 26.232921855000043],
              [88.97532312000004, 26.22434356700002],
              [89.01945479300014, 26.23447214800005],
              [89.03971195500003, 26.24718455000003],
              [89.03433760600007, 26.26578806600007],
              [89.02353723100003, 26.2688369750001],
              [89.01159997600013, 26.2691987110001],
              [89.00436527500005, 26.275709941000073],
              [89.00798262600011, 26.29715566],
              [88.99862919200007, 26.291522929000067],
              [88.98968916900009, 26.289404195000074],
              [88.9817309980001, 26.291832987000063],
              [88.97532312000004, 26.29994618800005],
              [88.96602136200005, 26.328471578000105],
              [88.94121667500008, 26.340098775000072],
              [88.91243290200009, 26.348935445000066],
              [88.89186568200006, 26.368779196000062],
              [88.89124556500013, 26.38578074100006],
              [88.89946211800003, 26.40448761000006],
              [88.91196781400004, 26.421230774000023],
              [88.92457686400007, 26.43213450100008],
              [88.94100996900005, 26.439420878000064],
              [88.95015669700012, 26.436940410000076],
              [88.95930342700012, 26.428568828],
              [88.97532312000004, 26.417871806000093],
              [88.98653690600008, 26.4127041630001],
              [89.00178145400014, 26.397149557000077],
              [89.01087650500011, 26.390173239000077],
              [89.02178023300007, 26.38624582900009],
              [89.04374271700004, 26.381078186000096],
              [89.05263106300004, 26.374618632000036],
              [89.05728194200003, 26.362629700000085],
              [89.05407800300003, 26.353948059000018],
              [89.05521488500005, 26.347023417000045],
              [89.07185469600006, 26.34061554],
              [89.09572920800008, 26.33451772100004],
              [89.10291223200011, 26.327334696],
              [89.10353234900009, 26.313692118000077],
              [89.09479903200014, 26.30950632700005],
              [89.0803296310001, 26.315604146000013],
              [89.0688574620001, 26.314260559000033],
              [89.06942590300014, 26.287388815000057],
              [89.07588545700008, 26.271059062000106],
              [89.09588423700012, 26.24103505500004],
              [89.10337732000005, 26.22517039000003],
              [89.11169722500011, 26.16450225900006],
              [89.11919030800004, 26.1466222130001],
              [89.13159265100012, 26.133754781],
              [89.19784183700011, 26.107709859000025],
              [89.21262129800004, 26.098976543000063],
              [89.22305993600008, 26.086574198000065],
              [89.22926110800006, 26.067195537000103],
              [89.23763269000011, 26.058100484000036],
              [89.27297937100013, 26.043476054000067],
              [89.29690555800005, 26.0181546030001],
              [89.31514733900008, 26.006785787000084],
              [89.33530114700005, 25.998569235000062],
              [89.35147587100005, 25.996863912000023],
              [89.3677539470001, 26.005442200000047],
              [89.37974287900005, 26.015312399000024],
              [89.39142175300003, 26.015467428000065],
              [89.40661462500003, 25.995055237000102],
              [89.4112655030001, 25.993194885000023],
              [89.41612308700013, 25.992626444000066],
              [89.42118737800007, 25.993194885000023],
              [89.42635502100012, 25.994951884000088],
              [89.42640669700012, 25.995055237000102],
              [89.48061527500005, 25.999241028000043],
              [89.4856278900001, 25.998724263000028],
              [89.49064050300007, 25.997329],
              [89.49534305900005, 25.995055237000102],
              [89.50945072500008, 25.97262766500002],
              [89.51818404200003, 25.96208567400005],
              [89.52841597500003, 25.957124735000022],
              [89.54169681900004, 25.959708558],
              [89.54908654800005, 25.96885528600008],
              [89.55182539900011, 25.98151601200003],
              [89.55068851700008, 25.995055237000102],
              [89.55916345200006, 26.02223704],
              [89.60288171400009, 26.055258280000075],
              [89.61135664900007, 26.072208150000066],
              [89.60386356700013, 26.084662171000062],
              [89.5907894290001, 26.085023906000046],
              [89.57694014500004, 26.082646790000112],
              [89.56701827000012, 26.087090963000023],
              [89.56691491700008, 26.098976543000063],
              [89.57787032100009, 26.107244771000083],
              [89.59254642800005, 26.113962708000102],
              [89.60422530100004, 26.120732320000073],
              [89.58577681500003, 26.122902731000053],
              [89.56939538600005, 26.130085754],
              [89.56278080300007, 26.142591452000104],
              [89.57342614800007, 26.16072987900013],
              [89.57993737800012, 26.166104228000094],
              [89.58675866700008, 26.169204814000025],
              [89.59399336800004, 26.16972157800008],
              [89.6144055580001, 26.164192200000073],
              [89.61528405800004, 26.169101461000096],
              [89.60846276900008, 26.180676982000037],
              [89.60639571100012, 26.2110110470001],
              [89.61332035300012, 26.219382629000066],
              [89.63492110200008, 26.22584218300001],
              [89.65300785400007, 26.222689921000054],
              [89.65838220200004, 26.207858785000028],
              [89.6578286080001, 26.18717448300005],
              [89.65724532100006, 26.165380758000097],
              [89.65579838100007, 26.161298320000085],
              [89.65817549700012, 26.159231262000034],
              [89.6703711340001, 26.15411529600003],
              [89.67770918800011, 26.153133443000073],
              [89.69765629100004, 26.154787089000095],
              [89.70654463700004, 26.154166972000056],
              [89.7184818930001, 26.14553700800009],
              [89.72432133000007, 26.130654195000048],
              [89.72876550300009, 26.114169413000084],
              [89.73672367300003, 26.100578511],
              [89.74984948700012, 26.08388702400005],
              [89.75114139900006, 26.071536357000085],
              [89.74871260600008, 26.05903066000009],
              [89.75021122300012, 26.041564026000046],
              [89.75584395400011, 26.032417297000066],
              [89.77641117400003, 26.008232727000077],
              [89.78395593200008, 25.99510691300013],
              [89.78943363500014, 25.9879755650001],
              [89.79553145400013, 25.985960185000053],
              [89.80204268400007, 25.98864736000006],
              [89.80886397300003, 25.99510691300013],
              [89.80917403100011, 25.99510691300013],
              [89.80932906100008, 25.995210266000058],
              [89.81103438300005, 25.99603708900007],
              [89.81268802900007, 25.996347148000055],
              [89.81413496900007, 25.99614044200011],
              [89.8152718500001, 25.99510691300013],
              [89.82865604700004, 25.979397278000064],
              [89.82560713700008, 25.965703024000035],
              [89.81155114700005, 25.955212708000076],
              [89.79201745600005, 25.94911488900003],
              [89.81072432500014, 25.938779603000015],
              [89.82643396000003, 25.937487691000072],
              [89.83439213000008, 25.931751608000113],
              [89.83005131100009, 25.90798044900005],
              [89.7869531660001, 25.839147441000065],
              [89.78312911000006, 25.81444610700005],
              [89.80152592000013, 25.72468414400005],
              [89.82421187300008, 25.674092916000106],
              [89.83439213000008, 25.63476715100002],
              [89.82509037300014, 25.56448720300004],
              [89.82323002100003, 25.489142965000056],
              [89.80856794000005, 25.439507112000015],
              [89.80069909700012, 25.41286855100013],
              [89.79923403500004, 25.402892809000022],
              [89.79501469000007, 25.374162903000112],
              [89.79852868700004, 25.340056458000035],
              [89.80736535600005, 25.304503073],
              [89.81904423000009, 25.284969381000067],
              [89.83459883600011, 25.282437236000092],
              [89.87020389800011, 25.29556305000007],
              [89.90813440000011, 25.29690663700002],
              [90.13008467700013, 25.211588847000044],
              [90.28692264800003, 25.180066223000082],
              [90.36464400300014, 25.149990540000104],
              [90.39978397700008, 25.149008687000034],
              [90.50137984200012, 25.168800761000014],
              [90.58333866400005, 25.16203114900007],
              [90.62343957500008, 25.171436259000032],
              [90.6375989180001, 25.171074524000048],
              [90.64896773300012, 25.167818909000047],
              [90.67056848100009, 25.158775533],
              [90.70767216000013, 25.15298777300002],
              [90.71635380000009, 25.153556214000062],
              [90.72203820800007, 25.15660512300009],
              [90.73268355400006, 25.16688873300008],
              [90.73795454900005, 25.16942087900007],
              [90.75397424300013, 25.167560527000077],
              [90.76689335100014, 25.16053253200006],
              [90.77939904800013, 25.151954244000038],
              [90.7939718020001, 25.14539133700005],
              [90.82198042800007, 25.142290752000108],
              [90.93482138600007, 25.156359858000044],
              [90.9434200450001, 25.15743194600013],
              [90.97514937400013, 25.167818909000047],
              [91.13534631400006, 25.191228333000097],
              [91.19084680200012, 25.189471334000032],
              [91.20314579300009, 25.191331686000026],
              [91.22495324700009, 25.201615296000043],
              [91.23570194500013, 25.201925354000096],
              [91.28396773300005, 25.178981018000073],
              [91.43186568300013, 25.137949931000023],
              [91.47103641800004, 25.133919170000027],
              [91.4807515870001, 25.135262757000092],
              [91.50090539600006, 25.14115387],
              [91.51165409400011, 25.14249745700006],
              [91.52343632100008, 25.145184632000095],
              [91.54017948400013, 25.157638652000074],
              [91.5487577720001, 25.161100973000103],
              [91.56612105300007, 25.15996409100002],
              [91.57345910700008, 25.152264302000034],
              [91.5801770430001, 25.140895488000027],
              [91.59619673700007, 25.128906555000086],
              [91.61314660700009, 25.12513417600006],
              [91.63867476400003, 25.12404897100005],
              [91.66203251100006, 25.127201233],
              [91.67226444500005, 25.13650299100003],
              [91.67743208800005, 25.152626038000037],
              [91.68890425700005, 25.15298777300002],
              [91.70182336400006, 25.14714833600003],
              [91.7107117110001, 25.14466786800007],
              [91.71773970600009, 25.149835511000063],
              [91.72373417200004, 25.161927796000057],
              [91.73014204900005, 25.167457174000063],
              [91.74533492100011, 25.169369202000055],
              [91.79370406100003, 25.16533844000007],
              [91.90057092300009, 25.177585754000106],
              [91.95627811700012, 25.169782613000066],
              [91.97508833800003, 25.175363668],
              [92.00175337700006, 25.18296010400006],
              [92.03399947100013, 25.181668193000107],
              [92.06603886000005, 25.174536845000077],
              [92.09291060400011, 25.164718323],
              [92.1004553630001, 25.159085592000068],
              [92.11037723800007, 25.144874573000024],
              [92.11616499900003, 25.139448548000033],
              [92.12412316900003, 25.136968079000056],
              [92.13859257000013, 25.136399638000015],
              [92.14551721200013, 25.13169708200003],
              [92.15099491400008, 25.129733379000086],
              [92.16474084500004, 25.133557434000053],
              [92.17269901600008, 25.131955465000104],
              [92.17921024600008, 25.126684469000068],
              [92.19409305900012, 25.109166159000026],
              [92.20804569500012, 25.098107401],
              [92.22013798000012, 25.090381775000097],
              [92.2336772060001, 25.08495575000005],
              [92.25155725100012, 25.080795797000107],
              [92.30354374200004, 25.07428456600003],
              [92.31212203000007, 25.0686001590001],
              [92.32814172400003, 25.048007101000096],
              [92.35625370300005, 25.037000021],
              [92.38105839100012, 25.02343495700002],
              [92.38493703500006, 25.004773236000048],
              [92.38687592400004, 24.9954444560001],
              [92.38692635100006, 24.99520183],
              [92.38694950400003, 24.99509043400012],
              [92.39470096900004, 24.993230082000096],
              [92.41186000600004, 24.987527227000058],
              [92.41213950000014, 24.987434336],
              [92.4122709560001, 24.987390646000037],
              [92.41246032100014, 24.98436081700008],
              [92.41247766200007, 24.98408335400002],
              [92.44444627300004, 24.962427197000082],
              [92.44451704900007, 24.96237925200002],
              [92.45376877000012, 24.9582310630001],
              [92.45402551300003, 24.95811594700008],
              [92.45782812800007, 24.953557685000035],
              [92.45805627500005, 24.953284201000045],
              [92.45002848600006, 24.94663618700004],
              [92.4497880460001, 24.946437073000098],
              [92.4742723330001, 24.936715371000062],
              [92.4743860270001, 24.93667022800004],
              [92.48379113800013, 24.92822113000004],
              [92.49126714800008, 24.912424218000055],
              [92.49133589700006, 24.91227895100012],
              [92.49453983600006, 24.894863993000072],
              [92.49154260200004, 24.883727722000046],
              [92.47769331900008, 24.863909810000067],
              [92.44203658000009, 24.855409037000058],
              [92.38074833200005, 24.836702169000077],
              [92.37092980900007, 24.837916565000015],
              [92.36359175600006, 24.84101715100006],
              [92.36350740900014, 24.841120014000026],
              [92.35935428900012, 24.846184794000052],
              [92.35932057700006, 24.84642836600004],
              [92.35832076000014, 24.853652039000096],
              [92.35814605200005, 24.853748899000024],
              [92.29041792900011, 24.891298320000104],
              [92.29024450000003, 24.891351286000045],
              [92.2521773680001, 24.902977194000087],
              [92.2230318610001, 24.89137583400013],
              [92.21765751100003, 24.874580994000084],
              [92.22175905800003, 24.857046883000052],
              [92.22179162600014, 24.856907654000068],
              [92.23492786100007, 24.82499071000008],
              [92.23502079300005, 24.824764914000028],
              [92.23688114400005, 24.808590190000032],
              [92.23646773300004, 24.793035584],
              [92.23378055900008, 24.777532654000098],
              [92.18293094900008, 24.647256368000015],
              [92.1734224860001, 24.60839569200006],
              [92.16887496000004, 24.574315084000077],
              [92.16360396300013, 24.55919972800008],
              [92.1531653240001, 24.54454945900001],
              [92.14997986200007, 24.54218295400004],
              [92.13859257000013, 24.533723246000065],
              [92.12319299300003, 24.525377503000087],
              [92.11089400300011, 24.514292908000087],
              [92.10593306500004, 24.495250143000092],
              [92.11120406100008, 24.43429779100005],
              [92.10758671100012, 24.40597910600006],
              [92.08825972500006, 24.38163950700003],
              [92.06273156800012, 24.37102],
              [92.03337935400003, 24.368849590000067],
              [91.9499735920001, 24.37538665800004],
              [91.94883671100007, 24.363526917000016],
              [91.97136763500009, 24.329678853000118],
              [91.97219445900004, 24.316062114000104],
              [91.95307417800012, 24.322986755],
              [91.93095666500011, 24.336965231000093],
              [91.92186161300003, 24.34450999000005],
              [91.89984745300006, 24.338050435000085],
              [91.89643680900014, 24.32011871400003],
              [91.90687544800005, 24.28035369900003],
              [91.90594527200011, 24.260639140000066],
              [91.88434452300004, 24.17555389500005],
              [91.87710982300007, 24.158035584000075],
              [91.86450077300009, 24.15059417700006],
              [91.84424361200007, 24.155322571000042],
              [91.81375451700006, 24.183124492],
              [91.81137740100013, 24.192038676000024],
              [91.8097237550001, 24.214543763000037],
              [91.80703658100003, 24.221132507000036],
              [91.79659794100013, 24.221597595000063],
              [91.73293257600011, 24.234284159000097],
              [91.72301070200012, 24.22097747800008],
              [91.72580122900007, 24.202063904000042],
              [91.73200240000006, 24.181677551000107],
              [91.73262251800003, 24.164314270000077],
              [91.72115035100012, 24.148992208000024],
              [91.70368371600006, 24.14294606500009],
              [91.68415002500006, 24.145478211000082],
              [91.66616662600006, 24.155916850000025],
              [91.65717492700003, 24.17136810400011],
              [91.63950158700004, 24.211701559000076],
              [91.62906294800007, 24.21531890900006],
              [91.62451542100007, 24.203459168000037],
              [91.61376672300014, 24.140103862],
              [91.60601525900012, 24.11886484800003],
              [91.59650679500004, 24.104989726000056],
              [91.58183068900007, 24.096101380000064],
              [91.55867964700008, 24.089667663000014],
              [91.51754520700007, 24.085197652000076],
              [91.48044152900013, 24.088014018000067],
              [91.40458052600007, 24.103129374000062],
              [91.36303267500011, 24.099847921000062],
              [91.35083703600009, 24.074242249000022],
              [91.34928674300005, 24.036053366000132],
              [91.3390548100001, 23.995228984000036],
              [91.32706587800004, 23.987865092000035],
              [91.31621382700007, 23.989467062000088],
              [91.30843257700013, 23.992501035000103],
              [91.30494836400004, 23.993859558000068],
              [91.29161584500008, 23.994815573000025],
              [91.27414921100006, 23.988226827000048],
              [91.26092004400004, 23.97727142400008],
              [91.25037805200003, 23.96404225700006],
              [91.21627160700012, 23.90838673900005],
              [91.21193078600004, 23.89445994100008],
              [91.2127576090001, 23.880739848000033],
              [91.22402307100003, 23.857485453000024],
              [91.22815718600009, 23.844979757000104],
              [91.2252633060001, 23.82614369800011],
              [91.20521285000012, 23.77157338500008],
              [91.19498091600013, 23.755166118000105],
              [91.17658410700005, 23.746536154000083],
              [91.15756717900007, 23.744985861000046],
              [91.14175419100008, 23.73989573200008],
              [91.13234908000004, 23.720646261000056],
              [91.13658654800008, 23.698890483000028],
              [91.15239953700006, 23.691009827000087],
              [91.16893599500008, 23.685377096000067],
              [91.1752405200001, 23.67031341600007],
              [91.1664555260001, 23.654087016000048],
              [91.15229618400014, 23.655094707000032],
              [91.13968713400004, 23.65357025100012],
              [91.13627648900012, 23.629514872000087],
              [91.14082401500013, 23.61209991500006],
              [91.16986617000003, 23.561973776000045],
              [91.17751428300011, 23.544274597000125],
              [91.1858858650001, 23.511563416000044],
              [91.19508426900006, 23.495181986000077],
              [91.20335249900012, 23.487921448000108],
              [91.22081913300008, 23.47789622000009],
              [91.22733036300014, 23.4687753300001],
              [91.22970747900007, 23.461178894000042],
              [91.23446171100005, 23.436270854000085],
              [91.24789758300005, 23.393766989000127],
              [91.2581295170001, 23.37363901800005],
              [91.27094527200006, 23.3645956430001],
              [91.28396773300005, 23.36144338000004],
              [91.28727502500004, 23.35555226700005],
              [91.28293420400007, 23.34764577300008],
              [91.27290897700004, 23.338499044000017],
              [91.26577762900007, 23.329352315000037],
              [91.26753462700009, 23.321549174],
              [91.27290897700004, 23.313487651000017],
              [91.27724979600009, 23.303255717000027],
              [91.30050419200012, 23.14230946900001],
              [91.31352665200006, 23.101045838000076],
              [91.33740116400003, 23.071073507000037],
              [91.37088749200007, 23.06277944],
              [91.37460819500006, 23.095723165000052],
              [91.35590132700008, 23.17964569100006],
              [91.35569462100011, 23.224139099000027],
              [91.36096561700003, 23.247522685],
              [91.37212772600009, 23.261888733000077],
              [91.39434859200003, 23.2626638790001],
              [91.41357222500005, 23.248633728000087],
              [91.42814498000013, 23.229513449000095],
              [91.43651656100008, 23.214863180000023],
              [91.43620650200012, 23.215715841000062],
              [91.43961714700004, 23.22264048200013],
              [91.43992720500012, 23.223518983000062],
              [91.44643843600005, 23.215534973],
              [91.44674849500007, 23.20879119900006],
              [91.44540490800011, 23.203029277],
              [91.44643843600005, 23.1978874710001],
              [91.46121789600011, 23.184425761000043],
              [91.46359501200004, 23.184115702000057],
              [91.47041630100011, 23.153290711000082],
              [91.47506717900006, 23.14308461500012],
              [91.49811486900012, 23.069962464000056],
              [91.50328251200011, 23.0444084680001],
              [91.50607303900006, 23.041178691000127],
              [91.51558150200009, 23.03880157500008],
              [91.51816532400005, 23.03508087200008],
              [91.51940555800007, 23.005625305000066],
              [91.52364302600006, 22.995212504000037],
              [91.53656213400006, 22.981854146],
              [91.54979130000004, 22.977229106000053],
              [91.5631238200001, 22.974981181000132],
              [91.57676639900006, 22.96880584800006],
              [91.5830709230001, 22.957798767000057],
              [91.58296757000005, 22.94790273100007],
              [91.58606815600012, 22.94446624800004],
              [91.60239790900005, 22.95296702100005],
              [91.60828902200006, 22.96033091300005],
              [91.61200972500006, 22.969839376000053],
              [91.61666060400012, 22.978055929000064],
              [91.62575565600008, 22.98154408800012],
              [91.63278365100012, 22.98030385300008],
              [91.63991499800005, 22.978004253000066],
              [91.64694299300004, 22.97658315000008],
              [91.65407434100007, 22.978055929000064],
              [91.66761356600006, 22.982629293000016],
              [91.69469201700014, 22.98813283300011],
              [91.70699100800005, 22.995367534000067],
              [91.7144324140001, 23.00311899800009],
              [91.73127893100008, 23.017330018000038],
              [91.73830692600006, 23.02466807100005],
              [91.75505009000011, 23.048232524000056],
              [91.75629032400008, 23.052159933000027],
              [91.75556685400005, 23.05683665000008],
              [91.75598026500006, 23.061539206000063],
              [91.76094120300013, 23.065492453000033],
              [91.76424849400013, 23.065647481000084],
              [91.77375695800004, 23.06489817300006],
              [91.77623742700007, 23.065259909000062],
              [91.7913269450001, 23.080375265000086],
              [91.79556441200003, 23.08949615500005],
              [91.79194706200013, 23.101149190000015],
              [91.77902795400013, 23.131767476000036],
              [91.76393843600005, 23.200626323000037],
              [91.74915897700004, 23.232407329000083],
              [91.74368127400004, 23.27232737300004],
              [91.7625948490001, 23.321549174],
              [91.79163700400005, 23.368342183000024],
              [91.81768192600003, 23.40092417400008],
              [91.83380497300004, 23.413894959000103],
              [91.88909875500013, 23.43593495800009],
              [91.9051184490001, 23.446631979000088],
              [91.91814091000003, 23.459938660000105],
              [91.94077518800009, 23.495181986000077],
              [91.94232548000008, 23.534430237000052],
              [91.91597050000007, 23.650159607000077],
              [91.91442020700003, 23.68832265300007],
              [91.91648726400007, 23.7098717250001],
              [91.9226884360001, 23.72297170000006],
              [91.93664107300009, 23.723540141000043],
              [91.94914677000008, 23.709768372000084],
              [91.96165246600009, 23.691139018000015],
              [92.00351037700005, 23.647420757000035],
              [92.01901330600003, 23.640056865000034],
              [92.04237105300007, 23.64556040500004],
              [92.05963098100005, 23.659487203000126],
              [92.09218713400003, 23.701345114],
              [92.10841353400014, 23.718243307000094],
              [92.15078820800005, 23.731653341000126],
              [92.17063195800006, 23.70364471400002],
              [92.18076053900012, 23.665378317000105],
              [92.19429976400005, 23.648144226000042],
              [92.20938928200007, 23.661605937],
              [92.22210168500004, 23.70777882900005],
              [92.23874149600005, 23.7168480430001],
              [92.25930871600013, 23.706486918000095],
              [92.25973660500011, 23.702640572000078],
              [92.26168583200007, 23.68511871300008],
              [92.25000695800003, 23.642614848000036],
              [92.25279748500009, 23.609309388],
              [92.29103804500005, 23.49528534000011],
              [92.29682580600013, 23.446580302000072],
              [92.30147668500007, 23.431800842000072],
              [92.30674768100005, 23.423868510000105],
              [92.31977014200004, 23.412163798000037],
              [92.32535119700009, 23.403507995000083],
              [92.32690149000013, 23.39601491300003],
              [92.32535119700009, 23.382165629000085],
              [92.32669478400004, 23.375266825],
              [92.33165572100012, 23.368652243],
              [92.34488488800008, 23.359117940000104],
              [92.34860559100008, 23.354105326000038],
              [92.34953576700013, 23.344958598000076],
              [92.34674523900009, 23.325295715000024],
              [92.3470552980001, 23.315425517000037],
              [92.3522229410001, 23.29883738200003],
              [92.35687382000003, 23.289122213],
              [92.35749393700013, 23.278941956000025],
              [92.35067264900005, 23.26098439500005],
              [92.3326892500001, 23.226257833000105],
              [92.32855513500004, 23.211194153000022],
              [92.3276249590001, 23.171429138000022],
              [92.3530497650001, 23.02991322800007],
              [92.3522229410001, 22.96033091300005],
              [92.35987105300006, 22.92661204000008],
              [92.37868127500008, 22.900437928000073],
              [92.4118575440001, 22.887932231],
              [92.42632694500003, 22.871059876000103],
              [92.4350085860001, 22.793286846000072],
              [92.44203658000009, 22.762926941000032],
              [92.45371545400008, 22.74796661400005],
              [92.48069055200011, 22.726159159000034],
              [92.49154260200004, 22.711069641000037],
              [92.49588342300012, 22.695618388000028],
              [92.50291141800011, 22.618620504000106],
              [92.50084436000009, 22.560536194000022],
              [92.50456506400008, 22.54379303000009],
              [92.51738081900004, 22.512580465],
              [92.51893111200008, 22.49537221300004],
              [92.57701542200004, 22.168673808000065],
              [92.57556848200005, 22.143300680000053],
              [92.56419966700008, 22.1383397420001],
              [92.54931685400004, 22.138494772000072],
              [92.5373279210001, 22.128624573000067],
              [92.55996219900004, 22.061341859],
              [92.57308801300007, 21.995402731000084],
              [92.57515507000005, 21.98656606100009],
              [92.57587854000013, 21.977574362000027],
            ],
          ],
          [
            [
              [91.93555748800003, 21.75999583500004],
              [91.93873131600003, 21.71482982000009],
              [91.97486412900008, 21.64874909100007],
              [91.98389733200008, 21.609198309000078],
              [91.98170006600003, 21.58808014500005],
              [91.97242272200003, 21.546087958000044],
              [91.97022545700008, 21.523586330000057],
              [91.96111087300005, 21.50617096600007],
              [91.93921959700003, 21.50535716400009],
              [91.91407311300003, 21.509466864000046],
              [91.89454186300003, 21.506781317000048],
              [91.89454186300003, 21.50141022300005],
              [91.89918053500003, 21.493841864000046],
              [91.89966881600003, 21.486029364000046],
              [91.88770592500003, 21.480129299000055],
              [91.87712649800005, 21.481024481000077],
              [91.86841881600003, 21.486761786000045],
              [91.86255944100003, 21.494940497000073],
              [91.85824629000007, 21.512640692000048],
              [91.85523522200003, 21.519476630000042],
              [91.85547936300003, 21.526678778000075],
              [91.87110436300003, 21.547674872000073],
              [91.87370853000004, 21.55801015800006],
              [91.87403405000003, 21.581854559000078],
              [91.86890709700003, 21.622219143000052],
              [91.84791100400008, 21.688788153000075],
              [91.85352623800003, 21.725816148000035],
              [91.86296634200005, 21.74559153900009],
              [91.87232506600003, 21.754828192000048],
              [91.88331139400003, 21.75389232000009],
              [91.89795983200008, 21.743312893000052],
              [91.90284264400003, 21.730292059000078],
              [91.89820397200003, 21.71482982000009],
              [91.89087975400008, 21.698960679000038],
              [91.88770592500003, 21.68496328300006],
              [91.90333092500003, 21.702866929000038],
              [91.90951582100007, 21.72679271000004],
              [91.90837649800005, 21.75218333500004],
              [91.90121504000007, 21.774318752000056],
              [91.91911868600005, 21.77684153900009],
              [91.93555748800003, 21.78115469000005],
              [91.93588300900007, 21.76512278900009],
              [91.93555748800003, 21.75999583500004],
            ],
          ],
          [
            [
              [89.11573326900003, 21.78115469000005],
              [89.13900800900007, 21.766831773000035],
              [89.14470462300005, 21.73932526200008],
              [89.13249759200005, 21.721625067000048],
              [89.10230553500003, 21.736761786000045],
              [89.05152428500003, 21.79319896000004],
              [89.05144290500004, 21.79710521000004],
              [89.05779056100005, 21.803290106000077],
              [89.06421959700003, 21.822088934000078],
              [89.06381269600007, 21.841457424000055],
              [89.05372155000003, 21.874741929000038],
              [89.05111738400007, 21.890326239000046],
              [89.04468834700003, 21.90778229400007],
              [89.04566491000003, 21.91705963700008],
              [89.05738366000003, 21.917669989000046],
              [89.06153405000003, 21.914943752000056],
              [89.06495201900003, 21.910223700000074],
              [89.06763756600003, 21.904364325000074],
              [89.07154381600003, 21.890326239000046],
              [89.08130944100003, 21.82294342700004],
              [89.09278405000003, 21.793402411000045],
              [89.11573326900003, 21.78115469000005],
            ],
          ],
          [
            [
              [91.88770592500003, 21.866156317000048],
              [91.88445071700005, 21.85028717700004],
              [91.87037194100003, 21.824611721000053],
              [91.86280358200008, 21.789984442000048],
              [91.84107506600003, 21.73541901200008],
              [91.83253014400003, 21.725816148000035],
              [91.82398522200003, 21.742621161000045],
              [91.83985436300003, 21.825506903000075],
              [91.83253014400003, 21.876695054000038],
              [91.83619225400008, 21.89411041900007],
              [91.84343509200005, 21.90696849200009],
              [91.86719811300003, 21.93195221600007],
              [91.87110436300003, 21.928859768000052],
              [91.87273196700005, 21.925604559000078],
              [91.87403405000003, 21.917669989000046],
              [91.88607832100007, 21.88027578300006],
              [91.88770592500003, 21.866156317000048],
            ],
          ],
          [
            [
              [90.59351647200003, 21.98655833500004],
              [90.59351647200003, 21.966131903000075],
              [90.59734134200005, 21.961330471000053],
              [90.60084069100003, 21.95457591400009],
              [90.60661868600005, 21.938788153000075],
              [90.59083092500003, 21.93512604400007],
              [90.58082116000003, 21.912502346000053],
              [90.57252037900008, 21.917669989000046],
              [90.56560306100005, 21.917669989000046],
              [90.55713951900003, 21.89752838700008],
              [90.54078209700003, 21.875921942000048],
              [90.52125084700003, 21.861476955000057],
              [90.50359134200005, 21.862453518000052],
              [90.50359134200005, 21.86985911700009],
              [90.51075280000003, 21.87140534100007],
              [90.52344811300003, 21.87567780200004],
              [90.53150475400008, 21.876695054000038],
              [90.52295983200008, 21.88808828300006],
              [90.51791425900007, 21.89325592700004],
              [90.51042728000004, 21.89785390800006],
              [90.51693769600007, 21.90448639500005],
              [90.51685631600003, 21.912176825000074],
              [90.51539147200003, 21.92129140800006],
              [90.51783287900008, 21.93195221600007],
              [90.52198326900003, 21.938788153000075],
              [90.52637780000003, 21.94358958500004],
              [90.59351647200003, 21.98655833500004],
            ],
          ],
          [
            [
              [90.33220462300005, 21.938788153000075],
              [90.35401451900003, 21.97675202000005],
              [90.37142988400007, 21.99477773600006],
              [90.39429772200003, 22.00023021000004],
              [90.39063561300003, 21.978257554000038],
              [90.36548912900008, 21.938706773000035],
              [90.34156334700003, 21.860296942000048],
              [90.33220462300005, 21.84951406500005],
              [90.32292728000004, 21.843898830000057],
              [90.31861412900008, 21.846258856000077],
              [90.31861412900008, 21.89280833500004],
              [90.32252037900008, 21.91669342700004],
              [90.33220462300005, 21.938788153000075],
            ],
          ],
          [
            [
              [90.38746178500003, 22.048041083000044],
              [90.38111412900008, 22.023098049000055],
              [90.35279381600003, 21.992987372000073],
              [90.34595787900008, 21.972316799000055],
              [90.33961022200003, 21.972316799000055],
              [90.34587649800005, 21.99359772300005],
              [90.35865319100003, 22.022691148000035],
              [90.37387129000007, 22.04555898600006],
              [90.38746178500003, 22.048041083000044],
            ],
          ],
          [
            [
              [90.43523196700005, 22.04120514500005],
              [90.47331790500004, 22.003648179000038],
              [90.48617597700007, 21.97679271000004],
              [90.47632897200003, 21.945013739000046],
              [90.45484459700003, 21.93305084800005],
              [90.43189537900008, 21.90778229400007],
              [90.41553795700008, 21.900539455000057],
              [90.40235436300003, 21.90688711100006],
              [90.39454186300003, 21.92145416900007],
              [90.39429772200003, 21.938788153000075],
              [90.39975019600007, 21.952948309000078],
              [90.40642337300005, 21.963364976000037],
              [90.41187584700003, 21.97601959800005],
              [90.41423587300005, 21.99713776200008],
              [90.41187584700003, 22.02871328300006],
              [90.41553795700008, 22.038316148000035],
              [90.42847741000003, 22.048041083000044],
              [90.43523196700005, 22.04120514500005],
            ],
          ],
          [
            [
              [90.54444420700008, 22.061672268000052],
              [90.53834069100003, 22.068508205000057],
              [90.49537194100003, 22.044989325000074],
              [90.48991946700005, 22.034979559000078],
              [90.48365319100003, 22.034979559000078],
              [90.48560631600003, 22.058335679000038],
              [90.49170983200008, 22.080145575000074],
              [90.50310306100005, 22.09634023600006],
              [90.52084394600007, 22.10260651200008],
              [90.53345787900008, 22.11005280200004],
              [90.56006920700008, 22.13768138200004],
              [90.57252037900008, 22.13739655200004],
              [90.58106530000003, 22.148871161000045],
              [90.59278405000003, 22.159409898000035],
              [90.60450280000003, 22.16559479400007],
              [90.61345462300005, 22.16404857000009],
              [90.59351647200003, 22.10260651200008],
              [90.59343509200005, 22.112534898000035],
              [90.59180748800003, 22.119086005000042],
              [90.58619225400008, 22.130560614000046],
              [90.57455488400007, 22.096136786000045],
              [90.56869550900007, 22.05809153900009],
              [90.55974368600005, 22.02374909100007],
              [90.53834069100003, 22.00023021000004],
              [90.51954186300003, 21.994696356000077],
              [90.50904381600003, 21.99941640800006],
              [90.50464928500003, 22.01048411700009],
              [90.50359134200005, 22.02411530200004],
              [90.50896243600005, 22.033148505000042],
              [90.54444420700008, 22.061672268000052],
            ],
          ],
          [
            [
              [90.94174238400007, 22.205023505000042],
              [90.94711347700007, 22.21161530200004],
              [90.95118248800003, 22.21246979400007],
              [90.95411217500003, 22.20807526200008],
              [90.95671634200005, 22.198879299000055],
              [90.95671634200005, 22.14484284100007],
              [90.94898522200003, 22.121649481000077],
              [90.92937259200005, 22.116888739000046],
              [90.91920006600003, 22.132147528000075],
              [90.92025800900007, 22.16006094000005],
              [90.92750084700003, 22.190252997000073],
              [90.93555748800003, 22.21246979400007],
              [90.94174238400007, 22.205023505000042],
            ],
          ],
          [
            [
              [90.97641035200007, 22.18577708500004],
              [90.97706139400003, 22.239203192000048],
              [90.98292076900003, 22.25918203300006],
              [90.99691816500007, 22.25348541900007],
              [90.99781334700003, 22.23509349200009],
              [90.99480228000004, 22.213812567000048],
              [90.98780358200008, 22.195379950000074],
              [90.97641035200007, 22.18577708500004],
            ],
          ],
          [
            [
              [90.95289147200003, 22.22675202000005],
              [90.93718509200005, 22.23273346600007],
              [90.94019616000003, 22.24681224200009],
              [90.95053144600007, 22.263617255000042],
              [90.95671634200005, 22.27765534100007],
              [90.96021569100003, 22.32298411700009],
              [90.96615644600007, 22.347398179000038],
              [90.97641035200007, 22.363348700000074],
              [90.98389733200008, 22.355902411000045],
              [90.98951256600003, 22.340765692000048],
              [90.99350019600007, 22.322333075000074],
              [90.99439537900008, 22.302069403000075],
              [90.99008222700007, 22.281398830000057],
              [90.95289147200003, 22.22675202000005],
            ],
          ],
          [
            [
              [91.14884715400007, 22.35705696800005],
              [91.15645027600004, 22.332078852000052],
              [91.17139733200008, 22.319647528000075],
              [91.18140709700003, 22.283596096000053],
              [91.18189537900008, 22.260321356000077],
              [91.18678466200004, 22.22775746500008],
              [91.17057633900004, 22.197170808000067],
              [91.16089928500003, 22.182074286000045],
              [91.15430748800003, 22.169663804000038],
              [91.14146765000004, 22.146201361000067],
              [91.12071197100005, 22.130301388000078],
              [91.10637395300006, 22.12165790000006],
              [91.09368931800003, 22.11885882200005],
              [91.08240771900006, 22.10138252300004],
              [91.06329364900006, 22.089847552000037],
              [91.03858483200008, 22.091131903000075],
              [91.02247155000003, 22.094875393000052],
              [91.01125716900003, 22.10209066500005],
              [91.00511111500003, 22.116821943000048],
              [91.03395508300008, 22.148779882000042],
              [91.05225670700008, 22.175441799000055],
              [91.05909264400003, 22.19204336100006],
              [91.06827393900005, 22.240732781000077],
              [91.06911953400004, 22.311029637000047],
              [91.07480066300008, 22.38858982700009],
              [91.09225698400007, 22.391338292000057],
              [91.12689879300007, 22.37486481800005],
              [91.14884715400007, 22.35705696800005],
            ],
          ],
          [
            [
              [90.61963951900003, 22.424750067000048],
              [90.61361738400007, 22.428615627000056],
              [90.60694420700008, 22.427435614000046],
              [90.60141035200007, 22.42918528900009],
              [90.59913170700008, 22.44212474200009],
              [90.60157311300003, 22.44830963700008],
              [90.60759524800005, 22.450344143000052],
              [90.61443118600005, 22.449042059000078],
              [90.61963951900003, 22.445257880000042],
              [90.63314863400007, 22.43162669500009],
              [90.64771569100003, 22.40721263200004],
              [90.65870201900003, 22.37954336100006],
              [90.66114342500003, 22.355902411000045],
              [90.65015709700003, 22.376166083000044],
              [90.64747155000003, 22.38377513200004],
              [90.64039147200003, 22.366034247000073],
              [90.64673912900008, 22.32607656500005],
              [90.64014733200008, 22.308742580000057],
              [90.63502037900008, 22.317613023000035],
              [90.63404381600003, 22.32835521000004],
              [90.63428795700008, 22.339544989000046],
              [90.63331139400003, 22.349676825000074],
              [90.64014733200008, 22.349676825000074],
              [90.63379967500003, 22.367621161000045],
              [90.62614993600005, 22.40696849200009],
              [90.61963951900003, 22.424750067000048],
            ],
          ],
          [
            [
              [90.64747155000003, 22.424750067000048],
              [90.65349368600005, 22.48346588700008],
              [90.65601647200003, 22.48069896000004],
              [90.66114342500003, 22.48004791900007],
              [90.66529381600003, 22.469142971000053],
              [90.66700280000003, 22.45844147300005],
              [90.66732832100007, 22.43903229400007],
              [90.65707441500007, 22.433661200000074],
              [90.65365644600007, 22.43105703300006],
              [90.64747155000003, 22.424750067000048],
            ],
          ],
          [
            [
              [91.15861860500007, 22.503423074000068],
              [91.19998796600004, 22.514694415000065],
              [91.21083048600008, 22.495521457000052],
              [91.20101719800005, 22.47219599600004],
              [91.18024445400005, 22.45923875300008],
              [91.15953324100008, 22.45067424700005],
              [91.13416328800008, 22.449480400000084],
              [91.11370966000004, 22.46141485000004],
              [91.12356215000005, 22.48914556400007],
              [91.15861860500007, 22.503423074000068],
            ],
          ],
          [
            [
              [91.46755661400005, 22.58630965100008],
              [91.55636062500008, 22.478210170000068],
              [91.56363308400006, 22.435621052000045],
              [91.55517907800004, 22.402031244000057],
              [91.50751921700004, 22.396796588000086],
              [91.47605216500006, 22.413317257000074],
              [91.44651727100006, 22.453242453000087],
              [91.42965828600006, 22.493002901000068],
              [91.42378639900005, 22.525301950000085],
              [91.44676458700008, 22.57630398300006],
              [91.46755661400005, 22.58630965100008],
            ],
          ],
          [
            [
              [90.79055251900007, 22.495333023000057],
              [90.83463688000006, 22.45829561000005],
              [90.85502409100008, 22.43466514000005],
              [90.83502200900006, 22.339615964000075],
              [90.83619225400008, 22.178168036000045],
              [90.82789147200003, 22.152411200000074],
              [90.77475019600007, 22.075913804000038],
              [90.75733483200008, 22.061672268000052],
              [90.75586998800003, 22.06598541900007],
              [90.75001061300003, 22.075995184000078],
              [90.72706139400003, 22.05369700700004],
              [90.71778405000003, 22.04840729400007],
              [90.69166100400008, 22.007025458000044],
              [90.68287194100003, 22.003973700000074],
              [90.67042076900003, 21.997707424000055],
              [90.65772545700008, 21.99286530200004],
              [90.64747155000003, 21.99404531500005],
              [90.63941491000003, 22.016099351000037],
              [90.65121504000007, 22.044623114000046],
              [90.66993248800003, 22.07493724200009],
              [90.68181399800005, 22.10260651200008],
              [90.62598717500003, 22.027167059000078],
              [90.61003665500004, 22.02411530200004],
              [90.60352623800003, 22.04401276200008],
              [90.60775800900007, 22.072333075000074],
              [90.61898847700007, 22.101304429000038],
              [90.63331139400003, 22.123114325000074],
              [90.62224368600005, 22.145086981000077],
              [90.63184655000003, 22.182114976000037],
              [90.67351321700005, 22.266424872000073],
              [90.67847741000003, 22.28278229400007],
              [90.68181399800005, 22.301906643000052],
              [90.68189537900008, 22.36041901200008],
              [90.68799889400003, 22.37763092700004],
              [90.67994225400008, 22.407171942000048],
              [90.67774498800003, 22.426703192000048],
              [90.68181399800005, 22.43903229400007],
              [90.68181399800005, 22.445257880000042],
              [90.67058353000004, 22.46385325700004],
              [90.65894616000003, 22.52440013200004],
              [90.64747155000003, 22.54828522300005],
              [90.63135826900003, 22.56159088700008],
              [90.57496178500003, 22.598863023000035],
              [90.55876712300005, 22.60293203300006],
              [90.55396569100003, 22.639797268000052],
              [90.55632571700005, 22.674709377000056],
              [90.57862389400003, 22.757025458000044],
              [90.58545983200008, 22.768052476000037],
              [90.59620201900003, 22.77537669500009],
              [90.61345462300005, 22.781683661000045],
              [90.63103274800005, 22.785630601000037],
              [90.65056399800005, 22.78742096600007],
              [90.66061944900008, 22.75780489600004],
              [90.67154649400004, 22.722410315000047],
              [90.68409525200008, 22.694372801000043],
              [90.70136948700008, 22.66189841700009],
              [90.71550702300004, 22.638283560000048],
              [90.73127161300005, 22.620527278000054],
              [90.74697855800008, 22.59690680300008],
              [90.75450738500007, 22.54843435400005],
              [90.76694021600008, 22.51753139100009],
              [90.79055251900007, 22.495333023000057],
            ],
          ],
          [
            [
              [90.64525350300005, 22.84928934900006],
              [90.66362959200006, 22.828918033000036],
              [90.67823326900003, 22.808335679000038],
              [90.66236412900008, 22.805487372000073],
              [90.62805225200003, 22.812082197000052],
              [90.59095563400007, 22.813918922000084],
              [90.56177819100003, 22.788804429000038],
              [90.54656009200005, 22.783677476000037],
              [90.53155868500005, 22.769236749000072],
              [90.52967723600005, 22.74436306800004],
              [90.53461211700005, 22.72877529100009],
              [90.52099282900008, 22.71176534400007],
              [90.51096129300004, 22.72272388300007],
              [90.49822024800005, 22.73383209800005],
              [90.49675540500004, 22.74315013200004],
              [90.49284915500004, 22.753241278000075],
              [90.48292076900003, 22.75975169500009],
              [90.45573978000004, 22.767401434000078],
              [90.46420332100007, 22.77887604400007],
              [90.46566816500007, 22.78807200700004],
              [90.46265709700003, 22.81582265800006],
              [90.46314537900008, 22.834051825000074],
              [90.46607506600003, 22.85175202000005],
              [90.47339928500003, 22.86513906500005],
              [90.48682701900003, 22.870428778000075],
              [90.52116946700005, 22.86465078300006],
              [90.53760826900003, 22.86676666900007],
              [90.54444420700008, 22.880682684000078],
              [90.55274498800003, 22.881740627000056],
              [90.59229576900003, 22.88190338700008],
              [90.60661868600005, 22.87726471600007],
              [90.62676027600003, 22.857215927000084],
              [90.64525350300005, 22.84928934900006],
            ],
          ],
          [
            [
              [90.66732832100007, 22.95302969000005],
              [90.64161217500003, 22.952297268000052],
              [90.63331139400003, 22.95302969000005],
              [90.64470462300005, 22.94599030200004],
              [90.65463300900007, 22.937323309000078],
              [90.66236412900008, 22.927801825000074],
              [90.66732832100007, 22.91819896000004],
              [90.63624108200008, 22.92133209800005],
              [90.62712649800005, 22.925034898000035],
              [90.61963951900003, 22.932521877000056],
              [90.60767662900008, 22.95258209800005],
              [90.59913170700008, 22.95917389500005],
              [90.58871504000007, 22.962062893000052],
              [90.58472741000003, 22.96039459800005],
              [90.58122806100005, 22.95652903900009],
              [90.57252037900008, 22.95302969000005],
              [90.56169681100005, 22.951564846000053],
              [90.53451582100007, 22.951239325000074],
              [90.52409915500004, 22.95302969000005],
              [90.50806725400008, 22.975775458000044],
              [90.52800540500004, 23.007635809000078],
              [90.56128991000003, 23.03261953300006],
              [90.58619225400008, 23.034898179000038],
              [90.60726972700007, 23.018133856000077],
              [90.64535566500007, 22.97483958500004],
              [90.66732832100007, 22.95917389500005],
              [90.66732832100007, 22.95302969000005],
            ],
          ],
          [
            [
              [90.51042728000004, 23.06903717700004],
              [90.51710045700008, 23.05931224200009],
              [90.51563561300003, 23.051947333000044],
              [90.50017337300005, 23.038031317000048],
              [90.47779381600003, 23.01239655200004],
              [90.46949303500003, 23.007635809000078],
              [90.46094811300003, 23.048488674000055],
              [90.45573978000004, 23.06281159100007],
              [90.49439537900008, 23.062933661000045],
              [90.50245201900003, 23.064886786000045],
              [90.51042728000004, 23.06903717700004],
            ],
          ],
          [
            [
              [90.52409915500004, 23.32225169500009],
              [90.50611412900008, 23.314195054000038],
              [90.48707116000003, 23.31903717700004],
              [90.46876061300003, 23.33161041900007],
              [90.43726647200003, 23.361802476000037],
              [90.42660566500007, 23.37596263200004],
              [90.42969811300003, 23.385158596000053],
              [90.45573978000004, 23.38495514500005],
              [90.49187259200005, 23.37303294500009],
              [90.53939863400007, 23.350002346000053],
              [90.57764733200008, 23.32363515800006],
              [90.58619225400008, 23.30174388200004],
              [90.54957116000003, 23.326239325000074],
              [90.52955162900008, 23.33356354400007],
              [90.52409915500004, 23.32225169500009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Afghanistan',
        iso3: 'AFG',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [74.54235396300004, 37.021669006000124],
            [74.54741825400009, 37.01567454000009],
            [74.54927860600003, 37.00893076600006],
            [74.54814172400012, 37.00164439000007],
            [74.54421431500003, 36.99402211500011],
            [74.53739302600007, 36.96224110900006],
            [74.52137333100012, 36.95849456800006],
            [74.50173628700009, 36.97242136700005],
            [74.48364953600009, 36.99397043900008],
            [74.4803422440001, 36.996915995000094],
            [74.47662154100004, 36.999318950000045],
            [74.45698449700012, 37.004383240000024],
            [74.43559045400013, 37.0032205210001],
            [74.39404260300012, 36.99402211500011],
            [74.36810103300007, 36.97676218700012],
            [74.28459191900009, 36.93423248300006],
            [74.23570601500012, 36.902167257000045],
            [74.21172815000011, 36.89513926200003],
            [74.14599572800012, 36.9017021690001],
            [74.12966597500008, 36.89842071600013],
            [74.11529992700008, 36.889532369],
            [74.10878869600003, 36.875631409000036],
            [74.10393111200011, 36.841318258000015],
            [74.0943192950001, 36.831241354000085],
            [74.03530480900014, 36.81558339400003],
            [74.00636600700011, 36.81573842400006],
            [73.97670373600005, 36.82483347600005],
            [73.94693811000013, 36.83087961800008],
            [73.86508264200012, 36.8725824990001],
            [73.83407678300006, 36.88286610900009],
            [73.77289188700007, 36.8920128380001],
            [73.71184199100009, 36.89413889400005],
            [73.71133490400007, 36.89415655300009],
            [73.71112830200013, 36.894163748000054],
            [73.70948256500003, 36.89422106100001],
            [73.64008345600007, 36.89663787800005],
            [73.50934208200005, 36.878680318000065],
            [73.47688928200012, 36.88286610900009],
            [73.44588342300011, 36.88648346000009],
            [73.37973759000005, 36.87924875900002],
            [73.33178186100008, 36.882090963000095],
            [73.28186242700014, 36.867983297000066],
            [73.26749637900014, 36.86653635700007],
            [73.25271691900014, 36.868034973000064],
            [73.2234680580001, 36.874339498],
            [73.19184208200005, 36.87702667300003],
            [73.0424971920001, 36.86426259400004],
            [73.0262707930001, 36.85945668500004],
            [73.00229292800009, 36.846124166000024],
            [72.99051070200005, 36.84157664100009],
            [72.97676477100003, 36.842093404000124],
            [72.94586226400014, 36.85222198500007],
            [72.92105757600012, 36.847364400000046],
            [72.89687300600013, 36.83697743700013],
            [72.86772749800014, 36.830414531000045],
            [72.77936079900007, 36.82679718000007],
            [72.69585168500004, 36.836719055000074],
            [72.6296024990001, 36.83294667600005],
            [72.56521366400011, 36.820596008000095],
            [72.51674117000005, 36.80059722900005],
            [72.45410933400012, 36.757964173000076],
            [72.43312870300014, 36.75341664600005],
            [72.38734338400008, 36.75579376200007],
            [72.34620894400013, 36.7448900350001],
            [72.3019739180001, 36.74271962500002],
            [72.2136072190001, 36.726441549000086],
            [72.16968225100004, 36.711352031],
            [72.15345585200004, 36.702101949000095],
            [72.14963179600011, 36.6893378700001],
            [72.16461796100009, 36.67006256200007],
            [72.17164595600008, 36.653629456000104],
            [72.15417932100013, 36.64546457900009],
            [72.09609501100005, 36.6389016720001],
            [72.07087691200007, 36.63228708900003],
            [72.0590946860001, 36.627119446],
            [72.05041304500014, 36.61864451200002],
            [72.05217004400004, 36.610376282000075],
            [72.05630415900004, 36.601901347000066],
            [72.0549605710001, 36.592857972],
            [72.03883752500008, 36.580455627000035],
            [71.99780643800005, 36.57244578000005],
            [71.97703251100012, 36.56304067000009],
            [71.96090946500004, 36.54960479700004],
            [71.91347050000013, 36.527590637000074],
            [71.89972456900011, 36.51834055600007],
            [71.88763228300013, 36.508005269000066],
            [71.87471317600011, 36.49906524600003],
            [71.85859012900005, 36.49415598600008],
            [71.79378788200012, 36.49074534100005],
            [71.77322066200014, 36.48004832000005],
            [71.77456425000008, 36.448422343000075],
            [71.7915141200001, 36.421292216],
            [71.794408, 36.40759796200008],
            [71.78262577300006, 36.39653920500005],
            [71.76691613800011, 36.39183665000009],
            [71.75099979700008, 36.3911131790001],
            [71.73632369000012, 36.3959190880001],
            [71.7068681230001, 36.42144724500004],
            [71.64930057800007, 36.45276316300006],
            [71.6291467690001, 36.459532776000074],
            [71.61043990000007, 36.45793080600005],
            [71.60072473100007, 36.4493008430001],
            [71.58873579900012, 36.418450013000026],
            [71.58036421700012, 36.40232696500003],
            [71.57230269400003, 36.39168162000006],
            [71.5471879480001, 36.371631165000096],
            [71.54222701000009, 36.35638661800006],
            [71.55266565000011, 36.340987041000076],
            [71.55835005700004, 36.3278612270001],
            [71.53891971800005, 36.319282939000075],
            [71.51463179500007, 36.315200501000064],
            [71.49582157400005, 36.30961944600004],
            [71.47907841000011, 36.30052439400008],
            [71.40275232000005, 36.23138132700008],
            [71.38244348100005, 36.21856557300002],
            [71.31913985200003, 36.200582174000104],
            [71.31397220900004, 36.19401926700003],
            [71.30901127100009, 36.17272857700006],
            [71.30208662900003, 36.1633234670001],
            [71.29268151800005, 36.15789744100003],
            [71.26229577600003, 36.14611521500002],
            [71.22307336400007, 36.1253929650001],
            [71.2176990160001, 36.118054912],
            [71.21263472600003, 36.09681589800003],
            [71.20762211100003, 36.087617493000025],
            [71.17537601700008, 36.06115915900004],
            [71.16591923000004, 36.04570790600003],
            [71.16991342200004, 36.03080174600002],
            [71.17093184400011, 36.02700103700006],
            [71.18188724800007, 36.018836162000056],
            [71.21785404400003, 36.00271311400006],
            [71.23191003400007, 35.9939797980001],
            [71.25743819200011, 35.9715522260001],
            [71.28430993600011, 35.96245717400002],
            [71.31252526900005, 35.957392883000054],
            [71.34156742400006, 35.9472643030001],
            [71.35639856000006, 35.933053284000025],
            [71.36068770400004, 35.900290426000126],
            [71.37133304900004, 35.88514923100011],
            [71.41670495600005, 35.858845927000075],
            [71.43101932800005, 35.84370473300005],
            [71.46440230300004, 35.79471547400006],
            [71.47091353400009, 35.77993601500013],
            [71.47205041500007, 35.76996246300003],
            [71.47101688700013, 35.76133250000008],
            [71.47112024000006, 35.752289124000114],
            [71.47556441300003, 35.74102366100006],
            [71.48135217300012, 35.73409902000007],
            [71.49613163300006, 35.72459055600008],
            [71.50274621600005, 35.719061178000075],
            [71.51535526600009, 35.70149119100002],
            [71.51979943800006, 35.68376617500009],
            [71.51401167800009, 35.66557607100005],
            [71.4959249260001, 35.64661082000002],
            [71.48331587700005, 35.62656036400007],
            [71.49272098800003, 35.60955881800005],
            [71.51277144300008, 35.596277975000035],
            [71.56785852100012, 35.57421213800005],
            [71.58418827400004, 35.56418691100002],
            [71.5934900310001, 35.54935577400009],
            [71.59286991400012, 35.530183817000065],
            [71.58604862500005, 35.51209706600007],
            [71.58170780500006, 35.49313181600009],
            [71.58780562400005, 35.47091095000006],
            [71.59342197900014, 35.46419378800003],
            [71.60072473100007, 35.45545969600006],
            [71.61395389800003, 35.443212382000056],
            [71.62242883300007, 35.42962148100004],
            [71.62087854000004, 35.41013946500006],
            [71.61106001800005, 35.39546335900006],
            [71.56227746600013, 35.360581767],
            [71.53158166500009, 35.327922262000115],
            [71.52982466700007, 35.30089548800008],
            [71.5478080640001, 35.27562571200009],
            [71.60320520000005, 35.22338084000002],
            [71.63369429600004, 35.20312367800001],
            [71.6379317630001, 35.189687806000066],
            [71.62925012200003, 35.17010243800003],
            [71.6041353760001, 35.13816640200007],
            [71.53499231000012, 35.098582256],
            [71.50894738800014, 35.07202056900009],
            [71.50750044800003, 35.028198954000075],
            [71.51297815000004, 35.01812205000003],
            [71.51132450400007, 35.00871693900008],
            [71.50429650900014, 35.000603739000084],
            [71.49344445800011, 34.994144185000025],
            [71.49334110500007, 34.994144185000025],
            [71.49334110500007, 34.994040833],
            [71.48538293500013, 34.98349884100013],
            [71.47670129500005, 34.96029612300002],
            [71.46956994700014, 34.94970245400005],
            [71.45995813000013, 34.94267445900003],
            [71.44523879700012, 34.937756748000126],
            [71.32492761200012, 34.89756093400008],
            [71.2894775800001, 34.87503000900007],
            [71.27082238800011, 34.84428253200009],
            [71.2556295170001, 34.81022776300004],
            [71.20307458500014, 34.748164368000076],
            [71.18953536000004, 34.73705393500008],
            [71.15093306500006, 34.72031077100003],
            [71.08060144100006, 34.67292348300005],
            [71.0701628010001, 34.661244609000065],
            [71.06876753700004, 34.64594838500001],
            [71.07626062000014, 34.623624166000056],
            [71.07987797100003, 34.60290191600002],
            [71.07657067900004, 34.578510641],
            [71.06582198100011, 34.558460185000044],
            [71.04752852400014, 34.55112213200006],
            [71.00696252500012, 34.55634145100008],
            [70.9858268640001, 34.55618642200004],
            [70.98335594700012, 34.55525610700006],
            [70.96867028900004, 34.549726868000064],
            [70.95699141500006, 34.53200185200005],
            [70.95564782700006, 34.51001353],
            [70.96122888200011, 34.48761179600008],
            [70.97084069800013, 34.4688790900001],
            [70.99151127200014, 34.4430667110001],
            [71.01982995600014, 34.41443796900002],
            [71.05093916900006, 34.3897883100001],
            [71.12204593900009, 34.35681874600006],
            [71.12638675900007, 34.33222076400007],
            [71.09708622300013, 34.26245758100002],
            [71.09687951700005, 34.244344991],
            [71.10654301000011, 34.20938588500009],
            [71.1094885660001, 34.18920623800001],
            [71.1080933020001, 34.165228373],
            [71.10178877800007, 34.15181833900006],
            [71.07388350400004, 34.12525665300005],
            [71.0627730710001, 34.10530955000003],
            [71.06385827700007, 34.08892812100008],
            [71.0672689210001, 34.073011780000044],
            [71.06261804200005, 34.05425323500005],
            [71.04670170100013, 34.041876729000094],
            [70.99771244300013, 34.03332428000006],
            [70.97714522300004, 34.02740732800005],
            [70.96572473200013, 34.013816427000066],
            [70.95399418200003, 34.00482472700013],
            [70.93973148600008, 34.00092315700006],
            [70.92123132300014, 34.00224090600001],
            [70.89430790300014, 34.00937225400007],
            [70.88433435100012, 34.00704681500012],
            [70.87999353000004, 33.994256898000046],
            [70.86221683700012, 33.964775492000044],
            [70.79131677300006, 33.95356170700008],
            [70.65618290200013, 33.9547502650001],
            [70.52197920700007, 33.93870473200006],
            [70.49149011200006, 33.93960907000009],
            [70.40896285000014, 33.95441436800003],
            [70.3281925870001, 33.957282410000104],
            [70.30989912900003, 33.9616749070001],
            [70.27558597800004, 33.97617014600003],
            [70.21884525600007, 33.98069183400007],
            [70.00283776900011, 34.043788758000105],
            [69.96909305800006, 34.04572662300005],
            [69.91602136300008, 34.03887949700008],
            [69.88925297100013, 34.031205546000095],
            [69.87261316000013, 34.017227071],
            [69.87044274900012, 34.00133656800007],
            [69.87385339400004, 33.98632456500009],
            [69.87199304200004, 33.97151926700006],
            [69.85421634900013, 33.95635223400005],
            [69.84109053600014, 33.941805319000096],
            [69.84718835500013, 33.92694834400005],
            [69.87648889100006, 33.902557068000036],
            [69.8854289140001, 33.889457093000075],
            [69.89876143400005, 33.85150075300005],
            [69.9075464280001, 33.835610250000045],
            [69.93131758600009, 33.80643890400002],
            [69.94010258000009, 33.79147857700006],
            [69.94723392800012, 33.77197072400004],
            [69.9575175380001, 33.75269541500002],
            [69.97265873300012, 33.74484059700008],
            [69.99647814300005, 33.74209099500003],
            [70.01182946800003, 33.74031890900007],
            [70.06557295800013, 33.7210177620001],
            [70.10815433800013, 33.72729644800002],
            [70.11812788900005, 33.71652191200009],
            [70.12655114700004, 33.67696360300003],
            [70.13254561300005, 33.66143483500012],
            [70.13688643400013, 33.65629303000013],
            [70.1459814860001, 33.64988515200007],
            [70.16251794400011, 33.64324473100008],
            [70.17021773300007, 33.638671366000025],
            [70.17409346600004, 33.632108459000065],
            [70.17347334800007, 33.60787221300008],
            [70.15300948100008, 33.5447494510001],
            [70.15135583500006, 33.52586171500009],
            [70.15497318500013, 33.50661224400007],
            [70.16375817900013, 33.488654683000064],
            [70.17760746300007, 33.47341013600003],
            [70.18546228000014, 33.46896596300003],
            [70.21336755400011, 33.46134368900006],
            [70.22044722500004, 33.45602101700011],
            [70.22783695500004, 33.439949646000045],
            [70.23300459800004, 33.43261159300006],
            [70.28571455900004, 33.38287302700003],
            [70.30157922400008, 33.3517896530001],
            [70.29444787600005, 33.31894928000007],
            [70.12479414900014, 33.199034119000075],
            [70.10536381100007, 33.18980987600007],
            [70.08365970900007, 33.19128265400006],
            [70.05978519700005, 33.19805226700002],
            [70.04800297000008, 33.194073181000036],
            [70.0145166420001, 33.140768942000065],
            [70.00686853000008, 33.13180308000001],
            [69.9947245680001, 33.1273330690001],
            [69.96573409000013, 33.12940012600005],
            [69.95581221600014, 33.127694805000104],
            [69.88093306500008, 33.089247539000056],
            [69.83871342000003, 33.086663717000064],
            [69.77184411600012, 33.114775696],
            [69.73298343900007, 33.1092979940001],
            [69.68600956200004, 33.080772604000046],
            [69.66776778200006, 33.07700022400003],
            [69.65877608200003, 33.07842132600011],
            [69.65019779400006, 33.081857809000056],
            [69.64068933100003, 33.084234925000075],
            [69.60833988500013, 33.079067282],
            [69.58777266400011, 33.079532370000024],
            [69.5475167240001, 33.07501068200007],
            [69.51418542500005, 33.05669138600011],
            [69.48772709200006, 33.028372701000094],
            [69.47812524800008, 33.011350078000035],
            [69.46850345900003, 32.99429209500006],
            [69.48721032700013, 32.88587493900009],
            [69.4772884520001, 32.856832785],
            [69.47144901600012, 32.85223358200007],
            [69.44555912300007, 32.83567128500006],
            [69.42106449400012, 32.80680999800002],
            [69.38716475400014, 32.785338440000075],
            [69.37631270300005, 32.77187672900003],
            [69.37806970300005, 32.7523172],
            [69.38323734600004, 32.744462383000084],
            [69.39042036900008, 32.737899476000095],
            [69.39915368700008, 32.732964376000055],
            [69.40773197400011, 32.729941305000025],
            [69.41465661600012, 32.725574646000055],
            [69.41724043800008, 32.71800404900007],
            [69.41910079000007, 32.70045990000001],
            [69.42912601700004, 32.66736114600012],
            [69.42602543100008, 32.65508799200008],
            [69.41393314600009, 32.63547678700006],
            [69.36122318600007, 32.56847829300007],
            [69.34354984600009, 32.55605011000007],
            [69.30210534700012, 32.54377695700005],
            [69.28195153800004, 32.53279571500006],
            [69.25156579600008, 32.500549621000104],
            [69.23285892700011, 32.462670797],
            [69.22800134300007, 32.42130381300008],
            [69.23854333500003, 32.37828318300008],
            [69.26443322800009, 32.32236928400009],
            [69.2681022540001, 32.30133697600006],
            [69.26696537200007, 32.27958119700007],
            [69.25998905400007, 32.23681894900004],
            [69.25952396600013, 32.19452179000005],
            [69.25187585500004, 32.152250469000066],
            [69.25104903100004, 32.13064972000008],
            [69.27063440000006, 32.035978495000066],
            [69.30215702300012, 31.959910787000112],
            [69.30479252100014, 31.94694000300008],
            [69.30115729900007, 31.94128170100008],
            [69.29884973100013, 31.937689922000075],
            [69.2509456790001, 31.907045797000038],
            [69.22376387600013, 31.881931051000024],
            [69.11431319200011, 31.737753804000036],
            [69.1000504970001, 31.724007874],
            [69.08475427200005, 31.715791321000083],
            [69.07162845800008, 31.697859599000097],
            [69.04010583500013, 31.673106588000067],
            [69.00403568500013, 31.651092428000098],
            [68.97726729300007, 31.64148061100009],
            [68.94099043800009, 31.64365102200007],
            [68.90698734600005, 31.634297588000024],
            [68.84352868600013, 31.60649566600007],
            [68.80384118600011, 31.60256825800012],
            [68.77727950000013, 31.618587952000055],
            [68.7311841230001, 31.67553538100013],
            [68.70544926000008, 31.701270244000042],
            [68.69790450100004, 31.715946350000124],
            [68.69490726700013, 31.756357321000095],
            [68.68829268400003, 31.768604634000027],
            [68.67578698700004, 31.774702453000074],
            [68.61945967600013, 31.78348744800006],
            [68.56106530800008, 31.811806132000058],
            [68.52747562700006, 31.8229682420001],
            [68.50509973100009, 31.82265818300003],
            [68.48148360200014, 31.81568186500003],
            [68.43817875200006, 31.79604482100008],
            [68.41874841300012, 31.783022360000032],
            [68.42221073400003, 31.773152161000056],
            [68.43957401600005, 31.766589254000067],
            [68.4614331460001, 31.763592021000065],
            [68.52127445500014, 31.76478057900009],
            [68.54060144100009, 31.762506816000055],
            [68.5497998460001, 31.75351511700002],
            [68.5368290610001, 31.741009420000026],
            [68.51517663600009, 31.729950663000025],
            [68.49802006100003, 31.72524810800006],
            [68.4609680590001, 31.73046742800007],
            [68.35606490100008, 31.762506816000055],
            [68.31653243000011, 31.765193991],
            [68.27694828300008, 31.763592021000065],
            [68.25503747500011, 31.766382548000124],
            [68.24263513200003, 31.77692454100007],
            [68.23229984500006, 31.790153707000073],
            [68.2068233650001, 31.807878723],
            [68.18475752800003, 31.81821401000009],
            [68.15912601800005, 31.825913798],
            [68.13855879800008, 31.824673564000065],
            [68.12574304200007, 31.81149607400009],
            [68.10450402900011, 31.768759664000058],
            [68.09834042600005, 31.7591236090001],
            [68.09349694800011, 31.751551412000097],
            [68.06047570800007, 31.72555816700013],
            [68.0555664470001, 31.716566468000096],
            [68.05225915500012, 31.69543080700005],
            [68.04657474800007, 31.688402812000035],
            [67.99407149300004, 31.663443095000062],
            [67.97732832900004, 31.651867574],
            [67.96606286700012, 31.63822499600009],
            [67.95521081600003, 31.633212382000053],
            [67.91469649300006, 31.63135203100005],
            [67.8843107510001, 31.635641175],
            [67.87066817200008, 31.635176087000062],
            [67.8427112230001, 31.623497213000107],
            [67.78116459100005, 31.564172669000087],
            [67.74828016400005, 31.54439209300007],
            [67.72669763200008, 31.531409811000074],
            [67.69631189000012, 31.5208161420001],
            [67.66546106000004, 31.518128967000067],
            [67.60050378400007, 31.53047963500002],
            [67.56898116000008, 31.529859517000048],
            [67.55611372900012, 31.51218617800005],
            [67.56340010600007, 31.497251689000095],
            [67.57807621300009, 31.482110494000082],
            [67.59109867400014, 31.46479888900008],
            [67.59698978700004, 31.42567983000005],
            [67.61145918800014, 31.410797018000025],
            [67.63140629100008, 31.400099996],
            [67.65114668800004, 31.395294088000085],
            [67.73429406800011, 31.40475087500006],
            [67.77036421700012, 31.39467397100013],
            [67.77506677200012, 31.352764384000054],
            [67.76473148600007, 31.334057516000044],
            [67.74943526200013, 31.328011373000024],
            [67.70902429200004, 31.329303284000062],
            [67.69279789200004, 31.32522084600005],
            [67.6789486080001, 31.316590882000114],
            [67.66592614800004, 31.306255595],
            [67.60215743000003, 31.27111562100005],
            [67.58365726700009, 31.26522450800006],
            [67.53022383600006, 31.256646220000036],
            [67.49332686400004, 31.242951965000103],
            [67.43389896600013, 31.236079],
            [67.36460087100005, 31.210705872000048],
            [67.3462040610001, 31.207760315000044],
            [67.28217696100006, 31.212772929],
            [67.23029382300007, 31.21060251900012],
            [67.2137573650001, 31.212256165000056],
            [67.19319014500007, 31.21850901300006],
            [67.15670658300007, 31.235923971000076],
            [67.13675948100007, 31.241091614000098],
            [67.11686405500006, 31.240316468000074],
            [67.07846846500013, 31.232048238000047],
            [67.05821130400005, 31.23235829700012],
            [67.03526696800009, 31.235923971000076],
            [67.02286462400014, 31.23938629200005],
            [67.01526818900004, 31.244657288000056],
            [67.0138729250001, 31.25266713500004],
            [67.01790368600007, 31.25871327700007],
            [67.02343306500006, 31.264862773000047],
            [67.0259652100001, 31.27302764900007],
            [67.02389815300012, 31.295300191000123],
            [67.01681848200008, 31.309149475000098],
            [67.00209069800007, 31.315867411000013],
            [66.94328291800008, 31.31473053000009],
            [66.90592085800006, 31.305532125000113],
            [66.83848311300005, 31.277006734000068],
            [66.80861413600013, 31.2547341920001],
            [66.7853080650001, 31.231789856000077],
            [66.75952152500008, 31.21478831000006],
            [66.72128096500006, 31.21029246000002],
            [66.69699304200009, 31.19582305900009],
            [66.6630933030001, 31.083116760000067],
            [66.64397302200007, 31.060172424000044],
            [66.55002526800007, 30.97697336800003],
            [66.52749434500004, 30.968343405],
            [66.39230879700011, 30.944623922000048],
            [66.3753589270001, 30.93671742800008],
            [66.36626387600012, 30.92286814400005],
            [66.26797530100004, 30.601389059000084],
            [66.26492639100007, 30.55782582600004],
            [66.28192793800008, 30.518138326000056],
            [66.30611250800007, 30.49111155200002],
            [66.31376062000004, 30.47829579700003],
            [66.31939335100009, 30.45783193000007],
            [66.32182214400007, 30.437368063000022],
            [66.30301192200005, 30.30528310100003],
            [66.30528568500006, 30.24477],
            [66.30089318800009, 30.22559804300009],
            [66.23634932500005, 30.111599834000103],
            [66.22172489400003, 30.07372100900001],
            [66.2192961020001, 30.057856344000086],
            [66.22523889100012, 30.044420471000066],
            [66.26043054200005, 30.023129781000065],
            [66.30156498200006, 29.98674957300007],
            [66.33236413600008, 29.966079],
            [66.34052901300004, 29.956570536000086],
            [66.3368083090001, 29.952023010000048],
            [66.32843672700005, 29.94954254100007],
            [66.3224422610001, 29.946545309000058],
            [66.30177168800009, 29.915694479000067],
            [66.27521000100006, 29.88515370700007],
            [66.19562829600005, 29.835337627000044],
            [66.1104655360001, 29.813633525000043],
            [66.05238122600014, 29.798854065000043],
            [65.99429691500006, 29.78402293],
            [65.93610925300004, 29.769295146],
            [65.87823164900004, 29.754489848000063],
            [65.82014733900013, 29.739736226000062],
            [65.76206302900005, 29.724905091000053],
            [65.70403039500007, 29.710151469000024],
            [65.64584273300005, 29.695346171000025],
            [65.58781009900008, 29.6805667120001],
            [65.52972578900005, 29.665735576000074],
            [65.47174483200007, 29.650956116000046],
            [65.41366052300009, 29.63617665600013],
            [65.35578291900009, 29.62142303500012],
            [65.29759525600008, 29.60664357600011],
            [65.23951094500006, 29.591838278000083],
            [65.18142663600008, 29.57711049400008],
            [65.03637089000006, 29.540161845000043],
            [64.98660648600014, 29.54155710900004],
            [64.8203117270001, 29.567886251000076],
            [64.68388594600003, 29.568816427000044],
            [64.49947701700006, 29.57020296000009],
            [64.47769698100007, 29.570366720000052],
            [64.20773929900014, 29.49998341900003],
            [64.17259932500008, 29.48429962200005],
            [64.1497583420001, 29.45846140600004],
            [64.11337813400007, 29.39629465800006],
            [64.08609297700008, 29.386605326000037],
            [63.97199141400006, 29.429574280000097],
            [63.78791996300009, 29.460580140000033],
            [63.56860518400009, 29.497477112000055],
            [63.415953003000084, 29.48497141500006],
            [63.36680871600004, 29.480940654000065],
            [63.31776778200003, 29.47690989200005],
            [63.2686751710001, 29.472879130000067],
            [63.21968591300009, 29.468796692000055],
            [63.170696656000075, 29.46476593100006],
            [63.12160404500014, 29.460786845000072],
            [63.072614787000134, 29.456756084000077],
            [63.02362552900013, 29.452673645000075],
            [62.97453291800008, 29.448642883000062],
            [62.92554366000007, 29.444637960000094],
            [62.87645105000013, 29.44058136000008],
            [62.82746179200012, 29.436602275],
            [62.77842085800006, 29.4325198370001],
            [62.72937992400006, 29.428489075000087],
            [62.68039066600005, 29.424458313000102],
            [62.63134973200005, 29.420427551],
            [62.602581132000125, 29.418069628000055],
            [62.47750899300013, 29.40781850200007],
            [62.37446618600012, 29.424871725000017],
            [62.27943322800007, 29.45148508700005],
            [62.196285848000116, 29.474920349000016],
            [62.11298344000005, 29.49822642100004],
            [62.02962935400012, 29.521635844000016],
            [61.94653365100004, 29.545045268000067],
            [61.86323124200004, 29.568351339000102],
            [61.7799288330001, 29.591786601000067],
            [61.696626424000044, 29.61519602500003],
            [61.61342736800003, 29.638502096000067],
            [61.53022831200013, 29.661859843000016],
            [61.446925904000125, 29.685320944000082],
            [61.36372684800011, 29.708627015000033],
            [61.28042443900006, 29.732010600000066],
            [61.197225383000045, 29.755342509000016],
            [61.11402632700003, 29.77872609400005],
            [61.03062056400012, 29.80216135700003],
            [60.947421508000104, 29.825519104000065],
            [60.87600467900006, 29.845517884000017],
            [60.844378703000075, 29.858178610000053],
            [60.90215295400009, 29.9168830360001],
            [60.97811731000013, 29.994139303000097],
            [60.9784273680001, 29.994397685000067],
            [61.13304325300004, 30.1542845660001],
            [61.21562219300006, 30.23970570900012],
            [61.272156210000105, 30.29830678300003],
            [61.38036665800013, 30.410289612000057],
            [61.461705363000135, 30.494522196000062],
            [61.57622033700005, 30.61389475500009],
            [61.702620891000095, 30.745514628000038],
            [61.785199829000135, 30.831400859000084],
            [61.80225305200014, 30.847058818000036],
            [61.79977258300005, 30.852381491000088],
            [61.7984289960001, 30.85346669500008],
            [61.79987593600009, 30.87150177000008],
            [61.80235640400008, 30.878529765000096],
            [61.80835087000008, 30.881423646000073],
            [61.80452681500009, 30.949739888000025],
            [61.800185995000106, 30.961418762],
            [61.81930627500009, 30.99392323800005],
            [61.82643762200013, 31.014955546000053],
            [61.826334269000085, 31.034592591],
            [61.82147668400006, 31.054488017],
            [61.80928104600008, 31.08714752200008],
            [61.79181441300011, 31.118928528000097],
            [61.789333944000134, 31.129315491000042],
            [61.78768029800011, 31.158616029000072],
            [61.779205363000074, 31.18109527600008],
            [61.75243697100012, 31.21912913000004],
            [61.74272180200006, 31.23954132100006],
            [61.74230839100005, 31.259436748000084],
            [61.74923303200006, 31.30237986300004],
            [61.74230839100005, 31.32088002500008],
            [61.70654829900013, 31.359844055000067],
            [61.6869112550001, 31.373176575000073],
            [61.66117639100014, 31.381909892000053],
            [61.60625863000013, 31.38874128800005],
            [61.490850871000134, 31.403097229000096],
            [61.29479048700006, 31.427643535000087],
            [61.125148649000096, 31.448887156000083],
            [61.12353479000012, 31.449089254000015],
            [60.95599979700012, 31.47006988500003],
            [60.855024048000075, 31.482730611000065],
            [60.821744425000134, 31.494667868000093],
            [60.80996219900004, 31.588357239000047],
            [60.79497603400006, 31.63667470400007],
            [60.792598918000124, 31.660084127000047],
            [60.8053113200001, 31.733981426000113],
            [60.7914620360001, 31.82653391600006],
            [60.789291626000136, 31.874954733000024],
            [60.796733032000134, 31.93675974600002],
            [60.79497603400006, 31.958463847000118],
            [60.79104862500009, 31.969160868000117],
            [60.786087688000066, 31.978979390000077],
            [60.7840206300001, 31.989263],
            [60.792598918000124, 32.01127716100005],
            [60.786707804000116, 32.0169098920001],
            [60.778336222000064, 32.02104400600011],
            [60.774925578000136, 32.02719350200009],
            [60.782677043000035, 32.042541402000055],
            [60.80882531700013, 32.07117014600003],
            [60.814819783000075, 32.08786163300006],
            [60.828255656000124, 32.167443339],
            [60.830322713000044, 32.24888539700002],
            [60.79631962100012, 32.3559072880001],
            [60.75229130100007, 32.49458099400009],
            [60.71167362500012, 32.61031036400003],
            [60.674880005000034, 32.715601095000025],
            [60.640050090000045, 32.815517477000085],
            [60.606150350000064, 32.91235911000008],
            [60.57752160700011, 32.99434377000007],
            [60.56294885300014, 33.05826751800005],
            [60.56150191200004, 33.137306621],
            [60.56759973100009, 33.151285096000024],
            [60.61596887300004, 33.20619130500002],
            [60.67033247900008, 33.26771209800005],
            [60.71901167800013, 33.32303171900007],
            [60.75704553300005, 33.36633656800005],
            [60.785880981000105, 33.387782288000054],
            [60.81864384000011, 33.40488718700003],
            [60.829082479000135, 33.416281841000014],
            [60.83466353400007, 33.436254781000045],
            [60.832803182000134, 33.45346303400002],
            [60.82928918400006, 33.47012868200004],
            [60.832183065000095, 33.484494731000055],
            [60.84985640500008, 33.49436493000003],
            [60.89729537000005, 33.49702626500006],
            [60.91207482900006, 33.50152211600006],
            [60.91978829300007, 33.51257051900011],
            [60.92085982200007, 33.51410532600009],
            [60.911971476000076, 33.52844553600009],
            [60.8951249590001, 33.54113210100003],
            [60.879622030000064, 33.5487026980001],
            [60.84603234800005, 33.5557823700001],
            [60.807378377000134, 33.558159486000065],
            [60.73389449000007, 33.55485219400005],
            [60.65555301900008, 33.55989064500004],
            [60.574834432000046, 33.5877959190001],
            [60.51178918500011, 33.638387146000056],
            [60.48688114500004, 33.711380107000096],
            [60.494942668000135, 33.74411712600009],
            [60.52584517400004, 33.80214976000006],
            [60.52801558500005, 33.841449687000036],
            [60.499386841000046, 33.994256898000046],
            [60.48846068000012, 34.08092732000004],
            [60.48677779100012, 34.09427663200002],
            [60.49277225700007, 34.139028422000095],
            [60.520884237000075, 34.18613149],
            [60.552406861000065, 34.22005706800009],
            [60.58744348200008, 34.25026194300001],
            [60.634985799000106, 34.271216736],
            [60.65059208200006, 34.285350241000046],
            [60.64366744000006, 34.30664093000003],
            [60.714360799000076, 34.310129089000085],
            [60.815956665000044, 34.31527089500007],
            [60.890474080000104, 34.31891408300005],
            [60.879105266000124, 34.33764679000005],
            [60.804897908000044, 34.41748687800005],
            [60.78908492000005, 34.4434801230001],
            [60.77936975100005, 34.45508148200007],
            [60.76727746600005, 34.46415069600003],
            [60.74278283700011, 34.47345245400005],
            [60.73389449000007, 34.48042877200005],
            [60.725316203000034, 34.50427744600002],
            [60.718908325000086, 34.51115041100009],
            [60.71033003800005, 34.515129497000075],
            [60.69968469200006, 34.51639556900001],
            [60.714360799000076, 34.53742787700013],
            [60.739268840000136, 34.5480215460001],
            [60.79404585800012, 34.55411936500006],
            [60.818953898000075, 34.55990712500004],
            [60.83848759000011, 34.57091420500002],
            [60.88385949700012, 34.61370229100005],
            [60.88892378800011, 34.62166046200012],
            [60.89543501800006, 34.62832672200004],
            [60.90887089000012, 34.63468292200007],
            [60.922823527000105, 34.63654327400006],
            [60.93584598800004, 34.63566477500002],
            [60.94752486200014, 34.637990214000055],
            [60.95796350100005, 34.64941070600007],
            [60.961994263000065, 34.67375030600006],
            [60.958686971000134, 34.69958852100008],
            [60.95992720600009, 34.72320465100002],
            [60.97801395700009, 34.740619609000035],
            [61.009639933000074, 34.76098012300007],
            [61.02907027200007, 34.789712220000084],
            [61.034754680000106, 34.806248678000074],
            [61.06545048000004, 34.81472361300008],
            [61.073408651000136, 34.84769317700004],
            [61.07774947200011, 34.88303985600005],
            [61.07702600100009, 34.8917214960001],
            [61.07258182800007, 34.91032501300005],
            [61.071548299000085, 34.92055694600013],
            [61.07475223800009, 34.93311431900004],
            [61.08891158100005, 34.951924541000054],
            [61.092012166000075, 34.961484680000055],
            [61.09531945800006, 34.981018372000065],
            [61.109892212000034, 35.01853546200006],
            [61.11588667800004, 35.059876608000096],
            [61.12312137900011, 35.07419097900008],
            [61.1473059490001, 35.10209625200007],
            [61.13676395600004, 35.11119130500002],
            [61.135213664000105, 35.11940785700007],
            [61.137900838000064, 35.12829620400008],
            [61.1398645430001, 35.13966501900008],
            [61.13707401600004, 35.143902487000034],
            [61.10152063000004, 35.183228252],
            [61.096352987000046, 35.193201802000104],
            [61.10234745300011, 35.19769765300005],
            [61.112372681000124, 35.2020384720001],
            [61.112786093000125, 35.211650289000104],
            [61.1079285080001, 35.22126210500004],
            [61.10234745300011, 35.22560292600012],
            [61.10162398300008, 35.23531809500007],
            [61.102450806000036, 35.256660462000056],
            [61.10834191900011, 35.27795115200003],
            [61.12270796700011, 35.28766632100009],
            [61.14399865700011, 35.2880797320001],
            [61.167873169000075, 35.29138702400009],
            [61.1870968020001, 35.30037872300004],
            [61.19505497300008, 35.31810374000004],
            [61.19040409400009, 35.369573466000034],
            [61.19505497300008, 35.39008901000001],
            [61.20084273300006, 35.40114776600011],
            [61.221823364000045, 35.424247132000076],
            [61.22730106700004, 35.434479065000076],
            [61.23598270700006, 35.46584666000008],
            [61.24704146300007, 35.48507029300002],
            [61.27050256300009, 35.508428040000055],
            [61.2838350830001, 35.527289938000095],
            [61.290036255000075, 35.548063863000024],
            [61.28755578700003, 35.56826934900003],
            [61.27701379400014, 35.60919708200005],
            [61.26967574100013, 35.61849884000007],
            [61.283318319000045, 35.62263295600009],
            [61.33571822100009, 35.63090118400005],
            [61.344193156000074, 35.63090118400005],
            [61.351531210000076, 35.62780059900008],
            [61.360936320000064, 35.621030986000065],
            [61.36010949700011, 35.61839548800013],
            [61.351531210000076, 35.607130026000064],
            [61.36393355300004, 35.598241679000054],
            [61.365483846000075, 35.598500061000024],
            [61.367654256000094, 35.597983297],
            [61.38346724500008, 35.586459453000074],
            [61.38388065600009, 35.582118632000075],
            [61.37995324700012, 35.57131825800006],
            [61.380263305000085, 35.567339173000065],
            [61.38687788900006, 35.559536032000054],
            [61.39318241400008, 35.55359324100003],
            [61.40124393700012, 35.549820862],
            [61.412612752000086, 35.5483222460001],
            [61.41930908800009, 35.54589138400006],
            [61.4277022710001, 35.542844543000015],
            [61.49271122300013, 35.49416534400008],
            [61.53870324700006, 35.45230743400002],
            [61.60474572800007, 35.4306033320001],
            [61.739621216000046, 35.41375681600003],
            [61.79904911300008, 35.41747751900006],
            [61.91935184700009, 35.451842346],
            [61.97774621600013, 35.45091217100013],
            [62.00746016400012, 35.43892323900006],
            [62.03381514500006, 35.42398875000002],
            [62.13634118700014, 35.34135813400006],
            [62.163884725000116, 35.32616526300005],
            [62.21902347800011, 35.30626983600003],
            [62.23369958500007, 35.29376414000005],
            [62.24434493000007, 35.27805450500007],
            [62.25121789600013, 35.260381165000055],
            [62.252613159000134, 35.24281117800008],
            [62.250959513000055, 35.2023485320001],
            [62.25685062700006, 35.18715566000007],
            [62.275712525000074, 35.151033835000064],
            [62.286202840000044, 35.140646871000044],
            [62.30201582800004, 35.147519837000104],
            [62.39932255100007, 35.25593699200006],
            [62.43187870300011, 35.28063832600007],
            [62.45890547700009, 35.281878561],
            [62.52458622200004, 35.23216583300008],
            [62.535489950000056, 35.227359924],
            [62.545515177000084, 35.22803171800008],
            [62.555437052000116, 35.230408834000016],
            [62.5661857500001, 35.230770569000114],
            [62.595641317000116, 35.220590312000056],
            [62.60452966300005, 35.21940175400003],
            [62.621066122000116, 35.22270904500003],
            [62.69361983200014, 35.248392232000114],
            [62.70860599800011, 35.25604034500007],
            [62.721628458000055, 35.266427308000104],
            [62.73423750800009, 35.28074167900009],
            [62.7604891360001, 35.30244578100009],
            [62.82306342900006, 35.327514064000084],
            [62.82756514500005, 35.32931752500009],
            [62.91820560700006, 35.388176982000076],
            [62.985281616000066, 35.41458363900007],
            [63.00553877800007, 35.418407695],
            [63.04708662900009, 35.4213532510001],
            [63.066827027000045, 35.425590719000056],
            [63.08021122200006, 35.43706288700007],
            [63.08625736500011, 35.45566640300002],
            [63.09049483200005, 35.493545228000116],
            [63.10072676600004, 35.52496449900006],
            [63.09721276900012, 35.535454814],
            [63.08057295700007, 35.546513570000016],
            [63.07736901800013, 35.55876088500004],
            [63.07494022700007, 35.60981720000011],
            [63.076645549000034, 35.62470001200005],
            [63.10315555800008, 35.646042379000065],
            [63.17989506000009, 35.66645457],
            [63.20769698100014, 35.683197734000046],
            [63.213588094000045, 35.69229278600001],
            [63.214414917000056, 35.69926910500003],
            [63.20935062700005, 35.70448842400013],
            [63.18392582200005, 35.712343242000074],
            [63.177259563000064, 35.716890768],
            [63.163255250000134, 35.732290345000095],
            [63.11204390500012, 35.769910787000114],
            [63.105687704000104, 35.78288157200002],
            [63.10129520700008, 35.80055491200004],
            [63.091321655000115, 35.81331899100009],
            [63.084397013000114, 35.82608306900006],
            [63.08863448100004, 35.843394674000066],
            [63.10408573400008, 35.85646881100003],
            [63.12527307200014, 35.86024119100004],
            [63.34293420400007, 35.856262106000074],
            [63.4302156980001, 35.871041565000084],
            [63.51108931500005, 35.90184071900005],
            [63.525920451000104, 35.91269277000002],
            [63.54958825700004, 35.939047751000075],
            [63.56343754000005, 35.950623271000026],
            [63.582092732000035, 35.959046530000094],
            [63.602298218000044, 35.96266388000008],
            [63.72570153800007, 35.968865052000055],
            [63.76590580200008, 35.97728831000005],
            [63.85985355600013, 36.02209177700003],
            [63.88982588700014, 36.02963653600007],
            [63.90632706100007, 36.03173234400002],
            [63.921968628000116, 36.03371897400008],
            [63.94997725400009, 36.028861389000056],
            [64.04511356600005, 35.99873403000008],
            [64.04557865400005, 36.011291402],
            [64.0363802490001, 36.05857533800004],
            [64.03622522000012, 36.07640370700007],
            [64.04464847900005, 36.092320049000094],
            [64.05725752800004, 36.105239156000025],
            [64.12335168400011, 36.14606353800009],
            [64.15869836500013, 36.16027455600006],
            [64.19590539500012, 36.1659072880001],
            [64.23714318900005, 36.16042958600012],
            [64.25373132300012, 36.1548485310001],
            [64.26613366700008, 36.15247141600004],
            [64.27605554200011, 36.159241028000096],
            [64.29186853100009, 36.19944529200002],
            [64.30365075700007, 36.211537578],
            [64.31894698100007, 36.21975413000003],
            [64.33724043800004, 36.22595530200003],
            [64.41087935400003, 36.239856262],
            [64.4445723880001, 36.249984843000036],
            [64.47769698100007, 36.27163726800002],
            [64.49816084800005, 36.291429342000114],
            [64.57665734900007, 36.38961456400007],
            [64.59438236500011, 36.42418609700009],
            [64.60585453300013, 36.461083069],
            [64.61050541200007, 36.50092559800002],
            [64.60776656100012, 36.52164784800006],
            [64.59371057100003, 36.55983673100003],
            [64.58900801600004, 36.58024892200008],
            [64.58880131100005, 36.60045440700007],
            [64.59200524900007, 36.621073303000074],
            [64.60482100400003, 36.66055409800002],
            [64.62135746300004, 36.6925934850001],
            [64.72854862900004, 36.850569547000035],
            [64.7652246500001, 36.90462188800002],
            [64.7787638750001, 36.93846995000011],
            [64.77462976100009, 36.977589010000045],
            [64.75561283400009, 37.053630880000085],
            [64.76016036000004, 37.0926207480001],
            [64.7787638750001, 37.1180455530001],
            [64.8079093830001, 37.13551218700006],
            [64.98908695500012, 37.21367279100009],
            [65.06308760600012, 37.2332323210001],
            [65.48792177900009, 37.24199746800004],
            [65.50140710500006, 37.24227569600005],
            [65.53685713700008, 37.257106833000094],
            [65.58315922000014, 37.308059795000034],
            [65.61127120000009, 37.331055806000066],
            [65.62408695500005, 37.345137635000114],
            [65.62946130400013, 37.3654206340001],
            [65.62889286300009, 37.38753814700003],
            [65.62098636900004, 37.430403748000074],
            [65.62574060100013, 37.452805481000055],
            [65.63576582900004, 37.474096171000056],
            [65.64816817200011, 37.493836568000106],
            [65.64827152500004, 37.49393992200005],
            [65.64832320200014, 37.49414662700009],
            [65.65871016400007, 37.51026967400007],
            [65.66883874500013, 37.52055328400006],
            [65.68103438400004, 37.52639272000006],
            [65.69829431200003, 37.52941579200008],
            [65.7394287520001, 37.52905405700007],
            [65.75265791800012, 37.53786488900006],
            [65.7588590900001, 37.5641165170001],
            [65.76144291200006, 37.57837921200009],
            [65.77653243000009, 37.57290151000008],
            [65.79647953300008, 37.569335836000036],
            [65.80433435100014, 37.56530507400002],
            [65.82107751500007, 37.535177715000046],
            [65.82908736200005, 37.52561757400004],
            [65.83606368000005, 37.51915802000009],
            [65.85518396000003, 37.50794423500004],
            [66.07966638200014, 37.4408682250001],
            [66.09785648600007, 37.42841420500004],
            [66.12560673000013, 37.39870025700007],
            [66.14291833500005, 37.38505767900004],
            [66.16307214300014, 37.37689280200003],
            [66.17464766500007, 37.37549753800006],
            [66.20772058100005, 37.37689280200003],
            [66.21846927900009, 37.374799906000064],
            [66.23252526900006, 37.3654206340001],
            [66.24187870300011, 37.36330190000005],
            [66.25084771600007, 37.359650022000054],
            [66.25774336800004, 37.35684234600008],
            [66.27438317900004, 37.34327728300009],
            [66.29443363400009, 37.331210836000125],
            [66.32068526200004, 37.32914377800007],
            [66.3896216230001, 37.34717885400006],
            [66.41349613500006, 37.34963348400002],
            [66.42362471500013, 37.34568023700005],
            [66.4386625570001, 37.32790354400002],
            [66.45106490100005, 37.32294260700009],
            [66.46145186400008, 37.32444122300008],
            [66.46992679900006, 37.32976389600013],
            [66.48522302300006, 37.34340647400005],
            [66.50289636200006, 37.35565378900007],
            [66.51958785000011, 37.36418040000008],
            [66.53901818900005, 37.3690896610001],
            [66.5645980220001, 37.37069163100004],
            [66.58857588700005, 37.368469543000046],
            [66.65467004400006, 37.34614532500008],
            [66.66702071100013, 37.344310811000085],
            [66.6940991620001, 37.34340647400005],
            [66.7047445070001, 37.34653289900008],
            [66.72443322700013, 37.360149638000095],
            [66.73497522000008, 37.36330190000005],
            [66.86576827000005, 37.36792694100011],
            [66.95764896600008, 37.385212708],
            [67.00591475400012, 37.38438588500007],
            [67.02410485800004, 37.3774870810001],
            [67.06410241700013, 37.35456858300007],
            [67.08508304900005, 37.34963348400002],
            [67.09738203900008, 37.34059010800006],
            [67.11391849800009, 37.29718190500007],
            [67.12332360900012, 37.281963196000035],
            [67.1434774170001, 37.271860453],
            [67.18781579600005, 37.2582437140001],
            [67.20796960500013, 37.243464254000074],
            [67.21799483200004, 37.2262560030001],
            [67.22528121000005, 37.20770416300006],
            [67.23675337700013, 37.19240793900009],
            [67.25912927200011, 37.18514740000005],
            [67.2814534910001, 37.18866139800009],
            [67.31959069800007, 37.208427633000056],
            [67.3452222090001, 37.213026836000026],
            [67.36951013200013, 37.21468048100006],
            [67.39116255700009, 37.219589742],
            [67.41126468900006, 37.22790964800005],
            [67.43110843900007, 37.239769389000074],
            [67.46397465000007, 37.266279398000066],
            [67.48237146000008, 37.277363993000094],
            [67.50314538600014, 37.281963196000035],
            [67.52614139800005, 37.27289398200007],
            [67.54500329600012, 37.231526998000035],
            [67.56138472500004, 37.21989980100007],
            [67.57218509900008, 37.22315541600007],
            [67.57993656400009, 37.23266388000006],
            [67.58603438300014, 37.24261159300006],
            [67.59228723100006, 37.2471849570001],
            [67.60272587100008, 37.248270162],
            [67.62179447400007, 37.25292104100005],
            [67.63316329000014, 37.25405792300005],
            [67.64463545700005, 37.251215719000086],
            [67.6664429120001, 37.238012391],
            [67.6775016680001, 37.23354237900007],
            [67.69016239400014, 37.23225046800003],
            [67.72587080900013, 37.23354237900007],
            [67.74659305800009, 37.22940826500006],
            [67.76426639800007, 37.220881653000035],
            [67.77599694800006, 37.207549134000104],
            [67.78054447500011, 37.18886810300005],
            [67.77196618700009, 37.124970195000074],
            [67.77305139200007, 37.1099840290001],
            [67.7853503820001, 37.09654815700007],
            [67.80803633700009, 37.083241476000055],
            [67.8328927010001, 37.07308705700008],
            [67.87810957900012, 37.06443125400004],
            [67.89195886200008, 37.05202891100008],
            [67.90250085500014, 37.03438140900006],
            [67.91841719600006, 37.01381418900009],
            [67.9292692460001, 37.00624359200013],
            [67.95293705300014, 36.99624420200011],
            [67.96182539900013, 36.989939677000095],
            [67.99619022600007, 36.95578155500003],
            [68.00202966300009, 36.94748748800005],
            [68.00606042500004, 36.93867665700007],
            [68.01112471500005, 36.93087351600006],
            [68.02021976800012, 36.92568003400005],
            [68.02481969200005, 36.92551846600007],
            [68.03272546400012, 36.925240784000025],
            [68.04471439600007, 36.92921986900011],
            [68.05494633000006, 36.93464589400007],
            [68.12109216300013, 36.98027618500008],
            [68.13339115400004, 36.986529032000064],
            [68.15199467000014, 36.992781881000056],
            [68.16796268800005, 37.00608856200007],
            [68.18641117300007, 37.018310038000024],
            [68.21255944800009, 37.02125559500011],
            [68.25374556500009, 37.010222677000016],
            [68.27777510600009, 37.01006764800006],
            [68.28831709800005, 37.02440785700007],
            [68.28159916200013, 37.066472473000076],
            [68.28077233900012, 37.086652121000085],
            [68.28831709800005, 37.103214417000075],
            [68.3072823490001, 37.11422149700006],
            [68.32666101100006, 37.113032939000036],
            [68.34609135000005, 37.106909281000085],
            [68.36583174600014, 37.103214417000075],
            [68.39187666900011, 37.105436503000064],
            [68.4114620360001, 37.11336883600005],
            [68.41802494300009, 37.12827748600007],
            [68.40371057100003, 37.151635234000125],
            [68.46577396700008, 37.15535593700004],
            [68.5133162840001, 37.16398590100009],
            [68.52385827600006, 37.16465769400007],
            [68.5327466230001, 37.16899851500004],
            [68.54654423000011, 37.188222148000065],
            [68.55145349100007, 37.19261464500006],
            [68.57140059500006, 37.19470754100003],
            [68.60881433200012, 37.204086813000075],
            [68.62690108300006, 37.206257222000076],
            [68.6307768150001, 37.21382782000002],
            [68.63640954600004, 37.229925029000086],
            [68.64860518400013, 37.244368591000026],
            [68.67123946100008, 37.2471849570001],
            [68.66545170100005, 37.259380595000025],
            [68.66266117300006, 37.26372141500009],
            [68.65754520700006, 37.26767466200006],
            [68.66886234500004, 37.278294169000034],
            [68.68694909600009, 37.27901764000005],
            [68.72591312700007, 37.27452179000004],
            [68.74653202300004, 37.276227112000086],
            [68.75960616100008, 37.27524526000012],
            [68.77128503400007, 37.27072357200008],
            [68.80849206500011, 37.2516291300001],
            [68.82037764500012, 37.2509056600001],
            [68.82461511300005, 37.260620830000036],
            [68.8220312900001, 37.281963196000035],
            [68.81019738800006, 37.31209055600003],
            [68.81381473800013, 37.323407695000085],
            [68.83582889800005, 37.32914377800007],
            [68.85675785300003, 37.324906311000106],
            [68.86802331600006, 37.312142233000046],
            [68.8770150150001, 37.29609670100008],
            [68.89029585800012, 37.281963196000035],
            [68.90471358200006, 37.27669220000011],
            [68.91582401600004, 37.27906931600005],
            [68.92114668800008, 37.28795766300006],
            [68.91763269100005, 37.3024270640001],
            [68.91298181200006, 37.30676788300009],
            [68.89675541200006, 37.31648305300003],
            [68.89029585800012, 37.32294260700009],
            [68.88507653800008, 37.334828186000024],
            [68.88786706600007, 37.3381354780001],
            [68.89365482600004, 37.33715362500003],
            [68.89716882400006, 37.33596506800002],
            [68.96543339100003, 37.32914377800007],
            [68.98522546400011, 37.32035878500007],
            [69.00548262600012, 37.30552764900004],
            [69.02103723200014, 37.28795766300006],
            [69.03576501500004, 37.25157745400007],
            [69.05560876500004, 37.23710805300006],
            [69.07839807200014, 37.225170797000104],
            [69.09643314600004, 37.213026836000026],
            [69.11431319200011, 37.17747345000005],
            [69.1236149500001, 37.1692052210001],
            [69.14573246300012, 37.15695790700006],
            [69.15100345900004, 37.15504587800005],
            [69.24567468300006, 37.103886210000056],
            [69.26577681500004, 37.10541066600008],
            [69.28562056500004, 37.11292958600002],
            [69.30861667800008, 37.1168820430001],
            [69.31207889800004, 37.11747711200006],
            [69.32391280200005, 37.12099111000002],
            [69.33476485200009, 37.129052633000086],
            [69.35083622300004, 37.144142151],
            [69.39119551600004, 37.16465769400007],
            [69.40773197400011, 37.17747345000005],
            [69.44214847900008, 37.223620504000095],
            [69.44519738800011, 37.23641042100006],
            [69.4268522540001, 37.239459331],
            [69.40985070800008, 37.24566050300008],
            [69.41791223100006, 37.26767466200006],
            [69.40969567900004, 37.276743877000015],
            [69.40308109500006, 37.31116038000006],
            [69.39460616000014, 37.32606903100013],
            [69.38943851700003, 37.33291615800009],
            [69.38644128500005, 37.341520284000026],
            [69.38489099100008, 37.35089955700006],
            [69.38447758000007, 37.360149638000095],
            [69.38582116700007, 37.36314687200009],
            [69.38850834100009, 37.36376698800008],
            [69.39088545700014, 37.36531728100009],
            [69.39119551600004, 37.37069163100004],
            [69.38830163600005, 37.37510996600004],
            [69.37894820200006, 37.377125346000085],
            [69.37703617400007, 37.38066518200007],
            [69.37631270300005, 37.41885406500005],
            [69.37837976100013, 37.43740590500006],
            [69.38447758000007, 37.453270569],
            [69.38964522300012, 37.45879994700009],
            [69.40401127100012, 37.46686147100009],
            [69.41171106000007, 37.47252004000002],
            [69.41558679200006, 37.47750681600006],
            [69.42178796400003, 37.489495748000124],
            [69.4254053140001, 37.49424998000002],
            [69.46974369400004, 37.52013987300005],
            [69.49144779500006, 37.536986390000024],
            [69.50865604600006, 37.57897349000005],
            [69.52865482600009, 37.58602732400006],
            [69.66497725500011, 37.57615712500008],
            [69.68730147300005, 37.579593608000025],
            [69.72957279500014, 37.594088848000055],
            [69.75427413000006, 37.59667266900006],
            [69.76223230000005, 37.59579416900003],
            [69.78445316600005, 37.590419820000065],
            [69.79184289500006, 37.58610483800008],
            [69.80222985800009, 37.58150563600013],
            [69.81266849800005, 37.58584645600011],
            [69.82300378500014, 37.59295196600003],
            [69.83292565900013, 37.59667266900006],
            [69.85328617400006, 37.60122019400008],
            [69.89524743600009, 37.618170065000086],
            [69.91881189000009, 37.6171365360001],
            [69.93524499600005, 37.60566436800009],
            [69.94454675300005, 37.58969635000007],
            [69.95539880400008, 37.575485331],
            [69.9765861410001, 37.569335836000036],
            [69.9895052490001, 37.567320455000086],
            [69.9946728920001, 37.56225616500011],
            [69.99849694800014, 37.555589905],
            [70.00418746200006, 37.55137051900003],
            [70.00759200100009, 37.54884613100005],
            [70.01689375800004, 37.54597808900009],
            [70.04800297000008, 37.54143056200003],
            [70.04169844600005, 37.54884613100005],
            [70.06919030800003, 37.545202942000074],
            [70.09905928600006, 37.536572978000024],
            [70.12913496900012, 37.53228383400007],
            [70.15786706500012, 37.54143056200003],
            [70.1926969810001, 37.57602793400004],
            [70.19941491700013, 37.57928355000003],
            [70.2019470620001, 37.587991029000094],
            [70.21646814000013, 37.6171365360001],
            [70.21843184500005, 37.617446595],
            [70.23765547700003, 37.61811838800007],
            [70.24096276900008, 37.6171365360001],
            [70.24607873600007, 37.62127065000003],
            [70.24830082200009, 37.62333770800008],
            [70.25393355300014, 37.63080495200002],
            [70.25522546400009, 37.63747121200005],
            [70.25388187700008, 37.646592102000014],
            [70.25357181800013, 37.65457611100008],
            [70.25770593300007, 37.65809010800005],
            [70.26256351700005, 37.6608806360001],
            [70.2751208900001, 37.67547922800007],
            [70.27703291800003, 37.687984925000066],
            [70.28054691600005, 37.69604644800005],
            [70.28307906100014, 37.70483144200004],
            [70.28189050300011, 37.719559225000054],
            [70.2717619230001, 37.748704733000054],
            [70.26959151200009, 37.76263153100005],
            [70.2751208900001, 37.77418121300009],
            [70.26556075100007, 37.78120920800008],
            [70.25651737500004, 37.79180287800007],
            [70.24985111500013, 37.80487701500003],
            [70.24716394000006, 37.8191655480001],
            [70.24034265200004, 37.827562968000095],
            [70.20747644000011, 37.835624492000065],
            [70.19600427300009, 37.83991363600005],
            [70.17915775600011, 37.86079091400002],
            [70.16520511900012, 37.88991058400002],
            [70.16050256400013, 37.92065806100008],
            [70.17212976100012, 37.946082866],
            [70.19223189300004, 37.93287953800011],
            [70.21471114100007, 37.92926218700002],
            [70.23812056500003, 37.932362773000065],
            [70.26152998900011, 37.93928741500004],
            [70.25367517100005, 37.947400615000035],
            [70.25016117400008, 37.955617167000085],
            [70.25041955600005, 37.964143779],
            [70.25393355300014, 37.97339386],
            [70.26090987200013, 37.97646860800005],
            [70.27269209900004, 37.9781739300001],
            [70.28375085500005, 37.981868795000096],
            [70.28871179200007, 37.99080881800005],
            [70.29377608300007, 37.99610565200008],
            [70.29858315700005, 37.99813427900007],
            [70.31796065300011, 38.006311748000044],
            [70.32628055800006, 38.011272685],
            [70.37118737800006, 38.05829823800006],
            [70.4153707270001, 38.09452341800004],
            [70.42596439700009, 38.10064707400009],
            [70.46007084200005, 38.11224843400005],
            [70.4703027750001, 38.12051666300009],
            [70.48260176600007, 38.137363180000065],
            [70.50854333500013, 38.19250193300003],
            [70.5379472250001, 38.238054708000035],
            [70.5471973060001, 38.26265269],
            [70.55939294400014, 38.268182068],
            [70.57303552300004, 38.271050110000076],
            [70.58306075100006, 38.27508087200009],
            [70.59659997600005, 38.30918731800004],
            [70.59670332800005, 38.31758473700002],
            [70.59556644700007, 38.327790833],
            [70.5957731520001, 38.338177796000124],
            [70.60001062000003, 38.34706614200003],
            [70.60931237800008, 38.35120025700006],
            [70.63210168500007, 38.35011505200008],
            [70.64135176600007, 38.35419748900007],
            [70.6766984460001, 38.374919739000106],
            [70.68475996900008, 38.386650289],
            [70.66486454300008, 38.39863922100004],
            [70.66486454300008, 38.405408834000085],
            [70.68331302900009, 38.41458140100009],
            [70.74181075100006, 38.4194389850001],
            [70.75421309400008, 38.43646637000002],
            [70.76108606000014, 38.443520203000034],
            [70.77726078300003, 38.44646575900005],
            [70.80888675900013, 38.446362407000024],
            [70.81798181200008, 38.444992981000055],
            [70.83410485800005, 38.44060048400006],
            [70.84304488100008, 38.44016123500005],
            [70.84981449400004, 38.442822571000065],
            [70.85358687400009, 38.44742177400009],
            [70.85932295700013, 38.45165924100006],
            [70.87100183100011, 38.45320953400007],
            [70.91223962400011, 38.43765492800004],
            [70.93621748900011, 38.433004049000075],
            [70.94675948100007, 38.443235983000065],
            [70.94345218900008, 38.46594777500003],
            [70.95073856600004, 38.47305328400007],
            [70.97404463700008, 38.47367340200013],
            [70.98680871600004, 38.470908712],
            [70.99822920700007, 38.46566355400007],
            [71.00856449400004, 38.45858388300003],
            [71.0186413990001, 38.44982472700006],
            [71.02458418800012, 38.441918233000095],
            [71.03295577000011, 38.42365061500006],
            [71.039467, 38.41533070900009],
            [71.04980228700009, 38.408664450000074],
            [71.05714034000005, 38.40902618400007],
            [71.0649434820001, 38.41181671200003],
            [71.07698409100004, 38.41217844700013],
            [71.08938643400012, 38.409853007],
            [71.11739506000004, 38.39863922100004],
            [71.15594567900013, 38.37621165000006],
            [71.2176990160001, 38.32582712800006],
            [71.3001229250001, 38.29869700100009],
            [71.3343843990001, 38.280661927],
            [71.35815555800013, 38.25125803700011],
            [71.36451176000008, 38.20681630500003],
            [71.35908573400008, 38.184104513000065],
            [71.34094730600009, 38.14092885400002],
            [71.33453942900013, 38.11167999300007],
            [71.31603926600013, 38.083283793000064],
            [71.3023966880001, 38.04233022100003],
            [71.27263106300012, 37.997991842],
            [71.26591312700009, 37.97254119900008],
            [71.25578454600003, 37.94988108300002],
            [71.25454431200012, 37.93928741500004],
            [71.25826501500012, 37.92647165900006],
            [71.26353601100004, 37.92435292600008],
            [71.27118412300013, 37.92618743900009],
            [71.28182946800013, 37.924998881000064],
            [71.31975996900013, 37.90058176700002],
            [71.34115401300005, 37.893295390000034],
            [71.36099776200012, 37.902028707000014],
            [71.37918786600005, 37.91293243400007],
            [71.50119592300013, 37.946212057000125],
            [71.53705936700004, 37.94445505800006],
            [71.56734175700007, 37.928073629],
            [71.59772749900003, 37.89835968100003],
            [71.59028609300003, 37.89143503800004],
            [71.59338667800006, 37.879342753000046],
            [71.59504032400014, 37.85753529900002],
            [71.59421350100007, 37.83376414000007],
            [71.59028609300003, 37.81572906500007],
            [71.57467981000008, 37.798004049000056],
            [71.53778283700007, 37.779038798],
            [71.52951460800011, 37.76113291500003],
            [71.53116825400008, 37.751753642],
            [71.54026330600004, 37.7305146290001],
            [71.54253706900005, 37.719559225000054],
            [71.54088342300008, 37.709714865000066],
            [71.52951460800011, 37.678579814],
            [71.52476037600013, 37.647728984000125],
            [71.52207320200012, 37.63762624100006],
            [71.51721561700009, 37.6292288210001],
            [71.5051233320001, 37.61599965500001],
            [71.50150598200008, 37.61034108500006],
            [71.49716516100011, 37.56654530900006],
            [71.51122115100003, 37.485878398000054],
            [71.50150598200008, 37.44577748700006],
            [71.49024052000004, 37.42337575300006],
            [71.4871399330001, 37.409087219000085],
            [71.49468469200013, 37.37069163100004],
            [71.49654504400007, 37.32852366200008],
            [71.49385787000011, 37.30754303],
            [71.48786340400011, 37.29498565700008],
            [71.48703658000005, 37.2670545460001],
            [71.45013960700004, 37.21667002400001],
            [71.45375695800004, 37.19261464500006],
            [71.44683231600004, 37.1835971070001],
            [71.44104455600007, 37.168430074000085],
            [71.43318973800012, 37.12734731100004],
            [71.43112268100009, 37.06698923700013],
            [71.43318973800012, 37.054741924],
            [71.43918420400007, 37.044096578],
            [71.45644413300005, 37.022547506000066],
            [71.45995813000013, 37.01073944100004],
            [71.45995813000013, 36.9697858680001],
            [71.46305871600003, 36.94808176700012],
            [71.47174035600011, 36.93004669200012],
            [71.52848107900013, 36.85614939400004],
            [71.53850630700003, 36.83609893800009],
            [71.5453275960001, 36.79000356100006],
            [71.55287235600008, 36.76959137000004],
            [71.56393111200009, 36.75067779600009],
            [71.57736698400004, 36.733262838000044],
            [71.61106001800005, 36.70484080000004],
            [71.65302128100006, 36.6870124310001],
            [71.69994348200004, 36.678640849000104],
            [71.74851932800004, 36.678640849000104],
            [71.79761193900003, 36.68608225500013],
            [71.83657596900014, 36.69915639200009],
            [72.12668746000008, 36.87273752900005],
            [72.15283573400006, 36.8957077030001],
            [72.1868388260001, 36.91139150000005],
            [72.19593387900011, 36.91898793600002],
            [72.21040328000004, 36.93660959900011],
            [72.22032515500013, 36.94554962200003],
            [72.25980594900005, 36.96730540000006],
            [72.36098840400012, 37.0002749640001],
            [72.40594689900013, 37.007664693000024],
            [72.47498661300011, 36.99748443600005],
            [72.50867964700006, 37.011075338000055],
            [72.65771447800006, 37.02882619200007],
            [72.66660282400005, 37.03833465600006],
            [72.67270064300004, 37.05760996500008],
            [72.71435184800004, 37.1099840290001],
            [72.7609639900001, 37.18749867800007],
            [72.7907296140001, 37.22026153600008],
            [72.8305204670001, 37.239769389000074],
            [72.87744266800007, 37.246874898],
            [72.90224735600009, 37.253799541],
            [72.92426151500007, 37.27483184900011],
            [72.99557499200006, 37.309300029000056],
            [73.06750858600009, 37.31506195100003],
            [73.0877657480001, 37.32606903100013],
            [73.09923791500012, 37.33986663800006],
            [73.11639449000006, 37.36906382300002],
            [73.13210412600006, 37.38438588500007],
            [73.17024133300004, 37.408260396000045],
            [73.1790263260001, 37.410740866000125],
            [73.20062707500006, 37.40417795900005],
            [73.21147912600009, 37.408260396000045],
            [73.26026167900005, 37.450040792000024],
            [73.27607466700005, 37.45947174100006],
            [73.29633182800006, 37.464949443000066],
            [73.32123986800013, 37.467016500000014],
            [73.34501102700011, 37.46448435500004],
            [73.36185754400009, 37.45639699400003],
            [73.37839400300004, 37.452547099000085],
            [73.44061242700008, 37.47993560800005],
            [73.48526086400011, 37.48096913700003],
            [73.60504683500005, 37.44577748700006],
            [73.67449995900012, 37.431049703000056],
            [73.71780481000008, 37.43182485000007],
            [73.75346154800008, 37.428388367000125],
            [73.74705367000013, 37.40311859200007],
            [73.74591678900003, 37.39490203900003],
            [73.74571008300006, 37.3528632620001],
            [73.73909550000008, 37.33834218400007],
            [73.7222489830001, 37.32245168100003],
            [73.70498905400012, 37.31095367400012],
            [73.69041630000004, 37.30521759100007],
            [73.65196903500009, 37.3020653280001],
            [73.63098840300012, 37.29599334800007],
            [73.60990441900009, 37.2813947560001],
            [73.59729536900005, 37.26180938700007],
            [73.60163619000014, 37.24088043200008],
            [73.6176558840001, 37.233180644000086],
            [73.65992720500009, 37.24374847500006],
            [73.68049442500006, 37.24245656300009],
            [73.6880391840001, 37.236901347000085],
            [73.70240523300009, 37.22116587400002],
            [73.70922652200005, 37.21700592000009],
            [73.7199752200001, 37.21754852400004],
            [73.7362016190001, 37.22765126600008],
            [73.74612349500006, 37.23054514600007],
            [73.76865441900003, 37.2288915000001],
            [73.78395064300014, 37.225894267000015],
            [73.79821333900014, 37.22852976500012],
            [73.83624719200009, 37.25674509700009],
            [73.85640100100005, 37.2615768430001],
            [73.89929244000007, 37.26547841500006],
            [73.95561975100003, 37.286769104000044],
            [73.97670373600005, 37.290283102],
            [74.05215132600011, 37.31224558600006],
            [74.16325565700004, 37.330073954000014],
            [74.18764693200006, 37.338393861000085],
            [74.20604374200013, 37.35565378900007],
            [74.2076973880001, 37.38991526300008],
            [74.22392378800009, 37.403351136000126],
            [74.25038212100009, 37.403687032],
            [74.2794242760001, 37.39751169900005],
            [74.30381555200012, 37.400173035000066],
            [74.31559777900003, 37.42691558800003],
            [74.32086877400013, 37.413893128],
            [74.33244429600006, 37.42035268100004],
            [74.3438131100001, 37.420998637000125],
            [74.35363163200003, 37.41590850900003],
            [74.36820438600012, 37.396374818000126],
            [74.37812626200008, 37.39376515800002],
            [74.38939172400006, 37.39340342200002],
            [74.41833052600003, 37.38919179300008],
            [74.43590051300009, 37.39234405500004],
            [74.45481408700005, 37.393635966],
            [74.47662154100004, 37.386091208000025],
            [74.51269169100004, 37.37722869900004],
            [74.52116662600008, 37.375600891],
            [74.52984826700003, 37.37575592100002],
            [74.63144413300012, 37.38107859300008],
            [74.66038293500009, 37.39397186300006],
            [74.78854048700003, 37.3311591600001],
            [74.81685917200008, 37.30692291300004],
            [74.86264449100014, 37.244601135],
            [74.89230676300008, 37.231113587000024],
            [74.81313846800009, 37.215429789000055],
            [74.7940181890001, 37.21393117300006],
            [74.78326949100006, 37.2196672570001],
            [74.74399540200011, 37.288396912000096],
            [74.73738081900012, 37.29612253800009],
            [74.7214644770001, 37.29777618500013],
            [74.7093721920001, 37.290825704000056],
            [74.69893355300007, 37.2803095500001],
            [74.67629927600012, 37.26372141500009],
            [74.67092492700004, 37.261344299000044],
            [74.65097782400005, 37.25963897700008],
            [74.64632694500006, 37.25483306900007],
            [74.64301965300007, 37.2483735150001],
            [74.62999719300012, 37.23829661100008],
            [74.62720666500007, 37.234317525000094],
            [74.6232792560001, 37.23080352800004],
            [74.61501102700004, 37.228374736],
            [74.60901656100003, 37.230183411000084],
            [74.59651086500014, 37.24075124100004],
            [74.5899996340001, 37.24336090100006],
            [74.57594364500005, 37.242146505000036],
            [74.53222538200009, 37.23219879200012],
            [74.50008264200005, 37.23163035100008],
            [74.48726688600004, 37.22594594300001],
            [74.47662154100004, 37.21005544100011],
            [74.46762984200012, 37.18992747000003],
            [74.45667443900004, 37.177318420000105],
            [74.44158492000014, 37.17054880800008],
            [74.42029423100007, 37.1680683390001],
            [74.38226037600003, 37.17204742500009],
            [74.36830774000003, 37.16706064900002],
            [74.36613732900014, 37.14775950100007],
            [74.38257043400012, 37.126572164000024],
            [74.41440311700006, 37.107839457000026],
            [74.47662154100004, 37.083138123000126],
            [74.4940881760001, 37.066472473000076],
            [74.50576705000009, 37.0470421350001],
            [74.51920292200003, 37.03024729400006],
            [74.54235396300004, 37.021669006000124],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Turkmenistan',
        iso3: 'TKM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [61.26967574100013, 35.61849884000007],
              [61.24538781800004, 35.649297995000026],
              [61.23174523900013, 35.671880595000076],
              [61.22916141800005, 35.69859731100003],
              [61.233088826000085, 35.70459177700006],
              [61.246731405000105, 35.71549550400003],
              [61.249728638000136, 35.72247182200003],
              [61.24900516800005, 35.740196839000035],
              [61.249728638000136, 35.74577789300004],
              [61.25634322100012, 35.769497375000086],
              [61.256136515000094, 35.77936757400006],
              [61.249728638000136, 35.786705628000064],
              [61.256136515000094, 35.80913320000006],
              [61.25551639800011, 35.825359599000066],
              [61.25189904800004, 35.840397441000064],
              [61.24735152200009, 35.876209208],
              [61.24104699700007, 35.89388254800009],
              [61.232158651000134, 35.91067738900004],
              [61.221823364000045, 35.92452667300002],
              [61.20580367100007, 35.94049469000005],
              [61.188337036000064, 35.953568828000115],
              [61.16807987400006, 35.96235382100009],
              [61.1435852460001, 35.96550608300005],
              [61.12983931500014, 35.97051869700003],
              [61.14141483500009, 35.98235260000003],
              [61.16177535000014, 35.99594350200003],
              [61.173970988000065, 36.006485494000074],
              [61.174591105000104, 36.015838928000036],
              [61.17107710800008, 36.0359410600001],
              [61.173970988000065, 36.048033345000064],
              [61.18027551300014, 36.052787577000075],
              [61.18968062300013, 36.055784811000066],
              [61.19815555800011, 36.06079742400006],
              [61.20197961500014, 36.07159779900009],
              [61.20239302600004, 36.08074452700005],
              [61.20415002400006, 36.090563049000124],
              [61.20725061100006, 36.09950307200005],
              [61.21221154800014, 36.10637603800002],
              [61.2227535400001, 36.117538148000065],
              [61.22471724400003, 36.123687643000025],
              [61.22306359900006, 36.12880361000002],
              [61.220479777000094, 36.158930969000025],
              [61.20549361100012, 36.22109771700009],
              [61.19092085800014, 36.2406314090001],
              [61.18761356700014, 36.25034657900004],
              [61.18720015400004, 36.27354929600004],
              [61.185443156000076, 36.28398793600009],
              [61.18141239400006, 36.29447825100003],
              [61.17727828000005, 36.30036936500004],
              [61.17107710800008, 36.306415508000086],
              [61.16311893700009, 36.311583151],
              [61.153507121000075, 36.314942118000104],
              [61.15619429600008, 36.32186676100007],
              [61.15774458800013, 36.32465728800004],
              [61.16094852800012, 36.328636373],
              [61.14668583200012, 36.3572651170001],
              [61.15247359200009, 36.406306051000016],
              [61.173970988000065, 36.4868179330001],
              [61.16797652200012, 36.50180409800008],
              [61.16632287600004, 36.51384470700013],
              [61.170663697000066, 36.52443837500003],
              [61.17686486900004, 36.53203481100009],
              [61.182239217000074, 36.541646627],
              [61.186166626000045, 36.55280873600013],
              [61.18761356700014, 36.56510772700007],
              [61.18595992000007, 36.57766510000009],
              [61.182239217000074, 36.586915181000094],
              [61.173970988000065, 36.602314759000066],
              [61.16580611200004, 36.636317851000015],
              [61.12518843600009, 36.640762024000125],
              [61.075475708000056, 36.64779001900003],
              [60.97294966700014, 36.64634307900003],
              [60.8544039300001, 36.64463775700007],
              [60.64108361800004, 36.641485495000026],
              [60.50124719200005, 36.63947011300006],
              [60.34229048700007, 36.637144674000055],
              [60.3092175700001, 36.65197581000008],
              [60.28865035000007, 36.681069641000065],
              [60.25960819500011, 36.74240956700005],
              [60.23852421100008, 36.769746399000056],
              [60.132587525000076, 36.87340932200003],
              [60.08638879400013, 36.93002085400012],
              [60.048871704000135, 36.99402211500011],
              [60.01920943200008, 37.02580312100004],
              [59.981588989000045, 37.038825583000076],
              [59.89952681500006, 37.05055613200007],
              [59.862836548000075, 37.067816061000045],
              [59.797207479000065, 37.112206116000024],
              [59.653236938000134, 37.149671529],
              [59.64259159300008, 37.150239970000044],
              [59.63318648300009, 37.146260885000075],
              [59.62150760900005, 37.131507264000064],
              [59.61447961400012, 37.12548695900004],
              [59.60497115100014, 37.12388499000009],
              [59.591535278000094, 37.132334086000085],
              [59.58461063600009, 37.14889638300009],
              [59.57985640400011, 37.16780995800012],
              [59.57272505700007, 37.18339040200006],
              [59.55598189300014, 37.197782288000056],
              [59.54120243300008, 37.19984934500003],
              [59.50947310400011, 37.189824117000015],
              [59.50120487500004, 37.19021169000011],
              [59.49272994000006, 37.19359649600004],
              [59.484668416000034, 37.19876414000005],
              [59.47815718600009, 37.2041384890001],
              [59.461724080000124, 37.20760081000013],
              [59.458830200000136, 37.214757996000074],
              [59.46182743300005, 37.22300038700003],
              [59.463067667000075, 37.22971832300006],
              [59.46451460800006, 37.23245717400009],
              [59.46813195800007, 37.23584198100009],
              [59.46937219300008, 37.24069956500004],
              [59.463481079000076, 37.24744333900007],
              [59.44467085800005, 37.26418650300012],
              [59.38203902200007, 37.30568267900007],
              [59.37036014900008, 37.31942860900001],
              [59.35072310400005, 37.38836497000004],
              [59.34834598800012, 37.40929392500003],
              [59.35165328000011, 37.42043019700007],
              [59.357854451000094, 37.43027455700003],
              [59.36198856700008, 37.43921458000007],
              [59.359198039000034, 37.44750864700002],
              [59.35320357200004, 37.45843821300009],
              [59.35630415900005, 37.4806332400001],
              [59.35165328000011, 37.493836568000106],
              [59.33232629400004, 37.515127259000096],
              [59.31227583800012, 37.53034596700003],
              [59.28922814900005, 37.535177715000046],
              [59.23310754400012, 37.51471384700007],
              [59.21171350100008, 37.51631581700012],
              [59.078284953000036, 37.59274525900007],
              [59.04562544700008, 37.61961700500008],
              [59.034566691000066, 37.62452626500003],
              [59.00552453600005, 37.628014425000075],
              [58.992192017000036, 37.63145090800002],
              [58.97813602700012, 37.639512431000085],
              [58.93865523300008, 37.653930156000015],
              [58.861037231000125, 37.66808949800004],
              [58.80109257000004, 37.69465118400008],
              [58.79561486800014, 37.68772654200008],
              [58.79313440000004, 37.672843730000054],
              [58.779801880000036, 37.65964040200005],
              [58.76925988800008, 37.65679819800009],
              [58.75902795500008, 37.65615224300011],
              [58.73773726400009, 37.65940785800008],
              [58.72636844900012, 37.65938201900009],
              [58.71923710200008, 37.654782817000054],
              [58.71293257600007, 37.64881418900002],
              [58.70425093600011, 37.64462839700009],
              [58.681720011000095, 37.64271637000006],
              [58.65908573400014, 37.64540354500009],
              [58.6158842370001, 37.65951121100004],
              [58.56565474400014, 37.69485789000002],
              [58.549324992000095, 37.70157582700004],
              [58.52979130000011, 37.70038726800003],
              [58.51428837100008, 37.691473084],
              [58.502299439000126, 37.67739125600009],
              [58.49310103400012, 37.660673931000034],
              [58.47966516100007, 37.644111634000055],
              [58.46230188000004, 37.63749705100004],
              [58.371764770000084, 37.63036570300001],
              [58.357812134000085, 37.6333112600001],
              [58.33145715300003, 37.64829742500008],
              [58.3188481040001, 37.65305165600007],
              [58.24092004400012, 37.662327576000095],
              [58.223866822000105, 37.66746938100009],
              [58.20681359900004, 37.67873484300004],
              [58.20195601400013, 37.69010365800004],
              [58.20185266200008, 37.7039529420001],
              [58.19926883900007, 37.722194723000044],
              [58.19575484200004, 37.72963612900007],
              [58.17994185400005, 37.753045553000035],
              [58.17911503100004, 37.76077117900003],
              [58.181285441000114, 37.767928366],
              [58.18118208800007, 37.77485300700006],
              [58.1735339760001, 37.78162262000011],
              [58.156687459000125, 37.788185527000095],
              [58.14056441300005, 37.791131083],
              [58.1068713790001, 37.793430685000104],
              [58.04093225100007, 37.80570383800004],
              [57.884145955000065, 37.86533844000006],
              [57.84952274600005, 37.87272817000006],
              [57.833296346000054, 37.87174631800009],
              [57.81644982900008, 37.86864573200005],
              [57.80001672300011, 37.86763804200008],
              [57.78503055900006, 37.8725731410001],
              [57.779139445000055, 37.87877431200009],
              [57.77004439300009, 37.8938896690001],
              [57.76301639900004, 37.899393209],
              [57.75474816900004, 37.90102101600006],
              [57.73841841600006, 37.89799794500003],
              [57.734827150000115, 37.89827166900004],
              [57.72994348100008, 37.898643900000096],
              [57.717127727000104, 37.90507761600004],
              [57.70462203000011, 37.913707581],
              [57.69118615700006, 37.92027048800007],
              [57.676096639000036, 37.920477193000025],
              [57.661110474000054, 37.917428284],
              [57.612327922000134, 37.91660146100007],
              [57.56137495900009, 37.92822865900003],
              [57.54463179500004, 37.9299856570001],
              [57.52768192500014, 37.927841085000026],
              [57.51207564300006, 37.924068705000096],
              [57.49626265400008, 37.92231170700002],
              [57.352395467000065, 37.967528585000096],
              [57.32707401500011, 37.994116110000036],
              [57.34681441200007, 38.046929424],
              [57.34929488100005, 38.06356923400001],
              [57.344333943000095, 38.081061707000075],
              [57.3229399010001, 38.10511708600011],
              [57.31136438000004, 38.1350119020001],
              [57.27860152200003, 38.162943014000106],
              [57.26692264800005, 38.176895651],
              [57.24883589700005, 38.211518861000016],
              [57.2257882080001, 38.24236969100009],
              [57.221550741000044, 38.25115468400007],
              [57.221137329000044, 38.2585960900001],
              [57.2183468020001, 38.26508148200007],
              [57.20728804600009, 38.27074005200011],
              [57.185894002000055, 38.276476136000056],
              [57.174938599000086, 38.27756134000005],
              [57.16398319500007, 38.276476136000056],
              [57.14661991300011, 38.26980987600005],
              [57.13791423900011, 38.262364232000024],
              [57.13483768800006, 38.259732971000105],
              [57.1146838790001, 38.232111918],
              [57.102798299000085, 38.22200917600007],
              [57.070448852000084, 38.20505930600005],
              [57.056496216000085, 38.19524078400009],
              [57.038409465000086, 38.18728261300002],
              [57.018048950000036, 38.189814759000015],
              [56.97836145000008, 38.202733866000116],
              [56.82787967900009, 38.22495473300005],
              [56.812376750000055, 38.22895965600004],
              [56.77816695200005, 38.24448842400007],
              [56.73899621600003, 38.26960317],
              [56.72938439900014, 38.271050110000076],
              [56.6815320230001, 38.26461639400013],
              [56.60133020000012, 38.2368661500001],
              [56.585207154000045, 38.234566549000064],
              [56.57177128100011, 38.23950164800003],
              [56.55916223100007, 38.247382304000055],
              [56.545209595000074, 38.254100240000085],
              [56.528156372000126, 38.25740753200007],
              [56.43648238100013, 38.25508209200005],
              [56.40010217300005, 38.244126689000055],
              [56.3664091390001, 38.22552317400003],
              [56.30336389200005, 38.1794277960001],
              [56.29705936700003, 38.16578521700008],
              [56.32424117000005, 38.14113555900009],
              [56.32899540200003, 38.12377227800006],
              [56.32548140400007, 38.105220439000036],
              [56.315456177000044, 38.08945912700004],
              [56.299746541000104, 38.080234884000035],
              [56.214067017000104, 38.06884023100004],
              [56.19784061700011, 38.07064890600013],
              [56.1667406250001, 38.08079215000005],
              [56.16187382000004, 38.08237945600003],
              [56.12146285000006, 38.086461894000124],
              [55.978422486000056, 38.065894674000035],
              [55.963022909000074, 38.0665147910001],
              [55.949070272000085, 38.07008046500009],
              [55.92188846900012, 38.08144928000006],
              [55.90504195200003, 38.085583395000086],
              [55.854088989000104, 38.0859968060001],
              [55.83941288200003, 38.08992421500007],
              [55.800345500000105, 38.10780426000012],
              [55.738437134000094, 38.11860463500007],
              [55.708671509000055, 38.118656311000066],
              [55.51095747900007, 38.085841776000066],
              [55.44739546700009, 38.083671367000065],
              [55.42310754400012, 38.075894063000064],
              [55.3487968340001, 38.03049631800012],
              [55.32812626100008, 38.02212473600004],
              [55.30745568800006, 38.00879221600003],
              [55.29608687400008, 38.007551982000095],
              [55.25050826000012, 37.995408020000085],
              [55.228804159000106, 37.98579620400007],
              [55.21970910600004, 37.969983215000084],
              [55.20741011500007, 37.96615916000003],
              [55.14963586400006, 37.95747751900008],
              [55.13030887800005, 37.952309876000086],
              [55.12173059100013, 37.94471344000003],
              [55.110775187000115, 37.92647165900006],
              [55.10354048700009, 37.91879770900006],
              [55.092791789000046, 37.91554209400009],
              [55.07873579900013, 37.913707581],
              [55.066643514000134, 37.90843658500005],
              [55.0613725180001, 37.89484568300007],
              [55.05351770100009, 37.884407043000024],
              [55.00680220600009, 37.84309173600009],
              [54.85663049300007, 37.76113291500003],
              [54.82665816200006, 37.73526886000009],
              [54.81363570200011, 37.718629049000086],
              [54.808158000000105, 37.70281606100009],
              [54.80371382600009, 37.68292063400007],
              [54.78728072100006, 37.65186309800005],
              [54.78831425000004, 37.63080495200002],
              [54.79182824800006, 37.62535308900006],
              [54.80361047300005, 37.616929831000064],
              [54.808158000000105, 37.61034108500006],
              [54.80939823400013, 37.60333892900006],
              [54.808158000000105, 37.57928355000003],
              [54.80505741300004, 37.56504669200005],
              [54.79141483600006, 37.53993194600004],
              [54.78831425000004, 37.52463572200007],
              [54.783663371000046, 37.51745269800004],
              [54.75834191900009, 37.50055450500004],
              [54.710799601000076, 37.47569814100008],
              [54.69829390500007, 37.46629303000013],
              [54.67855350800011, 37.45998850500011],
              [54.65395552600012, 37.43890452100008],
              [54.638969361000136, 37.43327179000006],
              [54.616851847000135, 37.433013407000075],
              [54.555977010000106, 37.44360707700007],
              [54.53334273300004, 37.440816549000104],
              [54.36415409400007, 37.36268178400006],
              [54.32849735500008, 37.353276673000025],
              [54.30637984200007, 37.353224996],
              [54.28333215400011, 37.35565378900007],
              [54.26152469900006, 37.35482696500004],
              [54.243024536000064, 37.344956767000056],
              [54.22452437300012, 37.3307457480001],
              [54.206437622000124, 37.324596253000024],
              [54.18659387300005, 37.323743591],
              [53.91374759200005, 37.34275950700004],
              [53.91374759200005, 37.343003648000035],
              [53.89966881600009, 37.468410549000055],
              [53.88982181100005, 37.50812409100007],
              [53.871104363000086, 37.54779694200005],
              [53.865244988000086, 37.567287502000056],
              [53.86060631600009, 37.611314195000034],
              [53.824880405000044, 37.74485911700009],
              [53.80713951900003, 38.03196849200009],
              [53.81031334700003, 38.04840729400007],
              [53.82398522200003, 38.08152903900009],
              [53.83415774800005, 38.13027578300006],
              [53.85889733200008, 38.20648834800005],
              [53.85499108200008, 38.233710028000075],
              [53.86646569100009, 38.26508209800005],
              [53.868174675000034, 38.30801015800006],
              [53.86304772200003, 38.38141510600008],
              [53.86150149800005, 38.38934967700004],
              [53.852549675000034, 38.40330638200004],
              [53.84815514400003, 38.41250234600005],
              [53.84555097700007, 38.422308661000045],
              [53.84343509200005, 38.442694403000075],
              [53.82829837300005, 38.503566799000055],
              [53.82699629000007, 38.525458075000074],
              [53.83611087300005, 38.60614655200004],
              [53.84742272200003, 38.64630768400008],
              [53.86304772200003, 38.679388739000046],
              [53.90984134200005, 38.73769765800006],
              [53.92693118600005, 38.77366771000004],
              [53.917002800000034, 38.80353424700007],
              [53.931976759000065, 38.81305573100008],
              [53.939789259000065, 38.83104075700004],
              [53.94556725400008, 38.85130442900004],
              [53.95460045700008, 38.86774323100008],
              [53.965586785000085, 38.88190338700008],
              [53.977549675000034, 38.90176015800006],
              [53.982758009000065, 38.916001695000034],
              [53.97291100400008, 38.913397528000075],
              [53.971364780000044, 38.93427155200004],
              [53.958018425000034, 38.944525458000044],
              [53.92318769600007, 38.954331773000035],
              [53.922862175000034, 38.95604075700004],
              [53.91879316500007, 38.96478913000004],
              [53.917002800000034, 38.96735260600008],
              [53.91228274800005, 38.96967194200005],
              [53.89975019600007, 38.97284577000005],
              [53.89665774800005, 38.97418854400007],
              [53.89177493600005, 38.980536200000074],
              [53.88721764400003, 38.98859284100007],
              [53.88404381600009, 38.998114325000074],
              [53.88233483200008, 39.008978583000044],
              [53.87094160200007, 39.02838776200008],
              [53.859711134000065, 39.035223700000074],
              [53.82081139400003, 39.03628164300005],
              [53.79664147200003, 39.04165273600006],
              [53.78736412900008, 39.04246653900009],
              [53.77686608200008, 39.039129950000074],
              [53.772146030000044, 39.03310781500005],
              [53.76726321700005, 39.03099192900004],
              [53.75635826900003, 39.03937409100007],
              [53.74781334700003, 39.05442942900004],
              [53.72803795700008, 39.10138580900008],
              [53.72185306100005, 39.111395575000074],
              [53.71216881600009, 39.10431549700007],
              [53.715179884000065, 39.08856842700004],
              [53.72413170700008, 39.07208893400008],
              [53.73210696700005, 39.062933661000045],
              [53.73210696700005, 39.056708075000074],
              [53.71599368600005, 39.06342194200005],
              [53.701508009000065, 39.07851797100005],
              [53.69467207100007, 39.09711334800005],
              [53.70533287900008, 39.124212958000044],
              [53.697276238000086, 39.14248281500005],
              [53.698008660000085, 39.152329820000034],
              [53.70394941500007, 39.158636786000045],
              [53.73210696700005, 39.17279694200005],
              [53.70240319100009, 39.175116278000075],
              [53.702159050000034, 39.19623444200005],
              [53.724619988000086, 39.24168528900009],
              [53.70394941500007, 39.23273346600007],
              [53.67628014400003, 39.21621328300006],
              [53.66000410200007, 39.200384833000044],
              [53.67408287900008, 39.19330475500004],
              [53.68376712300005, 39.08344147300005],
              [53.67212975400008, 39.09857819200005],
              [53.64730879000007, 39.12396881700005],
              [53.63599694100009, 39.138657945000034],
              [53.63135826900003, 39.15664297100005],
              [53.63021894600007, 39.17674388200004],
              [53.623383009000065, 39.19163646000004],
              [53.60173587300005, 39.19330475500004],
              [53.60694420700008, 39.20587799700007],
              [53.610362175000034, 39.221909898000035],
              [53.60857181100005, 39.23578522300005],
              [53.598317905000044, 39.24168528900009],
              [53.592784050000034, 39.23505280200004],
              [53.57667076900003, 39.20343659100007],
              [53.56763756600009, 39.19330475500004],
              [53.56397545700008, 39.21670156500005],
              [53.568695509000065, 39.24632396000004],
              [53.58814537900008, 39.303168036000045],
              [53.56080162900008, 39.28266022300005],
              [53.57732181100005, 39.31671784100007],
              [53.58130944100009, 39.33047109600005],
              [53.574554884000065, 39.32786692900004],
              [53.55396569100009, 39.32367584800005],
              [53.56495201900003, 39.34516022300005],
              [53.56202233200008, 39.35333893400008],
              [53.549815300000034, 39.34833405200004],
              [53.53345787900008, 39.33047109600005],
              [53.526133660000085, 39.337876695000034],
              [53.51482181100005, 39.33270905200004],
              [53.471446160000085, 39.33047109600005],
              [53.45248457100007, 39.318060614000046],
              [53.443369988000086, 39.318793036000045],
              [53.444102410000085, 39.337876695000034],
              [53.43726647200003, 39.337876695000034],
              [53.429698113000086, 39.32786692900004],
              [53.41879316500007, 39.318060614000046],
              [53.40512129000007, 39.31126536700009],
              [53.389414910000085, 39.310614325000074],
              [53.39429772200003, 39.31704336100006],
              [53.40316816500007, 39.337876695000034],
              [53.39616946700005, 39.33820221600007],
              [53.38200931100005, 39.337103583000044],
              [53.37517337300005, 39.337876695000034],
              [53.373789910000085, 39.33665599200009],
              [53.36548912900008, 39.33161041900007],
              [53.36158287900008, 39.33047109600005],
              [53.35857181100005, 39.33270905200004],
              [53.351573113000086, 39.342230536000045],
              [53.34791100400008, 39.34414297100005],
              [53.334646030000044, 39.34052155200004],
              [53.30909264400003, 39.33075592700004],
              [53.293304884000065, 39.33047109600005],
              [53.293304884000065, 39.337876695000034],
              [53.299489780000044, 39.34516022300005],
              [53.296885613000086, 39.34906647300005],
              [53.28825931100005, 39.35065338700008],
              [53.276133660000085, 39.35097890800006],
              [53.264659050000034, 39.352850653000075],
              [53.24952233200008, 39.36180247600004],
              [53.238617384000065, 39.36465078300006],
              [53.21851647200003, 39.36383698100008],
              [53.17017662900008, 39.35248444200005],
              [53.14991295700008, 39.34414297100005],
              [53.185883009000065, 39.32636139500005],
              [53.19776451900003, 39.32367584800005],
              [53.17953535200007, 39.30125560100004],
              [53.17302493600005, 39.288316148000035],
              [53.170258009000065, 39.27216217700004],
              [53.17212975400008, 39.25543854400007],
              [53.18409264400003, 39.21381256700005],
              [53.18148847700007, 39.18935781500005],
              [53.171885613000086, 39.17747630400004],
              [53.16146894600007, 39.17959219000005],
              [53.13689212300005, 39.32143789300005],
              [53.13054446700005, 39.33348216400009],
              [53.08871504000007, 39.383246161000045],
              [53.08521569100009, 39.400458075000074],
              [53.094737175000034, 39.41986725500004],
              [53.10401451900003, 39.429348049000055],
              [53.132823113000086, 39.45058828300006],
              [53.137461785000085, 39.45994700700004],
              [53.14087975400008, 39.472642320000034],
              [53.14535566500007, 39.48395416900007],
              [53.16553795700008, 39.49673086100006],
              [53.17823326900003, 39.515692450000074],
              [53.21461022200003, 39.59349192900004],
              [53.24170983200008, 39.63629791900007],
              [53.27588951900003, 39.66486237200007],
              [53.31373131600009, 39.65884023600006],
              [53.29273522200003, 39.64984772300005],
              [53.277354363000086, 39.63922760600008],
              [53.24854576900003, 39.60789622600004],
              [53.24439537900008, 39.599676825000074],
              [53.23519941500007, 39.57070547100005],
              [53.232432488000086, 39.56753164300005],
              [53.211273634000065, 39.55019765800006],
              [53.21697024800005, 39.525051174000055],
              [53.25407962300005, 39.521185614000046],
              [53.36353600400008, 39.53807200700004],
              [53.426768425000034, 39.53595612200007],
              [53.44678795700008, 39.530585028000075],
              [53.45875084700003, 39.51780833500004],
              [53.467539910000085, 39.50234609600005],
              [53.47828209700003, 39.488714911000045],
              [53.492198113000086, 39.48078034100007],
              [53.50912519600007, 39.47650788000004],
              [53.55054772200003, 39.47451406500005],
              [53.56788170700008, 39.46771881700005],
              [53.577159050000034, 39.46784088700008],
              [53.58130944100009, 39.47793203300006],
              [53.58057701900003, 39.487982489000046],
              [53.57740319100009, 39.49526601800005],
              [53.571299675000034, 39.49982330900008],
              [53.56080162900008, 39.50177643400008],
              [53.57374108200008, 39.52728913000004],
              [53.58611087300005, 39.523871161000045],
              [53.59945722700007, 39.50775788000004],
              [53.61540774800005, 39.49494049700007],
              [53.63445071700005, 39.495306708000044],
              [53.66358483200008, 39.51732005400004],
              [53.68376712300005, 39.52220286700009],
              [53.69288170700008, 39.51947663000004],
              [53.71599368600005, 39.50926341400009],
              [53.724619988000086, 39.50861237200007],
              [53.73617597700007, 39.51788971600007],
              [53.733164910000085, 39.52798086100006],
              [53.72250410200007, 39.53705475500004],
              [53.711599155000044, 39.543402411000045],
              [53.68930097700007, 39.550441799000055],
              [53.647146030000044, 39.558254299000055],
              [53.62916100400008, 39.57070547100005],
              [53.645274285000085, 39.57489655200004],
              [53.654633009000065, 39.582098700000074],
              [53.65552819100009, 39.59292226800005],
              [53.646494988000086, 39.60789622600004],
              [53.63306725400008, 39.61831289300005],
              [53.61963951900003, 39.62051015800006],
              [53.57162519600007, 39.616400458000044],
              [53.56820722700007, 39.62262604400007],
              [53.56763756600009, 39.64240143400008],
              [53.564463738000086, 39.65265534100007],
              [53.55648847700007, 39.664496161000045],
              [53.545664910000085, 39.67487213700008],
              [53.53345787900008, 39.68048737200007],
              [53.539724155000044, 39.64630768400008],
              [53.539724155000044, 39.632147528000075],
              [53.53345787900008, 39.632147528000075],
              [53.497080925000034, 39.67645905200004],
              [53.471039259000065, 39.69635651200008],
              [53.444102410000085, 39.70107656500005],
              [53.44776451900003, 39.69525788000004],
              [53.457774285000085, 39.673081773000035],
              [53.45167076900003, 39.676662502000056],
              [53.435883009000065, 39.68333567900004],
              [53.42986087300005, 39.686712958000044],
              [53.430430535000085, 39.66771067900004],
              [53.449229363000086, 39.64858633000006],
              [53.45093834700003, 39.632147528000075],
              [53.416758660000085, 39.64996979400007],
              [53.412852410000085, 39.68569570500006],
              [53.42986087300005, 39.76251862200007],
              [53.41822350400008, 39.75739166900007],
              [53.40577233200008, 39.75580475500004],
              [53.39340254000007, 39.757513739000046],
              [53.38200931100005, 39.76251862200007],
              [53.38200931100005, 39.76927317900004],
              [53.41521243600005, 39.78204987200007],
              [53.467539910000085, 39.83869049700007],
              [53.49927819100009, 39.86554596600007],
              [53.49382571700005, 39.87067291900007],
              [53.488291863000086, 39.88104889500005],
              [53.485036655000044, 39.88540273600006],
              [53.49382571700005, 39.88934967700004],
              [53.502696160000085, 39.89154694200005],
              [53.52271569100009, 39.89280833500004],
              [53.537119988000086, 39.89630768400008],
              [53.53695722700007, 39.90375397300005],
              [53.53077233200008, 39.91071198100008],
              [53.526133660000085, 39.91266510600008],
              [53.53728274800005, 39.92487213700008],
              [53.552744988000086, 39.93622467700004],
              [53.567067905000044, 39.94953034100007],
              [53.57447350400008, 39.96792226800005],
              [53.569102410000085, 39.96556224200009],
              [53.566416863000086, 39.964829820000034],
              [53.56421959700003, 39.96393463700008],
              [53.56080162900008, 39.96108633000006],
              [53.543630405000044, 39.974310614000046],
              [53.52881920700008, 39.97695547100005],
              [53.49187259200005, 39.97475820500006],
              [53.474945509000065, 39.97923411700009],
              [53.45199629000007, 39.99551015800006],
              [53.43726647200003, 40.00267161700009],
              [53.41960696700005, 40.00649648600006],
              [53.40211022200003, 40.00678131700005],
              [53.38526451900003, 40.00307851800005],
              [53.36890709700003, 39.99526601800005],
              [53.326833530000044, 39.958685614000046],
              [53.31031334700003, 39.95359935100004],
              [53.305674675000034, 39.95148346600007],
              [53.290049675000034, 39.94208405200004],
              [53.28272545700008, 39.94000885600008],
              [53.27491295700008, 39.94208405200004],
              [53.25709069100009, 39.95148346600007],
              [53.24854576900003, 39.95359935100004],
              [53.23755944100009, 39.95774974200009],
              [53.17237389400003, 39.99746328300006],
              [53.155284050000034, 39.99237702000005],
              [53.14039147200003, 39.98102448100008],
              [53.125743035000085, 39.97475820500006],
              [53.05355879000007, 39.96792226800005],
              [53.059255405000044, 39.97703685100004],
              [53.065114780000044, 39.984035549000055],
              [53.07243899800005, 39.98981354400007],
              [53.08171634200005, 39.99526601800005],
              [53.012461785000085, 39.97801341400009],
              [52.97486412900008, 39.974310614000046],
              [52.943695509000065, 39.98159414300005],
              [52.92750084700003, 40.01117584800005],
              [52.91358483200008, 40.02167389500005],
              [52.89600670700008, 40.00885651200008],
              [52.89584394600007, 39.99827708500004],
              [52.903086785000085, 39.98493073100008],
              [52.919932488000086, 39.964544989000046],
              [52.92359459700003, 39.95258209800005],
              [52.93018639400003, 39.89594147300005],
              [52.93604576900003, 39.887600002000056],
              [52.96452884200005, 39.85822174700007],
              [52.97486412900008, 39.85187409100007],
              [53.01254316500007, 39.79726797100005],
              [53.043711785000085, 39.774644273000035],
              [53.05355879000007, 39.76927317900004],
              [53.05355879000007, 39.76251862200007],
              [53.005869988000086, 39.78294505400004],
              [53.01937910200007, 39.77533600500004],
              [53.046885613000086, 39.74823639500005],
              [53.040049675000034, 39.74201080900008],
              [53.00806725400008, 39.76634349200009],
              [52.994883660000085, 39.78021881700005],
              [52.96631920700008, 39.83295319200005],
              [52.95264733200008, 39.84650299700007],
              [52.91716556100005, 39.85834381700005],
              [52.905284050000034, 39.87457916900007],
              [52.898448113000086, 39.89549388200004],
              [52.89283287900008, 39.93423086100006],
              [52.88412519600007, 39.94489166900007],
              [52.787852410000085, 40.004339911000045],
              [52.75326582100007, 40.03196849200009],
              [52.73845462300005, 40.053615627000056],
              [52.746104363000086, 40.096991278000075],
              [52.75375410200007, 40.121079820000034],
              [52.76197350400008, 40.13580963700008],
              [52.768321160000085, 40.15379466400009],
              [52.75806725400008, 40.17251211100006],
              [52.73096764400003, 40.20066966400009],
              [52.74341881600009, 40.20954010600008],
              [52.738942905000044, 40.21938711100006],
              [52.717784050000034, 40.23541901200008],
              [52.69898522200003, 40.273871161000045],
              [52.70199629000007, 40.31240469000005],
              [52.73658287900008, 40.48456452000005],
              [52.75025475400008, 40.517645575000074],
              [52.772471550000034, 40.55072663000004],
              [52.83253014400003, 40.614569403000075],
              [52.86312910200007, 40.65810781500005],
              [52.868174675000034, 40.69415924700007],
              [52.85922285200007, 40.70001862200007],
              [52.83318118600005, 40.70490143400008],
              [52.82764733200008, 40.71149323100008],
              [52.82984459700003, 40.72064850500004],
              [52.83757571700005, 40.73908112200007],
              [52.83725019600007, 40.74249909100007],
              [52.83253014400003, 40.74555084800005],
              [52.84522545700008, 40.751654364000046],
              [52.86158287900008, 40.75649648600006],
              [52.868174675000034, 40.755560614000046],
              [52.87037194100009, 40.76508209800005],
              [52.86882571700005, 40.77578359600005],
              [52.865244988000086, 40.78510163000004],
              [52.861989780000044, 40.790350653000075],
              [52.885508660000085, 40.86542389500005],
              [52.92335045700008, 40.94114817900004],
              [52.93132571700005, 40.97565338700008],
              [52.917002800000034, 41.044989325000074],
              [52.91651451900003, 41.085150458000044],
              [52.92725670700008, 41.07904694200005],
              [52.95142662900008, 41.068793036000045],
              [52.96119225400008, 41.060980536000045],
              [52.965505405000044, 41.04938385600008],
              [52.96306399800005, 41.03778717700004],
              [52.95875084700003, 41.02651601800005],
              [52.95818118600005, 41.01626211100006],
              [52.96843509200005, 40.99701569200005],
              [53.012054884000065, 40.954779364000046],
              [53.019867384000065, 40.937933661000045],
              [53.03174889400003, 40.89980703300006],
              [53.040049675000034, 40.885931708000044],
              [53.07203209700003, 40.86896393400008],
              [53.07447350400008, 40.86542389500005],
              [53.09978274800005, 40.86517975500004],
              [53.111338738000086, 40.86709219000005],
              [53.12191816500007, 40.872259833000044],
              [53.10629316500007, 40.858303127000056],
              [53.08187910200007, 40.85150788000004],
              [53.06470787900008, 40.84398021000004],
              [53.07081139400003, 40.82786692900004],
              [53.07797285200007, 40.82221100500004],
              [53.09400475400008, 40.81240469000005],
              [53.10206139400003, 40.803941148000035],
              [53.104258660000085, 40.794907945000034],
              [53.104258660000085, 40.78359609600005],
              [53.107432488000086, 40.77391185100004],
              [53.11890709700003, 40.76984284100007],
              [53.16325931100005, 40.76703522300005],
              [53.182302280000044, 40.768459377000056],
              [53.20460045700008, 40.77606842700004],
              [53.24976647200003, 40.812567450000074],
              [53.26587975400008, 40.81704336100006],
              [53.24935957100007, 40.790350653000075],
              [53.244883660000085, 40.77496979400007],
              [53.25603274800005, 40.76894765800006],
              [53.330821160000085, 40.77606842700004],
              [53.33952884200005, 40.78082916900007],
              [53.34115644600007, 40.79197825700004],
              [53.34115644600007, 40.80459219000005],
              [53.344493035000085, 40.81391022300005],
              [53.35922285200007, 40.829779364000046],
              [53.36996504000007, 40.835191148000035],
              [53.38200931100005, 40.831284898000035],
              [53.38306725400008, 40.82558828300006],
              [53.375987175000034, 40.807074286000045],
              [53.37517337300005, 40.79779694200005],
              [53.383799675000034, 40.77830638200004],
              [53.39869225400008, 40.76276276200008],
              [53.418304884000065, 40.75242747600004],
              [53.44068444100009, 40.74872467700004],
              [53.44695071700005, 40.746527411000045],
              [53.461273634000065, 40.73688385600008],
              [53.471446160000085, 40.73505280200004],
              [53.483083530000044, 40.73704661700009],
              [53.49187259200005, 40.74087148600006],
              [53.50554446700005, 40.74872467700004],
              [53.541677280000044, 40.76162344000005],
              [53.555349155000044, 40.773504950000074],
              [53.56080162900008, 40.79401276200008],
              [53.55909264400003, 40.836818752000056],
              [53.56275475400008, 40.85297272300005],
              [53.58741295700008, 40.89158763200004],
              [53.592784050000034, 40.89337799700007],
              [53.605479363000086, 40.89337799700007],
              [53.61475670700008, 40.89154694200005],
              [53.62468509200005, 40.88703034100007],
              [53.63257897200003, 40.881293036000045],
              [53.63599694100009, 40.87604401200008],
              [53.63892662900008, 40.87201569200005],
              [53.65284264400003, 40.86786530200004],
              [53.656993035000085, 40.86542389500005],
              [53.65748131600009, 40.859076239000046],
              [53.65455162900008, 40.85293203300006],
              [53.65088951900003, 40.84784577000005],
              [53.64958743600005, 40.844916083000044],
              [53.65512129000007, 40.823879299000055],
              [53.66032962300005, 40.81622955900008],
              [53.670664910000085, 40.81077708500004],
              [53.662119988000086, 40.79661692900004],
              [53.65674889400003, 40.78974030200004],
              [53.64958743600005, 40.78351471600007],
              [53.66098066500007, 40.76618073100008],
              [53.676442905000044, 40.725897528000075],
              [53.69117272200003, 40.70783112200007],
              [53.701182488000086, 40.703111070000034],
              [53.71119225400008, 40.70164622600004],
              [53.719493035000085, 40.69830963700008],
              [53.724619988000086, 40.687933661000045],
              [53.72201582100007, 40.68073151200008],
              [53.708018425000034, 40.65900299700007],
              [53.70476321700005, 40.650091864000046],
              [53.721039259000065, 40.62567780200004],
              [53.75953209700003, 40.62567780200004],
              [53.80486087300005, 40.63263580900008],
              [53.86264082100007, 40.626166083000044],
              [53.87916100400008, 40.637925523000035],
              [53.89478600400008, 40.65306224200009],
              [53.93775475400008, 40.67161692900004],
              [53.94776451900003, 40.67365143400008],
              [53.95785566500007, 40.67210521000004],
              [53.985362175000034, 40.660589911000045],
              [54.010752800000034, 40.657863674000055],
              [54.03052819100009, 40.66282786700009],
              [54.04908287900008, 40.669989325000074],
              [54.08033287900008, 40.67609284100007],
              [54.08814537900008, 40.68219635600008],
              [54.09327233200008, 40.69009023600006],
              [54.09522545700008, 40.69782135600008],
              [54.08961022200003, 40.698919989000046],
              [54.063243035000085, 40.70848216400009],
              [54.05420983200008, 40.715277411000045],
              [54.112071160000085, 40.71344635600008],
              [54.141368035000085, 40.716864325000074],
              [54.17107181100005, 40.729681708000044],
              [54.23218834700003, 40.72833893400008],
              [54.235036655000044, 40.72573476800005],
              [54.230479363000086, 40.71938711100006],
              [54.220713738000086, 40.695379950000074],
              [54.217539910000085, 40.69025299700007],
              [54.221690300000034, 40.68707916900007],
              [54.252696160000085, 40.67658112200007],
              [54.40357506600009, 40.67365143400008],
              [54.38396243600005, 40.68276601800005],
              [54.36264082100007, 40.687933661000045],
              [54.37517337300005, 40.70091380400004],
              [54.41488691500007, 40.70872630400004],
              [54.430430535000085, 40.72142161700009],
              [54.331065300000034, 40.72020091400009],
              [54.31820722700007, 40.72162506700005],
              [54.310557488000086, 40.73065827000005],
              [54.30811608200008, 40.75214264500005],
              [54.30388431100005, 40.77008698100008],
              [54.28500410200007, 40.79743073100008],
              [54.27857506600009, 40.82363515800006],
              [54.26880944100009, 40.839911200000074],
              [54.26644941500007, 40.84833405200004],
              [54.268321160000085, 40.85504791900007],
              [54.27198326900003, 40.85984935100004],
              [54.27458743600005, 40.864894924000055],
              [54.27328535200007, 40.872259833000044],
              [54.26710045700008, 40.87417226800005],
              [54.25709069100009, 40.873114325000074],
              [54.24830162900008, 40.874986070000034],
              [54.24594160200007, 40.885931708000044],
              [54.250010613000086, 40.890611070000034],
              [54.25749759200005, 40.89142487200007],
              [54.26612389400003, 40.89134349200003],
              [54.27328535200007, 40.89337799700007],
              [54.29900149800005, 40.916083075000074],
              [54.312510613000086, 40.923895575000074],
              [54.33171634200005, 40.92690664300005],
              [54.36052493600005, 40.91705963700008],
              [54.42115319100009, 40.87986888200004],
              [54.437836134000065, 40.87970612200007],
              [54.465830925000034, 40.86595286700003],
              [54.468760613000086, 40.851629950000074],
              [54.45630944100009, 40.835638739000046],
              [54.437836134000065, 40.81704336100006],
              [54.474945509000065, 40.809881903000075],
              [54.59066816500007, 40.82672760600008],
              [54.62435957100007, 40.83649323100008],
              [54.63990319100009, 40.838771877000056],
              [54.65756269600007, 40.86200592700004],
              [54.699554884000065, 40.87909577000005],
              [54.708994988000086, 40.88499583500004],
              [54.74659264400003, 40.93268463700008],
              [54.75603274800005, 40.948431708000044],
              [54.76002037900008, 40.96503327000005],
              [54.756195509000065, 40.98159414300005],
              [54.746836785000085, 40.99567291900007],
              [54.72201582100007, 41.019964911000045],
              [54.690114780000044, 41.05923086100006],
              [54.67798912900008, 41.06464264500005],
              [54.67798912900008, 41.07086823100008],
              [54.70053144600007, 41.06830475500004],
              [54.72437584700003, 41.05927155200004],
              [54.76742597700007, 41.036769924000055],
              [54.76091556100005, 41.04547760600008],
              [54.740977410000085, 41.057847398000035],
              [54.73259524800005, 41.06464264500005],
              [54.72388756600009, 41.07485586100006],
              [54.72006269600007, 41.08047109600005],
              [54.71843509200005, 41.085150458000044],
              [54.71989993600005, 41.09198639500005],
              [54.72429446700005, 41.09804922100005],
              [54.729258660000085, 41.10097890800006],
              [54.73259524800005, 41.09813060100004],
              [54.71607506600009, 41.11517975500004],
              [54.68873131600009, 41.12124258000006],
              [54.65935306100005, 41.12445709800005],
              [54.63640384200005, 41.13296133000006],
              [54.63502037900008, 41.16266510600008],
              [54.60043379000007, 41.19232819200005],
              [54.400401238000086, 41.309027411000045],
              [54.31177819100009, 41.33828359600005],
              [54.29476972700007, 41.34747955900008],
              [54.25806725400008, 41.37596263200004],
              [54.21143639400003, 41.395819403000075],
              [54.19076582100007, 41.40729401200008],
              [54.18604576900003, 41.412543036000045],
              [54.17497806100005, 41.429388739000046],
              [54.15284264400003, 41.45425039300005],
              [54.14478600400008, 41.45978424700007],
              [54.10865319100009, 41.46548086100006],
              [54.08936608200008, 41.47479889500005],
              [54.07398522200003, 41.487982489000046],
              [54.06104576900003, 41.50287506700005],
              [54.041351759000065, 41.53457265800006],
              [54.030284050000034, 41.56948476800005],
              [54.02588951900003, 41.60879140800006],
              [54.02556399800005, 41.69521719000005],
              [54.01970462300005, 41.73151276200008],
              [54.008555535000085, 41.764837958000044],
              [53.992198113000086, 41.79706452000005],
              [53.94459069100009, 41.85834381700005],
              [53.93685957100007, 41.876206773000035],
              [53.932302280000044, 41.88426341400009],
              [53.92172285200007, 41.88743724200003],
              [53.91032962300005, 41.88930898600006],
              [53.90284264400003, 41.89329661700003],
              [53.898773634000065, 41.90534088700008],
              [53.90162194100009, 41.91461823100008],
              [53.906911655000044, 41.923529364000046],
              [53.910166863000086, 41.93427155200004],
              [53.90935306100005, 41.940619208000044],
              [53.90406334700003, 41.96051666900007],
              [53.90284264400003, 41.97211334800005],
              [53.914805535000085, 41.99555084800005],
              [53.917002800000034, 42.00690338700008],
              [53.91627037900008, 42.023504950000074],
              [53.91325931100005, 42.043402411000045],
              [53.906911655000044, 42.062933661000045],
              [53.89665774800005, 42.07884349200003],
              [53.865570509000065, 42.10175202000005],
              [53.818695509000065, 42.12441640800006],
              [53.767914259000065, 42.13613515800006],
              [53.724619988000086, 42.12604401200008],
              [53.68181399800005, 42.14394765800006],
              [53.37517337300005, 42.105536200000074],
              [53.31657962300005, 42.08226146000004],
              [53.29672285200007, 42.07884349200003],
              [53.219737175000034, 42.08144765800006],
              [53.16382897200003, 42.10370514500005],
              [53.12191816500007, 42.08999258000006],
              [53.08448326900003, 42.064520575000074],
              [53.06039472700007, 42.044134833000044],
              [52.96029707100007, 41.984361070000034],
              [52.93702233200008, 41.95538971600007],
              [52.82146243600005, 41.764878648000035],
              [52.80404707100007, 41.74485911700003],
              [52.78956139400003, 41.73627350500004],
              [52.78207441500007, 41.72553131700005],
              [52.773773634000065, 41.70132070500006],
              [52.76921634200005, 41.67560455900008],
              [52.772471550000034, 41.66054922100005],
              [52.78467858200008, 41.66307200700004],
              [52.81568444100009, 41.69383372600004],
              [52.830821160000085, 41.70148346600007],
              [52.88054446700005, 41.69790273600006],
              [52.90381920700008, 41.68976471600007],
              [52.91651451900003, 41.67422109600005],
              [52.91537519600007, 41.66079336100006],
              [52.89991295700008, 41.640326239000046],
              [52.89600670700008, 41.62954336100006],
              [52.897146030000044, 41.61945221600007],
              [52.90186608200008, 41.59983958500004],
              [52.90284264400003, 41.58852773600006],
              [52.89893639400003, 41.56598541900007],
              [52.832692905000044, 41.437486070000034],
              [52.82764733200008, 41.417181708000044],
              [52.81568444100009, 41.388739325000074],
              [52.813487175000034, 41.379339911000045],
              [52.815440300000034, 41.36953359600005],
              [52.82764733200008, 41.344631252000056],
              [52.83725019600007, 41.30292389500005],
              [52.84400475400008, 41.24017975500004],
              [52.85132897200003, 41.22357819200005],
              [52.90398196700005, 41.14020416900007],
              [52.90967858200008, 41.122707424000055],
              [52.904307488000086, 41.101996161000045],
              [52.88306725400008, 41.07249583500004],
              [52.88233483200008, 41.050441799000055],
              [52.87549889400003, 41.050441799000055],
              [52.86996504000007, 41.06000397300005],
              [52.85401451900003, 41.07050202000005],
              [52.848317905000044, 41.07770416900007],
              [52.846690300000034, 41.08869049700007],
              [52.854502800000034, 41.11933014500005],
              [52.85466556100005, 41.14252350500004],
              [52.85108483200008, 41.163316148000035],
              [52.844086134000065, 41.18256256700005],
              [52.83383222700007, 41.201239325000074],
              [52.82927493600005, 41.20648834800005],
              [52.81666100400008, 41.21784088700008],
              [52.813487175000034, 41.22174713700008],
              [52.81104576900003, 41.233710028000075],
              [52.81373131600009, 41.25267161700003],
              [52.813487175000034, 41.26264069200005],
              [52.79127037900008, 41.32127513200004],
              [52.78956139400003, 41.33100006700005],
              [52.77711022200003, 41.339544989000046],
              [52.76099694100009, 41.37759023600006],
              [52.74529056100005, 41.38617584800005],
              [52.73194420700008, 41.38825104400007],
              [52.723399285000085, 41.394232489000046],
              [52.719086134000065, 41.403957424000055],
              [52.717784050000034, 41.417181708000044],
              [52.715830925000034, 41.42641836100006],
              [52.71029707100007, 41.43227773600006],
              [52.69361412900008, 41.444525458000044],
              [52.682383660000085, 41.45034414300005],
              [52.65593509200005, 41.45335521000004],
              [52.64625084700003, 41.458197333000044],
              [52.611664259000065, 41.49237702000005],
              [52.59392337300005, 41.50263092700004],
              [52.57536868600005, 41.50873444200005],
              [52.56218509200005, 41.51947663000004],
              [52.56023196700005, 41.543850002000056],
              [52.563487175000034, 41.546210028000075],
              [52.58415774800005, 41.57461172100005],
              [52.58773847700007, 41.58270905200004],
              [52.588633660000085, 41.594183661000045],
              [52.58757571700005, 41.61615631700005],
              [52.58912194100009, 41.62319570500006],
              [52.59522545700008, 41.63373444200005],
              [52.59555097700007, 41.64004140800006],
              [52.592539910000085, 41.645738023000035],
              [52.58773847700007, 41.64956289300005],
              [52.583018425000034, 41.652004299000055],
              [52.580739780000044, 41.65371328300006],
              [52.57252037900008, 41.67377350500004],
              [52.567149285000085, 41.681708075000074],
              [52.56023196700005, 41.68781159100007],
              [52.55290774800005, 41.68964264500005],
              [52.53663170700008, 41.687933661000045],
              [52.52955162900008, 41.69122955900008],
              [52.519867384000065, 41.70209381700005],
              [52.51449629000007, 41.70693594000005],
              [52.498789910000085, 41.712103583000044],
              [52.48357181100005, 41.726263739000046],
              [52.474619988000086, 41.72943756700005],
              [52.450205925000034, 41.734808661000045],
              [52.43767061735559, 41.74887574142544],
              [52.47884281400013, 41.78034495100009],
              [52.631443319000084, 41.894239807000034],
              [52.76435510300007, 41.993484395000095],
              [52.764665161000096, 41.993587748000024],
              [52.764665161000096, 41.99376861600008],
              [52.97870894400012, 42.12662872300008],
              [53.135081828000125, 42.167840678000076],
              [53.1917191980001, 42.19303293900002],
              [53.412274210000135, 42.258171082],
              [53.47842004400013, 42.26866139800005],
              [53.654429972000116, 42.292484233000025],
              [53.807598917000064, 42.31307729100003],
              [54.04717085800013, 42.3454008990001],
              [54.12261844900013, 42.337597758000086],
              [54.19527551300007, 42.318064067000094],
              [54.35051151600004, 42.24091115300003],
              [54.51897668400005, 42.1572728470001],
              [54.61964237500007, 42.107198385000075],
              [54.73829146300011, 42.04820973700005],
              [54.90706669100007, 41.93214447100003],
              [54.930837850000046, 41.909225973],
              [54.940759725000134, 41.88961476700008],
              [54.940553019000106, 41.87271657400008],
              [54.93641890400005, 41.855275778000035],
              [54.934971964000056, 41.83372670600009],
              [54.94024296100008, 41.8135987350001],
              [54.95068160000005, 41.7955636600001],
              [55.05475793500011, 41.69001454700013],
              [55.10002648900013, 41.644151714000074],
              [55.16493208800006, 41.557464498000016],
              [55.228390748000095, 41.47281850200004],
              [55.25918990100007, 41.44465484600006],
              [55.294123169000045, 41.421503805000086],
              [55.35675500500008, 41.38905100500007],
              [55.372567993000075, 41.3755634570001],
              [55.38466027800007, 41.35856191000009],
              [55.41266890400004, 41.307919007000024],
              [55.42951542100013, 41.29081410700006],
              [55.45028934800007, 41.27887685200004],
              [55.4782979740001, 41.266784567000045],
              [55.509303834000036, 41.258878073000105],
              [55.63549768100012, 41.264355774000094],
              [55.6944088140001, 41.281564026000055],
              [55.78732303900006, 41.291692607000115],
              [55.876619914000116, 41.324507141000126],
              [55.91010624200004, 41.32662587600002],
              [55.978422486000056, 41.32171661400007],
              [56.14068648300008, 41.315153707],
              [56.32682499200013, 41.30745391900008],
              [56.53372131600014, 41.29896879500005],
              [56.5700142820001, 41.29748036700009],
              [56.793463176000046, 41.2883336390001],
              [56.8879276940001, 41.27334747400003],
              [57.01019413200004, 41.254123841000094],
              [57.02952111800005, 41.262598776000104],
              [57.060320272000126, 41.30492177400002],
              [57.08006066900009, 41.322026672000064],
              [57.12667281100005, 41.339596660000026],
              [57.14796350100005, 41.35106882700005],
              [57.15922896300003, 41.36114573200008],
              [57.1613993740001, 41.36796702100004],
              [57.15375126100014, 41.37235951800004],
              [57.103625122000096, 41.38160959900004],
              [57.08832889800004, 41.387294007],
              [57.07416955500008, 41.394993795000076],
              [57.05225874800004, 41.41359731100003],
              [57.03303511500013, 41.43824696900005],
              [57.01959924300007, 41.46594553700005],
              [57.01505171700012, 41.49364410400007],
              [57.01577518700003, 41.52899078400007],
              [57.01205448400003, 41.55782623300003],
              [57.00058231600008, 41.58402618400005],
              [56.97836145000008, 41.61146637000009],
              [56.96048140500011, 41.6472006230001],
              [56.96161828600003, 41.678723247000065],
              [56.969473104000144, 41.71089182500002],
              [56.97195357300012, 41.748538106000055],
              [56.94983605900012, 41.8274996950001],
              [56.95014611800008, 41.86605031400008],
              [56.97836145000008, 41.89511830600007],
              [57.074376261000054, 41.9287855030001],
              [57.11551070200005, 41.95209157300006],
              [57.15292443900012, 41.993484395000095],
              [57.15292443900012, 41.993742778000055],
              [57.207804810000084, 42.07055979400003],
              [57.28821333800005, 42.129419251000044],
              [57.38226444500003, 42.16362904900002],
              [57.47827925600012, 42.16652293000003],
              [57.61976932800013, 42.14817779600013],
              [57.666278117000104, 42.1551024380001],
              [57.72157189900008, 42.175333761],
              [57.740898885000036, 42.17874440500013],
              [57.80921512900011, 42.1763931280001],
              [57.82843876200013, 42.17954539000006],
              [57.850452922000045, 42.19143096900008],
              [57.847352336000085, 42.200913595000046],
              [57.834536581000066, 42.21163645400007],
              [57.82730188000005, 42.22737192800004],
              [57.83546675700006, 42.2404460660001],
              [57.873707316000036, 42.24964447000009],
              [57.888073364000036, 42.261581727000035],
              [57.92879439300003, 42.33093149800008],
              [57.93747603300005, 42.35423757000011],
              [57.93571903500009, 42.369818014000046],
              [57.91432499200005, 42.40395029700004],
              [57.908640584000125, 42.43043446900002],
              [57.925590454000144, 42.44110565300012],
              [57.95277225800004, 42.450071513000054],
              [57.978300415000035, 42.471775615000055],
              [57.98708540800004, 42.48342865000002],
              [57.99773075300004, 42.493428040000126],
              [58.016024210000126, 42.49970672600004],
              [58.038245077000056, 42.50278147400006],
              [58.060879354000065, 42.50226470900013],
              [58.07989628100006, 42.49730377200008],
              [58.0943656820001, 42.48671010400001],
              [58.11720666500008, 42.46151784300007],
              [58.13322636000004, 42.45456736200008],
              [58.14945275900004, 42.455678406000075],
              [58.18572961400014, 42.467253927000016],
              [58.203816366000126, 42.46950185100003],
              [58.22572717300011, 42.46658213300013],
              [58.32504927600007, 42.43185557],
              [58.358949016000054, 42.41340708500009],
              [58.38468387900008, 42.38782725100005],
              [58.39491581300007, 42.35224802700007],
              [58.39150516800004, 42.333980408000016],
              [58.38613081800008, 42.31684967100004],
              [58.38582076000006, 42.30132090300005],
              [58.397602987000084, 42.287859192000084],
              [58.41393273900013, 42.28475860700003],
              [58.47821822100008, 42.291993307],
              [58.49062056500014, 42.29757436100003],
              [58.49413456200011, 42.30571339900003],
              [58.4895870360001, 42.31452423100002],
              [58.47821822100008, 42.32232737200003],
              [58.43791060400014, 42.35769989000006],
              [58.363703247000046, 42.44707428000005],
              [58.33703820800014, 42.49371226],
              [58.30623905400006, 42.528671367000115],
              [58.27099572800006, 42.54903188100003],
              [58.14573205600004, 42.59256927600008],
              [58.12702518700007, 42.60499745700004],
              [58.12134078000014, 42.62424692800006],
              [58.13064253700014, 42.63884552000003],
              [58.148832642000116, 42.64899993900009],
              [58.186556437000036, 42.66119557800003],
              [58.239576457000055, 42.68514760400002],
              [58.258283325000036, 42.689514262],
              [58.28267460200004, 42.68891998300005],
              [58.3905749920001, 42.65667389],
              [58.44183801300011, 42.647837220000085],
              [58.49320438600006, 42.64546010400004],
              [58.534545532000095, 42.65450348000009],
              [58.55573287000004, 42.68359731],
              [58.56937544700014, 42.768501689000075],
              [58.58787561100007, 42.79118764300004],
              [58.61226688700003, 42.780852356000125],
              [58.8274475500001, 42.593757833],
              [58.89442020700005, 42.547843323],
              [58.96470015500006, 42.524382223000046],
              [59.00924523900005, 42.51846527100004],
              [59.038597453000136, 42.51973134400008],
              [59.067432902000064, 42.52557078000005],
              [59.09647505700008, 42.5359835820001],
              [59.12200321500012, 42.53799896200003],
              [59.146084432000066, 42.526759339000094],
              [59.20964644400004, 42.47771840500006],
              [59.22380578600007, 42.460871888000085],
              [59.233314250000035, 42.44172576900009],
              [59.24519982900006, 42.36534800300002],
              [59.25842899600008, 42.347545471],
              [59.287161093000066, 42.33594411300005],
              [59.33811405500012, 42.331809998000026],
              [59.36157515400009, 42.325789694],
              [59.401469360000135, 42.29390533500002],
              [59.426480754000124, 42.286773987000075],
              [59.47815718600009, 42.28563710600007],
              [59.689513794000106, 42.30979583800003],
              [59.776330200000075, 42.303956401000065],
              [59.82097863800004, 42.30798716200006],
              [59.866350545000046, 42.30421478300012],
              [59.897873169000036, 42.278531596000036],
              [59.925675090000084, 42.246285502],
              [59.9607117110001, 42.22272104900007],
              [60.005050090000054, 42.20977610300007],
              [60.02820113100012, 42.19951833200007],
              [60.04039676900004, 42.18647003200003],
              [60.03698612400012, 42.16970102900008],
              [60.020553020000136, 42.16078684500006],
              [60.0000891520001, 42.15450815900006],
              [59.983656046000135, 42.14559397400002],
              [59.97445764200012, 42.09924021500002],
              [59.99409468600004, 42.05009592800006],
              [59.99719527200011, 42.01061513300006],
              [59.937870727000075, 41.99340688100007],
              [59.937560669000106, 41.99340688100007],
              [59.93725061100014, 41.99340688100007],
              [59.936940551000134, 41.993484395000095],
              [59.919267212000136, 41.98966034000004],
              [59.90800174900005, 41.979815979000065],
              [59.90645145700006, 41.96661265100009],
              [59.91751021300007, 41.952427471000036],
              [59.93177290800014, 41.94764740000004],
              [59.983656046000135, 41.949042663000014],
              [60.08876591000006, 41.91935455300005],
              [60.11822147700008, 41.90044097900001],
              [60.14114411600008, 41.874221484000074],
              [60.15253462700008, 41.86119272900005],
              [60.16752079300011, 41.84959137],
              [60.214856405000035, 41.82858490000008],
              [60.228912395000066, 41.819619039000045],
              [60.2411080330001, 41.80806935700012],
              [60.250823202000106, 41.79427175000008],
              [60.25268355300011, 41.7800607300001],
              [60.2411080330001, 41.76706410700008],
              [60.225398397000106, 41.76546213800013],
              [60.205864705000124, 41.77202504500012],
              [60.171344849000036, 41.78840647400007],
              [60.13372440600011, 41.797294821],
              [60.102408488000094, 41.795279440000044],
              [60.07491662600012, 41.78104258300006],
              [60.049181763000036, 41.753499044000094],
              [60.05827681500011, 41.718591614],
              [60.08907596900008, 41.67412404400004],
              [60.15563521300004, 41.60332733200009],
              [60.16473026500012, 41.58495636],
              [60.1509843340001, 41.57234731100006],
              [60.10964318900005, 41.556792704000046],
              [60.09258996600005, 41.545475566000064],
              [60.07956750500006, 41.53147125200006],
              [60.07171268700006, 41.51436635400002],
              [60.05920699100005, 41.43416453100012],
              [60.066131633000055, 41.4104967250001],
              [60.09424361200007, 41.3895160930001],
              [60.20369429600004, 41.34708974200005],
              [60.29991581200005, 41.309831035000045],
              [60.36027388600007, 41.276344706000046],
              [60.414534140000114, 41.23526194300008],
              [60.443266235000124, 41.21965566000004],
              [60.478096151000045, 41.21211090200008],
              [60.53814416500006, 41.213247782000096],
              [60.65886031100007, 41.243788554],
              [60.86029504400011, 41.2529869590001],
              [60.930264933000046, 41.24022288000002],
              [60.97801395700009, 41.20280914400006],
              [60.984628540000074, 41.20699493500008],
              [60.991139771000064, 41.21247263600007],
              [61.00431806800003, 41.229533188000104],
              [61.010260051000046, 41.23722564700002],
              [61.01408410700009, 41.23490020800007],
              [61.01718469200006, 41.22596018500006],
              [61.02276574700005, 41.21686513300007],
              [61.08188358600012, 41.22451324500007],
              [61.099660279000034, 41.22409983300004],
              [61.202599731000134, 41.16880605100003],
              [61.24321740800008, 41.15630035400004],
              [61.28135461400012, 41.157282207],
              [61.315874471000086, 41.170459697000084],
              [61.343986450000045, 41.19381744400003],
              [61.3630033770001, 41.22518503900004],
              [61.387498006000044, 41.23577870700002],
              [61.397213175000104, 41.27097035800007],
              [61.41075240100008, 41.2920026660001],
              [61.43317997200006, 41.30032257100005],
              [61.47007694500007, 41.297170309000094],
              [61.56733199100012, 41.27779164700003],
              [61.65435510300006, 41.249421285000025],
              [61.87790734900011, 41.12498443600002],
              [61.8974410400001, 41.10880971300013],
              [61.97082157400007, 41.01543039900004],
              [61.97929650900005, 40.99884226500005],
              [61.98270715300009, 40.978430075000105],
              [61.9853943280001, 40.90789174500013],
              [61.99025191200013, 40.89316396100013],
              [61.98270715300009, 40.885670878],
              [61.993869263000136, 40.86587880400002],
              [62.02534021000008, 40.78195627900003],
              [62.03681237800009, 40.73632598900012],
              [62.044770549000134, 40.71498362200002],
              [62.055725952000046, 40.70175445600002],
              [62.08869551600009, 40.674365947000084],
              [62.100064331000056, 40.660413310000095],
              [62.120683227000086, 40.59897003200008],
              [62.13417077600013, 40.577834372000055],
              [62.171377808000045, 40.53995554700005],
              [62.17726892100006, 40.53065378900003],
              [62.185330445000034, 40.507864482000045],
              [62.187061257000096, 40.50551552200001],
              [62.19184167500009, 40.49902781200005],
              [62.21344242400005, 40.486573792000044],
              [62.260933065000074, 40.4757217410001],
              [62.34361535600004, 40.439393209000045],
              [62.353278850000095, 40.430401510000095],
              [62.35637943500012, 40.38818186500002],
              [62.36258060800009, 40.369681702],
              [62.38831547100011, 40.33014923200007],
              [62.396532023000134, 40.31201080300012],
              [62.400201050000135, 40.292115377000115],
              [62.400976196000045, 40.265605368000124],
              [62.405058635000046, 40.245244853000074],
              [62.43575443500009, 40.194188538],
              [62.43968184400006, 40.172897848000034],
              [62.434100790000116, 40.154811097],
              [62.42578088300007, 40.13667266900008],
              [62.42159509200013, 40.115071920000034],
              [62.424385620000066, 40.09212758400007],
              [62.44195560700007, 40.03595530200003],
              [62.4528076580001, 40.00923858600005],
              [62.52458622200004, 39.93973378500009],
              [62.53538659700007, 39.934979553000076],
              [62.59316084800014, 39.89022776300003],
              [62.71015629100003, 39.8257355760001],
              [62.84647871900006, 39.750598043000096],
              [63.008949423000104, 39.661094462000065],
              [63.33864506000009, 39.47945180300012],
              [63.47755131000014, 39.40291900700002],
              [63.54100996900007, 39.356100159],
              [63.64849694800006, 39.23951812800003],
              [63.7092684320001, 39.190890605],
              [63.820062703000076, 39.129137268000036],
              [63.95969242400014, 39.05136423800009],
              [64.12061283400004, 38.96167978900003],
              [64.15058516400012, 38.9494583140001],
              [64.18014408400006, 38.94511749300004],
              [64.20598230000007, 38.9494583140001],
              [64.28339359600011, 38.97968902600003],
              [64.3135726320001, 38.98247955300009],
              [64.33734379100014, 38.97095570900005],
              [64.3675663030001, 38.94037404600006],
              [64.42431522600009, 38.88295074500003],
              [64.63489668800008, 38.744147848000026],
              [64.7633642990001, 38.68601186100004],
              [64.9105387780001, 38.64534250900009],
              [64.97771813900005, 38.61226959200009],
              [65.11083663000011, 38.51726247200007],
              [65.2053011480001, 38.44964386000002],
              [65.34017663600014, 38.37781362],
              [65.43960209100004, 38.32494862900002],
              [65.60413985200006, 38.237408753000054],
              [65.67162927300006, 38.21968373600002],
              [65.74020389800012, 38.22407623400004],
              [65.76599043800013, 38.23554840100003],
              [65.81435957800005, 38.26619252600007],
              [65.84288496900012, 38.27533925400006],
              [65.87668135600012, 38.272962138000096],
              [65.97745039900008, 38.234566549000064],
              [66.04349287900004, 38.2261949670001],
              [66.07160485800006, 38.21454193200013],
              [66.13356490000007, 38.17529368100007],
              [66.19841882400004, 38.160720927000014],
              [66.23107832900007, 38.14878367200005],
              [66.26043054200005, 38.126743673000064],
              [66.30693933100008, 38.080389914000065],
              [66.40832849200007, 38.04284698500008],
              [66.43943770400011, 38.03545725500008],
              [66.5159188230001, 38.03509552000007],
              [66.55415938400006, 38.02685312900003],
              [66.59038456200011, 38.01297800700006],
              [66.62402592000007, 37.99401275700011],
              [66.62423262600004, 37.993883566000065],
              [66.62433597800003, 37.99383188900005],
              [66.63652367000003, 37.966593133000075],
              [66.64578169800006, 37.94590199800005],
              [66.6090397540001, 37.88918711400002],
              [66.55364261900013, 37.83200714200008],
              [66.5188127030001, 37.782707825],
              [66.51498864700005, 37.743485413000045],
              [66.5229468180001, 37.66504058900004],
              [66.51912276300004, 37.625249736000015],
              [66.49721195400008, 37.55788950600002],
              [66.49349125100008, 37.522206929000035],
              [66.5071338300001, 37.493836568000106],
              [66.52682255100007, 37.48037485800005],
              [66.54268721500006, 37.466758118000044],
              [66.54661462400014, 37.45079010000002],
              [66.53080163600004, 37.43014536600002],
              [66.51209476800005, 37.414823303000034],
              [66.49700524900004, 37.397744242],
              [66.49483483900008, 37.37942494800002],
              [66.51958785000011, 37.36418040000008],
              [66.50289636200006, 37.35565378900007],
              [66.48522302300006, 37.34340647400005],
              [66.46992679900006, 37.32976389600013],
              [66.46145186400008, 37.32444122300008],
              [66.45106490100005, 37.32294260700009],
              [66.4386625570001, 37.32790354400002],
              [66.42362471500013, 37.34568023700005],
              [66.41349613500006, 37.34963348400002],
              [66.3896216230001, 37.34717885400006],
              [66.32068526200004, 37.32914377800007],
              [66.29443363400009, 37.331210836000125],
              [66.27438317900004, 37.34327728300009],
              [66.25774336800004, 37.35684234600008],
              [66.25084771600007, 37.359650022000054],
              [66.24187870300011, 37.36330190000005],
              [66.23252526900006, 37.3654206340001],
              [66.21846927900009, 37.374799906000064],
              [66.20772058100005, 37.37689280200003],
              [66.17464766500007, 37.37549753800006],
              [66.16307214300014, 37.37689280200003],
              [66.14291833500005, 37.38505767900004],
              [66.12560673000013, 37.39870025700007],
              [66.09785648600007, 37.42841420500004],
              [66.07966638200014, 37.4408682250001],
              [65.85518396000003, 37.50794423500004],
              [65.83606368000005, 37.51915802000009],
              [65.82908736200005, 37.52561757400004],
              [65.82107751500007, 37.535177715000046],
              [65.80433435100014, 37.56530507400002],
              [65.79647953300008, 37.569335836000036],
              [65.77653243000009, 37.57290151000008],
              [65.76144291200006, 37.57837921200009],
              [65.7588590900001, 37.5641165170001],
              [65.75265791800012, 37.53786488900006],
              [65.7394287520001, 37.52905405700007],
              [65.69829431200003, 37.52941579200008],
              [65.68103438400004, 37.52639272000006],
              [65.66883874500013, 37.52055328400006],
              [65.65871016400007, 37.51026967400007],
              [65.64832320200014, 37.49414662700009],
              [65.64827152500004, 37.49393992200005],
              [65.64816817200011, 37.493836568000106],
              [65.63576582900004, 37.474096171000056],
              [65.62574060100013, 37.452805481000055],
              [65.62098636900004, 37.430403748000074],
              [65.62889286300009, 37.38753814700003],
              [65.62946130400013, 37.3654206340001],
              [65.62408695500005, 37.345137635000114],
              [65.61127120000009, 37.331055806000066],
              [65.58315922000014, 37.308059795000034],
              [65.53685713700008, 37.257106833000094],
              [65.50140710500006, 37.24227569600005],
              [65.48792177900009, 37.24199746800004],
              [65.06308760600012, 37.2332323210001],
              [64.98908695500012, 37.21367279100009],
              [64.8079093830001, 37.13551218700006],
              [64.7787638750001, 37.1180455530001],
              [64.76016036000004, 37.0926207480001],
              [64.75561283400009, 37.053630880000085],
              [64.77462976100009, 36.977589010000045],
              [64.7787638750001, 36.93846995000011],
              [64.7652246500001, 36.90462188800002],
              [64.72854862900004, 36.850569547000035],
              [64.62135746300004, 36.6925934850001],
              [64.60482100400003, 36.66055409800002],
              [64.59200524900007, 36.621073303000074],
              [64.58880131100005, 36.60045440700007],
              [64.58900801600004, 36.58024892200008],
              [64.59371057100003, 36.55983673100003],
              [64.60776656100012, 36.52164784800006],
              [64.61050541200007, 36.50092559800002],
              [64.60585453300013, 36.461083069],
              [64.59438236500011, 36.42418609700009],
              [64.57665734900007, 36.38961456400007],
              [64.49816084800005, 36.291429342000114],
              [64.47769698100007, 36.27163726800002],
              [64.4445723880001, 36.249984843000036],
              [64.41087935400003, 36.239856262],
              [64.33724043800004, 36.22595530200003],
              [64.31894698100007, 36.21975413000003],
              [64.30365075700007, 36.211537578],
              [64.29186853100009, 36.19944529200002],
              [64.27605554200011, 36.159241028000096],
              [64.26613366700008, 36.15247141600004],
              [64.25373132300012, 36.1548485310001],
              [64.23714318900005, 36.16042958600012],
              [64.19590539500012, 36.1659072880001],
              [64.15869836500013, 36.16027455600006],
              [64.12335168400011, 36.14606353800009],
              [64.05725752800004, 36.105239156000025],
              [64.04464847900005, 36.092320049000094],
              [64.03622522000012, 36.07640370700007],
              [64.0363802490001, 36.05857533800004],
              [64.04557865400005, 36.011291402],
              [64.04511356600005, 35.99873403000008],
              [63.94997725400009, 36.028861389000056],
              [63.921968628000116, 36.03371897400008],
              [63.90632706100007, 36.03173234400002],
              [63.88982588700014, 36.02963653600007],
              [63.85985355600013, 36.02209177700003],
              [63.76590580200008, 35.97728831000005],
              [63.72570153800007, 35.968865052000055],
              [63.602298218000044, 35.96266388000008],
              [63.582092732000035, 35.959046530000094],
              [63.56343754000005, 35.950623271000026],
              [63.54958825700004, 35.939047751000075],
              [63.525920451000104, 35.91269277000002],
              [63.51108931500005, 35.90184071900005],
              [63.4302156980001, 35.871041565000084],
              [63.34293420400007, 35.856262106000074],
              [63.12527307200014, 35.86024119100004],
              [63.10408573400008, 35.85646881100003],
              [63.08863448100004, 35.843394674000066],
              [63.084397013000114, 35.82608306900006],
              [63.091321655000115, 35.81331899100009],
              [63.10129520700008, 35.80055491200004],
              [63.105687704000104, 35.78288157200002],
              [63.11204390500012, 35.769910787000114],
              [63.163255250000134, 35.732290345000095],
              [63.177259563000064, 35.716890768],
              [63.18392582200005, 35.712343242000074],
              [63.20935062700005, 35.70448842400013],
              [63.214414917000056, 35.69926910500003],
              [63.213588094000045, 35.69229278600001],
              [63.20769698100014, 35.683197734000046],
              [63.17989506000009, 35.66645457],
              [63.10315555800008, 35.646042379000065],
              [63.076645549000034, 35.62470001200005],
              [63.07494022700007, 35.60981720000011],
              [63.07736901800013, 35.55876088500004],
              [63.08057295700007, 35.546513570000016],
              [63.09721276900012, 35.535454814],
              [63.10072676600004, 35.52496449900006],
              [63.09049483200005, 35.493545228000116],
              [63.08625736500011, 35.45566640300002],
              [63.08021122200006, 35.43706288700007],
              [63.066827027000045, 35.425590719000056],
              [63.04708662900009, 35.4213532510001],
              [63.00553877800007, 35.418407695],
              [62.985281616000066, 35.41458363900007],
              [62.91820560700006, 35.388176982000076],
              [62.82756514500005, 35.32931752500009],
              [62.82306342900006, 35.327514064000084],
              [62.7604891360001, 35.30244578100009],
              [62.73423750800009, 35.28074167900009],
              [62.721628458000055, 35.266427308000104],
              [62.70860599800011, 35.25604034500007],
              [62.69361983200014, 35.248392232000114],
              [62.621066122000116, 35.22270904500003],
              [62.60452966300005, 35.21940175400003],
              [62.595641317000116, 35.220590312000056],
              [62.5661857500001, 35.230770569000114],
              [62.555437052000116, 35.230408834000016],
              [62.545515177000084, 35.22803171800008],
              [62.535489950000056, 35.227359924],
              [62.52458622200004, 35.23216583300008],
              [62.45890547700009, 35.281878561],
              [62.43187870300011, 35.28063832600007],
              [62.39932255100007, 35.25593699200006],
              [62.30201582800004, 35.147519837000104],
              [62.286202840000044, 35.140646871000044],
              [62.275712525000074, 35.151033835000064],
              [62.25685062700006, 35.18715566000007],
              [62.250959513000055, 35.2023485320001],
              [62.252613159000134, 35.24281117800008],
              [62.25121789600013, 35.260381165000055],
              [62.24434493000007, 35.27805450500007],
              [62.23369958500007, 35.29376414000005],
              [62.21902347800011, 35.30626983600003],
              [62.163884725000116, 35.32616526300005],
              [62.13634118700014, 35.34135813400006],
              [62.03381514500006, 35.42398875000002],
              [62.00746016400012, 35.43892323900006],
              [61.97774621600013, 35.45091217100013],
              [61.91935184700009, 35.451842346],
              [61.79904911300008, 35.41747751900006],
              [61.739621216000046, 35.41375681600003],
              [61.60474572800007, 35.4306033320001],
              [61.53870324700006, 35.45230743400002],
              [61.49271122300013, 35.49416534400008],
              [61.4277022710001, 35.542844543000015],
              [61.41930908800009, 35.54589138400006],
              [61.412612752000086, 35.5483222460001],
              [61.40124393700012, 35.549820862],
              [61.39318241400008, 35.55359324100003],
              [61.38687788900006, 35.559536032000054],
              [61.380263305000085, 35.567339173000065],
              [61.37995324700012, 35.57131825800006],
              [61.38388065600009, 35.582118632000075],
              [61.38346724500008, 35.586459453000074],
              [61.367654256000094, 35.597983297],
              [61.365483846000075, 35.598500061000024],
              [61.36393355300004, 35.598241679000054],
              [61.351531210000076, 35.607130026000064],
              [61.36010949700011, 35.61839548800013],
              [61.360936320000064, 35.621030986000065],
              [61.351531210000076, 35.62780059900008],
              [61.344193156000074, 35.63090118400005],
              [61.33571822100009, 35.63090118400005],
              [61.283318319000045, 35.62263295600009],
              [61.26967574100013, 35.61849884000007],
            ],
          ],
          [
            [
              [53.029958530000044, 39.06134674700007],
              [53.04029381600009, 39.08100006700005],
              [53.057627800000034, 39.09442780200004],
              [53.08171634200005, 39.097723700000074],
              [53.086599155000044, 39.09129466400009],
              [53.087901238000086, 39.08812083500004],
              [53.087901238000086, 39.08344147300005],
              [53.05884850400008, 39.06708405200004],
              [53.05396569100009, 39.02680084800005],
              [53.067393425000034, 38.94684479400007],
              [53.07943769600007, 38.86347077000005],
              [53.10206139400003, 38.78172435100004],
              [53.097992384000065, 38.769232489000046],
              [53.098399285000085, 38.76390208500004],
              [53.10206139400003, 38.755072333000044],
              [53.094737175000034, 38.755072333000044],
              [53.092133009000065, 38.77879466400009],
              [53.06299889400003, 38.86469147300005],
              [53.046885613000086, 38.89166901200008],
              [53.04021243600005, 38.906683661000045],
              [53.03842207100007, 38.91693756700005],
              [53.040049675000034, 38.943426825000074],
              [53.037852410000085, 38.97016022300005],
              [53.02857506600009, 39.01630280200004],
              [53.026377800000034, 39.03937409100007],
              [53.029958530000044, 39.06134674700007],
            ],
          ],
          [
            [
              [53.46851647200003, 39.58494700700004],
              [53.47999108200008, 39.59332916900007],
              [53.49187259200005, 39.59796784100007],
              [53.49830162900008, 39.591009833000044],
              [53.50375410200007, 39.58612702000005],
              [53.50863691500007, 39.58551666900007],
              [53.51295006600009, 39.59121328300006],
              [53.51734459700003, 39.56940338700008],
              [53.51929772200003, 39.56386953300006],
              [53.539724155000044, 39.53961823100008],
              [53.53443444100009, 39.52765534100007],
              [53.52198326900003, 39.51609935100004],
              [53.506195509000065, 39.50861237200007],
              [53.49187259200005, 39.50861237200007],
              [53.48658287900008, 39.51634349200009],
              [53.475271030000044, 39.548081773000035],
              [53.46827233200008, 39.56045156500005],
              [53.462901238000086, 39.57379791900007],
              [53.46851647200003, 39.58494700700004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Jordan',
        iso3: 'JOR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [35.611757849000156, 32.681900396000074],
            [35.612333850000084, 32.68153519700003],
            [35.635994913000104, 32.67914337200004],
            [35.64022553738743, 32.68099938753657],
            [35.65201460800006, 32.68617136600004],
            [35.68519087700008, 32.711234437000044],
            [35.740174601000035, 32.740534973000095],
            [35.75743453000007, 32.74428151400012],
            [35.75759034900011, 32.7443468580001],
            [35.76384240700014, 32.74696869000006],
            [35.769733520000045, 32.74805389400005],
            [35.77490116400014, 32.74727874800003],
            [35.77913863100008, 32.74451405800009],
            [35.779035278000094, 32.74428151400012],
            [35.78823368400009, 32.73441131700004],
            [35.89572066300008, 32.71327565600011],
            [35.90522912600005, 32.70857310000012],
            [35.92248905400004, 32.693767802000096],
            [35.927449992000106, 32.69237253900012],
            [35.94036910000011, 32.69250172900006],
            [35.94419315600004, 32.690770569000094],
            [35.94574344900008, 32.68410431000008],
            [35.94439986200007, 32.67761891700012],
            [35.941195922000134, 32.673536479000106],
            [35.937475219000135, 32.67400156700002],
            [35.94657027200009, 32.66444142700003],
            [35.955355265000094, 32.65743927100003],
            [35.96579390500011, 32.6543645230001],
            [35.98026330600004, 32.656612448000104],
            [36.003621053000074, 32.65508799200008],
            [36.00827193200007, 32.6437191780001],
            [36.00527469900004, 32.62669179300006],
            [36.00599816900012, 32.60790741000007],
            [36.0154032800001, 32.59116424600002],
            [36.060465128000146, 32.53326080300009],
            [36.06604618300014, 32.52160776800012],
            [36.06625288900011, 32.517318624000055],
            [36.06987023900007, 32.51659515400006],
            [36.081905549000055, 32.51626477300009],
            [36.096225220000065, 32.51587168400006],
            [36.13322554600012, 32.52010915100003],
            [36.139530070000035, 32.51954071000007],
            [36.149865356000134, 32.51613006700005],
            [36.15585982200014, 32.51519989100008],
            [36.16082076000009, 32.51721527100004],
            [36.17218957500006, 32.52592275000008],
            [36.17735721800011, 32.52731801400007],
            [36.18820926900014, 32.522279561000104],
            [36.22076542100007, 32.49458099400009],
            [36.2852576090001, 32.45693471300005],
            [36.373107544000106, 32.386422221000075],
            [36.387887004000106, 32.37931671200006],
            [36.40762740000008, 32.374226583000066],
            [36.463954712000145, 32.36939483700006],
            [36.48018111100009, 32.360790711000035],
            [36.51668392700009, 32.357014182000015],
            [36.65350386500006, 32.34285898800006],
            [36.68957401500006, 32.319656271000056],
            [36.70693729600009, 32.328337911000105],
            [36.72864139800009, 32.32779530900005],
            [36.79251346800004, 32.313532614000096],
            [36.80656945800007, 32.31304168700005],
            [36.819385213000146, 32.31678822900007],
            [36.980098918000124, 32.4100383510001],
            [37.133164510000086, 32.49452931800006],
            [37.13337121600006, 32.49458099400009],
            [37.244062134000046, 32.55439646400002],
            [37.41521447800005, 32.647129822000025],
            [37.49460567400013, 32.690055623],
            [37.586676880000084, 32.73983734200003],
            [37.75803592900007, 32.8325190230001],
            [37.92939497900005, 32.925329896],
            [38.056725708000045, 32.99434377000007],
            [38.23087528500014, 33.08630198200005],
            [38.31574206300013, 33.13118006300009],
            [38.52956506300012, 33.244250997000066],
            [38.77451135200005, 33.3716850790001],
            [38.821020142000066, 33.22903228800003],
            [38.862567993000084, 33.10071970600008],
            [38.89719120300009, 32.99434377000007],
            [38.942769816000066, 32.85233693400009],
            [38.99000207500012, 32.705575867],
            [39.05718143800004, 32.49659637400002],
            [38.97997684800009, 32.476054993000034],
            [38.97863326000004, 32.47569325800005],
            [38.978219849000084, 32.47496978800005],
            [38.97863326000004, 32.47372955400003],
            [38.97997684800009, 32.472101746000064],
            [39.02875939900014, 32.328337911000105],
            [39.03620080600007, 32.31335174500005],
            [39.04632938700013, 32.30849416100001],
            [39.23577518700006, 32.35285837800008],
            [39.25634240700009, 32.342678121000105],
            [39.27112186700009, 32.31195648200007],
            [39.29199914500009, 32.244518738000025],
            [39.26647098800004, 32.21286692300005],
            [39.14616825300004, 32.125843811],
            [39.14637496000012, 32.118144023000085],
            [39.13624637800007, 32.115353496000054],
            [39.11681604000006, 32.10289947500006],
            [38.99806359900009, 32.00693634100007],
            [38.963440389000084, 31.994482320000103],
            [38.963440389000084, 31.99432729100006],
            [38.96333703600004, 31.99437896700006],
            [38.84975223800012, 31.966318664000042],
            [38.624856405000116, 31.91086985300008],
            [38.40016727700004, 31.8553693650001],
            [38.175374796000085, 31.799920552000046],
            [37.98652246000006, 31.753358384000123],
            [37.95047896300008, 31.744471741000055],
            [37.76141217300011, 31.696120493000095],
            [37.70274214700004, 31.68111643500005],
            [37.45500533100005, 31.617709452000028],
            [37.207268514000134, 31.554354147000097],
            [36.99791151900007, 31.500813955000055],
            [36.959531698000035, 31.490998840000103],
            [37.08965295400009, 31.370075989000057],
            [37.21977421100013, 31.24910146100008],
            [37.221722009000075, 31.247292129000115],
            [37.34989546700007, 31.128230286000033],
            [37.48001672400005, 31.007255758000056],
            [37.48311730900008, 31.004103495000024],
            [37.48632124900007, 31.00089955700004],
            [37.4894218340001, 30.997695618000066],
            [37.49262577300004, 30.99449167900009],
            [37.60228316200005, 30.88323232100005],
            [37.71204390500009, 30.772024638000048],
            [37.82190800000012, 30.66086863200006],
            [37.93156538900013, 30.54966095000013],
            [37.98107141100007, 30.4994831340001],
            [37.98138146900004, 30.498811340000103],
            [37.980968058000144, 30.49839792900009],
            [37.98003788200009, 30.49808787100001],
            [37.97331994700005, 30.494522196000062],
            [37.900146118000066, 30.45907216400012],
            [37.77932662000006, 30.40041941400007],
            [37.67070275900005, 30.34760610000002],
            [37.647551718000045, 30.330862936000088],
            [37.63452925600012, 30.31277618400007],
            [37.60517704200004, 30.250712789000104],
            [37.56921024600007, 30.17495513900012],
            [37.5361373290001, 30.105295309],
            [37.4916955970001, 30.011192526000016],
            [37.47019820100007, 29.994552714000108],
            [37.352375936000044, 29.973313701000038],
            [37.21853397600006, 29.94912913000006],
            [37.075803670000084, 29.923290915000038],
            [36.93193648300013, 29.897245992000066],
            [36.84294966600004, 29.881226299],
            [36.756236613000056, 29.865516663000037],
            [36.72874475100008, 29.853527731000085],
            [36.704870239000115, 29.831151836000103],
            [36.64957645700008, 29.74939972],
            [36.603584432000105, 29.681471049000052],
            [36.54126265500008, 29.589409485000104],
            [36.47708052600012, 29.494609070000067],
            [36.3999792890001, 29.43890187600003],
            [36.28370731600006, 29.354850159000094],
            [36.17797733600008, 29.278369039000026],
            [36.06945682800006, 29.20002756800004],
            [36.04382531800013, 29.190880840000133],
            [36.016436808000094, 29.189950664],
            [35.912463827000124, 29.205686137000058],
            [35.79722538200008, 29.223075257000076],
            [35.740250622000076, 29.231730714000022],
            [35.622042277000105, 29.249688619000025],
            [35.47362756400008, 29.272064515000082],
            [35.33461796000012, 29.293148499000026],
            [35.179071899000064, 29.316661275000016],
            [35.060319458000095, 29.334696350000016],
            [34.9493851167955, 29.351685826515777],
            [34.96241295700008, 29.359767971000053],
            [34.96900475400008, 29.450832424000055],
            [34.97608483200008, 29.477036851000037],
            [34.99781334700009, 29.517971096000053],
            [34.996836785000085, 29.53388092700004],
            [34.97608483200008, 29.55215078300006],
            [34.96241295700008, 29.55215078300006],
            [34.961599155000044, 29.55540599200009],
            [34.961599155000044, 29.55809153900009],
            [34.96021569100009, 29.559515692000048],
            [34.95557701900009, 29.558986721000053],
            [34.959860474000095, 29.586205547000063],
            [34.966991822000125, 29.608116354000103],
            [34.98032434100014, 29.627004090000028],
            [34.98983280400006, 29.651963807000115],
            [34.995103801000084, 29.70816192700009],
            [35.00254520700008, 29.733095805000076],
            [35.04895064200008, 29.842313945000043],
            [35.053188110000065, 29.86262278200006],
            [35.05411828600012, 29.923394267000063],
            [35.06145634000012, 29.9573456830001],
            [35.065383748000045, 29.965975647000036],
            [35.07034468600011, 29.97372711200005],
            [35.07406538900011, 29.982563782000042],
            [35.074685506000094, 29.99460439100001],
            [35.086261027000035, 30.034033509000025],
            [35.129049113000065, 30.08974070200007],
            [35.14527551200007, 30.123382060000026],
            [35.14527551200007, 30.154904684000073],
            [35.12481164500008, 30.216089579000098],
            [35.12522505700014, 30.244666647000074],
            [35.13235640500005, 30.26187489800013],
            [35.14176151500004, 30.313964743],
            [35.147755981000046, 30.32647043900009],
            [35.154473918000065, 30.336754049],
            [35.15995162000007, 30.347502747000092],
            [35.162122029000045, 30.361403707000065],
            [35.1593315020001, 30.37561472600005],
            [35.1449654540001, 30.39587188700004],
            [35.140004517000136, 30.40615549700003],
            [35.140004517000136, 30.43018503800006],
            [35.15736779700006, 30.47085439100003],
            [35.162122029000045, 30.494677226000093],
            [35.205323527000076, 30.617098694000063],
            [35.2638212490001, 30.71977976500004],
            [35.26388190400013, 30.719966986000102],
            [35.27157271300007, 30.74370595300006],
            [35.276120239000136, 30.76897572800003],
            [35.27953088400005, 30.780241191000087],
            [35.28614546700004, 30.792333476000053],
            [35.29389693200005, 30.80018829300009],
            [35.31084680200007, 30.813314107000068],
            [35.31663456200005, 30.82282257100006],
            [35.320045206000145, 30.844940084000072],
            [35.319528442000035, 30.867315979000054],
            [35.32221561700004, 30.88995025600009],
            [35.33492802000012, 30.912584534000032],
            [35.34711028400005, 30.92270963500006],
            [35.374098755000034, 30.945140686000073],
            [35.38526086400009, 30.96327911400003],
            [35.385157511000045, 30.994646708000047],
            [35.39156538900011, 31.023947246],
            [35.438487590000136, 31.103735657000087],
            [35.44324182100013, 31.13220937100003],
            [35.43621382700013, 31.15954620400005],
            [35.42133101400009, 31.184505921000024],
            [35.41068566900009, 31.204608053000086],
            [35.40117720600011, 31.230291239000067],
            [35.395699504000106, 31.257679749000104],
            [35.40820520000011, 31.282019349],
            [35.42226119000014, 31.302999980000024],
            [35.42391483500006, 31.324600728000078],
            [35.416473429000064, 31.331835429000066],
            [35.435076945000105, 31.36061920200008],
            [35.452853637000146, 31.40082346600009],
            [35.456884400000035, 31.42350942000006],
            [35.4571275560001, 31.43352439400003],
            [35.45853804500007, 31.491618958000075],
            [35.45812463400006, 31.491929016000043],
            [35.45874475100004, 31.49156728100006],
            [35.45915816300004, 31.49187734000013],
            [35.45905481000011, 31.4928075160001],
            [35.45874475100004, 31.49440948500002],
            [35.46422245300005, 31.568565165000066],
            [35.48013879400014, 31.64111887600008],
            [35.50247856700008, 31.685360389000024],
            [35.527577758000064, 31.73506663000002],
            [35.55941044100007, 31.765349019000055],
            [35.53832645600005, 31.8192992150001],
            [35.53832645600005, 31.826740621000013],
            [35.54907515400009, 31.839194641000105],
            [35.524683879000065, 31.919241435000046],
            [35.527474406000124, 31.92735463500007],
            [35.53367557700011, 31.930300192000047],
            [35.5406002200001, 31.932005514000124],
            [35.54514774600011, 31.936604716000076],
            [35.54587121600014, 31.944562887000032],
            [35.53998010300012, 31.955621643000043],
            [35.53832645600005, 31.963941549000097],
            [35.53770634000011, 31.977584127000014],
            [35.535535929000105, 31.988229473],
            [35.524683879000065, 32.01169057200006],
            [35.52282352700007, 32.0578376270001],
            [35.528301229000135, 32.075097555000085],
            [35.54514774600011, 32.086828105000095],
            [35.53460575300005, 32.099230449000046],
            [35.53522587100014, 32.11080596900011],
            [35.55196903500007, 32.13519724500013],
            [35.546698038000045, 32.141605123000076],
            [35.546698038000045, 32.14703114900006],
            [35.5512455650001, 32.15152699800008],
            [35.55941044100007, 32.15509267200004],
            [35.55941044100007, 32.162534079000054],
            [35.55517297300014, 32.17439382],
            [35.55956241700005, 32.19037087200006],
            [35.572536255000045, 32.23759409600005],
            [35.55941044100007, 32.23759409600005],
            [35.561064087000034, 32.24314931200006],
            [35.56375126100005, 32.24681833900006],
            [35.56757531800008, 32.24950551400009],
            [35.572536255000045, 32.25190846800005],
            [35.56457808400012, 32.263587342],
            [35.56085738100006, 32.28263010700009],
            [35.56116744000008, 32.30169871100007],
            [35.5656116130001, 32.31335174500005],
            [35.556516560000034, 32.32820872000006],
            [35.557343384000035, 32.35820688900013],
            [35.55196903500007, 32.367947896000075],
            [35.55196903500007, 32.37482086200005],
            [35.55941044100007, 32.37482086200005],
            [35.55941044100007, 32.367947896000075],
            [35.5656116130001, 32.367947896000075],
            [35.563957967000135, 32.37704294900006],
            [35.560960734000105, 32.384716899000026],
            [35.556826620000095, 32.39091807100003],
            [35.55196903500007, 32.395284730000085],
            [35.549591919000136, 32.398540345000086],
            [35.54514774600011, 32.40957326300007],
            [35.55486291500006, 32.41117523200002],
            [35.5591003830001, 32.41396575900008],
            [35.558170207000046, 32.41799652200008],
            [35.55196903500007, 32.4232416790001],
            [35.55196903500007, 32.429442851000076],
            [35.55941044100007, 32.429442851000076],
            [35.55786014900008, 32.43411956800004],
            [35.55620650200012, 32.43479136200004],
            [35.554139445000146, 32.434455465000056],
            [35.55196903500007, 32.436212464000036],
            [35.5656116130001, 32.44370554600006],
            [35.55941044100007, 32.450526835000105],
            [35.56623173000014, 32.453110657000096],
            [35.572536255000045, 32.456728007],
            [35.572536255000045, 32.464195252000124],
            [35.568092082000135, 32.464970398000034],
            [35.56540490700013, 32.4663139850001],
            [35.563131144000124, 32.468174337],
            [35.55941044100007, 32.47039642300011],
            [35.56127079200007, 32.47708852200013],
            [35.56499149500013, 32.48390981100009],
            [35.57098596200012, 32.489206645000124],
            [35.5799776610001, 32.49148040800013],
            [35.5799776610001, 32.497733256000046],
            [35.57057255000012, 32.50602732400007],
            [35.568505493000146, 32.51026479100004],
            [35.561374145000116, 32.51917897600005],
            [35.557240031000106, 32.51933400500009],
            [35.55196903500007, 32.518817241000065],
            [35.55196903500007, 32.525586853],
            [35.5656116130001, 32.525586853],
            [35.56282108600004, 32.53202056900004],
            [35.55941044100007, 32.55294952400003],
            [35.5656116130001, 32.54610239700007],
            [35.57015913900011, 32.556825257000085],
            [35.572536255000045, 32.560390930000054],
            [35.57387984200011, 32.55674774200007],
            [35.57439660600005, 32.55439646400002],
            [35.575843546000044, 32.55496490500009],
            [35.5799776610001, 32.560390930000054],
            [35.57439660600005, 32.572767436000035],
            [35.57129602100014, 32.59855397500003],
            [35.5656116130001, 32.60754567500008],
            [35.5656116130001, 32.6150129200001],
            [35.572536255000045, 32.6150129200001],
            [35.572536255000045, 32.6212399300001],
            [35.564061320000064, 32.62547739700004],
            [35.56003055800005, 32.632686260000085],
            [35.560547323000094, 32.64090281200005],
            [35.56271773300011, 32.64421010400004],
            [35.56984908000004, 32.64676808700004],
            [35.578737427000135, 32.653434347000044],
            [35.593826945000046, 32.670358378000046],
            [35.61222375500006, 32.68154632600009],
            [35.611757849000156, 32.681900396000074],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Nepal',
        iso3: 'NPL',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [88.11821781400005, 27.860884501000058],
            [88.14302250200012, 27.855716858000065],
            [88.15640669800007, 27.85127268500007],
            [88.16462325100008, 27.84535573400005],
            [88.16658695500013, 27.83359934600007],
            [88.15459802200007, 27.815150859000042],
            [88.15966231300013, 27.774119772000105],
            [88.14932702700014, 27.748772482],
            [88.1348576260001, 27.723166809000062],
            [88.11087976100009, 27.639502666000013],
            [88.04876468900011, 27.545348206000043],
            [88.02333988400011, 27.494912008000128],
            [88.02209965000009, 27.48424082500013],
            [88.02333988400011, 27.474654847000025],
            [88.02809411600009, 27.45512115500013],
            [88.03078129100004, 27.450728659000035],
            [88.03977299000007, 27.442357077000068],
            [88.04163334200007, 27.438067933000085],
            [88.03930790200013, 27.42948964400007],
            [88.03481205300011, 27.42380523700011],
            [88.02959273300007, 27.418740947000046],
            [88.02582035300009, 27.412074686000025],
            [88.01724206500006, 27.389233704000034],
            [88.01476159700007, 27.378071594000076],
            [88.01579512500007, 27.364222311000034],
            [88.02013594600004, 27.353370260000062],
            [88.0325382900001, 27.333888245000068],
            [88.03512211100008, 27.322571106000012],
            [88.02902429200003, 27.298076477000066],
            [88.0046627590001, 27.249163088],
            [87.98933679200007, 27.2183914190001],
            [87.9854610590001, 27.148369853000062],
            [87.97083663000012, 27.119224345000063],
            [87.96918298300005, 27.11080108700007],
            [87.97073327700008, 27.10273956300007],
            [87.97548750900012, 27.095143128000117],
            [87.99130049700011, 27.08150055],
            [88.00949060100004, 27.04563710500007],
            [88.02737064700011, 27.03535349500008],
            [88.04282190000009, 27.028945618000122],
            [88.05594771400007, 27.018041891000067],
            [88.07687666900006, 26.991790263000027],
            [88.09682377100006, 26.95933746400003],
            [88.11180993700003, 26.924300842],
            [88.12043990100005, 26.9088495890001],
            [88.14281579600004, 26.878412170000033],
            [88.15139408400006, 26.862805888000096],
            [88.15532149300003, 26.845597636000022],
            [88.15904219600009, 26.802551169000097],
            [88.16782718900004, 26.762915344000035],
            [88.1690674240001, 26.74400177000011],
            [88.16751713100007, 26.725036519000057],
            [88.16338301600007, 26.70514109300005],
            [88.14663985200008, 26.661216126000014],
            [88.10168135600009, 26.581944479000086],
            [88.08713624100011, 26.539100004000105],
            [88.07982222500004, 26.51755564400007],
            [88.07915043200006, 26.507375387000096],
            [88.08225101700009, 26.4948696900001],
            [88.07418949400011, 26.453941955000104],
            [88.04432051600008, 26.405676168000085],
            [88.00664839700005, 26.369864400000054],
            [87.97548750900012, 26.366557108000066],
            [87.96122481300011, 26.378959453000036],
            [87.92897871900004, 26.396426086000062],
            [87.91476770100007, 26.408259990000076],
            [87.90851485200011, 26.417820130000067],
            [87.90200362200005, 26.43528676300012],
            [87.89730106600007, 26.44345164000005],
            [87.89476892100004, 26.442934876000024],
            [87.87068770400003, 26.460711569000026],
            [87.86980920500008, 26.464638978],
            [87.85208418800005, 26.460659892000123],
            [87.8215950930001, 26.437508851000032],
            [87.80443851800004, 26.437353821000087],
            [87.78593835400011, 26.445983785000024],
            [87.76898848500008, 26.451461487000117],
            [87.75617273000012, 26.446913961000078],
            [87.7494547930001, 26.425726624000035],
            [87.74222009300013, 26.410482076000093],
            [87.72754398600011, 26.403764140000064],
            [87.71090417500011, 26.405676168000085],
            [87.6975716550001, 26.41626983700006],
            [87.68119022600013, 26.424228007000025],
            [87.6596411540001, 26.417510071],
            [87.64874495200013, 26.40999327100006],
            [87.6239844160001, 26.392912089],
            [87.58698409000004, 26.378029277000067],
            [87.55205082300006, 26.38671091700003],
            [87.48032393400007, 26.423401185],
            [87.44962813400014, 26.428620504000023],
            [87.41645186400012, 26.426966858000057],
            [87.38420577000005, 26.418646953000106],
            [87.35640384900006, 26.403712464000037],
            [87.3449316820001, 26.389346416000038],
            [87.32622481300007, 26.353327942000064],
            [87.31402917500009, 26.343767802000073],
            [87.3004899500001, 26.345989888000062],
            [87.25842533400004, 26.36293975800008],
            [87.24529952000012, 26.370226136000056],
            [87.23630782100014, 26.383300273000103],
            [87.22943485500008, 26.398751526000083],
            [87.2190995690001, 26.408104960000045],
            [87.18845544500005, 26.399578349000123],
            [87.13502201400013, 26.394204],
            [87.10628991700014, 26.40474599300002],
            [87.08329390500006, 26.43208282500005],
            [87.06670577000006, 26.46562082900006],
            [87.05668054200004, 26.4948696900001],
            [87.05647383700011, 26.494921367000032],
            [87.04500166800005, 26.544272359000033],
            [87.04443322800012, 26.561170553000025],
            [87.04133264100005, 26.580187480000106],
            [87.02991215000009, 26.579774068000077],
            [87.01544274900004, 26.568973694000064],
            [86.98521203600012, 26.540655009000048],
            [86.97244795800009, 26.531973368000095],
            [86.93515347300013, 26.520289336000033],
            [86.9071289470001, 26.51150950100005],
            [86.87596805800007, 26.494921367000032],
            [86.86568444800014, 26.472442119000036],
            [86.84635746300012, 26.452650045000055],
            [86.82186283400006, 26.438128967000083],
            [86.79643802900006, 26.431514384000096],
            [86.78723962400005, 26.43306467700002],
            [86.75189294500012, 26.44551869700011],
            [86.7381986900001, 26.44371002200002],
            [86.73070560700006, 26.43378814800012],
            [86.72409102400007, 26.421954244000105],
            [86.71360070900005, 26.414564515000095],
            [86.69520389800005, 26.418233541000077],
            [86.62533736100005, 26.45631907100004],
            [86.55789961800014, 26.484017639000072],
            [86.53795251500003, 26.4948696900001],
            [86.53774580900006, 26.4948696900001],
            [86.52430993700011, 26.509080709000088],
            [86.5106156820001, 26.52013946600009],
            [86.4949060460001, 26.527839254000085],
            [86.47547570800003, 26.531973368000095],
            [86.4448315840001, 26.543083802000112],
            [86.38364668800006, 26.572849427],
            [86.35367435800003, 26.582616272000067],
            [86.34483768800004, 26.582616272000067],
            [86.32318526200004, 26.580084127000063],
            [86.31600223800012, 26.58096262700009],
            [86.30902592000012, 26.58799062200002],
            [86.30861250800007, 26.60214996300006],
            [86.30137780800004, 26.609022930000023],
            [86.28442793800014, 26.612020162000036],
            [86.26308557100003, 26.60907460600005],
            [86.22515507100013, 26.597395732000066],
            [86.20288252800009, 26.584579977000075],
            [86.19585453300004, 26.582667949000083],
            [86.18536421800007, 26.584424947000045],
            [86.17926639900003, 26.58861073800007],
            [86.17446049000006, 26.593313293000065],
            [86.16779423000014, 26.596620585000053],
            [86.15265303600012, 26.600651347000067],
            [86.14635461800009, 26.60135577600009],
            [86.14479821800006, 26.601529847000094],
            [86.12206058800012, 26.600289612000054],
            [86.11585941500005, 26.602563375000088],
            [86.11069177300004, 26.60674916600003],
            [86.04170373500006, 26.645454814000047],
            [86.01136967000014, 26.65444651300008],
            [85.97571293100003, 26.644369609000037],
            [85.95214847900013, 26.6420441690001],
            [85.93468184400007, 26.632897441000026],
            [85.86636560100004, 26.579929098000022],
            [85.84476485200008, 26.568508606000123],
            [85.82853845200003, 26.566131490000075],
            [85.82161381000009, 26.571712545000096],
            [85.81975345900008, 26.579515687000097],
            [85.81954675300011, 26.588300680000103],
            [85.81763472500006, 26.596723938000096],
            [85.80972823100007, 26.603028463],
            [85.80006473800012, 26.600703023000065],
            [85.7899878340001, 26.597033997000082],
            [85.78099613500012, 26.599204407000073],
            [85.72704593900005, 26.637599996000105],
            [85.71288659700014, 26.65320627900003],
            [85.70224125100003, 26.68844960600002],
            [85.70963098200014, 26.762450256000122],
            [85.70182784000013, 26.7966083780001],
            [85.6877718500001, 26.811852926000043],
            [85.60937870300012, 26.851023662000088],
            [85.59857832800009, 26.854382630000103],
            [85.51946171000009, 26.8264256800001],
            [85.47569177300011, 26.805238343000056],
            [85.43962162300011, 26.787720032],
            [85.42153487200005, 26.782655742000102],
            [85.4031897380001, 26.787616679000067],
            [85.38587813300006, 26.788443502000078],
            [85.36923832200006, 26.77500762900003],
            [85.35535245800008, 26.759912352000086],
            [85.35321862800009, 26.757592672],
            [85.33704390500003, 26.746792298000074],
            [85.30236901900008, 26.73733551],
            [85.28727950000007, 26.736973776000085],
            [85.1949337160001, 26.75888458300004],
            [85.16568485500005, 26.786273092],
            [85.16552982600012, 26.82079294900008],
            [85.16201582800005, 26.851023662000088],
            [85.12284509300008, 26.865699768000084],
            [85.10021081500008, 26.863529358000093],
            [85.0439868580001, 26.843737284],
            [85.01856205200005, 26.84580434200008],
            [85.01685673100013, 26.859240214000025],
            [85.01804528800005, 26.874433086000053],
            [85.00083703600006, 26.882236227000064],
            [84.98817631000003, 26.883786520000072],
            [84.97577396700007, 26.886887105000127],
            [84.95272627800011, 26.897635803000057],
            [84.94425134300008, 26.915722554000055],
            [84.93856693500004, 26.936599834000035],
            [84.92404585800011, 26.95566843700003],
            [84.90156661000009, 26.967192281000038],
            [84.85175052900007, 26.982126770000022],
            [84.82828942900005, 26.994839172000056],
            [84.82813440000012, 26.994942526000088],
            [84.81748905400013, 27.01060048400005],
            [84.80193444900004, 27.013752747000083],
            [84.78550134300013, 27.008481751000076],
            [84.77196211800009, 26.999179993000055],
            [84.7606966560001, 26.999024963000082],
            [84.64023889200007, 27.02837717700008],
            [84.62726810700008, 27.036490377000078],
            [84.6214803470001, 27.057987773000022],
            [84.63036869400008, 27.08082875600003],
            [84.64452803500006, 27.103721415000038],
            [84.65439823400004, 27.12537384100004],
            [84.65982426000011, 27.165113017000024],
            [84.65765384900004, 27.203405253000128],
            [84.64819706300005, 27.240715637000065],
            [84.63191898600013, 27.277044169000035],
            [84.60654585800012, 27.310478821000018],
            [84.5770386150001, 27.329030660000072],
            [84.28940759300008, 27.376107890000057],
            [84.26770349200007, 27.388561910000035],
            [84.24889327000005, 27.412436422000027],
            [84.23902307100008, 27.43114329100011],
            [84.22553552300008, 27.440393372000116],
            [84.1952531340001, 27.43605255100003],
            [84.18584802300012, 27.43863637400004],
            [84.17509932500008, 27.46297597300007],
            [84.16574589100009, 27.472174378000048],
            [84.14171634900003, 27.480752666000072],
            [84.1309676510001, 27.486411235000034],
            [84.12156254100006, 27.49496368400004],
            [84.11717004400009, 27.51328297900004],
            [84.0995483800001, 27.51687449100011],
            [84.07960127800004, 27.509536438000012],
            [84.02890669800007, 27.453725891000047],
            [84.00766768400013, 27.440806783000127],
            [83.97583500200005, 27.439721578000032],
            [83.93594079600012, 27.446077780000067],
            [83.92302168800012, 27.449953511000032],
            [83.92204311000006, 27.449695761],
            [83.89987064700011, 27.44385569200007],
            [83.85351688700013, 27.440961813000072],
            [83.83408654800013, 27.43403717000008],
            [83.8427165120001, 27.418069153000047],
            [83.87119022600012, 27.389440410000063],
            [83.8736706950001, 27.380086975000026],
            [83.87764978000007, 27.36990671900007],
            [83.87739139900003, 27.361741842000058],
            [83.86752120000006, 27.358382873000053],
            [83.86173343900003, 27.354507142000088],
            [83.8546020920001, 27.345050354000122],
            [83.85334011200007, 27.346194023000052],
            [83.84798750900012, 27.35104482000004],
            [83.80199548400003, 27.365927633000084],
            [83.66339929300005, 27.432280172000034],
            [83.59043217000004, 27.456619771000035],
            [83.48098148600008, 27.469745585000098],
            [83.38703373200008, 27.470469056000084],
            [83.36098881100008, 27.462200826000057],
            [83.35592452000003, 27.45248565700011],
            [83.35385746300005, 27.440290019000102],
            [83.35582116800009, 27.42866282200005],
            [83.37096236200011, 27.41021433500002],
            [83.36956709800012, 27.398173726000053],
            [83.3627458090001, 27.38561635400005],
            [83.34114506000003, 27.35693593300006],
            [83.32435022000004, 27.341691386000022],
            [83.30486820500005, 27.33192454100005],
            [83.28244063400007, 27.330942688000093],
            [83.25949629800004, 27.338125713000025],
            [83.2494193930001, 27.348099263000037],
            [83.24311486900007, 27.36215525300007],
            [83.23159102400007, 27.381223856000034],
            [83.2192403570001, 27.393781230000045],
            [83.16963098200011, 27.431194967000025],
            [83.13278568600009, 27.444217428000073],
            [83.01046757100005, 27.443390604000044],
            [82.94716394100004, 27.457317403000033],
            [82.90127526900011, 27.48036509200007],
            [82.87626387600011, 27.487548116000127],
            [82.75213708500007, 27.49496368400004],
            [82.7297095130001, 27.518166402000062],
            [82.71885746300012, 27.556122742000056],
            [82.70924564600011, 27.630924377],
            [82.69705000800008, 27.669397481000047],
            [82.6796867270001, 27.694408875000036],
            [82.67389143300011, 27.696458430000078],
            [82.65214318800008, 27.704149883000085],
            [82.52615604700009, 27.67521108000004],
            [82.44068322800007, 27.666426086000044],
            [82.40192590400011, 27.67717478400006],
            [82.34792403200004, 27.726009013000024],
            [82.27040938300007, 27.760477193],
            [82.15103682400007, 27.84827545200004],
            [82.10742191600008, 27.863571675000102],
            [82.09036869300007, 27.87233083100007],
            [82.07166182500009, 27.890030009],
            [82.05161136900006, 27.90517120300011],
            [82.05021249900011, 27.90558612200006],
            [82.0272200930001, 27.912405904000067],
            [81.97590539600009, 27.91695343000002],
            [81.94639815300013, 27.905352072000042],
            [81.90609053500009, 27.863106588000065],
            [81.88319787600005, 27.84905059900005],
            [81.85565433700009, 27.850936788000055],
            [81.82785241700003, 27.86563873300007],
            [81.80015384900008, 27.88408722000007],
            [81.75013106300014, 27.909667054000025],
            [81.71039188600014, 27.9475200400001],
            [81.6889461670001, 27.96320383700008],
            [81.66543339000003, 27.97080027300005],
            [81.61504886900013, 27.98123891300007],
            [81.59536014800005, 27.994778138000058],
            [81.59510176600008, 27.994881490000083],
            [81.58218265800008, 28.013278300000067],
            [81.56192549700006, 28.025990703000033],
            [81.47345544400014, 28.066401672000026],
            [81.45821089700013, 28.077279562000072],
            [81.45402510600007, 28.086607157000103],
            [81.4529399010001, 28.097045797000035],
            [81.4482373460001, 28.111411845000035],
            [81.43526656100005, 28.12978281600003],
            [81.41733483900009, 28.147016907000122],
            [81.39604414900003, 28.16063364700001],
            [81.37320316600011, 28.167842509000067],
            [81.35790694200006, 28.165982157000073],
            [81.35144738800011, 28.156809591000084],
            [81.34726159700006, 28.144433086],
            [81.3381148690001, 28.132728373000035],
            [81.32369714400005, 28.12624298100006],
            [81.30705733200006, 28.1238141890001],
            [81.29620528100008, 28.128310038000038],
            [81.29940922000009, 28.1425210580001],
            [81.28307946800004, 28.146086731000068],
            [81.27677494300008, 28.153786520000054],
            [81.2807540280001, 28.161977234000076],
            [81.2959469000001, 28.167454936000055],
            [81.28235599800013, 28.191587830000017],
            [81.22432336400004, 28.25078318300011],
            [81.21073246300006, 28.27863678000007],
            [81.19037194900005, 28.33811635300013],
            [81.16970137600003, 28.361319072000057],
            [81.14634362800007, 28.3722486380001],
            [81.04706637000004, 28.389087804],
            [81.00040938300003, 28.397001649000046],
            [80.99317468300006, 28.407827861000087],
            [80.99131433200006, 28.420256043000066],
            [80.9878003340001, 28.430978902000064],
            [80.97601810700007, 28.43692169200007],
            [80.9605151780001, 28.432270814000034],
            [80.94118819200014, 28.432684225000045],
            [80.92134444200013, 28.436198222000073],
            [80.90527307200006, 28.44084910100004],
            [80.88666955600013, 28.452786357],
            [80.88186364800004, 28.46684234700011],
            [80.88036503100011, 28.481880189],
            [80.87225183100009, 28.496866353000073],
            [80.85798913600013, 28.502447409000084],
            [80.8170097260001, 28.502550761000023],
            [80.79840620900012, 28.505703024000084],
            [80.78166304500007, 28.514746399000032],
            [80.74352583900003, 28.549963887],
            [80.72709273300006, 28.559679057000054],
            [80.69577681500004, 28.567508036000063],
            [80.6786202400001, 28.57471689800012],
            [80.66818160000014, 28.586344097000094],
            [80.64833785000008, 28.61975291000006],
            [80.6356254480001, 28.627866109000067],
            [80.59852176900012, 28.633783061000074],
            [80.58136519400006, 28.638950704000067],
            [80.56358850100014, 28.647038066000064],
            [80.55687056500011, 28.655022075000048],
            [80.55738732900005, 28.664349671000068],
            [80.55904097500007, 28.67303131200005],
            [80.55583703600013, 28.67894826200005],
            [80.53444380100007, 28.679555368000095],
            [80.51759647600005, 28.680033468000133],
            [80.49754602100006, 28.670137431000043],
            [80.4876241450001, 28.65646901500004],
            [80.48493697100008, 28.63928660100008],
            [80.49341190600006, 28.575647074000088],
            [80.48845096900004, 28.562443746],
            [80.46881392500006, 28.571848857000035],
            [80.42654260300009, 28.616807353000056],
            [80.40835249900005, 28.626341655000047],
            [80.38830204300012, 28.627245993000102],
            [80.3690784100001, 28.622646789000058],
            [80.34975142400003, 28.620217998000086],
            [80.32970096800005, 28.627478537000073],
            [80.31833215400007, 28.64011342400009],
            [80.29104699700008, 28.689671123000053],
            [80.28339888500011, 28.6953555300001],
            [80.26520878100007, 28.69928293800008],
            [80.25704390500005, 28.7027452600001],
            [80.24939579300008, 28.71021250500003],
            [80.23895715300011, 28.726258037],
            [80.23327274600007, 28.732717591000053],
            [80.21642622900009, 28.74194183400006],
            [80.18118290200005, 28.74729034500011],
            [80.16206262200012, 28.753284811000057],
            [80.14759322100008, 28.763310038000057],
            [80.11421024600014, 28.80258412700003],
            [80.08186079900014, 28.819353129],
            [80.07305357600006, 28.820924647000098],
            [80.05478234800006, 28.824184876000103],
            [80.0363855390001, 28.837026469000094],
            [80.03028772000005, 28.877669983000132],
            [80.03111454300006, 28.897797953000108],
            [80.03390507000012, 28.915936381000037],
            [80.04051965400004, 28.932808737000116],
            [80.05292199700006, 28.94911265000006],
            [80.06842492700008, 28.959938864],
            [80.08516809100013, 28.967483623000035],
            [80.09943078600008, 28.977276306000093],
            [80.10790572100012, 28.99458791100001],
            [80.10790572100012, 28.99476877900007],
            [80.10470178300005, 29.027609151000078],
            [80.11307336500005, 29.072205913000104],
            [80.13260705600004, 29.11021392800002],
            [80.16350956300005, 29.1233655810001],
            [80.18056278500006, 29.12132436100005],
            [80.20144006400005, 29.121169332000093],
            [80.22066369600003, 29.12607859300003],
            [80.23306604000004, 29.139307760000023],
            [80.23048221800013, 29.154733174000015],
            [80.21373905400009, 29.196565246],
            [80.21880334400004, 29.21108632400002],
            [80.23606327400006, 29.213075867000057],
            [80.24867232300005, 29.204394226000105],
            [80.25818078600014, 29.202456360000085],
            [80.27874800600006, 29.26808542900001],
            [80.28277876900012, 29.29131398500003],
            [80.28009159300012, 29.310150045000043],
            [80.27275354000011, 29.315705261000048],
            [80.26355513600004, 29.315317688000064],
            [80.25497684700008, 29.316635437000016],
            [80.24949914600006, 29.326996562000105],
            [80.24216109200012, 29.367407532000087],
            [80.22097375500005, 29.4001187140001],
            [80.21373905400009, 29.416887716000062],
            [80.21766646400005, 29.434638570000075],
            [80.22831180800006, 29.441718242],
            [80.25745731700005, 29.450063986000075],
            [80.26345178200006, 29.459236552000064],
            [80.26624231000005, 29.47212982200007],
            [80.27306359800008, 29.47866689100003],
            [80.28205529800005, 29.48429962200005],
            [80.29115035000012, 29.494609070000067],
            [80.29146040900008, 29.49473826100011],
            [80.31151086400013, 29.508122457000027],
            [80.3200891520001, 29.515822245000024],
            [80.32722050000012, 29.524839783000075],
            [80.32763391200012, 29.529929911000053],
            [80.3250500900001, 29.535510966000075],
            [80.32360314900012, 29.541660462000053],
            [80.32722050000012, 29.548585103000036],
            [80.33269820200007, 29.552460836000094],
            [80.3451005450001, 29.558351949000084],
            [80.35078495300013, 29.562072652],
            [80.37331587800003, 29.58419016500001],
            [80.38520145600006, 29.604834900000114],
            [80.38675175000009, 29.626823222],
            [80.37755334500008, 29.652945659000082],
            [80.36391076700005, 29.679714050000072],
            [80.35440230300009, 29.704880473000102],
            [80.35429895100009, 29.730279440000103],
            [80.36897505700006, 29.757926330000103],
            [80.39522668500007, 29.776581523000075],
            [80.45486128700009, 29.79058583600009],
            [80.47615197800008, 29.806140442000114],
            [80.52731164500005, 29.86241607700002],
            [80.5495325120001, 29.893680319000097],
            [80.56286503100006, 29.92969879200008],
            [80.57133996600004, 29.946855367000055],
            [80.58622277800009, 29.95414174500003],
            [80.62229292800009, 29.958172506000025],
            [80.64141320800007, 29.96344350200006],
            [80.65412561000005, 29.970574849000073],
            [80.68017053200003, 29.99207224500013],
            [80.71582727100008, 30.013311259000105],
            [80.72574914600011, 30.02276804700007],
            [80.75572147700012, 30.06457428000003],
            [80.76967411300012, 30.077286682000093],
            [80.82982548000007, 30.11712921200011],
            [80.84966923100006, 30.143380840000034],
            [80.83644006400004, 30.170045879000085],
            [80.85039270000004, 30.181931458000022],
            [80.8679110110001, 30.200173238000062],
            [80.88368373459112, 30.210280032524576],
            [80.8838787660946, 30.210405146915726],
            [80.89364690080846, 30.198104359137524],
            [80.903309336412, 30.180432806924035],
            [80.92082703591576, 30.176660408536822],
            [80.98816225269584, 30.196555926350566],
            [80.99601688700011, 30.19696930000002],
            [81.00650720200008, 30.188907776000107],
            [81.01942631000009, 30.172267965000074],
            [81.0308984780001, 30.152734274000082],
            [81.04366255800005, 30.12022979700005],
            [81.06660689300008, 30.08715688100007],
            [81.07420332800007, 30.071912334000032],
            [81.08445364600004, 30.027875774000094],
            [81.08484867400006, 30.026178690000094],
            [81.09776778200006, 30.01692860900009],
            [81.12458785000007, 30.02276804700007],
            [81.14810062700013, 30.02323313400008],
            [81.19450606300006, 30.004474589],
            [81.21683028200005, 30.008195292000025],
            [81.22726892100007, 30.022457987000095],
            [81.22571862800004, 30.050466614000086],
            [81.2395162360001, 30.058786520000055],
            [81.25708622300004, 30.063540752000037],
            [81.2668013920001, 30.06994862900008],
            [81.2679026460001, 30.07205300500003],
            [81.27202071100004, 30.07992218],
            [81.27594812100006, 30.09537343300009],
            [81.27450118000007, 30.10219472300004],
            [81.26633630400005, 30.117749329000063],
            [81.26695642100003, 30.125087382000075],
            [81.27770511900007, 30.131856995000092],
            [81.29325972600009, 30.132838847000087],
            [81.30953780200008, 30.132063701000064],
            [81.3224052330001, 30.133769023000028],
            [81.33826989700003, 30.143535868000086],
            [81.35005212400011, 30.157230123000105],
            [81.35728682500007, 30.173559876000056],
            [81.36183435100014, 30.20477244100003],
            [81.37439172400013, 30.223117574000113],
            [81.37785404500005, 30.232626038],
            [81.37692386900011, 30.241204325000027],
            [81.3705159910001, 30.257275696000093],
            [81.36901737500006, 30.26606068900007],
            [81.36803552300012, 30.30104563400009],
            [81.37154952000009, 30.3169102990001],
            [81.38214318800004, 30.3312763470001],
            [81.38725915500004, 30.345125631000045],
            [81.3848820400001, 30.360938619000066],
            [81.38751753800011, 30.37390940300007],
            [81.40741296400012, 30.37918040000001],
            [81.4261198320001, 30.372514140000092],
            [81.46281010000007, 30.34135325100003],
            [81.48306726100009, 30.331896464000053],
            [81.5093705650001, 30.328382467000026],
            [81.52068770400007, 30.33194814000008],
            [81.53195316600005, 30.370343730000016],
            [81.53681075100008, 30.378560283000056],
            [81.54425215700007, 30.38264272100004],
            [81.56326908400007, 30.385588277000053],
            [81.57670495600007, 30.390962626000103],
            [81.58197595200005, 30.399437561000113],
            [81.58507653800007, 30.408119202000066],
            [81.59158776800007, 30.414268697000054],
            [81.61401534000004, 30.416904195000072],
            [81.63571944200004, 30.410961406000055],
            [81.7573657640001, 30.362902324000075],
            [81.77901818800007, 30.35804473900008],
            [81.80149743700008, 30.36130035400005],
            [81.82278812700008, 30.368173320000025],
            [81.84438887500005, 30.371170553000027],
            [81.88717696200007, 30.35499583000005],
            [81.92149011200007, 30.35737294600007],
            [81.94123050900004, 30.353962301000067],
            [81.95011885600007, 30.348381246000045],
            [81.96210778900013, 30.333653463000033],
            [81.96903243000008, 30.32827911400007],
            [81.97885095300006, 30.326832174000074],
            [81.98846276900008, 30.329777731],
            [81.99817793800014, 30.33406687500006],
            [82.00763472500006, 30.336805726000094],
            [82.04985437000005, 30.339234518000055],
            [82.07321211800013, 30.337219137000105],
            [82.08876672400004, 30.330087789000075],
            [82.09321089700006, 30.31473988900011],
            [82.08210046400012, 30.25732737300011],
            [82.0849943450001, 30.2308173630001],
            [82.09589807100008, 30.21345408200007],
            [82.11424320500004, 30.202188619000125],
            [82.14039148000006, 30.194023743000102],
            [82.15568770300013, 30.181363017000066],
            [82.15098514800013, 30.162242737000057],
            [82.1275757250001, 30.124363912000078],
            [82.12871260600008, 30.110773010000074],
            [82.13522383600014, 30.08974070200007],
            [82.14452559400007, 30.069431865000055],
            [82.15382735200012, 30.058166402],
            [82.17423954300006, 30.055479228000067],
            [82.19217126400014, 30.06147369400007],
            [82.21067142800007, 30.064419251000075],
            [82.25573327600011, 30.039666240000074],
            [82.27599043800012, 30.036927388000024],
            [82.2965059820001, 30.036824036],
            [82.31888187700014, 30.031811422000132],
            [82.32715010600009, 30.025713603000057],
            [82.33908736200004, 30.009228821000093],
            [82.34730391400007, 30.003441061000032],
            [82.36373702000003, 30.001167298],
            [82.37913659700013, 30.00323435500006],
            [82.39443282100007, 30.00313100200013],
            [82.40978072100006, 29.99460439100001],
            [82.4228548590001, 29.979669902000055],
            [82.43892622900006, 29.965768942000082],
            [82.4570646570001, 29.9540900680001],
            [82.47582320100008, 29.945511780000075],
            [82.52424401900004, 29.932385966000098],
            [82.54181400500005, 29.923239238000022],
            [82.61850183100006, 29.839833476000067],
            [82.63586511200009, 29.829033101000036],
            [82.64640710500004, 29.82934316100001],
            [82.66697432500013, 29.83502756700007],
            [82.67730961100006, 29.834407451000075],
            [82.68898848500004, 29.827741191000072],
            [82.68919519100007, 29.81957631400006],
            [82.68464766500006, 29.809706116000072],
            [82.68175378500007, 29.797717183000103],
            [82.69095218900003, 29.780741476000017],
            [82.75151696800003, 29.73932281500005],
            [82.77012048400007, 29.71415639300001],
            [82.78107588700004, 29.705113017000073],
            [82.7930648200001, 29.699506124000052],
            [82.80515710500009, 29.695966289000083],
            [82.81554406800012, 29.690126851000073],
            [82.82236535700014, 29.67795705200008],
            [82.83657637600004, 29.65979278600004],
            [82.8574536540001, 29.666200664000073],
            [82.88008793200004, 29.68110931400004],
            [82.89972497600007, 29.688421529000024],
            [82.90913008600012, 29.684623312],
            [82.92370284000009, 29.669662984000027],
            [82.93191939300004, 29.664185283000037],
            [82.9420996500001, 29.6629450490001],
            [82.96432051600004, 29.665890605000087],
            [82.9758960370001, 29.664030253000092],
            [83.03289514200009, 29.620467021000067],
            [83.04090498800014, 29.610286764000094],
            [83.05449589000011, 29.586050517],
            [83.06493453000007, 29.57878997800013],
            [83.07955896000004, 29.579642640000074],
            [83.08555342600005, 29.59039133800009],
            [83.08844730700014, 29.604421488000085],
            [83.09335656700006, 29.615144349000033],
            [83.10028120900006, 29.617676493000104],
            [83.12668786600005, 29.623412577000053],
            [83.15004561400008, 29.62563466400006],
            [83.16208622200014, 29.625169576000033],
            [83.17355839100009, 29.62126800500009],
            [83.18725264500011, 29.612095439000072],
            [83.19086999600006, 29.606901957000062],
            [83.19448734600007, 29.59364695300006],
            [83.19717452000009, 29.58909942700005],
            [83.2049259850001, 29.58491363600011],
            [83.22187585400007, 29.579823507000114],
            [83.22931726100012, 29.575947774000056],
            [83.25257165600004, 29.555199687000126],
            [83.26083988500011, 29.542048035000064],
            [83.26332035400009, 29.52708770800008],
            [83.25990970900006, 29.518767802000028],
            [83.25401859500005, 29.513290101000038],
            [83.24874760000012, 29.506572164000104],
            [83.24719730600009, 29.49473826100011],
            [83.26394047000014, 29.47300832100008],
            [83.32796757000006, 29.48502309200005],
            [83.35520105000012, 29.460735168000056],
            [83.35778487100004, 29.44275177100006],
            [83.35520105000012, 29.427972310000072],
            [83.35700972500013, 29.415363261000024],
            [83.38724043800005, 29.393504130000096],
            [83.38941084800013, 29.382445374],
            [83.38827396600004, 29.37022389700006],
            [83.39313155100012, 29.35624542300006],
            [83.40501713000009, 29.3464785770001],
            [83.41778120900005, 29.340897523000095],
            [83.42816817300007, 29.33345611600008],
            [83.4372115480001, 29.30524078400002],
            [83.44821862800012, 29.29676584900001],
            [83.47581384300008, 29.28692148900005],
            [83.49338383000008, 29.276146952000104],
            [83.50299564700009, 29.26103159600011],
            [83.51250410900008, 29.223488668000087],
            [83.51457116700004, 29.201810405000018],
            [83.51705163600008, 29.19170766200007],
            [83.52371789500012, 29.183594462000073],
            [83.53596521000003, 29.179227804000064],
            [83.56139001500003, 29.176230570000072],
            [83.57203536000003, 29.168401592000023],
            [83.58381758700006, 29.16214874300003],
            [83.62443526200008, 29.155456645000115],
            [83.63926639800013, 29.15475901300003],
            [83.65499238900003, 29.160413575000078],
            [83.65600956200007, 29.160779318000053],
            [83.66339929300005, 29.174809469000067],
            [83.66774011200005, 29.192327780000127],
            [83.67507816600005, 29.208760885000103],
            [83.6954903570001, 29.22617584200013],
            [83.71972660300008, 29.233591411000035],
            [83.74535811400006, 29.234469910000072],
            [83.77062788900008, 29.232247824000083],
            [83.79321049000004, 29.23475413100006],
            [83.83785892700007, 29.254003601000093],
            [83.86163008600005, 29.26020477300007],
            [83.86886478700012, 29.263434550000042],
            [83.87739139900003, 29.276767070000076],
            [83.88343754100003, 29.282012228],
            [83.91439172400004, 29.28940195700001],
            [83.93315026800008, 29.291779073000058],
            [83.94555261300013, 29.291830750000074],
            [83.9579549560001, 29.289040222000025],
            [83.96725671400003, 29.284699402000044],
            [83.97325118100008, 29.277025452000046],
            [83.97583500200005, 29.263744609000028],
            [83.98823734600012, 29.269532369],
            [84.00089807100005, 29.27252960200012],
            [84.01252526900004, 29.270204163000088],
            [84.02151696800007, 29.25976552300007],
            [84.0352112220001, 29.24762156200005],
            [84.05303959200006, 29.25036041300011],
            [84.07205651900011, 29.256974996000096],
            [84.08972985800011, 29.256613261],
            [84.09913496900009, 29.247001445000095],
            [84.10533614100007, 29.219922994000044],
            [84.11236413600005, 29.20909678200009],
            [84.12600671400008, 29.2062545780001],
            [84.14197473200011, 29.208269959000077],
            [84.15546228100004, 29.206642151000025],
            [84.16166345300007, 29.19253448500008],
            [84.15520389800008, 29.175946351000093],
            [84.14171634900003, 29.160262554000028],
            [84.13225956200006, 29.143803609000045],
            [84.13799564600004, 29.124657492000054],
            [84.16011316000004, 29.105485535000028],
            [84.16621097900008, 29.098457540000126],
            [84.16972497600005, 29.08892323900004],
            [84.17546106000009, 29.05740061400006],
            [84.19819869000008, 29.045308329000093],
            [84.22057458500007, 29.03890045200005],
            [84.2314266360001, 29.025981343000026],
            [84.20672530100012, 28.940663554000068],
            [84.2252905100001, 28.914115306],
            [84.23514733900004, 28.900020040000115],
            [84.28599694900004, 28.873742574000076],
            [84.3540031330001, 28.861288554000097],
            [84.36630212500006, 28.85674102800006],
            [84.37658573500005, 28.848834534],
            [84.39307051600014, 28.82433990500006],
            [84.41430953000008, 28.808268534],
            [84.42273278800008, 28.79917348300002],
            [84.43782230700009, 28.753336487000055],
            [84.45084476800014, 28.73388031000006],
            [84.4757528080001, 28.727291565000073],
            [84.49859379100008, 28.72786000600003],
            [84.51564701300003, 28.721400452000083],
            [84.53197676600007, 28.712692973000017],
            [84.55182051600008, 28.7063884490001],
            [84.6072176510001, 28.69819773400006],
            [84.61620935100007, 28.693650207000033],
            [84.62582116700008, 28.676080221000078],
            [84.63264245600004, 28.668793844000092],
            [84.65227950100007, 28.66238596600006],
            [84.67114139800009, 28.658949483000114],
            [84.68297530100011, 28.65075876900009],
            [84.67775598100008, 28.604405009000075],
            [84.69083011900005, 28.596136780000037],
            [84.73661543800006, 28.594173075000114],
            [84.75563236500005, 28.58541392100004],
            [84.78178064000014, 28.558903910000126],
            [84.79914392100005, 28.54663075800009],
            [84.81195967600013, 28.54197987900004],
            [84.82394860900007, 28.540532939000045],
            [84.87929406700005, 28.54363352400007],
            [84.89143802900003, 28.541773173000067],
            [84.90787113500011, 28.537018942000074],
            [84.91872318600014, 28.535675354000105],
            [84.92849003100008, 28.53846588100008],
            [84.93644820200007, 28.544770406000097],
            [84.94895389800007, 28.568283183000077],
            [84.95494836400007, 28.57430348700011],
            [84.9847656660001, 28.588592021000082],
            [84.99406742400004, 28.5908141070001],
            [85.00249068200003, 28.594431458000074],
            [85.00915694200012, 28.60254465700008],
            [85.01876875900012, 28.619856262],
            [85.02527998900013, 28.62840871200011],
            [85.03210127800014, 28.634067281000043],
            [85.05494226100006, 28.63869232200001],
            [85.07504439300004, 28.6316643280001],
            [85.11188968900012, 28.6088233440001],
            [85.16098230000006, 28.59499989900003],
            [85.16801029400006, 28.583191833000043],
            [85.1569515380001, 28.533143209000045],
            [85.15374760000003, 28.52490081800009],
            [85.14764978100004, 28.515831604000127],
            [85.14036340400008, 28.510922343000075],
            [85.1231551510001, 28.504591980000058],
            [85.11721236200009, 28.4973314410001],
            [85.11566206800006, 28.491492005000012],
            [85.11555871600012, 28.4727334600001],
            [85.10946089700008, 28.45929758700005],
            [85.08367435700006, 28.44552581800012],
            [85.07757653800013, 28.435681457000058],
            [85.08568973800004, 28.38100779200009],
            [85.08568973800004, 28.361525777000097],
            [85.0818671020001, 28.331702005000082],
            [85.08021203600003, 28.318789368000083],
            [85.08739506100005, 28.304113261000097],
            [85.10940922100008, 28.292253520000074],
            [85.13416223200011, 28.291969300000105],
            [85.15457442200005, 28.30085764600001],
            [85.1735913490001, 28.30431996600005],
            [85.20573409100012, 28.278275045000086],
            [85.22392419500005, 28.2716863000001],
            [85.24340620900006, 28.267913921000073],
            [85.25958093300005, 28.266932068000088],
            [85.27312015800004, 28.269825949000094],
            [85.30102543200013, 28.28106557200003],
            [85.31260095200008, 28.282770895000098],
            [85.32572676600006, 28.277396546000134],
            [85.33482181800008, 28.268689067000068],
            [85.3453638100001, 28.261247660000052],
            [85.36257206200014, 28.259671529000016],
            [85.37781661000008, 28.265976054000035],
            [85.40138106300009, 28.288791199000045],
            [85.41523034700003, 28.2964393110001],
            [85.43156010000007, 28.297059428000082],
            [85.4466496170001, 28.29215016700006],
            [85.47569177300011, 28.279101868000012],
            [85.49755090300005, 28.282615865000068],
            [85.5206502690001, 28.282925924000054],
            [85.54369795800005, 28.28039377900005],
            [85.56529870600014, 28.27538116400008],
            [85.58550419100004, 28.263185526000072],
            [85.59894006300004, 28.25083486000004],
            [85.61180749500005, 28.251144918000094],
            [85.6390926520001, 28.287886862000093],
            [85.6469474700001, 28.293700460000068],
            [85.66813480600007, 28.30054758800013],
            [85.67505944900006, 28.306387024000017],
            [85.67619633000004, 28.315120341000082],
            [85.67598962500011, 28.32473215800009],
            [85.67914188700007, 28.332897034000027],
            [85.69293949400003, 28.33522247300006],
            [85.6980037840001, 28.31344085700003],
            [85.69976078300004, 28.269102478],
            [85.71557377100004, 28.243367615000082],
            [85.7344873450001, 28.221534323000057],
            [85.7566048590001, 28.203240866],
            [85.78275313300003, 28.188099671000074],
            [85.82688480700011, 28.170478007],
            [85.84827885000004, 28.158928325000048],
            [85.86336836800012, 28.14334788000012],
            [85.86703739500012, 28.13293508],
            [85.87173995000006, 28.110920919000094],
            [85.88910323100004, 28.090276184000103],
            [85.89106693500014, 28.080896912000057],
            [85.88982670100012, 28.071259257000023],
            [85.89044681900009, 28.059192810000056],
            [85.8983016360001, 28.03601593000006],
            [85.9089469810001, 28.022425029000075],
            [85.94398360200012, 27.99472646100004],
            [85.95659265100005, 27.9762262980001],
            [85.95628259300008, 27.956873474000062],
            [85.95183841900007, 27.936797181000102],
            [85.95121830300008, 27.916229961000013],
            [85.9626904700001, 27.891373596000065],
            [85.98026045800009, 27.88517242400006],
            [86.02645918800005, 27.88992665600007],
            [86.0514189050001, 27.887549540000023],
            [86.05459969400005, 27.888013072],
            [86.06170251500009, 27.889048157000033],
            [86.07565515100009, 27.894784241000067],
            [86.10717777500008, 27.922844544],
            [86.11286218300012, 27.926797791000084],
            [86.11224206500003, 27.93726226900013],
            [86.10717777500008, 27.9442385870001],
            [86.10056319200004, 27.950233053000048],
            [86.09560225500013, 27.957855326000114],
            [86.09508549000009, 27.968888245000116],
            [86.09803104700006, 27.977518209000053],
            [86.09813439900012, 27.985631409000078],
            [86.08940108300004, 27.99472646100004],
            [86.08940108300004, 27.994881490000083],
            [86.08929772900012, 27.994881490000083],
            [86.07916914900005, 28.001134339000075],
            [86.07761885600013, 28.00694793700005],
            [86.07953088400006, 28.013329977000083],
            [86.07953088400006, 28.021649882000062],
            [86.08392338100003, 28.038548076000055],
            [86.08469852700006, 28.04387074800009],
            [86.0815462650001, 28.0516997270001],
            [86.07017745000013, 28.066711731000098],
            [86.06873050900003, 28.07676279700003],
            [86.1559603280001, 28.156525371],
            [86.17601078300004, 28.15301137300004],
            [86.18603601100011, 28.133529358000047],
            [86.18717289300008, 28.108698832000087],
            [86.18076501500008, 28.088751729000094],
            [86.17223840400004, 28.071827698000092],
            [86.17446049000006, 28.062448425000028],
            [86.18185022000006, 28.054877828000073],
            [86.18913659700013, 28.043612366000033],
            [86.19600956200009, 28.01457021100002],
            [86.20303755700013, 28.00258127900007],
            [86.21776534000003, 27.99498484300001],
            [86.21792037000006, 27.99493316600008],
            [86.21838545700007, 27.99472646100004],
            [86.23853926600003, 27.98955881800005],
            [86.25900313300014, 27.987646790000028],
            [86.27807173600007, 27.98369354300003],
            [86.29465987200012, 27.97237640400006],
            [86.31822432400003, 27.945788880000052],
            [86.3277327880001, 27.93969106100009],
            [86.33755131000004, 27.93803741500004],
            [86.34561283400006, 27.940931295000027],
            [86.35367435800003, 27.944807028000085],
            [86.36297611500004, 27.946098938000105],
            [86.37196781400013, 27.941964824000095],
            [86.40571252400008, 27.917005107000122],
            [86.42529789200012, 27.909925435],
            [86.43883711700005, 27.91085561100006],
            [86.47547570800003, 27.927598775],
            [86.49692142700007, 27.937882385000094],
            [86.51046065300005, 27.952429301000038],
            [86.51676433500006, 27.971432200000024],
            [86.51645511900006, 27.99472646100004],
            [86.51619673700009, 28.012244771],
            [86.52229455600013, 28.02371694000003],
            [86.5309245200001, 28.03369049100003],
            [86.53836592600004, 28.047178040000077],
            [86.54074304200009, 28.06216420600005],
            [86.54125980600003, 28.078209738000012],
            [86.54415368700006, 28.09301503600004],
            [86.55355879700005, 28.104151306000077],
            [86.56952681500007, 28.106605937000026],
            [86.58311771700005, 28.098027649000088],
            [86.59686364700013, 28.086503805000078],
            [86.6123149010001, 28.080276794000085],
            [86.62714603700005, 28.08348073300006],
            [86.64947025600003, 28.101179911000074],
            [86.66197595200009, 28.106838481000082],
            [86.68006270300003, 28.105727437],
            [86.69964807100013, 28.098751119],
            [86.71768314700006, 28.088260804000058],
            [86.73173913600004, 28.07691782600007],
            [86.73597660400003, 28.064851380000093],
            [86.7322042240001, 28.03495656300008],
            [86.73980065900014, 28.02149485300002],
            [86.76997969600006, 28.01208974300006],
            [86.84046634900011, 28.014776917000077],
            [86.86816491700012, 27.994881490000083],
            [86.86816491700012, 27.99472646100004],
            [86.87689823400012, 27.970645243],
            [86.89307295800012, 27.954186300000018],
            [86.91472538200009, 27.945117086000053],
            [86.94035689300006, 27.943101705000018],
            [86.97022587100014, 27.947442525],
            [86.98209267100003, 27.950674405000072],
            [86.98872603400008, 27.952480978000054],
            [87.0056759040001, 27.951499126],
            [87.03053226700013, 27.938089091000037],
            [87.06200321500012, 27.9084268190001],
            [87.11652185100013, 27.84458058700004],
            [87.15579593900009, 27.825796204000042],
            [87.18199589000011, 27.82450429300009],
            [87.23289717600005, 27.829723613000013],
            [87.29051639800008, 27.816081035000096],
            [87.31392582200004, 27.8285867310001],
            [87.33583662900008, 27.846363424000018],
            [87.36384525500011, 27.855251770000038],
            [87.38534265100003, 27.849412334000064],
            [87.38069177200009, 27.83582143200006],
            [87.36911625200014, 27.819078268000013],
            [87.36911625200014, 27.803937073],
            [87.38678959100014, 27.804402161000027],
            [87.47556970200009, 27.82670054200007],
            [87.51453373200013, 27.835201314000088],
            [87.53158695500008, 27.836803284000027],
            [87.55132735200004, 27.83189402300009],
            [87.5559782310001, 27.827088115],
            [87.55980228700014, 27.819078268000013],
            [87.56507328300006, 27.810861715000087],
            [87.57334151200013, 27.805022278000095],
            [87.58998132300013, 27.804608867000084],
            [87.62109053600011, 27.81954335600004],
            [87.63607670100009, 27.82365163200005],
            [87.65995121300006, 27.819879252000035],
            [87.67852882500011, 27.813351022000077],
            [87.70046553600008, 27.80564239500005],
            [87.72682051600003, 27.807761129000042],
            [87.75637943500004, 27.82037017900005],
            [87.77984053500012, 27.839438782000045],
            [87.79865075700013, 27.863468323000077],
            [87.81415368700004, 27.890960185000054],
            [87.82588423700014, 27.906566467000076],
            [87.83668461200006, 27.908323467000073],
            [87.85611495000006, 27.898608297000024],
            [87.93455977400009, 27.895301006000025],
            [87.9452051190001, 27.892303772],
            [87.96639245600011, 27.8827436320001],
            [87.9784330650001, 27.880521545000093],
            [87.99181726100005, 27.882640280000075],
            [88.01812056500006, 27.892148743000078],
            [88.02995446800008, 27.893337301000074],
            [88.05279545100012, 27.88651601100004],
            [88.09573856600008, 27.86532867500007],
            [88.11821781400005, 27.860884501000058],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Yemen',
        iso3: 'YEM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [51.97861495000012, 18.99563751300012],
              [51.985688749000076, 18.97973180600009],
              [52.01396162900011, 18.91615916000002],
              [52.05674971500014, 18.819627584],
              [52.099537801000054, 18.72304433200007],
              [52.142325887000084, 18.626512757000043],
              [52.18501062000007, 18.529929504000094],
              [52.2277987060001, 18.433423767000065],
              [52.27069014500006, 18.336866353000048],
              [52.31332320200005, 18.240283102000078],
              [52.35616296400008, 18.14377736400006],
              [52.39900272600005, 18.047271627000057],
              [52.44173913600014, 17.9506366990001],
              [52.484527222000054, 17.85415679900008],
              [52.52741866000014, 17.75762522400005],
              [52.57020674700004, 17.66109364800012],
              [52.61283980300004, 17.56456207300009],
              [52.65562788900007, 17.467978821000045],
              [52.6984159750001, 17.371447246000017],
              [52.73014530500012, 17.299875387000085],
              [52.72828495300007, 17.299358622000042],
              [52.723013957000035, 17.29868682900006],
              [52.721463664000055, 17.298170065000093],
              [52.736243124000055, 17.28917836500007],
              [52.7738635660001, 17.287111308000092],
              [52.79102014100005, 17.281220195000103],
              [52.80156213400011, 17.26742258700007],
              [52.840319458000124, 17.183706767],
              [52.902744588000076, 17.0482628380001],
              [52.96527307200006, 16.912922262000038],
              [53.027904908000096, 16.777478333000133],
              [53.09034264400003, 16.642401434000078],
              [53.09001712300005, 16.642238674000055],
              [53.06918379000007, 16.63182200700004],
              [53.021820509000065, 16.61945221600007],
              [52.98487389400003, 16.628159898000092],
              [52.97388756600009, 16.618312893000052],
              [52.96216881600009, 16.61627838700008],
              [52.95053144600007, 16.615627346000053],
              [52.94027754000007, 16.610174872000073],
              [52.92115319100009, 16.591131903000075],
              [52.90992272200003, 16.58307526200008],
              [52.88526451900003, 16.575425523000092],
              [52.85108483200008, 16.55613841400009],
              [52.80909264400003, 16.54832591400009],
              [52.78882897200003, 16.53969961100006],
              [52.75212649800005, 16.51829661700009],
              [52.73682701900003, 16.51194896000004],
              [52.597666863000086, 16.476711330000057],
              [52.53256269600007, 16.44725169500009],
              [52.42042076900003, 16.371242580000057],
              [52.31861412900008, 16.291164455000057],
              [52.29273522200003, 16.263820705000057],
              [52.27947024800005, 16.243882554000038],
              [52.26140384200005, 16.20897044500009],
              [52.22868899800005, 16.171942450000074],
              [52.221446160000085, 16.16087474200009],
              [52.21705162900008, 16.148382880000042],
              [52.21705162900008, 16.13808828300006],
              [52.21957441500007, 16.12596263200004],
              [52.222666863000086, 16.116400458000044],
              [52.22437584700003, 16.11359284100007],
              [52.216807488000086, 16.09516022300005],
              [52.194346550000034, 16.07029857000009],
              [52.18409264400003, 16.029445705000057],
              [52.16000410200007, 16.002101955000057],
              [52.15552819100009, 15.983872789000088],
              [52.16342207100007, 15.964789130000042],
              [52.17741946700005, 15.94236888200004],
              [52.186534050000034, 15.919094143000052],
              [52.17546634200005, 15.87791575700004],
              [52.19157962300005, 15.862982489000046],
              [52.22437584700003, 15.84674713700008],
              [52.225271030000044, 15.83193594000005],
              [52.21705162900008, 15.76072825700004],
              [52.221446160000085, 15.716986395000049],
              [52.231211785000085, 15.674750067000048],
              [52.238291863000086, 15.668646552000041],
              [52.242849155000044, 15.663478908000059],
              [52.244883660000085, 15.657700914000088],
              [52.24382571700005, 15.651556708000044],
              [52.23853600400008, 15.642523505000042],
              [52.23747806100005, 15.637518622000073],
              [52.23658287900008, 15.629339911000045],
              [52.23357181100005, 15.621771552000041],
              [52.22836347700007, 15.616115627000056],
              [52.220713738000086, 15.613959052000041],
              [52.19898522200003, 15.611476955000057],
              [52.04712975400008, 15.570013739000046],
              [52.03874759200005, 15.56313711100006],
              [52.03150475400008, 15.555812893000052],
              [52.025726759000065, 15.551214911000045],
              [52.01693769600007, 15.548651434000078],
              [52.00163821700005, 15.547267971000053],
              [51.99170983200008, 15.545070705000057],
              [51.913096550000034, 15.515326239000046],
              [51.87419681100005, 15.491522528000075],
              [51.875010613000086, 15.46938711100006],
              [51.87419681100005, 15.465033270000049],
              [51.871836785000085, 15.463771877000056],
              [51.86939537900008, 15.463771877000056],
              [51.868174675000034, 15.46312083500004],
              [51.86866295700008, 15.451564846000053],
              [51.86540774800005, 15.450100002000056],
              [51.85987389400003, 15.453314520000049],
              [51.853851759000065, 15.45571523600006],
              [51.84652754000007, 15.459540106000077],
              [51.83871504000007, 15.466294664000088],
              [51.82927493600005, 15.468695380000042],
              [51.81666100400008, 15.459418036000045],
              [51.80941816500007, 15.455755927000041],
              [51.758799675000034, 15.44562409100007],
              [51.67994225400008, 15.403469143000052],
              [51.66724694100009, 15.391424872000073],
              [51.662119988000086, 15.377142645000049],
              [51.66773522200003, 15.35765208500004],
              [51.676524285000085, 15.346991278000075],
              [51.676442905000044, 15.340277411000045],
              [51.655284050000034, 15.33274974200009],
              [51.549489780000044, 15.32298411700009],
              [51.53052819100009, 15.316839911000045],
              [51.51343834700003, 15.30805084800005],
              [51.49830162900008, 15.298041083000044],
              [51.47429446700005, 15.270697333000044],
              [51.45427493600005, 15.26951732000009],
              [51.44654381600009, 15.266424872000073],
              [51.44361412900008, 15.260199286000045],
              [51.43246504000007, 15.25967031500005],
              [51.38200931100005, 15.238023179000038],
              [51.367849155000044, 15.229722398000092],
              [51.342458530000044, 15.237697658000059],
              [51.314463738000086, 15.226711330000057],
              [51.28842207100007, 15.210272528000075],
              [51.26880944100009, 15.20180898600006],
              [51.06983483200008, 15.149644273000092],
              [50.85132897200003, 15.109930731000077],
              [50.66146894600007, 15.05849844000005],
              [50.55404707100007, 15.048570054000038],
              [50.45948326900003, 15.010443427000041],
              [50.432383660000085, 14.995428778000075],
              [50.35824629000007, 14.933335679000038],
              [50.34302819100009, 14.924750067000048],
              [50.30225670700008, 14.917466539000088],
              [50.24382571700005, 14.887152411000045],
              [50.17953535200007, 14.843329169000071],
              [50.165049675000034, 14.842474677000041],
              [50.14625084700003, 14.849798895000049],
              [50.121429884000065, 14.844224351000037],
              [50.07935631600009, 14.825669664000088],
              [50.06039472700007, 14.82021719000005],
              [50.051768425000034, 14.818752346000053],
              [50.04184004000007, 14.81826406500005],
              [50.035817905000044, 14.83893463700008],
              [50.02979576900003, 14.850287177000041],
              [50.02100670700008, 14.849269924000055],
              [50.00603274800005, 14.84438711100006],
              [49.942149285000085, 14.838771877000056],
              [49.79859459700003, 14.792181708000044],
              [49.578135613000086, 14.73729075700004],
              [49.46045983200008, 14.673570054000038],
              [49.41781660200007, 14.656927802000041],
              [49.37240644600007, 14.649807033000059],
              [49.35206139400009, 14.639797268000052],
              [49.31275475400008, 14.612779039000088],
              [49.228851759000065, 14.57526276200008],
              [49.190196160000085, 14.548570054000038],
              [49.18189537900008, 14.51658763200004],
              [49.171885613000086, 14.518255927000041],
              [49.15674889400009, 14.52610911700009],
              [49.137054884000065, 14.53266022300005],
              [49.11353600400008, 14.530218817000048],
              [49.092784050000034, 14.519598700000074],
              [49.07797285200007, 14.50608958500004],
              [49.028086785000085, 14.436346747000073],
              [49.00993899800005, 14.40110911700009],
              [49.00025475400008, 14.359564520000049],
              [49.00798587300005, 14.354437567000048],
              [49.008555535000085, 14.343003648000092],
              [49.00603274800005, 14.331203518000052],
              [49.00367272200003, 14.324774481000077],
              [48.99154707100007, 14.316880601000037],
              [48.95053144600007, 14.300604559000078],
              [48.94166100400008, 14.29437897300005],
              [48.93580162900008, 14.270453192000048],
              [48.92156009200005, 14.261867580000057],
              [48.90349368600005, 14.258490302000041],
              [48.88697350400008, 14.25031159100007],
              [48.88233483200008, 14.24323151200008],
              [48.88038170700008, 14.23460521000004],
              [48.88013756600009, 14.212103583000044],
              [48.876963738000086, 14.206732489000046],
              [48.869883660000085, 14.201361395000049],
              [48.86296634200005, 14.194647528000075],
              [48.852549675000034, 14.16697825700004],
              [48.83529707100007, 14.15623607000009],
              [48.797618035000085, 14.140448309000078],
              [48.738291863000086, 14.068182684000078],
              [48.719493035000085, 14.05727773600006],
              [48.71371504000007, 14.05540599200009],
              [48.701833530000044, 14.046698309000078],
              [48.69581139400009, 14.04360586100006],
              [48.68930097700007, 14.04242584800005],
              [48.68148847700007, 14.04360586100006],
              [48.564789259000065, 14.046047268000052],
              [48.54810631600009, 14.040513414000088],
              [48.50342858200008, 14.002630927000041],
              [48.49382571700005, 13.998968817000048],
              [48.48552493600005, 13.998480536000045],
              [48.477549675000034, 13.99673086100006],
              [48.468760613000086, 13.988959052000041],
              [48.45045006600009, 14.010646877000056],
              [48.41537519600007, 14.016831773000092],
              [48.338226759000065, 14.016302802000041],
              [48.34115644600007, 14.012396552000041],
              [48.345713738000086, 14.002630927000041],
              [48.30420983200008, 14.001898505000042],
              [48.18873131600009, 13.969142971000053],
              [48.19361412900008, 13.993394273000092],
              [48.17758222700007, 14.009182033000059],
              [48.155284050000034, 14.020209052000041],
              [48.14039147200003, 14.030585028000075],
              [48.133555535000085, 14.023138739000046],
              [48.10596764400009, 14.036037502000056],
              [48.01685631600009, 14.05727773600006],
              [48.00163821700005, 14.04913971600007],
              [47.94857832100007, 14.033392645000049],
              [47.93116295700008, 14.030585028000075],
              [47.91732832100007, 14.02138906500005],
              [47.86654707100007, 13.96165599200009],
              [47.820974155000044, 13.93846263200004],
              [47.66724694100009, 13.887193101000037],
              [47.64568118600005, 13.873195705000057],
              [47.56421959700003, 13.789129950000074],
              [47.43604576900009, 13.67804596600007],
              [47.39820397200003, 13.654852606000077],
              [47.16684004000007, 13.585598049000055],
              [46.91187584700003, 13.533270575000074],
              [46.824229363000086, 13.476304429000038],
              [46.70069420700008, 13.43032461100006],
              [46.68384850400008, 13.427232164000088],
              [46.66391035200007, 13.430080471000053],
              [46.62826582100007, 13.440822658000059],
              [46.60474694100009, 13.440904039000088],
              [46.58350670700008, 13.435126044000071],
              [46.54021243600005, 13.416896877000056],
              [46.52003014400009, 13.413031317000048],
              [46.31299889400009, 13.413560289000088],
              [46.269541863000086, 13.420477606000077],
              [46.24781334700003, 13.432114976000037],
              [46.23454837300005, 13.436346747000073],
              [46.22868899800005, 13.431057033000059],
              [46.22413170700008, 13.42869700700004],
              [46.19752037900008, 13.420477606000077],
              [46.111338738000086, 13.406805731000077],
              [45.94060306100005, 13.399359442000048],
              [45.92318769600007, 13.395453192000048],
              [45.89047285200007, 13.382310289000088],
              [45.875743035000085, 13.379461981000077],
              [45.83375084700003, 13.381333726000037],
              [45.815440300000034, 13.37954336100006],
              [45.803477410000085, 13.372015692000048],
              [45.66578209700003, 13.341986395000049],
              [45.63209069100009, 13.324896552000041],
              [45.535899285000085, 13.228664455000057],
              [45.508474155000044, 13.208685614000046],
              [45.494151238000086, 13.194647528000075],
              [45.481455925000034, 13.157538153000075],
              [45.43409264400009, 13.098334052000041],
              [45.403005405000044, 13.070135809000078],
              [45.365244988000086, 13.05369700700004],
              [45.19353274800005, 13.01268138200004],
              [45.15406334700003, 12.992132880000042],
              [45.118174675000034, 12.961737372000073],
              [45.104502800000034, 12.944891669000071],
              [45.09945722700007, 12.93618398600006],
              [45.093760613000086, 12.926255601000037],
              [45.093190951000054, 12.924709377000056],
              [45.086599155000044, 12.90729401200008],
              [45.083994988000086, 12.889471747000073],
              [45.08228600400008, 12.88662344000005],
              [45.05876712300005, 12.82713450700004],
              [45.056651238000086, 12.81712474200009],
              [45.06202233200008, 12.776556708000044],
              [45.058604363000086, 12.76203034100007],
              [45.03931725400008, 12.756293036000045],
              [45.01775149800005, 12.759833075000074],
              [44.99463951900009, 12.769191799000055],
              [44.97934004000007, 12.78229401200008],
              [44.98096764400009, 12.797308661000045],
              [44.99740644600007, 12.80345286700009],
              [45.01775149800005, 12.80174388200004],
              [45.035166863000086, 12.803656317000048],
              [45.04249108200008, 12.820868231000077],
              [45.03858483200008, 12.821234442000048],
              [45.02328535200007, 12.841050523000092],
              [45.02198326900009, 12.845119533000059],
              [45.02003014400009, 12.848944403000075],
              [45.021494988000086, 12.853461005000042],
              [45.021494988000086, 12.857163804000038],
              [45.01514733200008, 12.858710028000075],
              [45.00928795700008, 12.856675523000092],
              [45.008474155000044, 12.852240302000041],
              [45.00928795700008, 12.84756094000005],
              [45.00831139400009, 12.845119533000059],
              [45.00123131600009, 12.833482164000088],
              [44.998057488000086, 12.831447658000059],
              [44.99301191500007, 12.832464911000045],
              [44.98365319100009, 12.837144273000092],
              [44.977549675000034, 12.83820221600007],
              [44.955088738000086, 12.837062893000052],
              [44.94459069100009, 12.83397044500009],
              [44.940114780000044, 12.82802969000005],
              [44.93311608200008, 12.812648830000057],
              [44.916758660000085, 12.79946523600006],
              [44.89828535200007, 12.796210028000075],
              [44.884776238000086, 12.810939846000053],
              [44.87159264400009, 12.803534247000073],
              [44.86744225400008, 12.79482656500005],
              [44.871836785000085, 12.769964911000045],
              [44.87940514400009, 12.77643463700008],
              [44.885427280000044, 12.77798086100006],
              [44.91627037900008, 12.774888414000088],
              [44.920909050000034, 12.77138906500005],
              [44.918955925000034, 12.759426174000055],
              [44.912771030000044, 12.748195705000057],
              [44.89828535200007, 12.736761786000045],
              [44.88135826900009, 12.729885158000059],
              [44.86833743600005, 12.732123114000046],
              [44.83961022200003, 12.743475653000075],
              [44.830821160000085, 12.748846747000073],
              [44.824880405000044, 12.757025458000044],
              [44.824961785000085, 12.76162344000005],
              [44.822601759000065, 12.76508209800005],
              [44.80974368600005, 12.769964911000045],
              [44.785166863000086, 12.772284247000073],
              [44.76490319100009, 12.765570380000042],
              [44.72779381600009, 12.742010809000078],
              [44.72673587300005, 12.746527411000045],
              [44.72291100400008, 12.752346096000053],
              [44.72095787900008, 12.756293036000045],
              [44.725596550000034, 12.766506252000056],
              [44.71924889400009, 12.780096747000073],
              [44.70687910200007, 12.793646552000041],
              [44.69361412900008, 12.80345286700009],
              [44.652354363000086, 12.817938544000071],
              [44.61060631600009, 12.819566148000092],
              [44.57276451900009, 12.81159088700008],
              [44.54281660200007, 12.797308661000045],
              [44.48991946700005, 12.753485419000071],
              [44.43295332100007, 12.69358958500004],
              [44.43083743600005, 12.688177802000041],
              [44.42351321700005, 12.675970770000049],
              [44.41553795700008, 12.67015208500004],
              [44.41179446700005, 12.684027411000045],
              [44.406993035000085, 12.685248114000046],
              [44.383474155000044, 12.676336981000077],
              [44.35434004000007, 12.669338283000059],
              [44.28956139400009, 12.63898346600007],
              [44.26734459700003, 12.636786200000074],
              [44.24732506600009, 12.63898346600007],
              [44.228526238000086, 12.63865794500009],
              [44.19117272200003, 12.61912669500009],
              [44.16911868600005, 12.61815013200004],
              [44.149424675000034, 12.62498607000009],
              [44.13803144600007, 12.63898346600007],
              [44.15162194100009, 12.637884833000044],
              [44.176117384000065, 12.633246161000045],
              [44.18995201900009, 12.632147528000075],
              [44.19841556100005, 12.639064846000053],
              [44.198008660000085, 12.65224844000005],
              [44.19117272200003, 12.66046784100007],
              [44.179698113000086, 12.65265534100007],
              [44.15349368600005, 12.655951239000046],
              [44.12134850400008, 12.643377997000073],
              [44.06234785200007, 12.611721096000053],
              [44.03370201900009, 12.604315497000073],
              [44.01710045700008, 12.603705145000049],
              [43.99170983200008, 12.612127997000073],
              [43.96143639400009, 12.59959544500009],
              [43.946299675000034, 12.598049221000053],
              [43.92709394600007, 12.610174872000073],
              [43.90943444100009, 12.645331122000073],
              [43.89478600400008, 12.65265534100007],
              [43.87419681100005, 12.655462958000044],
              [43.857758009000065, 12.662543036000045],
              [43.82960045700008, 12.680609442000048],
              [43.813487175000034, 12.688381252000056],
              [43.79468834700003, 12.694891669000071],
              [43.773773634000065, 12.699408270000049],
              [43.75147545700008, 12.701117255000042],
              [43.73780358200008, 12.705755927000041],
              [43.69947350400008, 12.727850653000075],
              [43.67945397200003, 12.735256252000056],
              [43.64405358200008, 12.734564520000049],
              [43.63461347700007, 12.738674221000053],
              [43.61939537900008, 12.749579169000071],
              [43.60962975400008, 12.754339911000045],
              [43.600596550000034, 12.756293036000045],
              [43.58773847700007, 12.751369533000059],
              [43.53077233200008, 12.695502020000049],
              [43.52556399800005, 12.690375067000048],
              [43.511729363000086, 12.683172919000071],
              [43.49073326900009, 12.680609442000048],
              [43.46802819100009, 12.68390534100007],
              [43.46225019600007, 12.69334544500009],
              [43.481211785000085, 12.77342357000009],
              [43.48194420700008, 12.812079169000071],
              [43.47315514400009, 12.846625067000048],
              [43.45289147200003, 12.878607489000046],
              [43.422618035000085, 12.906195380000042],
              [43.418711785000085, 12.916449286000045],
              [43.41553795700008, 12.928900458000044],
              [43.40845787900008, 12.93695709800005],
              [43.401377800000034, 12.943426825000074],
              [43.39820397200003, 12.95115794500009],
              [43.396820509000065, 12.970851955000057],
              [43.392914259000065, 12.98969147300005],
              [43.38640384200005, 13.00726959800005],
              [43.37712649800005, 13.023179429000038],
              [43.341807488000086, 13.062648830000057],
              [43.33619225400008, 13.074408270000049],
              [43.334727410000085, 13.082180080000057],
              [43.32252037900008, 13.10578034100007],
              [43.31299889400009, 13.131252346000053],
              [43.30884850400008, 13.13930898600006],
              [43.24887129000007, 13.212713934000078],
              [43.22632897200003, 13.283880927000041],
              [43.23959394600007, 13.315130927000041],
              [43.24830162900008, 13.348944403000075],
              [43.254242384000065, 13.526556708000044],
              [43.27466881600009, 13.55760325700004],
              [43.27849368600005, 13.566595770000049],
              [43.280284050000034, 13.57412344000005],
              [43.28451582100007, 13.58038971600007],
              [43.29517662900008, 13.585598049000055],
              [43.281993035000085, 13.617132880000042],
              [43.28532962300005, 13.68659088700008],
              [43.28093509200005, 13.72211334800005],
              [43.24789472700007, 13.783677476000037],
              [43.24350019600007, 13.794338283000059],
              [43.233164910000085, 13.876369533000059],
              [43.227305535000085, 13.885443427000041],
              [43.16171674700007, 13.953990384000065],
              [43.13919286500004, 14.007348449000062],
              [43.11806712900005, 14.05249176400008],
              [43.09552000100007, 14.083955708000076],
              [43.08425339100006, 14.159187050000071],
              [43.07579223300007, 14.194759292000072],
              [43.06591659800006, 14.224865071000067],
              [43.04756287100008, 14.275507584000081],
              [43.01905358200008, 14.368353583000044],
              [43.01099694100009, 14.388413804000038],
              [43.00611412900008, 14.419419664000088],
              [42.99350019600007, 14.44830963700008],
              [42.98991946700005, 14.480210679000038],
              [42.987315300000034, 14.48924388200004],
              [42.98170006600009, 14.49477773600006],
              [42.96338951900009, 14.507757880000042],
              [42.959320509000065, 14.513495184000078],
              [42.96119225400008, 14.52537669500009],
              [42.96599368600005, 14.53025950700004],
              [42.97348066500007, 14.528469143000052],
              [42.98365319100009, 14.520331122000073],
              [42.994151238000086, 14.500474351000037],
              [43.00611412900008, 14.454779364000046],
              [43.021494988000086, 14.442084052000041],
              [43.02198326900009, 14.471096096000053],
              [43.02003014400009, 14.48460521000004],
              [43.014008009000065, 14.496771552000041],
              [43.02865644600007, 14.537990627000056],
              [43.017588738000086, 14.571234442000048],
              [42.998057488000086, 14.601507880000042],
              [42.987315300000034, 14.63385651200008],
              [42.98951256600009, 14.641058661000045],
              [42.998789910000085, 14.651271877000056],
              [43.000987175000034, 14.657171942000048],
              [42.99984785200007, 14.663316148000092],
              [42.99732506600009, 14.666205145000049],
              [42.994802280000044, 14.667914130000042],
              [42.99048912900008, 14.680080471000053],
              [42.98365319100009, 14.685126044000071],
              [42.97681725400008, 14.688381252000056],
              [42.97380618600005, 14.691880601000037],
              [42.971446160000085, 14.697007554000038],
              [42.96656334700003, 14.701849677000041],
              [42.961680535000085, 14.708563544000071],
              [42.954112175000034, 14.742661851000037],
              [42.953135613000086, 14.753729559000078],
              [42.94223066500007, 14.788885809000078],
              [42.894541863000086, 14.847479559000078],
              [42.88363691500007, 14.883693752000056],
              [42.881602410000085, 14.90460846600007],
              [42.88331139400009, 14.915513414000088],
              [42.89112389400009, 14.913804429000038],
              [42.89576256600009, 14.905991929000038],
              [42.89405358200008, 14.899318752000056],
              [42.890961134000065, 14.891424872000073],
              [42.89112389400009, 14.88031647300005],
              [42.89828535200007, 14.861761786000045],
              [42.91041100400008, 14.841376044000071],
              [42.92660566500007, 14.82322825700004],
              [42.945648634000065, 14.811428127000056],
              [42.94678795700008, 14.825873114000046],
              [42.953135613000086, 14.859198309000078],
              [42.95232181100005, 14.87954336100006],
              [42.94166100400008, 14.915350653000075],
              [42.93726647200003, 14.948472398000092],
              [42.93213951900009, 14.96084219000005],
              [42.92359459700003, 14.97142161700009],
              [42.89812259200005, 14.995266018000052],
              [42.88721764400009, 15.008205471000053],
              [42.88013756600009, 15.02484772300005],
              [42.87745201900009, 15.048529364000046],
              [42.88233483200008, 15.102484442000048],
              [42.87745201900009, 15.11985911700009],
              [42.864024285000085, 15.136419989000046],
              [42.82894941500007, 15.151760158000059],
              [42.796885613000086, 15.17869700700004],
              [42.77670332100007, 15.19139232000009],
              [42.75473066500007, 15.20180898600006],
              [42.733409050000034, 15.20929596600007],
              [42.711273634000065, 15.214260158000059],
              [42.691416863000086, 15.214260158000059],
              [42.67693118600005, 15.20579661700009],
              [42.67139733200008, 15.185370184000078],
              [42.66041100400008, 15.182562567000048],
              [42.637705925000034, 15.19086334800005],
              [42.61801191500007, 15.207505601000037],
              [42.61670983200008, 15.229722398000092],
              [42.610118035000085, 15.24359772300005],
              [42.62134850400008, 15.244696356000077],
              [42.654633009000065, 15.237209377000056],
              [42.67172285200007, 15.239650783000059],
              [42.682627800000034, 15.246486721000053],
              [42.68873131600009, 15.257025458000044],
              [42.69190514400009, 15.270697333000044],
              [42.69092858200008, 15.28123607000009],
              [42.680674675000034, 15.296047268000052],
              [42.67823326900009, 15.308294989000046],
              [42.70427493600005, 15.35545482000009],
              [42.71241295700008, 15.36627838700008],
              [42.71762129000007, 15.353461005000042],
              [42.71509850400008, 15.33698151200008],
              [42.70785566500007, 15.321519273000092],
              [42.69939212300005, 15.311672268000052],
              [42.71851647200003, 15.303127346000053],
              [42.73373457100007, 15.293890692000048],
              [42.77426191500007, 15.260443427000041],
              [42.77914472700007, 15.253322658000059],
              [42.781260613000086, 15.240301825000074],
              [42.77857506600009, 15.221625067000048],
              [42.781993035000085, 15.21507396000004],
              [42.794932488000086, 15.20929596600007],
              [42.795909050000034, 15.217352606000077],
              [42.79460696700005, 15.222601630000042],
              [42.791677280000044, 15.226304429000038],
              [42.788096550000034, 15.229722398000092],
              [42.803070509000065, 15.24518463700008],
              [42.80909264400009, 15.267767645000049],
              [42.80689537900008, 15.344305731000077],
              [42.79737389400009, 15.379706122000073],
              [42.781260613000086, 15.407904364000046],
              [42.77719160200007, 15.421942450000074],
              [42.777679884000065, 15.432806708000044],
              [42.779958530000044, 15.443182684000078],
              [42.781260613000086, 15.45571523600006],
              [42.78052819100009, 15.467474677000041],
              [42.778330925000034, 15.478989976000037],
              [42.77426191500007, 15.491034247000073],
              [42.75993899800005, 15.516058661000045],
              [42.71924889400009, 15.570013739000046],
              [42.721364780000044, 15.578192450000074],
              [42.733409050000034, 15.592230536000045],
              [42.72388756600009, 15.60219961100006],
              [42.714854363000086, 15.613959052000041],
              [42.70826256600009, 15.627834377000056],
              [42.70557701900009, 15.644354559000078],
              [42.71607506600009, 15.679836330000057],
              [42.713633660000085, 15.694728908000059],
              [42.69190514400009, 15.702093817000048],
              [42.699229363000086, 15.71743398600006],
              [42.70923912900008, 15.725897528000075],
              [42.721039259000065, 15.732814846000053],
              [42.733409050000034, 15.743068752000056],
              [42.74170983200008, 15.753241278000075],
              [42.74577884200005, 15.76194896000004],
              [42.74691816500007, 15.772650458000044],
              [42.74724368600005, 15.788397528000075],
              [42.75245201900009, 15.81639232000009],
              [42.76579837300005, 15.835760809000078],
              [42.78345787900008, 15.849432684000078],
              [42.801768425000034, 15.86033763200004],
              [42.81999759200005, 15.874945380000042],
              [42.83033287900008, 15.892523505000042],
              [42.83480879000007, 15.915350653000075],
              [42.84327233200008, 16.05219147300005],
              [42.84009850400008, 16.097805080000057],
              [42.81275475400008, 16.23826732000009],
              [42.80884850400008, 16.312648830000057],
              [42.807627800000034, 16.319566148000092],
              [42.801768425000034, 16.34015534100007],
              [42.80258222700007, 16.33942291900007],
              [42.803070509000065, 16.342352606000077],
              [42.80298912900008, 16.347357489000046],
              [42.801768425000034, 16.353216864000046],
              [42.798838738000086, 16.35846588700008],
              [42.79070071700005, 16.36863841400009],
              [42.78948001400005, 16.37095774900007],
              [42.837312459000145, 16.387217916000097],
              [42.87245243400008, 16.401635641000027],
              [42.898187297000106, 16.4188955690001],
              [42.90676558400014, 16.434915263000065],
              [42.905628703000104, 16.451089986000042],
              [42.9029415280001, 16.46628285700008],
              [42.90676558400014, 16.479356995000032],
              [42.917410929000084, 16.483801168000056],
              [42.95627160600009, 16.49072581000003],
              [42.970947713000044, 16.495790100000093],
              [43.01466597500013, 16.520698141000068],
              [43.0362667230001, 16.536304424000022],
              [43.04877242000009, 16.55346099900008],
              [43.074610636000045, 16.618780009000105],
              [43.078641398000116, 16.637693584000047],
              [43.079984986000056, 16.658829244000103],
              [43.084945923000134, 16.672575175000034],
              [43.09776167800004, 16.677794495000043],
              [43.1227730710001, 16.673298646000134],
              [43.16292565900011, 16.661516419000023],
              [43.17997888200006, 16.66461700400008],
              [43.186076701000104, 16.683272196000033],
              [43.185678910000036, 16.684847057000056],
              [43.179772176000085, 16.708231914000024],
              [43.17067712400012, 16.72347646100006],
              [43.168506714000046, 16.737222392000106],
              [43.182872762000045, 16.757996317000035],
              [43.19186446100008, 16.764249166000056],
              [43.201062867000076, 16.768124899],
              [43.20860762500013, 16.77339589400013],
              [43.212845092000066, 16.783886210000063],
              [43.211501505000115, 16.796856995],
              [43.20473189300009, 16.807709046000056],
              [43.1944482830001, 16.81546051000005],
              [43.157344604000116, 16.825382385000054],
              [43.14582076000005, 16.83447743800012],
              [43.13372847500011, 16.871012675000046],
              [43.11264449100014, 16.91002838200005],
              [43.10871708200011, 16.92697825200007],
              [43.115435018000085, 16.951834616000028],
              [43.13155806500009, 16.9904369100001],
              [43.135898885000074, 17.00960886700001],
              [43.13600223800012, 17.031416321000037],
              [43.13031783000008, 17.053482157000033],
              [43.12246301300013, 17.070121969000056],
              [43.118432251000115, 17.086245016000035],
              [43.12432336500012, 17.10696726500005],
              [43.14530399600005, 17.146551412000022],
              [43.15098840400009, 17.166860251000045],
              [43.150058228000034, 17.18995961500009],
              [43.15615604700008, 17.209700013000074],
              [43.1768782960001, 17.225513001000067],
              [43.20333663000008, 17.23631337500011],
              [43.22617761200013, 17.241274312000044],
              [43.2486051840001, 17.251919658000034],
              [43.252170858000056, 17.271970114000098],
              [43.24183557100008, 17.293415833000026],
              [43.222198527000046, 17.307833557000052],
              [43.16504439300007, 17.32592030800005],
              [43.16788659700006, 17.330519511000105],
              [43.21594567900013, 17.387208557000108],
              [43.30307214300012, 17.459038798000037],
              [43.391025431000116, 17.5119554650001],
              [43.412884562000045, 17.519965312000082],
              [43.434950399000115, 17.52285919200007],
              [43.4531405030001, 17.518776754000058],
              [43.487143596000124, 17.517484843000105],
              [43.50336999500013, 17.51345408100009],
              [43.57706058700006, 17.482964986000027],
              [43.61953861500007, 17.458832093000055],
              [43.689301799000134, 17.383849589000093],
              [43.730642945000056, 17.35243031900005],
              [43.750641724000104, 17.345660706000032],
              [43.768780151000044, 17.34550567600006],
              [43.80619388800011, 17.34958811500009],
              [43.84577803500014, 17.346177470000057],
              [43.863244670000086, 17.346952616000053],
              [43.88670577000005, 17.3536705530001],
              [43.89264856000011, 17.351035055000082],
              [43.89264856000011, 17.340079651000096],
              [43.89006473800009, 17.32018422500009],
              [43.89404382300006, 17.312174378000023],
              [43.89735111500005, 17.3073684700001],
              [43.903293905000055, 17.30431956000008],
              [43.91512780800008, 17.301839091000105],
              [43.938692260000096, 17.305198060000023],
              [43.95429854300005, 17.32002919600005],
              [43.967114299000116, 17.33956288700007],
              [43.98230717000007, 17.356822815000058],
              [44.00390791800004, 17.367829896000032],
              [44.02096114100004, 17.366021220000036],
              [44.059356730000104, 17.347055969000095],
              [44.085349976000145, 17.343438619000025],
              [44.10447025600013, 17.351965231000023],
              [44.11966312600009, 17.36994862900012],
              [44.13428755700005, 17.394701640000036],
              [44.14901534000006, 17.40483022000008],
              [44.169375855000055, 17.40234975200012],
              [44.211543824000046, 17.390619202000025],
              [44.23056075000011, 17.391859436000075],
              [44.30735192900005, 17.40896433600001],
              [44.404141887000094, 17.41873118100007],
              [44.46517175300005, 17.416457418000064],
              [44.53379805500009, 17.40286651700005],
              [44.56196171100004, 17.404468486],
              [44.62464522300007, 17.42720611600008],
              [44.64645267700013, 17.431805319000105],
              [44.84902429200014, 17.430513407000078],
              [44.972466368000084, 17.42969619600005],
              [44.99733565200006, 17.4295315560001],
              [45.1653874110001, 17.428394674000103],
              [45.222128133000126, 17.417387594],
              [45.3847021900001, 17.32648874900009],
              [45.43038415500013, 17.312019348000078],
              [45.64230920400007, 17.291090394],
              [45.89082116700013, 17.266647441000046],
              [46.07995690900009, 17.247992249000063],
              [46.322629435000124, 17.224066060000084],
              [46.48789066500012, 17.245976868000028],
              [46.7100993250001, 17.275380758000026],
              [46.747203003000095, 17.25476186100012],
              [46.811798543000066, 17.168462219000062],
              [46.88579919400007, 17.0695535280001],
              [46.97034183800014, 16.956847229000076],
              [46.98300256400006, 16.949095764000063],
              [46.997026374000086, 16.948514131000067],
              [47.128781779000064, 16.943049621000014],
              [47.161337931000105, 16.947442119000115],
              [47.19089685000006, 16.958914286000024],
              [47.3135767010001, 17.027902324000067],
              [47.427574911000136, 17.09182607000004],
              [47.428568591000044, 17.09310365900005],
              [47.4579606530001, 17.13089345300007],
              [47.524829956000076, 17.307575175000053],
              [47.57211389200012, 17.432322083000074],
              [47.589012085000036, 17.46327626500006],
              [47.68626713000003, 17.579651591000086],
              [47.83550866700011, 17.758193664000103],
              [47.99358687400013, 17.947587789000053],
              [48.084382365000124, 18.05590159100008],
              [48.16194869000009, 18.148919169000052],
              [48.184427937000066, 18.16393117300005],
              [48.31258549000012, 18.22658884700006],
              [48.484357951000106, 18.310408020000054],
              [48.675974162000045, 18.404019877000067],
              [48.84753991700006, 18.48770986000001],
              [48.991303752000135, 18.55788645400007],
              [49.03584883700012, 18.579719747000112],
              [49.128814738000074, 18.612095032000113],
              [49.257850790000134, 18.629509989000056],
              [49.41804772900008, 18.6510590620001],
              [49.57824466900013, 18.672608134000043],
              [49.73844161000005, 18.694157207],
              [49.898535197000115, 18.71570627900006],
              [50.05873213700005, 18.73725535100003],
              [50.21892907800009, 18.758856099000084],
              [50.37912601800008, 18.78035349500003],
              [50.53932295700014, 18.801902567000084],
              [50.699364869000135, 18.82352915500006],
              [50.85971683800011, 18.845026551],
              [51.01981042500006, 18.86657562200007],
              [51.179904012000065, 18.88815053300003],
              [51.340100952000114, 18.909699606000075],
              [51.50029789200005, 18.93124867800013],
              [51.66049483200004, 18.9528235880001],
              [51.82069177300008, 18.97437266100006],
              [51.97861495000012, 18.99563751300012],
            ],
          ],
          [
            [
              [53.24832614200005, 12.121302453000055],
              [53.26807112100005, 12.128831559000048],
              [53.28688385000004, 12.12733733500005],
              [53.29806645900004, 12.12187308600005],
              [53.30823945700007, 12.118394537000086],
              [53.31026730700006, 12.111443672000064],
              [53.277495146000035, 12.113829090000081],
              [53.26307557500007, 12.11486939100007],
              [53.24832614200005, 12.121302453000055],
            ],
          ],
          [
            [
              [53.05306807200009, 12.17491986400006],
              [53.068365706000066, 12.174940026000058],
              [53.08291778600005, 12.164794378000067],
              [53.08707388300007, 12.148554792000084],
              [53.08637844700007, 12.13434439000008],
              [53.071828726000035, 12.130282908000083],
              [53.05658965100008, 12.128251135000085],
              [53.026774464000084, 12.139741661000073],
              [53.006703274000074, 12.156644227000072],
              [52.98526503800008, 12.162727253000071],
              [52.988719992000085, 12.172197631000074],
              [53.003953196000055, 12.176942240000074],
              [53.017050409000035, 12.17557632800009],
              [53.027459725000085, 12.17964766700004],
              [53.03854985500004, 12.180332719000091],
              [53.05306807200009, 12.17491986400006],
            ],
          ],
          [
            [
              [52.28919867900004, 12.200815051000063],
              [52.319373805000055, 12.188263653000092],
              [52.37468509200005, 12.200588283000059],
              [52.38949629000007, 12.19725169500009],
              [52.38957767000005, 12.19725169500009],
              [52.39470462300005, 12.187323309000078],
              [52.38148224100007, 12.182545219000076],
              [52.371129100000076, 12.171565271000077],
              [52.378940027000056, 12.165691300000049],
              [52.388463594000086, 12.148867843000062],
              [52.359980980000046, 12.153853921000064],
              [52.34790410100004, 12.151296407000075],
              [52.33057701900003, 12.146185614000046],
              [52.28467858200008, 12.154486395000049],
              [52.24023003500008, 12.156877327000075],
              [52.235034030000065, 12.16528311500008],
              [52.22437584700003, 12.18032461100006],
              [52.21810957100007, 12.180609442000048],
              [52.21176191500007, 12.180894273000092],
              [52.19068444100009, 12.174627997000073],
              [52.17986087300005, 12.17283763200004],
              [52.175791863000086, 12.176336981000077],
              [52.16456139400003, 12.192531643000052],
              [52.16236412900008, 12.197414455000057],
              [52.156993035000085, 12.196234442000048],
              [52.13669149800006, 12.204540547000079],
              [52.12375291800004, 12.201978275000045],
              [52.112315300000034, 12.198635158000059],
              [52.105804884000065, 12.203802802000041],
              [52.10181725400008, 12.20701732000009],
              [52.06848665200005, 12.222007893000068],
              [52.06411842300008, 12.235473303000049],
              [52.07876295300008, 12.239736797000091],
              [52.094086134000065, 12.241766669000071],
              [52.11843463400004, 12.241548796000075],
              [52.14777722400004, 12.234897729000068],
              [52.17887622100005, 12.213943448000066],
              [52.20043352000005, 12.20644285800006],
              [52.21680362900008, 12.207334582000044],
              [52.24611446400007, 12.202370688000087],
              [52.28919867900004, 12.200815051000063],
            ],
          ],
          [
            [
              [43.42896569100009, 12.673773505000042],
              [43.44223066500007, 12.667222398000092],
              [43.44385826900009, 12.663804429000038],
              [43.44898522200003, 12.65298086100006],
              [43.44743899800005, 12.63865794500009],
              [43.43580162900008, 12.632147528000075],
              [43.42888431100005, 12.63467031500005],
              [43.41716556100005, 12.64671458500004],
              [43.41138756600009, 12.65265534100007],
              [43.39975019600007, 12.64984772300005],
              [43.39275149800005, 12.65306224200009],
              [43.39014733200008, 12.66632721600007],
              [43.39763431100005, 12.670803127000056],
              [43.40642337300005, 12.673041083000044],
              [43.42896569100009, 12.673773505000042],
            ],
          ],
          [
            [
              [54.470662090000076, 12.543565598000043],
              [54.49693247600004, 12.546913901000039],
              [54.516092393000065, 12.55843404500007],
              [54.52683313600005, 12.55721391600008],
              [54.54029381600009, 12.55023834800005],
              [54.527926842000056, 12.537446101000057],
              [54.498038406000035, 12.529471603000047],
              [54.476524115000075, 12.52261315000004],
              [54.457422731000065, 12.519228400000088],
              [54.44665380400005, 12.51114958900007],
              [54.44468356300007, 12.484720990000085],
              [54.40234026200005, 12.467224178000038],
              [54.36866104500007, 12.459568589000071],
              [54.328168806000065, 12.443456635000075],
              [54.28333651200006, 12.44729095300005],
              [54.24594160200007, 12.433539130000042],
              [54.23747806100005, 12.425197658000059],
              [54.218760613000086, 12.39940013200004],
              [54.209727410000085, 12.393784898000092],
              [54.18384850400008, 12.382513739000046],
              [54.154958530000044, 12.359808661000045],
              [54.140497888000084, 12.35134430000005],
              [54.11071140300004, 12.35381063300008],
              [54.06422938900005, 12.350547619000054],
              [54.04754648100004, 12.352962049000041],
              [54.030885983000076, 12.348360811000077],
              [54.008243941000046, 12.329857074000074],
              [53.98593183700007, 12.337144273000092],
              [53.98568769600007, 12.337144273000092],
              [53.96998131600009, 12.341864325000074],
              [53.939280815000075, 12.334757060000072],
              [53.896470940000086, 12.327908182000044],
              [53.77635202000005, 12.304968586000086],
              [53.731164780000086, 12.300413636000087],
              [53.67292403700009, 12.306341909000082],
              [53.618264982000085, 12.322706338000046],
              [53.572146675000056, 12.334614153000075],
              [53.55200014300004, 12.354383226000039],
              [53.53598066500007, 12.37376536700009],
              [53.519541863000086, 12.39354075700004],
              [53.50562584700003, 12.41632721600007],
              [53.47937461500004, 12.425170201000071],
              [53.43787507800005, 12.451956330000087],
              [53.33423912900008, 12.51552969000005],
              [53.30974368600005, 12.537665106000077],
              [53.30689537900008, 12.543402411000045],
              [53.31568444100009, 12.550279039000088],
              [53.34249370900005, 12.542609032000087],
              [53.363002195000035, 12.544912840000052],
              [53.38453209700003, 12.557318427000041],
              [53.389414910000085, 12.56077708500004],
              [53.39112389400003, 12.569647528000075],
              [53.39958743600005, 12.587591864000046],
              [53.40316816500007, 12.598049221000053],
              [53.39602709800005, 12.65646775600004],
              [53.41073767100005, 12.662135737000085],
              [53.428024418000064, 12.66539001600006],
              [53.470077106000076, 12.67142388700006],
              [53.47957798900006, 12.68653505800006],
              [53.490326709000044, 12.701620604000084],
              [53.49986924500007, 12.712064513000087],
              [53.518945864000045, 12.71435067300007],
              [53.57376212300005, 12.703771964000055],
              [53.60619832600008, 12.699984973000085],
              [53.62993454900004, 12.702304075000086],
              [53.654754843000035, 12.704757999000037],
              [53.69400944700004, 12.669778568000083],
              [53.762893950000034, 12.619703217000051],
              [53.80806531800005, 12.607996129000071],
              [53.84610392700006, 12.598604923000039],
              [53.86640110700006, 12.62293307400006],
              [53.875995481000075, 12.64729368400009],
              [53.90339099700009, 12.653031404000046],
              [53.92242660000005, 12.650655317000087],
              [53.94018363500004, 12.642426078000085],
              [53.97354138900005, 12.646988269000076],
              [54.008096581000075, 12.645744035000064],
              [54.045131377000075, 12.666555564000078],
              [54.058258539000065, 12.671163037000042],
              [54.08216622500004, 12.686200302000088],
              [54.09302819100009, 12.698879299000055],
              [54.11939537900008, 12.701117255000042],
              [54.13224613600005, 12.688365928000053],
              [54.14651063000008, 12.677860515000077],
              [54.16789046400004, 12.664994769000089],
              [54.18346005400008, 12.66844404200009],
              [54.19549124800005, 12.675400124000078],
              [54.20053144600007, 12.673000393000052],
              [54.21070397200003, 12.661688544000071],
              [54.218760613000086, 12.65265534100007],
              [54.237315300000034, 12.652044989000046],
              [54.26002037900008, 12.64752838700008],
              [54.269340904000046, 12.632119208000063],
              [54.28485421900007, 12.626248531000044],
              [54.319467916000065, 12.610993760000042],
              [54.360144596000055, 12.60268859100006],
              [54.40077485000006, 12.580403897000053],
              [54.421909149000044, 12.57402783300006],
              [54.470662090000076, 12.543565598000043],
            ],
          ],
          [
            [
              [42.71924889400009, 13.742621161000045],
              [42.761729363000086, 13.772162177000041],
              [42.78256269600007, 13.77993398600006],
              [42.794932488000086, 13.769924221000053],
              [42.79184004000007, 13.75071849200009],
              [42.76148522200003, 13.719305731000077],
              [42.75407962300005, 13.69790273600006],
              [42.74390709700003, 13.688421942000048],
              [42.688568556000064, 13.663804429000038],
              [42.688487175000034, 13.663763739000046],
              [42.686289910000085, 13.675970770000049],
              [42.68580162900008, 13.67845286700009],
              [42.68580162900008, 13.678534247000073],
              [42.69353274800005, 13.69920482000009],
              [42.71924889400009, 13.742621161000045],
            ],
          ],
          [
            [
              [42.76026451900009, 14.06468333500004],
              [42.767588738000086, 14.071519273000092],
              [42.79574629000007, 14.037176825000074],
              [42.801768425000034, 14.023138739000046],
              [42.80160566500007, 14.012274481000077],
              [42.788096550000034, 13.97532786700009],
              [42.78663170700008, 13.94399648600006],
              [42.78858483200008, 13.926703192000048],
              [42.78174889400009, 13.919989325000074],
              [42.75407962300005, 13.920721747000073],
              [42.767588738000086, 13.94867584800005],
              [42.74659264400009, 13.956529039000088],
              [42.72152754000007, 13.96938711100006],
              [42.71249433700007, 13.977443752000056],
              [42.70069420700008, 13.987941799000055],
              [42.699229363000086, 13.992254950000074],
              [42.69190514400009, 14.013169664000088],
              [42.70085696700005, 14.028265692000048],
              [42.721039259000065, 14.04596588700008],
              [42.74398847700007, 14.060126044000071],
              [42.76026451900009, 14.06468333500004],
            ],
          ],
          [
            [
              [42.63599694100009, 15.44554271000004],
              [42.610362175000034, 15.429388739000046],
              [42.60718834700003, 15.42291901200008],
              [42.61150149800005, 15.421291408000059],
              [42.611989780000044, 15.416571356000077],
              [42.608083530000044, 15.41038646000004],
              [42.59896894600007, 15.403631903000075],
              [42.584727410000085, 15.396633205000057],
              [42.58155358200008, 15.39158763200004],
              [42.592539910000085, 15.389471747000073],
              [42.60564212300005, 15.393011786000045],
              [42.61850019600007, 15.400091864000046],
              [42.62818444100009, 15.39866771000004],
              [42.62810306100005, 15.386460679000038],
              [42.616221550000034, 15.348089911000045],
              [42.61345462300005, 15.33470286700009],
              [42.61548912900008, 15.326361395000049],
              [42.613291863000086, 15.318548895000049],
              [42.608409050000034, 15.314032294000071],
              [42.609385613000086, 15.312201239000046],
              [42.615244988000086, 15.314032294000071],
              [42.61410566500007, 15.30805084800005],
              [42.59392337300005, 15.278713283000059],
              [42.58220462300005, 15.26821523600006],
              [42.568369988000086, 15.268866278000075],
              [42.557383660000085, 15.27757396000004],
              [42.54574629000007, 15.294419664000088],
              [42.545909050000034, 15.316961981000077],
              [42.55616295700008, 15.341457424000055],
              [42.558929884000065, 15.392971096000053],
              [42.570974155000044, 15.410101630000042],
              [42.58375084700003, 15.422796942000048],
              [42.59343509200005, 15.43073151200008],
              [42.59750410200007, 15.439154364000046],
              [42.601898634000065, 15.44627513200004],
              [42.62387129000007, 15.45734284100007],
              [42.63103274800005, 15.454250393000052],
              [42.63599694100009, 15.44554271000004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Hong Kong',
        iso3: 'HKG',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [114.22982832100001, 22.555812893000052],
              [114.234711134, 22.55617910400008],
              [114.22722415500004, 22.54706452000005],
              [114.22217858200008, 22.541449286000045],
              [114.21485436300009, 22.534491278000075],
              [114.20997155000009, 22.534491278000075],
              [114.209320509, 22.52370840100008],
              [114.21794681100005, 22.52602773600006],
              [114.2186792330001, 22.529852606000077],
              [114.2303979830001, 22.532945054000038],
              [114.2343042330001, 22.536932684000078],
              [114.24203535200002, 22.55019765800006],
              [114.24594160200002, 22.55097077000005],
              [114.24903405000009, 22.54783763200004],
              [114.25456790500004, 22.55097077000005],
              [114.25766035200002, 22.54783763200004],
              [114.25326582100001, 22.539455471000053],
              [114.259206576, 22.540798244000086],
              [114.26563561300009, 22.535264390000066],
              [114.26514733200008, 22.528469143000052],
              [114.27003014400009, 22.52558014500005],
              [114.27800540500004, 22.529852606000077],
              [114.27979576900009, 22.52602773600006],
              [114.27979576900009, 22.51972077000005],
              [114.277679884, 22.511664130000042],
              [114.28516686300009, 22.51117584800005],
              [114.28923587300005, 22.505194403000075],
              [114.29851321700005, 22.501003322000088],
              [114.3265893890001, 22.50877513200004],
              [114.33277428500003, 22.51194896000004],
              [114.33513431100005, 22.506415106000077],
              [114.3163354830001, 22.49237702000005],
              [114.30543053500003, 22.48301829600007],
              [114.29363040500004, 22.478257554000038],
              [114.28044681100005, 22.47288646000004],
              [114.26872806100005, 22.46503327000005],
              [114.2640893890001, 22.45807526200008],
              [114.25375410200002, 22.45176829600007],
              [114.24594160200002, 22.45176829600007],
              [114.23121178500003, 22.46979401200008],
              [114.217133009, 22.467352606000077],
              [114.21176191500001, 22.47056712400007],
              [114.209320509, 22.46580638200004],
              [114.21094811300009, 22.45730215100008],
              [114.21558678500003, 22.45498281500005],
              [114.217133009, 22.44794342700004],
              [114.20997155000009, 22.44948965100008],
              [114.209320509, 22.45408763200004],
              [114.20224043100006, 22.45807526200008],
              [114.19060306100005, 22.45652903900009],
              [114.18669681100005, 22.45176829600007],
              [114.16749108200008, 22.448065497000073],
              [114.17652428500003, 22.44322337400007],
              [114.18751061300009, 22.43614329600007],
              [114.20020592500009, 22.428168036000045],
              [114.21176191500001, 22.42059967700004],
              [114.20997155000009, 22.41274648600006],
              [114.21485436300009, 22.40888092700004],
              [114.209320509, 22.39866771000004],
              [114.21558678500003, 22.400336005000042],
              [114.22339928500003, 22.41502513200004],
              [114.23422285200002, 22.424750067000048],
              [114.2382104830001, 22.435370184000078],
              [114.24382571700005, 22.43553294500009],
              [114.25147545700008, 22.43073151200008],
              [114.26718183700007, 22.43073151200008],
              [114.26937910200002, 22.425523179000038],
              [114.26718183700007, 22.415961005000042],
              [114.27255293100006, 22.40965403900009],
              [114.27645918100006, 22.41982656500005],
              [114.2889917330001, 22.42601146000004],
              [114.27645918100006, 22.44399648600006],
              [114.2889917330001, 22.45331452000005],
              [114.30160566500001, 22.45652903900009],
              [114.30079186300009, 22.46503327000005],
              [114.32374108200008, 22.48004791900007],
              [114.32504316500001, 22.47520579600007],
              [114.33073978000004, 22.47410716400009],
              [114.32504316500001, 22.46426015800006],
              [114.33570397200003, 22.461737372000073],
              [114.33806399800005, 22.44635651200008],
              [114.33277428500003, 22.440008856000077],
              [114.33741295700008, 22.431586005000042],
              [114.34278405000009, 22.43768952000005],
              [114.3475854830001, 22.42291901200008],
              [114.35230553500003, 22.42369212400007],
              [114.35157311300009, 22.44098541900007],
              [114.35987389400009, 22.46116771000004],
              [114.36784915500004, 22.45498281500005],
              [114.36736087300005, 22.44627513200004],
              [114.37020918100006, 22.440008856000077],
              [114.38575280000009, 22.439235744000086],
              [114.39975019600001, 22.43614329600007],
              [114.39739017000011, 22.42841217700004],
              [114.40129642000011, 22.41274648600006],
              [114.38933353000004, 22.417914130000042],
              [114.38176517000011, 22.41905345300006],
              [114.37020918100006, 22.39797597900008],
              [114.37501061300009, 22.400539455000057],
              [114.38493899800005, 22.38735586100006],
              [114.38974043100006, 22.36595286700009],
              [114.38656660200002, 22.36522044500009],
              [114.38575280000009, 22.37018463700008],
              [114.376394076, 22.37063222900008],
              [114.37948652400007, 22.36208730700008],
              [114.37558027400007, 22.353461005000042],
              [114.37020918100006, 22.348822333000044],
              [114.36085045700008, 22.345770575000074],
              [114.35759524800005, 22.332424221000053],
              [114.35230553500003, 22.339463609000063],
              [114.35230553500003, 22.351914781000062],
              [114.34197024800005, 22.345770575000074],
              [114.33904056100005, 22.352687893000052],
              [114.33277428500003, 22.359767971000053],
              [114.334320509, 22.37531159100007],
              [114.32040449300007, 22.38076406500005],
              [114.31861412900003, 22.38939036700009],
              [114.31006920700008, 22.38377513200004],
              [114.30005944100003, 22.38157786700009],
              [114.28598066500001, 22.390977281000062],
              [114.27800540500004, 22.390977281000062],
              [114.26872806100005, 22.37844472900008],
              [114.2733667330001, 22.363633531000062],
              [114.27979576900009, 22.35500722900008],
              [114.27645918100006, 22.348049221000053],
              [114.26718183700007, 22.35578034100007],
              [114.26636803500003, 22.36595286700009],
              [114.25839277400007, 22.36208730700008],
              [114.25554446700005, 22.355902411000045],
              [114.26579837300005, 22.34634023600006],
              [114.27255293100006, 22.320705471000053],
              [114.27719160200002, 22.319199937000064],
              [114.29127037900003, 22.316555080000057],
              [114.29208418100006, 22.305161851000037],
              [114.29599043100006, 22.305161851000037],
              [114.30388431100005, 22.306708075000074],
              [114.31161543100006, 22.297308661000045],
              [114.30567467500009, 22.290757554000038],
              [114.29769941500001, 22.285630601000037],
              [114.29053795700008, 22.287949937000064],
              [114.2889917330001, 22.287176825000074],
              [114.28972415500004, 22.281683661000045],
              [114.28956139400009, 22.273911851000037],
              [114.30005944100003, 22.277044989000046],
              [114.3031518890001, 22.269191799000055],
              [114.3031518890001, 22.262152411000045],
              [114.29672285200002, 22.258286851000037],
              [114.2889917330001, 22.264593817000048],
              [114.27833092500009, 22.270453192000048],
              [114.27979576900009, 22.279364325000074],
              [114.2733667330001, 22.295762437000064],
              [114.26482181100005, 22.301947333000044],
              [114.26563561300009, 22.309800523000035],
              [114.26636803500003, 22.31598541900007],
              [114.25554446700005, 22.322333075000074],
              [114.25147545700008, 22.305161851000037],
              [114.25302168100006, 22.295762437000064],
              [114.23894290500004, 22.281683661000045],
              [114.22811933700007, 22.291856187000064],
              [114.21176191500001, 22.310573635000083],
              [114.21485436300009, 22.301174221000053],
              [114.21249433700007, 22.301174221000053],
              [114.19548587300005, 22.31826406500005],
              [114.18653405000009, 22.308742580000057],
              [114.19141686300009, 22.301947333000044],
              [114.19141686300009, 22.298895575000074],
              [114.18368574300007, 22.301947333000044],
              [114.18165123800009, 22.29441966400009],
              [114.17652428500003, 22.291083075000074],
              [114.17188561300009, 22.288723049000055],
              [114.16724694100003, 22.294175523000035],
              [114.16822350400003, 22.305487372000073],
              [114.16570071700005, 22.310573635000083],
              [114.16488691500001, 22.31521230700008],
              [114.15951582100001, 22.31521230700008],
              [114.15951582100001, 22.32225169500009],
              [114.15219160200002, 22.328517971000053],
              [114.13819420700008, 22.336004950000074],
              [114.12435957100001, 22.342230536000045],
              [114.12354576900009, 22.337144273000035],
              [114.11337324300007, 22.352687893000052],
              [114.11101321700005, 22.36595286700009],
              [114.10482832100001, 22.36985911700009],
              [114.09750410200002, 22.363023179000038],
              [114.07911217500009, 22.36595286700009],
              [114.07829837300005, 22.36286041900007],
              [114.07040449300007, 22.36286041900007],
              [114.06723066500001, 22.358994859000063],
              [114.05795332100001, 22.36131419500009],
              [114.050222201, 22.358994859000063],
              [114.03988691500001, 22.35500722900008],
              [114.02051842500009, 22.35036855700008],
              [114.01498457100001, 22.353461005000042],
              [114.01498457100001, 22.358994859000063],
              [113.99862714900007, 22.358994859000063],
              [113.99187259200005, 22.364081122000073],
              [113.98267662900003, 22.36676666900007],
              [113.97673587300005, 22.37921784100007],
              [113.97291100400003, 22.37999095300006],
              [113.9706323580001, 22.387071031000062],
              [113.96436608200008, 22.380682684000078],
              [113.97461998800009, 22.37205638200004],
              [113.95492597700002, 22.36985911700009],
              [113.94483483200008, 22.36208730700008],
              [113.93067467500009, 22.369086005000042],
              [113.92595462300005, 22.369086005000042],
              [113.914398634, 22.376125393000052],
              [113.918304884, 22.387844143000052],
              [113.9105737640001, 22.39866771000004],
              [113.89698326900009, 22.408758856000077],
              [113.90943444100003, 22.41860586100006],
              [113.93067467500009, 22.41982656500005],
              [113.94100996200007, 22.426784572000088],
              [113.95411217500009, 22.44948965100008],
              [113.97754967500009, 22.45884837400007],
              [113.99862714900007, 22.48855215100008],
              [114.00489342500009, 22.48855215100008],
              [114.01270592500009, 22.486110744000086],
              [114.01172936300009, 22.48004791900007],
              [114.011159701, 22.47288646000004],
              [114.01498457100001, 22.47520579600007],
              [114.026784701, 22.478257554000038],
              [114.02987714900007, 22.478257554000038],
              [114.03142337300005, 22.482245184000078],
              [114.03060957100001, 22.487656968000067],
              [114.03060957100001, 22.49551015800006],
              [114.04224694100003, 22.501003322000088],
              [114.05795332100001, 22.50486888200004],
              [114.06177819100003, 22.50877513200004],
              [114.06576582100001, 22.51585521000004],
              [114.07349694100003, 22.51817454600007],
              [114.07829837300005, 22.51972077000005],
              [114.08529707100001, 22.52293528900009],
              [114.082367384, 22.52936432500003],
              [114.09146447800009, 22.534387919000025],
              [114.108414347, 22.534387919000025],
              [114.113995402, 22.528806864],
              [114.11709598800013, 22.527566630000067],
              [114.12887821400005, 22.538108623000042],
              [114.13817997200016, 22.539348857000064],
              [114.14872196500005, 22.538108623000042],
              [114.15388960900015, 22.55185455400006],
              [114.16195113200001, 22.560536194000022],
              [114.17321740100016, 22.56394603200009],
              [114.18303511600004, 22.55619537400004],
              [114.19988163300002, 22.55619537400004],
              [114.22071373800009, 22.555121161000088],
              [114.22982832100001, 22.555812893000052],
            ],
          ],
          [
            [
              [114.13738040500004, 22.17877838700008],
              [114.11085045700008, 22.177069403000075],
              [114.11410566500001, 22.18573639500005],
              [114.11410566500001, 22.216131903000075],
              [114.10425866000003, 22.215969143000052],
              [114.10637454500011, 22.222398179000038],
              [114.10670006600003, 22.23578522300005],
              [114.11329186300009, 22.233343817000048],
              [114.11744225400003, 22.221869208000044],
              [114.12574303500003, 22.213446356000077],
              [114.13282311300009, 22.216131903000075],
              [114.13282311300009, 22.20994700700004],
              [114.12574303500003, 22.205226955000057],
              [114.13819420700008, 22.20604075700004],
              [114.14966881600003, 22.20604075700004],
              [114.154633009, 22.203599351000037],
              [114.14307701900009, 22.196112372000073],
              [114.1390893890001, 22.191107489000046],
              [114.14535566500001, 22.17869700700004],
              [114.13738040500004, 22.17877838700008],
            ],
          ],
          [
            [
              [114.21558678500003, 22.285630601000037],
              [114.22177168100006, 22.279364325000074],
              [114.22811933700007, 22.280910549000055],
              [114.23585045700008, 22.277818101000037],
              [114.24366295700008, 22.264593817000048],
              [114.25147545700008, 22.259059963000084],
              [114.25147545700008, 22.248887437000064],
              [114.24529056100005, 22.241888739000046],
              [114.24903405000009, 22.232530015000066],
              [114.25375410200002, 22.223985093000067],
              [114.24903405000009, 22.222398179000038],
              [114.25611412900003, 22.203599351000037],
              [114.24366295700008, 22.201280015000066],
              [114.24048912900003, 22.205226955000057],
              [114.232758009, 22.211493231000077],
              [114.23267662900003, 22.221991278000075],
              [114.22950280000009, 22.233587958000044],
              [114.22266686300009, 22.238836981000077],
              [114.21680748800009, 22.234320380000042],
              [114.22266686300009, 22.232530015000066],
              [114.22266686300009, 22.224758205000057],
              [114.2186792330001, 22.223985093000067],
              [114.21176191500001, 22.216131903000075],
              [114.2186792330001, 22.206000067000048],
              [114.21558678500003, 22.198960679000038],
              [114.21949303500003, 22.191880601000037],
              [114.20769290500004, 22.189561265000066],
              [114.20606530000009, 22.205226955000057],
              [114.209320509, 22.207546291000085],
              [114.20655358200008, 22.21238841400009],
              [114.19605553500003, 22.207546291000085],
              [114.19141686300009, 22.20994700700004],
              [114.19605553500003, 22.215318101000037],
              [114.18905683700007, 22.219224351000037],
              [114.193695509, 22.225531317000048],
              [114.19141686300009, 22.230983791000085],
              [114.18270918100006, 22.232530015000066],
              [114.18384850400003, 22.241034247000073],
              [114.17115319100003, 22.233303127000056],
              [114.16724694100003, 22.227850653000075],
              [114.16488691500001, 22.227850653000075],
              [114.16260826900009, 22.233303127000056],
              [114.16098066500001, 22.240383205000057],
              [114.15219160200002, 22.245021877000056],
              [114.13599694100003, 22.245754299000055],
              [114.12907962300005, 22.248887437000064],
              [114.12501061300009, 22.256740627000056],
              [114.12354576900009, 22.261379299000055],
              [114.11882571700005, 22.269191799000055],
              [114.11255944100003, 22.271511135000083],
              [114.11337324300007, 22.277818101000037],
              [114.1156518890001, 22.279364325000074],
              [114.12045332100001, 22.281683661000045],
              [114.12907962300005, 22.285630601000037],
              [114.1390893890001, 22.288723049000055],
              [114.14991295700008, 22.285630601000037],
              [114.15707441500001, 22.281683661000045],
              [114.16570071700005, 22.279364325000074],
              [114.17888431100005, 22.279364325000074],
              [114.18816165500004, 22.287176825000074],
              [114.19678795700008, 22.291856187000064],
              [114.20639082100001, 22.288234768000052],
              [114.21558678500003, 22.285630601000037],
            ],
          ],
          [
            [
              [113.84644616000003, 22.197088934000078],
              [113.83920332100001, 22.204901434000078],
              [113.83790123800009, 22.217962958000044],
              [113.837331576, 22.228623765000066],
              [113.83920332100001, 22.234198309000078],
              [113.84921308700007, 22.234198309000078],
              [113.84921308700007, 22.24412669500009],
              [113.85678144600001, 22.24599844000005],
              [113.85678144600001, 22.25226471600007],
              [113.85059655000009, 22.256740627000056],
              [113.85108483200008, 22.257106838000084],
              [113.85987389400009, 22.263454494000086],
              [113.86695397200003, 22.26898834800005],
              [113.8676050140001, 22.270738023000035],
              [113.87680097700002, 22.272284247000073],
              [113.88396243600005, 22.279364325000074],
              [113.8925073580001, 22.292710679000038],
              [113.91130618600005, 22.292710679000038],
              [113.92147871200007, 22.291856187000064],
              [113.92839603000004, 22.284857489000046],
              [113.93864993600005, 22.288723049000055],
              [113.96192467500009, 22.301174221000053],
              [113.97673587300005, 22.298081773000035],
              [113.98373457100001, 22.309027411000045],
              [113.99244225400003, 22.310573635000083],
              [113.99952233200008, 22.32225169500009],
              [114.01734459700003, 22.33551666900007],
              [114.02051842500009, 22.328517971000053],
              [114.04379316500001, 22.345770575000074],
              [114.04932701900009, 22.342230536000045],
              [114.05486087300005, 22.336330471000053],
              [114.05176842500009, 22.328517971000053],
              [114.050222201, 22.319932359000063],
              [114.04615319100003, 22.323146877000056],
              [114.03834069100003, 22.324571031000062],
              [114.03142337300005, 22.324571031000062],
              [114.029633009, 22.308986721000053],
              [114.01270592500009, 22.311346747000073],
              [114.01270592500009, 22.298081773000035],
              [114.02214603000004, 22.301906643000052],
              [114.01758873800009, 22.28904857000009],
              [114.01889082100001, 22.264593817000048],
              [114.00416100400003, 22.264593817000048],
              [113.99537194100003, 22.26776764500005],
              [114.007253451, 22.252101955000057],
              [113.99244225400003, 22.24119700700004],
              [114.01498457100001, 22.227077541000085],
              [114.00017337300005, 22.216131903000075],
              [113.98194420700008, 22.208238023000035],
              [113.98064212300005, 22.215318101000037],
              [113.98064212300005, 22.237250067000048],
              [113.969086134, 22.237250067000048],
              [113.95956464900007, 22.237250067000048],
              [113.945648634, 22.237250067000048],
              [113.92839603000004, 22.223985093000067],
              [113.92147871200007, 22.223985093000067],
              [113.918304884, 22.219224351000037],
              [113.92839603000004, 22.216905015000066],
              [113.92839603000004, 22.210760809000078],
              [113.91911868600005, 22.205023505000042],
              [113.90626061300009, 22.204006252000056],
              [113.89405358200008, 22.215318101000037],
              [113.8925073580001, 22.222398179000038],
              [113.88396243600005, 22.219997463000084],
              [113.87370853000004, 22.21308014500005],
              [113.85914147200003, 22.20140208500004],
              [113.84644616000003, 22.197088934000078],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'N. Cyprus',
        iso3: '-99',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [34.012288940472615, 35.06379525856936],
              [34.00891076700009, 35.05972157800004],
              [33.96291874200011, 35.06829986700008],
              [33.94111128700007, 35.05972157800004],
              [33.92540165200012, 35.062770487000066],
              [33.912895955000124, 35.06592275000013],
              [33.90659143100004, 35.069049174000085],
              [33.906505327911546, 35.06910491074929],
              [33.90824507700006, 35.07072865800005],
              [33.91444624900004, 35.07305409800007],
              [33.92147424400014, 35.08070221000004],
              [33.913619425000036, 35.090882466000025],
              [33.905867961000126, 35.090882466000025],
              [33.905867961000126, 35.096360169],
              [33.90359419800012, 35.099512431000065],
              [33.89883996600008, 35.108814189000086],
              [33.891811971000095, 35.11046783400003],
              [33.88943485500005, 35.11899444600006],
              [33.876205689000074, 35.11899444600006],
              [33.87155481000008, 35.10023590100006],
              [33.87155481000008, 35.08545644200005],
              [33.87692915900004, 35.0768264770001],
              [33.87155481000008, 35.07305409800007],
              [33.866903930000035, 35.06674957300005],
              [33.853571411000075, 35.05817128500003],
              [33.842719360000046, 35.056620993000095],
              [33.83486454200005, 35.063597311000095],
              [33.824012492000065, 35.06674957300005],
              [33.79827762800011, 35.05264190700002],
              [33.794350220000126, 35.040187887000044],
              [33.78649540200007, 35.038534241],
              [33.7755399990001, 35.040187887000044],
              [33.76613488800007, 35.03160959900002],
              [33.73967655400014, 35.04721588200006],
              [33.718489217000126, 35.032384745000016],
              [33.70758548900005, 35.029284160000074],
              [33.71146122200008, 35.04096303300004],
              [33.719367716000136, 35.062770487000066],
              [33.71471683800007, 35.06674957300005],
              [33.70531172700004, 35.06674957300005],
              [33.694459675000076, 35.05817128500003],
              [33.67885339400004, 35.055794169000066],
              [33.67409916200006, 35.04644073400003],
              [33.67564945500004, 35.03703562400007],
              [33.6794345990001, 35.03389876400006],
              [33.6709985760001, 35.03083445300008],
              [33.65611576300006, 35.032384745000016],
              [33.65218835400009, 35.03083445300008],
              [33.63751224800012, 35.03083445300008],
              [33.61405114700011, 35.04644073400003],
              [33.60226892100013, 35.04168650300004],
              [33.59152022400008, 35.03393503900004],
              [33.578962850000096, 35.03548533200005],
              [33.56640547600006, 35.04334014900009],
              [33.56175459700012, 35.05817128500003],
              [33.55545007300009, 35.06674957300005],
              [33.546871785000064, 35.07305409800007],
              [33.54067061400008, 35.07305409800007],
              [33.53679488200004, 35.06674957300005],
              [33.53519291200007, 35.056620993000095],
              [33.52899174000004, 35.055794169000066],
              [33.51643436600011, 35.05972157800004],
              [33.50718428500011, 35.06127187200006],
              [33.500156290000064, 35.06127187200006],
              [33.49385176700008, 35.056620993000095],
              [33.486203654000064, 35.038534241],
              [33.48144942200008, 35.03160959900002],
              [33.478348837000055, 35.0191039030001],
              [33.47679854300014, 35.00897532200007],
              [33.47679854300014, 35.00272247300005],
              [33.46656661000014, 35.00509958900001],
              [33.46584314000006, 35.01440134700003],
              [33.47132084200007, 35.038534241],
              [33.47679854300014, 35.057396139],
              [33.47679854300014, 35.0768264770001],
              [33.47679854300014, 35.09480987600007],
              [33.46977054800004, 35.10416331000003],
              [33.450960326000086, 35.13222361300005],
              [33.44000492400005, 35.148656718000026],
              [33.427705933000084, 35.16813873300002],
              [33.42450199400014, 35.18219472300002],
              [33.421401408000065, 35.1938735960001],
              [33.41354659000007, 35.19940297400008],
              [33.40031742300005, 35.19774932900005],
              [33.38853519700007, 35.188395895],
              [33.380783732000054, 35.17826731400005],
              [33.37453088400014, 35.17433990600007],
              [33.3448169350001, 35.166640117],
              [33.32621341900011, 35.166640117],
              [33.31525801600014, 35.1618858850001],
              [33.29960005700008, 35.162661032000116],
              [33.27081628400009, 35.16896555600003],
              [33.24022383600004, 35.17129099600005],
              [33.22399743600005, 35.17914581300009],
              [33.1902527260001, 35.18994618700013],
              [33.157489868000084, 35.18529530800005],
              [33.14193526300005, 35.1806444300001],
              [33.12012780700013, 35.16033559200007],
              [33.10912072800005, 35.15878529900006],
              [33.09583988400004, 35.169740703000045],
              [33.07868330900004, 35.16508982400008],
              [33.056100708000145, 35.1556847130001],
              [33.03114099100014, 35.14943186400002],
              [33.013984416000085, 35.141628723000096],
              [32.98907637600013, 35.13144846600004],
              [32.9695426830001, 35.112793274000055],
              [32.94690840700008, 35.10261301700008],
              [32.934351034000144, 35.10023590100006],
              [32.9227238360001, 35.09873728400005],
              [32.911768433000134, 35.10023590100006],
              [32.88841068500005, 35.10261301700008],
              [32.87673181100007, 35.10023590100006],
              [32.87042728600005, 35.09796213800003],
              [32.86102217700011, 35.087781881000055],
              [32.85492435800006, 35.07915191700003],
              [32.839214721000076, 35.079927064000046],
              [32.82991296300008, 35.10023590100006],
              [32.81430668200005, 35.11661733000001],
              [32.794772990000126, 35.12679758700007],
              [32.759633016000066, 35.13377390600006],
              [32.743975057000114, 35.137752991000056],
              [32.73152103700005, 35.143179016000104],
              [32.720565633000035, 35.153359274000096],
              [32.71271081600014, 35.163436178000026],
              [32.71059208100007, 35.17532175800007],
              [32.711388415000044, 35.18163170900006],
              [32.74537194100009, 35.17804596600007],
              [32.776377800000034, 35.17084381700005],
              [32.801442905000044, 35.157131252000056],
              [32.82837975400008, 35.14858633000006],
              [32.865244988000086, 35.15696849200009],
              [32.892588738000086, 35.175034898000035],
              [32.914724155000044, 35.200832424000055],
              [32.92937259200005, 35.23297760600008],
              [32.93474368600005, 35.27057526200008],
              [32.93604576900009, 35.33661530200004],
              [32.93213951900009, 35.36627838700008],
              [32.92042076900009, 35.397772528000075],
              [32.944346550000034, 35.394517320000034],
              [32.985362175000034, 35.37457916900007],
              [33.00611412900008, 35.36985911700009],
              [33.069795878000036, 35.35872409400008],
              [33.14008008900004, 35.36215942200005],
              [33.262461785000085, 35.34935130400004],
              [33.28060957100007, 35.34247467700004],
              [33.42750084700009, 35.32892487200007],
              [33.66032962300005, 35.35932038000004],
              [33.742849155000044, 35.397772528000075],
              [33.78350763800006, 35.41671751100006],
              [33.834646030000044, 35.40997955900008],
              [33.88793845500004, 35.42390629000005],
              [34.03562217700005, 35.47138308500007],
              [34.07628968100005, 35.494322917000034],
              [34.13119012300007, 35.511347354000065],
              [34.181651238000086, 35.55418528900009],
              [34.21038520500008, 35.559145535000084],
              [34.267789608000044, 35.572256183000036],
              [34.31967207100007, 35.58616771000004],
              [34.361479821000046, 35.608309450000036],
              [34.54420006600009, 35.67837148600006],
              [34.578461134000065, 35.68976471600007],
              [34.592539910000085, 35.69196198100008],
              [34.58708743600005, 35.688706773000035],
              [34.58366946700005, 35.68496328300006],
              [34.58130944100009, 35.68121979400007],
              [34.578868035000085, 35.67837148600006],
              [34.57545006600009, 35.65013255400004],
              [34.57276451900009, 35.64354075700004],
              [34.565440300000034, 35.64118073100008],
              [34.54232832100007, 35.63727448100008],
              [34.53728274800005, 35.633978583000044],
              [34.441416863000086, 35.583644924000055],
              [34.352305535000085, 35.520697333000044],
              [34.137705925000034, 35.41510651200008],
              [34.10906009200005, 35.39427317900004],
              [34.08545983200008, 35.36985911700009],
              [34.06820722700007, 35.33771393400008],
              [34.058929884000065, 35.32412344000005],
              [34.04379316500007, 35.31525299700007],
              [34.01978600400008, 35.31435781500005],
              [33.994883660000085, 35.31928131700005],
              [33.971364780000044, 35.32127513200004],
              [33.95167076900009, 35.31150950700004],
              [33.92359459700009, 35.278550523000035],
              [33.912119988000086, 35.25999583500004],
              [33.90739993600005, 35.24290599200009],
              [33.89991295700008, 35.16445547100005],
              [33.91374759200005, 35.156236070000034],
              [33.95362389400009, 35.12262604400007],
              [33.961924675000034, 35.112616278000075],
              [33.966807488000086, 35.10008372600004],
              [33.97868899800005, 35.08746979400007],
              [34.012288940472615, 35.06379525856936],
            ],
          ],
          [
            [
              [32.64069432800005, 35.187076833000035],
              [32.63943363400011, 35.18374501700005],
              [32.63478275600005, 35.17284128900009],
              [32.62620446800014, 35.16508982400008],
              [32.61519738800013, 35.163436178000026],
              [32.60274336700013, 35.17433990600007],
              [32.601898634000065, 35.178615627000056],
              [32.61939537900008, 35.184881903000075],
              [32.64069432800005, 35.187076833000035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cyprus U.N. Buffer Zone',
        iso3: '-99',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [33.906505327911546, 35.06910491074929],
              [33.90659143100004, 35.069049174000085],
              [33.912895955000124, 35.06592275000013],
              [33.92540165200012, 35.062770487000066],
              [33.94111128700007, 35.05972157800004],
              [33.96291874200011, 35.06829986700008],
              [34.00891076700009, 35.05972157800004],
              [34.012288940472615, 35.06379525856936],
              [34.0219607300001, 35.05700872100003],
              [34.017489054000066, 35.05186676100003],
              [34.01190800000012, 35.04881785],
              [34.00198612400004, 35.04721588200006],
              [33.989480428000036, 35.05186676100003],
              [33.98007531700006, 35.057396139],
              [33.9620919190001, 35.057396139],
              [33.944935343000054, 35.051091613],
              [33.93077600100008, 35.051091613],
              [33.92147424400014, 35.05341705300013],
              [33.910518839000076, 35.057396139],
              [33.898116496000114, 35.06127187200006],
              [33.906505327911546, 35.06910491074929],
            ],
          ],
          [
            [
              [33.6794345990001, 35.03389876400006],
              [33.68500289000008, 35.029284160000074],
              [33.70221114100008, 35.02225616500006],
              [33.70531172700004, 35.01522817000004],
              [33.696630086000084, 35.00897532200007],
              [33.6997306720001, 35.00272247300005],
              [33.7154403080001, 34.997296448000085],
              [33.71146122200008, 34.98556589900009],
              [33.7029346110001, 34.98794301400004],
              [33.70055749400012, 34.988666484000035],
              [33.68500289000008, 34.997296448000085],
              [33.67409916200006, 34.998795064],
              [33.66159346500007, 35.000345357000114],
              [33.639786011000126, 35.009750468000064],
              [33.630329224000036, 35.01362620100012],
              [33.61952885000011, 35.016830140000096],
              [33.61167403200005, 35.01362620100012],
              [33.60299239100004, 35.012075908],
              [33.59152022400008, 35.018380432000114],
              [33.58056481900013, 35.01993072500004],
              [33.571883179000054, 35.01440134700003],
              [33.56413171400004, 35.00117218000004],
              [33.54604496200005, 34.994971009000054],
              [33.53364261900009, 34.999570211],
              [33.527441447000115, 35.01285105400011],
              [33.527441447000115, 35.03703562400007],
              [33.51958663000005, 35.044115295],
              [33.510284871000124, 35.03703562400007],
              [33.50281057400014, 35.030870057000115],
              [33.49700402800005, 35.0260802210001],
              [33.493128296000066, 34.997296448000085],
              [33.486203654000064, 34.98163848900002],
              [33.46977054800004, 34.977762757000065],
              [33.45881514500013, 34.977762757000065],
              [33.449410034000095, 34.98794301400004],
              [33.446309448000136, 35.00117218000004],
              [33.452510620000055, 35.0191039030001],
              [33.45881514500013, 35.04168650300004],
              [33.45881514500013, 35.06127187200006],
              [33.460365437000064, 35.07760162400011],
              [33.45881514500013, 35.09480987600007],
              [33.45726485200004, 35.10106272400007],
              [33.44320886300011, 35.11356842100007],
              [33.43235681200008, 35.12364532500003],
              [33.42450199400014, 35.12989817400002],
              [33.421401408000065, 35.144729309000056],
              [33.421401408000065, 35.15723500600005],
              [33.415923706000115, 35.16033559200007],
              [33.39866377800013, 35.15801015300006],
              [33.37303226700004, 35.1556847130001],
              [33.35659916100008, 35.15723500600005],
              [33.348020875000145, 35.154909566000114],
              [33.32771203600004, 35.136926168000016],
              [33.31525801600014, 35.129123027],
              [33.31365604600012, 35.12131988600008],
              [33.309056844000054, 35.1158938600001],
              [33.301202027000045, 35.11356842100007],
              [33.27856774900005, 35.118219300000035],
              [33.26213464300008, 35.12607411800006],
              [33.25210941600011, 35.136926168000016],
              [33.23867354400005, 35.14943186400002],
              [33.22854496200006, 35.153359274000096],
              [33.21614261900004, 35.154082743000075],
              [33.20281009900009, 35.15801015300006],
              [33.18947758000007, 35.162661032000116],
              [33.17387129700012, 35.162661032000116],
              [33.14968672700007, 35.148656718000026],
              [33.1434855550001, 35.14007843000009],
              [33.13712935400014, 35.136099345],
              [33.12307336400005, 35.13067332000013],
              [33.098217, 35.13067332000013],
              [33.071655314000054, 35.135324199000095],
              [33.0467472740001, 35.137752991000056],
              [33.03734216300012, 35.136099345],
              [33.02638675900005, 35.1276244110001],
              [33.003132365000056, 35.1158938600001],
              [32.985148966000054, 35.108814189000086],
              [32.96711389200004, 35.09480987600007],
              [32.94840702400006, 35.07915191700003],
              [32.9352295330001, 35.07227895100006],
              [32.92194868900009, 35.07227895100006],
              [32.906394084000055, 35.08070221000004],
              [32.90019291200008, 35.087781881000055],
              [32.8907878010001, 35.09165761300004],
              [32.8829329830001, 35.087781881000055],
              [32.87673181100007, 35.0768264770001],
              [32.87347619600013, 35.07227895100006],
              [32.86102217700011, 35.06509592700009],
              [32.834563842000136, 35.05894643200013],
              [32.8259855550001, 35.05894643200013],
              [32.81585697400004, 35.062770487000066],
              [32.81027592000004, 35.07072865800005],
              [32.81027592000004, 35.079927064000046],
              [32.80650354000011, 35.09480987600007],
              [32.79559981300014, 35.10261301700008],
              [32.77523929800009, 35.11046783400003],
              [32.75487878500007, 35.119769592000054],
              [32.72831709800005, 35.12679758700007],
              [32.71271081600014, 35.13377390600006],
              [32.70413252700007, 35.143902486000016],
              [32.69803470800014, 35.15723500600005],
              [32.691548895582855, 35.183705160320315],
              [32.711388415000044, 35.18163170900006],
              [32.71059208100007, 35.17532175800007],
              [32.71271081600014, 35.163436178000026],
              [32.720565633000035, 35.153359274000096],
              [32.73152103700005, 35.143179016000104],
              [32.743975057000114, 35.137752991000056],
              [32.759633016000066, 35.13377390600006],
              [32.794772990000126, 35.12679758700007],
              [32.81430668200005, 35.11661733000001],
              [32.82991296300008, 35.10023590100006],
              [32.839214721000076, 35.079927064000046],
              [32.85492435800006, 35.07915191700003],
              [32.86102217700011, 35.087781881000055],
              [32.87042728600005, 35.09796213800003],
              [32.87673181100007, 35.10023590100006],
              [32.88841068500005, 35.10261301700008],
              [32.911768433000134, 35.10023590100006],
              [32.9227238360001, 35.09873728400005],
              [32.934351034000144, 35.10023590100006],
              [32.94690840700008, 35.10261301700008],
              [32.9695426830001, 35.112793274000055],
              [32.98907637600013, 35.13144846600004],
              [33.013984416000085, 35.141628723000096],
              [33.03114099100014, 35.14943186400002],
              [33.056100708000145, 35.1556847130001],
              [33.07868330900004, 35.16508982400008],
              [33.09583988400004, 35.169740703000045],
              [33.10912072800005, 35.15878529900006],
              [33.12012780700013, 35.16033559200007],
              [33.14193526300005, 35.1806444300001],
              [33.157489868000084, 35.18529530800005],
              [33.1902527260001, 35.18994618700013],
              [33.22399743600005, 35.17914581300009],
              [33.24022383600004, 35.17129099600005],
              [33.27081628400009, 35.16896555600003],
              [33.29960005700008, 35.162661032000116],
              [33.31525801600014, 35.1618858850001],
              [33.32621341900011, 35.166640117],
              [33.3448169350001, 35.166640117],
              [33.37453088400014, 35.17433990600007],
              [33.380783732000054, 35.17826731400005],
              [33.38853519700007, 35.188395895],
              [33.40031742300005, 35.19774932900005],
              [33.41354659000007, 35.19940297400008],
              [33.421401408000065, 35.1938735960001],
              [33.42450199400014, 35.18219472300002],
              [33.427705933000084, 35.16813873300002],
              [33.44000492400005, 35.148656718000026],
              [33.450960326000086, 35.13222361300005],
              [33.46977054800004, 35.10416331000003],
              [33.47679854300014, 35.09480987600007],
              [33.47679854300014, 35.0768264770001],
              [33.47679854300014, 35.057396139],
              [33.47132084200007, 35.038534241],
              [33.46584314000006, 35.01440134700003],
              [33.46656661000014, 35.00509958900001],
              [33.47679854300014, 35.00272247300005],
              [33.47679854300014, 35.00897532200007],
              [33.478348837000055, 35.0191039030001],
              [33.48144942200008, 35.03160959900002],
              [33.486203654000064, 35.038534241],
              [33.49385176700008, 35.056620993000095],
              [33.500156290000064, 35.06127187200006],
              [33.50718428500011, 35.06127187200006],
              [33.51643436600011, 35.05972157800004],
              [33.52899174000004, 35.055794169000066],
              [33.53519291200007, 35.056620993000095],
              [33.53679488200004, 35.06674957300005],
              [33.54067061400008, 35.07305409800007],
              [33.546871785000064, 35.07305409800007],
              [33.55545007300009, 35.06674957300005],
              [33.56175459700012, 35.05817128500003],
              [33.56640547600006, 35.04334014900009],
              [33.578962850000096, 35.03548533200005],
              [33.59152022400008, 35.03393503900004],
              [33.60226892100013, 35.04168650300004],
              [33.61405114700011, 35.04644073400003],
              [33.63751224800012, 35.03083445300008],
              [33.65218835400009, 35.03083445300008],
              [33.65611576300006, 35.032384745000016],
              [33.6709985760001, 35.03083445300008],
              [33.6794345990001, 35.03389876400006],
            ],
          ],
          [
            [
              [32.64069432800005, 35.187076833000035],
              [32.650401238000086, 35.18805573100008],
              [32.659812714000054, 35.18708213000012],
              [32.653489624000144, 35.17433990600007],
              [32.646461629000044, 35.16111073800009],
              [32.63395593200005, 35.154082743000075],
              [32.622225382000124, 35.15180898000007],
              [32.607497599000055, 35.154082743000075],
              [32.592614787000116, 35.16111073800009],
              [32.58480879000007, 35.17251211100006],
              [32.601898634000065, 35.178615627000056],
              [32.60274336700013, 35.17433990600007],
              [32.61519738800013, 35.163436178000026],
              [32.62620446800014, 35.16508982400008],
              [32.63478275600005, 35.17284128900009],
              [32.63943363400011, 35.18374501700005],
              [32.64069432800005, 35.187076833000035],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Siachen Glacier',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [77.04897098800006, 35.110441997000024],
            [76.91316086450013, 35.37827685550006],
            [76.77735074100008, 35.6461117140001],
            [76.78283736200007, 35.64573232000008],
            [76.82459191900011, 35.647799378000045],
            [76.84298872900013, 35.64128814800007],
            [76.85694136500013, 35.62857574500002],
            [76.88050581900012, 35.60067047200003],
            [76.89642216000004, 35.58961171500003],
            [76.91502567600008, 35.58315216100006],
            [76.93579960200003, 35.579638164000116],
            [76.97641727700005, 35.578656312000035],
            [77.01755171800005, 35.58459910100005],
            [77.03904911300009, 35.58501251200006],
            [77.05816939300007, 35.58010325200003],
            [77.07108850100008, 35.571008199000076],
            [77.09227583900014, 35.54780548200007],
            [77.10529829900008, 35.537986959000094],
            [77.14126509600004, 35.525377910000074],
            [77.17754195100014, 35.52315582300007],
            [77.25081913300005, 35.53070058200011],
            [77.28110152200009, 35.52801340800009],
            [77.30538944500006, 35.51783315100003],
            [77.35200158700013, 35.48605214500007],
            [77.38373091600005, 35.47199615500007],
            [77.41277307100012, 35.46941233300005],
            [77.47643843600014, 35.47716379800006],
            [77.51219852700007, 35.478455709000016],
            [77.51960817800011, 35.477439204000035],
            [77.66061324100008, 35.45809519500007],
            [77.68965539600009, 35.46269439700005],
            [77.71673384600012, 35.47540680000007],
            [77.74742964700005, 35.494320374000026],
            [77.76034875500005, 35.49809275300005],
            [77.77357792200007, 35.498971253],
            [77.80034631400014, 35.49540557900012],
            [77.42465865100007, 35.302923788000115],
            [77.04897098800006, 35.110441997000024],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Baikonur',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [63.3839136150001, 45.56582448300013],
            [63.32427901200009, 45.567969055],
            [63.26634973200004, 45.57422190400011],
            [63.210487508000085, 45.58437632300006],
            [63.15689904800013, 45.59825144500003],
            [63.105946086000074, 45.61561472600006],
            [63.05783532700008, 45.63628529900008],
            [63.01292850700008, 45.66000478100001],
            [62.97148400900005, 45.68664398300005],
            [62.93386356600013, 45.71594451900002],
            [62.900273885000104, 45.747699687000036],
            [62.87102502500005, 45.78170278000009],
            [62.84647871900006, 45.81777293000009],
            [62.82689335100014, 45.85570343000008],
            [62.81252730300014, 45.89518422500002],
            [62.80363895700003, 45.93616363500006],
            [62.800641723000126, 45.978331604000104],
            [62.80363895700003, 46.020499573000066],
            [62.81252730300014, 46.06142730700007],
            [62.82689335100014, 46.100985616000045],
            [62.84647871900006, 46.13889028000004],
            [62.87102502500005, 46.17496042900002],
            [62.900273885000104, 46.208963522000076],
            [62.93386356600013, 46.240718689000104],
            [62.97148400900005, 46.27001922700005],
            [63.01292850700008, 46.29665842700008],
            [63.05783532700008, 46.320377909000044],
            [63.105946086000074, 46.34104848300005],
            [63.15689904800013, 46.35841176400008],
            [63.210487508000085, 46.37226104700004],
            [63.26634973200004, 46.382441305],
            [63.32427901200009, 46.38869415300009],
            [63.3839136150001, 46.390838725],
            [63.4435482180001, 46.38869415300009],
            [63.50147749900003, 46.382441305],
            [63.55739139800005, 46.37226104700004],
            [63.610928182000066, 46.35841176400008],
            [63.66188114500011, 46.34104848300005],
            [63.70994022600007, 46.320377909000044],
            [63.75489872300011, 46.29665842700008],
            [63.79634322100014, 46.27001922700005],
            [63.833963664000066, 46.240718689000104],
            [63.86755334500003, 46.208963522000076],
            [63.89669885200004, 46.17496042900002],
            [63.92129683500008, 46.13889028000004],
            [63.940933879000056, 46.100985616000045],
            [63.955299927000056, 46.06142730700007],
            [63.96408492000012, 46.020499573000066],
            [63.96713383000008, 45.978331604000104],
            [63.96408492000012, 45.93616363500006],
            [63.955299927000056, 45.89518422500002],
            [63.940933879000056, 45.85570343000008],
            [63.92129683500008, 45.81777293000009],
            [63.89669885200004, 45.78170278000009],
            [63.86755334500003, 45.747699687000036],
            [63.833963664000066, 45.71594451900002],
            [63.79634322100014, 45.68664398300005],
            [63.75489872300011, 45.66000478100001],
            [63.70994022600007, 45.63628529900008],
            [63.66188114500011, 45.61561472600006],
            [63.610928182000066, 45.59825144500003],
            [63.55739139800005, 45.58437632300006],
            [63.50147749800004, 45.57422190400011],
            [63.4435482180001, 45.567969055],
            [63.3839136150001, 45.56582448300013],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Akrotiri',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.01563463629242, 34.63442454100009],
            [33.00993899800005, 34.62490469000005],
            [33.00912519600007, 34.59739817900004],
            [33.030284050000034, 34.57477448100008],
            [33.030284050000034, 34.56854889500005],
            [32.94092858200008, 34.56854889500005],
            [32.94092858200008, 34.57477448100008],
            [32.94467207100007, 34.59369538000004],
            [32.91586347700007, 34.63939036700009],
            [32.91358483200008, 34.656683661000045],
            [32.857432488000086, 34.66901276200008],
            [32.834320509000065, 34.67096588700008],
            [32.812836134000065, 34.66864655200004],
            [32.76067142000005, 34.653225002000056],
            [32.760102265000114, 34.66910995000008],
            [32.766766104000055, 34.67614400300006],
            [32.778612929000076, 34.673182297000054],
            [32.79860444800005, 34.670961017000124],
            [32.806008714000086, 34.68576954900006],
            [32.81933639200008, 34.687620615000085],
            [32.822668312000076, 34.691322748000076],
            [32.827481085000045, 34.6965057340001],
            [32.83229385800007, 34.70094829400007],
            [32.835625777000075, 34.69983765400009],
            [32.84080876400009, 34.699467441000095],
            [32.84599175000005, 34.699467441000095],
            [32.85376622900009, 34.699467441000095],
            [32.85968964200009, 34.700578081000074],
            [32.860430068000085, 34.687620615000085],
            [32.8656130550001, 34.67873549600007],
            [32.8845035650001, 34.6666068790001],
            [32.91366655000013, 34.660279908000106],
            [32.917246135000084, 34.66713572200008],
            [32.92975183100009, 34.662484843000115],
            [32.93605635600011, 34.65773061100002],
            [32.942257528000084, 34.66713572200008],
            [32.95471154800009, 34.677315979000056],
            [32.9875260820001, 34.673388571000075],
            [32.98979984500011, 34.64610341500007],
            [32.970266154000115, 34.64610341500007],
            [32.96561527600005, 34.65158111600006],
            [32.95403975500011, 34.642951152000094],
            [32.955590047000044, 34.62889516200009],
            [32.9625146890001, 34.62501943000002],
            [32.9695426830001, 34.63204742500004],
            [32.99073002100005, 34.63442454100009],
            [33.01563463629242, 34.63442454100009],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Philippines',
        iso3: 'PHL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [120.86068769600001, 5.574367580000057],
              [120.87305748800009, 5.572414455000057],
              [120.88998457100001, 5.557928778000075],
              [120.90455162900003, 5.538031317000048],
              [120.90919030000009, 5.519720770000049],
              [120.89779707100001, 5.498521226000094],
              [120.87989342500009, 5.495754299000055],
              [120.85084069100003, 5.505438544000071],
              [120.84343509200005, 5.51007721600007],
              [120.83301842500009, 5.521063544000071],
              [120.82374108200008, 5.533636786000045],
              [120.81983483200008, 5.54328034100007],
              [120.82439212300005, 5.553208726000094],
              [120.83529707100001, 5.562933661000045],
              [120.84888756600003, 5.570461330000057],
              [120.86068769600001, 5.574367580000057],
            ],
          ],
          [
            [
              [121.90235436300009, 6.033636786000045],
              [121.92904707100001, 6.045355536000045],
              [121.94044030000009, 6.046087958000044],
              [121.94320722700002, 6.033636786000045],
              [121.93775475400003, 6.029445705000057],
              [121.91277103000004, 6.016017971000053],
              [121.86841881600003, 5.999741929000038],
              [121.85767662900003, 6.00226471600007],
              [121.80494225400003, 6.037176825000074],
              [121.78467858200008, 6.059556382000039],
              [121.77662194100003, 6.077378648000092],
              [121.79371178500003, 6.074611721000053],
              [121.84620201900009, 6.042792059000078],
              [121.87094160200002, 6.033107815000051],
              [121.90235436300009, 6.033636786000045],
            ],
          ],
          [
            [
              [125.79127037900003, 6.948187567000048],
              [125.79371178500003, 6.939520575000074],
              [125.78972415500004, 6.928778387000079],
              [125.78394616000003, 6.91742584800005],
              [125.77686608200008, 6.894029039000088],
              [125.76775149800005, 6.898871161000045],
              [125.75367272200003, 6.917466539000088],
              [125.74537194100003, 6.93695709800005],
              [125.73829186300009, 6.979193427000041],
              [125.72535241000003, 7.004787502000056],
              [125.72193444100003, 7.015570380000042],
              [125.71762129000001, 7.052232164000088],
              [125.71216881600003, 7.056301174000055],
              [125.70378665500004, 7.056708075000074],
              [125.68384850400003, 7.065252997000073],
              [125.67790774800005, 7.066392320000091],
              [125.67408287900003, 7.070217190000051],
              [125.67172285200002, 7.081976630000042],
              [125.67269941500001, 7.092759507000039],
              [125.67693118600005, 7.103908596000053],
              [125.68287194100003, 7.112616278000075],
              [125.68913821700005, 7.116115627000056],
              [125.69654381600003, 7.126939195000091],
              [125.70215905000009, 7.177150783000059],
              [125.70655358200008, 7.191839911000045],
              [125.71583092500009, 7.19594961100006],
              [125.72364342500009, 7.193101304000038],
              [125.72934004000001, 7.186102606000077],
              [125.73316491000003, 7.177557684000078],
              [125.74952233200008, 7.162054755000042],
              [125.76734459700003, 7.149725653000075],
              [125.78191165500004, 7.135199286000045],
              [125.78785241000003, 7.112982489000046],
              [125.78126061300009, 6.984849351000094],
              [125.78419030000009, 6.963120835000041],
              [125.79127037900003, 6.948187567000048],
            ],
          ],
          [
            [
              [122.97169030000009, 7.383612372000073],
              [122.95167076900009, 7.386419989000046],
              [122.94450931100005, 7.389837958000044],
              [122.95053144600001, 7.373480536000045],
              [122.95232181100005, 7.363511460000041],
              [122.95069420700008, 7.355698960000041],
              [122.94353274800005, 7.349269924000055],
              [122.93677819100003, 7.348578192000048],
              [122.93034915500004, 7.349676825000074],
              [122.92457116000003, 7.348863023000092],
              [122.89478600400003, 7.32680898600006],
              [122.88298587300005, 7.32094961100006],
              [122.87452233200008, 7.31867096600007],
              [122.86158287900003, 7.316961981000077],
              [122.85499108200008, 7.31476471600007],
              [122.85075931100005, 7.310288804000038],
              [122.84555097700002, 7.297796942000048],
              [122.84205162900003, 7.294256903000075],
              [122.82699629000001, 7.29132721600007],
              [122.81666100400003, 7.294907945000091],
              [122.80860436300009, 7.304877020000049],
              [122.80054772200003, 7.32094961100006],
              [122.79468834700003, 7.34634023600006],
              [122.79420006600003, 7.383937893000052],
              [122.80372155000009, 7.417466539000088],
              [122.82837975400003, 7.430812893000052],
              [122.84310957100001, 7.422796942000048],
              [122.85499108200008, 7.407863674000055],
              [122.86719811300009, 7.395982164000088],
              [122.88298587300005, 7.397284247000073],
              [122.88982181100005, 7.407212632000039],
              [122.89128665500004, 7.419989325000074],
              [122.89429772200003, 7.431586005000042],
              [122.90503991000003, 7.437730210000041],
              [122.92351321700005, 7.430853583000044],
              [122.94410241000003, 7.416245835000041],
              [122.96176191500001, 7.398911851000094],
              [122.97169030000009, 7.383612372000073],
            ],
          ],
          [
            [
              [121.25245201900009, 9.63117096600007],
              [121.25684655000009, 9.627346096000053],
              [121.25717207100001, 9.62445709800005],
              [121.23462975400003, 9.594305731000077],
              [121.22364342500009, 9.583319403000075],
              [121.21094811300009, 9.575873114000046],
              [121.21355228000004, 9.584377346000053],
              [121.22364342500009, 9.60569896000004],
              [121.22803795700008, 9.610052802000041],
              [121.23910566500001, 9.61432526200008],
              [121.24488366000003, 9.624416408000059],
              [121.25001061300009, 9.635931708000044],
              [121.25863691500001, 9.64484284100007],
              [121.25782311300009, 9.638373114000046],
              [121.25660241000003, 9.635565497000073],
              [121.25473066500001, 9.63385651200008],
              [121.25245201900009, 9.63117096600007],
            ],
          ],
          [
            [
              [125.99024498800009, 9.685736395000049],
              [126.00147545700008, 9.67674388200004],
              [125.99756920700008, 9.656073309000078],
              [125.98023522200003, 9.61749909100007],
              [125.98511803500003, 9.605658270000049],
              [125.98414147200003, 9.589504299000055],
              [125.97852623800009, 9.57518138200004],
              [125.96941165500004, 9.56907786700009],
              [125.95394941500001, 9.565659898000092],
              [125.94695071700005, 9.566229559000078],
              [125.95289147200003, 9.581976630000042],
              [125.94629967500009, 9.587591864000046],
              [125.93523196700005, 9.589911200000074],
              [125.92505944100003, 9.589544989000046],
              [125.92505944100003, 9.596380927000041],
              [125.93531334700003, 9.59601471600007],
              [125.93873131600003, 9.596380927000041],
              [125.93873131600003, 9.60382721600007],
              [125.91814212300005, 9.61749909100007],
              [125.91814212300005, 9.610052802000041],
              [125.91553795700008, 9.618963934000078],
              [125.91651451900009, 9.62913646000004],
              [125.92505944100003, 9.65102773600006],
              [125.92969811300009, 9.657945054000038],
              [125.93360436300009, 9.66038646000004],
              [125.93669681100005, 9.663560289000088],
              [125.93873131600003, 9.672756252000056],
              [125.93897545700008, 9.681341864000046],
              [125.93751061300009, 9.692531643000052],
              [125.93873131600003, 9.699408270000049],
              [125.92888431100005, 9.71507396000004],
              [125.92725670700008, 9.738714911000045],
              [125.93482506600003, 9.759914455000057],
              [125.95240319100003, 9.76829661700009],
              [125.95801842500009, 9.761379299000055],
              [125.96021569100003, 9.755804755000042],
              [125.95972741000003, 9.747219143000052],
              [125.969086134, 9.75193919500009],
              [125.97282962300005, 9.75462474200009],
              [125.97461998800009, 9.738348700000074],
              [125.97291100400003, 9.715277411000045],
              [125.97543379000001, 9.694647528000075],
              [125.99024498800009, 9.685736395000049],
            ],
          ],
          [
            [
              [126.56918379000001, 7.30109284100007],
              [126.57740319100003, 7.295314846000053],
              [126.61036217500009, 7.277044989000046],
              [126.61768639400009, 7.276841539000088],
              [126.61231530000009, 7.257879950000074],
              [126.58838951900009, 7.226792710000041],
              [126.58285566500001, 7.208644924000055],
              [126.57976321700005, 7.201076565000051],
              [126.57195071700005, 7.198187567000048],
              [126.56299889400009, 7.196356512000079],
              [126.55567467500009, 7.191839911000045],
              [126.55030358200008, 7.18305084800005],
              [126.529633009, 7.129136460000041],
              [126.52320397200003, 7.118841864000046],
              [126.49105879000001, 7.088812567000048],
              [126.47641035200002, 7.066229559000078],
              [126.46851647200003, 7.038763739000046],
              [126.46615644600001, 7.003119208000044],
              [126.451508009, 6.983547268000052],
              [126.41749108200008, 6.980047919000071],
              [126.37859134200005, 6.987372137000079],
              [126.34945722700002, 7.000067450000074],
              [126.32398522200003, 6.978094794000071],
              [126.30958092500009, 6.948919989000046],
              [126.30323326900009, 6.918646552000041],
              [126.30176842500009, 6.893255927000041],
              [126.30746504000001, 6.881415106000077],
              [126.33448326900009, 6.858587958000044],
              [126.34327233200008, 6.849188544000071],
              [126.34750410200002, 6.833889065000051],
              [126.34929446700005, 6.812933661000045],
              [126.34701582100001, 6.794501044000071],
              [126.33961022200003, 6.786525783000059],
              [126.30884850400003, 6.798041083000044],
              [126.29127037900003, 6.825832424000055],
              [126.26832116000003, 6.890204169000071],
              [126.24268639400009, 6.919256903000075],
              [126.21290123800009, 6.934027411000045],
              [126.19190514400009, 6.925116278000075],
              [126.19255618600005, 6.883368231000077],
              [126.18572024800005, 6.883368231000077],
              [126.18311608200008, 6.889471747000073],
              [126.17212975400003, 6.903876044000071],
              [126.16797936300009, 6.882554429000038],
              [126.17855879000001, 6.861395575000074],
              [126.19288170700008, 6.841701565000051],
              [126.20785566500001, 6.805894273000092],
              [126.22575931100005, 6.789740302000041],
              [126.24431399800005, 6.776516018000052],
              [126.25456790500004, 6.766669012000079],
              [126.25717207100001, 6.744818427000041],
              [126.24415123800009, 6.703924872000073],
              [126.22877037900003, 6.616197007000039],
              [126.226898634, 6.468939520000049],
              [126.21021569100003, 6.390204169000071],
              [126.20606530000009, 6.299302476000094],
              [126.20020592500009, 6.283189195000091],
              [126.18572024800005, 6.286851304000038],
              [126.18213951900009, 6.300726630000042],
              [126.17774498800009, 6.351467190000051],
              [126.17554772200003, 6.362616278000075],
              [126.14128665500004, 6.38617584800005],
              [126.13721764400009, 6.395575262000079],
              [126.13697350400003, 6.407416083000044],
              [126.13819420700008, 6.419867255000042],
              [126.13786868600005, 6.430853583000044],
              [126.11296634200005, 6.477362372000073],
              [126.10010826900009, 6.493719794000071],
              [126.09506269600001, 6.514105536000045],
              [126.08269290500004, 6.639715887000079],
              [126.084320509, 6.663072007000039],
              [126.09636478000004, 6.725043036000045],
              [126.09595787900003, 6.747219143000052],
              [126.08529707100001, 6.782619533000059],
              [126.08269290500004, 6.804510809000078],
              [126.08269290500004, 6.830877997000073],
              [126.07911217500009, 6.84251536700009],
              [126.06714928500003, 6.847886460000041],
              [126.04175866000003, 6.855414130000042],
              [126.02214603000004, 6.866766669000071],
              [125.98340905000009, 6.920884507000039],
              [125.97681725400003, 6.939601955000057],
              [125.98568769600001, 6.986070054000038],
              [125.98650149800005, 7.006293036000045],
              [125.97478274800005, 7.027736721000053],
              [125.91504967500009, 7.085028387000079],
              [125.90259850400003, 7.101141669000071],
              [125.89795983200008, 7.116034247000073],
              [125.89087975400003, 7.157049872000073],
              [125.85059655000009, 7.253892320000091],
              [125.84986412900003, 7.294256903000075],
              [125.85320071700005, 7.316229559000078],
              [125.85320071700005, 7.336004950000074],
              [125.84538821700005, 7.35024648600006],
              [125.83073978000004, 7.354274807000081],
              [125.82545006600003, 7.355698960000041],
              [125.80689537900003, 7.351141669000071],
              [125.74683678500003, 7.307928778000075],
              [125.687836134, 7.274644273000092],
              [125.67676842500009, 7.264634507000039],
              [125.67660566500001, 7.264471747000073],
              [125.668304884, 7.257025458000044],
              [125.65691165500004, 7.23704661700009],
              [125.65398196700005, 7.215073960000041],
              [125.65935306100005, 7.14984772300005],
              [125.65805097700002, 7.129136460000041],
              [125.65455162900003, 7.119574286000045],
              [125.64616946700005, 7.107855536000045],
              [125.64437910200002, 7.09906647300005],
              [125.639008009, 7.088771877000056],
              [125.60352623800009, 7.054632880000042],
              [125.57545006600003, 7.038723049000055],
              [125.54175866000003, 7.030585028000075],
              [125.50993899800005, 7.015570380000042],
              [125.48747806100005, 6.978949286000045],
              [125.48462975400003, 6.935126044000071],
              [125.48064212300005, 6.913234768000052],
              [125.46973717500009, 6.903876044000071],
              [125.42465254000001, 6.849188544000071],
              [125.40357506600003, 6.811835028000075],
              [125.38892662900003, 6.76829661700009],
              [125.38038170700008, 6.721502997000073],
              [125.37761478000004, 6.674221096000053],
              [125.38062584700003, 6.657212632000039],
              [125.39429772200003, 6.618231512000079],
              [125.39747155000009, 6.598456122000073],
              [125.40552819100003, 6.588853257000039],
              [125.42188561300009, 6.58234284100007],
              [125.43458092500009, 6.58820221600007],
              [125.43213951900009, 6.615790106000077],
              [125.46509850400003, 6.594671942000048],
              [125.50806725400003, 6.539496161000045],
              [125.53451582100001, 6.512844143000052],
              [125.55323326900009, 6.52484772300005],
              [125.57357832100001, 6.516913153000075],
              [125.58985436300009, 6.499172268000052],
              [125.59669030000009, 6.481756903000075],
              [125.59766686300009, 6.442694403000075],
              [125.60141035200002, 6.427883205000057],
              [125.63013756600003, 6.366197007000039],
              [125.640961134, 6.352362372000073],
              [125.64478600400003, 6.344142971000053],
              [125.64551842500009, 6.332586981000077],
              [125.64437910200002, 6.310492255000042],
              [125.64584394600001, 6.299627997000073],
              [125.64926191500001, 6.29242584800005],
              [125.65805097700002, 6.28001536700009],
              [125.70655358200008, 6.149725653000075],
              [125.71013431100005, 6.132066148000092],
              [125.71062259200005, 6.111029364000046],
              [125.70655358200008, 6.089544989000046],
              [125.69605553500003, 6.071193752000056],
              [125.69239342500009, 6.060980536000045],
              [125.69922936300009, 6.04047272300005],
              [125.69605553500003, 6.02993398600006],
              [125.69214928500003, 6.021877346000053],
              [125.68531334700003, 5.992661851000094],
              [125.66732832100001, 5.950140692000048],
              [125.59457441500001, 5.862127997000073],
              [125.49903405000009, 5.726141669000071],
              [125.43637129000001, 5.617661851000094],
              [125.42164147200003, 5.598211981000077],
              [125.40300540500004, 5.580877997000073],
              [125.38754316500001, 5.573797919000071],
              [125.37126712300005, 5.572943427000041],
              [125.32276451900009, 5.575506903000075],
              [125.30836022200003, 5.579575914000088],
              [125.30241946700005, 5.592189846000053],
              [125.30014082100001, 5.67133209800005],
              [125.29509524800005, 5.691066799000055],
              [125.28825931100005, 5.706040757000039],
              [125.27865644600001, 5.716498114000046],
              [125.26433353000004, 5.722560940000051],
              [125.24317467500009, 5.724554755000042],
              [125.23780358200008, 5.72797272300005],
              [125.23194420700008, 5.736273505000042],
              [125.22730553500003, 5.746568101000094],
              [125.22543379000001, 5.75617096600007],
              [125.22095787900003, 5.766424872000073],
              [125.21045983200008, 5.77212148600006],
              [125.19898522200003, 5.775580145000049],
              [125.19141686300009, 5.779201565000051],
              [125.18116295700008, 5.798325914000088],
              [125.18506920700008, 5.814520575000074],
              [125.19402103000004, 5.829494533000059],
              [125.19874108200008, 5.844916083000044],
              [125.20183353000004, 5.860541083000044],
              [125.20899498800009, 5.876857815000051],
              [125.22543379000001, 5.903265692000048],
              [125.264008009, 5.94993724200009],
              [125.27800540500004, 5.97923411700009],
              [125.28077233200008, 6.019354559000078],
              [125.27670332100001, 6.036037502000056],
              [125.26319420700008, 6.072211005000042],
              [125.26026451900009, 6.084540106000077],
              [125.25074303500003, 6.093085028000075],
              [125.24008222700002, 6.094224351000094],
              [125.22925866000003, 6.095404364000046],
              [125.19141686300009, 6.095119533000059],
              [125.17945397200003, 6.106756903000075],
              [125.16895592500009, 6.11196523600006],
              [125.15788821700005, 6.108791408000059],
              [125.15528405000009, 6.100165106000077],
              [125.15772545700008, 6.074286200000074],
              [125.15447024800005, 6.064357815000051],
              [125.14527428500003, 6.050034898000092],
              [125.11223392000011, 5.953355210000041],
              [125.08871504000001, 5.884711005000042],
              [125.06910241000003, 5.861721096000053],
              [125.04981530000009, 5.861395575000074],
              [125.00220787900003, 5.871975002000056],
              [124.96363366000003, 5.858587958000044],
              [124.93873131600003, 5.863959052000041],
              [124.83741295700008, 5.912258205000057],
              [124.810883009, 5.91860586100006],
              [124.767914259, 5.938055731000077],
              [124.75611412900003, 5.938177802000041],
              [124.74366295700008, 5.93695709800005],
              [124.73267662900003, 5.937445380000042],
              [124.70801842500009, 5.946600653000075],
              [124.64332116000003, 5.985256252000056],
              [124.63648522200003, 5.978420315000051],
              [124.605804884, 5.992336330000057],
              [124.59620201900009, 5.998928127000056],
              [124.59245853000004, 6.005519924000055],
              [124.58969160200002, 6.014634507000039],
              [124.58594811300009, 6.022691148000092],
              [124.57911217500009, 6.026190497000073],
              [124.56137129000001, 6.03001536700009],
              [124.42188561300009, 6.110296942000048],
              [124.37012780000009, 6.132717190000051],
              [124.24577884200005, 6.186509507000039],
              [124.22877037900003, 6.197007554000038],
              [124.20167076900009, 6.221747137000079],
              [124.18946373800009, 6.24054596600007],
              [124.17660566500001, 6.277818101000094],
              [124.16480553500003, 6.294338283000059],
              [124.09791100400003, 6.364650783000059],
              [124.07195071700005, 6.401516018000052],
              [124.05494225400003, 6.437689520000049],
              [124.04249108200008, 6.488470770000049],
              [124.04127037900003, 6.509711005000042],
              [124.03484134200005, 6.530585028000075],
              [124.03296959700003, 6.54242584800005],
              [124.037445509, 6.547552802000041],
              [124.05176842500009, 6.548895575000074],
              [124.05583743600005, 6.552720445000091],
              [124.05494225400003, 6.559027411000045],
              [124.05494225400003, 6.646551825000074],
              [124.05225670700008, 6.66937897300005],
              [124.03386478000004, 6.731919664000088],
              [124.03720136800007, 6.758408921000068],
              [124.03980553500003, 6.779120184000078],
              [124.03663170700008, 6.799709377000056],
              [124.01710045700008, 6.808294989000046],
              [124.01433353000004, 6.80609772300005],
              [124.00326582100001, 6.790228583000044],
              [123.99732506600003, 6.786078192000048],
              [123.994476759, 6.787909247000073],
              [123.99268639400009, 6.791815497000073],
              [123.98943118600005, 6.793931382000039],
              [123.98218834700003, 6.796820380000042],
              [123.974945509, 6.803900458000044],
              [123.96892337300005, 6.812730210000041],
              [123.96550540500004, 6.821275132000039],
              [123.965179884, 6.83234284100007],
              [123.97120201900009, 6.850775458000044],
              [123.97291100400003, 6.859116929000038],
              [123.97486412900003, 6.965318101000094],
              [123.98853600400003, 7.015611070000091],
              [124.02947024800005, 7.115139065000051],
              [124.051117384, 7.136623440000051],
              [124.06836998800009, 7.14134349200009],
              [124.09131920700008, 7.152777411000045],
              [124.12940514400009, 7.177557684000078],
              [124.16675866000003, 7.208400783000059],
              [124.18376712300005, 7.226385809000078],
              [124.19459069100003, 7.253648179000038],
              [124.21273847700002, 7.270575262000079],
              [124.21924889400009, 7.279974677000041],
              [124.22087649800005, 7.289292710000041],
              [124.21924889400009, 7.32094961100006],
              [124.22087649800005, 7.346584377000056],
              [124.22584069100003, 7.365790106000077],
              [124.24675540500004, 7.404120184000078],
              [124.23226972700002, 7.414740302000041],
              [124.21900475400003, 7.415757554000038],
              [124.18775475400003, 7.410345770000049],
              [124.17603600400003, 7.415716864000046],
              [124.16732832100001, 7.431911526000079],
              [124.16309655000009, 7.439642645000049],
              [124.15357506600003, 7.445054429000038],
              [124.14242597700002, 7.46124909100007],
              [124.09522545700008, 7.56118398600006],
              [124.06519616000003, 7.602728583000044],
              [124.02076256600003, 7.633490302000041],
              [124.01335696700005, 7.634344794000071],
              [123.95923912900003, 7.673895575000074],
              [123.91089928500003, 7.698919989000046],
              [123.90349368600005, 7.691473700000074],
              [123.88607832100001, 7.699408270000049],
              [123.86296634200005, 7.70343659100007],
              [123.861664259, 7.703477281000062],
              [123.81812584700003, 7.705145575000074],
              [123.79420006600003, 7.710516669000071],
              [123.77784264400009, 7.723944403000075],
              [123.72380618600005, 7.795599677000041],
              [123.70394941500001, 7.809393622000073],
              [123.68067467500009, 7.815008856000077],
              [123.65796959700003, 7.817206122000073],
              [123.61459394600001, 7.83352285400008],
              [123.60922285200002, 7.835516669000071],
              [123.58692467500009, 7.839341539000088],
              [123.52295983200008, 7.835516669000071],
              [123.50489342500009, 7.831732489000046],
              [123.47999108200008, 7.822658596000053],
              [123.45687910200002, 7.811468817000048],
              [123.44467207100001, 7.801336981000077],
              [123.44825280000009, 7.766424872000073],
              [123.47559655000009, 7.739325262000079],
              [123.49781334700003, 7.708807684000078],
              [123.48568769600001, 7.663560289000088],
              [123.47706139400009, 7.653306382000039],
              [123.46656334700003, 7.643866278000075],
              [123.455414259, 7.635931708000044],
              [123.44467207100001, 7.630072333000044],
              [123.40919030000009, 7.623480536000045],
              [123.40007571700005, 7.61945221600007],
              [123.39625084700003, 7.611761786000045],
              [123.39527428500003, 7.600409247000073],
              [123.39625084700003, 7.578558661000045],
              [123.39234459700003, 7.57562897300005],
              [123.37159264400009, 7.588039455000057],
              [123.36215254000001, 7.589056708000044],
              [123.35352623800009, 7.572088934000078],
              [123.36687259200005, 7.55219147300005],
              [123.38640384200005, 7.532619533000059],
              [123.39625084700003, 7.516791083000044],
              [123.40259850400003, 7.492092190000051],
              [123.41765384200005, 7.478664455000057],
              [123.43572024800005, 7.46820709800005],
              [123.45167076900009, 7.452541408000059],
              [123.45866946700005, 7.431301174000055],
              [123.45777428500003, 7.408636786000045],
              [123.45142662900003, 7.387925523000092],
              [123.44125410200002, 7.372748114000046],
              [123.43100019600001, 7.368719794000071],
              [123.41944420700008, 7.372259833000044],
              [123.38803144600001, 7.395412502000056],
              [123.35596764400009, 7.410345770000049],
              [123.342133009, 7.420477606000077],
              [123.31316165500004, 7.451320705000057],
              [123.30437259200005, 7.46743398600006],
              [123.28980553500003, 7.477606512000079],
              [123.28638756600003, 7.482611395000049],
              [123.28638756600003, 7.504584052000041],
              [123.28443444100003, 7.513251044000071],
              [123.28028405000009, 7.520209052000041],
              [123.26441491000003, 7.526353257000039],
              [123.24382571700005, 7.52407461100006],
              [123.22584069100003, 7.515611070000091],
              [123.21810957100001, 7.503404039000088],
              [123.21257571700005, 7.489325262000079],
              [123.19947350400003, 7.482001044000071],
              [123.18360436300009, 7.480943101000094],
              [123.17042076900009, 7.486029364000046],
              [123.14063561300009, 7.51312897300005],
              [123.12745201900009, 7.531480210000041],
              [123.12208092500009, 7.550604559000078],
              [123.12761478000004, 7.57257721600007],
              [123.14177493600005, 7.579820054000038],
              [123.15967858200008, 7.582098700000074],
              [123.17725670700008, 7.589056708000044],
              [123.18751061300009, 7.605861721000053],
              [123.18677819100003, 7.626206773000092],
              [123.17530358200008, 7.64329661700009],
              [123.15333092500009, 7.650539455000057],
              [123.14039147200003, 7.661363023000092],
              [123.13542728000004, 7.686468817000048],
              [123.13347415500004, 7.714178778000075],
              [123.12940514400009, 7.733099677000041],
              [123.11793053500003, 7.741359768000052],
              [123.10726972700002, 7.731919664000088],
              [123.09644616000003, 7.71430084800005],
              [123.08472741000003, 7.695217190000051],
              [123.05713951900009, 7.667303778000075],
              [123.05030358200008, 7.655096747000073],
              [123.05152428500003, 7.644964911000045],
              [123.05469811300009, 7.634833075000074],
              [123.05372155000009, 7.622544664000088],
              [123.04957116000003, 7.617987372000073],
              [123.03614342500009, 7.609320380000042],
              [123.03321373800009, 7.605861721000053],
              [123.03451582100001, 7.598618882000039],
              [123.03777103000004, 7.594671942000048],
              [123.04021243600005, 7.59015534100007],
              [123.04004967500009, 7.581610419000071],
              [123.03451582100001, 7.563869533000059],
              [123.01905358200008, 7.541978257000039],
              [123.01221764400009, 7.52765534100007],
              [123.01059004000001, 7.512844143000052],
              [123.01221764400009, 7.482611395000049],
              [123.00660241000003, 7.472357489000046],
              [122.99561608200008, 7.467271226000094],
              [122.99000084700003, 7.470363674000055],
              [122.98462975400003, 7.476060289000088],
              [122.97486412900003, 7.479193427000041],
              [122.97364342500009, 7.480373440000051],
              [122.95069420700008, 7.486029364000046],
              [122.94239342500009, 7.499701239000046],
              [122.92725670700008, 7.538153387000079],
              [122.91724694100003, 7.54751211100006],
              [122.90528405000009, 7.543402411000045],
              [122.89234459700003, 7.531439520000049],
              [122.88168379000001, 7.517401434000078],
              [122.87614993600005, 7.507147528000075],
              [122.87525475400003, 7.49282461100006],
              [122.87794030000009, 7.483710028000075],
              [122.87647545700008, 7.475978908000059],
              [122.86255944100003, 7.46556224200009],
              [122.85141035200002, 7.461004950000074],
              [122.83725019600001, 7.45844147300005],
              [122.82203209700003, 7.459418036000045],
              [122.80738366000003, 7.46556224200009],
              [122.81348717500009, 7.477769273000092],
              [122.81031334700003, 7.486070054000038],
              [122.80396569100003, 7.490179755000042],
              [122.80054772200003, 7.489732164000088],
              [122.79859459700003, 7.487127997000073],
              [122.79444420700008, 7.485256252000056],
              [122.78988691500001, 7.48468659100007],
              [122.78687584700003, 7.486029364000046],
              [122.78565514400009, 7.491766669000071],
              [122.78809655000009, 7.49681224200009],
              [122.79167728000004, 7.499945380000042],
              [122.79371178500003, 7.499701239000046],
              [122.79249108200008, 7.522691148000092],
              [122.79712975400003, 7.535589911000045],
              [122.808929884, 7.537543036000045],
              [122.82837975400003, 7.52765534100007],
              [122.83073978000004, 7.549790757000039],
              [122.82276451900009, 7.564439195000091],
              [122.81234785200002, 7.57689036700009],
              [122.80738366000003, 7.592474677000041],
              [122.79997806100005, 7.654201565000051],
              [122.79371178500003, 7.671047268000052],
              [122.80152428500003, 7.684393622000073],
              [122.80836022200003, 7.704250393000052],
              [122.81299889400009, 7.725531317000048],
              [122.81470787900003, 7.743353583000044],
              [122.80437259200005, 7.758612372000073],
              [122.78044681100005, 7.759833075000074],
              [122.73902428500003, 7.754136460000041],
              [122.73047936300009, 7.760728257000039],
              [122.71485436300009, 7.780951239000046],
              [122.70427493600005, 7.788316148000092],
              [122.65984134200005, 7.788316148000092],
              [122.65105228000004, 7.786078192000048],
              [122.63070722700002, 7.776312567000048],
              [122.61866295700008, 7.77407461100006],
              [122.59669030000009, 7.761419989000046],
              [122.51148522200003, 7.695705471000053],
              [122.48560631600003, 7.666896877000056],
              [122.44385826900009, 7.608587958000044],
              [122.43384850400003, 7.590643622000073],
              [122.43360436300009, 7.578558661000045],
              [122.45167076900009, 7.574408270000049],
              [122.47185306100005, 7.579901434000078],
              [122.48560631600003, 7.578517971000053],
              [122.48511803500003, 7.553697007000039],
              [122.47877037900003, 7.539862372000073],
              [122.46753991000003, 7.522853908000059],
              [122.45443769600001, 7.507757880000042],
              [122.44361412900003, 7.499701239000046],
              [122.45142662900003, 7.534165757000039],
              [122.45101972700002, 7.540676174000055],
              [122.43995201900009, 7.541937567000048],
              [122.42847741000003, 7.532904364000046],
              [122.41968834700003, 7.52016836100006],
              [122.41627037900003, 7.510239976000094],
              [122.40593509200005, 7.499945380000042],
              [122.35987389400009, 7.472845770000049],
              [122.347992384, 7.452541408000059],
              [122.35425866000003, 7.43040599200009],
              [122.36882571700005, 7.41046784100007],
              [122.37907962300005, 7.391587632000039],
              [122.37256920700008, 7.372748114000046],
              [122.36378014400009, 7.362209377000056],
              [122.34498131600003, 7.331773179000038],
              [122.33350670700008, 7.323879299000055],
              [122.32292728000004, 7.323146877000056],
              [122.31226647200003, 7.323960679000038],
              [122.30014082100001, 7.32094961100006],
              [122.28044681100005, 7.294501044000071],
              [122.26587975400003, 7.249090887000079],
              [122.25171959700003, 7.164496161000045],
              [122.24935957100001, 7.118109442000048],
              [122.24350019600001, 7.099269924000055],
              [122.20240319100003, 7.042629299000055],
              [122.16732832100001, 6.952704169000071],
              [122.15447024800005, 6.928127346000053],
              [122.13428795700008, 6.914211330000057],
              [122.12370853000004, 6.899644273000092],
              [122.11866295700008, 6.896429755000042],
              [122.09571373800009, 6.897406317000048],
              [122.08676191500001, 6.899644273000092],
              [122.03793379000001, 6.917385158000059],
              [121.96119225400003, 6.958197333000044],
              [121.93702233200008, 6.978949286000045],
              [121.89893639400009, 7.057196356000077],
              [121.89779707100001, 7.140285549000055],
              [121.93344160200002, 7.217922268000052],
              [122.00538170700008, 7.279974677000041],
              [122.03891035200002, 7.295599677000041],
              [122.04688561300009, 7.30109284100007],
              [122.05103600400003, 7.307806708000044],
              [122.05347741000003, 7.316880601000094],
              [122.05176842500009, 7.324896552000041],
              [122.04322350400003, 7.328355210000041],
              [122.03256269600001, 7.339829820000091],
              [122.03467858200008, 7.365790106000077],
              [122.04688561300009, 7.410345770000049],
              [122.04558353000004, 7.442531643000052],
              [122.04688561300009, 7.452541408000059],
              [122.05209394600001, 7.463283596000053],
              [122.06495201900009, 7.48110586100006],
              [122.06739342500009, 7.489732164000088],
              [122.06999759200005, 7.513657945000091],
              [122.07764733200008, 7.528021552000041],
              [122.090179884, 7.537543036000045],
              [122.107758009, 7.54751211100006],
              [122.11963951900009, 7.556545315000051],
              [122.13721764400009, 7.57298411700009],
              [122.14600670700008, 7.588812567000048],
              [122.11353600400003, 7.603257554000038],
              [122.11158287900003, 7.620672919000071],
              [122.12208092500009, 7.657375393000052],
              [122.12273196700005, 7.700384833000044],
              [122.117523634, 7.723211981000077],
              [122.10474694100003, 7.733099677000041],
              [122.09652754000001, 7.744696356000077],
              [122.10499108200008, 7.770819403000075],
              [122.12891686300009, 7.815008856000077],
              [122.21452884200005, 7.921128648000092],
              [122.23959394600001, 7.965725002000056],
              [122.25171959700003, 7.980129299000055],
              [122.26303144600001, 7.989813544000071],
              [122.29224694100003, 8.009914455000057],
              [122.32276451900009, 8.01821523600006],
              [122.36003665500004, 8.04047272300005],
              [122.43799889400009, 8.066555080000057],
              [122.46257571700005, 8.070990302000041],
              [122.47828209700003, 8.061997789000088],
              [122.48243248800009, 8.07054271000004],
              [122.48959394600001, 8.075100002000056],
              [122.49781334700003, 8.074652411000045],
              [122.50505618600005, 8.06826406500005],
              [122.52271569100003, 8.076361395000049],
              [122.599945509, 8.092922268000052],
              [122.63843834700003, 8.108547268000052],
              [122.64966881600003, 8.116034247000073],
              [122.66773522200003, 8.149969794000071],
              [122.67920983200008, 8.164211330000057],
              [122.68441816500001, 8.153957424000055],
              [122.69190514400009, 8.131659247000073],
              [122.71094811300009, 8.11977773600006],
              [122.73519941500001, 8.11546458500004],
              [122.75879967500009, 8.116034247000073],
              [122.85523522200003, 8.132473049000055],
              [122.86850019600001, 8.141831773000092],
              [122.87956790500004, 8.14398834800005],
              [122.90308678500003, 8.144680080000057],
              [122.91391035200002, 8.146551825000074],
              [122.92457116000003, 8.150132554000038],
              [122.94532311300009, 8.161851304000038],
              [123.00261478000004, 8.209133205000057],
              [123.01368248800009, 8.23240794500009],
              [123.00074303500003, 8.250392971000053],
              [122.96436608200008, 8.274359442000048],
              [122.96208743600005, 8.280829169000071],
              [122.95818118600005, 8.302394924000055],
              [122.95818118600005, 8.30849844000005],
              [122.96338951900009, 8.313950914000088],
              [122.98161868600005, 8.324693101000037],
              [122.98536217500009, 8.325873114000046],
              [122.98747806100005, 8.330633856000077],
              [122.99195397200003, 8.335760809000078],
              [122.996429884, 8.342718817000048],
              [122.998383009, 8.353176174000055],
              [122.99724368600005, 8.364650783000059],
              [122.99203535200002, 8.38548411700009],
              [122.99219811300009, 8.39720286700009],
              [122.99927819100003, 8.414943752000056],
              [123.02173912900003, 8.44440338700008],
              [123.02637780000009, 8.462713934000078],
              [123.03101647200003, 8.474554755000042],
              [123.04200280000009, 8.49013906500005],
              [123.05543053500003, 8.50495026200008],
              [123.06739342500009, 8.514553127000056],
              [123.08204186300009, 8.519232489000046],
              [123.160492384, 8.530666408000059],
              [123.19507897200003, 8.542222398000092],
              [123.211273634, 8.541815497000073],
              [123.21550540500004, 8.538316148000092],
              [123.22559655000009, 8.525091864000046],
              [123.23194420700008, 8.520697333000044],
              [123.24203535200002, 8.519110419000071],
              [123.30095462300005, 8.524237372000073],
              [123.31820722700002, 8.53351471600007],
              [123.33106530000009, 8.546616929000038],
              [123.34644616000003, 8.56976959800005],
              [123.34961998800009, 8.576605536000045],
              [123.36353600400003, 8.62327708500004],
              [123.37159264400009, 8.63344961100006],
              [123.38672936300009, 8.63743724200009],
              [123.39234459700003, 8.63572825700004],
              [123.39763431100005, 8.632391669000071],
              [123.40333092500009, 8.629828192000048],
              [123.41065514400009, 8.630560614000046],
              [123.41553795700008, 8.633693752000056],
              [123.42758222700002, 8.644232489000046],
              [123.43637129000001, 8.64948151200008],
              [123.431976759, 8.661078192000048],
              [123.40007571700005, 8.697658596000053],
              [123.39185631600003, 8.709418036000045],
              [123.39014733200008, 8.71938711100006],
              [123.39714603000004, 8.723211981000077],
              [123.41114342500009, 8.726385809000078],
              [123.42481530000009, 8.726955471000053],
              [123.43100019600001, 8.722805080000057],
              [123.43669681100005, 8.721828518000052],
              [123.46192467500009, 8.70726146000004],
              [123.47779381600003, 8.69529857000009],
              [123.48845462300005, 8.69212474200009],
              [123.50025475400003, 8.693101304000038],
              [123.51295006600003, 8.698879299000055],
              [123.51417076900009, 8.647284247000073],
              [123.521820509, 8.622544664000088],
              [123.53972415500004, 8.62376536700009],
              [123.54590905000009, 8.620062567000048],
              [123.54900149800005, 8.618841864000046],
              [123.56137129000001, 8.613836981000077],
              [123.56763756600003, 8.61009349200009],
              [123.57178795700008, 8.604681708000044],
              [123.58130944100003, 8.582831122000073],
              [123.59099368600005, 8.59275950700004],
              [123.59253991000003, 8.60228099200009],
              [123.592133009, 8.61237213700008],
              [123.59498131600003, 8.62376536700009],
              [123.60035241000003, 8.632554429000038],
              [123.61548912900003, 8.651068427000041],
              [123.60328209700003, 8.66307200700004],
              [123.61670983200008, 8.670721747000073],
              [123.63306725400003, 8.668443101000037],
              [123.62907962300005, 8.651068427000041],
              [123.71029707100001, 8.633246161000045],
              [123.72250410200002, 8.628078518000052],
              [123.73096764400009, 8.618882554000038],
              [123.73894290500004, 8.602687893000052],
              [123.74577884200005, 8.602687893000052],
              [123.75407962300005, 8.610296942000048],
              [123.75879967500009, 8.607489325000074],
              [123.76685631600003, 8.589016018000052],
              [123.76490319100003, 8.589097398000092],
              [123.77702884200005, 8.55735911700009],
              [123.78052819100003, 8.55174388200004],
              [123.78638756600003, 8.537665106000077],
              [123.82837975400003, 8.48655833500004],
              [123.84473717500009, 8.45221588700008],
              [123.85759524800005, 8.409409898000092],
              [123.86605879000001, 8.36432526200008],
              [123.86931399800005, 8.243312893000052],
              [123.88477623800009, 8.18545156500005],
              [123.88298587300005, 8.164496161000045],
              [123.87330162900003, 8.153265692000048],
              [123.76775149800005, 8.059027411000045],
              [123.74577884200005, 8.048407294000071],
              [123.70240319100003, 8.045803127000056],
              [123.68474368600005, 8.036810614000046],
              [123.6776636080001, 8.01072825700004],
              [123.67758222700002, 8.010606187000064],
              [123.67750084700003, 8.010199286000045],
              [123.67644290500004, 8.000067450000074],
              [123.67172285200002, 7.980658270000049],
              [123.67066491000003, 7.969224351000037],
              [123.67074629000001, 7.969183661000045],
              [123.67212975400003, 7.967759507000039],
              [123.67644290500004, 7.963364976000037],
              [123.67668704500011, 7.963487046000068],
              [123.68897545700008, 7.968329169000071],
              [123.70085696700005, 7.976467190000051],
              [123.70484459700003, 7.980129299000055],
              [123.74097741000003, 8.000433661000045],
              [123.87370853000004, 8.105169989000046],
              [123.88640384200005, 8.109198309000078],
              [123.90748131600003, 8.113226630000042],
              [123.92204837300005, 8.123236395000049],
              [123.94507897200003, 8.150132554000038],
              [123.96892337300005, 8.167792059000078],
              [124.00025475400003, 8.181341864000046],
              [124.03630618600005, 8.189846096000053],
              [124.15577233200008, 8.190252997000073],
              [124.19849694100003, 8.196478583000044],
              [124.23226972700002, 8.21287669500009],
              [124.24244225400003, 8.22532786700009],
              [124.25806725400003, 8.255926825000074],
              [124.27027428500003, 8.27094147300005],
              [124.27466881600003, 8.281073309000078],
              [124.27076256600003, 8.291449286000045],
              [124.26392662900003, 8.30182526200008],
              [124.26042728000004, 8.311916408000059],
              [124.26172936300009, 8.32453034100007],
              [124.26539147200003, 8.33397044500009],
              [124.27393639400009, 8.350043036000045],
              [124.27458743600005, 8.35455963700008],
              [124.27320397200003, 8.364813544000071],
              [124.27393639400009, 8.369289455000057],
              [124.27702884200005, 8.373521226000037],
              [124.28394616000003, 8.378607489000046],
              [124.28695722700002, 8.38353099200009],
              [124.29623457100001, 8.404730536000045],
              [124.29948978000004, 8.41547272300005],
              [124.30201256600003, 8.452460028000075],
              [124.30591881600003, 8.47370026200008],
              [124.32178795700008, 8.514553127000056],
              [124.34253991000003, 8.548651434000078],
              [124.37110436300009, 8.581366278000075],
              [124.40577233200008, 8.607896226000037],
              [124.44459069100003, 8.62376536700009],
              [124.46998131600003, 8.624823309000078],
              [124.47608483200008, 8.614569403000075],
              [124.47535241000003, 8.59870026200008],
              [124.48015384200005, 8.582831122000073],
              [124.48519941500001, 8.582464911000045],
              [124.50855553500003, 8.577337958000044],
              [124.51050866000003, 8.575995184000078],
              [124.51742597700002, 8.574652411000045],
              [124.52588951900009, 8.571112372000073],
              [124.54078209700003, 8.561712958000044],
              [124.57154381600003, 8.528143622000073],
              [124.58253014400009, 8.520697333000044],
              [124.599945509, 8.516180731000077],
              [124.65748131600003, 8.514553127000056],
              [124.64844811300009, 8.49632396000004],
              [124.640961134, 8.47601959800005],
              [124.63648522200003, 8.454291083000044],
              [124.63648522200003, 8.43195221600007],
              [124.64332116000003, 8.43195221600007],
              [124.65064537900003, 8.458197333000044],
              [124.66309655000009, 8.475816148000092],
              [124.68295332100001, 8.481838283000059],
              [124.71216881600003, 8.47296784100007],
              [124.71648196700005, 8.479803778000075],
              [124.73267662900003, 8.493394273000092],
              [124.73633873800009, 8.495021877000056],
              [124.74976647200003, 8.498724677000041],
              [124.75318444100003, 8.50023021000004],
              [124.75367272200003, 8.50657786700009],
              [124.75098717500009, 8.512518622000073],
              [124.74773196700005, 8.517401434000078],
              [124.74634850400003, 8.520697333000044],
              [124.75049889400009, 8.55149974200009],
              [124.75318444100003, 8.561712958000044],
              [124.75733483200008, 8.56907786700009],
              [124.76978600400003, 8.586330471000053],
              [124.77361087300005, 8.59642161700009],
              [124.77149498800009, 8.61587148600006],
              [124.75147545700008, 8.650458075000074],
              [124.74634850400003, 8.67096588700008],
              [124.75123131600003, 8.692775783000059],
              [124.76319420700008, 8.706000067000048],
              [124.77711022200003, 8.717352606000077],
              [124.78785241000003, 8.733628648000092],
              [124.78003991000003, 8.752875067000048],
              [124.78077233200008, 8.774603583000044],
              [124.78785241000003, 8.81899648600006],
              [124.78785241000003, 8.90428294500009],
              [124.78077233200008, 8.94912344000005],
              [124.78174889400009, 8.971136786000045],
              [124.79102623800009, 8.990627346000053],
              [124.79908287900003, 8.99998607000009],
              [124.80941816500001, 9.009466864000046],
              [124.82081139400009, 9.014553127000056],
              [124.83204186300009, 9.01072825700004],
              [124.84359785200002, 9.003729559000078],
              [124.85377037900003, 9.003973700000074],
              [124.86402428500003, 9.006740627000056],
              [124.87671959700003, 9.007391669000071],
              [124.89519290500004, 9.002752997000073],
              [124.91529381600003, 8.99412669500009],
              [124.93140709700003, 8.98273346600007],
              [124.93816165500004, 8.96979401200008],
              [124.94727623800009, 8.962469794000071],
              [125.02637780000009, 8.918524481000077],
              [125.03443444100003, 8.911769924000055],
              [125.05738366000003, 8.88226959800005],
              [125.07276451900009, 8.872788804000038],
              [125.09302819100003, 8.839789130000042],
              [125.10596764400009, 8.829779364000046],
              [125.11573326900009, 8.830552476000037],
              [125.13746178500003, 8.843491929000038],
              [125.15935306100005, 8.851141669000071],
              [125.17644290500004, 8.860581773000092],
              [125.18734785200002, 8.875921942000048],
              [125.19532311300009, 8.960882880000042],
              [125.19141686300009, 8.980047919000071],
              [125.18775475400003, 8.985907294000071],
              [125.18311608200008, 8.991400458000044],
              [125.17920983200008, 8.997992255000042],
              [125.17774498800009, 9.007391669000071],
              [125.17994225400003, 9.019476630000042],
              [125.18921959700003, 9.03937409100007],
              [125.19141686300009, 9.052069403000075],
              [125.19190514400009, 9.064927476000037],
              [125.19410241000003, 9.072414455000057],
              [125.19947350400003, 9.078273830000057],
              [125.20875084700003, 9.086493231000077],
              [125.21851647200003, 9.08812083500004],
              [125.22722415500004, 9.07884349200009],
              [125.23975670700008, 9.055161851000037],
              [125.26929772200003, 9.015570380000042],
              [125.28874759200005, 9.000433661000045],
              [125.31177819100003, 8.994330145000049],
              [125.37671959700003, 8.991359768000052],
              [125.41993248800009, 8.981594143000052],
              [125.44117272200003, 8.980414130000042],
              [125.46216881600003, 8.985174872000073],
              [125.51661217500009, 9.01593659100007],
              [125.52654056100005, 9.026190497000073],
              [125.53451582100001, 9.048976955000057],
              [125.54070071700005, 9.084051825000074],
              [125.54200280000009, 9.189195054000038],
              [125.53931725400003, 9.206691799000055],
              [125.53321373800009, 9.217596747000073],
              [125.52605228000004, 9.226955471000053],
              [125.52100670700008, 9.239488023000092],
              [125.52027428500003, 9.248236395000049],
              [125.52149498800009, 9.266180731000077],
              [125.52100670700008, 9.27484772300005],
              [125.51783287900003, 9.284491278000075],
              [125.50904381600003, 9.30369700700004],
              [125.50294030000009, 9.32916901200008],
              [125.48373457100001, 9.361273505000042],
              [125.47730553500003, 9.39061107000009],
              [125.47291100400003, 9.39834219000005],
              [125.46827233200008, 9.404242255000042],
              [125.46631920700008, 9.408351955000057],
              [125.46631920700008, 9.43935781500005],
              [125.4652612640001, 9.444688218000067],
              [125.46241295700008, 9.45929596600007],
              [125.44068444100003, 9.51593659100007],
              [125.43816165500004, 9.525824286000045],
              [125.43555748800009, 9.546047268000052],
              [125.39869225400003, 9.681057033000059],
              [125.39747155000009, 9.699408270000049],
              [125.40040123800009, 9.71743398600006],
              [125.40707441500001, 9.733710028000075],
              [125.45573978000004, 9.81281159100007],
              [125.45948326900009, 9.822943427000041],
              [125.47136478000004, 9.80890534100007],
              [125.48845462300005, 9.792914130000042],
              [125.50709069100003, 9.77993398600006],
              [125.54037519600001, 9.771063544000071],
              [125.56902103000004, 9.756659247000073],
              [125.58920332100001, 9.75462474200009],
              [125.58464603000004, 9.73078034100007],
              [125.59262129000001, 9.702337958000044],
              [125.60450280000009, 9.673325914000088],
              [125.61036217500009, 9.64789459800005],
              [125.62012780000009, 9.629787502000056],
              [125.64356530000009, 9.611273505000042],
              [125.67090905000009, 9.600083726000037],
              [125.69288170700008, 9.60382721600007],
              [125.69109134200005, 9.600165106000077],
              [125.69011478000004, 9.596909898000092],
              [125.68864993600005, 9.593491929000038],
              [125.68531334700003, 9.589544989000046],
              [125.69849694100003, 9.589992580000057],
              [125.70590254000001, 9.585150458000044],
              [125.71273847700002, 9.575873114000046],
              [125.72266686300009, 9.575506903000075],
              [125.74398847700002, 9.577378648000092],
              [125.75367272200003, 9.575873114000046],
              [125.77247155000009, 9.554836330000057],
              [125.78101647200003, 9.548570054000038],
              [125.79086347700002, 9.545314846000053],
              [125.84896894600001, 9.537176825000074],
              [125.86801191500001, 9.526922919000071],
              [125.90113366000003, 9.49705638200004],
              [125.91065514400009, 9.494208075000074],
              [125.92318769600001, 9.494289455000057],
              [125.93409264400009, 9.492336330000057],
              [125.93873131600003, 9.483710028000075],
              [125.94044030000009, 9.475002346000053],
              [125.94898522200003, 9.463080145000049],
              [125.95240319100003, 9.45302969000005],
              [125.96338951900009, 9.472479559000078],
              [125.96599368600005, 9.480292059000078],
              [125.97282962300005, 9.480292059000078],
              [125.97266686300009, 9.464016018000052],
              [125.97120201900009, 9.45408763200004],
              [125.96745853000004, 9.44717031500005],
              [125.95972741000003, 9.43935781500005],
              [125.94857832100001, 9.43423086100006],
              [125.920258009, 9.426906643000052],
              [125.91187584700003, 9.41819896000004],
              [125.91098066500001, 9.40493398600006],
              [125.91675866000003, 9.395412502000056],
              [125.92693118600005, 9.38890208500004],
              [125.93873131600003, 9.384711005000042],
              [125.95582116000003, 9.381781317000048],
              [125.96664472700002, 9.384263414000088],
              [125.99390709700003, 9.397772528000075],
              [125.99195397200003, 9.357855536000045],
              [125.99659264400009, 9.324652411000045],
              [126.01172936300009, 9.293850002000056],
              [126.05795332100001, 9.24599844000005],
              [126.06544030000009, 9.241766669000071],
              [126.07585696700005, 9.239488023000092],
              [126.08912194100003, 9.24087148600006],
              [126.10987389400009, 9.251206773000092],
              [126.14340254000001, 9.261419989000046],
              [126.17937259200005, 9.29718659100007],
              [126.19996178500003, 9.308417059000078],
              [126.21989993600005, 9.30565013200004],
              [126.22461998800009, 9.290961005000042],
              [126.21941165500004, 9.27220286700009],
              [126.20036868600005, 9.240627346000053],
              [126.19336998800009, 9.216376044000071],
              [126.18572024800005, 9.171820380000042],
              [126.18572024800005, 9.138332424000055],
              [126.17896569100003, 9.093003648000092],
              [126.18360436300009, 9.08148834800005],
              [126.19450931100005, 9.077460028000075],
              [126.20704186300009, 9.076117255000042],
              [126.21705162900003, 9.07249583500004],
              [126.222992384, 9.06391022300005],
              [126.23365319100003, 9.03937409100007],
              [126.24024498800009, 9.028469143000052],
              [126.31275475400003, 8.956244208000044],
              [126.32227623800009, 8.935370184000078],
              [126.32357832100001, 8.922349351000037],
              [126.33594811300009, 8.884466864000046],
              [126.33187910200002, 8.870021877000056],
              [126.332367384, 8.861070054000038],
              [126.34546959700003, 8.853257554000038],
              [126.34310957100001, 8.845119533000059],
              [126.338226759, 8.837632554000038],
              [126.33594811300009, 8.836086330000057],
              [126.32878665500004, 8.81273021000004],
              [126.31690514400009, 8.787990627000056],
              [126.30005944100003, 8.76829661700009],
              [126.27816816500001, 8.760321356000077],
              [126.24024498800009, 8.735052802000041],
              [126.23414147200003, 8.733628648000092],
              [126.23414147200003, 8.719183661000045],
              [126.24187259200005, 8.710598049000055],
              [126.26148522200003, 8.698879299000055],
              [126.26148522200003, 8.692694403000075],
              [126.25757897200003, 8.69049713700008],
              [126.25700931100005, 8.68968333500004],
              [126.25684655000009, 8.68854401200008],
              [126.25456790500004, 8.685207424000055],
              [126.24219811300009, 8.690008856000077],
              [126.23161868600005, 8.692206122000073],
              [126.20997155000009, 8.692694403000075],
              [126.19776451900009, 8.688299872000073],
              [126.17367597700002, 8.669094143000052],
              [126.13843834700003, 8.654038804000038],
              [126.11890709700003, 8.630560614000046],
              [126.11052493600005, 8.607123114000046],
              [126.13038170700008, 8.586493231000077],
              [126.14820397200003, 8.540676174000055],
              [126.15845787900003, 8.52757396000004],
              [126.16724694100003, 8.526597398000092],
              [126.19996178500003, 8.52757396000004],
              [126.21957441500001, 8.52171458500004],
              [126.22877037900003, 8.52147044500009],
              [126.24024498800009, 8.52757396000004],
              [126.22071373800009, 8.540432033000059],
              [126.21420332100001, 8.548244533000059],
              [126.22046959700003, 8.555487372000073],
              [126.23178144600001, 8.554836330000057],
              [126.24480228000004, 8.549302476000037],
              [126.25749759200005, 8.54686107000009],
              [126.26832116000003, 8.555487372000073],
              [126.29151451900009, 8.544623114000046],
              [126.35694420700008, 8.534369208000044],
              [126.35621178500003, 8.536281643000052],
              [126.35914147200003, 8.53937409100007],
              [126.36443118600005, 8.541815497000073],
              [126.37012780000009, 8.541815497000073],
              [126.36980228000004, 8.538885809000078],
              [126.37322024800005, 8.530829169000071],
              [126.38062584700003, 8.517645575000074],
              [126.40105228000004, 8.50218333500004],
              [126.40528405000009, 8.492621161000045],
              [126.39795983200008, 8.47915273600006],
              [126.40202884200005, 8.476304429000038],
              [126.40691165500004, 8.470404364000046],
              [126.41163170700008, 8.466131903000075],
              [126.38502037900003, 8.467352606000077],
              [126.37435957100001, 8.464544989000046],
              [126.37012780000009, 8.455552476000037],
              [126.36687259200005, 8.432074286000045],
              [126.37012780000009, 8.42763906500005],
              [126.38379967500009, 8.43195221600007],
              [126.38770592500009, 8.415350653000075],
              [126.38005618600005, 8.39557526200008],
              [126.35694420700008, 8.363714911000045],
              [126.35230553500003, 8.36237213700008],
              [126.34050540500004, 8.355169989000046],
              [126.33253014400009, 8.347072658000059],
              [126.33961022200003, 8.34320709800005],
              [126.34327233200008, 8.33812083500004],
              [126.35694420700008, 8.311916408000059],
              [126.36500084700003, 8.30499909100007],
              [126.37989342500009, 8.302069403000075],
              [126.38843834700003, 8.292914130000042],
              [126.37761478000004, 8.267523505000042],
              [126.34587649800005, 8.231390692000048],
              [126.33863366000003, 8.214585679000038],
              [126.34644616000003, 8.195502020000049],
              [126.36158287900003, 8.187160549000055],
              [126.37761478000004, 8.191595770000049],
              [126.39332116000003, 8.200506903000075],
              [126.42335045700008, 8.211004950000074],
              [126.459320509, 8.240179755000042],
              [126.46306399800005, 8.22992584800005],
              [126.45728600400003, 8.144720770000049],
              [126.45394941500001, 8.129339911000045],
              [126.45533287900003, 8.115057684000078],
              [126.46615644600001, 8.095526434000078],
              [126.44288170700008, 8.081447658000059],
              [126.43148847700002, 8.045599677000041],
              [126.43425540500004, 8.005926825000074],
              [126.45313561300009, 7.980129299000055],
              [126.43482506600003, 7.961818752000056],
              [126.39551842500009, 7.933335679000038],
              [126.38379967500009, 7.911200262000079],
              [126.38347415500004, 7.899562893000052],
              [126.38306725400003, 7.885687567000048],
              [126.39136803500003, 7.858303127000056],
              [126.40609785200002, 7.833238023000092],
              [126.42530358200008, 7.815008856000077],
              [126.45492597700002, 7.797308661000045],
              [126.459320509, 7.791693427000041],
              [126.46338951900009, 7.781073309000078],
              [126.48747806100005, 7.74673086100006],
              [126.51099694100003, 7.73273346600007],
              [126.56226647200003, 7.727525132000039],
              [126.58285566500001, 7.719427802000041],
              [126.57569420700008, 7.697088934000078],
              [126.57178795700008, 7.674953518000052],
              [126.56918379000001, 7.626369533000059],
              [126.57357832100001, 7.603501695000091],
              [126.59278405000009, 7.553900458000044],
              [126.60092207100001, 7.506415106000077],
              [126.60726972700002, 7.485174872000073],
              [126.60865319100003, 7.465318101000094],
              [126.59734134200005, 7.445054429000038],
              [126.58570397200003, 7.437323309000078],
              [126.57471764400009, 7.433010158000059],
              [126.56641686300009, 7.426011460000041],
              [126.56299889400009, 7.410345770000049],
              [126.566742384, 7.406683661000045],
              [126.58969160200002, 7.389837958000044],
              [126.58204186300009, 7.367377020000049],
              [126.58073978000004, 7.320013739000046],
              [126.56918379000001, 7.30109284100007],
            ],
          ],
          [
            [
              [125.29509524800005, 9.970648505000042],
              [125.30616295700008, 9.937445380000042],
              [125.30494225400003, 9.932806708000044],
              [125.29639733200008, 9.929266669000071],
              [125.291351759, 9.92218659100007],
              [125.28516686300009, 9.916937567000048],
              [125.27393639400009, 9.919134833000044],
              [125.26742597700002, 9.924505927000041],
              [125.26514733200008, 9.930894273000092],
              [125.26384524800005, 9.93821849200009],
              [125.26026451900009, 9.946478583000044],
              [125.23633873800009, 9.974351304000038],
              [125.19874108200008, 10.035834052000041],
              [125.16480553500003, 10.055975653000075],
              [125.14576256600003, 10.070705471000053],
              [125.13746178500003, 10.086737372000073],
              [125.12582441500001, 10.129828192000048],
              [125.12452233200008, 10.15180084800005],
              [125.13746178500003, 10.165513414000088],
              [125.14909915500004, 10.165961005000042],
              [125.15845787900003, 10.160589911000045],
              [125.17546634200005, 10.14549388200004],
              [125.21648196700005, 10.12962474200009],
              [125.22925866000003, 10.121161200000074],
              [125.23926842500009, 10.103908596000053],
              [125.25342858200008, 10.035834052000041],
              [125.26303144600001, 10.023138739000046],
              [125.27711022200003, 10.00885651200008],
              [125.28956139400009, 9.991685289000088],
              [125.29509524800005, 9.970648505000042],
            ],
          ],
          [
            [
              [124.37973066500001, 10.69131094000005],
              [124.38526451900009, 10.679754950000074],
              [124.38835696700005, 10.667141018000052],
              [124.38998457100001, 10.641302802000041],
              [124.37842858200008, 10.628322658000059],
              [124.30062910200002, 10.59007396000004],
              [124.28435306100005, 10.60382721600007],
              [124.28882897200003, 10.616929429000038],
              [124.301117384, 10.63117096600007],
              [124.30811608200008, 10.64842357000009],
              [124.30958092500009, 10.66233958500004],
              [124.31373131600003, 10.677801825000074],
              [124.31983483200008, 10.69236888200004],
              [124.32764733200008, 10.704006252000056],
              [124.34099368600005, 10.711818752000056],
              [124.35547936300009, 10.710638739000046],
              [124.36915123800009, 10.703070380000042],
              [124.37973066500001, 10.69131094000005],
            ],
          ],
          [
            [
              [124.46583092500009, 10.71360911700009],
              [124.50391686300009, 10.693304755000042],
              [124.52068118600005, 10.665757554000038],
              [124.50879967500009, 10.641546942000048],
              [124.46241295700008, 10.631048895000049],
              [124.40919030000009, 10.648260809000078],
              [124.40845787900003, 10.68382396000004],
              [124.43555748800009, 10.71360911700009],
              [124.46583092500009, 10.71360911700009],
            ],
          ],
          [
            [
              [125.82203209700003, 10.73468659100007],
              [125.83179772200003, 10.720119533000059],
              [125.82691491000003, 10.708929755000042],
              [125.81364993600005, 10.701849677000041],
              [125.79835045700008, 10.699367580000057],
              [125.77979576900009, 10.699164130000042],
              [125.76937910200002, 10.700384833000044],
              [125.76140384200005, 10.705552476000037],
              [125.75025475400003, 10.717352606000077],
              [125.74000084700003, 10.724432684000078],
              [125.70289147200003, 10.74095286700009],
              [125.68409264400009, 10.752752997000073],
              [125.67896569100003, 10.778876044000071],
              [125.68726647200003, 10.805161851000037],
              [125.70915774800005, 10.817694403000075],
              [125.73145592500009, 10.80805084800005],
              [125.74415123800009, 10.758368231000077],
              [125.76050866000003, 10.74095286700009],
              [125.77621504000001, 10.73891836100006],
              [125.80836022200003, 10.740423895000049],
              [125.82203209700003, 10.73468659100007],
            ],
          ],
          [
            [
              [119.63209069100003, 11.069891669000071],
              [119.63982181100005, 11.057766018000052],
              [119.64551842500009, 11.044094143000052],
              [119.64869225400003, 11.02960846600007],
              [119.64795983200008, 11.015285549000055],
              [119.64128665500004, 11.015285549000055],
              [119.63575280000009, 11.01951732000009],
              [119.62907962300005, 11.018866278000075],
              [119.621429884, 11.01463450700004],
              [119.61312910200002, 11.00844961100006],
              [119.60857181100005, 11.024562893000052],
              [119.59693444100003, 11.034735419000071],
              [119.58521569100003, 11.041205145000049],
              [119.57976321700005, 11.04596588700008],
              [119.57667076900009, 11.084051825000074],
              [119.57976321700005, 11.097845770000049],
              [119.62037194100003, 11.081244208000044],
              [119.63209069100003, 11.069891669000071],
            ],
          ],
          [
            [
              [119.61312910200002, 11.20026276200008],
              [119.62842858200008, 11.19017161700009],
              [119.63233483200008, 11.18162669500009],
              [119.62769616000003, 11.173041083000044],
              [119.60987389400009, 11.156724351000037],
              [119.58952884200005, 11.141791083000044],
              [119.58334394600001, 11.138820705000057],
              [119.57007897200003, 11.144354559000078],
              [119.56714928500003, 11.157049872000073],
              [119.56959069100003, 11.170721747000073],
              [119.57292728000004, 11.17914459800005],
              [119.57553144600001, 11.17837148600006],
              [119.59343509200005, 11.18659088700008],
              [119.59766686300009, 11.190822658000059],
              [119.60035241000003, 11.195135809000078],
              [119.60434004000001, 11.198635158000059],
              [119.61312910200002, 11.20026276200008],
            ],
          ],
          [
            [
              [124.59961998800009, 11.563381252000056],
              [124.621429884, 11.553900458000044],
              [124.62501061300009, 11.532700914000088],
              [124.61597741000003, 11.498195705000057],
              [124.60914147200003, 11.48655833500004],
              [124.59245853000004, 11.481634833000044],
              [124.53239993600005, 11.482570705000057],
              [124.50709069100003, 11.488836981000077],
              [124.48633873800009, 11.488226630000042],
              [124.48357181100005, 11.479681708000044],
              [124.47974694100003, 11.474676825000074],
              [124.47266686300009, 11.473944403000075],
              [124.467133009, 11.477728583000044],
              [124.46371504000001, 11.483872789000088],
              [124.46143639400009, 11.490179755000042],
              [124.45883222700002, 11.49445221600007],
              [124.42481530000009, 11.529242255000042],
              [124.41325931100005, 11.546454169000071],
              [124.38648522200003, 11.614488023000092],
              [124.38062584700003, 11.63670482000009],
              [124.37647545700008, 11.645900783000059],
              [124.35499108200008, 11.671210028000075],
              [124.34913170700008, 11.680080471000053],
              [124.36866295700008, 11.678941148000092],
              [124.41797936300009, 11.69367096600007],
              [124.43091881600003, 11.695054429000038],
              [124.469086134, 11.69281647300005],
              [124.49586022200003, 11.69476959800005],
              [124.50538170700008, 11.693060614000046],
              [124.52320397200003, 11.68626536700009],
              [124.54167728000004, 11.675197658000059],
              [124.55600019600001, 11.660223700000074],
              [124.56714928500003, 11.62523021000004],
              [124.59164472700002, 11.57412344000005],
              [124.59961998800009, 11.563381252000056],
            ],
          ],
          [
            [
              [124.81519616000003, 11.63226959800005],
              [124.82178795700008, 11.621486721000053],
              [124.82862389400009, 11.613430080000057],
              [124.83887780000009, 11.607855536000045],
              [124.85621178500003, 11.60492584800005],
              [124.85222415500004, 11.594427802000041],
              [124.85010826900009, 11.583726304000038],
              [124.84937584700003, 11.560248114000046],
              [124.846039259, 11.548773505000042],
              [124.83887780000009, 11.54002513200004],
              [124.83155358200008, 11.536322333000044],
              [124.80787194100003, 11.563381252000056],
              [124.80990644600001, 11.566839911000045],
              [124.80876712300005, 11.577337958000044],
              [124.80201256600003, 11.582464911000045],
              [124.78785241000003, 11.57021719000005],
              [124.77361087300005, 11.60492584800005],
              [124.78077233200008, 11.602240302000041],
              [124.78785241000003, 11.598089911000045],
              [124.78541100400003, 11.61432526200008],
              [124.77605228000004, 11.629828192000048],
              [124.76295006600003, 11.64134349200009],
              [124.74976647200003, 11.645900783000059],
              [124.740570509, 11.65062083500004],
              [124.73617597700002, 11.661688544000071],
              [124.73340905000009, 11.674302476000037],
              [124.72925866000003, 11.683417059000078],
              [124.72242272200003, 11.69326406500005],
              [124.72266686300009, 11.701564846000053],
              [124.73267662900003, 11.721625067000048],
              [124.73951256600003, 11.721625067000048],
              [124.74089603000004, 11.71971263200004],
              [124.75123131600003, 11.70888906500005],
              [124.78484134200005, 11.688706773000092],
              [124.789398634, 11.684881903000075],
              [124.79297936300009, 11.680365302000041],
              [124.79476972700002, 11.674709377000056],
              [124.79623457100001, 11.667792059000078],
              [124.79908287900003, 11.66201406500005],
              [124.81373131600003, 11.65534088700008],
              [124.81657962300005, 11.646063544000071],
              [124.81519616000003, 11.63226959800005],
            ],
          ],
          [
            [
              [122.297211134, 18.40387604400007],
              [122.31714928500003, 18.377427476000037],
              [122.32496178500003, 18.33661530200004],
              [122.32016035200002, 18.29254791900007],
              [122.306976759, 18.251288153000075],
              [122.28858483200008, 18.21820709800005],
              [122.26270592500009, 18.186102606000077],
              [122.24675540500004, 18.171942450000074],
              [122.21371504000001, 18.14996979400007],
              [122.180023634, 18.120754299000055],
              [122.17432701900009, 18.11347077000005],
              [122.16976972700002, 18.100490627000056],
              [122.16911868600005, 18.08812083500004],
              [122.17188561300009, 18.079413153000075],
              [122.17554772200003, 18.07184479400007],
              [122.17725670700008, 18.06317780200004],
              [122.17725670700008, 18.029038804000038],
              [122.18311608200008, 17.996486721000053],
              [122.18344160200002, 17.98436107000009],
              [122.14014733200008, 17.79828522300005],
              [122.13990319100003, 17.787909247000073],
              [122.14323978000004, 17.765285549000055],
              [122.14234459700003, 17.757066148000092],
              [122.13607832100001, 17.744289455000057],
              [122.13575280000009, 17.73729075700004],
              [122.13982181100005, 17.73004791900007],
              [122.15316816500001, 17.71552155200004],
              [122.15626061300009, 17.70693594000005],
              [122.156586134, 17.619289455000057],
              [122.16293379000001, 17.59332916900007],
              [122.19385826900009, 17.519191799000055],
              [122.19711347700002, 17.494614976000037],
              [122.20606530000009, 17.47528717700004],
              [122.22445722700002, 17.45189036700009],
              [122.23959394600001, 17.42682526200008],
              [122.23878014400009, 17.402167059000078],
              [122.24366295700008, 17.391099351000037],
              [122.24634850400003, 17.37490469000005],
              [122.25114993600005, 17.360174872000073],
              [122.26270592500009, 17.35374583500004],
              [122.26644941500001, 17.35537344000005],
              [122.27149498800009, 17.358628648000092],
              [122.27833092500009, 17.36123281500005],
              [122.28711998800009, 17.360581773000092],
              [122.30534915500004, 17.344183661000045],
              [122.31373131600003, 17.34007396000004],
              [122.32601972700002, 17.34088776200008],
              [122.35287519600001, 17.35114166900007],
              [122.36540774800005, 17.35374583500004],
              [122.38160241000003, 17.347398179000038],
              [122.39014733200008, 17.316880601000037],
              [122.40259850400003, 17.305975653000075],
              [122.39779707100001, 17.32908763200004],
              [122.41456139400009, 17.31907786700009],
              [122.43539472700002, 17.29242584800005],
              [122.44361412900003, 17.26561107000009],
              [122.42514082100001, 17.27952708500004],
              [122.41431725400003, 17.283636786000045],
              [122.40943444100003, 17.275213934000078],
              [122.41163170700008, 17.26044342700004],
              [122.42090905000009, 17.23232656500005],
              [122.42310631600003, 17.22060781500005],
              [122.42058353000004, 17.205877997000073],
              [122.41041100400003, 17.175523179000038],
              [122.40943444100003, 17.161932684000078],
              [122.41684004000001, 17.145819403000075],
              [122.44141686300009, 17.12799713700008],
              [122.45101972700002, 17.114162502000056],
              [122.45443769600001, 17.11871979400007],
              [122.46094811300009, 17.123480536000045],
              [122.46469160200002, 17.127834377000056],
              [122.48047936300009, 17.123480536000045],
              [122.49024498800009, 17.132879950000074],
              [122.50098717500009, 17.139797268000052],
              [122.51929772200003, 17.127834377000056],
              [122.52914472700002, 17.10960521000004],
              [122.52906334700003, 17.09052155200004],
              [122.52149498800009, 17.072007554000038],
              [122.50879967500009, 17.055853583000044],
              [122.50391686300009, 17.046535549000055],
              [122.50049889400009, 17.034125067000048],
              [122.49610436300009, 17.023260809000078],
              [122.48829186300009, 17.01854075700004],
              [122.48357181100005, 17.01365794500009],
              [122.47291100400003, 16.98969147300005],
              [122.45972741000003, 16.91201406500005],
              [122.46469160200002, 16.895086981000077],
              [122.44898522200003, 16.864976304000038],
              [122.42269941500001, 16.79433828300006],
              [122.373383009, 16.71352773600006],
              [122.36500084700003, 16.68512604400007],
              [122.34546959700003, 16.642523505000042],
              [122.33838951900009, 16.631293036000045],
              [122.32520592500009, 16.616156317000048],
              [122.30014082100001, 16.56549713700008],
              [122.28638756600003, 16.546820380000042],
              [122.25318444100003, 16.519964911000045],
              [122.24463951900009, 16.510565497000073],
              [122.23878014400009, 16.504055080000057],
              [122.23422285200002, 16.49510325700004],
              [122.23218834700003, 16.48651764500005],
              [122.23194420700008, 16.466498114000046],
              [122.22917728000004, 16.46161530200004],
              [122.21143639400009, 16.44940827000005],
              [122.20427493600005, 16.434759833000044],
              [122.20533287900003, 16.423895575000074],
              [122.21762129000001, 16.39476146000004],
              [122.22413170700008, 16.40851471600007],
              [122.22510826900009, 16.415269273000092],
              [122.23194420700008, 16.415269273000092],
              [122.224945509, 16.38076406500005],
              [122.19190514400009, 16.31736888200004],
              [122.19711347700002, 16.29169342700004],
              [122.21452884200005, 16.307074286000045],
              [122.23194420700008, 16.31903717700004],
              [122.22868899800005, 16.304632880000042],
              [122.20386803500003, 16.263820705000057],
              [122.20337975400003, 16.257473049000055],
              [122.20533287900003, 16.24249909100007],
              [122.20386803500003, 16.23651764500005],
              [122.19874108200008, 16.233710028000075],
              [122.18246504000001, 16.23200104400007],
              [122.17725670700008, 16.230292059000078],
              [122.14942467500009, 16.19554271000004],
              [122.11524498800009, 16.168890692000048],
              [122.08399498800009, 16.13735586100006],
              [122.080414259, 16.135321356000077],
              [122.07699629000001, 16.13271719000005],
              [122.07357832100001, 16.12726471600007],
              [122.07178795700008, 16.11933014500005],
              [122.07243899800005, 16.11155833500004],
              [122.07357832100001, 16.10492584800005],
              [122.07357832100001, 16.09992096600007],
              [122.05925540500004, 16.077785549000055],
              [122.01612389400009, 16.05145905200004],
              [121.99789472700002, 16.031073309000078],
              [121.99170983200008, 16.03851959800005],
              [122.01156660200002, 16.065741278000075],
              [122.02165774800005, 16.083929755000042],
              [122.02588951900009, 16.10370514500005],
              [122.03345787900003, 16.117132880000042],
              [122.08106530000009, 16.148382880000042],
              [122.08757571700005, 16.164455471000053],
              [122.09278405000009, 16.187323309000078],
              [122.10157311300009, 16.20774974200009],
              [122.13257897200003, 16.225490627000056],
              [122.14087975400003, 16.244086005000042],
              [122.13526451900009, 16.26072825700004],
              [122.107758009, 16.263820705000057],
              [122.08741295700008, 16.25531647300005],
              [122.07740319100003, 16.24127838700008],
              [122.07398522200003, 16.22402578300006],
              [122.07357832100001, 16.20575592700004],
              [122.06690514400009, 16.19013092700004],
              [122.05054772200003, 16.180853583000044],
              [122.01221764400009, 16.168890692000048],
              [121.95476321700005, 16.139146226000037],
              [121.94019616000003, 16.134711005000042],
              [121.90398196700005, 16.129828192000048],
              [121.86817467500009, 16.120428778000075],
              [121.85596764400009, 16.11131419500009],
              [121.844086134, 16.100002346000053],
              [121.82992597700002, 16.090399481000077],
              [121.79997806100005, 16.083238023000092],
              [121.78842207100001, 16.07721588700008],
              [121.777679884, 16.073187567000048],
              [121.76954186300009, 16.07575104400007],
              [121.76107832100001, 16.07998281500005],
              [121.752289259, 16.07689036700009],
              [121.68441816500001, 16.021144924000055],
              [121.67872155000009, 16.01072825700004],
              [121.64226321700005, 15.969631252000056],
              [121.59327233200008, 15.944891669000071],
              [121.57781009200005, 15.932074286000045],
              [121.56739342500009, 15.915716864000046],
              [121.56006920700008, 15.895209052000041],
              [121.55298912900003, 15.852932033000059],
              [121.55486087300005, 15.828924872000073],
              [121.570648634, 15.793768622000073],
              [121.574554884, 15.774359442000048],
              [121.58521569100003, 15.765448309000078],
              [121.60865319100003, 15.763088283000059],
              [121.63184655000009, 15.757025458000044],
              [121.64226321700005, 15.736883856000077],
              [121.63656660200002, 15.722479559000078],
              [121.59449303500003, 15.674750067000048],
              [121.61109459700003, 15.671087958000044],
              [121.61980228000004, 15.667466539000088],
              [121.62916100400003, 15.66111888200004],
              [121.59099368600005, 15.640448309000078],
              [121.57374108200008, 15.62726471600007],
              [121.56657962300005, 15.610256252000056],
              [121.56153405000009, 15.591376044000071],
              [121.54900149800005, 15.57640208500004],
              [121.49561608200008, 15.532456773000092],
              [121.48755944100003, 15.520412502000056],
              [121.47925866000003, 15.456203518000052],
              [121.47291100400003, 15.437689520000049],
              [121.46412194100003, 15.421535549000055],
              [121.42628014400009, 15.37376536700009],
              [121.40886478000004, 15.377752997000073],
              [121.39771569100003, 15.38271719000005],
              [121.38990319100003, 15.377875067000048],
              [121.38160241000003, 15.352687893000052],
              [121.37916100400003, 15.308172919000071],
              [121.39112389400009, 15.26626211100006],
              [121.41374759200005, 15.231634833000044],
              [121.44361412900003, 15.20929596600007],
              [121.46843509200005, 15.196112372000073],
              [121.48145592500009, 15.182521877000056],
              [121.48755944100003, 15.163316148000092],
              [121.508148634, 15.06281159100007],
              [121.51531009200005, 15.051662502000056],
              [121.52784264400009, 15.040757554000038],
              [121.56006920700008, 14.989650783000059],
              [121.56657962300005, 14.972805080000057],
              [121.570648634, 14.945990302000041],
              [121.58179772200003, 14.919663804000038],
              [121.59734134200005, 14.89484284100007],
              [121.61500084700003, 14.872870184000078],
              [121.60962975400003, 14.869940497000073],
              [121.59961998800009, 14.862005927000041],
              [121.59449303500003, 14.859198309000078],
              [121.63575280000009, 14.81159088700008],
              [121.64226321700005, 14.800848700000074],
              [121.64991295700008, 14.792181708000044],
              [121.71265709700003, 14.74437083500004],
              [121.724945509, 14.73078034100007],
              [121.72608483200008, 14.72016022300005],
              [121.707367384, 14.71580638200004],
              [121.67090905000009, 14.714341539000088],
              [121.64918053500003, 14.710516669000071],
              [121.62916100400003, 14.702826239000046],
              [121.61394290500004, 14.689886786000045],
              [121.60808353000004, 14.674261786000045],
              [121.60816491000003, 14.630194403000075],
              [121.61068769600001, 14.612616278000075],
              [121.64722741000003, 14.492254950000074],
              [121.65137780000009, 14.45612213700008],
              [121.662445509, 14.417385158000059],
              [121.67017662900003, 14.40110911700009],
              [121.68238366000003, 14.385443427000041],
              [121.72486412900003, 14.345892645000049],
              [121.734711134, 14.328680731000077],
              [121.73609459700003, 14.314886786000045],
              [121.73161868600005, 14.280422268000052],
              [121.73585045700008, 14.273138739000046],
              [121.75464928500003, 14.25576406500005],
              [121.75896243600005, 14.246568101000037],
              [121.75717207100001, 14.230617580000057],
              [121.75212649800005, 14.215725002000056],
              [121.74366295700008, 14.20343659100007],
              [121.73161868600005, 14.195054429000038],
              [121.73161868600005, 14.18821849200009],
              [121.74488366000003, 14.177150783000059],
              [121.78003991000003, 14.126166083000044],
              [121.84766686300009, 14.07835521000004],
              [121.91724694100003, 14.009507554000038],
              [121.93628991000003, 13.99518463700008],
              [122.08790123800009, 13.93781159100007],
              [122.23194420700008, 13.906439520000049],
              [122.23316491000003, 13.93305084800005],
              [122.22201582100001, 13.952093817000048],
              [122.18344160200002, 13.988959052000041],
              [122.20240319100003, 13.994574286000045],
              [122.293304884, 13.970119533000059],
              [122.29851321700005, 13.97256094000005],
              [122.30014082100001, 13.985581773000092],
              [122.29639733200008, 14.002752997000073],
              [122.29981530000009, 14.007554429000038],
              [122.31373131600003, 14.01007721600007],
              [122.31373131600003, 14.016302802000041],
              [122.29078209700003, 14.023098049000055],
              [122.25196373800009, 14.067694403000075],
              [122.23536217500009, 14.07835521000004],
              [122.20866946700005, 14.087632554000038],
              [122.18620853000004, 14.110541083000044],
              [122.17017662900003, 14.13963450700004],
              [122.16293379000001, 14.167792059000078],
              [122.17318769600001, 14.160223700000074],
              [122.17554772200003, 14.155951239000046],
              [122.17725670700008, 14.146673895000049],
              [122.18344160200002, 14.146673895000049],
              [122.18409264400009, 14.169867255000042],
              [122.19556725400003, 14.183783270000049],
              [122.23194420700008, 14.201849677000041],
              [122.24439537900003, 14.19603099200009],
              [122.24756920700008, 14.21279531500005],
              [122.24781334700003, 14.236151434000078],
              [122.25171959700003, 14.25031159100007],
              [122.26368248800009, 14.247381903000075],
              [122.26661217500009, 14.22760651200008],
              [122.264008009, 14.203680731000077],
              [122.25928795700008, 14.18821849200009],
              [122.26685631600003, 14.178859768000052],
              [122.26889082100001, 14.167303778000075],
              [122.26954186300009, 14.154242255000042],
              [122.27279707100001, 14.140448309000078],
              [122.27149498800009, 14.136664130000042],
              [122.27320397200003, 14.132513739000046],
              [122.279633009, 14.126166083000044],
              [122.28435306100005, 14.125881252000056],
              [122.28858483200008, 14.130194403000075],
              [122.29175866000003, 14.136053778000075],
              [122.293304884, 14.140448309000078],
              [122.29851321700005, 14.129339911000045],
              [122.30030358200008, 14.117580471000053],
              [122.30014082100001, 14.09202708500004],
              [122.318695509, 14.100043036000045],
              [122.33497155000009, 14.113226630000042],
              [122.34571373800009, 14.131333726000037],
              [122.347992384, 14.154120184000078],
              [122.34424889400009, 14.160589911000045],
              [122.33008873800009, 14.180568752000056],
              [122.32748457100001, 14.18821849200009],
              [122.33130944100003, 14.20026276200008],
              [122.33765709700003, 14.207586981000077],
              [122.34400475400003, 14.20693594000005],
              [122.347992384, 14.195054429000038],
              [122.35547936300009, 14.195054429000038],
              [122.35670006600003, 14.204657294000071],
              [122.35572350400003, 14.212225653000075],
              [122.35279381600003, 14.218085028000075],
              [122.347992384, 14.222357489000046],
              [122.36695397200003, 14.222154039000088],
              [122.37680097700002, 14.22850169500009],
              [122.37671959700003, 14.239650783000059],
              [122.36540774800005, 14.253404039000088],
              [122.36622155000009, 14.261460679000038],
              [122.38135826900009, 14.29328034100007],
              [122.38892662900003, 14.30491771000004],
              [122.39454186300009, 14.291489976000037],
              [122.40365644600001, 14.295396226000037],
              [122.412445509, 14.309027411000045],
              [122.41627037900003, 14.324774481000077],
              [122.43116295700008, 14.318060614000046],
              [122.44459069100003, 14.324652411000045],
              [122.45753014400009, 14.336615302000041],
              [122.47095787900003, 14.345892645000049],
              [122.48316491000003, 14.34666575700004],
              [122.49463951900009, 14.341376044000071],
              [122.51929772200003, 14.324774481000077],
              [122.51490319100003, 14.329901434000078],
              [122.50505618600005, 14.345892645000049],
              [122.52784264400009, 14.34870026200008],
              [122.57536868600005, 14.329291083000044],
              [122.60124759200005, 14.324774481000077],
              [122.59888756600003, 14.311224677000041],
              [122.60466556100005, 14.301255601000037],
              [122.61378014400009, 14.299709377000056],
              [122.62232506600003, 14.31118398600006],
              [122.62566165500004, 14.296535549000055],
              [122.63461347700002, 14.286037502000056],
              [122.64429772200003, 14.284735419000071],
              [122.64966881600003, 14.29751211100006],
              [122.67798912900003, 14.294663804000038],
              [122.69068444100003, 14.29124583500004],
              [122.67432701900009, 14.316107489000046],
              [122.67139733200008, 14.339422919000071],
              [122.67986087300005, 14.350531317000048],
              [122.69752037900003, 14.338446356000077],
              [122.70427493600005, 14.345892645000049],
              [122.71168053500003, 14.32953522300005],
              [122.72169030000009, 14.315741278000075],
              [122.73511803500003, 14.31354401200008],
              [122.75269616000003, 14.332220770000049],
              [122.75749759200005, 14.325832424000055],
              [122.76270592500009, 14.32135651200008],
              [122.76889082100001, 14.318793036000045],
              [122.78443444100003, 14.316961981000077],
              [122.78541100400003, 14.314154364000046],
              [122.78443444100003, 14.310044664000088],
              [122.78687584700003, 14.30491771000004],
              [122.80258222700002, 14.287176825000074],
              [122.80982506600003, 14.284409898000092],
              [122.82471764400009, 14.28384023600006],
              [122.85328209700003, 14.278550523000092],
              [122.87330162900003, 14.265204169000071],
              [122.90357506600003, 14.229193427000041],
              [122.90455162900003, 14.224025783000059],
              [122.90333092500009, 14.217189846000053],
              [122.90308678500003, 14.21124909100007],
              [122.90699303500003, 14.208685614000046],
              [122.91993248800009, 14.208156643000052],
              [122.92505944100003, 14.20612213700008],
              [122.93083743600005, 14.201849677000041],
              [122.95435631600003, 14.167792059000078],
              [122.96550540500004, 14.15924713700008],
              [123.00269616000003, 14.118882554000038],
              [123.01221764400009, 14.10569896000004],
              [123.02173912900003, 14.111395575000074],
              [123.03272545700008, 14.107814846000053],
              [123.04224694100003, 14.098049221000053],
              [123.04688561300009, 14.085191148000092],
              [123.04395592500009, 14.06976959800005],
              [123.03638756600003, 14.057440497000073],
              [123.03052819100003, 14.043443101000037],
              [123.03321373800009, 14.023138739000046],
              [123.05372155000009, 14.002630927000041],
              [123.07813561300009, 13.988104559000078],
              [123.08155358200008, 13.988959052000041],
              [123.08423912900003, 13.974269924000055],
              [123.08155358200008, 13.928168036000045],
              [123.08838951900009, 13.90143463700008],
              [123.08773847700002, 13.893459377000056],
              [123.08204186300009, 13.884426174000055],
              [123.07496178500003, 13.881659247000073],
              [123.06763756600003, 13.879584052000041],
              [123.06055748800009, 13.87295156500005],
              [123.05591881600003, 13.86131419500009],
              [123.04883873800009, 13.821966864000046],
              [123.04688561300009, 13.81085846600007],
              [123.04981530000009, 13.775824286000045],
              [123.06666100400003, 13.75608958500004],
              [123.08871504000001, 13.74164459800005],
              [123.10824629000001, 13.72211334800005],
              [123.11589603000004, 13.72211334800005],
              [123.13672936300009, 13.732814846000053],
              [123.16089928500003, 13.734076239000046],
              [123.21469160200002, 13.728949286000045],
              [123.224945509, 13.731146552000041],
              [123.25562584700003, 13.743312893000052],
              [123.26661217500009, 13.749416408000059],
              [123.30176842500009, 13.789455471000053],
              [123.30746504000001, 13.801255601000037],
              [123.30958092500009, 13.807928778000075],
              [123.31316165500004, 13.814113674000055],
              [123.31495201900009, 13.82054271000004],
              [123.30827884200005, 13.833319403000075],
              [123.29664147200003, 13.869818427000041],
              [123.28093509200005, 13.891831773000092],
              [123.28028405000009, 13.906439520000049],
              [123.31348717500009, 13.930080471000053],
              [123.31771894600001, 13.934393622000073],
              [123.32553144600001, 13.940008856000077],
              [123.33139082100001, 13.95335521000004],
              [123.33480879000001, 13.969183661000045],
              [123.33545983200008, 13.982163804000038],
              [123.32488040500004, 13.971502997000073],
              [123.31251061300009, 13.940822658000059],
              [123.30404707100001, 13.934393622000073],
              [123.29004967500009, 13.93455638200004],
              [123.28060957100001, 13.936102606000077],
              [123.23462975400003, 13.963812567000048],
              [123.222992384, 13.975816148000092],
              [123.21810957100001, 13.992743231000077],
              [123.22771243600005, 14.000433661000045],
              [123.24529056100005, 14.006781317000048],
              [123.254242384, 14.013739325000074],
              [123.23878014400009, 14.023138739000046],
              [123.25904381600003, 14.031195380000042],
              [123.26172936300009, 14.042303778000075],
              [123.252289259, 14.068101304000038],
              [123.26148522200003, 14.07290273600006],
              [123.28207441500001, 14.066473700000074],
              [123.31430097700002, 14.05109284100007],
              [123.31430097700002, 14.05727773600006],
              [123.31031334700003, 14.060248114000046],
              [123.30079186300009, 14.071519273000092],
              [123.32960045700008, 14.07029857000009],
              [123.33545983200008, 14.071519273000092],
              [123.33529707100001, 14.07876211100006],
              [123.32715905000009, 14.09601471600007],
              [123.33179772200003, 14.09951406500005],
              [123.34506269600001, 14.093695380000042],
              [123.35328209700003, 14.079413153000075],
              [123.36215254000001, 14.04360586100006],
              [123.34538821700005, 14.039536851000037],
              [123.34205162900003, 14.027777411000045],
              [123.34644616000003, 14.016302802000041],
              [123.35230553500003, 14.013169664000088],
              [123.37012780000009, 14.029852606000077],
              [123.37867272200003, 14.035101630000042],
              [123.39014733200008, 14.03733958500004],
              [123.385101759, 14.030910549000055],
              [123.37582441500001, 14.01007721600007],
              [123.38624108200008, 14.014105536000045],
              [123.39014733200008, 14.016302802000041],
              [123.39625084700003, 14.01007721600007],
              [123.39234459700003, 13.991848049000055],
              [123.41179446700005, 13.964260158000059],
              [123.40381920700008, 13.94867584800005],
              [123.41065514400009, 13.93943919500009],
              [123.41521243600005, 13.929388739000046],
              [123.41732832100001, 13.918443101000037],
              [123.41732832100001, 13.906439520000049],
              [123.424164259, 13.906439520000049],
              [123.42945397200003, 13.91937897300005],
              [123.43726647200003, 13.92914459800005],
              [123.443695509, 13.941351630000042],
              [123.44467207100001, 13.96165599200009],
              [123.46469160200002, 13.956447658000059],
              [123.47779381600003, 13.950506903000075],
              [123.48633873800009, 13.940008856000077],
              [123.492523634, 13.920721747000073],
              [123.53882897200003, 13.924953518000052],
              [123.61280358200008, 13.897162177000041],
              [123.68140709700003, 13.88467031500005],
              [123.71168053500003, 13.934393622000073],
              [123.73406009200005, 13.89712148600006],
              [123.76531009200005, 13.86432526200008],
              [123.80404707100001, 13.837632554000038],
              [123.87631269600001, 13.807318427000041],
              [123.87891686300009, 13.803900458000044],
              [123.88005618600005, 13.800726630000042],
              [123.88298587300005, 13.797796942000048],
              [123.89527428500003, 13.794094143000052],
              [123.91944420700008, 13.793768622000073],
              [123.93140709700003, 13.790350653000075],
              [123.93775475400003, 13.784002997000073],
              [123.95191491000003, 13.755601304000038],
              [123.96876061300009, 13.740057684000078],
              [123.97266686300009, 13.729315497000073],
              [123.96550540500004, 13.714667059000078],
              [123.94857832100001, 13.728176174000055],
              [123.94271894600001, 13.734564520000049],
              [123.93751061300009, 13.742621161000045],
              [123.93140709700003, 13.742621161000045],
              [123.92994225400003, 13.738430080000057],
              [123.92457116000003, 13.728949286000045],
              [123.90992272200003, 13.735988674000055],
              [123.89258873800009, 13.740057684000078],
              [123.85938561300009, 13.742621161000045],
              [123.85027103000004, 13.734076239000046],
              [123.836273634, 13.715277411000045],
              [123.81836998800009, 13.696478583000044],
              [123.79737389400009, 13.687974351000037],
              [123.77930748800009, 13.69212474200009],
              [123.74293053500003, 13.710435289000088],
              [123.68816165500004, 13.718695380000042],
              [123.66667728000004, 13.718329169000071],
              [123.65699303500003, 13.71157461100006],
              [123.64795983200008, 13.703558661000045],
              [123.62696373800009, 13.71084219000005],
              [123.603851759, 13.72288646000004],
              [123.58814537900003, 13.728949286000045],
              [123.57048587300005, 13.72296784100007],
              [123.56006920700008, 13.70962148600006],
              [123.52849368600005, 13.626776434000078],
              [123.52662194100003, 13.606024481000077],
              [123.53500410200002, 13.603949286000045],
              [123.53891035200002, 13.600978908000059],
              [123.53663170700008, 13.59516022300005],
              [123.53402754000001, 13.590643622000073],
              [123.53321373800009, 13.585598049000055],
              [123.53345787900003, 13.574693101000037],
              [123.53630618600005, 13.563299872000073],
              [123.54297936300009, 13.560248114000046],
              [123.55176842500009, 13.563625393000052],
              [123.56080162900003, 13.571234442000048],
              [123.59359785200002, 13.529445705000057],
              [123.59831790500004, 13.523586330000057],
              [123.60547936300009, 13.51666901200008],
              [123.66724694100003, 13.485581773000092],
              [123.680023634, 13.469956773000092],
              [123.70484459700003, 13.427232164000088],
              [123.70923912900003, 13.423529364000046],
              [123.72250410200002, 13.415187893000052],
              [123.72535241000003, 13.409898179000038],
              [123.72527103000004, 13.39907461100006],
              [123.72632897200003, 13.39085521000004],
              [123.73145592500009, 13.362534898000092],
              [123.74341881600003, 13.340318101000037],
              [123.75928795700008, 13.323879299000055],
              [123.77711022200003, 13.31736888200004],
              [123.79460696700005, 13.308417059000078],
              [123.80567467500009, 13.28709544500009],
              [123.82154381600003, 13.24290599200009],
              [123.82545006600003, 13.260158596000053],
              [123.83619225400003, 13.25608958500004],
              [123.84815514400009, 13.241888739000046],
              [123.85564212300005, 13.228664455000057],
              [123.78931725400003, 13.23240794500009],
              [123.76758873800009, 13.224310614000046],
              [123.75945071700005, 13.197943427000041],
              [123.75684655000009, 13.180975653000075],
              [123.75220787900003, 13.167629299000055],
              [123.74952233200008, 13.154730536000045],
              [123.75318444100003, 13.13930898600006],
              [123.77019290500004, 13.11078522300005],
              [123.76807701900009, 13.098537502000056],
              [123.74577884200005, 13.09210846600007],
              [123.74577884200005, 13.084662177000041],
              [123.75001061300009, 13.077622789000088],
              [123.74984785200002, 13.072658596000053],
              [123.74577884200005, 13.064154364000046],
              [123.76710045700008, 13.05337148600006],
              [123.77540123800009, 13.05076732000009],
              [123.78736412900003, 13.051174221000053],
              [123.79769941500001, 13.055161851000037],
              [123.81275475400003, 13.068182684000078],
              [123.81812584700003, 13.070990302000041],
              [123.85564212300005, 13.118801174000055],
              [123.86109459700003, 13.127875067000048],
              [123.86500084700003, 13.136379299000055],
              [123.87094160200002, 13.14288971600007],
              [123.88298587300005, 13.146063544000071],
              [123.89454186300009, 13.143500067000048],
              [123.90528405000009, 13.129055080000057],
              [123.91431725400003, 13.12563711100006],
              [123.92432701900009, 13.125067450000074],
              [123.93165123800009, 13.122707424000055],
              [123.93620853000004, 13.117580471000053],
              [123.93751061300009, 13.108587958000044],
              [123.94361412900003, 13.107896226000037],
              [123.97917728000004, 13.098334052000041],
              [123.99236087300005, 13.091620184000078],
              [124.008148634, 13.080023505000042],
              [124.02133222700002, 13.066595770000049],
              [124.02702884200005, 13.054266669000071],
              [124.07113691500001, 13.016099351000037],
              [124.08155358200008, 13.009507554000038],
              [124.09131920700008, 13.018744208000044],
              [124.11231530000009, 13.060492255000042],
              [124.11622155000009, 13.074408270000049],
              [124.12671959700003, 13.078680731000077],
              [124.14991295700008, 13.07290273600006],
              [124.17318769600001, 13.06354401200008],
              [124.18458092500009, 13.057318427000041],
              [124.18824303500003, 13.039536851000037],
              [124.18580162900003, 13.020819403000075],
              [124.17750084700003, 13.00999583500004],
              [124.16480553500003, 13.01634349200009],
              [124.15300540500004, 13.001288153000075],
              [124.14649498800009, 12.989935614000046],
              [124.13689212300005, 12.961737372000073],
              [124.11882571700005, 12.925482489000046],
              [124.11622155000009, 12.916449286000045],
              [124.119476759, 12.900824286000045],
              [124.13363691500001, 12.878485419000071],
              [124.14283287900003, 12.814398505000042],
              [124.14307701900009, 12.797308661000045],
              [124.12940514400009, 12.67719147300005],
              [124.12305748800009, 12.662298895000049],
              [124.09473717500009, 12.64354075700004],
              [124.08838951900009, 12.62881094000005],
              [124.09148196700005, 12.611883856000077],
              [124.09620201900009, 12.601629950000074],
              [124.09506269600001, 12.59365469000005],
              [124.08155358200008, 12.583726304000038],
              [124.08659915500004, 12.577378648000092],
              [124.09522545700008, 12.557074286000045],
              [124.08334394600001, 12.553412177000041],
              [124.066742384, 12.541449286000045],
              [124.05494225400003, 12.537258205000057],
              [124.04224694100003, 12.535834052000041],
              [124.010101759, 12.537258205000057],
              [123.98316491000003, 12.54677969000005],
              [123.95997155000009, 12.568915106000077],
              [123.93140709700003, 12.611721096000053],
              [123.93336022200003, 12.622219143000052],
              [123.92994225400003, 12.62368398600006],
              [123.92302493600005, 12.62107982000009],
              [123.91431725400003, 12.61912669500009],
              [123.89918053500003, 12.635891018000052],
              [123.87859134200005, 12.645209052000041],
              [123.87012780000009, 12.660345770000049],
              [123.86296634200005, 12.679429429000038],
              [123.84253991000003, 12.716213283000059],
              [123.84302819100003, 12.73578522300005],
              [123.84717858200008, 12.755804755000042],
              [123.84880618600005, 12.776190497000073],
              [123.84205162900003, 12.801214911000045],
              [123.82984459700003, 12.811997789000088],
              [123.81316165500004, 12.81867096600007],
              [123.79363040500004, 12.831447658000059],
              [123.81910241000003, 12.831854559000078],
              [123.83871504000001, 12.83930084800005],
              [123.85320071700005, 12.853094794000071],
              [123.86304772200003, 12.872381903000075],
              [123.87387129000001, 12.866929429000038],
              [123.88998457100001, 12.850734768000052],
              [123.89722741000003, 12.845119533000059],
              [123.90674889400009, 12.841620184000078],
              [123.91228274800005, 12.84202708500004],
              [123.91797936300009, 12.843939520000049],
              [123.92798912900003, 12.845119533000059],
              [123.94044030000009, 12.84829336100006],
              [123.94353274800005, 12.856146552000041],
              [123.94385826900009, 12.866115627000056],
              [123.94849694100003, 12.875474351000037],
              [123.95883222700002, 12.880031643000052],
              [123.96957441500001, 12.878078518000052],
              [123.97901451900009, 12.87400950700004],
              [123.98601321700005, 12.872381903000075],
              [124.00245201900009, 12.879706122000073],
              [124.01783287900003, 12.893784898000092],
              [124.02930748800009, 12.911769924000055],
              [124.03386478000004, 12.93040599200009],
              [124.02515709700003, 12.95530833500004],
              [124.00489342500009, 12.961330471000053],
              [123.95866946700005, 12.954291083000044],
              [123.94092858200008, 12.95726146000004],
              [123.91016686300009, 12.971502997000073],
              [123.89340254000001, 12.974798895000049],
              [123.88160241000003, 12.966498114000046],
              [123.87387129000001, 12.94749583500004],
              [123.86850019600001, 12.92682526200008],
              [123.86304772200003, 12.913316148000092],
              [123.83936608200008, 12.888169664000088],
              [123.82300866000003, 12.877020575000074],
              [123.79932701900009, 12.871242580000057],
              [123.79004967500009, 12.866115627000056],
              [123.78394616000003, 12.864935614000046],
              [123.77833092500009, 12.86709219000005],
              [123.76921634200005, 12.876450914000088],
              [123.76319420700008, 12.878607489000046],
              [123.75831139400009, 12.87490469000005],
              [123.74756920700008, 12.857489325000074],
              [123.73894290500004, 12.85187409100007],
              [123.73536217500009, 12.85032786700009],
              [123.72974694100003, 12.846258856000077],
              [123.72535241000003, 12.845119533000059],
              [123.72006269600001, 12.859076239000046],
              [123.71168053500003, 12.872381903000075],
              [123.72266686300009, 12.876369533000059],
              [123.73129316500001, 12.883286851000037],
              [123.73267662900003, 12.889878648000092],
              [123.72217858200008, 12.89288971600007],
              [123.69629967500009, 12.891546942000048],
              [123.69011478000004, 12.888739325000074],
              [123.69483483200008, 12.88279857000009],
              [123.69752037900003, 12.874945380000042],
              [123.69800866000003, 12.864935614000046],
              [123.67725670700008, 12.884182033000059],
              [123.68653405000009, 12.905422268000052],
              [123.70329837300005, 12.92719147300005],
              [123.69825280000009, 12.930894273000092],
              [123.69092858200008, 12.927801825000074],
              [123.68067467500009, 12.926988023000092],
              [123.66846764400009, 12.92413971600007],
              [123.66342207100001, 12.917141018000052],
              [123.66138756600003, 12.908351955000057],
              [123.65699303500003, 12.90029531500005],
              [123.64966881600003, 12.890326239000046],
              [123.64893639400009, 12.886297919000071],
              [123.64600670700008, 12.885687567000048],
              [123.63249759200005, 12.886053778000075],
              [123.61573326900009, 12.889471747000073],
              [123.60515384200005, 12.89288971600007],
              [123.59839928500003, 12.896551825000074],
              [123.57113691500001, 12.92796458500004],
              [123.55909264400009, 12.937892971000053],
              [123.53972415500004, 12.948065497000073],
              [123.52930748800009, 12.951646226000037],
              [123.52100670700008, 12.95343659100007],
              [123.51303144600001, 12.956691799000055],
              [123.50310306100005, 12.96482982000009],
              [123.48804772200003, 12.985581773000092],
              [123.46810957100001, 12.99599844000005],
              [123.45020592500009, 13.02928294500009],
              [123.44125410200002, 13.036851304000038],
              [123.41879316500001, 13.039252020000049],
              [123.40202884200005, 13.04328034100007],
              [123.38502037900003, 13.044094143000052],
              [123.36215254000001, 13.036851304000038],
              [123.330414259, 13.019029039000088],
              [123.31006920700008, 13.01235586100006],
              [123.30079186300009, 13.01976146000004],
              [123.29615319100003, 13.036078192000048],
              [123.28785241000003, 13.054348049000055],
              [123.28443444100003, 13.071519273000092],
              [123.29395592500009, 13.084662177000041],
              [123.27898196700005, 13.12018463700008],
              [123.30518639400009, 13.198635158000059],
              [123.30079186300009, 13.235500393000052],
              [123.28443444100003, 13.253607489000046],
              [123.24732506600003, 13.27920156500005],
              [123.23194420700008, 13.297552802000041],
              [123.22779381600003, 13.306301174000055],
              [123.22242272200003, 13.322007554000038],
              [123.21810957100001, 13.33104075700004],
              [123.19092858200008, 13.359035549000055],
              [123.19703209700003, 13.386542059000078],
              [123.18775475400003, 13.420477606000077],
              [123.16879316500001, 13.44920482000009],
              [123.14625084700003, 13.461371161000045],
              [123.11793053500003, 13.468898830000057],
              [123.06519616000003, 13.501776434000078],
              [123.03663170700008, 13.50922272300005],
              [123.01970462300005, 13.511379299000055],
              [122.99708092500009, 13.520697333000044],
              [122.98170006600003, 13.52289459800005],
              [122.97201582100001, 13.527533270000049],
              [122.94776451900009, 13.549994208000044],
              [122.88550866000003, 13.593329169000071],
              [122.87281334700003, 13.598578192000048],
              [122.85914147200003, 13.60610586100006],
              [122.82894941500001, 13.641750393000052],
              [122.81470787900003, 13.653794664000088],
              [122.86255944100003, 13.69476959800005],
              [122.81373131600003, 13.748439846000053],
              [122.78931725400003, 13.76854075700004],
              [122.75879967500009, 13.783596096000053],
              [122.75879967500009, 13.77732982000009],
              [122.75269616000003, 13.783596096000053],
              [122.75879967500009, 13.790350653000075],
              [122.77149498800009, 13.790961005000042],
              [122.76685631600003, 13.79954661700009],
              [122.75310306100005, 13.810492255000042],
              [122.73902428500003, 13.818304755000042],
              [122.69996178500003, 13.825832424000055],
              [122.69068444100003, 13.831976630000042],
              [122.67872155000009, 13.820786851000037],
              [122.66578209700003, 13.819484768000052],
              [122.65316816500001, 13.82607656500005],
              [122.64283287900003, 13.838812567000048],
              [122.644867384, 13.843003648000092],
              [122.65170332100001, 13.848089911000045],
              [122.656586134, 13.854315497000073],
              [122.65300540500004, 13.86237213700008],
              [122.62273196700005, 13.891994533000059],
              [122.61036217500009, 13.899318752000056],
              [122.59693444100003, 13.904486395000049],
              [122.58448326900009, 13.906439520000049],
              [122.58033287900003, 13.913275458000044],
              [122.57764733200008, 13.926459052000041],
              [122.57211347700002, 13.935044664000088],
              [122.56031334700003, 13.928168036000045],
              [122.55591881600003, 13.937892971000053],
              [122.54297936300009, 13.95258209800005],
              [122.54029381600003, 13.958563544000071],
              [122.53687584700003, 13.961127020000049],
              [122.51587975400003, 13.934393622000073],
              [122.45948326900009, 13.937892971000053],
              [122.43490644600001, 13.945990302000041],
              [122.41627037900003, 13.96165599200009],
              [122.41309655000009, 13.948065497000073],
              [122.42066491000003, 13.93227773600006],
              [122.43384850400003, 13.919338283000059],
              [122.44727623800009, 13.913885809000078],
              [122.45085696700005, 13.906195380000042],
              [122.49976647200003, 13.83779531500005],
              [122.50961347700002, 13.820013739000046],
              [122.50879967500009, 13.807766018000052],
              [122.50269616000003, 13.793158270000049],
              [122.50391686300009, 13.771918036000045],
              [122.51246178500003, 13.73578522300005],
              [122.490570509, 13.740627346000053],
              [122.48552493600005, 13.721625067000048],
              [122.49138431100005, 13.677069403000075],
              [122.49756920700008, 13.652044989000046],
              [122.51295006600003, 13.630438544000071],
              [122.54997806100005, 13.59516022300005],
              [122.62175540500004, 13.55272044500009],
              [122.63599694100003, 13.53709544500009],
              [122.63233483200008, 13.520697333000044],
              [122.60954837300005, 13.53196849200009],
              [122.56714928500003, 13.563869533000059],
              [122.57292728000004, 13.548041083000044],
              [122.59888756600003, 13.508286851000037],
              [122.64283287900003, 13.457586981000077],
              [122.65430748800009, 13.44041575700004],
              [122.66325931100005, 13.420477606000077],
              [122.67269941500001, 13.379299221000053],
              [122.67701256600003, 13.341945705000057],
              [122.67701256600003, 13.300970770000049],
              [122.67888431100005, 13.289862372000073],
              [122.68295332100001, 13.28229401200008],
              [122.68767337300005, 13.27610911700009],
              [122.69068444100003, 13.269598700000074],
              [122.69255618600005, 13.24876536700009],
              [122.69223066500001, 13.236802476000037],
              [122.69068444100003, 13.228664455000057],
              [122.68523196700005, 13.22524648600006],
              [122.67579186300009, 13.22211334800005],
              [122.66716556100005, 13.218085028000075],
              [122.66325931100005, 13.211615302000041],
              [122.65316816500001, 13.200995184000078],
              [122.63013756600003, 13.188055731000077],
              [122.60482832100001, 13.177557684000078],
              [122.58814537900003, 13.174017645000049],
              [122.57097415500004, 13.18455638200004],
              [122.50505618600005, 13.239203192000048],
              [122.50757897200003, 13.259466864000046],
              [122.51807701900009, 13.294867255000042],
              [122.51929772200003, 13.310614325000074],
              [122.50114993600005, 13.368068752000056],
              [122.40259850400003, 13.496161200000074],
              [122.40023847700002, 13.502875067000048],
              [122.39844811300009, 13.515814520000049],
              [122.39519290500004, 13.52289459800005],
              [122.37598717500009, 13.540838934000078],
              [122.369476759, 13.54979075700004],
              [122.34131920700008, 13.561102606000077],
              [122.33497155000009, 13.574693101000037],
              [122.31902103000004, 13.592230536000045],
              [122.25855553500003, 13.59202708500004],
              [122.25928795700008, 13.606024481000077],
              [122.24154707100001, 13.61196523600006],
              [122.20753014400009, 13.61432526200008],
              [122.19402103000004, 13.622788804000038],
              [122.18995201900009, 13.631048895000049],
              [122.18637129000001, 13.648016669000071],
              [122.18043053500003, 13.656927802000041],
              [122.172211134, 13.666693427000041],
              [122.11841881600003, 13.752101955000057],
              [122.09310957100001, 13.780585028000075],
              [122.05990644600001, 13.804632880000042],
              [122.05372155000009, 13.78514232000009],
              [122.03891035200002, 13.789618231000077],
              [122.02198326900009, 13.803127346000053],
              [122.00879967500009, 13.81085846600007],
              [121.98943118600005, 13.810044664000088],
              [121.98585045700008, 13.812079169000071],
              [121.94988040500004, 13.844549872000073],
              [121.93702233200008, 13.85179271000004],
              [121.92481530000009, 13.85537344000005],
              [121.91358483200008, 13.857123114000046],
              [121.90300540500004, 13.860541083000044],
              [121.88233483200008, 13.87799713700008],
              [121.87086022200003, 13.88572825700004],
              [121.85962975400003, 13.891302802000041],
              [121.82715905000009, 13.899725653000075],
              [121.81299889400009, 13.914943752000056],
              [121.80176842500009, 13.933091539000088],
              [121.78630618600005, 13.94867584800005],
              [121.77800540500004, 13.949042059000078],
              [121.74024498800009, 13.96190013200004],
              [121.72486412900003, 13.969142971000053],
              [121.71843509200005, 13.95530833500004],
              [121.70101972700002, 13.94476959800005],
              [121.69752037900003, 13.931301174000055],
              [121.68995201900009, 13.925970770000049],
              [121.64226321700005, 13.913885809000078],
              [121.63689212300005, 13.90961334800005],
              [121.62175540500004, 13.893459377000056],
              [121.61312910200002, 13.893052476000037],
              [121.59595787900003, 13.897406317000048],
              [121.59107506600003, 13.89679596600007],
              [121.57789147200003, 13.888006903000075],
              [121.54932701900009, 13.878159898000092],
              [121.53052819100003, 13.864976304000038],
              [121.52328535200002, 13.861883856000077],
              [121.51587975400003, 13.86001211100006],
              [121.49903405000009, 13.859076239000046],
              [121.49439537900003, 13.858099677000041],
              [121.48462975400003, 13.85179271000004],
              [121.45460045700008, 13.819240627000056],
              [121.43344160200002, 13.796372789000088],
              [121.44076582100001, 13.726385809000078],
              [121.43628991000003, 13.700995184000078],
              [121.44581139400009, 13.700913804000038],
              [121.45232181100005, 13.69944896000004],
              [121.46412194100003, 13.69476959800005],
              [121.43433678500003, 13.663560289000088],
              [121.430023634, 13.656927802000041],
              [121.38884524800005, 13.66673411700009],
              [121.37476647200003, 13.667466539000088],
              [121.35564212300005, 13.657131252000056],
              [121.29810631600003, 13.614894924000055],
              [121.27881920700008, 13.595038153000075],
              [121.26351972700002, 13.600043036000045],
              [121.24919681100005, 13.608628648000092],
              [121.24496504000001, 13.612250067000048],
              [121.21778405000009, 13.623236395000049],
              [121.20460045700008, 13.62571849200009],
              [121.18669681100005, 13.626532294000071],
              [121.17798912900003, 13.629095770000049],
              [121.16944420700008, 13.634588934000078],
              [121.15870201900009, 13.639471747000073],
              [121.14258873800009, 13.640204169000071],
              [121.11011803500003, 13.632961330000057],
              [121.09449303500003, 13.626898505000042],
              [121.080414259, 13.619086005000042],
              [121.07048587300005, 13.62250397300005],
              [121.04753665500004, 13.62726471600007],
              [121.03891035200002, 13.632757880000042],
              [121.03394616000003, 13.641831773000092],
              [121.03736412900003, 13.64712148600006],
              [121.04322350400003, 13.65298086100006],
              [121.04639733200008, 13.663763739000046],
              [121.04883873800009, 13.688299872000073],
              [121.05274498800009, 13.705877997000073],
              [121.05347741000003, 13.72211334800005],
              [121.03980553500003, 13.758693752000056],
              [121.03589928500003, 13.762600002000056],
              [121.01628665500004, 13.77529531500005],
              [121.00375410200002, 13.780910549000055],
              [120.99097741000003, 13.783636786000045],
              [120.98096764400009, 13.780462958000044],
              [120.90308678500003, 13.692938544000071],
              [120.89503014400009, 13.687974351000037],
              [120.88746178500003, 13.693508205000057],
              [120.88233483200008, 13.705226955000057],
              [120.88070722700002, 13.716864325000074],
              [120.88502037900003, 13.72211334800005],
              [120.89323978000004, 13.72728099200009],
              [120.89820397200003, 13.738836981000077],
              [120.90186608200008, 13.750392971000053],
              [120.90577233200008, 13.755601304000038],
              [120.91871178500003, 13.757025458000044],
              [120.92603600400003, 13.761664130000042],
              [120.92896569100003, 13.77024974200009],
              [120.92904707100001, 13.783596096000053],
              [120.91260826900009, 13.800034898000092],
              [120.90919030000009, 13.804632880000042],
              [120.90870201900009, 13.816107489000046],
              [120.91391035200002, 13.83734772300005],
              [120.91537519600001, 13.84870026200008],
              [120.91488691500001, 13.864935614000046],
              [120.91236412900003, 13.881781317000048],
              [120.90626061300009, 13.89647044500009],
              [120.89503014400009, 13.906439520000049],
              [120.87671959700003, 13.912258205000057],
              [120.78687584700003, 13.923325914000088],
              [120.74594160200002, 13.933783270000049],
              [120.72364342500009, 13.934393622000073],
              [120.70484459700003, 13.927435614000046],
              [120.69743899800005, 13.913885809000078],
              [120.70093834700003, 13.896144924000055],
              [120.71436608200008, 13.876369533000059],
              [120.72291100400003, 13.855414130000042],
              [120.70337975400003, 13.851711330000057],
              [120.66228274800005, 13.85927969000005],
              [120.65259850400003, 13.845526434000078],
              [120.65626061300009, 13.827093817000048],
              [120.66488691500001, 13.80662669500009],
              [120.66968834700003, 13.786932684000078],
              [120.66342207100001, 13.77537669500009],
              [120.64966881600003, 13.78424713700008],
              [120.62810306100005, 13.81085846600007],
              [120.62012780000009, 13.846625067000048],
              [120.61841881600003, 13.93162669500009],
              [120.60132897200003, 13.969142971000053],
              [120.61687259200005, 13.97166575700004],
              [120.62891686300009, 13.981268622000073],
              [120.63477623800009, 13.991603908000059],
              [120.63168379000001, 13.996486721000053],
              [120.61988366000003, 14.00291575700004],
              [120.61744225400003, 14.01788971600007],
              [120.62183678500003, 14.076564846000053],
              [120.619476759, 14.10423411700009],
              [120.607758009, 14.12490469000005],
              [120.58033287900003, 14.133002020000049],
              [120.58033287900003, 14.140448309000078],
              [120.59571373800009, 14.147935289000088],
              [120.59742272200003, 14.156927802000041],
              [120.58887780000009, 14.166164455000057],
              [120.57349694100003, 14.17454661700009],
              [120.58301842500009, 14.17446523600006],
              [120.58961022200003, 14.17601146000004],
              [120.60132897200003, 14.181382554000038],
              [120.60132897200003, 14.18821849200009],
              [120.58725019600001, 14.20026276200008],
              [120.59595787900003, 14.217962958000044],
              [120.61247806100005, 14.23704661700009],
              [120.62126712300005, 14.253404039000088],
              [120.62745201900009, 14.269598700000074],
              [120.64332116000003, 14.277085679000038],
              [120.68336022200003, 14.28384023600006],
              [120.697601759, 14.289496161000045],
              [120.71314537900003, 14.298529364000046],
              [120.72535241000003, 14.30955638200004],
              [120.73047936300009, 14.32135651200008],
              [120.73560631600003, 14.32721588700008],
              [120.76002037900003, 14.337144273000092],
              [120.76832116000003, 14.342189846000053],
              [120.78956139400009, 14.37531159100007],
              [120.87794030000009, 14.45888906500005],
              [120.88607832100001, 14.462388414000088],
              [120.89747155000009, 14.46312083500004],
              [120.91920006600003, 14.46198151200008],
              [120.926117384, 14.464667059000078],
              [120.94336998800009, 14.483099677000041],
              [120.97038821700005, 14.501898505000042],
              [120.98031660200002, 14.515448309000078],
              [120.98438561300009, 14.534002997000073],
              [120.98015384200005, 14.557440497000073],
              [120.95883222700002, 14.59178294500009],
              [120.95020592500009, 14.612779039000088],
              [120.94312584700003, 14.653509833000044],
              [120.93653405000009, 14.66742584800005],
              [120.90691165500004, 14.706732489000046],
              [120.90235436300009, 14.718939520000049],
              [120.89429772200003, 14.725083726000037],
              [120.84717858200008, 14.743719794000071],
              [120.84392337300005, 14.74909088700008],
              [120.84343509200005, 14.755682684000078],
              [120.84058678500003, 14.761216539000088],
              [120.83008873800009, 14.763617255000042],
              [120.73161868600005, 14.76666901200008],
              [120.66968834700003, 14.777289130000042],
              [120.66382897200003, 14.778957424000055],
              [120.65577233200008, 14.78123607000009],
              [120.64210045700008, 14.78701406500005],
              [120.63209069100003, 14.795477606000077],
              [120.62810306100005, 14.80768463700008],
              [120.62891686300009, 14.84202708500004],
              [120.62720787900003, 14.858710028000075],
              [120.62126712300005, 14.872870184000078],
              [120.61988366000003, 14.84048086100006],
              [120.62126712300005, 14.831854559000078],
              [120.61833743600005, 14.828314520000049],
              [120.60759524800005, 14.81826406500005],
              [120.603851759, 14.82493724200009],
              [120.60092207100001, 14.82562897300005],
              [120.59392337300005, 14.81826406500005],
              [120.60572350400003, 14.884833075000074],
              [120.60132897200003, 14.900824286000045],
              [120.58570397200003, 14.902818101000037],
              [120.57732181100005, 14.883490302000041],
              [120.57349694100003, 14.838771877000056],
              [120.55274498800009, 14.84992096600007],
              [120.54517662900003, 14.836859442000048],
              [120.54542076900009, 14.827093817000048],
              [120.54615319100003, 14.78782786700009],
              [120.53646894600001, 14.723211981000077],
              [120.53931725400003, 14.702826239000046],
              [120.57837975400003, 14.659409898000092],
              [120.58220462300005, 14.648260809000078],
              [120.57691491000003, 14.63694896000004],
              [120.57496178500003, 14.621649481000077],
              [120.59392337300005, 14.550726630000042],
              [120.59791100400003, 14.505601304000038],
              [120.58838951900009, 14.466986395000049],
              [120.56462649800005, 14.441229559000078],
              [120.52621504000001, 14.43463776200008],
              [120.51685631600003, 14.437201239000046],
              [120.50977623800009, 14.440822658000059],
              [120.50220787900003, 14.443182684000078],
              [120.49146569100003, 14.442084052000041],
              [120.48845462300005, 14.437933661000045],
              [120.48682701900009, 14.43073151200008],
              [120.48145592500009, 14.423976955000057],
              [120.46705162900003, 14.421047268000052],
              [120.463226759, 14.424261786000045],
              [120.46045983200008, 14.43154531500005],
              [120.45590254000001, 14.438788153000075],
              [120.41016686300009, 14.452053127000056],
              [120.40211022200003, 14.455755927000041],
              [120.38200931100005, 14.480292059000078],
              [120.37680097700002, 14.508205471000053],
              [120.38160241000003, 14.568101304000038],
              [120.37794030000009, 14.602036851000037],
              [120.36736087300005, 14.620754299000055],
              [120.32642662900003, 14.64752838700008],
              [120.31519616000003, 14.641302802000041],
              [120.30494225400003, 14.640570380000042],
              [120.29688561300009, 14.64484284100007],
              [120.29224694100003, 14.65375397300005],
              [120.28541100400003, 14.65375397300005],
              [120.25318444100003, 14.698635158000059],
              [120.24236087300005, 14.729641018000052],
              [120.26091556100005, 14.743719794000071],
              [120.27263431100005, 14.74705638200004],
              [120.26514733200008, 14.754584052000041],
              [120.24390709700003, 14.76703522300005],
              [120.24732506600003, 14.77806224200009],
              [120.25538170700008, 14.787054755000042],
              [120.26465905000009, 14.79515208500004],
              [120.27173912900003, 14.803941148000092],
              [120.277679884, 14.80272044500009],
              [120.28337649800005, 14.806708075000074],
              [120.28834069100003, 14.81476471600007],
              [120.29224694100003, 14.825669664000088],
              [120.275726759, 14.82713450700004],
              [120.26775149800005, 14.82953522300005],
              [120.26433353000004, 14.835353908000059],
              [120.26335696700005, 14.846584377000056],
              [120.25977623800009, 14.851507880000042],
              [120.25261478000004, 14.85260651200008],
              [120.24073326900009, 14.852362372000073],
              [120.23031660200002, 14.859808661000045],
              [120.22022545700008, 14.87335846600007],
              [120.209320509, 14.880031643000052],
              [120.19605553500003, 14.86664459800005],
              [120.20142662900003, 14.843085028000075],
              [120.19711347700002, 14.808010158000059],
              [120.18726647200003, 14.774969794000071],
              [120.17554772200003, 14.757391669000071],
              [120.16179446700005, 14.756415106000077],
              [120.14356530000009, 14.76040273600006],
              [120.12777754000001, 14.76703522300005],
              [120.12094160200002, 14.773871161000045],
              [120.11573326900009, 14.78546784100007],
              [120.09009850400003, 14.794338283000059],
              [120.07992597700002, 14.803941148000092],
              [120.088226759, 14.807440497000073],
              [120.09343509200005, 14.811835028000075],
              [120.09693444100003, 14.817613023000092],
              [120.10043379000001, 14.825669664000088],
              [120.09595787900003, 14.823472398000092],
              [120.07992597700002, 14.81826406500005],
              [120.05665123800009, 14.893255927000041],
              [120.04981530000009, 14.931219794000071],
              [120.05681399800005, 15.022162177000041],
              [120.05298912900003, 15.062445380000042],
              [120.01807701900009, 15.20612213700008],
              [120.00831139400009, 15.21548086100006],
              [120.00245201900009, 15.219671942000048],
              [120.00196373800009, 15.229437567000048],
              [120.00489342500009, 15.24681224200009],
              [120.00513756600003, 15.26943594000005],
              [120.00123131600003, 15.277411200000074],
              [119.98064212300005, 15.307806708000044],
              [119.96387780000009, 15.341009833000044],
              [119.95337975400003, 15.356390692000048],
              [119.89698326900009, 15.410589911000045],
              [119.88819420700008, 15.429022528000075],
              [119.89087975400003, 15.437445380000042],
              [119.90544681100005, 15.446763414000088],
              [119.90870201900009, 15.452297268000052],
              [119.90821373800009, 15.461615302000041],
              [119.90699303500003, 15.46865469000005],
              [119.90186608200008, 15.482977606000077],
              [119.92066491000003, 15.471502997000073],
              [119.94092858200008, 15.475775458000044],
              [119.95728600400003, 15.491441148000092],
              [119.96387780000009, 15.514349677000041],
              [119.96208743600005, 15.521307684000078],
              [119.95728600400003, 15.528876044000071],
              [119.95167076900009, 15.53506094000005],
              [119.94654381600003, 15.537583726000037],
              [119.94410241000003, 15.542547919000071],
              [119.941742384, 15.553615627000056],
              [119.93734785200002, 15.565578518000052],
              [119.92920983200008, 15.57298411700009],
              [119.92774498800009, 15.56867096600007],
              [119.92237389400009, 15.558742580000057],
              [119.90430748800009, 15.597072658000059],
              [119.90186608200008, 15.610256252000056],
              [119.90455162900003, 15.621283270000049],
              [119.91765384200005, 15.64744700700004],
              [119.92237389400009, 15.66111888200004],
              [119.91968834700003, 15.690334377000056],
              [119.90251712300005, 15.704657294000071],
              [119.88135826900009, 15.717718817000048],
              [119.86719811300009, 15.743068752000056],
              [119.88941491000003, 15.74803294500009],
              [119.89405358200008, 15.76390208500004],
              [119.88819420700008, 15.80573151200008],
              [119.89177493600005, 15.82298411700009],
              [119.89625084700003, 15.837469794000071],
              [119.89861087300005, 15.853176174000055],
              [119.89503014400009, 15.87400950700004],
              [119.87891686300009, 15.914740302000041],
              [119.86719811300009, 15.93500397300005],
              [119.85401451900009, 15.949164130000042],
              [119.82829837300005, 15.95571523600006],
              [119.81251061300009, 15.941880601000037],
              [119.80014082100001, 15.926662502000056],
              [119.78516686300009, 15.928656317000048],
              [119.78207441500001, 15.92479075700004],
              [119.77084394600001, 15.914984442000048],
              [119.75586998800009, 15.944566148000092],
              [119.75782311300009, 16.058986721000053],
              [119.76026451900009, 16.07558828300006],
              [119.77491295700008, 16.117987372000073],
              [119.77833092500009, 16.137844143000052],
              [119.77515709700003, 16.146877346000053],
              [119.76099694100003, 16.16201406500005],
              [119.75782311300009, 16.172267971000053],
              [119.75570722700002, 16.20343659100007],
              [119.75782311300009, 16.21670156500005],
              [119.77605228000004, 16.28074778900009],
              [119.78191165500004, 16.32225169500009],
              [119.79078209700003, 16.341864325000074],
              [119.80193118600005, 16.357855536000045],
              [119.81251061300009, 16.36749909100007],
              [119.81706790500004, 16.368312893000052],
              [119.82837975400003, 16.36660390800006],
              [119.83285566500001, 16.36749909100007],
              [119.84961998800009, 16.37889232000009],
              [119.85401451900009, 16.38117096600007],
              [119.87029056100005, 16.38540273600006],
              [119.89161217500009, 16.38735586100006],
              [119.916351759, 16.38084544500009],
              [119.92579186300009, 16.364976304000038],
              [119.92579186300009, 16.34511953300006],
              [119.90186608200008, 16.250799872000073],
              [119.91480553500003, 16.24249909100007],
              [119.96021569100003, 16.23143138200004],
              [119.97022545700008, 16.22654857000009],
              [119.97624759200005, 16.21824778900009],
              [120.00513756600003, 16.188421942000048],
              [120.01514733200008, 16.18187083500004],
              [120.03736412900003, 16.18235911700009],
              [120.05005944100003, 16.180853583000044],
              [120.06153405000009, 16.173000393000052],
              [120.07992597700002, 16.15452708500004],
              [120.08773847700002, 16.15721263200004],
              [120.09115644600001, 16.153469143000052],
              [120.10043379000001, 16.08974844000005],
              [120.10564212300005, 16.069647528000075],
              [120.11915123800009, 16.05573151200008],
              [120.13884524800005, 16.046128648000092],
              [120.18531334700003, 16.03339264500005],
              [120.20850670700008, 16.03266022300005],
              [120.22982832100001, 16.03729889500005],
              [120.24781334700003, 16.048488674000055],
              [120.25766035200002, 16.05219147300005],
              [120.29224694100003, 16.055609442000048],
              [120.30665123800009, 16.044663804000038],
              [120.29908287900003, 16.017401434000078],
              [120.31137129000001, 16.027085679000038],
              [120.32276451900009, 16.048570054000038],
              [120.33383222700002, 16.058986721000053],
              [120.34083092500009, 16.05487702000005],
              [120.35254967500009, 16.05272044500009],
              [120.36329186300009, 16.055487372000073],
              [120.36736087300005, 16.06582265800006],
              [120.36101321700005, 16.073187567000048],
              [120.34815514400009, 16.07029857000009],
              [120.33464603000004, 16.065252997000073],
              [120.32642662900003, 16.06582265800006],
              [120.32935631600003, 16.07949453300006],
              [120.36524498800009, 16.108710028000075],
              [120.37419681100005, 16.123846747000073],
              [120.37859134200005, 16.134100653000075],
              [120.39771569100003, 16.154038804000038],
              [120.40211022200003, 16.16547272300005],
              [120.40211022200003, 16.20575592700004],
              [120.39747155000009, 16.228989976000037],
              [120.38550866000003, 16.25193919500009],
              [120.35377037900003, 16.29169342700004],
              [120.35377037900003, 16.271307684000078],
              [120.34864342500009, 16.27952708500004],
              [120.34205162900003, 16.285589911000045],
              [120.336273634, 16.292181708000044],
              [120.31218509200005, 16.456203518000052],
              [120.29908287900003, 16.493801174000055],
              [120.30665123800009, 16.544989325000074],
              [120.29786217500009, 16.568915106000077],
              [120.28419030000009, 16.592962958000044],
              [120.27613366000003, 16.611883856000077],
              [120.28541100400003, 16.62067291900007],
              [120.28541100400003, 16.616848049000055],
              [120.28842207100001, 16.614569403000075],
              [120.295258009, 16.613714911000045],
              [120.30665123800009, 16.61391836100006],
              [120.30665123800009, 16.62067291900007],
              [120.30144290500004, 16.633205471000053],
              [120.30250084700003, 16.65497467700004],
              [120.30787194100003, 16.677679755000042],
              [120.32593834700003, 16.712591864000046],
              [120.32341556100005, 16.73383209800005],
              [120.31617272200003, 16.755804755000042],
              [120.31218509200005, 16.777777411000045],
              [120.31364993600005, 16.799627997000073],
              [120.31576582100001, 16.80927155200004],
              [120.31959069100003, 16.81932200700004],
              [120.32642662900003, 16.830959377000056],
              [120.33350670700008, 16.83698151200008],
              [120.34156334700003, 16.841945705000057],
              [120.35059655000009, 16.85032786700009],
              [120.42725670700008, 16.96190013200004],
              [120.43409264400009, 16.982123114000046],
              [120.43628991000003, 17.00800202000005],
              [120.416351759, 17.179348049000055],
              [120.41423587300005, 17.18431224200009],
              [120.40430748800009, 17.19830963700008],
              [120.40211022200003, 17.206691799000055],
              [120.40308678500003, 17.221625067000048],
              [120.41236412900003, 17.264593817000048],
              [120.40821373800009, 17.322699286000045],
              [120.41138756600003, 17.32831452000005],
              [120.42945397200003, 17.34756094000005],
              [120.43751061300009, 17.35883209800005],
              [120.441742384, 17.367987372000073],
              [120.44336998800009, 17.377101955000057],
              [120.443695509, 17.388495184000078],
              [120.43523196700005, 17.422796942000048],
              [120.40170332100001, 17.497015692000048],
              [120.40211022200003, 17.518866278000075],
              [120.35792076900009, 17.53025950700004],
              [120.34083092500009, 17.538763739000046],
              [120.33383222700002, 17.556382554000038],
              [120.35320071700005, 17.678127346000053],
              [120.36353600400003, 17.687160549000055],
              [120.38477623800009, 17.69013092700004],
              [120.40235436300009, 17.696966864000046],
              [120.412445509, 17.712836005000042],
              [120.41667728000004, 17.731024481000077],
              [120.416351759, 17.74477773600006],
              [120.40821373800009, 17.75999583500004],
              [120.39714603000004, 17.770738023000092],
              [120.39128665500004, 17.78143952000005],
              [120.39869225400003, 17.79633209800005],
              [120.42261803500003, 17.823553778000075],
              [120.42790774800005, 17.83812083500004],
              [120.42945397200003, 17.86082591400009],
              [120.42530358200008, 17.902411200000074],
              [120.42790774800005, 17.91665273600006],
              [120.45167076900009, 17.948879299000055],
              [120.47266686300009, 17.99160390800006],
              [120.47722415500004, 18.004828192000048],
              [120.47828209700003, 18.02179596600007],
              [120.47681725400003, 18.04364655200004],
              [120.472992384, 18.064276434000078],
              [120.46705162900003, 18.07713450700004],
              [120.47006269600001, 18.091009833000044],
              [120.52621504000001, 18.20408763200004],
              [120.52344811300009, 18.20254140800006],
              [120.52027428500003, 18.20604075700004],
              [120.517914259, 18.212103583000044],
              [120.51807701900009, 18.217718817000048],
              [120.52084394600001, 18.219631252000056],
              [120.52556399800005, 18.221258856000077],
              [120.52995853000004, 18.223537502000056],
              [120.53191165500004, 18.227362372000073],
              [120.53614342500009, 18.23981354400007],
              [120.56609134200005, 18.292222398000092],
              [120.57911217500009, 18.325140692000048],
              [120.58619225400003, 18.364488023000092],
              [120.58497155000009, 18.405462958000044],
              [120.57349694100003, 18.443060614000046],
              [120.56177819100003, 18.469671942000048],
              [120.56080162900003, 18.486761786000045],
              [120.57016035200002, 18.501776434000078],
              [120.59050540500004, 18.52216217700004],
              [120.61109459700003, 18.53856028900009],
              [120.62712649800005, 18.541489976000037],
              [120.66968834700003, 18.532416083000044],
              [120.69068444100003, 18.534409898000092],
              [120.73536217500009, 18.549302476000037],
              [120.754242384, 18.55292389500005],
              [120.77084394600001, 18.561468817000048],
              [120.77564537900003, 18.581366278000075],
              [120.77588951900009, 18.604315497000073],
              [120.77898196700005, 18.62181224200009],
              [120.79273522200003, 18.63613515800006],
              [120.81299889400009, 18.64451732000009],
              [120.83423912900003, 18.64594147300005],
              [120.85084069100003, 18.63886139500005],
              [120.86589603000004, 18.620306708000044],
              [120.89185631600003, 18.579901434000078],
              [120.90919030000009, 18.567206122000073],
              [120.92693118600005, 18.566229559000078],
              [120.94703209700003, 18.572007554000038],
              [120.96387780000009, 18.581366278000075],
              [120.97055097700002, 18.590765692000048],
              [120.97877037900003, 18.59829336100006],
              [121.01832116000003, 18.61709219000005],
              [121.03272545700008, 18.62181224200009],
              [121.04249108200008, 18.622300523000092],
              [121.06332441500001, 18.62067291900007],
              [121.07300866000003, 18.62181224200009],
              [121.08334394600001, 18.62799713700008],
              [121.09498131600003, 18.63703034100007],
              [121.10678144600001, 18.642726955000057],
              [121.11817467500009, 18.63886139500005],
              [121.12614993600005, 18.634100653000075],
              [121.137054884, 18.630926825000074],
              [121.15935306100005, 18.628648179000038],
              [121.17066491000003, 18.625474351000037],
              [121.17741946700005, 18.61782461100006],
              [121.18262780000009, 18.60883209800005],
              [121.19027754000001, 18.601304429000038],
              [121.23991946700005, 18.57770416900007],
              [121.26628665500004, 18.55487702000005],
              [121.36402428500003, 18.506415106000077],
              [121.37818444100003, 18.49485911700009],
              [121.39185631600003, 18.48631419500009],
              [121.42408287900003, 18.47724030200004],
              [121.49830162900003, 18.429388739000046],
              [121.50611412900003, 18.426662502000056],
              [121.51978600400003, 18.425116278000075],
              [121.52613366000003, 18.42255280200004],
              [121.53256269600001, 18.415961005000042],
              [121.53882897200003, 18.407049872000073],
              [121.54656009200005, 18.399237372000073],
              [121.59205162900003, 18.384711005000042],
              [121.61329186300009, 18.359320380000042],
              [121.62964928500003, 18.331691799000055],
              [121.64966881600003, 18.31395091400009],
              [121.64966881600003, 18.32021719000005],
              [121.63461347700002, 18.334540106000077],
              [121.63493899800005, 18.355129299000055],
              [121.64503014400009, 18.36945221600007],
              [121.65967858200008, 18.36481354400007],
              [121.67286217500009, 18.35496653900009],
              [121.85279381600003, 18.287990627000056],
              [121.89551842500009, 18.27920156500005],
              [121.91732832100001, 18.278631903000075],
              [121.97461998800009, 18.286037502000056],
              [121.98682701900009, 18.29043203300006],
              [122.03956139400009, 18.32021719000005],
              [122.07862389400009, 18.379461981000077],
              [122.09131920700008, 18.389064846000053],
              [122.11158287900003, 18.39276764500005],
              [122.11931399800005, 18.40302155200004],
              [122.12208092500009, 18.436835028000075],
              [122.14576256600003, 18.50739166900007],
              [122.15284264400009, 18.518784898000092],
              [122.19939212300005, 18.52285390800006],
              [122.22022545700008, 18.522406317000048],
              [122.23536217500009, 18.515366929000038],
              [122.24317467500009, 18.499823309000078],
              [122.24708092500009, 18.459784247000073],
              [122.25171959700003, 18.443060614000046],
              [122.26050866000003, 18.43227773600006],
              [122.28809655000009, 18.40924713700008],
              [122.297211134, 18.40387604400007],
            ],
          ],
          [
            [
              [120.25196373800009, 5.266506252000056],
              [120.25294030000009, 5.251532294000071],
              [120.23764082100001, 5.190130927000041],
              [120.23243248800009, 5.150458075000074],
              [120.22681725400003, 5.129380601000094],
              [120.21656334700003, 5.114976304000038],
              [120.20199629000001, 5.119940497000073],
              [120.19117272200003, 5.126369533000059],
              [120.18458092500009, 5.136460679000038],
              [120.18238366000003, 5.152818101000094],
              [120.18873131600003, 5.18235911700009],
              [120.18962649800005, 5.196519273000092],
              [120.18238366000003, 5.204413153000075],
              [120.17595462300005, 5.202622789000088],
              [120.17310631600003, 5.19562409100007],
              [120.17156009200005, 5.187648830000057],
              [120.16871178500003, 5.183294989000046],
              [120.16358483200008, 5.182318427000041],
              [120.14551842500009, 5.183294989000046],
              [120.13795006600003, 5.187201239000046],
              [120.13054446700005, 5.196600653000075],
              [120.12452233200008, 5.208075262000079],
              [120.12094160200002, 5.218003648000092],
              [120.11052493600005, 5.20343659100007],
              [120.10816491000003, 5.170843817000048],
              [120.10043379000001, 5.156642971000053],
              [120.08594811300009, 5.15070221600007],
              [120.07097415500004, 5.153876044000071],
              [120.056976759, 5.159898179000038],
              [120.04574629000001, 5.163478908000059],
              [120.02540123800009, 5.160549221000053],
              [120.01742597700002, 5.152492580000057],
              [120.01351972700002, 5.14126211100006],
              [120.00489342500009, 5.128648179000038],
              [119.99773196700005, 5.126898505000042],
              [119.98829186300009, 5.12767161700009],
              [119.98047936300009, 5.126450914000088],
              [119.97706139400009, 5.118719794000071],
              [119.97022545700008, 5.087713934000078],
              [119.95411217500009, 5.075506903000075],
              [119.94336998800009, 5.078070380000042],
              [119.93425540500004, 5.085516669000071],
              [119.92237389400009, 5.087713934000078],
              [119.91431725400003, 5.082017320000091],
              [119.90015709700003, 5.063706773000092],
              [119.89161217500009, 5.059800523000092],
              [119.86036217500009, 5.059800523000092],
              [119.84717858200008, 5.054510809000078],
              [119.83814537900003, 5.048976955000057],
              [119.82984459700003, 5.048814195000091],
              [119.81934655000009, 5.059800523000092],
              [119.81690514400009, 5.072211005000042],
              [119.81910241000003, 5.106634833000044],
              [119.81251061300009, 5.12250397300005],
              [119.82178795700008, 5.130560614000046],
              [119.82943769600001, 5.134955145000049],
              [119.86475670700008, 5.146470445000091],
              [119.89551842500009, 5.161200262000079],
              [119.90186608200008, 5.166896877000056],
              [119.90796959700003, 5.16937897300005],
              [119.94271894600001, 5.190130927000041],
              [119.95671634200005, 5.214829820000091],
              [119.96485436300009, 5.222601630000042],
              [119.99626712300005, 5.227525132000039],
              [120.019867384, 5.236517645000049],
              [120.02849368600005, 5.238511460000041],
              [120.03614342500009, 5.241603908000059],
              [120.05258222700002, 5.258978583000044],
              [120.06299889400009, 5.259751695000091],
              [120.07007897200003, 5.256659247000073],
              [120.07683353000004, 5.254828192000048],
              [120.08692467500009, 5.258978583000044],
              [120.08871504000001, 5.263739325000074],
              [120.09327233200008, 5.282700914000088],
              [120.09742272200003, 5.290025132000039],
              [120.12419681100005, 5.305650132000039],
              [120.13379967500009, 5.317572333000044],
              [120.14625084700003, 5.323879299000055],
              [120.16879316500001, 5.332261460000041],
              [120.187836134, 5.345119533000059],
              [120.19857832100001, 5.349595445000091],
              [120.20875084700003, 5.34796784100007],
              [120.21436608200008, 5.340236721000053],
              [120.21631920700008, 5.329046942000048],
              [120.21631920700008, 5.276841539000088],
              [120.22022545700008, 5.269598700000074],
              [120.22754967500009, 5.268459377000056],
              [120.23568769600001, 5.271958726000094],
              [120.24390709700003, 5.273504950000074],
              [120.25196373800009, 5.266506252000056],
            ],
          ],
          [
            [
              [120.58814537900003, 6.380764065000051],
              [120.59538821700005, 6.376044012000079],
              [120.60035241000003, 6.367580471000053],
              [120.60352623800009, 6.357814846000053],
              [120.60499108200008, 6.349351304000038],
              [120.60434004000001, 6.329657294000071],
              [120.58285566500001, 6.261460679000038],
              [120.57732181100005, 6.251532294000071],
              [120.56983483200008, 6.243638414000088],
              [120.55982506600003, 6.239081122000073],
              [120.54558353000004, 6.238470770000049],
              [120.50611412900003, 6.244086005000042],
              [120.49463951900009, 6.249335028000075],
              [120.488617384, 6.260158596000053],
              [120.49203535200002, 6.267401434000078],
              [120.50196373800009, 6.271389065000051],
              [120.51498457100001, 6.272609768000052],
              [120.52214603000004, 6.277248440000051],
              [120.53003991000003, 6.288072007000039],
              [120.53646894600001, 6.300685940000051],
              [120.53931725400003, 6.310492255000042],
              [120.54249108200008, 6.318019924000055],
              [120.55665123800009, 6.340521552000041],
              [120.56267337300005, 6.362005927000041],
              [120.56959069100003, 6.371893622000073],
              [120.57862389400009, 6.379095770000049],
              [120.58814537900003, 6.380764065000051],
            ],
          ],
          [
            [
              [122.29672285200002, 6.633246161000045],
              [122.32927493600005, 6.613836981000077],
              [122.33521569100003, 6.603338934000078],
              [122.32129967500009, 6.588568427000041],
              [122.30062910200002, 6.58234284100007],
              [122.25416100400003, 6.581284898000092],
              [122.23536217500009, 6.571193752000056],
              [122.22486412900003, 6.558254299000055],
              [122.21566816500001, 6.544012762000079],
              [122.20866946700005, 6.52875397300005],
              [122.20386803500003, 6.512844143000052],
              [122.19825280000009, 6.467596747000073],
              [122.18864993600005, 6.451076565000051],
              [122.166351759, 6.444525458000044],
              [122.14380944100003, 6.442938544000071],
              [122.12175540500004, 6.438544012000079],
              [122.05762780000009, 6.413885809000078],
              [122.03874759200005, 6.410223700000074],
              [121.99488366000003, 6.410345770000049],
              [121.96225019600001, 6.404852606000077],
              [121.95753014400009, 6.407294012000079],
              [121.95639082100001, 6.428127346000053],
              [121.95411217500009, 6.436916408000059],
              [121.95004316500001, 6.444525458000044],
              [121.88005618600005, 6.503241278000075],
              [121.87956790500004, 6.556138414000088],
              [121.87501061300009, 6.57485586100006],
              [121.85564212300005, 6.583400783000059],
              [121.83318118600005, 6.585150458000044],
              [121.81446373800009, 6.592922268000052],
              [121.80681399800005, 6.619289455000057],
              [121.81080162900003, 6.64516836100006],
              [121.82203209700003, 6.660956122000073],
              [121.83920332100001, 6.668931382000039],
              [121.94019616000003, 6.677313544000071],
              [121.94825280000009, 6.680568752000056],
              [121.95834394600001, 6.695054429000038],
              [121.99789472700002, 6.712062893000052],
              [122.01295006600003, 6.72992584800005],
              [122.02312259200005, 6.73663971600007],
              [122.04021243600005, 6.739325262000079],
              [122.06666100400003, 6.740708726000094],
              [122.07520592500009, 6.739813544000071],
              [122.08423912900003, 6.735663153000075],
              [122.09815514400009, 6.721584377000056],
              [122.10596764400009, 6.71556224200009],
              [122.11646569100003, 6.711086330000057],
              [122.14128665500004, 6.70538971600007],
              [122.15284264400009, 6.704575914000088],
              [122.15626061300009, 6.700344143000052],
              [122.16114342500009, 6.690904039000088],
              [122.16871178500003, 6.681586005000042],
              [122.18043053500003, 6.677313544000071],
              [122.22510826900009, 6.671087958000044],
              [122.23536217500009, 6.666205145000049],
              [122.24154707100001, 6.660386460000041],
              [122.24634850400003, 6.654689846000053],
              [122.25171959700003, 6.649969794000071],
              [122.26254316500001, 6.645453192000048],
              [122.28809655000009, 6.637884833000044],
              [122.29672285200002, 6.633246161000045],
            ],
          ],
          [
            [
              [118.53760826900009, 7.006293036000045],
              [118.52051842500009, 7.013373114000046],
              [118.52027428500003, 7.003159898000092],
              [118.53077233200008, 6.978949286000045],
              [118.51872806100005, 6.970933335000041],
              [118.50310306100005, 6.97142161700009],
              [118.47673587300005, 6.978949286000045],
              [118.44516035200002, 6.982326565000051],
              [118.43555748800009, 6.989243882000039],
              [118.42839603000004, 7.006293036000045],
              [118.42725670700008, 7.01821523600006],
              [118.43140709700003, 7.027085679000038],
              [118.44109134200005, 7.034328518000052],
              [118.45630944100003, 7.041001695000091],
              [118.47478274800005, 7.037014065000051],
              [118.48698978000004, 7.03978099200009],
              [118.49732506600003, 7.044663804000038],
              [118.51026451900009, 7.04718659100007],
              [118.52458743600005, 7.043646552000041],
              [118.53248131600003, 7.035101630000042],
              [118.54444420700008, 7.013088283000059],
              [118.53760826900009, 7.006293036000045],
            ],
          ],
          [
            [
              [117.08497155000009, 8.057847398000092],
              [117.08090254000001, 8.038275458000044],
              [117.08025149800005, 8.029486395000049],
              [117.08204186300009, 8.02415599200009],
              [117.09156334700003, 8.011542059000078],
              [117.08692467500009, 8.00421784100007],
              [117.07715905000009, 7.999172268000052],
              [117.07154381600003, 7.993150132000039],
              [117.07276451900009, 7.977525132000039],
              [117.08326256600003, 7.941473700000074],
              [117.08578535200002, 7.921128648000092],
              [117.08472741000003, 7.915920315000051],
              [117.07943769600001, 7.907171942000048],
              [117.07837975400003, 7.90375397300005],
              [117.07764733200008, 7.884466864000046],
              [117.07837975400003, 7.883286851000037],
              [117.08497155000009, 7.876288153000075],
              [117.08676191500001, 7.872137762000079],
              [117.08204186300009, 7.870266018000052],
              [117.08008873800009, 7.868719794000071],
              [117.07300866000003, 7.861517645000049],
              [117.07154381600003, 7.859361070000091],
              [117.06714928500003, 7.848700262000079],
              [117.05567467500009, 7.835638739000046],
              [117.04029381600003, 7.82493724200009],
              [117.02369225400003, 7.821844794000071],
              [117.03419030000009, 7.804632880000042],
              [117.02621504000001, 7.798407294000071],
              [117.00993899800005, 7.800279039000088],
              [116.99586022200003, 7.807562567000048],
              [117.00163821700005, 7.82367584800005],
              [116.99634850400003, 7.839260158000059],
              [116.97592207100001, 7.870266018000052],
              [116.95582116000003, 7.921087958000044],
              [116.95492597700002, 7.926011460000041],
              [116.96168053500003, 8.061997789000088],
              [116.97266686300009, 8.054836330000057],
              [116.974945509, 8.044745184000078],
              [116.97592207100001, 8.034572658000059],
              [116.98218834700003, 8.027289130000042],
              [116.99675540500004, 8.02732982000009],
              [117.00196373800009, 8.039943752000056],
              [117.00513756600003, 8.054836330000057],
              [117.01319420700008, 8.061997789000088],
              [117.05844160200002, 8.069810289000088],
              [117.07585696700005, 8.069566148000092],
              [117.08497155000009, 8.057847398000092],
            ],
          ],
          [
            [
              [117.03052819100003, 8.06826406500005],
              [117.02051842500009, 8.077866929000038],
              [117.01539147200003, 8.08812083500004],
              [117.00904381600003, 8.097154039000088],
              [116.99586022200003, 8.103013414000088],
              [117.02711022200003, 8.128729559000078],
              [117.04542076900009, 8.13580963700008],
              [117.05787194100003, 8.123480536000045],
              [117.06836998800009, 8.09275950700004],
              [117.06812584700003, 8.08624909100007],
              [117.05941816500001, 8.081244208000044],
              [117.04965254000001, 8.079820054000038],
              [117.03980553500003, 8.07721588700008],
              [117.03052819100003, 8.06826406500005],
            ],
          ],
          [
            [
              [117.16773522200003, 8.178127346000053],
              [117.18970787900003, 8.17674388200004],
              [117.20484459700003, 8.166815497000073],
              [117.20573978000004, 8.155503648000092],
              [117.18482506600003, 8.150132554000038],
              [117.16179446700005, 8.156724351000037],
              [117.15235436300009, 8.170070705000057],
              [117.15479576900009, 8.18040599200009],
              [117.16773522200003, 8.178127346000053],
            ],
          ],
          [
            [
              [117.32545006600003, 8.322739976000037],
              [117.35531660200002, 8.30272044500009],
              [117.35531660200002, 8.274644273000092],
              [117.34888756600003, 8.244696356000077],
              [117.35954837300005, 8.21906159100007],
              [117.35132897200003, 8.207220770000049],
              [117.34253991000003, 8.197211005000042],
              [117.33187910200002, 8.193182684000078],
              [117.31861412900003, 8.19920482000009],
              [117.28972415500004, 8.18431224200009],
              [117.27881920700008, 8.207098700000074],
              [117.27564537900003, 8.242987372000073],
              [117.27003014400009, 8.267523505000042],
              [117.27654056100005, 8.281398830000057],
              [117.279633009, 8.311102606000077],
              [117.28443444100003, 8.322739976000037],
              [117.29281660200002, 8.317857164000088],
              [117.30152428500003, 8.318019924000055],
              [117.31006920700008, 8.322007554000038],
              [117.31861412900003, 8.328924872000073],
              [117.31812584700003, 8.32453034100007],
              [117.31959069100003, 8.323553778000075],
              [117.32227623800009, 8.323635158000059],
              [117.32545006600003, 8.322739976000037],
            ],
          ],
          [
            [
              [117.24284915500004, 8.315252997000073],
              [117.25342858200008, 8.321966864000046],
              [117.26075280000009, 8.321112372000073],
              [117.26449629000001, 8.313788153000075],
              [117.26392662900003, 8.30101146000004],
              [117.24333743600005, 8.282904364000046],
              [117.21461022200003, 8.265122789000088],
              [117.19011478000004, 8.26203034100007],
              [117.18140709700003, 8.287990627000056],
              [117.18946373800009, 8.29954661700009],
              [117.24284915500004, 8.34320709800005],
              [117.24089603000004, 8.330511786000045],
              [117.23959394600001, 8.32721588700008],
              [117.23601321700005, 8.322739976000037],
              [117.24284915500004, 8.315252997000073],
            ],
          ],
          [
            [
              [124.78419030000009, 9.199774481000077],
              [124.79346764400009, 9.192694403000075],
              [124.80323326900009, 9.17609284100007],
              [124.80836022200003, 9.156805731000077],
              [124.80095462300005, 9.128729559000078],
              [124.80258222700002, 9.112494208000044],
              [124.80128014400009, 9.096258856000077],
              [124.78785241000003, 9.08307526200008],
              [124.77947024800005, 9.079494533000059],
              [124.77019290500004, 9.077378648000092],
              [124.76295006600003, 9.079006252000056],
              [124.75709069100003, 9.092718817000048],
              [124.75001061300009, 9.094305731000077],
              [124.74089603000004, 9.09446849200009],
              [124.73267662900003, 9.096136786000045],
              [124.67212975400003, 9.125392971000053],
              [124.64673912900003, 9.148871161000045],
              [124.63648522200003, 9.18235911700009],
              [124.64673912900003, 9.218898830000057],
              [124.67310631600003, 9.242377020000049],
              [124.70850670700008, 9.250189520000049],
              [124.74634850400003, 9.239488023000092],
              [124.76303144600001, 9.214422919000071],
              [124.77247155000009, 9.204046942000048],
              [124.78419030000009, 9.199774481000077],
            ],
          ],
          [
            [
              [123.69800866000003, 9.16502513200004],
              [123.70248457100001, 9.164536851000037],
              [123.71452884200005, 9.157416083000044],
              [123.72242272200003, 9.149115302000041],
              [123.71534264400009, 9.14516836100006],
              [123.70329837300005, 9.12836334800005],
              [123.69800866000003, 9.12400950700004],
              [123.68970787900003, 9.122544664000088],
              [123.66041100400003, 9.12400950700004],
              [123.65300540500004, 9.12295156500005],
              [123.64763431100005, 9.119696356000077],
              [123.64454186300009, 9.11432526200008],
              [123.64332116000003, 9.106919664000088],
              [123.63998457100001, 9.098578192000048],
              [123.63233483200008, 9.098334052000041],
              [123.61548912900003, 9.103583075000074],
              [123.59636478000004, 9.103989976000037],
              [123.578461134, 9.107001044000071],
              [123.56120853000004, 9.11424388200004],
              [123.47950280000009, 9.171820380000042],
              [123.47120201900009, 9.18545156500005],
              [123.47461998800009, 9.197088934000078],
              [123.50001061300009, 9.220282294000071],
              [123.51758873800009, 9.209865627000056],
              [123.54086347700002, 9.213446356000077],
              [123.56495201900009, 9.226141669000071],
              [123.59473717500009, 9.251288153000075],
              [123.60254967500009, 9.255438544000071],
              [123.60743248800009, 9.262152411000045],
              [123.60922285200002, 9.278265692000048],
              [123.61443118600005, 9.289252020000049],
              [123.62696373800009, 9.29393138200004],
              [123.64210045700008, 9.293646552000041],
              [123.65544681100005, 9.289129950000074],
              [123.66480553500003, 9.275458075000074],
              [123.67920983200008, 9.245306708000044],
              [123.68751061300009, 9.239488023000092],
              [123.70386803500003, 9.233303127000056],
              [123.70053144600001, 9.219631252000056],
              [123.68995201900009, 9.205959377000056],
              [123.68376712300005, 9.199693101000037],
              [123.68344160200002, 9.188299872000073],
              [123.68653405000009, 9.180609442000048],
              [123.69800866000003, 9.16502513200004],
            ],
          ],
          [
            [
              [126.16586347700002, 9.82916901200008],
              [126.17408287900003, 9.817206122000073],
              [126.18018639400009, 9.80149974200009],
              [126.17823326900009, 9.78782786700009],
              [126.15544681100005, 9.77920156500005],
              [126.13884524800005, 9.76561107000009],
              [126.13038170700008, 9.760891018000052],
              [126.12012780000009, 9.758937893000052],
              [126.09327233200008, 9.760891018000052],
              [126.05445397200003, 9.775091864000046],
              [126.04167728000004, 9.775132554000038],
              [126.04859459700003, 9.75462474200009],
              [126.03394616000003, 9.76634349200009],
              [126.01921634200005, 9.781683661000045],
              [125.99390709700003, 9.816107489000046],
              [125.99341881600003, 9.82029857000009],
              [125.99537194100003, 9.824652411000045],
              [125.99659264400009, 9.829779364000046],
              [125.99390709700003, 9.836615302000041],
              [125.98796634200005, 9.839992580000057],
              [125.98031660200002, 9.839789130000042],
              [125.97266686300009, 9.841498114000046],
              [125.96599368600005, 9.85024648600006],
              [125.97982832100001, 9.849188544000071],
              [125.99293053500003, 9.85024648600006],
              [126.00473066500001, 9.854885158000059],
              [126.01441491000003, 9.864488023000092],
              [126.00326582100001, 9.869289455000057],
              [125.98910566500001, 9.877142645000049],
              [125.97982832100001, 9.888006903000075],
              [125.98340905000009, 9.90180084800005],
              [126.04468834700003, 9.998724677000041],
              [126.04859459700003, 10.007961330000057],
              [126.04851321700005, 10.01748281500005],
              [126.04566491000003, 10.026190497000073],
              [126.045258009, 10.03514232000009],
              [126.05225670700008, 10.045477606000077],
              [126.07146243600005, 10.059068101000037],
              [126.08073978000004, 10.05565013200004],
              [126.12671959700003, 9.95604075700004],
              [126.13795006600003, 9.901922919000071],
              [126.13786868600005, 9.891180731000077],
              [126.133148634, 9.880682684000078],
              [126.11784915500004, 9.866888739000046],
              [126.11060631600003, 9.857082424000055],
              [126.12989342500009, 9.85455963700008],
              [126.14283287900003, 9.850043036000045],
              [126.15349368600005, 9.841986395000049],
              [126.16586347700002, 9.82916901200008],
            ],
          ],
          [
            [
              [124.56527754000001, 9.870754299000055],
              [124.54981530000009, 9.86155833500004],
              [124.57016035200002, 9.840521552000041],
              [124.62403405000009, 9.80182526200008],
              [124.59896894600001, 9.749701239000046],
              [124.59620201900009, 9.73729075700004],
              [124.58521569100003, 9.732082424000055],
              [124.56055748800009, 9.732611395000049],
              [124.53484134200005, 9.736273505000042],
              [124.52035566500001, 9.740383205000057],
              [124.51685631600003, 9.74876536700009],
              [124.51742597700002, 9.759100653000075],
              [124.51441491000003, 9.76703522300005],
              [124.49984785200002, 9.76829661700009],
              [124.49293053500003, 9.76276276200008],
              [124.46241295700008, 9.73078034100007],
              [124.45281009200005, 9.725775458000044],
              [124.44027754000001, 9.721584377000056],
              [124.42945397200003, 9.715033270000049],
              [124.42481530000009, 9.702826239000046],
              [124.424164259, 9.689601955000057],
              [124.42204837300005, 9.67869700700004],
              [124.41749108200008, 9.668890692000048],
              [124.410492384, 9.65843333500004],
              [124.38184655000009, 9.63670482000009],
              [124.33871504000001, 9.61859772300005],
              [124.29420006600003, 9.606756903000075],
              [124.26042728000004, 9.60382721600007],
              [124.22144616000003, 9.60578034100007],
              [124.06519616000003, 9.595404364000046],
              [123.93751061300009, 9.61749909100007],
              [123.89234459700003, 9.632147528000075],
              [123.87175540500004, 9.645005601000037],
              [123.86304772200003, 9.661851304000038],
              [123.86670983200008, 9.683539130000042],
              [123.87273196700005, 9.703802802000041],
              [123.87387129000001, 9.721136786000045],
              [123.86304772200003, 9.734198309000078],
              [123.84489993600005, 9.737250067000048],
              [123.82447350400003, 9.736151434000078],
              [123.80787194100003, 9.739976304000038],
              [123.80103600400003, 9.757757880000042],
              [123.80323326900009, 9.781195380000042],
              [123.80909264400009, 9.802679755000042],
              [123.82837975400003, 9.84284088700008],
              [123.84131920700008, 9.857367255000042],
              [123.87582441500001, 9.88694896000004],
              [123.88298587300005, 9.90180084800005],
              [123.88607832100001, 9.914862372000073],
              [123.89340254000001, 9.916937567000048],
              [123.90723717500009, 9.911688544000071],
              [123.91667728000004, 9.91510651200008],
              [123.92212975400003, 9.923000393000052],
              [123.92603600400003, 9.932074286000045],
              [123.93140709700003, 9.939032294000071],
              [123.96387780000009, 9.950751044000071],
              [124.00977623800009, 9.961615302000041],
              [124.05079186300009, 9.979315497000073],
              [124.06853274800005, 10.011664130000042],
              [124.06999759200005, 10.03221263200004],
              [124.07520592500009, 10.048325914000088],
              [124.08659915500004, 10.058783270000049],
              [124.11589603000004, 10.065252997000073],
              [124.11597741000003, 10.072088934000078],
              [124.113617384, 10.080959377000056],
              [124.11622155000009, 10.08982982000009],
              [124.12387129000001, 10.09666575700004],
              [124.13697350400003, 10.104885158000059],
              [124.14307701900009, 10.110296942000048],
              [124.15870201900009, 10.13117096600007],
              [124.16716556100005, 10.13743724200009],
              [124.18458092500009, 10.144476630000042],
              [124.22266686300009, 10.151922919000071],
              [124.26343834700003, 10.151922919000071],
              [124.33130944100003, 10.161525783000059],
              [124.34961998800009, 10.15102773600006],
              [124.35596764400009, 10.110296942000048],
              [124.36695397200003, 10.119289455000057],
              [124.38249759200005, 10.143784898000092],
              [124.396820509, 10.151922919000071],
              [124.40023847700002, 10.138373114000046],
              [124.40821373800009, 10.119696356000077],
              [124.41911868600005, 10.106756903000075],
              [124.43083743600005, 10.110174872000073],
              [124.47632897200003, 10.070013739000046],
              [124.48975670700008, 10.062567450000074],
              [124.52003014400009, 10.064195054000038],
              [124.53028405000009, 10.06053294500009],
              [124.54835045700008, 10.048895575000074],
              [124.57764733200008, 10.03392161700009],
              [124.58863366000003, 10.023871161000045],
              [124.58399498800009, 9.99900950700004],
              [124.58423912900003, 9.980943101000037],
              [124.58090254000001, 9.972154039000088],
              [124.568695509, 9.987453518000052],
              [124.56617272200003, 9.968329169000071],
              [124.56617272200003, 9.952785549000055],
              [124.56446373800009, 9.94399648600006],
              [124.55616295700008, 9.92568594000005],
              [124.57146243600005, 9.912298895000049],
              [124.58375084700003, 9.893947658000059],
              [124.58464603000004, 9.87767161700009],
              [124.56527754000001, 9.870754299000055],
            ],
          ],
          [
            [
              [125.71957441500001, 9.911688544000071],
              [125.72169030000009, 9.894354559000078],
              [125.71452884200005, 9.88084544500009],
              [125.69947350400003, 9.874253648000092],
              [125.67855879000001, 9.87759023600006],
              [125.66358483200008, 9.889146226000037],
              [125.66081790500004, 9.903998114000046],
              [125.66187584700003, 9.92096588700008],
              [125.65805097700002, 9.939032294000071],
              [125.64861087300005, 9.946966864000046],
              [125.62061608200008, 9.955226955000057],
              [125.61036217500009, 9.966945705000057],
              [125.62029056100005, 9.966538804000038],
              [125.62330162900003, 9.966945705000057],
              [125.61500084700003, 9.972479559000078],
              [125.61133873800009, 9.97728099200009],
              [125.61231530000009, 9.982001044000071],
              [125.61719811300009, 9.987453518000052],
              [125.61719811300009, 9.99359772300005],
              [125.59302819100003, 9.992987372000073],
              [125.58318118600005, 10.009711005000042],
              [125.58521569100003, 10.033880927000041],
              [125.59669030000009, 10.05565013200004],
              [125.60141035200002, 10.047430731000077],
              [125.60840905000009, 10.04360586100006],
              [125.61451256600003, 10.046616929000038],
              [125.61719811300009, 10.059068101000037],
              [125.61451256600003, 10.064154364000046],
              [125.60132897200003, 10.080267645000049],
              [125.59669030000009, 10.08982982000009],
              [125.58920332100001, 10.08982982000009],
              [125.58448326900009, 10.077541408000059],
              [125.57789147200003, 10.076646226000037],
              [125.56934655000009, 10.08079661700009],
              [125.55884850400003, 10.083644924000055],
              [125.55250084700003, 10.078680731000077],
              [125.545258009, 10.068752346000053],
              [125.53541100400003, 10.06085846600007],
              [125.52100670700008, 10.062567450000074],
              [125.51343834700003, 10.07298411700009],
              [125.51319420700008, 10.086615302000041],
              [125.51075280000009, 10.098456122000073],
              [125.49708092500009, 10.103461005000042],
              [125.49529056100005, 10.108710028000075],
              [125.49594160200002, 10.134588934000078],
              [125.49366295700008, 10.144476630000042],
              [125.50896243600005, 10.151312567000048],
              [125.51758873800009, 10.16937897300005],
              [125.51937910200002, 10.190619208000044],
              [125.51417076900009, 10.207098700000074],
              [125.52198326900009, 10.21039459800005],
              [125.52898196700005, 10.209784247000073],
              [125.535492384, 10.206000067000048],
              [125.54200280000009, 10.199693101000037],
              [125.53882897200003, 10.21515534100007],
              [125.53199303500003, 10.228989976000037],
              [125.53028405000009, 10.241888739000046],
              [125.54200280000009, 10.254339911000045],
              [125.53695722700002, 10.257147528000075],
              [125.53484134200005, 10.26007721600007],
              [125.53288821700005, 10.26365794500009],
              [125.52784264400009, 10.26862213700008],
              [125.53223717500009, 10.28392161700009],
              [125.52393639400009, 10.301906643000052],
              [125.52214603000004, 10.316961981000077],
              [125.54542076900009, 10.323187567000048],
              [125.55779056100005, 10.325100002000056],
              [125.56251061300009, 10.33079661700009],
              [125.56251061300009, 10.353949286000045],
              [125.56039472700002, 10.36131419500009],
              [125.55689537900003, 10.366034247000073],
              [125.55616295700008, 10.370754299000055],
              [125.56251061300009, 10.378485419000071],
              [125.56788170700008, 10.380926825000074],
              [125.57471764400009, 10.38117096600007],
              [125.580414259, 10.37913646000004],
              [125.58643639400009, 10.36741771000004],
              [125.59441165500004, 10.365179755000042],
              [125.60336347700002, 10.366766669000071],
              [125.61036217500009, 10.37099844000005],
              [125.61475670700008, 10.381048895000049],
              [125.61719811300009, 10.419419664000088],
              [125.62419681100005, 10.44367096600007],
              [125.62964928500003, 10.454046942000048],
              [125.63770592500009, 10.46039459800005],
              [125.64966881600003, 10.46190013200004],
              [125.65739993600005, 10.456447658000059],
              [125.67172285200002, 10.43305084800005],
              [125.68482506600003, 10.399888414000088],
              [125.68384850400003, 10.364406643000052],
              [125.66488691500001, 10.29588450700004],
              [125.66138756600003, 10.27057526200008],
              [125.65805097700002, 10.26170482000009],
              [125.654633009, 10.264227606000077],
              [125.64625084700003, 10.265366929000038],
              [125.63868248800009, 10.261379299000055],
              [125.63770592500009, 10.248114325000074],
              [125.64584394600001, 10.23969147300005],
              [125.66016686300009, 10.228257554000038],
              [125.66814212300005, 10.214667059000078],
              [125.65805097700002, 10.199693101000037],
              [125.66488691500001, 10.192857164000088],
              [125.65381920700008, 10.18659088700008],
              [125.65650475400003, 10.176336981000077],
              [125.66846764400009, 10.169256903000075],
              [125.68531334700003, 10.172349351000037],
              [125.67758222700002, 10.14484284100007],
              [125.67676842500009, 10.12767161700009],
              [125.681976759, 10.11399974200009],
              [125.69849694100003, 10.093939520000049],
              [125.70476321700005, 10.081773179000038],
              [125.70655358200008, 10.06932200700004],
              [125.70313561300009, 10.056708075000074],
              [125.69646243600005, 10.04092031500005],
              [125.68864993600005, 10.027289130000042],
              [125.681976759, 10.021551825000074],
              [125.68506920700008, 10.01463450700004],
              [125.69288170700008, 9.974351304000038],
              [125.68148847700002, 9.95807526200008],
              [125.69060306100005, 9.941839911000045],
              [125.70728600400003, 9.926214911000045],
              [125.71957441500001, 9.911688544000071],
            ],
          ],
          [
            [
              [119.95020592500009, 10.60374583500004],
              [119.97413170700008, 10.595363674000055],
              [120.00001061300009, 10.580471096000053],
              [120.01124108200008, 10.565252997000073],
              [119.990570509, 10.555975653000075],
              [119.990570509, 10.54913971600007],
              [119.99317467500009, 10.539984442000048],
              [119.98414147200003, 10.531317450000074],
              [119.96827233200008, 10.528143622000073],
              [119.95020592500009, 10.53546784100007],
              [119.94947350400003, 10.528794664000088],
              [119.94727623800009, 10.52415599200009],
              [119.94467207100001, 10.520086981000077],
              [119.94271894600001, 10.515041408000059],
              [119.91879316500001, 10.548041083000044],
              [119.90870201900009, 10.555975653000075],
              [119.91187584700003, 10.536281643000052],
              [119.91765384200005, 10.516180731000077],
              [119.920258009, 10.497259833000044],
              [119.91488691500001, 10.480861721000053],
              [119.90674889400009, 10.47874583500004],
              [119.89527428500003, 10.480658270000049],
              [119.88526451900009, 10.479966539000088],
              [119.88070722700002, 10.470363674000055],
              [119.87712649800005, 10.464667059000078],
              [119.86841881600003, 10.461737372000073],
              [119.85035241000003, 10.46039459800005],
              [119.83562259200005, 10.45604075700004],
              [119.82162519600001, 10.448553778000075],
              [119.80648847700002, 10.446112372000073],
              [119.78858483200008, 10.456976630000042],
              [119.78093509200005, 10.472235419000071],
              [119.77808678500003, 10.49359772300005],
              [119.77833092500009, 10.53546784100007],
              [119.76612389400009, 10.530747789000088],
              [119.75709069100003, 10.534002997000073],
              [119.75261478000004, 10.53978099200009],
              [119.75416100400003, 10.54295482000009],
              [119.79542076900009, 10.573391018000052],
              [119.80543053500003, 10.585150458000044],
              [119.82894941500001, 10.62641022300005],
              [119.83790123800009, 10.637518622000073],
              [119.84351647200003, 10.642238674000055],
              [119.84986412900003, 10.64476146000004],
              [119.85962975400003, 10.64329661700009],
              [119.89087975400003, 10.625189520000049],
              [119.92009524800005, 10.61273834800005],
              [119.95020592500009, 10.60374583500004],
            ],
          ],
          [
            [
              [122.71111087300005, 10.73468659100007],
              [122.73796634200005, 10.694159247000073],
              [122.73707116000003, 10.640041408000059],
              [122.72152754000001, 10.585191148000092],
              [122.68685957100001, 10.506008205000057],
              [122.66431725400003, 10.470851955000057],
              [122.63445071700005, 10.444240627000056],
              [122.59498131600003, 10.43305084800005],
              [122.60523522200003, 10.460516669000071],
              [122.59449303500003, 10.45970286700009],
              [122.57797285200002, 10.447088934000078],
              [122.57081139400009, 10.439276434000078],
              [122.56519616000003, 10.43618398600006],
              [122.54761803500003, 10.42251211100006],
              [122.53663170700008, 10.419419664000088],
              [122.53052819100003, 10.423244533000059],
              [122.52637780000009, 10.43235911700009],
              [122.51929772200003, 10.453558661000045],
              [122.51872806100005, 10.458197333000044],
              [122.52027428500003, 10.469875393000052],
              [122.51929772200003, 10.47406647300005],
              [122.51433353000004, 10.477036851000037],
              [122.50196373800009, 10.479681708000044],
              [122.49878991000003, 10.480861721000053],
              [122.49480228000004, 10.48346588700008],
              [122.48585045700008, 10.493068752000056],
              [122.48243248800009, 10.50336334800005],
              [122.49512780000009, 10.508205471000053],
              [122.50700931100005, 10.508002020000049],
              [122.51685631600003, 10.509100653000075],
              [122.52361087300005, 10.514105536000045],
              [122.52613366000003, 10.525580145000049],
              [122.52930748800009, 10.533270575000074],
              [122.54590905000009, 10.540716864000046],
              [122.55347741000003, 10.54913971600007],
              [122.53500410200002, 10.553290106000077],
              [122.52735436300009, 10.570135809000078],
              [122.52857506600003, 10.591213283000059],
              [122.53663170700008, 10.607489325000074],
              [122.54786217500009, 10.622015692000048],
              [122.56413821700005, 10.65257396000004],
              [122.574554884, 10.665838934000078],
              [122.59058678500003, 10.673773505000042],
              [122.60857181100005, 10.677394924000055],
              [122.62322024800005, 10.684475002000056],
              [122.63379967500009, 10.722601630000042],
              [122.644867384, 10.736273505000042],
              [122.65845787900003, 10.74803294500009],
              [122.67017662900003, 10.76203034100007],
              [122.69971764400009, 10.740383205000057],
              [122.71111087300005, 10.73468659100007],
            ],
          ],
          [
            [
              [123.57447350400003, 10.830959377000056],
              [123.57553144600001, 10.825588283000059],
              [123.57081139400009, 10.779242255000042],
              [123.56153405000009, 10.76007721600007],
              [123.53345787900003, 10.721096096000053],
              [123.51685631600003, 10.680975653000075],
              [123.48568769600001, 10.54913971600007],
              [123.47364342500009, 10.526760158000059],
              [123.38965905000009, 10.437160549000055],
              [123.37940514400009, 10.421535549000055],
              [123.36573326900009, 10.392523505000042],
              [123.34473717500009, 10.34796784100007],
              [123.34180748800009, 10.326605536000045],
              [123.34034264400009, 10.260687567000048],
              [123.33545983200008, 10.240668036000045],
              [123.30469811300009, 10.178534247000073],
              [123.30079186300009, 10.15534088700008],
              [123.29981530000009, 10.131415106000077],
              [123.29664147200003, 10.111476955000057],
              [123.29037519600001, 10.093573309000078],
              [123.24415123800009, 10.02635325700004],
              [123.23552493600005, 10.001898505000042],
              [123.22852623800009, 9.994696356000077],
              [123.22136478000004, 9.989081122000073],
              [123.21810957100001, 9.984035549000055],
              [123.20443769600001, 9.939032294000071],
              [123.17595462300005, 9.90810781500005],
              [123.16236412900003, 9.890204169000071],
              [123.15674889400009, 9.867621161000045],
              [123.17042076900009, 9.695990302000041],
              [123.16456139400009, 9.67218659100007],
              [123.16358483200008, 9.661851304000038],
              [123.16041100400003, 9.647406317000048],
              [123.15308678500003, 9.646633205000057],
              [123.14405358200008, 9.649237372000073],
              [123.13624108200008, 9.64484284100007],
              [123.13542728000004, 9.618353583000044],
              [123.17741946700005, 9.589911200000074],
              [123.17042076900009, 9.562892971000053],
              [123.16114342500009, 9.583807684000078],
              [123.14380944100003, 9.57367584800005],
              [123.13550866000003, 9.552679755000042],
              [123.15333092500009, 9.541164455000057],
              [123.18091881600003, 9.53742096600007],
              [123.18995201900009, 9.52680084800005],
              [123.19166100400003, 9.509833075000074],
              [123.197601759, 9.487127997000073],
              [123.21168053500003, 9.472723700000074],
              [123.23259524800005, 9.459662177000041],
              [123.25147545700008, 9.44399648600006],
              [123.26726321700005, 9.39834219000005],
              [123.28484134200005, 9.379706122000073],
              [123.30518639400009, 9.362494208000044],
              [123.32113691500001, 9.343166408000059],
              [123.32829837300005, 9.302557684000078],
              [123.31763756600003, 9.25690338700008],
              [123.29859459700003, 9.215033270000049],
              [123.24341881600003, 9.136460679000038],
              [123.23878014400009, 9.120306708000044],
              [123.23015384200005, 9.107611395000049],
              [123.16098066500001, 9.065659898000092],
              [123.14771569100003, 9.061835028000075],
              [123.11207116000003, 9.06195709800005],
              [123.099945509, 9.059963283000059],
              [123.07992597700002, 9.050970770000049],
              [123.05787194100003, 9.046820380000042],
              [123.04265384200005, 9.03733958500004],
              [123.03321373800009, 9.035305080000057],
              [122.99048912900003, 9.048773505000042],
              [122.95769290500004, 9.081244208000044],
              [122.93360436300009, 9.121486721000053],
              [122.89258873800009, 9.22101471600007],
              [122.88672936300009, 9.287990627000056],
              [122.88054446700005, 9.305853583000044],
              [122.86939537900003, 9.322658596000053],
              [122.84489993600005, 9.347072658000059],
              [122.82789147200003, 9.358710028000075],
              [122.81104576900009, 9.36359284100007],
              [122.74512780000009, 9.366603908000059],
              [122.72478274800005, 9.37107982000009],
              [122.68067467500009, 9.394354559000078],
              [122.66675866000003, 9.397772528000075],
              [122.65723717500009, 9.40143463700008],
              [122.64926191500001, 9.409898179000038],
              [122.64242597700002, 9.419256903000075],
              [122.63599694100003, 9.425726630000042],
              [122.62354576900009, 9.428900458000044],
              [122.61011803500003, 9.429632880000042],
              [122.59945722700002, 9.43268463700008],
              [122.597097201, 9.437648830000057],
              [122.59066816500001, 9.450995184000078],
              [122.57016035200002, 9.47524648600006],
              [122.55176842500009, 9.49095286700009],
              [122.52979576900009, 9.537909247000073],
              [122.51587975400003, 9.548570054000038],
              [122.50521894600001, 9.552394924000055],
              [122.49659264400009, 9.561712958000044],
              [122.46680748800009, 9.623846747000073],
              [122.45728600400003, 9.637925523000092],
              [122.46436608200008, 9.646958726000037],
              [122.46143639400009, 9.65525950700004],
              [122.44361412900003, 9.672756252000056],
              [122.43824303500003, 9.668402411000045],
              [122.42823326900009, 9.662787177000041],
              [122.42310631600003, 9.65843333500004],
              [122.42481530000009, 9.672796942000048],
              [122.43083743600005, 9.698797919000071],
              [122.43043053500003, 9.713690497000073],
              [122.42457116000003, 9.710150458000044],
              [122.40870201900009, 9.703070380000042],
              [122.40259850400003, 9.699408270000049],
              [122.40357506600003, 9.738959052000041],
              [122.40935306100005, 9.77570221600007],
              [122.40984134200005, 9.808539130000042],
              [122.39519290500004, 9.836615302000041],
              [122.39519290500004, 9.84284088700008],
              [122.40593509200005, 9.853461005000042],
              [122.44410241000003, 9.921535549000055],
              [122.46159915500004, 9.96580638200004],
              [122.47461998800009, 9.974351304000038],
              [122.49537194100003, 9.976996161000045],
              [122.53777103000004, 9.98704661700009],
              [122.56031334700003, 9.987453518000052],
              [122.62598717500009, 9.974676825000074],
              [122.64283287900003, 9.966945705000057],
              [122.65699303500003, 9.975816148000092],
              [122.70777428500003, 9.986395575000074],
              [122.72852623800009, 9.997381903000075],
              [122.78223717500009, 10.05296458500004],
              [122.80738366000003, 10.06932200700004],
              [122.82691491000003, 10.058091539000088],
              [122.84489993600005, 10.067287502000056],
              [122.87281334700003, 10.100409247000073],
              [122.87891686300009, 10.118068752000056],
              [122.87582441500001, 10.143011786000045],
              [122.86255944100003, 10.18545156500005],
              [122.85531660200002, 10.228013414000088],
              [122.86939537900003, 10.350531317000048],
              [122.85938561300009, 10.394476630000042],
              [122.82178795700008, 10.472479559000078],
              [122.81470787900003, 10.515041408000059],
              [122.82390384200005, 10.532863674000055],
              [122.84253991000003, 10.541408596000053],
              [122.86101321700005, 10.546210028000075],
              [122.86939537900003, 10.552557684000078],
              [122.87484785200002, 10.561835028000075],
              [122.91041100400003, 10.59756094000005],
              [122.93384850400003, 10.648830471000053],
              [122.93458092500009, 10.658392645000049],
              [122.97169030000009, 10.721096096000053],
              [122.97584069100003, 10.74241771000004],
              [122.97169030000009, 10.80609772300005],
              [122.96851647200003, 10.811102606000077],
              [122.95394941500001, 10.822007554000038],
              [122.95069420700008, 10.82721588700008],
              [122.95215905000009, 10.847723700000074],
              [122.95435631600003, 10.85578034100007],
              [122.95818118600005, 10.864447333000044],
              [122.96631920700008, 10.876369533000059],
              [122.99382571700005, 10.906724351000037],
              [123.00261478000004, 10.91282786700009],
              [123.04802493600005, 10.914862372000073],
              [123.06771894600001, 10.918850002000056],
              [123.08773847700002, 10.925930080000057],
              [123.17009524800005, 10.97719961100006],
              [123.21355228000004, 10.99640534100007],
              [123.25977623800009, 10.994818427000041],
              [123.26221764400009, 10.991156317000048],
              [123.26514733200008, 10.984116929000038],
              [123.26978600400003, 10.977362372000073],
              [123.27686608200008, 10.974310614000046],
              [123.29566491000003, 10.97532786700009],
              [123.30079186300009, 10.974310614000046],
              [123.31185957100001, 10.966986395000049],
              [123.32960045700008, 10.95140208500004],
              [123.34180748800009, 10.94635651200008],
              [123.35377037900003, 10.94757721600007],
              [123.379242384, 10.958807684000078],
              [123.39014733200008, 10.96002838700008],
              [123.40357506600003, 10.953192450000074],
              [123.40137780000009, 10.94529857000009],
              [123.39503014400009, 10.936224677000041],
              [123.39625084700003, 10.925930080000057],
              [123.40544681100005, 10.91982656500005],
              [123.41293379000001, 10.92405833500004],
              [123.42066491000003, 10.93268463700008],
              [123.43100019600001, 10.939601955000057],
              [123.445648634, 10.942287502000056],
              [123.45687910200002, 10.94049713700008],
              [123.46705162900003, 10.93650950700004],
              [123.50261478000004, 10.92772044500009],
              [123.521820509, 10.91990794500009],
              [123.53500410200002, 10.904852606000077],
              [123.54175866000003, 10.86546458500004],
              [123.54664147200003, 10.85610586100006],
              [123.56080162900003, 10.837144273000092],
              [123.56364993600005, 10.835353908000059],
              [123.56739342500009, 10.83539459800005],
              [123.57105553500003, 10.834784247000073],
              [123.57447350400003, 10.830959377000056],
            ],
          ],
          [
            [
              [124.04737389400009, 10.834051825000074],
              [124.04379316500001, 10.809475002000056],
              [124.02662194100003, 10.769598700000074],
              [124.02076256600003, 10.747748114000046],
              [124.02393639400009, 10.70844147300005],
              [124.05079186300009, 10.627386786000045],
              [124.05494225400003, 10.59007396000004],
              [124.05176842500009, 10.589504299000055],
              [124.04468834700003, 10.586004950000074],
              [124.03736412900003, 10.58112213700008],
              [124.03386478000004, 10.57648346600007],
              [124.03443444100003, 10.571437893000052],
              [124.04037519600001, 10.568548895000049],
              [124.04127037900003, 10.56281159100007],
              [124.04004967500009, 10.48436107000009],
              [124.03589928500003, 10.46678294500009],
              [124.00977623800009, 10.404038804000038],
              [124.010101759, 10.394924221000053],
              [124.01872806100005, 10.380804755000042],
              [124.01490319100003, 10.372463283000059],
              [123.99284915500004, 10.357367255000042],
              [123.99048912900003, 10.368841864000046],
              [123.98585045700008, 10.37596263200004],
              [123.97966556100005, 10.37718333500004],
              [123.97291100400003, 10.37099844000005],
              [123.97087649800005, 10.362209377000056],
              [123.97291100400003, 10.326605536000045],
              [123.96111087300005, 10.32330963700008],
              [123.90626061300009, 10.294501044000071],
              [123.88965905000009, 10.28221263200004],
              [123.86866295700008, 10.248195705000057],
              [123.85710696700005, 10.242132880000042],
              [123.83179772200003, 10.240668036000045],
              [123.80811608200008, 10.23663971600007],
              [123.79363040500004, 10.22646719000005],
              [123.77369225400003, 10.199693101000037],
              [123.71949303500003, 10.156805731000077],
              [123.71168053500003, 10.14134349200009],
              [123.70997155000009, 10.120591539000088],
              [123.70484459700003, 10.10545482000009],
              [123.69613691500001, 10.093898830000057],
              [123.68376712300005, 10.083644924000055],
              [123.67554772200003, 10.079006252000056],
              [123.66342207100001, 10.074652411000045],
              [123.65699303500003, 10.06932200700004],
              [123.65259850400003, 10.063625393000052],
              [123.64820397200003, 10.05565013200004],
              [123.64478600400003, 10.047023830000057],
              [123.64332116000003, 10.03896719000005],
              [123.64332116000003, 9.960109768000052],
              [123.63086998800009, 9.907619533000059],
              [123.62907962300005, 9.887518622000073],
              [123.62476647200003, 9.879339911000045],
              [123.61548912900003, 9.87445709800005],
              [123.60596764400009, 9.871161200000074],
              [123.60181725400003, 9.867621161000045],
              [123.50945071700005, 9.653509833000044],
              [123.50342858200008, 9.615301825000074],
              [123.48829186300009, 9.566473700000074],
              [123.47950280000009, 9.548570054000038],
              [123.471039259, 9.53896719000005],
              [123.45329837300005, 9.52806224200009],
              [123.44467207100001, 9.521307684000078],
              [123.435883009, 9.509955145000049],
              [123.42269941500001, 9.487697658000059],
              [123.36963951900009, 9.425726630000042],
              [123.35857181100005, 9.415757554000038],
              [123.34245853000004, 9.406805731000077],
              [123.32764733200008, 9.408148505000042],
              [123.32113691500001, 9.42914459800005],
              [123.31421959700003, 9.485541083000044],
              [123.31430097700002, 9.507635809000078],
              [123.36524498800009, 9.785345770000049],
              [123.40495853000004, 9.878404039000088],
              [123.40919030000009, 9.897691148000092],
              [123.41065514400009, 9.922552802000041],
              [123.40642337300005, 9.927557684000078],
              [123.38754316500001, 9.937079169000071],
              [123.38331139400009, 9.942694403000075],
              [123.387054884, 9.973781643000052],
              [123.39014733200008, 9.980617580000057],
              [123.39844811300009, 9.984808661000045],
              [123.40406334700003, 9.981268622000073],
              [123.40772545700008, 9.975816148000092],
              [123.41065514400009, 9.974351304000038],
              [123.41521243600005, 9.981350002000056],
              [123.41716556100005, 9.989650783000059],
              [123.41732832100001, 10.011664130000042],
              [123.42253665500004, 10.037502346000053],
              [123.43539472700002, 10.055080471000053],
              [123.47201582100001, 10.083644924000055],
              [123.50798587300005, 10.122219143000052],
              [123.52133222700002, 10.14524974200009],
              [123.53345787900003, 10.190375067000048],
              [123.58130944100003, 10.254339911000045],
              [123.59685306100005, 10.317775783000059],
              [123.60547936300009, 10.333156643000052],
              [123.62273196700005, 10.350531317000048],
              [123.70679772200003, 10.46198151200008],
              [123.71168053500003, 10.477443752000056],
              [123.71387780000009, 10.48232656500005],
              [123.71851647200003, 10.48729075700004],
              [123.72315514400009, 10.494208075000074],
              [123.72535241000003, 10.504787502000056],
              [123.71802819100003, 10.537054755000042],
              [123.719086134, 10.54913971600007],
              [123.72925866000003, 10.569240627000056],
              [123.75440514400009, 10.599432684000078],
              [123.76498457100001, 10.640041408000059],
              [123.77784264400009, 10.662583726000037],
              [123.79273522200003, 10.683254299000055],
              [123.83155358200008, 10.725083726000037],
              [123.84929446700005, 10.752630927000041],
              [123.91578209700003, 10.93976471600007],
              [123.93458092500009, 10.970445054000038],
              [123.930023634, 10.99359772300005],
              [123.91773522200003, 11.028957424000055],
              [123.92408287900003, 11.04633209800005],
              [123.93523196700005, 11.05923086100006],
              [123.94434655000009, 11.074164130000042],
              [123.94507897200003, 11.097845770000049],
              [123.95191491000003, 11.097845770000049],
              [123.955414259, 11.090236721000053],
              [123.95964603000004, 11.085516669000071],
              [123.97291100400003, 11.077337958000044],
              [123.96070397200003, 11.13076406500005],
              [123.95525149800005, 11.142238674000055],
              [123.95191491000003, 11.156724351000037],
              [123.95875084700003, 11.175930080000057],
              [123.96973717500009, 11.194525458000044],
              [124.01832116000003, 11.258490302000041],
              [124.04566491000003, 11.277167059000078],
              [124.07471764400009, 11.269110419000071],
              [124.07276451900009, 11.26203034100007],
              [124.06812584700003, 11.233343817000048],
              [124.05567467500009, 11.205023505000042],
              [124.05128014400009, 11.185492255000042],
              [124.04737389400009, 11.14874909100007],
              [124.04127037900003, 11.130113023000092],
              [124.01075280000009, 11.094549872000073],
              [123.99952233200008, 11.077337958000044],
              [124.00912519600001, 11.073391018000052],
              [124.01254316500001, 11.066229559000078],
              [124.01392662900003, 11.05931224200009],
              [124.01710045700008, 11.056219794000071],
              [124.03728274800005, 11.057521877000056],
              [124.04615319100003, 11.059759833000044],
              [124.05494225400003, 11.063666083000044],
              [124.05193118600005, 11.043158270000049],
              [124.06177819100003, 10.98427969000005],
              [124.05974368600005, 10.962307033000059],
              [124.05347741000003, 10.930568752000056],
              [124.05494225400003, 10.91282786700009],
              [124.06690514400009, 10.889064846000053],
              [124.06853274800005, 10.878119208000044],
              [124.06495201900009, 10.86790599200009],
              [124.05062910200002, 10.845038153000075],
              [124.04737389400009, 10.834051825000074],
            ],
          ],
          [
            [
              [123.80103600400003, 11.17914459800005],
              [123.81153405000009, 11.165269273000092],
              [123.81804446700005, 11.154730536000045],
              [123.81495201900009, 11.148016669000071],
              [123.74968509200005, 11.14134349200009],
              [123.74577884200005, 11.138820705000057],
              [123.73365319100003, 11.15428294500009],
              [123.70866946700005, 11.21784088700008],
              [123.70484459700003, 11.24119700700004],
              [123.70850670700008, 11.252427476000037],
              [123.71583092500009, 11.264146226000037],
              [123.732758009, 11.283758856000077],
              [123.74577884200005, 11.292466539000088],
              [123.75464928500003, 11.289536851000037],
              [123.76091556100005, 11.278876044000071],
              [123.78931725400003, 11.198919989000046],
              [123.80103600400003, 11.17914459800005],
            ],
          ],
          [
            [
              [119.67188561300009, 10.552557684000078],
              [119.71412194100003, 10.53266022300005],
              [119.72535241000003, 10.51862213700008],
              [119.70997155000009, 10.494533596000053],
              [119.70199629000001, 10.49087148600006],
              [119.67847741000003, 10.485663153000075],
              [119.66846764400009, 10.480861721000053],
              [119.64795983200008, 10.44985586100006],
              [119.63965905000009, 10.444728908000059],
              [119.59343509200005, 10.405178127000056],
              [119.57585696700005, 10.380519924000055],
              [119.56324303500003, 10.373480536000045],
              [119.54224694100003, 10.37099844000005],
              [119.50082441500001, 10.37099844000005],
              [119.48902428500003, 10.372463283000059],
              [119.47266686300009, 10.378119208000044],
              [119.46306399800005, 10.378485419000071],
              [119.44922936300009, 10.37303294500009],
              [119.41871178500003, 10.35455963700008],
              [119.39812259200005, 10.350531317000048],
              [119.37826582100001, 10.344142971000053],
              [119.35596764400009, 10.32884349200009],
              [119.28598066500001, 10.261379299000055],
              [119.25733483200008, 10.221991278000075],
              [119.23715254000001, 10.179348049000055],
              [119.22071373800009, 10.084173895000049],
              [119.19629967500009, 10.056341864000046],
              [119.15943444100003, 10.04124583500004],
              [119.11353600400003, 10.028998114000046],
              [119.10254967500009, 10.02440013200004],
              [119.08253014400009, 10.012518622000073],
              [119.07203209700003, 10.007961330000057],
              [119.06055748800009, 10.006659247000073],
              [119.03614342500009, 10.009019273000092],
              [119.02475019600001, 10.007961330000057],
              [119.01498457100001, 10.003729559000078],
              [118.99496504000001, 9.992010809000078],
              [118.98389733200008, 9.987453518000052],
              [118.97291100400003, 9.984523830000057],
              [118.95142662900003, 9.981024481000077],
              [118.90300540500004, 9.978664455000057],
              [118.87476647200003, 9.971869208000044],
              [118.84880618600005, 9.959133205000057],
              [118.81934655000009, 9.939032294000071],
              [118.79656009200005, 9.94521719000005],
              [118.77418053500003, 9.934149481000077],
              [118.75717207100001, 9.912665106000077],
              [118.75049889400009, 9.887518622000073],
              [118.75456790500004, 9.855943101000037],
              [118.77564537900003, 9.814032294000071],
              [118.78467858200008, 9.788234768000052],
              [118.77784264400009, 9.734198309000078],
              [118.76490319100003, 9.72874583500004],
              [118.74903405000009, 9.732814846000053],
              [118.73560631600003, 9.743475653000075],
              [118.72999108200008, 9.757757880000042],
              [118.73389733200008, 9.77570221600007],
              [118.72966556100005, 9.780422268000052],
              [118.71290123800009, 9.78196849200009],
              [118.70093834700003, 9.775539455000057],
              [118.70191491000003, 9.760239976000037],
              [118.70557701900009, 9.74217357000009],
              [118.70199629000001, 9.727362372000073],
              [118.71314537900003, 9.721625067000048],
              [118.71973717500009, 9.713812567000048],
              [118.72095787900003, 9.704046942000048],
              [118.71631920700008, 9.692572333000044],
              [118.74293053500003, 9.696844794000071],
              [118.75831139400009, 9.683335679000038],
              [118.75635826900009, 9.667669989000046],
              [118.72999108200008, 9.665269273000092],
              [118.73161868600005, 9.65037669500009],
              [118.72535241000003, 9.631293036000045],
              [118.71550540500004, 9.612779039000088],
              [118.70582116000003, 9.600083726000037],
              [118.70053144600001, 9.591498114000046],
              [118.69890384200005, 9.583726304000038],
              [118.69532311300009, 9.578070380000042],
              [118.67481530000009, 9.574367580000057],
              [118.66920006600003, 9.569973049000055],
              [118.592133009, 9.446193752000056],
              [118.55730228000004, 9.411688544000071],
              [118.55193118600005, 9.401190497000073],
              [118.54737389400009, 9.383002020000049],
              [118.53646894600001, 9.36432526200008],
              [118.49789472700002, 9.313666083000044],
              [118.49219811300009, 9.30882396000004],
              [118.45508873800009, 9.284369208000044],
              [118.445648634, 9.281683661000045],
              [118.43083743600005, 9.273179429000038],
              [118.38054446700005, 9.220282294000071],
              [118.36500084700003, 9.193060614000046],
              [118.35377037900003, 9.183172919000071],
              [118.33578535200002, 9.179266669000071],
              [118.29493248800009, 9.179266669000071],
              [118.28435306100005, 9.17641836100006],
              [118.26140384200005, 9.162787177000041],
              [118.25017337300005, 9.158148505000042],
              [118.18913821700005, 9.155991929000038],
              [118.17123457100001, 9.148260809000078],
              [118.16342207100001, 9.14280833500004],
              [118.13697350400003, 9.13084544500009],
              [118.13209069100003, 9.126654364000046],
              [118.12671959700003, 9.096136786000045],
              [118.11304772200003, 9.06940338700008],
              [118.11207116000003, 9.064927476000037],
              [118.11345462300005, 9.05377838700008],
              [118.11304772200003, 9.048976955000057],
              [118.10914147200003, 9.04759349200009],
              [118.10222415500004, 9.047796942000048],
              [118.09546959700003, 9.04596588700008],
              [118.09253991000003, 9.038397528000075],
              [118.08912194100003, 9.01976146000004],
              [118.080414259, 8.996283270000049],
              [118.05836022200003, 8.952093817000048],
              [118.01368248800009, 8.887600002000056],
              [118.00066165500004, 8.877386786000045],
              [117.91041100400003, 8.829738674000055],
              [117.84009850400003, 8.77448151200008],
              [117.77369225400003, 8.703070380000042],
              [117.75538170700008, 8.69017161700009],
              [117.73292076900009, 8.685207424000055],
              [117.711273634, 8.682928778000075],
              [117.69800866000003, 8.677435614000046],
              [117.68580162900003, 8.67064036700009],
              [117.66732832100001, 8.664740302000041],
              [117.64673912900003, 8.663275458000044],
              [117.58887780000009, 8.67096588700008],
              [117.56560306100005, 8.661078192000048],
              [117.55738366000003, 8.638413804000038],
              [117.55811608200008, 8.59642161700009],
              [117.55014082100001, 8.57562897300005],
              [117.52312259200005, 8.53969961100006],
              [117.51726321700005, 8.517645575000074],
              [117.51286868600005, 8.506781317000048],
              [117.50318444100003, 8.50071849200009],
              [117.49350019600001, 8.499660549000055],
              [117.48910566500001, 8.503648179000038],
              [117.48414147200003, 8.513006903000075],
              [117.47217858200008, 8.513820705000057],
              [117.37891686300009, 8.48631419500009],
              [117.34498131600003, 8.471258856000077],
              [117.31861412900003, 8.451849677000041],
              [117.31519616000003, 8.446112372000073],
              [117.30762780000009, 8.429388739000046],
              [117.30437259200005, 8.424505927000041],
              [117.27003014400009, 8.41429271000004],
              [117.26384524800005, 8.397609768000052],
              [117.24927819100003, 8.38353099200009],
              [117.22234134200005, 8.363714911000045],
              [117.19800866000003, 8.334784247000073],
              [117.19076582100001, 8.338324286000045],
              [117.18824303500003, 8.366522528000075],
              [117.19044030000009, 8.378159898000092],
              [117.19971764400009, 8.398016669000071],
              [117.20476321700005, 8.418646552000041],
              [117.21143639400009, 8.427069403000075],
              [117.21843509200005, 8.433417059000078],
              [117.22234134200005, 8.438177802000041],
              [117.22339928500003, 8.448065497000073],
              [117.22193444100003, 8.46906159100007],
              [117.22250410200002, 8.484320380000042],
              [117.22193444100003, 8.495062567000048],
              [117.22234134200005, 8.50023021000004],
              [117.22535241000003, 8.50531647300005],
              [117.23414147200003, 8.511297919000071],
              [117.23959394600001, 8.53579336100006],
              [117.24854576900009, 8.555080471000053],
              [117.27003014400009, 8.589016018000052],
              [117.26775149800005, 8.590318101000037],
              [117.26392662900003, 8.61009349200009],
              [117.27995853000004, 8.604966539000088],
              [117.28679446700005, 8.620347398000092],
              [117.29151451900009, 8.640814520000049],
              [117.301117384, 8.651068427000041],
              [117.31218509200005, 8.656195380000042],
              [117.32715905000009, 8.668646552000041],
              [117.34205162900003, 8.684271552000041],
              [117.35271243600005, 8.698879299000055],
              [117.33904056100005, 8.698879299000055],
              [117.35962975400003, 8.731268622000073],
              [117.37598717500009, 8.74681224200009],
              [117.41773522200003, 8.759100653000075],
              [117.43555748800009, 8.773138739000046],
              [117.45036868600005, 8.791164455000057],
              [117.51978600400003, 8.899725653000075],
              [117.54379316500001, 8.925441799000055],
              [117.62273196700005, 8.991848049000055],
              [117.64014733200008, 9.020982164000088],
              [117.64771569100003, 9.042914130000042],
              [117.65552819100003, 9.057928778000075],
              [117.66863040500004, 9.06663646000004],
              [117.69190514400009, 9.06940338700008],
              [117.70443769600001, 9.079494533000059],
              [117.71225019600001, 9.081610419000071],
              [117.71566816500001, 9.07249583500004],
              [117.71973717500009, 9.065822658000059],
              [117.72950280000009, 9.064154364000046],
              [117.74073326900009, 9.065904039000088],
              [117.75001061300009, 9.06940338700008],
              [117.76189212300005, 9.077948309000078],
              [117.76807701900009, 9.086411851000037],
              [117.78052819100003, 9.120266018000052],
              [117.78239993600005, 9.122544664000088],
              [117.78785241000003, 9.127427476000037],
              [117.79127037900003, 9.134833075000074],
              [117.78931725400003, 9.142320054000038],
              [117.78402754000001, 9.15135325700004],
              [117.79656009200005, 9.163275458000044],
              [117.83668053500003, 9.18821849200009],
              [117.84986412900003, 9.192938544000071],
              [117.86646569100003, 9.203599351000037],
              [117.88998457100001, 9.250555731000077],
              [117.90447024800005, 9.261216539000088],
              [117.94499759200005, 9.25608958500004],
              [117.96631920700008, 9.25726959800005],
              [117.98951256600003, 9.267401434000078],
              [117.98804772200003, 9.255926825000074],
              [117.98959394600001, 9.246242580000057],
              [117.994476759, 9.23859284100007],
              [118.00318444100003, 9.233303127000056],
              [118.01636803500003, 9.24323151200008],
              [118.02588951900009, 9.25381094000005],
              [118.04468834700003, 9.281683661000045],
              [118.05437259200005, 9.291449286000045],
              [118.12696373800009, 9.337836005000042],
              [118.13355553500003, 9.343166408000059],
              [118.13526451900009, 9.35187409100007],
              [118.13103274800005, 9.373195705000057],
              [118.13355553500003, 9.384711005000042],
              [118.14820397200003, 9.39671458500004],
              [118.17156009200005, 9.407863674000055],
              [118.19288170700008, 9.421820380000042],
              [118.21631920700008, 9.47797272300005],
              [118.27719160200002, 9.519720770000049],
              [118.29769941500001, 9.554877020000049],
              [118.32618248800009, 9.579046942000048],
              [118.33277428500003, 9.586411851000037],
              [118.33497155000009, 9.591620184000078],
              [118.33961022200003, 9.596584377000056],
              [118.34424889400009, 9.603216864000046],
              [118.34644616000003, 9.613755601000037],
              [118.34546959700003, 9.63617584800005],
              [118.34913170700008, 9.645738023000092],
              [118.36011803500003, 9.65843333500004],
              [118.37175540500004, 9.654364325000074],
              [118.38233483200008, 9.657782294000071],
              [118.40113366000003, 9.672756252000056],
              [118.40845787900003, 9.676336981000077],
              [118.41529381600003, 9.67772044500009],
              [118.420258009, 9.68073151200008],
              [118.42432701900009, 9.69790273600006],
              [118.42945397200003, 9.70062897300005],
              [118.43620853000004, 9.70189036700009],
              [118.44263756600003, 9.706244208000044],
              [118.45085696700005, 9.715765692000048],
              [118.53052819100003, 9.774237372000073],
              [118.53760826900009, 9.785101630000042],
              [118.54835045700008, 9.81240469000005],
              [118.59571373800009, 9.857367255000042],
              [118.60645592500009, 9.874172268000052],
              [118.60824629000001, 9.885321356000077],
              [118.61312910200002, 9.900946356000077],
              [118.62061608200008, 9.916896877000056],
              [118.65723717500009, 9.965236721000053],
              [118.66797936300009, 9.974351304000038],
              [118.65650475400003, 9.996161200000074],
              [118.67359459700003, 10.011786200000074],
              [118.72250410200002, 10.035834052000041],
              [118.728851759, 10.045803127000056],
              [118.76368248800009, 10.120754299000055],
              [118.77165774800005, 10.130804755000042],
              [118.77662194100003, 10.09906647300005],
              [118.77662194100003, 10.08307526200008],
              [118.76783287900003, 10.07615794500009],
              [118.76295006600003, 10.069240627000056],
              [118.77947024800005, 10.056301174000055],
              [118.801117384, 10.049017645000049],
              [118.81185957100001, 10.059068101000037],
              [118.814789259, 10.067287502000056],
              [118.82129967500009, 10.073879299000055],
              [118.82829837300005, 10.079250393000052],
              [118.832367384, 10.083644924000055],
              [118.83765709700003, 10.09568919500009],
              [118.83863366000003, 10.09992096600007],
              [118.83643639400009, 10.102728583000044],
              [118.81771894600001, 10.13670482000009],
              [118.81234785200002, 10.152085679000038],
              [118.81185957100001, 10.172349351000037],
              [118.81576582100001, 10.18891022300005],
              [118.82227623800009, 10.194525458000044],
              [118.84294681100005, 10.192857164000088],
              [118.85515384200005, 10.19603099200009],
              [118.875336134, 10.210150458000044],
              [118.89112389400009, 10.213324286000045],
              [118.91846764400009, 10.208319403000075],
              [118.93360436300009, 10.209662177000041],
              [118.94971764400009, 10.22016022300005],
              [118.95834394600001, 10.235256252000056],
              [118.96013431100005, 10.252508856000077],
              [118.95671634200005, 10.269191799000055],
              [118.94971764400009, 10.28221263200004],
              [118.95655358200008, 10.284816799000055],
              [118.95948326900009, 10.286810614000046],
              [118.96265709700003, 10.286444403000075],
              [118.97022545700008, 10.28221263200004],
              [118.97925866000003, 10.292303778000075],
              [118.99341881600003, 10.300279039000088],
              [119.00945071700005, 10.30609772300005],
              [119.02475019600001, 10.30955638200004],
              [119.02173912900003, 10.32518138200004],
              [119.03003991000003, 10.338568427000041],
              [119.03394616000003, 10.349351304000038],
              [119.017914259, 10.357367255000042],
              [119.008148634, 10.353705145000049],
              [118.99594160200002, 10.346096096000053],
              [118.98438561300009, 10.34406159100007],
              [118.97641035200002, 10.357367255000042],
              [118.97974694100003, 10.368109442000048],
              [118.98975670700008, 10.383286851000037],
              [119.00196373800009, 10.39752838700008],
              [119.01172936300009, 10.405178127000056],
              [119.02751712300005, 10.407171942000048],
              [119.04395592500009, 10.40420156500005],
              [119.05933678500003, 10.398260809000078],
              [119.07203209700003, 10.391506252000056],
              [119.07911217500009, 10.404689846000053],
              [119.07911217500009, 10.41547272300005],
              [119.084320509, 10.422796942000048],
              [119.10670006600003, 10.425604559000078],
              [119.09961998800009, 10.438706773000092],
              [119.09058678500003, 10.44562409100007],
              [119.08448326900009, 10.452785549000055],
              [119.08570397200003, 10.466620184000078],
              [119.09131920700008, 10.473089911000045],
              [119.11109459700003, 10.480658270000049],
              [119.12037194100003, 10.48773834800005],
              [119.11850019600001, 10.47679271000004],
              [119.11703535200002, 10.472398179000038],
              [119.11353600400003, 10.466620184000078],
              [119.11882571700005, 10.454291083000044],
              [119.12720787900003, 10.394924221000053],
              [119.13526451900009, 10.38812897300005],
              [119.15284264400009, 10.398504950000074],
              [119.18181399800005, 10.425604559000078],
              [119.19206790500004, 10.44798411700009],
              [119.19556725400003, 10.453558661000045],
              [119.20264733200008, 10.457180080000057],
              [119.21192467500009, 10.45970286700009],
              [119.21998131600003, 10.463364976000037],
              [119.22999108200008, 10.48541901200008],
              [119.26392662900003, 10.49412669500009],
              [119.27808678500003, 10.508205471000053],
              [119.26840254000001, 10.51951732000009],
              [119.25562584700003, 10.530951239000046],
              [119.24724368600005, 10.54295482000009],
              [119.25074303500003, 10.555975653000075],
              [119.26954186300009, 10.548529364000046],
              [119.29078209700003, 10.55768463700008],
              [119.30909264400009, 10.57453034100007],
              [119.31910241000003, 10.59007396000004],
              [119.34498131600003, 10.723578192000048],
              [119.34205162900003, 10.736151434000078],
              [119.32960045700008, 10.751166083000044],
              [119.32545006600003, 10.757513739000046],
              [119.32178795700008, 10.76561107000009],
              [119.31690514400009, 10.772691148000092],
              [119.30909264400009, 10.77570221600007],
              [119.30201256600003, 10.772853908000059],
              [119.29167728000004, 10.762111721000053],
              [119.28484134200005, 10.76203034100007],
              [119.27393639400009, 10.771673895000049],
              [119.27027428500003, 10.784898179000038],
              [119.27125084700003, 10.812933661000045],
              [119.26612389400009, 10.826605536000045],
              [119.25359134200005, 10.837469794000071],
              [119.23780358200008, 10.845404364000046],
              [119.22339928500003, 10.850816148000092],
              [119.25261478000004, 10.887274481000077],
              [119.25757897200003, 10.891099351000037],
              [119.24927819100003, 10.90232982000009],
              [119.23633873800009, 10.90843333500004],
              [119.22877037900003, 10.91624583500004],
              [119.23707116000003, 10.93268463700008],
              [119.22250410200002, 10.94171784100007],
              [119.23194420700008, 10.95115794500009],
              [119.24724368600005, 10.949774481000077],
              [119.25074303500003, 10.925930080000057],
              [119.25757897200003, 10.925930080000057],
              [119.25896243600005, 10.930080471000053],
              [119.26441491000003, 10.939601955000057],
              [119.26832116000003, 10.931789455000057],
              [119.27312259200005, 10.927476304000038],
              [119.27857506600003, 10.927557684000078],
              [119.28484134200005, 10.93268463700008],
              [119.29167728000004, 10.93268463700008],
              [119.28785241000003, 10.92055898600006],
              [119.28516686300009, 10.917466539000088],
              [119.27808678500003, 10.91282786700009],
              [119.29167728000004, 10.884955145000049],
              [119.27125084700003, 10.884955145000049],
              [119.27808678500003, 10.874945380000042],
              [119.28858483200008, 10.871527411000045],
              [119.30079186300009, 10.873114325000074],
              [119.312836134, 10.878119208000044],
              [119.30583743600005, 10.857123114000046],
              [119.30982506600003, 10.847316799000055],
              [119.32032311300009, 10.839260158000059],
              [119.33326256600003, 10.823472398000092],
              [119.33952884200005, 10.823472398000092],
              [119.33952884200005, 10.830959377000056],
              [119.34693444100003, 10.830959377000056],
              [119.35157311300009, 10.810736395000049],
              [119.36817467500009, 10.801336981000077],
              [119.38640384200005, 10.79368724200009],
              [119.39470462300005, 10.778794664000088],
              [119.39795983200008, 10.76821523600006],
              [119.40495853000004, 10.76235586100006],
              [119.41211998800009, 10.761379299000055],
              [119.41871178500003, 10.769924221000053],
              [119.426117384, 10.762640692000048],
              [119.43327884200005, 10.752346096000053],
              [119.43946373800009, 10.740423895000049],
              [119.44109134200005, 10.73273346600007],
              [119.44507897200003, 10.727484442000048],
              [119.45679772200003, 10.72728099200009],
              [119.46753991000003, 10.73265208500004],
              [119.46949303500003, 10.741034247000073],
              [119.46566816500001, 10.75023021000004],
              [119.45997155000009, 10.758286851000037],
              [119.44597415500004, 10.78937409100007],
              [119.43970787900003, 10.796047268000052],
              [119.44418379000001, 10.810614325000074],
              [119.45240319100003, 10.82493724200009],
              [119.45679772200003, 10.830959377000056],
              [119.44988040500004, 10.841294664000088],
              [119.43506920700008, 10.852240302000041],
              [119.41822350400003, 10.860907294000071],
              [119.40495853000004, 10.864447333000044],
              [119.38795006600003, 10.86469147300005],
              [119.37012780000009, 10.867743231000077],
              [119.35523522200003, 10.877752997000073],
              [119.34693444100003, 10.898586330000057],
              [119.34864342500009, 10.908026434000078],
              [119.35906009200005, 10.927679755000042],
              [119.36060631600003, 10.93268463700008],
              [119.35173587300005, 10.934759833000044],
              [119.33773847700002, 10.932928778000075],
              [119.32471764400009, 10.93349844000005],
              [119.31910241000003, 10.943019924000055],
              [119.31999759200005, 11.000881252000056],
              [119.32593834700003, 11.015285549000055],
              [119.32593834700003, 11.022772528000075],
              [119.33326256600003, 11.022772528000075],
              [119.33521569100003, 11.011542059000078],
              [119.34058678500003, 11.004055080000057],
              [119.34888756600003, 11.000433661000045],
              [119.36060631600003, 11.00096263200004],
              [119.35279381600003, 11.023586330000057],
              [119.32740319100003, 11.06443919500009],
              [119.32593834700003, 11.090399481000077],
              [119.33497155000009, 11.102932033000059],
              [119.34791100400003, 11.089178778000075],
              [119.36264082100001, 11.067572333000044],
              [119.377289259, 11.056219794000071],
              [119.38754316500001, 11.054022528000075],
              [119.39714603000004, 11.050279039000088],
              [119.40609785200002, 11.04954661700009],
              [119.41529381600003, 11.056219794000071],
              [119.41879316500001, 11.067857164000088],
              [119.41871178500003, 11.09560781500005],
              [119.43213951900009, 11.122219143000052],
              [119.426117384, 11.133937893000052],
              [119.41716556100005, 11.140326239000046],
              [119.41529381600003, 11.138820705000057],
              [119.398773634, 11.15924713700008],
              [119.39210045700008, 11.171372789000088],
              [119.38795006600003, 11.18659088700008],
              [119.400726759, 11.185370184000078],
              [119.41334069100003, 11.196682033000059],
              [119.42359459700003, 11.21320221600007],
              [119.42896569100003, 11.22752513200004],
              [119.42839603000004, 11.249823309000078],
              [119.42058353000004, 11.297552802000041],
              [119.42554772200003, 11.31354401200008],
              [119.43018639400009, 11.318426825000074],
              [119.43344160200002, 11.322658596000053],
              [119.43506920700008, 11.327378648000092],
              [119.43580162900003, 11.33397044500009],
              [119.43873131600003, 11.337958075000074],
              [119.44483483200008, 11.337836005000042],
              [119.44988040500004, 11.334906317000048],
              [119.44939212300005, 11.330633856000077],
              [119.46550540500004, 11.346828518000052],
              [119.47380618600005, 11.357855536000045],
              [119.47730553500003, 11.368475653000075],
              [119.47999108200008, 11.396185614000046],
              [119.48438561300009, 11.410549221000053],
              [119.49105879000001, 11.42088450700004],
              [119.50196373800009, 11.423325914000088],
              [119.50904381600003, 11.41307200700004],
              [119.51295006600003, 11.397772528000075],
              [119.51441491000003, 11.385443427000041],
              [119.51449629000001, 11.367661851000037],
              [119.51539147200003, 11.361761786000045],
              [119.51856530000009, 11.350775458000044],
              [119.52295983200008, 11.339911200000074],
              [119.52955162900003, 11.330552476000037],
              [119.53882897200003, 11.323716539000088],
              [119.54151451900009, 11.328070380000042],
              [119.54769941500001, 11.33266836100006],
              [119.55241946700005, 11.337388414000088],
              [119.56706790500004, 11.30141836100006],
              [119.56902103000004, 11.261664130000042],
              [119.56104576900009, 11.220282294000071],
              [119.54566491000003, 11.17914459800005],
              [119.52051842500009, 11.138413804000038],
              [119.51636803500003, 11.11749909100007],
              [119.52857506600003, 11.094142971000053],
              [119.55339603000004, 11.072211005000042],
              [119.56177819100003, 11.059027411000045],
              [119.57243899800005, 11.015326239000046],
              [119.57056725400003, 11.007513739000046],
              [119.55925540500004, 11.00096263200004],
              [119.53834069100003, 11.01276276200008],
              [119.52418053500003, 11.017320054000038],
              [119.51758873800009, 11.011867580000057],
              [119.50660241000003, 10.983587958000044],
              [119.50456790500004, 10.970892645000049],
              [119.50570722700002, 10.958644924000055],
              [119.51042728000004, 10.937323309000078],
              [119.51140384200005, 10.925930080000057],
              [119.510101759, 10.91632721600007],
              [119.50505618600005, 10.89647044500009],
              [119.50456790500004, 10.884955145000049],
              [119.50733483200008, 10.874945380000042],
              [119.51587975400003, 10.85927969000005],
              [119.51929772200003, 10.837713934000078],
              [119.52393639400009, 10.827622789000088],
              [119.531586134, 10.819810289000088],
              [119.54224694100003, 10.81663646000004],
              [119.55494225400003, 10.81867096600007],
              [119.56275475400003, 10.823187567000048],
              [119.56804446700005, 10.828070380000042],
              [119.57292728000004, 10.830959377000056],
              [119.58521569100003, 10.83344147300005],
              [119.58912194100003, 10.83470286700009],
              [119.59343509200005, 10.837144273000092],
              [119.60271243600005, 10.824408270000049],
              [119.60157311300009, 10.81085846600007],
              [119.59644616000003, 10.797552802000041],
              [119.59343509200005, 10.785589911000045],
              [119.60010826900009, 10.754584052000041],
              [119.60010826900009, 10.717352606000077],
              [119.59636478000004, 10.697088934000078],
              [119.59050540500004, 10.682440497000073],
              [119.59083092500009, 10.672430731000077],
              [119.60629316500001, 10.665838934000078],
              [119.62720787900003, 10.668117580000057],
              [119.64136803500003, 10.675848700000074],
              [119.65357506600003, 10.675116278000075],
              [119.66846764400009, 10.652167059000078],
              [119.65919030000009, 10.655096747000073],
              [119.65064537900003, 10.656195380000042],
              [119.64242597700002, 10.65525950700004],
              [119.63445071700005, 10.652167059000078],
              [119.63990319100003, 10.643947658000059],
              [119.64258873800009, 10.637884833000044],
              [119.64275149800005, 10.632066148000092],
              [119.64128665500004, 10.62490469000005],
              [119.65512129000001, 10.61229075700004],
              [119.66277103000004, 10.570990302000041],
              [119.67188561300009, 10.552557684000078],
            ],
          ],
          [
            [
              [119.86719811300009, 11.515570380000042],
              [119.87614993600005, 11.479641018000052],
              [119.86980228000004, 11.440619208000044],
              [119.85352623800009, 11.404730536000045],
              [119.83285566500001, 11.37836334800005],
              [119.82203209700003, 11.387396552000041],
              [119.82056725400003, 11.399603583000044],
              [119.82545006600003, 11.41315338700008],
              [119.83285566500001, 11.426174221000053],
              [119.820648634, 11.42641836100006],
              [119.80396569100003, 11.43162669500009],
              [119.79542076900009, 11.433010158000059],
              [119.78907311300009, 11.420355536000045],
              [119.78207441500001, 11.411322333000044],
              [119.77084394600001, 11.406317450000074],
              [119.77003014400009, 11.410630601000037],
              [119.76368248800009, 11.41982656500005],
              [119.75513756600003, 11.428900458000044],
              [119.74732506600003, 11.433010158000059],
              [119.73609459700003, 11.43740469000005],
              [119.73023522200003, 11.456447658000059],
              [119.71615644600001, 11.460353908000059],
              [119.72868899800005, 11.478013414000088],
              [119.74138431100005, 11.46906159100007],
              [119.75513756600003, 11.450832424000055],
              [119.77084394600001, 11.44041575700004],
              [119.78101647200003, 11.447699286000045],
              [119.78419030000009, 11.464789130000042],
              [119.78516686300009, 11.49445221600007],
              [119.79273522200003, 11.484808661000045],
              [119.80298912900003, 11.468003648000092],
              [119.81251061300009, 11.460353908000059],
              [119.81788170700008, 11.470038153000075],
              [119.82357832100001, 11.47256094000005],
              [119.82886803500003, 11.468898830000057],
              [119.83285566500001, 11.460353908000059],
              [119.84009850400003, 11.47565338700008],
              [119.84449303500003, 11.490668036000045],
              [119.84148196700005, 11.50259023600006],
              [119.82601972700002, 11.508734442000048],
              [119.83725019600001, 11.51561107000009],
              [119.84839928500003, 11.520656643000052],
              [119.85840905000009, 11.521429755000042],
              [119.86719811300009, 11.515570380000042],
            ],
          ],
          [
            [
              [125.27393639400009, 10.323187567000048],
              [125.27588951900009, 10.300360419000071],
              [125.27328535200002, 10.27798086100006],
              [125.26002037900003, 10.261053778000075],
              [125.22925866000003, 10.254339911000045],
              [125.15935306100005, 10.281805731000077],
              [125.14087975400003, 10.278794664000088],
              [125.13404381600003, 10.257961330000057],
              [125.13672936300009, 10.228583075000074],
              [125.14405358200008, 10.200995184000078],
              [125.15105228000004, 10.18545156500005],
              [125.11703535200002, 10.19749583500004],
              [125.08855228000004, 10.228989976000037],
              [125.06885826900009, 10.267238674000055],
              [125.06169681100005, 10.299302476000037],
              [125.04664147200003, 10.31932200700004],
              [125.04493248800009, 10.323187567000048],
              [125.04151451900009, 10.328599351000037],
              [125.04175866000003, 10.364203192000048],
              [125.03003991000003, 10.375392971000053],
              [125.01042728000004, 10.38304271000004],
              [124.99097741000003, 10.381333726000037],
              [124.97974694100003, 10.364203192000048],
              [124.99301191500001, 10.334906317000048],
              [125.00017337300005, 10.199693101000037],
              [125.02426191500001, 10.136053778000075],
              [125.03060957100001, 10.093939520000049],
              [125.04224694100003, 10.049017645000049],
              [125.04175866000003, 10.028998114000046],
              [125.03174889400009, 10.02024974200009],
              [125.01531009200005, 10.02610911700009],
              [124.96216881600003, 10.067328192000048],
              [124.95923912900003, 10.072739976000037],
              [124.95411217500009, 10.086127020000049],
              [124.94206790500004, 10.09170156500005],
              [124.92823326900009, 10.093898830000057],
              [124.91773522200003, 10.097316799000055],
              [124.90211022200003, 10.113023179000038],
              [124.89389082100001, 10.12604401200008],
              [124.88282311300009, 10.134955145000049],
              [124.85962975400003, 10.138251044000071],
              [124.81519616000003, 10.13939036700009],
              [124.79517662900003, 10.143377997000073],
              [124.78044681100005, 10.151922919000071],
              [124.76579837300005, 10.185939846000053],
              [124.77198326900009, 10.225165106000077],
              [124.78565514400009, 10.26552969000005],
              [124.79411868600005, 10.30272044500009],
              [124.79224694100003, 10.325669664000088],
              [124.78484134200005, 10.352728583000044],
              [124.77100670700008, 10.37531159100007],
              [124.74976647200003, 10.38467031500005],
              [124.73894290500004, 10.395453192000048],
              [124.73560631600003, 10.420314846000053],
              [124.73682701900009, 10.447739976000037],
              [124.74398847700002, 10.493719794000071],
              [124.74634850400003, 10.501369533000059],
              [124.75147545700008, 10.509955145000049],
              [124.76482181100005, 10.525864976000037],
              [124.76734459700003, 10.532375393000052],
              [124.76856530000009, 10.577337958000044],
              [124.77230879000001, 10.597357489000046],
              [124.79810631600003, 10.659125067000048],
              [124.80095462300005, 10.678290106000077],
              [124.80054772200003, 10.72451406500005],
              [124.77881920700008, 10.821437893000052],
              [124.77361087300005, 10.830959377000056],
              [124.73812910200002, 10.861517645000049],
              [124.73267662900003, 10.86815013200004],
              [124.72836347700002, 10.886419989000046],
              [124.71802819100003, 10.905585028000075],
              [124.691742384, 10.939601955000057],
              [124.65015709700003, 10.970892645000049],
              [124.64332116000003, 10.977443752000056],
              [124.63721764400009, 10.994208075000074],
              [124.62232506600003, 11.002020575000074],
              [124.60238691500001, 11.003485419000071],
              [124.58253014400009, 11.00096263200004],
              [124.56267337300005, 10.994330145000049],
              [124.54957116000003, 10.983303127000056],
              [124.54688561300009, 10.968329169000071],
              [124.55827884200005, 10.950140692000048],
              [124.56275475400003, 10.931463934000078],
              [124.55355879000001, 10.908596096000053],
              [124.53923587300005, 10.888373114000046],
              [124.52784264400009, 10.878119208000044],
              [124.51449629000001, 10.87368398600006],
              [124.50733483200008, 10.874416408000059],
              [124.47071373800009, 10.902411200000074],
              [124.46924889400009, 10.905462958000044],
              [124.45264733200008, 10.900783596000053],
              [124.44695071700005, 10.903143622000073],
              [124.44239342500009, 10.931219794000071],
              [124.43685957100001, 10.935207424000055],
              [124.42481530000009, 10.93268463700008],
              [124.41260826900009, 10.932318427000041],
              [124.40211022200003, 10.929836330000057],
              [124.39600670700008, 10.934068101000037],
              [124.396820509, 10.953802802000041],
              [124.40162194100003, 10.966538804000038],
              [124.41488691500001, 10.984849351000037],
              [124.41797936300009, 11.00096263200004],
              [124.41537519600001, 11.019964911000045],
              [124.40821373800009, 11.028876044000071],
              [124.398773634, 11.036078192000048],
              [124.38998457100001, 11.04946523600006],
              [124.38843834700003, 11.06586334800005],
              [124.39380944100003, 11.080511786000045],
              [124.400726759, 11.092596747000073],
              [124.40650475400003, 11.108303127000056],
              [124.41578209700003, 11.12181224200009],
              [124.41797936300009, 11.128566799000055],
              [124.41675866000003, 11.13617584800005],
              [124.41163170700008, 11.148016669000071],
              [124.40430748800009, 11.210760809000078],
              [124.40430748800009, 11.302679755000042],
              [124.387054884, 11.300726630000042],
              [124.36915123800009, 11.311224677000041],
              [124.35474694100003, 11.328680731000077],
              [124.34913170700008, 11.347357489000046],
              [124.35230553500003, 11.355902411000045],
              [124.36695397200003, 11.36587148600006],
              [124.37029056100005, 11.374945380000042],
              [124.35425866000003, 11.379828192000048],
              [124.34229576900009, 11.384955145000049],
              [124.33472741000003, 11.39203522300005],
              [124.34848066500001, 11.399115302000041],
              [124.34498131600003, 11.407375393000052],
              [124.33497155000009, 11.417385158000059],
              [124.32911217500009, 11.42959219000005],
              [124.32593834700003, 11.44440338700008],
              [124.31137129000001, 11.46678294500009],
              [124.29753665500004, 11.52680084800005],
              [124.30062910200002, 11.54287344000005],
              [124.30518639400009, 11.544256903000075],
              [124.32601972700002, 11.554388739000046],
              [124.32911217500009, 11.557114976000037],
              [124.34009850400003, 11.55101146000004],
              [124.36589603000004, 11.51593659100007],
              [124.42481530000009, 11.46775950700004],
              [124.44312584700003, 11.446926174000055],
              [124.48015384200005, 11.385199286000045],
              [124.48365319100003, 11.427679755000042],
              [124.48959394600001, 11.446682033000059],
              [124.50326582100001, 11.443833726000037],
              [124.53370201900009, 11.421698309000078],
              [124.545258009, 11.409002997000073],
              [124.56967207100001, 11.346828518000052],
              [124.59424889400009, 11.319525458000044],
              [124.62989342500009, 11.304429429000038],
              [124.67798912900003, 11.302679755000042],
              [124.71338951900009, 11.31159088700008],
              [124.74439537900003, 11.328558661000045],
              [124.79411868600005, 11.371527411000045],
              [124.83277428500003, 11.424505927000041],
              [124.84571373800009, 11.433010158000059],
              [124.85466556100005, 11.430975653000075],
              [124.87484785200002, 11.422023830000057],
              [124.88689212300005, 11.419989325000074],
              [124.89063561300009, 11.422023830000057],
              [124.89014733200008, 11.430975653000075],
              [124.89372806100005, 11.433010158000059],
              [124.90015709700003, 11.430975653000075],
              [124.90333092500009, 11.426459052000041],
              [124.90430748800009, 11.422023830000057],
              [124.90398196700005, 11.419989325000074],
              [124.92969811300009, 11.421291408000059],
              [124.93816165500004, 11.419989325000074],
              [124.94800866000003, 11.41396719000005],
              [124.96973717500009, 11.395819403000075],
              [124.97632897200003, 11.39203522300005],
              [124.98414147200003, 11.381333726000037],
              [124.98218834700003, 11.357896226000037],
              [124.97559655000009, 11.334418036000045],
              [124.96631920700008, 11.318304755000042],
              [124.965179884, 11.306382554000038],
              [124.96631920700008, 11.294419664000088],
              [124.96949303500003, 11.289007880000042],
              [124.97217858200008, 11.28709544500009],
              [124.97396894600001, 11.277085679000038],
              [124.97632897200003, 11.272609768000052],
              [124.98145592500009, 11.267971096000053],
              [124.98454837300005, 11.266180731000077],
              [124.98780358200008, 11.264878648000092],
              [124.99333743600005, 11.261664130000042],
              [125.00521894600001, 11.257147528000075],
              [125.01392662900003, 11.256659247000073],
              [125.01937910200002, 11.25259023600006],
              [125.02344811300009, 11.227932033000059],
              [125.02808678500003, 11.22850169500009],
              [125.03256269600001, 11.236273505000042],
              [125.03443444100003, 11.24803294500009],
              [125.04175866000003, 11.24803294500009],
              [125.04273522200003, 11.21702708500004],
              [125.04175866000003, 11.207098700000074],
              [125.03874759200005, 11.197943427000041],
              [125.02947024800005, 11.182074286000045],
              [125.02759850400003, 11.17601146000004],
              [125.029633009, 11.164455471000053],
              [125.03956139400009, 11.14476146000004],
              [125.04175866000003, 11.13540273600006],
              [125.03980553500003, 11.103461005000042],
              [125.05445397200003, 11.010646877000056],
              [125.053070509, 10.96820709800005],
              [125.01286868600005, 10.844671942000048],
              [125.00611412900003, 10.797349351000037],
              [125.01384524800005, 10.754584052000041],
              [125.02719160200002, 10.74290599200009],
              [125.08725019600001, 10.714789130000042],
              [125.11198978000004, 10.707464911000045],
              [125.12029056100005, 10.703070380000042],
              [125.12403405000009, 10.695135809000078],
              [125.13054446700005, 10.665838934000078],
              [125.16993248800009, 10.619614976000037],
              [125.17457116000003, 10.61123281500005],
              [125.19410241000003, 10.60297272300005],
              [125.19581139400009, 10.582586981000077],
              [125.18523196700005, 10.532375393000052],
              [125.18726647200003, 10.519680080000057],
              [125.19662519600001, 10.497544664000088],
              [125.19874108200008, 10.48427969000005],
              [125.19654381600003, 10.446844794000071],
              [125.19874108200008, 10.43305084800005],
              [125.20573978000004, 10.41860586100006],
              [125.21892337300005, 10.398382880000042],
              [125.23218834700003, 10.386867580000057],
              [125.23975670700008, 10.39834219000005],
              [125.24659264400009, 10.39834219000005],
              [125.25912519600001, 10.383205471000053],
              [125.26661217500009, 10.368394273000092],
              [125.27100670700008, 10.34983958500004],
              [125.27393639400009, 10.323187567000048],
            ],
          ],
          [
            [
              [123.17042076900009, 11.48078034100007],
              [123.17481530000009, 11.467474677000041],
              [123.16928144600001, 11.453599351000037],
              [123.16114342500009, 11.438950914000088],
              [123.15674889400009, 11.423081773000092],
              [123.16089928500003, 11.394354559000078],
              [123.16041100400003, 11.380438544000071],
              [123.14942467500009, 11.361883856000077],
              [123.14926191500001, 11.356350002000056],
              [123.14771569100003, 11.352484442000048],
              [123.12916100400003, 11.349351304000038],
              [123.12566165500004, 11.344875393000052],
              [123.12476647200003, 11.338324286000045],
              [123.12208092500009, 11.330633856000077],
              [123.12387129000001, 11.329291083000044],
              [123.12208092500009, 11.302679755000042],
              [123.12134850400003, 11.301581122000073],
              [123.11589603000004, 11.282171942000048],
              [123.11353600400003, 11.26666901200008],
              [123.11589603000004, 11.230658270000049],
              [123.11890709700003, 11.221502997000073],
              [123.12598717500009, 11.21678294500009],
              [123.13306725400003, 11.210435289000088],
              [123.13624108200008, 11.196519273000092],
              [123.13135826900009, 11.18268463700008],
              [123.11133873800009, 11.168036200000074],
              [123.10824629000001, 11.15180084800005],
              [123.08562259200005, 11.162543036000045],
              [123.060883009, 11.169419664000088],
              [123.04127037900003, 11.163397528000075],
              [123.02833092500009, 11.109849351000037],
              [123.01490319100003, 11.091620184000078],
              [122.99537194100003, 11.078802802000041],
              [122.97169030000009, 11.069891669000071],
              [122.97706139400009, 11.057033596000053],
              [122.97242272200003, 11.049017645000049],
              [122.95069420700008, 11.03579336100006],
              [122.95240319100003, 11.046087958000044],
              [122.95167076900009, 11.05573151200008],
              [122.94727623800009, 11.062323309000078],
              [122.93824303500003, 11.063666083000044],
              [122.93336022200003, 11.058417059000078],
              [122.93034915500004, 11.036851304000038],
              [122.92457116000003, 11.028957424000055],
              [122.91407311300009, 11.026271877000056],
              [122.90739993600005, 11.029730536000045],
              [122.90040123800009, 11.034491278000075],
              [122.88990319100003, 11.03579336100006],
              [122.88502037900003, 11.03318919500009],
              [122.86255944100003, 11.015285549000055],
              [122.86255944100003, 11.028957424000055],
              [122.83912194100003, 11.018052476000037],
              [122.81202233200008, 10.998480536000045],
              [122.78931725400003, 10.976060289000088],
              [122.78003991000003, 10.95693594000005],
              [122.78516686300009, 10.92568594000005],
              [122.79428144600001, 10.900539455000057],
              [122.79802493600005, 10.875433661000045],
              [122.78687584700003, 10.844549872000073],
              [122.76148522200003, 10.810736395000049],
              [122.74480228000004, 10.79564036700009],
              [122.72852623800009, 10.78937409100007],
              [122.71900475400003, 10.791489976000037],
              [122.70240319100003, 10.800848700000074],
              [122.69410241000003, 10.80296458500004],
              [122.68653405000009, 10.800848700000074],
              [122.66675866000003, 10.78937409100007],
              [122.65552819100003, 10.78701406500005],
              [122.64275149800005, 10.78123607000009],
              [122.63062584700003, 10.774359442000048],
              [122.61475670700008, 10.761460679000038],
              [122.61003665500004, 10.75608958500004],
              [122.60124759200005, 10.74095286700009],
              [122.60303795700008, 10.738755601000037],
              [122.60596764400009, 10.734035549000055],
              [122.60499108200008, 10.727728583000044],
              [122.59498131600003, 10.721096096000053],
              [122.58985436300009, 10.698716539000088],
              [122.54468834700003, 10.689846096000053],
              [122.45101972700002, 10.686346747000073],
              [122.36540774800005, 10.672674872000073],
              [122.35718834700003, 10.670396226000037],
              [122.34359785200002, 10.660630601000037],
              [122.33838951900009, 10.658392645000049],
              [122.30404707100001, 10.659735419000071],
              [122.293304884, 10.658392645000049],
              [122.28239993600005, 10.654038804000038],
              [122.26856530000009, 10.642726955000057],
              [122.25928795700008, 10.637884833000044],
              [122.24854576900009, 10.637925523000092],
              [122.23755944100003, 10.641424872000073],
              [122.22657311300009, 10.642238674000055],
              [122.21452884200005, 10.634466864000046],
              [122.17359459700003, 10.60065338700008],
              [122.16195722700002, 10.59373607000009],
              [122.15202884200005, 10.592352606000077],
              [122.14161217500009, 10.59243398600006],
              [122.12891686300009, 10.59007396000004],
              [122.10181725400003, 10.56932200700004],
              [122.03956139400009, 10.466620184000078],
              [122.03321373800009, 10.46092357000009],
              [122.01579837300005, 10.445461330000057],
              [121.98210696700005, 10.430243231000077],
              [121.94971764400009, 10.433172919000071],
              [121.92969811300009, 10.466620184000078],
              [121.93246504000001, 10.508693752000056],
              [121.97217858200008, 10.582098700000074],
              [121.98487389400009, 10.62490469000005],
              [121.98487389400009, 10.647284247000073],
              [121.97803795700008, 10.710191148000092],
              [121.97185306100005, 10.725002346000053],
              [121.94410241000003, 10.753566799000055],
              [121.93702233200008, 10.77570221600007],
              [121.93970787900003, 10.79360586100006],
              [121.95411217500009, 10.82322825700004],
              [121.95997155000009, 10.853908596000053],
              [121.97803795700008, 10.905462958000044],
              [122.04509524800005, 11.017401434000078],
              [122.053070509, 11.063666083000044],
              [122.053070509, 11.233791408000059],
              [122.05062910200002, 11.254706122000073],
              [122.04428144600001, 11.277777411000045],
              [122.04175866000003, 11.300441799000055],
              [122.05005944100003, 11.32029857000009],
              [122.06137129000001, 11.339056708000044],
              [122.06609134200005, 11.360174872000073],
              [122.07357832100001, 11.477362372000073],
              [122.07593834700003, 11.482570705000057],
              [122.08082116000003, 11.487616278000075],
              [122.08570397200003, 11.494574286000045],
              [122.10718834700003, 11.657945054000038],
              [122.10157311300009, 11.69367096600007],
              [122.08448326900009, 11.724676825000074],
              [122.06023196700005, 11.733710028000075],
              [122.02906334700003, 11.73468659100007],
              [121.99170983200008, 11.741441148000092],
              [121.95785566500001, 11.755357164000088],
              [121.94117272200003, 11.76007721600007],
              [121.91968834700003, 11.76194896000004],
              [121.88217207100001, 11.76072825700004],
              [121.86475670700008, 11.762640692000048],
              [121.853851759, 11.76943594000005],
              [121.85442142000011, 11.771836656000062],
              [121.85613040500004, 11.779771226000037],
              [121.86622155000009, 11.793443101000037],
              [121.87810306100005, 11.80532461100006],
              [121.88526451900009, 11.810370184000078],
              [121.889008009, 11.819281317000048],
              [121.89144941500001, 11.839260158000059],
              [121.89177493600005, 11.859930731000077],
              [121.88868248800009, 11.871242580000057],
              [121.89185631600003, 11.885239976000037],
              [121.896820509, 11.893784898000092],
              [121.90552819100003, 11.898016669000071],
              [121.91968834700003, 11.899115302000041],
              [121.92652428500003, 11.90338776200008],
              [121.93970787900003, 11.92218659100007],
              [121.94662519600001, 11.926459052000041],
              [121.95337975400003, 11.927801825000074],
              [121.95899498800009, 11.933172919000071],
              [121.96371504000001, 11.93390534100007],
              [121.97217858200008, 11.930365302000041],
              [121.97730553500003, 11.924017645000049],
              [121.98096764400009, 11.917466539000088],
              [121.98487389400009, 11.913397528000075],
              [122.02003014400009, 11.903143622000073],
              [122.03028405000009, 11.896307684000078],
              [122.05323326900009, 11.866685289000088],
              [122.072601759, 11.849310614000046],
              [122.09441165500004, 11.834662177000041],
              [122.11793053500003, 11.823553778000075],
              [122.22868899800005, 11.799750067000048],
              [122.26539147200003, 11.785549221000053],
              [122.30014082100001, 11.76194896000004],
              [122.32211347700002, 11.742254950000074],
              [122.33611087300005, 11.73663971600007],
              [122.37720787900003, 11.733221747000073],
              [122.38795006600003, 11.727443752000056],
              [122.42798912900003, 11.668768622000073],
              [122.44076582100001, 11.657456773000092],
              [122.45411217500009, 11.652736721000053],
              [122.46534264400009, 11.64524974200009],
              [122.51246178500003, 11.598089911000045],
              [122.57227623800009, 11.57493724200009],
              [122.58814537900003, 11.563381252000056],
              [122.5922143890001, 11.554266669000071],
              [122.59473717500009, 11.548570054000038],
              [122.59750410200002, 11.531805731000077],
              [122.60417728000004, 11.517075914000088],
              [122.62232506600003, 11.508734442000048],
              [122.62842858200008, 11.51040273600006],
              [122.64128665500004, 11.520086981000077],
              [122.65447024800005, 11.526068427000041],
              [122.65430748800009, 11.534409898000092],
              [122.65088951900009, 11.54360586100006],
              [122.64966881600003, 11.549709377000056],
              [122.65414472700002, 11.565985419000071],
              [122.66041100400003, 11.568752346000053],
              [122.67359459700003, 11.560248114000046],
              [122.68604576900009, 11.545843817000048],
              [122.69263756600003, 11.542466539000088],
              [122.70427493600005, 11.54287344000005],
              [122.69410241000003, 11.55532461100006],
              [122.695648634, 11.561346747000073],
              [122.70313561300009, 11.565008856000077],
              [122.71111087300005, 11.57021719000005],
              [122.730804884, 11.592230536000045],
              [122.73340905000009, 11.601304429000038],
              [122.73031660200002, 11.604437567000048],
              [122.72803795700008, 11.607855536000045],
              [122.72478274800005, 11.611761786000045],
              [122.75538170700008, 11.613836981000077],
              [122.79395592500009, 11.61229075700004],
              [122.83033287900003, 11.605292059000078],
              [122.85499108200008, 11.59125397300005],
              [122.86345462300005, 11.57615794500009],
              [122.86866295700008, 11.56045156500005],
              [122.87484785200002, 11.54791901200008],
              [122.88640384200005, 11.54287344000005],
              [122.90015709700003, 11.540676174000055],
              [122.94450931100005, 11.522406317000048],
              [122.89429772200003, 11.487209377000056],
              [122.87582441500001, 11.465643622000073],
              [122.87614993600005, 11.44725169500009],
              [122.900726759, 11.437933661000045],
              [122.92774498800009, 11.451117255000042],
              [122.955414259, 11.47068919500009],
              [122.98170006600003, 11.48078034100007],
              [123.00806725400003, 11.48729075700004],
              [123.04420006600003, 11.51585521000004],
              [123.08961022200003, 11.529689846000053],
              [123.11784915500004, 11.548163153000075],
              [123.14234459700003, 11.572699286000045],
              [123.15674889400009, 11.598089911000045],
              [123.16358483200008, 11.598089911000045],
              [123.164398634, 11.537990627000056],
              [123.15674889400009, 11.522406317000048],
              [123.14909915500004, 11.519354559000078],
              [123.13786868600005, 11.518011786000045],
              [123.127289259, 11.515448309000078],
              [123.12208092500009, 11.508734442000048],
              [123.12322024800005, 11.498724677000041],
              [123.129242384, 11.493801174000055],
              [123.13884524800005, 11.492743231000077],
              [123.14991295700008, 11.49445221600007],
              [123.14039147200003, 11.479315497000073],
              [123.14812259200005, 11.476955471000053],
              [123.17042076900009, 11.48078034100007],
            ],
          ],
          [
            [
              [120.02475019600001, 11.892971096000053],
              [120.05258222700002, 11.871242580000057],
              [120.07325280000009, 11.865301825000074],
              [120.08326256600003, 11.86041901200008],
              [120.076508009, 11.85814036700009],
              [120.05005944100003, 11.854315497000073],
              [120.04859459700003, 11.844427802000041],
              [120.05176842500009, 11.831000067000048],
              [120.03907311300009, 11.816595770000049],
              [120.03907311300009, 11.810370184000078],
              [120.04297936300009, 11.808986721000053],
              [120.05258222700002, 11.803615627000056],
              [120.05258222700002, 11.810370184000078],
              [120.06218509200005, 11.806301174000055],
              [120.06999759200005, 11.80109284100007],
              [120.07593834700003, 11.79523346600007],
              [120.07992597700002, 11.789252020000049],
              [120.06006920700008, 11.76748281500005],
              [120.05258222700002, 11.76194896000004],
              [120.06706790500004, 11.741766669000071],
              [120.04704837300005, 11.708929755000042],
              [120.01417076900009, 11.682114976000037],
              [119.98438561300009, 11.680080471000053],
              [119.96697024800005, 11.66437409100007],
              [119.95460045700008, 11.680121161000045],
              [119.95020592500009, 11.709377346000053],
              [119.95639082100001, 11.73468659100007],
              [119.96989993600005, 11.725531317000048],
              [119.97396894600001, 11.720770575000074],
              [119.97706139400009, 11.714178778000075],
              [119.98438561300009, 11.714178778000075],
              [119.98259524800005, 11.728583075000074],
              [119.98096764400009, 11.734198309000078],
              [119.97706139400009, 11.741441148000092],
              [119.99048912900003, 11.754787502000056],
              [120.00114993600005, 11.76862213700008],
              [120.00489342500009, 11.782538153000075],
              [119.99805748800009, 11.796087958000044],
              [119.99024498800009, 11.790269273000092],
              [119.98511803500003, 11.789740302000041],
              [119.97706139400009, 11.796087958000044],
              [119.97169030000009, 11.774807033000059],
              [119.95923912900003, 11.76585521000004],
              [119.943695509, 11.76703522300005],
              [119.92920983200008, 11.775580145000049],
              [119.92115319100003, 11.788316148000092],
              [119.91187584700003, 11.81639232000009],
              [119.90186608200008, 11.824042059000078],
              [119.90748131600003, 11.827948309000078],
              [119.91618899800005, 11.835191148000092],
              [119.92237389400009, 11.837713934000078],
              [119.91187584700003, 11.853949286000045],
              [119.88607832100001, 11.878648179000038],
              [119.87452233200008, 11.892971096000053],
              [119.86801191500001, 11.90656159100007],
              [119.85401451900009, 11.954413153000075],
              [119.86231530000009, 11.952704169000071],
              [119.86719811300009, 11.949693101000037],
              [119.87240644600001, 11.947333075000074],
              [119.88070722700002, 11.94757721600007],
              [119.87916100400003, 11.945868231000077],
              [119.88233483200008, 11.94334544500009],
              [119.88746178500003, 11.941107489000046],
              [119.89161217500009, 11.940130927000041],
              [119.89478600400003, 11.942328192000048],
              [119.89576256600003, 11.94725169500009],
              [119.89478600400003, 11.95213450700004],
              [119.89161217500009, 11.954413153000075],
              [119.89283287900003, 11.962591864000046],
              [119.90479576900009, 11.97687409100007],
              [119.91968834700003, 11.98151276200008],
              [119.92920983200008, 11.96116771000004],
              [119.96387780000009, 11.940130927000041],
              [119.959320509, 11.92999909100007],
              [119.97706139400009, 11.926174221000053],
              [120.02165774800005, 11.926459052000041],
              [120.03142337300005, 11.92446523600006],
              [120.03199303500003, 11.91990794500009],
              [120.02588951900009, 11.91547272300005],
              [120.00310306100005, 11.91006094000005],
              [120.00806725400003, 11.902736721000053],
              [120.01921634200005, 11.89557526200008],
              [120.02475019600001, 11.892971096000053],
            ],
          ],
          [
            [
              [120.34750410200002, 12.029486395000049],
              [120.35287519600001, 12.016180731000077],
              [120.34913170700008, 12.007025458000044],
              [120.33952884200005, 12.000555731000077],
              [120.32642662900003, 11.995306708000044],
              [120.31275475400003, 11.992010809000078],
              [120.30616295700008, 11.993963934000078],
              [120.30128014400009, 11.998480536000045],
              [120.29224694100003, 12.002834377000056],
              [120.27491295700008, 12.003404039000088],
              [120.26286868600005, 11.997748114000046],
              [120.25180097700002, 11.99087148600006],
              [120.23764082100001, 11.987941799000055],
              [120.22437584700003, 11.993068752000056],
              [120.21338951900009, 12.00226471600007],
              [120.20240319100003, 12.008002020000049],
              [120.18921959700003, 12.002834377000056],
              [120.18702233200008, 12.018255927000041],
              [120.17457116000003, 12.022691148000092],
              [120.15748131600003, 12.023911851000037],
              [120.14210045700008, 12.029486395000049],
              [120.13461347700002, 12.022040106000077],
              [120.14136803500003, 12.00967031500005],
              [120.14063561300009, 11.999253648000092],
              [120.13689212300005, 11.988470770000049],
              [120.13461347700002, 11.97483958500004],
              [120.12598717500009, 11.979396877000056],
              [120.12134850400003, 11.979396877000056],
              [120.11833743600005, 11.975287177000041],
              [120.11410566500001, 11.96743398600006],
              [120.10792076900009, 11.96743398600006],
              [120.09351647200003, 11.99437083500004],
              [120.08228600400003, 12.001532294000071],
              [120.03907311300009, 11.995306708000044],
              [120.02149498800009, 11.999823309000078],
              [120.00114993600005, 12.01117584800005],
              [119.98406009200005, 12.02570221600007],
              [119.97055097700002, 12.054754950000074],
              [119.94239342500009, 12.087144273000092],
              [119.935883009, 12.108303127000056],
              [119.93580162900003, 12.12303294500009],
              [119.93409264400009, 12.134833075000074],
              [119.92896569100003, 12.145331122000073],
              [119.91863040500004, 12.156073309000078],
              [119.91236412900003, 12.166896877000056],
              [119.91041100400003, 12.180568752000056],
              [119.90650475400003, 12.194891669000071],
              [119.89503014400009, 12.20766836100006],
              [119.88347415500004, 12.198919989000046],
              [119.87305748800009, 12.18740469000005],
              [119.86500084700003, 12.17381419500009],
              [119.86036217500009, 12.15916575700004],
              [119.84766686300009, 12.16673411700009],
              [119.85035241000003, 12.17446523600006],
              [119.85962975400003, 12.183254299000055],
              [119.86719811300009, 12.19399648600006],
              [119.86963951900009, 12.206610419000071],
              [119.86931399800005, 12.21670156500005],
              [119.86719811300009, 12.231838283000059],
              [119.87232506600003, 12.251695054000038],
              [119.88550866000003, 12.259507554000038],
              [119.90349368600005, 12.264593817000048],
              [119.92237389400009, 12.276516018000052],
              [119.89763431100005, 12.277044989000046],
              [119.88754316500001, 12.275051174000055],
              [119.88070722700002, 12.269029039000088],
              [119.87794030000009, 12.308091539000088],
              [119.88502037900003, 12.322699286000045],
              [119.90870201900009, 12.32367584800005],
              [119.92693118600005, 12.316473700000074],
              [119.93344160200002, 12.30109284100007],
              [119.93458092500009, 12.28514232000009],
              [119.935883009, 12.276516018000052],
              [119.95020592500009, 12.271551825000074],
              [119.98902428500003, 12.267157294000071],
              [120.00489342500009, 12.262884833000044],
              [120.02149498800009, 12.253119208000044],
              [120.04883873800009, 12.231146552000041],
              [120.07276451900009, 12.20604075700004],
              [120.07992597700002, 12.200832424000055],
              [120.08814537900003, 12.19822825700004],
              [120.10531660200002, 12.197658596000053],
              [120.11410566500001, 12.19399648600006],
              [120.10368899800005, 12.191473700000074],
              [120.09685306100005, 12.186021226000037],
              [120.09351647200003, 12.17772044500009],
              [120.09424889400009, 12.16665273600006],
              [120.11695397200003, 12.166449286000045],
              [120.17017662900003, 12.125433661000045],
              [120.19605553500003, 12.112005927000041],
              [120.19841556100005, 12.122788804000038],
              [120.20435631600003, 12.12836334800005],
              [120.21314537900003, 12.129095770000049],
              [120.22396894600001, 12.125677802000041],
              [120.22413170700008, 12.219183661000045],
              [120.22974694100003, 12.21865469000005],
              [120.24390709700003, 12.200832424000055],
              [120.25074303500003, 12.185492255000042],
              [120.25277754000001, 12.169623114000046],
              [120.25196373800009, 12.14248281500005],
              [120.25831139400009, 12.131781317000048],
              [120.27247155000009, 12.134711005000042],
              [120.28638756600003, 12.135443427000041],
              [120.29224694100003, 12.11823151200008],
              [120.29590905000009, 12.12018463700008],
              [120.29704837300005, 12.12010325700004],
              [120.29753665500004, 12.12099844000005],
              [120.29908287900003, 12.125677802000041],
              [120.32911217500009, 12.097479559000078],
              [120.342133009, 12.080755927000041],
              [120.34750410200002, 12.067328192000048],
              [120.34489993600005, 12.053290106000077],
              [120.33790123800009, 12.048488674000055],
              [120.32886803500003, 12.045355536000045],
              [120.31959069100003, 12.036322333000044],
              [120.31519616000003, 12.023179429000038],
              [120.31959069100003, 12.01788971600007],
              [120.32740319100003, 12.020086981000077],
              [120.33383222700002, 12.029486395000049],
              [120.33838951900009, 12.02928294500009],
              [120.33936608200008, 12.028143622000073],
              [120.33920332100001, 12.025824286000045],
              [120.34009850400003, 12.022040106000077],
              [120.34750410200002, 12.029486395000049],
            ],
          ],
          [
            [
              [122.68751061300009, 12.402818101000037],
              [122.68677819100003, 12.38898346600007],
              [122.67017662900003, 12.317531643000052],
              [122.65919030000009, 12.30540599200009],
              [122.64283287900003, 12.291937567000048],
              [122.625336134, 12.280991929000038],
              [122.61182701900009, 12.276516018000052],
              [122.60718834700003, 12.279445705000057],
              [122.59156334700003, 12.300116278000075],
              [122.58301842500009, 12.30565013200004],
              [122.56251061300009, 12.311102606000077],
              [122.55347741000003, 12.317531643000052],
              [122.52881920700008, 12.35846588700008],
              [122.51197350400003, 12.377630927000041],
              [122.48829186300009, 12.38572825700004],
              [122.46509850400003, 12.38857656500005],
              [122.44605553500003, 12.396673895000049],
              [122.43189537900003, 12.409735419000071],
              [122.42310631600003, 12.427394924000055],
              [122.42302493600005, 12.46287669500009],
              [122.44459069100003, 12.483710028000075],
              [122.48113040500004, 12.493353583000044],
              [122.59424889400009, 12.492621161000045],
              [122.63209069100003, 12.484523830000057],
              [122.64372806100005, 12.47947825700004],
              [122.64918053500003, 12.473211981000077],
              [122.65544681100005, 12.452460028000075],
              [122.66138756600003, 12.43935781500005],
              [122.66920006600003, 12.426214911000045],
              [122.68751061300009, 12.402818101000037],
            ],
          ],
          [
            [
              [125.71273847700002, 11.14874909100007],
              [125.72901451900009, 11.117377020000049],
              [125.76026451900009, 11.08462148600006],
              [125.779633009, 11.052394924000055],
              [125.76050866000003, 11.022772528000075],
              [125.75220787900003, 11.030422268000052],
              [125.72877037900003, 11.042792059000078],
              [125.71957441500001, 11.04946523600006],
              [125.71070397200003, 11.082831122000073],
              [125.70875084700003, 11.085760809000078],
              [125.70720462300005, 11.088568427000041],
              [125.70655358200008, 11.094142971000053],
              [125.70704186300009, 11.112005927000041],
              [125.70606530000009, 11.116766669000071],
              [125.70004316500001, 11.117865302000041],
              [125.68531334700003, 11.125148830000057],
              [125.68100019600001, 11.12986888200004],
              [125.66667728000004, 11.14166901200008],
              [125.65154056100005, 11.14940013200004],
              [125.64437910200002, 11.142238674000055],
              [125.61036217500009, 11.122015692000048],
              [125.60010826900009, 11.118312893000052],
              [125.58806399800005, 11.122259833000044],
              [125.58383222700002, 11.131740627000056],
              [125.58155358200008, 11.142767645000049],
              [125.57545006600003, 11.15180084800005],
              [125.56381269600001, 11.156805731000077],
              [125.55713951900009, 11.154038804000038],
              [125.55014082100001, 11.148627020000049],
              [125.53834069100003, 11.145656643000052],
              [125.53598066500001, 11.13812897300005],
              [125.53109785200002, 11.10228099200009],
              [125.52784264400009, 11.090399481000077],
              [125.50082441500001, 11.115057684000078],
              [125.48243248800009, 11.127630927000041],
              [125.46973717500009, 11.128566799000055],
              [125.45093834700003, 11.106675523000092],
              [125.44019616000003, 11.09756094000005],
              [125.42465254000001, 11.090399481000077],
              [125.42400149800005, 11.10651276200008],
              [125.41651451900009, 11.116603908000059],
              [125.40626061300009, 11.117132880000042],
              [125.39747155000009, 11.104681708000044],
              [125.37378991000003, 11.12596263200004],
              [125.36329186300009, 11.131984768000052],
              [125.32715905000009, 11.137518622000073],
              [125.32162519600001, 11.142238674000055],
              [125.31706790500004, 11.149562893000052],
              [125.30600019600001, 11.14744700700004],
              [125.275726759, 11.135646877000056],
              [125.27051842500009, 11.128078518000052],
              [125.26612389400009, 11.118882554000038],
              [125.25456790500004, 11.101996161000045],
              [125.25196373800009, 11.094671942000048],
              [125.24683678500003, 11.092189846000053],
              [125.24138431100005, 11.09438711100006],
              [125.23292076900009, 11.097845770000049],
              [125.22543379000001, 11.105536200000074],
              [125.21892337300005, 11.118068752000056],
              [125.21412194100003, 11.131537177000041],
              [125.20866946700005, 11.185044664000088],
              [125.19874108200008, 11.22752513200004],
              [125.17237389400009, 11.265204169000071],
              [125.13282311300009, 11.282131252000056],
              [125.08708743600005, 11.285345770000049],
              [125.04175866000003, 11.282171942000048],
              [125.00098717500009, 11.28978099200009],
              [124.99170983200008, 11.318019924000055],
              [125.00017337300005, 11.398871161000045],
              [124.99984785200002, 11.407131252000056],
              [125.00074303500003, 11.413723049000055],
              [125.00294030000009, 11.419745184000078],
              [125.00700931100005, 11.426174221000053],
              [124.99927819100003, 11.43032461100006],
              [124.97974694100003, 11.44725169500009],
              [124.97242272200003, 11.450140692000048],
              [124.95834394600001, 11.451361395000049],
              [124.95183353000004, 11.453517971000053],
              [124.93799889400009, 11.46279531500005],
              [124.92644290500004, 11.473944403000075],
              [124.91732832100001, 11.48704661700009],
              [124.91146894600001, 11.501898505000042],
              [124.89649498800009, 11.470119533000059],
              [124.88746178500003, 11.465521552000041],
              [124.86988366000003, 11.46775950700004],
              [124.85613040500004, 11.473049221000053],
              [124.84506269600001, 11.481756903000075],
              [124.83619225400003, 11.493638414000088],
              [124.82829837300005, 11.508734442000048],
              [124.84376061300009, 11.515773830000057],
              [124.85238691500001, 11.524969794000071],
              [124.85954837300005, 11.53461334800005],
              [124.86988366000003, 11.54287344000005],
              [124.88640384200005, 11.54718659100007],
              [124.90007571700005, 11.548773505000042],
              [124.90365644600001, 11.554266669000071],
              [124.89031009200005, 11.57021719000005],
              [124.94874108200008, 11.57021719000005],
              [124.96143639400009, 11.576971747000073],
              [124.97779381600003, 11.59275950700004],
              [124.99244225400003, 11.611029364000046],
              [125.00017337300005, 11.624823309000078],
              [124.99952233200008, 11.640285549000055],
              [124.99439537900003, 11.655666408000059],
              [124.99122155000009, 11.670314846000053],
              [124.99675540500004, 11.683417059000078],
              [125.01840254000001, 11.706366278000075],
              [125.03443444100003, 11.727850653000075],
              [125.039398634, 11.72296784100007],
              [125.05543053500003, 11.714178778000075],
              [125.05420983200008, 11.738226630000042],
              [125.04371178500003, 11.757757880000042],
              [125.02637780000009, 11.770900783000059],
              [125.00359134200005, 11.775580145000049],
              [124.986664259, 11.77024974200009],
              [124.94532311300009, 11.74681224200009],
              [124.92823326900009, 11.741441148000092],
              [124.89242597700002, 11.761460679000038],
              [124.83350670700008, 11.845363674000055],
              [124.79411868600005, 11.85814036700009],
              [124.79411868600005, 11.864976304000038],
              [124.80103600400003, 11.864569403000075],
              [124.80787194100003, 11.864976304000038],
              [124.79818769600001, 11.869818427000041],
              [124.79411868600005, 11.871242580000057],
              [124.80787194100003, 11.899115302000041],
              [124.81267337300005, 11.896144924000055],
              [124.81755618600005, 11.893947658000059],
              [124.82276451900009, 11.89093659100007],
              [124.82829837300005, 11.885443427000041],
              [124.82398522200003, 11.905829169000071],
              [124.80982506600003, 11.915676174000055],
              [124.79493248800009, 11.916449286000045],
              [124.77857506600003, 11.89915599200009],
              [124.76107832100001, 11.901312567000048],
              [124.75196373800009, 11.910305080000057],
              [124.76734459700003, 11.92023346600007],
              [124.762054884, 11.929022528000075],
              [124.75570722700002, 11.933294989000046],
              [124.74822024800005, 11.932562567000048],
              [124.73951256600003, 11.926459052000041],
              [124.73747806100005, 11.953314520000049],
              [124.73422285200002, 11.96820709800005],
              [124.72925866000003, 11.97797272300005],
              [124.67986087300005, 12.029730536000045],
              [124.64014733200008, 12.045355536000045],
              [124.60043379000001, 12.054632880000042],
              [124.56934655000009, 12.050848700000074],
              [124.54037519600001, 12.065741278000075],
              [124.49317467500009, 12.097805080000057],
              [124.44646243600005, 12.15306224200009],
              [124.42481530000009, 12.17283763200004],
              [124.42750084700003, 12.175034898000092],
              [124.42823326900009, 12.175848700000074],
              [124.43091881600003, 12.18032461100006],
              [124.40723717500009, 12.193793036000045],
              [124.39079837300005, 12.221869208000044],
              [124.342133009, 12.38572825700004],
              [124.27621504000001, 12.533270575000074],
              [124.27393639400009, 12.546820380000042],
              [124.27662194100003, 12.558539130000042],
              [124.28345787900003, 12.57062409100007],
              [124.29346764400009, 12.57998281500005],
              [124.305023634, 12.58299388200004],
              [124.31275475400003, 12.579494533000059],
              [124.35840905000009, 12.54490794500009],
              [124.36304772200003, 12.54360586100006],
              [124.37330162900003, 12.543402411000045],
              [124.39861087300005, 12.55491771000004],
              [124.40748131600003, 12.557074286000045],
              [124.41325931100005, 12.555243231000077],
              [124.43848717500009, 12.543402411000045],
              [124.45427493600005, 12.538397528000075],
              [124.51734459700003, 12.537258205000057],
              [124.52149498800009, 12.53579336100006],
              [124.53248131600003, 12.528794664000088],
              [124.53467858200008, 12.526312567000048],
              [124.53679446700005, 12.52252838700008],
              [124.54151451900009, 12.52415599200009],
              [124.54712975400003, 12.527777411000045],
              [124.55144290500004, 12.529730536000045],
              [124.57447350400003, 12.527533270000049],
              [124.59620201900009, 12.522935289000088],
              [124.67920983200008, 12.51593659100007],
              [124.86793053500003, 12.53034088700008],
              [124.87720787900003, 12.533392645000049],
              [124.88689212300005, 12.540350653000075],
              [124.89551842500009, 12.554266669000071],
              [124.88990319100003, 12.563625393000052],
              [124.88021894600001, 12.572211005000042],
              [124.87671959700003, 12.583726304000038],
              [124.87671959700003, 12.59125397300005],
              [124.89478600400003, 12.585435289000088],
              [124.90821373800009, 12.573716539000088],
              [124.91895592500009, 12.562241929000038],
              [124.92823326900009, 12.557074286000045],
              [124.94141686300009, 12.562974351000037],
              [124.95850670700008, 12.57322825700004],
              [124.97339928500003, 12.576320705000057],
              [124.97974694100003, 12.56077708500004],
              [124.98951256600003, 12.561997789000088],
              [125.01042728000004, 12.553412177000041],
              [125.02857506600003, 12.542547919000071],
              [125.03101647200003, 12.537258205000057],
              [125.03687584700003, 12.535549221000053],
              [125.04224694100003, 12.532131252000056],
              [125.04957116000003, 12.529364325000074],
              [125.06169681100005, 12.529730536000045],
              [125.06983483200008, 12.533026434000078],
              [125.08139082100001, 12.53969961100006],
              [125.09180748800009, 12.547349351000037],
              [125.09644616000003, 12.553656317000048],
              [125.09978274800005, 12.574652411000045],
              [125.10914147200003, 12.579291083000044],
              [125.13746178500003, 12.570746161000045],
              [125.14722741000003, 12.571966864000046],
              [125.15699303500003, 12.575995184000078],
              [125.16627037900003, 12.57811107000009],
              [125.17457116000003, 12.574164130000042],
              [125.19874108200008, 12.55023834800005],
              [125.248383009, 12.519476630000042],
              [125.27214603000004, 12.49900950700004],
              [125.27393639400009, 12.482001044000071],
              [125.28484134200005, 12.470445054000038],
              [125.30616295700008, 12.458319403000075],
              [125.314789259, 12.447211005000042],
              [125.32634524800005, 12.42133209800005],
              [125.33366946700005, 12.412665106000077],
              [125.34961998800009, 12.39940013200004],
              [125.33090254000001, 12.38890208500004],
              [125.312836134, 12.366685289000088],
              [125.30787194100003, 12.341864325000074],
              [125.32911217500009, 12.32367584800005],
              [125.32227623800009, 12.31932200700004],
              [125.31853274800005, 12.313666083000044],
              [125.31600996200007, 12.302069403000075],
              [125.314789259, 12.296372789000088],
              [125.34555097700002, 12.313706773000092],
              [125.35645592500009, 12.317531643000052],
              [125.35466556100005, 12.307928778000075],
              [125.35482832100001, 12.301336981000077],
              [125.35417728000004, 12.29588450700004],
              [125.34961998800009, 12.289536851000037],
              [125.36068769600001, 12.28514232000009],
              [125.37045332100001, 12.28896719000005],
              [125.39063561300009, 12.303859768000052],
              [125.38445071700005, 12.284979559000078],
              [125.39421634200005, 12.280503648000092],
              [125.43213951900009, 12.282700914000088],
              [125.45069420700008, 12.273627020000049],
              [125.48601321700005, 12.247381903000075],
              [125.50049889400009, 12.248602606000077],
              [125.50603274800005, 12.23773834800005],
              [125.52784264400009, 12.211004950000074],
              [125.53825931100005, 12.18349844000005],
              [125.53760826900009, 12.172430731000077],
              [125.52100670700008, 12.18032461100006],
              [125.51295006600003, 12.17446523600006],
              [125.48926842500009, 12.17023346600007],
              [125.47934004000001, 12.16665273600006],
              [125.48845462300005, 12.163031317000048],
              [125.49545332100001, 12.15884023600006],
              [125.50147545700008, 12.15338776200008],
              [125.50733483200008, 12.146185614000046],
              [125.47974694100003, 12.139837958000044],
              [125.467133009, 12.134914455000057],
              [125.45948326900009, 12.125677802000041],
              [125.457367384, 12.107082424000055],
              [125.46794681100005, 12.101996161000045],
              [125.50049889400009, 12.10455963700008],
              [125.49830162900003, 12.101304429000038],
              [125.49561608200008, 12.094224351000037],
              [125.49366295700008, 12.090969143000052],
              [125.50269616000003, 12.083685614000046],
              [125.51563561300009, 12.070868231000077],
              [125.52515709700003, 12.05695221600007],
              [125.52442467500009, 12.046210028000075],
              [125.49048912900003, 12.018947658000059],
              [125.48226972700002, 12.00853099200009],
              [125.46998131600003, 11.986761786000045],
              [125.45199629000001, 11.964056708000044],
              [125.44581139400009, 11.947333075000074],
              [125.44385826900009, 11.927883205000057],
              [125.44516035200002, 11.905951239000046],
              [125.44703209700003, 11.900091864000046],
              [125.45948326900009, 11.871242580000057],
              [125.45728600400003, 11.840521552000041],
              [125.45948326900009, 11.830267645000049],
              [125.46509850400003, 11.82322825700004],
              [125.49048912900003, 11.79979075700004],
              [125.49366295700008, 11.790228583000044],
              [125.49048912900003, 11.781073309000078],
              [125.48373457100001, 11.776190497000073],
              [125.45720462300005, 11.785711981000077],
              [125.44727623800009, 11.767767645000049],
              [125.45020592500009, 11.750433661000045],
              [125.46973717500009, 11.75853099200009],
              [125.48161868600005, 11.757310289000088],
              [125.49122155000009, 11.737982489000046],
              [125.50049889400009, 11.701117255000042],
              [125.49903405000009, 11.675848700000074],
              [125.48926842500009, 11.670803127000056],
              [125.47681725400003, 11.668768622000073],
              [125.46631920700008, 11.652736721000053],
              [125.47901451900009, 11.64752838700008],
              [125.47632897200003, 11.638006903000075],
              [125.46859785200002, 11.625474351000037],
              [125.46631920700008, 11.611761786000045],
              [125.47087649800005, 11.60260651200008],
              [125.47657311300009, 11.600165106000077],
              [125.48316491000003, 11.599310614000046],
              [125.49048912900003, 11.594671942000048],
              [125.49366295700008, 11.58779531500005],
              [125.49366295700008, 11.563381252000056],
              [125.49789472700002, 11.548325914000088],
              [125.50196373800009, 11.539129950000074],
              [125.52418053500003, 11.507310289000088],
              [125.53093509200005, 11.491603908000059],
              [125.53101647200003, 11.47565338700008],
              [125.52100670700008, 11.460353908000059],
              [125.52906334700003, 11.459458726000037],
              [125.53451582100001, 11.458156643000052],
              [125.54037519600001, 11.457912502000056],
              [125.54883873800009, 11.460353908000059],
              [125.55420983200008, 11.43626536700009],
              [125.55860436300009, 11.42479075700004],
              [125.56592858200008, 11.419989325000074],
              [125.57618248800009, 11.416693427000041],
              [125.59424889400009, 11.402167059000078],
              [125.60694420700008, 11.398871161000045],
              [125.60906009200005, 11.393133856000077],
              [125.61988366000003, 11.38108958500004],
              [125.63184655000009, 11.370306708000044],
              [125.63770592500009, 11.368475653000075],
              [125.63795006600003, 11.342352606000077],
              [125.63502037900003, 11.32648346600007],
              [125.62712649800005, 11.31354401200008],
              [125.56617272200003, 11.268133856000077],
              [125.555023634, 11.24803294500009],
              [125.555023634, 11.211859442000048],
              [125.57178795700008, 11.192572333000044],
              [125.59913170700008, 11.189113674000055],
              [125.63086998800009, 11.20026276200008],
              [125.61605879000001, 11.218939520000049],
              [125.61573326900009, 11.233872789000088],
              [125.62891686300009, 11.23631419500009],
              [125.67497806100005, 11.203070380000042],
              [125.69361412900003, 11.192572333000044],
              [125.707367384, 11.177435614000046],
              [125.71273847700002, 11.14874909100007],
            ],
          ],
          [
            [
              [124.05494225400003, 11.79979075700004],
              [124.05909264400009, 11.78392161700009],
              [124.06714928500003, 11.764105536000045],
              [124.07252037900003, 11.744086005000042],
              [124.06853274800005, 11.727850653000075],
              [124.05486087300005, 11.72557200700004],
              [124.04151451900009, 11.742987372000073],
              [124.02076256600003, 11.78310781500005],
              [124.00798587300005, 11.796698309000078],
              [123.97437584700003, 11.82493724200009],
              [123.945648634, 11.835679429000038],
              [123.92408287900003, 11.859564520000049],
              [123.89031009200005, 11.870794989000046],
              [123.87517337300005, 11.884507554000038],
              [123.85564212300005, 11.913397528000075],
              [123.84253991000003, 11.90615469000005],
              [123.82439212300005, 11.91006094000005],
              [123.78736412900003, 11.926459052000041],
              [123.764008009, 11.915676174000055],
              [123.74293053500003, 11.926947333000044],
              [123.72510826900009, 11.944891669000071],
              [123.71168053500003, 11.954413153000075],
              [123.71607506600003, 11.966742255000042],
              [123.72242272200003, 11.975816148000092],
              [123.73194420700008, 11.980902411000045],
              [123.74577884200005, 11.98110586100006],
              [123.73267662900003, 12.008368231000077],
              [123.726898634, 11.999335028000075],
              [123.72535241000003, 11.995306708000044],
              [123.719086134, 11.995306708000044],
              [123.71062259200005, 12.007391669000071],
              [123.69849694100003, 12.020819403000075],
              [123.68539472700002, 12.031805731000077],
              [123.65943444100003, 12.04295482000009],
              [123.650726759, 12.05695221600007],
              [123.65300540500004, 12.069281317000048],
              [123.67066491000003, 12.07103099200009],
              [123.64893639400009, 12.07758209800005],
              [123.62907962300005, 12.075873114000046],
              [123.61475670700008, 12.079331773000092],
              [123.603851759, 12.118719794000071],
              [123.59099368600005, 12.13548411700009],
              [123.56080162900003, 12.16665273600006],
              [123.54639733200008, 12.188055731000077],
              [123.53972415500004, 12.19399648600006],
              [123.51075280000009, 12.206000067000048],
              [123.50310306100005, 12.211004950000074],
              [123.48536217500009, 12.218085028000075],
              [123.46159915500004, 12.215725002000056],
              [123.43864993600005, 12.208400783000059],
              [123.424164259, 12.200832424000055],
              [123.41236412900003, 12.188177802000041],
              [123.38200931100005, 12.145086981000077],
              [123.37273196700005, 12.118638414000088],
              [123.36475670700008, 12.106024481000077],
              [123.35474694100003, 12.095404364000046],
              [123.34522545700008, 12.090969143000052],
              [123.33375084700003, 12.089504299000055],
              [123.32837975400003, 12.085272528000075],
              [123.32113691500001, 12.07103099200009],
              [123.265961134, 12.007513739000046],
              [123.18140709700003, 11.930853583000044],
              [123.15967858200008, 11.917792059000078],
              [123.14991295700008, 11.930161851000037],
              [123.15186608200008, 11.950384833000044],
              [123.15699303500003, 11.974310614000046],
              [123.16472415500004, 11.99437083500004],
              [123.17383873800009, 12.002834377000056],
              [123.18523196700005, 12.005113023000092],
              [123.19011478000004, 12.011664130000042],
              [123.19109134200005, 12.021185614000046],
              [123.19092858200008, 12.032904364000046],
              [123.19320722700002, 12.04633209800005],
              [123.19898522200003, 12.056586005000042],
              [123.20557701900009, 12.066107489000046],
              [123.211273634, 12.077297268000052],
              [123.21021569100003, 12.114976304000038],
              [123.21599368600005, 12.133490302000041],
              [123.23194420700008, 12.125677802000041],
              [123.23731530000009, 12.139227606000077],
              [123.24431399800005, 12.14984772300005],
              [123.25464928500003, 12.156805731000077],
              [123.27003014400009, 12.15916575700004],
              [123.27719160200002, 12.16429271000004],
              [123.27344811300009, 12.175848700000074],
              [123.25977623800009, 12.19399648600006],
              [123.27369225400003, 12.202948309000078],
              [123.28663170700008, 12.208482164000088],
              [123.29460696700005, 12.217230536000045],
              [123.29395592500009, 12.235541083000044],
              [123.25953209700003, 12.236883856000077],
              [123.23698978000004, 12.235174872000073],
              [123.21810957100001, 12.228094794000071],
              [123.21876061300009, 12.234849351000037],
              [123.21778405000009, 12.265448309000078],
              [123.21876061300009, 12.268011786000045],
              [123.22120201900009, 12.269720770000049],
              [123.24878991000003, 12.307114976000037],
              [123.252289259, 12.32062409100007],
              [123.25562584700003, 12.350287177000041],
              [123.27019290500004, 12.400539455000057],
              [123.27344811300009, 12.423651434000078],
              [123.27149498800009, 12.43943919500009],
              [123.26563561300009, 12.447333075000074],
              [123.25586998800009, 12.453680731000077],
              [123.24244225400003, 12.464585679000038],
              [123.23194420700008, 12.580633856000077],
              [123.234711134, 12.59275950700004],
              [123.24219811300009, 12.595363674000055],
              [123.25212649800005, 12.59202708500004],
              [123.26221764400009, 12.586127020000049],
              [123.27711022200003, 12.57953522300005],
              [123.30583743600005, 12.57493724200009],
              [123.32113691500001, 12.570746161000045],
              [123.33073978000004, 12.56435781500005],
              [123.33814537900003, 12.55662669500009],
              [123.34734134200005, 12.550930080000057],
              [123.35645592500009, 12.549261786000045],
              [123.35531660200002, 12.547674872000073],
              [123.35596764400009, 12.543402411000045],
              [123.33838951900009, 12.546942450000074],
              [123.34034264400009, 12.531683661000045],
              [123.35596764400009, 12.495591539000088],
              [123.35043379000001, 12.487779039000088],
              [123.33855228000004, 12.479437567000048],
              [123.32667076900009, 12.467922268000052],
              [123.32113691500001, 12.450913804000038],
              [123.32642662900003, 12.438055731000077],
              [123.338226759, 12.44529857000009],
              [123.35596764400009, 12.468329169000071],
              [123.35865319100003, 12.469183661000045],
              [123.36890709700003, 12.46979401200008],
              [123.37281334700003, 12.471380927000041],
              [123.37476647200003, 12.475775458000044],
              [123.37452233200008, 12.485174872000073],
              [123.37582441500001, 12.488755601000037],
              [123.37378991000003, 12.489650783000059],
              [123.37916100400003, 12.501206773000092],
              [123.38648522200003, 12.512518622000073],
              [123.39014733200008, 12.512396552000041],
              [123.39763431100005, 12.519029039000088],
              [123.41472415500004, 12.52094147300005],
              [123.43409264400009, 12.51862213700008],
              [123.44809004000001, 12.512396552000041],
              [123.47982832100001, 12.481024481000077],
              [123.49561608200008, 12.468573309000078],
              [123.51295006600003, 12.460882880000042],
              [123.54712975400003, 12.460882880000042],
              [123.55241946700005, 12.456610419000071],
              [123.56421959700003, 12.440375067000048],
              [123.57227623800009, 12.431830145000049],
              [123.58139082100001, 12.41307200700004],
              [123.59343509200005, 12.394354559000078],
              [123.60922285200002, 12.38572825700004],
              [123.60922285200002, 12.37889232000009],
              [123.59750410200002, 12.377875067000048],
              [123.59009850400003, 12.372300523000092],
              [123.58716881600003, 12.363104559000078],
              [123.58814537900003, 12.35101959800005],
              [123.62191816500001, 12.368353583000044],
              [123.63697350400003, 12.370266018000052],
              [123.64332116000003, 12.354722398000092],
              [123.64771569100003, 12.34829336100006],
              [123.65756269600001, 12.34642161700009],
              [123.66895592500009, 12.346258856000077],
              [123.67750084700003, 12.34479401200008],
              [123.68824303500003, 12.33779531500005],
              [123.69678795700008, 12.329901434000078],
              [123.70435631600003, 12.320746161000045],
              [123.76734459700003, 12.214056708000044],
              [123.79363040500004, 12.187160549000055],
              [123.78842207100001, 12.231268622000073],
              [123.79493248800009, 12.246893622000073],
              [123.81812584700003, 12.231838283000059],
              [123.84880618600005, 12.200832424000055],
              [123.86264082100001, 12.202866929000038],
              [123.87354576900009, 12.210191148000092],
              [123.88233483200008, 12.21279531500005],
              [123.88965905000009, 12.200832424000055],
              [123.88965905000009, 12.20766836100006],
              [123.89942467500009, 12.18773021000004],
              [123.95191491000003, 12.10455963700008],
              [123.95826256600003, 12.10057200700004],
              [123.97315514400009, 12.095648505000042],
              [123.97917728000004, 12.090969143000052],
              [123.98324629000001, 12.08234284100007],
              [123.99284915500004, 12.049302476000037],
              [123.99830162900003, 12.039740302000041],
              [124.04029381600003, 11.988104559000078],
              [124.05030358200008, 11.971136786000045],
              [124.05494225400003, 11.954413153000075],
              [124.03842207100001, 11.964544989000046],
              [124.017914259, 11.99555084800005],
              [123.99952233200008, 12.008368231000077],
              [124.00294030000009, 11.997788804000038],
              [124.00717207100001, 11.990708726000037],
              [124.02076256600003, 11.97483958500004],
              [124.00953209700003, 11.965765692000048],
              [124.01295006600003, 11.954250393000052],
              [124.03386478000004, 11.926459052000041],
              [124.05827884200005, 11.875189520000049],
              [124.06177819100003, 11.86155833500004],
              [124.06177819100003, 11.837713934000078],
              [124.05567467500009, 11.81053294500009],
              [124.05494225400003, 11.79979075700004],
            ],
          ],
          [
            [
              [122.279633009, 12.60545482000009],
              [122.29688561300009, 12.573919989000046],
              [122.31128991000003, 12.536688544000071],
              [122.30982506600003, 12.501125393000052],
              [122.279633009, 12.47451406500005],
              [122.26368248800009, 12.49323151200008],
              [122.25464928500003, 12.51117584800005],
              [122.25114993600005, 12.529689846000053],
              [122.25171959700003, 12.55023834800005],
              [122.25074303500003, 12.554185289000088],
              [122.24822024800005, 12.559027411000045],
              [122.24586022200003, 12.564601955000057],
              [122.24561608200008, 12.570746161000045],
              [122.24822024800005, 12.575873114000046],
              [122.25570722700002, 12.57884349200009],
              [122.25928795700008, 12.583726304000038],
              [122.26587975400003, 12.604803778000075],
              [122.27100670700008, 12.613104559000078],
              [122.279633009, 12.61912669500009],
              [122.279633009, 12.60545482000009],
            ],
          ],
          [
            [
              [122.11524498800009, 12.66632721600007],
              [122.14568118600005, 12.657456773000092],
              [122.15601647200003, 12.64834219000005],
              [122.15626061300009, 12.632147528000075],
              [122.15137780000009, 12.628119208000044],
              [122.13591556100005, 12.630275783000059],
              [122.12891686300009, 12.625392971000053],
              [122.12867272200003, 12.616400458000044],
              [122.13575280000009, 12.56077708500004],
              [122.13038170700008, 12.52838776200008],
              [122.10694420700008, 12.459784247000073],
              [122.09888756600003, 12.386379299000055],
              [122.08082116000003, 12.31549713700008],
              [122.05103600400003, 12.242987372000073],
              [122.04322350400003, 12.231838283000059],
              [122.03646894600001, 12.214056708000044],
              [122.04802493600005, 12.20062897300005],
              [122.06120853000004, 12.188055731000077],
              [122.05990644600001, 12.17283763200004],
              [122.04688561300009, 12.187160549000055],
              [122.04102623800009, 12.179348049000055],
              [122.02279707100001, 12.16282786700009],
              [122.01905358200008, 12.156073309000078],
              [122.01905358200008, 12.10455963700008],
              [122.01221764400009, 12.10455963700008],
              [121.99105879000001, 12.128485419000071],
              [121.98617597700002, 12.14256419500009],
              [121.99170983200008, 12.15916575700004],
              [121.96501712300005, 12.161444403000075],
              [121.95899498800009, 12.177801825000074],
              [121.96371504000001, 12.228094794000071],
              [121.97331790500004, 12.204494533000059],
              [121.98715254000001, 12.200100002000056],
              [121.99976647200003, 12.210638739000046],
              [122.00538170700008, 12.231838283000059],
              [122.00212649800005, 12.24437083500004],
              [121.99366295700008, 12.249212958000044],
              [121.98267662900003, 12.25141022300005],
              [121.97120201900009, 12.256048895000049],
              [121.92969811300009, 12.296372789000088],
              [121.92074629000001, 12.302883205000057],
              [121.92408287900003, 12.339341539000088],
              [121.93441816500001, 12.380072333000044],
              [121.94662519600001, 12.39940013200004],
              [121.97828209700003, 12.411810614000046],
              [121.99317467500009, 12.441799221000053],
              [121.99781334700003, 12.478908596000053],
              [121.99789472700002, 12.512396552000041],
              [121.99089603000004, 12.571193752000056],
              [121.99586022200003, 12.592718817000048],
              [122.01905358200008, 12.611721096000053],
              [122.07634524800005, 12.627346096000053],
              [122.10499108200008, 12.641791083000044],
              [122.11524498800009, 12.66632721600007],
            ],
          ],
          [
            [
              [123.78736412900003, 12.375555731000077],
              [123.793304884, 12.35545482000009],
              [123.79476972700002, 12.343329169000071],
              [123.79053795700008, 12.337958075000074],
              [123.78248131600003, 12.341131903000075],
              [123.77491295700008, 12.349025783000059],
              [123.76921634200005, 12.358954169000071],
              [123.76685631600003, 12.368719794000071],
              [123.76254316500001, 12.378078518000052],
              [123.73267662900003, 12.40623607000009],
              [123.58318118600005, 12.623928127000056],
              [123.58025149800005, 12.63344961100006],
              [123.58130944100003, 12.646429755000042],
              [123.58814537900003, 12.646429755000042],
              [123.59734134200005, 12.64134349200009],
              [123.60181725400003, 12.65460846600007],
              [123.60474694100003, 12.674017645000049],
              [123.60922285200002, 12.687445380000042],
              [123.61833743600005, 12.687323309000078],
              [123.62956790500004, 12.67763906500005],
              [123.64673912900003, 12.657131252000056],
              [123.69629967500009, 12.62836334800005],
              [123.70484459700003, 12.625392971000053],
              [123.70386803500003, 12.618841864000046],
              [123.70093834700003, 12.615423895000049],
              [123.69117272200003, 12.611721096000053],
              [123.70492597700002, 12.611721096000053],
              [123.71656334700003, 12.608303127000056],
              [123.72584069100003, 12.60146719000005],
              [123.73267662900003, 12.59125397300005],
              [123.72787519600001, 12.573635158000059],
              [123.73568769600001, 12.55369700700004],
              [123.74732506600003, 12.534491278000075],
              [123.75318444100003, 12.519232489000046],
              [123.75635826900009, 12.503485419000071],
              [123.77051842500009, 12.471096096000053],
              [123.781586134, 12.41868724200009],
              [123.78394616000003, 12.413723049000055],
              [123.789398634, 12.409125067000048],
              [123.79004967500009, 12.39834219000005],
              [123.78736412900003, 12.375555731000077],
            ],
          ],
          [
            [
              [123.28028405000009, 12.864935614000046],
              [123.28663170700008, 12.815008856000077],
              [123.36085045700008, 12.736517645000049],
              [123.37582441500001, 12.69358958500004],
              [123.34107506600003, 12.71820709800005],
              [123.27344811300009, 12.810939846000053],
              [123.25196373800009, 12.832709052000041],
              [123.23845462300005, 12.841498114000046],
              [123.20101972700002, 12.848822333000044],
              [123.18531334700003, 12.85846588700008],
              [123.10987389400009, 12.923895575000074],
              [123.10206139400009, 12.937567450000074],
              [123.09791100400003, 12.93891022300005],
              [123.08033287900003, 12.957220770000049],
              [123.07789147200003, 12.961737372000073],
              [123.06967207100001, 12.964789130000042],
              [123.06609134200005, 12.971991278000075],
              [123.06381269600001, 12.980861721000053],
              [123.06055748800009, 12.988470770000049],
              [123.035492384, 13.004380601000037],
              [122.97388756600003, 13.018703518000052],
              [122.95069420700008, 13.04368724200009],
              [122.94410241000003, 13.099554755000042],
              [122.94450931100005, 13.11131419500009],
              [122.95826256600003, 13.120021877000056],
              [122.97543379000001, 13.121893622000073],
              [122.98894290500004, 13.128973700000074],
              [122.99219811300009, 13.153550523000092],
              [123.00391686300009, 13.150213934000078],
              [123.01710045700008, 13.14362213700008],
              [123.03980553500003, 13.128078518000052],
              [123.04981530000009, 13.118475653000075],
              [123.05884850400003, 13.107855536000045],
              [123.07422936300009, 13.084662177000041],
              [123.09457441500001, 13.04368724200009],
              [123.11833743600005, 13.024603583000044],
              [123.12208092500009, 13.01976146000004],
              [123.12517337300005, 13.00804271000004],
              [123.13933353000004, 12.98338450700004],
              [123.14242597700002, 12.971380927000041],
              [123.14503014400009, 12.96873607000009],
              [123.16016686300009, 12.937567450000074],
              [123.17701256600003, 12.922308661000045],
              [123.20142662900003, 12.906439520000049],
              [123.22657311300009, 12.89834219000005],
              [123.24610436300009, 12.90648021000004],
              [123.26197350400003, 12.897853908000059],
              [123.26856530000009, 12.888169664000088],
              [123.27263431100005, 12.877386786000045],
              [123.28028405000009, 12.864935614000046],
            ],
          ],
          [
            [
              [121.52613366000003, 12.704494533000059],
              [121.52735436300009, 12.692206122000073],
              [121.53093509200005, 12.67601146000004],
              [121.53638756600003, 12.660345770000049],
              [121.54639733200008, 12.644110419000071],
              [121.54737389400009, 12.636908270000049],
              [121.54566491000003, 12.61123281500005],
              [121.54273522200003, 12.609035549000055],
              [121.53825931100005, 12.609198309000078],
              [121.53239993600005, 12.60545482000009],
              [121.49341881600003, 12.549261786000045],
              [121.48145592500009, 12.539007880000042],
              [121.45671634200005, 12.522935289000088],
              [121.44898522200003, 12.520819403000075],
              [121.44239342500009, 12.522406317000048],
              [121.437836134, 12.521633205000057],
              [121.43628991000003, 12.512396552000041],
              [121.43677819100003, 12.495917059000078],
              [121.43897545700008, 12.48924388200004],
              [121.44361412900003, 12.482001044000071],
              [121.43628991000003, 12.47451406500005],
              [121.430023634, 12.482001044000071],
              [121.42628014400009, 12.475083726000037],
              [121.42465254000001, 12.470038153000075],
              [121.42562910200002, 12.464097398000092],
              [121.430023634, 12.454657294000071],
              [121.41187584700003, 12.443182684000078],
              [121.412445509, 12.414984442000048],
              [121.42530358200008, 12.38422272300005],
              [121.44361412900003, 12.365301825000074],
              [121.44361412900003, 12.35846588700008],
              [121.40333092500009, 12.369818427000041],
              [121.38428795700008, 12.36859772300005],
              [121.38160241000003, 12.35101959800005],
              [121.38721764400009, 12.34471263200004],
              [121.38892662900003, 12.336371161000045],
              [121.38697350400003, 12.32689036700009],
              [121.38160241000003, 12.317531643000052],
              [121.39039147200003, 12.313055731000077],
              [121.39454186300009, 12.30768463700008],
              [121.39584394600001, 12.30023834800005],
              [121.39576256600003, 12.289536851000037],
              [121.36573326900009, 12.307766018000052],
              [121.35474694100003, 12.32412344000005],
              [121.340179884, 12.31663646000004],
              [121.31641686300009, 12.296372789000088],
              [121.30339603000004, 12.293402411000045],
              [121.29127037900003, 12.28620026200008],
              [121.27295983200008, 12.269029039000088],
              [121.24781334700003, 12.219916083000044],
              [121.24496504000001, 12.214422919000071],
              [121.23015384200005, 12.214341539000088],
              [121.20777428500003, 12.236029364000046],
              [121.193695509, 12.241766669000071],
              [121.13168379000001, 12.241766669000071],
              [121.113617384, 12.251288153000075],
              [121.09913170700008, 12.274644273000092],
              [121.09327233200008, 12.30369700700004],
              [121.10108483200008, 12.330511786000045],
              [121.10694420700008, 12.31435781500005],
              [121.11597741000003, 12.305243231000077],
              [121.12818444100003, 12.303656317000048],
              [121.14258873800009, 12.310044664000088],
              [121.13493899800005, 12.31346263200004],
              [121.12818444100003, 12.312933661000045],
              [121.12159264400009, 12.310044664000088],
              [121.11540774800005, 12.327541408000059],
              [121.11475670700008, 12.330511786000045],
              [121.09441165500004, 12.345404364000046],
              [121.08725019600001, 12.343247789000088],
              [121.08725019600001, 12.32367584800005],
              [121.07113691500001, 12.332505601000037],
              [121.05062910200002, 12.349432684000078],
              [121.03288821700005, 12.368109442000048],
              [121.02051842500009, 12.389797268000052],
              [120.99488366000003, 12.413723049000055],
              [120.98682701900009, 12.416205145000049],
              [120.98113040500004, 12.422674872000073],
              [120.93897545700008, 12.493963934000078],
              [120.92603600400003, 12.50185781500005],
              [120.916351759, 12.512396552000041],
              [120.91846764400009, 12.536281643000052],
              [120.92904707100001, 12.57758209800005],
              [120.92790774800005, 12.597601630000042],
              [120.92212975400003, 12.61709219000005],
              [120.912445509, 12.634711005000042],
              [120.88591556100005, 12.664984442000048],
              [120.86866295700008, 12.699652411000045],
              [120.85450280000009, 12.715318101000037],
              [120.83220462300005, 12.724025783000059],
              [120.81226647200003, 12.724269924000055],
              [120.79786217500009, 12.729437567000048],
              [120.79249108200008, 12.75259023600006],
              [120.791351759, 12.763861395000049],
              [120.78630618600005, 12.782619533000059],
              [120.78516686300009, 12.793850002000056],
              [120.78199303500003, 12.805568752000056],
              [120.76531009200005, 12.831447658000059],
              [120.76644941500001, 12.840521552000041],
              [120.77084394600001, 12.84711334800005],
              [120.77588951900009, 12.852728583000044],
              [120.77898196700005, 12.858710028000075],
              [120.779633009, 12.86790599200009],
              [120.77670332100001, 12.916083075000074],
              [120.76742597700002, 12.946844794000071],
              [120.75831139400009, 13.002386786000045],
              [120.74097741000003, 13.033270575000074],
              [120.69695071700005, 13.09210846600007],
              [120.66488691500001, 13.155910549000055],
              [120.64234459700003, 13.183254299000055],
              [120.59457441500001, 13.19920482000009],
              [120.57634524800005, 13.22142161700009],
              [120.55982506600003, 13.228664455000057],
              [120.52515709700003, 13.22565338700008],
              [120.51482181100005, 13.230536200000074],
              [120.52621504000001, 13.249172268000052],
              [120.49976647200003, 13.27334219000005],
              [120.47999108200008, 13.30149974200009],
              [120.46778405000009, 13.333482164000088],
              [120.45972741000003, 13.403713283000059],
              [120.45248457100001, 13.42023346600007],
              [120.43995201900009, 13.427232164000088],
              [120.43262780000009, 13.426703192000048],
              [120.41504967500009, 13.423000393000052],
              [120.40821373800009, 13.420477606000077],
              [120.40015709700003, 13.41502513200004],
              [120.39576256600003, 13.409491278000075],
              [120.39242597700002, 13.40420156500005],
              [120.38786868600005, 13.399359442000048],
              [120.36817467500009, 13.383368231000077],
              [120.35596764400009, 13.380519924000055],
              [120.34009850400003, 13.386297919000071],
              [120.32764733200008, 13.396877346000053],
              [120.31690514400009, 13.41120026200008],
              [120.30933678500003, 13.42763906500005],
              [120.30665123800009, 13.44432200700004],
              [120.31055748800009, 13.466986395000049],
              [120.32154381600003, 13.487779039000088],
              [120.33765709700003, 13.50531647300005],
              [120.35661868600005, 13.518377997000073],
              [120.38013756600003, 13.52635325700004],
              [120.40316816500001, 13.52732982000009],
              [120.47169030000009, 13.511542059000078],
              [120.53191165500004, 13.50922272300005],
              [120.54468834700003, 13.510931708000044],
              [120.55518639400009, 13.513495184000078],
              [120.56544030000009, 13.51312897300005],
              [120.58472741000003, 13.50185781500005],
              [120.59538821700005, 13.498928127000056],
              [120.61443118600005, 13.496161200000074],
              [120.65333092500009, 13.496568101000037],
              [120.67652428500003, 13.492987372000073],
              [120.69019616000003, 13.48187897300005],
              [120.70639082100001, 13.490383205000057],
              [120.71924889400009, 13.485174872000073],
              [120.73731530000009, 13.468247789000088],
              [120.75456790500004, 13.466742255000042],
              [120.77003014400009, 13.47068919500009],
              [120.79932701900009, 13.48187897300005],
              [120.88819420700008, 13.50185781500005],
              [120.91537519600001, 13.51666901200008],
              [120.92839603000004, 13.50495026200008],
              [120.93677819100003, 13.507513739000046],
              [120.94483483200008, 13.512844143000052],
              [120.95020592500009, 13.53034088700008],
              [120.96436608200008, 13.52635325700004],
              [120.96900475400003, 13.527167059000078],
              [120.97738691500001, 13.53034088700008],
              [120.97868899800005, 13.526516018000052],
              [120.98438561300009, 13.52289459800005],
              [120.97966556100005, 13.514146226000037],
              [120.97388756600003, 13.507757880000042],
              [120.96656334700003, 13.503973700000074],
              [120.95704186300009, 13.50299713700008],
              [120.96306399800005, 13.494330145000049],
              [120.97315514400009, 13.48273346600007],
              [120.98462975400003, 13.472601630000042],
              [120.99488366000003, 13.468247789000088],
              [121.00391686300009, 13.459662177000041],
              [121.02686608200008, 13.421576239000046],
              [121.04273522200003, 13.413031317000048],
              [121.10865319100003, 13.415961005000042],
              [121.12525475400003, 13.404771226000037],
              [121.12159264400009, 13.372015692000048],
              [121.12826582100001, 13.372015692000048],
              [121.13013756600003, 13.37836334800005],
              [121.13282311300009, 13.39362213700008],
              [121.135101759, 13.399359442000048],
              [121.13933353000004, 13.405422268000052],
              [121.14112389400009, 13.407416083000044],
              [121.148773634, 13.413031317000048],
              [121.15886478000004, 13.417547919000071],
              [121.17164147200003, 13.421454169000071],
              [121.18336022200003, 13.428127346000053],
              [121.19027754000001, 13.440904039000088],
              [121.19711347700002, 13.440904039000088],
              [121.21778405000009, 13.404120184000078],
              [121.33375084700003, 13.310614325000074],
              [121.37623131600003, 13.24510325700004],
              [121.39210045700008, 13.235500393000052],
              [121.41391035200002, 13.23273346600007],
              [121.43051191500001, 13.224269924000055],
              [121.44076582100001, 13.209418036000045],
              [121.44361412900003, 13.187689520000049],
              [121.44068444100003, 13.177435614000046],
              [121.43555748800009, 13.166693427000041],
              [121.43262780000009, 13.156073309000078],
              [121.43628991000003, 13.146063544000071],
              [121.44752037900003, 13.13898346600007],
              [121.45899498800009, 13.13971588700008],
              [121.47022545700008, 13.143744208000044],
              [121.48121178500003, 13.146063544000071],
              [121.50464928500003, 13.14516836100006],
              [121.52702884200005, 13.140773830000057],
              [121.54444420700008, 13.13031647300005],
              [121.55298912900003, 13.11131419500009],
              [121.549164259, 13.090643622000073],
              [121.53589928500003, 13.076849677000041],
              [121.50171959700003, 13.054266669000071],
              [121.48951256600003, 13.036769924000055],
              [121.48316491000003, 13.01471588700008],
              [121.48194420700008, 12.99087148600006],
              [121.49244225400003, 12.929510809000078],
              [121.49203535200002, 12.913316148000092],
              [121.48308353000004, 12.87213776200008],
              [121.48462975400003, 12.858710028000075],
              [121.47779381600003, 12.858710028000075],
              [121.48340905000009, 12.83112213700008],
              [121.48560631600003, 12.768459377000056],
              [121.49512780000009, 12.745428778000075],
              [121.52247155000009, 12.711493231000077],
              [121.52613366000003, 12.704494533000059],
            ],
          ],
          [
            [
              [122.10157311300009, 13.416693427000041],
              [122.10547936300009, 13.40843333500004],
              [122.12370853000004, 13.395209052000041],
              [122.12891686300009, 13.386297919000071],
              [122.12029056100005, 13.356634833000044],
              [122.06202233200008, 13.298570054000038],
              [122.03956139400009, 13.269598700000074],
              [122.04908287900003, 13.24835846600007],
              [122.04029381600003, 13.23069896000004],
              [122.00879967500009, 13.204779364000046],
              [121.99317467500009, 13.201605536000045],
              [121.97673587300005, 13.213080145000049],
              [121.96257571700005, 13.228013414000088],
              [121.95386803500003, 13.235500393000052],
              [121.94288170700008, 13.240179755000042],
              [121.90919030000009, 13.269598700000074],
              [121.900726759, 13.271958726000037],
              [121.88347415500004, 13.273179429000038],
              [121.87501061300009, 13.27643463700008],
              [121.86491946700005, 13.284369208000044],
              [121.84766686300009, 13.310614325000074],
              [121.81723066500001, 13.341945705000057],
              [121.81373131600003, 13.352240302000041],
              [121.81788170700008, 13.375799872000073],
              [121.81723066500001, 13.382879950000074],
              [121.81413821700005, 13.39752838700008],
              [121.81430097700002, 13.450506903000075],
              [121.81723066500001, 13.46482982000009],
              [121.82439212300005, 13.47406647300005],
              [121.85075931100005, 13.52094147300005],
              [121.853851759, 13.53034088700008],
              [121.85564212300005, 13.558417059000078],
              [121.85865319100003, 13.56549713700008],
              [121.87305748800009, 13.568508205000057],
              [121.88754316500001, 13.554754950000074],
              [121.90919030000009, 13.52289459800005],
              [121.91374759200005, 13.528631903000075],
              [121.92505944100003, 13.538641669000071],
              [121.92969811300009, 13.544623114000046],
              [121.94499759200005, 13.528998114000046],
              [121.96802819100003, 13.52374909100007],
              [121.98902428500003, 13.530462958000044],
              [121.99789472700002, 13.55076732000009],
              [122.01099694100003, 13.542141018000052],
              [122.02019290500004, 13.533636786000045],
              [122.02344811300009, 13.523179429000038],
              [122.01905358200008, 13.50922272300005],
              [122.03394616000003, 13.51463450700004],
              [122.04517662900003, 13.50922272300005],
              [122.04867597700002, 13.49876536700009],
              [122.03956139400009, 13.48932526200008],
              [122.04379316500001, 13.48533763200004],
              [122.05469811300009, 13.478094794000071],
              [122.05990644600001, 13.475734768000052],
              [122.07520592500009, 13.48541901200008],
              [122.09669030000009, 13.479681708000044],
              [122.11524498800009, 13.464992580000057],
              [122.12208092500009, 13.447739976000037],
              [122.11841881600003, 13.443101304000038],
              [122.11133873800009, 13.44139232000009],
              [122.10157311300009, 13.440904039000088],
              [122.10084069100003, 13.43390534100007],
              [122.10157311300009, 13.416693427000041],
            ],
          ],
          [
            [
              [120.26091556100005, 13.71157461100006],
              [120.26929772200003, 13.70734284100007],
              [120.27719160200002, 13.70604075700004],
              [120.28305097700002, 13.702460028000075],
              [120.28541100400003, 13.69139232000009],
              [120.26856530000009, 13.67869700700004],
              [120.26433353000004, 13.67373281500005],
              [120.25782311300009, 13.682114976000037],
              [120.25082441500001, 13.693793036000045],
              [120.24317467500009, 13.704046942000048],
              [120.23389733200008, 13.70844147300005],
              [120.21949303500003, 13.71124909100007],
              [120.21363366000003, 13.718247789000088],
              [120.21021569100003, 13.72719961100006],
              [120.203461134, 13.73578522300005],
              [120.19288170700008, 13.742580471000053],
              [120.18279056100005, 13.74673086100006],
              [120.17188561300009, 13.748846747000073],
              [120.15886478000004, 13.749416408000059],
              [120.15251712300005, 13.752630927000041],
              [120.14112389400009, 13.766750393000052],
              [120.10824629000001, 13.776841539000088],
              [120.09229576900009, 13.794501044000071],
              [120.08285566500001, 13.817938544000071],
              [120.07992597700002, 13.842230536000045],
              [120.08130944100003, 13.852932033000059],
              [120.08570397200003, 13.86078522300005],
              [120.09302819100003, 13.865301825000074],
              [120.10368899800005, 13.86627838700008],
              [120.11833743600005, 13.860825914000088],
              [120.14283287900003, 13.84870026200008],
              [120.16407311300009, 13.834906317000048],
              [120.16871178500003, 13.82453034100007],
              [120.18336022200003, 13.828802802000041],
              [120.20264733200008, 13.824611721000053],
              [120.22217858200008, 13.81541575700004],
              [120.23764082100001, 13.804632880000042],
              [120.27173912900003, 13.752508856000077],
              [120.26677493600005, 13.74127838700008],
              [120.25733483200008, 13.733099677000041],
              [120.25269616000003, 13.724432684000078],
              [120.26091556100005, 13.71157461100006],
            ],
          ],
          [
            [
              [124.41797936300009, 13.87295156500005],
              [124.41797936300009, 13.86546458500004],
              [124.40349368600005, 13.856838283000059],
              [124.38998457100001, 13.845648505000042],
              [124.40357506600003, 13.838812567000048],
              [124.40984134200005, 13.82640208500004],
              [124.41293379000001, 13.811672268000052],
              [124.41797936300009, 13.797796942000048],
              [124.398773634, 13.790432033000059],
              [124.38998457100001, 13.790350653000075],
              [124.39722741000003, 13.77960846600007],
              [124.398773634, 13.771185614000046],
              [124.39576256600003, 13.742377020000049],
              [124.39112389400009, 13.721869208000044],
              [124.38998457100001, 13.71157461100006],
              [124.40748131600003, 13.683742580000057],
              [124.40870201900009, 13.667303778000075],
              [124.38656660200002, 13.66006094000005],
              [124.36605879000001, 13.660711981000077],
              [124.35531660200002, 13.65961334800005],
              [124.35084069100003, 13.65180084800005],
              [124.34913170700008, 13.632757880000042],
              [124.33334394600001, 13.572455145000049],
              [124.33472741000003, 13.55760325700004],
              [124.31983483200008, 13.567775783000059],
              [124.30640709700003, 13.58852773600006],
              [124.29346764400009, 13.604071356000077],
              [124.28077233200008, 13.598578192000048],
              [124.26807701900009, 13.60219961100006],
              [124.25163821700005, 13.599188544000071],
              [124.23519941500001, 13.591538804000038],
              [124.22266686300009, 13.581854559000078],
              [124.21534264400009, 13.567531643000052],
              [124.20801842500009, 13.547796942000048],
              [124.19939212300005, 13.530422268000052],
              [124.18775475400003, 13.52289459800005],
              [124.17017662900003, 13.529771226000037],
              [124.11622155000009, 13.57811107000009],
              [124.08594811300009, 13.600043036000045],
              [124.068695509, 13.60610586100006],
              [124.04737389400009, 13.606024481000077],
              [124.05128014400009, 13.619533596000053],
              [124.04810631600003, 13.633368231000077],
              [124.04004967500009, 13.646307684000078],
              [124.03044681100005, 13.656927802000041],
              [124.02605228000004, 13.669623114000046],
              [124.03589928500003, 13.680812893000052],
              [124.06177819100003, 13.69476959800005],
              [124.08716881600003, 13.716131903000075],
              [124.10743248800009, 13.74510325700004],
              [124.12183678500003, 13.779771226000037],
              [124.12940514400009, 13.818304755000042],
              [124.12077884200005, 13.875921942000048],
              [124.12598717500009, 13.890326239000046],
              [124.13591556100005, 13.90729401200008],
              [124.13453209700003, 13.925034898000092],
              [124.12029056100005, 13.96352773600006],
              [124.11622155000009, 13.98069896000004],
              [124.11622155000009, 13.988959052000041],
              [124.12110436300009, 13.99412669500009],
              [124.12964928500003, 14.001695054000038],
              [124.13591556100005, 14.010646877000056],
              [124.13306725400003, 14.019720770000049],
              [124.12452233200008, 14.03384023600006],
              [124.12452233200008, 14.049383856000077],
              [124.12964928500003, 14.064846096000053],
              [124.13689212300005, 14.07835521000004],
              [124.14966881600003, 14.062241929000038],
              [124.16391035200002, 14.065578518000052],
              [124.18458092500009, 14.085191148000092],
              [124.19361412900003, 14.090033270000049],
              [124.20093834700003, 14.092230536000045],
              [124.20777428500003, 14.09125397300005],
              [124.21566816500001, 14.086493231000077],
              [124.23585045700008, 14.068060614000046],
              [124.25261478000004, 14.046698309000078],
              [124.26563561300009, 14.022691148000092],
              [124.27393639400009, 13.996486721000053],
              [124.27735436300009, 13.955511786000045],
              [124.28687584700003, 13.95258209800005],
              [124.29542076900009, 13.945502020000049],
              [124.30811608200008, 13.928168036000045],
              [124.30062910200002, 13.920721747000073],
              [124.30543053500003, 13.91404857000009],
              [124.30689537900003, 13.91120026200008],
              [124.30811608200008, 13.906439520000049],
              [124.31495201900009, 13.906439520000049],
              [124.32976321700005, 13.933091539000088],
              [124.357758009, 13.920599677000041],
              [124.41797936300009, 13.87295156500005],
            ],
          ],
          [
            [
              [122.10474694100003, 14.10260651200008],
              [122.14975019600001, 14.072699286000045],
              [122.17269941500001, 14.053534247000073],
              [122.18344160200002, 14.030585028000075],
              [122.17701256600003, 14.007066148000092],
              [122.15837649800005, 14.006781317000048],
              [122.13607832100001, 14.019232489000046],
              [122.09896894600001, 14.050360419000071],
              [122.03337649800005, 14.09202708500004],
              [121.99317467500009, 14.127630927000041],
              [121.98145592500009, 14.133002020000049],
              [121.965179884, 14.142971096000053],
              [121.94581139400009, 14.165757554000038],
              [121.92986087300005, 14.191148179000038],
              [121.92351321700005, 14.208685614000046],
              [121.92660566500001, 14.221258856000077],
              [121.93433678500003, 14.229437567000048],
              [121.94507897200003, 14.232611395000049],
              [121.95777428500003, 14.229966539000088],
              [121.96404056100005, 14.226141669000071],
              [121.96810957100001, 14.221380927000041],
              [121.97584069100003, 14.210435289000088],
              [122.10474694100003, 14.10260651200008],
            ],
          ],
          [
            [
              [122.23536217500009, 14.797756252000056],
              [122.24822024800005, 14.78815338700008],
              [122.25700931100005, 14.76703522300005],
              [122.25660241000003, 14.745917059000078],
              [122.24219811300009, 14.73631419500009],
              [122.24154707100001, 14.741115627000056],
              [122.16293379000001, 14.797756252000056],
              [122.13550866000003, 14.802557684000078],
              [122.12126712300005, 14.80687083500004],
              [122.11524498800009, 14.814846096000053],
              [122.11117597700002, 14.826117255000042],
              [122.10499108200008, 14.837836005000042],
              [122.10572350400003, 14.843939520000049],
              [122.12208092500009, 14.838771877000056],
              [122.12484785200002, 14.842474677000041],
              [122.13575280000009, 14.852362372000073],
              [122.13843834700003, 14.83893463700008],
              [122.14600670700008, 14.833644924000055],
              [122.15707441500001, 14.83429596600007],
              [122.16976972700002, 14.838771877000056],
              [122.20386803500003, 14.838771877000056],
              [122.19695071700005, 14.832912502000056],
              [122.19263756600003, 14.824774481000077],
              [122.19239342500009, 14.814927476000037],
              [122.19711347700002, 14.803941148000092],
              [122.20630944100003, 14.796616929000038],
              [122.21697024800005, 14.79515208500004],
              [122.23536217500009, 14.797756252000056],
            ],
          ],
          [
            [
              [122.00538170700008, 15.010687567000048],
              [122.02906334700003, 15.009182033000059],
              [122.04818769600001, 14.99945709800005],
              [122.05787194100003, 14.983303127000056],
              [122.053070509, 14.962225653000075],
              [122.03150475400003, 14.98773834800005],
              [122.02035566500001, 14.993719794000071],
              [122.00538170700008, 14.990179755000042],
              [121.99512780000009, 14.980129299000055],
              [121.99268639400009, 14.969183661000045],
              [121.99634850400003, 14.96352773600006],
              [122.00538170700008, 14.96906159100007],
              [122.01319420700008, 14.944810289000088],
              [122.01286868600005, 14.932928778000075],
              [122.00359134200005, 14.92523834800005],
              [121.97169030000009, 14.905585028000075],
              [121.96810957100001, 14.90257396000004],
              [121.96957441500001, 14.897772528000075],
              [121.97152754000001, 14.86204661700009],
              [121.97364342500009, 14.852118231000077],
              [121.97803795700008, 14.838771877000056],
              [121.99659264400009, 14.841376044000071],
              [122.00879967500009, 14.824611721000053],
              [122.01587975400003, 14.79946523600006],
              [122.02588951900009, 14.73631419500009],
              [122.02369225400003, 14.722601630000042],
              [122.00416100400003, 14.673651434000078],
              [121.98487389400009, 14.656927802000041],
              [121.96119225400003, 14.64476146000004],
              [121.94019616000003, 14.64008209800005],
              [121.91667728000004, 14.64907461100006],
              [121.90870201900009, 14.67096588700008],
              [121.91032962300005, 14.697821356000077],
              [121.91602623800009, 14.722072658000059],
              [121.93490644600001, 14.725775458000044],
              [121.93384850400003, 14.764960028000075],
              [121.91944420700008, 14.810248114000046],
              [121.89893639400009, 14.831854559000078],
              [121.88363691500001, 14.836411851000037],
              [121.87916100400003, 14.848334052000041],
              [121.88184655000009, 14.883693752000056],
              [121.87745201900009, 14.89443594000005],
              [121.85572350400003, 14.926947333000044],
              [121.84766686300009, 14.93553294500009],
              [121.83139082100001, 14.940578518000052],
              [121.82178795700008, 14.940334377000056],
              [121.81836998800009, 14.94603099200009],
              [121.82642662900003, 15.012152411000045],
              [121.83326256600003, 15.035305080000057],
              [121.84424889400009, 15.045396226000037],
              [121.87427819100003, 15.027777411000045],
              [121.89372806100005, 15.024562893000052],
              [121.90235436300009, 15.041693427000041],
              [121.90992272200003, 15.050197658000059],
              [121.92798912900003, 15.052232164000088],
              [121.96941165500004, 15.04718659100007],
              [121.98487389400009, 15.037990627000056],
              [121.99382571700005, 15.042914130000042],
              [122.00513756600003, 15.038641669000071],
              [122.01124108200008, 15.027167059000078],
              [122.00538170700008, 15.010687567000048],
            ],
          ],
          [
            [
              [121.38843834700003, 18.90298086100006],
              [121.41675866000003, 18.908148505000042],
              [121.42986087300005, 18.905585028000075],
              [121.44361412900003, 18.89549388200004],
              [121.45053144600001, 18.888413804000038],
              [121.45801842500009, 18.883937893000052],
              [121.46697024800005, 18.881781317000048],
              [121.47779381600003, 18.88190338700008],
              [121.45362389400009, 18.86595286700009],
              [121.43140709700003, 18.85614655200004],
              [121.40674889400009, 18.850816148000035],
              [121.31861412900003, 18.84320709800005],
              [121.29493248800009, 18.846828518000052],
              [121.27914472700002, 18.86200592700004],
              [121.27523847700002, 18.875881252000056],
              [121.28003991000003, 18.880560614000046],
              [121.29957116000003, 18.88190338700008],
              [121.35328209700003, 18.898830471000053],
              [121.38843834700003, 18.90298086100006],
            ],
          ],
          [
            [
              [121.97120201900009, 18.984930731000077],
              [121.98365319100003, 18.97483958500004],
              [121.99089603000004, 18.96112702000005],
              [121.98910566500001, 18.94912344000005],
              [121.96257571700005, 18.938666083000044],
              [121.94239342500009, 18.909979559000078],
              [121.92969811300009, 18.89549388200004],
              [121.89527428500003, 18.867661851000037],
              [121.88103274800005, 18.850165106000077],
              [121.87501061300009, 18.83038971600007],
              [121.86573326900009, 18.821926174000055],
              [121.84717858200008, 18.824367580000057],
              [121.83415774800005, 18.83429596600007],
              [121.84083092500009, 18.84833405200004],
              [121.84107506600003, 18.86815013200004],
              [121.86158287900003, 18.884019273000035],
              [121.87484785200002, 18.900824286000045],
              [121.853851759, 18.923488674000055],
              [121.86410566500001, 18.93463776200008],
              [121.87159264400009, 18.95062897300005],
              [121.87468509200005, 18.96503327000005],
              [121.87159264400009, 18.971258856000077],
              [121.87916100400003, 18.975409247000073],
              [121.89258873800009, 18.996486721000053],
              [121.90235436300009, 19.00535716400009],
              [121.90796959700003, 19.00458405200004],
              [121.91504967500009, 19.00063711100006],
              [121.92090905000009, 18.998114325000074],
              [121.92351321700005, 19.002020575000074],
              [121.92660566500001, 19.00389232000009],
              [121.94166100400003, 19.01072825700004],
              [121.94662519600001, 19.012193101000037],
              [121.95582116000003, 19.00885651200008],
              [121.96070397200003, 19.00096263200004],
              [121.96461022200003, 18.991888739000046],
              [121.97120201900009, 18.984930731000077],
            ],
          ],
          [
            [
              [121.21094811300009, 19.176703192000048],
              [121.21973717500009, 19.17177969000005],
              [121.22584069100003, 19.16620514500005],
              [121.22982832100001, 19.15924713700008],
              [121.23853600400003, 19.118394273000035],
              [121.25220787900003, 19.081284898000035],
              [121.25896243600005, 19.045721747000073],
              [121.24496504000001, 19.018459377000056],
              [121.20923912900003, 19.05023834800005],
              [121.19678795700008, 19.06549713700008],
              [121.19027754000001, 19.08734772300005],
              [121.19239342500009, 19.111721096000053],
              [121.20818118600005, 19.15379466400009],
              [121.21094811300009, 19.176703192000048],
            ],
          ],
          [
            [
              [121.52613366000003, 19.320705471000053],
              [121.53785241000003, 19.306789455000057],
              [121.53980553500003, 19.30337148600006],
              [121.54086347700002, 19.300116278000075],
              [121.543304884, 19.29588450700004],
              [121.54558353000004, 19.290269273000035],
              [121.54672285200002, 19.282863674000055],
              [121.543304884, 19.27887604400007],
              [121.53516686300009, 19.27875397300005],
              [121.52588951900009, 19.279730536000045],
              [121.51872806100005, 19.279120184000078],
              [121.51270592500009, 19.273993231000077],
              [121.510101759, 19.267645575000074],
              [121.50668379000001, 19.262152411000045],
              [121.49830162900003, 19.25926341400009],
              [121.47095787900003, 19.269232489000046],
              [121.46461022200003, 19.27496979400007],
              [121.42628014400009, 19.296535549000055],
              [121.42115319100003, 19.29791901200008],
              [121.41391035200002, 19.29759349200009],
              [121.40601647200003, 19.298529364000046],
              [121.39893639400009, 19.30337148600006],
              [121.39356530000009, 19.31122467700004],
              [121.38160241000003, 19.334377346000053],
              [121.34986412900003, 19.370306708000044],
              [121.35084069100003, 19.375921942000048],
              [121.36768639400009, 19.37799713700008],
              [121.37891686300009, 19.383734442000048],
              [121.39576256600003, 19.403265692000048],
              [121.45240319100003, 19.38434479400007],
              [121.47095787900003, 19.382147528000075],
              [121.48894290500004, 19.385931708000044],
              [121.504242384, 19.392279364000046],
              [121.51661217500009, 19.39354075700004],
              [121.52613366000003, 19.38226959800005],
              [121.52613366000003, 19.334865627000056],
              [121.52515709700003, 19.331366278000075],
              [121.52466881600003, 19.327866929000038],
              [121.52613366000003, 19.320705471000053],
            ],
          ],
          [
            [
              [121.97730553500003, 19.577378648000035],
              [121.98292076900009, 19.575344143000052],
              [121.99122155000009, 19.57054271000004],
              [121.99773196700005, 19.564927476000037],
              [121.99789472700002, 19.560288804000038],
              [121.99203535200002, 19.548163153000075],
              [121.98715254000001, 19.51312897300005],
              [121.97803795700008, 19.498846747000073],
              [121.96094811300009, 19.49176666900007],
              [121.94711347700002, 19.49677155200004],
              [121.92351321700005, 19.519354559000078],
              [121.90552819100003, 19.52993398600006],
              [121.89820397200003, 19.536769924000055],
              [121.89551842500009, 19.546616929000038],
              [121.896820509, 19.55687083500004],
              [121.90023847700002, 19.55923086100006],
              [121.90642337300005, 19.558661200000074],
              [121.92652428500003, 19.562567450000074],
              [121.94157962300005, 19.55996328300006],
              [121.95004316500001, 19.560288804000038],
              [121.957367384, 19.564113674000055],
              [121.96949303500003, 19.575344143000052],
              [121.97730553500003, 19.577378648000035],
            ],
          ],
          [
            [
              [121.84164472700002, 20.34601471600007],
              [121.85938561300009, 20.347357489000046],
              [121.87940514400009, 20.33344147300005],
              [121.89323978000004, 20.313666083000044],
              [121.89210045700008, 20.297349351000037],
              [121.86931399800005, 20.276190497000073],
              [121.86182701900009, 20.27374909100007],
              [121.85084069100003, 20.27342357000009],
              [121.83920332100001, 20.320786851000037],
              [121.83765709700003, 20.333929755000042],
              [121.83838951900009, 20.340765692000048],
              [121.84164472700002, 20.34601471600007],
            ],
          ],
          [
            [
              [122.00977623800009, 20.48847077000005],
              [122.01929772200003, 20.486476955000057],
              [122.02759850400003, 20.48114655200004],
              [122.03272545700008, 20.473456122000073],
              [122.03239993600005, 20.464056708000044],
              [122.02654056100005, 20.45579661700009],
              [121.99122155000009, 20.43235911700009],
              [121.96876061300009, 20.413397528000075],
              [121.96371504000001, 20.406642971000053],
              [121.96615644600001, 20.39354075700004],
              [121.97087649800005, 20.386053778000075],
              [121.97388756600003, 20.379299221000053],
              [121.97120201900009, 20.368475653000075],
              [121.95801842500009, 20.35496653900009],
              [121.93897545700008, 20.34870026200008],
              [121.92212975400003, 20.35415273600006],
              [121.91602623800009, 20.375921942000048],
              [121.92237389400009, 20.39329661700009],
              [121.96371504000001, 20.451605536000045],
              [121.96599368600005, 20.460638739000046],
              [121.98023522200003, 20.47296784100007],
              [121.99789472700002, 20.48387278900009],
              [122.00977623800009, 20.48847077000005],
            ],
          ],
          [
            [
              [121.87720787900003, 20.770331122000073],
              [121.86768639400009, 20.744289455000057],
              [121.85173587300005, 20.718573309000078],
              [121.82984459700003, 20.698960679000038],
              [121.80339603000004, 20.691148179000038],
              [121.78638756600003, 20.703070380000042],
              [121.79118899800005, 20.73004791900007],
              [121.80543053500003, 20.758978583000044],
              [121.82374108200008, 20.786810614000046],
              [121.83765709700003, 20.820257880000042],
              [121.84587649800005, 20.831366278000075],
              [121.855804884, 20.838324286000045],
              [121.86597741000003, 20.83820221600007],
              [121.87484785200002, 20.827826239000046],
              [121.879242384, 20.81403229400007],
              [121.88070722700002, 20.799383856000077],
              [121.87989342500009, 20.784491278000075],
              [121.87720787900003, 20.770331122000073],
            ],
          ],
          [
            [
              [119.48324629000001, 4.850897528000075],
              [119.48658287900003, 4.832220770000049],
              [119.50098717500009, 4.79913971600007],
              [119.50440514400009, 4.782619533000059],
              [119.50359134200005, 4.764227606000077],
              [119.50082441500001, 4.748480536000045],
              [119.49659264400009, 4.733587958000044],
              [119.46705162900003, 4.666449286000045],
              [119.45655358200008, 4.65570709800005],
              [119.45655358200008, 4.717759507000039],
              [119.46273847700002, 4.775783596000053],
              [119.45687910200002, 4.842718817000048],
              [119.44849694100003, 4.874416408000059],
              [119.43539472700002, 4.902777411000045],
              [119.44703209700003, 4.905503648000092],
              [119.45850670700008, 4.90180084800005],
              [119.46876061300009, 4.893703518000052],
              [119.47592207100001, 4.883775132000039],
              [119.47934004000001, 4.875962632000039],
              [119.48145592500009, 4.867743231000077],
              [119.48292076900009, 4.859361070000091],
              [119.48324629000001, 4.850897528000075],
            ],
          ],
          [
            [
              [121.21745853000004, 5.820746161000045],
              [121.22982832100001, 5.816148179000038],
              [121.23462975400003, 5.810695705000057],
              [121.23113040500004, 5.800930080000057],
              [121.22527103000004, 5.799261786000045],
              [121.19703209700003, 5.800930080000057],
              [121.16211998800009, 5.787583726000094],
              [121.14649498800009, 5.789536851000094],
              [121.13502037900003, 5.807074286000045],
              [121.13502037900003, 5.821519273000092],
              [121.14226321700005, 5.833889065000051],
              [121.152679884, 5.843085028000075],
              [121.16285241000003, 5.848049221000053],
              [121.17994225400003, 5.846747137000079],
              [121.19516035200002, 5.84048086100006],
              [121.20785566500001, 5.831203518000052],
              [121.21745853000004, 5.820746161000045],
            ],
          ],
          [
            [
              [121.38160241000003, 6.005682684000078],
              [121.40349368600005, 5.99945709800005],
              [121.42123457100001, 5.987127997000073],
              [121.42872155000009, 5.969794012000079],
              [121.41944420700008, 5.94798411700009],
              [121.40992272200003, 5.943019924000055],
              [121.39991295700008, 5.94281647300005],
              [121.39177493600005, 5.939886786000045],
              [121.38843834700003, 5.926906643000052],
              [121.38949629000001, 5.909857489000046],
              [121.38575280000009, 5.911363023000092],
              [121.34766686300009, 5.906195380000042],
              [121.34058678500003, 5.903265692000048],
              [121.33082116000003, 5.895331122000073],
              [121.30298912900003, 5.865139065000051],
              [121.29249108200008, 5.85883209800005],
              [121.28142337300005, 5.859035549000055],
              [121.27100670700008, 5.86391836100006],
              [121.26172936300009, 5.871975002000056],
              [121.25342858200008, 5.885321356000077],
              [121.25196373800009, 5.89679596600007],
              [121.25318444100003, 5.906927802000041],
              [121.25245201900009, 5.91632721600007],
              [121.22779381600003, 5.94212474200009],
              [121.18946373800009, 5.940252997000073],
              [121.10792076900009, 5.903265692000048],
              [121.088226759, 5.891180731000077],
              [121.08106530000009, 5.888169664000088],
              [121.07300866000003, 5.889064846000053],
              [121.06714928500003, 5.894232489000046],
              [121.05445397200003, 5.912339585000041],
              [121.04981530000009, 5.91632721600007],
              [121.00831139400009, 5.923773505000042],
              [120.99952233200008, 5.920070705000057],
              [120.96387780000009, 5.896429755000042],
              [120.94361412900003, 5.886867580000057],
              [120.93409264400009, 5.885687567000048],
              [120.92286217500009, 5.889064846000053],
              [120.91765384200005, 5.89398834800005],
              [120.91675866000003, 5.899969794000071],
              [120.91724694100003, 5.90570709800005],
              [120.91537519600001, 5.910101630000042],
              [120.90935306100005, 5.91351959800005],
              [120.896820509, 5.916571356000077],
              [120.89185631600003, 5.920070705000057],
              [120.87631269600001, 5.942572333000044],
              [120.87183678500003, 5.961004950000074],
              [120.87647545700008, 5.978705145000049],
              [120.88884524800005, 5.998928127000056],
              [120.90552819100003, 6.015041408000059],
              [120.94320722700002, 6.031154690000051],
              [120.97095787900003, 6.050116278000075],
              [120.99284915500004, 6.052679755000042],
              [121.00171959700003, 6.057562567000048],
              [121.02418053500003, 6.08860911700009],
              [121.03272545700008, 6.095119533000059],
              [121.04224694100003, 6.09711334800005],
              [121.07740319100003, 6.095282294000071],
              [121.09636478000004, 6.096136786000045],
              [121.11475670700008, 6.095119533000059],
              [121.12582441500001, 6.090643622000073],
              [121.14828535200002, 6.077378648000092],
              [121.15935306100005, 6.074611721000053],
              [121.17904707100001, 6.063625393000052],
              [121.20232181100005, 6.013169664000088],
              [121.21778405000009, 5.998928127000056],
              [121.23601321700005, 6.003566799000055],
              [121.25245201900009, 6.017320054000038],
              [121.27125084700003, 6.026190497000073],
              [121.31657962300005, 6.006089585000041],
              [121.33887780000009, 6.004339911000045],
              [121.38160241000003, 6.005682684000078],
            ],
          ],
          [
            [
              [121.62891686300009, 6.657416083000044],
              [121.62891686300009, 6.588568427000041],
              [121.62330162900003, 6.567531643000052],
              [121.61638431100005, 6.561428127000056],
              [121.61036217500009, 6.569566148000092],
              [121.60792076900009, 6.591620184000078],
              [121.60157311300009, 6.605454820000091],
              [121.58961022200003, 6.620103257000039],
              [121.58253014400009, 6.631659247000073],
              [121.59083092500009, 6.636297919000071],
              [121.59929446700005, 6.645656643000052],
              [121.60726972700002, 6.662990627000056],
              [121.61670983200008, 6.672267971000053],
              [121.62891686300009, 6.657416083000044],
            ],
          ],
          [
            [
              [121.09449303500003, 10.895819403000075],
              [121.09449303500003, 10.873480536000045],
              [121.08073978000004, 10.841742255000042],
              [121.08716881600003, 10.823472398000092],
              [121.06226647200003, 10.817572333000044],
              [121.03467858200008, 10.819810289000088],
              [121.01758873800009, 10.834133205000057],
              [121.02515709700003, 10.864447333000044],
              [121.03207441500001, 10.870510158000059],
              [121.06666100400003, 10.891099351000037],
              [121.08578535200002, 10.908880927000041],
              [121.09327233200008, 10.91038646000004],
              [121.09449303500003, 10.895819403000075],
            ],
          ],
          [
            [
              [120.28516686300009, 11.930161851000037],
              [120.28321373800009, 11.926988023000092],
              [120.27279707100001, 11.925360419000071],
              [120.26783287900003, 11.923325914000088],
              [120.26343834700003, 11.916164455000057],
              [120.26547285200002, 11.909735419000071],
              [120.26978600400003, 11.90420156500005],
              [120.27149498800009, 11.899115302000041],
              [120.26465905000009, 11.872015692000048],
              [120.26417076900009, 11.86155833500004],
              [120.26677493600005, 11.85154857000009],
              [120.27719160200002, 11.831773179000038],
              [120.27833092500009, 11.824042059000078],
              [120.267914259, 11.816229559000078],
              [120.25554446700005, 11.83624909100007],
              [120.23747806100005, 11.885443427000041],
              [120.20329837300005, 11.94757721600007],
              [120.21314537900003, 11.94953034100007],
              [120.25879967500009, 11.967596747000073],
              [120.267914259, 11.968085028000075],
              [120.27637780000009, 11.964911200000074],
              [120.28199303500003, 11.95799388200004],
              [120.28451582100001, 11.949042059000078],
              [120.28516686300009, 11.930161851000037],
            ],
          ],
          [
            [
              [121.40642337300005, 12.062445380000042],
              [121.41285241000003, 12.04710521000004],
              [121.41667728000004, 12.030218817000048],
              [121.41382897200003, 12.014553127000056],
              [121.40186608200008, 12.002834377000056],
              [121.38428795700008, 12.000921942000048],
              [121.37183678500003, 12.011135158000059],
              [121.36426842500009, 12.02732982000009],
              [121.36085045700008, 12.043158270000049],
              [121.36158287900003, 12.050604559000078],
              [121.36768639400009, 12.07103099200009],
              [121.36459394600001, 12.081447658000059],
              [121.35865319100003, 12.087836005000042],
              [121.35564212300005, 12.094183661000045],
              [121.36085045700008, 12.10455963700008],
              [121.35857181100005, 12.112005927000041],
              [121.35865319100003, 12.11469147300005],
              [121.36768639400009, 12.11041901200008],
              [121.40642337300005, 12.062445380000042],
            ],
          ],
          [
            [
              [119.95972741000003, 8.880601304000038],
              [119.96062259200005, 8.877101955000057],
              [119.95834394600001, 8.87718333500004],
              [119.95972741000003, 8.880601304000038],
            ],
          ],
          [
            [
              [119.96924889400009, 8.880926825000074],
              [119.96827233200008, 8.884100653000075],
              [119.97193444100003, 8.882391669000071],
              [119.97144616000003, 8.880926825000074],
              [119.96924889400009, 8.880926825000074],
            ],
          ],
          [
            [
              [119.96534264400009, 8.887193101000037],
              [119.96566816500001, 8.887396552000041],
              [119.96607506600003, 8.885687567000048],
              [119.96485436300009, 8.88499583500004],
              [119.96436608200008, 8.885646877000056],
              [119.96420332100001, 8.885565497000073],
              [119.963226759, 8.88703034100007],
              [119.965179884, 8.887925523000092],
              [119.96534264400009, 8.887193101000037],
            ],
          ],
          [
            [
              [119.96778405000009, 8.891546942000048],
              [119.96827233200008, 8.891791083000044],
              [119.96851647200003, 8.890041408000059],
              [119.96729576900009, 8.889349677000041],
              [119.96680748800009, 8.889960028000075],
              [119.96680748800009, 8.889878648000092],
              [119.96566816500001, 8.891424872000073],
              [119.96762129000001, 8.892279364000046],
              [119.96778405000009, 8.891546942000048],
            ],
          ],
          [
            [
              [121.72396894600001, 12.91396719000005],
              [121.72046959700003, 12.913234768000052],
              [121.71745853000004, 12.911078192000048],
              [121.71924889400009, 12.90729401200008],
              [121.72217858200008, 12.903631903000075],
              [121.71778405000009, 12.899603583000044],
              [121.71119225400003, 12.90037669500009],
              [121.70671634200005, 12.905096747000073],
              [121.70329837300005, 12.904120184000078],
              [121.69906660200002, 12.90534088700008],
              [121.69166100400003, 12.914455471000053],
              [121.68474368600005, 12.92015208500004],
              [121.68279056100005, 12.924383856000077],
              [121.68181399800005, 12.93553294500009],
              [121.68864993600005, 12.94717031500005],
              [121.70045006600003, 12.950140692000048],
              [121.71412194100003, 12.947333075000074],
              [121.71827233200008, 12.947333075000074],
              [121.72575931100005, 12.939886786000045],
              [121.73170006600003, 12.92877838700008],
              [121.72917728000004, 12.919134833000044],
              [121.72396894600001, 12.91396719000005],
            ],
          ],
          [
            [
              [121.08863366000003, 13.53034088700008],
              [121.07211347700002, 13.535834052000041],
              [121.04346764400009, 13.561224677000041],
              [121.04346764400009, 13.567572333000044],
              [121.05128014400009, 13.567775783000059],
              [121.05811608200008, 13.56509023600006],
              [121.06690514400009, 13.567206122000073],
              [121.07748457100001, 13.57225169500009],
              [121.08578535200002, 13.57062409100007],
              [121.09131920700008, 13.562323309000078],
              [121.09424889400009, 13.537054755000042],
              [121.08863366000003, 13.53034088700008],
            ],
          ],
          [
            [
              [121.93669681100005, 21.065619208000044],
              [121.92969811300009, 21.064520575000074],
              [121.93482506600003, 21.07322825700004],
              [121.93669681100005, 21.065619208000044],
            ],
          ],
          [
            [
              [121.94743899800005, 21.116156317000048],
              [121.95069420700008, 21.122381903000075],
              [121.95427493600005, 21.118394273000035],
              [121.94906660200002, 21.10687897300005],
              [121.94743899800005, 21.116156317000048],
            ],
          ],
          [
            [
              [119.83090254000001, 4.82094961100006],
              [119.85377037900003, 4.808254299000055],
              [119.85767662900003, 4.798570054000038],
              [119.84978274800005, 4.796861070000091],
              [119.83399498800009, 4.796616929000038],
              [119.81934655000009, 4.803859768000052],
              [119.81234785200002, 4.816839911000045],
              [119.83090254000001, 4.82094961100006],
            ],
          ],
          [
            [
              [119.83692467500009, 4.862860419000071],
              [119.82105553500003, 4.862779039000088],
              [119.79859459700003, 4.879787502000056],
              [119.79037519600001, 4.905951239000046],
              [119.79314212300005, 4.921861070000091],
              [119.80437259200005, 4.927435614000046],
              [119.81568444100003, 4.922430731000077],
              [119.82146243600005, 4.914129950000074],
              [119.84262129000001, 4.904852606000077],
              [119.85075931100005, 4.887884833000044],
              [119.84986412900003, 4.873277085000041],
              [119.84205162900003, 4.865668036000045],
              [119.83692467500009, 4.862860419000071],
            ],
          ],
          [
            [
              [119.79656009200005, 5.057603257000039],
              [119.79224694100003, 5.055894273000092],
              [119.79029381600003, 5.05304596600007],
              [119.78614342500009, 5.04633209800005],
              [119.77466881600003, 5.041896877000056],
              [119.75212649800005, 5.036078192000048],
              [119.74577884200005, 5.044012762000079],
              [119.74870853000004, 5.062689520000049],
              [119.76929772200003, 5.097560940000051],
              [119.78296959700003, 5.110988674000055],
              [119.79835045700008, 5.121039130000042],
              [119.80600019600001, 5.118475653000075],
              [119.80551191500001, 5.105047919000071],
              [119.80713951900009, 5.093410549000055],
              [119.81055748800009, 5.082464911000045],
              [119.81251061300009, 5.069891669000071],
              [119.80795332100001, 5.058661200000074],
              [119.80103600400003, 5.055161851000094],
              [119.79656009200005, 5.057603257000039],
            ],
          ],
          [
            [
              [125.41871178500003, 5.425482489000046],
              [125.422211134, 5.42023346600007],
              [125.42457116000003, 5.407375393000052],
              [125.42335045700008, 5.377915757000039],
              [125.41871178500003, 5.368475653000075],
              [125.41163170700008, 5.368109442000048],
              [125.39909915500004, 5.371771552000041],
              [125.38062584700003, 5.370347398000092],
              [125.36378014400009, 5.367173570000091],
              [125.35157311300009, 5.37173086100006],
              [125.34327233200008, 5.380601304000038],
              [125.33423912900003, 5.387681382000039],
              [125.33350670700008, 5.392523505000042],
              [125.34205162900003, 5.400295315000051],
              [125.35816491000003, 5.422064520000049],
              [125.37680097700002, 5.431219794000071],
              [125.40479576900009, 5.430487372000073],
              [125.41871178500003, 5.425482489000046],
            ],
          ],
          [
            [
              [120.86011803500003, 5.70384349200009],
              [120.879242384, 5.69407786700009],
              [120.88266035200002, 5.685288804000038],
              [120.87370853000004, 5.682928778000075],
              [120.86011803500003, 5.675848700000074],
              [120.83887780000009, 5.668646552000041],
              [120.81999759200005, 5.667181708000044],
              [120.80811608200008, 5.664292710000041],
              [120.79932701900009, 5.667629299000055],
              [120.79664147200003, 5.678615627000056],
              [120.80738366000003, 5.695705471000053],
              [120.83301842500009, 5.706773179000038],
              [120.84864342500009, 5.706976630000042],
              [120.86011803500003, 5.70384349200009],
            ],
          ],
          [
            [
              [120.90430748800009, 5.759100653000075],
              [120.91618899800005, 5.753241278000075],
              [120.92937259200005, 5.733221747000073],
              [120.92432701900009, 5.711737372000073],
              [120.90992272200003, 5.700018622000073],
              [120.89087975400003, 5.709784247000073],
              [120.89234459700003, 5.741441148000092],
              [120.90430748800009, 5.759100653000075],
            ],
          ],
          [
            [
              [123.84131920700008, 9.642401434000078],
              [123.86052493600005, 9.630072333000044],
              [123.86833743600005, 9.620510158000059],
              [123.86231530000009, 9.608547268000052],
              [123.84424889400009, 9.58885325700004],
              [123.80453535200002, 9.560288804000038],
              [123.78516686300009, 9.552313544000071],
              [123.76514733200008, 9.549953518000052],
              [123.74984785200002, 9.55414459800005],
              [123.73764082100001, 9.57908763200004],
              [123.72632897200003, 9.58698151200008],
              [123.72722415500004, 9.591213283000059],
              [123.73926842500009, 9.59406159100007],
              [123.74789472700002, 9.599107164000088],
              [123.75456790500004, 9.605414130000042],
              [123.76587975400003, 9.614081122000073],
              [123.78191165500004, 9.623521226000037],
              [123.820648634, 9.639593817000048],
              [123.84131920700008, 9.642401434000078],
            ],
          ],
          [
            [
              [124.60694420700008, 10.140326239000046],
              [124.59571373800009, 10.123521226000037],
              [124.59538821700005, 10.108547268000052],
              [124.59766686300009, 10.094183661000045],
              [124.58887780000009, 10.08624909100007],
              [124.57569420700008, 10.090236721000053],
              [124.56104576900009, 10.08584219000005],
              [124.55005944100003, 10.069037177000041],
              [124.54037519600001, 10.06085846600007],
              [124.52955162900003, 10.068548895000049],
              [124.52540123800009, 10.078802802000041],
              [124.52540123800009, 10.087225653000075],
              [124.52279707100001, 10.098456122000073],
              [124.521820509, 10.11204661700009],
              [124.52759850400003, 10.117336330000057],
              [124.53565514400009, 10.11469147300005],
              [124.54224694100003, 10.11595286700009],
              [124.54688561300009, 10.12205638200004],
              [124.55176842500009, 10.126776434000078],
              [124.55762780000009, 10.12604401200008],
              [124.56723066500001, 10.12767161700009],
              [124.58008873800009, 10.13670482000009],
              [124.586273634, 10.142238674000055],
              [124.59278405000009, 10.14516836100006],
              [124.60621178500003, 10.147609768000052],
              [124.60694420700008, 10.140326239000046],
            ],
          ],
          [
            [
              [121.47413170700008, 11.866848049000055],
              [121.51050866000003, 11.855943101000037],
              [121.52605228000004, 11.846584377000056],
              [121.51742597700002, 11.837713934000078],
              [121.49537194100003, 11.827826239000046],
              [121.47291100400003, 11.827378648000092],
              [121.45582116000003, 11.831732489000046],
              [121.44548587300005, 11.836127020000049],
              [121.43995201900009, 11.836737372000073],
              [121.43506920700008, 11.839056708000044],
              [121.43091881600003, 11.843451239000046],
              [121.42628014400009, 11.84243398600006],
              [121.41797936300009, 11.83779531500005],
              [121.41260826900009, 11.840277411000045],
              [121.41570071700005, 11.84951406500005],
              [121.42562910200002, 11.86123281500005],
              [121.44288170700008, 11.867987372000073],
              [121.45297285200002, 11.868312893000052],
              [121.47413170700008, 11.866848049000055],
            ],
          ],
          [
            [
              [124.20622806100005, 12.081244208000044],
              [124.22803795700008, 12.07367584800005],
              [124.22925866000003, 12.063625393000052],
              [124.209320509, 12.060939846000053],
              [124.19857832100001, 12.05263906500005],
              [124.17847741000003, 12.039618231000077],
              [124.16431725400003, 12.03774648600006],
              [124.15023847700002, 12.043850002000056],
              [124.14625084700003, 12.05304596600007],
              [124.15333092500009, 12.065130927000041],
              [124.16537519600001, 12.075425523000092],
              [124.181976759, 12.080145575000074],
              [124.20622806100005, 12.081244208000044],
            ],
          ],
          [
            [
              [121.11597741000003, 12.196763414000088],
              [121.12826582100001, 12.174994208000044],
              [121.13103274800005, 12.16437409100007],
              [121.12769616000003, 12.159857489000046],
              [121.11890709700003, 12.15810781500005],
              [121.10865319100003, 12.162502346000053],
              [121.09937584700003, 12.169419664000088],
              [121.09009850400003, 12.174261786000045],
              [121.08366946700005, 12.18349844000005],
              [121.07960045700008, 12.197699286000045],
              [121.06959069100003, 12.211371161000045],
              [121.05160566500001, 12.22093333500004],
              [121.03956139400009, 12.251532294000071],
              [121.05990644600001, 12.27838776200008],
              [121.08814537900003, 12.267075914000088],
              [121.09791100400003, 12.244696356000077],
              [121.10523522200003, 12.21116771000004],
              [121.11011803500003, 12.20311107000009],
              [121.11410566500001, 12.199164130000042],
              [121.11597741000003, 12.196763414000088],
            ],
          ],
          [
            [
              [124.16863040500004, 12.398138739000046],
              [124.14909915500004, 12.41469961100006],
              [124.13746178500003, 12.437567450000074],
              [124.13379967500009, 12.459418036000045],
              [124.13355553500003, 12.470770575000074],
              [124.14258873800009, 12.468695380000042],
              [124.160492384, 12.45604075700004],
              [124.17660566500001, 12.43268463700008],
              [124.181976759, 12.406927802000041],
              [124.16863040500004, 12.398138739000046],
            ],
          ],
          [
            [
              [124.14861087300005, 13.18577708500004],
              [124.13624108200008, 13.18854401200008],
              [124.11378014400009, 13.189032294000071],
              [124.09791100400003, 13.19245026200008],
              [124.06902103000004, 13.20376211100006],
              [124.06560306100005, 13.210760809000078],
              [124.08472741000003, 13.216986395000049],
              [124.11410566500001, 13.227728583000044],
              [124.12378991000003, 13.23314036700009],
              [124.13884524800005, 13.234198309000078],
              [124.17872155000009, 13.22296784100007],
              [124.19792728000004, 13.213039455000057],
              [124.20964603000004, 13.195786851000037],
              [124.20915774800005, 13.178208726000037],
              [124.19678795700008, 13.173325914000088],
              [124.16236412900003, 13.180812893000052],
              [124.14861087300005, 13.18577708500004],
            ],
          ],
          [
            [
              [124.086273634, 13.260443427000041],
              [124.07309004000001, 13.254055080000057],
              [124.06755618600005, 13.25141022300005],
              [124.06226647200003, 13.245428778000075],
              [124.05640709700003, 13.235988674000055],
              [124.04615319100003, 13.226385809000078],
              [124.0394800140001, 13.224961656000062],
              [124.02540123800009, 13.221991278000075],
              [124.01742597700002, 13.223781643000052],
              [123.99789472700002, 13.228216864000046],
              [123.97673587300005, 13.235581773000092],
              [123.95834394600001, 13.23704661700009],
              [123.93930097700002, 13.24445221600007],
              [123.92188561300009, 13.258693752000056],
              [123.91391035200002, 13.271307684000078],
              [123.91480553500003, 13.27960846600007],
              [123.91285241000003, 13.28514232000009],
              [123.912445509, 13.288641669000071],
              [123.91391035200002, 13.289455471000053],
              [123.91472415500004, 13.289943752000056],
              [123.96257571700005, 13.28733958500004],
              [123.98682701900009, 13.27602773600006],
              [123.99537194100003, 13.278794664000088],
              [124.00245201900009, 13.281073309000078],
              [124.01579837300005, 13.280422268000052],
              [124.01693769600001, 13.28034088700008],
              [124.01807701900009, 13.278998114000046],
              [124.02556399800005, 13.27016836100006],
              [124.03256269600001, 13.266750393000052],
              [124.03825931100005, 13.269680080000057],
              [124.03858483200008, 13.273993231000077],
              [124.03956139400009, 13.278509833000044],
              [124.04769941500001, 13.278957424000055],
              [124.05640709700003, 13.276068427000041],
              [124.06918379000001, 13.273016669000071],
              [124.08448326900009, 13.267401434000078],
              [124.08562259200005, 13.262925523000092],
              [124.086273634, 13.260443427000041],
            ],
          ],
          [
            [
              [123.89031009200005, 13.27407461100006],
              [123.89665774800005, 13.258490302000041],
              [123.90357506600003, 13.246486721000053],
              [123.90186608200008, 13.238348700000074],
              [123.88428795700008, 13.22992584800005],
              [123.87354576900009, 13.229641018000052],
              [123.863617384, 13.24477773600006],
              [123.857758009, 13.250148830000057],
              [123.84595787900003, 13.27024974200009],
              [123.84449303500003, 13.282416083000044],
              [123.84937584700003, 13.29913971600007],
              [123.85108483200008, 13.317572333000044],
              [123.84717858200008, 13.330877997000073],
              [123.83676191500001, 13.344671942000048],
              [123.84009850400003, 13.348537502000056],
              [123.84888756600003, 13.35415273600006],
              [123.85889733200008, 13.35382721600007],
              [123.90007571700005, 13.340521552000041],
              [123.90609785200002, 13.335598049000055],
              [123.91342207100001, 13.332220770000049],
              [123.92212975400003, 13.32998281500005],
              [123.92212975400003, 13.320013739000046],
              [123.89527428500003, 13.29287344000005],
              [123.89031009200005, 13.27407461100006],
            ],
          ],
          [
            [
              [123.80152428500003, 13.366034247000073],
              [123.77515709700003, 13.39158763200004],
              [123.77165774800005, 13.403509833000044],
              [123.78736412900003, 13.39907461100006],
              [123.80420983200008, 13.391546942000048],
              [123.82048587300005, 13.380275783000059],
              [123.82748457100001, 13.373114325000074],
              [123.83301842500009, 13.373236395000049],
              [123.84294681100005, 13.37181224200009],
              [123.84555097700002, 13.36782461100006],
              [123.83472741000003, 13.355902411000045],
              [123.82309004000001, 13.351955471000053],
              [123.80152428500003, 13.366034247000073],
            ],
          ],
          [
            [
              [122.41179446700005, 14.725816148000092],
              [122.41846764400009, 14.719956773000092],
              [122.41960696700005, 14.705145575000074],
              [122.39779707100001, 14.68585846600007],
              [122.37484785200002, 14.681463934000078],
              [122.35401451900009, 14.679510809000078],
              [122.31934655000009, 14.68349844000005],
              [122.31641686300009, 14.698919989000046],
              [122.34156334700003, 14.712591864000046],
              [122.36426842500009, 14.72060781500005],
              [122.38062584700003, 14.728705145000049],
              [122.39698326900009, 14.732245184000078],
              [122.41179446700005, 14.725816148000092],
            ],
          ],
          [
            [
              [120.00505618600005, 16.26862213700008],
              [120.01075280000009, 16.25462474200009],
              [120.01221764400009, 16.241522528000075],
              [120.00554446700005, 16.232082424000055],
              [119.99293053500003, 16.230169989000046],
              [119.98096764400009, 16.239447333000044],
              [119.97632897200003, 16.247259833000044],
              [119.95671634200005, 16.26243724200009],
              [119.93677819100003, 16.28815338700008],
              [119.92554772200003, 16.295355536000045],
              [119.92237389400009, 16.30377838700008],
              [119.92750084700003, 16.31313711100006],
              [119.94304446700005, 16.329291083000044],
              [119.953461134, 16.331976630000042],
              [119.96119225400003, 16.334784247000073],
              [119.96257571700005, 16.33885325700004],
              [119.96501712300005, 16.34438711100006],
              [119.97315514400009, 16.35057200700004],
              [119.98406009200005, 16.34870026200008],
              [119.99122155000009, 16.343573309000078],
              [119.99488366000003, 16.337551174000055],
              [119.99708092500009, 16.33075592700004],
              [120.00562584700003, 16.311753648000092],
              [120.00505618600005, 16.26862213700008],
            ],
          ],
          [
            [
              [123.99164944169532, 10.324283806534812],
              [124.00939438039761, 10.311757967450836],
              [124.02087639955792, 10.316977067069159],
              [124.03862133826023, 10.329502906153136],
              [124.04384043787854, 10.324283806534812],
              [124.02609549917625, 10.306538867832511],
              [124.00626292062663, 10.287750109206547],
              [123.98851798192432, 10.266873710733252],
              [123.97599214284034, 10.255391691572939],
              [123.95720338421438, 10.25330405172561],
              [123.94676518497772, 10.245997312259956],
              [123.93319552597009, 10.254347871649275],
              [123.93423934589376, 10.27313663027524],
              [123.93423934589376, 10.288793929130211],
              [123.94780900490139, 10.306538867832511],
              [123.980167422535, 10.320108526840153],
              [123.99164944169532, 10.324283806534812],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Sri Lanka',
        iso3: 'LKA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [81.87598717500003, 7.091945705000057],
              [81.87842858200008, 7.076117255000042],
              [81.88868248800003, 7.040757554000038],
              [81.89031009200005, 7.019924221000053],
              [81.88461347700007, 6.980169989000046],
              [81.83855228000004, 6.821437893000052],
              [81.83594811300003, 6.805080471000053],
              [81.83497155000003, 6.783433335000041],
              [81.83155358200008, 6.765366929000038],
              [81.81714928500008, 6.737494208000044],
              [81.81397545700008, 6.725043036000045],
              [81.80827884200005, 6.707953192000048],
              [81.78891035200007, 6.677801825000074],
              [81.77979576900003, 6.66360097900008],
              [81.78663170700008, 6.639268296000068],
              [81.77564537900008, 6.610419012000079],
              [81.68148847700007, 6.462144273000092],
              [81.65007571700005, 6.430853583000044],
              [81.59205162900008, 6.389878648000092],
              [81.57309004000007, 6.38422272300005],
              [81.54769941500007, 6.370672919000071],
              [81.36207116000008, 6.225409247000073],
              [81.32496178500008, 6.20538971600007],
              [81.20443769600007, 6.16274648600006],
              [81.20435631600003, 6.16274648600006],
              [81.20272871200007, 6.17719147300005],
              [81.20264733200008, 6.17804596600007],
              [81.19548587300005, 6.183661200000074],
              [81.19532311300003, 6.183620510000083],
              [81.19369550900007, 6.183213609000063],
              [81.18767337300005, 6.181586005000042],
              [81.18384850400008, 6.173570054000038],
              [81.18189537900008, 6.156724351000094],
              [81.17644290500004, 6.150376695000091],
              [81.16765384200005, 6.148016669000071],
              [81.15601647200003, 6.14288971600007],
              [81.13428795700008, 6.129828192000048],
              [81.11255944100003, 6.120306708000044],
              [81.00847415500004, 6.098049221000053],
              [80.95801842500003, 6.08079661700009],
              [80.90267988400007, 6.070786851000094],
              [80.87745201900003, 6.061102606000077],
              [80.86231530000003, 6.039862372000073],
              [80.83521569100003, 6.045152085000041],
              [80.81853274800005, 6.038763739000046],
              [80.80909264400003, 6.035101630000042],
              [80.77059980600006, 6.006740627000056],
              [80.73210696700005, 5.978420315000051],
              [80.71436608200008, 5.957912502000056],
              [80.67343183700007, 5.960313218000067],
              [80.67335045700008, 5.960353908000059],
              [80.65626061300003, 5.957912502000056],
              [80.64291425900007, 5.952866929000038],
              [80.62916100400008, 5.945054429000038],
              [80.60482832100007, 5.926906643000052],
              [80.59782962300005, 5.925279039000088],
              [80.59083092500003, 5.923732815000051],
              [80.57422936300003, 5.930121161000045],
              [80.55665123800003, 5.939154364000046],
              [80.54656009200005, 5.942206122000073],
              [80.53956139400003, 5.944281317000048],
              [80.48170006600003, 5.937445380000042],
              [80.46517988400007, 5.940659898000092],
              [80.45679772200003, 5.948919989000046],
              [80.45142662900008, 5.959784247000073],
              [80.44719485800005, 5.966131903000075],
              [80.44402103000004, 5.970892645000049],
              [80.42709394600007, 5.961086330000057],
              [80.41195722700007, 5.959947007000039],
              [80.38502037900008, 5.963812567000048],
              [80.37859134200005, 5.964748440000051],
              [80.37378991000008, 5.966864325000074],
              [80.37045332100007, 5.971584377000056],
              [80.36622155000003, 5.976263739000046],
              [80.35840905000003, 5.978420315000051],
              [80.35377037900008, 5.976792710000041],
              [80.35010826900003, 5.973537502000056],
              [80.34620201900003, 5.970770575000074],
              [80.34099368600005, 5.970933335000041],
              [80.33920332100007, 5.972398179000038],
              [80.33757571700005, 5.973822333000044],
              [80.33122806100005, 5.982814846000053],
              [80.32813561300003, 5.98468659100007],
              [80.32732181100005, 5.985174872000073],
              [80.32732181100005, 5.985256252000056],
              [80.32024173300005, 5.98773834800005],
              [80.27751712300005, 6.002997137000079],
              [80.26002037900008, 6.00657786700009],
              [80.24756920700008, 6.009182033000059],
              [80.22584069100003, 6.026556708000044],
              [80.22095787900008, 6.028916734000063],
              [80.21135501400005, 6.033555406000062],
              [80.21119225400008, 6.033636786000045],
              [80.20386803500008, 6.026190497000073],
              [80.18523196700005, 6.041164455000057],
              [80.10377037900008, 6.127142645000049],
              [80.09709720100005, 6.13235097900008],
              [80.09701582100007, 6.132391669000071],
              [80.09628339900007, 6.133327541000085],
              [80.09400475400008, 6.136053778000075],
              [80.09278405000003, 6.140244859000063],
              [80.09310957100007, 6.14874909100007],
              [80.09058678500008, 6.153143622000073],
              [80.08716881600003, 6.157578843000067],
              [80.07813561300003, 6.169338283000059],
              [80.03199303500008, 6.26634349200009],
              [80.03003991000008, 6.275620835000041],
              [80.03003991000008, 6.27570221600007],
              [80.03028405000003, 6.284002997000073],
              [80.03052819100003, 6.292303778000075],
              [80.03052819100003, 6.292385158000059],
              [80.02881920700008, 6.297430731000077],
              [80.02051842500003, 6.314642645000049],
              [80.01205488400007, 6.361314195000091],
              [79.99366295700008, 6.394110419000071],
              [79.98210696700005, 6.441026109000063],
              [79.97787519600007, 6.458197333000044],
              [79.97575931100005, 6.459865627000056],
              [79.97144616000008, 6.462469794000071],
              [79.96697024800005, 6.466376044000071],
              [79.96420332100007, 6.471869208000044],
              [79.96534264400003, 6.477728583000044],
              [79.97022545700008, 6.47915273600006],
              [79.97535241000008, 6.478583075000074],
              [79.97543379000007, 6.478583075000074],
              [79.97787519600007, 6.478705145000049],
              [79.97022545700008, 6.531154690000051],
              [79.96957441500007, 6.535345770000049],
              [79.94874108200008, 6.588568427000041],
              [79.86304772200003, 6.807196356000077],
              [79.84945722700007, 6.882717190000051],
              [79.84815514400003, 6.890204169000071],
              [79.84815514400003, 6.962144273000092],
              [79.84929446700005, 6.964951890000066],
              [79.85922285200007, 6.988674221000053],
              [79.86182701900003, 7.000067450000074],
              [79.86158287900008, 7.011664130000042],
              [79.86158287900008, 7.011867580000057],
              [79.81373131600003, 7.180731512000079],
              [79.82032311300003, 7.205511786000045],
              [79.81999759200005, 7.190252997000073],
              [79.82374108200008, 7.180650132000039],
              [79.82911217500003, 7.173244533000059],
              [79.83383222700007, 7.164496161000045],
              [79.84343509200005, 7.131008205000057],
              [79.84815514400003, 7.122951565000051],
              [79.85434004000007, 7.122951565000051],
              [79.85580488400007, 7.132513739000046],
              [79.85865319100003, 7.136542059000078],
              [79.86117597700007, 7.137193101000094],
              [79.86125735800005, 7.137193101000094],
              [79.86182701900003, 7.136623440000051],
              [79.86158287900008, 7.167222398000092],
              [79.86158287900008, 7.16742584800005],
              [79.85938561300003, 7.180812893000052],
              [79.85434004000007, 7.191839911000045],
              [79.84961998800003, 7.195054429000038],
              [79.83643639400003, 7.19790273600006],
              [79.83057701900003, 7.20180898600006],
              [79.82992597700007, 7.203192450000074],
              [79.82634524800005, 7.21039459800005],
              [79.82797285200007, 7.218329169000071],
              [79.83179772200003, 7.225734768000052],
              [79.83383222700007, 7.232814846000053],
              [79.78467858200008, 7.589789130000042],
              [79.77857506600003, 7.602728583000044],
              [79.78272545700008, 7.607123114000046],
              [79.78581790500004, 7.607570705000057],
              [79.79297936300003, 7.602728583000044],
              [79.79460696700005, 7.620021877000056],
              [79.79957116000008, 7.64008209800005],
              [79.80079186300003, 7.649684963000084],
              [79.80201256600003, 7.659328518000052],
              [79.79639733200008, 7.674383856000077],
              [79.78882897200003, 7.688177802000041],
              [79.78736412900008, 7.697333075000074],
              [79.78589928500008, 7.70648834800005],
              [79.78598066500007, 7.743353583000044],
              [79.76295006600003, 7.855454820000091],
              [79.76026451900003, 7.868394273000092],
              [79.74838300900007, 7.893011786000045],
              [79.73829186300003, 7.944728908000059],
              [79.72193444100003, 7.985541083000044],
              [79.69678795700008, 8.09829336100006],
              [79.69678795700008, 8.13031647300005],
              [79.70085696700005, 8.128485419000071],
              [79.70110110800005, 8.128200588000084],
              [79.70142662900008, 8.12791575700004],
              [79.70142662900008, 8.126898505000042],
              [79.70362389400003, 8.123480536000045],
              [79.70720462300005, 8.142075914000088],
              [79.70191491000008, 8.20115794500009],
              [79.69678795700008, 8.21906159100007],
              [79.71322675900007, 8.229803778000075],
              [79.72877037900008, 8.249701239000046],
              [79.74000084700003, 8.272365627000056],
              [79.74447675900007, 8.291408596000053],
              [79.74903405000003, 8.303859768000052],
              [79.77857506600003, 8.350043036000045],
              [79.77824954500005, 8.349269924000055],
              [79.76335696700005, 8.314398505000042],
              [79.74447675900007, 8.28115469000005],
              [79.74862714900007, 8.273057359000063],
              [79.74968509200005, 8.271063544000071],
              [79.75709069100003, 8.263739325000074],
              [79.76677493600005, 8.259914455000057],
              [79.77857506600003, 8.25999583500004],
              [79.76889082100007, 8.232814846000053],
              [79.75879967500003, 8.21287669500009],
              [79.75440514400003, 8.209418036000045],
              [79.74976647200003, 8.208929755000042],
              [79.74610436300003, 8.20612213700008],
              [79.74447675900007, 8.195502020000049],
              [79.74537194100003, 8.17186107000009],
              [79.74447675900007, 8.164496161000045],
              [79.72754967500003, 8.110907294000071],
              [79.72820071700005, 8.100978908000059],
              [79.72950280000003, 8.08112213700008],
              [79.74699954500005, 8.060492255000042],
              [79.75196373800003, 8.054632880000042],
              [79.73194420700008, 8.01312897300005],
              [79.76384524800005, 7.990139065000051],
              [79.81023196700005, 7.986517645000049],
              [79.83383222700007, 8.003078518000052],
              [79.82935631600003, 8.020900783000059],
              [79.82178795700008, 8.034857489000046],
              [79.81885826900003, 8.040187893000052],
              [79.81527754000007, 8.044582424000055],
              [79.80640709700003, 8.05565013200004],
              [79.79639733200008, 8.061997789000088],
              [79.79346764400003, 8.072821356000077],
              [79.82715905000003, 8.136542059000078],
              [79.82585696700005, 8.148098049000055],
              [79.82154381600003, 8.156642971000053],
              [79.81657962300005, 8.163804429000038],
              [79.81348717500003, 8.171291408000059],
              [79.81267337300005, 8.183335679000038],
              [79.81381269600007, 8.20408763200004],
              [79.81348717500003, 8.212632554000038],
              [79.81348717500003, 8.21287669500009],
              [79.81291751400005, 8.214504299000055],
              [79.81023196700005, 8.221625067000048],
              [79.80860436300003, 8.223089911000045],
              [79.80665123800003, 8.22492096600007],
              [79.80469811300003, 8.228989976000037],
              [79.80665123800003, 8.240179755000042],
              [79.81137129000007, 8.249660549000055],
              [79.82447350400008, 8.26666901200008],
              [79.82715905000003, 8.277736721000053],
              [79.82927493600005, 8.298651434000078],
              [79.83863366000008, 8.340521552000041],
              [79.84815514400003, 8.438177802000041],
              [79.85425866000008, 8.449286200000074],
              [79.86085045700008, 8.454779364000046],
              [79.86589603000004, 8.461411851000037],
              [79.86801191500007, 8.47601959800005],
              [79.86801191500007, 8.517645575000074],
              [79.87378991000008, 8.53807200700004],
              [79.88738040500004, 8.551214911000045],
              [79.90349368600005, 8.562079169000071],
              [79.91651451900003, 8.575995184000078],
              [79.91814212300005, 8.580918687000064],
              [79.92807050900007, 8.611517645000049],
              [79.92945397200003, 8.61281972900008],
              [79.93018639400003, 8.61351146000004],
              [79.93238366000008, 8.622463283000059],
              [79.94166100400008, 8.64248281500005],
              [79.95053144600007, 8.739813544000071],
              [79.92644290500004, 8.801906643000052],
              [79.92839603000004, 8.812689520000049],
              [79.93018639400003, 8.883490302000041],
              [79.93018639400003, 8.884466864000046],
              [79.92774498800003, 8.90810781500005],
              [79.92481530000003, 8.919745184000078],
              [79.91960696700005, 8.928534247000073],
              [79.91553795700008, 8.93854401200008],
              [79.92481530000003, 8.943508205000057],
              [79.93824303500008, 8.945990302000041],
              [79.94711347700007, 8.94867584800005],
              [80.00513756600003, 9.000555731000077],
              [80.03541100400008, 9.015326239000046],
              [80.04802493600005, 9.026271877000056],
              [80.05469811300003, 9.050604559000078],
              [80.06666100400008, 9.07562897300005],
              [80.07349694100003, 9.11041901200008],
              [80.10564212300005, 9.192857164000088],
              [80.10678144600007, 9.197414455000057],
              [80.10979251400005, 9.209458726000037],
              [80.11597741000008, 9.23383209800005],
              [80.11597741000008, 9.291937567000048],
              [80.11817467500003, 9.300441799000055],
              [80.11622155000003, 9.30617910400008],
              [80.10450280000003, 9.308417059000078],
              [80.07691491000008, 9.322658596000053],
              [80.06617272200003, 9.332586981000077],
              [80.05941816500007, 9.351385809000078],
              [80.05827884200005, 9.354803778000075],
              [80.05347741000008, 9.378241278000075],
              [80.05298912900008, 9.391546942000048],
              [80.06495201900003, 9.404038804000038],
              [80.08708743600005, 9.414984442000048],
              [80.11166425900007, 9.422756252000056],
              [80.13184655000003, 9.425726630000042],
              [80.14087975400008, 9.43032461100006],
              [80.16285241000008, 9.45921458500004],
              [80.16537519600007, 9.461086330000057],
              [80.16920006600003, 9.464016018000052],
              [80.17652428500008, 9.468329169000071],
              [80.18555748800003, 9.47166575700004],
              [80.19703209700003, 9.473456122000073],
              [80.18751061300003, 9.49087148600006],
              [80.18181399800005, 9.498521226000037],
              [80.17603600400008, 9.50617096600007],
              [80.16130618600005, 9.52057526200008],
              [80.14185631600003, 9.534979559000078],
              [80.06788170700008, 9.57802969000005],
              [80.05298912900008, 9.596380927000041],
              [80.08521569100003, 9.595363674000055],
              [80.11573326900003, 9.583238023000092],
              [80.17595462300005, 9.548570054000038],
              [80.23340905000003, 9.53424713700008],
              [80.24854576900003, 9.524644273000092],
              [80.27222741000008, 9.50413646000004],
              [80.27808678500008, 9.493312893000052],
              [80.26587975400008, 9.487127997000073],
              [80.26856530000003, 9.480292059000078],
              [80.27214603000004, 9.473456122000073],
              [80.26587975400008, 9.46670156500005],
              [80.26596113400007, 9.46666087400007],
              [80.28687584700003, 9.452704169000071],
              [80.33627363400007, 9.464667059000078],
              [80.42660566500007, 9.500189520000049],
              [80.45093834700003, 9.497870184000078],
              [80.50424238400007, 9.483303127000056],
              [80.56714928500008, 9.455226955000057],
              [80.61459394600007, 9.446193752000056],
              [80.61475670700008, 9.446193752000056],
              [80.54672285200007, 9.49241771000004],
              [80.52328535200007, 9.503159898000092],
              [80.50245201900003, 9.507635809000078],
              [80.49935957100007, 9.509059963000084],
              [80.49634850400008, 9.51048411700009],
              [80.47828209700003, 9.52407461100006],
              [80.47144616000008, 9.52806224200009],
              [80.46461022200003, 9.529120184000078],
              [80.45639082100007, 9.528713283000059],
              [80.44402103000004, 9.52806224200009],
              [80.43620853000004, 9.525091864000046],
              [80.43506920700008, 9.523382880000042],
              [80.43287194100003, 9.51976146000004],
              [80.42896569100003, 9.517767645000049],
              [80.41570071700005, 9.527492580000057],
              [80.41041100400008, 9.52838776200008],
              [80.37794030000003, 9.527533270000049],
              [80.36866295700008, 9.530218817000048],
              [80.29753665500004, 9.59125397300005],
              [80.26701907600005, 9.610825914000088],
              [80.26693769600007, 9.610825914000088],
              [80.25603274800005, 9.615586656000062],
              [80.20460045700008, 9.637884833000044],
              [80.18604576900003, 9.648504950000074],
              [80.17359459700003, 9.64866771000004],
              [80.17595462300005, 9.624335028000075],
              [80.18287194100003, 9.61717357000009],
              [80.19361412900008, 9.609076239000046],
              [80.19996178500008, 9.599188544000071],
              [80.19361412900008, 9.586411851000037],
              [80.18604576900003, 9.584133205000057],
              [80.17872155000003, 9.588039455000057],
              [80.17204837300005, 9.593573309000078],
              [80.15284264400003, 9.603461005000042],
              [80.11548912900008, 9.63572825700004],
              [80.09400475400008, 9.64484284100007],
              [80.09408613400007, 9.64476146000004],
              [80.10499108200008, 9.632879950000074],
              [80.12468509200005, 9.616034247000073],
              [80.13559004000007, 9.60382721600007],
              [80.11133873800003, 9.60846588700008],
              [80.08741295700008, 9.618353583000044],
              [80.03931725400008, 9.64484284100007],
              [80.00098717500003, 9.674709377000056],
              [79.97820071700005, 9.68268463700008],
              [79.97592207100007, 9.684068101000037],
              [79.96729576900003, 9.689601955000057],
              [79.95923912900008, 9.69281647300005],
              [79.95801842500003, 9.685736395000049],
              [79.94703209700003, 9.693182684000078],
              [79.94288170700008, 9.702826239000046],
              [79.94092858200008, 9.714341539000088],
              [79.93702233200008, 9.727362372000073],
              [79.93043053500008, 9.738470770000049],
              [79.92652428500008, 9.743516343000067],
              [79.91627037900008, 9.756781317000048],
              [79.90967858200008, 9.76829661700009],
              [79.93132571700005, 9.779038804000038],
              [79.97071373800003, 9.815130927000041],
              [79.98845462300005, 9.822943427000041],
              [79.98853600400008, 9.822943427000041],
              [80.06666100400008, 9.816107489000046],
              [80.10743248800003, 9.82062409100007],
              [80.12232506600003, 9.818915106000077],
              [80.12818444100003, 9.805568752000056],
              [80.12720787900008, 9.78461334800005],
              [80.13013756600003, 9.77732982000009],
              [80.13868248800003, 9.774562893000052],
              [80.14698326900003, 9.773382880000042],
              [80.17090905000003, 9.767279364000046],
              [80.17595462300005, 9.764593817000048],
              [80.18043053500008, 9.755804755000042],
              [80.19117272200003, 9.75617096600007],
              [80.19963626400005, 9.758734442000048],
              [80.20289147200003, 9.759711005000042],
              [80.20777428500008, 9.76040273600006],
              [80.21119225400008, 9.760891018000052],
              [80.21127363400007, 9.76085032800006],
              [80.21900475400008, 9.756374416000085],
              [80.22234134200005, 9.754461981000077],
              [80.25033613400007, 9.724269924000055],
              [80.33855228000004, 9.62921784100007],
              [80.36963951900003, 9.609849351000037],
              [80.44174238400007, 9.57689036700009],
              [80.44402103000004, 9.575913804000038],
              [80.44402103000004, 9.583319403000075],
              [80.40772545700008, 9.601507880000042],
              [80.31983483200008, 9.672756252000056],
              [80.24781334700003, 9.755072333000044],
              [80.21119225400008, 9.77452220300006],
              [80.15381920700008, 9.787990627000056],
              [80.13868248800003, 9.79873281500005],
              [80.13672936300003, 9.81391022300005],
              [80.15772545700008, 9.822943427000041],
              [80.16456139400003, 9.82408274900007],
              [80.18539472700007, 9.827541408000059],
              [80.22681725400008, 9.829575914000088],
              [80.24675540500004, 9.825873114000046],
              [80.26059004000007, 9.816229559000078],
              [80.26978600400008, 9.78351471600007],
              [80.27898196700005, 9.76984284100007],
              [80.40992272200003, 9.61749909100007],
              [80.42920983200008, 9.603461005000042],
              [80.46827233200008, 9.581366278000075],
              [80.74439537900008, 9.35968659100007],
              [80.74545332100007, 9.357896226000037],
              [80.75245201900003, 9.346258856000077],
              [80.76368248800003, 9.332424221000053],
              [80.78516686300003, 9.31240469000005],
              [80.79883873800003, 9.294867255000042],
              [80.78671308700007, 9.288560289000088],
              [80.78663170700008, 9.28851959800005],
              [80.77979576900003, 9.291571356000077],
              [80.77898196700005, 9.291937567000048],
              [80.77881920700008, 9.29197825700004],
              [80.76832116000008, 9.30540599200009],
              [80.76254316500007, 9.308335679000038],
              [80.76246178500008, 9.308417059000078],
              [80.74439537900008, 9.311346747000073],
              [80.73650149800005, 9.308986721000053],
              [80.74040774800005, 9.30101146000004],
              [80.74170983200008, 9.298488674000055],
              [80.79363040500004, 9.250555731000077],
              [80.81389407600005, 9.239528713000084],
              [80.81397545700008, 9.239488023000092],
              [80.80591881600003, 9.251898505000042],
              [80.80103600400008, 9.263251044000071],
              [80.80355879000007, 9.271633205000057],
              [80.81739342500003, 9.27484772300005],
              [80.82390384200005, 9.27049388200004],
              [80.83448326900003, 9.239488023000092],
              [80.84416751400005, 9.220404364000046],
              [80.88217207100007, 9.14516836100006],
              [80.87452233200008, 9.14797597900008],
              [80.85336347700007, 9.155747789000088],
              [80.84009850400008, 9.155991929000038],
              [80.83448326900003, 9.141750393000052],
              [80.84229576900003, 9.13812897300005],
              [80.85857181100005, 9.13548411700009],
              [80.87305748800003, 9.126450914000088],
              [80.87322024800005, 9.12523021000004],
              [80.87533613400007, 9.103583075000074],
              [80.87549889400003, 9.103583075000074],
              [80.88217207100007, 9.103583075000074],
              [80.88550866000008, 9.109320380000042],
              [80.88851972700007, 9.111802476000037],
              [80.89193769600007, 9.113430080000057],
              [80.89649498800003, 9.116603908000059],
              [80.89649498800003, 9.116522528000075],
              [80.90162194100003, 9.09666575700004],
              [80.90219160200007, 9.094183661000045],
              [80.91635175900007, 9.062160549000055],
              [80.93531334700003, 9.03343333500004],
              [80.95460045700008, 9.020982164000088],
              [80.95606530000003, 9.019802151000079],
              [80.95834394600007, 9.01788971600007],
              [80.95826256600003, 9.010891018000052],
              [80.95362389400003, 9.003851630000042],
              [80.94434655000003, 9.000555731000077],
              [80.94166100400008, 9.003485419000071],
              [80.93067467500003, 9.020982164000088],
              [80.91871178500008, 9.02724844000005],
              [80.89128665500004, 9.03424713700008],
              [80.87533613400007, 9.041489976000037],
              [80.88266035200007, 9.031398830000057],
              [80.88672936300003, 9.025783596000053],
              [80.92286217500003, 8.992254950000074],
              [80.92318769600007, 8.973211981000077],
              [80.93506920700008, 8.964911200000074],
              [80.93498782600005, 8.96482982000009],
              [80.92432701900003, 8.955023505000042],
              [80.91488691500007, 8.943915106000077],
              [80.91496829500005, 8.943874416000085],
              [80.93067467500003, 8.93162669500009],
              [80.94760175900007, 8.932928778000075],
              [80.96143639400003, 8.945746161000045],
              [80.97169030000003, 8.963568427000041],
              [80.97836347700007, 8.980047919000071],
              [80.97852623800003, 8.979966539000088],
              [81.01465905000003, 8.936712958000044],
              [81.04672285200007, 8.882147528000075],
              [81.05982506600003, 8.868638414000088],
              [81.07813561300003, 8.863348700000074],
              [81.09278405000003, 8.851629950000074],
              [81.11426842500003, 8.799994208000044],
              [81.11972089900007, 8.794338283000059],
              [81.12549889400003, 8.788275458000044],
              [81.12558027400007, 8.788234768000052],
              [81.15015709700003, 8.777167059000078],
              [81.16244550900007, 8.751166083000044],
              [81.17652428500008, 8.698879299000055],
              [81.17904707100007, 8.708482164000088],
              [81.18230228000004, 8.712225653000075],
              [81.18775475400008, 8.711004950000074],
              [81.18783613400007, 8.710964260000083],
              [81.19752037900008, 8.70571523600006],
              [81.19459069100003, 8.696112372000073],
              [81.22242272200003, 8.66600169500009],
              [81.23170006600003, 8.651068427000041],
              [81.23161868600005, 8.63304271000004],
              [81.22429446700005, 8.625799872000073],
              [81.21387780000003, 8.621039130000042],
              [81.20435631600003, 8.61009349200009],
              [81.20451907600005, 8.610174872000073],
              [81.21176191500007, 8.612005927000041],
              [81.21924889400003, 8.61391836100006],
              [81.22112063900005, 8.614935614000046],
              [81.22486412900008, 8.616929429000038],
              [81.22494550900007, 8.616848049000055],
              [81.24659264400003, 8.570135809000078],
              [81.24976647200003, 8.545803127000056],
              [81.22494550900007, 8.541815497000073],
              [81.22486412900008, 8.541815497000073],
              [81.22999108200008, 8.557928778000075],
              [81.22331790500004, 8.570868231000077],
              [81.21225019600007, 8.572699286000045],
              [81.20435631600003, 8.555487372000073],
              [81.20704186300003, 8.542141018000052],
              [81.21412194100003, 8.53266022300005],
              [81.21802819100003, 8.52252838700008],
              [81.21062259200005, 8.507066148000092],
              [81.20476321700005, 8.511542059000078],
              [81.19385826900003, 8.519964911000045],
              [81.17652428500008, 8.530585028000075],
              [81.15902754000007, 8.534572658000059],
              [81.14234459700003, 8.52757396000004],
              [81.12940514400003, 8.510321356000077],
              [81.13396243600005, 8.501288153000075],
              [81.14942467500003, 8.503648179000038],
              [81.17025800900007, 8.520697333000044],
              [81.18458092500003, 8.505601304000038],
              [81.19752037900008, 8.487494208000044],
              [81.21314537900008, 8.472398179000038],
              [81.23511803500008, 8.466131903000075],
              [81.28109785200007, 8.46702708500004],
              [81.29664147200003, 8.47679271000004],
              [81.28638756600003, 8.50023021000004],
              [81.31267337300005, 8.512152411000045],
              [81.32309004000007, 8.515326239000046],
              [81.33415774800005, 8.514553127000056],
              [81.33423912900008, 8.514471747000073],
              [81.34636478000004, 8.507554429000038],
              [81.35743248800003, 8.495835679000038],
              [81.36573326900003, 8.482163804000038],
              [81.37281334700003, 8.44212474200009],
              [81.38843834700003, 8.39061107000009],
              [81.38892662900008, 8.37718333500004],
              [81.38941491000008, 8.363714911000045],
              [81.37671959700003, 8.372544664000088],
              [81.36345462300005, 8.39907461100006],
              [81.35181725400008, 8.404689846000053],
              [81.35141035200007, 8.39744700700004],
              [81.35621178500008, 8.364976304000038],
              [81.35661868600005, 8.362494208000044],
              [81.36207116000008, 8.350043036000045],
              [81.36874433700007, 8.346909898000092],
              [81.37484785200007, 8.34406159100007],
              [81.37501061300003, 8.34406159100007],
              [81.38851972700007, 8.34406159100007],
              [81.39926191500007, 8.339260158000059],
              [81.40560957100007, 8.30101146000004],
              [81.41325931100005, 8.27448151200008],
              [81.41456139400003, 8.270086981000077],
              [81.41667728000004, 8.253851630000042],
              [81.41667728000004, 8.25377024900007],
              [81.41976972700007, 8.243394273000092],
              [81.44060306100005, 8.173529364000046],
              [81.44849694100003, 8.12799713700008],
              [81.43034915500004, 8.103135484000063],
              [81.43034915500004, 8.103013414000088],
              [81.42025800900007, 8.144232489000046],
              [81.41879316500007, 8.150051174000055],
              [81.40357506600003, 8.191799221000053],
              [81.39625084700003, 8.191799221000053],
              [81.39503014400003, 8.160101630000042],
              [81.39625084700003, 8.150132554000038],
              [81.39551842500003, 8.150458075000074],
              [81.39478600400008, 8.147609768000052],
              [81.39478600400008, 8.14752838700008],
              [81.39478600400008, 8.14256419500009],
              [81.39625084700003, 8.136542059000078],
              [81.39958743600005, 8.132635809000078],
              [81.40805097700007, 8.130072333000044],
              [81.40813235800005, 8.130031643000052],
              [81.40984134200005, 8.126898505000042],
              [81.41797936300003, 8.105943101000037],
              [81.43555748800003, 8.093166408000059],
              [81.43563886800007, 8.093166408000059],
              [81.45240319100003, 8.094549872000073],
              [81.45826256600003, 8.116034247000073],
              [81.46436608200008, 8.116034247000073],
              [81.47071373800003, 8.10455963700008],
              [81.47242272200003, 8.10146719000005],
              [81.48064212300005, 8.065375067000048],
              [81.48902428500008, 8.05149974200009],
              [81.50017337300005, 8.03937409100007],
              [81.50733483200008, 8.02757396000004],
              [81.51970462300005, 7.999335028000075],
              [81.52458743600005, 8.00421784100007],
              [81.53101647200003, 8.009019273000092],
              [81.53394616000008, 8.013617255000042],
              [81.53834069100003, 8.004299221000053],
              [81.53394616000008, 7.999335028000075],
              [81.53614342500003, 7.995754299000055],
              [81.53809655000003, 7.993394273000092],
              [81.53842207100007, 7.992783921000068],
              [81.53956139400003, 7.990790106000077],
              [81.54021243600005, 7.986314195000091],
              [81.54029381600003, 7.986395575000074],
              [81.54525800900007, 7.990464585000041],
              [81.55551191500007, 7.995347398000092],
              [81.56072024800005, 7.999335028000075],
              [81.56072024800005, 7.999253648000092],
              [81.56308027400007, 7.993638414000088],
              [81.56592858200008, 7.986802476000037],
              [81.56381269600007, 7.978705145000049],
              [81.56031334700003, 7.970648505000042],
              [81.56047610800005, 7.964422919000071],
              [81.56072024800005, 7.958400783000059],
              [81.56771894600007, 7.944973049000055],
              [81.58008873800003, 7.935573635000083],
              [81.58814537900008, 7.929429429000038],
              [81.59546959700003, 7.91742584800005],
              [81.59083092500003, 7.917141018000052],
              [81.58847089900007, 7.91555410400008],
              [81.58545983200008, 7.91351959800005],
              [81.58358808700007, 7.912339585000041],
              [81.58171634200005, 7.911200262000079],
              [81.57878665500004, 7.900295315000051],
              [81.57585696700005, 7.88939036700009],
              [81.58757571700005, 7.855292059000078],
              [81.59392337300005, 7.848049221000053],
              [81.60824629000007, 7.831691799000055],
              [81.60840905000003, 7.831691799000055],
              [81.62956790500004, 7.835516669000071],
              [81.63640384200005, 7.835516669000071],
              [81.64332116000008, 7.814642645000049],
              [81.65121504000007, 7.801743882000039],
              [81.65365644600007, 7.797756252000056],
              [81.69678795700008, 7.752997137000079],
              [81.71070397200003, 7.731146552000041],
              [81.71314537900008, 7.711818752000056],
              [81.69100996200007, 7.705186265000066],
              [81.69092858200008, 7.705145575000074],
              [81.68067467500003, 7.712062893000052],
              [81.65609785200007, 7.743109442000048],
              [81.64323978000004, 7.754136460000041],
              [81.62663821700005, 7.760199286000045],
              [81.62647545700008, 7.760199286000045],
              [81.62476647200003, 7.760036526000079],
              [81.61296634200005, 7.759019273000092],
              [81.60254967500003, 7.748439846000053],
              [81.59546959700003, 7.726263739000046],
              [81.60743248800003, 7.720851955000057],
              [81.61898847700007, 7.719224351000037],
              [81.62891686300003, 7.722886460000041],
              [81.63640384200005, 7.733099677000041],
              [81.64820397200003, 7.728705145000049],
              [81.65902754000007, 7.723334052000041],
              [81.66277103000004, 7.718939520000049],
              [81.66529381600003, 7.715887762000079],
              [81.66374759200005, 7.705145575000074],
              [81.67701256600003, 7.69281647300005],
              [81.69027754000007, 7.680487372000073],
              [81.70069420700008, 7.66860586100006],
              [81.71159915500004, 7.650539455000057],
              [81.71151777400007, 7.650498765000066],
              [81.70639082100007, 7.644598700000074],
              [81.70508873800003, 7.638861395000049],
              [81.70679772200003, 7.631984768000052],
              [81.71159915500004, 7.622544664000088],
              [81.71778405000003, 7.630072333000044],
              [81.71404056100005, 7.64366282800006],
              [81.71404056100005, 7.643744208000044],
              [81.72584069100003, 7.639593817000048],
              [81.74903405000003, 7.622544664000088],
              [81.75456790500004, 7.614569403000075],
              [81.77295983200008, 7.567979234000063],
              [81.77182050900007, 7.565985419000071],
              [81.76612389400003, 7.540676174000055],
              [81.76693769600007, 7.537909247000073],
              [81.76710045700008, 7.537502346000053],
              [81.77182050900007, 7.527818101000094],
              [81.77295983200008, 7.523911851000094],
              [81.76905358200008, 7.51703522300005],
              [81.76189212300005, 7.511542059000078],
              [81.75757897200003, 7.505438544000071],
              [81.76270592500003, 7.496568101000094],
              [81.76758873800003, 7.490179755000042],
              [81.76929772200003, 7.485174872000073],
              [81.76954186300003, 7.484523830000057],
              [81.77247155000003, 7.47882721600007],
              [81.77979576900003, 7.472357489000046],
              [81.76905358200008, 7.464626369000086],
              [81.77003014400003, 7.460842190000051],
              [81.77100670700008, 7.456976630000042],
              [81.77906334700003, 7.455308335000041],
              [81.78711998800003, 7.46556224200009],
              [81.79330488400007, 7.46556224200009],
              [81.79338626400005, 7.465521552000041],
              [81.80103600400008, 7.425197658000059],
              [81.80079186300003, 7.410345770000049],
              [81.80095462300005, 7.410345770000049],
              [81.80779056100005, 7.410345770000049],
              [81.80779056100005, 7.410711981000077],
              [81.80860436300003, 7.424709377000056],
              [81.81104576900003, 7.438544012000079],
              [81.81527754000007, 7.450344143000052],
              [81.82146243600005, 7.458726304000038],
              [81.82146243600005, 7.465521552000041],
              [81.82089277400007, 7.46710846600007],
              [81.81869550900007, 7.47337474200009],
              [81.82048587300005, 7.476507880000042],
              [81.82601972700007, 7.474188544000071],
              [81.83497155000003, 7.46556224200009],
              [81.83806399800005, 7.45766836100006],
              [81.84034264400003, 7.436468817000048],
              [81.85572350400008, 7.412176825000074],
              [81.88070722700007, 7.327093817000048],
              [81.87598717500003, 7.091945705000057],
            ],
          ],
          [
            [
              [81.73878014400003, 7.66046784100007],
              [81.73707116000008, 7.670965887000079],
              [81.73316491000008, 7.679103908000059],
              [81.72836347700007, 7.689113674000055],
              [81.72510826900003, 7.698919989000046],
              [81.72559655000003, 7.70929596600007],
              [81.72868899800005, 7.718491929000038],
              [81.72999108200008, 7.728176174000055],
              [81.72510826900003, 7.739813544000071],
              [81.72510826900003, 7.739935614000046],
              [81.73796634200005, 7.727484442000048],
              [81.75025475400008, 7.698635158000059],
              [81.75928795700008, 7.685288804000038],
              [81.76148522200003, 7.679510809000078],
              [81.77076256600003, 7.654689846000053],
              [81.79509524800005, 7.616278387000079],
              [81.80632571700005, 7.598578192000048],
              [81.82325280000003, 7.511379299000055],
              [81.82325280000003, 7.511297919000071],
              [81.82260175900007, 7.491359768000052],
              [81.80779056100005, 7.479193427000041],
              [81.79371178500008, 7.490220445000091],
              [81.78939863400007, 7.494737046000068],
              [81.78736412900008, 7.49681224200009],
              [81.78671308700007, 7.501776434000078],
              [81.78598066500007, 7.506740627000056],
              [81.78614342500003, 7.508775132000039],
              [81.79029381600003, 7.57172272300005],
              [81.78736412900008, 7.593451239000046],
              [81.77637780000003, 7.602728583000044],
              [81.77222741000008, 7.61163971600007],
              [81.73878014400003, 7.66046784100007],
            ],
          ],
          [
            [
              [79.71412194100003, 9.07562897300005],
              [79.70297285200007, 9.07998281500005],
              [79.69800866000008, 9.089585679000038],
              [79.70118248800003, 9.099188544000071],
              [79.71412194100003, 9.103583075000074],
              [79.75879967500003, 9.103583075000074],
              [79.77857506600003, 9.098537502000056],
              [79.79900149800005, 9.093329169000071],
              [79.84164472700007, 9.07721588700008],
              [79.88233483200008, 9.05377838700008],
              [79.91651451900003, 9.020982164000088],
              [79.91643313900005, 9.02102285400008],
              [79.90007571700005, 9.02440013200004],
              [79.87126712300005, 9.038560289000088],
              [79.85434004000007, 9.041489976000037],
              [79.88030032600005, 9.012193101000037],
              [79.90072675900007, 8.989081122000073],
              [79.90967858200008, 8.973211981000077],
              [79.88575280000003, 8.976223049000055],
              [79.87012780000003, 8.98818594000005],
              [79.85938561300003, 9.001206773000092],
              [79.85132897200003, 9.007391669000071],
              [79.84099368600005, 9.012600002000056],
              [79.79981530000003, 9.048976955000057],
              [79.77938886800007, 9.058010158000059],
              [79.75896243600005, 9.06704336100006],
              [79.74398847700007, 9.071071682000081],
              [79.73601321700005, 9.07322825700004],
              [79.71412194100003, 9.07562897300005],
            ],
          ],
          [
            [
              [79.73080488400007, 9.500189520000049],
              [79.72282962300005, 9.492621161000045],
              [79.71469160200007, 9.485052802000041],
              [79.68946373800003, 9.483587958000044],
              [79.66602623800003, 9.49127838700008],
              [79.65577233200008, 9.50389232000009],
              [79.65577233200008, 9.544867255000042],
              [79.65870201900003, 9.555365302000041],
              [79.66529381600003, 9.554022528000075],
              [79.67212975400008, 9.545599677000041],
              [79.67628014400003, 9.534979559000078],
              [79.69353274800005, 9.52960846600007],
              [79.71412194100003, 9.52806224200009],
              [79.71924889400003, 9.524359442000048],
              [79.73080488400007, 9.500189520000049],
            ],
          ],
          [
            [
              [79.89584394600007, 9.61749909100007],
              [79.88038170700008, 9.628607489000046],
              [79.86491946700005, 9.651516018000052],
              [79.84066816500007, 9.699408270000049],
              [79.85173587300005, 9.716538804000038],
              [79.85425866000008, 9.738470770000049],
              [79.86052493600005, 9.756252346000053],
              [79.88233483200008, 9.760891018000052],
              [79.89389082100007, 9.757432359000063],
              [79.89405358200008, 9.757391669000071],
              [79.89503014400003, 9.748968817000048],
              [79.89112389400003, 9.737209377000056],
              [79.88843834700003, 9.72361888200004],
              [79.88884524800005, 9.709906317000048],
              [79.89031009200005, 9.698960679000038],
              [79.89039147200003, 9.69830963700008],
              [79.89128665500004, 9.696112372000073],
              [79.89470462300005, 9.688177802000041],
              [79.89926191500007, 9.683010158000059],
              [79.90284264400003, 9.678941148000092],
              [79.90707441500007, 9.677883205000057],
              [79.92644290500004, 9.678941148000092],
              [79.92969811300003, 9.675970770000049],
              [79.93116295700008, 9.660956122000073],
              [79.93360436300003, 9.654730536000045],
              [79.94499759200005, 9.647609768000052],
              [79.96045983200008, 9.641058661000045],
              [79.97339928500008, 9.63377513200004],
              [79.97445722700007, 9.63149648600006],
              [79.97787519600007, 9.624335028000075],
              [79.97095787900008, 9.617254950000074],
              [79.95777428500008, 9.61717357000009],
              [79.94361412900008, 9.621527411000045],
              [79.93360436300003, 9.627752997000073],
              [79.92652428500008, 9.629461981000077],
              [79.90853925900007, 9.618963934000078],
              [79.89592532600005, 9.61749909100007],
              [79.89584394600007, 9.61749909100007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Taiwan',
        iso3: 'TWN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [121.90577233200008, 24.950100002000056],
              [121.83472741000003, 24.871527411000045],
              [121.82349694100003, 24.85492584800005],
              [121.81462649800005, 24.831732489000046],
              [121.80884850400003, 24.805161851000037],
              [121.80681399800005, 24.77875397300005],
              [121.80779056100005, 24.753119208000044],
              [121.82032311300009, 24.699652411000045],
              [121.81959069100003, 24.685980536000045],
              [121.81421959700003, 24.672308661000045],
              [121.81495201900009, 24.644354559000078],
              [121.82797285200002, 24.622788804000038],
              [121.85271243600005, 24.60887278900009],
              [121.88184655000009, 24.603989976000037],
              [121.88184655000009, 24.597805080000057],
              [121.869476759, 24.598944403000075],
              [121.857758009, 24.59784577000005],
              [121.84791100400003, 24.594916083000044],
              [121.84083092500009, 24.590318101000037],
              [121.85084069100003, 24.57298411700009],
              [121.85596764400009, 24.550523179000038],
              [121.85279381600003, 24.530991929000038],
              [121.83008873800009, 24.519232489000046],
              [121.82837975400003, 24.51072825700004],
              [121.83130944100003, 24.500392971000053],
              [121.83773847700002, 24.491034247000073],
              [121.84001712300005, 24.481350002000056],
              [121.830414259, 24.473130601000037],
              [121.80681399800005, 24.460638739000046],
              [121.78003991000003, 24.43268463700008],
              [121.77914472700002, 24.42177969000005],
              [121.78077233200008, 24.397609768000052],
              [121.77637780000009, 24.388332424000055],
              [121.77149498800009, 24.380560614000046],
              [121.76840254000001, 24.36937083500004],
              [121.76644941500001, 24.347357489000046],
              [121.76433353000004, 24.34170156500005],
              [121.76050866000003, 24.337103583000044],
              [121.75855553500003, 24.33234284100007],
              [121.76254316500001, 24.326605536000045],
              [121.76335696700005, 24.325791734000063],
              [121.76587975400003, 24.323187567000048],
              [121.76929772200003, 24.318060614000046],
              [121.77198326900009, 24.312933661000045],
              [121.77271569100003, 24.30923086100006],
              [121.76742597700002, 24.300930080000057],
              [121.74529056100005, 24.28123607000009],
              [121.72144616000003, 24.251166083000044],
              [121.70386803500003, 24.238348700000074],
              [121.69825280000009, 24.23151276200008],
              [121.70093834700003, 24.22418854400007],
              [121.69776451900009, 24.21898021000004],
              [121.67237389400009, 24.20148346600007],
              [121.66285241000003, 24.193101304000038],
              [121.65219160200002, 24.17218659100007],
              [121.64128665500004, 24.12986888200004],
              [121.61304772200003, 24.09210846600007],
              [121.60743248800009, 24.07684967700004],
              [121.60816491000003, 24.060492255000042],
              [121.61500084700003, 24.042303778000075],
              [121.62077884200005, 24.03461334800005],
              [121.62574303500003, 24.030951239000046],
              [121.62891686300009, 24.026190497000073],
              [121.62916100400003, 24.014960028000075],
              [121.62501061300009, 24.002386786000045],
              [121.61109459700003, 23.982489325000074],
              [121.60816491000003, 23.970363674000055],
              [121.60670006600003, 23.948065497000073],
              [121.59449303500003, 23.891506252000056],
              [121.57032311300009, 23.832098700000074],
              [121.53980553500003, 23.69281647300005],
              [121.52149498800009, 23.658677476000037],
              [121.47950280000009, 23.435207424000055],
              [121.46216881600003, 23.343003648000035],
              [121.45362389400009, 23.325995184000078],
              [121.42676842500009, 23.293117580000057],
              [121.41675866000003, 23.27606842700004],
              [121.40886478000004, 23.25458405200004],
              [121.40333092500009, 23.21474844000005],
              [121.40381920700008, 23.17926666900007],
              [121.40007571700005, 23.14549388200004],
              [121.38160241000003, 23.110663153000075],
              [121.37370853000004, 23.103216864000046],
              [121.35547936300009, 23.091009833000044],
              [121.34742272200003, 23.083319403000075],
              [121.34343509200005, 23.075384833000044],
              [121.33708743600005, 23.055080471000053],
              [121.31885826900009, 23.025539455000057],
              [121.30762780000009, 22.979803778000075],
              [121.29957116000003, 22.95917389500005],
              [121.26050866000003, 22.90729401200008],
              [121.25562584700003, 22.897772528000075],
              [121.20281009200005, 22.85651276200008],
              [121.19027754000001, 22.84316640800006],
              [121.18848717500009, 22.833929755000042],
              [121.19092858200008, 22.81195709800005],
              [121.19027754000001, 22.80215078300006],
              [121.18555748800009, 22.790961005000042],
              [121.17741946700005, 22.778631903000075],
              [121.15935306100005, 22.757473049000055],
              [121.14144941500001, 22.74176666900007],
              [121.08025149800005, 22.70408763200004],
              [121.03907311300009, 22.66242096600007],
              [121.02906334700003, 22.657538153000075],
              [121.02100670700008, 22.64789459800005],
              [121.00114993600005, 22.600775458000044],
              [120.99122155000009, 22.58307526200008],
              [120.96062259200005, 22.547796942000048],
              [120.94825280000009, 22.52680084800005],
              [120.94109134200005, 22.483628648000035],
              [120.92286217500009, 22.424750067000048],
              [120.88656660200002, 22.36595286700009],
              [120.88135826900009, 22.34593333500004],
              [120.87501061300009, 22.28925202000005],
              [120.87598717500009, 22.23769765800006],
              [120.879242384, 22.055812893000052],
              [120.87330162900003, 22.02997467700004],
              [120.863617384, 22.008937893000052],
              [120.85084069100003, 22.00023021000004],
              [120.83570397200003, 21.987250067000048],
              [120.83619225400003, 21.95770905200004],
              [120.84156334700003, 21.925482489000046],
              [120.84034264400009, 21.90460846600007],
              [120.82309004000001, 21.928615627000056],
              [120.79737389400009, 21.94676341400009],
              [120.76742597700002, 21.95929596600007],
              [120.73731530000009, 21.966131903000075],
              [120.73609459700003, 21.94281647300005],
              [120.72730553500003, 21.934475002000056],
              [120.71436608200008, 21.93748607000009],
              [120.70036868600005, 21.948431708000044],
              [120.699554884, 21.956691799000055],
              [120.70435631600003, 21.981390692000048],
              [120.68336022200003, 22.01386139500005],
              [120.68165123800009, 22.02252838700008],
              [120.68189537900003, 22.02960846600007],
              [120.68336022200003, 22.04120514500005],
              [120.68336022200003, 22.079046942000048],
              [120.68555748800009, 22.09015534100007],
              [120.69483483200008, 22.10260651200008],
              [120.69695071700005, 22.113226630000042],
              [120.62126712300005, 22.295070705000057],
              [120.61500084700003, 22.30499909100007],
              [120.59392337300005, 22.32916901200008],
              [120.57732181100005, 22.363836981000077],
              [120.56967207100001, 22.373846747000073],
              [120.53874759200005, 22.396429755000042],
              [120.52637780000009, 22.40302155200004],
              [120.52222741000003, 22.40428294500009],
              [120.51807701900009, 22.40696849200009],
              [120.51441491000003, 22.420070705000057],
              [120.51197350400003, 22.424750067000048],
              [120.49529056100005, 22.434759833000044],
              [120.45720462300005, 22.451605536000045],
              [120.43995201900009, 22.462591864000046],
              [120.42172285200002, 22.477362372000073],
              [120.41325931100005, 22.48232656500005],
              [120.40211022200003, 22.486802476000037],
              [120.39600670700008, 22.486476955000057],
              [120.389008009, 22.484076239000046],
              [120.38086998800009, 22.48387278900009],
              [120.33122806100005, 22.51972077000005],
              [120.28516686300009, 22.58006419500009],
              [120.33366946700005, 22.525946356000077],
              [120.32797285200002, 22.551703192000048],
              [120.31991621200007, 22.56582265800006],
              [120.31348717500009, 22.577053127000056],
              [120.293304884, 22.59829336100006],
              [120.25896243600005, 22.62759023600006],
              [120.24577884200005, 22.642523505000042],
              [120.23959394600001, 22.659084377000056],
              [120.24781334700003, 22.67523834800005],
              [120.25212649800005, 22.68964264500005],
              [120.24634850400003, 22.709906317000048],
              [120.23617597700002, 22.72988515800006],
              [120.21753991000003, 22.756740627000056],
              [120.19996178500003, 22.79246653900009],
              [120.19605553500003, 22.808335679000038],
              [120.19646243600005, 22.81858958500004],
              [120.20215905000009, 22.831244208000044],
              [120.203461134, 22.839667059000078],
              [120.20134524800005, 22.844142971000053],
              [120.19646243600005, 22.847479559000078],
              [120.19141686300009, 22.852036851000037],
              [120.18921959700003, 22.860174872000073],
              [120.17847741000003, 22.877346096000053],
              [120.17554772200003, 22.884100653000075],
              [120.16749108200008, 22.93187083500004],
              [120.16382897200003, 22.95384349200009],
              [120.15691165500004, 22.966538804000038],
              [120.14210045700008, 22.980292059000078],
              [120.16016686300009, 22.992132880000042],
              [120.170258009, 23.013373114000046],
              [120.16618899800005, 23.031724351000037],
              [120.14210045700008, 23.034898179000038],
              [120.13746178500003, 23.02838776200008],
              [120.13347415500004, 23.016546942000048],
              [120.12671959700003, 23.007147528000075],
              [120.11410566500001, 23.007635809000078],
              [120.10914147200003, 23.015448309000078],
              [120.11101321700005, 23.039984442000048],
              [120.10792076900009, 23.048570054000038],
              [120.09245853000004, 23.054754950000074],
              [120.08375084700003, 23.04755280200004],
              [120.07667076900009, 23.03742096600007],
              [120.06625410200002, 23.034898179000038],
              [120.05518639400009, 23.04368724200009],
              [120.05241946700005, 23.055812893000052],
              [120.05494225400003, 23.06777578300006],
              [120.05941816500001, 23.075873114000046],
              [120.07056725400003, 23.081203518000052],
              [120.08472741000003, 23.082953192000048],
              [120.09644616000003, 23.086411851000037],
              [120.10043379000001, 23.096991278000075],
              [120.09498131600003, 23.102484442000048],
              [120.05941816500001, 23.110663153000075],
              [120.05941816500001, 23.11749909100007],
              [120.08920332100001, 23.117743231000077],
              [120.086273634, 23.12693919500009],
              [120.07007897200003, 23.139797268000052],
              [120.05941816500001, 23.15102773600006],
              [120.06202233200008, 23.16502513200004],
              [120.07154381600003, 23.169989325000074],
              [120.08187910200002, 23.173163153000075],
              [120.08692467500009, 23.182033596000053],
              [120.08383222700002, 23.195746161000045],
              [120.07862389400009, 23.206976630000042],
              [120.08215891700002, 23.21729237900007],
              [120.08744371300008, 23.230287823000083],
              [120.096097504, 23.23949089200005],
              [120.09424889400009, 23.24750397300005],
              [120.096039259, 23.25535716400009],
              [120.10889733200008, 23.28668854400007],
              [120.11491946700005, 23.292710679000038],
              [120.12468509200005, 23.294989325000074],
              [120.11049353800001, 23.303698714000063],
              [120.116527217, 23.317897404000064],
              [120.13117971100007, 23.31881007800007],
              [120.14356530000009, 23.323879299000055],
              [120.14893639400009, 23.32225169500009],
              [120.14576256600003, 23.333319403000075],
              [120.13734148200001, 23.32773406000007],
              [120.130284437, 23.329334817000074],
              [120.12094160200002, 23.329738674000055],
              [120.12077884200005, 23.34125397300005],
              [120.13014916000009, 23.36096024400007],
              [120.14416428100003, 23.36185437200004],
              [120.1645773890001, 23.36171145600008],
              [120.15064537900003, 23.398138739000046],
              [120.13477623800009, 23.426255601000037],
              [120.14210045700008, 23.43895091400009],
              [120.14210045700008, 23.445786851000037],
              [120.13054446700005, 23.450995184000078],
              [120.13209069100003, 23.456976630000042],
              [120.13868248800009, 23.46426015800006],
              [120.14210045700008, 23.473089911000045],
              [120.15754360400001, 23.491475715000036],
              [120.12502924700004, 23.489611410000066],
              [120.1242615330001, 23.520020550000083],
              [120.14168913100002, 23.537946590000047],
              [120.14086753400011, 23.595262518000084],
              [120.143609008, 23.63803570200008],
              [120.1542299140001, 23.672211863000086],
              [120.17080496100004, 23.69890152000005],
              [120.17554772200003, 23.73383209800005],
              [120.18441816500001, 23.76439036700009],
              [120.18921959700003, 23.77480703300006],
              [120.21265709700003, 23.803168036000045],
              [120.21656334700003, 23.812648830000057],
              [120.21949303500003, 23.81793854400007],
              [120.24073326900009, 23.832831122000073],
              [120.24675540500004, 23.843410549000055],
              [120.25294030000009, 23.868068752000056],
              [120.25749759200005, 23.87840403900009],
              [120.28443444100003, 23.902004299000055],
              [120.29224694100003, 23.911932684000078],
              [120.30250084700003, 23.93886953300006],
              [120.31812584700003, 23.96580638200004],
              [120.34009850400003, 24.02179596600007],
              [120.35035241000003, 24.03807200700004],
              [120.36182701900009, 24.048529364000046],
              [120.37126712300005, 24.054348049000055],
              [120.37956790500004, 24.05801015800006],
              [120.38550866000003, 24.063055731000077],
              [120.38786868600005, 24.07330963700008],
              [120.39234459700003, 24.082912502000056],
              [120.41187584700003, 24.096909898000035],
              [120.416351759, 24.107489325000074],
              [120.41863040500004, 24.142523505000042],
              [120.42204837300005, 24.152167059000078],
              [120.43230228000004, 24.161078192000048],
              [120.47543379000001, 24.207098700000074],
              [120.47779381600003, 24.20966217700004],
              [120.48064212300005, 24.221096096000053],
              [120.49317467500009, 24.23065827000005],
              [120.50163821700005, 24.252875067000048],
              [120.51197350400003, 24.29555898600006],
              [120.54737389400009, 24.35154857000009],
              [120.55811608200008, 24.385891018000052],
              [120.57081139400009, 24.40493398600006],
              [120.62134850400003, 24.456000067000048],
              [120.64893639400009, 24.48387278900009],
              [120.65601647200003, 24.497870184000078],
              [120.65935306100005, 24.520697333000044],
              [120.66773522200003, 24.54002513200004],
              [120.69019616000003, 24.576117255000042],
              [120.69629967500009, 24.597723700000074],
              [120.70215905000009, 24.60700104400007],
              [120.72787519600001, 24.61391836100006],
              [120.73511803500003, 24.621242580000057],
              [120.73943118600005, 24.63035716400009],
              [120.74463951900009, 24.638820705000057],
              [120.76059004000001, 24.653957424000055],
              [120.77808678500003, 24.665716864000046],
              [120.79932701900009, 24.670803127000056],
              [120.82667076900009, 24.666083075000074],
              [120.82300866000003, 24.68504466400009],
              [120.83334394600001, 24.697821356000077],
              [120.84750410200002, 24.71084219000005],
              [120.85450280000009, 24.73065827000005],
              [120.85767662900003, 24.73700592700004],
              [120.87134850400003, 24.74323151200008],
              [120.87696373800009, 24.76190827000005],
              [120.89812259200005, 24.801174221000053],
              [120.90642337300005, 24.811468817000048],
              [120.90919030000009, 24.816880601000037],
              [120.90902754000001, 24.822739976000037],
              [120.90650475400003, 24.82908763200004],
              [120.90235436300009, 24.836818752000056],
              [120.90805097700002, 24.84707265800006],
              [120.91464277400007, 24.85342031500005],
              [120.91488691500001, 24.85370514500005],
              [120.92058353000004, 24.861395575000074],
              [120.92286217500009, 24.874660549000055],
              [120.92603600400003, 24.884711005000042],
              [120.933929884, 24.894598700000074],
              [120.94402103000004, 24.902044989000046],
              [120.95362389400009, 24.90501536700009],
              [120.95281009200005, 24.90924713700008],
              [120.95533287900003, 24.91937897300005],
              [120.96387780000009, 24.94041575700004],
              [120.97169030000009, 24.95176829600007],
              [121.00554446700005, 25.00067780200004],
              [121.03199303500003, 25.029242255000042],
              [121.05933678500003, 25.05023834800005],
              [121.12940514400009, 25.071112372000073],
              [121.14576256600003, 25.08038971600007],
              [121.15984134200005, 25.091620184000078],
              [121.17693118600005, 25.100043036000045],
              [121.21094811300009, 25.111151434000078],
              [121.287445509, 25.12368398600006],
              [121.33025149800005, 25.130682684000078],
              [121.34831790500004, 25.137111721000053],
              [121.37175540500004, 25.154771226000037],
              [121.37875410200002, 25.157945054000038],
              [121.38738040500004, 25.159328518000052],
              [121.39893639400009, 25.159491278000075],
              [121.41228274800005, 25.155462958000044],
              [121.41944420700008, 25.14638906500005],
              [121.42408287900003, 25.13690827000005],
              [121.430023634, 25.13157786700009],
              [121.44320722700002, 25.136419989000046],
              [121.42945397200003, 25.155991929000038],
              [121.40739993600005, 25.176214911000045],
              [121.39576256600003, 25.182806708000044],
              [121.39909915500004, 25.19212474200009],
              [121.40601647200003, 25.197333075000074],
              [121.41325931100005, 25.200425523000035],
              [121.41627037900003, 25.203599351000037],
              [121.424164259, 25.22134023600006],
              [121.43628991000003, 25.241441148000035],
              [121.461273634, 25.26190827000005],
              [121.49781334700003, 25.27875397300005],
              [121.53972415500004, 25.28742096600007],
              [121.58082116000003, 25.283026434000078],
              [121.59791100400003, 25.271429755000042],
              [121.63599694100003, 25.222805080000057],
              [121.64966881600003, 25.197088934000078],
              [121.65414472700002, 25.19879791900007],
              [121.664398634, 25.20136139500005],
              [121.676117384, 25.20258209800005],
              [121.68441816500001, 25.200506903000075],
              [121.683929884, 25.19745514500005],
              [121.67994225400003, 25.193019924000055],
              [121.676117384, 25.18691640800006],
              [121.67644290500004, 25.179388739000046],
              [121.68051191500001, 25.175034898000035],
              [121.69459069100003, 25.166083075000074],
              [121.69752037900003, 25.162583726000037],
              [121.70386803500003, 25.15688711100006],
              [121.71851647200003, 25.152004299000055],
              [121.89283287900003, 25.113674221000053],
              [121.90512129000001, 25.106594143000052],
              [121.89893639400009, 25.09398021000004],
              [121.89722741000003, 25.08388906500005],
              [121.89991295700008, 25.06598541900007],
              [121.90919030000009, 25.036037502000056],
              [121.91920006600003, 25.022040106000077],
              [121.92725670700008, 25.018703518000052],
              [121.95386803500003, 25.022365627000056],
              [121.96753991000003, 25.02106354400007],
              [121.98357181100005, 25.01715729400007],
              [121.99773196700005, 25.010687567000048],
              [122.00538170700008, 25.001898505000042],
              [121.92676842500009, 24.966620184000078],
              [121.90577233200008, 24.950100002000056],
            ],
          ],
          [
            [
              [121.56348717500009, 22.044623114000046],
              [121.58106530000009, 22.03221263200004],
              [121.58887780000009, 22.023504950000074],
              [121.58765709700003, 22.01386139500005],
              [121.56690514400009, 22.007757880000042],
              [121.53891035200002, 22.01821523600006],
              [121.51319420700008, 22.03506094000005],
              [121.49830162900003, 22.048041083000044],
              [121.50277754000001, 22.057562567000048],
              [121.50261478000004, 22.066555080000057],
              [121.49878991000003, 22.074774481000077],
              [121.49203535200002, 22.082180080000057],
              [121.56657962300005, 22.082180080000057],
              [121.56657962300005, 22.075995184000078],
              [121.56462649800005, 22.07217031500005],
              [121.56137129000001, 22.063666083000044],
              [121.56006920700008, 22.053534247000073],
              [121.56348717500009, 22.044623114000046],
            ],
          ],
          [
            [
              [118.39421634200005, 24.522691148000035],
              [118.422596613, 24.52796832200005],
              [118.44958993900002, 24.505527833000087],
              [118.46735474900004, 24.461827610000057],
              [118.463355546, 24.431523084000048],
              [118.44878503900009, 24.415513445000045],
              [118.422900529, 24.430303610000067],
              [118.40362421200007, 24.436009837000086],
              [118.3728561050001, 24.433201267000072],
              [118.34576026800005, 24.417579187000058],
              [118.33099387900006, 24.39648245400008],
              [118.31821764600011, 24.390544350000084],
              [118.30323326900009, 24.397040106000077],
              [118.29297936300009, 24.397650458000044],
              [118.28394616000003, 24.401271877000056],
              [118.27955162900003, 24.40843333500004],
              [118.28109785200002, 24.411037502000056],
              [118.289398634, 24.42059967700004],
              [118.29200280000009, 24.424994208000044],
              [118.29273522200003, 24.432074286000045],
              [118.29232832100001, 24.440619208000044],
              [118.28956139400009, 24.455633856000077],
              [118.28296959700003, 24.470038153000075],
              [118.28207441500001, 24.477362372000073],
              [118.28785241000003, 24.48045482000009],
              [118.3166568150001, 24.49334875900007],
              [118.35480862500003, 24.470561718000056],
              [118.381414146, 24.473511031000044],
              [118.385392712, 24.503817045000062],
              [118.39421634200005, 24.522691148000035],
            ],
          ],
          [
            [
              [119.64795983200008, 23.603461005000042],
              [119.66578209700003, 23.57330963700008],
              [119.67066491000003, 23.55923086100006],
              [119.66846764400009, 23.54881419500009],
              [119.66114342500009, 23.55573151200008],
              [119.65137780000009, 23.56159088700008],
              [119.64063561300009, 23.56354401200008],
              [119.62566165500004, 23.555812893000052],
              [119.61500084700003, 23.554632880000042],
              [119.609711134, 23.551947333000044],
              [119.60678144600001, 23.546820380000042],
              [119.60271243600005, 23.53261953300006],
              [119.60010826900009, 23.52838776200008],
              [119.582367384, 23.51894765800006],
              [119.56397545700008, 23.51658763200004],
              [119.54558353000004, 23.523098049000055],
              [119.52711022200003, 23.539984442000048],
              [119.53199303500003, 23.54881419500009],
              [119.54216556100005, 23.537583726000037],
              [119.55738366000003, 23.53461334800005],
              [119.57374108200008, 23.538763739000046],
              [119.58716881600003, 23.54881419500009],
              [119.57789147200003, 23.551988023000035],
              [119.57056725400003, 23.55605703300006],
              [119.56462649800005, 23.561672268000052],
              [119.55925540500004, 23.56932200700004],
              [119.55713951900009, 23.566107489000046],
              [119.55713951900009, 23.565008856000077],
              [119.55640709700003, 23.564398505000042],
              [119.55241946700005, 23.56248607000009],
              [119.55152428500003, 23.57648346600007],
              [119.55241946700005, 23.590399481000077],
              [119.55925540500004, 23.590399481000077],
              [119.56723066500001, 23.58852773600006],
              [119.59546959700003, 23.604722398000035],
              [119.61312910200002, 23.610296942000048],
              [119.60840905000009, 23.594875393000052],
              [119.60629316500001, 23.590399481000077],
              [119.62159264400009, 23.594671942000048],
              [119.63331139400009, 23.593491929000038],
              [119.64185631600003, 23.59406159100007],
              [119.64795983200008, 23.603461005000042],
            ],
          ],
          [
            [
              [119.47706139400009, 23.603461005000042],
              [119.48943118600005, 23.63963450700004],
              [119.50131269600001, 23.65037669500009],
              [119.51734459700003, 23.637600002000056],
              [119.50782311300009, 23.63239166900007],
              [119.50123131600003, 23.61981842700004],
              [119.49073326900009, 23.590399481000077],
              [119.49024498800009, 23.582464911000045],
              [119.49284915500004, 23.57575104400007],
              [119.49170983200008, 23.57103099200009],
              [119.48023522200003, 23.56932200700004],
              [119.47193444100003, 23.56903717700004],
              [119.46607506600003, 23.568060614000046],
              [119.46119225400003, 23.56598541900007],
              [119.45655358200008, 23.56248607000009],
              [119.44239342500009, 23.56248607000009],
              [119.44483483200008, 23.56976959800005],
              [119.44947350400003, 23.57412344000005],
              [119.45655358200008, 23.57615794500009],
              [119.46615644600001, 23.57680898600006],
              [119.47445722700002, 23.579738674000055],
              [119.47681725400003, 23.586818752000056],
              [119.47706139400009, 23.603461005000042],
            ],
          ],
          [
            [
              [119.572601759, 23.62767161700009],
              [119.56934655000009, 23.63971588700008],
              [119.56177819100003, 23.64984772300005],
              [119.545258009, 23.664943752000056],
              [119.56641686300009, 23.67918528900009],
              [119.57886803500003, 23.673081773000035],
              [119.59107506600003, 23.66351959800005],
              [119.59620201900009, 23.653265692000048],
              [119.58692467500009, 23.645005601000037],
              [119.59066816500001, 23.63279857000009],
              [119.58513431100005, 23.624741929000038],
              [119.57683353000004, 23.62250397300005],
              [119.572601759, 23.62767161700009],
            ],
          ],
          [
            [
              [121.46070397200003, 22.659002997000073],
              [121.455414259, 22.67381419500009],
              [121.45753014400009, 22.675930080000057],
              [121.49577884200005, 22.678534247000073],
              [121.50001061300009, 22.676255601000037],
              [121.50277754000001, 22.66950104400007],
              [121.49976647200003, 22.65566640800006],
              [121.49634850400003, 22.650051174000055],
              [121.49496504000001, 22.644191799000055],
              [121.49634850400003, 22.638495184000078],
              [121.49610436300009, 22.63467031500005],
              [121.49317467500009, 22.63540273600006],
              [121.48658287900003, 22.63540273600006],
              [121.48316491000003, 22.63613515800006],
              [121.48145592500009, 22.63808828300006],
              [121.47144616000003, 22.641791083000044],
              [121.46070397200003, 22.659002997000073],
            ],
          ],
          [
            [
              [120.02186078900002, 23.45164440700006],
              [120.07493184000009, 23.50081817100005],
              [120.11525123000001, 23.54791155500004],
              [120.12476993200005, 23.550453797000046],
              [120.090300909, 23.499395950000064],
              [120.07344997300004, 23.483814315000075],
              [120.06227206400001, 23.471279090000053],
              [120.04791202000001, 23.458084713000062],
              [120.03659538500006, 23.45080878100009],
              [120.01954186300009, 23.438381252000056],
              [120.00765628500005, 23.432593713000074],
              [120.02186078900002, 23.45164440700006],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Japan',
        iso3: 'JPN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [129.7832137380001, 31.799627997000073],
              [129.79086347700002, 31.784409898000035],
              [129.79859459700003, 31.763657945000034],
              [129.79957116000003, 31.745428778000075],
              [129.78638756600003, 31.737616278000075],
              [129.77613366000003, 31.72947825700004],
              [129.74170983200008, 31.676174221000053],
              [129.72934004, 31.644232489000046],
              [129.7192488940001, 31.63735586100006],
              [129.695977406, 31.621447336000074],
              [129.6776940750001, 31.62969967300006],
              [129.6593736750001, 31.64193470500004],
              [129.655381433, 31.659784838000064],
              [129.6762976550001, 31.666966426000045],
              [129.69060286800004, 31.70019805600009],
              [129.71664472700002, 31.73037344000005],
              [129.73170006600003, 31.737616278000075],
              [129.75359134200005, 31.743801174000055],
              [129.76775149800005, 31.75934479400007],
              [129.776703321, 31.77952708500004],
              [129.7832137380001, 31.799627997000073],
            ],
          ],
          [
            [
              [131.65979027600008, 32.47681957400005],
              [131.65662940000004, 32.45735773000007],
              [131.67388918300003, 32.441804894000086],
              [131.68913158600003, 32.421737335000046],
              [131.66358483200008, 32.40643952000005],
              [131.65308678500003, 32.401271877000056],
              [131.64136803500003, 32.39923737200007],
              [131.63347415500004, 32.39549388200004],
              [131.6294051440001, 32.386786200000074],
              [131.62183678500003, 32.36029694200005],
              [131.619476759, 32.337103583000044],
              [131.61646569100003, 32.33234284100007],
              [131.61101321700005, 32.32998281500005],
              [131.60279381600003, 32.323553778000075],
              [131.59253991000003, 32.30365631700005],
              [131.580414259, 32.253973700000074],
              [131.56241690000002, 32.21791637100006],
              [131.5503272420001, 32.16946608900008],
              [131.53052845600007, 32.10739128200004],
              [131.49648639400004, 32.01274426700007],
              [131.45857033700008, 31.905451862000064],
              [131.4472762380001, 31.876898505000042],
              [131.44996178500003, 31.858710028000075],
              [131.447621863, 31.847434831000044],
              [131.4559034780001, 31.821973977000084],
              [131.468042276, 31.80489943300006],
              [131.49634850400003, 31.79596588700008],
              [131.493011915, 31.786932684000078],
              [131.4785262380001, 31.770331122000073],
              [131.47527103000004, 31.762152411000045],
              [131.450531446, 31.65110911700009],
              [131.45533287900003, 31.620917059000078],
              [131.42335045700008, 31.59833405200004],
              [131.411468946, 31.58612702000005],
              [131.40691165500004, 31.56972890800006],
              [131.40406334700003, 31.568060614000046],
              [131.39079837300005, 31.548814195000034],
              [131.38648522200003, 31.539007880000042],
              [131.3852645190001, 31.52692291900007],
              [131.38795006600003, 31.52049388200004],
              [131.391449415, 31.516750393000052],
              [131.39332116000003, 31.512274481000077],
              [131.39372806100005, 31.491034247000073],
              [131.38892662900003, 31.485581773000035],
              [131.37623131600003, 31.474432684000078],
              [131.3735457690001, 31.467352606000077],
              [131.3637801440001, 31.419663804000038],
              [131.35865319100003, 31.41046784100007],
              [131.34546959700003, 31.394964911000045],
              [131.3418074880001, 31.386053778000075],
              [131.34058678500003, 31.378729559000078],
              [131.338226759, 31.37262604400007],
              [131.33130944100003, 31.367661851000037],
              [131.32764733200008, 31.37132396000004],
              [131.32496178500003, 31.372870184000078],
              [131.31820722700002, 31.375148830000057],
              [131.322601759, 31.381293036000045],
              [131.32374108200008, 31.383937893000052],
              [131.325043165, 31.38812897300005],
              [131.28484134200005, 31.381984768000052],
              [131.26587975400003, 31.38117096600007],
              [131.24984785200002, 31.38812897300005],
              [131.2451278000001, 31.39557526200008],
              [131.24577884200005, 31.412176825000074],
              [131.243011915, 31.422267971000053],
              [131.238617384, 31.42841217700004],
              [131.2192488940001, 31.446478583000044],
              [131.21265709700003, 31.454738674000055],
              [131.20780235400002, 31.45604914000006],
              [131.200342492, 31.45737328200005],
              [131.17863301300008, 31.452428893000047],
              [131.1615568850001, 31.46399793100005],
              [131.15064537900003, 31.47134023600006],
              [131.13038170700008, 31.46942780200004],
              [131.1093856130001, 31.464544989000046],
              [131.07178795700008, 31.449611721000053],
              [131.05689537900003, 31.43964264500005],
              [131.045258009, 31.427476304000038],
              [131.02807477500005, 31.401785761000042],
              [131.01361073600003, 31.363069850000045],
              [131.02545128600002, 31.354095225000037],
              [131.0595809250001, 31.344875393000052],
              [131.083343946, 31.338446356000077],
              [131.1040145190001, 31.32884349200009],
              [131.1073875940001, 31.317184411000085],
              [131.10438183500003, 31.309449248000078],
              [131.082986237, 31.297055970000088],
              [131.07421690500007, 31.28210440500004],
              [131.09259076700005, 31.27605066400008],
              [131.12474719500005, 31.288345546000073],
              [131.13211394400003, 31.279513102000067],
              [131.06024973900003, 31.225314840000067],
              [131.0329508970001, 31.227524446000075],
              [131.00815940200005, 31.22108228400009],
              [131.00660241000003, 31.199774481000077],
              [130.9970809250001, 31.18659088700008],
              [130.97999108200008, 31.155991929000038],
              [130.96859785200002, 31.141750393000052],
              [130.95622806100005, 31.13117096600007],
              [130.94068444100003, 31.12132396000004],
              [130.92400149800005, 31.112982489000046],
              [130.9072371750001, 31.10691966400009],
              [130.87068066200004, 31.09601851800005],
              [130.84522545700008, 31.089911200000074],
              [130.81951105400003, 31.08726047400006],
              [130.79235710500006, 31.077847115000054],
              [130.77379645200006, 31.065482772000053],
              [130.7675887380001, 31.056463934000078],
              [130.72542805, 31.04703956700007],
              [130.69488036000007, 31.018824916000085],
              [130.67794304400002, 31.00501043400004],
              [130.6577220260001, 31.00319120000006],
              [130.66333941000005, 31.069506364000063],
              [130.68897545700008, 31.09015534100007],
              [130.72868899800005, 31.11155833500004],
              [130.7426863940001, 31.12128327000005],
              [130.76478445300006, 31.18650933200007],
              [130.753940574, 31.20388265300005],
              [130.7803691150001, 31.242514662000076],
              [130.78967014700004, 31.275148674000036],
              [130.79664629800004, 31.325345784000035],
              [130.79525160600008, 31.344425107000063],
              [130.78272545700008, 31.372788804000038],
              [130.7695418630001, 31.402411200000074],
              [130.74732506600003, 31.435492255000042],
              [130.70341738600007, 31.45930455100006],
              [130.69252519000008, 31.485572010000055],
              [130.70533287900003, 31.52875397300005],
              [130.69556725400003, 31.545803127000056],
              [130.63689212300005, 31.555243231000077],
              [130.619476759, 31.564276434000078],
              [130.6093856130001, 31.56631094000005],
              [130.59831790500004, 31.573431708000044],
              [130.5908888460001, 31.585987911000075],
              [130.61389305800003, 31.612066478000088],
              [130.63787805900006, 31.622594691000074],
              [130.66228274800005, 31.61786530200004],
              [130.687836134, 31.61945221600007],
              [130.71168053500003, 31.614406643000052],
              [130.72234134200005, 31.597316799000055],
              [130.7192488940001, 31.570705471000053],
              [130.7226668630001, 31.563421942000048],
              [130.73601321700005, 31.559475002000056],
              [130.7490340500001, 31.559719143000052],
              [130.758636915, 31.563788153000075],
              [130.7763778000001, 31.579901434000078],
              [130.79900149800005, 31.611721096000053],
              [130.81031334700003, 31.650946356000077],
              [130.80453535200002, 31.687241929000038],
              [130.7763778000001, 31.710272528000075],
              [130.73796468800003, 31.70843859000007],
              [130.6860457690001, 31.725531317000048],
              [130.64478600400003, 31.71474844000005],
              [130.61304772200003, 31.68235911700009],
              [130.61011803500003, 31.672308661000045],
              [130.60621178500003, 31.646633205000057],
              [130.60222415500004, 31.63825104400007],
              [130.57496178500003, 31.611273505000042],
              [130.56763756600003, 31.600734768000052],
              [130.55844160200002, 31.56631094000005],
              [130.54224694100003, 31.54173411700009],
              [130.52914472700002, 31.51325104400007],
              [130.5180770190001, 31.472398179000038],
              [130.5161238940001, 31.45331452000005],
              [130.5205184250001, 31.432440497000073],
              [130.55046634200005, 31.375148830000057],
              [130.56267337300005, 31.334377346000053],
              [130.57349694100003, 31.314601955000057],
              [130.58912194100003, 31.30621979400007],
              [130.602875196, 31.301988023000035],
              [130.6236819840001, 31.275646770000037],
              [130.66032962300005, 31.271429755000042],
              [130.66195722700002, 31.258612372000073],
              [130.65007571700005, 31.22370026200008],
              [130.64665774800005, 31.20693594000005],
              [130.63982181100005, 31.186468817000048],
              [130.62330162900003, 31.178859768000052],
              [130.60368899800005, 31.172349351000037],
              [130.5864363940001, 31.155422268000052],
              [130.573578321, 31.16742584800005],
              [130.5625106130001, 31.166937567000048],
              [130.5507918630001, 31.16242096600007],
              [130.53679446700005, 31.162176825000074],
              [130.52173912900003, 31.16868724200009],
              [130.51685631600003, 31.175441799000055],
              [130.5161238940001, 31.189520575000074],
              [130.50660241000003, 31.21279531500005],
              [130.49480228000004, 31.22724030200004],
              [130.45114447600008, 31.249388072000045],
              [130.2973738940001, 31.253729559000078],
              [130.27507571700005, 31.25299713700008],
              [130.24878991000003, 31.244126695000034],
              [130.2222047140001, 31.246299862000058],
              [130.21205593000002, 31.26086575100004],
              [130.2087152260001, 31.279282515000034],
              [130.2030932140001, 31.293824192000045],
              [130.192952418, 31.31515659300004],
              [130.17938199500009, 31.327781069000082],
              [130.19072152900003, 31.326789327000085],
              [130.20659505900005, 31.324819150000053],
              [130.20777428500003, 31.33661530200004],
              [130.19654381600003, 31.35419342700004],
              [130.170258009, 31.377020575000074],
              [130.1406356130001, 31.397650458000044],
              [130.11898847700002, 31.408636786000045],
              [130.1450301440001, 31.420070705000057],
              [130.15308678500003, 31.422267971000053],
              [130.16236412900003, 31.421942450000074],
              [130.17546634200005, 31.417303778000075],
              [130.1840926440001, 31.416083075000074],
              [130.19597415500004, 31.412054755000042],
              [130.215179884, 31.391058661000045],
              [130.22828209700003, 31.381293036000045],
              [130.24488366000003, 31.404852606000077],
              [130.293268129, 31.44470403200006],
              [130.30476023300002, 31.476634180000076],
              [130.31706790500004, 31.493068752000056],
              [130.328461134, 31.529038804000038],
              [130.3344832690001, 31.56240469000005],
              [130.32447350400003, 31.586737372000073],
              [130.33765709700003, 31.607896226000037],
              [130.33619225400003, 31.626166083000044],
              [130.32545006600003, 31.64207591400009],
              [130.2973738940001, 31.669989325000074],
              [130.25928795700008, 31.720851955000057],
              [130.24626712300005, 31.729641018000052],
              [130.1997176440001, 31.753729559000078],
              [130.1840926440001, 31.758693752000056],
              [130.18181399800005, 31.76825592700004],
              [130.17143062700006, 31.790136657000062],
              [130.181000196, 31.826971747000073],
              [130.1903187380001, 31.835088246000055],
              [130.22282962300005, 31.82444896000004],
              [130.23511803500003, 31.819525458000044],
              [130.207855665, 31.843695380000042],
              [130.1970037420001, 31.85848542800005],
              [130.21472979100008, 31.88561847400007],
              [130.22043774400004, 31.929594515000076],
              [130.21391755000002, 31.95017443200004],
              [130.20512664400007, 31.97167037300005],
              [130.19410241000003, 31.980902411000045],
              [130.1899520190001, 31.986029364000046],
              [130.17410608700004, 31.998755987000038],
              [130.1729936600001, 32.01744955600009],
              [130.18630718500003, 32.02679581400008],
              [130.20404812200002, 32.04828530800006],
              [130.20404738700006, 32.07258078500007],
              [130.17986087300005, 32.093451239000046],
              [130.20679772200003, 32.12067291900007],
              [130.24830162900003, 32.13373444200005],
              [130.278656446, 32.10053131700005],
              [130.29851321700005, 32.10586172100005],
              [130.31959069100003, 32.11823151200008],
              [130.33187910200002, 32.128607489000046],
              [130.33513431100005, 32.135199286000045],
              [130.344655795, 32.161769924000055],
              [130.34498131600003, 32.16274648600006],
              [130.348480665, 32.16657135600008],
              [130.35694420700008, 32.16937897300005],
              [130.35865319100003, 32.17267487200007],
              [130.357758009, 32.18724192900004],
              [130.35865319100003, 32.190659898000035],
              [130.431000196, 32.257147528000075],
              [130.44117272200003, 32.28261953300006],
              [130.44402103000004, 32.28782786700009],
              [130.4570418630001, 32.29486725500004],
              [130.46168053500003, 32.29995351800005],
              [130.46371504, 32.30939362200007],
              [130.46045983200008, 32.31818268400008],
              [130.46168053500003, 32.32721588700008],
              [130.469574415, 32.34711334800005],
              [130.4770613940001, 32.34902578300006],
              [130.50318444100003, 32.32721588700008],
              [130.51246178500003, 32.33820221600007],
              [130.51392662900003, 32.35032786700009],
              [130.51002037900003, 32.37848541900007],
              [130.51490319100003, 32.38589101800005],
              [130.54053795700008, 32.416001695000034],
              [130.56202233200008, 32.427069403000075],
              [130.5712996750001, 32.45189036700009],
              [130.56763756600003, 32.47768789300005],
              [130.55046634200005, 32.49168528900009],
              [130.55884850400003, 32.50177643400008],
              [130.57007897200003, 32.50560130400004],
              [130.59880618600005, 32.50535716400009],
              [130.59058678500003, 32.518459377000056],
              [130.567718946, 32.53416575700004],
              [130.56470787900003, 32.54633209800005],
              [130.57007897200003, 32.55459219000005],
              [130.64128665500004, 32.607489325000074],
              [130.65642337300005, 32.62372467700004],
              [130.668304884, 32.64874909100007],
              [130.641449415, 32.64834219000005],
              [130.47803795700008, 32.62201569200005],
              [130.46168053500003, 32.615220445000034],
              [130.44800866000003, 32.62140534100007],
              [130.45720462300005, 32.635199286000045],
              [130.47527103000004, 32.64704010600008],
              [130.54420006600003, 32.67670319200005],
              [130.5654403000001, 32.693426825000074],
              [130.576508009, 32.69839101800005],
              [130.59197024800005, 32.69721100500004],
              [130.60816491000003, 32.70221588700008],
              [130.61646569100003, 32.70376211100006],
              [130.6259871750001, 32.704006252000056],
              [130.6259871750001, 32.71141185100004],
              [130.6123153000001, 32.71625397300005],
              [130.60141035200002, 32.72614166900007],
              [130.59449303500003, 32.737982489000046],
              [130.59197024800005, 32.74872467700004],
              [130.5937606130001, 32.75560130400004],
              [130.5981551440001, 32.76308828300006],
              [130.6093856130001, 32.77570221600007],
              [130.61304772200003, 32.781236070000034],
              [130.6113387380001, 32.78546784100007],
              [130.60767662900003, 32.78986237200007],
              [130.60564212300005, 32.79645416900007],
              [130.59302819100003, 32.81586334800005],
              [130.5161238940001, 32.868475653000075],
              [130.47022545700008, 32.90973541900007],
              [130.44125410200002, 32.92365143400008],
              [130.43311608200008, 32.94171784100007],
              [130.42644290500004, 33.007147528000075],
              [130.42847741000003, 33.05052317900004],
              [130.42164147200003, 33.06976959800005],
              [130.422211134, 33.08258698100008],
              [130.42066491000003, 33.087591864000046],
              [130.4150496750001, 33.09162018400008],
              [130.40967858200008, 33.092678127000056],
              [130.40447024800005, 33.093003648000035],
              [130.40015709700003, 33.095038153000075],
              [130.3794051440001, 33.107855536000045],
              [130.37224368600005, 33.114894924000055],
              [130.367523634, 33.12636953300006],
              [130.368011915, 33.13495514500005],
              [130.36475670700008, 33.140326239000046],
              [130.33741295700008, 33.14337799700007],
              [130.314789259, 33.148504950000074],
              [130.30054772200003, 33.149644273000035],
              [130.29044274400007, 33.14958862900005],
              [130.258148634, 33.17865631700005],
              [130.24139647700008, 33.188234066000064],
              [130.21930162, 33.15946595200006],
              [130.1782332690001, 33.13491445500006],
              [130.1508895190001, 33.11188385600008],
              [130.1275648720001, 33.120936620000066],
              [130.1319460850001, 33.101971727000034],
              [130.14512925400004, 33.08483626000009],
              [130.160492384, 33.05410390800006],
              [130.20390147900002, 32.991781615000036],
              [130.22231019900005, 32.97520504800008],
              [130.219146927, 32.95505985900007],
              [130.2042577850001, 32.95087110800006],
              [130.20378665500004, 32.928900458000044],
              [130.18853629400007, 32.91532115800004],
              [130.16359606100002, 32.90929081300004],
              [130.1491302510001, 32.89641304400004],
              [130.134639816, 32.88904417800006],
              [130.11540774800005, 32.88027578300006],
              [130.10531660200002, 32.87592194200005],
              [130.12231510100003, 32.86881610800009],
              [130.13252880200002, 32.85593935700007],
              [130.15363495200006, 32.84245733200004],
              [130.1782842890001, 32.842494953000084],
              [130.1950023720001, 32.844940112000074],
              [130.24358790200006, 32.875284097000076],
              [130.30728451900006, 32.876298975000054],
              [130.339419787, 32.856579311000075],
              [130.35124759200005, 32.83392975500004],
              [130.37224368600005, 32.793402411000045],
              [130.37484785200002, 32.780178127000056],
              [130.3757820940001, 32.747884438000085],
              [130.37370621700006, 32.738968889000034],
              [130.35499108200008, 32.717230536000045],
              [130.35093633100007, 32.70406338500004],
              [130.36082701600003, 32.687963369000045],
              [130.34170370900006, 32.66725767400004],
              [130.30557751000003, 32.65143396800005],
              [130.26823067700002, 32.65036133400008],
              [130.25904566300005, 32.643865711000046],
              [130.25993899800005, 32.63271719000005],
              [130.2539168630001, 32.62482330900008],
              [130.23650802100008, 32.62247670600004],
              [130.23154564000004, 32.61001434800005],
              [130.22307901800002, 32.60588090300007],
              [130.19841204400007, 32.602978191000034],
              [130.18148028400003, 32.59232724600008],
              [130.16598697300003, 32.59295565700006],
              [130.173053879, 32.60363378100004],
              [130.16956158300002, 32.619092230000035],
              [130.1554875600001, 32.62565433600008],
              [130.14704924400007, 32.63399204700005],
              [130.12945734900006, 32.641134202000046],
              [130.12879260800003, 32.661317419000056],
              [130.12813256000004, 32.68387054600004],
              [130.14222326700008, 32.68206490400007],
              [130.1535077000001, 32.68619748900005],
              [130.16692510400003, 32.698037947000046],
              [130.17748022600006, 32.70517956500004],
              [130.190131683, 32.714106049000065],
              [130.20132314600005, 32.72425020600008],
              [130.21031382400008, 32.73324984100009],
              [130.207585429, 32.752162345000045],
              [130.19583342700003, 32.757391134000045],
              [130.18681992200004, 32.76206462600004],
              [130.18287194100003, 32.76902903900009],
              [130.1860457690001, 32.77435944200005],
              [130.19023316200003, 32.78348173400008],
              [130.17842736700004, 32.79292178700007],
              [130.14809900800003, 32.79535371600008],
              [130.1382142650001, 32.78884735300005],
              [130.126222063, 32.78887009200008],
              [130.093789355, 32.79486030900006],
              [130.0641668070001, 32.784811268000055],
              [130.05004571000006, 32.77236437400006],
              [130.032411657, 32.75934986500005],
              [130.0084457910001, 32.754626322000036],
              [129.9908080350001, 32.74691678000005],
              [129.9703798380001, 32.74456321900004],
              [129.962671806, 32.75289419100005],
              [129.96201159100008, 32.76180925300008],
              [129.958508413, 32.76478227300004],
              [129.94932582400008, 32.75766121600009],
              [129.95489089500006, 32.745171077000066],
              [129.94213628300008, 32.72852185000005],
              [129.9167645990001, 32.698278549000065],
              [129.90344364200007, 32.68113718500007],
              [129.89492938400008, 32.662689399000044],
              [129.874452904, 32.648988692000046],
              [129.85544474200003, 32.64008608000006],
              [129.84127669600002, 32.63941524900008],
              [129.83772459300008, 32.63166779000005],
              [129.83228560100008, 32.61580479700007],
              [129.8085433220001, 32.59755228000006],
              [129.7858295540001, 32.58310535600009],
              [129.78290880300005, 32.57350310800007],
              [129.77656135300003, 32.57645720100004],
              [129.76314686800004, 32.579976042000055],
              [129.749611511, 32.57269832500009],
              [129.74035124, 32.56844238700006],
              [129.7340049080001, 32.58092038700005],
              [129.74959016900004, 32.59171044200008],
              [129.7616873500001, 32.595980299000075],
              [129.775197284, 32.60085152000005],
              [129.78297457600002, 32.60741488500008],
              [129.79416252400006, 32.63231433300007],
              [129.80461534900007, 32.64768373700008],
              [129.81449596100003, 32.662551104000045],
              [129.81808351000006, 32.67743817500008],
              [129.81387181500008, 32.68337935000005],
              [129.803249284, 32.67799558400009],
              [129.7968825910001, 32.68450621000005],
              [129.79692255500004, 32.69224452900005],
              [129.80895979700006, 32.69406804800008],
              [129.81531954700006, 32.701797723000084],
              [129.8259541660001, 32.704808136000054],
              [129.83437803100003, 32.69412163700008],
              [129.845693536, 32.70127403300006],
              [129.85906009200005, 32.72451406500005],
              [129.82379517000004, 32.72198462400007],
              [129.82398522200003, 32.73607005400004],
              [129.8037215500001, 32.77228424700007],
              [129.793304884, 32.780178127000056],
              [129.78467858200008, 32.78489817900004],
              [129.778656446, 32.791001695000034],
              [129.7763778000001, 32.80329010600008],
              [129.77100670700008, 32.81395091400009],
              [129.754508987, 32.81848265700006],
              [129.74434328100006, 32.80988554000004],
              [129.7327100450001, 32.80557017500007],
              [129.72103494200007, 32.82707413800006],
              [129.69809004, 32.839544989000046],
              [129.68702233200008, 32.854803778000075],
              [129.67839603000004, 32.870428778000075],
              [129.67465254, 32.880519924000055],
              [129.67335045700008, 32.89240143400008],
              [129.66968834700003, 32.90497467700004],
              [129.66130618600005, 32.91474030200004],
              [129.65186608200008, 32.92279694200005],
              [129.638430137, 32.92654636300006],
              [129.631129363, 32.956533586000035],
              [129.6324026650001, 32.97910666700005],
              [129.64626919500006, 32.989563298000064],
              [129.6535188360001, 33.004253288000086],
              [129.649720817, 33.01704906000009],
              [129.65186151400007, 33.03355786700007],
              [129.66065830000002, 33.03969659100005],
              [129.66341673400007, 33.06902397600004],
              [129.68161222900005, 33.094092267000065],
              [129.7201975270001, 33.078967687000045],
              [129.734711134, 33.060248114000046],
              [129.7353621750001, 33.057847398000035],
              [129.73422285200002, 33.04905833500004],
              [129.734711134, 33.04661692900004],
              [129.73796634200005, 33.046128648000035],
              [129.74433684100006, 33.051523762000045],
              [129.75015446500004, 33.057039056000065],
              [129.75526629500007, 33.055216089000055],
              [129.7596653390001, 33.047889438000084],
              [129.75312015100008, 33.04176196700007],
              [129.7386319100001, 33.019118252000055],
              [129.73578382200003, 33.003843619000065],
              [129.74166376900007, 32.99103548100004],
              [129.7518386370001, 32.995939633000035],
              [129.76632809800003, 33.01795398200005],
              [129.796959, 33.01006172800004],
              [129.812307573, 32.99480358000005],
              [129.82327699500001, 32.97953752800004],
              [129.8160093040001, 32.970967451000035],
              [129.81384491900008, 32.96179569800006],
              [129.81608896700004, 32.937947697000084],
              [129.81466930400006, 32.92265535000007],
              [129.80667695500006, 32.91469654700006],
              [129.800827475, 32.923866660000044],
              [129.7956739660001, 32.94779418000007],
              [129.78694480600007, 32.94780487100007],
              [129.7899352500001, 32.91224538900008],
              [129.80379470800005, 32.90246010800007],
              [129.80747728000006, 32.88594190900005],
              [129.79439983400005, 32.874920702000054],
              [129.8148143520001, 32.86331302600007],
              [129.822833672, 32.85843758800007],
              [129.83158612900002, 32.850508251000065],
              [129.84178867900005, 32.84441060100005],
              [129.845439553, 32.83830848400004],
              [129.85052814900007, 32.84137051100004],
              [129.854884546, 32.84748575200007],
              [129.86870212600002, 32.853013496000074],
              [129.87451413200006, 32.860963222000066],
              [129.88320558400005, 32.87569270700004],
              [129.9356096470001, 32.860488941000085],
              [129.98787790900008, 32.84171406100006],
              [130.00314754200008, 32.845378716000084],
              [129.985691116, 32.863087170000085],
              [129.93122442100002, 32.92889427000006],
              [129.929725265, 32.95764131200008],
              [129.9391837170001, 32.97232342400008],
              [129.947601759, 32.99506256700005],
              [129.9456226420001, 33.015757714000074],
              [129.91208162100008, 33.03650814800005],
              [129.881443666, 33.062762999000086],
              [129.85301131300002, 33.05416733900006],
              [129.83406973900003, 33.04313491700009],
              [129.8238593850001, 33.043118812000046],
              [129.82235552400005, 33.06267999000005],
              [129.79751505900003, 33.07730904400006],
              [129.7865893390001, 33.07056414200008],
              [129.77495184000009, 33.05831396000008],
              [129.76109609900004, 33.057062665000046],
              [129.74647953500005, 33.065590119000035],
              [129.74244225400003, 33.07636139500005],
              [129.733225585, 33.101632521000056],
              [129.73906641500002, 33.10103458900005],
              [129.74919681100005, 33.09813060100004],
              [129.74558543700005, 33.116334760000086],
              [129.74628823800003, 33.12489568800004],
              [129.760144857, 33.12981531600008],
              [129.75867661200004, 33.13894149100008],
              [129.747730037, 33.13952432900004],
              [129.7285262380001, 33.122300523000035],
              [129.72364464100008, 33.132775250000066],
              [129.72143755700006, 33.14557295600008],
              [129.72285634600007, 33.15840396900006],
              [129.70976418500004, 33.16257034400007],
              [129.71216881600003, 33.141058661000045],
              [129.7080184250001, 33.119208075000074],
              [129.7041121750001, 33.11180247600004],
              [129.69686225700002, 33.11426520800006],
              [129.68074700600005, 33.11487864500009],
              [129.6734896060001, 33.10386878300005],
              [129.6665145190001, 33.101263739000046],
              [129.66233194300003, 33.12651117200005],
              [129.6836043630001, 33.13104889500005],
              [129.68702233200008, 33.142238674000055],
              [129.68327884200005, 33.152329820000034],
              [129.6743270190001, 33.160223700000074],
              [129.66325931100005, 33.166001695000034],
              [129.6528426440001, 33.17015208500004],
              [129.65609785200002, 33.178941148000035],
              [129.65609785200002, 33.184881903000075],
              [129.652679884, 33.19025299700007],
              [129.6455184250001, 33.19745514500005],
              [129.638031446, 33.19277578300006],
              [129.62810306100005, 33.19179922100005],
              [129.61744225400003, 33.194647528000075],
              [129.6001082690001, 33.208319403000075],
              [129.59009850400003, 33.21112702000005],
              [129.56413821700005, 33.21112702000005],
              [129.5521443460001, 33.225838734000035],
              [129.563341755, 33.25549040800007],
              [129.56534239400003, 33.27206736000005],
              [129.57382024700007, 33.27683511400005],
              [129.58091237300005, 33.27508441300006],
              [129.59149849000005, 33.283410159000084],
              [129.58934295200004, 33.28991462600004],
              [129.58432577500002, 33.301145664000046],
              [129.57146659700004, 33.32063960100004],
              [129.57628043, 33.34789650300007],
              [129.58041276000006, 33.371007269000074],
              [129.59241527900008, 33.381115210000075],
              [129.62061608200008, 33.35927969000005],
              [129.64437910200002, 33.36237213700008],
              [129.67318468100007, 33.39853911700004],
              [129.6796025320001, 33.389672534000056],
              [129.67687347600008, 33.362418888000036],
              [129.70100788500008, 33.35300693100004],
              [129.74416374600003, 33.364314257000046],
              [129.80746504, 33.34813060100004],
              [129.81454511800007, 33.331244208000044],
              [129.81470787900003, 33.33087799700007],
              [129.81983483200008, 33.304754950000074],
              [129.8271590500001, 33.29389069200005],
              [129.8379012380001, 33.28538646000004],
              [129.8515731130001, 33.28001536700009],
              [129.847992384, 33.293402411000045],
              [129.8413281180001, 33.315977314000065],
              [129.84629540100002, 33.34796460600006],
              [129.85900813400008, 33.36751408400005],
              [129.871025357, 33.37817788400008],
              [129.86186331800002, 33.39004618600006],
              [129.86866295700008, 33.39744700700004],
              [129.81639218700002, 33.426102031000084],
              [129.7968856130001, 33.44448476800005],
              [129.7872572230001, 33.45451903900005],
              [129.79717159900008, 33.46758179600005],
              [129.804244745, 33.48182305800009],
              [129.81844004700008, 33.48421177600005],
              [129.83545983200008, 33.46637604400007],
              [129.84131920700008, 33.454413153000075],
              [129.84888756600003, 33.44245026200008],
              [129.86207116000003, 33.43699778900009],
              [129.87134850400003, 33.44293854400007],
              [129.86687259200005, 33.456732489000046],
              [129.84395138900004, 33.48121705400007],
              [129.8368347390001, 33.513254121000045],
              [129.8545792440001, 33.53285385400005],
              [129.8531871560001, 33.55250171100005],
              [129.86878891900005, 33.539399950000075],
              [129.8858313830001, 33.53584022100006],
              [129.91005948600002, 33.54720499900009],
              [129.94214928500003, 33.531683661000045],
              [129.961273634, 33.51276276200008],
              [129.95699680100006, 33.502782411000055],
              [129.945544702, 33.49085512700009],
              [129.9412089010001, 33.47953658700004],
              [129.95333126000003, 33.47365559600007],
              [129.96264789400004, 33.482607278000046],
              [129.96690162200002, 33.47252883400006],
              [129.96686887600004, 33.463027013000044],
              [129.97538907600006, 33.45414314300007],
              [129.9889460280001, 33.448851378000086],
              [130.01685631600003, 33.44578685100004],
              [130.02881920700008, 33.45066966400009],
              [130.04021243600005, 33.46124909100007],
              [130.04462561600008, 33.48574090400007],
              [130.05529438300005, 33.495225676000075],
              [130.08597211100005, 33.50653186400007],
              [130.10384486200007, 33.51190524500004],
              [130.11526180200008, 33.50895078600007],
              [130.1259871750001, 33.51618073100008],
              [130.1298934250001, 33.51898834800005],
              [130.14275149800005, 33.52049388200004],
              [130.15642337300005, 33.525376695000034],
              [130.1679793630001, 33.534084377000056],
              [130.174164259, 33.546861070000034],
              [130.16187584700003, 33.54661692900004],
              [130.1298934250001, 33.54002513200004],
              [130.12037194100003, 33.54315827000005],
              [130.11793053500003, 33.55683014500005],
              [130.10914147200003, 33.559881903000075],
              [130.09693444100003, 33.561712958000044],
              [130.09205162900003, 33.566473700000074],
              [130.09302819100003, 33.573431708000044],
              [130.098480665, 33.581691799000055],
              [130.10914147200003, 33.58974844000005],
              [130.11939537900003, 33.59125397300005],
              [130.12916100400003, 33.59125397300005],
              [130.13941491000003, 33.59467194200005],
              [130.156663622, 33.60650551500004],
              [130.153839339, 33.61894298100009],
              [130.1595475270001, 33.62959605400005],
              [130.17074629, 33.62885163000004],
              [130.18189537900003, 33.62905508000006],
              [130.19068444100003, 33.63031647300005],
              [130.1977645190001, 33.63361237200007],
              [130.20476321700005, 33.63971588700008],
              [130.208011242, 33.66507643700004],
              [130.22055097700002, 33.65973541900007],
              [130.23170006600003, 33.65330638200004],
              [130.23650149800005, 33.644232489000046],
              [130.22715623300007, 33.63484353900009],
              [130.2313843830001, 33.61884615200006],
              [130.24537194100003, 33.611761786000045],
              [130.25147545700008, 33.60797760600008],
              [130.27192137300005, 33.61166814100005],
              [130.2754495370001, 33.60336765000005],
              [130.26543167800003, 33.58857951500005],
              [130.27324374700004, 33.582642956000086],
              [130.28541100400003, 33.57697174700007],
              [130.29029381600003, 33.574204820000034],
              [130.29529753400004, 33.579042582000056],
              [130.30152428500003, 33.57965729400007],
              [130.30543053500003, 33.58494700700004],
              [130.31530703800001, 33.59736182000006],
              [130.33026873200004, 33.597919940000054],
              [130.35804962400005, 33.59725860000009],
              [130.37303995000002, 33.603144833000044],
              [130.39086562400007, 33.60487402200005],
              [130.39947835200007, 33.61611050100004],
              [130.40240768500007, 33.63092078800008],
              [130.40750100800005, 33.650468484000044],
              [130.403260381, 33.65818688100006],
              [130.39869225400003, 33.669134833000044],
              [130.379242384, 33.65924713700008],
              [130.36158287900003, 33.64622630400004],
              [130.34897188800005, 33.64113020500008],
              [130.33616833300005, 33.64767755200006],
              [130.32478674000004, 33.65303453300004],
              [130.31839397600004, 33.65838070800004],
              [130.30698072000007, 33.65544060500008],
              [130.29490003900003, 33.66435087500008],
              [130.28926262000004, 33.681544502000065],
              [130.294280577, 33.68923940700006],
              [130.304966046, 33.68744291200005],
              [130.31061090100002, 33.672617553000066],
              [130.3241222590001, 33.664887418000035],
              [130.3454978970001, 33.66247159000005],
              [130.38648522200003, 33.67723216400009],
              [130.40202884200005, 33.68939850500004],
              [130.41529381600003, 33.702826239000046],
              [130.4287215500001, 33.71369049700007],
              [130.44459069100003, 33.71820709800005],
              [130.45211308600005, 33.72797385300004],
              [130.46767384400005, 33.74356360100006],
              [130.46998655100003, 33.762869178000074],
              [130.4667595950001, 33.78035298600008],
              [130.45570365100002, 33.78223217800007],
              [130.44800866000003, 33.789943752000056],
              [130.449554884, 33.80223216400009],
              [130.45435631600003, 33.80768463700008],
              [130.46208743600005, 33.81118398600006],
              [130.47217858200008, 33.81753164300005],
              [130.47779381600003, 33.82514069200005],
              [130.48894290500004, 33.85537344000005],
              [130.4970809250001, 33.84813060100004],
              [130.50757897200003, 33.84906647300005],
              [130.53052819100003, 33.86155833500004],
              [130.5390731130001, 33.86945221600007],
              [130.542328321, 33.87596263200004],
              [130.548187696, 33.88076406500005],
              [130.56470787900003, 33.88328685100004],
              [130.61207116000003, 33.879787502000056],
              [130.63306725400003, 33.882473049000055],
              [130.65406334700003, 33.89630768400008],
              [130.684418165, 33.93423086100006],
              [130.6923934250001, 33.93732330900008],
              [130.70525149800005, 33.938706773000035],
              [130.71705162900003, 33.93789297100005],
              [130.7315048380001, 33.931848734000084],
              [130.75604891900002, 33.94368111300008],
              [130.790494512, 33.94441130800004],
              [130.82822790400007, 33.93958513800004],
              [130.82133888200008, 33.92028713700006],
              [130.83586868700002, 33.925729009000065],
              [130.86142341900006, 33.92556771800008],
              [130.8711989950001, 33.91351609900005],
              [130.88085281300005, 33.89593952100006],
              [130.8969832690001, 33.88930898600006],
              [130.91358483200008, 33.89118073100008],
              [130.92603600400003, 33.89907461100006],
              [130.9414168630001, 33.91681549700007],
              [130.94947136400003, 33.93819283900007],
              [130.97656724600006, 33.957366930000035],
              [131.007147594, 33.96605493200008],
              [131.0186856580001, 33.956262097000035],
              [131.01531009200005, 33.93512604400007],
              [131.0063582690001, 33.92291901200008],
              [131.00359134200005, 33.91681549700007],
              [131.00416100400003, 33.91107819200005],
              [130.99292883500004, 33.89766466700007],
              [131.00177079800005, 33.887228684000036],
              [130.9998293210001, 33.87386354000006],
              [130.98460705500008, 33.87396048700009],
              [130.988081329, 33.86428416100006],
              [130.99068439000007, 33.856827183000064],
              [130.98433485600003, 33.848697918000084],
              [130.97974694100003, 33.84271881700005],
              [130.96357418600007, 33.83323528200009],
              [130.9619246750001, 33.82005442900004],
              [130.96168053500003, 33.81622955900008],
              [130.96599368600005, 33.81305573100008],
              [130.98551079600009, 33.80866486500008],
              [131.0069447090001, 33.813087590000066],
              [131.00359134200005, 33.77968984600005],
              [131.00603274800005, 33.77228424700007],
              [131.0097762380001, 33.746161200000074],
              [131.01978600400003, 33.726548570000034],
              [131.0507918630001, 33.68187083500004],
              [131.0644637380001, 33.65326569200005],
              [131.08130944100003, 33.63495514500005],
              [131.10297618100003, 33.62425323800005],
              [131.1199716970001, 33.62633852100004],
              [131.14587465700004, 33.62163367200009],
              [131.188699101, 33.616028293000056],
              [131.21986918300001, 33.60754487000008],
              [131.2564638120001, 33.60495535200005],
              [131.28383445500003, 33.58236918000006],
              [131.323093352, 33.58122055200005],
              [131.367620482, 33.57480177900004],
              [131.41770310800007, 33.58168167900004],
              [131.42317582400005, 33.589053522000086],
              [131.45931405600004, 33.616143772000044],
              [131.47563704700008, 33.631565882000075],
              [131.4840322870001, 33.653038364000054],
              [131.49855721400002, 33.66698519000005],
              [131.52104511700009, 33.67637079200006],
              [131.55147501700003, 33.680444246000036],
              [131.57380154600003, 33.680895527000075],
              [131.59001712300005, 33.68301015800006],
              [131.60718834700003, 33.67719147300005],
              [131.6274520190001, 33.667669989000046],
              [131.64722741000003, 33.66982656500005],
              [131.66736627400007, 33.66719200300008],
              [131.68955031300004, 33.64134224500009],
              [131.71311515500008, 33.605438664000076],
              [131.72953798100002, 33.58023616300005],
              [131.73707116000003, 33.56037018400008],
              [131.73991946700005, 33.53969961100006],
              [131.729109, 33.51254769600007],
              [131.737294841, 33.48460779900006],
              [131.7273475830001, 33.46353913000007],
              [131.7092823690001, 33.432637870000065],
              [131.70624349800005, 33.40958266700005],
              [131.697436434, 33.406392597000035],
              [131.67457116000003, 33.41616445500006],
              [131.6587020190001, 33.42283763200004],
              [131.64031009200005, 33.41657135600008],
              [131.63542728000004, 33.402329820000034],
              [131.63843834700003, 33.38666413000004],
              [131.63461347700002, 33.37396881700005],
              [131.60962975400003, 33.368801174000055],
              [131.60108483200008, 33.364935614000046],
              [131.59623445500006, 33.349400219000074],
              [131.57628894100003, 33.34635520200004],
              [131.55616295700008, 33.34638092700004],
              [131.5473738940001, 33.35228099200009],
              [131.532980942, 33.366113306000045],
              [131.50602854600004, 33.36307383900004],
              [131.49838511400003, 33.34066626900005],
              [131.51037964, 33.273403693000034],
              [131.52849368600005, 33.26121653900009],
              [131.5478621750001, 33.25495026200008],
              [131.61221917500006, 33.25293648400009],
              [131.6545351640001, 33.271625235000045],
              [131.700043165, 33.25409577000005],
              [131.71086238200007, 33.27017583800006],
              [131.76209241900006, 33.253543499000045],
              [131.82217409700002, 33.24403243800009],
              [131.85085719000006, 33.25221895900006],
              [131.88444854400007, 33.26830565600005],
              [131.902624533, 33.26604183300009],
              [131.8821953150001, 33.236532484000065],
              [131.87155536400007, 33.21541862600009],
              [131.87224368600005, 33.20034414300005],
              [131.86466184000005, 33.19306970900004],
              [131.8487435400001, 33.18799917800004],
              [131.83097601300005, 33.16971306700009],
              [131.826660629, 33.152561727000034],
              [131.8095736890001, 33.12764888700008],
              [131.84262129, 33.113267320000034],
              [131.86883062000004, 33.12876699900005],
              [131.9004012380001, 33.12913646000004],
              [131.91145721600003, 33.12481513400007],
              [131.88435011500007, 33.10935456000004],
              [131.8689377610001, 33.09434021100009],
              [131.8632173310001, 33.08253329200005],
              [131.88051074700002, 33.07504043000006],
              [131.890859223, 33.07951064400004],
              [131.905797527, 33.07729573600005],
              [131.9158313490001, 33.06916163000005],
              [131.929216945, 33.068270865000045],
              [131.9326183080001, 33.07946960400005],
              [131.93446936200007, 33.092017862000034],
              [131.9423835450001, 33.09255668600008],
              [131.95093834700003, 33.076157945000034],
              [131.9580184250001, 33.06720612200007],
              [131.967133009, 33.06167226800005],
              [131.97608483200008, 33.060248114000046],
              [131.985199415, 33.06317780200004],
              [131.99146569100003, 33.06899648600006],
              [131.99611291500003, 33.09171124900007],
              [132.01343834700003, 33.06386953300006],
              [132.00945071700005, 33.05117422100005],
              [131.98400888800006, 33.04554450900008],
              [131.94535031300006, 33.04749881500004],
              [131.929550264, 33.047089602000085],
              [131.9228287530001, 33.02865454100004],
              [131.90677350700003, 33.01184695400008],
              [131.903168165, 32.98305898600006],
              [131.91459563600006, 32.97649247000004],
              [131.93470534100004, 32.95950686200007],
              [131.94970144800004, 32.959274942000036],
              [131.95923912900003, 32.944525458000044],
              [131.96989993600005, 32.94830963700008],
              [131.97917728000004, 32.950384833000044],
              [131.98560631600003, 32.947333075000074],
              [131.99097741000003, 32.94171784100007],
              [131.99822024800005, 32.93891022300005],
              [132.0102645190001, 32.94415924700007],
              [132.0097762380001, 32.93903229400007],
              [132.013879094, 32.93439292900007],
              [132.021830657, 32.93691682100007],
              [132.0347898, 32.95129061700004],
              [132.0607438300001, 32.94688499600005],
              [132.08118890900005, 32.94322970300004],
              [132.0841147540001, 32.93323398500007],
              [132.064445697, 32.93621532000009],
              [132.04371447900007, 32.92727560900005],
              [132.02547498600006, 32.923595910000074],
              [131.99480228000004, 32.903550523000035],
              [131.98218834700003, 32.88890208500004],
              [131.986664259, 32.88226959800005],
              [131.99586022200003, 32.87836334800005],
              [132.00017337300005, 32.87128327000005],
              [131.98975670700008, 32.854803778000075],
              [131.9809676440001, 32.84833405200004],
              [131.97234134200005, 32.84446849200009],
              [131.96371504, 32.83901601800005],
              [131.9555770190001, 32.82754140800006],
              [131.96851647200003, 32.82611725500004],
              [131.99781334700003, 32.82965729400007],
              [132.00342858200008, 32.82412344000005],
              [131.9965926440001, 32.810532945000034],
              [131.98072350400003, 32.799261786000045],
              [131.96241295700008, 32.792669989000046],
              [131.94809004, 32.793402411000045],
              [131.92920983200008, 32.77826569200005],
              [131.88249759200005, 32.78343333500004],
              [131.8730574880001, 32.76235586100006],
              [131.8730574880001, 32.73468659100007],
              [131.87232506600003, 32.731634833000044],
              [131.8711043630001, 32.72679271000004],
              [131.86687259200005, 32.722723700000074],
              [131.86215254, 32.720363674000055],
              [131.8593856130001, 32.717678127000056],
              [131.856994063, 32.70086428700006],
              [131.85592484900008, 32.686084221000044],
              [131.84791100400003, 32.68183014500005],
              [131.8339517390001, 32.69866452900004],
              [131.82193770100002, 32.70268559100009],
              [131.81656441200005, 32.689146346000086],
              [131.800639584, 32.68083304800007],
              [131.788422071, 32.662990627000056],
              [131.77564537900003, 32.65371328300006],
              [131.77076256600003, 32.64874909100007],
              [131.76783287900003, 32.64411041900007],
              [131.76823978000004, 32.64240143400008],
              [131.76978600400003, 32.639553127000056],
              [131.77076256600003, 32.631740627000056],
              [131.76685631600003, 32.620794989000046],
              [131.7490340500001, 32.59406159100007],
              [131.74333743600005, 32.587958075000074],
              [131.7295028000001, 32.584051825000074],
              [131.70879259100002, 32.585903477000045],
              [131.70471287200007, 32.58157515700009],
              [131.69906660200002, 32.564520575000074],
              [131.6821395190001, 32.53506094000005],
              [131.68506920700008, 32.52244700700004],
              [131.695648634, 32.51146067900004],
              [131.71265709700003, 32.51162344000005],
              [131.71892337300005, 32.50873444200005],
              [131.73650149800005, 32.49168528900009],
              [131.7172957690001, 32.47296784100007],
              [131.69548587300005, 32.46824778900009],
              [131.67894569400005, 32.47390700400007],
              [131.65979027600008, 32.47681957400005],
            ],
          ],
          [
            [
              [134.689789259, 33.82807038000004],
              [134.722031249, 33.83407324800004],
              [134.7400455500001, 33.840282578000085],
              [134.75123131600003, 33.83490631700005],
              [134.73230385400007, 33.825951916000065],
              [134.70204863100003, 33.81367689100006],
              [134.66465403400002, 33.79848707600007],
              [134.65186608200008, 33.786444403000075],
              [134.616799862, 33.782601997000086],
              [134.607758009, 33.76601797100005],
              [134.57937739500005, 33.76417006200006],
              [134.57066101500004, 33.736448978000055],
              [134.54637791100004, 33.73250210200007],
              [134.53844025700005, 33.71685772500007],
              [134.4573003920001, 33.67092600800004],
              [134.40402239800005, 33.65447756000009],
              [134.3761745380001, 33.63565700800007],
              [134.38862168100002, 33.623634081000034],
              [134.36376953800004, 33.600755389000085],
              [134.36052417400003, 33.58870858700004],
              [134.3529669180001, 33.58163085800004],
              [134.339452853, 33.57706668000009],
              [134.32626048100008, 33.58012784400006],
              [134.312348015, 33.57250647400008],
              [134.31546049500002, 33.55513788700006],
              [134.313701067, 33.54307917700004],
              [134.2967117940001, 33.53136344700005],
              [134.2732050850001, 33.50800352400006],
              [134.2446336050001, 33.46075022600007],
              [134.21452884200005, 33.376613674000055],
              [134.20777428500003, 33.339097398000035],
              [134.19849694100003, 33.31028880400004],
              [134.1962996750001, 33.29677969000005],
              [134.19119962600007, 33.27125762500009],
              [134.19025513100007, 33.24832929400009],
              [134.17652712200004, 33.23612782100008],
              [134.15796959700003, 33.26972077000005],
              [134.14176414200006, 33.29179326500008],
              [134.12750724600005, 33.289525482000045],
              [134.1062243450001, 33.294332361000045],
              [134.107960423, 33.31492348200004],
              [134.07997292100004, 33.33904807300007],
              [134.0400496750001, 33.384100653000075],
              [134.025536461, 33.41540034500008],
              [133.99662190200002, 33.42456538000005],
              [133.9687606130001, 33.43569570500006],
              [133.94214849600007, 33.45887910400006],
              [133.92520516600007, 33.49369326100009],
              [133.85490166900001, 33.50009453000007],
              [133.76305219800008, 33.51978440700009],
              [133.73939679, 33.537506879000034],
              [133.67214782000008, 33.528902337000034],
              [133.60773318400004, 33.51582468000004],
              [133.58930516600003, 33.501933551000036],
              [133.54686167900002, 33.486111348000065],
              [133.46590938600002, 33.454324098000086],
              [133.45036868600005, 33.430853583000044],
              [133.4550887380001, 33.41469961100006],
              [133.43970787900003, 33.401678778000075],
              [133.41480553500003, 33.39305247600004],
              [133.3916121750001, 33.389837958000044],
              [133.3754988940001, 33.38939036700009],
              [133.36500084700003, 33.387600002000056],
              [133.35661868600005, 33.38328685100004],
              [133.3466903000001, 33.37555573100008],
              [133.3281356130001, 33.35346100500004],
              [133.32309004, 33.35130442900004],
              [133.32601972700002, 33.368801174000055],
              [133.31910241000003, 33.371527411000045],
              [133.31234785200002, 33.37555573100008],
              [133.29224694100003, 33.36469147300005],
              [133.26937910200002, 33.346869208000044],
              [133.25456790500004, 33.326239325000074],
              [133.25847415500004, 33.306708075000074],
              [133.2519637380001, 33.29474518400008],
              [133.25464928500003, 33.28652578300006],
              [133.2607528000001, 33.27977122600004],
              [133.2646590500001, 33.27252838700008],
              [133.26587975400003, 33.267645575000074],
              [133.26970462300005, 33.26422760600008],
              [133.270843946, 33.25950755400004],
              [133.26937910200002, 33.25234609600005],
              [133.26514733200008, 33.24843984600005],
              [133.26050866000003, 33.245754299000055],
              [133.25847415500004, 33.24213288000004],
              [133.253265821, 33.21906159100007],
              [133.24097741000003, 33.20579661700009],
              [133.226898634, 33.19440338700008],
              [133.21533962500007, 33.187503519000074],
              [133.21794681100005, 33.16583893400008],
              [133.22543379, 33.159084377000056],
              [133.2097610410001, 33.15104182500005],
              [133.20383583600005, 33.16262210700006],
              [133.19014923300006, 33.16331643500007],
              [133.16503341100008, 33.13719955500005],
              [133.13238695400003, 33.08902945600005],
              [133.107436129, 33.061068704000036],
              [133.0971161340001, 33.048111006000056],
              [133.098866992, 33.03264824000007],
              [133.09776417700004, 33.02346692000009],
              [133.0898543630001, 33.01927317900004],
              [133.07461708800008, 33.02873789200004],
              [133.052847681, 33.03949864300006],
              [133.01825880900003, 33.024023267000075],
              [133.001702206, 32.98695675100004],
              [132.994412721, 32.948993177000034],
              [133.00928795700008, 32.90346914300005],
              [133.0024520190001, 32.86933014500005],
              [132.98990530800006, 32.862576095000065],
              [132.96105903500006, 32.86410052600007],
              [132.95509926500006, 32.85262854200005],
              [132.95789947100002, 32.835425557000065],
              [132.95547713300004, 32.81461873300009],
              [132.9697371750001, 32.807074286000045],
              [132.97673587300005, 32.79515208500004],
              [132.9848738940001, 32.787095445000034],
              [133.00407962300005, 32.77228424700007],
              [133.01734459700003, 32.757879950000074],
              [133.02759850400003, 32.73965078300006],
              [133.02800540500004, 32.72064850500004],
              [133.00220787900003, 32.71165599200009],
              [132.9843856130001, 32.719631252000056],
              [132.9765731130001, 32.72451406500005],
              [132.97136478000004, 32.731675523000035],
              [132.961761915, 32.75112539300005],
              [132.95679772200003, 32.75861237200007],
              [132.93913821700005, 32.77045319200005],
              [132.9150496750001, 32.77798086100006],
              [132.89283287900003, 32.77423737200007],
              [132.88111412900003, 32.752386786000045],
              [132.8720809250001, 32.768744208000044],
              [132.8584090500001, 32.769598700000074],
              [132.84327233200008, 32.760931708000044],
              [132.82960045700008, 32.74872467700004],
              [132.81218509200005, 32.740301825000074],
              [132.7915145190001, 32.740668036000045],
              [132.7719832690001, 32.746079820000034],
              [132.75757897200003, 32.752386786000045],
              [132.72934004, 32.77415599200009],
              [132.71140079600002, 32.78952538900006],
              [132.66464317600003, 32.77886830400007],
              [132.62766076800006, 32.752093098000046],
              [132.61990336400004, 32.772990306000054],
              [132.623376882, 32.79949569300004],
              [132.64600159500003, 32.825692004000075],
              [132.6630072600001, 32.85680765600006],
              [132.69278518700003, 32.88433009100004],
              [132.70516686400003, 32.89716469000007],
              [132.70915774800005, 32.909409898000035],
              [132.63990319100003, 32.90892161700009],
              [132.62720787900003, 32.906317450000074],
              [132.61841881600003, 32.90688711100006],
              [132.57545006600003, 32.93183014500005],
              [132.558929884, 32.936753648000035],
              [132.57203209700003, 32.923081773000035],
              [132.55290774800005, 32.92487213700008],
              [132.53638756600003, 32.93121979400007],
              [132.52418053500003, 32.93024323100008],
              [132.51734459700003, 32.909409898000035],
              [132.5234481130001, 32.90688711100006],
              [132.5322371750001, 32.89940013200004],
              [132.53785241000003, 32.895819403000075],
              [132.52076256600003, 32.88930898600006],
              [132.50416100400003, 32.89166901200008],
              [132.49048912900003, 32.90119049700007],
              [132.47227232600005, 32.933672312000056],
              [132.494039466, 32.94893138500004],
              [132.48291855800005, 32.97050124400005],
              [132.49612784400006, 32.98533214000008],
              [132.50147545700008, 32.99323151200008],
              [132.48140843600004, 33.02352753800005],
              [132.47149541200008, 33.04068590400004],
              [132.44113728700006, 33.04365934800006],
              [132.419704131, 33.05192155800006],
              [132.39670036500002, 33.01659380400008],
              [132.382402156, 33.019779079000045],
              [132.40044648700007, 33.04391394800007],
              [132.396884785, 33.058005309000066],
              [132.4079223970001, 33.06932932600006],
              [132.45183353000004, 33.05288320500006],
              [132.47152754, 33.05560944200005],
              [132.48316491000003, 33.067694403000075],
              [132.46273847700002, 33.067694403000075],
              [132.4687606130001, 33.08234284100007],
              [132.46900475400003, 33.095770575000074],
              [132.46273847700002, 33.105454820000034],
              [132.44906660200002, 33.108710028000075],
              [132.44906660200002, 33.114894924000055],
              [132.47144616000003, 33.11395905200004],
              [132.47584069100003, 33.114894924000055],
              [132.48015384200005, 33.11831289300005],
              [132.48755944100003, 33.12547435100004],
              [132.49008222700002, 33.13275788000004],
              [132.4795028000001, 33.135972398000035],
              [132.4502059250001, 33.13666413000004],
              [132.44068444100003, 33.142279364000046],
              [132.43539472700002, 33.15582916900007],
              [132.4380436130001, 33.16821834500007],
              [132.45860651700002, 33.17370587800008],
              [132.44924661700009, 33.185075323000035],
              [132.43810824600007, 33.191397889000086],
              [132.42366068900003, 33.19917609400005],
              [132.41538655700003, 33.189277566000044],
              [132.398647482, 33.18718380200005],
              [132.39467584800002, 33.20389482100006],
              [132.42012383400004, 33.209824239000056],
              [132.44549372400002, 33.20496542200004],
              [132.45965886500005, 33.20401231800008],
              [132.461201039, 33.191403309000066],
              [132.47782146500003, 33.181408297000075],
              [132.48570176400005, 33.169153220000055],
              [132.505077281, 33.18123508500008],
              [132.50266988300007, 33.19873474700006],
              [132.51376684500008, 33.21334291800008],
              [132.53617229300005, 33.21756625000006],
              [132.54836358700004, 33.226902944000074],
              [132.53682887000002, 33.242584289000035],
              [132.52449224200006, 33.24998236300007],
              [132.541393707, 33.26255771700005],
              [132.52421284500008, 33.26302333000007],
              [132.507701687, 33.25790311900005],
              [132.50257981200002, 33.26660913300009],
              [132.491823351, 33.270716494000055],
              [132.48457057000007, 33.27652591800006],
              [132.484735461, 33.29084085900007],
              [132.5047883420001, 33.30381085100004],
              [132.522280443, 33.30762090800005],
              [132.5256097680001, 33.31466423100005],
              [132.48680352500003, 33.316068149000046],
              [132.42012139200006, 33.30435563900005],
              [132.4012213750001, 33.30938686700006],
              [132.39027438000005, 33.316188081000064],
              [132.37867272200003, 33.31948476800005],
              [132.384125196, 33.33087799700007],
              [132.39136803500003, 33.334865627000056],
              [132.40788821700005, 33.33624909100007],
              [132.41553795700008, 33.341457424000055],
              [132.417328321, 33.34739817900004],
              [132.42115319100003, 33.37555573100008],
              [132.4023543630001, 33.362616278000075],
              [132.3906356130001, 33.374986070000034],
              [132.3911238940001, 33.39789459800005],
              [132.40805097700002, 33.41657135600008],
              [132.40805097700002, 33.42340729400007],
              [132.39437910200002, 33.42340729400007],
              [132.39820397200003, 33.431341864000046],
              [132.40414472700002, 33.43764883000006],
              [132.41187584700003, 33.44196198100008],
              [132.42115319100003, 33.44448476800005],
              [132.38111412900003, 33.466050523000035],
              [132.36296634200005, 33.468085028000075],
              [132.3445962300001, 33.46715465400007],
              [132.33375159500008, 33.462444308000045],
              [132.32223273500006, 33.45755532700008],
              [132.30780389000006, 33.46428988300005],
              [132.2785860240001, 33.447300719000054],
              [132.253606956, 33.44070882600005],
              [132.21440218300006, 33.42294673200007],
              [132.17973878400005, 33.40698609900005],
              [132.1499849060001, 33.389167102000044],
              [132.13943055100003, 33.37397803600004],
              [132.13066048300004, 33.36356636600004],
              [132.114136518, 33.36415118300005],
              [132.1015677480001, 33.37013383500005],
              [132.1102955670001, 33.386727643000086],
              [132.07350789600002, 33.36763167000004],
              [132.02548739100007, 33.344903696000074],
              [132.01053892000004, 33.34898863900008],
              [132.02963653000006, 33.36524659100007],
              [132.0515547, 33.37604022700009],
              [132.094319993, 33.40848712800005],
              [132.13548759700006, 33.42002259800006],
              [132.153248276, 33.41542941400007],
              [132.16657605400007, 33.42020372400009],
              [132.15708555000003, 33.42884152800008],
              [132.155280026, 33.437046147000046],
              [132.1713312610001, 33.445634434000056],
              [132.19976662700003, 33.455010144000084],
              [132.22188075000008, 33.45402577700008],
              [132.24068462600007, 33.464576055000066],
              [132.26463165100006, 33.464073502000076],
              [132.2937458780001, 33.48538023100008],
              [132.41236412900003, 33.53497955900008],
              [132.42847741000003, 33.54759349200009],
              [132.43539472700002, 33.563666083000044],
              [132.44166100400003, 33.57294342700004],
              [132.47046959700003, 33.60211823100008],
              [132.4795028000001, 33.60834381700005],
              [132.50061234100008, 33.62499820900007],
              [132.60173587300005, 33.66038646000004],
              [132.61848949800003, 33.67428922700009],
              [132.64547459300002, 33.68958766600008],
              [132.676605665, 33.71564362200007],
              [132.69711347700002, 33.756740627000056],
              [132.69556725400003, 33.786444403000075],
              [132.69008267200002, 33.81390538000005],
              [132.6989816580001, 33.85038414600007],
              [132.70628330500006, 33.87705178500005],
              [132.712370372, 33.904548780000084],
              [132.7549368770001, 33.91032024900005],
              [132.75748129400006, 33.93494834400008],
              [132.7724715500001, 33.95587799700007],
              [132.76986156700002, 33.996270044000084],
              [132.798733867, 34.013104233000035],
              [132.84718604500006, 34.03996357900007],
              [132.8623590960001, 34.055893542000035],
              [132.91911043000005, 34.06840607300006],
              [132.92252062900002, 34.08483910800004],
              [132.93033802800005, 34.094375970000044],
              [132.9261582900001, 34.11166809600007],
              [132.90620625300005, 34.11316541800005],
              [132.89536372300006, 34.11321435000008],
              [132.8974999410001, 34.12271401800007],
              [132.91551131900007, 34.12025878700007],
              [132.92877482400002, 34.11987449700007],
              [132.94238361200007, 34.14126203700005],
              [132.95403348500008, 34.12539330900006],
              [132.96132289500008, 34.12113403200004],
              [132.96631920700008, 34.11432526200008],
              [132.9765731130001, 34.108587958000044],
              [133.0318488380001, 34.052734410000085],
              [133.06031334700003, 33.99135976800005],
              [133.06919679500004, 33.97422315400007],
              [133.077294392, 33.959732720000034],
              [133.08660030500005, 33.94931331500004],
              [133.10776334500008, 33.94117284200007],
              [133.1270108880001, 33.93329063900006],
              [133.146703956, 33.93154110200004],
              [133.173292231, 33.94058406500005],
              [133.208868424, 33.94740331400004],
              [133.24368022400006, 33.95625729500006],
              [133.24887447000003, 33.97410853100007],
              [133.2790455600001, 33.983276759000034],
              [133.29982343000006, 33.98102486000005],
              [133.322607543, 33.990552810000054],
              [133.340966815, 33.98993913600009],
              [133.35994768400008, 33.98270960000008],
              [133.41480553500003, 33.98574453300006],
              [133.43824303500003, 33.98187897300005],
              [133.4863387380001, 33.96674225500004],
              [133.51099694100003, 33.96523672100005],
              [133.532074415, 33.97093333500004],
              [133.54859459700003, 33.98094310100004],
              [133.56169681100005, 33.993394273000035],
              [133.57252037900003, 34.00617096600007],
              [133.587250196, 34.02033112200007],
              [133.62086022200003, 34.04555898600006],
              [133.63396243600005, 34.06077708500004],
              [133.64128665500004, 34.07916901200008],
              [133.64812259200005, 34.124660549000055],
              [133.64600670700008, 34.16738515800006],
              [133.6411238940001, 34.18463776200008],
              [133.63298587300005, 34.19830963700008],
              [133.62037194100003, 34.21165599200009],
              [133.6040145190001, 34.22337474200009],
              [133.58765709700003, 34.23191966400009],
              [133.5722762380001, 34.242173570000034],
              [133.55836022200003, 34.259466864000046],
              [133.57935631600003, 34.24941640800006],
              [133.60922285200002, 34.23895905200004],
              [133.637543165, 34.233587958000044],
              [133.65447024800005, 34.23895905200004],
              [133.67261803500003, 34.22313060100004],
              [133.70142662900003, 34.23126862200007],
              [133.73194420700008, 34.25096263200004],
              [133.75464928500003, 34.27000560100004],
              [133.78199303500003, 34.288275458000044],
              [133.84359785200002, 34.31224192900004],
              [133.87419681100005, 34.32831452000005],
              [133.8828231130001, 34.33844635600008],
              [133.8906356130001, 34.35219961100006],
              [133.89966881600003, 34.364162502000056],
              [133.9121199880001, 34.36933014500005],
              [133.9209090500001, 34.370428778000075],
              [133.93702233200008, 34.375067450000074],
              [133.94654381600003, 34.376166083000044],
              [133.95622806100005, 34.37396881700005],
              [133.97087649800005, 34.36465078300006],
              [133.98902428500003, 34.36078522300005],
              [134.00123131600003, 34.35224030200004],
              [134.01197350400003, 34.348822333000044],
              [134.02125084700003, 34.34918854400007],
              [134.03687584700003, 34.354681708000044],
              [134.04615319100003, 34.35504791900007],
              [134.08130944100003, 34.347723700000074],
              [134.0883895190001, 34.354803778000075],
              [134.10075931100005, 34.376166083000044],
              [134.11687259200005, 34.36050039300005],
              [134.12281334700003, 34.36660390800006],
              [134.12452233200008, 34.380845445000034],
              [134.1274520190001, 34.38979726800005],
              [134.1435653000001, 34.391791083000044],
              [134.15300540500004, 34.38572825700004],
              [134.1582137380001, 34.37494538000004],
              [134.16163170700008, 34.362494208000044],
              [134.16163170700008, 34.33490631700005],
              [134.16627037900003, 34.32485586100006],
              [134.1826278000001, 34.32094961100006],
              [134.1904403000001, 34.325384833000044],
              [134.21216881600003, 34.34723541900007],
              [134.2168074880001, 34.35504791900007],
              [134.23780358200008, 34.34080638200004],
              [134.26042728000004, 34.334418036000045],
              [134.27125084700003, 34.32306549700007],
              [134.2578231130001, 34.294175523000035],
              [134.2968856130001, 34.27529531500005],
              [134.3095809250001, 34.273098049000055],
              [134.32178795700008, 34.26894765800006],
              [134.34351647200003, 34.25063711100006],
              [134.35767662900003, 34.24640534100007],
              [134.384125196, 34.250067450000074],
              [134.39665774800005, 34.24945709800005],
              [134.401703321, 34.24274323100008],
              [134.40577233200008, 34.234442450000074],
              [134.41570071700005, 34.22418854400007],
              [134.43976701100007, 34.20834943300008],
              [134.46862330400006, 34.20746014400004],
              [134.4952425680001, 34.22423534200004],
              [134.560883009, 34.22142161700009],
              [134.58171634200005, 34.22964101800005],
              [134.5942488940001, 34.232123114000046],
              [134.6071447930001, 34.25084548800004],
              [134.61109366800008, 34.239414243000056],
              [134.60048233600003, 34.22819423200008],
              [134.59404424800005, 34.21381249700005],
              [134.610349369, 34.216027454000084],
              [134.62789552800007, 34.23308190400007],
              [134.6468714560001, 34.239252459000056],
              [134.6407007040001, 34.22535586200007],
              [134.62717628000007, 34.20967378800009],
              [134.625747865, 34.201014144000055],
              [134.62540441400006, 34.19346690900005],
              [134.62720787900003, 34.187933661000045],
              [134.607758009, 34.18431224200009],
              [134.6191512380001, 34.182074286000045],
              [134.628265821, 34.17792389500005],
              [134.64208874500002, 34.179263295000055],
              [134.634302263, 34.16593226800006],
              [134.623695527, 34.150771923000036],
              [134.620462621, 34.14025293000009],
              [134.62273196700005, 34.134466864000046],
              [134.60518737900009, 34.110776919000045],
              [134.60458482500007, 34.08483439100007],
              [134.607758009, 34.067613023000035],
              [134.60181725400003, 34.063706773000035],
              [134.59522545700008, 34.04596588700008],
              [134.5942488940001, 34.03974030200004],
              [134.594574415, 34.02977122600004],
              [134.59978274800005, 34.009466864000046],
              [134.604966364, 34.001024089000055],
              [134.61163713300004, 33.997020270000064],
              [134.62425075300007, 33.99758112900008],
              [134.62659146500005, 34.00813961600005],
              [134.637016, 34.01066622400009],
              [134.65092897, 33.98594078100007],
              [134.662916031, 33.96886860900008],
              [134.69596250000006, 33.95189325700005],
              [134.69023165700003, 33.94239734900009],
              [134.70257054, 33.93726674100009],
              [134.70223081000006, 33.92096530500004],
              [134.70289147200003, 33.906236070000034],
              [134.69071417600003, 33.89573350400008],
              [134.68677819100003, 33.88621653900009],
              [134.67351321700005, 33.88165924700007],
              [134.66236412900003, 33.875881252000056],
              [134.64625084700003, 33.85309479400007],
              [134.66081790500004, 33.84638092700004],
              [134.71705162900003, 33.84796784100007],
              [134.71705162900003, 33.84170156500005],
              [134.70826256600003, 33.84056224200009],
              [134.6982528000001, 33.83624909100007],
              [134.689789259, 33.83490631700005],
              [134.689789259, 33.82807038000004],
            ],
          ],
          [
            [
              [133.12134850400003, 36.10976797100005],
              [133.13542728000004, 36.089544989000046],
              [133.12322024800005, 36.062933661000045],
              [133.09945722700002, 36.03750234600005],
              [133.0791121750001, 36.02094147300005],
              [133.0786238940001, 36.049994208000044],
              [133.08130944100003, 36.080145575000074],
              [133.09351647200003, 36.102769273000035],
              [133.12134850400003, 36.10976797100005],
            ],
          ],
          [
            [
              [133.09058678500003, 36.11786530200004],
              [133.09327233200008, 36.12335846600007],
              [133.113617384, 36.11351146000004],
              [133.09327233200008, 36.10976797100005],
              [133.09058678500003, 36.11786530200004],
            ],
          ],
          [
            [
              [133.0742293630001, 36.12791575700004],
              [133.08757571700005, 36.127020575000074],
              [133.08814537900003, 36.11827220300006],
              [133.08716881600003, 36.11078522300005],
              [133.0727645190001, 36.107855536000045],
              [133.05836022200003, 36.103176174000055],
              [133.0517684250001, 36.08551666900007],
              [133.05396569100003, 36.07489655200004],
              [133.056976759, 36.067694403000075],
              [133.05583743600005, 36.061753648000035],
              [133.0449324880001, 36.055121161000045],
              [133.035980665, 36.053900458000044],
              [133.02702884200005, 36.056301174000055],
              [133.01978600400003, 36.060614325000074],
              [133.01710045700008, 36.06500885600008],
              [133.01677493600005, 36.07477448100008],
              [133.01490319100003, 36.079779364000046],
              [133.01002037900003, 36.08152903900009],
              [133.00025475400003, 36.08177317900004],
              [132.99040774800005, 36.077053127000056],
              [132.9931746750001, 36.06635163000004],
              [133.00407962300005, 36.04828522300005],
              [132.99496504, 36.03823476800005],
              [132.9814559250001, 36.03986237200007],
              [132.96550540500004, 36.04913971600007],
              [132.94939212300005, 36.06195709800005],
              [132.96949303500003, 36.082017320000034],
              [133.01449629, 36.110988674000055],
              [133.03874759200005, 36.13080475500004],
              [133.0566512380001, 36.12494538000004],
              [133.0742293630001, 36.12791575700004],
            ],
          ],
          [
            [
              [133.422211134, 34.445013739000046],
              [133.412445509, 34.42446523600006],
              [133.34107506600003, 34.34804922100005],
              [133.325531446, 34.336818752000056],
              [133.2954207690001, 34.32489655200004],
              [133.2817488940001, 34.321519273000035],
              [133.26978600400003, 34.32241445500006],
              [133.2646590500001, 34.331732489000046],
              [133.269867384, 34.339178778000075],
              [133.2822371750001, 34.34271881700005],
              [133.2959090500001, 34.345038153000075],
              [133.305511915, 34.348822333000044],
              [133.3149520190001, 34.36603424700007],
              [133.3046981130001, 34.37759023600006],
              [133.2832137380001, 34.38312409100007],
              [133.25847415500004, 34.38231028900009],
              [133.25847415500004, 34.38979726800005],
              [133.27662194100003, 34.40176015800006],
              [133.2666121750001, 34.42059967700004],
              [133.24732506600003, 34.42649974200009],
              [133.22966556100005, 34.376166083000044],
              [133.213226759, 34.36310455900008],
              [133.19499759200005, 34.35370514500005],
              [133.1821395190001, 34.34137604400007],
              [133.20191491000003, 34.32831452000005],
              [133.20866946700005, 34.307806708000044],
              [133.20289147200003, 34.28888580900008],
              [133.1855574880001, 34.280503648000035],
              [133.1782332690001, 34.28278229400007],
              [133.16578209700003, 34.292303778000075],
              [133.160980665, 34.294175523000035],
              [133.155609571, 34.29181549700007],
              [133.14405358200008, 34.28261953300006],
              [133.12517337300005, 34.276271877000056],
              [133.10271243600005, 34.257147528000075],
              [133.09327233200008, 34.25263092700004],
              [133.07642662900003, 34.25958893400008],
              [133.070648634, 34.27724844000005],
              [133.0722762380001, 34.31753164300005],
              [133.07691491000003, 34.31671784100007],
              [133.08741295700008, 34.32648346600007],
              [133.10328209700003, 34.34511953300006],
              [133.11402428500003, 34.35175202000005],
              [133.11793053500003, 34.34227122600004],
              [133.11703535200002, 34.32656484600005],
              [133.1132918630001, 34.314113674000055],
              [133.133148634, 34.31818268400008],
              [133.1474715500001, 34.35138580900008],
              [133.1684676440001, 34.35504791900007],
              [133.1684676440001, 34.362494208000044],
              [133.15259850400003, 34.37384674700007],
              [133.13428795700008, 34.38231028900009],
              [133.12322024800005, 34.38434479400007],
              [133.1132918630001, 34.383978583000044],
              [133.1035262380001, 34.38458893400008],
              [133.09327233200008, 34.38979726800005],
              [133.0791121750001, 34.38231028900009],
              [133.08578535200002, 34.35101959800005],
              [133.0590926440001, 34.33234284100007],
              [133.01832116000003, 34.32330963700008],
              [132.91187584700003, 34.31476471600007],
              [132.88306725400003, 34.30459219000005],
              [132.85303795700008, 34.28733958500004],
              [132.83619225400003, 34.31110260600008],
              [132.81820722700002, 34.30337148600006],
              [132.79908287900003, 34.28400299700007],
              [132.77808678500003, 34.273098049000055],
              [132.7622176440001, 34.27033112200007],
              [132.764008009, 34.26316966400009],
              [132.772797071, 34.25340403900009],
              [132.77808678500003, 34.24274323100008],
              [132.7714949880001, 34.23529694200005],
              [132.75660241000003, 34.23232656500005],
              [132.7265731130001, 34.232123114000046],
              [132.70297285200002, 34.225490627000056],
              [132.6562606130001, 34.199286200000074],
              [132.62720787900003, 34.19798411700009],
              [132.62224368600005, 34.20189036700009],
              [132.61841881600003, 34.20888906500005],
              [132.615570509, 34.21548086100006],
              [132.61353600400003, 34.218451239000046],
              [132.60425866000003, 34.21662018400008],
              [132.59945722700002, 34.21230703300006],
              [132.59652754, 34.20742422100005],
              [132.59302819100003, 34.20425039300005],
              [132.56617272200003, 34.19196198100008],
              [132.55445397200003, 34.19236888200004],
              [132.54468834700003, 34.20425039300005],
              [132.55982506600003, 34.218410549000055],
              [132.55062910200002, 34.23086172100005],
              [132.53345787900003, 34.24477773600006],
              [132.52100670700008, 34.26976146000004],
              [132.50733483200008, 34.28302643400008],
              [132.50367272200003, 34.28733958500004],
              [132.50342858200008, 34.30036041900007],
              [132.50709069100003, 34.30841705900008],
              [132.50904381600003, 34.31622955900008],
              [132.50367272200003, 34.32831452000005],
              [132.5107528000001, 34.32982005400004],
              [132.52312259200005, 34.33429596600007],
              [132.53101647200003, 34.335150458000044],
              [132.52613366000003, 34.34560781500005],
              [132.5175887380001, 34.35301341400009],
              [132.49683678500003, 34.362494208000044],
              [132.481293165, 34.35455963700008],
              [132.46168053500003, 34.34955475500004],
              [132.44157962300005, 34.35000234600005],
              [132.40552819100003, 34.368068752000056],
              [132.38347415500004, 34.365668036000045],
              [132.346039259, 34.348822333000044],
              [132.31234785200002, 34.32697174700007],
              [132.22250410200002, 34.23895905200004],
              [132.23170006600003, 34.22524648600006],
              [132.2382918630001, 34.20425039300005],
              [132.24040774800005, 34.18980540600006],
              [132.24366295700008, 34.16693756700005],
              [132.23894290500004, 34.142645575000074],
              [132.2275496750001, 34.132025458000044],
              [132.21371504, 34.124335028000075],
              [132.20191491000003, 34.108587958000044],
              [132.19906660200002, 34.06476471600007],
              [132.2109481130001, 34.02521393400008],
              [132.213226759, 33.98965078300006],
              [132.18148847700002, 33.95783112200007],
              [132.1572371750001, 33.948919989000046],
              [132.1425887380001, 33.94643789300005],
              [132.13559004, 33.93842194200005],
              [132.1337996750001, 33.913397528000075],
              [132.13892662900003, 33.894964911000045],
              [132.15992272200003, 33.85732656500005],
              [132.16163170700008, 33.84170156500005],
              [132.15007571700005, 33.830145575000074],
              [132.105804884, 33.809027411000045],
              [132.07593834700003, 33.78705475500004],
              [132.05591881600003, 33.77716705900008],
              [132.041351759, 33.776271877000056],
              [132.04444420700008, 33.79328034100007],
              [132.0654403000001, 33.80695221600007],
              [132.0688582690001, 33.81167226800005],
              [132.07634524800005, 33.82672760600008],
              [132.078461134, 33.83490631700005],
              [132.08716881600003, 33.825100002000056],
              [132.09888756600003, 33.82363515800006],
              [132.10889733200008, 33.83026764500005],
              [132.1132918630001, 33.84487539300005],
              [132.10922285200002, 33.862616278000075],
              [132.09945722700002, 33.872259833000044],
              [132.08708743600005, 33.878566799000055],
              [132.07545006600003, 33.886419989000046],
              [132.05779056100005, 33.89524974200009],
              [131.99480228000004, 33.91347890800006],
              [131.97234134200005, 33.91681549700007],
              [131.96656334700003, 33.921535549000055],
              [131.9419051440001, 33.95091380400004],
              [131.93091881600003, 33.95697663000004],
              [131.9033309250001, 33.96670156500005],
              [131.8935653000001, 33.97142161700009],
              [131.87086022200003, 33.98851146000004],
              [131.8520613940001, 33.99835846600007],
              [131.83366946700005, 33.99469635600008],
              [131.81226647200003, 33.97142161700009],
              [131.826508009, 33.97142161700009],
              [131.826508009, 33.96523672100005],
              [131.791351759, 33.964056708000044],
              [131.77955162900003, 33.96967194200005],
              [131.77751712300005, 33.98574453300006],
              [131.80730228000004, 34.00580475500004],
              [131.82390384200005, 34.02016836100006],
              [131.8227645190001, 34.026678778000075],
              [131.81364993600005, 34.02875397300005],
              [131.79957116000003, 34.03774648600006],
              [131.74146569100003, 34.05621979400007],
              [131.70337975400003, 34.044175523000035],
              [131.68873131600003, 34.04718659100007],
              [131.676117384, 34.04018789300005],
              [131.644867384, 34.02887604400007],
              [131.63347415500004, 34.026678778000075],
              [131.60621178500003, 34.026678778000075],
              [131.60173587300005, 34.03001536700009],
              [131.5981551440001, 34.036037502000056],
              [131.59327233200008, 34.03729889500005],
              [131.58513431100005, 34.026678778000075],
              [131.59400475400003, 34.015326239000046],
              [131.59742272200003, 34.00263092700004],
              [131.59302819100003, 33.99168528900009],
              [131.57886803500003, 33.98574453300006],
              [131.57178795700008, 33.98517487200007],
              [131.56763756600003, 33.98627350500004],
              [131.56568444100003, 33.98965078300006],
              [131.56519616000003, 33.99628327000005],
              [131.56226647200003, 34.00462474200009],
              [131.55616295700008, 34.005194403000075],
              [131.551117384, 34.00214264500005],
              [131.55103600400003, 33.99941640800006],
              [131.51929772200003, 34.00849030200004],
              [131.51050866000003, 34.01239655200004],
              [131.493011915, 34.02814362200007],
              [131.4829207690001, 34.03204987200007],
              [131.46900475400003, 34.026678778000075],
              [131.47380618600005, 34.01862213700008],
              [131.47429446700005, 34.01398346600007],
              [131.46900475400003, 34.00617096600007],
              [131.46631920700008, 34.00678131700005],
              [131.45671634200005, 33.999335028000075],
              [131.45533287900003, 33.99315013200004],
              [131.45199629, 33.989569403000075],
              [131.45183353000004, 33.98590729400007],
              [131.449554884, 33.98224518400008],
              [131.44117272200003, 33.97890859600005],
              [131.43433678500003, 33.98021067900004],
              [131.4282332690001, 33.98590729400007],
              [131.42351321700005, 33.99310944200005],
              [131.42058353000004, 33.99941640800006],
              [131.41553795700008, 33.98940664300005],
              [131.40967858200008, 33.98305898600006],
              [131.40251712300005, 33.98139069200005],
              [131.39332116000003, 33.98574453300006],
              [131.40219160200002, 33.999335028000075],
              [131.4047957690001, 34.017279364000046],
              [131.40064537900003, 34.03294505400004],
              [131.38990319100003, 34.03974030200004],
              [131.383148634, 34.03302643400008],
              [131.35572350400003, 33.989447333000044],
              [131.3325301440001, 33.962103583000044],
              [131.32195071700005, 33.95307038000004],
              [131.27222741000003, 33.92682526200008],
              [131.25798587300005, 33.92479075700004],
              [131.24984785200002, 33.937933661000045],
              [131.242523634, 33.934475002000056],
              [131.23357181100005, 33.93305084800005],
              [131.22584069100003, 33.93500397300005],
              [131.2226668630001, 33.94135163000004],
              [131.2207137380001, 33.950384833000044],
              [131.2158309250001, 33.95075104400007],
              [131.20923912900003, 33.947251695000034],
              [131.2021590500001, 33.94476959800005],
              [131.20036868600005, 33.94253164300005],
              [131.194672071, 33.93764883000006],
              [131.18702233200008, 33.93276601800005],
              [131.1782332690001, 33.93048737200007],
              [131.173187696, 33.93398672100005],
              [131.17066491000003, 33.94188060100004],
              [131.16026595300002, 33.95279605600007],
              [131.1615370830001, 33.96437425400006],
              [131.16684004, 33.97239817900004],
              [131.1660262380001, 33.97711823100008],
              [131.15739993600005, 33.97890859600005],
              [131.12399879100008, 33.99993139600008],
              [131.10316468400003, 34.03021689000008],
              [131.072423984, 34.03699727700007],
              [131.03559480800004, 34.04797509500008],
              [131.01396225400003, 34.01476201500009],
              [130.96859785200002, 33.97142161700009],
              [130.93208630100003, 33.94536528400005],
              [130.926290665, 33.922690670000065],
              [130.91575345500007, 33.913989822000076],
              [130.89918053500003, 33.924261786000045],
              [130.89372806100005, 33.93231842700004],
              [130.8794051440001, 33.937933661000045],
              [130.88022440100008, 33.95043178000009],
              [130.8994246750001, 33.94985586100006],
              [130.90965033600003, 33.973651604000054],
              [130.90772545700008, 33.98493073100008],
              [130.913422071, 33.99941640800006],
              [130.91713452200008, 34.01091306300009],
              [130.912811701, 34.02192067800007],
              [130.9052840500001, 34.02960846600007],
              [130.91257739700006, 34.05334156200007],
              [130.9039136780001, 34.06582577800009],
              [130.87842858200008, 34.06785716400009],
              [130.87322024800005, 34.078192450000074],
              [130.86931399800005, 34.09174225500004],
              [130.86280358200008, 34.10179271000004],
              [130.86158287900003, 34.11273834800005],
              [130.87322024800005, 34.12909577000005],
              [130.88648522200003, 34.13898346600007],
              [130.899261915, 34.14565664300005],
              [130.9111434250001, 34.15448639500005],
              [130.9209090500001, 34.17064036700009],
              [130.92335045700008, 34.18378327000005],
              [130.920258009, 34.192572333000044],
              [130.91578209700003, 34.19969310100004],
              [130.91041100400003, 34.22492096600007],
              [130.89673912900003, 34.24481842700004],
              [130.89372806100005, 34.25604889500005],
              [130.8916121750001, 34.259833075000074],
              [130.87623131600003, 34.27000560100004],
              [130.8715926440001, 34.27924225500004],
              [130.875336134, 34.28668854400007],
              [130.88200931100005, 34.293402411000045],
              [130.88624108200008, 34.300441799000055],
              [130.8896590500001, 34.33120351800005],
              [130.8930770190001, 34.34349192900004],
              [130.89991295700008, 34.35504791900007],
              [130.9111434250001, 34.350897528000075],
              [130.92741946700005, 34.348944403000075],
              [130.9419051440001, 34.35097890800006],
              [130.9482528000001, 34.35879140800006],
              [130.95476321700005, 34.36172109600005],
              [130.9961043630001, 34.36933014500005],
              [131.0117293630001, 34.37596263200004],
              [131.03360681000004, 34.381789240000046],
              [131.01788186800002, 34.39329681000004],
              [131.00359134200005, 34.39288971600007],
              [130.96509850400003, 34.39996979400007],
              [130.9550887380001, 34.40346914300005],
              [130.94890384200005, 34.39500560100004],
              [130.9462996750001, 34.39240143400008],
              [130.933929884, 34.39598216400009],
              [130.93921959700003, 34.40770091400009],
              [130.9477645190001, 34.41893138200004],
              [130.95875084700003, 34.427435614000046],
              [130.97639607600001, 34.438967292000086],
              [130.989731698, 34.43503825300007],
              [131.0028453540001, 34.42594628900008],
              [131.00114993600005, 34.41486237200007],
              [131.0097762380001, 34.41030508000006],
              [131.02263431100005, 34.409369208000044],
              [131.03728274800005, 34.41111888200004],
              [131.05095462300005, 34.41518789300005],
              [131.06120853000004, 34.42084381700005],
              [131.0747176440001, 34.42475006700005],
              [131.09937584700003, 34.413275458000044],
              [131.11571755700004, 34.40979405500008],
              [131.133922988, 34.41156180400009],
              [131.14079837300005, 34.37848541900007],
              [131.153656446, 34.36933014500005],
              [131.172699415, 34.36774323100008],
              [131.17895756400003, 34.37877599700005],
              [131.19170165700007, 34.39364779300007],
              [131.17359459700003, 34.410223700000074],
              [131.17058353000004, 34.41681549700007],
              [131.17131454900004, 34.42953460500007],
              [131.192718946, 34.42475006700005],
              [131.207367384, 34.428941148000035],
              [131.2348738940001, 34.43349844000005],
              [131.2526317610001, 34.437386992000086],
              [131.26453684, 34.42808719400006],
              [131.28121391700006, 34.40795780000008],
              [131.26625585200009, 34.409448841000085],
              [131.25102696400006, 34.41913055400005],
              [131.24101992700002, 34.421183598000084],
              [131.2295028000001, 34.41771067900004],
              [131.222015821, 34.40839264500005],
              [131.21607506600003, 34.396918036000045],
              [131.211761915, 34.38377513200004],
              [131.2089949880001, 34.36933014500005],
              [131.21607506600003, 34.372300523000035],
              [131.22877037900003, 34.380194403000075],
              [131.23617597700002, 34.38231028900009],
              [131.28448215100002, 34.384211288000074],
              [131.32309029500004, 34.393011809000086],
              [131.33473090300004, 34.41611429100004],
              [131.3650500120001, 34.41565087500004],
              [131.41431725400003, 34.42397695500006],
              [131.41331462800008, 34.45387373300008],
              [131.42640717300003, 34.46564545000007],
              [131.45622806100005, 34.49038320500006],
              [131.4619246750001, 34.499253648000035],
              [131.45476321700005, 34.51911041900007],
              [131.461761915, 34.523504950000074],
              [131.48267662900003, 34.52757396000004],
              [131.52076256600003, 34.55190664300005],
              [131.536468946, 34.565619208000044],
              [131.55103600400003, 34.58152903900009],
              [131.55543053500003, 34.59218984600005],
              [131.55729919400005, 34.61485699900004],
              [131.56479249900008, 34.61949431700009],
              [131.58518438800002, 34.61842166400004],
              [131.59587649800005, 34.616848049000055],
              [131.5942488940001, 34.62567780200004],
              [131.59410358500008, 34.64205125400008],
              [131.59687157300004, 34.659589372000084],
              [131.6152418900001, 34.66488063600008],
              [131.6294051440001, 34.65924713700008],
              [131.65641471600009, 34.65358629000008],
              [131.6708585570001, 34.662817774000075],
              [131.67335498800003, 34.67093186000005],
              [131.680332196, 34.674649043000045],
              [131.71159915500004, 34.671576239000046],
              [131.746081807, 34.675353457000085],
              [131.790375196, 34.68610260600008],
              [131.82295583100006, 34.69828303200006],
              [131.840784385, 34.70532851000007],
              [131.8584090500001, 34.714504299000055],
              [131.86312910200002, 34.737494208000044],
              [131.86687259200005, 34.74603913000004],
              [131.87375767000003, 34.75922287700007],
              [131.89633222700002, 34.762925523000035],
              [131.90132190300005, 34.77045129700008],
              [131.92378849800002, 34.78785980400005],
              [131.95700657400005, 34.81303024300007],
              [131.99732506600003, 34.837225653000075],
              [132.02116946700005, 34.86587148600006],
              [132.0345512, 34.87657900500005],
              [132.05388431100005, 34.872259833000044],
              [132.0605574880001, 34.88568756700005],
              [132.06330411800002, 34.907489343000066],
              [132.11117597700002, 34.94310130400004],
              [132.1318465500001, 34.958644924000055],
              [132.157940371, 34.97613237400009],
              [132.21631920700008, 35.01357656500005],
              [132.23649497000008, 35.034818088000065],
              [132.27084188700007, 35.040329058000054],
              [132.29361034800002, 35.04840696100007],
              [132.31684998700007, 35.062346339000044],
              [132.326594268, 35.09206984400004],
              [132.3570407420001, 35.11120724300008],
              [132.37994884300008, 35.124980778000065],
              [132.38921227800006, 35.13482940100005],
              [132.386574258, 35.14553759200004],
              [132.4023543630001, 35.16046784100007],
              [132.40808491500002, 35.17505067800005],
              [132.4676775580001, 35.213148079000064],
              [132.49582670100006, 35.23245521000007],
              [132.52971849900007, 35.24491322200004],
              [132.53193742200006, 35.25767159600008],
              [132.5502652560001, 35.262432293000074],
              [132.5756172450001, 35.27327009700008],
              [132.62114153700009, 35.28444409600007],
              [132.63867918900007, 35.29464467300005],
              [132.65139544300007, 35.31292353300006],
              [132.663346756, 35.32953554900007],
              [132.67144646200006, 35.355128136000076],
              [132.67413653100004, 35.37203725400008],
              [132.67402321100008, 35.38542475600008],
              [132.6707911430001, 35.39947458800009],
              [132.65374245600003, 35.40686988900006],
              [132.63114205500005, 35.41981396300008],
              [132.62380835800002, 35.43106990400008],
              [132.63535916900003, 35.44095469500007],
              [132.6558763710001, 35.44299398600009],
              [132.68209873600006, 35.44901641600006],
              [132.70144369900004, 35.44921971800005],
              [132.73443814200004, 35.44863223200008],
              [132.74855100700006, 35.451549379000085],
              [132.75473933400008, 35.45624507500008],
              [132.744476759, 35.46356842700004],
              [132.72549563500002, 35.47077964400006],
              [132.73627944100008, 35.47274245600005],
              [132.7527198370001, 35.47707763500006],
              [132.77542651400006, 35.481007496000075],
              [132.80482662200006, 35.49518180100006],
              [132.83767937900006, 35.506123184000046],
              [132.86490913700004, 35.51098268100009],
              [132.92223136400003, 35.51317501300008],
              [132.9463653800001, 35.518677497000056],
              [132.9697371750001, 35.51699453300006],
              [132.97320551100006, 35.54188385000003],
              [132.991485344, 35.544551314000046],
              [133.0143994870001, 35.540780117000054],
              [133.033489379, 35.545992142000046],
              [133.04249238800003, 35.56152796900005],
              [133.05177218200004, 35.57373032500004],
              [133.064600605, 35.580271302000085],
              [133.08144222400006, 35.57532590200009],
              [133.09134539000001, 35.58753877200007],
              [133.091261013, 35.60148491100006],
              [133.10535285100002, 35.597516589000065],
              [133.11973193300003, 35.584906973000045],
              [133.14142764200005, 35.57016529100008],
              [133.15646656900003, 35.56262168500007],
              [133.189661129, 35.57190753200007],
              [133.20706772900007, 35.57282813000006],
              [133.22473074000004, 35.58294498500004],
              [133.2301629320001, 35.578197844000044],
              [133.2231551440001, 35.56850820500006],
              [133.22803795700008, 35.56468333500004],
              [133.23933637000005, 35.563614802000075],
              [133.24625319200004, 35.567319817000055],
              [133.266376798, 35.574236505000044],
              [133.28677883300008, 35.57619275300004],
              [133.308772373, 35.57718857800006],
              [133.32601972700002, 35.56850820500006],
              [133.312904215, 35.56197612100004],
              [133.29887426200003, 35.55863831700009],
              [133.286928536, 35.55372692200007],
              [133.27013504800004, 35.54961013700006],
              [133.25749759200005, 35.53620026200008],
              [133.254730665, 35.53384023600006],
              [133.25416100400003, 35.52179596600007],
              [133.26050866000003, 35.50995514500005],
              [133.2646590500001, 35.496161200000074],
              [133.29454316300007, 35.48041646300004],
              [133.3296256210001, 35.46550438700007],
              [133.3608574540001, 35.46041669200008],
              [133.38068988100008, 35.45641486000005],
              [133.40015709700003, 35.454291083000044],
              [133.41741190900007, 35.45654296500004],
              [133.44124508900006, 35.49103766500008],
              [133.49275500400006, 35.51036183600007],
              [133.52559462700003, 35.52242699200008],
              [133.58018171100002, 35.533602742000085],
              [133.6325682480001, 35.52132835600008],
              [133.731144642, 35.50290661400004],
              [133.9115467370001, 35.51459457200008],
              [134.00838333700005, 35.53704892300004],
              [134.03478971200002, 35.519355662000066],
              [134.17366172700008, 35.53627136000006],
              [134.23776516100008, 35.546651206000035],
              [134.26206575800006, 35.55358778700008],
              [134.281586134, 35.564886786000045],
              [134.29387121000002, 35.585893956000064],
              [134.34262129, 35.593817450000074],
              [134.3520613940001, 35.594183661000045],
              [134.36150149800005, 35.595770575000074],
              [134.37649117900003, 35.61118425500007],
              [134.41382264900005, 35.621139940000035],
              [134.46621486200002, 35.63755465300005],
              [134.4980957360001, 35.653879327000084],
              [134.5369873090001, 35.67220309900006],
              [134.59020875200008, 35.65942839100006],
              [134.64744713200002, 35.664265416000035],
              [134.691474502, 35.66344715900004],
              [134.76690713200003, 35.66655919200008],
              [134.79829520400006, 35.665642253000044],
              [134.81341933700003, 35.66237377200008],
              [134.834137144, 35.65714558500008],
              [134.842348044, 35.645365334000076],
              [134.863249913, 35.658278401000075],
              [134.88096824600007, 35.657322495000074],
              [134.885047535, 35.64591375200007],
              [134.897749492, 35.64916184900005],
              [134.91570383300007, 35.64436743400006],
              [134.92701256600003, 35.64118073100008],
              [134.9472762380001, 35.65485260600008],
              [134.9536238940001, 35.657904364000046],
              [134.96371504, 35.661037502000056],
              [134.95962217700003, 35.67375324500006],
              [134.98794378000002, 35.689777236000054],
              [135.010843852, 35.69111295300007],
              [135.0290315420001, 35.69286863100007],
              [135.04482240700008, 35.70173922100008],
              [135.08578535200002, 35.72597890800006],
              [135.084119836, 35.73902244700008],
              [135.13430528700007, 35.751901306000036],
              [135.18384850400003, 35.76023997600004],
              [135.21013431100005, 35.763373114000046],
              [135.22684561200003, 35.772320652000076],
              [135.25066024, 35.75781549700008],
              [135.2617293630001, 35.73981354400007],
              [135.276703321, 35.73139069200005],
              [135.29249108200008, 35.71165599200009],
              [135.304047071, 35.68891022300005],
              [135.30616295700008, 35.671535549000055],
              [135.2993270190001, 35.657904364000046],
              [135.27921371900004, 35.66853270000007],
              [135.25882700300008, 35.65682881300006],
              [135.246415178, 35.635520248000034],
              [135.242393935, 35.62264035600003],
              [135.2327554000001, 35.61421404300006],
              [135.2049023830001, 35.58735277400007],
              [135.18817537200005, 35.56504457600005],
              [135.188324232, 35.54525757600004],
              [135.196040821, 35.53989476800007],
              [135.20667266200007, 35.541467856000054],
              [135.208084182, 35.55905389800006],
              [135.2216903000001, 35.56793854400007],
              [135.23524646400006, 35.584548485000084],
              [135.24822550200008, 35.59169447900007],
              [135.25342858200008, 35.57127513200004],
              [135.2654376800001, 35.56707533200006],
              [135.27091067100002, 35.56292289500004],
              [135.26204205600004, 35.557546596000066],
              [135.25195709700006, 35.55731581800006],
              [135.2398152190001, 35.55796303400007],
              [135.23873893400003, 35.54202559100008],
              [135.301521966, 35.51324263100008],
              [135.31617752400007, 35.518337563000046],
              [135.32443612400004, 35.524446383000054],
              [135.33548989200006, 35.50821008500009],
              [135.3295641960001, 35.49475491900006],
              [135.32496178500003, 35.485663153000075],
              [135.31527754, 35.466782945000034],
              [135.3134871750001, 35.458644924000055],
              [135.31902103000004, 35.446966864000046],
              [135.33025149800005, 35.45453522300005],
              [135.339757307, 35.47112248900004],
              [135.35251785900005, 35.486984186000086],
              [135.3705039350001, 35.48612645800006],
              [135.394867384, 35.47646719000005],
              [135.4023543630001, 35.48216380400004],
              [135.4023543630001, 35.507025458000044],
              [135.37378991000003, 35.50169505400004],
              [135.3502240250001, 35.51031344800003],
              [135.3377962190001, 35.537477564000085],
              [135.3613387380001, 35.55418528900009],
              [135.37370853000004, 35.55768463700008],
              [135.4028426440001, 35.55817291900007],
              [135.4160262380001, 35.56167226800005],
              [135.42595462300005, 35.56981028900009],
              [135.4355574880001, 35.58002350500004],
              [135.43948099800002, 35.59056974300006],
              [135.46322209200002, 35.603327396000054],
              [135.45824425800004, 35.58698726200004],
              [135.452389789, 35.571781119000036],
              [135.47003048600004, 35.56595953900006],
              [135.482937686, 35.559199188000036],
              [135.478760705, 35.543724790000056],
              [135.4804793630001, 35.53388092700004],
              [135.47868899800005, 35.52728913000004],
              [135.4790145190001, 35.52252838700008],
              [135.4882918630001, 35.520697333000044],
              [135.49561608200008, 35.52391185100004],
              [135.50269616000003, 35.53164297100005],
              [135.5122176440001, 35.548041083000044],
              [135.51246178500003, 35.52985260600008],
              [135.508636915, 35.51190827000005],
              [135.51099694100003, 35.49819570500006],
              [135.52955162900003, 35.49274323100008],
              [135.55827884200005, 35.49176666900007],
              [135.5673934250001, 35.49274323100008],
              [135.57683353000004, 35.49599844000005],
              [135.59644616000003, 35.505113023000035],
              [135.605248565, 35.517168438000056],
              [135.62479780900003, 35.53234396900007],
              [135.64894517800008, 35.54283352900006],
              [135.66976972700002, 35.534369208000044],
              [135.66476622100004, 35.52966431400006],
              [135.64192428600006, 35.52171835000007],
              [135.63461347700002, 35.49355703300006],
              [135.6220809250001, 35.48655833500004],
              [135.645065724, 35.48020001400005],
              [135.69668606000005, 35.491842543000075],
              [135.72443120100002, 35.49073208600004],
              [135.7380363640001, 35.49873863800008],
              [135.74835148300008, 35.51371915000004],
              [135.74819794300004, 35.533525420000046],
              [135.72080139600007, 35.52230481500004],
              [135.70860440900003, 35.54055094000006],
              [135.69163589700008, 35.54587719600005],
              [135.70609333200002, 35.56209461800006],
              [135.73844643100006, 35.57053137300005],
              [135.74804468900004, 35.564204344000075],
              [135.75613707800005, 35.54907241500007],
              [135.77725798100005, 35.549856049000084],
              [135.7940502560001, 35.53138182200007],
              [135.81049953600007, 35.52686268400004],
              [135.834320509, 35.534369208000044],
              [135.82349694100003, 35.538397528000075],
              [135.81617272200003, 35.54596588700008],
              [135.80150220300004, 35.568003462000036],
              [135.804254904, 35.57517476400005],
              [135.81543350100003, 35.577591581000036],
              [135.825890457, 35.56935555100006],
              [135.84012939600007, 35.57341458900004],
              [135.85474694100003, 35.57904694200005],
              [135.8515731130001, 35.58641185100004],
              [135.84449303500003, 35.59174225500004],
              [135.83757571700005, 35.59918854400007],
              [135.834320509, 35.61318594000005],
              [135.83025149800005, 35.61713288000004],
              [135.81601831600005, 35.63085602400008],
              [135.8116846050001, 35.64340581100004],
              [135.82322255600002, 35.644620961000044],
              [135.84086572400008, 35.63365449200006],
              [135.85375711000006, 35.62491969800004],
              [135.86784078100004, 35.61775318300005],
              [135.9018474180001, 35.62436015600008],
              [135.909767096, 35.614962749000085],
              [135.91944111600003, 35.60816038200005],
              [135.9395865890001, 35.61843882000005],
              [135.95093848200008, 35.62888168500007],
              [135.9710528820001, 35.625981151000076],
              [135.98057361100007, 35.63048059100004],
              [135.98166761900006, 35.64363788800006],
              [135.96354036800005, 35.65540930800006],
              [135.97315915800004, 35.67621119000006],
              [135.97437115000002, 35.69094901400007],
              [135.97008375400003, 35.70299009100006],
              [135.95644806000007, 35.70056518700005],
              [135.95600508100006, 35.728324936000035],
              [135.98154353000007, 35.739854378000075],
              [136.01970526600007, 35.765347201000054],
              [136.03356317100008, 35.74622550600009],
              [136.03132091400005, 35.73807644700008],
              [136.03889018900009, 35.722506116000034],
              [136.04684700500002, 35.70372189800008],
              [136.041958142, 35.69146931700004],
              [136.03195403100005, 35.691626426000084],
              [136.027006444, 35.68094741500005],
              [136.04329577700003, 35.67016694600005],
              [136.04745939000009, 35.65881225800007],
              [136.06911435400002, 35.66187974300004],
              [136.07462120000002, 35.679031535000036],
              [136.08138118700003, 35.68419368000008],
              [136.083595424, 35.69044927400006],
              [136.082647693, 35.70439476100006],
              [136.09239818700007, 35.71516472700006],
              [136.09263301800001, 35.724638680000055],
              [136.0929581580001, 35.743115180000075],
              [136.09986412900003, 35.759833075000074],
              [136.09945722700002, 35.77570221600007],
              [136.088212409, 35.795294073000036],
              [136.07668286700005, 35.81173807300007],
              [136.07049761300004, 35.82474933100008],
              [136.04880787900004, 35.83866838800009],
              [136.01226671000006, 35.870980305000046],
              [135.99345406400005, 35.88514211700004],
              [135.99535838000008, 35.913108400000056],
              [135.99438018900003, 35.93591278200006],
              [135.9707075560001, 35.96006407300007],
              [135.95728600400003, 35.97313060100004],
              [135.96321741100007, 35.999923222000064],
              [135.9873431540001, 36.01173328500005],
              [136.0001323890001, 36.02418682700005],
              [136.017914259, 36.05744049700007],
              [136.03109785200002, 36.08071523600006],
              [136.04361081500008, 36.11083253800007],
              [136.09282041200004, 36.161363244000086],
              [136.1075493940001, 36.18516511200005],
              [136.1201548570001, 36.19975469800005],
              [136.13484480500006, 36.22455239400006],
              [136.119422397, 36.246444489000055],
              [136.12417327600008, 36.25317933200006],
              [136.144911235, 36.25427923600006],
              [136.16262712500009, 36.252242211000066],
              [136.1967378060001, 36.26436216400003],
              [136.27866738800003, 36.32240577500005],
              [136.29841744100008, 36.34727817000004],
              [136.3467788480001, 36.365800910000075],
              [136.38229344500007, 36.39107136800004],
              [136.4301863940001, 36.432521877000056],
              [136.63996143100007, 36.662600574000066],
              [136.68968479300008, 36.73082693100008],
              [136.76055452600008, 36.870599361000075],
              [136.76563379700008, 36.889527893000036],
              [136.76544802900003, 36.91339711100005],
              [136.75823829400008, 36.919312657000035],
              [136.75038571000005, 36.92572910200005],
              [136.7519586190001, 36.93541643100008],
              [136.7609328420001, 36.952397595000036],
              [136.76761331400007, 36.98099874800005],
              [136.759909676, 37.00008710100008],
              [136.7422883710001, 37.01338806100006],
              [136.73155998900006, 37.04764867600005],
              [136.72044825800003, 37.054998330000046],
              [136.71841293800003, 37.076261489000046],
              [136.72673587300005, 37.126613674000055],
              [136.72096084600003, 37.142047501000036],
              [136.70856414900004, 37.14987732700007],
              [136.69842979700002, 37.14759712700004],
              [136.69626613100002, 37.13636152400005],
              [136.67644378300008, 37.13740149600005],
              [136.6702589030001, 37.149957088000065],
              [136.67447257100002, 37.17547192100005],
              [136.6820094100001, 37.19905012400005],
              [136.690423893, 37.21500773200006],
              [136.7055770190001, 37.22825755400004],
              [136.69783547500003, 37.239542596000035],
              [136.7127711610001, 37.25106551400006],
              [136.726145342, 37.26963998000008],
              [136.73321719800003, 37.28501484600008],
              [136.72443485100007, 37.297491111000056],
              [136.72153094200007, 37.32532953900005],
              [136.749094194, 37.357917400000076],
              [136.78376714400008, 37.373892339000065],
              [136.842170667, 37.39953277200004],
              [136.880798507, 37.407986994000055],
              [136.90348352500007, 37.398323368000035],
              [136.934766136, 37.39945701800008],
              [137.04487433600002, 37.447916391000035],
              [137.0715345210001, 37.45300312900008],
              [137.0913386420001, 37.47263502000004],
              [137.11384056300005, 37.487746918000084],
              [137.25549087500008, 37.52459398900004],
              [137.29570988800003, 37.53149016500004],
              [137.3409655590001, 37.51709413800006],
              [137.350873771, 37.50610344200004],
              [137.34369685500008, 37.48666688600008],
              [137.3452992980001, 37.475020106000045],
              [137.35897927200006, 37.46663506600004],
              [137.35613040500004, 37.453192450000074],
              [137.35120513000004, 37.44567560400009],
              [137.3251360810001, 37.43911155300009],
              [137.307833135, 37.439808897000034],
              [137.28725280900005, 37.44297530500006],
              [137.26812894400007, 37.436490424000056],
              [137.2536012390001, 37.42910590200006],
              [137.24598300500008, 37.413555571000074],
              [137.237363609, 37.37988162000005],
              [137.24887841500004, 37.35726027800007],
              [137.267485534, 37.35508577600007],
              [137.26534921200005, 37.33980730300004],
              [137.26254497500008, 37.326049487000034],
              [137.255821383, 37.31526048600006],
              [137.23766775, 37.30170764600007],
              [137.23023522200003, 37.29214101800005],
              [137.20918093, 37.29303190400009],
              [137.16560551600003, 37.30083373900004],
              [137.10872138900004, 37.28344965100007],
              [137.092873123, 37.261365984000065],
              [137.07130008000001, 37.23811173100006],
              [137.070666716, 37.218643978000046],
              [137.05436953700007, 37.21018374600004],
              [137.0328921260001, 37.20466420300005],
              [137.02695161400004, 37.19136096500006],
              [137.0141707690001, 37.184881903000075],
              [136.98023522200003, 37.196478583000044],
              [136.96022288300003, 37.20733866900008],
              [136.945883008, 37.21718561900008],
              [136.956347681, 37.22806693100006],
              [136.959954187, 37.23472002200003],
              [136.9510699550001, 37.23448289400005],
              [136.94180612000002, 37.22472017600006],
              [136.93043053500003, 37.22162506700005],
              [136.92652428500003, 37.21352773600006],
              [136.916567793, 37.198207266000054],
              [136.89259776400002, 37.17332110000007],
              [136.880215453, 37.144152871000074],
              [136.8956676370001, 37.13890407800005],
              [136.89323421900008, 37.117534384000066],
              [136.88775294000004, 37.110318420000056],
              [136.868670501, 37.11091236500005],
              [136.86811660400008, 37.08910758900004],
              [136.86092618400005, 37.07677545000007],
              [136.87468509200005, 37.069647528000075],
              [136.89332116000003, 37.07306549700007],
              [136.91423587300005, 37.08242422100005],
              [136.9336043630001, 37.07982005400004],
              [136.963226759, 37.05174388200004],
              [136.9801259620001, 37.04685964000004],
              [137.003991628, 37.055457543000045],
              [137.02429826600007, 37.09540888600009],
              [137.03868675600006, 37.10282104000004],
              [137.04712975400003, 37.098822333000044],
              [137.05396569100003, 37.07982005400004],
              [137.04884394200008, 37.02292600100009],
              [137.05444619900004, 36.966749864000064],
              [137.02741452300006, 36.93884298800009],
              [137.025040116, 36.91394722700005],
              [136.987741561, 36.87102163700007],
              [137.00554446700005, 36.835923570000034],
              [137.05291460800004, 36.81104398500008],
              [137.0806963020001, 36.79008655300004],
              [137.12802035700008, 36.77683954300005],
              [137.15699303500003, 36.76080963700008],
              [137.1972877510001, 36.758124588000044],
              [137.2414419590001, 36.76506775100006],
              [137.29867296700002, 36.75700875800004],
              [137.33334435900008, 36.762726067000074],
              [137.35053007200008, 36.78230909800004],
              [137.3836057960001, 36.80014545500006],
              [137.39490546800005, 36.82722280400009],
              [137.40835627700005, 36.845203748000074],
              [137.41297129300006, 36.86201101800009],
              [137.41953143800004, 36.87733545700007],
              [137.413764539, 36.89689210800009],
              [137.42710766900007, 36.92201115800009],
              [137.447601759, 36.93353913000004],
              [137.4993469650001, 36.95574161700006],
              [137.5867332050001, 36.969893864000085],
              [137.68327884200005, 36.987982489000046],
              [137.8075446790001, 37.030805238000085],
              [137.89673912900003, 37.057521877000056],
              [137.99937413200007, 37.11105409800007],
              [138.05339603000004, 37.130113023000035],
              [138.07683353000004, 37.149725653000075],
              [138.0975018040001, 37.17105935200004],
              [138.16443255600007, 37.16169930800004],
              [138.2069532590001, 37.16920530200008],
              [138.24489497900004, 37.18378944500006],
              [138.32510269600004, 37.23104347200007],
              [138.437515909, 37.32203684800004],
              [138.55062910200002, 37.37791575700004],
              [138.57797285200002, 37.40289948100008],
              [138.59683020500006, 37.43529360200006],
              [138.62253960700002, 37.47754346900007],
              [138.6597345780001, 37.52443260400008],
              [138.71827233200008, 37.56484609600005],
              [138.7465926440001, 37.596869208000044],
              [138.7656356130001, 37.63467031500005],
              [138.8094257350001, 37.76077187900006],
              [138.82702387000006, 37.79728696600006],
              [138.85767662900003, 37.827826239000046],
              [138.93039446900002, 37.874923177000085],
              [139.05988081300006, 37.94594167000008],
              [139.068193436, 37.95509385200006],
              [139.09133915000007, 37.954658308000035],
              [139.13246598800004, 37.958828931000085],
              [139.21594314100003, 37.98993395400004],
              [139.2390621950001, 38.003154582000036],
              [139.30453535200002, 38.04193756700005],
              [139.40805097700002, 38.13190338700008],
              [139.425140821, 38.151271877000056],
              [139.43238366000003, 38.169134833000044],
              [139.46216881600003, 38.374986070000034],
              [139.47282962300005, 38.41250234600005],
              [139.4926863940001, 38.45416901200008],
              [139.52995853000004, 38.50800202000005],
              [139.5800887380001, 38.60687897300005],
              [139.5992151490001, 38.648254087000055],
              [139.62705899900004, 38.68121429300004],
              [139.716156446, 38.74567291900007],
              [139.747406446, 38.778957424000055],
              [139.77384433300006, 38.817116774000056],
              [139.81527369900004, 38.94106263500004],
              [139.8575639610001, 39.03228377100004],
              [139.8673056450001, 39.06222210900006],
              [139.8740340500001, 39.09845612200007],
              [139.88062584700003, 39.11473216400009],
              [139.891937696, 39.13320547100005],
              [139.895843946, 39.15228913000004],
              [139.89795983200008, 39.19330475500004],
              [139.90358143900005, 39.22493941100004],
              [139.91684255200005, 39.26249903000007],
              [139.93181044000005, 39.287111834000086],
              [139.9635796240001, 39.29882013200006],
              [139.99531019000005, 39.32732856000007],
              [140.02024245400003, 39.40758142300007],
              [140.04857715000003, 39.50466964600008],
              [140.05933387900006, 39.69806625600006],
              [140.05929588100003, 39.72749224900008],
              [140.03911708700002, 39.76928182100005],
              [140.03908976800005, 39.79328263100007],
              [140.02759850400003, 39.82453034100007],
              [140.00456790500004, 39.850897528000075],
              [139.96648196700005, 39.880072333000044],
              [139.92139733200008, 39.898504950000074],
              [139.8774520190001, 39.89280833500004],
              [139.8642684250001, 39.88222890800006],
              [139.854828321, 39.87083567900004],
              [139.8437606130001, 39.861761786000045],
              [139.825531446, 39.85805898600006],
              [139.760101759, 39.85805898600006],
              [139.75180097700002, 39.86627838700008],
              [139.73812910200002, 39.891913153000075],
              [139.73015384200005, 39.90273672100005],
              [139.70866946700005, 39.924261786000045],
              [139.704172093, 39.945157201000086],
              [139.71943758300006, 39.952141356000084],
              [139.70099004100007, 39.96066114800004],
              [139.69773066900007, 39.98856648200007],
              [139.700639313, 40.00563611200005],
              [139.7434519960001, 39.982463933000076],
              [139.80046634200005, 39.962591864000046],
              [139.82211347700002, 39.96108633000006],
              [139.86692463200006, 39.98429728600007],
              [139.90419316100008, 40.01769512100009],
              [139.97803795700008, 40.12547435100004],
              [139.993500196, 40.169623114000046],
              [139.98861094900008, 40.191113804000054],
              [140.002841718, 40.22243970300008],
              [140.01115209900001, 40.23545842000004],
              [140.01989872700005, 40.33321038300005],
              [140.0242629610001, 40.355016067000065],
              [140.01173376100007, 40.36785890800007],
              [139.99857651000002, 40.37715986500007],
              [139.9634554810001, 40.40392272000008],
              [139.94605553500003, 40.418850002000056],
              [139.94263756600003, 40.43439362200007],
              [139.945648634, 40.47809479400007],
              [139.94353274800005, 40.52142975500004],
              [139.94278633300007, 40.54458555800005],
              [139.930978309, 40.55443808700005],
              [139.92850275500007, 40.57097044500006],
              [139.91515451300006, 40.58617340700005],
              [139.87639612100008, 40.58343784600004],
              [139.856781446, 40.59015534100007],
              [139.8603621750001, 40.60879140800006],
              [139.88038466, 40.625232554000036],
              [139.90029743700006, 40.64247505800006],
              [139.925841999, 40.646821001000035],
              [139.938624076, 40.66984990800006],
              [139.95954043000006, 40.67769251500005],
              [139.9701370900001, 40.693649883000035],
              [139.9868773930001, 40.71789968300004],
              [139.99815616500007, 40.742104090000055],
              [140.04597727600003, 40.76777008700009],
              [140.06931012100006, 40.76558251200004],
              [140.09513809700002, 40.74927419200009],
              [140.1076180130001, 40.74407301800005],
              [140.1223587180001, 40.74476553400007],
              [140.14013941000007, 40.74957629000005],
              [140.1547744620001, 40.761448243000075],
              [140.1980380870001, 40.78645254300005],
              [140.21908790400005, 40.77833468000006],
              [140.240570509, 40.78351471600007],
              [140.25806725400003, 40.79564036700009],
              [140.27076256600003, 40.81240469000005],
              [140.29664147200003, 40.87376536700003],
              [140.30925540500004, 40.93622467700004],
              [140.31625410200002, 40.954413153000075],
              [140.31511478000004, 40.978501695000034],
              [140.319238175, 40.99972153500005],
              [140.3219215580001, 41.02744519700008],
              [140.324833894, 41.027461359000085],
              [140.34099368600005, 41.005072333000044],
              [140.3498260240001, 40.99825666700008],
              [140.36228565300007, 40.99287923600008],
              [140.36959444000001, 40.98605469100005],
              [140.38233483200008, 40.988267320000034],
              [140.37587989300005, 41.01236805000008],
              [140.36962853800003, 41.021661632000075],
              [140.3768607410001, 41.028008653000086],
              [140.38558219700008, 41.02942508400008],
              [140.39651086100002, 41.02701276800008],
              [140.40779258300006, 41.02569846100005],
              [140.40446189300008, 41.03418132000007],
              [140.39898677500003, 41.03937203000004],
              [140.37897206000002, 41.038166566000086],
              [140.3680536810001, 41.03838470300008],
              [140.35058592000007, 41.03884449200007],
              [140.34435617100007, 41.04402182000007],
              [140.34066533100008, 41.05003493300006],
              [140.3337851330001, 41.045611403000066],
              [140.3269048200001, 41.04118680800008],
              [140.32395648300007, 41.04528458400006],
              [140.32264494100002, 41.070507828000075],
              [140.32185208300007, 41.08292085900007],
              [140.3001619810001, 41.11127729200007],
              [140.281795428, 41.11920156000008],
              [140.26472982300004, 41.12099656200007],
              [140.24809544900006, 41.12336100200008],
              [140.245477048, 41.133873846000085],
              [140.25618438200001, 41.13889667800004],
              [140.28150475400003, 41.14036692900004],
              [140.303971091, 41.13668050100006],
              [140.32043302, 41.14977976200004],
              [140.3293670490001, 41.17211254600005],
              [140.33277428500003, 41.19131094000005],
              [140.32837975400003, 41.20132070500006],
              [140.3300887380001, 41.21185944200005],
              [140.33277902700002, 41.237153409000086],
              [140.34100620700008, 41.24646276100009],
              [140.338220868, 41.25889596300004],
              [140.34228304300007, 41.26573129800005],
              [140.35914755300007, 41.25394959800008],
              [140.379063953, 41.24411441700005],
              [140.391481214, 41.24044348400008],
              [140.40943444100003, 41.224676825000074],
              [140.43580162900003, 41.198146877000056],
              [140.46224804000008, 41.18388740700004],
              [140.48367398100004, 41.18346812600004],
              [140.51106755500007, 41.19771902400004],
              [140.52475613000001, 41.21997640700005],
              [140.54859759400006, 41.226242993000085],
              [140.59390699100004, 41.22017794000004],
              [140.63270238300004, 41.194257795000055],
              [140.64266573200007, 41.17137914700004],
              [140.63701139400007, 41.14474739600007],
              [140.63461347700002, 41.11546458500004],
              [140.63103274800005, 41.10565827000005],
              [140.63152103000004, 41.093085028000075],
              [140.63697350400003, 41.071926174000055],
              [140.64128665500004, 41.04148997600004],
              [140.65455162900003, 41.00849030200004],
              [140.67302493600005, 40.89557526200008],
              [140.7031216700001, 40.85329202300005],
              [140.752402511, 40.835186570000076],
              [140.79922346800004, 40.83908125100004],
              [140.8307489350001, 40.86683804200004],
              [140.85206829100002, 40.883848724000075],
              [140.8707263990001, 40.915135476000046],
              [140.86570872100003, 40.92226795400006],
              [140.86293283500004, 40.933564121000074],
              [140.86688513900003, 40.940992390000076],
              [140.87083680400008, 40.94485248400008],
              [140.86280763700006, 40.94726942200003],
              [140.85360123300006, 40.94491889100004],
              [140.8472456400001, 40.94760752700006],
              [140.84051994900005, 40.952971527000045],
              [140.84921628000006, 40.95624868800007],
              [140.861488388, 40.95713361300005],
              [140.85948816000007, 40.96518480100008],
              [140.8610516550001, 40.97204276600007],
              [140.87096258300005, 40.97797815000007],
              [140.86853472400003, 40.98426696100006],
              [140.87210169800005, 40.989024474000075],
              [140.88233210700002, 41.007822022000084],
              [140.88867495600005, 41.01077779500008],
              [140.902885406, 41.008995810000044],
              [140.914405859, 40.99609776500006],
              [140.93883612500008, 40.99434078100006],
              [140.94870251300006, 40.99074773500007],
              [140.957775072, 40.977915228000086],
              [140.96643156800008, 40.969601573000034],
              [140.98140227400006, 40.959768599000085],
              [140.98178952400008, 40.95381221000008],
              [140.97981597600005, 40.95173234200007],
              [140.9794214110001, 40.95143509800005],
              [140.97665426700007, 40.94608651000004],
              [140.97506573300006, 40.937755320000065],
              [140.97979578000002, 40.935663849000036],
              [140.99097741000003, 40.93431224200003],
              [141.01099694100003, 40.92951080900008],
              [141.0349361760001, 40.91833765900009],
              [141.04715557500003, 40.914749897000036],
              [141.05822181400004, 40.916522572000076],
              [141.06807564200005, 40.91084813100008],
              [141.073919208, 40.90012069800008],
              [141.083704774, 40.886413220000065],
              [141.09276681100005, 40.88163138300007],
              [141.11134557100002, 40.87263328600005],
              [141.12626868300003, 40.87291908200007],
              [141.1471450140001, 40.87883994300006],
              [141.16377570600002, 40.891308077000076],
              [141.18524863300001, 40.91121452900006],
              [141.22640007400003, 40.987442920000035],
              [141.23640716500006, 41.01572156100008],
              [141.24190264900005, 41.082742],
              [141.24789472700002, 41.09813060100004],
              [141.246366158, 41.106862387000035],
              [141.25234706100002, 41.11875852600008],
              [141.263463214, 41.12617311400004],
              [141.27223835200004, 41.13657760500007],
              [141.277882083, 41.155329909000045],
              [141.2704802500001, 41.18520388400009],
              [141.25610124900004, 41.211236661000044],
              [141.235466901, 41.23797276500005],
              [141.20591119200003, 41.26471970400007],
              [141.18337455300002, 41.27706277200008],
              [141.1612324580001, 41.27846726200005],
              [141.15246083700004, 41.26398044500007],
              [141.14597765300005, 41.25550840300008],
              [141.1369634360001, 41.246697177000044],
              [141.137639411, 41.24271426100006],
              [141.14385385900005, 41.24166270200004],
              [141.14963557400006, 41.24874840400008],
              [141.15611297200007, 41.25479616600006],
              [141.15911483900004, 41.25669431400007],
              [141.158871181, 41.25323173800007],
              [141.1570088420001, 41.24821429700006],
              [141.14683011300008, 41.236288570000056],
              [141.11337199500008, 41.21436328300007],
              [141.09473672700005, 41.210264513000084],
              [141.0723764600001, 41.19661705300007],
              [141.05807571800005, 41.183068125000034],
              [141.03413513500004, 41.185861325000076],
              [141.00563260700005, 41.19576286500006],
              [140.9920538990001, 41.19335164900008],
              [140.977561863, 41.19647781500004],
              [140.963067583, 41.18990252900005],
              [140.946265175, 41.17328947700008],
              [140.907788697, 41.17364541400008],
              [140.89078478800002, 41.16377995100004],
              [140.875356022, 41.166549296000085],
              [140.86273009800004, 41.16412311100004],
              [140.82850222700006, 41.14610662600006],
              [140.81452501500007, 41.128461806000075],
              [140.79815518300006, 41.128577901000085],
              [140.76579604300002, 41.14501873900008],
              [140.76530067700003, 41.184626508000065],
              [140.76555366700006, 41.19595586000008],
              [140.778168165, 41.20685455900008],
              [140.78469859000006, 41.23514784300005],
              [140.780395753, 41.25193437900003],
              [140.79309271300008, 41.27842175200004],
              [140.79928382000003, 41.30300457000004],
              [140.80321422500003, 41.32118674800006],
              [140.8031479340001, 41.32954397600008],
              [140.815172877, 41.33756239600007],
              [140.8236313660001, 41.364709589000086],
              [140.827308991, 41.38755930000008],
              [140.83695137100005, 41.41822188600008],
              [140.85333808400003, 41.430339450000076],
              [140.88382800500005, 41.46740993900005],
              [140.89795983200008, 41.47614166900007],
              [140.90105228000004, 41.48102448100008],
              [140.90710228800003, 41.50079851500004],
              [140.9057158930001, 41.51308858200008],
              [140.89946179000003, 41.52417520800009],
              [140.90362850500003, 41.52815413900004],
              [140.90709272100003, 41.53854826300005],
              [140.913572359, 41.54685719300005],
              [140.92699769800004, 41.533324933000074],
              [140.9508002450001, 41.521911388000035],
              [140.96441713000002, 41.509076536000066],
              [140.97805707600003, 41.49765904100008],
              [140.9930157440001, 41.491067669000074],
              [141.00333950800007, 41.48708488900007],
              [141.02126455500002, 41.484118126000055],
              [141.06530723900005, 41.48111619600007],
              [141.10775040700003, 41.46386893600004],
              [141.14290933000007, 41.43322531400008],
              [141.1596639490001, 41.41712322800004],
              [141.17995380600007, 41.40562133200007],
              [141.18402107200006, 41.39741473700008],
              [141.19499759200005, 41.387152411000045],
              [141.23566610900002, 41.367585477000034],
              [141.276095682, 41.35319552800007],
              [141.31791884200004, 41.35304670600004],
              [141.34881101400003, 41.360219794000045],
              [141.38216087800004, 41.37259958300007],
              [141.41035306700007, 41.390388346000066],
              [141.4313316260001, 41.406088314000044],
              [141.44819724900003, 41.41840423500008],
              [141.46057858100005, 41.43022317800006],
              [141.463865746, 41.42602266500006],
              [141.46692099400002, 41.419327886000076],
              [141.4604310750001, 41.41335629300005],
              [141.46344160600006, 41.40381685400007],
              [141.461849335, 41.40048371600005],
              [141.45381379800006, 41.39635130100004],
              [141.45559512800003, 41.39196423800007],
              [141.45988422000005, 41.387962927000046],
              [141.4574654930001, 41.37747296200007],
              [141.44528424100008, 41.36618409700009],
              [141.43988362800008, 41.35117566100007],
              [141.43191811600002, 41.33002057500005],
              [141.42379443000004, 41.312706921000085],
              [141.40891673300007, 41.256677393000075],
              [141.40428358000008, 41.23065244500009],
              [141.40376745800006, 41.22063293800005],
              [141.39081676700005, 41.16101119700005],
              [141.39460702200006, 41.138200175000065],
              [141.39828535200002, 41.128119208000044],
              [141.39446549800005, 41.11646771900007],
              [141.3947298390001, 41.102885066000056],
              [141.396359255, 41.09173074200004],
              [141.38630694100004, 41.03036180100008],
              [141.38806285300006, 40.977231939000035],
              [141.39026167600002, 40.93393259100009],
              [141.39304294500005, 40.921750444000054],
              [141.4055534050001, 40.816822863000084],
              [141.4231560400001, 40.72577228600005],
              [141.43738666000002, 40.67014093100005],
              [141.470398091, 40.59341807100009],
              [141.48241247400006, 40.574069069000075],
              [141.491639652, 40.562326700000085],
              [141.5196960080001, 40.537986372000034],
              [141.532504271, 40.531397895000055],
              [141.54821362400003, 40.531595226000036],
              [141.55939515900002, 40.53939933200007],
              [141.57554958600008, 40.542279059000066],
              [141.58210069000006, 40.53279883700009],
              [141.58926137100002, 40.52210463500006],
              [141.62370853000004, 40.50136953300006],
              [141.681000196, 40.45099518400008],
              [141.69092858200008, 40.442287502000056],
              [141.719140981, 40.41283517800008],
              [141.72608451300005, 40.393792775000065],
              [141.74377693500003, 40.38392223200009],
              [141.753573888, 40.36949056000009],
              [141.75855553500003, 40.35895416900007],
              [141.772797071, 40.33392975500004],
              [141.77556399800005, 40.32758209800005],
              [141.77849368600005, 40.31549713700008],
              [141.7856551440001, 40.30687083500004],
              [141.80347741000003, 40.29002513200004],
              [141.830414259, 40.251166083000044],
              [141.84197024800005, 40.225775458000044],
              [141.83423912900003, 40.21434153900009],
              [141.82447350400003, 40.211004950000074],
              [141.81519616000003, 40.20286692900004],
              [141.81023196700005, 40.19277578300006],
              [141.813324415, 40.183579820000034],
              [141.82593834700003, 40.17568594000005],
              [141.85279381600003, 40.167222398000035],
              [141.86500084700003, 40.15973541900007],
              [141.87720787900003, 40.13930898600006],
              [141.86589603000004, 40.12726471600007],
              [141.84742272200003, 40.11513906500005],
              [141.83757571700005, 40.09454987200007],
              [141.84245853000004, 40.070379950000074],
              [141.85499108200008, 40.05499909100007],
              [141.91960696700005, 40.00885651200008],
              [141.93034915500004, 40.00409577000005],
              [141.94117272200003, 40.00145091400009],
              [141.949554884, 39.99656810100004],
              [141.95533287900003, 39.97492096600007],
              [141.95964603000004, 39.96430084800005],
              [141.9614363940001, 39.95368073100008],
              [141.95679772200003, 39.94375234600005],
              [141.94507897200003, 39.931301174000055],
              [141.942230665, 39.92450592700004],
              [141.95297285200002, 39.90643952000005],
              [141.95923912900003, 39.89838288000004],
              [141.96607506600003, 39.89175039300005],
              [141.97185306100005, 39.88300202000005],
              [141.97543379, 39.85219961100006],
              [141.97868899800005, 39.83930084800005],
              [142.002289259, 39.77757396000004],
              [142.0048934250001, 39.772691148000035],
              [142.0039168630001, 39.76740143400008],
              [142.0068465500001, 39.76044342700004],
              [142.0087996750001, 39.75275299700007],
              [142.0048934250001, 39.74506256700005],
              [141.99390709700003, 39.73529694200005],
              [141.9912215500001, 39.730454820000034],
              [141.98389733200008, 39.70697663000004],
              [141.9809676440001, 39.662543036000045],
              [141.97828209700003, 39.64785390800006],
              [141.9648543630001, 39.62571849200009],
              [141.96045983200008, 39.61163971600007],
              [141.96631920700008, 39.59845612200007],
              [142.01246178500003, 39.63580963700008],
              [142.0361434250001, 39.63898346600007],
              [142.03101647200003, 39.62962474200009],
              [142.02898196700005, 39.62299225500004],
              [142.03077233200008, 39.61749909100007],
              [142.0361434250001, 39.61163971600007],
              [142.0273543630001, 39.59471263200004],
              [142.03077233200008, 39.58417389500005],
              [142.0590926440001, 39.56289297100005],
              [142.06413821700005, 39.559881903000075],
              [142.06812584700003, 39.55638255400004],
              [142.0703231130001, 39.55019765800006],
              [142.0693465500001, 39.54047272300005],
              [142.06470787900003, 39.536444403000075],
              [142.05933678500003, 39.533270575000074],
              [142.0566512380001, 39.52602773600006],
              [142.05030358200008, 39.522691148000035],
              [142.01514733200008, 39.488714911000045],
              [141.99927819100003, 39.48102448100008],
              [141.96631920700008, 39.47134023600006],
              [141.95297285200002, 39.46076080900008],
              [141.97087649800005, 39.44326406500005],
              [141.99626712300005, 39.44525788000004],
              [142.018890821, 39.45937734600005],
              [142.02881920700008, 39.47793203300006],
              [142.03638756600003, 39.48379140800006],
              [142.05062910200002, 39.476996161000045],
              [142.05844160200002, 39.46629466400009],
              [142.04615319100003, 39.46076080900008],
              [142.039886915, 39.45457591400009],
              [142.03834069100003, 39.44025299700007],
              [142.0380965500001, 39.42401764500005],
              [142.031586134, 39.417303778000075],
              [142.01059004, 39.415716864000046],
              [142.00114993600005, 39.41364166900007],
              [141.99170983200008, 39.41437409100007],
              [141.9809676440001, 39.41242096600007],
              [141.9716903000001, 39.40696849200009],
              [141.9502059250001, 39.39154694200005],
              [141.93873131600003, 39.38507721600007],
              [141.96412194100003, 39.37555573100008],
              [141.95337975400003, 39.36200592700004],
              [141.92693118600005, 39.34642161700009],
              [141.9052840500001, 39.33047109600005],
              [141.92465254, 39.32489655200004],
              [141.94678795700008, 39.33038971600007],
              [141.967133009, 39.34096914300005],
              [141.9809676440001, 39.35097890800006],
              [141.98365319100003, 39.32713450700004],
              [141.96371504, 39.312567450000074],
              [141.914886915, 39.29486725500004],
              [141.9228621750001, 39.29047272300005],
              [141.92888431100005, 39.28388092700004],
              [141.9326278000001, 39.27521393400008],
              [141.9243270190001, 39.275824286000045],
              [141.9072371750001, 39.27456289300005],
              [141.89909915500004, 39.27521393400008],
              [141.89820397200003, 39.26211172100005],
              [141.89909915500004, 39.24852122600004],
              [141.93148847700002, 39.247707424000055],
              [141.94703209700003, 39.249701239000046],
              [141.94678795700008, 39.24852122600004],
              [141.9492293630001, 39.22801341400009],
              [141.930023634, 39.212225653000075],
              [141.90211022200003, 39.204331773000035],
              [141.87867272200003, 39.20758698100008],
              [141.88168379, 39.19245026200008],
              [141.89372806100005, 39.186753648000035],
              [141.9262801440001, 39.18707916900007],
              [141.91578209700003, 39.169989325000074],
              [141.89519290500004, 39.159369208000044],
              [141.869476759, 39.153957424000055],
              [141.8437606130001, 39.152329820000034],
              [141.86109459700003, 39.13841380400004],
              [141.90886478000004, 39.10976797100005],
              [141.91334069100003, 39.097723700000074],
              [141.89047285200002, 39.089544989000046],
              [141.83545983200008, 39.10431549700007],
              [141.81714928500003, 39.09088776200008],
              [141.859711134, 39.07330963700008],
              [141.87183678500003, 39.062933661000045],
              [141.86052493600005, 39.05923086100006],
              [141.848480665, 39.05703359600005],
              [141.83611087300005, 39.05621979400007],
              [141.8232528000001, 39.056708075000074],
              [141.8232528000001, 39.049261786000045],
              [141.8339949880001, 39.04441966400009],
              [141.8481551440001, 39.03510163000004],
              [141.85572350400003, 39.02606842700004],
              [141.84742272200003, 39.02195872600004],
              [141.80648847700002, 39.02948639500005],
              [141.76636803500003, 39.02484772300005],
              [141.74561608200008, 39.02619049700007],
              [141.72771243600005, 39.03628164300005],
              [141.72820071700005, 39.02171458500004],
              [141.73365319100003, 39.010199286000045],
              [141.74146569100003, 38.99949778900009],
              [141.74822024800005, 38.98786041900007],
              [141.736664259, 38.98932526200008],
              [141.7270613940001, 38.987616278000075],
              [141.7133895190001, 38.97418854400007],
              [141.72828209700003, 38.969916083000044],
              [141.73389733200008, 38.96051666900007],
              [141.73023522200003, 38.951157945000034],
              [141.717133009, 38.94684479400007],
              [141.7041121750001, 38.95058828300006],
              [141.69092858200008, 38.95962148600006],
              [141.680023634, 38.970770575000074],
              [141.67310631600003, 38.98102448100008],
              [141.68620853000004, 38.98590729400007],
              [141.69361412900003, 38.995306708000044],
              [141.65105228000004, 38.99681224200009],
              [141.63835696700005, 38.98541901200008],
              [141.6405542330001, 38.96519603100006],
              [141.64527428500003, 38.92300039300005],
              [141.668793165, 38.87262604400007],
              [141.67359459700003, 38.85195547100005],
              [141.65211022200003, 38.86432526200008],
              [141.649261915, 38.86908600500004],
              [141.64568118600005, 38.88263580900008],
              [141.64210045700008, 38.88849518400008],
              [141.6367293630001, 38.89109935100004],
              [141.63152103000004, 38.88971588700008],
              [141.62525475400003, 38.88690827000005],
              [141.61784915500004, 38.88544342700004],
              [141.5986434250001, 38.885199286000045],
              [141.58855228000004, 38.88222890800006],
              [141.5844832690001, 38.873114325000074],
              [141.58375084700003, 38.85443756700005],
              [141.58619225400003, 38.83510976800005],
              [141.58936608200008, 38.82607656500005],
              [141.58708743600005, 38.819240627000056],
              [141.5732528000001, 38.80658600500004],
              [141.53052819100003, 38.78082916900007],
              [141.52165774800005, 38.76813385600008],
              [141.53199303500003, 38.763332424000055],
              [141.53882897200003, 38.75625234600005],
              [141.54908287900003, 38.74079010600008],
              [141.56706790500004, 38.72882721600007],
              [141.572601759, 38.71865469000005],
              [141.5664168630001, 38.703558661000045],
              [141.55974368600005, 38.69953034100007],
              [141.55445397200003, 38.70258209800005],
              [141.54908287900003, 38.707017320000034],
              [141.54281660200002, 38.70726146000004],
              [141.53785241000003, 38.70408763200004],
              [141.5254012380001, 38.68992747600004],
              [141.51587975400003, 38.68427155200004],
              [141.49105879, 38.67755768400008],
              [141.48072350400003, 38.67255280200004],
              [141.46306399800005, 38.661363023000035],
              [141.46314537900003, 38.655462958000044],
              [141.47388756600003, 38.64520905200004],
              [141.485199415, 38.64085521000004],
              [141.5322371750001, 38.63841380400004],
              [141.5351668630001, 38.632025458000044],
              [141.52808678500003, 38.61790599200009],
              [141.51775149800005, 38.60382721600007],
              [141.51140384200005, 38.59739817900004],
              [141.46705162900003, 38.569525458000044],
              [141.48308353000004, 38.55731842700004],
              [141.4990340500001, 38.54165273600006],
              [141.5146590500001, 38.534816799000055],
              [141.52914472700002, 38.54901764500005],
              [141.54224694100003, 38.53343333500004],
              [141.54761803500003, 38.51862213700008],
              [141.54712975400003, 38.50214264500005],
              [141.54281660200002, 38.48139069200005],
              [141.5317488940001, 38.484076239000046],
              [141.52418053500003, 38.48969147300005],
              [141.51872806100005, 38.49795156500005],
              [141.51482181100005, 38.50804271000004],
              [141.50066165500004, 38.47044505400004],
              [141.49496504, 38.46088288000004],
              [141.50074303500003, 38.457912502000056],
              [141.503265821, 38.45465729400007],
              [141.5048934250001, 38.45099518400008],
              [141.50798587300005, 38.446600653000075],
              [141.4829207690001, 38.440619208000044],
              [141.47144616000003, 38.43573639500005],
              [141.47046959700003, 38.42951080900008],
              [141.47722415500004, 38.41844310100004],
              [141.47681725400003, 38.40973541900007],
              [141.4775496750001, 38.401556708000044],
              [141.48755944100003, 38.39203522300005],
              [141.4990340500001, 38.399603583000044],
              [141.51840254, 38.402329820000034],
              [141.5376082690001, 38.39817942900004],
              [141.54908287900003, 38.38515859600005],
              [141.5341903000001, 38.389837958000044],
              [141.520355665, 38.39052969000005],
              [141.50904381600003, 38.38515859600005],
              [141.50123131600003, 38.371527411000045],
              [141.52523847700002, 38.35993073100008],
              [141.5293074880001, 38.339544989000046],
              [141.5297957690001, 38.31793854400007],
              [141.54281660200002, 38.30263906500005],
              [141.53736412900003, 38.29507070500006],
              [141.5254012380001, 38.26780833500004],
              [141.5185653000001, 38.27045319200005],
              [141.4912215500001, 38.29238515800006],
              [141.48462975400003, 38.29559967700004],
              [141.46998131600003, 38.296087958000044],
              [141.4633895190001, 38.29922109600005],
              [141.4599715500001, 38.306341864000046],
              [141.4633895190001, 38.31240469000005],
              [141.46753991000003, 38.31781647300005],
              [141.46705162900003, 38.32306549700007],
              [141.45777428500003, 38.33087799700007],
              [141.42554772200003, 38.34357330900008],
              [141.43083743600005, 38.35024648600006],
              [141.43970787900003, 38.371527411000045],
              [141.428070509, 38.38043854400007],
              [141.41944420700008, 38.38068268400008],
              [141.410492384, 38.37791575700004],
              [141.39812259200005, 38.37767161700009],
              [141.38624108200008, 38.380845445000034],
              [141.37614993600005, 38.38544342700004],
              [141.35377037900003, 38.40224844000005],
              [141.33318118600005, 38.40900299700007],
              [141.30445397200003, 38.407904364000046],
              [141.2295028000001, 38.39411041900007],
              [141.20240319100003, 38.38580963700008],
              [141.18091881600003, 38.371161200000074],
              [141.17212975400003, 38.347316799000055],
              [141.17497806100005, 38.32436758000006],
              [141.16968834700003, 38.32282135600008],
              [141.15211022200003, 38.32306549700007],
              [141.14771569100003, 38.32949453300006],
              [141.1318465500001, 38.371527411000045],
              [141.12322024800005, 38.366522528000075],
              [141.114593946, 38.36465078300006],
              [141.1059676440001, 38.36615631700005],
              [141.09782962300005, 38.371527411000045],
              [141.079437696, 38.36090729400007],
              [141.06470787900003, 38.34662506700005],
              [141.05420983200008, 38.32916901200008],
              [141.04867597700002, 38.309475002000056],
              [141.05836022200003, 38.313706773000035],
              [141.06959069100003, 38.314886786000045],
              [141.0791121750001, 38.31159088700008],
              [141.08350670700008, 38.30263906500005],
              [141.0805770190001, 38.294907945000034],
              [141.07252037900003, 38.28953685100004],
              [141.06226647200003, 38.28473541900007],
              [141.0527449880001, 38.27871328300006],
              [141.01734459700003, 38.24485911700009],
              [140.98796634200005, 38.207017320000034],
              [140.9668074880001, 38.17047760600008],
              [140.9257918630001, 38.04938385600008],
              [140.91863040500004, 38.00722890800006],
              [140.91976972700002, 37.96515534100007],
              [140.9326278000001, 37.89175039300005],
              [140.93336022200003, 37.88922760600008],
              [140.95926646200007, 37.849958763000075],
              [140.99325908700007, 37.79983832100004],
              [141.00459510300004, 37.76440553700007],
              [141.008148634, 37.75018952000005],
              [141.01742597700002, 37.73997630400004],
              [141.02222741000003, 37.72695547100005],
              [141.0219832690001, 37.706732489000046],
              [141.01905358200008, 37.69863515800006],
              [141.00928795700008, 37.685248114000046],
              [141.0078231130001, 37.67885976800005],
              [141.01140384200005, 37.67226797100005],
              [141.02515709700003, 37.65794505400004],
              [141.028168165, 37.648098049000055],
              [141.04184004, 37.37714264500005],
              [141.0361434250001, 37.34471263200004],
              [141.01441491000003, 37.271470445000034],
              [141.01449629, 37.23997630400004],
              [141.0078231130001, 37.22675202000005],
              [141.0078231130001, 37.13385651200008],
              [141.00513756600003, 37.12287018400008],
              [140.98796634200005, 37.08978913000004],
              [140.97437584700003, 37.00177643400008],
              [140.960297071, 36.96621328300006],
              [140.9257918630001, 36.93891022300005],
              [140.91724694100003, 36.93646881700005],
              [140.89177493600005, 36.93211497600004],
              [140.85906009200005, 36.91400788000004],
              [140.83521569100003, 36.90843333500004],
              [140.8203231130001, 36.89435455900008],
              [140.81226647200003, 36.89118073100008],
              [140.80437259200005, 36.885972398000035],
              [140.80193118600005, 36.87457916900007],
              [140.80225670700008, 36.85700104400007],
              [140.7972925140001, 36.84650299700007],
              [140.79314212300005, 36.837551174000055],
              [140.75171959700003, 36.78506094000005],
              [140.74187259200005, 36.768459377000056],
              [140.6938582690001, 36.61798737200007],
              [140.63892662900003, 36.53974030200004],
              [140.6235457690001, 36.50608958500004],
              [140.61011803500003, 36.43390534100007],
              [140.61052493600005, 36.41815827000005],
              [140.6235457690001, 36.37962474200009],
              [140.62476647200003, 36.36359284100007],
              [140.61687259200005, 36.33779531500005],
              [140.57938199800003, 36.30475890300005],
              [140.5641073710001, 36.28309580200005],
              [140.56643664500007, 36.24583748900005],
              [140.57837975400003, 36.16095612200007],
              [140.6099023050001, 36.095056760000034],
              [140.646034105, 36.013320444000044],
              [140.78931725400003, 35.808661200000074],
              [140.83082116000003, 35.761053778000075],
              [140.84164472700002, 35.74241771000004],
              [140.8525496750001, 35.737534898000035],
              [140.85946699300007, 35.73537832200009],
              [140.86500084700003, 35.733628648000035],
              [140.87427819100003, 35.72923411700009],
              [140.8794051440001, 35.72052643400008],
              [140.86876177700003, 35.69675396200006],
              [140.8606646720001, 35.68779101800004],
              [140.84685306100005, 35.69525788000004],
              [140.84021114000006, 35.704379042000085],
              [140.82830145700007, 35.71396943700006],
              [140.80314419800004, 35.70937139000006],
              [140.770890109, 35.69705142200007],
              [140.72078890300008, 35.68251721100006],
              [140.716260551, 35.69879072800006],
              [140.6610564560001, 35.68863497800004],
              [140.5961624470001, 35.65207529800006],
              [140.4834674970001, 35.56599105500004],
              [140.42321951300005, 35.49064438000005],
              [140.38591856900007, 35.380998573000056],
              [140.40503991000003, 35.32892487200007],
              [140.4130965500001, 35.301214911000045],
              [140.40408370800003, 35.25950925500007],
              [140.39883763, 35.22209519200004],
              [140.39419527500002, 35.19659166200006],
              [140.377629651, 35.17635690900005],
              [140.3489351930001, 35.18051589700008],
              [140.33047969900008, 35.15778336400007],
              [140.33353722800007, 35.14234798800004],
              [140.32121361200007, 35.13039407800005],
              [140.303349485, 35.133402885000066],
              [140.29436841200004, 35.14663912100008],
              [140.27891015, 35.13198816600004],
              [140.2533254880001, 35.134623945000044],
              [140.23738075200004, 35.11242952500004],
              [140.20006695100005, 35.11498426400004],
              [140.15551320300006, 35.118075357000066],
              [140.134602814, 35.12264536400005],
              [140.10595281100007, 35.097603003000074],
              [140.10080523400006, 35.07575134500007],
              [140.075487834, 35.05926940100005],
              [140.05553662300008, 35.058868491000055],
              [140.0211555850001, 35.03842885800009],
              [139.99096763300008, 35.02050211200009],
              [139.98057300900007, 35.00751446600009],
              [139.97486950200005, 34.99019749100006],
              [139.9640643580001, 34.975959644000056],
              [139.964648033, 34.95928462900008],
              [139.9621388810001, 34.940850503000036],
              [139.95238826500008, 34.92797425400005],
              [139.94303968000008, 34.91864977200004],
              [139.9263958460001, 34.90735665200009],
              [139.90079996000009, 34.903012715000045],
              [139.88293893700006, 34.90130532100005],
              [139.87064389700004, 34.904726639000046],
              [139.855791469, 34.90243585200005],
              [139.843099617, 34.89998186000008],
              [139.83814537900003, 34.90468984600005],
              [139.821984262, 34.91210983000008],
              [139.824964603, 34.921371227000066],
              [139.82318224300002, 34.934921744000064],
              [139.81083100900003, 34.94353955300005],
              [139.77881155300008, 34.95413884000004],
              [139.756993555, 34.956283674000076],
              [139.75243898200006, 34.964737814000046],
              [139.75277736500004, 34.97580871200006],
              [139.76530374200001, 34.97649999100008],
              [139.783621895, 34.97425062900004],
              [139.794453804, 34.97344853800007],
              [139.8085128670001, 34.97616585700007],
              [139.82044658100006, 34.98136827700006],
              [139.8271049220001, 34.99019351800007],
              [139.84030331500003, 34.991003171000045],
              [139.85865319100003, 34.98680247600004],
              [139.86548912900003, 34.99054596600007],
              [139.86996504, 34.999335028000075],
              [139.8676863940001, 35.013332424000055],
              [139.8559676440001, 35.020819403000075],
              [139.83578535200002, 35.02724844000005],
              [139.83464603000004, 35.03742096600007],
              [139.8462020190001, 35.04682038000004],
              [139.8496199880001, 35.05801015800006],
              [139.84742272200003, 35.06932200700004],
              [139.83806399800005, 35.088324286000045],
              [139.83578535200002, 35.099269924000055],
              [139.8364363940001, 35.135199286000045],
              [139.81897429600008, 35.157662877000064],
              [139.82211347700002, 35.17059967700004],
              [139.8194346680001, 35.18504826700007],
              [139.82460882400005, 35.199063900000056],
              [139.85195684100006, 35.21466754000005],
              [139.86515060700003, 35.22409896400006],
              [139.86632662800002, 35.24620537700008],
              [139.84831790500004, 35.27171458500004],
              [139.84933413400006, 35.29355360000005],
              [139.80813764700008, 35.30548489100005],
              [139.78215300800002, 35.31417710000005],
              [139.78100337900003, 35.31806065600006],
              [139.80218970600004, 35.31735035200006],
              [139.82415804200002, 35.32842398900004],
              [139.824667997, 35.34700932700008],
              [139.83874471700005, 35.359298994000085],
              [139.84477673600009, 35.37620508400005],
              [139.8927430760001, 35.36418368900007],
              [139.907865055, 35.37871859200004],
              [139.90731450700002, 35.39230448600006],
              [139.900121044, 35.42310445500004],
              [139.9128234540001, 35.434436180000034],
              [139.94075591, 35.44251764400008],
              [139.95867218600006, 35.45620969700008],
              [139.98233663500002, 35.458668431000035],
              [140.005859289, 35.47342712000005],
              [140.0201180250001, 35.491210495000075],
              [140.041455089, 35.51377297500005],
              [140.07188712900006, 35.542856802000074],
              [140.09015640100006, 35.54084883200005],
              [140.09782201000007, 35.55532235600009],
              [140.102048684, 35.56708749400008],
              [140.086119779, 35.56680512400004],
              [140.0830184250001, 35.585598049000055],
              [140.07960045700008, 35.603583075000074],
              [140.06382667700007, 35.61534216400008],
              [140.04761498000005, 35.63077500900005],
              [140.03287822000004, 35.64099547700005],
              [140.008949863, 35.659759819000044],
              [139.99577884200005, 35.656683661000045],
              [139.983614332, 35.66864466800007],
              [139.95041397400007, 35.67259201500008],
              [139.92053189700005, 35.66206667300008],
              [139.9395792910001, 35.63689149800007],
              [139.91207079900005, 35.624087461000045],
              [139.89716783000006, 35.614373758000056],
              [139.8911238940001, 35.623114325000074],
              [139.8794051440001, 35.625067450000074],
              [139.87086022200003, 35.631293036000045],
              [139.86424285700002, 35.63206757700004],
              [139.85027103000004, 35.63751862200007],
              [139.84327233200008, 35.628892320000034],
              [139.83727706700006, 35.61454952400004],
              [139.82388751100007, 35.62295089600008],
              [139.82035734500005, 35.63804933000006],
              [139.80682518800006, 35.63819253400004],
              [139.80030358200008, 35.61863841400009],
              [139.789146748, 35.60324341200004],
              [139.774854602, 35.617637271000035],
              [139.7756252160001, 35.641103505000046],
              [139.7652724520001, 35.65351048500008],
              [139.7581622360001, 35.63156424200008],
              [139.76880944100003, 35.60097890800006],
              [139.78480408500002, 35.580466096000066],
              [139.7850047280001, 35.56816522000008],
              [139.79905634500005, 35.54001012800006],
              [139.78687584700003, 35.52716705900008],
              [139.7880965500001, 35.51325104400007],
              [139.78663170700008, 35.51154205900008],
              [139.77857506600003, 35.50185781500005],
              [139.74455011300006, 35.48430496600008],
              [139.71407684000008, 35.46473072500004],
              [139.6882217330001, 35.46110650400004],
              [139.66689706, 35.46793427800009],
              [139.65162194100003, 35.46458567900004],
              [139.6423018370001, 35.45426118200004],
              [139.66221936600004, 35.44648058700005],
              [139.68054456100003, 35.43838609900007],
              [139.68739709600004, 35.43217553000005],
              [139.682043377, 35.418810922000034],
              [139.686859571, 35.40070221600007],
              [139.67457116000003, 35.400824286000045],
              [139.6499959250001, 35.41055080800004],
              [139.6357919080001, 35.40163242700004],
              [139.64214195600005, 35.388480564000076],
              [139.65723847900006, 35.37702195400004],
              [139.654633009, 35.33942291900007],
              [139.64966881600003, 35.32664622600004],
              [139.65023847700002, 35.31037018400008],
              [139.648358142, 35.297890507000034],
              [139.65750456700005, 35.286647050000056],
              [139.66438993500003, 35.29878081000004],
              [139.676899305, 35.29153718100008],
              [139.69418379, 35.268744208000044],
              [139.7342280480001, 35.26520292300006],
              [139.745453321, 35.24896881700005],
              [139.725922071, 35.233303127000056],
              [139.72934004, 35.22931549700007],
              [139.7309676440001, 35.225897528000075],
              [139.73226972700002, 35.22256094000005],
              [139.7280246570001, 35.20708410000009],
              [139.68879598, 35.20913368600009],
              [139.666456229, 35.19389322400008],
              [139.660589416, 35.17823249200006],
              [139.67058353000004, 35.15997955900008],
              [139.68034915500004, 35.149603583000044],
              [139.68506920700008, 35.14044830900008],
              [139.67505944100003, 35.13646067900004],
              [139.66431725400003, 35.134833075000074],
              [139.64151397500007, 35.139633865000064],
              [139.625336134, 35.13178131700005],
              [139.61628493600006, 35.134001708000085],
              [139.6114520120001, 35.141972689000056],
              [139.61606961400003, 35.15262239800006],
              [139.6143019980001, 35.17404269600007],
              [139.60179274300003, 35.201835319000054],
              [139.62395895200007, 35.211617096000055],
              [139.61991832900003, 35.21974007600005],
              [139.604322561, 35.224233507000065],
              [139.59759518300007, 35.23868757400004],
              [139.569497953, 35.268857317000084],
              [139.56625410200002, 35.27606842700004],
              [139.56068062000008, 35.28692774600006],
              [139.54851321700005, 35.28790924700007],
              [139.5441777970001, 35.30789279800007],
              [139.52660337300006, 35.30203700900006],
              [139.50667053000006, 35.304172695000034],
              [139.486664259, 35.30052317900004],
              [139.46691429100008, 35.31331858400006],
              [139.4148557200001, 35.318814659000054],
              [139.3300220760001, 35.304475677000084],
              [139.2820504240001, 35.29619758400008],
              [139.23336693300007, 35.28532441900006],
              [139.18353782100007, 35.26326671600009],
              [139.145957437, 35.235226985000054],
              [139.14242597700002, 35.184027411000045],
              [139.15805097700002, 35.13646067900004],
              [139.12077055300006, 35.15025745000008],
              [139.08847267500005, 35.11005777000008],
              [139.07673175500008, 35.075094009000054],
              [139.07587403600007, 35.05317728600005],
              [139.1059676440001, 35.04938385600008],
              [139.10175644700007, 35.03054164000008],
              [139.09709101300007, 35.01149501300006],
              [139.08654809100005, 34.99730546900008],
              [139.100602546, 34.974755422000044],
              [139.13070722700002, 34.96515534100007],
              [139.1425887380001, 34.942287502000056],
              [139.14828535200002, 34.90509674700007],
              [139.14087975400003, 34.87055084800005],
              [139.119297985, 34.86738948800007],
              [139.099072944, 34.85611941800005],
              [139.0883895190001, 34.84227122600004],
              [139.0839949880001, 34.82835521000004],
              [139.07481770100003, 34.80896906900006],
              [139.0590859360001, 34.79257003200007],
              [139.05171284900007, 34.77778765100004],
              [139.042983467, 34.76756908400006],
              [139.02632726900003, 34.764246600000035],
              [139.01898917200003, 34.75428978500008],
              [139.01097162300005, 34.746621126000036],
              [138.99875872200005, 34.73328434200005],
              [139.00261478000004, 34.72182851800005],
              [138.9970809250001, 34.71503327000005],
              [138.9887801440001, 34.70140208500004],
              [138.98560631600003, 34.683294989000046],
              [138.98755944100003, 34.66478099200009],
              [138.99366295700008, 34.64984772300005],
              [138.9824324880001, 34.64447663000004],
              [138.9726668630001, 34.645819403000075],
              [138.9648543630001, 34.65253327000005],
              [138.9408259810001, 34.661107187000084],
              [138.89597911200008, 34.629045776000055],
              [138.86094893900008, 34.61349798100008],
              [138.835297071, 34.59589264500005],
              [138.81999759200005, 34.60236237200007],
              [138.806000196, 34.61367422100005],
              [138.79468834700003, 34.626288153000075],
              [138.7713901310001, 34.64731395300004],
              [138.7778426440001, 34.663316148000035],
              [138.7739363940001, 34.67096588700008],
              [138.76685631600003, 34.676214911000045],
              [138.75904381600003, 34.67845286700009],
              [138.7519637380001, 34.682074286000045],
              [138.7465926440001, 34.691473700000074],
              [138.74594160200002, 34.70917389500005],
              [138.74400124200008, 34.72889189500006],
              [138.7562422850001, 34.73747022500004],
              [138.76182943900005, 34.748281714000086],
              [138.774261915, 34.751288153000075],
              [138.758761188, 34.78270405300009],
              [138.74812686400003, 34.81320925300008],
              [138.75789301600003, 34.829702497000085],
              [138.7622176440001, 34.84642161700009],
              [138.7602645190001, 34.84906647300005],
              [138.76050866000003, 34.86937083500004],
              [138.753838793, 34.87946727500008],
              [138.76299558100004, 34.89398688000006],
              [138.7767874000001, 34.90482837700006],
              [138.78980553500003, 34.90680573100008],
              [138.77849368600005, 34.92202383000006],
              [138.7739363940001, 34.931626695000034],
              [138.7636926460001, 34.95605640500008],
              [138.7618935590001, 34.97990260500006],
              [138.77680217, 35.003160568000055],
              [138.78608990100008, 35.026438762000055],
              [138.82659514700003, 35.02362521900005],
              [138.85541578700008, 35.01902692800007],
              [138.87512759900005, 35.02009448400008],
              [138.89380944100003, 35.02000560100004],
              [138.907562696, 35.03066640800006],
              [138.8534354960001, 35.07822164400005],
              [138.83853700300006, 35.099525698000036],
              [138.8033316850001, 35.121909308000056],
              [138.74422004400003, 35.13484289300004],
              [138.69618557600006, 35.13897567500004],
              [138.66363181200006, 35.12714398500009],
              [138.6372695660001, 35.11598535200005],
              [138.58678602100008, 35.11436020000008],
              [138.55408217500008, 35.096069379000085],
              [138.52765127300006, 35.050808017000065],
              [138.49788298200008, 35.03256950200006],
              [138.4948830940001, 35.00073149500008],
              [138.507010004, 34.99107225200004],
              [138.50702289100002, 35.01189308800008],
              [138.52098226200008, 35.01937347200004],
              [138.53161744200008, 35.016923751000036],
              [138.51429303400005, 34.98017780400005],
              [138.46836274400005, 34.959069567000085],
              [138.429755054, 34.94473446500007],
              [138.40050460700002, 34.93249572800005],
              [138.367107895, 34.917309439000064],
              [138.3533526120001, 34.90411501600005],
              [138.34686565000004, 34.88818873000008],
              [138.3364363940001, 34.87409088700008],
              [138.32829837300005, 34.85529205900008],
              [138.3300887380001, 34.845404364000046],
              [138.3408309250001, 34.82648346600007],
              [138.32588911900007, 34.807908231000056],
              [138.3148726610001, 34.79836868000007],
              [138.29322798300007, 34.76577441500007],
              [138.24950579000006, 34.73902319000007],
              [138.21598919100006, 34.712282661000074],
              [138.2016707690001, 34.66010163000004],
              [138.19361412900003, 34.641506252000056],
              [138.20093834700003, 34.62156810100004],
              [138.22505168600003, 34.61630119900008],
              [138.24032772700002, 34.602561079000054],
              [138.23328976100004, 34.59458877000009],
              [138.1901763740001, 34.601227717000086],
              [138.04723701, 34.65463981500005],
              [137.96758503500007, 34.666540387000055],
              [137.8927975680001, 34.667696567000064],
              [137.79216556100005, 34.63939036700009],
              [137.68350648400008, 34.67075459900008],
              [137.595062696, 34.67719147300005],
              [137.54699814000003, 34.67728852500005],
              [137.4275572790001, 34.66774579100007],
              [137.33970288, 34.64744751300009],
              [137.14072680900006, 34.589289111000085],
              [137.09582116700005, 34.59323397800006],
              [137.04482177, 34.58063023500006],
              [137.03150475400003, 34.579413153000075],
              [137.01609532100008, 34.578784710000036],
              [137.02359643, 34.59077881500008],
              [137.02964210200003, 34.59801495600004],
              [137.04248611100002, 34.61757853200004],
              [137.05221990300004, 34.646803169000066],
              [137.07283016600002, 34.664599003000035],
              [137.10108483200008, 34.63914622600004],
              [137.1045028000001, 34.632025458000044],
              [137.11085045700008, 34.625433661000045],
              [137.11869901800003, 34.633708339000066],
              [137.1210200710001, 34.63766082400008],
              [137.13703100100008, 34.64557830000007],
              [137.153168165, 34.65131256700005],
              [137.16765384200005, 34.656683661000045],
              [137.19743544000005, 34.67393411100005],
              [137.241111284, 34.69667799400008],
              [137.2597158000001, 34.70414459500006],
              [137.282254577, 34.73117851600006],
              [137.29822593400002, 34.728215300000045],
              [137.2996710230001, 34.70684664400005],
              [137.295677694, 34.69120409900006],
              [137.3034520120001, 34.689428676000034],
              [137.30996040900004, 34.70659849200007],
              [137.309256237, 34.72566427800007],
              [137.33259033900003, 34.72033825800008],
              [137.340819453, 34.726542951000056],
              [137.3123394920001, 34.73667473100005],
              [137.320814584, 34.755251774000044],
              [137.32431631200006, 34.766844656000046],
              [137.32154381600003, 34.77338288000004],
              [137.29792810200001, 34.79719109500007],
              [137.27995853000004, 34.80809153900009],
              [137.26650522300008, 34.80313888900008],
              [137.2458095720001, 34.80964062400005],
              [137.22282679300008, 34.81626329100004],
              [137.20771529500007, 34.80258023400006],
              [137.19443232100002, 34.80699872100007],
              [137.19084265200001, 34.78868068400004],
              [137.18873911600008, 34.770111700000086],
              [137.17083922900008, 34.76386499700004],
              [137.1714708070001, 34.78404980300007],
              [137.15747383500002, 34.78116491800006],
              [137.14053338200006, 34.78781337000004],
              [137.121548889, 34.788343361000045],
              [137.10144007600002, 34.78459645400005],
              [137.0874467110001, 34.776028248000046],
              [137.0727086490001, 34.78496379100005],
              [137.050165591, 34.777606125000034],
              [137.028817086, 34.78015714400004],
              [137.01824785300005, 34.78328903500005],
              [137.002289259, 34.802394924000055],
              [136.99561608200008, 34.80809153900009],
              [136.9766259920001, 34.82550679500008],
              [136.9582313730001, 34.83235218500005],
              [136.9624035280001, 34.85799564600006],
              [136.98259524800005, 34.89826080900008],
              [136.978851759, 34.92422109600005],
              [136.96949303500003, 34.91160716400009],
              [136.95679772200003, 34.884833075000074],
              [136.9384871750001, 34.860988674000055],
              [136.931000196, 34.84642161700009],
              [136.92574639300005, 34.82827095600004],
              [136.9155640360001, 34.77596001200004],
              [136.926605665, 34.76361725500004],
              [136.93726647200003, 34.74603913000004],
              [136.9626499850001, 34.73496420500004],
              [136.97185687800004, 34.713403750000055],
              [136.9714965940001, 34.69641132500004],
              [136.94539164900004, 34.69847069000008],
              [136.913204285, 34.71087424700005],
              [136.87810982000008, 34.72852009700006],
              [136.8559676440001, 34.73981354400007],
              [136.84459379300006, 34.75254813600009],
              [136.8428861010001, 34.76907728900005],
              [136.85301440900002, 34.78759522100006],
              [136.85697530900006, 34.804757693000056],
              [136.8647340120001, 34.821545090000086],
              [136.86426376300005, 34.83652562000009],
              [136.856286199, 34.85649521600004],
              [136.84341791300005, 34.87116311900007],
              [136.82772581000006, 34.87194149700008],
              [136.8229381970001, 34.89562323900009],
              [136.82176567300007, 34.91949379300007],
              [136.822247296, 34.938299802000074],
              [136.82346477800002, 34.95485542300008],
              [136.83329350600002, 34.972092074000045],
              [136.8438138150001, 34.989480583000045],
              [136.856906427, 35.00803718100008],
              [136.8658805010001, 35.02569016400008],
              [136.87985931700007, 35.04383685700009],
              [136.88279637300002, 35.071047848000035],
              [136.88572989700003, 35.08919548600005],
              [136.871821469, 35.093395273000056],
              [136.8570600810001, 35.061786607000045],
              [136.84886474000007, 35.03946941500004],
              [136.844125921, 35.060766751000074],
              [136.843151734, 35.07504335100003],
              [136.83011829400004, 35.07883139300009],
              [136.83932725500006, 35.03251957900005],
              [136.81302073200004, 35.02738553700004],
              [136.80895927300003, 35.048830543000065],
              [136.79946622900002, 35.04855935200004],
              [136.79790005000007, 35.024069190000034],
              [136.7784691060001, 35.020401545000084],
              [136.75180097700002, 35.02614980700008],
              [136.74480228000004, 35.023423570000034],
              [136.7255965500001, 35.02724844000005],
              [136.68116295700008, 35.00092194200005],
              [136.6591903000001, 34.98395416900007],
              [136.64991295700008, 34.96889883000006],
              [136.64869225400003, 34.962591864000046],
              [136.6435653000001, 34.953192450000074],
              [136.64242597700002, 34.94806549700007],
              [136.64478600400003, 34.94236888200004],
              [136.661666836, 34.940504575000034],
              [136.64555099200004, 34.92978744800007],
              [136.64825961300005, 34.911600243000066],
              [136.63931594000007, 34.889048701000036],
              [136.61611454500007, 34.85350057100004],
              [136.56501226500006, 34.800119265000035],
              [136.53493993900008, 34.765695099000084],
              [136.5273543630001, 34.72125885600008],
              [136.52165774800005, 34.70172760600008],
              [136.5195418630001, 34.680853583000044],
              [136.52165774800005, 34.67609284100007],
              [136.5322371750001, 34.660142320000034],
              [136.53630618600005, 34.656683661000045],
              [136.54639733200008, 34.651597398000035],
              [136.54566491000003, 34.639878648000035],
              [136.54118899800005, 34.626206773000035],
              [136.5400496750001, 34.61570872600004],
              [136.55103600400003, 34.601996161000045],
              [136.56812584700003, 34.59638092700004],
              [136.61207116000003, 34.59589264500005],
              [136.63298587300005, 34.591131903000075],
              [136.648773634, 34.579738674000055],
              [136.6626082690001, 34.56598541900007],
              [136.677093946, 34.55426666900007],
              [136.752289259, 34.513332424000055],
              [136.80355879, 34.49526601800005],
              [136.8144637380001, 34.486029364000046],
              [136.82496178500003, 34.489447333000044],
              [136.8388778000001, 34.489162502000056],
              [136.85230553500003, 34.485541083000044],
              [136.86215254, 34.47919342700004],
              [136.86890709700003, 34.46735260600008],
              [136.87077884200005, 34.45685455900008],
              [136.8735457690001, 34.44708893400008],
              [136.8833113940001, 34.437567450000074],
              [136.89633222700002, 34.43341705900008],
              [136.90699303500003, 34.43463776200008],
              [136.9160262380001, 34.43398672100005],
              [136.9243270190001, 34.42397695500006],
              [136.9257918630001, 34.41290924700007],
              [136.91675866000003, 34.376166083000044],
              [136.904633009, 34.38117096600007],
              [136.8930770190001, 34.38239166900007],
              [136.883148634, 34.37885163000004],
              [136.87525475400003, 34.36933014500005],
              [136.8798934250001, 34.36273834800005],
              [136.8872176440001, 34.357082424000055],
              [136.89722741000003, 34.353949286000045],
              [136.90992272200003, 34.35504791900007],
              [136.89437910200002, 34.34271881700005],
              [136.8886824880001, 34.33616771000004],
              [136.8833113940001, 34.32831452000005],
              [136.89128665500004, 34.317694403000075],
              [136.897797071, 34.30097077000005],
              [136.90023847700002, 34.282538153000075],
              [136.89568118600005, 34.266913153000075],
              [136.88599694100003, 34.26044342700004],
              [136.85084069100003, 34.249253648000035],
              [136.83545983200008, 34.24640534100007],
              [136.81853274800005, 34.24762604400007],
              [136.79420006600003, 34.253119208000044],
              [136.77515709700003, 34.26186758000006],
              [136.7734481130001, 34.273098049000055],
              [136.78793379, 34.277411200000074],
              [136.80925540500004, 34.273871161000045],
              [136.82960045700008, 34.26654694200005],
              [136.84164472700002, 34.259466864000046],
              [136.83961022200003, 34.266058661000045],
              [136.83806399800005, 34.27533600500004],
              [136.83545983200008, 34.280503648000035],
              [136.848480665, 34.273098049000055],
              [136.85621178500003, 34.294175523000035],
              [136.84644616000003, 34.30756256700005],
              [136.82740319100003, 34.31240469000005],
              [136.80746504, 34.307847398000035],
              [136.80982506600003, 34.30109284100007],
              [136.80974368600005, 34.29791901200008],
              [136.80836022200003, 34.294623114000046],
              [136.80746504, 34.28733958500004],
              [136.7734481130001, 34.307847398000035],
              [136.75660241000003, 34.296087958000044],
              [136.72584069100003, 34.291001695000034],
              [136.70264733200008, 34.29515208500004],
              [136.70826256600003, 34.310980536000045],
              [136.72339928500003, 34.331284898000035],
              [136.70679772200003, 34.33429596600007],
              [136.6762801440001, 34.32640208500004],
              [136.64991295700008, 34.314113674000055],
              [136.66814212300005, 34.30955638200004],
              [136.6670028000001, 34.29791901200008],
              [136.6547957690001, 34.286037502000056],
              [136.62289472700002, 34.274603583000044],
              [136.60808353000004, 34.26459381700005],
              [136.59253991000003, 34.26264069200005],
              [136.57406660200002, 34.280503648000035],
              [136.56820722700002, 34.274318752000056],
              [136.56397545700008, 34.27171458500004],
              [136.5615340500001, 34.26837799700007],
              [136.5605574880001, 34.259466864000046],
              [136.53288821700005, 34.27167389500005],
              [136.52295983200008, 34.273098049000055],
              [136.51775149800005, 34.26121653900009],
              [136.5122176440001, 34.25218333500004],
              [136.5058699880001, 34.24640534100007],
              [136.51482181100005, 34.229803778000075],
              [136.5029403000001, 34.22907135600008],
              [136.4716903000001, 34.23895905200004],
              [136.42725670700008, 34.213771877000056],
              [136.4165145190001, 34.20425039300005],
              [136.38428795700008, 34.20425039300005],
              [136.33668053500003, 34.184027411000045],
              [136.29900149800005, 34.154282945000034],
              [136.29704837300005, 34.12567780200004],
              [136.30836022200003, 34.11782461100006],
              [136.3164168630001, 34.11432526200008],
              [136.31902103000004, 34.10883209800005],
              [136.3134871750001, 34.094956773000035],
              [136.30844160200002, 34.09003327000005],
              [136.30030358200008, 34.08567942900004],
              [136.29118899800005, 34.08250560100004],
              [136.28345787900003, 34.081284898000035],
              [136.27312259200005, 34.08584219000005],
              [136.2607528000001, 34.105129299000055],
              [136.25269616000003, 34.108587958000044],
              [136.24634850400003, 34.103583075000074],
              [136.23023522200003, 34.082098700000074],
              [136.21851647200003, 34.07514069200005],
              [136.21851647200003, 34.067613023000035],
              [136.23308353000004, 34.06777578300006],
              [136.24382571700005, 34.064154364000046],
              [136.2504988940001, 34.056341864000046],
              [136.25269616000003, 34.04344310100004],
              [136.27076256600003, 34.02814362200007],
              [136.2797957690001, 34.01732005400004],
              [136.27662194100003, 34.01239655200004],
              [136.27458743600005, 34.006740627000056],
              [136.2754012380001, 33.97996653900009],
              [136.27320397200003, 33.97142161700009],
              [136.258636915, 33.96588776200008],
              [136.24732506600003, 33.97150299700007],
              [136.238617384, 33.982489325000074],
              [136.23218834700003, 33.99315013200004],
              [136.21900475400003, 33.98114655200004],
              [136.20484459700003, 33.97142161700009],
              [136.20484459700003, 33.96523672100005],
              [136.2275496750001, 33.96173737200007],
              [136.234711134, 33.948431708000044],
              [136.2285262380001, 33.938381252000056],
              [136.21111087300005, 33.94476959800005],
              [136.20630944100003, 33.926947333000044],
              [136.19890384200005, 33.92088450700004],
              [136.16480553500003, 33.91616445500006],
              [136.160492384, 33.913397528000075],
              [136.152679884, 33.906236070000034],
              [136.1425887380001, 33.89362213700008],
              [136.13697350400003, 33.89057038000004],
              [136.12574303500003, 33.889553127000056],
              [136.1047442250001, 33.89141140000004],
              [136.06931712800008, 33.84704388300008],
              [136.0170750740001, 33.73389913600005],
              [135.99374433700007, 33.68626536700009],
              [135.990570509, 33.682521877000056],
              [135.98072350400003, 33.65298086100006],
              [135.96159915500004, 33.64252350500004],
              [135.95728600400003, 33.62571849200009],
              [135.937066684, 33.61747297900007],
              [135.93873646200007, 33.60394802800005],
              [135.95987107500002, 33.59308822500009],
              [135.9460713420001, 33.57780993300008],
              [135.91253492700002, 33.54768686700004],
              [135.894209005, 33.54164240700004],
              [135.8847762380001, 33.528998114000046],
              [135.82806328700008, 33.513648259000036],
              [135.809183986, 33.50503721300004],
              [135.79799322100007, 33.495161487000075],
              [135.78296949000003, 33.47289128700004],
              [135.79021590700006, 33.45339146900005],
              [135.78926326300007, 33.441062324000086],
              [135.77202431600006, 33.44491902400006],
              [135.76002037900003, 33.43333567900004],
              [135.75384601400003, 33.45157716400007],
              [135.77075201000002, 33.46822920000005],
              [135.7655706070001, 33.48154548800005],
              [135.66822350400003, 33.49046458500004],
              [135.637543165, 33.49461497600004],
              [135.490763022, 33.54122717300004],
              [135.44483483200008, 33.550848700000074],
              [135.4091903000001, 33.574204820000034],
              [135.39750451600003, 33.58258693600004],
              [135.387324143, 33.594067317000054],
              [135.3868133410001, 33.607838720000075],
              [135.39234459700003, 33.61888255400004],
              [135.38070722700002, 33.63711172100005],
              [135.3750106130001, 33.64313385600008],
              [135.36939537900003, 33.644964911000045],
              [135.3586623120001, 33.654207314000075],
              [135.341967254, 33.65721093600007],
              [135.3276951260001, 33.67119293500008],
              [135.34294453100006, 33.69389835100009],
              [135.37921421300007, 33.69811089400008],
              [135.4023543630001, 33.70111725500004],
              [135.3916121750001, 33.71356842700004],
              [135.3408309250001, 33.745306708000044],
              [135.32138786300004, 33.75292358100006],
              [135.312102234, 33.76552878400008],
              [135.29402077300006, 33.76371566600005],
              [135.26434503500002, 33.78131573100006],
              [135.23258264800006, 33.781998007000084],
              [135.22984796100002, 33.798554135000074],
              [135.19646243600005, 33.81476471600007],
              [135.17335045700008, 33.838324286000045],
              [135.15275760100008, 33.875854179000044],
              [135.11868351100009, 33.89293870400007],
              [135.100120232, 33.88984017900009],
              [135.06545384900005, 33.88557181900006],
              [135.058859504, 33.880032887000084],
              [135.06130745400003, 33.88987988000008],
              [135.0664965850001, 33.896407725000074],
              [135.05736156500006, 33.90129779600005],
              [135.06423797000002, 33.90602024800006],
              [135.0791267630001, 33.906025414000055],
              [135.07799229, 33.91855214600008],
              [135.06955997700004, 33.93066660300008],
              [135.08471704600004, 33.942213724000055],
              [135.1012224010001, 33.954437547000055],
              [135.094975879, 33.95869124200004],
              [135.0773346210001, 33.95898546600006],
              [135.07573725100008, 33.97748793800008],
              [135.0919983990001, 33.99203611100006],
              [135.11327708800002, 33.99338693300007],
              [135.12793504700005, 33.99860523400008],
              [135.153168165, 34.009751695000034],
              [135.16163170700008, 34.02496979400007],
              [135.16277103000004, 34.03974030200004],
              [135.15308678500003, 34.04857005400004],
              [135.1333113940001, 34.058294989000046],
              [135.11109459700003, 34.065741278000075],
              [135.09449303500003, 34.067613023000035],
              [135.11491946700005, 34.10179271000004],
              [135.11736087300005, 34.10342031500005],
              [135.1254988940001, 34.10614655200004],
              [135.12867272200003, 34.108587958000044],
              [135.13054446700005, 34.11322663000004],
              [135.13062584700003, 34.122381903000075],
              [135.12283938400003, 34.137101115000064],
              [135.148770624, 34.138076298000044],
              [135.18702233200008, 34.135931708000044],
              [135.1899520190001, 34.149603583000044],
              [135.1796981130001, 34.16583893400008],
              [135.16585549400008, 34.18672339300008],
              [135.148773634, 34.185614325000074],
              [135.13542728000004, 34.22768789300005],
              [135.119628917, 34.24220217300007],
              [135.09266843600005, 34.25988713800007],
              [135.06104364700002, 34.267274919000045],
              [135.0712996750001, 34.28579336100006],
              [135.105030715, 34.31811688100004],
              [135.20898538000006, 34.34227764500008],
              [135.256564013, 34.37675475200007],
              [135.28129845600006, 34.39742826300005],
              [135.31968984900004, 34.428758197000036],
              [135.35347650300002, 34.46748311400006],
              [135.372562312, 34.48451311600007],
              [135.37427942500005, 34.50775608100008],
              [135.37320827300005, 34.51893221900008],
              [135.390996836, 34.52364861700005],
              [135.39913822100004, 34.532931993000034],
              [135.408323731, 34.540974933000086],
              [135.41437915100005, 34.55812547000005],
              [135.41523416000007, 34.57996770800008],
              [135.4157815220001, 34.60961152200008],
              [135.40731751300007, 34.63420060100009],
              [135.403590677, 34.65891218200005],
              [135.41293379, 34.69208405200004],
              [135.39757432300007, 34.686213783000085],
              [135.38121442800002, 34.68126282900005],
              [135.36324441800002, 34.68907092900008],
              [135.3412673680001, 34.708509605000074],
              [135.31748518100005, 34.70695845700004],
              [135.286862671, 34.70544269800007],
              [135.28730090800002, 34.67996987600009],
              [135.25360478100004, 34.67699777100006],
              [135.25489028200002, 34.70091002200007],
              [135.22006657000009, 34.69077377000008],
              [135.24234854000008, 34.650751996000054],
              [135.21090197, 34.65518024800008],
              [135.2044032770001, 34.677260673000035],
              [135.186030437, 34.67490879400009],
              [135.1839760470001, 34.65115585800004],
              [135.11131213300007, 34.64038240500008],
              [135.07954647400004, 34.62777575900009],
              [135.04576878800003, 34.624966887000085],
              [135.0168455700001, 34.642155986000034],
              [134.97925866000003, 34.64101797100005],
              [134.960297071, 34.64362213700008],
              [134.9370248570001, 34.667368869000086],
              [134.90762493400007, 34.67760643300005],
              [134.88835696700005, 34.691473700000074],
              [134.833343946, 34.72138092700004],
              [134.80046634200005, 34.730902411000045],
              [134.76238040500004, 34.75698476800005],
              [134.74439537900003, 34.76654694200005],
              [134.6962996750001, 34.77619049700007],
              [134.5669051440001, 34.76654694200005],
              [134.559906446, 34.76829661700009],
              [134.55445397200003, 34.77163320500006],
              [134.54908287900003, 34.77326080900008],
              [134.54265384200005, 34.769964911000045],
              [134.53785241000003, 34.76654694200005],
              [134.53150475400003, 34.76312897300005],
              [134.52491295700008, 34.760646877000056],
              [134.51905358200008, 34.75971100500004],
              [134.5058699880001, 34.760972398000035],
              [134.49586022200003, 34.764553127000056],
              [134.49048912900003, 34.77260976800005],
              [134.4912215500001, 34.78705475500004],
              [134.48454837300005, 34.78530508000006],
              [134.47820071700005, 34.78192780200004],
              [134.4731551440001, 34.77684153900009],
              [134.47136478000004, 34.769964911000045],
              [134.470062696, 34.761786200000074],
              [134.46705162900003, 34.760972398000035],
              [134.46257571700005, 34.76203034100007],
              [134.4570418630001, 34.75971100500004],
              [134.43140709700003, 34.730454820000034],
              [134.4228621750001, 34.72557200700004],
              [134.4087020190001, 34.726263739000046],
              [134.39820397200003, 34.73151276200008],
              [134.3896590500001, 34.73737213700008],
              [134.3813582690001, 34.73981354400007],
              [134.36841881600003, 34.735988674000055],
              [134.357758009, 34.72736237200007],
              [134.35222415500004, 34.71625397300005],
              [134.3540145190001, 34.705145575000074],
              [134.3266707690001, 34.704331773000035],
              [134.2763778000001, 34.71523672100005],
              [134.24781334700003, 34.71816640800006],
              [134.2207137380001, 34.72846100500004],
              [134.20875084700003, 34.72801341400009],
              [134.2168074880001, 34.71190013200004],
              [134.226898634, 34.707912502000056],
              [134.27881920700008, 34.69822825700004],
              [134.27100670700008, 34.69627513200004],
              [134.25163821700005, 34.69375234600005],
              [134.24480228000004, 34.691473700000074],
              [134.22445722700002, 34.667669989000046],
              [134.22022545700008, 34.66351959800005],
              [134.212250196, 34.661363023000035],
              [134.1962996750001, 34.652004299000055],
              [134.1782332690001, 34.64883047100005],
              [134.17066491000003, 34.64598216400009],
              [134.1552840500001, 34.63686758000006],
              [134.1621199880001, 34.63222890800006],
              [134.170258009, 34.63076406500005],
              [134.1796981130001, 34.63231028900009],
              [134.1894637380001, 34.63686758000006],
              [134.17725670700008, 34.614447333000044],
              [134.14795983200008, 34.596991278000075],
              [134.11304772200003, 34.585638739000046],
              [134.08366946700005, 34.58152903900009],
              [134.0693465500001, 34.58584219000005],
              [134.0473738940001, 34.60464101800005],
              [134.02881920700008, 34.60887278900009],
              [133.99439537900003, 34.608710028000075],
              [133.97925866000003, 34.605902411000045],
              [133.95386803500003, 34.593003648000035],
              [133.93669681100005, 34.587225653000075],
              [133.925140821, 34.57786692900004],
              [133.92945397200003, 34.56110260600008],
              [133.94255618600005, 34.555121161000045],
              [133.957367384, 34.564439195000034],
              [133.98406009200005, 34.589056708000044],
              [134.00074303500003, 34.59446849200009],
              [134.01929772200003, 34.59682851800005],
              [134.0356551440001, 34.593410549000055],
              [134.04615319100003, 34.58152903900009],
              [134.04566491000003, 34.56391022300005],
              [134.03345787900003, 34.55247630400004],
              [134.0175887380001, 34.54364655200004],
              [134.00513756600003, 34.53384023600006],
              [134.00766035200002, 34.530503648000035],
              [134.008636915, 34.528550523000035],
              [134.01197350400003, 34.52008698100008],
              [133.98316491000003, 34.528631903000075],
              [133.96656334700003, 34.50641510600008],
              [133.95386803500003, 34.473822333000044],
              [133.93628991000003, 34.451239325000074],
              [133.85906009200005, 34.462876695000034],
              [133.82178795700008, 34.462144273000035],
              [133.82642662900003, 34.437567450000074],
              [133.79444420700008, 34.44293854400007],
              [133.78052819100003, 34.46336497600004],
              [133.768890821, 34.48802317900004],
              [133.74382571700005, 34.505845445000034],
              [133.7368270190001, 34.502386786000045],
              [133.7304793630001, 34.50698476800005],
              [133.72575931100005, 34.51642487200007],
              [133.72339928500003, 34.52757396000004],
              [133.71656334700003, 34.52008698100008],
              [133.69996178500003, 34.52594635600008],
              [133.68506920700008, 34.52008698100008],
              [133.66944420700008, 34.51080963700008],
              [133.6406356130001, 34.50169505400004],
              [133.5962020190001, 34.48232656500005],
              [133.58619225400003, 34.47573476800005],
              [133.583343946, 34.46869538000004],
              [133.5766707690001, 34.463324286000045],
              [133.5688582690001, 34.45990631700005],
              [133.55046634200005, 34.457017320000034],
              [133.543304884, 34.45307038000004],
              [133.5380965500001, 34.448553778000075],
              [133.532074415, 34.445013739000046],
              [133.470062696, 34.42397695500006],
              [133.50928795700008, 34.462103583000044],
              [133.5224715500001, 34.48305898600006],
              [133.50114993600005, 34.492173570000034],
              [133.4902449880001, 34.489569403000075],
              [133.46851647200003, 34.476996161000045],
              [133.45655358200008, 34.472357489000046],
              [133.43034915500004, 34.47296784100007],
              [133.41911868600005, 34.46792226800005],
              [133.41480553500003, 34.451239325000074],
              [133.422211134, 34.445013739000046],
            ],
          ],
          [
            [
              [143.8964949880001, 44.15814850500004],
              [143.91179446700005, 44.15228913000004],
              [143.95720462300005, 44.152004299000055],
              [143.97584069100003, 44.14826080900008],
              [143.9404403000001, 44.13914622600004],
              [143.8964949880001, 44.14590078300006],
              [143.81373131600003, 44.168402411000045],
              [143.81763756600003, 44.17560455900008],
              [143.836273634, 44.17593008000006],
              [143.85954837300005, 44.172756252000056],
              [143.88152103000004, 44.16669342700004],
              [143.8964949880001, 44.15814850500004],
            ],
          ],
          [
            [
              [145.76742597700002, 43.38727448100008],
              [145.78003991000003, 43.386053778000075],
              [145.81324303500003, 43.378607489000046],
              [145.82496178500003, 43.37360260600008],
              [145.81853274800005, 43.364447333000044],
              [145.81031334700003, 43.36078522300005],
              [145.78785241000003, 43.360581773000035],
              [145.777679884, 43.35626862200007],
              [145.760101759, 43.33698151200008],
              [145.746918165, 43.33270905200004],
              [145.70850670700008, 43.32632070500006],
              [145.69898522200003, 43.32208893400008],
              [145.6840926440001, 43.310248114000046],
              [145.67310631600003, 43.307928778000075],
              [145.643890821, 43.312201239000046],
              [145.62916100400003, 43.309759833000044],
              [145.62134850400003, 43.30341217700004],
              [145.61548912900003, 43.29450104400007],
              [145.6064559250001, 43.28424713700008],
              [145.57984459700003, 43.26504140800006],
              [145.5722762380001, 43.25698476800005],
              [145.56617272200003, 43.246079820000034],
              [145.55738366000003, 43.22142161700003],
              [145.5517684250001, 43.20978424700007],
              [145.54558353000004, 43.20197174700007],
              [145.51710045700008, 43.174994208000044],
              [145.530609571, 43.168850002000056],
              [145.518890821, 43.166449286000045],
              [145.49878991000003, 43.16791413000004],
              [145.47828209700003, 43.17210521000004],
              [145.45240319100003, 43.18390534100007],
              [145.43539472700002, 43.182074286000045],
              [145.40406334700003, 43.174994208000044],
              [145.30250084700003, 43.173488674000055],
              [145.2802840500001, 43.16502513200004],
              [145.2583113940001, 43.14948151200008],
              [145.23113040500004, 43.14109935100004],
              [145.15406334700003, 43.13226959800005],
              [145.13843834700003, 43.128159898000035],
              [145.1254988940001, 43.12006256700005],
              [145.11931399800005, 43.10610586100006],
              [145.12273196700005, 43.08820221600007],
              [145.13542728000004, 43.08429596600007],
              [145.15219160200002, 43.08462148600006],
              [145.16822350400003, 43.079413153000075],
              [145.15902754, 43.07050202000005],
              [145.14918053500003, 43.06631094000005],
              [145.11101321700005, 43.06362539300005],
              [145.1079207690001, 43.05939362200007],
              [145.1064559250001, 43.05292389500005],
              [145.09929446700005, 43.044623114000046],
              [145.07569420700008, 43.03400299700007],
              [145.0512801440001, 43.03310781500005],
              [145.00310306100005, 43.044623114000046],
              [145.02222741000003, 43.02033112200007],
              [145.02751712300005, 43.00934479400007],
              [145.02369225400003, 42.99628327000005],
              [145.01433353000004, 42.989488023000035],
              [145.00017337300005, 42.98615143400008],
              [144.93376712300005, 42.97825755400004],
              [144.899750196, 42.97947825700004],
              [144.86882571700005, 42.98847077000005],
              [144.84205162900003, 43.007147528000075],
              [144.84050540500004, 43.016913153000075],
              [144.843109571, 43.029364325000074],
              [144.840179884, 43.04010651200008],
              [144.82154381600003, 43.044623114000046],
              [144.81006920700008, 43.045355536000045],
              [144.8037215500001, 43.04645416900007],
              [144.79867597700002, 43.04669830900008],
              [144.79086347700002, 43.044623114000046],
              [144.78386478000004, 43.039943752000056],
              [144.77312259200005, 43.02684153900009],
              [144.76628665500004, 43.02415599200003],
              [144.75757897200003, 43.018784898000035],
              [144.747406446, 43.00617096600007],
              [144.739105665, 42.99135976800005],
              [144.73560631600003, 42.97947825700004],
              [144.74146569100003, 42.96523672100005],
              [144.75538170700008, 42.954413153000075],
              [144.77125084700003, 42.94489166900007],
              [144.78345787900003, 42.934759833000044],
              [144.74195397200003, 42.92422109600005],
              [144.59913170700008, 42.94912344000005],
              [144.52173912900003, 42.94407786700003],
              [144.49586022200003, 42.933254299000055],
              [144.4648543630001, 42.93707916900007],
              [144.3906356130001, 42.95644765800006],
              [144.382172071, 42.96149323100008],
              [144.3730574880001, 42.96954987200007],
              [144.368500196, 42.978176174000055],
              [144.36491946700005, 42.989569403000075],
              [144.35808353000004, 42.99945709800005],
              [144.34522545700008, 43.00372955900008],
              [144.32300866000003, 43.00263092700004],
              [144.18311608200008, 42.97638580900008],
              [144.0420028000001, 42.92658112200007],
              [143.88640384200005, 42.844183661000045],
              [143.79029381600003, 42.75726959800005],
              [143.63884524800005, 42.66107819200005],
              [143.5752059250001, 42.60333893400008],
              [143.44809004, 42.45502350500004],
              [143.348968946, 42.31915924700007],
              [143.33171634200005, 42.27724844000005],
              [143.32488040500004, 42.229722398000035],
              [143.3364363940001, 42.17300039300005],
              [143.3379012380001, 42.15021393400008],
              [143.3359481130001, 42.12970612200007],
              [143.3310653000001, 42.10691966400009],
              [143.30347741000003, 42.02578359600005],
              [143.292328321, 42.005194403000075],
              [143.26547285200002, 41.98672109600005],
              [143.2529403000001, 41.94188060100004],
              [143.241547071, 41.92804596600007],
              [143.22608483200008, 41.93227773600006],
              [143.2031356130001, 41.94586823100008],
              [143.18238366000003, 41.96157461100006],
              [143.17335045700008, 41.97211334800005],
              [143.16334069100003, 41.99038320500006],
              [143.14047285200002, 42.01048411700003],
              [143.1152449880001, 42.02798086100006],
              [142.95972741000003, 42.10537344000005],
              [142.75766035200002, 42.15839264500005],
              [142.54639733200008, 42.25055573100008],
              [142.4599715500001, 42.27130768400008],
              [142.28101647200003, 42.366522528000075],
              [142.22217858200008, 42.411769924000055],
              [142.16775167700007, 42.45985850800008],
              [142.06258038500005, 42.47072827200009],
              [141.9809676440001, 42.51023997600004],
              [141.92595462300005, 42.558579820000034],
              [141.90935306100005, 42.56549713700008],
              [141.88819420700008, 42.56976959800005],
              [141.81714928500003, 42.599595445000034],
              [141.72608483200008, 42.617173570000034],
              [141.63648522200003, 42.61579010600008],
              [141.54957116000003, 42.60114166900007],
              [141.4277449880001, 42.56439850500004],
              [141.26246178500003, 42.46824778900009],
              [141.23462975400003, 42.458685614000046],
              [141.21509850400003, 42.444525458000044],
              [141.20329837300005, 42.44135163000004],
              [141.19117272200003, 42.440334377000056],
              [141.1796981130001, 42.43744538000004],
              [141.16871178500003, 42.433294989000046],
              [141.09156334700003, 42.391791083000044],
              [141.0732528000001, 42.37714264500005],
              [141.01677493600005, 42.316107489000046],
              [141.0009871750001, 42.30483633000006],
              [140.98975670700008, 42.30141836100006],
              [140.97730553500003, 42.29962799700007],
              [140.96469160200002, 42.300482489000046],
              [140.95240319100003, 42.30483633000006],
              [140.9458113940001, 42.310248114000046],
              [140.93702233200008, 42.31976959800005],
              [140.9316512380001, 42.32876211100006],
              [140.9360457690001, 42.33270905200004],
              [140.97543379, 42.32656484600005],
              [140.98414147200003, 42.32904694200005],
              [140.9868270190001, 42.339829820000034],
              [140.9746199880001, 42.34662506700005],
              [140.94695071700005, 42.353216864000046],
              [140.92652428500003, 42.36517975500004],
              [140.9179793630001, 42.37254466400009],
              [140.9121199880001, 42.380560614000046],
              [140.9013778000001, 42.42084381700005],
              [140.73365319100003, 42.564154364000046],
              [140.68628991000003, 42.57916901200008],
              [140.66293379, 42.57982005400004],
              [140.59742272200003, 42.57172272300005],
              [140.52564537900003, 42.58063385600008],
              [140.50066165500004, 42.57916901200008],
              [140.4575301440001, 42.56427643400008],
              [140.4170028000001, 42.53815338700008],
              [140.3808699880001, 42.505072333000044],
              [140.32545006600003, 42.432806708000044],
              [140.30396569100003, 42.39297109600005],
              [140.28858483200008, 42.35016510600008],
              [140.28150475400003, 42.30483633000006],
              [140.29175866000003, 42.25958893400008],
              [140.321625196, 42.23395416900007],
              [140.42408287900003, 42.192287502000056],
              [140.456390821, 42.173081773000035],
              [140.5302840500001, 42.111761786000045],
              [140.5488387380001, 42.105536200000074],
              [140.57195071700005, 42.107855536000045],
              [140.61011803500003, 42.117621161000045],
              [140.67408287900003, 42.12205638200004],
              [140.69320722700002, 42.126166083000044],
              [140.71355228000004, 42.13349030200004],
              [140.77361087300005, 42.10219961100006],
              [140.78931725400003, 42.07453034100007],
              [140.83708743600005, 42.02362702000005],
              [140.85368899800005, 42.01121653900009],
              [140.89177493600005, 41.991522528000075],
              [140.90845787900003, 41.978949286000045],
              [140.97429446700005, 41.913763739000046],
              [140.9921981130001, 41.90216705900008],
              [141.01156660200002, 41.893744208000044],
              [141.0337020190001, 41.888739325000074],
              [141.0595809250001, 41.88711172100005],
              [141.08326256600003, 41.88263580900008],
              [141.10694420700008, 41.87177155200004],
              [141.18279056100005, 41.81830475500004],
              [141.19996178500003, 41.79946523600006],
              [141.1899520190001, 41.79092031500005],
              [141.1435653000001, 41.78579336100006],
              [141.1215926440001, 41.779364325000074],
              [141.1040145190001, 41.770412502000056],
              [141.043304884, 41.723863023000035],
              [141.0063582690001, 41.712144273000035],
              [140.9599715500001, 41.721991278000075],
              [140.87427819100003, 41.758246161000045],
              [140.82398522200003, 41.770697333000044],
              [140.77507571700005, 41.770412502000056],
              [140.72999108200008, 41.749986070000034],
              [140.7080184250001, 41.74555084800005],
              [140.698578321, 41.759833075000074],
              [140.70671634200005, 41.77411530200004],
              [140.72242272200003, 41.78335195500006],
              [140.7334090500001, 41.79364655200004],
              [140.72722415500004, 41.81134674700007],
              [140.7089949880001, 41.82440827000005],
              [140.68482506600003, 41.82990143400008],
              [140.66041100400003, 41.82713450700004],
              [140.6416121750001, 41.81509023600006],
              [140.6313582690001, 41.797308661000045],
              [140.6157332690001, 41.75470612200007],
              [140.60425866000003, 41.73627350500004],
              [140.54476972700002, 41.712591864000046],
              [140.53484134200005, 41.70526764500005],
              [140.5234481130001, 41.69867584800005],
              [140.470062696, 41.687201239000046],
              [140.45289147200003, 41.68105703300006],
              [140.43327884200005, 41.64468008000006],
              [140.44320722700002, 41.563706773000035],
              [140.43238366000003, 41.53082916900007],
              [140.40064537900003, 41.513006903000075],
              [140.27466881600003, 41.48236725500004],
              [140.25953209700003, 41.472723700000074],
              [140.2412215500001, 41.45722077000005],
              [140.22584069100003, 41.437933661000045],
              [140.21949303500003, 41.417181708000044],
              [140.2089949880001, 41.40110911700003],
              [140.18506920700008, 41.40379466400009],
              [140.13746178500003, 41.42096588700008],
              [140.12680097700002, 41.42047760600008],
              [140.109711134, 41.41486237200007],
              [140.10035241000003, 41.41351959800005],
              [140.0883895190001, 41.41681549700007],
              [140.0629988940001, 41.431341864000046],
              [140.052093946, 41.43463776200008],
              [140.03825931100005, 41.442572333000044],
              [140.028168165, 41.46141185100004],
              [140.014008009, 41.50287506700005],
              [139.98365319100003, 41.56049225500004],
              [139.979828321, 41.581732489000046],
              [139.98422285200002, 41.603176174000055],
              [140.00342858200008, 41.63467031500005],
              [140.0195418630001, 41.696966864000046],
              [140.071136915, 41.760199286000045],
              [140.0830184250001, 41.800767320000034],
              [140.08741295700008, 41.805121161000045],
              [140.1093856130001, 41.80341217700004],
              [140.1176863940001, 41.80451080900008],
              [140.12671959700003, 41.81403229400007],
              [140.129730665, 41.82322825700004],
              [140.1313582690001, 41.84552643400008],
              [140.13062584700003, 41.85150788000004],
              [140.124359571, 41.86005280200004],
              [140.12387129, 41.86595286700003],
              [140.12777754, 41.870794989000046],
              [140.13493899800005, 41.87514883000006],
              [140.1450301440001, 41.87958405200004],
              [140.14714603000004, 41.89134349200003],
              [140.14795983200008, 41.907538153000075],
              [140.151703321, 41.913763739000046],
              [140.14519290500004, 41.92963288000004],
              [140.1396590500001, 41.94871653900009],
              [140.13843834700003, 41.96751536700003],
              [140.1450301440001, 41.98265208500004],
              [140.1118270190001, 42.01113515800006],
              [140.0610457690001, 42.08002350500004],
              [140.02759850400003, 42.105536200000074],
              [139.92750084700003, 42.13890208500004],
              [139.90935306100005, 42.15656159100007],
              [139.9082137380001, 42.16083405200004],
              [139.90308678500003, 42.16559479400007],
              [139.883636915, 42.194973049000055],
              [139.874359571, 42.19989655200004],
              [139.84343509200005, 42.20856354400007],
              [139.79835045700008, 42.23590729400007],
              [139.787445509, 42.24677155200004],
              [139.77759850400003, 42.271144924000055],
              [139.7675887380001, 42.310980536000045],
              [139.77230879, 42.33047109600005],
              [139.78443444100003, 42.350816148000035],
              [139.8261824880001, 42.402044989000046],
              [139.836761915, 42.423895575000074],
              [139.8496199880001, 42.46930573100008],
              [139.84929446700005, 42.51414622600004],
              [139.83277428500003, 42.58881256700005],
              [139.84343509200005, 42.626939195000034],
              [139.8769637380001, 42.663397528000075],
              [139.91724694100003, 42.67723216400009],
              [140.014008009, 42.68158600500004],
              [140.03785241000003, 42.68602122600004],
              [140.05388431100005, 42.69415924700007],
              [140.09546959700003, 42.73379140800006],
              [140.10515384200005, 42.73908112200007],
              [140.11548912900003, 42.74209219000005],
              [140.12761478000004, 42.74298737200007],
              [140.13591556100005, 42.74713776200008],
              [140.14429772200003, 42.75698476800005],
              [140.16976972700002, 42.79584381700005],
              [140.18336022200003, 42.810207424000055],
              [140.20036868600005, 42.81427643400008],
              [140.22291100400003, 42.80133698100008],
              [140.24577884200005, 42.77293528900009],
              [140.2607528000001, 42.760972398000035],
              [140.28150475400003, 42.75726959800005],
              [140.3032332690001, 42.76972077000005],
              [140.309906446, 42.79319896000004],
              [140.31177819100003, 42.81598541900007],
              [140.31910241000003, 42.826239325000074],
              [140.33741295700008, 42.83413320500006],
              [140.3520613940001, 42.85297272300005],
              [140.37712649800005, 42.893784898000035],
              [140.3930770190001, 42.90851471600007],
              [140.46119225400003, 42.95888906500005],
              [140.50318444100003, 42.98004791900007],
              [140.52116946700005, 42.99628327000005],
              [140.52711022200003, 43.01544830900008],
              [140.51685631600003, 43.02997467700004],
              [140.5019637380001, 43.04572174700007],
              [140.49439537900003, 43.06854889500005],
              [140.4873153000001, 43.08270905200004],
              [140.43921959700003, 43.134019273000035],
              [140.40609785200002, 43.160223700000074],
              [140.36793053500003, 43.18309153900009],
              [140.33806399800005, 43.21051666900007],
              [140.32935631600003, 43.25071849200003],
              [140.36011803500003, 43.32518138200004],
              [140.409515821, 43.32469310100004],
              [140.433929884, 43.32843659100007],
              [140.45289147200003, 43.33885325700004],
              [140.45818118600005, 43.34796784100007],
              [140.46119225400003, 43.358587958000044],
              [140.46509850400003, 43.368068752000056],
              [140.47331790500004, 43.37360260600008],
              [140.48715254, 43.372381903000075],
              [140.49968509200005, 43.36517975500004],
              [140.5102645190001, 43.35700104400007],
              [140.5180770190001, 43.353176174000055],
              [140.5351668630001, 43.34788646000004],
              [140.62094160200002, 43.301214911000045],
              [140.63884524800005, 43.28888580900008],
              [140.668793165, 43.26032135600008],
              [140.68921959700003, 43.24835846600007],
              [140.76140384200005, 43.22345612200007],
              [140.77125084700003, 43.21552155200004],
              [140.78630618600005, 43.20062897300005],
              [140.79615319100003, 43.19550202000005],
              [140.809906446, 43.19245026200008],
              [140.9126082690001, 43.20416901200008],
              [140.9882918630001, 43.226996161000045],
              [141.01124108200008, 43.22898997600004],
              [141.02230879, 43.22378164300005],
              [141.0122176440001, 43.21051666900007],
              [141.0044051440001, 43.193060614000046],
              [141.0219832690001, 43.174994208000044],
              [141.032562696, 43.172308661000045],
              [141.06983483200008, 43.168850002000056],
              [141.11085045700008, 43.15619538000004],
              [141.13550866000003, 43.152411200000074],
              [141.15650475400003, 43.143011786000045],
              [141.16911868600005, 43.14085521000004],
              [141.18726647200003, 43.141506252000056],
              [141.20085696700005, 43.14362213700008],
              [141.2275496750001, 43.15448639500005],
              [141.30396569100003, 43.197251695000034],
              [141.37086022200003, 43.25071849200003],
              [141.3974715500001, 43.279730536000045],
              [141.42335045700008, 43.31785716400009],
              [141.44011478000004, 43.36172109600005],
              [141.43970787900003, 43.40778229400007],
              [141.42701256600003, 43.43455638200004],
              [141.37086022200003, 43.49713776200008],
              [141.3598738940001, 43.52358633000006],
              [141.36247806100005, 43.54336172100005],
              [141.37452233200008, 43.560532945000034],
              [141.39136803500003, 43.57908763200004],
              [141.37273196700005, 43.61823151200008],
              [141.36402428500003, 43.62750885600008],
              [141.36695397200003, 43.64630768400008],
              [141.34392337300005, 43.69017161700003],
              [141.33741295700008, 43.71283600500004],
              [141.34359785200002, 43.73151276200008],
              [141.35816491000003, 43.75580475500004],
              [141.38502037900003, 43.79132721600007],
              [141.40211022200003, 43.803615627000056],
              [141.4248153000001, 43.81460195500006],
              [141.44800866000003, 43.82249583500004],
              [141.490570509, 43.827337958000044],
              [141.51002037900003, 43.83258698100008],
              [141.528168165, 43.84121328300006],
              [141.58472741000003, 43.875433661000045],
              [141.6157332690001, 43.902777411000045],
              [141.6406356130001, 43.937933661000045],
              [141.65894616000003, 43.98379140800006],
              [141.66716556100005, 44.025091864000046],
              [141.67017662900003, 44.06663646000004],
              [141.65544681100005, 44.27692291900007],
              [141.66570071700005, 44.31273021000004],
              [141.74724368600005, 44.42422109600005],
              [141.79175866000003, 44.596991278000075],
              [141.79607181100005, 44.64175039300005],
              [141.78345787900003, 44.76536692900004],
              [141.75359134200005, 44.88544342700004],
              [141.72185306100005, 44.955145575000074],
              [141.5864363940001, 45.16437409100007],
              [141.57488040500004, 45.20685455900008],
              [141.58375084700003, 45.251166083000044],
              [141.58969160200002, 45.25820547100005],
              [141.6098738940001, 45.27586497600004],
              [141.61784915500004, 45.28534577000005],
              [141.62256920700008, 45.29596588700008],
              [141.62468509200005, 45.30548737200007],
              [141.62769616000003, 45.31439850500004],
              [141.64918053500003, 45.341009833000044],
              [141.65015709700003, 45.35736725500004],
              [141.639008009, 45.38898346600007],
              [141.637054884, 45.40444570500006],
              [141.63941491000003, 45.421128648000035],
              [141.64795983200008, 45.437201239000046],
              [141.66570071700005, 45.450425523000035],
              [141.67725670700008, 45.44432200700004],
              [141.6836043630001, 45.43618398600006],
              [141.68628991000003, 45.42552317900004],
              [141.68677819100003, 45.41229889500005],
              [141.69214928500003, 45.40228913000004],
              [141.704437696, 45.40208567900004],
              [141.72771243600005, 45.40888092700004],
              [141.77409915500004, 45.41290924700007],
              [141.8232528000001, 45.42255280200004],
              [141.85759524800005, 45.440334377000056],
              [141.86841881600003, 45.443019924000055],
              [141.875336134, 45.44818756700005],
              [141.87720787900003, 45.460191148000035],
              [141.87720787900003, 45.473863023000035],
              [141.87867272200003, 45.484035549000055],
              [141.893890821, 45.50055573100008],
              [141.91944420700008, 45.51585521000004],
              [141.94499759200005, 45.520412502000056],
              [141.96045983200008, 45.51023997600004],
              [141.9775496750001, 45.48078034100007],
              [141.98755944100003, 45.46849192900004],
              [142.00180097700002, 45.46344635600008],
              [142.01775149800005, 45.45571523600006],
              [142.0566512380001, 45.402044989000046],
              [142.09652754, 45.372300523000035],
              [142.18311608200008, 45.32599518400008],
              [142.2212020190001, 45.29962799700007],
              [142.53931725400003, 45.018459377000056],
              [142.6142684250001, 44.90387604400007],
              [142.63070722700002, 44.88373444200005],
              [142.66570071700005, 44.86664459800005],
              [142.71404056100005, 44.80621979400007],
              [142.90748131600003, 44.64740631700005],
              [142.939789259, 44.63471100500004],
              [142.9814559250001, 44.58649323100008],
              [143.04273522200003, 44.55491771000004],
              [143.11841881600003, 44.49689362200007],
              [143.204437696, 44.447251695000034],
              [143.22486412900003, 44.44245026200008],
              [143.2407332690001, 44.43634674700007],
              [143.27857506600003, 44.40615469000005],
              [143.2968856130001, 44.39468008000006],
              [143.34009850400003, 44.38654205900008],
              [143.35141035200002, 44.38104889500005],
              [143.368500196, 44.35138580900008],
              [143.3691512380001, 44.34625885600008],
              [143.3964949880001, 44.32294342700004],
              [143.4052840500001, 44.31745026200008],
              [143.55241946700005, 44.25250885600008],
              [143.77662194100003, 44.18927643400008],
              [143.77662194100003, 44.18235911700003],
              [143.6953231130001, 44.18984609600005],
              [143.68043053500003, 44.18235911700003],
              [143.68506920700008, 44.17593008000006],
              [143.7089949880001, 44.157863674000055],
              [143.71461022200003, 44.15135325700004],
              [143.72828209700003, 44.11347077000005],
              [143.73845462300005, 44.11798737200007],
              [143.74244225400003, 44.12091705900008],
              [143.75709069100003, 44.11017487200007],
              [143.76970462300005, 44.10374583500004],
              [143.7832137380001, 44.10065338700008],
              [143.9296981130001, 44.098944403000075],
              [143.93775475400003, 44.09642161700003],
              [143.96607506600003, 44.12006256700005],
              [143.98324629, 44.12995026200008],
              [143.99919681100005, 44.133978583000044],
              [144.11931399800005, 44.12905508000006],
              [144.15308678500003, 44.117254950000074],
              [144.17172285200002, 44.10602448100008],
              [144.17156009200005, 44.102728583000044],
              [144.1587020190001, 44.10065338700008],
              [144.14039147200003, 44.093003648000035],
              [144.12680097700002, 44.080145575000074],
              [144.1054793630001, 44.03156159100007],
              [144.13835696700005, 44.020697333000044],
              [144.1528426440001, 44.01984284100007],
              [144.1670028000001, 44.025376695000034],
              [144.17758222700002, 44.035223700000074],
              [144.18873131600003, 44.05027903900009],
              [144.197601759, 44.06720612200007],
              [144.2011824880001, 44.082464911000045],
              [144.21509850400003, 44.11147695500006],
              [144.24293053500003, 44.119208075000074],
              [144.26343834700003, 44.10781484600005],
              [144.2558699880001, 44.079413153000075],
              [144.26832116000003, 44.04938385600008],
              [144.2783309250001, 44.036769924000055],
              [144.29371178500003, 44.03156159100007],
              [144.30225670700008, 44.02411530200004],
              [144.31861412900003, 43.99119700700004],
              [144.32781009200005, 43.98379140800006],
              [144.33659915500004, 43.98029205900008],
              [144.3794051440001, 43.95648834800005],
              [144.395355665, 43.950873114000046],
              [144.43043053500003, 43.942572333000044],
              [144.5703231130001, 43.92479075700004],
              [144.74048912900003, 43.91461823100008],
              [144.7880965500001, 43.92177969000005],
              [144.83122806100005, 43.94220612200007],
              [144.947601759, 44.034084377000056],
              [145.03728274800005, 44.11041901200008],
              [145.04851321700005, 44.12213776200008],
              [145.11931399800005, 44.15448639500005],
              [145.16667728000004, 44.19049713700008],
              [145.184906446, 44.19546133000006],
              [145.2016707690001, 44.20579661700003],
              [145.25025475400003, 44.27179596600007],
              [145.28972415500004, 44.298895575000074],
              [145.30974368600005, 44.31635163000004],
              [145.3183699880001, 44.33633047100005],
              [145.3227645190001, 44.341782945000034],
              [145.3320418630001, 44.346136786000045],
              [145.34148196700005, 44.34552643400008],
              [145.34945722700002, 44.32599518400008],
              [145.3671981130001, 44.30288320500006],
              [145.3730574880001, 44.292222398000035],
              [145.37183678500003, 44.24876536700003],
              [145.34986412900003, 44.21161530200004],
              [145.29053795700008, 44.15448639500005],
              [145.27914472700002, 44.13393789300005],
              [145.26921634200005, 44.085150458000044],
              [145.26042728000004, 44.06940338700008],
              [145.16960696700005, 43.98529694200005],
              [145.14429772200003, 43.95294830900008],
              [145.12232506600003, 43.91705963700008],
              [145.10613040500004, 43.88076406500005],
              [145.11597741000003, 43.86245351800005],
              [145.1098738940001, 43.84194570500006],
              [145.098480665, 43.82282135600008],
              [145.089203321, 43.80072663000004],
              [145.0747176440001, 43.786037502000056],
              [145.07146243600005, 43.774603583000044],
              [145.0722762380001, 43.76154205900008],
              [145.0747176440001, 43.75372955900008],
              [145.11597741000003, 43.686835028000075],
              [145.13013756600003, 43.671576239000046],
              [145.19483483200008, 43.62067291900007],
              [145.2075301440001, 43.60687897300005],
              [145.21851647200003, 43.58966705900008],
              [145.22624759200005, 43.56976959800005],
              [145.2290145190001, 43.548041083000044],
              [145.23226972700002, 43.539943752000056],
              [145.24683678500003, 43.530462958000044],
              [145.25212649800005, 43.51430898600006],
              [145.26441491000003, 43.48969147300005],
              [145.29078209700003, 43.40534088700008],
              [145.31169681100005, 43.36676666900007],
              [145.3457137380001, 43.33270905200004],
              [145.3935653000001, 43.30536530200004],
              [145.361664259, 43.30145905200004],
              [145.299164259, 43.34125397300005],
              [145.2700301440001, 43.34638092700004],
              [145.26050866000003, 43.33856842700004],
              [145.2583113940001, 43.32709381700005],
              [145.26449629, 43.31671784100007],
              [145.2802840500001, 43.312201239000046],
              [145.29810631600003, 43.30927155200004],
              [145.31511478000004, 43.30292389500005],
              [145.3208113940001, 43.29596588700008],
              [145.30420983200008, 43.29169342700004],
              [145.321625196, 43.276271877000056],
              [145.35108483200008, 43.26544830900008],
              [145.383636915, 43.259019273000035],
              [145.46843509200005, 43.25299713700008],
              [145.49195397200003, 43.244574286000045],
              [145.51710045700008, 43.22898997600004],
              [145.5219832690001, 43.24119700700004],
              [145.51335696700005, 43.24884674700007],
              [145.501312696, 43.25698476800005],
              [145.4965926440001, 43.27057526200008],
              [145.50310306100005, 43.27753327000005],
              [145.54086347700002, 43.301662502000056],
              [145.58228600400003, 43.33576080900008],
              [145.59489993600005, 43.34284088700008],
              [145.62086022200003, 43.34796784100007],
              [145.6337996750001, 43.353176174000055],
              [145.64031009200005, 43.35976797100005],
              [145.64372806100005, 43.366888739000046],
              [145.64918053500003, 43.37376536700003],
              [145.66163170700008, 43.37982819200005],
              [145.67595462300005, 43.38198476800005],
              [145.7231551440001, 43.37982819200005],
              [145.73161868600005, 43.382025458000044],
              [145.74439537900003, 43.391791083000044],
              [145.750336134, 43.39411041900007],
              [145.75709069100003, 43.39313385600008],
              [145.76148522200003, 43.39081452000005],
              [145.76449629, 43.388373114000046],
              [145.76742597700002, 43.38727448100008],
            ],
          ],
          [
            [
              [123.81470787900003, 24.391750393000052],
              [123.83472741000003, 24.39549388200004],
              [123.87208092500009, 24.39012278900009],
              [123.910492384, 24.37954336100006],
              [123.93441816500001, 24.36749909100007],
              [123.93604576900009, 24.341457424000055],
              [123.91553795700008, 24.30683014500005],
              [123.87305748800009, 24.258246161000045],
              [123.85124759200005, 24.256984768000052],
              [123.74577884200005, 24.28123607000009],
              [123.68344160200002, 24.285305080000057],
              [123.66822350400003, 24.296616929000038],
              [123.68376712300005, 24.323472398000035],
              [123.68767337300005, 24.32050202000005],
              [123.69092858200008, 24.318833726000037],
              [123.69800866000003, 24.31598541900007],
              [123.70704186300009, 24.328680731000077],
              [123.71753991000003, 24.32367584800005],
              [123.72925866000003, 24.315741278000075],
              [123.74236087300005, 24.31972890800006],
              [123.74805748800009, 24.32957591400009],
              [123.75318444100003, 24.364447333000044],
              [123.76531009200005, 24.40110911700009],
              [123.76685631600003, 24.409409898000035],
              [123.769867384, 24.418361721000053],
              [123.77686608200008, 24.419745184000078],
              [123.78492272200003, 24.416083075000074],
              [123.79127037900003, 24.40961334800005],
              [123.81470787900003, 24.391750393000052],
            ],
          ],
          [
            [
              [123.00261478000004, 24.474310614000046],
              [123.01636803500003, 24.46979401200008],
              [123.01823978000004, 24.45929596600007],
              [123.01107832100001, 24.447699286000045],
              [122.998383009, 24.439520575000074],
              [122.98780358200008, 24.443304755000042],
              [122.94752037900003, 24.439520575000074],
              [122.93864993600005, 24.444240627000056],
              [122.93816165500004, 24.454820054000038],
              [122.94459069100003, 24.46625397300005],
              [122.95557701900009, 24.473130601000037],
              [122.96794681100005, 24.471177476000037],
              [123.00261478000004, 24.474310614000046],
            ],
          ],
          [
            [
              [124.32911217500009, 24.58356354400007],
              [124.33228600400003, 24.57103099200009],
              [124.32691491000003, 24.56118398600006],
              [124.31902103000004, 24.55304596600007],
              [124.30909264400009, 24.534857489000046],
              [124.27393639400009, 24.487941799000055],
              [124.26050866000003, 24.445257880000042],
              [124.25391686300009, 24.40180084800005],
              [124.24187259200005, 24.363714911000045],
              [124.21192467500009, 24.337103583000044],
              [124.17701256600003, 24.33299388200004],
              [124.14031009200005, 24.34198639500005],
              [124.12224368600005, 24.360581773000035],
              [124.14307701900009, 24.384914455000057],
              [124.13257897200003, 24.39199453300006],
              [124.12875410200002, 24.403550523000035],
              [124.12273196700005, 24.41429271000004],
              [124.10572350400003, 24.419094143000052],
              [124.08863366000003, 24.421942450000074],
              [124.07789147200003, 24.42845286700009],
              [124.07837975400003, 24.435492255000042],
              [124.09522545700008, 24.439520575000074],
              [124.10173587300005, 24.446600653000075],
              [124.11231530000009, 24.463364976000037],
              [124.11622155000009, 24.46747467700004],
              [124.12916100400003, 24.46938711100006],
              [124.13298587300005, 24.464016018000052],
              [124.13445071700005, 24.456773179000038],
              [124.13990319100003, 24.453192450000074],
              [124.14795983200008, 24.44635651200008],
              [124.15650475400003, 24.44163646000004],
              [124.16781660200002, 24.439520575000074],
              [124.19125410200002, 24.440008856000077],
              [124.20215905000009, 24.442206122000073],
              [124.21192467500009, 24.446966864000046],
              [124.22242272200003, 24.461004950000074],
              [124.23031660200002, 24.47915273600006],
              [124.24024498800009, 24.49485911700009],
              [124.25660241000003, 24.501613674000055],
              [124.26840254000001, 24.51044342700004],
              [124.30062910200002, 24.56989166900007],
              [124.31446373800009, 24.58730703300006],
              [124.32129967500009, 24.590277411000045],
              [124.32911217500009, 24.58356354400007],
            ],
          ],
          [
            [
              [141.357758009, 24.789618231000077],
              [141.36548912900003, 24.777736721000053],
              [141.35726972700002, 24.77342357000009],
              [141.34262129, 24.77212148600006],
              [141.3305770190001, 24.76911041900007],
              [141.3203231130001, 24.758612372000073],
              [141.30258222700002, 24.73436107000009],
              [141.2895613940001, 24.726955471000053],
              [141.28980553500003, 24.760239976000037],
              [141.29265384200005, 24.773871161000045],
              [141.29948978000004, 24.78587474200009],
              [141.31169681100005, 24.791815497000073],
              [141.33025149800005, 24.794094143000052],
              [141.347992384, 24.793117580000057],
              [141.357758009, 24.789618231000077],
            ],
          ],
          [
            [
              [125.38721764400009, 24.782171942000048],
              [125.404633009, 24.77838776200008],
              [125.42628014400009, 24.768866278000075],
              [125.44483483200008, 24.756740627000056],
              [125.45264733200008, 24.744940497000073],
              [125.44402103000004, 24.737209377000056],
              [125.42351321700005, 24.732245184000078],
              [125.38379967500009, 24.726955471000053],
              [125.29965254000001, 24.72565338700008],
              [125.25879967500009, 24.73338450700004],
              [125.25684655000009, 24.751695054000038],
              [125.26148522200003, 24.76386139500005],
              [125.27393639400009, 24.820013739000046],
              [125.27475019600001, 24.85643138200004],
              [125.27100670700008, 24.86782461100006],
              [125.26026451900009, 24.885199286000045],
              [125.26246178500003, 24.88434479400007],
              [125.27442467500009, 24.88222890800006],
              [125.28516686300009, 24.877346096000053],
              [125.29021243600005, 24.873928127000056],
              [125.29444420700008, 24.869574286000045],
              [125.30225670700008, 24.857570705000057],
              [125.31421959700003, 24.829901434000078],
              [125.32162519600001, 24.816880601000037],
              [125.32667076900009, 24.81073639500005],
              [125.35824629000001, 24.78261953300006],
              [125.365570509, 24.77993398600006],
              [125.38721764400009, 24.782171942000048],
            ],
          ],
          [
            [
              [131.25513756600003, 25.87498607000009],
              [131.27711022200003, 25.85838450700004],
              [131.2705184250001, 25.853664455000057],
              [131.2641707690001, 25.84634023600006],
              [131.25928795700008, 25.837225653000075],
              [131.25733483200008, 25.827093817000048],
              [131.2524520190001, 25.81903717700004],
              [131.24146569100003, 25.818752346000053],
              [131.23072350400003, 25.82168203300006],
              [131.21208743600005, 25.829046942000048],
              [131.21273847700002, 25.841457424000055],
              [131.2212020190001, 25.85569896000004],
              [131.23609459700003, 25.87205638200004],
              [131.24105879, 25.87567780200004],
              [131.2470809250001, 25.87685781500005],
              [131.25513756600003, 25.87498607000009],
            ],
          ],
          [
            [
              [126.81006920700008, 26.35187409100007],
              [126.81031334700003, 26.34251536700009],
              [126.80738366000003, 26.332586981000077],
              [126.80209394600001, 26.323553778000075],
              [126.79574629000001, 26.31712474200009],
              [126.79371178500003, 26.312892971000053],
              [126.79509524800005, 26.30890534100007],
              [126.79517662900003, 26.305609442000048],
              [126.78891035200002, 26.30345286700009],
              [126.78239993600005, 26.304510809000078],
              [126.77540123800009, 26.308539130000042],
              [126.77003014400009, 26.314195054000038],
              [126.76783287900003, 26.32054271000004],
              [126.75993899800005, 26.334418036000045],
              [126.74146569100003, 26.34170156500005],
              [126.71998131600003, 26.346991278000075],
              [126.70362389400009, 26.355292059000078],
              [126.69776451900009, 26.36904531500005],
              [126.70679772200003, 26.37913646000004],
              [126.72364342500009, 26.385972398000035],
              [126.74170983200008, 26.38971588700008],
              [126.75212649800005, 26.390692450000074],
              [126.769867384, 26.388006903000075],
              [126.78711998800009, 26.380072333000044],
              [126.80144290500004, 26.367661851000037],
              [126.81006920700008, 26.35187409100007],
            ],
          ],
          [
            [
              [142.19320722700002, 26.64606354400007],
              [142.18140709700003, 26.644232489000046],
              [142.17554772200003, 26.63865794500009],
              [142.17505944100003, 26.630072333000044],
              [142.1801863940001, 26.618801174000055],
              [142.15992272200003, 26.632025458000044],
              [142.139008009, 26.662502346000053],
              [142.1113387380001, 26.721177476000037],
              [142.1176863940001, 26.72174713700008],
              [142.122406446, 26.720445054000038],
              [142.1318465500001, 26.714992580000057],
              [142.1357528000001, 26.706691799000055],
              [142.14323978000004, 26.70221588700008],
              [142.15349368600005, 26.70066966400009],
              [142.16586347700002, 26.701320705000057],
              [142.16586347700002, 26.694525458000044],
              [142.1543074880001, 26.686468817000048],
              [142.155609571, 26.67914459800005],
              [142.16578209700003, 26.674383856000077],
              [142.1801863940001, 26.67401764500005],
              [142.1801863940001, 26.666571356000077],
              [142.17554772200003, 26.663234768000052],
              [142.1748153000001, 26.66152578300006],
              [142.17505944100003, 26.659084377000056],
              [142.172699415, 26.653509833000044],
              [142.18181399800005, 26.657171942000048],
              [142.18620853000004, 26.657904364000046],
              [142.18913821700005, 26.65452708500004],
              [142.19320722700002, 26.64606354400007],
            ],
          ],
          [
            [
              [128.33765709700003, 26.796942450000074],
              [128.333343946, 26.793036200000074],
              [128.33025149800005, 26.787258205000057],
              [128.32984459700003, 26.78034088700008],
              [128.33423912900003, 26.77301666900007],
              [128.33765709700003, 26.76430898600006],
              [128.333343946, 26.756659247000073],
              [128.32683353000004, 26.750474351000037],
              [128.32341556100005, 26.746039130000042],
              [128.30974368600005, 26.721177476000037],
              [128.30884850400003, 26.71775950700004],
              [128.30974368600005, 26.704738674000055],
              [128.30811608200008, 26.700873114000046],
              [128.30420983200008, 26.701320705000057],
              [128.29997806100005, 26.70258209800005],
              [128.29664147200003, 26.701320705000057],
              [128.26441491000003, 26.652411200000074],
              [128.24333743600005, 26.633286851000037],
              [128.217133009, 26.62563711100006],
              [128.172211134, 26.623480536000045],
              [128.15886478000004, 26.618801174000055],
              [128.15162194100003, 26.612453518000052],
              [128.14283287900003, 26.60175202000005],
              [128.1352645190001, 26.59007396000004],
              [128.13209069100003, 26.581244208000044],
              [128.13502037900003, 26.577948309000078],
              [128.14087975400003, 26.576727606000077],
              [128.14576256600003, 26.573431708000044],
              [128.14519290500004, 26.564113674000055],
              [128.14177493600005, 26.556586005000042],
              [128.13835696700005, 26.554022528000075],
              [128.13306725400003, 26.553208726000037],
              [128.108734571, 26.54515208500004],
              [128.0903426440001, 26.542669989000046],
              [128.071625196, 26.54401276200008],
              [128.05591881600003, 26.550482489000046],
              [128.03638756600003, 26.52732982000009],
              [127.98414147200003, 26.478461005000042],
              [127.97201582100001, 26.471869208000044],
              [127.95997155000009, 26.470851955000057],
              [127.95093834700003, 26.46670156500005],
              [127.94727623800009, 26.45115794500009],
              [127.94027754000001, 26.447739976000037],
              [127.87061608200008, 26.447414455000057],
              [127.85987389400009, 26.44562409100007],
              [127.85173587300005, 26.441229559000078],
              [127.83887780000009, 26.42523834800005],
              [127.84302819100003, 26.41746653900009],
              [127.85474694100003, 26.412990627000056],
              [127.86475670700008, 26.40648021000004],
              [127.86980228000004, 26.393459377000056],
              [127.873383009, 26.36481354400007],
              [127.87826582100001, 26.35187409100007],
              [127.88884524800005, 26.339097398000035],
              [127.91016686300009, 26.323065497000073],
              [127.91993248800009, 26.30963776200008],
              [127.90186608200008, 26.30499909100007],
              [127.88209069100003, 26.31073639500005],
              [127.86150149800005, 26.31940338700008],
              [127.84083092500009, 26.323919989000046],
              [127.82829837300005, 26.316229559000078],
              [127.77751712300005, 26.233343817000048],
              [127.77100670700008, 26.216498114000046],
              [127.76840254000001, 26.197658596000053],
              [127.77540123800009, 26.18512604400007],
              [127.79151451900009, 26.185492255000042],
              [127.80990644600001, 26.189195054000038],
              [127.82357832100001, 26.186753648000035],
              [127.81421959700003, 26.16592031500005],
              [127.79688561300009, 26.13971588700008],
              [127.775726759, 26.12177155200004],
              [127.75489342500009, 26.12531159100007],
              [127.74170983200008, 26.115627346000053],
              [127.72535241000003, 26.089585679000038],
              [127.71013431100005, 26.084377346000053],
              [127.65170332100001, 26.084377346000053],
              [127.65707441500001, 26.12177155200004],
              [127.63591556100005, 26.191351630000042],
              [127.63819420700008, 26.21474844000005],
              [127.65845787900003, 26.21234772300005],
              [127.67774498800009, 26.230617580000057],
              [127.69263756600003, 26.256252346000053],
              [127.70020592500009, 26.27610911700009],
              [127.71827233200008, 26.27407461100006],
              [127.73129316500001, 26.28937409100007],
              [127.73910566500001, 26.30923086100006],
              [127.74187259200005, 26.32054271000004],
              [127.738617384, 26.341457424000055],
              [127.72437584700003, 26.38544342700004],
              [127.72071373800009, 26.40648021000004],
              [127.72250410200002, 26.42991771000004],
              [127.73129316500001, 26.439886786000045],
              [127.74773196700005, 26.441839911000045],
              [127.78109785200002, 26.441229559000078],
              [127.79371178500003, 26.442694403000075],
              [127.80518639400009, 26.44757721600007],
              [127.81006920700008, 26.45799388200004],
              [127.81373131600003, 26.45799388200004],
              [127.82878665500004, 26.48305898600006],
              [127.83057701900009, 26.488430080000057],
              [127.86426842500009, 26.505682684000078],
              [127.902679884, 26.516424872000073],
              [127.93751061300009, 26.532131252000056],
              [127.96021569100003, 26.564113674000055],
              [127.96241295700008, 26.581976630000042],
              [127.95590254000001, 26.59479401200008],
              [127.94060306100005, 26.602484442000048],
              [127.89429772200003, 26.60927969000005],
              [127.88559004000001, 26.62018463700008],
              [127.88477623800009, 26.635687567000048],
              [127.88575280000009, 26.653509833000044],
              [127.87794030000009, 26.68659088700008],
              [127.87826582100001, 26.694525458000044],
              [127.88542728000004, 26.696112372000073],
              [127.91993248800009, 26.694525458000044],
              [127.96461022200003, 26.69717031500005],
              [127.98731530000009, 26.69293854400007],
              [128.00123131600003, 26.680243231000077],
              [127.99952233200008, 26.671820380000042],
              [127.992523634, 26.663275458000044],
              [127.98853600400003, 26.65298086100006],
              [127.99561608200008, 26.639227606000077],
              [128.0044051440001, 26.63475169500009],
              [128.01490319100003, 26.634833075000074],
              [128.05738366000003, 26.64476146000004],
              [128.11109459700003, 26.67401764500005],
              [128.10328209700003, 26.691229559000078],
              [128.1113387380001, 26.70343659100007],
              [128.1523543630001, 26.73151276200008],
              [128.15699303500003, 26.737127997000073],
              [128.16195722700002, 26.757147528000075],
              [128.16920006600003, 26.76117584800005],
              [128.176117384, 26.762518622000073],
              [128.17945397200003, 26.76585521000004],
              [128.1879988940001, 26.780503648000035],
              [128.225922071, 26.80097077000005],
              [128.23462975400003, 26.81395091400009],
              [128.23853600400003, 26.832424221000053],
              [128.2544051440001, 26.864406643000052],
              [128.25505618600005, 26.88629791900007],
              [128.331390821, 26.813421942000048],
              [128.33765709700003, 26.796942450000074],
            ],
          ],
          [
            [
              [142.19320722700002, 27.091742255000042],
              [142.20655358200008, 27.09711334800005],
              [142.22087649800005, 27.09833405200004],
              [142.23324629, 27.094305731000077],
              [142.24105879, 27.08429596600007],
              [142.23462975400003, 27.050034898000035],
              [142.21851647200003, 27.040350653000075],
              [142.198578321, 27.05109284100007],
              [142.1801863940001, 27.078070380000042],
              [142.21436608200008, 27.063788153000075],
              [142.21070397200003, 27.072821356000077],
              [142.2055770190001, 27.080959377000056],
              [142.199554884, 27.08746979400007],
              [142.19320722700002, 27.091742255000042],
            ],
          ],
          [
            [
              [128.70069420700008, 27.454820054000038],
              [128.702484571, 27.451605536000045],
              [128.70281009200005, 27.45075104400007],
              [128.703461134, 27.450425523000035],
              [128.70687910200002, 27.44863515800006],
              [128.697601759, 27.43573639500005],
              [128.66976972700002, 27.421087958000044],
              [128.65577233200008, 27.41014232000009],
              [128.64047285200002, 27.38467031500005],
              [128.63070722700002, 27.37567780200004],
              [128.6181746750001, 27.379706122000073],
              [128.61312910200002, 27.36432526200008],
              [128.60474694100003, 27.361802476000037],
              [128.59546959700003, 27.36391836100006],
              [128.58741295700008, 27.36204661700009],
              [128.57447350400003, 27.353338934000078],
              [128.559906446, 27.350734768000052],
              [128.5454207690001, 27.35374583500004],
              [128.53248131600003, 27.36204661700009],
              [128.52686608200008, 27.371893622000073],
              [128.52515709700003, 27.38467031500005],
              [128.52613366000003, 27.39716217700004],
              [128.52881920700008, 27.40643952000005],
              [128.53386478000004, 27.415269273000035],
              [128.538422071, 27.417629299000055],
              [128.54656009200005, 27.41787344000005],
              [128.5615340500001, 27.420396226000037],
              [128.60027103000004, 27.415350653000075],
              [128.61882571700005, 27.41559479400007],
              [128.6352645190001, 27.423773505000042],
              [128.6504012380001, 27.434719143000052],
              [128.70069420700008, 27.454820054000038],
            ],
          ],
          [
            [
              [128.9887801440001, 27.811102606000077],
              [128.99952233200008, 27.802801825000074],
              [129.01319420700008, 27.79523346600007],
              [129.02466881600003, 27.786078192000048],
              [129.029633009, 27.773260809000078],
              [129.024261915, 27.75657786700009],
              [129.00025475400003, 27.727728583000044],
              [128.98951256600003, 27.707464911000045],
              [128.97632897200003, 27.69550202000005],
              [128.96070397200003, 27.68577708500004],
              [128.94703209700003, 27.681382554000038],
              [128.92945397200003, 27.686712958000044],
              [128.9218856130001, 27.700913804000038],
              [128.919281446, 27.71556224200009],
              [128.916351759, 27.722357489000046],
              [128.8945418630001, 27.728216864000046],
              [128.89087975400003, 27.741888739000046],
              [128.899261915, 27.76951732000009],
              [128.8789168630001, 27.824774481000077],
              [128.88428795700008, 27.836859442000048],
              [128.88851972700002, 27.853176174000055],
              [128.8945418630001, 27.89130280200004],
              [128.89991295700008, 27.89590078300006],
              [128.91521243600005, 27.900336005000042],
              [128.94703209700003, 27.914129950000074],
              [128.96550540500004, 27.894354559000078],
              [128.97730553500003, 27.83661530200004],
              [128.9887801440001, 27.811102606000077],
            ],
          ],
          [
            [
              [129.29664147200003, 28.119574286000045],
              [129.325531446, 28.123480536000045],
              [129.34734134200005, 28.10691966400009],
              [129.35043379, 28.086493231000077],
              [129.32398522200003, 28.078599351000037],
              [129.30640709700003, 28.094142971000053],
              [129.30347741000003, 28.09601471600007],
              [129.3007918630001, 28.100531317000048],
              [129.29517662900003, 28.09906647300005],
              [129.29053795700008, 28.09516022300005],
              [129.290375196, 28.092922268000052],
              [129.29070071700005, 28.088812567000048],
              [129.28541100400003, 28.08148834800005],
              [129.27914472700002, 28.077093817000048],
              [129.27613366000003, 28.08201732000009],
              [129.27361087300005, 28.083319403000075],
              [129.26392662900003, 28.09634023600006],
              [129.263031446, 28.09910716400009],
              [129.25180097700002, 28.100002346000053],
              [129.23064212300005, 28.09666575700004],
              [129.22144616000003, 28.09910716400009],
              [129.218109571, 28.10610586100006],
              [129.21599368600005, 28.13084544500009],
              [129.21412194100003, 28.14008209800005],
              [129.18702233200008, 28.174994208000044],
              [129.18083743600005, 28.190252997000073],
              [129.1958113940001, 28.195461330000057],
              [129.22771243600005, 28.195257880000042],
              [129.22152754, 28.17601146000004],
              [129.23259524800005, 28.170721747000073],
              [129.26929772200003, 28.17487213700008],
              [129.26392662900003, 28.16738515800006],
              [129.25603274800005, 28.15916575700004],
              [129.2504988940001, 28.15102773600006],
              [129.25180097700002, 28.143784898000035],
              [129.2641707690001, 28.134711005000042],
              [129.28777103000004, 28.12518952000005],
              [129.29664147200003, 28.119574286000045],
            ],
          ],
          [
            [
              [130.0302840500001, 28.373480536000045],
              [130.03101647200003, 28.35651276200008],
              [130.0214949880001, 28.331284898000035],
              [130.00766035200002, 28.30654531500005],
              [129.995453321, 28.29092031500005],
              [129.97820071700005, 28.283758856000077],
              [129.95655358200008, 28.284816799000055],
              [129.91358483200008, 28.29710521000004],
              [129.9755965500001, 28.34324778900009],
              [130.01832116000003, 28.36465078300006],
              [130.0302840500001, 28.373480536000045],
            ],
          ],
          [
            [
              [129.7075301440001, 28.462144273000035],
              [129.7114363940001, 28.455633856000077],
              [129.7172957690001, 28.45026276200008],
              [129.7216903000001, 28.44403717700004],
              [129.721039259, 28.434881903000075],
              [129.71599368600005, 28.42914459800005],
              [129.70850670700008, 28.42877838700008],
              [129.700531446, 28.42999909100007],
              [129.6938582690001, 28.42869700700004],
              [129.6816512380001, 28.421087958000044],
              [129.63941491000003, 28.40534088700008],
              [129.62525475400003, 28.402736721000053],
              [129.61931399800005, 28.400783596000053],
              [129.61687259200005, 28.39647044500009],
              [129.6152449880001, 28.389593817000048],
              [129.61117597700002, 28.38312409100007],
              [129.601898634, 28.38031647300005],
              [129.58155358200008, 28.37067291900007],
              [129.55396569100003, 28.32843659100007],
              [129.53345787900003, 28.318833726000037],
              [129.53003991000003, 28.31476471600007],
              [129.49887129, 28.287502346000053],
              [129.4873153000001, 28.282538153000075],
              [129.46119225400003, 28.29169342700004],
              [129.44743899800005, 28.29092031500005],
              [129.45484459700003, 28.27724844000005],
              [129.4477645190001, 28.26630280200004],
              [129.43962649800005, 28.259019273000035],
              [129.43043053500003, 28.25409577000005],
              [129.42017662900003, 28.249945380000042],
              [129.4316512380001, 28.241034247000073],
              [129.45687910200002, 28.225734768000052],
              [129.46794681100005, 28.215765692000048],
              [129.41521243600005, 28.18573639500005],
              [129.40650475400003, 28.184475002000056],
              [129.40154056100005, 28.163316148000035],
              [129.3886824880001, 28.16282786700009],
              [129.3711043630001, 28.167222398000035],
              [129.35181725400003, 28.160549221000053],
              [129.36443118600005, 28.154038804000038],
              [129.37452233200008, 28.14004140800006],
              [129.3794051440001, 28.12596263200004],
              [129.3759871750001, 28.119574286000045],
              [129.3657332690001, 28.123195705000057],
              [129.33757571700005, 28.14752838700008],
              [129.28663170700008, 28.17792389500005],
              [129.2802840500001, 28.19049713700008],
              [129.28142337300005, 28.204820054000038],
              [129.28077233200008, 28.218573309000078],
              [129.26929772200003, 28.229437567000048],
              [129.2563582690001, 28.214667059000078],
              [129.24244225400003, 28.21430084800005],
              [129.207855665, 28.229437567000048],
              [129.17359459700003, 28.236070054000038],
              [129.15894616000003, 28.240627346000053],
              [129.14576256600003, 28.249945380000042],
              [129.14576256600003, 28.25617096600007],
              [129.15447024800005, 28.260321356000077],
              [129.16285241000003, 28.262640692000048],
              [129.17139733200008, 28.261664130000042],
              [129.180511915, 28.25617096600007],
              [129.20883222700002, 28.264227606000077],
              [129.24138431100005, 28.256333726000037],
              [129.270843946, 28.25535716400009],
              [129.290375196, 28.284084377000056],
              [129.25367272200003, 28.28457265800006],
              [129.23951256600003, 28.290350653000075],
              [129.22771243600005, 28.30459219000005],
              [129.24146569100003, 28.312567450000074],
              [129.2524520190001, 28.321519273000035],
              [129.26392662900003, 28.32884349200009],
              [129.28825931100005, 28.33307526200008],
              [129.29566491000003, 28.336371161000045],
              [129.31625410200002, 28.350165106000077],
              [129.3305770190001, 28.363714911000045],
              [129.33130944100003, 28.366034247000073],
              [129.35726972700002, 28.368353583000044],
              [129.38062584700003, 28.36676666900007],
              [129.39958743600005, 28.37173086100006],
              [129.41334069100003, 28.39329661700009],
              [129.43230228000004, 28.38690827000005],
              [129.45093834700003, 28.39203522300005],
              [129.466156446, 28.404852606000077],
              [129.47535241000003, 28.42129140800006],
              [129.4824324880001, 28.411037502000056],
              [129.4926863940001, 28.404852606000077],
              [129.5044051440001, 28.39988841400009],
              [129.51636803500003, 28.39329661700009],
              [129.53345787900003, 28.430487372000073],
              [129.56080162900003, 28.451117255000042],
              [129.62623131600003, 28.48273346600007],
              [129.61394290500004, 28.44798411700009],
              [129.61646569100003, 28.43854401200008],
              [129.63249759200005, 28.434881903000075],
              [129.64405358200008, 28.43976471600007],
              [129.6543074880001, 28.45213450700004],
              [129.67335045700008, 28.48273346600007],
              [129.67253665500004, 28.487616278000075],
              [129.668793165, 28.495062567000048],
              [129.66724694100003, 28.50299713700008],
              [129.67310631600003, 28.509833075000074],
              [129.68775475400003, 28.508978583000044],
              [129.69800866000003, 28.49485911700009],
              [129.7075301440001, 28.462144273000035],
            ],
          ],
          [
            [
              [129.7148543630001, 29.65452708500004],
              [129.74594160200002, 29.661037502000056],
              [129.75375410200002, 29.645412502000056],
              [129.74382571700005, 29.622300523000035],
              [129.721039259, 29.60614655200004],
              [129.7129012380001, 29.629299221000053],
              [129.7114363940001, 29.642523505000042],
              [129.7148543630001, 29.65452708500004],
            ],
          ],
          [
            [
              [129.8935653000001, 29.874741929000038],
              [129.89741851200006, 29.846915495000076],
              [129.92725670700008, 29.825873114000046],
              [129.92212975400003, 29.823146877000056],
              [129.9204207690001, 29.819647528000075],
              [129.86340189200007, 29.82460653000004],
              [129.85234765200005, 29.83923431800008],
              [129.840184754, 29.84972943000008],
              [129.83277226500002, 29.873077651000074],
              [129.85098067800004, 29.886729695000042],
              [129.875336134, 29.87832265800006],
              [129.87956790500004, 29.87913646000004],
              [129.88404381600003, 29.878892320000034],
              [129.8886824880001, 29.877508856000077],
              [129.8935653000001, 29.874741929000038],
            ],
          ],
          [
            [
              [130.67457116000003, 30.37457916900007],
              [130.66944420700008, 30.339667059000078],
              [130.64714603000004, 30.29051341400009],
              [130.60375105100002, 30.252468518000057],
              [130.57727971400004, 30.23590585900007],
              [130.54682984500005, 30.231416228000057],
              [130.517719671, 30.22749239400008],
              [130.48597745300003, 30.22577701000006],
              [130.4377132080001, 30.238970153000082],
              [130.4271399380001, 30.255535937000047],
              [130.41063389300007, 30.29155631900005],
              [130.38626403800004, 30.339605661000064],
              [130.37901254000008, 30.36587568500005],
              [130.376246508, 30.394435997000073],
              [130.38648522200003, 30.398138739000046],
              [130.42336102800004, 30.398968251000042],
              [130.44117272200003, 30.422308661000045],
              [130.4611824100001, 30.441141568000035],
              [130.467118926, 30.45722526700007],
              [130.48834512500002, 30.457026279000047],
              [130.4989507360001, 30.467962261000082],
              [130.52369225400003, 30.449652411000045],
              [130.56782501700002, 30.435941711000055],
              [130.59958849400005, 30.41245819800008],
              [130.6386781760001, 30.40266076900008],
              [130.67457116000003, 30.37457916900007],
            ],
          ],
          [
            [
              [131.05201256600003, 30.840236721000053],
              [131.06153821600003, 30.840587948000064],
              [131.06240698400006, 30.824528995000037],
              [131.073594694, 30.79958158100004],
              [131.087933572, 30.782606299000065],
              [131.07120798000005, 30.76930179900006],
              [131.070968966, 30.737329878000082],
              [131.07893733100002, 30.699084278000043],
              [131.05376059500009, 30.661867794000045],
              [131.0578028970001, 30.64233795000007],
              [131.05761514300002, 30.611269028000038],
              [131.05131930700009, 30.597092024000062],
              [131.037847983, 30.58917133600005],
              [131.03769896100005, 30.572294187000068],
              [131.0355637560001, 30.557209431000047],
              [131.01791169, 30.551088098000037],
              [131.00340350800002, 30.55116662200004],
              [130.99403411700007, 30.532571782000048],
              [130.98263885900008, 30.519305321000047],
              [130.98047401100007, 30.49709550500006],
              [130.96696052800007, 30.479399958000045],
              [130.96789930600005, 30.464294822000056],
              [130.9647533760001, 30.456319105000034],
              [130.9729538260001, 30.449170034000076],
              [130.97803086800002, 30.43759680100004],
              [130.97176863900006, 30.42608701200004],
              [130.96963857800006, 30.41543863600009],
              [130.97779709100007, 30.400280234000036],
              [130.96328212800006, 30.386143668000045],
              [130.96217717500008, 30.372808183000075],
              [130.9436506090001, 30.37468118600009],
              [130.92408287900003, 30.369533596000053],
              [130.90651933000004, 30.366014516000064],
              [130.89101960900007, 30.35542132200004],
              [130.88581760500006, 30.34385066400006],
              [130.87038107900003, 30.343904295000073],
              [130.86734562800007, 30.353699646000052],
              [130.857117893, 30.36619154600004],
              [130.86027567600001, 30.37952507300008],
              [130.8655153950001, 30.397292703000062],
              [130.86257151000007, 30.42394700300008],
              [130.8533975470001, 30.440830762000076],
              [130.84938214600004, 30.46126404200004],
              [130.85149508200004, 30.470143740000083],
              [130.86177144400006, 30.46566283100009],
              [130.870002258, 30.46386097900006],
              [130.8762783420001, 30.480704794000076],
              [130.90113980700005, 30.503691978000063],
              [130.93022119900002, 30.54085964500007],
              [130.94214928500003, 30.56981028900009],
              [130.95093834700003, 30.595038153000075],
              [130.951273786, 30.61001820100006],
              [130.94837684900006, 30.64110939300008],
              [130.94330858700005, 30.654460150000034],
              [130.945430439, 30.664215375000083],
              [130.93929969700002, 30.672251498000037],
              [130.95279689000006, 30.68549581600007],
              [130.96634534600003, 30.701441462000048],
              [130.98513182700003, 30.72977588100008],
              [130.98523937100003, 30.74135231100007],
              [130.99970311700008, 30.745686335000073],
              [131.00813866600004, 30.767864858000053],
              [131.00625712800002, 30.789246757000058],
              [131.02717589000008, 30.819371621000073],
              [131.03923587300005, 30.83144765800006],
              [131.045258009, 30.836859442000048],
              [131.05201256600003, 30.840236721000053],
            ],
          ],
          [
            [
              [130.15308678500003, 32.20376211100006],
              [130.17603600400003, 32.20335521000004],
              [130.18726647200003, 32.19635651200008],
              [130.19410241000003, 32.17641836100006],
              [130.190765821, 32.16461823100008],
              [130.17359459700003, 32.124335028000075],
              [130.167328321, 32.11432526200008],
              [130.149261915, 32.11050039300005],
              [130.13461347700002, 32.11798737200007],
              [130.12777754, 32.13231028900009],
              [130.1333113940001, 32.14911530200004],
              [130.12322024800005, 32.15892161700009],
              [130.11508222700002, 32.175441799000055],
              [130.11109459700003, 32.19330475500004],
              [130.1132918630001, 32.20758698100008],
              [130.1211043630001, 32.21263255400004],
              [130.13200931100005, 32.21133047100005],
              [130.15308678500003, 32.20376211100006],
            ],
          ],
          [
            [
              [130.41000410200002, 32.51162344000005],
              [130.44019616000003, 32.52399323100008],
              [130.4570418630001, 32.52558014500005],
              [130.46851647200003, 32.51162344000005],
              [130.43482506600003, 32.49274323100008],
              [130.39283287900003, 32.39716217700004],
              [130.3623153000001, 32.374986070000034],
              [130.358734571, 32.37995026200008],
              [130.3579207690001, 32.39118073100008],
              [130.35865319100003, 32.41290924700007],
              [130.353851759, 32.42413971600007],
              [130.343109571, 32.42182038000004],
              [130.32447350400003, 32.409816799000055],
              [130.28443444100003, 32.407538153000075],
              [130.26482181100005, 32.403631903000075],
              [130.24195397200003, 32.39549388200004],
              [130.2216903000001, 32.421861070000034],
              [130.21306399800005, 32.43650950700004],
              [130.21363366000003, 32.450425523000035],
              [130.21859785200002, 32.455959377000056],
              [130.2251082690001, 32.458197333000044],
              [130.239105665, 32.460272528000075],
              [130.24789472700002, 32.46458567900004],
              [130.26783287900003, 32.48419830900008],
              [130.29029381600003, 32.49795156500005],
              [130.3051863940001, 32.50405508000006],
              [130.34156334700003, 32.51434967700004],
              [130.36304772200003, 32.52708567900004],
              [130.37094160200002, 32.527044989000046],
              [130.37720787900003, 32.52289459800005],
              [130.37964928500003, 32.515326239000046],
              [130.3833113940001, 32.509426174000055],
              [130.39177493600005, 32.50873444200005],
              [130.41000410200002, 32.51162344000005],
            ],
          ],
          [
            [
              [130.160492384, 32.54633209800005],
              [130.1894637380001, 32.52179596600007],
              [130.19898522200003, 32.480169989000046],
              [130.201508009, 32.39549388200004],
              [130.2041121750001, 32.38764069200005],
              [130.20679772200003, 32.38125234600005],
              [130.208343946, 32.37327708500004],
              [130.2055770190001, 32.34662506700005],
              [130.20337975400003, 32.33885325700004],
              [130.1992293630001, 32.33274974200009],
              [130.19068444100003, 32.323553778000075],
              [130.18140709700003, 32.31826406500005],
              [130.15772545700008, 32.310248114000046],
              [130.15308678500003, 32.30337148600006],
              [130.1333113940001, 32.26512278900009],
              [130.12777754, 32.261419989000046],
              [130.10531660200002, 32.25214264500005],
              [130.09693444100003, 32.245021877000056],
              [130.07496178500003, 32.220770575000074],
              [130.0610457690001, 32.21185944200005],
              [130.03687584700003, 32.19977448100008],
              [130.01197350400003, 32.190619208000044],
              [129.995453321, 32.190659898000035],
              [129.99439537900003, 32.19989655200004],
              [130.009125196, 32.25214264500005],
              [129.99732506600003, 32.24404531500005],
              [129.9863387380001, 32.24437083500004],
              [129.97584069100003, 32.24591705900008],
              [129.958343946, 32.237534898000035],
              [129.9580184250001, 32.24237702000005],
              [129.961273634, 32.25214264500005],
              [129.9653426440001, 32.25820547100005],
              [129.99626712300005, 32.28217194200005],
              [130.0166121750001, 32.29311758000006],
              [130.03012129, 32.29523346600007],
              [130.04216556100005, 32.29450104400007],
              [130.0532332690001, 32.296535549000055],
              [130.06430097700002, 32.30678945500006],
              [130.05420983200008, 32.30695221600007],
              [130.04615319100003, 32.308254299000055],
              [130.0302840500001, 32.31362539300005],
              [130.0087996750001, 32.305894273000035],
              [129.99146569100003, 32.314439195000034],
              [129.97974694100003, 32.33299388200004],
              [129.97527103000004, 32.35541413000004],
              [129.9765731130001, 32.366441148000035],
              [129.9804793630001, 32.37563711100006],
              [129.98698978000004, 32.38296133000006],
              [129.995453321, 32.388657945000034],
              [129.98902428500003, 32.40448639500005],
              [129.99439537900003, 32.42413971600007],
              [130.00652103000004, 32.44403717700004],
              [130.0200301440001, 32.46067942900004],
              [130.0302840500001, 32.482407945000034],
              [130.0254012380001, 32.50214264500005],
              [130.0029403000001, 32.53335195500006],
              [130.01547285200002, 32.53278229400007],
              [130.024750196, 32.52773672100005],
              [130.03296959700003, 32.521918036000045],
              [130.04322350400003, 32.51902903900009],
              [130.05648847700002, 32.521185614000046],
              [130.07691491000003, 32.53099192900004],
              [130.10279381600003, 32.53652578300006],
              [130.12029056100005, 32.54287344000005],
              [130.13982181100005, 32.54767487200007],
              [130.160492384, 32.54633209800005],
            ],
          ],
          [
            [
              [128.87842693200002, 32.673924825000086],
              [128.89371185700008, 32.657617505000076],
              [128.90113366000003, 32.646918036000045],
              [128.90113366000003, 32.64598216400009],
              [128.899261915, 32.64252350500004],
              [128.88093113700006, 32.642359311000064],
              [128.85789915700002, 32.64340912400007],
              [128.81771562400002, 32.63458958800004],
              [128.81548846500004, 32.64681013500007],
              [128.79322350400003, 32.65249258000006],
              [128.7880965500001, 32.648504950000074],
              [128.779633009, 32.64679596600007],
              [128.7758895190001, 32.64252350500004],
              [128.77222741000003, 32.63190338700008],
              [128.77515709700003, 32.62714264500005],
              [128.78012129, 32.62482330900008],
              [128.79495874300005, 32.610093420000055],
              [128.7922283790001, 32.597941535000075],
              [128.79020082700004, 32.58638451500008],
              [128.773110265, 32.57166584300006],
              [128.75538170700008, 32.580511786000045],
              [128.7360418190001, 32.603493841000045],
              [128.71241295700008, 32.60431549700007],
              [128.66285241000003, 32.601548570000034],
              [128.65263104100006, 32.59107501300008],
              [128.61854433500002, 32.60953627500004],
              [128.60043889300005, 32.614177909000034],
              [128.60381873200004, 32.63059803500005],
              [128.61060631600003, 32.64252350500004],
              [128.61353600400003, 32.65021393400008],
              [128.6181746750001, 32.65965403900009],
              [128.62427819100003, 32.667303778000075],
              [128.6318465500001, 32.66986725500004],
              [128.63306725400003, 32.66547272300005],
              [128.63624108200008, 32.643744208000044],
              [128.6386824880001, 32.63515859600005],
              [128.6396590500001, 32.64126211100006],
              [128.652679884, 32.66791413000004],
              [128.6543074880001, 32.67796458500004],
              [128.65455162900003, 32.68886953300006],
              [128.65349368600005, 32.69961172100005],
              [128.65064537900003, 32.70929596600007],
              [128.64795983200008, 32.71385325700004],
              [128.6450301440001, 32.717962958000044],
              [128.6425887380001, 32.72239817900004],
              [128.64226321700005, 32.72801341400009],
              [128.64405358200008, 32.733303127000056],
              [128.6504012380001, 32.74453359600005],
              [128.64176757200005, 32.76138397300008],
              [128.65093959400008, 32.77541308200006],
              [128.66081790500004, 32.78278229400007],
              [128.679047071, 32.782904364000046],
              [128.6857384970001, 32.77091567000008],
              [128.69965289100003, 32.743771302000084],
              [128.705364948, 32.747461232000035],
              [128.72184869, 32.75428343600004],
              [128.7431746750001, 32.75828685100004],
              [128.779223828, 32.776625290000084],
              [128.78412547900007, 32.788181200000054],
              [128.8084903890001, 32.799908412000036],
              [128.81202233200008, 32.782416083000044],
              [128.81080162900003, 32.77488841400009],
              [128.8105574880001, 32.766058661000045],
              [128.82768805500007, 32.761902974000066],
              [128.8422957690001, 32.759466864000046],
              [128.84978274800005, 32.74274323100008],
              [128.842068713, 32.70386139100009],
              [128.85522575700008, 32.68886442000007],
              [128.87842693200002, 32.673924825000086],
            ],
          ],
          [
            [
              [139.7910262380001, 33.13532135600008],
              [139.81316165500004, 33.12376536700009],
              [139.8388778000001, 33.11668528900009],
              [139.8623153000001, 33.10700104400007],
              [139.8774520190001, 33.087591864000046],
              [139.86939537900003, 33.075506903000075],
              [139.84522545700008, 33.04677969000005],
              [139.83578535200002, 33.03978099200009],
              [139.82097415500004, 33.040269273000035],
              [139.80290774800005, 33.04743073100008],
              [139.7876082690001, 33.05841705900008],
              [139.7763778000001, 33.07998281500005],
              [139.74341881600003, 33.11859772300005],
              [139.73975670700008, 33.133246161000045],
              [139.750824415, 33.14524974200009],
              [139.76775149800005, 33.14988841400009],
              [139.7910262380001, 33.13532135600008],
            ],
          ],
          [
            [
              [129.097992384, 32.988267320000034],
              [129.109711134, 32.98289622600004],
              [129.1696282160001, 33.005816536000054],
              [129.18280727800004, 32.984685539000054],
              [129.17595462300005, 32.96698639500005],
              [129.15632505300005, 32.958490107000046],
              [129.1372176440001, 32.93817780200004],
              [129.11754349400007, 32.935841081000035],
              [129.10035241000003, 32.91901276200008],
              [129.09253686500006, 32.90660793700005],
              [129.09055078000006, 32.89147978700004],
              [129.098480665, 32.87514883000006],
              [129.097992384, 32.868475653000075],
              [129.0965722520001, 32.85694237600006],
              [129.08619225400003, 32.85724518400008],
              [129.0679197190001, 32.86118283400009],
              [129.0614950370001, 32.848384242000066],
              [129.068695509, 32.839178778000075],
              [129.06853274800005, 32.82591380400004],
              [129.0649520190001, 32.81781647300005],
              [129.04572282800007, 32.822092732000044],
              [129.04712975400003, 32.841457424000055],
              [129.04041432000008, 32.862728196000035],
              [129.04147538400002, 32.89599958800005],
              [129.0478195170001, 32.909964614000046],
              [129.03305097700002, 32.93333567900004],
              [129.024261915, 32.93789297100005],
              [128.9887801440001, 32.94415924700007],
              [128.97942307000005, 32.94760914500006],
              [128.98146031200008, 32.960351967000065],
              [128.99807570200005, 32.966534179000064],
              [129.02042041900006, 32.980624687000045],
              [129.03503841200006, 32.967404474000034],
              [129.05445397200003, 32.97931549700007],
              [129.04258414900005, 33.00015967200005],
              [129.04862219400002, 33.039602796000054],
              [129.06521060500006, 33.04395398200006],
              [129.067645125, 33.01911582900004],
              [129.07773711800007, 33.02039796300005],
              [129.0839949880001, 33.02338288000004],
              [129.084320509, 33.04319896000004],
              [129.08099664400004, 33.05678184700008],
              [129.085875278, 33.07620750500007],
              [129.10172462800006, 33.08297300600009],
              [129.106619099, 33.101188154000056],
              [129.0985470490001, 33.11449115700009],
              [129.09626241, 33.12537451900005],
              [129.1081802980001, 33.16668808900005],
              [129.11766686500005, 33.15885922700005],
              [129.1163873710001, 33.14065587600004],
              [129.11212829800002, 33.13153491800006],
              [129.1085937680001, 33.12241788400007],
              [129.11590807200002, 33.11397540400009],
              [129.12391110500005, 33.109172923000074],
              [129.118310081, 33.08853075900004],
              [129.11196658400002, 33.070308784000076],
              [129.1027123340001, 33.05449343500004],
              [129.09927084900005, 33.03568710900004],
              [129.09725354, 33.01810575300004],
              [129.097992384, 32.988267320000034],
            ],
          ],
          [
            [
              [129.5556842000001, 33.41080491100007],
              [129.56216330100006, 33.366393867000056],
              [129.55587394100007, 33.35314538100005],
              [129.54202815300005, 33.33567670100007],
              [129.52752846200008, 33.32347747300008],
              [129.5383170030001, 33.31559461200004],
              [129.5263401420001, 33.30338426900005],
              [129.51434189400004, 33.29804494000007],
              [129.51438622800003, 33.288012293000065],
              [129.501148101, 33.28003244000007],
              [129.50247802800004, 33.26525992000006],
              [129.49309512600007, 33.245163286000036],
              [129.44660473600004, 33.19851960500006],
              [129.41259095300006, 33.17831786000005],
              [129.37602131000006, 33.16971922700009],
              [129.35808353000004, 33.176947333000044],
              [129.342500664, 33.179620180000086],
              [129.34496016700007, 33.19019663600005],
              [129.3498690240001, 33.21346751500005],
              [129.3607009320001, 33.19871806800006],
              [129.384781986, 33.183493173000045],
              [129.40015709700003, 33.18569570500006],
              [129.40650475400003, 33.19403717700004],
              [129.40308678500003, 33.19765859600005],
              [129.39600670700008, 33.20258209800005],
              [129.38466500200002, 33.204099875000054],
              [129.3776568840001, 33.21463952800008],
              [129.38200542000004, 33.22891994300005],
              [129.39396140600002, 33.23952590600004],
              [129.41676916100005, 33.23692960500006],
              [129.40843180000002, 33.253823673000056],
              [129.40641102400002, 33.27495079100004],
              [129.43726510800002, 33.296679880000056],
              [129.440896188, 33.325260075000074],
              [129.442662691, 33.34806608900004],
              [129.49512950000008, 33.35829457300008],
              [129.5083096620001, 33.38209177600004],
              [129.515914178, 33.37839513000006],
              [129.52291622400003, 33.36837711800007],
              [129.5393097000001, 33.37948754900009],
              [129.52345591900007, 33.39056654500007],
              [129.52532080700007, 33.40492725000007],
              [129.5556842000001, 33.41080491100007],
            ],
          ],
          [
            [
              [132.24366295700008, 33.79328034100007],
              [132.2524520190001, 33.78534577000005],
              [132.27409915500004, 33.77220286700009],
              [132.27295983200008, 33.76854075700004],
              [132.25733483200008, 33.76601797100005],
              [132.2363387380001, 33.76854075700004],
              [132.204437696, 33.782131252000056],
              [132.188324415, 33.77968984600005],
              [132.1953231130001, 33.79352448100008],
              [132.20875084700003, 33.800116278000075],
              [132.22575931100005, 33.79987213700008],
              [132.24366295700008, 33.79328034100007],
            ],
          ],
          [
            [
              [129.7763778000001, 33.773423570000034],
              [129.79957116000003, 33.764837958000044],
              [129.79965254, 33.75104401200008],
              [129.78386478000004, 33.73818594000005],
              [129.7603788030001, 33.737304520000066],
              [129.73506403500005, 33.73673856400006],
              [129.722767353, 33.71674819700007],
              [129.721039259, 33.69773997600004],
              [129.71045983200008, 33.700832424000055],
              [129.6909566810001, 33.71561246200008],
              [129.67729361500005, 33.72909541000007],
              [129.68116070200006, 33.744217528000036],
              [129.67076324700008, 33.75013909300009],
              [129.657126909, 33.74255478300006],
              [129.64930417100004, 33.756039813000086],
              [129.64665808300003, 33.77277290600006],
              [129.67693118600005, 33.76072825700004],
              [129.68702233200008, 33.75918203300006],
              [129.68702233200008, 33.76601797100005],
              [129.6602833510001, 33.783591931000046],
              [129.658269248, 33.80357374700009],
              [129.6569338810001, 33.81545368900004],
              [129.678401807, 33.81493097400005],
              [129.67314449900005, 33.832217928000034],
              [129.6789520760001, 33.848985077000066],
              [129.68671992200007, 33.85979586600007],
              [129.68864750300008, 33.871145815000034],
              [129.70069420700008, 33.86155833500004],
              [129.76726321700005, 33.84454987200007],
              [129.7680401020001, 33.836650259000066],
              [129.762202774, 33.82313843700007],
              [129.76287179100007, 33.812343646000045],
              [129.76678701100002, 33.80209537200005],
              [129.78109511900004, 33.79239255600004],
              [129.7968856130001, 33.786444403000075],
              [129.79127037900003, 33.78497955900008],
              [129.78191165500004, 33.78115469000005],
              [129.7763778000001, 33.77968984600005],
              [129.7763778000001, 33.773423570000034],
            ],
          ],
          [
            [
              [132.23617597700002, 33.86904531500005],
              [132.23121178500003, 33.86391836100006],
              [132.22641035200002, 33.860663153000075],
              [132.21631920700008, 33.85537344000005],
              [132.20826256600003, 33.87518952000005],
              [132.1933699880001, 33.897650458000044],
              [132.18628991000003, 33.921210028000075],
              [132.20191491000003, 33.94476959800005],
              [132.22608483200008, 33.95270416900007],
              [132.25359134200005, 33.950100002000056],
              [132.27947024800005, 33.94122955900008],
              [132.298187696, 33.93048737200007],
              [132.3261824880001, 33.89630768400008],
              [132.34009850400003, 33.89720286700009],
              [132.35320071700005, 33.90338776200008],
              [132.3740340500001, 33.91681549700007],
              [132.380218946, 33.91754791900007],
              [132.39527428500003, 33.91547272300005],
              [132.40121504, 33.91681549700007],
              [132.407074415, 33.923041083000044],
              [132.40967858200008, 33.93390534100007],
              [132.41553795700008, 33.937933661000045],
              [132.42758222700002, 33.939886786000045],
              [132.453949415, 33.937567450000074],
              [132.46949303500003, 33.937933661000045],
              [132.457855665, 33.92767975500004],
              [132.4365340500001, 33.903550523000035],
              [132.42847741000003, 33.90253327000005],
              [132.4189559250001, 33.90566640800006],
              [132.3945418630001, 33.899318752000056],
              [132.3847762380001, 33.894191799000055],
              [132.38070722700002, 33.886419989000046],
              [132.3794051440001, 33.86188385600008],
              [132.3774520190001, 33.85203685100004],
              [132.3740340500001, 33.84170156500005],
              [132.36255944100003, 33.84544505400004],
              [132.34058678500003, 33.844956773000035],
              [132.332367384, 33.84796784100007],
              [132.32837975400003, 33.85651276200008],
              [132.32960045700008, 33.86579010600008],
              [132.3286238940001, 33.875067450000074],
              [132.31861412900003, 33.88328685100004],
              [132.31177819100003, 33.875881252000056],
              [132.29810631600003, 33.884019273000035],
              [132.29184004, 33.87872955900008],
              [132.28882897200003, 33.868353583000044],
              [132.284515821, 33.86155833500004],
              [132.27214603000004, 33.86041901200008],
              [132.25464928500003, 33.865668036000045],
              [132.24366295700008, 33.86155833500004],
              [132.23617597700002, 33.86904531500005],
            ],
          ],
          [
            [
              [139.48707116000003, 34.06077708500004],
              [139.49439537900003, 34.09275950700004],
              [139.5234481130001, 34.11237213700008],
              [139.55632571700005, 34.11347077000005],
              [139.575043165, 34.09003327000005],
              [139.56128991000003, 34.05809153900009],
              [139.534515821, 34.037543036000045],
              [139.50611412900003, 34.03587474200009],
              [139.48707116000003, 34.06077708500004],
            ],
          ],
          [
            [
              [132.5551863940001, 34.07135651200008],
              [132.5322371750001, 34.082098700000074],
              [132.47803795700008, 34.08047109600005],
              [132.45533287900003, 34.08812083500004],
              [132.473968946, 34.10521067900004],
              [132.49732506600003, 34.11713288000004],
              [132.51002037900003, 34.13182200700004],
              [132.49683678500003, 34.15704987200007],
              [132.50660241000003, 34.16779205900008],
              [132.51929772200003, 34.17438385600008],
              [132.53248131600003, 34.17731354400007],
              [132.543304884, 34.17670319200005],
              [132.55152428500003, 34.17064036700009],
              [132.54900149800005, 34.16632721600007],
              [132.5478621750001, 34.16168854400007],
              [132.54509524800005, 34.15814850500004],
              [132.53785241000003, 34.15704987200007],
              [132.546234571, 34.144964911000045],
              [132.54900149800005, 34.13336823100008],
              [132.54948978000004, 34.12148672100005],
              [132.55152428500003, 34.108587958000044],
              [132.57764733200008, 34.11888255400004],
              [132.5805770190001, 34.09983958500004],
              [132.56983483200008, 34.075873114000046],
              [132.5551863940001, 34.07135651200008],
            ],
          ],
          [
            [
              [132.99947548700004, 34.208377288000065],
              [132.9638778000001, 34.19188060100004],
              [132.95484459700003, 34.19818756700005],
              [132.9629012380001, 34.218451239000046],
              [132.96949303500003, 34.22304922100005],
              [132.98585045700008, 34.22695547100005],
              [132.99089603000004, 34.232123114000046],
              [132.99170983200008, 34.242254950000074],
              [132.9873153000001, 34.24884674700007],
              [132.97934004, 34.25218333500004],
              [132.9697371750001, 34.25263092700004],
              [132.9887801440001, 34.27301666900007],
              [133.01002037900003, 34.29124583500004],
              [133.03003991000003, 34.29531484600005],
              [133.0449324880001, 34.273098049000055],
              [133.0556746750001, 34.24237702000005],
              [133.0517684250001, 34.222316799000055],
              [133.03484134200005, 34.20734284100007],
              [132.99947548700004, 34.208377288000065],
            ],
          ],
          [
            [
              [129.31252838900002, 34.27975637600008],
              [129.31678390000002, 34.294468719000065],
              [129.34258315800002, 34.29305183900004],
              [129.34710276200008, 34.28697774700004],
              [129.34296047100008, 34.278277529000036],
              [129.32560990600007, 34.27138467800006],
              [129.31807550400003, 34.25834963300008],
              [129.3210526040001, 34.24079649200007],
              [129.32480321700007, 34.22925262400008],
              [129.30938369900002, 34.21905214800006],
              [129.29746398300006, 34.21865848400006],
              [129.29802122700005, 34.21317660300008],
              [129.30257932300003, 34.20928496000005],
              [129.29971373600006, 34.19782318000006],
              [129.2980900670001, 34.181964366000045],
              [129.29721196100002, 34.170476062000034],
              [129.29449413700002, 34.16667814600004],
              [129.287848285, 34.16512018200007],
              [129.28373507900005, 34.15750473300005],
              [129.2835190520001, 34.14600476600009],
              [129.27658744000007, 34.12911120600006],
              [129.26458316700007, 34.123786830000086],
              [129.262423528, 34.11449633700005],
              [129.251090201, 34.10757029000007],
              [129.2482968390001, 34.09992685800006],
              [129.23585751100006, 34.10076336000009],
              [129.23180011400007, 34.094814056000075],
              [129.220421471, 34.08887792300004],
              [129.216062405, 34.09833929200005],
              [129.21073071, 34.09996089100008],
              [129.19830716400008, 34.11099165600007],
              [129.19030802600003, 34.11481074200009],
              [129.17762902800007, 34.108929999000054],
              [129.17163425900003, 34.10680681200006],
              [129.1703536440001, 34.14681568300006],
              [129.17880296200008, 34.169765202000065],
              [129.17588028900002, 34.195509135000066],
              [129.18049970800007, 34.227217013000086],
              [129.18925958300008, 34.234227385000054],
              [129.188821856, 34.249552909000045],
              [129.195885, 34.27299251300008],
              [129.19853454100007, 34.316228084000045],
              [129.207360827, 34.32927727400005],
              [129.22524498500002, 34.32740336900008],
              [129.22846143900006, 34.32078103500004],
              [129.2243560720001, 34.31261085300008],
              [129.22405260200003, 34.29344308800006],
              [129.230672292, 34.29336287400008],
              [129.23871754000004, 34.29928705100008],
              [129.24822024800005, 34.300441799000055],
              [129.2620431790001, 34.30776139300008],
              [129.27528831000006, 34.30759681400008],
              [129.27078723900001, 34.315320307000036],
              [129.26892495000004, 34.32246424500005],
              [129.28019698700007, 34.32287172800005],
              [129.28938532900008, 34.31782388700009],
              [129.30246202400008, 34.30778735000007],
              [129.30143578800005, 34.28809728200008],
              [129.31252838900002, 34.27975637600008],
            ],
          ],
          [
            [
              [139.270355665, 34.39598216400009],
              [139.27955162900003, 34.402777411000045],
              [139.2915145190001, 34.41453685100004],
              [139.30095462300005, 34.41791413000004],
              [139.30250084700003, 34.399725653000075],
              [139.29639733200008, 34.36786530200004],
              [139.28345787900003, 34.33685944200005],
              [139.26783287900003, 34.322699286000045],
              [139.25367272200003, 34.34137604400007],
              [139.25464928500003, 34.35346100500004],
              [139.26539147200003, 34.38861725500004],
              [139.270355665, 34.39598216400009],
            ],
          ],
          [
            [
              [135.002681887, 34.60842304800008],
              [135.028168165, 34.591009833000044],
              [135.03012129, 34.57884349200009],
              [135.018413259, 34.56604837500004],
              [135.00327729100002, 34.551574781000056],
              [134.99539969300008, 34.53023319400006],
              [134.98414147200003, 34.50576406500005],
              [134.9563008670001, 34.48487725400008],
              [134.9325420020001, 34.453482284000074],
              [134.902973179, 34.41900554700004],
              [134.89722741000003, 34.38149648600006],
              [134.89576256600003, 34.372748114000046],
              [134.8989363940001, 34.36082591400009],
              [134.899674838, 34.34903575900006],
              [134.91627037900003, 34.33828359600005],
              [134.918613165, 34.32039442000007],
              [134.92618311400008, 34.30849507800008],
              [134.95045006600003, 34.28733958500004],
              [134.95825406100005, 34.27035550100004],
              [134.937984066, 34.26275510800008],
              [134.90947036600005, 34.25718023200005],
              [134.8849059370001, 34.24448107000006],
              [134.856118122, 34.236007305000044],
              [134.83385849900003, 34.22661011400004],
              [134.800049522, 34.20075373700007],
              [134.75187547300004, 34.19195544200005],
              [134.72867714100005, 34.190939349000075],
              [134.72686973700002, 34.209970042000066],
              [134.7053787430001, 34.21796839800004],
              [134.70216251400007, 34.221198790000074],
              [134.713595844, 34.239970053000036],
              [134.72388756600003, 34.25263092700004],
              [134.68811432000007, 34.24357989100008],
              [134.6665145190001, 34.26552969000005],
              [134.65716913300002, 34.288204316000076],
              [134.66963515700002, 34.30206522100008],
              [134.68325958600008, 34.328226407000045],
              [134.70515563800006, 34.32316807600006],
              [134.72081440700003, 34.329788749000045],
              [134.79895562900003, 34.44679379100006],
              [134.8242293630001, 34.46084219000005],
              [134.84253991000003, 34.47028229400007],
              [134.85043379, 34.47573476800005],
              [134.8564559250001, 34.483303127000056],
              [134.86500084700003, 34.50067780200004],
              [134.87134850400003, 34.50958893400008],
              [134.8838308930001, 34.529488695000055],
              [134.92246118600008, 34.54608208600007],
              [134.93811010500008, 34.55090579700004],
              [134.96306260100005, 34.580816112000036],
              [134.98133299800008, 34.60240240600007],
              [135.002681887, 34.60842304800008],
            ],
          ],
          [
            [
              [129.45264733200008, 34.61945221600007],
              [129.4629012380001, 34.60911692900004],
              [129.47820071700005, 34.59711334800005],
              [129.47537364000004, 34.588451047000035],
              [129.47310177600002, 34.579332460000046],
              [129.464241065, 34.55427396300007],
              [129.4460831890001, 34.51477564000004],
              [129.40232637400004, 34.48164673200006],
              [129.379472781, 34.452622973000075],
              [129.38428795700008, 34.42401764500005],
              [129.3618308670001, 34.405485748000046],
              [129.35946395400003, 34.39062150700005],
              [129.3755062240001, 34.39441603200004],
              [129.39318101000003, 34.41080021800008],
              [129.39442173700002, 34.403331912000056],
              [129.38859779400002, 34.38965888300004],
              [129.38431153200008, 34.38341631900005],
              [129.38814520100004, 34.36675509200006],
              [129.39958743600005, 34.35504791900007],
              [129.4079686450001, 34.351579901000036],
              [129.400755935, 34.337924254000086],
              [129.386052822, 34.33125826400004],
              [129.37916100400003, 34.324652411000045],
              [129.368241614, 34.30743171200004],
              [129.34383322200006, 34.30031431500004],
              [129.324511883, 34.304593338000075],
              [129.30546399500008, 34.32487545400005],
              [129.32090476000008, 34.333849042000054],
              [129.34506369500002, 34.32724397800007],
              [129.3470027080001, 34.35585198900009],
              [129.3345957140001, 34.36059135700009],
              [129.31620389800003, 34.34249649600008],
              [129.3051037470001, 34.34320609200006],
              [129.30405895900003, 34.36212271200009],
              [129.30493826400004, 34.37242417900006],
              [129.309322243, 34.384401910000065],
              [129.297384255, 34.37710499100007],
              [129.2874439520001, 34.36576828200009],
              [129.2933984880001, 34.34907806600006],
              [129.286358737, 34.34400826400008],
              [129.27199211700008, 34.35621928200004],
              [129.24829130400008, 34.351925460000075],
              [129.22891302300002, 34.35560142600008],
              [129.23538380000002, 34.368132348000074],
              [129.25972666300004, 34.36955277700008],
              [129.272349114, 34.375696607000066],
              [129.27375144500002, 34.41293237800005],
              [129.26856862500006, 34.43305128800006],
              [129.2770890930001, 34.44152705100004],
              [129.28686405500002, 34.44311244600004],
              [129.29168986600007, 34.44075623400005],
              [129.29738949600005, 34.44754637200009],
              [129.31086745200002, 34.46051106800007],
              [129.30889545800005, 34.466841042000055],
              [129.29332759300007, 34.45332664000006],
              [129.28073429900007, 34.45064666500008],
              [129.276044124, 34.46218849400009],
              [129.28902402900007, 34.48723729400007],
              [129.3049307670001, 34.520287272000076],
              [129.3261191900001, 34.53543877000004],
              [129.325545842, 34.54232653400004],
              [129.30845618800004, 34.56038743000005],
              [129.29094474300007, 34.55607171200006],
              [129.28910691400006, 34.56986674800004],
              [129.303359203, 34.58687697000005],
              [129.30784427000003, 34.603463495000085],
              [129.32330009600003, 34.64807215700006],
              [129.33656962500004, 34.64841143800004],
              [129.3609682550001, 34.64800679100006],
              [129.37833743400006, 34.644851764000066],
              [129.39037028500002, 34.65447130000007],
              [129.4096619940001, 34.67517282600005],
              [129.42574516500008, 34.67780118600007],
              [129.41822846900004, 34.68539200500004],
              [129.42330488100004, 34.69507089000007],
              [129.4386154240001, 34.69371319700008],
              [129.450619952, 34.70100212400007],
              [129.46456058500007, 34.70080530600006],
              [129.47066369700008, 34.69268493700008],
              [129.48072350400003, 34.68398672100005],
              [129.4877511300001, 34.676396890000035],
              [129.48327784600008, 34.66269661200005],
              [129.47757936900007, 34.65703587100006],
              [129.46911995900007, 34.652558845000044],
              [129.47814236700003, 34.65072063800005],
              [129.4878018280001, 34.64600565000006],
              [129.4882777150001, 34.63567767100005],
              [129.480912804, 34.619909575000065],
              [129.47242272200003, 34.61676666900007],
              [129.4619246750001, 34.62189362200007],
              [129.45264733200008, 34.61945221600007],
            ],
          ],
          [
            [
              [139.41822350400003, 34.78082916900007],
              [139.43775475400003, 34.771918036000045],
              [139.450043165, 34.75678131700005],
              [139.45671634200005, 34.73712799700007],
              [139.45850670700008, 34.71503327000005],
              [139.457855665, 34.689886786000045],
              [139.45378665500004, 34.678941148000035],
              [139.442718946, 34.67670319200005],
              [139.42164147200003, 34.67719147300005],
              [139.3593528460001, 34.70229865300007],
              [139.35119548300008, 34.72003363400006],
              [139.35201437, 34.76733961600007],
              [139.35646512200003, 34.79722949200004],
              [139.40064537900003, 34.78864166900007],
              [139.41822350400003, 34.78082916900007],
            ],
          ],
          [
            [
              [133.01246178500003, 36.01479726800005],
              [133.02418053500003, 36.02558014500005],
              [133.04517662900003, 36.02000560100004],
              [133.06666100400003, 36.00653717700004],
              [133.0791121750001, 35.99363841400009],
              [133.0649520190001, 35.99506256700005],
              [133.0278426440001, 35.99363841400009],
              [133.02133222700002, 35.995754299000055],
              [133.0161238940001, 36.00092194200005],
              [133.01295006600003, 36.007798570000034],
              [133.01246178500003, 36.01479726800005],
            ],
          ],
          [
            [
              [133.36703535200002, 36.27423737200007],
              [133.3818465500001, 36.25771719000005],
              [133.379242384, 36.208238023000035],
              [133.373383009, 36.197699286000045],
              [133.360199415, 36.19163646000004],
              [133.3525496750001, 36.20351797100005],
              [133.34351647200003, 36.204331773000035],
              [133.334320509, 36.198879299000055],
              [133.32601972700002, 36.19163646000004],
              [133.33765709700003, 36.18439362200007],
              [133.34131920700008, 36.175034898000035],
              [133.33741295700008, 36.16559479400007],
              [133.32601972700002, 36.15814850500004],
              [133.3183699880001, 36.15843333500004],
              [133.2783309250001, 36.16498444200005],
              [133.2563582690001, 36.16498444200005],
              [133.24976647200003, 36.16828034100007],
              [133.20264733200008, 36.20229726800005],
              [133.19263756600003, 36.205959377000056],
              [133.18775475400003, 36.216131903000075],
              [133.1962996750001, 36.27798086100006],
              [133.2094832690001, 36.29718659100007],
              [133.2920028000001, 36.34247467700004],
              [133.29281660200002, 36.33055247600004],
              [133.3007918630001, 36.325873114000046],
              [133.31120853000004, 36.324286200000074],
              [133.32016035200002, 36.32184479400007],
              [133.32349694100003, 36.318345445000034],
              [133.326508009, 36.30939362200007],
              [133.329437696, 36.30491771000004],
              [133.33570397200003, 36.30093008000006],
              [133.3486434250001, 36.29759349200009],
              [133.3540145190001, 36.29466380400004],
              [133.3593856130001, 36.28856028900009],
              [133.363617384, 36.279282945000034],
              [133.36703535200002, 36.27423737200007],
            ],
          ],
          [
            [
              [138.45923912900003, 38.06989166900007],
              [138.4946395190001, 38.06696198100008],
              [138.54078209700003, 38.07672760600008],
              [138.5752059250001, 38.074286200000074],
              [138.5752059250001, 38.03510163000004],
              [138.56592858200008, 38.01634349200009],
              [138.5244246750001, 37.96344635600008],
              [138.51319420700008, 37.94481028900009],
              [138.5004988940001, 37.906683661000045],
              [138.48650149800005, 37.89175039300005],
              [138.37037194100003, 37.82876211100006],
              [138.26514733200008, 37.79832591400009],
              [138.2431746750001, 37.796128648000035],
              [138.23259524800005, 37.79767487200007],
              [138.2226668630001, 37.80223216400009],
              [138.21509850400003, 37.80955638200004],
              [138.21216881600003, 37.81940338700008],
              [138.21550540500004, 37.83026764500005],
              [138.22388756600003, 37.83417389500005],
              [138.27214603000004, 37.842230536000045],
              [138.2832137380001, 37.84833405200004],
              [138.28785241000003, 37.861029364000046],
              [138.28785241000003, 37.90599192900004],
              [138.29859459700003, 37.92243073100008],
              [138.33082116000003, 37.95189036700009],
              [138.34253991000003, 37.966864325000074],
              [138.314789259, 37.99746328300006],
              [138.24789472700002, 37.978501695000034],
              [138.23267662900003, 38.00775788000004],
              [138.23259524800005, 38.031317450000074],
              [138.23560631600003, 38.05215078300006],
              [138.2421981130001, 38.071478583000044],
              [138.25310306100005, 38.09031810100004],
              [138.29468834700003, 38.13617584800005],
              [138.31006920700008, 38.16811758000006],
              [138.3291121750001, 38.18195221600007],
              [138.3481551440001, 38.19281647300005],
              [138.35670006600003, 38.20359935100004],
              [138.40186608200008, 38.24119700700004],
              [138.42855879, 38.256293036000045],
              [138.46941165500004, 38.31317780200004],
              [138.47803795700008, 38.319566148000035],
              [138.48951256600003, 38.32245514500005],
              [138.5141707690001, 38.32306549700007],
              [138.5200301440001, 38.31850820500006],
              [138.51929772200003, 38.30744049700007],
              [138.50709069100003, 38.241441148000035],
              [138.48658287900003, 38.181301174000055],
              [138.4438582690001, 38.10224030200004],
              [138.43816165500004, 38.08348216400009],
              [138.4375106130001, 38.063788153000075],
              [138.44320722700002, 38.051947333000044],
              [138.451508009, 38.052435614000046],
              [138.45923912900003, 38.06989166900007],
            ],
          ],
          [
            [
              [139.54851321700005, 42.243353583000044],
              [139.56421959700003, 42.231756903000075],
              [139.55396569100003, 42.21157461100006],
              [139.52068118600005, 42.17450592700004],
              [139.5136824880001, 42.14817942900004],
              [139.5127059250001, 42.12372467700004],
              [139.50896243600005, 42.100816148000035],
              [139.49390709700003, 42.07884349200003],
              [139.45533287900003, 42.05158112200007],
              [139.445648634, 42.05483633000006],
              [139.43539472700002, 42.062933661000045],
              [139.42945397200003, 42.07379791900007],
              [139.43238366000003, 42.08510976800005],
              [139.42725670700008, 42.09393952000005],
              [139.42505944100003, 42.10268789300005],
              [139.42505944100003, 42.12299225500004],
              [139.422699415, 42.13149648600006],
              [139.41285241000003, 42.14398834800005],
              [139.41081790500004, 42.153998114000046],
              [139.41431725400003, 42.17251211100006],
              [139.4238387380001, 42.19159577000005],
              [139.43702233200008, 42.20722077000005],
              [139.4521590500001, 42.21531810100004],
              [139.46371504, 42.21625397300005],
              [139.48552493600005, 42.221136786000045],
              [139.49732506600003, 42.22223541900007],
              [139.509125196, 42.225775458000044],
              [139.53834069100003, 42.240668036000045],
              [139.54851321700005, 42.243353583000044],
            ],
          ],
          [
            [
              [145.3115340500001, 43.59332916900007],
              [145.34441165500004, 43.57591380400004],
              [145.3603621750001, 43.56476471600007],
              [145.36280358200008, 43.55487702000005],
              [145.3501082690001, 43.54962799700007],
              [145.31202233200008, 43.542181708000044],
              [145.30420983200008, 43.53473541900007],
              [145.2973738940001, 43.522650458000044],
              [145.283539259, 43.51788971600007],
              [145.27320397200003, 43.522365627000056],
              [145.27686608200008, 43.53815338700008],
              [145.28785241000003, 43.54751211100006],
              [145.318695509, 43.55776601800005],
              [145.3320418630001, 43.56541575700004],
              [145.20240319100003, 43.61383698100008],
              [145.28695722700002, 43.60101959800005],
              [145.3115340500001, 43.59332916900007],
            ],
          ],
          [
            [
              [144.4482528000001, 43.94220612200007],
              [144.4550887380001, 43.94220612200007],
              [144.44898522200003, 43.94204336100006],
              [144.4482528000001, 43.94220612200007],
            ],
          ],
          [
            [
              [141.3271590500001, 45.17234935100004],
              [141.33562259200005, 45.15778229400007],
              [141.328461134, 45.147650458000044],
              [141.3164168630001, 45.137925523000035],
              [141.31006920700008, 45.12457916900007],
              [141.30445397200003, 45.12018463700008],
              [141.26840254, 45.10101959800005],
              [141.25123131600003, 45.09918854400007],
              [141.2353621750001, 45.10248444200005],
              [141.18181399800005, 45.126613674000055],
              [141.15007571700005, 45.14712148600006],
              [141.13111412900003, 45.17015208500004],
              [141.1455184250001, 45.18976471600007],
              [141.14087975400003, 45.19603099200003],
              [141.13550866000003, 45.20612213700008],
              [141.1318465500001, 45.210272528000075],
              [141.16716556100005, 45.23997630400004],
              [141.1796981130001, 45.24437083500004],
              [141.20264733200008, 45.24909088700008],
              [141.235199415, 45.24127838700008],
              [141.26832116000003, 45.22553131700005],
              [141.2929793630001, 45.20652903900009],
              [141.3271590500001, 45.17234935100004],
            ],
          ],
          [
            [
              [141.0527449880001, 45.450425523000035],
              [141.06902103000004, 45.442694403000075],
              [141.073578321, 45.424709377000056],
              [141.0590926440001, 45.321966864000046],
              [141.04957116000003, 45.29291413000004],
              [141.0356551440001, 45.264878648000035],
              [141.02906334700003, 45.278509833000044],
              [141.02995853000004, 45.28392161700003],
              [141.0356551440001, 45.292181708000044],
              [141.01050866000003, 45.327785549000055],
              [140.99887129, 45.35000234600005],
              [140.9941512380001, 45.37103913000004],
              [141.0009871750001, 45.419134833000044],
              [140.99634850400003, 45.43024323100008],
              [140.9668074880001, 45.46344635600008],
              [140.97413170700008, 45.46771881700005],
              [140.98064212300005, 45.46893952000005],
              [140.98609459700003, 45.46743398600006],
              [140.99048912900003, 45.46336497600004],
              [140.9931746750001, 45.45880768400008],
              [141.00660241000003, 45.44041575700004],
              [141.0200301440001, 45.43984609600005],
              [141.03532962300005, 45.44623444200005],
              [141.0527449880001, 45.450425523000035],
            ],
          ],
          [
            [
              [140.86996504, 27.21824778900009],
              [140.86793053500003, 27.23395416900007],
              [140.87419681100005, 27.238226630000042],
              [140.87818444100003, 27.23261139500005],
              [140.86996504, 27.21824778900009],
            ],
          ],
          [
            [
              [127.80982506600003, 26.73541901200008],
              [127.81120853000004, 26.706976630000042],
              [127.78565514400009, 26.70258209800005],
              [127.75855553500003, 26.71287669500009],
              [127.75464928500003, 26.728583075000074],
              [127.76880944100003, 26.734035549000055],
              [127.79574629000001, 26.73151276200008],
              [127.80982506600003, 26.73541901200008],
            ],
          ],
          [
            [
              [127.99537194100003, 27.091742255000042],
              [128.0009871750001, 27.091742255000042],
              [127.99317467500009, 27.06671784100007],
              [127.97575931100005, 27.03974030200004],
              [127.95215905000009, 27.01829661700009],
              [127.92579186300009, 27.00975169500009],
              [127.93572024800005, 27.025091864000046],
              [127.98707116000003, 27.078599351000037],
              [127.99537194100003, 27.091742255000042],
            ],
          ],
          [
            [
              [130.220062696, 30.471584377000056],
              [130.242867, 30.46361180400004],
              [130.26214412700006, 30.447032385000057],
              [130.26215684400006, 30.435023779000062],
              [130.24063399200008, 30.43493568000008],
              [130.23184544100002, 30.42354163300007],
              [130.2124676420001, 30.420690741000044],
              [130.1930820990001, 30.43956333700004],
              [130.1943865070001, 30.45214809400005],
              [130.19038082300005, 30.46129914800008],
              [130.17311500100004, 30.454421868000054],
              [130.16310837600008, 30.46871657300005],
              [130.15177683600007, 30.477863163000052],
              [130.14176604600004, 30.489301081000065],
              [130.16505068900005, 30.489890078000087],
              [130.191016268, 30.476172262000034],
              [130.2023057880001, 30.48190106000004],
              [130.220062696, 30.471584377000056],
            ],
          ],
          [
            [
              [134.36736087300005, 34.55426666900007],
              [134.3632918630001, 34.545355536000045],
              [134.3657332690001, 34.53628164300005],
              [134.37061608200008, 34.52586497600004],
              [134.37427819100003, 34.513332424000055],
              [134.36890709700003, 34.484361070000034],
              [134.34693444100003, 34.43081289300005],
              [134.342133009, 34.43968333500004],
              [134.33277428500003, 34.44476959800005],
              [134.32016035200002, 34.446478583000044],
              [134.30591881600003, 34.445013739000046],
              [134.30591881600003, 34.451239325000074],
              [134.32496178500003, 34.45368073100008],
              [134.32960045700008, 34.46238841400009],
              [134.320648634, 34.46893952000005],
              [134.29908287900003, 34.464911200000074],
              [134.28492272200003, 34.45229726800005],
              [134.27418053500003, 34.43500397300005],
              [134.26238040500004, 34.42088450700004],
              [134.24439537900003, 34.41771067900004],
              [134.24870853000004, 34.453192450000074],
              [134.2431746750001, 34.46385325700004],
              [134.22339928500003, 34.472357489000046],
              [134.20484459700003, 34.471584377000056],
              [134.185883009, 34.466050523000035],
              [134.17017662900003, 34.46548086100006],
              [134.16138756600003, 34.47919342700004],
              [134.17172285200002, 34.48590729400007],
              [134.17253665500004, 34.49664948100008],
              [134.17107181100005, 34.50893789300005],
              [134.17505944100003, 34.52008698100008],
              [134.20378665500004, 34.51243724200009],
              [134.22828209700003, 34.51837799700007],
              [134.27125084700003, 34.540676174000055],
              [134.2832137380001, 34.54364655200004],
              [134.31902103000004, 34.54682038000004],
              [134.35368899800005, 34.554388739000046],
              [134.36736087300005, 34.55426666900007],
            ],
          ],
          [
            [
              [141.45297285200002, 24.222398179000038],
              [141.46021569100003, 24.227362372000073],
              [141.46998131600003, 24.226263739000046],
              [141.4707137380001, 24.219183661000045],
              [141.46794681100005, 24.213771877000056],
              [141.46314537900003, 24.212103583000044],
              [141.45573978000004, 24.21588776200008],
              [141.45297285200002, 24.222398179000038],
            ],
          ],
          [
            [
              [153.972992384, 24.28969961100006],
              [153.98121178500003, 24.295355536000045],
              [153.98560631600003, 24.291083075000074],
              [153.98365319100003, 24.282945054000038],
              [153.97828209700003, 24.282416083000044],
              [153.972015821, 24.284816799000055],
              [153.972992384, 24.28969961100006],
            ],
          ],
          [
            [
              [141.287445509, 25.417710679000038],
              [141.27466881600003, 25.427069403000075],
              [141.2705184250001, 25.440375067000048],
              [141.274750196, 25.451117255000042],
              [141.28825931100005, 25.45254140800006],
              [141.29753665500004, 25.44529857000009],
              [141.29948978000004, 25.434800523000035],
              [141.29566491000003, 25.42450592700004],
              [141.287445509, 25.417710679000038],
            ],
          ],
          [
            [
              [131.28972415500004, 25.95136139500005],
              [131.302093946, 25.953192450000074],
              [131.3212996750001, 25.947699286000045],
              [131.32789147200003, 25.93707916900007],
              [131.3222762380001, 25.927069403000075],
              [131.31657962300005, 25.923081773000035],
              [131.3095809250001, 25.922756252000056],
              [131.30152428500003, 25.92674388200004],
              [131.29086347700002, 25.938666083000044],
              [131.28972415500004, 25.95136139500005],
            ],
          ],
          [
            [
              [127.22217858200008, 26.598944403000075],
              [127.232758009, 26.600775458000044],
              [127.24236087300005, 26.59674713700008],
              [127.24415123800009, 26.586411851000037],
              [127.23682701900009, 26.57916901200008],
              [127.22706139400009, 26.57953522300005],
              [127.21485436300009, 26.577460028000075],
              [127.20883222700002, 26.581976630000042],
              [127.21485436300009, 26.592922268000052],
              [127.22217858200008, 26.598944403000075],
            ],
          ],
          [
            [
              [128.45435631600003, 27.04751211100006],
              [128.45484459700003, 27.02875397300005],
              [128.448578321, 27.020697333000044],
              [128.43140709700003, 27.02167389500005],
              [128.41089928500003, 27.030585028000075],
              [128.40609785200002, 27.035101630000042],
              [128.40154056100005, 27.036932684000078],
              [128.39625084700003, 27.040757554000038],
              [128.39625084700003, 27.04901764500005],
              [128.40162194100003, 27.050726630000042],
              [128.4087020190001, 27.050848700000074],
              [128.41570071700005, 27.059759833000044],
              [128.42896569100003, 27.066473700000074],
              [128.4443465500001, 27.062567450000074],
              [128.4516707690001, 27.05414459800005],
              [128.45435631600003, 27.04751211100006],
            ],
          ],
          [
            [
              [142.18921959700003, 27.14549388200004],
              [142.18425540500004, 27.158351955000057],
              [142.18531334700003, 27.17413971600007],
              [142.19092858200008, 27.185207424000055],
              [142.20045006600003, 27.183294989000046],
              [142.2041121750001, 27.173895575000074],
              [142.20183353000004, 27.16274648600006],
              [142.19597415500004, 27.152411200000074],
              [142.18921959700003, 27.14549388200004],
            ],
          ],
          [
            [
              [142.1953231130001, 27.59910716400009],
              [142.17945397200003, 27.612494208000044],
              [142.18311608200008, 27.61945221600007],
              [142.19288170700008, 27.61619700700004],
              [142.1953231130001, 27.59910716400009],
            ],
          ],
          [
            [
              [142.0805770190001, 27.716945705000057],
              [142.0786238940001, 27.72724030200004],
              [142.08228600400003, 27.72988515800006],
              [142.08513431100005, 27.72606028900009],
              [142.0805770190001, 27.716945705000057],
            ],
          ],
          [
            [
              [128.23658287900003, 27.866522528000075],
              [128.23853600400003, 27.86090729400007],
              [128.24341881600003, 27.857245184000078],
              [128.241547071, 27.845363674000055],
              [128.23226972700002, 27.852850653000075],
              [128.229828321, 27.868963934000078],
              [128.23658287900003, 27.866522528000075],
            ],
          ],
          [
            [
              [129.59156334700003, 29.450100002000056],
              [129.58741295700008, 29.458238023000035],
              [129.59131920700008, 29.467962958000044],
              [129.5981551440001, 29.472357489000046],
              [129.60108483200008, 29.47134023600006],
              [129.6035262380001, 29.469549872000073],
              [129.60808353000004, 29.469224351000037],
              [129.610687696, 29.46556224200009],
              [129.61540774800005, 29.455226955000057],
              [129.6123153000001, 29.44334544500009],
              [129.5996199880001, 29.44334544500009],
              [129.59156334700003, 29.450100002000056],
            ],
          ],
          [
            [
              [129.527679884, 29.902329820000034],
              [129.52857506600003, 29.90892161700009],
              [129.53541100400003, 29.909857489000046],
              [129.543304884, 29.908148505000042],
              [129.550140821, 29.90387604400007],
              [129.55445397200003, 29.89752838700008],
              [129.55152428500003, 29.89362213700008],
              [129.539886915, 29.889878648000035],
              [129.53305097700002, 29.893500067000048],
              [129.527679884, 29.902329820000034],
            ],
          ],
          [
            [
              [129.943695509, 29.965277411000045],
              [129.9453231130001, 29.96161530200004],
              [129.94800866000003, 29.959458726000037],
              [129.94800866000003, 29.95856354400007],
              [129.94092858200008, 29.953192450000074],
              [129.9238117330001, 29.95792003400004],
              [129.9133333310001, 29.960901639000042],
              [129.90308678500003, 29.970851955000057],
              [129.90064537900003, 29.97256094000005],
              [129.899750196, 29.97565338700008],
              [129.90113366000003, 29.98069896000004],
              [129.90357506600003, 29.984361070000034],
              [129.91236412900003, 29.991888739000046],
              [129.90902754, 29.999335028000075],
              [129.913422071, 30.00031159100007],
              [129.9219895450001, 30.00472988100006],
              [129.92713547100004, 29.993404422000083],
              [129.93415344000005, 29.98210162400005],
              [129.943695509, 29.965277411000045],
            ],
          ],
          [
            [
              [140.3076278000001, 30.491156317000048],
              [140.31714928500003, 30.491156317000048],
              [140.32593834700003, 30.485174872000073],
              [140.31861412900003, 30.475531317000048],
              [140.30648847700002, 30.47361888200004],
              [140.301605665, 30.48069896000004],
              [140.30144290500004, 30.486273505000042],
              [140.3076278000001, 30.491156317000048],
            ],
          ],
          [
            [
              [129.4282332690001, 30.84642161700009],
              [129.43091881600003, 30.848211981000077],
              [129.43384850400003, 30.844549872000073],
              [129.42945397200003, 30.84088776200008],
              [129.4282332690001, 30.84642161700009],
            ],
          ],
          [
            [
              [129.9462996750001, 30.84471263200004],
              [129.95826256600003, 30.83698151200008],
              [129.95980879, 30.828680731000077],
              [129.95036868600005, 30.81932200700004],
              [129.9394637380001, 30.813421942000048],
              [129.9277449880001, 30.813421942000048],
              [129.91195722700002, 30.81976959800005],
              [129.91041100400003, 30.821966864000046],
              [129.90984134200005, 30.825873114000046],
              [129.90398196700005, 30.834418036000045],
              [129.9082137380001, 30.838446356000077],
              [129.91586347700002, 30.841945705000057],
              [129.92554772200003, 30.849595445000034],
              [129.9321395190001, 30.85175202000005],
              [129.9399520190001, 30.848944403000075],
              [129.9462996750001, 30.84471263200004],
            ],
          ],
          [
            [
              [140.0434676440001, 31.443101304000038],
              [140.04444420700008, 31.445054429000038],
              [140.04566491000003, 31.443304755000042],
              [140.0434676440001, 31.443101304000038],
            ],
          ],
          [
            [
              [140.04127037900003, 31.444159247000073],
              [140.041351759, 31.446478583000044],
              [140.04314212300005, 31.444566148000035],
              [140.0415145190001, 31.443101304000038],
              [140.04127037900003, 31.444159247000073],
            ],
          ],
          [
            [
              [139.7563582690001, 32.45229726800005],
              [139.75709069100003, 32.470363674000055],
              [139.773773634, 32.44098541900007],
              [139.7563582690001, 32.45229726800005],
            ],
          ],
          [
            [
              [139.29908287900003, 33.650091864000046],
              [139.29615319100003, 33.65106842700004],
              [139.29908287900003, 33.65070221600007],
              [139.29908287900003, 33.650091864000046],
            ],
          ],
          [
            [
              [139.62281334700003, 33.88556549700007],
              [139.62956790500004, 33.87173086100006],
              [139.62875410200002, 33.86570872600004],
              [139.62289472700002, 33.856756903000075],
              [139.610199415, 33.852850653000075],
              [139.5942488940001, 33.854722398000035],
              [139.58130944100003, 33.862534898000035],
              [139.57976321700005, 33.88031647300005],
              [139.59245853000004, 33.895819403000075],
              [139.60962975400003, 33.89638906500005],
              [139.61898847700002, 33.89012278900009],
              [139.62281334700003, 33.88556549700007],
            ],
          ],
          [
            [
              [139.37289472700002, 41.52216217700004],
              [139.378265821, 41.519232489000046],
              [139.3818465500001, 41.51357656500005],
              [139.37427819100003, 41.504339911000045],
              [139.34555097700002, 41.493353583000044],
              [139.3408309250001, 41.49750397300005],
              [139.3364363940001, 41.51113515800006],
              [139.3364363940001, 41.51850006700005],
              [139.3403426440001, 41.52383047100005],
              [139.3481551440001, 41.52423737200007],
              [139.35572350400003, 41.52216217700004],
              [139.37289472700002, 41.52216217700004],
            ],
          ],
          [
            [
              [153.966237826, 24.308661200000074],
              [153.953461134, 24.29250722900008],
              [153.94068444100003, 24.311468817000048],
              [153.95370527400007, 24.31582265800006],
              [153.966237826, 24.308661200000074],
            ],
          ],
          [
            [
              [125.20289147200003, 24.846258856000077],
              [125.21078535200002, 24.83698151200008],
              [125.21705162900003, 24.81659577000005],
              [125.20525149800005, 24.80499909100007],
              [125.16814212300005, 24.80097077000005],
              [125.15064537900003, 24.804348049000055],
              [125.14014733200008, 24.81639232000009],
              [125.14112389400009, 24.828599351000037],
              [125.14966881600003, 24.83193594000005],
              [125.15756269600001, 24.833807684000078],
              [125.15967858200008, 24.84442780200004],
              [125.16358483200008, 24.854641018000052],
              [125.17701256600003, 24.856390692000048],
              [125.19450931100005, 24.85028717700004],
              [125.20289147200003, 24.846258856000077],
            ],
          ],
          [
            [
              [127.36963951900009, 26.214585679000038],
              [127.37077884200005, 26.21002838700008],
              [127.37086022200003, 26.203192450000074],
              [127.36793053500003, 26.190619208000044],
              [127.363617384, 26.177557684000078],
              [127.36109459700003, 26.164007880000042],
              [127.35352623800009, 26.153998114000046],
              [127.34538821700005, 26.158270575000074],
              [127.34278405000009, 26.17023346600007],
              [127.34229576900009, 26.17999909100007],
              [127.34262129000001, 26.18573639500005],
              [127.34620201900009, 26.206366278000075],
              [127.35417728000004, 26.21893952000005],
              [127.36410566500001, 26.22134023600006],
              [127.36963951900009, 26.214585679000038],
            ],
          ],
          [
            [
              [142.10515384200005, 27.727036851000037],
              [142.108815951, 27.729681708000044],
              [142.111664259, 27.725856838000084],
              [142.10718834700003, 27.716742255000042],
              [142.10515384200005, 27.727036851000037],
            ],
          ],
          [
            [
              [129.93336022200003, 31.86782461100006],
              [129.92847741000003, 31.86391836100006],
              [129.9277449880001, 31.859523830000057],
              [129.9296981130001, 31.85342031500005],
              [129.928070509, 31.846502997000073],
              [129.92847741000003, 31.840399481000077],
              [129.93116295700008, 31.836371161000045],
              [129.93148847700002, 31.83348216400009],
              [129.92920983200008, 31.826727606000077],
              [129.922211134, 31.81981028900009],
              [129.91277103000004, 31.819484768000052],
              [129.9033309250001, 31.818060614000046],
              [129.88990319100003, 31.81073639500005],
              [129.8759871750001, 31.81126536700009],
              [129.86866295700008, 31.818426825000074],
              [129.8632918630001, 31.820868231000077],
              [129.85906009200005, 31.82367584800005],
              [129.8574324880001, 31.828558661000045],
              [129.85377037900003, 31.835150458000044],
              [129.84742272200003, 31.843410549000055],
              [129.84652754, 31.850897528000075],
              [129.8535262380001, 31.855169989000046],
              [129.85043379, 31.857407945000034],
              [129.83952884200005, 31.853664455000057],
              [129.83179772200003, 31.843736070000034],
              [129.8242293630001, 31.842271226000037],
              [129.82056725400003, 31.845526434000078],
              [129.8203231130001, 31.85187409100007],
              [129.82309004, 31.863023179000038],
              [129.83179772200003, 31.873521226000037],
              [129.84498131600003, 31.880601304000038],
              [129.86451256600003, 31.875555731000077],
              [129.90202884200005, 31.848130601000037],
              [129.90992272200003, 31.845689195000034],
              [129.91277103000004, 31.85187409100007],
              [129.90845787900003, 31.861802476000037],
              [129.913422071, 31.867743231000077],
              [129.92855879, 31.869696356000077],
              [129.93336022200003, 31.86782461100006],
            ],
          ],
          [
            [
              [130.24390709700003, 32.30182526200008],
              [130.2602645190001, 32.29507070500006],
              [130.266449415, 32.28705475500004],
              [130.263031446, 32.281317450000074],
              [130.25359134200005, 32.27163320500006],
              [130.24284915500004, 32.26308828300006],
              [130.23267662900003, 32.25877513200004],
              [130.2231551440001, 32.257066148000035],
              [130.21509850400003, 32.25267161700009],
              [130.21070397200003, 32.25535716400009],
              [130.2109481130001, 32.26577383000006],
              [130.2129012380001, 32.276678778000075],
              [130.21705162900003, 32.28693268400008],
              [130.22291100400003, 32.29205963700008],
              [130.2285262380001, 32.293036200000074],
              [130.23121178500003, 32.29511139500005],
              [130.23226972700002, 32.29865143400008],
              [130.24390709700003, 32.30182526200008],
            ],
          ],
          [
            [
              [130.44678795700008, 32.59682851800005],
              [130.45264733200008, 32.59064362200007],
              [130.45386803500003, 32.580064195000034],
              [130.45093834700003, 32.56342194200005],
              [130.4458113940001, 32.55255768400008],
              [130.43189537900003, 32.54987213700008],
              [130.42457116000003, 32.54682038000004],
              [130.42758222700002, 32.53729889500005],
              [130.42139733200008, 32.54075755400004],
              [130.4091903000001, 32.549261786000045],
              [130.4067488940001, 32.560980536000045],
              [130.41138756600003, 32.573879299000055],
              [130.40772545700008, 32.581732489000046],
              [130.39966881600003, 32.58641185100004],
              [130.398773634, 32.59316640800006],
              [130.41358483200008, 32.61359284100007],
              [130.4165145190001, 32.61395905200004],
              [130.41684004, 32.61005280200004],
              [130.42009524800005, 32.61155833500004],
              [130.42847741000003, 32.61766185100004],
              [130.4365340500001, 32.62067291900007],
              [130.44646243600005, 32.61660390800006],
              [130.45289147200003, 32.610988674000055],
              [130.450043165, 32.60325755400004],
              [130.44678795700008, 32.59682851800005],
            ],
          ],
          [
            [
              [132.56202233200008, 32.74213288000004],
              [132.56861412900003, 32.734361070000034],
              [132.57154381600003, 32.725490627000056],
              [132.5708113940001, 32.71727122600004],
              [132.56324303500003, 32.70994700700004],
              [132.54965254, 32.704291083000044],
              [132.54322350400003, 32.70844147300005],
              [132.54053795700008, 32.72150299700007],
              [132.539886915, 32.73379140800006],
              [132.543793165, 32.74559153900009],
              [132.54859459700003, 32.75079987200007],
              [132.55494225400003, 32.74750397300005],
              [132.557953321, 32.745306708000044],
              [132.56202233200008, 32.74213288000004],
            ],
          ],
          [
            [
              [128.899750196, 32.81830475500004],
              [128.9028426440001, 32.814154364000046],
              [128.908539259, 32.80133698100008],
              [128.9072371750001, 32.79401276200008],
              [128.894867384, 32.78172435100004],
              [128.88233483200008, 32.765285549000055],
              [128.875336134, 32.76349518400008],
              [128.86646569100003, 32.764960028000075],
              [128.84791100400003, 32.77488841400009],
              [128.84009850400003, 32.77757396000004],
              [128.83521569100003, 32.78766510600008],
              [128.8359481130001, 32.81899648600006],
              [128.83464603000004, 32.827053127000056],
              [128.837250196, 32.83380768400008],
              [128.8462020190001, 32.834865627000056],
              [128.85694420700008, 32.83002350500004],
              [128.86345462300005, 32.81883372600004],
              [128.8662215500001, 32.80735911700009],
              [128.86988366000003, 32.80109284100007],
              [128.87387129, 32.79873281500005],
              [128.8750106130001, 32.80174388200004],
              [128.87419681100005, 32.804348049000055],
              [128.873383009, 32.807847398000035],
              [128.87077884200005, 32.816066799000055],
              [128.8662215500001, 32.825384833000044],
              [128.86296634200005, 32.835272528000075],
              [128.8681746750001, 32.83783600500004],
              [128.89226321700005, 32.82371653900009],
              [128.899750196, 32.81830475500004],
            ],
          ],
          [
            [
              [128.9531356130001, 32.874212958000044],
              [128.955414259, 32.86310455900008],
              [128.9580184250001, 32.841498114000046],
              [128.954437696, 32.83071523600006],
              [128.94695071700005, 32.82802969000005],
              [128.94459069100003, 32.82339101800005],
              [128.9477645190001, 32.81981028900009],
              [128.94939212300005, 32.813381252000056],
              [128.94507897200003, 32.804348049000055],
              [128.9404403000001, 32.80442942900004],
              [128.9384871750001, 32.812933661000045],
              [128.931976759, 32.81712474200009],
              [128.92302493600005, 32.818060614000046],
              [128.92058353000004, 32.820746161000045],
              [128.92408287900003, 32.82461172100005],
              [128.92400149800005, 32.82965729400007],
              [128.92017662900003, 32.83502838700008],
              [128.91570071700005, 32.83885325700004],
              [128.90992272200003, 32.84243398600006],
              [128.89576256600003, 32.85643138200004],
              [128.8896590500001, 32.85814036700009],
              [128.883148634, 32.85594310100004],
              [128.88070722700002, 32.862616278000075],
              [128.89087975400003, 32.87091705900008],
              [128.90894616000003, 32.866441148000035],
              [128.9243270190001, 32.85150788000004],
              [128.92945397200003, 32.84979889500005],
              [128.9267684250001, 32.862209377000056],
              [128.92896569100003, 32.86469147300005],
              [128.93767337300005, 32.86078522300005],
              [128.94214928500003, 32.86517975500004],
              [128.9433699880001, 32.876288153000075],
              [128.94654381600003, 32.880194403000075],
              [128.9511824880001, 32.87645091400009],
              [128.9531356130001, 32.874212958000044],
            ],
          ],
          [
            [
              [129.0278426440001, 32.89980703300006],
              [129.02947024800005, 32.89175039300005],
              [129.02995853000004, 32.88861725500004],
              [129.028168165, 32.85565827000005],
              [129.02409915500004, 32.84804922100005],
              [129.017914259, 32.84804922100005],
              [129.01742597700002, 32.856675523000035],
              [129.0136824880001, 32.85879140800006],
              [129.00660241000003, 32.86469147300005],
              [128.99683678500003, 32.86664459800005],
              [128.98267662900003, 32.86225006700005],
              [128.9775496750001, 32.86399974200009],
              [128.97380618600005, 32.86904531500005],
              [128.96949303500003, 32.87148672100005],
              [128.96802819100003, 32.87368398600006],
              [128.96412194100003, 32.889553127000056],
              [128.96461022200003, 32.89826080900008],
              [128.972992384, 32.898504950000074],
              [128.99170983200008, 32.889837958000044],
              [128.99561608200008, 32.89052969000005],
              [128.994476759, 32.89533112200007],
              [128.9887801440001, 32.90021393400008],
              [128.983734571, 32.90664297100005],
              [128.98226972700002, 32.91242096600007],
              [128.97966556100005, 32.91648997600004],
              [128.97934004, 32.92023346600007],
              [128.98267662900003, 32.92324453300006],
              [128.984711134, 32.92609284100007],
              [128.98462975400003, 32.92918528900009],
              [128.99244225400003, 32.92942942900004],
              [129.00961347700002, 32.92450592700004],
              [129.02068118600005, 32.91669342700004],
              [129.02458743600005, 32.908636786000045],
              [129.0278426440001, 32.89980703300006],
            ],
          ],
          [
            [
              [129.13550866000003, 33.29987213700008],
              [129.14332116000003, 33.284816799000055],
              [129.15015709700003, 33.27651601800005],
              [129.14958743600005, 33.26902903900009],
              [129.13428795700008, 33.25861237200007],
              [129.127289259, 33.24750397300005],
              [129.1191512380001, 33.246527411000045],
              [129.10320071700005, 33.24917226800005],
              [129.092133009, 33.25543854400007],
              [129.08578535200002, 33.26007721600007],
              [129.07976321700005, 33.26129791900007],
              [129.075043165, 33.25991445500006],
              [129.0761824880001, 33.268784898000035],
              [129.08912194100003, 33.283270575000074],
              [129.10377037900003, 33.28896719000005],
              [129.11312910200002, 33.29140859600005],
              [129.128265821, 33.30158112200007],
              [129.13550866000003, 33.29987213700008],
            ],
          ],
          [
            [
              [129.55591881600003, 33.49396393400008],
              [129.57341556100005, 33.496079820000034],
              [129.57642662900003, 33.488348700000074],
              [129.56804446700005, 33.478501695000034],
              [129.55445397200003, 33.47345612200007],
              [129.539398634, 33.47516510600008],
              [129.52686608200008, 33.480454820000034],
              [129.51905358200008, 33.478176174000055],
              [129.516449415, 33.473537502000056],
              [129.51197350400003, 33.47296784100007],
              [129.50318444100003, 33.47370026200008],
              [129.50668379, 33.48309967700004],
              [129.52466881600003, 33.49754466400009],
              [129.54175866000003, 33.50731028900009],
              [129.5517684250001, 33.50690338700008],
              [129.55486087300005, 33.49982330900008],
              [129.55591881600003, 33.49396393400008],
            ],
          ],
          [
            [
              [132.64136803500003, 34.01406484600005],
              [132.643890821, 34.011419989000046],
              [132.64429772200003, 34.000881252000056],
              [132.64275149800005, 33.989935614000046],
              [132.640961134, 33.98395416900007],
              [132.63697350400003, 33.97923411700009],
              [132.63502037900003, 33.97483958500004],
              [132.63445071700005, 33.964829820000034],
              [132.62029056100005, 33.95380280200004],
              [132.60043379, 33.94989655200004],
              [132.58912194100003, 33.95644765800006],
              [132.5869246750001, 33.96967194200005],
              [132.59636478000004, 33.98094310100004],
              [132.6064559250001, 33.98920319200005],
              [132.6137801440001, 33.99404531500005],
              [132.61793053500003, 33.99567291900007],
              [132.62452233200008, 33.99909088700008],
              [132.63640384200005, 34.00828685100004],
              [132.64136803500003, 34.01406484600005],
            ],
          ],
          [
            [
              [133.09351647200003, 34.17430247600004],
              [133.09913170700008, 34.17519765800006],
              [133.10173587300005, 34.17096588700008],
              [133.09441165500004, 34.16038646000004],
              [133.04517662900003, 34.118394273000035],
              [133.0278426440001, 34.11155833500004],
              [133.01710045700008, 34.118841864000046],
              [133.01685631600003, 34.13629791900007],
              [133.0200301440001, 34.149644273000035],
              [133.02564537900003, 34.15444570500006],
              [133.0317488940001, 34.15412018400008],
              [133.03679446700005, 34.15326569200005],
              [133.03394616000003, 34.161363023000035],
              [133.02621504, 34.17617422100005],
              [133.03305097700002, 34.18939850500004],
              [133.05543053500003, 34.19354889500005],
              [133.07154381600003, 34.18805573100008],
              [133.0766707690001, 34.18065013200004],
              [133.0830184250001, 34.175034898000035],
              [133.09351647200003, 34.17430247600004],
            ],
          ],
          [
            [
              [132.73853600400003, 34.196966864000046],
              [132.75505618600005, 34.189113674000055],
              [132.76140384200005, 34.17715078300006],
              [132.75611412900003, 34.16746653900009],
              [132.747406446, 34.162543036000045],
              [132.74000084700003, 34.15989817900004],
              [132.73755944100003, 34.16160716400009],
              [132.7373153000001, 34.168402411000045],
              [132.73161868600005, 34.17133209800005],
              [132.7236434250001, 34.170803127000056],
              [132.69792728000004, 34.181341864000046],
              [132.68897545700008, 34.189886786000045],
              [132.69516035200002, 34.20014069200005],
              [132.7089949880001, 34.20331452000005],
              [132.728851759, 34.19879791900007],
              [132.73853600400003, 34.196966864000046],
            ],
          ],
          [
            [
              [132.92115319100003, 34.277329820000034],
              [132.92847741000003, 34.28400299700007],
              [132.93230228000004, 34.27484772300005],
              [132.92847741000003, 34.251939195000034],
              [132.91911868600005, 34.23289622600004],
              [132.91675866000003, 34.221869208000044],
              [132.90577233200008, 34.21308014500005],
              [132.88306725400003, 34.208644924000055],
              [132.86312910200002, 34.20848216400009],
              [132.849945509, 34.21515534100007],
              [132.84302819100003, 34.22842031500005],
              [132.84644616000003, 34.240220445000034],
              [132.8540145190001, 34.245021877000056],
              [132.85718834700003, 34.24583567900004],
              [132.88599694100003, 34.257025458000044],
              [132.89714603000004, 34.256740627000056],
              [132.9082137380001, 34.262884833000044],
              [132.92115319100003, 34.277329820000034],
            ],
          ],
          [
            [
              [132.3383895190001, 34.30442942900004],
              [132.3442488940001, 34.29564036700009],
              [132.34546959700003, 34.28656647300005],
              [132.34498131600003, 34.28196849200009],
              [132.325531446, 34.26471588700008],
              [132.2959090500001, 34.24323151200008],
              [132.2793074880001, 34.238348700000074],
              [132.267914259, 34.24445221600007],
              [132.26726321700005, 34.253607489000046],
              [132.28663170700008, 34.27912018400008],
              [132.2988387380001, 34.292222398000035],
              [132.3144637380001, 34.300441799000055],
              [132.3286238940001, 34.30621979400007],
              [132.3383895190001, 34.30442942900004],
            ],
          ],
          [
            [
              [133.715668165, 34.396144924000055],
              [133.72445722700002, 34.384466864000046],
              [133.72584069100003, 34.37140534100007],
              [133.72046959700003, 34.36383698100008],
              [133.7129012380001, 34.359442450000074],
              [133.70630944100003, 34.35464101800005],
              [133.7031356130001, 34.35175202000005],
              [133.6958113940001, 34.354803778000075],
              [133.6884871750001, 34.36615631700005],
              [133.6919051440001, 34.37840403900009],
              [133.70533287900003, 34.391791083000044],
              [133.70826256600003, 34.39728424700007],
              [133.715668165, 34.396144924000055],
            ],
          ],
          [
            [
              [135.20517916100005, 34.43049087500009],
              [135.24097098900006, 34.45464659500004],
              [135.2570542850001, 34.435778061000065],
              [135.22441622000008, 34.41630428000008],
              [135.21054196500006, 34.42190593600009],
              [135.20517916100005, 34.43049087500009],
            ],
          ],
          [
            [
              [134.04900149800005, 34.47435130400004],
              [134.0394800140001, 34.47829824400009],
              [134.03663170700008, 34.48078034100007],
              [134.03834069100003, 34.483303127000056],
              [134.04599043100006, 34.48765696800007],
              [134.05486087300005, 34.48883698100008],
              [134.07203209700003, 34.498480536000045],
              [134.083425326, 34.50071849200009],
              [134.08741295700008, 34.49782949400009],
              [134.09538821700005, 34.49197011900009],
              [134.10181725400003, 34.491441148000035],
              [134.1045028000001, 34.49026113500008],
              [134.102875196, 34.48094310100004],
              [134.0839949880001, 34.459824937000064],
              [134.0761824880001, 34.46076080900008],
              [134.06788170700008, 34.46670156500005],
              [134.06706790500004, 34.46702708500004],
              [134.04900149800005, 34.47435130400004],
            ],
          ],
          [
            [
              [136.891968442, 34.49669208000006],
              [136.8989915200001, 34.50405336600005],
              [136.90895254200007, 34.50236246700007],
              [136.9069063620001, 34.49414952200004],
              [136.902471106, 34.48606033400006],
              [136.89120225700003, 34.47970794400004],
              [136.8832042900001, 34.47536609000008],
              [136.8775363530001, 34.48317624300006],
              [136.87259894600004, 34.491139333000035],
              [136.891968442, 34.49669208000006],
            ],
          ],
          [
            [
              [136.89017871600004, 34.531200943000044],
              [136.8964736150001, 34.538411189000044],
              [136.9100523510001, 34.540109474000076],
              [136.90248620500006, 34.531974157000036],
              [136.9031747460001, 34.525015299000074],
              [136.8890634920001, 34.522552647000055],
              [136.87398509000002, 34.51341308800005],
              [136.85621599600006, 34.51013930400006],
              [136.84912737600007, 34.51503705200008],
              [136.86591662, 34.52132662400004],
              [136.89017871600004, 34.531200943000044],
            ],
          ],
          [
            [
              [136.79805969000006, 34.87640064000004],
              [136.810968999, 34.876305527000056],
              [136.82350283300002, 34.86203744100004],
              [136.82595147000006, 34.84907610000005],
              [136.81470086500008, 34.846306784000035],
              [136.81500242800007, 34.83991708900004],
              [136.8077305920001, 34.839196455000035],
              [136.79805969000006, 34.87640064000004],
            ],
          ],
          [
            [
              [137.04810631600003, 37.15228913000004],
              [137.045258009, 37.14508698100008],
              [137.04444420700008, 37.136704820000034],
              [137.0459090500001, 37.128119208000044],
              [137.03874759200005, 37.12010325700004],
              [137.02222741000003, 37.114447333000044],
              [137.00375410200002, 37.11347077000005],
              [136.98585045700008, 37.108303127000056],
              [136.9726668630001, 37.101629950000074],
              [136.963226759, 37.101548570000034],
              [136.9472762380001, 37.096991278000075],
              [136.943695509, 37.097357489000046],
              [136.93482506600003, 37.10814036700009],
              [136.91553795700008, 37.12775299700007],
              [136.9052840500001, 37.14362213700008],
              [136.911468946, 37.15094635600008],
              [136.91960696700005, 37.14744700700004],
              [136.92351321700005, 37.14008209800005],
              [136.92839603000004, 37.13776276200008],
              [136.93433678500003, 37.141791083000044],
              [136.94125410200002, 37.14443594000005],
              [136.9502059250001, 37.14476146000004],
              [136.959320509, 37.147365627000056],
              [136.96664472700002, 37.15180084800005],
              [136.9736434250001, 37.15326569200005],
              [136.98121178500003, 37.15131256700005],
              [136.98902428500003, 37.14533112200007],
              [136.9990340500001, 37.13947174700007],
              [137.00855553500003, 37.140611070000034],
              [137.01628665500004, 37.14484284100007],
              [137.02719160200002, 37.15521881700005],
              [137.04175866000003, 37.15973541900007],
              [137.04810631600003, 37.15228913000004],
            ],
          ],
          [
            [
              [123.60629316500012, 25.738999742000146],
              [123.60466556100016, 25.73875560100015],
              [123.60043379000001, 25.739365953000174],
              [123.60279381600003, 25.745469468000067],
              [123.60629316500012, 25.738999742000146],
            ],
          ],
          [
            [
              [123.54533938900022, 25.76178620000013],
              [123.52890058700007, 25.76178620000013],
              [123.51148522200015, 25.75808340100008],
              [123.51392662900014, 25.76911041900013],
              [123.53142337300005, 25.77334219000005],
              [123.53744550900012, 25.773260809000135],
              [123.54533938900022, 25.76178620000013],
            ],
          ],
          [
            [
              [123.67302493600016, 25.928697006999982],
              [123.67204837300017, 25.92747630400015],
              [123.67172285200013, 25.929754950000017],
              [123.67302493600016, 25.928697006999982],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Indian Ocean Ter.',
        iso3: '-99',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [96.86312910200007, -12.18173593499995],
              [96.86939537900008, -12.187920830999929],
              [96.84522545700003, -12.197686455999929],
              [96.83057701900003, -12.179945570999905],
              [96.82341556100005, -12.150974216999941],
              [96.82154381600003, -12.126560153999947],
              [96.82837975400008, -12.126560153999947],
              [96.82837975400008, -12.136325778999947],
              [96.82984459700003, -12.144463799999926],
              [96.83521569100003, -12.160577080999929],
              [96.83130944100003, -12.171482028999947],
              [96.83619225400008, -12.182061455999929],
              [96.84766686300003, -12.18718840899993],
              [96.86312910200007, -12.18173593499995],
            ],
          ],
          [
            [
              [96.90219160200007, -12.199965101999908],
              [96.89234459700003, -12.195896091999941],
              [96.88965905000003, -12.192803643999923],
              [96.88851972700007, -12.187432549999926],
              [96.90007571700005, -12.18678150799991],
              [96.90902754000007, -12.182061455999929],
              [96.91456139400003, -12.17351653399993],
              [96.91618899800005, -12.16179778399993],
              [96.92107181100005, -12.17351653399993],
              [96.92017662900008, -12.184991143999923],
              [96.91391035200007, -12.194512627999927],
              [96.90219160200007, -12.199965101999908],
            ],
          ],
          [
            [
              [105.70411217500003, -10.430840752999927],
              [105.71469160200007, -10.43718840899993],
              [105.71265709700003, -10.45094166499996],
              [105.71143639400003, -10.469903252999927],
              [105.70630944100003, -10.49423593499995],
              [105.70630944100003, -10.514255466999941],
              [105.69792728000004, -10.52898528399993],
              [105.69988040500004, -10.553399346999925],
              [105.69459069100003, -10.564873955999929],
              [105.67872155000003, -10.566013278999947],
              [105.67351321700005, -10.549086195999905],
              [105.66724694100003, -10.53329843499995],
              [105.66407311300003, -10.51848723799992],
              [105.64926191500007, -10.513116143999923],
              [105.62818444100003, -10.508965752999927],
              [105.60499108200003, -10.510023695999905],
              [105.58497155000003, -10.516371351999908],
              [105.58179772200003, -10.50481536299992],
              [105.59229576900003, -10.498467705999929],
              [105.59961998800003, -10.48056405999995],
              [105.59424889400003, -10.466729424999926],
              [105.59424889400003, -10.45403411299992],
              [105.60718834700003, -10.458428643999923],
              [105.62712649800005, -10.468926690999922],
              [105.65455162900003, -10.469903252999927],
              [105.66928144600007, -10.456231377999927],
              [105.68523196700005, -10.44036223799992],
              [105.70411217500003, -10.430840752999927],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Singapore',
        iso3: 'SGP',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [103.96078535200007, 1.391099351000094],
            [103.98568769600007, 1.385443427000041],
            [103.99952233200003, 1.38031647300005],
            [104.00342858200003, 1.374172268000052],
            [103.99187259200005, 1.35492584800005],
            [103.97486412900008, 1.334458726000094],
            [103.95435631600003, 1.318101304000038],
            [103.93189537900008, 1.311468817000048],
            [103.90723717500003, 1.308742580000057],
            [103.88770592500003, 1.301255601000094],
            [103.85271243600005, 1.277289130000042],
            [103.84693444100003, 1.271918036000045],
            [103.84408613400007, 1.268500067000048],
            [103.83887780000003, 1.26626211100006],
            [103.82601972700007, 1.26430898600006],
            [103.80160566500007, 1.264797268000052],
            [103.78956139400003, 1.26788971600007],
            [103.78443444100003, 1.273871161000045],
            [103.77588951900003, 1.287583726000094],
            [103.75513756600003, 1.297105210000041],
            [103.73015384200005, 1.302923895000049],
            [103.70875084700003, 1.305243231000077],
            [103.66529381600003, 1.304103908000059],
            [103.64763431100005, 1.308417059000078],
            [103.64039147200003, 1.322251695000091],
            [103.64470462300005, 1.338039455000057],
            [103.67457116000003, 1.38031647300005],
            [103.67888431100005, 1.399237372000073],
            [103.68384850400008, 1.409898179000038],
            [103.69507897200003, 1.42133209800005],
            [103.70834394600007, 1.429388739000046],
            [103.71794681100005, 1.430975653000075],
            [103.73975670700003, 1.428127346000053],
            [103.76221764400003, 1.430975653000075],
            [103.79004967500003, 1.444281317000048],
            [103.80494225400008, 1.448635158000059],
            [103.83155358200003, 1.447088934000078],
            [103.85718834700003, 1.438706773000092],
            [103.93246504000007, 1.40110911700009],
            [103.96078535200007, 1.391099351000094],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bahrain',
        iso3: 'BHR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [50.55160566500007, 26.194240627000056],
              [50.594737175000034, 26.160305080000057],
              [50.60487053991397, 26.17473159438857],
              [50.61989816690731, 26.18546561366953],
              [50.62633857847588, 26.170437986676188],
              [50.63277899004446, 26.146823144258082],
              [50.64565981318161, 26.145749742329986],
              [50.63550651826553, 26.134382379256266],
              [50.63492579390065, 26.115694488343305],
              [50.61475670700008, 26.111151434000078],
              [50.62061608200008, 26.05296458500004],
              [50.61841881600009, 25.96474844000005],
              [50.603526238000086, 25.85455963700008],
              [50.594493035000085, 25.83270905200004],
              [50.565440300000034, 25.78969961100006],
              [50.56527754000007, 25.789536851000037],
              [50.558604363000086, 25.81976959800005],
              [50.547211134000065, 25.85293203300006],
              [50.53142337300005, 25.885239976000037],
              [50.51140384200005, 25.913031317000048],
              [50.467784050000034, 25.957586981000077],
              [50.46045983200008, 25.985296942000048],
              [50.47999108200008, 26.018866278000075],
              [50.485443556000064, 26.03343333500004],
              [50.490896030000044, 26.048000393000052],
              [50.48519941500007, 26.085638739000046],
              [50.46998131600009, 26.12262604400007],
              [50.45297285200007, 26.149562893000052],
              [50.44890384200005, 26.16160716400009],
              [50.449554884000065, 26.17796458500004],
              [50.46119225400008, 26.22524648600006],
              [50.46851647200003, 26.236883856000077],
              [50.481455925000034, 26.242580471000053],
              [50.48161868600005, 26.242539781000062],
              [50.48259524800005, 26.242539781000062],
              [50.503916863000086, 26.242010809000078],
              [50.516368035000085, 26.23969147300005],
              [50.53239993600005, 26.23309967700004],
              [50.54542076900003, 26.227728583000044],
              [50.54550214900007, 26.227769273000035],
              [50.586680535000085, 26.24249909100007],
              [50.59327233200008, 26.23859284100007],
              [50.59742272200003, 26.225531317000048],
              [50.60474694100009, 26.216498114000046],
              [50.60694420700008, 26.21238841400009],
              [50.60914147200003, 26.208278713000084],
              [50.603526238000086, 26.197658596000053],
              [50.594086134000065, 26.19529857000009],
              [50.56560306100005, 26.198879299000055],
              [50.55160566500007, 26.194240627000056],
            ],
          ],
          [
            [
              [50.397703967791486, 26.17473159438857],
              [50.408437987072446, 26.171511388604284],
              [50.419172006353406, 26.166144378963804],
              [50.419172006353406, 26.14896994811427],
              [50.42131881020959, 26.135015723049026],
              [50.42346561406578, 26.119988096055685],
              [50.40521778128816, 26.12428170376807],
              [50.38589654658244, 26.123208301839973],
              [50.38052953694196, 26.13930933076141],
              [50.38267634079815, 26.15970396739523],
              [50.397703967791486, 26.17473159438857],
            ],
          ],
          [
            [
              [50.60165033412968, 26.278851581413857],
              [50.63277899004446, 26.287438796838625],
              [50.655320430534466, 26.27670477755767],
              [50.65639383246256, 26.261677150564328],
              [50.65639383246256, 26.246649523570987],
              [50.67142145945591, 26.227328288865262],
              [50.68430228259305, 26.221961279224782],
              [50.67893527295258, 26.208007054159538],
              [50.6735682633121, 26.20264004451906],
              [50.65746723439066, 26.211227259943826],
              [50.653173626678274, 26.22518148500907],
              [50.6478066170378, 26.239135710074315],
              [50.63385239197255, 26.242355915858603],
              [50.62097156883541, 26.244502719714795],
              [50.61238435341064, 26.241282513930507],
              [50.59950353027349, 26.262750552492424],
              [50.60165033412968, 26.278851581413857],
            ],
          ],
          [
            [
              [50.774310446595955, 25.721647752530224],
              [50.7825374054341, 25.720382066555125],
              [50.790764364272235, 25.726077653443067],
              [50.80088985207302, 25.73114039734346],
              [50.80088985207302, 25.724811967467968],
              [50.79835848012282, 25.715952165642282],
              [50.790764364272235, 25.705826677841497],
              [50.78317024842165, 25.69696687601581],
              [50.78823299232204, 25.692536975102968],
              [50.795827108172624, 25.68494285925238],
              [50.792030050247334, 25.679880115351988],
              [50.7800060334839, 25.682411487302183],
              [50.774310446595955, 25.67861442937689],
              [50.76608348775782, 25.671653156513848],
              [50.76228642983253, 25.667856098588555],
              [50.76671633074537, 25.654566395850026],
              [50.774310446595955, 25.64507375103679],
              [50.7762089755586, 25.6387453211613],
              [50.769247702695566, 25.636213949211104],
              [50.76545064477027, 25.629885519335613],
              [50.76418495879518, 25.621658560497476],
              [50.769880545683115, 25.61786150257218],
              [50.774310446595955, 25.61216591568424],
              [50.76798201672047, 25.6064703287963],
              [50.76228642983253, 25.597610526970612],
              [50.75722368593213, 25.588750725144923],
              [50.75975505788233, 25.582422295269435],
              [50.75659084294458, 25.579890923319237],
              [50.7451996691687, 25.58495366721963],
              [50.73760555331811, 25.595711998007964],
              [50.74140261124341, 25.6052046428212],
              [50.748996727093996, 25.621025717509927],
              [50.748363884106446, 25.630518362323162],
              [50.748363884106446, 25.64444090804924],
              [50.73950408228076, 25.653300709874927],
              [50.74013692526831, 25.662160511700613],
              [50.74140261124341, 25.674184528464046],
              [50.7451996691687, 25.687474231202575],
              [50.755325156969484, 25.702029619916203],
              [50.768614859708016, 25.71658500862983],
              [50.774310446595955, 25.721647752530224],
            ],
          ],
          [
            [
              [50.775576132571054, 25.75265705892013],
              [50.78317024842165, 25.755821273857872],
              [50.790131521284685, 25.755188430870323],
              [50.791397207259784, 25.74886000099483],
              [50.78063887647145, 25.745062943069538],
              [50.775576132571054, 25.75265705892013],
            ],
          ],
          [
            [
              [50.80468690999831, 25.67924727236444],
              [50.81987514169949, 25.67861442937689],
              [50.81671092676174, 25.669121784563654],
              [50.80848396792361, 25.66405904066326],
              [50.80405406701076, 25.669754627551203],
              [50.80215553804812, 25.674817371451596],
              [50.80468690999831, 25.67924727236444],
            ],
          ],
          [
            [
              [50.79329573622243, 25.652035023899828],
              [50.79962416609792, 25.651402180912278],
              [50.811648182861354, 25.649503651949633],
              [50.81671092676174, 25.64444090804924],
              [50.815445240786644, 25.63684679219865],
              [50.811648182861354, 25.63178404829826],
              [50.80785112493606, 25.633049734273357],
              [50.80278838103567, 25.634315420248456],
              [50.795827108172624, 25.633049734273357],
              [50.790764364272235, 25.630518362323162],
              [50.78633446335939, 25.6387453211613],
              [50.78823299232204, 25.64380806506169],
              [50.78506877738429, 25.648237965974534],
              [50.78696730634694, 25.652667866887377],
              [50.79329573622243, 25.652035023899828],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Spratly Is.',
        iso3: '-99',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [115.36719811300009, 10.237494208000044],
              [115.36597741000003, 10.239162502000056],
              [115.36793053500003, 10.239162502000056],
              [115.36719811300009, 10.237494208000044],
            ],
          ],
          [
            [
              [114.37322024800005, 9.687648830000057],
              [114.37468509200005, 9.68976471600007],
              [114.37867272200003, 9.692694403000075],
              [114.38103274800005, 9.692206122000073],
              [114.38184655000009, 9.69017161700009],
              [114.38184655000009, 9.689642645000049],
              [114.38086998800009, 9.686224677000041],
              [114.37647545700008, 9.680121161000045],
              [114.373383009, 9.679510809000078],
              [114.37061608200008, 9.681382554000038],
              [114.37086022200003, 9.684149481000077],
              [114.37322024800005, 9.687648830000057],
            ],
          ],
          [
            [
              [114.029633009, 10.011867580000057],
              [114.027679884, 10.015122789000088],
              [114.02930748800009, 10.017401434000078],
              [114.03777103000004, 10.021063544000071],
              [114.04004967500009, 10.019476630000042],
              [114.03394616000003, 10.012396552000041],
              [114.029633009, 10.011867580000057],
            ],
          ],
          [
            [
              [114.36540774800005, 10.175482489000046],
              [114.36036217500009, 10.176255601000037],
              [114.35865319100003, 10.179348049000055],
              [114.35889733200008, 10.183417059000078],
              [114.36304772200003, 10.187079169000071],
              [114.36597741000003, 10.187201239000046],
              [114.36980228000004, 10.18390534100007],
              [114.37126712300005, 10.180487372000073],
              [114.36540774800005, 10.175482489000046],
            ],
          ],
          [
            [
              [114.46420332100001, 10.367377020000049],
              [114.46168053500003, 10.372015692000048],
              [114.46461022200003, 10.37799713700008],
              [114.46697024800005, 10.37836334800005],
              [114.46973717500009, 10.376654364000046],
              [114.47095787900003, 10.372300523000092],
              [114.46843509200005, 10.367743231000077],
              [114.46420332100001, 10.367377020000049],
            ],
          ],
          [
            [
              [114.36378014400009, 10.367865302000041],
              [114.35889733200008, 10.372544664000088],
              [114.35816491000003, 10.377427476000037],
              [114.36036217500009, 10.378566799000055],
              [114.36638431100005, 10.37400950700004],
              [114.36784915500004, 10.370835679000038],
              [114.36695397200003, 10.368068752000056],
              [114.36378014400009, 10.367865302000041],
            ],
          ],
          [
            [
              [114.45484459700003, 10.388332424000055],
              [114.45020592500009, 10.389797268000052],
              [114.44996178500003, 10.39443594000005],
              [114.45191491000003, 10.396633205000057],
              [114.45492597700002, 10.39720286700009],
              [114.45834394600001, 10.395819403000075],
              [114.45980879000001, 10.392726955000057],
              [114.45484459700003, 10.388332424000055],
            ],
          ],
          [
            [
              [115.83057701900009, 10.73460521000004],
              [115.83139082100001, 10.734198309000078],
              [115.83399498800009, 10.729437567000048],
              [115.83269290500004, 10.727728583000044],
              [115.830414259, 10.727443752000056],
              [115.82496178500003, 10.726752020000049],
              [115.81836998800009, 10.720851955000057],
              [115.81462649800005, 10.723334052000041],
              [115.812836134, 10.727687893000052],
              [115.81462649800005, 10.734320380000042],
              [115.81788170700008, 10.73509349200009],
              [115.82813561300009, 10.735988674000055],
              [115.83057701900009, 10.73460521000004],
            ],
          ],
          [
            [
              [115.84034264400009, 10.823187567000048],
              [115.83375084700003, 10.824042059000078],
              [115.83025149800005, 10.827704169000071],
              [115.82960045700008, 10.831773179000038],
              [115.83122806100005, 10.83344147300005],
              [115.84148196700005, 10.832709052000041],
              [115.84473717500009, 10.831284898000092],
              [115.84522545700008, 10.831203518000052],
              [115.84880618600005, 10.82640208500004],
              [115.84693444100003, 10.823391018000052],
              [115.84571373800009, 10.822414455000057],
              [115.84034264400009, 10.823187567000048],
            ],
          ],
          [
            [
              [114.27857506600003, 11.040432033000059],
              [114.27165774800005, 11.043524481000077],
              [114.27222741000003, 11.045843817000048],
              [114.27857506600003, 11.050034898000092],
              [114.28272545700008, 11.05068594000005],
              [114.28687584700003, 11.046616929000038],
              [114.28305097700002, 11.04100169500009],
              [114.27857506600003, 11.040432033000059],
            ],
          ],
          [
            [
              [115.01840254000001, 11.107123114000046],
              [115.01384524800005, 11.10765208500004],
              [115.00912519600001, 11.113226630000042],
              [115.010101759, 11.115912177000041],
              [115.01238040500004, 11.115301825000074],
              [115.02076256600003, 11.117987372000073],
              [115.02165774800005, 11.114569403000075],
              [115.02035566500001, 11.10927969000005],
              [115.01840254000001, 11.107123114000046],
            ],
          ],
          [
            [
              [114.36133873800009, 9.76711660400008],
              [114.35995527400007, 9.770046291000085],
              [114.36280358200008, 9.769110419000071],
              [114.36133873800009, 9.76711660400008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Macao',
        iso3: 'MAC',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [113.55860436300009, 22.163031317000048],
              [113.56942793100006, 22.16075267100007],
              [113.57406660200002, 22.16075267100007],
              [113.57406660200002, 22.15611399900007],
              [113.57178795700008, 22.152899481000077],
              [113.56788170700008, 22.15058014500005],
              [113.56324303500003, 22.15058014500005],
              [113.56023196700005, 22.141546942000048],
              [113.56763756600003, 22.139064846000053],
              [113.57252037900003, 22.13731517100007],
              [113.57797285200002, 22.13963450700004],
              [113.57797285200002, 22.13808828300006],
              [113.57488040500004, 22.13503652600008],
              [113.57976321700005, 22.13190338700008],
              [113.58594811300009, 22.13194407800006],
              [113.58668053500003, 22.12954336100006],
              [113.58749433700007, 22.12722402600008],
              [113.58749433700007, 22.12486399900007],
              [113.58594811300009, 22.12409088700008],
              [113.58358808700007, 22.12331777600008],
              [113.57748457100001, 22.126654364000046],
              [113.57797285200002, 22.120917059000078],
              [113.57406660200002, 22.11937083500004],
              [113.57097415500004, 22.120143947000088],
              [113.566742384, 22.12335846600007],
              [113.56666100400003, 22.11737702000005],
              [113.56519616000003, 22.112616278000075],
              [113.5663354830001, 22.10769277600008],
              [113.56324303500003, 22.10691966400009],
              [113.55738366000003, 22.111151434000078],
              [113.55225670700008, 22.10769277600008],
              [113.55152428500003, 22.10614655200004],
              [113.549164259, 22.10537344000005],
              [113.5468042330001, 22.10537344000005],
              [113.54371178500003, 22.10769277600008],
              [113.54110761800007, 22.11326732000009],
              [113.545258009, 22.11424388200004],
              [113.54232832100001, 22.140733140000066],
              [113.54224694100003, 22.14081452000005],
              [113.53410892000011, 22.148789781000062],
              [113.53223717500009, 22.15253327000005],
              [113.53223717500009, 22.15261465100008],
              [113.53443444100003, 22.16120026200008],
              [113.5414331390001, 22.16233958500004],
              [113.54297936300009, 22.163804429000038],
              [113.55290774800005, 22.165838934000078],
              [113.55860436300009, 22.163031317000048],
            ],
          ],
          [
            [
              [113.53646894600001, 22.21706777600008],
              [113.53891035200002, 22.220770575000074],
              [113.54452558700007, 22.217678127000056],
              [113.54452558700007, 22.216131903000075],
              [113.5507104830001, 22.21385325700004],
              [113.55380293100006, 22.211493231000077],
              [113.55559329500011, 22.207546291000085],
              [113.55681399800005, 22.203558661000045],
              [113.55152428500003, 22.204413153000075],
              [113.54843183700007, 22.202053127000056],
              [113.549164259, 22.199733791000085],
              [113.5507104830001, 22.198960679000038],
              [113.55713951900009, 22.202460028000075],
              [113.55380293100006, 22.196641343000067],
              [113.55380293100006, 22.195868231000077],
              [113.55225670700008, 22.197414455000057],
              [113.5507104830001, 22.195868231000077],
              [113.55152428500003, 22.194199937000064],
              [113.55152428500003, 22.191880601000037],
              [113.55152428500003, 22.191107489000046],
              [113.55152428500003, 22.189561265000066],
              [113.54843183700007, 22.188055731000077],
              [113.54297936300009, 22.18419017100007],
              [113.53988691500001, 22.182643947000088],
              [113.53598066500001, 22.182643947000088],
              [113.53288821700005, 22.17869700700004],
              [113.52890058700007, 22.17869700700004],
              [113.524831576, 22.17381419500009],
              [113.52475019600001, 22.17373281500005],
              [113.519867384, 22.183742580000057],
              [113.52019290500004, 22.184881903000075],
              [113.52214603000004, 22.19049713700008],
              [113.524831576, 22.193060614000046],
              [113.52540123800009, 22.19363027600008],
              [113.53036543100006, 22.201524156000062],
              [113.53524824300007, 22.207546291000085],
              [113.53370201900009, 22.210760809000078],
              [113.53207441500001, 22.210760809000078],
              [113.53288821700005, 22.20917389500005],
              [113.52735436300009, 22.207546291000085],
              [113.52434329500011, 22.212551174000055],
              [113.52890058700007, 22.21385325700004],
              [113.52890058700007, 22.214626369000086],
              [113.53524824300007, 22.214626369000086],
              [113.53646894600001, 22.21706777600008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Scarborough Reef',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [117.75388717800001, 15.154369263000092],
            [117.75569233100009, 15.151887178000038],
            [117.75388717800001, 15.150082025000074],
            [117.75185638100004, 15.151887178000038],
            [117.75388717800001, 15.154369263000092],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Chile',
        iso3: 'CHL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-69.51008875199994, -17.506588197999946],
              [-69.50611446099992, -17.585127054999916],
              [-69.49712276299996, -17.621403909999884],
              [-69.47578039599998, -17.652409769999906],
              [-69.39477758799995, -17.72113942499996],
              [-69.35940506999995, -17.759379983999864],
              [-69.33423864799991, -17.805785420999968],
              [-69.32764990299992, -17.841545510999893],
              [-69.32687475599991, -17.915132750999888],
              [-69.31785721899988, -17.951616312999903],
              [-69.30240596499996, -17.976214293999888],
              [-69.29002945999991, -17.9766277049999],
              [-69.27760127799993, -17.967532653999925],
              [-69.26204667199991, -17.964018655999965],
              [-69.24189286399991, -17.986756286999935],
              [-69.2348131919999, -17.99295745799992],
              [-69.22778519799988, -17.995541279999927],
              [-69.20416906799997, -18.00112233499995],
              [-69.17388667799995, -18.01889902799988],
              [-69.15771195499985, -18.025720315999934],
              [-69.14083959999996, -18.0307846069999],
              [-69.11988480699998, -18.029854430999947],
              [-69.1041751709999, -18.0237566119999],
              [-69.0920570479999, -18.02334319999997],
              [-69.08228408699998, -18.039077667999962],
              [-69.08172176199992, -18.039983011999908],
              [-69.08921484399994, -18.08308115699991],
              [-69.12593094999991, -18.111089782999926],
              [-69.15543819299992, -18.140235289999936],
              [-69.14120133499995, -18.18684743299991],
              [-69.11066056399997, -18.21795664499996],
              [-69.10035111499988, -18.234286396999906],
              [-69.09694047099993, -18.25754079099991],
              [-69.09683711799991, -18.267979430999944],
              [-69.0957519129999, -18.276764423999936],
              [-69.08102412999992, -18.319139098999955],
              [-69.07929296899994, -18.32802744599988],
              [-69.08187678999994, -18.38249440499996],
              [-69.07782019099994, -18.39882415799991],
              [-69.04169836499992, -18.457735289999917],
              [-69.03438614899994, -18.478302510999896],
              [-69.03490291399987, -18.501040139999887],
              [-69.0416466879999, -18.54889251699997],
              [-69.04283524599992, -18.600465596999896],
              [-69.03384354699989, -18.6494548539999],
              [-69.01014990299987, -18.689762471999956],
              [-69.00348364299995, -18.70268157999996],
              [-69.0011065269999, -18.716220804999935],
              [-69.00317358499987, -18.729553323999966],
              [-69.01053747599985, -18.742989196999915],
              [-69.0106666669999, -18.74371266699991],
              [-69.01053747599985, -18.744539488999933],
              [-69.01014990299987, -18.745262959999934],
              [-68.95464941499998, -18.85698740699989],
              [-68.95144547599992, -18.867322692999906],
              [-68.95178137199989, -18.88933685299989],
              [-68.95984289599988, -18.907837015999903],
              [-68.98960852099987, -18.946490986999905],
              [-68.97397639999991, -18.95620615599995],
              [-68.96170324699989, -18.969435322999942],
              [-68.94315140899994, -19.001164651999957],
              [-68.91969030799987, -19.05377126099995],
              [-68.90850235999994, -19.06793060299991],
              [-68.8947822669999, -19.076508890999932],
              [-68.84736914099992, -19.09201181999994],
              [-68.81540726799994, -19.113302509999926],
              [-68.72125280799986, -19.191747334999945],
              [-68.69846350099996, -19.215621845999934],
              [-68.66332352699993, -19.27360280299989],
              [-68.63572831299993, -19.290552672999894],
              [-68.60007157499993, -19.303368428999974],
              [-68.49320471199991, -19.376955667999965],
              [-68.4725858159999, -19.395455830999893],
              [-68.45501582899993, -19.415402933999914],
              [-68.4476260989999, -19.43462656699994],
              [-68.45610103399991, -19.44124114999994],
              [-68.49635697499986, -19.458397724999898],
              [-68.51020625799993, -19.47162689199989],
              [-68.53211706599987, -19.50087575299993],
              [-68.53211706599987, -19.50097910599996],
              [-68.57673588299994, -19.56460698499997],
              [-68.63097408099992, -19.64195241299997],
              [-68.64859574399992, -19.66034922299987],
              [-68.69029862499985, -19.695385843999887],
              [-68.70321773299986, -19.715539652999965],
              [-68.70543981899996, -19.733833109999935],
              [-68.69841182499994, -19.746338805999926],
              [-68.6503527429999, -19.781582132999915],
              [-68.61888179599995, -19.81341481499996],
              [-68.60157019099995, -19.825403747999914],
              [-68.5708227129999, -19.837599385999923],
              [-68.56110754399995, -19.84431732099995],
              [-68.55351110799998, -19.857856546999926],
              [-68.55252925699992, -19.864884540999938],
              [-68.55154740499995, -19.89444346099988],
              [-68.5469482009999, -19.908189391999912],
              [-68.54291743999991, -19.91418385799993],
              [-68.54157385299993, -19.92038502999992],
              [-68.54462276199988, -19.93475107799992],
              [-68.56493159999988, -19.981363219999892],
              [-68.5661201579999, -20.0008969109999],
              [-68.5745434159999, -20.035210062999923],
              [-68.5793493249999, -20.04544199599991],
              [-68.58834102399993, -20.055570576999955],
              [-68.59717769399995, -20.056707457999963],
              [-68.60777136199994, -20.05360687299992],
              [-68.62213741099993, -20.0513331089999],
              [-68.65288488799987, -20.054226988999886],
              [-68.7755388999999, -20.08967702199992],
              [-68.79259212199995, -20.106626891999923],
              [-68.78946569899989, -20.125850524999947],
              [-68.75902827999991, -20.144143981999918],
              [-68.72626542199993, -20.150965270999876],
              [-68.7232681889999, -20.160990498999894],
              [-68.72828080299988, -20.189619242999882],
              [-68.7294693609999, -20.228686624999895],
              [-68.71804886899989, -20.261966247999936],
              [-68.67851639899993, -20.32862884499994],
              [-68.73515376899994, -20.347542419999883],
              [-68.75768469299996, -20.36428558399993],
              [-68.76902766999984, -20.390537210999966],
              [-68.76541031999994, -20.421233012],
              [-68.75070837399997, -20.451825459999924],
              [-68.72967606599985, -20.479213968999957],
              [-68.70755855399995, -20.50091807099996],
              [-68.68554439299996, -20.51683441099989],
              [-68.58332841099988, -20.563033141999938],
              [-68.5363028569999, -20.591765237999937],
              [-68.51020625799993, -20.601893818999898],
              [-68.48095739799987, -20.624734802999896],
              [-68.48162919099985, -20.643028258999962],
              [-68.55020381699998, -20.6990455119999],
              [-68.56508662999994, -20.719509378999945],
              [-68.57278641799991, -20.742867126999982],
              [-68.5719595949999, -20.87236826599988],
              [-68.55511307799992, -20.91391611699997],
              [-68.53155442599987, -20.927688032999924],
              [-68.51020625799993, -20.94016774499991],
              [-68.49599523899985, -20.941614684999905],
              [-68.45393062299993, -20.9397543339999],
              [-68.43207149299988, -20.945025328999918],
              [-68.41631018099991, -20.959804788999932],
              [-68.20753739499989, -21.284332783999915],
              [-68.19373978699994, -21.32846445699991],
              [-68.19844234199991, -21.571860452999942],
              [-68.19058752499987, -21.60638030999992],
              [-68.12836909999987, -21.712316996999988],
              [-68.10759517399993, -21.789624938999907],
              [-68.09622635999995, -21.953955993999955],
              [-68.09204056899989, -21.968425394999898],
              [-68.08273881099987, -21.98031097399992],
              [-68.05876094599995, -22.000774840999966],
              [-68.01023677599997, -22.044906513999962],
              [-67.99018632099992, -22.057618916999928],
              [-67.97261633299985, -22.078806253999886],
              [-67.96062740099998, -22.102887470999917],
              [-67.95716507999995, -22.12459157299992],
              [-67.96062740099998, -22.133686624999896],
              [-67.97328812699993, -22.150429788999944],
              [-67.97659541899992, -22.159834899999893],
              [-67.97302974499988, -22.170583597999922],
              [-67.94496944199994, -22.208307392999956],
              [-67.93597774299991, -22.23228525799989],
              [-67.93478918499997, -22.251715596999958],
              [-67.9522041429999, -22.314140726999923],
              [-67.95189408399992, -22.33408782899994],
              [-67.94527950099993, -22.35424163799992],
              [-67.9069355879999, -22.420077411999912],
              [-67.89820227099992, -22.441471455999917],
              [-67.88967565999991, -22.49118418299993],
              [-67.85918656499993, -22.547304788999966],
              [-67.8587214769999, -22.566838479999973],
              [-67.89132930499997, -22.715666605999914],
              [-67.89148433499992, -22.792871195999894],
              [-67.88709183799992, -22.81870941199992],
              [-67.8763431399999, -22.833592223999872],
              [-67.83794754999985, -22.840826923999927],
              [-67.83303828999993, -22.840103454999934],
              [-67.81128251099992, -22.871626077999892],
              [-67.80358272299992, -22.878654072999907],
              [-67.77143998299988, -22.888679300999925],
              [-67.61677242099995, -22.89725758799996],
              [-67.54711258999993, -22.892503356999967],
              [-67.51026729399993, -22.885785420999937],
              [-67.19390417499997, -22.82222340899996],
              [-67.01396683799987, -23.00071380599988],
              [-67.0195478919999, -23.03192637099994],
              [-67.03727290899991, -23.08535980199987],
              [-67.10744950399987, -23.297749938999885],
              [-67.17767777499995, -23.510243428999914],
              [-67.24790604699984, -23.72273691799994],
              [-67.2513287399999, -23.73309062599988],
              [-67.28473211096949, -23.834136437456095],
              [-67.31813431899991, -23.935178730999965],
              [-67.3397867429999, -24.000601094999936],
              [-67.36236934499993, -24.03036671899993],
              [-67.41228877799992, -24.05558481799997],
              [-67.45218298399993, -24.069640807999903],
              [-67.46122635899991, -24.072948099999905],
              [-67.48122513899995, -24.080079447999935],
              [-67.50117224199994, -24.087107441999947],
              [-67.51026729399993, -24.09041473399995],
              [-67.63522090699988, -24.141471048999918],
              [-67.76022619699995, -24.192734069999943],
              [-67.8852314859999, -24.24389373699995],
              [-68.01023677599997, -24.29505340599995],
              [-68.06046626799991, -24.3143803909999],
              [-68.11064408399994, -24.333810729999882],
              [-68.16082189999989, -24.353137715999935],
              [-68.21105139199994, -24.37246470099997],
              [-68.24448604399993, -24.38538380999998],
              [-68.26241776499998, -24.396752623999888],
              [-68.26712032099996, -24.4041940299999],
              [-68.27683548999991, -24.432306009999934],
              [-68.31404252199991, -24.487289733999972],
              [-68.32680659999988, -24.49824513699987],
              [-68.3448933519999, -24.499795430999967],
              [-68.36241166199994, -24.49421437599996],
              [-68.3798266199999, -24.491113789999915],
              [-68.39765498899993, -24.500518899999875],
              [-68.43770422399993, -24.57968719499989],
              [-68.44437048399993, -24.61017628999987],
              [-68.45150183199988, -24.629296569999966],
              [-68.46281896999994, -24.623302103999933],
              [-68.48183589699991, -24.598807474999973],
              [-68.49553015099994, -24.601804707999904],
              [-68.50369502799995, -24.61234669999996],
              [-68.50803584899992, -24.62681610099989],
              [-68.51020625799993, -24.641285501999917],
              [-68.52131669099992, -24.67528859399995],
              [-68.5723730069999, -24.769856465999865],
              [-68.5785741789999, -24.79166391999989],
              [-68.57800573799994, -24.80871714299991],
              [-68.55516475499994, -24.862150572999937],
              [-68.55103063999991, -24.868765156999928],
              [-68.54157385299993, -24.877446797999895],
              [-68.51759598799993, -24.890055846999914],
              [-68.51020625799993, -24.895533548999907],
              [-68.48994909699991, -24.89584360699989],
              [-68.47930375199991, -24.899564309999903],
              [-68.47305090399993, -24.907935892999973],
              [-68.46571284999993, -24.922095234999915],
              [-68.46684973199984, -24.923128764],
              [-68.46860672999992, -24.92695281999994],
              [-68.4696402589999, -24.93201710999992],
              [-68.46907181799995, -24.936771341999915],
              [-68.46514440899998, -24.941422220999883],
              [-68.45387894799993, -24.949277037999906],
              [-68.45000321499995, -24.95392791699996],
              [-68.44493892499989, -24.961576029999947],
              [-68.4398229579999, -24.967570495999965],
              [-68.43739416599993, -24.974081725999937],
              [-68.44013301599998, -24.98369354199987],
              [-68.4435436609999, -25.02110727899992],
              [-68.42049597199994, -25.051182962999903],
              [-68.3889733479999, -25.077537943999957],
              [-68.3673725999999, -25.103376158999964],
              [-68.36664912899991, -25.12342661499993],
              [-68.37920650199993, -25.13675913499995],
              [-68.39920528199985, -25.144820658999933],
              [-68.42075435399991, -25.1487480669999],
              [-68.44194169099995, -25.14812794999993],
              [-68.45837479699992, -25.144924010999958],
              [-68.4740327559999, -25.145440774999912],
              [-68.49304968299995, -25.155879414999944],
              [-68.49646779899987, -25.159996516999882],
              [-68.5160456959999, -25.18357798299988],
              [-68.55422846999991, -25.291191962999903],
              [-68.60596268699993, -25.43699920699993],
              [-68.60994177299992, -25.474206237999937],
              [-68.60823644999994, -25.492913105999918],
              [-68.6029137779999, -25.510689798999948],
              [-68.56658524599993, -25.5517208859999],
              [-68.5550097249999, -25.572598163999956],
              [-68.56880733299994, -25.5877910359999],
              [-68.55960892699994, -25.60856496199993],
              [-68.56095251499991, -25.635229999999893],
              [-68.55935054599988, -25.66303192099994],
              [-68.54131547099988, -25.687319844999934],
              [-68.52188513199988, -25.705613301999904],
              [-68.5075707609999, -25.728867695999924],
              [-68.49847570799992, -25.754912617999906],
              [-68.48638342299995, -25.836561380999896],
              [-68.41708532699991, -26.09359995499993],
              [-68.40902380499992, -26.144242857999885],
              [-68.41987585499987, -26.179279479999906],
              [-68.54612137899997, -26.269093118999905],
              [-68.57516353399987, -26.303509623999958],
              [-68.58735917199988, -26.338029479999932],
              [-68.59392207899987, -26.37864715599997],
              [-68.59531734299995, -26.457298685999945],
              [-68.5874108489999, -26.5082516479999],
              [-68.57015091999992, -26.5506263219999],
              [-68.54420935099995, -26.589280293999906],
              [-68.51020625799993, -26.62907114699992],
              [-68.32014034099987, -26.870090026],
              [-68.30536088099987, -26.897995300999895],
              [-68.30210526499988, -26.92662404299996],
              [-68.30742793799993, -26.94460744199995],
              [-68.32380936699988, -26.980987649999932],
              [-68.3291320399999, -27.000107929999928],
              [-68.33114741999987, -27.012200214999922],
              [-68.32840856999991, -27.03741831399988],
              [-68.33047562699988, -27.04496307299992],
              [-68.33776200399987, -27.045583190999892],
              [-68.36649410099997, -27.043516132999926],
              [-68.37734615099993, -27.04444630899988],
              [-68.4221496179999, -27.062016296999943],
              [-68.4430785729999, -27.06666717499992],
              [-68.49423824099998, -27.068630879999944],
              [-68.51800939899994, -27.07689910899998],
              [-68.53976517799995, -27.09033498099994],
              [-68.55738684099992, -27.10738820399989],
              [-68.56916906799992, -27.129505716999887],
              [-68.57537023999993, -27.14934946699988],
              [-68.58586055499995, -27.162785338999925],
              [-68.61071691899991, -27.165679219999916],
              [-68.64947424299996, -27.151209818999888],
              [-68.68285721899991, -27.12692189499998],
              [-68.71861730999984, -27.106664733999892],
              [-68.76429927599986, -27.104597676999916],
              [-68.80109289599994, -27.11276255299994],
              [-68.81432206199995, -27.120307311999895],
              [-68.82902400699993, -27.13601694699996],
              [-68.87075272699988, -27.198442077999914],
              [-68.87971858799992, -27.22148976699988],
              [-68.88137223299987, -27.23905975299995],
              [-68.87930517599992, -27.27854054799988],
              [-68.88305171699992, -27.294973652999943],
              [-68.93144669599988, -27.39522593199989],
              [-68.94263464399992, -27.40886850999989],
              [-68.95862849999986, -27.421064147999914],
              [-68.99358760599995, -27.437703958999933],
              [-69.01014990299987, -27.448866067999873],
              [-69.01741044199991, -27.460441588999913],
              [-69.02051102699997, -27.473360697999922],
              [-69.01989091099989, -27.48689992299998],
              [-69.01627355999992, -27.5001290889999],
              [-69.01901240999987, -27.524313659999862],
              [-69.02857255099985, -27.55128875699998],
              [-69.05386816399994, -27.59965789699993],
              [-69.0629890539999, -27.609993183999933],
              [-69.08554581799984, -27.6293201699999],
              [-69.09234126899989, -27.640172220999943],
              [-69.09321976799993, -27.65650197399988],
              [-69.08745784599995, -27.66921437599993],
              [-69.08001643899993, -27.68151336599996],
              [-69.07583064799991, -27.69618947399995],
              [-69.08110164399994, -27.703837585999935],
              [-69.10833512399992, -27.7158265179999],
              [-69.11820532299993, -27.722131041999916],
              [-69.12432897999989, -27.734430032999953],
              [-69.13406045699995, -27.772343536999884],
              [-69.17300817899991, -27.924082539999887],
              [-69.19019059299987, -27.951367695999892],
              [-69.21589961799995, -27.96852427099995],
              [-69.27514664799986, -27.982890319999868],
              [-69.29106298899998, -27.98940155099993],
              [-69.30323278799989, -27.999530130999887],
              [-69.31310298699987, -28.014516296999943],
              [-69.31377478099995, -28.022681171999878],
              [-69.31093257699987, -28.029295755999968],
              [-69.31175939999991, -28.036530456999927],
              [-69.33082800299988, -28.05244679799995],
              [-69.36715653599995, -28.130374857999925],
              [-69.38986832699993, -28.162000833999926],
              [-69.4118824869999, -28.202515156999937],
              [-69.4203057449999, -28.212643737999983],
              [-69.43562780799996, -28.208509622999955],
              [-69.45606583699993, -28.195797220999907],
              [-69.47616796899987, -28.18794240299988],
              [-69.49050817899987, -28.19838104199991],
              [-69.50123103899998, -28.25036753299993],
              [-69.51009354699988, -28.267524108999893],
              [-69.5535275879999, -28.31785695399988],
              [-69.60732275399991, -28.356304219999913],
              [-69.65303055899992, -28.397852070999903],
              [-69.65404516399985, -28.40099354799996],
              [-69.6723575449999, -28.457693379999867],
              [-69.67483801299994, -28.563113300999916],
              [-69.67840368699993, -28.57386199899993],
              [-69.68512162299996, -28.577789408999905],
              [-69.69320898499984, -28.579753112999924],
              [-69.70088293499992, -28.584403991999892],
              [-69.72207027199988, -28.610655618999928],
              [-69.74085465599998, -28.640627949999967],
              [-69.7533861899999, -28.67339080799988],
              [-69.7559183359999, -28.707703958999986],
              [-69.75106075099987, -28.729821471999912],
              [-69.73638464399997, -28.772402851999885],
              [-69.73276729299991, -28.794313658999926],
              [-69.73584204099993, -28.812400410999942],
              [-69.76483251999991, -28.858599141999903],
              [-69.76682206199985, -28.867590840999938],
              [-69.76643448999994, -28.87585906999989],
              [-69.76731298899998, -28.884230651999957],
              [-69.77312658699987, -28.892705586999867],
              [-69.78539973999989, -28.90583140099993],
              [-69.79506323299992, -28.920817565999897],
              [-69.80278885999991, -28.939937845999893],
              [-69.80661291499987, -28.959884948999914],
              [-69.80630285699988, -28.980142109999917],
              [-69.80167781599991, -28.99998585999991],
              [-69.79576086499992, -29.050111998999924],
              [-69.79723364299991, -29.076673684999946],
              [-69.80392574099992, -29.098687845999933],
              [-69.82232255099993, -29.120081887999945],
              [-69.84436254899992, -29.12928029399994],
              [-69.89448868899984, -29.13723846499991],
              [-69.9109476319999, -29.14323293099993],
              [-69.91472001199992, -29.148813984999947],
              [-69.9152884529999, -29.156152037999945],
              [-69.9219805509999, -29.16803761799987],
              [-69.9326000579999, -29.17692596499998],
              [-69.95936844899995, -29.192118834999917],
              [-69.97505224599993, -29.204314472999926],
              [-69.9800648609999, -29.20586476699995],
              [-69.98505163699994, -29.20834523599993],
              [-69.98949580899995, -29.214443054999975],
              [-69.98810054599997, -29.220024109],
              [-69.97616328999993, -29.23345998099994],
              [-69.97474218799994, -29.240798033999937],
              [-69.98032324199994, -29.249996438999943],
              [-69.9893407799999, -29.25733449299993],
              [-69.99985693399987, -29.262915547999953],
              [-70.01001135299992, -29.26642954499991],
              [-70.03112117599994, -29.277178242999923],
              [-70.04065547799985, -29.29753875799996],
              [-70.0444795329999, -29.34611460399995],
              [-70.04261918099988, -29.363064473999955],
              [-70.03574621599992, -29.376913756999926],
              [-70.02698706099994, -29.38993621799996],
              [-70.01954565399993, -29.404405618999903],
              [-70.01001135299992, -29.45608205199993],
              [-70.0021823729999, -29.465590514999917],
              [-69.99613623099995, -29.47644256599996],
              [-69.99161454299991, -29.488121439999944],
              [-69.96846350099995, -29.583309427999907],
              [-69.96890275099986, -29.61307505299989],
              [-69.97293351299996, -29.643150735999953],
              [-69.97319189499993, -29.666095071999905],
              [-69.96350256399998, -29.685525410999972],
              [-69.93787105399991, -29.704749043999897],
              [-69.92935283799989, -29.71787711599997],
              [-69.92908605999995, -29.718288268999885],
              [-69.91559851099987, -29.80562143999991],
              [-69.92218725699988, -29.939566751999905],
              [-69.92797501699994, -29.976773782999913],
              [-69.94128169799987, -30.01305063899987],
              [-69.97562068699997, -30.058629251999946],
              [-69.98037491899987, -30.07247853599992],
              [-69.97324357099984, -30.08942840499992],
              [-69.9576631269999, -30.092735696999924],
              [-69.91867325899992, -30.08777475999996],
              [-69.88071691999988, -30.099763691999925],
              [-69.84973689899988, -30.126635436999933],
              [-69.83575842299987, -30.161878762999905],
              [-69.84896175099996, -30.199085794999917],
              [-69.85741084899988, -30.20549367299995],
              [-69.87707373099991, -30.213141784999934],
              [-69.88624629799989, -30.220996601999957],
              [-69.89074214699991, -30.228954772999927],
              [-69.8940236009999, -30.238049824999905],
              [-69.89808020099991, -30.256549987999932],
              [-69.8998630369999, -30.29437713599991],
              [-69.90280859399991, -30.312670592999964],
              [-69.91213619099992, -30.329517109999955],
              [-69.93802608299987, -30.355562031999924],
              [-69.96458776899988, -30.374785664999948],
              [-69.99445674599991, -30.388118183999964],
              [-70.030191, -30.397109882999914],
              [-70.06427160699988, -30.38925506599989],
              [-70.14692806099993, -30.35390838699989],
              [-70.17341223199992, -30.364657084999905],
              [-70.17377396699993, -30.382227070999974],
              [-70.14871089699992, -30.418710631999986],
              [-70.1439308269999, -30.43958791099996],
              [-70.15119136599989, -30.459741718999936],
              [-70.1637745779999, -30.470180358999883],
              [-70.17969091899994, -30.477105000999956],
              [-70.19697668499992, -30.486820169999902],
              [-70.21710465599989, -30.51513885499989],
              [-70.23539811199996, -30.591619974999958],
              [-70.25077185099994, -30.62655324299996],
              [-70.27020218899992, -30.657249043999897],
              [-70.27598994999988, -30.673062031999905],
              [-70.27986568299994, -30.69311248799994],
              [-70.2793489179999, -30.705618183999945],
              [-70.27661006699987, -30.715643412999967],
              [-70.27617081699995, -30.725565286999952],
              [-70.2822944749999, -30.737760924999876],
              [-70.30007116799993, -30.75812143999991],
              [-70.30503210499998, -30.76545949299991],
              [-70.31947566799991, -30.80080617199991],
              [-70.33921606499987, -30.938162129999924],
              [-70.33521114099997, -30.956042174999894],
              [-70.32513423699993, -30.97164845799992],
              [-70.30859777799995, -30.988184916999913],
              [-70.27986568299994, -31.01030242899992],
              [-70.26759252999992, -31.02384165399991],
              [-70.26655900099993, -31.036450703999932],
              [-70.27831538899991, -31.03944793699995],
              [-70.3209484459999, -31.03366017599997],
              [-70.33978450599992, -31.041721699999954],
              [-70.36249629799991, -31.073037617999972],
              [-70.3723923339999, -31.092157897999968],
              [-70.3808931079999, -31.121613463999964],
              [-70.39306290699992, -31.13763315899992],
              [-70.40864335099994, -31.150035501999895],
              [-70.42339697299994, -31.153756204999908],
              [-70.43561844999996, -31.14135386199993],
              [-70.44060522499993, -31.11882293699992],
              [-70.44809830699995, -31.097635598999958],
              [-70.46778702799992, -31.08936737099991],
              [-70.47980179899989, -31.096705423999907],
              [-70.5359224039999, -31.17256642699992],
              [-70.54140010599991, -31.188172708999957],
              [-70.54336381099995, -31.208119811999964],
              [-70.54289872299992, -31.24677378299988],
              [-70.54680029299988, -31.26455047599991],
              [-70.5689694829999, -31.304237975999897],
              [-70.56721248399992, -31.323048196999906],
              [-70.55990026899994, -31.341651712999948],
              [-70.5546551109999, -31.362942402999934],
              [-70.55778153499995, -31.381752623999944],
              [-70.57537735999995, -31.412965189999937],
              [-70.57899470999993, -31.431982116999905],
              [-70.57790950599991, -31.468879088999927],
              [-70.58137182599995, -31.505672708999924],
              [-70.59137121599989, -31.549597675999863],
              [-70.58976924699994, -31.567684427999964],
              [-70.58026078299986, -31.592282409999953],
              [-70.52721492499995, -31.684266458999943],
              [-70.49677750699988, -31.714548847999964],
              [-70.48631302899994, -31.7311886599999],
              [-70.48848343899994, -31.773873392999903],
              [-70.48398758999991, -31.79764455199995],
              [-70.47522843399992, -31.82007212399995],
              [-70.4641438399999, -31.83826222799989],
              [-70.42828039599996, -31.870094909999935],
              [-70.39399308299994, -31.87763966899989],
              [-70.35722530099986, -31.87650278699998],
              [-70.31332617299992, -31.8820838419999],
              [-70.29624711199989, -31.890972187999907],
              [-70.27500809799992, -31.90699188299996],
              [-70.25568111199988, -31.925698750999942],
              [-70.24446732699994, -31.942235208999932],
              [-70.24170263699997, -31.961458841999956],
              [-70.2476712649999, -31.974584655999934],
              [-70.25772233099994, -31.98616017599997],
              [-70.2672049569999, -32.00093963699989],
              [-70.27542150899984, -32.037784933],
              [-70.28469742899995, -32.04677663199995],
              [-70.31004471899985, -32.0477068079999],
              [-70.35231604099994, -32.0333407589999],
              [-70.37332250999992, -32.03039520299998],
              [-70.38748185299988, -32.041712340999965],
              [-70.38908382199992, -32.05308115599986],
              [-70.3846138109999, -32.06196950299997],
              [-70.36805151399992, -32.07705902099988],
              [-70.36120438699993, -32.08584401399996],
              [-70.35924068199992, -32.0936988319999],
              [-70.35991247599989, -32.11302581799994],
              [-70.35559749399991, -32.12263763399996],
              [-70.3389576829999, -32.13338633199989],
              [-70.3352369799999, -32.140000914999874],
              [-70.33686478699994, -32.14919931999988],
              [-70.34391861999995, -32.16573577899996],
              [-70.3455205899999, -32.17472747799991],
              [-70.34309179699991, -32.18692311599992],
              [-70.33130957099993, -32.208213805999904],
              [-70.33082360899994, -32.20958811899993],
              [-70.32725296999993, -32.21968597399993],
              [-70.32691707399994, -32.22878102599989],
              [-70.3297851159999, -32.24686777799991],
              [-70.32973343899991, -32.25554941799996],
              [-70.32180110799993, -32.28014739999995],
              [-70.30970882199995, -32.28831227599997],
              [-70.29250056999987, -32.290999450999905],
              [-70.26919449899995, -32.2990609739999],
              [-70.25611904399997, -32.31427788099995],
              [-70.24237443099986, -32.330273538999876],
              [-70.24531998699987, -32.40396413099998],
              [-70.22725907399985, -32.434659932999935],
              [-70.18852758899993, -32.45357350599997],
              [-70.17248205699988, -32.464942321999956],
              [-70.1608290209999, -32.4853028359999],
              [-70.15814184599986, -32.506490172999946],
              [-70.15979549199992, -32.52519704199993],
              [-70.1578834639999, -32.54245696999992],
              [-70.13772965499993, -32.56901865599994],
              [-70.14710892799988, -32.57211924299989],
              [-70.17057002799996, -32.572739358999954],
              [-70.1758926999999, -32.58049082499987],
              [-70.17876074299997, -32.58896575999995],
              [-70.18108618199992, -32.60756927499992],
              [-70.18044022699993, -32.630203551999955],
              [-70.15573889199993, -32.738414001999956],
              [-70.14002925699995, -32.76828297899989],
              [-70.0872676189999, -32.823266702999916],
              [-70.05432389399996, -32.85075856499989],
              [-70.0367797449999, -32.85975026399993],
              [-70.0143521729999, -32.867501729999944],
              [-70.00021866899996, -32.87659678099992],
              [-70.00016699299994, -32.88899912499997],
              [-70.01714270099987, -32.91659433999989],
              [-70.0242740489999, -32.93478444399992],
              [-70.03424759899991, -32.97695241299998],
              [-70.04248998999995, -32.99266204799994],
              [-70.05649430399987, -33.00134368899991],
              [-70.08892126499995, -33.00826833099998],
              [-70.10295141699987, -33.018293558999915],
              [-70.11119380799991, -33.038447366999975],
              [-70.10610066299995, -33.05259252099991],
              [-70.1052768559999, -33.054880472999955],
              [-70.09548417199994, -33.07131357899992],
              [-70.09217687999995, -33.09177744599988],
              [-70.10977270499993, -33.14944834299986],
              [-70.10946264699993, -33.169602151999925],
              [-70.10083268199989, -33.186862080999916],
              [-70.08569148799998, -33.201331481999944],
              [-70.05179174799989, -33.22530934599986],
              [-70.04112056599988, -33.23895192499997],
              [-70.01001135299992, -33.29910329199991],
              [-69.98386307799993, -33.294452412999945],
              [-69.94055822799996, -33.24287933399994],
              [-69.90528906299997, -33.23822845399988],
              [-69.86968400099991, -33.24959726999995],
              [-69.83684362899987, -33.26572031699993],
              [-69.81389929299993, -33.289491475999895],
              [-69.8056827389999, -33.34426849399998],
              [-69.78767350299992, -33.379408466999934],
              [-69.78674332699995, -33.399252217999916],
              [-69.79446895399985, -33.41465179399991],
              [-69.82059138999995, -33.44286712699997],
              [-69.83090083799996, -33.458163350999925],
              [-69.83415645299993, -33.4745964559999],
              [-69.83813553899992, -33.52110524499993],
              [-69.84146866899994, -33.53278411799991],
              [-69.84927181099994, -33.53650482099991],
              [-69.8692705899999, -33.542912699999945],
              [-69.87529089399993, -33.54735687199987],
              [-69.87883072899987, -33.55800221699987],
              [-69.87707373099991, -33.566787210999934],
              [-69.8737664389999, -33.5754688519999],
              [-69.87293961599988, -33.58601084399996],
              [-69.89392024799989, -33.642751566999976],
              [-69.89536718799988, -33.6622852579999],
              [-69.88678889999994, -33.678718362999945],
              [-69.85968461199988, -33.71137786799993],
              [-69.86004634599988, -33.7263640339999],
              [-69.87255204299987, -33.73742278999991],
              [-69.90650345899991, -33.76026377399991],
              [-69.91425492399992, -33.77194264799989],
              [-69.91477168799995, -33.79354339599986],
              [-69.8972792159999, -33.871368103],
              [-69.89864864099988, -33.88893808999997],
              [-69.90805375199992, -33.927902119999956],
              [-69.90955236799994, -33.955704039999915],
              [-69.9003022869999, -33.95901133199992],
              [-69.88428259299988, -33.95415374799998],
              [-69.8656015629999, -33.95766774499994],
              [-69.85580887899994, -33.984746195],
              [-69.85544714399992, -34.03115163199992],
              [-69.86397375599995, -34.10752939899996],
              [-69.86844376699986, -34.122618916999954],
              [-69.87237117499993, -34.13099049799993],
              [-69.87324967499987, -34.139982197999885],
              [-69.8685987959999, -34.15672536199993],
              [-69.86211340399984, -34.17016123499988],
              [-69.8373087169999, -34.20933196999992],
              [-69.82888545799992, -34.23330983399994],
              [-69.83276118999996, -34.24323170999993],
              [-69.90229182999985, -34.26865651499995],
              [-69.90484981299994, -34.27382415799994],
              [-69.90593501799995, -34.28074879999993],
              [-69.91156774999988, -34.28457285599997],
              [-69.94748286999993, -34.27382415799994],
              [-69.96820511999996, -34.27000010199991],
              [-69.98923742799988, -34.26906992599996],
              [-70.04034541799987, -34.27702809699991],
              [-70.04817621499987, -34.283461794999965],
              [-70.05757950899994, -34.291187438999955],
              [-70.06450415099994, -34.313511657999925],
              [-70.06365148899991, -34.34369069399993],
              [-70.05943986099996, -34.37293955499989],
              [-70.05869055199994, -34.39578053799998],
              [-70.06757889899987, -34.41459075999998],
              [-70.11429439299985, -34.447353616999905],
              [-70.12837622099988, -34.4694711299999],
              [-70.15072627799995, -34.518150329999926],
              [-70.1677795009999, -34.53840749099993],
              [-70.20919816099985, -34.56796640999997],
              [-70.22782751499992, -34.585329690999885],
              [-70.24242610699989, -34.61943613699995],
              [-70.25221879099993, -34.695813903999905],
              [-70.27314774599992, -34.72702646899998],
              [-70.29312068699994, -34.736534932999874],
              [-70.30945043999989, -34.73973887099994],
              [-70.31629756699994, -34.74562998399993],
              [-70.30751257399996, -34.76309661899998],
              [-70.29283646699989, -34.777566019999924],
              [-70.28069250499996, -34.7863510129999],
              [-70.27671341999988, -34.79823659299993],
              [-70.35371130399992, -34.953265888999866],
              [-70.37259903999984, -35.024682718999955],
              [-70.37244657199994, -35.02738854499992],
              [-70.36851660199994, -35.09713307699994],
              [-70.38662919099994, -35.16668955399986],
              [-70.54289872299992, -35.20927093499992],
              [-70.57889135799991, -35.25970713299992],
              [-70.56041703399987, -35.29836110499993],
              [-70.52070369499998, -35.30962656699998],
              [-70.47528011099985, -35.31407073999989],
              [-70.43975256399989, -35.332157490999904],
              [-70.42838374899989, -35.35706553099996],
              [-70.44060522499993, -35.36678069999991],
              [-70.46037146099988, -35.371018167999964],
              [-70.47176611399988, -35.37938974999993],
              [-70.46918229199989, -35.3946859739999],
              [-70.44546280999992, -35.46114186599995],
              [-70.43107092299994, -35.47778167699997],
              [-70.41642065499985, -35.491114195999984],
              [-70.40822993999993, -35.5062037149999],
              [-70.4181001389999, -35.54754486099992],
              [-70.41197648199994, -35.58743906599996],
              [-70.41226070199991, -35.607386169999884],
              [-70.42272517999996, -35.643869730999896],
              [-70.42153662099994, -35.6596827189999],
              [-70.37639725799997, -35.76138193799993],
              [-70.36156612199994, -35.78308603999993],
              [-70.3573286539999, -35.815228779999956],
              [-70.42024471099998, -35.8683521519999],
              [-70.42078731299992, -35.90380218499992],
              [-70.41236405399985, -35.9081430049999],
              [-70.39073746799997, -35.905869241999895],
              [-70.38368363499987, -35.91320729599997],
              [-70.38482051599996, -35.921165465999934],
              [-70.39146093799988, -35.927366637999924],
              [-70.39959997599988, -35.93274098699989],
              [-70.40502600099995, -35.93832204199991],
              [-70.4125707609999, -35.95733896899988],
              [-70.41272578999994, -35.96891448999992],
              [-70.38368363499987, -36.03051279699994],
              [-70.38032466699994, -36.046015726999954],
              [-70.38693924999984, -36.05872812899992],
              [-70.40430253199986, -36.074437763999896],
              [-70.41068456999989, -36.08373952199992],
              [-70.42272517999996, -36.11660573299994],
              [-70.43074804399996, -36.129402117999916],
              [-70.43510168499992, -36.13634613099991],
              [-70.45148311399987, -36.15226247199993],
              [-70.4711459959999, -36.16249440499992],
              [-70.49912878499993, -36.16363128599993],
              [-70.54530167599995, -36.14275400799994],
              [-70.56832352799992, -36.13903330499994],
              [-70.58142350299988, -36.14316741899995],
              [-70.5884773359999, -36.15019541399997],
              [-70.59832169599989, -36.16962575299995],
              [-70.6002854009999, -36.175206807999956],
              [-70.60131892999988, -36.18812591499997],
              [-70.6043678389999, -36.19463714599995],
              [-70.60865698299997, -36.197944437999936],
              [-70.61994828299996, -36.20228525799992],
              [-70.62467667699994, -36.20517913899991],
              [-70.66162532599986, -36.244556578999905],
              [-70.67503535999992, -36.252411396999946],
              [-70.69389725799994, -36.2566488639999],
              [-70.70312150099994, -36.260059508999916],
              [-70.71051123099994, -36.265847269999895],
              [-70.71487788899995, -36.275252380999945],
              [-70.71376684599994, -36.2835206099999],
              [-70.71159643599995, -36.29168548499992],
              [-70.71265580299993, -36.30026377299994],
              [-70.72968318699986, -36.32548187199998],
              [-70.73221533199995, -36.33426686599998],
              [-70.72911474599991, -36.34687591499991],
              [-70.7135859789999, -36.3681666059999],
              [-70.70859920299992, -36.379948832999986],
              [-70.70890926099992, -36.40320322699992],
              [-70.71865026899988, -36.414572041999904],
              [-70.80719783599992, -36.43338226299991],
              [-70.81432918399986, -36.429971618999986],
              [-70.82032364999989, -36.42459726999992],
              [-70.82882442199991, -36.41984303799994],
              [-70.8685894379999, -36.404650166999915],
              [-70.89037105399993, -36.40041269999995],
              [-70.90778601099996, -36.40516693099994],
              [-70.91626094599985, -36.419326272999896],
              [-70.92331477899998, -36.45674000999996],
              [-70.93496781399995, -36.47255299899986],
              [-70.95315791799987, -36.48247487399995],
              [-70.97103796399995, -36.48547210699988],
              [-70.9896414799999, -36.48330169699997],
              [-71.00997615599991, -36.47751393599991],
              [-71.02781930399993, -36.48116838999994],
              [-71.04328161599997, -36.48433522499995],
              [-71.06142004499989, -36.52040537499995],
              [-71.06891312699995, -36.56639739999996],
              [-71.06997249399993, -36.60381113699992],
              [-71.05532222599993, -36.67130055699995],
              [-71.0574409589999, -36.6876303099999],
              [-71.07302140299996, -36.696828714999896],
              [-71.09077225799987, -36.68949066099991],
              [-71.1099958909999, -36.678535257999926],
              [-71.12994299399992, -36.676881611999974],
              [-71.14534256999991, -36.68825042699996],
              [-71.14890824399987, -36.703960061999936],
              [-71.14684118699992, -36.74106374099992],
              [-71.15154374199989, -36.76049407899998],
              [-71.17671016499992, -36.814857685999954],
              [-71.1817744549999, -36.82240244599991],
              [-71.18895747999994, -36.83046396899991],
              [-71.19515865099993, -36.83914560899996],
              [-71.19686397399991, -36.84824066199994],
              [-71.19164465399987, -36.858369241999895],
              [-71.18280798399988, -36.86291676799992],
              [-71.17309281499985, -36.866120706999894],
              [-71.1652379969999, -36.872115173999916],
              [-71.15877844199986, -36.88265716499998],
              [-71.15852006099988, -36.88689463299994],
              [-71.16053544199994, -36.8904086299999],
              [-71.16105220499986, -36.89878021299997],
              [-71.16363602799987, -36.90632497099992],
              [-71.1685452879999, -36.9143864949999],
              [-71.16906205299995, -36.92193125399996],
              [-71.14017492699989, -36.9375375369999],
              [-71.13567907799998, -36.951490173999986],
              [-71.14332718899996, -36.96544280999997],
              [-71.16146561799988, -36.9754680379999],
              [-71.18110266199992, -36.975261331999945],
              [-71.20068802999992, -36.971437275999904],
              [-71.2071475839999, -36.97236745199996],
              [-71.18740718599992, -36.9868368529999],
              [-71.1560395919999, -37.00275319399992],
              [-71.1486498619999, -37.01350189199994],
              [-71.13955480999994, -37.06166432699992],
              [-71.1268940839999, -37.07758066799994],
              [-71.08911861199994, -37.10341888499997],
              [-71.12513708499992, -37.12005869499998],
              [-71.13929642799985, -37.13328786199989],
              [-71.14761633299992, -37.15478525799992],
              [-71.14797806799993, -37.175869242999866],
              [-71.14549759999994, -37.19540293399996],
              [-71.14647945199991, -37.214833271999936],
              [-71.15758988499994, -37.23571055099991],
              [-71.1972257079999, -37.27488128699996],
              [-71.20559728999987, -37.29265797899998],
              [-71.2046154379999, -37.315395608999964],
              [-71.19474523899993, -37.343507589],
              [-71.16828690599993, -37.391566670999865],
              [-71.13640254699988, -37.42505299899996],
              [-71.12307002799994, -37.4432431029999],
              [-71.11769567899998, -37.466497497999924],
              [-71.12084794099985, -37.48634124699991],
              [-71.13640254699988, -37.52437510199994],
              [-71.14172521999993, -37.54390879299994],
              [-71.13955480999994, -37.55486419699993],
              [-71.1273074959999, -37.57264088999996],
              [-71.12792761199995, -37.584423115999954],
              [-71.13309525599988, -37.59062428799986],
              [-71.15717647399993, -37.60250986699988],
              [-71.17242102099996, -37.61449879899993],
              [-71.18389318899997, -37.62586761499992],
              [-71.19076615499995, -37.64002695799988],
              [-71.19226477099994, -37.660904235999936],
              [-71.1850300699999, -37.70606943699991],
              [-71.13325028499992, -37.83846445699989],
              [-71.0949063729999, -37.897375589999896],
              [-71.0875941569999, -37.94016367599991],
              [-71.06113582399993, -37.9784042359999],
              [-71.05204077199994, -37.99928151499998],
              [-71.04645971699992, -38.02026214599998],
              [-71.03744217999989, -38.03659189799991],
              [-71.00997615599991, -38.06553069999997],
              [-71.00741817199992, -38.071008402999965],
              [-71.00664302599992, -38.07669280999991],
              [-71.00741817199992, -38.08227386399993],
              [-71.00997615599991, -38.08785491899994],
              [-71.0235153809999, -38.1045980839999],
              [-71.02305029299987, -38.12289154099996],
              [-71.01614241299987, -38.14369709399995],
              [-71.00997615599991, -38.16226898199996],
              [-71.00896846599994, -38.16505950899992],
              [-71.00865840699996, -38.16764333099992],
              [-71.00896846599994, -38.17033050499995],
              [-71.01788264999996, -38.20371348099992],
              [-71.01974300099997, -38.23430592799994],
              [-71.01669409199985, -38.264691670999895],
              [-70.97375097699998, -38.42468190499996],
              [-70.95047074399986, -38.45940846799991],
              [-70.91729447499995, -38.4829729209999],
              [-70.87982906099995, -38.503023375999945],
              [-70.84866817299991, -38.52762135899994],
              [-70.83430212499988, -38.56441497799993],
              [-70.83758357799988, -38.58446543399988],
              [-70.84773799699994, -38.59996836399998],
              [-70.87300777199991, -38.627770283999936],
              [-70.88342057299994, -38.643066507999905],
              [-70.88510005799989, -38.64947438599994],
              [-70.88579768899987, -38.66053314199995],
              [-70.88298132299991, -38.6688013709999],
              [-70.87698685699988, -38.67500254299998],
              [-70.87233597799991, -38.68161712599996],
              [-70.87383459499992, -38.69143564899994],
              [-70.87936397299984, -38.69463958699991],
              [-70.90954300999994, -38.70642181399991],
              [-70.9153566089999, -38.71220957499989],
              [-70.92949011299996, -38.73577402699989],
              [-70.94504471899998, -38.74724619599991],
              [-70.96723974699992, -38.75076019299986],
              [-71.00997615599991, -38.74631601999995],
              [-71.04842342199987, -38.746626077999935],
              [-71.07865413399989, -38.75706471799988],
              [-71.1368676349999, -38.792204690999924],
              [-71.15283565299984, -38.798819274999914],
              [-71.22802486199987, -38.808844502999946],
              [-71.23603470899994, -38.811635029999906],
              [-71.2409956459999, -38.81845631899995],
              [-71.25375972499995, -38.832719014999924],
              [-71.27975297099991, -38.85018564799988],
              [-71.37070349199993, -38.888012796999945],
              [-71.39990067499988, -38.91054372099997],
              [-71.41576533999998, -38.935348408999914],
              [-71.4302347419999, -38.999117126999934],
              [-71.43100988799992, -39.02598887099994],
              [-71.41266475499992, -39.10060963999992],
              [-71.40196773299994, -39.236001891999905],
              [-71.41204463699995, -39.31796071399988],
              [-71.42020951399988, -39.34214528399994],
              [-71.43907141199992, -39.355994567999915],
              [-71.46056880799995, -39.36715667699994],
              [-71.4765368249999, -39.38296966599994],
              [-71.47762202999988, -39.40219329799996],
              [-71.46165401199994, -39.43381927499986],
              [-71.47043900599994, -39.449115498999916],
              [-71.4824796149999, -39.46110443099987],
              [-71.50144486499994, -39.48828623399994],
              [-71.51565588399993, -39.50130869499989],
              [-71.54195918799988, -39.532314554999914],
              [-71.49565710499988, -39.56559417699995],
              [-71.5035119229999, -39.60166432699995],
              [-71.51999670399991, -39.61499684599997],
              [-71.53668819199993, -39.61572031699997],
              [-71.55498164999992, -39.612826436999896],
              [-71.57642736899993, -39.6146867879999],
              [-71.60076696899995, -39.61954437199992],
              [-71.61782019099988, -39.61665049299992],
              [-71.63239294499994, -39.607555439999956],
              [-71.64109884299995, -39.599999000999915],
              [-71.67740311799986, -39.56848805799994],
              [-71.68975378399992, -39.568384704999914],
              [-71.70541174399997, -39.583577574999936],
              [-71.7143517669999, -39.60135426799988],
              [-71.7187442629999, -39.62336842799995],
              [-71.71605708899997, -39.64476247099988],
              [-71.6940429279999, -39.67349456799988],
              [-71.69879715999988, -39.69023773199993],
              [-71.7087707119999, -39.708427835999956],
              [-71.7143517669999, -39.72630788199993],
              [-71.71047603399995, -39.74749521899989],
              [-71.69197587099993, -39.78997324699992],
              [-71.68691157999984, -39.81157399499999],
              [-71.68458614099993, -39.83348480299995],
              [-71.6793668219999, -39.84785085099995],
              [-71.66923824099985, -39.85921966599993],
              [-71.63451167799991, -39.88350758899993],
              [-71.62117915899998, -39.89508310999989],
              [-71.61663163299994, -39.9098625689999],
              [-71.62484818599998, -39.931049906999945],
              [-71.6620552169999, -39.995128682999876],
              [-71.66727453599992, -40.00050303099992],
              [-71.67440588399995, -40.004430439999894],
              [-71.68050370299991, -40.009494730999876],
              [-71.68282914299994, -40.0180730189999],
              [-71.68076208599987, -40.02913177499991],
              [-71.6731139739999, -40.050319111999954],
              [-71.67094356299992, -40.0607577509999],
              [-71.68370764199997, -40.09899831199989],
              [-71.72168981999991, -40.09383066899997],
              [-71.76675166899994, -40.076880797999976],
              [-71.80070308499995, -40.07967132599994],
              [-71.81403560399988, -40.09290049299993],
              [-71.81455236799994, -40.09961842799996],
              [-71.80711096199991, -40.10840342199994],
              [-71.80287349499986, -40.11605153399992],
              [-71.80478552299988, -40.124629821999946],
              [-71.80902298999993, -40.13382822699995],
              [-71.81646439599984, -40.164420674999874],
              [-71.81672277899992, -40.17454925499992],
              [-71.81207189999995, -40.18467783599996],
              [-71.81357051599986, -40.18819183399992],
              [-71.82235550999985, -40.202867939999905],
              [-71.82375077399993, -40.21010264099996],
              [-71.81599930899992, -40.22715586299991],
              [-71.80194331899992, -40.242348734999936],
              [-71.77073075399991, -40.26715342199988],
              [-71.7500601809999, -40.2915446989999],
              [-71.7426704509999, -40.29650563599995],
              [-71.72995804899995, -40.29857269299991],
              [-71.7257205809999, -40.29526540199991],
              [-71.7239119059999, -40.28999440499989],
              [-71.71848588099994, -40.286273701999875],
              [-71.70546341999989, -40.28193288199989],
              [-71.69874548399986, -40.282759703999915],
              [-71.68670487499989, -40.288547464999894],
              [-71.67926346899986, -40.29526540199991],
              [-71.67518102999986, -40.30394704199996],
              [-71.67368241499986, -40.31376556399994],
              [-71.67404414899994, -40.32410085099994],
              [-71.67848832199988, -40.34022389699993],
              [-71.71905432199989, -40.4129843139999],
              [-71.72928625599988, -40.42135589599988],
              [-71.74225703999988, -40.42083913199993],
              [-71.78473506699993, -40.41133066799995],
              [-71.79641394099991, -40.41453460699992],
              [-71.8041654059999, -40.426420185999945],
              [-71.84085567299988, -40.516027119999904],
              [-71.85878739499995, -40.54238210099996],
              [-71.86183630399998, -40.54972015399994],
              [-71.86059606999993, -40.55943532299999],
              [-71.85093257699992, -40.57028737399993],
              [-71.84772863799995, -40.57958913099988],
              [-71.85310298699991, -40.616382751999964],
              [-71.8733601479999, -40.64707855199991],
              [-71.94963456199994, -40.70929697699991],
              [-71.95557735299985, -40.72035573299992],
              [-71.9212125249999, -40.82773935899989],
              [-71.91067053299994, -40.85006357899995],
              [-71.87087967999994, -40.89574554499997],
              [-71.85987259899994, -40.91341888399997],
              [-71.85144934099995, -40.93832692499994],
              [-71.85144934099995, -40.95765390999989],
              [-71.86767574099986, -40.99899505599993],
              [-71.86740158899991, -41.01023528699993],
              [-71.86715897699992, -41.02018239399989],
              [-71.85284460499994, -41.057182718999925],
              [-71.85398148699994, -41.07888681999992],
              [-71.86261144999989, -41.11464691199994],
              [-71.86586706599988, -41.150407002999955],
              [-71.87134476799986, -41.1667367549999],
              [-71.8814216719999, -41.17262786799991],
              [-71.88943151899988, -41.17975921599994],
              [-71.88844966699992, -41.200326435999926],
              [-71.87594396999992, -41.23360605899997],
              [-71.8733601479999, -41.24921234199991],
              [-71.8777009689999, -41.2697795619999],
              [-71.90224727499995, -41.33592539499996],
              [-71.90395259599993, -41.36765472399989],
              [-71.89232539899987, -41.40537851999994],
              [-71.88431555199989, -41.422948506999916],
              [-71.87981970299995, -41.43669443699994],
              [-71.8788378509999, -41.45106048599986],
              [-71.88121496699995, -41.47038747099991],
              [-71.88870804899997, -41.50015309699998],
              [-71.8880879319999, -41.512762145999915],
              [-71.8806982019999, -41.529712014999916],
              [-71.86808915299989, -41.5451115929999],
              [-71.85687536699993, -41.555963642999956],
              [-71.85325801599996, -41.56733245899994],
              [-71.86348994999992, -41.5844890339999],
              [-71.8777009689999, -41.594927672999944],
              [-71.91185909099997, -41.6102238969999],
              [-71.92596675699991, -41.62293629999995],
              [-71.9259150799999, -41.65301198399992],
              [-71.86896765199992, -41.71554046599991],
              [-71.8585806889999, -41.748613382999906],
              [-71.85687536699993, -41.786130472999986],
              [-71.83894364499986, -41.81331227699988],
              [-71.81465572099995, -41.83780690499994],
              [-71.79403682499995, -41.86746917699989],
              [-71.77439978099991, -41.93919606499989],
              [-71.77507157499991, -41.95635264099994],
              [-71.7798774819999, -41.97226898199996],
              [-71.78065262899992, -41.98642832399992],
              [-71.76925956899987, -41.99960662199996],
              [-71.76251420199989, -42.00740895599992],
              [-71.74385900899992, -42.024358825999926],
              [-71.73956986599987, -42.03190358499997],
              [-71.73626257399985, -42.0838900759999],
              [-71.74944006399994, -42.10435394299995],
              [-71.77310786999996, -42.119960225999904],
              [-71.80132320199994, -42.130295511999904],
              [-71.87180985599989, -42.139700621999864],
              [-71.88426387599986, -42.14424814899989],
              [-71.89372066299993, -42.152619730999874],
              [-71.90080033399997, -42.1630583699999],
              [-71.90948197499992, -42.17225677499991],
              [-71.92379634699992, -42.17690765399996],
              [-71.9480325939999, -42.167295836999955],
              [-71.96136511299991, -42.14486826499996],
              [-71.9774881599999, -42.125334573999865],
              [-72.0098376059999, -42.1247144569999],
              [-72.03991328999987, -42.1446615599999],
              [-72.05138545799988, -42.17049977599993],
              [-72.05893021599994, -42.19757822699998],
              [-72.07717199699988, -42.221246032999915],
              [-72.10301021399991, -42.24088307699995],
              [-72.12471431599991, -42.26331064899995],
              [-72.13370601399996, -42.287598571999936],
              [-72.12156205199994, -42.31302337699995],
              [-72.06988562099991, -42.3499720249999],
              [-72.0606872159999, -42.36888559999993],
              [-72.07665523299994, -42.42335255899992],
              [-72.07520829299995, -42.433791198999955],
              [-72.04575272699995, -42.469861348999956],
              [-72.03918981999996, -42.48123016399995],
              [-72.04192867099991, -42.49104868599993],
              [-72.09282995699994, -42.51078908199989],
              [-72.12264725799994, -42.52990936299997],
              [-72.14321447799992, -42.55709116599988],
              [-72.14843379799996, -42.59264455099992],
              [-72.14543656399994, -42.60049936899996],
              [-72.1346361899999, -42.61476206499994],
              [-72.13158728099995, -42.624063821999954],
              [-72.1324657799999, -42.63171193499994],
              [-72.14145747899994, -42.65568979899986],
              [-72.1398555099999, -42.6698491409999],
              [-72.12564449099995, -42.70385223399994],
              [-72.12125199399986, -42.71966522199993],
              [-72.11267370599992, -42.863842467999916],
              [-72.1194949959999, -42.89856903099995],
              [-72.14212927199992, -42.96368133499993],
              [-72.14853715099989, -42.99871795599995],
              [-72.12931351799995, -43.04222951199998],
              [-72.09608557199994, -43.078506367999935],
              [-72.05443436699991, -43.105378112999944],
              [-72.0098376059999, -43.12036427799991],
              [-71.86188798099988, -43.13318003399989],
              [-71.77016231299987, -43.16139536499996],
              [-71.75016353399994, -43.17245412199988],
              [-71.74298050899998, -43.19012746199988],
              [-71.74566768499992, -43.19922251399994],
              [-71.75512447099987, -43.216379089999904],
              [-71.75765661699995, -43.22537078899994],
              [-71.7569848229999, -43.23529266299994],
              [-71.75140376799988, -43.25100229899991],
              [-71.74954341599997, -43.25916717499993],
              [-71.74840653499987, -43.27704722099989],
              [-71.75068029799988, -43.295340677999945],
              [-71.76086055499994, -43.3069161989999],
              [-71.80509558099996, -43.29999155699991],
              [-71.8243708899999, -43.303402201999944],
              [-71.86400671399988, -43.3175615439999],
              [-71.88943151899988, -43.31921518999994],
              [-71.90173050999991, -43.3220057169999],
              [-71.90736324099996, -43.329653828999966],
              [-71.90917191599993, -43.35972951299995],
              [-71.91232417799989, -43.36779103599994],
              [-71.91955887899988, -43.374302266999905],
              [-71.9274136969999, -43.37812632299995],
              [-71.9348551029999, -43.382777201999914],
              [-71.94095292199998, -43.39176890099995],
              [-71.94105627499991, -43.398383483999865],
              [-71.93676713099993, -43.42670216899994],
              [-71.94208980299987, -43.434246927999894],
              [-71.95077144399994, -43.438587747999875],
              [-71.95511226499991, -43.44354868599993],
              [-71.94741247599993, -43.45316050199993],
              [-71.93733557199988, -43.456881204999945],
              [-71.92694860899988, -43.45481414799988],
              [-71.91650996899992, -43.45088673899991],
              [-71.90622635899985, -43.44923309399988],
              [-71.88612422699987, -43.45336720799989],
              [-71.86881262199998, -43.462565612999896],
              [-71.85832230699992, -43.477448424999935],
              [-71.85863236499992, -43.498635762999896],
              [-71.85878739499995, -43.499255879999865],
              [-71.87826940999994, -43.51920298299997],
              [-71.88152502499992, -43.52447397899991],
              [-71.87382523599993, -43.538943379999935],
              [-71.85113928299995, -43.54256072999992],
              [-71.82344071499995, -43.54214731899991],
              [-71.80070308499995, -43.54421437499988],
              [-71.78979935699991, -43.54938201899998],
              [-71.7834948329999, -43.55537648499991],
              [-71.77884395399994, -43.56147430399996],
              [-71.77274613499986, -43.567468770999895],
              [-71.7661832279999, -43.572016296999934],
              [-71.72375687699986, -43.59475392599991],
              [-71.71430008999988, -43.602195332999926],
              [-71.7106827399999, -43.614080911999864],
              [-71.70365474499991, -43.67164845799991],
              [-71.70918412299991, -43.684360859999956],
              [-71.7257205809999, -43.69738332199998],
              [-71.74432409699995, -43.70523813899993],
              [-71.78638871299998, -43.71722707099988],
              [-71.80323522999996, -43.726012063999875],
              [-71.81341548699993, -43.73944793699992],
              [-71.8192032469999, -43.758051452999965],
              [-71.81548254399988, -43.77438120499991],
              [-71.79713741099991, -43.780789082999945],
              [-71.77553666199992, -43.77562143899986],
              [-71.76204911399986, -43.76890350399992],
              [-71.75502111899996, -43.771383971999896],
              [-71.75295406099988, -43.793604837999936],
              [-71.75564123499993, -43.802699889999914],
              [-71.76080887899994, -43.80962453199989],
              [-71.76427119999997, -43.81727264399996],
              [-71.76184240799992, -43.828434753],
              [-71.75579626499987, -43.83453257199996],
              [-71.73688268999993, -43.84176727299992],
              [-71.7287178149999, -43.84621144599993],
              [-71.71579870699989, -43.85871714199993],
              [-71.65988480699991, -43.926309915999894],
              [-71.65926468999993, -43.93974578899994],
              [-71.66959997599994, -43.95979624399989],
              [-71.74525991399992, -44.04499811699988],
              [-71.76220414199992, -44.06407928499992],
              [-71.79569047099992, -44.08599009199989],
              [-71.83522294099996, -44.094361673999956],
              [-71.85873571799993, -44.107797546999905],
              [-71.84405961099995, -44.145314635999895],
              [-71.81248531199986, -44.18779266299994],
              [-71.80509558099996, -44.20515594499996],
              [-71.8062841389999, -44.222519225999875],
              [-71.82793656499987, -44.2520781459999],
              [-71.83181229699991, -44.270164896999916],
              [-71.82395747899989, -44.286804707999934],
              [-71.81165848799995, -44.300550638999965],
              [-71.80401037699997, -44.314813334999954],
              [-71.8104182539999, -44.333623554999875],
              [-71.82499100799987, -44.340651549999876],
              [-71.84757360899991, -44.3480929559999],
              [-71.8641617429999, -44.3591517129999],
              [-71.86059606999993, -44.37713511099989],
              [-71.82204545099995, -44.40318003399996],
              [-71.78070430599993, -44.402663268999916],
              [-71.73781286599987, -44.393361511999984],
              [-71.69435298699997, -44.393361511999984],
              [-71.64319331899986, -44.4025599159999],
              [-71.43783117699988, -44.40152638699992],
              [-71.28683264199995, -44.423333841999934],
              [-71.23500117999995, -44.42385060599989],
              [-71.2097830809999, -44.42757130899989],
              [-71.18632198099994, -44.43800994899992],
              [-71.17133581499988, -44.452169290999876],
              [-71.1656514089999, -44.46632863299992],
              [-71.16265417499991, -44.48141815199992],
              [-71.15541947499995, -44.498574726999976],
              [-71.14265539599995, -44.51232065799992],
              [-71.13061478799989, -44.520382181999906],
              [-71.12265661699993, -44.53030405699991],
              [-71.12239823399997, -44.549424336999905],
              [-71.13164831499998, -44.57061167399986],
              [-71.14735795199994, -44.580843606999935],
              [-71.16725337799994, -44.58415089899994],
              [-71.18880244999991, -44.584771015999905],
              [-71.1993961179999, -44.59169565799989],
              [-71.21340043099988, -44.607095234999875],
              [-71.23489782699994, -44.638824563999975],
              [-71.24063391099989, -44.65815154999994],
              [-71.23929032399994, -44.67437794999995],
              [-71.23102209499987, -44.70951792399998],
              [-71.23815344299993, -44.74786183699992],
              [-71.26280310099992, -44.77711069799996],
              [-71.29783972199994, -44.79561085999998],
              [-71.33597692899991, -44.801605325999915],
              [-71.37886836799996, -44.79189015699997],
              [-71.4571064859999, -44.7522026569999],
              [-71.49710404499987, -44.74290089999997],
              [-71.54040889499993, -44.75044565899992],
              [-71.63120438699991, -44.78000457699994],
              [-71.67264888599988, -44.77855763699995],
              [-71.73998327699988, -44.75768035899998],
              [-71.76266922999994, -44.75437306699989],
              [-71.78690547699992, -44.75726694699996],
              [-71.80101314299995, -44.766775410999955],
              [-71.81320878099987, -44.77855763699995],
              [-71.83139888499991, -44.788169453999956],
              [-71.8545499279999, -44.79095998099993],
              [-71.98761673999985, -44.7724598179999],
              [-72.0098376059999, -44.765535175999915],
              [-72.0478197839999, -44.7547864779999],
              [-72.07624182099994, -44.76078094399992],
              [-72.08874751899992, -44.782795104999906],
              [-72.07412308799985, -44.83705535899995],
              [-72.07484655799996, -44.85317840599993],
              [-72.08094437699992, -44.88656138099991],
              [-72.0735029709999, -44.90216766399993],
              [-72.05329748499989, -44.9068185429999],
              [-72.0098376059999, -44.904544779999895],
              [-71.96968501799998, -44.91529347799991],
              [-71.92948075399994, -44.933793639999934],
              [-71.88943151899988, -44.94722951299988],
              [-71.8497440189999, -44.94340545699994],
              [-71.8284533289999, -44.93524057999993],
              [-71.80566402199992, -44.929246113999895],
              [-71.78246130399992, -44.92738576299989],
              [-71.75987870299988, -44.9318299359999],
              [-71.74484086099989, -44.940614929999896],
              [-71.71864090999986, -44.96438608799994],
              [-71.70236283399996, -44.973687845999876],
              [-71.66169348199989, -44.97916554799987],
              [-71.62396968599995, -44.97492807999991],
              [-71.58872635899988, -44.97813201899989],
              [-71.55518835499996, -45.005830586999906],
              [-71.51513911999987, -45.065775247999895],
              [-71.49705236899987, -45.111663919999955],
              [-71.4871821699999, -45.12334279399994],
              [-71.4489416099999, -45.158999531999925],
              [-71.39540482599995, -45.18597462999995],
              [-71.3632620859999, -45.208815612999956],
              [-71.33861242799992, -45.23424041699987],
              [-71.3171667069999, -45.26720998099992],
              [-71.31153397699995, -45.299456074999895],
              [-71.33432328399994, -45.32281382299993],
              [-71.35075638899991, -45.33283904999986],
              [-71.37432084199992, -45.359194030999916],
              [-71.38935868399992, -45.37076955099987],
              [-71.40791052299994, -45.37872772199992],
              [-71.50831783099991, -45.408389993999975],
              [-71.51033321199986, -45.41841522199991],
              [-71.50159989499991, -45.43877573699994],
              [-71.4813427329999, -45.46792124399987],
              [-71.47813879399993, -45.48270070399988],
              [-71.48909419799989, -45.498513691999875],
              [-71.5258361409999, -45.518977558999936],
              [-71.56169958499993, -45.52393849699989],
              [-71.6392142329999, -45.52001108799992],
              [-71.67208044499992, -45.5236284379999],
              [-71.71373164899993, -45.53324025499991],
              [-71.7495950929999, -45.54925994799996],
              [-71.7650980229999, -45.57241099099994],
              [-71.76173905499988, -45.57623504699998],
              [-71.74654618399995, -45.587293802999895],
              [-71.74282548099984, -45.59432179799991],
              [-71.74525427299992, -45.6009363809999],
              [-71.75150712099989, -45.60662078899995],
              [-71.7588451739999, -45.611685078999926],
              [-71.76458125799985, -45.61654266399994],
              [-71.7824096279999, -45.641760762999894],
              [-71.78587194899984, -45.653026223999944],
              [-71.7879390059999, -45.669459329999924],
              [-71.78638871299998, -45.676900735999936],
              [-71.78271968599998, -45.68289520299996],
              [-71.78049759999988, -45.689406433999935],
              [-71.78364986199992, -45.69850148499991],
              [-71.79951452599994, -45.717105000999965],
              [-71.80178828999996, -45.72402964299994],
              [-71.79853267499988, -45.739945983999874],
              [-71.7890758879999, -45.750901387999946],
              [-71.76287593599989, -45.76867807999989],
              [-71.74902665199991, -45.7867648309999],
              [-71.75145544499989, -45.8018543499999],
              [-71.76008540899994, -45.81591033899991],
              [-71.76489131699992, -45.83099985799991],
              [-71.75848343899989, -45.84815643299997],
              [-71.74318721599994, -45.85756154399992],
              [-71.70086421799994, -45.868516946999904],
              [-71.66587927299994, -45.884019876999915],
              [-71.64133296799986, -45.905723978999916],
              [-71.62438309799995, -45.93414601599993],
              [-71.61229081299987, -45.970526224999915],
              [-71.64916319199992, -45.99941415799994],
              [-71.72349849499989, -46.0576526899999],
              [-71.73543575099984, -46.07119191499997],
              [-71.7559512949999, -46.10064748199997],
              [-71.77016231299987, -46.11263641399994],
              [-71.79227982599988, -46.121938170999954],
              [-71.81636104299992, -46.12679575599988],
              [-71.89051672399995, -46.13341033999997],
              [-71.90446936099997, -46.13630421899995],
              [-71.91263423699988, -46.14209197999993],
              [-71.91470129399994, -46.15232391299992],
              [-71.90948197499992, -46.156664733999904],
              [-71.9004902749999, -46.15893849699991],
              [-71.89129186999989, -46.162969257999904],
              [-71.84292272999994, -46.19614552799992],
              [-71.78277136199989, -46.22467091799987],
              [-71.76334102399991, -46.244514668999955],
              [-71.7592585859999, -46.272936705999896],
              [-71.7629276129999, -46.318515319999875],
              [-71.76158402599992, -46.3579961139999],
              [-71.7518688559999, -46.39303273499992],
              [-71.68489619999991, -46.519226582999906],
              [-71.68050370299991, -46.538140156999944],
              [-71.68577469999994, -46.55384979199991],
              [-71.69321610599988, -46.56914601599996],
              [-71.69554154499988, -46.58712941499995],
              [-71.68019364499992, -46.65957977299993],
              [-71.68716996299992, -46.690068867999926],
              [-71.7201912029999, -46.715597025999955],
              [-71.77600174999995, -46.73812794999989],
              [-71.79321000199994, -46.7510470579999],
              [-71.8195649829999, -46.778952330999886],
              [-71.83408605999995, -46.78856414799989],
              [-71.85579016199992, -46.7944552609999],
              [-71.90746659399989, -46.79486867199991],
              [-71.93413163199992, -46.79951955099996],
              [-71.95009964999986, -46.81398895299989],
              [-71.95071976799991, -46.82360076899991],
              [-71.9462239179999, -46.83114552799995],
              [-71.94002274599993, -46.83827687599998],
              [-71.93537186799995, -46.84613169399992],
              [-71.93619868999988, -46.854296569999946],
              [-71.9418314209999, -46.86091115299995],
              [-71.94865270999986, -46.86752573699994],
              [-71.95320023699989, -46.87476043699991],
              [-71.96963334199995, -46.9339816289999],
              [-71.97035681199986, -46.94845102999993],
              [-71.9602282319999, -46.96219695999987],
              [-71.92669022599989, -46.98379770899993],
              [-71.91480464699987, -46.998473815999915],
              [-71.93470007299987, -47.01439015699994],
              [-71.99996740799992, -47.042192076999896],
              [-72.00518672699994, -47.06193247499996],
              [-71.98430944899985, -47.080535989999916],
              [-71.92028234899996, -47.10678761799994],
              [-71.89346227999997, -47.12136037199991],
              [-71.87413529499992, -47.142547709999874],
              [-71.86255977499988, -47.16890268899992],
              [-71.86328324399997, -47.196601256999955],
              [-71.8806982019999, -47.22192270899993],
              [-71.91253088499985, -47.23453175899995],
              [-71.9458105059999, -47.2277104689999],
              [-72.0098376059999, -47.19815155099988],
              [-72.03030147399994, -47.19753143299991],
              [-72.04146358299988, -47.2037326049999],
              [-72.04513260999988, -47.21582488999988],
              [-72.04316890499985, -47.23287811299991],
              [-72.0367093509999, -47.24962127699986],
              [-72.03055985499992, -47.25964650499989],
              [-72.02942297399991, -47.26967173299991],
              [-72.03815629099998, -47.28703501299992],
              [-72.05794836499987, -47.3119430539999],
              [-72.14538488799991, -47.38180959099988],
              [-72.17055131099994, -47.40754445399996],
              [-72.18734615099993, -47.417466328999964],
              [-72.20915360599994, -47.420256855999924],
              [-72.26294877199987, -47.41384897899988],
              [-72.2881668709999, -47.41498586099989],
              [-72.32873286999993, -47.426458027999914],
              [-72.34661291599988, -47.436276549999974],
              [-72.36118566999994, -47.450952656999874],
              [-72.37048742699997, -47.474517109999866],
              [-72.35829178899988, -47.483405455999886],
              [-72.33751786299993, -47.487952982999914],
              [-72.3208780519999, -47.49839162199994],
              [-72.31963781799996, -47.51193084699993],
              [-72.33756953999995, -47.56567433699993],
              [-72.33994665599988, -47.58520802799994],
              [-72.3444425059999, -47.602261250999874],
              [-72.35172888199989, -47.618280944999924],
              [-72.36283931499992, -47.635024108999886],
              [-72.45730383299988, -47.74912567199998],
              [-72.47440873199992, -47.78281870599993],
              [-72.50045365499989, -47.85289194799988],
              [-72.52422481299996, -47.88265757199987],
              [-72.5439135339999, -47.9148003129999],
              [-72.53528356999996, -47.94580617299992],
              [-72.50944535399992, -47.972987976],
              [-72.47745764199993, -47.99376190199986],
              [-72.45611527599993, -48.00109995599993],
              [-72.43689164299991, -48.00420054099989],
              [-72.4191666269999, -48.00957488999994],
              [-72.4025784909999, -48.02414764399991],
              [-72.3988577879999, -48.033242695999974],
              [-72.39777258299989, -48.04233774799994],
              [-72.39544714399995, -48.050916035999975],
              [-72.38800573699984, -48.05784067799995],
              [-72.37705033399996, -48.06218149799993],
              [-72.34304724199993, -48.07044972699988],
              [-72.33322871999985, -48.09081024199992],
              [-72.3095092369999, -48.211216328999924],
              [-72.31152461799988, -48.2309567259999],
              [-72.3241336669999, -48.26857716799992],
              [-72.32563228399991, -48.285527038999916],
              [-72.31757075999991, -48.29896291099996],
              [-72.30372147699993, -48.31601613399991],
              [-72.29509151199989, -48.3332760619999],
              [-72.30232621299987, -48.34753875699997],
              [-72.31540035099991, -48.350329283999926],
              [-72.3448559169999, -48.34371470199993],
              [-72.35865352399986, -48.34299123099993],
              [-72.37141760299994, -48.346401875999874],
              [-72.37715368699989, -48.350329283999926],
              [-72.38867753099993, -48.36428192199992],
              [-72.41673783399995, -48.39115366599992],
              [-72.4331192629999, -48.400352070999915],
              [-72.4964745689999, -48.41513153099993],
              [-72.53786739199995, -48.43125457699992],
              [-72.57677974399994, -48.4521318569999],
              [-72.61471024599985, -48.51000946099991],
              [-72.60659704699992, -48.56096242299995],
              [-72.58422115099995, -48.6159461469999],
              [-72.57801997899986, -48.721882832999974],
              [-72.58215409399989, -48.76053680399989],
              [-72.59233435099986, -48.7911292519999],
              [-72.61879268499985, -48.819654641999946],
              [-72.67196773299989, -48.86295949299991],
              [-72.74291947499998, -48.91380910299993],
              [-72.78121171099988, -48.93385955799997],
              [-72.82492997299994, -48.94450490299997],
              [-72.9222366939999, -48.95225636799997],
              [-72.96962398299988, -48.96434865299996],
              [-73.00972489499986, -48.990393574999935],
              [-73.01747635999988, -48.998248392999876],
              [-73.0175797119999, -48.998248392999876],
              [-73.07855790299996, -49.0587098189999],
              [-73.0922521569999, -49.08103403699996],
              [-73.09509436099995, -49.09581349699997],
              [-73.0948359789999, -49.108732604999894],
              [-73.09710974099991, -49.12134165499992],
              [-73.10718664599995, -49.1348808799999],
              [-73.17131709799989, -49.1893478389999],
              [-73.1843395599999, -49.21425587999996],
              [-73.18315100099989, -49.2390605669999],
              [-73.17044785899989, -49.25087001999994],
              [-73.16258378099991, -49.2581808469999],
              [-73.09762650599995, -49.266552428999965],
              [-73.09824662299991, -49.272753600999955],
              [-73.13064774599991, -49.27874806699989],
              [-73.14129309199993, -49.28556935599994],
              [-73.14501379499993, -49.30365610799995],
              [-73.45786291499994, -49.307686868999944],
              [-73.47111791999993, -49.31719533299993],
              [-73.47047196499994, -49.34220672599993],
              [-73.46204870599988, -49.37496958399993],
              [-73.46672542399995, -49.387578632999954],
              [-73.48380448499998, -49.400704446999924],
              [-73.52227758799992, -49.41672414199988],
              [-73.54044185499987, -49.42778289799988],
              [-73.55113887599987, -49.444009296999894],
              [-73.55072546499986, -49.46323292999991],
              [-73.54434342499994, -49.477598978999914],
              [-73.54258642699995, -49.49103485099996],
              [-73.55594478399988, -49.50808807299999],
              [-73.5865889079999, -49.52999888099995],
              [-73.58803584899991, -49.54054087299992],
              [-73.57555598999991, -49.559247741999904],
              [-73.56219763199988, -49.5717534379999],
              [-73.53294877199994, -49.59397430499993],
              [-73.52111486899992, -49.60896046999991],
              [-73.51819514999991, -49.628494160999914],
              [-73.52809118699992, -49.644410501999936],
              [-73.54072607499995, -49.65950001999994],
              [-73.54638464399997, -49.67675994899993],
              [-73.5395116789999, -49.69267628899986],
              [-73.5247838949999, -49.70600880999988],
              [-73.49626512648797, -49.72534201500291],
              [-73.49261531599987, -49.727816264],
              [-73.4650976159999, -49.759959004999935],
              [-73.46297888199993, -49.78714080799992],
              [-73.48210722501858, -49.81173676818831],
              [-73.53449906399996, -49.84760223399994],
              [-73.53883988499993, -49.86155487099994],
              [-73.53827144399989, -49.87674774199987],
              [-73.54194046999987, -49.8945244349999],
              [-73.55398107999994, -49.90806365999988],
              [-73.56839880399986, -49.920052591999934],
              [-73.57273962499994, -49.93235158299997],
              [-73.55444616799988, -49.947131042999985],
              [-73.50021175199993, -49.97865366699995],
              [-73.48747351099988, -49.99115936299995],
              [-73.47858516499986, -50.00945281999992],
              [-73.48075557499993, -50.02268198599992],
              [-73.53150183199995, -50.08314341199994],
              [-73.54147538199993, -50.11373586099995],
              [-73.53057165599998, -50.140814310999914],
              [-73.4058247479999, -50.21698537199991],
              [-73.36510371999992, -50.23197153799989],
              [-73.34634517499993, -50.243650410999955],
              [-73.32293575099996, -50.268351745999965],
              [-73.30143835499993, -50.29956431099995],
              [-73.28433345599987, -50.33305063899994],
              [-73.27420487499992, -50.36446990999989],
              [-73.27275793499993, -50.384727070999894],
              [-73.27575516799993, -50.42555145199989],
              [-73.27404984599988, -50.44518849699992],
              [-73.26180253199996, -50.499035338999946],
              [-73.26185420799987, -50.55660288499989],
              [-73.25761674099991, -50.57303599099995],
              [-73.24490433799988, -50.58946909599992],
              [-73.2026846929999, -50.62646942199988],
              [-73.19224605399995, -50.64135223399992],
              [-73.18526973599995, -50.6784559119999],
              [-73.18671667499987, -50.71669647199989],
              [-73.17772497599992, -50.749459329999894],
              [-73.13948441599993, -50.77023325599993],
              [-73.09607621299992, -50.770646666999944],
              [-73.05173783399988, -50.75783091199987],
              [-73.01008662899997, -50.736436868999945],
              [-72.9384114179999, -50.68538055399997],
              [-72.90285803299992, -50.66657033299996],
              [-72.77842118399991, -50.61964813199992],
              [-72.75578690599988, -50.616444193999946],
              [-72.73351436399992, -50.62429901099998],
              [-72.6826647549999, -50.65954233799995],
              [-72.66261429899996, -50.667810566999904],
              [-72.61812089099996, -50.66677703799992],
              [-72.54913285399991, -50.61510060599998],
              [-72.5059830329999, -50.60125132199992],
              [-72.38335485899998, -50.62026824999989],
              [-72.34521765199992, -50.63732147199992],
              [-72.32191158099988, -50.641558938999964],
              [-72.30284297799992, -50.64889699399996],
              [-72.30491003399996, -50.664916686999916],
              [-72.34098018399996, -50.71514617899996],
              [-72.34769812099998, -50.728995462999926],
              [-72.34738806199991, -50.74315480599997],
              [-72.3381379809999, -50.76062143999992],
              [-72.31116288299995, -50.78873341799996],
              [-72.28392940299995, -50.810644225999916],
              [-72.2634655359999, -50.83627573699997],
              [-72.25674759999987, -50.87513641399993],
              [-72.26594600499988, -50.96071258499998],
              [-72.2770564379999, -51.00732472799986],
              [-72.29343786699985, -51.029235534999906],
              [-72.32248002199992, -51.03264617899993],
              [-72.33860306799991, -51.036986998999915],
              [-72.35074702999992, -51.046702167999946],
              [-72.36816198799994, -51.066649271999964],
              [-72.39653234899995, -51.09207407599988],
              [-72.40459387299995, -51.10582000699991],
              [-72.40309525599994, -51.12607716899992],
              [-72.38221797799989, -51.1605970259999],
              [-72.34945511899988, -51.18390309699993],
              [-72.27395585099995, -51.216769307999954],
              [-72.25757442199989, -51.230618590999924],
              [-72.25881465699985, -51.24519134599998],
              [-72.27049353099991, -51.25955739299989],
              [-72.31343664599987, -51.29800465899993],
              [-72.32046464099989, -51.31257741299989],
              [-72.32330684499996, -51.33448822099985],
              [-72.32356522599994, -51.390815530999944],
              [-72.3289912519999, -51.40879892999993],
              [-72.3344689539999, -51.41634368899989],
              [-72.34170365399987, -51.42295827199989],
              [-72.34831823699994, -51.43050303099993],
              [-72.35172888199989, -51.440424905999926],
              [-72.35105708799989, -51.449416605999964],
              [-72.34909338499997, -51.45902842199989],
              [-72.34831823699994, -51.46833017999991],
              [-72.35121211799995, -51.475978291999894],
              [-72.42231888899997, -51.5223837279999],
              [-72.45006913299991, -51.55266611799993],
              [-72.42914017799993, -51.576023864999875],
              [-72.40201005099993, -51.57974456799989],
              [-72.3757067469999, -51.579537861999924],
              [-72.35152217599992, -51.583465270999895],
              [-72.33090327999992, -51.59938161199992],
              [-72.32279007999992, -51.6162281289999],
              [-72.31416011599987, -51.67152191199992],
              [-72.30072424399992, -51.69146901499994],
              [-72.28113887599991, -51.70149424199987],
              [-72.18708776899985, -51.72071787499989],
              [-72.14212927199992, -51.73942474299987],
              [-72.07262447099995, -51.77859547899991],
              [-72.0098376059999, -51.82779144299988],
              [-71.98172562699995, -51.844948018999936],
              [-71.95847123199994, -51.867995706999906],
              [-71.94849768099994, -51.896004332999915],
              [-71.9602282319999, -51.92794036899989],
              [-71.96524084499987, -51.97062510199989],
              [-71.91769852799987, -51.99005543999996],
              [-71.83760005699989, -51.99077891099996],
              [-71.61213578299993, -51.99274261399999],
              [-71.38661983299994, -51.99470631899993],
              [-71.1611555579999, -51.99677337699998],
              [-70.93569128499993, -51.99873708099992],
              [-70.71014949599996, -52.00070078499996],
              [-70.48471105999991, -52.002664489999894],
              [-70.25924678599995, -52.00462819399993],
              [-70.03375667399987, -52.00659189899996],
              [-69.95275386599988, -52.007418721999976],
              [-69.83332963099991, -52.039354756999955],
              [-69.66393428599989, -52.084726664999984],
              [-69.48528885999986, -52.13247568699996],
              [-69.21225642899986, -52.13795338999995],
              [-69.00756608099994, -52.17908782999993],
              [-68.85866044199989, -52.23324473099985],
              [-68.82049739699991, -52.24316660599994],
              [-68.62172399899993, -52.2636304729999],
              [-68.60358557099988, -52.26797129299988],
              [-68.57314815299992, -52.28027028399992],
              [-68.55681839999988, -52.28368092899986],
              [-68.47780513499993, -52.29535980199992],
              [-68.45449906399998, -52.29990732799986],
              [-68.44820791496335, -52.3103940627235],
              [-68.4486097329999, -52.346617015999925],
              [-68.47167491399995, -52.33722598499992],
              [-68.56546333799992, -52.34092918199991],
              [-68.71276452599994, -52.306908268999905],
              [-68.78188573699993, -52.313305476999915],
              [-68.82164466099994, -52.30364348799992],
              [-68.89846139999992, -52.30353719899995],
              [-68.94737708199995, -52.28720468499995],
              [-68.96568762899994, -52.28378671699994],
              [-69.00812740799995, -52.26726653399993],
              [-69.08604895699995, -52.22519296699994],
              [-69.13011633999992, -52.208103122999944],
              [-69.18537350199995, -52.19890715899993],
              [-69.23470812199992, -52.20314306999995],
              [-69.34621833099993, -52.24456519699993],
              [-69.40310363099991, -52.245991346999915],
              [-69.44200598899994, -52.25212981599992],
              [-69.45181230399993, -52.26034921699994],
              [-69.47093665299991, -52.27271900799991],
              [-69.47960364499994, -52.28378671699994],
              [-69.4824926419999, -52.29045989399992],
              [-69.48949133999992, -52.36614348799992],
              [-69.49693762899994, -52.38534921699994],
              [-69.51744544199994, -52.39299895599993],
              [-69.54531816299993, -52.39934661299992],
              [-69.55528723899994, -52.41480885199991],
              [-69.55736243399991, -52.434665622999944],
              [-69.56151282499991, -52.45387135199991],
              [-69.57485917899993, -52.46795012799993],
              [-69.61632239499994, -52.4880510399999],
              [-69.63385982999995, -52.49920012799993],
              [-69.65453040299991, -52.5153947899999],
              [-69.67235149599992, -52.53085653799991],
              [-69.71557905499992, -52.53543992999994],
              [-69.77981956099995, -52.52261401399994],
              [-69.81243476299994, -52.5060870019999],
              [-69.82853882499995, -52.4917879489999],
              [-69.8465795969999, -52.48654268599995],
              [-69.87173613599992, -52.49632505699992],
              [-69.91161048099991, -52.51034921699994],
              [-69.94568934699993, -52.53109421399995],
              [-70.08341581899992, -52.575221033999924],
              [-70.1519818939999, -52.586508318999904],
              [-70.18032668699993, -52.60296893599991],
              [-70.19937089799993, -52.62167734199994],
              [-70.2077156819999, -52.65100346799994],
              [-70.24212928599991, -52.63938850199992],
              [-70.2747289699999, -52.63941822699991],
              [-70.29165206399995, -52.63460857699994],
              [-70.32179292399991, -52.63814717199995],
              [-70.33055693199992, -52.645040389999906],
              [-70.33300686399991, -52.6601146079999],
              [-70.3661392379999, -52.655530925999926],
              [-70.38351465499994, -52.67138716799991],
              [-70.51773438899994, -52.723254926999914],
              [-70.54823529899994, -52.72272184399992],
              [-70.54978728999993, -52.702743203999944],
              [-70.52363005299992, -52.687859214999946],
              [-70.50177322299993, -52.67749491899991],
              [-70.5059884559999, -52.66128854099992],
              [-70.52587829099991, -52.659927067999945],
              [-70.54616250499993, -52.66662214099995],
              [-70.5679245199999, -52.6692508349999],
              [-70.58303941299994, -52.67199926599994],
              [-70.59216323899994, -52.68796581499993],
              [-70.56957641399993, -52.70249632799994],
              [-70.58682268699994, -52.71428352399994],
              [-70.60800327399994, -52.70482225399991],
              [-70.6331824849999, -52.708383212999934],
              [-70.65883955599992, -52.72101341899992],
              [-70.68402282799991, -52.72457038899995],
              [-70.69817809699992, -52.73943212599994],
              [-70.71641305299994, -52.737063819999946],
              [-70.71563213699994, -52.722954262999906],
              [-70.72345943899995, -52.70427825299993],
              [-70.73403886599993, -52.701429945999905],
              [-70.74445553299995, -52.70794036299992],
              [-70.75454667899993, -52.71689218499995],
              [-70.76439368399991, -52.721368096999925],
              [-70.80699622299994, -52.72779713299991],
              [-70.82274329299992, -52.72820403399993],
              [-70.83438066299993, -52.725274346999925],
              [-70.84333248599995, -52.72079843499995],
              [-70.85220292899993, -52.71843840899993],
              [-70.86375891799992, -52.721368096999925],
              [-70.85684160099993, -52.73398202899995],
              [-70.84703528599994, -52.737399997999944],
              [-70.83531653599994, -52.73796965899993],
              [-70.80577551999994, -52.74773528399993],
              [-70.80231686099995, -52.74928150799991],
              [-70.80142167899993, -52.75335051899992],
              [-70.80329342399995, -52.765883070999905],
              [-70.80231686099995, -52.769789320999905],
              [-70.79149329299992, -52.776055596999925],
              [-70.78490149599992, -52.77629973799992],
              [-70.7766820949999, -52.77507903399993],
              [-70.74274654899995, -52.778415622999944],
              [-70.73884029899995, -52.783868096999925],
              [-70.74767005099994, -52.79705169099992],
              [-70.75633704299992, -52.801039320999905],
              [-70.79548092399995, -52.81072356599992],
              [-70.80626380099994, -52.81682708099993],
              [-70.81212317599994, -52.821384372999944],
              [-70.82274329299992, -52.83806731599992],
              [-70.82681230399993, -52.8474260399999],
              [-70.83218339799993, -52.86581796699994],
              [-70.83702551999994, -52.87273528399993],
              [-70.84124811099991, -52.90342732499994],
              [-70.85969622399995, -52.90180881099991],
              [-70.87821384999995, -52.90142837199994],
              [-70.88921476599995, -52.91362639399995],
              [-70.86054074099991, -52.91670158799991],
              [-70.83604888099995, -52.92092823899992],
              [-70.81045488199993, -52.92717864399992],
              [-70.80870520699995, -52.942071221999925],
              [-70.80915279899995, -52.961602471999925],
              [-70.81151282499991, -52.97926197699991],
              [-70.81688391799992, -52.992445570999905],
              [-70.86611894399994, -53.04973723799992],
              [-70.87059485599991, -53.061211846999925],
              [-70.87515214799993, -53.08912525799991],
              [-70.88711503799993, -53.11386484199994],
              [-70.9387914699999, -53.176853122999944],
              [-70.95055091099994, -53.197523695999905],
              [-70.95759029899995, -53.22283294099992],
              [-70.95909583199995, -53.302666924999926],
              [-70.96373450399994, -53.32675546699994],
              [-70.98692786399994, -53.36419036299992],
              [-70.99274654899995, -53.38298919099992],
              [-70.99478105399993, -53.40439218499995],
              [-70.9934789699999, -53.42701588299991],
              [-70.98289954299992, -53.46770598799992],
              [-70.94953365799995, -53.54697030999995],
              [-70.93944251199991, -53.59221770599993],
              [-70.94017493399991, -53.613946221999925],
              [-70.94562740799995, -53.63884856599992],
              [-70.95555579299992, -53.65935637799993],
              [-70.96987870999993, -53.667901299999926],
              [-70.97948157499991, -53.67929452899995],
              [-70.97838294199994, -53.70549895599993],
              [-70.97398841099994, -53.73495859199994],
              [-70.97362219999991, -53.75603606599992],
              [-70.99583899599992, -53.78728606599992],
              [-71.03425045499995, -53.80974700299993],
              [-71.22874915299991, -53.87468840899993],
              [-71.28502356699994, -53.88600025799991],
              [-71.33604895699995, -53.879571221999925],
              [-71.4297582669999, -53.842461846999925],
              [-71.47984778599994, -53.82935963299991],
              [-71.64464270699995, -53.82366301899992],
              [-71.72032630099994, -53.79762135199991],
              [-71.73005123599995, -53.79216887799993],
              [-71.74547278599994, -53.78134530999995],
              [-71.75446529899995, -53.77654387799993],
              [-71.81607011599993, -53.76018645599993],
              [-71.83755449099993, -53.74570077899995],
              [-71.84752356699994, -53.74236419099992],
              [-71.86514238199993, -53.73316822699991],
              [-71.87441972599993, -53.69654713299991],
              [-71.89159094999991, -53.694024346999925],
              [-71.90245520699995, -53.701836846999925],
              [-71.91746985599991, -53.72421640399995],
              [-71.92943274599992, -53.728773695999905],
              [-71.94302324099993, -53.7243791649999],
              [-71.96178137899994, -53.705743096999925],
              [-71.97728430899991, -53.697198174999926],
              [-71.99233964799993, -53.678399346999925],
              [-72.00145423099991, -53.674086195999905],
              [-72.01553300699993, -53.676039320999905],
              [-72.01805579299992, -53.68092213299991],
              [-72.01744544199994, -53.687432549999926],
              [-72.02196204299992, -53.694024346999925],
              [-72.04246985599991, -53.7068010399999],
              [-72.05345618399991, -53.706963799999926],
              [-72.06631425699993, -53.69768645599993],
              [-72.07730058499993, -53.691664320999905],
              [-72.10387122299994, -53.68906015399995],
              [-72.11440995999993, -53.68401458099993],
              [-72.18700110599991, -53.62639739399992],
              [-72.22826087099992, -53.60035572699991],
              [-72.25177975199995, -53.58928801899992],
              [-72.28408769399994, -53.58123137799993],
              [-72.28844153599994, -53.57236093499995],
              [-72.29084225199995, -53.56129322699991],
              [-72.2969457669999, -53.55120208099993],
              [-72.30650794199994, -53.54461028399993],
              [-72.32567298099991, -53.53720468499995],
              [-72.3372289699999, -53.53069426899992],
              [-72.38923092399995, -53.48495859199994],
              [-72.39806067599994, -53.47893645599993],
              [-72.40636145699995, -53.45916106599992],
              [-72.44359290299991, -53.42131926899992],
              [-72.45327714799993, -53.407321872999944],
              [-72.44489498599995, -53.38591887799993],
              [-72.42259680899991, -53.37346770599993],
              [-72.40648352799991, -53.361586195999905],
              [-72.4160863919999, -53.341729424999926],
              [-72.42345130099994, -53.3318010399999],
              [-72.42345130099994, -53.3239885399999],
              [-72.41881262899994, -53.31731536299992],
              [-72.41234290299991, -53.31096770599993],
              [-72.40977942599994, -53.310804945999905],
              [-72.39183508999992, -53.30413176899992],
              [-72.30125891799992, -53.24879322699991],
              [-72.28229732999995, -53.24277109199994],
              [-72.15908769399994, -53.25644296699994],
              [-72.13703365799995, -53.254978122999944],
              [-72.11461341099994, -53.25676848799992],
              [-72.09723873599995, -53.26775481599992],
              [-72.08043372299994, -53.32903411299992],
              [-72.07730058499993, -53.350274346999925],
              [-72.08340410099993, -53.37249114399992],
              [-72.09064693899995, -53.382745049999926],
              [-72.09959876199991, -53.39006926899992],
              [-72.10993404899995, -53.391289971999925],
              [-72.13573157499991, -53.37127044099992],
              [-72.14268958199995, -53.376071872999944],
              [-72.14854895699995, -53.39666106599992],
              [-72.16869055899991, -53.41155364399992],
              [-72.21768144399994, -53.424086195999905],
              [-72.24168860599991, -53.43450286299992],
              [-72.21141516799992, -53.44198984199994],
              [-72.18248450399994, -53.43840911299992],
              [-72.15392005099994, -53.43108489399992],
              [-72.10521399599992, -53.42595794099992],
              [-72.09251868399991, -53.42262135199991],
              [-72.06973222599993, -53.407321872999944],
              [-72.0559789699999, -53.39421965899993],
              [-72.04893958199995, -53.38982512799993],
              [-72.04157467399995, -53.38982512799993],
              [-72.02285722599993, -53.395196221999925],
              [-72.01512610599991, -53.39299895599993],
              [-72.00446529899995, -53.350274346999925],
              [-72.01805579299992, -53.29583098799992],
              [-72.02171790299991, -53.24732838299991],
              [-71.98094641799992, -53.22226327899995],
              [-71.96495520699995, -53.223321221999925],
              [-71.93927975199995, -53.23284270599993],
              [-71.92577063699991, -53.23528411299992],
              [-71.91368567599994, -53.23333098799992],
              [-71.89329993399991, -53.22429778399993],
              [-71.88166256399995, -53.22226327899995],
              [-71.85562089799993, -53.22535572699991],
              [-71.84178626199991, -53.235039971999925],
              [-71.83495032499991, -53.25204843499995],
              [-71.81798255099994, -53.34221770599993],
              [-71.81651770699995, -53.36248137799993],
              [-71.8106176419999, -53.37932708099993],
              [-71.79841061099995, -53.3982072899999],
              [-71.78844153599994, -53.419040622999944],
              [-71.78917395699995, -53.441338799999926],
              [-71.80308997299994, -53.4568010399999],
              [-71.82795162699995, -53.47234465899993],
              [-71.85472571499992, -53.484307549999926],
              [-71.87450110599991, -53.48919036299992],
              [-71.90119381399995, -53.49179452899995],
              [-71.96727454299992, -53.51653411299992],
              [-71.99380449099993, -53.52223072699991],
              [-72.00413977799991, -53.52825286299992],
              [-72.00829016799992, -53.54070403399993],
              [-72.00796464799993, -53.55429452899995],
              [-72.00544186099995, -53.561618747999944],
              [-71.99836178299995, -53.564385674999926],
              [-71.9844457669999, -53.56487395599993],
              [-71.96275794199994, -53.56023528399993],
              [-71.92003333199995, -53.53834400799991],
              [-71.89842688699991, -53.53069426899992],
              [-71.84178626199991, -53.526462497999944],
              [-71.81419837099992, -53.52068450299993],
              [-71.79259192599994, -53.50628020599993],
              [-71.75999915299991, -53.47226327899995],
              [-71.75446529899995, -53.46249765399995],
              [-71.75523841099994, -53.45086028399993],
              [-71.76537024599992, -53.431573174999926],
              [-71.76866614499994, -53.42083098799992],
              [-71.76235917899993, -53.398695570999905],
              [-71.76056881399995, -53.38534921699994],
              [-71.76524817599994, -53.37932708099993],
              [-71.7676488919999, -53.37420012799993],
              [-71.77550208199995, -53.341729424999926],
              [-71.77318274599992, -53.31926848799992],
              [-71.74242102799991, -53.22340260199991],
              [-71.72862708199995, -53.21209075299993],
              [-71.69212805899991, -53.20712655999995],
              [-71.67931067599994, -53.20273202899995],
              [-71.67186438699991, -53.201104424999926],
              [-71.64517167899993, -53.201104424999926],
              [-71.62999426999994, -53.19801197699991],
              [-71.62100175699993, -53.19378020599993],
              [-71.58470618399991, -53.16692473799992],
              [-71.57266191299993, -53.162041924999926],
              [-71.54360917899993, -53.1579729149999],
              [-71.47984778599994, -53.13551197699991],
              [-71.46711178299995, -53.13290780999995],
              [-71.42015540299991, -53.13437265399995],
              [-71.40493730399993, -53.13290780999995],
              [-71.38292395699995, -53.12639739399992],
              [-71.36021887899994, -53.11614348799992],
              [-71.33853105399993, -53.10312265399995],
              [-71.3196508449999, -53.088148695999905],
              [-71.3118383449999, -53.078789971999925],
              [-71.29775956899994, -53.055352471999925],
              [-71.28892981699994, -53.04412200299993],
              [-71.27940833199995, -53.03671640399995],
              [-71.26170813699991, -53.02597421699994],
              [-71.25413977799991, -53.01677825299993],
              [-71.24795488199993, -52.99765390399995],
              [-71.24339758999992, -52.974867445999905],
              [-71.23485266799992, -52.95582447699991],
              [-71.19858154699995, -52.92390359199993],
              [-71.1724789939999, -52.93065638899992],
              [-71.11876433599991, -52.9196357699999],
              [-71.1204931119999, -52.88028949699992],
              [-71.1487428339999, -52.842785498999945],
              [-71.16928539699995, -52.81281300599994],
              [-71.21015453799993, -52.81551970599992],
              [-71.24918179699995, -52.78875586399994],
              [-71.30927851899992, -52.80571263399992],
              [-71.35211477999991, -52.807111447999944],
              [-71.36888587099992, -52.78394947699991],
              [-71.38117428299995, -52.768243096999925],
              [-71.39879309799994, -52.72820403399993],
              [-71.40233313699991, -52.751071872999944],
              [-71.40200761599993, -52.77044036299992],
              [-71.40428626199991, -52.78850676899992],
              [-71.39990934899993, -52.8206221609999],
              [-71.39862915399993, -52.83171545899995],
              [-71.42142735999994, -52.837276921999944],
              [-71.44745309899992, -52.83045963699993],
              [-71.46751868399991, -52.82561614399992],
              [-71.48395748599995, -52.824883721999925],
              [-71.49095618399991, -52.82822030999995],
              [-71.50055904899995, -52.83863697699991],
              [-71.50597083199995, -52.84343840899993],
              [-71.51138261599993, -52.8454729149999],
              [-71.5308001439999, -52.86665627199994],
              [-71.5771994669999, -52.88998026299993],
              [-71.6119878099999, -52.89272641499991],
              [-71.64222483799995, -52.91645046499991],
              [-71.66671098099994, -52.91698514299992],
              [-71.70465205099993, -52.93434141799992],
              [-71.73577311699995, -52.94206748799991],
              [-71.77839394699993, -52.96666209999995],
              [-71.83878231499995, -52.983353001999944],
              [-71.8627263969999, -53.00236944499994],
              [-71.90623283899993, -53.010888517999945],
              [-71.92308508999992, -53.034274997999944],
              [-71.99522864499994, -53.09124114399992],
              [-72.0137426419999, -53.11858489399992],
              [-72.02196204299992, -53.12542083099993],
              [-72.03335527299993, -53.12639739399992],
              [-72.04605058499993, -53.122979424999926],
              [-72.05964107999995, -53.121758721999925],
              [-72.08560136599993, -53.13437265399995],
              [-72.10155188699991, -53.133477471999925],
              [-72.11705481699994, -53.12859465899993],
              [-72.13670813699991, -53.11598072699991],
              [-72.15566972599993, -53.10662200299993],
              [-72.16527258999992, -53.09929778399993],
              [-72.17300370999993, -53.09059010199991],
              [-72.18443762899994, -53.0739885399999],
              [-72.19326738199993, -53.06462981599992],
              [-72.2044164699999, -53.05510833099993],
              [-72.21495520699995, -53.048760674999926],
              [-72.22667395699995, -53.045179945999905],
              [-72.25413977799991, -53.04192473799992],
              [-72.27574622299994, -53.03215911299992],
              [-72.28600012899994, -53.02988046699994],
              [-72.31362870999993, -53.03337981599992],
              [-72.30654863199993, -53.042901299999926],
              [-72.28498287699995, -53.05624765399995],
              [-72.26895097599993, -53.07146575299993],
              [-72.28848222599993, -53.07154713299991],
              [-72.30752519399994, -53.06853606599992],
              [-72.36412512899994, -53.05201588299991],
              [-72.38003495999993, -53.05038827899995],
              [-72.49478105399993, -53.05592213299991],
              [-72.53498287699995, -53.06454843499995],
              [-72.56314042899993, -53.07887135199991],
              [-72.54279537699995, -53.08554452899995],
              [-72.52017167899993, -53.081963799999926],
              [-72.49681555899991, -53.074883721999925],
              [-72.47443600199995, -53.07146575299993],
              [-72.43325761599993, -53.083103122999944],
              [-72.41270911399994, -53.08538176899992],
              [-72.39500891799992, -53.07512786299992],
              [-72.36709550699993, -53.0681291649999],
              [-72.32164466099994, -53.13209400799991],
              [-72.22712154899995, -53.1501604149999],
              [-72.21003170499995, -53.15683359199994],
              [-72.19749915299991, -53.16952890399995],
              [-72.19139563699991, -53.18059661299992],
              [-72.19367428299995, -53.19085051899992],
              [-72.20628821499992, -53.201104424999926],
              [-72.22557532499991, -53.20598723799992],
              [-72.25348873599995, -53.2068010399999],
              [-72.27855383999992, -53.202243747999944],
              [-72.29873613199993, -53.18254973799992],
              [-72.32046464799993, -53.17986419099992],
              [-72.3645727199999, -53.180759372999944],
              [-72.3645727199999, -53.18759530999995],
              [-72.32827714799993, -53.1911760399999],
              [-72.31578528599994, -53.20671965899993],
              [-72.32762610599991, -53.22128671699994],
              [-72.3645727199999, -53.22226327899995],
              [-72.45205644399994, -53.18962981599992],
              [-72.48802649599992, -53.18759530999995],
              [-72.45006262899994, -53.20476653399993],
              [-72.43529212099992, -53.21640390399995],
              [-72.44029700399994, -53.228448174999926],
              [-72.46198482999995, -53.22991301899992],
              [-72.48509680899991, -53.21754322699991],
              [-72.51537024599992, -53.19426848799992],
              [-72.53819739499994, -53.19736093499995],
              [-72.53709876199991, -53.20745208099993],
              [-72.52163652299993, -53.21949635199991],
              [-72.50169837099992, -53.228448174999926],
              [-72.45128333199995, -53.23552825299993],
              [-72.42662512899994, -53.24228280999995],
              [-72.41234290299991, -53.25644296699994],
              [-72.42568925699993, -53.26506926899992],
              [-72.43521074099993, -53.27467213299991],
              [-72.44701087099992, -53.281914971999925],
              [-72.46694902299993, -53.283135674999926],
              [-72.48420162699995, -53.27654387799993],
              [-72.50031490799995, -53.26677825299993],
              [-72.51695716099994, -53.26189544099992],
              [-72.53587805899991, -53.27011484199994],
              [-72.51549231699994, -53.28630950299993],
              [-72.50377356699994, -53.31389739399992],
              [-72.50475012899994, -53.343682549999926],
              [-72.52220618399991, -53.366306247999944],
              [-72.55825761599993, -53.37460702899995],
              [-72.59349524599992, -53.36402760199991],
              [-72.62385006399995, -53.34254322699991],
              [-72.64513098899994, -53.31780364399992],
              [-72.65147864499994, -53.34075286299992],
              [-72.63727779899995, -53.358493747999944],
              [-72.5911352199999, -53.38681405999995],
              [-72.57872473899994, -53.39918385199991],
              [-72.57022050699993, -53.410088799999926],
              [-72.55923417899993, -53.417901299999926],
              [-72.53929602799991, -53.42083098799992],
              [-72.53575598899994, -53.4177385399999],
              [-72.53140214799993, -53.40390390399995],
              [-72.52965247299994, -53.40048593499995],
              [-72.52220618399991, -53.399509372999944],
              [-72.49828040299991, -53.40048593499995],
              [-72.48346920499995, -53.40911223799992],
              [-72.38231360599991, -53.52385833099993],
              [-72.3645727199999, -53.5368791649999],
              [-72.52253170499995, -53.54436614399992],
              [-72.53172766799992, -53.542087497999944],
              [-72.53722083199995, -53.53655364399992],
              [-72.54214433499993, -53.529554945999905],
              [-72.54954993399991, -53.5232072899999],
              [-72.57135982999995, -53.51531340899993],
              [-72.61676998599995, -53.50741952899995],
              [-72.63890540299991, -53.49667734199994],
              [-72.64622962099992, -53.488213799999926],
              [-72.65086829299992, -53.47909921699994],
              [-72.65721594999991, -53.47161223799992],
              [-72.66966712099992, -53.468682549999926],
              [-72.71198482999995, -53.4646135399999],
              [-72.72142493399991, -53.46249765399995],
              [-72.73306230399993, -53.449151299999926],
              [-72.73131262899994, -53.4177385399999],
              [-72.74132239499994, -53.40048593499995],
              [-72.76317298099991, -53.387790622999944],
              [-72.76976477799991, -53.39902109199994],
              [-72.77086341099994, -53.41936614399992],
              [-72.77603105399993, -53.43450286299992],
              [-72.79466712099992, -53.440118096999925],
              [-72.80068925699993, -53.42546965899993],
              [-72.8028051419999, -53.40349700299993],
              [-72.80955969999991, -53.38681405999995],
              [-72.82843990799995, -53.38437265399995],
              [-72.85680091099994, -53.38534921699994],
              [-72.87730872299994, -53.381931247999944],
              [-72.87230383999992, -53.366306247999944],
              [-72.88719641799992, -53.36012135199991],
              [-72.94367428299995, -53.352634372999944],
              [-73.07835852799991, -53.28639088299991],
              [-73.14118404899995, -53.268649997999944],
              [-73.17137610599991, -53.25644296699994],
              [-73.19908606699994, -53.24081796699994],
              [-73.22109941299993, -53.22226327899995],
              [-73.25210527299993, -53.18417734199994],
              [-73.26455644399994, -53.17595794099992],
              [-73.29279537699995, -53.16570403399993],
              [-73.30304928299995, -53.153415622999944],
              [-73.18236243399991, -53.185804945999905],
              [-73.13914954299992, -53.18759530999995],
              [-73.11888587099992, -53.182712497999944],
              [-73.08482825399994, -53.1696916649999],
              [-72.98094641799992, -53.16025155999995],
              [-72.9563695949999, -53.16057708099993],
              [-72.94050045499995, -53.16643645599993],
              [-72.92870032499991, -53.176853122999944],
              [-72.91637122299994, -53.19101327899995],
              [-72.90607662699995, -53.19540780999995],
              [-72.87950598899994, -53.193617445999905],
              [-72.86856035099993, -53.19768645599993],
              [-72.86070716099994, -53.20322030999995],
              [-72.77611243399991, -53.233086846999925],
              [-72.75869706899994, -53.23528411299992],
              [-72.75234941299993, -53.242120049999926],
              [-72.75690670499995, -53.2575822899999],
              [-72.76659094999991, -53.27385833099993],
              [-72.77603105399993, -53.283135674999926],
              [-72.7676488919999, -53.290134372999944],
              [-72.75682532499991, -53.294854424999926],
              [-72.74522864499994, -53.293633721999925],
              [-72.73448645699995, -53.283135674999926],
              [-72.71955318899995, -53.29257577899995],
              [-72.71328691299993, -53.29029713299991],
              [-72.71519934799994, -53.280368747999944],
              [-72.72451738199993, -53.266696872999944],
              [-72.71593176999994, -53.26230234199994],
              [-72.69985917899993, -53.25139739399992],
              [-72.68919837099992, -53.24032968499995],
              [-72.69664466099994, -53.23528411299992],
              [-72.72276770699995, -53.228448174999926],
              [-72.75438391799992, -53.212009372999944],
              [-72.78209387899994, -53.19158294099992],
              [-72.79596920499995, -53.17327239399992],
              [-72.77818762899994, -53.17302825299993],
              [-72.72765051999994, -53.18759530999995],
              [-72.73790442599994, -53.16952890399995],
              [-72.75487219999991, -53.15553150799991],
              [-72.76329505099994, -53.14568450299993],
              [-72.74815833199995, -53.13909270599993],
              [-72.72679602799991, -53.13958098799992],
              [-72.65257727799991, -53.153415622999944],
              [-72.66071529899995, -53.14177825299993],
              [-72.67520097599993, -53.13551197699991],
              [-72.69212805899991, -53.13128020599993],
              [-72.70718339799993, -53.12542083099993],
              [-72.71393795499995, -53.108493747999944],
              [-72.71397864499994, -53.10556405999995],
              [-72.72545325399994, -53.10515715899993],
              [-72.73102779899995, -53.10947030999995],
              [-72.73485266799992, -53.11492278399993],
              [-72.74132239499994, -53.11858489399992],
              [-72.78750566299993, -53.11581796699994],
              [-72.80337480399993, -53.11858489399992],
              [-72.82974199099993, -53.1423479149999],
              [-72.84508216099994, -53.1501604149999],
              [-72.9121801419999, -53.11882903399993],
              [-72.93374589799993, -53.10475025799991],
              [-72.93004309799994, -53.088148695999905],
              [-72.89102128799993, -53.05681731599992],
              [-72.87608801999994, -53.03639088299991],
              [-72.87848873599995, -53.01677825299993],
              [-72.89488684799994, -53.03020598799992],
              [-72.90453040299991, -53.03630950299993],
              [-72.91323808499993, -53.03728606599992],
              [-72.92076575399994, -53.03248463299991],
              [-72.92642167899993, -53.02459075299993],
              [-72.92796790299991, -53.01531340899993],
              [-72.92292232999995, -53.00628020599993],
              [-72.91722571499992, -52.98943450299993],
              [-72.92601477799991, -52.97014739399992],
              [-72.93932044199994, -52.95086028399993],
              [-72.94737708199995, -52.934258721999925],
              [-72.94766191299993, -52.92636484199994],
              [-72.94595292899993, -52.92034270599993],
              [-72.93993079299992, -52.906914971999925],
              [-72.93472245999993, -52.90081145599993],
              [-72.92747962099992, -52.89421965899993],
              [-72.92398027299993, -52.88640715899993],
              [-72.93004309799994, -52.87615325299993],
              [-72.96861731699994, -52.85125090899993],
              [-72.97647050699993, -52.83879973799992],
              [-72.96035722599993, -52.82496510199991],
              [-72.93431555899991, -52.81853606599992],
              [-72.87816321499992, -52.81308359199994],
              [-72.83397376199991, -52.787041924999926],
              [-72.76244055899991, -52.769789320999905],
              [-72.74445553299995, -52.75741952899995],
              [-72.70348059799994, -52.707696221999925],
              [-72.69017493399991, -52.708916924999926],
              [-72.68163001199991, -52.7126604149999],
              [-72.65876217399995, -52.72820403399993],
              [-72.61913001199991, -52.738946221999925],
              [-72.61156165299991, -52.74187590899993],
              [-72.61131751199991, -52.774102471999925],
              [-72.65029863199993, -52.80169036299992],
              [-72.69749915299991, -52.82708098799992],
              [-72.72142493399991, -52.85173919099992],
              [-72.71483313699991, -52.869398695999905],
              [-72.69473222599993, -52.860039971999925],
              [-72.66991126199991, -52.84140390399995],
              [-72.62755286399994, -52.822930596999925],
              [-72.60850989499994, -52.80681731599992],
              [-72.58820553299995, -52.795993747999944],
              [-72.56314042899993, -52.80388762799993],
              [-72.57966061099995, -52.812758070999905],
              [-72.59365800699993, -52.82439544099992],
              [-72.59585527299993, -52.834242445999905],
              [-72.57681230399993, -52.83806731599992],
              [-72.56224524599992, -52.83367278399993],
              [-72.53502356699994, -52.81487395599993],
              [-72.52594967399995, -52.81072356599992],
              [-72.49063066299993, -52.80437590899993],
              [-72.47398841099994, -52.8064104149999],
              [-72.46694902299993, -52.821384372999944],
              [-72.46092688699991, -52.840508721999925],
              [-72.44701087099992, -52.85491301899992],
              [-72.43126380099994, -52.85662200299993],
              [-72.41978919199994, -52.83806731599992],
              [-72.42589270699995, -52.82480234199994],
              [-72.42007402299993, -52.80828215899993],
              [-72.40868079299992, -52.79306405999995],
              [-72.39806067599994, -52.783461195999905],
              [-72.38097083199995, -52.77467213299991],
              [-72.31309973899994, -52.75115325299993],
              [-72.30394446499992, -52.74651458099993],
              [-72.29515540299991, -52.74065520599993],
              [-72.28600012899994, -52.73186614399992],
              [-72.28189042899993, -52.72519296699994],
              [-72.27367102799991, -52.70671965899993],
              [-72.26895097599993, -52.70086028399993],
              [-72.24742591099994, -52.69459400799991],
              [-72.19859778599994, -52.693291924999926],
              [-72.17959550699993, -52.680352471999925],
              [-72.1775439189999, -52.65772970899991],
              [-72.16087419899992, -52.6521177649999],
              [-72.11457750299991, -52.658566623999945],
              [-72.09597158199995, -52.65425304199994],
              [-72.07765336999995, -52.653618398999924],
              [-72.06383945599993, -52.65772635499991],
              [-72.04289702099993, -52.67433315999995],
              [-72.01451441199993, -52.67273036499995],
              [-72.00716684399993, -52.655739611999934],
              [-72.00037768399994, -52.64609812899994],
              [-71.98014009999991, -52.645461079999905],
              [-71.96430149399993, -52.6496157549999],
              [-71.94946881299995, -52.667284467999934],
              [-71.92031105899991, -52.681624195999916],
              [-71.85052856599992, -52.69470955799994],
              [-71.62943764999994, -52.683783699999935],
              [-71.59820797799995, -52.674817823999945],
              [-71.58500453099992, -52.660390830999916],
              [-71.51951629699994, -52.65606973899992],
              [-71.4781028509999, -52.64613773299993],
              [-71.49181067599994, -52.61256275799991],
              [-71.53484369599994, -52.58038301399995],
              [-71.57161105299991, -52.561277867999934],
              [-71.63111050099991, -52.57440015299994],
              [-71.6868251219999, -52.56309545399995],
              [-71.72912830999991, -52.56193056199993],
              [-71.75989235999992, -52.56840723599993],
              [-71.8333749709999, -52.552792224999905],
              [-71.91120868599995, -52.54196763199991],
              [-71.97535046999991, -52.56085692499994],
              [-72.00283053699991, -52.55145126799994],
              [-72.02773140199992, -52.5592606429999],
              [-72.04777239499992, -52.5574188999999],
              [-72.07223762399991, -52.537089719999926],
              [-72.0872289699999, -52.52092864399992],
              [-72.09764563699991, -52.51653411299992],
              [-72.12482662699995, -52.51327890399995],
              [-72.2031957669999, -52.523370049999926],
              [-72.28156490799995, -52.51384856599992],
              [-72.30992591099994, -52.51653411299992],
              [-72.32778886599993, -52.5251604149999],
              [-72.34557044199994, -52.54045989399992],
              [-72.35912024599992, -52.55820077899995],
              [-72.3645727199999, -52.57431405999995],
              [-72.37393144399994, -52.588148695999905],
              [-72.41852779899995, -52.60670338299991],
              [-72.43346106699994, -52.6189104149999],
              [-72.42406165299991, -52.61419036299992],
              [-72.41515051999994, -52.61256275799991],
              [-72.40648352799991, -52.614353122999944],
              [-72.39806067599994, -52.6189104149999],
              [-72.41364498599995, -52.64885833099993],
              [-72.4192602199999, -52.653008721999925],
              [-72.43163001199991, -52.65097421699994],
              [-72.44139563699991, -52.645603122999944],
              [-72.46076412699995, -52.63201262799993],
              [-72.50169837099992, -52.61532968499995],
              [-72.5059301419999, -52.61142343499995],
              [-72.52594967399995, -52.60019296699994],
              [-72.54914303299995, -52.5915666649999],
              [-72.54157467399995, -52.577243747999944],
              [-72.50792395699995, -52.55006275799991],
              [-72.48688717399995, -52.53875090899993],
              [-72.46898352799991, -52.535088799999926],
              [-72.42662512899994, -52.53639088299991],
              [-72.40172278599994, -52.5310197899999],
              [-72.38768469999991, -52.5193010399999],
              [-72.38963782499991, -52.5075822899999],
              [-72.41266842399995, -52.502211195999905],
              [-72.42398027299993, -52.50408294099992],
              [-72.44322669199994, -52.51311614399992],
              [-72.45327714799993, -52.51653411299992],
              [-72.46524003799993, -52.5173479149999],
              [-72.48981686099995, -52.51580169099992],
              [-72.50169837099992, -52.51653411299992],
              [-72.53062903599994, -52.528415622999944],
              [-72.53929602799991, -52.53020598799992],
              [-72.54743404899995, -52.53435637799993],
              [-72.55907141799992, -52.552666924999926],
              [-72.56997636599993, -52.556898695999905],
              [-72.58922278599994, -52.55413176899992],
              [-72.61245683499993, -52.547133070999905],
              [-72.63003495999993, -52.53834400799991],
              [-72.63206946499992, -52.53020598799992],
              [-72.65611731699994, -52.52166106599992],
              [-72.67935136599993, -52.52483489399992],
              [-72.70205644399994, -52.532321872999944],
              [-72.77944902299993, -52.54387786299992],
              [-72.79503333199995, -52.54119231599992],
              [-72.80028235599991, -52.53435637799993],
              [-72.80264238199993, -52.52556731599992],
              [-72.80955969999991, -52.51653411299992],
              [-72.84837805899991, -52.50286223799992],
              [-72.85802161399994, -52.502211195999905],
              [-72.86192786399994, -52.51018645599993],
              [-72.85728919199994, -52.52971770599993],
              [-72.86143958199995, -52.540134372999944],
              [-72.86717688699991, -52.54827239399992],
              [-72.87059485599991, -52.55592213299991],
              [-72.87205969999991, -52.56170012799993],
              [-72.87230383999992, -52.56373463299991],
              [-72.88988196499992, -52.588555596999925],
              [-72.89281165299991, -52.594821872999944],
              [-72.89610755099994, -52.61370208099993],
              [-72.90453040299991, -52.62965260199991],
              [-72.91539466099994, -52.64267343499995],
              [-72.92625891799992, -52.653008721999925],
              [-72.98009192599994, -52.69410572699991],
              [-72.9883520169999, -52.70427825299993],
              [-72.97264563699991, -52.717054945999905],
              [-72.93716386599993, -52.69060637799993],
              [-72.86432857999995, -52.61191171699994],
              [-72.84105383999992, -52.59433359199994],
              [-72.81920325399994, -52.58652109199994],
              [-72.79873613199993, -52.61541106599992],
              [-72.77342688699991, -52.62420012799993],
              [-72.72142493399991, -52.63201262799993],
              [-72.69522050699993, -52.63209400799991],
              [-72.68700110599991, -52.63420989399992],
              [-72.67642167899993, -52.642836195999905],
              [-72.6738988919999, -52.65252044099992],
              [-72.68016516799992, -52.66253020599993],
              [-72.71320553299995, -52.69255950299993],
              [-72.76244055899991, -52.72820403399993],
              [-72.77969316299993, -52.74578215899993],
              [-72.79084225199995, -52.75269947699991],
              [-72.80650794199994, -52.75554778399993],
              [-72.83242753799993, -52.756117445999905],
              [-72.84512285099993, -52.75937265399995],
              [-72.85057532499991, -52.766289971999925],
              [-72.86042232999995, -52.7888322899999],
              [-72.88434811099995, -52.795179945999905],
              [-72.93993079299992, -52.79705169099992],
              [-73.00527910099993, -52.83326588299991],
              [-73.01561438699991, -52.841729424999926],
              [-73.00739498599995, -52.85588958099993],
              [-72.96760006399995, -52.87900155999995],
              [-72.95360266799992, -52.89332447699991],
              [-72.96939042899993, -52.90748463299991],
              [-72.97252356699994, -52.92473723799992],
              [-72.96727454299992, -52.95842864399992],
              [-72.9641820949999, -52.96379973799992],
              [-72.9505102199999, -52.97698333099993],
              [-72.94737708199995, -52.98577239399992],
              [-72.95360266799992, -53.02361419099992],
              [-72.96304277299993, -53.037367445999905],
              [-72.97956295499995, -53.05478280999995],
              [-72.99510657499991, -53.06414153399993],
              [-73.0020238919999, -53.05437590899993],
              [-73.01048743399991, -53.05624765399995],
              [-73.11628170499995, -53.09693775799991],
              [-73.13971920499995, -53.09921640399995],
              [-73.1634008449999, -53.088148695999905],
              [-73.17796790299991, -53.07350025799991],
              [-73.18468176999994, -53.06462981599992],
              [-73.18700110599991, -53.05779387799993],
              [-73.18032792899993, -53.05095794099992],
              [-73.16828365799995, -53.04461028399993],
              [-73.15868079299992, -53.03630950299993],
              [-73.15965735599991, -53.02361419099992],
              [-73.17666581899994, -53.01523202899995],
              [-73.19489498599995, -53.030368747999944],
              [-73.20815995999993, -53.05315520599993],
              [-73.21056067599994, -53.06804778399993],
              [-73.20213782499991, -53.07366301899992],
              [-73.19139563699991, -53.07854583099993],
              [-73.18268795499995, -53.08407968499995],
              [-73.18008378799993, -53.09124114399992],
              [-73.18724524599992, -53.10247161299992],
              [-73.19847571499992, -53.10491301899992],
              [-73.21076412699995, -53.102634372999944],
              [-73.22109941299993, -53.09929778399993],
              [-73.2324926419999, -53.09417083099993],
              [-73.24185136599993, -53.08733489399992],
              [-73.25291907499991, -53.08147551899992],
              [-73.32725989499994, -53.07146575299993],
              [-73.35826575399994, -53.05095794099992],
              [-73.38621985599991, -53.01677825299993],
              [-73.39907792899993, -53.014743747999944],
              [-73.42625891799992, -53.01775481599992],
              [-73.43712317599994, -53.01311614399992],
              [-73.45287024599992, -52.99667734199994],
              [-73.45596269399994, -52.98650481599992],
              [-73.44395911399994, -52.98202890399995],
              [-73.4043676419999, -52.980726820999905],
              [-73.39244544199994, -52.98202890399995],
              [-73.38414466099994, -52.98601653399993],
              [-73.37633216099994, -52.992120049999926],
              [-73.36636308499993, -52.99651458099993],
              [-73.35142981699994, -52.99578215899993],
              [-73.35765540299991, -52.98707447699991],
              [-73.36440995999993, -52.98064544099992],
              [-73.36974036399994, -52.97421640399995],
              [-73.37193762899994, -52.96526458099993],
              [-73.36628170499995, -52.95671965899993],
              [-73.35277258999992, -52.955010674999926],
              [-73.3235570949999, -52.955336195999905],
              [-73.32249915299991, -52.95159270599993],
              [-73.32266191299993, -52.94451262799993],
              [-73.32091223899994, -52.937432549999926],
              [-73.31387285099993, -52.934258721999925],
              [-73.30874589799993, -52.9353166649999],
              [-73.29918372299994, -52.94003671699994],
              [-73.27839107999995, -52.94394296699994],
              [-73.25503495999993, -52.95712655999995],
              [-73.24156653599994, -52.961602471999925],
              [-73.24518795499995, -52.95126718499995],
              [-73.26207434799994, -52.92742278399993],
              [-73.23599199099993, -52.930759372999944],
              [-73.22793535099993, -52.934258721999925],
              [-73.23265540299991, -52.91375090899993],
              [-73.22354081899994, -52.901462497999944],
              [-73.20474199099993, -52.89690520599993],
              [-73.21385657499991, -52.887790622999944],
              [-73.28872636599993, -52.9021135399999],
              [-73.30304928299995, -52.882745049999926],
              [-73.30785071499992, -52.87379322699991],
              [-73.31993567599994, -52.877618096999925],
              [-73.33568274599992, -52.8845354149999],
              [-73.35142981699994, -52.88591887799993],
              [-73.36204993399991, -52.87590911299992],
              [-73.37071692599994, -52.85979583099993],
              [-73.38263912699995, -52.844821872999944],
              [-73.40298417899993, -52.83806731599992],
              [-73.49205481699994, -52.82561614399992],
              [-73.54185950399994, -52.812432549999926],
              [-73.56371008999992, -52.79705169099992],
              [-73.54088294199994, -52.78004322699991],
              [-73.49449622299994, -52.775323174999926],
              [-73.45885169199994, -52.78484465899993],
              [-73.46812903599994, -52.81072356599992],
              [-73.44798743399991, -52.80681731599992],
              [-73.42463131399995, -52.78240325299993],
              [-73.4094945949999, -52.77662525799991],
              [-73.39622962099992, -52.78264739399992],
              [-73.38418535099993, -52.803806247999944],
              [-73.37535559799994, -52.80046965899993],
              [-73.36717688699991, -52.795993747999944],
              [-73.35484778599994, -52.79241301899992],
              [-73.34251868399991, -52.79119231599992],
              [-73.32485917899993, -52.797539971999925],
              [-73.31541907499991, -52.79371510199991],
              [-73.3059789699999, -52.78728606599992],
              [-73.2962133449999, -52.783461195999905],
              [-73.25377356699994, -52.79119231599992],
              [-73.23306230399993, -52.79062265399995],
              [-73.22109941299993, -52.77662525799991],
              [-73.23363196499992, -52.77809010199991],
              [-73.24413001199991, -52.77703215899993],
              [-73.25015214799993, -52.77239348799992],
              [-73.24901282499991, -52.76287200299993],
              [-73.26085364499994, -52.75400155999995],
              [-73.28758704299992, -52.761651299999926],
              [-73.30304928299995, -52.75554778399993],
              [-73.30833899599992, -52.748711846999925],
              [-73.31045488199993, -52.74163176899992],
              [-73.31045488199993, -52.72478606599992],
              [-73.30663001199991, -52.71542734199994],
              [-73.29796301999994, -52.715508721999925],
              [-73.28258216099994, -52.721368096999925],
              [-73.26235917899993, -52.713148695999905],
              [-73.24937903599994, -52.70387135199991],
              [-73.23936926999994, -52.69150155999995],
              [-73.22793535099993, -52.6735979149999],
              [-73.22667395699995, -52.6657854149999],
              [-73.22752844999991, -52.65683359199994],
              [-73.22598222599993, -52.64934661299992],
              [-73.21739661399994, -52.6462541649999],
              [-73.18008378799993, -52.6462541649999],
              [-73.16331946499992, -52.64299895599993],
              [-73.15269934799994, -52.63396575299993],
              [-73.14708411399994, -52.61988697699991],
              [-73.14537512899994, -52.60165780999995],
              [-73.12730872299994, -52.55828215899993],
              [-73.12214107999995, -52.55006275799991],
              [-73.04865475199995, -52.554620049999926],
              [-73.02301998599995, -52.56406015399995],
              [-73.0110570949999, -52.563164971999925],
              [-73.0039770169999, -52.55828215899993],
              [-73.00885982999995, -52.55006275799991],
              [-73.01675370999993, -52.54827239399992],
              [-73.04979407499991, -52.55006275799991],
              [-73.10814368399991, -52.53639088299991],
              [-73.11799068899995, -52.53281015399995],
              [-73.11558997299994, -52.524102471999925],
              [-73.10850989499994, -52.51425546699994],
              [-73.10440019399994, -52.50628020599993],
              [-73.09162350199995, -52.49382903399993],
              [-73.06224524599992, -52.490899346999925],
              [-73.00885982999995, -52.496026299999926],
              [-72.92882239499994, -52.5134416649999],
              [-72.90746008999992, -52.52703215899993],
              [-72.89928137899994, -52.53020598799992],
              [-72.88585364499994, -52.525648695999905],
              [-72.88735917899993, -52.51531340899993],
              [-72.89647376199991, -52.503838799999926],
              [-72.90583248599995, -52.496026299999926],
              [-72.91795813699991, -52.49179452899995],
              [-72.96035722599993, -52.488539320999905],
              [-73.02139238199993, -52.47478606599992],
              [-73.05577551999994, -52.47144947699991],
              [-73.08079993399991, -52.47869231599992],
              [-73.10057532499991, -52.489353122999944],
              [-73.12262936099995, -52.492852471999925],
              [-73.14354407499991, -52.4900041649999],
              [-73.15965735599991, -52.48170338299991],
              [-73.18224036399994, -52.445570570999905],
              [-73.19497636599993, -52.42986419099992],
              [-73.20059160099993, -52.437432549999926],
              [-73.19859778599994, -52.44670989399992],
              [-73.1946508449999, -52.45671965899993],
              [-73.19212805899991, -52.466729424999926],
              [-73.19444739499994, -52.47551848799992],
              [-73.20372473899994, -52.47975025799991],
              [-73.21629798099991, -52.47942473799992],
              [-73.22817949099993, -52.482354424999926],
              [-73.23534094999991, -52.496026299999926],
              [-73.19652258999992, -52.50090911299992],
              [-73.18089758999992, -52.51482512799993],
              [-73.17365475199995, -52.53606536299992],
              [-73.15965735599991, -52.56373463299991],
              [-73.18578040299991, -52.592054945999905],
              [-73.2031957669999, -52.60564544099992],
              [-73.22447669199994, -52.61150481599992],
              [-73.23884029899995, -52.62004973799992],
              [-73.25621497299994, -52.660414320999905],
              [-73.26891028599994, -52.6735979149999],
              [-73.2910863919999, -52.672946872999944],
              [-73.31859290299991, -52.662774346999925],
              [-73.33775794199994, -52.64666106599992],
              [-73.33438066299993, -52.628838799999926],
              [-73.3137914699999, -52.61207447699991],
              [-73.30492102799991, -52.601820570999905],
              [-73.30304928299995, -52.5915666649999],
              [-73.30846106699994, -52.584649346999925],
              [-73.31663977799991, -52.58562590899993],
              [-73.32673092399995, -52.5896135399999],
              [-73.33775794199994, -52.5915666649999],
              [-73.35167395699995, -52.59075286299992],
              [-73.36245683499993, -52.58806731599992],
              [-73.36945553299995, -52.581149997999944],
              [-73.37193762899994, -52.567478122999944],
              [-73.37523352799991, -52.55820077899995],
              [-73.38345292899993, -52.54900481599992],
              [-73.39362545499995, -52.54412200299993],
              [-73.40298417899993, -52.54697030999995],
              [-73.40697180899991, -52.564385674999926],
              [-73.38536536399994, -52.60556405999995],
              [-73.38621985599991, -52.62574635199991],
              [-73.39732825399994, -52.6364885399999],
              [-73.40990149599992, -52.63746510199991],
              [-73.43712317599994, -52.63201262799993],
              [-73.44969641799992, -52.63518645599993],
              [-73.45295162699995, -52.64316171699994],
              [-73.45335852799991, -52.653415622999944],
              [-73.45759029899995, -52.66334400799991],
              [-73.47325598899994, -52.664320570999905],
              [-73.49351966099994, -52.65634530999995],
              [-73.50869706899994, -52.6560197899999],
              [-73.5091039699999, -52.680352471999925],
              [-73.53477942599994, -52.674899997999944],
              [-73.5579320949999, -52.6853166649999],
              [-73.59788977799991, -52.721368096999925],
              [-73.60334225199995, -52.72234465899993],
              [-73.61034094999991, -52.72112395599993],
              [-73.61636308499993, -52.720961195999905],
              [-73.61900794199994, -52.72478606599992],
              [-73.61778723899994, -52.73105234199994],
              [-73.61522376199991, -52.73406340899993],
              [-73.61266028599994, -52.7360979149999],
              [-73.61148027299993, -52.73870208099993],
              [-73.61644446499992, -52.749118747999944],
              [-73.62808183499993, -52.745212497999944],
              [-73.65314693899995, -52.72820403399993],
              [-73.68517005099994, -52.721368096999925],
              [-73.69953365799995, -52.71453215899993],
              [-73.69782467399995, -52.70427825299993],
              [-73.67096920499995, -52.68010833099993],
              [-73.65998287699995, -52.6735979149999],
              [-73.60826575399994, -52.66269296699994],
              [-73.58438066299993, -52.65325286299992],
              [-73.57054602799991, -52.63201262799993],
              [-73.59154212099992, -52.63396575299993],
              [-73.64631100199995, -52.6462541649999],
              [-73.66958574099993, -52.643243096999925],
              [-73.67731686099995, -52.63225676899992],
              [-73.67983964799993, -52.616306247999944],
              [-73.68785559799994, -52.59783294099992],
              [-73.65794837099992, -52.59075286299992],
              [-73.64443925699993, -52.58440520599993],
              [-73.63882402299993, -52.57431405999995],
              [-73.63585364499994, -52.563164971999925],
              [-73.62852942599994, -52.56129322699991],
              [-73.61961829299992, -52.56340911299992],
              [-73.61148027299993, -52.56373463299991],
              [-73.60484778599994, -52.559258721999925],
              [-73.60326087099992, -52.55478280999995],
              [-73.60065670499995, -52.55136484199994],
              [-73.59105383999992, -52.55006275799991],
              [-73.58397376199991, -52.55120208099993],
              [-73.5801488919999, -52.55348072699991],
              [-73.57754472599993, -52.55584075299993],
              [-73.5742895169999, -52.556898695999905],
              [-73.5618383449999, -52.555352471999925],
              [-73.55337480399993, -52.551039320999905],
              [-73.55089270699995, -52.54452890399995],
              [-73.55626380099994, -52.53639088299991],
              [-73.56704667899993, -52.53167083099993],
              [-73.61522376199991, -52.523370049999926],
              [-73.61925208199995, -52.52044036299992],
              [-73.60863196499992, -52.513604424999926],
              [-73.58421790299991, -52.502211195999905],
              [-73.57689368399991, -52.49570077899995],
              [-73.56550045499995, -52.47893645599993],
              [-73.55996660099993, -52.47551848799992],
              [-73.49486243399991, -52.47551848799992],
              [-73.51878821499992, -52.46502044099992],
              [-73.53091386599993, -52.456963799999926],
              [-73.53018144399994, -52.44426848799992],
              [-73.51528886599993, -52.42034270599993],
              [-73.53294837099992, -52.41529713299991],
              [-73.54727128799993, -52.42595794099992],
              [-73.56200110599991, -52.44068775799991],
              [-73.58112545499995, -52.448337497999944],
              [-73.65440833199995, -52.430759372999944],
              [-73.66616777299993, -52.42400481599992],
              [-73.66510982999995, -52.40007903399993],
              [-73.66026770699995, -52.383884372999944],
              [-73.64903723899994, -52.3747697899999],
              [-73.62889563699991, -52.37200286299992],
              [-73.62035071499992, -52.37517669099992],
              [-73.61375891799992, -52.38176848799992],
              [-73.60692298099991, -52.386976820999905],
              [-73.59788977799991, -52.38616301899992],
              [-73.5891820949999, -52.37908294099992],
              [-73.58519446499992, -52.36972421699994],
              [-73.58421790299991, -52.348321221999925],
              [-73.57835852799991, -52.34384530999995],
              [-73.56786048099991, -52.33326588299991],
              [-73.56297766799992, -52.32284921699994],
              [-73.5742895169999, -52.31796640399995],
              [-73.59837805899991, -52.30217864399992],
              [-73.60472571499992, -52.296807549999926],
              [-73.61266028599994, -52.27743905999995],
              [-73.6067602199999, -52.26458098799992],
              [-73.59479732999995, -52.252211195999905],
              [-73.58421790299991, -52.23479583099993],
              [-73.58055579299992, -52.20842864399992],
              [-73.59137936099995, -52.20045338299991],
              [-73.61070716099994, -52.19963958099993],
              [-73.63263912699995, -52.19378020599993],
              [-73.6321508449999, -52.18889739399992],
              [-73.63711503799993, -52.1755510399999],
              [-73.64329993399991, -52.16366952899995],
              [-73.64631100199995, -52.16301848799992],
              [-73.65070553299995, -52.158135674999926],
              [-73.68040930899991, -52.14592864399992],
              [-73.68834387899994, -52.12232838299991],
              [-73.71963456899994, -52.09579843499995],
              [-73.74498450399994, -52.06536223799992],
              [-73.73501542899993, -52.029961846999925],
              [-73.71589107999995, -52.020603122999944],
              [-73.69896399599992, -52.02629973799992],
              [-73.67699133999992, -52.04306405999995],
              [-73.67430579299992, -52.051446221999925],
              [-73.63882402299993, -52.09823984199994],
              [-73.62547766799992, -52.13014088299991],
              [-73.6145727199999, -52.14470794099992],
              [-73.60130774599992, -52.142510674999926],
              [-73.5813695949999, -52.13437265399995],
              [-73.56826738199993, -52.14861419099992],
              [-73.55894934799994, -52.170993747999944],
              [-73.5501195949999, -52.18694426899992],
              [-73.52887936099995, -52.195570570999905],
              [-73.51085364499994, -52.18987395599993],
              [-73.49449622299994, -52.1794572899999],
              [-73.47809811099995, -52.17392343499995],
              [-73.46833248599995, -52.169040622999944],
              [-73.48387610599991, -52.15764739399992],
              [-73.5227758449999, -52.13909270599993],
              [-73.49571692599994, -52.131931247999944],
              [-73.4629613919999, -52.13836028399993],
              [-73.4317113919999, -52.153008721999925],
              [-73.38719641799992, -52.1911760399999],
              [-73.36196855399993, -52.20794036299992],
              [-73.33385169199994, -52.218682549999926],
              [-73.30304928299995, -52.221774997999944],
              [-73.27159583199995, -52.21607838299991],
              [-73.24282792899993, -52.20208098799992],
              [-73.22179114499994, -52.17986419099992],
              [-73.21369381399995, -52.149509372999944],
              [-73.21617591099994, -52.12509530999995],
              [-73.21377519399994, -52.11923593499995],
              [-73.20409094999991, -52.108086846999925],
              [-73.19131425699993, -52.103773695999905],
              [-73.17341061099995, -52.10711028399993],
              [-73.15611731699994, -52.115166924999926],
              [-73.14537512899994, -52.12558359199994],
              [-73.11880449099993, -52.10214609199994],
              [-73.08690344999991, -52.08245208099993],
              [-73.05260169199994, -52.06910572699991],
              [-73.01878821499992, -52.06406015399995],
              [-72.99779212099992, -52.06487395599993],
              [-72.98766028599994, -52.06926848799992],
              [-72.98363196499992, -52.07952239399992],
              [-72.98094641799992, -52.09823984199994],
              [-72.98082434799994, -52.10979583099993],
              [-72.98298092399995, -52.1267229149999],
              [-72.98745683499993, -52.14299895599993],
              [-72.99453691299993, -52.15292734199994],
              [-73.00348873599995, -52.154229424999926],
              [-73.0235082669999, -52.14788176899992],
              [-73.03270423099991, -52.14592864399992],
              [-73.04088294199994, -52.14885833099993],
              [-73.04588782499991, -52.15553150799991],
              [-73.04942786399994, -52.16375090899993],
              [-73.05353756399995, -52.170179945999905],
              [-73.06371008999992, -52.181573174999926],
              [-73.07380123599995, -52.19573333099993],
              [-73.08153235599991, -52.210870049999926],
              [-73.08458411399994, -52.22519296699994],
              [-73.07925370999993, -52.23707447699991],
              [-73.06749426999994, -52.23211028399993],
              [-73.02745520699995, -52.19296640399995],
              [-73.01431230399993, -52.187432549999926],
              [-72.99453691299993, -52.18694426899992],
              [-72.94664466099994, -52.20175546699994],
              [-72.92198645699995, -52.213962497999944],
              [-72.91637122299994, -52.22519296699994],
              [-72.92210852799991, -52.23845794099992],
              [-72.91283118399991, -52.244805596999925],
              [-72.88589433499993, -52.248304945999905],
              [-72.87267005099994, -52.25335051899992],
              [-72.86644446499992, -52.25676848799992],
              [-72.86115475199995, -52.25595468499995],
              [-72.84068762899994, -52.24065520599993],
              [-72.83482825399994, -52.23398202899995],
              [-72.83202063699991, -52.225274346999925],
              [-72.83128821499992, -52.211195570999905],
              [-72.82795162699995, -52.20061614399992],
              [-72.81297766799992, -52.17913176899992],
              [-72.80955969999991, -52.170179945999905],
              [-72.80679277299993, -52.14657968499995],
              [-72.79873613199993, -52.12965260199991],
              [-72.76862545499995, -52.09823984199994],
              [-72.75430253799993, -52.07512786299992],
              [-72.75487219999991, -52.05681731599992],
              [-72.76838131399995, -52.05120208099993],
              [-72.82579505099994, -52.09140390399995],
              [-72.84117591099994, -52.105726820999905],
              [-72.85057532499991, -52.12558359199994],
              [-72.85098222599993, -52.161228122999944],
              [-72.85460364499994, -52.17848072699991],
              [-72.86856035099993, -52.197198174999926],
              [-72.88369706899994, -52.198337497999944],
              [-72.90746008999992, -52.19003671699994],
              [-72.93146725199995, -52.17782968499995],
              [-72.94737708199995, -52.16643645599993],
              [-72.94098873599995, -52.15129973799992],
              [-72.94884192599994, -52.121758721999925],
              [-72.94017493399991, -52.095635674999926],
              [-72.95030676999994, -52.06462981599992],
              [-72.94737708199995, -52.04973723799992],
              [-72.93272864499994, -52.03948333099993],
              [-72.92031816299993, -52.04566822699991],
              [-72.9102270169999, -52.05754973799992],
              [-72.90233313699991, -52.06406015399995],
              [-72.89452063699991, -52.05706145599993],
              [-72.88707434799994, -52.023695570999905],
              [-72.88223222599993, -52.01230234199994],
              [-72.87474524599992, -51.99960702899995],
              [-72.87059485599991, -51.96819426899992],
              [-72.86485755099994, -51.95476653399993],
              [-72.85362708199995, -51.948337497999944],
              [-72.83446204299992, -51.94198984199994],
              [-72.81493079299992, -51.93759530999995],
              [-72.8028051419999, -51.937432549999926],
              [-72.74132239499994, -51.96843840899993],
              [-72.69579016799992, -51.98137786299992],
              [-72.68667558499993, -51.98837655999995],
              [-72.6887914699999, -52.00750090899993],
              [-72.70421301999994, -52.021742445999905],
              [-72.71507727799991, -52.03728606599992],
              [-72.70348059799994, -52.0603166649999],
              [-72.69395911399994, -52.06715260199991],
              [-72.67027747299994, -52.07773202899995],
              [-72.65876217399995, -52.08456796699994],
              [-72.65184485599991, -52.09254322699991],
              [-72.64875240799995, -52.10003020599993],
              [-72.64403235599991, -52.10662200299993],
              [-72.63206946499992, -52.11191171699994],
              [-72.63158118399991, -52.108493747999944],
              [-72.62816321499992, -52.10214609199994],
              [-72.62242591099994, -52.09807708099993],
              [-72.61465410099993, -52.1013322899999],
              [-72.60138912699995, -52.11191171699994],
              [-72.59825598899994, -52.117120049999926],
              [-72.58088131399995, -52.13909270599993],
              [-72.57681230399993, -52.142510674999926],
              [-72.56851152299993, -52.164320570999905],
              [-72.55125891799992, -52.17913176899992],
              [-72.53652910099993, -52.195570570999905],
              [-72.53587805899991, -52.221774997999944],
              [-72.54137122299994, -52.22812265399995],
              [-72.55064856699994, -52.23398202899995],
              [-72.55939693899995, -52.241306247999944],
              [-72.56314042899993, -52.25212981599992],
              [-72.56432044199994, -52.26018645599993],
              [-72.56944739499994, -52.2751604149999],
              [-72.57420813699991, -52.30917734199994],
              [-72.58478756399995, -52.32708098799992],
              [-72.60171464799993, -52.33928801899992],
              [-72.62462317599994, -52.34465911299992],
              [-72.63670813699991, -52.34392669099992],
              [-72.64903723899994, -52.340915622999944],
              [-72.66030839799993, -52.33554452899995],
              [-72.66966712099992, -52.32781340899993],
              [-72.6790258449999, -52.32301197699991],
              [-72.68578040299991, -52.32870859199994],
              [-72.69664466099994, -52.348321221999925],
              [-72.71450761599993, -52.36288827899995],
              [-72.74006100199995, -52.374932549999926],
              [-72.76537024599992, -52.37786223799992],
              [-72.78286699099993, -52.36565520599993],
              [-72.77521725199995, -52.3825822899999],
              [-72.78160559799994, -52.386976820999905],
              [-72.79381262899994, -52.385837497999944],
              [-72.80337480399993, -52.38616301899992],
              [-72.81135006399995, -52.392510674999926],
              [-72.83128821499992, -52.41350676899992],
              [-72.85216223899994, -52.42522551899992],
              [-72.87938391799992, -52.434665622999944],
              [-72.9082738919999, -52.440118096999925],
              [-72.93374589799993, -52.44085051899992],
              [-72.93053137899994, -52.44817473799992],
              [-72.92699133999992, -52.45175546699994],
              [-72.92170162699995, -52.45322030999995],
              [-72.91323808499993, -52.45387135199991],
              [-72.88898678299995, -52.451836846999925],
              [-72.83942623599995, -52.437432549999926],
              [-72.79076087099992, -52.42986419099992],
              [-72.74596106699994, -52.41171640399995],
              [-72.72142493399991, -52.40667083099993],
              [-72.69298255099994, -52.4079729149999],
              [-72.61465410099993, -52.42034270599993],
              [-72.58995520699995, -52.42791106599992],
              [-72.57144120999993, -52.44296640399995],
              [-72.55142167899993, -52.45354583099993],
              [-72.52220618399991, -52.448337497999944],
              [-72.50568600199995, -52.43368905999995],
              [-72.52098548099991, -52.42522551899992],
              [-72.60631262899994, -52.417087497999944],
              [-72.62193762899994, -52.412774346999925],
              [-72.63206946499992, -52.40667083099993],
              [-72.63756262899994, -52.39763762799993],
              [-72.63414466099994, -52.39397551899992],
              [-72.62458248599995, -52.39153411299992],
              [-72.61156165299991, -52.38616301899992],
              [-72.57681230399993, -52.36541106599992],
              [-72.54613196499992, -52.34148528399993],
              [-72.52647864499994, -52.32976653399993],
              [-72.50999915299991, -52.324883721999925],
              [-72.49714107999995, -52.31536223799992],
              [-72.46959387899994, -52.22340260199991],
              [-72.46694902299993, -52.20427825299993],
              [-72.47565670499995, -52.187432549999926],
              [-72.57974199099993, -52.09693775799991],
              [-72.60850989499994, -52.08359140399995],
              [-72.64867102799991, -52.04900481599992],
              [-72.65876217399995, -52.036228122999944],
              [-72.66470292899993, -51.970635674999926],
              [-72.66966712099992, -51.96103280999995],
              [-72.66112219999991, -51.95745208099993],
              [-72.65440833199995, -51.95045338299991],
              [-72.64598548099991, -51.94540780999995],
              [-72.63206946499992, -51.94736093499995],
              [-72.62515214799993, -51.95435963299991],
              [-72.61994381399995, -51.9646135399999],
              [-72.61229407499991, -51.973321221999925],
              [-72.59797115799995, -51.975274346999925],
              [-72.58755449099993, -51.96843840899993],
              [-72.58242753799993, -51.94548919099992],
              [-72.57371985599991, -51.94060637799993],
              [-72.56175696499992, -51.94280364399992],
              [-72.54133053299995, -51.95256926899992],
              [-72.52904212099992, -51.95476653399993],
              [-72.50401770699995, -51.951429945999905],
              [-72.48497473899994, -51.942478122999944],
              [-72.46898352799991, -51.92929452899995],
              [-72.45327714799993, -51.91326262799993],
              [-72.46642005099994, -51.896416924999926],
              [-72.4981176419999, -51.874118747999944],
              [-72.50792395699995, -51.85857512799993],
              [-72.50837154899995, -51.83709075299993],
              [-72.49815833199995, -51.820977471999925],
              [-72.46694902299993, -51.789727471999925],
              [-72.49494381399995, -51.76921965899993],
              [-72.5098363919999, -51.72820403399993],
              [-72.52204342399995, -51.71306731599992],
              [-72.56322180899991, -51.70273202899995],
              [-72.60798092399995, -51.67848072699991],
              [-72.62462317599994, -51.66676197699991],
              [-72.63548743399991, -51.65504322699991],
              [-72.66966712099992, -51.60816822699991],
              [-72.68903561099995, -51.59343840899993],
              [-72.71251380099994, -51.58220794099992],
              [-72.73770097599993, -51.57463958099993],
              [-72.76244055899991, -51.570570570999905],
              [-72.82754472599993, -51.570570570999905],
              [-72.83751380099994, -51.56731536299992],
              [-72.85838782499991, -51.55282968499995],
              [-72.86856035099993, -51.549493096999925],
              [-72.89899654899995, -51.54900481599992],
              [-72.91515051999994, -51.54705169099992],
              [-72.92625891799992, -51.54265715899993],
              [-72.93272864499994, -51.53460051899992],
              [-72.94220943899995, -51.51523202899995],
              [-72.94737708199995, -51.508477471999925],
              [-72.96947180899991, -51.49846770599993],
              [-73.02916419199994, -51.488539320999905],
              [-73.05353756399995, -51.48748137799993],
              [-73.06794186099995, -51.47861093499995],
              [-73.07974199099993, -51.45826588299991],
              [-73.08438066299993, -51.43564218499995],
              [-73.07713782499991, -51.4196916649999],
              [-73.09097245999993, -51.42083098799992],
              [-73.12262936099995, -51.439711195999905],
              [-73.13914954299992, -51.4470354149999],
              [-73.24547278599994, -51.46502044099992],
              [-73.26036536399994, -51.47112395599993],
              [-73.2676488919999, -51.48056405999995],
              [-73.26207434799994, -51.49488697699991],
              [-73.24559485599991, -51.50660572699991],
              [-73.22712154899995, -51.50790780999995],
              [-73.17357337099992, -51.49732838299991],
              [-73.15733801999994, -51.4900041649999],
              [-73.14061438699991, -51.48756275799991],
              [-73.12214107999995, -51.498304945999905],
              [-73.10513261599993, -51.502211195999905],
              [-73.05431067599994, -51.502618096999925],
              [-73.04356848899994, -51.51189544099992],
              [-73.04161536399994, -51.52263762799993],
              [-73.03868567599994, -51.52890390399995],
              [-73.03888912699995, -51.53533294099992],
              [-73.04674231699994, -51.54607512799993],
              [-73.05410722599993, -51.55169036299992],
              [-73.07306881399995, -51.56129322699991],
              [-73.10610917899993, -51.583916924999926],
              [-73.11074785099993, -51.59335702899995],
              [-73.09825598899994, -51.60475025799991],
              [-73.03770911399994, -51.565118096999925],
              [-73.02464758999992, -51.56064218499995],
              [-73.02310136599993, -51.554620049999926],
              [-73.02367102799991, -51.54778411299992],
              [-73.02183997299994, -51.54265715899993],
              [-73.01341712099992, -51.536228122999944],
              [-73.00177975199995, -51.52939218499995],
              [-72.98916581899994, -51.52662525799991],
              [-72.97777258999992, -51.53281015399995],
              [-72.94957434799994, -51.55917734199994],
              [-72.94367428299995, -51.563164971999925],
              [-72.92296301999994, -51.567478122999944],
              [-72.85802161399994, -51.59734465899993],
              [-72.83568274599992, -51.59840260199991],
              [-72.81456458199995, -51.5954729149999],
              [-72.79381262899994, -51.59612395599993],
              [-72.77232825399994, -51.60816822699991],
              [-72.75792395699995, -51.62346770599993],
              [-72.71589107999995, -51.68181731599992],
              [-72.71060136599993, -51.69101327899995],
              [-72.70295162699995, -51.69801197699991],
              [-72.69009355399993, -51.7009416649999],
              [-72.63548743399991, -51.70720794099992],
              [-72.63243567599994, -51.70907968499995],
              [-72.62336178299995, -51.71819426899992],
              [-72.61778723899994, -51.72144947699991],
              [-72.60973059799994, -51.72234465899993],
              [-72.59251868399991, -51.72087981599992],
              [-72.56261145699995, -51.72478606599992],
              [-72.55524654899995, -51.72966887799993],
              [-72.54954993399991, -51.741306247999944],
              [-72.55158443899995, -51.7575822899999],
              [-72.56240800699993, -51.77825286299992],
              [-72.57803300699993, -51.795993747999944],
              [-72.60488847599993, -51.80722421699994],
              [-72.63190670499995, -51.82561614399992],
              [-72.64513098899994, -51.83131275799991],
              [-72.65819251199991, -51.832696221999925],
              [-72.69969641799992, -51.83131275799991],
              [-72.71580969999991, -51.836602471999925],
              [-72.72411048099991, -51.838148695999905],
              [-72.72765051999994, -51.83440520599993],
              [-72.72899329299992, -51.83017343499995],
              [-72.73558508999992, -51.81926848799992],
              [-72.73790442599994, -51.817071221999925],
              [-72.78628495999993, -51.810804945999905],
              [-72.80003821499992, -51.8025041649999],
              [-72.81248938699991, -51.78484465899993],
              [-72.82974199099993, -51.76799895599993],
              [-72.85802161399994, -51.762383721999925],
              [-72.88451087099992, -51.77385833099993],
              [-72.89932206899994, -51.776055596999925],
              [-72.90583248599995, -51.76580169099992],
              [-72.90941321499992, -51.757745049999926],
              [-72.91795813699991, -51.75741952899995],
              [-72.96271725199995, -51.76848723799992],
              [-72.97667395699995, -51.76921965899993],
              [-72.9883520169999, -51.762383721999925],
              [-72.99038652299993, -51.75318775799991],
              [-72.98619544199994, -51.74358489399992],
              [-72.98314368399991, -51.73333098799992],
              [-72.9883520169999, -51.72144947699991],
              [-72.99815833199995, -51.71892669099992],
              [-73.02940833199995, -51.716729424999926],
              [-73.03620357999995, -51.710870049999926],
              [-73.03986568899995, -51.70208098799992],
              [-73.04881751199991, -51.69687265399995],
              [-73.05996660099993, -51.69426848799992],
              [-73.07022050699993, -51.69353606599992],
              [-73.12328040299991, -51.70191822699991],
              [-73.15078691299993, -51.703057549999926],
              [-73.17332923099991, -51.69353606599992],
              [-73.18480383999992, -51.67001718499995],
              [-73.18028723899994, -51.650648695999905],
              [-73.18244381399995, -51.63746510199991],
              [-73.22842363199993, -51.62908294099992],
              [-73.24201412699995, -51.61150481599992],
              [-73.25523841099994, -51.60475025799991],
              [-73.26838131399995, -51.603773695999905],
              [-73.28001868399991, -51.60621510199991],
              [-73.28962154899995, -51.61142343499995],
              [-73.2962133449999, -51.61834075299993],
              [-73.25381425699993, -51.6364885399999],
              [-73.23753821499992, -51.64739348799992],
              [-73.22793535099993, -51.66676197699991],
              [-73.22842363199993, -51.67929452899995],
              [-73.23224850199995, -51.688164971999925],
              [-73.23302161399994, -51.697523695999905],
              [-73.22447669199994, -51.710870049999926],
              [-73.21385657499991, -51.717461846999925],
              [-73.19953365799995, -51.7204729149999],
              [-73.07005774599992, -51.724541924999926],
              [-73.0266820949999, -51.744073174999926],
              [-72.99453691299993, -51.789727471999925],
              [-73.02757727799991, -51.77743905999995],
              [-73.06680253799993, -51.75505950299993],
              [-73.10602779899995, -51.74488697699991],
              [-73.13914954299992, -51.76921965899993],
              [-73.12840735599991, -51.77556731599992],
              [-73.11644446499992, -51.776462497999944],
              [-73.10464433499993, -51.77271900799991],
              [-73.09447180899991, -51.76580169099992],
              [-73.08421790299991, -51.76132577899995],
              [-73.07408606699994, -51.76295338299991],
              [-73.06037350199995, -51.76921965899993],
              [-73.04922441299993, -51.77792734199994],
              [-73.04564368399991, -51.79762135199991],
              [-73.04674231699994, -51.818617445999905],
              [-73.04979407499991, -51.83131275799991],
              [-73.08234615799995, -51.85361093499995],
              [-73.17414303299995, -51.85979583099993],
              [-73.20742753799993, -51.87908294099992],
              [-73.19041907499991, -51.887383721999925],
              [-73.1680395169999, -51.88982512799993],
              [-73.14565995999993, -51.88616301899992],
              [-73.12857011599993, -51.875664971999925],
              [-73.11831620999993, -51.871026299999926],
              [-73.07713782499991, -51.87224700299993],
              [-73.06663977799991, -51.86842213299991],
              [-73.04356848899994, -51.85116952899995],
              [-73.00861568899995, -51.83220794099992],
              [-72.97240149599992, -51.82170989399992],
              [-72.94078528599994, -51.82773202899995],
              [-72.91942298099991, -51.85857512799993],
              [-72.93761145699995, -51.869398695999905],
              [-73.0020238919999, -51.88534921699994],
              [-73.06135006399995, -51.91611093499995],
              [-73.08079993399991, -51.92066822699991],
              [-73.10326087099992, -51.92245859199994],
              [-73.12682044199994, -51.92848072699991],
              [-73.14533443899995, -51.94003671699994],
              [-73.15282141799992, -51.95794036299992],
              [-73.15575110599991, -51.97185637799993],
              [-73.17332923099991, -52.022556247999944],
              [-73.17438717399995, -52.04705169099992],
              [-73.17271887899994, -52.06658294099992],
              [-73.17666581899994, -52.08123137799993],
              [-73.19444739499994, -52.09075286299992],
              [-73.22370357999995, -52.09148528399993],
              [-73.24193274599992, -52.07903411299992],
              [-73.27261308499993, -52.03964609199994],
              [-73.27501380099994, -52.0232072899999],
              [-73.26821855399993, -51.97193775799991],
              [-73.27261308499993, -51.96103280999995],
              [-73.28014075399994, -51.95240650799991],
              [-73.30304928299995, -51.89959075299993],
              [-73.29527747299994, -51.87167734199994],
              [-73.29971269399994, -51.831963799999926],
              [-73.32677161399994, -51.72698333099993],
              [-73.33849036399994, -51.69980234199994],
              [-73.35680091099994, -51.676446221999925],
              [-73.38621985599991, -51.65252044099992],
              [-73.38670813699991, -51.67083098799992],
              [-73.37995357999995, -51.683526299999926],
              [-73.35826575399994, -51.70720794099992],
              [-73.35065670499995, -51.72144947699991],
              [-73.34129798099991, -51.75269947699991],
              [-73.33263098899994, -51.801853122999944],
              [-73.32852128799993, -51.86142343499995],
              [-73.31143144399994, -51.957696221999925],
              [-73.30797278599994, -52.02206796699994],
              [-73.28502356699994, -52.10442473799992],
              [-73.28258216099994, -52.142510674999926],
              [-73.29283606699994, -52.16570403399993],
              [-73.31623287699995, -52.16611093499995],
              [-73.34166419199994, -52.155368747999944],
              [-73.35826575399994, -52.14592864399992],
              [-73.39439856699994, -52.13445403399993],
              [-73.39981035099993, -52.12900155999995],
              [-73.40265865799995, -52.117852471999925],
              [-73.40965735599991, -52.10800546699994],
              [-73.41942298099991, -52.10084400799991],
              [-73.45156816299993, -52.09433359199994],
              [-73.54002844999991, -52.05527109199994],
              [-73.56354732999995, -52.03997161299992],
              [-73.58128821499992, -52.02190520599993],
              [-73.58112545499995, -52.00546640399995],
              [-73.57290605399993, -51.98365650799991],
              [-73.58315995999993, -51.96526458099993],
              [-73.60000566299993, -51.9489885399999],
              [-73.61148027299993, -51.93434010199991],
              [-73.60130774599992, -51.93499114399992],
              [-73.59312903599994, -51.93401458099993],
              [-73.58576412699995, -51.93124765399995],
              [-73.57799231699994, -51.92693450299993],
              [-73.59496008999992, -51.9118791649999],
              [-73.6223852199999, -51.88128020599993],
              [-73.64557857999995, -51.848728122999944],
              [-73.6497289699999, -51.8278947899999],
              [-73.62092037699995, -51.81218840899993],
              [-73.59927324099993, -51.82268645599993],
              [-73.56371008999992, -51.86541106599992],
              [-73.53770911399994, -51.88355885199991],
              [-73.52708899599992, -51.895196221999925],
              [-73.5227758449999, -51.90984465899993],
              [-73.52049719999991, -51.92392343499995],
              [-73.51402747299994, -51.938571872999944],
              [-73.50422115799995, -51.95012786299992],
              [-73.46422278599994, -51.96738046699994],
              [-73.45181230399993, -51.99334075299993],
              [-73.43643144399994, -52.01523202899995],
              [-73.39981035099993, -52.01572030999995],
              [-73.41551673099991, -51.99041106599992],
              [-73.48180091099994, -51.91326262799993],
              [-73.47557532499991, -51.91155364399992],
              [-73.46939042899993, -51.908868096999925],
              [-73.46263587099992, -51.90667083099993],
              [-73.45449785099993, -51.90642669099992],
              [-73.46117102799991, -51.89568450299993],
              [-73.47044837099992, -51.89218515399995],
              [-73.48013261599993, -51.89031340899993],
              [-73.48863684799994, -51.88534921699994],
              [-73.4922582669999, -51.87542083099993],
              [-73.49303137899994, -51.85491301899992],
              [-73.49852454299992, -51.85116952899995],
              [-73.51984615799995, -51.84644947699991],
              [-73.53062903599994, -51.83473072699991],
              [-73.53148352799991, -51.81926848799992],
              [-73.5227758449999, -51.803399346999925],
              [-73.55044511599993, -51.78948333099993],
              [-73.57982337099992, -51.768649997999944],
              [-73.5891820949999, -51.74960702899995],
              [-73.53400631399995, -51.73601653399993],
              [-73.50348873599995, -51.72275155999995],
              [-73.47565670499995, -51.705010674999926],
              [-73.46068274599992, -51.68670012799993],
              [-73.48818925699993, -51.68759530999995],
              [-73.50987708199995, -51.69605885199991],
              [-73.5501195949999, -51.72144947699991],
              [-73.5501195949999, -51.68043385199991],
              [-73.56240800699993, -51.68954843499995],
              [-73.57876542899993, -51.713555596999925],
              [-73.59166419199994, -51.72144947699991],
              [-73.61164303299995, -51.71998463299991],
              [-73.62328040299991, -51.707696221999925],
              [-73.6301977199999, -51.69345468499995],
              [-73.63573157499991, -51.68670012799993],
              [-73.65485592399995, -51.688571872999944],
              [-73.65929114499994, -51.694431247999944],
              [-73.66047115799995, -51.704196872999944],
              [-73.67764238199993, -51.72812265399995],
              [-73.68374589799993, -51.74187590899993],
              [-73.68553626199991, -51.75660572699991],
              [-73.68040930899991, -51.76921965899993],
              [-73.69945227799991, -51.78525155999995],
              [-73.71890214799993, -51.77581145599993],
              [-73.76231848899994, -51.735039971999925],
              [-73.76276607999995, -51.715101820999905],
              [-73.81200110599991, -51.688571872999944],
              [-73.80703691299993, -51.67001718499995],
              [-73.78636633999992, -51.6599260399999],
              [-73.73717200399994, -51.65097421699994],
              [-73.71458899599992, -51.63884856599992],
              [-73.73648027299993, -51.637383721999925],
              [-73.76016191299993, -51.642510674999926],
              [-73.78416907499991, -51.64495208099993],
              [-73.80703691299993, -51.635837497999944],
              [-73.81891842399995, -51.628838799999926],
              [-73.82852128799993, -51.62851327899995],
              [-73.83861243399991, -51.63103606599992],
              [-73.85142981699994, -51.6325822899999],
              [-73.86384029899995, -51.6286760399999],
              [-73.87458248599995, -51.62167734199994],
              [-73.88581295499995, -51.61809661299992],
              [-73.89952551999994, -51.62517669099992],
              [-73.90298417899993, -51.618259372999944],
              [-73.90420488199993, -51.61174895599993],
              [-73.90318762899994, -51.60491301899992],
              [-73.89952551999994, -51.59734465899993],
              [-73.89122473899994, -51.58668385199991],
              [-73.88414466099994, -51.58342864399992],
              [-73.87621008999992, -51.58220794099992],
              [-73.86538652299993, -51.57740650799991],
              [-73.82603919199994, -51.54656340899993],
              [-73.81696529899995, -51.53655364399992],
              [-73.88145911399994, -51.53679778399993],
              [-73.90925045499995, -51.52695077899995],
              [-73.92064368399991, -51.498304945999905],
              [-73.91722571499992, -51.490899346999925],
              [-73.91063391799992, -51.48495859199994],
              [-73.9063207669999, -51.478773695999905],
              [-73.90977942599994, -51.470961195999905],
              [-73.9141332669999, -51.465508721999925],
              [-73.91934160099993, -51.45566171699994],
              [-73.92369544199994, -51.450290622999944],
              [-73.92878170499995, -51.43914153399993],
              [-73.92829342399995, -51.41521575299993],
              [-73.93431555899991, -51.4060197899999],
              [-73.93431555899991, -51.39934661299992],
              [-73.89928137899994, -51.37517669099992],
              [-73.88036048099991, -51.36793385199991],
              [-73.87218176999994, -51.38225676899992],
              [-73.86143958199995, -51.392836195999905],
              [-73.81403561099995, -51.39218515399995],
              [-73.80333411399994, -51.40276458099993],
              [-73.79662024599992, -51.41814544099992],
              [-73.78075110599991, -51.43303801899992],
              [-73.7481176419999, -51.45330169099992],
              [-73.71344967399995, -51.469821872999944],
              [-73.69953365799995, -51.48007577899995],
              [-73.68785559799994, -51.49488697699991],
              [-73.66356360599991, -51.541273695999905],
              [-73.65453040299991, -51.56658294099992],
              [-73.63060462099992, -51.59612395599993],
              [-73.62083899599992, -51.62818775799991],
              [-73.61188717399995, -51.62542083099993],
              [-73.60448157499991, -51.61142343499995],
              [-73.60472571499992, -51.59107838299991],
              [-73.61001542899993, -51.578383070999905],
              [-73.63882402299993, -51.53655364399992],
              [-73.61644446499992, -51.52288176899992],
              [-73.60460364499994, -51.51295338299991],
              [-73.60814368399991, -51.508477471999925],
              [-73.63914954299992, -51.50937265399995],
              [-73.65143795499995, -51.50554778399993],
              [-73.65998287699995, -51.49488697699991],
              [-73.6555883449999, -51.46843840899993],
              [-73.5996801419999, -51.45126718499995],
              [-73.59788977799991, -51.43279387799993],
              [-73.63792883999992, -51.44646575299993],
              [-73.66909745999993, -51.43865325299993],
              [-73.69220943899995, -51.41448333099993],
              [-73.71955318899995, -51.356540622999944],
              [-73.72142493399991, -51.34775155999995],
              [-73.72142493399991, -51.30999114399992],
              [-73.72012285099993, -51.29924895599993],
              [-73.71743730399993, -51.29355234199994],
              [-73.71768144399994, -51.28850676899992],
              [-73.72508704299992, -51.27947356599992],
              [-73.74038652299993, -51.26921965899993],
              [-73.74596106699994, -51.26311614399992],
              [-73.7481176419999, -51.251885674999926],
              [-73.75283769399994, -51.248711846999925],
              [-73.7754613919999, -51.240899346999925],
              [-73.78282630099994, -51.23479583099993],
              [-73.78429114499994, -51.22356536299992],
              [-73.77940833199995, -51.215101820999905],
              [-73.77293860599991, -51.2087541649999],
              [-73.76984615799995, -51.203789971999925],
              [-73.75959225199995, -51.19500090899993],
              [-73.73713131399995, -51.20842864399992],
              [-73.70466061099995, -51.238213799999926],
              [-73.70107988199993, -51.24749114399992],
              [-73.70164954299992, -51.25823333099993],
              [-73.70103919199994, -51.26832447699991],
              [-73.69408118399991, -51.27581145599993],
              [-73.68272864499994, -51.27597421699994],
              [-73.68175208199995, -51.26490650799991],
              [-73.68785559799994, -51.24504973799992],
              [-73.69261633999992, -51.21453215899993],
              [-73.68919837099992, -51.20232512799993],
              [-73.67357337099992, -51.19378020599993],
              [-73.67357337099992, -51.18767669099992],
              [-73.69041907499991, -51.19085051899992],
              [-73.70490475199995, -51.19060637799993],
              [-73.71751868399991, -51.18678150799991],
              [-73.72883053299995, -51.179620049999926],
              [-73.72118079299992, -51.167901299999926],
              [-73.69408118399991, -51.13925546699994],
              [-73.70628821499992, -51.131524346999925],
              [-73.71548417899993, -51.135023695999905],
              [-73.72411048099991, -51.14218515399995],
              [-73.73501542899993, -51.14544036299992],
              [-73.74437415299991, -51.14185963299991],
              [-73.76984615799995, -51.11809661299992],
              [-73.77399654899995, -51.12835051899992],
              [-73.77106686099995, -51.13339609199994],
              [-73.7656957669999, -51.13746510199991],
              [-73.76231848899994, -51.14544036299992],
              [-73.76138261599993, -51.15960051899992],
              [-73.76284745999993, -51.1638322899999],
              [-73.76919511599993, -51.16611093499995],
              [-73.78282630099994, -51.17343515399995],
              [-73.85789954299992, -51.22795989399992],
              [-73.87938391799992, -51.23788827899995],
              [-73.89757239499994, -51.238539320999905],
              [-73.91397050699993, -51.231540622999944],
              [-73.94139563699991, -51.209242445999905],
              [-73.96727454299992, -51.19410572699991],
              [-73.97524980399993, -51.18767669099992],
              [-73.97813880099994, -51.179945570999905],
              [-73.98204505099994, -51.152276299999926],
              [-73.99217688699991, -51.13689544099992],
              [-74.00829016799992, -51.11858489399992],
              [-74.02330481699994, -51.11101653399993],
              [-74.02989661399994, -51.128024997999944],
              [-74.02562415299991, -51.148695570999905],
              [-74.01846269399994, -51.17050546699994],
              [-74.01699785099993, -51.19085051899992],
              [-74.02989661399994, -51.20761484199994],
              [-74.0540258449999, -51.21233489399992],
              [-74.07945716099994, -51.20468515399995],
              [-74.10505123599995, -51.19345468499995],
              [-74.12950598899994, -51.18767669099992],
              [-74.13597571499992, -51.17693450299993],
              [-74.1328832669999, -51.111260674999926],
              [-74.13459225199995, -51.09295012799993],
              [-74.14964758999992, -51.08025481599992],
              [-74.15444902299993, -51.07073333099993],
              [-74.15294348899994, -51.06096770599993],
              [-74.14806067599994, -51.05217864399992],
              [-74.09821529899995, -51.00164153399993],
              [-74.07770748599995, -50.98788827899995],
              [-74.08633378799993, -50.98162200299993],
              [-74.08682206899994, -50.97389088299991],
              [-74.08116614499994, -50.96624114399992],
              [-74.07144120999993, -50.96054452899995],
              [-74.07144120999993, -50.95370859199994],
              [-74.0891820949999, -50.95712655999995],
              [-74.10216223899994, -50.96453215899993],
              [-74.18399003799993, -51.03394947699991],
              [-74.19664466099994, -51.03769296699994],
              [-74.23224850199995, -51.03557708099993],
              [-74.23936926999994, -51.02792734199994],
              [-74.23884029899995, -50.98967864399992],
              [-74.24217688699991, -50.97421640399995],
              [-74.22451738199993, -50.96575286299992],
              [-74.22520911399994, -50.95582447699991],
              [-74.23790442599994, -50.94646575299993],
              [-74.25641842399995, -50.939385674999926],
              [-74.23257402299993, -50.90748463299991],
              [-74.19554602799991, -50.885023695999905],
              [-74.15103105399993, -50.8728166649999],
              [-74.10496985599991, -50.87118905999995],
              [-73.99571692599994, -50.885430596999925],
              [-73.97524980399993, -50.89080169099992],
              [-73.95173092399995, -50.89316171699994],
              [-73.93297278599994, -50.88640715899993],
              [-73.92682857999995, -50.864353122999944],
              [-73.90221106699994, -50.873304945999905],
              [-73.87425696499992, -50.88909270599993],
              [-73.85545813699991, -50.90960051899992],
              [-73.85789954299992, -50.93320077899995],
              [-73.80333411399994, -50.96054452899995],
              [-73.80174719999991, -50.9470354149999],
              [-73.7903539699999, -50.93132903399993],
              [-73.78966223899994, -50.91952890399995],
              [-73.81696529899995, -50.878024997999944],
              [-73.85789954299992, -50.844414971999925],
              [-73.86375891799992, -50.842868747999944],
              [-73.87096106699994, -50.84335702899995],
              [-73.87706458199995, -50.84189218499995],
              [-73.87970943899995, -50.83416106599992],
              [-73.87751217399995, -50.828383070999905],
              [-73.87254798099991, -50.82561614399992],
              [-73.86758378799993, -50.82382577899995],
              [-73.86538652299993, -50.82048919099992],
              [-73.85460364499994, -50.79729583099993],
              [-73.82998613199993, -50.79705169099992],
              [-73.80337480399993, -50.808526299999926],
              [-73.77660071499992, -50.82586028399993],
              [-73.76162675699993, -50.830010674999926],
              [-73.74791419199994, -50.82935963299991],
              [-73.74185136599993, -50.82048919099992],
              [-73.74787350199995, -50.81267669099992],
              [-73.77782141799992, -50.80234140399995],
              [-73.78966223899994, -50.79656340899993],
              [-73.78331458199995, -50.78826262799993],
              [-73.77676347599993, -50.77418385199991],
              [-73.77183997299994, -50.758477471999925],
              [-73.76984615799995, -50.74504973799992],
              [-73.77245032499991, -50.72966887799993],
              [-73.7825414699999, -50.70037200299993],
              [-73.78282630099994, -50.68678150799991],
              [-73.77293860599991, -50.67066822699991],
              [-73.75544186099995, -50.66025155999995],
              [-73.73542232999995, -50.65439218499995],
              [-73.70010331899994, -50.650323174999926],
              [-73.66820227799991, -50.640557549999926],
              [-73.65314693899995, -50.63836028399993],
              [-73.63670813699991, -50.63990650799991],
              [-73.62002519399994, -50.644463799999926],
              [-73.60448157499991, -50.65097421699994],
              [-73.59166419199994, -50.658868096999925],
              [-73.56114661399994, -50.70061614399992],
              [-73.55321204299992, -50.70720794099992],
              [-73.53335527299993, -50.70647551899992],
              [-73.53010006399995, -50.703383070999905],
              [-73.53237870999993, -50.697198174999926],
              [-73.52961178299995, -50.68678150799991],
              [-73.51992753799993, -50.676853122999944],
              [-73.50865637899994, -50.67278411299992],
              [-73.47435462099992, -50.67245859199994],
              [-73.48713131399995, -50.660088799999926],
              [-73.50767981699994, -50.65748463299991],
              [-73.5305883449999, -50.65748463299991],
              [-73.5501195949999, -50.652601820999905],
              [-73.55703691299993, -50.63355885199991],
              [-73.55996660099993, -50.62835051899992],
              [-73.56773841099994, -50.62444426899992],
              [-73.57787024599992, -50.62363046699994],
              [-73.59821529899995, -50.62468840899993],
              [-73.63536536399994, -50.61842213299991],
              [-73.66869055899991, -50.602634372999944],
              [-73.72508704299992, -50.55950286299992],
              [-73.72801673099991, -50.54802825299993],
              [-73.72105872299994, -50.533135674999926],
              [-73.70933997299994, -50.52027760199991],
              [-73.69782467399995, -50.51482512799993],
              [-73.65933183499993, -50.51295338299991],
              [-73.64216061099995, -50.508884372999944],
              [-73.62515214799993, -50.50115325299993],
              [-73.60700436099995, -50.483493747999944],
              [-73.58202063699991, -50.43206145599993],
              [-73.56371008999992, -50.404961846999925],
              [-73.58755449099993, -50.403415622999944],
              [-73.60912024599992, -50.42424895599993],
              [-73.64631100199995, -50.47380950299993],
              [-73.65794837099992, -50.48202890399995],
              [-73.6699926419999, -50.48845794099992],
              [-73.68317623599995, -50.49277109199994],
              [-73.70954342399995, -50.49667734199994],
              [-73.72911536399994, -50.50644296699994],
              [-73.75938880099994, -50.51572030999995],
              [-73.76781165299991, -50.53329843499995],
              [-73.77599036399994, -50.57691822699991],
              [-73.78380286399994, -50.58733489399992],
              [-73.79283606699994, -50.59343840899993],
              [-73.80020097599993, -50.600681247999944],
              [-73.80333411399994, -50.61443450299993],
              [-73.80117753799993, -50.62664153399993],
              [-73.79796301999994, -50.63616301899992],
              [-73.79832923099991, -50.645196221999925],
              [-73.8255102199999, -50.6794572899999],
              [-73.82298743399991, -50.69841887799993],
              [-73.81346594999991, -50.71754322699991],
              [-73.81078040299991, -50.7419572899999],
              [-73.82262122299994, -50.75790780999995],
              [-73.84609941299993, -50.77581145599993],
              [-73.87092037699995, -50.78964609199994],
              [-73.88613847599993, -50.79314544099992],
              [-73.89801998599995, -50.79241301899992],
              [-73.90733801999994, -50.799899997999944],
              [-73.92064368399991, -50.817071221999925],
              [-73.93712317599994, -50.82708098799992],
              [-73.94701087099992, -50.82976653399993],
              [-73.98521887899994, -50.830010674999926],
              [-74.04271399599992, -50.8220354149999],
              [-74.0606176419999, -50.81365325299993],
              [-74.11266028599994, -50.778008721999925],
              [-74.12608801999994, -50.76246510199991],
              [-74.06826738199993, -50.7360979149999],
              [-74.05719967399995, -50.72771575299993],
              [-74.06017005099994, -50.712009372999944],
              [-74.07848059799994, -50.701104424999926],
              [-74.11864173099991, -50.68678150799991],
              [-74.11709550699993, -50.7009416649999],
              [-74.11563066299993, -50.706963799999926],
              [-74.11241614499994, -50.71404387799993],
              [-74.1341039699999, -50.73300546699994],
              [-74.14712480399993, -50.72869231599992],
              [-74.16706295499995, -50.68678150799991],
              [-74.18195553299995, -50.666680596999925],
              [-74.22069251199991, -50.626071872999944],
              [-74.23595130099994, -50.604180596999925],
              [-74.21959387899994, -50.5857072899999],
              [-74.20262610599991, -50.5720354149999],
              [-74.19871985599991, -50.55901458099993],
              [-74.22166907499991, -50.5427385399999],
              [-74.23542232999995, -50.53997161299992],
              [-74.24864661399994, -50.53964609199994],
              [-74.25865637899994, -50.53476327899995],
              [-74.26622473899994, -50.506117445999905],
              [-74.27505449099993, -50.49667734199994],
              [-74.29735266799992, -50.48064544099992],
              [-74.28066972599993, -50.47470468499995],
              [-74.22105872299994, -50.46379973799992],
              [-74.20799719999991, -50.46363697699991],
              [-74.20400956899994, -50.47771575299993],
              [-74.19432532499991, -50.49537525799991],
              [-74.18203691299993, -50.51262786299992],
              [-74.17048092399995, -50.52548593499995],
              [-74.16038977799991, -50.54070403399993],
              [-74.14134680899991, -50.57976653399993],
              [-74.12608801999994, -50.590508721999925],
              [-74.10789954299992, -50.587823174999926],
              [-74.11579342399995, -50.569431247999944],
              [-74.14590410099993, -50.53590260199991],
              [-74.1406957669999, -50.531182549999926],
              [-74.13125566299993, -50.51970794099992],
              [-74.12608801999994, -50.51482512799993],
              [-74.14842688699991, -50.50628020599993],
              [-74.15680904899995, -50.49358489399992],
              [-74.14981035099993, -50.483086846999925],
              [-74.12608801999994, -50.48064544099992],
              [-74.10765540299991, -50.48837655999995],
              [-74.07127844999991, -50.51620859199994],
              [-74.05345618399991, -50.52223072699991],
              [-73.93871008999992, -50.53948333099993],
              [-73.91763261599993, -50.545993747999944],
              [-73.89728756399995, -50.549086195999905],
              [-73.87970943899995, -50.5427385399999],
              [-73.90709387899994, -50.53004322699991],
              [-73.97508704299992, -50.5114885399999],
              [-74.00568600199995, -50.50855885199991],
              [-74.01650956899994, -50.50269947699991],
              [-74.02009029899995, -50.48919036299992],
              [-74.01805579299992, -50.47421640399995],
              [-74.01252193899995, -50.46363697699991],
              [-74.00918535099993, -50.455336195999905],
              [-74.01500403599994, -50.449151299999926],
              [-74.02464758999992, -50.44670989399992],
              [-74.03294837099992, -50.449883721999925],
              [-74.05719967399995, -50.467054945999905],
              [-74.07335364499994, -50.469414971999925],
              [-74.08165442599994, -50.46624114399992],
              [-74.09813391799992, -50.44654713299991],
              [-74.12132727799991, -50.432305596999925],
              [-74.12889563699991, -50.422946872999944],
              [-74.11554928299995, -50.418633721999925],
              [-74.10098222599993, -50.416680596999925],
              [-74.08665930899991, -50.410821221999925],
              [-74.07579505099994, -50.40129973799992],
              [-74.07144120999993, -50.38827890399995],
              [-74.06436113199993, -50.37981536299992],
              [-74.04796301999994, -50.37249114399992],
              [-74.01622473899994, -50.363946221999925],
              [-74.03335527299993, -50.36296965899993],
              [-74.06725012899994, -50.354587497999944],
              [-74.08385169199994, -50.3571916649999],
              [-74.08653723899994, -50.36207447699991],
              [-74.08926347599993, -50.37981536299992],
              [-74.09068762899994, -50.38445403399993],
              [-74.09723873599995, -50.38730234199994],
              [-74.11180579299992, -50.38982512799993],
              [-74.16551673099991, -50.40960051899992],
              [-74.18130449099993, -50.412367445999905],
              [-74.2122289699999, -50.40569426899992],
              [-74.22874915299991, -50.40545012799993],
              [-74.25255286399994, -50.440524997999944],
              [-74.28746497299994, -50.42652760199991],
              [-74.31786048099991, -50.39934661299992],
              [-74.32127844999991, -50.38445403399993],
              [-74.31456458199995, -50.377618096999925],
              [-74.28990637899994, -50.34042734199994],
              [-74.28258216099994, -50.33220794099992],
              [-74.26915442599994, -50.32561614399992],
              [-74.26292883999992, -50.317071221999925],
              [-74.27696692599994, -50.3025041649999],
              [-74.26984615799995, -50.28069426899992],
              [-74.28270423099991, -50.26490650799991],
              [-74.30109615799995, -50.25855885199991],
              [-74.31041419199994, -50.26531340899993],
              [-74.31480872299994, -50.28435637799993],
              [-74.33397376199991, -50.31178150799991],
              [-74.33836829299992, -50.326429945999905],
              [-74.35484778599994, -50.35955169099992],
              [-74.39378821499992, -50.365899346999925],
              [-74.43932044199994, -50.35711028399993],
              [-74.47549394399994, -50.34417083099993],
              [-74.47020423099991, -50.34099700299993],
              [-74.46007239499994, -50.33294036299992],
              [-74.4544164699999, -50.3298479149999],
              [-74.46788489499994, -50.32431405999995],
              [-74.4954320949999, -50.325290622999944],
              [-74.50963294199994, -50.32301197699991],
              [-74.51488196499992, -50.31878020599993],
              [-74.53636633999992, -50.29631926899992],
              [-74.52281653599994, -50.28240325299993],
              [-74.49303137899994, -50.2614885399999],
              [-74.4817602199999, -50.24863046699994],
              [-74.49689693899995, -50.24928150799991],
              [-74.5215551419999, -50.260837497999944],
              [-74.53636633999992, -50.2614885399999],
              [-74.54914303299995, -50.25448984199994],
              [-74.54381262899994, -50.244073174999926],
              [-74.53148352799991, -50.2321916649999],
              [-74.52330481699994, -50.220635674999926],
              [-74.54784094999991, -50.22535572699991],
              [-74.56981360599991, -50.23455169099992],
              [-74.59251868399991, -50.24032968499995],
              [-74.61888587099992, -50.23495859199994],
              [-74.61461341099994, -50.223728122999944],
              [-74.60838782499991, -50.2146135399999],
              [-74.60065670499995, -50.20720794099992],
              [-74.59162350199995, -50.20077890399995],
              [-74.59845943899995, -50.193291924999926],
              [-74.62385006399995, -50.20623137799993],
              [-74.65566972599993, -50.21445077899995],
              [-74.68301347599993, -50.20940520599993],
              [-74.6946508449999, -50.18303801899992],
              [-74.69131425699993, -50.16855234199994],
              [-74.68309485599991, -50.15976327899995],
              [-74.66047115799995, -50.145603122999944],
              [-74.64053300699993, -50.12468840899993],
              [-74.62828528599994, -50.11492278399993],
              [-74.61546790299991, -50.11077239399992],
              [-74.60118567599994, -50.10857512799993],
              [-74.57371985599991, -50.09929778399993],
              [-74.55748450399994, -50.09710051899992],
              [-74.53673255099994, -50.10116952899995],
              [-74.53189042899993, -50.11060963299991],
              [-74.53302975199995, -50.12200286299992],
              [-74.53014075399994, -50.13128020599993],
              [-74.51870683499993, -50.13437265399995],
              [-74.50438391799992, -50.131931247999944],
              [-74.49518795499995, -50.12468840899993],
              [-74.49913489499994, -50.11419036299992],
              [-74.50649980399993, -50.104180596999925],
              [-74.50792395699995, -50.09433359199994],
              [-74.5039770169999, -50.085056247999944],
              [-74.4954320949999, -50.07659270599993],
              [-74.47679602799991, -50.08554452899995],
              [-74.46182206899994, -50.09710051899992],
              [-74.46865800699993, -50.09710051899992],
              [-74.46031653599994, -50.09840260199991],
              [-74.34764563699991, -50.08611419099992],
              [-74.33576412699995, -50.090101820999905],
              [-74.33092200399994, -50.107354424999926],
              [-74.3255102199999, -50.11223723799992],
              [-74.29942786399994, -50.124932549999926],
              [-74.28990637899994, -50.13128020599993],
              [-74.31753495999993, -50.16139088299991],
              [-74.32469641799992, -50.17278411299992],
              [-74.31432044199994, -50.16855234199994],
              [-74.30223548099991, -50.16529713299991],
              [-74.28941809799994, -50.16415780999995],
              [-74.27696692599994, -50.16529713299991],
              [-74.27163652299993, -50.16806405999995],
              [-74.26817786399994, -50.175713799999926],
              [-74.26260331899994, -50.179620049999926],
              [-74.24217688699991, -50.18645598799992],
              [-74.22496497299994, -50.1970354149999],
              [-74.20913652299993, -50.2107072899999],
              [-74.20295162699995, -50.22771575299993],
              [-74.2149145169999, -50.24863046699994],
              [-74.19440670499995, -50.259698174999926],
              [-74.17735755099994, -50.25318775799991],
              [-74.14590410099993, -50.22747161299992],
              [-74.12144934799994, -50.22307708099993],
              [-74.09642493399991, -50.22779713299991],
              [-73.95856686099995, -50.287774346999925],
              [-73.90599524599992, -50.29810963299991],
              [-73.85789954299992, -50.28948333099993],
              [-73.87677975199995, -50.274509372999944],
              [-73.97524980399993, -50.25481536299992],
              [-73.99913489499994, -50.24179452899995],
              [-74.02131100199995, -50.22478606599992],
              [-74.02550208199995, -50.21233489399992],
              [-73.99571692599994, -50.21379973799992],
              [-74.00609290299991, -50.20191822699991],
              [-74.02448482999995, -50.20086028399993],
              [-74.06432044199994, -50.206963799999926],
              [-74.07066809799994, -50.2048479149999],
              [-74.08226477799991, -50.19589609199994],
              [-74.09068762899994, -50.193291924999926],
              [-74.09886633999992, -50.19410572699991],
              [-74.11375891799992, -50.19939544099992],
              [-74.15908769399994, -50.20232512799993],
              [-74.17471269399994, -50.19850025799991],
              [-74.19371497299994, -50.18645598799992],
              [-74.20457923099991, -50.17620208099993],
              [-74.20889238199993, -50.16757577899995],
              [-74.2149145169999, -50.13876718499995],
              [-74.22191321499992, -50.123711846999925],
              [-74.23884029899995, -50.09775155999995],
              [-74.24217688699991, -50.080010674999926],
              [-74.25072180899991, -50.08098723799992],
              [-74.28970292899993, -50.06560637799993],
              [-74.30044511599993, -50.059258721999925],
              [-74.34666907499991, -50.01523202899995],
              [-74.36485755099994, -49.99032968499995],
              [-74.35879472599993, -49.97356536299992],
              [-74.36485755099994, -49.951104424999926],
              [-74.34943600199995, -49.9353166649999],
              [-74.32843990799995, -49.9275041649999],
              [-74.31786048099991, -49.92929452899995],
              [-74.31265214799993, -49.94963958099993],
              [-74.29971269399994, -49.94866301899992],
              [-74.28294837099992, -49.93873463299991],
              [-74.26634680899991, -49.93254973799992],
              [-74.22813880099994, -49.940524997999944],
              [-74.19810950399994, -49.96021900799991],
              [-74.14964758999992, -50.01140715899993],
              [-74.13947506399995, -50.015883070999905],
              [-74.13023841099994, -50.01181405999995],
              [-74.12132727799991, -50.00505950299993],
              [-74.11241614499994, -50.00156015399995],
              [-74.10374915299991, -50.00286223799992],
              [-74.07770748599995, -50.01523202899995],
              [-74.07310950399994, -50.019463799999926],
              [-74.06297766799992, -50.03167083099993],
              [-74.05719967399995, -50.03573984199994],
              [-74.04893958199995, -50.037041924999926],
              [-73.95417232999995, -50.026055596999925],
              [-73.93431555899991, -50.02890390399995],
              [-73.91954505099994, -50.04070403399993],
              [-73.90367591099994, -50.069431247999944],
              [-73.88589433499993, -50.07659270599993],
              [-73.88532467399995, -50.05608489399992],
              [-73.88902747299994, -50.03557708099993],
              [-73.89793860599991, -50.01848723799992],
              [-73.91319739499994, -50.007745049999926],
              [-73.94591223899994, -50.01767343499995],
              [-73.9837133449999, -50.010837497999944],
              [-74.00767981699994, -49.99138762799993],
              [-73.99913489499994, -49.96331145599993],
              [-73.96019446499992, -49.93059661299992],
              [-73.95103919199994, -49.92587655999995],
              [-73.91380774599992, -49.926039320999905],
              [-73.89598548099991, -49.92424895599993],
              [-73.87970943899995, -49.919040622999944],
              [-73.90416419199994, -49.91570403399993],
              [-73.91014563699991, -49.90162525799991],
              [-73.90636145699995, -49.85686614399992],
              [-73.91982988199993, -49.86736419099992],
              [-73.93492591099994, -49.894789320999905],
              [-73.9473363919999, -49.905368747999944],
              [-73.95702063699991, -49.90634530999995],
              [-73.98070227799991, -49.903008721999925],
              [-73.9895727199999, -49.905368747999944],
              [-73.99111894399994, -49.910821221999925],
              [-73.99388587099992, -49.93238697699991],
              [-73.99571692599994, -49.939385674999926],
              [-74.01471920499995, -49.95956796699994],
              [-74.03595943899995, -49.964776299999926],
              [-74.08726966099994, -49.95989348799992],
              [-74.11046301999994, -49.95468515399995],
              [-74.12336178299995, -49.94182708099993],
              [-74.1328832669999, -49.92595794099992],
              [-74.14590410099993, -49.91155364399992],
              [-74.18854732999995, -49.89812590899993],
              [-74.28892981699994, -49.89348723799992],
              [-74.32469641799992, -49.87118905999995],
              [-74.34227454299992, -49.830010674999926],
              [-74.34886633999992, -49.805759372999944],
              [-74.34825598899994, -49.792087497999944],
              [-74.33576412699995, -49.787041924999926],
              [-74.32209225199995, -49.789320570999905],
              [-74.30874589799993, -49.79371510199991],
              [-74.29735266799992, -49.79550546699994],
              [-74.28579667899993, -49.791680596999925],
              [-74.27985592399995, -49.78630950299993],
              [-74.27578691299993, -49.780368747999944],
              [-74.27009029899995, -49.77499765399995],
              [-74.24722245999993, -49.76336028399993],
              [-74.22280839799993, -49.754571221999925],
              [-74.19713294199994, -49.74895598799992],
              [-74.09316972599993, -49.74822356599992],
              [-74.07144120999993, -49.74146900799991],
              [-74.07603919199994, -49.73512135199991],
              [-74.07530676999994, -49.72820403399993],
              [-74.07070878799993, -49.72087981599992],
              [-74.06403561099995, -49.713555596999925],
              [-74.09886633999992, -49.71257903399993],
              [-74.16698157499991, -49.71884530999995],
              [-74.20164954299992, -49.728448174999926],
              [-74.24893144399994, -49.72771575299993],
              [-74.27892005099994, -49.740899346999925],
              [-74.28990637899994, -49.74146900799991],
              [-74.31627356699994, -49.71949635199991],
              [-74.32677161399994, -49.67717864399992],
              [-74.32225501199991, -49.63250090899993],
              [-74.30357825399994, -49.60369231599992],
              [-74.26231848899994, -49.58709075299993],
              [-74.25951087099992, -49.5837541649999],
              [-74.25377356699994, -49.58049895599993],
              [-74.24494381399995, -49.573337497999944],
              [-74.23387610599991, -49.56601327899995],
              [-74.22166907499991, -49.56267669099992],
              [-74.16954505099994, -49.55999114399992],
              [-74.14696204299992, -49.55584075299993],
              [-74.10374915299991, -49.541273695999905],
              [-74.07852128799993, -49.5368791649999],
              [-74.05382239499994, -49.539320570999905],
              [-74.03294837099992, -49.55242278399993],
              [-74.02855383999992, -49.569024346999925],
              [-74.03307044199994, -49.588148695999905],
              [-74.03514563699991, -49.605726820999905],
              [-74.02301998599995, -49.617852471999925],
              [-74.00690670499995, -49.57105885199991],
              [-73.99913489499994, -49.559258721999925],
              [-73.98350989499994, -49.55291106599992],
              [-73.96182206899994, -49.55348072699991],
              [-73.9407445949999, -49.559665622999944],
              [-73.92682857999995, -49.56951262799993],
              [-73.93390865799995, -49.582696221999925],
              [-73.92821204299992, -49.59140390399995],
              [-73.91836503799993, -49.600274346999925],
              [-73.91319739499994, -49.61419036299992],
              [-73.91177324099993, -49.62786223799992],
              [-73.90782630099994, -49.63982512799993],
              [-73.90135657499991, -49.64999765399995],
              [-73.89268958199995, -49.65829843499995],
              [-73.80882727799991, -49.68840911299992],
              [-73.79649817599994, -49.7028947899999],
              [-73.75552324099993, -49.72771575299993],
              [-73.74596106699994, -49.73674895599993],
              [-73.7395727199999, -49.74504973799992],
              [-73.73607337099992, -49.75546640399995],
              [-73.73501542899993, -49.77117278399993],
              [-73.7278539699999, -49.78167083099993],
              [-73.71198482999995, -49.765557549999926],
              [-73.69579016799992, -49.73967864399992],
              [-73.68785559799994, -49.72031015399995],
              [-73.71255449099993, -49.71607838299991],
              [-73.72435462099992, -49.71257903399993],
              [-73.73501542899993, -49.70671965899993],
              [-73.74038652299993, -49.7009416649999],
              [-73.74632727799991, -49.689385674999926],
              [-73.75182044199994, -49.68279387799993],
              [-73.77269446499992, -49.66855234199994],
              [-73.79063880099994, -49.664727471999925],
              [-73.8106176419999, -49.663995049999926],
              [-73.83739173099991, -49.65829843499995],
              [-73.85252844999991, -49.65325286299992],
              [-73.85496985599991, -49.65081145599993],
              [-73.85366777299993, -49.64544036299992],
              [-73.86424719999991, -49.61646900799991],
              [-73.86896725199995, -49.60816822699991],
              [-73.87588456899994, -49.60051848799992],
              [-73.87877356699994, -49.588148695999905],
              [-73.87633216099994, -49.54436614399992],
              [-73.87970943899995, -49.52849700299993],
              [-73.91527258999992, -49.51051197699991],
              [-74.07770748599995, -49.50115325299993],
              [-74.09097245999993, -49.497165622999944],
              [-74.10216223899994, -49.49187590899993],
              [-74.10968990799995, -49.48357512799993],
              [-74.11241614499994, -49.47014739399992],
              [-74.10753333199995, -49.448337497999944],
              [-74.10777747299994, -49.43718840899993],
              [-74.11554928299995, -49.432305596999925],
              [-74.12352454299992, -49.42262135199991],
              [-74.11961829299992, -49.40081145599993],
              [-74.09068762899994, -49.32236093499995],
              [-74.08576412699995, -49.29941171699994],
              [-74.08385169199994, -49.27809010199991],
              [-74.07445227799991, -49.261651299999926],
              [-74.05239824099993, -49.25855885199991],
              [-74.02745520699995, -49.26458098799992],
              [-74.00877844999991, -49.27467213299991],
              [-73.99266516799992, -49.294040622999944],
              [-73.97972571499992, -49.31406015399995],
              [-73.96353105399993, -49.32976653399993],
              [-73.92735755099994, -49.33798593499995],
              [-73.90925045499995, -49.34685637799993],
              [-73.89952551999994, -49.34978606599992],
              [-73.84487870999993, -49.34978606599992],
              [-73.84487870999993, -49.3435197899999],
              [-73.92454993399991, -49.32122161299992],
              [-73.9473363919999, -49.30877044099992],
              [-73.98509680899991, -49.273370049999926],
              [-74.00243079299992, -49.24920012799993],
              [-74.00877844999991, -49.22625090899993],
              [-74.00462805899991, -49.21526458099993],
              [-73.98204505099994, -49.186618747999944],
              [-73.97793535099993, -49.17115650799991],
              [-73.97972571499992, -49.16423919099992],
              [-73.98460852799991, -49.15960051899992],
              [-73.9895727199999, -49.15178801899992],
              [-73.99762936099995, -49.124932549999926],
              [-74.00255286399994, -49.1169572899999],
              [-74.01097571499992, -49.107354424999926],
              [-74.04352779899995, -49.08294036299992],
              [-73.97760982999995, -49.037367445999905],
              [-73.94225012899994, -49.02353280999995],
              [-73.89952551999994, -49.02825286299992],
              [-73.87169348899994, -49.04827239399992],
              [-73.85472571499992, -49.05706145599993],
              [-73.83739173099991, -49.05624765399995],
              [-73.82184811099995, -49.04225025799991],
              [-73.83287512899994, -49.03215911299992],
              [-73.86876380099994, -49.01799895599993],
              [-73.88923092399995, -49.00741952899995],
              [-73.91274980399993, -49.00725676899992],
              [-74.0305883449999, -49.02288176899992],
              [-74.04662024599992, -49.01799895599993],
              [-74.05748450399994, -49.01246510199991],
              [-74.06265214799993, -49.02076588299991],
              [-74.06411699099993, -49.033868096999925],
              [-74.06403561099995, -49.04192473799992],
              [-74.06004798099991, -49.05120208099993],
              [-74.04649817599994, -49.06959400799991],
              [-74.04352779899995, -49.07976653399993],
              [-74.04771887899994, -49.10003020599993],
              [-74.05394446499992, -49.11663176899992],
              [-74.05308997299994, -49.131117445999905],
              [-74.03604081899994, -49.14495208099993],
              [-74.07876542899993, -49.19866301899992],
              [-74.10643469999991, -49.22128671699994],
              [-74.1328832669999, -49.22625090899993],
              [-74.14150956899994, -49.22079843499995],
              [-74.15729732999995, -49.20403411299992],
              [-74.16706295499995, -49.19963958099993],
              [-74.17662512899994, -49.199883721999925],
              [-74.18667558499993, -49.20273202899995],
              [-74.19286048099991, -49.20818450299993],
              [-74.19066321499992, -49.21640390399995],
              [-74.18268795499995, -49.22161223799992],
              [-74.16344153599994, -49.23007577899995],
              [-74.15965735599991, -49.23691171699994],
              [-74.15811113199993, -49.244398695999905],
              [-74.15013587099992, -49.26116301899992],
              [-74.14590410099993, -49.267836195999905],
              [-74.15196692599994, -49.276462497999944],
              [-74.15396074099993, -49.285088799999926],
              [-74.15196692599994, -49.29371510199991],
              [-74.14590410099993, -49.30201588299991],
              [-74.15245520699995, -49.31365325299993],
              [-74.15672766799992, -49.32586028399993],
              [-74.15892493399991, -49.33879973799992],
              [-74.15965735599991, -49.35320403399993],
              [-74.16295325399994, -49.36728280999995],
              [-74.17796790299991, -49.38632577899995],
              [-74.18130449099993, -49.39470794099992],
              [-74.19473222599993, -49.46998463299991],
              [-74.18748938699991, -49.48756275799991],
              [-74.2149145169999, -49.52312590899993],
              [-74.24111894399994, -49.52792734199994],
              [-74.27049719999991, -49.50994231599992],
              [-74.30699622299994, -49.47698333099993],
              [-74.31859290299991, -49.46298593499995],
              [-74.32725989499994, -49.44817473799992],
              [-74.33714758999992, -49.43499114399992],
              [-74.35195878799993, -49.42546965899993],
              [-74.38023841099994, -49.41887786299992],
              [-74.39488684799994, -49.413181247999944],
              [-74.41030839799993, -49.40129973799992],
              [-74.42275956899994, -49.384698174999926],
              [-74.42414303299995, -49.37118905999995],
              [-74.41685950399994, -49.35906340899993],
              [-74.40347245999993, -49.346774997999944],
              [-74.39468339799993, -49.33318450299993],
              [-74.39354407499991, -49.317478122999944],
              [-74.41270911399994, -49.21884530999995],
              [-74.40404212099992, -49.19353606599992],
              [-74.37189693899995, -49.186618747999944],
              [-74.40127519399994, -49.15764739399992],
              [-74.41087805899991, -49.140557549999926],
              [-74.41344153599994, -49.1169572899999],
              [-74.41087805899991, -49.10564544099992],
              [-74.40176347599993, -49.08863697699991],
              [-74.39976966099994, -49.07976653399993],
              [-74.40550696499992, -49.06780364399992],
              [-74.41836503799993, -49.07040780999995],
              [-74.43224036399994, -49.080336195999905],
              [-74.44078528599994, -49.09042734199994],
              [-74.45396887899994, -49.08017343499995],
              [-74.46263587099992, -49.066338799999926],
              [-74.46727454299992, -49.049899997999944],
              [-74.46865800699993, -49.03167083099993],
              [-74.46133378799993, -49.01970794099992],
              [-74.44448808499993, -49.01230234199994],
              [-74.42601477799991, -49.006931247999944],
              [-74.41344153599994, -49.00090911299992],
              [-74.40314693899995, -48.98723723799992],
              [-74.40054277299993, -48.97478606599992],
              [-74.40526282499991, -48.96233489399992],
              [-74.41685950399994, -48.94939544099992],
              [-74.42247473899994, -48.93499114399992],
              [-74.4063207669999, -48.928806247999944],
              [-74.38263912699995, -48.92864348799992],
              [-74.36563066299993, -48.93206145599993],
              [-74.38052324099993, -48.92107512799993],
              [-74.41226152299993, -48.91253020599993],
              [-74.42711341099994, -48.90471770599993],
              [-74.43464107999995, -48.89568450299993],
              [-74.43895423099991, -48.88404713299991],
              [-74.43565833199995, -48.87420012799993],
              [-74.42027747299994, -48.87070077899995],
              [-74.42027747299994, -48.863213799999926],
              [-74.44595292899993, -48.851495049999926],
              [-74.45348059799994, -48.83098723799992],
              [-74.44790605399993, -48.80779387799993],
              [-74.43455969999991, -48.78801848799992],
              [-74.39976966099994, -48.760837497999944],
              [-74.39281165299991, -48.74895598799992],
              [-74.38833574099993, -48.73788827899995],
              [-74.38263912699995, -48.727634372999944],
              [-74.37189693899995, -48.71917083099993],
              [-74.34105383999992, -48.75237395599993],
              [-74.33482825399994, -48.75505950299993],
              [-74.33641516799992, -48.751071872999944],
              [-74.33836829299992, -48.74032968499995],
              [-74.30687415299991, -48.749932549999926],
              [-74.27236894399994, -48.74138762799993],
              [-74.23643958199995, -48.72698333099993],
              [-74.20055091099994, -48.71917083099993],
              [-74.11864173099991, -48.72665780999995],
              [-74.10472571499992, -48.73202890399995],
              [-74.09097245999993, -48.73919036299992],
              [-74.07575436099995, -48.74358489399992],
              [-74.06672115799995, -48.7419572899999],
              [-74.05719967399995, -48.74032968499995],
              [-74.05719967399995, -48.73284270599993],
              [-74.08922278599994, -48.71721770599993],
              [-74.12816321499992, -48.70720794099992],
              [-74.16934160099993, -48.70330169099992],
              [-74.20799719999991, -48.706149997999944],
              [-74.2727758449999, -48.72503020599993],
              [-74.30622311099995, -48.72771575299993],
              [-74.33092200399994, -48.71298593499995],
              [-74.32237708199995, -48.70403411299992],
              [-74.31281490799995, -48.697523695999905],
              [-74.30211341099994, -48.69353606599992],
              [-74.28990637899994, -48.692478122999944],
              [-74.29796301999994, -48.68287525799991],
              [-74.30711829299992, -48.67913176899992],
              [-74.31468665299991, -48.67506275799991],
              [-74.31786048099991, -48.66448333099993],
              [-74.32892818899995, -48.677992445999905],
              [-74.34715735599991, -48.68474700299993],
              [-74.36432857999995, -48.682305596999925],
              [-74.37189693899995, -48.66806405999995],
              [-74.37026933499993, -48.63909270599993],
              [-74.37189693899995, -48.63103606599992],
              [-74.37905839799993, -48.62460702899995],
              [-74.38829505099994, -48.623304945999905],
              [-74.39622962099992, -48.62078215899993],
              [-74.39976966099994, -48.61052825299993],
              [-74.39216061099995, -48.59905364399992],
              [-74.32799231699994, -48.54900481599992],
              [-74.30874589799993, -48.54143645599993],
              [-74.28807532499991, -48.53655364399992],
              [-74.27009029899995, -48.53484465899993],
              [-74.2832738919999, -48.52353280999995],
              [-74.27037512899994, -48.51091887799993],
              [-74.23224850199995, -48.490166924999926],
              [-74.22545325399994, -48.48495859199994],
              [-74.21593176999994, -48.479587497999944],
              [-74.20567786399994, -48.47519296699994],
              [-74.19713294199994, -48.473321221999925],
              [-74.18663489499994, -48.47665780999995],
              [-74.16576087099992, -48.49065520599993],
              [-74.13687089799993, -48.50017669099992],
              [-74.08385169199994, -48.541680596999925],
              [-74.0528051419999, -48.549899997999944],
              [-74.04352779899995, -48.555352471999925],
              [-74.03701738199993, -48.56340911299992],
              [-74.02708899599992, -48.58367278399993],
              [-74.02301998599995, -48.58945077899995],
              [-73.9934789699999, -48.59726327899995],
              [-73.97541256399995, -48.58407968499995],
              [-73.97183183499993, -48.56503671699994],
              [-73.98574785099993, -48.555352471999925],
              [-74.00987708199995, -48.549086195999905],
              [-74.02061926999994, -48.53362395599993],
              [-74.02330481699994, -48.51246510199991],
              [-74.02301998599995, -48.490166924999926],
              [-74.02855383999992, -48.44801197699991],
              [-74.01984615799995, -48.43840911299992],
              [-73.91641191299993, -48.41887786299992],
              [-73.89268958199995, -48.41130950299993],
              [-73.89956620999993, -48.40195077899995],
              [-73.90367591099994, -48.39959075299993],
              [-73.91319739499994, -48.39763762799993],
              [-73.93529212099992, -48.39568450299993],
              [-73.99551347599993, -48.41415780999995],
              [-74.02989661399994, -48.41130950299993],
              [-74.03677324099993, -48.407321872999944],
              [-74.04991614499994, -48.39495208099993],
              [-74.05719967399995, -48.39080169099992],
              [-74.06529700399994, -48.389743747999944],
              [-74.08242753799993, -48.39120859199994],
              [-74.09068762899994, -48.39080169099992],
              [-74.10928300699993, -48.38567473799992],
              [-74.12022864499994, -48.37908294099992],
              [-74.13906816299993, -48.36345794099992],
              [-74.15493730399993, -48.35784270599993],
              [-74.22728430899991, -48.35393645599993],
              [-74.23790442599994, -48.35076262799993],
              [-74.23696855399993, -48.34531015399995],
              [-74.22166907499991, -48.33562590899993],
              [-74.20555579299992, -48.33066171699994],
              [-74.15339107999995, -48.32935963299991],
              [-74.10334225199995, -48.31731536299992],
              [-74.08385169199994, -48.31568775799991],
              [-74.10716712099992, -48.30608489399992],
              [-74.13560950399994, -48.303399346999925],
              [-74.18748938699991, -48.308851820999905],
              [-74.21104895699995, -48.31519947699991],
              [-74.26158606699994, -48.33513762799993],
              [-74.27009029899995, -48.33562590899993],
              [-74.2786352199999, -48.326836846999925],
              [-74.27481035099993, -48.31796640399995],
              [-74.26675370999993, -48.30917734199994],
              [-74.26260331899994, -48.301446221999925],
              [-74.26423092399995, -48.289320570999905],
              [-74.26716061099995, -48.28134530999995],
              [-74.27696692599994, -48.26726653399993],
              [-74.29088294199994, -48.25554778399993],
              [-74.3079320949999, -48.244398695999905],
              [-74.31969153599994, -48.23105234199994],
              [-74.31786048099991, -48.21209075299993],
              [-74.39826412699995, -48.19931405999995],
              [-74.44249426999994, -48.18238697699991],
              [-74.46182206899994, -48.15439218499995],
              [-74.46963456899994, -48.14706796699994],
              [-74.50177975199995, -48.10564544099992],
              [-74.50625566299993, -48.095961195999905],
              [-74.51207434799994, -48.08993905999995],
              [-74.49889075399994, -48.076429945999905],
              [-74.46865800699993, -48.055759372999944],
              [-74.46865800699993, -48.04810963299991],
              [-74.47329667899993, -48.04070403399993],
              [-74.4727270169999, -48.03671640399995],
              [-74.46865800699993, -48.02776458099993],
              [-74.49461829299992, -48.033868096999925],
              [-74.54112708199995, -48.064385674999926],
              [-74.56427975199995, -48.07545338299991],
              [-74.58803602899991, -48.079985148999924],
              [-74.60814797099994, -48.07520362999992],
              [-74.62682328499994, -48.058903881999925],
              [-74.63257070399993, -48.03492355199995],
              [-74.62970345499991, -48.02149330799995],
              [-74.62540932399992, -48.004227071999935],
              [-74.6039070249999, -47.996548599999926],
              [-74.5950414699999, -47.99358489399992],
              [-74.57274329299992, -47.98772551899992],
              [-74.53746497299994, -47.96306731599992],
              [-74.51707923099991, -47.95940520599993],
              [-74.5051977199999, -47.963555596999925],
              [-74.48399817599994, -47.97714609199994],
              [-74.47207597599993, -47.97991301899992],
              [-74.42739824099993, -47.97991301899992],
              [-74.41539466099994, -47.98365650799991],
              [-74.38556881399995, -48.00790780999995],
              [-74.37584387899994, -48.01132577899995],
              [-74.35391191299993, -48.016289971999925],
              [-74.34455318899995, -48.02092864399992],
              [-74.33438066299993, -48.03215911299992],
              [-74.30870520699995, -48.07170989399992],
              [-74.30357825399994, -48.0857072899999],
              [-74.29674231699994, -48.1286760399999],
              [-74.28376217399995, -48.17107512799993],
              [-74.27647864499994, -48.18450286299992],
              [-74.27236894399994, -48.188164971999925],
              [-74.25267493399991, -48.1853166649999],
              [-74.24583899599992, -48.18824635199991],
              [-74.24054928299995, -48.195245049999926],
              [-74.23713131399995, -48.203057549999926],
              [-74.23595130099994, -48.208916924999926],
              [-74.22691809799994, -48.22869231599992],
              [-74.20563717399995, -48.23105234199994],
              [-74.18032792899993, -48.222914320999905],
              [-74.17198645699995, -48.21860116999994],
              [-74.18504798099991, -48.21892669099992],
              [-74.19603430899991, -48.21347421699994],
              [-74.20055091099994, -48.20240650799991],
              [-74.20091712099992, -48.19296640399995],
              [-74.20303300699993, -48.19109465899993],
              [-74.2083227199999, -48.189711195999905],
              [-74.21825110599991, -48.18173593499995],
              [-74.2324926419999, -48.16464609199994],
              [-74.23460852799991, -48.15911223799992],
              [-74.23595130099994, -48.15113697699991],
              [-74.23387610599991, -48.146416924999926],
              [-74.22256425699993, -48.142836195999905],
              [-74.22166907499991, -48.13689544099992],
              [-74.2259008449999, -48.13160572699991],
              [-74.23200436099995, -48.13095468499995],
              [-74.23802649599992, -48.131524346999925],
              [-74.24217688699991, -48.13014088299991],
              [-74.2512914699999, -48.11956145599993],
              [-74.25763912699995, -48.113946221999925],
              [-74.26138261599993, -48.10702890399995],
              [-74.26260331899994, -48.092868747999944],
              [-74.28209387899994, -48.06731536299992],
              [-74.28685462099992, -48.062432549999926],
              [-74.29767818899995, -48.0544572899999],
              [-74.31407630099994, -48.03590260199991],
              [-74.32787024599992, -48.01523202899995],
              [-74.33092200399994, -48.00042083099993],
              [-74.30996660099993, -47.99041106599992],
              [-74.24535071499992, -47.99968840899993],
              [-74.22508704299992, -47.99700286299992],
              [-74.20417232999995, -47.98992278399993],
              [-74.0606176419999, -48.00042083099993],
              [-74.04954993399991, -48.005791924999926],
              [-74.04149329299992, -48.029229424999926],
              [-74.03294837099992, -48.03443775799991],
              [-74.02375240799995, -48.03264739399992],
              [-74.02033443899995, -48.0290666649999],
              [-74.01561438699991, -48.026462497999944],
              [-74.00255286399994, -48.02776458099993],
              [-73.99250240799995, -48.03215911299992],
              [-73.97297115799995, -48.04534270599993],
              [-73.96157792899993, -48.04810963299991],
              [-73.91698157499991, -48.02947356599992],
              [-73.89110266799992, -48.02223072699991],
              [-73.87970943899995, -48.031182549999926],
              [-73.87645423099991, -48.0388322899999],
              [-73.86925208199995, -48.040948174999926],
              [-73.86172441299993, -48.040948174999926],
              [-73.85789954299992, -48.04192473799992],
              [-73.85773678299995, -48.048760674999926],
              [-73.86025956899994, -48.053806247999944],
              [-73.86351477799991, -48.05779387799993],
              [-73.86538652299993, -48.062432549999926],
              [-73.86969967399995, -48.06910572699991],
              [-73.87755286399994, -48.07740650799991],
              [-73.8828832669999, -48.086602471999925],
              [-73.87970943899995, -48.095961195999905],
              [-73.86685136599993, -48.09238046699994],
              [-73.82164466099994, -48.056898695999905],
              [-73.79027258999992, -48.04436614399992],
              [-73.7805883449999, -48.029229424999926],
              [-73.76984615799995, -48.02776458099993],
              [-73.76211503799993, -48.03248463299991],
              [-73.75890051999994, -48.041273695999905],
              [-73.75914466099994, -48.05201588299991],
              [-73.76231848899994, -48.062432549999926],
              [-73.79238847599993, -48.09075286299992],
              [-73.80418860599991, -48.108086846999925],
              [-73.79308020699995, -48.115899346999925],
              [-73.78502356699994, -48.11060963299991],
              [-73.76207434799994, -48.08749765399995],
              [-73.7481176419999, -48.08171965899993],
              [-73.73839270699995, -48.08440520599993],
              [-73.70152747299994, -48.10279713299991],
              [-73.67690995999993, -48.10800546699994],
              [-73.6497289699999, -48.109633070999905],
              [-73.63621985599991, -48.11288827899995],
              [-73.61188717399995, -48.126885674999926],
              [-73.60130774599992, -48.13014088299991],
              [-73.59170488199993, -48.14072030999995],
              [-73.59137936099995, -48.16464609199994],
              [-73.59683183499993, -48.19019947699991],
              [-73.60472571499992, -48.20582447699991],
              [-73.58755449099993, -48.21209075299993],
              [-73.57738196499992, -48.22112395599993],
              [-73.55626380099994, -48.24684010199991],
              [-73.54743404899995, -48.23406340899993],
              [-73.52961178299995, -48.1989885399999],
              [-73.51650956899994, -48.18572356599992],
              [-73.50234941299993, -48.17717864399992],
              [-73.4863988919999, -48.172539971999925],
              [-73.46751868399991, -48.17107512799993],
              [-73.43358313699991, -48.17669036299992],
              [-73.35142981699994, -48.21949635199991],
              [-73.35252844999991, -48.20476653399993],
              [-73.34919186099995, -48.19150155999995],
              [-73.34089107999995, -48.18173593499995],
              [-73.31582597599993, -48.173760674999926],
              [-73.29336503799993, -48.15545012799993],
              [-73.28624426999994, -48.15113697699991],
              [-73.2766820949999, -48.13836028399993],
              [-73.27623450399994, -48.10947030999995],
              [-73.28180904899995, -48.07927825299993],
              [-73.29002844999991, -48.062432549999926],
              [-73.29116777299993, -48.07244231599992],
              [-73.29002844999991, -48.11272551899992],
              [-73.29458574099993, -48.12704843499995],
              [-73.30565344999991, -48.1345354149999],
              [-73.33096269399994, -48.14373137799993],
              [-73.35065670499995, -48.154554945999905],
              [-73.37482662699995, -48.16253020599993],
              [-73.40029863199993, -48.162041924999926],
              [-73.43545488199993, -48.13990650799991],
              [-73.48180091099994, -48.123304945999905],
              [-73.50645911399994, -48.094821872999944],
              [-73.51219641799992, -48.089776299999926],
              [-73.53091386599993, -48.08367278399993],
              [-73.59166419199994, -48.04192473799992],
              [-73.58063717399995, -48.02288176899992],
              [-73.58096269399994, -48.01287200299993],
              [-73.59170488199993, -48.00701262799993],
              [-73.62718665299991, -47.99342213299991],
              [-73.64220130099994, -47.98357512799993],
              [-73.64720618399991, -47.973728122999944],
              [-73.63263912699995, -47.96624114399992],
              [-73.63263912699995, -47.95940520599993],
              [-73.6458227199999, -47.951104424999926],
              [-73.65526282499991, -47.932305596999925],
              [-73.65855872299994, -47.91179778399993],
              [-73.65314693899995, -47.89804452899995],
              [-73.64268958199995, -47.89657968499995],
              [-73.5821020169999, -47.90764739399992],
              [-73.57559160099993, -47.90984465899993],
              [-73.55772864499994, -47.93368905999995],
              [-73.54759680899991, -47.9528947899999],
              [-73.54015051999994, -47.962823174999926],
              [-73.53258216099994, -47.96754322699991],
              [-73.50706946499992, -47.97795989399992],
              [-73.49852454299992, -47.97991301899992],
              [-73.42609615799995, -47.98837655999995],
              [-73.34483801999994, -47.97893645599993],
              [-73.31460527299993, -47.98007577899995],
              [-73.27318274599992, -48.00115325299993],
              [-73.24596106699994, -48.00725676899992],
              [-73.2278539699999, -48.00408294099992],
              [-73.23534094999991, -47.98674895599993],
              [-73.25731360599991, -47.976495049999926],
              [-73.31354732999995, -47.97193775799991],
              [-73.35558020699995, -47.95566171699994],
              [-73.44082597599993, -47.96624114399992],
              [-73.46833248599995, -47.965915622999944],
              [-73.48131262899994, -47.96306731599992],
              [-73.52619381399995, -47.93206145599993],
              [-73.52599036399994, -47.928399346999925],
              [-73.51260331899994, -47.9079729149999],
              [-73.5091039699999, -47.89804452899995],
              [-73.51109778599994, -47.88640715899993],
              [-73.51683508999992, -47.87851327899995],
              [-73.52574622299994, -47.87346770599993],
              [-73.53701738199993, -47.87004973799992],
              [-73.54092363199993, -47.88420989399992],
              [-73.54979407499991, -47.89023202899995],
              [-73.56151282499991, -47.888604424999926],
              [-73.5742895169999, -47.88030364399992],
              [-73.58360755099994, -47.876071872999944],
              [-73.61217200399994, -47.86777109199994],
              [-73.61900794199994, -47.86386484199994],
              [-73.61302649599992, -47.84840260199991],
              [-73.59292558499993, -47.83098723799992],
              [-73.56867428299995, -47.81609465899993],
              [-73.5501195949999, -47.80803801899992],
              [-73.57823645699995, -47.79973723799992],
              [-73.67357337099992, -47.79436614399992],
              [-73.69839433499993, -47.78590260199991],
              [-73.70970618399991, -47.776055596999925],
              [-73.71751868399991, -47.76246510199991],
              [-73.73192298099991, -47.74309661299992],
              [-73.74095618399991, -47.703057549999926],
              [-73.7071020169999, -47.67351653399993],
              [-73.66909745999993, -47.64706796699994],
              [-73.66616777299993, -47.616306247999944],
              [-73.68346106699994, -47.62444426899992],
              [-73.70152747299994, -47.62981536299992],
              [-73.70840410099993, -47.60947030999995],
              [-73.70278886599993, -47.59319426899992],
              [-73.68956458199995, -47.5798479149999],
              [-73.67357337099992, -47.56845468499995],
              [-73.68248450399994, -47.559258721999925],
              [-73.69286048099991, -47.55478280999995],
              [-73.70384680899991, -47.55527109199994],
              [-73.71458899599992, -47.561618747999944],
              [-73.72321529899995, -47.55388762799993],
              [-73.72793535099993, -47.54656340899993],
              [-73.72765051999994, -47.53997161299992],
              [-73.72142493399991, -47.534274997999944],
              [-73.72142493399991, -47.52743905999995],
              [-73.73631751199991, -47.53533294099992],
              [-73.75495357999995, -47.57577890399995],
              [-73.77599036399994, -47.588962497999944],
              [-73.77599036399994, -47.59579843499995],
              [-73.73094641799992, -47.623711846999925],
              [-73.74323482999995, -47.65837981599992],
              [-73.77525794199994, -47.69768645599993],
              [-73.78966223899994, -47.73967864399992],
              [-73.78563391799992, -47.74944426899992],
              [-73.77257239499994, -47.76523202899995],
              [-73.76984615799995, -47.77076588299991],
              [-73.77293860599991, -47.77947356599992],
              [-73.78652910099993, -47.79265715899993],
              [-73.78966223899994, -47.79802825299993],
              [-73.80186926999994, -47.80706145599993],
              [-73.87970943899995, -47.822198174999926],
              [-73.91319739499994, -47.840101820999905],
              [-73.92369544199994, -47.84270598799992],
              [-73.93472245999993, -47.841729424999926],
              [-73.95372473899994, -47.83709075299993],
              [-73.9954320949999, -47.83538176899992],
              [-74.00934811099995, -47.83318450299993],
              [-74.02301998599995, -47.82854583099993],
              [-74.03506425699993, -47.82146575299993],
              [-74.03892981699994, -47.81585051899992],
              [-74.04002844999991, -47.80982838299991],
              [-74.04352779899995, -47.801853122999944],
              [-74.06773841099994, -47.77076588299991],
              [-74.07371985599991, -47.77304452899995],
              [-74.19749915299991, -47.78923919099992],
              [-74.22166907499991, -47.788181247999944],
              [-74.26414954299992, -47.77304452899995],
              [-74.29137122299994, -47.76816171699994],
              [-74.31798255099994, -47.789727471999925],
              [-74.35069739499994, -47.78850676899992],
              [-74.38573157499991, -47.7790666649999],
              [-74.40721594999991, -47.76767343499995],
              [-74.39073645699995, -47.76425546699994],
              [-74.34386145699995, -47.76051197699991],
              [-74.33836829299992, -47.75400155999995],
              [-74.35496985599991, -47.744398695999905],
              [-74.37840735599991, -47.744805596999925],
              [-74.47744706899994, -47.76213958099993],
              [-74.53258216099994, -47.78199635199991],
              [-74.5488988919999, -47.78476327899995],
              [-74.54381262899994, -47.77385833099993],
              [-74.54381262899994, -47.76767343499995],
              [-74.57868404899995, -47.772149346999925],
              [-74.62840735599991, -47.76775481599992],
              [-74.67007402299993, -47.754571221999925],
              [-74.6809789699999, -47.73284270599993],
              [-74.69399980399993, -47.738213799999926],
              [-74.71076412699995, -47.737399997999944],
              [-74.72618567599994, -47.730726820999905],
              [-74.73558508999992, -47.718682549999926],
              [-74.73623613199993, -47.70452239399992],
              [-74.72883053299995, -47.69605885199991],
              [-74.70490475199995, -47.68132903399993],
              [-74.68504798099991, -47.65837981599992],
              [-74.67271887899994, -47.6482072899999],
              [-74.65672766799992, -47.64413827899995],
              [-74.63784745999993, -47.64576588299991],
              [-74.5950414699999, -47.656508070999905],
              [-74.57795162699995, -47.663995049999926],
              [-74.58291581899994, -47.67066822699991],
              [-74.59162350199995, -47.69198984199994],
              [-74.57787024599992, -47.68873463299991],
              [-74.56761633999992, -47.68092213299991],
              [-74.55064856699994, -47.663995049999926],
              [-74.56265214799993, -47.653415622999944],
              [-74.58307857999995, -47.64226653399993],
              [-74.60521399599992, -47.633477471999925],
              [-74.62267005099994, -47.62981536299992],
              [-74.63219153599994, -47.62127044099992],
              [-74.62559973899994, -47.60214609199994],
              [-74.61489824099993, -47.58123137799993],
              [-74.61213131399995, -47.56845468499995],
              [-74.5567113919999, -47.55006275799991],
              [-74.5332738919999, -47.547946872999944],
              [-74.52232825399994, -47.5603166649999],
              [-74.52261308499993, -47.58513762799993],
              [-74.52065995999993, -47.60320403399993],
              [-74.50283769399994, -47.59579843499995],
              [-74.49624589799993, -47.58611419099992],
              [-74.48940995999993, -47.56406015399995],
              [-74.4817602199999, -47.55478280999995],
              [-74.47118079299992, -47.5505510399999],
              [-74.46051998599995, -47.551039320999905],
              [-74.43765214799993, -47.55478280999995],
              [-74.41991126199991, -47.56340911299992],
              [-74.4121801419999, -47.60361093499995],
              [-74.39976966099994, -47.616306247999944],
              [-74.39867102799991, -47.60393645599993],
              [-74.39354407499991, -47.59319426899992],
              [-74.38442949099993, -47.58717213299991],
              [-74.37189693899995, -47.588962497999944],
              [-74.36961829299992, -47.59498463299991],
              [-74.35195878799993, -47.62656015399995],
              [-74.34455318899995, -47.636651299999926],
              [-74.37413489499994, -47.656182549999926],
              [-74.45588131399995, -47.67156340899993],
              [-74.4817602199999, -47.69882577899995],
              [-74.38556881399995, -47.67831796699994],
              [-74.36620032499991, -47.67197030999995],
              [-74.35602779899995, -47.669854424999926],
              [-74.34455318899995, -47.67083098799992],
              [-74.32876542899993, -47.6755510399999],
              [-74.32738196499992, -47.6794572899999],
              [-74.32966061099995, -47.68613046699994],
              [-74.32469641799992, -47.69882577899995],
              [-74.29588782499991, -47.72535572699991],
              [-74.25328528599994, -47.747165622999944],
              [-74.20506751199991, -47.75660572699991],
              [-74.15965735599991, -47.74651458099993],
              [-74.25267493399991, -47.73967864399992],
              [-74.26976477799991, -47.73259856599992],
              [-74.28233801999994, -47.715508721999925],
              [-74.30357825399994, -47.67831796699994],
              [-74.27261308499993, -47.66334400799991],
              [-74.17381751199991, -47.67424895599993],
              [-74.1328832669999, -47.663995049999926],
              [-74.16071529899995, -47.65667083099993],
              [-74.2141820949999, -47.66326262799993],
              [-74.24217688699991, -47.65781015399995],
              [-74.26260331899994, -47.64202239399992],
              [-74.25389563699991, -47.63128020599993],
              [-74.2298070949999, -47.62509530999995],
              [-74.19322669199994, -47.62200286299992],
              [-74.17442786399994, -47.61728280999995],
              [-74.16331946499992, -47.616306247999944],
              [-74.15249589799993, -47.61834075299993],
              [-74.13219153599994, -47.62769947699991],
              [-74.1223852199999, -47.62981536299992],
              [-74.07453365799995, -47.62810637799993],
              [-74.05370032499991, -47.622165622999944],
              [-74.04352779899995, -47.60947030999995],
              [-74.09007727799991, -47.61093515399995],
              [-74.10496985599991, -47.60947030999995],
              [-74.11510169199994, -47.604587497999944],
              [-74.12995357999995, -47.59531015399995],
              [-74.14000403599994, -47.586195570999905],
              [-74.13597571499992, -47.58212655999995],
              [-74.11327063699991, -47.57773202899995],
              [-74.09056555899991, -47.56658294099992],
              [-74.07079016799992, -47.55120208099993],
              [-74.05719967399995, -47.534274997999944],
              [-74.07689368399991, -47.54615650799991],
              [-74.11766516799992, -47.55396900799991],
              [-74.13906816299993, -47.561618747999944],
              [-74.15054277299993, -47.56951262799993],
              [-74.15904700399994, -47.57773202899995],
              [-74.16808020699995, -47.58456796699994],
              [-74.18130449099993, -47.588962497999944],
              [-74.19375566299993, -47.58912525799991],
              [-74.21422278599994, -47.58359140399995],
              [-74.22508704299992, -47.58212655999995],
              [-74.23607337099992, -47.5837541649999],
              [-74.26447506399995, -47.5935197899999],
              [-74.27354895699995, -47.59905364399992],
              [-74.28359941299993, -47.603773695999905],
              [-74.29442298099991, -47.60214609199994],
              [-74.30500240799995, -47.597914320999905],
              [-74.31411699099993, -47.59579843499995],
              [-74.32835852799991, -47.5857072899999],
              [-74.33511308499993, -47.56267669099992],
              [-74.33910071499992, -47.53728606599992],
              [-74.34455318899995, -47.51995208099993],
              [-74.36896725199995, -47.53484465899993],
              [-74.39232337099992, -47.53476327899995],
              [-74.41429602799991, -47.523695570999905],
              [-74.43455969999991, -47.50701262799993],
              [-74.45352128799993, -47.48105234199994],
              [-74.44204667899993, -47.470635674999926],
              [-74.38556881399995, -47.45916106599992],
              [-74.39439856699994, -47.44654713299991],
              [-74.40851803299995, -47.44540780999995],
              [-74.42491614499994, -47.447523695999905],
              [-74.44078528599994, -47.44548919099992],
              [-74.44717363199993, -47.43873463299991],
              [-74.45055091099994, -47.429620049999926],
              [-74.45518958199995, -47.42156340899993],
              [-74.46532141799992, -47.41814544099992],
              [-74.46617591099994, -47.431573174999926],
              [-74.48473059799994, -47.45623137799993],
              [-74.50658118399991, -47.46965911299992],
              [-74.52855383999992, -47.43173593499995],
              [-74.52887936099995, -47.42229583099993],
              [-74.51341712099992, -47.41814544099992],
              [-74.50283769399994, -47.41301848799992],
              [-74.49449622299994, -47.40113697699991],
              [-74.4817602199999, -47.37664153399993],
              [-74.46727454299992, -47.36288827899995],
              [-74.4505102199999, -47.35426197699991],
              [-74.40721594999991, -47.342461846999925],
              [-74.41616777299993, -47.321384372999944],
              [-74.39525305899991, -47.30592213299991],
              [-74.3665258449999, -47.29070403399993],
              [-74.35195878799993, -47.269789320999905],
              [-74.32469641799992, -47.21892669099992],
              [-74.31407630099994, -47.21949635199991],
              [-74.30378170499995, -47.22747161299992],
              [-74.29381262899994, -47.23796965899993],
              [-74.28376217399995, -47.24627044099992],
              [-74.27871660099993, -47.2243791649999],
              [-74.27428137899994, -47.21559010199991],
              [-74.26634680899991, -47.21217213299991],
              [-74.25584876199991, -47.21640390399995],
              [-74.23786373599995, -47.23512135199991],
              [-74.23224850199995, -47.23943450299993],
              [-74.22166907499991, -47.2360979149999],
              [-74.22305253799993, -47.2282854149999],
              [-74.22716223899994, -47.21819426899992],
              [-74.22508704299992, -47.2087541649999],
              [-74.21572831899994, -47.20468515399995],
              [-74.20254472599993, -47.203789971999925],
              [-74.17760169199994, -47.20525481599992],
              [-74.16771399599992, -47.21575286299992],
              [-74.15965735599991, -47.2810197899999],
              [-74.14952551999994, -47.29802825299993],
              [-74.13516191299993, -47.31682708099993],
              [-74.11937415299991, -47.333103122999944],
              [-74.11241614499994, -47.33554452899995],
              [-74.11070716099994, -47.32903411299992],
              [-74.10606848899994, -47.32236093499995],
              [-74.10496985599991, -47.315118096999925],
              [-74.10948645699995, -47.306573174999926],
              [-74.12608801999994, -47.28728606599992],
              [-74.13670813699991, -47.26962655999995],
              [-74.14012610599991, -47.25660572699991],
              [-74.13906816299993, -47.22234465899993],
              [-74.13223222599993, -47.20452239399992],
              [-74.11538652299993, -47.19296640399995],
              [-74.09422766799992, -47.18670012799993],
              [-74.07457434799994, -47.18482838299991],
              [-74.05553137899994, -47.19036223799992],
              [-74.04702714799993, -47.190118096999925],
              [-74.04352779899995, -47.18108489399992],
              [-74.04002844999991, -47.17831796699994],
              [-74.03189042899993, -47.176446221999925],
              [-74.02281653599994, -47.176039320999905],
              [-74.01622473899994, -47.17742278399993],
              [-74.00308183499993, -47.19939544099992],
              [-73.98704993399991, -47.235039971999925],
              [-73.97350012899994, -47.254978122999944],
              [-73.96776282499991, -47.229180596999925],
              [-73.97118079299992, -47.21575286299992],
              [-73.98615475199995, -47.18678150799991],
              [-73.9895727199999, -47.16741301899992],
              [-73.99893144399994, -47.16497161299992],
              [-74.05719967399995, -47.156914971999925],
              [-73.95763098899994, -47.0603166649999],
              [-73.9473363919999, -47.04762135199991],
              [-73.94127356699994, -47.02792734199994],
              [-73.94896399599992, -47.015557549999926],
              [-74.02009029899995, -46.9782854149999],
              [-74.04059811099995, -46.97185637799993],
              [-74.06403561099995, -46.972588799999926],
              [-74.10289466099994, -46.98674895599993],
              [-74.11864173099991, -46.9880510399999],
              [-74.13906816299993, -46.97869231599992],
              [-74.15322831899994, -46.96721770599993],
              [-74.20645097599993, -46.90789153399993],
              [-74.20864824099993, -46.89397551899992],
              [-74.20042883999992, -46.881524346999925],
              [-74.18130449099993, -46.869398695999905],
              [-74.1719457669999, -46.86858489399992],
              [-74.1602270169999, -46.86972421699994],
              [-74.15013587099992, -46.86809661299992],
              [-74.14590410099993, -46.85955169099992],
              [-74.14452063699991, -46.851495049999926],
              [-74.14045162699995, -46.84449635199991],
              [-74.13418535099993, -46.83912525799991],
              [-74.12608801999994, -46.83538176899992],
              [-74.12608801999994, -46.82854583099993],
              [-74.16795813699991, -46.83757903399993],
              [-74.18130449099993, -46.84221770599993],
              [-74.19102942599994, -46.84880950299993],
              [-74.2090551419999, -46.8650041649999],
              [-74.22166907499991, -46.869398695999905],
              [-74.24331620999993, -46.86467864399992],
              [-74.26549231699994, -46.830743096999925],
              [-74.28990637899994, -46.82170989399992],
              [-74.28189042899993, -46.812432549999926],
              [-74.27257239499994, -46.80877044099992],
              [-74.26512610599991, -46.80478280999995],
              [-74.26260331899994, -46.79371510199991],
              [-74.26683508999992, -46.78167083099993],
              [-74.27611243399991, -46.77971770599993],
              [-74.28892981699994, -46.78134530999995],
              [-74.30357825399994, -46.78004322699991],
              [-74.31017005099994, -46.778008721999925],
              [-74.31700598899994, -46.77507903399993],
              [-74.32249915299991, -46.77027760199991],
              [-74.32469641799992, -46.76336028399993],
              [-74.32762610599991, -46.75823333099993],
              [-74.33360755099994, -46.75994231599992],
              [-74.33853105399993, -46.764336846999925],
              [-74.33836829299992, -46.76718515399995],
              [-74.44139563699991, -46.76718515399995],
              [-74.45616614499994, -46.76490650799991],
              [-74.48216712099992, -46.75554778399993],
              [-74.52122962099992, -46.75009530999995],
              [-74.59162350199995, -46.72551848799992],
              [-74.59162350199995, -46.732354424999926],
              [-74.52090410099993, -46.76311614399992],
              [-74.47765051999994, -46.77239348799992],
              [-74.48379472599993, -46.78411223799992],
              [-74.50450598899994, -46.795993747999944],
              [-74.52672278599994, -46.80120208099993],
              [-74.58812415299991, -46.79371510199991],
              [-74.60041256399995, -46.79045989399992],
              [-74.61327063699991, -46.78378671699994],
              [-74.62657630099994, -46.77857838299991],
              [-74.64000403599994, -46.78004322699991],
              [-74.65086829299992, -46.78834400799991],
              [-74.65192623599995, -46.79697030999995],
              [-74.64854895699995, -46.8064104149999],
              [-74.64622962099992, -46.818291924999926],
              [-74.64883378799993, -46.82927825299993],
              [-74.65566972599993, -46.83684661299992],
              [-74.67349199099993, -46.84905364399992],
              [-74.55093339799993, -46.83538176899992],
              [-74.53335527299993, -46.839776299999926],
              [-74.50767981699994, -46.85898202899995],
              [-74.49229895699995, -46.86337655999995],
              [-74.45018469999991, -46.85605234199994],
              [-74.43455969999991, -46.85588958099993],
              [-74.47915605399993, -46.902276299999926],
              [-74.54572506399995, -46.895603122999944],
              [-74.61831620999993, -46.876071872999944],
              [-74.6809789699999, -46.883884372999944],
              [-74.69102942599994, -46.87656015399995],
              [-74.70225989499994, -46.86565520599993],
              [-74.71133378799993, -46.85426197699991],
              [-74.71507727799991, -46.845635674999926],
              [-74.72154700399994, -46.84002044099992],
              [-74.76292883999992, -46.81487395599993],
              [-74.78791256399995, -46.80722421699994],
              [-74.79954993399991, -46.80120208099993],
              [-74.80451412699995, -46.79070403399993],
              [-74.80748450399994, -46.77581145599993],
              [-74.81525631399995, -46.76848723799992],
              [-74.82603919199994, -46.76970794099992],
              [-74.83800208199995, -46.78004322699991],
              [-74.83185787699995, -46.78004322699991],
              [-74.84626217399995, -46.80681731599992],
              [-74.85635331899994, -46.81389739399992],
              [-74.86953691299993, -46.80592213299991],
              [-74.89321855399993, -46.78753020599993],
              [-74.90062415299991, -46.78362395599993],
              [-74.95494544199994, -46.761651299999926],
              [-74.95811926999994, -46.759698174999926],
              [-75.00649980399993, -46.75351327899995],
              [-75.01500403599994, -46.74920012799993],
              [-75.01622473899994, -46.73943450299993],
              [-75.01488196499992, -46.72820403399993],
              [-75.01618404899995, -46.71933359199994],
              [-75.07510331899994, -46.66073984199994],
              [-75.08336341099994, -46.640883070999905],
              [-75.07518469999991, -46.62004973799992],
              [-75.05919348899994, -46.602227471999925],
              [-75.02586829299992, -46.57927825299993],
              [-75.01545162699995, -46.56601327899995],
              [-75.00731360599991, -46.5525041649999],
              [-74.99624589799993, -46.53997161299992],
              [-74.9798070949999, -46.531914971999925],
              [-74.95921790299991, -46.525323174999926],
              [-74.94163977799991, -46.51677825299993],
              [-74.93419348899994, -46.50269947699991],
              [-74.93691972599993, -46.482679945999905],
              [-74.94139563699991, -46.4704729149999],
              [-74.94229081899994, -46.45818450299993],
              [-74.93419348899994, -46.43759530999995],
              [-74.96458899599992, -46.45403411299992],
              [-74.98814856699994, -46.490899346999925],
              [-75.01406816299993, -46.52011484199994],
              [-75.05150305899991, -46.51327890399995],
              [-75.07506262899994, -46.5583635399999],
              [-75.11164303299995, -46.58684661299992],
              [-75.20173092399995, -46.629978122999944],
              [-75.20775305899991, -46.60491301899992],
              [-75.20791581899994, -46.59514739399992],
              [-75.23448645699995, -46.62314218499995],
              [-75.24836178299995, -46.63250090899993],
              [-75.2669164699999, -46.63616301899992],
              [-75.32477779899995, -46.64006926899992],
              [-75.33893795499995, -46.643649997999944],
              [-75.33999589799993, -46.6462541649999],
              [-75.33877519399994, -46.651055596999925],
              [-75.33844967399995, -46.655368747999944],
              [-75.34235592399995, -46.657321872999944],
              [-75.38654537699995, -46.65553150799991],
              [-75.39614824099993, -46.652276299999926],
              [-75.40038001199991, -46.64666106599992],
              [-75.40465247299994, -46.62981536299992],
              [-75.41486568899995, -46.632745049999926],
              [-75.4270727199999, -46.64348723799992],
              [-75.43724524599992, -46.64983489399992],
              [-75.56175696499992, -46.680759372999944],
              [-75.57506262899994, -46.68792083099993],
              [-75.58336341099994, -46.69378020599993],
              [-75.5911352199999, -46.6970354149999],
              [-75.59675045499995, -46.70086028399993],
              [-75.5989477199999, -46.70842864399992],
              [-75.59927324099993, -46.71697356599992],
              [-75.60057532499991, -46.72275155999995],
              [-75.6028539699999, -46.727227471999925],
              [-75.60643469999991, -46.732354424999926],
              [-75.61778723899994, -46.74236419099992],
              [-75.64659583199995, -46.75595468499995],
              [-75.66104081899994, -46.76718515399995],
              [-75.63133704299992, -46.785414320999905],
              [-75.5977270169999, -46.75855885199991],
              [-75.56566321499992, -46.718682549999926],
              [-75.54059811099995, -46.69817473799992],
              [-75.46373450399994, -46.699883721999925],
              [-75.44066321499992, -46.705010674999926],
              [-75.42247473899994, -46.713962497999944],
              [-75.41759192599994, -46.72193775799991],
              [-75.42613684799994, -46.72665780999995],
              [-75.44810950399994, -46.72551848799992],
              [-75.44131425699993, -46.74236419099992],
              [-75.44884192599994, -46.756524346999925],
              [-75.4629613919999, -46.76718515399995],
              [-75.47606360599991, -46.77402109199994],
              [-75.40001380099994, -46.77695077899995],
              [-75.38670813699991, -46.78004322699991],
              [-75.38231360599991, -46.80632903399993],
              [-75.39883378799993, -46.82870859199994],
              [-75.42096920499995, -46.847588799999926],
              [-75.43390865799995, -46.86337655999995],
              [-75.39435787699995, -46.85173919099992],
              [-75.37205969999991, -46.84880950299993],
              [-75.35260982999995, -46.85588958099993],
              [-75.34630286399994, -46.86679452899995],
              [-75.3469945949999, -46.879164320999905],
              [-75.35260982999995, -46.90056731599992],
              [-75.36119544199994, -46.902601820999905],
              [-75.41055253799993, -46.931573174999926],
              [-75.42479407499991, -46.93320077899995],
              [-75.46861731699994, -46.945245049999926],
              [-75.5208227199999, -46.94931405999995],
              [-75.55174719999991, -46.948337497999944],
              [-75.56895911399994, -46.93987395599993],
              [-75.58348548099991, -46.90984465899993],
              [-75.58531653599994, -46.90357838299991],
              [-75.59361731699994, -46.89902109199994],
              [-75.61681067599994, -46.89348723799992],
              [-75.62633216099994, -46.88990650799991],
              [-75.64224199099993, -46.88014088299991],
              [-75.65021725199995, -46.87322356599992],
              [-75.65355383999992, -46.86638762799993],
              [-75.65294348899994, -46.84465911299992],
              [-75.65387936099995, -46.83342864399992],
              [-75.66026770699995, -46.824476820999905],
              [-75.70702063699991, -46.78655364399992],
              [-75.71141516799992, -46.744398695999905],
              [-75.7083227199999, -46.65471770599993],
              [-75.70470130099994, -46.63925546699994],
              [-75.69469153599994, -46.62835051899992],
              [-75.67536373599995, -46.61565520599993],
              [-75.66038977799991, -46.6013322899999],
              [-75.64952551999994, -46.58562590899993],
              [-75.6360570949999, -46.57301197699991],
              [-75.61318925699993, -46.56780364399992],
              [-75.57144120999993, -46.56910572699991],
              [-75.55797278599994, -46.56780364399992],
              [-75.54922441299993, -46.56389739399992],
              [-75.54210364499994, -46.55803801899992],
              [-75.53262285099993, -46.553806247999944],
              [-75.51707923099991, -46.55429452899995],
              [-75.53425045499995, -46.53240325299993],
              [-75.54259192599994, -46.51913827899995],
              [-75.54059811099995, -46.51327890399995],
              [-75.47232011599993, -46.51327890399995],
              [-75.45299231699994, -46.50937265399995],
              [-75.44619706899994, -46.50009530999995],
              [-75.44286048099991, -46.488539320999905],
              [-75.43390865799995, -46.478448174999926],
              [-75.41881262899994, -46.4743791649999],
              [-75.38906816299993, -46.47673919099992],
              [-75.37303626199991, -46.47161223799992],
              [-75.37303626199991, -46.46542734199994],
              [-75.39932206899994, -46.44890715899993],
              [-75.40111243399991, -46.440524997999944],
              [-75.39045162699995, -46.42734140399995],
              [-75.34532630099994, -46.394789320999905],
              [-75.33519446499992, -46.39031340899993],
              [-75.31281490799995, -46.38632577899995],
              [-75.29686438699991, -46.37712981599992],
              [-75.28400631399995, -46.36760833099993],
              [-75.27061926999994, -46.362399997999944],
              [-75.25426184799994, -46.365492445999905],
              [-75.23867753799993, -46.37574635199991],
              [-75.22695878799993, -46.38982512799993],
              [-75.22223873599995, -46.40398528399993],
              [-75.21165930899991, -46.33513762799993],
              [-75.20494544199994, -46.33049895599993],
              [-75.20360266799992, -46.31991952899995],
              [-75.20384680899991, -46.3083635399999],
              [-75.20173092399995, -46.30095794099992],
              [-75.19627844999991, -46.29827239399992],
              [-75.18700110599991, -46.295993747999944],
              [-75.17829342399995, -46.29697030999995],
              [-75.17442786399994, -46.30437590899993],
              [-75.15318762899994, -46.32431405999995],
              [-75.10578365799995, -46.34710051899992],
              [-75.05650794199994, -46.35784270599993],
              [-75.02977454299992, -46.34197356599992],
              [-75.05711829299992, -46.33879973799992],
              [-75.10627193899995, -46.32512786299992],
              [-75.12975012899994, -46.3220354149999],
              [-75.13866126199991, -46.31406015399995],
              [-75.13621985599991, -46.29648202899995],
              [-75.12279212099992, -46.279554945999905],
              [-75.09870357999995, -46.27361419099992],
              [-75.09870357999995, -46.26677825299993],
              [-75.11164303299995, -46.260430596999925],
              [-75.11632239499994, -46.24960702899995],
              [-75.11412512899994, -46.23723723799992],
              [-75.10610917899993, -46.22584400799991],
              [-75.09068762899994, -46.21607838299991],
              [-75.07070878799993, -46.21054452899995],
              [-75.04930579299992, -46.20907968499995],
              [-75.02977454299992, -46.21217213299991],
              [-75.00658118399991, -46.227227471999925],
              [-74.98509680899991, -46.249118747999944],
              [-74.96051998599995, -46.267836195999905],
              [-74.92804928299995, -46.27361419099992],
              [-74.95177161399994, -46.24822356599992],
              [-74.96153723899994, -46.23015715899993],
              [-74.95811926999994, -46.21526458099993],
              [-74.92422441299993, -46.18767669099992],
              [-74.91942298099991, -46.17929452899995],
              [-74.91002356699994, -46.1501604149999],
              [-74.89146887899994, -46.147149346999925],
              [-74.87954667899993, -46.146742445999905],
              [-74.86534583199995, -46.1501604149999],
              [-74.83800208199995, -46.170586846999925],
              [-74.80955969999991, -46.19850025799991],
              [-74.79539954299992, -46.20916106599992],
              [-74.77721106699994, -46.21217213299991],
              [-74.78575598899994, -46.19646575299993],
              [-74.79084225199995, -46.19109465899993],
              [-74.78376217399995, -46.18377044099992],
              [-74.77550208199995, -46.17913176899992],
              [-74.76634680899991, -46.17734140399995],
              [-74.75601152299993, -46.177992445999905],
              [-74.77228756399995, -46.16545989399992],
              [-74.80516516799992, -46.15398528399993],
              [-74.81818600199995, -46.14267343499995],
              [-74.82445227799991, -46.12590911299992],
              [-74.82119706899994, -46.11223723799992],
              [-74.81480872299994, -46.0993791649999],
              [-74.81126868399991, -46.084649346999925],
              [-74.78148352799991, -46.04697030999995],
              [-74.77375240799995, -46.04029713299991],
              [-74.70148678299995, -46.03289153399993],
              [-74.70592200399994, -46.02271900799991],
              [-74.71076412699995, -46.02166106599992],
              [-74.7168676419999, -46.02459075299993],
              [-74.72533118399991, -46.02654387799993],
              [-74.73786373599995, -46.02312590899993],
              [-74.73786373599995, -46.01490650799991],
              [-74.72874915299991, -45.998711846999925],
              [-74.72451738199993, -45.99358489399992],
              [-74.71739661399994, -45.98951588299991],
              [-74.71336829299992, -45.98447030999995],
              [-74.71849524599992, -45.97535572699991],
              [-74.72484290299991, -45.96754322699991],
              [-74.72740637899994, -45.96103280999995],
              [-74.72874915299991, -45.944024346999925],
              [-74.69090735599991, -45.8415666649999],
              [-74.66559811099995, -45.823337497999944],
              [-74.64732825399994, -45.8161760399999],
              [-74.62946529899995, -45.824883721999925],
              [-74.61660722599993, -45.83953215899993],
              [-74.6067602199999, -45.84587981599992],
              [-74.59626217399995, -45.8435197899999],
              [-74.5813695949999, -45.83171965899993],
              [-74.55996660099993, -45.82626718499995],
              [-74.54605058499993, -45.84449635199991],
              [-74.54401607999995, -45.87428150799991],
              [-74.55809485599991, -45.90309010199991],
              [-74.5449926419999, -45.9040666649999],
              [-74.52892005099994, -45.90276458099993],
              [-74.51537024599992, -45.904229424999926],
              [-74.50963294199994, -45.91326262799993],
              [-74.50743567599994, -45.92742278399993],
              [-74.50194251199991, -45.92929452899995],
              [-74.49510657499991, -45.9255510399999],
              [-74.48916581899994, -45.9235979149999],
              [-74.4766332669999, -45.924899997999944],
              [-74.47183183499993, -45.923760674999926],
              [-74.46800696499992, -45.92506275799991],
              [-74.45815995999993, -45.933851820999905],
              [-74.45299231699994, -45.944024346999925],
              [-74.45494544199994, -45.95525481599992],
              [-74.45938066299993, -45.96607838299991],
              [-74.46182206899994, -45.97535572699991],
              [-74.46654212099992, -45.98674895599993],
              [-74.47545325399994, -45.99749114399992],
              [-74.48094641799992, -46.00839609199994],
              [-74.47549394399994, -46.019789320999905],
              [-74.46471106699994, -46.022149346999925],
              [-74.45335852799991, -46.01637135199991],
              [-74.44440670499995, -46.00798919099992],
              [-74.44078528599994, -46.00212981599992],
              [-74.43822180899991, -45.992445570999905],
              [-74.43219967399995, -45.98495859199994],
              [-74.42540442599994, -45.97820403399993],
              [-74.42027747299994, -45.97193775799991],
              [-74.4173070949999, -45.9607072899999],
              [-74.41661536399994, -45.95037200299993],
              [-74.41266842399995, -45.94215260199991],
              [-74.39976966099994, -45.93718840899993],
              [-74.39976966099994, -45.93043385199991],
              [-74.42398027299993, -45.917087497999944],
              [-74.44701087099992, -45.89421965899993],
              [-74.46369381399995, -45.86581796699994],
              [-74.46865800699993, -45.83473072699991],
              [-74.46056067599994, -45.83912525799991],
              [-74.45295162699995, -45.84124114399992],
              [-74.43455969999991, -45.8415666649999],
              [-74.44985917899993, -45.828789971999925],
              [-74.46182206899994, -45.81503671699994],
              [-74.44664466099994, -45.80828215899993],
              [-74.39297441299993, -45.800713799999926],
              [-74.35960852799991, -45.79029713299991],
              [-74.34508216099994, -45.79111093499995],
              [-74.33092200399994, -45.800713799999926],
              [-74.3281957669999, -45.80706145599993],
              [-74.32530676999994, -45.82463958099993],
              [-74.32127844999991, -45.83171965899993],
              [-74.31362870999993, -45.833103122999944],
              [-74.30540930899991, -45.82773202899995],
              [-74.29723059799994, -45.8200822899999],
              [-74.28990637899994, -45.81503671699994],
              [-74.18936113199993, -45.793633721999925],
              [-74.17027747299994, -45.79176197699991],
              [-74.15648352799991, -45.79729583099993],
              [-74.10313880099994, -45.83684661299992],
              [-74.11554928299995, -45.85361093499995],
              [-74.13548743399991, -45.867120049999926],
              [-74.14590410099993, -45.865492445999905],
              [-74.15379798099991, -45.871758721999925],
              [-74.17210852799991, -45.877618096999925],
              [-74.19277910099993, -45.881931247999944],
              [-74.18455969999991, -45.88250090899993],
              [-74.11864173099991, -45.8962541649999],
              [-74.12450110599991, -45.90504322699991],
              [-74.13036048099991, -45.9118791649999],
              [-74.13719641799992, -45.9177385399999],
              [-74.14590410099993, -45.9235979149999],
              [-74.14590410099993, -45.93043385199991],
              [-74.07994544199994, -45.92115650799991],
              [-74.05919348899994, -45.92986419099992],
              [-74.06403561099995, -45.96453215899993],
              [-74.08006751199991, -45.98186614399992],
              [-74.10716712099992, -45.99456145599993],
              [-74.13849850199995, -46.00253671699994],
              [-74.16706295499995, -46.00554778399993],
              [-74.16706295499995, -46.01295338299991],
              [-74.15176347599993, -46.01832447699991],
              [-74.10155188699991, -46.01295338299991],
              [-74.0860082669999, -46.017836195999905],
              [-74.08385169199994, -46.02971770599993],
              [-74.09850012899994, -46.08082447699991],
              [-74.11803137899994, -46.10230885199991],
              [-74.16706295499995, -46.13640715899993],
              [-74.13947506399995, -46.131117445999905],
              [-74.10533606699994, -46.115899346999925],
              [-74.07628333199995, -46.09612395599993],
              [-74.06403561099995, -46.07781340899993],
              [-74.05638587099992, -46.02792734199994],
              [-74.0606176419999, -46.019789320999905],
              [-74.06924394399994, -46.01189544099992],
              [-74.06973222599993, -45.99537525799991],
              [-74.06135006399995, -45.98088958099993],
              [-74.04352779899995, -45.978773695999905],
              [-74.03697669199994, -45.9860979149999],
              [-74.03416907499991, -45.99765390399995],
              [-74.03001868399991, -46.00839609199994],
              [-73.98204505099994, -46.02971770599993],
              [-73.97960364499994, -46.039727471999925],
              [-73.96947180899991, -46.06096770599993],
              [-73.96776282499991, -46.07439544099992],
              [-73.97057044199994, -46.08416106599992],
              [-73.9895727199999, -46.11598072699991],
              [-74.02131100199995, -46.1482072899999],
              [-74.06358801999994, -46.17205169099992],
              [-74.19151770699995, -46.21835702899995],
              [-74.26402747299994, -46.23056405999995],
              [-74.31322180899991, -46.249932549999926],
              [-74.33836829299992, -46.25253671699994],
              [-74.35948645699995, -46.2458635399999],
              [-74.39761308499993, -46.223321221999925],
              [-74.41685950399994, -46.21843840899993],
              [-74.42430579299992, -46.215101820999905],
              [-74.48062089799993, -46.168633721999925],
              [-74.48916581899994, -46.16375090899993],
              [-74.48989824099993, -46.189385674999926],
              [-74.46568762899994, -46.20818450299993],
              [-74.41030839799993, -46.23577239399992],
              [-74.40029863199993, -46.24382903399993],
              [-74.38784745999993, -46.25074635199991],
              [-74.37376868399991, -46.256117445999905],
              [-74.35879472599993, -46.260023695999905],
              [-74.34215247299994, -46.260837497999944],
              [-74.18984941299993, -46.24228280999995],
              [-74.07721920499995, -46.203789971999925],
              [-74.04971269399994, -46.19109465899993],
              [-74.04352779899995, -46.197930596999925],
              [-74.05553137899994, -46.215508721999925],
              [-74.07144120999993, -46.232679945999905],
              [-74.03892981699994, -46.24700286299992],
              [-74.04165605399993, -46.27076588299991],
              [-74.07770748599995, -46.3220354149999],
              [-74.06175696499992, -46.317071221999925],
              [-74.03648841099994, -46.29241301899992],
              [-74.02643795499995, -46.28671640399995],
              [-74.00853430899991, -46.288995049999926],
              [-73.94151770699995, -46.304945570999905],
              [-73.92935136599993, -46.31454843499995],
              [-73.91860917899993, -46.32586028399993],
              [-73.90636145699995, -46.33513762799993],
              [-73.89244544199994, -46.339776299999926],
              [-73.84487870999993, -46.34197356599992],
              [-73.94522050699993, -46.26572030999995],
              [-73.95815995999993, -46.24944426899992],
              [-73.95299231699994, -46.231540622999944],
              [-73.97459876199991, -46.22226327899995],
              [-74.01622473899994, -46.21843840899993],
              [-74.01927649599992, -46.20435963299991],
              [-74.01162675699993, -46.185804945999905],
              [-73.99864661399994, -46.16741301899992],
              [-73.98574785099993, -46.15357838299991],
              [-73.96816972599993, -46.14470794099992],
              [-73.94326738199993, -46.13941822699991],
              [-73.89610755099994, -46.13640715899993],
              [-73.88182532499991, -46.14177825299993],
              [-73.87267005099994, -46.15488046699994],
              [-73.85789954299992, -46.184258721999925],
              [-73.82848059799994, -46.20452239399992],
              [-73.79552161399994, -46.21640390399995],
              [-73.76984615799995, -46.23455169099992],
              [-73.76231848899994, -46.27361419099992],
              [-73.77306067599994, -46.32089609199994],
              [-73.79417883999992, -46.361586195999905],
              [-73.82323157499991, -46.39763762799993],
              [-73.85789954299992, -46.430759372999944],
              [-73.91250566299993, -46.46884530999995],
              [-73.92064368399991, -46.48186614399992],
              [-73.92772376199991, -46.497165622999944],
              [-73.97524980399993, -46.53997161299992],
              [-73.98916581899994, -46.55974700299993],
              [-73.98375403599994, -46.56650155999995],
              [-73.96629798099991, -46.570977471999925],
              [-73.92454993399991, -46.59693775799991],
              [-73.89964758999992, -46.60271575299993],
              [-73.87389075399994, -46.602227471999925],
              [-73.85171464799993, -46.59514739399992],
              [-73.83161373599995, -46.5778947899999],
              [-73.82091223899994, -46.557305596999925],
              [-73.81273352799991, -46.53590260199991],
              [-73.79133053299995, -46.50505950299993],
              [-73.78734290299991, -46.497165622999944],
              [-73.78213456899994, -46.494805596999925],
              [-73.76984615799995, -46.49960702899995],
              [-73.76024329299992, -46.506524346999925],
              [-73.75328528599994, -46.51523202899995],
              [-73.74185136599993, -46.53378671699994],
              [-73.73729407499991, -46.52166106599992],
              [-73.73859615799995, -46.50798919099992],
              [-73.74396725199995, -46.496758721999925],
              [-73.75182044199994, -46.492120049999926],
              [-73.76549231699994, -46.486260674999926],
              [-73.76646887899994, -46.472588799999926],
              [-73.75552324099993, -46.444431247999944],
              [-73.74233964799993, -46.420993747999944],
              [-73.69098873599995, -46.373304945999905],
              [-73.67227128799993, -46.35955169099992],
              [-73.62214107999995, -46.334242445999905],
              [-73.60130774599992, -46.31845468499995],
              [-73.58018958199995, -46.31023528399993],
              [-73.51431230399993, -46.30754973799992],
              [-73.48863684799994, -46.30095794099992],
              [-73.52977454299992, -46.299899997999944],
              [-73.55052649599992, -46.295586846999925],
              [-73.56371008999992, -46.28671640399995],
              [-73.56834876199991, -46.27044036299992],
              [-73.56240800699993, -46.2575822899999],
              [-73.55211341099994, -46.24578215899993],
              [-73.54328365799995, -46.232679945999905],
              [-73.52391516799992, -46.17522551899992],
              [-73.50645911399994, -46.155368747999944],
              [-73.47435462099992, -46.1501604149999],
              [-73.48180091099994, -46.14267343499995],
              [-73.42373613199993, -46.071384372999944],
              [-73.40367591099994, -46.05999114399992],
              [-73.35765540299991, -46.04216887799993],
              [-73.34459387899994, -46.02654387799993],
              [-73.36156165299991, -46.02271900799991],
              [-73.38634192599994, -46.02011484199994],
              [-73.41173255099994, -46.02157968499995],
              [-73.43028723899994, -46.02971770599993],
              [-73.44522050699993, -46.04892343499995],
              [-73.46947180899991, -46.08928801899992],
              [-73.57632402299993, -46.201836846999925],
              [-73.61148027299993, -46.21843840899993],
              [-73.61148027299993, -46.22584400799991],
              [-73.59984290299991, -46.246758721999925],
              [-73.62437903599994, -46.276462497999944],
              [-73.68785559799994, -46.3220354149999],
              [-73.70152747299994, -46.29355234199994],
              [-73.69180253799993, -46.25644296699994],
              [-73.66637122299994, -46.22625090899993],
              [-73.63263912699995, -46.21843840899993],
              [-73.64810136599993, -46.19475676899992],
              [-73.64207923099991, -46.164320570999905],
              [-73.62791907499991, -46.131931247999944],
              [-73.61900794199994, -46.10230885199991],
              [-73.62018795499995, -46.083103122999944],
              [-73.62645423099991, -46.07105885199991],
              [-73.6497289699999, -46.05046965899993],
              [-73.65123450399994, -46.041680596999925],
              [-73.65314693899995, -45.99553801899992],
              [-73.65648352799991, -45.98479583099993],
              [-73.66148841099994, -45.98015715899993],
              [-73.66055253799993, -45.975681247999944],
              [-73.64631100199995, -45.96453215899993],
              [-73.62193762899994, -45.95037200299993],
              [-73.61925208199995, -45.945570570999905],
              [-73.61900794199994, -45.933851820999905],
              [-73.60960852799991, -45.90309010199991],
              [-73.58604895699995, -45.88551197699991],
              [-73.55483964799993, -45.877618096999925],
              [-73.5227758449999, -45.87574635199991],
              [-73.53648841099994, -45.87070077899995],
              [-73.54930579299992, -45.86345794099992],
              [-73.55915279899995, -45.85369231599992],
              [-73.56371008999992, -45.8415666649999],
              [-73.56021074099993, -45.82976653399993],
              [-73.54149329299992, -45.81218840899993],
              [-73.53701738199993, -45.80413176899992],
              [-73.40208899599992, -45.70191822699991],
              [-73.35631262899994, -45.68808359199994],
              [-73.19749915299991, -45.67717864399992],
              [-73.18854732999995, -45.672133070999905],
              [-73.18578040299991, -45.66253020599993],
              [-73.18887285099993, -45.65585702899995],
              [-73.19749915299991, -45.660088799999926],
              [-73.2962133449999, -45.64983489399992],
              [-73.3118383449999, -45.64397551899992],
              [-73.31627356699994, -45.63811614399992],
              [-73.3184301419999, -45.63054778399993],
              [-73.32725989499994, -45.619073174999926],
              [-73.33364824099993, -45.621026299999926],
              [-73.36025956899994, -45.633884372999944],
              [-73.36851966099994, -45.639336846999925],
              [-73.37816321499992, -45.64373137799993],
              [-73.42031816299993, -45.64983489399992],
              [-73.42589270699995, -45.65447356599992],
              [-73.47378495999993, -45.71257903399993],
              [-73.48965410099993, -45.72665780999995],
              [-73.51219641799992, -45.732354424999926],
              [-73.53278561099995, -45.74114348799992],
              [-73.56550045499995, -45.776462497999944],
              [-73.59166419199994, -45.78020598799992],
              [-73.58169511599993, -45.75139739399992],
              [-73.57518469999991, -45.72323984199994],
              [-73.57054602799991, -45.660088799999926],
              [-73.56533769399994, -45.6325822899999],
              [-73.5423070949999, -45.58147551899992],
              [-73.53482011599993, -45.536228122999944],
              [-73.52497311099995, -45.50554778399993],
              [-73.52135169199994, -45.47193775799991],
              [-73.51732337099992, -45.46038176899992],
              [-73.51085364499994, -45.45175546699994],
              [-73.50230872299994, -45.44378020599993],
              [-73.47508704299992, -45.42457447699991],
              [-73.44587154899995, -45.41350676899992],
              [-73.42247473899994, -45.41952890399995],
              [-73.41291256399995, -45.45126718499995],
              [-73.40607662699995, -45.45126718499995],
              [-73.39907792899993, -45.38787200299993],
              [-73.39244544199994, -45.37558359199994],
              [-73.37096106699994, -45.36687590899993],
              [-73.35334225199995, -45.37265390399995],
              [-73.3235570949999, -45.39592864399992],
              [-73.32494055899991, -45.37810637799993],
              [-73.32884680899991, -45.35759856599992],
              [-73.32770748599995, -45.340915622999944],
              [-73.31387285099993, -45.333916924999926],
              [-73.30524654899995, -45.331963799999926],
              [-73.28693600199995, -45.322930596999925],
              [-73.27574622299994, -45.32089609199994],
              [-73.26520748599995, -45.32048919099992],
              [-73.25812740799995, -45.319024346999925],
              [-73.25218665299991, -45.31568775799991],
              [-73.24535071499992, -45.3103166649999],
              [-73.22642981699994, -45.30087655999995],
              [-73.20864824099993, -45.30217864399992],
              [-73.19294186099995, -45.31178150799991],
              [-73.18008378799993, -45.32708098799992],
              [-73.17666581899994, -45.33521900799991],
              [-73.17271887899994, -45.35230885199991],
              [-73.16710364499994, -45.36191171699994],
              [-73.16197669199994, -45.36565520599993],
              [-73.13914954299992, -45.37558359199994],
              [-73.10545813699991, -45.398695570999905],
              [-73.08788001199991, -45.40667083099993],
              [-73.06688391799992, -45.40960051899992],
              [-73.04478919199994, -45.41619231599992],
              [-73.01431230399993, -45.44475676899992],
              [-72.9915258449999, -45.45126718499995],
              [-72.90404212099992, -45.464776299999926],
              [-72.85952714799993, -45.46445077899995],
              [-72.85802161399994, -45.44378020599993],
              [-72.83775794199994, -45.427992445999905],
              [-72.83063717399995, -45.41806405999995],
              [-72.83438066299993, -45.406182549999926],
              [-72.84520423099991, -45.396416924999926],
              [-72.85846920499995, -45.38925546699994],
              [-72.8743383449999, -45.38616301899992],
              [-72.89281165299991, -45.38925546699994],
              [-72.9043676419999, -45.394789320999905],
              [-72.91397050699993, -45.40154387799993],
              [-72.92491614499994, -45.407321872999944],
              [-72.94054114499994, -45.40960051899992],
              [-72.9551488919999, -45.40837981599992],
              [-72.98151607999995, -45.40097421699994],
              [-73.07909094999991, -45.35475025799991],
              [-73.17666581899994, -45.28167083099993],
              [-73.21629798099991, -45.258884372999944],
              [-73.25666256399995, -45.24822356599992],
              [-73.2962133449999, -45.25945403399993],
              [-73.32896887899994, -45.28394947699991],
              [-73.34642493399991, -45.29062265399995],
              [-73.37535559799994, -45.292901299999926],
              [-73.39879309799994, -45.29176197699991],
              [-73.42520097599993, -45.28769296699994],
              [-73.44806881399995, -45.27947356599992],
              [-73.46068274599992, -45.266289971999925],
              [-73.46263587099992, -45.24618905999995],
              [-73.45881100199995, -45.220961195999905],
              [-73.45006262899994, -45.199476820999905],
              [-73.43712317599994, -45.19060637799993],
              [-73.38272050699993, -45.194024346999925],
              [-73.35594641799992, -45.19068775799991],
              [-73.33096269399994, -45.1775041649999],
              [-73.33234615799995, -45.1618791649999],
              [-73.31704667899993, -45.15398528399993],
              [-73.30443274599992, -45.144789320999905],
              [-73.31387285099993, -45.125664971999925],
              [-73.33169511599993, -45.10906340899993],
              [-73.33775794199994, -45.10173919099992],
              [-73.33828691299993, -45.094414971999925],
              [-73.33482825399994, -45.087823174999926],
              [-73.33706620999993, -45.083103122999944],
              [-73.35484778599994, -45.08131275799991],
              [-73.37018795499995, -45.07545338299991],
              [-73.38609778599994, -45.06145598799992],
              [-73.39924068899995, -45.04338958099993],
              [-73.40607662699995, -45.026055596999925],
              [-73.40526282499991, -45.006117445999905],
              [-73.3977758449999, -44.988213799999926],
              [-73.38581295499995, -44.973728122999944],
              [-73.37193762899994, -44.96404387799993],
              [-73.34825598899994, -44.95777760199991],
              [-73.23436438699991, -44.96526458099993],
              [-73.22109941299993, -44.96404387799993],
              [-73.20995032499991, -44.96021900799991],
              [-73.19050045499995, -44.94850025799991],
              [-73.18008378799993, -44.94410572699991],
              [-73.15855872299994, -44.94304778399993],
              [-73.11709550699993, -44.948337497999944],
              [-73.10130774599992, -44.94068775799991],
              [-73.08385169199994, -44.92392343499995],
              [-73.02928626199991, -44.88941822699991],
              [-73.00706946499992, -44.865492445999905],
              [-72.99828040299991, -44.861586195999905],
              [-72.95702063699991, -44.861586195999905],
              [-72.93565833199995, -44.857679945999905],
              [-72.91478430899991, -44.84783294099992],
              [-72.81004798099991, -44.76775481599992],
              [-72.76634680899991, -44.750664971999925],
              [-72.72765051999994, -44.75855885199991],
              [-72.72386633999992, -44.74627044099992],
              [-72.71068274599992, -44.73316822699991],
              [-72.70718339799993, -44.72503020599993],
              [-72.71003170499995, -44.71738046699994],
              [-72.72427324099993, -44.70077890399995],
              [-72.72765051999994, -44.694024346999925],
              [-72.73151607999995, -44.67424895599993],
              [-72.72915605399993, -44.66562265399995],
              [-72.70824133999992, -44.6423479149999],
              [-72.70360266799992, -44.63437265399995],
              [-72.68578040299991, -44.580336195999905],
              [-72.68150794199994, -44.56015390399995],
              [-72.67983964799993, -44.54355234199994],
              [-72.66901607999995, -44.53199635199991],
              [-72.64403235599991, -44.51921965899993],
              [-72.6165258449999, -44.50896575299993],
              [-72.59797115799995, -44.50530364399992],
              [-72.61815344999991, -44.46526458099993],
              [-72.61595618399991, -44.42156340899993],
              [-72.5911352199999, -44.34075286299992],
              [-72.59483801999994, -44.35019296699994],
              [-72.61156165299991, -44.37151458099993],
              [-72.61522376199991, -44.37151458099993],
              [-72.63011633999992, -44.391289971999925],
              [-72.63206946499992, -44.39544036299992],
              [-72.64256751199991, -44.40545012799993],
              [-72.64948482999995, -44.408135674999926],
              [-72.66250566299993, -44.40911223799992],
              [-72.66641191299993, -44.41301848799992],
              [-72.66087805899991, -44.43254973799992],
              [-72.66250566299993, -44.440118096999925],
              [-72.67247473899994, -44.45435963299991],
              [-72.68675696499992, -44.48845794099992],
              [-72.69969641799992, -44.49846770599993],
              [-72.72191321499992, -44.50139739399992],
              [-72.73448645699995, -44.494805596999925],
              [-72.74006100199995, -44.48056405999995],
              [-72.74132239499994, -44.46062590899993],
              [-72.75023352799991, -44.4489885399999],
              [-72.77106686099995, -44.439385674999926],
              [-72.79503333199995, -44.432712497999944],
              [-72.81334387899994, -44.43027109199994],
              [-72.81720943899995, -44.42742278399993],
              [-72.83751380099994, -44.40911223799992],
              [-72.84845943899995, -44.40243905999995],
              [-72.92463131399995, -44.373711846999925],
              [-72.93374589799993, -44.36467864399992],
              [-72.93053137899994, -44.346368096999925],
              [-72.92577063699991, -44.33277760199991],
              [-72.92658443899995, -44.320570570999905],
              [-72.93993079299992, -44.30673593499995],
              [-72.96133378799993, -44.298760674999926],
              [-73.01390540299991, -44.29216887799993],
              [-73.05158443899995, -44.273370049999926],
              [-73.15953528599994, -44.260430596999925],
              [-73.17227128799993, -44.256117445999905],
              [-73.18350175699993, -44.24814218499995],
              [-73.1887914699999, -44.24163176899992],
              [-73.19273841099994, -44.23365650799991],
              [-73.19204667899993, -44.226820570999905],
              [-73.13914954299992, -44.21054452899995],
              [-73.12218176999994, -44.1892229149999],
              [-73.11864173099991, -44.18320077899995],
              [-73.1184789699999, -44.15911223799992],
              [-73.12808183499993, -44.14576588299991],
              [-73.13975989499994, -44.145196221999925],
              [-73.15330969999991, -44.17734140399995],
              [-73.17296301999994, -44.18914153399993],
              [-73.19766191299993, -44.19548919099992],
              [-73.22109941299993, -44.19687265399995],
              [-73.24510657499991, -44.194431247999944],
              [-73.26732337099992, -44.187432549999926],
              [-73.28359941299993, -44.174086195999905],
              [-73.29002844999991, -44.15243905999995],
              [-73.28693600199995, -44.12346770599993],
              [-73.27774003799993, -44.110039971999925],
              [-73.26260331899994, -44.108493747999944],
              [-73.24156653599994, -44.11492278399993],
              [-73.23452714799993, -44.12070077899995],
              [-73.22793535099993, -44.12737395599993],
              [-73.22301184799994, -44.12704843499995],
              [-73.22109941299993, -44.11150481599992],
              [-73.22109941299993, -44.07732512799993],
              [-73.21540279899995, -44.06796640399995],
              [-73.20177161399994, -44.06145598799992],
              [-73.18590247299994, -44.05868905999995],
              [-73.17332923099991, -44.059665622999944],
              [-73.16836503799993, -44.06406015399995],
              [-73.15982011599993, -44.080010674999926],
              [-73.15282141799992, -44.08757903399993],
              [-73.12718665299991, -44.09685637799993],
              [-73.11611894399994, -44.0857072899999],
              [-73.11579342399995, -44.06853606599992],
              [-73.12214107999995, -44.059665622999944],
              [-73.13280188699991, -44.0485979149999],
              [-73.13805091099994, -44.024102471999925],
              [-73.13914954299992, -43.98512135199991],
              [-73.13206946499992, -43.96803150799991],
              [-73.12035071499992, -43.95208098799992],
              [-73.09447180899991, -43.92652760199991],
              [-73.08397376199991, -43.9196916649999],
              [-73.07664954299992, -43.91806405999995],
              [-73.07042395699995, -43.91448333099993],
              [-73.06346594999991, -43.90203215899993],
              [-73.06175696499992, -43.89316171699994],
              [-73.06236731699994, -43.88404713299991],
              [-73.06191972599993, -43.87379322699991],
              [-73.05724036399994, -43.86101653399993],
              [-73.03075110599991, -43.826836846999925],
              [-73.02000891799992, -43.80828215899993],
              [-73.01561438699991, -43.78248463299991],
              [-73.01268469999991, -43.772149346999925],
              [-73.00584876199991, -43.774102471999925],
              [-72.99453691299993, -43.78590260199991],
              [-72.98936926999994, -43.79583098799992],
              [-72.98843339799993, -43.80584075299993],
              [-72.9837133449999, -43.81454843499995],
              [-72.96727454299992, -43.8200822899999],
              [-72.95128333199995, -43.80364348799992],
              [-72.92686926999994, -43.78728606599992],
              [-72.89891516799992, -43.77695077899995],
              [-72.87230383999992, -43.7790666649999],
              [-72.86693274599992, -43.78630950299993],
              [-72.86302649599992, -43.79778411299992],
              [-72.8567602199999, -43.808526299999926],
              [-72.84406490799995, -43.81324635199991],
              [-72.83063717399995, -43.81194426899992],
              [-72.82461503799993, -43.80787525799991],
              [-72.82591712099992, -43.80046965899993],
              [-72.84410559799994, -43.77548593499995],
              [-72.84959876199991, -43.75920989399992],
              [-72.85155188699991, -43.7400041649999],
              [-72.85057532499991, -43.71697356599992],
              [-72.84386145699995, -43.70037200299993],
              [-72.84227454299992, -43.689711195999905],
              [-72.84715735599991, -43.6794572899999],
              [-72.85407467399995, -43.67888762799993],
              [-72.85732988199993, -43.69019947699991],
              [-72.85912024599992, -43.70476653399993],
              [-72.86143958199995, -43.713555596999925],
              [-72.86799068899995, -43.72380950299993],
              [-72.87096106699994, -43.73406340899993],
              [-72.87531490799995, -43.74342213299991],
              [-72.88589433499993, -43.75115325299993],
              [-72.89688066299993, -43.75310637799993],
              [-72.92218990799995, -43.75074635199991],
              [-72.93374589799993, -43.75115325299993],
              [-72.94513912699995, -43.75505950299993],
              [-72.95946204299992, -43.76384856599992],
              [-72.97093665299991, -43.7653947899999],
              [-72.97935950399994, -43.76116301899992],
              [-72.98867753799993, -43.74187590899993],
              [-72.99828040299991, -43.73748137799993],
              [-73.02415930899991, -43.735446872999944],
              [-73.0423070949999, -43.729587497999944],
              [-73.04588782499991, -43.728448174999926],
              [-73.05524654899995, -43.71559010199991],
              [-73.04356848899994, -43.695977471999925],
              [-73.02521725199995, -43.68523528399993],
              [-73.00462805899991, -43.677666924999926],
              [-72.98786373599995, -43.66643645599993],
              [-72.97301184799994, -43.621351820999905],
              [-72.95343990799995, -43.61492278399993],
              [-72.92886308499993, -43.61419036299992],
              [-72.90583248599995, -43.607679945999905],
              [-72.91710364499994, -43.58863697699991],
              [-72.93297278599994, -43.585870049999926],
              [-72.97777258999992, -43.59417083099993],
              [-73.00719153599994, -43.59270598799992],
              [-73.02603105399993, -43.58668385199991],
              [-73.03872636599993, -43.574151299999926],
              [-73.06822669199994, -43.513929945999905],
              [-73.07994544199994, -43.49627044099992],
              [-73.11131751199991, -43.46103280999995],
              [-73.11180579299992, -43.443291924999926],
              [-73.09080969999991, -43.40243905999995],
              [-73.0852758449999, -43.38250090899993],
              [-73.08458411399994, -43.316338799999926],
              [-73.07591712099992, -43.30136484199994],
              [-73.05573482999995, -43.28866952899995],
              [-72.95466061099995, -43.247165622999944],
              [-72.93004309799994, -43.244073174999926],
              [-72.9121801419999, -43.235446872999944],
              [-72.9063207669999, -43.21493905999995],
              [-72.90811113199993, -43.190118096999925],
              [-72.91323808499993, -43.169040622999944],
              [-72.93032792899993, -43.12460702899995],
              [-72.93443762899994, -43.09823984199994],
              [-72.92292232999995, -43.08635833099993],
              [-72.90746008999992, -43.07756926899992],
              [-72.86485755099994, -43.01873137799993],
              [-72.84805253799993, -43.01091887799993],
              [-72.82506262899994, -43.00750090899993],
              [-72.80467688699991, -43.013929945999905],
              [-72.78986568899995, -43.0544572899999],
              [-72.77452551999994, -43.06764088299991],
              [-72.75454667899993, -43.0759416649999],
              [-72.73448645699995, -43.07968515399995],
              [-72.75658118399991, -43.035088799999926],
              [-72.7610570949999, -43.00904713299991],
              [-72.75157630099994, -42.98772551899992],
              [-72.7500707669999, -42.97893645599993],
              [-72.74714107999995, -42.90976327899995],
              [-72.75316321499992, -42.90081145599993],
              [-72.76862545499995, -42.8884416649999],
              [-72.82144120999993, -42.85751718499995],
              [-72.84219316299993, -42.83806731599992],
              [-72.85057532499991, -42.809665622999944],
              [-72.85252844999991, -42.79355234199994],
              [-72.86485755099994, -42.75123463299991],
              [-72.86400305899991, -42.73723723799992],
              [-72.86115475199995, -42.72478606599992],
              [-72.86001542899993, -42.71168385199991],
              [-72.86485755099994, -42.69654713299991],
              [-72.83556067599994, -42.68808359199994],
              [-72.82701575399994, -42.68027109199994],
              [-72.82384192599994, -42.66529713299991],
              [-72.82909094999991, -42.652601820999905],
              [-72.85496985599991, -42.63355885199991],
              [-72.86485755099994, -42.6208635399999],
              [-72.86705481699994, -42.59042734199994],
              [-72.85680091099994, -42.55592213299991],
              [-72.84032141799992, -42.52483489399992],
              [-72.82384192599994, -42.504164320999905],
              [-72.79552161399994, -42.49382903399993],
              [-72.75357011599993, -42.49187590899993],
              [-72.71076412699995, -42.496026299999926],
              [-72.67983964799993, -42.504164320999905],
              [-72.66734778599994, -42.51262786299992],
              [-72.65416419199994, -42.524102471999925],
              [-72.63914954299992, -42.53411223799992],
              [-72.60655676999994, -42.54265715899993],
              [-72.57966061099995, -42.56129322699991],
              [-72.56314042899993, -42.56568775799991],
              [-72.53941809799994, -42.55828215899993],
              [-72.54133053299995, -42.54159921699994],
              [-72.55846106699994, -42.52483489399992],
              [-72.58055579299992, -42.51726653399993],
              [-72.60212154899995, -42.514336846999925],
              [-72.65876217399995, -42.49114348799992],
              [-72.67845618399991, -42.478448174999926],
              [-72.71776282499991, -42.43254973799992],
              [-72.72223873599995, -42.42245859199994],
              [-72.7161352199999, -42.40056731599992],
              [-72.72142493399991, -42.38811614399992],
              [-72.72972571499992, -42.3845354149999],
              [-72.75348873599995, -42.38372161299992],
              [-72.76244055899991, -42.38128020599993],
              [-72.77306067599994, -42.36581796699994],
              [-72.79112708199995, -42.3161760399999],
              [-72.79283606699994, -42.30559661299992],
              [-72.81407630099994, -42.30543385199991],
              [-72.83413652299993, -42.30291106599992],
              [-72.84630286399994, -42.294854424999926],
              [-72.84373938699991, -42.27825286299992],
              [-72.80972245999993, -42.243259372999944],
              [-72.76585852799991, -42.22698333099993],
              [-72.67300370999993, -42.20940520599993],
              [-72.61994381399995, -42.18474700299993],
              [-72.59455318899995, -42.18206145599993],
              [-72.57217363199993, -42.19060637799993],
              [-72.5579320949999, -42.21111419099992],
              [-72.45616614499994, -42.44085051899992],
              [-72.44033769399994, -42.458916924999926],
              [-72.42601477799991, -42.46298593499995],
              [-72.41978919199994, -42.43962981599992],
              [-72.42650305899991, -42.39617278399993],
              [-72.44029700399994, -42.35409921699994],
              [-72.45079505099994, -42.33928801899992],
              [-72.46442623599995, -42.32431405999995],
              [-72.47618567599994, -42.30779387799993],
              [-72.48131262899994, -42.28850676899992],
              [-72.47350012899994, -42.269789320999905],
              [-72.45482337099992, -42.258884372999944],
              [-72.43219967399995, -42.249932549999926],
              [-72.41234290299991, -42.237399997999944],
              [-72.43797766799992, -42.237399997999944],
              [-72.46003170499995, -42.234307549999926],
              [-72.47541256399995, -42.22307708099993],
              [-72.48131262899994, -42.199151299999926],
              [-72.47691809799994, -42.173760674999926],
              [-72.46515865799995, -42.16350676899992],
              [-72.44758053299995, -42.1579729149999],
              [-72.42601477799991, -42.14723072699991],
              [-72.44277910099993, -42.14413827899995],
              [-72.46011308499993, -42.14299895599993],
              [-72.4759008449999, -42.138929945999905],
              [-72.48802649599992, -42.12753671699994],
              [-72.49014238199993, -42.11687590899993],
              [-72.48985755099994, -42.08025481599992],
              [-72.48802649599992, -42.064711195999905],
              [-72.46255449099993, -41.98552825299993],
              [-72.46434485599991, -41.97616952899995],
              [-72.48468990799995, -41.959242445999905],
              [-72.51720130099994, -41.9509416649999],
              [-72.54100501199991, -41.97779713299991],
              [-72.56065833199995, -42.0134416649999],
              [-72.58055579299992, -42.031182549999926],
              [-72.60826575399994, -42.033135674999926],
              [-72.61778723899994, -42.031182549999926],
              [-72.6262914699999, -42.01604583099993],
              [-72.63304602799991, -42.0095354149999],
              [-72.65465247299994, -42.020603122999944],
              [-72.66759192599994, -42.01572030999995],
              [-72.67886308499993, -42.005791924999926],
              [-72.68667558499993, -41.997165622999944],
              [-72.71011308499993, -42.015557549999926],
              [-72.73729407499991, -42.013929945999905],
              [-72.81607011599993, -41.97909921699994],
              [-72.82664954299992, -41.97234465899993],
              [-72.83751380099994, -41.96233489399992],
              [-72.8399145169999, -41.95761484199994],
              [-72.84117591099994, -41.94654713299991],
              [-72.84373938699991, -41.94182708099993],
              [-72.85033118399991, -41.937432549999926],
              [-72.86497962099992, -41.93254973799992],
              [-72.87230383999992, -41.928806247999944],
              [-72.88027910099993, -41.92327239399992],
              [-72.8880102199999, -41.91659921699994],
              [-72.88857988199993, -41.910821221999925],
              [-72.86359615799995, -41.90593840899993],
              [-72.85448157499991, -41.89983489399992],
              [-72.84064693899995, -41.88445403399993],
              [-72.83551998599995, -41.88144296699994],
              [-72.82115637899994, -41.87664153399993],
              [-72.81704667899993, -41.87420012799993],
              [-72.81623287699995, -41.86972421699994],
              [-72.81802324099993, -41.85800546699994],
              [-72.81704667899993, -41.85369231599992],
              [-72.80919348899994, -41.84514739399992],
              [-72.72036699099993, -41.778415622999944],
              [-72.70348059799994, -41.77117278399993],
              [-72.69180253799993, -41.76441822699991],
              [-72.66331946499992, -41.732679945999905],
              [-72.64513098899994, -41.72283294099992],
              [-72.62035071499992, -41.723321221999925],
              [-72.59471594999991, -41.728773695999905],
              [-72.56948808499993, -41.73056405999995],
              [-72.53425045499995, -41.71363697699991],
              [-72.52179928299995, -41.713962497999944],
              [-72.50869706899994, -41.71624114399992],
              [-72.49494381399995, -41.7165666649999],
              [-72.48379472599993, -41.713555596999925],
              [-72.46076412699995, -41.702243747999944],
              [-72.42467200399994, -41.696384372999944],
              [-72.4160863919999, -41.69231536299992],
              [-72.38194739499994, -41.66814544099992],
              [-72.37657630099994, -41.66545989399992],
              [-72.36046301999994, -41.65276458099993],
              [-72.3509008449999, -41.6482072899999],
              [-72.33958899599992, -41.64690520599993],
              [-72.30308997299994, -41.6482072899999],
              [-72.32872473899994, -41.63551197699991],
              [-72.33800208199995, -41.62769947699991],
              [-72.34341386599993, -41.61296965899993],
              [-72.34170488199993, -41.60019296699994],
              [-72.32359778599994, -41.565118096999925],
              [-72.32306881399995, -41.55877044099992],
              [-72.32469641799992, -41.54452890399995],
              [-72.32359778599994, -41.53834400799991],
              [-72.30614173099991, -41.52857838299991],
              [-72.30308997299994, -41.524102471999925],
              [-72.30724036399994, -41.51189544099992],
              [-72.32542883999992, -41.49358489399992],
              [-72.33043372299994, -41.48316822699991],
              [-72.32510331899994, -41.456963799999926],
              [-72.29987545499995, -41.40520598799992],
              [-72.30308997299994, -41.380791924999926],
              [-72.32135982999995, -41.367445570999905],
              [-72.33922278599994, -41.37151458099993],
              [-72.34414628799993, -41.38681405999995],
              [-72.32359778599994, -41.4079729149999],
              [-72.32970130099994, -41.420993747999944],
              [-72.34479732999995, -41.442071221999925],
              [-72.3509008449999, -41.45582447699991],
              [-72.37267005099994, -41.590101820999905],
              [-72.38194739499994, -41.60979583099993],
              [-72.39053300699993, -41.62070077899995],
              [-72.40689042899993, -41.646742445999905],
              [-72.4160863919999, -41.65829843499995],
              [-72.42617753799993, -41.663995049999926],
              [-72.45860755099994, -41.67343515399995],
              [-72.52098548099991, -41.681898695999905],
              [-72.53278561099995, -41.685479424999926],
              [-72.54279537699995, -41.69280364399992],
              [-72.57241777299993, -41.70671965899993],
              [-72.58429928299995, -41.70973072699991],
              [-72.6094457669999, -41.70671965899993],
              [-72.65054277299993, -41.68718840899993],
              [-72.66966712099992, -41.68238697699991],
              [-72.67747962099992, -41.6735979149999],
              [-72.68610592399995, -41.63005950299993],
              [-72.69351152299993, -41.61296965899993],
              [-72.72793535099993, -41.59042734199994],
              [-72.73106848899994, -41.586195570999905],
              [-72.7363988919999, -41.58123137799993],
              [-72.75157630099994, -41.54843515399995],
              [-72.75885982999995, -41.54387786299992],
              [-72.78970292899993, -41.53093840899993],
              [-72.81932532499991, -41.50896575299993],
              [-72.8430883449999, -41.49968840899993],
              [-72.85387122299994, -41.497165622999944],
              [-72.86440995999993, -41.498711846999925],
              [-72.87539628799993, -41.50709400799991],
              [-72.88556881399995, -41.511651299999926],
              [-72.89537512899994, -41.50750090899993],
              [-72.90371660099993, -41.50042083099993],
              [-72.90953528599994, -41.49684010199991],
              [-72.93553626199991, -41.48552825299993],
              [-72.94737708199995, -41.48316822699991],
              [-72.95726477799991, -41.48357512799993],
              [-72.97801388899995, -41.5157371599999],
              [-73.02206288799994, -41.51466222899995],
              [-73.03590123099991, -41.52922436499995],
              [-73.03557638799992, -41.55684279199994],
              [-73.07713782499991, -41.565118096999925],
              [-73.08633378799993, -41.570245049999926],
              [-73.09544837099992, -41.57268645599993],
              [-73.10411536399994, -41.57659270599993],
              [-73.11188717399995, -41.586195570999905],
              [-73.10610917899993, -41.590915622999944],
              [-73.09642493399991, -41.60214609199994],
              [-73.09080969999991, -41.60670338299991],
              [-73.09410559799994, -41.61052825299993],
              [-73.09557044199994, -41.61370208099993],
              [-73.09650631399995, -41.61663176899992],
              [-73.09825598899994, -41.62029387799993],
              [-73.0801488919999, -41.62769947699991],
              [-73.07453365799995, -41.63681405999995],
              [-73.07713782499991, -41.665134372999944],
              [-73.07237708199995, -41.67400481599992],
              [-73.06371008999992, -41.68645598799992],
              [-73.05919348899994, -41.69744231599992],
              [-73.06688391799992, -41.702243747999944],
              [-73.08861243399991, -41.70427825299993],
              [-73.09972083199995, -41.71054452899995],
              [-73.11864173099991, -41.736993096999925],
              [-73.12922115799995, -41.74749114399992],
              [-73.14171301999994, -41.75481536299992],
              [-73.15636145699995, -41.75676848799992],
              [-73.17332923099991, -41.750664971999925],
              [-73.20140540299991, -41.78476327899995],
              [-73.27627519399994, -41.78411223799992],
              [-73.36318925699993, -41.77353280999995],
              [-73.42715410099993, -41.778008721999925],
              [-73.42381751199991, -41.78281015399995],
              [-73.42174231699994, -41.78655364399992],
              [-73.41881262899994, -41.78948333099993],
              [-73.41291256399995, -41.79225025799991],
              [-73.41291256399995, -41.79851653399993],
              [-73.43541419199994, -41.793226820999905],
              [-73.45543372299994, -41.795993747999944],
              [-73.49486243399991, -41.80592213299991],
              [-73.51504472599993, -41.80364348799992],
              [-73.57054602799991, -41.778008721999925],
              [-73.65998287699995, -41.75750090899993],
              [-73.73534094999991, -41.75448984199994],
              [-73.75994602599991, -41.74884134899992],
              [-73.7546631109999, -41.74095640399992],
              [-73.74057544899995, -41.735706233999906],
              [-73.72825314399995, -41.726509036999914],
              [-73.71066366299993, -41.697597696999935],
              [-73.70011595499994, -41.681825131999915],
              [-73.69836762299991, -41.66868028099992],
              [-73.69486121599994, -41.65158802099995],
              [-73.69663178799993, -41.637124513999936],
              [-73.68394934799994, -41.62704843499995],
              [-73.66893469999991, -41.61663176899992],
              [-73.63947506399995, -41.61296965899993],
              [-73.58189856699994, -41.61484140399995],
              [-73.5547582669999, -41.608493747999944],
              [-73.54328365799995, -41.58928801899992],
              [-73.53600012899994, -41.56650155999995],
              [-73.50340735599991, -41.52988046699994],
              [-73.49486243399991, -41.510430596999925],
              [-73.52769934799994, -41.53728606599992],
              [-73.54784094999991, -41.56658294099992],
              [-73.5716039699999, -41.590101820999905],
              [-73.61522376199991, -41.599867445999905],
              [-73.62661699099993, -41.59807708099993],
              [-73.64793860599991, -41.58912525799991],
              [-73.65998287699995, -41.586195570999905],
              [-73.66763261599993, -41.58684661299992],
              [-73.68492591099994, -41.59140390399995],
              [-73.69408118399991, -41.59238046699994],
              [-73.71349036399994, -41.58912525799991],
              [-73.74494381399995, -41.57561614399992],
              [-73.75890051999994, -41.572523695999905],
              [-73.76618404899995, -41.56991952899995],
              [-73.77041581899994, -41.56454843499995],
              [-73.77497311099995, -41.5603166649999],
              [-73.78282630099994, -41.56170012799993],
              [-73.78742428299995, -41.56365325299993],
              [-73.79271399599992, -41.565118096999925],
              [-73.7981664699999, -41.56568775799991],
              [-73.80680348999994, -41.55623317499993],
              [-73.81028697499994, -41.545709590999934],
              [-73.79973752799992, -41.53520051999993],
              [-73.80147361299993, -41.523368443999914],
              [-73.81369517799993, -41.49706427099994],
              [-73.84171261999995, -41.46681986199991],
              [-73.84865061999994, -41.44052934699994],
              [-73.8538394389999, -41.42211828399991],
              [-73.84318468399994, -41.39584873199993],
              [-73.84121670299993, -41.33282054199992],
              [-73.85482280799994, -41.27904908499994],
              [-73.87407446399993, -41.22780855599996],
              [-73.89495775099994, -41.184437164999906],
              [-73.91966475399994, -41.152697935999925],
              [-73.91399399199992, -41.134534568999925],
              [-73.91749529799995, -41.11611461299992],
              [-73.93168451999992, -41.09488354399991],
              [-73.92989280299992, -41.07517352799994],
              [-73.94058512099991, -41.04996438999996],
              [-73.93692855199993, -41.02111299199993],
              [-73.9406754229999, -40.99395457999992],
              [-73.94690423799995, -40.97284059799995],
              [-73.93797344799992, -40.959485936999954],
              [-73.92607006199995, -40.95392728199994],
              [-73.90211447699994, -40.94948337199992],
              [-73.89191206499993, -40.93726202199991],
              [-73.87256230199995, -40.93060261699992],
              [-73.85464036899992, -40.91616273999995],
              [-73.8562177519999, -40.90169782399994],
              [-73.87418317599992, -40.889409877999924],
              [-73.88894652099992, -40.87824853799992],
              [-73.89322978299992, -40.86378244399992],
              [-73.89022173799992, -40.85266292199992],
              [-73.87976977199992, -40.84046072599995],
              [-73.87080176899991, -40.82047051699993],
              [-73.87093706399992, -40.794820976999915],
              [-73.86217915599991, -40.7647142589999],
              [-73.84564734799994, -40.739308198999936],
              [-73.82801827499992, -40.71594909099991],
              [-73.80888528199995, -40.70598594799992],
              [-73.8222450529999, -40.69026609799994],
              [-73.83850411199995, -40.67678856999993],
              [-73.84149523299993, -40.6667067649999],
              [-73.83125513999994, -40.65776204899993],
              [-73.82101918699993, -40.641002011999944],
              [-73.80483272399994, -40.63101373299992],
              [-73.76070146799992, -40.60775881699993],
              [-73.7490167169999, -40.574265186999924],
              [-73.72849765799992, -40.54418016299991],
              [-73.73733003299992, -40.52294376399993],
              [-73.7481176419999, -40.5036760399999],
              [-73.74815833199995, -40.48837655999995],
              [-73.75133216099994, -40.475681247999944],
              [-73.76231848899994, -40.45525481599992],
              [-73.76939856699994, -40.44784921699994],
              [-73.77599036399994, -40.44345468499995],
              [-73.78091386599993, -40.4372697899999],
              [-73.78282630099994, -40.42457447699991],
              [-73.77965247299994, -40.41545989399992],
              [-73.76553300699993, -40.40162525799991],
              [-73.76231848899994, -40.39023202899995],
              [-73.76292883999992, -40.347588799999926],
              [-73.76109778599994, -40.32781340899993],
              [-73.74864661399994, -40.27304452899995],
              [-73.7481176419999, -40.260430596999925],
              [-73.74600175699993, -40.24944426899992],
              [-73.73713131399995, -40.23137786299992],
              [-73.73306230399993, -40.219821872999944],
              [-73.72411048099991, -40.21453215899993],
              [-73.72142493399991, -40.208916924999926],
              [-73.72207597599993, -40.20370859199994],
              [-73.72435462099992, -40.19784921699994],
              [-73.72704016799992, -40.19394296699994],
              [-73.72883053299995, -40.195245049999926],
              [-73.72935950399994, -40.18954843499995],
              [-73.73485266799992, -40.180352471999925],
              [-73.73501542899993, -40.17473723799992],
              [-73.71873938699991, -40.16529713299991],
              [-73.71458899599992, -40.16106536299992],
              [-73.69912675699993, -40.13176848799992],
              [-73.69782467399995, -40.12639739399992],
              [-73.68663489499994, -40.12639739399992],
              [-73.67422441299993, -40.12509530999995],
              [-73.66405188699991, -40.12029387799993],
              [-73.65998287699995, -40.10955169099992],
              [-73.66405188699991, -40.067071221999925],
              [-73.66852779899995, -40.04566822699991],
              [-73.67357337099992, -40.03085702899995],
              [-73.70026607999995, -39.999932549999926],
              [-73.7141820949999, -39.978448174999926],
              [-73.71117102799991, -39.968682549999926],
              [-73.70152747299994, -39.96412525799991],
              [-73.68321692599994, -39.942478122999944],
              [-73.67357337099992, -39.93450286299992],
              [-73.66234290299991, -39.931898695999905],
              [-73.63263912699995, -39.93450286299992],
              [-73.61148027299993, -39.92620208099993],
              [-73.58283443899995, -39.90471770599993],
              [-73.53746497299994, -39.89690520599993],
              [-73.51707923099991, -39.88762786299992],
              [-73.49852454299992, -39.87428150799991],
              [-73.48180091099994, -39.85881926899992],
              [-73.4668676419999, -39.83993905999995],
              [-73.45840410099993, -39.8337541649999],
              [-73.44395911399994, -39.83147551899992],
              [-73.43443762899994, -39.83326588299991],
              [-73.42430579299992, -39.837823174999926],
              [-73.41616777299993, -39.84343840899993],
              [-73.41291256399995, -39.84889088299991],
              [-73.41063391799992, -39.87151458099993],
              [-73.40404212099992, -39.89544036299992],
              [-73.39329993399991, -39.90894947699991],
              [-73.37877356699994, -39.90048593499995],
              [-73.37267005099994, -39.88046640399995],
              [-73.37572180899991, -39.857679945999905],
              [-73.38463294199994, -39.83652109199994],
              [-73.39610755099994, -39.821384372999944],
              [-73.40192623599995, -39.80413176899992],
              [-73.39500891799992, -39.78281015399995],
              [-73.38426673099991, -39.76100025799991],
              [-73.37877356699994, -39.74277109199994],
              [-73.38565019399994, -39.72226327899995],
              [-73.39867102799991, -39.708103122999944],
              [-73.40607662699995, -39.69491952899995],
              [-73.39610755099994, -39.67791106599992],
              [-73.35903886599993, -39.66415780999995],
              [-73.34630286399994, -39.65593840899993],
              [-73.35826575399994, -39.647149346999925],
              [-73.31688391799992, -39.60670338299991],
              [-73.29796301999994, -39.582696221999925],
              [-73.29002844999991, -39.560804945999905],
              [-73.28807532499991, -39.551039320999905],
              [-73.28282630099994, -39.53875090899993],
              [-73.27505449099993, -39.52809010199991],
              [-73.26549231699994, -39.523695570999905],
              [-73.26276607999995, -39.51832447699991],
              [-73.26056881399995, -39.506931247999944],
              [-73.25487219999991, -39.49504973799992],
              [-73.24156653599994, -39.48951588299991],
              [-73.25177975199995, -39.46843840899993],
              [-73.24998938699991, -39.450290622999944],
              [-73.23981686099995, -39.43368905999995],
              [-73.22447669199994, -39.41725025799991],
              [-73.22594153599994, -39.41057708099993],
              [-73.24502519399994, -39.39031340899993],
              [-73.24901282499991, -39.37965260199991],
              [-73.24364173099991, -39.369073174999926],
              [-73.23420162699995, -39.363213799999926],
              [-73.22508704299992, -39.356133721999925],
              [-73.22109941299993, -39.341729424999926],
              [-73.22427324099993, -39.3181291649999],
              [-73.23599199099993, -39.27044036299992],
              [-73.23534094999991, -39.24928150799991],
              [-73.21165930899991, -39.21347421699994],
              [-73.20982825399994, -39.19378020599993],
              [-73.23534094999991, -39.18092213299991],
              [-73.23298092399995, -39.20663827899995],
              [-73.23814856699994, -39.22210051899992],
              [-73.2454320949999, -39.22128671699994],
              [-73.25210527299993, -39.17791106599992],
              [-73.26577714799993, -39.14348723799992],
              [-73.28343665299991, -39.075290622999944],
              [-73.36131751199991, -38.9138322899999],
              [-73.43342037699995, -38.68694426899992],
              [-73.44082597599993, -38.68694426899992],
              [-73.4375707669999, -38.73357512799993],
              [-73.42715410099993, -38.77629973799992],
              [-73.43748938699991, -38.77206796699994],
              [-73.44505774599992, -38.76140715899993],
              [-73.45449785099993, -38.73479583099993],
              [-73.45759029899995, -38.71453215899993],
              [-73.45848548099991, -38.693617445999905],
              [-73.46153723899994, -38.673760674999926],
              [-73.48322506399995, -38.63746510199991],
              [-73.50230872299994, -38.570977471999925],
              [-73.51561438699991, -38.53915780999995],
              [-73.52065995999993, -38.52157968499995],
              [-73.52513587099992, -38.475681247999944],
              [-73.54328365799995, -38.42066822699991],
              [-73.54185950399994, -38.39918385199991],
              [-73.52774003799993, -38.35198333099993],
              [-73.52619381399995, -38.34124114399992],
              [-73.53099524599992, -38.33212655999995],
              [-73.52489173099991, -38.32626718499995],
              [-73.51520748599995, -38.32170989399992],
              [-73.5091039699999, -38.31650155999995],
              [-73.50796464799993, -38.30673593499995],
              [-73.52065995999993, -38.26702239399992],
              [-73.51992753799993, -38.257745049999926],
              [-73.51219641799992, -38.24504973799992],
              [-73.50503495999993, -38.2400041649999],
              [-73.49494381399995, -38.234307549999926],
              [-73.48574785099993, -38.22730885199991],
              [-73.48180091099994, -38.21803150799991],
              [-73.46279863199993, -38.091729424999926],
              [-73.4629613919999, -38.05120208099993],
              [-73.47069251199991, -38.01189544099992],
              [-73.5032445949999, -37.93328215899993],
              [-73.55768795499995, -37.84612395599993],
              [-73.62205969999991, -37.75872161299992],
              [-73.63170325399994, -37.751071872999944],
              [-73.65192623599995, -37.74138762799993],
              [-73.65998287699995, -37.73479583099993],
              [-73.66657467399995, -37.72551848799992],
              [-73.66808020699995, -37.719414971999925],
              [-73.66616777299993, -37.662774346999925],
              [-73.66950436099995, -37.65243905999995],
              [-73.68447831899994, -37.63176848799992],
              [-73.68785559799994, -37.62167734199994],
              [-73.68512936099995, -37.59840260199991],
              [-73.67764238199993, -37.57935963299991],
              [-73.66657467399995, -37.56365325299993],
              [-73.65314693899995, -37.549899997999944],
              [-73.61904863199993, -37.52703215899993],
              [-73.60411536399994, -37.512383721999925],
              [-73.59788977799991, -37.49187590899993],
              [-73.59927324099993, -37.44784921699994],
              [-73.60334225199995, -37.42896900799991],
              [-73.61148027299993, -37.41269296699994],
              [-73.67178300699993, -37.36256275799991],
              [-73.68040930899991, -37.34783294099992],
              [-73.67568925699993, -37.32626718499995],
              [-73.65355383999992, -37.29029713299991],
              [-73.64631100199995, -37.26873137799993],
              [-73.64464270699995, -37.201429945999905],
              [-73.63573157499991, -37.1833635399999],
              [-73.62035071499992, -37.166273695999905],
              [-73.60757402299993, -37.15545012799993],
              [-73.59447180899991, -37.15243905999995],
              [-73.57799231699994, -37.158868096999925],
              [-73.56590735599991, -37.17400481599992],
              [-73.55699622299994, -37.18279387799993],
              [-73.54670162699995, -37.18678150799991],
              [-73.54283606699994, -37.18914153399993],
              [-73.50251217399995, -37.20777760199991],
              [-73.47769120999993, -37.20476653399993],
              [-73.46812903599994, -37.20720794099992],
              [-73.46471106699994, -37.215508721999925],
              [-73.46654212099992, -37.225274346999925],
              [-73.46739661399994, -37.234633070999905],
              [-73.46068274599992, -37.2419572899999],
              [-73.44880123599995, -37.24138762799993],
              [-73.42845618399991, -37.22714609199994],
              [-73.40339107999995, -37.236586195999905],
              [-73.38849850199995, -37.23479583099993],
              [-73.36168372299994, -37.22771575299993],
              [-73.31993567599994, -37.22356536299992],
              [-73.28258216099994, -37.21404387799993],
              [-73.23696855399993, -37.19150155999995],
              [-73.2090551419999, -37.16025155999995],
              [-73.17332923099991, -37.07634856599992],
              [-73.17153886599993, -37.02695077899995],
              [-73.17723548099991, -37.01051197699991],
              [-73.17931067599994, -37.00139739399992],
              [-73.18008378799993, -36.990899346999925],
              [-73.17723548099991, -36.985039971999925],
              [-73.15965735599991, -36.96021900799991],
              [-73.15689042899993, -36.94996510199991],
              [-73.14537512899994, -36.833916924999926],
              [-73.15094967399995, -36.80868905999995],
              [-73.1653539699999, -36.79314544099992],
              [-73.18529212099992, -36.78337981599992],
              [-73.20742753799993, -36.775323174999926],
              [-73.19859778599994, -36.763929945999905],
              [-73.18691972599993, -36.75212981599992],
              [-73.17349199099993, -36.74179452899995],
              [-73.15965735599991, -36.73495859199994],
              [-73.14928137899994, -36.746758721999925],
              [-73.13170325399994, -36.73642343499995],
              [-73.12645423099991, -36.71835702899995],
              [-73.15282141799992, -36.706963799999926],
              [-73.13052324099993, -36.677666924999926],
              [-73.12555904899995, -36.66545989399992],
              [-73.1328832669999, -36.64999765399995],
              [-73.12913977799991, -36.6325822899999],
              [-73.12189693899995, -36.614353122999944],
              [-73.11864173099991, -36.59710051899992],
              [-73.09243730399993, -36.61834075299993],
              [-73.09089107999995, -36.687432549999926],
              [-73.07022050699993, -36.71379973799992],
              [-73.05451412699995, -36.71884530999995],
              [-73.03587805899991, -36.72079843499995],
              [-73.01740475199995, -36.71933359199994],
              [-73.0020238919999, -36.71379973799992],
              [-72.98802649599992, -36.70256926899992],
              [-72.98192298099991, -36.69036223799992],
              [-72.98094641799992, -36.65585702899995],
              [-72.97891191299993, -36.6482072899999],
              [-72.97423255099994, -36.64023202899995],
              [-72.96861731699994, -36.633070570999905],
              [-72.96385657499991, -36.62810637799993],
              [-72.95946204299992, -36.62070077899995],
              [-72.96117102799991, -36.61402760199991],
              [-72.96507727799991, -36.60751718499995],
              [-72.97052975199995, -36.59270598799992],
              [-72.98501542899993, -36.5778947899999],
              [-72.9883520169999, -36.57317473799992],
              [-72.98810787699995, -36.52898528399993],
              [-72.98619544199994, -36.521416924999926],
              [-72.98106848899994, -36.51677825299993],
              [-72.97093665299991, -36.51523202899995],
              [-72.9622289699999, -36.51832447699991],
              [-72.96051998599995, -36.52548593499995],
              [-72.96056067599994, -36.53248463299991],
              [-72.95702063699991, -36.53573984199994],
              [-72.94220943899995, -36.53240325299993],
              [-72.93224036399994, -36.52361419099992],
              [-72.92528235599991, -36.51051197699991],
              [-72.90518144399994, -36.455010674999926],
              [-72.89586341099994, -36.43808359199994],
              [-72.88223222599993, -36.42245859199994],
              [-72.87840735599991, -36.41423919099992],
              [-72.87230383999992, -36.378024997999944],
              [-72.86766516799992, -36.3669572899999],
              [-72.85057532499991, -36.34392669099992],
              [-72.84089107999995, -36.32732512799993],
              [-72.83234615799995, -36.30803801899992],
              [-72.82616126199991, -36.287041924999926],
              [-72.82384192599994, -36.26506926899992],
              [-72.83731035099993, -36.19654713299991],
              [-72.83751380099994, -36.17937590899993],
              [-72.83116614499994, -36.16920338299991],
              [-72.81334387899994, -36.15447356599992],
              [-72.80955969999991, -36.14177825299993],
              [-72.8118383449999, -36.13095468499995],
              [-72.82164466099994, -36.11052825299993],
              [-72.82384192599994, -36.100681247999944],
              [-72.81908118399991, -36.081149997999944],
              [-72.79674231699994, -36.04973723799992],
              [-72.78970292899993, -36.02849700299993],
              [-72.79002844999991, -36.01913827899995],
              [-72.79214433499993, -36.0075822899999],
              [-72.79556230399993, -35.9978166649999],
              [-72.80431067599994, -35.98886484199994],
              [-72.80016028599994, -35.97812265399995],
              [-72.79332434799994, -35.967461846999925],
              [-72.78014075399994, -35.95256926899992],
              [-72.68569902299993, -35.88339609199994],
              [-72.67178300699993, -35.865899346999925],
              [-72.66616777299993, -35.846774997999944],
              [-72.61099199099993, -35.81910572699991],
              [-72.59797115799995, -35.81015390399995],
              [-72.58356686099995, -35.770603122999944],
              [-72.58682206899994, -35.72966887799993],
              [-72.60065670499995, -35.69101327899995],
              [-72.64915930899991, -35.607354424999926],
              [-72.65257727799991, -35.586602471999925],
              [-72.64659583199995, -35.56658294099992],
              [-72.63206946499992, -35.55291106599992],
              [-72.53868567599994, -35.49879322699991],
              [-72.52965247299994, -35.49041106599992],
              [-72.50523841099994, -35.44801197699991],
              [-72.48802649599992, -35.41838958099993],
              [-72.49071204299992, -35.404554945999905],
              [-72.49185136599993, -35.39080169099992],
              [-72.48936926999994, -35.37704843499995],
              [-72.48131262899994, -35.363213799999926],
              [-72.46524003799993, -35.352227471999925],
              [-72.44709225199995, -35.34539153399993],
              [-72.43219967399995, -35.33456796699994],
              [-72.42601477799991, -35.31194426899992],
              [-72.42454993399991, -35.28875090899993],
              [-72.41982988199993, -35.26816171699994],
              [-72.41120357999995, -35.24968840899993],
              [-72.39806067599994, -35.233493747999944],
              [-72.36400305899991, -35.20777760199991],
              [-72.28823808499993, -35.16855234199994],
              [-72.25475012899994, -35.14470794099992],
              [-72.23058020699995, -35.11614348799992],
              [-72.21349036399994, -35.08131275799991],
              [-72.20343990799995, -35.04062265399995],
              [-72.19326738199993, -34.90829843499995],
              [-72.18781490799995, -34.88551197699991],
              [-72.17479407499991, -34.8669572899999],
              [-72.15904700399994, -34.84929778399993],
              [-72.14541581899994, -34.82935963299991],
              [-72.13182532499991, -34.78435637799993],
              [-72.12645423099991, -34.778415622999944],
              [-72.10301673099991, -34.76091887799993],
              [-72.09764563699991, -34.750258070999905],
              [-72.09349524599992, -34.7341447899999],
              [-72.06289628799993, -34.67848072699991],
              [-72.05724036399994, -34.65878671699994],
              [-72.05394446499992, -34.56951262799993],
              [-72.04238847599993, -34.50790780999995],
              [-72.04259192599994, -34.4860979149999],
              [-72.0528051419999, -34.44939544099992],
              [-72.05549068899995, -34.42815520599993],
              [-72.04808508999992, -34.40390390399995],
              [-72.03066972599993, -34.38990650799991],
              [-72.01065019399994, -34.3806291649999],
              [-71.99522864499994, -34.37004973799992],
              [-71.98908443899995, -34.3552385399999],
              [-71.98713131399995, -34.335056247999944],
              [-71.98912512899994, -34.254164320999905],
              [-71.99522864499994, -34.21249765399995],
              [-72.00487219999991, -34.197930596999925],
              [-72.0188695949999, -34.1814104149999],
              [-72.02684485599991, -34.16269296699994],
              [-72.01854407499991, -34.14080169099992],
              [-71.97276770699995, -34.09197356599992],
              [-71.96051998599995, -34.075290622999944],
              [-71.94371497299994, -34.039727471999925],
              [-71.93138587099992, -34.02206796699994],
              [-71.90660559799994, -34.00945403399993],
              [-71.90477454299992, -33.99749114399992],
              [-71.90583248599995, -33.98365650799991],
              [-71.90526282499991, -33.97283294099992],
              [-71.90029863199993, -33.96493905999995],
              [-71.87791907499991, -33.94548919099992],
              [-71.86025956899994, -33.9118791649999],
              [-71.83531653599994, -33.826429945999905],
              [-71.81651770699995, -33.78728606599992],
              [-71.80809485599991, -33.77695077899995],
              [-71.80199133999992, -33.77304452899995],
              [-71.79539954299992, -33.77027760199991],
              [-71.78547115799995, -33.76376718499995],
              [-71.77578691299993, -33.76018645599993],
              [-71.75365149599992, -33.76091887799993],
              [-71.74449622299994, -33.756931247999944],
              [-71.72516842399995, -33.74260833099993],
              [-71.70579993399991, -33.733086846999925],
              [-71.68765214799993, -33.72087981599992],
              [-71.67186438699991, -33.69850025799991],
              [-71.6543676419999, -33.656508070999905],
              [-71.6477758449999, -33.633884372999944],
              [-71.64517167899993, -33.61288827899995],
              [-71.64663652299993, -33.57903411299992],
              [-71.64517167899993, -33.56878020599993],
              [-71.64073645699995, -33.560804945999905],
              [-71.62751217399995, -33.54656340899993],
              [-71.62466386599993, -33.54143645599993],
              [-71.64077714799993, -33.50058359199994],
              [-71.70592200399994, -33.43434010199991],
              [-71.70726477799991, -33.38990650799991],
              [-71.70270748599995, -33.37900155999995],
              [-71.69749915299991, -33.37037525799991],
              [-71.68919837099992, -33.365166924999926],
              [-71.67560787699995, -33.36337655999995],
              [-71.67218990799995, -33.35857512799993],
              [-71.6712133449999, -33.3474260399999],
              [-71.67186438699991, -33.32577890399995],
              [-71.67609615799995, -33.30095794099992],
              [-71.68590247299994, -33.283868096999925],
              [-71.69749915299991, -33.267836195999905],
              [-71.70726477799991, -33.24667734199994],
              [-71.72032630099994, -33.16757577899995],
              [-71.72573808499993, -33.15398528399993],
              [-71.75226803299995, -33.113539320999905],
              [-71.76187089799993, -33.10198333099993],
              [-71.74351966099994, -33.08635833099993],
              [-71.69033769399994, -33.08562590899993],
              [-71.67931067599994, -33.07154713299991],
              [-71.67747962099992, -33.06072356599992],
              [-71.67271887899994, -33.047946872999944],
              [-71.66616777299993, -33.03606536299992],
              [-71.65880286399994, -33.02752044099992],
              [-71.64574133999992, -33.01897551899992],
              [-71.63805091099994, -33.01799895599993],
              [-71.63048255099994, -33.02011484199994],
              [-71.59357662699995, -33.019463799999926],
              [-71.58238684799994, -33.01685963299991],
              [-71.57286536399994, -33.01018645599993],
              [-71.56822669199994, -33.001885674999926],
              [-71.5645238919999, -32.98406340899993],
              [-71.55264238199993, -32.96428801899992],
              [-71.55378170499995, -32.953789971999925],
              [-71.55687415299991, -32.94345468499995],
              [-71.55577551999994, -32.931898695999905],
              [-71.54857337099992, -32.92197030999995],
              [-71.52892005099994, -32.90764739399992],
              [-71.52106686099995, -32.89657968499995],
              [-71.51829993399991, -32.87314218499995],
              [-71.52619381399995, -32.85165780999995],
              [-71.53685462099992, -32.83123137799993],
              [-71.54434160099993, -32.8044572899999],
              [-71.54792232999995, -32.79550546699994],
              [-71.54869544199994, -32.78484465899993],
              [-71.54214433499993, -32.77361419099992],
              [-71.53213456899994, -32.76921965899993],
              [-71.50942949099993, -32.76970794099992],
              [-71.50112870999993, -32.76677825299993],
              [-71.49498450399994, -32.74618905999995],
              [-71.50352942599994, -32.72600676899992],
              [-71.50674394399994, -32.710870049999926],
              [-71.46548417899993, -32.699476820999905],
              [-71.45417232999995, -32.68564218499995],
              [-71.44831295499995, -32.66570403399993],
              [-71.44591223899994, -32.64275481599992],
              [-71.44912675699993, -32.59710051899992],
              [-71.45474199099993, -32.57301197699991],
              [-71.47671464799993, -32.53525155999995],
              [-71.47142493399991, -32.51580169099992],
              [-71.45616614499994, -32.49920012799993],
              [-71.43968665299991, -32.485039971999925],
              [-71.44139563699991, -32.47226327899995],
              [-71.43175208199995, -32.42669036299992],
              [-71.42609615799995, -32.41057708099993],
              [-71.41812089799993, -32.39983489399992],
              [-71.41100012899994, -32.39413827899995],
              [-71.40794837099992, -32.38632577899995],
              [-71.41246497299994, -32.36956145599993],
              [-71.44591223899994, -32.341729424999926],
              [-71.45075436099995, -32.33953215899993],
              [-71.46426347599993, -32.33513762799993],
              [-71.46711178299995, -32.33171965899993],
              [-71.46735592399995, -32.330743096999925],
              [-71.46776282499991, -32.3161760399999],
              [-71.46711178299995, -32.31503671699994],
              [-71.47622636599993, -32.27752044099992],
              [-71.48131262899994, -32.26653411299992],
              [-71.49624589799993, -32.25164153399993],
              [-71.51390540299991, -32.240166924999926],
              [-71.53050696499992, -32.22665780999995],
              [-71.54214433499993, -32.20517343499995],
              [-71.54385331899994, -32.193291924999926],
              [-71.54214433499993, -32.160088799999926],
              [-71.53990637899994, -32.14902109199994],
              [-71.52790279899995, -32.126071872999944],
              [-71.52696692599994, -32.08367278399993],
              [-71.50772050699993, -31.97747161299992],
              [-71.51138261599993, -31.961195570999905],
              [-71.52013098899994, -31.951104424999926],
              [-71.52599036399994, -31.941176039999903],
              [-71.52879798099991, -31.93010833099993],
              [-71.52790279899995, -31.91659921699994],
              [-71.52269446499992, -31.906508070999905],
              [-71.51402747299994, -31.899590752999927],
              [-71.50560462099992, -31.894301039999903],
              [-71.50112870999993, -31.889825127999927],
              [-71.50645911399994, -31.86923593499995],
              [-71.53962154899995, -31.837660414999903],
              [-71.53872636599993, -31.82463958099993],
              [-71.52171790299991, -31.806247653999947],
              [-71.51451575399994, -31.790459893999923],
              [-71.5149633449999, -31.77548593499995],
              [-71.56322180899991, -31.608086846999925],
              [-71.5703832669999, -31.591566664999903],
              [-71.56944739499994, -31.51921965899993],
              [-71.59365800699993, -31.444105726999908],
              [-71.60846920499995, -31.420179945999905],
              [-71.64712480399993, -31.20208098799992],
              [-71.66616777299993, -31.169854424999926],
              [-71.66783606699994, -31.15048593499995],
              [-71.65274003799993, -31.06894296699994],
              [-71.65099036399994, -31.02239348799992],
              [-71.65493730399993, -30.976006768999923],
              [-71.66563880099994, -30.937107028999947],
              [-71.6699926419999, -30.930759372999944],
              [-71.67442786399994, -30.925957940999922],
              [-71.67788652299993, -30.919040622999944],
              [-71.68032792899993, -30.895684502999927],
              [-71.68512936099995, -30.87590911299992],
              [-71.68911699099993, -30.84303150799991],
              [-71.70726477799991, -30.779473565999922],
              [-71.69896399599992, -30.708916924999926],
              [-71.70352128799993, -30.697442315999922],
              [-71.71344967399995, -30.61492278399993],
              [-71.70970618399991, -30.593682549999926],
              [-71.69489498599995, -30.544854424999926],
              [-71.69668535099993, -30.529229424999926],
              [-71.70348059799994, -30.508558851999908],
              [-71.69937089799993, -30.485039971999925],
              [-71.68614661399994, -30.44980234199994],
              [-71.67682857999995, -30.342543226999908],
              [-71.63923092399995, -30.252211195999905],
              [-71.63776607999995, -30.24146900799991],
              [-71.63463294199994, -30.238213799999926],
              [-71.62779700399994, -30.240492445999905],
              [-71.62096106699994, -30.24667734199994],
              [-71.60879472599993, -30.275160414999903],
              [-71.58747311099995, -30.284926039999903],
              [-71.56232662699995, -30.287286065999922],
              [-71.54214433499993, -30.285332940999922],
              [-71.51756751199991, -30.27857838299991],
              [-71.50609290299991, -30.27190520599993],
              [-71.50112870999993, -30.26181405999995],
              [-71.50352942599994, -30.251153252999927],
              [-71.50658118399991, -30.243747653999947],
              [-71.50438391799992, -30.23951588299991],
              [-71.49095618399991, -30.238213799999926],
              [-71.48615475199995, -30.226820570999905],
              [-71.44591223899994, -30.162367445999905],
              [-71.43297278599994, -30.17392343499995],
              [-71.42430579299992, -30.184747002999927],
              [-71.41462154899995, -30.18808359199994],
              [-71.39879309799994, -30.17669036299992],
              [-71.38817298099991, -30.16269296699994],
              [-71.38255774599992, -30.14771900799991],
              [-71.37767493399991, -30.114678643999923],
              [-71.37645423099991, -30.078871351999908],
              [-71.38239498599995, -30.046075127999927],
              [-71.3946020169999, -30.016778252999927],
              [-71.41246497299994, -29.991794528999947],
              [-71.40733801999994, -29.982679945999905],
              [-71.40103105399993, -29.978122653999947],
              [-71.39346269399994, -29.97861093499995],
              [-71.38442949099993, -29.984307549999926],
              [-71.38312740799995, -29.976169528999947],
              [-71.37995357999995, -29.96965911299992],
              [-71.37482662699995, -29.96542734199994],
              [-71.35855058499993, -29.961602471999925],
              [-71.35850989499994, -29.95631275799991],
              [-71.36050370999993, -29.94963958099993],
              [-71.35781816299993, -29.943291924999926],
              [-71.35399329299992, -29.938164971999925],
              [-71.3535863919999, -29.933770440999922],
              [-71.35069739499994, -29.930840752999927],
              [-71.33983313699991, -29.92978280999995],
              [-71.33608964799993, -29.931817315999922],
              [-71.32632402299993, -29.941176039999903],
              [-71.3196508449999, -29.943291924999926],
              [-71.29775956899994, -29.933851820999905],
              [-71.28661048099991, -29.91025155999995],
              [-71.28258216099994, -29.88014088299991],
              [-71.28209387899994, -29.85084400799991],
              [-71.28514563699991, -29.836114190999922],
              [-71.29287675699993, -29.82545338299991],
              [-71.31248938699991, -29.809665622999944],
              [-71.31944739499994, -29.799981377999927],
              [-71.32412675699993, -29.787286065999922],
              [-71.33592688699991, -29.728122653999947],
              [-71.33535722599993, -29.711195570999905],
              [-71.32648678299995, -29.703789971999925],
              [-71.32022050699993, -29.69695403399993],
              [-71.31753495999993, -29.681817315999922],
              [-71.31851152299993, -29.665622653999947],
              [-71.32306881399995, -29.65593840899993],
              [-71.29718990799995, -29.622653903999947],
              [-71.28807532499991, -29.603122653999947],
              [-71.29881751199991, -29.594496351999908],
              [-71.31151282499991, -29.586683851999908],
              [-71.32335364499994, -29.567803643999923],
              [-71.33218339799993, -29.544854424999926],
              [-71.33604895699995, -29.524997653999947],
              [-71.33348548099991, -29.504082940999922],
              [-71.31944739499994, -29.471856377999927],
              [-71.31419837099992, -29.444024346999925],
              [-71.31012936099995, -29.433038018999923],
              [-71.30724036399994, -29.42115650799991],
              [-71.30882727799991, -29.408868096999925],
              [-71.31456458199995, -29.401055596999925],
              [-71.32998613199993, -29.390801690999922],
              [-71.33604895699995, -29.381036065999922],
              [-71.34117591099994, -29.357191664999903],
              [-71.34276282499991, -29.336602471999925],
              [-71.34715735599991, -29.31682708099993],
              [-71.36091061099995, -29.295586846999925],
              [-71.37608801999994, -29.282403252999927],
              [-71.46939042899993, -29.228773695999905],
              [-71.48692786399994, -29.21184661299992],
              [-71.49429277299993, -29.19264088299991],
              [-71.49461829299992, -29.142347914999903],
              [-71.49575761599993, -29.138929945999905],
              [-71.49620520699995, -29.134698174999926],
              [-71.49429277299993, -29.127129815999922],
              [-71.49156653599994, -29.122165622999944],
              [-71.48350989499994, -29.112399997999944],
              [-71.48131262899994, -29.10784270599993],
              [-71.48208574099993, -29.09343840899993],
              [-71.48916581899994, -29.086195570999905],
              [-71.49730383999992, -29.08017343499995],
              [-71.50112870999993, -29.069756768999923],
              [-71.49901282499991, -29.06096770599993],
              [-71.48965410099993, -29.046644789999903],
              [-71.48753821499992, -29.03557708099993],
              [-71.50112870999993, -28.99114348799992],
              [-71.49925696499992, -28.986586195999905],
              [-71.49754798099991, -28.976820570999905],
              [-71.50112870999993, -28.97079843499995],
              [-71.51480058499993, -28.977634372999944],
              [-71.52196204299992, -28.940118096999925],
              [-71.51121985599991, -28.88958098799992],
              [-71.48778235599991, -28.845147393999923],
              [-71.45645097599993, -28.826104424999926],
              [-71.4407445949999, -28.822930596999925],
              [-71.40184485599991, -28.806573174999926],
              [-71.39134680899991, -28.799493096999925],
              [-71.38036048099991, -28.780450127999927],
              [-71.36815344999991, -28.74081796699994],
              [-71.35781816299993, -28.723728122999944],
              [-71.31851152299993, -28.69264088299991],
              [-71.30186926999994, -28.674899997999944],
              [-71.28766842399995, -28.618910414999903],
              [-71.28892981699994, -28.607028903999947],
              [-71.29466712099992, -28.599541924999926],
              [-71.3040258449999, -28.591973565999922],
              [-71.31261145699995, -28.583428643999923],
              [-71.31623287699995, -28.572930596999925],
              [-71.30748450399994, -28.561700127999927],
              [-71.28868567599994, -28.55242278399993],
              [-71.27009029899995, -28.540459893999923],
              [-71.26158606699994, -28.521661065999922],
              [-71.26988684799994, -28.48601653399993],
              [-71.26781165299991, -28.47665780999995],
              [-71.26048743399991, -28.472426039999903],
              [-71.25059973899994, -28.471368096999925],
              [-71.24071204299992, -28.471368096999925],
              [-71.23363196499992, -28.470472914999903],
              [-71.21035722599993, -28.446709893999923],
              [-71.18858801999994, -28.405450127999927],
              [-71.17393958199995, -28.36060963299991],
              [-71.17223059799994, -28.326429945999905],
              [-71.17845618399991, -28.30901458099993],
              [-71.18333899599992, -28.301527601999908],
              [-71.18932044199994, -28.29851653399993],
              [-71.19359290299991, -28.294366143999923],
              [-71.18691972599993, -28.284763278999947],
              [-71.17223059799994, -28.267754815999922],
              [-71.17003333199995, -28.25009530999995],
              [-71.16014563699991, -28.211683851999908],
              [-71.15709387899994, -28.142836195999905],
              [-71.16002356699994, -28.120212497999944],
              [-71.17308508999992, -28.092950127999927],
              [-71.16783606699994, -28.083591403999947],
              [-71.15880286399994, -28.074151299999926],
              [-71.15172278599994, -28.06454843499995],
              [-71.14732825399994, -28.04892343499995],
              [-71.13809160099993, -27.945977471999925],
              [-71.13263912699995, -27.92351653399993],
              [-71.12437903599994, -27.90129973799992],
              [-71.11872311099995, -27.895196221999925],
              [-71.11107337099992, -27.890394789999903],
              [-71.10326087099992, -27.884209893999923],
              [-71.09715735599991, -27.87395598799992],
              [-71.1028539699999, -27.852227471999925],
              [-71.10472571499992, -27.838962497999944],
              [-71.10020911399994, -27.83294036299992],
              [-71.08971106699994, -27.83017343499995],
              [-71.08462480399993, -27.822930596999925],
              [-71.08299719999991, -27.81292083099993],
              [-71.08283443899995, -27.801934502999927],
              [-71.07876542899993, -27.780694268999923],
              [-71.05785071499992, -27.744398695999905],
              [-71.04869544199994, -27.72307708099993],
              [-71.04369055899991, -27.701918226999908],
              [-71.04185950399994, -27.678480726999908],
              [-71.03868567599994, -27.66643645599993],
              [-71.03160559799994, -27.657403252999927],
              [-71.02456620999993, -27.655450127999927],
              [-71.02139238199993, -27.664727471999925],
              [-71.01325436099995, -27.67156340899993],
              [-70.97109941299993, -27.660332940999922],
              [-70.95250403599994, -27.66106536299992],
              [-70.94749915299991, -27.649183851999908],
              [-70.9395238919999, -27.638278903999947],
              [-70.93040930899991, -27.630059502999927],
              [-70.92210852799991, -27.626885674999926],
              [-70.91242428299995, -27.621840101999908],
              [-70.91222083199995, -27.610039971999925],
              [-70.91901607999995, -27.58603280999995],
              [-70.91856848899994, -27.54387786299992],
              [-70.89537512899994, -27.50253671699994],
              [-70.89167232999995, -27.49309661299992],
              [-70.89557857999995, -27.469821872999944],
              [-70.90518144399994, -27.44150155999995],
              [-70.91734778599994, -27.415134372999944],
              [-70.94579016799992, -27.371840101999908],
              [-70.94493567599994, -27.349541924999926],
              [-70.93700110599991, -27.326429945999905],
              [-70.93268795499995, -27.298028252999927],
              [-70.93814042899993, -27.281426690999922],
              [-70.94831295499995, -27.262465101999908],
              [-70.95490475199995, -27.243584893999923],
              [-70.94493567599994, -27.21493905999995],
              [-70.94880123599995, -27.20435963299991],
              [-70.95995032499991, -27.188164971999925],
              [-70.9610082669999, -27.181410414999903],
              [-70.96104895699995, -27.16806405999995],
              [-70.95995032499991, -27.16139088299991],
              [-70.94847571499992, -27.132419528999947],
              [-70.94688880099994, -27.12363046699994],
              [-70.94131425699993, -27.11337655999995],
              [-70.92926998599995, -27.10670338299991],
              [-70.91706295499995, -27.106866143999923],
              [-70.91152910099993, -27.116794528999947],
              [-70.90819251199991, -27.129164320999905],
              [-70.9004613919999, -27.13250090899993],
              [-70.89134680899991, -27.13054778399993],
              [-70.88418535099993, -27.127211195999905],
              [-70.87083899599992, -27.117852471999925],
              [-70.86896725199995, -27.110039971999925],
              [-70.87132727799991, -27.10214609199994],
              [-70.87059485599991, -27.092461846999925],
              [-70.86506100199995, -27.08440520599993],
              [-70.85822506399995, -27.078301690999922],
              [-70.85244706899994, -27.07154713299991],
              [-70.85008704299992, -27.06178150799991],
              [-70.84874426999994, -27.048028252999927],
              [-70.84520423099991, -27.045993747999944],
              [-70.83983313699991, -27.049004815999922],
              [-70.8333227199999, -27.051527601999908],
              [-70.8184301419999, -27.047946872999944],
              [-70.81696529899995, -27.039727471999925],
              [-70.82111568899995, -27.030450127999927],
              [-70.82274329299992, -27.023614190999922],
              [-70.81501217399995, -27.015232028999947],
              [-70.79417883999992, -27.00253671699994],
              [-70.78864498599995, -26.996270440999922],
              [-70.79076087099992, -26.97779713299991],
              [-70.80695553299995, -26.93059661299992],
              [-70.80573482999995, -26.92115650799991],
              [-70.80638587099992, -26.916192315999922],
              [-70.82274329299992, -26.886976820999905],
              [-70.82420813699991, -26.873793226999908],
              [-70.82241777299993, -26.86581796699994],
              [-70.78604081899994, -26.78801848799992],
              [-70.77806555899991, -26.77792734199994],
              [-70.77179928299995, -26.77239348799992],
              [-70.74893848099993, -26.76055710299994],
              [-70.7324669429999, -26.749280592999924],
              [-70.74868730399993, -26.72942473799992],
              [-70.75283769399994, -26.722426039999903],
              [-70.75617428299995, -26.713636976999908],
              [-70.75450598899994, -26.70208098799992],
              [-70.74693762899994, -26.692071221999925],
              [-70.73033606699994, -26.681817315999922],
              [-70.72716223899994, -26.671482028999947],
              [-70.72598222599993, -26.660088799999926],
              [-70.71499589799993, -26.608575127999927],
              [-70.69530188699991, -26.568536065999922],
              [-70.69245357999995, -26.544366143999923],
              [-70.70470130099994, -26.511488539999903],
              [-70.70665442599994, -26.492852471999925],
              [-70.69587154899995, -26.472426039999903],
              [-70.68984941299993, -26.46453215899993],
              [-70.68663489499994, -26.456475518999923],
              [-70.68541419199994, -26.44695403399993],
              [-70.6856176419999, -26.43450286299992],
              [-70.68809973899994, -26.423760674999926],
              [-70.69766191299993, -26.400648695999905],
              [-70.6992895169999, -26.39299895599993],
              [-70.69127065599992, -26.383551259999933],
              [-70.66663609499994, -26.385269249999908],
              [-70.6565483469999, -26.35582416099993],
              [-70.62995437299992, -26.340976922999914],
              [-70.64241290899992, -26.31533099099994],
              [-70.68144343799992, -26.30449591599995],
              [-70.6754456299999, -26.27690905499992],
              [-70.65705663999995, -26.265802165999958],
              [-70.64826412699995, -26.235772393999923],
              [-70.65485592399995, -26.21917083099993],
              [-70.66454016799992, -26.20281340899993],
              [-70.66494706899994, -26.175713799999926],
              [-70.6719457669999, -26.160821221999925],
              [-70.66543535099993, -26.14967213299991],
              [-70.66173255099994, -26.13404713299991],
              [-70.6582738919999, -26.099379164999903],
              [-70.65965735599991, -26.072523695999905],
              [-70.6582738919999, -26.064629815999922],
              [-70.65343176999994, -26.056410414999903],
              [-70.64220130099994, -26.04973723799992],
              [-70.63780676999994, -26.044122002999927],
              [-70.63072669199994, -26.009535414999903],
              [-70.63597571499992, -25.97470468499995],
              [-70.64891516799992, -25.943617445999905],
              [-70.66510982999995, -25.920586846999925],
              [-70.69668535099993, -25.88518645599993],
              [-70.70384680899991, -25.867364190999922],
              [-70.70612545499995, -25.84189218499995],
              [-70.71035722599993, -25.835381768999923],
              [-70.73111677899993, -25.829288833999954],
              [-70.73998509499995, -25.829322758999922],
              [-70.73338782499991, -25.80396900799991],
              [-70.72399857599993, -25.77871257499993],
              [-70.70031251799992, -25.773376801999916],
              [-70.69161801999991, -25.74145406699995],
              [-70.69383704299992, -25.714043877999927],
              [-70.69245357999995, -25.691338799999926],
              [-70.68667558499993, -25.66806405999995],
              [-70.67341061099995, -25.653903903999947],
              [-70.65080870499992, -25.648306369999943],
              [-70.6347747339999, -25.62550241999992],
              [-70.63780676999994, -25.581475518999923],
              [-70.6399633449999, -25.571384372999944],
              [-70.64932206899994, -25.55120208099993],
              [-70.65143795499995, -25.54078541499996],
              [-70.65038001199991, -25.52857838299991],
              [-70.64688066299993, -25.521661065999922],
              [-70.62287350199995, -25.504164320999905],
              [-70.61872311099995, -25.50318775799991],
              [-70.61375891799992, -25.50359465899993],
              [-70.60366777299993, -25.50164153399993],
              [-70.58495032499991, -25.493584893999923],
              [-70.55113684799994, -25.47242603999996],
              [-70.53848222599993, -25.468194268999923],
              [-70.53091386599993, -25.45680103999996],
              [-70.52135169199994, -25.40325286299992],
              [-70.51366126199991, -25.386325778999947],
              [-70.47642981699994, -25.386325778999947],
              [-70.4649145169999, -25.382419528999947],
              [-70.45848548099991, -25.37363046699994],
              [-70.45425370999993, -25.363213799999926],
              [-70.44937089799993, -25.35515715899993],
              [-70.44481360599991, -25.344903252999927],
              [-70.4466039699999, -25.333103122999944],
              [-70.45287024599992, -25.31804778399993],
              [-70.45083574099993, -25.30632903399993],
              [-70.43919837099992, -25.276462497999944],
              [-70.43439693899995, -25.23609791499996],
              [-70.43700110599991, -25.19345468499995],
              [-70.44908606699994, -25.15292734199994],
              [-70.4727270169999, -25.119317315999922],
              [-70.48912512899994, -25.110446872999944],
              [-70.49718176999994, -25.104261976999908],
              [-70.50059973899994, -25.09547291499996],
              [-70.49966386599993, -25.08456796699994],
              [-70.49535071499992, -25.069024346999925],
              [-70.49445553299995, -25.06096770599993],
              [-70.48859615799995, -25.03948333099993],
              [-70.47704016799992, -25.020277601999908],
              [-70.46873938699991, -25.00009530999995],
              [-70.4727270169999, -24.975274346999925],
              [-70.52098548099991, -24.919040622999944],
              [-70.52794348899994, -24.89617278399993],
              [-70.53172766799992, -24.87314218499995],
              [-70.54979407499991, -24.83245208099993],
              [-70.55589758999992, -24.810804945999905],
              [-70.55589758999992, -24.765883070999905],
              [-70.55907141799992, -24.75628020599993],
              [-70.57310950399994, -24.73723723799992],
              [-70.57640540299991, -24.73170338299991],
              [-70.57640540299991, -24.65325286299992],
              [-70.55479895699995, -24.60588958099993],
              [-70.55650794199994, -24.595147393999923],
              [-70.56045488199993, -24.58440520599993],
              [-70.56541907499991, -24.561700127999927],
              [-70.5716039699999, -24.553806247999944],
              [-70.57827714799993, -24.546807549999926],
              [-70.58259029899995, -24.53720468499995],
              [-70.58283443899995, -24.524834893999923],
              [-70.57945716099994, -24.517510674999926],
              [-70.57420813699991, -24.51140715899993],
              [-70.56891842399995, -24.50237395599993],
              [-70.56111663699994, -24.481820529999936],
              [-70.55387106499995, -24.44946766499993],
              [-70.5419174459999, -24.41522868699991],
              [-70.54906165299991, -24.38567473799992],
              [-70.54979407499991, -24.37981536299992],
              [-70.55492102799991, -24.371026299999926],
              [-70.55589758999992, -24.365166924999926],
              [-70.55370032499991, -24.364841403999947],
              [-70.54865475199995, -24.360528252999927],
              [-70.54369055899991, -24.35515715899993],
              [-70.54161536399994, -24.351495049999926],
              [-70.54491126199991, -24.34148528399993],
              [-70.5477467309999, -24.327255443999945],
              [-70.53927191899993, -24.318406465999942],
              [-70.5328842429999, -24.305731630999958],
              [-70.53458530299991, -24.29220728599995],
              [-70.53070608999991, -24.278842053999938],
              [-70.53429114499994, -24.26100025799991],
              [-70.5305883449999, -24.24472421699994],
              [-70.51366126199991, -24.214450778999947],
              [-70.51968339799993, -24.201348565999922],
              [-70.5176488919999, -24.18954843499995],
              [-70.5060978379999, -24.167380796999907],
              [-70.5145089639999, -24.145807873999956],
              [-70.5195515289999, -24.123821756999916],
              [-70.50941827199995, -24.122196065999958],
              [-70.50401770699995, -24.114841403999947],
              [-70.50031490799995, -24.09742603999996],
              [-70.50230872299994, -24.06764088299991],
              [-70.50841223899994, -24.03769296699994],
              [-70.52635657499991, -23.996270440999922],
              [-70.51984615799995, -23.96526458099993],
              [-70.50059973899994, -23.91269296699994],
              [-70.50389563699991, -23.886325778999947],
              [-70.51227779899995, -23.871840101999908],
              [-70.51329505099994, -23.85906340899993],
              [-70.49445553299995, -23.83757903399993],
              [-70.49852454299992, -23.784600518999923],
              [-70.49445553299995, -23.768731377999927],
              [-70.48399817599994, -23.754978122999944],
              [-70.45254472599993, -23.728773695999905],
              [-70.43919837099992, -23.714043877999927],
              [-70.42125403599994, -23.684665622999944],
              [-70.40526282499991, -23.65081145599993],
              [-70.39411373599995, -23.614353122999944],
              [-70.39073645699995, -23.576918226999908],
              [-70.40430665399992, -23.551877717999957],
              [-70.41308475999995, -23.51125271299992],
              [-70.44051304399994, -23.492646751999928],
              [-70.4662446719999, -23.480260512999905],
              [-70.49698299399995, -23.469472339999925],
              [-70.51223515899994, -23.480502749999914],
              [-70.5206638599999, -23.504010854999933],
              [-70.5325302679999, -23.51658433399996],
              [-70.53931501599993, -23.532273105999934],
              [-70.56138517799991, -23.52609053799995],
              [-70.58186274399992, -23.519925739999906],
              [-70.6058297859999, -23.510653126999955],
              [-70.62133765599992, -23.531090457999937],
              [-70.63161225499994, -23.517038645999946],
              [-70.6250270079999, -23.474748596999916],
              [-70.61636308499993, -23.455010674999926],
              [-70.61388098899994, -23.447198174999926],
              [-70.60171464799993, -23.444105726999908],
              [-70.59178626199991, -23.435723565999922],
              [-70.58507239499994, -23.42359791499996],
              [-70.5962259769999, -23.40583134499991],
              [-70.59929150599993, -23.404909207999935],
              [-70.6024252819999, -23.379715002999944],
              [-70.60463327199994, -23.357283424999935],
              [-70.59154212099992, -23.32626718499995],
              [-70.59658206099994, -23.301348918999906],
              [-70.60079990799994, -23.281724608999923],
              [-70.59889996599992, -23.263011898999935],
              [-70.60012342599993, -23.244225197999924],
              [-70.58610137099993, -23.213268524999933],
              [-70.56779540899993, -23.20022223999996],
              [-70.5628398369999, -23.175002509999956],
              [-70.5722134849999, -23.155201131999945],
              [-70.56516912399991, -23.130994750999946],
              [-70.58068510699991, -23.108320772999946],
              [-70.57270085599993, -23.080221472999938],
              [-70.56224524599992, -23.05982838299991],
              [-70.53697669199994, -23.032810153999947],
              [-70.51183020699995, -23.01490650799991],
              [-70.50890051999994, -23.010023695999905],
              [-70.50617428299995, -23.010023695999905],
              [-70.49754798099991, -23.018324476999908],
              [-70.49351966099994, -23.02662525799991],
              [-70.49356035099993, -23.037286065999922],
              [-70.49644934799994, -23.047621351999908],
              [-70.50059973899994, -23.05559661299992],
              [-70.4934792329999, -23.073023166999917],
              [-70.48438615799995, -23.08603415899995],
              [-70.4680336749999, -23.09623136999994],
              [-70.4507514849999, -23.097075416999928],
              [-70.4254231889999, -23.08853015099993],
              [-70.39710605199991, -23.07062259299994],
              [-70.37285934899995, -23.05087423899994],
              [-70.35635331899994, -23.02988046699994],
              [-70.33714758999992, -23.002618096999925],
              [-70.32933508999992, -22.97047291499996],
              [-70.32884680899991, -22.96217213299991],
              [-70.32750403599994, -22.95680103999996],
              [-70.32249915299991, -22.94695403399993],
              [-70.32079016799992, -22.946058851999908],
              [-70.30874589799993, -22.93328215899993],
              [-70.29702714799993, -22.91773853999996],
              [-70.29157467399995, -22.901950778999947],
              [-70.28856360599991, -22.884698174999926],
              [-70.28774980399993, -22.86809661299992],
              [-70.2942602199999, -22.845147393999923],
              [-70.30622311099995, -22.81878020599993],
              [-70.3125707669999, -22.790622653999947],
              [-70.30199133999992, -22.761976820999905],
              [-70.30321204299992, -22.74773528399993],
              [-70.29124915299991, -22.724053643999923],
              [-70.28111731699994, -22.695245049999926],
              [-70.28774980399993, -22.66570403399993],
              [-70.28099524599992, -22.65789153399993],
              [-70.28286699099993, -22.650323174999926],
              [-70.2871801419999, -22.64185963299991],
              [-70.28774980399993, -22.631605726999908],
              [-70.28229732999995, -22.623793226999908],
              [-70.27550208199995, -22.62232838299991],
              [-70.26968339799993, -22.61956145599993],
              [-70.26724199099993, -22.60711028399993],
              [-70.26939856699994, -22.596368096999925],
              [-70.27879798099991, -22.578057549999926],
              [-70.28087317599994, -22.56617603999996],
              [-70.27855383999992, -22.55673593499995],
              [-70.24315344999991, -22.49651458099993],
              [-70.24058997299994, -22.48756275799991],
              [-70.24266516799992, -22.47828541499996],
              [-70.25422115799995, -22.456638278999947],
              [-70.24673417899993, -22.38518645599993],
              [-70.24819902299993, -22.327569268999923],
              [-70.24364173099991, -22.313164971999925],
              [-70.23550370999993, -22.29810963299991],
              [-70.22288977799991, -22.162367445999905],
              [-70.22496497299994, -22.14690520599993],
              [-70.21117102799991, -22.101739190999922],
              [-70.21324622299994, -22.08294036299992],
              [-70.19847571499992, -22.07512786299992],
              [-70.19005286399994, -22.059747002999927],
              [-70.18614661399994, -22.04143645599993],
              [-70.18529212099992, -22.024997653999947],
              [-70.20010331899994, -22.00554778399993],
              [-70.19835364499994, -22.00286223799992],
              [-70.19440670499995, -22.001885674999926],
              [-70.19212805899991, -22.001071872999944],
              [-70.19041907499991, -21.99472421699994],
              [-70.17788652299993, -21.97307708099993],
              [-70.18276933499993, -21.963962497999944],
              [-70.17992102799991, -21.95566171699994],
              [-70.17442786399994, -21.94589609199994],
              [-70.17162024599992, -21.93206145599993],
              [-70.17381751199991, -21.91765715899993],
              [-70.17886308499993, -21.906508070999905],
              [-70.19212805899991, -21.884372653999947],
              [-70.15005449099993, -21.861993096999925],
              [-70.14606686099995, -21.811700127999927],
              [-70.15314693899995, -21.759942315999922],
              [-70.14435787699995, -21.733493747999944],
              [-70.14879309799994, -21.72275155999995],
              [-70.15196692599994, -21.664808851999908],
              [-70.15021725199995, -21.653497002999927],
              [-70.1398444969999, -21.63264574099992],
              [-70.12250852599993, -21.61930300599994],
              [-70.10364476399991, -21.608698752999942],
              [-70.09614534799994, -21.591221515999905],
              [-70.0946621569999, -21.573689075999937],
              [-70.08971106699994, -21.55917734199994],
              [-70.08716044399995, -21.545629573999918],
              [-70.07440289199991, -21.537940490999915],
              [-70.07141491199991, -21.52255583899995],
              [-70.07516473099992, -21.51129708299993],
              [-70.07893586699993, -21.500733822999905],
              [-70.08272197399992, -21.48881317599995],
              [-70.08291581899994, -21.48333098799992],
              [-70.07145276299991, -21.46565690999995],
              [-70.0617015439999, -21.450296917999935],
              [-70.05869493799992, -21.433377481999912],
              [-70.06625805599992, -21.41515119999991],
              [-70.08286348999991, -21.39130889599994],
              [-70.09269761699994, -21.365340174999915],
              [-70.09410559799994, -21.34547291499996],
              [-70.08746519499994, -21.337105617999953],
              [-70.08220911699993, -21.327281016999905],
              [-70.07290605399993, -21.315850518999923],
              [-70.06867428299995, -21.305840752999927],
              [-70.07626142599992, -21.282394643999908],
              [-70.07781762199994, -21.26355824199993],
              [-70.08683179399992, -21.25505417399995],
              [-70.08698482999995, -21.24586353999996],
              [-70.08309098899991, -21.24031493399991],
              [-70.08009447099994, -21.23332500999993],
              [-70.08360755099994, -21.22584400799991],
              [-70.08914506299993, -21.216478774999928],
              [-70.09518221099995, -21.203161632999922],
              [-70.09520052999994, -21.189839004999953],
              [-70.1102662959999, -21.173703363999948],
              [-70.11168372299994, -21.16269296699994],
              [-70.11831620999993, -21.140069268999923],
              [-70.12279212099992, -21.13486093499995],
              [-70.12759355399993, -21.13014088299991],
              [-70.13072669199994, -21.12395598799992],
              [-70.13023841099994, -21.118340752999927],
              [-70.12779700399994, -21.112888278999947],
              [-70.12490800699993, -21.109551690999922],
              [-70.12328040299991, -21.11028411299992],
              [-70.12730158499994, -21.08920269899994],
              [-70.14014817899994, -21.076460935999933],
              [-70.16442234499993, -21.04049793599995],
              [-70.17129472599993, -21.01458098799992],
              [-70.16828365799995, -20.99700286299992],
              [-70.16222083199995, -20.98756275799991],
              [-70.15014089699991, -20.962800854999955],
              [-70.13046911599992, -20.94657792399994],
              [-70.12746248499991, -20.935275],
              [-70.14112133799995, -20.91546342299995],
              [-70.1365754059999, -20.900683516999948],
              [-70.14113267099992, -20.880916861999935],
              [-70.14781653599994, -20.867364190999922],
              [-70.15400677199995, -20.85621054199993],
              [-70.1684161739999, -20.84201465299992],
              [-70.18356600599992, -20.828562983999916],
              [-70.19416895299992, -20.815832722999914],
              [-70.21232721199993, -20.813702572999944],
              [-70.21384425299993, -20.81157740699996],
              [-70.1972000849999, -20.80452936699993],
              [-70.19041788999994, -20.791782619999935],
              [-70.20409413699991, -20.762707340999953],
              [-70.20563717399995, -20.739353122999944],
              [-70.19212805899991, -20.719903252999927],
              [-70.19212805899991, -20.713067315999922],
              [-70.19717363199993, -20.711602471999925],
              [-70.19937089799993, -20.710137627999927],
              [-70.20148678299995, -20.70826588299991],
              [-70.20579993399991, -20.706231377999927],
              [-70.19562740799995, -20.676934502999927],
              [-70.19420325399994, -20.64462655999995],
              [-70.20382638099994, -20.541958309999927],
              [-70.20579993399991, -20.528090101999908],
              [-70.19888261599993, -20.515883070999905],
              [-70.17650305899991, -20.491794528999947],
              [-70.17144826599991, -20.476168487999928],
              [-70.16668639799991, -20.448069052999926],
              [-70.17162024599992, -20.42164478999996],
              [-70.17491614499994, -20.40357838299991],
              [-70.18887285099993, -20.379571221999925],
              [-70.19212805899991, -20.366794528999947],
              [-70.18687903599994, -20.354261976999908],
              [-70.16388912699995, -20.33912525799991],
              [-70.14574177499992, -20.330414704999953],
              [-70.14167232999995, -20.30169036299992],
              [-70.13687089799993, -20.294122002999927],
              [-70.13072669199994, -20.266778252999927],
              [-70.16047115799995, -20.220879815999922],
              [-70.16486568899995, -20.20875416499996],
              [-70.16234290299991, -20.19654713299991],
              [-70.15648352799991, -20.192559502999927],
              [-70.14964758999992, -20.189060153999947],
              [-70.14435787699995, -20.17864348799992],
              [-70.14517167899993, -20.17156340899993],
              [-70.15078691299993, -20.148370049999926],
              [-70.15119381399995, -20.13762786299992],
              [-70.14525305899991, -20.12314218499995],
              [-70.12706458199995, -20.091729424999926],
              [-70.12328040299991, -20.072198174999926],
              [-70.12535559799994, -20.06617603999996],
              [-70.1348363919999, -20.05136484199994],
              [-70.13687089799993, -20.04159921699994],
              [-70.13475501199991, -20.031426690999922],
              [-70.12555904899995, -20.009698174999926],
              [-70.12328040299991, -19.999932549999926],
              [-70.12486731699994, -19.97820403399993],
              [-70.13459225199995, -19.94931405999995],
              [-70.13805091099994, -19.916192315999922],
              [-70.14435787699995, -19.890069268999923],
              [-70.14289303299995, -19.87932708099993],
              [-70.13695227799991, -19.860528252999927],
              [-70.13687089799993, -19.849053643999923],
              [-70.15859941299993, -19.81845468499995],
              [-70.15859941299993, -19.79070403399993],
              [-70.14932206899994, -19.73723723799992],
              [-70.15119381399995, -19.719414971999925],
              [-70.17495683499993, -19.660414320999905],
              [-70.17788652299993, -19.640232028999947],
              [-70.18414521599993, -19.629385974999934],
              [-70.20899806599994, -19.616768420999904],
              [-70.23822354299995, -19.603279931999907],
              [-70.24254412699992, -19.598202934999904],
              [-70.21442008399993, -19.59635863999995],
              [-70.20836341099994, -19.580254815999922],
              [-70.20274817599994, -19.569024346999925],
              [-70.20396887899994, -19.55242278399993],
              [-70.19957434799994, -19.534356377999927],
              [-70.20763098899994, -19.489841403999947],
              [-70.21398392999993, -19.46109748899994],
              [-70.22613596899993, -19.436903671999914],
              [-70.22630774599992, -19.410821221999925],
              [-70.24058997299994, -19.373304945999905],
              [-70.26602128799993, -19.334730726999908],
              [-70.26414954299992, -19.328301690999922],
              [-70.26081295499995, -19.32350025799991],
              [-70.26992753799993, -19.313246351999908],
              [-70.28213456899994, -19.303806247999944],
              [-70.28774980399993, -19.300957940999922],
              [-70.2884008449999, -19.29192473799992],
              [-70.28258216099994, -19.27320728999996],
              [-70.28087317599994, -19.26344166499996],
              [-70.28221594999991, -19.223402601999908],
              [-70.27953040299991, -19.204278252999927],
              [-70.26622473899994, -19.178399346999925],
              [-70.27033443899995, -19.171482028999947],
              [-70.27721106699994, -19.16611093499995],
              [-70.28087317599994, -19.160414320999905],
              [-70.27529863199993, -19.133070570999905],
              [-70.2747289699999, -19.12281666499996],
              [-70.2774145169999, -19.108982028999947],
              [-70.31273352799991, -19.02190520599993],
              [-70.31380310899993, -19.007084756999916],
              [-70.30896411999993, -18.971466043999953],
              [-70.32012321999991, -18.944281530999945],
              [-70.33016351799995, -18.87921440699995],
              [-70.34518712899995, -18.83935780999991],
              [-70.35309811099995, -18.797051690999922],
              [-70.35659745999993, -18.773370049999926],
              [-70.35423743399991, -18.763116143999923],
              [-70.34292558499993, -18.735935153999947],
              [-70.34292558499993, -18.70826588299991],
              [-70.34154212099992, -18.696465752999927],
              [-70.33617102799991, -18.675713799999926],
              [-70.33617102799991, -18.663506768999923],
              [-70.33922278599994, -18.65398528399993],
              [-70.34805253799993, -18.643324476999908],
              [-70.35045325399994, -18.636325778999947],
              [-70.33524749299994, -18.617575090999935],
              [-70.33885657499991, -18.57822030999995],
              [-70.33429928299995, -18.545993747999944],
              [-70.32542883999992, -18.52402109199994],
              [-70.32249915299991, -18.51336028399993],
              [-70.32286536399994, -18.502129815999922],
              [-70.32835852799991, -18.480075778999947],
              [-70.32933508999992, -18.471856377999927],
              [-70.30636896499993, -18.46055498599992],
              [-70.30356149199991, -18.445438941999953],
              [-70.31371008999992, -18.43010833099993],
              [-70.32591712099992, -18.41375090899993],
              [-70.34947680399995, -18.38318069099995],
              [-70.37009034899995, -18.362701001999937],
              [-70.39257532599993, -18.33955874299994],
              [-70.39470274677868, -18.337746206368088],
              [-70.36939030599993, -18.324729473999938],
              [-70.31789473999993, -18.32121547699998],
              [-70.21087284899994, -18.33124070399991],
              [-70.1590672269999, -18.325969708999963],
              [-70.13415918599992, -18.318941713999962],
              [-70.06323328199994, -18.280701152999967],
              [-70.03935876999995, -18.273053041999987],
              [-70.01000655699997, -18.272639630999976],
              [-69.98778569199993, -18.26426804899991],
              [-69.9703448949999, -18.250625470999907],
              [-69.92280257799987, -18.196468569999894],
              [-69.8834509749999, -18.16360235799995],
              [-69.86533838499989, -18.1445854319999],
              [-69.84358260699986, -18.113166160999953],
              [-69.78309534299993, -17.981597962999913],
              [-69.77989140399987, -17.962581036999936],
              [-69.78237187299993, -17.94387416799995],
              [-69.79061426399997, -17.924753887999955],
              [-69.81278345299998, -17.888270326999944],
              [-69.81815780199994, -17.871423809999968],
              [-69.82009566799988, -17.846102357999897],
              [-69.82903569099992, -17.80383103699991],
              [-69.84608891399995, -17.76910447399996],
              [-69.85756108199988, -17.734171205999886],
              [-69.84983545499995, -17.691589825999912],
              [-69.81805444899993, -17.659137025999897],
              [-69.77580896599994, -17.656966615999906],
              [-69.72904179499994, -17.66327113999992],
              [-69.68390243099986, -17.65603643999995],
              [-69.63832381799989, -17.62606411],
              [-69.51008875199994, -17.506588197999946],
            ],
          ],
          [
            [
              [-68.64199785099993, -54.799167575999945],
              [-68.64234289599992, -54.85365325899993],
              [-68.65413543186631, -54.886244564385144],
              [-68.66584225199995, -54.88640715899993],
              [-68.68614661399994, -54.87932708099993],
              [-68.73981686099995, -54.84710051899992],
              [-68.92857825399994, -54.77849700299993],
              [-68.96568762899994, -54.78443775799991],
              [-68.96568762899994, -54.79070403399993],
              [-68.88296464799993, -54.807712497999944],
              [-68.87010657499991, -54.82170989399992],
              [-68.86058508999992, -54.835056247999944],
              [-68.83844967399995, -54.85100676899992],
              [-68.81314042899993, -54.86532968499995],
              [-68.79434160099993, -54.873304945999905],
              [-68.74449622299994, -54.88640715899993],
              [-68.73786373599995, -54.89609140399995],
              [-68.76024329299992, -54.911228122999944],
              [-68.78799394399994, -54.920179945999905],
              [-69.06700598899994, -54.94882577899995],
              [-69.13011633999992, -54.94215260199991],
              [-69.28270423099991, -54.899102471999925],
              [-69.5059301419999, -54.86150481599992],
              [-69.56151282499991, -54.845961195999905],
              [-69.59251868399991, -54.82903411299992],
              [-69.60244706899994, -54.824883721999925],
              [-69.61799068899995, -54.823337497999944],
              [-69.63353430899991, -54.82390715899993],
              [-69.64830481699994, -54.822523695999905],
              [-69.6614477199999, -54.81503671699994],
              [-69.67442786399994, -54.80478280999995],
              [-69.67772376199991, -54.79900481599992],
              [-69.67882239499994, -54.78769296699994],
              [-69.67235266799992, -54.778008721999925],
              [-69.65737870999993, -54.77467213299991],
              [-69.64118404899995, -54.77385833099993],
              [-69.63044186099995, -54.77092864399992],
              [-69.62437903599994, -54.760837497999944],
              [-69.62523352799991, -54.75164153399993],
              [-69.62873287699995, -54.74358489399992],
              [-69.63044186099995, -54.73674895599993],
              [-69.62706458199995, -54.692071221999925],
              [-69.63914954299992, -54.69768645599993],
              [-69.66356360599991, -54.75351327899995],
              [-69.67882239499994, -54.764743747999944],
              [-69.69212805899991, -54.74968840899993],
              [-69.69774329299992, -54.69980234199994],
              [-69.71605383999992, -54.68906015399995],
              [-69.72130286399994, -54.69817473799992],
              [-69.71231035099993, -54.764743747999944],
              [-69.71300208199995, -54.78476327899995],
              [-69.71467037699995, -54.79176197699991],
              [-69.71979732999995, -54.79810963299991],
              [-69.73078365799995, -54.80315520599993],
              [-69.74681555899991, -54.805759372999944],
              [-69.76130123599995, -54.80364348799992],
              [-69.76756751199991, -54.79452890399995],
              [-69.76060950399994, -54.74928150799991],
              [-69.76170813699991, -54.72730885199991],
              [-69.77440344999991, -54.71559010199991],
              [-69.79084225199995, -54.72144947699991],
              [-69.79637610599991, -54.74179452899995],
              [-69.79491126199991, -54.78769296699994],
              [-69.80899003799993, -54.81096770599993],
              [-69.84215247299994, -54.82105885199991],
              [-69.8809301419999, -54.822198174999926],
              [-69.91161048099991, -54.818617445999905],
              [-69.93057206899994, -54.81072356599992],
              [-69.95067298099991, -54.79615650799991],
              [-69.96662350199995, -54.778415622999944],
              [-69.97301184799994, -54.76091887799993],
              [-69.97301184799994, -54.71933359199994],
              [-69.96979732999995, -54.70940520599993],
              [-69.96312415299991, -54.70191822699991],
              [-69.95807857999995, -54.69378020599993],
              [-69.95938066299993, -54.681573174999926],
              [-69.96955318899995, -54.676853122999944],
              [-69.98322506399995, -54.69019947699991],
              [-69.99522864499994, -54.71217213299991],
              [-70.00035559799994, -54.73333098799992],
              [-69.99771074099993, -54.75603606599992],
              [-69.98460852799991, -54.7868791649999],
              [-69.97984778599994, -54.80437590899993],
              [-69.97850501199991, -54.822198174999926],
              [-69.98224850199995, -54.831149997999944],
              [-69.99327551999994, -54.835056247999944],
              [-70.08006751199991, -54.849867445999905],
              [-70.09284420499995, -54.84905364399992],
              [-70.09829667899993, -54.83538176899992],
              [-70.09410559799994, -54.820570570999905],
              [-70.08678137899994, -54.8064104149999],
              [-70.08291581899994, -54.79452890399995],
              [-70.08714758999992, -54.77857838299991],
              [-70.09654700399994, -54.78093840899993],
              [-70.10594641799992, -54.79420338299991],
              [-70.11021887899994, -54.811211846999925],
              [-70.13878333199995, -54.797133070999905],
              [-70.14293372299994, -54.80706145599993],
              [-70.14439856699994, -54.82756926899992],
              [-70.16486568899995, -54.845961195999905],
              [-70.20030676999994, -54.85475025799991],
              [-70.23973548099991, -54.85784270599993],
              [-70.27790279899995, -54.85312265399995],
              [-70.30943762899994, -54.838555596999925],
              [-70.32664954299992, -54.817071221999925],
              [-70.32380123599995, -54.797539971999925],
              [-70.30833899599992, -54.779961846999925],
              [-70.27131100199995, -54.75139739399992],
              [-70.23859615799995, -54.71445077899995],
              [-70.22630774599992, -54.6950822899999],
              [-70.24453691299993, -54.68906015399995],
              [-70.25446529899995, -54.69980234199994],
              [-70.26309160099993, -54.71526458099993],
              [-70.27782141799992, -54.72307708099993],
              [-70.28937740799995, -54.72714609199994],
              [-70.32241777299993, -54.74651458099993],
              [-70.32933508999992, -54.753838799999926],
              [-70.33193925699993, -54.76116301899992],
              [-70.33824622299994, -54.76653411299992],
              [-70.34532630099994, -54.7712541649999],
              [-70.35045325399994, -54.77703215899993],
              [-70.35277258999992, -54.78394947699991],
              [-70.35464433499993, -54.79778411299992],
              [-70.35659745999993, -54.80437590899993],
              [-70.35708574099993, -54.810479424999926],
              [-70.35521399599992, -54.82708098799992],
              [-70.35659745999993, -54.832289320999905],
              [-70.36534583199995, -54.83521900799991],
              [-70.37450110599991, -54.83220794099992],
              [-70.38170325399994, -54.82732512799993],
              [-70.38459225199995, -54.824883721999925],
              [-70.43089758999992, -54.812432549999926],
              [-70.4622289699999, -54.80934010199991],
              [-70.50544186099995, -54.799493096999925],
              [-70.54320227799991, -54.78394947699991],
              [-70.58116614499994, -54.77898528399993],
              [-70.61050370999993, -54.78069426899992],
              [-70.61046301999994, -54.79070403399993],
              [-70.62706458199995, -54.80193450299993],
              [-70.65225175699993, -54.80820077899995],
              [-70.69587154899995, -54.811211846999925],
              [-70.71764075399994, -54.81804778399993],
              [-70.73680579299992, -54.83131275799991],
              [-70.75877844999991, -54.84059010199991],
              [-70.78864498599995, -54.83538176899992],
              [-70.82494055899991, -54.82146575299993],
              [-70.83409583199995, -54.8103166649999],
              [-70.83702551999994, -54.78769296699994],
              [-70.82738196499992, -54.77743905999995],
              [-70.80500240799995, -54.767510674999926],
              [-70.77969316299993, -54.76018645599993],
              [-70.71324622299994, -54.753838799999926],
              [-70.62458248599995, -54.731540622999944],
              [-70.54556230399993, -54.69768645599993],
              [-70.45287024599992, -54.63372161299992],
              [-70.49103756399995, -54.61386484199994],
              [-70.54308020699995, -54.62346770599993],
              [-70.63097083199995, -54.6677385399999],
              [-70.61904863199993, -54.674086195999905],
              [-70.59455318899995, -54.68279387799993],
              [-70.58259029899995, -54.68906015399995],
              [-70.60635331899994, -54.703789971999925],
              [-70.63817298099991, -54.71738046699994],
              [-70.67145748599995, -54.72673919099992],
              [-70.6992895169999, -54.72991301899992],
              [-70.71642005099994, -54.72673919099992],
              [-70.72915605399993, -54.721774997999944],
              [-70.74229895699995, -54.71917083099993],
              [-70.76065019399994, -54.72307708099993],
              [-70.77326412699995, -54.7302385399999],
              [-70.78575598899994, -54.739353122999944],
              [-70.79954993399991, -54.74700286299992],
              [-70.81590735599991, -54.75042083099993],
              [-70.89199785099993, -54.74895598799992],
              [-70.92723548099991, -54.738213799999926],
              [-70.92210852799991, -54.71257903399993],
              [-70.89085852799991, -54.69817473799992],
              [-70.80825761599993, -54.69304778399993],
              [-70.77432206899994, -54.681573174999926],
              [-70.79971269399994, -54.673760674999926],
              [-70.85619055899991, -54.6814104149999],
              [-70.88418535099993, -54.681573174999926],
              [-70.92638098899994, -54.67001718499995],
              [-70.94481360599991, -54.672133070999905],
              [-70.95995032499991, -54.68906015399995],
              [-70.93984941299993, -54.70208098799992],
              [-70.95018469999991, -54.721368096999925],
              [-71.01040605399993, -54.770603122999944],
              [-71.02757727799991, -54.77703215899993],
              [-71.04234778599994, -54.77556731599992],
              [-71.04869544199994, -54.76091887799993],
              [-71.04259192599994, -54.74618905999995],
              [-71.02830969999991, -54.73512135199991],
              [-71.01231848899994, -54.72576262799993],
              [-71.00088456899994, -54.71559010199991],
              [-70.99575761599993, -54.70012786299992],
              [-70.99815833199995, -54.68710702899995],
              [-71.00186113199993, -54.67457447699991],
              [-71.00088456899994, -54.66106536299992],
              [-70.96084550699993, -54.63201262799993],
              [-70.94969641799992, -54.626885674999926],
              [-70.94798743399991, -54.623304945999905],
              [-70.95156816299993, -54.61638762799993],
              [-70.95921790299991, -54.61223723799992],
              [-70.97695878799993, -54.62004973799992],
              [-70.98615475199995, -54.6208635399999],
              [-71.00401770699995, -54.62004973799992],
              [-71.01520748599995, -54.615492445999905],
              [-71.04405676999994, -54.595961195999905],
              [-71.06236731699994, -54.59270598799992],
              [-71.0559789699999, -54.60621510199991],
              [-71.04808508999992, -54.617445570999905],
              [-71.0423070949999, -54.62835051899992],
              [-71.04185950399994, -54.640557549999926],
              [-71.05003821499992, -54.65740325299993],
              [-71.06078040299991, -54.66220468499995],
              [-71.0723363919999, -54.65976327899995],
              [-71.08283443899995, -54.65488046699994],
              [-71.08608964799993, -54.649102471999925],
              [-71.08641516799992, -54.64120859199994],
              [-71.09007727799991, -54.63494231599992],
              [-71.10334225199995, -54.63372161299992],
              [-71.10484778599994, -54.637383721999925],
              [-71.14826412699995, -54.6872697899999],
              [-71.16266842399995, -54.69817473799992],
              [-71.17967688699991, -54.70256926899992],
              [-71.19212805899991, -54.69890715899993],
              [-71.21861731699994, -54.6814104149999],
              [-71.23363196499992, -54.67522551899992],
              [-71.27009029899995, -54.67742278399993],
              [-71.28966223899994, -54.676446221999925],
              [-71.30260169199994, -54.6677385399999],
              [-71.30370032499991, -54.65243905999995],
              [-71.28962154899995, -54.64690520599993],
              [-71.21841386599993, -54.6443010399999],
              [-71.20433508999992, -54.6384416649999],
              [-71.1926977199999, -54.626885674999926],
              [-71.21833248599995, -54.621758721999925],
              [-71.24038652299993, -54.621026299999926],
              [-71.25576738199993, -54.61386484199994],
              [-71.26292883999992, -54.580743096999925],
              [-71.26500403599994, -54.57512786299992],
              [-71.26537024599992, -54.568617445999905],
              [-71.26158606699994, -54.558526299999926],
              [-71.25479081899994, -54.54998137799993],
              [-71.23997962099992, -54.54029713299991],
              [-71.23363196499992, -54.53134530999995],
              [-71.26305091099994, -54.53435637799993],
              [-71.28123938699991, -54.549899997999944],
              [-71.29796301999994, -54.55934010199991],
              [-71.32306881399995, -54.54501718499995],
              [-71.3379613919999, -54.52157968499995],
              [-71.34707597599993, -54.51718515399995],
              [-71.36091061099995, -54.52752044099992],
              [-71.36217200399994, -54.53826262799993],
              [-71.35440019399994, -54.549899997999944],
              [-71.34365800699993, -54.55982838299991],
              [-71.33604895699995, -54.565524997999944],
              [-71.36131751199991, -54.568291924999926],
              [-71.38304602799991, -54.558851820999905],
              [-71.40029863199993, -54.55608489399992],
              [-71.41246497299994, -54.579196872999944],
              [-71.37193762899994, -54.58749765399995],
              [-71.3509008449999, -54.59498463299991],
              [-71.33604895699995, -54.60637786299992],
              [-71.35045325399994, -54.61345794099992],
              [-71.35985266799992, -54.61028411299992],
              [-71.36864173099991, -54.603448174999926],
              [-71.38109290299991, -54.599541924999926],
              [-71.39464270699995, -54.60393645599993],
              [-71.39875240799995, -54.61451588299991],
              [-71.39989173099991, -54.628024997999944],
              [-71.40493730399993, -54.640557549999926],
              [-71.41710364499994, -54.65129973799992],
              [-71.42271887899994, -54.647556247999944],
              [-71.42894446499992, -54.63876718499995],
              [-71.44286048099991, -54.63372161299992],
              [-71.45189368399991, -54.63811614399992],
              [-71.45836341099994, -54.64706796699994],
              [-71.46833248599995, -54.654554945999905],
              [-71.48753821499992, -54.65488046699994],
              [-71.47736568899995, -54.676446221999925],
              [-71.48786373599995, -54.687432549999926],
              [-71.50658118399991, -54.683526299999926],
              [-71.52106686099995, -54.66106536299992],
              [-71.52179928299995, -54.637790622999944],
              [-71.51402747299994, -54.62078215899993],
              [-71.49429277299993, -54.59270598799992],
              [-71.51512610599991, -54.59823984199994],
              [-71.53416907499991, -54.61256275799991],
              [-71.54723059799994, -54.63250090899993],
              [-71.54963131399995, -54.65488046699994],
              [-71.55785071499992, -54.648695570999905],
              [-71.56639563699991, -54.646742445999905],
              [-71.57494055899991, -54.648695570999905],
              [-71.58311926999994, -54.65488046699994],
              [-71.59162350199995, -54.63876718499995],
              [-71.58413652299993, -54.61882903399993],
              [-71.56932532499991, -54.59970468499995],
              [-71.55577551999994, -54.585870049999926],
              [-71.5645238919999, -54.58513762799993],
              [-71.56989498599995, -54.587823174999926],
              [-71.57502193899995, -54.59107838299991],
              [-71.58311926999994, -54.59270598799992],
              [-71.5911352199999, -54.58928801899992],
              [-71.59422766799992, -54.58318450299993],
              [-71.59776770699995, -54.58098723799992],
              [-71.60732988199993, -54.58928801899992],
              [-71.61070716099994, -54.59644947699991],
              [-71.60920162699995, -54.60230885199991],
              [-71.60846920499995, -54.608493747999944],
              [-71.61412512899994, -54.61663176899992],
              [-71.63776607999995, -54.63372161299992],
              [-71.64061438699991, -54.63941822699991],
              [-71.63951575399994, -54.644789320999905],
              [-71.63947506399995, -54.64999765399995],
              [-71.64517167899993, -54.65488046699994],
              [-71.65208899599992, -54.656182549999926],
              [-71.66112219999991, -54.65585702899995],
              [-71.66982988199993, -54.65398528399993],
              [-71.67560787699995, -54.651055596999925],
              [-71.68504798099991, -54.634698174999926],
              [-71.67992102799991, -54.62184010199991],
              [-71.65200761599993, -54.599541924999926],
              [-71.66454016799992, -54.600274346999925],
              [-71.68765214799993, -54.605726820999905],
              [-71.69981848899994, -54.60637786299992],
              [-71.71393795499995, -54.60361093499995],
              [-71.73973548099991, -54.594821872999944],
              [-71.75446529899995, -54.59270598799992],
              [-71.74046790299991, -54.61419036299992],
              [-71.75959225199995, -54.6228166649999],
              [-71.79161536399994, -54.62322356599992],
              [-71.81651770699995, -54.62004973799992],
              [-71.80736243399991, -54.63095468499995],
              [-71.80451412699995, -54.6403947899999],
              [-71.80919348899994, -54.64853280999995],
              [-71.82266191299993, -54.65488046699994],
              [-71.84972083199995, -54.647556247999944],
              [-71.87083899599992, -54.647149346999925],
              [-71.91893469999991, -54.65488046699994],
              [-71.94432532499991, -54.654554945999905],
              [-71.96190344999991, -54.647149346999925],
              [-71.97350012899994, -54.63323333099993],
              [-71.98094641799992, -54.613213799999926],
              [-71.96076412699995, -54.60686614399992],
              [-71.94399980399993, -54.60507577899995],
              [-71.92686926999994, -54.607354424999926],
              [-71.90526282499991, -54.613213799999926],
              [-71.91445878799993, -54.60295989399992],
              [-71.91893469999991, -54.599541924999926],
              [-71.90233313699991, -54.59059010199991],
              [-71.89549719999991, -54.585056247999944],
              [-71.89159094999991, -54.579196872999944],
              [-71.88975989499994, -54.5681291649999],
              [-71.89378821499992, -54.56698984199994],
              [-71.90184485599991, -54.57000090899993],
              [-71.91209876199991, -54.57170989399992],
              [-71.94664466099994, -54.570570570999905],
              [-71.95327714799993, -54.56487395599993],
              [-71.93252519399994, -54.55120208099993],
              [-71.94786536399994, -54.54998137799993],
              [-72.00145423099991, -54.57170989399992],
              [-72.00108801999994, -54.55828215899993],
              [-71.99669348899994, -54.54802825299993],
              [-71.9895727199999, -54.53948333099993],
              [-71.98094641799992, -54.53134530999995],
              [-71.99836178299995, -54.51702239399992],
              [-72.00670325399994, -54.51311614399992],
              [-72.00772050699993, -54.50530364399992],
              [-72.00401770699995, -54.49895598799992],
              [-71.99836178299995, -54.499932549999926],
              [-71.9863988919999, -54.506524346999925],
              [-71.96873938699991, -54.51051197699991],
              [-71.95128333199995, -54.511976820999905],
              [-71.94001217399995, -54.510837497999944],
              [-71.99006100199995, -54.47861093499995],
              [-72.00234941299993, -54.45907968499995],
              [-71.97350012899994, -54.44866301899992],
              [-71.94180253799993, -54.46021900799991],
              [-71.92145748599995, -54.46428801899992],
              [-71.91746985599991, -54.46843840899993],
              [-71.91510982999995, -54.472914320999905],
              [-71.91209876199991, -54.47600676899992],
              [-71.88536536399994, -54.48284270599993],
              [-71.86583411399994, -54.50139739399992],
              [-71.85968990799995, -54.512790622999944],
              [-71.85741126199991, -54.52752044099992],
              [-71.84976152299993, -54.538181247999944],
              [-71.83185787699995, -54.54241301899992],
              [-71.79600989499994, -54.54501718499995],
              [-71.70592200399994, -54.56894296699994],
              [-71.67186438699991, -54.57170989399992],
              [-71.68309485599991, -54.56373463299991],
              [-71.70628821499992, -54.55486419099992],
              [-71.7168676419999, -54.54802825299993],
              [-71.7403051419999, -54.51832447699991],
              [-71.74819902299993, -54.510837497999944],
              [-71.71068274599992, -54.51051197699991],
              [-71.63170325399994, -54.546807549999926],
              [-71.58311926999994, -54.54501718499995],
              [-71.65762285099993, -54.513604424999926],
              [-71.69127356699994, -54.49138762799993],
              [-71.69359290299991, -54.46933359199994],
              [-71.71666419199994, -54.4626604149999],
              [-71.73778235599991, -54.465508721999925],
              [-71.75885982999995, -54.47193775799991],
              [-71.78172766799992, -54.47600676899992],
              [-71.83067786399994, -54.469008070999905],
              [-71.84068762899994, -54.465915622999944],
              [-71.85065670499995, -54.45452239399992],
              [-71.8528539699999, -54.445977471999925],
              [-71.84642493399991, -54.44109465899993],
              [-71.8301488919999, -54.441338799999926],
              [-71.83275305899991, -54.43222421699994],
              [-71.83698482999995, -54.42498137799993],
              [-71.84288489499994, -54.41912200299993],
              [-71.85065670499995, -54.41464609199994],
              [-71.81387285099993, -54.41619231599992],
              [-71.80284583199995, -54.41464609199994],
              [-71.79869544199994, -54.410414320999905],
              [-71.7942602199999, -54.40325286299992],
              [-71.7864477199999, -54.39657968499995],
              [-71.77208411399994, -54.39348723799992],
              [-71.74913489499994, -54.397149346999925],
              [-71.72500566299993, -54.40545012799993],
              [-71.71519934799994, -54.41480885199991],
              [-71.73452714799993, -54.42148202899995],
              [-71.73452714799993, -54.427666924999926],
              [-71.68919837099992, -54.44019947699991],
              [-71.61485755099994, -54.50139739399992],
              [-71.56322180899991, -54.510837497999944],
              [-71.56248938699991, -54.49179452899995],
              [-71.49522864499994, -54.49374765399995],
              [-71.49429277299993, -54.47600676899992],
              [-71.51671301999994, -54.46502044099992],
              [-71.57966061099995, -54.46209075299993],
              [-71.60415605399993, -54.44866301899992],
              [-71.60912024599992, -54.44215260199991],
              [-71.61489824099993, -54.431898695999905],
              [-71.61782792899993, -54.42066822699991],
              [-71.61412512899994, -54.41090260199991],
              [-71.59825598899994, -54.401055596999925],
              [-71.58731035099993, -54.405368747999944],
              [-71.56944739499994, -54.427666924999926],
              [-71.55915279899995, -54.43515390399995],
              [-71.54417883999992, -54.44345468499995],
              [-71.52892005099994, -54.448337497999944],
              [-71.51793372299994, -54.44500090899993],
              [-71.51402747299994, -54.43377044099992],
              [-71.51797441299993, -54.422539971999925],
              [-71.52627519399994, -54.41326262799993],
              [-71.53530839799993, -54.40715911299992],
              [-71.52000891799992, -54.40960051899992],
              [-71.49657141799992, -54.424086195999905],
              [-71.45958411399994, -54.43515390399995],
              [-71.45201575399994, -54.4353166649999],
              [-71.4348852199999, -54.43377044099992],
              [-71.41722571499992, -54.43596770599993],
              [-71.41055253799993, -54.43523528399993],
              [-71.40640214799993, -54.43694426899992],
              [-71.40493730399993, -54.44500090899993],
              [-71.40269934799994, -54.45281340899993],
              [-71.39696204299992, -54.45720794099992],
              [-71.38927161399994, -54.457289320999905],
              [-71.36701412699995, -54.444431247999944],
              [-71.33584550699993, -54.438571872999944],
              [-71.32306881399995, -54.427666924999926],
              [-71.34487870999993, -54.41765715899993],
              [-71.40599524599992, -54.41301848799992],
              [-71.4329320949999, -54.40097421699994],
              [-71.42345130099994, -54.39861419099992],
              [-71.41539466099994, -54.39421965899993],
              [-71.40908769399994, -54.38787200299993],
              [-71.40493730399993, -54.37981536299992],
              [-71.39146887899994, -54.38591887799993],
              [-71.38312740799995, -54.382745049999926],
              [-71.37559973899994, -54.37639739399992],
              [-71.36461341099994, -54.372979424999926],
              [-71.35212154899995, -54.37517669099992],
              [-71.33141028599994, -54.38445403399993],
              [-71.30064856699994, -54.39023202899995],
              [-71.18927975199995, -54.42848072699991],
              [-71.1673070949999, -54.441338799999926],
              [-71.14989173099991, -54.47698333099993],
              [-71.13084876199991, -54.49146900799991],
              [-71.09024003799993, -54.510837497999944],
              [-71.13955644399994, -54.45134856599992],
              [-71.14488684799994, -54.43515390399995],
              [-71.12515214799993, -54.433526299999926],
              [-71.01085364499994, -54.44866301899992],
              [-70.97240149599992, -54.469008070999905],
              [-70.96617591099994, -54.465915622999944],
              [-70.96617591099994, -54.440524997999944],
              [-70.96153723899994, -54.43124765399995],
              [-70.94969641799992, -54.427666924999926],
              [-70.93415279899995, -54.415948174999926],
              [-70.93639075399994, -54.38909270599993],
              [-70.95250403599994, -54.33879973799992],
              [-70.92931067599994, -54.34417083099993],
              [-70.90672766799992, -54.33603280999995],
              [-70.88394120999993, -54.3239885399999],
              [-70.86034094999991, -54.31780364399992],
              [-70.80064856699994, -54.31585051899992],
              [-70.77139238199993, -54.31951262799993],
              [-70.74767005099994, -54.33147551899992],
              [-70.74551347599993, -54.34531015399995],
              [-70.72484290299991, -54.34685637799993],
              [-70.6856176419999, -54.33879973799992],
              [-70.68211829299992, -54.33652109199994],
              [-70.67568925699993, -54.32773202899995],
              [-70.6719457669999, -54.325290622999944],
              [-70.66466223899994, -54.32496510199991],
              [-70.65412350199995, -54.330010674999926],
              [-70.64834550699993, -54.33147551899992],
              [-70.62804114499994, -54.33245208099993],
              [-70.6192113919999, -54.33473072699991],
              [-70.61046301999994, -54.33879973799992],
              [-70.70262610599991, -54.41806405999995],
              [-70.70775305899991, -54.42066822699991],
              [-70.72345943899995, -54.425713799999926],
              [-70.72716223899994, -54.427666924999926],
              [-70.72838294199994, -54.43482838299991],
              [-70.72557532499991, -54.43889739399992],
              [-70.72166907499991, -54.44182708099993],
              [-70.71971594999991, -54.44500090899993],
              [-70.71703040299991, -54.45859140399995],
              [-70.71255449099993, -54.46933359199994],
              [-70.71157792899993, -54.480726820999905],
              [-70.71971594999991, -54.49651458099993],
              [-70.77407792899993, -54.54412200299993],
              [-70.78180904899995, -54.56194426899992],
              [-70.78066972599993, -54.57154713299991],
              [-70.77745520699995, -54.58407968499995],
              [-70.77196204299992, -54.59490325299993],
              [-70.76439368399991, -54.599541924999926],
              [-70.75739498599995, -54.59335702899995],
              [-70.74815833199995, -54.56267669099992],
              [-70.74022376199991, -54.55120208099993],
              [-70.7051488919999, -54.58147551899992],
              [-70.68423417899993, -54.59433359199994],
              [-70.64146887899994, -54.60279713299991],
              [-70.63402258999992, -54.600274346999925],
              [-70.64150956899994, -54.58928801899992],
              [-70.65062415299991, -54.58212655999995],
              [-70.67878170499995, -54.565524997999944],
              [-70.70116126199991, -54.533461195999905],
              [-70.69692949099993, -54.494805596999925],
              [-70.67690995999993, -54.45712655999995],
              [-70.65143795499995, -54.427666924999926],
              [-70.6348363919999, -54.41423919099992],
              [-70.61046301999994, -54.39902109199994],
              [-70.58519446499992, -54.390557549999926],
              [-70.56582597599993, -54.39723072699991],
              [-70.56383216099994, -54.40203215899993],
              [-70.56212317599994, -54.41269296699994],
              [-70.55923417899993, -54.41464609199994],
              [-70.55500240799995, -54.4157854149999],
              [-70.54234778599994, -54.42197030999995],
              [-70.52887936099995, -54.430759372999944],
              [-70.49445553299995, -54.441338799999926],
              [-70.45889238199993, -54.46770598799992],
              [-70.43976803299995, -54.478448174999926],
              [-70.39574133999992, -54.486586195999905],
              [-70.34626217399995, -54.506931247999944],
              [-70.32933508999992, -54.51702239399992],
              [-70.28062903599994, -54.56170012799993],
              [-70.24941972599993, -54.57537200299993],
              [-70.23314368399991, -54.55120208099993],
              [-70.2571508449999, -54.54265715899993],
              [-70.27599036399994, -54.53240325299993],
              [-70.29059811099995, -54.51799895599993],
              [-70.30199133999992, -54.49651458099993],
              [-70.26016191299993, -54.504978122999944],
              [-70.17577063699991, -54.54045989399992],
              [-70.13072669199994, -54.54501718499995],
              [-70.15355383999992, -54.529961846999925],
              [-70.20872962099992, -54.51230234199994],
              [-70.25251217399995, -54.4860979149999],
              [-70.42764238199993, -54.43767669099992],
              [-70.44937089799993, -54.424493096999925],
              [-70.45567786399994, -54.416273695999905],
              [-70.45840410099993, -54.40699635199991],
              [-70.45909583199995, -54.38323333099993],
              [-70.50177975199995, -54.367120049999926],
              [-70.51366126199991, -54.359307549999926],
              [-70.4981176419999, -54.34099700299993],
              [-70.51032467399995, -54.32089609199994],
              [-70.55247962099992, -54.287367445999905],
              [-70.57770748599995, -54.27483489399992],
              [-70.65802975199995, -54.26409270599993],
              [-70.80719967399995, -54.269463799999926],
              [-70.84325110599991, -54.26311614399992],
              [-70.86856035099993, -54.24618905999995],
              [-70.88044186099995, -54.2224260399999],
              [-70.88752193899995, -54.19890715899993],
              [-70.8985082669999, -54.18181731599992],
              [-70.89167232999995, -54.17441171699994],
              [-70.87669837099992, -54.18206145599993],
              [-70.85826575399994, -54.18840911299992],
              [-70.82274329299992, -54.19548919099992],
              [-70.86929277299993, -54.16529713299991],
              [-70.88792883999992, -54.16130950299993],
              [-70.90290279899995, -54.15585702899995],
              [-70.91734778599994, -54.14267343499995],
              [-70.92821204299992, -54.1267229149999],
              [-70.93268795499995, -54.113539320999905],
              [-70.54043535099993, -54.256524346999925],
              [-70.42463131399995, -54.29306405999995],
              [-70.32249915299991, -54.325290622999944],
              [-70.31029212099992, -54.333103122999944],
              [-70.29991614499994, -54.342054945999905],
              [-70.28880774599992, -54.3493791649999],
              [-70.24596106699994, -54.3571916649999],
              [-70.22679602799991, -54.36923593499995],
              [-70.19212805899991, -54.40097421699994],
              [-70.1504613919999, -54.42392343499995],
              [-70.13687089799993, -54.427666924999926],
              [-70.14464270699995, -54.39137135199991],
              [-70.13573157499991, -54.38836028399993],
              [-70.08604895699995, -54.38323333099993],
              [-70.07290605399993, -54.377618096999925],
              [-70.07481848899994, -54.369805596999925],
              [-70.09593665299991, -54.359307549999926],
              [-70.16576087099992, -54.34929778399993],
              [-70.18529212099992, -54.33879973799992],
              [-70.19904537699995, -54.320570570999905],
              [-70.19286048099991, -54.311618747999944],
              [-70.15859941299993, -54.30478280999995],
              [-70.13988196499992, -54.2966447899999],
              [-70.13296464799993, -54.287367445999905],
              [-70.12677975199995, -54.27629973799992],
              [-70.11021887899994, -54.26311614399992],
              [-70.09019934799994, -54.25318775799991],
              [-70.07298743399991, -54.24879322699991],
              [-70.05549068899995, -54.25017669099992],
              [-70.0344945949999, -54.256931247999944],
              [-70.0000707669999, -54.27239348799992],
              [-69.98322506399995, -54.283868096999925],
              [-69.97301184799994, -54.29729583099993],
              [-69.97297115799995, -54.314711195999905],
              [-69.97695878799993, -54.33171965899993],
              [-69.9739477199999, -54.34531015399995],
              [-69.95254472599993, -54.352634372999944],
              [-69.9668676419999, -54.37981536299992],
              [-69.93858801999994, -54.37322356599992],
              [-69.92467200399994, -54.37379322699991],
              [-69.91161048099991, -54.37981536299992],
              [-69.90672766799992, -54.39006926899992],
              [-69.90758216099994, -54.401462497999944],
              [-69.90428626199991, -54.41073984199994],
              [-69.88707434799994, -54.41464609199994],
              [-69.87486731699994, -54.420993747999944],
              [-69.87059485599991, -54.43515390399995],
              [-69.87287350199995, -54.44931405999995],
              [-69.88023841099994, -54.45566171699994],
              [-69.88402258999992, -54.460870049999926],
              [-69.88365637899994, -54.50335051899992],
              [-69.87425696499992, -54.49960702899995],
              [-69.85798092399995, -54.48593515399995],
              [-69.85317949099993, -54.48284270599993],
              [-69.84878495999993, -54.48162200299993],
              [-69.83604895699995, -54.47535572699991],
              [-69.82485917899993, -54.46835702899995],
              [-69.81826738199993, -54.46998463299991],
              [-69.81187903599994, -54.47389088299991],
              [-69.7852270169999, -54.4841447899999],
              [-69.78477942599994, -54.50286223799992],
              [-69.79369055899991, -54.52353280999995],
              [-69.80174719999991, -54.53753020599993],
              [-69.79027258999992, -54.540948174999926],
              [-69.77538001199991, -54.55486419099992],
              [-69.76756751199991, -54.55486419099992],
              [-69.75747636599993, -54.54851653399993],
              [-69.75413977799991, -54.542901299999926],
              [-69.75666256399995, -54.53639088299991],
              [-69.76423092399995, -54.52752044099992],
              [-69.76378333199995, -54.51970794099992],
              [-69.74571692599994, -54.498711846999925],
              [-69.7403051419999, -54.48967864399992],
              [-69.74132239499994, -54.47795989399992],
              [-69.74681555899991, -54.4685197899999],
              [-69.76081295499995, -54.45566171699994],
              [-69.77912350199995, -54.44345468499995],
              [-69.79930579299992, -54.43320077899995],
              [-69.81554114499994, -54.42115650799991],
              [-69.82217363199993, -54.4040666649999],
              [-69.80801347599993, -54.38437265399995],
              [-69.8098852199999, -54.381524346999925],
              [-69.8137914699999, -54.379571221999925],
              [-69.82119706899994, -54.36858489399992],
              [-69.84430904899995, -54.360039971999925],
              [-69.84951738199993, -54.34921640399995],
              [-69.8489477199999, -54.3376604149999],
              [-69.85094153599994, -54.33294036299992],
              [-69.85700436099995, -54.325290622999944],
              [-69.86823482999995, -54.31804778399993],
              [-69.87779700399994, -54.31682708099993],
              [-69.88194739499994, -54.31267669099992],
              [-69.87682044199994, -54.29729583099993],
              [-69.85912024599992, -54.280368747999944],
              [-69.83511308499993, -54.279961846999925],
              [-69.77647864499994, -54.2927385399999],
              [-69.74714107999995, -54.30478280999995],
              [-69.69188391799992, -54.31780364399992],
              [-69.6524145169999, -54.34099700299993],
              [-69.63805091099994, -54.35588958099993],
              [-69.64342200399994, -54.36679452899995],
              [-69.63719641799992, -54.376071872999944],
              [-69.62926184799994, -54.38209400799991],
              [-69.60993404899995, -54.39348723799992],
              [-69.60545813699991, -54.39544036299992],
              [-69.59434973899994, -54.39812590899993],
              [-69.58877519399994, -54.40097421699994],
              [-69.58413652299993, -54.406914971999925],
              [-69.58202063699991, -54.419040622999944],
              [-69.57860266799992, -54.424493096999925],
              [-69.55858313699991, -54.43645598799992],
              [-69.53600012899994, -54.442071221999925],
              [-69.52204342399995, -54.43645598799992],
              [-69.52798417899993, -54.41464609199994],
              [-69.55874589799993, -54.388929945999905],
              [-69.57087154899995, -54.3728166649999],
              [-69.56525631399995, -54.35605234199994],
              [-69.54360917899993, -54.34124114399992],
              [-69.52293860599991, -54.33749765399995],
              [-69.50047766799992, -54.34221770599993],
              [-69.28783118399991, -54.427666924999926],
              [-69.24958248599995, -54.43645598799992],
              [-69.23997962099992, -54.441338799999926],
              [-69.23412024599992, -54.44963958099993],
              [-69.2278539699999, -54.46379973799992],
              [-69.22667395699995, -54.47698333099993],
              [-69.23631751199991, -54.48284270599993],
              [-69.25914466099994, -54.488539320999905],
              [-69.27627519399994, -54.501885674999926],
              [-69.29141191299993, -54.517836195999905],
              [-69.30825761599993, -54.53134530999995],
              [-69.34496008999992, -54.54501718499995],
              [-69.35606848899994, -54.55120208099993],
              [-69.36522376199991, -54.560479424999926],
              [-69.37364661399994, -54.57935963299991],
              [-69.38027910099993, -54.58928801899992],
              [-69.41746985599991, -54.623304945999905],
              [-69.39020748599995, -54.64739348799992],
              [-69.39622962099992, -54.65862395599993],
              [-69.39509029899995, -54.668226820999905],
              [-69.38817298099991, -54.676039320999905],
              [-69.37718665299991, -54.681573174999926],
              [-69.36823482999995, -54.663181247999944],
              [-69.37254798099991, -54.63811614399992],
              [-69.37303626199991, -54.615899346999925],
              [-69.35265051999994, -54.60637786299992],
              [-69.33165442599994, -54.59970468499995],
              [-69.3164770169999, -54.58342864399992],
              [-69.30321204299992, -54.56340911299992],
              [-69.28783118399991, -54.54501718499995],
              [-69.26943925699993, -54.53240325299993],
              [-69.24754798099991, -54.52548593499995],
              [-69.22443600199995, -54.527276299999926],
              [-69.20213782499991, -54.54119231599992],
              [-69.18163001199991, -54.57284921699994],
              [-69.16991126199991, -54.57822030999995],
              [-69.15746008999992, -54.558526299999926],
              [-69.16006425699993, -54.54216887799993],
              [-69.17516028599994, -54.48772551899992],
              [-69.17487545499995, -54.47600676899992],
              [-69.16966712099992, -54.471774997999944],
              [-69.16437740799995, -54.46249765399995],
              [-69.15746008999992, -54.453057549999926],
              [-69.14753170499995, -54.44866301899992],
              [-69.09813391799992, -54.447198174999926],
              [-69.08234615799995, -54.44866301899992],
              [-69.07017981699994, -54.4528947899999],
              [-69.04076087099992, -54.46933359199994],
              [-69.00967363199993, -54.47144947699991],
              [-68.99494381399995, -54.46843840899993],
              [-68.99640865799995, -54.45907968499995],
              [-68.99673417899993, -54.4509416649999],
              [-68.99168860599991, -54.440524997999944],
              [-68.98900305899991, -54.4314104149999],
              [-69.04076087099992, -54.40715911299992],
              [-69.09137936099995, -54.39137135199991],
              [-69.17174231699994, -54.38241952899995],
              [-69.19399980399993, -54.37184010199991],
              [-69.23253333199995, -54.34579843499995],
              [-69.27961178299995, -54.32154713299991],
              [-69.50690670499995, -54.260023695999905],
              [-69.53111731699994, -54.256931247999944],
              [-69.53872636599993, -54.25359465899993],
              [-69.55772864499994, -54.23748137799993],
              [-69.56851152299993, -54.22478606599992],
              [-69.58495032499991, -54.2224260399999],
              [-69.61681067599994, -54.22226327899995],
              [-69.88365637899994, -54.16130950299993],
              [-69.91234290299991, -54.142836195999905],
              [-69.9212133449999, -54.14031340899993],
              [-69.9258520169999, -54.13762786299992],
              [-69.97321529899995, -54.11874765399995],
              [-70.01402747299994, -54.113539320999905],
              [-70.05675208199995, -54.087009372999944],
              [-70.07359778599994, -54.05234140399995],
              [-70.08299719999991, -54.01230234199994],
              [-70.10338294199994, -53.96949635199991],
              [-70.12092037699995, -53.95086028399993],
              [-70.13621985599991, -53.93767669099992],
              [-70.14708411399994, -53.92229583099993],
              [-70.15591386599993, -53.873711846999925],
              [-70.17821204299992, -53.83342864399992],
              [-70.18529212099992, -53.81129322699991],
              [-70.17516028599994, -53.76051197699991],
              [-70.13695227799991, -53.73870208099993],
              [-70.0587199979999, -53.71212225799991],
              [-69.98036359399993, -53.687584933999915],
              [-69.92546440299992, -53.67885725299993],
              [-69.9157767239999, -53.661475192999944],
              [-69.87927704499992, -53.65788603099992],
              [-69.80676495999995, -53.66548269799995],
              [-69.65143987999994, -53.63623052499992],
              [-69.36084245099994, -53.52167450899992],
              [-69.32400882099995, -53.49227775599991],
              [-69.3186127269999, -53.450522830999944],
              [-69.3291721619999, -53.41537273199992],
              [-69.33315899599995, -53.3897599739999],
              [-69.3509008449999, -53.363213799999926],
              [-69.35265051999994, -53.355726820999905],
              [-69.39783447899993, -53.354204599999946],
              [-69.46330742799995, -53.35635950299991],
              [-69.67547349699993, -53.358357724999905],
              [-69.80497038399994, -53.382435563999934],
              [-69.89782239599992, -53.38664375099995],
              [-69.9502933089999, -53.39943047899993],
              [-69.98708747299992, -53.41785603799991],
              [-70.0216016629999, -53.43632606099993],
              [-70.05870520699995, -53.42701588299991],
              [-70.11644446499992, -53.43450286299992],
              [-70.13902747299994, -53.441664320999905],
              [-70.17955481699994, -53.463962497999944],
              [-70.20270748599995, -53.468682549999926],
              [-70.23094641799992, -53.46689218499995],
              [-70.25670325399994, -53.46103280999995],
              [-70.28018144399994, -53.45037200299993],
              [-70.30199133999992, -53.43450286299992],
              [-70.32852128799993, -53.4040666649999],
              [-70.34471594999991, -53.39177825299993],
              [-70.36717688699991, -53.38681405999995],
              [-70.39342200399994, -53.38372161299992],
              [-70.41958574099993, -53.37558359199994],
              [-70.44253495999993, -53.36248137799993],
              [-70.45909583199995, -53.34514739399992],
              [-70.46678626199991, -53.32952239399992],
              [-70.47354081899994, -53.309258721999925],
              [-70.46176415499991, -53.27214471099995],
              [-70.46259107399993, -53.22065406099995],
              [-70.45288245599994, -53.194578022999906],
              [-70.44719196999995, -53.181555859999946],
              [-70.43477675199995, -53.168641822999916],
              [-70.4339510719999, -53.151513879999925],
              [-70.43620465899994, -53.1282947979999],
              [-70.44019072599991, -53.10606116899993],
              [-70.4318170059999, -53.07093407799994],
              [-70.43226689799991, -53.04473561899994],
              [-70.42640421699991, -53.02671360399995],
              [-70.41899261099991, -53.01171639599994],
              [-70.39490040299995, -52.99800780499993],
              [-70.36241057599995, -52.98342042999991],
              [-70.34004007499993, -52.969678908999924],
              [-70.32811286599991, -52.964832213999955],
              [-70.31486503799994, -52.96804770099993],
              [-70.31371387399992, -52.98014655599991],
              [-70.32933975299994, -52.99299859799993],
              [-70.34292558499993, -53.00628020599993],
              [-70.33039266399993, -53.01714213799994],
              [-70.3157150209999, -53.02642754699991],
              [-70.31804379699992, -53.04149197699991],
              [-70.33523874899993, -53.051295798999945],
              [-70.32394519999991, -53.06153576899993],
              [-70.29696323599995, -53.05791917999994],
              [-70.24345211099995, -53.06172485899992],
              [-70.1834953579999, -53.02938145399992],
              [-70.13422928499995, -53.011950621999915],
              [-70.11633664399994, -52.98102091699991],
              [-70.10898005599995, -52.963018114999954],
              [-70.09809096899994, -52.946176443999946],
              [-70.08917481599991, -52.91106302299994],
              [-70.11042232999995, -52.887790622999944],
              [-70.13072669199994, -52.879571221999925],
              [-70.13817298099991, -52.879164320999905],
              [-70.14378821499992, -52.881524346999925],
              [-70.14899654899995, -52.88445403399993],
              [-70.15489661399994, -52.88591887799993],
              [-70.16193600199995, -52.88404713299991],
              [-70.17251542899993, -52.87558359199994],
              [-70.17788652299993, -52.87273528399993],
              [-70.20482337099992, -52.866306247999944],
              [-70.21939042899993, -52.865166924999926],
              [-70.22964433499993, -52.869073174999926],
              [-70.24449622299994, -52.879164320999905],
              [-70.26324142699991, -52.89336495799995],
              [-70.27546759299992, -52.906262916999935],
              [-70.30089064099991, -52.914930227999946],
              [-70.30365799899994, -52.9018031089999],
              [-70.28618728399994, -52.88294879499995],
              [-70.25720176399994, -52.868296175999944],
              [-70.26713081799994, -52.825869445999956],
              [-70.2826598549999, -52.79844867699995],
              [-70.33584550699993, -52.77703215899993],
              [-70.41551673099991, -52.77874114399992],
              [-70.42552649599992, -52.77662525799991],
              [-70.42589270699995, -52.76637135199991],
              [-70.41612708199995, -52.758070570999905],
              [-70.36876522099993, -52.74568893199995],
              [-70.2747289699999, -52.73560963299991],
              [-70.19865473099992, -52.73729588599991],
              [-70.16012232199995, -52.72980491299995],
              [-70.12861520899992, -52.7322824819999],
              [-70.11456260099993, -52.75664802499995],
              [-70.04666151899994, -52.81094109999992],
              [-70.00113300999993, -52.84173378899993],
              [-69.94976229799994, -52.8494370759999],
              [-69.9113997629999, -52.847904273999916],
              [-69.85321566599993, -52.79929942399991],
              [-69.8244030809999, -52.78252016399995],
              [-69.78434885599995, -52.777946125999904],
              [-69.7343510849999, -52.77445919099995],
              [-69.71398750899994, -52.760580940999944],
              [-69.70030782599991, -52.74763234399995],
              [-69.69155853199993, -52.73261308399992],
              [-69.67281922199993, -52.716685534999954],
              [-69.64038189699994, -52.68577291799994],
              [-69.61829704799993, -52.66784528399995],
              [-69.6046531529999, -52.65486351299995],
              [-69.59101107499993, -52.64187341099995],
              [-69.60142981699994, -52.61565520599993],
              [-69.60724850199995, -52.59693775799991],
              [-69.61790930899991, -52.57968515399995],
              [-69.62360592399995, -52.5603166649999],
              [-69.61815344999991, -52.53753020599993],
              [-69.60387122299994, -52.52117278399993],
              [-69.58389238199993, -52.50986093499995],
              [-69.50694739499994, -52.488539320999905],
              [-69.47130286399994, -52.47087981599992],
              [-69.45225989499994, -52.46502044099992],
              [-69.44054114499994, -52.458916924999926],
              [-69.42955481699994, -52.4548479149999],
              [-69.41756511599993, -52.451472415999945],
              [-69.3963158009999, -52.45574519899992],
              [-69.37415891799992, -52.47028987199991],
              [-69.3445647609999, -52.50610519499992],
              [-69.32806608899995, -52.524702660999935],
              [-69.3182411439999, -52.53982937399991],
              [-69.29730102399992, -52.56324461999992],
              [-69.2762235539999, -52.5798162289999],
              [-69.22594153599994, -52.63925546699994],
              [-69.18594316299993, -52.6677385399999],
              [-69.14024817599994, -52.68377044099992],
              [-69.08853105399993, -52.680352471999925],
              [-69.02025305899991, -52.6501604149999],
              [-68.96586479899992, -52.65093213499995],
              [-68.92065656299991, -52.64017525299994],
              [-68.8776627279999, -52.6232349359999],
              [-68.83580415199992, -52.60489930199992],
              [-68.81315844199992, -52.59128233799993],
              [-68.80063095399993, -52.57489161399991],
              [-68.79260930399994, -52.557802616999936],
              [-68.77902610599995, -52.548253849999924],
              [-68.76740475199995, -52.54843515399995],
              [-68.74596106699994, -52.556898695999905],
              [-68.67389889199995, -52.61541106599992],
              [-68.65632076699995, -52.62639739399992],
              [-68.62840735599991, -52.63925546699994],
              [-68.6276167764778, -52.639571698869695],
              [-68.6293721109999, -52.90720876099996],
              [-68.63123246299989, -53.17509938599995],
              [-68.63298946099988, -53.442886657999914],
              [-68.63474646099985, -53.710880634999924],
              [-68.63655513599994, -53.97877126099991],
              [-68.63831213399993, -54.24655853299988],
              [-68.6400970499999, -54.51476787199995],
              [-68.64188192676619, -54.78297131557072],
              [-68.70006262899994, -54.767836195999905],
              [-68.71239173099991, -54.77092864399992],
              [-68.70547441299993, -54.78069426899992],
              [-68.68374589799993, -54.7888322899999],
              [-68.64354407499991, -54.79810963299991],
              [-68.64199785099993, -54.799167575999945],
            ],
          ],
          [
            [
              [-80.75934811099995, -33.76677825299993],
              [-80.77733313699991, -33.73447030999995],
              [-80.76707923099991, -33.701104424999926],
              [-80.74083411399994, -33.68515390399995],
              [-80.71092688699991, -33.705336195999905],
              [-80.70726477799991, -33.71624114399992],
              [-80.70360266799992, -33.73447030999995],
              [-80.70205644399994, -33.75359465899993],
              [-80.70470130099994, -33.76677825299993],
              [-80.71532141799992, -33.77288176899992],
              [-80.73208574099993, -33.775323174999926],
              [-80.74889075399994, -33.77353280999995],
              [-80.75934811099995, -33.76677825299993],
            ],
          ],
          [
            [
              [-78.78897050699993, -33.60906340899993],
              [-78.78038489499994, -33.61345794099992],
              [-78.75763912699995, -33.643243096999925],
              [-78.76927649599992, -33.6423479149999],
              [-78.78018144399994, -33.64299895599993],
              [-78.79051673099991, -33.645603122999944],
              [-78.79987545499995, -33.650648695999905],
              [-78.80850175699993, -33.6443010399999],
              [-78.81285559799994, -33.650648695999905],
              [-78.84105383999992, -33.63632577899995],
              [-78.86363684799994, -33.63046640399995],
              [-78.88499915299991, -33.632745049999926],
              [-78.92100989499994, -33.64788176899992],
              [-78.94469153599994, -33.65292734199994],
              [-78.95689856699994, -33.656914971999925],
              [-78.97948157499991, -33.66912200299993],
              [-78.98737545499995, -33.66855234199994],
              [-78.99168860599991, -33.656914971999925],
              [-78.96703040299991, -33.63339609199994],
              [-78.94322669199994, -33.61646900799991],
              [-78.93317623599995, -33.61272551899992],
              [-78.91112219999991, -33.60702890399995],
              [-78.9016820949999, -33.602227471999925],
              [-78.89830481699994, -33.596368096999925],
              [-78.89565995999993, -33.58749765399995],
              [-78.89183508999992, -33.579196872999944],
              [-78.88487708199995, -33.57561614399992],
              [-78.87002519399994, -33.576836846999925],
              [-78.84813391799992, -33.58147551899992],
              [-78.82835852799991, -33.59059010199991],
              [-78.81973222599993, -33.60564544099992],
              [-78.81578528599994, -33.60881926899992],
              [-78.80675208199995, -33.609633070999905],
              [-78.78897050699993, -33.60906340899993],
            ],
          ],
          [
            [
              [-109.23159745999993, -27.092461846999925],
              [-109.2200414699999, -27.105238539999903],
              [-109.22655188699991, -27.118747653999947],
              [-109.24356035099993, -27.129164320999905],
              [-109.27391516799992, -27.13567473799992],
              [-109.29222571499992, -27.145603122999944],
              [-109.3042699859999, -27.14771900799991],
              [-109.32384192599994, -27.14902109199994],
              [-109.33238684799994, -27.15081145599993],
              [-109.34146074099993, -27.15398528399993],
              [-109.35130774599992, -27.15984465899993],
              [-109.35924231699994, -27.166761976999908],
              [-109.36778723899994, -27.172621351999908],
              [-109.37930253799993, -27.17506275799991],
              [-109.3887426419999, -27.17546965899993],
              [-109.3958227199999, -27.176853122999944],
              [-109.41030839799993, -27.181898695999905],
              [-109.41856848899994, -27.19198984199994],
              [-109.4292699859999, -27.199395440999922],
              [-109.44066321499992, -27.201429945999905],
              [-109.45132402299993, -27.195489190999922],
              [-109.45372473899994, -27.187758070999905],
              [-109.45103919199994, -27.179294528999947],
              [-109.44676673099991, -27.17115650799991],
              [-109.4234106109999, -27.09929778399993],
              [-109.41319739499994, -27.084730726999908],
              [-109.39688066299993, -27.06926848799992],
              [-109.37962805899991, -27.05950286299992],
              [-109.36632239499994, -27.06178150799991],
              [-109.31102454299992, -27.08562590899993],
              [-109.30134029899995, -27.087823174999926],
              [-109.27916419199994, -27.097100518999923],
              [-109.26943925699993, -27.09929778399993],
              [-109.26134192599994, -27.09734465899993],
              [-109.25194251199991, -27.09343840899993],
              [-109.24185136599993, -27.09075286299992],
              [-109.23159745999993, -27.092461846999925],
            ],
          ],
          [
            [
              [-105.45954342399995, -26.464776299999926],
              [-105.47093665299991, -26.457696221999925],
              [-105.46593176999994, -26.45549895599993],
              [-105.46349036399994, -26.456963799999926],
              [-105.46190344999991, -26.46062590899993],
              [-105.45954342399995, -26.464776299999926],
            ],
          ],
          [
            [
              [-79.90176347599993, -26.347426039999903],
              [-79.89073645699995, -26.351739190999922],
              [-79.89020748599995, -26.35605234199994],
              [-79.89736894399994, -26.358819268999923],
              [-79.90941321499992, -26.358168226999908],
              [-79.90176347599993, -26.347426039999903],
            ],
          ],
          [
            [
              [-80.09569251199991, -26.26604583099993],
              [-80.09483801999994, -26.267836195999905],
              [-80.09268144399994, -26.269463799999926],
              [-80.09072831899994, -26.271416924999926],
              [-80.09044348899994, -26.274509372999944],
              [-80.09923255099994, -26.275323174999926],
              [-80.10777747299994, -26.274997653999947],
              [-80.09569251199991, -26.26604583099993],
            ],
          ],
          [
            [
              [-67.24510657499991, -55.8396135399999],
              [-67.22862708199995, -55.84498463299991],
              [-67.21739661399994, -55.85173919099992],
              [-67.21495520699995, -55.86101653399993],
              [-67.22524980399993, -55.87379322699991],
              [-67.21947180899991, -55.875258070999905],
              [-67.21007239499994, -55.87948984199994],
              [-67.20417232999995, -55.8806291649999],
              [-67.22411048099991, -55.897556247999944],
              [-67.25812740799995, -55.89104583099993],
              [-67.32087154899995, -55.86760833099993],
              [-67.33844967399995, -55.86492278399993],
              [-67.34593665299991, -55.857679945999905],
              [-67.35020911399994, -55.84775155999995],
              [-67.35838782499991, -55.836602471999925],
              [-67.37132727799991, -55.831963799999926],
              [-67.40221106699994, -55.83668385199991],
              [-67.41706295499995, -55.83359140399995],
              [-67.40347245999993, -55.818617445999905],
              [-67.38267981699994, -55.81170012799993],
              [-67.35855058499993, -55.810479424999926],
              [-67.28197180899991, -55.820977471999925],
              [-67.25609290299991, -55.82887135199991],
              [-67.24510657499991, -55.8396135399999],
            ],
          ],
          [
            [
              [-67.09430904899995, -55.826104424999926],
              [-67.09740149599992, -55.83904387799993],
              [-67.09471594999991, -55.8571916649999],
              [-67.08755449099993, -55.87615325299993],
              [-67.07750403599994, -55.89153411299992],
              [-67.07237708199995, -55.90292734199994],
              [-67.07843990799995, -55.910088799999926],
              [-67.08995520699995, -55.91375090899993],
              [-67.10142981699994, -55.91480885199991],
              [-67.11432857999995, -55.91269296699994],
              [-67.12401282499991, -55.90699635199991],
              [-67.13927161399994, -55.89153411299992],
              [-67.14769446499992, -55.88616301899992],
              [-67.16490637899994, -55.87965260199991],
              [-67.17003333199995, -55.87379322699991],
              [-67.17186438699991, -55.86207447699991],
              [-67.16917883999992, -55.85165780999995],
              [-67.16372636599993, -55.84221770599993],
              [-67.15697180899991, -55.83359140399995],
              [-67.14037024599992, -55.81731536299992],
              [-67.12116451699995, -55.80754973799992],
              [-67.10081946499992, -55.80543385199991],
              [-67.08063717399995, -55.812432549999926],
              [-67.08145097599993, -55.81878020599993],
              [-67.08421790299991, -55.82236093499995],
              [-67.08869381399995, -55.82439544099992],
              [-67.09430904899995, -55.826104424999926],
            ],
          ],
          [
            [
              [-67.50161699099993, -55.82105885199991],
              [-67.49811676299993, -55.812576977999925],
              [-67.4815694799999, -55.80769089499995],
              [-67.4716027369999, -55.817704146999915],
              [-67.47559173099995, -55.82906354799991],
              [-67.47201342799991, -55.8425992949999],
              [-67.50729169899995, -55.830306649999955],
              [-67.53155443799994, -55.840833328999906],
              [-67.52931525199995, -55.857207408999955],
              [-67.54385718599991, -55.889845514999934],
              [-67.56813635799995, -55.89894387499993],
              [-67.59450192299994, -55.88454439599991],
              [-67.60984911999992, -55.89084580699995],
              [-67.60893898799992, -55.908639432999905],
              [-67.6218425799999, -55.9185042229999],
              [-67.64078281099995, -55.91411576299993],
              [-67.64691831599993, -55.90411121699992],
              [-67.6440659029999, -55.88919013799995],
              [-67.63232592199995, -55.8736208709999],
              [-67.63203018699994, -55.85939638199994],
              [-67.64866985999993, -55.85988550899992],
              [-67.66521814899994, -55.863307782999925],
              [-67.67530444599993, -55.861096895999935],
              [-67.68681062399992, -55.86743356099993],
              [-67.69591652699995, -55.880215954999926],
              [-67.69355835499994, -55.88952097799995],
              [-67.71251586699992, -55.88652334299991],
              [-67.73132691599994, -55.87709805399993],
              [-67.72101614499991, -55.86861084099991],
              [-67.7259725909999, -55.86358055599993],
              [-67.7320935219999, -55.85428033799991],
              [-67.74840891899993, -55.849203520999936],
              [-67.75497183099992, -55.85910579299991],
              [-67.77416036299991, -55.8675071909999],
              [-67.79327716599994, -55.872356563999915],
              [-67.79982838899991, -55.88085044399992],
              [-67.8028101829999, -55.89795643299993],
              [-67.82415486799994, -55.88993989799991],
              [-67.83656969399993, -55.87988601399991],
              [-67.8544022879999, -55.882603660999905],
              [-67.87728597099994, -55.88523808699995],
              [-67.90357904099994, -55.874318323999944],
              [-67.90199326299995, -55.86295898499992],
              [-67.90928221399992, -55.85082962599995],
              [-67.91394471199993, -55.836566116999904],
              [-67.89915837599995, -55.82841240999994],
              [-67.87526586199994, -55.82655114499994],
              [-67.8477022209999, -55.82370166599992],
              [-67.82750403599994, -55.816664320999905],
              [-67.80064856699994, -55.812432549999926],
              [-67.7881713939999, -55.820512125999926],
              [-67.7630100799999, -55.82566383099993],
              [-67.73523001099994, -55.82656410299995],
              [-67.71119170799994, -55.82531604099995],
              [-67.68839846299994, -55.82407009499991],
              [-67.67039562999992, -55.815731883999945],
              [-67.6580138189999, -55.82287287899993],
              [-67.61876380099994, -55.826104424999926],
              [-67.58349858899993, -55.8405117019999],
              [-67.56061764199995, -55.83798593499995],
              [-67.56918326699991, -55.82068757899992],
              [-67.58670034699992, -55.80990899599993],
              [-67.58907505499991, -55.80206994999992],
              [-67.56765903099995, -55.80718442999995],
              [-67.55190995999993, -55.81194426899992],
              [-67.5246195819999, -55.80744486399993],
              [-67.51326267999991, -55.80964496999991],
              [-67.50767981699994, -55.81568775799991],
              [-67.50161699099993, -55.82105885199991],
            ],
          ],
          [
            [
              [-67.23208574099993, -55.771416924999926],
              [-67.21397864499994, -55.761976820999905],
              [-67.18781490799995, -55.756931247999944],
              [-67.16490637899994, -55.760837497999944],
              [-67.15697180899991, -55.77825286299992],
              [-67.16787675699993, -55.78329843499995],
              [-67.17992102799991, -55.78460051899992],
              [-67.19229081899994, -55.78289153399993],
              [-67.20417232999995, -55.77825286299992],
              [-67.21165930899991, -55.79534270599993],
              [-67.22850501199991, -55.79843515399995],
              [-67.24010169199994, -55.789727471999925],
              [-67.23208574099993, -55.771416924999926],
            ],
          ],
          [
            [
              [-67.37608801999994, -55.75090911299992],
              [-67.38369706899994, -55.74814218499995],
              [-67.38853919199994, -55.74488697699991],
              [-67.39395097599993, -55.74293385199991],
              [-67.40343176999994, -55.74423593499995],
              [-67.42223059799994, -55.76051197699991],
              [-67.43073482999995, -55.763929945999905],
              [-67.44554602799991, -55.76262786299992],
              [-67.45213782499991, -55.756931247999944],
              [-67.45653235599991, -55.74968840899993],
              [-67.46483313699991, -55.74423593499995],
              [-67.47630774599992, -55.742445570999905],
              [-67.51329505099994, -55.74423593499995],
              [-67.53282630099994, -55.741306247999944],
              [-67.55182857999995, -55.73560963299991],
              [-67.56851152299993, -55.72730885199991],
              [-67.58153235599991, -55.71624114399992],
              [-67.58153235599991, -55.70940520599993],
              [-67.55068925699993, -55.706149997999944],
              [-67.53905188699991, -55.660088799999926],
              [-67.50584876199991, -55.6540666649999],
              [-67.49132239499994, -55.65894947699991],
              [-67.46654212099992, -55.67245859199994],
              [-67.44774329299992, -55.67522551899992],
              [-67.43504798099991, -55.68287525799991],
              [-67.42804928299995, -55.69784921699994],
              [-67.42064368399991, -55.70745208099993],
              [-67.40680904899995, -55.69939544099992],
              [-67.40436764199995, -55.68962981599992],
              [-67.40343176999994, -55.64788176899992],
              [-67.41209876199991, -55.63762786299992],
              [-67.42320716099994, -55.63128020599993],
              [-67.43285071499992, -55.62379322699991],
              [-67.43687903599994, -55.610039971999925],
              [-67.43199622299994, -55.5954729149999],
              [-67.41982988199993, -55.58709075299993],
              [-67.35912024599992, -55.57390715899993],
              [-67.34870357999995, -55.57561614399992],
              [-67.35496985599991, -55.585870049999926],
              [-67.35606848899994, -55.58912525799991],
              [-67.35582434799994, -55.592054945999905],
              [-67.35692298099991, -55.593682549999926],
              [-67.36180579299992, -55.59335702899995],
              [-67.34825598899994, -55.60035572699991],
              [-67.34508216099994, -55.60816822699991],
              [-67.34874426999994, -55.623711846999925],
              [-67.34520423099991, -55.63339609199994],
              [-67.32774817599994, -55.64470794099992],
              [-67.32087154899995, -55.6540666649999],
              [-67.33706620999993, -55.66171640399995],
              [-67.35000566299993, -55.67197030999995],
              [-67.3587133449999, -55.68629322699991],
              [-67.36180579299992, -55.70623137799993],
              [-67.34911048099991, -55.71062590899993],
              [-67.26992753799993, -55.71624114399992],
              [-67.26817786399994, -55.71933359199994],
              [-67.27721106699994, -55.73447030999995],
              [-67.27989661399994, -55.74081796699994],
              [-67.27529863199993, -55.74684010199991],
              [-67.26537024599992, -55.74920012799993],
              [-67.25584876199991, -55.753024997999944],
              [-67.25255286399994, -55.763929945999905],
              [-67.26475989499994, -55.77776458099993],
              [-67.29039466099994, -55.78329843499995],
              [-67.31932532499991, -55.786228122999944],
              [-67.34137936099995, -55.79192473799992],
              [-67.33971106699994, -55.76873137799993],
              [-67.34300696499992, -55.75855885199991],
              [-67.35423743399991, -55.75481536299992],
              [-67.37608801999994, -55.75090911299992],
            ],
          ],
          [
            [
              [-67.64313717399995, -55.49732838299991],
              [-67.61758378799993, -55.51287200299993],
              [-67.59557044199994, -55.533135674999926],
              [-67.58531653599994, -55.55413176899992],
              [-67.59520423099991, -55.572198174999926],
              [-67.59064693899995, -55.57903411299992],
              [-67.58775794199994, -55.585870049999926],
              [-67.61530514199995, -55.58806731599992],
              [-67.66104081899994, -55.60865650799991],
              [-67.71458899599992, -55.61988697699991],
              [-67.73119055899991, -55.62151458099993],
              [-67.73859615799995, -55.61687590899993],
              [-67.73688717399995, -55.60637786299992],
              [-67.73208574099993, -55.596368096999925],
              [-67.72468014199995, -55.58879973799992],
              [-67.71495520699995, -55.585870049999926],
              [-67.70148678299995, -55.58407968499995],
              [-67.69229081899994, -55.57935963299991],
              [-67.68667558499993, -55.57268645599993],
              [-67.68394934799994, -55.56536223799992],
              [-67.68382727799991, -55.55217864399992],
              [-67.68834387899994, -55.54420338299991],
              [-67.69420325399994, -55.53834400799991],
              [-67.69762122299994, -55.531182549999926],
              [-67.70124264199995, -55.51295338299991],
              [-67.69937089799993, -55.50546640399995],
              [-67.69139563699991, -55.497165622999944],
              [-67.68545488199993, -55.49382903399993],
              [-67.67870032499991, -55.49163176899992],
              [-67.67170162699995, -55.49065520599993],
              [-67.66490637899994, -55.490492445999905],
              [-67.66051184799994, -55.49098072699991],
              [-67.65534420499995, -55.492445570999905],
              [-67.64313717399995, -55.49732838299991],
            ],
          ],
          [
            [
              [-69.71450761599993, -55.34498463299991],
              [-69.67467200399994, -55.3552385399999],
              [-69.65615800699993, -55.36419036299992],
              [-69.64037024599992, -55.37704843499995],
              [-69.63731848899994, -55.38836028399993],
              [-69.65550696499992, -55.385837497999944],
              [-69.68846594999991, -55.37363046699994],
              [-69.70645097599993, -55.376885674999926],
              [-69.70116126199991, -55.384698174999926],
              [-69.67145748599995, -55.401462497999944],
              [-69.68602454299992, -55.407321872999944],
              [-69.70274817599994, -55.40894947699991],
              [-69.80174719999991, -55.40781015399995],
              [-69.79417883999992, -55.398695570999905],
              [-69.78929602799991, -55.39031340899993],
              [-69.78380286399994, -55.38372161299992],
              [-69.77440344999991, -55.38046640399995],
              [-69.78091386599993, -55.36541106599992],
              [-69.80174719999991, -55.33261484199994],
              [-69.71450761599993, -55.34498463299991],
            ],
          ],
          [
            [
              [-70.01402747299994, -55.30592213299991],
              [-69.97150631399995, -55.28826262799993],
              [-69.94782467399995, -55.283868096999925],
              [-69.94513912699995, -55.29851653399993],
              [-69.97984778599994, -55.32634856599992],
              [-69.98216712099992, -55.335056247999944],
              [-69.98460852799991, -55.35947030999995],
              [-69.98668372299994, -55.36614348799992],
              [-70.00645911399994, -55.37444426899992],
              [-70.01699785099993, -55.36093515399995],
              [-70.02611243399991, -55.34148528399993],
              [-70.04133053299995, -55.33261484199994],
              [-70.03758704299992, -55.330743096999925],
              [-70.03482011599993, -55.32903411299992],
              [-70.03189042899993, -55.32740650799991],
              [-70.02765865799995, -55.32634856599992],
              [-70.02765865799995, -55.31894296699994],
              [-70.04832923099991, -55.31145598799992],
              [-70.06802324099993, -55.31170012799993],
              [-70.08820553299995, -55.30901458099993],
              [-70.11021887899994, -55.29225025799991],
              [-70.0950414699999, -55.29176197699991],
              [-70.06932532499991, -55.28525155999995],
              [-70.05500240799995, -55.28484465899993],
              [-70.04454505099994, -55.28866952899995],
              [-70.02358964799993, -55.302666924999926],
              [-70.01402747299994, -55.30592213299991],
            ],
          ],
          [
            [
              [-66.85533606699994, -55.27117278399993],
              [-66.82957923099991, -55.28248463299991],
              [-66.83958899599992, -55.3025041649999],
              [-66.86766516799992, -55.322198174999926],
              [-66.89631100199995, -55.33261484199994],
              [-66.93805904899995, -55.33456796699994],
              [-67.06017005099994, -55.32634856599992],
              [-67.0501195949999, -55.307305596999925],
              [-67.05532792899993, -55.29924895599993],
              [-67.06655839799993, -55.29265715899993],
              [-67.07445227799991, -55.278008721999925],
              [-67.06940670499995, -55.26718515399995],
              [-67.05573482999995, -55.254571221999925],
              [-67.03941809799994, -55.24358489399992],
              [-67.02660071499992, -55.236993096999925],
              [-66.99225826699995, -55.22869231599992],
              [-66.87511145699995, -55.23088958099993],
              [-66.86530514199995, -55.23300546699994],
              [-66.85716712099992, -55.23788827899995],
              [-66.85106360599991, -55.24765390399995],
              [-66.84943600199995, -55.25351327899995],
              [-66.84850012899994, -55.261651299999926],
              [-66.84992428299995, -55.268649997999944],
              [-66.85533606699994, -55.27117278399993],
            ],
          ],
          [
            [
              [-66.42674719999991, -55.185479424999926],
              [-66.42080644399994, -55.20086028399993],
              [-66.43635006399995, -55.209649346999925],
              [-66.47175045499995, -55.21648528399993],
              [-66.48265540299991, -55.227227471999925],
              [-66.50401770699995, -55.25798919099992],
              [-66.51549231699994, -55.264336846999925],
              [-66.53522701699995, -55.267510674999926],
              [-66.56932532499991, -55.28167083099993],
              [-66.58779863199993, -55.28484465899993],
              [-66.59349524599992, -55.28142669099992],
              [-66.59829667899993, -55.27499765399995],
              [-66.60391191299993, -55.27076588299991],
              [-66.62083899599992, -55.27947356599992],
              [-66.62975012899994, -55.27792734199994],
              [-66.63752193899995, -55.27206796699994],
              [-66.64305579299992, -55.264336846999925],
              [-66.64525305899991, -55.25074635199991],
              [-66.64297441299993, -55.23333098799992],
              [-66.63805091099994, -55.216729424999926],
              [-66.63219153599994, -55.20598723799992],
              [-66.61913001199991, -55.19801197699991],
              [-66.56729081899994, -55.18238697699991],
              [-66.54613196499992, -55.16838958099993],
              [-66.53482011599993, -55.162774346999925],
              [-66.52245032499991, -55.16033294099992],
              [-66.50861568899995, -55.16301848799992],
              [-66.48452714799993, -55.176853122999944],
              [-66.47175045499995, -55.18238697699991],
              [-66.46060136599993, -55.18303801899992],
              [-66.43635006399995, -55.1814104149999],
              [-66.42674719999991, -55.185479424999926],
            ],
          ],
          [
            [
              [-66.86900794199994, -55.024102471999925],
              [-66.84801184799994, -55.039320570999905],
              [-66.83096269399994, -55.0622697899999],
              [-66.80687415299991, -55.11288827899995],
              [-66.85171464799993, -55.10662200299993],
              [-66.92784583199995, -55.06267669099992],
              [-66.99010169199994, -55.04762135199991],
              [-67.03571529899995, -55.02849700299993],
              [-67.06623287699995, -55.022149346999925],
              [-67.07095292899993, -55.01677825299993],
              [-67.07091223899994, -55.00945403399993],
              [-67.06602942599994, -55.00115325299993],
              [-67.04702714799993, -54.99114348799992],
              [-67.02391516799992, -54.992445570999905],
              [-66.97858639199995, -55.004571221999925],
              [-66.89561926999994, -55.01572030999995],
              [-66.86900794199994, -55.024102471999925],
            ],
          ],
          [
            [
              [-67.99925696499992, -55.62753671699994],
              [-68.01781165299991, -55.64137135199991],
              [-68.02717037699995, -55.6501604149999],
              [-68.03335527299993, -55.66155364399992],
              [-67.99819902299993, -55.660414320999905],
              [-67.98485266799992, -55.66415780999995],
              [-67.98558508999992, -55.67522551899992],
              [-67.99290930899991, -55.67701588299991],
              [-68.03677324099993, -55.69573333099993],
              [-68.06159420499995, -55.71306731599992],
              [-68.07152258999992, -55.71624114399992],
              [-68.08922278599994, -55.71526458099993],
              [-68.09829667899993, -55.71209075299993],
              [-68.11595618399991, -55.69573333099993],
              [-68.13560950399994, -55.68124765399995],
              [-68.14378821499992, -55.672946872999944],
              [-68.15005449099993, -55.66155364399992],
              [-68.15025794199994, -55.65585702899995],
              [-68.14403235599991, -55.64706796699994],
              [-68.14321855399993, -55.64104583099993],
              [-68.14622962099992, -55.63494231599992],
              [-68.15510006399995, -55.6267229149999],
              [-68.15689042899993, -55.623711846999925],
              [-68.15196692599994, -55.60361093499995],
              [-68.15330969999991, -55.59628671699994],
              [-68.16372636599993, -55.59335702899995],
              [-68.17666581899994, -55.59587981599992],
              [-68.21153723899994, -55.61370208099993],
              [-68.23534094999991, -55.617445570999905],
              [-68.26748613199993, -55.617852471999925],
              [-68.28978430899991, -55.61012135199991],
              [-68.28380286399994, -55.58953215899993],
              [-68.25609290299991, -55.55868905999995],
              [-68.24864661399994, -55.54176197699991],
              [-68.25251217399995, -55.524509372999944],
              [-68.26984615799995, -55.51653411299992],
              [-68.32900956899994, -55.50318775799991],
              [-68.34186764199995, -55.49374765399995],
              [-68.35362708199995, -55.475274346999925],
              [-68.38011633999992, -55.480401299999926],
              [-68.42503821499992, -55.503838799999926],
              [-68.45750891799992, -55.50310637799993],
              [-68.50047766799992, -55.49098072699991],
              [-68.53807532499991, -55.472588799999926],
              [-68.55418860599991, -55.45232512799993],
              [-68.55418860599991, -55.43254973799992],
              [-68.55577551999994, -55.42351653399993],
              [-68.56090247299994, -55.42115650799991],
              [-68.57184811099995, -55.42131926899992],
              [-68.57583574099993, -55.42400481599992],
              [-68.57974199099993, -55.42978280999995],
              [-68.58560136599993, -55.43482838299991],
              [-68.59508216099994, -55.43564218499995],
              [-68.59679114499994, -55.43084075299993],
              [-68.59788977799991, -55.42107512799993],
              [-68.60301673099991, -55.41179778399993],
              [-68.61681067599994, -55.40781015399995],
              [-68.61750240799995, -55.42327239399992],
              [-68.61514238199993, -55.437432549999926],
              [-68.61021887899994, -55.45045338299991],
              [-68.60252844999991, -55.46233489399992],
              [-68.68468176999994, -55.45794036299992],
              [-68.71178137899994, -55.46607838299991],
              [-68.73151607999995, -55.46493905999995],
              [-68.77330481699994, -55.428806247999944],
              [-68.80113684799994, -55.42131926899992],
              [-68.77448482999995, -55.45126718499995],
              [-68.77220618399991, -55.46379973799992],
              [-68.80113684799994, -55.46233489399992],
              [-68.77651933499993, -55.4821916649999],
              [-68.76829993399991, -55.49260833099993],
              [-68.78010006399995, -55.497165622999944],
              [-68.79893958199995, -55.499118747999944],
              [-68.83291581899994, -55.508070570999905],
              [-68.85269120999993, -55.510023695999905],
              [-68.86534583199995, -55.50530364399992],
              [-68.88255774599992, -55.49431731599992],
              [-68.89769446499992, -55.48186614399992],
              [-68.90420488199993, -55.47283294099992],
              [-68.90925045499995, -55.46298593499995],
              [-68.93594316299993, -55.453383070999905],
              [-68.94859778599994, -55.445570570999905],
              [-68.96735592399995, -55.429945570999905],
              [-68.97105872299994, -55.42115650799991],
              [-68.96568762899994, -55.40781015399995],
              [-68.95596269399994, -55.402601820999905],
              [-68.90420488199993, -55.38730234199994],
              [-68.88402258999992, -55.38518645599993],
              [-68.82795162699995, -55.38730234199994],
              [-68.77232825399994, -55.38005950299993],
              [-68.75340735599991, -55.38046640399995],
              [-68.76789303299995, -55.37810637799993],
              [-68.8086645169999, -55.35995859199994],
              [-68.8086645169999, -55.35312265399995],
              [-68.76024329299992, -55.33261484199994],
              [-68.78600012899994, -55.331963799999926],
              [-68.9505102199999, -55.381117445999905],
              [-68.96304277299993, -55.38225676899992],
              [-68.97130286399994, -55.37712981599992],
              [-68.96605383999992, -55.36842213299991],
              [-68.92764238199993, -55.340101820999905],
              [-68.91746985599991, -55.33473072699991],
              [-68.90762285099993, -55.33261484199994],
              [-68.89785722599993, -55.32781340899993],
              [-68.89639238199993, -55.31650155999995],
              [-68.89781653599994, -55.30315520599993],
              [-68.89679928299995, -55.29225025799991],
              [-68.8887426419999, -55.281508070999905],
              [-68.85582434799994, -55.25750090899993],
              [-68.86074785099993, -55.25286223799992],
              [-68.8653051419999, -55.246351820999905],
              [-68.87010657499991, -55.24382903399993],
              [-68.86424719999991, -55.233493747999944],
              [-68.85484778599994, -55.22470468499995],
              [-68.84349524599992, -55.218682549999926],
              [-68.83161373599995, -55.21648528399993],
              [-68.82640540299991, -55.2126604149999],
              [-68.80850175699993, -55.19451262799993],
              [-68.80113684799994, -55.18865325299993],
              [-68.82477779899995, -55.18759530999995],
              [-68.90420488199993, -55.22275155999995],
              [-68.94908606699994, -55.2321916649999],
              [-68.95946204299992, -55.236993096999925],
              [-68.96568762899994, -55.25514088299991],
              [-68.96910559799994, -55.26091887799993],
              [-68.97655188699991, -55.26441822699991],
              [-68.98668372299994, -55.26523202899995],
              [-69.0371801419999, -55.26230234199994],
              [-69.05679277299993, -55.25351327899995],
              [-69.08853105399993, -55.22275155999995],
              [-69.09805253799993, -55.21640390399995],
              [-69.10798092399995, -55.21152109199994],
              [-69.11660722599993, -55.20566171699994],
              [-69.12267005099994, -55.19605885199991],
              [-69.12389075399994, -55.18287525799991],
              [-69.11880449099993, -55.15984465899993],
              [-69.12267005099994, -55.14763762799993],
              [-69.15143795499995, -55.17083098799992],
              [-69.14439856699994, -55.196384372999944],
              [-69.1231176419999, -55.22144947699991],
              [-69.10903886599993, -55.24382903399993],
              [-69.1341039699999, -55.24773528399993],
              [-69.16486568899995, -55.242120049999926],
              [-69.19359290299991, -55.23056405999995],
              [-69.21271725199995, -55.21648528399993],
              [-69.22008216099994, -55.20566171699994],
              [-69.22647050699993, -55.192478122999944],
              [-69.23086503799993, -55.178399346999925],
              [-69.23253333199995, -55.16497161299992],
              [-69.23737545499995, -55.156508070999905],
              [-69.24596106699994, -55.15195077899995],
              [-69.24974524599992, -55.1443010399999],
              [-69.23997962099992, -55.12712981599992],
              [-69.25047766799992, -55.129978122999944],
              [-69.26732337099992, -55.13884856599992],
              [-69.27383378799993, -55.14080169099992],
              [-69.32095292899993, -55.13958098799992],
              [-69.35244706899994, -55.152276299999926],
              [-69.41454016799992, -55.15642669099992],
              [-69.43862870999993, -55.1618791649999],
              [-69.41950436099995, -55.16611093499995],
              [-69.38475501199991, -55.158135674999926],
              [-69.36660722599993, -55.158135674999926],
              [-69.35212154899995, -55.16423919099992],
              [-69.30557206899994, -55.16545989399992],
              [-69.28783118399991, -55.16814544099992],
              [-69.29710852799991, -55.17351653399993],
              [-69.3008520169999, -55.17498137799993],
              [-69.29190019399994, -55.19036223799992],
              [-69.27212480399993, -55.21347421699994],
              [-69.26732337099992, -55.23015715899993],
              [-69.29613196499992, -55.22226327899995],
              [-69.3223363919999, -55.22673919099992],
              [-69.37718665299991, -55.24382903399993],
              [-69.40904700399994, -55.24684010199991],
              [-69.42495683499993, -55.2458635399999],
              [-69.43179277299993, -55.24041106599992],
              [-69.43809973899994, -55.23064544099992],
              [-69.45254472599993, -55.22942473799992],
              [-69.46857662699995, -55.23284270599993],
              [-69.47960364499994, -55.236993096999925],
              [-69.47960364499994, -55.24382903399993],
              [-69.47044837099992, -55.249118747999944],
              [-69.46153723899994, -55.25750090899993],
              [-69.45466061099995, -55.26604583099993],
              [-69.45164954299992, -55.27117278399993],
              [-69.45006262899994, -55.27971770599993],
              [-69.44981848899994, -55.28728606599992],
              [-69.45225989499994, -55.295586846999925],
              [-69.45909583199995, -55.30592213299991],
              [-69.44684811099995, -55.30348072699991],
              [-69.42906653599994, -55.289727471999925],
              [-69.41812089799993, -55.28484465899993],
              [-69.40583248599995, -55.28443775799991],
              [-69.39281165299991, -55.287367445999905],
              [-69.38044186099995, -55.29265715899993],
              [-69.36974036399994, -55.29851653399993],
              [-69.36009680899991, -55.30543385199991],
              [-69.35521399599992, -55.310479424999926],
              [-69.34898841099994, -55.31462981599992],
              [-69.33560136599993, -55.31894296699994],
              [-69.32054602799991, -55.31894296699994],
              [-69.30703691299993, -55.31454843499995],
              [-69.29405676999994, -55.3122697899999],
              [-69.28038489499994, -55.31894296699994],
              [-69.2884008449999, -55.32366301899992],
              [-69.30581620999993, -55.33066171699994],
              [-69.31509355399993, -55.33261484199994],
              [-69.31509355399993, -55.33945077899995],
              [-69.30606035099993, -55.34295012799993],
              [-69.30231686099995, -55.34661223799992],
              [-69.30321204299992, -55.35198333099993],
              [-69.30825761599993, -55.35995859199994],
              [-69.29015051999994, -55.36272551899992],
              [-69.26187089799993, -55.364353122999944],
              [-69.24058997299994, -55.36956145599993],
              [-69.24339758999992, -55.383884372999944],
              [-69.28042558499993, -55.401462497999944],
              [-69.2988988919999, -55.41375090899993],
              [-69.3008520169999, -55.42815520599993],
              [-69.29283606699994, -55.43027109199994],
              [-69.26357988199993, -55.42791106599992],
              [-69.25365149599992, -55.42815520599993],
              [-69.24795488199993, -55.43303801899992],
              [-69.24396725199995, -55.440118096999925],
              [-69.23867753799993, -55.44646575299993],
              [-69.22948157499991, -55.44931405999995],
              [-69.20616614499994, -55.437758070999905],
              [-69.19497636599993, -55.43564218499995],
              [-69.16519120999993, -55.43710702899995],
              [-69.13703365799995, -55.44182708099993],
              [-69.17223059799994, -55.46168385199991],
              [-69.17796790299991, -55.469821872999944],
              [-69.17430579299992, -55.47771575299993],
              [-69.15514075399994, -55.48495859199994],
              [-69.15062415299991, -55.49374765399995],
              [-69.16161048099991, -55.514336846999925],
              [-69.18639075399994, -55.50408294099992],
              [-69.22638912699995, -55.469821872999944],
              [-69.24909420499995, -55.46917083099993],
              [-69.29938717399995, -55.49032968499995],
              [-69.31883704299992, -55.48691171699994],
              [-69.3294164699999, -55.47991301899992],
              [-69.33922278599994, -55.474867445999905],
              [-69.34642493399991, -55.46721770599993],
              [-69.34923255099994, -55.45232512799993],
              [-69.34740149599992, -55.41765715899993],
              [-69.34923255099994, -55.40781015399995],
              [-69.36286373599995, -55.388929945999905],
              [-69.37608801999994, -55.3903947899999],
              [-69.38621985599991, -55.40488046699994],
              [-69.39020748599995, -55.42473723799992],
              [-69.39102128799993, -55.446384372999944],
              [-69.39484615799995, -55.46917083099993],
              [-69.40330969999991, -55.4880510399999],
              [-69.41812089799993, -55.497165622999944],
              [-69.43708248599995, -55.491306247999944],
              [-69.44237219999991, -55.4724260399999],
              [-69.43862870999993, -55.431898695999905],
              [-69.45152747299994, -55.408868096999925],
              [-69.50804602799991, -55.40862395599993],
              [-69.52057857999995, -55.39397551899992],
              [-69.50405839799993, -55.38046640399995],
              [-69.39769446499992, -55.35995859199994],
              [-69.4160863919999, -55.35312265399995],
              [-69.48704993399991, -55.35995859199994],
              [-69.48704993399991, -55.35312265399995],
              [-69.48106848899994, -55.350274346999925],
              [-69.46593176999994, -55.33945077899995],
              [-69.49376380099994, -55.33611419099992],
              [-69.50934811099995, -55.34612395599993],
              [-69.52293860599991, -55.35947030999995],
              [-69.54478919199994, -55.36614348799992],
              [-69.60765540299991, -55.365492445999905],
              [-69.63044186099995, -55.35995859199994],
              [-69.61253821499992, -55.35442473799992],
              [-69.60651607999995, -55.347914320999905],
              [-69.60985266799992, -55.33993905999995],
              [-69.62018795499995, -55.32952239399992],
              [-69.63068600199995, -55.32659270599993],
              [-69.66421464799993, -55.32830169099992],
              [-69.67882239499994, -55.32634856599992],
              [-69.68919837099992, -55.320570570999905],
              [-69.69847571499992, -55.31389739399992],
              [-69.70986894399994, -55.30828215899993],
              [-69.72667395699995, -55.30592213299991],
              [-69.78807532499991, -55.30592213299991],
              [-69.77725175699993, -55.29420338299991],
              [-69.76187089799993, -55.29143645599993],
              [-69.74498450399994, -55.292087497999944],
              [-69.72964433499993, -55.29111093499995],
              [-69.67080644399994, -55.27418385199991],
              [-69.64997311099995, -55.27166106599992],
              [-69.56895911399994, -55.27117278399993],
              [-69.59300696499992, -55.26327890399995],
              [-69.61628170499995, -55.261651299999926],
              [-69.66828365799995, -55.264336846999925],
              [-69.67398027299993, -55.26034921699994],
              [-69.67003333199995, -55.25123463299991],
              [-69.65770423099991, -55.236993096999925],
              [-69.63914954299992, -55.228773695999905],
              [-69.54637610599991, -55.20582447699991],
              [-69.53111731699994, -55.199151299999926],
              [-69.50389563699991, -55.18059661299992],
              [-69.5000707669999, -55.17498137799993],
              [-69.5078832669999, -55.171807549999926],
              [-69.55158443899995, -55.17498137799993],
              [-69.56895911399994, -55.179945570999905],
              [-69.60586503799993, -55.20330169099992],
              [-69.62360592399995, -55.209649346999925],
              [-69.63902747299994, -55.208916924999926],
              [-69.64948482999995, -55.20582447699991],
              [-69.65819251199991, -55.20566171699994],
              [-69.66828365799995, -55.21306731599992],
              [-69.67251542899993, -55.219414971999925],
              [-69.67528235599991, -55.22503020599993],
              [-69.68049068899995, -55.23064544099992],
              [-69.69188391799992, -55.236993096999925],
              [-69.71690833199995, -55.24374765399995],
              [-69.84805253799993, -55.25790780999995],
              [-69.86685136599993, -55.25408294099992],
              [-69.86314856699994, -55.236993096999925],
              [-69.87840735599991, -55.23300546699994],
              [-69.91055253799993, -55.229180596999925],
              [-69.92467200399994, -55.22275155999995],
              [-69.87608801999994, -55.22144947699991],
              [-69.85240637899994, -55.215508721999925],
              [-69.8352758449999, -55.20232512799993],
              [-69.89403235599991, -55.201104424999926],
              [-69.91161048099991, -55.19605885199991],
              [-69.90160071499992, -55.18613046699994],
              [-69.84268144399994, -55.16814544099992],
              [-69.86733964799993, -55.16375090899993],
              [-69.95958411399994, -55.16179778399993],
              [-69.98326575399994, -55.16497161299992],
              [-70.00210527299993, -55.17115650799991],
              [-70.02000891799992, -55.16423919099992],
              [-70.03148352799991, -55.15325286299992],
              [-70.03107662699995, -55.14763762799993],
              [-70.02183997299994, -55.14316171699994],
              [-69.98668372299994, -55.11288827899995],
              [-69.97716223899994, -55.12509530999995],
              [-69.96593176999994, -55.12664153399993],
              [-69.95645097599993, -55.11882903399993],
              [-69.94758053299995, -55.08709075299993],
              [-69.93529212099992, -55.07927825299993],
              [-69.88597571499992, -55.063571872999944],
              [-69.82217363199993, -55.065118096999925],
              [-69.77301998599995, -55.053399346999925],
              [-69.65025794199994, -55.05169036299992],
              [-69.61681067599994, -55.04143645599993],
              [-69.58747311099995, -55.04119231599992],
              [-69.57526607999995, -55.066338799999926],
              [-69.56997636599993, -55.10051848799992],
              [-69.56151282499991, -55.12712981599992],
              [-69.58202063699991, -55.15447356599992],
              [-69.54149329299992, -55.14511484199994],
              [-69.53819739499994, -55.1208635399999],
              [-69.54678300699993, -55.08798593499995],
              [-69.54165605399993, -55.05201588299991],
              [-69.5462133449999, -55.03753020599993],
              [-69.52757727799991, -55.03199635199991],
              [-69.47960364499994, -55.03093840899993],
              [-69.44570878799993, -55.01832447699991],
              [-69.43862870999993, -55.016696872999944],
              [-69.42593339799993, -55.02304452899995],
              [-69.42650305899991, -55.03134530999995],
              [-69.43480383999992, -55.03915780999995],
              [-69.44546464799993, -55.04461028399993],
              [-69.42979895699995, -55.052666924999926],
              [-69.41673743399991, -55.049899997999944],
              [-69.40416419199994, -55.042901299999926],
              [-69.39020748599995, -55.03834400799991],
              [-69.37458248599995, -55.03980885199991],
              [-69.34463456899994, -55.04924895599993],
              [-69.32876542899993, -55.05201588299991],
              [-69.33763587099992, -55.038995049999926],
              [-69.38341223899994, -55.016696872999944],
              [-69.3196508449999, -54.99334075299993],
              [-69.28563391799992, -54.98707447699991],
              [-69.25365149599992, -54.99065520599993],
              [-69.21328691299993, -55.0134416649999],
              [-69.19871985599991, -55.016696872999944],
              [-69.18553626199991, -55.01327890399995],
              [-69.18883216099994, -55.00546640399995],
              [-69.20055091099994, -54.996758721999925],
              [-69.21271725199995, -54.99065520599993],
              [-69.18370520699995, -54.992445570999905],
              [-69.12584387899994, -54.988539320999905],
              [-69.09601803299995, -54.99065520599993],
              [-69.06305904899995, -55.00204843499995],
              [-69.05101477799991, -55.00359465899993],
              [-69.03966223899994, -55.00042083099993],
              [-69.02415930899991, -54.98642343499995],
              [-69.01349850199995, -54.98316822699991],
              [-68.83438066299993, -54.981540622999944],
              [-68.73546301999994, -54.94963958099993],
              [-68.68472245999993, -54.94215260199991],
              [-68.57526607999995, -54.94215260199991],
              [-68.56444251199991, -54.940118096999925],
              [-68.53913326699995, -54.93092213299991],
              [-68.52745520699995, -54.92848072699991],
              [-68.51357988199993, -54.92888762799993],
              [-68.44115149599992, -54.939711195999905],
              [-68.41698157499991, -54.94841887799993],
              [-68.40611731699994, -54.95435963299991],
              [-68.37385006399995, -54.98088958099993],
              [-68.34569251199991, -54.99846770599993],
              [-68.33507239499994, -55.010430596999925],
              [-68.32860266799992, -55.02792734199994],
              [-68.32835852799991, -55.04615650799991],
              [-68.33482825399994, -55.062432549999926],
              [-68.34870357999995, -55.07317473799992],
              [-68.37271074099993, -55.07496510199991],
              [-68.39362545499995, -55.06536223799992],
              [-68.41266842399995, -55.0525041649999],
              [-68.43126380099994, -55.04461028399993],
              [-68.44139563699991, -55.04566822699991],
              [-68.44383704299992, -55.0525041649999],
              [-68.44005286399994, -55.06389739399992],
              [-68.43126380099994, -55.078789971999925],
              [-68.48062089799993, -55.10279713299991],
              [-68.51081295499995, -55.112399997999944],
              [-68.5305883449999, -55.10979583099993],
              [-68.54613196499992, -55.095961195999905],
              [-68.57359778599994, -55.07675546699994],
              [-68.60260982999995, -55.06609465899993],
              [-68.62303626199991, -55.078789971999925],
              [-68.62022864499994, -55.086602471999925],
              [-68.60753333199995, -55.09140390399995],
              [-68.59243730399993, -55.09514739399992],
              [-68.58210201699995, -55.09978606599992],
              [-68.57575436099995, -55.10947030999995],
              [-68.56997636599993, -55.12314218499995],
              [-68.56944739499994, -55.135430596999925],
              [-68.57868404899995, -55.14080169099992],
              [-68.59024003799993, -55.14299895599993],
              [-68.61607825399994, -55.152276299999926],
              [-68.62950598899994, -55.15447356599992],
              [-68.64663652299993, -55.153008721999925],
              [-68.69131425699993, -55.14080169099992],
              [-68.75340735599991, -55.13396575299993],
              [-68.79173743399991, -55.12200286299992],
              [-68.80492102799991, -55.12029387799993],
              [-68.82591712099992, -55.115166924999926],
              [-68.89053300699993, -55.078789971999925],
              [-68.96556555899991, -55.0544572899999],
              [-68.99299068899995, -55.05201588299991],
              [-69.00389563699991, -55.042087497999944],
              [-69.02798417899993, -55.02459075299993],
              [-69.05190995999993, -55.01921965899993],
              [-69.06187903599994, -55.04461028399993],
              [-69.05699622299994, -55.060804945999905],
              [-69.0462133449999, -55.063164971999925],
              [-69.03286699099993, -55.059665622999944],
              [-69.02025305899991, -55.05828215899993],
              [-69.00495357999995, -55.06324635199991],
              [-68.99767005099994, -55.06951262799993],
              [-68.99315344999991, -55.077243747999944],
              [-68.98615475199995, -55.086195570999905],
              [-68.96784420499995, -55.10076262799993],
              [-68.94847571499992, -55.11093515399995],
              [-68.78661048099991, -55.16521575299993],
              [-68.76244055899991, -55.169040622999944],
              [-68.67857825399994, -55.16838958099993],
              [-68.60879472599993, -55.17538827899995],
              [-68.58551998599995, -55.185479424999926],
              [-68.56403561099995, -55.19198984199994],
              [-68.41405188699991, -55.179945570999905],
              [-68.38312740799995, -55.18450286299992],
              [-68.35753333199995, -55.21306731599992],
              [-68.29702714799993, -55.220635674999926],
              [-68.27424068899995, -55.23015715899993],
              [-68.28819739499994, -55.22966887799993],
              [-68.32884680899991, -55.236993096999925],
              [-68.23884029899995, -55.25750090899993],
              [-68.21784420499995, -55.259698174999926],
              [-68.20921790299991, -55.26287200299993],
              [-68.20531165299991, -55.27117278399993],
              [-68.20807857999995, -55.28281015399995],
              [-68.21637936099995, -55.28915780999995],
              [-68.22760982999995, -55.29176197699991],
              [-68.23916581899994, -55.29225025799991],
              [-68.2747289699999, -55.27971770599993],
              [-68.28380286399994, -55.28142669099992],
              [-68.29279537699995, -55.28630950299993],
              [-68.30492102799991, -55.28923919099992],
              [-68.43154863199993, -55.29851653399993],
              [-68.45368404899995, -55.29225025799991],
              [-68.46654212099992, -55.29070403399993],
              [-68.47223873599995, -55.29534270599993],
              [-68.47671464799993, -55.30396900799991],
              [-68.48745683499993, -55.30917734199994],
              [-68.50007076699995, -55.31145598799992],
              [-68.59251868399991, -55.312758070999905],
              [-68.61681067599994, -55.30592213299991],
              [-68.6282445949999, -55.29509856599992],
              [-68.64940344999991, -55.263929945999905],
              [-68.66095943899995, -55.25750090899993],
              [-68.70173092399995, -55.25505950299993],
              [-68.72215735599991, -55.25855885199991],
              [-68.74596106699994, -55.27117278399993],
              [-68.70055091099994, -55.26572030999995],
              [-68.68004309799994, -55.26718515399995],
              [-68.67145748599995, -55.28142669099992],
              [-68.67491614499994, -55.28630950299993],
              [-68.68028723899994, -55.292087497999944],
              [-68.68032792899993, -55.29656340899993],
              [-68.65684973899994, -55.30038827899995],
              [-68.64801998599995, -55.30510833099993],
              [-68.64464270699995, -55.31170012799993],
              [-68.65038001199991, -55.31894296699994],
              [-68.63170325399994, -55.32659270599993],
              [-68.60826575399994, -55.328383070999905],
              [-68.56159420499995, -55.32634856599992],
              [-68.57315019399994, -55.335056247999944],
              [-68.5852758449999, -55.341729424999926],
              [-68.59581458199995, -55.34921640399995],
              [-68.60252844999991, -55.35995859199994],
              [-68.58381100199995, -55.35881926899992],
              [-68.51325436099995, -55.33277760199991],
              [-68.49290930899991, -55.32887135199991],
              [-68.44798743399991, -55.32634856599992],
              [-68.42617753799993, -55.328789971999925],
              [-68.41075598899994, -55.33261484199994],
              [-68.40534420499995, -55.33562590899993],
              [-68.39924068899995, -55.34026458099993],
              [-68.39110266799992, -55.344414971999925],
              [-68.37975012899994, -55.34628671699994],
              [-68.35578365799995, -55.34254322699991],
              [-68.34532630099994, -55.344008070999905],
              [-68.33507239499994, -55.35312265399995],
              [-68.33112545499995, -55.36337655999995],
              [-68.33291581899994, -55.37184010199991],
              [-68.33584550699993, -55.379571221999925],
              [-68.33507239499994, -55.38730234199994],
              [-68.32437089799993, -55.399509372999944],
              [-68.31476803299995, -55.396742445999905],
              [-68.30333411399994, -55.38762786299992],
              [-68.28726152299993, -55.38046640399995],
              [-68.27623450399994, -55.379164320999905],
              [-68.26634680899991, -55.38014088299991],
              [-68.25743567599994, -55.38396575299993],
              [-68.2395727199999, -55.39853280999995],
              [-68.23208574099993, -55.39902109199994],
              [-68.2239477199999, -55.39609140399995],
              [-68.21214758999992, -55.39397551899992],
              [-68.16909745999993, -55.39723072699991],
              [-68.14647376199991, -55.40439218499995],
              [-68.14663652299993, -55.417901299999926],
              [-68.15127519399994, -55.4255510399999],
              [-68.15135657499991, -55.43238697699991],
              [-68.14989173099991, -55.43808359199994],
              [-68.15005449099993, -55.44182708099993],
              [-68.15684973899994, -55.44850025799991],
              [-68.17031816299993, -55.45517343499995],
              [-68.17735755099994, -55.46233489399992],
              [-68.15680904899995, -55.4704729149999],
              [-68.07872473899994, -55.46233489399992],
              [-68.05748450399994, -55.469008070999905],
              [-68.06484941299993, -55.48406340899993],
              [-68.09544837099992, -55.510023695999905],
              [-68.10138912699995, -55.527601820999905],
              [-68.09072831899994, -55.53590260199991],
              [-68.07135982999995, -55.54257577899995],
              [-68.05109615799995, -55.55510833099993],
              [-68.04482988199993, -55.56487395599993],
              [-68.04381262899994, -55.5720354149999],
              [-68.04043535099993, -55.57870859199994],
              [-68.02721106699994, -55.585870049999926],
              [-68.01121985599991, -55.588555596999925],
              [-67.98013261599993, -55.58757903399993],
              [-67.96515865799995, -55.59335702899995],
              [-67.97960364499994, -55.597588799999926],
              [-67.98672441299993, -55.60588958099993],
              [-67.9915258449999, -55.61638762799993],
              [-67.99925696499992, -55.62753671699994],
            ],
          ],
          [
            [
              [-67.88316809799994, -55.24382903399993],
              [-67.86050370999993, -55.232354424999926],
              [-67.73859615799995, -55.236993096999925],
              [-67.75792395699995, -55.2243791649999],
              [-67.83629309799994, -55.21038176899992],
              [-67.86270097599993, -55.20232512799993],
              [-67.88548743399991, -55.17896900799991],
              [-67.89810136599993, -55.16871510199991],
              [-67.90367591099994, -55.17156340899993],
              [-67.90680904899995, -55.18629322699991],
              [-67.91417395699995, -55.195245049999926],
              [-67.92320716099994, -55.19500090899993],
              [-67.93101966099994, -55.18238697699991],
              [-67.93781490799995, -55.18238697699991],
              [-67.95734615799995, -55.21054452899995],
              [-67.98558508999992, -55.22356536299992],
              [-68.08185787699995, -55.233086846999925],
              [-68.11050370999993, -55.2302385399999],
              [-68.13508053299995, -55.21884530999995],
              [-68.15689042899993, -55.19605885199991],
              [-68.14956620999993, -55.18914153399993],
              [-68.13931230399993, -55.18377044099992],
              [-68.11595618399991, -55.17498137799993],
              [-68.14683997299994, -55.160821221999925],
              [-68.15689042899993, -55.15447356599992],
              [-68.16429602799991, -55.146416924999926],
              [-68.18809973899994, -55.10442473799992],
              [-68.18838456899994, -55.09661223799992],
              [-68.18545488199993, -55.09026458099993],
              [-68.18175208199995, -55.07708098799992],
              [-68.17731686099995, -55.07146575299993],
              [-68.16746985599991, -55.06170012799993],
              [-68.16392981699994, -55.05486419099992],
              [-68.16539466099994, -55.04924895599993],
              [-68.16869055899991, -55.044040622999944],
              [-68.17056230399993, -55.03834400799991],
              [-68.17686926999994, -54.99765390399995],
              [-68.18635006399995, -54.97820403399993],
              [-68.20156816299993, -54.97975025799991],
              [-68.22581946499992, -54.98992278399993],
              [-68.26292883999992, -54.99529387799993],
              [-68.30125891799992, -54.99553801899992],
              [-68.32884680899991, -54.99065520599993],
              [-68.34341386599993, -54.97698333099993],
              [-68.35692298099991, -54.953383070999905],
              [-68.36050370999993, -54.93092213299991],
              [-68.34528561099995, -54.92107512799993],
              [-68.25487219999991, -54.92392343499995],
              [-68.22581946499992, -54.92107512799993],
              [-68.22492428299995, -54.91920338299991],
              [-68.22175045499995, -54.915134372999944],
              [-68.21703040299991, -54.91057708099993],
              [-68.21153723899994, -54.9079729149999],
              [-67.94180253799993, -54.90545012799993],
              [-67.80577551999994, -54.91375090899993],
              [-67.72419186099995, -54.93515390399995],
              [-67.70181230399993, -54.93173593499995],
              [-67.67931067599994, -54.924899997999944],
              [-67.64981035099993, -54.92107512799993],
              [-67.46182206899994, -54.92205169099992],
              [-67.30182857999995, -54.92888762799993],
              [-67.22272701699995, -54.94841887799993],
              [-67.18309485599991, -54.96803150799991],
              [-67.14907792899993, -54.99488697699991],
              [-67.11538652299993, -55.03093840899993],
              [-67.09813391799992, -55.045179945999905],
              [-67.07860266799992, -55.05738697699991],
              [-67.06187903599994, -55.0720354149999],
              [-67.05337480399993, -55.093682549999926],
              [-67.05455481699994, -55.10475025799991],
              [-67.05186926999994, -55.12363046699994],
              [-67.05333411399994, -55.13396575299993],
              [-67.05968176999994, -55.14495208099993],
              [-67.07701575399994, -55.166680596999925],
              [-67.08063717399995, -55.17864348799992],
              [-67.08849036399994, -55.190524997999944],
              [-67.22557532499991, -55.29111093499995],
              [-67.27061926999994, -55.306898695999905],
              [-67.35228430899991, -55.302992445999905],
              [-67.41331946499992, -55.2927385399999],
              [-67.43382727799991, -55.28142669099992],
              [-67.44326738199993, -55.274509372999944],
              [-67.45116126199991, -55.27157968499995],
              [-67.45665442599994, -55.26677825299993],
              [-67.45860755099994, -55.25408294099992],
              [-67.45360266799992, -55.24146900799991],
              [-67.43032792899993, -55.22779713299991],
              [-67.42324785099993, -55.21648528399993],
              [-67.44399980399993, -55.182305596999925],
              [-67.50291907499991, -55.172133070999905],
              [-67.56847083199995, -55.17717864399992],
              [-67.60879472599993, -55.18865325299993],
              [-67.62230383999992, -55.200290622999944],
              [-67.62975012899994, -55.21217213299991],
              [-67.64297441299993, -55.24382903399993],
              [-67.64525305899991, -55.25400155999995],
              [-67.64395097599993, -55.258884372999944],
              [-67.64736894399994, -55.2614885399999],
              [-67.66344153599994, -55.264336846999925],
              [-67.67638098899994, -55.26482512799993],
              [-67.71190344999991, -55.25750090899993],
              [-67.73525956899994, -55.25628020599993],
              [-67.80064856699994, -55.264336846999925],
              [-67.82164466099994, -55.2614885399999],
              [-67.88316809799994, -55.24382903399993],
            ],
          ],
          [
            [
              [-70.29515540299991, -55.08245208099993],
              [-70.29234778599994, -55.09579843499995],
              [-70.28538977799991, -55.10019296699994],
              [-70.27623450399994, -55.10320403399993],
              [-70.26724199099993, -55.11288827899995],
              [-70.31159420499995, -55.12664153399993],
              [-70.33844967399995, -55.12851327899995],
              [-70.35045325399994, -55.11663176899992],
              [-70.35846920499995, -55.10076262799993],
              [-70.37751217399995, -55.08831145599993],
              [-70.39989173099991, -55.08066171699994],
              [-70.41808020699995, -55.078789971999925],
              [-70.39757239499994, -55.10662200299993],
              [-70.41380774599992, -55.10588958099993],
              [-70.43691972599993, -55.101820570999905],
              [-70.45250403599994, -55.1052385399999],
              [-70.44603430899991, -55.12712981599992],
              [-70.42821204299992, -55.138929945999905],
              [-70.38438880099994, -55.144463799999926],
              [-70.37026933499993, -55.1618791649999],
              [-70.39061438699991, -55.169040622999944],
              [-70.42772376199991, -55.17156340899993],
              [-70.44603430899991, -55.17498137799993],
              [-70.45995032499991, -55.18320077899995],
              [-70.47940019399994, -55.20387135199991],
              [-70.49445553299995, -55.209649346999925],
              [-70.48851477799991, -55.184665622999944],
              [-70.49571692599994, -55.16741301899992],
              [-70.51329505099994, -55.15748463299991],
              [-70.53848222599993, -55.15447356599992],
              [-70.54832923099991, -55.160821221999925],
              [-70.52403723899994, -55.19394296699994],
              [-70.52794348899994, -55.209649346999925],
              [-70.54808508999992, -55.213555596999925],
              [-70.5606176419999, -55.199151299999926],
              [-70.56704667899993, -55.17701588299991],
              [-70.56891842399995, -55.158135674999926],
              [-70.56407630099994, -55.14031340899993],
              [-70.55138098899994, -55.127211195999905],
              [-70.53368079299992, -55.11834075299993],
              [-70.51366126199991, -55.11288827899995],
              [-70.51366126199991, -55.10662200299993],
              [-70.54796301999994, -55.098321221999925],
              [-70.56273352799991, -55.09107838299991],
              [-70.57530676999994, -55.06023528399993],
              [-70.59007727799991, -55.05046965899993],
              [-70.60631262899994, -55.04892343499995],
              [-70.61729895699995, -55.05828215899993],
              [-70.60802161399994, -55.058851820999905],
              [-70.60191809799994, -55.06178150799991],
              [-70.58999589799993, -55.07317473799992],
              [-70.60033118399991, -55.076429945999905],
              [-70.6204320949999, -55.076836846999925],
              [-70.63036048099991, -55.076836846999925],
              [-70.63434811099995, -55.074151299999926],
              [-70.64020748599995, -55.072523695999905],
              [-70.64525305899991, -55.07317473799992],
              [-70.6458227199999, -55.07561614399992],
              [-70.64468339799993, -55.0837541649999],
              [-70.64525305899991, -55.086195570999905],
              [-70.66657467399995, -55.10662200299993],
              [-70.67894446499992, -55.11288827899995],
              [-70.6992895169999, -55.11288827899995],
              [-70.70034745999993, -55.12558359199994],
              [-70.71580969999991, -55.1228166649999],
              [-70.73501542899993, -55.111993096999925],
              [-70.74767005099994, -55.09978606599992],
              [-70.73037675699993, -55.086602471999925],
              [-70.72252356699994, -55.06853606599992],
              [-70.72899329299992, -55.05396900799991],
              [-70.75450598899994, -55.05201588299991],
              [-70.7656957669999, -55.05681731599992],
              [-70.77391516799992, -55.06389739399992],
              [-70.78351803299995, -55.07040780999995],
              [-70.7988988919999, -55.07317473799992],
              [-70.80231686099995, -55.07537200299993],
              [-70.80500240799995, -55.08017343499995],
              [-70.80858313699991, -55.084649346999925],
              [-70.81533769399994, -55.086195570999905],
              [-70.82363847599993, -55.08342864399992],
              [-70.82787024599992, -55.07903411299992],
              [-70.83023027299993, -55.074883721999925],
              [-70.8333227199999, -55.07317473799992],
              [-70.84048417899993, -55.0700822899999],
              [-70.84764563699991, -55.06373463299991],
              [-70.85684160099993, -55.058526299999926],
              [-70.87059485599991, -55.05828215899993],
              [-70.88263912699995, -55.06340911299992],
              [-70.89907792899993, -55.07626718499995],
              [-70.9121801419999, -55.078789971999925],
              [-70.9297582669999, -55.076836846999925],
              [-70.94098873599995, -55.0720354149999],
              [-70.95995032499991, -55.05828215899993],
              [-70.97915605399993, -55.04745859199994],
              [-70.9895727199999, -55.045179945999905],
              [-71.0071508449999, -55.04461028399993],
              [-71.0071508449999, -55.03834400799991],
              [-70.99111894399994, -55.03362395599993],
              [-70.99181067599994, -55.02548593499995],
              [-70.99669348899994, -55.01506926899992],
              [-70.9934789699999, -55.00359465899993],
              [-70.97411048099991, -54.996758721999925],
              [-70.93032792899993, -55.00123463299991],
              [-70.91901607999995, -54.99065520599993],
              [-70.95250403599994, -54.987399997999944],
              [-70.99258378799993, -54.978448174999926],
              [-71.01284745999993, -54.96502044099992],
              [-70.98721269399994, -54.94841887799993],
              [-70.96760006399995, -54.94589609199994],
              [-70.92540442599994, -54.94931405999995],
              [-70.90538489499994, -54.94841887799993],
              [-70.89122473899994, -54.94296640399995],
              [-70.87779700399994, -54.935479424999926],
              [-70.86440995999993, -54.93084075299993],
              [-70.85008704299992, -54.93417734199994],
              [-70.86611894399994, -54.95761484199994],
              [-70.86412512899994, -54.96559010199991],
              [-70.84675045499995, -54.96892669099992],
              [-70.82111568899995, -54.96599700299993],
              [-70.80972245999993, -54.96770598799992],
              [-70.79548092399995, -54.9763322899999],
              [-70.79653886599993, -54.95322030999995],
              [-70.79482988199993, -54.94548919099992],
              [-70.79613196499992, -54.93678150799991],
              [-70.79548092399995, -54.93417734199994],
              [-70.78856360599991, -54.93222421699994],
              [-70.78233801999994, -54.9353166649999],
              [-70.77660071499992, -54.93987395599993],
              [-70.77122962099992, -54.94215260199991],
              [-70.76357988199993, -54.944431247999944],
              [-70.74990800699993, -54.95370859199994],
              [-70.74054928299995, -54.95582447699991],
              [-70.73082434799994, -54.95663827899995],
              [-70.72191321499992, -54.95907968499995],
              [-70.71361243399991, -54.96306731599992],
              [-70.70612545499995, -54.96892669099992],
              [-70.69050045499995, -54.960870049999926],
              [-70.67638098899994, -54.960870049999926],
              [-70.64525305899991, -54.96892669099992],
              [-70.56265214799993, -54.96892669099992],
              [-70.56265214799993, -54.96209075299993],
              [-70.60334225199995, -54.95859140399995],
              [-70.61506100199995, -54.95322030999995],
              [-70.61046301999994, -54.94215260199991],
              [-70.59312903599994, -54.93368905999995],
              [-70.54995683499993, -54.92693450299993],
              [-70.49205481699994, -54.89999765399995],
              [-70.39224199099993, -54.899102471999925],
              [-70.35045325399994, -54.89373137799993],
              [-70.31566321499992, -54.90056731599992],
              [-70.31566321499992, -54.9079729149999],
              [-70.44542395699995, -54.93840911299992],
              [-70.49380449099993, -54.94215260199991],
              [-70.50544186099995, -54.95077890399995],
              [-70.50967363199993, -54.988213799999926],
              [-70.52452551999994, -54.996758721999925],
              [-70.57542883999992, -54.98601653399993],
              [-70.59715735599991, -54.98650481599992],
              [-70.59679114499994, -55.00359465899993],
              [-70.66152910099993, -55.00017669099992],
              [-70.69066321499992, -54.9939104149999],
              [-70.71971594999991, -54.98316822699991],
              [-70.73029537699995, -55.00481536299992],
              [-70.72984778599994, -55.01336028399993],
              [-70.71629798099991, -55.016696872999944],
              [-70.69981848899994, -55.018649997999944],
              [-70.65143795499995, -55.03093840899993],
              [-70.56582597599993, -55.03093840899993],
              [-70.5579320949999, -55.02874114399992],
              [-70.54222571499992, -55.01897551899992],
              [-70.53164628799993, -55.016696872999944],
              [-70.50792395699995, -55.01677825299993],
              [-70.4973852199999, -55.01897551899992],
              [-70.48692786399994, -55.024102471999925],
              [-70.49400794199994, -55.025648695999905],
              [-70.50597083199995, -55.03004322699991],
              [-70.51366126199991, -55.03093840899993],
              [-70.49356035099993, -55.04062265399995],
              [-70.46442623599995, -55.047133070999905],
              [-70.40811113199993, -55.05201588299991],
              [-70.39761308499993, -55.048760674999926],
              [-70.37633216099994, -55.034274997999944],
              [-70.36343339799993, -55.03093840899993],
              [-70.30943762899994, -55.02792734199994],
              [-70.29515540299991, -55.03093840899993],
              [-70.27774003799993, -55.04851653399993],
              [-70.2969457669999, -55.05738697699991],
              [-70.32721920499995, -55.06267669099992],
              [-70.34292558499993, -55.06910572699991],
              [-70.33551998599995, -55.078383070999905],
              [-70.30264238199993, -55.0778947899999],
              [-70.29515540299991, -55.08245208099993],
            ],
          ],
          [
            [
              [-69.90416419199994, -54.996758721999925],
              [-69.91222083199995, -54.98455169099992],
              [-69.92332923099991, -54.98121510199991],
              [-69.93610592399995, -54.97966887799993],
              [-69.94884192599994, -54.972588799999926],
              [-69.95034745999993, -54.9528947899999],
              [-69.9160863919999, -54.946384372999944],
              [-69.84268144399994, -54.94841887799993],
              [-69.84268144399994, -54.94215260199991],
              [-69.90876217399995, -54.92546965899993],
              [-69.92467200399994, -54.91423919099992],
              [-69.92829342399995, -54.89763762799993],
              [-69.91559811099995, -54.88689544099992],
              [-69.8946020169999, -54.881117445999905],
              [-69.86180579299992, -54.87753671699994],
              [-69.8489477199999, -54.873711846999925],
              [-69.83633378799993, -54.87224700299993],
              [-69.82559160099993, -54.87639739399992],
              [-69.80516516799992, -54.90056731599992],
              [-69.78563391799992, -54.906508070999905],
              [-69.77953040299991, -54.920993747999944],
              [-69.77855383999992, -54.93906015399995],
              [-69.77440344999991, -54.95582447699991],
              [-69.76329505099994, -54.945570570999905],
              [-69.75088456899994, -54.93808359199994],
              [-69.73737545499995, -54.936618747999944],
              [-69.72288977799991, -54.945245049999926],
              [-69.71349036399994, -54.94882577899995],
              [-69.70360266799992, -54.945977471999925],
              [-69.69835364499994, -54.939385674999926],
              [-69.7024633449999, -54.93132903399993],
              [-69.73346920499995, -54.91423919099992],
              [-69.72354081899994, -54.90894947699991],
              [-69.71279863199993, -54.9079729149999],
              [-69.70189368399991, -54.9099260399999],
              [-69.69188391799992, -54.91423919099992],
              [-69.70579993399991, -54.90097421699994],
              [-69.71361243399991, -54.89576588299991],
              [-69.72288977799991, -54.89373137799993],
              [-69.75194251199991, -54.89218515399995],
              [-69.76773027299993, -54.88795338299991],
              [-69.77440344999991, -54.87948984199994],
              [-69.76012122299994, -54.86834075299993],
              [-69.72834225199995, -54.86451588299991],
              [-69.67145748599995, -54.86646900799991],
              [-69.5137426419999, -54.89373137799993],
              [-69.50658118399991, -54.89804452899995],
              [-69.50934811099995, -54.908135674999926],
              [-69.52057857999995, -54.92848072699991],
              [-69.53107662699995, -54.94085051899992],
              [-69.53001868399991, -54.94605885199991],
              [-69.5137426419999, -54.94841887799993],
              [-69.50218665299991, -54.94670989399992],
              [-69.49364173099991, -54.94215260199991],
              [-69.46393795499995, -54.91423919099992],
              [-69.4473363919999, -54.90439218499995],
              [-69.42638098899994, -54.89959075299993],
              [-69.39769446499992, -54.90056731599992],
              [-69.37144934799994, -54.906508070999905],
              [-69.32632402299993, -54.92327239399992],
              [-69.3008520169999, -54.92848072699991],
              [-69.23493404899995, -54.931898695999905],
              [-69.17235266799992, -54.95403411299992],
              [-69.16429602799991, -54.95582447699991],
              [-69.20840410099993, -54.97014739399992],
              [-69.25967363199993, -54.97087981599992],
              [-69.35606848899994, -54.95582447699991],
              [-69.33812415299991, -54.97161223799992],
              [-69.33189856699994, -54.97966887799993],
              [-69.33901933499993, -54.98316822699991],
              [-69.36880449099993, -54.98552825299993],
              [-69.42686926999994, -54.99749114399992],
              [-69.44253495999993, -54.99846770599993],
              [-69.45543372299994, -54.99374765399995],
              [-69.47370357999995, -54.979180596999925],
              [-69.48517818899995, -54.97519296699994],
              [-69.5000707669999, -54.9763322899999],
              [-69.48485266799992, -54.99553801899992],
              [-69.49864661399994, -55.005791924999926],
              [-69.52505449099993, -55.00986093499995],
              [-69.54784094999991, -55.010430596999925],
              [-69.59129798099991, -55.00400155999995],
              [-69.60244706899994, -55.00359465899993],
              [-69.6113988919999, -55.00709400799991],
              [-69.62881425699993, -55.01995208099993],
              [-69.63727779899995, -55.024102471999925],
              [-69.77643795499995, -55.03460051899992],
              [-69.79698645699995, -55.02971770599993],
              [-69.81602942599994, -55.016696872999944],
              [-69.83706620999993, -55.03289153399993],
              [-69.86217200399994, -55.038995049999926],
              [-69.91779537699995, -55.03834400799991],
              [-69.91779537699995, -55.03093840899993],
              [-69.9075414699999, -55.02459075299993],
              [-69.90233313699991, -55.017510674999926],
              [-69.90143795499995, -55.00855885199991],
              [-69.90416419199994, -54.996758721999925],
            ],
          ],
          [
            [
              [-70.42178300699993, -54.845961195999905],
              [-70.41173255099994, -54.850274346999925],
              [-70.40196692599994, -54.859633070999905],
              [-70.39688066299993, -54.869073174999926],
              [-70.40099036399994, -54.873304945999905],
              [-70.45287024599992, -54.87948984199994],
              [-70.50743567599994, -54.87948984199994],
              [-70.58088131399995, -54.89788176899992],
              [-70.65453040299991, -54.90195077899995],
              [-70.67853756399995, -54.8982072899999],
              [-70.69245357999995, -54.88689544099992],
              [-70.68724524599992, -54.87908294099992],
              [-70.69155839799993, -54.87590911299992],
              [-70.71288001199991, -54.873304945999905],
              [-70.71703040299991, -54.87517669099992],
              [-70.71987870999993, -54.880791924999926],
              [-70.72435462099992, -54.88616301899992],
              [-70.73338782499991, -54.88689544099992],
              [-70.73273678299995, -54.88534921699994],
              [-70.74767005099994, -54.873304945999905],
              [-70.74767005099994, -54.86646900799991],
              [-70.71092688699991, -54.85214609199994],
              [-70.68960527299993, -54.846774997999944],
              [-70.67536373599995, -54.84905364399992],
              [-70.65729732999995, -54.85564544099992],
              [-70.63947506399995, -54.84880950299993],
              [-70.62246660099993, -54.83798593499995],
              [-70.60708574099993, -54.832289320999905],
              [-70.54161536399994, -54.832289320999905],
              [-70.42178300699993, -54.845961195999905],
            ],
          ],
          [
            [
              [-70.98379472599993, -54.92848072699991],
              [-70.99079342399995, -54.92652760199991],
              [-70.9973852199999, -54.922539971999925],
              [-71.00495357999995, -54.9196916649999],
              [-71.01455644399994, -54.92107512799993],
              [-71.02183997299994, -54.925713799999926],
              [-71.02920488199993, -54.93710702899995],
              [-71.03506425699993, -54.94215260199991],
              [-71.06427975199995, -54.94963958099993],
              [-71.11803137899994, -54.93368905999995],
              [-71.15172278599994, -54.93417734199994],
              [-71.14150956899994, -54.922946872999944],
              [-71.12580318899995, -54.91448333099993],
              [-71.10765540299991, -54.90911223799992],
              [-71.09024003799993, -54.9079729149999],
              [-71.10728919199994, -54.894789320999905],
              [-71.12067623599995, -54.89226653399993],
              [-71.18248450399994, -54.907321872999944],
              [-71.19298255099994, -54.9079729149999],
              [-71.20482337099992, -54.90642669099992],
              [-71.20579993399991, -54.90178801899992],
              [-71.20376542899993, -54.89511484199994],
              [-71.21031653599994, -54.87851327899995],
              [-71.20836341099994, -54.87200286299992],
              [-71.20982825399994, -54.86793385199991],
              [-71.22374426999994, -54.86646900799991],
              [-71.26158606699994, -54.873304945999905],
              [-71.27228756399995, -54.86728280999995],
              [-71.27904212099992, -54.86541106599992],
              [-71.28209387899994, -54.86988697699991],
              [-71.28408769399994, -54.87981536299992],
              [-71.28954016799992, -54.88567473799992],
              [-71.29800370999993, -54.88795338299991],
              [-71.30882727799991, -54.88689544099992],
              [-71.30406653599994, -54.904961846999925],
              [-71.30785071499992, -54.92506275799991],
              [-71.31818600199995, -54.94158294099992],
              [-71.33299719999991, -54.94841887799993],
              [-71.33901933499993, -54.95037200299993],
              [-71.34487870999993, -54.953789971999925],
              [-71.35098222599993, -54.95435963299991],
              [-71.35781816299993, -54.94841887799993],
              [-71.36115475199995, -54.94019947699991],
              [-71.35806230399993, -54.93710702899995],
              [-71.35301673099991, -54.93434010199991],
              [-71.35033118399991, -54.92848072699991],
              [-71.33641516799992, -54.91155364399992],
              [-71.33462480399993, -54.902276299999926],
              [-71.35033118399991, -54.90056731599992],
              [-71.38170325399994, -54.92864348799992],
              [-71.40282141799992, -54.94264088299991],
              [-71.41246497299994, -54.938164971999925],
              [-71.41600501199991, -54.91375090899993],
              [-71.42601477799991, -54.90252044099992],
              [-71.44098873599995, -54.89421965899993],
              [-71.45958411399994, -54.87948984199994],
              [-71.40493730399993, -54.85906340899993],
              [-71.41649329299992, -54.835870049999926],
              [-71.40412350199995, -54.8298479149999],
              [-71.38280188699991, -54.830743096999925],
              [-71.36774654899995, -54.82854583099993],
              [-71.35777747299994, -54.82512786299992],
              [-71.34557044199994, -54.82854583099993],
              [-71.32306881399995, -54.838555596999925],
              [-71.31017005099994, -54.840508721999925],
              [-71.29576575399994, -54.838555596999925],
              [-71.20352128799993, -54.845961195999905],
              [-71.19151770699995, -54.83652109199994],
              [-71.18028723899994, -54.83147551899992],
              [-71.16539466099994, -54.832289320999905],
              [-71.15514075399994, -54.835870049999926],
              [-71.14781653599994, -54.84002044099992],
              [-71.14419511599993, -54.84710051899992],
              [-71.14488684799994, -54.85906340899993],
              [-71.12474524599992, -54.85881926899992],
              [-71.07787024599992, -54.88014088299991],
              [-71.05923417899993, -54.87639739399992],
              [-71.04605058499993, -54.86858489399992],
              [-71.02603105399993, -54.861586195999905],
              [-71.00617428299995, -54.857679945999905],
              [-70.9934789699999, -54.85906340899993],
              [-70.98790442599994, -54.873711846999925],
              [-70.97736568899995, -54.87932708099993],
              [-70.96320553299995, -54.87835051899992],
              [-70.94688880099994, -54.873304945999905],
              [-70.94815019399994, -54.88689544099992],
              [-70.95547441299993, -54.89690520599993],
              [-70.96328691299993, -54.90390390399995],
              [-70.96617591099994, -54.9079729149999],
              [-70.95714270699995, -54.91415780999995],
              [-70.92577063699991, -54.91643645599993],
              [-70.91152910099993, -54.92107512799993],
              [-70.92658443899995, -54.928399346999925],
              [-70.94562740799995, -54.93027109199994],
              [-70.98379472599993, -54.92848072699991],
            ],
          ],
          [
            [
              [-71.94684811099995, -54.70256926899992],
              [-71.92926998599995, -54.69491952899995],
              [-71.92125403599994, -54.70525481599992],
              [-71.92088782499991, -54.72275155999995],
              [-71.92638098899994, -54.73674895599993],
              [-71.93838456899994, -54.74578215899993],
              [-71.95360266799992, -54.75123463299991],
              [-71.96983801999994, -54.754164320999905],
              [-71.98497473899994, -54.75530364399992],
              [-71.99746660099993, -54.75310637799993],
              [-72.00706946499992, -54.74684010199991],
              [-72.00967363199993, -54.73788827899995],
              [-72.00133216099994, -54.72771575299993],
              [-71.99331620999993, -54.721774997999944],
              [-71.98745683499993, -54.71526458099993],
              [-71.98607337099992, -54.707696221999925],
              [-71.9915258449999, -54.69890715899993],
              [-72.02196204299992, -54.67522551899992],
              [-72.03359941299993, -54.65789153399993],
              [-72.04027258999992, -54.65048593499995],
              [-72.04987545499995, -54.64739348799992],
              [-72.06427975199995, -54.65162525799991],
              [-72.0657445949999, -54.66130950299993],
              [-72.06338456899994, -54.670993747999944],
              [-72.06631425699993, -54.67522551899992],
              [-72.08018958199995, -54.67441171699994],
              [-72.08788001199991, -54.67131926899992],
              [-72.10081946499992, -54.65789153399993],
              [-72.10431881399995, -54.644789320999905],
              [-72.09093176999994, -54.63600025799991],
              [-72.0716039699999, -54.63128020599993],
              [-72.03770911399994, -54.62851327899995],
              [-72.02818762899994, -54.62932708099993],
              [-72.01943925699993, -54.63298919099992],
              [-72.01158606699994, -54.63990650799991],
              [-71.9915258449999, -54.664320570999905],
              [-71.97911536399994, -54.67310963299991],
              [-71.96670488199993, -54.67986419099992],
              [-71.95555579299992, -54.68824635199991],
              [-71.94684811099995, -54.70256926899992],
            ],
          ],
          [
            [
              [-72.33983313699991, -54.33147551899992],
              [-72.31151282499991, -54.32903411299992],
              [-72.30138098899994, -54.33277760199991],
              [-72.2969457669999, -54.34579843499995],
              [-72.30532792899993, -54.365166924999926],
              [-72.32799231699994, -54.36028411299992],
              [-72.35558020699995, -54.34978606599992],
              [-72.37881425699993, -54.352634372999944],
              [-72.37120520699995, -54.358086846999925],
              [-72.36196855399993, -54.36736419099992],
              [-72.3567602199999, -54.376071872999944],
              [-72.36082923099991, -54.37981536299992],
              [-72.39150956899994, -54.37981536299992],
              [-72.39976966099994, -54.37769947699991],
              [-72.40440833199995, -54.37322356599992],
              [-72.40786699099993, -54.36874765399995],
              [-72.41234290299991, -54.36679452899995],
              [-72.43521074099993, -54.377211195999905],
              [-72.45177161399994, -54.41838958099993],
              [-72.47069251199991, -54.427666924999926],
              [-72.47777258999992, -54.42310963299991],
              [-72.50169837099992, -54.39348723799992],
              [-72.53278561099995, -54.3630510399999],
              [-72.54173743399991, -54.34303150799991],
              [-72.49962317599994, -54.34921640399995],
              [-72.50169837099992, -54.33147551899992],
              [-72.44774329299992, -54.33521900799991],
              [-72.42686926999994, -54.33017343499995],
              [-72.43346106699994, -54.311618747999944],
              [-72.42495683499993, -54.30592213299991],
              [-72.41588294199994, -54.30413176899992],
              [-72.40689042899993, -54.30608489399992],
              [-72.39806067599994, -54.311618747999944],
              [-72.38296464799993, -54.31487395599993],
              [-72.35728919199994, -54.328383070999905],
              [-72.34032141799992, -54.33131275799991],
              [-72.33983313699991, -54.33147551899992],
            ],
          ],
          [
            [
              [-70.38459225199995, -54.18808359199994],
              [-70.36213131399995, -54.18962981599992],
              [-70.31322180899991, -54.184665622999944],
              [-70.28774980399993, -54.18808359199994],
              [-70.28693600199995, -54.190524997999944],
              [-70.27358964799993, -54.20452239399992],
              [-70.26724199099993, -54.20916106599992],
              [-70.25621497299994, -54.212009372999944],
              [-70.23521887899994, -54.21233489399992],
              [-70.22630774599992, -54.21542734199994],
              [-70.21865800699993, -54.234633070999905],
              [-70.22960364499994, -54.24651458099993],
              [-70.24592037699995, -54.2556291649999],
              [-70.25422115799995, -54.26653411299992],
              [-70.26943925699993, -54.27109140399995],
              [-70.33975175699993, -54.26580169099992],
              [-70.36042232999995, -54.260023695999905],
              [-70.38170325399994, -54.24968840899993],
              [-70.43447831899994, -54.24228280999995],
              [-70.45909583199995, -54.23593515399995],
              [-70.47911536399994, -54.22470468499995],
              [-70.49705969999991, -54.20989348799992],
              [-70.51154537699995, -54.19264088299991],
              [-70.52110755099994, -54.17441171699994],
              [-70.49168860599991, -54.148370049999926],
              [-70.45543372299994, -54.15357838299991],
              [-70.38459225199995, -54.18808359199994],
            ],
          ],
          [
            [
              [-72.2969457669999, -54.078789971999925],
              [-72.27916419199994, -54.08953215899993],
              [-72.25621497299994, -54.10019296699994],
              [-72.23973548099991, -54.11207447699991],
              [-72.24168860599991, -54.12664153399993],
              [-72.23078365799995, -54.1286760399999],
              [-72.22126217399995, -54.13225676899992],
              [-72.20628821499992, -54.14031340899993],
              [-72.20628821499992, -54.14771900799991],
              [-72.23721269399994, -54.14462655999995],
              [-72.24697831899994, -54.14861419099992],
              [-72.25475012899994, -54.16130950299993],
              [-72.25373287699995, -54.17278411299992],
              [-72.24962317599994, -54.186211846999925],
              [-72.25064042899993, -54.197523695999905],
              [-72.26524817599994, -54.20232512799993],
              [-72.28331458199995, -54.200290622999944],
              [-72.29206295499995, -54.19784921699994],
              [-72.29674231699994, -54.2009416649999],
              [-72.30308997299994, -54.21542734199994],
              [-72.2981664699999, -54.23886484199994],
              [-72.30150305899991, -54.25139739399992],
              [-72.31989498599995, -54.256931247999944],
              [-72.34854081899994, -54.24944426899992],
              [-72.37852942599994, -54.22380950299993],
              [-72.39806067599994, -54.22909921699994],
              [-72.41047115799995, -54.23967864399992],
              [-72.41763261599993, -54.24863046699994],
              [-72.42650305899991, -54.25465260199991],
              [-72.44371497299994, -54.256931247999944],
              [-72.46056067599994, -54.25595468499995],
              [-72.47443600199995, -54.253024997999944],
              [-72.50169837099992, -54.24277109199994],
              [-72.50169837099992, -54.23593515399995],
              [-72.49453691299993, -54.23202890399995],
              [-72.48997962099992, -54.22771575299993],
              [-72.48131262899994, -54.21542734199994],
              [-72.51537024599992, -54.20232512799993],
              [-72.49331620999993, -54.190524997999944],
              [-72.44005286399994, -54.17131926899992],
              [-72.4192602199999, -54.168226820999905],
              [-72.36851966099994, -54.16765715899993],
              [-72.34479732999995, -54.15960051899992],
              [-72.33043372299994, -54.14031340899993],
              [-72.36318925699993, -54.13795338299991],
              [-72.37718665299991, -54.139743747999944],
              [-72.39183508999992, -54.14771900799991],
              [-72.38971920499995, -54.128838799999926],
              [-72.36009680899991, -54.12151458099993],
              [-72.32262122299994, -54.11874765399995],
              [-72.2969457669999, -54.113539320999905],
              [-72.34341386599993, -54.106133721999925],
              [-72.36481686099995, -54.10711028399993],
              [-72.37140865799995, -54.106133721999925],
              [-72.38670813699991, -54.09921640399995],
              [-72.39313717399995, -54.09449635199991],
              [-72.36733964799993, -54.084242445999905],
              [-72.34044348899994, -54.06959400799991],
              [-72.31456458199995, -54.06308359199994],
              [-72.2969457669999, -54.078789971999925],
            ],
          ],
          [
            [
              [-73.18008378799993, -54.07195403399993],
              [-73.18224036399994, -54.078383070999905],
              [-73.18472245999993, -54.092868747999944],
              [-73.18700110599991, -54.09929778399993],
              [-73.17983964799993, -54.10051848799992],
              [-73.16685950399994, -54.10507577899995],
              [-73.15965735599991, -54.106133721999925],
              [-73.17845618399991, -54.127211195999905],
              [-73.20531165299991, -54.12265390399995],
              [-73.23326575399994, -54.11150481599992],
              [-73.25523841099994, -54.113539320999905],
              [-73.2532445949999, -54.125664971999925],
              [-73.27892005099994, -54.12664153399993],
              [-73.31338456899994, -54.12118905999995],
              [-73.3235570949999, -54.113539320999905],
              [-73.33043372299994, -54.10271575299993],
              [-73.33234615799995, -54.09433359199994],
              [-73.33096269399994, -54.07537200299993],
              [-73.33739173099991, -54.06585051899992],
              [-73.35142981699994, -54.064711195999905],
              [-73.36554928299995, -54.06894296699994],
              [-73.37193762899994, -54.07537200299993],
              [-73.3860570949999, -54.08025481599992],
              [-73.41808020699995, -54.08098723799992],
              [-73.45270748599995, -54.07822030999995],
              [-73.47435462099992, -54.07195403399993],
              [-73.45909583199995, -54.06454843499995],
              [-73.42796790299991, -54.05820077899995],
              [-73.41291256399995, -54.051446221999925],
              [-73.39159094999991, -54.03183359199994],
              [-73.37987219999991, -54.02581145599993],
              [-73.35826575399994, -54.02361419099992],
              [-73.27497311099995, -54.02825286299992],
              [-73.24282792899993, -54.04257577899995],
              [-73.24901282499991, -54.07195403399993],
              [-73.2305395169999, -54.07048919099992],
              [-73.20738684799994, -54.05877044099992],
              [-73.18785559799994, -54.05364348799992],
              [-73.18008378799993, -54.07195403399993],
            ],
          ],
          [
            [
              [-71.6309301419999, -54.078789971999925],
              [-71.63426673099991, -54.04420338299991],
              [-71.65054277299993, -54.01262786299992],
              [-71.65705318899995, -53.98316822699991],
              [-71.6309301419999, -53.95525481599992],
              [-71.61217200399994, -53.94801197699991],
              [-71.58218339799993, -53.94085051899992],
              [-71.55435136599993, -53.94182708099993],
              [-71.54214433499993, -53.95867278399993],
              [-71.53954016799992, -53.96803150799991],
              [-71.53286699099993, -53.97812265399995],
              [-71.52399654899995, -53.98601653399993],
              [-71.51480058499993, -53.98943450299993],
              [-71.50084387899994, -53.98707447699991],
              [-71.49771074099993, -53.98056405999995],
              [-71.4981176419999, -53.97161223799992],
              [-71.49429277299993, -53.96209075299993],
              [-71.48814856699994, -53.95232512799993],
              [-71.48570716099994, -53.94605885199991],
              [-71.47984778599994, -53.94264088299991],
              [-71.46328691299993, -53.94158294099992],
              [-71.45567786399994, -53.94646575299993],
              [-71.4524633449999, -53.957696221999925],
              [-71.45287024599992, -53.97031015399995],
              [-71.45645097599993, -53.979180596999925],
              [-71.4473363919999, -53.98381926899992],
              [-71.43586178299995, -54.004164320999905],
              [-71.41860917899993, -54.044040622999944],
              [-71.39635169199994, -54.062758070999905],
              [-71.37930253799993, -54.04119231599992],
              [-71.37694251199991, -54.00400155999995],
              [-71.39879309799994, -53.97576262799993],
              [-71.37564042899993, -53.96917083099993],
              [-71.3379613919999, -53.97625090899993],
              [-71.30150305899991, -53.99146900799991],
              [-71.28209387899994, -54.00994231599992],
              [-71.27672278599994, -54.02402109199994],
              [-71.27114824099993, -54.05046965899993],
              [-71.26471920499995, -54.06178150799991],
              [-71.26113847599993, -54.07431405999995],
              [-71.27017167899993, -54.08473072699991],
              [-71.2825414699999, -54.094821872999944],
              [-71.28892981699994, -54.106133721999925],
              [-71.26964270699995, -54.10173919099992],
              [-71.25340735599991, -54.111586195999905],
              [-71.24107825399994, -54.12900155999995],
              [-71.23363196499992, -54.14771900799991],
              [-71.2363988919999, -54.15829843499995],
              [-71.23696855399993, -54.166273695999905],
              [-71.23363196499992, -54.17441171699994],
              [-71.22105872299994, -54.184665622999944],
              [-71.21190344999991, -54.18417734199994],
              [-71.20946204299992, -54.17636484199994],
              [-71.21690833199995, -54.164727471999925],
              [-71.21450761599993, -54.15007903399993],
              [-71.18834387899994, -54.09807708099993],
              [-71.17967688699991, -54.08562590899993],
              [-71.16364498599995, -54.08652109199994],
              [-71.16270911399994, -54.10564544099992],
              [-71.17223059799994, -54.15081145599993],
              [-71.16685950399994, -54.15390390399995],
              [-71.15514075399994, -54.155368747999944],
              [-71.14342200399994, -54.15276458099993],
              [-71.13809160099993, -54.14397551899992],
              [-71.13809160099993, -54.10271575299993],
              [-71.13068600199995, -54.08294036299992],
              [-71.11245683499993, -54.07048919099992],
              [-71.09007727799991, -54.06487395599993],
              [-71.06981360599991, -54.065118096999925],
              [-71.02887936099995, -54.08562590899993],
              [-71.01622473899994, -54.09539153399993],
              [-71.01252193899995, -54.10084400799991],
              [-71.01455644399994, -54.12322356599992],
              [-71.02139238199993, -54.14804452899995],
              [-71.05296790299991, -54.182305596999925],
              [-71.06236731699994, -54.20232512799993],
              [-71.04552161399994, -54.20159270599993],
              [-71.03433183499993, -54.19304778399993],
              [-71.01797441299993, -54.17131926899992],
              [-71.00495357999995, -54.16643645599993],
              [-70.99669348899994, -54.17457447699991],
              [-70.99486243399991, -54.18889739399992],
              [-71.00088456899994, -54.20232512799993],
              [-70.9942113919999, -54.212823174999926],
              [-70.99327551999994, -54.22380950299993],
              [-70.99864661399994, -54.232354424999926],
              [-71.01085364499994, -54.23593515399995],
              [-71.02798417899993, -54.237399997999944],
              [-71.02578691299993, -54.24098072699991],
              [-71.0071508449999, -54.24944426899992],
              [-70.99014238199993, -54.26580169099992],
              [-70.99242102799991, -54.27206796699994],
              [-71.00772050699993, -54.28053150799991],
              [-71.02033443899995, -54.28573984199994],
              [-71.03416907499991, -54.28964609199994],
              [-71.04845130099994, -54.291680596999925],
              [-71.06236731699994, -54.29111093499995],
              [-71.05459550699993, -54.2966447899999],
              [-71.04710852799991, -54.304620049999926],
              [-71.04287675699993, -54.31340911299992],
              [-71.04527747299994, -54.32146575299993],
              [-71.05646725199995, -54.330010674999926],
              [-71.06314042899993, -54.32773202899995],
              [-71.06944739499994, -54.321384372999944],
              [-71.07945716099994, -54.31780364399992],
              [-71.09947669199994, -54.3142229149999],
              [-71.13792883999992, -54.29973723799992],
              [-71.15794837099992, -54.29729583099993],
              [-71.14932206899994, -54.30950286299992],
              [-71.14171301999994, -54.31658294099992],
              [-71.11758378799993, -54.32830169099992],
              [-71.08739173099991, -54.3318010399999],
              [-71.08283443899995, -54.33513762799993],
              [-71.08381100199995, -54.34197356599992],
              [-71.08625240799995, -54.349867445999905],
              [-71.08971106699994, -54.35662200299993],
              [-71.09365800699993, -54.359307549999926],
              [-71.09727942599994, -54.36248137799993],
              [-71.10118567599994, -54.36956145599993],
              [-71.10651607999995, -54.37664153399993],
              [-71.11388098899994, -54.37981536299992],
              [-71.14830481699994, -54.37981536299992],
              [-71.1543676419999, -54.37460702899995],
              [-71.1692602199999, -54.34978606599992],
              [-71.17682857999995, -54.32773202899995],
              [-71.18614661399994, -54.33953215899993],
              [-71.19367428299995, -54.35898202899995],
              [-71.1926977199999, -54.36679452899995],
              [-71.20750891799992, -54.36923593499995],
              [-71.22081458199995, -54.36272551899992],
              [-71.24054928299995, -54.34579843499995],
              [-71.29515540299991, -54.31780364399992],
              [-71.33153235599991, -54.31373463299991],
              [-71.34752356699994, -54.30917734199994],
              [-71.35781816299993, -54.29729583099993],
              [-71.3477270169999, -54.28484465899993],
              [-71.33584550699993, -54.28476327899995],
              [-71.32274329299992, -54.28923919099992],
              [-71.30882727799991, -54.29111093499995],
              [-71.2988988919999, -54.28679778399993],
              [-71.29320227799991, -54.279554945999905],
              [-71.28595943899995, -54.27288176899992],
              [-71.27122962099992, -54.26995208099993],
              [-71.26366126199991, -54.271742445999905],
              [-71.24665279899995, -54.27809010199991],
              [-71.24054928299995, -54.27743905999995],
              [-71.2344457669999, -54.270603122999944],
              [-71.23786373599995, -54.26637135199991],
              [-71.24437415299991, -54.263604424999926],
              [-71.24791419199994, -54.260023695999905],
              [-71.24364173099991, -54.2497697899999],
              [-71.22191321499992, -54.23837655999995],
              [-71.21320553299995, -54.22909921699994],
              [-71.22345943899995, -54.21949635199991],
              [-71.23119055899991, -54.21559010199991],
              [-71.23851477799991, -54.216729424999926],
              [-71.24791419199994, -54.22226327899995],
              [-71.26158606699994, -54.239353122999944],
              [-71.26431230399993, -54.246758721999925],
              [-71.27098548099991, -54.249118747999944],
              [-71.27892005099994, -54.25009530999995],
              [-71.30077063699991, -54.26140715899993],
              [-71.31334387899994, -54.25481536299992],
              [-71.32310950399994, -54.24138762799993],
              [-71.32982337099992, -54.22909921699994],
              [-71.32872473899994, -54.22551848799992],
              [-71.32530676999994, -54.219821872999944],
              [-71.32331295499995, -54.212823174999926],
              [-71.32648678299995, -54.205743096999925],
              [-71.33169511599993, -54.20403411299992],
              [-71.33731035099993, -54.206963799999926],
              [-71.34170488199993, -54.21249765399995],
              [-71.34349524599992, -54.21884530999995],
              [-71.3548070949999, -54.24456145599993],
              [-71.38117428299995, -54.24627044099992],
              [-71.41100012899994, -54.23333098799992],
              [-71.4329320949999, -54.21542734199994],
              [-71.44595292899993, -54.1853166649999],
              [-71.42931067599994, -54.17148202899995],
              [-71.39907792899993, -54.16415780999995],
              [-71.37144934799994, -54.15390390399995],
              [-71.38548743399991, -54.14934661299992],
              [-71.41344153599994, -54.15195077899995],
              [-71.41860917899993, -54.14397551899992],
              [-71.41698157499991, -54.13925546699994],
              [-71.41307532499991, -54.13176848799992],
              [-71.40855872299994, -54.12615325299993],
              [-71.40493730399993, -54.12664153399993],
              [-71.41209876199991, -54.11402760199991],
              [-71.41661536399994, -54.110039971999925],
              [-71.41860917899993, -54.11679452899995],
              [-71.43211829299992, -54.13445403399993],
              [-71.46202551999994, -54.13689544099992],
              [-71.49258378799993, -54.13518645599993],
              [-71.50796464799993, -54.14031340899993],
              [-71.50548255099994, -54.14983489399992],
              [-71.48607337099992, -54.15943775799991],
              [-71.48131262899994, -54.17131926899992],
              [-71.48778235599991, -54.17538827899995],
              [-71.50059973899994, -54.17986419099992],
              [-71.50959225199995, -54.18678150799991],
              [-71.49986731699994, -54.21103280999995],
              [-71.51048743399991, -54.217054945999905],
              [-71.53530839799993, -54.22226327899995],
              [-71.54002844999991, -54.23121510199991],
              [-71.54214433499993, -54.26995208099993],
              [-71.57559160099993, -54.25546640399995],
              [-71.59064693899995, -54.24382903399993],
              [-71.59679114499994, -54.22909921699994],
              [-71.59064693899995, -54.21249765399995],
              [-71.57689368399991, -54.203057549999926],
              [-71.56118730399993, -54.19491952899995],
              [-71.54963131399995, -54.18181731599992],
              [-71.58771725199995, -54.193617445999905],
              [-71.60045325399994, -54.19548919099992],
              [-71.6055395169999, -54.201836846999925],
              [-71.61221269399994, -54.229587497999944],
              [-71.62124589799993, -54.23593515399995],
              [-71.65151933499993, -54.23202890399995],
              [-71.66405188699991, -54.22144947699991],
              [-71.67235266799992, -54.205336195999905],
              [-71.68984941299993, -54.18499114399992],
              [-71.69981848899994, -54.16619231599992],
              [-71.69107011599993, -54.14812590899993],
              [-71.67227128799993, -54.13201262799993],
              [-71.65200761599993, -54.119805596999925],
              [-71.61424719999991, -54.105726820999905],
              [-71.60415605399993, -54.09929778399993],
              [-71.59634355399993, -54.087823174999926],
              [-71.5996801419999, -54.080336195999905],
              [-71.61192786399994, -54.07740650799991],
              [-71.6309301419999, -54.078789971999925],
            ],
          ],
          [
            [
              [-72.01512610599991, -54.20232512799993],
              [-72.04263261599993, -54.19654713299991],
              [-72.11070716099994, -54.15390390399995],
              [-72.09430904899995, -54.14804452899995],
              [-72.05850175699993, -54.14544036299992],
              [-72.04238847599993, -54.14031340899993],
              [-72.06041419199994, -54.13355885199991],
              [-72.08165442599994, -54.131931247999944],
              [-72.12437903599994, -54.133477471999925],
              [-72.1145727199999, -54.11687590899993],
              [-72.09251868399991, -54.111586195999905],
              [-72.04238847599993, -54.113539320999905],
              [-72.05313066299993, -54.10751718499995],
              [-72.07750403599994, -54.10125090899993],
              [-72.08678137899994, -54.09587981599992],
              [-72.09166419199994, -54.08717213299991],
              [-72.09788977799991, -54.065524997999944],
              [-72.10387122299994, -54.0583635399999],
              [-72.11733964799993, -54.05982838299991],
              [-72.13524329299992, -54.07195403399993],
              [-72.16905676999994, -54.10271575299993],
              [-72.18610592399995, -54.10491301899992],
              [-72.20531165299991, -54.09189218499995],
              [-72.22118079299992, -54.07317473799992],
              [-72.22801673099991, -54.0583635399999],
              [-72.20303300699993, -54.00514088299991],
              [-72.2031957669999, -53.99627044099992],
              [-72.22935950399994, -53.9919572899999],
              [-72.23973548099991, -53.98056405999995],
              [-72.24551347599993, -53.96412525799991],
              [-72.25816809799994, -53.9450822899999],
              [-72.2591039699999, -53.92986419099992],
              [-72.23200436099995, -53.92506275799991],
              [-72.12804114499994, -53.93417734199994],
              [-72.11774654899995, -53.93914153399993],
              [-72.11107337099992, -53.95037200299993],
              [-72.10610917899993, -53.963148695999905],
              [-72.10081946499992, -53.97275155999995],
              [-72.09105383999992, -53.97926197699991],
              [-72.07787024599992, -53.98381926899992],
              [-72.06476803299995, -53.98357512799993],
              [-72.05549068899995, -53.97576262799993],
              [-72.05724036399994, -53.96835702899995],
              [-72.06582597599993, -53.96021900799991],
              [-72.08340410099993, -53.94850025799991],
              [-72.07144120999993, -53.9470354149999],
              [-72.06029212099992, -53.94882577899995],
              [-72.05044511599993, -53.953789971999925],
              [-72.04238847599993, -53.96209075299993],
              [-72.03929602799991, -53.951104424999926],
              [-72.04019120999993, -53.94280364399992],
              [-72.03970292899993, -53.934665622999944],
              [-72.0325414699999, -53.92424895599993],
              [-72.02074133999992, -53.91716887799993],
              [-72.00845292899993, -53.91155364399992],
              [-72.00210527299993, -53.90292734199994],
              [-72.00829016799992, -53.88640715899993],
              [-71.99551347599993, -53.88600025799991],
              [-71.98330644399994, -53.88746510199991],
              [-71.96051998599995, -53.89381275799991],
              [-71.96637936099995, -53.88437265399995],
              [-71.97459876199991, -53.876885674999926],
              [-71.98448645699995, -53.8708635399999],
              [-71.99522864499994, -53.865899346999925],
              [-71.94570878799993, -53.85279713299991],
              [-71.90387936099995, -53.86174895599993],
              [-71.86644446499992, -53.8864885399999],
              [-71.8301488919999, -53.920586846999925],
              [-71.84089107999995, -53.93572356599992],
              [-71.85179602799991, -53.95826588299991],
              [-71.85187740799995, -53.97405364399992],
              [-71.8301488919999, -53.96949635199991],
              [-71.82900956899994, -53.964776299999926],
              [-71.80907141799992, -53.93417734199994],
              [-71.79800370999993, -53.904554945999905],
              [-71.79259192599994, -53.89706796699994],
              [-71.78400631399995, -53.89657968499995],
              [-71.76537024599992, -53.90740325299993],
              [-71.7559301419999, -53.8982072899999],
              [-71.74233964799993, -53.89666106599992],
              [-71.72728430899991, -53.89861419099992],
              [-71.69579016799992, -53.912367445999905],
              [-71.66763261599993, -53.91814544099992],
              [-71.65290279899995, -53.92636484199994],
              [-71.71324622299994, -53.968682549999926],
              [-71.73521887899994, -53.97869231599992],
              [-71.78026282499991, -53.98772551899992],
              [-71.79222571499992, -53.997979424999926],
              [-71.78807532499991, -54.00595468499995],
              [-71.76187089799993, -54.0036760399999],
              [-71.71800696499992, -53.985039971999925],
              [-71.70059160099993, -53.985446872999944],
              [-71.69359290299991, -54.006931247999944],
              [-71.70201575399994, -54.03069426899992],
              [-71.72227942599994, -54.03753020599993],
              [-71.74697831899994, -54.03997161299992],
              [-71.76866614499994, -54.051446221999925],
              [-71.75743567599994, -54.050713799999926],
              [-71.74665279899995, -54.051853122999944],
              [-71.73643958199995, -54.05437590899993],
              [-71.72712154899995, -54.0583635399999],
              [-71.73607337099992, -54.079196872999944],
              [-71.74079342399995, -54.08562590899993],
              [-71.71873938699991, -54.0857072899999],
              [-71.68911699099993, -54.07634856599992],
              [-71.66315670499995, -54.07244231599992],
              [-71.65200761599993, -54.08904387799993],
              [-71.66063391799992, -54.103773695999905],
              [-71.71344967399995, -54.14771900799991],
              [-71.76610266799992, -54.163995049999926],
              [-71.80809485599991, -54.14812590899993],
              [-71.87108313699991, -54.08562590899993],
              [-71.90786699099993, -54.05722421699994],
              [-71.92625891799992, -54.03875090899993],
              [-71.92267818899995, -54.03045012799993],
              [-71.91832434799994, -54.02613697699991],
              [-71.91934160099993, -54.01702239399992],
              [-71.92552649599992, -54.00790780999995],
              [-71.93626868399991, -54.0036760399999],
              [-71.94717363199993, -54.006931247999944],
              [-71.95230058499993, -54.01490650799991],
              [-71.95368404899995, -54.02597421699994],
              [-71.95303300699993, -54.03785572699991],
              [-71.95010331899994, -54.05022551899992],
              [-71.94493567599994, -54.05779387799993],
              [-71.93871008999992, -54.06373463299991],
              [-71.93252519399994, -54.07195403399993],
              [-71.92015540299991, -54.10857512799993],
              [-71.91551673099991, -54.11679452899995],
              [-71.89614824099993, -54.13046640399995],
              [-71.83698482999995, -54.16130950299993],
              [-71.82363847599993, -54.17669036299992],
              [-71.81200110599991, -54.19451262799993],
              [-71.79832923099991, -54.209242445999905],
              [-71.7571508449999, -54.21965911299992],
              [-71.74445553299995, -54.23105234199994],
              [-71.74461829299992, -54.246351820999905],
              [-71.76187089799993, -54.26311614399992],
              [-71.77383378799993, -54.25920989399992],
              [-71.81753495999993, -54.25448984199994],
              [-71.83698482999995, -54.24944426899992],
              [-71.83926347599993, -54.26311614399992],
              [-71.84723873599995, -54.27271900799991],
              [-71.85850989499994, -54.279229424999926],
              [-71.87108313699991, -54.28362395599993],
              [-71.86131751199991, -54.28866952899995],
              [-71.8301488919999, -54.29729583099993],
              [-71.84972083199995, -54.309258721999925],
              [-71.85741126199991, -54.311618747999944],
              [-71.85741126199991, -54.31780364399992],
              [-71.85000566299993, -54.320245049999926],
              [-71.8301488919999, -54.33147551899992],
              [-71.84605872299994, -54.33798593499995],
              [-71.86522376199991, -54.33489348799992],
              [-71.88565019399994, -54.32870859199994],
              [-71.90526282499991, -54.325290622999944],
              [-71.94871985599991, -54.32708098799992],
              [-71.97061113199993, -54.325290622999944],
              [-71.98786373599995, -54.31780364399992],
              [-71.96231035099993, -54.29778411299992],
              [-71.93687903599994, -54.2458635399999],
              [-71.90526282499991, -54.22909921699994],
              [-71.93057206899994, -54.21249765399995],
              [-71.95860755099994, -54.205010674999926],
              [-72.01512610599991, -54.20232512799993],
            ],
          ],
          [
            [
              [-70.45503586899991, -53.61159801499991],
              [-70.46205624099991, -53.64327010699992],
              [-70.47315572799994, -53.665345213999956],
              [-70.46926929699993, -53.691737066999906],
              [-70.44533982299993, -53.76284683199992],
              [-70.42163887799995, -53.80252701099994],
              [-70.4313176199999, -53.826604603999954],
              [-70.41971855199995, -53.87122647699994],
              [-70.45221920499995, -53.88689544099992],
              [-70.44432532499991, -53.90520598799992],
              [-70.42613684799994, -53.92115650799991],
              [-70.40811113199993, -53.927992445999905],
              [-70.3958227199999, -53.93629322699991],
              [-70.3594457669999, -53.978773695999905],
              [-70.33627699399995, -54.00740331599991],
              [-70.34279526499995, -54.02806889899995],
              [-70.38477128999995, -54.05035998499994],
              [-70.43925242199992, -54.060409171999936],
              [-70.49565479599994, -54.03323146699995],
              [-70.53538977799991, -54.0036760399999],
              [-70.61050370999993, -53.94841887799993],
              [-70.64894762799992, -53.938694477999945],
              [-70.66996194899991, -53.95034151699991],
              [-70.67113196499992, -53.96770598799992],
              [-70.63508053299995, -54.00139739399992],
              [-70.59337317599994, -54.03281015399995],
              [-70.56891842399995, -54.065118096999925],
              [-70.56676184799994, -54.078057549999926],
              [-70.56786048099991, -54.08798593499995],
              [-70.57286536399994, -54.09490325299993],
              [-70.58259029899995, -54.09929778399993],
              [-70.54841061099995, -54.12053801899992],
              [-70.53880774599992, -54.13420989399992],
              [-70.53538977799991, -54.15764739399992],
              [-70.53819739499994, -54.16676197699991],
              [-70.54409745999993, -54.17457447699991],
              [-70.54906165299991, -54.1833635399999],
              [-70.54906165299991, -54.19548919099992],
              [-70.54434160099993, -54.2009416649999],
              [-70.53482011599993, -54.20745208099993],
              [-70.52354895699995, -54.212823174999926],
              [-70.51366126199991, -54.21542734199994],
              [-70.54043535099993, -54.22161223799992],
              [-70.59341386599993, -54.21379973799992],
              [-70.6856176419999, -54.18808359199994],
              [-70.82274329299992, -54.113539320999905],
              [-70.80646725199995, -54.095961195999905],
              [-70.83047441299993, -54.07577890399995],
              [-70.86595618399991, -54.052666924999926],
              [-70.88418535099993, -54.02703215899993],
              [-70.8848363919999, -53.99879322699991],
              [-70.89732825399994, -53.947930596999925],
              [-70.89753170499995, -53.93124765399995],
              [-70.88780676999994, -53.92156340899993],
              [-70.86375891799992, -53.920586846999925],
              [-70.89268958199995, -53.89104583099993],
              [-70.90054277299993, -53.873711846999925],
              [-70.88109290299991, -53.865899346999925],
              [-70.85753333199995, -53.860039971999925],
              [-70.88150532299994, -53.842263989999935],
              [-70.85536954299994, -53.83951233599993],
              [-70.81994212399991, -53.83694665399992],
              [-70.78864498599995, -53.8318010399999],
              [-70.77656970099991, -53.82467905199991],
              [-70.71806123199991, -53.84226240899994],
              [-70.6720776059999, -53.849697481999954],
              [-70.63440387299994, -53.873345334999954],
              [-70.60611442699991, -53.865125201999945],
              [-70.60054127099994, -53.829152182999906],
              [-70.63255774599992, -53.81389739399992],
              [-70.6992895169999, -53.78720468499995],
              [-70.70612545499995, -53.746351820999905],
              [-70.70421301999994, -53.740492445999905],
              [-70.70083574099993, -53.73593515399995],
              [-70.6992895169999, -53.73121510199991],
              [-70.70262610599991, -53.72535572699991],
              [-70.70612545499995, -53.72079843499995],
              [-70.70970618399991, -53.71404387799993],
              [-70.71239173099991, -53.706963799999926],
              [-70.71288001199991, -53.701429945999905],
              [-70.70059160099993, -53.69060637799993],
              [-70.6636684099999, -53.68560724699995],
              [-70.62726803299995, -53.66106536299992],
              [-70.60863196499992, -53.65325286299992],
              [-70.56645303699992, -53.62605326499994],
              [-70.54659234199994, -53.596775995999906],
              [-70.5474947749999, -53.576985512999954],
              [-70.53555253799993, -53.560479424999926],
              [-70.51060950399994, -53.55803801899992],
              [-70.48643958199995, -53.56129322699991],
              [-70.46953406199992, -53.56631495499994],
              [-70.46261091199995, -53.57636062899991],
              [-70.45503586899991, -53.61159801499991],
            ],
          ],
          [
            [
              [-73.82445227799991, -53.47210051899992],
              [-73.81973222599993, -53.47966887799993],
              [-73.80850175699993, -53.4841447899999],
              [-73.73021399599992, -53.49968840899993],
              [-73.70645097599993, -53.50823333099993],
              [-73.68785559799994, -53.5232072899999],
              [-73.70177161399994, -53.538181247999944],
              [-73.71662350199995, -53.54143645599993],
              [-73.75523841099994, -53.5368791649999],
              [-73.77953040299991, -53.53915780999995],
              [-73.78457597599993, -53.54566822699991],
              [-73.78359941299993, -53.556573174999926],
              [-73.78966223899994, -53.57170989399992],
              [-73.80418860599991, -53.58025481599992],
              [-73.82725989499994, -53.58668385199991],
              [-73.84854081899994, -53.58831145599993],
              [-73.85789954299992, -53.58163827899995],
              [-73.85362708199995, -53.56560637799993],
              [-73.84365800699993, -53.55779387799993],
              [-73.83250891799992, -53.55087655999995],
              [-73.82445227799991, -53.5368791649999],
              [-73.8743383449999, -53.539727471999925],
              [-73.88589433499993, -53.5368791649999],
              [-73.89232337099992, -53.52629973799992],
              [-73.88345292899993, -53.52011484199994],
              [-73.86815344999991, -53.51718515399995],
              [-73.85484778599994, -53.51653411299992],
              [-73.83336341099994, -53.505791924999926],
              [-73.84434973899994, -53.482354424999926],
              [-73.86058508999992, -53.458916924999926],
              [-73.85484778599994, -53.44817473799992],
              [-73.84422766799992, -53.449883721999925],
              [-73.83446204299992, -53.45476653399993],
              [-73.82725989499994, -53.46233489399992],
              [-73.82445227799991, -53.47210051899992],
            ],
          ],
          [
            [
              [-73.39244544199994, -53.413995049999926],
              [-73.45726477799991, -53.43572356599992],
              [-73.48802649599992, -53.45159270599993],
              [-73.5091039699999, -53.47551848799992],
              [-73.49689693899995, -53.478773695999905],
              [-73.49111894399994, -53.47600676899992],
              [-73.48591061099995, -53.47128671699994],
              [-73.47496497299994, -53.468682549999926],
              [-73.46788489499994, -53.47185637799993],
              [-73.45299231699994, -53.48601653399993],
              [-73.44395911399994, -53.48919036299992],
              [-73.43423417899993, -53.49472421699994],
              [-73.39244544199994, -53.53069426899992],
              [-73.40062415299991, -53.54143645599993],
              [-73.41331946499992, -53.54509856599992],
              [-73.44395911399994, -53.54436614399992],
              [-73.45221920499995, -53.54827239399992],
              [-73.47101803299995, -53.566338799999926],
              [-73.48180091099994, -53.57170989399992],
              [-73.50723222599993, -53.568617445999905],
              [-73.52049719999991, -53.55242278399993],
              [-73.52977454299992, -53.53045012799993],
              [-73.54328365799995, -53.51034921699994],
              [-73.55247962099992, -53.54045989399992],
              [-73.55964107999995, -53.5466447899999],
              [-73.57799231699994, -53.54436614399992],
              [-73.59422766799992, -53.52654387799993],
              [-73.60130774599992, -53.5232072899999],
              [-73.6497289699999, -53.51653411299992],
              [-73.66185462099992, -53.51091887799993],
              [-73.69115149599992, -53.484633070999905],
              [-73.70767167899993, -53.47551848799992],
              [-73.76500403599994, -53.45745208099993],
              [-73.77940833199995, -53.455010674999926],
              [-73.78136145699995, -53.45126718499995],
              [-73.79922441299993, -53.43596770599993],
              [-73.80333411399994, -53.43450286299992],
              [-73.80321204299992, -53.42205169099992],
              [-73.7981664699999, -53.41855234199994],
              [-73.77940833199995, -53.42083098799992],
              [-73.76598059799994, -53.42546965899993],
              [-73.69115149599992, -53.46721770599993],
              [-73.68073482999995, -53.468682549999926],
              [-73.65343176999994, -53.46721770599993],
              [-73.63914954299992, -53.46795012799993],
              [-73.62889563699991, -53.47210051899992],
              [-73.61327063699991, -53.48251718499995],
              [-73.59341386599993, -53.4900041649999],
              [-73.57494055899991, -53.49114348799992],
              [-73.56371008999992, -53.482354424999926],
              [-73.5938207669999, -53.471774997999944],
              [-73.60606848899994, -53.4646135399999],
              [-73.61900794199994, -53.455010674999926],
              [-73.59976152299993, -53.447930596999925],
              [-73.5794164699999, -53.44939544099992],
              [-73.55833899599992, -53.45370859199994],
              [-73.53701738199993, -53.455010674999926],
              [-73.54849199099993, -53.443291924999926],
              [-73.59788977799991, -53.42400481599992],
              [-73.59805253799993, -53.39267343499995],
              [-73.59260006399995, -53.385837497999944],
              [-73.57799231699994, -53.38681405999995],
              [-73.56916256399995, -53.39153411299992],
              [-73.5567113919999, -53.404554945999905],
              [-73.54670162699995, -53.407321872999944],
              [-73.53433183499993, -53.404961846999925],
              [-73.51431230399993, -53.395196221999925],
              [-73.50568600199995, -53.39299895599993],
              [-73.44847571499992, -53.39153411299992],
              [-73.43455969999991, -53.39421965899993],
              [-73.39244544199994, -53.407321872999944],
              [-73.39244544199994, -53.413995049999926],
            ],
          ],
          [
            [
              [-72.52965247299994, -54.07537200299993],
              [-72.54328365799995, -54.10003020599993],
              [-72.57437089799993, -54.0954729149999],
              [-72.60875403599994, -54.07675546699994],
              [-72.63206946499992, -54.0583635399999],
              [-72.6262914699999, -54.04827239399992],
              [-72.62344316299993, -54.0368791649999],
              [-72.62572180899991, -54.02743905999995],
              [-72.63548743399991, -54.02361419099992],
              [-72.64464270699995, -54.02695077899995],
              [-72.65025794199994, -54.03484465899993],
              [-72.6543676419999, -54.04412200299993],
              [-72.65876217399995, -54.051446221999925],
              [-72.68004309799994, -54.06878020599993],
              [-72.69261633999992, -54.07586028399993],
              [-72.70348059799994, -54.078789971999925],
              [-72.70677649599992, -54.08098723799992],
              [-72.70982825399994, -54.08611419099992],
              [-72.71141516799992, -54.09189218499995],
              [-72.71060136599993, -54.09587981599992],
              [-72.70689856699994, -54.1032854149999],
              [-72.71426347599993, -54.103773695999905],
              [-72.72411048099991, -54.10116952899995],
              [-72.72765051999994, -54.09929778399993],
              [-72.78628495999993, -54.092461846999925],
              [-72.79352779899995, -54.09726327899995],
              [-72.81704667899993, -54.12664153399993],
              [-72.8430883449999, -54.13355885199991],
              [-72.89736894399994, -54.12118905999995],
              [-72.92625891799992, -54.119805596999925],
              [-72.8965551419999, -54.11256275799991],
              [-72.88280188699991, -54.10564544099992],
              [-72.87848873599995, -54.092461846999925],
              [-72.88508053299995, -54.083916924999926],
              [-72.89712480399993, -54.08733489399992],
              [-72.91006425699993, -54.09498463299991],
              [-72.91942298099991, -54.09929778399993],
              [-72.92479407499991, -54.09710051899992],
              [-72.93390865799995, -54.087823174999926],
              [-72.9368383449999, -54.08562590899993],
              [-72.94371497299994, -54.08668385199991],
              [-72.95555579299992, -54.09124114399992],
              [-72.98424231699994, -54.09661223799992],
              [-72.99510657499991, -54.09685637799993],
              [-73.00885982999995, -54.092461846999925],
              [-73.02684485599991, -54.074883721999925],
              [-73.00450598899994, -54.06454843499995],
              [-72.93374589799993, -54.0583635399999],
              [-72.82628333199995, -54.06780364399992],
              [-72.79596920499995, -54.0583635399999],
              [-72.88072669199994, -54.03443775799991],
              [-72.88589433499993, -54.02361419099992],
              [-72.86095130099994, -54.01677825299993],
              [-72.76244055899991, -54.03045012799993],
              [-72.77293860599991, -54.01677825299993],
              [-72.80776933499993, -54.005791924999926],
              [-72.82384192599994, -53.99627044099992],
              [-72.80968176999994, -53.9958635399999],
              [-72.79735266799992, -53.99228280999995],
              [-72.78628495999993, -53.985446872999944],
              [-72.77603105399993, -53.97576262799993],
              [-72.84015865799995, -53.96038176899992],
              [-72.85057532499991, -53.95525481599992],
              [-72.84142005099994, -53.947198174999926],
              [-72.78286699099993, -53.927992445999905],
              [-72.75601152299993, -53.902601820999905],
              [-72.74307206899994, -53.893649997999944],
              [-72.72142493399991, -53.88640715899993],
              [-72.68057206899994, -53.878838799999926],
              [-72.66258704299992, -53.87224700299993],
              [-72.64513098899994, -53.859633070999905],
              [-72.74181067599994, -53.876071872999944],
              [-72.76862545499995, -53.87273528399993],
              [-72.74254309799994, -53.86093515399995],
              [-72.73298092399995, -53.85320403399993],
              [-72.72765051999994, -53.83863697699991],
              [-72.74950110599991, -53.8415666649999],
              [-72.78709876199991, -53.85816822699991],
              [-72.80955969999991, -53.859633070999905],
              [-72.78286699099993, -53.8318010399999],
              [-72.78880774599992, -53.8200822899999],
              [-72.80166581899994, -53.817478122999944],
              [-72.81627356699994, -53.820977471999925],
              [-72.84520423099991, -53.84148528399993],
              [-72.89720618399991, -53.86728280999995],
              [-72.91942298099991, -53.87273528399993],
              [-72.94367428299995, -53.868259372999944],
              [-72.95543372299994, -53.85759856599992],
              [-72.96548417899993, -53.85198333099993],
              [-73.00731360599991, -53.873711846999925],
              [-73.01610266799992, -53.86174895599993],
              [-73.02183997299994, -53.82431405999995],
              [-73.04063880099994, -53.80803801899992],
              [-73.05601966099994, -53.812758070999905],
              [-73.0664770169999, -53.83131275799991],
              [-73.07022050699993, -53.85605234199994],
              [-73.07648678299995, -53.875664971999925],
              [-73.10167395699995, -53.910414320999905],
              [-73.10440019399994, -53.93417734199994],
              [-73.0918676419999, -53.95126718499995],
              [-73.0462133449999, -53.97380950299993],
              [-73.03620357999995, -53.98601653399993],
              [-73.04405676999994, -53.999118747999944],
              [-73.06240800699993, -54.016696872999944],
              [-73.08311926999994, -54.031914971999925],
              [-73.09825598899994, -54.03785572699991],
              [-73.10407467399995, -54.03533294099992],
              [-73.10830644399994, -54.03045012799993],
              [-73.1153051419999, -54.02044036299992],
              [-73.12344316299993, -54.014336846999925],
              [-73.12946529899995, -54.01262786299992],
              [-73.13585364499994, -54.01213958099993],
              [-73.14537512899994, -54.00994231599992],
              [-73.19225012899994, -53.9919572899999],
              [-73.20409094999991, -53.98943450299993],
              [-73.27440344999991, -53.98406340899993],
              [-73.30894934799994, -53.97380950299993],
              [-73.33775794199994, -53.95525481599992],
              [-73.32445227799991, -53.95061614399992],
              [-73.29596920499995, -53.94573333099993],
              [-73.28258216099994, -53.94158294099992],
              [-73.26471920499995, -53.93206145599993],
              [-73.26219641799992, -53.92595794099992],
              [-73.26475989499994, -53.91912200299993],
              [-73.26207434799994, -53.90748463299991],
              [-73.25255286399994, -53.90195077899995],
              [-73.24071204299992, -53.89999765399995],
              [-73.2363988919999, -53.89657968499995],
              [-73.24901282499991, -53.88640715899993],
              [-73.26821855399993, -53.88005950299993],
              [-73.28087317599994, -53.881524346999925],
              [-73.28791256399995, -53.879571221999925],
              [-73.29002844999991, -53.86288827899995],
              [-73.29430091099994, -53.851820570999905],
              [-73.31305904899995, -53.84449635199991],
              [-73.31729081899994, -53.83521900799991],
              [-73.30972245999993, -53.82431405999995],
              [-73.29308020699995, -53.81975676899992],
              [-73.27647864499994, -53.81780364399992],
              [-73.26891028599994, -53.814711195999905],
              [-73.2571508449999, -53.79827239399992],
              [-73.25283769399994, -53.78606536299992],
              [-73.25865637899994, -53.773370049999926],
              [-73.2688695949999, -53.76425546699994],
              [-73.27993730399993, -53.75644296699994],
              [-73.29332434799994, -53.75123463299991],
              [-73.31045488199993, -53.75042083099993],
              [-73.31045488199993, -53.74236419099992],
              [-73.26073157499991, -53.72714609199994],
              [-73.24535071499992, -53.71575286299992],
              [-73.26207434799994, -53.701429945999905],
              [-73.27489173099991, -53.70086028399993],
              [-73.30211341099994, -53.71257903399993],
              [-73.31387285099993, -53.71559010199991],
              [-73.36245683499993, -53.71331145599993],
              [-73.53416907499991, -53.75212981599992],
              [-73.59166419199994, -53.75603606599992],
              [-73.56578528599994, -53.74041106599992],
              [-73.51927649599992, -53.721368096999925],
              [-73.48485266799992, -53.70086028399993],
              [-73.49486243399991, -53.680352471999925],
              [-73.49669348899994, -53.66497161299992],
              [-73.52623450399994, -53.66448333099993],
              [-73.56334387899994, -53.667901299999926],
              [-73.5879613919999, -53.66448333099993],
              [-73.59874426999994, -53.658868096999925],
              [-73.60875403599994, -53.65683359199994],
              [-73.61607825399994, -53.65162525799991],
              [-73.61900794199994, -53.63689544099992],
              [-73.61807206899994, -53.623304945999905],
              [-73.61534583199995, -53.61402760199991],
              [-73.61091061099995, -53.60662200299993],
              [-73.60472571499992, -53.59905364399992],
              [-73.58470618399991, -53.58277760199991],
              [-73.56509355399993, -53.57952239399992],
              [-73.49559485599991, -53.58847421699994],
              [-73.48281816299993, -53.58798593499995],
              [-73.47126217399995, -53.58163827899995],
              [-73.45787512899994, -53.56975676899992],
              [-73.44692949099993, -53.5642229149999],
              [-73.43545488199993, -53.56324635199991],
              [-73.42031816299993, -53.56487395599993],
              [-73.36558997299994, -53.57732512799993],
              [-73.33629309799994, -53.588962497999944],
              [-73.3235570949999, -53.60271575299993],
              [-73.31680253799993, -53.61931731599992],
              [-73.30044511599993, -53.63445403399993],
              [-73.28026282499991, -53.6462541649999],
              [-73.26207434799994, -53.65357838299991],
              [-73.20421301999994, -53.66619231599992],
              [-72.9739477199999, -53.669854424999926],
              [-72.95287024599992, -53.66448333099993],
              [-72.94737708199995, -53.646742445999905],
              [-72.95848548099991, -53.63323333099993],
              [-72.97655188699991, -53.63713958099993],
              [-72.99632727799991, -53.64763762799993],
              [-73.01219641799992, -53.65357838299991],
              [-73.05939693899995, -53.65309010199991],
              [-73.08079993399991, -53.6482072899999],
              [-73.08079993399991, -53.63689544099992],
              [-73.03726152299993, -53.60051848799992],
              [-73.02928626199991, -53.58473072699991],
              [-73.03819739499994, -53.59197356599992],
              [-73.04771887899994, -53.596368096999925],
              [-73.05833899599992, -53.59840260199991],
              [-73.07022050699993, -53.59905364399992],
              [-73.08096269399994, -53.60247161299992],
              [-73.08844967399995, -53.61052825299993],
              [-73.09825598899994, -53.62639739399992],
              [-73.11546790299991, -53.63958098799992],
              [-73.1348363919999, -53.6462541649999],
              [-73.15807044199994, -53.64812590899993],
              [-73.20763098899994, -53.64495208099993],
              [-73.25865637899994, -53.63518645599993],
              [-73.27635657499991, -53.62639739399992],
              [-73.29124915299991, -53.60588958099993],
              [-73.28856360599991, -53.58953215899993],
              [-73.26207434799994, -53.55803801899992],
              [-73.31578528599994, -53.55510833099993],
              [-73.33999589799993, -53.547946872999944],
              [-73.41283118399991, -53.493259372999944],
              [-73.42031816299993, -53.47893645599993],
              [-73.42125403599994, -53.47087981599992],
              [-73.42100989499994, -53.46689218499995],
              [-73.41539466099994, -53.4646135399999],
              [-73.39981035099993, -53.46249765399995],
              [-73.38735917899993, -53.46217213299991],
              [-73.34459387899994, -53.468682549999926],
              [-73.29775956899994, -53.48284270599993],
              [-73.27619381399995, -53.49431731599992],
              [-73.26207434799994, -53.51034921699994],
              [-73.22301184799994, -53.4939104149999],
              [-73.16958574099993, -53.49920012799993],
              [-73.07713782499991, -53.53069426899992],
              [-73.08820553299995, -53.51384856599992],
              [-73.10366777299993, -53.50465260199991],
              [-73.11953691299993, -53.49822356599992],
              [-73.13170325399994, -53.48919036299992],
              [-73.13556881399995, -53.47275155999995],
              [-73.13292395699995, -53.45476653399993],
              [-73.13491777299993, -53.44036223799992],
              [-73.15257727799991, -53.43450286299992],
              [-73.17398027299993, -53.43027109199994],
              [-73.17516028599994, -53.42083098799992],
              [-73.16152910099993, -53.41139088299991],
              [-73.13853919199994, -53.407321872999944],
              [-73.11416581899994, -53.40569426899992],
              [-73.09080969999991, -53.40048593499995],
              [-73.05724036399994, -53.38681405999995],
              [-73.03770911399994, -53.38551197699991],
              [-73.03262285099993, -53.39031340899993],
              [-73.03620357999995, -53.42083098799992],
              [-73.03783118399991, -53.424899997999944],
              [-73.04051673099991, -53.42888762799993],
              [-73.04019120999993, -53.43499114399992],
              [-73.02061926999994, -53.45794036299992],
              [-73.01695716099994, -53.46453215899993],
              [-73.01138261599993, -53.48919036299992],
              [-73.0020238919999, -53.493259372999944],
              [-72.99258378799993, -53.48512135199991],
              [-72.9883520169999, -53.46559010199991],
              [-72.9895727199999, -53.447523695999905],
              [-72.99388587099992, -53.43287525799991],
              [-73.00226803299995, -53.421807549999926],
              [-73.01561438699991, -53.413995049999926],
              [-73.01561438699991, -53.407321872999944],
              [-72.98477128799993, -53.41130950299993],
              [-72.93517005099994, -53.43572356599992],
              [-72.91323808499993, -53.42701588299991],
              [-72.9134008449999, -53.45077890399995],
              [-72.91808020699995, -53.471774997999944],
              [-72.92634029899995, -53.490166924999926],
              [-72.9368383449999, -53.50628020599993],
              [-72.94098873599995, -53.51832447699991],
              [-72.93667558499993, -53.52703215899993],
              [-72.92983964799993, -53.53053150799991],
              [-72.92625891799992, -53.52703215899993],
              [-72.9219457669999, -53.51490650799991],
              [-72.91120357999995, -53.50986093499995],
              [-72.89801998599995, -53.510837497999944],
              [-72.88589433499993, -53.51653411299992],
              [-72.87254798099991, -53.53484465899993],
              [-72.87653561099995, -53.55169036299992],
              [-72.88683020699995, -53.56894296699994],
              [-72.89598548099991, -53.59978606599992],
              [-72.91002356699994, -53.61296965899993],
              [-72.91323808499993, -53.62322356599992],
              [-72.91095943899995, -53.63209400799991],
              [-72.90534420499995, -53.63990650799991],
              [-72.89281165299991, -53.65357838299991],
              [-72.88923092399995, -53.672946872999944],
              [-72.88414466099994, -53.68132903399993],
              [-72.87230383999992, -53.680352471999925],
              [-72.86424719999991, -53.67156340899993],
              [-72.86510169199994, -53.65976327899995],
              [-72.87230383999992, -53.63689544099992],
              [-72.86778723899994, -53.62704843499995],
              [-72.85802161399994, -53.61988697699991],
              [-72.84821529899995, -53.61451588299991],
              [-72.84373938699991, -53.609307549999926],
              [-72.84015865799995, -53.598321221999925],
              [-72.82298743399991, -53.575290622999944],
              [-72.81704667899993, -53.56487395599993],
              [-72.81493079299992, -53.53923919099992],
              [-72.82481848899994, -53.523695570999905],
              [-72.83751380099994, -53.510837497999944],
              [-72.84703528599994, -53.48479583099993],
              [-72.86156165299991, -53.4704729149999],
              [-72.86485755099994, -53.4587541649999],
              [-72.85846920499995, -53.45273202899995],
              [-72.84455318899995, -53.45940520599993],
              [-72.82384192599994, -53.47551848799992],
              [-72.80833899599992, -53.477634372999944],
              [-72.79279537699995, -53.47795989399992],
              [-72.78087317599994, -53.48300546699994],
              [-72.77603105399993, -53.49944426899992],
              [-72.77065995999993, -53.504571221999925],
              [-72.75829016799992, -53.50986093499995],
              [-72.73448645699995, -53.51653411299992],
              [-72.74327551999994, -53.537774346999925],
              [-72.74815833199995, -53.54436614399992],
              [-72.73102779899995, -53.55429452899995],
              [-72.69098873599995, -53.58440520599993],
              [-72.67983964799993, -53.59905364399992],
              [-72.67609615799995, -53.611586195999905],
              [-72.67593339799993, -53.62249114399992],
              [-72.68032792899993, -53.632745049999926],
              [-72.69009355399993, -53.64373137799993],
              [-72.69611568899995, -53.65699635199991],
              [-72.68927975199995, -53.66765715899993],
              [-72.67857825399994, -53.67327239399992],
              [-72.67300370999993, -53.67107512799993],
              [-72.66787675699993, -53.66961028399993],
              [-72.64232337099992, -53.67148202899995],
              [-72.63206946499992, -53.667901299999926],
              [-72.63048255099994, -53.6599260399999],
              [-72.63442949099993, -53.597588799999926],
              [-72.6419164699999, -53.57740650799991],
              [-72.65461178299995, -53.560479424999926],
              [-72.67300370999993, -53.54436614399992],
              [-72.67300370999993, -53.5368791649999],
              [-72.65587317599994, -53.53679778399993],
              [-72.55797278599994, -53.578789971999925],
              [-72.54613196499992, -53.58847421699994],
              [-72.53351803299995, -53.59140390399995],
              [-72.49779212099992, -53.57586028399993],
              [-72.48131262899994, -53.57170989399992],
              [-72.4641820949999, -53.57512786299992],
              [-72.44652258999992, -53.58359140399995],
              [-72.4368383449999, -53.59531015399995],
              [-72.44371497299994, -53.609307549999926],
              [-72.43724524599992, -53.61541106599992],
              [-72.41551673099991, -53.62265390399995],
              [-72.39728756399995, -53.633477471999925],
              [-72.40176347599993, -53.6501604149999],
              [-72.41673743399991, -53.65593840899993],
              [-72.45474199099993, -53.65374114399992],
              [-72.47443600199995, -53.66106536299992],
              [-72.48468990799995, -53.67400481599992],
              [-72.4844457669999, -53.68710702899995],
              [-72.47484290299991, -53.69736093499995],
              [-72.43805904899995, -53.70549895599993],
              [-72.43614661399994, -53.715508721999925],
              [-72.45327714799993, -53.74236419099992],
              [-72.43663489499994, -53.74928150799991],
              [-72.4278051419999, -53.74114348799992],
              [-72.42064368399991, -53.728448174999926],
              [-72.40892493399991, -53.72193775799991],
              [-72.40660559799994, -53.71445077899995],
              [-72.39077714799993, -53.69939544099992],
              [-72.37303626199991, -53.687758070999905],
              [-72.3645727199999, -53.69085051899992],
              [-72.34752356699994, -53.71013762799993],
              [-72.23424231699994, -53.728773695999905],
              [-72.27326412699995, -53.75920989399992],
              [-72.26838131399995, -53.7634416649999],
              [-72.22618567599994, -53.766289971999925],
              [-72.18700110599991, -53.77654387799993],
              [-72.15274003799993, -53.79615650799991],
              [-72.13866126199991, -53.79762135199991],
              [-72.15733801999994, -53.80779387799993],
              [-72.20026607999995, -53.81365325299993],
              [-72.21715247299994, -53.82122161299992],
              [-72.22765051999994, -53.83554452899995],
              [-72.22036699099993, -53.85165780999995],
              [-72.23110917899993, -53.86931731599992],
              [-72.25088456899994, -53.87753671699994],
              [-72.27464758999992, -53.87232838299991],
              [-72.29625403599994, -53.86150481599992],
              [-72.32848059799994, -53.8396135399999],
              [-72.34862219999991, -53.83131275799991],
              [-72.36994381399995, -53.8318010399999],
              [-72.39183508999992, -53.84539153399993],
              [-72.3509008449999, -53.859633070999905],
              [-72.35619055899991, -53.87835051899992],
              [-72.34406490799995, -53.910088799999926],
              [-72.3509008449999, -53.927992445999905],
              [-72.38662675699993, -53.9040666649999],
              [-72.40953528599994, -53.89316171699994],
              [-72.41978919199994, -53.89706796699994],
              [-72.4160863919999, -53.91757577899995],
              [-72.40566972599993, -53.93124765399995],
              [-72.39028886599993, -53.94060637799993],
              [-72.37140865799995, -53.94850025799991],
              [-72.37970943899995, -53.95956796699994],
              [-72.39195716099994, -53.96249765399995],
              [-72.40599524599992, -53.963555596999925],
              [-72.41978919199994, -53.96949635199991],
              [-72.38516191299993, -53.98105234199994],
              [-72.32359778599994, -53.98943450299993],
              [-72.31777910099993, -54.00212981599992],
              [-72.32054602799991, -54.01897551899992],
              [-72.32990475199995, -54.03460051899992],
              [-72.34341386599993, -54.044040622999944],
              [-72.3548070949999, -54.04550546699994],
              [-72.36774654899995, -54.044040622999944],
              [-72.37979081899994, -54.03997161299992],
              [-72.38841712099992, -54.03411223799992],
              [-72.39704342399995, -54.03248463299991],
              [-72.42308508999992, -54.04176197699991],
              [-72.43346106699994, -54.044040622999944],
              [-72.45421301999994, -54.03826262799993],
              [-72.4590551419999, -54.02678801899992],
              [-72.45327714799993, -53.98943450299993],
              [-72.46886145699995, -53.99578215899993],
              [-72.48550370999993, -53.996351820999905],
              [-72.50157630099994, -53.99187590899993],
              [-72.51537024599992, -53.98259856599992],
              [-72.51720130099994, -53.99504973799992],
              [-72.52330481699994, -54.008477471999925],
              [-72.53278561099995, -54.02361419099992],
              [-72.51866614499994, -54.03020598799992],
              [-72.51911373599995, -54.04566822699991],
              [-72.52965247299994, -54.07537200299993],
            ],
          ],
          [
            [
              [-74.14590410099993, -53.24277109199994],
              [-74.12393144399994, -53.235039971999925],
              [-74.09581458199995, -53.228448174999926],
              [-74.07079016799992, -53.23088958099993],
              [-74.05809485599991, -53.250258070999905],
              [-74.0657445949999, -53.260023695999905],
              [-74.07774817599994, -53.263929945999905],
              [-74.09170488199993, -53.26620859199994],
              [-74.10496985599991, -53.27011484199994],
              [-74.09801184799994, -53.29265715899993],
              [-74.11611894399994, -53.30738697699991],
              [-74.14513098899994, -53.315524997999944],
              [-74.17048092399995, -53.31780364399992],
              [-74.17662512899994, -53.32000090899993],
              [-74.18846594999991, -53.32927825299993],
              [-74.19371497299994, -53.33147551899992],
              [-74.20221920499995, -53.330743096999925],
              [-74.21735592399995, -53.32586028399993],
              [-74.22508704299992, -53.32463958099993],
              [-74.23888098899994, -53.31462981599992],
              [-74.24217688699991, -53.31096770599993],
              [-74.24372311099995, -53.30282968499995],
              [-74.24128170499995, -53.29998137799993],
              [-74.23770097599993, -53.2985979149999],
              [-74.23595130099994, -53.294040622999944],
              [-74.22362219999991, -53.2810197899999],
              [-74.14590410099993, -53.24277109199994],
            ],
          ],
          [
            [
              [-73.43342037699995, -52.86541106599992],
              [-73.38532467399995, -52.89763762799993],
              [-73.37877356699994, -52.91033294099992],
              [-73.38174394399994, -52.92701588299991],
              [-73.39012610599991, -52.94158294099992],
              [-73.40290279899995, -52.95240650799991],
              [-73.41930091099994, -52.957696221999925],
              [-73.43626868399991, -52.957289320999905],
              [-73.4571020169999, -52.953057549999926],
              [-73.47630774599992, -52.945245049999926],
              [-73.48863684799994, -52.934258721999925],
              [-73.49250240799995, -52.92197030999995],
              [-73.48908443899995, -52.91269296699994],
              [-73.47838294199994, -52.907321872999944],
              [-73.46068274599992, -52.906914971999925],
              [-73.46068274599992, -52.90007903399993],
              [-73.47248287699995, -52.89812590899993],
              [-73.49168860599991, -52.88827890399995],
              [-73.50194251199991, -52.88591887799993],
              [-73.5501195949999, -52.88591887799993],
              [-73.5606176419999, -52.887383721999925],
              [-73.56883704299992, -52.88958098799992],
              [-73.57721920499995, -52.889336846999925],
              [-73.5879613919999, -52.882745049999926],
              [-73.59683183499993, -52.879164320999905],
              [-73.60960852799991, -52.87810637799993],
              [-73.63263912699995, -52.879571221999925],
              [-73.66197669199994, -52.891696872999944],
              [-73.67332923099991, -52.89332447699991],
              [-73.71540279899995, -52.89185963299991],
              [-73.72883053299995, -52.89332447699991],
              [-73.78734290299991, -52.913181247999944],
              [-73.81078040299991, -52.91375090899993],
              [-73.79808508999992, -52.89861419099992],
              [-73.75890051999994, -52.891696872999944],
              [-73.74185136599993, -52.879571221999925],
              [-73.74819902299993, -52.86923593499995],
              [-73.73648027299993, -52.86646900799991],
              [-73.7180883449999, -52.86598072699991],
              [-73.70466061099995, -52.86223723799992],
              [-73.69351152299993, -52.85279713299991],
              [-73.68455969999991, -52.84970468499995],
              [-73.67442786399994, -52.85003020599993],
              [-73.64622962099992, -52.85442473799992],
              [-73.61538652299993, -52.86345794099992],
              [-73.60130774599992, -52.86541106599992],
              [-73.59243730399993, -52.86060963299991],
              [-73.60391191299993, -52.849867445999905],
              [-73.63263912699995, -52.83123137799993],
              [-73.61172441299993, -52.82170989399992],
              [-73.55235755099994, -52.85320403399993],
              [-73.52961178299995, -52.83806731599992],
              [-73.50885982999995, -52.85247161299992],
              [-73.47850501199991, -52.866306247999944],
              [-73.44969641799992, -52.87273528399993],
              [-73.43342037699995, -52.86541106599992],
            ],
          ],
          [
            [
              [-73.20742753799993, -53.31780364399992],
              [-73.17861894399994, -53.31926848799992],
              [-73.13971920499995, -53.32781340899993],
              [-73.10545813699991, -53.340915622999944],
              [-73.09080969999991, -53.355726820999905],
              [-73.10781816299993, -53.3689104149999],
              [-73.18944251199991, -53.35816822699991],
              [-73.21739661399994, -53.36248137799993],
              [-73.23094641799992, -53.36809661299992],
              [-73.24718176999994, -53.365166924999926],
              [-73.27635657499991, -53.352634372999944],
              [-73.28905188699991, -53.34124114399992],
              [-73.2962133449999, -53.33831145599993],
              [-73.29743404899995, -53.340915622999944],
              [-73.30304928299995, -53.345961195999905],
              [-73.31045488199993, -53.35076262799993],
              [-73.31729081899994, -53.352634372999944],
              [-73.34557044199994, -53.342868747999944],
              [-73.37515214799993, -53.32439544099992],
              [-73.40172278599994, -53.302666924999926],
              [-73.42031816299993, -53.283135674999926],
              [-73.43390865799995, -53.2946916649999],
              [-73.44489498599995, -53.308526299999926],
              [-73.45799719999991, -53.32000090899993],
              [-73.47809811099995, -53.32463958099993],
              [-73.55964107999995, -53.32366301899992],
              [-73.58421790299991, -53.31780364399992],
              [-73.60204016799992, -53.30901458099993],
              [-73.60960852799991, -53.30006275799991],
              [-73.60362708199995, -53.293226820999905],
              [-73.58112545499995, -53.29062265399995],
              [-73.53184973899994, -53.299899997999944],
              [-73.5078832669999, -53.30095794099992],
              [-73.49486243399991, -53.29062265399995],
              [-73.51447506399995, -53.28460051899992],
              [-73.55842037699995, -53.27809010199991],
              [-73.57799231699994, -53.27011484199994],
              [-73.59072831899994, -53.257745049999926],
              [-73.60000566299993, -53.24146900799991],
              [-73.59976152299993, -53.227634372999944],
              [-73.58421790299991, -53.22226327899995],
              [-73.59618079299992, -53.217868747999944],
              [-73.60594641799992, -53.21111419099992],
              [-73.61164303299995, -53.20134856599992],
              [-73.61148027299993, -53.18759530999995],
              [-73.62132727799991, -53.19158294099992],
              [-73.63548743399991, -53.205010674999926],
              [-73.64256751199991, -53.20794036299992],
              [-73.65461178299995, -53.20663827899995],
              [-73.65868079299992, -53.20273202899995],
              [-73.66055253799993, -53.19622161299992],
              [-73.66616777299993, -53.18759530999995],
              [-73.69489498599995, -53.154554945999905],
              [-73.71003170499995, -53.14153411299992],
              [-73.72883053299995, -53.13290780999995],
              [-73.72642981699994, -53.142510674999926],
              [-73.71458899599992, -53.167087497999944],
              [-73.74453691299993, -53.1657854149999],
              [-73.76113847599993, -53.150648695999905],
              [-73.76829993399991, -53.129164320999905],
              [-73.76984615799995, -53.10906340899993],
              [-73.77843176999994, -53.10816822699991],
              [-73.81981360599991, -53.1130510399999],
              [-73.83433997299994, -53.10906340899993],
              [-73.85936438699991, -53.07830169099992],
              [-73.88044186099995, -53.057712497999944],
              [-73.8841039699999, -53.0583635399999],
              [-73.8860570949999, -53.06487395599993],
              [-73.89268958199995, -53.07146575299993],
              [-73.91209876199991, -53.07935963299991],
              [-73.92308508999992, -53.080336195999905],
              [-73.94050045499995, -53.07887135199991],
              [-74.03482011599993, -53.05624765399995],
              [-74.05719967399995, -53.05779387799993],
              [-74.04735266799992, -53.066338799999926],
              [-74.01622473899994, -53.08513762799993],
              [-74.02354895699995, -53.08904387799993],
              [-74.03026282499991, -53.090915622999944],
              [-74.04662024599992, -53.09124114399992],
              [-74.05443274599992, -53.0935197899999],
              [-74.06045488199993, -53.1032854149999],
              [-74.06773841099994, -53.10556405999995],
              [-74.08629309799994, -53.10491301899992],
              [-74.09410559799994, -53.10198333099993],
              [-74.10155188699991, -53.09531015399995],
              [-74.11119544199994, -53.0896135399999],
              [-74.12100175699993, -53.091729424999926],
              [-74.13052324099993, -53.09661223799992],
              [-74.13939368399991, -53.09929778399993],
              [-74.16974850199995, -53.089776299999926],
              [-74.21963456899994, -53.047133070999905],
              [-74.24893144399994, -53.03728606599992],
              [-74.23607337099992, -53.0583635399999],
              [-74.23200436099995, -53.07284921699994],
              [-74.23985755099994, -53.08294036299992],
              [-74.26260331899994, -53.09124114399992],
              [-74.28685462099992, -53.08513762799993],
              [-74.29019120999993, -53.08733489399992],
              [-74.28966223899994, -53.09710051899992],
              [-74.29369055899991, -53.09929778399993],
              [-74.30630449099993, -53.09921640399995],
              [-74.31834876199991, -53.09734465899993],
              [-74.32738196499992, -53.09221770599993],
              [-74.33092200399994, -53.081963799999926],
              [-74.32892818899995, -53.070245049999926],
              [-74.32559160099993, -53.05950286299992],
              [-74.32494055899991, -53.04900481599992],
              [-74.33092200399994, -53.03728606599992],
              [-74.33641516799992, -53.03337981599992],
              [-74.34585527299993, -53.029554945999905],
              [-74.35488847599993, -53.03053150799991],
              [-74.35879472599993, -53.04070403399993],
              [-74.36558997299994, -53.04631926899992],
              [-74.38076738199993, -53.043226820999905],
              [-74.39712480399993, -53.03630950299993],
              [-74.40721594999991, -53.02988046699994],
              [-74.40660559799994, -53.02507903399993],
              [-74.4024145169999, -53.018649997999944],
              [-74.40221106699994, -53.01100025799991],
              [-74.41344153599994, -53.00318775799991],
              [-74.40933183499993, -52.99504973799992],
              [-74.40733801999994, -52.98707447699991],
              [-74.40721594999991, -52.969008070999905],
              [-74.42503821499992, -52.97380950299993],
              [-74.4993383449999, -52.96803150799991],
              [-74.50755774599992, -52.965915622999944],
              [-74.51707923099991, -52.961602471999925],
              [-74.5176488919999, -52.9587541649999],
              [-74.51707923099991, -52.94451262799993],
              [-74.51935787699995, -52.94101327899995],
              [-74.5247289699999, -52.94085051899992],
              [-74.53107662699995, -52.94158294099992],
              [-74.58063717399995, -52.93238697699991],
              [-74.59654700399994, -52.922946872999944],
              [-74.58486894399994, -52.89568450299993],
              [-74.58608964799993, -52.886976820999905],
              [-74.58922278599994, -52.8806291649999],
              [-74.59162350199995, -52.879571221999925],
              [-74.58763587099992, -52.87151458099993],
              [-74.58299719999991, -52.86484140399995],
              [-74.57115637899994, -52.85173919099992],
              [-74.58202063699991, -52.84579843499995],
              [-74.59219316299993, -52.8376604149999],
              [-74.6087133449999, -52.821384372999944],
              [-74.70848548099991, -52.78557708099993],
              [-74.73086503799993, -52.77263762799993],
              [-74.74986731699994, -52.75554778399993],
              [-74.74278723899994, -52.74920012799993],
              [-74.73534094999991, -52.74651458099993],
              [-74.72813880099994, -52.74488697699991],
              [-74.72191321499992, -52.74187590899993],
              [-74.71760006399995, -52.740899346999925],
              [-74.70588131399995, -52.74277109199994],
              [-74.70148678299995, -52.74187590899993],
              [-74.70091712099992, -52.739353122999944],
              [-74.70205644399994, -52.73056405999995],
              [-74.70148678299995, -52.72820403399993],
              [-74.69798743399991, -52.72519296699994],
              [-74.69522050699993, -52.72144947699991],
              [-74.69151770699995, -52.7185197899999],
              [-74.68512936099995, -52.71770598799992],
              [-74.67442786399994, -52.72128671699994],
              [-74.6426488919999, -52.74472421699994],
              [-74.59845943899995, -52.769789320999905],
              [-74.57213294199994, -52.7790666649999],
              [-74.48916581899994, -52.79705169099992],
              [-74.49445553299995, -52.81170012799993],
              [-74.49767005099994, -52.81845468499995],
              [-74.50283769399994, -52.82496510199991],
              [-74.48932857999995, -52.83538176899992],
              [-74.44912675699993, -52.8493791649999],
              [-74.44078528599994, -52.855401299999926],
              [-74.43399003799993, -52.86874765399995],
              [-74.41787675699993, -52.8708635399999],
              [-74.38243567599994, -52.86541106599992],
              [-74.37096106699994, -52.87265390399995],
              [-74.38117428299995, -52.888604424999926],
              [-74.40721594999991, -52.91375090899993],
              [-74.40147864499994, -52.921807549999926],
              [-74.35879472599993, -52.947930596999925],
              [-74.34264075399994, -52.925713799999926],
              [-74.32689368399991, -52.924086195999905],
              [-74.27098548099991, -52.95761484199994],
              [-74.26146399599992, -52.96021900799991],
              [-74.24893144399994, -52.961602471999925],
              [-74.24510657499991, -52.95973072699991],
              [-74.23985755099994, -52.95077890399995],
              [-74.23595130099994, -52.947930596999925],
              [-74.22964433499993, -52.94817473799992],
              [-74.21837317599994, -52.95387135199991],
              [-74.21141516799992, -52.955336195999905],
              [-74.20571855399993, -52.951836846999925],
              [-74.19786536399994, -52.94491952899995],
              [-74.18830318899995, -52.940524997999944],
              [-74.17760169199994, -52.94451262799993],
              [-74.15660559799994, -52.97039153399993],
              [-74.15339107999995, -52.97861093499995],
              [-74.14297441299993, -52.98967864399992],
              [-74.11978105399993, -52.98300546699994],
              [-74.08385169199994, -52.961602471999925],
              [-74.11237545499995, -52.95256926899992],
              [-74.12393144399994, -52.94573333099993],
              [-74.1328832669999, -52.934258721999925],
              [-74.08934485599991, -52.94654713299991],
              [-74.07457434799994, -52.947930596999925],
              [-74.02989661399994, -52.98202890399995],
              [-74.02562415299991, -52.963555596999925],
              [-74.00780188699991, -52.9665666649999],
              [-73.96776282499991, -52.98943450299993],
              [-73.94713294199994, -52.99309661299992],
              [-73.93822180899991, -52.99618905999995],
              [-73.93431555899991, -53.00318775799991],
              [-73.93932044199994, -53.008477471999925],
              [-73.97524980399993, -53.00937265399995],
              [-73.96471106699994, -53.01848723799992],
              [-73.96003170499995, -53.021416924999926],
              [-73.95474199099993, -53.02361419099992],
              [-73.96157792899993, -53.02361419099992],
              [-73.94546464799993, -53.025323174999926],
              [-73.89952551999994, -53.03728606599992],
              [-73.90428626199991, -53.02304452899995],
              [-73.90233313699991, -53.01230234199994],
              [-73.89305579299992, -53.00554778399993],
              [-73.87588456899994, -53.00318775799991],
              [-73.86603756399995, -53.0095354149999],
              [-73.84170488199993, -53.037774346999925],
              [-73.82787024599992, -53.04412200299993],
              [-73.82396399599992, -53.04729583099993],
              [-73.8196508449999, -53.05437590899993],
              [-73.81419837099992, -53.06145598799992],
              [-73.80703691299993, -53.06462981599992],
              [-73.79832923099991, -53.062432549999926],
              [-73.79255123599995, -53.057712497999944],
              [-73.78954016799992, -53.052992445999905],
              [-73.78966223899994, -53.05095794099992],
              [-73.77204342399995, -53.05242278399993],
              [-73.75552324099993, -53.05754973799992],
              [-73.72883053299995, -53.07146575299993],
              [-73.68297278599994, -53.10751718499995],
              [-73.66982988199993, -53.112399997999944],
              [-73.66006425699993, -53.11777109199994],
              [-73.63621985599991, -53.14120859199994],
              [-73.62889563699991, -53.14657968499995],
              [-73.61034094999991, -53.14185963299991],
              [-73.61497962099992, -53.131117445999905],
              [-73.63882402299993, -53.112399997999944],
              [-73.6458227199999, -53.100681247999944],
              [-73.65998287699995, -53.05779387799993],
              [-73.64110266799992, -53.05722421699994],
              [-73.62328040299991, -53.05982838299991],
              [-73.60822506399995, -53.06658294099992],
              [-73.59788977799991, -53.07887135199991],
              [-73.59919186099995, -53.08367278399993],
              [-73.6028539699999, -53.09140390399995],
              [-73.60484778599994, -53.10035572699991],
              [-73.60130774599992, -53.10906340899993],
              [-73.59593665299991, -53.11077239399992],
              [-73.57054602799991, -53.112399997999944],
              [-73.57054602799991, -53.09929778399993],
              [-73.56794186099995, -53.10369231599992],
              [-73.55549068899995, -53.113946221999925],
              [-73.55117753799993, -53.11842213299991],
              [-73.54308020699995, -53.14104583099993],
              [-73.54523678299995, -53.15585702899995],
              [-73.55443274599992, -53.16765715899993],
              [-73.57799231699994, -53.18759530999995],
              [-73.54967200399994, -53.208103122999944],
              [-73.54328365799995, -53.214776299999926],
              [-73.53282630099994, -53.23398202899995],
              [-73.52977454299992, -53.24431731599992],
              [-73.53331458199995, -53.24895598799992],
              [-73.51634680899991, -53.26140715899993],
              [-73.50658118399991, -53.263929945999905],
              [-73.50230872299994, -53.252618096999925],
              [-73.49986731699994, -53.2380510399999],
              [-73.49303137899994, -53.23015715899993],
              [-73.48224850199995, -53.22584400799991],
              [-73.46812903599994, -53.22226327899995],
              [-73.47386633999992, -53.21111419099992],
              [-73.4817602199999, -53.20159270599993],
              [-73.49132239499994, -53.193617445999905],
              [-73.50230872299994, -53.18759530999995],
              [-73.48534094999991, -53.17107512799993],
              [-73.49771074099993, -53.143243096999925],
              [-73.48180091099994, -53.13290780999995],
              [-73.45954342399995, -53.13290780999995],
              [-73.43512936099995, -53.14023202899995],
              [-73.42202714799993, -53.15243905999995],
              [-73.43342037699995, -53.167087497999944],
              [-73.42003333199995, -53.165948174999926],
              [-73.40811113199993, -53.166680596999925],
              [-73.39858964799993, -53.170993747999944],
              [-73.39244544199994, -53.180759372999944],
              [-73.40607662699995, -53.18759530999995],
              [-73.35521399599992, -53.20452239399992],
              [-73.33775794199994, -53.214776299999926],
              [-73.31802324099993, -53.22991301899992],
              [-73.31167558499993, -53.23886484199994],
              [-73.32042395699995, -53.24277109199994],
              [-73.35875403599994, -53.24529387799993],
              [-73.37193762899994, -53.24277109199994],
              [-73.36302649599992, -53.25310637799993],
              [-73.35826575399994, -53.25644296699994],
              [-73.36603756399995, -53.27117278399993],
              [-73.34325110599991, -53.27206796699994],
              [-73.28624426999994, -53.26327890399995],
              [-73.26646887899994, -53.26873137799993],
              [-73.19444739499994, -53.30413176899992],
              [-73.20343990799995, -53.309665622999944],
              [-73.20742753799993, -53.31096770599993],
              [-73.20742753799993, -53.31780364399992],
            ],
          ],
          [
            [
              [-73.33096269399994, -52.694024346999925],
              [-73.33096269399994, -52.70086028399993],
              [-73.3692113919999, -52.72861093499995],
              [-73.38857988199993, -52.737399997999944],
              [-73.39981035099993, -52.72820403399993],
              [-73.37193762899994, -52.707696221999925],
              [-73.36290442599994, -52.70330169099992],
              [-73.33096269399994, -52.694024346999925],
            ],
          ],
          [
            [
              [-73.83739173099991, -52.70086028399993],
              [-73.85789954299992, -52.70086028399993],
              [-73.85781816299993, -52.70273202899995],
              [-73.86237545499995, -52.707289320999905],
              [-73.87218176999994, -52.715101820999905],
              [-73.87804114499994, -52.71542734199994],
              [-73.88670813699991, -52.70867278399993],
              [-73.89268958199995, -52.707696221999925],
              [-73.89793860599991, -52.71062590899993],
              [-73.90184485599991, -52.71542734199994],
              [-73.9063207669999, -52.719821872999944],
              [-73.91319739499994, -52.721368096999925],
              [-73.93614661399994, -52.72039153399993],
              [-73.94579016799992, -52.716729424999926],
              [-73.95474199099993, -52.707696221999925],
              [-73.95140540299991, -52.688164971999925],
              [-73.93980872299994, -52.676039320999905],
              [-73.90977942599994, -52.65642669099992],
              [-73.86412512899994, -52.611586195999905],
              [-73.84487870999993, -52.59783294099992],
              [-73.87633216099994, -52.60995859199994],
              [-73.95897376199991, -52.656182549999926],
              [-73.98204505099994, -52.653008721999925],
              [-73.98216712099992, -52.63250090899993],
              [-73.96694902299993, -52.61646900799991],
              [-73.88418535099993, -52.565118096999925],
              [-73.87218176999994, -52.55006275799991],
              [-73.90933183499993, -52.56015390399995],
              [-73.9940009199999, -52.61187774299992],
              [-74.03817026199994, -52.65668871699995],
              [-74.1234192739999, -52.706616519999955],
              [-74.14331847099993, -52.70697442699992],
              [-74.14696519299991, -52.69661652199994],
              [-74.1358947839999, -52.68621043499991],
              [-74.12778058899994, -52.66591508599993],
              [-74.18154858399993, -52.647949024999946],
              [-74.18954017099992, -52.61697404599994],
              [-74.18436800099994, -52.58680072399994],
              [-74.14383421699995, -52.57453332499995],
              [-74.09808427699994, -52.57086345499994],
              [-74.04971269399994, -52.56373463299991],
              [-74.01842200399994, -52.537774346999925],
              [-73.97705546499992, -52.498332475999916],
              [-73.94399946399994, -52.48278773399994],
              [-73.9481192639999, -52.47002514199994],
              [-73.98709026099993, -52.46678611599992],
              [-74.0342098239999, -52.475987113999906],
              [-74.04225415499991, -52.451190442999916],
              [-74.02972872799995, -52.42991772699992],
              [-73.97574775599992, -52.42685508699992],
              [-73.93773642799994, -52.42485124099994],
              [-73.89488456799995, -52.4081413639999],
              [-73.85517595499994, -52.41965822399993],
              [-73.82030188699991, -52.42424895599993],
              [-73.78966223899994, -52.42782968499995],
              [-73.77456620999993, -52.4079729149999],
              [-73.74909420499995, -52.39983489399992],
              [-73.72516842399995, -52.40471770599993],
              [-73.70702063699991, -52.440118096999925],
              [-73.67788652299993, -52.473321221999925],
              [-73.67699133999992, -52.48512135199991],
              [-73.68883216099994, -52.50090911299992],
              [-73.69566809799994, -52.5075822899999],
              [-73.71442623599995, -52.51246510199991],
              [-73.72423255099994, -52.517836195999905],
              [-73.73192298099991, -52.525323174999926],
              [-73.73965410099993, -52.54550546699994],
              [-73.75096594999991, -52.55006275799991],
              [-73.77940833199995, -52.55006275799991],
              [-73.78734290299991, -52.55429452899995],
              [-73.78172766799992, -52.56373463299991],
              [-73.76984615799995, -52.57317473799992],
              [-73.75890051999994, -52.57732512799993],
              [-73.73688717399995, -52.592868747999944],
              [-73.74852454299992, -52.62786223799992],
              [-73.77481035099993, -52.665134372999944],
              [-73.79649817599994, -52.68718840899993],
              [-73.80703691299993, -52.69296640399995],
              [-73.83739173099991, -52.70086028399993],
            ],
          ],
          [
            [
              [-74.67256560099992, -52.390548821999914],
              [-74.70352141199993, -52.38592848999991],
              [-74.70191954499995, -52.34956328699991],
              [-74.7132776819999, -52.34282817299993],
              [-74.7445190279999, -52.341825050999944],
              [-74.75548191399992, -52.36514557599992],
              [-74.78408487399992, -52.367861992999906],
              [-74.81541341399992, -52.350446949999935],
              [-74.82039556599995, -52.32205468199993],
              [-74.80072239799995, -52.30175502399993],
              [-74.80666038899994, -52.2842440899999],
              [-74.87669837099992, -52.25530364399992],
              [-74.9063207669999, -52.23479583099993],
              [-74.9134008449999, -52.21949635199991],
              [-74.91161048099991, -52.20281340899993],
              [-74.90029863199993, -52.19003671699994],
              [-74.8789770169999, -52.18694426899992],
              [-74.86668860599991, -52.19280364399992],
              [-74.83214270699995, -52.21754322699991],
              [-74.81517493399991, -52.236586195999905],
              [-74.79344641799992, -52.23137786299992],
              [-74.75951087099992, -52.21428801899992],
              [-74.68407141799992, -52.21428801899992],
              [-74.67454993399991, -52.21054452899995],
              [-74.64565995999993, -52.20452239399992],
              [-74.62067623599995, -52.20427825299993],
              [-74.5892850059999, -52.21289965299991],
              [-74.5777185419999, -52.23511741699991],
              [-74.54442183999993, -52.2461592759999],
              [-74.53609616999995, -52.271904546999906],
              [-74.54194958399995, -52.2890192669999],
              [-74.56042936599994, -52.314847899999904],
              [-74.56815757499993, -52.3364535419999],
              [-74.57359055699993, -52.3663201949999],
              [-74.5938386709999, -52.394820257999925],
              [-74.67256560099992, -52.390548821999914],
            ],
          ],
          [
            [
              [-73.76984615799995, -52.37932708099993],
              [-73.78636633999992, -52.38795338299991],
              [-73.80711829299992, -52.393243096999925],
              [-73.82868404899995, -52.393649997999944],
              [-73.84776770699995, -52.387790622999944],
              [-73.87267005099994, -52.37615325299993],
              [-73.8821508449999, -52.36956145599993],
              [-73.88589433499993, -52.361993096999925],
              [-73.87751217399995, -52.35637786299992],
              [-73.82445227799991, -52.34465911299992],
              [-73.82445227799991, -52.33847421699994],
              [-73.83844967399995, -52.33611419099992],
              [-73.84618079299992, -52.330336195999905],
              [-73.85147050699993, -52.32341887799993],
              [-73.85789954299992, -52.31796640399995],
              [-73.90392005099994, -52.30738697699991],
              [-73.91690019399994, -52.30022551899992],
              [-73.93496660099993, -52.28394947699991],
              [-73.9426977199999, -52.27890390399995],
              [-73.96666419199994, -52.26816171699994],
              [-73.99107825399994, -52.26116301899992],
              [-74.00255286399994, -52.255791924999926],
              [-74.02074133999992, -52.23951588299991],
              [-74.05370032499991, -52.20134856599992],
              [-74.09288489499994, -52.18523528399993],
              [-74.09276282499991, -52.16659921699994],
              [-74.07917232999995, -52.14771900799991],
              [-74.05719967399995, -52.13909270599993],
              [-74.04222571499992, -52.141289971999925],
              [-74.03278561099995, -52.14666106599992],
              [-74.02529863199993, -52.153415622999944],
              [-74.01622473899994, -52.15960051899992],
              [-74.01008053299995, -52.16057708099993],
              [-73.99559485599991, -52.15862395599993],
              [-73.9895727199999, -52.15960051899992],
              [-73.98424231699994, -52.16448333099993],
              [-73.97520911399994, -52.17693450299993],
              [-73.97154700399994, -52.1794572899999],
              [-73.96288001199991, -52.18279387799993],
              [-73.95734615799995, -52.19003671699994],
              [-73.95030676999994, -52.19736093499995],
              [-73.92686926999994, -52.203383070999905],
              [-73.89268958199995, -52.221774997999944],
              [-73.81533769399994, -52.24114348799992],
              [-73.80333411399994, -52.25212981599992],
              [-73.79906165299991, -52.258070570999905],
              [-73.78966223899994, -52.2653947899999],
              [-73.78026282499991, -52.27483489399992],
              [-73.77599036399994, -52.28655364399992],
              [-73.78014075399994, -52.29851653399993],
              [-73.79605058499993, -52.319024346999925],
              [-73.79649817599994, -52.33163827899995],
              [-73.78140214799993, -52.34197356599992],
              [-73.75938880099994, -52.34807708099993],
              [-73.7493383449999, -52.357679945999905],
              [-73.76984615799995, -52.37932708099993],
            ],
          ],
          [
            [
              [-74.12254798099991, -52.39771900799991],
              [-74.14411373599995, -52.38827890399995],
              [-74.16576087099992, -52.37615325299993],
              [-74.18732662699995, -52.36736419099992],
              [-74.19810950399994, -52.35295989399992],
              [-74.18748938699991, -52.324151299999926],
              [-74.22565670499995, -52.326429945999905],
              [-74.23595130099994, -52.324151299999926],
              [-74.24535071499992, -52.31658294099992],
              [-74.24567623599995, -52.31015390399995],
              [-74.23839270699995, -52.30543385199991],
              [-74.22508704299992, -52.30364348799992],
              [-74.21556555899991, -52.30120208099993],
              [-74.20531165299991, -52.29534270599993],
              [-74.19709225199995, -52.28769296699994],
              [-74.19371497299994, -52.28004322699991],
              [-74.23595130099994, -52.248304945999905],
              [-74.2071020169999, -52.2263322899999],
              [-74.17076575399994, -52.23381926899992],
              [-74.13426673099991, -52.24846770599993],
              [-74.10496985599991, -52.248304945999905],
              [-74.12950598899994, -52.22795989399992],
              [-74.20303300699993, -52.2028947899999],
              [-74.22166907499991, -52.18694426899992],
              [-74.20189368399991, -52.18678150799991],
              [-74.16563880099994, -52.19345468499995],
              [-74.14590410099993, -52.19378020599993],
              [-74.21450761599993, -52.16936614399992],
              [-74.24242102799991, -52.16643645599993],
              [-74.2551977199999, -52.16326262799993],
              [-74.27354895699995, -52.14918385199991],
              [-74.28343665299991, -52.14592864399992],
              [-74.2981664699999, -52.14885833099993],
              [-74.32363847599993, -52.162041924999926],
              [-74.33836829299992, -52.16643645599993],
              [-74.35985266799992, -52.16415780999995],
              [-74.39049231699994, -52.15553150799991],
              [-74.41466223899994, -52.14299895599993],
              [-74.41685950399994, -52.12900155999995],
              [-74.40192623599995, -52.118259372999944],
              [-74.34455318899995, -52.09075286299992],
              [-74.32217363199993, -52.084649346999925],
              [-74.30996660099993, -52.08342864399992],
              [-74.29735266799992, -52.08456796699994],
              [-74.28677324099993, -52.08863697699991],
              [-74.26455644399994, -52.10173919099992],
              [-74.23668372299994, -52.10947030999995],
              [-74.11913001199991, -52.18181731599992],
              [-74.08291581899994, -52.212009372999944],
              [-74.04181881399995, -52.235039971999925],
              [-74.02301998599995, -52.248304945999905],
              [-73.99571692599994, -52.27629973799992],
              [-73.95103919199994, -52.30706145599993],
              [-73.93569902299993, -52.324883721999925],
              [-73.93968665299991, -52.331963799999926],
              [-73.98204505099994, -52.33163827899995],
              [-73.96776282499991, -52.34465911299992],
              [-73.99034583199995, -52.348728122999944],
              [-74.01919511599993, -52.34465911299992],
              [-74.03941809799994, -52.34417083099993],
              [-74.03604081899994, -52.35816822699991],
              [-74.05797278599994, -52.37460702899995],
              [-74.09040279899995, -52.390557549999926],
              [-74.12254798099991, -52.39771900799991],
            ],
          ],
          [
            [
              [-74.79084225199995, -52.1794572899999],
              [-74.80329342399995, -52.172133070999905],
              [-74.80418860599991, -52.159274997999944],
              [-74.79702714799993, -52.12900155999995],
              [-74.79385331899994, -52.12395598799992],
              [-74.78636633999992, -52.121351820999905],
              [-74.77033443899995, -52.11874765399995],
              [-74.76451575399994, -52.1189104149999],
              [-74.75694739499994, -52.124118747999944],
              [-74.75291907499991, -52.122165622999944],
              [-74.74982662699995, -52.11972421699994],
              [-74.68765214799993, -52.087823174999926],
              [-74.63752193899995, -52.07732512799993],
              [-74.63255774599992, -52.0739885399999],
              [-74.62800045499995, -52.061618747999944],
              [-74.61778723899994, -52.05934010199991],
              [-74.60728919199994, -52.06194426899992],
              [-74.60179602799991, -52.06406015399995],
              [-74.59923255099994, -52.070245049999926],
              [-74.61034094999991, -52.083916924999926],
              [-74.65636145699995, -52.12265390399995],
              [-74.66421464799993, -52.13372161299992],
              [-74.66734778599994, -52.149509372999944],
              [-74.6719457669999, -52.16301848799992],
              [-74.68358313699991, -52.166680596999925],
              [-74.71507727799991, -52.16643645599993],
              [-74.74937903599994, -52.18279387799993],
              [-74.77037512899994, -52.18759530999995],
              [-74.79084225199995, -52.1794572899999],
            ],
          ],
          [
            [
              [-74.34455318899995, -52.06406015399995],
              [-74.35716712099992, -52.074151299999926],
              [-74.37279212099992, -52.07830169099992],
              [-74.38780676999994, -52.077243747999944],
              [-74.39879309799994, -52.07089609199994],
              [-74.40330969999991, -52.06487395599993],
              [-74.40640214799993, -52.0583635399999],
              [-74.40782630099994, -52.051039320999905],
              [-74.40721594999991, -52.04306405999995],
              [-74.35973059799994, -52.05681731599992],
              [-74.34455318899995, -52.06406015399995],
            ],
          ],
          [
            [
              [-74.49229895699995, -51.97869231599992],
              [-74.49388587099992, -51.99228280999995],
              [-74.51406816299993, -52.00530364399992],
              [-74.62588456899994, -52.0427385399999],
              [-74.64305579299992, -52.05315520599993],
              [-74.64948482999995, -52.059258721999925],
              [-74.65737870999993, -52.064711195999905],
              [-74.66673743399991, -52.068617445999905],
              [-74.69326738199993, -52.07317473799992],
              [-74.72044837099992, -52.08416106599992],
              [-74.73558508999992, -52.08456796699994],
              [-74.7324926419999, -52.07366301899992],
              [-74.7219945949999, -52.04998137799993],
              [-74.70714270699995, -52.02629973799992],
              [-74.69090735599991, -52.01572030999995],
              [-74.67979895699995, -52.011651299999926],
              [-74.64688066299993, -51.99228280999995],
              [-74.64000403599994, -51.98528411299992],
              [-74.62677975199995, -51.98056405999995],
              [-74.54381262899994, -51.92066822699991],
              [-74.53709876199991, -51.92742278399993],
              [-74.51935787699995, -51.93474700299993],
              [-74.50963294199994, -51.94060637799993],
              [-74.49986731699994, -51.951836846999925],
              [-74.49746660099993, -51.961195570999905],
              [-74.49681555899991, -51.96990325299993],
              [-74.49229895699995, -51.97869231599992],
            ],
          ],
          [
            [
              [-73.70767167899993, -52.18694426899992],
              [-73.70384680899991, -52.191664320999905],
              [-73.69151770699995, -52.20134856599992],
              [-73.68785559799994, -52.208103122999944],
              [-73.68761145699995, -52.21648528399993],
              [-73.69408118399991, -52.24228280999995],
              [-73.70693925699993, -52.23788827899995],
              [-73.71922766799992, -52.23088958099993],
              [-73.72996985599991, -52.221774997999944],
              [-73.73814856699994, -52.2107072899999],
              [-73.74673417899993, -52.1950822899999],
              [-73.75145423099991, -52.19019947699991],
              [-73.79649817599994, -52.15960051899992],
              [-73.80675208199995, -52.14397551899992],
              [-73.81078040299991, -52.13909270599993],
              [-73.87124589799993, -52.09490325299993],
              [-73.91026770699995, -52.08326588299991],
              [-73.96495520699995, -52.05046965899993],
              [-74.01964270699995, -52.03801848799992],
              [-74.09024003799993, -52.010023695999905],
              [-74.11241614499994, -51.99456145599993],
              [-74.1048070949999, -51.99928150799991],
              [-74.09797115799995, -52.001885674999926],
              [-74.09121660099993, -52.00074635199991],
              [-74.08385169199994, -51.99456145599993],
              [-74.07461503799993, -52.00017669099992],
              [-74.06501217399995, -52.004164320999905],
              [-74.0547582669999, -52.00701262799993],
              [-74.04352779899995, -52.008884372999944],
              [-74.05260169199994, -51.99472421699994],
              [-74.06700598899994, -51.98992278399993],
              [-74.0833227199999, -51.98796965899993],
              [-74.09813391799992, -51.98211028399993],
              [-74.11021887899994, -51.96892669099992],
              [-74.10977128799993, -51.958916924999926],
              [-74.09845943899995, -51.953789971999925],
              [-74.07770748599995, -51.95476653399993],
              [-74.09455318899995, -51.93962981599992],
              [-74.09439042899993, -51.92701588299991],
              [-74.08071855399993, -51.92148202899995],
              [-74.05719967399995, -51.92693450299993],
              [-74.06419837099992, -51.91090260199991],
              [-74.05329342399995, -51.908461195999905],
              [-74.03498287699995, -51.91448333099993],
              [-74.01964270699995, -51.923760674999926],
              [-73.98859615799995, -51.94882577899995],
              [-73.97069251199991, -51.95761484199994],
              [-73.95103919199994, -51.96103280999995],
              [-73.93663489499994, -51.96640390399995],
              [-73.78400631399995, -52.059665622999944],
              [-73.75890051999994, -52.081149997999944],
              [-73.72671464799993, -52.125664971999925],
              [-73.70767167899993, -52.15960051899992],
              [-73.70889238199993, -52.16057708099993],
              [-73.70909583199995, -52.17896900799991],
              [-73.70767167899993, -52.18694426899992],
            ],
          ],
          [
            [
              [-74.74986731699994, -52.04306405999995],
              [-74.76805579299992, -52.06853606599992],
              [-74.78294837099992, -52.08294036299992],
              [-74.80329342399995, -52.08928801899992],
              [-74.83800208199995, -52.09075286299992],
              [-74.83617102799991, -52.11207447699991],
              [-74.85057532499991, -52.13014088299991],
              [-74.87071692599994, -52.13713958099993],
              [-74.88638261599993, -52.12558359199994],
              [-74.89635169199994, -52.1130510399999],
              [-74.88890540299991, -52.09238046699994],
              [-74.87340247299994, -52.07089609199994],
              [-74.85912024599992, -52.056573174999926],
              [-74.80040442599994, -52.025323174999926],
              [-74.78335527299993, -52.008884372999944],
              [-74.81517493399991, -52.010023695999905],
              [-74.82494055899991, -52.008884372999944],
              [-74.82896887899994, -52.010023695999905],
              [-74.83202063699991, -52.013604424999926],
              [-74.83556067599994, -52.01572030999995],
              [-74.84142005099994, -52.01230234199994],
              [-74.84390214799993, -52.00798919099992],
              [-74.84544837099992, -52.00204843499995],
              [-74.84487870999993, -51.996758721999925],
              [-74.84142005099994, -51.99456145599993],
              [-74.83360755099994, -51.98528411299992],
              [-74.77989661399994, -51.87167734199994],
              [-74.75088456899994, -51.833916924999926],
              [-74.7461645169999, -51.83131275799991],
              [-74.73387610599991, -51.83318450299993],
              [-74.72834225199995, -51.83879973799992],
              [-74.72907467399995, -51.8474260399999],
              [-74.73558508999992, -51.85857512799993],
              [-74.73070227799991, -51.86728280999995],
              [-74.72874915299991, -51.87224700299993],
              [-74.71324622299994, -51.86858489399992],
              [-74.66954505099994, -51.87004973799992],
              [-74.66047115799995, -51.86882903399993],
              [-74.65269934799994, -51.85784270599993],
              [-74.61644446499992, -51.84628671699994],
              [-74.60521399599992, -51.83749765399995],
              [-74.59845943899995, -51.83749765399995],
              [-74.60753333199995, -51.856133721999925],
              [-74.62315833199995, -51.87900155999995],
              [-74.64093990799995, -51.8982072899999],
              [-74.66588294199994, -51.91139088299991],
              [-74.69090735599991, -51.944024346999925],
              [-74.70372473899994, -51.953057549999926],
              [-74.71670488199993, -51.96013762799993],
              [-74.72793535099993, -51.96884530999995],
              [-74.73558508999992, -51.98211028399993],
              [-74.72057044199994, -51.98056405999995],
              [-74.69749915299991, -51.969821872999944],
              [-74.6809789699999, -51.96843840899993],
              [-74.68565833199995, -51.97673919099992],
              [-74.69522050699993, -51.98796965899993],
              [-74.70714270699995, -51.9978166649999],
              [-74.71849524599992, -52.00204843499995],
              [-74.72630774599992, -52.00725676899992],
              [-74.74986731699994, -52.04306405999995],
            ],
          ],
          [
            [
              [-75.06114661399994, -51.88225676899992],
              [-75.07359778599994, -51.891696872999944],
              [-75.08747311099995, -51.89804452899995],
              [-75.10212154899995, -51.899509372999944],
              [-75.11685136599993, -51.89413827899995],
              [-75.11978105399993, -51.87810637799993],
              [-75.11286373599995, -51.86150481599992],
              [-75.10171464799993, -51.84384530999995],
              [-75.09243730399993, -51.824476820999905],
              [-75.10757402299993, -51.806898695999905],
              [-75.09536699099993, -51.776462497999944],
              [-75.05459550699993, -51.724867445999905],
              [-75.03978430899991, -51.71640390399995],
              [-75.01935787699995, -51.71306731599992],
              [-74.99860592399995, -51.71493905999995],
              [-74.98265540299991, -51.72144947699991],
              [-74.96996008999992, -51.73674895599993],
              [-74.97398841099994, -51.74920012799993],
              [-74.98574785099993, -51.76140715899993],
              [-74.99624589799993, -51.77662525799991],
              [-74.97516842399995, -51.77662525799991],
              [-75.00088456899994, -51.84384530999995],
              [-75.01305091099994, -51.861993096999925],
              [-75.02375240799995, -51.869073174999926],
              [-75.04930579299992, -51.87542083099993],
              [-75.06114661399994, -51.88225676899992],
            ],
          ],
          [
            [
              [-74.43455969999991, -51.84490325299993],
              [-74.42247473899994, -51.83473072699991],
              [-74.41112219999991, -51.820977471999925],
              [-74.40965735599991, -51.80868905999995],
              [-74.44351152299993, -51.79851653399993],
              [-74.45738684799994, -51.78753020599993],
              [-74.46141516799992, -51.77597421699994],
              [-74.44815019399994, -51.76921965899993],
              [-74.44815019399994, -51.762383721999925],
              [-74.46788489499994, -51.75253671699994],
              [-74.49400794199994, -51.72275155999995],
              [-74.50963294199994, -51.7146135399999],
              [-74.50283769399994, -51.70720794099992],
              [-74.41588294199994, -51.72714609199994],
              [-74.37584387899994, -51.74228280999995],
              [-74.37189693899995, -51.76921965899993],
              [-74.35753333199995, -51.76970794099992],
              [-74.31786048099991, -51.762383721999925],
              [-74.32420813699991, -51.76726653399993],
              [-74.32974199099993, -51.774102471999925],
              [-74.33018958199995, -51.78020598799992],
              [-74.31163489499994, -51.78655364399992],
              [-74.3125707669999, -51.79534270599993],
              [-74.31602942599994, -51.805759372999944],
              [-74.31411699099993, -51.81389739399992],
              [-74.29727128799993, -51.82187265399995],
              [-74.27892005099994, -51.822198174999926],
              [-74.23900305899991, -51.817071221999925],
              [-74.22874915299991, -51.81959400799991],
              [-74.22451738199993, -51.82577890399995],
              [-74.22150631399995, -51.83261484199994],
              [-74.2149145169999, -51.83749765399995],
              [-74.20531165299991, -51.83798593499995],
              [-74.18224036399994, -51.83538176899992],
              [-74.1738988919999, -51.83749765399995],
              [-74.16307532499991, -51.85556405999995],
              [-74.17739824099993, -51.86598072699991],
              [-74.20189368399991, -51.871026299999926],
              [-74.22166907499991, -51.87224700299993],
              [-74.18203691299993, -51.883477471999925],
              [-74.16079667899993, -51.88640715899993],
              [-74.13906816299993, -51.88534921699994],
              [-74.10220292899993, -51.87346770599993],
              [-74.09630286399994, -51.87737395599993],
              [-74.10496985599991, -51.89959075299993],
              [-74.11241614499994, -51.91130950299993],
              [-74.13597571499992, -51.939711195999905],
              [-74.14590410099993, -51.94736093499995],
              [-74.16734778599994, -51.951104424999926],
              [-74.19473222599993, -51.950290622999944],
              [-74.22179114499994, -51.94605885199991],
              [-74.24217688699991, -51.94060637799993],
              [-74.25153561099995, -51.92734140399995],
              [-74.25975501199991, -51.920993747999944],
              [-74.28376217399995, -51.91326262799993],
              [-74.29751542899993, -51.91529713299991],
              [-74.30638587099992, -51.91285572699991],
              [-74.31041419199994, -51.903008721999925],
              [-74.31362870999993, -51.898695570999905],
              [-74.32127844999991, -51.895603122999944],
              [-74.33031165299991, -51.89332447699991],
              [-74.36945553299995, -51.891289971999925],
              [-74.38101152299993, -51.88437265399995],
              [-74.38556881399995, -51.86882903399993],
              [-74.39207923099991, -51.86345794099992],
              [-74.43455969999991, -51.84490325299993],
            ],
          ],
          [
            [
              [-73.78966223899994, -51.735039971999925],
              [-73.77839107999995, -51.74879322699991],
              [-73.77122962099992, -51.76572030999995],
              [-73.7715551419999, -51.7810197899999],
              [-73.78282630099994, -51.789727471999925],
              [-73.79027258999992, -51.78394947699991],
              [-73.79845130099994, -51.779961846999925],
              [-73.80736243399991, -51.77752044099992],
              [-73.81696529899995, -51.77662525799991],
              [-73.80622311099995, -51.79265715899993],
              [-73.79478919199994, -51.80543385199991],
              [-73.79539954299992, -51.81389739399992],
              [-73.82070878799993, -51.817071221999925],
              [-73.83877519399994, -51.81259530999995],
              [-73.85537675699993, -51.801446221999925],
              [-73.86754309799994, -51.78720468499995],
              [-73.87645423099991, -51.75986093499995],
              [-73.8867895169999, -51.740166924999926],
              [-73.89915930899991, -51.72234465899993],
              [-73.90977942599994, -51.7146135399999],
              [-73.92983964799993, -51.7087541649999],
              [-73.93871008999992, -51.69491952899995],
              [-73.94078528599994, -51.67791106599992],
              [-73.94050045499995, -51.663181247999944],
              [-73.93040930899991, -51.65642669099992],
              [-73.90807044199994, -51.66285572699991],
              [-73.87218176999994, -51.68043385199991],
              [-73.85973059799994, -51.68450286299992],
              [-73.85399329299992, -51.68328215899993],
              [-73.85057532499991, -51.683851820999905],
              [-73.84487870999993, -51.69353606599992],
              [-73.84459387899994, -51.70256926899992],
              [-73.85334225199995, -51.72014739399992],
              [-73.85171464799993, -51.72820403399993],
              [-73.83983313699991, -51.733086846999925],
              [-73.80654863199993, -51.728448174999926],
              [-73.78966223899994, -51.735039971999925],
            ],
          ],
          [
            [
              [-74.88980058499993, -52.00204843499995],
              [-74.90396074099993, -52.00676848799992],
              [-74.90111243399991, -52.018243096999925],
              [-74.89171301999994, -52.031914971999925],
              [-74.88638261599993, -52.04306405999995],
              [-74.94953365799995, -52.11060963299991],
              [-74.96422278599994, -52.11760833099993],
              [-74.97516842399995, -52.11191171699994],
              [-74.9739477199999, -52.09970468499995],
              [-74.94786536399994, -52.056573174999926],
              [-74.99058997299994, -52.09221770599993],
              [-75.01398678299995, -52.10409921699994],
              [-75.02358964799993, -52.08456796699994],
              [-75.00694739499994, -52.07586028399993],
              [-74.9922582669999, -52.06560637799993],
              [-74.98110917899993, -52.05282968499995],
              [-74.97516842399995, -52.036228122999944],
              [-74.99453691299993, -52.041680596999925],
              [-75.00690670499995, -52.036228122999944],
              [-75.01622473899994, -52.0271135399999],
              [-75.03600012899994, -52.018243096999925],
              [-75.05117753799993, -52.007745049999926],
              [-75.06525631399995, -51.99456145599993],
              [-75.07140051999994, -51.98211028399993],
              [-75.0625707669999, -51.969008070999905],
              [-75.0247289699999, -51.96599700299993],
              [-75.01618404899995, -51.951104424999926],
              [-75.00918535099993, -51.94646575299993],
              [-74.97769120999993, -51.935804945999905],
              [-74.96898352799991, -51.92693450299993],
              [-74.98875891799992, -51.92815520599993],
              [-75.00772050699993, -51.93320077899995],
              [-75.02440344999991, -51.93328215899993],
              [-75.03722083199995, -51.92066822699991],
              [-75.00816809799994, -51.88681405999995],
              [-74.98412024599992, -51.84189218499995],
              [-74.95750891799992, -51.81560637799993],
              [-74.92052161399994, -51.83749765399995],
              [-74.93350175699993, -51.85637786299992],
              [-74.91466223899994, -51.86402760199991],
              [-74.88491777299993, -51.86874765399995],
              [-74.86534583199995, -51.87908294099992],
              [-74.85765540299991, -51.86687590899993],
              [-74.83844967399995, -51.848321221999925],
              [-74.83185787699995, -51.83749765399995],
              [-74.85411536399994, -51.83806731599992],
              [-74.86750240799995, -51.8318010399999],
              [-74.86815344999991, -51.82000090899993],
              [-74.85228430899991, -51.803399346999925],
              [-74.87425696499992, -51.79216887799993],
              [-74.88292395699995, -51.78394947699991],
              [-74.88638261599993, -51.77304452899995],
              [-74.88206946499992, -51.76490650799991],
              [-74.87132727799991, -51.764336846999925],
              [-74.85777747299994, -51.76531340899993],
              [-74.84483801999994, -51.762383721999925],
              [-74.84483801999994, -51.75554778399993],
              [-74.85997473899994, -51.748304945999905],
              [-74.86449133999992, -51.73552825299993],
              [-74.86099199099993, -51.720635674999926],
              [-74.85228430899991, -51.70720794099992],
              [-74.86412512899994, -51.70134856599992],
              [-74.87612870999993, -51.701104424999926],
              [-74.88817298099991, -51.702243747999944],
              [-74.90005449099993, -51.7009416649999],
              [-74.89468339799993, -51.688571872999944],
              [-74.89183508999992, -51.68417734199994],
              [-74.88638261599993, -51.68043385199991],
              [-74.88638261599993, -51.67302825299993],
              [-74.92223059799994, -51.65585702899995],
              [-74.92516028599994, -51.63600025799991],
              [-74.90343176999994, -51.621026299999926],
              [-74.86534583199995, -51.61834075299993],
              [-74.87279212099992, -51.62517669099992],
              [-74.86506100199995, -51.63250090899993],
              [-74.85635331899994, -51.63811614399992],
              [-74.83800208199995, -51.64568450299993],
              [-74.82282467399995, -51.63323333099993],
              [-74.80724036399994, -51.63420989399992],
              [-74.79344641799992, -51.6443010399999],
              [-74.78335527299993, -51.65935637799993],
              [-74.7903539699999, -51.67937590899993],
              [-74.77721106699994, -51.71379973799992],
              [-74.79084225199995, -51.72820403399993],
              [-74.77599036399994, -51.73796965899993],
              [-74.77135169199994, -51.751885674999926],
              [-74.76943925699993, -51.76767343499995],
              [-74.76292883999992, -51.78289153399993],
              [-74.77017167899993, -51.78435637799993],
              [-74.78282630099994, -51.78875090899993],
              [-74.79084225199995, -51.789727471999925],
              [-74.78465735599991, -51.80632903399993],
              [-74.78758704299992, -51.81926848799992],
              [-74.79369055899991, -51.830336195999905],
              [-74.80247962099992, -51.857354424999926],
              [-74.82632402299993, -51.881524346999925],
              [-74.83185787699995, -51.89617278399993],
              [-74.83165442599994, -51.92986419099992],
              [-74.83433997299994, -51.94736093499995],
              [-74.84142005099994, -51.95476653399993],
              [-74.85716712099992, -51.96217213299991],
              [-74.87865149599992, -51.99456145599993],
              [-74.88980058499993, -52.00204843499995],
            ],
          ],
          [
            [
              [-73.94391842399995, -51.741306247999944],
              [-73.9368383449999, -51.7439104149999],
              [-73.93138587099992, -51.750258070999905],
              [-73.92804928299995, -51.75823333099993],
              [-73.92682857999995, -51.76580169099992],
              [-73.92853756399995, -51.77629973799992],
              [-73.93297278599994, -51.77947356599992],
              [-73.93956458199995, -51.779961846999925],
              [-73.97984778599994, -51.797133070999905],
              [-74.01455644399994, -51.79973723799992],
              [-74.04963131399995, -51.79338958099993],
              [-74.23224850199995, -51.70720794099992],
              [-74.24063066299993, -51.69850025799991],
              [-74.23558508999992, -51.681898695999905],
              [-74.21910559799994, -51.67131926899992],
              [-74.19371497299994, -51.68043385199991],
              [-74.18333899599992, -51.6677385399999],
              [-74.16905676999994, -51.667901299999926],
              [-74.15355383999992, -51.670993747999944],
              [-74.13906816299993, -51.66676197699991],
              [-74.13247636599993, -51.654554945999905],
              [-74.1341039699999, -51.63990650799991],
              [-74.14077714799993, -51.62574635199991],
              [-74.14964758999992, -51.6150041649999],
              [-74.14964758999992, -51.604180596999925],
              [-74.12360592399995, -51.60320403399993],
              [-74.09093176999994, -51.60564544099992],
              [-74.07144120999993, -51.60475025799991],
              [-74.10098222599993, -51.565118096999925],
              [-74.10496985599991, -51.55331796699994],
              [-74.09813391799992, -51.538995049999926],
              [-74.08214270699995, -51.538181247999944],
              [-74.0637914699999, -51.54583098799992],
              [-74.04971269399994, -51.556898695999905],
              [-74.04222571499992, -51.56878020599993],
              [-74.03587805899991, -51.58416106599992],
              [-74.03148352799991, -51.60035572699991],
              [-74.02989661399994, -51.6150041649999],
              [-74.02550208199995, -51.63005950299993],
              [-74.01500403599994, -51.64267343499995],
              [-73.99266516799992, -51.663181247999944],
              [-73.98892167899993, -51.67782968499995],
              [-73.99762936099995, -51.69068775799991],
              [-74.00772050699993, -51.70256926899992],
              [-74.00877844999991, -51.7146135399999],
              [-74.00169837099992, -51.72087981599992],
              [-73.99323482999995, -51.72112395599993],
              [-73.98403886599993, -51.71990325299993],
              [-73.97524980399993, -51.72144947699991],
              [-73.94713294199994, -51.73837655999995],
              [-73.94391842399995, -51.741306247999944],
            ],
          ],
          [
            [
              [-74.19713294199994, -51.42669036299992],
              [-74.22207597599993, -51.4216447899999],
              [-74.23859615799995, -51.40960051899992],
              [-74.24046790299991, -51.39397551899992],
              [-74.22166907499991, -51.378838799999926],
              [-74.24815833199995, -51.371351820999905],
              [-74.25999915299991, -51.35312265399995],
              [-74.26292883999992, -51.3278947899999],
              [-74.26260331899994, -51.29998137799993],
              [-74.25462805899991, -51.2907854149999],
              [-74.23643958199995, -51.29111093499995],
              [-74.21666419199994, -51.29387786299992],
              [-74.20425370999993, -51.2927385399999],
              [-74.19294186099995, -51.28639088299991],
              [-74.17796790299991, -51.283461195999905],
              [-74.16510982999995, -51.287041924999926],
              [-74.15965735599991, -51.29998137799993],
              [-74.15835527299993, -51.308851820999905],
              [-74.15514075399994, -51.31845468499995],
              [-74.14590410099993, -51.337823174999926],
              [-74.13853919199994, -51.34840260199991],
              [-74.11851966099994, -51.37037525799991],
              [-74.11241614499994, -51.378838799999926],
              [-74.10777747299994, -51.40129973799992],
              [-74.10968990799995, -51.427992445999905],
              [-74.11937415299991, -51.44744231599992],
              [-74.13792883999992, -51.447523695999905],
              [-74.15892493399991, -51.41887786299992],
              [-74.16706295499995, -51.41350676899992],
              [-74.17642167899993, -51.41326262799993],
              [-74.18663489499994, -51.42392343499995],
              [-74.19713294199994, -51.42669036299992],
            ],
          ],
          [
            [
              [-75.02358964799993, -51.33098723799992],
              [-75.01211503799993, -51.33603280999995],
              [-75.00352942599994, -51.34189218499995],
              [-74.99815833199995, -51.349867445999905],
              [-74.99624589799993, -51.36174895599993],
              [-74.99722245999993, -51.37468840899993],
              [-75.00059973899994, -51.3903947899999],
              [-75.00670325399994, -51.40471770599993],
              [-75.01618404899995, -51.41350676899992],
              [-75.0313207669999, -51.41179778399993],
              [-75.05223548099991, -51.40439218499995],
              [-75.07079016799992, -51.400648695999905],
              [-75.07876542899993, -51.40984465899993],
              [-75.08112545499995, -51.42693450299993],
              [-75.08726966099994, -51.43401458099993],
              [-75.09593665299991, -51.43824635199991],
              [-75.10610917899993, -51.4470354149999],
              [-75.10952714799993, -51.45468515399995],
              [-75.10928300699993, -51.46135833099993],
              [-75.10838782499991, -51.46689218499995],
              [-75.10952714799993, -51.470961195999905],
              [-75.11595618399991, -51.47323984199994],
              [-75.12385006399995, -51.47161223799992],
              [-75.13060462099992, -51.46803150799991],
              [-75.13341223899994, -51.46412525799991],
              [-75.13585364499994, -51.45061614399992],
              [-75.14195716099994, -51.4392229149999],
              [-75.15074622299994, -51.43092213299991],
              [-75.16075598899994, -51.42669036299992],
              [-75.15770423099991, -51.45061614399992],
              [-75.13817298099991, -51.50351327899995],
              [-75.13341223899994, -51.53281015399995],
              [-75.14175370999993, -51.56503671699994],
              [-75.16242428299995, -51.57317473799992],
              [-75.18903561099995, -51.56536223799992],
              [-75.21540279899995, -51.549493096999925],
              [-75.22085527299993, -51.57480234199994],
              [-75.20864824099993, -51.59197356599992],
              [-75.20579993399991, -51.60173919099992],
              [-75.23924719999991, -51.60475025799991],
              [-75.25194251199991, -51.60759856599992],
              [-75.28941809799994, -51.62786223799992],
              [-75.30125891799992, -51.63128020599993],
              [-75.30748450399994, -51.63144296699994],
              [-75.31289628799993, -51.629164320999905],
              [-75.31725012899994, -51.622165622999944],
              [-75.31761633999992, -51.613213799999926],
              [-75.31663977799991, -51.60393645599993],
              [-75.31704667899993, -51.59539153399993],
              [-75.31895911399994, -51.59075286299992],
              [-75.32384192599994, -51.58220794099992],
              [-75.32526607999995, -51.57740650799991],
              [-75.32298743399991, -51.57187265399995],
              [-75.31468665299991, -51.54314544099992],
              [-75.31468665299991, -51.53655364399992],
              [-75.30601966099994, -51.53443775799991],
              [-75.29605058499993, -51.52988046699994],
              [-75.28693600199995, -51.524102471999925],
              [-75.2805883449999, -51.51913827899995],
              [-75.27037512899994, -51.51287200299993],
              [-75.24689693899995, -51.50725676899992],
              [-75.23591061099995, -51.5017229149999],
              [-75.22533118399991, -51.49065520599993],
              [-75.22443600199995, -51.48284270599993],
              [-75.22765051999994, -51.47584400799991],
              [-75.22964433499993, -51.46754322699991],
              [-75.22057044199994, -51.412774346999925],
              [-75.21629798099991, -51.40357838299991],
              [-75.20482337099992, -51.38909270599993],
              [-75.20002193899995, -51.38616301899992],
              [-75.19424394399994, -51.38420989399992],
              [-75.18944251199991, -51.38128020599993],
              [-75.18740800699993, -51.37542083099993],
              [-75.19025631399995, -51.36793385199991],
              [-75.19664466099994, -51.36638762799993],
              [-75.20352128799993, -51.36679452899995],
              [-75.20791581899994, -51.365166924999926],
              [-75.21450761599993, -51.34970468499995],
              [-75.22081458199995, -51.32659270599993],
              [-75.21983801999994, -51.30543385199991],
              [-75.20482337099992, -51.29615650799991],
              [-75.18512936099995, -51.28866952899995],
              [-75.16319739499994, -51.27402109199994],
              [-75.14240475199995, -51.26384856599992],
              [-75.12604732999995, -51.270196221999925],
              [-75.12608801999994, -51.286228122999944],
              [-75.14240475199995, -51.34002044099992],
              [-75.15453040299991, -51.36370208099993],
              [-75.14883378799993, -51.367120049999926],
              [-75.13866126199991, -51.36614348799992],
              [-75.12975012899994, -51.36174895599993],
              [-75.12409420499995, -51.352634372999944],
              [-75.11717688699991, -51.32740650799991],
              [-75.11294511599993, -51.317478122999944],
              [-75.11164303299995, -51.311211846999925],
              [-75.11180579299992, -51.30429452899995],
              [-75.11001542899993, -51.29851653399993],
              [-75.10240637899994, -51.29615650799991],
              [-75.09235592399995, -51.29843515399995],
              [-75.08495032499991, -51.302992445999905],
              [-75.0794164699999, -51.307712497999944],
              [-75.07510331899994, -51.30999114399992],
              [-75.07168535099993, -51.31267669099992],
              [-75.06334387899994, -51.326104424999926],
              [-75.05772864499994, -51.33098723799992],
              [-75.04971269399994, -51.33220794099992],
              [-75.03172766799992, -51.330010674999926],
              [-75.02358964799993, -51.33098723799992],
            ],
          ],
          [
            [
              [-73.79308020699995, -51.25872161299992],
              [-73.76520748599995, -51.28215911299992],
              [-73.75487219999991, -51.29762135199991],
              [-73.75890051999994, -51.31365325299993],
              [-73.7669164699999, -51.329196872999944],
              [-73.77179928299995, -51.347588799999926],
              [-73.77892005099994, -51.36345794099992],
              [-73.79369055899991, -51.371026299999926],
              [-73.80256100199995, -51.36858489399992],
              [-73.80996660099993, -51.36532968499995],
              [-73.81509355399993, -51.35995859199994],
              [-73.81696529899995, -51.351495049999926],
              [-73.83031165299991, -51.357354424999926],
              [-73.84349524599992, -51.36093515399995],
              [-73.85724850199995, -51.36150481599992],
              [-73.87218176999994, -51.35833098799992],
              [-73.88121497299994, -51.35369231599992],
              [-73.89037024599992, -51.345635674999926],
              [-73.89557857999995, -51.33521900799991],
              [-73.89268958199995, -51.324151299999926],
              [-73.87995357999995, -51.32830169099992],
              [-73.8594457669999, -51.32439544099992],
              [-73.83849036399994, -51.31519947699991],
              [-73.82445227799991, -51.30364348799992],
              [-73.87539628799993, -51.313571872999944],
              [-73.90005449099993, -51.31373463299991],
              [-73.92064368399991, -51.30364348799992],
              [-73.90013587099992, -51.28069426899992],
              [-73.86473548099991, -51.25872161299992],
              [-73.82534745999993, -51.247979424999926],
              [-73.79308020699995, -51.25872161299992],
            ],
          ],
          [
            [
              [-74.73900305899991, -51.36858489399992],
              [-74.79084225199995, -51.4196916649999],
              [-74.78335527299993, -51.42669036299992],
              [-74.79865475199995, -51.432305596999925],
              [-74.83185787699995, -51.43873463299991],
              [-74.86632239499994, -51.441338799999926],
              [-74.9063207669999, -51.45330169099992],
              [-74.92027747299994, -51.45256926899992],
              [-74.93317623599995, -51.44931405999995],
              [-74.94554602799991, -51.44890715899993],
              [-74.95811926999994, -51.456963799999926],
              [-74.97118079299992, -51.46835702899995],
              [-74.98542232999995, -51.474541924999926],
              [-75.00047766799992, -51.47470468499995],
              [-75.01618404899995, -51.46754322699991],
              [-75.02415930899991, -51.45623137799993],
              [-75.01793372299994, -51.44280364399992],
              [-75.00316321499992, -51.43132903399993],
              [-74.96764075399994, -51.422133070999905],
              [-74.87026933499993, -51.37753671699994],
              [-74.85533606699994, -51.36736419099992],
              [-74.84142005099994, -51.35491301899992],
              [-74.82843990799995, -51.346368096999925],
              [-74.81240800699993, -51.338962497999944],
              [-74.79832923099991, -51.330010674999926],
              [-74.79084225199995, -51.317478122999944],
              [-74.92178300699993, -51.36370208099993],
              [-74.95128333199995, -51.36174895599993],
              [-74.96377519399994, -51.343682549999926],
              [-74.96279863199993, -51.32935963299991],
              [-74.95177161399994, -51.316664320999905],
              [-74.93419348899994, -51.30364348799992],
              [-74.91026770699995, -51.29225025799991],
              [-74.86196855399993, -51.28394947699991],
              [-74.83800208199995, -51.27581145599993],
              [-74.83625240799995, -51.25505950299993],
              [-74.81761633999992, -51.22975025799991],
              [-74.79308020699995, -51.211195570999905],
              [-74.77375240799995, -51.21062590899993],
              [-74.76036536399994, -51.21404387799993],
              [-74.74453691299993, -51.20818450299993],
              [-74.72862708199995, -51.199151299999926],
              [-74.71507727799991, -51.19378020599993],
              [-74.69688880099994, -51.19589609199994],
              [-74.67772376199991, -51.201429945999905],
              [-74.65925045499995, -51.204196872999944],
              [-74.64305579299992, -51.19695403399993],
              [-74.60191809799994, -51.20598723799992],
              [-74.55573482999995, -51.25042083099993],
              [-74.54898027299993, -51.28435637799993],
              [-74.62633216099994, -51.26213958099993],
              [-74.62389075399994, -51.28093840899993],
              [-74.57994544199994, -51.318291924999926],
              [-74.57795162699995, -51.337823174999926],
              [-74.56651770699995, -51.34107838299991],
              [-74.5567113919999, -51.34661223799992],
              [-74.54906165299991, -51.354587497999944],
              [-74.54381262899994, -51.365166924999926],
              [-74.59422766799992, -51.399509372999944],
              [-74.62315833199995, -51.40699635199991],
              [-74.64622962099992, -51.392510674999926],
              [-74.64525305899991, -51.38787200299993],
              [-74.64207923099991, -51.379571221999925],
              [-74.64020748599995, -51.370212497999944],
              [-74.64305579299992, -51.36174895599993],
              [-74.65070553299995, -51.35515715899993],
              [-74.6660863919999, -51.34514739399992],
              [-74.67349199099993, -51.337823174999926],
              [-74.67951412699995, -51.3278947899999],
              [-74.68447831899994, -51.31462981599992],
              [-74.68736731699994, -51.299086195999905],
              [-74.68716386599993, -51.28329843499995],
              [-74.69920813699991, -51.29436614399992],
              [-74.70763098899994, -51.30901458099993],
              [-74.71792558499993, -51.31406015399995],
              [-74.73558508999992, -51.29615650799991],
              [-74.74205481699994, -51.30706145599993],
              [-74.74071204299992, -51.31658294099992],
              [-74.73428300699993, -51.32545338299991],
              [-74.72533118399991, -51.33440520599993],
              [-74.72459876199991, -51.34124114399992],
              [-74.72838294199994, -51.351495049999926],
              [-74.73403886599993, -51.36191171699994],
              [-74.73900305899991, -51.36858489399992],
            ],
          ],
          [
            [
              [-74.86534583199995, -51.12151458099993],
              [-74.86363684799994, -51.1286760399999],
              [-74.86082923099991, -51.13616301899992],
              [-74.86021887899994, -51.14381275799991],
              [-74.86534583199995, -51.152276299999926],
              [-74.87694251199991, -51.158461195999905],
              [-74.89146887899994, -51.16025155999995],
              [-74.92080644399994, -51.15911223799992],
              [-74.94196529899995, -51.16139088299991],
              [-75.00389563699991, -51.17595794099992],
              [-75.02049719999991, -51.17278411299992],
              [-75.02269446499992, -51.1618791649999],
              [-75.01622473899994, -51.147556247999944],
              [-75.00674394399994, -51.13355885199991],
              [-74.99889075399994, -51.12444426899992],
              [-74.98985755099994, -51.11646900799991],
              [-74.97984778599994, -51.10995859199994],
              [-74.96898352799991, -51.10442473799992],
              [-74.94481360599991, -51.10125090899993],
              [-74.91002356699994, -51.10312265399995],
              [-74.87881425699993, -51.110039971999925],
              [-74.86534583199995, -51.12151458099993],
            ],
          ],
          [
            [
              [-74.42027747299994, -51.111260674999926],
              [-74.39452063699991, -51.12224700299993],
              [-74.38536536399994, -51.14373137799993],
              [-74.38988196499992, -51.16936614399992],
              [-74.40514075399994, -51.19264088299991],
              [-74.41417395699995, -51.20037200299993],
              [-74.4238988919999, -51.20517343499995],
              [-74.43415279899995, -51.20582447699991],
              [-74.44489498599995, -51.20134856599992],
              [-74.45563717399995, -51.19182708099993],
              [-74.46003170499995, -51.18889739399992],
              [-74.47508704299992, -51.181898695999905],
              [-74.52041581899994, -51.16871510199991],
              [-74.55093339799993, -51.165948174999926],
              [-74.57437089799993, -51.15488046699994],
              [-74.59137936099995, -51.129164320999905],
              [-74.60171464799993, -51.10051848799992],
              [-74.60521399599992, -51.08025481599992],
              [-74.50283769399994, -51.02190520599993],
              [-74.48607337099992, -51.0212541649999],
              [-74.47044837099992, -51.025648695999905],
              [-74.45889238199993, -51.03411223799992],
              [-74.4544164699999, -51.04583098799992],
              [-74.4602758449999, -51.06210702899995],
              [-74.47345943899995, -51.06910572699991],
              [-74.48741614499994, -51.06536223799992],
              [-74.4954320949999, -51.04924895599993],
              [-74.51268469999991, -51.05950286299992],
              [-74.52114824099993, -51.07822030999995],
              [-74.51952063699991, -51.096368096999925],
              [-74.50625566299993, -51.10442473799992],
              [-74.49693762899994, -51.1052385399999],
              [-74.47297115799995, -51.11060963299991],
              [-74.45421301999994, -51.119805596999925],
              [-74.44237219999991, -51.11777109199994],
              [-74.43077551999994, -51.113213799999926],
              [-74.42027747299994, -51.111260674999926],
            ],
          ],
          [
            [
              [-74.24893144399994, -51.23479583099993],
              [-74.26260331899994, -51.24146900799991],
              [-74.27599036399994, -51.24334075299993],
              [-74.28457597599993, -51.23560963299991],
              [-74.28380286399994, -51.21428801899992],
              [-74.28380286399994, -51.21404387799993],
              [-74.28538977799991, -51.19646575299993],
              [-74.28978430899991, -51.17937590899993],
              [-74.31615149599992, -51.11012135199991],
              [-74.33287512899994, -51.03215911299992],
              [-74.33409583199995, -51.01523202899995],
              [-74.33092200399994, -50.99456145599993],
              [-74.32310950399994, -50.97356536299992],
              [-74.32176673099991, -50.964776299999926],
              [-74.32469641799992, -50.95370859199994],
              [-74.33055579299992, -50.947198174999926],
              [-74.33873450399994, -50.94296640399995],
              [-74.34683183499993, -50.93694426899992],
              [-74.35195878799993, -50.925713799999926],
              [-74.32274329299992, -50.9216447899999],
              [-74.30134029899995, -50.9392229149999],
              [-74.28819739499994, -50.96819426899992],
              [-74.28376217399995, -50.997979424999926],
              [-74.27623450399994, -51.02385833099993],
              [-74.2434789699999, -51.06926848799992],
              [-74.22736568899995, -51.130791924999926],
              [-74.19692949099993, -51.17538827899995],
              [-74.20055091099994, -51.20012786299992],
              [-74.20938066299993, -51.20916106599992],
              [-74.24893144399994, -51.23479583099993],
            ],
          ],
          [
            [
              [-74.38556881399995, -50.98105234199994],
              [-74.37938391799992, -51.0036760399999],
              [-74.38027910099993, -51.02752044099992],
              [-74.38927161399994, -51.03834400799991],
              [-74.40721594999991, -51.02190520599993],
              [-74.40501868399991, -51.037367445999905],
              [-74.39517167899993, -51.06308359199994],
              [-74.39297441299993, -51.08025481599992],
              [-74.39830481699994, -51.08684661299992],
              [-74.41002356699994, -51.07854583099993],
              [-74.42178300699993, -51.0622697899999],
              [-74.43219967399995, -51.03093840899993],
              [-74.44473222599993, -51.01441822699991],
              [-74.46056067599994, -51.00090911299992],
              [-74.47549394399994, -50.99456145599993],
              [-74.48940995999993, -50.99732838299991],
              [-74.53636633999992, -51.02190520599993],
              [-74.57713782499991, -51.03199635199991],
              [-74.61546790299991, -51.03557708099993],
              [-74.63438880099994, -51.040134372999944],
              [-74.63621985599991, -51.051853122999944],
              [-74.63036048099991, -51.068291924999926],
              [-74.62633216099994, -51.08709075299993],
              [-74.7083227199999, -51.10442473799992],
              [-74.72545325399994, -51.10507577899995],
              [-74.73961341099994, -51.101495049999926],
              [-74.74998938699991, -51.09254322699991],
              [-74.75601152299993, -51.076429945999905],
              [-74.74136308499993, -51.073337497999944],
              [-74.73692786399994, -51.06462981599992],
              [-74.74046790299991, -51.053399346999925],
              [-74.74986731699994, -51.04241301899992],
              [-74.73086503799993, -51.03557708099993],
              [-74.70982825399994, -51.0329729149999],
              [-74.69151770699995, -51.02662525799991],
              [-74.6809789699999, -51.00823333099993],
              [-74.74478105399993, -51.010023695999905],
              [-74.75951087099992, -51.00481536299992],
              [-74.77456620999993, -50.99334075299993],
              [-74.77623450399994, -51.00237395599993],
              [-74.77464758999992, -51.02117278399993],
              [-74.78026282499991, -51.038995049999926],
              [-74.8001195949999, -51.06536223799992],
              [-74.81232662699995, -51.0739885399999],
              [-74.83185787699995, -51.076429945999905],
              [-74.83372962099992, -51.07480234199994],
              [-74.86534583199995, -51.063571872999944],
              [-74.88402258999992, -51.060479424999926],
              [-74.88988196499992, -51.05754973799992],
              [-74.89321855399993, -51.04924895599993],
              [-74.83800208199995, -50.97421640399995],
              [-74.85277258999992, -50.970635674999926],
              [-74.85814368399991, -50.970635674999926],
              [-74.86534583199995, -50.97421640399995],
              [-74.87828528599994, -50.96607838299991],
              [-74.88939368399991, -50.960870049999926],
              [-74.9004613919999, -50.9587541649999],
              [-74.91368567599994, -50.96054452899995],
              [-74.92381751199991, -50.96754322699991],
              [-74.93358313699991, -50.97771575299993],
              [-74.94522050699993, -50.98284270599993],
              [-74.96153723899994, -50.97421640399995],
              [-74.96654212099992, -50.96363697699991],
              [-74.96642005099994, -50.949883721999925],
              [-74.9622289699999, -50.93596770599993],
              [-74.95470130099994, -50.925713799999926],
              [-74.94444739499994, -50.920993747999944],
              [-74.93089758999992, -50.91920338299991],
              [-74.90005449099993, -50.91952890399995],
              [-74.93089758999992, -50.89462655999995],
              [-74.92796790299991, -50.887790622999944],
              [-74.90318762899994, -50.885430596999925],
              [-74.87865149599992, -50.88632577899995],
              [-74.69591223899994, -50.91765715899993],
              [-74.66047115799995, -50.93320077899995],
              [-74.65371660099993, -50.923760674999926],
              [-74.64452063699991, -50.91920338299991],
              [-74.63459225199995, -50.9196916649999],
              [-74.62547766799992, -50.924899997999944],
              [-74.59727942599994, -50.89527760199991],
              [-74.58478756399995, -50.885430596999925],
              [-74.64045162699995, -50.885430596999925],
              [-74.65672766799992, -50.8747697899999],
              [-74.64305579299992, -50.84783294099992],
              [-74.62092037699995, -50.8376604149999],
              [-74.56899980399993, -50.83294036299992],
              [-74.55809485599991, -50.817071221999925],
              [-74.59007727799991, -50.82146575299993],
              [-74.6067602199999, -50.811618747999944],
              [-74.61766516799992, -50.79420338299991],
              [-74.63255774599992, -50.77613697699991],
              [-74.67796790299991, -50.74627044099992],
              [-74.67931067599994, -50.73528411299992],
              [-74.66047115799995, -50.72771575299993],
              [-74.55064856699994, -50.75164153399993],
              [-74.53888912699995, -50.76336028399993],
              [-74.48729407499991, -50.78215911299992],
              [-74.47549394399994, -50.79973723799992],
              [-74.46621660099993, -50.82382577899995],
              [-74.44444739499994, -50.828383070999905],
              [-74.41930091099994, -50.82968515399995],
              [-74.39976966099994, -50.844414971999925],
              [-74.39492753799993, -50.869805596999925],
              [-74.40420488199993, -50.89031340899993],
              [-74.43455969999991, -50.925713799999926],
              [-74.41832434799994, -50.93417734199994],
              [-74.40404212099992, -50.95012786299992],
              [-74.38556881399995, -50.98105234199994],
            ],
          ],
          [
            [
              [-74.9063207669999, -50.79656340899993],
              [-74.94774329299992, -50.779961846999925],
              [-74.96157792899993, -50.76921965899993],
              [-74.94786536399994, -50.76246510199991],
              [-74.95897376199991, -50.7282854149999],
              [-74.92634029899995, -50.72535572699991],
              [-74.84483801999994, -50.74822356599992],
              [-74.85411536399994, -50.731133721999925],
              [-74.89439856699994, -50.71607838299991],
              [-74.9063207669999, -50.70037200299993],
              [-74.90111243399991, -50.676039320999905],
              [-74.87759355399993, -50.68181731599992],
              [-74.83185787699995, -50.70720794099992],
              [-74.82237708199995, -50.69548919099992],
              [-74.82787024599992, -50.67815520599993],
              [-74.82848059799994, -50.665134372999944],
              [-74.80451412699995, -50.666273695999905],
              [-74.74242102799991, -50.70720794099992],
              [-74.75340735599991, -50.72014739399992],
              [-74.75352942599994, -50.733086846999925],
              [-74.75153561099995, -50.74504973799992],
              [-74.75601152299993, -50.75505950299993],
              [-74.74689693899995, -50.77027760199991],
              [-74.72378495999993, -50.79029713299991],
              [-74.71507727799991, -50.80282968499995],
              [-74.77721106699994, -50.80282968499995],
              [-74.75934811099995, -50.81682708099993],
              [-74.74136308499993, -50.82431405999995],
              [-74.72744706899994, -50.8337541649999],
              [-74.72191321499992, -50.85466887799993],
              [-74.71816972599993, -50.86150481599992],
              [-74.71019446499992, -50.853773695999905],
              [-74.70295162699995, -50.842054945999905],
              [-74.70148678299995, -50.83757903399993],
              [-74.67349199099993, -50.81023528399993],
              [-74.66047115799995, -50.82390715899993],
              [-74.67845618399991, -50.87167734199994],
              [-74.69302324099993, -50.89006926899992],
              [-74.71507727799991, -50.885430596999925],
              [-74.78197180899991, -50.88201262799993],
              [-74.84483801999994, -50.87118905999995],
              [-74.85928300699993, -50.866306247999944],
              [-74.88174394399994, -50.85515715899993],
              [-74.89321855399993, -50.85125090899993],
              [-74.90855872299994, -50.85084400799991],
              [-74.92076575399994, -50.85320403399993],
              [-74.93126380099994, -50.85100676899992],
              [-74.94163977799991, -50.83757903399993],
              [-74.92406165299991, -50.83066171699994],
              [-74.85912024599992, -50.82390715899993],
              [-74.88027910099993, -50.81698984199994],
              [-74.90412350199995, -50.815118096999925],
              [-74.92609615799995, -50.810804945999905],
              [-74.94163977799991, -50.79656340899993],
              [-74.9063207669999, -50.79656340899993],
            ],
          ],
          [
            [
              [-74.98151607999995, -50.79778411299992],
              [-74.98135331899994, -50.80006275799991],
              [-74.98468990799995, -50.80331796699994],
              [-74.99986731699994, -50.811618747999944],
              [-75.00548255099994, -50.813571872999944],
              [-75.00706946499992, -50.81389739399992],
              [-75.01683508999992, -50.812758070999905],
              [-75.03709876199991, -50.80592213299991],
              [-75.06777910099993, -50.79119231599992],
              [-75.07510331899994, -50.789727471999925],
              [-75.08389238199993, -50.78362395599993],
              [-75.09683183499993, -50.75465260199991],
              [-75.10240637899994, -50.74504973799992],
              [-75.11253821499992, -50.73251718499995],
              [-75.11314856699994, -50.72128671699994],
              [-75.10586503799993, -50.71233489399992],
              [-75.09243730399993, -50.70720794099992],
              [-75.07917232999995, -50.71054452899995],
              [-75.06680253799993, -50.71843840899993],
              [-75.05524654899995, -50.72079843499995],
              [-75.04405676999994, -50.70720794099992],
              [-75.06273352799991, -50.69158294099992],
              [-75.08039303299995, -50.67107512799993],
              [-75.08169511599993, -50.65488046699994],
              [-75.05150305899991, -50.652601820999905],
              [-75.04393469999991, -50.65488046699994],
              [-75.03795325399994, -50.65837981599992],
              [-75.0266820949999, -50.66936614399992],
              [-75.02009029899995, -50.672946872999944],
              [-75.0149633449999, -50.67148202899995],
              [-75.01146399599992, -50.66814544099992],
              [-75.00991777299993, -50.666273695999905],
              [-75.00112870999993, -50.6618791649999],
              [-74.9922582669999, -50.65553150799991],
              [-74.98542232999995, -50.65715911299992],
              [-74.98265540299991, -50.67620208099993],
              [-74.98473059799994, -50.68962981599992],
              [-74.99413001199991, -50.71111419099992],
              [-74.99624589799993, -50.72429778399993],
              [-74.99624589799993, -50.75872161299992],
              [-74.99913489499994, -50.781182549999926],
              [-74.99649003799993, -50.792087497999944],
              [-74.98570716099994, -50.79656340899993],
              [-74.98448645699995, -50.79656340899993],
              [-74.98241126199991, -50.797133070999905],
              [-74.98151607999995, -50.79778411299992],
            ],
          ],
          [
            [
              [-74.6087133449999, -50.51482512799993],
              [-74.58409583199995, -50.53093840899993],
              [-74.60265051999994, -50.56308359199994],
              [-74.64045162699995, -50.58635833099993],
              [-74.67349199099993, -50.57691822699991],
              [-74.67137610599991, -50.556898695999905],
              [-74.68455969999991, -50.53199635199991],
              [-74.6809789699999, -50.51482512799993],
              [-74.66649329299992, -50.50310637799993],
              [-74.64757239499994, -50.50448984199994],
              [-74.62730872299994, -50.51091887799993],
              [-74.6087133449999, -50.51482512799993],
            ],
          ],
          [
            [
              [-75.12604732999995, -50.49431731599992],
              [-75.10533606699994, -50.49578215899993],
              [-75.09740149599992, -50.49724700299993],
              [-75.09886633999992, -50.50237395599993],
              [-75.11168372299994, -50.523695570999905],
              [-75.11986243399991, -50.53362395599993],
              [-75.12954667899993, -50.5427385399999],
              [-75.13963782499991, -50.54900481599992],
              [-75.15514075399994, -50.551039320999905],
              [-75.16637122299994, -50.54957447699991],
              [-75.17446855399993, -50.552992445999905],
              [-75.18065344999991, -50.57000090899993],
              [-75.18805904899995, -50.56389739399992],
              [-75.19635982999995, -50.559665622999944],
              [-75.20543372299994, -50.55706145599993],
              [-75.21540279899995, -50.5564104149999],
              [-75.20360266799992, -50.58082447699991],
              [-75.2024633449999, -50.59295012799993],
              [-75.21540279899995, -50.59693775799991],
              [-75.24608313699991, -50.59734465899993],
              [-75.26891028599994, -50.589776299999926],
              [-75.30077063699991, -50.556573174999926],
              [-75.32152258999992, -50.54900481599992],
              [-75.34557044199994, -50.56072356599992],
              [-75.27086341099994, -50.62053801899992],
              [-75.29043535099993, -50.64576588299991],
              [-75.29735266799992, -50.63836028399993],
              [-75.3047582669999, -50.64576588299991],
              [-75.28246008999992, -50.65292734199994],
              [-75.27204342399995, -50.65764739399992],
              [-75.26317298099991, -50.666273695999905],
              [-75.27501380099994, -50.67546965899993],
              [-75.28075110599991, -50.68108489399992],
              [-75.28302975199995, -50.686211846999925],
              [-75.28429114499994, -50.69353606599992],
              [-75.28123938699991, -50.699476820999905],
              [-75.27749589799993, -50.70916106599992],
              [-75.28229732999995, -50.71607838299991],
              [-75.3047582669999, -50.71404387799993],
              [-75.3047582669999, -50.72087981599992],
              [-75.29002844999991, -50.7282854149999],
              [-75.27912350199995, -50.73984140399995],
              [-75.27464758999992, -50.75408294099992],
              [-75.27892005099994, -50.77011484199994],
              [-75.29059811099995, -50.78183359199994],
              [-75.3079320949999, -50.78948333099993],
              [-75.32506262899994, -50.788995049999926],
              [-75.33604895699995, -50.776462497999944],
              [-75.33617102799991, -50.77068450299993],
              [-75.33242753799993, -50.7575822899999],
              [-75.33141028599994, -50.75164153399993],
              [-75.33629309799994, -50.74081796699994],
              [-75.34654700399994, -50.74627044099992],
              [-75.35631262899994, -50.75725676899992],
              [-75.35936438699991, -50.76246510199991],
              [-75.38646399599992, -50.77206796699994],
              [-75.41063391799992, -50.77239348799992],
              [-75.46182206899994, -50.76246510199991],
              [-75.45799719999991, -50.75400155999995],
              [-75.45189368399991, -50.7478166649999],
              [-75.44375566299993, -50.74382903399993],
              [-75.43390865799995, -50.7419572899999],
              [-75.44863847599993, -50.72380950299993],
              [-75.45498613199993, -50.71233489399992],
              [-75.45156816299993, -50.70720794099992],
              [-75.43854732999995, -50.70598723799992],
              [-75.4238988919999, -50.70208098799992],
              [-75.41201738199993, -50.69459400799991],
              [-75.40713456899994, -50.68328215899993],
              [-75.40705318899995, -50.673760674999926],
              [-75.40892493399991, -50.67131926899992],
              [-75.48228919199994, -50.67506275799991],
              [-75.49657141799992, -50.67245859199994],
              [-75.50755774599992, -50.66562265399995],
              [-75.51427161399994, -50.65683359199994],
              [-75.51382402299993, -50.649102471999925],
              [-75.50332597599993, -50.64576588299991],
              [-75.48643958199995, -50.64609140399995],
              [-75.47581946499992, -50.6443010399999],
              [-75.47028561099995, -50.63730234199994],
              [-75.46861731699994, -50.62127044099992],
              [-75.45596269399994, -50.60637786299992],
              [-75.42690995999993, -50.60409921699994],
              [-75.37303626199991, -50.61101653399993],
              [-75.37511145699995, -50.606540622999944],
              [-75.37800045499995, -50.59531015399995],
              [-75.37987219999991, -50.590508721999925],
              [-75.35936438699991, -50.590508721999925],
              [-75.37694251199991, -50.57236093499995],
              [-75.39028886599993, -50.5525041649999],
              [-75.40689042899993, -50.538181247999944],
              [-75.43390865799995, -50.53590260199991],
              [-75.43199622299994, -50.531182549999926],
              [-75.42951412699995, -50.51970794099992],
              [-75.42764238199993, -50.51482512799993],
              [-75.4414770169999, -50.51482512799993],
              [-75.45303300699993, -50.5114885399999],
              [-75.46206620999993, -50.50465260199991],
              [-75.46861731699994, -50.49431731599992],
              [-75.46035722599993, -50.491306247999944],
              [-75.45221920499995, -50.48943450299993],
              [-75.43419348899994, -50.4880510399999],
              [-75.42418372299994, -50.48381926899992],
              [-75.41657467399995, -50.46453215899993],
              [-75.40379798099991, -50.46013762799993],
              [-75.38198808499993, -50.463962497999944],
              [-75.37071692599994, -50.47356536299992],
              [-75.36314856699994, -50.48674895599993],
              [-75.35260982999995, -50.50115325299993],
              [-75.34154212099992, -50.48788827899995],
              [-75.33763587099992, -50.474867445999905],
              [-75.33092200399994, -50.46648528399993],
              [-75.31159420499995, -50.467054945999905],
              [-75.29991614499994, -50.47380950299993],
              [-75.28917395699995, -50.494398695999905],
              [-75.27684485599991, -50.50115325299993],
              [-75.26891028599994, -50.50009530999995],
              [-75.26162675699993, -50.49553801899992],
              [-75.25674394399994, -50.49065520599993],
              [-75.25633704299992, -50.4880510399999],
              [-75.24937903599994, -50.49065520599993],
              [-75.24242102799991, -50.49504973799992],
              [-75.23737545499995, -50.49944426899992],
              [-75.23591061099995, -50.50115325299993],
              [-75.23058020699995, -50.503024997999944],
              [-75.22752844999991, -50.50554778399993],
              [-75.22345943899995, -50.50790780999995],
              [-75.21540279899995, -50.50855885199991],
              [-75.20763098899994, -50.50644296699994],
              [-75.20372473899994, -50.50212981599992],
              [-75.20055091099994, -50.49749114399992],
              [-75.19489498599995, -50.49431731599992],
              [-75.16246497299994, -50.49236419099992],
              [-75.12604732999995, -50.49431731599992],
            ],
          ],
          [
            [
              [-74.31041419199994, -50.83416106599992],
              [-74.32217363199993, -50.84587981599992],
              [-74.34801184799994, -50.842054945999905],
              [-74.37376868399991, -50.82740650799991],
              [-74.38556881399995, -50.806573174999926],
              [-74.39679928299995, -50.79143645599993],
              [-74.41685950399994, -50.77613697699991],
              [-74.42479407499991, -50.7614885399999],
              [-74.39976966099994, -50.74822356599992],
              [-74.43309485599991, -50.74342213299991],
              [-74.48302161399994, -50.7419572899999],
              [-74.51707923099991, -50.73162200299993],
              [-74.50283769399994, -50.70037200299993],
              [-74.53823808499993, -50.69264088299991],
              [-74.54381262899994, -50.69019947699991],
              [-74.54698645699995, -50.68222421699994],
              [-74.5676977199999, -50.65569426899992],
              [-74.58120683499993, -50.63355885199991],
              [-74.57022050699993, -50.62004973799992],
              [-74.53014075399994, -50.604180596999925],
              [-74.52725175699993, -50.59889088299991],
              [-74.52391516799992, -50.5896135399999],
              [-74.51952063699991, -50.580743096999925],
              [-74.51341712099992, -50.57691822699991],
              [-74.46532141799992, -50.57000090899993],
              [-74.46117102799991, -50.56568775799991],
              [-74.46865800699993, -50.54412200299993],
              [-74.46865800699993, -50.53590260199991],
              [-74.45962480399993, -50.53045012799993],
              [-74.44640051999994, -50.52792734199994],
              [-74.43219967399995, -50.52752044099992],
              [-74.42027747299994, -50.52849700299993],
              [-74.43146725199995, -50.52068450299993],
              [-74.44399980399993, -50.515557549999926],
              [-74.45685787699995, -50.51531340899993],
              [-74.46865800699993, -50.52223072699991],
              [-74.48741614499994, -50.51311614399992],
              [-74.50145423099991, -50.50920989399992],
              [-74.56053626199991, -50.50701262799993],
              [-74.57957923099991, -50.50139739399992],
              [-74.59512285099993, -50.49081796699994],
              [-74.60521399599992, -50.47380950299993],
              [-74.62092037699995, -50.479180596999925],
              [-74.63963782499991, -50.48186614399992],
              [-74.6582738919999, -50.48056405999995],
              [-74.67349199099993, -50.47380950299993],
              [-74.65355383999992, -50.46526458099993],
              [-74.61058508999992, -50.438571872999944],
              [-74.5950414699999, -50.43287525799991],
              [-74.56956946499992, -50.42937590899993],
              [-74.55247962099992, -50.42392343499995],
              [-74.5371801419999, -50.42457447699991],
              [-74.51707923099991, -50.439711195999905],
              [-74.50967363199993, -50.44939544099992],
              [-74.50454667899993, -50.4587541649999],
              [-74.49864661399994, -50.467054945999905],
              [-74.48916581899994, -50.47380950299993],
              [-74.47667395699995, -50.4763322899999],
              [-74.43081620999993, -50.47380950299993],
              [-74.41026770699995, -50.46795012799993],
              [-74.39614824099993, -50.458103122999944],
              [-74.38312740799995, -50.45598723799992],
              [-74.36563066299993, -50.47380950299993],
              [-74.35631262899994, -50.49065520599993],
              [-74.34748287699995, -50.511651299999926],
              [-74.33267167899993, -50.57732512799993],
              [-74.31867428299995, -50.59197356599992],
              [-74.28376217399995, -50.61101653399993],
              [-74.27110755099994, -50.62428150799991],
              [-74.23900305899991, -50.67620208099993],
              [-74.24925696499992, -50.68010833099993],
              [-74.34455318899995, -50.666273695999905],
              [-74.38654537699995, -50.651055596999925],
              [-74.40876217399995, -50.64690520599993],
              [-74.42711341099994, -50.652601820999905],
              [-74.40257727799991, -50.664320570999905],
              [-74.34398352799991, -50.67205169099992],
              [-74.31053626199991, -50.68906015399995],
              [-74.2981664699999, -50.692071221999925],
              [-74.28795325399994, -50.69768645599993],
              [-74.28376217399995, -50.71062590899993],
              [-74.27806555899991, -50.72039153399993],
              [-74.26524817599994, -50.720635674999926],
              [-74.24242102799991, -50.71404387799993],
              [-74.22264563699991, -50.72161223799992],
              [-74.20348059799994, -50.73992278399993],
              [-74.18858801999994, -50.762383721999925],
              [-74.18130449099993, -50.782321872999944],
              [-74.18065344999991, -50.80803801899992],
              [-74.18610592399995, -50.833103122999944],
              [-74.19920813699991, -50.848321221999925],
              [-74.23672441299993, -50.84107838299991],
              [-74.24266516799992, -50.805352471999925],
              [-74.25641842399995, -50.789727471999925],
              [-74.26935787699995, -50.78655364399992],
              [-74.27765865799995, -50.789320570999905],
              [-74.28628495999993, -50.79412200299993],
              [-74.31550045499995, -50.800713799999926],
              [-74.31737219999991, -50.810479424999926],
              [-74.31041419199994, -50.83416106599992],
            ],
          ],
          [
            [
              [-74.78335527299993, -50.48064544099992],
              [-74.77757727799991, -50.461195570999905],
              [-74.76634680899991, -50.444024346999925],
              [-74.73558508999992, -50.412367445999905],
              [-74.74400794199994, -50.409274997999944],
              [-74.76292883999992, -50.398695570999905],
              [-74.73672441299993, -50.37184010199991],
              [-74.69595292899993, -50.362399997999944],
              [-74.6087133449999, -50.363946221999925],
              [-74.59959876199991, -50.366306247999944],
              [-74.58006751199991, -50.376071872999944],
              [-74.5676977199999, -50.37818775799991],
              [-74.54938717399995, -50.37818775799991],
              [-74.54458574099993, -50.38209400799991],
              [-74.54381262899994, -50.39185963299991],
              [-74.55500240799995, -50.40374114399992],
              [-74.57892818899995, -50.40984465899993],
              [-74.62633216099994, -50.412367445999905],
              [-74.62633216099994, -50.418633721999925],
              [-74.62295488199993, -50.427992445999905],
              [-74.62873287699995, -50.43962981599992],
              [-74.64085852799991, -50.44931405999995],
              [-74.65672766799992, -50.45330169099992],
              [-74.67503821499992, -50.45435963299991],
              [-74.68447831899994, -50.45777760199991],
              [-74.72028561099995, -50.489353122999944],
              [-74.73037675699993, -50.49309661299992],
              [-74.7461645169999, -50.49431731599992],
              [-74.77676347599993, -50.49334075299993],
              [-74.78530839799993, -50.48943450299993],
              [-74.78335527299993, -50.48064544099992],
            ],
          ],
          [
            [
              [-75.04063880099994, -50.28948333099993],
              [-75.05931555899991, -50.29778411299992],
              [-75.07559160099993, -50.31373463299991],
              [-75.09410559799994, -50.32439544099992],
              [-75.11978105399993, -50.31682708099993],
              [-75.11628170499995, -50.32350025799991],
              [-75.11367753799993, -50.332696221999925],
              [-75.11489824099993, -50.34075286299992],
              [-75.12287350199995, -50.34417083099993],
              [-75.13499915299991, -50.34644947699991],
              [-75.14004472599993, -50.35198333099993],
              [-75.14248613199993, -50.35857512799993],
              [-75.14647376199991, -50.363946221999925],
              [-75.17072506399995, -50.37818775799991],
              [-75.18077551999994, -50.380791924999926],
              [-75.18468176999994, -50.38713958099993],
              [-75.18675696499992, -50.394789320999905],
              [-75.19115149599992, -50.40178801899992],
              [-75.20327714799993, -50.41570403399993],
              [-75.21129309799994, -50.42782968499995],
              [-75.22288977799991, -50.43645598799992],
              [-75.24608313699991, -50.439711195999905],
              [-75.30557206899994, -50.432305596999925],
              [-75.32115637899994, -50.4275041649999],
              [-75.32420813699991, -50.41920338299991],
              [-75.32506262899994, -50.40984465899993],
              [-75.32323157499991, -50.400323174999926],
              [-75.31777910099993, -50.39185963299991],
              [-75.27647864499994, -50.37379322699991],
              [-75.27375240799995, -50.37078215899993],
              [-75.25365149599992, -50.36248137799993],
              [-75.23021399599992, -50.342868747999944],
              [-75.19489498599995, -50.3025041649999],
              [-75.21446692599994, -50.30396900799991],
              [-75.24258378799993, -50.31373463299991],
              [-75.27009029899995, -50.32756926899992],
              [-75.29698645699995, -50.34644947699991],
              [-75.30776933499993, -50.3474260399999],
              [-75.31358801999994, -50.34335702899995],
              [-75.30817623599995, -50.33326588299991],
              [-75.29059811099995, -50.32195403399993],
              [-75.2852270169999, -50.31536223799992],
              [-75.29043535099993, -50.30877044099992],
              [-75.30459550699993, -50.30527109199994],
              [-75.31167558499993, -50.31113046699994],
              [-75.31688391799992, -50.32105885199991],
              [-75.32526607999995, -50.3298479149999],
              [-75.33641516799992, -50.3337541649999],
              [-75.34593665299991, -50.33326588299991],
              [-75.35627193899995, -50.33123137799993],
              [-75.36961829299992, -50.3298479149999],
              [-75.39093990799995, -50.33806731599992],
              [-75.41169186099995, -50.354587497999944],
              [-75.43272864499994, -50.36736419099992],
              [-75.45494544199994, -50.363946221999925],
              [-75.46092688699991, -50.35003020599993],
              [-75.44505774599992, -50.27662525799991],
              [-75.43740800699993, -50.26881275799991],
              [-75.42756100199995, -50.2634416649999],
              [-75.40086829299992, -50.25798919099992],
              [-75.40412350199995, -50.249932549999926],
              [-75.42145748599995, -50.23495859199994],
              [-75.42015540299991, -50.2224260399999],
              [-75.41624915299991, -50.21640390399995],
              [-75.41128495999993, -50.21257903399993],
              [-75.40713456899994, -50.206963799999926],
              [-75.39745032499991, -50.1716447899999],
              [-75.39045162699995, -50.16228606599992],
              [-75.36709550699993, -50.14739348799992],
              [-75.34788977799991, -50.145196221999925],
              [-75.29735266799992, -50.15911223799992],
              [-75.26789303299995, -50.15862395599993],
              [-75.25975501199991, -50.16228606599992],
              [-75.25609290299991, -50.170179945999905],
              [-75.25926673099991, -50.177992445999905],
              [-75.26618404899995, -50.18401458099993],
              [-75.27375240799995, -50.18645598799992],
              [-75.31761633999992, -50.188571872999944],
              [-75.3391820949999, -50.19280364399992],
              [-75.35260982999995, -50.20077890399995],
              [-75.33189856699994, -50.219008070999905],
              [-75.31891842399995, -50.22616952899995],
              [-75.30817623599995, -50.22405364399992],
              [-75.29474850199995, -50.21754322699991],
              [-75.28612219999991, -50.22576262799993],
              [-75.27916419199994, -50.239353122999944],
              [-75.27061926999994, -50.24863046699994],
              [-75.25621497299994, -50.24968840899993],
              [-75.24233964799993, -50.24578215899993],
              [-75.22793535099993, -50.244073174999926],
              [-75.21165930899991, -50.25164153399993],
              [-75.19798743399991, -50.25628020599993],
              [-75.17931067599994, -50.255791924999926],
              [-75.14647376199991, -50.24863046699994],
              [-75.15672766799992, -50.22144947699991],
              [-75.14492753799993, -50.1970354149999],
              [-75.12726803299995, -50.17083098799992],
              [-75.11978105399993, -50.13876718499995],
              [-75.16478430899991, -50.16155364399992],
              [-75.18797766799992, -50.16415780999995],
              [-75.21507727799991, -50.15545012799993],
              [-75.22667395699995, -50.14853280999995],
              [-75.24608313699991, -50.12810637799993],
              [-75.25869706899994, -50.12346770599993],
              [-75.29088294199994, -50.126885674999926],
              [-75.3047582669999, -50.12509530999995],
              [-75.32152258999992, -50.11272551899992],
              [-75.33800208199995, -50.09661223799992],
              [-75.3574926419999, -50.08261484199994],
              [-75.38329016799992, -50.07659270599993],
              [-75.38638261599993, -50.07170989399992],
              [-75.39785722599993, -50.04778411299992],
              [-75.40038001199991, -50.03915780999995],
              [-75.39476477799991, -50.03199635199991],
              [-75.38166256399995, -50.03289153399993],
              [-75.36583411399994, -50.035821221999925],
              [-75.35260982999995, -50.03573984199994],
              [-75.3430883449999, -50.028415622999944],
              [-75.3301488919999, -50.00709400799991],
              [-75.32526607999995, -50.00156015399995],
              [-75.31289628799993, -50.00042083099993],
              [-75.29698645699995, -50.00286223799992],
              [-75.28571529899995, -50.00896575299993],
              [-75.28742428299995, -50.018243096999925],
              [-75.29161536399994, -50.02890390399995],
              [-75.28726152299993, -50.039727471999925],
              [-75.28042558499993, -50.049899997999944],
              [-75.27684485599991, -50.059258721999925],
              [-75.27147376199991, -50.067071221999925],
              [-75.25959225199995, -50.06015390399995],
              [-75.23350989499994, -50.03199635199991],
              [-75.22964433499993, -50.02890390399995],
              [-75.22716223899994, -50.03069426899992],
              [-75.20173092399995, -50.03573984199994],
              [-75.17149817599994, -50.023370049999926],
              [-75.15705318899995, -50.021416924999926],
              [-75.12873287699995, -50.029554945999905],
              [-75.12474524599992, -50.04851653399993],
              [-75.13101152299993, -50.069431247999944],
              [-75.13341223899994, -50.08342864399992],
              [-75.12181555899991, -50.09303150799991],
              [-75.10936438699991, -50.08831145599993],
              [-75.09679114499994, -50.07935963299991],
              [-75.08503170499995, -50.07659270599993],
              [-75.07909094999991, -50.082696221999925],
              [-75.05540930899991, -50.12322356599992],
              [-75.05211341099994, -50.12517669099992],
              [-75.04405676999994, -50.12509530999995],
              [-75.0352270169999, -50.12127044099992],
              [-75.03258216099994, -50.11492278399993],
              [-75.03213456899994, -50.10816822699991],
              [-75.02977454299992, -50.10393645599993],
              [-75.01577714799993, -50.100274346999925],
              [-75.00031490799995, -50.097914320999905],
              [-74.98778235599991, -50.09254322699991],
              [-74.98265540299991, -50.080010674999926],
              [-74.97716223899994, -50.072198174999926],
              [-74.96524003799993, -50.07236093499995],
              [-74.95327714799993, -50.07976653399993],
              [-74.94786536399994, -50.094008070999905],
              [-74.95213782499991, -50.10881926899992],
              [-74.96271725199995, -50.116306247999944],
              [-74.98884029899995, -50.12509530999995],
              [-75.07140051999994, -50.179620049999926],
              [-75.07140051999994, -50.18645598799992],
              [-75.05101477799991, -50.18564218499995],
              [-75.03669186099995, -50.18320077899995],
              [-74.99290930899991, -50.16692473799992],
              [-74.98013261599993, -50.16521575299993],
              [-74.94786536399994, -50.16529713299991],
              [-74.94298255099994, -50.16676197699991],
              [-74.93358313699991, -50.172539971999925],
              [-74.92804928299995, -50.17278411299992],
              [-74.92365475199995, -50.1696916649999],
              [-74.92023678299995, -50.16090260199991],
              [-74.91710364499994, -50.15911223799992],
              [-74.90111243399991, -50.152601820999905],
              [-74.89321855399993, -50.15162525799991],
              [-74.87828528599994, -50.15488046699994],
              [-74.86945553299995, -50.15829843499995],
              [-74.86046301999994, -50.15520598799992],
              [-74.84483801999994, -50.13876718499995],
              [-74.85065670499995, -50.134698174999926],
              [-74.85342363199993, -50.13030364399992],
              [-74.8555395169999, -50.12468840899993],
              [-74.85912024599992, -50.11760833099993],
              [-74.81501217399995, -50.1189104149999],
              [-74.79971269399994, -50.12542083099993],
              [-74.79084225199995, -50.145603122999944],
              [-74.79369055899991, -50.169854424999926],
              [-74.81590735599991, -50.19548919099992],
              [-74.81126868399991, -50.21379973799992],
              [-74.83385169199994, -50.21949635199991],
              [-74.94237219999991, -50.22014739399992],
              [-74.95128333199995, -50.22405364399992],
              [-74.95278886599993, -50.23316822699991],
              [-74.95055091099994, -50.24578215899993],
              [-74.95221920499995, -50.25676848799992],
              [-74.98151607999995, -50.265883070999905],
              [-75.01756751199991, -50.285088799999926],
              [-75.04063880099994, -50.28948333099993],
            ],
          ],
          [
            [
              [-75.44810950399994, -49.77499765399995],
              [-75.47554811899994, -49.78138109199995],
              [-75.48990700999991, -49.78673886699994],
              [-75.50649980399993, -49.79550546699994],
              [-75.52061926999994, -49.800713799999926],
              [-75.54023738199993, -49.80818033799994],
              [-75.54279399199993, -49.823576748999926],
              [-75.54413818799992, -49.83667820699992],
              [-75.57414489999991, -49.847394798999915],
              [-75.6173869559999, -49.86422267899991],
              [-75.63485425899995, -49.82794301999991],
              [-75.62030425799992, -49.809511039999904],
              [-75.63545525299992, -49.78172259799993],
              [-75.62678626299993, -49.75634257099995],
              [-75.58850842499993, -49.745700738999915],
              [-75.55500244599995, -49.73426623499995],
              [-75.52525159499993, -49.73972354299991],
              [-75.51075727699993, -49.71822296499994],
              [-75.52136676999993, -49.7051241179999],
              [-75.54041469599991, -49.70430165699992],
              [-75.56354732999995, -49.70745208099993],
              [-75.58667750799992, -49.68799822199992],
              [-75.58290930599992, -49.66571432899991],
              [-75.58149384299992, -49.64264951699994],
              [-75.61351964699992, -49.636375453999904],
              [-75.57407071099993, -49.61268836599993],
              [-75.56301177299991, -49.59976494499995],
              [-75.5480192839999, -49.588968173999945],
              [-75.52938104999993, -49.586219016999905],
              [-75.51186060399993, -49.588277166999944],
              [-75.49751930199994, -49.583503692999955],
              [-75.49881389699993, -49.573865257999955],
              [-75.5087412609999, -49.56378898199995],
              [-75.5043518679999, -49.55697339599993],
              [-75.49505736099991, -49.55740438299995],
              [-75.48519168399991, -49.56466565699992],
              [-75.47223205799992, -49.57273847099992],
              [-75.45858781699991, -49.57076872199991],
              [-75.4462197439999, -49.57883543199995],
              [-75.4338383999999, -49.5828829159999],
              [-75.41153686099995, -49.58494433299995],
              [-75.39423567499995, -49.5910067179999],
              [-75.38157881399991, -49.603236444999936],
              [-75.3553394459999, -49.61017613999991],
              [-75.34532630099994, -49.63567473799992],
              [-75.32848059799994, -49.65203215899993],
              [-75.31159420499995, -49.672539971999925],
              [-75.30752519399994, -49.68010833099993],
              [-75.30109615799995, -49.69882577899995],
              [-75.29735266799992, -49.70671965899993],
              [-75.29141191299993, -49.70956796699994],
              [-75.28246008999992, -49.71103280999995],
              [-75.27424068899995, -49.714776299999926],
              [-75.26943925699993, -49.727227471999925],
              [-75.2669164699999, -49.731133721999925],
              [-75.26431230399993, -49.736586195999905],
              [-75.26317298099991, -49.74423593499995],
              [-75.25357011599993, -49.760430596999925],
              [-75.21129309799994, -49.7927385399999],
              [-75.20173092399995, -49.81218840899993],
              [-75.17788652299993, -49.88420989399992],
              [-75.18065344999991, -49.905368747999944],
              [-75.19298255099994, -49.891289971999925],
              [-75.20734615799995, -49.884698174999926],
              [-75.22207597599993, -49.87981536299992],
              [-75.23591061099995, -49.87118905999995],
              [-75.24714107999995, -49.85605234199994],
              [-75.2532445949999, -49.8435197899999],
              [-75.26276607999995, -49.83456796699994],
              [-75.28429114499994, -49.82952239399992],
              [-75.27603105399993, -49.84140390399995],
              [-75.26935787699995, -49.8571916649999],
              [-75.26480058499993, -49.87395598799992],
              [-75.26317298099991, -49.88787200299993],
              [-75.27041581899994, -49.89804452899995],
              [-75.28648841099994, -49.89511484199994],
              [-75.30308997299994, -49.88591887799993],
              [-75.31159420499995, -49.87737395599993],
              [-75.33971106699994, -49.85955169099992],
              [-75.36733964799993, -49.82887135199991],
              [-75.37572180899991, -49.7985979149999],
              [-75.3457738919999, -49.78183359199994],
              [-75.36620032499991, -49.72031015399995],
              [-75.37303626199991, -49.72031015399995],
              [-75.38451087099992, -49.74822356599992],
              [-75.43125425699992, -49.75837686299991],
              [-75.44810950399994, -49.77499765399995],
            ],
          ],
          [
            [
              [-75.52130818799992, -49.37909900199992],
              [-75.50597671999992, -49.38685564799994],
              [-75.48951388599994, -49.40307624999991],
              [-75.47058132399991, -49.40314945499995],
              [-75.46120726499993, -49.41855571699995],
              [-75.46721344399992, -49.43469194699992],
              [-75.4684824229999, -49.44929831199994],
              [-75.45905925699992, -49.45855763599991],
              [-75.44475428999993, -49.45016819999995],
              [-75.43529417199994, -49.45712748299991],
              [-75.42943267599992, -49.46636515599994],
              [-75.43425559299993, -49.48017988599992],
              [-75.43312914199993, -49.48940315099992],
              [-75.43083664099993, -49.501703112999905],
              [-75.44041954199992, -49.51781086199992],
              [-75.45109330399993, -49.51854777799991],
              [-75.45577813999995, -49.51008088899994],
              [-75.46638622099994, -49.497746882999934],
              [-75.49245701399991, -49.49535086399993],
              [-75.49950548499993, -49.48533071799994],
              [-75.51249538499991, -49.47835879199994],
              [-75.53135242899992, -49.464452353999945],
              [-75.54429919599994, -49.452866366999956],
              [-75.5371046109999, -49.44058807899995],
              [-75.5181509969999, -49.43912132499992],
              [-75.50157544599995, -49.438411025999926],
              [-75.50264592099995, -49.42148808999991],
              [-75.51679972099993, -49.41451272799992],
              [-75.5357846629999, -49.42136179399995],
              [-75.54755410199994, -49.41131134299991],
              [-75.54149375899993, -49.39055984999993],
              [-75.52130818799992, -49.37909900199992],
            ],
          ],
          [
            [
              [-74.90318762899994, -49.07675546699994],
              [-74.89045162699995, -49.0954729149999],
              [-74.89492753799993, -49.13762786299992],
              [-74.91368567599994, -49.205743096999925],
              [-74.91567949099993, -49.25139739399992],
              [-74.92052161399994, -49.27263762799993],
              [-74.93569902299993, -49.28045012799993],
              [-74.94912675699993, -49.2771135399999],
              [-74.96271725199995, -49.270603122999944],
              [-75.01284745999993, -49.23772551899992],
              [-75.05996660099993, -49.19646575299993],
              [-75.07876542899993, -49.17229583099993],
              [-75.07433020699995, -49.16806405999995],
              [-75.06948808499993, -49.1657854149999],
              [-75.06407630099994, -49.16521575299993],
              [-75.05772864499994, -49.16545989399992],
              [-75.08975175699993, -49.15837981599992],
              [-75.20173092399995, -49.17229583099993],
              [-75.20173092399995, -49.16545989399992],
              [-75.16698157499991, -49.14495208099993],
              [-75.13052324099993, -49.13681405999995],
              [-75.11978105399993, -49.13128020599993],
              [-75.15762285099993, -49.12859465899993],
              [-75.20392818899995, -49.140883070999905],
              [-75.23558508999992, -49.14495208099993],
              [-75.22964433499993, -49.1169572899999],
              [-75.22032630099994, -49.106133721999925],
              [-75.15843665299991, -49.051039320999905],
              [-75.13931230399993, -49.04631926899992],
              [-75.09870357999995, -49.048760674999926],
              [-75.10802161399994, -49.04412200299993],
              [-75.11579342399995, -49.038181247999944],
              [-75.12181555899991, -49.03069426899992],
              [-75.12604732999995, -49.021416924999926],
              [-75.11245683499993, -49.024102471999925],
              [-75.09544837099992, -49.02988046699994],
              [-75.07921301999994, -49.03753020599993],
              [-75.05337480399993, -49.05478280999995],
              [-75.01475989499994, -49.070570570999905],
              [-74.99974524599992, -49.07976653399993],
              [-74.99006100199995, -49.07659270599993],
              [-74.98330644399994, -49.03093840899993],
              [-74.97203528599994, -49.03167083099993],
              [-74.91681881399995, -49.07048919099992],
              [-74.90318762899994, -49.07675546699994],
            ],
          ],
          [
            [
              [-75.55797278599994, -49.24732838299991],
              [-75.56798255099994, -49.244398695999905],
              [-75.58804277299993, -49.242120049999926],
              [-75.63508053299995, -49.22893645599993],
              [-75.65147864499994, -49.21949635199991],
              [-75.66104081899994, -49.205743096999925],
              [-75.64981035099993, -49.2048479149999],
              [-75.63902747299994, -49.20525481599992],
              [-75.62901770699995, -49.207696221999925],
              [-75.62010657499991, -49.21257903399993],
              [-75.63011633999992, -49.18474700299993],
              [-75.60732988199993, -49.151055596999925],
              [-75.56871497299994, -49.12273528399993],
              [-75.53066972599993, -49.11077239399992],
              [-75.55113684799994, -49.14495208099993],
              [-75.53555253799993, -49.138929945999905],
              [-75.50499426999994, -49.1325822899999],
              [-75.49657141799992, -49.12444426899992],
              [-75.50511633999992, -49.12810637799993],
              [-75.51024329299992, -49.128838799999926],
              [-75.52383378799993, -49.12444426899992],
              [-75.48375403599994, -49.100274346999925],
              [-75.46324622299994, -49.09099700299993],
              [-75.44810950399994, -49.09644947699991],
              [-75.44115149599992, -49.08521900799991],
              [-75.42235266799992, -49.07187265399995],
              [-75.41397050699993, -49.062432549999926],
              [-75.43390865799995, -49.06064218499995],
              [-75.44298255099994, -49.05559661299992],
              [-75.44102942599994, -49.04534270599993],
              [-75.42764238199993, -49.02825286299992],
              [-75.40697180899991, -49.007745049999926],
              [-75.39427649599992, -48.99814218499995],
              [-75.35130774599992, -48.98552825299993],
              [-75.33726966099994, -48.989353122999944],
              [-75.33141028599994, -49.01091887799993],
              [-75.3379613919999, -49.02353280999995],
              [-75.3665258449999, -49.0407854149999],
              [-75.37303626199991, -49.05624765399995],
              [-75.34854081899994, -49.04810963299991],
              [-75.33788001199991, -49.04656340899993],
              [-75.32526607999995, -49.048760674999926],
              [-75.31297766799992, -49.055352471999925],
              [-75.30345618399991, -49.065118096999925],
              [-75.28742428299995, -49.086602471999925],
              [-75.29320227799991, -49.10670338299991],
              [-75.31590735599991, -49.133477471999925],
              [-75.33893795499995, -49.146416924999926],
              [-75.3457738919999, -49.12444426899992],
              [-75.38931230399993, -49.17913176899992],
              [-75.40379798099991, -49.186618747999944],
              [-75.42052161399994, -49.18132903399993],
              [-75.42174231699994, -49.167901299999926],
              [-75.41315670499995, -49.15007903399993],
              [-75.40038001199991, -49.13128020599993],
              [-75.41519120999993, -49.13494231599992],
              [-75.42198645699995, -49.14527760199991],
              [-75.42638098899994, -49.158868096999925],
              [-75.43390865799995, -49.17229583099993],
              [-75.44005286399994, -49.175713799999926],
              [-75.4544164699999, -49.176039320999905],
              [-75.46182206899994, -49.17913176899992],
              [-75.46861731699994, -49.205743096999925],
              [-75.47166907499991, -49.208916924999926],
              [-75.47492428299995, -49.21013762799993],
              [-75.47850501199991, -49.212823174999926],
              [-75.48224850199995, -49.21998463299991],
              [-75.48200436099995, -49.22429778399993],
              [-75.47911536399994, -49.22795989399992],
              [-75.47622636599993, -49.23259856599992],
              [-75.47606360599991, -49.23992278399993],
              [-75.48265540299991, -49.25408294099992],
              [-75.49376380099994, -49.2634416649999],
              [-75.50804602799991, -49.26799895599993],
              [-75.52383378799993, -49.267836195999905],
              [-75.53331458199995, -49.263929945999905],
              [-75.54898027299993, -49.25237395599993],
              [-75.55797278599994, -49.24732838299991],
            ],
          ],
          [
            [
              [-75.21540279899995, -49.01458098799992],
              [-75.20759029899995, -49.03460051899992],
              [-75.21320553299995, -49.052666924999926],
              [-75.22813880099994, -49.06609465899993],
              [-75.24864661399994, -49.0720354149999],
              [-75.27603105399993, -49.06324635199991],
              [-75.29214433499993, -49.03915780999995],
              [-75.31505286399994, -48.965508721999925],
              [-75.31387285099993, -48.957289320999905],
              [-75.31651770699995, -48.95370859199994],
              [-75.33141028599994, -48.95256926899992],
              [-75.35171464799993, -48.965101820999905],
              [-75.36392167899993, -48.966729424999926],
              [-75.37303626199991, -48.95256926899992],
              [-75.37531490799995, -48.96363697699991],
              [-75.37987219999991, -48.96803150799991],
              [-75.38634192599994, -48.969821872999944],
              [-75.39415442599994, -48.97307708099993],
              [-75.39976966099994, -48.9743791649999],
              [-75.41193600199995, -48.973728122999944],
              [-75.41771399599992, -48.97673919099992],
              [-75.42080644399994, -48.98105234199994],
              [-75.42577063699991, -48.99114348799992],
              [-75.42764238199993, -48.994073174999926],
              [-75.46507727799991, -49.03639088299991],
              [-75.47915605399993, -49.04192473799992],
              [-75.4993383449999, -49.03915780999995],
              [-75.52061926999994, -49.03142669099992],
              [-75.5332738919999, -49.019463799999926],
              [-75.52725175699993, -49.00408294099992],
              [-75.50991777299993, -48.99179452899995],
              [-75.49323482999995, -48.98259856599992],
              [-75.47883053299995, -48.97112395599993],
              [-75.46861731699994, -48.95256926899992],
              [-75.48680579299992, -48.95208098799992],
              [-75.50527910099993, -48.96306731599992],
              [-75.52424068899995, -48.97730885199991],
              [-75.54377193899995, -48.986586195999905],
              [-75.56956946499992, -48.98951588299991],
              [-75.59740149599992, -48.98772551899992],
              [-75.62437903599994, -48.980401299999926],
              [-75.64736894399994, -48.96689218499995],
              [-75.65664628799993, -48.95191822699991],
              [-75.65855872299994, -48.932305596999925],
              [-75.65485592399995, -48.91106536299992],
              [-75.64736894399994, -48.89120859199994],
              [-75.63365637899994, -48.87232838299991],
              [-75.61473548099991, -48.85865650799991],
              [-75.59658769399994, -48.85800546699994],
              [-75.58531653599994, -48.87737395599993],
              [-75.57843990799995, -48.86077239399992],
              [-75.56818600199995, -48.85247161299992],
              [-75.55455481699994, -48.85312265399995],
              [-75.53750566299993, -48.863213799999926],
              [-75.54067949099993, -48.83367278399993],
              [-75.52318274599992, -48.83538176899992],
              [-75.49559485599991, -48.84587981599992],
              [-75.46861731699994, -48.84270598799992],
              [-75.47960364499994, -48.85711028399993],
              [-75.52098548099991, -48.89706796699994],
              [-75.52725175699993, -48.908135674999926],
              [-75.5110570949999, -48.90862395599993],
              [-75.48672441299993, -48.89771900799991],
              [-75.46458899599992, -48.88355885199991],
              [-75.45494544199994, -48.874118747999944],
              [-75.44591223899994, -48.86223723799992],
              [-75.42564856699994, -48.842868747999944],
              [-75.40489661399994, -48.82773202899995],
              [-75.39415442599994, -48.82903411299992],
              [-75.39728756399995, -48.83847421699994],
              [-75.4063207669999, -48.84970468499995],
              [-75.41681881399995, -48.8591447899999],
              [-75.42454993399991, -48.863213799999926],
              [-75.42650305899991, -48.86842213299991],
              [-75.42682857999995, -48.87835051899992],
              [-75.42162024599992, -48.88420989399992],
              [-75.40713456899994, -48.87737395599993],
              [-75.40135657499991, -48.89275481599992],
              [-75.39240475199995, -48.90667083099993],
              [-75.3789770169999, -48.91611093499995],
              [-75.35936438699991, -48.91838958099993],
              [-75.38329016799992, -48.879571221999925],
              [-75.38670813699991, -48.86687590899993],
              [-75.37926184799994, -48.852227471999925],
              [-75.36196855399993, -48.850274346999925],
              [-75.32835852799991, -48.85702890399995],
              [-75.3059789699999, -48.86492278399993],
              [-75.28490149599992, -48.88420989399992],
              [-75.26927649599992, -48.90789153399993],
              [-75.26065019399994, -48.93962981599992],
              [-75.24022376199991, -48.98691171699994],
              [-75.23810787699995, -48.99667734199994],
              [-75.23591061099995, -49.00090911299992],
              [-75.23058020699995, -49.00603606599992],
              [-75.21955318899995, -49.01140715899993],
              [-75.21540279899995, -49.01458098799992],
            ],
          ],
          [
            [
              [-75.10582434799994, -48.96990325299993],
              [-75.13597571499992, -48.97079843499995],
              [-75.16515051999994, -48.98601653399993],
              [-75.19399980399993, -48.99570077899995],
              [-75.22301184799994, -48.97893645599993],
              [-75.23648027299993, -48.95598723799992],
              [-75.24714107999995, -48.92457447699991],
              [-75.24893144399994, -48.89332447699991],
              [-75.23591061099995, -48.87070077899995],
              [-75.25304114499994, -48.86874765399995],
              [-75.26813717399995, -48.86248137799993],
              [-75.28075110599991, -48.85320403399993],
              [-75.29043535099993, -48.84270598799992],
              [-75.30386308499993, -48.8161760399999],
              [-75.30907141799992, -48.801446221999925],
              [-75.30817623599995, -48.794854424999926],
              [-75.27489173099991, -48.79705169099992],
              [-75.21060136599993, -48.81178150799991],
              [-75.12083899599992, -48.84978606599992],
              [-75.09142005099994, -48.87070077899995],
              [-75.07876542899993, -48.89462655999995],
              [-75.08238684799994, -48.90447356599992],
              [-75.09072831899994, -48.91448333099993],
              [-75.1009008449999, -48.92229583099993],
              [-75.10952714799993, -48.92522551899992],
              [-75.12621008999992, -48.91952890399995],
              [-75.13556881399995, -48.91765715899993],
              [-75.13963782499991, -48.921807549999926],
              [-75.13707434799994, -48.92929452899995],
              [-75.13048255099994, -48.934258721999925],
              [-75.12181555899991, -48.9372697899999],
              [-75.11294511599993, -48.93889739399992],
              [-75.07868404899995, -48.92937590899993],
              [-75.06444251199991, -48.948337497999944],
              [-75.07282467399995, -48.97031015399995],
              [-75.10582434799994, -48.96990325299993],
            ],
          ],
          [
            [
              [-75.19831295499995, -49.77117278399993],
              [-75.20669511599993, -49.760430596999925],
              [-75.20929928299995, -49.753024997999944],
              [-75.2051488919999, -49.71607838299991],
              [-75.20693925699993, -49.70842864399992],
              [-75.21540279899995, -49.69931405999995],
              [-75.2278539699999, -49.692478122999944],
              [-75.25210527299993, -49.68694426899992],
              [-75.26317298099991, -49.67937590899993],
              [-75.2598363919999, -49.67343515399995],
              [-75.25304114499994, -49.65789153399993],
              [-75.24950110599991, -49.65203215899993],
              [-75.28384355399993, -49.64031340899993],
              [-75.29393469999991, -49.63836028399993],
              [-75.29723059799994, -49.63298919099992],
              [-75.2981664699999, -49.621026299999926],
              [-75.29527747299994, -49.60906340899993],
              [-75.28742428299995, -49.60369231599992],
              [-75.26618404899995, -49.5993791649999],
              [-75.25275631399995, -49.588555596999925],
              [-75.23591061099995, -49.55584075299993],
              [-75.25413977799991, -49.563164971999925],
              [-75.28075110599991, -49.564711195999905],
              [-75.30540930899991, -49.56015390399995],
              [-75.31777910099993, -49.54900481599992],
              [-75.31021074099993, -49.53785572699991],
              [-75.26935787699995, -49.5095354149999],
              [-75.25633704299992, -49.49382903399993],
              [-75.27208411399994, -49.49928150799991],
              [-75.32192949099993, -49.51116301899992],
              [-75.33519446499992, -49.51116301899992],
              [-75.34878495999993, -49.496351820999905],
              [-75.34683183499993, -49.487399997999944],
              [-75.33657792899993, -49.47730885199991],
              [-75.32526607999995, -49.459649346999925],
              [-75.35065670499995, -49.45956796699994],
              [-75.36204993399991, -49.46135833099993],
              [-75.37303626199991, -49.46648528399993],
              [-75.37547766799992, -49.4568010399999],
              [-75.37214107999995, -49.4489885399999],
              [-75.35936438699991, -49.432305596999925],
              [-75.38304602799991, -49.43474700299993],
              [-75.40667211899995, -49.42728022999995],
              [-75.42320033399994, -49.41105833799992],
              [-75.43254090499994, -49.38487870799992],
              [-75.44076559299992, -49.36944941399992],
              [-75.45494544199994, -49.34978606599992],
              [-75.45791581899994, -49.34254322699991],
              [-75.46288001199991, -49.33806731599992],
              [-75.46727454299992, -49.332696221999925],
              [-75.46861731699994, -49.32244231599992],
              [-75.46198482999995, -49.306573174999926],
              [-75.44688880099994, -49.29119231599992],
              [-75.42723548099991, -49.27947356599992],
              [-75.40713456899994, -49.27467213299991],
              [-75.38329016799992, -49.28045012799993],
              [-75.36896725199995, -49.29501718499995],
              [-75.3574926419999, -49.31406015399995],
              [-75.33088131399995, -49.34693775799991],
              [-75.28868567599994, -49.41611093499995],
              [-75.20531165299991, -49.47909921699994],
              [-75.16698157499991, -49.50115325299993],
              [-75.17560787699995, -49.48495859199994],
              [-75.19245357999995, -49.46697356599992],
              [-75.20156816299993, -49.45061614399992],
              [-75.18740800699993, -49.43914153399993],
              [-75.22093665299991, -49.426039320999905],
              [-75.25967363199993, -49.401462497999944],
              [-75.28831946499992, -49.37078215899993],
              [-75.29173743399991, -49.340101820999905],
              [-75.30736243399991, -49.32968515399995],
              [-75.32054602799991, -49.31536223799992],
              [-75.32583574099993, -49.298760674999926],
              [-75.31777910099993, -49.28142669099992],
              [-75.32335364499994, -49.263604424999926],
              [-75.30606035099993, -49.254571221999925],
              [-75.28026282499991, -49.25465260199991],
              [-75.25975501199991, -49.26409270599993],
              [-75.18517005099994, -49.34726327899995],
              [-75.17715410099993, -49.360446872999944],
              [-75.17072506399995, -49.367120049999926],
              [-75.15221106699994, -49.37769947699991],
              [-75.13390051999994, -49.37965260199991],
              [-75.09243730399993, -49.37029387799993],
              [-75.10887610599991, -49.363946221999925],
              [-75.14561926999994, -49.358493747999944],
              [-75.16075598899994, -49.34978606599992],
              [-75.16836503799993, -49.33798593499995],
              [-75.18740800699993, -49.295179945999905],
              [-75.18740800699993, -49.28826262799993],
              [-75.15998287699995, -49.29412200299993],
              [-75.11115475199995, -49.319431247999944],
              [-75.09870357999995, -49.30877044099992],
              [-75.10301673099991, -49.29941171699994],
              [-75.1113988919999, -49.28557708099993],
              [-75.11253821499992, -49.2732072899999],
              [-75.09557044199994, -49.267836195999905],
              [-75.06651770699995, -49.26848723799992],
              [-75.04995683499993, -49.26637135199991],
              [-75.03722083199995, -49.260430596999925],
              [-75.05492102799991, -49.24944426899992],
              [-75.07262122299994, -49.23455169099992],
              [-75.08641516799992, -49.21721770599993],
              [-75.09243730399993, -49.19963958099993],
              [-75.06688391799992, -49.20973072699991],
              [-75.00308183499993, -49.267836195999905],
              [-74.95299231699994, -49.29656340899993],
              [-74.93016516799992, -49.3142229149999],
              [-74.92052161399994, -49.333103122999944],
              [-74.91930091099994, -49.3454729149999],
              [-74.91486568899995, -49.359633070999905],
              [-74.90648352799991, -49.36834075299993],
              [-74.89321855399993, -49.36402760199991],
              [-74.88638261599993, -49.31218840899993],
              [-74.88508053299995, -49.254571221999925],
              [-74.87319902299993, -49.23284270599993],
              [-74.84483801999994, -49.23992278399993],
              [-74.86876380099994, -49.22535572699991],
              [-74.87621008999992, -49.21624114399992],
              [-74.8789770169999, -49.20273202899995],
              [-74.87588456899994, -49.1911760399999],
              [-74.86799068899995, -49.18368905999995],
              [-74.85700436099995, -49.179620049999926],
              [-74.84483801999994, -49.17913176899992],
              [-74.84483801999994, -49.17229583099993],
              [-74.85728919199994, -49.16285572699991],
              [-74.85643469999991, -49.15178801899992],
              [-74.84813391799992, -49.140557549999926],
              [-74.83800208199995, -49.13128020599993],
              [-74.84552975199995, -49.12704843499995],
              [-74.85049394399994, -49.122165622999944],
              [-74.85912024599992, -49.11077239399992],
              [-74.84634355399993, -49.10621510199991],
              [-74.83307857999995, -49.10442473799992],
              [-74.80451412699995, -49.10393645599993],
              [-74.95470130099994, -49.00709400799991],
              [-74.93687903599994, -48.99863046699994],
              [-74.85692298099991, -48.976495049999926],
              [-74.84496008999992, -48.97966887799993],
              [-74.81818600199995, -49.00709400799991],
              [-74.81871497299994, -48.9743791649999],
              [-74.82363847599993, -48.95037200299993],
              [-74.83755449099993, -48.93954843499995],
              [-74.86534583199995, -48.946384372999944],
              [-74.91323808499993, -48.97340260199991],
              [-74.94172115799995, -48.98512135199991],
              [-74.96898352799991, -48.986586195999905],
              [-74.96422278599994, -48.976820570999905],
              [-74.96153723899994, -48.97307708099993],
              [-74.98631751199991, -48.96738046699994],
              [-74.98326575399994, -48.9528947899999],
              [-74.95470130099994, -48.91838958099993],
              [-74.98753821499992, -48.92009856599992],
              [-75.00381425699993, -48.918226820999905],
              [-75.01618404899995, -48.91155364399992],
              [-75.02098548099991, -48.90048593499995],
              [-75.01520748599995, -48.89177825299993],
              [-75.00230872299994, -48.88632577899995],
              [-74.98570716099994, -48.88420989399992],
              [-74.97227942599994, -48.88103606599992],
              [-74.94424394399994, -48.86638762799993],
              [-74.88377844999991, -48.848321221999925],
              [-74.87279212099992, -48.84270598799992],
              [-74.91612708199995, -48.84514739399992],
              [-74.96450761599993, -48.86223723799992],
              [-75.01183020699995, -48.87322356599992],
              [-75.05150305899991, -48.85702890399995],
              [-75.06110592399995, -48.837009372999944],
              [-75.05797278599994, -48.816664320999905],
              [-75.04548092399995, -48.80120208099993],
              [-75.0266820949999, -48.794854424999926],
              [-74.99860592399995, -48.80632903399993],
              [-74.97520911399994, -48.81064218499995],
              [-74.96251380099994, -48.81585051899992],
              [-74.95042883999992, -48.82244231599992],
              [-74.94163977799991, -48.82903411299992],
              [-74.94469153599994, -48.82187265399995],
              [-74.94823157499991, -48.81853606599992],
              [-74.95262610599991, -48.81609465899993],
              [-74.95811926999994, -48.81194426899992],
              [-74.97203528599994, -48.789727471999925],
              [-74.97085527299993, -48.78533294099992],
              [-74.9719945949999, -48.782321872999944],
              [-74.99718176999994, -48.78069426899992],
              [-75.00316321499992, -48.77874114399992],
              [-75.00991777299993, -48.77434661299992],
              [-74.98501542899993, -48.75904713299991],
              [-74.87783769399994, -48.719414971999925],
              [-74.86750240799995, -48.71233489399992],
              [-74.84854081899994, -48.695570570999905],
              [-74.83031165299991, -48.68954843499995],
              [-74.82005774599992, -48.70232512799993],
              [-74.80785071499992, -48.73650481599992],
              [-74.79478919199994, -48.74724700299993],
              [-74.79308020699995, -48.74032968499995],
              [-74.79600989499994, -48.725681247999944],
              [-74.79702714799993, -48.71298593499995],
              [-74.79173743399991, -48.69882577899995],
              [-74.78331458199995, -48.687758070999905],
              [-74.7715551419999, -48.680759372999944],
              [-74.75633704299992, -48.67815520599993],
              [-74.69664466099994, -48.67986419099992],
              [-74.6809789699999, -48.68499114399992],
              [-74.66779537699995, -48.696384372999944],
              [-74.66104081899994, -48.70956796699994],
              [-74.66429602799991, -48.72087981599992],
              [-74.6809789699999, -48.72665780999995],
              [-74.66486568899995, -48.730401299999926],
              [-74.63516191299993, -48.719008070999905],
              [-74.62267005099994, -48.72283294099992],
              [-74.61880449099993, -48.7341447899999],
              [-74.62555904899995, -48.74553801899992],
              [-74.63512122299994, -48.7575822899999],
              [-74.64000403599994, -48.77092864399992],
              [-74.63756262899994, -48.78248463299991],
              [-74.62755286399994, -48.80722421699994],
              [-74.62633216099994, -48.81536223799992],
              [-74.63467363199993, -48.82756926899992],
              [-74.65929114499994, -48.84303150799991],
              [-74.66734778599994, -48.85702890399995],
              [-74.65119381399995, -48.85751718499995],
              [-74.6348363919999, -48.8552385399999],
              [-74.62092037699995, -48.85035572699991],
              [-74.61213131399995, -48.84270598799992],
              [-74.60997473899994, -48.83261484199994],
              [-74.60928300699993, -48.81487395599993],
              [-74.61082923099991, -48.79656340899993],
              [-74.61546790299991, -48.78476327899995],
              [-74.61632239499994, -48.76336028399993],
              [-74.59764563699991, -48.73560963299991],
              [-74.56993567599994, -48.71257903399993],
              [-74.54381262899994, -48.706149997999944],
              [-74.52550208199995, -48.72283294099992],
              [-74.52261308499993, -48.75237395599993],
              [-74.53014075399994, -48.81194426899992],
              [-74.53014075399994, -48.86687590899993],
              [-74.53791256399995, -48.88176848799992],
              [-74.55313066299993, -48.890883070999905],
              [-74.56387285099993, -48.90097421699994],
              [-74.55809485599991, -48.91838958099993],
              [-74.52867591099994, -48.90593840899993],
              [-74.50584876199991, -48.90569426899992],
              [-74.48851477799991, -48.91887786299992],
              [-74.47549394399994, -48.946384372999944],
              [-74.47411048099991, -48.9743791649999],
              [-74.48656165299991, -48.99627044099992],
              [-74.50706946499992, -49.013604424999926],
              [-74.53014075399994, -49.02825286299992],
              [-74.50706946499992, -49.03948333099993],
              [-74.49461829299992, -49.057712497999944],
              [-74.48534094999991, -49.07927825299993],
              [-74.46178137899994, -49.11931731599992],
              [-74.47345943899995, -49.1482072899999],
              [-74.46865800699993, -49.17229583099993],
              [-74.46353105399993, -49.18010833099993],
              [-74.45250403599994, -49.19182708099993],
              [-74.44815019399994, -49.19963958099993],
              [-74.44481360599991, -49.21306731599992],
              [-74.44522050699993, -49.22275155999995],
              [-74.44709225199995, -49.23186614399992],
              [-74.44815019399994, -49.24374765399995],
              [-74.44579016799992, -49.30234140399995],
              [-74.44815019399994, -49.32244231599992],
              [-74.46654212099992, -49.37981536299992],
              [-74.47085527299993, -49.42327239399992],
              [-74.47679602799991, -49.44264088299991],
              [-74.48534094999991, -49.45956796699994],
              [-74.4954320949999, -49.47389088299991],
              [-74.50479081899994, -49.482679945999905],
              [-74.52920488199993, -49.50074635199991],
              [-74.53636633999992, -49.50798919099992],
              [-74.53941809799994, -49.5193010399999],
              [-74.53433183499993, -49.52385833099993],
              [-74.52700761599993, -49.52825286299992],
              [-74.52013098899994, -49.54892343499995],
              [-74.50601152299993, -49.56373463299991],
              [-74.50283769399994, -49.572930596999925],
              [-74.50365149599992, -49.58749765399995],
              [-74.50674394399994, -49.59343840899993],
              [-74.5313207669999, -49.60898202899995],
              [-74.54686438699991, -49.61598072699991],
              [-74.55435136599993, -49.621026299999926],
              [-74.55846106699994, -49.62908294099992],
              [-74.55646725199995, -49.64918385199991],
              [-74.55809485599991, -49.65829843499995],
              [-74.57030188699991, -49.66814544099992],
              [-74.58885657499991, -49.67913176899992],
              [-74.60383053299995, -49.69353606599992],
              [-74.60521399599992, -49.713555596999925],
              [-74.59325110599991, -49.72421640399995],
              [-74.5774633449999, -49.71559010199991],
              [-74.56187903599994, -49.69939544099992],
              [-74.53856360599991, -49.66871510199991],
              [-74.53477942599994, -49.64185963299991],
              [-74.52672278599994, -49.62786223799992],
              [-74.50829016799992, -49.62029387799993],
              [-74.48395748599995, -49.62314218499995],
              [-74.46043860599991, -49.63176848799992],
              [-74.44448808499993, -49.64177825299993],
              [-74.43008378799993, -49.65789153399993],
              [-74.42300370999993, -49.67310963299991],
              [-74.42052161399994, -49.68962981599992],
              [-74.42031816299993, -49.7341447899999],
              [-74.42365475199995, -49.74488697699991],
              [-74.43468176999994, -49.74732838299991],
              [-74.45815995999993, -49.74700286299992],
              [-74.46857662699995, -49.74504973799992],
              [-74.48326575399994, -49.73642343499995],
              [-74.4954320949999, -49.73398202899995],
              [-74.50641842399995, -49.735039971999925],
              [-74.51671301999994, -49.7380510399999],
              [-74.53636633999992, -49.74700286299992],
              [-74.51349850199995, -49.7575822899999],
              [-74.45433508999992, -49.77263762799993],
              [-74.43455969999991, -49.78866952899995],
              [-74.43195553299995, -49.80982838299991],
              [-74.43610592399995, -49.84124114399992],
              [-74.44448808499993, -49.87037525799991],
              [-74.4544164699999, -49.88486093499995],
              [-74.46035722599993, -49.86150481599992],
              [-74.46548417899993, -49.8513322899999],
              [-74.47549394399994, -49.84319426899992],
              [-74.47667395699995, -49.86386484199994],
              [-74.48940995999993, -49.869398695999905],
              [-74.50719153599994, -49.86532968499995],
              [-74.52330481699994, -49.85686614399992],
              [-74.52489173099991, -49.87070077899995],
              [-74.51618404899995, -49.88420989399992],
              [-74.50157630099994, -49.894463799999926],
              [-74.48546301999994, -49.89853280999995],
              [-74.47105872299994, -49.90699635199991],
              [-74.46841386599993, -49.92587655999995],
              [-74.47423255099994, -49.94451262799993],
              [-74.48546301999994, -49.953057549999926],
              [-74.50348873599995, -49.95549895599993],
              [-74.51732337099992, -49.95973072699991],
              [-74.53148352799991, -49.96054452899995],
              [-74.55064856699994, -49.953057549999926],
              [-74.59593665299991, -49.9196916649999],
              [-74.61213131399995, -49.91155364399992],
              [-74.54767818899995, -49.97323984199994],
              [-74.53636633999992, -49.99472421699994],
              [-74.56322180899991, -50.004164320999905],
              [-74.62633216099994, -50.04241301899992],
              [-74.64126542899993, -50.04705169099992],
              [-74.66063391799992, -50.0505510399999],
              [-74.67992102799991, -50.05022551899992],
              [-74.6946508449999, -50.04241301899992],
              [-74.70067298099991, -50.02849700299993],
              [-74.69391842399995, -50.01832447699991],
              [-74.68219967399995, -50.00823333099993],
              [-74.67349199099993, -49.99472421699994],
              [-74.68732662699995, -49.99879322699991],
              [-74.72720292899993, -50.01653411299992],
              [-74.73558508999992, -50.02507903399993],
              [-74.74054928299995, -50.040948174999926],
              [-74.75279700399994, -50.05038827899995],
              [-74.76842200399994, -50.05331796699994],
              [-74.78335527299993, -50.04924895599993],
              [-74.80426998599995, -50.03948333099993],
              [-74.81627356699994, -50.02402109199994],
              [-74.81712805899991, -50.00554778399993],
              [-74.80451412699995, -49.98723723799992],
              [-74.82144120999993, -49.989353122999944],
              [-74.83336341099994, -49.997979424999926],
              [-74.83771725199995, -50.0114885399999],
              [-74.83185787699995, -50.02890390399995],
              [-74.86774654899995, -50.01620859199994],
              [-74.85627193899995, -49.991306247999944],
              [-74.8223363919999, -49.964776299999926],
              [-74.73965410099993, -49.921807549999926],
              [-74.72191321499992, -49.919040622999944],
              [-74.70714270699995, -49.9235979149999],
              [-74.6778051419999, -49.94451262799993],
              [-74.66047115799995, -49.953057549999926],
              [-74.68053137899994, -49.928399346999925],
              [-74.70490475199995, -49.90862395599993],
              [-74.73460852799991, -49.899102471999925],
              [-74.77033443899995, -49.905368747999944],
              [-74.83897864499994, -49.94264088299991],
              [-74.88121497299994, -49.958916924999926],
              [-74.90005449099993, -49.950290622999944],
              [-74.90200761599993, -49.94646575299993],
              [-74.91100012899994, -49.93328215899993],
              [-74.91368567599994, -49.92587655999995],
              [-74.9134008449999, -49.91676197699991],
              [-74.90770423099991, -49.90325286299992],
              [-74.90221106699994, -49.876885674999926],
              [-74.89122473899994, -49.867852471999925],
              [-74.8750707669999, -49.86467864399992],
              [-74.85570227799991, -49.864353122999944],
              [-74.83975175699993, -49.867852471999925],
              [-74.82087154899995, -49.87444426899992],
              [-74.80223548099991, -49.87851327899995],
              [-74.7871801419999, -49.87428150799991],
              [-74.77183997299994, -49.86451588299991],
              [-74.74229895699995, -49.85247161299992],
              [-74.72874915299991, -49.84319426899992],
              [-74.79181881399995, -49.85198333099993],
              [-74.82266191299993, -49.85116952899995],
              [-74.83800208199995, -49.83635833099993],
              [-74.83446204299992, -49.826104424999926],
              [-74.82506262899994, -49.81259530999995],
              [-74.81456458199995, -49.8005510399999],
              [-74.80785071499992, -49.79550546699994],
              [-74.79588782499991, -49.79111093499995],
              [-74.78111731699994, -49.78142669099992],
              [-74.77122962099992, -49.77190520599993],
              [-74.77375240799995, -49.767510674999926],
              [-74.80695553299995, -49.76441822699991],
              [-74.81818600199995, -49.767510674999926],
              [-74.8469945949999, -49.7946916649999],
              [-74.85582434799994, -49.80136484199994],
              [-74.86388098899994, -49.80282968499995],
              [-74.87287350199995, -49.80291106599992],
              [-74.8789770169999, -49.80169036299992],
              [-74.88255774599992, -49.79697030999995],
              [-74.8899633449999, -49.760837497999944],
              [-74.89000403599994, -49.74944426899992],
              [-74.88292395699995, -49.74236419099992],
              [-74.86534583199995, -49.74146900799991],
              [-74.86534583199995, -49.73398202899995],
              [-74.88149980399993, -49.72714609199994],
              [-74.90151933499993, -49.71168385199991],
              [-74.9173070949999, -49.69394296699994],
              [-74.92052161399994, -49.67937590899993],
              [-74.90615800699993, -49.67156340899993],
              [-74.88560950399994, -49.6775041649999],
              [-74.86351477799991, -49.68808359199994],
              [-74.84483801999994, -49.693617445999905],
              [-74.84483801999994, -49.686211846999925],
              [-74.88267981699994, -49.66057708099993],
              [-74.89769446499992, -49.645603122999944],
              [-74.89321855399993, -49.63160572699991],
              [-74.89195716099994, -49.61443450299993],
              [-74.86685136599993, -49.61484140399995],
              [-74.78502356699994, -49.641696872999944],
              [-74.77009029899995, -49.64470794099992],
              [-74.75951087099992, -49.64177825299993],
              [-74.74852454299992, -49.63551197699991],
              [-74.73424231699994, -49.63298919099992],
              [-74.71971594999991, -49.63404713299991],
              [-74.7083227199999, -49.63836028399993],
              [-74.71837317599994, -49.625258070999905],
              [-74.7337133449999, -49.62428150799991],
              [-74.75084387899994, -49.626071872999944],
              [-74.76659094999991, -49.621026299999926],
              [-74.77041581899994, -49.61191171699994],
              [-74.75841223899994, -49.58993905999995],
              [-74.75601152299993, -49.57634856599992],
              [-74.76968339799993, -49.58456796699994],
              [-74.77847245999993, -49.5935197899999],
              [-74.78905188699991, -49.600681247999944],
              [-74.80785071499992, -49.60369231599992],
              [-74.82795162699995, -49.60230885199991],
              [-74.84679114499994, -49.59775155999995],
              [-74.86400305899991, -49.58945077899995],
              [-74.8789770169999, -49.57634856599992],
              [-74.88613847599993, -49.56462981599992],
              [-74.89073645699995, -49.5485979149999],
              [-74.88695227799991, -49.53460051899992],
              [-74.86900794199994, -49.52849700299993],
              [-74.86314856699994, -49.52353280999995],
              [-74.80785071499992, -49.49749114399992],
              [-74.79185950399994, -49.481540622999944],
              [-74.78294837099992, -49.47869231599992],
              [-74.74917558499993, -49.51531340899993],
              [-74.74331620999993, -49.51873137799993],
              [-74.74209550699993, -49.51067473799992],
              [-74.74242102799991, -49.49065520599993],
              [-74.74665279899995, -49.47470468499995],
              [-74.75308183499993, -49.465508721999925],
              [-74.75255286399994, -49.457696221999925],
              [-74.73558508999992, -49.445977471999925],
              [-74.71739661399994, -49.44068775799991],
              [-74.67808997299994, -49.43873463299991],
              [-74.66047115799995, -49.432305596999925],
              [-74.67951412699995, -49.42693450299993],
              [-74.69737708199995, -49.42831796699994],
              [-74.71564693899995, -49.431573174999926],
              [-74.73558508999992, -49.432305596999925],
              [-74.71617591099994, -49.410414320999905],
              [-74.66270911399994, -49.37590911299992],
              [-74.64622962099992, -49.34978606599992],
              [-74.67088782499991, -49.35588958099993],
              [-74.72874915299991, -49.391289971999925],
              [-74.73892167899993, -49.39592864399992],
              [-74.74697831899994, -49.39804452899995],
              [-74.77375240799995, -49.39812590899993],
              [-74.78380286399994, -49.39527760199991],
              [-74.79971269399994, -49.38201262799993],
              [-74.81126868399991, -49.37769947699991],
              [-74.80386308499993, -49.391696872999944],
              [-74.78880774599992, -49.404961846999925],
              [-74.77037512899994, -49.41480885199991],
              [-74.75291907499991, -49.418633721999925],
              [-74.74889075399994, -49.424899997999944],
              [-74.76455644399994, -49.438164971999925],
              [-74.79393469999991, -49.45663827899995],
              [-74.81737219999991, -49.47625090899993],
              [-74.8516332669999, -49.49814218499995],
              [-74.88023841099994, -49.50359465899993],
              [-74.88638261599993, -49.47389088299991],
              [-74.90005449099993, -49.48845794099992],
              [-74.90998287699995, -49.5114885399999],
              [-74.92259680899991, -49.53281015399995],
              [-74.94473222599993, -49.54216887799993],
              [-74.96426347599993, -49.531508070999905],
              [-74.96324622299994, -49.484633070999905],
              [-74.97887122299994, -49.47389088299991],
              [-74.98770097599993, -49.47926197699991],
              [-74.98888098899994, -49.49098072699991],
              [-74.98851477799991, -49.50269947699991],
              [-74.99254309799994, -49.50798919099992],
              [-75.00438391799992, -49.51091887799993],
              [-75.00951087099992, -49.518649997999944],
              [-75.01060950399994, -49.52947356599992],
              [-75.00991777299993, -49.54216887799993],
              [-75.00279700399994, -49.58017343499995],
              [-75.01195227799991, -49.58993905999995],
              [-75.04405676999994, -49.59002044099992],
              [-75.03701738199993, -49.59880950299993],
              [-75.01683508999992, -49.61077239399992],
              [-75.00991777299993, -49.617852471999925],
              [-75.00674394399994, -49.63005950299993],
              [-75.00934811099995, -49.63925546699994],
              [-75.01378333199995, -49.64885833099993],
              [-75.01618404899995, -49.662041924999926],
              [-75.01097571499992, -49.676039320999905],
              [-74.99815833199995, -49.66350676899992],
              [-74.98159745999993, -49.64267343499995],
              [-74.96524003799993, -49.63160572699991],
              [-74.95287024599992, -49.640883070999905],
              [-74.95864824099993, -49.66220468499995],
              [-74.97203528599994, -49.68499114399992],
              [-74.98265540299991, -49.69931405999995],
              [-75.01325436099995, -49.725681247999944],
              [-75.02257239499994, -49.742120049999926],
              [-75.01618404899995, -49.76132577899995],
              [-75.00426184799994, -49.74570077899995],
              [-74.99274654899995, -49.73756275799991],
              [-74.98106848899994, -49.73984140399995],
              [-74.96898352799991, -49.75448984199994],
              [-74.96580969999991, -49.760430596999925],
              [-74.96344967399995, -49.76637135199991],
              [-74.96202551999994, -49.77418385199991],
              [-74.96153723899994, -49.78525155999995],
              [-74.99254309799994, -49.808526299999926],
              [-75.01398678299995, -49.81170012799993],
              [-75.03502356699994, -49.819024346999925],
              [-75.04344641799992, -49.82634856599992],
              [-75.0266820949999, -49.82952239399992],
              [-75.01219641799992, -49.83733489399992],
              [-75.00841223899994, -49.856133721999925],
              [-75.00991777299993, -49.89853280999995],
              [-75.02188066299993, -49.895196221999925],
              [-75.05052649599992, -49.892510674999926],
              [-75.06114661399994, -49.88787200299993],
              [-75.08079993399991, -49.8689104149999],
              [-75.09097245999993, -49.86532968499995],
              [-75.10952714799993, -49.864353122999944],
              [-75.13394120999993, -49.85833098799992],
              [-75.14932206899994, -49.842868747999944],
              [-75.17442786399994, -49.80169036299992],
              [-75.19831295499995, -49.77117278399993],
            ],
          ],
          [
            [
              [-75.08503170499995, -48.63730234199994],
              [-75.07201087099992, -48.637790622999944],
              [-75.06411699099993, -48.643243096999925],
              [-75.05992591099994, -48.65439218499995],
              [-75.05772864499994, -48.67148202899995],
              [-75.06065833199995, -48.69939544099992],
              [-75.08031165299991, -48.74928150799991],
              [-75.08503170499995, -48.77092864399992],
              [-75.08893795499995, -48.78264739399992],
              [-75.09821529899995, -48.79648202899995],
              [-75.1094457669999, -48.80917734199994],
              [-75.11925208199995, -48.81715260199991],
              [-75.1321508449999, -48.8200822899999],
              [-75.14879309799994, -48.81878020599993],
              [-75.21471106699994, -48.80193450299993],
              [-75.23200436099995, -48.7946916649999],
              [-75.24608313699991, -48.78476327899995],
              [-75.24913489499994, -48.76677825299993],
              [-75.22960364499994, -48.75237395599993],
              [-75.20189368399991, -48.74309661299992],
              [-75.18065344999991, -48.74032968499995],
              [-75.18065344999991, -48.73284270599993],
              [-75.18297278599994, -48.71892669099992],
              [-75.13817298099991, -48.69068775799991],
              [-75.12604732999995, -48.66806405999995],
              [-75.09349524599992, -48.642510674999926],
              [-75.08503170499995, -48.63730234199994],
            ],
          ],
          [
            [
              [-75.02358964799993, -48.68873463299991],
              [-75.01821855399993, -48.68108489399992],
              [-75.00527910099993, -48.68059661299992],
              [-74.97516842399995, -48.68499114399992],
              [-74.99168860599991, -48.67701588299991],
              [-75.0032445949999, -48.66814544099992],
              [-75.00938880099994, -48.65569426899992],
              [-75.00991777299993, -48.63730234199994],
              [-74.96861731699994, -48.65325286299992],
              [-74.94725501199991, -48.655368747999944],
              [-74.89810136599993, -48.64267343499995],
              [-74.87222245999993, -48.645196221999925],
              [-74.82494055899991, -48.65837981599992],
              [-74.82494055899991, -48.66448333099993],
              [-74.85204016799992, -48.67620208099993],
              [-74.92804928299995, -48.71917083099993],
              [-74.98827063699991, -48.740492445999905],
              [-75.02306067599994, -48.74456145599993],
              [-75.04405676999994, -48.73284270599993],
              [-75.04051673099991, -48.71892669099992],
              [-75.0266820949999, -48.700290622999944],
              [-75.02358964799993, -48.68873463299991],
            ],
          ],
          [
            [
              [-75.33893795499995, -48.62420012799993],
              [-75.32774817599994, -48.62712981599992],
              [-75.32555091099994, -48.63396575299993],
              [-75.32900956899994, -48.640883070999905],
              [-75.33519446499992, -48.64413827899995],
              [-75.34129798099991, -48.64592864399992],
              [-75.34496008999992, -48.650323174999926],
              [-75.34544837099992, -48.65593840899993],
              [-75.34235592399995, -48.66139088299991],
              [-75.33844967399995, -48.66253020599993],
              [-75.3274633449999, -48.65935637799993],
              [-75.32152258999992, -48.65837981599992],
              [-75.30882727799991, -48.65764739399992],
              [-75.30199133999992, -48.658135674999926],
              [-75.29723059799994, -48.66375090899993],
              [-75.29043535099993, -48.67815520599993],
              [-75.28628495999993, -48.69500090899993],
              [-75.28795325399994, -48.71298593499995],
              [-75.29698645699995, -48.72714609199994],
              [-75.31468665299991, -48.73284270599993],
              [-75.32701575399994, -48.73455169099992],
              [-75.33629309799994, -48.73707447699991],
              [-75.34508216099994, -48.73674895599993],
              [-75.35602779899995, -48.72975025799991],
              [-75.36221269399994, -48.72747161299992],
              [-75.37694251199991, -48.726495049999926],
              [-75.37987219999991, -48.72283294099992],
              [-75.37840735599991, -48.717054945999905],
              [-75.37287350199995, -48.70273202899995],
              [-75.37303626199991, -48.69866301899992],
              [-75.36620032499991, -48.69866301899992],
              [-75.38418535099993, -48.69646575299993],
              [-75.39781653599994, -48.705743096999925],
              [-75.42145748599995, -48.73284270599993],
              [-75.42983964799993, -48.73748137799993],
              [-75.44713294199994, -48.74334075299993],
              [-75.45494544199994, -48.747165622999944],
              [-75.46149654899995, -48.75237395599993],
              [-75.47179114499994, -48.76384856599992],
              [-75.47606360599991, -48.767510674999926],
              [-75.49323482999995, -48.77556731599992],
              [-75.5098363919999, -48.77890390399995],
              [-75.55113684799994, -48.78134530999995],
              [-75.59178626199991, -48.79216887799993],
              [-75.6126195949999, -48.794854424999926],
              [-75.63312740799995, -48.78801848799992],
              [-75.64785722599993, -48.77890390399995],
              [-75.6536352199999, -48.760837497999944],
              [-75.65355383999992, -48.71599700299993],
              [-75.64183508999992, -48.70134856599992],
              [-75.61436926999994, -48.70322030999995],
              [-75.55797278599994, -48.71917083099993],
              [-75.50755774599992, -48.71754322699991],
              [-75.46051998599995, -48.699883721999925],
              [-75.34557044199994, -48.626885674999926],
              [-75.33893795499995, -48.62420012799993],
            ],
          ],
          [
            [
              [-75.32835852799991, -48.55217864399992],
              [-75.32298743399991, -48.56129322699991],
              [-75.31883704299992, -48.57537200299993],
              [-75.31773841099994, -48.58953215899993],
              [-75.32152258999992, -48.60003020599993],
              [-75.3399145169999, -48.61484140399995],
              [-75.50621497299994, -48.69475676899992],
              [-75.54165605399993, -48.70086028399993],
              [-75.55724036399994, -48.7009416649999],
              [-75.57323157499991, -48.699151299999926],
              [-75.58844967399995, -48.694431247999944],
              [-75.60122636599993, -48.68564218499995],
              [-75.60781816299993, -48.67693450299993],
              [-75.61017818899995, -48.66806405999995],
              [-75.60655676999994, -48.66106536299992],
              [-75.59552975199995, -48.65837981599992],
              [-75.52725175699993, -48.66448333099993],
              [-75.49937903599994, -48.660088799999926],
              [-75.47329667899993, -48.64812590899993],
              [-75.45250403599994, -48.63095468499995],
              [-75.44066321499992, -48.61052825299993],
              [-75.46442623599995, -48.61345794099992],
              [-75.51414954299992, -48.6325822899999],
              [-75.54377193899995, -48.63730234199994],
              [-75.52879798099991, -48.62810637799993],
              [-75.49901282499991, -48.6150041649999],
              [-75.48912512899994, -48.60369231599992],
              [-75.53669186099995, -48.606133721999925],
              [-75.55113684799994, -48.61052825299993],
              [-75.58604895699995, -48.63396575299993],
              [-75.5989477199999, -48.63730234199994],
              [-75.62612870999993, -48.63201262799993],
              [-75.64443925699993, -48.61842213299991],
              [-75.67536373599995, -48.58318450299993],
              [-75.65697180899991, -48.567071221999925],
              [-75.65387936099995, -48.54802825299993],
              [-75.66104081899994, -48.50408294099992],
              [-75.65575110599991, -48.485039971999925],
              [-75.64293372299994, -48.48251718499995],
              [-75.62706458199995, -48.481133721999925],
              [-75.6126195949999, -48.465915622999944],
              [-75.6145727199999, -48.457696221999925],
              [-75.62149003799993, -48.45134856599992],
              [-75.62242591099994, -48.44573333099993],
              [-75.60643469999991, -48.4392229149999],
              [-75.59536699099993, -48.44003671699994],
              [-75.57917232999995, -48.44426848799992],
              [-75.56436113199993, -48.45037200299993],
              [-75.55797278599994, -48.45598723799992],
              [-75.54771887899994, -48.472914320999905],
              [-75.52432206899994, -48.47185637799993],
              [-75.49885006399995, -48.462009372999944],
              [-75.48224850199995, -48.4528947899999],
              [-75.45059160099993, -48.42888762799993],
              [-75.43862870999993, -48.42848072699991],
              [-75.43073482999995, -48.45842864399992],
              [-75.42393958199995, -48.4587541649999],
              [-75.41710364499994, -48.45281340899993],
              [-75.41185462099992, -48.43596770599993],
              [-75.40660559799994, -48.430352471999925],
              [-75.39989173099991, -48.426446221999925],
              [-75.39354407499991, -48.42498137799993],
              [-75.38219153599994, -48.42791106599992],
              [-75.38141842399995, -48.43450286299992],
              [-75.38670813699991, -48.44548919099992],
              [-75.37922115799995, -48.45582447699991],
              [-75.37877356699994, -48.46013762799993],
              [-75.37718665299991, -48.45907968499995],
              [-75.36620032499991, -48.4528947899999],
              [-75.36563066299993, -48.44801197699991],
              [-75.35582434799994, -48.43564218499995],
              [-75.34434973899994, -48.42742278399993],
              [-75.33893795499995, -48.435479424999926],
              [-75.34056555899991, -48.45842864399992],
              [-75.35260982999995, -48.52117278399993],
              [-75.35448157499991, -48.52581145599993],
              [-75.36620032499991, -48.541680596999925],
              [-75.35309811099995, -48.5407854149999],
              [-75.34341386599993, -48.542087497999944],
              [-75.33576412699995, -48.54583098799992],
              [-75.32835852799991, -48.55217864399992],
            ],
          ],
          [
            [
              [-74.47207597599993, -48.45598723799992],
              [-74.50625566299993, -48.428399346999925],
              [-74.51024329299992, -48.40829843499995],
              [-74.47687740799995, -48.40553150799991],
              [-74.40721594999991, -48.41814544099992],
              [-74.31395423099991, -48.46428801899992],
              [-74.30699622299994, -48.465915622999944],
              [-74.30337480399993, -48.47031015399995],
              [-74.30313066299993, -48.47991301899992],
              [-74.30654863199993, -48.48943450299993],
              [-74.31411699099993, -48.49382903399993],
              [-74.34170488199993, -48.500258070999905],
              [-74.40005449099993, -48.52548593499995],
              [-74.4290258449999, -48.52581145599993],
              [-74.43854732999995, -48.51653411299992],
              [-74.46182206899994, -48.479587497999944],
              [-74.46524003799993, -48.47210051899992],
              [-74.46568762899994, -48.467054945999905],
              [-74.46670488199993, -48.46233489399992],
              [-74.47207597599993, -48.45598723799992],
            ],
          ],
          [
            [
              [-74.09068762899994, -48.479587497999944],
              [-74.11099199099993, -48.47356536299992],
              [-74.17906653599994, -48.4431291649999],
              [-74.20079505099994, -48.422133070999905],
              [-74.24551347599993, -48.39421965899993],
              [-74.25080318899995, -48.378024997999944],
              [-74.23521887899994, -48.36809661299992],
              [-74.21190344999991, -48.36370208099993],
              [-74.19371497299994, -48.36345794099992],
              [-74.16380774599992, -48.37395598799992],
              [-74.1204320949999, -48.40488046699994],
              [-74.08726966099994, -48.41130950299993],
              [-74.05719967399995, -48.4255510399999],
              [-74.05418860599991, -48.455010674999926],
              [-74.06859290299991, -48.47966887799993],
              [-74.09068762899994, -48.479587497999944],
            ],
          ],
          [
            [
              [-74.4954320949999, -48.349867445999905],
              [-74.45824133999992, -48.34075286299992],
              [-74.42406165299991, -48.34661223799992],
              [-74.35879472599993, -48.37029387799993],
              [-74.38223222599993, -48.34840260199991],
              [-74.39517167899993, -48.33017343499995],
              [-74.39317786399994, -48.313164971999925],
              [-74.37189693899995, -48.295179945999905],
              [-74.35765540299991, -48.28753020599993],
              [-74.34544837099992, -48.28329843499995],
              [-74.3321020169999, -48.28134530999995],
              [-74.31411699099993, -48.28093840899993],
              [-74.29796301999994, -48.28801848799992],
              [-74.29845130099994, -48.30396900799991],
              [-74.31041419199994, -48.33245208099993],
              [-74.30231686099995, -48.36337655999995],
              [-74.28221594999991, -48.385430596999925],
              [-74.23224850199995, -48.42156340899993],
              [-74.22329667899993, -48.44491952899995],
              [-74.24303137899994, -48.459242445999905],
              [-74.27171790299991, -48.4626604149999],
              [-74.33910071499992, -48.422946872999944],
              [-74.46084550699993, -48.38445403399993],
              [-74.4954320949999, -48.349867445999905],
            ],
          ],
          [
            [
              [-74.49913489499994, -48.58318450299993],
              [-74.48713131399995, -48.59042734199994],
              [-74.48302161399994, -48.60711028399993],
              [-74.48525956899994, -48.62615325299993],
              [-74.49229895699995, -48.64072030999995],
              [-74.51406816299993, -48.66611093499995],
              [-74.52774003799993, -48.674899997999944],
              [-74.56265214799993, -48.68059661299992],
              [-74.59211178299995, -48.691338799999926],
              [-74.60732988199993, -48.69394296699994],
              [-74.62100175699993, -48.69182708099993],
              [-74.65566972599993, -48.671807549999926],
              [-74.66738847599993, -48.66676197699991],
              [-74.69212805899991, -48.65935637799993],
              [-74.70490475199995, -48.65837981599992],
              [-74.7129613919999, -48.65504322699991],
              [-74.73900305899991, -48.63404713299991],
              [-74.75059973899994, -48.62948984199994],
              [-74.76439368399991, -48.63095468499995],
              [-74.79084225199995, -48.63730234199994],
              [-74.81753495999993, -48.63640715899993],
              [-74.86701412699995, -48.62664153399993],
              [-74.94713294199994, -48.61956145599993],
              [-74.97411048099991, -48.61337655999995],
              [-74.99624589799993, -48.60369231599992],
              [-75.01085364499994, -48.58684661299992],
              [-75.01671301999994, -48.5446916649999],
              [-75.0266820949999, -48.52459075299993],
              [-75.03307044199994, -48.50448984199994],
              [-75.02375240799995, -48.484633070999905],
              [-75.00829016799992, -48.46843840899993],
              [-74.94562740799995, -48.41757577899995],
              [-74.93106035099993, -48.41130950299993],
              [-74.92015540299991, -48.41033294099992],
              [-74.89826412699995, -48.4060197899999],
              [-74.88609778599994, -48.40504322699991],
              [-74.87149003799993, -48.40195077899995],
              [-74.84593665299991, -48.39023202899995],
              [-74.83185787699995, -48.39080169099992],
              [-74.81997636599993, -48.40349700299993],
              [-74.81102454299992, -48.44980234199994],
              [-74.80077063699991, -48.46965911299992],
              [-74.78156490799995, -48.485039971999925],
              [-74.76561438699991, -48.489353122999944],
              [-74.75088456899994, -48.48479583099993],
              [-74.73558508999992, -48.473321221999925],
              [-74.71715247299994, -48.45354583099993],
              [-74.71344967399995, -48.43824635199991],
              [-74.72598222599993, -48.42848072699991],
              [-74.75633704299992, -48.42498137799993],
              [-74.81126868399991, -48.36345794099992],
              [-74.81358801999994, -48.34254322699991],
              [-74.80451412699995, -48.28435637799993],
              [-74.79865475199995, -48.26637135199991],
              [-74.77139238199993, -48.22975025799991],
              [-74.76292883999992, -48.21209075299993],
              [-74.76183020699995, -48.18824635199991],
              [-74.76475989499994, -48.1696916649999],
              [-74.76431230399993, -48.152601820999905],
              [-74.75291907499991, -48.13355885199991],
              [-74.73766028599994, -48.12574635199991],
              [-74.72223873599995, -48.13054778399993],
              [-74.70921790299991, -48.14275481599992],
              [-74.70148678299995, -48.15740325299993],
              [-74.69806881399995, -48.17083098799992],
              [-74.69762122299994, -48.18434010199991],
              [-74.70335852799991, -48.19491952899995],
              [-74.71849524599992, -48.1989885399999],
              [-74.7285863919999, -48.20671965899993],
              [-74.72130286399994, -48.22193775799991],
              [-74.7083227199999, -48.233493747999944],
              [-74.70148678299995, -48.22942473799992],
              [-74.69615637899994, -48.22869231599992],
              [-74.68439693899995, -48.237399997999944],
              [-74.67259680899991, -48.25090911299992],
              [-74.66734778599994, -48.26425546699994],
              [-74.67943274599992, -48.29070403399993],
              [-74.68004309799994, -48.303399346999925],
              [-74.64183508999992, -48.31609465899993],
              [-74.61778723899994, -48.3337541649999],
              [-74.59703528599994, -48.35588958099993],
              [-74.58478756399995, -48.37656015399995],
              [-74.58690344999991, -48.403415622999944],
              [-74.61314856699994, -48.40837981599992],
              [-74.64736894399994, -48.40781015399995],
              [-74.67349199099993, -48.41814544099992],
              [-74.63560950399994, -48.431573174999926],
              [-74.61803137899994, -48.442071221999925],
              [-74.60521399599992, -48.45916106599992],
              [-74.60212154899995, -48.475274346999925],
              [-74.60521399599992, -48.528008721999925],
              [-74.60342363199993, -48.549493096999925],
              [-74.59943600199995, -48.56365325299993],
              [-74.59146074099993, -48.57537200299993],
              [-74.54743404899995, -48.61598072699991],
              [-74.53062903599994, -48.621758721999925],
              [-74.52330481699994, -48.60711028399993],
              [-74.52651933499993, -48.58342864399992],
              [-74.52013098899994, -48.58245208099993],
              [-74.49913489499994, -48.58318450299993],
            ],
          ],
          [
            [
              [-74.54381262899994, -48.32195403399993],
              [-74.55158443899995, -48.30348072699991],
              [-74.55581620999993, -48.28557708099993],
              [-74.55809485599991, -48.24342213299991],
              [-74.52944902299993, -48.20989348799992],
              [-74.52188066299993, -48.19451262799993],
              [-74.54381262899994, -48.1989885399999],
              [-74.55577551999994, -48.21054452899995],
              [-74.56411699099993, -48.226495049999926],
              [-74.57510331899994, -48.24065520599993],
              [-74.5950414699999, -48.24684010199991],
              [-74.60374915299991, -48.235446872999944],
              [-74.60179602799991, -48.20956796699994],
              [-74.59390214799993, -48.18173593499995],
              [-74.58478756399995, -48.16423919099992],
              [-74.59044348899994, -48.16301848799992],
              [-74.59959876199991, -48.158868096999925],
              [-74.60521399599992, -48.15740325299993],
              [-74.58039303299995, -48.13437265399995],
              [-74.55817623599995, -48.12232838299991],
              [-74.53384355399993, -48.12460702899995],
              [-74.50283769399994, -48.14373137799993],
              [-74.47411048099991, -48.17978280999995],
              [-74.46532141799992, -48.1853166649999],
              [-74.4512426419999, -48.19003671699994],
              [-74.40957597599993, -48.21306731599992],
              [-74.38141842399995, -48.23552825299993],
              [-74.37340247299994, -48.24423593499995],
              [-74.37262936099995, -48.25318775799991],
              [-74.37930253799993, -48.26726653399993],
              [-74.39085852799991, -48.281508070999905],
              [-74.40392005099994, -48.28997161299992],
              [-74.41763261599993, -48.29412200299993],
              [-74.44098873599995, -48.296807549999926],
              [-74.44513912699995, -48.300713799999926],
              [-74.44810950399994, -48.30527109199994],
              [-74.4544164699999, -48.308851820999905],
              [-74.48916581899994, -48.31568775799991],
              [-74.51939856699994, -48.33318450299993],
              [-74.53441321499992, -48.33562590899993],
              [-74.54381262899994, -48.32195403399993],
            ],
          ],
          [
            [
              [-75.16075598899994, -48.29843515399995],
              [-75.15534420499995, -48.2868791649999],
              [-75.12905839799993, -48.27288176899992],
              [-75.11978105399993, -48.26100025799991],
              [-75.14073645699995, -48.26295338299991],
              [-75.15811113199993, -48.26067473799992],
              [-75.17003333199995, -48.25058359199994],
              [-75.17442786399994, -48.22942473799992],
              [-75.17906653599994, -48.227227471999925],
              [-75.18976803299995, -48.22519296699994],
              [-75.20107988199993, -48.220961195999905],
              [-75.20791581899994, -48.21209075299993],
              [-75.20445716099994, -48.20777760199991],
              [-75.19615637899994, -48.20256926899992],
              [-75.18858801999994, -48.195245049999926],
              [-75.18740800699993, -48.1853166649999],
              [-75.19530188699991, -48.17669036299992],
              [-75.21760006399995, -48.16855234199994],
              [-75.22223873599995, -48.160821221999925],
              [-75.22109941299993, -48.15488046699994],
              [-75.21760006399995, -48.14421965899993],
              [-75.2188207669999, -48.14031340899993],
              [-75.22964433499993, -48.1267229149999],
              [-75.23204505099994, -48.11809661299992],
              [-75.23766028599994, -48.1130510399999],
              [-75.2442113919999, -48.10906340899993],
              [-75.24950110599991, -48.10279713299991],
              [-75.25096594999991, -48.09661223799992],
              [-75.25259355399993, -48.08245208099993],
              [-75.25633704299992, -48.07545338299991],
              [-75.25633704299992, -48.068617445999905],
              [-75.16759192599994, -48.075290622999944],
              [-75.15330969999991, -48.07870859199994],
              [-75.14354407499991, -48.09449635199991],
              [-75.12047278599994, -48.102634372999944],
              [-75.07140051999994, -48.109633070999905],
              [-75.07140051999994, -48.10279713299991],
              [-75.07689368399991, -48.09970468499995],
              [-75.07966061099995, -48.09685637799993],
              [-75.08169511599993, -48.093682549999926],
              [-75.08503170499995, -48.089776299999926],
              [-75.04527747299994, -48.09319426899992],
              [-75.01750464499992, -48.0830201359999],
              [-74.97760815299995, -48.09388870799995],
              [-74.91008644499993, -48.114759646999914],
              [-74.88951024399995, -48.11973542599992],
              [-74.86601980299992, -48.12964263099991],
              [-74.82782024399995, -48.14549165699992],
              [-74.81232662699995, -48.17278411299992],
              [-74.80451412699995, -48.174493096999925],
              [-74.80557206899994, -48.21298593499995],
              [-74.81053626199991, -48.23202890399995],
              [-74.83486894399994, -48.24928150799991],
              [-74.83934485599991, -48.27044036299992],
              [-74.83739173099991, -48.344821872999944],
              [-74.84129798099991, -48.359307549999926],
              [-74.85228430899991, -48.37029387799993],
              [-74.86388098899994, -48.37420012799993],
              [-74.87352454299992, -48.3728166649999],
              [-74.88280188699991, -48.37029387799993],
              [-74.89321855399993, -48.37029387799993],
              [-74.90257727799991, -48.37468840899993],
              [-74.92137610599991, -48.38795338299991],
              [-74.96393795499995, -48.40325286299992],
              [-74.99868730399993, -48.42742278399993],
              [-75.03111731699994, -48.44378020599993],
              [-75.05675208199995, -48.432712497999944],
              [-75.0598852199999, -48.42848072699991],
              [-75.06236731699994, -48.42400481599992],
              [-75.06395423099991, -48.41952890399995],
              [-75.06676184799994, -48.40471770599993],
              [-75.07656816299993, -48.39421965899993],
              [-75.07876542899993, -48.387383721999925],
              [-75.08389238199993, -48.376071872999944],
              [-75.11978105399993, -48.33562590899993],
              [-75.14419511599993, -48.32170989399992],
              [-75.15583248599995, -48.31218840899993],
              [-75.16075598899994, -48.29843515399995],
            ],
          ],
          [
            [
              [-75.14989173099991, -48.65837981599992],
              [-75.16462154899995, -48.66334400799991],
              [-75.20543372299994, -48.69980234199994],
              [-75.22447669199994, -48.70647551899992],
              [-75.23961341099994, -48.701429945999905],
              [-75.24941972599993, -48.68694426899992],
              [-75.25291907499991, -48.66562265399995],
              [-75.24917558499993, -48.65699635199991],
              [-75.24120032499991, -48.65097421699994],
              [-75.23326575399994, -48.646742445999905],
              [-75.22964433499993, -48.64413827899995],
              [-75.22964433499993, -48.63730234199994],
              [-75.24372311099995, -48.637383721999925],
              [-75.25552324099993, -48.64031340899993],
              [-75.26622473899994, -48.64153411299992],
              [-75.27684485599991, -48.63730234199994],
              [-75.28282630099994, -48.63054778399993],
              [-75.28404700399994, -48.62363046699994],
              [-75.28001868399991, -48.61687590899993],
              [-75.27061926999994, -48.61052825299993],
              [-75.28246008999992, -48.60442473799992],
              [-75.29572506399995, -48.59197356599992],
              [-75.30410722599993, -48.57773202899995],
              [-75.30101477799991, -48.56585051899992],
              [-75.29116777299993, -48.552666924999926],
              [-75.29320227799991, -48.54111093499995],
              [-75.31468665299991, -48.51775481599992],
              [-75.32066809799994, -48.492445570999905],
              [-75.30992591099994, -48.46135833099993],
              [-75.29059811099995, -48.43523528399993],
              [-75.27061926999994, -48.42498137799993],
              [-75.27061926999994, -48.41814544099992],
              [-75.30162512899994, -48.408461195999905],
              [-75.31802324099993, -48.401462497999944],
              [-75.32526607999995, -48.39421965899993],
              [-75.31798255099994, -48.363213799999926],
              [-75.31794186099995, -48.34889088299991],
              [-75.32835852799991, -48.34303150799991],
              [-75.33678137899994, -48.34856536299992],
              [-75.35753333199995, -48.37517669099992],
              [-75.36620032499991, -48.38396575299993],
              [-75.38023841099994, -48.39031340899993],
              [-75.39696204299992, -48.39462655999995],
              [-75.41372636599993, -48.39527760199991],
              [-75.42764238199993, -48.39080169099992],
              [-75.43814042899993, -48.40553150799991],
              [-75.46019446499992, -48.41659921699994],
              [-75.48656165299991, -48.42302825299993],
              [-75.51024329299992, -48.42498137799993],
              [-75.53734290299991, -48.4157854149999],
              [-75.55418860599991, -48.397149346999925],
              [-75.55500240799995, -48.37859465899993],
              [-75.53408769399994, -48.37029387799993],
              [-75.52464758999992, -48.36858489399992],
              [-75.47443600199995, -48.35369231599992],
              [-75.43073482999995, -48.349867445999905],
              [-75.4055883449999, -48.344414971999925],
              [-75.38438880099994, -48.33131275799991],
              [-75.3457738919999, -48.301446221999925],
              [-75.3457738919999, -48.295179945999905],
              [-75.36375891799992, -48.29534270599993],
              [-75.37848873599995, -48.30152760199991],
              [-75.39199785099993, -48.30982838299991],
              [-75.40713456899994, -48.31568775799991],
              [-75.40269934799994, -48.29412200299993],
              [-75.39415442599994, -48.274102471999925],
              [-75.41193600199995, -48.283461195999905],
              [-75.44249426999994, -48.30738697699991],
              [-75.46182206899994, -48.31568775799991],
              [-75.46715247299994, -48.31129322699991],
              [-75.47716223899994, -48.30608489399992],
              [-75.48224850199995, -48.301446221999925],
              [-75.51073157499991, -48.31991952899995],
              [-75.52765865799995, -48.32577890399995],
              [-75.54377193899995, -48.32195403399993],
              [-75.55431067599994, -48.307712497999944],
              [-75.55150305899991, -48.29371510199991],
              [-75.54141191299993, -48.28199635199991],
              [-75.53066972599993, -48.274102471999925],
              [-75.47305253799993, -48.24618905999995],
              [-75.44692949099993, -48.22665780999995],
              [-75.43390865799995, -48.1989885399999],
              [-75.45787512899994, -48.20273202899995],
              [-75.49608313699991, -48.227227471999925],
              [-75.52049719999991, -48.23316822699991],
              [-75.53050696499992, -48.23137786299992],
              [-75.54010982999995, -48.22625090899993],
              [-75.54491126199991, -48.2185197899999],
              [-75.54059811099995, -48.208916924999926],
              [-75.5325414699999, -48.19931405999995],
              [-75.53246008999992, -48.19426848799992],
              [-75.55410722599993, -48.17669036299992],
              [-75.56078040299991, -48.174899997999944],
              [-75.56582597599993, -48.17131926899992],
              [-75.57164466099994, -48.15740325299993],
              [-75.57164466099994, -48.11956145599993],
              [-75.57380123599995, -48.111260674999926],
              [-75.58324133999992, -48.0974260399999],
              [-75.58531653599994, -48.0857072899999],
              [-75.55113684799994, -48.055759372999944],
              [-75.53514563699991, -48.04583098799992],
              [-75.50462805899991, -48.03134530999995],
              [-75.47508704299992, -48.02629973799992],
              [-75.46182206899994, -48.04509856599992],
              [-75.45645097599993, -48.065524997999944],
              [-75.44424394399994, -48.058526299999926],
              [-75.42145748599995, -48.02776458099993],
              [-75.40615800699993, -48.01921965899993],
              [-75.37808183499993, -48.00823333099993],
              [-75.35098222599993, -48.00448984199994],
              [-75.33893795499995, -48.017510674999926],
              [-75.34166419199994, -48.02874114399992],
              [-75.35094153599994, -48.05120208099993],
              [-75.34911048099991, -48.05917734199994],
              [-75.33495032499991, -48.07480234199994],
              [-75.32526607999995, -48.089776299999926],
              [-75.32485917899993, -48.0974260399999],
              [-75.32567298099991, -48.10670338299991],
              [-75.32115637899994, -48.11077239399992],
              [-75.3047582669999, -48.10279713299991],
              [-75.29873613199993, -48.12542083099993],
              [-75.28087317599994, -48.14568450299993],
              [-75.26891028599994, -48.165948174999926],
              [-75.2805883449999, -48.188571872999944],
              [-75.28648841099994, -48.195977471999925],
              [-75.29076087099992, -48.20631275799991],
              [-75.28994706899994, -48.215508721999925],
              [-75.2805883449999, -48.21949635199991],
              [-75.27603105399993, -48.21648528399993],
              [-75.27440344999991, -48.21103280999995],
              [-75.27147376199991, -48.20777760199991],
              [-75.26317298099991, -48.21209075299993],
              [-75.26089433499993, -48.21835702899995],
              [-75.26309160099993, -48.22698333099993],
              [-75.26720130099994, -48.235039971999925],
              [-75.27061926999994, -48.2400041649999],
              [-75.25645911399994, -48.24504973799992],
              [-75.24836178299995, -48.251885674999926],
              [-75.21092688699991, -48.31292083099993],
              [-75.20791581899994, -48.32561614399992],
              [-75.20392818899995, -48.33554452899995],
              [-75.19473222599993, -48.347914320999905],
              [-75.18455969999991, -48.35881926899992],
              [-75.17756100199995, -48.36345794099992],
              [-75.16478430899991, -48.36956145599993],
              [-75.16934160099993, -48.38339609199994],
              [-75.18740800699993, -48.41130950299993],
              [-75.15176347599993, -48.40894947699991],
              [-75.13426673099991, -48.422539971999925],
              [-75.12108313699991, -48.444024346999925],
              [-75.09870357999995, -48.465915622999944],
              [-75.11131751199991, -48.47039153399993],
              [-75.13878333199995, -48.47625090899993],
              [-75.14989173099991, -48.48300546699994],
              [-75.14476477799991, -48.48870208099993],
              [-75.10383053299995, -48.49895598799992],
              [-75.08873450399994, -48.500664971999925],
              [-75.08340410099993, -48.507745049999926],
              [-75.08551998599995, -48.52353280999995],
              [-75.09243730399993, -48.549086195999905],
              [-75.08824622299994, -48.55877044099992],
              [-75.07359778599994, -48.58245208099993],
              [-75.07140051999994, -48.59628671699994],
              [-75.08275305899991, -48.61345794099992],
              [-75.10692298099991, -48.63396575299993],
              [-75.13292395699995, -48.65113697699991],
              [-75.14989173099991, -48.65837981599992],
            ],
          ],
          [
            [
              [-75.27061926999994, -48.02776458099993],
              [-75.23167883999992, -48.00546640399995],
              [-75.22321529899995, -47.99260833099993],
              [-75.23591061099995, -47.9724260399999],
              [-75.20702134399994, -47.916947241999935],
              [-75.16777265099995, -47.893604282999945],
              [-75.08789732899993, -47.86730647399992],
              [-75.04439757999995, -47.868241740999906],
              [-75.00818474399995, -47.86820653399991],
              [-74.94292566799993, -47.883665608999934],
              [-74.92125588499994, -47.86515173799995],
              [-74.90233313699991, -47.84710051899992],
              [-74.89073645699995, -47.82870859199994],
              [-74.87279212099992, -47.815524997999944],
              [-74.85407467399995, -47.822930596999925],
              [-74.84178626199991, -47.817478122999944],
              [-74.8313695949999, -47.810804945999905],
              [-74.81818600199995, -47.815524997999944],
              [-74.78832381299992, -47.81232427099991],
              [-74.77662731099991, -47.82881146799991],
              [-74.76775708999992, -47.854054677999954],
              [-74.76573686799992, -47.88421156299995],
              [-74.78004467999995, -47.90341305299995],
              [-74.78864287199991, -47.91684502599992],
              [-74.8072419639999, -47.92834842099995],
              [-74.81298195599993, -47.938897175999955],
              [-74.78436874099992, -47.949485668999955],
              [-74.77718186899995, -47.97061189899995],
              [-74.7842006699999, -47.98884979299993],
              [-74.81866054099993, -47.993584831999954],
              [-74.83486894399994, -48.00790780999995],
              [-74.82152258999992, -48.01409270599993],
              [-74.7844217729999, -48.01183398299992],
              [-74.76441883699994, -48.02144139099994],
              [-74.75735143799994, -48.042546124999944],
              [-74.72737923799991, -48.10589183899992],
              [-74.7933102909999, -48.07799269699996],
              [-74.85207335299992, -48.07214127799995],
              [-74.89648605899993, -48.0682137309999],
              [-74.94163977799991, -48.055759372999944],
              [-74.96369381399995, -48.04697030999995],
              [-75.01284745999993, -48.04143645599993],
              [-75.03351803299995, -48.031182549999926],
              [-75.0364477199999, -48.02288176899992],
              [-75.02660071499992, -48.00546640399995],
              [-75.02977454299992, -47.99358489399992],
              [-75.03872636599993, -47.98837655999995],
              [-75.05235755099994, -47.986260674999926],
              [-75.06688391799992, -47.986260674999926],
              [-75.10240637899994, -47.990166924999926],
              [-75.11998450399994, -47.9978166649999],
              [-75.13463294199994, -48.00937265399995],
              [-75.14989173099991, -48.02434661299992],
              [-75.16909745999993, -48.033868096999925],
              [-75.19810950399994, -48.03997161299992],
              [-75.2278539699999, -48.04265715899993],
              [-75.24950110599991, -48.04192473799992],
              [-75.25495357999995, -48.038995049999926],
              [-75.27061926999994, -48.02776458099993],
            ],
          ],
          [
            [
              [-74.41372636599993, -47.93824635199991],
              [-74.46153723899994, -47.93629322699991],
              [-74.48216712099992, -47.930352471999925],
              [-74.50283769399994, -47.917901299999926],
              [-74.47667395699995, -47.8962541649999],
              [-74.42153886599993, -47.86028411299992],
              [-74.39635169199994, -47.83945077899995],
              [-74.36424719999991, -47.83082447699991],
              [-74.32363847599993, -47.84531015399995],
              [-74.28258216099994, -47.86614348799992],
              [-74.24893144399994, -47.876885674999926],
              [-74.26089433499993, -47.86093515399995],
              [-74.28429114499994, -47.84579843499995],
              [-74.33092200399994, -47.822198174999926],
              [-74.28990637899994, -47.80738697699991],
              [-74.24522864499994, -47.8064104149999],
              [-74.07481848899994, -47.84783294099992],
              [-73.99547278599994, -47.85361093499995],
              [-73.97569739499994, -47.85979583099993],
              [-73.93138587099992, -47.88014088299991],
              [-73.90758216099994, -47.883884372999944],
              [-73.88414466099994, -47.879978122999944],
              [-73.86168372299994, -47.8669572899999],
              [-73.83690344999991, -47.85686614399992],
              [-73.8184301419999, -47.86638762799993],
              [-73.80890865799995, -47.887383721999925],
              [-73.81078040299991, -47.91171640399995],
              [-73.83120683499993, -47.93824635199991],
              [-73.82799231699994, -47.9372697899999],
              [-73.82603919199994, -47.94109465899993],
              [-73.82673092399995, -47.94695403399993],
              [-73.83120683499993, -47.95256926899992],
              [-73.83702551999994, -47.95387135199991],
              [-73.86168372299994, -47.95256926899992],
              [-73.90977942599994, -47.95598723799992],
              [-73.92300370999993, -47.96363697699991],
              [-73.93000240799995, -47.957696221999925],
              [-73.93431555899991, -47.93824635199991],
              [-73.93077551999994, -47.94019947699991],
              [-73.92625891799992, -47.93482838299991],
              [-73.92227128799993, -47.92693450299993],
              [-73.92064368399991, -47.92131926899992],
              [-73.92487545499995, -47.915948174999926],
              [-73.93447831899994, -47.9177385399999],
              [-73.95103919199994, -47.92457447699991],
              [-73.96336829299992, -47.92693450299993],
              [-73.99571692599994, -47.94589609199994],
              [-74.02452551999994, -47.95387135199991],
              [-74.11554928299995, -47.94589609199994],
              [-74.13023841099994, -47.9470354149999],
              [-74.16706295499995, -47.95940520599993],
              [-74.31847083199995, -47.98121510199991],
              [-74.34455318899995, -47.9724260399999],
              [-74.36217200399994, -47.962009372999944],
              [-74.37482662699995, -47.95077890399995],
              [-74.38963782499991, -47.94198984199994],
              [-74.41372636599993, -47.93824635199991],
            ],
          ],
          [
            [
              [-75.18236243399991, -47.83147551899992],
              [-75.1915657269999, -47.80801175999994],
              [-75.22209778799993, -47.79207358299993],
              [-75.26616243799992, -47.77610704199992],
              [-75.3047582669999, -47.76767343499995],
              [-75.34254640099994, -47.78286244199995],
              [-75.33395781599995, -47.75895262699993],
              [-75.35591345599994, -47.73614002799991],
              [-75.3371913279999, -47.7213613159999],
              [-75.31848630099995, -47.706584139999904],
              [-75.29475457399991, -47.703195827999934],
              [-75.26767713699991, -47.712333557999955],
              [-75.24568452699992, -47.723738357999935],
              [-75.2084073609999, -47.71692592699992],
              [-75.18638407899994, -47.71123931099993],
              [-75.16776228999993, -47.70896605899992],
              [-75.15135657499991, -47.703057549999926],
              [-75.15330969999991, -47.69882577899995],
              [-75.11700417999992, -47.67936435899992],
              [-75.09163752899991, -47.68049221699994],
              [-75.07639317799993, -47.70097077699995],
              [-75.06278898599993, -47.73396075699992],
              [-75.05936917999992, -47.74988696499992],
              [-75.09508216099994, -47.76531340899993],
              [-75.10631262899994, -47.766289971999925],
              [-75.11636308499993, -47.77076588299991],
              [-75.12319902299993, -47.781914971999925],
              [-75.11558997299994, -47.785821221999925],
              [-75.10142981699994, -47.783868096999925],
              [-75.08873450399994, -47.777276299999926],
              [-75.07713782499991, -47.77271900799991],
              [-75.06895911399994, -47.77939218499995],
              [-75.04403389499993, -47.79082663499992],
              [-75.02368236099994, -47.80332502999994],
              [-75.0507557919999, -47.82269933199996],
              [-75.09386145699995, -47.826836846999925],
              [-75.09870357999995, -47.83220794099992],
              [-75.1321873949999, -47.8398692799999],
              [-75.16105118399992, -47.837613793999935],
              [-75.22731378999993, -47.85471428799991],
              [-75.22052053699991, -47.846748385999945],
              [-75.19671426499991, -47.836491596999906],
              [-75.18236243399991, -47.83147551899992],
            ],
          ],
          [
            [
              [-74.88522879899995, -47.71206318199995],
              [-74.86137525099991, -47.74387616999991],
              [-74.86804045299994, -47.76324224199993],
              [-74.93138587099992, -47.7732072899999],
              [-74.95772277599991, -47.77479505999992],
              [-74.9678883709999, -47.7725332519999],
              [-74.98484009799995, -47.765729774999954],
              [-75.0051937799999, -47.75210257099991],
              [-75.02723100199995, -47.73847422099993],
              [-75.03914787899993, -47.71117972899992],
              [-75.05442142099992, -47.68957206099992],
              [-75.04262510099994, -47.66679884999991],
              [-75.00038361399993, -47.66220014999993],
              [-74.9496241409999, -47.6780542809999],
              [-74.90395468799994, -47.68593536499992],
              [-74.88522879899995, -47.71206318199995],
            ],
          ],
          [
            [
              [-74.46865800699993, -47.07496510199991],
              [-74.43932044199994, -47.06145598799992],
              [-74.39842688699991, -47.049493096999925],
              [-74.35667883999992, -47.04501718499995],
              [-74.32469641799992, -47.05388762799993],
              [-74.31639563699991, -47.06487395599993],
              [-74.31578528599994, -47.078057549999926],
              [-74.32115637899994, -47.09124114399992],
              [-74.33092200399994, -47.10230885199991],
              [-74.34292558499993, -47.10881926899992],
              [-74.37682044199994, -47.12118905999995],
              [-74.39297441299993, -47.129571221999925],
              [-74.44078528599994, -47.16375090899993],
              [-74.45470130099994, -47.1677385399999],
              [-74.46694902299993, -47.16619231599992],
              [-74.47154700399994, -47.15935637799993],
              [-74.46247311099995, -47.147556247999944],
              [-74.46816972599993, -47.138604424999926],
              [-74.48375403599994, -47.12509530999995],
              [-74.48916581899994, -47.11646900799991],
              [-74.49217688699991, -47.09889088299991],
              [-74.48778235599991, -47.087823174999926],
              [-74.47899329299992, -47.080743096999925],
              [-74.46865800699993, -47.07496510199991],
            ],
          ],
          [
            [
              [-74.07457434799994, -47.02027760199991],
              [-74.04735266799992, -47.02263762799993],
              [-74.02269446499992, -47.02898528399993],
              [-73.97524980399993, -47.04762135199991],
              [-74.02326412699995, -47.081149997999944],
              [-74.02989661399994, -47.09197356599992],
              [-74.03600012899994, -47.10670338299991],
              [-74.05044511599993, -47.12363046699994],
              [-74.06737219999991, -47.13746510199991],
              [-74.14590410099993, -47.17115650799991],
              [-74.17251542899993, -47.16920338299991],
              [-74.18285071499992, -47.15976327899995],
              [-74.17658443899995, -47.150648695999905],
              [-74.15339107999995, -47.150648695999905],
              [-74.15566972599993, -47.14853280999995],
              [-74.16356360599991, -47.13909270599993],
              [-74.16714433499993, -47.13591887799993],
              [-74.17251542899993, -47.13396575299993],
              [-74.17829342399995, -47.13290780999995],
              [-74.21003170499995, -47.13144296699994],
              [-74.21922766799992, -47.1286760399999],
              [-74.22647050699993, -47.12200286299992],
              [-74.23070227799991, -47.10214609199994],
              [-74.22419186099995, -47.07935963299991],
              [-74.21239173099991, -47.05779387799993],
              [-74.18586178299995, -47.02304452899995],
              [-74.17735755099994, -47.01653411299992],
              [-74.16706295499995, -47.01287200299993],
              [-74.15689042899993, -47.014743747999944],
              [-74.12535559799994, -47.025648695999905],
              [-74.11864173099991, -47.03020598799992],
              [-74.11119544199994, -47.05388762799993],
              [-74.09508216099994, -47.04762135199991],
              [-74.07974199099993, -47.03020598799992],
              [-74.07457434799994, -47.02027760199991],
            ],
          ],
          [
            [
              [-73.72508704299992, -46.05046965899993],
              [-73.71198482999995, -46.05877044099992],
              [-73.69815019399994, -46.06462981599992],
              [-73.68667558499993, -46.07284921699994],
              [-73.68040930899991, -46.08806731599992],
              [-73.68407141799992, -46.105401299999926],
              [-73.70864824099993, -46.1267229149999],
              [-73.71458899599992, -46.13958098799992],
              [-73.71776282499991, -46.142510674999926],
              [-73.72484290299991, -46.14348723799992],
              [-73.73180091099994, -46.14592864399992],
              [-73.73501542899993, -46.15357838299991],
              [-73.73766028599994, -46.171807549999926],
              [-73.7454320949999, -46.18718840899993],
              [-73.75804602799991, -46.1970354149999],
              [-73.7754613919999, -46.199476820999905],
              [-73.79206295499995, -46.19687265399995],
              [-73.80846106699994, -46.19109465899993],
              [-73.82201087099992, -46.1814104149999],
              [-73.83031165299991, -46.166680596999925],
              [-73.83104407499991, -46.16375090899993],
              [-73.82933508999992, -46.15195077899995],
              [-73.82140051999994, -46.14332447699991],
              [-73.80968176999994, -46.13811614399992],
              [-73.8235570949999, -46.13486093499995],
              [-73.84235592399995, -46.129571221999925],
              [-73.89281165299991, -46.094414971999925],
              [-73.9270727199999, -46.078057549999926],
              [-73.94050045499995, -46.0681291649999],
              [-73.9192602199999, -46.027601820999905],
              [-73.90977942599994, -46.01637135199991],
              [-73.89647376199991, -46.0114885399999],
              [-73.87531490799995, -46.01018645599993],
              [-73.83739173099991, -46.01295338299991],
              [-73.82241777299993, -46.019789320999905],
              [-73.79181881399995, -46.04225025799991],
              [-73.77940833199995, -46.04705169099992],
              [-73.75210527299993, -46.04225025799991],
              [-73.73888098899994, -46.04265715899993],
              [-73.72508704299992, -46.05046965899993],
            ],
          ],
          [
            [
              [-73.70767167899993, -45.9235979149999],
              [-73.70348059799994, -45.9353166649999],
              [-73.70596269399994, -45.97161223799992],
              [-73.68317623599995, -46.01767343499995],
              [-73.71263587099992, -46.02157968499995],
              [-73.81948808499993, -45.998711846999925],
              [-73.82632402299993, -45.98577239399992],
              [-73.82176673099991, -45.96892669099992],
              [-73.78628495999993, -45.9138322899999],
              [-73.77212480399993, -45.898695570999905],
              [-73.75552324099993, -45.88884856599992],
              [-73.74836178299995, -45.91887786299992],
              [-73.7481176419999, -45.9235979149999],
              [-73.73888098899994, -45.92498137799993],
              [-73.71629798099991, -45.92148202899995],
              [-73.70767167899993, -45.9235979149999],
            ],
          ],
          [
            [
              [-74.75291907499991, -45.80754973799992],
              [-74.7356664699999, -45.80722421699994],
              [-74.72109941299993, -45.80982838299991],
              [-74.71300208199995, -45.82187265399995],
              [-74.71507727799991, -45.84840260199991],
              [-74.72288977799991, -45.865492445999905],
              [-74.74522864499994, -45.89999765399995],
              [-74.75153561099995, -45.92717864399992],
              [-74.76292883999992, -45.95826588299991],
              [-74.76634680899991, -45.98886484199994],
              [-74.77033443899995, -45.998711846999925],
              [-74.78075110599991, -46.0114885399999],
              [-74.79649817599994, -46.02507903399993],
              [-74.81358801999994, -46.035821221999925],
              [-74.85212154899995, -46.04501718499995],
              [-74.86778723899994, -46.056573174999926],
              [-74.89321855399993, -46.08806731599992],
              [-74.91966712099992, -46.104180596999925],
              [-74.95213782499991, -46.11142343499995],
              [-74.98615475199995, -46.11207447699991],
              [-75.04771887899994, -46.105726820999905],
              [-75.06285559799994, -46.10165780999995],
              [-75.07433020699995, -46.09384530999995],
              [-75.08185787699995, -46.08147551899992],
              [-75.08747311099995, -46.0681291649999],
              [-75.09447180899991, -46.05592213299991],
              [-75.10610917899993, -46.04705169099992],
              [-75.09732011599993, -46.03443775799991],
              [-75.08438066299993, -46.02678801899992],
              [-74.98884029899995, -46.00554778399993],
              [-74.95563717399995, -46.00660572699991],
              [-74.92267818899995, -46.01441822699991],
              [-74.89045162699995, -46.01620859199994],
              [-74.85912024599992, -45.998711846999925],
              [-74.86534583199995, -45.992445570999905],
              [-74.90200761599993, -46.00660572699991],
              [-74.91368567599994, -46.01295338299991],
              [-74.96564693899995, -45.98284270599993],
              [-74.98265540299991, -45.978773695999905],
              [-74.99413001199991, -45.980726820999905],
              [-75.02057857999995, -45.99032968499995],
              [-75.03351803299995, -45.992445570999905],
              [-75.04580644399994, -45.99179452899995],
              [-75.07876542899993, -45.985039971999925],
              [-75.07087154899995, -45.97478606599992],
              [-75.05899003799993, -45.97128671699994],
              [-75.02977454299992, -45.97193775799991],
              [-75.02977454299992, -45.96453215899993],
              [-75.08873450399994, -45.950290622999944],
              [-75.08503170499995, -45.916680596999925],
              [-75.09015865799995, -45.90976327899995],
              [-75.10887610599991, -45.89218515399995],
              [-75.11294511599993, -45.88567473799992],
              [-75.10826575399994, -45.87420012799993],
              [-75.09658769399994, -45.8669572899999],
              [-75.08189856699994, -45.863213799999926],
              [-75.06798255099994, -45.86207447699991],
              [-75.05435136599993, -45.863539320999905],
              [-75.01618404899995, -45.87574635199991],
              [-74.96979732999995, -45.885430596999925],
              [-74.95811926999994, -45.892510674999926],
              [-74.94058183499993, -45.90634530999995],
              [-74.91319739499994, -45.92107512799993],
              [-74.88353430899991, -45.92937590899993],
              [-74.85912024599992, -45.9235979149999],
              [-74.87791907499991, -45.90837981599992],
              [-74.96458899599992, -45.87078215899993],
              [-74.97052975199995, -45.86288827899995],
              [-74.96153723899994, -45.85466887799993],
              [-74.94737708199995, -45.85409921699994],
              [-74.93712317599994, -45.86174895599993],
              [-74.92796790299991, -45.87118905999995],
              [-74.91710364499994, -45.87574635199991],
              [-74.90689042899993, -45.87818775799991],
              [-74.89696204299992, -45.88201262799993],
              [-74.88939368399991, -45.881931247999944],
              [-74.88638261599993, -45.87232838299991],
              [-74.88499915299991, -45.85621510199991],
              [-74.88068600199995, -45.85426197699991],
              [-74.8731176419999, -45.85881926899992],
              [-74.86217200399994, -45.86207447699991],
              [-74.8360082669999, -45.85881926899992],
              [-74.82933508999992, -45.84880950299993],
              [-74.83145097599993, -45.83171965899993],
              [-74.83185787699995, -45.80754973799992],
              [-74.8040258449999, -45.81975676899992],
              [-74.79393469999991, -45.82122161299992],
              [-74.78233801999994, -45.819024346999925],
              [-74.76231848899994, -45.80974700299993],
              [-74.75291907499991, -45.80754973799992],
            ],
          ],
          [
            [
              [-73.74185136599993, -45.79387786299992],
              [-73.71629798099991, -45.81218840899993],
              [-73.71007239499994, -45.837009372999944],
              [-73.70783443899995, -45.863946221999925],
              [-73.69408118399991, -45.88884856599992],
              [-73.71568762899994, -45.88600025799991],
              [-73.73863684799994, -45.87753671699994],
              [-73.76317298099991, -45.871351820999905],
              [-73.78966223899994, -45.87574635199991],
              [-73.80308997299994, -45.89202239399992],
              [-73.81281490799995, -45.91521575299993],
              [-73.82469641799992, -45.93059661299992],
              [-73.84487870999993, -45.9235979149999],
              [-73.84284420499995, -45.934258721999925],
              [-73.84142005099994, -45.93824635199991],
              [-73.83739173099991, -45.944024346999925],
              [-73.85655676999994, -45.96754322699991],
              [-73.88312740799995, -45.98088958099993],
              [-73.91095943899995, -45.98259856599992],
              [-73.93431555899991, -45.97193775799991],
              [-73.94493567599994, -45.939711195999905],
              [-73.94570878799993, -45.92506275799991],
              [-73.94050045499995, -45.9099260399999],
              [-73.92857825399994, -45.89348723799992],
              [-73.9114477199999, -45.875258070999905],
              [-73.8926488919999, -45.86077239399992],
              [-73.87588456899994, -45.85466887799993],
              [-73.83653723899994, -45.849541924999926],
              [-73.8020727199999, -45.835870049999926],
              [-73.74185136599993, -45.79387786299992],
            ],
          ],
          [
            [
              [-73.92682857999995, -45.74537525799991],
              [-73.9668676419999, -45.769789320999905],
              [-73.97524980399993, -45.78020598799992],
              [-73.96344967399995, -45.7868791649999],
              [-73.96202551999994, -45.79566822699991],
              [-73.96540279899995, -45.80608489399992],
              [-73.96776282499991, -45.81804778399993],
              [-73.96983801999994, -45.82073333099993],
              [-73.97451738199993, -45.8239885399999],
              [-73.97935950399994, -45.82830169099992],
              [-73.98204505099994, -45.83473072699991],
              [-73.98005123599995, -45.83928801899992],
              [-73.97008216099994, -45.85125090899993],
              [-73.96776282499991, -45.85833098799992],
              [-73.97598222599993, -45.88054778399993],
              [-73.99478105399993, -45.90276458099993],
              [-74.01561438699991, -45.913995049999926],
              [-74.02989661399994, -45.90309010199991],
              [-74.04295813699991, -45.86663176899992],
              [-74.04971269399994, -45.85466887799993],
              [-74.05919348899994, -45.845635674999926],
              [-74.06871497299994, -45.83863697699991],
              [-74.07225501199991, -45.82976653399993],
              [-74.06403561099995, -45.81503671699994],
              [-74.09097245999993, -45.81462981599992],
              [-74.10240637899994, -45.7888322899999],
              [-74.09459387899994, -45.763929945999905],
              [-74.06403561099995, -45.76653411299992],
              [-74.05968176999994, -45.744398695999905],
              [-74.04458574099993, -45.73845794099992],
              [-74.0254613919999, -45.74114348799992],
              [-74.00877844999991, -45.74537525799991],
              [-73.98810787699995, -45.74700286299992],
              [-73.94774329299992, -45.74423593499995],
              [-73.92682857999995, -45.74537525799991],
            ],
          ],
          [
            [
              [-74.79084225199995, -45.63250090899993],
              [-74.74986731699994, -45.69768645599993],
              [-74.75243079299992, -45.69963958099993],
              [-74.76943925699993, -45.70452239399992],
              [-74.77505449099993, -45.70525481599992],
              [-74.79710852799991, -45.697523695999905],
              [-74.85228430899991, -45.65667083099993],
              [-74.86359615799995, -45.65252044099992],
              [-74.87059485599991, -45.65081145599993],
              [-74.87515214799993, -45.646742445999905],
              [-74.8789770169999, -45.63551197699991],
              [-74.87926184799994, -45.62460702899995],
              [-74.87584387899994, -45.61345794099992],
              [-74.86986243399991, -45.60491301899992],
              [-74.86217200399994, -45.601495049999926],
              [-74.83910071499992, -45.601820570999905],
              [-74.81582597599993, -45.60515715899993],
              [-74.79800370999993, -45.61443450299993],
              [-74.79084225199995, -45.63250090899993],
            ],
          ],
          [
            [
              [-74.55435136599993, -45.57480234199994],
              [-74.54133053299995, -45.57870859199994],
              [-74.53888912699995, -45.58749765399995],
              [-74.54149329299992, -45.59661223799992],
              [-74.54381262899994, -45.601495049999926],
              [-74.56529700399994, -45.63323333099993],
              [-74.57266191299993, -45.6540666649999],
              [-74.55044511599993, -45.67131926899992],
              [-74.55406653599994, -45.68889739399992],
              [-74.5637914699999, -45.70761484199994],
              [-74.58389238199993, -45.73528411299992],
              [-74.59569251199991, -45.74578215899993],
              [-74.61148027299993, -45.75139739399992],
              [-74.63630123599995, -45.75286223799992],
              [-74.66344153599994, -45.75090911299992],
              [-74.68569902299993, -45.74334075299993],
              [-74.7005102199999, -45.727634372999944],
              [-74.70563717399995, -45.7009416649999],
              [-74.70238196499992, -45.67392343499995],
              [-74.69371497299994, -45.64609140399995],
              [-74.67967688699991, -45.62070077899995],
              [-74.66047115799995, -45.601495049999926],
              [-74.64346269399994, -45.59433359199994],
              [-74.60407467399995, -45.586195570999905],
              [-74.58128821499992, -45.57463958099993],
              [-74.57217363199993, -45.57390715899993],
              [-74.55435136599993, -45.57480234199994],
            ],
          ],
          [
            [
              [-74.07144120999993, -45.69085051899992],
              [-74.10094153599994, -45.64202239399992],
              [-74.10728919199994, -45.615492445999905],
              [-74.11172441299993, -45.60784270599993],
              [-74.11465410099993, -45.59970468499995],
              [-74.11241614499994, -45.587823174999926],
              [-74.0840551419999, -45.57048919099992],
              [-74.08071855399993, -45.56731536299992],
              [-74.0684301419999, -45.55974700299993],
              [-74.05044511599993, -45.54461028399993],
              [-74.0305883449999, -45.533135674999926],
              [-74.01252193899995, -45.53655364399992],
              [-74.00169837099992, -45.54338958099993],
              [-73.97874915299991, -45.549493096999925],
              [-73.96776282499991, -45.55364348799992],
              [-73.94497636599993, -45.57236093499995],
              [-73.93740800699993, -45.57480234199994],
              [-73.9102270169999, -45.59099700299993],
              [-73.90062415299991, -45.62835051899992],
              [-73.90526282499991, -45.66961028399993],
              [-73.92064368399991, -45.69768645599993],
              [-73.95457923099991, -45.713962497999944],
              [-74.0000707669999, -45.72161223799992],
              [-74.04356848899994, -45.715508721999925],
              [-74.07144120999993, -45.69085051899992],
            ],
          ],
          [
            [
              [-74.50283769399994, -45.732354424999926],
              [-74.46532141799992, -45.69426848799992],
              [-74.45604407499991, -45.67742278399993],
              [-74.45742753799993, -45.65097421699994],
              [-74.44815019399994, -45.64299895599993],
              [-74.45685787699995, -45.631524346999925],
              [-74.48029537699995, -45.62118905999995],
              [-74.49229895699995, -45.612399997999944],
              [-74.48912512899994, -45.60662200299993],
              [-74.45897376199991, -45.59384530999995],
              [-74.44815019399994, -45.587823174999926],
              [-74.46544348899994, -45.57244231599992],
              [-74.46963456899994, -45.5466447899999],
              [-74.46393795499995, -45.51832447699991],
              [-74.45128333199995, -45.49529387799993],
              [-74.42125403599994, -45.45427825299993],
              [-74.40387936099995, -45.44736093499995],
              [-74.37189693899995, -45.45126718499995],
              [-74.31777910099993, -45.46697356599992],
              [-74.29352779899995, -45.47909921699994],
              [-74.27354895699995, -45.49529387799993],
              [-74.25739498599995, -45.5153947899999],
              [-74.24864661399994, -45.53557708099993],
              [-74.25316321499992, -45.55348072699991],
              [-74.27696692599994, -45.56731536299992],
              [-74.26154537699995, -45.57154713299991],
              [-74.24128170499995, -45.57439544099992],
              [-74.22496497299994, -45.58212655999995],
              [-74.22166907499991, -45.601495049999926],
              [-74.23131262899994, -45.61419036299992],
              [-74.24937903599994, -45.62037525799991],
              [-74.28990637899994, -45.62249114399992],
              [-74.27122962099992, -45.63591887799993],
              [-74.24937903599994, -45.63486093499995],
              [-74.22744706899994, -45.63095468499995],
              [-74.20799719999991, -45.63551197699991],
              [-74.22093665299991, -45.64918385199991],
              [-74.23009192599994, -45.66334400799991],
              [-74.24181067599994, -45.67595794099992],
              [-74.26260331899994, -45.684665622999944],
              [-74.33568274599992, -45.687758070999905],
              [-74.35879472599993, -45.69768645599993],
              [-74.33763587099992, -45.69736093499995],
              [-74.32628333199995, -45.70370859199994],
              [-74.3242895169999, -45.71379973799992],
              [-74.33092200399994, -45.724867445999905],
              [-74.34162350199995, -45.733086846999925],
              [-74.40615800699993, -45.76685963299991],
              [-74.43968665299991, -45.77695077899995],
              [-74.47044837099992, -45.77499765399995],
              [-74.49327551999994, -45.7478166649999],
              [-74.50283769399994, -45.732354424999926],
            ],
          ],
          [
            [
              [-73.66616777299993, -45.43694426899992],
              [-73.63141842399995, -45.44394296699994],
              [-73.60317949099993, -45.457696221999925],
              [-73.5860082669999, -45.48015715899993],
              [-73.58421790299991, -45.51262786299992],
              [-73.58739173099991, -45.52027760199991],
              [-73.59190833199995, -45.526462497999944],
              [-73.59605872299994, -45.53337981599992],
              [-73.59788977799991, -45.54338958099993],
              [-73.59679114499994, -45.567478122999944],
              [-73.59788977799991, -45.57480234199994],
              [-73.60651607999995, -45.5896135399999],
              [-73.61799068899995, -45.60507577899995],
              [-73.62279212099992, -45.6189104149999],
              [-73.61148027299993, -45.62932708099993],
              [-73.62905839799993, -45.635837497999944],
              [-73.64671790299991, -45.63486093499995],
              [-73.68040930899991, -45.62249114399992],
              [-73.66958574099993, -45.645603122999944],
              [-73.66315670499995, -45.65471770599993],
              [-73.65314693899995, -45.66350676899992],
              [-73.63052324099993, -45.67278411299992],
              [-73.61888587099992, -45.6794572899999],
              [-73.61148027299993, -45.69085051899992],
              [-73.61388098899994, -45.7146135399999],
              [-73.62987219999991, -45.73756275799991],
              [-73.65392005099994, -45.75269947699991],
              [-73.68040930899991, -45.75286223799992],
              [-73.69782467399995, -45.72926197699991],
              [-73.72142493399991, -45.70517343499995],
              [-73.76805579299992, -45.68027109199994],
              [-73.77599036399994, -45.673760674999926],
              [-73.78620357999995, -45.670586846999925],
              [-73.80581620999993, -45.65715911299992],
              [-73.81826738199993, -45.642510674999926],
              [-73.80703691299993, -45.63551197699991],
              [-73.74185136599993, -45.60898202899995],
              [-73.74185136599993, -45.601495049999926],
              [-73.78620357999995, -45.56991952899995],
              [-73.77090410099993, -45.511976820999905],
              [-73.72223873599995, -45.45777760199991],
              [-73.66616777299993, -45.43694426899992],
            ],
          ],
          [
            [
              [-73.88589433499993, -45.47112395599993],
              [-73.84414628799993, -45.4528947899999],
              [-73.82502193899995, -45.45208098799992],
              [-73.81696529899995, -45.47478606599992],
              [-73.82152258999992, -45.49260833099993],
              [-73.83259029899995, -45.51327890399995],
              [-73.87047278599994, -45.56170012799993],
              [-73.88589433499993, -45.56113046699994],
              [-73.89858964799993, -45.558851820999905],
              [-73.92267818899995, -45.54900481599992],
              [-73.93053137899994, -45.546807549999926],
              [-73.95616614499994, -45.53533294099992],
              [-73.98119055899991, -45.531508070999905],
              [-74.01622473899994, -45.519463799999926],
              [-74.02965247299994, -45.5173479149999],
              [-74.0606176419999, -45.519463799999926],
              [-74.07266191299993, -45.52263762799993],
              [-74.09780839799993, -45.53679778399993],
              [-74.1087133449999, -45.53997161299992],
              [-74.11424719999991, -45.54501718499995],
              [-74.12189693899995, -45.56796640399995],
              [-74.12608801999994, -45.57480234199994],
              [-74.1426488919999, -45.57496510199991],
              [-74.14500891799992, -45.55803801899992],
              [-74.13955644399994, -45.535414320999905],
              [-74.1328832669999, -45.519463799999926],
              [-74.1262914699999, -45.511976820999905],
              [-74.11961829299992, -45.50709400799991],
              [-74.11449133999992, -45.50058359199994],
              [-74.11241614499994, -45.48845794099992],
              [-74.10659745999993, -45.47185637799993],
              [-74.09292558499993, -45.45175546699994],
              [-74.07689368399991, -45.43377044099992],
              [-74.06403561099995, -45.42327239399992],
              [-74.04710852799991, -45.4216447899999],
              [-73.98940995999993, -45.4275041649999],
              [-73.97154700399994, -45.433851820999905],
              [-73.95518958199995, -45.44500090899993],
              [-73.9317113919999, -45.45761484199994],
              [-73.90664628799993, -45.46754322699991],
              [-73.88589433499993, -45.47112395599993],
            ],
          ],
          [
            [
              [-74.55435136599993, -45.546807549999926],
              [-74.57103430899991, -45.539727471999925],
              [-74.56818600199995, -45.523695570999905],
              [-74.55064856699994, -45.499118747999944],
              [-74.51976477799991, -45.44410572699991],
              [-74.49885006399995, -45.42473723799992],
              [-74.46865800699993, -45.41716887799993],
              [-74.44566809799994, -45.42815520599993],
              [-74.45494544199994, -45.45387135199991],
              [-74.49913489499994, -45.50253671699994],
              [-74.50438391799992, -45.52809010199991],
              [-74.5000707669999, -45.563571872999944],
              [-74.50133216099994, -45.58806731599992],
              [-74.52330481699994, -45.58098723799992],
              [-74.52733313699991, -45.57040780999995],
              [-74.53376217399995, -45.559258721999925],
              [-74.54279537699995, -45.55038827899995],
              [-74.55435136599993, -45.546807549999926],
            ],
          ],
          [
            [
              [-73.82445227799991, -45.39592864399992],
              [-73.83779863199993, -45.40976327899995],
              [-73.86339270699995, -45.42034270599993],
              [-73.89370683499993, -45.42742278399993],
              [-73.92174231699994, -45.43043385199991],
              [-73.98306230399993, -45.42066822699991],
              [-74.01121985599991, -45.411228122999944],
              [-74.02301998599995, -45.39267343499995],
              [-74.00894120999993, -45.380791924999926],
              [-73.97667395699995, -45.37070077899995],
              [-73.94102942599994, -45.366306247999944],
              [-73.89077714799993, -45.37664153399993],
              [-73.85582434799994, -45.371351820999905],
              [-73.82823645699995, -45.37232838299991],
              [-73.82445227799991, -45.39592864399992],
            ],
          ],
          [
            [
              [-74.34142005099994, -45.3376604149999],
              [-74.33385169199994, -45.35165780999995],
              [-74.32949785099993, -45.36614348799992],
              [-74.32339433499993, -45.37932708099993],
              [-74.31041419199994, -45.38925546699994],
              [-74.32140051999994, -45.39470794099992],
              [-74.33311926999994, -45.39902109199994],
              [-74.34532630099994, -45.40203215899993],
              [-74.35753333199995, -45.40357838299991],
              [-74.37804114499994, -45.40097421699994],
              [-74.48916581899994, -45.35507577899995],
              [-74.51081295499995, -45.338555596999925],
              [-74.52635657499991, -45.315524997999944],
              [-74.52578691299993, -45.29501718499995],
              [-74.49913489499994, -45.28606536299992],
              [-74.4290258449999, -45.279554945999905],
              [-74.38927161399994, -45.28167083099993],
              [-74.37189693899995, -45.2966447899999],
              [-74.36790930899991, -45.30396900799991],
              [-74.34142005099994, -45.3376604149999],
            ],
          ],
          [
            [
              [-73.82445227799991, -45.266289971999925],
              [-73.80968176999994, -45.27939218499995],
              [-73.79214433499993, -45.30234140399995],
              [-73.78123938699991, -45.324151299999926],
              [-73.78624426999994, -45.333916924999926],
              [-73.81476803299995, -45.34539153399993],
              [-73.82787024599992, -45.347588799999926],
              [-73.98005123599995, -45.3493791649999],
              [-73.99632727799991, -45.35279713299991],
              [-74.01227779899995, -45.35361093499995],
              [-74.07144120999993, -45.333916924999926],
              [-74.11851966099994, -45.32830169099992],
              [-74.12950598899994, -45.3239885399999],
              [-74.13914954299992, -45.3122697899999],
              [-74.15196692599994, -45.29265715899993],
              [-74.16291256399995, -45.27092864399992],
              [-74.16706295499995, -45.252618096999925],
              [-74.15807044199994, -45.23552825299993],
              [-74.13857988199993, -45.22869231599992],
              [-74.11522376199991, -45.22421640399995],
              [-74.0703832669999, -45.20427825299993],
              [-74.05431067599994, -45.21453215899993],
              [-74.02989661399994, -45.252618096999925],
              [-73.98607337099992, -45.27076588299991],
              [-73.87279212099992, -45.260837497999944],
              [-73.82445227799991, -45.266289971999925],
            ],
          ],
          [
            [
              [-74.27354895699995, -45.20794036299992],
              [-74.27086341099994, -45.215915622999944],
              [-74.27684485599991, -45.220635674999926],
              [-74.28990637899994, -45.225274346999925],
              [-74.29914303299995, -45.27239348799992],
              [-74.30748450399994, -45.29452890399995],
              [-74.32534745999993, -45.30234140399995],
              [-74.33849036399994, -45.2985979149999],
              [-74.39317786399994, -45.268243096999925],
              [-74.40550696499992, -45.258884372999944],
              [-74.41510982999995, -45.24700286299992],
              [-74.42027747299994, -45.23211028399993],
              [-74.41966712099992, -45.19980234199994],
              [-74.40831458199995, -45.17197030999995],
              [-74.38756262899994, -45.15520598799992],
              [-74.35879472599993, -45.15642669099992],
              [-74.34316972599993, -45.16480885199991],
              [-74.30357825399994, -45.19801197699991],
              [-74.29649817599994, -45.20077890399995],
              [-74.27969316299993, -45.20427825299993],
              [-74.27354895699995, -45.20794036299992],
            ],
          ],
          [
            [
              [-73.73192298099991, -45.214776299999926],
              [-73.74217688699991, -45.23560963299991],
              [-73.73184160099993, -45.26726653399993],
              [-73.74185136599993, -45.279961846999925],
              [-73.76797441299993, -45.28460051899992],
              [-73.78986568899995, -45.27353280999995],
              [-73.80968176999994, -45.25644296699994],
              [-73.8301488919999, -45.24309661299992],
              [-73.84284420499995, -45.23967864399992],
              [-73.86961829299992, -45.238213799999926],
              [-73.96251380099994, -45.249118747999944],
              [-73.9895727199999, -45.24578215899993],
              [-74.00739498599995, -45.23211028399993],
              [-74.02696692599994, -45.192071221999925],
              [-74.03978430899991, -45.18368905999995],
              [-74.05801347599993, -45.17506275799991],
              [-74.08409583199995, -45.14006926899992],
              [-74.10496985599991, -45.13591887799993],
              [-74.1113988919999, -45.14120859199994],
              [-74.11579342399995, -45.150323174999926],
              [-74.12169348899994, -45.15911223799992],
              [-74.1328832669999, -45.16326262799993],
              [-74.14362545499995, -45.15740325299993],
              [-74.15721594999991, -45.14666106599992],
              [-74.16893469999991, -45.141696872999944],
              [-74.1738988919999, -45.153008721999925],
              [-74.18358313699991, -45.16952890399995],
              [-74.20547441299993, -45.16936614399992],
              [-74.22866777299993, -45.160088799999926],
              [-74.24217688699991, -45.14959075299993],
              [-74.25011145699995, -45.109633070999905],
              [-74.23542232999995, -45.07236093499995],
              [-74.20693925699993, -45.04265715899993],
              [-74.1738988919999, -45.026055596999925],
              [-74.14940344999991, -45.02361419099992],
              [-74.07457434799994, -45.033461195999905],
              [-74.06330318899995, -45.03134530999995],
              [-74.0442602199999, -45.02157968499995],
              [-74.03294837099992, -45.01921965899993],
              [-73.98916581899994, -45.02068450299993],
              [-73.97524980399993, -45.01921965899993],
              [-73.95392818899995, -45.01246510199991],
              [-73.91470292899993, -44.99529387799993],
              [-73.88931230399993, -44.99187590899993],
              [-73.86607825399994, -44.99456145599993],
              [-73.84557044199994, -45.00123463299991],
              [-73.77814693899995, -45.03875090899993],
              [-73.76984615799995, -45.04656340899993],
              [-73.75959225199995, -45.06210702899995],
              [-73.76073157499991, -45.06804778399993],
              [-73.76642818899995, -45.070977471999925],
              [-73.76984615799995, -45.07756926899992],
              [-73.75991777299993, -45.085870049999926],
              [-73.73786373599995, -45.09775155999995],
              [-73.71458899599992, -45.11419036299992],
              [-73.70152747299994, -45.13591887799993],
              [-73.70079505099994, -45.16057708099993],
              [-73.70689856699994, -45.18132903399993],
              [-73.71788489499994, -45.199151299999926],
              [-73.73192298099991, -45.214776299999926],
            ],
          ],
          [
            [
              [-74.27009029899995, -44.94410572699991],
              [-74.25332597599993, -44.932305596999925],
              [-74.21141516799992, -44.885837497999944],
              [-74.18830318899995, -44.869073174999926],
              [-74.16372636599993, -44.86467864399992],
              [-74.13833574099993, -44.868259372999944],
              [-74.04198157499991, -44.89381275799991],
              [-73.98664303299995, -44.89771900799991],
              [-73.96959387899994, -44.90398528399993],
              [-73.94050045499995, -44.92986419099992],
              [-73.91665605399993, -44.944431247999944],
              [-73.91319739499994, -44.95037200299993],
              [-73.91783606699994, -44.95647551899992],
              [-73.93809973899994, -44.96917083099993],
              [-73.94391842399995, -44.97144947699991],
              [-73.95494544199994, -44.973728122999944],
              [-73.97565670499995, -44.98300546699994],
              [-73.98574785099993, -44.98512135199991],
              [-73.99762936099995, -44.983086846999925],
              [-74.02399654899995, -44.97405364399992],
              [-74.04320227799991, -44.97014739399992],
              [-74.05614173099991, -44.96559010199991],
              [-74.06403561099995, -44.96404387799993],
              [-74.06017005099994, -44.97234465899993],
              [-74.05394446499992, -44.979180596999925],
              [-74.03604081899994, -44.99187590899993],
              [-74.06578528599994, -44.99879322699991],
              [-74.18748938699991, -44.99187590899993],
              [-74.21670488199993, -45.00204843499995],
              [-74.24840247299994, -45.01767343499995],
              [-74.28014075399994, -45.02743905999995],
              [-74.30955969999991, -45.01962655999995],
              [-74.33629309799994, -45.01881275799991],
              [-74.35692298099991, -45.0114885399999],
              [-74.36359615799995, -44.99724700299993],
              [-74.34825598899994, -44.974867445999905],
              [-74.33128821499992, -44.96453215899993],
              [-74.27009029899995, -44.94410572699991],
            ],
          ],
          [
            [
              [-73.96157792899993, -44.81015390399995],
              [-73.97374426999994, -44.83456796699994],
              [-74.00328528599994, -44.84775155999995],
              [-74.03929602799991, -44.85312265399995],
              [-74.07144120999993, -44.854180596999925],
              [-74.09727942599994, -44.8415666649999],
              [-74.17625891799992, -44.81845468499995],
              [-74.18748938699991, -44.80632903399993],
              [-74.16633053299995, -44.800713799999926],
              [-74.03864498599995, -44.78337981599992],
              [-74.00991777299993, -44.7732072899999],
              [-73.99571692599994, -44.772149346999925],
              [-73.97329667899993, -44.775648695999905],
              [-73.96349036399994, -44.78053150799991],
              [-73.96125240799995, -44.79070403399993],
              [-73.96157792899993, -44.81015390399995],
            ],
          ],
          [
            [
              [-73.93053137899994, -44.78923919099992],
              [-73.91051184799994, -44.77499765399995],
              [-73.8977758449999, -44.768649997999944],
              [-73.88589433499993, -44.7653947899999],
              [-73.85448157499991, -44.76873137799993],
              [-73.83678137899994, -44.78411223799992],
              [-73.81696529899995, -44.834242445999905],
              [-73.76231848899994, -44.92986419099992],
              [-73.77867591099994, -44.946384372999944],
              [-73.79458574099993, -44.9568010399999],
              [-73.81371008999992, -44.960870049999926],
              [-73.83967037699995, -44.95859140399995],
              [-73.88320878799993, -44.92815520599993],
              [-73.92369544199994, -44.89267343499995],
              [-73.92886308499993, -44.88103606599992],
              [-73.93028723899994, -44.865166924999926],
              [-73.92674719999991, -44.85442473799992],
              [-73.91690019399994, -44.85784270599993],
              [-73.88988196499992, -44.882745049999926],
              [-73.87535559799994, -44.89104583099993],
              [-73.85789954299992, -44.89568450299993],
              [-73.86876380099994, -44.88827890399995],
              [-73.87767493399991, -44.878024997999944],
              [-73.88365637899994, -44.86728280999995],
              [-73.8887426419999, -44.84384530999995],
              [-73.89647376199991, -44.83757903399993],
              [-73.90758216099994, -44.833916924999926],
              [-73.92064368399991, -44.82740650799991],
              [-73.93089758999992, -44.820570570999905],
              [-73.93911699099993, -44.81292083099993],
              [-73.94058183499993, -44.80291106599992],
              [-73.93053137899994, -44.78923919099992],
            ],
          ],
          [
            [
              [-75.09147325499993, -44.79605605599994],
              [-75.06328310099991, -44.83090345699992],
              [-75.02173439899991, -44.843664722999904],
              [-75.02647063199993, -44.85304619099992],
              [-75.04250521699993, -44.87043797599995],
              [-75.03503483499992, -44.88989378799994],
              [-75.0312720629999, -44.90396927099994],
              [-75.05114545099991, -44.9059650019999],
              [-75.06916256399995, -44.92009856599992],
              [-75.08519446499992, -44.92343515399995],
              [-75.10981686899993, -44.92597822199991],
              [-75.13061157899995, -44.92593727399992],
              [-75.15235794499995, -44.921213887999954],
              [-75.1646665419999, -44.913835401999904],
              [-75.1589139859999, -44.90512386899991],
              [-75.14833457499992, -44.89037733299995],
              [-75.14635149899993, -44.87832337399993],
              [-75.15485617299993, -44.86492926099993],
              [-75.18512868999994, -44.838762877999955],
              [-75.20021264199994, -44.816615131999924],
              [-75.19832239499993, -44.8072324229999],
              [-75.17460927399992, -44.78315836899992],
              [-75.14718188599994, -44.76376652599993],
              [-75.11317938199994, -44.76651821599995],
              [-75.09998328699993, -44.77659055799995],
              [-75.09147325499993, -44.79605605599994],
            ],
          ],
          [
            [
              [-73.60472571499992, -44.74488697699991],
              [-73.60488847599993, -44.758070570999905],
              [-73.62230383999992, -44.78020598799992],
              [-73.62205969999991, -44.78923919099992],
              [-73.61339270699995, -44.81267669099992],
              [-73.62730872299994, -44.82976653399993],
              [-73.6524145169999, -44.83912525799991],
              [-73.67731686099995, -44.84026458099993],
              [-73.70128333199995, -44.8337541649999],
              [-73.72826087099992, -44.82105885199991],
              [-73.74925696499992, -44.80282968499995],
              [-73.75552324099993, -44.779554945999905],
              [-73.74168860599991, -44.75465260199991],
              [-73.71776282499991, -44.7517229149999],
              [-73.68960527299993, -44.75318775799991],
              [-73.66307532499991, -44.74187590899993],
              [-73.65025794199994, -44.73447030999995],
              [-73.63304602799991, -44.731540622999944],
              [-73.61628170499995, -44.734307549999926],
              [-73.60472571499992, -44.74488697699991],
            ],
          ],
          [
            [
              [-74.34142005099994, -44.80632903399993],
              [-74.33169511599993, -44.81292083099993],
              [-74.31786048099991, -44.82708098799992],
              [-74.31236731699994, -44.84140390399995],
              [-74.32778886599993, -44.847914320999905],
              [-74.39354407499991, -44.85702890399995],
              [-74.41030839799993, -44.85100676899992],
              [-74.42369544199994, -44.84303150799991],
              [-74.45588131399995, -44.835056247999944],
              [-74.46939042899993, -44.826836846999925],
              [-74.47484290299991, -44.81959400799991],
              [-74.48843339799993, -44.79452890399995],
              [-74.52505449099993, -44.75400155999995],
              [-74.52774003799993, -44.743259372999944],
              [-74.52285722599993, -44.73357512799993],
              [-74.50963294199994, -44.72503020599993],
              [-74.49083411399994, -44.71965911299992],
              [-74.46556555899991, -44.71624114399992],
              [-74.44172115799995, -44.71542734199994],
              [-74.42711341099994, -44.71819426899992],
              [-74.41893469999991, -44.72909921699994],
              [-74.41266842399995, -44.7458635399999],
              [-74.40868079299992, -44.76327890399995],
              [-74.40721594999991, -44.77597421699994],
              [-74.39879309799994, -44.78769296699994],
              [-74.37922115799995, -44.79729583099993],
              [-74.35716712099992, -44.80388762799993],
              [-74.34142005099994, -44.80632903399993],
            ],
          ],
          [
            [
              [-74.48232988199993, -44.63632577899995],
              [-74.46930904899995, -44.63909270599993],
              [-74.46068274599992, -44.64706796699994],
              [-74.45592200399994, -44.65878671699994],
              [-74.4544164699999, -44.67351653399993],
              [-74.45836341099994, -44.69003671699994],
              [-74.46898352799991, -44.697198174999926],
              [-74.48436438699991, -44.69841887799993],
              [-74.56712805899991, -44.69304778399993],
              [-74.59325110599991, -44.68222421699994],
              [-74.6087133449999, -44.68401458099993],
              [-74.62474524599992, -44.68808359199994],
              [-74.6387426419999, -44.689385674999926],
              [-74.65225175699993, -44.686211846999925],
              [-74.66348222599993, -44.679945570999905],
              [-74.66950436099995, -44.670179945999905],
              [-74.66734778599994, -44.656182549999926],
              [-74.66095943899995, -44.65374114399992],
              [-74.62800045499995, -44.62818775799991],
              [-74.62267005099994, -44.62200286299992],
              [-74.57013912699995, -44.62004973799992],
              [-74.55064856699994, -44.62200286299992],
              [-74.49819902299993, -44.63445403399993],
              [-74.48232988199993, -44.63632577899995],
            ],
          ],
          [
            [
              [-73.92682857999995, -44.628838799999926],
              [-73.89313717399995, -44.66033294099992],
              [-73.87755286399994, -44.68059661299992],
              [-73.87588456899994, -44.694024346999925],
              [-73.96776282499991, -44.70452239399992],
              [-74.01183020699995, -44.71648528399993],
              [-74.09316972599993, -44.75335051899992],
              [-74.19566809799994, -44.778415622999944],
              [-74.24730383999992, -44.80120208099993],
              [-74.25869706899994, -44.8044572899999],
              [-74.26935787699995, -44.805352471999925],
              [-74.27969316299993, -44.803806247999944],
              [-74.32046464799993, -44.78980885199991],
              [-74.33958899599992, -44.779229424999926],
              [-74.35602779899995, -44.76506926899992],
              [-74.36876380099994, -44.74749114399992],
              [-74.37287350199995, -44.725274346999925],
              [-74.36082923099991, -44.71331145599993],
              [-74.34007727799991, -44.70907968499995],
              [-74.31786048099991, -44.71013762799993],
              [-74.31786048099991, -44.70452239399992],
              [-74.33551998599995, -44.7048479149999],
              [-74.40697180899991, -44.69426848799992],
              [-74.41380774599992, -44.68596770599993],
              [-74.41344153599994, -44.65276458099993],
              [-74.40054277299993, -44.626071872999944],
              [-74.36945553299995, -44.62127044099992],
              [-74.29735266799992, -44.628838799999926],
              [-74.30679277299993, -44.61638762799993],
              [-74.29214433499993, -44.60800546699994],
              [-74.26716061099995, -44.60312265399995],
              [-74.02562415299991, -44.60312265399995],
              [-73.97134355399993, -44.61101653399993],
              [-73.92682857999995, -44.628838799999926],
            ],
          ],
          [
            [
              [-74.77721106699994, -44.581149997999944],
              [-74.7415258449999, -44.57236093499995],
              [-74.73253333199995, -44.59319426899992],
              [-74.73908443899995, -44.62664153399993],
              [-74.74986731699994, -44.656182549999926],
              [-74.74779212099992, -44.66562265399995],
              [-74.76402747299994, -44.67327239399992],
              [-74.78673255099994, -44.676853122999944],
              [-74.80386308499993, -44.673760674999926],
              [-74.81891842399995, -44.65569426899992],
              [-74.82583574099993, -44.63095468499995],
              [-74.82705644399994, -44.60442473799992],
              [-74.82494055899991, -44.581149997999944],
              [-74.81484941299993, -44.558526299999926],
              [-74.79824785099993, -44.548760674999926],
              [-74.78302975199995, -44.55510833099993],
              [-74.77721106699994, -44.581149997999944],
            ],
          ],
          [
            [
              [-73.65998287699995, -44.67652760199991],
              [-73.64053300699993, -44.67701588299991],
              [-73.62661699099993, -44.67522551899992],
              [-73.61465410099993, -44.676853122999944],
              [-73.60130774599992, -44.68718840899993],
              [-73.59154212099992, -44.70671965899993],
              [-73.60293535099993, -44.71575286299992],
              [-73.62466386599993, -44.71819426899992],
              [-73.64598548099991, -44.71819426899992],
              [-73.71324622299994, -44.73707447699991],
              [-73.75251217399995, -44.74138762799993],
              [-73.76984615799995, -44.72503020599993],
              [-73.78709876199991, -44.703789971999925],
              [-73.83788001199991, -44.664320570999905],
              [-73.84430904899995, -44.65252044099992],
              [-73.83120683499993, -44.642510674999926],
              [-73.82070878799993, -44.653415622999944],
              [-73.8164770169999, -44.637383721999925],
              [-73.81696529899995, -44.61370208099993],
              [-73.82070878799993, -44.601495049999926],
              [-73.82705644399994, -44.594414971999925],
              [-73.82140051999994, -44.57870859199994],
              [-73.80939693899995, -44.56218840899993],
              [-73.79649817599994, -44.55315520599993],
              [-73.77676347599993, -44.55169036299992],
              [-73.7551977199999, -44.55282968499995],
              [-73.73452714799993, -44.55169036299992],
              [-73.71800696499992, -44.54355234199994],
              [-73.69953365799995, -44.53679778399993],
              [-73.67992102799991, -44.544854424999926],
              [-73.66315670499995, -44.559665622999944],
              [-73.65314693899995, -44.57366301899992],
              [-73.67357337099992, -44.57366301899992],
              [-73.66323808499993, -44.586602471999925],
              [-73.63337154899995, -44.608086846999925],
              [-73.62515214799993, -44.62200286299992],
              [-73.62686113199993, -44.640557549999926],
              [-73.6367895169999, -44.65374114399992],
              [-73.64952551999994, -44.66464609199994],
              [-73.65998287699995, -44.67652760199991],
            ],
          ],
          [
            [
              [-74.19371497299994, -44.49228280999995],
              [-74.17686926999994, -44.503838799999926],
              [-74.1543676419999, -44.538995049999926],
              [-74.1328832669999, -44.54697030999995],
              [-74.15420488199993, -44.55974700299993],
              [-74.24893144399994, -44.566664320999905],
              [-74.30089270699995, -44.57781340899993],
              [-74.32632402299993, -44.57968515399995],
              [-74.34455318899995, -44.57366301899992],
              [-74.35822506399995, -44.55917734199994],
              [-74.36888587099992, -44.54111093499995],
              [-74.36839758999992, -44.52556731599992],
              [-74.32843990799995, -44.514743747999944],
              [-74.29434160099993, -44.49944426899992],
              [-74.25438391799992, -44.50595468499995],
              [-74.21202551999994, -44.49342213299991],
              [-74.19371497299994, -44.49228280999995],
            ],
          ],
          [
            [
              [-74.03604081899994, -44.49846770599993],
              [-74.05894934799994, -44.47600676899992],
              [-74.14366614499994, -44.458103122999944],
              [-74.16706295499995, -44.43027109199994],
              [-74.15404212099992, -44.43254973799992],
              [-74.14488684799994, -44.43824635199991],
              [-74.13658606699994, -44.44500090899993],
              [-74.12608801999994, -44.45061614399992],
              [-74.11388098899994, -44.453383070999905],
              [-74.01622473899994, -44.4568010399999],
              [-74.00475012899994, -44.460056247999944],
              [-73.98216712099992, -44.46917083099993],
              [-73.97154700399994, -44.47128671699994],
              [-73.95742753799993, -44.47926197699991],
              [-73.95030676999994, -44.49895598799992],
              [-73.9473363919999, -44.54355234199994],
              [-73.95962480399993, -44.551446221999925],
              [-73.98839270699995, -44.55413176899992],
              [-74.04588782499991, -44.55315520599993],
              [-74.07066809799994, -44.55201588299991],
              [-74.1016332669999, -44.54550546699994],
              [-74.12645423099991, -44.534274997999944],
              [-74.1328832669999, -44.51897551899992],
              [-74.11815344999991, -44.511651299999926],
              [-74.03604081899994, -44.49846770599993],
            ],
          ],
          [
            [
              [-74.39297441299993, -44.54697030999995],
              [-74.42100989499994, -44.5466447899999],
              [-74.49400794199994, -44.53590260199991],
              [-74.52330481699994, -44.526462497999944],
              [-74.54059811099995, -44.50204843499995],
              [-74.54771887899994, -44.47665780999995],
              [-74.54112708199995, -44.453789971999925],
              [-74.51707923099991, -44.43710702899995],
              [-74.50304114499994, -44.43450286299992],
              [-74.4387914699999, -44.43914153399993],
              [-74.43004309799994, -44.445570570999905],
              [-74.42516028599994, -44.45631275799991],
              [-74.42027747299994, -44.47128671699994],
              [-74.36558997299994, -44.41139088299991],
              [-74.34825598899994, -44.402276299999926],
              [-74.32111568899995, -44.39544036299992],
              [-74.30638587099992, -44.39373137799993],
              [-74.28551184799994, -44.40309010199991],
              [-74.26813717399995, -44.40642669099992],
              [-74.25951087099992, -44.41285572699991],
              [-74.23900305899991, -44.440118096999925],
              [-74.22305253799993, -44.46738046699994],
              [-74.24014238199993, -44.47812265399995],
              [-74.30357825399994, -44.48479583099993],
              [-74.35680091099994, -44.499118747999944],
              [-74.42027747299994, -44.50530364399992],
              [-74.41071529899995, -44.514336846999925],
              [-74.40265865799995, -44.524509372999944],
              [-74.39659583199995, -44.53525155999995],
              [-74.39297441299993, -44.54697030999995],
            ],
          ],
          [
            [
              [-73.78966223899994, -44.42278411299992],
              [-73.78294837099992, -44.44304778399993],
              [-73.79718990799995, -44.45452239399992],
              [-73.82046464799993, -44.46054452899995],
              [-73.86701412699995, -44.46607838299991],
              [-73.88853919199994, -44.46013762799993],
              [-73.90412350199995, -44.44491952899995],
              [-73.91193600199995, -44.41936614399992],
              [-73.91095943899995, -44.396742445999905],
              [-73.90282141799992, -44.37835051899992],
              [-73.88768469999991, -44.36923593499995],
              [-73.86538652299993, -44.374932549999926],
              [-73.85362708199995, -44.38534921699994],
              [-73.8469945949999, -44.40447356599992],
              [-73.83804277299993, -44.41285572699991],
              [-73.82494055899991, -44.41659921699994],
              [-73.79893958199995, -44.41757577899995],
              [-73.78966223899994, -44.42278411299992],
            ],
          ],
          [
            [
              [-73.38247636599993, -44.587823174999926],
              [-73.37559973899994, -44.59148528399993],
              [-73.3594457669999, -44.60881926899992],
              [-73.35142981699994, -44.615166924999926],
              [-73.31895911399994, -44.60295989399992],
              [-73.31045488199993, -44.601495049999926],
              [-73.29743404899995, -44.606133721999925],
              [-73.27061926999994, -44.62468840899993],
              [-73.25104732999995, -44.631931247999944],
              [-73.24644934799994, -44.63730234199994],
              [-73.24120032499991, -44.639336846999925],
              [-73.23167883999992, -44.6325822899999],
              [-73.22618567599994, -44.62053801899992],
              [-73.23338782499991, -44.61256275799991],
              [-73.25523841099994, -44.601495049999926],
              [-73.26744544199994, -44.58603280999995],
              [-73.27965247299994, -44.56292083099993],
              [-73.28050696499992, -44.54176197699991],
              [-73.25865637899994, -44.53264739399992],
              [-73.23672441299993, -44.53557708099993],
              [-73.15916907499991, -44.57040780999995],
              [-73.14899654899995, -44.57170989399992],
              [-73.13914954299992, -44.566664320999905],
              [-73.13243567599994, -44.55632903399993],
              [-73.13158118399991, -44.545179945999905],
              [-73.13695227799991, -44.53630950299993],
              [-73.14907792899993, -44.53264739399992],
              [-73.17275956899994, -44.53093840899993],
              [-73.22386633999992, -44.51995208099993],
              [-73.24156653599994, -44.51213958099993],
              [-73.26121985599991, -44.477227471999925],
              [-73.24624589799993, -44.43718840899993],
              [-73.21031653599994, -44.408868096999925],
              [-73.16710364499994, -44.40911223799992],
              [-73.16100012899994, -44.41497161299992],
              [-73.1465551419999, -44.43564218499995],
              [-73.13914954299992, -44.443291924999926],
              [-73.13841712099992, -44.43873463299991],
              [-73.13683020699995, -44.43613046699994],
              [-73.13451087099992, -44.433851820999905],
              [-73.12267005099994, -44.43434010199991],
              [-73.11115475199995, -44.43254973799992],
              [-73.09996497299994, -44.427666924999926],
              [-73.08458411399994, -44.43027109199994],
              [-73.07209225199995, -44.44068775799991],
              [-73.05040442599994, -44.47144947699991],
              [-73.03620357999995, -44.48479583099993],
              [-73.04820716099994, -44.44548919099992],
              [-73.04979407499991, -44.43368905999995],
              [-73.05479895699995, -44.418633721999925],
              [-73.06651770699995, -44.41521575299993],
              [-73.08018958199995, -44.41301848799992],
              [-73.09080969999991, -44.402276299999926],
              [-73.08381100199995, -44.3845354149999],
              [-73.02049719999991, -44.374118747999944],
              [-73.0020238919999, -44.361260674999926],
              [-72.97923743399991, -44.37444426899992],
              [-72.95352128799993, -44.394463799999926],
              [-72.93321692599994, -44.41692473799992],
              [-72.92625891799992, -44.43710702899995],
              [-72.93390865799995, -44.4509416649999],
              [-72.98094641799992, -44.51213958099993],
              [-72.95555579299992, -44.513604424999926],
              [-72.90583248599995, -44.45273202899995],
              [-72.87230383999992, -44.43710702899995],
              [-72.85167395699995, -44.44036223799992],
              [-72.80972245999993, -44.45387135199991],
              [-72.78628495999993, -44.4568010399999],
              [-72.76891028599994, -44.4665666649999],
              [-72.74657141799992, -44.50920989399992],
              [-72.73106848899994, -44.51897551899992],
              [-72.72118079299992, -44.528008721999925],
              [-72.72984778599994, -44.54843515399995],
              [-72.74518795499995, -44.56951262799993],
              [-72.80113684799994, -44.628838799999926],
              [-72.81334387899994, -44.63632577899995],
              [-72.90078691299993, -44.63095468499995],
              [-72.94127356699994, -44.62037525799991],
              [-72.98094641799992, -44.601495049999926],
              [-72.97744706899994, -44.62232838299991],
              [-72.96255449099993, -44.63290780999995],
              [-72.94237219999991, -44.6403947899999],
              [-72.92292232999995, -44.65276458099993],
              [-72.90233313699991, -44.66155364399992],
              [-72.84740149599992, -44.66757577899995],
              [-72.83128821499992, -44.67652760199991],
              [-72.83763587099992, -44.71013762799993],
              [-72.87677975199995, -44.74138762799993],
              [-72.96816972599993, -44.78769296699994],
              [-73.00755774599992, -44.81324635199991],
              [-73.01561438699991, -44.82366301899992],
              [-73.02000891799992, -44.82781340899993],
              [-73.02965247299994, -44.83049895599993],
              [-73.03921464799993, -44.835056247999944],
              [-73.04698645699995, -44.85100676899992],
              [-73.05483964799993, -44.858086846999925],
              [-73.14745032499991, -44.9118791649999],
              [-73.19005286399994, -44.92742278399993],
              [-73.25698808499993, -44.94003671699994],
              [-73.27578691299993, -44.939385674999926],
              [-73.29141191299993, -44.93238697699991],
              [-73.30304928299995, -44.91619231599992],
              [-73.36510169199994, -44.86842213299991],
              [-73.39313717399995, -44.84140390399995],
              [-73.40758216099994, -44.82244231599992],
              [-73.40298417899993, -44.81373463299991],
              [-73.35997473899994, -44.81503671699994],
              [-73.34459387899994, -44.81023528399993],
              [-73.32725989499994, -44.79648202899995],
              [-73.30748450399994, -44.78590260199991],
              [-73.28844153599994, -44.78980885199991],
              [-73.25523841099994, -44.81373463299991],
              [-73.24388587099992, -44.80901458099993],
              [-73.21963456899994, -44.80413176899992],
              [-73.20742753799993, -44.80006275799991],
              [-73.20742753799993, -44.79265715899993],
              [-73.21825110599991, -44.79045989399992],
              [-73.29963131399995, -44.75855885199991],
              [-73.30654863199993, -44.76132577899995],
              [-73.33775794199994, -44.779554945999905],
              [-73.35875403599994, -44.788995049999926],
              [-73.36937415299991, -44.791680596999925],
              [-73.38247636599993, -44.79265715899993],
              [-73.39342200399994, -44.78866952899995],
              [-73.40074622299994, -44.77890390399995],
              [-73.40477454299992, -44.76653411299992],
              [-73.40607662699995, -44.75514088299991],
              [-73.40941321499992, -44.74651458099993],
              [-73.43342037699995, -44.72503020599993],
              [-73.44261633999992, -44.7068010399999],
              [-73.45567786399994, -44.66171640399995],
              [-73.46812903599994, -44.642510674999926],
              [-73.42715410099993, -44.60100676899992],
              [-73.41661536399994, -44.59465911299992],
              [-73.40721594999991, -44.5935197899999],
              [-73.39126542899993, -44.588962497999944],
              [-73.38247636599993, -44.587823174999926],
            ],
          ],
          [
            [
              [-73.72647050699993, -44.42506275799991],
              [-73.78966223899994, -44.38241952899995],
              [-73.74596106699994, -44.36370208099993],
              [-73.73192298099991, -44.361260674999926],
              [-73.69782467399995, -44.361260674999926],
              [-73.69017493399991, -44.35898202899995],
              [-73.68211829299992, -44.34889088299991],
              [-73.67357337099992, -44.34693775799991],
              [-73.65412350199995, -44.35084400799991],
              [-73.65135657499991, -44.35881926899992],
              [-73.6563207669999, -44.37037525799991],
              [-73.65998287699995, -44.38551197699991],
              [-73.66942298099991, -44.3884416649999],
              [-73.72883053299995, -44.388604424999926],
              [-73.69668535099993, -44.3982072899999],
              [-73.68053137899994, -44.40748463299991],
              [-73.67357337099992, -44.41961028399993],
              [-73.67870032499991, -44.43450286299992],
              [-73.69151770699995, -44.43792083099993],
              [-73.70864824099993, -44.433526299999926],
              [-73.72647050699993, -44.42506275799991],
            ],
          ],
          [
            [
              [-74.02989661399994, -44.354587497999944],
              [-74.00218665299991, -44.35621510199991],
              [-73.95055091099994, -44.34856536299992],
              [-73.92682857999995, -44.354587497999944],
              [-73.93464107999995, -44.379164320999905],
              [-73.92886308499993, -44.43124765399995],
              [-73.94050045499995, -44.45061614399992],
              [-73.98802649599992, -44.419040622999944],
              [-74.00633704299992, -44.41301848799992],
              [-74.03111731699994, -44.40935637799993],
              [-74.04295813699991, -44.40569426899992],
              [-74.06322180899991, -44.39218515399995],
              [-74.08153235599991, -44.38396575299993],
              [-74.09068762899994, -44.374932549999926],
              [-74.09618079299992, -44.36492278399993],
              [-74.10586503799993, -44.338962497999944],
              [-74.11241614499994, -44.327243747999944],
              [-74.09142005099994, -44.320245049999926],
              [-74.07054602799991, -44.329196872999944],
              [-74.05003821499992, -44.34384530999995],
              [-74.02989661399994, -44.354587497999944],
            ],
          ],
          [
            [
              [-73.26280676999994, -44.3884416649999],
              [-73.28319251199991, -44.381524346999925],
              [-73.29849199099993, -44.36809661299992],
              [-73.30272376199991, -44.34970468499995],
              [-73.29002844999991, -44.327243747999944],
              [-73.28270423099991, -44.32195403399993],
              [-73.25804602799991, -44.30917734199994],
              [-73.24901282499991, -44.30673593499995],
              [-73.24400794199994, -44.3103166649999],
              [-73.21450761599993, -44.3239885399999],
              [-73.21056067599994, -44.32382577899995],
              [-73.17715410099993, -44.36777109199994],
              [-73.17674719999991, -44.374932549999926],
              [-73.26280676999994, -44.3884416649999],
            ],
          ],
          [
            [
              [-73.86538652299993, -44.33407968499995],
              [-73.89614824099993, -44.33473072699991],
              [-73.93248450399994, -44.32854583099993],
              [-73.96263587099992, -44.31389739399992],
              [-73.97524980399993, -44.28964609199994],
              [-73.96288001199991, -44.28378671699994],
              [-73.87970943899995, -44.29924895599993],
              [-73.85106360599991, -44.29631926899992],
              [-73.84121660099993, -44.28980885199991],
              [-73.83739173099991, -44.275648695999905],
              [-73.83470618399991, -44.271742445999905],
              [-73.8281957669999, -44.26832447699991],
              [-73.82042395699995, -44.26604583099993],
              [-73.81383216099994, -44.26506926899992],
              [-73.80565344999991, -44.26637135199991],
              [-73.80382239499994, -44.27011484199994],
              [-73.80345618399991, -44.27556731599992],
              [-73.78905188699991, -44.30950286299992],
              [-73.80748450399994, -44.32512786299992],
              [-73.83849036399994, -44.332289320999905],
              [-73.86538652299993, -44.33407968499995],
            ],
          ],
          [
            [
              [-74.38662675699993, -44.249932549999926],
              [-74.3665258449999, -44.246758721999925],
              [-74.34390214799993, -44.24618905999995],
              [-74.32201087099992, -44.24944426899992],
              [-74.30357825399994, -44.25823333099993],
              [-74.29133053299995, -44.27678801899992],
              [-74.29002844999991, -44.29729583099993],
              [-74.2981664699999, -44.30950286299992],
              [-74.31411699099993, -44.302992445999905],
              [-74.33844967399995, -44.29631926899992],
              [-74.37706458199995, -44.29257577899995],
              [-74.40990149599992, -44.28443775799991],
              [-74.41685950399994, -44.26490650799991],
              [-74.41152910099993, -44.25855885199991],
              [-74.40347245999993, -44.25448984199994],
              [-74.38662675699993, -44.249932549999926],
            ],
          ],
          [
            [
              [-73.74185136599993, -44.26506926899992],
              [-73.69835364499994, -44.24187590899993],
              [-73.67568925699993, -44.241306247999944],
              [-73.66616777299993, -44.26506926899992],
              [-73.67536373599995, -44.27792734199994],
              [-73.69688880099994, -44.29314544099992],
              [-73.72203528599994, -44.30282968499995],
              [-73.74185136599993, -44.29924895599993],
              [-73.75739498599995, -44.28240325299993],
              [-73.75967363199993, -44.26287200299993],
              [-73.75316321499992, -44.25286223799992],
              [-73.74185136599993, -44.26506926899992],
            ],
          ],
          [
            [
              [-74.1087133449999, -44.22747161299992],
              [-74.1262914699999, -44.200290622999944],
              [-74.11050370999993, -44.18914153399993],
              [-74.07909094999991, -44.18962981599992],
              [-74.04971269399994, -44.19687265399995],
              [-74.04971269399994, -44.19003671699994],
              [-74.0579320949999, -44.18254973799992],
              [-74.06818600199995, -44.16855234199994],
              [-74.07286536399994, -44.15504322699991],
              [-74.06432044199994, -44.14902109199994],
              [-74.04898027299993, -44.15292734199994],
              [-74.03636633999992, -44.16228606599992],
              [-73.99608313699991, -44.201429945999905],
              [-73.98420162699995, -44.20794036299992],
              [-73.91515051999994, -44.21526458099993],
              [-73.90294348899994, -44.22079843499995],
              [-73.89362545499995, -44.239353122999944],
              [-73.91417395699995, -44.24236419099992],
              [-73.94627844999991, -44.24138762799993],
              [-73.97154700399994, -44.24814218499995],
              [-73.98485266799992, -44.25400155999995],
              [-73.99815833199995, -44.25400155999995],
              [-74.00934811099995, -44.25725676899992],
              [-74.01622473899994, -44.272556247999944],
              [-74.01382402299993, -44.28525155999995],
              [-73.9895727199999, -44.327243747999944],
              [-74.01793372299994, -44.32773202899995],
              [-74.03140214799993, -44.32586028399993],
              [-74.04352779899995, -44.32040780999995],
              [-74.09439042899993, -44.28240325299993],
              [-74.10065670499995, -44.26970794099992],
              [-74.10216223899994, -44.2400041649999],
              [-74.1087133449999, -44.22747161299992],
            ],
          ],
          [
            [
              [-74.27696692599994, -44.14902109199994],
              [-74.26952063699991, -44.15504322699991],
              [-74.26121985599991, -44.16448333099993],
              [-74.25816809799994, -44.17310963299991],
              [-74.26634680899991, -44.17693450299993],
              [-74.33739173099991, -44.18987395599993],
              [-74.38556881399995, -44.15960051899992],
              [-74.37726803299995, -44.15056731599992],
              [-74.35781816299993, -44.145603122999944],
              [-74.2962133449999, -44.14332447699991],
              [-74.28612219999991, -44.145196221999925],
              [-74.27696692599994, -44.14902109199994],
            ],
          ],
          [
            [
              [-73.88280188699991, -44.11834075299993],
              [-73.86790930899991, -44.13128020599993],
              [-73.86461341099994, -44.13925546699994],
              [-73.87588456899994, -44.142836195999905],
              [-73.87857011599993, -44.1443010399999],
              [-73.88044186099995, -44.14804452899995],
              [-73.88097083199995, -44.152276299999926],
              [-73.87970943899995, -44.15585702899995],
              [-73.87173417899993, -44.160821221999925],
              [-73.86554928299995, -44.15862395599993],
              [-73.85936438699991, -44.15504322699991],
              [-73.85171464799993, -44.15585702899995],
              [-73.84190833199995, -44.15862395599993],
              [-73.83568274599992, -44.158135674999926],
              [-73.83226477799991, -44.160821221999925],
              [-73.83120683499993, -44.172946872999944],
              [-73.83568274599992, -44.18303801899992],
              [-73.84626217399995, -44.19019947699991],
              [-73.85920162699995, -44.19475676899992],
              [-73.87035071499992, -44.19654713299991],
              [-73.9114477199999, -44.19410572699991],
              [-73.95238196499992, -44.18629322699991],
              [-73.98875891799992, -44.170179945999905],
              [-74.01622473899994, -44.142836195999905],
              [-73.95270748599995, -44.10475025799991],
              [-73.91763261599993, -44.09840260199991],
              [-73.88280188699991, -44.11834075299993],
            ],
          ],
          [
            [
              [-74.29735266799992, -44.01189544099992],
              [-74.2774145169999, -44.01189544099992],
              [-74.20799719999991, -44.0193010399999],
              [-74.29832923099991, -44.031914971999925],
              [-74.30699622299994, -44.029229424999926],
              [-74.3145238919999, -44.02117278399993],
              [-74.31680253799993, -44.01653411299992],
              [-74.3118383449999, -44.013929945999905],
              [-74.29735266799992, -44.01189544099992],
            ],
          ],
          [
            [
              [-73.74498450399994, -43.95354583099993],
              [-73.72834225199995, -43.94068775799991],
              [-73.71133378799993, -43.93718840899993],
              [-73.70189368399991, -43.944431247999944],
              [-73.70767167899993, -43.96404387799993],
              [-73.69001217399995, -43.96803150799991],
              [-73.66901607999995, -43.97812265399995],
              [-73.65001380099994, -43.99138762799993],
              [-73.63882402299993, -44.00505950299993],
              [-73.63927161399994, -44.019463799999926],
              [-73.64899654899995, -44.02809010199991],
              [-73.65550696499992, -44.037367445999905],
              [-73.64631100199995, -44.053399346999925],
              [-73.61644446499992, -44.072523695999905],
              [-73.61021887899994, -44.08513762799993],
              [-73.61900794199994, -44.108086846999925],
              [-73.63341223899994, -44.12379322699991],
              [-73.65054277299993, -44.131931247999944],
              [-73.66543535099993, -44.12981536299992],
              [-73.67357337099992, -44.11492278399993],
              [-73.66812089799993, -44.094414971999925],
              [-73.6719457669999, -44.080743096999925],
              [-73.68346106699994, -44.07040780999995],
              [-73.7090551419999, -44.05624765399995],
              [-73.72398841099994, -44.05046965899993],
              [-73.72883053299995, -44.04656340899993],
              [-73.73180091099994, -44.038181247999944],
              [-73.73355058499993, -44.017510674999926],
              [-73.73843339799993, -44.008477471999925],
              [-73.74840247299994, -43.99765390399995],
              [-73.75499426999994, -43.98528411299992],
              [-73.75495357999995, -43.97087981599992],
              [-73.74498450399994, -43.95354583099993],
            ],
          ],
          [
            [
              [-73.22793535099993, -44.01189544099992],
              [-73.23981686099995, -44.00139739399992],
              [-73.27513587099992, -43.994073174999926],
              [-73.28258216099994, -43.981540622999944],
              [-73.28648841099994, -43.95012786299992],
              [-73.28416907499991, -43.93572356599992],
              [-73.27261308499993, -43.91936614399992],
              [-73.24966386599993, -43.903008721999925],
              [-73.21751868399991, -43.88811614399992],
              [-73.18472245999993, -43.87948984199994],
              [-73.15965735599991, -43.881524346999925],
              [-73.14427649599992, -43.892510674999926],
              [-73.14077714799993, -43.90357838299991],
              [-73.14537512899994, -43.93328215899993],
              [-73.14879309799994, -43.945245049999926],
              [-73.16372636599993, -43.97128671699994],
              [-73.16710364499994, -43.981540622999944],
              [-73.16120357999995, -43.99773528399993],
              [-73.15176347599993, -44.00790780999995],
              [-73.15160071499992, -44.01580169099992],
              [-73.17332923099991, -44.02556731599992],
              [-73.18700110599991, -44.02654387799993],
              [-73.20327714799993, -44.02361419099992],
              [-73.21825110599991, -44.018243096999925],
              [-73.22793535099993, -44.01189544099992],
            ],
          ],
          [
            [
              [-74.1439377929999, -43.82755091699994],
              [-74.11651950899994, -43.80959957899995],
              [-74.04524466499993, -43.7960937979999],
              [-73.99579647899992, -43.81390284999992],
              [-73.96734975599992, -43.82883363499991],
              [-73.91319739499994, -43.81324635199991],
              [-73.92096920499995, -43.79924895599993],
              [-73.90282141799992, -43.79371510199991],
              [-73.87791907499991, -43.79216887799993],
              [-73.86538652299993, -43.789320570999905],
              [-73.86603756399995, -43.770196221999925],
              [-73.86510169199994, -43.76262786299992],
              [-73.85822506399995, -43.76677825299993],
              [-73.79332434799994, -43.82903411299992],
              [-73.77513587099992, -43.855726820999905],
              [-73.76231848899994, -43.888929945999905],
              [-73.84650631399995, -43.89185963299991],
              [-73.87218176999994, -43.888929945999905],
              [-73.90746008999992, -43.873711846999925],
              [-73.91319739499994, -43.867852471999925],
              [-73.90416419199994, -43.85995859199994],
              [-73.87535559799994, -43.85833098799992],
              [-73.86538652299993, -43.84734465899993],
              [-73.89354407499991, -43.84026458099993],
              [-73.92845618399991, -43.84075286299992],
              [-73.95938066299993, -43.84978606599992],
              [-73.97524980399993, -43.867852471999925],
              [-73.95628821499992, -43.88128020599993],
              [-73.91930091099994, -43.895603122999944],
              [-73.90636145699995, -43.90943775799991],
              [-73.9317113919999, -43.91285572699991],
              [-73.97028561099995, -43.93434010199991],
              [-73.99571692599994, -43.93670012799993],
              [-74.00698808499993, -43.92978280999995],
              [-74.0156957669999, -43.9196916649999],
              [-74.02110755099994, -43.908868096999925],
              [-74.02301998599995, -43.89861419099992],
              [-74.03189042899993, -43.89299895599993],
              [-74.05174719999991, -43.894789320999905],
              [-74.08385169199994, -43.90203215899993],
              [-74.13792883999992, -43.89080169099992],
              [-74.14964758999992, -43.88518645599993],
              [-74.16087805899991, -43.87639739399992],
              [-74.16539466099994, -43.87509530999995],
              [-74.16637122299994, -43.872979424999926],
              [-74.16706295499995, -43.86101653399993],
              [-74.16616777299993, -43.853773695999905],
              [-74.14911194199993, -43.84404374799993],
              [-74.1439377929999, -43.82755091699994],
            ],
          ],
          [
            [
              [-74.81818600199995, -43.635023695999905],
              [-74.81470204499993, -43.618000855999924],
              [-74.82453431899995, -43.594642362999934],
              [-74.82733188799995, -43.571793026999956],
              [-74.82502555799994, -43.56241219899994],
              [-74.8103658359999, -43.56652565899992],
              [-74.78441602499993, -43.575296978999916],
              [-74.76268041599991, -43.570588750999946],
              [-74.7449005929999, -43.56590591299994],
              [-74.7409375709999, -43.551283044999934],
              [-74.74514063599992, -43.53603366099992],
              [-74.7379004849999, -43.5301774319999],
              [-74.71525091099994, -43.53309881899992],
              [-74.69580235899991, -43.5407045739999],
              [-74.68110993399995, -43.553022067999905],
              [-74.64824680299995, -43.55400615199994],
              [-74.61819872099994, -43.57795846199991],
              [-74.58266836099995, -43.597684658999924],
              [-74.55748608999994, -43.627409746999945],
              [-74.5784301779999, -43.63565279099993],
              [-74.67273330699993, -43.639392184999906],
              [-74.7226727449999, -43.65290649499991],
              [-74.7382089649999, -43.67165142999994],
              [-74.75845471199995, -43.67694915099992],
              [-74.77542723499994, -43.674631302999956],
              [-74.78988796999994, -43.65827149799992],
              [-74.81818600199995, -43.635023695999905],
            ],
          ],
          [
            [
              [-73.61148027299993, -42.936211846999925],
              [-73.58844967399995, -42.91350676899992],
              [-73.5528051419999, -42.918633721999925],
              [-73.49176998599995, -42.94304778399993],
              [-73.46056067599994, -42.946384372999944],
              [-73.42064368399991, -42.95566171699994],
              [-73.38451087099992, -42.970635674999926],
              [-73.36510169199994, -42.99081796699994],
              [-73.37352454299992, -42.99041106599992],
              [-73.38036048099991, -42.99277109199994],
              [-73.38634192599994, -42.9958635399999],
              [-73.39220130099994, -42.99822356599992],
              [-73.42381751199991, -42.99749114399992],
              [-73.45006262899994, -42.99374765399995],
              [-73.47227942599994, -42.98455169099992],
              [-73.49176998599995, -42.96721770599993],
              [-73.50259355399993, -42.96103280999995],
              [-73.53400631399995, -42.95435963299991],
              [-73.54670162699995, -42.94687265399995],
              [-73.55882727799991, -42.94182708099993],
              [-73.59683183499993, -42.939385674999926],
              [-73.61148027299993, -42.936211846999925],
            ],
          ],
          [
            [
              [-73.60472571499992, -42.57927825299993],
              [-73.59927324099993, -42.59392669099992],
              [-73.60846920499995, -42.62224700299993],
              [-73.60716712099992, -42.637383721999925],
              [-73.61676998599995, -42.63876718499995],
              [-73.65526282499991, -42.62379322699991],
              [-73.67235266799992, -42.62265390399995],
              [-73.68911699099993, -42.624118747999944],
              [-73.70555579299992, -42.62810637799993],
              [-73.72142493399991, -42.6345354149999],
              [-73.73338782499991, -42.62639739399992],
              [-73.74893144399994, -42.61223723799992],
              [-73.75503495999993, -42.59880950299993],
              [-73.73843339799993, -42.59295012799993],
              [-73.66307532499991, -42.58668385199991],
              [-73.64688066299993, -42.58147551899992],
              [-73.63394120999993, -42.57195403399993],
              [-73.62096106699994, -42.56804778399993],
              [-73.60472571499992, -42.57927825299993],
            ],
          ],
          [
            [
              [-73.41234290299991, -42.525648695999905],
              [-73.41307532499991, -42.52947356599992],
              [-73.41832434799994, -42.53834400799991],
              [-73.42023678299995, -42.54241301899992],
              [-73.42096920499995, -42.547946872999944],
              [-73.42080644399994, -42.553399346999925],
              [-73.41942298099991, -42.5642229149999],
              [-73.4212133449999, -42.563571872999944],
              [-73.43203691299993, -42.554620049999926],
              [-73.47126217399995, -42.50074635199991],
              [-73.47960364499994, -42.49529387799993],
              [-73.48908443899995, -42.49342213299991],
              [-73.49909420499995, -42.492852471999925],
              [-73.5091039699999, -42.49114348799992],
              [-73.54515540299991, -42.47307708099993],
              [-73.55321204299992, -42.46998463299991],
              [-73.56916256399995, -42.46738046699994],
              [-73.61266028599994, -42.451836846999925],
              [-73.62515214799993, -42.44345468499995],
              [-73.62901770699995, -42.43515390399995],
              [-73.63133704299992, -42.42473723799992],
              [-73.63263912699995, -42.404961846999925],
              [-73.63727779899995, -42.39804452899995],
              [-73.64610755099994, -42.393243096999925],
              [-73.65160071499992, -42.3864885399999],
              [-73.64631100199995, -42.37379322699991],
              [-73.63101152299993, -42.36793385199991],
              [-73.60708574099993, -42.36874765399995],
              [-73.54320227799991, -42.379164320999905],
              [-73.53384355399993, -42.3923479149999],
              [-73.52912350199995, -42.40935637799993],
              [-73.51903235599991, -42.425713799999926],
              [-73.41738847599993, -42.51767343499995],
              [-73.41234290299991, -42.525648695999905],
            ],
          ],
          [
            [
              [-73.08763587099992, -42.24749114399992],
              [-73.07945716099994, -42.25660572699991],
              [-73.07225501199991, -42.26685963299991],
              [-73.06920325399994, -42.27792734199994],
              [-73.07323157499991, -42.288995049999926],
              [-73.08922278599994, -42.29957447699991],
              [-73.11620032499991, -42.3103166649999],
              [-73.14159094999991, -42.31373463299991],
              [-73.15282141799992, -42.30242278399993],
              [-73.15876217399995, -42.30152760199991],
              [-73.17105058499993, -42.292901299999926],
              [-73.18199622299994, -42.2829729149999],
              [-73.18350175699993, -42.27825286299992],
              [-73.18748938699991, -42.27271900799991],
              [-73.19249426999994, -42.260837497999944],
              [-73.19391842399995, -42.249118747999944],
              [-73.18700110599991, -42.24423593499995],
              [-73.17666581899994, -42.25009530999995],
              [-73.16047115799995, -42.27312590899993],
              [-73.14537512899994, -42.27825286299992],
              [-73.12319902299993, -42.25286223799992],
              [-73.10606848899994, -42.24098072699991],
              [-73.08763587099992, -42.24749114399992],
            ],
          ],
          [
            [
              [-72.54271399599992, -42.14104583099993],
              [-72.60798092399995, -42.11191171699994],
              [-72.61778723899994, -42.10361093499995],
              [-72.61074785099993, -42.08847421699994],
              [-72.59422766799992, -42.07146575299993],
              [-72.57494055899991, -42.05738697699991],
              [-72.55972245999993, -42.05169036299992],
              [-72.52985592399995, -42.05364348799992],
              [-72.51475989499994, -42.060479424999926],
              [-72.50926673099991, -42.073337497999944],
              [-72.50658118399991, -42.11638762799993],
              [-72.50804602799991, -42.138929945999905],
              [-72.51817786399994, -42.150648695999905],
              [-72.54271399599992, -42.14104583099993],
            ],
          ],
          [
            [
              [-74.33462480399993, -43.28167083099993],
              [-74.36331975799993, -43.291730797999946],
              [-74.37950598899994, -43.2693010399999],
              [-74.40099036399994, -43.260430596999925],
              [-74.40721594999991, -43.23788827899995],
              [-74.40306555899991, -43.230726820999905],
              [-74.37553859999991, -43.217010814999924],
              [-74.35839078999993, -43.177414804999955],
              [-74.35879472599993, -43.15837981599992],
              [-74.35383053299995, -43.15309010199991],
              [-74.32970130099994, -43.142836195999905],
              [-74.31171424699994, -43.13751586899991],
              [-74.30787376599994, -43.12476715799994],
              [-74.32420813699991, -43.11834075299993],
              [-74.3340551419999, -43.11028411299992],
              [-74.33836829299992, -43.10003020599993],
              [-74.33063717399995, -43.0876604149999],
              [-74.31784979699995, -43.0721185349999],
              [-74.29901786499994, -43.075789571999906],
              [-74.28008990699993, -43.06848933999993],
              [-74.2572994439999, -43.046586275999914],
              [-74.23959978799991, -43.032892671999946],
              [-74.22951976999991, -43.022876985999915],
              [-74.22820667299993, -43.010118966999926],
              [-74.24945244699995, -43.00278414999991],
              [-74.25564999399995, -42.99091705299992],
              [-74.2468434999999, -42.98090955099991],
              [-74.21924761999992, -42.97729828899992],
              [-74.2116518659999, -42.96362671999992],
              [-74.21530946999991, -42.946291326999926],
              [-74.22525339399994, -42.93805458499992],
              [-74.23267312699994, -42.92890524699993],
              [-74.23224850199995, -42.916680596999925],
              [-74.22305253799993, -42.91326262799993],
              [-74.21153723899994, -42.912041924999926],
              [-74.18253350599991, -42.903478047999954],
              [-74.1673627369999, -42.88251407899992],
              [-74.16221169399995, -42.859721444999934],
              [-74.16209998599993, -42.84057350599994],
              [-74.17206078699991, -42.82870281699991],
              [-74.16697518199993, -42.81685741399991],
              [-74.15687611999994, -42.80411381099992],
              [-74.16181838199992, -42.792250175999925],
              [-74.17053441099995, -42.78310932699992],
              [-74.17043650499994, -42.76669563199994],
              [-74.15035692799995, -42.75855255999994],
              [-74.14654219899995, -42.74762750399992],
              [-74.14895752599995, -42.732125269999926],
              [-74.16138894699992, -42.71840455499995],
              [-74.1538758719999, -42.71022532899991],
              [-74.13888826399995, -42.70389856199995],
              [-74.13139085599994, -42.69298192799994],
              [-74.12750680099992, -42.67113293199992],
              [-74.12838184999993, -42.6411362419999],
              [-74.1368509159999, -42.60377467099994],
              [-74.14428532999995, -42.578179675999934],
              [-74.15339107999995, -42.558851820999905],
              [-74.15664628799993, -42.55234140399995],
              [-74.16120357999995, -42.54648202899995],
              [-74.16527258999992, -42.53923919099992],
              [-74.16706295499995, -42.52809010199991],
              [-74.1741759439999, -42.524009157999956],
              [-74.18558657299991, -42.52098179799992],
              [-74.1937284249999, -42.51418919899993],
              [-74.19044571499995, -42.49690369699994],
              [-74.18296488099992, -42.48340203099991],
              [-74.1847134329999, -42.463876169999935],
              [-74.18965838199995, -42.452604134999945],
              [-74.18961766399991, -42.4319060169999],
              [-74.15384608799991, -42.361516243999915],
              [-74.14321641499993, -42.318648013999905],
              [-74.15954187699992, -42.29011658399992],
              [-74.16877411099995, -42.265326684999934],
              [-74.1595034799999, -42.241297913999915],
              [-74.14710021799993, -42.21652426899993],
              [-74.12339540499994, -42.19480723499993],
              [-74.06952878399994, -42.152874969999914],
              [-74.05333551599995, -42.130345173999956],
              [-74.05633707399994, -42.11229540699992],
              [-74.06403561099995, -42.08953215899993],
              [-74.05996660099993, -42.080743096999925],
              [-74.05174719999991, -42.06926848799992],
              [-74.04527747299994, -42.05779387799993],
              [-74.04662024599992, -42.0485979149999],
              [-74.04991614499994, -42.04062265399995],
              [-74.05882727799991, -41.98788827899995],
              [-74.05874589799993, -41.96526458099993],
              [-74.05528723899994, -41.94500090899993],
              [-74.04662024599992, -41.93629322699991],
              [-74.05308997299994, -41.93328215899993],
              [-74.04458574099993, -41.92693450299993],
              [-74.03209387899994, -41.920993747999944],
              [-74.02643795499995, -41.91887786299992],
              [-74.01235917899993, -41.90781015399995],
              [-74.00914466099994, -41.90081145599993],
              [-74.00877844999991, -41.88787200299993],
              [-74.02041581899994, -41.86687590899993],
              [-74.0305883449999, -41.85312265399995],
              [-74.03978430899991, -41.84685637799993],
              [-74.05679277299993, -41.84303150799991],
              [-74.06208248599995, -41.83326588299991],
              [-74.06224524599992, -41.82000090899993],
              [-74.06403561099995, -41.80592213299991],
              [-74.05345618399991, -41.79892343499995],
              [-74.04552161399994, -41.78753020599993],
              [-74.03978430899991, -41.77662525799991],
              [-74.03604081899994, -41.77117278399993],
              [-74.02257239499994, -41.77068450299993],
              [-74.01528886599993, -41.778415622999944],
              [-74.00918535099993, -41.78769296699994],
              [-73.99913489499994, -41.79225025799991],
              [-73.98884029899995, -41.79452890399995],
              [-73.96996008999992, -41.803806247999944],
              [-73.9590551419999, -41.807712497999944],
              [-73.95457923099991, -41.81072356599992],
              [-73.94985917899993, -41.81218840899993],
              [-73.94391842399995, -41.80901458099993],
              [-73.94078528599994, -41.80388762799993],
              [-73.93492591099994, -41.78785572699991],
              [-73.93431555899991, -41.78484465899993],
              [-73.91706295499995, -41.78264739399992],
              [-73.90147864499994, -41.79062265399995],
              [-73.89024817599994, -41.80510833099993],
              [-73.88589433499993, -41.82268645599993],
              [-73.89610755099994, -41.84270598799992],
              [-73.91934160099993, -41.84254322699991],
              [-73.96157792899993, -41.826429945999905],
              [-73.98306230399993, -41.82089609199994],
              [-73.99327551999994, -41.82122161299992],
              [-74.00255286399994, -41.826429945999905],
              [-74.00938880099994, -41.83757903399993],
              [-74.00617428299995, -41.84514739399992],
              [-73.99937903599994, -41.85116952899995],
              [-73.99571692599994, -41.85711028399993],
              [-73.98355058499993, -41.86646900799991],
              [-73.90636145699995, -41.88103606599992],
              [-73.88898678299995, -41.88713958099993],
              [-73.86603756399995, -41.89226653399993],
              [-73.84605872299994, -41.887383721999925],
              [-73.83739173099991, -41.86370208099993],
              [-73.82583574099993, -41.85686614399992],
              [-73.80077063699991, -41.87127044099992],
              [-73.77721106699994, -41.891289971999925],
              [-73.76984615799995, -41.90154387799993],
              [-73.76032467399995, -41.8962541649999],
              [-73.76366126199991, -41.88600025799991],
              [-73.77599036399994, -41.87037525799991],
              [-73.7774145169999, -41.858086846999925],
              [-73.74596106699994, -41.837009372999944],
              [-73.70763098899994, -41.82089609199994],
              [-73.69098873599995, -41.80901458099993],
              [-73.67833411399994, -41.81414153399993],
              [-73.65599524599992, -41.82732512799993],
              [-73.63467363199993, -41.83294036299992],
              [-73.61949622299994, -41.80632903399993],
              [-73.60606848899994, -41.80038827899995],
              [-73.59044348899994, -41.79778411299992],
              [-73.57799231699994, -41.79851653399993],
              [-73.56493079299992, -41.804945570999905],
              [-73.55455481699994, -41.815524997999944],
              [-73.53701738199993, -41.84002044099992],
              [-73.52830969999991, -41.834649346999925],
              [-73.51952063699991, -41.833103122999944],
              [-73.51081295499995, -41.835056247999944],
              [-73.50230872299994, -41.84002044099992],
              [-73.50230872299994, -41.84685637799993],
              [-73.52969316299993, -41.85637786299992],
              [-73.53701738199993, -41.86052825299993],
              [-73.54767818899995, -41.87004973799992],
              [-73.54869544199994, -41.873711846999925],
              [-73.54548092399995, -41.87664153399993],
              [-73.54124915299991, -41.889743747999944],
              [-73.53209387899994, -41.89723072699991],
              [-73.52961178299995, -41.90154387799993],
              [-73.53026282499991, -41.906914971999925],
              [-73.53563391799992, -41.91423919099992],
              [-73.54076087099992, -41.928806247999944],
              [-73.54979407499991, -41.928399346999925],
              [-73.56078040299991, -41.925713799999926],
              [-73.57054602799991, -41.928806247999944],
              [-73.57843990799995, -41.94548919099992],
              [-73.5676977199999, -41.953383070999905],
              [-73.54906165299991, -41.95842864399992],
              [-73.53331458199995, -41.96607838299991],
              [-73.49693762899994, -42.01718515399995],
              [-73.48521887899994, -42.024509372999944],
              [-73.47020423099991, -42.03020598799992],
              [-73.45645097599993, -42.04436614399992],
              [-73.44749915299991, -42.0622697899999],
              [-73.44701087099992, -42.07968515399995],
              [-73.45791581899994, -42.08912525799991],
              [-73.49437415299991, -42.1032854149999],
              [-73.50230872299994, -42.11663176899992],
              [-73.48908443899995, -42.145603122999944],
              [-73.45742753799993, -42.16611093499995],
              [-73.38621985599991, -42.19573333099993],
              [-73.38988196499992, -42.199883721999925],
              [-73.39525305899991, -42.20973072699991],
              [-73.39981035099993, -42.21624114399992],
              [-73.3841039699999, -42.22625090899993],
              [-73.37559973899994, -42.2400041649999],
              [-73.37401282499991, -42.25741952899995],
              [-73.37877356699994, -42.27825286299992],
              [-73.38475501199991, -42.29306405999995],
              [-73.38963782499991, -42.301446221999925],
              [-73.39610755099994, -42.30901458099993],
              [-73.40290279899995, -42.309665622999944],
              [-73.42438717399995, -42.30169036299992],
              [-73.43342037699995, -42.29941171699994],
              [-73.45335852799991, -42.30315520599993],
              [-73.48688717399995, -42.32122161299992],
              [-73.5091039699999, -42.326104424999926],
              [-73.57241777299993, -42.32301197699991],
              [-73.59166419199994, -42.326104424999926],
              [-73.65054277299993, -42.3454729149999],
              [-73.66616777299993, -42.35409921699994],
              [-73.68154863199993, -42.37004973799992],
              [-73.68236243399991, -42.38241952899995],
              [-73.67690995999993, -42.39397551899992],
              [-73.67357337099992, -42.4079729149999],
              [-73.67813066299993, -42.42888762799993],
              [-73.68541419199994, -42.441338799999926],
              [-73.68854732999995, -42.45273202899995],
              [-73.68040930899991, -42.46998463299991],
              [-73.66563880099994, -42.48284270599993],
              [-73.62804114499994, -42.49846770599993],
              [-73.61148027299993, -42.511651299999926],
              [-73.6231176419999, -42.51620859199994],
              [-73.70767167899993, -42.53834400799991],
              [-73.73009192599994, -42.53923919099992],
              [-73.75373287699995, -42.53362395599993],
              [-73.77481035099993, -42.52206796699994],
              [-73.78966223899994, -42.504164320999905],
              [-73.77745520699995, -42.49700286299992],
              [-73.76939856699994, -42.486993096999925],
              [-73.75552324099993, -42.463148695999905],
              [-73.76231848899994, -42.45712655999995],
              [-73.80260169199994, -42.47795989399992],
              [-73.81818600199995, -42.49309661299992],
              [-73.82445227799991, -42.51441822699991],
              [-73.82005774599992, -42.52353280999995],
              [-73.80089270699995, -42.53573984199994],
              [-73.79649817599994, -42.54176197699991],
              [-73.79954993399991, -42.55510833099993],
              [-73.81354732999995, -42.57634856599992],
              [-73.81696529899995, -42.58668385199991],
              [-73.80915279899995, -42.60865650799991],
              [-73.78888912699995, -42.62420012799993],
              [-73.76471920499995, -42.63730234199994],
              [-73.73534094999991, -42.65829843499995],
              [-73.72350012899994, -42.661228122999944],
              [-73.69782467399995, -42.66179778399993],
              [-73.69884192599994, -42.66659921699994],
              [-73.68919837099992, -42.676853122999944],
              [-73.67784583199995, -42.68629322699991],
              [-73.67357337099992, -42.68914153399993],
              [-73.64146887899994, -42.73211028399993],
              [-73.63243567599994, -42.74065520599993],
              [-73.62205969999991, -42.744398695999905],
              [-73.59776770699995, -42.74814218499995],
              [-73.57603919199994, -42.75701262799993],
              [-73.51667232999995, -42.78923919099992],
              [-73.50145423099991, -42.80152760199991],
              [-73.49193274599992, -42.818617445999905],
              [-73.48863684799994, -42.843682549999926],
              [-73.49429277299993, -42.86679452899995],
              [-73.50951087099992, -42.87769947699991],
              [-73.53111731699994, -42.88095468499995],
              [-73.57188880099994, -42.879978122999944],
              [-73.58560136599993, -42.877211195999905],
              [-73.61148027299993, -42.86736419099992],
              [-73.62205969999991, -42.88632577899995],
              [-73.6497289699999, -42.88323333099993],
              [-73.68228105399993, -42.87232838299991],
              [-73.70767167899993, -42.86736419099992],
              [-73.70767167899993, -42.87468840899993],
              [-73.65392005099994, -42.89763762799993],
              [-73.64631100199995, -42.90545012799993],
              [-73.64801998599995, -42.91464609199994],
              [-73.65396074099993, -42.92864348799992],
              [-73.65314693899995, -42.936211846999925],
              [-73.64639238199993, -42.941664320999905],
              [-73.63707434799994, -42.94231536299992],
              [-73.62877356699994, -42.94410572699991],
              [-73.62181555899991, -42.962009372999944],
              [-73.6133520169999, -42.9646135399999],
              [-73.59105383999992, -42.963555596999925],
              [-73.57738196499992, -42.96575286299992],
              [-73.57380123599995, -42.971774997999944],
              [-73.57371985599991, -42.980401299999926],
              [-73.57054602799991, -42.99081796699994],
              [-73.5227758449999, -43.05291106599992],
              [-73.54670162699995, -43.05120208099993],
              [-73.58755449099993, -43.034274997999944],
              [-73.60879343999994, -43.03560619299992],
              [-73.61174070099992, -43.049549053999954],
              [-73.56824408999995, -43.05374628399994],
              [-73.52868607099992, -43.0734698789999],
              [-73.49006100199995, -43.10003020599993],
              [-73.50230872299994, -43.128024997999944],
              [-73.52428137899994, -43.13103606599992],
              [-73.5469457669999, -43.12314218499995],
              [-73.56867428299995, -43.112399997999944],
              [-73.5879613919999, -43.10686614399992],
              [-73.61241614499994, -43.11077239399992],
              [-73.65086829299992, -43.128838799999926],
              [-73.72142493399991, -43.141696872999944],
              [-73.72809811099995, -43.13437265399995],
              [-73.73350989499994, -43.12265390399995],
              [-73.73851477799991, -43.10686614399992],
              [-73.76382402299993, -43.109633070999905],
              [-73.77574622299994, -43.11809661299992],
              [-73.7571225399999, -43.13625148099993],
              [-73.74568503799992, -43.17039591799994],
              [-73.75007593499993, -43.193305693999946],
              [-73.75455699499992, -43.20934364999994],
              [-73.74498450399994, -43.22698333099993],
              [-73.72826087099992, -43.23902760199991],
              [-73.71068274599992, -43.24749114399992],
              [-73.69762122299994, -43.25823333099993],
              [-73.67520323899993, -43.27984176699994],
              [-73.6660471109999, -43.29440738499994],
              [-73.6658080549999, -43.309844090999945],
              [-73.6802130449999, -43.31724048199993],
              [-73.70477883099994, -43.31657621699992],
              [-73.73154340499991, -43.31673093299992],
              [-73.71031653599994, -43.32732512799993],
              [-73.69544411599992, -43.339318259999914],
              [-73.67162503199995, -43.351052317999915],
              [-73.66901449799991, -43.363847189999944],
              [-73.68173184999995, -43.381101788999956],
              [-73.70758013599993, -43.388169165999955],
              [-73.7311091919999, -43.39264029699996],
              [-73.74898521699993, -43.385144289999914],
              [-73.7610570949999, -43.3728166649999],
              [-73.77599036399994, -43.368259372999944],
              [-73.79997615399992, -43.35977588999992],
              [-73.80092236899992, -43.376903618999904],
              [-73.7983655729999, -43.39143875099995],
              [-73.80048161299993, -43.40944354699991],
              [-73.81347032299993, -43.40868423699993],
              [-73.82771316599991, -43.40194260399994],
              [-73.83345517599992, -43.4139693539999],
              [-73.84749065799991, -43.42348324299991],
              [-73.87700444599994, -43.421959442999935],
              [-73.8890469079999, -43.400625660999935],
              [-73.90682897599993, -43.39217247399995],
              [-73.91761596299995, -43.375970683999924],
              [-73.92952961499992, -43.364898904999905],
              [-73.95546823099994, -43.36588111899994],
              [-73.97311190099992, -43.3694065009999],
              [-73.9918201719999, -43.38833412999992],
              [-74.00373301699994, -43.37469491499991],
              [-74.02623815699991, -43.36452281599992],
              [-74.0533787519999, -43.36293589299993],
              [-74.07923384399993, -43.376753238999925],
              [-74.08494839499991, -43.401628082999935],
              [-74.09799782699992, -43.39482440699993],
              [-74.11586056399995, -43.370052820999945],
              [-74.12995357999995, -43.35686614399992],
              [-74.16557328099992, -43.34197420899994],
              [-74.20095615799994, -43.3455025209999],
              [-74.2152251569999, -43.33012464199993],
              [-74.24851415299992, -43.32670240099992],
              [-74.29338084499994, -43.319964515999914],
              [-74.31505286399994, -43.2966447899999],
              [-74.33462480399993, -43.28167083099993],
            ],
          ],
          [
            [
              [-73.08763587099992, -41.84343840899993],
              [-73.08812415299991, -41.83603280999995],
              [-73.08193925699993, -41.82708098799992],
              [-73.07433020699995, -41.81853606599992],
              [-73.07022050699993, -41.81210702899995],
              [-73.08470618399991, -41.77206796699994],
              [-73.08580481699994, -41.7478166649999],
              [-73.06688391799992, -41.736993096999925],
              [-73.05337480399993, -41.747165622999944],
              [-73.02554277299993, -41.80901458099993],
              [-73.01024329299992, -41.826104424999926],
              [-73.00300045499995, -41.84433359199994],
              [-73.00963294199994, -41.857679945999905],
              [-73.03620357999995, -41.86052825299993],
              [-73.06354732999995, -41.85564544099992],
              [-73.07664954299992, -41.8513322899999],
              [-73.08763587099992, -41.84343840899993],
            ],
          ],
          [
            [
              [-73.0371789859999, -54.4564614169999],
              [-72.97284124399994, -54.4450118769999],
              [-72.95757871099994, -54.446589660999905],
              [-72.9537844809999, -54.45685838299994],
              [-72.96534822399991, -54.46682693799994],
              [-72.97533763099995, -54.48702675099992],
              [-72.98911544599991, -54.495697428999904],
              [-73.01288256299995, -54.49010667099992],
              [-73.0389805019999, -54.485753719999934],
              [-73.05701166999995, -54.493037074999904],
              [-73.08570725899995, -54.494997129999945],
              [-73.09831420699993, -54.485808119999945],
              [-73.07760342299991, -54.47093457299991],
              [-73.05471774199992, -54.4561044699999],
              [-73.0371789859999, -54.4564614169999],
            ],
          ],
          [
            [
              [-70.4026034119999, -54.07863268999995],
              [-70.3601803599999, -54.07091839099991],
              [-70.34002241399992, -54.057906439999954],
              [-70.31325263299993, -54.052750105999905],
              [-70.29330233499991, -54.068474987999934],
              [-70.29123731099992, -54.09330388899991],
              [-70.2981432869999, -54.1259526529999],
              [-70.32287559699995, -54.15072535099995],
              [-70.34965637099992, -54.15587439799992],
              [-70.40513417699992, -54.150441659999956],
              [-70.46711542899993, -54.12409595999992],
              [-70.51369144999995, -54.09128582299991],
              [-70.5048350369999, -54.073039313999914],
              [-70.48045125099992, -54.069213619999914],
              [-70.43607851099995, -54.085056652999924],
              [-70.4026034119999, -54.07863268999995],
            ],
          ],
          [
            [
              [-70.6868143669999, -52.847389516999954],
              [-70.63173666299991, -52.832657369999936],
              [-70.61925198699993, -52.84338431899994],
              [-70.63498535499991, -52.85359460099994],
              [-70.64923467299991, -52.876957242999936],
              [-70.67626578599993, -52.89483012699992],
              [-70.72515517799991, -52.91360801299993],
              [-70.76444247199993, -52.91547588499992],
              [-70.78974034899994, -52.90054072299995],
              [-70.76945195799993, -52.887803135999945],
              [-70.73143812899991, -52.868847169999924],
              [-70.6868143669999, -52.847389516999954],
            ],
          ],
          [
            [
              [-74.42775741499992, -52.50366163599995],
              [-74.4153130009999, -52.50487384899992],
              [-74.39419819099993, -52.519902713999954],
              [-74.38206474899994, -52.5431376599999],
              [-74.36199781699992, -52.571706424999945],
              [-74.35444024899994, -52.59992384299994],
              [-74.34925666099991, -52.622980783999935],
              [-74.36930506999994, -52.62919608899995],
              [-74.41940814399993, -52.609082205999925],
              [-74.45978758899992, -52.59008473599994],
              [-74.48196030499992, -52.570765139999935],
              [-74.49157234099994, -52.55181071599992],
              [-74.46654478999994, -52.535590234999916],
              [-74.45070993999991, -52.52927712999991],
              [-74.42775741499992, -52.50366163599995],
            ],
          ],
          [
            [
              [-74.47636839899991, -52.30966691599991],
              [-74.48401238299994, -52.32816720999995],
              [-74.46906418499992, -52.353010645999916],
              [-74.48785232999995, -52.37681214599991],
              [-74.48888678299994, -52.38990656999994],
              [-74.45232240799993, -52.39478346399994],
              [-74.46149547099992, -52.413240996999946],
              [-74.46188344799992, -52.437593457999924],
              [-74.48223251399992, -52.441658257999904],
              [-74.50870107899993, -52.42584998099994],
              [-74.53776972999992, -52.40432651099991],
              [-74.53644852799994, -52.36873619699992],
              [-74.52872122899993, -52.3295778559999],
              [-74.50820566899995, -52.3039677779999],
              [-74.47636839899991, -52.30966691599991],
            ],
          ],
          [
            [
              [-73.81514329399994, -51.86405867199994],
              [-73.79043109899993, -51.85351601699995],
              [-73.77901279899993, -51.83467373199994],
              [-73.7695348389999, -51.827595483999914],
              [-73.73916140699993, -51.83234576399991],
              [-73.71832960599994, -51.84886004599991],
              [-73.7089867599999, -51.88302049299995],
              [-73.6976729289999, -51.90775677899995],
              [-73.69977356999993, -51.94307014099991],
              [-73.72075294599995, -51.93831608699992],
              [-73.71131412799991, -51.95716964399992],
              [-73.7037780309999, -51.97601803799995],
              [-73.71345073599991, -51.99600695799995],
              [-73.7384073259999, -52.0112532469999],
              [-73.76705946999994, -52.00529691699995],
              [-73.80511865999995, -51.980471233999936],
              [-73.83710739299994, -51.94388603999994],
              [-73.83864973399994, -51.916838611999935],
              [-73.8768275839999, -51.90138996399992],
              [-73.91313114299993, -51.900066506999906],
              [-73.94361923299994, -51.892875329999924],
              [-73.95097702899994, -51.86812677699993],
              [-73.97935816199993, -51.838543888999936],
              [-73.96586041199993, -51.81856754899991],
              [-73.9371117899999, -51.808113216999914],
              [-73.9007487909999, -51.80360308099995],
              [-73.8778311719999, -51.814351607999924],
              [-73.86067045899995, -51.83094935699995],
              [-73.8282442229999, -51.85112979599995],
              [-73.81514329399994, -51.86405867199994],
            ],
          ],
          [
            [
              [-74.35903594299992, -51.33794079799992],
              [-74.34505327599993, -51.34235284499994],
              [-74.32868256599994, -51.357754936999925],
              [-74.3109471969999, -51.37615553099994],
              [-74.29651017299994, -51.39538906599995],
              [-74.3062489319999, -51.417783641999904],
              [-74.33557616899992, -51.42678698099991],
              [-74.36984453899993, -51.41784527599992],
              [-74.39648801099992, -51.413082380999924],
              [-74.40124205899991, -51.39213824199993],
              [-74.3934765699999, -51.37355080799995],
              [-74.41202642799993, -51.367044337999914],
              [-74.39634794199992, -51.34869430899994],
              [-74.38427881399991, -51.336189565999916],
              [-74.35903594299992, -51.33794079799992],
            ],
          ],
          [
            [
              [-74.9702766929999, -50.28751639299992],
              [-74.9265971339999, -50.275426110999945],
              [-74.88925839099994, -50.294923200999904],
              [-74.92852759699991, -50.33675421399994],
              [-74.96250745399993, -50.35830182899991],
              [-74.9544472369999, -50.38815379899995],
              [-74.97626633699991, -50.43288751599994],
              [-75.0445223019999, -50.475994397999955],
              [-75.11166039099993, -50.46896464999992],
              [-75.17158148999994, -50.46215001499991],
              [-75.16850483699994, -50.430384242999935],
              [-75.12117753099994, -50.38208595499992],
              [-75.07170163399991, -50.347515433999945],
              [-74.9702766929999, -50.28751639299992],
            ],
          ],
          [
            [
              [-74.42601477799991, -49.61492278399993],
              [-74.43529212099992, -49.60279713299991],
              [-74.43309485599991, -49.572523695999905],
              [-74.44017493399991, -49.551039320999905],
              [-74.43407141799992, -49.534274997999944],
              [-74.43761145699995, -49.5251604149999],
              [-74.46373450399994, -49.508884372999944],
              [-74.46861731699994, -49.50115325299993],
              [-74.46678626199991, -49.49342213299991],
              [-74.46080481699994, -49.48707447699991],
              [-74.45352128799993, -49.48105234199994],
              [-74.44810950399994, -49.47389088299991],
              [-74.44493567599994, -49.465101820999905],
              [-74.44261633999992, -49.45549895599993],
              [-74.4407039049999, -49.43572356599992],
              [-74.43643144399994, -49.42701588299991],
              [-74.4270320299999, -49.42652760199991],
              [-74.41771399599992, -49.430759372999944],
              [-74.4133601549999, -49.43572356599992],
              [-74.40855872299994, -49.44801197699991],
              [-74.39700273299991, -49.451836846999925],
              [-74.38333085799991, -49.45191822699991],
              [-74.37181555899991, -49.453383070999905],
              [-74.35313880099994, -49.46526458099993],
              [-74.3069148429999, -49.518649997999944],
              [-74.29898027299993, -49.532321872999944],
              [-74.29360917899993, -49.53875090899993],
              [-74.28799394399994, -49.54843515399995],
              [-74.29308020699995, -49.554620049999926],
              [-74.37181555899991, -49.593682549999926],
              [-74.37954667899993, -49.606133721999925],
              [-74.39700273299991, -49.61842213299991],
              [-74.41539466099994, -49.62379322699991],
              [-74.42601477799991, -49.61492278399993],
            ],
          ],
          [
            [
              [-74.64986523399995, -47.79774223699991],
              [-74.62870288099992, -47.80078372999992],
              [-74.59548277399995, -47.80482872199991],
              [-74.55779015799993, -47.80683929399993],
              [-74.52618050699994, -47.81286809899996],
              [-74.5201794699999, -47.838069091999955],
              [-74.5246713649999, -47.86835127799992],
              [-74.54573996099992, -47.872414018999905],
              [-74.59397231499992, -47.864388601999906],
              [-74.62119463599993, -47.87856549599991],
              [-74.62428586899995, -47.904864207999935],
              [-74.6213173399999, -47.921057452999946],
              [-74.64401579199995, -47.92311027299991],
              [-74.65909359499994, -47.90187218099993],
              [-74.67422963399991, -47.8907601919999],
              [-74.6877956429999, -47.86243778699992],
              [-74.68923028499995, -47.83411712199995],
              [-74.68917028299995, -47.813894165999955],
              [-74.64986523399995, -47.79774223699991],
            ],
          ],
          [
            [
              [-75.32314685199992, -46.685089311999945],
              [-75.28158313599994, -46.68390565499993],
              [-75.25209962399992, -46.681531143999905],
              [-75.2191070149999, -46.67440207099992],
              [-75.17399230399991, -46.67796365599992],
              [-75.1461990009999, -46.69701549399991],
              [-75.13571339999993, -46.72681088199994],
              [-75.12180152999991, -46.747033992999945],
              [-75.13221358599992, -46.777994805999924],
              [-75.16177566599993, -46.78157945999993],
              [-75.20696718799991, -46.75181108599992],
              [-75.25044481099991, -46.74345719699994],
              [-75.26606236099991, -46.72439208499992],
              [-75.30765842799991, -46.71365679799993],
              [-75.3422518619999, -46.70173659099993],
              [-75.32314685199992, -46.685089311999945],
            ],
          ],
          [
            [
              [-74.25336138099993, -43.35039208299992],
              [-74.2474194639999, -43.35252987399991],
              [-74.24657134599994, -43.37031159599991],
              [-74.2516443479999, -43.388652168999954],
              [-74.2463636679999, -43.39995549799994],
              [-74.23077253299994, -43.40582768799993],
              [-74.23072644099994, -43.41336956999993],
              [-74.24701011999991, -43.413421154999924],
              [-74.2521628369999, -43.4177435709999],
              [-74.25730730799995, -43.427452099999925],
              [-74.26619245299992, -43.42478237499995],
              [-74.28402606999992, -43.41783755499995],
              [-74.28113286699994, -43.407600858999956],
              [-74.27610005499992, -43.38980408599991],
              [-74.27326006999994, -43.37039074899991],
              [-74.27405297199994, -43.36123122899994],
              [-74.25336138099993, -43.35039208299992],
            ],
          ],
          [
            [
              [-73.6910916089999, -43.188156497999955],
              [-73.67211486799994, -43.190440742999954],
              [-73.6564222209999, -43.19600022499992],
              [-73.64697900499993, -43.2292406169999],
              [-73.66123828499991, -43.24479598399995],
              [-73.68821396999994, -43.23118656199995],
              [-73.71852394299992, -43.21598090599991],
              [-73.72669033599993, -43.19168550199993],
              [-73.71460425999993, -43.180219113999954],
              [-73.6910916089999, -43.188156497999955],
            ],
          ],
          [
            [
              [-73.00919178399994, -42.69525942699994],
              [-72.99580145599992, -42.69994010399995],
              [-72.99039049699991, -42.716920187999904],
              [-72.9816571579999, -42.7338508979999],
              [-72.95832154499993, -42.737162833999946],
              [-72.95534970599994, -42.72371496499994],
              [-72.94392179099992, -42.71623278099992],
              [-72.93044389399995, -42.723340169999915],
              [-72.92800117399992, -42.75622415299995],
              [-72.9188151919999, -42.78653235899992],
              [-72.93698349699991, -42.792902443999935],
              [-72.9565246809999, -42.80780413799994],
              [-72.97029039199992, -42.79095652299992],
              [-72.98430445399993, -42.76192187999993],
              [-73.01654005299991, -42.73313659999991],
              [-73.03361629099993, -42.71388626899994],
              [-73.03072158499992, -42.69678717499994],
              [-73.00919178399994, -42.69525942699994],
            ],
          ],
          [
            [
              [-73.3073409289999, -42.62734339799994],
              [-73.27753151399992, -42.62818675299991],
              [-73.27422165699994, -42.62814482099992],
              [-73.24103816399992, -42.63137144299992],
              [-73.23895066699993, -42.65082611999992],
              [-73.2603188619999, -42.6584031239999],
              [-73.29518144299993, -42.65395117299994],
              [-73.32519784499993, -42.64334148599994],
              [-73.35692687699992, -42.62903736099992],
              [-73.34386657699991, -42.62038707399995],
              [-73.3073409289999, -42.62734339799994],
            ],
          ],
          [
            [
              [-73.88243567599994, -38.36077239399992],
              [-73.87531490799995, -38.36842213299991],
              [-73.87157141799992, -38.386651299999926],
              [-73.87816321499992, -38.401462497999944],
              [-73.88499915299991, -38.40960051899992],
              [-73.89224199099993, -38.413995049999926],
              [-73.89924068899995, -38.41423919099992],
              [-73.91209876199991, -38.4099260399999],
              [-73.92796790299991, -38.39609140399995],
              [-73.94701087099992, -38.3728166649999],
              [-73.95002193899995, -38.35800546699994],
              [-73.94957434799994, -38.33904387799993],
              [-73.95482337099992, -38.32244231599992],
              [-73.95343990799995, -38.313571872999944],
              [-73.93077551999994, -38.32382577899995],
              [-73.88243567599994, -38.36077239399992],
            ],
          ],
          [
            [
              [-73.54083025699993, -36.98944149599993],
              [-73.5326546149999, -36.97308466699991],
              [-73.52309595899993, -36.975265374999935],
              [-73.52034843299992, -36.98944076899994],
              [-73.52029844299994, -37.00581304599996],
              [-73.5066573929999, -37.01778499899996],
              [-73.48479304599994, -37.025408667999955],
              [-73.46975854899995, -37.03629693899995],
              [-73.45881235099995, -37.04827833199994],
              [-73.44649378399993, -37.059169519999955],
              [-73.46289108499991, -37.05482520999993],
              [-73.47656671699991, -37.04938124599994],
              [-73.49296140299992, -37.04176519799995],
              [-73.51071030199995, -37.05049215299994],
              [-73.51615852999993, -37.07120112799993],
              [-73.51888449499995, -37.07992152899993],
              [-73.52846040999992, -37.06902844599995],
              [-73.53668453699993, -37.04177396599994],
              [-73.55168501999992, -37.02762067499992],
              [-73.54348799899992, -37.018903732999945],
              [-73.5408195199999, -37.00034573799991],
              [-73.54083025699993, -36.98944149599993],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bolivia',
        iso3: 'BOL',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-69.51008875199994, -17.506588197999946],
            [-69.51009354699988, -17.50544199599996],
            [-69.5083365479999, -17.43402516599987],
            [-69.51138545799995, -17.398678486999955],
            [-69.5225992439999, -17.36911956799993],
            [-69.53709448299992, -17.351136169999933],
            [-69.55693823299993, -17.331499124999908],
            [-69.59727168799989, -17.30049326599989],
            [-69.61300716199986, -17.295118916999925],
            [-69.66441572199994, -17.288562462999934],
            [-69.66649226999988, -17.288297627999967],
            [-69.64941320899993, -17.262769469999924],
            [-69.63383276399992, -17.20726898099994],
            [-69.62279984599991, -17.185564879999944],
            [-69.61835567199992, -17.18422129299998],
            [-69.60114742099992, -17.18153411899995],
            [-69.59504960199988, -17.179673766999954],
            [-69.54099605399989, -17.13223480199987],
            [-69.51009354699988, -17.112080992999978],
            [-69.48280839099988, -17.10174570699988],
            [-69.4541538089999, -17.096578063999885],
            [-69.42743709299992, -17.08686289499994],
            [-69.40601721199991, -17.062988382999947],
            [-69.40126298099992, -17.047175394999954],
            [-69.40601721199991, -17.04087086899993],
            [-69.4133035889999, -17.037770283999905],
            [-69.41655920499997, -17.031982522999925],
            [-69.41358780999988, -17.02226735399998],
            [-69.40715409399994, -17.015652770999893],
            [-69.36431433199988, -16.991158141999932],
            [-69.35245459099986, -16.977722269999973],
            [-69.32594457999994, -16.922221780999905],
            [-69.22445206699987, -16.81824879999995],
            [-69.21065445999994, -16.797061461999903],
            [-69.19166337099998, -16.743007913999904],
            [-69.18236161299984, -16.728745218999933],
            [-69.1663677579999, -16.719133402999915],
            [-69.13058182799998, -16.715826110999927],
            [-69.11205582699995, -16.711485289999942],
            [-69.05381648799991, -16.682339782999918],
            [-69.03707332399998, -16.670247496999934],
            [-69.02051102699997, -16.64947357199989],
            [-69.00834122799995, -16.634177347999938],
            [-69.03513545799984, -16.59800384499991],
            [-69.04012223399991, -16.58136403399989],
            [-69.03764176499993, -16.55025482199993],
            [-69.03888199899987, -16.49186045299996],
            [-69.03681494199989, -16.47149993899994],
            [-69.02787491899997, -16.454136657999925],
            [-69.00172664399986, -16.422820739999906],
            [-68.96836950699989, -16.40638763399994],
            [-68.85584407599993, -16.36318613599991],
            [-68.83349401899994, -16.328976338999908],
            [-68.84364843799992, -16.302001240999886],
            [-68.86667028799988, -16.286911722999974],
            [-68.91876013199993, -16.266654560999967],
            [-68.9595069989999, -16.223349710999912],
            [-68.98203792399991, -16.210017190999892],
            [-69.01014990299987, -16.219112243999874],
            [-69.0427318939999, -16.2092937219999],
            [-69.05355810599985, -16.208363545999944],
            [-69.06451350999993, -16.212084248999943],
            [-69.0838921719999, -16.226553649999886],
            [-69.09518347199986, -16.23120452899994],
            [-69.12081498299992, -16.23120452899994],
            [-69.14468949499991, -16.22345306399994],
            [-69.16626440499996, -16.210430602999907],
            [-69.18486791999993, -16.195031025999924],
            [-69.21964615999988, -16.152759704999937],
            [-69.24212540799988, -16.09818939199991],
            [-69.2845775959999, -15.99504323299989],
            [-69.3271331389999, -15.892000426999886],
            [-69.36961116599991, -15.78895762099998],
            [-69.41221838399991, -15.68581146299995],
            [-69.42433650799998, -15.656252542999923],
            [-69.43002091599993, -15.626280211999884],
            [-69.42118424499992, -15.596411234999962],
            [-69.35640783799994, -15.501429951999867],
            [-69.35111100299989, -15.481896260999946],
            [-69.3485271809999, -15.46184580499991],
            [-69.34341121499992, -15.442208760999875],
            [-69.33036291499985, -15.424225361999973],
            [-69.32026017299992, -15.418851012999923],
            [-69.2929233399999, -15.409859313999974],
            [-69.28592118299989, -15.405415140999963],
            [-69.28540441899995, -15.396733499999911],
            [-69.29695410199989, -15.36696787499993],
            [-69.29116634199991, -15.35084482799995],
            [-69.27519832399989, -15.33027760799996],
            [-69.25589717699992, -15.313327738999945],
            [-69.22259171599998, -15.302165628999916],
            [-69.20913000599992, -15.263615010999942],
            [-69.18972550499984, -15.262374775999916],
            [-69.16613521399992, -15.263925068999924],
            [-69.15042557799995, -15.251626078999976],
            [-69.14810013899992, -15.233332620999917],
            [-69.17176794499997, -15.210801696999894],
            [-69.1964951169999, -15.176591897999899],
            [-69.2126698409999, -15.161295674999948],
            [-69.27220109099994, -15.118197529999932],
            [-69.28858251999992, -15.101971129999924],
            [-69.34609838899993, -15.01649831199991],
            [-69.36281571499998, -15.001305439999967],
            [-69.38431311099993, -14.981771748999876],
            [-69.39066931199994, -14.964408466999942],
            [-69.38622513899995, -14.945804951999904],
            [-69.36984370999988, -14.90828786199991],
            [-69.36775081399992, -14.900536396999897],
            [-69.37198828199988, -14.818680928999953],
            [-69.37054134199988, -14.801524352999891],
            [-69.3614204509999, -14.787985127999917],
            [-69.33904455599992, -14.774755960999926],
            [-69.28351822999994, -14.759666442999915],
            [-69.2676277269999, -14.750674742999976],
            [-69.25383011899996, -14.721839293999935],
            [-69.24749975599994, -14.593681741999916],
            [-69.23465816299995, -14.574251403999938],
            [-69.2149436039999, -14.572287698999915],
            [-69.19223181199993, -14.576938577999968],
            [-69.17039851899989, -14.57755869599994],
            [-69.1645074059999, -14.566396585999911],
            [-69.1674271249999, -14.520301207999893],
            [-69.16427486199993, -14.503041279999891],
            [-69.15820288099988, -14.498493753999952],
            [-69.14114965899995, -14.494152932999967],
            [-69.13401831099992, -14.490742289999943],
            [-69.0945633549999, -14.44640391],
            [-69.07513301599991, -14.432451272999913],
            [-69.01014990299987, -14.397104593999913],
            [-68.99025447599985, -14.3790178429999],
            [-68.99462113499993, -14.35896738699995],
            [-69.00831538899988, -14.339020283999929],
            [-69.0161702069999, -14.32114023799997],
            [-69.01722957399997, -14.282486266999868],
            [-69.01570511899988, -14.263159280999915],
            [-69.01014990299987, -14.245899352999928],
            [-68.98490596499991, -14.228329365999954],
            [-68.95131628399989, -14.219957783999888],
            [-68.88372351099991, -14.211482848999964],
            [-68.86444820199995, -14.191225686999971],
            [-68.86889237499989, -14.156189065999953],
            [-68.89372290099993, -14.089216410999953],
            [-68.8999757489999, -14.0547999059999],
            [-68.90576350899988, -14.039296975999989],
            [-68.91617630999991, -14.024930927999975],
            [-68.96971309499986, -13.99051442499993],
            [-68.98296809899998, -13.97222096799996],
            [-68.98904008099993, -13.94007822699993],
            [-68.98919510899987, -13.903698018999947],
            [-68.9929933279999, -13.869798278999937],
            [-69.01014990299987, -13.844373473999923],
            [-69.02309484899988, -13.806029561999907],
            [-69.0242834069999, -13.79249033599993],
            [-69.02082108599987, -13.77636728899995],
            [-69.01596350099993, -13.764585061999952],
            [-69.01596350099993, -13.75311289499993],
            [-69.02704809599993, -13.738230081999887],
            [-69.08104996799992, -13.695441995999957],
            [-69.1015913499999, -13.66660654699993],
            [-69.0875870369999, -13.643868916999864],
            [-69.07453873699987, -13.64262868199991],
            [-69.04402380399995, -13.648003031999878],
            [-69.03262915099987, -13.645935973999912],
            [-69.02384415799989, -13.63498056999994],
            [-69.02361161399992, -13.62330169699996],
            [-69.02552364199994, -13.610692646999937],
            [-69.02319820199989, -13.596946715999906],
            [-69.01539505999997, -13.585474547999894],
            [-68.99425939899993, -13.563046975999981],
            [-68.9856552739999, -13.550231221999908],
            [-68.9768186039999, -13.526253356999902],
            [-68.97074662299985, -13.501448668999956],
            [-68.97444148799985, -13.478814391999904],
            [-68.96278845299989, -13.283580829999948],
            [-68.97702530999996, -13.204929300999893],
            [-68.97966080799998, -13.164570006999924],
            [-68.97214188699994, -13.046127623999936],
            [-68.97393624599988, -13.031759582999953],
            [-68.98622371499994, -12.933369649999904],
            [-68.98658544899985, -12.89047820999994],
            [-68.98095271799991, -12.867947285999932],
            [-68.94943009499985, -12.843866067999983],
            [-68.93873307399986, -12.819681497999909],
            [-68.92661494999996, -12.800974629999928],
            [-68.90462662799987, -12.803971862999944],
            [-68.89199173999995, -12.77575653099997],
            [-68.87656632599996, -12.754982604999938],
            [-68.85620581099994, -12.741443378999946],
            [-68.77373022499992, -12.719429218999963],
            [-68.76613378899995, -12.710540872999957],
            [-68.74295690999986, -12.665789082999908],
            [-68.75298213799988, -12.654730325999893],
            [-68.78533158399998, -12.645945332999915],
            [-68.79460750399988, -12.636540221999951],
            [-68.79341894599986, -12.620210469999918],
            [-68.78388464399987, -12.60574106899989],
            [-68.77011287499994, -12.594372252999989],
            [-68.74026973499991, -12.578559264999896],
            [-68.72605871599987, -12.565950215999877],
            [-68.71453487199994, -12.551170755999863],
            [-68.70626664299988, -12.535977884999923],
            [-68.70022049999994, -12.516030781999916],
            [-68.69438106299995, -12.50683237699991],
            [-68.68425248299991, -12.502491556999928],
            [-68.68946323799992, -12.493417655999934],
            [-68.71422481399995, -12.450298359999948],
            [-68.8185595299999, -12.269224141999942],
            [-68.92286840899993, -12.088149922999946],
            [-69.0272806399999, -11.907075702999947],
            [-69.13158951899996, -11.726001484999955],
            [-69.23595007299991, -11.544927265999945],
            [-69.34033646699987, -11.363749694999925],
            [-69.44456783099989, -11.182675475999929],
            [-69.54895422399994, -11.001704609999948],
            [-69.5524940599999, -10.995606791999904],
            [-69.55611140999989, -10.98940561899991],
            [-69.55972875999987, -10.983101093999906],
            [-69.56326859599994, -10.97689992299992],
            [-69.56683426899991, -10.97069875099993],
            [-69.57050329599991, -10.964600931999968],
            [-69.57401729399996, -10.95850311299992],
            [-69.57763464399994, -10.95230194099993],
            [-69.50288468499994, -10.955299173999947],
            [-69.46337805199991, -10.951268411999948],
            [-69.3959403079999, -10.93504201199994],
            [-69.36307409699995, -10.940106301999919],
            [-69.32958776899994, -10.94940805999994],
            [-69.29351761899994, -10.954989114999961],
            [-69.23680273499994, -10.9529220579999],
            [-69.15851293999987, -10.962120462999906],
            [-69.1214867759999, -10.970595397999901],
            [-69.08688940499991, -10.967184752999884],
            [-69.07130896099997, -10.969975279999929],
            [-68.9969982509999, -11.001704609999948],
            [-68.99250240099985, -11.002428079999945],
            [-68.98338151099998, -11.002428079999945],
            [-68.97893733799987, -11.001704609999948],
            [-68.95542456099989, -11.000464375999925],
            [-68.90814062499993, -11.013383483999931],
            [-68.8840335699999, -11.016380716999947],
            [-68.85891882399997, -11.010489603999943],
            [-68.83168534399996, -11.000361021999893],
            [-68.80465856999993, -10.99467661599995],
            [-68.77455704799985, -11.003461608999928],
            [-68.75763301699993, -11.011936543999937],
            [-68.7739886069999, -11.035087584999928],
            [-68.78564164299985, -11.059272154999903],
            [-68.79117102099985, -11.085110371999917],
            [-68.78701106799991, -11.126038105999939],
            [-68.78398799699991, -11.13533986399996],
            [-68.7759264739999, -11.140610859999896],
            [-68.75833064899993, -11.141127623999935],
            [-68.6157295329999, -11.112498880999865],
            [-68.58803096599988, -11.098649596999905],
            [-68.53609615099995, -11.061545918999911],
            [-68.49330806499992, -11.047386575999965],
            [-68.47656490099988, -11.04480275399996],
            [-68.4596667079999, -11.04480275399996],
            [-68.4424067789999, -11.047696634999866],
            [-68.42819576099993, -11.043665872999952],
            [-68.39641475499991, -11.01441701199991],
            [-68.37827632699987, -11.005011900999946],
            [-68.33114741999987, -11.000464375999925],
            [-68.31383581599997, -10.99343638099991],
            [-68.2933202719999, -10.978966979999882],
            [-68.27435502199992, -10.960053405999943],
            [-68.25750850499986, -10.938762714999953],
            [-68.24376257399993, -10.916955260999927],
            [-68.21756262199992, -10.858044127999918],
            [-68.2035583089999, -10.838923848999926],
            [-68.1472826749999, -10.779599303999916],
            [-68.11209102399994, -10.714073587999906],
            [-68.0978800049999, -10.69774383499987],
            [-68.07457393399994, -10.681724140999918],
            [-68.04377478099988, -10.666944681999908],
            [-68.02713496999988, -10.661777038999986],
            [-68.01023677599997, -10.659709980999935],
            [-67.98181473899984, -10.664360859999903],
            [-67.86264888599987, -10.658779804999881],
            [-67.84776607299992, -10.66095021599996],
            [-67.8333483479999, -10.664980976999871],
            [-67.81427974499994, -10.675936380999943],
            [-67.77495397999985, -10.70652882899995],
            [-67.75578202299994, -10.714176940999934],
            [-67.72172725499988, -10.705495299999967],
            [-67.70513911999987, -10.67665985099994],
            [-67.6960440679999, -10.64048634799991],
            [-67.68467525199992, -10.61051401799996],
            [-67.67382320199997, -10.599351907999932],
            [-67.64348913599991, -10.5745472199999],
            [-67.6308284109999, -10.559561054999918],
            [-67.61113968999993, -10.528761900999953],
            [-67.5999775809999, -10.515429381999937],
            [-67.58462967899993, -10.50178680399992],
            [-67.56509598799991, -10.49589569099993],
            [-67.52933589799991, -10.478532409999914],
            [-67.48820145699992, -10.464786477999965],
            [-67.46804764899986, -10.452280781999974],
            [-67.45052933799991, -10.435951028999938],
            [-67.43662837799991, -10.417450866999914],
            [-67.43223588099991, -10.406082051999917],
            [-67.43187414599993, -10.397917174999904],
            [-67.42929032499993, -10.390372415999948],
            [-67.41833491999995, -10.381484069999942],
            [-67.40918819199996, -10.378796894999908],
            [-67.36500484199988, -10.378073424999911],
            [-67.35348099799992, -10.376213073999907],
            [-67.34283565299992, -10.372492370999893],
            [-67.33529089399988, -10.366291198999917],
            [-67.33368892399994, -10.3566793829999],
            [-67.33942500899991, -10.334871927999885],
            [-67.33782303899997, -10.326086933999889],
            [-67.32350866699989, -10.31885223399992],
            [-67.30066768399988, -10.315131529999917],
            [-67.25917150899991, -10.313684590999912],
            [-67.24103308199997, -10.316371764999943],
            [-67.20175899299991, -10.326810403999971],
            [-67.18470576999997, -10.326707051999946],
            [-67.17230342699989, -10.319575703999917],
            [-67.16486201999987, -10.30851694799992],
            [-67.1590742599999, -10.297148131999919],
            [-67.15173620699991, -10.288983254999906],
            [-67.1417626549999, -10.285572611999967],
            [-67.12073034699998, -10.284539082999899],
            [-67.11003332599998, -10.282575377999962],
            [-67.06429968299994, -10.256943867999908],
            [-66.90265580299993, -10.093129576999985],
            [-66.77062251799995, -9.99256724099996],
            [-66.75160559199989, -9.982645364999968],
            [-66.67000850399992, -9.951536152999921],
            [-66.66008662899992, -9.945334980999931],
            [-66.6548156339999, -9.937170104999922],
            [-66.65249019399997, -9.92611134899991],
            [-66.6489245199999, -9.915879414999935],
            [-66.64261999599998, -9.90792124399988],
            [-66.63187129799988, -9.90430389399998],
            [-66.51384232599989, -9.883943379999948],
            [-66.45286413599993, -9.888697611999945],
            [-66.43271032799996, -9.886113788999936],
            [-66.41327998899996, -9.879189147999867],
            [-66.3717321369999, -9.855934752999943],
            [-66.35527319399992, -9.849630227999924],
            [-66.25732051599991, -9.834850768999914],
            [-66.23897538299991, -9.828132831999895],
            [-66.20796952399988, -9.808082376999934],
            [-66.19065791899988, -9.80084767699988],
            [-66.13546748899998, -9.795163268999929],
            [-66.13169510899988, -9.797023620999937],
            [-66.12792272999994, -9.801157734999961],
            [-66.12358190899994, -9.805085143999932],
            [-66.11818172199989, -9.806015319999887],
            [-66.11311743199991, -9.802397968999898],
            [-66.1060635989999, -9.790409036999932],
            [-66.10198116099988, -9.78741180499992],
            [-66.0869949959999, -9.784517923999942],
            [-66.081724, -9.78565480499995],
            [-66.06932165499992, -9.79009897899995],
            [-66.0427858079999, -9.80487843799996],
            [-66.02947912699989, -9.808289082999906],
            [-66.0103846849999, -9.804051614999949],
            [-65.96565873199995, -9.77676645899993],
            [-65.94695186399986, -9.77139210999988],
            [-65.92933020099989, -9.770255227999954],
            [-65.91527421099994, -9.771702168999951],
            [-65.87442399099987, -9.781313984999969],
            [-65.86246089699992, -9.781830748999909],
            [-65.85042028899994, -9.775319518999936],
            [-65.83406469699989, -9.758266295999903],
            [-65.83166174399994, -9.765294290999918],
            [-65.82739843799988, -9.773975930999967],
            [-65.82212744199995, -9.781830748999909],
            [-65.81652054899993, -9.785964863999936],
            [-65.80641780599987, -9.784414570999914],
            [-65.80370479399994, -9.775526224999894],
            [-65.8038856609999, -9.764777526999879],
            [-65.80264542699987, -9.757336120999952],
            [-65.79450638799995, -9.737699075999913],
            [-65.78856359899993, -9.733048196999945],
            [-65.78220739799991, -9.746277363999951],
            [-65.7799594729999, -9.755992532999898],
            [-65.77734981299997, -9.763433939999913],
            [-65.77244055299985, -9.76880828799996],
            [-65.76319046999993, -9.77232228599992],
            [-65.72549251399988, -9.756819355999909],
            [-65.70996374499987, -9.755992532999898],
            [-65.71373612499991, -9.778730162999878],
            [-65.71730179899987, -9.791235859999873],
            [-65.71311600799993, -9.794233092999974],
            [-65.70505448499995, -9.79330291699992],
            [-65.69707047499986, -9.794336445999903],
            [-65.69435746299993, -9.793716328999935],
            [-65.68360876499992, -9.789892272999907],
            [-65.67895788699985, -9.789375507999864],
            [-65.67262752399992, -9.792579446999923],
            [-65.6637133379999, -9.802914732999938],
            [-65.6584940189999, -9.807358906999937],
            [-65.62888342299993, -9.826892597999858],
            [-65.61438818399989, -9.83392059299996],
            [-65.59612056499995, -9.837951353999955],
            [-65.58397660399993, -9.837227884999962],
            [-65.5793774009999, -9.832783710999948],
            [-65.57705196199996, -9.82616912899995],
            [-65.57188431899996, -9.818831074999963],
            [-65.57061824599992, -9.815833841999947],
            [-65.56992061399993, -9.806015319999887],
            [-65.5679827479999, -9.802087910999916],
            [-65.56281510499988, -9.799194029999924],
            [-65.55080033399992, -9.797023620999937],
            [-65.54682124799984, -9.795163268999929],
            [-65.53532324199992, -9.782450865999877],
            [-65.52542720599993, -9.76787811199992],
            [-65.52139644399995, -9.758576354999889],
            [-65.51713313799988, -9.743176777999906],
            [-65.51077693699995, -9.734081725999928],
            [-65.46522416199988, -9.69646128299992],
            [-65.45183996699984, -9.68137176499991],
            [-65.44248653199989, -9.679821471999986],
            [-65.41623490499995, -9.680131530999887],
            [-65.3979931239999, -9.686746113999973],
            [-65.37050126199995, -9.710620625999866],
            [-65.3560576989999, -9.741626484999884],
            [-65.35373225999987, -9.745037128999911],
            [-65.34006384299997, -9.789685566999935],
            [-65.33032283599991, -9.80074432399995],
            [-65.31660274299989, -9.812526549999944],
            [-65.30438126699997, -9.825652363999922],
            [-65.29911027099985, -9.841258645999858],
            [-65.30358028199996, -9.864513040999967],
            [-65.32523270699994, -9.905130716999906],
            [-65.33329422999992, -9.926834817999904],
            [-65.33683406599988, -9.96724578899989],
            [-65.33293249599993, -10.008380228999954],
            [-65.32414750199985, -10.046414081999899],
            [-65.3055698249999, -10.098400572999921],
            [-65.30146154799988, -10.119691263999911],
            [-65.29911027099985, -10.162996113999966],
            [-65.29681066899991, -10.173331400999885],
            [-65.28683711799991, -10.196482441999876],
            [-65.28482173699987, -10.20681772799989],
            [-65.28807735199985, -10.21622283899994],
            [-65.30536311899994, -10.242164408999884],
            [-65.31562089099992, -10.291257018999929],
            [-65.32781652899985, -10.31440806099991],
            [-65.36502355999994, -10.332184752999936],
            [-65.3792345789999, -10.35140838599996],
            [-65.3901899819999, -10.374042662999912],
            [-65.39464619599991, -10.392070069999903],
            [-65.39473750899992, -10.39243947299991],
            [-65.39308386199988, -10.400190937999923],
            [-65.39143021699994, -10.403498228999922],
            [-65.38727026399991, -10.4067021689999],
            [-65.41093806999993, -10.44918019599993],
            [-65.42538163299994, -10.463132832999918],
            [-65.44997961499993, -10.468093769999967],
            [-65.44997961499993, -10.47491505999993],
            [-65.43791316799985, -10.492588398999928],
            [-65.43569108199995, -10.499202982999918],
            [-65.43672460899992, -10.50406056699994],
            [-65.44147884099993, -10.51336232499996],
            [-65.44248653199989, -10.519356790999908],
            [-65.44163387099988, -10.527831725999903],
            [-65.43930843199993, -10.538167011999917],
            [-65.4358977869999, -10.546952005999898],
            [-65.43199621599985, -10.550672708999912],
            [-65.4292315269999, -10.561421406999926],
            [-65.43563940499993, -10.610824075999858],
            [-65.43569108199995, -10.625810241999929],
            [-65.41861202099992, -10.64451710999991],
            [-65.40078365099987, -10.655472512999978],
            [-65.38675349899995, -10.66952850299991],
            [-65.3810690919999, -10.698053893999955],
            [-65.38225764999993, -10.715623880999928],
            [-65.38977657099989, -10.75376108799989],
            [-65.40473689799992, -10.79923634899994],
            [-65.39969844599997, -10.812258808999971],
            [-65.36029516599987, -10.82259409599989],
            [-65.34218257699985, -10.834893085999937],
            [-65.32711889699993, -10.850499368999877],
            [-65.31897985899994, -10.86538218199992],
            [-65.31277868699996, -10.950958352999876],
            [-65.31011734999993, -10.956539407999884],
            [-65.3045104579999, -10.962017109999877],
            [-65.29960119599988, -10.969665221999946],
            [-65.29911027099985, -10.982067565999927],
            [-65.30298600299989, -10.99074920599989],
            [-65.3096522619999, -10.99664031899988],
            [-65.31784297699994, -11.002014668999934],
            [-65.32644710299988, -11.009352721999932],
            [-65.34197587199989, -11.032813821999909],
            [-65.3426993409999, -11.05059051499994],
            [-65.33704077199985, -11.067747089999898],
            [-65.33329422999992, -11.088521016999948],
            [-65.34104569599992, -11.10660776799996],
            [-65.37967382799994, -11.136373391999939],
            [-65.39473750899992, -11.153426614999972],
            [-65.39814815299985, -11.178024596999961],
            [-65.38520320699993, -11.193630879999901],
            [-65.36833085099994, -11.20541310599991],
            [-65.3600109459999, -11.218848978999858],
            [-65.36605708899992, -11.234041848999894],
            [-65.37861446099993, -11.24200001999995],
            [-65.38861385099995, -11.253162129999879],
            [-65.38727026399991, -11.277553404999907],
            [-65.37448034699992, -11.295846861999877],
            [-65.35391312699994, -11.310626322999894],
            [-65.33481868499985, -11.321168313999863],
            [-65.32644710299988, -11.327782897999953],
            [-65.33006445399985, -11.340495300999905],
            [-65.3475052499999, -11.360752460999919],
            [-65.35373225999987, -11.372431334999888],
            [-65.35476578799995, -11.382353209999891],
            [-65.35300878999988, -11.39062143899993],
            [-65.3195482999999, -11.476404316999933],
            [-65.29246984899993, -11.504723001999935],
            [-65.25756241899995, -11.49531789099997],
            [-65.23304195199998, -11.508340352999909],
            [-65.22265498899986, -11.517435403999883],
            [-65.21598872899995, -11.530147806999935],
            [-65.21598872899995, -11.53996632899991],
            [-65.22361100299992, -11.557949726999894],
            [-65.22340429699997, -11.571075540999871],
            [-65.21924434399995, -11.584511413999905],
            [-65.21454178899995, -11.587508645999918],
            [-65.20735876499992, -11.587611998999947],
            [-65.19544734799987, -11.592159524999886],
            [-65.17397578999993, -11.6065255729999],
            [-65.16743872199996, -11.615517272999938],
            [-65.19092565999995, -11.623165384999908],
            [-65.19335445199991, -11.632363789999914],
            [-65.18927201299991, -11.657065123999928],
            [-65.19133907099987, -11.666883645999889],
            [-65.20025325499998, -11.681973164999889],
            [-65.20232031299994, -11.691481628999966],
            [-65.20185522499992, -11.727965189999892],
            [-65.19619665599987, -11.741814472999948],
            [-65.18245072499994, -11.756697285999891],
            [-65.16446732599985, -11.769823099999954],
            [-65.15149654199993, -11.773130390999953],
            [-65.14353837099986, -11.763828633999935],
            [-65.13800899299989, -11.715252786999926],
            [-65.13397823199998, -11.702643737999907],
            [-65.12785457399991, -11.694582213999922],
            [-65.1134110109999, -11.690551452999927],
            [-65.11046545499988, -11.699956563999876],
            [-65.11356603999994, -11.722590839999924],
            [-65.09919999199991, -11.73623341899993],
            [-65.08106156499989, -11.7434681189999],
            [-65.06555863499997, -11.753079935999907],
            [-65.05630855399997, -11.785636087999947],
            [-65.04331193099995, -11.80765024799993],
            [-65.03845434599992, -11.818709004999945],
            [-65.03744665499994, -11.828424173999892],
            [-65.03920365399992, -11.848681334999895],
            [-65.03845434599992, -11.858499856999856],
            [-65.03367427599991, -11.879790547999932],
            [-65.02809322099989, -11.888885598999906],
            [-65.01793880199995, -11.893639830999902],
            [-65.0145281579999, -11.893846536999959],
            [-65.0045804449999, -11.898394062999984],
            [-64.99812088999997, -11.90893605499987],
            [-64.9964930829999, -11.921235045999907],
            [-65.00085974099991, -11.931053567999868],
            [-65.01463151099995, -11.950277200999892],
            [-65.01633683299991, -11.968467304999933],
            [-65.00943802899994, -11.984280292999927],
            [-64.99744909699987, -11.996269225999896],
            [-64.98344478399989, -12.003917337999965],
            [-64.96760595699996, -12.007948099999865],
            [-64.92515376799994, -12.009911803999984],
            [-64.90448319599992, -12.014045918999912],
            [-64.88350256399991, -12.02138397199991],
            [-64.8620826829999, -12.024794616999941],
            [-64.83983597899996, -12.016733092999942],
            [-64.82761450299992, -12.022314147999865],
            [-64.80929520699996, -12.02582814499992],
            [-64.7925003659999, -12.03254608099985],
            [-64.78518815099991, -12.047428893999978],
            [-64.78048559599992, -12.067686055999985],
            [-64.76857417799988, -12.08649627699991],
            [-64.73679317199995, -12.119775898999947],
            [-64.74418290299988, -12.133625182999907],
            [-64.73953202399991, -12.144580585999975],
            [-64.72839575199987, -12.149851582999915],
            [-64.71627762899988, -12.146544290999913],
            [-64.71364213099986, -12.138482766999928],
            [-64.71028316299996, -12.111921080999906],
            [-64.7063815919999, -12.10613332099993],
            [-64.68992264899993, -12.10437632199995],
            [-64.68646032699988, -12.109957376999972],
            [-64.68157690499996, -12.126597187999906],
            [-64.68157690499996, -12.134865416999943],
            [-64.68857906199986, -12.147164408999885],
            [-64.68899247299987, -12.15388234399991],
            [-64.68594356299994, -12.159153339999946],
            [-64.67718440799987, -12.167628274999942],
            [-64.67534989499995, -12.171038919999972],
            [-64.66485957799992, -12.180960794999876],
            [-64.64057165499992, -12.195120136999918],
            [-64.5934169109999, -12.215997415999894],
            [-64.58104040599994, -12.217444355999888],
            [-64.55489213099992, -12.217754414999959],
            [-64.54843257699989, -12.219098001999924],
            [-64.53210282399994, -12.232223815999902],
            [-64.51148392799993, -12.24266245499993],
            [-64.51034704599994, -12.2395618689999],
            [-64.5102436929999, -12.237288105999966],
            [-64.50884842999992, -12.23604787199993],
            [-64.49424983799986, -12.238011575999877],
            [-64.48939225299992, -12.239458515999956],
            [-64.47303666199988, -12.253204446999902],
            [-64.46905757699992, -12.261059264999929],
            [-64.46815323999996, -12.272634785999884],
            [-64.46931595899989, -12.29485565199991],
            [-64.47443192599988, -12.316456400999883],
            [-64.49244116299988, -12.356557311999978],
            [-64.48977982599985, -12.373610533999909],
            [-64.48363033099989, -12.377641296999911],
            [-64.46164200899989, -12.385289407999977],
            [-64.45252111899993, -12.390353697999956],
            [-64.44407202199992, -12.39975880899992],
            [-64.43236730999985, -12.420946146999967],
            [-64.42487422699992, -12.43138478599991],
            [-64.41133500199993, -12.445130716999941],
            [-64.39572871899989, -12.457326354999864],
            [-64.37676346899994, -12.465904642999888],
            [-64.35319901599993, -12.46921193499989],
            [-64.31265885399992, -12.4618738799999],
            [-64.29769852799987, -12.46569793699993],
            [-64.2875441079999, -12.497117207999878],
            [-64.27824235099988, -12.499287617999954],
            [-64.26870804899997, -12.497220560999907],
            [-64.26385046399986, -12.49525685599987],
            [-64.25682246899993, -12.490812682999959],
            [-64.24571203599993, -12.479443867999876],
            [-64.23656530799994, -12.475413105999877],
            [-64.21522294099995, -12.473759459999926],
            [-64.19754960099993, -12.478720396999876],
            [-64.18310603899991, -12.487918802999971],
            [-64.15525244199995, -12.51696095799987],
            [-64.1447879639999, -12.520371601999983],
            [-64.13476273699987, -12.510863138999909],
            [-64.11982824699993, -12.489675801999852],
            [-64.10445450899994, -12.507142435999896],
            [-64.04445817099995, -12.509106139999929],
            [-64.02283158399987, -12.537838235999928],
            [-64.00417639199989, -12.535461120999898],
            [-63.972447062999976, -12.523885599999943],
            [-63.95932124899991, -12.528019713999868],
            [-63.95001949099989, -12.536804707999949],
            [-63.939064086999906, -12.544142760999947],
            [-63.92123571799996, -12.544349466999904],
            [-63.90914343299997, -12.534324238999972],
            [-63.90247717299988, -12.525435891999877],
            [-63.896896117999944, -12.51572072299993],
            [-63.863203084999896, -12.474792988999909],
            [-63.86289302599991, -12.46921193499989],
            [-63.845581420999906, -12.466938171999871],
            [-63.8149889739999, -12.457223001999935],
            [-63.8013980719999, -12.454949238999916],
            [-63.657737589999954, -12.475413105999877],
            [-63.65484370899989, -12.47830698599995],
            [-63.60042842699991, -12.506108906999913],
            [-63.55872554599995, -12.539905292999904],
            [-63.54218908699997, -12.547966816999889],
            [-63.52022660299991, -12.551170755999863],
            [-63.50751420199995, -12.551584166999874],
            [-63.49614538599988, -12.553341165999939],
            [-63.485758422999936, -12.557475280999967],
            [-63.47619828399985, -12.564813333999965],
            [-63.46875687699992, -12.575768737999937],
            [-63.46699987799994, -12.585793964999965],
            [-63.46637976199989, -12.595302428999943],
            [-63.462504028999916, -12.605120950999918],
            [-63.45423579999988, -12.612045592999905],
            [-63.44534745399994, -12.61483611999995],
            [-63.4381644289999, -12.619176940999935],
            [-63.43521887199992, -12.630339049999876],
            [-63.43144649299998, -12.636953633999966],
            [-63.39330928599992, -12.664548848999871],
            [-63.37108841999989, -12.669923196999918],
            [-63.359461221999936, -12.674677428999914],
            [-63.33041906699992, -12.69700164699988],
            [-63.317913370999946, -12.701962585999922],
            [-63.24732336399995, -12.70134246799995],
            [-63.23595454999986, -12.698551940999906],
            [-63.23202714099989, -12.691110534999979],
            [-63.22267370599985, -12.682532245999951],
            [-63.2018481049999, -12.66785613999987],
            [-63.197300577999954, -12.666822610999887],
            [-63.18557002799989, -12.668476256999924],
            [-63.180712443999965, -12.66785613999987],
            [-63.17611324099991, -12.663618672999917],
            [-63.171669067999915, -12.652353209999944],
            [-63.167069864999945, -12.647392272999909],
            [-63.139474649999954, -12.6356100469999],
            [-63.136684122999895, -12.633749695],
            [-63.12505692599984, -12.635920104999883],
            [-63.10521317599995, -12.645221862999918],
            [-63.07503413999984, -12.65266326899993],
            [-63.064750529999856, -12.666202493999918],
            [-63.05782588799988, -12.701962585999922],
            [-63.053588419999926, -12.708370462999966],
            [-63.04707718999995, -12.713538105999973],
            [-63.043459838999865, -12.719119160999895],
            [-63.05110795099995, -12.730798034999864],
            [-63.05219315699995, -12.736482441999911],
            [-63.05110795099995, -12.742166849999947],
            [-63.047904012999965, -12.746714375999986],
            [-63.02568314599992, -12.76573130199995],
            [-63.01472774299995, -12.777720234999919],
            [-63.01002518799987, -12.787952168999894],
            [-63.00707963099998, -12.809966328999877],
            [-62.99917313699993, -12.829086608999958],
            [-62.988011026999914, -12.843866067999983],
            [-62.97529862499994, -12.852857767999922],
            [-62.964498249999906, -12.856578470999935],
            [-62.95514481599989, -12.85750864699989],
            [-62.94651485199992, -12.855234883999884],
            [-62.93803991699991, -12.849447122999905],
            [-62.92889318899992, -12.846036478999878],
            [-62.92377722199984, -12.852857767999922],
            [-62.92046993099984, -12.862262878999971],
            [-62.867914998999964, -12.929028828999918],
            [-62.86507279499989, -12.935540059],
            [-62.860111857999954, -12.940294290999887],
            [-62.84900142399994, -12.942154642999895],
            [-62.83892451999989, -12.942774759999864],
            [-62.83143143799995, -12.94494516999994],
            [-62.82667720599997, -12.950009459999919],
            [-62.825075236999936, -12.958691100999971],
            [-62.820165974999895, -12.974917500999894],
            [-62.80740189599993, -12.988870137999882],
            [-62.78983190999995, -13.00065236399989],
            [-62.77045324799988, -13.01047088599995],
            [-62.768644571999886, -12.990627135999958],
            [-62.75789587399987, -12.985149433999965],
            [-62.74130773999988, -12.985356139999922],
            [-62.72203242999993, -12.982565611999874],
            [-62.70916499899994, -12.974607441999908],
            [-62.698984740999975, -12.966649270999937],
            [-62.686634073999926, -12.964995625999904],
            [-62.66746211799992, -12.976364440999888],
            [-62.6579019779999, -12.984632669999925],
            [-62.65133907099991, -12.992487487999966],
            [-62.64751501499998, -13.00158253999993],
            [-62.64518957599995, -13.025353698999893],
            [-62.641675577999905, -13.03000457799996],
            [-62.55460078899995, -13.06679819699987],
            [-62.49269242399993, -13.065041198999978],
            [-62.47212520399992, -13.06845184399991],
            [-62.45848262599992, -13.077960305999895],
            [-62.43093908699984, -13.109792988999942],
            [-62.42871700099994, -13.114547220999924],
            [-62.4274767659999, -13.124572448999956],
            [-62.424117797999884, -13.12653615299989],
            [-62.41026851399991, -13.125709329999964],
            [-62.406702840999856, -13.12653615299989],
            [-62.389701293999934, -13.137078144999947],
            [-62.3818464769999, -13.13986867299991],
            [-62.33502762899988, -13.145139668999946],
            [-62.321591756999936, -13.143692728999952],
            [-62.310533, -13.133977558999916],
            [-62.290327514999944, -13.1420390829999],
            [-62.273636026999895, -13.138421732999916],
            [-62.25916662599988, -13.130773619999943],
            [-62.22164953699988, -13.121265156999954],
            [-62.21152095499991, -13.120334981999903],
            [-62.20092728699984, -13.122712096999948],
            [-62.17395218999991, -13.140798848999864],
            [-62.1724535729999, -13.117854512999926],
            [-62.16237666899988, -13.120748392999914],
            [-62.13984574399984, -13.14700002099994],
            [-62.129148722999844, -13.150927428999921],
            [-62.120467081999976, -13.14875701899993],
            [-62.114679321999915, -13.150203958999924],
            [-62.11250891099991, -13.164776712999881],
            [-62.11245723499991, -13.231801045999887],
            [-62.10940832599988, -13.248957620999946],
            [-62.099228068999906, -13.262600198999863],
            [-62.07773067299988, -13.277896422999916],
            [-62.03359899899988, -13.325542093999957],
            [-62.019698038999906, -13.332570088999958],
            [-62.01866450999992, -13.336807555999926],
            [-62.003264933999844, -13.360475361999946],
            [-61.99778723199995, -13.36409271199993],
            [-61.97535966099986, -13.374117940999952],
            [-61.958358113999935, -13.385486754999945],
            [-61.90983394399987, -13.431892190999946],
            [-61.89949865799994, -13.439230244999948],
            [-61.879913289999934, -13.449152119999937],
            [-61.87231685399988, -13.456076761999924],
            [-61.86859615099985, -13.463931578999862],
            [-61.84797725399994, -13.530800881999923],
            [-61.836350056999976, -13.540619404999902],
            [-61.81397416199991, -13.54423675599989],
            [-61.79428544099994, -13.540309345999916],
            [-61.7742349859999, -13.533384704999932],
            [-61.75433955999989, -13.530284118999887],
            [-61.735115926999896, -13.538035582999981],
            [-61.71573726399993, -13.52656341499997],
            [-61.69289628099992, -13.51798512799995],
            [-61.66809159399986, -13.512507425999956],
            [-61.597114013999885, -13.506099547999924],
            [-61.593060170999934, -13.506794492999958],
            [-61.58807063899994, -13.507649840999932],
            [-61.56086299699993, -13.532661233999931],
            [-61.55081193099991, -13.538035582999981],
            [-61.50342464199991, -13.548164163999942],
            [-61.45875036699988, -13.543719990999932],
            [-61.41547135399992, -13.528113707999907],
            [-61.347723551999934, -13.493697204999947],
            [-61.33237565199994, -13.49483408599987],
            [-61.31713110399991, -13.500931904999916],
            [-61.28121598299995, -13.50723642999992],
            [-61.2600286469999, -13.520052184999912],
            [-61.24855647799998, -13.524393004999894],
            [-61.23788529499987, -13.524393004999894],
            [-61.21504431199989, -13.517468362999907],
            [-61.14910518399995, -13.519845478999954],
            [-61.1393124999999, -13.514057718999979],
            [-61.133576415999926, -13.49400726299993],
            [-61.1187194419999, -13.484498798999951],
            [-61.076008869999896, -13.478297627999964],
            [-61.07218481499987, -13.474370218999894],
            [-61.06011836799988, -13.467135518999925],
            [-61.04722509799987, -13.464551696999933],
            [-61.04125646999995, -13.474576924999951],
            [-61.04125646999995, -13.515194600999891],
            [-61.02200699899993, -13.535245055999937],
            [-60.97787532599992, -13.542996520999935],
            [-60.92929947899992, -13.54620045899992],
            [-60.89674332699988, -13.552918395999939],
            [-60.878243163999855, -13.570385029999983],
            [-60.8706725669999, -13.575449320999951],
            [-60.80196875099995, -13.60418141599996],
            [-60.72557172299989, -13.662844600999975],
            [-60.6527013759999, -13.718799742999906],
            [-60.61807816599989, -13.736886494999922],
            [-60.595082153999925, -13.741640725999915],
            [-60.58862259999995, -13.744534606999906],
            [-60.58487605799985, -13.749082131999941],
            [-60.5795792239999, -13.761071064999982],
            [-60.575135050999904, -13.765618590999935],
            [-60.56606583699994, -13.769959411999906],
            [-60.49061824599994, -13.787736104999937],
            [-60.47263484699994, -13.797864684999894],
            [-60.465270955999955, -13.816571552999974],
            [-60.46312638399988, -13.843443297999968],
            [-60.4573127859999, -13.870935160999949],
            [-60.44881201199988, -13.896773375999956],
            [-60.438554240999906, -13.918374124999929],
            [-60.43044103999989, -13.92674570699991],
            [-60.40863358599995, -13.94452239999994],
            [-60.406721557999845, -13.950413512999944],
            [-60.41160498099987, -13.960542094],
            [-60.40542964799991, -13.966743265999881],
            [-60.395740315999944, -13.970980733999923],
            [-60.389694173999914, -13.974908141999904],
            [-60.38718786699994, -13.98327972399997],
            [-60.38796301299993, -13.989377542999932],
            [-60.39651546199988, -14.008394470999903],
            [-60.40940873199989, -14.05531666999994],
            [-60.419433960999896, -14.076917418999912],
            [-60.437236490999936, -14.092006937999912],
            [-60.461395223999915, -14.098621520999913],
            [-60.46826818899987, -14.103685811999895],
            [-60.47351334599989, -14.11722503699987],
            [-60.47764746199991, -14.139962666999935],
            [-60.47893937199987, -14.162700296999915],
            [-60.4756837569999, -14.176032816999935],
            [-60.462402913999966, -14.19846038799993],
            [-60.46201534099987, -14.223885192999944],
            [-60.46563269099994, -14.251066995999935],
            [-60.4643407799999, -14.27835215199994],
            [-60.45431555199988, -14.296645609999914],
            [-60.399926106999914, -14.340777281999905],
            [-60.39134781899986, -14.357107034999942],
            [-60.37669755099998, -14.419945576999922],
            [-60.34380550199995, -14.490948994999911],
            [-60.338431151999885, -14.53260019899993],
            [-60.36920446799985, -14.542832132999905],
            [-60.35271968599997, -14.575388284999946],
            [-60.30404048699995, -14.608151142999944],
            [-60.2917156579999, -14.630061949999913],
            [-60.288821777999914, -14.690730081999988],
            [-60.284868530999944, -14.77268890299996],
            [-60.28088944499987, -14.854647724999921],
            [-60.27685868399996, -14.936606546999897],
            [-60.27290543699988, -15.018565367999955],
            [-60.269804849999844, -15.083367614999972],
            [-60.27497249399994, -15.09514984099988],
            [-60.38930659999991, -15.096493428999935],
            [-60.582240559999946, -15.098870543999894],
            [-60.529478922999914, -15.143725686999872],
            [-60.460180826999874, -15.22423756899994],
            [-60.3521254069999, -15.349604593999914],
            [-60.26045141599991, -15.456058043999931],
            [-60.246395425999935, -15.478278909999915],
            [-60.237972167999885, -15.502670185999904],
            [-60.22482051599991, -15.651394957999912],
            [-60.20699214699988, -15.853036396999897],
            [-60.19376297999989, -16.00145110999992],
            [-60.18696752999995, -16.108731383999967],
            [-60.1798103429999, -16.222006122999943],
            [-60.16069006399991, -16.264794209999963],
            [-60.12983923399992, -16.273062438999915],
            [-60.06041194699995, -16.275439554999963],
            [-59.87001013199992, -16.282157490999893],
            [-59.67955664099986, -16.288772074999898],
            [-59.48910314999992, -16.295386656999895],
            [-59.29867549699989, -16.302104593999914],
            [-59.10824784399995, -16.308719176999915],
            [-58.91776851499989, -16.315437113999934],
            [-58.72744421499988, -16.32215504899996],
            [-58.53696488499992, -16.32876963299995],
            [-58.46472123299989, -16.331250101999927],
            [-58.44224198399988, -16.328459574999968],
            [-58.421623087999876, -16.318434345999947],
            [-58.414233357999876, -16.308925882999873],
            [-58.400332397999904, -16.284224547999955],
            [-58.392942667999904, -16.279366963999934],
            [-58.34974117099995, -16.280400491999913],
            [-58.339560913999975, -16.289288838999923],
            [-58.33454829899992, -16.38664723699989],
            [-58.3388374429999, -16.400496520999937],
            [-58.36229854399997, -16.419306741999947],
            [-58.363590453999905, -16.436670022999877],
            [-58.34266149899992, -16.473153584999892],
            [-58.35609737199988, -16.50953379299996],
            [-58.4558845629999, -16.61908782999994],
            [-58.47267940299986, -16.64957692499992],
            [-58.480275838999916, -16.683683369999898],
            [-58.47665848799994, -16.726988219999953],
            [-58.45624629799988, -16.802435811999956],
            [-58.45293900599998, -16.841296487999912],
            [-58.455109415999885, -16.848324482999928],
            [-58.46404943899992, -16.866101174999955],
            [-58.46663326099991, -16.875506285999904],
            [-58.4662715259999, -16.887288512999916],
            [-58.456349650999925, -16.93700124099992],
            [-58.43919307499996, -16.96728362999994],
            [-58.43247513899993, -16.985370380999953],
            [-58.4267907309999, -17.055236917999935],
            [-58.421623087999876, -17.07063649499993],
            [-58.410977742999904, -17.088206481999904],
            [-58.40627518799991, -17.110117288999945],
            [-58.40482824699993, -17.19962086999996],
            [-58.39914383999988, -17.237448017999952],
            [-58.38116044199998, -17.267213642999934],
            [-58.3436950279999, -17.286954040999902],
            [-58.31217240399994, -17.290881449999873],
            [-58.30214717699991, -17.293775328999956],
            [-58.29227697799993, -17.29966644299995],
            [-58.27439693199997, -17.31403249099995],
            [-58.2645267339999, -17.320026956999897],
            [-58.256155151999934, -17.32250742599996],
            [-58.23992875199991, -17.32519459999989],
            [-58.231557169999945, -17.32974212599993],
            [-58.220240030999946, -17.344314879999985],
            [-58.20406530799997, -17.377387796999884],
            [-58.1884073489999, -17.388549906999913],
            [-58.174558065999946, -17.392063903999954],
            [-58.163189249999874, -17.39340749099992],
            [-58.15223384599989, -17.396404723999936],
            [-58.1393664149999, -17.40456959999996],
            [-58.11202958199996, -17.433508401999916],
            [-58.10112585499991, -17.44125986699993],
            [-58.06572749899988, -17.455935973999914],
            [-58.05368688999991, -17.462343851999947],
            [-58.01017533399988, -17.496760354999907],
            [-57.98149491399991, -17.508749286999958],
            [-57.943564412999905, -17.51784433999994],
            [-57.9056855879999, -17.520324808999916],
            [-57.8770051679999, -17.512263284999918],
            [-57.8541125079999, -17.508542581999905],
            [-57.83674922699987, -17.51102305099998],
            [-57.814425007999915, -17.519704691999934],
            [-57.800730753999886, -17.53345062299988],
            [-57.79075720299997, -17.555774840999945],
            [-57.78827673399991, -17.58057952899989],
            [-57.78956864399996, -17.604143981999883],
            [-57.78755326399991, -17.620473733999916],
            [-57.78796667499992, -17.65892099999988],
            [-57.785899617999945, -17.677524514999917],
            [-57.777941446999904, -17.695507913999904],
            [-57.767554483999874, -17.70873708099991],
            [-57.75489375899991, -17.720622659999933],
            [-57.74037268099988, -17.73023447699994],
            [-57.724456339999875, -17.736642353999883],
            [-57.73298295099997, -17.76847503699993],
            [-57.72931392399997, -17.77932708699997],
            [-57.7113305259999, -17.80082448299993],
            [-57.69680944899994, -17.82511240699992],
            [-57.69877315299988, -17.843095804999905],
            [-57.73008907099998, -17.84609303799992],
            [-57.63691646399988, -18.00112233499995],
            [-57.5854984129999, -18.122768656999895],
            [-57.55108190999994, -18.183643492999934],
            [-57.51118770399992, -18.205554300999978],
            [-57.49072383699985, -18.205554300999978],
            [-57.47454911299985, -18.208034768999966],
            [-57.465660766999946, -18.2177499389999],
            [-57.46679764899994, -18.23955739399993],
            [-57.53573400899998, -18.24048756899988],
            [-57.55387243699991, -18.244518330999966],
            [-57.5667398679999, -18.256093850999918],
            [-57.58301794399992, -18.305703225999906],
            [-57.63004349799991, -18.44843353299997],
            [-57.67701737499996, -18.591060485999932],
            [-57.723991251999934, -18.733687438999894],
            [-57.77106848199992, -18.87631439199994],
            [-57.78233394399987, -18.910420836999904],
            [-57.74223303299988, -18.913624776999967],
            [-57.731794392999944, -18.921996357999944],
            [-57.72755692599989, -18.941943460999966],
            [-57.72176916499993, -19.001164651999957],
            [-57.71582637599991, -19.044572854999956],
            [-57.77189530499993, -19.048706970999973],
            [-57.789000203999905, -19.05924896199994],
            [-57.81204789199995, -19.105034280999888],
            [-57.843105428999905, -19.16683929499989],
            [-57.911628376999914, -19.30285166399993],
            [-57.980047973999916, -19.438864033999977],
            [-58.011208862999865, -19.50066904699989],
            [-58.011208862999865, -19.500772398999914],
            [-58.01126053899989, -19.50087575299993],
            [-58.023559529999915, -19.52568043999989],
            [-58.050482950999935, -19.580147399999888],
            [-58.07745804799987, -19.6347177129999],
            [-58.08975703999991, -19.659419046999915],
            [-58.1246386309999, -19.729905699999875],
            [-58.1169388429999, -19.75801767999991],
            [-58.04112951699989, -19.823440042999977],
            [-57.96046260599988, -19.893099873999915],
            [-57.85974523899992, -19.980122985999955],
            [-57.86977046799984, -19.992938740999932],
            [-57.881139281999936, -20.00916514099994],
            [-57.895608682999864, -20.024151305999922],
            [-57.91793290299992, -20.03417653399994],
            [-57.94320267799989, -20.028078714999893],
            [-57.959170694999926, -20.02621836299997],
            [-57.9663537189999, -20.031075947999895],
            [-57.968937540999974, -20.039757587999958],
            [-57.97581050699995, -20.04750905399996],
            [-57.985680704999936, -20.053090107999978],
            [-57.99710119599993, -20.05526051799997],
            [-58.02237097199989, -20.064975686999915],
            [-58.05353186099995, -20.107660420999906],
            [-58.079576782999936, -20.117375589999938],
            [-58.086243042999854, -20.120889588],
            [-58.09828365099992, -20.1381495159999],
            [-58.10355464799994, -20.14404062899989],
            [-58.11631872599992, -20.150448505999933],
            [-58.15879675299996, -20.165124612999918],
            [-58.15952022399995, -20.13907969199994],
            [-58.144740762999845, -20.086163024999877],
            [-58.143138793999924, -20.06528574699989],
            [-58.14448238199989, -20.02311777799993],
            [-58.141846883999875, -20.0008969109999],
            [-58.14515417599995, -19.969580992999894],
            [-58.16220739799991, -19.912323506999925],
            [-58.16422277899994, -19.88028411799992],
            [-58.161173868999924, -19.84721120199994],
            [-58.164429483999896, -19.83294850699987],
            [-58.175281534999954, -19.821372984999925],
            [-58.214452270999885, -19.798325296999863],
            [-58.30777990799996, -19.74365163199991],
            [-58.401004190999885, -19.688874612999925],
            [-58.49428015199993, -19.634200947999958],
            [-58.58750443499986, -19.57942392999989],
            [-58.6808320719999, -19.52475026399992],
            [-58.77410803299995, -19.47007659899988],
            [-58.86743566899992, -19.415299580999985],
            [-58.96065995299995, -19.3605225619999],
            [-59.01109615099995, -19.330963643999965],
            [-59.039673217999905, -19.311636657999927],
            [-59.06964554899986, -19.291482848999948],
            [-59.08954097499986, -19.28672861699995],
            [-59.170724649999926, -19.287762145999935],
            [-59.35908524599989, -19.290139261999883],
            [-59.547497517999886, -19.292413024999902],
            [-59.73585811399997, -19.294790140999936],
            [-59.92432206299989, -19.29706390399987],
            [-60.00638423699988, -19.298097431999935],
            [-60.15699519899991, -19.328999938999942],
            [-60.49547582999986, -19.39845306399991],
            [-60.83393062399992, -19.46790618899989],
            [-61.172359578999874, -19.53746266699997],
            [-61.510840210999845, -19.60691579099995],
            [-61.53228592999997, -19.610016377999983],
            [-61.57954402699991, -19.616837666999942],
            [-61.62672460999994, -19.623658954999897],
            [-61.648222005999884, -19.626759541999945],
            [-61.73723465999987, -19.639575296999922],
            [-61.753202677999894, -19.64587982199994],
            [-61.76121252499988, -19.657765400999963],
            [-61.7800744219999, -19.706961363999937],
            [-61.80818640099994, -19.780341897999875],
            [-61.83629838099998, -19.85382578499994],
            [-61.86441035999991, -19.927413024999936],
            [-61.892574015999855, -20.0008969109999],
            [-61.90554479999989, -20.026735127999913],
            [-61.918412231999895, -20.05257334399994],
            [-61.92473979899995, -20.06512763899987],
            [-61.931383016999916, -20.078308206999935],
            [-61.944250447999906, -20.104146422999946],
            [-61.96094193599993, -20.128020934999938],
            [-61.97758174699996, -20.1517920939999],
            [-61.99416988099995, -20.175666604999975],
            [-62.010809692999885, -20.19954111699988],
            [-62.055509806999936, -20.26041595399991],
            [-62.10020992099987, -20.321187438999928],
            [-62.14496171099992, -20.382062275999957],
            [-62.18966182499989, -20.442833760999875],
            [-62.21057310199993, -20.471305462999922],
            [-62.23239823499989, -20.501021422999983],
            [-62.26883011899989, -20.553111266999935],
            [-62.277305053999896, -20.579776305999886],
            [-62.27616817299989, -20.67072682699998],
            [-62.275031290999976, -20.758680115],
            [-62.273791056999926, -20.854798277999905],
            [-62.27188577399994, -21.000423652999885],
            [-62.271879027999915, -21.000939229999915],
            [-62.27570308499986, -21.06656829799995],
            [-62.30789750199992, -21.16930104599996],
            [-62.34040197799993, -21.272860615999903],
            [-62.375490275999965, -21.384481709999932],
            [-62.41197383699998, -21.50085703499994],
            [-62.44618363499998, -21.60689707399986],
            [-62.49279577699994, -21.751797789999927],
            [-62.529227661999954, -21.865072529999907],
            [-62.57284256999989, -22.000774840999966],
            [-62.59940425699992, -22.089865010999887],
            [-62.627516234999945, -22.184536233999907],
            [-62.65035721899994, -22.234455667999967],
            [-62.65898718299991, -22.231665140999908],
            [-62.661829386999955, -22.22453379299988],
            [-62.66322465099995, -22.21554209399993],
            [-62.66746211799992, -22.20655039399989],
            [-62.679296020999914, -22.194768167999896],
            [-62.72203242999993, -22.166242776999937],
            [-62.7693680429999, -22.144745381],
            [-62.78347570899993, -22.130896097999937],
            [-62.79091711499984, -22.113222757999935],
            [-62.791072143999884, -22.081596781999934],
            [-62.79779007999991, -22.069401143999926],
            [-62.79505122899988, -22.061132913999884],
            [-62.794999552999855, -22.05121103999997],
            [-62.8013557539999, -22.01348724299993],
            [-62.8043529869999, -22.004082131999965],
            [-62.81856400599986, -22.00087819399991],
            [-62.86202388599986, -21.993230081999926],
            [-63.00992183499994, -22.00067148899994],
            [-63.01043859899988, -22.000774840999966],
            [-63.32491552749988, -21.999121195499967],
            [-63.63939245599988, -21.997467549999968],
            [-63.67783972199993, -22.003668720999954],
            [-63.69391109299991, -22.012040302999935],
            [-63.74041988099992, -22.050590921999913],
            [-63.75178869699991, -22.045733336999902],
            [-63.79302648999993, -22.011523538999896],
            [-63.81312862199988, -22.003048604999904],
            [-63.90640458199994, -21.997157490999896],
            [-63.933172973999916, -22.00180836999995],
            [-63.94759069899993, -22.007596129999925],
            [-63.950949666999946, -22.0108000689999],
            [-63.951466430999886, -22.016691181999903],
            [-63.96102657099988, -22.039118753999986],
            [-63.96464392099995, -22.058549092999968],
            [-63.96810624199989, -22.066507262999934],
            [-63.975806030999905, -22.073845315999932],
            [-63.983454141999886, -22.077359313999892],
            [-63.990378783999944, -22.079323017999926],
            [-63.995649780999884, -22.0829403689999],
            [-64.00438309799995, -22.099270120999932],
            [-64.01978267499993, -22.155390726999897],
            [-64.05102107799993, -22.22918467199993],
            [-64.05879838099995, -22.24034678099987],
            [-64.0788746749999, -22.25057871499986],
            [-64.0862385659999, -22.257916767999944],
            [-64.1605492759999, -22.438474223],
            [-64.18470800799994, -22.471237080999913],
            [-64.23633276399997, -22.516712341999963],
            [-64.25082800299992, -22.540690204999876],
            [-64.29397782399994, -22.690861917999968],
            [-64.29459794199991, -22.762898864999954],
            [-64.30348628799993, -22.782329202999932],
            [-64.3269473879999, -22.85922373499993],
            [-64.32529374199996, -22.871936136999878],
            [-64.34389725799991, -22.863667906999936],
            [-64.34772131399984, -22.81695241299994],
            [-64.35999446599988, -22.80299977599995],
            [-64.3523205159999, -22.77912526399996],
            [-64.35573116099991, -22.751943460999968],
            [-64.36898616599993, -22.72972259499994],
            [-64.39076778199984, -22.72052419099994],
            [-64.40172318499992, -22.712359313999926],
            [-64.42828487199992, -22.659029235999924],
            [-64.43823258499992, -22.65189788799998],
            [-64.44722428399987, -22.64869394899992],
            [-64.45370967599985, -22.642906188999945],
            [-64.45624182199992, -22.628023375999902],
            [-64.45520829299994, -22.61665456099992],
            [-64.45045406099987, -22.597120869999912],
            [-64.44942053199989, -22.58709564199998],
            [-64.44554480099993, -22.576243590999937],
            [-64.43725073299987, -22.567355244999916],
            [-64.42983516499996, -22.55712331099994],
            [-64.42828487199992, -22.54234385199993],
            [-64.4837336839999, -22.49118418299993],
            [-64.4981255699999, -22.47278737399992],
            [-64.50404252099992, -22.449946390999926],
            [-64.50781490099985, -22.44395192399989],
            [-64.52574662299992, -22.43299652099992],
            [-64.53132767799994, -22.42565846699992],
            [-64.53106929599994, -22.415529886999963],
            [-64.52329199299993, -22.396202900999924],
            [-64.52455806599988, -22.38535085099997],
            [-64.5378905849999, -22.374292092999966],
            [-64.55887121599991, -22.360649515999867],
            [-64.57202286799989, -22.34318288199991],
            [-64.56207515499997, -22.319825133999956],
            [-64.54915604699997, -22.305355732999928],
            [-64.54225724299991, -22.291506448999968],
            [-64.54277400699993, -22.27548675599992],
            [-64.5518432209999, -22.255022887999957],
            [-64.56021480299998, -22.243137308999934],
            [-64.58687984199992, -22.21275156699997],
            [-64.59620743899995, -22.20655039399989],
            [-64.61628373199991, -22.202209574999912],
            [-64.63871130399991, -22.191667581999937],
            [-64.65777990799998, -22.178438414999945],
            [-64.67904475999995, -22.175441182999933],
            [-64.68744217999995, -22.172857359999938],
            [-64.69524532099987, -22.174200947999907],
            [-64.71369380699988, -22.181745706999948],
            [-64.72289221199989, -22.183296],
            [-64.7623213299999, -22.17440765399995],
            [-64.83247208699996, -22.137510680999924],
            [-65.0203675949999, -22.096582946999916],
            [-65.19047821899997, -22.09847395899996],
            [-65.45734350599994, -22.101440530999923],
            [-65.51046687899986, -22.09585947699992],
            [-65.57989416599992, -22.086454365999955],
            [-65.58852412999997, -22.087281187999892],
            [-65.5934333909999, -22.091105244999923],
            [-65.59787756399993, -22.095652770999948],
            [-65.60531896999993, -22.09906341499989],
            [-65.74461279399989, -22.11404958099986],
            [-65.77530859399994, -22.105057880999908],
            [-65.80455745399988, -22.085834248999987],
            [-65.9326891689999, -21.944550882999906],
            [-65.95449662299993, -21.933078714999894],
            [-66.04653234899993, -21.917989196999983],
            [-66.05175166899994, -21.91261484799992],
            [-66.06358557199985, -21.864039000999924],
            [-66.09448807899994, -21.83292978999988],
            [-66.13781876599992, -21.812465921999916],
            [-66.22246476199993, -21.786937763999973],
            [-66.2400089109999, -21.792415465999866],
            [-66.2875512299999, -21.956953225999968],
            [-66.29716304599992, -22.05028086399993],
            [-66.3015038659999, -22.064956969999912],
            [-66.30760168499995, -22.077049254999906],
            [-66.30982377199987, -22.078186136999918],
            [-66.3140612389999, -22.075809020999955],
            [-66.32667028899994, -22.077359313999892],
            [-66.33524857599988, -22.082320250999928],
            [-66.34300004099987, -22.090485127999955],
            [-66.34917537499985, -22.100200296999986],
            [-66.35323197499986, -22.10960540799995],
            [-66.37746822099984, -22.12707204099989],
            [-66.51032832899995, -22.162935485999938],
            [-66.62675533099988, -22.192597757999906],
            [-66.6305793869999, -22.197351989999987],
            [-66.63326656099994, -22.204896748999943],
            [-66.63631546999997, -22.211304625999972],
            [-66.64137976099994, -22.212544859999923],
            [-66.65781286599992, -22.207377216999916],
            [-66.67739823399992, -22.205103453999897],
            [-66.68845699099992, -22.20169280999997],
            [-66.6993090419999, -22.20076263499992],
            [-66.71284826699986, -22.20644704099996],
            [-66.73589595599992, -22.22505055799992],
            [-66.74886674099994, -22.24489430699991],
            [-66.75610144099991, -22.268252054999948],
            [-66.76793534399994, -22.342562763999936],
            [-66.7751700439999, -22.365197041999892],
            [-66.78803747599989, -22.38007985399993],
            [-66.79051794399996, -22.388348082999883],
            [-66.78447180199993, -22.41728688499994],
            [-66.78509191899988, -22.427622171999957],
            [-66.7964607349999, -22.434856872999916],
            [-66.90865026899988, -22.4675163779999],
            [-66.9353153079999, -22.480538838999934],
            [-66.95557246899992, -22.50069264699991],
            [-66.96523596299994, -22.514335225999915],
            [-66.97815506999984, -22.522500100999935],
            [-66.99355464699994, -22.525807392999937],
            [-67.01567216099994, -22.523843688999904],
            [-67.03272538299987, -22.524567158999986],
            [-67.0243538009999, -22.61758473699996],
            [-67.02662756399991, -22.639392190999985],
            [-67.03768632099991, -22.654585062999928],
            [-67.11323726399985, -22.710085550999906],
            [-67.14269283099995, -22.742745055999976],
            [-67.19390417499997, -22.82222340899996],
            [-67.51026729399993, -22.885785420999937],
            [-67.54711258999993, -22.892503356999967],
            [-67.61677242099995, -22.89725758799996],
            [-67.77143998299988, -22.888679300999925],
            [-67.80358272299992, -22.878654072999907],
            [-67.81128251099992, -22.871626077999892],
            [-67.83303828999993, -22.840103454999934],
            [-67.83794754999985, -22.840826923999927],
            [-67.8763431399999, -22.833592223999872],
            [-67.88709183799992, -22.81870941199992],
            [-67.89148433499992, -22.792871195999894],
            [-67.89132930499997, -22.715666605999914],
            [-67.8587214769999, -22.566838479999973],
            [-67.85918656499993, -22.547304788999966],
            [-67.88967565999991, -22.49118418299993],
            [-67.89820227099992, -22.441471455999917],
            [-67.9069355879999, -22.420077411999912],
            [-67.94527950099993, -22.35424163799992],
            [-67.95189408399992, -22.33408782899994],
            [-67.9522041429999, -22.314140726999923],
            [-67.93478918499997, -22.251715596999958],
            [-67.93597774299991, -22.23228525799989],
            [-67.94496944199994, -22.208307392999956],
            [-67.97302974499988, -22.170583597999922],
            [-67.97659541899992, -22.159834899999893],
            [-67.97328812699993, -22.150429788999944],
            [-67.96062740099998, -22.133686624999896],
            [-67.95716507999995, -22.12459157299992],
            [-67.96062740099998, -22.102887470999917],
            [-67.97261633299985, -22.078806253999886],
            [-67.99018632099992, -22.057618916999928],
            [-68.01023677599997, -22.044906513999962],
            [-68.05876094599995, -22.000774840999966],
            [-68.08273881099987, -21.98031097399992],
            [-68.09204056899989, -21.968425394999898],
            [-68.09622635999995, -21.953955993999955],
            [-68.10759517399993, -21.789624938999907],
            [-68.12836909999987, -21.712316996999988],
            [-68.19058752499987, -21.60638030999992],
            [-68.19844234199991, -21.571860452999942],
            [-68.19373978699994, -21.32846445699991],
            [-68.20753739499989, -21.284332783999915],
            [-68.41631018099991, -20.959804788999932],
            [-68.43207149299988, -20.945025328999918],
            [-68.45393062299993, -20.9397543339999],
            [-68.49599523899985, -20.941614684999905],
            [-68.51020625799993, -20.94016774499991],
            [-68.53155442599987, -20.927688032999924],
            [-68.55511307799992, -20.91391611699997],
            [-68.5719595949999, -20.87236826599988],
            [-68.57278641799991, -20.742867126999982],
            [-68.56508662999994, -20.719509378999945],
            [-68.55020381699998, -20.6990455119999],
            [-68.48162919099985, -20.643028258999962],
            [-68.48095739799987, -20.624734802999896],
            [-68.51020625799993, -20.601893818999898],
            [-68.5363028569999, -20.591765237999937],
            [-68.58332841099988, -20.563033141999938],
            [-68.68554439299996, -20.51683441099989],
            [-68.70755855399995, -20.50091807099996],
            [-68.72967606599985, -20.479213968999957],
            [-68.75070837399997, -20.451825459999924],
            [-68.76541031999994, -20.421233012],
            [-68.76902766999984, -20.390537210999966],
            [-68.75768469299996, -20.36428558399993],
            [-68.73515376899994, -20.347542419999883],
            [-68.67851639899993, -20.32862884499994],
            [-68.71804886899989, -20.261966247999936],
            [-68.7294693609999, -20.228686624999895],
            [-68.72828080299988, -20.189619242999882],
            [-68.7232681889999, -20.160990498999894],
            [-68.72626542199993, -20.150965270999876],
            [-68.75902827999991, -20.144143981999918],
            [-68.78946569899989, -20.125850524999947],
            [-68.79259212199995, -20.106626891999923],
            [-68.7755388999999, -20.08967702199992],
            [-68.65288488799987, -20.054226988999886],
            [-68.62213741099993, -20.0513331089999],
            [-68.60777136199994, -20.05360687299992],
            [-68.59717769399995, -20.056707457999963],
            [-68.58834102399993, -20.055570576999955],
            [-68.5793493249999, -20.04544199599991],
            [-68.5745434159999, -20.035210062999923],
            [-68.5661201579999, -20.0008969109999],
            [-68.56493159999988, -19.981363219999892],
            [-68.54462276199988, -19.93475107799992],
            [-68.54157385299993, -19.92038502999992],
            [-68.54291743999991, -19.91418385799993],
            [-68.5469482009999, -19.908189391999912],
            [-68.55154740499995, -19.89444346099988],
            [-68.55252925699992, -19.864884540999938],
            [-68.55351110799998, -19.857856546999926],
            [-68.56110754399995, -19.84431732099995],
            [-68.5708227129999, -19.837599385999923],
            [-68.60157019099995, -19.825403747999914],
            [-68.61888179599995, -19.81341481499996],
            [-68.6503527429999, -19.781582132999915],
            [-68.69841182499994, -19.746338805999926],
            [-68.70543981899996, -19.733833109999935],
            [-68.70321773299986, -19.715539652999965],
            [-68.69029862499985, -19.695385843999887],
            [-68.64859574399992, -19.66034922299987],
            [-68.63097408099992, -19.64195241299997],
            [-68.57673588299994, -19.56460698499997],
            [-68.53211706599987, -19.50097910599996],
            [-68.53211706599987, -19.50087575299993],
            [-68.51020625799993, -19.47162689199989],
            [-68.49635697499986, -19.458397724999898],
            [-68.45610103399991, -19.44124114999994],
            [-68.4476260989999, -19.43462656699994],
            [-68.45501582899993, -19.415402933999914],
            [-68.4725858159999, -19.395455830999893],
            [-68.49320471199991, -19.376955667999965],
            [-68.60007157499993, -19.303368428999974],
            [-68.63572831299993, -19.290552672999894],
            [-68.66332352699993, -19.27360280299989],
            [-68.69846350099996, -19.215621845999934],
            [-68.72125280799986, -19.191747334999945],
            [-68.81540726799994, -19.113302509999926],
            [-68.84736914099992, -19.09201181999994],
            [-68.8947822669999, -19.076508890999932],
            [-68.90850235999994, -19.06793060299991],
            [-68.91969030799987, -19.05377126099995],
            [-68.94315140899994, -19.001164651999957],
            [-68.96170324699989, -18.969435322999942],
            [-68.97397639999991, -18.95620615599995],
            [-68.98960852099987, -18.946490986999905],
            [-68.95984289599988, -18.907837015999903],
            [-68.95178137199989, -18.88933685299989],
            [-68.95144547599992, -18.867322692999906],
            [-68.95464941499998, -18.85698740699989],
            [-69.01014990299987, -18.745262959999934],
            [-69.01053747599985, -18.744539488999933],
            [-69.0106666669999, -18.74371266699991],
            [-69.01053747599985, -18.742989196999915],
            [-69.00317358499987, -18.729553323999966],
            [-69.0011065269999, -18.716220804999935],
            [-69.00348364299995, -18.70268157999996],
            [-69.01014990299987, -18.689762471999956],
            [-69.03384354699989, -18.6494548539999],
            [-69.04283524599992, -18.600465596999896],
            [-69.0416466879999, -18.54889251699997],
            [-69.03490291399987, -18.501040139999887],
            [-69.03438614899994, -18.478302510999896],
            [-69.04169836499992, -18.457735289999917],
            [-69.07782019099994, -18.39882415799991],
            [-69.08187678999994, -18.38249440499996],
            [-69.07929296899994, -18.32802744599988],
            [-69.08102412999992, -18.319139098999955],
            [-69.0957519129999, -18.276764423999936],
            [-69.09683711799991, -18.267979430999944],
            [-69.09694047099993, -18.25754079099991],
            [-69.10035111499988, -18.234286396999906],
            [-69.11066056399997, -18.21795664499996],
            [-69.14120133499995, -18.18684743299991],
            [-69.15543819299992, -18.140235289999936],
            [-69.12593094999991, -18.111089782999926],
            [-69.08921484399994, -18.08308115699991],
            [-69.08172176199992, -18.039983011999908],
            [-69.08228408699998, -18.039077667999962],
            [-69.0920570479999, -18.02334319999997],
            [-69.1041751709999, -18.0237566119999],
            [-69.11988480699998, -18.029854430999947],
            [-69.14083959999996, -18.0307846069999],
            [-69.15771195499985, -18.025720315999934],
            [-69.17388667799995, -18.01889902799988],
            [-69.20416906799997, -18.00112233499995],
            [-69.22778519799988, -17.995541279999927],
            [-69.2348131919999, -17.99295745799992],
            [-69.24189286399991, -17.986756286999935],
            [-69.26204667199991, -17.964018655999965],
            [-69.27760127799993, -17.967532653999925],
            [-69.29002945999991, -17.9766277049999],
            [-69.30240596499996, -17.976214293999888],
            [-69.31785721899988, -17.951616312999903],
            [-69.32687475599991, -17.915132750999888],
            [-69.32764990299992, -17.841545510999893],
            [-69.33423864799991, -17.805785420999968],
            [-69.35940506999995, -17.759379983999864],
            [-69.39477758799995, -17.72113942499996],
            [-69.47578039599998, -17.652409769999906],
            [-69.49712276299996, -17.621403909999884],
            [-69.50611446099992, -17.585127054999916],
            [-69.51008875199994, -17.506588197999946],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Peru',
        iso3: 'PER',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-69.51008875199994, -17.506588197999946],
              [-69.63832381799989, -17.62606411],
              [-69.68390243099986, -17.65603643999995],
              [-69.72904179499994, -17.66327113999992],
              [-69.77580896599994, -17.656966615999906],
              [-69.81805444899993, -17.659137025999897],
              [-69.84983545499995, -17.691589825999912],
              [-69.85756108199988, -17.734171205999886],
              [-69.84608891399995, -17.76910447399996],
              [-69.82903569099992, -17.80383103699991],
              [-69.82009566799988, -17.846102357999897],
              [-69.81815780199994, -17.871423809999968],
              [-69.81278345299998, -17.888270326999944],
              [-69.79061426399997, -17.924753887999955],
              [-69.78237187299993, -17.94387416799995],
              [-69.77989140399987, -17.962581036999936],
              [-69.78309534299993, -17.981597962999913],
              [-69.84358260699986, -18.113166160999953],
              [-69.86533838499989, -18.1445854319999],
              [-69.8834509749999, -18.16360235799995],
              [-69.92280257799987, -18.196468569999894],
              [-69.9703448949999, -18.250625470999907],
              [-69.98778569199993, -18.26426804899991],
              [-70.01000655699997, -18.272639630999976],
              [-70.03935876999995, -18.273053041999987],
              [-70.06323328199994, -18.280701152999967],
              [-70.13415918599992, -18.318941713999962],
              [-70.1590672269999, -18.325969708999963],
              [-70.21087284899994, -18.33124070399991],
              [-70.31789473999993, -18.32121547699998],
              [-70.36939030599993, -18.324729473999938],
              [-70.39470274677868, -18.337746206368088],
              [-70.4197391209999, -18.316415519999907],
              [-70.46940313699992, -18.286093817999927],
              [-70.53125161699995, -18.243258732999948],
              [-70.56219465599992, -18.224477287999946],
              [-70.59780617799993, -18.205705232999946],
              [-70.6344057789999, -18.186867579999955],
              [-70.68325609099992, -18.161697837999952],
              [-70.73338782499991, -18.115492445999905],
              [-70.73668372299994, -18.11109791499996],
              [-70.74217688699991, -18.100355726999908],
              [-70.74767005099994, -18.094414971999925],
              [-70.75234941299993, -18.091729424999926],
              [-70.76244055899991, -18.09042734199994],
              [-70.76817786399994, -18.088148695999905],
              [-70.82616126199991, -18.036716403999947],
              [-70.84349524599992, -18.02662525799991],
              [-70.87889563699991, -18.016696872999944],
              [-70.89167232999995, -18.00562916499996],
              [-70.90489661399994, -17.96656666499996],
              [-70.91462154899995, -17.94654713299991],
              [-70.92886308499993, -17.93792083099993],
              [-70.94489498599995, -17.931573174999926],
              [-70.98704993399991, -17.90081145599993],
              [-71.0071508449999, -17.890232028999947],
              [-71.06631425699993, -17.871758721999925],
              [-71.08657792899993, -17.869073174999926],
              [-71.13809160099993, -17.82073333099993],
              [-71.15957597599993, -17.808200778999947],
              [-71.17308508999992, -17.796319268999923],
              [-71.20352128799993, -17.76262786299992],
              [-71.21922766799992, -17.751560153999947],
              [-71.26781165299991, -17.731215101999908],
              [-71.30455481699994, -17.70598723799992],
              [-71.32579505099994, -17.695245049999926],
              [-71.34691321499992, -17.691013278999947],
              [-71.38003495999993, -17.695245049999926],
              [-71.38442949099993, -17.69784921699994],
              [-71.38516191299993, -17.68726978999996],
              [-71.37865149599992, -17.675713799999926],
              [-71.36400305899991, -17.656182549999926],
              [-71.35960852799991, -17.633070570999905],
              [-71.36278235599991, -17.613213799999926],
              [-71.36839758999992, -17.593194268999923],
              [-71.37767493399991, -17.492364190999922],
              [-71.38194739499994, -17.473809502999927],
              [-71.3958227199999, -17.43417734199994],
              [-71.40025794199994, -17.400323174999926],
              [-71.40444902299993, -17.396091403999947],
              [-71.41075598899994, -17.39430103999996],
              [-71.41860917899993, -17.389336846999925],
              [-71.44591223899994, -17.35515715899993],
              [-71.48131262899994, -17.331231377999927],
              [-71.48387610599991, -17.328383070999905],
              [-71.49771074099993, -17.297133070999905],
              [-71.51451575399994, -17.284600518999923],
              [-71.5305883449999, -17.27971770599993],
              [-71.56944739499994, -17.27320728999996],
              [-71.5930883449999, -17.265557549999926],
              [-71.60252844999991, -17.25953541499996],
              [-71.61998450399994, -17.244317315999922],
              [-71.63683020699995, -17.23365650799991],
              [-71.64146887899994, -17.231622002999927],
              [-71.80760657499991, -17.191338799999926],
              [-71.84569251199991, -17.174574476999908],
              [-71.87791907499991, -17.149102471999925],
              [-71.92442786399994, -17.095635674999926],
              [-71.94859778599994, -17.07350025799991],
              [-72.00308183499993, -17.042575778999947],
              [-72.02456620999993, -17.03362395599993],
              [-72.04727128799993, -17.02776458099993],
              [-72.10993404899995, -17.02312590899993],
              [-72.11815344999991, -17.01930103999996],
              [-72.12352454299992, -17.009372653999947],
              [-72.12218176999994, -16.988213799999926],
              [-72.12437903599994, -16.977715752999927],
              [-72.13805091099994, -16.964776299999926],
              [-72.17853756399995, -16.942152601999908],
              [-72.18700110599991, -16.93336353999996],
              [-72.19725501199991, -16.91643645599993],
              [-72.22109941299993, -16.90593840899993],
              [-72.26895097599993, -16.895196221999925],
              [-72.29336503799993, -16.88062916499996],
              [-72.29796301999994, -16.86296965899993],
              [-72.29735266799992, -16.84351978999996],
              [-72.30650794199994, -16.824151299999926],
              [-72.36221269399994, -16.761325778999947],
              [-72.38508053299995, -16.745700778999947],
              [-72.39635169199994, -16.742364190999922],
              [-72.40562903599994, -16.742364190999922],
              [-72.41397050699993, -16.741306247999944],
              [-72.42292232999995, -16.73479583099993],
              [-72.43325761599993, -16.720310153999947],
              [-72.44009355399993, -16.714450778999947],
              [-72.45018469999991, -16.712090752999927],
              [-72.45645097599993, -16.709161065999922],
              [-72.47809811099995, -16.69508228999996],
              [-72.48802649599992, -16.69036223799992],
              [-72.52965247299994, -16.683526299999926],
              [-72.58775794199994, -16.659356377999927],
              [-72.69235303099993, -16.66065390999995],
              [-72.7813207669999, -16.62932708099993],
              [-72.88833574099993, -16.554620049999926],
              [-73.06024642499995, -16.494881019999923],
              [-73.0938207669999, -16.460137627999927],
              [-73.13792883999992, -16.438571872999944],
              [-73.17516028599994, -16.413262627999927],
              [-73.19253495999993, -16.40715911299992],
              [-73.23167883999992, -16.40797291499996],
              [-73.25039628799993, -16.403008721999925],
              [-73.26573645699995, -16.393731377999927],
              [-73.28014075399994, -16.38836028399993],
              [-73.2962133449999, -16.395603122999944],
              [-73.30467688699991, -16.381931247999944],
              [-73.31729081899994, -16.34042734199994],
              [-73.32599850199995, -16.330743096999925],
              [-73.33604895699995, -16.32626718499995],
              [-73.36510169199994, -16.319919528999947],
              [-73.42031816299993, -16.293145440999922],
              [-73.48180091099994, -16.278903903999947],
              [-73.59890933499992, -16.239849265999908],
              [-73.67620239899992, -16.227872934999937],
              [-73.70068690599993, -16.24459438599996],
              [-73.70027772999993, -16.22069635799994],
              [-73.71849524599992, -16.206231377999927],
              [-73.72793535099993, -16.196058851999908],
              [-73.73501542899993, -16.190118096999925],
              [-73.77135794599991, -16.178201886999943],
              [-73.84264075399994, -16.146661065999922],
              [-73.87218176999994, -16.12867603999996],
              [-73.9344209269999, -16.086441469999954],
              [-74.0040770519999, -16.03705939999992],
              [-74.03282630099994, -16.01230234199994],
              [-74.0331646919999, -16.00078270599994],
              [-74.02790424599993, -15.988802543999952],
              [-74.03575805399993, -15.973241911999935],
              [-74.04662024599992, -15.960137627999927],
              [-74.07710435099995, -15.946034487999952],
              [-74.16169186099995, -15.901055596999925],
              [-74.17739824099993, -15.896905205999929],
              [-74.22061113199993, -15.891289971999925],
              [-74.23692786399994, -15.881036065999922],
              [-74.25017353099992, -15.86615000799992],
              [-74.25336307299995, -15.855733609999959],
              [-74.2657386219999, -15.847661498999912],
              [-74.28995140599994, -15.83959972599996],
              [-74.32793664299993, -15.848055468999917],
              [-74.36311836899995, -15.839254798999946],
              [-74.39801188199993, -15.826863044999925],
              [-74.44172115799995, -15.798028252999927],
              [-74.44640051999994, -15.79225025799991],
              [-74.44896399599992, -15.77271900799991],
              [-74.45152747299994, -15.76262786299992],
              [-74.45669511599993, -15.754571221999925],
              [-74.45764703399993, -15.740821364999931],
              [-74.46306827599994, -15.726723526999933],
              [-74.48851477799991, -15.71770598799992],
              [-74.53831798999994, -15.702639778999924],
              [-74.6809789699999, -15.642022393999923],
              [-74.75122323599993, -15.604642783999907],
              [-74.84755998999992, -15.566293733999942],
              [-74.86864492699993, -15.538050754999915],
              [-74.97911536399994, -15.482354424999926],
              [-75.00641842399995, -15.461195570999905],
              [-75.01988684799994, -15.45712655999995],
              [-75.03477942599994, -15.459242445999905],
              [-75.04161536399994, -15.46217213299991],
              [-75.04869544199994, -15.46070728999996],
              [-75.06456458199995, -15.449639580999929],
              [-75.09487870999993, -15.417168877999927],
              [-75.10610917899993, -15.408623955999929],
              [-75.12572180899991, -15.402601820999905],
              [-75.14549719999991, -15.399509372999944],
              [-75.16079667899993, -15.393324476999908],
              [-75.16698157499991, -15.377618096999925],
              [-75.17210852799991, -15.373630466999941],
              [-75.1894160029999, -15.36954497399995],
              [-75.19098976099991, -15.362100977999944],
              [-75.1894609819999, -15.35837115299995],
              [-75.17559195599995, -15.351614275999907],
              [-75.15542235799995, -15.34641966299995],
              [-75.15164083299993, -15.33298807999995],
              [-75.16685950399994, -15.311293226999908],
              [-75.19595292899993, -15.293633721999925],
              [-75.23643958199995, -15.276788018999923],
              [-75.26317298099991, -15.250420830999929],
              [-75.24380449099993, -15.251397393999923],
              [-75.23277747299994, -15.24578215899993],
              [-75.22842363199993, -15.235772393999923],
              [-75.22964433499993, -15.223728122999944],
              [-75.23412024599992, -15.21453215899993],
              [-75.24111894399994, -15.205336195999905],
              [-75.28962154899995, -15.16106536299992],
              [-75.30955969999991, -15.15203215899993],
              [-75.36180579299992, -15.144789320999905],
              [-75.37645423099991, -15.13404713299991],
              [-75.38524329299992, -15.11695728999996],
              [-75.39415442599994, -15.093926690999922],
              [-75.44102942599994, -15.027764580999929],
              [-75.44810950399994, -15.007989190999922],
              [-75.45579993399991, -14.99814218499995],
              [-75.49160722599993, -14.974541924999926],
              [-75.50275631399995, -14.963636976999908],
              [-75.50438391799992, -14.956963799999926],
              [-75.50275631399995, -14.92546965899993],
              [-75.50658118399991, -14.918226820999905],
              [-75.55064856699994, -14.884942315999922],
              [-75.6328832669999, -14.84579843499995],
              [-75.65991378699994, -14.831718243999944],
              [-75.68053256799993, -14.821026617999905],
              [-75.70474199099993, -14.805759372999944],
              [-75.7483320959999, -14.770979643999908],
              [-75.79820716099994, -14.74732838299991],
              [-75.80166581899994, -14.742445570999905],
              [-75.80996660099993, -14.736993096999925],
              [-75.81989498599995, -14.73219166499996],
              [-75.82827714799993, -14.73023853999996],
              [-75.83942623599995, -14.72633228999996],
              [-75.84691321499992, -14.717054945999905],
              [-75.85293535099993, -14.70598723799992],
              [-75.85968990799995, -14.696058851999908],
              [-75.86676998599995, -14.68954843499995],
              [-75.87417558499993, -14.684258721999925],
              [-75.91588294199994, -14.66383228999996],
              [-75.93065344999991, -14.64934661299992],
              [-75.92729030899994, -14.626830893999909],
              [-75.93041683299992, -14.603422610999928],
              [-75.93276944199994, -14.580015124999932],
              [-75.94607485199992, -14.55888979599996],
              [-75.96327508799993, -14.534760010999946],
              [-75.97343438099995, -14.528741470999933],
              [-75.97651060599992, -14.517386182999928],
              [-75.9718484409999, -14.50834229599991],
              [-75.96483203399993, -14.492490385999929],
              [-75.96893900399994, -14.483759687999907],
              [-75.98063612599992, -14.46109879799991],
              [-76.00340735599991, -14.449802341999941],
              [-76.0371801419999, -14.429294528999947],
              [-76.04914303299995, -14.41806405999995],
              [-76.0684301419999, -14.391371351999908],
              [-76.08185787699995, -14.377699476999908],
              [-76.09215247299994, -14.37314218499995],
              [-76.11660722599993, -14.370700778999947],
              [-76.12657630099994, -14.367120049999926],
              [-76.13320878799993, -14.359633070999905],
              [-76.1435525789999, -14.327895112999954],
              [-76.11611326799994, -14.324873809999929],
              [-76.10827712499992, -14.31574029099994],
              [-76.10670895599992, -14.305859528999918],
              [-76.11376205999994, -14.292927167999949],
              [-76.12316263899993, -14.273908143999904],
              [-76.12930253799993, -14.26344166499996],
              [-76.13707434799994, -14.24187590899993],
              [-76.14915930899991, -14.22389088299991],
              [-76.16470292899993, -14.216403903999947],
              [-76.18114173099991, -14.21062590899993],
              [-76.1895238919999, -14.19695403399993],
              [-76.19489498599995, -14.181084893999923],
              [-76.20225989499994, -14.168552341999941],
              [-76.21544348899994, -14.161228122999944],
              [-76.24993962399992, -14.14780620299996],
              [-76.25156666399994, -14.16980738199993],
              [-76.27119345499995, -14.200930401999926],
              [-76.29043535099993, -14.167413018999923],
              [-76.2820561819999, -14.140924437999956],
              [-76.28280594299991, -14.10369480199995],
              [-76.29173743399991, -14.08098723799992],
              [-76.28120009199995, -14.073314226999912],
              [-76.28087317599994, -14.057386976999908],
              [-76.2679072379999, -14.049715412999944],
              [-76.2741807139999, -14.039040030999956],
              [-76.2718197339999, -14.030684073999907],
              [-76.26944939399993, -14.020059455999956],
              [-76.27886350799992, -14.008602180999958],
              [-76.28457597599993, -13.991631768999923],
              [-76.27280498199991, -13.987397577999957],
              [-76.27043882599992, -13.962500100999932],
              [-76.27742903799992, -13.94510325899995],
              [-76.29531010699992, -13.934502471999906],
              [-76.29784094999991, -13.922133070999905],
              [-76.29686438699991, -13.91497161299992],
              [-76.29377193899995, -13.90748463299991],
              [-76.29271399599992, -13.90048593499995],
              [-76.29784094999991, -13.89421965899993],
              [-76.30846106699994, -13.891778252999927],
              [-76.31505286399994, -13.896661065999922],
              [-76.3178436579999, -13.912702095999919],
              [-76.32485993199992, -13.921000374999949],
              [-76.33730080399994, -13.916453254999908],
              [-76.35439941999994, -13.91943709599991],
              [-76.3730266739999, -13.908831455999916],
              [-76.39395968899993, -13.908020420999947],
              [-76.39354407499991, -13.881931247999944],
              [-76.39110266799992, -13.867852471999925],
              [-76.37760155599995, -13.83588812399995],
              [-76.36671345499991, -13.822023559999934],
              [-76.37136106299994, -13.809178307999957],
              [-76.36201552599994, -13.80164219799991],
              [-76.3441320739999, -13.80544692299992],
              [-76.32575436099995, -13.791192315999922],
              [-76.30809485599991, -13.791761976999908],
              [-76.29590351399992, -13.793435777999946],
              [-76.29047349799993, -13.804770452999946],
              [-76.30060154699993, -13.819101517999911],
              [-76.30295190599992, -13.83268893099995],
              [-76.29360977899995, -13.840256135999937],
              [-76.2805883449999, -13.846856377999927],
              [-76.26177321599994, -13.861428284999931],
              [-76.25398463099992, -13.850867950999941],
              [-76.2531829159999, -13.82973194199991],
              [-76.24771711599993, -13.808601830999919],
              [-76.23289938099992, -13.764072735999946],
              [-76.22431705799994, -13.733871439999916],
              [-76.22492428299995, -13.713636976999908],
              [-76.22134355399993, -13.686618747999944],
              [-76.20970618399991, -13.65398528399993],
              [-76.19815019399994, -13.622491143999923],
              [-76.18126380099994, -13.539483330999929],
              [-76.18785559799994, -13.46493905999995],
              [-76.19603430899991, -13.428155205999929],
              [-76.22110152699992, -13.357555918999935],
              [-76.27428137899994, -13.287286065999922],
              [-76.30695451799994, -13.25704470699992],
              [-76.37096106699994, -13.17359791499996],
              [-76.4509504429999, -13.071710554999925],
              [-76.48334719299993, -13.036295975999906],
              [-76.49094831699995, -13.012079023999945],
              [-76.50548255099994, -12.990166924999926],
              [-76.51647444299994, -12.946153000999914],
              [-76.51167287999994, -12.910820269999931],
              [-76.51623308699993, -12.869918827999925],
              [-76.53197180899991, -12.843926690999922],
              [-76.5423070949999, -12.831963799999926],
              [-76.61107337099992, -12.77434661299992],
              [-76.63003495999993, -12.750664971999925],
              [-76.67247473899994, -12.668552341999941],
              [-76.68179277299993, -12.655368747999944],
              [-76.68065344999991, -12.62867603999996],
              [-76.68146725199995, -12.619317315999922],
              [-76.68932044199994, -12.609633070999905],
              [-76.70476694099995, -12.594410910999954],
              [-76.73618046299993, -12.55241525599996],
              [-76.78001668499991, -12.523388818999933],
              [-76.79907928699993, -12.50934209299993],
              [-76.81175696499992, -12.482679945999905],
              [-76.79112708199995, -12.45671965899993],
              [-76.78242985599991, -12.419212948999927],
              [-76.79088558699993, -12.381046973999958],
              [-76.82542883999992, -12.35247161299992],
              [-76.85364603599993, -12.302644124999915],
              [-76.94896399599992, -12.25009530999995],
              [-77.00625566299993, -12.22633228999996],
              [-77.01720130099994, -12.225762627999927],
              [-77.02086341099994, -12.220635674999926],
              [-77.03831946499992, -12.20435963299991],
              [-77.04454505099994, -12.194756768999923],
              [-77.0469457669999, -12.180759372999944],
              [-77.04417883999992, -12.172051690999922],
              [-77.04010982999995, -12.164483330999929],
              [-77.03831946499992, -12.153741143999923],
              [-77.05394446499992, -12.11419036299992],
              [-77.08897864499994, -12.088962497999944],
              [-77.11440995999993, -12.08131275799991],
              [-77.1328832669999, -12.075778903999947],
              [-77.17491614499994, -12.071872653999947],
              [-77.16649329299992, -12.053317966999941],
              [-77.15510006399995, -12.038995049999926],
              [-77.14509029899995, -12.023044528999947],
              [-77.14073645699995, -11.999200127999927],
              [-77.14590410099993, -11.932061455999929],
              [-77.1543676419999, -11.90943775799991],
              [-77.16185462099992, -11.879489841999941],
              [-77.16637122299994, -11.869561455999929],
              [-77.1817113919999, -11.845879815999922],
              [-77.18724524599992, -11.825290622999944],
              [-77.18144065699994, -11.800578023999947],
              [-77.19637374199993, -11.776822169999946],
              [-77.1963363189999, -11.767835058999935],
              [-77.1779780839999, -11.770370520999904],
              [-77.16705975899993, -11.756536131999951],
              [-77.17108562099992, -11.736138062999942],
              [-77.19542395699995, -11.691338799999926],
              [-77.19981848899994, -11.670098565999922],
              [-77.21092688699991, -11.646416924999926],
              [-77.22545325399994, -11.627211195999905],
              [-77.24006100199995, -11.619398695999905],
              [-77.25300045499995, -11.614841403999947],
              [-77.26423092399995, -11.604261976999908],
              [-77.28136145699995, -11.58212655999995],
              [-77.28473873599995, -11.575372002999927],
              [-77.27774003799993, -11.565850518999923],
              [-77.27794348899994, -11.557305596999925],
              [-77.28189042899993, -11.549493096999925],
              [-77.29898027299993, -11.529961846999925],
              [-77.31273352799991, -11.50481536299992],
              [-77.32046464799993, -11.493747653999947],
              [-77.32945716099994, -11.489027601999908],
              [-77.34032141799992, -11.485935153999947],
              [-77.34801184799994, -11.47828541499996],
              [-77.36046301999994, -11.461114190999922],
              [-77.37779700399994, -11.449883721999925],
              [-77.42080644399994, -11.430759372999944],
              [-77.45335852799991, -11.403741143999923],
              [-77.60850989499994, -11.322442315999922],
              [-77.63418535099993, -11.303399346999925],
              [-77.64725670599995, -11.292316286999949],
              [-77.64484993899993, -11.279902764999918],
              [-77.64701713799991, -11.25676343899994],
              [-77.65208976299994, -11.23699214599992],
              [-77.64513417599994, -11.230823806999922],
              [-77.6479675409999, -11.222346117999905],
              [-77.63984978999991, -11.213929789999952],
              [-77.63063069099991, -11.213418070999921],
              [-77.61855712499994, -11.21630575699993],
              [-77.6093328529999, -11.210719672999915],
              [-77.59779929899992, -11.206836516999942],
              [-77.59367704499994, -11.191068729999927],
              [-77.59468411699993, -11.165117081999938],
              [-77.60833064699995, -11.141921577999938],
              [-77.61860031599991, -11.127193636999948],
              [-77.6127617759999, -11.115396226999906],
              [-77.63336825699992, -11.09268953399993],
              [-77.62868952399992, -11.082571884999936],
              [-77.63898243099993, -11.064978995999923],
              [-77.63431646299995, -11.056557865999935],
              [-77.64286552099992, -11.03728244599995],
              [-77.66130667699991, -11.014460244999952],
              [-77.65722139299993, -11.006014782999955],
              [-77.64680611499995, -10.996477374999927],
              [-77.65588135999991, -10.976118735999933],
              [-77.6643812929999, -10.96026614099992],
              [-77.66314234299995, -10.947298411999952],
              [-77.67053876699993, -10.927519692999908],
              [-77.6813487679999, -10.90996674899992],
              [-77.69615571199995, -10.890697914999919],
              [-77.71155430699991, -10.86803423899994],
              [-77.70916981399995, -10.852246908999916],
              [-77.73493404899995, -10.832289320999905],
              [-77.75315523499995, -10.815768816999935],
              [-77.7530518239999, -10.801091318999909],
              [-77.7478033829999, -10.792072210999947],
              [-77.76487744399992, -10.768851042999927],
              [-77.7636761999999, -10.761524056999917],
              [-77.79246985599991, -10.734958591999941],
              [-77.80768214099993, -10.72404361599996],
              [-77.81346594999991, -10.71217213299991],
              [-77.81920325399994, -10.701348565999922],
              [-77.82689368399991, -10.692803643999923],
              [-77.84850012899994, -10.673760674999926],
              [-77.9119729059999, -10.566389668999932],
              [-77.90957058799995, -10.555114385999957],
              [-77.92259209299993, -10.53078531899996],
              [-77.94204667899993, -10.515801690999922],
              [-77.96849524599992, -10.49391041499996],
              [-77.96629873499995, -10.478073023999912],
              [-77.97715943199995, -10.455981312999938],
              [-77.99546449199994, -10.432118454999909],
              [-78.01097571499992, -10.412774346999925],
              [-78.01292883999992, -10.40325286299992],
              [-78.00483075299991, -10.393745897999906],
              [-78.0064265709999, -10.382481975999951],
              [-78.01781165299991, -10.371758721999925],
              [-78.05580446599993, -10.347524045999933],
              [-78.0573365919999, -10.328350971999953],
              [-78.0581727899999, -10.301908290999961],
              [-78.07689368399991, -10.286553643999923],
              [-78.08554820099994, -10.277426314999957],
              [-78.08766827799991, -10.261593833999939],
              [-78.09551117399991, -10.240667154999926],
              [-78.09073175499992, -10.22884445099993],
              [-78.10041625699995, -10.214692903999946],
              [-78.10493434499995, -10.201132252999912],
              [-78.12434157699994, -10.179554607999933],
              [-78.16659629299994, -10.141410896999957],
              [-78.17556276099992, -10.121044011999913],
              [-78.18233507499991, -10.11084626999991],
              [-78.18283556799992, -10.100684181999952],
              [-78.17423231399994, -10.09905335399992],
              [-78.16796892799994, -10.093415519999951],
              [-78.1696140009999, -10.080973612999912],
              [-78.1787080119999, -10.069043911999927],
              [-78.17580996399994, -10.062845394999954],
              [-78.1774270219999, -10.050984808999942],
              [-78.17794284199994, -10.04250709999991],
              [-78.19390382699993, -10.020878555999957],
              [-78.19797643299995, -9.997386286999927],
              [-78.20353910999995, -9.986618396999916],
              [-78.21226572499995, -9.973036966999928],
              [-78.2150681789999, -9.962858039999958],
              [-78.22548307799991, -9.95883011099994],
              [-78.22889470799993, -9.95428691199993],
              [-78.23463008499994, -9.952549154999929],
              [-78.23630829099994, -9.946889298999906],
              [-78.23454181499994, -9.941820757999949],
              [-78.22874081399993, -9.93565478399995],
              [-78.22984371599995, -9.924894552999945],
              [-78.22898387399994, -9.913167909999913],
              [-78.22992342899994, -9.900726964999933],
              [-78.23448041499995, -9.88508358799993],
              [-78.24160152699994, -9.875977280999905],
              [-78.24325856699994, -9.858939505999956],
              [-78.2388918549999, -9.838725993999958],
              [-78.22989113099993, -9.825043712999957],
              [-78.22942242699992, -9.793784130999938],
              [-78.26891286199992, -9.75860541599991],
              [-78.30112333699992, -9.721917471999916],
              [-78.30753675699992, -9.698406957999907],
              [-78.32443220699992, -9.680981534999944],
              [-78.3324629469999, -9.662956080999948],
              [-78.34251866299991, -9.652898575999927],
              [-78.3544734109999, -9.632200538999939],
              [-78.36990378699994, -9.61543226099991],
              [-78.37443538299993, -9.58478058399993],
              [-78.36807141899993, -9.556929344999958],
              [-78.38703428499991, -9.546713148999913],
              [-78.39090104199994, -9.53007316399993],
              [-78.39001746799994, -9.516168561999905],
              [-78.39940344999991, -9.501885674999926],
              [-78.40591386599993, -9.477715752999927],
              [-78.39769532799994, -9.463903195999933],
              [-78.38507788999993, -9.451430494999954],
              [-78.39321334999994, -9.435382636999918],
              [-78.40629504499992, -9.43521987999992],
              [-78.4271153549999, -9.419739687999936],
              [-78.43161355699993, -9.392422655999951],
              [-78.42867653099995, -9.375848977999908],
              [-78.42101243299993, -9.368000086999928],
              [-78.41475375999994, -9.362127347999945],
              [-78.42572722099993, -9.357956050999917],
              [-78.43459339299994, -9.34649363099993],
              [-78.44298255099994, -9.340915622999944],
              [-78.44859778599994, -9.32822030999995],
              [-78.46133378799993, -9.32350025799991],
              [-78.47516842399995, -9.324883721999925],
              [-78.48395748599995, -9.330254815999922],
              [-78.50648570699991, -9.30503845499993],
              [-78.50775243399994, -9.295728014999952],
              [-78.50967454799991, -9.284419438999919],
              [-78.5190492939999, -9.278360823999947],
              [-78.52672278599994, -9.26962655999995],
              [-78.51757509799995, -9.263093342999923],
              [-78.50875636799992, -9.255862824999951],
              [-78.49728382299992, -9.253306809999913],
              [-78.48970312799992, -9.233450559999937],
              [-78.48818841999991, -9.213536931999954],
              [-78.49741098599992, -9.189538477999918],
              [-78.51615427399992, -9.178086694999934],
              [-78.53565999799991, -9.172566082999936],
              [-78.55052659799992, -9.178412979999905],
              [-78.55856518799993, -9.183727466999926],
              [-78.56192373399995, -9.19172208699996],
              [-78.55734789699994, -9.19968485599992],
              [-78.55687870699995, -9.21224981499995],
              [-78.55226892899992, -9.23225842499994],
              [-78.5531068759999, -9.244181686999923],
              [-78.56444696199992, -9.240791445999946],
              [-78.57766568499994, -9.213447990999953],
              [-78.59702406299994, -9.191339868999933],
              [-78.6111549929999, -9.176522352999939],
              [-78.61039443599992, -9.165888486999961],
              [-78.61439507999995, -9.160530021999932],
              [-78.60963922799993, -9.15591889999996],
              [-78.59418234999993, -9.161384555999916],
              [-78.57056710199993, -9.168326976999936],
              [-78.56452955299994, -9.16032810899992],
              [-78.5596906959999, -9.148428983999906],
              [-78.55945087599991, -9.128186674999938],
              [-78.5680301349999, -9.10422396499996],
              [-78.57867318899991, -9.089518090999945],
              [-78.5920265499999, -9.077443891999906],
              [-78.6054943709999, -9.076667897999926],
              [-78.62372509399995, -9.079178267999907],
              [-78.6324260419999, -9.072458728999948],
              [-78.64172160599992, -9.05642798599996],
              [-78.6402213369999, -9.039822941999944],
              [-78.63333032299994, -9.023265652999953],
              [-78.62851097899994, -9.013338417999933],
              [-78.63718550999994, -9.004622446999917],
              [-78.6613783919999, -8.995765399999925],
              [-78.66196271399991, -8.985123338999927],
              [-78.6538733399999, -8.987193059999925],
              [-78.64909172199992, -8.980590222999922],
              [-78.64891141299995, -8.958654113999955],
              [-78.65477172899995, -8.933333138999956],
              [-78.6627453449999, -8.917957306999938],
              [-78.6740309839999, -8.897232536999923],
              [-78.68199688499993, -8.882521678999922],
              [-78.69671170899994, -8.865064573999916],
              [-78.71727454299992, -8.83684661299992],
              [-78.76429990199995, -8.775111853999931],
              [-78.76218533699995, -8.765816773999916],
              [-78.7620939389999, -8.756508648999954],
              [-78.75460793999991, -8.747929216999921],
              [-78.74305158599992, -8.740019175999919],
              [-78.74074604299994, -8.711457971999948],
              [-78.74525809599993, -8.68817796299993],
              [-78.74308222799993, -8.672911959999908],
              [-78.75027483399992, -8.646946297999932],
              [-78.75932805199994, -8.608327352999936],
              [-78.78945878799993, -8.566827080999929],
              [-78.81973222599993, -8.52825286299992],
              [-78.85924231699994, -8.491306247999944],
              [-78.88194739499994, -8.474541924999926],
              [-78.91331946499992, -8.462497653999947],
              [-78.92784583199995, -8.450616143999923],
              [-78.94026169199992, -8.435525562999942],
              [-78.93479362799991, -8.422951991999923],
              [-78.92464144599995, -8.424410694999949],
              [-78.91932698399995, -8.427106067999944],
              [-78.9065574629999, -8.417899062999936],
              [-78.9016625989999, -8.397349081999948],
              [-78.90212508199994, -8.376761354999928],
              [-78.96368760799993, -8.286699685999906],
              [-78.96548519299995, -8.264763838999954],
              [-78.9899561929999, -8.231978580999908],
              [-78.98574001199995, -8.217420553999943],
              [-79.01835588099993, -8.180565205999926],
              [-79.12422330699991, -8.089650475999917],
              [-79.12465624999993, -8.06507253399991],
              [-79.18374589799993, -8.025648695999905],
              [-79.29971269399994, -7.938653252999927],
              [-79.35171310599992, -7.880710764999947],
              [-79.38408064399994, -7.833788339999955],
              [-79.39569943799995, -7.79243221999991],
              [-79.4447172209999, -7.737414687999944],
              [-79.45653235599991, -7.726332289999959],
              [-79.46594209599994, -7.715929211999935],
              [-79.46116602699993, -7.70866974899991],
              [-79.4490467409999, -7.704807829999936],
              [-79.43684103299995, -7.693634194999959],
              [-79.43528685199993, -7.674386646999949],
              [-79.44844316099994, -7.650336509999931],
              [-79.48425046799991, -7.593484959999955],
              [-79.55556548899995, -7.495709142999942],
              [-79.58250891799992, -7.463636976999908],
              [-79.58443443999994, -7.439575130999913],
              [-79.58959725199992, -7.420910492999951],
              [-79.58873450399994, -7.411309502999927],
              [-79.57793883099993, -7.399779778999914],
              [-79.57376128899995, -7.38653942499991],
              [-79.5848634539999, -7.357164644999955],
              [-79.59668411199993, -7.331088196999929],
              [-79.59577973599994, -7.312500444999955],
              [-79.61275968199993, -7.266392093999912],
              [-79.64470478899995, -7.23175032499995],
              [-79.68377578399992, -7.192111662999935],
              [-79.69701205299992, -7.178009189999955],
              [-79.69072993099991, -7.156809580999948],
              [-79.68908551299995, -7.130911014999924],
              [-79.70824034999993, -7.106777354999906],
              [-79.81446558499994, -7.000931219999927],
              [-79.86626296799994, -6.94974799299996],
              [-79.87747647999993, -6.928975008999942],
              [-79.93154863199993, -6.883477471999925],
              [-79.94538153699995, -6.852025214999912],
              [-79.94901601999993, -6.820090827999934],
              [-79.96467956599992, -6.78735510599995],
              [-79.98840547099991, -6.757846698999913],
              [-80.00454667899993, -6.740899346999925],
              [-80.11891636099995, -6.650611101999914],
              [-80.16942981499994, -6.618712367999933],
              [-80.29809584599991, -6.54444781199993],
              [-80.4602069309999, -6.462652661999925],
              [-80.72766054199991, -6.329450588999919],
              [-80.79052806199991, -6.299691754999913],
              [-80.85312845399994, -6.239497572999937],
              [-80.92606831299992, -6.189385925999943],
              [-81.01389431299992, -6.139070919999938],
              [-81.10145703599994, -6.072068060999925],
              [-81.13081112999993, -6.034561306999933],
              [-81.15141998099995, -5.975873226999909],
              [-81.14903907399992, -5.936007709999956],
              [-81.1493860569999, -5.892390525999929],
              [-81.15021572099994, -5.883073312999954],
              [-81.12941208199993, -5.865809967999951],
              [-81.12359125799992, -5.846354009999914],
              [-81.11885387699994, -5.839907272999938],
              [-81.0963443359999, -5.838563691999923],
              [-81.08578655899993, -5.81550971799993],
              [-81.08467238399993, -5.799684702999912],
              [-81.07519399599994, -5.78678539799995],
              [-81.0574980859999, -5.787973996999938],
              [-81.03827900999994, -5.818103118999943],
              [-81.00956231399994, -5.831579916999942],
              [-80.97159284799994, -5.845957222999914],
              [-80.93993079299992, -5.85084400799991],
              [-80.90339107999995, -5.814629815999922],
              [-80.86401229599994, -5.743936439999914],
              [-80.85621181599993, -5.650461607999944],
              [-80.8812160679999, -5.57386826599992],
              [-80.93182413799991, -5.463815405999924],
              [-80.96206667699994, -5.430046733999916],
              [-81.05528723899994, -5.339939059999949],
              [-81.07219584199993, -5.318920736999928],
              [-81.09445532399991, -5.313043178999919],
              [-81.10759351399992, -5.317459064999923],
              [-81.13160622099991, -5.30040187599991],
              [-81.15249589799993, -5.267673434999949],
              [-81.17821204299992, -5.238539320999905],
              [-81.19847571499992, -5.208103122999944],
              [-81.19353888299992, -5.198295701999939],
              [-81.18687763199995, -5.190024877999917],
              [-81.1737083939999, -5.184603003999939],
              [-81.16598754599994, -5.164327717999925],
              [-81.16958220999993, -5.15317196399991],
              [-81.17782232799993, -5.142860991999953],
              [-81.17668952899993, -5.12988611399993],
              [-81.16261625499993, -5.126342029999932],
              [-81.16704373099992, -5.108679846999905],
              [-81.17140029099994, -5.087299027999961],
              [-81.16277207899992, -5.072572221999906],
              [-81.14693825699993, -5.07463223499991],
              [-81.1291261689999, -5.064691117999928],
              [-81.11257336699992, -5.081584049999947],
              [-81.08275735199993, -5.079213886999923],
              [-81.06759009399991, -5.057201638999913],
              [-81.06335474399992, -5.022042810999949],
              [-81.08502129699991, -4.974485715999947],
              [-81.11807678499991, -4.940654648999953],
              [-81.14940738599995, -4.91703310999992],
              [-81.17313977499992, -4.881456521999951],
              [-81.18950149999995, -4.851538079999955],
              [-81.22340037299995, -4.806488091999938],
              [-81.30348569799992, -4.720718123999916],
              [-81.33755752899992, -4.678304297999944],
              [-81.33268782599993, -4.664447122999945],
              [-81.32038878799995, -4.658193013999949],
              [-81.30525274199994, -4.643567566999934],
              [-81.30791329599992, -4.623896788999957],
              [-81.31651770699995, -4.60125090899993],
              [-81.3079320949999, -4.55006275799991],
              [-81.30748450399994, -4.534274997999944],
              [-81.31314042899993, -4.516289971999925],
              [-81.32266191299993, -4.495863539999959],
              [-81.3289281889999, -4.476657809999949],
              [-81.32481848899994, -4.461602471999925],
              [-81.31432044199994, -4.452325127999927],
              [-81.30736243399991, -4.447360934999949],
              [-81.30134029899995, -4.441664320999905],
              [-81.29381262899994, -4.430433851999908],
              [-81.27953040299991, -4.396416924999926],
              [-81.27916419199994, -4.373630466999941],
              [-81.29381262899994, -4.317559502999927],
              [-81.28897050699993, -4.297784112999921],
              [-81.27765865799995, -4.274102471999925],
              [-81.26402747299994, -4.252373955999929],
              [-81.25279700399994, -4.238702080999929],
              [-81.16563880099994, -4.17937590899993],
              [-81.14297441299993, -4.156182549999926],
              [-81.1243383449999, -4.123223565999922],
              [-81.11034094999991, -4.107598565999922],
              [-81.09142005099994, -4.101006768999923],
              [-81.07331295499995, -4.096774997999944],
              [-81.06248938699991, -4.085707289999959],
              [-81.04674231699994, -4.053155205999929],
              [-80.99290930899991, -3.972100518999923],
              [-80.96157792899993, -3.939385674999926],
              [-80.92381751199991, -3.90984465899993],
              [-80.88292395699995, -3.886895440999922],
              [-80.86778723899994, -3.87273528399993],
              [-80.86180579299992, -3.851739190999922],
              [-80.85912024599992, -3.829278252999927],
              [-80.8523656889999, -3.80828215899993],
              [-80.83446204299992, -3.773207289999959],
              [-80.80760657499991, -3.739434502999927],
              [-80.77171790299991, -3.710137627999927],
              [-80.61310787699995, -3.615655205999929],
              [-80.58458411399994, -3.588067315999922],
              [-80.5423070949999, -3.526136976999908],
              [-80.53624426999994, -3.505303643999923],
              [-80.52818762899994, -3.502048434999949],
              [-80.51817786399994, -3.500420830999929],
              [-80.50926673099991, -3.495212497999944],
              [-80.49372311099995, -3.489190362999921],
              [-80.42418372299994, -3.49146900799991],
              [-80.40501868399991, -3.487237237999921],
              [-80.38451087099992, -3.478692315999922],
              [-80.36823482999995, -3.465508721999925],
              [-80.36148027299993, -3.447686455999929],
              [-80.3587133449999, -3.436700127999927],
              [-80.34544837099992, -3.414157809999949],
              [-80.34105383999992, -3.403252862999921],
              [-80.34072866667043, -3.393497653515368],
              [-80.33390315799988, -3.397052509999924],
              [-80.31762508199998, -3.405527444999919],
              [-80.27974625699997, -3.415552672999951],
              [-80.26566442899986, -3.426404723999894],
              [-80.26778316299993, -3.443871357999939],
              [-80.2738809819999, -3.464645282999896],
              [-80.27163305699989, -3.485522562999961],
              [-80.26556107599993, -3.491103616999879],
              [-80.24907629399985, -3.497924905999923],
              [-80.24266841699992, -3.505159606999896],
              [-80.24029130099987, -3.514047952999917],
              [-80.24026546299987, -3.523866475999881],
              [-80.24212581499995, -3.542986754999973],
              [-80.24990311699989, -3.56996185299991],
              [-80.2499806319999, -3.577713317999908],
              [-80.24354691599984, -3.584637959999981],
              [-80.23367671699987, -3.587841898999955],
              [-80.2249950769999, -3.59187265999995],
              [-80.22228206399987, -3.601277770999914],
              [-80.22212703499991, -3.61243987999994],
              [-80.21639095099997, -3.631560159999935],
              [-80.21520239299994, -3.642515563999922],
              [-80.21677852399998, -3.652437438999911],
              [-80.22328975399995, -3.671867776999889],
              [-80.2249434009999, -3.680652770999885],
              [-80.2249434009999, -3.690677998999902],
              [-80.22398738599992, -3.698429462999911],
              [-80.21786372899996, -3.717136331999896],
              [-80.21685603899991, -3.726954853999956],
              [-80.2201891689999, -3.734706318999955],
              [-80.22445247399986, -3.741630960999942],
              [-80.22631282599986, -3.749279072999926],
              [-80.22163610899989, -3.769432880999901],
              [-80.20155981499994, -3.801472269999906],
              [-80.19272314499995, -3.821626078999884],
              [-80.1914570719999, -3.830617776999929],
              [-80.1914570719999, -3.849117939999942],
              [-80.18876989799986, -3.857696226999892],
              [-80.18006241899991, -3.867824808999927],
              [-80.17109655799996, -3.873612568999903],
              [-80.16505041599993, -3.879503682999911],
              [-80.16507379399991, -3.880695936999885],
              [-80.16525712199987, -3.890045673999879],
              [-80.18114762399989, -3.907925719999923],
              [-80.25907568399987, -3.943685810999852],
              [-80.27328670299991, -3.961255797999925],
              [-80.28780778099988, -3.984406839999906],
              [-80.30462845899984, -4.005180765999867],
              [-80.32550573799992, -4.015412698999938],
              [-80.34426428299992, -4.011588642999897],
              [-80.38645808999988, -3.988954365999945],
              [-80.40710282399988, -3.982443135999887],
              [-80.42746333899993, -3.981306253999961],
              [-80.44769466199992, -3.982753193999955],
              [-80.46614314799993, -3.988127542999919],
              [-80.48107763699988, -3.99877288799992],
              [-80.49198136399994, -4.014895934999899],
              [-80.5035827239999, -4.039080504999959],
              [-80.51221268699993, -4.064195251999891],
              [-80.5122938559999, -4.065033996999929],
              [-80.51407303899995, -4.083418883999911],
              [-80.50906042499989, -4.095821227999892],
              [-80.49260148199991, -4.118455505999933],
              [-80.48717545599993, -4.13127125999992],
              [-80.48683955899995, -4.14067637099987],
              [-80.49068945399989, -4.159693297999937],
              [-80.49076696799992, -4.168995055999872],
              [-80.46960546899996, -4.213230081999882],
              [-80.43472387799989, -4.216950784999895],
              [-80.39141902699993, -4.204135029999918],
              [-80.34527197299988, -4.198450621999967],
              [-80.35630489199988, -4.220568134999965],
              [-80.4885448819999, -4.395957946999928],
              [-80.49229142299993, -4.413011168999958],
              [-80.48353226799995, -4.433991799999959],
              [-80.46996720399997, -4.446084085999942],
              [-80.42511206099988, -4.471508889999953],
              [-80.40849808799996, -4.477503355999886],
              [-80.39074723399995, -4.476986591999946],
              [-80.38286657799989, -4.476263121999949],
              [-80.37325476099988, -4.467581481999986],
              [-80.33230118899988, -4.445670673999942],
              [-80.25540665699987, -4.386759541999936],
              [-80.2396711829999, -4.369809671999931],
              [-80.23220393899996, -4.353996683999924],
              [-80.22194616699997, -4.318960062999906],
              [-80.21344539399988, -4.304904072999889],
              [-80.20504797399988, -4.298186136999959],
              [-80.1947643639999, -4.293121846999981],
              [-80.1838347979999, -4.289401142999878],
              [-80.14308793199984, -4.284130146999942],
              [-80.14024572799988, -4.283096617999959],
              [-80.13386368799985, -4.293948668999917],
              [-80.11722387799992, -4.299116312999914],
              [-80.0968633629999, -4.302837015999927],
              [-80.07965511099991, -4.309038187999917],
              [-80.06162003599991, -4.3244377649999],
              [-80.02927058999992, -4.359681090999885],
              [-80.00909094299993, -4.373840432999927],
              [-79.9820124929999, -4.388619892999941],
              [-79.95601924699992, -4.391720478999972],
              [-79.93033605999995, -4.392030537999872],
              [-79.9040844319999, -4.398645120999959],
              [-79.87873714199992, -4.422002867999907],
              [-79.8577306729999, -4.453318785999912],
              [-79.83287430899986, -4.478950296999884],
              [-79.79574479199997, -4.484738056999944],
              [-79.72859126899993, -4.464067483999941],
              [-79.69412308799986, -4.443603616999965],
              [-79.65797542299993, -4.438746031999955],
              [-79.63032853299993, -4.45249196399989],
              [-79.57984065799991, -4.502308043999932],
              [-79.57203751599988, -4.506028746999931],
              [-79.55777482199991, -4.516570739999906],
              [-79.55162532599985, -4.519878031999909],
              [-79.52754410799992, -4.519671324999948],
              [-79.50720943199988, -4.531556904999974],
              [-79.50162837699986, -4.540962015999924],
              [-79.50413468499994, -4.55563812199992],
              [-79.5271823729999, -4.596565856999931],
              [-79.5278541669999, -4.618063252999974],
              [-79.49870865899996, -4.660644632999947],
              [-79.48721065299995, -4.719969177999872],
              [-79.46103653999992, -4.769165139999927],
              [-79.46082314399985, -4.770455597999941],
              [-79.45775508599993, -4.789008890999924],
              [-79.4505720629999, -4.810196227999882],
              [-79.43331213499991, -4.823942158999913],
              [-79.41269323799989, -4.83479420999987],
              [-79.39532995699997, -4.847609964999947],
              [-79.3899297689999, -4.856498310999953],
              [-79.38341853899993, -4.876238707999931],
              [-79.37807002799988, -4.884816995999955],
              [-79.36936254899993, -4.89112151999997],
              [-79.34985469599991, -4.898459574999961],
              [-79.34104386399991, -4.904247333999933],
              [-79.32784053599994, -4.923264261999904],
              [-79.31716935299994, -4.944399921999945],
              [-79.30321671599995, -4.961246438999922],
              [-79.28027237999993, -4.967344257999883],
              [-79.23368869399991, -4.965647838999942],
              [-79.20932063799992, -4.964760436999882],
              [-79.19175065199997, -4.967654316999869],
              [-79.15831599899988, -4.979333190999938],
              [-79.14084936599994, -4.983260598999905],
              [-79.13066910899997, -4.982847187999894],
              [-79.11452022399988, -4.978816426999899],
              [-79.10415909799988, -4.980056660999935],
              [-79.09338456299994, -4.985120950999914],
              [-79.08245499699987, -4.993079121999884],
              [-79.06392899599993, -5.011372578999939],
              [-79.03509354699989, -4.987498066999947],
              [-79.00928116899988, -4.960109557999914],
              [-79.00209814499993, -4.939128926999913],
              [-78.99101354999993, -4.890398050999877],
              [-78.98034236699993, -4.873964944999912],
              [-78.96026607299987, -4.868900654999933],
              [-78.93396276899992, -4.868693948999876],
              [-78.91081172699992, -4.863526305999883],
              [-78.90021805899994, -4.843682555999891],
              [-78.90533402499995, -4.819808043999984],
              [-78.92789078799987, -4.774849547999878],
              [-78.92861425799987, -4.74746103899993],
              [-78.91734879599991, -4.719969177999872],
              [-78.89864192799993, -4.694234313999885],
              [-78.85306331499993, -4.652273049999877],
              [-78.8112829179999, -4.62870859799996],
              [-78.7197122799999, -4.592225036999949],
              [-78.7089347759999, -4.585108369999887],
              [-78.68167842699998, -4.567110290999935],
              [-78.67266088899993, -4.550987242999952],
              [-78.6714464929999, -4.531763609999928],
              [-78.67237666899985, -4.51181650799991],
              [-78.66979284699994, -4.493419697999911],
              [-78.65534928499991, -4.470165302999902],
              [-78.63989803099992, -4.451251728999949],
              [-78.63721085599988, -4.435128681999885],
              [-78.66098201599993, -4.420659280999942],
              [-78.67315181499995, -4.401539000999946],
              [-78.68121333899987, -4.364435322999967],
              [-78.68242773499989, -4.326918232999972],
              [-78.67413366799991, -4.305937600999883],
              [-78.65573685699994, -4.290641376999915],
              [-78.64710689399988, -4.271107685999908],
              [-78.63757259199988, -4.227389423999924],
              [-78.57662023999993, -4.10005869499993],
              [-78.56592321799991, -4.055720316999981],
              [-78.5669050699999, -3.996189065999914],
              [-78.56207332399987, -3.979755960999853],
              [-78.55189306699992, -3.969213968999981],
              [-78.54075679499988, -3.966320088999893],
              [-78.5286386729999, -3.965389912999939],
              [-78.51571956399988, -3.96135915099994],
              [-78.50176692699989, -3.95371103899987],
              [-78.49763281299997, -3.949576924999946],
              [-78.49771032699988, -3.942652282999873],
              [-78.48784012899992, -3.868651631999867],
              [-78.48068294299986, -3.849531351999957],
              [-78.47037349499996, -3.830204365999919],
              [-78.46432735299993, -3.82565683999988],
              [-78.45200252399988, -3.819869078999901],
              [-78.44407019099992, -3.814804788999922],
              [-78.41967891499988, -3.791033629999959],
              [-78.41358109499993, -3.771809996999949],
              [-78.42637101299991, -3.707214456999893],
              [-78.4264226889999, -3.69460540699987],
              [-78.42585424899997, -3.689437763999962],
              [-78.42110001699987, -3.687784118999915],
              [-78.40836177599991, -3.685613708999924],
              [-78.40073950199994, -3.679825947999859],
              [-78.40009354699987, -3.670110778999913],
              [-78.4042534999999, -3.649750263999891],
              [-78.40471858799992, -3.613783466999905],
              [-78.4023931479999, -3.594353128999927],
              [-78.39567521199987, -3.573785908999938],
              [-78.37725256399995, -3.533684997999941],
              [-78.37587184799995, -3.529348453999958],
              [-78.36293819199997, -3.488726500999931],
              [-78.35529007999989, -3.44552500399989],
              [-78.35469580099993, -3.434569600999922],
              [-78.3607936199999, -3.414932555999883],
              [-78.36172379599995, -3.408524677999935],
              [-78.35079423099995, -3.389611103999897],
              [-78.33397355199989, -3.384546813999918],
              [-78.3130187589999, -3.387440693999906],
              [-78.26968806999994, -3.399532978999986],
              [-78.25718237299992, -3.409558206999918],
              [-78.2496892909999, -3.424544371999986],
              [-78.23586584599994, -3.488829854999949],
              [-78.22630570499985, -3.507019958999905],
              [-78.21268896599994, -3.500508727999929],
              [-78.19685013899993, -3.487589619999923],
              [-78.17912512299992, -3.483765563999981],
              [-78.16372554599994, -3.477254332999919],
              [-78.15452714099985, -3.456790465999859],
              [-78.1566458739999, -3.429298603999882],
              [-78.16920324699993, -3.414932555999883],
              [-78.18496455899992, -3.403770446999943],
              [-78.19651424199995, -3.385580342999901],
              [-78.19641088899994, -3.363669534999943],
              [-78.18460282399991, -3.349510192999901],
              [-78.14817093899993, -3.322431742999939],
              [-78.13582027299987, -3.304655049999923],
              [-78.10491776599986, -3.245433857999927],
              [-78.09086177599994, -3.230034280999945],
              [-78.0425443119999, -3.189933369999949],
              [-77.94146520999996, -3.054541116999957],
              [-77.86782629399994, -2.990255634999897],
              [-77.84901607299994, -2.98064381899988],
              [-77.81036941199991, -2.967149115999945],
              [-77.7827152099999, -2.957492776999899],
              [-77.65698645099985, -2.913567809999947],
              [-77.53120601399988, -2.869642841999919],
              [-77.40547725399992, -2.825614522999956],
              [-77.27974849499986, -2.781689554999929],
              [-77.1540197349999, -2.737661234999962],
              [-77.0281876219999, -2.69373626699992],
              [-76.90245886199995, -2.649811299999982],
              [-76.77667842699987, -2.605782978999926],
              [-76.68459102499995, -2.5736402389999],
              [-76.66966155799986, -2.564588924999896],
              [-76.62526647999994, -2.537673441999928],
              [-76.56862910999985, -2.49426523899993],
              [-76.50894282999994, -2.448583271999922],
              [-76.4492565509999, -2.402901305999904],
              [-76.38962194899992, -2.357322692999915],
              [-76.32988399299998, -2.311537373999968],
              [-76.27024938999998, -2.265855406999961],
              [-76.21051143399984, -2.220276794999975],
              [-76.15087683199994, -2.174594827999968],
              [-76.09124222899993, -2.12891286199995],
              [-76.04127111899996, -2.070725198999952],
              [-75.9913516849999, -2.012640888999968],
              [-75.94138057499993, -1.954453226999959],
              [-75.89146114199986, -1.896265563999947],
              [-75.84154170699989, -1.838077900999934],
              [-75.79154475999991, -1.779890237999922],
              [-75.74162532599985, -1.721702575999913],
              [-75.69173173099998, -1.663618265999929],
              [-75.65147578999995, -1.616696064999886],
              [-75.59654374199991, -1.565743102999946],
              [-75.5807400969999, -1.546639795999923],
              [-75.57303096599992, -1.537321064999915],
              [-75.5600343429999, -1.502594501999894],
              [-75.54533239799991, -1.444820250999982],
              [-75.51530838999994, -1.326997985999881],
              [-75.4852843839999, -1.209072366999933],
              [-75.45526037699995, -1.091146748999989],
              [-75.42523636899998, -0.973324482999971],
              [-75.41257564299994, -0.92392181299995],
              [-75.40640030999995, -0.915136819999873],
              [-75.37805578699997, -0.941181741999941],
              [-75.36441320799995, -0.956891377999909],
              [-75.35859960999997, -0.966916604999938],
              [-75.34872941099988, -0.974978128999922],
              [-75.32594010499989, -0.975494892999961],
              [-75.28348791499988, -0.970430602999983],
              [-75.23620397999991, -0.970430602999983],
              [-75.2272639579999, -0.969810484999925],
              [-75.22749650099985, -0.963092549999899],
              [-75.23475703999992, -0.95317067499991],
              [-75.24434301799994, -0.944799092999929],
              [-75.25206864499992, -0.933430276999943],
              [-75.25390315799993, -0.924128519999911],
              [-75.2523011889999, -0.90686859099992],
              [-75.25261124699998, -0.897876891999971],
              [-75.29702713999984, -0.746981709999972],
              [-75.29661372899992, -0.734476012999977],
              [-75.2902575279999, -0.716492613999904],
              [-75.28813879399993, -0.706260680999918],
              [-75.28865555799987, -0.696132100999961],
              [-75.29294470299993, -0.677735289999958],
              [-75.29397823099993, -0.667916767999898],
              [-75.28943070599988, -0.656031188999876],
              [-75.27875952199989, -0.648899840999931],
              [-75.26664139799988, -0.642698668999941],
              [-75.25764969999994, -0.633190204999963],
              [-75.2555826419999, -0.624301858999942],
              [-75.25697790599986, -0.616757101],
              [-75.25930334499989, -0.609522399999932],
              [-75.2601301679999, -0.601254170999894],
              [-75.25702958199989, -0.56198008199992],
              [-75.26069860899989, -0.543479918999893],
              [-75.27204158499987, -0.525703225999948],
              [-75.27653743599987, -0.524152933999929],
              [-75.28591670799992, -0.52901051799995],
              [-75.2909809979999, -0.527976989999971],
              [-75.29485673099995, -0.523222757999889],
              [-75.30002437399986, -0.511750589999878],
              [-75.30428767899991, -0.50709971099991],
              [-75.3432775469999, -0.476817321999874],
              [-75.34735998599993, -0.470926208999884],
              [-75.35307023199996, -0.467722268999907],
              [-75.36539506099993, -0.468755797999975],
              [-75.37565283299992, -0.46699879899991],
              [-75.38699580999989, -0.459970804999898],
              [-75.40562516299985, -0.442400817999925],
              [-75.43422806899991, -0.403023375999922],
              [-75.45272823099995, -0.360648701999907],
              [-75.48476761999987, -0.247684020999912],
              [-75.49618811099995, -0.23311126699987],
              [-75.5121561279999, -0.223086038999938],
              [-75.53352433299989, -0.216058043999922],
              [-75.54590083899987, -0.209753518999918],
              [-75.56682979399994, -0.190013122999943],
              [-75.57897375499994, -0.182675068999856],
              [-75.5887147629999, -0.181331481999976],
              [-75.61013464399991, -0.182985127999942],
              [-75.61956559299998, -0.180918069999976],
              [-75.62863480699994, -0.170479430999933],
              [-75.63840165199989, -0.150945738999937],
              [-75.64320756099991, -0.128828226999929],
              [-75.63760066799998, -0.111464945999913],
              [-75.62300207599992, -0.106607360999888],
              [-75.60501867699992, -0.111361592999884],
              [-75.58677689599998, -0.118699645999882],
              [-75.57117061399993, -0.121696878999984],
              [-75.55329056799988, -0.119836527999979],
              [-75.53926041799986, -0.120043232999933],
              [-75.52574702999988, -0.123247171999907],
              [-75.45526037699995, -0.161177672999912],
              [-75.42949967499993, -0.163658141999889],
              [-75.40257625399991, -0.14577809599993],
              [-75.39423050999994, -0.145054625999933],
              [-75.36002071199997, -0.149912210999943],
              [-75.34405269399991, -0.149085387999932],
              [-75.3307460129999, -0.144641214999922],
              [-75.31795609599993, -0.138336689999903],
              [-75.29534765599988, -0.122316995999952],
              [-75.28348791499988, -0.107020771999899],
              [-75.26834672099994, -0.101749775999878],
              [-75.25253373299995, -0.089554137999954],
              [-75.24013138899988, -0.07477467799994],
              [-75.23511877499993, -0.061958923999953],
              [-75.2317081299999, -0.0426319379999],
              [-75.22209631399988, -0.032400003999925],
              [-75.20674841399992, -0.029092711999922],
              [-75.18669795699986, -0.031263121999913],
              [-75.14168778599992, -0.043458759999922],
              [-75.12065547799992, -0.054104104999922],
              [-75.10163854999985, -0.06909026999989],
              [-75.06231278599995, -0.123143818999978],
              [-75.05073726399993, -0.134305928999908],
              [-75.04223649099993, -0.13730316099992],
              [-75.02469234299994, -0.137716572999935],
              [-75.0153647459999, -0.140507100999898],
              [-75.0091118979999, -0.145261331999976],
              [-74.96821000199989, -0.189703063999957],
              [-74.95487748199989, -0.200038349999971],
              [-74.93345760199986, -0.209443460999921],
              [-74.89932531799988, -0.216781513999919],
              [-74.88271134499988, -0.222775980999941],
              [-74.87271195499994, -0.221949156999926],
              [-74.8614723309999, -0.213164163999934],
              [-74.83653845299992, -0.173269957999906],
              [-74.8246528729999, -0.170479430999933],
              [-74.80369807999989, -0.18897959399996],
              [-74.78946122199994, -0.20903004999991],
              [-74.75532893899995, -0.278276468999934],
              [-74.78284663899984, -0.299153746999906],
              [-74.79070145699987, -0.312589618999951],
              [-74.77300227899985, -0.318687437999913],
              [-74.76269283099995, -0.319824319999924],
              [-74.7430041099999, -0.324888610999892],
              [-74.71812190799994, -0.32726572699994],
              [-74.71184322099995, -0.330262959999857],
              [-74.7076574299999, -0.334603779999938],
              [-74.70073278799993, -0.339771422999931],
              [-74.69564265999995, -0.34462900799987],
              [-74.6925162359999, -0.349693297999934],
              [-74.68657344599987, -0.353414000999948],
              [-74.67275000099991, -0.35403411899992],
              [-74.66771154799994, -0.351553649999943],
              [-74.66140702299992, -0.346799417999947],
              [-74.65308711799989, -0.341941833999925],
              [-74.64231258199996, -0.339771422999931],
              [-74.63272660399994, -0.347419534999915],
              [-74.60445959499987, -0.394961852999927],
              [-74.56239497899995, -0.439403584999909],
              [-74.53635005799995, -0.459970804999898],
              [-74.47563024999997, -0.496454365999909],
              [-74.46377050899994, -0.506789651999924],
              [-74.45056717899985, -0.521569111999938],
              [-74.44188553899988, -0.535521747999923],
              [-74.43653702899994, -0.537795511999946],
              [-74.42292028899993, -0.538312275999886],
              [-74.4179593509999, -0.542653095999867],
              [-74.4158147789999, -0.552678324999889],
              [-74.41471693699992, -0.563756555999902],
              [-74.4146778979999, -0.564150491999911],
              [-74.41266251699994, -0.573142191999949],
              [-74.36488765499988, -0.676184996999936],
              [-74.36726477099992, -0.683212991999952],
              [-74.38013220199991, -0.694271748999952],
              [-74.38475724399987, -0.702850035999887],
              [-74.3851448159999, -0.721970315999982],
              [-74.37819433699988, -0.736543069999939],
              [-74.3443204349999, -0.774060159999934],
              [-74.33755082199994, -0.778607685999873],
              [-74.32786149099991, -0.781501565999861],
              [-74.31057572499992, -0.782018330999989],
              [-74.30279842199991, -0.78542897599992],
              [-74.31060156299992, -0.801448668999882],
              [-74.30483964099994, -0.81312754299995],
              [-74.29460770699987, -0.823669534999922],
              [-74.28913000599988, -0.836278584999945],
              [-74.29512447199991, -0.847337340999943],
              [-74.30905126999991, -0.847337340999943],
              [-74.32514847899998, -0.844546813999983],
              [-74.33755082199994, -0.846820575999914],
              [-74.34442378799992, -0.858602802999911],
              [-74.33832596899995, -0.867697855999978],
              [-74.31336625199987, -0.884441019999926],
              [-74.30339269999988, -0.897773538999942],
              [-74.28913000599988, -0.943042093999864],
              [-74.26675410999991, -0.972290954999906],
              [-74.2401924239999, -0.986863708999863],
              [-74.1805319829999, -0.997715758999902],
              [-74.11963130699993, -1.020970153999926],
              [-74.09237198899993, -1.0201433309999],
              [-74.07689489799992, -0.990894469999944],
              [-74.06544856799991, -1.001436462999919],
              [-74.04203914399994, -1.07109629299994],
              [-74.03720739799994, -1.079674580999963],
              [-74.02909419799994, -1.086392516999908],
              [-74.01679520699989, -1.091560159999901],
              [-74.01111079999995, -1.090009866999893],
              [-74.00589147999992, -1.084842223999971],
              [-73.99496191499986, -1.079674580999963],
              [-73.99134456399989, -1.075333759999893],
              [-73.98783056699992, -1.068925882999864],
              [-73.98279211399995, -1.066238707999929],
              [-73.97447220899988, -1.073370055999959],
              [-73.97333532699989, -1.081638284999912],
              [-73.98268876099993, -1.099208271999885],
              [-73.98129349799984, -1.107476501999926],
              [-73.96762508199993, -1.114814554999924],
              [-73.93641251699995, -1.107786559999909],
              [-73.91990189699996, -1.113781025999941],
              [-73.91411413599991, -1.123082783999962],
              [-73.89876623599991, -1.162770283999947],
              [-73.88075699899994, -1.190985615999921],
              [-73.8710159909999, -1.201424255999953],
              [-73.85716670799991, -1.210519306999927],
              [-73.83047583099997, -1.219924417999977],
              [-73.81448197399993, -1.223335062999908],
              [-73.80254471899988, -1.22364512099989],
              [-73.78585323199985, -1.214240009999941],
              [-73.76978186099987, -1.188918557999955],
              [-73.7547181809999, -1.183337503999937],
              [-73.7463724369999, -1.201320901999921],
              [-73.73236812399992, -1.216513772999861],
              [-73.71340287399997, -1.22715911899985],
              [-73.69020015499987, -1.231086526999917],
              [-73.67911555999984, -1.234290465999976],
              [-73.66007279499988, -1.248346454999904],
              [-73.6365600179999, -1.255167744999952],
              [-73.63139237499988, -1.264056090999873],
              [-73.62880855399987, -1.275114847999888],
              [-73.62154801499992, -1.290617777999984],
              [-73.62002355999988, -1.301573180999867],
              [-73.6182148849999, -1.306120706999906],
              [-73.61418412299992, -1.307050882999945],
              [-73.6008774419999, -1.305190531999941],
              [-73.59713089999988, -1.306120706999906],
              [-73.59397863799992, -1.31335540699996],
              [-73.5920666099999, -1.321726988999941],
              [-73.59087805199997, -1.343431090999943],
              [-73.58896602399994, -1.350252379999901],
              [-73.58426346899998, -1.358313903999885],
              [-73.57857906099991, -1.364928486999887],
              [-73.56292110299998, -1.372163186999941],
              [-73.5677528489999, -1.382705179999917],
              [-73.58343664599994, -1.401722106999969],
              [-73.57421240299993, -1.416914977999909],
              [-73.53713456299997, -1.434278258999925],
              [-73.52597245399994, -1.451744892999969],
              [-73.5048884689999, -1.46724782299988],
              [-73.49716284199991, -1.477996520999909],
              [-73.49527665199989, -1.487918395999898],
              [-73.49545751999995, -1.498460387999955],
              [-73.49406225599995, -1.511586201999933],
              [-73.4835461019999, -1.55334075899988],
              [-73.48452795399987, -1.572461038999961],
              [-73.50881587699988, -1.586827086999961],
              [-73.5174200029999, -1.602019958999989],
              [-73.52881465699991, -1.635092874999884],
              [-73.5309850669999, -1.673746845999887],
              [-73.51093461199994, -1.698551533999932],
              [-73.4462873949999, -1.738135680999974],
              [-73.44484045399989, -1.741856383999988],
              [-73.44153316299989, -1.755292256999937],
              [-73.4400862219999, -1.758702900999964],
              [-73.43543534399993, -1.759529723999904],
              [-73.42442826399994, -1.75808278399991],
              [-73.4102172449999, -1.759736429999947],
              [-73.39915848799987, -1.759219664999918],
              [-73.3870662029999, -1.760873311999958],
              [-73.3745605069999, -1.768831481999925],
              [-73.35053096599995, -1.790638935999951],
              [-73.34029903199988, -1.792189228999874],
              [-73.33270259599993, -1.781130471999873],
              [-73.31657954999994, -1.765420836999894],
              [-73.30123164899987, -1.763560485999989],
              [-73.26769364399988, -1.772242125999952],
              [-73.26133744399993, -1.768831481999925],
              [-73.25725500599992, -1.742373147999928],
              [-73.24702307099994, -1.742373147999928],
              [-73.22030635699988, -1.772345478999881],
              [-73.21069453999988, -1.779270120999868],
              [-73.20139278199994, -1.783300882999953],
              [-73.19302119999986, -1.788675231999918],
              [-73.18625158699993, -1.799630635999989],
              [-73.19364131799995, -1.836837666999898],
              [-73.1883186449999, -1.850686950999958],
              [-73.16470251599989, -1.878488870999917],
              [-73.1589147549999, -1.895232034999964],
              [-73.16113684099992, -1.90443044099996],
              [-73.17116206899993, -1.929545185999899],
              [-73.1725573329999, -1.943601175999916],
              [-73.16873327699997, -1.959310810999881],
              [-73.16196366399993, -1.972436624999943],
              [-73.14460038299993, -1.99817148799994],
              [-73.13783076999997, -2.016878356999925],
              [-73.13235306899989, -2.039822692999863],
              [-73.12454992699986, -2.060803323999949],
              [-73.1110623779999, -2.073412373999886],
              [-73.1405179439999, -2.121884866999949],
              [-73.14992305499996, -2.14358896899995],
              [-73.18625158699993, -2.176351826999863],
              [-73.1952949629999, -2.187203877999906],
              [-73.19855057799987, -2.193818460999893],
              [-73.19984248899993, -2.203740335999981],
              [-73.19777543199987, -2.213558857999956],
              [-73.1883186449999, -2.228751729999885],
              [-73.18625158699993, -2.234746195999918],
              [-73.18309932499997, -2.239707132999868],
              [-73.16945674599987, -2.250145771999897],
              [-73.16630448399991, -2.255520120999961],
              [-73.16139522399988, -2.285389098999886],
              [-73.1589147549999, -2.293037210999955],
              [-73.14248164899993, -2.304095966999867],
              [-73.09886673999998, -2.31494801799991],
              [-73.08997839399987, -2.323836363999916],
              [-73.08382889899991, -2.345127054999907],
              [-73.07070308499993, -2.33324147499988],
              [-73.05886918199991, -2.310607197999929],
              [-73.05644038899996, -2.299858499999914],
              [-72.98755570599994, -2.337685648999894],
              [-72.98430008999986, -2.343370055999927],
              [-72.96977901299991, -2.356082457999975],
              [-72.9527774659999, -2.402281187999932],
              [-72.94326900199991, -2.419024352999884],
              [-72.93541418499987, -2.425328877999988],
              [-72.92616410399995, -2.42522552399987],
              [-72.88378942999995, -2.41675058899996],
              [-72.86999182199989, -2.411789651999925],
              [-72.85805456599985, -2.400317484999903],
              [-72.82947749899989, -2.390188902999853],
              [-72.80467281099996, -2.377786559999976],
              [-72.78798132399993, -2.383574319999951],
              [-72.76167801999986, -2.402281187999932],
              [-72.75904252099986, -2.389982197999899],
              [-72.75418493699993, -2.380680440999868],
              [-72.74607173699994, -2.373445739999909],
              [-72.73372106999997, -2.367554626999905],
              [-72.72876013199993, -2.374685973999931],
              [-72.72457434099988, -2.383470967999926],
              [-72.72173213699992, -2.393702900999912],
              [-72.7183214929999, -2.419851175999909],
              [-72.7124303789999, -2.422124938999929],
              [-72.69584224499988, -2.416543883999907],
              [-72.68318151899985, -2.404761657999913],
              [-72.65682653799988, -2.350191344999885],
              [-72.6443208419999, -2.334068297999906],
              [-72.62597570799991, -2.336858824999865],
              [-72.60840572199993, -2.346367288999943],
              [-72.56298213799988, -2.383057555999912],
              [-72.54412023899997, -2.389052021999944],
              [-72.4415941979999, -2.405175068999924],
              [-72.43265417499987, -2.412926533999922],
              [-72.42753820899989, -2.425018818999916],
              [-72.41425736499988, -2.437111103999896],
              [-72.39658402599989, -2.44651621499986],
              [-72.37803218699992, -2.450753682999903],
              [-72.35560461499995, -2.448893330999908],
              [-72.31565873199989, -2.438351337999933],
              [-72.29240433799987, -2.435870869999874],
              [-72.28382604999993, -2.433183694999926],
              [-72.28098384599986, -2.426155699999924],
              [-72.2818623449999, -2.405691832999963],
              [-72.2766947019999, -2.401557718999939],
              [-72.2509598399999, -2.396286721999914],
              [-72.24093461099997, -2.395459899999892],
              [-72.17639074699994, -2.410342711999931],
              [-72.16145625899989, -2.405691832999963],
              [-72.11737626099992, -2.355152281999935],
              [-72.0894193119999, -2.330967711999961],
              [-72.06151403899992, -2.320012307999974],
              [-72.02895788599989, -2.319598896999963],
              [-71.96627437399985, -2.328487242999884],
              [-71.94865270999986, -2.324146423999906],
              [-71.93635371999991, -2.311847431999865],
              [-71.93175451699997, -2.289626565999924],
              [-71.92441646299997, -2.281875101999916],
              [-71.87718420399995, -2.245288186999886],
              [-71.84106237899994, -2.19009775699989],
              [-71.83620479399991, -2.179762470999975],
              [-71.82612788899988, -2.179039000999879],
              [-71.76794022699997, -2.142245381999885],
              [-71.74613277299994, -2.132323506999896],
              [-71.73848465999995, -2.137697854999942],
              [-71.73998327699988, -2.172941181999917],
              [-71.73140498899994, -2.189891051999922],
              [-71.71202632699988, -2.186790465999891],
              [-71.67853999899998, -2.169530536999986],
              [-71.65492386899987, -2.173768004999943],
              [-71.6352351489999, -2.185550231999855],
              [-71.61663163299994, -2.199916279999854],
              [-71.59596105999992, -2.211078388999894],
              [-71.53839351399989, -2.22296396899992],
              [-71.52712805199994, -2.231542256999944],
              [-71.5222704679999, -2.25035247699995],
              [-71.52097855599996, -2.292107034999901],
              [-71.51405391499989, -2.307403258999955],
              [-71.49813757299995, -2.315051370999939],
              [-71.49043778599986, -2.303269143999927],
              [-71.48056758699988, -2.265752054999936],
              [-71.46666662699991, -2.251489358999962],
              [-71.45648636899995, -2.255106708999946],
              [-71.43896805899988, -2.286215921999897],
              [-71.41524857699994, -2.316291604999961],
              [-71.41163122599994, -2.326626891999879],
              [-71.41437007699989, -2.335101826999974],
              [-71.42816768399985, -2.347504170999855],
              [-71.43214676899993, -2.355152281999935],
              [-71.42082963099995, -2.3760295619999],
              [-71.38698156799995, -2.368898213999955],
              [-71.31546138499994, -2.334068297999906],
              [-71.3076065679999, -2.347814228999937],
              [-71.28905472899996, -2.343370055999927],
              [-71.26817744999997, -2.332414652999944],
              [-71.25334631399994, -2.326626891999879],
              [-71.2424425859999, -2.329107360999956],
              [-71.23045365399992, -2.337995706999962],
              [-71.21985998599985, -2.341509703999918],
              [-71.20905961199992, -2.339235940999913],
              [-71.1902493899999, -2.324559834999917],
              [-71.16193070599991, -2.310193785999914],
              [-71.14281042499991, -2.262858174999863],
              [-71.1199694419999, -2.252109476999934],
              [-71.09221919799995, -2.247251891999909],
              [-71.07911922199992, -2.247561949999906],
              [-71.05392696199996, -2.262651468999906],
              [-71.04142126499997, -2.265338642999922],
              [-71.02969071499987, -2.263995055999956],
              [-71.02062150099991, -2.258930765999892],
              [-71.02979406799992, -2.233505960999878],
              [-71.0319903159999, -2.210768330999898],
              [-71.02144832399995, -2.196712340999881],
              [-70.99271622799992, -2.197435811999881],
              [-70.9503157149999, -2.215419208999961],
              [-70.92525264499992, -2.220276794999975],
              [-70.90455623399987, -2.211078388999894],
              [-70.87419632999993, -2.229578551999907],
              [-70.82236486799985, -2.284768981999903],
              [-70.78787084999988, -2.307403258999955],
              [-70.75105139199988, -2.320529072999918],
              [-70.73247371499991, -2.324973245999928],
              [-70.70658382199989, -2.32828053799993],
              [-70.70144201699989, -2.33324147499988],
              [-70.69906490099993, -2.341096292999907],
              [-70.69903906299993, -2.370138447999906],
              [-70.69524084499992, -2.37210215199994],
              [-70.66371822199994, -2.398250426999937],
              [-70.65754288799988, -2.409102477999895],
              [-70.6562251389999, -2.419231058999941],
              [-70.6562509769999, -2.433080341999911],
              [-70.65446813999992, -2.445379332999948],
              [-70.64759517499996, -2.450753682999903],
              [-70.60635738099995, -2.450753682999903],
              [-70.59863175499996, -2.446619567999974],
              [-70.59775325499993, -2.437111103999896],
              [-70.59858007799994, -2.425845641999942],
              [-70.59607377099988, -2.416543883999907],
              [-70.57860713799991, -2.40548512799991],
              [-70.56553300099995, -2.413753356999948],
              [-70.55320817099991, -2.428119404999947],
              [-70.53773107899991, -2.435870869999874],
              [-70.52091040099992, -2.43804127999995],
              [-70.50199682699991, -2.443829039999926],
              [-70.48445267799994, -2.452510680999893],
              [-70.47192114299992, -2.463156025999879],
              [-70.46610754399995, -2.474008076999922],
              [-70.4625935469999, -2.484240009999908],
              [-70.45698665399996, -2.492714944999904],
              [-70.44525610399998, -2.498502705999968],
              [-70.43484330299995, -2.497675882999957],
              [-70.41133052599986, -2.487443948999967],
              [-70.40024593199985, -2.48486012799988],
              [-70.37877437399993, -2.484653421999923],
              [-70.35753536099995, -2.486927184999928],
              [-70.34492631099991, -2.496642353999974],
              [-70.3496288659999, -2.518346455999961],
              [-70.35453812699984, -2.521550393999945],
              [-70.37156551099986, -2.527958271999893],
              [-70.37634558099995, -2.532609150999946],
              [-70.3757254649999, -2.541084085999941],
              [-70.37091955599988, -2.550282490999948],
              [-70.36461503099989, -2.557620543999946],
              [-70.3596024169999, -2.560617777999951],
              [-70.33510778899995, -2.554003193999961],
              [-70.31508317099991, -2.541807555999938],
              [-70.2958853769999, -2.535399678999909],
              [-70.27394873099993, -2.546251728999948],
              [-70.26139135799991, -2.564751891999975],
              [-70.24730952999991, -2.60722991899992],
              [-70.23606990599984, -2.625109964999879],
              [-70.2175180669999, -2.632137959999895],
              [-70.20090409399998, -2.624386494999982],
              [-70.18387670999996, -2.619528910999875],
              [-70.1640846359999, -2.635031838999879],
              [-70.16113907899998, -2.6450570679999],
              [-70.16147497599988, -2.655185647999943],
              [-70.1597179769999, -2.663970641999938],
              [-70.15046789599998, -2.66924163799996],
              [-70.14183793199993, -2.666967874999955],
              [-70.13643774399989, -2.658596292999974],
              [-70.13194189499987, -2.647950947999973],
              [-70.12620581099989, -2.638752542999981],
              [-70.10579361999996, -2.625213316999904],
              [-70.0949674069999, -2.632551370999906],
              [-70.08212581399991, -2.676579690999873],
              [-70.07579545099989, -2.691359150999887],
              [-70.06747554499992, -2.703451435999867],
              [-70.05600337799993, -2.712443135999905],
              [-70.0504481609999, -2.71430348699991],
              [-70.05062902799995, -2.715130309999935],
              [-70.07305659999986, -2.750683694999907],
              [-70.15150142399997, -2.87305348699995],
              [-70.22994624899988, -2.99531992599988],
              [-70.30836523399998, -3.117793069999948],
              [-70.38683589699991, -3.240162861999892],
              [-70.46528072099991, -3.362532653999935],
              [-70.54372554499994, -3.485005797999918],
              [-70.62211869399994, -3.607272236999933],
              [-70.70056351799985, -3.729642027999887],
              [-70.73412735999997, -3.782041930999924],
              [-70.69064164299996, -3.78679616299992],
              [-70.55496516999989, -3.857902933999938],
              [-70.5442939859999, -3.865240986999936],
              [-70.49088639399989, -3.878470153999928],
              [-70.46424719299995, -3.87878021199991],
              [-70.43851232899993, -3.867721455999913],
              [-70.39921240299986, -3.831858011999955],
              [-70.37768916899992, -3.818835550999921],
              [-70.34957718999988, -3.815838317999905],
              [-70.31110408499993, -3.829274189999865],
              [-70.27356115699993, -3.856559345999884],
              [-70.24087581499995, -3.890872496999904],
              [-70.21697546399986, -3.924978942999957],
              [-70.20457312099998, -3.960118915999914],
              [-70.19894038899986, -3.995982360999946],
              [-70.1883983969999, -4.028951923999912],
              [-70.16170751999994, -4.055616963999867],
              [-70.06049922699995, -4.10719004299996],
              [-70.0305010589999, -4.131581318999906],
              [-70.01021805899998, -4.155145771999898],
              [-69.99275142399992, -4.180880634999895],
              [-69.96494950399997, -4.236484476999905],
              [-69.96257238799984, -4.26428639699995],
              [-69.97182246999995, -4.290951435999901],
              [-69.98939245599993, -4.314619241999935],
              [-70.02290462299993, -4.338907165999927],
              [-70.03703812699987, -4.340870869999961],
              [-70.05096492599995, -4.337253518999972],
              [-70.06334143099991, -4.328468525999895],
              [-70.07561458299995, -4.316169534999858],
              [-70.08109228599994, -4.30883148199996],
              [-70.08574316499991, -4.283923441999889],
              [-70.09662105399985, -4.265733336999944],
              [-70.11651647999986, -4.258291930999931],
              [-70.13889237499984, -4.260462340999922],
              [-70.15726334699994, -4.270177510999957],
              [-70.17025996899986, -4.288470967999928],
              [-70.1865638839999, -4.326298115999904],
              [-70.20563248699997, -4.342937926999923],
              [-70.21674291999989, -4.328881936999906],
              [-70.22472692899996, -4.313068948999913],
              [-70.23131567399986, -4.303663837999949],
              [-70.23917049199989, -4.301803486999944],
              [-70.24798132399988, -4.30211354599993],
              [-70.2575931399999, -4.299219665999942],
              [-70.3069958099999, -4.260255634999865],
              [-70.31671097899996, -4.247026467999959],
              [-70.3183904629999, -4.228939716999946],
              [-70.30934708699996, -4.191215921999898],
              [-70.31110408499993, -4.170855406999877],
              [-70.3187005209999, -4.156282653999909],
              [-70.33061193899994, -4.143156839999946],
              [-70.3430659599999, -4.139436136999933],
              [-70.3614369309999, -4.168168232999932],
              [-70.37368424599993, -4.164550882999947],
              [-70.39866980099993, -4.142330016999921],
              [-70.41533544899994, -4.135612080999891],
              [-70.42993404199993, -4.134165140999897],
              [-70.4442225759999, -4.137369078999967],
              [-70.4600097249999, -4.14460377999994],
              [-70.50088578299989, -4.177366637999938],
              [-70.5159753019999, -4.182327575999892],
              [-70.52638810299993, -4.176023049999884],
              [-70.52938533499994, -4.161346943999888],
              [-70.53411372899993, -4.146774189999931],
              [-70.54969417399985, -4.14067637099987],
              [-70.56563635299989, -4.148841247999897],
              [-70.57232845099992, -4.165894469999927],
              [-70.57656591799986, -4.183877868999915],
              [-70.58527339699992, -4.194523213999901],
              [-70.63253149499988, -4.166824645999966],
              [-70.63317744999995, -4.15183847999991],
              [-70.62958593799996, -4.133441669999911],
              [-70.63105871599987, -4.118972268999883],
              [-70.64676835199992, -4.115664977999884],
              [-70.66289139799991, -4.122176208999946],
              [-70.6720381269999, -4.133441669999911],
              [-70.6830710459999, -4.163827412999865],
              [-70.69405228799988, -4.172302346999871],
              [-70.71211319999989, -4.171888935999945],
              [-70.77425410999987, -4.155042418999884],
              [-70.78456355799997, -4.156282653999909],
              [-70.83223506699991, -4.179433694999901],
              [-70.84518001399994, -4.191009215999941],
              [-70.8483064379999, -4.204445088999904],
              [-70.8398056639999, -4.228733011999893],
              [-70.8427512209999, -4.238138121999953],
              [-70.8582541509999, -4.243305764999945],
              [-70.8737054039999, -4.250747171999876],
              [-70.8811209719999, -4.265629984999919],
              [-70.8865728349999, -4.283510029999974],
              [-70.89639135799987, -4.299839781999921],
              [-70.92633785099989, -4.328985289999935],
              [-70.93884354699989, -4.345108337999918],
              [-70.9480936279999, -4.364228617999913],
              [-70.96868668699992, -4.385312601999942],
              [-70.98971899499992, -4.366192321999947],
              [-71.0054544679999, -4.347588805999891],
              [-71.00997615599991, -4.369809671999931],
              [-71.02932897999997, -4.385829365999882],
              [-71.08157385299998, -4.364125263999881],
              [-71.10604264399993, -4.373840432999927],
              [-71.1195560299999, -4.396371357999939],
              [-71.12849605299994, -4.401849059999932],
              [-71.14410233599995, -4.399265238999931],
              [-71.15247391799994, -4.391720478999972],
              [-71.16311926299994, -4.369086201999934],
              [-71.1696821699999, -4.362781676999916],
              [-71.1861669519999, -4.37218678799988],
              [-71.20068802999992, -4.395647887999942],
              [-71.21407222499997, -4.410840758999967],
              [-71.24166743999987, -4.380041605999907],
              [-71.26481848099988, -4.375494079999967],
              [-71.28848628799989, -4.3807650749999],
              [-71.30460933399988, -4.394924417999945],
              [-71.30724483299988, -4.406809997999886],
              [-71.30512609899992, -4.416628519999946],
              [-71.30538448199988, -4.42706715899989],
              [-71.31515132699994, -4.439986266999895],
              [-71.31845861899984, -4.439366149999927],
              [-71.32409134999997, -4.436575622999968],
              [-71.33075760899987, -4.435128681999885],
              [-71.33701045799998, -4.438332620999944],
              [-71.34589880399989, -4.450114847999942],
              [-71.34956783099989, -4.453525492999873],
              [-71.3632620859999, -4.459209899999919],
              [-71.37116857999987, -4.453215432999897],
              [-71.37762813299992, -4.442673441999929],
              [-71.38698156799995, -4.434921975999913],
              [-71.4007791759999, -4.433371683999894],
              [-71.44697790599986, -4.440296325999967],
              [-71.47741532499992, -4.440606383999864],
              [-71.49234981399988, -4.442776794999943],
              [-71.50614742099992, -4.44856455399993],
              [-71.51286535699995, -4.457142842999957],
              [-71.51906652799994, -4.479157002999941],
              [-71.52459590699993, -4.485151468999959],
              [-71.53234737199995, -4.48463470399993],
              [-71.55756547099992, -4.479363707999894],
              [-71.5715697839999, -4.480707295999949],
              [-71.6171483979999, -4.500344339999899],
              [-71.6134276949999, -4.479260355999955],
              [-71.62350459799993, -4.482257587999882],
              [-71.64381343699995, -4.502308043999932],
              [-71.65652583799991, -4.506752217999932],
              [-71.66520747899995, -4.507579039999953],
              [-71.67306229699989, -4.503651630999897],
              [-71.68334590699988, -4.49352305099994],
              [-71.69931392499993, -4.481637470999914],
              [-71.70964921099991, -4.484738056999944],
              [-71.72106970199994, -4.492799580999943],
              [-71.74018998199992, -4.495590107999902],
              [-71.75145544499989, -4.492076110999946],
              [-71.7743481039999, -4.481534118999974],
              [-71.78483841999986, -4.480500589999906],
              [-71.7930549729999, -4.48463470399993],
              [-71.79574214699991, -4.491145934999892],
              [-71.79698238199995, -4.49796722399995],
              [-71.80065140799985, -4.502411396999946],
              [-71.80762772699995, -4.504478454999912],
              [-71.89015498899997, -4.513676858999915],
              [-71.90720821199992, -4.518431090999911],
              [-71.93314978099994, -4.536724548999885],
              [-71.98027868699995, -4.582303160999871],
              [-72.0098376059999, -4.591604918999892],
              [-72.02616735899991, -4.605660908999909],
              [-72.03552079299996, -4.611862080999899],
              [-72.04358231599986, -4.613825785999921],
              [-72.05355586799996, -4.610208434999947],
              [-72.06270259599995, -4.605660908999909],
              [-72.07112585499993, -4.605144143999965],
              [-72.07872228999992, -4.613412373999921],
              [-72.09660233599996, -4.649792581999904],
              [-72.10802282699987, -4.664261982999932],
              [-72.12709143199996, -4.680074970999925],
              [-72.18243688999988, -4.710667418999932],
              [-72.23313146999996, -4.748391214999899],
              [-72.25106319199992, -4.758829853999927],
              [-72.2693049719999, -4.764927672999889],
              [-72.28237910999994, -4.765444436999928],
              [-72.31979284699992, -4.760173441999896],
              [-72.33193680799991, -4.763274026999937],
              [-72.33684606999995, -4.769888610999928],
              [-72.33942989099995, -4.777330016999954],
              [-72.34470088699987, -4.782601012999891],
              [-72.38609370899991, -4.793969827999973],
              [-72.39684240699995, -4.805648701999942],
              [-72.40412878499993, -4.860219013999966],
              [-72.41467077699988, -4.876342060999946],
              [-72.43110388199995, -4.887814228999972],
              [-72.45260127799989, -4.899183043999955],
              [-72.45797562699994, -4.900423278999895],
              [-72.4717732339999, -4.900733336999892],
              [-72.47647578999988, -4.902490335999872],
              [-72.47947302299988, -4.908071390999879],
              [-72.47993811099991, -4.914169209999926],
              [-72.47967972799995, -4.919646910999916],
              [-72.48066158099991, -4.923367613999929],
              [-72.48588090099994, -4.932566019999925],
              [-72.48892980999995, -4.941195983999876],
              [-72.49513098199995, -4.946983743999851],
              [-72.50975541199992, -4.94750050899998],
              [-72.52851395699992, -4.950187682999925],
              [-72.5464456789999, -4.958249206999909],
              [-72.56220699099987, -4.97023813899996],
              [-72.58659826699991, -4.996696471999954],
              [-72.61434851099995, -5.009718932999903],
              [-72.62726761899995, -5.022431334999851],
              [-72.63160843899993, -5.033180032999965],
              [-72.63243526199994, -5.042791849999972],
              [-72.63507076099995, -5.051783548999921],
              [-72.6447859299999, -5.060568541999913],
              [-72.65419104099996, -5.063152363999919],
              [-72.70798620699989, -5.063152363999919],
              [-72.72881180899995, -5.057261250999915],
              [-72.74757035399995, -5.055090840999924],
              [-72.76017940299997, -5.064702656999927],
              [-72.77294348199993, -5.081135762999907],
              [-72.79030676399995, -5.088783873999972],
              [-72.83113114399993, -5.096638691999914],
              [-72.83635046399988, -5.096225280999903],
              [-72.84901118999991, -5.092091165999875],
              [-72.85397212699985, -5.09250457799989],
              [-72.85702103699987, -5.097568867999954],
              [-72.85769282999988, -5.112141621999925],
              [-72.85893306499989, -5.116069030999896],
              [-72.87283402499989, -5.123613789999936],
              [-72.88068884299992, -5.125267434999984],
              [-72.89381465699998, -5.125887552999956],
              [-72.91794755099994, -5.132088724999946],
              [-72.92197831299993, -5.146868183999871],
              [-72.91495031799991, -5.164438171999933],
              [-72.90559688399989, -5.179114277999915],
              [-72.90032588699995, -5.194617207999926],
              [-72.89489986199996, -5.255698749999922],
              [-72.89665686099994, -5.271615091999948],
              [-72.90539017699993, -5.285671080999876],
              [-72.91624222799996, -5.299106953999924],
              [-72.92399369399988, -5.313576354999952],
              [-72.93050492399993, -5.356467793999911],
              [-72.9347940669999, -5.372177428999876],
              [-72.96419795799989, -5.433775735999916],
              [-72.97349971599994, -5.466125182999903],
              [-72.96910721899994, -5.499198098999983],
              [-72.96032222599985, -5.531237487999903],
              [-72.96047725499989, -5.559246113999905],
              [-72.97691035999995, -5.651746927999937],
              [-72.98719396999985, -5.681099140999919],
              [-73.0013533129999, -5.708797708999938],
              [-73.10563635299994, -5.84698048899989],
              [-73.14000117999987, -5.878503112999852],
              [-73.19710363799987, -6.005007018999919],
              [-73.2188594159999, -6.040250345999894],
              [-73.23477575799993, -6.077560729999931],
              [-73.23529252199995, -6.12365610699996],
              [-73.22599076299991, -6.147944029999863],
              [-73.1776732999999, -6.202410989999862],
              [-73.17204056899996, -6.219670918999938],
              [-73.16155025199993, -6.299769388999906],
              [-73.15571081599992, -6.322713723999939],
              [-73.13380000899988, -6.368085631999875],
              [-73.12697871899994, -6.391340026999984],
              [-73.12703039599992, -6.413044127999896],
              [-73.13178462799993, -6.435264994999926],
              [-73.1478043219999, -6.476192727999944],
              [-73.17147212799992, -6.517430521999941],
              [-73.19896398899988, -6.545645852999911],
              [-73.23358719899989, -6.56404266299991],
              [-73.27849401899991, -6.575721536999893],
              [-73.34918737899991, -6.576445007999979],
              [-73.37068477399993, -6.583886413999906],
              [-73.40628983599993, -6.615615742999921],
              [-73.44540889499984, -6.639593606999938],
              [-73.51320837499986, -6.69778126999995],
              [-73.59387528499988, -6.743980000999912],
              [-73.64405310099991, -6.783977559999883],
              [-73.6719583739999, -6.800720723999916],
              [-73.68508418799988, -6.811882832999856],
              [-73.69696976799989, -6.837204284999927],
              [-73.70678828999988, -6.849606627999904],
              [-73.74859452299992, -6.875548197999947],
              [-73.75942073599987, -6.88743377699997],
              [-73.76549271699992, -6.904176939999928],
              [-73.7677148029999, -6.959264017999899],
              [-73.7922611089999, -7.050007831999949],
              [-73.80657547999988, -7.078223164999926],
              [-73.81233740199994, -7.102924498999926],
              [-73.80676214999997, -7.117879292999888],
              [-73.80355240899985, -7.126488952999935],
              [-73.73453853399991, -7.22508758599993],
              [-73.72453914399998, -7.26756561299996],
              [-73.7160900479999, -7.286375833999969],
              [-73.71309281399988, -7.304669290999939],
              [-73.72474584999995, -7.324823098999929],
              [-73.74125646999994, -7.334434915999935],
              [-73.76076432399992, -7.337432148999952],
              [-73.80027095599988, -7.335675149999872],
              [-73.82585078999992, -7.337432148999952],
              [-73.8434207759999, -7.343116555999899],
              [-73.87974930899986, -7.365027363999943],
              [-73.90202185099992, -7.373398945999924],
              [-73.92047033799992, -7.372158711999887],
              [-73.96106217499994, -7.356449076999922],
              [-73.9828954679999, -7.356449076999922],
              [-73.97943314599985, -7.374535827999935],
              [-73.9505460209999, -7.42321502699987],
              [-73.94431901099989, -7.448743183999895],
              [-73.94987422799991, -7.46517628999996],
              [-73.95778072199997, -7.480369160999885],
              [-73.95871089799991, -7.501969908999868],
              [-73.97142329999988, -7.523984068999937],
              [-73.9844863999999, -7.529407299999946],
              [-74.01847469099994, -7.543517760999947],
              [-74.00966385999996, -7.56108774799992],
              [-73.96938207999992, -7.584652200999926],
              [-73.83879573599992, -7.720561217999943],
              [-73.8111488449999, -7.739268086999928],
              [-73.77960038299994, -7.752910663999941],
              [-73.7422383219999, -7.764072774999875],
              [-73.71216263899993, -7.78815399199992],
              [-73.70255082299991, -7.827841490999987],
              [-73.71371293199985, -7.866288756999936],
              [-73.74611405499985, -7.886442565999914],
              [-73.77960038299994, -7.874453632999874],
              [-73.79463822499994, -7.874143574999977],
              [-73.79577510599995, -7.89223032599989],
              [-73.78494889399991, -7.94039276099997],
              [-73.77879939799993, -7.954138691999916],
              [-73.7484911709999, -7.976979674999924],
              [-73.70590979099993, -7.993826191999901],
              [-73.66803096599992, -8.013773294999922],
              [-73.65164953699988, -8.046019387999877],
              [-73.64472489499991, -8.06834360799985],
              [-73.61185868399988, -8.11257863399996],
              [-73.60110998599995, -8.136143086999965],
              [-73.60054154499988, -8.155470071999915],
              [-73.60617427599993, -8.192780455999952],
              [-73.60328039599995, -8.211590677999965],
              [-73.59061966999991, -8.234741719999946],
              [-73.56173254399994, -8.272672219999961],
              [-73.5527150069999, -8.299130553999944],
              [-73.54767655499992, -8.340161640999895],
              [-73.54082942699998, -8.359075215999937],
              [-73.52654089399988, -8.372407734999868],
              [-73.44726924699995, -8.416125996999938],
              [-73.43652054899994, -8.425221048999916],
              [-73.42024247299992, -8.446201679999916],
              [-73.4102172449999, -8.455503437999937],
              [-73.40050207599995, -8.459430846999908],
              [-73.3794180909999, -8.46191131599997],
              [-73.37052974499991, -8.465218606999969],
              [-73.35642207899988, -8.47979136099994],
              [-73.34929073199993, -8.49808481799991],
              [-73.34825720299995, -8.518341979999917],
              [-73.3576623139999, -8.562990416999938],
              [-73.35699051899991, -8.581800638999951],
              [-73.35058264199998, -8.598337096999941],
              [-73.30810461499993, -8.653217467999951],
              [-73.28986283399988, -8.670477395999853],
              [-73.26914058499995, -8.681639504999879],
              [-73.21100459799996, -8.69393849699992],
              [-73.19198767099988, -8.703860371999923],
              [-73.17457271299986, -8.7207068889999],
              [-73.16346227999995, -8.739620462999937],
              [-73.14584061699995, -8.78220184299991],
              [-73.06863602699988, -8.89371958399991],
              [-73.05380489199985, -8.906018574999848],
              [-73.01670121299986, -8.93040985099988],
              [-73.00367875199993, -8.94415578199991],
              [-72.97608353699994, -8.985393574999918],
              [-72.97003739499988, -9.001930032999908],
              [-72.9593920499999, -9.08564585399995],
              [-72.96368119399995, -9.11551483099987],
              [-72.97200109899993, -9.134428405999913],
              [-72.98238806199993, -9.14714080799996],
              [-73.02786332199989, -9.183107604999933],
              [-73.02853511599997, -9.21059946699991],
              [-73.03437455199986, -9.22258839899996],
              [-73.04791377799995, -9.230339863999873],
              [-73.06419185499996, -9.234784036999969],
              [-73.07840287299993, -9.236851094999935],
              [-73.09023677599993, -9.244189147999933],
              [-73.10119217899992, -9.260002135999926],
              [-73.11757360799987, -9.291938171999902],
              [-73.1408280039999, -9.322840677999906],
              [-73.19353796399992, -9.375653991999854],
              [-73.21498368399995, -9.40903696699992],
              [-72.8133027749999, -9.410897317999925],
              [-72.69170813099996, -9.435081887999985],
              [-72.68679886899992, -9.437459003999933],
              [-72.67801387599994, -9.445003763999892],
              [-72.67227779199987, -9.446657409999943],
              [-72.66778194199986, -9.445313821999974],
              [-72.6598237719999, -9.439836119999896],
              [-72.65594803899995, -9.439009297999874],
              [-72.63651770099995, -9.44293670699993],
              [-72.59605505399986, -9.45554575599995],
              [-72.55445552599988, -9.47600962299991],
              [-72.53564530399987, -9.481590677999932],
              [-72.49079016099995, -9.486448261999954],
              [-72.43022538299991, -9.4822107949999],
              [-72.40950313299987, -9.486344909999929],
              [-72.39022782499984, -9.496473489999886],
              [-72.3624775799999, -9.520658059999946],
              [-72.34454585799992, -9.532853697999954],
              [-72.33452063099992, -9.53399057999988],
              [-72.32294510999986, -9.53213022899996],
              [-72.31266149999996, -9.532543639999886],
              [-72.30677038599987, -9.540915221999853],
              [-72.30563350499995, -9.550630390999899],
              [-72.3069254159999, -9.579982604999955],
              [-72.30413488799985, -9.60085988399993],
              [-72.29488480699985, -9.61749969499995],
              [-72.26765132699992, -9.649539082999866],
              [-72.26165686099992, -9.66741912799992],
              [-72.26511918099996, -9.686539407999916],
              [-72.27700476099997, -9.724263203999968],
              [-72.26522253499988, -9.762193704999973],
              [-72.19473588099993, -9.805808613999929],
              [-72.17385860199994, -9.8458061729999],
              [-72.1711197509999, -9.856864928999897],
              [-72.16290319899989, -9.87722544299993],
              [-72.16042272999991, -9.887664082999962],
              [-72.16269649299991, -9.900066426999928],
              [-72.17835445199998, -9.91866994199998],
              [-72.18393550699989, -9.929005228999898],
              [-72.18553747599992, -9.949675800999913],
              [-72.18352209499997, -9.967039081999928],
              [-72.18460729999987, -9.984609069999905],
              [-72.1956660569999, -10.005589700999906],
              [-72.1419742439999, -10.005693053999934],
              [-71.96363887499984, -10.005899759999892],
              [-71.7853551849999, -10.006106465999949],
              [-71.60701981599993, -10.00651987699996],
              [-71.42868444899989, -10.006726581999914],
              [-71.39142574099986, -10.006829934999942],
              [-71.37339066599986, -10.002282409999907],
              [-71.3636238199999, -9.994530943999905],
              [-71.3595930589999, -9.986882832999925],
              [-71.35406367999991, -9.981301777999903],
              [-71.3396459549999, -9.97975148499998],
              [-71.3289489339999, -9.98336883499988],
              [-71.32171423399993, -9.989466653999926],
              [-71.31344600399987, -9.994220885999923],
              [-71.29970007399993, -9.993394062999897],
              [-71.28032141099987, -9.983472187999894],
              [-71.24512976199992, -9.956083678999946],
              [-71.1965022389999, -9.939857278999852],
              [-71.18311804199996, -9.920633646999917],
              [-71.17391963799986, -9.89727589899988],
              [-71.16105220499986, -9.875571797999967],
              [-71.1442573649999, -9.863066100999973],
              [-71.07746557699994, -9.83381723999993],
              [-71.01542801999992, -9.817487486999894],
              [-70.99721207699986, -9.80353485099991],
              [-70.98956396499997, -9.792062682999898],
              [-70.97760087099994, -9.766741230999912],
              [-70.9690484219999, -9.754855651999975],
              [-70.95747290099987, -9.7453471889999],
              [-70.9315571699999, -9.729740905999947],
              [-70.92026586899993, -9.72012908899994],
              [-70.89158544999995, -9.678581236999946],
              [-70.87548824099989, -9.660494485999934],
              [-70.82518123499992, -9.633622741999943],
              [-70.80538916099994, -9.618016458999904],
              [-70.76779455599993, -9.579879251999941],
              [-70.74727901299994, -9.564583027999973],
              [-70.6808489579999, -9.527686054999947],
              [-70.66209041399989, -9.509185892999923],
              [-70.62713130799989, -9.466604511999961],
              [-70.60638321999997, -9.448827819999934],
              [-70.58687536699995, -9.4395260619999],
              [-70.56697993999995, -9.435288594999946],
              [-70.52499283899994, -9.43094777399996],
              [-70.52375260399992, -9.44397023499991],
              [-70.52535457399995, -9.446760761999968],
              [-70.53566402199993, -9.464434102999874],
              [-70.53829951999995, -9.48097055999996],
              [-70.5432604579999, -9.493476256999955],
              [-70.56194148799989, -9.501744486999911],
              [-70.5597969159999, -9.504948424999967],
              [-70.5571872559999, -9.512596537999869],
              [-70.55512019899993, -9.516007180999893],
              [-70.5678584399999, -9.519211119999866],
              [-70.57615250699985, -9.52913299499994],
              [-70.57806453499995, -9.541845397999907],
              [-70.56452530899989, -9.565409850999913],
              [-70.57387874399993, -9.567786965999858],
              [-70.5874438079999, -9.565616556999956],
              [-70.59266312799994, -9.563756204999947],
              [-70.61922481399995, -9.564479674999859],
              [-70.62441829499997, -9.565823262999913],
              [-70.61467728699992, -9.584116719999898],
              [-70.60728755699992, -9.616776224999867],
              [-70.60080216599994, -9.635276386999891],
              [-70.5896142169999, -9.650262552999962],
              [-70.56021032799993, -9.673310241999928],
              [-70.54863480699987, -9.687676289999928],
              [-70.54186519399994, -9.708243509999917],
              [-70.54341548699995, -9.726950377999898],
              [-70.55124446699998, -9.74410695399996],
              [-70.56336258999997, -9.76074676499988],
              [-70.56666988099997, -9.767051289999898],
              [-70.56915035099985, -9.779143574999878],
              [-70.5741629639999, -9.784931334999953],
              [-70.57956315099997, -9.78565480499995],
              [-70.59007930499993, -9.77904022199995],
              [-70.59524694899994, -9.77904022199995],
              [-70.60545304399992, -9.785034688999886],
              [-70.61509069899992, -9.79226938899994],
              [-70.62322973699995, -9.801054381999933],
              [-70.62901749699992, -9.811596374999894],
              [-70.63844844599987, -9.851800638999919],
              [-70.63855179899991, -9.911641947999968],
              [-70.63865963799995, -9.95589164199987],
              [-70.6388618579999, -10.038869323999947],
              [-70.63917191599995, -10.16620005299994],
              [-70.63948197399995, -10.293530781999934],
              [-70.63984370999995, -10.420861510999941],
              [-70.64020544499994, -10.548088886999906],
              [-70.64051550299993, -10.675419616999903],
              [-70.64085139999992, -10.802646991999964],
              [-70.6411356209999, -10.929874368999933],
              [-70.64134232599986, -11.010799661999926],
              [-70.55555944899996, -10.942793477999942],
              [-70.53411372899993, -10.938142598999889],
              [-70.5071903079999, -10.961293639999965],
              [-70.46249019399997, -11.01390024799987],
              [-70.43727209499991, -11.036741231999969],
              [-70.39130590899993, -11.059065449999935],
              [-70.34102473999988, -11.067230325999958],
              [-70.28939998399994, -11.064749857999885],
              [-70.23948055099987, -11.055138040999879],
              [-70.19873368299992, -11.04118540399989],
              [-69.95611283399998, -10.919332376999876],
              [-69.9142032469999, -10.921399433999937],
              [-69.89513464399991, -10.92687713699992],
              [-69.87570430599993, -10.928014016999938],
              [-69.8350866289999, -10.925326842999908],
              [-69.80831823799991, -10.927187194999917],
              [-69.79105830999993, -10.934318542999947],
              [-69.75343786699992, -10.958296406999864],
              [-69.72020991999997, -10.964910989999865],
              [-69.59623815899991, -10.951991881999945],
              [-69.57763464399994, -10.95230194099993],
              [-69.57401729399996, -10.95850311299992],
              [-69.57050329599991, -10.964600931999968],
              [-69.56683426899991, -10.97069875099993],
              [-69.56326859599994, -10.97689992299992],
              [-69.55972875999987, -10.983101093999906],
              [-69.55611140999989, -10.98940561899991],
              [-69.5524940599999, -10.995606791999904],
              [-69.54895422399994, -11.001704609999948],
              [-69.44456783099989, -11.182675475999929],
              [-69.34033646699987, -11.363749694999925],
              [-69.23595007299991, -11.544927265999945],
              [-69.13158951899996, -11.726001484999955],
              [-69.0272806399999, -11.907075702999947],
              [-68.92286840899993, -12.088149922999946],
              [-68.8185595299999, -12.269224141999942],
              [-68.71422481399995, -12.450298359999948],
              [-68.68946323799992, -12.493417655999934],
              [-68.68425248299991, -12.502491556999928],
              [-68.69438106299995, -12.50683237699991],
              [-68.70022049999994, -12.516030781999916],
              [-68.70626664299988, -12.535977884999923],
              [-68.71453487199994, -12.551170755999863],
              [-68.72605871599987, -12.565950215999877],
              [-68.74026973499991, -12.578559264999896],
              [-68.77011287499994, -12.594372252999989],
              [-68.78388464399987, -12.60574106899989],
              [-68.79341894599986, -12.620210469999918],
              [-68.79460750399988, -12.636540221999951],
              [-68.78533158399998, -12.645945332999915],
              [-68.75298213799988, -12.654730325999893],
              [-68.74295690999986, -12.665789082999908],
              [-68.76613378899995, -12.710540872999957],
              [-68.77373022499992, -12.719429218999963],
              [-68.85620581099994, -12.741443378999946],
              [-68.87656632599996, -12.754982604999938],
              [-68.89199173999995, -12.77575653099997],
              [-68.90462662799987, -12.803971862999944],
              [-68.92661494999996, -12.800974629999928],
              [-68.93873307399986, -12.819681497999909],
              [-68.94943009499985, -12.843866067999983],
              [-68.98095271799991, -12.867947285999932],
              [-68.98658544899985, -12.89047820999994],
              [-68.98622371499994, -12.933369649999904],
              [-68.97393624599988, -13.031759582999953],
              [-68.97214188699994, -13.046127623999936],
              [-68.97966080799998, -13.164570006999924],
              [-68.97702530999996, -13.204929300999893],
              [-68.96278845299989, -13.283580829999948],
              [-68.97444148799985, -13.478814391999904],
              [-68.97074662299985, -13.501448668999956],
              [-68.9768186039999, -13.526253356999902],
              [-68.9856552739999, -13.550231221999908],
              [-68.99425939899993, -13.563046975999981],
              [-69.01539505999997, -13.585474547999894],
              [-69.02319820199989, -13.596946715999906],
              [-69.02552364199994, -13.610692646999937],
              [-69.02361161399992, -13.62330169699996],
              [-69.02384415799989, -13.63498056999994],
              [-69.03262915099987, -13.645935973999912],
              [-69.04402380399995, -13.648003031999878],
              [-69.07453873699987, -13.64262868199991],
              [-69.0875870369999, -13.643868916999864],
              [-69.1015913499999, -13.66660654699993],
              [-69.08104996799992, -13.695441995999957],
              [-69.02704809599993, -13.738230081999887],
              [-69.01596350099993, -13.75311289499993],
              [-69.01596350099993, -13.764585061999952],
              [-69.02082108599987, -13.77636728899995],
              [-69.0242834069999, -13.79249033599993],
              [-69.02309484899988, -13.806029561999907],
              [-69.01014990299987, -13.844373473999923],
              [-68.9929933279999, -13.869798278999937],
              [-68.98919510899987, -13.903698018999947],
              [-68.98904008099993, -13.94007822699993],
              [-68.98296809899998, -13.97222096799996],
              [-68.96971309499986, -13.99051442499993],
              [-68.91617630999991, -14.024930927999975],
              [-68.90576350899988, -14.039296975999989],
              [-68.8999757489999, -14.0547999059999],
              [-68.89372290099993, -14.089216410999953],
              [-68.86889237499989, -14.156189065999953],
              [-68.86444820199995, -14.191225686999971],
              [-68.88372351099991, -14.211482848999964],
              [-68.95131628399989, -14.219957783999888],
              [-68.98490596499991, -14.228329365999954],
              [-69.01014990299987, -14.245899352999928],
              [-69.01570511899988, -14.263159280999915],
              [-69.01722957399997, -14.282486266999868],
              [-69.0161702069999, -14.32114023799997],
              [-69.00831538899988, -14.339020283999929],
              [-68.99462113499993, -14.35896738699995],
              [-68.99025447599985, -14.3790178429999],
              [-69.01014990299987, -14.397104593999913],
              [-69.07513301599991, -14.432451272999913],
              [-69.0945633549999, -14.44640391],
              [-69.13401831099992, -14.490742289999943],
              [-69.14114965899995, -14.494152932999967],
              [-69.15820288099988, -14.498493753999952],
              [-69.16427486199993, -14.503041279999891],
              [-69.1674271249999, -14.520301207999893],
              [-69.1645074059999, -14.566396585999911],
              [-69.17039851899989, -14.57755869599994],
              [-69.19223181199993, -14.576938577999968],
              [-69.2149436039999, -14.572287698999915],
              [-69.23465816299995, -14.574251403999938],
              [-69.24749975599994, -14.593681741999916],
              [-69.25383011899996, -14.721839293999935],
              [-69.2676277269999, -14.750674742999976],
              [-69.28351822999994, -14.759666442999915],
              [-69.33904455599992, -14.774755960999926],
              [-69.3614204509999, -14.787985127999917],
              [-69.37054134199988, -14.801524352999891],
              [-69.37198828199988, -14.818680928999953],
              [-69.36775081399992, -14.900536396999897],
              [-69.36984370999988, -14.90828786199991],
              [-69.38622513899995, -14.945804951999904],
              [-69.39066931199994, -14.964408466999942],
              [-69.38431311099993, -14.981771748999876],
              [-69.36281571499998, -15.001305439999967],
              [-69.34609838899993, -15.01649831199991],
              [-69.28858251999992, -15.101971129999924],
              [-69.27220109099994, -15.118197529999932],
              [-69.2126698409999, -15.161295674999948],
              [-69.1964951169999, -15.176591897999899],
              [-69.17176794499997, -15.210801696999894],
              [-69.14810013899992, -15.233332620999917],
              [-69.15042557799995, -15.251626078999976],
              [-69.16613521399992, -15.263925068999924],
              [-69.18972550499984, -15.262374775999916],
              [-69.20913000599992, -15.263615010999942],
              [-69.22259171599998, -15.302165628999916],
              [-69.25589717699992, -15.313327738999945],
              [-69.27519832399989, -15.33027760799996],
              [-69.29116634199991, -15.35084482799995],
              [-69.29695410199989, -15.36696787499993],
              [-69.28540441899995, -15.396733499999911],
              [-69.28592118299989, -15.405415140999963],
              [-69.2929233399999, -15.409859313999974],
              [-69.32026017299992, -15.418851012999923],
              [-69.33036291499985, -15.424225361999973],
              [-69.34341121499992, -15.442208760999875],
              [-69.3485271809999, -15.46184580499991],
              [-69.35111100299989, -15.481896260999946],
              [-69.35640783799994, -15.501429951999867],
              [-69.42118424499992, -15.596411234999962],
              [-69.43002091599993, -15.626280211999884],
              [-69.42433650799998, -15.656252542999923],
              [-69.41221838399991, -15.68581146299995],
              [-69.36961116599991, -15.78895762099998],
              [-69.3271331389999, -15.892000426999886],
              [-69.2845775959999, -15.99504323299989],
              [-69.24212540799988, -16.09818939199991],
              [-69.21964615999988, -16.152759704999937],
              [-69.18486791999993, -16.195031025999924],
              [-69.16626440499996, -16.210430602999907],
              [-69.14468949499991, -16.22345306399994],
              [-69.12081498299992, -16.23120452899994],
              [-69.09518347199986, -16.23120452899994],
              [-69.0838921719999, -16.226553649999886],
              [-69.06451350999993, -16.212084248999943],
              [-69.05355810599985, -16.208363545999944],
              [-69.0427318939999, -16.2092937219999],
              [-69.01014990299987, -16.219112243999874],
              [-68.98203792399991, -16.210017190999892],
              [-68.9595069989999, -16.223349710999912],
              [-68.91876013199993, -16.266654560999967],
              [-68.86667028799988, -16.286911722999974],
              [-68.84364843799992, -16.302001240999886],
              [-68.83349401899994, -16.328976338999908],
              [-68.85584407599993, -16.36318613599991],
              [-68.96836950699989, -16.40638763399994],
              [-69.00172664399986, -16.422820739999906],
              [-69.02787491899997, -16.454136657999925],
              [-69.03681494199989, -16.47149993899994],
              [-69.03888199899987, -16.49186045299996],
              [-69.03764176499993, -16.55025482199993],
              [-69.04012223399991, -16.58136403399989],
              [-69.03513545799984, -16.59800384499991],
              [-69.00834122799995, -16.634177347999938],
              [-69.02051102699997, -16.64947357199989],
              [-69.03707332399998, -16.670247496999934],
              [-69.05381648799991, -16.682339782999918],
              [-69.11205582699995, -16.711485289999942],
              [-69.13058182799998, -16.715826110999927],
              [-69.1663677579999, -16.719133402999915],
              [-69.18236161299984, -16.728745218999933],
              [-69.19166337099998, -16.743007913999904],
              [-69.21065445999994, -16.797061461999903],
              [-69.22445206699987, -16.81824879999995],
              [-69.32594457999994, -16.922221780999905],
              [-69.35245459099986, -16.977722269999973],
              [-69.36431433199988, -16.991158141999932],
              [-69.40715409399994, -17.015652770999893],
              [-69.41358780999988, -17.02226735399998],
              [-69.41655920499997, -17.031982522999925],
              [-69.4133035889999, -17.037770283999905],
              [-69.40601721199991, -17.04087086899993],
              [-69.40126298099992, -17.047175394999954],
              [-69.40601721199991, -17.062988382999947],
              [-69.42743709299992, -17.08686289499994],
              [-69.4541538089999, -17.096578063999885],
              [-69.48280839099988, -17.10174570699988],
              [-69.51009354699988, -17.112080992999978],
              [-69.54099605399989, -17.13223480199987],
              [-69.59504960199988, -17.179673766999954],
              [-69.60114742099992, -17.18153411899995],
              [-69.61835567199992, -17.18422129299998],
              [-69.62279984599991, -17.185564879999944],
              [-69.63383276399992, -17.20726898099994],
              [-69.64941320899993, -17.262769469999924],
              [-69.66649226999988, -17.288297627999967],
              [-69.66441572199994, -17.288562462999934],
              [-69.61300716199986, -17.295118916999925],
              [-69.59727168799989, -17.30049326599989],
              [-69.55693823299993, -17.331499124999908],
              [-69.53709448299992, -17.351136169999933],
              [-69.5225992439999, -17.36911956799993],
              [-69.51138545799995, -17.398678486999955],
              [-69.5083365479999, -17.43402516599987],
              [-69.51009354699988, -17.50544199599996],
              [-69.51008875199994, -17.506588197999946],
            ],
          ],
          [
            [
              [-76.1952315389999, -14.263294351999946],
              [-76.18897196499995, -14.274692691999917],
              [-76.18584462799993, -14.28305027999994],
              [-76.17565995399991, -14.288374846999943],
              [-76.17958508399994, -14.29520815199993],
              [-76.19134066999993, -14.292920521999918],
              [-76.20700649299994, -14.28151423199995],
              [-76.22032433499993, -14.274666426999943],
              [-76.22031113699995, -14.263275687999908],
              [-76.21247039799994, -14.259481970999957],
              [-76.1952315389999, -14.263294351999946],
            ],
          ],
          [
            [
              [-76.4436686599999, -13.830487871999935],
              [-76.4366890039999, -13.833521613999949],
              [-76.43673975599995, -13.84409564099991],
              [-76.44144082499992, -13.853906215999928],
              [-76.45073123199995, -13.856144834999952],
              [-76.46162872499991, -13.856126434999908],
              [-76.4702495539999, -13.853855728999918],
              [-76.46769938699993, -13.841755636999949],
              [-76.4591283339999, -13.83346985199995],
              [-76.4568313879999, -13.822912215999906],
              [-76.4459799629999, -13.823689177999938],
              [-76.4436686599999, -13.830487871999935],
            ],
          ],
          [
            [
              [-77.2327136049999, -12.065443234999918],
              [-77.19383939799991, -12.100041125999951],
              [-77.1853164819999, -12.109382420999907],
              [-77.18154080399995, -12.115912219999927],
              [-77.19200141599993, -12.113077161999911],
              [-77.20439315899995, -12.114887611999904],
              [-77.21768023999994, -12.105525421999914],
              [-77.23666794899992, -12.093344583999908],
              [-77.24801708099994, -12.077473468999926],
              [-77.25365964899993, -12.063488095999958],
              [-77.24410791399993, -12.058877654999947],
              [-77.2327136049999, -12.065443234999918],
            ],
          ],
          [
            [
              [-80.84297014399993, -6.381611945999907],
              [-80.84866830399994, -6.388945959999944],
              [-80.85542783599993, -6.405527953999922],
              [-80.85002226499995, -6.419499688999906],
              [-80.84175087099993, -6.42888232599995],
              [-80.84098241299995, -6.440938901999914],
              [-80.8421417909999, -6.457603004999953],
              [-80.83958388299993, -6.475245538999957],
              [-80.85079905599991, -6.476945109999917],
              [-80.86384079399994, -6.475839133999955],
              [-80.86744375599994, -6.46652245599995],
              [-80.86357713199993, -6.456379224999921],
              [-80.86709169199992, -6.440577799999915],
              [-80.87537971899991, -6.433052594999936],
              [-80.86781141699993, -6.424814657999946],
              [-80.86481161599994, -6.410032490999924],
              [-80.85313507899991, -6.374988469999948],
              [-80.84297014399993, -6.381611945999907],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Argentina',
        iso3: 'ARG',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-67.19390417499997, -22.82222340899996],
              [-67.14269283099995, -22.742745055999976],
              [-67.11323726399985, -22.710085550999906],
              [-67.03768632099991, -22.654585062999928],
              [-67.02662756399991, -22.639392190999985],
              [-67.0243538009999, -22.61758473699996],
              [-67.03272538299987, -22.524567158999986],
              [-67.01567216099994, -22.523843688999904],
              [-66.99355464699994, -22.525807392999937],
              [-66.97815506999984, -22.522500100999935],
              [-66.96523596299994, -22.514335225999915],
              [-66.95557246899992, -22.50069264699991],
              [-66.9353153079999, -22.480538838999934],
              [-66.90865026899988, -22.4675163779999],
              [-66.7964607349999, -22.434856872999916],
              [-66.78509191899988, -22.427622171999957],
              [-66.78447180199993, -22.41728688499994],
              [-66.79051794399996, -22.388348082999883],
              [-66.78803747599989, -22.38007985399993],
              [-66.7751700439999, -22.365197041999892],
              [-66.76793534399994, -22.342562763999936],
              [-66.75610144099991, -22.268252054999948],
              [-66.74886674099994, -22.24489430699991],
              [-66.73589595599992, -22.22505055799992],
              [-66.71284826699986, -22.20644704099996],
              [-66.6993090419999, -22.20076263499992],
              [-66.68845699099992, -22.20169280999997],
              [-66.67739823399992, -22.205103453999897],
              [-66.65781286599992, -22.207377216999916],
              [-66.64137976099994, -22.212544859999923],
              [-66.63631546999997, -22.211304625999972],
              [-66.63326656099994, -22.204896748999943],
              [-66.6305793869999, -22.197351989999987],
              [-66.62675533099988, -22.192597757999906],
              [-66.51032832899995, -22.162935485999938],
              [-66.37746822099984, -22.12707204099989],
              [-66.35323197499986, -22.10960540799995],
              [-66.34917537499985, -22.100200296999986],
              [-66.34300004099987, -22.090485127999955],
              [-66.33524857599988, -22.082320250999928],
              [-66.32667028899994, -22.077359313999892],
              [-66.3140612389999, -22.075809020999955],
              [-66.30982377199987, -22.078186136999918],
              [-66.30760168499995, -22.077049254999906],
              [-66.3015038659999, -22.064956969999912],
              [-66.29716304599992, -22.05028086399993],
              [-66.2875512299999, -21.956953225999968],
              [-66.2400089109999, -21.792415465999866],
              [-66.22246476199993, -21.786937763999973],
              [-66.13781876599992, -21.812465921999916],
              [-66.09448807899994, -21.83292978999988],
              [-66.06358557199985, -21.864039000999924],
              [-66.05175166899994, -21.91261484799992],
              [-66.04653234899993, -21.917989196999983],
              [-65.95449662299993, -21.933078714999894],
              [-65.9326891689999, -21.944550882999906],
              [-65.80455745399988, -22.085834248999987],
              [-65.77530859399994, -22.105057880999908],
              [-65.74461279399989, -22.11404958099986],
              [-65.60531896999993, -22.09906341499989],
              [-65.59787756399993, -22.095652770999948],
              [-65.5934333909999, -22.091105244999923],
              [-65.58852412999997, -22.087281187999892],
              [-65.57989416599992, -22.086454365999955],
              [-65.51046687899986, -22.09585947699992],
              [-65.45734350599994, -22.101440530999923],
              [-65.19047821899997, -22.09847395899996],
              [-65.0203675949999, -22.096582946999916],
              [-64.83247208699996, -22.137510680999924],
              [-64.7623213299999, -22.17440765399995],
              [-64.72289221199989, -22.183296],
              [-64.71369380699988, -22.181745706999948],
              [-64.69524532099987, -22.174200947999907],
              [-64.68744217999995, -22.172857359999938],
              [-64.67904475999995, -22.175441182999933],
              [-64.65777990799998, -22.178438414999945],
              [-64.63871130399991, -22.191667581999937],
              [-64.61628373199991, -22.202209574999912],
              [-64.59620743899995, -22.20655039399989],
              [-64.58687984199992, -22.21275156699997],
              [-64.56021480299998, -22.243137308999934],
              [-64.5518432209999, -22.255022887999957],
              [-64.54277400699993, -22.27548675599992],
              [-64.54225724299991, -22.291506448999968],
              [-64.54915604699997, -22.305355732999928],
              [-64.56207515499997, -22.319825133999956],
              [-64.57202286799989, -22.34318288199991],
              [-64.55887121599991, -22.360649515999867],
              [-64.5378905849999, -22.374292092999966],
              [-64.52455806599988, -22.38535085099997],
              [-64.52329199299993, -22.396202900999924],
              [-64.53106929599994, -22.415529886999963],
              [-64.53132767799994, -22.42565846699992],
              [-64.52574662299992, -22.43299652099992],
              [-64.50781490099985, -22.44395192399989],
              [-64.50404252099992, -22.449946390999926],
              [-64.4981255699999, -22.47278737399992],
              [-64.4837336839999, -22.49118418299993],
              [-64.42828487199992, -22.54234385199993],
              [-64.42983516499996, -22.55712331099994],
              [-64.43725073299987, -22.567355244999916],
              [-64.44554480099993, -22.576243590999937],
              [-64.44942053199989, -22.58709564199998],
              [-64.45045406099987, -22.597120869999912],
              [-64.45520829299994, -22.61665456099992],
              [-64.45624182199992, -22.628023375999902],
              [-64.45370967599985, -22.642906188999945],
              [-64.44722428399987, -22.64869394899992],
              [-64.43823258499992, -22.65189788799998],
              [-64.42828487199992, -22.659029235999924],
              [-64.40172318499992, -22.712359313999926],
              [-64.39076778199984, -22.72052419099994],
              [-64.36898616599993, -22.72972259499994],
              [-64.35573116099991, -22.751943460999968],
              [-64.3523205159999, -22.77912526399996],
              [-64.35999446599988, -22.80299977599995],
              [-64.34772131399984, -22.81695241299994],
              [-64.34389725799991, -22.863667906999936],
              [-64.32529374199996, -22.871936136999878],
              [-64.3269473879999, -22.85922373499993],
              [-64.30348628799993, -22.782329202999932],
              [-64.29459794199991, -22.762898864999954],
              [-64.29397782399994, -22.690861917999968],
              [-64.25082800299992, -22.540690204999876],
              [-64.23633276399997, -22.516712341999963],
              [-64.18470800799994, -22.471237080999913],
              [-64.1605492759999, -22.438474223],
              [-64.0862385659999, -22.257916767999944],
              [-64.0788746749999, -22.25057871499986],
              [-64.05879838099995, -22.24034678099987],
              [-64.05102107799993, -22.22918467199993],
              [-64.01978267499993, -22.155390726999897],
              [-64.00438309799995, -22.099270120999932],
              [-63.995649780999884, -22.0829403689999],
              [-63.990378783999944, -22.079323017999926],
              [-63.983454141999886, -22.077359313999892],
              [-63.975806030999905, -22.073845315999932],
              [-63.96810624199989, -22.066507262999934],
              [-63.96464392099995, -22.058549092999968],
              [-63.96102657099988, -22.039118753999986],
              [-63.951466430999886, -22.016691181999903],
              [-63.950949666999946, -22.0108000689999],
              [-63.94759069899993, -22.007596129999925],
              [-63.933172973999916, -22.00180836999995],
              [-63.90640458199994, -21.997157490999896],
              [-63.81312862199988, -22.003048604999904],
              [-63.79302648999993, -22.011523538999896],
              [-63.75178869699991, -22.045733336999902],
              [-63.74041988099992, -22.050590921999913],
              [-63.69391109299991, -22.012040302999935],
              [-63.67783972199993, -22.003668720999954],
              [-63.63939245599988, -21.997467549999968],
              [-63.32491552749988, -21.999121195499967],
              [-63.01043859899988, -22.000774840999966],
              [-63.00992183499994, -22.00067148899994],
              [-62.86202388599986, -21.993230081999926],
              [-62.81856400599986, -22.00087819399991],
              [-62.8043529869999, -22.004082131999965],
              [-62.8013557539999, -22.01348724299993],
              [-62.794999552999855, -22.05121103999997],
              [-62.79505122899988, -22.061132913999884],
              [-62.79779007999991, -22.069401143999926],
              [-62.791072143999884, -22.081596781999934],
              [-62.79091711499984, -22.113222757999935],
              [-62.78347570899993, -22.130896097999937],
              [-62.7693680429999, -22.144745381],
              [-62.72203242999993, -22.166242776999937],
              [-62.679296020999914, -22.194768167999896],
              [-62.66746211799992, -22.20655039399989],
              [-62.66322465099995, -22.21554209399993],
              [-62.661829386999955, -22.22453379299988],
              [-62.65898718299991, -22.231665140999908],
              [-62.65035721899994, -22.234455667999967],
              [-62.64038366799994, -22.23621266699986],
              [-62.63180537899993, -22.240760192999886],
              [-62.62482906099993, -22.247271422999944],
              [-62.61960974099989, -22.255022887999957],
              [-62.62643103099995, -22.255022887999957],
              [-62.620281534999975, -22.268458760999906],
              [-62.624208943999946, -22.278897398999945],
              [-62.63082352699985, -22.28768239399993],
              [-62.63268387899987, -22.295950622999968],
              [-62.62529414899984, -22.305045674999946],
              [-62.613150186999945, -22.31145355199989],
              [-62.59961096199987, -22.315174254999903],
              [-62.5882938229999, -22.31641448899994],
              [-62.56467769399998, -22.321995543999947],
              [-62.54762447099995, -22.335328063999967],
              [-62.52338822499988, -22.364886982999906],
              [-62.51072749899993, -22.37015797899994],
              [-62.470574910999915, -22.38183685299991],
              [-62.46194494699995, -22.388761493999894],
              [-62.454968627999875, -22.403851013],
              [-62.43807043499987, -22.4196640009999],
              [-62.36825557499992, -22.464415791999954],
              [-62.3487218839999, -22.471340433999927],
              [-62.34135696699991, -22.472261048],
              [-62.30572709199993, -22.476714781999902],
              [-62.29451330599997, -22.479815368999937],
              [-62.2872269289999, -22.48394948299996],
              [-62.284539753999866, -22.488703714999943],
              [-62.283609578999915, -22.493768005999925],
              [-62.28381628499997, -22.504826761999936],
              [-62.28138749199991, -22.512061463],
              [-62.27559973199993, -22.513508401999985],
              [-62.26883011899989, -22.51299163899995],
              [-62.26335241699991, -22.51443857799994],
              [-62.24118322799998, -22.53841644299986],
              [-62.23322505699991, -22.556296487999916],
              [-62.23885778899995, -22.573039651999878],
              [-62.252965454999895, -22.59112640299989],
              [-62.25281042499995, -22.603632100999974],
              [-62.239736287999904, -22.61376068099993],
              [-62.21493159999994, -22.624302672999903],
              [-62.202529256999895, -22.62719655299989],
              [-62.19658646699986, -22.626473083999983],
              [-62.192969116999876, -22.62823008199996],
              [-62.18764644399994, -22.638565368999963],
              [-62.19462276299993, -22.66057952899986],
              [-62.19503617399994, -22.67360198999998],
              [-62.17591589399984, -22.68486745199995],
              [-62.18826656099989, -22.70832855299993],
              [-62.18418412299991, -22.71370290099989],
              [-62.17079992699988, -22.71732025099996],
              [-62.16408199099993, -22.725898538999985],
              [-62.15974116999985, -22.737164000999954],
              [-62.15348832299995, -22.747809345999954],
              [-62.12615148999993, -22.77571461999993],
              [-62.12253413999994, -22.783156026999862],
              [-62.119743611999894, -22.792147724999907],
              [-62.11586787999994, -22.799795836999877],
              [-62.10878820799991, -22.80299977599995],
              [-62.107858031999854, -22.80651377399991],
              [-62.099228068999906, -22.81374847399988],
              [-62.08935786999993, -22.819949645999955],
              [-62.08460363799995, -22.82015635099991],
              [-62.08083125899992, -22.832351988999918],
              [-62.071632853999915, -22.84392751099996],
              [-62.050445515999854, -22.86449473099995],
              [-62.035821085999885, -22.884855244999898],
              [-62.0171658939999, -22.92175221799991],
              [-62.0060554609999, -22.93684173599992],
              [-62.00378169799998, -22.946350198999895],
              [-62.008949340999976, -22.969707945999943],
              [-62.0060554609999, -22.97435882499991],
              [-62.00590043099996, -22.97890635199994],
              [-61.99205114799989, -22.998129984999963],
              [-61.956446085999914, -23.034406839999917],
              [-61.84498002199993, -23.097245381999898],
              [-61.83697017499995, -23.104686787999924],
              [-61.814284219999905, -23.135175882999903],
              [-61.80265702299994, -23.144994404999878],
              [-61.78002274699989, -23.156879984999904],
              [-61.76927404899996, -23.165561624999953],
              [-61.75847367399993, -23.177447204999893],
              [-61.752272501999926, -23.187059020999897],
              [-61.749481974999895, -23.198841246999905],
              [-61.7488101809999, -23.21734141099992],
              [-61.74426265499997, -23.234808043999877],
              [-61.7329971929999, -23.2433863319999],
              [-61.71852779199989, -23.249277444999905],
              [-61.70442012499984, -23.258372497999886],
              [-61.68876216699988, -23.274495543999947],
              [-61.68031306999998, -23.279249775999943],
              [-61.666851359999924, -23.28286712599993],
              [-61.6196191009999, -23.28286712599993],
              [-61.605149699999885, -23.28927500399996],
              [-61.55463598599994, -23.33836761499991],
              [-61.545773478999934, -23.342605082999867],
              [-61.53396541399994, -23.344568785999897],
              [-61.51605952999995, -23.34498219799991],
              [-61.52078792399993, -23.35325042699995],
              [-61.52546463999991, -23.36472259499996],
              [-61.52634313999994, -23.374747823],
              [-61.5103751229999, -23.38435963899991],
              [-61.50107336399989, -23.40782073999989],
              [-61.49184912199988, -23.41319508899994],
              [-61.47030004899992, -23.414125264999896],
              [-61.45192907799992, -23.417432555999895],
              [-61.43570267799993, -23.423737080999913],
              [-61.42050980699989, -23.433658955999903],
              [-61.40872757999989, -23.443580830999906],
              [-61.39867651399996, -23.450092061999968],
              [-61.3848530679999, -23.453709411999952],
              [-61.36177954099995, -23.454742940999935],
              [-61.29695145699992, -23.481407979999886],
              [-61.288967448999955, -23.49412038099993],
              [-61.282947143999934, -23.509933369999928],
              [-61.2726118569999, -23.52357594799993],
              [-61.25194128399991, -23.529260354999877],
              [-61.24292374699985, -23.533084411999923],
              [-61.22357092299998, -23.55127451599995],
              [-61.21439835599989, -23.557165628999954],
              [-61.20768042099988, -23.55757904099997],
              [-61.18773331699995, -23.556235453999903],
              [-61.18024023399991, -23.557165628999954],
              [-61.16781205199993, -23.566570738999914],
              [-61.154453694999916, -23.58031667099995],
              [-61.13949336799993, -23.592719013999925],
              [-61.122233439999945, -23.598196715999904],
              [-61.10985693399991, -23.606981709999985],
              [-61.10623958399992, -23.627238871999907],
              [-61.10975358099995, -23.649976500999884],
              [-61.11884863299994, -23.666409606999935],
              [-61.109650227999936, -23.67560801199994],
              [-61.09251949099988, -23.701859638999878],
              [-61.066216186999924, -23.715708922999937],
              [-61.04998978699993, -23.734725850999908],
              [-61.03805253099998, -23.755396422999922],
              [-61.036243855999885, -23.76883229599987],
              [-61.03022355099995, -23.774620055999947],
              [-61.01580582699992, -23.796685892999932],
              [-61.00634903999986, -23.805470885999924],
              [-60.97482641699992, -23.82407440199998],
              [-60.93666337099992, -23.813842467999905],
              [-60.899947265999856, -23.830482279999927],
              [-60.86635758499992, -23.855907083999924],
              [-60.83762548799993, -23.871823424999945],
              [-60.81685156299997, -23.874097187999965],
              [-60.787776137999884, -23.873445156999935],
              [-60.72928584899998, -23.87213348399993],
              [-60.71985489899993, -23.87502736399992],
              [-60.69941687099987, -23.891253763999927],
              [-60.689675862999934, -23.89363087999989],
              [-60.64370967699995, -23.891357116999956],
              [-60.63215999399989, -23.89228729299991],
              [-60.62115291399991, -23.895801289999966],
              [-60.603841308999904, -23.904689635999972],
              [-60.5946170659999, -23.906549987999895],
              [-60.593583536999915, -23.912234394999928],
              [-60.57753800499995, -23.944170430999918],
              [-60.5717502439999, -23.946030781999923],
              [-60.535964314999944, -23.94758107499993],
              [-60.517722533999915, -23.95574595199996],
              [-60.48488216199988, -23.977346699999927],
              [-60.42305131099988, -23.988508809999956],
              [-60.38742041099991, -23.987165221999902],
              [-60.378351196999944, -23.988508809999956],
              [-60.36757665999991, -23.994709980999943],
              [-60.34804296899989, -24.010833027999922],
              [-60.33737178599989, -24.016414082999944],
              [-60.328018350999855, -24.017964375999952],
              [-60.29641821299987, -24.016414082999944],
              [-60.218128418999896, -24.027369486999916],
              [-60.14324926799986, -24.02519907599992],
              [-60.119297241999845, -24.02023813899997],
              [-60.0723750409999, -24.004838561999904],
              [-60.0517303069999, -24.002874857999956],
              [-60.03366939299988, -24.007008971999895],
              [-59.673639688999856, -24.225393574999927],
              [-59.63532161499995, -24.261463724999928],
              [-59.61772578999995, -24.28347788499991],
              [-59.610516927999925, -24.289575703999958],
              [-59.600517537999906, -24.292882994999957],
              [-59.57540279199986, -24.295880228999877],
              [-59.558427082999856, -24.30538869199995],
              [-59.53997859799995, -24.308799335999893],
              [-59.53202042699988, -24.31407033299992],
              [-59.521142537999935, -24.32502573699989],
              [-59.51041967799992, -24.33267384799997],
              [-59.48765620899994, -24.34476613299995],
              [-59.46590043199993, -24.353551126999946],
              [-59.45972509799995, -24.358512064999985],
              [-59.45628861499992, -24.365436705999883],
              [-59.45380814699993, -24.374531758999936],
              [-59.450268310999974, -24.382386575999888],
              [-59.4260320649999, -24.392515156999934],
              [-59.387093871999895, -24.42383107499994],
              [-59.377766276999864, -24.43354624399997],
              [-59.35740576199993, -24.468996276999917],
              [-59.34097265699998, -24.48759979299996],
              [-59.30808060699994, -24.498761901999984],
              [-59.29505814599989, -24.512921244999944],
              [-59.28560135999993, -24.516125182999915],
              [-59.27046016499992, -24.518192239999877],
              [-59.263122111999934, -24.523463235999913],
              [-59.25764440899994, -24.53018117299993],
              [-59.248084269999936, -24.537209167999947],
              [-59.20648474199993, -24.55023162899998],
              [-59.17790767499989, -24.568731790999905],
              [-59.15439489799988, -24.57627654999996],
              [-59.11698116099993, -24.598807474999973],
              [-59.097189087999936, -24.60542205799989],
              [-59.078327189999925, -24.605628762999928],
              [-59.07217769399995, -24.60676564499994],
              [-59.062462524999916, -24.61234669999996],
              [-59.04241206899985, -24.630536803999902],
              [-59.032696899999905, -24.63704803499988],
              [-59.000915893999974, -24.644179381999905],
              [-58.80919632999988, -24.776781106999934],
              [-58.78847408099995, -24.78163869199996],
              [-58.737469441999906, -24.782775572999967],
              [-58.72325842399994, -24.786702982999927],
              [-58.71597204599996, -24.791870625999934],
              [-58.708117227999935, -24.795074564999908],
              [-58.701916055999845, -24.79931203199996],
              [-58.699383911999945, -24.807270202999916],
              [-58.694216267999934, -24.812024434999913],
              [-58.47340287299994, -24.851298522999883],
              [-58.450768595999904, -24.861737161999926],
              [-58.43852128099988, -24.872795918999927],
              [-58.41480179899992, -24.903078307999948],
              [-58.350567992999885, -24.96860402399996],
              [-58.34436682099988, -24.978319193999894],
              [-58.34131791199988, -24.98617401099993],
              [-58.335995238999914, -24.991858418999882],
              [-58.32328283699988, -24.995269064],
              [-58.3119656989999, -24.993615416999944],
              [-58.29930497299995, -24.987724303999954],
              [-58.28726436399998, -24.979766133999888],
              [-58.259152384999936, -24.952997741999923],
              [-58.242512572999914, -24.94173227899995],
              [-58.22406408799989, -24.94121551499991],
              [-58.13388871299989, -24.9978528849999],
              [-58.12401851499993, -25.01294240299991],
              [-58.11151281799991, -25.01232228599993],
              [-58.04205969299994, -25.044361673999944],
              [-58.03213781699995, -25.04508514399994],
              [-58.0098135989999, -25.04250132299994],
              [-58.000460164999936, -25.044361673999944],
              [-57.99363887599989, -25.05273325599991],
              [-57.98986649599996, -25.06410207099991],
              [-57.983768676999915, -25.074230651999954],
              [-57.9697643639999, -25.07846811999991],
              [-57.89049271599987, -25.078674824999965],
              [-57.87070064399998, -25.08528940799995],
              [-57.85648962399992, -25.096761575999977],
              [-57.812409627999955, -25.14368377699992],
              [-57.79732010999996, -25.153915709999907],
              [-57.76600419199994, -25.167868346999896],
              [-57.75406693499991, -25.18089080799993],
              [-57.72176916499993, -25.246106465999958],
              [-57.70233882699995, -25.2709111529999],
              [-57.671975553999886, -25.289830980999923],
              [-57.67148799699996, -25.290134785999925],
              [-57.64120560799992, -25.360518086999946],
              [-57.64079219599992, -25.372610371999926],
              [-57.57872879999988, -25.41674204499992],
              [-57.565292927999906, -25.430384622999924],
              [-57.55810990499995, -25.4435104369999],
              [-57.55692134599994, -25.459840189999923],
              [-57.570047159999916, -25.54665659599992],
              [-57.57531815699994, -25.56443328899995],
              [-57.58715205899995, -25.575698750999905],
              [-57.600691283999936, -25.578799336999865],
              [-57.611646687999894, -25.585930683999976],
              [-57.616297566999975, -25.609185078999914],
              [-57.62306717999991, -25.61538625099989],
              [-57.638776814999886, -25.6157996619999],
              [-57.668077351999926, -25.612285664999945],
              [-57.67004105699996, -25.616936543999913],
              [-57.6752603759999, -25.639260762999882],
              [-57.678981079999915, -25.647012226999976],
              [-57.68833451399985, -25.652696634999927],
              [-57.69820471199992, -25.65362681099988],
              [-57.70869502799988, -25.652903340999984],
              [-57.71990881299993, -25.65383351699994],
              [-57.74125118099991, -25.66189503899993],
              [-57.7537051999999, -25.672747089999888],
              [-57.774582478999974, -25.701685891999944],
              [-57.76848465999993, -25.709954121999985],
              [-57.760578165999874, -25.715638528999932],
              [-57.7511213789999, -25.719565937999903],
              [-57.74037268099988, -25.72214975999991],
              [-57.7510697029999, -25.734862161999956],
              [-57.767916219999876, -25.75067514999995],
              [-57.787243204999925, -25.7641110229999],
              [-57.80558833899991, -25.769898782999874],
              [-57.82062617999989, -25.77827036499994],
              [-57.81706050699992, -25.797493997999965],
              [-57.80186763499998, -25.83139373799989],
              [-57.812823039999955, -25.84524302199995],
              [-57.81966196599987, -25.84977922099992],
              [-57.8332352299999, -25.858782246999922],
              [-57.854215860999915, -25.86891082699988],
              [-57.875351521999875, -25.876145527999938],
              [-57.87819372599992, -25.883173522999954],
              [-57.875351521999875, -25.89020151799987],
              [-57.85240718599991, -25.897952981999964],
              [-57.851373656999925, -25.90839162199991],
              [-57.85710974199989, -25.91986378899992],
              [-57.86331091399998, -25.92761525499992],
              [-57.89824418199987, -25.953556822999886],
              [-57.90584061799984, -25.96864634199997],
              [-57.859590210999954, -25.980945332999923],
              [-57.859693562999894, -25.99427785199994],
              [-57.87271602399994, -26.010297546],
              [-57.98821284999991, -26.088535664999952],
              [-58.02159582599998, -26.10569223999991],
              [-58.08650142399992, -26.127189635999954],
              [-58.09668168099989, -26.136698099999933],
              [-58.1062934979999, -26.170287780999956],
              [-58.115233520999936, -26.190958352999886],
              [-58.12401851499993, -26.201913756999957],
              [-58.12763586499992, -26.1946790559999],
              [-58.13321691899992, -26.18899464999994],
              [-58.14117508999988, -26.1847571819999],
              [-58.15130366999992, -26.181449889999982],
              [-58.14892655499989, -26.199329935999955],
              [-58.13714432799989, -26.209458516999902],
              [-58.12122798699997, -26.21669321699997],
              [-58.106603556999886, -26.22609832699993],
              [-58.105983438999914, -26.23953419999988],
              [-58.12329504399992, -26.25152313199993],
              [-58.145980997999885, -26.260101419999955],
              [-58.161845662999895, -26.26330535899993],
              [-58.16995886299989, -26.270333353999945],
              [-58.17001053899992, -26.28655975299995],
              [-58.16494624899994, -26.31859914099995],
              [-58.16763342299987, -26.33503224699993],
              [-58.17269771399995, -26.349294942999904],
              [-58.20618404199985, -26.402728372999917],
              [-58.21305700699992, -26.41864471399994],
              [-58.209594686999964, -26.431253762999873],
              [-58.1854101159999, -26.451717630999923],
              [-58.1886657309999, -26.462052916999937],
              [-58.202721719999914, -26.471561380999916],
              [-58.20592565999988, -26.479416197999868],
              [-58.208716186999936, -26.4968828329999],
              [-58.214193888999915, -26.512385762999912],
              [-58.21734615099987, -26.527578632999933],
              [-58.213367065999904, -26.54452850299994],
              [-58.20799271699994, -26.55021291099989],
              [-58.1854101159999, -26.564992369999914],
              [-58.17931229699994, -26.572640482999887],
              [-58.17052730299986, -26.58679982499993],
              [-58.16494624899994, -26.592277526999922],
              [-58.17150915499991, -26.598582050999937],
              [-58.188510701999945, -26.609744160999966],
              [-58.192283081999875, -26.61284474699991],
              [-58.1920763759999, -26.62462697399991],
              [-58.18716711499988, -26.633618671999955],
              [-58.181379353999915, -26.64157684299991],
              [-58.17864050299997, -26.65067189499989],
              [-58.18385982299989, -26.65676971499994],
              [-58.19569372599989, -26.657493183999932],
              [-58.22716467299995, -26.652015482999943],
              [-58.23228063999994, -26.648604837999926],
              [-58.235536254999914, -26.649845072999952],
              [-58.24065222199991, -26.661213886999946],
              [-58.24519974799995, -26.680230814999916],
              [-58.24793859899998, -26.758158874999893],
              [-58.251762654999936, -26.763223164999957],
              [-58.25925573699996, -26.764463398999908],
              [-58.27139969899986, -26.76425669399994],
              [-58.28793615799995, -26.76859751399992],
              [-58.28654089399987, -26.778726094999882],
              [-58.2784793699999, -26.790198261999905],
              [-58.27481034399989, -26.798363138999918],
              [-58.288556274999934, -26.81148895299988],
              [-58.305506143999935, -26.809111836999932],
              [-58.32333451299988, -26.803840839999907],
              [-58.34002600199992, -26.808595071999903],
              [-58.35237666799986, -26.830505879999947],
              [-58.3403877369999, -26.844458515999932],
              [-58.32214595599996, -26.85675750699997],
              [-58.31578975399992, -26.874120788999903],
              [-58.3289155679999, -26.884146015999917],
              [-58.37470088699993, -26.887556660999863],
              [-58.38467443899995, -26.897065124999926],
              [-58.39387284299994, -26.90967417399996],
              [-58.415525268999914, -26.9175289919999],
              [-58.45981197099985, -26.928174336999888],
              [-58.47546993099991, -26.937992858999863],
              [-58.48368648299993, -26.950601907999967],
              [-58.48161942599998, -26.963831074999874],
              [-58.46663326099991, -26.975923359999868],
              [-58.47453975499985, -26.990082702999914],
              [-58.49236812399991, -27.009719746999934],
              [-58.501359822999945, -27.023672383999937],
              [-58.504873819999915, -27.031527200999875],
              [-58.50673417199991, -27.038451842999862],
              [-58.50756099499992, -27.05509165499997],
              [-58.51154007999992, -27.06015594499995],
              [-58.519808308999956, -27.058502298999898],
              [-58.5200320939999, -27.05836802799989],
              [-58.527043009999915, -27.054161478999916],
              [-58.52802486199988, -27.05168100999994],
              [-58.52802486199988, -27.047753600999968],
              [-58.53050533099986, -27.040518900999913],
              [-58.536034708999864, -27.036178079999928],
              [-58.536258596999915, -27.03629371399991],
              [-58.54543981999993, -27.041035664999953],
              [-58.55169266799993, -27.048167011999894],
              [-58.556395223999914, -27.05550506599988],
              [-58.55970251499991, -27.063359883999922],
              [-58.56218298299987, -27.0721448769999],
              [-58.56238968999992, -27.090128275999888],
              [-58.560529337999924, -27.10552785299997],
              [-58.56549027499997, -27.11596649099991],
              [-58.61613317899992, -27.12382130999994],
              [-58.638819132999885, -27.135913594999934],
              [-58.65328853399993, -27.156274108999952],
              [-58.658404499999904, -27.185109557999894],
              [-58.65235835799987, -27.198028665999914],
              [-58.63871577999987, -27.210120950999894],
              [-58.61401444499995, -27.226657409999888],
              [-58.601560424999974, -27.245674336999954],
              [-58.59990677999991, -27.266138203999915],
              [-58.60413463399988, -27.315548077999907],
              [-58.60419592299988, -27.31626434299993],
              [-58.60016516099989, -27.31295705199993],
              [-58.510764932999905, -27.278437194999952],
              [-58.238223428999845, -27.257043151999937],
              [-58.12882442299991, -27.269652200999957],
              [-58.113993285999896, -27.268928730999875],
              [-58.05353186099995, -27.259006855999885],
              [-58.02204621299995, -27.25983135699998],
              [-58.02195755999989, -27.259833678999897],
              [-58.00366413399993, -27.26330312199991],
              [-57.94435643399987, -27.274551133999935],
              [-57.9440295009999, -27.27461313899991],
              [-57.91338537599998, -27.286292012999894],
              [-57.89950352199989, -27.288960658999898],
              [-57.8550884709999, -27.29749900199991],
              [-57.85478430199987, -27.297557474999863],
              [-57.81191292999998, -27.31058298799988],
              [-57.811582803999926, -27.31068328899991],
              [-57.709366821999964, -27.329803568999907],
              [-57.69818345599995, -27.333398221999886],
              [-57.69779130099991, -27.33352427199992],
              [-57.535682332999954, -27.40721486399994],
              [-57.51993790499995, -27.412098551999904],
              [-57.513358113999914, -27.414139505999927],
              [-57.487674926999915, -27.416413268999946],
              [-57.3866991779999, -27.403494160999927],
              [-57.36039587499994, -27.403390807999912],
              [-57.35646609699995, -27.40434299199991],
              [-57.33522945099989, -27.409488626999874],
              [-57.32628942999989, -27.414862975999924],
              [-57.31011574999988, -27.429207701999943],
              [-57.30298335799995, -27.435533548999942],
              [-57.292493041999904, -27.44070119299994],
              [-57.283026316999894, -27.443014888999883],
              [-57.23758762399984, -27.454120240999927],
              [-57.23709590699994, -27.454240417999927],
              [-57.22707067899992, -27.458684590999923],
              [-57.20040563999987, -27.478941751999926],
              [-57.191207234999865, -27.484212747999962],
              [-57.1804525069999, -27.48721406699987],
              [-57.18009680199995, -27.487313333999907],
              [-57.1566873779999, -27.48772674599992],
              [-57.148160766999865, -27.488966979999958],
              [-57.108990030999934, -27.49062062599991],
              [-57.07622717399994, -27.48400604299991],
              [-56.97731848199996, -27.435326842999885],
              [-56.940989949999874, -27.422097675999893],
              [-56.90444715299995, -27.418695948999897],
              [-56.90435135899992, -27.41868703199995],
              [-56.8692630619999, -27.431502786999943],
              [-56.807458048999905, -27.486796569999868],
              [-56.771510649999925, -27.506548448999908],
              [-56.771155354999934, -27.506743671999885],
              [-56.734232543999894, -27.50043914799997],
              [-56.683124552999914, -27.464679056999955],
              [-56.63801587499992, -27.45291157499993],
              [-56.61299963399995, -27.446385598999896],
              [-56.5469333449999, -27.455002941999865],
              [-56.54644038899988, -27.455067240999938],
              [-56.50621028699996, -27.5001290889999],
              [-56.48732255099992, -27.52720753899986],
              [-56.46148433499991, -27.553872577999897],
              [-56.431356974999915, -27.575369976999937],
              [-56.400298629999895, -27.586636240999965],
              [-56.39973099799991, -27.58684214299994],
              [-56.36753658099988, -27.580640970999966],
              [-56.34965653499992, -27.556353047999963],
              [-56.33598811899989, -27.525657246999927],
              [-56.3164802659999, -27.50043914799997],
              [-56.296998250999906, -27.480905456999963],
              [-56.28531937699992, -27.46095835299994],
              [-56.28146948299988, -27.438634134999887],
              [-56.28531937699992, -27.41134897799988],
              [-56.27984167499994, -27.38964487699988],
              [-56.25676814799988, -27.37827606199997],
              [-56.22801021299995, -27.371248066999968],
              [-56.20542761299993, -27.362153014999905],
              [-56.1688923749999, -27.32473927799994],
              [-56.14997879999996, -27.31182016999992],
              [-56.124553995999946, -27.298901061999914],
              [-56.098948323999906, -27.30055470699996],
              [-56.07424597799991, -27.304811111999882],
              [-56.07375606299985, -27.304895527999946],
              [-56.00689354499991, -27.328250904999962],
              [-55.984846760999886, -27.332284036999894],
              [-55.96609441599989, -27.33172306899992],
              [-55.960662190999926, -27.331560566999897],
              [-55.93637426799992, -27.32825327499998],
              [-55.913094034999915, -27.32783986399997],
              [-55.89283687399998, -27.334867858999885],
              [-55.877850708999915, -27.35357472699988],
              [-55.86278702799993, -27.391091816999875],
              [-55.85415706399988, -27.40122039799992],
              [-55.84209061699991, -27.407421569999897],
              [-55.81516719599989, -27.414139505999927],
              [-55.75473160799987, -27.44369842499995],
              [-55.71749873899995, -27.4173434449999],
              [-55.68171280999994, -27.379412943999895],
              [-55.6536266679999, -27.360085957999942],
              [-55.628718628999934, -27.35636525499993],
              [-55.60747961499996, -27.345513203999886],
              [-55.591330728999964, -27.328356627999923],
              [-55.58164139799993, -27.305515645999918],
              [-55.58076289899989, -27.29166636099994],
              [-55.583243367999984, -27.28350148499993],
              [-55.58407019099991, -27.276783549],
              [-55.570711832999876, -27.25642303499997],
              [-55.56867061399993, -27.245984394999937],
              [-55.57058264199995, -27.235339049999936],
              [-55.5748717859999, -27.223556823999942],
              [-55.59897884199995, -27.18262908999992],
              [-55.59828120999995, -27.16753957099992],
              [-55.571745361999945, -27.161545104999902],
              [-55.55533809499991, -27.153793639999975],
              [-55.54952449599992, -27.135810241999906],
              [-55.54536454299998, -27.115243021999916],
              [-55.53384069899994, -27.099430033999923],
              [-55.51399694899996, -27.097466328999886],
              [-55.486401733999884, -27.100050149999973],
              [-55.46185542899991, -27.097983092999925],
              [-55.451313435999936, -27.082066751999903],
              [-55.44883296699996, -27.035868021999946],
              [-55.4427609869999, -27.01550750699991],
              [-55.43084956899989, -26.996387226999914],
              [-55.414003051999885, -26.979850768999924],
              [-55.39632971199998, -26.969308776999952],
              [-55.37622757999992, -26.963831074999874],
              [-55.329408731999905, -26.95845672599991],
              [-55.28060034199984, -26.934272155999935],
              [-55.256544962999925, -26.93458221399993],
              [-55.23517675799991, -26.942230326],
              [-55.21665075699988, -26.95122202599994],
              [-55.201199503999874, -26.955459492999907],
              [-55.161563679999915, -26.9573198449999],
              [-55.13836096299991, -26.953702493999927],
              [-55.122315429999844, -26.941713561999876],
              [-55.1188789469999, -26.920009460999964],
              [-55.13267655499996, -26.880632018999876],
              [-55.12577775099987, -26.863578795999928],
              [-55.060897989999944, -26.805184427999876],
              [-55.040744181999884, -26.798466491999946],
              [-54.99178076199988, -26.794642435999904],
              [-54.975270141999886, -26.787821145999942],
              [-54.96100744599991, -26.772318216999935],
              [-54.951137247999924, -26.75753875699992],
              [-54.943876708999966, -26.73996877099995],
              [-54.930725056999876, -26.693976744999944],
              [-54.91989884499995, -26.67413299599987],
              [-54.903336548999846, -26.659870299999895],
              [-54.879358683999925, -26.654392598999905],
              [-54.83496862799987, -26.654392598999905],
              [-54.827423868999915, -26.658113301999904],
              [-54.82282466699988, -26.66328094499991],
              [-54.81732112699987, -26.66576141399989],
              [-54.807011678999885, -26.661213886999946],
              [-54.793059041999896, -26.64498748799994],
              [-54.78494584199987, -26.6227666219999],
              [-54.781276814999984, -26.598168639999926],
              [-54.78034663999992, -26.57522430399989],
              [-54.78349890199988, -26.55672414199995],
              [-54.78876989799991, -26.54256479899992],
              [-54.789829264999895, -26.528508808999987],
              [-54.78034663999992, -26.51042205799989],
              [-54.76530879799995, -26.494092305999942],
              [-54.737170980999906, -26.47321502699988],
              [-54.70647517899994, -26.441795755999934],
              [-54.69766434799996, -26.42815317799993],
              [-54.693065144999906, -26.411926777999923],
              [-54.6834016519999, -26.350845234999923],
              [-54.68043025799997, -26.34526418],
              [-54.67906083199992, -26.33988983199994],
              [-54.66366125499991, -26.30836720799998],
              [-54.66366125499991, -26.26330535899993],
              [-54.666141723999885, -26.24366831499991],
              [-54.66497381799991, -26.238863213999963],
              [-54.66433304899991, -26.236226908999882],
              [-54.65619401099988, -26.22299774199989],
              [-54.64469600499987, -26.208218281999876],
              [-54.638288126999925, -26.196952819999908],
              [-54.64185380099991, -26.1840337109999],
              [-54.65994055199991, -26.164396666999963],
              [-54.66381628399995, -26.149203796999927],
              [-54.64314571099993, -26.085228373999954],
              [-54.64252559499997, -26.06280080199987],
              [-54.65332596899992, -26.03076141299995],
              [-54.658261067999945, -26.0003756709999],
              [-54.66159419799996, -25.989937031999958],
              [-54.66226599099994, -25.97991180399994],
              [-54.65619401099988, -25.96916310599991],
              [-54.64795161999987, -25.96564910899987],
              [-54.623689533999965, -25.9643055209999],
              [-54.61524043799997, -25.9617216999999],
              [-54.60640376799995, -25.946632181999902],
              [-54.60733394399992, -25.927925312999918],
              [-54.61524043799997, -25.882863464999957],
              [-54.61007279499995, -25.866533711999935],
              [-54.59922074399992, -25.850720722999938],
              [-54.58955725099989, -25.832944029999908],
              [-54.58790360499992, -25.8108265179999],
              [-54.59451818899993, -25.798734232999905],
              [-54.61715246599988, -25.773516133999948],
              [-54.62206172699993, -25.75997690899989],
              [-54.62492976899989, -25.74023651099992],
              [-54.64314571099993, -25.687939961999902],
              [-54.64288732999998, -25.661584980999947],
              [-54.63371476299997, -25.652076516999955],
              [-54.598497273999925, -25.65383351699994],
              [-54.58335607899991, -25.6448418169999],
              [-54.58624995999989, -25.624688008999925],
              [-54.602217976999924, -25.592441914999952],
              [-54.60020261299988, -25.57494488399989],
              [-54.56005000799988, -25.570221048999926],
              [-54.54563228399985, -25.57476857499995],
              [-54.539999552999916, -25.586757506999916],
              [-54.53870764199988, -25.601330260999973],
              [-54.53229976399993, -25.610632018999908],
              [-54.51142248599987, -25.606187845999983],
              [-54.491061971999926, -25.614042663999925],
              [-54.473026895999936, -25.625824890999922],
              [-54.460572875999844, -25.64205128999994],
              [-54.45700720299996, -25.663135273999956],
              [-54.456542114999934, -25.672643736999945],
              [-54.45354488199993, -25.68318572999992],
              [-54.44734370899994, -25.68918019599994],
              [-54.43731848199991, -25.685252786999882],
              [-54.433132690999884, -25.67657114699992],
              [-54.43773189399994, -25.655383808999957],
              [-54.43742183399985, -25.645048521999954],
              [-54.43132401499989, -25.636883646999934],
              [-54.41266882299993, -25.627271829999927],
              [-54.40507238799995, -25.6198304239999],
              [-54.402798624999946, -25.61032196099991],
              [-54.40367712499997, -25.600193378999876],
              [-54.402850300999944, -25.590271504999876],
              [-54.395408894999946, -25.58107309899988],
              [-54.38621048999994, -25.5771456909999],
              [-54.377787231999946, -25.577662455999942],
              [-54.360113891999845, -25.58427703799994],
              [-54.34967525199991, -25.582416686999935],
              [-54.333087117999895, -25.561952819999973],
              [-54.321718302999926, -25.555131530999915],
              [-54.2992390549999, -25.55265106199994],
              [-54.284407918999875, -25.556785175999963],
              [-54.273659220999946, -25.568774108999932],
              [-54.2631689049999, -25.59006479899992],
              [-54.25562414499987, -25.598746438999882],
              [-54.24962967999991, -25.593268737999978],
              [-54.24368688999991, -25.577559102999913],
              [-54.23510860199988, -25.576732279999888],
              [-54.228959105999905, -25.57704233799997],
              [-54.20994217999993, -25.582209980999977],
              [-54.190253458999905, -25.580763040999983],
              [-54.1946976319999, -25.56329640699994],
              [-54.21479976499995, -25.53146372399989],
              [-54.206944946999926, -25.527949726999935],
              [-54.19671301299985, -25.529603372999887],
              [-54.177696085999884, -25.535804544999877],
              [-54.16508703599996, -25.534357604999883],
              [-54.15428666199992, -25.52825978599992],
              [-54.12819006399994, -25.50056121899989],
              [-54.12209224499989, -25.49622039799992],
              [-54.11640783699994, -25.49456675199987],
              [-54.11144689999989, -25.495910338999934],
              [-54.10715775599991, -25.50056121899989],
              [-54.1118603109999, -25.51937143899991],
              [-54.120180216999955, -25.535494486999895],
              [-54.12596797699993, -25.55203094399988],
              [-54.123125773999874, -25.571771341999934],
              [-54.11769974799998, -25.580556334999926],
              [-54.108966430999914, -25.590271504999876],
              [-54.09888952699987, -25.59719614699995],
              [-54.08963944599995, -25.597402852],
              [-54.08576371299989, -25.590581562999944],
              [-54.08648718299989, -25.57983286499993],
              [-54.08876094599992, -25.568360696999918],
              [-54.08927770999995, -25.55885223399993],
              [-54.082714802999874, -25.550067240999937],
              [-54.0724828699999, -25.55533823599997],
              [-54.055377970999956, -25.57073781299995],
              [-54.04292394999996, -25.568464049999946],
              [-54.036774454999886, -25.564536641999965],
              [-54.030211548999915, -25.56215952599993],
              [-54.0165172939999, -25.56505340599992],
              [-53.99744868999991, -25.57497527999992],
              [-53.984994669999935, -25.58934132899992],
              [-53.978276733999905, -25.607014668999923],
              [-53.97620967599994, -25.627581888999913],
              [-53.96773474099993, -25.65321339899988],
              [-53.948097696999895, -25.650629576999876],
              [-53.909960489999946, -25.629235533999946],
              [-53.89812658699992, -25.639467467999935],
              [-53.88753291899994, -25.66127492299995],
              [-53.876474162999926, -25.697861835999987],
              [-53.87828283799993, -25.706130065999943],
              [-53.88252030499987, -25.71346811899994],
              [-53.8855175379999, -25.72256317199991],
              [-53.883450480999926, -25.735585632999943],
              [-53.87704260299998, -25.74612762399991],
              [-53.85781896999987, -25.763180846999944],
              [-53.84934403599996, -25.772896016999894],
              [-53.84035233599991, -25.791396178999918],
              [-53.83730342599989, -25.809172871999948],
              [-53.84164424699989, -25.867670592999943],
              [-53.829603637999895, -25.921310729999917],
              [-53.83058548999986, -25.931646015999917],
              [-53.83394445899998, -25.94032765699997],
              [-53.836063191999955, -25.949732767999933],
              [-53.83342769399994, -25.962238464999928],
              [-53.82619299299998, -25.97267710299988],
              [-53.792861694999914, -26.0003756709999],
              [-53.79270666599987, -26.00047902399993],
              [-53.79270666599987, -26.000582376999944],
              [-53.76500809799995, -26.02807423899992],
              [-53.753484253999915, -26.058666686999928],
              [-53.746766316999896, -26.091636250999983],
              [-53.73338212099995, -26.126362813999933],
              [-53.68511633299994, -26.187651061999887],
              [-53.666719522999955, -26.219173685999948],
              [-53.661551879999934, -26.25979136099997],
              [-53.67323075299993, -26.29255421899998],
              [-53.71586380999989, -26.34671112],
              [-53.72444209799994, -26.37606333399988],
              [-53.71276322499995, -26.469597675999893],
              [-53.7129182539999, -26.500293477999932],
              [-53.7129182539999, -26.500500182999886],
              [-53.72743933099994, -26.51135223399993],
              [-53.73457067899997, -26.518276875999916],
              [-53.73746455899996, -26.52530486999993],
              [-53.735604207999955, -26.535123392999893],
              [-53.73183182799994, -26.54556203199992],
              [-53.728214477999956, -26.55186655699994],
              [-53.726819213999875, -26.548559264999938],
              [-53.72960974199992, -26.565819192999925],
              [-53.7423738199999, -26.600545755999875],
              [-53.74294226099994, -26.619149270999927],
              [-53.737877970999875, -26.65707977299992],
              [-53.739531616999926, -26.675579935999863],
              [-53.746042846999984, -26.69387339199993],
              [-53.753742634999895, -26.69955779999988],
              [-53.76361283399987, -26.700798034999906],
              [-53.77172603399987, -26.70369191399989],
              [-53.774309854999984, -26.714337259999894],
              [-53.7696589759999, -26.726636249999927],
              [-53.7610806889999, -26.732837422999907],
              [-53.75245072499993, -26.73593800799995],
              [-53.747851521999905, -26.739141947999926],
              [-53.74728308099992, -26.749063821999925],
              [-53.753897664999926, -26.763119811999942],
              [-53.75291581299987, -26.77324839299989],
              [-53.74966019699988, -26.774902037999937],
              [-53.73756791199989, -26.775728860999962],
              [-53.73400223799993, -26.777382507999917],
              [-53.72242671699988, -26.81438283299987],
              [-53.710696166999895, -26.873810729999917],
              [-53.7125048419999, -26.904506530999953],
              [-53.724597127999886, -26.940473327999925],
              [-53.7684704189999, -27.024085794999948],
              [-53.77317297399986, -27.03018361399991],
              [-53.78004593999992, -27.033800963999894],
              [-53.79580725099993, -27.035868021999946],
              [-53.80092321799992, -27.03907196099992],
              [-53.805005655999906, -27.052197773999893],
              [-53.803248656999926, -27.08061981199991],
              [-53.80490230399988, -27.09436574299994],
              [-53.80975988799992, -27.10098032599994],
              [-53.82433264199997, -27.10935190799991],
              [-53.82872513899986, -27.114416198999976],
              [-53.828260050999944, -27.12175425199989],
              [-53.81875158699995, -27.13146942099992],
              [-53.81921667499998, -27.139737649999873],
              [-53.830017049999924, -27.156790872999906],
              [-53.84200598099997, -27.163508809999925],
              [-53.84877559499992, -27.157514342999903],
              [-53.857870645999895, -27.140977884999913],
              [-53.86877437399994, -27.125888367],
              [-53.882210245999886, -27.11989390099997],
              [-53.890840209999936, -27.12712860099994],
              [-53.89941849799996, -27.158444518999943],
              [-53.90949540199992, -27.168263040999918],
              [-53.925411743999945, -27.1659892779999],
              [-53.938537557999894, -27.15544728599994],
              [-53.950888223999954, -27.147799173999957],
              [-53.964117390999945, -27.154000345999947],
              [-53.96623612499994, -27.16722951299994],
              [-53.96106848199992, -27.180768737999912],
              [-53.96179195199991, -27.191414082999913],
              [-53.98148067299988, -27.19565154999995],
              [-53.98845699099988, -27.193791198999946],
              [-53.9926944579999, -27.190070495999947],
              [-53.99729366099987, -27.187279967999885],
              [-54.00514847799991, -27.18821014399994],
              [-54.01088456299996, -27.193997903999914],
              [-54.01811926299993, -27.212291360999885],
              [-54.091758178999925, -27.285155130999968],
              [-54.12819006399994, -27.28887583399998],
              [-54.158059041999934, -27.279470722999932],
              [-54.155940307999884, -27.257663268999906],
              [-54.16477697799988, -27.250635273999904],
              [-54.1770242929999, -27.243400573999935],
              [-54.18952998899991, -27.26086720799988],
              [-54.21815873299997, -27.329286803999963],
              [-54.22255122899986, -27.33683156299992],
              [-54.22792557899993, -27.34303273499991],
              [-54.231801309999895, -27.351507669999904],
              [-54.22957922399988, -27.37197153799987],
              [-54.23164628199993, -27.380549824999903],
              [-54.23924271599989, -27.383857115999902],
              [-54.25071488499992, -27.385200703999956],
              [-54.26125687699988, -27.388714701999916],
              [-54.26580440299992, -27.398016458999948],
              [-54.26859493099997, -27.406388040999914],
              [-54.27489945499988, -27.41610320999986],
              [-54.2819274499999, -27.424371438999913],
              [-54.28688838699995, -27.428402200999898],
              [-54.30693884399989, -27.42891896599994],
              [-54.321511596999954, -27.41951385499989],
              [-54.33401729399995, -27.406077982999932],
              [-54.34771154799998, -27.394295755999934],
              [-54.34610957899994, -27.426541849999893],
              [-54.34771154799998, -27.435843607999928],
              [-54.354326130999965, -27.446282246999957],
              [-54.363472859999945, -27.453516946999926],
              [-54.371586059999856, -27.45444712299988],
              [-54.37499670399998, -27.445765482999917],
              [-54.378717407999915, -27.42271779399995],
              [-54.38889766499997, -27.41114227299991],
              [-54.40424556499994, -27.407421569999897],
              [-54.44455318199988, -27.408971861999916],
              [-54.4608312579999, -27.412589212999904],
              [-54.46455196099993, -27.42333791099992],
              [-54.44765376899994, -27.445765482999917],
              [-54.44837723799992, -27.458891296999894],
              [-54.46858272399993, -27.470260110999973],
              [-54.533539998999885, -27.487416686999936],
              [-54.54325516799992, -27.48700327499992],
              [-54.55379715999996, -27.482972513999925],
              [-54.557621215999916, -27.47780486999993],
              [-54.56723303299992, -27.459614765999973],
              [-54.57054032499991, -27.455687356999917],
              [-54.578550170999904, -27.454240417999927],
              [-54.58382116699994, -27.452070006999932],
              [-54.58945389799996, -27.452586770999872],
              [-54.598497273999925, -27.459098001999934],
              [-54.605318562999884, -27.467986347999954],
              [-54.609814412999896, -27.478528340999915],
              [-54.61524043799997, -27.496718444999956],
              [-54.62591162199996, -27.515321960999913],
              [-54.63952836099986, -27.526794127999935],
              [-54.651233072999844, -27.52586395199998],
              [-54.65619401099988, -27.50726043699993],
              [-54.65947546399988, -27.502816263999918],
              [-54.66645178199988, -27.503849791999897],
              [-54.67347977699998, -27.509740905999905],
              [-54.67668371599987, -27.520592956999863],
              [-54.6764511719999, -27.534235533999947],
              [-54.6772004799999, -27.541780292999903],
              [-54.68112788899987, -27.54643117199997],
              [-54.69032629399996, -27.55128875699998],
              [-54.69967972799992, -27.553045755999875],
              [-54.72195227099988, -27.550978698999913],
              [-54.731899983999966, -27.55128875699998],
              [-54.77393876099998, -27.563794453999975],
              [-54.78034663999992, -27.56214080799994],
              [-54.7816902269999, -27.560073750999976],
              [-54.78802058999992, -27.552839050999907],
              [-54.79001013199985, -27.55128875699998],
              [-54.79373083499988, -27.549221699999933],
              [-54.79212886599993, -27.54426076299997],
              [-54.78853735399994, -27.538576354999933],
              [-54.786547810999906, -27.534235533999947],
              [-54.79223221799995, -27.52317677799995],
              [-54.80504797399993, -27.526380716999924],
              [-54.81889725799991, -27.5361992389999],
              [-54.827527221999844, -27.545087584999905],
              [-54.83367671799991, -27.565344746999912],
              [-54.83700984699993, -27.590459492999926],
              [-54.84509720899993, -27.61185353599994],
              [-54.86540604699994, -27.62084523499989],
              [-54.889797322999954, -27.620638529999937],
              [-54.89827225699986, -27.62363576199995],
              [-54.89646358199988, -27.661152851999944],
              [-54.90157954899988, -27.704457701999914],
              [-54.9069022219999, -27.727091979999955],
              [-54.91320674599993, -27.73691050199993],
              [-54.93299881999991, -27.743835143999902],
              [-54.98519201699989, -27.785279641999878],
              [-55.00911820499988, -27.788380228999912],
              [-55.02759252899992, -27.783005879999862],
              [-55.04464575299994, -27.775047708999892],
              [-55.06430863499989, -27.771016947999982],
              [-55.08115515199995, -27.77825164799995],
              [-55.07125911499986, -27.79437469499993],
              [-55.04043412299998, -27.819489440999874],
              [-55.02580969299993, -27.840160013999977],
              [-55.02963374799995, -27.850702005999935],
              [-55.04580847199995, -27.850702005999935],
              [-55.0677192789999, -27.83933319099995],
              [-55.077899535999876, -27.84336395299995],
              [-55.09993953399996, -27.843777363999962],
              [-55.108698689999926, -27.84677459699988],
              [-55.11138586399997, -27.852975768999954],
              [-55.1192406829999, -27.880881042999945],
              [-55.13970454999986, -27.876746927999918],
              [-55.16146032699987, -27.85824676499989],
              [-55.17755753599994, -27.853595885999923],
              [-55.19773718299993, -27.86062388099994],
              [-55.2123099369999, -27.877160339999932],
              [-55.22404048699988, -27.893800149999947],
              [-55.260239827999925, -27.91922495499996],
              [-55.270084187999885, -27.922428893999935],
              [-55.2807812099999, -27.92056854299993],
              [-55.30176184099989, -27.913953958999926],
              [-55.314112508999955, -27.91498748799991],
              [-55.32987381999993, -27.928113301999886],
              [-55.33302608199989, -27.94661346399991],
              [-55.337909504999914, -27.963149922999904],
              [-55.35886429899992, -27.97028126999993],
              [-55.36909623199989, -27.970798033999884],
              [-55.3764342849999, -27.973175149999918],
              [-55.380930135999904, -27.978239439999896],
              [-55.382428751999925, -27.987334492999963],
              [-55.38142106099994, -28.00872853599988],
              [-55.38338476599998, -28.014206237999957],
              [-55.38984431999992, -28.02423146599999],
              [-55.43508703699993, -28.070740254999933],
              [-55.44074560599995, -28.078905130999942],
              [-55.464852660999924, -28.085106302999932],
              [-55.475498005999896, -28.08634653699997],
              [-55.48231929599987, -28.083142597999895],
              [-55.4865309249999, -28.077148131999962],
              [-55.492964640999844, -28.073944193999907],
              [-55.505935424999876, -28.078905130999942],
              [-55.50991451099995, -28.08396942099992],
              [-55.520223957999946, -28.10681040399993],
              [-55.52479732299989, -28.110634459999872],
              [-55.53787145999985, -28.119316100999924],
              [-55.54376257299995, -28.12417368499986],
              [-55.54828426099988, -28.13223520899993],
              [-55.54973120099987, -28.139883320999914],
              [-55.55347774299989, -28.14556772799996],
              [-55.5648723969999, -28.14773813899994],
              [-55.57709387199992, -28.144327493999924],
              [-55.5793159589999, -28.136369323999958],
              [-55.578540812999904, -28.127480976999948],
              [-55.58164139799993, -28.121073099999904],
              [-55.60474076399993, -28.11693898499989],
              [-55.61665218099995, -28.129548034999914],
              [-55.62304188899989, -28.144350089999932],
              [-55.62383520599991, -28.146187845999933],
              [-55.63254268399987, -28.154662780999928],
              [-55.641999470999934, -28.160347187999974],
              [-55.68406408699988, -28.196210631999918],
              [-55.74793615799993, -28.215744322999925],
              [-55.7725341389999, -28.231970723999936],
              [-55.766591349999885, -28.257602233999904],
              [-55.754602416999944, -28.2656637569999],
              [-55.71470821199989, -28.281890156999907],
              [-55.7014532069999, -28.284990742999938],
              [-55.687216348999925, -28.290055032999916],
              [-55.677216959999924, -28.301837259999914],
              [-55.66360021999992, -28.326538593999928],
              [-55.67737198899994, -28.3738742069999],
              [-55.68406408699988, -28.388033548999942],
              [-55.69424434399994, -28.400125833999923],
              [-55.70569067399995, -28.40767059399988],
              [-55.71496659399986, -28.404466654999908],
              [-55.71884232599993, -28.384519550999883],
              [-55.734603637999896, -28.36591603599993],
              [-55.77119055199995, -28.35754445399995],
              [-55.81253169799987, -28.35320363299988],
              [-55.84234899999987, -28.346382344999924],
              [-55.88735917199992, -28.36333221499993],
              [-55.90560095199996, -28.37800832099991],
              [-55.90038163199995, -28.398472187999886],
              [-55.89666092899992, -28.406843769999952],
              [-55.89691931199991, -28.453455912999914],
              [-55.89805619299992, -28.46069061299997],
              [-55.902035278999904, -28.465134785999894],
              [-55.910665242999926, -28.470509134999944],
              [-55.91908850099992, -28.47340301499993],
              [-55.951592976999876, -28.476710306999934],
              [-55.979136515999954, -28.489216002999925],
              [-56.01158931499995, -28.496554056999926],
              [-56.02143367599993, -28.510403340999886],
              [-56.02295812999995, -28.528283386999945],
              [-56.020503499999876, -28.546266783999926],
              [-56.02189876399987, -28.585747578999957],
              [-56.04081233699989, -28.60900197399988],
              [-56.10300492399989, -28.64806935599998],
              [-56.18470536299989, -28.744187520999915],
              [-56.21845007399986, -28.764134622999933],
              [-56.265475626999944, -28.771989440999874],
              [-56.28614619999988, -28.780154316999884],
              [-56.294827839999925, -28.79576059899992],
              [-56.3010031739999, -28.88144012399991],
              [-56.32306901099989, -28.916476745999915],
              [-56.39161779799991, -28.95223683699993],
              [-56.41091894599995, -28.99130421999986],
              [-56.41192663599992, -29.031818541999954],
              [-56.415750691999875, -29.05135223399988],
              [-56.42797216799988, -29.06985239699989],
              [-56.44427608299992, -29.078120625999944],
              [-56.51331579599989, -29.09372690899997],
              [-56.54830074099988, -29.109953307999987],
              [-56.58421586099985, -29.132277525999953],
              [-56.61728877799993, -29.160906269999927],
              [-56.6436695969999, -29.196149596999916],
              [-56.6506717529999, -29.209068704999922],
              [-56.65630448399992, -29.22343475299992],
              [-56.6572863369999, -29.23790415399995],
              [-56.650465047999944, -29.251340026999912],
              [-56.66064530499992, -29.27087371799992],
              [-56.67702673399987, -29.313351745999867],
              [-56.68865393099992, -29.32957814499987],
              [-56.705500447999896, -29.343737487999917],
              [-56.71813533499994, -29.35148895199991],
              [-56.753559529999876, -29.367405292999933],
              [-56.76270625799995, -29.37288299599993],
              [-56.76994095899991, -29.379084166999917],
              [-56.775780394999884, -29.386422220999904],
              [-56.78081884799988, -29.39531056799993],
              [-56.78255000899992, -29.405439147999886],
              [-56.782033243999905, -29.41660125699991],
              [-56.78342850799987, -29.425799661999903],
              [-56.799835774999934, -29.43396453899993],
              [-56.80756140099993, -29.444713236999945],
              [-56.812935750999884, -29.457115579999922],
              [-56.81495113199995, -29.46703745499991],
              [-56.81903356999993, -29.474995625999966],
              [-56.897271687999904, -29.535663756999952],
              [-56.90435135899992, -29.54961639399994],
              [-56.91241288299992, -29.558401387999936],
              [-56.951635294999875, -29.586306660999924],
              [-56.96579463799992, -29.600879414999966],
              [-56.97938553899991, -29.634985859999944],
              [-57.00884110599992, -29.662581074999935],
              [-57.0135953379999, -29.673123066999906],
              [-57.020933390999915, -29.683355000999896],
              [-57.09415889499991, -29.751981301999933],
              [-57.11286576399988, -29.766037291999865],
              [-57.13338130699995, -29.772135110999912],
              [-57.177461303999934, -29.772858581999913],
              [-57.21962927299998, -29.778336282999902],
              [-57.26257238799985, -29.792598978999962],
              [-57.29151118999991, -29.815129902999985],
              [-57.308512736999944, -29.84851287799995],
              [-57.318744669999916, -29.96550832099986],
              [-57.32515254799995, -29.981011249999952],
              [-57.4114521889999, -30.03961232499998],
              [-57.50617508999994, -30.144308776999935],
              [-57.548601440999875, -30.170043639999918],
              [-57.56865189699991, -30.17655487099998],
              [-57.61169836499991, -30.182962747999937],
              [-57.63397090699996, -30.183582864999906],
              [-57.64246584634791, -30.193092102762034],
              [-57.63794999199985, -30.215105488999967],
              [-57.62373897299989, -30.25810028099994],
              [-57.6310770259999, -30.29706430999994],
              [-57.652729451999875, -30.329103698999944],
              [-57.84961665899996, -30.48526987799997],
              [-57.87710852099994, -30.514828795999904],
              [-57.889769246999975, -30.550795592999876],
              [-57.8857901609999, -30.589862975999978],
              [-57.86331091399998, -30.628620299999923],
              [-57.848531453999954, -30.647947285999876],
              [-57.82620723499991, -30.689701842999924],
              [-57.81788732999985, -30.71202606199998],
              [-57.80865916899995, -30.747331216999925],
              [-57.80186763499998, -30.773314309999932],
              [-57.79939710199994, -30.791460706999914],
              [-57.79602819899989, -30.816205748999977],
              [-57.79499466999991, -30.857960306999928],
              [-57.79613155099992, -30.86839894599997],
              [-57.80186763499998, -30.892480162999917],
              [-57.80724198499985, -30.907569681999917],
              [-57.819644327999924, -30.911600442999912],
              [-57.84279536999992, -30.909223326999964],
              [-57.88532507299996, -30.91883514399997],
              [-57.903980265999934, -30.92968719499993],
              [-57.911731730999946, -30.94736053499993],
              [-57.905478881999926, -30.95883270199994],
              [-57.86331091399998, -31.012266133999958],
              [-57.8552493899999, -31.058981627999955],
              [-57.873749552999925, -31.093088073999922],
              [-57.89901932799998, -31.12647104899989],
              [-57.911731730999946, -31.17060272199997],
              [-57.90501379399993, -31.21504445399995],
              [-57.90511714699994, -31.240986022999905],
              [-57.91483231599997, -31.252458190999917],
              [-57.93560624199992, -31.290285338999908],
              [-57.94299597199992, -31.29679656999987],
              [-57.95948075399991, -31.30795867899991],
              [-57.9663537189999, -31.314573262],
              [-57.975552123999876, -31.335140481999886],
              [-57.980513061999915, -31.38051238999992],
              [-57.990228230999975, -31.39932261199992],
              [-58.005937865999925, -31.4110014849999],
              [-58.04355830899996, -31.43063852999994],
              [-58.06257523599993, -31.44428110799994],
              [-58.07523596199988, -31.47518361399993],
              [-58.05079300899993, -31.500815124999903],
              [-58.03897801099987, -31.508637468999908],
              [-58.01332759699994, -31.525619811999945],
              [-57.986817585999944, -31.55414520299989],
              [-57.979582885999974, -31.598793639999926],
              [-57.98862626099992, -31.642821960999896],
              [-58.0488809819999, -31.79712778699991],
              [-58.05926794399991, -31.811493834999922],
              [-58.08345251499989, -31.819762063999875],
              [-58.13083980299987, -31.827823587999944],
              [-58.15285396399986, -31.83598846499997],
              [-58.16861527499992, -31.8460136919999],
              [-58.196003784999874, -31.872575377999908],
              [-58.202618367999975, -31.893142597999898],
              [-58.19031937699992, -31.913296406999876],
              [-58.15879675299996, -31.943888854999983],
              [-58.149029906999914, -31.975204772999902],
              [-58.145309203999915, -32.017889505999904],
              [-58.148306437999906, -32.06289967799992],
              [-58.15879675299996, -32.101553648999925],
              [-58.18086258999995, -32.13245615599992],
              [-58.18654699699991, -32.15292002399988],
              [-58.17522985899993, -32.17410736099994],
              [-58.10691361499997, -32.25182871499996],
              [-58.096526652999955, -32.28097422299989],
              [-58.101590942999934, -32.31135996499994],
              [-58.16494624899994, -32.38949472999987],
              [-58.18995764199994, -32.433936461999934],
              [-58.1997244879999, -32.44478851299989],
              [-58.20012361999997, -32.44720104199993],
              [-58.200428839999915, -32.44459400799991],
              [-58.22008216099994, -32.48951588299991],
              [-58.22280839799993, -32.534274997999944],
              [-58.21157792899993, -32.657321872999944],
              [-58.19298255099994, -32.72584400799991],
              [-58.179351365999935, -32.82830169099992],
              [-58.16966712099992, -32.84823984199994],
              [-58.14317786399994, -32.885023695999905],
              [-58.13776607999995, -32.900323174999926],
              [-58.141184048999946, -32.91912200299993],
              [-58.15611731699994, -32.95777760199991],
              [-58.1594945949999, -32.97975025799991],
              [-58.14907792899993, -33.02499765399995],
              [-58.14679928299995, -33.04998137799993],
              [-58.15575110599991, -33.06113046699994],
              [-58.19298255099994, -33.08831145599993],
              [-58.20445716099994, -33.09189218499995],
              [-58.22866777299993, -33.09514739399992],
              [-58.241444464999915, -33.09514739399992],
              [-58.38316809799994, -33.07545338299991],
              [-58.41893469999991, -33.08831145599993],
              [-58.423491990999935, -33.09335702899995],
              [-58.43016516799992, -33.102634372999944],
              [-58.43199622299994, -33.111586195999905],
              [-58.41283118399991, -33.11874765399995],
              [-58.41270911399994, -33.12639739399992],
              [-58.41649329299992, -33.1364885399999],
              [-58.41893469999991, -33.14666106599992],
              [-58.42149817599994, -33.16838958099993],
              [-58.43195553299995, -33.21306731599992],
              [-58.43321692599994, -33.232354424999926],
              [-58.41706295499995, -33.27548593499995],
              [-58.41234290299991, -33.29827239399992],
              [-58.42235266799992, -33.30803801899992],
              [-58.44005286399994, -33.31609465899993],
              [-58.45995032499991, -33.33473072699991],
              [-58.48786373599995, -33.36956145599993],
              [-58.50649980399993, -33.40585702899995],
              [-58.52171790299991, -33.44931405999995],
              [-58.53184973899994, -33.4939104149999],
              [-58.53563391799992, -33.53394947699991],
              [-58.52879798099991, -33.57903411299992],
              [-58.53099524599992, -33.588962497999944],
              [-58.54084225199995, -33.60898202899995],
              [-58.549387173999946, -33.68303801899992],
              [-58.54922441299993, -33.705336195999905],
              [-58.540679490999935, -33.745212497999944],
              [-58.524322068999936, -33.77776458099993],
              [-58.46939042899993, -33.842461846999925],
              [-58.461048956999946, -33.85947030999995],
              [-58.45555579299992, -33.87900155999995],
              [-58.452056443999936, -33.92457447699991],
              [-58.43936113199993, -33.97966887799993],
              [-58.44172115799995, -33.98992278399993],
              [-58.44664466099994, -34.00139739399992],
              [-58.44697018099993, -34.006931247999944],
              [-58.44717363199993, -34.01051197699991],
              [-58.43626868399991, -34.01441822699991],
              [-58.426991339999915, -34.01620859199994],
              [-58.40269934799994, -34.02597421699994],
              [-58.395375128999945, -34.031182549999926],
              [-58.38780676999994, -34.04648202899995],
              [-58.384429490999935, -34.066338799999926],
              [-58.38536536399994, -34.110039971999925],
              [-58.39134680899991, -34.14202239399992],
              [-58.392241990999935, -34.1540666649999],
              [-58.39012610599991, -34.15960051899992],
              [-58.38072669199994, -34.17717864399992],
              [-58.378570115999935, -34.18824635199991],
              [-58.412098761999914, -34.218682549999926],
              [-58.41633053299995, -34.22600676899992],
              [-58.42149817599994, -34.23992278399993],
              [-58.425770636999914, -34.24667734199994],
              [-58.441070115999935, -34.26116301899992],
              [-58.460194464999915, -34.27288176899992],
              [-58.480132615999935, -34.27743905999995],
              [-58.49836178299995, -34.27076588299991],
              [-58.506418423999946, -34.26897551899992],
              [-58.543080206999946, -34.26767343499995],
              [-58.54930579299992, -34.27263762799993],
              [-58.552845831999946, -34.27947356599992],
              [-58.55833899599992, -34.285414320999905],
              [-58.570423956999946, -34.288181247999944],
              [-58.512277798999946, -34.31568775799991],
              [-58.49461829299992, -34.32854583099993],
              [-58.46661549299995, -34.34798734699996],
              [-58.45460711399994, -34.366182764999905],
              [-58.473208049999926, -34.39815096399991],
              [-58.48550549899994, -34.40707233999996],
              [-58.49664106899991, -34.418004003999954],
              [-58.511465270999906, -34.43594476299995],
              [-58.510397017999935, -34.44900594599994],
              [-58.50322450099992, -34.463126926999905],
              [-58.47728430899991, -34.48333098799992],
              [-58.47370357999995, -34.49179452899995],
              [-58.47496497299994, -34.511976820999905],
              [-58.47419186099995, -34.52157968499995],
              [-58.45157491599991, -34.53381807499994],
              [-58.43335263499995, -34.54199441299994],
              [-58.41275119099993, -34.55519842599995],
              [-58.3787718829999, -34.57250942099995],
              [-58.363352016999954, -34.58611419099992],
              [-58.3449878479999, -34.6078512439999],
              [-58.33183610799995, -34.632009689999904],
              [-58.315030933999935, -34.65719461799995],
              [-58.236149621999914, -34.70080211599992],
              [-58.19012038799991, -34.73516444099994],
              [-58.15487164299992, -34.75040033899995],
              [-58.11829099199991, -34.75359930999991],
              [-58.0939244729999, -34.75773476499995],
              [-58.06354218999991, -34.77292764799995],
              [-58.0306400849999, -34.77909784499991],
              [-58.00018978599991, -34.78725815899992],
              [-57.965031436999936, -34.8245302869999],
              [-57.93822105699991, -34.83367068199993],
              [-57.88201939999993, -34.828867749999915],
              [-57.87103209399993, -34.829914576999954],
              [-57.85156801399995, -34.8480547499999],
              [-57.806436367999936, -34.872324817999925],
              [-57.758842977999905, -34.90966217999994],
              [-57.68681812799991, -34.93386829499991],
              [-57.60357479599992, -34.987702070999944],
              [-57.52203233999995, -35.01315372599993],
              [-57.48748290099991, -35.04438651299995],
              [-57.446698158999936, -35.07053410699996],
              [-57.349579855999934, -35.14987995899992],
              [-57.31393097299991, -35.189093560999936],
              [-57.27026988999995, -35.229714498999954],
              [-57.24876868399991, -35.24879322699991],
              [-57.20157722399995, -35.31015434799991],
              [-57.16223424599991, -35.37174067099994],
              [-57.13358301199992, -35.416656951999926],
              [-57.12814350499991, -35.441320754999936],
              [-57.14490852699993, -35.48420028899994],
              [-57.18044544299994, -35.52205817999993],
              [-57.22378495999993, -35.56926848799992],
              [-57.32359778599994, -35.696384372999944],
              [-57.35262539099995, -35.72752363299992],
              [-57.36563066299993, -35.76376718499995],
              [-57.3713785029999, -35.78998722099993],
              [-57.38122800799994, -35.83141565999995],
              [-57.39329993399991, -35.86296965899993],
              [-57.383480264999946, -35.89955562599994],
              [-57.37356475699994, -35.93947829599995],
              [-57.37246660099993, -35.96835702899995],
              [-57.37059485599991, -35.97698333099993],
              [-57.366444464999915, -35.98788827899995],
              [-57.34801184799994, -36.001071872999944],
              [-57.343861456999946, -36.01116301899992],
              [-57.34203040299991, -36.013929945999905],
              [-57.31598873599995, -36.06951262799993],
              [-57.31265214799993, -36.09075286299992],
              [-57.30882727799991, -36.099867445999905],
              [-57.291127081999946, -36.1071916649999],
              [-57.27188066299993, -36.12363046699994],
              [-57.26817786399994, -36.12786223799992],
              [-57.26231848899994, -36.1501604149999],
              [-57.248036261999914, -36.17034270599993],
              [-57.108265753999945, -36.282321872999944],
              [-57.005523240999935, -36.33367278399993],
              [-56.96031653599994, -36.34124114399992],
              [-56.93773352799991, -36.35076262799993],
              [-56.92870032499991, -36.36370208099993],
              [-56.94603430899991, -36.378024997999944],
              [-56.93919837099992, -36.38486093499995],
              [-56.920765753999945, -36.37004973799992],
              [-56.90021725199995, -36.35898202899995],
              [-56.856678839999915, -36.34392669099992],
              [-56.833973761999914, -36.34075286299992],
              [-56.76789303299995, -36.34392669099992],
              [-56.77867591099994, -36.32146575299993],
              [-56.77603105399993, -36.3064104149999],
              [-56.76244055899991, -36.30331796699994],
              [-56.74058997299994, -36.31658294099992],
              [-56.73485266799992, -36.32887135199991],
              [-56.72240149599992, -36.36931731599992],
              [-56.71637936099995, -36.378024997999944],
              [-56.69762122299994, -36.39617278399993],
              [-56.69957434799994, -36.521416924999926],
              [-56.675770636999914, -36.57634856599992],
              [-56.67227128799993, -36.60051848799992],
              [-56.66832434799994, -36.73642343499995],
              [-56.66486568899995, -36.85100676899992],
              [-56.668853318999936, -36.89421965899993],
              [-56.686431443999936, -36.927666924999926],
              [-56.790272589999915, -37.03834400799991],
              [-56.888661261999914, -37.162041924999926],
              [-57.01927649599992, -37.347588799999926],
              [-57.055897589999915, -37.41269296699994],
              [-57.16576087099992, -37.53557708099993],
              [-57.200835740999935, -37.56731536299992],
              [-57.309152798999946, -37.64544036299992],
              [-57.34874426999994, -37.69850025799991],
              [-57.360666469999956, -37.70761484199994],
              [-57.376942511999914, -37.7146135399999],
              [-57.457875128999945, -37.79501718499995],
              [-57.48741614499994, -37.83220794099992],
              [-57.51187089799993, -37.87232838299991],
              [-57.52887936099995, -37.91366952899995],
              [-57.53819739499994, -37.955336195999905],
              [-57.541859503999945, -37.99895598799992],
              [-57.54010982999995, -38.00514088299991],
              [-57.53148352799991, -38.016696872999944],
              [-57.52887936099995, -38.02353280999995],
              [-57.529408331999946, -38.02971770599993],
              [-57.534413214999915, -38.039320570999905],
              [-57.535715298999946, -38.043226820999905],
              [-57.53278561099995, -38.072523695999905],
              [-57.535715298999946, -38.084242445999905],
              [-57.55842037699995, -38.1208635399999],
              [-57.59357662699995, -38.15276458099993],
              [-57.686390753999945, -38.20476653399993],
              [-57.790272589999915, -38.252211195999905],
              [-57.861887173999946, -38.29412200299993],
              [-58.01870683499993, -38.36793385199991],
              [-58.052723761999914, -38.3728166649999],
              [-58.066070115999935, -38.37818775799991],
              [-58.11790930899991, -38.41326262799993],
              [-58.15566972599993, -38.43010833099993],
              [-58.275502081999946, -38.4685197899999],
              [-58.312611456999946, -38.48642343499995],
              [-58.330962693999936, -38.49277109199994],
              [-58.41950436099995, -38.504164320999905],
              [-58.49364173099991, -38.52434661299992],
              [-58.56700598899994, -38.558851820999905],
              [-58.72923743399991, -38.58847421699994],
              [-58.940297003999945, -38.64609140399995],
              [-58.99714107999995, -38.676039320999905],
              [-59.02830969999991, -38.68181731599992],
              [-59.06322180899991, -38.69378020599993],
              [-59.34780839749993, -38.738783461499935],
              [-59.63239498599995, -38.78378671699994],
              [-59.796864386999914, -38.83847421699994],
              [-59.819203253999945, -38.84075286299992],
              [-59.88931230399993, -38.83847421699994],
              [-60.34487870999993, -38.90667083099993],
              [-60.503570115999935, -38.927666924999926],
              [-60.659087693999936, -38.94304778399993],
              [-60.86571204299992, -38.975681247999944],
              [-60.97826087099992, -38.9743791649999],
              [-61.00304114499994, -38.969008070999905],
              [-61.016468878999945, -38.96819426899992],
              [-61.028553839999915, -38.96998463299991],
              [-61.037180141999954, -38.97405364399992],
              [-61.05064856699994, -38.98251718499995],
              [-61.14338131399995, -39.001071872999944],
              [-61.33775794199994, -38.98137786299992],
              [-61.42804928299995, -38.98251718499995],
              [-61.493072068999936, -38.99920012799993],
              [-61.50308183499993, -39.00603606599992],
              [-61.51805579299992, -39.0114885399999],
              [-61.67516028599994, -38.9939104149999],
              [-61.68858801999994, -38.98455169099992],
              [-61.70653235599991, -38.980401299999926],
              [-61.71670488199993, -38.970961195999905],
              [-61.72280839799993, -38.96819426899992],
              [-61.73110917899993, -38.96835702899995],
              [-61.73802649599992, -38.97087981599992],
              [-61.74400794199994, -38.97389088299991],
              [-61.74950110599991, -38.975681247999944],
              [-61.79051673099991, -38.98251718499995],
              [-61.83901933499993, -38.98088958099993],
              [-62.02672278599994, -38.93759530999995],
              [-62.06403561099995, -38.922946872999944],
              [-62.09316972599993, -38.90195077899995],
              [-62.113270636999914, -38.87265390399995],
              [-62.13003495999993, -38.836602471999925],
              [-62.14293372299994, -38.818291924999926],
              [-62.15733801999994, -38.810479424999926],
              [-62.31871497299994, -38.8005510399999],
              [-62.33543860599991, -38.79338958099993],
              [-62.35846920499995, -38.78728606599992],
              [-62.379750128999945, -38.79843515399995],
              [-62.39020748599995, -38.814711195999905],
              [-62.3801977199999, -38.824151299999926],
              [-62.38634192599994, -38.84514739399992],
              [-62.368072068999936, -38.882745049999926],
              [-62.373931443999936, -38.89999765399995],
              [-62.36017818899995, -38.8903947899999],
              [-62.34650631399995, -38.88990650799991],
              [-62.336008266999954, -38.89690520599993],
              [-62.33177649599992, -38.910088799999926],
              [-62.33446204299992, -38.94736093499995],
              [-62.33177649599992, -38.95452239399992],
              [-62.32046464799993, -38.9607072899999],
              [-62.30650794199994, -38.96013762799993],
              [-62.27403723899994, -38.95452239399992],
              [-62.27440344999991, -38.959649346999925],
              [-62.28107662699995, -38.97234465899993],
              [-62.28661048099991, -38.9880510399999],
              [-62.28392493399991, -39.002211195999905],
              [-62.30850175699993, -39.01262786299992],
              [-62.31851152299993, -39.02206796699994],
              [-62.33177649599992, -39.05754973799992],
              [-62.342355923999946, -39.07854583099993],
              [-62.348500128999945, -39.08757903399993],
              [-62.35594641799992, -39.09539153399993],
              [-62.35781816299993, -39.102227471999925],
              [-62.35204016799992, -39.10979583099993],
              [-62.34398352799991, -39.11793385199991],
              [-62.3391820949999, -39.12639739399992],
              [-62.34019934799994, -39.14462655999995],
              [-62.34508216099994, -39.160088799999926],
              [-62.34703528599994, -39.175713799999926],
              [-62.3391820949999, -39.19410572699991],
              [-62.32168535099993, -39.21054452899995],
              [-62.27696692599994, -39.23756275799991],
              [-62.25723222599993, -39.25554778399993],
              [-62.27257239499994, -39.25530364399992],
              [-62.28490149599992, -39.25253671699994],
              [-62.31126868399991, -39.24187590899993],
              [-62.32559160099993, -39.25465260199991],
              [-62.316395636999914, -39.26523202899995],
              [-62.29434160099993, -39.27271900799991],
              [-62.27033443899995, -39.27662525799991],
              [-62.19237219999991, -39.27874114399992],
              [-62.16787675699993, -39.28337981599992],
              [-62.08901933499993, -39.3142229149999],
              [-62.04662024599992, -39.33863697699991],
              [-62.02391516799992, -39.36484140399995],
              [-62.023101365999935, -39.37704843499995],
              [-62.02717037699995, -39.388929945999905],
              [-62.03465735599991, -39.39934661299992],
              [-62.04442298099991, -39.406914971999925],
              [-62.05699622299994, -39.41155364399992],
              [-62.06505286399994, -39.40943775799991],
              [-62.07135982999995, -39.40447356599992],
              [-62.07848059799994, -39.40007903399993],
              [-62.098540818999936, -39.39185963299991],
              [-62.15599524599992, -39.35214609199994],
              [-62.174672003999945, -39.33123137799993],
              [-62.17837480399993, -39.32586028399993],
              [-62.18382727799991, -39.315118096999925],
              [-62.188343878999945, -39.31072356599992],
              [-62.196156378999945, -39.30738697699991],
              [-62.20059160099993, -39.3083635399999],
              [-62.20409094999991, -39.310479424999926],
              [-62.20885169199994, -39.31072356599992],
              [-62.2278539699999, -39.30722421699994],
              [-62.28392493399991, -39.31072356599992],
              [-62.28172766799992, -39.31991952899995],
              [-62.278187628999945, -39.32968515399995],
              [-62.27253170499995, -39.33863697699991],
              [-62.26414954299992, -39.3454729149999],
              [-62.25348873599995, -39.34661223799992],
              [-62.23985755099994, -39.34514739399992],
              [-62.22813880099994, -39.346368096999925],
              [-62.22313391799992, -39.35556405999995],
              [-62.214833136999914, -39.37615325299993],
              [-62.195423956999946, -39.397149346999925],
              [-62.15420488199993, -39.42742278399993],
              [-62.13556881399995, -39.43572356599992],
              [-62.08641516799992, -39.44589609199994],
              [-62.061431443999936, -39.44736093499995],
              [-62.05577551999994, -39.45191822699991],
              [-62.05260169199994, -39.46168385199991],
              [-62.05060787699995, -39.47470468499995],
              [-62.05508378799993, -39.48552825299993],
              [-62.06688391799992, -39.494398695999905],
              [-62.072336391999954, -39.50318775799991],
              [-62.075062628999945, -39.57350025799991],
              [-62.08218339799993, -39.58456796699994],
              [-62.08665930899991, -39.595961195999905],
              [-62.11168372299994, -39.73251718499995],
              [-62.11436926999994, -39.82146575299993],
              [-62.11945553299995, -39.83831145599993],
              [-62.12535559799994, -39.8376604149999],
              [-62.16047115799995, -39.85442473799992],
              [-62.164173956999946, -39.85881926899992],
              [-62.2395727199999, -39.848728122999944],
              [-62.26162675699993, -39.838555596999925],
              [-62.30504309799994, -39.81113046699994],
              [-62.30874589799993, -39.82187265399995],
              [-62.30455481699994, -39.83220794099992],
              [-62.28392493399991, -39.852634372999944],
              [-62.308664516999954, -39.86150481599992],
              [-62.314564581999946, -39.869398695999905],
              [-62.31212317599994, -39.88241952899995],
              [-62.31126868399991, -39.907321872999944],
              [-62.31541907499991, -39.924493096999925],
              [-62.32884680899991, -39.96021900799991],
              [-62.335601365999935, -39.99431731599992],
              [-62.35505123599995, -40.03590260199991],
              [-62.36310787699995, -40.04436614399992],
              [-62.36632239499994, -40.05413176899992],
              [-62.3391820949999, -40.11272551899992],
              [-62.340402798999946, -40.13372161299992],
              [-62.35582434799994, -40.17538827899995],
              [-62.35968990799995, -40.19182708099993],
              [-62.36872311099995, -40.211195570999905],
              [-62.39012610599991, -40.221774997999944],
              [-62.41502844999991, -40.228448174999926],
              [-62.434803839999915, -40.236260674999926],
              [-62.45177161399994, -40.24960702899995],
              [-62.46979732999995, -40.2673479149999],
              [-62.48420162699995, -40.28753020599993],
              [-62.49006100199995, -40.30787525799991],
              [-62.48546301999994, -40.322198174999926],
              [-62.455922003999945, -40.365899346999925],
              [-62.440663214999915, -40.42498137799993],
              [-62.431630011999914, -40.434258721999925],
              [-62.43146725199995, -40.438571872999944],
              [-62.414906378999945, -40.46209075299993],
              [-62.40526282499991, -40.46795012799993],
              [-62.373931443999936, -40.47576262799993],
              [-62.34024003799993, -40.49334075299993],
              [-62.328684048999946, -40.49627044099992],
              [-62.325103318999936, -40.50164153399993],
              [-62.32603919199994, -40.52507903399993],
              [-62.32213294199994, -40.53045012799993],
              [-62.30809485599991, -40.53915780999995],
              [-62.296864386999914, -40.55527109199994],
              [-62.28368079299992, -40.564385674999926],
              [-62.26414954299992, -40.55152760199991],
              [-62.25047766799992, -40.596774997999944],
              [-62.25064042899993, -40.62224700299993],
              [-62.26720130099994, -40.633477471999925],
              [-62.315012173999946, -40.62664153399993],
              [-62.32013912699995, -40.62273528399993],
              [-62.33535722599993, -40.60466887799993],
              [-62.34601803299995, -40.59929778399993],
              [-62.346913214999915, -40.60857512799993],
              [-62.345366990999935, -40.61646900799991],
              [-62.34162350199995, -40.623304945999905],
              [-62.33543860599991, -40.63005950299993],
              [-62.32884680899991, -40.640557549999926],
              [-62.33055579299992, -40.648695570999905],
              [-62.33568274599992, -40.65349700299993],
              [-62.3391820949999, -40.65398528399993],
              [-62.329741990999935, -40.66912200299993],
              [-62.322377081999946, -40.672946872999944],
              [-62.244252081999946, -40.636976820999905],
              [-62.21353105399993, -40.628024997999944],
              [-62.18154863199993, -40.62664153399993],
              [-62.193348761999914, -40.63787200299993],
              [-62.22923743399991, -40.65862395599993],
              [-62.23680579299992, -40.67131926899992],
              [-62.23888098899994, -40.68629322699991],
              [-62.24779212099992, -40.71648528399993],
              [-62.24982662699995, -40.733086846999925],
              [-62.25426184799994, -40.746351820999905],
              [-62.28392493399991, -40.791680596999925],
              [-62.31126868399991, -40.84579843499995],
              [-62.33779863199993, -40.87273528399993],
              [-62.486439581999946, -40.93254973799992],
              [-62.6067602199999, -40.98984140399995],
              [-62.67446855399993, -41.01100025799991],
              [-62.69176184799994, -41.02044036299992],
              [-62.71007239499994, -41.03378671699994],
              [-62.729400193999936, -41.04111093499995],
              [-62.75133216099994, -41.04420338299991],
              [-62.777414516999954, -41.04501718499995],
              [-62.801625128999945, -41.041680596999925],
              [-62.81094316299993, -41.044040622999944],
              [-62.82274329299992, -41.05486419099992],
              [-62.848866339999915, -41.07187265399995],
              [-62.863840298999946, -41.08513762799993],
              [-62.93512936099995, -41.09970468499995],
              [-63.053578253999945, -41.147149346999925],
              [-63.09951738199993, -41.15488046699994],
              [-63.31700598899994, -41.14804452899995],
              [-63.36046301999994, -41.15837981599992],
              [-63.38414466099994, -41.16106536299992],
              [-63.47948157499991, -41.154229424999926],
              [-63.62181555899991, -41.16090260199991],
              [-63.779408331999946, -41.15878671699994],
              [-63.824208136999914, -41.15081145599993],
              [-63.86668860599991, -41.13372161299992],
              [-63.966867641999954, -41.06023528399993],
              [-64.01134192599994, -41.04501718499995],
              [-64.05288652299993, -41.045993747999944],
              [-64.06285559799994, -41.041273695999905],
              [-64.06541907499991, -41.03142669099992],
              [-64.06135006399995, -41.021416924999926],
              [-64.05231686099995, -41.00709400799991],
              [-64.06212317599994, -40.99944426899992],
              [-64.08531653599994, -41.00408294099992],
              [-64.11253821499992, -41.012790622999944],
              [-64.13426673099991, -41.01702239399992],
              [-64.17430579299992, -41.00896575299993],
              [-64.41710364499994, -40.91073984199994],
              [-64.5520727199999, -40.88290780999995],
              [-64.64476477799991, -40.84644947699991],
              [-64.73493404899995, -40.830336195999905],
              [-64.78331458199995, -40.82740650799991],
              [-64.85326087099992, -40.83294036299992],
              [-64.88540605399993, -40.83098723799992],
              [-64.91120357999995, -40.82382577899995],
              [-64.91197669199994, -40.80877044099992],
              [-64.89362545499995, -40.79843515399995],
              [-64.86799068899995, -40.79216887799993],
              [-64.84992428299995, -40.79509856599992],
              [-64.85423743399991, -40.81218840899993],
              [-64.84727942599994, -40.811618747999944],
              [-64.83946692599994, -40.809258721999925],
              [-64.83381100199995, -40.80673593499995],
              [-64.83311926999994, -40.805352471999925],
              [-64.77301998599995, -40.80608489399992],
              [-64.7551977199999, -40.80429452899995],
              [-64.74498450399994, -40.79729583099993],
              [-64.75357011599993, -40.77654387799993],
              [-64.78311113199993, -40.76799895599993],
              [-64.80028235599991, -40.758884372999944],
              [-64.77163652299993, -40.73650481599992],
              [-64.7962133449999, -40.723321221999925],
              [-64.89045162699995, -40.70598723799992],
              [-64.94652258999992, -40.71135833099993],
              [-64.98184160099993, -40.723321221999925],
              [-64.99136308499993, -40.72966887799993],
              [-64.97329667899993, -40.731540622999944],
              [-64.94066321499992, -40.724867445999905],
              [-64.92247473899994, -40.72966887799993],
              [-64.93639075399994, -40.74472421699994],
              [-64.93236243399991, -40.75351327899995],
              [-64.91999264199995, -40.760430596999925],
              [-64.90884355399993, -40.77011484199994],
              [-65.01085364499994, -40.76726653399993],
              [-65.0286352199999, -40.773695570999905],
              [-65.04206295499995, -40.78484465899993],
              [-65.12193762899994, -40.83367278399993],
              [-65.13170325399994, -40.84238046699994],
              [-65.13532467399995, -40.85165780999995],
              [-65.13438880099994, -40.873711846999925],
              [-65.13817298099991, -40.88298919099992],
              [-65.15245520699995, -40.90162525799991],
              [-65.16368567599994, -40.92302825299993],
              [-65.17162024599992, -40.94589609199994],
              [-65.17568925699993, -40.96917083099993],
              [-65.1751195949999, -41.01018645599993],
              [-65.14679928299995, -41.18059661299992],
              [-65.10684160099993, -41.298760674999926],
              [-65.10488847599993, -41.32976653399993],
              [-65.07970130099994, -41.38632577899995],
              [-65.07335364499994, -41.41765715899993],
              [-65.06118730399993, -41.44841887799993],
              [-65.00625566299993, -41.49342213299991],
              [-64.99136308499993, -41.524102471999925],
              [-64.99327551999994, -41.552992445999905],
              [-65.00186113199993, -41.58652109199994],
              [-65.01455644399994, -41.617120049999926],
              [-65.0286352199999, -41.637383721999925],
              [-65.03722083199995, -41.665134372999944],
              [-65.02676347599993, -41.7009416649999],
              [-64.99819902299993, -41.75750090899993],
              [-64.99990800699993, -41.79338958099993],
              [-65.01768958199995, -41.83635833099993],
              [-65.05968176999994, -41.90837981599992],
              [-65.07453365799995, -41.9509416649999],
              [-65.06956946499992, -41.98577239399992],
              [-65.05459550699993, -42.01067473799992],
              [-65.00499426999994, -42.09319426899992],
              [-64.97240149599992, -42.126885674999926],
              [-64.93545488199993, -42.15390390399995],
              [-64.85728919199994, -42.193617445999905],
              [-64.84398352799991, -42.19573333099993],
              [-64.82233639199995, -42.19459400799991],
              [-64.81114661399994, -42.19540780999995],
              [-64.80304928299995, -42.199151299999926],
              [-64.78661048099991, -42.209649346999925],
              [-64.76260331899994, -42.219414971999925],
              [-64.73729407499991, -42.22665780999995],
              [-64.71703040299991, -42.22991301899992],
              [-64.66673743399991, -42.23015715899993],
              [-64.64415442599994, -42.234633070999905],
              [-64.62425696499992, -42.24749114399992],
              [-64.60289466099994, -42.25823333099993],
              [-64.57945716099994, -42.25595468499995],
              [-64.55528723899994, -42.24846770599993],
              [-64.53148352799991, -42.24423593499995],
              [-64.50397701699995, -42.24553801899992],
              [-64.49063066299993, -42.24863046699994],
              [-64.48086503799993, -42.25465260199991],
              [-64.46666419199994, -42.26848723799992],
              [-64.46422278599994, -42.275323174999926],
              [-64.49111894399994, -42.284274997999944],
              [-64.51089433499993, -42.298760674999926],
              [-64.58747311099995, -42.38128020599993],
              [-64.59414628799993, -42.39153411299992],
              [-64.60228430899991, -42.42205169099992],
              [-64.59552975199995, -42.43059661299992],
              [-64.56627356699994, -42.43596770599993],
              [-64.48574785099993, -42.43124765399995],
              [-64.44505774599992, -42.44670989399992],
              [-64.41063391799992, -42.44622161299992],
              [-64.37608801999994, -42.44158294099992],
              [-64.35391191299993, -42.43596770599993],
              [-64.33141028599994, -42.42701588299991],
              [-64.31554114499994, -42.42302825299993],
              [-64.12755286399994, -42.432712497999944],
              [-64.10358639199995, -42.42782968499995],
              [-64.09325110599991, -42.41171640399995],
              [-64.08828691299993, -42.40935637799993],
              [-64.05972245999993, -42.38811614399992],
              [-64.05321204299992, -42.37859465899993],
              [-64.05158443899995, -42.37224700299993],
              [-64.05231686099995, -42.35409921699994],
              [-64.05321204299992, -42.348728122999944],
              [-64.05850175699993, -42.34343840899993],
              [-64.05972245999993, -42.336602471999925],
              [-64.05752519399994, -42.3337541649999],
              [-64.05260169199994, -42.3318010399999],
              [-64.04771887899994, -42.328789971999925],
              [-64.04548092399995, -42.32268645599993],
              [-64.04771887899994, -42.310804945999905],
              [-64.05752519399994, -42.291273695999905],
              [-64.05972245999993, -42.28167083099993],
              [-64.06843014199995, -42.26962655999995],
              [-64.08901933499993, -42.262790622999944],
              [-64.13426673099991, -42.25839609199994],
              [-64.24290930899991, -42.26230234199994],
              [-64.29662024599992, -42.2575822899999],
              [-64.33971106699994, -42.237399997999944],
              [-64.30654863199993, -42.22421640399995],
              [-64.16218014199995, -42.20940520599993],
              [-64.0389870809999, -42.15754157799995],
              [-63.957870114999935, -42.11348936299993],
              [-63.87091450999992, -42.083712721999916],
              [-63.80995988799992, -42.070174454999915],
              [-63.76864810099994, -42.07772318699995],
              [-63.73224850199995, -42.1052385399999],
              [-63.70962480399993, -42.13437265399995],
              [-63.678944464999915, -42.19459400799991],
              [-63.67491614499994, -42.212823174999926],
              [-63.66832434799994, -42.22861093499995],
              [-63.65274003799993, -42.24187590899993],
              [-63.62026933499993, -42.263929945999905],
              [-63.59797115799995, -42.29998137799993],
              [-63.59048417899993, -42.34124114399992],
              [-63.59750656999995, -42.441633226999954],
              [-63.579335089999915, -42.59295012799993],
              [-63.59211178299995, -42.633477471999925],
              [-63.61701412699995, -42.67473723799992],
              [-63.63329016799992, -42.7146135399999],
              [-63.62026933499993, -42.75123463299991],
              [-63.67149817599994, -42.80217864399992],
              [-63.73664303299995, -42.82480234199994],
              [-63.941965298999946, -42.859633070999905],
              [-64.00487219999991, -42.859633070999905],
              [-64.02562415299991, -42.86223723799992],
              [-64.06999663499994, -42.87860349899995],
              [-64.10789954299992, -42.88372161299992],
              [-64.13853919199994, -42.8669572899999],
              [-64.16218014199995, -42.84685637799993],
              [-64.19542395699995, -42.8083635399999],
              [-64.21397864499994, -42.79216887799993],
              [-64.23387610599991, -42.785414320999905],
              [-64.25133216099994, -42.77507903399993],
              [-64.25096594999991, -42.75212981599992],
              [-64.24290930899991, -42.72861093499995],
              [-64.23729407499991, -42.71648528399993],
              [-64.21861731699994, -42.65593840899993],
              [-64.20685787699995, -42.6482072899999],
              [-64.19566809799994, -42.64421965899993],
              [-64.20238196499992, -42.635430596999925],
              [-64.22423255099994, -42.6208635399999],
              [-64.22899329299992, -42.61858489399992],
              [-64.24404863199993, -42.61345794099992],
              [-64.24909420499995, -42.60979583099993],
              [-64.25352942599994, -42.60312265399995],
              [-64.25772050699993, -42.60035572699991],
              [-64.29442298099991, -42.5857072899999],
              [-64.30736243399991, -42.57439544099992],
              [-64.31236731699994, -42.555759372999944],
              [-64.32262122299994, -42.54241301899992],
              [-64.34593665299991, -42.53093840899993],
              [-64.38805091099994, -42.51726653399993],
              [-64.43773352799991, -42.506931247999944],
              [-64.54222571499992, -42.50628020599993],
              [-64.61485755099994, -42.51531340899993],
              [-64.63963782499991, -42.521742445999905],
              [-64.66295325399994, -42.53069426899992],
              [-64.68834387899994, -42.547133070999905],
              [-64.72325598899994, -42.552666924999926],
              [-64.73473059799994, -42.55787525799991],
              [-64.74229895699995, -42.56308359199994],
              [-64.78624426999994, -42.60833098799992],
              [-64.8040258449999, -42.62151458099993],
              [-64.82315019399994, -42.62712981599992],
              [-64.87311764199995, -42.63095468499995],
              [-64.92247473899994, -42.64137135199991],
              [-64.94603430899991, -42.654229424999926],
              [-64.95836341099994, -42.66936614399992],
              [-64.96727454299992, -42.68678150799991],
              [-64.98082434799994, -42.70623137799993],
              [-65.01219641799992, -42.73186614399992],
              [-65.01891028599994, -42.74684010199991],
              [-65.01187089799993, -42.77109140399995],
              [-64.99714107999995, -42.78484465899993],
              [-64.95677649599992, -42.79257577899995],
              [-64.92446855399993, -42.81129322699991],
              [-64.86046301999994, -42.82634856599992],
              [-64.73790442599994, -42.871026299999926],
              [-64.70400956899994, -42.8884416649999],
              [-64.66539466099994, -42.91521575299993],
              [-64.64549719999991, -42.92538827899995],
              [-64.61375891799992, -42.93132903399993],
              [-64.59068762899994, -42.940524997999944],
              [-64.57990475199995, -42.94304778399993],
              [-64.56480872299994, -42.94280364399992],
              [-64.53868567599994, -42.937432549999926],
              [-64.51305091099994, -42.93629322699991],
              [-64.50316321499992, -42.9372697899999],
              [-64.49486243399991, -42.94036223799992],
              [-64.47940019399994, -42.953383070999905],
              [-64.46157792899993, -42.961195570999905],
              [-64.45323645699995, -42.96721770599993],
              [-64.43346106699994, -42.9763322899999],
              [-64.40811113199993, -42.97616952899995],
              [-64.32827714799993, -42.951836846999925],
              [-64.31578528599994, -42.95045338299991],
              [-64.31505286399994, -42.9548479149999],
              [-64.30211341099994, -42.98088958099993],
              [-64.30671139199995, -42.99358489399992],
              [-64.32819576699995, -43.00986093499995],
              [-64.44758053299995, -43.068617445999905],
              [-64.56529700399994, -43.10409921699994],
              [-64.76524817599994, -43.14739348799992],
              [-64.94391842399995, -43.23943450299993],
              [-64.97541256399995, -43.269463799999926],
              [-64.99498450399994, -43.28337981599992],
              [-65.01528886599993, -43.29412200299993],
              [-65.03233801999994, -43.29941171699994],
              [-65.04336503799993, -43.32154713299991],
              [-65.04214433499993, -43.33945077899995],
              [-65.03604081899994, -43.35670338299991],
              [-65.03233801999994, -43.37810637799993],
              [-65.03905188699991, -43.395603122999944],
              [-65.05504309799994, -43.40683359199994],
              [-65.07412675699993, -43.41570403399993],
              [-65.15526282499991, -43.47812265399995],
              [-65.1926977199999, -43.52971770599993],
              [-65.20982825399994, -43.54631926899992],
              [-65.26353919199994, -43.5818010399999],
              [-65.27538001199991, -43.58733489399992],
              [-65.31354732999995, -43.63827890399995],
              [-65.31676184799994, -43.648370049999926],
              [-65.33079993399991, -43.66334400799991],
              [-65.33405514199995, -43.67262135199991],
              [-65.33238684799994, -43.730726820999905],
              [-65.32725989499994, -43.74627044099992],
              [-65.30606035099993, -43.7790666649999],
              [-65.31187903599994, -43.79225025799991],
              [-65.31737219999991, -43.81308359199994],
              [-65.31822669199994, -43.83220794099992],
              [-65.30980383999992, -43.84059010199991],
              [-65.29649817599994, -43.84807708099993],
              [-65.2884008449999, -43.865166924999926],
              [-65.28237870999993, -43.8845354149999],
              [-65.27538001199991, -43.89861419099992],
              [-65.27098548099991, -43.912774346999925],
              [-65.27554277299993, -43.951104424999926],
              [-65.27196204299992, -43.96404387799993],
              [-65.25812740799995, -43.96754322699991],
              [-65.23932857999995, -43.96331145599993],
              [-65.22860967999992, -43.9752534239999],
              [-65.25185855899991, -43.9881335419999],
              [-65.2427851889999, -44.01084562299991],
              [-65.24197713099994, -44.02726740299994],
              [-65.22237391199991, -44.03689592799992],
              [-65.18670758399992, -44.03553942499991],
              [-65.21148657799995, -44.05042856199992],
              [-65.2320826529999, -44.06743529999994],
              [-65.23786373599995, -44.08416106599992],
              [-65.23616731399994, -44.0991098689999],
              [-65.23386829399993, -44.113498070999924],
              [-65.22123961699992, -44.1188690269999],
              [-65.2148171259999, -44.13743482099994],
              [-65.23074687199994, -44.14326334799995],
              [-65.26232156799995, -44.14775565899993],
              [-65.28256747099994, -44.154517219999946],
              [-65.29876554099991, -44.16647892499992],
              [-65.30870792199994, -44.20008451099994],
              [-65.30682808499995, -44.224712482999905],
              [-65.3047235649999, -44.2400889189999],
              [-65.29153031399994, -44.25489932599993],
              [-65.28461430399994, -44.26207904799992],
              [-65.27651933499993, -44.265557549999926],
              [-65.26798522599995, -44.27226956599992],
              [-65.27196204299992, -44.28240325299993],
              [-65.26870969899994, -44.29101550999991],
              [-65.26586637799994, -44.301410146999956],
              [-65.2523390259999, -44.30732067799994],
              [-65.25656303799991, -44.31474363299992],
              [-65.25820427099995, -44.32315771399993],
              [-65.24619496899993, -44.334666668999944],
              [-65.22911639699993, -44.33407223799992],
              [-65.22141201499994, -44.338449254999944],
              [-65.22108491799992, -44.35599715799992],
              [-65.2168847019999, -44.36641033799992],
              [-65.22885195399994, -44.37040143699994],
              [-65.2344351779999, -44.3792143309999],
              [-65.23538257699994, -44.38670417399993],
              [-65.24789998299991, -44.38786530099992],
              [-65.2597414519999, -44.38856969799991],
              [-65.2659142999999, -44.39501212199991],
              [-65.27028372899991, -44.405715855999915],
              [-65.27951589899993, -44.40694101999992],
              [-65.28565658699995, -44.41241618999993],
              [-65.27927122699992, -44.41676377899995],
              [-65.27882171699991, -44.42193440299991],
              [-65.28743716699995, -44.4241119589999],
              [-65.28949766199992, -44.42641766199995],
              [-65.28239947399993, -44.42937261499992],
              [-65.28580890199993, -44.43259038399992],
              [-65.29691513499995, -44.431432799999925],
              [-65.30457142499995, -44.42612022199995],
              [-65.30990843299992, -44.428360177999934],
              [-65.31144705899993, -44.43395939399994],
              [-65.3057766149999, -44.43970246199996],
              [-65.30926802199991, -44.44479256499994],
              [-65.31591706199993, -44.447005375999936],
              [-65.3207032439999, -44.45159910199993],
              [-65.32866424399992, -44.45378523399995],
              [-65.33159002299993, -44.460759638999946],
              [-65.32649707599995, -44.46414550499992],
              [-65.31541418099994, -44.46577722699993],
              [-65.3116870369999, -44.47101549899992],
              [-65.31418630699994, -44.47645521699991],
              [-65.31903168699995, -44.48245734999995],
              [-65.32190606299991, -44.48849790999992],
              [-65.31358728399994, -44.494292523999945],
              [-65.30759650399995, -44.49253803799991],
              [-65.30098631999994, -44.491734255999916],
              [-65.29629168499991, -44.48948341499994],
              [-65.28260115199993, -44.492575993999935],
              [-65.2828249559999, -44.49820246899992],
              [-65.28828928999991, -44.50325369299992],
              [-65.28718011899991, -44.508437769999944],
              [-65.28005996899992, -44.511397073999944],
              [-65.27927794099992, -44.516263273999925],
              [-65.28990188699993, -44.518395909999924],
              [-65.30297205199992, -44.51578439899993],
              [-65.30902854699991, -44.51894715299994],
              [-65.31251055199994, -44.52357023299993],
              [-65.31477113099993, -44.530566489999956],
              [-65.32013505599991, -44.532804395999904],
              [-65.3238375279999, -44.526625820999925],
              [-65.32078311999993, -44.516360224999914],
              [-65.3257099189999, -44.50827791699993],
              [-65.33747428799995, -44.50709431899992],
              [-65.34867295999993, -44.509203870999954],
              [-65.35279983899994, -44.51474429099994],
              [-65.35869333499994, -44.51508701299991],
              [-65.36515081999994, -44.513073092999946],
              [-65.37310176699992, -44.51618322099995],
              [-65.37459740499992, -44.5213058839999],
              [-65.36949622299994, -44.529554945999905],
              [-65.36148027299993, -44.533868096999925],
              [-65.36122495099994, -44.54039415799991],
              [-65.3699066609999, -44.54349670499994],
              [-65.38088720899992, -44.54136659599993],
              [-65.3883183989999, -44.54543613199991],
              [-65.3933082559999, -44.55192198199995],
              [-65.39056290199994, -44.56093879799994],
              [-65.38027027999993, -44.5672584159999],
              [-65.37169663199995, -44.567435417999945],
              [-65.36550405999992, -44.572988195999926],
              [-65.3563280539999, -44.57411801599994],
              [-65.3585530979999, -44.58017247399994],
              [-65.36867923099993, -44.58606198299992],
              [-65.3739264159999, -44.585482945999956],
              [-65.37551252599991, -44.576063768999916],
              [-65.3827724809999, -44.576380754999946],
              [-65.3882142299999, -44.580489979999925],
              [-65.39176024699992, -44.58651621799993],
              [-65.39470777299994, -44.59396365999993],
              [-65.4004372839999, -44.589149092999946],
              [-65.40819996399995, -44.585699295999916],
              [-65.4104393959999, -44.57626609599993],
              [-65.41690084999993, -44.57331130599994],
              [-65.42092922099994, -44.57510245299994],
              [-65.42415738199992, -44.573623933999954],
              [-65.4292562409999, -44.56975743699991],
              [-65.43797043299992, -44.573323960999915],
              [-65.4499328469999, -44.57587978299995],
              [-65.4618120479999, -44.57655805399992],
              [-65.46536503399994, -44.582580520999954],
              [-65.46574142799994, -44.59102434999994],
              [-65.46091465499995, -44.60099342099994],
              [-65.47537934299993, -44.60020775899994],
              [-65.47956505999991, -44.60528430699992],
              [-65.49995370399995, -44.60436402199991],
              [-65.54273928099991, -44.61959284999995],
              [-65.57829647799991, -44.6478845929999],
              [-65.59851526799991, -44.642743683999925],
              [-65.64320848299991, -44.6679999829999],
              [-65.66047115799995, -44.68303801899992],
              [-65.6709675109999, -44.69738646999991],
              [-65.6792520489999, -44.70516962699992],
              [-65.6855386819999, -44.712529511999946],
              [-65.6958311219999, -44.734810325999945],
              [-65.69317418799994, -44.7625596389999],
              [-65.69522940199994, -44.777998672999956],
              [-65.69987877599993, -44.79243810199995],
              [-65.70426436999992, -44.801251736999916],
              [-65.71760408699993, -44.8042086019999],
              [-65.72710046799995, -44.80960483399991],
              [-65.72677892299993, -44.83026519999993],
              [-65.71845424199995, -44.83563897699992],
              [-65.7245336659999, -44.83876215299995],
              [-65.72825457099992, -44.84758238699993],
              [-65.71544314199991, -44.869962545999954],
              [-65.69777553999995, -44.874151974999904],
              [-65.68582549599995, -44.87349808599993],
              [-65.6820509339999, -44.877806782999926],
              [-65.67413321399994, -44.87846056199993],
              [-65.66972315699991, -44.88326233899994],
              [-65.66472710999994, -44.8899317609999],
              [-65.64814242199992, -44.889380057999915],
              [-65.64816361699991, -44.889847484999905],
              [-65.6340134209999, -44.88455813999991],
              [-65.61752053899994, -44.888432242999954],
              [-65.5981299149999, -44.8992202309999],
              [-65.57291603999994, -44.8958289709999],
              [-65.55294959299994, -44.9110238639999],
              [-65.53526213999993, -44.91563486799993],
              [-65.52139967599993, -44.93189759199993],
              [-65.53408789199995, -44.93396784099991],
              [-65.5478557369999, -44.94539489299996],
              [-65.56000912099995, -44.95028720699992],
              [-65.5649403569999, -44.95674761299995],
              [-65.57378343399995, -44.961713424999914],
              [-65.58688086299992, -44.95813808799994],
              [-65.59518900499995, -44.9659282259999],
              [-65.60543577299995, -44.97274058499994],
              [-65.60000699599993, -44.98459188699991],
              [-65.58782782399993, -44.99377788299995],
              [-65.58380890299992, -45.00747171099994],
              [-65.60089922199995, -45.00427308299993],
              [-65.61191283499994, -44.998867108999946],
              [-65.62223153499991, -45.00707109399991],
              [-65.61722414499991, -45.01328070399995],
              [-65.60264260499991, -45.02768655299991],
              [-65.64338037699991, -45.04739188199994],
              [-65.66441422799994, -45.042682337999906],
              [-65.68505571199995, -45.044537875999936],
              [-65.69061894499993, -45.06272142699993],
              [-65.7346139519999, -45.03533572099991],
              [-65.75137518799994, -45.0236458789999],
              [-65.78595042199993, -45.02713182899993],
              [-65.80318599499992, -45.027570658999934],
              [-65.81739670499991, -45.04029019199993],
              [-65.83068670199992, -45.034744367999906],
              [-65.8285729289999, -45.016526893999924],
              [-65.84159184399994, -45.00321645999992],
              [-65.85641929799993, -45.004582727999946],
              [-65.87237126299993, -45.00332169699993],
              [-65.8898069249999, -45.00808525299993],
              [-65.89069084099992, -45.0263149189999],
              [-65.88765865099992, -45.03944443599994],
              [-65.90859841399993, -45.03892709299993],
              [-65.93623791099992, -45.04868440599995],
              [-65.96421969199992, -45.041877316999944],
              [-65.98535354299992, -45.022186018999946],
              [-66.01635697499995, -45.00310723399991],
              [-66.04470906799992, -45.00409292699993],
              [-66.11030849499991, -44.98841203699993],
              [-66.16857413699995, -44.99639741999994],
              [-66.20036661899991, -44.992919196999935],
              [-66.2213395089999, -45.01581514399993],
              [-66.25958531499992, -45.039095963999955],
              [-66.28157880799995, -45.05760290399991],
              [-66.30069467599992, -45.04748620999993],
              [-66.31529296999992, -45.044454240999926],
              [-66.33618799299995, -45.0438455499999],
              [-66.3497072959999, -45.04345041399995],
              [-66.36717067399991, -45.04728643699991],
              [-66.37255088899991, -45.054955976999906],
              [-66.39334942099993, -45.052597412999944],
              [-66.40407016999995, -45.063626995999925],
              [-66.46772005799994, -45.0770158439999],
              [-66.49658992299993, -45.08838184199993],
              [-66.52387280699992, -45.108972139999935],
              [-66.52530085399991, -45.131880123999906],
              [-66.47605071099991, -45.14257148199994],
              [-66.45475808399993, -45.14934090699995],
              [-66.47330234599991, -45.168673843999954],
              [-66.57142151199992, -45.1411698469999],
              [-66.58779863199993, -45.139336846999925],
              [-66.58821368299994, -45.16666196099993],
              [-66.54310183799993, -45.174187256999915],
              [-66.5225725279999, -45.19318462299992],
              [-66.52399711399994, -45.216097126999955],
              [-66.56085939499991, -45.214957944999924],
              [-66.6695151099999, -45.214589857999954],
              [-66.78576840599993, -45.2291825179999],
              [-66.86892147899994, -45.23559726299993],
              [-66.92926587199992, -45.25653354299993],
              [-66.96121441999992, -45.276887221999914],
              [-67.00926673099991, -45.30388762799993],
              [-67.06479532499992, -45.34994880399995],
              [-67.0963804779999, -45.39180435299994],
              [-67.13397512499995, -45.42577822499993],
              [-67.1673508909999, -45.46143600999994],
              [-67.20132884499992, -45.50175043199994],
              [-67.2233287009999, -45.52867760399994],
              [-67.26980527799992, -45.560825681999916],
              [-67.29369055899991, -45.58993905999995],
              [-67.30776933499993, -45.601495049999926],
              [-67.33192450099995, -45.613491404999934],
              [-67.3445886529999, -45.633277334999946],
              [-67.35628532699991, -45.65896466799995],
              [-67.35623091199994, -45.68988371599994],
              [-67.35442622499994, -45.70579875499993],
              [-67.33511308499993, -45.71884530999995],
              [-67.33983313699991, -45.72869231599992],
              [-67.34626217399995, -45.73398202899995],
              [-67.3639044709999, -45.735682685999905],
              [-67.36443040499995, -45.74987129999994],
              [-67.36967714499991, -45.76230233299992],
              [-67.36873016299995, -45.76900048199991],
              [-67.36063562299995, -45.77666154299993],
              [-67.36459739199995, -45.78661041099991],
              [-67.37706458199995, -45.79412200299993],
              [-67.39708768299994, -45.79103073099992],
              [-67.4276721999999, -45.80799824299993],
              [-67.44241760699992, -45.817742292999924],
              [-67.45587397399993, -45.82500283599995],
              [-67.47402389299992, -45.86221250099993],
              [-67.50474049399992, -45.878345699999954],
              [-67.51510157399991, -45.897353436999936],
              [-67.53624316399993, -45.91614268799992],
              [-67.5477316269999, -45.9334458159999],
              [-67.53311113199993, -45.95826588299991],
              [-67.55757025799994, -45.96751579699992],
              [-67.57848059799994, -45.992852471999925],
              [-67.58165442599994, -46.00001392999991],
              [-67.61351477799991, -46.07187265399995],
              [-67.62120520699995, -46.099541924999926],
              [-67.62441972599993, -46.13005950299993],
              [-67.62246660099993, -46.16375090899993],
              [-67.57469641799992, -46.3220354149999],
              [-67.54088294199994, -46.40129973799992],
              [-67.51813717399995, -46.438164971999925],
              [-67.42321976499994, -46.56741944899994],
              [-67.36507905799994, -46.606216299999915],
              [-67.3364981439999, -46.6251919419999],
              [-67.28742428299995, -46.63616301899992],
              [-67.25627145699991, -46.64342173099993],
              [-67.24606090799995, -46.65161870399993],
              [-67.23208574099993, -46.670993747999944],
              [-67.1936397309999, -46.69100409899994],
              [-67.15243243899994, -46.69713652799993],
              [-67.12999479199993, -46.70659560899992],
              [-67.11538652299993, -46.73601653399993],
              [-67.08210700299992, -46.757094293999955],
              [-67.04740196599994, -46.795630238999934],
              [-67.03319251199991, -46.81910572699991],
              [-67.02257239499994, -46.82122161299992],
              [-67.00926673099991, -46.82170989399992],
              [-66.99982662699995, -46.824883721999925],
              [-66.99022376199991, -46.83904387799993],
              [-66.98228919199994, -46.84221770599993],
              [-66.9719945949999, -46.848321221999925],
              [-66.88304602799991, -46.91871510199991],
              [-66.82457434799994, -46.98137786299992],
              [-66.7864477199999, -47.00660572699991],
              [-66.69924531999993, -47.03774420499991],
              [-66.66106381299994, -47.03568441199991],
              [-66.62879545299995, -47.05121808799993],
              [-66.58779863199993, -47.0407854149999],
              [-66.56749426999994, -47.04802825299993],
              [-66.54702714799993, -47.04648202899995],
              [-66.52627519399994, -47.042087497999944],
              [-66.50523841099994, -47.0407854149999],
              [-66.48932857999995, -47.04501718499995],
              [-66.45677649599992, -47.0583635399999],
              [-66.44066321499992, -47.06129322699991],
              [-66.38565019399994, -47.05779387799993],
              [-66.36872311099995, -47.06129322699991],
              [-66.35822506399995, -47.06698984199994],
              [-66.3042793269999, -47.07379151099991],
              [-66.20049277099992, -47.089586768999936],
              [-66.08580481699994, -47.08261484199994],
              [-66.02879798099991, -47.06731536299992],
              [-66.00328528599994, -47.063571872999944],
              [-65.97956295499995, -47.0661760399999],
              [-65.91929052599994, -47.093916100999934],
              [-65.88115573199991, -47.09655518499994],
              [-65.85806308199994, -47.113407167999924],
              [-65.84738115699992, -47.139686817999916],
              [-65.82408300799995, -47.15330224699994],
              [-65.80581620999993, -47.16806405999995],
              [-65.79645748599995, -47.17424895599993],
              [-65.7449021939999, -47.20416400799991],
              [-65.75535523499991, -47.22345203999993],
              [-65.73774471599995, -47.277581427999905],
              [-65.72431445799992, -47.30956267699992],
              [-65.71301381699993, -47.341497173999926],
              [-65.72679696299991, -47.40884756299994],
              [-65.73566515999994, -47.50953542499991],
              [-65.76185443499992, -47.56805745199995],
              [-65.79070200699994, -47.63270647499991],
              [-65.84562584399993, -47.74220572699994],
              [-65.86513411299995, -47.74990584099993],
              [-65.89495022999995, -47.75066397199993],
              [-65.92189692799991, -47.74652916699995],
              [-65.97287331299992, -47.740986637999924],
              [-66.03206441799995, -47.739525295999954],
              [-66.06193029499991, -47.75815925299992],
              [-66.0956211589999, -47.787457134999954],
              [-66.12196428299995, -47.799704998999914],
              [-66.14801079799992, -47.80656641599995],
              [-66.21043860599991, -47.82854583099993],
              [-66.27391516799992, -47.85947030999995],
              [-66.29637610599991, -47.86386484199994],
              [-66.37344316299993, -47.861260674999926],
              [-66.38914954299992, -47.86386484199994],
              [-66.34064693899995, -47.87517669099992],
              [-66.30109615799995, -47.87249114399992],
              [-66.22411048099991, -47.84270598799992],
              [-66.19977779899995, -47.83806731599992],
              [-66.1444431779999, -47.828202140999906],
              [-66.04937103399993, -47.791863522999904],
              [-66.02257205199993, -47.77099306899993],
              [-65.97414375699992, -47.76464970699993],
              [-65.92935031699994, -47.7676205379999],
              [-65.90182401399994, -47.76994984799995],
              [-65.88462771999991, -47.783830451999904],
              [-65.86721256899995, -47.83507742199993],
              [-65.85340938299993, -47.87959037199994],
              [-65.82703907299992, -47.89853302899991],
              [-65.7903558989999, -47.90477738199991],
              [-65.76173881699992, -47.9119076259999],
              [-65.78815330499992, -47.92531431999993],
              [-65.79512145899992, -47.93593417999995],
              [-65.77458791499993, -47.943957019999914],
              [-65.7619523379999, -47.94855158699994],
              [-65.78633148599994, -47.95338917499993],
              [-65.81244735999991, -47.96032816799993],
              [-65.83674174499993, -47.96299095799992],
              [-65.84706762499991, -47.94441661099995],
              [-65.89955863599994, -47.93237992399992],
              [-65.92738479899992, -47.94140874099992],
              [-65.9462139659999, -47.96250188899995],
              [-65.95200869399991, -47.98069202399995],
              [-65.92999068999995, -47.99095078899995],
              [-65.93687903599994, -48.01580169099992],
              [-65.94041907499991, -48.02092864399992],
              [-65.94688880099994, -48.02629973799992],
              [-65.94896399599992, -48.03826262799993],
              [-65.968445, -48.04716810799994],
              [-65.96413056199992, -48.05698808199992],
              [-65.93747650599994, -48.071685817999935],
              [-65.90318762899994, -48.07854583099993],
              [-65.8976881449999, -48.09445615499993],
              [-65.91723745599995, -48.113813629999925],
              [-65.94497130399992, -48.11779738899992],
              [-65.95315975699992, -48.10475529799993],
              [-65.97167519499993, -48.09944889099995],
              [-65.99007949899993, -48.10720897199991],
              [-66.01520800399993, -48.10647073399991],
              [-66.06152579999991, -48.11013456799992],
              [-66.09005949599992, -48.116261891999955],
              [-66.10863196499992, -48.123304945999905],
              [-66.13201060499995, -48.1363403549999],
              [-66.14007149399993, -48.160237570999925],
              [-66.15276941299993, -48.174897769999916],
              [-66.15953528599994, -48.1853166649999],
              [-66.20129786599995, -48.1988586679999],
              [-66.23828681399993, -48.208923400999936],
              [-66.26481205899995, -48.242779234999944],
              [-66.30085201699995, -48.251885674999926],
              [-66.31688391799992, -48.26425546699994],
              [-66.33678137899994, -48.28630950299993],
              [-66.35498753599995, -48.321216130999915],
              [-66.34111464199992, -48.35272452299995],
              [-66.35284255899995, -48.356139270999904],
              [-66.38626011899993, -48.3511745749999],
              [-66.42096018599995, -48.35038396099992],
              [-66.44859778599994, -48.350274346999925],
              [-66.45156816299993, -48.35507577899995],
              [-66.4695581229999, -48.36493178599994],
              [-66.46380813399992, -48.37876765599992],
              [-66.46849041399992, -48.40027515899993],
              [-66.50105555699992, -48.413988107999955],
              [-66.54497184999991, -48.42396739399993],
              [-66.57622911399994, -48.42390248699991],
              [-66.65099036399994, -48.43108489399992],
              [-66.6933673019999, -48.4550878309999],
              [-66.7498351719999, -48.47529201399993],
              [-66.77335389099994, -48.494180866999955],
              [-66.8092006299999, -48.5126828999999],
              [-66.83827796999992, -48.53957142399992],
              [-66.8578115009999, -48.54830711199992],
              [-66.86038775399993, -48.56984619799994],
              [-66.8664354949999, -48.589834355999926],
              [-66.88977315099993, -48.59589537799991],
              [-66.91548417199994, -48.60425682399995],
              [-66.9869231369999, -48.61169789799993],
              [-67.04413302199993, -48.64423687499993],
              [-67.1143484879999, -48.67375008599993],
              [-67.13675175199995, -48.692800752999915],
              [-67.14579291599995, -48.742427180999925],
              [-67.18463619399995, -48.7715770019999],
              [-67.19323122799995, -48.79610571199993],
              [-67.19828466699994, -48.818353344999935],
              [-67.24780769299991, -48.845645256999944],
              [-67.32183988399993, -48.86734733299994],
              [-67.40573688699993, -48.90423524899995],
              [-67.55654869799992, -49.01581686399993],
              [-67.57494219199992, -49.047866134999936],
              [-67.58993182099994, -49.08458553399993],
              [-67.59635898099992, -49.10679736399993],
              [-67.61543146899993, -49.11811372199992],
              [-67.63255774599992, -49.129978122999944],
              [-67.6351983369999, -49.15554487199995],
              [-67.6153668419999, -49.16114289899991],
              [-67.60992954699992, -49.178107403999945],
              [-67.62413489499994, -49.18482838299991],
              [-67.63170325399994, -49.19060637799993],
              [-67.65013587099992, -49.195977471999925],
              [-67.65587317599994, -49.20403411299992],
              [-67.66030839799993, -49.213962497999944],
              [-67.66834449999993, -49.22404097499992],
              [-67.67536006999995, -49.248788730999934],
              [-67.70250148499991, -49.26750864799993],
              [-67.73232988199993, -49.27467213299991],
              [-67.72288977799991, -49.28435637799993],
              [-67.71068274599992, -49.29371510199991],
              [-67.70417232999995, -49.30388762799993],
              [-67.71190344999991, -49.31560637799993],
              [-67.72630774599992, -49.3181291649999],
              [-67.73980888699992, -49.32754606099991],
              [-67.75780155399991, -49.33478111599993],
              [-67.7453661959999, -49.34242202099995],
              [-67.74577902999994, -49.3556925929999],
              [-67.77431215199994, -49.37440818999994],
              [-67.83088131399995, -49.379571221999925],
              [-67.83250891799992, -49.385430596999925],
              [-67.81427975199995, -49.391289971999925],
              [-67.79312089799993, -49.39177825299993],
              [-67.72518395899993, -49.390745539999955],
              [-67.69789541299991, -49.3719603909999],
              [-67.68288778099992, -49.33647913999994],
              [-67.68469529299995, -49.309964676999925],
              [-67.66907689699991, -49.296065178999925],
              [-67.66320732399993, -49.267152912999904],
              [-67.64574133999992, -49.25204843499995],
              [-67.63683020699995, -49.24724700299993],
              [-67.62218176999994, -49.25074635199991],
              [-67.60765540299991, -49.26506926899992],
              [-67.60784683999992, -49.284313579999946],
              [-67.61140455499992, -49.3231925689999],
              [-67.65330969999991, -49.37712981599992],
              [-67.65664628799993, -49.39470794099992],
              [-67.6763874099999, -49.46193873599992],
              [-67.70006262899994, -49.534274997999944],
              [-67.70628821499992, -49.56210702899995],
              [-67.70624909499992, -49.60603329799994],
              [-67.71354882399993, -49.62965601999991],
              [-67.71799844899994, -49.67055083999992],
              [-67.71253818899993, -49.68554912099995],
              [-67.73201204799994, -49.78130177299994],
              [-67.76317298099991, -49.84840260199991],
              [-67.77171790299991, -49.8708635399999],
              [-67.78685462099992, -49.89218515399995],
              [-67.79381262899994, -49.905368747999944],
              [-67.79889889199995, -49.90984465899993],
              [-67.83320700599995, -49.954540455999904],
              [-67.8949271059999, -49.99687492399994],
              [-67.98217462199995, -50.043199340999934],
              [-68.07635021999994, -50.087267966999946],
              [-68.17010877399991, -50.1140340849999],
              [-68.25836740999995, -50.124647109999955],
              [-68.32827714799993, -50.120212497999944],
              [-68.34186764199995, -50.11760833099993],
              [-68.35191809799994, -50.11052825299993],
              [-68.37661699099993, -50.08342864399992],
              [-68.39949716899991, -50.07531568399992],
              [-68.42195327399992, -50.051188993999915],
              [-68.43619574799993, -50.03152622899995],
              [-68.4451164539999, -50.005491527999936],
              [-68.46245273499994, -49.98039071399995],
              [-68.48663630999994, -49.959471192999956],
              [-68.52094919599995, -49.94052407399994],
              [-68.54185950399994, -49.91562265399995],
              [-68.5489413439999, -49.893675825999935],
              [-68.569066, -49.85881865099992],
              [-68.59466653099992, -49.834627274999946],
              [-68.64126542899993, -49.77459075299993],
              [-68.65404212099992, -49.75790780999995],
              [-68.67223059799994, -49.74578215899993],
              [-68.69579016799992, -49.73560963299991],
              [-68.71987870999993, -49.72909921699994],
              [-68.73973548099991, -49.72771575299993],
              [-68.67711341099994, -49.755791924999926],
              [-68.66405188699991, -49.767510674999926],
              [-68.65811113199993, -49.78264739399992],
              [-68.6306064609999, -49.81776976599991],
              [-68.59578014499994, -49.85830677999991],
              [-68.57779826899991, -49.90282559399992],
              [-68.5772722879999, -49.92761588199994],
              [-68.5930883449999, -49.93759530999995],
              [-68.62645423099991, -49.953057549999926],
              [-68.65013587099992, -49.95818450299993],
              [-68.67438717399995, -49.96835702899995],
              [-68.70144621599991, -49.970391355999936],
              [-68.74298794899994, -49.96415360599991],
              [-68.80357382199992, -49.96831264899993],
              [-68.87537908599995, -49.96249530199992],
              [-68.91334172299992, -49.98110111799991],
              [-68.94596623399991, -49.991230395999935],
              [-68.97492428299995, -49.99187590899993],
              [-69.01349850199995, -50.007745049999926],
              [-69.01349850199995, -50.01523202899995],
              [-69.00837154899995, -50.015557549999926],
              [-68.99803626199991, -50.01490650799991],
              [-68.99299068899995, -50.01523202899995],
              [-68.96996008999992, -50.01376718499995],
              [-68.9150126749999, -50.01126585599991],
              [-68.88190670499995, -49.99260833099993],
              [-68.85602779899995, -49.983493747999944],
              [-68.84215247299994, -49.98105234199994],
              [-68.82900956899994, -49.981540622999944],
              [-68.80106994699992, -49.984534],
              [-68.76905515699991, -49.98195025399991],
              [-68.7174548239999, -49.98945652099991],
              [-68.67084224599995, -49.99472571399991],
              [-68.63898678299995, -49.984307549999926],
              [-68.60118524199993, -49.972540153999944],
              [-68.58346975799992, -49.9703374419999],
              [-68.56773088199992, -49.97414476799992],
              [-68.55960165199991, -49.97968188199991],
              [-68.55211341099994, -49.99968840899993],
              [-68.53232169799992, -50.00834316699991],
              [-68.51885100499993, -50.015666031999956],
              [-68.5189671139999, -50.0251131359999],
              [-68.51802370399992, -50.03966783099992],
              [-68.51150165799993, -50.060767608999925],
              [-68.4937536459999, -50.08011367499995],
              [-68.46666261699994, -50.10013224499994],
              [-68.44526254999994, -50.109666519999905],
              [-68.41924472099993, -50.11195050999993],
              [-68.40298368499992, -50.11697586699995],
              [-68.39111386399992, -50.12901289699994],
              [-68.3631293059999, -50.13424102899995],
              [-68.34987266699994, -50.148810460999925],
              [-68.36209878599993, -50.16931403199993],
              [-68.39590410099993, -50.17782968499995],
              [-68.41832434799994, -50.19182708099993],
              [-68.43809973899994, -50.20077890399995],
              [-68.61435785799995, -50.25202158199994],
              [-68.73664909799993, -50.29143435799995],
              [-68.76732952099991, -50.28867542499995],
              [-68.79167878099992, -50.303876516999935],
              [-68.79465338699993, -50.31752639699994],
              [-68.8255188409999, -50.32413316399993],
              [-68.84025504499994, -50.32572975799991],
              [-68.8562189779999, -50.322189169999945],
              [-68.8764293239999, -50.33057201899993],
              [-68.88093771599995, -50.35275568499992],
              [-68.89989173099991, -50.361993096999925],
              [-68.94631046399991, -50.4043428679999],
              [-68.97507873699993, -50.42890766499994],
              [-68.98961341099994, -50.45159270599993],
              [-69.00987348599995, -50.47724447999991],
              [-69.04386623999994, -50.515471557999945],
              [-69.06004759699994, -50.541335498999956],
              [-69.0765186079999, -50.5601720599999],
              [-69.07990810299992, -50.60453716099994],
              [-69.12267005099994, -50.67986419099992],
              [-69.14240475199995, -50.71949635199991],
              [-69.14997311099995, -50.742120049999926],
              [-69.14753170499995, -50.75872161299992],
              [-69.13257050399994, -50.78400325599995],
              [-69.12726696299995, -50.846726349999926],
              [-69.12806415499995, -50.8780575209999],
              [-69.13679981999991, -50.90348080799993],
              [-69.15906766299992, -50.91564219399993],
              [-69.2058726649999, -50.93558316299993],
              [-69.26048743399991, -50.97421640399995],
              [-69.34780839799993, -51.018649997999944],
              [-69.39012610599991, -51.04851653399993],
              [-69.41071529899995, -51.083916924999926],
              [-69.38072669199994, -51.06487395599993],
              [-69.32326410499991, -51.03237618899993],
              [-69.28808258399994, -51.01576894699991],
              [-69.2277307789999, -50.99214310499991],
              [-69.19666185599993, -50.98036212399995],
              [-69.1677783049999, -50.97822484799991],
              [-69.15866819999991, -50.99646176199991],
              [-69.15746008999992, -51.01572030999995],
              [-69.14541581899994, -51.05722421699994],
              [-69.12369661399993, -51.13453844399993],
              [-69.10845061599991, -51.184336586999905],
              [-69.10417679699992, -51.21485815199992],
              [-69.08690344999991, -51.23528411299992],
              [-69.07925370999993, -51.277601820999905],
              [-69.06265214799993, -51.32146575299993],
              [-68.96373450399994, -51.50074635199991],
              [-68.95620683499993, -51.52223072699991],
              [-68.95445716099994, -51.542901299999926],
              [-68.96255449099993, -51.56015390399995],
              [-68.98184160099993, -51.57154713299991],
              [-68.99941972599993, -51.56926848799992],
              [-69.01976477799991, -51.563164971999925],
              [-69.04759680899991, -51.563164971999925],
              [-69.06875566299993, -51.57236093499995],
              [-69.10130774599992, -51.59921640399995],
              [-69.11961829299992, -51.60475025799991],
              [-69.14753170499995, -51.6032854149999],
              [-69.17186438699991, -51.5993791649999],
              [-69.28433183499993, -51.55974700299993],
              [-69.36009680899991, -51.555759372999944],
              [-69.37718665299991, -51.556898695999905],
              [-69.38878333199995, -51.559665622999944],
              [-69.41812089799993, -51.570570570999905],
              [-69.47427324099993, -51.575290622999944],
              [-69.49990800699993, -51.58025481599992],
              [-69.54556230399993, -51.60588958099993],
              [-69.59414628799993, -51.61663176899992],
              [-69.61681067599994, -51.62517669099992],
              [-69.39872109399994, -51.592600629999936],
              [-69.35299021599991, -51.58836983799995],
              [-69.3045589219999, -51.59348970399992],
              [-69.20066835599994, -51.62049249799992],
              [-69.1569823559999, -51.63488330899992],
              [-69.16477974799994, -51.651758540999936],
              [-69.21890214799993, -51.68043385199991],
              [-69.21890214799993, -51.68670012799993],
              [-69.19896399599992, -51.686618747999944],
              [-69.18065344999991, -51.681573174999926],
              [-69.0980841569999, -51.653131232999954],
              [-69.05538131999992, -51.62986557799991],
              [-69.02892005099994, -51.61419036299992],
              [-69.00066337699991, -51.61135016399993],
              [-68.97351114399993, -51.619951743999934],
              [-68.93592766299992, -51.64551591499992],
              [-68.87315833199995, -51.75896575299993],
              [-68.82670866299992, -51.803747520999934],
              [-68.75307118699993, -51.91472399799994],
              [-68.68505901199995, -52.005006357999946],
              [-68.52159583199995, -52.16350676899992],
              [-68.39792135899995, -52.27523441599993],
              [-68.36561064099993, -52.30620370899993],
              [-68.35480913399994, -52.32497790499991],
              [-68.36247238499993, -52.33907152099994],
              [-68.39013823999994, -52.35787086399995],
              [-68.40705325699992, -52.37102424099993],
              [-68.41781478299993, -52.38605157099994],
              [-68.43474805699992, -52.39074851799995],
              [-68.44245100099994, -52.379480573999956],
              [-68.43629713899992, -52.36633480599994],
              [-68.4486097329999, -52.346617015999925],
              [-68.44820791496335, -52.3103940627235],
              [-68.45449906399998, -52.29990732799986],
              [-68.47780513499993, -52.29535980199992],
              [-68.55681839999988, -52.28368092899986],
              [-68.57314815299992, -52.28027028399992],
              [-68.60358557099988, -52.26797129299988],
              [-68.62172399899993, -52.2636304729999],
              [-68.82049739699991, -52.24316660599994],
              [-68.85866044199989, -52.23324473099985],
              [-69.00756608099994, -52.17908782999993],
              [-69.21225642899986, -52.13795338999995],
              [-69.48528885999986, -52.13247568699996],
              [-69.66393428599989, -52.084726664999984],
              [-69.83332963099991, -52.039354756999955],
              [-69.95275386599988, -52.007418721999976],
              [-70.03375667399987, -52.00659189899996],
              [-70.25924678599995, -52.00462819399993],
              [-70.48471105999991, -52.002664489999894],
              [-70.71014949599996, -52.00070078499996],
              [-70.93569128499993, -51.99873708099992],
              [-71.1611555579999, -51.99677337699998],
              [-71.38661983299994, -51.99470631899993],
              [-71.61213578299993, -51.99274261399999],
              [-71.83760005699989, -51.99077891099996],
              [-71.91769852799987, -51.99005543999996],
              [-71.96524084499987, -51.97062510199989],
              [-71.9602282319999, -51.92794036899989],
              [-71.94849768099994, -51.896004332999915],
              [-71.95847123199994, -51.867995706999906],
              [-71.98172562699995, -51.844948018999936],
              [-72.0098376059999, -51.82779144299988],
              [-72.07262447099995, -51.77859547899991],
              [-72.14212927199992, -51.73942474299987],
              [-72.18708776899985, -51.72071787499989],
              [-72.28113887599991, -51.70149424199987],
              [-72.30072424399992, -51.69146901499994],
              [-72.31416011599987, -51.67152191199992],
              [-72.32279007999992, -51.6162281289999],
              [-72.33090327999992, -51.59938161199992],
              [-72.35152217599992, -51.583465270999895],
              [-72.3757067469999, -51.579537861999924],
              [-72.40201005099993, -51.57974456799989],
              [-72.42914017799993, -51.576023864999875],
              [-72.45006913299991, -51.55266611799993],
              [-72.42231888899997, -51.5223837279999],
              [-72.35121211799995, -51.475978291999894],
              [-72.34831823699994, -51.46833017999991],
              [-72.34909338499997, -51.45902842199989],
              [-72.35105708799989, -51.449416605999964],
              [-72.35172888199989, -51.440424905999926],
              [-72.34831823699994, -51.43050303099993],
              [-72.34170365399987, -51.42295827199989],
              [-72.3344689539999, -51.41634368899989],
              [-72.3289912519999, -51.40879892999993],
              [-72.32356522599994, -51.390815530999944],
              [-72.32330684499996, -51.33448822099985],
              [-72.32046464099989, -51.31257741299989],
              [-72.31343664599987, -51.29800465899993],
              [-72.27049353099991, -51.25955739299989],
              [-72.25881465699985, -51.24519134599998],
              [-72.25757442199989, -51.230618590999924],
              [-72.27395585099995, -51.216769307999954],
              [-72.34945511899988, -51.18390309699993],
              [-72.38221797799989, -51.1605970259999],
              [-72.40309525599994, -51.12607716899992],
              [-72.40459387299995, -51.10582000699991],
              [-72.39653234899995, -51.09207407599988],
              [-72.36816198799994, -51.066649271999964],
              [-72.35074702999992, -51.046702167999946],
              [-72.33860306799991, -51.036986998999915],
              [-72.32248002199992, -51.03264617899993],
              [-72.29343786699985, -51.029235534999906],
              [-72.2770564379999, -51.00732472799986],
              [-72.26594600499988, -50.96071258499998],
              [-72.25674759999987, -50.87513641399993],
              [-72.2634655359999, -50.83627573699997],
              [-72.28392940299995, -50.810644225999916],
              [-72.31116288299995, -50.78873341799996],
              [-72.3381379809999, -50.76062143999992],
              [-72.34738806199991, -50.74315480599997],
              [-72.34769812099998, -50.728995462999926],
              [-72.34098018399996, -50.71514617899996],
              [-72.30491003399996, -50.664916686999916],
              [-72.30284297799992, -50.64889699399996],
              [-72.32191158099988, -50.641558938999964],
              [-72.34521765199992, -50.63732147199992],
              [-72.38335485899998, -50.62026824999989],
              [-72.5059830329999, -50.60125132199992],
              [-72.54913285399991, -50.61510060599998],
              [-72.61812089099996, -50.66677703799992],
              [-72.66261429899996, -50.667810566999904],
              [-72.6826647549999, -50.65954233799995],
              [-72.73351436399992, -50.62429901099998],
              [-72.75578690599988, -50.616444193999946],
              [-72.77842118399991, -50.61964813199992],
              [-72.90285803299992, -50.66657033299996],
              [-72.9384114179999, -50.68538055399997],
              [-73.01008662899997, -50.736436868999945],
              [-73.05173783399988, -50.75783091199987],
              [-73.09607621299992, -50.770646666999944],
              [-73.13948441599993, -50.77023325599993],
              [-73.17772497599992, -50.749459329999894],
              [-73.18671667499987, -50.71669647199989],
              [-73.18526973599995, -50.6784559119999],
              [-73.19224605399995, -50.64135223399992],
              [-73.2026846929999, -50.62646942199988],
              [-73.24490433799988, -50.58946909599992],
              [-73.25761674099991, -50.57303599099995],
              [-73.26185420799987, -50.55660288499989],
              [-73.26180253199996, -50.499035338999946],
              [-73.27404984599988, -50.44518849699992],
              [-73.27575516799993, -50.42555145199989],
              [-73.27275793499993, -50.384727070999894],
              [-73.27420487499992, -50.36446990999989],
              [-73.28433345599987, -50.33305063899994],
              [-73.30143835499993, -50.29956431099995],
              [-73.32293575099996, -50.268351745999965],
              [-73.34634517499993, -50.243650410999955],
              [-73.36510371999992, -50.23197153799989],
              [-73.4058247479999, -50.21698537199991],
              [-73.53057165599998, -50.140814310999914],
              [-73.54147538199993, -50.11373586099995],
              [-73.53150183199995, -50.08314341199994],
              [-73.48075557499993, -50.02268198599992],
              [-73.47858516499986, -50.00945281999992],
              [-73.48747351099988, -49.99115936299995],
              [-73.50021175199993, -49.97865366699995],
              [-73.55444616799988, -49.947131042999985],
              [-73.57273962499994, -49.93235158299997],
              [-73.56839880399986, -49.920052591999934],
              [-73.55398107999994, -49.90806365999988],
              [-73.54194046999987, -49.8945244349999],
              [-73.53827144399989, -49.87674774199987],
              [-73.53883988499993, -49.86155487099994],
              [-73.53449906399996, -49.84760223399994],
              [-73.48210722501858, -49.81173676818831],
              [-73.46297888199993, -49.78714080799992],
              [-73.4650976159999, -49.759959004999935],
              [-73.1967496125649, -49.682423211773184],
              [-73.13351656426859, -49.62101455329142],
              [-73.05974467458955, -49.5549707924146],
              [-73.05742351085179, -49.475919864136046],
              [-73.08433530448258, -49.42261495378312],
              [-73.11865150724658, -49.39242714177951],
              [-73.10892593437559, -49.31051813919908],
              [-73.09824662299991, -49.272753600999955],
              [-73.09762650599995, -49.266552428999965],
              [-73.16258378099991, -49.2581808469999],
              [-73.17044785899989, -49.25087001999994],
              [-73.18315100099989, -49.2390605669999],
              [-73.1843395599999, -49.21425587999996],
              [-73.17131709799989, -49.1893478389999],
              [-73.10718664599995, -49.1348808799999],
              [-73.09710974099991, -49.12134165499992],
              [-73.0948359789999, -49.108732604999894],
              [-73.09509436099995, -49.09581349699997],
              [-73.0922521569999, -49.08103403699996],
              [-73.07855790299996, -49.0587098189999],
              [-73.0175797119999, -48.998248392999876],
              [-73.01747635999988, -48.998248392999876],
              [-73.00972489499986, -48.990393574999935],
              [-72.96962398299988, -48.96434865299996],
              [-72.9222366939999, -48.95225636799997],
              [-72.82492997299994, -48.94450490299997],
              [-72.78121171099988, -48.93385955799997],
              [-72.74291947499998, -48.91380910299993],
              [-72.67196773299989, -48.86295949299991],
              [-72.61879268499985, -48.819654641999946],
              [-72.59233435099986, -48.7911292519999],
              [-72.58215409399989, -48.76053680399989],
              [-72.57801997899986, -48.721882832999974],
              [-72.58422115099995, -48.6159461469999],
              [-72.60659704699992, -48.56096242299995],
              [-72.61471024599985, -48.51000946099991],
              [-72.57677974399994, -48.4521318569999],
              [-72.53786739199995, -48.43125457699992],
              [-72.4964745689999, -48.41513153099993],
              [-72.4331192629999, -48.400352070999915],
              [-72.41673783399995, -48.39115366599992],
              [-72.38867753099993, -48.36428192199992],
              [-72.37715368699989, -48.350329283999926],
              [-72.37141760299994, -48.346401875999874],
              [-72.35865352399986, -48.34299123099993],
              [-72.3448559169999, -48.34371470199993],
              [-72.31540035099991, -48.350329283999926],
              [-72.30232621299987, -48.34753875699997],
              [-72.29509151199989, -48.3332760619999],
              [-72.30372147699993, -48.31601613399991],
              [-72.31757075999991, -48.29896291099996],
              [-72.32563228399991, -48.285527038999916],
              [-72.3241336669999, -48.26857716799992],
              [-72.31152461799988, -48.2309567259999],
              [-72.3095092369999, -48.211216328999924],
              [-72.33322871999985, -48.09081024199992],
              [-72.34304724199993, -48.07044972699988],
              [-72.37705033399996, -48.06218149799993],
              [-72.38800573699984, -48.05784067799995],
              [-72.39544714399995, -48.050916035999975],
              [-72.39777258299989, -48.04233774799994],
              [-72.3988577879999, -48.033242695999974],
              [-72.4025784909999, -48.02414764399991],
              [-72.4191666269999, -48.00957488999994],
              [-72.43689164299991, -48.00420054099989],
              [-72.45611527599993, -48.00109995599993],
              [-72.47745764199993, -47.99376190199986],
              [-72.50944535399992, -47.972987976],
              [-72.53528356999996, -47.94580617299992],
              [-72.5439135339999, -47.9148003129999],
              [-72.52422481299996, -47.88265757199987],
              [-72.50045365499989, -47.85289194799988],
              [-72.47440873199992, -47.78281870599993],
              [-72.45730383299988, -47.74912567199998],
              [-72.36283931499992, -47.635024108999886],
              [-72.35172888199989, -47.618280944999924],
              [-72.3444425059999, -47.602261250999874],
              [-72.33994665599988, -47.58520802799994],
              [-72.33756953999995, -47.56567433699993],
              [-72.31963781799996, -47.51193084699993],
              [-72.3208780519999, -47.49839162199994],
              [-72.33751786299993, -47.487952982999914],
              [-72.35829178899988, -47.483405455999886],
              [-72.37048742699997, -47.474517109999866],
              [-72.36118566999994, -47.450952656999874],
              [-72.34661291599988, -47.436276549999974],
              [-72.32873286999993, -47.426458027999914],
              [-72.2881668709999, -47.41498586099989],
              [-72.26294877199987, -47.41384897899988],
              [-72.20915360599994, -47.420256855999924],
              [-72.18734615099993, -47.417466328999964],
              [-72.17055131099994, -47.40754445399996],
              [-72.14538488799991, -47.38180959099988],
              [-72.05794836499987, -47.3119430539999],
              [-72.03815629099998, -47.28703501299992],
              [-72.02942297399991, -47.26967173299991],
              [-72.03055985499992, -47.25964650499989],
              [-72.0367093509999, -47.24962127699986],
              [-72.04316890499985, -47.23287811299991],
              [-72.04513260999988, -47.21582488999988],
              [-72.04146358299988, -47.2037326049999],
              [-72.03030147399994, -47.19753143299991],
              [-72.0098376059999, -47.19815155099988],
              [-71.9458105059999, -47.2277104689999],
              [-71.91253088499985, -47.23453175899995],
              [-71.8806982019999, -47.22192270899993],
              [-71.86328324399997, -47.196601256999955],
              [-71.86255977499988, -47.16890268899992],
              [-71.87413529499992, -47.142547709999874],
              [-71.89346227999997, -47.12136037199991],
              [-71.92028234899996, -47.10678761799994],
              [-71.98430944899985, -47.080535989999916],
              [-72.00518672699994, -47.06193247499996],
              [-71.99996740799992, -47.042192076999896],
              [-71.93470007299987, -47.01439015699994],
              [-71.91480464699987, -46.998473815999915],
              [-71.92669022599989, -46.98379770899993],
              [-71.9602282319999, -46.96219695999987],
              [-71.97035681199986, -46.94845102999993],
              [-71.96963334199995, -46.9339816289999],
              [-71.95320023699989, -46.87476043699991],
              [-71.94865270999986, -46.86752573699994],
              [-71.9418314209999, -46.86091115299995],
              [-71.93619868999988, -46.854296569999946],
              [-71.93537186799995, -46.84613169399992],
              [-71.94002274599993, -46.83827687599998],
              [-71.9462239179999, -46.83114552799995],
              [-71.95071976799991, -46.82360076899991],
              [-71.95009964999986, -46.81398895299989],
              [-71.93413163199992, -46.79951955099996],
              [-71.90746659399989, -46.79486867199991],
              [-71.85579016199992, -46.7944552609999],
              [-71.83408605999995, -46.78856414799989],
              [-71.8195649829999, -46.778952330999886],
              [-71.79321000199994, -46.7510470579999],
              [-71.77600174999995, -46.73812794999989],
              [-71.7201912029999, -46.715597025999955],
              [-71.68716996299992, -46.690068867999926],
              [-71.68019364499992, -46.65957977299993],
              [-71.69554154499988, -46.58712941499995],
              [-71.69321610599988, -46.56914601599996],
              [-71.68577469999994, -46.55384979199991],
              [-71.68050370299991, -46.538140156999944],
              [-71.68489619999991, -46.519226582999906],
              [-71.7518688559999, -46.39303273499992],
              [-71.76158402599992, -46.3579961139999],
              [-71.7629276129999, -46.318515319999875],
              [-71.7592585859999, -46.272936705999896],
              [-71.76334102399991, -46.244514668999955],
              [-71.78277136199989, -46.22467091799987],
              [-71.84292272999994, -46.19614552799992],
              [-71.89129186999989, -46.162969257999904],
              [-71.9004902749999, -46.15893849699991],
              [-71.90948197499992, -46.156664733999904],
              [-71.91470129399994, -46.15232391299992],
              [-71.91263423699988, -46.14209197999993],
              [-71.90446936099997, -46.13630421899995],
              [-71.89051672399995, -46.13341033999997],
              [-71.81636104299992, -46.12679575599988],
              [-71.79227982599988, -46.121938170999954],
              [-71.77016231299987, -46.11263641399994],
              [-71.7559512949999, -46.10064748199997],
              [-71.73543575099984, -46.07119191499997],
              [-71.72349849499989, -46.0576526899999],
              [-71.64916319199992, -45.99941415799994],
              [-71.61229081299987, -45.970526224999915],
              [-71.62438309799995, -45.93414601599993],
              [-71.64133296799986, -45.905723978999916],
              [-71.66587927299994, -45.884019876999915],
              [-71.70086421799994, -45.868516946999904],
              [-71.74318721599994, -45.85756154399992],
              [-71.75848343899989, -45.84815643299997],
              [-71.76489131699992, -45.83099985799991],
              [-71.76008540899994, -45.81591033899991],
              [-71.75145544499989, -45.8018543499999],
              [-71.74902665199991, -45.7867648309999],
              [-71.76287593599989, -45.76867807999989],
              [-71.7890758879999, -45.750901387999946],
              [-71.79853267499988, -45.739945983999874],
              [-71.80178828999996, -45.72402964299994],
              [-71.79951452599994, -45.717105000999965],
              [-71.78364986199992, -45.69850148499991],
              [-71.78049759999988, -45.689406433999935],
              [-71.78271968599998, -45.68289520299996],
              [-71.78638871299998, -45.676900735999936],
              [-71.7879390059999, -45.669459329999924],
              [-71.78587194899984, -45.653026223999944],
              [-71.7824096279999, -45.641760762999894],
              [-71.76458125799985, -45.61654266399994],
              [-71.7588451739999, -45.611685078999926],
              [-71.75150712099989, -45.60662078899995],
              [-71.74525427299992, -45.6009363809999],
              [-71.74282548099984, -45.59432179799991],
              [-71.74654618399995, -45.587293802999895],
              [-71.76173905499988, -45.57623504699998],
              [-71.7650980229999, -45.57241099099994],
              [-71.7495950929999, -45.54925994799996],
              [-71.71373164899993, -45.53324025499991],
              [-71.67208044499992, -45.5236284379999],
              [-71.6392142329999, -45.52001108799992],
              [-71.56169958499993, -45.52393849699989],
              [-71.5258361409999, -45.518977558999936],
              [-71.48909419799989, -45.498513691999875],
              [-71.47813879399993, -45.48270070399988],
              [-71.4813427329999, -45.46792124399987],
              [-71.50159989499991, -45.43877573699994],
              [-71.51033321199986, -45.41841522199991],
              [-71.50831783099991, -45.408389993999975],
              [-71.40791052299994, -45.37872772199992],
              [-71.38935868399992, -45.37076955099987],
              [-71.37432084199992, -45.359194030999916],
              [-71.35075638899991, -45.33283904999986],
              [-71.33432328399994, -45.32281382299993],
              [-71.31153397699995, -45.299456074999895],
              [-71.3171667069999, -45.26720998099992],
              [-71.33861242799992, -45.23424041699987],
              [-71.3632620859999, -45.208815612999956],
              [-71.39540482599995, -45.18597462999995],
              [-71.4489416099999, -45.158999531999925],
              [-71.4871821699999, -45.12334279399994],
              [-71.49705236899987, -45.111663919999955],
              [-71.51513911999987, -45.065775247999895],
              [-71.55518835499996, -45.005830586999906],
              [-71.58872635899988, -44.97813201899989],
              [-71.62396968599995, -44.97492807999991],
              [-71.66169348199989, -44.97916554799987],
              [-71.70236283399996, -44.973687845999876],
              [-71.71864090999986, -44.96438608799994],
              [-71.74484086099989, -44.940614929999896],
              [-71.75987870299988, -44.9318299359999],
              [-71.78246130399992, -44.92738576299989],
              [-71.80566402199992, -44.929246113999895],
              [-71.8284533289999, -44.93524057999993],
              [-71.8497440189999, -44.94340545699994],
              [-71.88943151899988, -44.94722951299988],
              [-71.92948075399994, -44.933793639999934],
              [-71.96968501799998, -44.91529347799991],
              [-72.0098376059999, -44.904544779999895],
              [-72.05329748499989, -44.9068185429999],
              [-72.0735029709999, -44.90216766399993],
              [-72.08094437699992, -44.88656138099991],
              [-72.07484655799996, -44.85317840599993],
              [-72.07412308799985, -44.83705535899995],
              [-72.08874751899992, -44.782795104999906],
              [-72.07624182099994, -44.76078094399992],
              [-72.0478197839999, -44.7547864779999],
              [-72.0098376059999, -44.765535175999915],
              [-71.98761673999985, -44.7724598179999],
              [-71.8545499279999, -44.79095998099993],
              [-71.83139888499991, -44.788169453999956],
              [-71.81320878099987, -44.77855763699995],
              [-71.80101314299995, -44.766775410999955],
              [-71.78690547699992, -44.75726694699996],
              [-71.76266922999994, -44.75437306699989],
              [-71.73998327699988, -44.75768035899998],
              [-71.67264888599988, -44.77855763699995],
              [-71.63120438699991, -44.78000457699994],
              [-71.54040889499993, -44.75044565899992],
              [-71.49710404499987, -44.74290089999997],
              [-71.4571064859999, -44.7522026569999],
              [-71.37886836799996, -44.79189015699997],
              [-71.33597692899991, -44.801605325999915],
              [-71.29783972199994, -44.79561085999998],
              [-71.26280310099992, -44.77711069799996],
              [-71.23815344299993, -44.74786183699992],
              [-71.23102209499987, -44.70951792399998],
              [-71.23929032399994, -44.67437794999995],
              [-71.24063391099989, -44.65815154999994],
              [-71.23489782699994, -44.638824563999975],
              [-71.21340043099988, -44.607095234999875],
              [-71.1993961179999, -44.59169565799989],
              [-71.18880244999991, -44.584771015999905],
              [-71.16725337799994, -44.58415089899994],
              [-71.14735795199994, -44.580843606999935],
              [-71.13164831499998, -44.57061167399986],
              [-71.12239823399997, -44.549424336999905],
              [-71.12265661699993, -44.53030405699991],
              [-71.13061478799989, -44.520382181999906],
              [-71.14265539599995, -44.51232065799992],
              [-71.15541947499995, -44.498574726999976],
              [-71.16265417499991, -44.48141815199992],
              [-71.1656514089999, -44.46632863299992],
              [-71.17133581499988, -44.452169290999876],
              [-71.18632198099994, -44.43800994899992],
              [-71.2097830809999, -44.42757130899989],
              [-71.23500117999995, -44.42385060599989],
              [-71.28683264199995, -44.423333841999934],
              [-71.43783117699988, -44.40152638699992],
              [-71.64319331899986, -44.4025599159999],
              [-71.69435298699997, -44.393361511999984],
              [-71.73781286599987, -44.393361511999984],
              [-71.78070430599993, -44.402663268999916],
              [-71.82204545099995, -44.40318003399996],
              [-71.86059606999993, -44.37713511099989],
              [-71.8641617429999, -44.3591517129999],
              [-71.84757360899991, -44.3480929559999],
              [-71.82499100799987, -44.340651549999876],
              [-71.8104182539999, -44.333623554999875],
              [-71.80401037699997, -44.314813334999954],
              [-71.81165848799995, -44.300550638999965],
              [-71.82395747899989, -44.286804707999934],
              [-71.83181229699991, -44.270164896999916],
              [-71.82793656499987, -44.2520781459999],
              [-71.8062841389999, -44.222519225999875],
              [-71.80509558099996, -44.20515594499996],
              [-71.81248531199986, -44.18779266299994],
              [-71.84405961099995, -44.145314635999895],
              [-71.85873571799993, -44.107797546999905],
              [-71.83522294099996, -44.094361673999956],
              [-71.79569047099992, -44.08599009199989],
              [-71.76220414199992, -44.06407928499992],
              [-71.74525991399992, -44.04499811699988],
              [-71.66959997599994, -43.95979624399989],
              [-71.65926468999993, -43.93974578899994],
              [-71.65988480699991, -43.926309915999894],
              [-71.71579870699989, -43.85871714199993],
              [-71.7287178149999, -43.84621144599993],
              [-71.73688268999993, -43.84176727299992],
              [-71.75579626499987, -43.83453257199996],
              [-71.76184240799992, -43.828434753],
              [-71.76427119999997, -43.81727264399996],
              [-71.76080887899994, -43.80962453199989],
              [-71.75564123499993, -43.802699889999914],
              [-71.75295406099988, -43.793604837999936],
              [-71.75502111899996, -43.771383971999896],
              [-71.76204911399986, -43.76890350399992],
              [-71.77553666199992, -43.77562143899986],
              [-71.79713741099991, -43.780789082999945],
              [-71.81548254399988, -43.77438120499991],
              [-71.8192032469999, -43.758051452999965],
              [-71.81341548699993, -43.73944793699992],
              [-71.80323522999996, -43.726012063999875],
              [-71.78638871299998, -43.71722707099988],
              [-71.74432409699995, -43.70523813899993],
              [-71.7257205809999, -43.69738332199998],
              [-71.70918412299991, -43.684360859999956],
              [-71.70365474499991, -43.67164845799991],
              [-71.7106827399999, -43.614080911999864],
              [-71.71430008999988, -43.602195332999926],
              [-71.72375687699986, -43.59475392599991],
              [-71.7661832279999, -43.572016296999934],
              [-71.77274613499986, -43.567468770999895],
              [-71.77884395399994, -43.56147430399996],
              [-71.7834948329999, -43.55537648499991],
              [-71.78979935699991, -43.54938201899998],
              [-71.80070308499995, -43.54421437499988],
              [-71.82344071499995, -43.54214731899991],
              [-71.85113928299995, -43.54256072999992],
              [-71.87382523599993, -43.538943379999935],
              [-71.88152502499992, -43.52447397899991],
              [-71.87826940999994, -43.51920298299997],
              [-71.85878739499995, -43.499255879999865],
              [-71.85863236499992, -43.498635762999896],
              [-71.85832230699992, -43.477448424999935],
              [-71.86881262199998, -43.462565612999896],
              [-71.88612422699987, -43.45336720799989],
              [-71.90622635899985, -43.44923309399988],
              [-71.91650996899992, -43.45088673899991],
              [-71.92694860899988, -43.45481414799988],
              [-71.93733557199988, -43.456881204999945],
              [-71.94741247599993, -43.45316050199993],
              [-71.95511226499991, -43.44354868599993],
              [-71.95077144399994, -43.438587747999875],
              [-71.94208980299987, -43.434246927999894],
              [-71.93676713099993, -43.42670216899994],
              [-71.94105627499991, -43.398383483999865],
              [-71.94095292199998, -43.39176890099995],
              [-71.9348551029999, -43.382777201999914],
              [-71.9274136969999, -43.37812632299995],
              [-71.91955887899988, -43.374302266999905],
              [-71.91232417799989, -43.36779103599994],
              [-71.90917191599993, -43.35972951299995],
              [-71.90736324099996, -43.329653828999966],
              [-71.90173050999991, -43.3220057169999],
              [-71.88943151899988, -43.31921518999994],
              [-71.86400671399988, -43.3175615439999],
              [-71.8243708899999, -43.303402201999944],
              [-71.80509558099996, -43.29999155699991],
              [-71.76086055499994, -43.3069161989999],
              [-71.75068029799988, -43.295340677999945],
              [-71.74840653499987, -43.27704722099989],
              [-71.74954341599997, -43.25916717499993],
              [-71.75140376799988, -43.25100229899991],
              [-71.7569848229999, -43.23529266299994],
              [-71.75765661699995, -43.22537078899994],
              [-71.75512447099987, -43.216379089999904],
              [-71.74566768499992, -43.19922251399994],
              [-71.74298050899998, -43.19012746199988],
              [-71.75016353399994, -43.17245412199988],
              [-71.77016231299987, -43.16139536499996],
              [-71.86188798099988, -43.13318003399989],
              [-72.0098376059999, -43.12036427799991],
              [-72.05443436699991, -43.105378112999944],
              [-72.09608557199994, -43.078506367999935],
              [-72.12931351799995, -43.04222951199998],
              [-72.14853715099989, -42.99871795599995],
              [-72.14212927199992, -42.96368133499993],
              [-72.1194949959999, -42.89856903099995],
              [-72.11267370599992, -42.863842467999916],
              [-72.12125199399986, -42.71966522199993],
              [-72.12564449099995, -42.70385223399994],
              [-72.1398555099999, -42.6698491409999],
              [-72.14145747899994, -42.65568979899986],
              [-72.1324657799999, -42.63171193499994],
              [-72.13158728099995, -42.624063821999954],
              [-72.1346361899999, -42.61476206499994],
              [-72.14543656399994, -42.60049936899996],
              [-72.14843379799996, -42.59264455099992],
              [-72.14321447799992, -42.55709116599988],
              [-72.12264725799994, -42.52990936299997],
              [-72.09282995699994, -42.51078908199989],
              [-72.04192867099991, -42.49104868599993],
              [-72.03918981999996, -42.48123016399995],
              [-72.04575272699995, -42.469861348999956],
              [-72.07520829299995, -42.433791198999955],
              [-72.07665523299994, -42.42335255899992],
              [-72.0606872159999, -42.36888559999993],
              [-72.06988562099991, -42.3499720249999],
              [-72.12156205199994, -42.31302337699995],
              [-72.13370601399996, -42.287598571999936],
              [-72.12471431599991, -42.26331064899995],
              [-72.10301021399991, -42.24088307699995],
              [-72.07717199699988, -42.221246032999915],
              [-72.05893021599994, -42.19757822699998],
              [-72.05138545799988, -42.17049977599993],
              [-72.03991328999987, -42.1446615599999],
              [-72.0098376059999, -42.1247144569999],
              [-71.9774881599999, -42.125334573999865],
              [-71.96136511299991, -42.14486826499996],
              [-71.9480325939999, -42.167295836999955],
              [-71.92379634699992, -42.17690765399996],
              [-71.90948197499992, -42.17225677499991],
              [-71.90080033399997, -42.1630583699999],
              [-71.89372066299993, -42.152619730999874],
              [-71.88426387599986, -42.14424814899989],
              [-71.87180985599989, -42.139700621999864],
              [-71.80132320199994, -42.130295511999904],
              [-71.77310786999996, -42.119960225999904],
              [-71.74944006399994, -42.10435394299995],
              [-71.73626257399985, -42.0838900759999],
              [-71.73956986599987, -42.03190358499997],
              [-71.74385900899992, -42.024358825999926],
              [-71.76251420199989, -42.00740895599992],
              [-71.76925956899987, -41.99960662199996],
              [-71.78065262899992, -41.98642832399992],
              [-71.7798774819999, -41.97226898199996],
              [-71.77507157499991, -41.95635264099994],
              [-71.77439978099991, -41.93919606499989],
              [-71.79403682499995, -41.86746917699989],
              [-71.81465572099995, -41.83780690499994],
              [-71.83894364499986, -41.81331227699988],
              [-71.85687536699993, -41.786130472999986],
              [-71.8585806889999, -41.748613382999906],
              [-71.86896765199992, -41.71554046599991],
              [-71.9259150799999, -41.65301198399992],
              [-71.92596675699991, -41.62293629999995],
              [-71.91185909099997, -41.6102238969999],
              [-71.8777009689999, -41.594927672999944],
              [-71.86348994999992, -41.5844890339999],
              [-71.85325801599996, -41.56733245899994],
              [-71.85687536699993, -41.555963642999956],
              [-71.86808915299989, -41.5451115929999],
              [-71.8806982019999, -41.529712014999916],
              [-71.8880879319999, -41.512762145999915],
              [-71.88870804899997, -41.50015309699998],
              [-71.88121496699995, -41.47038747099991],
              [-71.8788378509999, -41.45106048599986],
              [-71.87981970299995, -41.43669443699994],
              [-71.88431555199989, -41.422948506999916],
              [-71.89232539899987, -41.40537851999994],
              [-71.90395259599993, -41.36765472399989],
              [-71.90224727499995, -41.33592539499996],
              [-71.8777009689999, -41.2697795619999],
              [-71.8733601479999, -41.24921234199991],
              [-71.87594396999992, -41.23360605899997],
              [-71.88844966699992, -41.200326435999926],
              [-71.88943151899988, -41.17975921599994],
              [-71.8814216719999, -41.17262786799991],
              [-71.87134476799986, -41.1667367549999],
              [-71.86586706599988, -41.150407002999955],
              [-71.86261144999989, -41.11464691199994],
              [-71.85398148699994, -41.07888681999992],
              [-71.85284460499994, -41.057182718999925],
              [-71.86715897699992, -41.02018239399989],
              [-71.86740158899991, -41.01023528699993],
              [-71.86767574099986, -40.99899505599993],
              [-71.85144934099995, -40.95765390999989],
              [-71.85144934099995, -40.93832692499994],
              [-71.85987259899994, -40.91341888399997],
              [-71.87087967999994, -40.89574554499997],
              [-71.91067053299994, -40.85006357899995],
              [-71.9212125249999, -40.82773935899989],
              [-71.95557735299985, -40.72035573299992],
              [-71.94963456199994, -40.70929697699991],
              [-71.8733601479999, -40.64707855199991],
              [-71.85310298699991, -40.616382751999964],
              [-71.84772863799995, -40.57958913099988],
              [-71.85093257699992, -40.57028737399993],
              [-71.86059606999993, -40.55943532299999],
              [-71.86183630399998, -40.54972015399994],
              [-71.85878739499995, -40.54238210099996],
              [-71.84085567299988, -40.516027119999904],
              [-71.8041654059999, -40.426420185999945],
              [-71.79641394099991, -40.41453460699992],
              [-71.78473506699993, -40.41133066799995],
              [-71.74225703999988, -40.42083913199993],
              [-71.72928625599988, -40.42135589599988],
              [-71.71905432199989, -40.4129843139999],
              [-71.67848832199988, -40.34022389699993],
              [-71.67404414899994, -40.32410085099994],
              [-71.67368241499986, -40.31376556399994],
              [-71.67518102999986, -40.30394704199996],
              [-71.67926346899986, -40.29526540199991],
              [-71.68670487499989, -40.288547464999894],
              [-71.69874548399986, -40.282759703999915],
              [-71.70546341999989, -40.28193288199989],
              [-71.71848588099994, -40.286273701999875],
              [-71.7239119059999, -40.28999440499989],
              [-71.7257205809999, -40.29526540199991],
              [-71.72995804899995, -40.29857269299991],
              [-71.7426704509999, -40.29650563599995],
              [-71.7500601809999, -40.2915446989999],
              [-71.77073075399991, -40.26715342199988],
              [-71.80194331899992, -40.242348734999936],
              [-71.81599930899992, -40.22715586299991],
              [-71.82375077399993, -40.21010264099996],
              [-71.82235550999985, -40.202867939999905],
              [-71.81357051599986, -40.18819183399992],
              [-71.81207189999995, -40.18467783599996],
              [-71.81672277899992, -40.17454925499992],
              [-71.81646439599984, -40.164420674999874],
              [-71.80902298999993, -40.13382822699995],
              [-71.80478552299988, -40.124629821999946],
              [-71.80287349499986, -40.11605153399992],
              [-71.80711096199991, -40.10840342199994],
              [-71.81455236799994, -40.09961842799996],
              [-71.81403560399988, -40.09290049299993],
              [-71.80070308499995, -40.07967132599994],
              [-71.76675166899994, -40.076880797999976],
              [-71.72168981999991, -40.09383066899997],
              [-71.68370764199997, -40.09899831199989],
              [-71.67094356299992, -40.0607577509999],
              [-71.6731139739999, -40.050319111999954],
              [-71.68076208599987, -40.02913177499991],
              [-71.68282914299994, -40.0180730189999],
              [-71.68050370299991, -40.009494730999876],
              [-71.67440588399995, -40.004430439999894],
              [-71.66727453599992, -40.00050303099992],
              [-71.6620552169999, -39.995128682999876],
              [-71.62484818599998, -39.931049906999945],
              [-71.61663163299994, -39.9098625689999],
              [-71.62117915899998, -39.89508310999989],
              [-71.63451167799991, -39.88350758899993],
              [-71.66923824099985, -39.85921966599993],
              [-71.6793668219999, -39.84785085099995],
              [-71.68458614099993, -39.83348480299995],
              [-71.68691157999984, -39.81157399499999],
              [-71.69197587099993, -39.78997324699992],
              [-71.71047603399995, -39.74749521899989],
              [-71.7143517669999, -39.72630788199993],
              [-71.7087707119999, -39.708427835999956],
              [-71.69879715999988, -39.69023773199993],
              [-71.6940429279999, -39.67349456799988],
              [-71.71605708899997, -39.64476247099988],
              [-71.7187442629999, -39.62336842799995],
              [-71.7143517669999, -39.60135426799988],
              [-71.70541174399997, -39.583577574999936],
              [-71.68975378399992, -39.568384704999914],
              [-71.67740311799986, -39.56848805799994],
              [-71.64109884299995, -39.599999000999915],
              [-71.63239294499994, -39.607555439999956],
              [-71.61782019099988, -39.61665049299992],
              [-71.60076696899995, -39.61954437199992],
              [-71.57642736899993, -39.6146867879999],
              [-71.55498164999992, -39.612826436999896],
              [-71.53668819199993, -39.61572031699997],
              [-71.51999670399991, -39.61499684599997],
              [-71.5035119229999, -39.60166432699995],
              [-71.49565710499988, -39.56559417699995],
              [-71.54195918799988, -39.532314554999914],
              [-71.51565588399993, -39.50130869499989],
              [-71.50144486499994, -39.48828623399994],
              [-71.4824796149999, -39.46110443099987],
              [-71.47043900599994, -39.449115498999916],
              [-71.46165401199994, -39.43381927499986],
              [-71.47762202999988, -39.40219329799996],
              [-71.4765368249999, -39.38296966599994],
              [-71.46056880799995, -39.36715667699994],
              [-71.43907141199992, -39.355994567999915],
              [-71.42020951399988, -39.34214528399994],
              [-71.41204463699995, -39.31796071399988],
              [-71.40196773299994, -39.236001891999905],
              [-71.41266475499992, -39.10060963999992],
              [-71.43100988799992, -39.02598887099994],
              [-71.4302347419999, -38.999117126999934],
              [-71.41576533999998, -38.935348408999914],
              [-71.39990067499988, -38.91054372099997],
              [-71.37070349199993, -38.888012796999945],
              [-71.27975297099991, -38.85018564799988],
              [-71.25375972499995, -38.832719014999924],
              [-71.2409956459999, -38.81845631899995],
              [-71.23603470899994, -38.811635029999906],
              [-71.22802486199987, -38.808844502999946],
              [-71.15283565299984, -38.798819274999914],
              [-71.1368676349999, -38.792204690999924],
              [-71.07865413399989, -38.75706471799988],
              [-71.04842342199987, -38.746626077999935],
              [-71.00997615599991, -38.74631601999995],
              [-70.96723974699992, -38.75076019299986],
              [-70.94504471899998, -38.74724619599991],
              [-70.92949011299996, -38.73577402699989],
              [-70.9153566089999, -38.71220957499989],
              [-70.90954300999994, -38.70642181399991],
              [-70.87936397299984, -38.69463958699991],
              [-70.87383459499992, -38.69143564899994],
              [-70.87233597799991, -38.68161712599996],
              [-70.87698685699988, -38.67500254299998],
              [-70.88298132299991, -38.6688013709999],
              [-70.88579768899987, -38.66053314199995],
              [-70.88510005799989, -38.64947438599994],
              [-70.88342057299994, -38.643066507999905],
              [-70.87300777199991, -38.627770283999936],
              [-70.84773799699994, -38.59996836399998],
              [-70.83758357799988, -38.58446543399988],
              [-70.83430212499988, -38.56441497799993],
              [-70.84866817299991, -38.52762135899994],
              [-70.87982906099995, -38.503023375999945],
              [-70.91729447499995, -38.4829729209999],
              [-70.95047074399986, -38.45940846799991],
              [-70.97375097699998, -38.42468190499996],
              [-71.01669409199985, -38.264691670999895],
              [-71.01974300099997, -38.23430592799994],
              [-71.01788264999996, -38.20371348099992],
              [-71.00896846599994, -38.17033050499995],
              [-71.00865840699996, -38.16764333099992],
              [-71.00896846599994, -38.16505950899992],
              [-71.00997615599991, -38.16226898199996],
              [-71.01614241299987, -38.14369709399995],
              [-71.02305029299987, -38.12289154099996],
              [-71.0235153809999, -38.1045980839999],
              [-71.00997615599991, -38.08785491899994],
              [-71.00741817199992, -38.08227386399993],
              [-71.00664302599992, -38.07669280999991],
              [-71.00741817199992, -38.071008402999965],
              [-71.00997615599991, -38.06553069999997],
              [-71.03744217999989, -38.03659189799991],
              [-71.04645971699992, -38.02026214599998],
              [-71.05204077199994, -37.99928151499998],
              [-71.06113582399993, -37.9784042359999],
              [-71.0875941569999, -37.94016367599991],
              [-71.0949063729999, -37.897375589999896],
              [-71.13325028499992, -37.83846445699989],
              [-71.1850300699999, -37.70606943699991],
              [-71.19226477099994, -37.660904235999936],
              [-71.19076615499995, -37.64002695799988],
              [-71.18389318899997, -37.62586761499992],
              [-71.17242102099996, -37.61449879899993],
              [-71.15717647399993, -37.60250986699988],
              [-71.13309525599988, -37.59062428799986],
              [-71.12792761199995, -37.584423115999954],
              [-71.1273074959999, -37.57264088999996],
              [-71.13955480999994, -37.55486419699993],
              [-71.14172521999993, -37.54390879299994],
              [-71.13640254699988, -37.52437510199994],
              [-71.12084794099985, -37.48634124699991],
              [-71.11769567899998, -37.466497497999924],
              [-71.12307002799994, -37.4432431029999],
              [-71.13640254699988, -37.42505299899996],
              [-71.16828690599993, -37.391566670999865],
              [-71.19474523899993, -37.343507589],
              [-71.2046154379999, -37.315395608999964],
              [-71.20559728999987, -37.29265797899998],
              [-71.1972257079999, -37.27488128699996],
              [-71.15758988499994, -37.23571055099991],
              [-71.14647945199991, -37.214833271999936],
              [-71.14549759999994, -37.19540293399996],
              [-71.14797806799993, -37.175869242999866],
              [-71.14761633299992, -37.15478525799992],
              [-71.13929642799985, -37.13328786199989],
              [-71.12513708499992, -37.12005869499998],
              [-71.08911861199994, -37.10341888499997],
              [-71.1268940839999, -37.07758066799994],
              [-71.13955480999994, -37.06166432699992],
              [-71.1486498619999, -37.01350189199994],
              [-71.1560395919999, -37.00275319399992],
              [-71.18740718599992, -36.9868368529999],
              [-71.2071475839999, -36.97236745199996],
              [-71.20068802999992, -36.971437275999904],
              [-71.18110266199992, -36.975261331999945],
              [-71.16146561799988, -36.9754680379999],
              [-71.14332718899996, -36.96544280999997],
              [-71.13567907799998, -36.951490173999986],
              [-71.14017492699989, -36.9375375369999],
              [-71.16906205299995, -36.92193125399996],
              [-71.1685452879999, -36.9143864949999],
              [-71.16363602799987, -36.90632497099992],
              [-71.16105220499986, -36.89878021299997],
              [-71.16053544199994, -36.8904086299999],
              [-71.15852006099988, -36.88689463299994],
              [-71.15877844199986, -36.88265716499998],
              [-71.1652379969999, -36.872115173999916],
              [-71.17309281499985, -36.866120706999894],
              [-71.18280798399988, -36.86291676799992],
              [-71.19164465399987, -36.858369241999895],
              [-71.19686397399991, -36.84824066199994],
              [-71.19515865099993, -36.83914560899996],
              [-71.18895747999994, -36.83046396899991],
              [-71.1817744549999, -36.82240244599991],
              [-71.17671016499992, -36.814857685999954],
              [-71.15154374199989, -36.76049407899998],
              [-71.14684118699992, -36.74106374099992],
              [-71.14890824399987, -36.703960061999936],
              [-71.14534256999991, -36.68825042699996],
              [-71.12994299399992, -36.676881611999974],
              [-71.1099958909999, -36.678535257999926],
              [-71.09077225799987, -36.68949066099991],
              [-71.07302140299996, -36.696828714999896],
              [-71.0574409589999, -36.6876303099999],
              [-71.05532222599993, -36.67130055699995],
              [-71.06997249399993, -36.60381113699992],
              [-71.06891312699995, -36.56639739999996],
              [-71.06142004499989, -36.52040537499995],
              [-71.04328161599997, -36.48433522499995],
              [-71.02781930399993, -36.48116838999994],
              [-71.00997615599991, -36.47751393599991],
              [-70.9896414799999, -36.48330169699997],
              [-70.97103796399995, -36.48547210699988],
              [-70.95315791799987, -36.48247487399995],
              [-70.93496781399995, -36.47255299899986],
              [-70.92331477899998, -36.45674000999996],
              [-70.91626094599985, -36.419326272999896],
              [-70.90778601099996, -36.40516693099994],
              [-70.89037105399993, -36.40041269999995],
              [-70.8685894379999, -36.404650166999915],
              [-70.82882442199991, -36.41984303799994],
              [-70.82032364999989, -36.42459726999992],
              [-70.81432918399986, -36.429971618999986],
              [-70.80719783599992, -36.43338226299991],
              [-70.71865026899988, -36.414572041999904],
              [-70.70890926099992, -36.40320322699992],
              [-70.70859920299992, -36.379948832999986],
              [-70.7135859789999, -36.3681666059999],
              [-70.72911474599991, -36.34687591499991],
              [-70.73221533199995, -36.33426686599998],
              [-70.72968318699986, -36.32548187199998],
              [-70.71265580299993, -36.30026377299994],
              [-70.71159643599995, -36.29168548499992],
              [-70.71376684599994, -36.2835206099999],
              [-70.71487788899995, -36.275252380999945],
              [-70.71051123099994, -36.265847269999895],
              [-70.70312150099994, -36.260059508999916],
              [-70.69389725799994, -36.2566488639999],
              [-70.67503535999992, -36.252411396999946],
              [-70.66162532599986, -36.244556578999905],
              [-70.62467667699994, -36.20517913899991],
              [-70.61994828299996, -36.20228525799992],
              [-70.60865698299997, -36.197944437999936],
              [-70.6043678389999, -36.19463714599995],
              [-70.60131892999988, -36.18812591499997],
              [-70.6002854009999, -36.175206807999956],
              [-70.59832169599989, -36.16962575299995],
              [-70.5884773359999, -36.15019541399997],
              [-70.58142350299988, -36.14316741899995],
              [-70.56832352799992, -36.13903330499994],
              [-70.54530167599995, -36.14275400799994],
              [-70.49912878499993, -36.16363128599993],
              [-70.4711459959999, -36.16249440499992],
              [-70.45148311399987, -36.15226247199993],
              [-70.43510168499992, -36.13634613099991],
              [-70.43074804399996, -36.129402117999916],
              [-70.42272517999996, -36.11660573299994],
              [-70.41068456999989, -36.08373952199992],
              [-70.40430253199986, -36.074437763999896],
              [-70.38693924999984, -36.05872812899992],
              [-70.38032466699994, -36.046015726999954],
              [-70.38368363499987, -36.03051279699994],
              [-70.41272578999994, -35.96891448999992],
              [-70.4125707609999, -35.95733896899988],
              [-70.40502600099995, -35.93832204199991],
              [-70.39959997599988, -35.93274098699989],
              [-70.39146093799988, -35.927366637999924],
              [-70.38482051599996, -35.921165465999934],
              [-70.38368363499987, -35.91320729599997],
              [-70.39073746799997, -35.905869241999895],
              [-70.41236405399985, -35.9081430049999],
              [-70.42078731299992, -35.90380218499992],
              [-70.42024471099998, -35.8683521519999],
              [-70.3573286539999, -35.815228779999956],
              [-70.36156612199994, -35.78308603999993],
              [-70.37639725799997, -35.76138193799993],
              [-70.42153662099994, -35.6596827189999],
              [-70.42272517999996, -35.643869730999896],
              [-70.41226070199991, -35.607386169999884],
              [-70.41197648199994, -35.58743906599996],
              [-70.4181001389999, -35.54754486099992],
              [-70.40822993999993, -35.5062037149999],
              [-70.41642065499985, -35.491114195999984],
              [-70.43107092299994, -35.47778167699997],
              [-70.44546280999992, -35.46114186599995],
              [-70.46918229199989, -35.3946859739999],
              [-70.47176611399988, -35.37938974999993],
              [-70.46037146099988, -35.371018167999964],
              [-70.44060522499993, -35.36678069999991],
              [-70.42838374899989, -35.35706553099996],
              [-70.43975256399989, -35.332157490999904],
              [-70.47528011099985, -35.31407073999989],
              [-70.52070369499998, -35.30962656699998],
              [-70.56041703399987, -35.29836110499993],
              [-70.57889135799991, -35.25970713299992],
              [-70.54289872299992, -35.20927093499992],
              [-70.38662919099994, -35.16668955399986],
              [-70.36851660199994, -35.09713307699994],
              [-70.37244657199994, -35.02738854499992],
              [-70.37259903999984, -35.024682718999955],
              [-70.35371130399992, -34.953265888999866],
              [-70.27671341999988, -34.79823659299993],
              [-70.28069250499996, -34.7863510129999],
              [-70.29283646699989, -34.777566019999924],
              [-70.30751257399996, -34.76309661899998],
              [-70.31629756699994, -34.74562998399993],
              [-70.30945043999989, -34.73973887099994],
              [-70.29312068699994, -34.736534932999874],
              [-70.27314774599992, -34.72702646899998],
              [-70.25221879099993, -34.695813903999905],
              [-70.24242610699989, -34.61943613699995],
              [-70.22782751499992, -34.585329690999885],
              [-70.20919816099985, -34.56796640999997],
              [-70.1677795009999, -34.53840749099993],
              [-70.15072627799995, -34.518150329999926],
              [-70.12837622099988, -34.4694711299999],
              [-70.11429439299985, -34.447353616999905],
              [-70.06757889899987, -34.41459075999998],
              [-70.05869055199994, -34.39578053799998],
              [-70.05943986099996, -34.37293955499989],
              [-70.06365148899991, -34.34369069399993],
              [-70.06450415099994, -34.313511657999925],
              [-70.05757950899994, -34.291187438999955],
              [-70.04817621499987, -34.283461794999965],
              [-70.04034541799987, -34.27702809699991],
              [-69.98923742799988, -34.26906992599996],
              [-69.96820511999996, -34.27000010199991],
              [-69.94748286999993, -34.27382415799994],
              [-69.91156774999988, -34.28457285599997],
              [-69.90593501799995, -34.28074879999993],
              [-69.90484981299994, -34.27382415799994],
              [-69.90229182999985, -34.26865651499995],
              [-69.83276118999996, -34.24323170999993],
              [-69.82888545799992, -34.23330983399994],
              [-69.8373087169999, -34.20933196999992],
              [-69.86211340399984, -34.17016123499988],
              [-69.8685987959999, -34.15672536199993],
              [-69.87324967499987, -34.139982197999885],
              [-69.87237117499993, -34.13099049799993],
              [-69.86844376699986, -34.122618916999954],
              [-69.86397375599995, -34.10752939899996],
              [-69.85544714399992, -34.03115163199992],
              [-69.85580887899994, -33.984746195],
              [-69.8656015629999, -33.95766774499994],
              [-69.88428259299988, -33.95415374799998],
              [-69.9003022869999, -33.95901133199992],
              [-69.90955236799994, -33.955704039999915],
              [-69.90805375199992, -33.927902119999956],
              [-69.89864864099988, -33.88893808999997],
              [-69.8972792159999, -33.871368103],
              [-69.91477168799995, -33.79354339599986],
              [-69.91425492399992, -33.77194264799989],
              [-69.90650345899991, -33.76026377399991],
              [-69.87255204299987, -33.73742278999991],
              [-69.86004634599988, -33.7263640339999],
              [-69.85968461199988, -33.71137786799993],
              [-69.88678889999994, -33.678718362999945],
              [-69.89536718799988, -33.6622852579999],
              [-69.89392024799989, -33.642751566999976],
              [-69.87293961599988, -33.58601084399996],
              [-69.8737664389999, -33.5754688519999],
              [-69.87707373099991, -33.566787210999934],
              [-69.87883072899987, -33.55800221699987],
              [-69.87529089399993, -33.54735687199987],
              [-69.8692705899999, -33.542912699999945],
              [-69.84927181099994, -33.53650482099991],
              [-69.84146866899994, -33.53278411799991],
              [-69.83813553899992, -33.52110524499993],
              [-69.83415645299993, -33.4745964559999],
              [-69.83090083799996, -33.458163350999925],
              [-69.82059138999995, -33.44286712699997],
              [-69.79446895399985, -33.41465179399991],
              [-69.78674332699995, -33.399252217999916],
              [-69.78767350299992, -33.379408466999934],
              [-69.8056827389999, -33.34426849399998],
              [-69.81389929299993, -33.289491475999895],
              [-69.83684362899987, -33.26572031699993],
              [-69.86968400099991, -33.24959726999995],
              [-69.90528906299997, -33.23822845399988],
              [-69.94055822799996, -33.24287933399994],
              [-69.98386307799993, -33.294452412999945],
              [-70.01001135299992, -33.29910329199991],
              [-70.04112056599988, -33.23895192499997],
              [-70.05179174799989, -33.22530934599986],
              [-70.08569148799998, -33.201331481999944],
              [-70.10083268199989, -33.186862080999916],
              [-70.10946264699993, -33.169602151999925],
              [-70.10977270499993, -33.14944834299986],
              [-70.09217687999995, -33.09177744599988],
              [-70.09548417199994, -33.07131357899992],
              [-70.1052768559999, -33.054880472999955],
              [-70.10610066299995, -33.05259252099991],
              [-70.11119380799991, -33.038447366999975],
              [-70.10295141699987, -33.018293558999915],
              [-70.08892126499995, -33.00826833099998],
              [-70.05649430399987, -33.00134368899991],
              [-70.04248998999995, -32.99266204799994],
              [-70.03424759899991, -32.97695241299998],
              [-70.0242740489999, -32.93478444399992],
              [-70.01714270099987, -32.91659433999989],
              [-70.00016699299994, -32.88899912499997],
              [-70.00021866899996, -32.87659678099992],
              [-70.0143521729999, -32.867501729999944],
              [-70.0367797449999, -32.85975026399993],
              [-70.05432389399996, -32.85075856499989],
              [-70.0872676189999, -32.823266702999916],
              [-70.14002925699995, -32.76828297899989],
              [-70.15573889199993, -32.738414001999956],
              [-70.18044022699993, -32.630203551999955],
              [-70.18108618199992, -32.60756927499992],
              [-70.17876074299997, -32.58896575999995],
              [-70.1758926999999, -32.58049082499987],
              [-70.17057002799996, -32.572739358999954],
              [-70.14710892799988, -32.57211924299989],
              [-70.13772965499993, -32.56901865599994],
              [-70.1578834639999, -32.54245696999992],
              [-70.15979549199992, -32.52519704199993],
              [-70.15814184599986, -32.506490172999946],
              [-70.1608290209999, -32.4853028359999],
              [-70.17248205699988, -32.464942321999956],
              [-70.18852758899993, -32.45357350599997],
              [-70.22725907399985, -32.434659932999935],
              [-70.24531998699987, -32.40396413099998],
              [-70.24237443099986, -32.330273538999876],
              [-70.25611904399997, -32.31427788099995],
              [-70.26919449899995, -32.2990609739999],
              [-70.29250056999987, -32.290999450999905],
              [-70.30970882199995, -32.28831227599997],
              [-70.32180110799993, -32.28014739999995],
              [-70.32973343899991, -32.25554941799996],
              [-70.3297851159999, -32.24686777799991],
              [-70.32691707399994, -32.22878102599989],
              [-70.32725296999993, -32.21968597399993],
              [-70.33082360899994, -32.20958811899993],
              [-70.33130957099993, -32.208213805999904],
              [-70.34309179699991, -32.18692311599992],
              [-70.3455205899999, -32.17472747799991],
              [-70.34391861999995, -32.16573577899996],
              [-70.33686478699994, -32.14919931999988],
              [-70.3352369799999, -32.140000914999874],
              [-70.3389576829999, -32.13338633199989],
              [-70.35559749399991, -32.12263763399996],
              [-70.35991247599989, -32.11302581799994],
              [-70.35924068199992, -32.0936988319999],
              [-70.36120438699993, -32.08584401399996],
              [-70.36805151399992, -32.07705902099988],
              [-70.3846138109999, -32.06196950299997],
              [-70.38908382199992, -32.05308115599986],
              [-70.38748185299988, -32.041712340999965],
              [-70.37332250999992, -32.03039520299998],
              [-70.35231604099994, -32.0333407589999],
              [-70.31004471899985, -32.0477068079999],
              [-70.28469742899995, -32.04677663199995],
              [-70.27542150899984, -32.037784933],
              [-70.2672049569999, -32.00093963699989],
              [-70.25772233099994, -31.98616017599997],
              [-70.2476712649999, -31.974584655999934],
              [-70.24170263699997, -31.961458841999956],
              [-70.24446732699994, -31.942235208999932],
              [-70.25568111199988, -31.925698750999942],
              [-70.27500809799992, -31.90699188299996],
              [-70.29624711199989, -31.890972187999907],
              [-70.31332617299992, -31.8820838419999],
              [-70.35722530099986, -31.87650278699998],
              [-70.39399308299994, -31.87763966899989],
              [-70.42828039599996, -31.870094909999935],
              [-70.4641438399999, -31.83826222799989],
              [-70.47522843399992, -31.82007212399995],
              [-70.48398758999991, -31.79764455199995],
              [-70.48848343899994, -31.773873392999903],
              [-70.48631302899994, -31.7311886599999],
              [-70.49677750699988, -31.714548847999964],
              [-70.52721492499995, -31.684266458999943],
              [-70.58026078299986, -31.592282409999953],
              [-70.58976924699994, -31.567684427999964],
              [-70.59137121599989, -31.549597675999863],
              [-70.58137182599995, -31.505672708999924],
              [-70.57790950599991, -31.468879088999927],
              [-70.57899470999993, -31.431982116999905],
              [-70.57537735999995, -31.412965189999937],
              [-70.55778153499995, -31.381752623999944],
              [-70.5546551109999, -31.362942402999934],
              [-70.55990026899994, -31.341651712999948],
              [-70.56721248399992, -31.323048196999906],
              [-70.5689694829999, -31.304237975999897],
              [-70.54680029299988, -31.26455047599991],
              [-70.54289872299992, -31.24677378299988],
              [-70.54336381099995, -31.208119811999964],
              [-70.54140010599991, -31.188172708999957],
              [-70.5359224039999, -31.17256642699992],
              [-70.47980179899989, -31.096705423999907],
              [-70.46778702799992, -31.08936737099991],
              [-70.44809830699995, -31.097635598999958],
              [-70.44060522499993, -31.11882293699992],
              [-70.43561844999996, -31.14135386199993],
              [-70.42339697299994, -31.153756204999908],
              [-70.40864335099994, -31.150035501999895],
              [-70.39306290699992, -31.13763315899992],
              [-70.3808931079999, -31.121613463999964],
              [-70.3723923339999, -31.092157897999968],
              [-70.36249629799991, -31.073037617999972],
              [-70.33978450599992, -31.041721699999954],
              [-70.3209484459999, -31.03366017599997],
              [-70.27831538899991, -31.03944793699995],
              [-70.26655900099993, -31.036450703999932],
              [-70.26759252999992, -31.02384165399991],
              [-70.27986568299994, -31.01030242899992],
              [-70.30859777799995, -30.988184916999913],
              [-70.32513423699993, -30.97164845799992],
              [-70.33521114099997, -30.956042174999894],
              [-70.33921606499987, -30.938162129999924],
              [-70.31947566799991, -30.80080617199991],
              [-70.30503210499998, -30.76545949299991],
              [-70.30007116799993, -30.75812143999991],
              [-70.2822944749999, -30.737760924999876],
              [-70.27617081699995, -30.725565286999952],
              [-70.27661006699987, -30.715643412999967],
              [-70.2793489179999, -30.705618183999945],
              [-70.27986568299994, -30.69311248799994],
              [-70.27598994999988, -30.673062031999905],
              [-70.27020218899992, -30.657249043999897],
              [-70.25077185099994, -30.62655324299996],
              [-70.23539811199996, -30.591619974999958],
              [-70.21710465599989, -30.51513885499989],
              [-70.19697668499992, -30.486820169999902],
              [-70.17969091899994, -30.477105000999956],
              [-70.1637745779999, -30.470180358999883],
              [-70.15119136599989, -30.459741718999936],
              [-70.1439308269999, -30.43958791099996],
              [-70.14871089699992, -30.418710631999986],
              [-70.17377396699993, -30.382227070999974],
              [-70.17341223199992, -30.364657084999905],
              [-70.14692806099993, -30.35390838699989],
              [-70.06427160699988, -30.38925506599989],
              [-70.030191, -30.397109882999914],
              [-69.99445674599991, -30.388118183999964],
              [-69.96458776899988, -30.374785664999948],
              [-69.93802608299987, -30.355562031999924],
              [-69.91213619099992, -30.329517109999955],
              [-69.90280859399991, -30.312670592999964],
              [-69.8998630369999, -30.29437713599991],
              [-69.89808020099991, -30.256549987999932],
              [-69.8940236009999, -30.238049824999905],
              [-69.89074214699991, -30.228954772999927],
              [-69.88624629799989, -30.220996601999957],
              [-69.87707373099991, -30.213141784999934],
              [-69.85741084899988, -30.20549367299995],
              [-69.84896175099996, -30.199085794999917],
              [-69.83575842299987, -30.161878762999905],
              [-69.84973689899988, -30.126635436999933],
              [-69.88071691999988, -30.099763691999925],
              [-69.91867325899992, -30.08777475999996],
              [-69.9576631269999, -30.092735696999924],
              [-69.97324357099984, -30.08942840499992],
              [-69.98037491899987, -30.07247853599992],
              [-69.97562068699997, -30.058629251999946],
              [-69.94128169799987, -30.01305063899987],
              [-69.92797501699994, -29.976773782999913],
              [-69.92218725699988, -29.939566751999905],
              [-69.91559851099987, -29.80562143999991],
              [-69.92908605999995, -29.718288268999885],
              [-69.92935283799989, -29.71787711599997],
              [-69.93787105399991, -29.704749043999897],
              [-69.96350256399998, -29.685525410999972],
              [-69.97319189499993, -29.666095071999905],
              [-69.97293351299996, -29.643150735999953],
              [-69.96890275099986, -29.61307505299989],
              [-69.96846350099995, -29.583309427999907],
              [-69.99161454299991, -29.488121439999944],
              [-69.99613623099995, -29.47644256599996],
              [-70.0021823729999, -29.465590514999917],
              [-70.01001135299992, -29.45608205199993],
              [-70.01954565399993, -29.404405618999903],
              [-70.02698706099994, -29.38993621799996],
              [-70.03574621599992, -29.376913756999926],
              [-70.04261918099988, -29.363064473999955],
              [-70.0444795329999, -29.34611460399995],
              [-70.04065547799985, -29.29753875799996],
              [-70.03112117599994, -29.277178242999923],
              [-70.01001135299992, -29.26642954499991],
              [-69.99985693399987, -29.262915547999953],
              [-69.9893407799999, -29.25733449299993],
              [-69.98032324199994, -29.249996438999943],
              [-69.97474218799994, -29.240798033999937],
              [-69.97616328999993, -29.23345998099994],
              [-69.98810054599997, -29.220024109],
              [-69.98949580899995, -29.214443054999975],
              [-69.98505163699994, -29.20834523599993],
              [-69.9800648609999, -29.20586476699995],
              [-69.97505224599993, -29.204314472999926],
              [-69.95936844899995, -29.192118834999917],
              [-69.9326000579999, -29.17692596499998],
              [-69.9219805509999, -29.16803761799987],
              [-69.9152884529999, -29.156152037999945],
              [-69.91472001199992, -29.148813984999947],
              [-69.9109476319999, -29.14323293099993],
              [-69.89448868899984, -29.13723846499991],
              [-69.84436254899992, -29.12928029399994],
              [-69.82232255099993, -29.120081887999945],
              [-69.80392574099992, -29.098687845999933],
              [-69.79723364299991, -29.076673684999946],
              [-69.79576086499992, -29.050111998999924],
              [-69.80167781599991, -28.99998585999991],
              [-69.80630285699988, -28.980142109999917],
              [-69.80661291499987, -28.959884948999914],
              [-69.80278885999991, -28.939937845999893],
              [-69.79506323299992, -28.920817565999897],
              [-69.78539973999989, -28.90583140099993],
              [-69.77312658699987, -28.892705586999867],
              [-69.76731298899998, -28.884230651999957],
              [-69.76643448999994, -28.87585906999989],
              [-69.76682206199985, -28.867590840999938],
              [-69.76483251999991, -28.858599141999903],
              [-69.73584204099993, -28.812400410999942],
              [-69.73276729299991, -28.794313658999926],
              [-69.73638464399997, -28.772402851999885],
              [-69.75106075099987, -28.729821471999912],
              [-69.7559183359999, -28.707703958999986],
              [-69.7533861899999, -28.67339080799988],
              [-69.74085465599998, -28.640627949999967],
              [-69.72207027199988, -28.610655618999928],
              [-69.70088293499992, -28.584403991999892],
              [-69.69320898499984, -28.579753112999924],
              [-69.68512162299996, -28.577789408999905],
              [-69.67840368699993, -28.57386199899993],
              [-69.67483801299994, -28.563113300999916],
              [-69.6723575449999, -28.457693379999867],
              [-69.65404516399985, -28.40099354799996],
              [-69.65303055899992, -28.397852070999903],
              [-69.60732275399991, -28.356304219999913],
              [-69.5535275879999, -28.31785695399988],
              [-69.51009354699988, -28.267524108999893],
              [-69.50123103899998, -28.25036753299993],
              [-69.49050817899987, -28.19838104199991],
              [-69.47616796899987, -28.18794240299988],
              [-69.45606583699993, -28.195797220999907],
              [-69.43562780799996, -28.208509622999955],
              [-69.4203057449999, -28.212643737999983],
              [-69.4118824869999, -28.202515156999937],
              [-69.38986832699993, -28.162000833999926],
              [-69.36715653599995, -28.130374857999925],
              [-69.33082800299988, -28.05244679799995],
              [-69.31175939999991, -28.036530456999927],
              [-69.31093257699987, -28.029295755999968],
              [-69.31377478099995, -28.022681171999878],
              [-69.31310298699987, -28.014516296999943],
              [-69.30323278799989, -27.999530130999887],
              [-69.29106298899998, -27.98940155099993],
              [-69.27514664799986, -27.982890319999868],
              [-69.21589961799995, -27.96852427099995],
              [-69.19019059299987, -27.951367695999892],
              [-69.17300817899991, -27.924082539999887],
              [-69.13406045699995, -27.772343536999884],
              [-69.12432897999989, -27.734430032999953],
              [-69.11820532299993, -27.722131041999916],
              [-69.10833512399992, -27.7158265179999],
              [-69.08110164399994, -27.703837585999935],
              [-69.07583064799991, -27.69618947399995],
              [-69.08001643899993, -27.68151336599996],
              [-69.08745784599995, -27.66921437599993],
              [-69.09321976799993, -27.65650197399988],
              [-69.09234126899989, -27.640172220999943],
              [-69.08554581799984, -27.6293201699999],
              [-69.0629890539999, -27.609993183999933],
              [-69.05386816399994, -27.59965789699993],
              [-69.02857255099985, -27.55128875699998],
              [-69.01901240999987, -27.524313659999862],
              [-69.01627355999992, -27.5001290889999],
              [-69.01989091099989, -27.48689992299998],
              [-69.02051102699997, -27.473360697999922],
              [-69.01741044199991, -27.460441588999913],
              [-69.01014990299987, -27.448866067999873],
              [-68.99358760599995, -27.437703958999933],
              [-68.95862849999986, -27.421064147999914],
              [-68.94263464399992, -27.40886850999989],
              [-68.93144669599988, -27.39522593199989],
              [-68.88305171699992, -27.294973652999943],
              [-68.87930517599992, -27.27854054799988],
              [-68.88137223299987, -27.23905975299995],
              [-68.87971858799992, -27.22148976699988],
              [-68.87075272699988, -27.198442077999914],
              [-68.82902400699993, -27.13601694699996],
              [-68.81432206199995, -27.120307311999895],
              [-68.80109289599994, -27.11276255299994],
              [-68.76429927599986, -27.104597676999916],
              [-68.71861730999984, -27.106664733999892],
              [-68.68285721899991, -27.12692189499998],
              [-68.64947424299996, -27.151209818999888],
              [-68.61071691899991, -27.165679219999916],
              [-68.58586055499995, -27.162785338999925],
              [-68.57537023999993, -27.14934946699988],
              [-68.56916906799992, -27.129505716999887],
              [-68.55738684099992, -27.10738820399989],
              [-68.53976517799995, -27.09033498099994],
              [-68.51800939899994, -27.07689910899998],
              [-68.49423824099998, -27.068630879999944],
              [-68.4430785729999, -27.06666717499992],
              [-68.4221496179999, -27.062016296999943],
              [-68.37734615099993, -27.04444630899988],
              [-68.36649410099997, -27.043516132999926],
              [-68.33776200399987, -27.045583190999892],
              [-68.33047562699988, -27.04496307299992],
              [-68.32840856999991, -27.03741831399988],
              [-68.33114741999987, -27.012200214999922],
              [-68.3291320399999, -27.000107929999928],
              [-68.32380936699988, -26.980987649999932],
              [-68.30742793799993, -26.94460744199995],
              [-68.30210526499988, -26.92662404299996],
              [-68.30536088099987, -26.897995300999895],
              [-68.32014034099987, -26.870090026],
              [-68.51020625799993, -26.62907114699992],
              [-68.54420935099995, -26.589280293999906],
              [-68.57015091999992, -26.5506263219999],
              [-68.5874108489999, -26.5082516479999],
              [-68.59531734299995, -26.457298685999945],
              [-68.59392207899987, -26.37864715599997],
              [-68.58735917199988, -26.338029479999932],
              [-68.57516353399987, -26.303509623999958],
              [-68.54612137899997, -26.269093118999905],
              [-68.41987585499987, -26.179279479999906],
              [-68.40902380499992, -26.144242857999885],
              [-68.41708532699991, -26.09359995499993],
              [-68.48638342299995, -25.836561380999896],
              [-68.49847570799992, -25.754912617999906],
              [-68.5075707609999, -25.728867695999924],
              [-68.52188513199988, -25.705613301999904],
              [-68.54131547099988, -25.687319844999934],
              [-68.55935054599988, -25.66303192099994],
              [-68.56095251499991, -25.635229999999893],
              [-68.55960892699994, -25.60856496199993],
              [-68.56880733299994, -25.5877910359999],
              [-68.5550097249999, -25.572598163999956],
              [-68.56658524599993, -25.5517208859999],
              [-68.6029137779999, -25.510689798999948],
              [-68.60823644999994, -25.492913105999918],
              [-68.60994177299992, -25.474206237999937],
              [-68.60596268699993, -25.43699920699993],
              [-68.55422846999991, -25.291191962999903],
              [-68.5160456959999, -25.18357798299988],
              [-68.49646779899987, -25.159996516999882],
              [-68.49304968299995, -25.155879414999944],
              [-68.4740327559999, -25.145440774999912],
              [-68.45837479699992, -25.144924010999958],
              [-68.44194169099995, -25.14812794999993],
              [-68.42075435399991, -25.1487480669999],
              [-68.39920528199985, -25.144820658999933],
              [-68.37920650199993, -25.13675913499995],
              [-68.36664912899991, -25.12342661499993],
              [-68.3673725999999, -25.103376158999964],
              [-68.3889733479999, -25.077537943999957],
              [-68.42049597199994, -25.051182962999903],
              [-68.4435436609999, -25.02110727899992],
              [-68.44013301599998, -24.98369354199987],
              [-68.43739416599993, -24.974081725999937],
              [-68.4398229579999, -24.967570495999965],
              [-68.44493892499989, -24.961576029999947],
              [-68.45000321499995, -24.95392791699996],
              [-68.45387894799993, -24.949277037999906],
              [-68.46514440899998, -24.941422220999883],
              [-68.46907181799995, -24.936771341999915],
              [-68.4696402589999, -24.93201710999992],
              [-68.46860672999992, -24.92695281999994],
              [-68.46684973199984, -24.923128764],
              [-68.46571284999993, -24.922095234999915],
              [-68.47305090399993, -24.907935892999973],
              [-68.47930375199991, -24.899564309999903],
              [-68.48994909699991, -24.89584360699989],
              [-68.51020625799993, -24.895533548999907],
              [-68.51759598799993, -24.890055846999914],
              [-68.54157385299993, -24.877446797999895],
              [-68.55103063999991, -24.868765156999928],
              [-68.55516475499994, -24.862150572999937],
              [-68.57800573799994, -24.80871714299991],
              [-68.5785741789999, -24.79166391999989],
              [-68.5723730069999, -24.769856465999865],
              [-68.52131669099992, -24.67528859399995],
              [-68.51020625799993, -24.641285501999917],
              [-68.50803584899992, -24.62681610099989],
              [-68.50369502799995, -24.61234669999996],
              [-68.49553015099994, -24.601804707999904],
              [-68.48183589699991, -24.598807474999973],
              [-68.46281896999994, -24.623302103999933],
              [-68.45150183199988, -24.629296569999966],
              [-68.44437048399993, -24.61017628999987],
              [-68.43770422399993, -24.57968719499989],
              [-68.39765498899993, -24.500518899999875],
              [-68.3798266199999, -24.491113789999915],
              [-68.36241166199994, -24.49421437599996],
              [-68.3448933519999, -24.499795430999967],
              [-68.32680659999988, -24.49824513699987],
              [-68.31404252199991, -24.487289733999972],
              [-68.27683548999991, -24.432306009999934],
              [-68.26712032099996, -24.4041940299999],
              [-68.26241776499998, -24.396752623999888],
              [-68.24448604399993, -24.38538380999998],
              [-68.21105139199994, -24.37246470099997],
              [-68.16082189999989, -24.353137715999935],
              [-68.11064408399994, -24.333810729999882],
              [-68.06046626799991, -24.3143803909999],
              [-68.01023677599997, -24.29505340599995],
              [-67.8852314859999, -24.24389373699995],
              [-67.76022619699995, -24.192734069999943],
              [-67.63522090699988, -24.141471048999918],
              [-67.51026729399993, -24.09041473399995],
              [-67.50117224199994, -24.087107441999947],
              [-67.48122513899995, -24.080079447999935],
              [-67.46122635899991, -24.072948099999905],
              [-67.45218298399993, -24.069640807999903],
              [-67.41228877799992, -24.05558481799997],
              [-67.36236934499993, -24.03036671899993],
              [-67.3397867429999, -24.000601094999936],
              [-67.31813431899991, -23.935178730999965],
              [-67.28473211096949, -23.834136437456095],
              [-67.2513287399999, -23.73309062599988],
              [-67.24790604699984, -23.72273691799994],
              [-67.17767777499995, -23.510243428999914],
              [-67.10744950399987, -23.297749938999885],
              [-67.03727290899991, -23.08535980199987],
              [-67.0195478919999, -23.03192637099994],
              [-67.01396683799987, -23.00071380599988],
              [-67.19390417499997, -22.82222340899996],
            ],
          ],
          [
            [
              [-68.65413543186631, -54.886244564385144],
              [-68.64234289599992, -54.85365325899993],
              [-68.64199785099993, -54.799167575999945],
              [-68.63231360599991, -54.805352471999925],
              [-68.60936438699991, -54.832289320999905],
              [-68.59947669199994, -54.84140390399995],
              [-68.58055579299992, -54.85475025799991],
              [-68.57184811099995, -54.86272551899992],
              [-68.56822669199994, -54.87835051899992],
              [-68.58726966099994, -54.88534921699994],
              [-68.65413543186631, -54.886244564385144],
            ],
          ],
          [
            [
              [-68.64188192676619, -54.78297131557072],
              [-68.6400970499999, -54.51476787199995],
              [-68.63831213399993, -54.24655853299988],
              [-68.63655513599994, -53.97877126099991],
              [-68.63474646099985, -53.710880634999924],
              [-68.63298946099988, -53.442886657999914],
              [-68.63123246299989, -53.17509938599995],
              [-68.6293721109999, -52.90720876099996],
              [-68.6276167764778, -52.639571698869695],
              [-68.59487870999993, -52.654229424999926],
              [-68.58580481699994, -52.662774346999925],
              [-68.56602942599994, -52.69491952899995],
              [-68.55785071499992, -52.70427825299993],
              [-68.49274654899995, -52.76287200299993],
              [-68.42813066299993, -52.834649346999925],
              [-68.41030839799993, -52.84856536299992],
              [-68.34186764199995, -52.88591887799993],
              [-68.31143144399994, -52.912041924999926],
              [-68.28587805899991, -52.94353606599992],
              [-68.26598059799994, -52.98064544099992],
              [-68.22923743399991, -53.08733489399992],
              [-68.22581946499992, -53.10247161299992],
              [-68.23053951699995, -53.11858489399992],
              [-68.24132239499994, -53.10833098799992],
              [-68.25283769399994, -53.08717213299991],
              [-68.28042558499993, -53.0153947899999],
              [-68.30484008499991, -53.0066690079999],
              [-68.32497431199994, -53.00804823099992],
              [-68.34956888499994, -53.01616203999993],
              [-68.38087623799993, -53.03100985499992],
              [-68.4099613489999, -53.04854033899994],
              [-68.46006284099991, -53.0863317109999],
              [-68.52071548799995, -53.12063140399994],
              [-68.55479871599994, -53.167051676999904],
              [-68.56357504499994, -53.202042080999945],
              [-68.55075082199994, -53.23853671899991],
              [-68.50870694399993, -53.268149997999956],
              [-68.4513507289999, -53.29771739899991],
              [-68.41064573599994, -53.299929274999954],
              [-68.36482463699991, -53.30894963599991],
              [-68.29607390199993, -53.32016938899994],
              [-68.18933186699991, -53.31373722099994],
              [-68.11140185599993, -53.343801801999916],
              [-68.09190541299995, -53.375618162999956],
              [-68.07636005299992, -53.3952980709999],
              [-68.08250891799992, -53.42978280999995],
              [-68.07872473899994, -53.43792083099993],
              [-68.06627356699994, -53.4568010399999],
              [-68.05573482999995, -53.503024997999944],
              [-68.04767818899995, -53.5232072899999],
              [-67.99242102799991, -53.58847421699994],
              [-67.98363196499992, -53.6013322899999],
              [-67.79378440199991, -53.72717358999995],
              [-67.72435462099992, -53.7595354149999],
              [-67.70246118699993, -53.77474616099994],
              [-67.69864797899993, -53.790117230999954],
              [-67.70877942999994, -53.80456828899992],
              [-67.6827101209999, -53.80333861399993],
              [-67.66015050899995, -53.800078872999904],
              [-67.63027397699994, -53.813181140999916],
              [-67.55824792099992, -53.836188706999906],
              [-67.54923875199995, -53.8474080389999],
              [-67.5770138339999, -53.85176011699991],
              [-67.58775794199994, -53.86931731599992],
              [-67.58336341099994, -53.893243096999925],
              [-67.57152258999992, -53.9079729149999],
              [-67.29775956899994, -54.053806247999944],
              [-67.14084446299995, -54.12339826999994],
              [-67.02732347699992, -54.1558679769999],
              [-66.96136149299991, -54.18168321399992],
              [-66.9430563169999, -54.199918975999935],
              [-66.90730195099991, -54.21280322699994],
              [-66.76658164999992, -54.249841673999924],
              [-66.70173092399995, -54.28826262799993],
              [-66.65402314999994, -54.34654228799991],
              [-66.55421110099991, -54.40442562499993],
              [-66.5282261399999, -54.42964904199994],
              [-66.49231372199995, -54.44134393999991],
              [-66.48221331399992, -54.46580035499994],
              [-66.44824481599994, -54.47340762099992],
              [-66.41800704499991, -54.47697354899992],
              [-66.37687234599991, -54.485470318999944],
              [-66.28746497299994, -54.519463799999926],
              [-65.94416256399995, -54.62004973799992],
              [-65.93040930899991, -54.62265390399995],
              [-65.90294348899994, -54.62428150799991],
              [-65.88890540299991, -54.626885674999926],
              [-65.8548070949999, -54.64470794099992],
              [-65.84422766799992, -54.64739348799992],
              [-65.76793372299994, -54.65048593499995],
              [-65.69810950399994, -54.662367445999905],
              [-65.45689856699994, -54.640557549999926],
              [-65.40623938699991, -54.64527760199991],
              [-65.37970943899995, -54.644789320999905],
              [-65.30931555899991, -54.62656015399995],
              [-65.1555883449999, -54.640557549999926],
              [-65.1419164699999, -54.64690520599993],
              [-65.15038001199991, -54.66106536299992],
              [-65.1692602199999, -54.67522551899992],
              [-65.18663489499994, -54.681573174999926],
              [-65.19371497299994, -54.69019947699991],
              [-65.22419186099995, -54.74358489399992],
              [-65.21983801999994, -54.74895598799992],
              [-65.21422278599994, -54.75920989399992],
              [-65.20982825399994, -54.764743747999944],
              [-65.24376380099994, -54.78337981599992],
              [-65.25145423099991, -54.79070403399993],
              [-65.25031490799995, -54.80006275799991],
              [-65.24478105399993, -54.81129322699991],
              [-65.24339758999992, -54.820977471999925],
              [-65.26545162699995, -54.82830169099992],
              [-65.29735266799992, -54.84539153399993],
              [-65.30606035099993, -54.852227471999925],
              [-65.33226477799991, -54.9138322899999],
              [-65.34439042899993, -54.92156340899993],
              [-65.35895748599995, -54.92669036299992],
              [-65.37124589799993, -54.92848072699991],
              [-65.39293372299994, -54.92546965899993],
              [-65.39671790299991, -54.91741301899992],
              [-65.39541581899994, -54.906182549999926],
              [-65.4016820949999, -54.89373137799993],
              [-65.42857825399994, -54.88404713299991],
              [-65.46271725199995, -54.88445403399993],
              [-65.48542232999995, -54.89462655999995],
              [-65.47740637899994, -54.91423919099992],
              [-65.49966386599993, -54.93303801899992],
              [-65.58063717399995, -54.92831796699994],
              [-65.61514238199993, -54.93417734199994],
              [-65.62340247299994, -54.94264088299991],
              [-65.62816321499992, -54.95273202899995],
              [-65.63475501199991, -54.96209075299993],
              [-65.64867102799991, -54.96892669099992],
              [-65.66909745999993, -54.971774997999944],
              [-65.68569902299993, -54.96917083099993],
              [-65.69912675699993, -54.96135833099993],
              [-65.71019446499992, -54.94841887799993],
              [-65.71080481699994, -54.94345468499995],
              [-65.70840410099993, -54.92913176899992],
              [-65.71019446499992, -54.92107512799993],
              [-65.71397864499994, -54.914727471999925],
              [-65.71886145699995, -54.909274997999944],
              [-65.7318478329999, -54.90755552299993],
              [-65.75000619799994, -54.906714053999906],
              [-65.7698304779999, -54.90587819299992],
              [-65.81088962599995, -54.91558780299994],
              [-65.8771150419999, -54.8998014469999],
              [-65.90169783199991, -54.911293137999905],
              [-65.9662250639999, -54.902073326999925],
              [-65.98755793899994, -54.91068279299992],
              [-65.97250193699995, -54.92579848199995],
              [-65.95082888499991, -54.93994935399991],
              [-65.96876788799995, -54.95709373799991],
              [-65.99335508699994, -54.972366361999946],
              [-66.06097914299994, -54.983968982999954],
              [-66.1170603619999, -54.99553030099992],
              [-66.19640801199995, -54.99286906999993],
              [-66.3170681979999, -54.99497793599994],
              [-66.37163252499994, -55.00547798699995],
              [-66.36831813799995, -55.02256163299995],
              [-66.37162219299995, -55.03775518899994],
              [-66.42503821499992, -55.04631926899992],
              [-66.45067298099991, -55.05201588299991],
              [-66.54050772599993, -55.05104602999995],
              [-66.63006734599992, -55.03109736399995],
              [-66.65965735599991, -55.02076588299991],
              [-66.68057206899994, -55.00701262799993],
              [-66.69762122299994, -54.99187590899993],
              [-66.71422278599994, -54.980401299999926],
              [-66.80280514199995, -54.94255950299993],
              [-66.83092200399994, -54.93645598799992],
              [-66.94554602799991, -54.92864348799992],
              [-67.03099524599992, -54.90520598799992],
              [-67.33275305899991, -54.89226653399993],
              [-67.54076087099992, -54.87460702899995],
              [-67.66779537699995, -54.8806291649999],
              [-67.93195553299995, -54.86248137799993],
              [-68.07762610599991, -54.84612395599993],
              [-68.12364661399994, -54.8239885399999],
              [-68.21898352799991, -54.818617445999905],
              [-68.27212480399993, -54.79900481599992],
              [-68.3020727199999, -54.79216887799993],
              [-68.31517493399991, -54.80136484199994],
              [-68.31151282499991, -54.824151299999926],
              [-68.31468665299991, -54.83261484199994],
              [-68.32823645699995, -54.84238046699994],
              [-68.52033443899995, -54.852227471999925],
              [-68.54629472599993, -54.848321221999925],
              [-68.56460527299993, -54.83879973799992],
              [-68.59508216099994, -54.811211846999925],
              [-68.63609778599994, -54.78443775799991],
              [-68.64188192676619, -54.78297131557072],
            ],
          ],
          [
            [
              [-63.88841712099992, -54.72991301899992],
              [-63.86823482999995, -54.733086846999925],
              [-63.845814581999946, -54.72210051899992],
              [-63.82567298099991, -54.71493905999995],
              [-63.81212317599994, -54.72991301899992],
              [-63.83356686099995, -54.73992278399993],
              [-63.841908331999946, -54.7458635399999],
              [-63.84996497299994, -54.753838799999926],
              [-63.86266028599994, -54.774509372999944],
              [-63.870350714999915, -54.78167083099993],
              [-63.88467363199993, -54.78443775799991],
              [-63.903553839999915, -54.78590260199991],
              [-63.91592363199993, -54.78980885199991],
              [-63.966786261999914, -54.81503671699994],
              [-63.97826087099992, -54.81609465899993],
              [-63.99083411399994, -54.811211846999925],
              [-63.98497473899994, -54.801853122999944],
              [-63.966786261999914, -54.779961846999925],
              [-63.962880011999914, -54.77402109199994],
              [-63.96776282499991, -54.75920989399992],
              [-63.97964433499993, -54.75741952899995],
              [-63.99445553299995, -54.76384856599992],
              [-64.00792395699995, -54.77402109199994],
              [-64.02179928299995, -54.78199635199991],
              [-64.03693600199995, -54.78484465899993],
              [-64.07298743399991, -54.78378671699994],
              [-64.07738196499992, -54.78199635199991],
              [-64.08287512899994, -54.781508070999905],
              [-64.09325110599991, -54.78443775799991],
              [-64.09878495999993, -54.78875090899993],
              [-64.10191809799994, -54.79452890399995],
              [-64.10411536399994, -54.80022551899992],
              [-64.10692298099991, -54.80437590899993],
              [-64.13101152299993, -54.81178150799991],
              [-64.22423255099994, -54.82170989399992],
              [-64.23037675699993, -54.831963799999926],
              [-64.24453691299993, -54.83709075299993],
              [-64.26016191299993, -54.83538176899992],
              [-64.27074133999992, -54.824883721999925],
              [-64.27025305899991, -54.81406015399995],
              [-64.26455644399994, -54.80022551899992],
              [-64.25157630099994, -54.77703215899993],
              [-64.26976477799991, -54.77752044099992],
              [-64.27708899599992, -54.77971770599993],
              [-64.28506425699993, -54.78443775799991],
              [-64.29930579299992, -54.77662525799991],
              [-64.31110592399995, -54.777601820999905],
              [-64.33348548099991, -54.79070403399993],
              [-64.38805091099994, -54.811211846999925],
              [-64.39875240799995, -54.81764088299991],
              [-64.41706295499995, -54.831963799999926],
              [-64.42906653599994, -54.838555596999925],
              [-64.44513912699995, -54.84335702899995],
              [-64.46255449099993, -54.8454729149999],
              [-64.49791419199994, -54.845961195999905],
              [-64.49474036399994, -54.84197356599992],
              [-64.49278723899994, -54.83863697699991],
              [-64.48997962099992, -54.83554452899995],
              [-64.48428300699993, -54.832289320999905],
              [-64.48428300699993, -54.824883721999925],
              [-64.49596106699994, -54.82496510199991],
              [-64.50658118399991, -54.82732512799993],
              [-64.51634680899991, -54.8318010399999],
              [-64.52525794199994, -54.838555596999925],
              [-64.52131100199995, -54.840101820999905],
              [-64.51227779899995, -54.845961195999905],
              [-64.52440344999991, -54.85295989399992],
              [-64.57241777299993, -54.86646900799991],
              [-64.58405514199995, -54.8747697899999],
              [-64.59837805899991, -54.893649997999944],
              [-64.60716712099992, -54.90056731599992],
              [-64.62441972599993, -54.90374114399992],
              [-64.67625891799992, -54.90325286299992],
              [-64.68976803299995, -54.90056731599992],
              [-64.69505774599992, -54.891696872999944],
              [-64.68907630099994, -54.88445403399993],
              [-64.67813066299993, -54.87664153399993],
              [-64.66860917899993, -54.86646900799991],
              [-64.75865637899994, -54.832289320999905],
              [-64.75373287699995, -54.81340911299992],
              [-64.73180091099994, -54.80152760199991],
              [-64.70787512899994, -54.79216887799993],
              [-64.6966039699999, -54.78085702899995],
              [-64.68309485599991, -54.770196221999925],
              [-64.65290279899995, -54.777601820999905],
              [-64.60374915299991, -54.79810963299991],
              [-64.58275305899991, -54.79607512799993],
              [-64.52257239499994, -54.78167083099993],
              [-64.50475012899994, -54.77092864399992],
              [-64.56017005099994, -54.73748137799993],
              [-64.56989498599995, -54.72210051899992],
              [-64.54234778599994, -54.71559010199991],
              [-64.53433183499993, -54.72031015399995],
              [-64.50999915299991, -54.74236419099992],
              [-64.49791419199994, -54.75042083099993],
              [-64.46324622299994, -54.75725676899992],
              [-64.45262610599991, -54.75465260199991],
              [-64.43382727799991, -54.74553801899992],
              [-64.42564856699994, -54.74358489399992],
              [-64.41714433499993, -54.74309661299992],
              [-64.40705318899995, -54.74382903399993],
              [-64.39850826699995, -54.748711846999925],
              [-64.39492753799993, -54.76091887799993],
              [-64.39439856699994, -54.77597421699994],
              [-64.39134680899991, -54.78199635199991],
              [-64.38438880099994, -54.78443775799991],
              [-64.37262936099995, -54.78264739399992],
              [-64.37071692599994, -54.777601820999905],
              [-64.37319902299993, -54.77117278399993],
              [-64.37441972599993, -54.764743747999944],
              [-64.37409420499995, -54.747979424999926],
              [-64.37661699099993, -54.73447030999995],
              [-64.37547766799992, -54.721368096999925],
              [-64.36388098899994, -54.70598723799992],
              [-64.35456295499995, -54.70720794099992],
              [-64.34056555899991, -54.71599700299993],
              [-64.32371985599991, -54.72226327899995],
              [-64.30553137899994, -54.71559010199991],
              [-64.30064856699994, -54.72079843499995],
              [-64.29625403599994, -54.72210051899992],
              [-64.29137122299994, -54.72210051899992],
              [-64.28506425699993, -54.72307708099993],
              [-64.27155514199995, -54.727227471999925],
              [-64.24136308499993, -54.721774997999944],
              [-64.22423255099994, -54.72307708099993],
              [-64.21165930899991, -54.73007577899995],
              [-64.19920813699991, -54.73967864399992],
              [-64.18716386599993, -54.74700286299992],
              [-64.17585201699995, -54.74700286299992],
              [-64.16905676999994, -54.73723723799992],
              [-64.17324785099993, -54.72714609199994],
              [-64.17446855399993, -54.71892669099992],
              [-64.15876217399995, -54.71559010199991],
              [-64.15111243399991, -54.71795012799993],
              [-64.13719641799992, -54.72771575299993],
              [-64.12743079299992, -54.72991301899992],
              [-64.11929277299993, -54.72714609199994],
              [-64.11204993399991, -54.72128671699994],
              [-64.10391191299993, -54.71607838299991],
              [-64.09325110599991, -54.71559010199991],
              [-64.08779863199993, -54.721368096999925],
              [-64.07579505099994, -54.74374765399995],
              [-64.06598873599995, -54.75042083099993],
              [-64.05357825399994, -54.74863046699994],
              [-64.02432206899994, -54.73357512799993],
              [-63.914051886999914, -54.71542734199994],
              [-63.880970831999946, -54.72307708099993],
              [-63.88841712099992, -54.72991301899992],
            ],
          ],
          [
            [
              [-61.90721594999991, -39.136651299999926],
              [-61.90339107999995, -39.13209400799991],
              [-61.89476477799991, -39.13982512799993],
              [-61.88048255099994, -39.16057708099993],
              [-61.86172441299993, -39.20989348799992],
              [-61.859364386999914, -39.22519296699994],
              [-61.86827551999994, -39.23943450299993],
              [-61.88849850199995, -39.24065520599993],
              [-61.91047115799995, -39.23406340899993],
              [-61.92454993399991, -39.22519296699994],
              [-61.94098873599995, -39.211602471999925],
              [-62.004017706999946, -39.19410572699991],
              [-62.02684485599991, -39.18287525799991],
              [-62.04450436099995, -39.16952890399995],
              [-62.086048956999946, -39.122979424999926],
              [-62.09703528599994, -39.10361093499995],
              [-62.09801184799994, -39.087823174999926],
              [-62.07848059799994, -39.08554452899995],
              [-62.04137122299994, -39.09970468499995],
              [-61.94180253799993, -39.11777109199994],
              [-61.92145748599995, -39.14348723799992],
              [-61.9192602199999, -39.15252044099992],
              [-61.91429602799991, -39.15309010199991],
              [-61.909413214999915, -39.14723072699991],
              [-61.90721594999991, -39.136651299999926],
            ],
          ],
          [
            [
              [-62.085926886999914, -39.023370049999926],
              [-62.100453253999945, -39.035088799999926],
              [-62.119984503999945, -39.03289153399993],
              [-62.13076738199993, -39.020603122999944],
              [-62.11945553299995, -39.002211195999905],
              [-62.04019120999993, -39.00546640399995],
              [-62.00267493399991, -39.014743747999944],
              [-61.972320115999935, -39.03394947699991],
              [-61.96727454299992, -39.04697030999995],
              [-61.975453253999945, -39.057712497999944],
              [-61.99160722599993, -39.06406015399995],
              [-62.01024329299992, -39.064385674999926],
              [-62.03001868399991, -39.05754973799992],
              [-62.085926886999914, -39.023370049999926],
            ],
          ],
          [
            [
              [-62.155299648999915, -40.37420507899992],
              [-62.12905022399991, -40.37721777099995],
              [-62.093997489999936, -40.377419249999946],
              [-62.06672256699994, -40.39945790399992],
              [-62.049492174999955, -40.42715596699992],
              [-62.028517293999926, -40.454881721999925],
              [-62.037592607999954, -40.48436498299992],
              [-62.06671067199994, -40.51185059099993],
              [-62.085877317999916, -40.543206665999946],
              [-62.10870882599994, -40.56406373999994],
              [-62.13633348099995, -40.564870140999915],
              [-62.16133983599991, -40.55710138499995],
              [-62.15466516399994, -40.526625398999954],
              [-62.1657295089999, -40.50940096799991],
              [-62.193546356999946, -40.522603656999934],
              [-62.22117676599993, -40.52244483299995],
              [-62.237325909999925, -40.50994910499992],
              [-62.21949423299992, -40.491944230999934],
              [-62.19902582499992, -40.46347311099993],
              [-62.1934830699999, -40.42348984499995],
              [-62.17283599099994, -40.375047613999925],
              [-62.155299648999915, -40.37420507899992],
            ],
          ],
          [
            [
              [-62.11896195299994, -40.130719995999925],
              [-62.10025187999992, -40.12989329399994],
              [-62.07038591299994, -40.136760540999944],
              [-62.04058042899993, -40.14645570999994],
              [-62.014659846999905, -40.175163236999936],
              [-62.01876413899993, -40.217968765999956],
              [-62.02049868799992, -40.273146821999944],
              [-62.014774650999925, -40.32836128899993],
              [-62.02116455999993, -40.343552548999924],
              [-62.03095334499994, -40.322566740999946],
              [-62.04193979099995, -40.29681641499991],
              [-62.065428563999944, -40.27289570699992],
              [-62.11110504299995, -40.219319422999945],
              [-62.13317951999994, -40.18109401999993],
              [-62.11896195299994, -40.130719995999925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Suriname',
        iso3: 'SUR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-54.08080455699991, 3.309314029000092],
            [-54.11428910399985, 3.285381979000135],
            [-54.140023966999934, 3.24502268500008],
            [-54.17655920499996, 3.200580953000099],
            [-54.190460164999934, 3.178101705000088],
            [-54.21118241399998, 3.127407125000019],
            [-54.18797969599987, 3.130972799000091],
            [-54.17707596799991, 3.116555074000075],
            [-54.17469885299997, 3.093920797000109],
            [-54.1770242929999, 3.072785136000078],
            [-54.17945308399996, 3.070304668000105],
            [-54.1840006109999, 3.06797922800007],
            [-54.188496459999925, 3.064620260000055],
            [-54.190666869999916, 3.059142558000076],
            [-54.18854813699994, 3.05831573500005],
            [-54.17919470299998, 3.05159779900012],
            [-54.1770242929999, 3.04891062500009],
            [-54.170874796999925, 3.024829407000141],
            [-54.16916947399997, 3.010721741000111],
            [-54.17361364799987, 3.004520569000121],
            [-54.18513749199991, 2.997802633000106],
            [-54.179763143999935, 2.983746643000089],
            [-54.16875606299996, 2.971395976000039],
            [-54.1634333909999, 2.969742330000074],
            [-54.16296830299987, 2.955996399000043],
            [-54.170203002999955, 2.925403951000121],
            [-54.17325191299997, 2.919512837000127],
            [-54.18704951999993, 2.89930735300004],
            [-54.190666869999916, 2.887835185000114],
            [-54.191338663999886, 2.877344870000073],
            [-54.18963334199992, 2.870626933000054],
            [-54.18338049399992, 2.863857320000108],
            [-54.170203002999955, 2.853056946000081],
            [-54.182191935999896, 2.846545716000108],
            [-54.188909871999925, 2.838277486000067],
            [-54.20472285999992, 2.791768698000027],
            [-54.21252600199995, 2.776420797000057],
            [-54.28533809499993, 2.677977193000103],
            [-54.320426391999945, 2.606663717000032],
            [-54.35944209799996, 2.508013408000124],
            [-54.375616821999955, 2.483777161000134],
            [-54.42346919799988, 2.435924784000036],
            [-54.435458130999905, 2.431118876000127],
            [-54.45054764799991, 2.428948466000051],
            [-54.472613484999926, 2.428690084000067],
            [-54.483310505999924, 2.422850647000089],
            [-54.49338741099987, 2.41706288600011],
            [-54.52031083199998, 2.348901672000096],
            [-54.53157629399993, 2.340168356000021],
            [-54.551161661999856, 2.338101298000055],
            [-54.58475134299988, 2.348333231000126],
            [-54.59922074399992, 2.345801087000055],
            [-54.615292114999875, 2.326267396000048],
            [-54.63412817399998, 2.320117900000071],
            [-54.65337764499992, 2.316500550000086],
            [-54.672859659999915, 2.315983785000057],
            [-54.69249670499994, 2.318981018000059],
            [-54.70412390199991, 2.324820455000051],
            [-54.70655269399987, 2.332881979000135],
            [-54.70544165099997, 2.342545472000069],
            [-54.706733561999926, 2.353190816000065],
            [-54.71569942299996, 2.375928446000046],
            [-54.70996333799991, 2.394790344000057],
            [-54.70727616399998, 2.395875550000056],
            [-54.70203100599994, 2.395720520000111],
            [-54.69725093599993, 2.39732249000005],
            [-54.69559728999991, 2.403523661000037],
            [-54.69683752399993, 2.409104716000058],
            [-54.701100830999906, 2.419905090000086],
            [-54.7025477709999, 2.425744528000067],
            [-54.70319372599997, 2.445846660000129],
            [-54.70766373799998, 2.450342509000052],
            [-54.72117712399995, 2.457990621000121],
            [-54.7430362559999, 2.466517233000047],
            [-54.759805256999954, 2.465793762000146],
            [-54.775494351999896, 2.457335294000089],
            [-54.79249060099991, 2.448172099000061],
            [-54.84191910799987, 2.433495992000076],
            [-54.88028885999998, 2.447345276000135],
            [-54.9785774339999, 2.543050029000142],
            [-54.98281490099993, 2.552351786000074],
            [-54.979559285999954, 2.566097718000108],
            [-54.960232299999916, 2.585683086000117],
            [-54.95366939299993, 2.59906728100006],
            [-54.95909541799989, 2.608989156000064],
            [-54.97687211099992, 2.606922099000101],
            [-55.01774816999992, 2.590592346000065],
            [-55.03774694899997, 2.577931620000115],
            [-55.076297566999926, 2.545220439000033],
            [-55.112471069999884, 2.527805481000101],
            [-55.12089432799985, 2.524808248000085],
            [-55.12885249899992, 2.525686747000123],
            [-55.13660396399993, 2.533799948000123],
            [-55.13308996599997, 2.552868551000103],
            [-55.137792521999955, 2.562170309000038],
            [-55.17195064299992, 2.559328105000063],
            [-55.25191992199987, 2.497884827000078],
            [-55.275251831999896, 2.499331767000072],
            [-55.28698238199988, 2.513904521000114],
            [-55.302795369999984, 2.51969228100009],
            [-55.320520385999885, 2.518297018000027],
            [-55.33775447699989, 2.511269023000111],
            [-55.35452347799992, 2.494887594000062],
            [-55.36007869499994, 2.476232402000093],
            [-55.36276586899987, 2.457938945000109],
            [-55.37105993699993, 2.442539368000041],
            [-55.39958532799997, 2.430188700000073],
            [-55.435552124999845, 2.430860494000058],
            [-55.47430944899989, 2.435821431000107],
            [-55.511309773999926, 2.436389872000063],
            [-55.5682055259999, 2.431273906000072],
            [-55.58732580599988, 2.433857727000074],
            [-55.60830643699998, 2.433961080000103],
            [-55.64538427699995, 2.416649475000099],
            [-55.72429418999991, 2.396909078000135],
            [-55.74411210199989, 2.401043193000064],
            [-55.754602416999944, 2.40941477500013],
            [-55.76612626199997, 2.431273906000072],
            [-55.773567667999885, 2.440058899000064],
            [-55.783127807999904, 2.445174866000059],
            [-55.853769490999895, 2.462641500000089],
            [-55.870667683999955, 2.470909729000141],
            [-55.925031290999954, 2.515661519000105],
            [-55.947200479999964, 2.528167216000099],
            [-55.971023315999844, 2.53033762600009],
            [-55.983012248999984, 2.526461894000136],
            [-55.989239257999884, 2.520829162000013],
            [-55.99691320899987, 2.503259176000128],
            [-56.007506876999855, 2.460677795000066],
            [-56.00817867099994, 2.416287740000101],
            [-56.01334631399993, 2.398821106000057],
            [-56.04256933699989, 2.355102844000072],
            [-56.05024328699997, 2.347041321000091],
            [-56.06215470399991, 2.341563619000098],
            [-56.073420166999966, 2.342390442000124],
            [-56.08228267399997, 2.347713115000076],
            [-56.09145524099995, 2.351898906000102],
            [-56.103780069999914, 2.349056702000041],
            [-56.11680253099985, 2.333088684000089],
            [-56.13199540299988, 2.30435658800009],
            [-56.14388098099991, 2.274745992000049],
            [-56.14677486199989, 2.256194153000095],
            [-56.13525101799988, 2.248546041000026],
            [-56.09145524099995, 2.245910543000107],
            [-56.07292923999992, 2.24151804600011],
            [-56.054015665999884, 2.224051412000065],
            [-56.044843099999895, 2.184725647000079],
            [-56.031329711999916, 2.163486634000108],
            [-56.004406290999924, 2.144986471000081],
            [-55.99577632699996, 2.137390035000124],
            [-55.95996455899993, 2.090984599000109],
            [-55.92580643799994, 2.061684062000054],
            [-55.91826167799991, 2.050392761000083],
            [-55.91513525399995, 2.037654521000121],
            [-55.91676306199989, 2.028507793000045],
            [-55.92038041299989, 2.019386902000065],
            [-55.92358435099996, 2.006596985000087],
            [-55.92234411599992, 1.962155254000024],
            [-55.91676306199989, 1.922235210000068],
            [-55.92203405799992, 1.88621673600008],
            [-55.95381506399988, 1.853273011000027],
            [-56.01965083799985, 1.83350677500006],
            [-56.082644408999954, 1.846555074000094],
            [-56.14527624499988, 1.871773173000051],
            [-56.20976843299991, 1.888542176000016],
            [-56.2579308679999, 1.885648295000124],
            [-56.273795531999895, 1.887508647000033],
            [-56.29270910699995, 1.895466817000084],
            [-56.32862422699989, 1.918462830000038],
            [-56.34795121299996, 1.926601868000148],
            [-56.367174845999955, 1.928875631000068],
            [-56.396527058999936, 1.921666769000112],
            [-56.41518225099992, 1.919703064000075],
            [-56.42980668199991, 1.922700298000095],
            [-56.481819010999914, 1.941613871000129],
            [-56.48510046399991, 1.953215231000087],
            [-56.491198282999875, 1.962904562000105],
            [-56.49998327699987, 1.969984232000044],
            [-56.52096390899996, 1.976728007000077],
            [-56.52938716699995, 1.981792298000045],
            [-56.53649267599988, 1.988639425000102],
            [-56.5420737309999, 1.997166036000124],
            [-56.57977168799994, 2.016803080000059],
            [-56.677801879999976, 2.018405050000098],
            [-56.70519038899991, 2.029644674000053],
            [-56.80146358199997, 2.165967103000085],
            [-56.80874995999994, 2.195784404000094],
            [-56.816346395999915, 2.21759185800002],
            [-56.8261907559999, 2.261671855000088],
            [-56.83887731899995, 2.281102193000066],
            [-56.84779150399996, 2.285856425000063],
            [-56.87086503099994, 2.290145569000032],
            [-56.88014095099996, 2.294796448000085],
            [-56.884430093999924, 2.303736471000121],
            [-56.88388749199987, 2.339754944000106],
            [-56.8950496009999, 2.362079163000075],
            [-56.93083553099993, 2.393291728000051],
            [-56.93845780399991, 2.411430155000076],
            [-56.93202408899995, 2.425796204000079],
            [-56.93024125199986, 2.43618316700011],
            [-56.93507299799998, 2.445898336000141],
            [-56.951635294999875, 2.461246236000108],
            [-56.95636368899994, 2.470031230000103],
            [-56.95959346499993, 2.483777161000134],
            [-56.95752640899988, 2.49349233000008],
            [-56.95261714699993, 2.504551086000077],
            [-56.951273559999976, 2.515454814000051],
            [-56.95959346499993, 2.524704895000056],
            [-56.980005655999975, 2.509718730000088],
            [-56.99411332199992, 2.504861146000067],
            [-57.000572875999865, 2.514162903000098],
            [-56.99530188099993, 2.547855937000051],
            [-56.99711055599994, 2.555142314000122],
            [-57.02238033099991, 2.58454620400002],
            [-57.027237914999915, 2.593589580000071],
            [-57.027909708999914, 2.610591125000099],
            [-57.023155476999904, 2.623665263000049],
            [-57.02046830299989, 2.635447489000057],
            [-57.027237914999915, 2.648211568000107],
            [-57.04801184099995, 2.63648101800004],
            [-57.05597001199993, 2.64237213100003],
            [-57.061964477999936, 2.681749573000033],
            [-57.071886352999854, 2.700094707000105],
            [-57.097724568999865, 2.72737986200012],
            [-57.102943887999885, 2.740454],
            [-57.09901647999993, 2.750375875000074],
            [-57.09214351499995, 2.76303660100011],
            [-57.089869750999924, 2.773888652000068],
            [-57.09953324399996, 2.778591207000133],
            [-57.13374304299995, 2.773423564000041],
            [-57.13705033399995, 2.771149801000121],
            [-57.14366491699985, 2.790011698000043],
            [-57.126404988999866, 2.826030171000127],
            [-57.13338130699995, 2.832593078000116],
            [-57.145215209999975, 2.830422669000114],
            [-57.165265665999925, 2.821069234000078],
            [-57.17461909999986, 2.818950501000103],
            [-57.186608031999924, 2.823239644000068],
            [-57.19105220599994, 2.832593078000116],
            [-57.19425614499991, 2.841998189000066],
            [-57.202265991999866, 2.846235657000122],
            [-57.20634842999988, 2.856570943000037],
            [-57.21962927299998, 2.908299052000089],
            [-57.210327514999875, 2.918220927000078],
            [-57.19472123199992, 2.930623271000059],
            [-57.183817504999865, 2.944679261000076],
            [-57.188623412999874, 2.959510397000102],
            [-57.221851358999885, 2.963024394000058],
            [-57.23461543799996, 2.970362448000046],
            [-57.22645056199994, 2.98338490800009],
            [-57.221179564999915, 2.992583313000083],
            [-57.22179968299989, 3.000438131000109],
            [-57.224693562999875, 3.009171448000089],
            [-57.22645056199994, 3.021263733000083],
            [-57.22324662299988, 3.024777730000039],
            [-57.209242309999865, 3.024054261000046],
            [-57.20598669499989, 3.028136699000044],
            [-57.207020223999876, 3.035681458000099],
            [-57.211774455999944, 3.048342184000134],
            [-57.212859659999936, 3.056041972000031],
            [-57.2222130939999, 3.078262838000072],
            [-57.239473022999874, 3.094127503000081],
            [-57.24856807499995, 3.11236928300012],
            [-57.233323526999925, 3.141669820000089],
            [-57.23673417199984, 3.143478495000082],
            [-57.237405965999926, 3.143995260000025],
            [-57.23761267099988, 3.144873759000063],
            [-57.239473022999874, 3.14787099200008],
            [-57.24624263599992, 3.141618144000077],
            [-57.25497595199991, 3.135830384000101],
            [-57.2648978279999, 3.132626444000039],
            [-57.2749230549999, 3.134280091000079],
            [-57.28603348899992, 3.14239329100009],
            [-57.284173136999925, 3.148956197000075],
            [-57.277713582999866, 3.156914368000045],
            [-57.2749230549999, 3.169006653000025],
            [-57.285671752999946, 3.192106018000089],
            [-57.287945516999855, 3.203113099000092],
            [-57.28711869299994, 3.215360412000024],
            [-57.281744344999964, 3.235927632000099],
            [-57.280452433999926, 3.24781321200004],
            [-57.28401810699998, 3.259750468000078],
            [-57.29027095599989, 3.267967021000104],
            [-57.292493041999904, 3.276286926000068],
            [-57.28422481399994, 3.288792623000063],
            [-57.28277787299996, 3.295045471000066],
            [-57.280452433999926, 3.329772034000101],
            [-57.28355301999994, 3.343802185000115],
            [-57.3084093839999, 3.394910177000099],
            [-57.340035359999916, 3.37015716600007],
            [-57.366752075999955, 3.365609639000041],
            [-57.39346879099992, 3.37382619300007],
            [-57.42504309099991, 3.387494609000086],
            [-57.423957886999915, 3.369382019000071],
            [-57.430934204999915, 3.360622864000078],
            [-57.459201212999886, 3.353336487000107],
            [-57.46168168199995, 3.349977518000088],
            [-57.46876135299988, 3.343182068000132],
            [-57.47625443599992, 3.338944601000094],
            [-57.479716755999874, 3.343388774000104],
            [-57.48204219599998, 3.348556417000097],
            [-57.4879849859999, 3.351527812000114],
            [-57.49583980399984, 3.352974752000108],
            [-57.50390132699994, 3.353336487000107],
            [-57.509637410999886, 3.357677307000088],
            [-57.522401489999964, 3.365247904000043],
            [-57.535268920999954, 3.367780050000121],
            [-57.545035766999916, 3.348143006000086],
            [-57.554234171999894, 3.346747742000019],
            [-57.565137898999865, 3.349822490000051],
            [-57.596192593999945, 3.367120724000102],
            [-57.59640214099997, 3.367237447000079],
            [-57.61324865799995, 3.376642558000043],
            [-57.6414639889999, 3.382430318000019],
            [-57.64993892399991, 3.38594431500006],
            [-57.65484818599995, 3.390130107000104],
            [-57.65820715299995, 3.395220235000082],
            [-57.66254797399992, 3.407079976000105],
            [-57.66461503199989, 3.417544454000051],
            [-57.663994913999915, 3.425838521000102],
            [-57.658930623999936, 3.44389943500002],
            [-57.658362182999895, 3.450617371000135],
            [-57.660532592999886, 3.462993877000102],
            [-57.66068762199993, 3.469505107000074],
            [-57.645494751999905, 3.498986511000084],
            [-57.64404781199991, 3.516659851000085],
            [-57.66042924099986, 3.535185852000026],
            [-57.68125484199993, 3.547303976000109],
            [-57.685130574999874, 3.549164327000113],
            [-57.687249307999934, 3.55216156000003],
            [-57.697998005999864, 3.553608500000024],
            [-57.70285559099989, 3.555675558000075],
            [-57.7073514409999, 3.560662334000128],
            [-57.708643351999854, 3.564124654000082],
            [-57.70952185099989, 3.567690329000044],
            [-57.717480021999876, 3.582443950000055],
            [-57.72249263599991, 3.599962260000027],
            [-57.7261099859999, 3.607196961000085],
            [-57.764247192999875, 3.631588236000098],
            [-57.81313309799995, 3.651845398000106],
            [-57.82977290899987, 3.66243906600009],
            [-57.84098669399992, 3.680990906000119],
            [-57.84692948499992, 3.702100729000065],
            [-57.84961665899996, 3.747472636000097],
            [-57.85385412699992, 3.766670430000104],
            [-57.8751448159999, 3.812197368000085],
            [-57.925839396999976, 3.886404724000045],
            [-57.94211747299991, 3.905447490000114],
            [-58.00790157099996, 3.957278951000092],
            [-58.03213781699995, 3.987716370000072],
            [-58.042008015999926, 4.023037211000073],
            [-58.05508215299989, 4.108070780000077],
            [-58.067691202999924, 4.151143087000079],
            [-58.065934203999944, 4.171839498000097],
            [-58.05203324399986, 4.19310435000007],
            [-57.96495845599989, 4.282039490000045],
            [-57.95384802299989, 4.299015198000049],
            [-57.94738846899992, 4.318755595000113],
            [-57.945269734999954, 4.343922018000058],
            [-57.9480602619999, 4.360484314000061],
            [-57.95348628799988, 4.375703024000089],
            [-57.95663854999995, 4.391438497000067],
            [-57.95265946399988, 4.409731954000037],
            [-57.94278926699988, 4.425105693000106],
            [-57.93131709799988, 4.437843933000067],
            [-57.921860310999904, 4.450943909000031],
            [-57.914470580999875, 4.484068502000127],
            [-57.89607377099989, 4.528510234000109],
            [-57.879123901999975, 4.556828918000093],
            [-57.86331091399998, 4.607730204000035],
            [-57.84543086799994, 4.633516744000133],
            [-57.837421020999955, 4.650880025000063],
            [-57.836025756999874, 4.669845276000018],
            [-57.84434566299993, 4.687518616000105],
            [-57.871165730999905, 4.721728414000012],
            [-57.88454992699985, 4.762862854000076],
            [-57.90113806199986, 4.773921611000091],
            [-57.91782954999991, 4.782370707000084],
            [-57.92537430899995, 4.796142476000028],
            [-57.918501342999974, 4.829757996000055],
            [-57.902429972999926, 4.852728170000091],
            [-57.884188191999954, 4.872261861000098],
            [-57.87070064399998, 4.888927511000134],
            [-57.850340128999875, 4.922801412000041],
            [-57.84279536999992, 4.929881083000069],
            [-57.83023799599991, 4.93305918400003],
            [-57.820574503999865, 4.930294495000069],
            [-57.810962687999876, 4.925540263000087],
            [-57.79845699099988, 4.9230597950001],
            [-57.77396236199991, 4.926444601000128],
            [-57.762335164999854, 4.935539653000092],
            [-57.74729732299997, 4.964013367000035],
            [-57.720477253999974, 4.98979990600013],
            [-57.68693924999988, 5.006258851000027],
            [-57.649370482999956, 5.008429260000099],
            [-57.610096394999886, 4.991350199000067],
            [-57.566223103999874, 5.007085673000049],
            [-57.54327876799994, 5.01109059700012],
            [-57.51759558099985, 5.012434184000085],
            [-57.512221232999906, 5.0091527310001],
            [-57.49687333199992, 4.994657491000069],
            [-57.490258748999935, 4.991350199000067],
            [-57.47733963999991, 4.992487081000078],
            [-57.460493122999935, 4.997628886000072],
            [-57.381376505999924, 5.005742086000069],
            [-57.35621008399991, 5.012434184000085],
            [-57.345513060999906, 5.016619975000125],
            [-57.33807165499988, 5.02075408900015],
            [-57.32944169199993, 5.024087220000055],
            [-57.31523067199987, 5.026102600000101],
            [-57.30649735599991, 5.024448955000054],
            [-57.298694214999955, 5.021115824000049],
            [-57.290477660999926, 5.020289001000037],
            [-57.280452433999926, 5.026102600000101],
            [-57.31693599499994, 5.058968811000042],
            [-57.32143184399985, 5.070156759000071],
            [-57.32019160999991, 5.083411764000076],
            [-57.317091023999865, 5.09475474100006],
            [-57.302208211999925, 5.128473612000022],
            [-57.29554195199992, 5.157205709000038],
            [-57.288979044999934, 5.171029155000085],
            [-57.277713582999866, 5.176920268000089],
            [-57.25993688999995, 5.176300150000117],
            [-57.24727616399991, 5.17237274200005],
            [-57.23874955299988, 5.162011617000132],
            [-57.233323526999925, 5.142116191000127],
            [-57.217768921999976, 5.148549907000074],
            [-57.20200760899991, 5.157619121000039],
            [-57.18981197199989, 5.169220480000092],
            [-57.184902709999875, 5.183147278000078],
            [-57.19239579299989, 5.203171896000114],
            [-57.22572709199994, 5.243608704000096],
            [-57.23252170199993, 5.260572120000077],
            [-57.233323526999925, 5.262573954000061],
            [-57.23761267099988, 5.268723450000039],
            [-57.2476378989999, 5.271772360000057],
            [-57.25900671399998, 5.271203919000101],
            [-57.26742997299988, 5.266294657000074],
            [-57.26918697199994, 5.25670867900007],
            [-57.26401932799985, 5.247045186000136],
            [-57.253787394999875, 5.234927063000043],
            [-57.25642289299989, 5.228286641000039],
            [-57.26303747599988, 5.22399749700007],
            [-57.27166743999993, 5.222860616000062],
            [-57.280452433999926, 5.225341085000139],
            [-57.28546504799988, 5.230818787000118],
            [-57.28727372299997, 5.238699442000069],
            [-57.28882401599989, 5.308540141000051],
            [-57.29202795499987, 5.311330668000011],
            [-57.29833247899998, 5.311020610000114],
            [-57.3084093839999, 5.313475240000088],
            [-57.32282710799993, 5.307609965000097],
            [-57.33171545499994, 5.307609965000097],
            [-57.33569453899992, 5.316885885000104],
            [-57.332283894999904, 5.32786712700009],
            [-57.32411901899988, 5.338589987000105],
            [-57.27549149599989, 5.387398377000068],
            [-57.26520788599987, 5.403366395000106],
            [-57.2612288009999, 5.426749980000068],
            [-57.260091918999876, 5.448195699000095],
            [-57.25693965699992, 5.464086202000104],
            [-57.24767005099994, 5.484930731000077],
            [-57.23399817599994, 5.498968817000048],
            [-57.22508704299992, 5.507513739000046],
            [-57.193023240999935, 5.519720770000049],
            [-57.17951412699995, 5.530585028000075],
            [-57.17015540299991, 5.542792059000078],
            [-57.16368567599994, 5.557074286000045],
            [-57.13963782499991, 5.665106512000079],
            [-57.134877081999946, 5.759914455000057],
            [-57.12800045499995, 5.793158270000049],
            [-57.12576991299994, 5.818145202000039],
            [-57.11384695299995, 5.858844279000039],
            [-57.10228335599993, 5.886415857000088],
            [-57.07579505099994, 5.92999909100007],
            [-57.07164466099994, 5.941229559000078],
            [-57.06602942599994, 5.950100002000056],
            [-57.05768795499995, 5.955877997000073],
            [-57.034820115999935, 5.959906317000048],
            [-57.027902798999946, 5.964422919000071],
            [-57.022694464999915, 5.968939520000049],
            [-57.01744544199994, 5.970933335000041],
            [-57.01280676999994, 5.973863023000092],
            [-57.000111456999946, 5.987982489000046],
            [-56.99449622299994, 5.992661851000094],
            [-56.98468990799995, 5.996283270000049],
            [-56.974598761999914, 5.998114325000074],
            [-56.96387174799992, 6.009151948000067],
            [-56.95653728299993, 6.011573766000083],
            [-56.92884361699993, 6.004262377000089],
            [-56.866972319999945, 5.989636515000086],
            [-56.83035597899993, 5.985556838000093],
            [-56.7807244249999, 5.985508468000091],
            [-56.70263103499991, 5.982190205000052],
            [-56.65951168499993, 5.979715570000053],
            [-56.642432053999926, 5.973222757000087],
            [-56.61142173999991, 5.953646911000078],
            [-56.59310418799993, 5.945752637000055],
            [-56.57395023099991, 5.940756315000044],
            [-56.52685903299994, 5.936548576000064],
            [-56.41831440699991, 5.911349189000077],
            [-56.355023984999946, 5.894670237000071],
            [-56.303806599999916, 5.892507929000089],
            [-56.256765973999904, 5.880405812000049],
            [-56.22283396699993, 5.870753118000039],
            [-56.19163977799991, 5.862616278000075],
            [-56.124256964999915, 5.848049221000053],
            [-56.083036283999945, 5.834365957000045],
            [-56.05859455299992, 5.827737312000068],
            [-56.037993943999936, 5.824164130000042],
            [-55.99918207299993, 5.810712549000073],
            [-55.93600595099991, 5.804660631000047],
            [-55.91787675699993, 5.784735419000071],
            [-55.903553839999915, 5.776353257000039],
            [-55.897694464999915, 5.763006903000075],
            [-55.897694464999915, 5.676703192000048],
            [-55.897246873999904, 5.676703192000048],
            [-55.89024817599994, 5.676703192000048],
            [-55.88499915299991, 5.692450262000079],
            [-55.88329016799992, 5.708075262000079],
            [-55.884022589999915, 5.741929429000038],
            [-55.887277798999946, 5.759466864000046],
            [-55.90453040299991, 5.79718659100007],
            [-55.91536159299994, 5.821770989000072],
            [-55.89996263099994, 5.841963548000081],
            [-55.910002851999934, 5.850917821000053],
            [-55.922245296999904, 5.850352823000037],
            [-55.933958685999926, 5.849827132000087],
            [-55.94787193199994, 5.861520820000067],
            [-55.951168793999955, 5.881510800000058],
            [-55.9466686209999, 5.896492641000066],
            [-55.93043306399994, 5.91758029500005],
            [-55.92361255299994, 5.927844941000046],
            [-55.91039502299992, 5.941615553000076],
            [-55.90065382699993, 5.951945171000091],
            [-55.886051934999955, 5.962954274000083],
            [-55.86799044599991, 5.969812878000084],
            [-55.844381978999934, 5.975961707000067],
            [-55.8200945289999, 5.977274794000039],
            [-55.729088531999935, 5.981216439000093],
            [-55.678578253999945, 5.985256252000056],
            [-55.63731848899994, 5.985907294000071],
            [-55.394987880999906, 5.973876003000044],
            [-55.33596733599995, 5.962708199000076],
            [-55.307870814999944, 5.943349544000057],
            [-55.29204537399994, 5.936726952000072],
            [-55.270822719999956, 5.92999909100007],
            [-55.263783331999946, 5.92641836100006],
            [-55.25320390499991, 5.917792059000078],
            [-55.24290930899991, 5.909369208000044],
            [-55.23289954299992, 5.903265692000048],
            [-55.22976640499991, 5.902411200000074],
            [-55.22142493399991, 5.900213934000078],
            [-55.212880011999914, 5.900213934000078],
            [-55.20243289399991, 5.898761043000093],
            [-55.18836054199994, 5.897395008000046],
            [-55.17690766699991, 5.901290001000064],
            [-55.164051886999914, 5.906683661000045],
            [-55.14784048599995, 5.908177475000059],
            [-55.13072689299992, 5.89585543600009],
            [-55.11082923099991, 5.88117096600007],
            [-55.10310721299993, 5.866412291000074],
            [-55.1151012119999, 5.837128193000069],
            [-55.12987219999991, 5.820746161000045],
            [-55.12861080599993, 5.821356512000079],
            [-55.10103935899991, 5.830499325000062],
            [-55.09171227799993, 5.852791383000067],
            [-55.090748842999915, 5.875116669000079],
            [-55.08551998599995, 5.882798570000091],
            [-55.063423422999904, 5.882882815000073],
            [-55.03038489499994, 5.859767971000053],
            [-55.01012122299994, 5.855536200000074],
            [-54.99705969999991, 5.858465887000079],
            [-54.98892167899993, 5.863674221000053],
            [-54.98119055899991, 5.865464585000041],
            [-54.95881100199995, 5.851792710000041],
            [-54.95030676999994, 5.850287177000041],
            [-54.94180253799993, 5.852118231000077],
            [-54.93195553299995, 5.855536200000074],
            [-54.92414303299995, 5.860419012000079],
            [-54.91869055899991, 5.867092190000051],
            [-54.91197669199994, 5.872870184000078],
            [-54.90025794199994, 5.875392971000053],
            [-54.89077714799993, 5.87335846600007],
            [-54.88072669199994, 5.868353583000044],
            [-54.86302649599992, 5.855536200000074],
            [-54.86754309799994, 5.863674221000053],
            [-54.874338344999956, 5.871568101000094],
            [-54.88219153599994, 5.87836334800005],
            [-54.890288865999935, 5.882798570000091],
            [-54.90347245999993, 5.88540273600006],
            [-54.91258039499991, 5.884024968000062],
            [-54.92185060699995, 5.876625344000047],
            [-54.93331850699991, 5.869671869000058],
            [-54.956207495999934, 5.867574735000062],
            [-54.971565503999955, 5.877266689000066],
            [-54.98563364599994, 5.880387456000051],
            [-55.0015167599999, 5.871258979000061],
            [-55.01659094999991, 5.871975002000056],
            [-55.03172766799992, 5.884466864000046],
            [-55.04727128799993, 5.892279364000046],
            [-55.10529537699995, 5.90892161700009],
            [-55.12564042899993, 5.918646552000041],
            [-55.14297441299993, 5.930121161000045],
            [-55.150380011999914, 5.94086334800005],
            [-55.15412350199995, 5.951361395000049],
            [-55.15996561999992, 5.958113974000071],
            [-55.15332344099994, 5.968592041000079],
            [-55.14449955899994, 5.974247897000055],
            [-55.116851365999935, 5.985256252000056],
            [-55.085301141999935, 5.990649034000057],
            [-55.0447990049999, 5.99310494100007],
            [-55.01390540299991, 5.993394273000092],
            [-54.77358964799993, 5.985256252000056],
            [-54.75536048099991, 5.980943101000094],
            [-54.712555109999926, 5.976183871000046],
            [-54.67355600999991, 5.96919162800009],
            [-54.471780922999926, 5.940969850000045],
            [-54.34863012599993, 5.913755159000061],
            [-54.252699443999916, 5.894808339000065],
            [-54.16934160099993, 5.86790599200009],
            [-54.09739562699991, 5.84733938100004],
            [-54.0744563099999, 5.84488748800004],
            [-54.06203176999992, 5.84055851800008],
            [-54.03673144499993, 5.842350790000069],
            [-54.03094366199991, 5.834184262000065],
            [-54.02046226899995, 5.830250206000073],
            [-54.01468747699994, 5.820148403000076],
            [-54.01630686199991, 5.809703943000045],
            [-53.992085009999926, 5.76349738600004],
            [-53.986357453999915, 5.745664571000077],
            [-53.99592037699995, 5.734523830000057],
            [-54.0197529269999, 5.688979194000069],
            [-54.03114763399992, 5.669309742000053],
            [-54.03643877499991, 5.62950234200008],
            [-54.05036373599995, 5.552069403000075],
            [-54.061105923999946, 5.512884833000044],
            [-54.07359778599994, 5.489813544000071],
            [-54.091786261999914, 5.467922268000052],
            [-54.10912024599992, 5.452826239000046],
            [-54.118478969999956, 5.442775783000059],
            [-54.12254798099991, 5.433417059000078],
            [-54.12852942599994, 5.414292710000041],
            [-54.17096920499995, 5.34837474200009],
            [-54.190460164999934, 5.325748393000111],
            [-54.269163370999934, 5.269085185000037],
            [-54.311331339999896, 5.225806173000066],
            [-54.32065194299989, 5.212454410000049],
            [-54.332001912999914, 5.196195577000111],
            [-54.34357743299995, 5.156378886000098],
            [-54.350036986999896, 5.149583436000057],
            [-54.36543656399991, 5.138757222000024],
            [-54.36988073799989, 5.132375183000079],
            [-54.37230952999997, 5.121058045000012],
            [-54.375616821999955, 5.114882711000035],
            [-54.430238810999896, 5.053387757000024],
            [-54.44863561999989, 5.024293925000023],
            [-54.45478511599987, 5.008532613000042],
            [-54.45757564299993, 4.991350199000067],
            [-54.44884232599995, 4.951481832000127],
            [-54.4508060309999, 4.93672821100003],
            [-54.45550858599995, 4.931431377000081],
            [-54.48212194899989, 4.912802022000022],
            [-54.486721150999955, 4.902957662000048],
            [-54.48496415299988, 4.892751567000076],
            [-54.47865962699987, 4.878669739000145],
            [-54.47865962699987, 4.755188904000093],
            [-54.475404011999956, 4.741727194000134],
            [-54.46729081299986, 4.736197815000125],
            [-54.45700720299996, 4.73332977300015],
            [-54.44734370899994, 4.727852071000072],
            [-54.435458130999905, 4.709403585000061],
            [-54.43514807099993, 4.692376200000126],
            [-54.43855871599996, 4.673281759000048],
            [-54.43773189399994, 4.648735453000072],
            [-54.42527787299994, 4.616050110000089],
            [-54.42346919799988, 4.604345398000106],
            [-54.42346919799988, 4.563391825000082],
            [-54.42817175299993, 4.546157736000097],
            [-54.44796382699991, 4.509544983000055],
            [-54.4508060309999, 4.484223532000073],
            [-54.433442748999965, 4.37637481700007],
            [-54.4029536539999, 4.312941997000038],
            [-54.39411698399988, 4.269818013000119],
            [-54.39318680899993, 4.244393209000108],
            [-54.39959468599997, 4.227262472000064],
            [-54.410550089999845, 4.208581441000078],
            [-54.40657100399997, 4.191528219000048],
            [-54.3948921299999, 4.177911479000045],
            [-54.38248978699991, 4.169565735000077],
            [-54.34890010599989, 4.160522359000112],
            [-54.3385648199999, 4.152331645000089],
            [-54.33468908699993, 4.131712748000098],
            [-54.33758296699992, 4.1166490680001],
            [-54.351018839999966, 4.08207753500011],
            [-54.35515295399989, 4.066522929000087],
            [-54.35386104299994, 4.041718241000041],
            [-54.34435258099995, 4.02494923900008],
            [-54.31019445899997, 3.994201762000031],
            [-54.30388993399987, 3.984460755000086],
            [-54.29314123599994, 3.949811707000066],
            [-54.28647497599994, 3.940716655000102],
            [-54.27252233899995, 3.92952870700006],
            [-54.26580440299992, 3.922526551000061],
            [-54.24105139199989, 3.876353658000113],
            [-54.22224117099998, 3.866199239000053],
            [-54.21800370299994, 3.857646789000029],
            [-54.21454138199991, 3.858215230000084],
            [-54.20704829899995, 3.846484680000088],
            [-54.19748815999995, 3.82689931200008],
            [-54.1873595779999, 3.814677837000147],
            [-54.18162349499994, 3.811008810000061],
            [-54.170203002999955, 3.805815328000051],
            [-54.13609655799988, 3.795738424000106],
            [-54.12550288999989, 3.788736267000104],
            [-54.10478063999997, 3.758040467000072],
            [-54.094445352999855, 3.747059225000086],
            [-54.07403316299991, 3.676107483000095],
            [-54.05067541599996, 3.640554098000052],
            [-54.05010697499992, 3.634533793000102],
            [-54.039409952999904, 3.636445821000038],
            [-54.02840287299992, 3.639830627000052],
            [-54.01786088099996, 3.641458435000089],
            [-54.00881750499991, 3.637918599000031],
            [-53.994813191999896, 3.623604228000133],
            [-53.98881872599986, 3.61099517800011],
            [-53.99026566599986, 3.59569895500006],
            [-53.998275512999925, 3.573038839000091],
            [-54.00628535999991, 3.531025900000088],
            [-54.003029744999935, 3.455397441000045],
            [-54.01935949799986, 3.41537404400006],
            [-54.055688028999924, 3.377676086000108],
            [-54.06033890799989, 3.364214376000064],
            [-54.06271602399994, 3.346696066000092],
            [-54.06948563699987, 3.327084859000067],
            [-54.080234334999915, 3.309721578000051],
            [-54.08080455699991, 3.309314029000092],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Guyana',
        iso3: 'GUY',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-56.481819010999914, 1.941613871000129],
              [-56.5285086669999, 1.924018046000057],
              [-56.558920247999964, 1.906654765000042],
              [-56.574862426999914, 1.905466207000103],
              [-56.59010697499994, 1.912985128000059],
              [-56.604421345999924, 1.924586487000099],
              [-56.62023433399992, 1.934560039000104],
              [-56.63956132099989, 1.936859639000133],
              [-56.656407836999875, 1.930064188000088],
              [-56.669662841999866, 1.919858094000119],
              [-56.68395137599995, 1.912106628000103],
              [-56.70410518499992, 1.912830099000104],
              [-56.724155639999964, 1.916137391000106],
              [-56.737643188999925, 1.912985128000059],
              [-56.78063798099993, 1.879059550000122],
              [-56.79273026599989, 1.87353017200013],
              [-56.80647619699994, 1.873581848000043],
              [-56.877634643999954, 1.885648295000124],
              [-56.890708780999915, 1.890195821000063],
              [-56.906831827999895, 1.9032441210001],
              [-56.9134464119999, 1.912830099000104],
              [-56.92192134699991, 1.91810109400005],
              [-56.94352209499996, 1.918256124000081],
              [-56.97685339399993, 1.91458709700008],
              [-56.99323482299988, 1.914845479000064],
              [-57.01116654499995, 1.918566182000063],
              [-57.037469848999905, 1.932389628000124],
              [-57.05597001199993, 1.948073425000089],
              [-57.06780391499984, 1.968692322000081],
              [-57.07405676299993, 1.997166036000124],
              [-57.10449418199991, 2.021453959000027],
              [-57.152914998999876, 2.002204488000089],
              [-57.23843949399989, 1.948538513000102],
              [-57.25864497899988, 1.952233378000116],
              [-57.294818481999926, 1.974841817000055],
              [-57.3194164629999, 1.977141419000077],
              [-57.34148229999991, 1.968847351000122],
              [-57.35615840699998, 1.955282287000045],
              [-57.368767456999905, 1.939650167000096],
              [-57.38452876799991, 1.925206604000067],
              [-57.40556107599991, 1.914277039000098],
              [-57.4195137129999, 1.909186910000116],
              [-57.42948726499992, 1.900298564000096],
              [-57.45429195199995, 1.833816834000046],
              [-57.46478226699989, 1.815730082000115],
              [-57.53128983599987, 1.731549175000055],
              [-57.56115881399998, 1.708966573000026],
              [-57.60787430899998, 1.697106832000088],
              [-57.638570108999915, 1.696176656000134],
              [-57.72311275299998, 1.711653748000046],
              [-57.758821166999894, 1.713462423000038],
              [-57.79075720299997, 1.704935812000116],
              [-57.87147578999989, 1.669253235000028],
              [-57.9053755299999, 1.648556824000096],
              [-57.922222046999906, 1.642484843000148],
              [-57.93901688699995, 1.643311666000074],
              [-57.969144246999946, 1.655481465000079],
              [-57.98500891099985, 1.65770355300009],
              [-57.991003376999885, 1.650417175000101],
              [-57.98976314299995, 1.634604187000107],
              [-57.98392370699986, 1.604115092000129],
              [-57.986972615999974, 1.586829326000043],
              [-57.993587198999876, 1.568484192000142],
              [-58.01115718599996, 1.536186422000071],
              [-58.027228556999916, 1.516859436000118],
              [-58.06913814299992, 1.509004618000091],
              [-58.116422078999875, 1.510554912000103],
              [-58.1486164959999, 1.519081523000125],
              [-58.155541137999876, 1.527375590000076],
              [-58.16287919199988, 1.549183045000106],
              [-58.1706306559999, 1.558820700000112],
              [-58.187270466999905, 1.567605693000104],
              [-58.19776078299995, 1.565900371000055],
              [-58.206959187999956, 1.559957580000031],
              [-58.219671589999905, 1.556056010000077],
              [-58.23858516499985, 1.556701965000045],
              [-58.2605476489999, 1.560319315000129],
              [-58.281993367999945, 1.566572164000121],
              [-58.299201619999906, 1.575176290000073],
              [-58.306332967999964, 1.58277272600013],
              [-58.316151489999925, 1.59889577200002],
              [-58.320492309999906, 1.601221211000052],
              [-58.3319128009999, 1.593392233000117],
              [-58.338734089999946, 1.580188904000124],
              [-58.34426346899997, 1.56548695900004],
              [-58.351394815999896, 1.553317159000116],
              [-58.360283162999906, 1.547374370000114],
              [-58.383124144999925, 1.537219951000054],
              [-58.390255492999955, 1.530760397000094],
              [-58.39170243399985, 1.520838522000105],
              [-58.385914672999974, 1.499728699000073],
              [-58.386379760999915, 1.490194397000081],
              [-58.41345821199988, 1.472030131000039],
              [-58.426430232999905, 1.46980534700009],
              [-58.49887935399997, 1.457379863000057],
              [-58.5017543459999, 1.4537810960001],
              [-58.51365881399988, 1.438879700000129],
              [-58.50699255399988, 1.418183289000112],
              [-58.488078979999926, 1.378883362000039],
              [-58.48172277799992, 1.358057760000079],
              [-58.48110266199993, 1.333873189000101],
              [-58.4876138919999, 1.316458232000073],
              [-58.51892980999992, 1.267262268000096],
              [-58.52714636199994, 1.266848856000095],
              [-58.53505285599991, 1.271551412000065],
              [-58.54306270399988, 1.27439361600004],
              [-58.542752644999894, 1.276357320000074],
              [-58.54673172999989, 1.280439758000085],
              [-58.552312784999884, 1.284625549000026],
              [-58.55696366399985, 1.286899312000045],
              [-58.56140783699996, 1.285142314000069],
              [-58.574171915999926, 1.275375468000107],
              [-58.58052811699986, 1.272739970000089],
              [-58.68258907099988, 1.28245513900012],
              [-58.697730264999905, 1.281059876000057],
              [-58.709202433999906, 1.272274882000062],
              [-58.73690100099995, 1.232329],
              [-58.75281734199987, 1.214965718000087],
              [-58.77193762299996, 1.201271465000076],
              [-58.79596716299989, 1.191814677000096],
              [-58.815965941999934, 1.187267151000071],
              [-58.834001017999924, 1.185820211000078],
              [-58.852036091999935, 1.188714091000065],
              [-58.8721382249999, 1.197240702000073],
              [-58.8978730879999, 1.217807922000063],
              [-58.90645137599992, 1.238530172000097],
              [-58.91172237099994, 1.260234273000094],
              [-58.927483683999924, 1.284212138000015],
              [-58.94598384599996, 1.298991598000029],
              [-58.96649938999994, 1.310153707000055],
              [-58.97202466099995, 1.312311316000148],
              [-59.01109615099995, 1.327568664000083],
              [-59.177959350999885, 1.357127584000111],
              [-59.24214147999993, 1.377798157000129],
              [-59.25991817199986, 1.387435812000149],
              [-59.27242386899985, 1.404153138000098],
              [-59.29381791199995, 1.452108867000035],
              [-59.30218949399995, 1.462960918000078],
              [-59.32032792199996, 1.473528748000135],
              [-59.324720418999874, 1.490762838000123],
              [-59.32694250499986, 1.509521383000035],
              [-59.338569701999916, 1.52463673900013],
              [-59.347690592999896, 1.526032003000111],
              [-59.36802526899993, 1.520399271000088],
              [-59.38016922999992, 1.523344828000077],
              [-59.38386409599994, 1.527892354000116],
              [-59.39096960499995, 1.5436536670001],
              [-59.39463863099985, 1.549441427000076],
              [-59.399728759999846, 1.552025249000081],
              [-59.41210526599991, 1.553265483000104],
              [-59.41683365899988, 1.555280864000068],
              [-59.42587703499993, 1.565952046000064],
              [-59.44551407899988, 1.601014506000084],
              [-59.45476415999988, 1.611323954000085],
              [-59.486002563999875, 1.636076965000115],
              [-59.50282324199995, 1.657651876000074],
              [-59.530728515999925, 1.703075460000107],
              [-59.55147660399987, 1.720516256000053],
              [-59.57271561699994, 1.727156677000067],
              [-59.5905698249999, 1.724908752000147],
              [-59.607933104999915, 1.719999492000113],
              [-59.628164428999895, 1.718810933000086],
              [-59.639662434999934, 1.721756490000089],
              [-59.64981685399988, 1.727001648000027],
              [-59.658963582999974, 1.73408131900004],
              [-59.68084855099991, 1.757387390000076],
              [-59.68247635899988, 1.765603943000102],
              [-59.66648250399993, 1.787101339000046],
              [-59.6454760339999, 1.827693176000082],
              [-59.64645788599998, 1.839966329000021],
              [-59.64911922199991, 1.841361593000087],
              [-59.65547542399992, 1.839707947000136],
              [-59.66798111999992, 1.842705180000053],
              [-59.705575724999846, 1.857407125000051],
              [-59.7172287599999, 1.858053080000033],
              [-59.737511759999904, 1.85079254200005],
              [-59.749681559999914, 1.85130930600009],
              [-59.75875077299989, 1.862135518000045],
              [-59.76355668199989, 1.882573548000082],
              [-59.76513281299992, 1.904639384000077],
              [-59.76453853399997, 1.9205298870001],
              [-59.760869507999956, 1.931924540000097],
              [-59.74836380999997, 1.95125152600005],
              [-59.743816283999934, 1.961845194000119],
              [-59.74280859399994, 1.970966085000015],
              [-59.74534073899994, 1.997166036000124],
              [-59.74353206399985, 2.005666810000122],
              [-59.73779598099989, 2.02222910600004],
              [-59.73709834899989, 2.030419821000066],
              [-59.74040563999989, 2.041401063000137],
              [-59.75146439699992, 2.06225250300011],
              [-59.75296301299991, 2.075455831000099],
              [-59.74983658899987, 2.085971985000057],
              [-59.738571126999915, 2.103619487000046],
              [-59.73539302599994, 2.113515524000135],
              [-59.73585811399997, 2.123721619000108],
              [-59.744979003999845, 2.153513082000103],
              [-59.74575415099986, 2.19082346600004],
              [-59.74022477199995, 2.229477438000046],
              [-59.741697550999874, 2.263790588000063],
              [-59.76324662399992, 2.287975159000041],
              [-59.77226416099995, 2.290352275000089],
              [-59.79184952799997, 2.290869039000114],
              [-59.80120296299992, 2.292729390000119],
              [-59.8136311449999, 2.299188945000083],
              [-59.84424943099992, 2.325440572000019],
              [-59.88406612199992, 2.346007792000108],
              [-59.903134724999916, 2.359598694000098],
              [-59.91344417399992, 2.378718974000094],
              [-59.91181636599987, 2.387814026000072],
              [-59.90150691699998, 2.404505513000103],
              [-59.90181697699995, 2.41561594700002],
              [-59.90403906299986, 2.42620961500009],
              [-59.905072591999954, 2.447862041000079],
              [-59.90677791399992, 2.458765767000045],
              [-59.9358459069999, 2.523878072000045],
              [-59.93951493299991, 2.542998352000041],
              [-59.93923071399993, 2.555452372000019],
              [-59.940729328999936, 2.56299713100006],
              [-59.94902339699988, 2.57984364800005],
              [-59.953131673999906, 2.583926086000048],
              [-59.96602494399991, 2.588680318000044],
              [-59.97098588099996, 2.592556051000088],
              [-59.97026241099985, 2.595759989000072],
              [-59.965327311999914, 2.608058981000099],
              [-59.96504309099993, 2.613433329000074],
              [-59.996462361999875, 2.674773255000034],
              [-60.000079711999945, 2.69404856400007],
              [-59.99372351099993, 2.857294414000123],
              [-59.972975422999895, 2.939304911000107],
              [-59.97041743999989, 2.960440572000053],
              [-59.97398311399988, 3.017646382000095],
              [-59.96922888199987, 3.042709453000015],
              [-59.95938452099989, 3.06648061100006],
              [-59.932667806999945, 3.110043844000103],
              [-59.92737097199989, 3.114332988000072],
              [-59.920756388999905, 3.116761780000033],
              [-59.9148652749999, 3.119965719000092],
              [-59.911609659999925, 3.126425273000052],
              [-59.91269486499991, 3.133401591000052],
              [-59.92018794799995, 3.143995260000025],
              [-59.92155737299993, 3.150093079000087],
              [-59.91837927299986, 3.15283192900003],
              [-59.90571854699991, 3.154795634000067],
              [-59.903212239999846, 3.15867136700011],
              [-59.90543432699994, 3.165234274000099],
              [-59.91393509899987, 3.174639385000148],
              [-59.91685481799993, 3.181150615000121],
              [-59.916673949999904, 3.194173076000055],
              [-59.91150630699988, 3.201872864000052],
              [-59.904245767999925, 3.208229065000083],
              [-59.89763118599993, 3.217375794000063],
              [-59.884014444999934, 3.262540995000037],
              [-59.879621948999926, 3.272566223000055],
              [-59.8537320559999, 3.315380148000088],
              [-59.84319006399994, 3.349021505000039],
              [-59.83998612499997, 3.349874166000063],
              [-59.83368159999995, 3.350287578000078],
              [-59.82680863499988, 3.351941223000026],
              [-59.8217701829999, 3.356592102000093],
              [-59.820995035999914, 3.363490906000067],
              [-59.82709285499996, 3.376694234000055],
              [-59.82848811899993, 3.383412171000074],
              [-59.82404394599993, 3.431677959000083],
              [-59.841355550999936, 3.425399272000078],
              [-59.83853918499997, 3.443020935000078],
              [-59.8213567709999, 3.484387919000113],
              [-59.82954748599991, 3.509761048000101],
              [-59.84763423699994, 3.530457459000033],
              [-59.86303381399992, 3.552368266000087],
              [-59.86287878399989, 3.581720479000055],
              [-59.83766068499992, 3.60928985700005],
              [-59.755546834999905, 3.638125305000088],
              [-59.71764217199993, 3.673213603000107],
              [-59.69505957099997, 3.683057963000095],
              [-59.68622290099998, 3.690215149000039],
              [-59.68012508199993, 3.701687317000051],
              [-59.67955664099986, 3.710343120000104],
              [-59.680771036999914, 3.719153951000095],
              [-59.68015091999993, 3.731117045000047],
              [-59.67180517599988, 3.756231792000079],
              [-59.65911861199993, 3.768918355000025],
              [-59.618294230999936, 3.787185974000082],
              [-59.598605509999885, 3.80240468300012],
              [-59.59540157099991, 3.816538188000067],
              [-59.59971655299998, 3.833126322000069],
              [-59.602507079999924, 3.855683085000095],
              [-59.59633174699985, 3.875888570000086],
              [-59.58178483099991, 3.899194641000108],
              [-59.56315547799994, 3.918185730000076],
              [-59.5445777999999, 3.925704651000032],
              [-59.53470760099992, 3.927099915000099],
              [-59.52922989999993, 3.931905823000108],
              [-59.5276537689999, 3.939528097000078],
              [-59.52959163399993, 3.949449971000078],
              [-59.53682633499989, 3.957692362000017],
              [-59.5486860769999, 3.961929830000059],
              [-59.58038956699991, 3.96712331100008],
              [-59.59000138399995, 3.966709900000069],
              [-59.59628007099994, 3.97063730900004],
              [-59.59537573299991, 3.996372172000122],
              [-59.59971655299998, 4.002263285000112],
              [-59.605736857999915, 4.00714670800005],
              [-59.61981868499993, 4.032726543000095],
              [-59.65369258699994, 4.064197489000136],
              [-59.66325272699993, 4.079726258000065],
              [-59.660100463999896, 4.103187357000138],
              [-59.64899003099987, 4.119801330000058],
              [-59.646173665999896, 4.13403818700003],
              [-59.66736100299994, 4.150574646000024],
              [-59.71032995699994, 4.164449768000082],
              [-59.7267372229999, 4.176464539000051],
              [-59.73846777399987, 4.2027678420001],
              [-59.74043147799992, 4.21364573200006],
              [-59.740534830999934, 4.222327372000024],
              [-59.73795100899994, 4.240000712000025],
              [-59.73552221699987, 4.245840149000102],
              [-59.72660803299996, 4.257699891000115],
              [-59.724489298999885, 4.264056091000057],
              [-59.726556355999946, 4.270696513000061],
              [-59.736684935999904, 4.282091167000146],
              [-59.73846777399987, 4.28658701600007],
              [-59.72779658999988, 4.30529388400015],
              [-59.69361263099998, 4.340692240000081],
              [-59.68738562099989, 4.364463399000044],
              [-59.687115057999904, 4.371465559000043],
              [-59.68673966499992, 4.381180725000078],
              [-59.69046036799992, 4.384462179000067],
              [-59.70195837499995, 4.385650737000091],
              [-59.7135080569999, 4.389371440000104],
              [-59.72234472699989, 4.397717184000072],
              [-59.72991532399996, 4.407535706000132],
              [-59.73795100899994, 4.415571391000114],
              [-59.79626786299988, 4.448205058000084],
              [-59.80962622099992, 4.465749207000059],
              [-59.817687744999915, 4.456835022000035],
              [-59.82624019399992, 4.454612936000032],
              [-59.84763423699994, 4.460245667000066],
              [-59.85236262999993, 4.460762431000092],
              [-59.86324051999989, 4.460659078000077],
              [-59.86763301599987, 4.461976827000029],
              [-59.871689615999884, 4.468229675000117],
              [-59.868847411999894, 4.48091624000007],
              [-59.872929849999906, 4.484688620000099],
              [-59.88582311999991, 4.484740296000027],
              [-59.90527929699991, 4.47528350900005],
              [-59.91455521699993, 4.474353333000096],
              [-59.919929564999876, 4.479210917000017],
              [-59.93429561399998, 4.498253683000087],
              [-59.943313151999945, 4.50391225200012],
              [-59.953131673999906, 4.505875956000054],
              [-59.96468135699985, 4.506496074000026],
              [-59.97455155499992, 4.503705546000063],
              [-59.9788923749999, 4.495411479000026],
              [-59.98455094499994, 4.488796895000107],
              [-59.99697912599993, 4.490760600000058],
              [-60.02069860899988, 4.498873800000055],
              [-60.04018062399987, 4.495928243000051],
              [-60.05560603899994, 4.49158742200008],
              [-60.06625138399994, 4.494326274000116],
              [-60.07154821799989, 4.512542216000071],
              [-60.07687089099991, 4.519957785000088],
              [-60.087774617999884, 4.525538839000092],
              [-60.098600830999914, 4.526003927000119],
              [-60.10384598799996, 4.517994080000051],
              [-60.106197265999896, 4.506599427000054],
              [-60.11201086399987, 4.502155253000055],
              [-60.12092504899991, 4.502361959000012],
              [-60.132862304999946, 4.504868266000088],
              [-60.148778645999954, 4.513007304000098],
              [-60.15999243199991, 4.527786763000108],
              [-60.164850016999935, 4.546209412000024],
              [-60.16154272499992, 4.565200500000074],
              [-60.134826008999966, 4.593545024000079],
              [-60.12622188399993, 4.594991964000073],
              [-60.10614558899988, 4.595353699000071],
              [-60.097076374999915, 4.598557638000045],
              [-60.08769710299987, 4.607523499000081],
              [-60.08428645899994, 4.616928610000031],
              [-60.083201253999846, 4.627083028000087],
              [-60.080669108999956, 4.638322652000042],
              [-60.0756306559999, 4.650285747000098],
              [-60.047053588999916, 4.691756084000062],
              [-60.03847530199988, 4.708008321000079],
              [-60.032454996999945, 4.725423279000012],
              [-60.0300778809999, 4.744362691000063],
              [-60.03452205499991, 4.787796733000064],
              [-60.02046606499991, 4.832290141000044],
              [-60.017959757999904, 4.892234802000132],
              [-60.01100927799993, 4.921716207000131],
              [-60.003593708999915, 4.939828796000072],
              [-60.0002089029999, 4.958328960000088],
              [-59.99927872799995, 4.996879578000062],
              [-59.98150203499992, 5.057418518000105],
              [-59.983104004999944, 5.085943909000065],
              [-60.01100927799993, 5.100025737000095],
              [-60.055115112999914, 5.125088806000093],
              [-60.075734008999916, 5.140824280000075],
              [-60.08870391499994, 5.155393807000038],
              [-60.09123693899991, 5.158239238000107],
              [-60.12301794499987, 5.231852316000101],
              [-60.13172542399994, 5.243401998000053],
              [-60.1765547279999, 5.227149760000131],
              [-60.190946614999916, 5.239939677000109],
              [-60.20030004899988, 5.263452453000099],
              [-60.21342586299991, 5.267224833000029],
              [-60.25520625899989, 5.256450297000086],
              [-60.27373225999992, 5.247355245000023],
              [-60.314065714999884, 5.206918436000123],
              [-60.33308264199994, 5.193766785000065],
              [-60.35499344899989, 5.193172506000096],
              [-60.39894425499992, 5.208313700000105],
              [-60.41979569599991, 5.207228496000113],
              [-60.42741796899986, 5.200768942000067],
              [-60.439122680999844, 5.181390279000098],
              [-60.44896704099992, 5.174233094000058],
              [-60.45635677099992, 5.174698181000082],
              [-60.46312638399988, 5.180020853000116],
              [-60.47002518699995, 5.186867981000091],
              [-60.47749243199988, 5.19193227100007],
              [-60.4974136969999, 5.195937195000056],
              [-60.55384436099993, 5.188056539000101],
              [-60.56828792399995, 5.189710185000067],
              [-60.579398356999945, 5.19485199000006],
              [-60.58970780399997, 5.201208191000077],
              [-60.60177425199993, 5.206582540000042],
              [-60.61355647799985, 5.208933818000077],
              [-60.672958536999886, 5.213016256000088],
              [-60.69517940299991, 5.211931051000093],
              [-60.73985367899988, 5.202138367000131],
              [-60.8169032399999, 5.285079041000074],
              [-60.89266088899987, 5.368562317000055],
              [-60.9684960539999, 5.452071432000139],
              [-61.04425370299987, 5.535606385000051],
              [-61.12001135299994, 5.619115499000131],
              [-61.19582067899995, 5.702676290000042],
              [-61.271604166999936, 5.786107890000011],
              [-61.34736181699992, 5.869668681000107],
              [-61.37960791099988, 5.905299581000094],
              [-61.39671280899992, 5.945581360000034],
              [-61.38627417099991, 5.956588440000118],
              [-61.352762003999885, 5.975191956000074],
              [-61.3380858969999, 5.986793314000039],
              [-61.291189534999944, 6.061155701000132],
              [-61.278554646999936, 6.093040060000092],
              [-61.26938208099995, 6.107225240000062],
              [-61.25610123699994, 6.114382426000091],
              [-61.222924967999916, 6.120531921000065],
              [-61.20651770099994, 6.125777079000088],
              [-61.19447709099998, 6.132856750000116],
              [-61.18473608499994, 6.146008403000096],
              [-61.173987386999926, 6.171639913000149],
              [-61.16111995499992, 6.182879537000105],
              [-61.14734818499997, 6.185049948000099],
              [-61.13269791699989, 6.183551331000089],
              [-61.12156164499987, 6.18665191600013],
              [-61.118357706999916, 6.202568258000056],
              [-61.11804764899992, 6.216236674000072],
              [-61.11285416699991, 6.254141337000078],
              [-61.11479203299993, 6.264011536000055],
              [-61.11794429499989, 6.267241313000042],
              [-61.12135493999992, 6.269463400000035],
              [-61.124145467999966, 6.276233012000077],
              [-61.1290805669999, 6.283312683000091],
              [-61.1467022299999, 6.294216411000065],
              [-61.15197322599994, 6.303363139000055],
              [-61.159492146999895, 6.331268412000028],
              [-61.16091324899986, 6.342353007000042],
              [-61.1548154299999, 6.390567119000139],
              [-61.14993200799998, 6.404442241000112],
              [-61.14109533799987, 6.416457011000077],
              [-61.13897660299992, 6.42480275500013],
              [-61.13856319199991, 6.433070984000082],
              [-61.1397517499999, 6.441261698000105],
              [-61.1425939529999, 6.449426575000132],
              [-61.15347184299995, 6.464361064000087],
              [-61.16303198299994, 6.49428171800011],
              [-61.17086096199995, 6.509242045000079],
              [-61.18613134799992, 6.523323873000024],
              [-61.20008398499991, 6.531101176000035],
              [-61.209669962999925, 6.540971375000098],
              [-61.211969563999844, 6.561435242000073],
              [-61.2047865399999, 6.595825908000108],
              [-61.19018794799993, 6.632877909000072],
              [-61.17065425599992, 6.668508810000063],
              [-61.1393124999999, 6.704449768000117],
              [-61.12982987499993, 6.715844421000028],
              [-61.11096797699989, 6.719513449000118],
              [-61.08905716999993, 6.717498067000065],
              [-61.07040197799998, 6.711865336000045],
              [-61.06122941099997, 6.730081279000089],
              [-61.04006791199993, 6.726980693000144],
              [-61.01867386999993, 6.720443624000069],
              [-61.0002512209999, 6.734370422000055],
              [-60.9545950939999, 6.728737691000035],
              [-60.93382116699988, 6.73173492500004],
              [-60.92836930399997, 6.735869039000065],
              [-60.90123917699992, 6.764420268000023],
              [-60.89948217799994, 6.768554383000051],
              [-60.89906876699993, 6.776770935000073],
              [-60.90129085299992, 6.786021016000092],
              [-60.9111610519999, 6.800025329000093],
              [-60.913383137999915, 6.811213277000121],
              [-60.90756953999994, 6.815244039000035],
              [-60.89457291699989, 6.81415883400004],
              [-60.872403727999966, 6.808112692000094],
              [-60.86571162999985, 6.803306783000082],
              [-60.85852860499992, 6.796459656000124],
              [-60.8496144209999, 6.789948426000052],
              [-60.83762548799993, 6.786356913000077],
              [-60.8282978929999, 6.787132059000086],
              [-60.80525020399992, 6.792480571000041],
              [-60.79351965299995, 6.793824158000106],
              [-60.77305578599987, 6.788423971000043],
              [-60.73646887199993, 6.764782003000022],
              [-60.72153438299998, 6.75969187400004],
              [-60.70034704699992, 6.76708160400004],
              [-60.68414648499993, 6.784031474000045],
              [-60.65580196199991, 6.824571635000069],
              [-60.63954972399992, 6.837723287000131],
              [-60.62068782599988, 6.845888164000058],
              [-60.54872839399994, 6.863096415000129],
              [-60.420958414999916, 6.942213034000119],
              [-60.394190022999936, 6.948465881000033],
              [-60.37734350599996, 6.938544007000118],
              [-60.368093424999955, 6.988101705000091],
              [-60.35969600399997, 7.004896546000055],
              [-60.34458064799986, 7.017608948000102],
              [-60.32755326399993, 7.028564352000089],
              [-60.3134197599999, 7.040243225000069],
              [-60.303575398999925, 7.054144185000041],
              [-60.29579809599991, 7.070732321000051],
              [-60.291586466999945, 7.088302307000021],
              [-60.292335774999884, 7.105252177000125],
              [-60.29993221099994, 7.121013489000106],
              [-60.31282548099992, 7.132589009000057],
              [-60.34757788099998, 7.151915995000095],
              [-60.34827287499991, 7.152684071000053],
              [-60.360109416999876, 7.16576527900007],
              [-60.372020833999926, 7.172276509000127],
              [-60.3851724859999, 7.17331003800011],
              [-60.40147640099991, 7.170881246000064],
              [-60.41581660999992, 7.171346334000077],
              [-60.42674617499998, 7.176875713000086],
              [-60.43713313799992, 7.183748678000057],
              [-60.449509643999875, 7.18834788],
              [-60.47532202199989, 7.188502910000054],
              [-60.49661271199997, 7.1805964160001],
              [-60.51286494999988, 7.165196839000103],
              [-60.53490494799988, 7.125767721000102],
              [-60.54800492399994, 7.125509338000128],
              [-60.61763891599995, 7.180389710000043],
              [-60.62841345299998, 7.191138408000057],
              [-60.64306372099986, 7.22090403200005],
              [-60.64355464699989, 7.250669658000035],
              [-60.63110062699991, 7.277696432000084],
              [-60.60676102799991, 7.299452209000094],
              [-60.60223933999987, 7.306531881000112],
              [-60.59996557699995, 7.313921610000122],
              [-60.599862223999935, 7.321879781000078],
              [-60.60177425199993, 7.330148011000034],
              [-60.61055924499993, 7.343635559000091],
              [-60.622005574999946, 7.371540833000083],
              [-60.628981892999946, 7.38435658800006],
              [-60.63608740299986, 7.389834290000053],
              [-60.64515661699994, 7.393399963000107],
              [-60.65324397799992, 7.398464254000089],
              [-60.657274739999934, 7.408127747000023],
              [-60.65691300499992, 7.416551005000102],
              [-60.65582779999994, 7.422855530000021],
              [-60.65626704999994, 7.428798320000041],
              [-60.66063370799992, 7.436136373000124],
              [-60.674198771999926, 7.445489807000072],
              [-60.6881255699999, 7.448642070000034],
              [-60.70065710499992, 7.453499655000144],
              [-60.723833984999914, 7.495822652000044],
              [-60.729699259999904, 7.510343730000088],
              [-60.73057775899994, 7.525433248000084],
              [-60.7164959319999, 7.551581523000095],
              [-60.67114986199991, 7.566050924000123],
              [-60.65562109399988, 7.585222880000046],
              [-60.64148758999994, 7.610906067000116],
              [-60.63169490599998, 7.624600322000035],
              [-60.625157836999904, 7.629457906000056],
              [-60.61066259799986, 7.626822408000038],
              [-60.60125748699991, 7.633850403000054],
              [-60.59745926999997, 7.646717834000043],
              [-60.599862223999935, 7.661548971000073],
              [-60.58451432299995, 7.688524068000106],
              [-60.58441096999994, 7.69937611900005],
              [-60.587718261999925, 7.718341370000104],
              [-60.58699479199993, 7.727126363000096],
              [-60.582085530999905, 7.736324769000092],
              [-60.55958044499988, 7.763041483000052],
              [-60.53984004799992, 7.800093486000023],
              [-60.52575821999989, 7.813374329000027],
              [-60.50327897199989, 7.820867412000069],
              [-60.418503784999956, 7.819368795000059],
              [-60.37475968499987, 7.823606263000016],
              [-60.35042008499994, 7.841796367000143],
              [-60.34241023799987, 7.864792379000093],
              [-60.32034440099997, 7.884739482000029],
              [-60.271871907999895, 7.917760722000082],
              [-60.267998436999875, 7.921262469000098],
              [-60.253294229999966, 7.934555562000057],
              [-60.24301061999995, 7.950575256000107],
              [-60.23112504099993, 7.964114482000085],
              [-60.18309179699989, 7.982666321000124],
              [-60.16572851599997, 7.997032369000124],
              [-60.14978633699994, 8.013465475000089],
              [-60.129219116999934, 8.02881337500007],
              [-60.10790258899996, 8.035557150000088],
              [-60.06800838299992, 8.03175893200006],
              [-60.046485148999864, 8.032921652000084],
              [-60.02958695499987, 8.04281768800007],
              [-60.019458373999925, 8.060310161000118],
              [-60.01100927799993, 8.100436911000116],
              [-59.99933040399995, 8.115397237000082],
              [-59.99801265499991, 8.127050273000052],
              [-60.000544799999886, 8.138548279000076],
              [-60.00067399099993, 8.15294016500009],
              [-59.99331009899993, 8.168520609000026],
              [-59.967678588999945, 8.188390198000121],
              [-59.95705908199997, 8.200146587000106],
              [-59.939721638999856, 8.208440654000071],
              [-59.88975052899988, 8.21988698300008],
              [-59.86920914699991, 8.22112721800002],
              [-59.84846105999986, 8.227741801000107],
              [-59.82928910299995, 8.245105083000041],
              [-59.81665421599993, 8.267196757000121],
              [-59.81559484899992, 8.287763977000026],
              [-59.8556182449999, 8.352126974000015],
              [-59.95969458099998, 8.46816640300004],
              [-60.02098548099991, 8.558010158000059],
              [-60.00108801999994, 8.548895575000074],
              [-59.96816972599993, 8.52757396000004],
              [-59.932484503999945, 8.491766669000071],
              [-59.87531490799995, 8.405218817000048],
              [-59.83779863199993, 8.369289455000057],
              [-59.80939693899995, 8.354681708000044],
              [-59.76056881399995, 8.341498114000046],
              [-59.73542232999995, 8.328924872000073],
              [-59.680572068999936, 8.289211330000057],
              [-59.65184485599991, 8.27366771000004],
              [-59.62218176999994, 8.267523505000042],
              [-59.61310787699995, 8.252142645000049],
              [-59.61123613199993, 8.250148830000057],
              [-59.60985266799992, 8.24209219000005],
              [-59.60594641799992, 8.240301825000074],
              [-59.599720831999946, 8.24095286700009],
              [-59.54344641799992, 8.22947825700004],
              [-59.53612219999991, 8.222479559000078],
              [-59.52301998599995, 8.20648834800005],
              [-59.43374589799993, 8.13031647300005],
              [-59.45677649599992, 8.167222398000092],
              [-59.49168860599991, 8.201320705000057],
              [-59.53355872299994, 8.228908596000053],
              [-59.608631964999915, 8.259426174000055],
              [-59.70067298099991, 8.322739976000037],
              [-59.76130123599995, 8.35545482000009],
              [-59.769520636999914, 8.366522528000075],
              [-59.78184973899994, 8.394191799000055],
              [-59.77953040299991, 8.407131252000056],
              [-59.755848761999914, 8.41087474200009],
              [-59.73936926999994, 8.403631903000075],
              [-59.703968878999945, 8.375555731000077],
              [-59.66323808499993, 8.363470770000049],
              [-59.64338131399995, 8.350002346000053],
              [-59.61123613199993, 8.322739976000037],
              [-59.54539954299992, 8.283758856000077],
              [-59.45409094999991, 8.242621161000045],
              [-59.34788977799991, 8.166815497000073],
              [-59.16515051999994, 8.058742580000057],
              [-59.1048070949999, 8.013617255000042],
              [-59.09012937999995, 8.000027174000081],
              [-59.07542998799994, 7.98078941700004],
              [-59.02143289399993, 7.93100206400004],
              [-58.884751930999926, 7.778687500000046],
              [-58.83341638099995, 7.738300239000068],
              [-58.804192893999925, 7.696217931000092],
              [-58.77861695799993, 7.662363706000065],
              [-58.754053349999936, 7.612114488000088],
              [-58.73762950199995, 7.58833420600007],
              [-58.7339180429999, 7.594694043000061],
              [-58.743901508999954, 7.619352058000061],
              [-58.74200435999995, 7.630278444000055],
              [-58.72821716899995, 7.629295072000048],
              [-58.70343372499991, 7.620962696000049],
              [-58.682377268999915, 7.603534104000062],
              [-58.66316323399991, 7.585201298000072],
              [-58.646717044999946, 7.565057085000092],
              [-58.63029246699995, 7.54035108700009],
              [-58.609314611999935, 7.506494794000048],
              [-58.584055141999954, 7.475775458000044],
              [-58.56818026299993, 7.45334061300008],
              [-58.48973548099991, 7.376125393000052],
              [-58.471587693999936, 7.345404364000046],
              [-58.46422278599994, 7.312201239000046],
              [-58.47419186099995, 7.279974677000041],
              [-58.467355923999946, 7.28742096600007],
              [-58.47252356699994, 7.24445221600007],
              [-58.467355923999946, 7.116115627000056],
              [-58.48501542899993, 7.010809637000079],
              [-58.4973852199999, 6.994818427000041],
              [-58.519602016999954, 6.97764720300006],
              [-58.53563391799992, 6.965277411000045],
              [-58.55068925699993, 6.947088934000078],
              [-58.56159420499995, 6.927232164000088],
              [-58.56818600199995, 6.906805731000077],
              [-58.57404537699995, 6.868394273000092],
              [-58.597727016999954, 6.808294989000046],
              [-58.59984290299991, 6.787258205000057],
              [-58.597727016999954, 6.721625067000048],
              [-58.59984290299991, 6.711330471000053],
              [-58.60920162699995, 6.698919989000046],
              [-58.611398891999954, 6.68781159100007],
              [-58.611398891999954, 6.509711005000042],
              [-58.61701412699995, 6.48814524900007],
              [-58.61994381399995, 6.47687409100007],
              [-58.686431443999936, 6.382473049000055],
              [-58.68224036399994, 6.379828192000048],
              [-58.67959550699993, 6.376206773000092],
              [-58.64883378799993, 6.404201565000051],
              [-58.638661261999914, 6.410345770000049],
              [-58.635609503999945, 6.41437409100007],
              [-58.632923956999946, 6.420070705000057],
              [-58.628895636999914, 6.423325914000088],
              [-58.61538652299993, 6.417385158000059],
              [-58.60680091099994, 6.41632721600007],
              [-58.60214918316576, 6.416563743893611],
              [-58.601999477999925, 6.416571356000077],
              [-58.59024003799993, 6.417222398000092],
              [-58.597727016999954, 6.423407294000071],
              [-58.58116614499994, 6.463446356000077],
              [-58.57721920499995, 6.594712632000039],
              [-58.56700598899994, 6.636704820000091],
              [-58.46153723899994, 6.821844794000071],
              [-58.4348852199999, 6.857814846000053],
              [-58.398426886999914, 6.883368231000077],
              [-58.354400193999936, 6.894354559000078],
              [-58.312163865999935, 6.892157294000071],
              [-58.27383378799993, 6.880519924000055],
              [-58.214100714999915, 6.849188544000071],
              [-58.19448808499993, 6.830959377000056],
              [-58.189564581999946, 6.828111070000091],
              [-58.18651282499991, 6.82453034100007],
              [-58.17821204299992, 6.817572333000044],
              [-58.17369544199994, 6.815375067000048],
              [-58.16966712099992, 6.813421942000048],
              [-58.165679490999935, 6.817857164000088],
              [-58.162220831999946, 6.82953522300005],
              [-58.15371660099993, 6.832220770000049],
              [-58.06786340499991, 6.821702861000063],
              [-58.005674540999905, 6.79175788200007],
              [-57.98581301699994, 6.775223291000088],
              [-57.95605476499992, 6.752912016000039],
              [-57.91859667499995, 6.716302682000048],
              [-57.89189130199992, 6.696441843000059],
              [-57.838075396999955, 6.645302221000065],
              [-57.80613834899992, 6.613178006000055],
              [-57.79698615299992, 6.598146822000047],
              [-57.77885743799993, 6.590347242000064],
              [-57.75698131199994, 6.567700740000078],
              [-57.69962545299995, 6.521614996000039],
              [-57.667938585999934, 6.495933437000076],
              [-57.646819242999925, 6.477809403000037],
              [-57.63325259299995, 6.463473072000056],
              [-57.618175109999925, 6.448377075000053],
              [-57.59857774699992, 6.427246229000048],
              [-57.57799231699994, 6.378159898000092],
              [-57.5476220189999, 6.307144584000071],
              [-57.536673478999944, 6.293162901000073],
              [-57.53352244899992, 6.273656378000055],
              [-57.52891272499994, 6.265709146000063],
              [-57.52042734199995, 6.277992549000089],
              [-57.51869212199995, 6.287130867000087],
              [-57.517041976999906, 6.298223379000092],
              [-57.517037168999934, 6.315075983000042],
              [-57.5041918309999, 6.32903953400006],
              [-57.4942612719999, 6.334821824000073],
              [-57.490632656999935, 6.338920939000047],
              [-57.48607043299995, 6.339505005000092],
              [-57.4663702279999, 6.337906198000042],
              [-57.44559134699995, 6.330366451000089],
              [-57.428944809999905, 6.322750581000093],
              [-57.408800535999944, 6.312764897000079],
              [-57.37743079299992, 6.294338283000059],
              [-57.36504404699991, 6.287483771000041],
              [-57.330466189999925, 6.264391639000053],
              [-57.28982366999992, 6.234738597000046],
              [-57.20749372999995, 6.151377836000052],
              [-57.18665981799995, 6.121188246000088],
              [-57.167307094999956, 6.085109768000052],
              [-57.15843665299991, 6.04437897300005],
              [-57.15535746899991, 6.019666901000051],
              [-57.15188838499995, 6.007802647000062],
              [-57.14675216699993, 5.99758987000007],
              [-57.14443593499993, 5.989022398000088],
              [-57.14361322499991, 5.977984624000044],
              [-57.158314581999946, 5.998928127000056],
              [-57.16576087099992, 6.005682684000078],
              [-57.1479260239999, 5.96991618900006],
              [-57.141964524999935, 5.955741944000067],
              [-57.141683996999916, 5.93417812000007],
              [-57.14000403599994, 5.917914130000042],
              [-57.13725897599994, 5.882091552000077],
              [-57.15367591099994, 5.84711334800005],
              [-57.158192511999914, 5.828599351000094],
              [-57.16543535099993, 5.811346747000073],
              [-57.1700205759999, 5.799621837000075],
              [-57.17061466799993, 5.779035644000089],
              [-57.18067573399992, 5.754928247000066],
              [-57.18305467199991, 5.731410052000058],
              [-57.15957320399991, 5.69291198500008],
              [-57.16151750599994, 5.638905690000058],
              [-57.1733287859999, 5.607472667000081],
              [-57.185658331999946, 5.58734772300005],
              [-57.196929490999935, 5.56476471600007],
              [-57.24767005099994, 5.491848049000055],
              [-57.24767005099994, 5.484930731000077],
              [-57.25693965699992, 5.464086202000104],
              [-57.260091918999876, 5.448195699000095],
              [-57.2612288009999, 5.426749980000068],
              [-57.26520788599987, 5.403366395000106],
              [-57.27549149599989, 5.387398377000068],
              [-57.32411901899988, 5.338589987000105],
              [-57.332283894999904, 5.32786712700009],
              [-57.33569453899992, 5.316885885000104],
              [-57.33171545499994, 5.307609965000097],
              [-57.32282710799993, 5.307609965000097],
              [-57.3084093839999, 5.313475240000088],
              [-57.29833247899998, 5.311020610000114],
              [-57.29202795499987, 5.311330668000011],
              [-57.28882401599989, 5.308540141000051],
              [-57.28727372299997, 5.238699442000069],
              [-57.28546504799988, 5.230818787000118],
              [-57.280452433999926, 5.225341085000139],
              [-57.27166743999993, 5.222860616000062],
              [-57.26303747599988, 5.22399749700007],
              [-57.25642289299989, 5.228286641000039],
              [-57.253787394999875, 5.234927063000043],
              [-57.26401932799985, 5.247045186000136],
              [-57.26918697199994, 5.25670867900007],
              [-57.26742997299988, 5.266294657000074],
              [-57.25900671399998, 5.271203919000101],
              [-57.2476378989999, 5.271772360000057],
              [-57.23761267099988, 5.268723450000039],
              [-57.233323526999925, 5.262573954000061],
              [-57.23252170199993, 5.260572120000077],
              [-57.22572709199994, 5.243608704000096],
              [-57.19239579299989, 5.203171896000114],
              [-57.184902709999875, 5.183147278000078],
              [-57.18981197199989, 5.169220480000092],
              [-57.20200760899991, 5.157619121000039],
              [-57.217768921999976, 5.148549907000074],
              [-57.233323526999925, 5.142116191000127],
              [-57.23874955299988, 5.162011617000132],
              [-57.24727616399991, 5.17237274200005],
              [-57.25993688999995, 5.176300150000117],
              [-57.277713582999866, 5.176920268000089],
              [-57.288979044999934, 5.171029155000085],
              [-57.29554195199992, 5.157205709000038],
              [-57.302208211999925, 5.128473612000022],
              [-57.317091023999865, 5.09475474100006],
              [-57.32019160999991, 5.083411764000076],
              [-57.32143184399985, 5.070156759000071],
              [-57.31693599499994, 5.058968811000042],
              [-57.280452433999926, 5.026102600000101],
              [-57.290477660999926, 5.020289001000037],
              [-57.298694214999955, 5.021115824000049],
              [-57.30649735599991, 5.024448955000054],
              [-57.31523067199987, 5.026102600000101],
              [-57.32944169199993, 5.024087220000055],
              [-57.33807165499988, 5.02075408900015],
              [-57.345513060999906, 5.016619975000125],
              [-57.35621008399991, 5.012434184000085],
              [-57.381376505999924, 5.005742086000069],
              [-57.460493122999935, 4.997628886000072],
              [-57.47733963999991, 4.992487081000078],
              [-57.490258748999935, 4.991350199000067],
              [-57.49687333199992, 4.994657491000069],
              [-57.512221232999906, 5.0091527310001],
              [-57.51759558099985, 5.012434184000085],
              [-57.54327876799994, 5.01109059700012],
              [-57.566223103999874, 5.007085673000049],
              [-57.610096394999886, 4.991350199000067],
              [-57.649370482999956, 5.008429260000099],
              [-57.68693924999988, 5.006258851000027],
              [-57.720477253999974, 4.98979990600013],
              [-57.74729732299997, 4.964013367000035],
              [-57.762335164999854, 4.935539653000092],
              [-57.77396236199991, 4.926444601000128],
              [-57.79845699099988, 4.9230597950001],
              [-57.810962687999876, 4.925540263000087],
              [-57.820574503999865, 4.930294495000069],
              [-57.83023799599991, 4.93305918400003],
              [-57.84279536999992, 4.929881083000069],
              [-57.850340128999875, 4.922801412000041],
              [-57.87070064399998, 4.888927511000134],
              [-57.884188191999954, 4.872261861000098],
              [-57.902429972999926, 4.852728170000091],
              [-57.918501342999974, 4.829757996000055],
              [-57.92537430899995, 4.796142476000028],
              [-57.91782954999991, 4.782370707000084],
              [-57.90113806199986, 4.773921611000091],
              [-57.88454992699985, 4.762862854000076],
              [-57.871165730999905, 4.721728414000012],
              [-57.84434566299993, 4.687518616000105],
              [-57.836025756999874, 4.669845276000018],
              [-57.837421020999955, 4.650880025000063],
              [-57.84543086799994, 4.633516744000133],
              [-57.86331091399998, 4.607730204000035],
              [-57.879123901999975, 4.556828918000093],
              [-57.89607377099989, 4.528510234000109],
              [-57.914470580999875, 4.484068502000127],
              [-57.921860310999904, 4.450943909000031],
              [-57.93131709799988, 4.437843933000067],
              [-57.94278926699988, 4.425105693000106],
              [-57.95265946399988, 4.409731954000037],
              [-57.95663854999995, 4.391438497000067],
              [-57.95348628799988, 4.375703024000089],
              [-57.9480602619999, 4.360484314000061],
              [-57.945269734999954, 4.343922018000058],
              [-57.94738846899992, 4.318755595000113],
              [-57.95384802299989, 4.299015198000049],
              [-57.96495845599989, 4.282039490000045],
              [-58.05203324399986, 4.19310435000007],
              [-58.065934203999944, 4.171839498000097],
              [-58.067691202999924, 4.151143087000079],
              [-58.05508215299989, 4.108070780000077],
              [-58.042008015999926, 4.023037211000073],
              [-58.03213781699995, 3.987716370000072],
              [-58.00790157099996, 3.957278951000092],
              [-57.94211747299991, 3.905447490000114],
              [-57.925839396999976, 3.886404724000045],
              [-57.8751448159999, 3.812197368000085],
              [-57.85385412699992, 3.766670430000104],
              [-57.84961665899996, 3.747472636000097],
              [-57.84692948499992, 3.702100729000065],
              [-57.84098669399992, 3.680990906000119],
              [-57.82977290899987, 3.66243906600009],
              [-57.81313309799995, 3.651845398000106],
              [-57.764247192999875, 3.631588236000098],
              [-57.7261099859999, 3.607196961000085],
              [-57.72249263599991, 3.599962260000027],
              [-57.717480021999876, 3.582443950000055],
              [-57.70952185099989, 3.567690329000044],
              [-57.708643351999854, 3.564124654000082],
              [-57.7073514409999, 3.560662334000128],
              [-57.70285559099989, 3.555675558000075],
              [-57.697998005999864, 3.553608500000024],
              [-57.687249307999934, 3.55216156000003],
              [-57.685130574999874, 3.549164327000113],
              [-57.68125484199993, 3.547303976000109],
              [-57.66042924099986, 3.535185852000026],
              [-57.64404781199991, 3.516659851000085],
              [-57.645494751999905, 3.498986511000084],
              [-57.66068762199993, 3.469505107000074],
              [-57.660532592999886, 3.462993877000102],
              [-57.658362182999895, 3.450617371000135],
              [-57.658930623999936, 3.44389943500002],
              [-57.663994913999915, 3.425838521000102],
              [-57.66461503199989, 3.417544454000051],
              [-57.66254797399992, 3.407079976000105],
              [-57.65820715299995, 3.395220235000082],
              [-57.65484818599995, 3.390130107000104],
              [-57.64993892399991, 3.38594431500006],
              [-57.6414639889999, 3.382430318000019],
              [-57.61324865799995, 3.376642558000043],
              [-57.59640214099997, 3.367237447000079],
              [-57.596192593999945, 3.367120724000102],
              [-57.565137898999865, 3.349822490000051],
              [-57.554234171999894, 3.346747742000019],
              [-57.545035766999916, 3.348143006000086],
              [-57.535268920999954, 3.367780050000121],
              [-57.522401489999964, 3.365247904000043],
              [-57.509637410999886, 3.357677307000088],
              [-57.50390132699994, 3.353336487000107],
              [-57.49583980399984, 3.352974752000108],
              [-57.4879849859999, 3.351527812000114],
              [-57.48204219599998, 3.348556417000097],
              [-57.479716755999874, 3.343388774000104],
              [-57.47625443599992, 3.338944601000094],
              [-57.46876135299988, 3.343182068000132],
              [-57.46168168199995, 3.349977518000088],
              [-57.459201212999886, 3.353336487000107],
              [-57.430934204999915, 3.360622864000078],
              [-57.423957886999915, 3.369382019000071],
              [-57.42504309099991, 3.387494609000086],
              [-57.39346879099992, 3.37382619300007],
              [-57.366752075999955, 3.365609639000041],
              [-57.340035359999916, 3.37015716600007],
              [-57.3084093839999, 3.394910177000099],
              [-57.28355301999994, 3.343802185000115],
              [-57.280452433999926, 3.329772034000101],
              [-57.28277787299996, 3.295045471000066],
              [-57.28422481399994, 3.288792623000063],
              [-57.292493041999904, 3.276286926000068],
              [-57.29027095599989, 3.267967021000104],
              [-57.28401810699998, 3.259750468000078],
              [-57.280452433999926, 3.24781321200004],
              [-57.281744344999964, 3.235927632000099],
              [-57.28711869299994, 3.215360412000024],
              [-57.287945516999855, 3.203113099000092],
              [-57.285671752999946, 3.192106018000089],
              [-57.2749230549999, 3.169006653000025],
              [-57.277713582999866, 3.156914368000045],
              [-57.284173136999925, 3.148956197000075],
              [-57.28603348899992, 3.14239329100009],
              [-57.2749230549999, 3.134280091000079],
              [-57.2648978279999, 3.132626444000039],
              [-57.25497595199991, 3.135830384000101],
              [-57.24624263599992, 3.141618144000077],
              [-57.239473022999874, 3.14787099200008],
              [-57.23761267099988, 3.144873759000063],
              [-57.237405965999926, 3.143995260000025],
              [-57.23673417199984, 3.143478495000082],
              [-57.233323526999925, 3.141669820000089],
              [-57.24856807499995, 3.11236928300012],
              [-57.239473022999874, 3.094127503000081],
              [-57.2222130939999, 3.078262838000072],
              [-57.212859659999936, 3.056041972000031],
              [-57.211774455999944, 3.048342184000134],
              [-57.207020223999876, 3.035681458000099],
              [-57.20598669499989, 3.028136699000044],
              [-57.209242309999865, 3.024054261000046],
              [-57.22324662299988, 3.024777730000039],
              [-57.22645056199994, 3.021263733000083],
              [-57.224693562999875, 3.009171448000089],
              [-57.22179968299989, 3.000438131000109],
              [-57.221179564999915, 2.992583313000083],
              [-57.22645056199994, 2.98338490800009],
              [-57.23461543799996, 2.970362448000046],
              [-57.221851358999885, 2.963024394000058],
              [-57.188623412999874, 2.959510397000102],
              [-57.183817504999865, 2.944679261000076],
              [-57.19472123199992, 2.930623271000059],
              [-57.210327514999875, 2.918220927000078],
              [-57.21962927299998, 2.908299052000089],
              [-57.20634842999988, 2.856570943000037],
              [-57.202265991999866, 2.846235657000122],
              [-57.19425614499991, 2.841998189000066],
              [-57.19105220599994, 2.832593078000116],
              [-57.186608031999924, 2.823239644000068],
              [-57.17461909999986, 2.818950501000103],
              [-57.165265665999925, 2.821069234000078],
              [-57.145215209999975, 2.830422669000114],
              [-57.13338130699995, 2.832593078000116],
              [-57.126404988999866, 2.826030171000127],
              [-57.14366491699985, 2.790011698000043],
              [-57.13705033399995, 2.771149801000121],
              [-57.13374304299995, 2.773423564000041],
              [-57.09953324399996, 2.778591207000133],
              [-57.089869750999924, 2.773888652000068],
              [-57.09214351499995, 2.76303660100011],
              [-57.09901647999993, 2.750375875000074],
              [-57.102943887999885, 2.740454],
              [-57.097724568999865, 2.72737986200012],
              [-57.071886352999854, 2.700094707000105],
              [-57.061964477999936, 2.681749573000033],
              [-57.05597001199993, 2.64237213100003],
              [-57.04801184099995, 2.63648101800004],
              [-57.027237914999915, 2.648211568000107],
              [-57.02046830299989, 2.635447489000057],
              [-57.023155476999904, 2.623665263000049],
              [-57.027909708999914, 2.610591125000099],
              [-57.027237914999915, 2.593589580000071],
              [-57.02238033099991, 2.58454620400002],
              [-56.99711055599994, 2.555142314000122],
              [-56.99530188099993, 2.547855937000051],
              [-57.000572875999865, 2.514162903000098],
              [-56.99411332199992, 2.504861146000067],
              [-56.980005655999975, 2.509718730000088],
              [-56.95959346499993, 2.524704895000056],
              [-56.951273559999976, 2.515454814000051],
              [-56.95261714699993, 2.504551086000077],
              [-56.95752640899988, 2.49349233000008],
              [-56.95959346499993, 2.483777161000134],
              [-56.95636368899994, 2.470031230000103],
              [-56.951635294999875, 2.461246236000108],
              [-56.93507299799998, 2.445898336000141],
              [-56.93024125199986, 2.43618316700011],
              [-56.93202408899995, 2.425796204000079],
              [-56.93845780399991, 2.411430155000076],
              [-56.93083553099993, 2.393291728000051],
              [-56.8950496009999, 2.362079163000075],
              [-56.88388749199987, 2.339754944000106],
              [-56.884430093999924, 2.303736471000121],
              [-56.88014095099996, 2.294796448000085],
              [-56.87086503099994, 2.290145569000032],
              [-56.84779150399996, 2.285856425000063],
              [-56.83887731899995, 2.281102193000066],
              [-56.8261907559999, 2.261671855000088],
              [-56.816346395999915, 2.21759185800002],
              [-56.80874995999994, 2.195784404000094],
              [-56.80146358199997, 2.165967103000085],
              [-56.70519038899991, 2.029644674000053],
              [-56.677801879999976, 2.018405050000098],
              [-56.57977168799994, 2.016803080000059],
              [-56.5420737309999, 1.997166036000124],
              [-56.53649267599988, 1.988639425000102],
              [-56.52938716699995, 1.981792298000045],
              [-56.52096390899996, 1.976728007000077],
              [-56.49998327699987, 1.969984232000044],
              [-56.491198282999875, 1.962904562000105],
              [-56.48510046399991, 1.953215231000087],
              [-56.481819010999914, 1.941613871000129],
            ],
          ],
          [
            [
              [-58.378570115999935, 6.97211334800005],
              [-58.33360755099994, 6.965277411000045],
              [-58.33470618399991, 6.961004950000074],
              [-58.39102128799993, 6.919867255000042],
              [-58.44102942599994, 6.904771226000094],
              [-58.46051998599995, 6.883368231000077],
              [-58.46349036399994, 6.900295315000051],
              [-58.45750891799992, 6.923041083000044],
              [-58.44701087099992, 6.943060614000046],
              [-58.431752081999946, 6.954657294000071],
              [-58.42251542899993, 6.968329169000071],
              [-58.41893469999991, 6.97211334800005],
              [-58.40965735599991, 6.973618882000039],
              [-58.378570115999935, 6.97211334800005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Brazil',
        iso3: 'BRA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-57.602792548565105, -30.190516953885325],
              [-57.61169836499991, -30.182962747999937],
              [-57.56865189699991, -30.17655487099998],
              [-57.548601440999875, -30.170043639999918],
              [-57.50617508999994, -30.144308776999935],
              [-57.4114521889999, -30.03961232499998],
              [-57.32515254799995, -29.981011249999952],
              [-57.318744669999916, -29.96550832099986],
              [-57.308512736999944, -29.84851287799995],
              [-57.29151118999991, -29.815129902999985],
              [-57.26257238799985, -29.792598978999962],
              [-57.21962927299998, -29.778336282999902],
              [-57.177461303999934, -29.772858581999913],
              [-57.13338130699995, -29.772135110999912],
              [-57.11286576399988, -29.766037291999865],
              [-57.09415889499991, -29.751981301999933],
              [-57.020933390999915, -29.683355000999896],
              [-57.0135953379999, -29.673123066999906],
              [-57.00884110599992, -29.662581074999935],
              [-56.97938553899991, -29.634985859999944],
              [-56.96579463799992, -29.600879414999966],
              [-56.951635294999875, -29.586306660999924],
              [-56.91241288299992, -29.558401387999936],
              [-56.90435135899992, -29.54961639399994],
              [-56.897271687999904, -29.535663756999952],
              [-56.81903356999993, -29.474995625999966],
              [-56.81495113199995, -29.46703745499991],
              [-56.812935750999884, -29.457115579999922],
              [-56.80756140099993, -29.444713236999945],
              [-56.799835774999934, -29.43396453899993],
              [-56.78342850799987, -29.425799661999903],
              [-56.782033243999905, -29.41660125699991],
              [-56.78255000899992, -29.405439147999886],
              [-56.78081884799988, -29.39531056799993],
              [-56.775780394999884, -29.386422220999904],
              [-56.76994095899991, -29.379084166999917],
              [-56.76270625799995, -29.37288299599993],
              [-56.753559529999876, -29.367405292999933],
              [-56.71813533499994, -29.35148895199991],
              [-56.705500447999896, -29.343737487999917],
              [-56.68865393099992, -29.32957814499987],
              [-56.67702673399987, -29.313351745999867],
              [-56.66064530499992, -29.27087371799992],
              [-56.650465047999944, -29.251340026999912],
              [-56.6572863369999, -29.23790415399995],
              [-56.65630448399992, -29.22343475299992],
              [-56.6506717529999, -29.209068704999922],
              [-56.6436695969999, -29.196149596999916],
              [-56.61728877799993, -29.160906269999927],
              [-56.58421586099985, -29.132277525999953],
              [-56.54830074099988, -29.109953307999987],
              [-56.51331579599989, -29.09372690899997],
              [-56.44427608299992, -29.078120625999944],
              [-56.42797216799988, -29.06985239699989],
              [-56.415750691999875, -29.05135223399988],
              [-56.41192663599992, -29.031818541999954],
              [-56.41091894599995, -28.99130421999986],
              [-56.39161779799991, -28.95223683699993],
              [-56.32306901099989, -28.916476745999915],
              [-56.3010031739999, -28.88144012399991],
              [-56.294827839999925, -28.79576059899992],
              [-56.28614619999988, -28.780154316999884],
              [-56.265475626999944, -28.771989440999874],
              [-56.21845007399986, -28.764134622999933],
              [-56.18470536299989, -28.744187520999915],
              [-56.10300492399989, -28.64806935599998],
              [-56.04081233699989, -28.60900197399988],
              [-56.02189876399987, -28.585747578999957],
              [-56.020503499999876, -28.546266783999926],
              [-56.02295812999995, -28.528283386999945],
              [-56.02143367599993, -28.510403340999886],
              [-56.01158931499995, -28.496554056999926],
              [-55.979136515999954, -28.489216002999925],
              [-55.951592976999876, -28.476710306999934],
              [-55.91908850099992, -28.47340301499993],
              [-55.910665242999926, -28.470509134999944],
              [-55.902035278999904, -28.465134785999894],
              [-55.89805619299992, -28.46069061299997],
              [-55.89691931199991, -28.453455912999914],
              [-55.89666092899992, -28.406843769999952],
              [-55.90038163199995, -28.398472187999886],
              [-55.90560095199996, -28.37800832099991],
              [-55.88735917199992, -28.36333221499993],
              [-55.84234899999987, -28.346382344999924],
              [-55.81253169799987, -28.35320363299988],
              [-55.77119055199995, -28.35754445399995],
              [-55.734603637999896, -28.36591603599993],
              [-55.71884232599993, -28.384519550999883],
              [-55.71496659399986, -28.404466654999908],
              [-55.70569067399995, -28.40767059399988],
              [-55.69424434399994, -28.400125833999923],
              [-55.68406408699988, -28.388033548999942],
              [-55.67737198899994, -28.3738742069999],
              [-55.66360021999992, -28.326538593999928],
              [-55.677216959999924, -28.301837259999914],
              [-55.687216348999925, -28.290055032999916],
              [-55.7014532069999, -28.284990742999938],
              [-55.71470821199989, -28.281890156999907],
              [-55.754602416999944, -28.2656637569999],
              [-55.766591349999885, -28.257602233999904],
              [-55.7725341389999, -28.231970723999936],
              [-55.74793615799993, -28.215744322999925],
              [-55.68406408699988, -28.196210631999918],
              [-55.641999470999934, -28.160347187999974],
              [-55.63254268399987, -28.154662780999928],
              [-55.62383520599991, -28.146187845999933],
              [-55.62304188899989, -28.144350089999932],
              [-55.61665218099995, -28.129548034999914],
              [-55.60474076399993, -28.11693898499989],
              [-55.58164139799993, -28.121073099999904],
              [-55.578540812999904, -28.127480976999948],
              [-55.5793159589999, -28.136369323999958],
              [-55.57709387199992, -28.144327493999924],
              [-55.5648723969999, -28.14773813899994],
              [-55.55347774299989, -28.14556772799996],
              [-55.54973120099987, -28.139883320999914],
              [-55.54828426099988, -28.13223520899993],
              [-55.54376257299995, -28.12417368499986],
              [-55.53787145999985, -28.119316100999924],
              [-55.52479732299989, -28.110634459999872],
              [-55.520223957999946, -28.10681040399993],
              [-55.50991451099995, -28.08396942099992],
              [-55.505935424999876, -28.078905130999942],
              [-55.492964640999844, -28.073944193999907],
              [-55.4865309249999, -28.077148131999962],
              [-55.48231929599987, -28.083142597999895],
              [-55.475498005999896, -28.08634653699997],
              [-55.464852660999924, -28.085106302999932],
              [-55.44074560599995, -28.078905130999942],
              [-55.43508703699993, -28.070740254999933],
              [-55.38984431999992, -28.02423146599999],
              [-55.38338476599998, -28.014206237999957],
              [-55.38142106099994, -28.00872853599988],
              [-55.382428751999925, -27.987334492999963],
              [-55.380930135999904, -27.978239439999896],
              [-55.3764342849999, -27.973175149999918],
              [-55.36909623199989, -27.970798033999884],
              [-55.35886429899992, -27.97028126999993],
              [-55.337909504999914, -27.963149922999904],
              [-55.33302608199989, -27.94661346399991],
              [-55.32987381999993, -27.928113301999886],
              [-55.314112508999955, -27.91498748799991],
              [-55.30176184099989, -27.913953958999926],
              [-55.2807812099999, -27.92056854299993],
              [-55.270084187999885, -27.922428893999935],
              [-55.260239827999925, -27.91922495499996],
              [-55.22404048699988, -27.893800149999947],
              [-55.2123099369999, -27.877160339999932],
              [-55.19773718299993, -27.86062388099994],
              [-55.17755753599994, -27.853595885999923],
              [-55.16146032699987, -27.85824676499989],
              [-55.13970454999986, -27.876746927999918],
              [-55.1192406829999, -27.880881042999945],
              [-55.11138586399997, -27.852975768999954],
              [-55.108698689999926, -27.84677459699988],
              [-55.09993953399996, -27.843777363999962],
              [-55.077899535999876, -27.84336395299995],
              [-55.0677192789999, -27.83933319099995],
              [-55.04580847199995, -27.850702005999935],
              [-55.02963374799995, -27.850702005999935],
              [-55.02580969299993, -27.840160013999977],
              [-55.04043412299998, -27.819489440999874],
              [-55.07125911499986, -27.79437469499993],
              [-55.08115515199995, -27.77825164799995],
              [-55.06430863499989, -27.771016947999982],
              [-55.04464575299994, -27.775047708999892],
              [-55.02759252899992, -27.783005879999862],
              [-55.00911820499988, -27.788380228999912],
              [-54.98519201699989, -27.785279641999878],
              [-54.93299881999991, -27.743835143999902],
              [-54.91320674599993, -27.73691050199993],
              [-54.9069022219999, -27.727091979999955],
              [-54.90157954899988, -27.704457701999914],
              [-54.89646358199988, -27.661152851999944],
              [-54.89827225699986, -27.62363576199995],
              [-54.889797322999954, -27.620638529999937],
              [-54.86540604699994, -27.62084523499989],
              [-54.84509720899993, -27.61185353599994],
              [-54.83700984699993, -27.590459492999926],
              [-54.83367671799991, -27.565344746999912],
              [-54.827527221999844, -27.545087584999905],
              [-54.81889725799991, -27.5361992389999],
              [-54.80504797399993, -27.526380716999924],
              [-54.79223221799995, -27.52317677799995],
              [-54.786547810999906, -27.534235533999947],
              [-54.78853735399994, -27.538576354999933],
              [-54.79212886599993, -27.54426076299997],
              [-54.79373083499988, -27.549221699999933],
              [-54.79001013199985, -27.55128875699998],
              [-54.78802058999992, -27.552839050999907],
              [-54.7816902269999, -27.560073750999976],
              [-54.78034663999992, -27.56214080799994],
              [-54.77393876099998, -27.563794453999975],
              [-54.731899983999966, -27.55128875699998],
              [-54.72195227099988, -27.550978698999913],
              [-54.69967972799992, -27.553045755999875],
              [-54.69032629399996, -27.55128875699998],
              [-54.68112788899987, -27.54643117199997],
              [-54.6772004799999, -27.541780292999903],
              [-54.6764511719999, -27.534235533999947],
              [-54.67668371599987, -27.520592956999863],
              [-54.67347977699998, -27.509740905999905],
              [-54.66645178199988, -27.503849791999897],
              [-54.65947546399988, -27.502816263999918],
              [-54.65619401099988, -27.50726043699993],
              [-54.651233072999844, -27.52586395199998],
              [-54.63952836099986, -27.526794127999935],
              [-54.62591162199996, -27.515321960999913],
              [-54.61524043799997, -27.496718444999956],
              [-54.609814412999896, -27.478528340999915],
              [-54.605318562999884, -27.467986347999954],
              [-54.598497273999925, -27.459098001999934],
              [-54.58945389799996, -27.452586770999872],
              [-54.58382116699994, -27.452070006999932],
              [-54.578550170999904, -27.454240417999927],
              [-54.57054032499991, -27.455687356999917],
              [-54.56723303299992, -27.459614765999973],
              [-54.557621215999916, -27.47780486999993],
              [-54.55379715999996, -27.482972513999925],
              [-54.54325516799992, -27.48700327499992],
              [-54.533539998999885, -27.487416686999936],
              [-54.46858272399993, -27.470260110999973],
              [-54.44837723799992, -27.458891296999894],
              [-54.44765376899994, -27.445765482999917],
              [-54.46455196099993, -27.42333791099992],
              [-54.4608312579999, -27.412589212999904],
              [-54.44455318199988, -27.408971861999916],
              [-54.40424556499994, -27.407421569999897],
              [-54.38889766499997, -27.41114227299991],
              [-54.378717407999915, -27.42271779399995],
              [-54.37499670399998, -27.445765482999917],
              [-54.371586059999856, -27.45444712299988],
              [-54.363472859999945, -27.453516946999926],
              [-54.354326130999965, -27.446282246999957],
              [-54.34771154799998, -27.435843607999928],
              [-54.34610957899994, -27.426541849999893],
              [-54.34771154799998, -27.394295755999934],
              [-54.33401729399995, -27.406077982999932],
              [-54.321511596999954, -27.41951385499989],
              [-54.30693884399989, -27.42891896599994],
              [-54.28688838699995, -27.428402200999898],
              [-54.2819274499999, -27.424371438999913],
              [-54.27489945499988, -27.41610320999986],
              [-54.26859493099997, -27.406388040999914],
              [-54.26580440299992, -27.398016458999948],
              [-54.26125687699988, -27.388714701999916],
              [-54.25071488499992, -27.385200703999956],
              [-54.23924271599989, -27.383857115999902],
              [-54.23164628199993, -27.380549824999903],
              [-54.22957922399988, -27.37197153799987],
              [-54.231801309999895, -27.351507669999904],
              [-54.22792557899993, -27.34303273499991],
              [-54.22255122899986, -27.33683156299992],
              [-54.21815873299997, -27.329286803999963],
              [-54.18952998899991, -27.26086720799988],
              [-54.1770242929999, -27.243400573999935],
              [-54.16477697799988, -27.250635273999904],
              [-54.155940307999884, -27.257663268999906],
              [-54.158059041999934, -27.279470722999932],
              [-54.12819006399994, -27.28887583399998],
              [-54.091758178999925, -27.285155130999968],
              [-54.01811926299993, -27.212291360999885],
              [-54.01088456299996, -27.193997903999914],
              [-54.00514847799991, -27.18821014399994],
              [-53.99729366099987, -27.187279967999885],
              [-53.9926944579999, -27.190070495999947],
              [-53.98845699099988, -27.193791198999946],
              [-53.98148067299988, -27.19565154999995],
              [-53.96179195199991, -27.191414082999913],
              [-53.96106848199992, -27.180768737999912],
              [-53.96623612499994, -27.16722951299994],
              [-53.964117390999945, -27.154000345999947],
              [-53.950888223999954, -27.147799173999957],
              [-53.938537557999894, -27.15544728599994],
              [-53.925411743999945, -27.1659892779999],
              [-53.90949540199992, -27.168263040999918],
              [-53.89941849799996, -27.158444518999943],
              [-53.890840209999936, -27.12712860099994],
              [-53.882210245999886, -27.11989390099997],
              [-53.86877437399994, -27.125888367],
              [-53.857870645999895, -27.140977884999913],
              [-53.84877559499992, -27.157514342999903],
              [-53.84200598099997, -27.163508809999925],
              [-53.830017049999924, -27.156790872999906],
              [-53.81921667499998, -27.139737649999873],
              [-53.81875158699995, -27.13146942099992],
              [-53.828260050999944, -27.12175425199989],
              [-53.82872513899986, -27.114416198999976],
              [-53.82433264199997, -27.10935190799991],
              [-53.80975988799992, -27.10098032599994],
              [-53.80490230399988, -27.09436574299994],
              [-53.803248656999926, -27.08061981199991],
              [-53.805005655999906, -27.052197773999893],
              [-53.80092321799992, -27.03907196099992],
              [-53.79580725099993, -27.035868021999946],
              [-53.78004593999992, -27.033800963999894],
              [-53.77317297399986, -27.03018361399991],
              [-53.7684704189999, -27.024085794999948],
              [-53.724597127999886, -26.940473327999925],
              [-53.7125048419999, -26.904506530999953],
              [-53.710696166999895, -26.873810729999917],
              [-53.72242671699988, -26.81438283299987],
              [-53.73400223799993, -26.777382507999917],
              [-53.73756791199989, -26.775728860999962],
              [-53.74966019699988, -26.774902037999937],
              [-53.75291581299987, -26.77324839299989],
              [-53.753897664999926, -26.763119811999942],
              [-53.74728308099992, -26.749063821999925],
              [-53.747851521999905, -26.739141947999926],
              [-53.75245072499993, -26.73593800799995],
              [-53.7610806889999, -26.732837422999907],
              [-53.7696589759999, -26.726636249999927],
              [-53.774309854999984, -26.714337259999894],
              [-53.77172603399987, -26.70369191399989],
              [-53.76361283399987, -26.700798034999906],
              [-53.753742634999895, -26.69955779999988],
              [-53.746042846999984, -26.69387339199993],
              [-53.739531616999926, -26.675579935999863],
              [-53.737877970999875, -26.65707977299992],
              [-53.74294226099994, -26.619149270999927],
              [-53.7423738199999, -26.600545755999875],
              [-53.72960974199992, -26.565819192999925],
              [-53.726819213999875, -26.548559264999938],
              [-53.728214477999956, -26.55186655699994],
              [-53.73183182799994, -26.54556203199992],
              [-53.735604207999955, -26.535123392999893],
              [-53.73746455899996, -26.52530486999993],
              [-53.73457067899997, -26.518276875999916],
              [-53.72743933099994, -26.51135223399993],
              [-53.7129182539999, -26.500500182999886],
              [-53.7129182539999, -26.500293477999932],
              [-53.71276322499995, -26.469597675999893],
              [-53.72444209799994, -26.37606333399988],
              [-53.71586380999989, -26.34671112],
              [-53.67323075299993, -26.29255421899998],
              [-53.661551879999934, -26.25979136099997],
              [-53.666719522999955, -26.219173685999948],
              [-53.68511633299994, -26.187651061999887],
              [-53.73338212099995, -26.126362813999933],
              [-53.746766316999896, -26.091636250999983],
              [-53.753484253999915, -26.058666686999928],
              [-53.76500809799995, -26.02807423899992],
              [-53.79270666599987, -26.000582376999944],
              [-53.79270666599987, -26.00047902399993],
              [-53.792861694999914, -26.0003756709999],
              [-53.82619299299998, -25.97267710299988],
              [-53.83342769399994, -25.962238464999928],
              [-53.836063191999955, -25.949732767999933],
              [-53.83394445899998, -25.94032765699997],
              [-53.83058548999986, -25.931646015999917],
              [-53.829603637999895, -25.921310729999917],
              [-53.84164424699989, -25.867670592999943],
              [-53.83730342599989, -25.809172871999948],
              [-53.84035233599991, -25.791396178999918],
              [-53.84934403599996, -25.772896016999894],
              [-53.85781896999987, -25.763180846999944],
              [-53.87704260299998, -25.74612762399991],
              [-53.883450480999926, -25.735585632999943],
              [-53.8855175379999, -25.72256317199991],
              [-53.88252030499987, -25.71346811899994],
              [-53.87828283799993, -25.706130065999943],
              [-53.876474162999926, -25.697861835999987],
              [-53.88753291899994, -25.66127492299995],
              [-53.89812658699992, -25.639467467999935],
              [-53.909960489999946, -25.629235533999946],
              [-53.948097696999895, -25.650629576999876],
              [-53.96773474099993, -25.65321339899988],
              [-53.97620967599994, -25.627581888999913],
              [-53.978276733999905, -25.607014668999923],
              [-53.984994669999935, -25.58934132899992],
              [-53.99744868999991, -25.57497527999992],
              [-54.0165172939999, -25.56505340599992],
              [-54.030211548999915, -25.56215952599993],
              [-54.036774454999886, -25.564536641999965],
              [-54.04292394999996, -25.568464049999946],
              [-54.055377970999956, -25.57073781299995],
              [-54.0724828699999, -25.55533823599997],
              [-54.082714802999874, -25.550067240999937],
              [-54.08927770999995, -25.55885223399993],
              [-54.08876094599992, -25.568360696999918],
              [-54.08648718299989, -25.57983286499993],
              [-54.08576371299989, -25.590581562999944],
              [-54.08963944599995, -25.597402852],
              [-54.09888952699987, -25.59719614699995],
              [-54.108966430999914, -25.590271504999876],
              [-54.11769974799998, -25.580556334999926],
              [-54.123125773999874, -25.571771341999934],
              [-54.12596797699993, -25.55203094399988],
              [-54.120180216999955, -25.535494486999895],
              [-54.1118603109999, -25.51937143899991],
              [-54.10715775599991, -25.50056121899989],
              [-54.11144689999989, -25.495910338999934],
              [-54.11640783699994, -25.49456675199987],
              [-54.12209224499989, -25.49622039799992],
              [-54.12819006399994, -25.50056121899989],
              [-54.15428666199992, -25.52825978599992],
              [-54.16508703599996, -25.534357604999883],
              [-54.177696085999884, -25.535804544999877],
              [-54.19671301299985, -25.529603372999887],
              [-54.206944946999926, -25.527949726999935],
              [-54.21479976499995, -25.53146372399989],
              [-54.1946976319999, -25.56329640699994],
              [-54.190253458999905, -25.580763040999983],
              [-54.20994217999993, -25.582209980999977],
              [-54.228959105999905, -25.57704233799997],
              [-54.23510860199988, -25.576732279999888],
              [-54.24368688999991, -25.577559102999913],
              [-54.24962967999991, -25.593268737999978],
              [-54.25562414499987, -25.598746438999882],
              [-54.2631689049999, -25.59006479899992],
              [-54.273659220999946, -25.568774108999932],
              [-54.284407918999875, -25.556785175999963],
              [-54.2992390549999, -25.55265106199994],
              [-54.321718302999926, -25.555131530999915],
              [-54.333087117999895, -25.561952819999973],
              [-54.34967525199991, -25.582416686999935],
              [-54.360113891999845, -25.58427703799994],
              [-54.377787231999946, -25.577662455999942],
              [-54.38621048999994, -25.5771456909999],
              [-54.395408894999946, -25.58107309899988],
              [-54.402850300999944, -25.590271504999876],
              [-54.40367712499997, -25.600193378999876],
              [-54.402798624999946, -25.61032196099991],
              [-54.40507238799995, -25.6198304239999],
              [-54.41266882299993, -25.627271829999927],
              [-54.43132401499989, -25.636883646999934],
              [-54.43742183399985, -25.645048521999954],
              [-54.43773189399994, -25.655383808999957],
              [-54.433132690999884, -25.67657114699992],
              [-54.43731848199991, -25.685252786999882],
              [-54.44734370899994, -25.68918019599994],
              [-54.45354488199993, -25.68318572999992],
              [-54.456542114999934, -25.672643736999945],
              [-54.45700720299996, -25.663135273999956],
              [-54.460572875999844, -25.64205128999994],
              [-54.473026895999936, -25.625824890999922],
              [-54.491061971999926, -25.614042663999925],
              [-54.51142248599987, -25.606187845999983],
              [-54.53229976399993, -25.610632018999908],
              [-54.53870764199988, -25.601330260999973],
              [-54.539999552999916, -25.586757506999916],
              [-54.54563228399985, -25.57476857499995],
              [-54.56005000799988, -25.570221048999926],
              [-54.60020261299988, -25.57494488399989],
              [-54.59994421499991, -25.5727015169999],
              [-54.59415645399994, -25.548620300999943],
              [-54.59146927899991, -25.524745788999965],
              [-54.598497273999925, -25.505832213999923],
              [-54.60852250199994, -25.487642109999882],
              [-54.61244991099991, -25.46552459699997],
              [-54.61182979299994, -25.444027200999926],
              [-54.609814412999896, -25.43276173899997],
              [-54.59798050999987, -25.397518411999982],
              [-54.575656290999916, -25.36031138099989],
              [-54.547079223999845, -25.336643574999954],
              [-54.528475708999906, -25.3143193559999],
              [-54.50356766799993, -25.2786626179999],
              [-54.48145015499992, -25.213240253999928],
              [-54.46940954599995, -25.1954635619999],
              [-54.43566483599997, -25.16704152399997],
              [-54.42662146099991, -25.149471537],
              [-54.429722045999966, -25.13055796299996],
              [-54.45519852699988, -25.09211069699991],
              [-54.463311726999876, -25.07278371199996],
              [-54.464190225999914, -25.055937194999984],
              [-54.46227819799989, -25.0372303259999],
              [-54.453286498999944, -25.00281382199995],
              [-54.40729447499987, -24.821222838999915],
              [-54.39974971599992, -24.80478973399994],
              [-54.37112097199994, -24.76665252699989],
              [-54.358429464999915, -24.73142174699997],
              [-54.3213048909999, -24.62836639399991],
              [-54.32068477399994, -24.595913593999896],
              [-54.33479243999997, -24.527287292999944],
              [-54.33453405799989, -24.496694843999933],
              [-54.32290685999993, -24.46434539799995],
              [-54.28409785999989, -24.411325377999944],
              [-54.27169551599991, -24.38941457099989],
              [-54.262187051999945, -24.358512064999985],
              [-54.26105017099994, -24.329469909],
              [-54.27433101399993, -24.298257344999925],
              [-54.282650919999895, -24.275313008999973],
              [-54.30626704899993, -24.246684264999914],
              [-54.314121866999955, -24.234178567999905],
              [-54.31897945199995, -24.19676483099994],
              [-54.33184688299988, -24.165035501999924],
              [-54.33463741099993, -24.148912454999945],
              [-54.32476721199993, -24.11821665399991],
              [-54.30104772999991, -24.08989796999991],
              [-54.26621781499992, -24.06592010499989],
              [-54.24528885899994, -24.050623880999936],
              [-54.24574984799989, -24.050393385999953],
              [-54.273607543999844, -24.03646453799989],
              [-54.36760697499997, -23.984684753999915],
              [-54.422900756999894, -23.913784688999954],
              [-54.4431579189999, -23.89993540399989],
              [-54.61255326399993, -23.81115529399996],
              [-54.63921830299998, -23.80443735699994],
              [-54.654592040999944, -23.811465351999956],
              [-54.679784301999916, -23.836683450999914],
              [-54.69683752399993, -23.84515838599991],
              [-54.827423868999915, -23.887016296999974],
              [-54.891916056999946, -23.92060597699991],
              [-54.90488684099995, -23.93300832099989],
              [-54.92674597199991, -23.959880065999883],
              [-54.94364416499991, -23.969181823999904],
              [-54.96105912299993, -23.971765644999905],
              [-54.994571289999925, -23.973109232999974],
              [-55.01149532099993, -23.9805506389999],
              [-55.0422944739999, -23.989025573999896],
              [-55.10557226599988, -23.988508809999956],
              [-55.13107458499991, -24.00039438899998],
              [-55.13107458499991, -24.000601094999936],
              [-55.131281290999965, -24.000601094999936],
              [-55.165439412999945, -24.016827493999955],
              [-55.20086360699989, -24.01951466799997],
              [-55.23683040399996, -24.01269337999993],
              [-55.272409627999934, -24.000601094999936],
              [-55.27256465699986, -24.000497741999922],
              [-55.27266800899989, -24.000497741999922],
              [-55.2727196859999, -24.00039438899998],
              [-55.30434566299991, -23.994089863999974],
              [-55.367184203999955, -23.98964569099988],
              [-55.398035033999946, -23.976829935999973],
              [-55.420669311999916, -23.954505715999915],
              [-55.430177774999976, -23.92856414799988],
              [-55.4453189699999, -23.7354493199999],
              [-55.46697139599988, -23.673230896],
              [-55.511309773999926, -23.629409280999894],
              [-55.53053340699995, -23.60346771199994],
              [-55.533892374999965, -23.569981383999945],
              [-55.533065551999954, -23.53401458699996],
              [-55.533795620999854, -23.53044413699986],
              [-55.53991267899991, -23.500528259999967],
              [-55.542470662999904, -23.465801696999932],
              [-55.51554724199988, -23.410197855999925],
              [-55.51386775799992, -23.37939870199996],
              [-55.52487483699991, -23.36048512699992],
              [-55.555596476999966, -23.330306090999926],
              [-55.562159383999955, -23.30787851999993],
              [-55.559007120999894, -23.291342060999938],
              [-55.535649373999945, -23.245866800999877],
              [-55.535235962999934, -23.229123635999926],
              [-55.55714676999989, -23.154709574999913],
              [-55.56086747299989, -23.145924579999928],
              [-55.58866939299995, -23.13011159199992],
              [-55.59939225299988, -23.11708913199989],
              [-55.60014156199986, -23.100552672999896],
              [-55.595232299999935, -23.064069111999885],
              [-55.600684163999915, -23.044535419999974],
              [-55.611458699999844, -23.029135843999896],
              [-55.63781367999991, -23.00071380599988],
              [-55.6399840899999, -22.98376393599996],
              [-55.634351359999954, -22.950070901999908],
              [-55.63429968299994, -22.93281097399992],
              [-55.656572224999906, -22.85570973699997],
              [-55.659001017999856, -22.818296],
              [-55.645926879999905, -22.78791025799994],
              [-55.6285894369999, -22.758971455999884],
              [-55.618331665999904, -22.725691833999946],
              [-55.61918432599995, -22.71690683999995],
              [-55.625669718999916, -22.700783792999886],
              [-55.62778845299988, -22.69210215199992],
              [-55.62701330599987, -22.683627217999913],
              [-55.62150976599989, -22.66709075899992],
              [-55.620476237999895, -22.65933929399992],
              [-55.623680175999965, -22.638668721999906],
              [-55.63119909699992, -22.62678314199988],
              [-55.64435074899998, -22.61954844199991],
              [-55.66468542599992, -22.612727151999948],
              [-55.69791337199993, -22.59557057699989],
              [-55.72393245399991, -22.569629006999932],
              [-55.74126989799993, -22.537176208999924],
              [-55.748297892999915, -22.500899352999866],
              [-55.751579345999914, -22.41625335699996],
              [-55.760235147999964, -22.391965433999957],
              [-55.77015702399987, -22.38142344099991],
              [-55.81077469899989, -22.35310475699991],
              [-55.86103002999994, -22.289542744999935],
              [-55.872011270999934, -22.31021331699995],
              [-55.87438838699998, -22.31734466499998],
              [-55.89294022599992, -22.306802673999925],
              [-55.95526200399988, -22.301324970999943],
              [-55.97086828699989, -22.293883564999916],
              [-55.985234334999916, -22.28323821999993],
              [-55.99856685399993, -22.277243753999898],
              [-56.011356770999896, -22.283858337999987],
              [-56.02471512899993, -22.28737233399994],
              [-56.19679764799989, -22.27931081199995],
              [-56.21426428299992, -22.27538340199989],
              [-56.23152421099991, -22.26535817399987],
              [-56.26108313099985, -22.23858978299998],
              [-56.316841999999895, -22.207687275999902],
              [-56.34733109599998, -22.180402119999982],
              [-56.370843872999956, -22.1473292029999],
              [-56.39730220599995, -22.086247660999987],
              [-56.407637491999964, -22.075809020999955],
              [-56.421796834999924, -22.074465433999904],
              [-56.49383378199988, -22.086557718999885],
              [-56.51130041499994, -22.09141530399991],
              [-56.52163570199994, -22.099890237999915],
              [-56.530679077999906, -22.10908864399991],
              [-56.54597530099994, -22.13006927499991],
              [-56.5490758869999, -22.136270446999987],
              [-56.554605265999896, -22.15208343499998],
              [-56.55801590999994, -22.156424254999962],
              [-56.565302286999895, -22.159938252999922],
              [-56.567911946999914, -22.16231536899997],
              [-56.58496516899996, -22.19053070099993],
              [-56.595739705999875, -22.201486103999912],
              [-56.629174356999954, -22.22474049799993],
              [-56.637184204999926, -22.22825449599989],
              [-56.648346313999866, -22.231355081999922],
              [-56.65470251499991, -22.237349547999955],
              [-56.644134684999926, -22.25543629999997],
              [-56.64881140199989, -22.263497822999867],
              [-56.66457271299987, -22.25998382599991],
              [-56.69860164399992, -22.223500263999895],
              [-56.71537064699987, -22.215438741],
              [-56.720538289999894, -22.2194695029999],
              [-56.72854813599986, -22.237452900999884],
              [-56.73319901599993, -22.244067484999974],
              [-56.743534301999944, -22.250372008999904],
              [-56.74560135899989, -22.248408304999955],
              [-56.746789916999916, -22.243964130999956],
              [-56.75436051499989, -22.24262054399989],
              [-56.786994180999926, -22.251818948999897],
              [-56.7945647789999, -22.252542419999983],
              [-56.808284871999916, -22.247994893999945],
              [-56.8119022219999, -22.249648538999907],
              [-56.81314245599995, -22.256159769999968],
              [-56.819653686999914, -22.265461526999985],
              [-56.84285640499991, -22.289025981],
              [-56.85605973299991, -22.29316009499992],
              [-56.87954667199989, -22.28995615699995],
              [-56.88171708199988, -22.277243753999898],
              [-56.892000691999954, -22.252232360999898],
              [-56.90367956599994, -22.236936136999944],
              [-56.914789998999964, -22.262877705999898],
              [-56.92494441799991, -22.262360941999944],
              [-56.94259191899991, -22.253989359999977],
              [-56.9521003829999, -22.253575947999963],
              [-56.96052364099998, -22.254816182],
              [-56.965484578999934, -22.25088877299993],
              [-56.96455440299988, -22.23486907999998],
              [-56.975716512999924, -22.24169036899994],
              [-56.98646521099994, -22.241380309999954],
              [-57.01116654499995, -22.2338355509999],
              [-57.027651326999916, -22.235075784999935],
              [-57.059484008999874, -22.2326986689999],
              [-57.07162796999998, -22.235695902999908],
              [-57.07922440599995, -22.23858978299998],
              [-57.085063842999915, -22.238073018999955],
              [-57.090748250999866, -22.2364193719999],
              [-57.10847326699988, -22.233525492999917],
              [-57.11327917499989, -22.229391376999985],
              [-57.114622761999954, -22.22505055799992],
              [-57.115036173999954, -22.222880146999927],
              [-57.12418290199986, -22.218539326999945],
              [-57.1541552329999, -22.207997334999973],
              [-57.17038163299992, -22.205723571999954],
              [-57.177926391999875, -22.207377216999916],
              [-57.18361079999991, -22.21089121499996],
              [-57.189967, -22.213578388999906],
              [-57.19952714099992, -22.2128549199999],
              [-57.206400105999904, -22.207480569999944],
              [-57.20944901599992, -22.192080992999948],
              [-57.213789835999904, -22.18815358499998],
              [-57.22748409099992, -22.191254170999926],
              [-57.252443807999896, -22.210581156999893],
              [-57.27166743999993, -22.21378509499995],
              [-57.316315877999955, -22.203656513999903],
              [-57.331767130999964, -22.202416279999866],
              [-57.33305904199992, -22.205413512999968],
              [-57.33481603999988, -22.211718037999987],
              [-57.339932006999874, -22.216989033999923],
              [-57.35124914599996, -22.21719573899989],
              [-57.36664872199992, -22.2091342169999],
              [-57.37502030399992, -22.20727386499989],
              [-57.37863765499989, -22.213371683999938],
              [-57.38499385599991, -22.21326833099991],
              [-57.417860066999935, -22.193837991999928],
              [-57.432277791999866, -22.188670348999935],
              [-57.44318151899992, -22.187946878999938],
              [-57.46395544499998, -22.180402119999982],
              [-57.472482055999905, -22.180298766999954],
              [-57.51118770399992, -22.18877370199995],
              [-57.53459712799989, -22.17440765399995],
              [-57.54229691599997, -22.17151377299996],
              [-57.55469925999992, -22.170273538999936],
              [-57.55997025599996, -22.1716171259999],
              [-57.56400101799994, -22.17440765399995],
              [-57.57273433399993, -22.17771494499995],
              [-57.59671219899985, -22.18102223699995],
              [-57.61407548099996, -22.176991474999866],
              [-57.627201294999935, -22.16510589599993],
              [-57.63893184499992, -22.14453867599994],
              [-57.65448644999995, -22.104541116999968],
              [-57.663684855999946, -22.100613709],
              [-57.67081620299987, -22.102370706999892],
              [-57.67851599199989, -22.106401468999977],
              [-57.6896264239999, -22.109295348999964],
              [-57.70993526299992, -22.10846852599994],
              [-57.72326778199994, -22.104747822999926],
              [-57.7363419189999, -22.103714293999943],
              [-57.756185669999894, -22.11063893599993],
              [-57.76026810699989, -22.11074228899996],
              [-57.76993159999992, -22.107434996999956],
              [-57.77365230299992, -22.107745055999942],
              [-57.77561600799996, -22.11115569999997],
              [-57.777424682999936, -22.117046813999963],
              [-57.77778641799995, -22.1223178099999],
              [-57.7754093019999, -22.12397145599995],
              [-57.787501587999884, -22.1296558639999],
              [-57.795304727999905, -22.13099945099995],
              [-57.80548498499988, -22.128622334999918],
              [-57.81576859499995, -22.128312276999935],
              [-57.831788289999906, -22.14112803099991],
              [-57.8438805749999, -22.143711852999914],
              [-57.84868648299991, -22.140301207999897],
              [-57.862845825999955, -22.125831806999955],
              [-57.87137243699988, -22.12118092899989],
              [-57.87819372599992, -22.12211110399994],
              [-57.895505330999924, -22.128932392999985],
              [-57.906254028999854, -22.128932392999985],
              [-57.93999873899992, -22.118390400999928],
              [-57.9524527589999, -22.105988056999962],
              [-57.96139278199993, -22.09007171599994],
              [-57.972864949999945, -22.08118336999992],
              [-57.973133663999874, -22.08104849399996],
              [-57.98624914599989, -22.074465433999904],
              [-57.98800614499996, -22.064130146999986],
              [-57.98836787999997, -22.04904062899989],
              [-57.986817585999944, -22.03529469799996],
              [-57.96485510299988, -21.976693623999935],
              [-57.96263301599987, -21.966978454999904],
              [-57.95322790499992, -21.958193460999908],
              [-57.929921834999874, -21.917369079999915],
              [-57.92537430899995, -21.90496673599995],
              [-57.932764037999874, -21.881919046999982],
              [-57.94666499899992, -21.86548594199992],
              [-57.955915079999954, -21.851119893999922],
              [-57.94893876099985, -21.83385996499993],
              [-57.93570959499996, -21.8120525099999],
              [-57.9347794199999, -21.792932229999906],
              [-57.93844844599991, -21.774638772999936],
              [-57.93901688699995, -21.755311787999887],
              [-57.895608682999864, -21.68844248499991],
              [-57.90113806199986, -21.678934020999932],
              [-57.91178340699986, -21.67304290799993],
              [-57.92434077999988, -21.658676858999925],
              [-57.934831095999925, -21.64069346099994],
              [-57.93901688699995, -21.623743590999936],
              [-57.93214392099989, -21.606690368999907],
              [-57.9193281659999, -21.583952737999923],
              [-57.91209346499994, -21.564005635999905],
              [-57.921601928999934, -21.555427346999878],
              [-57.93979203299995, -21.548192646999908],
              [-57.948111938999915, -21.53051930799991],
              [-57.9491454679999, -21.50829844099988],
              [-57.945269734999954, -21.487214456999936],
              [-57.929921834999874, -21.453108011999873],
              [-57.86331091399998, -21.356886494999927],
              [-57.85555944799998, -21.33073821999993],
              [-57.86630814599991, -21.320919697999955],
              [-57.88232784099995, -21.316372171999916],
              [-57.8906477459999, -21.305933531999884],
              [-57.89364497999992, -21.30035247799988],
              [-57.89994950399995, -21.29508148099994],
              [-57.9049104419999, -21.28743336999996],
              [-57.90429032399993, -21.27492767299995],
              [-57.89901932799998, -21.267176207999867],
              [-57.87070064399998, -21.247642516999946],
              [-57.84785966099989, -21.216223245999913],
              [-57.8339586999999, -21.173848571999898],
              [-57.829876261999914, -21.127029723999968],
              [-57.836025756999874, -21.082484638999873],
              [-57.85173539199994, -21.051995543999894],
              [-57.852458862999924, -21.037836201999937],
              [-57.82538041199987, -20.99856211399988],
              [-57.81602697799994, -20.975411070999968],
              [-57.81757726999987, -20.953603616999956],
              [-57.836025756999874, -20.938514098999946],
              [-57.84031490099994, -20.955980732999905],
              [-57.84703283699986, -20.955980732999905],
              [-57.86992549599998, -20.93272633899997],
              [-57.89302486199995, -20.914846292999925],
              [-57.898089151999926, -20.914846292999925],
              [-57.90113806199986, -20.91236582399995],
              [-57.90801102699993, -20.910505472999944],
              [-57.91483231599997, -20.905647888999923],
              [-57.91793290299992, -20.894382425999964],
              [-57.9086828209999, -20.881566670999888],
              [-57.86739335199991, -20.860069274999944],
              [-57.85710974199989, -20.849733987999926],
              [-57.85964188599988, -20.831647236999913],
              [-57.87070064399998, -20.816454365999988],
              [-57.8876505129999, -20.80591237399993],
              [-57.90801102699993, -20.80198496499996],
              [-57.93395259599987, -20.79971120199994],
              [-57.94041215099992, -20.793613382999894],
              [-57.933074096999945, -20.784621683999944],
              [-57.91793290299992, -20.77407969099997],
              [-57.906667439999865, -20.762194111999946],
              [-57.898760945999925, -20.756613056999925],
              [-57.8770051679999, -20.752375589999886],
              [-57.865274617999916, -20.747414651999932],
              [-57.85767818299985, -20.73986989299989],
              [-57.86021032699995, -20.730258076999874],
              [-57.868943644999916, -20.722196552999975],
              [-57.8843432219999, -20.711964619999904],
              [-57.8906477459999, -20.70638356499998],
              [-57.89447180199994, -20.699975687999938],
              [-57.90020788599992, -20.685196227999924],
              [-57.90429032399993, -20.678995055999934],
              [-57.918087930999974, -20.669796650999942],
              [-57.934004272999886, -20.667419534999894],
              [-57.947181762999975, -20.675067646999963],
              [-57.95638016799995, -20.709897561999938],
              [-57.96501013199992, -20.71103444399995],
              [-57.97441524299995, -20.704006448999934],
              [-57.98061641499996, -20.69274098699988],
              [-57.9810815029999, -20.681165465999925],
              [-57.97358841999994, -20.661941832999915],
              [-57.973123331999915, -20.65119313599989],
              [-57.9778258879999, -20.64013437899989],
              [-57.99095170099986, -20.62060068699988],
              [-57.99363887599989, -20.60675140399991],
              [-57.99255367099991, -20.58504730199992],
              [-57.993328816999906, -20.573781839999953],
              [-58.00474930899992, -20.549803974999932],
              [-58.008935099999945, -20.525722756999897],
              [-58.010020304999955, -20.50009124699993],
              [-58.00790157099996, -20.479834085999926],
              [-57.99214025899988, -20.450895283999955],
              [-57.989401407999935, -20.43311859199993],
              [-58.00418086799996, -20.425160420999973],
              [-58.023146118999904, -20.420716246999874],
              [-58.04562536699993, -20.409347431999976],
              [-58.06712276299996, -20.393534443999968],
              [-58.08298742799988, -20.376171161999963],
              [-58.09079056899989, -20.35942799899992],
              [-58.097715209999876, -20.334623310999874],
              [-58.09993729699997, -20.309198506999877],
              [-58.090325480999866, -20.2817066449999],
              [-58.095079712999876, -20.272198180999908],
              [-58.103089559999944, -20.26444671599991],
              [-58.10975581899993, -20.26072601299998],
              [-58.120039428999945, -20.261346129999964],
              [-58.12624060099992, -20.267030537999915],
              [-58.130943155999915, -20.27281829899998],
              [-58.13704097499996, -20.2743685909999],
              [-58.15631628499989, -20.26165618799986],
              [-58.162672485999934, -20.243156025999923],
              [-58.155282755999906, -20.226412861999876],
              [-58.118540812999925, -20.21442392999991],
              [-58.12050451699986, -20.203881937999952],
              [-58.12990962699993, -20.19251312199995],
              [-58.13704097499996, -20.18558847999988],
              [-58.144068969999864, -20.18352142399992],
              [-58.1523371989999, -20.184658304999928],
              [-58.158331664999935, -20.181144307999972],
              [-58.15879675299996, -20.165124612999918],
              [-58.11631872599992, -20.150448505999933],
              [-58.10355464799994, -20.14404062899989],
              [-58.09828365099992, -20.1381495159999],
              [-58.086243042999854, -20.120889588],
              [-58.079576782999936, -20.117375589999938],
              [-58.05353186099995, -20.107660420999906],
              [-58.02237097199989, -20.064975686999915],
              [-57.99710119599993, -20.05526051799997],
              [-57.985680704999936, -20.053090107999978],
              [-57.97581050699995, -20.04750905399996],
              [-57.968937540999974, -20.039757587999958],
              [-57.9663537189999, -20.031075947999895],
              [-57.959170694999926, -20.02621836299997],
              [-57.94320267799989, -20.028078714999893],
              [-57.91793290299992, -20.03417653399994],
              [-57.895608682999864, -20.024151305999922],
              [-57.881139281999936, -20.00916514099994],
              [-57.86977046799984, -19.992938740999932],
              [-57.85974523899992, -19.980122985999955],
              [-57.96046260599988, -19.893099873999915],
              [-58.04112951699989, -19.823440042999977],
              [-58.1169388429999, -19.75801767999991],
              [-58.1246386309999, -19.729905699999875],
              [-58.08975703999991, -19.659419046999915],
              [-58.07745804799987, -19.6347177129999],
              [-58.050482950999935, -19.580147399999888],
              [-58.023559529999915, -19.52568043999989],
              [-58.01126053899989, -19.50087575299993],
              [-58.011208862999865, -19.500772398999914],
              [-58.011208862999865, -19.50066904699989],
              [-57.980047973999916, -19.438864033999977],
              [-57.911628376999914, -19.30285166399993],
              [-57.843105428999905, -19.16683929499989],
              [-57.81204789199995, -19.105034280999888],
              [-57.789000203999905, -19.05924896199994],
              [-57.77189530499993, -19.048706970999973],
              [-57.71582637599991, -19.044572854999956],
              [-57.72176916499993, -19.001164651999957],
              [-57.72755692599989, -18.941943460999966],
              [-57.731794392999944, -18.921996357999944],
              [-57.74223303299988, -18.913624776999967],
              [-57.78233394399987, -18.910420836999904],
              [-57.77106848199992, -18.87631439199994],
              [-57.723991251999934, -18.733687438999894],
              [-57.67701737499996, -18.591060485999932],
              [-57.63004349799991, -18.44843353299997],
              [-57.58301794399992, -18.305703225999906],
              [-57.5667398679999, -18.256093850999918],
              [-57.55387243699991, -18.244518330999966],
              [-57.53573400899998, -18.24048756899988],
              [-57.46679764899994, -18.23955739399993],
              [-57.465660766999946, -18.2177499389999],
              [-57.47454911299985, -18.208034768999966],
              [-57.49072383699985, -18.205554300999978],
              [-57.51118770399992, -18.205554300999978],
              [-57.55108190999994, -18.183643492999934],
              [-57.5854984129999, -18.122768656999895],
              [-57.63691646399988, -18.00112233499995],
              [-57.73008907099998, -17.84609303799992],
              [-57.69877315299988, -17.843095804999905],
              [-57.69680944899994, -17.82511240699992],
              [-57.7113305259999, -17.80082448299993],
              [-57.72931392399997, -17.77932708699997],
              [-57.73298295099997, -17.76847503699993],
              [-57.724456339999875, -17.736642353999883],
              [-57.74037268099988, -17.73023447699994],
              [-57.75489375899991, -17.720622659999933],
              [-57.767554483999874, -17.70873708099991],
              [-57.777941446999904, -17.695507913999904],
              [-57.785899617999945, -17.677524514999917],
              [-57.78796667499992, -17.65892099999988],
              [-57.78755326399991, -17.620473733999916],
              [-57.78956864399996, -17.604143981999883],
              [-57.78827673399991, -17.58057952899989],
              [-57.79075720299997, -17.555774840999945],
              [-57.800730753999886, -17.53345062299988],
              [-57.814425007999915, -17.519704691999934],
              [-57.83674922699987, -17.51102305099998],
              [-57.8541125079999, -17.508542581999905],
              [-57.8770051679999, -17.512263284999918],
              [-57.9056855879999, -17.520324808999916],
              [-57.943564412999905, -17.51784433999994],
              [-57.98149491399991, -17.508749286999958],
              [-58.01017533399988, -17.496760354999907],
              [-58.05368688999991, -17.462343851999947],
              [-58.06572749899988, -17.455935973999914],
              [-58.10112585499991, -17.44125986699993],
              [-58.11202958199996, -17.433508401999916],
              [-58.1393664149999, -17.40456959999996],
              [-58.15223384599989, -17.396404723999936],
              [-58.163189249999874, -17.39340749099992],
              [-58.174558065999946, -17.392063903999954],
              [-58.1884073489999, -17.388549906999913],
              [-58.20406530799997, -17.377387796999884],
              [-58.220240030999946, -17.344314879999985],
              [-58.231557169999945, -17.32974212599993],
              [-58.23992875199991, -17.32519459999989],
              [-58.256155151999934, -17.32250742599996],
              [-58.2645267339999, -17.320026956999897],
              [-58.27439693199997, -17.31403249099995],
              [-58.29227697799993, -17.29966644299995],
              [-58.30214717699991, -17.293775328999956],
              [-58.31217240399994, -17.290881449999873],
              [-58.3436950279999, -17.286954040999902],
              [-58.38116044199998, -17.267213642999934],
              [-58.39914383999988, -17.237448017999952],
              [-58.40482824699993, -17.19962086999996],
              [-58.40627518799991, -17.110117288999945],
              [-58.410977742999904, -17.088206481999904],
              [-58.421623087999876, -17.07063649499993],
              [-58.4267907309999, -17.055236917999935],
              [-58.43247513899993, -16.985370380999953],
              [-58.43919307499996, -16.96728362999994],
              [-58.456349650999925, -16.93700124099992],
              [-58.4662715259999, -16.887288512999916],
              [-58.46663326099991, -16.875506285999904],
              [-58.46404943899992, -16.866101174999955],
              [-58.455109415999885, -16.848324482999928],
              [-58.45293900599998, -16.841296487999912],
              [-58.45624629799988, -16.802435811999956],
              [-58.47665848799994, -16.726988219999953],
              [-58.480275838999916, -16.683683369999898],
              [-58.47267940299986, -16.64957692499992],
              [-58.4558845629999, -16.61908782999994],
              [-58.35609737199988, -16.50953379299996],
              [-58.34266149899992, -16.473153584999892],
              [-58.363590453999905, -16.436670022999877],
              [-58.36229854399997, -16.419306741999947],
              [-58.3388374429999, -16.400496520999937],
              [-58.33454829899992, -16.38664723699989],
              [-58.339560913999975, -16.289288838999923],
              [-58.34974117099995, -16.280400491999913],
              [-58.392942667999904, -16.279366963999934],
              [-58.400332397999904, -16.284224547999955],
              [-58.414233357999876, -16.308925882999873],
              [-58.421623087999876, -16.318434345999947],
              [-58.44224198399988, -16.328459574999968],
              [-58.46472123299989, -16.331250101999927],
              [-58.53696488499992, -16.32876963299995],
              [-58.72744421499988, -16.32215504899996],
              [-58.91776851499989, -16.315437113999934],
              [-59.10824784399995, -16.308719176999915],
              [-59.29867549699989, -16.302104593999914],
              [-59.48910314999992, -16.295386656999895],
              [-59.67955664099986, -16.288772074999898],
              [-59.87001013199992, -16.282157490999893],
              [-60.06041194699995, -16.275439554999963],
              [-60.12983923399992, -16.273062438999915],
              [-60.16069006399991, -16.264794209999963],
              [-60.1798103429999, -16.222006122999943],
              [-60.18696752999995, -16.108731383999967],
              [-60.19376297999989, -16.00145110999992],
              [-60.20699214699988, -15.853036396999897],
              [-60.22482051599991, -15.651394957999912],
              [-60.237972167999885, -15.502670185999904],
              [-60.246395425999935, -15.478278909999915],
              [-60.26045141599991, -15.456058043999931],
              [-60.3521254069999, -15.349604593999914],
              [-60.460180826999874, -15.22423756899994],
              [-60.529478922999914, -15.143725686999872],
              [-60.582240559999946, -15.098870543999894],
              [-60.38930659999991, -15.096493428999935],
              [-60.27497249399994, -15.09514984099988],
              [-60.269804849999844, -15.083367614999972],
              [-60.27290543699988, -15.018565367999955],
              [-60.27685868399996, -14.936606546999897],
              [-60.28088944499987, -14.854647724999921],
              [-60.284868530999944, -14.77268890299996],
              [-60.288821777999914, -14.690730081999988],
              [-60.2917156579999, -14.630061949999913],
              [-60.30404048699995, -14.608151142999944],
              [-60.35271968599997, -14.575388284999946],
              [-60.36920446799985, -14.542832132999905],
              [-60.338431151999885, -14.53260019899993],
              [-60.34380550199995, -14.490948994999911],
              [-60.37669755099998, -14.419945576999922],
              [-60.39134781899986, -14.357107034999942],
              [-60.399926106999914, -14.340777281999905],
              [-60.45431555199988, -14.296645609999914],
              [-60.4643407799999, -14.27835215199994],
              [-60.46563269099994, -14.251066995999935],
              [-60.46201534099987, -14.223885192999944],
              [-60.462402913999966, -14.19846038799993],
              [-60.4756837569999, -14.176032816999935],
              [-60.47893937199987, -14.162700296999915],
              [-60.47764746199991, -14.139962666999935],
              [-60.47351334599989, -14.11722503699987],
              [-60.46826818899987, -14.103685811999895],
              [-60.461395223999915, -14.098621520999913],
              [-60.437236490999936, -14.092006937999912],
              [-60.419433960999896, -14.076917418999912],
              [-60.40940873199989, -14.05531666999994],
              [-60.39651546199988, -14.008394470999903],
              [-60.38796301299993, -13.989377542999932],
              [-60.38718786699994, -13.98327972399997],
              [-60.389694173999914, -13.974908141999904],
              [-60.395740315999944, -13.970980733999923],
              [-60.40542964799991, -13.966743265999881],
              [-60.41160498099987, -13.960542094],
              [-60.406721557999845, -13.950413512999944],
              [-60.40863358599995, -13.94452239999994],
              [-60.43044103999989, -13.92674570699991],
              [-60.438554240999906, -13.918374124999929],
              [-60.44881201199988, -13.896773375999956],
              [-60.4573127859999, -13.870935160999949],
              [-60.46312638399988, -13.843443297999968],
              [-60.465270955999955, -13.816571552999974],
              [-60.47263484699994, -13.797864684999894],
              [-60.49061824599994, -13.787736104999937],
              [-60.56606583699994, -13.769959411999906],
              [-60.575135050999904, -13.765618590999935],
              [-60.5795792239999, -13.761071064999982],
              [-60.58487605799985, -13.749082131999941],
              [-60.58862259999995, -13.744534606999906],
              [-60.595082153999925, -13.741640725999915],
              [-60.61807816599989, -13.736886494999922],
              [-60.6527013759999, -13.718799742999906],
              [-60.72557172299989, -13.662844600999975],
              [-60.80196875099995, -13.60418141599996],
              [-60.8706725669999, -13.575449320999951],
              [-60.878243163999855, -13.570385029999983],
              [-60.89674332699988, -13.552918395999939],
              [-60.92929947899992, -13.54620045899992],
              [-60.97787532599992, -13.542996520999935],
              [-61.02200699899993, -13.535245055999937],
              [-61.04125646999995, -13.515194600999891],
              [-61.04125646999995, -13.474576924999951],
              [-61.04722509799987, -13.464551696999933],
              [-61.06011836799988, -13.467135518999925],
              [-61.07218481499987, -13.474370218999894],
              [-61.076008869999896, -13.478297627999964],
              [-61.1187194419999, -13.484498798999951],
              [-61.133576415999926, -13.49400726299993],
              [-61.1393124999999, -13.514057718999979],
              [-61.14910518399995, -13.519845478999954],
              [-61.21504431199989, -13.517468362999907],
              [-61.23788529499987, -13.524393004999894],
              [-61.24855647799998, -13.524393004999894],
              [-61.2600286469999, -13.520052184999912],
              [-61.28121598299995, -13.50723642999992],
              [-61.31713110399991, -13.500931904999916],
              [-61.33237565199994, -13.49483408599987],
              [-61.347723551999934, -13.493697204999947],
              [-61.41547135399992, -13.528113707999907],
              [-61.45875036699988, -13.543719990999932],
              [-61.50342464199991, -13.548164163999942],
              [-61.55081193099991, -13.538035582999981],
              [-61.56086299699993, -13.532661233999931],
              [-61.58807063899994, -13.507649840999932],
              [-61.593060170999934, -13.506794492999958],
              [-61.597114013999885, -13.506099547999924],
              [-61.66809159399986, -13.512507425999956],
              [-61.69289628099992, -13.51798512799995],
              [-61.71573726399993, -13.52656341499997],
              [-61.735115926999896, -13.538035582999981],
              [-61.75433955999989, -13.530284118999887],
              [-61.7742349859999, -13.533384704999932],
              [-61.79428544099994, -13.540309345999916],
              [-61.81397416199991, -13.54423675599989],
              [-61.836350056999976, -13.540619404999902],
              [-61.84797725399994, -13.530800881999923],
              [-61.86859615099985, -13.463931578999862],
              [-61.87231685399988, -13.456076761999924],
              [-61.879913289999934, -13.449152119999937],
              [-61.89949865799994, -13.439230244999948],
              [-61.90983394399987, -13.431892190999946],
              [-61.958358113999935, -13.385486754999945],
              [-61.97535966099986, -13.374117940999952],
              [-61.99778723199995, -13.36409271199993],
              [-62.003264933999844, -13.360475361999946],
              [-62.01866450999992, -13.336807555999926],
              [-62.019698038999906, -13.332570088999958],
              [-62.03359899899988, -13.325542093999957],
              [-62.07773067299988, -13.277896422999916],
              [-62.099228068999906, -13.262600198999863],
              [-62.10940832599988, -13.248957620999946],
              [-62.11245723499991, -13.231801045999887],
              [-62.11250891099991, -13.164776712999881],
              [-62.114679321999915, -13.150203958999924],
              [-62.120467081999976, -13.14875701899993],
              [-62.129148722999844, -13.150927428999921],
              [-62.13984574399984, -13.14700002099994],
              [-62.16237666899988, -13.120748392999914],
              [-62.1724535729999, -13.117854512999926],
              [-62.17395218999991, -13.140798848999864],
              [-62.20092728699984, -13.122712096999948],
              [-62.21152095499991, -13.120334981999903],
              [-62.22164953699988, -13.121265156999954],
              [-62.25916662599988, -13.130773619999943],
              [-62.273636026999895, -13.138421732999916],
              [-62.290327514999944, -13.1420390829999],
              [-62.310533, -13.133977558999916],
              [-62.321591756999936, -13.143692728999952],
              [-62.33502762899988, -13.145139668999946],
              [-62.3818464769999, -13.13986867299991],
              [-62.389701293999934, -13.137078144999947],
              [-62.406702840999856, -13.12653615299989],
              [-62.41026851399991, -13.125709329999964],
              [-62.424117797999884, -13.12653615299989],
              [-62.4274767659999, -13.124572448999956],
              [-62.42871700099994, -13.114547220999924],
              [-62.43093908699984, -13.109792988999942],
              [-62.45848262599992, -13.077960305999895],
              [-62.47212520399992, -13.06845184399991],
              [-62.49269242399993, -13.065041198999978],
              [-62.55460078899995, -13.06679819699987],
              [-62.641675577999905, -13.03000457799996],
              [-62.64518957599995, -13.025353698999893],
              [-62.64751501499998, -13.00158253999993],
              [-62.65133907099991, -12.992487487999966],
              [-62.6579019779999, -12.984632669999925],
              [-62.66746211799992, -12.976364440999888],
              [-62.686634073999926, -12.964995625999904],
              [-62.698984740999975, -12.966649270999937],
              [-62.70916499899994, -12.974607441999908],
              [-62.72203242999993, -12.982565611999874],
              [-62.74130773999988, -12.985356139999922],
              [-62.75789587399987, -12.985149433999965],
              [-62.768644571999886, -12.990627135999958],
              [-62.77045324799988, -13.01047088599995],
              [-62.78983190999995, -13.00065236399989],
              [-62.80740189599993, -12.988870137999882],
              [-62.820165974999895, -12.974917500999894],
              [-62.825075236999936, -12.958691100999971],
              [-62.82667720599997, -12.950009459999919],
              [-62.83143143799995, -12.94494516999994],
              [-62.83892451999989, -12.942774759999864],
              [-62.84900142399994, -12.942154642999895],
              [-62.860111857999954, -12.940294290999887],
              [-62.86507279499989, -12.935540059],
              [-62.867914998999964, -12.929028828999918],
              [-62.92046993099984, -12.862262878999971],
              [-62.92377722199984, -12.852857767999922],
              [-62.92889318899992, -12.846036478999878],
              [-62.93803991699991, -12.849447122999905],
              [-62.94651485199992, -12.855234883999884],
              [-62.95514481599989, -12.85750864699989],
              [-62.964498249999906, -12.856578470999935],
              [-62.97529862499994, -12.852857767999922],
              [-62.988011026999914, -12.843866067999983],
              [-62.99917313699993, -12.829086608999958],
              [-63.00707963099998, -12.809966328999877],
              [-63.01002518799987, -12.787952168999894],
              [-63.01472774299995, -12.777720234999919],
              [-63.02568314599992, -12.76573130199995],
              [-63.047904012999965, -12.746714375999986],
              [-63.05110795099995, -12.742166849999947],
              [-63.05219315699995, -12.736482441999911],
              [-63.05110795099995, -12.730798034999864],
              [-63.043459838999865, -12.719119160999895],
              [-63.04707718999995, -12.713538105999973],
              [-63.053588419999926, -12.708370462999966],
              [-63.05782588799988, -12.701962585999922],
              [-63.064750529999856, -12.666202493999918],
              [-63.07503413999984, -12.65266326899993],
              [-63.10521317599995, -12.645221862999918],
              [-63.12505692599984, -12.635920104999883],
              [-63.136684122999895, -12.633749695],
              [-63.139474649999954, -12.6356100469999],
              [-63.167069864999945, -12.647392272999909],
              [-63.171669067999915, -12.652353209999944],
              [-63.17611324099991, -12.663618672999917],
              [-63.180712443999965, -12.66785613999987],
              [-63.18557002799989, -12.668476256999924],
              [-63.197300577999954, -12.666822610999887],
              [-63.2018481049999, -12.66785613999987],
              [-63.22267370599985, -12.682532245999951],
              [-63.23202714099989, -12.691110534999979],
              [-63.23595454999986, -12.698551940999906],
              [-63.24732336399995, -12.70134246799995],
              [-63.317913370999946, -12.701962585999922],
              [-63.33041906699992, -12.69700164699988],
              [-63.359461221999936, -12.674677428999914],
              [-63.37108841999989, -12.669923196999918],
              [-63.39330928599992, -12.664548848999871],
              [-63.43144649299998, -12.636953633999966],
              [-63.43521887199992, -12.630339049999876],
              [-63.4381644289999, -12.619176940999935],
              [-63.44534745399994, -12.61483611999995],
              [-63.45423579999988, -12.612045592999905],
              [-63.462504028999916, -12.605120950999918],
              [-63.46637976199989, -12.595302428999943],
              [-63.46699987799994, -12.585793964999965],
              [-63.46875687699992, -12.575768737999937],
              [-63.47619828399985, -12.564813333999965],
              [-63.485758422999936, -12.557475280999967],
              [-63.49614538599988, -12.553341165999939],
              [-63.50751420199995, -12.551584166999874],
              [-63.52022660299991, -12.551170755999863],
              [-63.54218908699997, -12.547966816999889],
              [-63.55872554599995, -12.539905292999904],
              [-63.60042842699991, -12.506108906999913],
              [-63.65484370899989, -12.47830698599995],
              [-63.657737589999954, -12.475413105999877],
              [-63.8013980719999, -12.454949238999916],
              [-63.8149889739999, -12.457223001999935],
              [-63.845581420999906, -12.466938171999871],
              [-63.86289302599991, -12.46921193499989],
              [-63.863203084999896, -12.474792988999909],
              [-63.896896117999944, -12.51572072299993],
              [-63.90247717299988, -12.525435891999877],
              [-63.90914343299997, -12.534324238999972],
              [-63.92123571799996, -12.544349466999904],
              [-63.939064086999906, -12.544142760999947],
              [-63.95001949099989, -12.536804707999949],
              [-63.95932124899991, -12.528019713999868],
              [-63.972447062999976, -12.523885599999943],
              [-64.00417639199989, -12.535461120999898],
              [-64.02283158399987, -12.537838235999928],
              [-64.04445817099995, -12.509106139999929],
              [-64.10445450899994, -12.507142435999896],
              [-64.11982824699993, -12.489675801999852],
              [-64.13476273699987, -12.510863138999909],
              [-64.1447879639999, -12.520371601999983],
              [-64.15525244199995, -12.51696095799987],
              [-64.18310603899991, -12.487918802999971],
              [-64.19754960099993, -12.478720396999876],
              [-64.21522294099995, -12.473759459999926],
              [-64.23656530799994, -12.475413105999877],
              [-64.24571203599993, -12.479443867999876],
              [-64.25682246899993, -12.490812682999959],
              [-64.26385046399986, -12.49525685599987],
              [-64.26870804899997, -12.497220560999907],
              [-64.27824235099988, -12.499287617999954],
              [-64.2875441079999, -12.497117207999878],
              [-64.29769852799987, -12.46569793699993],
              [-64.31265885399992, -12.4618738799999],
              [-64.35319901599993, -12.46921193499989],
              [-64.37676346899994, -12.465904642999888],
              [-64.39572871899989, -12.457326354999864],
              [-64.41133500199993, -12.445130716999941],
              [-64.42487422699992, -12.43138478599991],
              [-64.43236730999985, -12.420946146999967],
              [-64.44407202199992, -12.39975880899992],
              [-64.45252111899993, -12.390353697999956],
              [-64.46164200899989, -12.385289407999977],
              [-64.48363033099989, -12.377641296999911],
              [-64.48977982599985, -12.373610533999909],
              [-64.49244116299988, -12.356557311999978],
              [-64.47443192599988, -12.316456400999883],
              [-64.46931595899989, -12.29485565199991],
              [-64.46815323999996, -12.272634785999884],
              [-64.46905757699992, -12.261059264999929],
              [-64.47303666199988, -12.253204446999902],
              [-64.48939225299992, -12.239458515999956],
              [-64.49424983799986, -12.238011575999877],
              [-64.50884842999992, -12.23604787199993],
              [-64.5102436929999, -12.237288105999966],
              [-64.51034704599994, -12.2395618689999],
              [-64.51148392799993, -12.24266245499993],
              [-64.53210282399994, -12.232223815999902],
              [-64.54843257699989, -12.219098001999924],
              [-64.55489213099992, -12.217754414999959],
              [-64.58104040599994, -12.217444355999888],
              [-64.5934169109999, -12.215997415999894],
              [-64.64057165499992, -12.195120136999918],
              [-64.66485957799992, -12.180960794999876],
              [-64.67534989499995, -12.171038919999972],
              [-64.67718440799987, -12.167628274999942],
              [-64.68594356299994, -12.159153339999946],
              [-64.68899247299987, -12.15388234399991],
              [-64.68857906199986, -12.147164408999885],
              [-64.68157690499996, -12.134865416999943],
              [-64.68157690499996, -12.126597187999906],
              [-64.68646032699988, -12.109957376999972],
              [-64.68992264899993, -12.10437632199995],
              [-64.7063815919999, -12.10613332099993],
              [-64.71028316299996, -12.111921080999906],
              [-64.71364213099986, -12.138482766999928],
              [-64.71627762899988, -12.146544290999913],
              [-64.72839575199987, -12.149851582999915],
              [-64.73953202399991, -12.144580585999975],
              [-64.74418290299988, -12.133625182999907],
              [-64.73679317199995, -12.119775898999947],
              [-64.76857417799988, -12.08649627699991],
              [-64.78048559599992, -12.067686055999985],
              [-64.78518815099991, -12.047428893999978],
              [-64.7925003659999, -12.03254608099985],
              [-64.80929520699996, -12.02582814499992],
              [-64.82761450299992, -12.022314147999865],
              [-64.83983597899996, -12.016733092999942],
              [-64.8620826829999, -12.024794616999941],
              [-64.88350256399991, -12.02138397199991],
              [-64.90448319599992, -12.014045918999912],
              [-64.92515376799994, -12.009911803999984],
              [-64.96760595699996, -12.007948099999865],
              [-64.98344478399989, -12.003917337999965],
              [-64.99744909699987, -11.996269225999896],
              [-65.00943802899994, -11.984280292999927],
              [-65.01633683299991, -11.968467304999933],
              [-65.01463151099995, -11.950277200999892],
              [-65.00085974099991, -11.931053567999868],
              [-64.9964930829999, -11.921235045999907],
              [-64.99812088999997, -11.90893605499987],
              [-65.0045804449999, -11.898394062999984],
              [-65.0145281579999, -11.893846536999959],
              [-65.01793880199995, -11.893639830999902],
              [-65.02809322099989, -11.888885598999906],
              [-65.03367427599991, -11.879790547999932],
              [-65.03845434599992, -11.858499856999856],
              [-65.03920365399992, -11.848681334999895],
              [-65.03744665499994, -11.828424173999892],
              [-65.03845434599992, -11.818709004999945],
              [-65.04331193099995, -11.80765024799993],
              [-65.05630855399997, -11.785636087999947],
              [-65.06555863499997, -11.753079935999907],
              [-65.08106156499989, -11.7434681189999],
              [-65.09919999199991, -11.73623341899993],
              [-65.11356603999994, -11.722590839999924],
              [-65.11046545499988, -11.699956563999876],
              [-65.1134110109999, -11.690551452999927],
              [-65.12785457399991, -11.694582213999922],
              [-65.13397823199998, -11.702643737999907],
              [-65.13800899299989, -11.715252786999926],
              [-65.14353837099986, -11.763828633999935],
              [-65.15149654199993, -11.773130390999953],
              [-65.16446732599985, -11.769823099999954],
              [-65.18245072499994, -11.756697285999891],
              [-65.19619665599987, -11.741814472999948],
              [-65.20185522499992, -11.727965189999892],
              [-65.20232031299994, -11.691481628999966],
              [-65.20025325499998, -11.681973164999889],
              [-65.19133907099987, -11.666883645999889],
              [-65.18927201299991, -11.657065123999928],
              [-65.19335445199991, -11.632363789999914],
              [-65.19092565999995, -11.623165384999908],
              [-65.16743872199996, -11.615517272999938],
              [-65.17397578999993, -11.6065255729999],
              [-65.19544734799987, -11.592159524999886],
              [-65.20735876499992, -11.587611998999947],
              [-65.21454178899995, -11.587508645999918],
              [-65.21924434399995, -11.584511413999905],
              [-65.22340429699997, -11.571075540999871],
              [-65.22361100299992, -11.557949726999894],
              [-65.21598872899995, -11.53996632899991],
              [-65.21598872899995, -11.530147806999935],
              [-65.22265498899986, -11.517435403999883],
              [-65.23304195199998, -11.508340352999909],
              [-65.25756241899995, -11.49531789099997],
              [-65.29246984899993, -11.504723001999935],
              [-65.3195482999999, -11.476404316999933],
              [-65.35300878999988, -11.39062143899993],
              [-65.35476578799995, -11.382353209999891],
              [-65.35373225999987, -11.372431334999888],
              [-65.3475052499999, -11.360752460999919],
              [-65.33006445399985, -11.340495300999905],
              [-65.32644710299988, -11.327782897999953],
              [-65.33481868499985, -11.321168313999863],
              [-65.35391312699994, -11.310626322999894],
              [-65.37448034699992, -11.295846861999877],
              [-65.38727026399991, -11.277553404999907],
              [-65.38861385099995, -11.253162129999879],
              [-65.37861446099993, -11.24200001999995],
              [-65.36605708899992, -11.234041848999894],
              [-65.3600109459999, -11.218848978999858],
              [-65.36833085099994, -11.20541310599991],
              [-65.38520320699993, -11.193630879999901],
              [-65.39814815299985, -11.178024596999961],
              [-65.39473750899992, -11.153426614999972],
              [-65.37967382799994, -11.136373391999939],
              [-65.34104569599992, -11.10660776799996],
              [-65.33329422999992, -11.088521016999948],
              [-65.33704077199985, -11.067747089999898],
              [-65.3426993409999, -11.05059051499994],
              [-65.34197587199989, -11.032813821999909],
              [-65.32644710299988, -11.009352721999932],
              [-65.31784297699994, -11.002014668999934],
              [-65.3096522619999, -10.99664031899988],
              [-65.30298600299989, -10.99074920599989],
              [-65.29911027099985, -10.982067565999927],
              [-65.29960119599988, -10.969665221999946],
              [-65.3045104579999, -10.962017109999877],
              [-65.31011734999993, -10.956539407999884],
              [-65.31277868699996, -10.950958352999876],
              [-65.31897985899994, -10.86538218199992],
              [-65.32711889699993, -10.850499368999877],
              [-65.34218257699985, -10.834893085999937],
              [-65.36029516599987, -10.82259409599989],
              [-65.39969844599997, -10.812258808999971],
              [-65.40473689799992, -10.79923634899994],
              [-65.38977657099989, -10.75376108799989],
              [-65.38225764999993, -10.715623880999928],
              [-65.3810690919999, -10.698053893999955],
              [-65.38675349899995, -10.66952850299991],
              [-65.40078365099987, -10.655472512999978],
              [-65.41861202099992, -10.64451710999991],
              [-65.43569108199995, -10.625810241999929],
              [-65.43563940499993, -10.610824075999858],
              [-65.4292315269999, -10.561421406999926],
              [-65.43199621599985, -10.550672708999912],
              [-65.4358977869999, -10.546952005999898],
              [-65.43930843199993, -10.538167011999917],
              [-65.44163387099988, -10.527831725999903],
              [-65.44248653199989, -10.519356790999908],
              [-65.44147884099993, -10.51336232499996],
              [-65.43672460899992, -10.50406056699994],
              [-65.43569108199995, -10.499202982999918],
              [-65.43791316799985, -10.492588398999928],
              [-65.44997961499993, -10.47491505999993],
              [-65.44997961499993, -10.468093769999967],
              [-65.42538163299994, -10.463132832999918],
              [-65.41093806999993, -10.44918019599993],
              [-65.38727026399991, -10.4067021689999],
              [-65.39143021699994, -10.403498228999922],
              [-65.39308386199988, -10.400190937999923],
              [-65.39473750899992, -10.39243947299991],
              [-65.39464619599991, -10.392070069999903],
              [-65.3901899819999, -10.374042662999912],
              [-65.3792345789999, -10.35140838599996],
              [-65.36502355999994, -10.332184752999936],
              [-65.32781652899985, -10.31440806099991],
              [-65.31562089099992, -10.291257018999929],
              [-65.30536311899994, -10.242164408999884],
              [-65.28807735199985, -10.21622283899994],
              [-65.28482173699987, -10.20681772799989],
              [-65.28683711799991, -10.196482441999876],
              [-65.29681066899991, -10.173331400999885],
              [-65.29911027099985, -10.162996113999966],
              [-65.30146154799988, -10.119691263999911],
              [-65.3055698249999, -10.098400572999921],
              [-65.32414750199985, -10.046414081999899],
              [-65.33293249599993, -10.008380228999954],
              [-65.33683406599988, -9.96724578899989],
              [-65.33329422999992, -9.926834817999904],
              [-65.32523270699994, -9.905130716999906],
              [-65.30358028199996, -9.864513040999967],
              [-65.29911027099985, -9.841258645999858],
              [-65.30438126699997, -9.825652363999922],
              [-65.31660274299989, -9.812526549999944],
              [-65.33032283599991, -9.80074432399995],
              [-65.34006384299997, -9.789685566999935],
              [-65.35373225999987, -9.745037128999911],
              [-65.3560576989999, -9.741626484999884],
              [-65.37050126199995, -9.710620625999866],
              [-65.3979931239999, -9.686746113999973],
              [-65.41623490499995, -9.680131530999887],
              [-65.44248653199989, -9.679821471999986],
              [-65.45183996699984, -9.68137176499991],
              [-65.46522416199988, -9.69646128299992],
              [-65.51077693699995, -9.734081725999928],
              [-65.51713313799988, -9.743176777999906],
              [-65.52139644399995, -9.758576354999889],
              [-65.52542720599993, -9.76787811199992],
              [-65.53532324199992, -9.782450865999877],
              [-65.54682124799984, -9.795163268999929],
              [-65.55080033399992, -9.797023620999937],
              [-65.56281510499988, -9.799194029999924],
              [-65.5679827479999, -9.802087910999916],
              [-65.56992061399993, -9.806015319999887],
              [-65.57061824599992, -9.815833841999947],
              [-65.57188431899996, -9.818831074999963],
              [-65.57705196199996, -9.82616912899995],
              [-65.5793774009999, -9.832783710999948],
              [-65.58397660399993, -9.837227884999962],
              [-65.59612056499995, -9.837951353999955],
              [-65.61438818399989, -9.83392059299996],
              [-65.62888342299993, -9.826892597999858],
              [-65.6584940189999, -9.807358906999937],
              [-65.6637133379999, -9.802914732999938],
              [-65.67262752399992, -9.792579446999923],
              [-65.67895788699985, -9.789375507999864],
              [-65.68360876499992, -9.789892272999907],
              [-65.69435746299993, -9.793716328999935],
              [-65.69707047499986, -9.794336445999903],
              [-65.70505448499995, -9.79330291699992],
              [-65.71311600799993, -9.794233092999974],
              [-65.71730179899987, -9.791235859999873],
              [-65.71373612499991, -9.778730162999878],
              [-65.70996374499987, -9.755992532999898],
              [-65.72549251399988, -9.756819355999909],
              [-65.76319046999993, -9.77232228599992],
              [-65.77244055299985, -9.76880828799996],
              [-65.77734981299997, -9.763433939999913],
              [-65.7799594729999, -9.755992532999898],
              [-65.78220739799991, -9.746277363999951],
              [-65.78856359899993, -9.733048196999945],
              [-65.79450638799995, -9.737699075999913],
              [-65.80264542699987, -9.757336120999952],
              [-65.8038856609999, -9.764777526999879],
              [-65.80370479399994, -9.775526224999894],
              [-65.80641780599987, -9.784414570999914],
              [-65.81652054899993, -9.785964863999936],
              [-65.82212744199995, -9.781830748999909],
              [-65.82739843799988, -9.773975930999967],
              [-65.83166174399994, -9.765294290999918],
              [-65.83406469699989, -9.758266295999903],
              [-65.85042028899994, -9.775319518999936],
              [-65.86246089699992, -9.781830748999909],
              [-65.87442399099987, -9.781313984999969],
              [-65.91527421099994, -9.771702168999951],
              [-65.92933020099989, -9.770255227999954],
              [-65.94695186399986, -9.77139210999988],
              [-65.96565873199995, -9.77676645899993],
              [-66.0103846849999, -9.804051614999949],
              [-66.02947912699989, -9.808289082999906],
              [-66.0427858079999, -9.80487843799996],
              [-66.06932165499992, -9.79009897899995],
              [-66.081724, -9.78565480499995],
              [-66.0869949959999, -9.784517923999942],
              [-66.10198116099988, -9.78741180499992],
              [-66.1060635989999, -9.790409036999932],
              [-66.11311743199991, -9.802397968999898],
              [-66.11818172199989, -9.806015319999887],
              [-66.12358190899994, -9.805085143999932],
              [-66.12792272999994, -9.801157734999961],
              [-66.13169510899988, -9.797023620999937],
              [-66.13546748899998, -9.795163268999929],
              [-66.19065791899988, -9.80084767699988],
              [-66.20796952399988, -9.808082376999934],
              [-66.23897538299991, -9.828132831999895],
              [-66.25732051599991, -9.834850768999914],
              [-66.35527319399992, -9.849630227999924],
              [-66.3717321369999, -9.855934752999943],
              [-66.41327998899996, -9.879189147999867],
              [-66.43271032799996, -9.886113788999936],
              [-66.45286413599993, -9.888697611999945],
              [-66.51384232599989, -9.883943379999948],
              [-66.63187129799988, -9.90430389399998],
              [-66.64261999599998, -9.90792124399988],
              [-66.6489245199999, -9.915879414999935],
              [-66.65249019399997, -9.92611134899991],
              [-66.6548156339999, -9.937170104999922],
              [-66.66008662899992, -9.945334980999931],
              [-66.67000850399992, -9.951536152999921],
              [-66.75160559199989, -9.982645364999968],
              [-66.77062251799995, -9.99256724099996],
              [-66.90265580299993, -10.093129576999985],
              [-67.06429968299994, -10.256943867999908],
              [-67.11003332599998, -10.282575377999962],
              [-67.12073034699998, -10.284539082999899],
              [-67.1417626549999, -10.285572611999967],
              [-67.15173620699991, -10.288983254999906],
              [-67.1590742599999, -10.297148131999919],
              [-67.16486201999987, -10.30851694799992],
              [-67.17230342699989, -10.319575703999917],
              [-67.18470576999997, -10.326707051999946],
              [-67.20175899299991, -10.326810403999971],
              [-67.24103308199997, -10.316371764999943],
              [-67.25917150899991, -10.313684590999912],
              [-67.30066768399988, -10.315131529999917],
              [-67.32350866699989, -10.31885223399992],
              [-67.33782303899997, -10.326086933999889],
              [-67.33942500899991, -10.334871927999885],
              [-67.33368892399994, -10.3566793829999],
              [-67.33529089399988, -10.366291198999917],
              [-67.34283565299992, -10.372492370999893],
              [-67.35348099799992, -10.376213073999907],
              [-67.36500484199988, -10.378073424999911],
              [-67.40918819199996, -10.378796894999908],
              [-67.41833491999995, -10.381484069999942],
              [-67.42929032499993, -10.390372415999948],
              [-67.43187414599993, -10.397917174999904],
              [-67.43223588099991, -10.406082051999917],
              [-67.43662837799991, -10.417450866999914],
              [-67.45052933799991, -10.435951028999938],
              [-67.46804764899986, -10.452280781999974],
              [-67.48820145699992, -10.464786477999965],
              [-67.52933589799991, -10.478532409999914],
              [-67.56509598799991, -10.49589569099993],
              [-67.58462967899993, -10.50178680399992],
              [-67.5999775809999, -10.515429381999937],
              [-67.61113968999993, -10.528761900999953],
              [-67.6308284109999, -10.559561054999918],
              [-67.64348913599991, -10.5745472199999],
              [-67.67382320199997, -10.599351907999932],
              [-67.68467525199992, -10.61051401799996],
              [-67.6960440679999, -10.64048634799991],
              [-67.70513911999987, -10.67665985099994],
              [-67.72172725499988, -10.705495299999967],
              [-67.75578202299994, -10.714176940999934],
              [-67.77495397999985, -10.70652882899995],
              [-67.81427974499994, -10.675936380999943],
              [-67.8333483479999, -10.664980976999871],
              [-67.84776607299992, -10.66095021599996],
              [-67.86264888599987, -10.658779804999881],
              [-67.98181473899984, -10.664360859999903],
              [-68.01023677599997, -10.659709980999935],
              [-68.02713496999988, -10.661777038999986],
              [-68.04377478099988, -10.666944681999908],
              [-68.07457393399994, -10.681724140999918],
              [-68.0978800049999, -10.69774383499987],
              [-68.11209102399994, -10.714073587999906],
              [-68.1472826749999, -10.779599303999916],
              [-68.2035583089999, -10.838923848999926],
              [-68.21756262199992, -10.858044127999918],
              [-68.24376257399993, -10.916955260999927],
              [-68.25750850499986, -10.938762714999953],
              [-68.27435502199992, -10.960053405999943],
              [-68.2933202719999, -10.978966979999882],
              [-68.31383581599997, -10.99343638099991],
              [-68.33114741999987, -11.000464375999925],
              [-68.37827632699987, -11.005011900999946],
              [-68.39641475499991, -11.01441701199991],
              [-68.42819576099993, -11.043665872999952],
              [-68.4424067789999, -11.047696634999866],
              [-68.4596667079999, -11.04480275399996],
              [-68.47656490099988, -11.04480275399996],
              [-68.49330806499992, -11.047386575999965],
              [-68.53609615099995, -11.061545918999911],
              [-68.58803096599988, -11.098649596999905],
              [-68.6157295329999, -11.112498880999865],
              [-68.75833064899993, -11.141127623999935],
              [-68.7759264739999, -11.140610859999896],
              [-68.78398799699991, -11.13533986399996],
              [-68.78701106799991, -11.126038105999939],
              [-68.79117102099985, -11.085110371999917],
              [-68.78564164299985, -11.059272154999903],
              [-68.7739886069999, -11.035087584999928],
              [-68.75763301699993, -11.011936543999937],
              [-68.77455704799985, -11.003461608999928],
              [-68.80465856999993, -10.99467661599995],
              [-68.83168534399996, -11.000361021999893],
              [-68.85891882399997, -11.010489603999943],
              [-68.8840335699999, -11.016380716999947],
              [-68.90814062499993, -11.013383483999931],
              [-68.95542456099989, -11.000464375999925],
              [-68.97893733799987, -11.001704609999948],
              [-68.98338151099998, -11.002428079999945],
              [-68.99250240099985, -11.002428079999945],
              [-68.9969982509999, -11.001704609999948],
              [-69.07130896099997, -10.969975279999929],
              [-69.08688940499991, -10.967184752999884],
              [-69.1214867759999, -10.970595397999901],
              [-69.15851293999987, -10.962120462999906],
              [-69.23680273499994, -10.9529220579999],
              [-69.29351761899994, -10.954989114999961],
              [-69.32958776899994, -10.94940805999994],
              [-69.36307409699995, -10.940106301999919],
              [-69.3959403079999, -10.93504201199994],
              [-69.46337805199991, -10.951268411999948],
              [-69.50288468499994, -10.955299173999947],
              [-69.57763464399994, -10.95230194099993],
              [-69.59623815899991, -10.951991881999945],
              [-69.72020991999997, -10.964910989999865],
              [-69.75343786699992, -10.958296406999864],
              [-69.79105830999993, -10.934318542999947],
              [-69.80831823799991, -10.927187194999917],
              [-69.8350866289999, -10.925326842999908],
              [-69.87570430599993, -10.928014016999938],
              [-69.89513464399991, -10.92687713699992],
              [-69.9142032469999, -10.921399433999937],
              [-69.95611283399998, -10.919332376999876],
              [-70.19873368299992, -11.04118540399989],
              [-70.23948055099987, -11.055138040999879],
              [-70.28939998399994, -11.064749857999885],
              [-70.34102473999988, -11.067230325999958],
              [-70.39130590899993, -11.059065449999935],
              [-70.43727209499991, -11.036741231999969],
              [-70.46249019399997, -11.01390024799987],
              [-70.5071903079999, -10.961293639999965],
              [-70.53411372899993, -10.938142598999889],
              [-70.55555944899996, -10.942793477999942],
              [-70.64134232599986, -11.010799661999926],
              [-70.6411356209999, -10.929874368999933],
              [-70.64085139999992, -10.802646991999964],
              [-70.64051550299993, -10.675419616999903],
              [-70.64020544499994, -10.548088886999906],
              [-70.63984370999995, -10.420861510999941],
              [-70.63948197399995, -10.293530781999934],
              [-70.63917191599995, -10.16620005299994],
              [-70.6388618579999, -10.038869323999947],
              [-70.63865963799995, -9.95589164199987],
              [-70.63855179899991, -9.911641947999968],
              [-70.63844844599987, -9.851800638999919],
              [-70.62901749699992, -9.811596374999894],
              [-70.62322973699995, -9.801054381999933],
              [-70.61509069899992, -9.79226938899994],
              [-70.60545304399992, -9.785034688999886],
              [-70.59524694899994, -9.77904022199995],
              [-70.59007930499993, -9.77904022199995],
              [-70.57956315099997, -9.78565480499995],
              [-70.5741629639999, -9.784931334999953],
              [-70.56915035099985, -9.779143574999878],
              [-70.56666988099997, -9.767051289999898],
              [-70.56336258999997, -9.76074676499988],
              [-70.55124446699998, -9.74410695399996],
              [-70.54341548699995, -9.726950377999898],
              [-70.54186519399994, -9.708243509999917],
              [-70.54863480699987, -9.687676289999928],
              [-70.56021032799993, -9.673310241999928],
              [-70.5896142169999, -9.650262552999962],
              [-70.60080216599994, -9.635276386999891],
              [-70.60728755699992, -9.616776224999867],
              [-70.61467728699992, -9.584116719999898],
              [-70.62441829499997, -9.565823262999913],
              [-70.61922481399995, -9.564479674999859],
              [-70.59266312799994, -9.563756204999947],
              [-70.5874438079999, -9.565616556999956],
              [-70.57387874399993, -9.567786965999858],
              [-70.56452530899989, -9.565409850999913],
              [-70.57806453499995, -9.541845397999907],
              [-70.57615250699985, -9.52913299499994],
              [-70.5678584399999, -9.519211119999866],
              [-70.55512019899993, -9.516007180999893],
              [-70.5571872559999, -9.512596537999869],
              [-70.5597969159999, -9.504948424999967],
              [-70.56194148799989, -9.501744486999911],
              [-70.5432604579999, -9.493476256999955],
              [-70.53829951999995, -9.48097055999996],
              [-70.53566402199993, -9.464434102999874],
              [-70.52535457399995, -9.446760761999968],
              [-70.52375260399992, -9.44397023499991],
              [-70.52499283899994, -9.43094777399996],
              [-70.56697993999995, -9.435288594999946],
              [-70.58687536699995, -9.4395260619999],
              [-70.60638321999997, -9.448827819999934],
              [-70.62713130799989, -9.466604511999961],
              [-70.66209041399989, -9.509185892999923],
              [-70.6808489579999, -9.527686054999947],
              [-70.74727901299994, -9.564583027999973],
              [-70.76779455599993, -9.579879251999941],
              [-70.80538916099994, -9.618016458999904],
              [-70.82518123499992, -9.633622741999943],
              [-70.87548824099989, -9.660494485999934],
              [-70.89158544999995, -9.678581236999946],
              [-70.92026586899993, -9.72012908899994],
              [-70.9315571699999, -9.729740905999947],
              [-70.95747290099987, -9.7453471889999],
              [-70.9690484219999, -9.754855651999975],
              [-70.97760087099994, -9.766741230999912],
              [-70.98956396499997, -9.792062682999898],
              [-70.99721207699986, -9.80353485099991],
              [-71.01542801999992, -9.817487486999894],
              [-71.07746557699994, -9.83381723999993],
              [-71.1442573649999, -9.863066100999973],
              [-71.16105220499986, -9.875571797999967],
              [-71.17391963799986, -9.89727589899988],
              [-71.18311804199996, -9.920633646999917],
              [-71.1965022389999, -9.939857278999852],
              [-71.24512976199992, -9.956083678999946],
              [-71.28032141099987, -9.983472187999894],
              [-71.29970007399993, -9.993394062999897],
              [-71.31344600399987, -9.994220885999923],
              [-71.32171423399993, -9.989466653999926],
              [-71.3289489339999, -9.98336883499988],
              [-71.3396459549999, -9.97975148499998],
              [-71.35406367999991, -9.981301777999903],
              [-71.3595930589999, -9.986882832999925],
              [-71.3636238199999, -9.994530943999905],
              [-71.37339066599986, -10.002282409999907],
              [-71.39142574099986, -10.006829934999942],
              [-71.42868444899989, -10.006726581999914],
              [-71.60701981599993, -10.00651987699996],
              [-71.7853551849999, -10.006106465999949],
              [-71.96363887499984, -10.005899759999892],
              [-72.1419742439999, -10.005693053999934],
              [-72.1956660569999, -10.005589700999906],
              [-72.18460729999987, -9.984609069999905],
              [-72.18352209499997, -9.967039081999928],
              [-72.18553747599992, -9.949675800999913],
              [-72.18393550699989, -9.929005228999898],
              [-72.17835445199998, -9.91866994199998],
              [-72.16269649299991, -9.900066426999928],
              [-72.16042272999991, -9.887664082999962],
              [-72.16290319899989, -9.87722544299993],
              [-72.1711197509999, -9.856864928999897],
              [-72.17385860199994, -9.8458061729999],
              [-72.19473588099993, -9.805808613999929],
              [-72.26522253499988, -9.762193704999973],
              [-72.27700476099997, -9.724263203999968],
              [-72.26511918099996, -9.686539407999916],
              [-72.26165686099992, -9.66741912799992],
              [-72.26765132699992, -9.649539082999866],
              [-72.29488480699985, -9.61749969499995],
              [-72.30413488799985, -9.60085988399993],
              [-72.3069254159999, -9.579982604999955],
              [-72.30563350499995, -9.550630390999899],
              [-72.30677038599987, -9.540915221999853],
              [-72.31266149999996, -9.532543639999886],
              [-72.32294510999986, -9.53213022899996],
              [-72.33452063099992, -9.53399057999988],
              [-72.34454585799992, -9.532853697999954],
              [-72.3624775799999, -9.520658059999946],
              [-72.39022782499984, -9.496473489999886],
              [-72.40950313299987, -9.486344909999929],
              [-72.43022538299991, -9.4822107949999],
              [-72.49079016099995, -9.486448261999954],
              [-72.53564530399987, -9.481590677999932],
              [-72.55445552599988, -9.47600962299991],
              [-72.59605505399986, -9.45554575599995],
              [-72.63651770099995, -9.44293670699993],
              [-72.65594803899995, -9.439009297999874],
              [-72.6598237719999, -9.439836119999896],
              [-72.66778194199986, -9.445313821999974],
              [-72.67227779199987, -9.446657409999943],
              [-72.67801387599994, -9.445003763999892],
              [-72.68679886899992, -9.437459003999933],
              [-72.69170813099996, -9.435081887999985],
              [-72.8133027749999, -9.410897317999925],
              [-73.21498368399995, -9.40903696699992],
              [-73.19353796399992, -9.375653991999854],
              [-73.1408280039999, -9.322840677999906],
              [-73.11757360799987, -9.291938171999902],
              [-73.10119217899992, -9.260002135999926],
              [-73.09023677599993, -9.244189147999933],
              [-73.07840287299993, -9.236851094999935],
              [-73.06419185499996, -9.234784036999969],
              [-73.04791377799995, -9.230339863999873],
              [-73.03437455199986, -9.22258839899996],
              [-73.02853511599997, -9.21059946699991],
              [-73.02786332199989, -9.183107604999933],
              [-72.98238806199993, -9.14714080799996],
              [-72.97200109899993, -9.134428405999913],
              [-72.96368119399995, -9.11551483099987],
              [-72.9593920499999, -9.08564585399995],
              [-72.97003739499988, -9.001930032999908],
              [-72.97608353699994, -8.985393574999918],
              [-73.00367875199993, -8.94415578199991],
              [-73.01670121299986, -8.93040985099988],
              [-73.05380489199985, -8.906018574999848],
              [-73.06863602699988, -8.89371958399991],
              [-73.14584061699995, -8.78220184299991],
              [-73.16346227999995, -8.739620462999937],
              [-73.17457271299986, -8.7207068889999],
              [-73.19198767099988, -8.703860371999923],
              [-73.21100459799996, -8.69393849699992],
              [-73.26914058499995, -8.681639504999879],
              [-73.28986283399988, -8.670477395999853],
              [-73.30810461499993, -8.653217467999951],
              [-73.35058264199998, -8.598337096999941],
              [-73.35699051899991, -8.581800638999951],
              [-73.3576623139999, -8.562990416999938],
              [-73.34825720299995, -8.518341979999917],
              [-73.34929073199993, -8.49808481799991],
              [-73.35642207899988, -8.47979136099994],
              [-73.37052974499991, -8.465218606999969],
              [-73.3794180909999, -8.46191131599997],
              [-73.40050207599995, -8.459430846999908],
              [-73.4102172449999, -8.455503437999937],
              [-73.42024247299992, -8.446201679999916],
              [-73.43652054899994, -8.425221048999916],
              [-73.44726924699995, -8.416125996999938],
              [-73.52654089399988, -8.372407734999868],
              [-73.54082942699998, -8.359075215999937],
              [-73.54767655499992, -8.340161640999895],
              [-73.5527150069999, -8.299130553999944],
              [-73.56173254399994, -8.272672219999961],
              [-73.59061966999991, -8.234741719999946],
              [-73.60328039599995, -8.211590677999965],
              [-73.60617427599993, -8.192780455999952],
              [-73.60054154499988, -8.155470071999915],
              [-73.60110998599995, -8.136143086999965],
              [-73.61185868399988, -8.11257863399996],
              [-73.64472489499991, -8.06834360799985],
              [-73.65164953699988, -8.046019387999877],
              [-73.66803096599992, -8.013773294999922],
              [-73.70590979099993, -7.993826191999901],
              [-73.7484911709999, -7.976979674999924],
              [-73.77879939799993, -7.954138691999916],
              [-73.78494889399991, -7.94039276099997],
              [-73.79577510599995, -7.89223032599989],
              [-73.79463822499994, -7.874143574999977],
              [-73.77960038299994, -7.874453632999874],
              [-73.74611405499985, -7.886442565999914],
              [-73.71371293199985, -7.866288756999936],
              [-73.70255082299991, -7.827841490999987],
              [-73.71216263899993, -7.78815399199992],
              [-73.7422383219999, -7.764072774999875],
              [-73.77960038299994, -7.752910663999941],
              [-73.8111488449999, -7.739268086999928],
              [-73.83879573599992, -7.720561217999943],
              [-73.96938207999992, -7.584652200999926],
              [-74.00966385999996, -7.56108774799992],
              [-74.01847469099994, -7.543517760999947],
              [-73.9844863999999, -7.529407299999946],
              [-73.97142329999988, -7.523984068999937],
              [-73.95871089799991, -7.501969908999868],
              [-73.95778072199997, -7.480369160999885],
              [-73.94987422799991, -7.46517628999996],
              [-73.94431901099989, -7.448743183999895],
              [-73.9505460209999, -7.42321502699987],
              [-73.97943314599985, -7.374535827999935],
              [-73.9828954679999, -7.356449076999922],
              [-73.96106217499994, -7.356449076999922],
              [-73.92047033799992, -7.372158711999887],
              [-73.90202185099992, -7.373398945999924],
              [-73.87974930899986, -7.365027363999943],
              [-73.8434207759999, -7.343116555999899],
              [-73.82585078999992, -7.337432148999952],
              [-73.80027095599988, -7.335675149999872],
              [-73.76076432399992, -7.337432148999952],
              [-73.74125646999994, -7.334434915999935],
              [-73.72474584999995, -7.324823098999929],
              [-73.71309281399988, -7.304669290999939],
              [-73.7160900479999, -7.286375833999969],
              [-73.72453914399998, -7.26756561299996],
              [-73.73453853399991, -7.22508758599993],
              [-73.80355240899985, -7.126488952999935],
              [-73.80676214999997, -7.117879292999888],
              [-73.81233740199994, -7.102924498999926],
              [-73.80657547999988, -7.078223164999926],
              [-73.7922611089999, -7.050007831999949],
              [-73.7677148029999, -6.959264017999899],
              [-73.76549271699992, -6.904176939999928],
              [-73.75942073599987, -6.88743377699997],
              [-73.74859452299992, -6.875548197999947],
              [-73.70678828999988, -6.849606627999904],
              [-73.69696976799989, -6.837204284999927],
              [-73.68508418799988, -6.811882832999856],
              [-73.6719583739999, -6.800720723999916],
              [-73.64405310099991, -6.783977559999883],
              [-73.59387528499988, -6.743980000999912],
              [-73.51320837499986, -6.69778126999995],
              [-73.44540889499984, -6.639593606999938],
              [-73.40628983599993, -6.615615742999921],
              [-73.37068477399993, -6.583886413999906],
              [-73.34918737899991, -6.576445007999979],
              [-73.27849401899991, -6.575721536999893],
              [-73.23358719899989, -6.56404266299991],
              [-73.19896398899988, -6.545645852999911],
              [-73.17147212799992, -6.517430521999941],
              [-73.1478043219999, -6.476192727999944],
              [-73.13178462799993, -6.435264994999926],
              [-73.12703039599992, -6.413044127999896],
              [-73.12697871899994, -6.391340026999984],
              [-73.13380000899988, -6.368085631999875],
              [-73.15571081599992, -6.322713723999939],
              [-73.16155025199993, -6.299769388999906],
              [-73.17204056899996, -6.219670918999938],
              [-73.1776732999999, -6.202410989999862],
              [-73.22599076299991, -6.147944029999863],
              [-73.23529252199995, -6.12365610699996],
              [-73.23477575799993, -6.077560729999931],
              [-73.2188594159999, -6.040250345999894],
              [-73.19710363799987, -6.005007018999919],
              [-73.14000117999987, -5.878503112999852],
              [-73.10563635299994, -5.84698048899989],
              [-73.0013533129999, -5.708797708999938],
              [-72.98719396999985, -5.681099140999919],
              [-72.97691035999995, -5.651746927999937],
              [-72.96047725499989, -5.559246113999905],
              [-72.96032222599985, -5.531237487999903],
              [-72.96910721899994, -5.499198098999983],
              [-72.97349971599994, -5.466125182999903],
              [-72.96419795799989, -5.433775735999916],
              [-72.9347940669999, -5.372177428999876],
              [-72.93050492399993, -5.356467793999911],
              [-72.92399369399988, -5.313576354999952],
              [-72.91624222799996, -5.299106953999924],
              [-72.90539017699993, -5.285671080999876],
              [-72.89665686099994, -5.271615091999948],
              [-72.89489986199996, -5.255698749999922],
              [-72.90032588699995, -5.194617207999926],
              [-72.90559688399989, -5.179114277999915],
              [-72.91495031799991, -5.164438171999933],
              [-72.92197831299993, -5.146868183999871],
              [-72.91794755099994, -5.132088724999946],
              [-72.89381465699998, -5.125887552999956],
              [-72.88068884299992, -5.125267434999984],
              [-72.87283402499989, -5.123613789999936],
              [-72.85893306499989, -5.116069030999896],
              [-72.85769282999988, -5.112141621999925],
              [-72.85702103699987, -5.097568867999954],
              [-72.85397212699985, -5.09250457799989],
              [-72.84901118999991, -5.092091165999875],
              [-72.83635046399988, -5.096225280999903],
              [-72.83113114399993, -5.096638691999914],
              [-72.79030676399995, -5.088783873999972],
              [-72.77294348199993, -5.081135762999907],
              [-72.76017940299997, -5.064702656999927],
              [-72.74757035399995, -5.055090840999924],
              [-72.72881180899995, -5.057261250999915],
              [-72.70798620699989, -5.063152363999919],
              [-72.65419104099996, -5.063152363999919],
              [-72.6447859299999, -5.060568541999913],
              [-72.63507076099995, -5.051783548999921],
              [-72.63243526199994, -5.042791849999972],
              [-72.63160843899993, -5.033180032999965],
              [-72.62726761899995, -5.022431334999851],
              [-72.61434851099995, -5.009718932999903],
              [-72.58659826699991, -4.996696471999954],
              [-72.56220699099987, -4.97023813899996],
              [-72.5464456789999, -4.958249206999909],
              [-72.52851395699992, -4.950187682999925],
              [-72.50975541199992, -4.94750050899998],
              [-72.49513098199995, -4.946983743999851],
              [-72.48892980999995, -4.941195983999876],
              [-72.48588090099994, -4.932566019999925],
              [-72.48066158099991, -4.923367613999929],
              [-72.47967972799995, -4.919646910999916],
              [-72.47993811099991, -4.914169209999926],
              [-72.47947302299988, -4.908071390999879],
              [-72.47647578999988, -4.902490335999872],
              [-72.4717732339999, -4.900733336999892],
              [-72.45797562699994, -4.900423278999895],
              [-72.45260127799989, -4.899183043999955],
              [-72.43110388199995, -4.887814228999972],
              [-72.41467077699988, -4.876342060999946],
              [-72.40412878499993, -4.860219013999966],
              [-72.39684240699995, -4.805648701999942],
              [-72.38609370899991, -4.793969827999973],
              [-72.34470088699987, -4.782601012999891],
              [-72.33942989099995, -4.777330016999954],
              [-72.33684606999995, -4.769888610999928],
              [-72.33193680799991, -4.763274026999937],
              [-72.31979284699992, -4.760173441999896],
              [-72.28237910999994, -4.765444436999928],
              [-72.2693049719999, -4.764927672999889],
              [-72.25106319199992, -4.758829853999927],
              [-72.23313146999996, -4.748391214999899],
              [-72.18243688999988, -4.710667418999932],
              [-72.12709143199996, -4.680074970999925],
              [-72.10802282699987, -4.664261982999932],
              [-72.09660233599996, -4.649792581999904],
              [-72.07872228999992, -4.613412373999921],
              [-72.07112585499993, -4.605144143999965],
              [-72.06270259599995, -4.605660908999909],
              [-72.05355586799996, -4.610208434999947],
              [-72.04358231599986, -4.613825785999921],
              [-72.03552079299996, -4.611862080999899],
              [-72.02616735899991, -4.605660908999909],
              [-72.0098376059999, -4.591604918999892],
              [-71.98027868699995, -4.582303160999871],
              [-71.93314978099994, -4.536724548999885],
              [-71.90720821199992, -4.518431090999911],
              [-71.89015498899997, -4.513676858999915],
              [-71.80762772699995, -4.504478454999912],
              [-71.80065140799985, -4.502411396999946],
              [-71.79698238199995, -4.49796722399995],
              [-71.79574214699991, -4.491145934999892],
              [-71.7930549729999, -4.48463470399993],
              [-71.78483841999986, -4.480500589999906],
              [-71.7743481039999, -4.481534118999974],
              [-71.75145544499989, -4.492076110999946],
              [-71.74018998199992, -4.495590107999902],
              [-71.72106970199994, -4.492799580999943],
              [-71.70964921099991, -4.484738056999944],
              [-71.69931392499993, -4.481637470999914],
              [-71.68334590699988, -4.49352305099994],
              [-71.67306229699989, -4.503651630999897],
              [-71.66520747899995, -4.507579039999953],
              [-71.65652583799991, -4.506752217999932],
              [-71.64381343699995, -4.502308043999932],
              [-71.62350459799993, -4.482257587999882],
              [-71.6134276949999, -4.479260355999955],
              [-71.6171483979999, -4.500344339999899],
              [-71.5715697839999, -4.480707295999949],
              [-71.55756547099992, -4.479363707999894],
              [-71.53234737199995, -4.48463470399993],
              [-71.52459590699993, -4.485151468999959],
              [-71.51906652799994, -4.479157002999941],
              [-71.51286535699995, -4.457142842999957],
              [-71.50614742099992, -4.44856455399993],
              [-71.49234981399988, -4.442776794999943],
              [-71.47741532499992, -4.440606383999864],
              [-71.44697790599986, -4.440296325999967],
              [-71.4007791759999, -4.433371683999894],
              [-71.38698156799995, -4.434921975999913],
              [-71.37762813299992, -4.442673441999929],
              [-71.37116857999987, -4.453215432999897],
              [-71.3632620859999, -4.459209899999919],
              [-71.34956783099989, -4.453525492999873],
              [-71.34589880399989, -4.450114847999942],
              [-71.33701045799998, -4.438332620999944],
              [-71.33075760899987, -4.435128681999885],
              [-71.32409134999997, -4.436575622999968],
              [-71.31845861899984, -4.439366149999927],
              [-71.31515132699994, -4.439986266999895],
              [-71.30538448199988, -4.42706715899989],
              [-71.30512609899992, -4.416628519999946],
              [-71.30724483299988, -4.406809997999886],
              [-71.30460933399988, -4.394924417999945],
              [-71.28848628799989, -4.3807650749999],
              [-71.26481848099988, -4.375494079999967],
              [-71.24166743999987, -4.380041605999907],
              [-71.21407222499997, -4.410840758999967],
              [-71.20068802999992, -4.395647887999942],
              [-71.1861669519999, -4.37218678799988],
              [-71.1696821699999, -4.362781676999916],
              [-71.16311926299994, -4.369086201999934],
              [-71.15247391799994, -4.391720478999972],
              [-71.14410233599995, -4.399265238999931],
              [-71.12849605299994, -4.401849059999932],
              [-71.1195560299999, -4.396371357999939],
              [-71.10604264399993, -4.373840432999927],
              [-71.08157385299998, -4.364125263999881],
              [-71.02932897999997, -4.385829365999882],
              [-71.00997615599991, -4.369809671999931],
              [-71.0054544679999, -4.347588805999891],
              [-70.98971899499992, -4.366192321999947],
              [-70.96868668699992, -4.385312601999942],
              [-70.9480936279999, -4.364228617999913],
              [-70.93884354699989, -4.345108337999918],
              [-70.92633785099989, -4.328985289999935],
              [-70.89639135799987, -4.299839781999921],
              [-70.8865728349999, -4.283510029999974],
              [-70.8811209719999, -4.265629984999919],
              [-70.8737054039999, -4.250747171999876],
              [-70.8582541509999, -4.243305764999945],
              [-70.8427512209999, -4.238138121999953],
              [-70.8398056639999, -4.228733011999893],
              [-70.8483064379999, -4.204445088999904],
              [-70.84518001399994, -4.191009215999941],
              [-70.83223506699991, -4.179433694999901],
              [-70.78456355799997, -4.156282653999909],
              [-70.77425410999987, -4.155042418999884],
              [-70.71211319999989, -4.171888935999945],
              [-70.69405228799988, -4.172302346999871],
              [-70.6830710459999, -4.163827412999865],
              [-70.6720381269999, -4.133441669999911],
              [-70.66289139799991, -4.122176208999946],
              [-70.64676835199992, -4.115664977999884],
              [-70.63105871599987, -4.118972268999883],
              [-70.62958593799996, -4.133441669999911],
              [-70.63317744999995, -4.15183847999991],
              [-70.63253149499988, -4.166824645999966],
              [-70.58527339699992, -4.194523213999901],
              [-70.57656591799986, -4.183877868999915],
              [-70.57232845099992, -4.165894469999927],
              [-70.56563635299989, -4.148841247999897],
              [-70.54969417399985, -4.14067637099987],
              [-70.53411372899993, -4.146774189999931],
              [-70.52938533499994, -4.161346943999888],
              [-70.52638810299993, -4.176023049999884],
              [-70.5159753019999, -4.182327575999892],
              [-70.50088578299989, -4.177366637999938],
              [-70.4600097249999, -4.14460377999994],
              [-70.4442225759999, -4.137369078999967],
              [-70.42993404199993, -4.134165140999897],
              [-70.41533544899994, -4.135612080999891],
              [-70.39866980099993, -4.142330016999921],
              [-70.37368424599993, -4.164550882999947],
              [-70.3614369309999, -4.168168232999932],
              [-70.3430659599999, -4.139436136999933],
              [-70.33061193899994, -4.143156839999946],
              [-70.3187005209999, -4.156282653999909],
              [-70.31110408499993, -4.170855406999877],
              [-70.30934708699996, -4.191215921999898],
              [-70.3183904629999, -4.228939716999946],
              [-70.31671097899996, -4.247026467999959],
              [-70.3069958099999, -4.260255634999865],
              [-70.2575931399999, -4.299219665999942],
              [-70.24798132399988, -4.30211354599993],
              [-70.23917049199989, -4.301803486999944],
              [-70.23131567399986, -4.303663837999949],
              [-70.22472692899996, -4.313068948999913],
              [-70.21674291999989, -4.328881936999906],
              [-70.20563248699997, -4.342937926999923],
              [-70.1865638839999, -4.326298115999904],
              [-70.17025996899986, -4.288470967999928],
              [-70.15726334699994, -4.270177510999957],
              [-70.13889237499984, -4.260462340999922],
              [-70.11651647999986, -4.258291930999931],
              [-70.09662105399985, -4.265733336999944],
              [-70.08574316499991, -4.283923441999889],
              [-70.08109228599994, -4.30883148199996],
              [-70.07561458299995, -4.316169534999858],
              [-70.06334143099991, -4.328468525999895],
              [-70.05096492599995, -4.337253518999972],
              [-70.03703812699987, -4.340870869999961],
              [-70.02290462299993, -4.338907165999927],
              [-69.98939245599993, -4.314619241999935],
              [-69.97182246999995, -4.290951435999901],
              [-69.96257238799984, -4.26428639699995],
              [-69.96494950399997, -4.236484476999905],
              [-69.96386429899988, -4.234314066999914],
              [-69.96272741699997, -4.232040303999895],
              [-69.96164221299998, -4.229766539999972],
              [-69.96050533099987, -4.227596129999895],
              [-69.95942012499998, -4.225425719999905],
              [-69.95833492099987, -4.223151956999885],
              [-69.95719803899988, -4.220878193999866],
              [-69.95611283399998, -4.218811136999904],
              [-69.9550793059999, -4.216640725999909],
              [-69.95391658599988, -4.21436696299989],
              [-69.95277970399988, -4.212093199999885],
              [-69.95169449899987, -4.209922790999883],
              [-69.95055761799998, -4.207752379999903],
              [-69.94942073599987, -4.205581969999912],
              [-69.94833553099997, -4.203411559999921],
              [-69.94719864899986, -4.201137796999902],
              [-69.91784643599988, -4.040010680999913],
              [-69.88852006099992, -3.87878021199991],
              [-69.85916784699992, -3.717653095999935],
              [-69.82981563399997, -3.55652598099995],
              [-69.80046341999989, -3.395295511999947],
              [-69.77116288299993, -3.234168395999873],
              [-69.74173315499993, -3.072937926999955],
              [-69.71240677899996, -2.911810810999967],
              [-69.6830804039999, -2.750683694999907],
              [-69.65370235199993, -2.589453226999893],
              [-69.62435013799984, -2.428326110999919],
              [-69.59499792499986, -2.267095641999902],
              [-69.5656973879999, -2.105968525999927],
              [-69.5363193359999, -1.944841409999938],
              [-69.50696712299995, -1.783610940999935],
              [-69.47761490999997, -1.62248382599995],
              [-69.46642696099994, -1.561092223999879],
              [-69.45193172299989, -1.510862731999936],
              [-69.45226761899988, -1.4905022169999],
              [-69.43394832399991, -1.42218597399993],
              [-69.43469763199991, -1.376400654999898],
              [-69.41831620299988, -1.284106546999922],
              [-69.42106507199992, -1.239310156999906],
              [-69.4211067299999, -1.238631285999958],
              [-69.39945430499992, -1.182717386999883],
              [-69.41046138599992, -1.152745055999929],
              [-69.44815934299996, -1.092076924999944],
              [-69.44828853399991, -1.080398050999875],
              [-69.44193233299987, -1.059830830999886],
              [-69.43976192199997, -1.048668720999942],
              [-69.44503291899991, -1.010738219999936],
              [-69.44286250899992, -1.008361103999988],
              [-69.44691910799992, -1.000816344999947],
              [-69.44996801799996, -0.996785582999948],
              [-69.45508398499993, -0.994615172999957],
              [-69.46513505099998, -0.993064879999849],
              [-69.47123286999994, -0.988000589999956],
              [-69.49314367699989, -0.956167906999923],
              [-69.50247127399993, -0.950276793999919],
              [-69.52427872799984, -0.940975036999887],
              [-69.5325986329999, -0.934050394999915],
              [-69.53923905399992, -0.920614521999951],
              [-69.53861893799984, -0.910589293999934],
              [-69.53621598299989, -0.901184183999888],
              [-69.53732702699989, -0.889505309999905],
              [-69.5432956539999, -0.878653258999861],
              [-69.5502461349999, -0.873175556999868],
              [-69.55750667399988, -0.869454853999869],
              [-69.56419877199988, -0.863460387999922],
              [-69.57324214799985, -0.849197691999947],
              [-69.5756709389999, -0.839172464999933],
              [-69.57272538299992, -0.813540954999965],
              [-69.58068355399988, -0.79938161199992],
              [-69.61835567199992, -0.756903584999876],
              [-69.62838090099993, -0.733442483999909],
              [-69.6219730219999, -0.715355732999896],
              [-69.59076045799992, -0.66822682699997],
              [-69.58422338899993, -0.644559020999864],
              [-69.58696223999988, -0.63246673599987],
              [-69.59269832399994, -0.624095153999889],
              [-69.59926123099993, -0.616447040999915],
              [-69.60453222699994, -0.606318460999958],
              [-69.60657344599991, -0.596499938999983],
              [-69.60706437199994, -0.566837665999927],
              [-69.61171525099991, -0.544616800999989],
              [-69.61975093599989, -0.52456634499994],
              [-69.63207576499994, -0.506893005999942],
              [-69.64951656099987, -0.492010192999899],
              [-69.66649226999988, -0.482915140999935],
              [-69.74646154799993, -0.453046162999911],
              [-69.76157690499991, -0.440850524999902],
              [-69.79144588199995, -0.408191019999933],
              [-69.80175533099992, -0.40095631899996],
              [-69.82477718099989, -0.390207620999945],
              [-69.8347765709999, -0.383179625999929],
              [-69.84229549199995, -0.373154398999915],
              [-69.85167476399991, -0.350830179999946],
              [-69.85810848099996, -0.341425068999897],
              [-69.8752392179999, -0.330573017999939],
              [-69.91497839399992, -0.321684671999918],
              [-69.93363358599987, -0.314346618999934],
              [-69.94435644599989, -0.305458272999914],
              [-69.96665482599994, -0.272282002999901],
              [-70.01755611199988, -0.22566985999994],
              [-70.05636511299991, -0.181021422999905],
              [-70.0680439859999, -0.160144144999933],
              [-70.07380590799994, -0.124900817999958],
              [-70.07248815999989, -0.074671324999912],
              [-70.07181636599992, -0.049143167999972],
              [-70.06995601499992, 0.018036194000075],
              [-70.06726883999988, 0.113017477000085],
              [-70.06427160699988, 0.22195139600008],
              [-70.06137772599988, 0.330885315000089],
              [-70.05869055199994, 0.425866598000084],
              [-70.05683020099994, 0.493045960000046],
              [-70.05610673099994, 0.518574117000085],
              [-70.05424637899995, 0.588130595000081],
              [-70.03941524299992, 0.574591369000103],
              [-70.02065669799993, 0.579862366000043],
              [-69.99923681699991, 0.589784241000118],
              [-69.97649918599993, 0.5904043580001],
              [-69.9528572179999, 0.585753480000037],
              [-69.93389196799984, 0.588957418000106],
              [-69.91446162999995, 0.594538473000028],
              [-69.84591284199993, 0.598672587000053],
              [-69.80532100499991, 0.60694081600009],
              [-69.76754553299995, 0.620686748000125],
              [-69.73287064599992, 0.638980205000095],
              [-69.69468176299995, 0.668745829000088],
              [-69.67948889199991, 0.670037740000041],
              [-69.65127355999994, 0.65737701400009],
              [-69.61915665699993, 0.650659078000075],
              [-69.60458390299996, 0.667402242000108],
              [-69.59411942599993, 0.689313049000077],
              [-69.574224, 0.697943014000117],
              [-69.55564632199989, 0.700165100000021],
              [-69.52342606599993, 0.720939026000067],
              [-69.50371150799995, 0.72962066700012],
              [-69.4780799969999, 0.732824606000094],
              [-69.4578745119999, 0.728070374000097],
              [-69.43971024599998, 0.715771382000057],
              [-69.36893937199994, 0.644406230000072],
              [-69.36255733199991, 0.640943909000029],
              [-69.34232600899992, 0.650245667000149],
              [-69.32026017299992, 0.656343486000111],
              [-69.30214758399998, 0.656550191000065],
              [-69.29281998699986, 0.645594788000096],
              [-69.2970574549999, 0.618102925000116],
              [-69.2789965419999, 0.619239807000042],
              [-69.24238378899986, 0.613762106000138],
              [-69.22618322799985, 0.614795634000117],
              [-69.21905187999991, 0.619549866000114],
              [-69.20835485799992, 0.63463938400011],
              [-69.2006033939999, 0.639496969000035],
              [-69.19013891699987, 0.639703674000089],
              [-69.17140620899997, 0.632779033000105],
              [-69.16233699599991, 0.631435445000051],
              [-69.14365596599993, 0.637533265000101],
              [-69.13745479399995, 0.650142314000036],
              [-69.14120133499995, 0.668177388000032],
              [-69.15207922399992, 0.690553283000014],
              [-69.15949479199992, 0.697322897000049],
              [-69.18119889399992, 0.707503154000023],
              [-69.18926041699993, 0.715151266000092],
              [-69.19225764999993, 0.728948873000135],
              [-69.18502294999988, 0.737682190000015],
              [-69.17455847199992, 0.745433655000028],
              [-69.16776302199989, 0.756027323000097],
              [-69.16776302199989, 0.778971659000121],
              [-69.17760738099986, 0.823568421000047],
              [-69.17538529499987, 0.844445699000119],
              [-69.16931331399991, 0.848063049000103],
              [-69.15975317399992, 0.849613342000026],
              [-69.15233760599989, 0.854264221000093],
              [-69.1523892829999, 0.867803446000067],
              [-69.1589263519999, 0.876175028000134],
              [-69.1707344159999, 0.883151347000137],
              [-69.19388545699988, 0.892091370000074],
              [-69.20998266599995, 0.907542623000069],
              [-69.20432409699993, 0.943664449000082],
              [-69.22618322799985, 0.957203675000059],
              [-69.22912878499994, 0.967435608000045],
              [-69.23016231399993, 0.979114482000114],
              [-69.23284948799997, 0.988364563000033],
              [-69.24023921699995, 0.995650941000108],
              [-69.25718908699989, 1.006916402000073],
              [-69.27426814799992, 1.028207093000049],
              [-69.28881506399998, 1.038439026000034],
              [-69.33878617399995, 1.064122213000104],
              [-69.35496089799994, 1.067067770000108],
              [-69.37085139999996, 1.062985332000011],
              [-69.4181611729999, 1.02862050400006],
              [-69.42841894599991, 1.030480855000064],
              [-69.44728084399992, 1.041694641000021],
              [-69.4523709719999, 1.046242167000059],
              [-69.45541988199994, 1.050738017000072],
              [-69.45976070099991, 1.055182190000082],
              [-69.46872656299985, 1.05941965700012],
              [-69.47826086499995, 1.060659892000075],
              [-69.51009354699988, 1.056112366000121],
              [-69.54295975699992, 1.055595601000093],
              [-69.55329504399992, 1.056835836000033],
              [-69.59675492399992, 1.071925354000129],
              [-69.61990596599992, 1.072752177000055],
              [-69.71602412899995, 1.058592835000098],
              [-69.7265144459999, 1.061021627000073],
              [-69.72806473799992, 1.08298411100013],
              [-69.7368238929999, 1.088358459000091],
              [-69.7496654869999, 1.090528870000085],
              [-69.76255875699988, 1.091097310000038],
              [-69.78767350299992, 1.084224345000067],
              [-69.82935054599994, 1.057249248000048],
              [-69.85219152899995, 1.05941965700012],
              [-69.85193314599988, 1.119260966000084],
              [-69.85154557399997, 1.187990621000068],
              [-69.85110632399994, 1.256616923000109],
              [-69.85077042599994, 1.325346578000079],
              [-69.85035701499993, 1.39405039500005],
              [-69.84999527999994, 1.462805888000034],
              [-69.84960770699985, 1.531483866000087],
              [-69.84924597199995, 1.600187684000062],
              [-69.84880672299991, 1.668891500000129],
              [-69.85617061399992, 1.707674663000063],
              [-69.84118458799986, 1.707579109000065],
              [-69.8075430909999, 1.707364603000087],
              [-69.78919795799993, 1.712790629000054],
              [-69.74635819499989, 1.735166525000039],
              [-69.72914994299992, 1.738990581000081],
              [-69.71145076499991, 1.738525493000054],
              [-69.69008256099991, 1.735476583000121],
              [-69.64905147299996, 1.738938904000065],
              [-69.58029597999987, 1.770228983000067],
              [-69.54195206699987, 1.772709452000043],
              [-69.46919165099987, 1.757387390000076],
              [-69.39338232499998, 1.725270488000135],
              [-69.35240291399995, 1.720206197000067],
              [-69.30452469999994, 1.720206197000067],
              [-69.17838252799996, 1.720309550000096],
              [-68.9999954839999, 1.720464580000041],
              [-68.79548600299992, 1.720671285000094],
              [-68.59102819899988, 1.720877991000052],
              [-68.4126411549999, 1.721033021000096],
              [-68.28644730699992, 1.721136373000121],
              [-68.23859492999992, 1.721188049000133],
              [-68.16330236799988, 1.721291402000062],
              [-68.1804072679999, 1.729688823000046],
              [-68.18877884999998, 1.73583831800002],
              [-68.19172440599988, 1.742427063000108],
              [-68.19074255499993, 1.755010274000128],
              [-68.19353308199987, 1.763743592000097],
              [-68.20154292799995, 1.768678691000048],
              [-68.2389566649999, 1.770280660000083],
              [-68.24112707599991, 1.788341573000082],
              [-68.2389566649999, 1.810252380000037],
              [-68.24831009899995, 1.82211212100006],
              [-68.27368322799995, 1.825264385000111],
              [-68.28024613499994, 1.829398499000135],
              [-68.26081579699985, 1.858208110000064],
              [-68.20081945799987, 2.007837219000123],
              [-68.1921894939999, 2.014891052000038],
              [-68.18743526299991, 2.008250631000038],
              [-68.18728023299988, 1.988200175000088],
              [-68.18516149999991, 1.980758769000062],
              [-68.17709997599991, 1.973188172000107],
              [-68.1697619219999, 1.969725851000064],
              [-68.14914302699992, 1.965540060000123],
              [-68.12614701399988, 1.956212463000099],
              [-68.11110917199997, 1.942414856000141],
              [-68.10123897299991, 1.924121399000072],
              [-68.07922481299991, 1.859965109000143],
              [-68.05865759299994, 1.816401876000015],
              [-68.03178584899993, 1.777515361000042],
              [-67.99824784299992, 1.749971823000067],
              [-67.96486486899994, 1.740153300000088],
              [-67.92884639499997, 1.741290181000096],
              [-67.89318965699997, 1.749713440000093],
              [-67.86053015199991, 1.76152150500009],
              [-67.82084265199993, 1.784000753000015],
              [-67.79045690999996, 1.812577820000072],
              [-67.66974076299996, 1.973343201000148],
              [-67.59294958599989, 2.05481109600008],
              [-67.55439896699991, 2.073130392000067],
              [-67.52732051599986, 2.096591492000044],
              [-67.51026729399993, 2.107417705000074],
              [-67.47533402499994, 2.111861877000081],
              [-67.46608394399993, 2.116357727000107],
              [-67.44913407399991, 2.134134420000038],
              [-67.43972896299996, 2.139560445000114],
              [-67.42463944599987, 2.138113505000121],
              [-67.3817480059999, 2.122739767000041],
              [-67.36577998899986, 2.114962464000129],
              [-67.34061356599992, 2.090106100000071],
              [-67.32040808199994, 2.053079936000117],
              [-67.2886270759999, 1.974893494000071],
              [-67.2647525639999, 1.932544657000065],
              [-67.15571529199988, 1.788083191000112],
              [-67.11716467399992, 1.709793396000052],
              [-67.08295487499993, 1.604631856000069],
              [-67.07360144099988, 1.541199035000133],
              [-67.09819942199996, 1.253361308000123],
              [-67.09447871899994, 1.20121978800006],
              [-67.08610713699997, 1.176001689000103],
              [-67.06522985899991, 1.172694397000015],
              [-66.97820674699994, 1.196827291000062],
              [-66.91340450099995, 1.214862366000062],
              [-66.87506058799994, 1.222510478000046],
              [-66.85676713099988, 1.206077372000081],
              [-66.80855301999986, 1.162772522000111],
              [-66.74039180599993, 1.101587626000082],
              [-66.66220536299991, 1.031411031000118],
              [-66.58407059799987, 0.961131083000026],
              [-66.51590938399994, 0.899946187000097],
              [-66.46769527199987, 0.856641337000042],
              [-66.4494534909999, 0.840208232000066],
              [-66.4070788169999, 0.802071025000103],
              [-66.34620397999993, 0.759386292000016],
              [-66.28507076099993, 0.745847066000039],
              [-66.2282783609999, 0.762796936000129],
              [-66.2087446699999, 0.76310699500003],
              [-66.18903011099994, 0.754942119000106],
              [-66.1730620939999, 0.743056539000079],
              [-66.15634476699995, 0.733031311000047],
              [-66.13438228399988, 0.73111928400003],
              [-66.11112788899987, 0.741816305000043],
              [-66.0791918539999, 0.777576396000057],
              [-66.0574619139999, 0.786981506000103],
              [-66.01384700599993, 0.789668681000137],
              [-65.99418412299991, 0.794732971000116],
              [-65.97408199099993, 0.806980286000041],
              [-65.95266210999992, 0.827960917000041],
              [-65.91424068199987, 0.87462473600003],
              [-65.89176143399996, 0.895605368000119],
              [-65.87196936099988, 0.908989563000063],
              [-65.78541133699989, 0.949142151000075],
              [-65.74543961599991, 0.974153545000064],
              [-65.72097082599996, 0.981905009000073],
              [-65.70104956099993, 0.984385478000135],
              [-65.62872839399989, 0.982008362000101],
              [-65.6081094969999, 0.985263977000088],
              [-65.59604305099992, 0.983610331000122],
              [-65.58294307499995, 0.97766754200012],
              [-65.57085078999998, 0.968572490000057],
              [-65.55984370999988, 0.957978821000069],
              [-65.53581416899996, 0.928471578000057],
              [-65.52511714699995, 0.908317769000078],
              [-65.51850256399985, 0.886510315000052],
              [-65.51700394699995, 0.862790833000105],
              [-65.53317867099994, 0.816333720000088],
              [-65.56328019299991, 0.777938130000052],
              [-65.58733557199986, 0.73912913],
              [-65.58521683799998, 0.691483459000068],
              [-65.57431311099992, 0.670244446000083],
              [-65.56048966599985, 0.656033427000125],
              [-65.54266129599992, 0.64931549100001],
              [-65.51969112099997, 0.650865784000118],
              [-65.49783199099994, 0.658720601000056],
              [-65.47287227499996, 0.672518209000103],
              [-65.45121984899987, 0.690139872000088],
              [-65.43274552499994, 0.720939026000067],
              [-65.41388362599992, 0.741609599000085],
              [-65.40943945399991, 0.755252177000088],
              [-65.41083471699989, 0.783880921000062],
              [-65.40962032099986, 0.792149150000114],
              [-65.40000850399986, 0.816540426000046],
              [-65.38902726199987, 0.835660706000041],
              [-65.32719641099987, 0.910281474000016],
              [-65.31027237999987, 0.918653056000082],
              [-65.28438248699985, 0.919376526000079],
              [-65.2433772389999, 0.913123678000076],
              [-65.22314591499989, 0.914363912000027],
              [-65.20304378299994, 0.923820699000089],
              [-65.17898840299989, 0.955395],
              [-65.16844641199992, 0.996477763000129],
              [-65.16017818299989, 1.080193584000071],
              [-65.13676875899992, 1.126909078000068],
              [-65.10051774199988, 1.136107483000075],
              [-65.05961584499997, 1.132386780000061],
              [-65.02248632899997, 1.139983216000118],
              [-65.02070349199991, 1.144013977000029],
              [-65.01969580199992, 1.157708232000047],
              [-65.01744787599992, 1.162979228000069],
              [-65.01321040899995, 1.165769756000117],
              [-65.00334020999989, 1.169387106000016],
              [-64.9993611249999, 1.171970927000103],
              [-64.96646907599995, 1.200599670000088],
              [-64.95605627399993, 1.206800843000082],
              [-64.93293107099996, 1.213002015000058],
              [-64.91466345299997, 1.214759013000048],
              [-64.89740352399988, 1.219668274000071],
              [-64.87771480399994, 1.234912822000112],
              [-64.85531306999985, 1.258683981000075],
              [-64.83929337599992, 1.270827942000068],
              [-64.82143916799996, 1.270569559000094],
              [-64.77131302999993, 1.246746724000033],
              [-64.75121089799995, 1.243336080000105],
              [-64.73087622099985, 1.247573548000062],
              [-64.60421728599994, 1.3312893680001],
              [-64.5911689859999, 1.350099589000109],
              [-64.57026586899991, 1.395497335000044],
              [-64.55119726599992, 1.419526876000077],
              [-64.52791703299991, 1.435727437000082],
              [-64.47505204299995, 1.463012594000091],
              [-64.43309077999993, 1.494044292000112],
              [-64.4090095629999, 1.507506002000085],
              [-64.38642696199986, 1.510244853000117],
              [-64.36459366899993, 1.497093201000055],
              [-64.3638185229999, 1.477352803000088],
              [-64.38503169799989, 1.436399232000056],
              [-64.39136206099991, 1.417718201000085],
              [-64.39477270599991, 1.392190044000046],
              [-64.3895792239999, 1.369297384000035],
              [-64.37009720899991, 1.358729554000149],
              [-64.35294063399996, 1.365835063000091],
              [-64.34074499599984, 1.384206034000073],
              [-64.32188309799992, 1.424436137000015],
              [-64.30152258399988, 1.446657003000055],
              [-64.23214697299994, 1.497144877000068],
              [-64.17708573399997, 1.55114674900004],
              [-64.1297242839999, 1.578070170000061],
              [-64.10954463699991, 1.598456523000095],
              [-64.09295650299993, 1.622615255000056],
              [-64.08086421799993, 1.647394104000085],
              [-64.07541235399995, 1.665429179000085],
              [-64.07254431199988, 1.684575297000094],
              [-64.07595495599989, 1.745372620000111],
              [-64.06029699799984, 1.807461853000078],
              [-64.05360489999993, 1.893709819000108],
              [-64.03662919099992, 1.927273661000129],
              [-63.99502966299991, 1.958021139000081],
              [-63.958339396999946, 1.97070770300013],
              [-63.920822305999934, 1.974325053000115],
              [-63.802276570999936, 1.972309672000065],
              [-63.78320796799994, 1.974996847000099],
              [-63.76264074799988, 1.985668030000099],
              [-63.617533324999954, 2.101164856000082],
              [-63.56198116099995, 2.126357117000026],
              [-63.5489586999999, 2.128372498000076],
              [-63.5205366619999, 2.124496765000117],
              [-63.51066646399991, 2.124600119000135],
              [-63.44343542599995, 2.137183329000067],
              [-63.41175777199993, 2.149378967000075],
              [-63.40219763199994, 2.17051462800012],
              [-63.4039029539999, 2.188498026000019],
              [-63.400595662999905, 2.204621074000087],
              [-63.38654594199997, 2.235888844000016],
              [-63.3726387129999, 2.266839498000095],
              [-63.370519979999926, 2.281153870000082],
              [-63.37279374199994, 2.349108378000054],
              [-63.371243448999934, 2.365128073000093],
              [-63.36111486899998, 2.400009664000081],
              [-63.36488724799989, 2.413083802000131],
              [-63.38483435099991, 2.42057688400007],
              [-63.51066646399991, 2.424659322000082],
              [-63.57381506399986, 2.434374491000113],
              [-63.70409134999997, 2.437578431000091],
              [-63.76703324399995, 2.429310201000135],
              [-63.83131872599992, 2.428638408000054],
              [-63.95182816599987, 2.461504618000092],
              [-64.0107909759999, 2.468170878000095],
              [-64.03249507699991, 2.463003235000087],
              [-64.0479721689999, 2.471323140000052],
              [-64.05662797099987, 2.48853139300013],
              [-64.05781652899987, 2.510442200000085],
              [-64.05053015199991, 2.534678447000076],
              [-64.01218623899987, 2.603769837000044],
              [-64.00769038899995, 2.622786763000107],
              [-64.00443477399998, 2.679527486000026],
              [-63.9978718669999, 2.705985819000105],
              [-63.997561808999905, 2.714925842000042],
              [-64.0008690999999, 2.725364482000074],
              [-64.01223791599989, 2.744019674000057],
              [-64.02908443299987, 2.797969869000013],
              [-64.10595312599995, 2.947211405000061],
              [-64.13750158799994, 2.987260640000045],
              [-64.1734683839999, 3.051907857000103],
              [-64.20530106699994, 3.089166565000127],
              [-64.22292272999994, 3.123996481000091],
              [-64.2253773599999, 3.165596009000097],
              [-64.21630814699992, 3.251430562000024],
              [-64.21987381999992, 3.292875062000078],
              [-64.24560868299989, 3.418939717000029],
              [-64.24214636299988, 3.442969259000066],
              [-64.23212113499994, 3.461133525000093],
              [-64.20506852299988, 3.497074483000063],
              [-64.19785965999992, 3.51508372000005],
              [-64.19563757299991, 3.532912089000092],
              [-64.19574092599996, 3.570067444000088],
              [-64.20297562699992, 3.594717102000089],
              [-64.2220959069999, 3.616214498000119],
              [-64.26555578699993, 3.652207133000019],
              [-64.32415685999985, 3.724114889000049],
              [-64.34735957899994, 3.738300069000104],
              [-64.39448848499995, 3.75607676200012],
              [-64.43453771999992, 3.77847849600002],
              [-64.53143103099995, 3.853512675000104],
              [-64.57496842499998, 3.914206645000093],
              [-64.59610408599994, 3.935884908000091],
              [-64.64289709499994, 3.972962748000057],
              [-64.66279252199985, 3.996992290000094],
              [-64.66289587499998, 3.996992290000094],
              [-64.70744095899988, 4.082956034000048],
              [-64.71953324399996, 4.123237813000088],
              [-64.72710384199993, 4.140781962000062],
              [-64.74190913899994, 4.157189230000114],
              [-64.76294144699995, 4.168997294000121],
              [-64.78366369699998, 4.177084656000119],
              [-64.80125952199995, 4.188530985000043],
              [-64.81304174899986, 4.210570984000114],
              [-64.81554805499985, 4.231034851000075],
              [-64.81291255799994, 4.252790629000089],
              [-64.80505773899989, 4.271885071000085],
              [-64.79162186699995, 4.284416606000079],
              [-64.74593990099993, 4.287620545000053],
              [-64.69987036199993, 4.264159444000086],
              [-64.66098384699995, 4.227469177000017],
              [-64.64802418899987, 4.207904544000115],
              [-64.6369026289999, 4.191114808000037],
              [-64.62106380299991, 4.146879781000024],
              [-64.60822220899993, 4.126493429000078],
              [-64.58967036999988, 4.118871155000107],
              [-64.36498124199994, 4.151866557000076],
              [-64.24059606999992, 4.142022197000088],
              [-64.17269323699989, 4.123392843000133],
              [-64.14669999199992, 4.110551249000139],
              [-64.12509924299985, 4.088485412000054],
              [-64.10814937299995, 4.05809967000009],
              [-64.0957728679999, 4.024380799000127],
              [-64.07902970399994, 3.953093160000066],
              [-64.0638109949999, 3.911596985000088],
              [-64.0376627199999, 3.882503154000077],
              [-63.99642492699991, 3.880797832000027],
              [-63.956944132999865, 3.901881816000056],
              [-63.916843221999954, 3.929373678000019],
              [-63.875140340999934, 3.949811707000066],
              [-63.83111201999989, 3.949449971000078],
              [-63.79059769699995, 3.93304270500002],
              [-63.77101232999985, 3.928805237000063],
              [-63.74589758399992, 3.93027801500007],
              [-63.690758829999936, 3.943998108000088],
              [-63.67158687399993, 3.946246033000094],
              [-63.622804321999894, 3.935213114000106],
              [-63.554229695999936, 3.875371806000132],
              [-63.51066646399991, 3.854546204000087],
              [-63.46886022999985, 3.867232768000036],
              [-63.455372680999886, 3.900589905000089],
              [-63.44824133299994, 3.939373068000037],
              [-63.42540034999985, 3.968363546000106],
              [-63.391448933999925, 3.97156748500008],
              [-63.35170975799991, 3.958725891000086],
              [-63.28597733599986, 3.920821229000097],
              [-63.2511990969999, 3.886559754000089],
              [-63.19321813999994, 3.806745504000091],
              [-63.130844685999904, 3.762122905000069],
              [-63.02495967699994, 3.637763571000079],
              [-63.01069698099988, 3.614974263000093],
              [-62.997054402999964, 3.599135437000086],
              [-62.975143595999896, 3.583064067000123],
              [-62.951062377999875, 3.570170797000117],
              [-62.931011922999915, 3.563762919000084],
              [-62.90770585199988, 3.560972392000025],
              [-62.88941239499991, 3.56081736200008],
              [-62.871997436999976, 3.565468241000048],
              [-62.85127518799993, 3.577224630000046],
              [-62.83158646699991, 3.594872131000031],
              [-62.822336385999876, 3.5988253780001],
              [-62.80776363199993, 3.596680807000027],
              [-62.79644649299985, 3.597300924000095],
              [-62.78631791299989, 3.604406434000026],
              [-62.77102168799985, 3.623345846000063],
              [-62.74957596899992, 3.660372010000032],
              [-62.73991247599989, 3.700447083000114],
              [-62.74042924099993, 3.741943258000092],
              [-62.74957596899992, 3.783568624000097],
              [-62.76683589699991, 3.822041727000055],
              [-62.77019486499992, 3.847828267000068],
              [-62.774277302999934, 3.854856262000069],
              [-62.77980668199993, 3.861289978000116],
              [-62.78512935399988, 3.8722970580001],
              [-62.788798380999964, 3.899401347000079],
              [-62.78280391499993, 3.920046081000081],
              [-62.77319209899994, 3.939941508000089],
              [-62.76626745599995, 3.964694520000108],
              [-62.76740433799995, 3.9870962520001],
              [-62.77065995299995, 4.005389710000074],
              [-62.766215779999925, 4.020711772000126],
              [-62.74435664899991, 4.034018453000058],
              [-62.72745845599991, 4.038514302000067],
              [-62.67066605699998, 4.043656108000064],
              [-62.5886555589999, 4.03071116200006],
              [-62.56095699099987, 4.037790833000074],
              [-62.54881302999988, 4.077452494000056],
              [-62.548606322999916, 4.098071391000062],
              [-62.546435913999915, 4.113910218000058],
              [-62.53697912599995, 4.125408224000083],
              [-62.51491328999995, 4.133108012000079],
              [-62.48370072499998, 4.139179993000113],
              [-62.47517411299995, 4.143882548000093],
              [-62.46985144099992, 4.151608175000092],
              [-62.4665441489999, 4.168738912000052],
              [-62.46297847499994, 4.174707540000071],
              [-62.42809688399987, 4.183182475000081],
              [-62.38417191599993, 4.173467306000134],
              [-62.19265905799989, 4.094738261000145],
              [-62.15359167499989, 4.09029408800005],
              [-62.111113647999844, 4.104841004000093],
              [-62.03504593999989, 4.159876404000045],
              [-61.990190795999894, 4.166413473000119],
              [-61.96859004699991, 4.160083110000102],
              [-61.95034826699995, 4.152228292000075],
              [-61.93148636999993, 4.146414693000082],
              [-61.908231973999904, 4.146156311000112],
              [-61.88812984199987, 4.150161235000013],
              [-61.866890828999885, 4.157034200000069],
              [-61.84704707899991, 4.166051737000117],
              [-61.83102738499994, 4.176929627000078],
              [-61.77919592299986, 4.232688497000126],
              [-61.75635493999994, 4.246356914000046],
              [-61.73780310099991, 4.252067159000092],
              [-61.71888952599997, 4.254650980000093],
              [-61.68054561399995, 4.252480571000106],
              [-61.64915218099992, 4.243411357000042],
              [-61.64052221799997, 4.241912740000132],
              [-61.62822322599993, 4.243463033000054],
              [-61.61018815099993, 4.251627909000078],
              [-61.599077717999904, 4.254392599000127],
              [-61.5854093019999, 4.253410746000057],
              [-61.57657263199991, 4.249715881000057],
              [-61.56727087499988, 4.248527324000037],
              [-61.55215551799995, 4.254961040000083],
              [-61.54210445199993, 4.263022562000074],
              [-61.53350032599991, 4.273590393000049],
              [-61.52673071299995, 4.285501811000074],
              [-61.52236405499988, 4.297774964000027],
              [-61.51642126499988, 4.374772848000134],
              [-61.501874348999905, 4.401851298000096],
              [-61.458181925999924, 4.419137064000083],
              [-61.43862239699993, 4.421152446000036],
              [-61.3810806889999, 4.417741801000105],
              [-61.36002254299987, 4.418930359000043],
              [-61.33322831299998, 4.423865459000069],
              [-61.3082427569999, 4.433322246000046],
              [-61.29304988599995, 4.448050029000044],
              [-61.29584041399991, 4.469004822000045],
              [-61.322944702999905, 4.508847351000071],
              [-61.315580810999904, 4.52078460700011],
              [-61.29726151599991, 4.523730164000099],
              [-61.23806616299993, 4.515875346000072],
              [-61.22010860299994, 4.510681865000066],
              [-61.18592464199986, 4.494119568000059],
              [-61.168587198999944, 4.490243835000101],
              [-61.151198079999915, 4.492052510000093],
              [-61.095465046999976, 4.507684631000046],
              [-61.01195593299988, 4.518304138000133],
              [-60.97728104699988, 4.534969788000069],
              [-60.94779964299997, 4.573597921000058],
              [-60.94040991199995, 4.594061788000118],
              [-60.9310564779999, 4.637392477000091],
              [-60.90343542499991, 4.699585062000082],
              [-60.89581315199993, 4.708525085000119],
              [-60.887958333999904, 4.711134745000038],
              [-60.86868302499997, 4.711186422000139],
              [-60.8600272219999, 4.712426656000076],
              [-60.76367651399994, 4.755085552000068],
              [-60.71814957699988, 4.784282735000104],
              [-60.68006404699992, 4.817949931000058],
              [-60.6126263029999, 4.9005805460001],
              [-60.59192989199997, 4.949724834000051],
              [-60.59867366599991, 4.996879578000062],
              [-60.66430273499992, 5.170254008000072],
              [-60.684869954999925, 5.188314921000085],
              [-60.71101822899993, 5.198159282000063],
              [-60.73985367899988, 5.202138367000131],
              [-60.69517940299991, 5.211931051000093],
              [-60.672958536999886, 5.213016256000088],
              [-60.61355647799985, 5.208933818000077],
              [-60.60177425199993, 5.206582540000042],
              [-60.58970780399997, 5.201208191000077],
              [-60.579398356999945, 5.19485199000006],
              [-60.56828792399995, 5.189710185000067],
              [-60.55384436099993, 5.188056539000101],
              [-60.4974136969999, 5.195937195000056],
              [-60.47749243199988, 5.19193227100007],
              [-60.47002518699995, 5.186867981000091],
              [-60.46312638399988, 5.180020853000116],
              [-60.45635677099992, 5.174698181000082],
              [-60.44896704099992, 5.174233094000058],
              [-60.439122680999844, 5.181390279000098],
              [-60.42741796899986, 5.200768942000067],
              [-60.41979569599991, 5.207228496000113],
              [-60.39894425499992, 5.208313700000105],
              [-60.35499344899989, 5.193172506000096],
              [-60.33308264199994, 5.193766785000065],
              [-60.314065714999884, 5.206918436000123],
              [-60.27373225999992, 5.247355245000023],
              [-60.25520625899989, 5.256450297000086],
              [-60.21342586299991, 5.267224833000029],
              [-60.20030004899988, 5.263452453000099],
              [-60.190946614999916, 5.239939677000109],
              [-60.1765547279999, 5.227149760000131],
              [-60.13172542399994, 5.243401998000053],
              [-60.12301794499987, 5.231852316000101],
              [-60.09123693899991, 5.158239238000107],
              [-60.08870391499994, 5.155393807000038],
              [-60.075734008999916, 5.140824280000075],
              [-60.055115112999914, 5.125088806000093],
              [-60.01100927799993, 5.100025737000095],
              [-59.983104004999944, 5.085943909000065],
              [-59.98150203499992, 5.057418518000105],
              [-59.99927872799995, 4.996879578000062],
              [-60.0002089029999, 4.958328960000088],
              [-60.003593708999915, 4.939828796000072],
              [-60.01100927799993, 4.921716207000131],
              [-60.017959757999904, 4.892234802000132],
              [-60.02046606499991, 4.832290141000044],
              [-60.03452205499991, 4.787796733000064],
              [-60.0300778809999, 4.744362691000063],
              [-60.032454996999945, 4.725423279000012],
              [-60.03847530199988, 4.708008321000079],
              [-60.047053588999916, 4.691756084000062],
              [-60.0756306559999, 4.650285747000098],
              [-60.080669108999956, 4.638322652000042],
              [-60.083201253999846, 4.627083028000087],
              [-60.08428645899994, 4.616928610000031],
              [-60.08769710299987, 4.607523499000081],
              [-60.097076374999915, 4.598557638000045],
              [-60.10614558899988, 4.595353699000071],
              [-60.12622188399993, 4.594991964000073],
              [-60.134826008999966, 4.593545024000079],
              [-60.16154272499992, 4.565200500000074],
              [-60.164850016999935, 4.546209412000024],
              [-60.15999243199991, 4.527786763000108],
              [-60.148778645999954, 4.513007304000098],
              [-60.132862304999946, 4.504868266000088],
              [-60.12092504899991, 4.502361959000012],
              [-60.11201086399987, 4.502155253000055],
              [-60.106197265999896, 4.506599427000054],
              [-60.10384598799996, 4.517994080000051],
              [-60.098600830999914, 4.526003927000119],
              [-60.087774617999884, 4.525538839000092],
              [-60.07687089099991, 4.519957785000088],
              [-60.07154821799989, 4.512542216000071],
              [-60.06625138399994, 4.494326274000116],
              [-60.05560603899994, 4.49158742200008],
              [-60.04018062399987, 4.495928243000051],
              [-60.02069860899988, 4.498873800000055],
              [-59.99697912599993, 4.490760600000058],
              [-59.98455094499994, 4.488796895000107],
              [-59.9788923749999, 4.495411479000026],
              [-59.97455155499992, 4.503705546000063],
              [-59.96468135699985, 4.506496074000026],
              [-59.953131673999906, 4.505875956000054],
              [-59.943313151999945, 4.50391225200012],
              [-59.93429561399998, 4.498253683000087],
              [-59.919929564999876, 4.479210917000017],
              [-59.91455521699993, 4.474353333000096],
              [-59.90527929699991, 4.47528350900005],
              [-59.88582311999991, 4.484740296000027],
              [-59.872929849999906, 4.484688620000099],
              [-59.868847411999894, 4.48091624000007],
              [-59.871689615999884, 4.468229675000117],
              [-59.86763301599987, 4.461976827000029],
              [-59.86324051999989, 4.460659078000077],
              [-59.85236262999993, 4.460762431000092],
              [-59.84763423699994, 4.460245667000066],
              [-59.82624019399992, 4.454612936000032],
              [-59.817687744999915, 4.456835022000035],
              [-59.80962622099992, 4.465749207000059],
              [-59.79626786299988, 4.448205058000084],
              [-59.73795100899994, 4.415571391000114],
              [-59.72991532399996, 4.407535706000132],
              [-59.72234472699989, 4.397717184000072],
              [-59.7135080569999, 4.389371440000104],
              [-59.70195837499995, 4.385650737000091],
              [-59.69046036799992, 4.384462179000067],
              [-59.68673966499992, 4.381180725000078],
              [-59.687115057999904, 4.371465559000043],
              [-59.68738562099989, 4.364463399000044],
              [-59.69361263099998, 4.340692240000081],
              [-59.72779658999988, 4.30529388400015],
              [-59.73846777399987, 4.28658701600007],
              [-59.736684935999904, 4.282091167000146],
              [-59.726556355999946, 4.270696513000061],
              [-59.724489298999885, 4.264056091000057],
              [-59.72660803299996, 4.257699891000115],
              [-59.73552221699987, 4.245840149000102],
              [-59.73795100899994, 4.240000712000025],
              [-59.740534830999934, 4.222327372000024],
              [-59.74043147799992, 4.21364573200006],
              [-59.73846777399987, 4.2027678420001],
              [-59.7267372229999, 4.176464539000051],
              [-59.71032995699994, 4.164449768000082],
              [-59.66736100299994, 4.150574646000024],
              [-59.646173665999896, 4.13403818700003],
              [-59.64899003099987, 4.119801330000058],
              [-59.660100463999896, 4.103187357000138],
              [-59.66325272699993, 4.079726258000065],
              [-59.65369258699994, 4.064197489000136],
              [-59.61981868499993, 4.032726543000095],
              [-59.605736857999915, 4.00714670800005],
              [-59.59971655299998, 4.002263285000112],
              [-59.59537573299991, 3.996372172000122],
              [-59.59628007099994, 3.97063730900004],
              [-59.59000138399995, 3.966709900000069],
              [-59.58038956699991, 3.96712331100008],
              [-59.5486860769999, 3.961929830000059],
              [-59.53682633499989, 3.957692362000017],
              [-59.52959163399993, 3.949449971000078],
              [-59.5276537689999, 3.939528097000078],
              [-59.52922989999993, 3.931905823000108],
              [-59.53470760099992, 3.927099915000099],
              [-59.5445777999999, 3.925704651000032],
              [-59.56315547799994, 3.918185730000076],
              [-59.58178483099991, 3.899194641000108],
              [-59.59633174699985, 3.875888570000086],
              [-59.602507079999924, 3.855683085000095],
              [-59.59971655299998, 3.833126322000069],
              [-59.59540157099991, 3.816538188000067],
              [-59.598605509999885, 3.80240468300012],
              [-59.618294230999936, 3.787185974000082],
              [-59.65911861199993, 3.768918355000025],
              [-59.67180517599988, 3.756231792000079],
              [-59.68015091999993, 3.731117045000047],
              [-59.680771036999914, 3.719153951000095],
              [-59.67955664099986, 3.710343120000104],
              [-59.68012508199993, 3.701687317000051],
              [-59.68622290099998, 3.690215149000039],
              [-59.69505957099997, 3.683057963000095],
              [-59.71764217199993, 3.673213603000107],
              [-59.755546834999905, 3.638125305000088],
              [-59.83766068499992, 3.60928985700005],
              [-59.86287878399989, 3.581720479000055],
              [-59.86303381399992, 3.552368266000087],
              [-59.84763423699994, 3.530457459000033],
              [-59.82954748599991, 3.509761048000101],
              [-59.8213567709999, 3.484387919000113],
              [-59.83853918499997, 3.443020935000078],
              [-59.841355550999936, 3.425399272000078],
              [-59.82404394599993, 3.431677959000083],
              [-59.82848811899993, 3.383412171000074],
              [-59.82709285499996, 3.376694234000055],
              [-59.820995035999914, 3.363490906000067],
              [-59.8217701829999, 3.356592102000093],
              [-59.82680863499988, 3.351941223000026],
              [-59.83368159999995, 3.350287578000078],
              [-59.83998612499997, 3.349874166000063],
              [-59.84319006399994, 3.349021505000039],
              [-59.8537320559999, 3.315380148000088],
              [-59.879621948999926, 3.272566223000055],
              [-59.884014444999934, 3.262540995000037],
              [-59.89763118599993, 3.217375794000063],
              [-59.904245767999925, 3.208229065000083],
              [-59.91150630699988, 3.201872864000052],
              [-59.916673949999904, 3.194173076000055],
              [-59.91685481799993, 3.181150615000121],
              [-59.91393509899987, 3.174639385000148],
              [-59.90543432699994, 3.165234274000099],
              [-59.903212239999846, 3.15867136700011],
              [-59.90571854699991, 3.154795634000067],
              [-59.91837927299986, 3.15283192900003],
              [-59.92155737299993, 3.150093079000087],
              [-59.92018794799995, 3.143995260000025],
              [-59.91269486499991, 3.133401591000052],
              [-59.911609659999925, 3.126425273000052],
              [-59.9148652749999, 3.119965719000092],
              [-59.920756388999905, 3.116761780000033],
              [-59.92737097199989, 3.114332988000072],
              [-59.932667806999945, 3.110043844000103],
              [-59.95938452099989, 3.06648061100006],
              [-59.96922888199987, 3.042709453000015],
              [-59.97398311399988, 3.017646382000095],
              [-59.97041743999989, 2.960440572000053],
              [-59.972975422999895, 2.939304911000107],
              [-59.99372351099993, 2.857294414000123],
              [-60.000079711999945, 2.69404856400007],
              [-59.996462361999875, 2.674773255000034],
              [-59.96504309099993, 2.613433329000074],
              [-59.965327311999914, 2.608058981000099],
              [-59.97026241099985, 2.595759989000072],
              [-59.97098588099996, 2.592556051000088],
              [-59.96602494399991, 2.588680318000044],
              [-59.953131673999906, 2.583926086000048],
              [-59.94902339699988, 2.57984364800005],
              [-59.940729328999936, 2.56299713100006],
              [-59.93923071399993, 2.555452372000019],
              [-59.93951493299991, 2.542998352000041],
              [-59.9358459069999, 2.523878072000045],
              [-59.90677791399992, 2.458765767000045],
              [-59.905072591999954, 2.447862041000079],
              [-59.90403906299986, 2.42620961500009],
              [-59.90181697699995, 2.41561594700002],
              [-59.90150691699998, 2.404505513000103],
              [-59.91181636599987, 2.387814026000072],
              [-59.91344417399992, 2.378718974000094],
              [-59.903134724999916, 2.359598694000098],
              [-59.88406612199992, 2.346007792000108],
              [-59.84424943099992, 2.325440572000019],
              [-59.8136311449999, 2.299188945000083],
              [-59.80120296299992, 2.292729390000119],
              [-59.79184952799997, 2.290869039000114],
              [-59.77226416099995, 2.290352275000089],
              [-59.76324662399992, 2.287975159000041],
              [-59.741697550999874, 2.263790588000063],
              [-59.74022477199995, 2.229477438000046],
              [-59.74575415099986, 2.19082346600004],
              [-59.744979003999845, 2.153513082000103],
              [-59.73585811399997, 2.123721619000108],
              [-59.73539302599994, 2.113515524000135],
              [-59.738571126999915, 2.103619487000046],
              [-59.74983658899987, 2.085971985000057],
              [-59.75296301299991, 2.075455831000099],
              [-59.75146439699992, 2.06225250300011],
              [-59.74040563999989, 2.041401063000137],
              [-59.73709834899989, 2.030419821000066],
              [-59.73779598099989, 2.02222910600004],
              [-59.74353206399985, 2.005666810000122],
              [-59.74534073899994, 1.997166036000124],
              [-59.74280859399994, 1.970966085000015],
              [-59.743816283999934, 1.961845194000119],
              [-59.74836380999997, 1.95125152600005],
              [-59.760869507999956, 1.931924540000097],
              [-59.76453853399997, 1.9205298870001],
              [-59.76513281299992, 1.904639384000077],
              [-59.76355668199989, 1.882573548000082],
              [-59.75875077299989, 1.862135518000045],
              [-59.749681559999914, 1.85130930600009],
              [-59.737511759999904, 1.85079254200005],
              [-59.7172287599999, 1.858053080000033],
              [-59.705575724999846, 1.857407125000051],
              [-59.66798111999992, 1.842705180000053],
              [-59.65547542399992, 1.839707947000136],
              [-59.64911922199991, 1.841361593000087],
              [-59.64645788599998, 1.839966329000021],
              [-59.6454760339999, 1.827693176000082],
              [-59.66648250399993, 1.787101339000046],
              [-59.68247635899988, 1.765603943000102],
              [-59.68084855099991, 1.757387390000076],
              [-59.658963582999974, 1.73408131900004],
              [-59.64981685399988, 1.727001648000027],
              [-59.639662434999934, 1.721756490000089],
              [-59.628164428999895, 1.718810933000086],
              [-59.607933104999915, 1.719999492000113],
              [-59.5905698249999, 1.724908752000147],
              [-59.57271561699994, 1.727156677000067],
              [-59.55147660399987, 1.720516256000053],
              [-59.530728515999925, 1.703075460000107],
              [-59.50282324199995, 1.657651876000074],
              [-59.486002563999875, 1.636076965000115],
              [-59.45476415999988, 1.611323954000085],
              [-59.44551407899988, 1.601014506000084],
              [-59.42587703499993, 1.565952046000064],
              [-59.41683365899988, 1.555280864000068],
              [-59.41210526599991, 1.553265483000104],
              [-59.399728759999846, 1.552025249000081],
              [-59.39463863099985, 1.549441427000076],
              [-59.39096960499995, 1.5436536670001],
              [-59.38386409599994, 1.527892354000116],
              [-59.38016922999992, 1.523344828000077],
              [-59.36802526899993, 1.520399271000088],
              [-59.347690592999896, 1.526032003000111],
              [-59.338569701999916, 1.52463673900013],
              [-59.32694250499986, 1.509521383000035],
              [-59.324720418999874, 1.490762838000123],
              [-59.32032792199996, 1.473528748000135],
              [-59.30218949399995, 1.462960918000078],
              [-59.29381791199995, 1.452108867000035],
              [-59.27242386899985, 1.404153138000098],
              [-59.25991817199986, 1.387435812000149],
              [-59.24214147999993, 1.377798157000129],
              [-59.177959350999885, 1.357127584000111],
              [-59.01109615099995, 1.327568664000083],
              [-58.97202466099995, 1.312311316000148],
              [-58.96649938999994, 1.310153707000055],
              [-58.94598384599996, 1.298991598000029],
              [-58.927483683999924, 1.284212138000015],
              [-58.91172237099994, 1.260234273000094],
              [-58.90645137599992, 1.238530172000097],
              [-58.8978730879999, 1.217807922000063],
              [-58.8721382249999, 1.197240702000073],
              [-58.852036091999935, 1.188714091000065],
              [-58.834001017999924, 1.185820211000078],
              [-58.815965941999934, 1.187267151000071],
              [-58.79596716299989, 1.191814677000096],
              [-58.77193762299996, 1.201271465000076],
              [-58.75281734199987, 1.214965718000087],
              [-58.73690100099995, 1.232329],
              [-58.709202433999906, 1.272274882000062],
              [-58.697730264999905, 1.281059876000057],
              [-58.68258907099988, 1.28245513900012],
              [-58.58052811699986, 1.272739970000089],
              [-58.574171915999926, 1.275375468000107],
              [-58.56140783699996, 1.285142314000069],
              [-58.55696366399985, 1.286899312000045],
              [-58.552312784999884, 1.284625549000026],
              [-58.54673172999989, 1.280439758000085],
              [-58.542752644999894, 1.276357320000074],
              [-58.54306270399988, 1.27439361600004],
              [-58.53505285599991, 1.271551412000065],
              [-58.52714636199994, 1.266848856000095],
              [-58.51892980999992, 1.267262268000096],
              [-58.4876138919999, 1.316458232000073],
              [-58.48110266199993, 1.333873189000101],
              [-58.48172277799992, 1.358057760000079],
              [-58.488078979999926, 1.378883362000039],
              [-58.50699255399988, 1.418183289000112],
              [-58.51365881399988, 1.438879700000129],
              [-58.5017543459999, 1.4537810960001],
              [-58.49887935399997, 1.457379863000057],
              [-58.426430232999905, 1.46980534700009],
              [-58.41345821199988, 1.472030131000039],
              [-58.386379760999915, 1.490194397000081],
              [-58.385914672999974, 1.499728699000073],
              [-58.39170243399985, 1.520838522000105],
              [-58.390255492999955, 1.530760397000094],
              [-58.383124144999925, 1.537219951000054],
              [-58.360283162999906, 1.547374370000114],
              [-58.351394815999896, 1.553317159000116],
              [-58.34426346899997, 1.56548695900004],
              [-58.338734089999946, 1.580188904000124],
              [-58.3319128009999, 1.593392233000117],
              [-58.320492309999906, 1.601221211000052],
              [-58.316151489999925, 1.59889577200002],
              [-58.306332967999964, 1.58277272600013],
              [-58.299201619999906, 1.575176290000073],
              [-58.281993367999945, 1.566572164000121],
              [-58.2605476489999, 1.560319315000129],
              [-58.23858516499985, 1.556701965000045],
              [-58.219671589999905, 1.556056010000077],
              [-58.206959187999956, 1.559957580000031],
              [-58.19776078299995, 1.565900371000055],
              [-58.187270466999905, 1.567605693000104],
              [-58.1706306559999, 1.558820700000112],
              [-58.16287919199988, 1.549183045000106],
              [-58.155541137999876, 1.527375590000076],
              [-58.1486164959999, 1.519081523000125],
              [-58.116422078999875, 1.510554912000103],
              [-58.06913814299992, 1.509004618000091],
              [-58.027228556999916, 1.516859436000118],
              [-58.01115718599996, 1.536186422000071],
              [-57.993587198999876, 1.568484192000142],
              [-57.986972615999974, 1.586829326000043],
              [-57.98392370699986, 1.604115092000129],
              [-57.98976314299995, 1.634604187000107],
              [-57.991003376999885, 1.650417175000101],
              [-57.98500891099985, 1.65770355300009],
              [-57.969144246999946, 1.655481465000079],
              [-57.93901688699995, 1.643311666000074],
              [-57.922222046999906, 1.642484843000148],
              [-57.9053755299999, 1.648556824000096],
              [-57.87147578999989, 1.669253235000028],
              [-57.79075720299997, 1.704935812000116],
              [-57.758821166999894, 1.713462423000038],
              [-57.72311275299998, 1.711653748000046],
              [-57.638570108999915, 1.696176656000134],
              [-57.60787430899998, 1.697106832000088],
              [-57.56115881399998, 1.708966573000026],
              [-57.53128983599987, 1.731549175000055],
              [-57.46478226699989, 1.815730082000115],
              [-57.45429195199995, 1.833816834000046],
              [-57.42948726499992, 1.900298564000096],
              [-57.4195137129999, 1.909186910000116],
              [-57.40556107599991, 1.914277039000098],
              [-57.38452876799991, 1.925206604000067],
              [-57.368767456999905, 1.939650167000096],
              [-57.35615840699998, 1.955282287000045],
              [-57.34148229999991, 1.968847351000122],
              [-57.3194164629999, 1.977141419000077],
              [-57.294818481999926, 1.974841817000055],
              [-57.25864497899988, 1.952233378000116],
              [-57.23843949399989, 1.948538513000102],
              [-57.152914998999876, 2.002204488000089],
              [-57.10449418199991, 2.021453959000027],
              [-57.07405676299993, 1.997166036000124],
              [-57.06780391499984, 1.968692322000081],
              [-57.05597001199993, 1.948073425000089],
              [-57.037469848999905, 1.932389628000124],
              [-57.01116654499995, 1.918566182000063],
              [-56.99323482299988, 1.914845479000064],
              [-56.97685339399993, 1.91458709700008],
              [-56.94352209499996, 1.918256124000081],
              [-56.92192134699991, 1.91810109400005],
              [-56.9134464119999, 1.912830099000104],
              [-56.906831827999895, 1.9032441210001],
              [-56.890708780999915, 1.890195821000063],
              [-56.877634643999954, 1.885648295000124],
              [-56.80647619699994, 1.873581848000043],
              [-56.79273026599989, 1.87353017200013],
              [-56.78063798099993, 1.879059550000122],
              [-56.737643188999925, 1.912985128000059],
              [-56.724155639999964, 1.916137391000106],
              [-56.70410518499992, 1.912830099000104],
              [-56.68395137599995, 1.912106628000103],
              [-56.669662841999866, 1.919858094000119],
              [-56.656407836999875, 1.930064188000088],
              [-56.63956132099989, 1.936859639000133],
              [-56.62023433399992, 1.934560039000104],
              [-56.604421345999924, 1.924586487000099],
              [-56.59010697499994, 1.912985128000059],
              [-56.574862426999914, 1.905466207000103],
              [-56.558920247999964, 1.906654765000042],
              [-56.5285086669999, 1.924018046000057],
              [-56.481819010999914, 1.941613871000129],
              [-56.42980668199991, 1.922700298000095],
              [-56.41518225099992, 1.919703064000075],
              [-56.396527058999936, 1.921666769000112],
              [-56.367174845999955, 1.928875631000068],
              [-56.34795121299996, 1.926601868000148],
              [-56.32862422699989, 1.918462830000038],
              [-56.29270910699995, 1.895466817000084],
              [-56.273795531999895, 1.887508647000033],
              [-56.2579308679999, 1.885648295000124],
              [-56.20976843299991, 1.888542176000016],
              [-56.14527624499988, 1.871773173000051],
              [-56.082644408999954, 1.846555074000094],
              [-56.01965083799985, 1.83350677500006],
              [-55.95381506399988, 1.853273011000027],
              [-55.92203405799992, 1.88621673600008],
              [-55.91676306199989, 1.922235210000068],
              [-55.92234411599992, 1.962155254000024],
              [-55.92358435099996, 2.006596985000087],
              [-55.92038041299989, 2.019386902000065],
              [-55.91676306199989, 2.028507793000045],
              [-55.91513525399995, 2.037654521000121],
              [-55.91826167799991, 2.050392761000083],
              [-55.92580643799994, 2.061684062000054],
              [-55.95996455899993, 2.090984599000109],
              [-55.99577632699996, 2.137390035000124],
              [-56.004406290999924, 2.144986471000081],
              [-56.031329711999916, 2.163486634000108],
              [-56.044843099999895, 2.184725647000079],
              [-56.054015665999884, 2.224051412000065],
              [-56.07292923999992, 2.24151804600011],
              [-56.09145524099995, 2.245910543000107],
              [-56.13525101799988, 2.248546041000026],
              [-56.14677486199989, 2.256194153000095],
              [-56.14388098099991, 2.274745992000049],
              [-56.13199540299988, 2.30435658800009],
              [-56.11680253099985, 2.333088684000089],
              [-56.103780069999914, 2.349056702000041],
              [-56.09145524099995, 2.351898906000102],
              [-56.08228267399997, 2.347713115000076],
              [-56.073420166999966, 2.342390442000124],
              [-56.06215470399991, 2.341563619000098],
              [-56.05024328699997, 2.347041321000091],
              [-56.04256933699989, 2.355102844000072],
              [-56.01334631399993, 2.398821106000057],
              [-56.00817867099994, 2.416287740000101],
              [-56.007506876999855, 2.460677795000066],
              [-55.99691320899987, 2.503259176000128],
              [-55.989239257999884, 2.520829162000013],
              [-55.983012248999984, 2.526461894000136],
              [-55.971023315999844, 2.53033762600009],
              [-55.947200479999964, 2.528167216000099],
              [-55.925031290999954, 2.515661519000105],
              [-55.870667683999955, 2.470909729000141],
              [-55.853769490999895, 2.462641500000089],
              [-55.783127807999904, 2.445174866000059],
              [-55.773567667999885, 2.440058899000064],
              [-55.76612626199997, 2.431273906000072],
              [-55.754602416999944, 2.40941477500013],
              [-55.74411210199989, 2.401043193000064],
              [-55.72429418999991, 2.396909078000135],
              [-55.64538427699995, 2.416649475000099],
              [-55.60830643699998, 2.433961080000103],
              [-55.58732580599988, 2.433857727000074],
              [-55.5682055259999, 2.431273906000072],
              [-55.511309773999926, 2.436389872000063],
              [-55.47430944899989, 2.435821431000107],
              [-55.435552124999845, 2.430860494000058],
              [-55.39958532799997, 2.430188700000073],
              [-55.37105993699993, 2.442539368000041],
              [-55.36276586899987, 2.457938945000109],
              [-55.36007869499994, 2.476232402000093],
              [-55.35452347799992, 2.494887594000062],
              [-55.33775447699989, 2.511269023000111],
              [-55.320520385999885, 2.518297018000027],
              [-55.302795369999984, 2.51969228100009],
              [-55.28698238199988, 2.513904521000114],
              [-55.275251831999896, 2.499331767000072],
              [-55.25191992199987, 2.497884827000078],
              [-55.17195064299992, 2.559328105000063],
              [-55.137792521999955, 2.562170309000038],
              [-55.13308996599997, 2.552868551000103],
              [-55.13660396399993, 2.533799948000123],
              [-55.12885249899992, 2.525686747000123],
              [-55.12089432799985, 2.524808248000085],
              [-55.112471069999884, 2.527805481000101],
              [-55.076297566999926, 2.545220439000033],
              [-55.03774694899997, 2.577931620000115],
              [-55.01774816999992, 2.590592346000065],
              [-54.97687211099992, 2.606922099000101],
              [-54.95909541799989, 2.608989156000064],
              [-54.95366939299993, 2.59906728100006],
              [-54.960232299999916, 2.585683086000117],
              [-54.979559285999954, 2.566097718000108],
              [-54.98281490099993, 2.552351786000074],
              [-54.9785774339999, 2.543050029000142],
              [-54.88028885999998, 2.447345276000135],
              [-54.84191910799987, 2.433495992000076],
              [-54.79249060099991, 2.448172099000061],
              [-54.775494351999896, 2.457335294000089],
              [-54.759805256999954, 2.465793762000146],
              [-54.7430362559999, 2.466517233000047],
              [-54.72117712399995, 2.457990621000121],
              [-54.70766373799998, 2.450342509000052],
              [-54.70319372599997, 2.445846660000129],
              [-54.7025477709999, 2.425744528000067],
              [-54.701100830999906, 2.419905090000086],
              [-54.69683752399993, 2.409104716000058],
              [-54.69559728999991, 2.403523661000037],
              [-54.69725093599993, 2.39732249000005],
              [-54.70203100599994, 2.395720520000111],
              [-54.70727616399998, 2.395875550000056],
              [-54.70996333799991, 2.394790344000057],
              [-54.71569942299996, 2.375928446000046],
              [-54.706733561999926, 2.353190816000065],
              [-54.70544165099997, 2.342545472000069],
              [-54.70655269399987, 2.332881979000135],
              [-54.70412390199991, 2.324820455000051],
              [-54.69249670499994, 2.318981018000059],
              [-54.672859659999915, 2.315983785000057],
              [-54.65337764499992, 2.316500550000086],
              [-54.63412817399998, 2.320117900000071],
              [-54.615292114999875, 2.326267396000048],
              [-54.58816198799991, 2.324355367000123],
              [-54.56464921099993, 2.314846904000134],
              [-54.5442886969999, 2.300222473000062],
              [-54.52640865099994, 2.282652486000089],
              [-54.549146280999906, 2.279448548000119],
              [-54.54578731399991, 2.268596497000075],
              [-54.51142248599987, 2.243430074000045],
              [-54.49266394099996, 2.222707825000015],
              [-54.47664424699991, 2.21412953800008],
              [-54.43395951399992, 2.209323629000068],
              [-54.42708654899994, 2.207153219000077],
              [-54.4114802659999, 2.199711812000061],
              [-54.40254024299989, 2.197127991000059],
              [-54.38781245999988, 2.196301168000033],
              [-54.38052608299998, 2.197696432000015],
              [-54.37391149899989, 2.196507873000087],
              [-54.360940714999884, 2.188187968000122],
              [-54.33505082199994, 2.163900045000034],
              [-54.32285518499992, 2.157337138000045],
              [-54.31401851399991, 2.154856669000068],
              [-54.263789021999884, 2.148190410000055],
              [-54.246477416999966, 2.151601054000082],
              [-54.229785929999935, 2.157233785000116],
              [-54.210045532999885, 2.161574605000098],
              [-54.194490925999844, 2.163073222000094],
              [-54.18854813699994, 2.161316224000117],
              [-54.15738724899995, 2.121654562000046],
              [-54.14813716599994, 2.114394023000074],
              [-54.134908, 2.11067332000006],
              [-54.1115266969999, 2.114270443000066],
              [-54.11139522299996, 2.114290670000045],
              [-54.09842443899993, 2.127959086000061],
              [-54.084213419999884, 2.169326070000096],
              [-54.07666866099993, 2.183692119000099],
              [-54.06927893099993, 2.188342998000067],
              [-54.048453328999955, 2.188808086000094],
              [-54.043337361999875, 2.187722880000095],
              [-54.033260457999944, 2.180333150000095],
              [-54.02798946099992, 2.178576152000105],
              [-54.02137487899992, 2.180591532000065],
              [-54.011711384999984, 2.19056508400007],
              [-54.00597530199991, 2.1943374640001],
              [-53.963910685999906, 2.209323629000068],
              [-53.94613399299996, 2.221984355000103],
              [-53.93874426299996, 2.240122783000047],
              [-53.93776241099988, 2.264617412000092],
              [-53.932904825999884, 2.269630026000058],
              [-53.9216393639999, 2.265960999000058],
              [-53.901227173999956, 2.264514059000064],
              [-53.88846309399989, 2.273815817000084],
              [-53.879368041999925, 2.290610657000059],
              [-53.866810668999904, 2.304925028000042],
              [-53.843452921999955, 2.306630351000109],
              [-53.83089554899996, 2.310144348000065],
              [-53.82107702699997, 2.323631897000027],
              [-53.81182694499998, 2.340426737000087],
              [-53.80097489399992, 2.353810934000123],
              [-53.78345658399988, 2.36409454400011],
              [-53.764801391999896, 2.368693746000076],
              [-53.748264933999906, 2.364662985000081],
              [-53.737361205999946, 2.349056702000041],
              [-53.738033, 2.338824768000052],
              [-53.74816158099989, 2.319342753000058],
              [-53.74873002199993, 2.312676494000058],
              [-53.742167114999944, 2.308542379000116],
              [-53.71317663599987, 2.307353821000106],
              [-53.64599727399991, 2.278466695000063],
              [-53.62946081599992, 2.275314433000091],
              [-53.59530269399994, 2.273867493000097],
              [-53.57902461799992, 2.270405172000068],
              [-53.54734696499992, 2.251749980000099],
              [-53.53179235899998, 2.247047424000115],
              [-53.51153519699997, 2.252266744000039],
              [-53.47324296099987, 2.254127096000047],
              [-53.462132527999955, 2.258984681000058],
              [-53.42544226099989, 2.286011455000107],
              [-53.39040563999987, 2.299033915000052],
              [-53.37852006099993, 2.307560527000064],
              [-53.3510798749999, 2.341718649000128],
              [-53.34880611199986, 2.34766143800006],
              [-53.3441035569999, 2.349625143000083],
              [-53.33092606699992, 2.345697734000026],
              [-53.32255448499993, 2.338566386000082],
              [-53.29743973799992, 2.303684794000105],
              [-53.23418778499993, 2.25097483400009],
              [-53.234652872999845, 2.241259665000143],
              [-53.2543415939999, 2.234179993000026],
              [-53.27222163899995, 2.219968974000068],
              [-53.27971472199991, 2.204982808000082],
              [-53.26850093599995, 2.195732727000077],
              [-53.25284297699989, 2.196507873000087],
              [-53.13228186099994, 2.219297181000073],
              [-53.11336828599991, 2.219348856000096],
              [-53.09223262599994, 2.211907450000069],
              [-53.06122676599992, 2.186275940000101],
              [-53.01911047399997, 2.181986796000047],
              [-52.98092159099991, 2.173253479000067],
              [-52.95968257699994, 2.175217184000104],
              [-52.95322302299988, 2.179041240000046],
              [-52.944386352999885, 2.190978495000081],
              [-52.93906367999995, 2.195732727000077],
              [-52.9341027429999, 2.196404521000062],
              [-52.92314733899991, 2.193665670000115],
              [-52.91715287299988, 2.195732727000077],
              [-52.906714232999946, 2.204982808000082],
              [-52.9003063559999, 2.21412953800008],
              [-52.89239986199996, 2.236867167000057],
              [-52.88015254699994, 2.260379944000135],
              [-52.86273758999991, 2.274229228000095],
              [-52.81969112199991, 2.291540833000099],
              [-52.70770829299997, 2.358926901000117],
              [-52.690603393999936, 2.372982890000046],
              [-52.677219197999904, 2.390397847000074],
              [-52.656083536999944, 2.430912171000074],
              [-52.61918656499992, 2.463468323000114],
              [-52.59040279099992, 2.504706116000122],
              [-52.56906042499992, 2.55038808200004],
              [-52.563686075999954, 2.559328105000063],
              [-52.55794999299988, 2.565632630000081],
              [-52.55345414199988, 2.57338409400009],
              [-52.551903849999945, 2.586561585000069],
              [-52.5557795819999, 2.598137105000106],
              [-52.57205765799992, 2.622993470000068],
              [-52.57577836099992, 2.633742167000079],
              [-52.57159256999998, 2.638599752000104],
              [-52.55102534999992, 2.645989482000104],
              [-52.54296382699991, 2.65151886000011],
              [-52.539604858999894, 2.659425354000064],
              [-52.533300333999904, 2.689862773000129],
              [-52.455268920999885, 2.865045878000032],
              [-52.448447631999926, 2.874347636000067],
              [-52.44162634299997, 2.881323954000052],
              [-52.43346146699986, 2.886594951000092],
              [-52.422351033999945, 2.890522359000059],
              [-52.4092768969999, 2.897343649000106],
              [-52.41067215999996, 2.905560201000043],
              [-52.41785518399993, 2.915482076000046],
              [-52.422196003999915, 2.927471008000097],
              [-52.41656327299995, 2.942508850000081],
              [-52.353207967999964, 3.058419088000079],
              [-52.351554320999895, 3.06596384700012],
              [-52.361114461999904, 3.109320373000102],
              [-52.36183793099991, 3.131954651000058],
              [-52.35532670099994, 3.151591695000093],
              [-52.31935990399995, 3.177636617000061],
              [-52.299102741999945, 3.225333964000114],
              [-52.27946569799991, 3.242490539000087],
              [-52.26701167799993, 3.244919332000052],
              [-52.25926021399994, 3.243317363000102],
              [-52.25119868999994, 3.243058980000043],
              [-52.23807287599996, 3.249725240000146],
              [-52.2279184569999, 3.260112203000077],
              [-52.0927587489999, 3.481390686000097],
              [-52.0920352789999, 3.490201518000092],
              [-52.09379227799988, 3.499399923000084],
              [-52.09358557099992, 3.506867168000028],
              [-52.07418107099994, 3.516634013000072],
              [-52.06599035699992, 3.528855489000094],
              [-52.05449234999989, 3.556709087000058],
              [-52.012763630999956, 3.61910837900011],
              [-52.00310013899994, 3.642311096000114],
              [-51.99537451199993, 3.685331726000101],
              [-51.98842403199993, 3.70455535900004],
              [-51.972843587999904, 3.721686096000084],
              [-51.96330928599991, 3.725458476000114],
              [-51.9558162029999, 3.724424947000031],
              [-51.94871069399994, 3.725096741000115],
              [-51.9400807289999, 3.733959249000122],
              [-51.9381945399999, 3.742511699000133],
              [-51.94098506699996, 3.763569845000063],
              [-51.938659627999925, 3.773569234000078],
              [-51.93093400099991, 3.781398214000106],
              [-51.89972143499995, 3.796668600000061],
              [-51.83541011599996, 3.867542827000108],
              [-51.8186152749999, 3.891081442000115],
              [-51.806238769999936, 3.917513937000095],
              [-51.79753129099987, 3.949966736000107],
              [-51.78319108099987, 3.980946757000126],
              [-51.75794714399993, 4.002521668000085],
              [-51.68321692599994, 4.03937409100007],
              [-51.651600714999915, 4.047674872000073],
              [-51.631743943999936, 4.06781647300005],
              [-51.595814581999946, 4.157863674000055],
              [-51.59690638799992, 4.21550439300006],
              [-51.585346511999944, 4.233817846000079],
              [-51.571603969999956, 4.235419012000079],
              [-51.55968176999994, 4.223700262000079],
              [-51.55215410099993, 4.207180080000057],
              [-51.53921464799993, 4.149237372000073],
              [-51.51187089799993, 4.080308335000041],
              [-51.45099850199995, 3.970526434000078],
              [-51.436838344999956, 3.929510809000078],
              [-51.42821204299992, 3.95774974200009],
              [-51.43541419199994, 3.985907294000071],
              [-51.46349036399994, 4.031927802000041],
              [-51.498158331999946, 4.105414130000042],
              [-51.54670162699995, 4.255031643000052],
              [-51.56102454299992, 4.357123114000046],
              [-51.56004798099991, 4.369370835000041],
              [-51.54768275799995, 4.421784939000077],
              [-51.53784299299991, 4.432061124000086],
              [-51.51649757699994, 4.441122259000053],
              [-51.490674293999916, 4.427744438000047],
              [-51.453424844999915, 4.402280900000051],
              [-51.38923018399993, 4.358902248000049],
              [-51.29828784599994, 4.258537021000052],
              [-51.22443496799991, 4.165042593000067],
              [-51.18692981899994, 4.078849145000049],
              [-51.17943274599992, 4.025213934000078],
              [-51.179439016999936, 3.924936685000091],
              [-51.18023099499993, 3.804443555000091],
              [-51.19748700899993, 3.699520841000037],
              [-51.17613684799994, 3.648342190000051],
              [-51.17345130099994, 3.67133209800005],
              [-51.15562903599994, 3.73773834800005],
              [-51.14883378799993, 3.827093817000048],
              [-51.136382615999935, 3.867743231000077],
              [-51.11636308499993, 3.906195380000042],
              [-51.093152259999954, 3.907229003000054],
              [-51.07990475199995, 3.88226959800005],
              [-51.090003134999904, 3.724950770000078],
              [-51.08443998599995, 3.59207204900008],
              [-51.07938534699991, 3.492087470000058],
              [-51.09647663699991, 3.449020773000086],
              [-51.09274174299992, 3.376328545000092],
              [-51.03600381199993, 3.229214],
              [-51.027815836999935, 3.181612555000072],
              [-51.04062690399991, 3.150936818000048],
              [-51.03370854499991, 3.127104360000089],
              [-51.01839603099995, 3.092004588000066],
              [-51.013983212999904, 3.072386024000082],
              [-51.019214949999935, 3.056994705000079],
              [-51.01677941499992, 3.035571925000056],
              [-51.00401851899994, 3.022652221000044],
              [-50.997278639999934, 3.00549067500009],
              [-50.98887632199995, 2.980622523000079],
              [-50.98645069899993, 2.958362067000053],
              [-50.979730322999956, 2.938650009000071],
              [-50.96447137899992, 2.916327455000044],
              [-50.95180834699994, 2.889752508000072],
              [-50.944201222999936, 2.875178105000089],
              [-50.945989883999914, 2.863222737000058],
              [-50.94951097499995, 2.847860948000061],
              [-50.948726249999936, 2.836748692000072],
              [-50.94454021799993, 2.822200538000061],
              [-50.934326735999946, 2.814448006000077],
              [-50.92292232999995, 2.80890534100007],
              [-50.91734778599994, 2.800726630000042],
              [-50.90280318099991, 2.793754509000053],
              [-50.89862286399995, 2.77920436900007],
              [-50.8935990839999, 2.762941752000074],
              [-50.88256450699993, 2.748351906000039],
              [-50.87498464799995, 2.728656177000062],
              [-50.87341406299993, 2.703867967000065],
              [-50.865833117999955, 2.684164640000063],
              [-50.85224682499995, 2.666133364000075],
              [-50.846366582999906, 2.647292705000041],
              [-50.84391823599992, 2.626762253000038],
              [-50.83469411599992, 2.593356260000064],
              [-50.81895911399994, 2.552394924000055],
              [-50.821929490999935, 2.528387762000079],
              [-50.830067511999914, 2.518011786000045],
              [-50.836822068999936, 2.514593817000048],
              [-50.84024003799993, 2.506537177000041],
              [-50.83946692599994, 2.497463283000059],
              [-50.83348548099991, 2.490708726000094],
              [-50.82363847599993, 2.48969147300005],
              [-50.81786048099991, 2.495306708000044],
              [-50.81285559799994, 2.502101955000057],
              [-50.805531378999945, 2.504380601000094],
              [-50.79161536399994, 2.494574286000045],
              [-50.774229411999954, 2.465337205000083],
              [-50.762989717999915, 2.443561682000052],
              [-50.7610678019999, 2.418754529000068],
              [-50.75189891899993, 2.39700462400009],
              [-50.74242102799991, 2.378485419000071],
              [-50.744130011999914, 2.367254950000074],
              [-50.739572719999956, 2.351467190000051],
              [-50.73381923099993, 2.313277547000041],
              [-50.720526812999935, 2.292556262000062],
              [-50.71764256299991, 2.258496444000059],
              [-50.71261755799992, 2.236803468000062],
              [-50.69726772999991, 2.216079307000086],
              [-50.68602985199993, 2.198476740000046],
              [-50.67926998599995, 2.171698309000078],
              [-50.69554602799991, 2.147284247000073],
              [-50.703195766999954, 2.141302802000041],
              [-50.71324622299994, 2.138495184000078],
              [-50.72996985599991, 2.139634507000039],
              [-50.73729407499991, 2.134466864000046],
              [-50.76585852799991, 2.143255927000041],
              [-50.778228318999936, 2.149969794000071],
              [-50.785715298999946, 2.161810614000046],
              [-50.79255123599995, 2.161810614000046],
              [-50.79255123599995, 2.154974677000041],
              [-50.791127081999946, 2.150539455000057],
              [-50.785715298999946, 2.141302802000041],
              [-50.78042558499993, 2.136379299000055],
              [-50.773426886999914, 2.133856512000079],
              [-50.767241990999935, 2.130682684000078],
              [-50.764556443999936, 2.123968817000048],
              [-50.765736456999946, 2.117621161000045],
              [-50.77086341099994, 2.10814036700009],
              [-50.77806555899991, 2.083156643000052],
              [-50.77969316299993, 2.07094961100006],
              [-50.77196204299992, 2.060939846000053],
              [-50.76789303299995, 2.05141836100006],
              [-50.76154537699995, 2.043850002000056],
              [-50.75157630099994, 2.045111395000049],
              [-50.74596106699994, 2.05304596600007],
              [-50.745025193999936, 2.064032294000071],
              [-50.74547278599994, 2.075751044000071],
              [-50.744130011999914, 2.086004950000074],
              [-50.73473059799994, 2.10382721600007],
              [-50.72061113199993, 2.119370835000041],
              [-50.702056443999936, 2.13031647300005],
              [-50.67926998599995, 2.134466864000046],
              [-50.65998287699995, 2.130682684000078],
              [-50.61955508299991, 2.105237894000084],
              [-50.60014135199992, 2.075201618000051],
              [-50.59410559799994, 2.028713283000059],
              [-50.589914516999954, 2.017157294000071],
              [-50.55972245999993, 1.963120835000041],
              [-50.53343665299991, 1.930365302000041],
              [-50.52220618399991, 1.912502346000053],
              [-50.51524817599994, 1.872870184000078],
              [-50.50918535099993, 1.857163804000038],
              [-50.50072180899991, 1.843939520000049],
              [-50.49087480399993, 1.832831122000073],
              [-50.46654212099992, 1.815415757000039],
              [-50.43260657499991, 1.802476304000038],
              [-50.39338131399995, 1.797796942000048],
              [-50.35309811099995, 1.804877020000049],
              [-50.33055579299992, 1.818060614000046],
              [-50.305041789999905, 1.81355132300007],
              [-50.29076087099992, 1.81195709800005],
              [-50.26838131399995, 1.811712958000044],
              [-50.257883266999954, 1.807806708000044],
              [-50.2224171389999, 1.813982981000038],
              [-50.20693108699993, 1.81387062400006],
              [-50.18315648099991, 1.818862693000085],
              [-50.164598388999934, 1.815634186000068],
              [-50.13787522799993, 1.798935353000047],
              [-50.091553114999954, 1.782098293000047],
              [-50.00405114199992, 1.751600782000082],
              [-49.950597040999924, 1.721326457000089],
              [-49.922960032999924, 1.690189407000048],
              [-49.91015891099994, 1.664262758000064],
              [-49.90078925899991, 1.611650521000058],
              [-49.89998937899992, 1.577606284000069],
              [-49.89908301299994, 1.557998575000056],
              [-49.895128033999924, 1.531145434000052],
              [-49.887562628999945, 1.469142971000053],
              [-49.87633880099992, 1.43343907600007],
              [-49.873551490999944, 1.392303629000082],
              [-49.87304648399993, 1.359850407000067],
              [-49.883025533999955, 1.307713925000087],
              [-49.895240980999915, 1.289776742000072],
              [-49.912919090999935, 1.272327269000073],
              [-49.94042792899995, 1.258668816000068],
              [-49.97532832699994, 1.245032823000088],
              [-50.02502076099995, 1.23038026100005],
              [-50.06729586799992, 1.225213376000056],
              [-50.102193094999905, 1.214744241000062],
              [-50.118045191999954, 1.215842820000091],
              [-50.13071701399991, 1.220102035000082],
              [-50.14127256599994, 1.225412148000089],
              [-50.149740667999936, 1.221209164000072],
              [-50.14767033499993, 1.205357301000049],
              [-50.13818887699995, 1.193711803000042],
              [-50.12023911199992, 1.185214851000069],
              [-50.09801706999991, 1.194664258000046],
              [-50.06739555799993, 1.187189696000075],
              [-50.026165196999955, 1.197641488000045],
              [-49.99869295099995, 1.199679483000068],
              [-49.975457251999956, 1.197503832000052],
              [-49.9447632749999, 1.218544704000067],
              [-49.9215218409999, 1.218481244000088],
              [-49.904855923999946, 1.206773179000038],
              [-49.890736456999946, 1.186021226000094],
              [-49.887562628999945, 1.174872137000079],
              [-49.89004472599993, 1.165228583000044],
              [-49.90807044199994, 1.133286851000094],
              [-49.93887285099993, 1.097235419000071],
              [-49.97883053299995, 1.072211005000042],
              [-50.01427161399994, 1.070868231000077],
              [-50.03156490799995, 1.105943101000094],
              [-50.04116777299993, 1.087958075000074],
              [-50.04674231699994, 1.052923895000049],
              [-50.06090247299994, 1.018866278000075],
              [-50.09642493399991, 1.003607489000046],
              [-50.10610917899993, 0.995306708000044],
              [-50.14142818899995, 0.941473700000074],
              [-50.15583248599995, 0.927313544000071],
              [-50.17039954299992, 0.916489976000094],
              [-50.24864661399994, 0.880072333000044],
              [-50.26158606699994, 0.869818427000041],
              [-50.302805141999954, 0.825425523000092],
              [-50.312489386999914, 0.817206122000073],
              [-50.34557044199994, 0.736273505000042],
              [-50.35342363199993, 0.726711330000057],
              [-50.36668860599991, 0.71556224200009],
              [-50.43321692599994, 0.678656317000048],
              [-50.45335852799991, 0.664048570000091],
              [-50.46589107999995, 0.646429755000042],
              [-50.499663865999935, 0.555975653000075],
              [-50.560658331999946, 0.44798411700009],
              [-50.60895748599995, 0.373928127000056],
              [-50.69395911399994, 0.286444403000075],
              [-50.79063880099994, 0.169501044000071],
              [-50.801665818999936, 0.169012762000079],
              [-50.819203253999945, 0.173651434000078],
              [-50.85399329299992, 0.173651434000078],
              [-50.928944464999915, 0.155422268000052],
              [-50.97984778599994, 0.120428778000075],
              [-51.01740475199995, 0.071437893000052],
              [-51.06916256399995, -0.019341729999951],
              [-51.08141028599994, -0.032525322999959],
              [-51.09727942599994, -0.037896416999956],
              [-51.160145636999914, -0.039320570999962],
              [-51.20156816299993, -0.049086195999962],
              [-51.207875128999945, -0.053155205999929],
              [-51.210275844999956, -0.061822197999959],
              [-51.21519934799994, -0.068658135999954],
              [-51.23932857999995, -0.072564385999954],
              [-51.26545162699995, -0.083428643999923],
              [-51.30894934799994, -0.076755466999941],
              [-51.32697506399995, -0.079522393999923],
              [-51.32697506399995, -0.085707289999959],
              [-51.317697719999956, -0.090671481999948],
              [-51.29393469999991, -0.095798434999949],
              [-51.28221594999991, -0.103122653999947],
              [-51.27574622299994, -0.113213799999926],
              [-51.27253170499995, -0.121840101999908],
              [-51.26634680899991, -0.127129815999922],
              [-51.251210089999915, -0.127373955999929],
              [-51.32249915299991, -0.215264580999929],
              [-51.337554490999935, -0.26100025799991],
              [-51.356678839999915, -0.290459893999923],
              [-51.363840298999946, -0.326104424999926],
              [-51.37071692599994, -0.342950127999927],
              [-51.38841712099992, -0.373711846999925],
              [-51.40099036399994, -0.389580987999921],
              [-51.43077551999994, -0.414320570999962],
              [-51.443023240999935, -0.428399346999925],
              [-51.44554602799991, -0.440362237999921],
              [-51.44444739499994, -0.455336195999962],
              [-51.44517981699994, -0.471449476999908],
              [-51.45360266799992, -0.486748955999929],
              [-51.48623613199993, -0.517185153999947],
              [-51.50609290299991, -0.531914971999925],
              [-51.52183997299994, -0.538262627999927],
              [-51.53652910099993, -0.535577080999929],
              [-51.562489386999914, -0.525485934999949],
              [-51.580189581999946, -0.525160414999959],
              [-51.580189581999946, -0.531996351999908],
              [-51.57079016799992, -0.531670830999929],
              [-51.56432044199994, -0.533379815999922],
              [-51.552845831999946, -0.538262627999927],
              [-51.552845831999946, -0.545586846999925],
              [-51.56908118399991, -0.55006275799991],
              [-51.58763587099992, -0.551853122999944],
              [-51.58763587099992, -0.558689059999949],
              [-51.57359778599994, -0.559747002999927],
              [-51.561105923999946, -0.558689059999949],
              [-51.551625128999945, -0.55437590899993],
              [-51.54670162699995, -0.545586846999925],
              [-51.53237870999993, -0.551853122999944],
              [-51.579009568999936, -0.604261976999908],
              [-51.628570115999935, -0.676039320999962],
              [-51.635650193999936, -0.682224216999941],
              [-51.64981035099993, -0.690524997999944],
              [-51.65648352799991, -0.695896091999941],
              [-51.69749915299991, -0.747165622999944],
              [-51.700510219999956, -0.759698174999926],
              [-51.713734503999945, -0.793226820999962],
              [-51.72419186099995, -0.877699476999908],
              [-51.71084550699993, -0.978610934999949],
              [-51.71117102799991, -1.011163018999923],
              [-51.712880011999914, -1.020440362999921],
              [-51.71548417899993, -1.027520440999922],
              [-51.71910559799994, -1.033379815999922],
              [-51.72419186099995, -1.039157809999949],
              [-51.73273678299995, -1.045586846999925],
              [-51.75177975199995, -1.055271091999941],
              [-51.784820115999935, -1.083591403999947],
              [-51.80064856699994, -1.092705987999921],
              [-51.82209225199995, -1.123630466999941],
              [-51.834095831999946, -1.134698174999926],
              [-51.908314581999946, -1.157972914999959],
              [-51.929351365999935, -1.178317966999941],
              [-51.930246548999946, -1.223402601999908],
              [-51.916005011999914, -1.309177341999941],
              [-51.92145748599995, -1.325778903999947],
              [-51.93455969999991, -1.33953215899993],
              [-51.96442623599995, -1.36060963299991],
              [-51.995350714999915, -1.396416924999926],
              [-52.00845292899993, -1.40162525799991],
              [-52.06578528599994, -1.405043226999908],
              [-52.08726966099994, -1.40162525799991],
              [-52.15135657499991, -1.380954684999949],
              [-52.166127081999946, -1.370863539999959],
              [-52.17943274599992, -1.356866143999923],
              [-52.195383266999954, -1.34498463299991],
              [-52.21458899599992, -1.340020440999922],
              [-52.23810787699995, -1.346368096999925],
              [-52.24917558499993, -1.353773695999962],
              [-52.27599036399994, -1.38445403399993],
              [-52.28547115799995, -1.390069268999923],
              [-52.30833899599992, -1.393649997999944],
              [-52.333241339999915, -1.407810153999947],
              [-52.40196692599994, -1.422051690999922],
              [-52.421986456999946, -1.430352471999925],
              [-52.44220943899995, -1.443129164999959],
              [-52.45783443899995, -1.45826588299991],
              [-52.46401933499993, -1.473565362999921],
              [-52.47508704299992, -1.48406340899993],
              [-52.55809485599991, -1.518731377999927],
              [-52.57534745999993, -1.52312590899993],
              [-52.61827551999994, -1.525648695999962],
              [-52.68211829299992, -1.544854424999926],
              [-52.69741777299993, -1.55242278399993],
              [-52.70604407499991, -1.560642184999949],
              [-52.71003170499995, -1.567803643999923],
              [-52.71108964799993, -1.576836846999925],
              [-52.711048956999946, -1.590264580999929],
              [-52.70811926999994, -1.600030205999929],
              [-52.70055091099994, -1.600274346999925],
              [-52.69050045499995, -1.596449476999908],
              [-52.68004309799994, -1.594008070999962],
              [-52.658273891999954, -1.59148528399993],
              [-52.595041469999956, -1.57350025799991],
              [-52.423085089999915, -1.56609465899993],
              [-52.34390214799993, -1.55242278399993],
              [-52.32677161399994, -1.547051690999922],
              [-52.29124915299991, -1.523614190999922],
              [-52.27912350199995, -1.518243096999925],
              [-52.26349850199995, -1.525485934999949],
              [-52.25039628799993, -1.54225025799991],
              [-52.241444464999915, -1.561700127999927],
              [-52.23656165299991, -1.585381768999923],
              [-52.23338782499991, -1.59343840899993],
              [-52.23106848899994, -1.602715752999927],
              [-52.23192298099991, -1.614434502999927],
              [-52.23680579299992, -1.625583591999941],
              [-52.25230872299994, -1.644952080999929],
              [-52.25861568899995, -1.655450127999927],
              [-52.263335740999935, -1.676853122999944],
              [-52.26024329299992, -1.695245049999926],
              [-52.24876868399991, -1.703057549999926],
              [-52.222320115999935, -1.691176039999959],
              [-52.20889238199993, -1.691827080999929],
              [-52.203968878999945, -1.690199476999908],
              [-52.20034745999993, -1.684747002999927],
              [-52.19896399599992, -1.673923434999949],
              [-52.19713294199994, -1.669691664999959],
              [-52.162993943999936, -1.634942315999922],
              [-52.14195716099994, -1.62273528399993],
              [-52.12376868399991, -1.619073174999926],
              [-52.077381964999915, -1.621270440999922],
              [-52.07249915299991, -1.619561455999929],
              [-52.056630011999914, -1.610935153999947],
              [-52.04629472599993, -1.607598565999922],
              [-52.03661048099991, -1.607191664999959],
              [-52.01577714799993, -1.60865650799991],
              [-52.004750128999945, -1.607598565999922],
              [-51.958648240999935, -1.593357028999947],
              [-51.914621548999946, -1.570977471999925],
              [-51.66954505099994, -1.40162525799991],
              [-51.595041469999956, -1.386895440999922],
              [-51.57677161399994, -1.377699476999908],
              [-51.55797278599994, -1.365411065999922],
              [-51.48399817599994, -1.340101820999962],
              [-51.46202551999994, -1.32935963299991],
              [-51.437489386999914, -1.312676690999922],
              [-51.41771399599992, -1.291680596999925],
              [-51.409494594999956, -1.268161716999941],
              [-51.399647589999915, -1.251071872999944],
              [-51.37633216099994, -1.240004164999959],
              [-51.32697506399995, -1.230889580999929],
              [-51.32697506399995, -1.237074476999908],
              [-51.334828253999945, -1.240655205999929],
              [-51.339914516999954, -1.244886976999908],
              [-51.34357662699995, -1.250258070999962],
              [-51.34740149599992, -1.257582289999959],
              [-51.32848059799994, -1.253838799999926],
              [-51.30532792899993, -1.24382903399993],
              [-51.28343665299991, -1.231377862999921],
              [-51.26829993399991, -1.22039153399993],
              [-51.25218665299991, -1.201918226999908],
              [-51.227853969999956, -1.162692966999941],
              [-51.21369381399995, -1.144952080999929],
              [-51.187489386999914, -1.121677341999941],
              [-51.16148841099994, -1.103610934999949],
              [-51.03294837099992, -1.038018487999921],
              [-51.00340735599991, -1.013767184999949],
              [-50.991118943999936, -0.987237237999921],
              [-50.99657141799992, -0.970798434999949],
              [-51.00609290299991, -0.95281340899993],
              [-51.009755011999914, -0.935967705999929],
              [-50.997303839999915, -0.922458591999941],
              [-50.976673956999946, -0.920179945999962],
              [-50.95742753799993, -0.949883721999925],
              [-50.93590247299994, -0.956638278999947],
              [-50.93590247299994, -0.949151299999926],
              [-50.947377081999946, -0.942478122999944],
              [-50.95327714799993, -0.93132903399993],
              [-50.95221920499995, -0.919122002999927],
              [-50.94273841099994, -0.908786716999941],
              [-50.928618943999936, -0.905694268999923],
              [-50.88133704299992, -0.914971612999921],
              [-50.85423743399991, -0.91139088299991],
              [-50.83958899599992, -0.912774346999925],
              [-50.82664954299992, -0.922458591999941],
              [-50.82168535099993, -0.935316664999959],
              [-50.821929490999935, -0.950616143999923],
              [-50.82664954299992, -0.983819268999923],
              [-50.82445227799991, -1.03093840899993],
              [-50.82664954299992, -1.045342705999929],
              [-50.83389238199993, -1.058689059999949],
              [-50.843861456999946, -1.065850518999923],
              [-50.855458136999914, -1.071465752999927],
              [-50.86766516799992, -1.079522393999923],
              [-50.89240475199995, -1.112237237999921],
              [-50.90176347599993, -1.121026299999926],
              [-50.91234290299991, -1.125583591999941],
              [-50.92528235599991, -1.127699476999908],
              [-50.95641028599994, -1.128513278999947],
              [-50.84748287699995, -1.197849216999941],
              [-50.830067511999914, -1.213799737999921],
              [-50.81993567599994, -1.23170338299991],
              [-50.81859290299991, -1.252373955999929],
              [-50.82925370999993, -1.312107028999947],
              [-50.82664954299992, -1.370863539999959],
              [-50.823475714999915, -1.376397393999923],
              [-50.81655839799993, -1.382256768999923],
              [-50.80931555899991, -1.390232028999947],
              [-50.805531378999945, -1.40162525799991],
              [-50.813343878999945, -1.41375090899993],
              [-50.81810462099992, -1.424899997999944],
              [-50.819203253999945, -1.436293226999908],
              [-50.80968176999994, -1.457696221999925],
              [-50.77867591099994, -1.498630466999941],
              [-50.76671301999994, -1.540785414999959],
              [-50.75332597599993, -1.557061455999929],
              [-50.68927975199995, -1.612074476999908],
              [-50.67955481699994, -1.629001559999949],
              [-50.670480923999946, -1.696465752999927],
              [-50.66380774599992, -1.719414971999925],
              [-50.65469316299993, -1.73796965899993],
              [-50.673939581999946, -1.764743747999944],
              [-50.69102942599994, -1.765394789999959],
              [-50.73729407499991, -1.73796965899993],
              [-50.72642981699994, -1.761163018999923],
              [-50.71797742299992, -1.768763716999956],
              [-50.70950814999992, -1.790948470999922],
              [-50.71728258099995, -1.822473028999923],
              [-50.73950701199993, -1.832651286999919],
              [-50.758327883999925, -1.84539727899994],
              [-50.766935599999954, -1.863288958999931],
              [-50.76700867699992, -1.882057221999958],
              [-50.787567286999945, -1.897369651999952],
              [-50.8149046499999, -1.896456074999946],
              [-50.83621428399994, -1.882754929999919],
              [-50.85842751999991, -1.865648005999958],
              [-50.87980342399993, -1.85195062899993],
              [-50.88841532099991, -1.868147424999961],
              [-50.89273390499994, -1.879234599999961],
              [-50.87988748399994, -1.882672187999958],
              [-50.8705157789999, -1.901463277999937],
              [-50.85342169899991, -1.908323222999911],
              [-50.854384875999926, -1.933080238999935],
              [-50.84421518499994, -1.955300851999937],
              [-50.831420227999956, -1.963010771999961],
              [-50.81860699799995, -1.969006744999945],
              [-50.821947036999916, -1.945952],
              [-50.826159521999955, -1.93057614199995],
              [-50.81844088999992, -1.924615871999947],
              [-50.791954984999904, -1.927230587999929],
              [-50.737207303999924, -1.92134836799994],
              [-50.7132582939999, -1.914565917999937],
              [-50.7021436039999, -1.909472010999934],
              [-50.69782028399993, -1.888166310999907],
              [-50.700341013999946, -1.871962251999946],
              [-50.698587769999904, -1.854062255999906],
              [-50.69002098199991, -1.842998459999933],
              [-50.6763294239999, -1.830242687999942],
              [-50.667738511999914, -1.808099979999952],
              [-50.66004374899995, -1.803004285999918],
              [-50.63360790899992, -1.811591092999947],
              [-50.610580676999916, -1.814202552999916],
              [-50.59170488199993, -1.843194268999923],
              [-50.565337693999936, -1.890720309999949],
              [-50.54723059799994, -1.906914971999925],
              [-50.52481035099993, -1.921482028999947],
              [-50.50450598899994, -1.929131768999923],
              [-50.48961341099994, -1.928480726999908],
              [-50.476226365999935, -1.926039320999962],
              [-50.46666419199994, -1.927829684999949],
              [-50.462961391999954, -1.939711195999962],
              [-50.46593176999994, -1.947198174999926],
              [-50.47996985599991, -1.967054945999962],
              [-50.484038865999935, -1.977634372999944],
              [-50.47008216099994, -1.969903252999927],
              [-50.45665442599994, -1.943942966999941],
              [-50.443023240999935, -1.935967705999929],
              [-50.44188391799992, -1.94695403399993],
              [-50.44322669199994, -1.956638278999947],
              [-50.44709225199995, -1.965508721999925],
              [-50.45335852799991, -1.97389088299991],
              [-50.45750891799992, -1.983819268999923],
              [-50.45425370999993, -1.993584893999923],
              [-50.443023240999935, -2.011651299999926],
              [-50.43590247299994, -2.045098565999922],
              [-50.428578253999945, -2.062920830999929],
              [-50.41576087099992, -2.073174737999921],
              [-50.40977942599994, -2.047458591999941],
              [-50.40387936099995, -2.035821221999925],
              [-50.394642706999946, -2.025485934999949],
              [-50.382476365999935, -2.017185153999947],
              [-50.378756439999904, -2.005425314999911],
              [-50.377907121999954, -1.99875153399995],
              [-50.373702916999946, -1.98707718199995],
              [-50.37284057099993, -1.973727897999936],
              [-50.36445586099995, -1.961227996999924],
              [-50.34100750099992, -1.936245103999909],
              [-50.31253899899991, -1.908773717999907],
              [-50.280769956999904, -1.893828695999957],
              [-50.25133216099994, -1.901788018999923],
              [-50.23155676999994, -1.89576588299991],
              [-50.20734615799995, -1.897149346999925],
              [-50.18272864499994, -1.904229424999926],
              [-50.16193600199995, -1.915622653999947],
              [-50.15477454299992, -1.882745049999926],
              [-50.13658606699994, -1.861993096999925],
              [-50.11042232999995, -1.849216403999947],
              [-50.02489173099991, -1.826104424999926],
              [-50.00059973899994, -1.823663018999923],
              [-49.97691809799994, -1.826104424999926],
              [-49.95270748599995, -1.833428643999923],
              [-49.93224036399994, -1.842950127999927],
              [-49.87535559799994, -1.879571221999925],
              [-49.86929277299993, -1.888767184999949],
              [-49.86705481699994, -1.90553150799991],
              [-49.87047278599994, -1.919040622999944],
              [-49.89439856699994, -1.963311455999929],
              [-49.87482662699995, -1.942966403999947],
              [-49.860259568999936, -1.922458591999941],
              [-49.85423743399991, -1.942966403999947],
              [-49.85065670499995, -1.96257903399993],
              [-49.850168423999946, -1.982679945999962],
              [-49.85342363199993, -2.004978122999944],
              [-49.86119544199994, -2.026543877999927],
              [-49.88194739499994, -2.066582940999922],
              [-49.887562628999945, -2.087497653999947],
              [-49.88072669199994, -2.087497653999947],
              [-49.860259568999936, -2.045830987999921],
              [-49.85342363199993, -2.045830987999921],
              [-49.84797115799995, -2.062432549999926],
              [-49.83751380099994, -2.081149997999944],
              [-49.82494055899991, -2.097751559999949],
              [-49.812489386999914, -2.108005466999941],
              [-49.82892818899995, -2.057793877999927],
              [-49.839182094999956, -2.004978122999944],
              [-49.837880011999914, -1.926690362999921],
              [-49.846587693999936, -1.909356377999927],
              [-49.846587693999936, -1.901788018999923],
              [-49.83470618399991, -1.90593840899993],
              [-49.83088131399995, -1.918064059999949],
              [-49.83234615799995, -1.949639580999929],
              [-49.82335364499994, -1.928155205999929],
              [-49.81981360599991, -1.91179778399993],
              [-49.81045488199993, -1.900567315999922],
              [-49.78453528599994, -1.895114841999941],
              [-49.76048743399991, -1.896742445999962],
              [-49.74718176999994, -1.904717705999929],
              [-49.73741614499994, -1.916273695999962],
              [-49.72370357999995, -1.929131768999923],
              [-49.72789466099994, -1.910821221999925],
              [-49.72130286399994, -1.904066664999959],
              [-49.71068274599992, -1.908298434999949],
              [-49.70262610599991, -1.922458591999941],
              [-49.69399980399993, -1.907321872999944],
              [-49.67609615799995, -1.908623955999929],
              [-49.65420488199993, -1.920179945999962],
              [-49.61945553299995, -1.950290622999944],
              [-49.60464433499993, -1.967868747999944],
              [-49.59434973899994, -1.988376559999949],
              [-49.59276282499991, -2.011651299999926],
              [-49.579416469999956, -1.994317315999922],
              [-49.59292558499993, -1.964043877999927],
              [-49.63434811099995, -1.909356377999927],
              [-49.647368943999936, -1.915622653999947],
              [-49.649281378999945, -1.907972914999959],
              [-49.65477454299992, -1.895114841999941],
              [-49.631703253999945, -1.867852471999925],
              [-49.59801184799994, -1.842705987999921],
              [-49.563343878999945, -1.83521900799991],
              [-49.53746497299994, -1.860935153999947],
              [-49.522368943999936, -1.795993747999944],
              [-49.51081295499995, -1.77898528399993],
              [-49.485218878999945, -1.763929945999962],
              [-49.466460740999935, -1.764336846999925],
              [-49.45799719999991, -1.778741143999923],
              [-49.463002081999946, -1.805759372999944],
              [-49.45287024599992, -1.799981377999927],
              [-49.43590247299994, -1.784926039999959],
              [-49.42202714799993, -1.77898528399993],
              [-49.42821204299992, -1.798760674999926],
              [-49.451161261999914, -1.824639580999929],
              [-49.45616614499994, -1.836683851999908],
              [-49.45421301999994, -1.856133721999925],
              [-49.44758053299995, -1.869886976999908],
              [-49.434803839999915, -1.879978122999944],
              [-49.41466223899994, -1.888278903999947],
              [-49.37922115799995, -1.896416924999926],
              [-49.370432094999956, -1.905043226999908],
              [-49.36742102799991, -1.925713799999926],
              [-49.36974036399994, -1.940199476999908],
              [-49.37580318899995, -1.957207940999922],
              [-49.38434811099995, -1.972832940999922],
              [-49.39411373599995, -1.983819268999923],
              [-49.39411373599995, -1.991306247999944],
              [-49.38109290299991, -1.991306247999944],
              [-49.38906816299993, -2.005629164999959],
              [-49.41291256399995, -2.027439059999949],
              [-49.42202714799993, -2.038995049999926],
              [-49.42552649599992, -2.050876559999949],
              [-49.42821204299992, -2.131524346999925],
              [-49.43049068899995, -2.141208591999941],
              [-49.440297003999945, -2.160902601999908],
              [-49.44554602799991, -2.183770440999922],
              [-49.45299231699994, -2.190850518999923],
              [-49.46198482999995, -2.196465752999927],
              [-49.46983801999994, -2.203545830999929],
              [-49.49583899599992, -2.246677341999941],
              [-49.500111456999946, -2.252211195999962],
              [-49.50300045499995, -2.258396091999941],
              [-49.503977016999954, -2.31023528399993],
              [-49.50645911399994, -2.31959400799991],
              [-49.512277798999946, -2.326755466999941],
              [-49.51903235599991, -2.333591403999947],
              [-49.52440344999991, -2.341241143999923],
              [-49.52721106699994, -2.35084400799991],
              [-49.52892005099994, -2.37078215899993],
              [-49.531320766999954, -2.380466403999947],
              [-49.548939581999946, -2.403090101999908],
              [-49.55174719999991, -2.412774346999925],
              [-49.55068925699993, -2.423760674999926],
              [-49.54600989499994, -2.442559502999927],
              [-49.54210364499994, -2.497165622999944],
              [-49.545765753999945, -2.516534112999921],
              [-49.60781816299993, -2.604913018999923],
              [-49.617258266999954, -2.615004164999959],
              [-49.64053300699993, -2.619724216999941],
              [-49.66063391799992, -2.631768487999921],
              [-49.67690995999993, -2.649102471999925],
              [-49.68895423099991, -2.669040622999944],
              [-49.66368567599994, -2.677666924999926],
              [-49.61986243399991, -2.670179945999962],
              [-49.544911261999914, -2.642347914999959],
              [-49.527414516999954, -2.628350518999923],
              [-49.523548956999946, -2.615655205999929],
              [-49.52379309799994, -2.600762627999927],
              [-49.51829993399991, -2.580254815999922],
              [-49.51195227799991, -2.57350025799991],
              [-49.49201412699995, -2.562432549999926],
              [-49.48656165299991, -2.560316664999959],
              [-49.482533331999946, -2.556817315999922],
              [-49.479400193999936, -2.538832289999959],
              [-49.47728430899991, -2.53248463299991],
              [-49.45274817599994, -2.50750090899993],
              [-49.442616339999915, -2.492364190999922],
              [-49.43569902299993, -2.47039153399993],
              [-49.434437628999945, -2.451836846999925],
              [-49.436756964999915, -2.413995049999926],
              [-49.43569902299993, -2.395277601999908],
              [-49.42682857999995, -2.367282809999949],
              [-49.33161373599995, -2.20476653399993],
              [-49.31395423099991, -2.160414320999962],
              [-49.30601966099994, -2.124444268999923],
              [-49.304758266999954, -2.104587497999944],
              [-49.30052649599992, -2.090915622999944],
              [-49.23200436099995, -1.948174737999921],
              [-49.20409094999991, -1.907321872999944],
              [-49.17564856699994, -1.881442966999941],
              [-49.16832434799994, -1.878106377999927],
              [-49.16002356699994, -1.875746351999908],
              [-49.14556909899994, -1.856758475999925],
              [-49.14276431199994, -1.839946013999906],
              [-49.12866458499991, -1.800707216999911],
              [-49.12300603299991, -1.76800830499991],
              [-49.08673009699993, -1.748893903999942],
              [-49.049648419999926, -1.721792002999962],
              [-49.00886436899992, -1.681124010999952],
              [-48.99154295699992, -1.635483829999941],
              [-48.96558945999993, -1.59971933199995],
              [-48.92607902299994, -1.593599050999956],
              [-48.90311715999991, -1.584229619999917],
              [-48.877873766999926, -1.571169416999908],
              [-48.86478048099991, -1.559961038999916],
              [-48.85636876099994, -1.559030551999911],
              [-48.8573168339999, -1.566525034999927],
              [-48.87508358699995, -1.586137351999923],
              [-48.89285097399994, -1.598251955999956],
              [-48.89567830699991, -1.62254258999991],
              [-48.90316645599995, -1.638421725999933],
              [-48.91160678299991, -1.672979591999933],
              [-48.930302722999954, -1.68604053699994],
              [-48.936848503999954, -1.693506880999962],
              [-48.94339430399992, -1.700037817999942],
              [-48.946201222999946, -1.704704712999956],
              [-48.94247707299991, -1.719651677999934],
              [-48.9434316949999, -1.74299740999993],
              [-48.95559937299993, -1.766329046999942],
              [-48.968704155999944, -1.785924677999958],
              [-48.99581502199993, -1.793367713999942],
              [-49.01172139899995, -1.807360388999939],
              [-49.01828883399992, -1.827901087999919],
              [-49.03232450899992, -1.839095985999961],
              [-49.03326892799993, -1.846567612999934],
              [-49.01732337099992, -1.847263278999947],
              [-49.002417737999906, -1.842860329999951],
              [-48.992123887999924, -1.832596080999906],
              [-48.98275523399991, -1.813926336999941],
              [-48.95657702199992, -1.803679459999955],
              [-48.92946479199992, -1.787832365999918],
              [-48.91729221499992, -1.762633650999931],
              [-48.910733301999926, -1.74209742499994],
              [-48.90025794199994, -1.734551690999922],
              [-48.89305579299992, -1.722832940999922],
              [-48.88390051999994, -1.717461846999925],
              [-48.881418423999946, -1.713474216999941],
              [-48.89024817599994, -1.693780205999929],
              [-48.890736456999946, -1.686455987999921],
              [-48.88239498599995, -1.679620049999926],
              [-48.86400305899991, -1.67156340899993],
              [-48.856312628999945, -1.665948174999926],
              [-48.853586391999954, -1.661879164999959],
              [-48.847767706999946, -1.64967213299991],
              [-48.84666907499991, -1.645196221999925],
              [-48.84508216099994, -1.641371351999908],
              [-48.84129798099991, -1.641696872999944],
              [-48.836781378999945, -1.642754815999922],
              [-48.82966061099995, -1.640557549999926],
              [-48.81969153599994, -1.640394789999959],
              [-48.815337693999936, -1.63836028399993],
              [-48.81281490799995, -1.63404713299991],
              [-48.81322180899991, -1.625420830999929],
              [-48.81187903599994, -1.621270440999922],
              [-48.73680579299992, -1.51140715899993],
              [-48.73542232999995, -1.507419528999947],
              [-48.73582923099991, -1.503106377999927],
              [-48.73582923099991, -1.498793226999908],
              [-48.73306230399993, -1.494317315999922],
              [-48.72899329299992, -1.492608330999929],
              [-48.71865800699993, -1.491957289999959],
              [-48.715687628999945, -1.490980726999908],
              [-48.703968878999945, -1.478936455999929],
              [-48.699330206999946, -1.472914320999962],
              [-48.69522050699993, -1.463636976999908],
              [-48.67637140799991, -1.417570647999923],
              [-48.656946270999924, -1.383379529999957],
              [-48.642121353999926, -1.385674793999954],
              [-48.63073297799991, -1.406211440999925],
              [-48.61820513799995, -1.427890533999914],
              [-48.60643469999991, -1.456231377999927],
              [-48.57591712099992, -1.512627862999921],
              [-48.561756964999915, -1.528903903999947],
              [-48.55231686099995, -1.544366143999923],
              [-48.543853318999936, -1.565606377999927],
              [-48.53502356699994, -1.581475518999923],
              [-48.52391516799992, -1.580336195999962],
              [-48.50230872299994, -1.612074476999908],
              [-48.490223761999914, -1.619073174999926],
              [-48.46593176999994, -1.621270440999922],
              [-48.45262610599991, -1.625664971999925],
              [-48.44204667899993, -1.63640715899993],
              [-48.43399003799993, -1.64967213299991],
              [-48.42833411399994, -1.662286065999922],
              [-48.42145748599995, -1.645114841999941],
              [-48.42446855399993, -1.626153252999927],
              [-48.430978969999956, -1.607191664999959],
              [-48.43455969999991, -1.590264580999929],
              [-48.443023240999935, -1.57000090899993],
              [-48.47838294199994, -1.535088799999926],
              [-48.48289954299992, -1.51140715899993],
              [-48.464833136999914, -1.522067966999941],
              [-48.44790605399993, -1.525974216999941],
              [-48.42804928299995, -1.524183851999908],
              [-48.37580318899995, -1.510511976999908],
              [-48.35582434799994, -1.500420830999929],
              [-48.33958899599992, -1.487237237999921],
              [-48.32530676999994, -1.470472914999959],
              [-48.33413652299993, -1.468682549999926],
              [-48.36628170499995, -1.470472914999959],
              [-48.37755286399994, -1.469170830999929],
              [-48.38809160099993, -1.46607838299991],
              [-48.39793860599991, -1.461846612999921],
              [-48.40721594999991, -1.456231377999927],
              [-48.417632615999935, -1.465101820999962],
              [-48.43492591099994, -1.470961195999962],
              [-48.45555579299992, -1.472914320999962],
              [-48.47614498599995, -1.470472914999959],
              [-48.49657141799992, -1.461358330999929],
              [-48.50328528599994, -1.44850025799991],
              [-48.50157630099994, -1.431247653999947],
              [-48.49657141799992, -1.408379815999922],
              [-48.48981686099995, -1.326918226999908],
              [-48.48275288299993, -1.281300493999936],
              [-48.454006543999924, -1.24415984299992],
              [-48.43590301599994, -1.218688411999949],
              [-48.4231728929999, -1.232515528999954],
              [-48.42853363499995, -1.265439599999922],
              [-48.42538650799992, -1.297312483999917],
              [-48.409820115999935, -1.302829684999949],
              [-48.33971106699994, -1.316013278999947],
              [-48.33458411399994, -1.313653252999927],
              [-48.33161373599995, -1.29420338299991],
              [-48.32648678299995, -1.279473565999922],
              [-48.32005774599992, -1.229587497999944],
              [-48.30504309799994, -1.188246351999908],
              [-48.281361456999946, -1.167087497999944],
              [-48.25015214799993, -1.189385674999926],
              [-48.25731360599991, -1.17351653399993],
              [-48.26939856699994, -1.161716403999947],
              [-48.277007615999935, -1.149997653999947],
              [-48.27065995999993, -1.134698174999926],
              [-48.27814693899995, -1.128513278999947],
              [-48.27065995999993, -1.121026299999926],
              [-48.25894120999993, -1.126153252999927],
              [-48.248158331999946, -1.122816664999959],
              [-48.23668372299994, -1.11687590899993],
              [-48.22288977799991, -1.113539320999962],
              [-48.23460852799991, -1.108819268999923],
              [-48.24714107999995, -1.109307549999926],
              [-48.27440344999991, -1.113539320999962],
              [-48.27782141799992, -1.108493747999944],
              [-48.291127081999946, -1.079522393999923],
              [-48.29600989499994, -1.055596612999921],
              [-48.29173743399991, -1.043633721999925],
              [-48.27769934799994, -1.039646091999941],
              [-48.23094641799992, -1.03875090899993],
              [-48.21251380099994, -1.036553643999923],
              [-48.198109503999945, -1.030450127999927],
              [-48.187489386999914, -1.018649997999944],
              [-48.185536261999914, -1.009942315999922],
              [-48.18468176999994, -0.998223565999922],
              [-48.182932094999956, -0.988213799999926],
              [-48.177845831999946, -0.983819268999923],
              [-48.17617753799993, -0.97975025799991],
              [-48.16380774599992, -0.962823174999926],
              [-48.16079667899993, -0.960056247999944],
              [-48.15868079299992, -0.936455987999921],
              [-48.153960740999935, -0.914971612999921],
              [-48.15217037699995, -0.914239190999922],
              [-48.14781653599994, -0.910577080999929],
              [-48.14305579299992, -0.905857028999947],
              [-48.140288865999935, -0.901299737999921],
              [-48.145741339999915, -0.886163018999923],
              [-48.146555141999954, -0.880791924999926],
              [-48.14110266799992, -0.85475025799991],
              [-48.140288865999935, -0.842950127999927],
              [-48.14354407499991, -0.83326588299991],
              [-48.15054277299993, -0.826755466999941],
              [-48.15758216099994, -0.821384372999944],
              [-48.16079667899993, -0.816013278999947],
              [-48.15916907499991, -0.796644789999959],
              [-48.15404212099992, -0.781833591999941],
              [-48.11156165299991, -0.724541924999926],
              [-48.03791256399995, -0.661716403999947],
              [-48.02525794199994, -0.675713799999926],
              [-48.02110755099994, -0.683526299999926],
              [-48.01744544199994, -0.695896091999941],
              [-48.01781165299991, -0.702732028999947],
              [-48.023548956999946, -0.715427341999941],
              [-48.02358964799993, -0.723239841999941],
              [-48.02135169199994, -0.725030205999929],
              [-48.01207434799994, -0.731052341999941],
              [-48.00999915299991, -0.73365650799991],
              [-48.00255286399994, -0.746514580999929],
              [-47.969634568999936, -0.779473565999922],
              [-47.962147589999915, -0.781833591999941],
              [-47.94611568899995, -0.740492445999962],
              [-47.87791907499991, -0.696872653999947],
              [-47.86623811599992, -0.673505404999958],
              [-47.85008704299992, -0.670993747999944],
              [-47.82127844999991, -0.679782809999949],
              [-47.80244441299993, -0.690333769999938],
              [-47.807380348999914, -0.677309867999952],
              [-47.822229974999914, -0.664892773999952],
              [-47.825285627999904, -0.63948304999991],
              [-47.82461635899995, -0.606651658999908],
              [-47.815918232999934, -0.588699799999915],
              [-47.81280014899994, -0.573835827999915],
              [-47.80907086099995, -0.56516744299995],
              [-47.789888970999925, -0.582543783999938],
              [-47.77504503699993, -0.599292497999954],
              [-47.76949982699995, -0.619743734999929],
              [-47.77025305899991, -0.637139580999929],
              [-47.74681555899991, -0.633884372999944],
              [-47.725168423999946, -0.644138278999947],
              [-47.71642005099994, -0.667738539999959],
              [-47.715728318999936, -0.712985934999949],
              [-47.72240149599992, -0.724379164999959],
              [-47.735218878999945, -0.735446872999944],
              [-47.743397589999915, -0.746270440999922],
              [-47.736317511999914, -0.757256768999923],
              [-47.72866777299993, -0.756524346999925],
              [-47.65282141799992, -0.72389088299991],
              [-47.626616990999935, -0.707207940999922],
              [-47.610585089999915, -0.693942966999941],
              [-47.59727942599994, -0.677341403999947],
              [-47.58828691299993, -0.641696872999944],
              [-47.578099591999944, -0.635407492999946],
              [-47.58716344299995, -0.613963781999928],
              [-47.58451353999993, -0.578246976999935],
              [-47.573475997999935, -0.582808732999922],
              [-47.559195968999916, -0.591270689999931],
              [-47.53843983999991, -0.610780268999918],
              [-47.54300873699992, -0.627006898999923],
              [-47.534494594999956, -0.637302341999941],
              [-47.529408331999946, -0.646091403999947],
              [-47.527414516999954, -0.65748463299991],
              [-47.523996548999946, -0.669122002999927],
              [-47.51943925699993, -0.676039320999962],
              [-47.50914466099994, -0.687269789999959],
              [-47.49327551999994, -0.712090752999927],
              [-47.48737545499995, -0.728285414999959],
              [-47.48766028599994, -0.745700778999947],
              [-47.49669348899994, -0.764743747999944],
              [-47.42406165299991, -0.764743747999944],
              [-47.40859941299993, -0.771091403999947],
              [-47.406361456999946, -0.801446221999925],
              [-47.39305579299992, -0.812595309999949],
              [-47.39305579299992, -0.800713799999926],
              [-47.39085852799991, -0.789727471999925],
              [-47.38634192599994, -0.779961846999925],
              [-47.37938391799992, -0.770928643999923],
              [-47.38491777299993, -0.767185153999947],
              [-47.38927161399994, -0.762627862999921],
              [-47.39199785099993, -0.756280205999929],
              [-47.39305579299992, -0.747165622999944],
              [-47.414133266999954, -0.736911716999941],
              [-47.438791469999956, -0.703301690999922],
              [-47.44831295499995, -0.695896091999941],
              [-47.45103919199994, -0.707126559999949],
              [-47.45470130099994, -0.716566664999959],
              [-47.460194464999915, -0.724541924999926],
              [-47.468739386999914, -0.730645440999922],
              [-47.470041469999956, -0.621840101999908],
              [-47.46442623599995, -0.60906340899993],
              [-47.44831295499995, -0.60711028399993],
              [-47.46190344999991, -0.592868747999944],
              [-47.44640051999994, -0.585137627999927],
              [-47.43016516799992, -0.580010674999926],
              [-47.41437740799995, -0.581231377999927],
              [-47.39981035099993, -0.592868747999944],
              [-47.40453040299991, -0.599786065999922],
              [-47.40965735599991, -0.609795830999929],
              [-47.414133266999954, -0.613946221999925],
              [-47.41002356699994, -0.628350518999923],
              [-47.41470292899993, -0.661309502999927],
              [-47.40733801999994, -0.681573174999926],
              [-47.40880286399994, -0.670098565999922],
              [-47.40729732999995, -0.660251559999949],
              [-47.40217037699995, -0.652520440999922],
              [-47.39305579299992, -0.64812590899993],
              [-47.390288865999935, -0.661553643999923],
              [-47.38573157499991, -0.672784112999921],
              [-47.37804114499994, -0.679864190999922],
              [-47.36571204299992, -0.681573174999926],
              [-47.36571204299992, -0.676039320999962],
              [-47.37401282499991, -0.670342705999929],
              [-47.38023841099994, -0.658868096999925],
              [-47.38109290299991, -0.645440362999921],
              [-47.373158331999946, -0.633884372999944],
              [-47.359445766999954, -0.630954684999949],
              [-47.34642493399991, -0.637302341999941],
              [-47.32469641799992, -0.654880466999941],
              [-47.326283331999946, -0.639092705999929],
              [-47.33267167899993, -0.629164320999962],
              [-47.34019934799994, -0.620212497999944],
              [-47.34520423099991, -0.60711028399993],
              [-47.32884680899991, -0.613457940999922],
              [-47.31663977799991, -0.607598565999922],
              [-47.305897589999915, -0.597914320999962],
              [-47.29401607999995, -0.592868747999944],
              [-47.27912350199995, -0.599216403999947],
              [-47.27708899599992, -0.614190362999921],
              [-47.27904212099992, -0.63250090899993],
              [-47.27635657499991, -0.64812590899993],
              [-47.269520636999914, -0.64812590899993],
              [-47.257883266999954, -0.640883070999962],
              [-47.25080318899995, -0.647067966999941],
              [-47.24958248599995, -0.660577080999929],
              [-47.255848761999914, -0.676039320999962],
              [-47.23875891799992, -0.664727471999925],
              [-47.234486456999946, -0.651055596999925],
              [-47.23766028599994, -0.635837497999944],
              [-47.24278723899994, -0.620212497999944],
              [-47.198109503999945, -0.651543877999927],
              [-47.194569464999915, -0.663832289999959],
              [-47.19994055899991, -0.676934502999927],
              [-47.20860755099994, -0.681817315999922],
              [-47.21548417899993, -0.669122002999927],
              [-47.222320115999935, -0.669122002999927],
              [-47.22533118399991, -0.679620049999926],
              [-47.23062089799993, -0.687269789999959],
              [-47.23851477799991, -0.69264088299991],
              [-47.24901282499991, -0.695896091999941],
              [-47.24901282499991, -0.702732028999947],
              [-47.23595130099994, -0.716403903999947],
              [-47.22911536399994, -0.716403903999947],
              [-47.22223873599995, -0.702325127999927],
              [-47.208241339999915, -0.699151299999926],
              [-47.19090735599991, -0.70281340899993],
              [-47.173939581999946, -0.709567966999941],
              [-47.17406165299991, -0.698825778999947],
              [-47.171986456999946, -0.692152601999908],
              [-47.167632615999935, -0.68718840899993],
              [-47.16087805899991, -0.681573174999926],
              [-47.15489661399994, -0.697523695999962],
              [-47.15420488199993, -0.713311455999929],
              [-47.15843665299991, -0.728773695999962],
              [-47.16710364499994, -0.743747653999947],
              [-47.17365475199995, -0.748467705999929],
              [-47.19090735599991, -0.756280205999929],
              [-47.19440670499995, -0.76100025799991],
              [-47.19082597599993, -0.770196221999925],
              [-47.18272864499994, -0.769707940999922],
              [-47.17357337099992, -0.764092705999929],
              [-47.16710364499994, -0.757256768999923],
              [-47.15575110599991, -0.764092705999929],
              [-47.14801998599995, -0.774102471999925],
              [-47.14305579299992, -0.786065362999921],
              [-47.13975989499994, -0.798923434999949],
              [-47.13467363199993, -0.78053150799991],
              [-47.13853919199994, -0.759698174999926],
              [-47.139556443999936, -0.741387627999927],
              [-47.12608801999994, -0.730645440999922],
              [-47.12474524599992, -0.73796965899993],
              [-47.120757615999935, -0.745049737999921],
              [-47.11929277299993, -0.750583591999941],
              [-47.115223761999914, -0.74187590899993],
              [-47.11571204299992, -0.736504815999922],
              [-47.11790930899991, -0.730645440999922],
              [-47.11929277299993, -0.719821872999944],
              [-47.11782792899993, -0.713148695999962],
              [-47.109934048999946, -0.70281340899993],
              [-47.10562089799993, -0.695896091999941],
              [-47.10289466099994, -0.674981377999927],
              [-47.09898841099994, -0.665622653999947],
              [-47.08824622299994, -0.661716403999947],
              [-47.07754472599993, -0.66570403399993],
              [-47.07306881399995, -0.675225518999923],
              [-47.07359778599994, -0.686455987999921],
              [-47.07835852799991, -0.695896091999941],
              [-47.075510219999956, -0.697686455999929],
              [-47.07371985599991, -0.697360934999949],
              [-47.07258053299995, -0.697930596999925],
              [-47.071522589999915, -0.702732028999947],
              [-47.07970130099994, -0.709649346999925],
              [-47.07966061099995, -0.735935153999947],
              [-47.084543423999946, -0.750583591999941],
              [-47.07835852799991, -0.757256768999923],
              [-47.071522589999915, -0.743747653999947],
              [-47.06598873599995, -0.759698174999926],
              [-47.06468665299991, -0.77703215899993],
              [-47.059885219999956, -0.789646091999941],
              [-47.04356848899994, -0.791436455999929],
              [-47.05426998599995, -0.802829684999949],
              [-47.073475714999915, -0.815362237999921],
              [-47.07835852799991, -0.826267184999949],
              [-47.07656816299993, -0.836602471999925],
              [-47.062611456999946, -0.855889580999929],
              [-47.057199673999946, -0.867120049999926],
              [-47.05418860599991, -0.856540622999944],
              [-47.05101477799991, -0.819431247999944],
              [-47.047759568999936, -0.810723565999922],
              [-47.04234778599994, -0.800713799999926],
              [-47.036000128999945, -0.791680596999925],
              [-47.02989661399994, -0.785251559999949],
              [-47.02611243399991, -0.787692966999941],
              [-47.01622473899994, -0.791436455999929],
              [-47.01659094999991, -0.770114841999941],
              [-47.01524817599994, -0.760023695999962],
              [-47.00841223899994, -0.757256768999923],
              [-46.99266516799992, -0.757256768999923],
              [-46.98460852799991, -0.749200127999927],
              [-46.97736568899995, -0.730564059999949],
              [-46.96910559799994, -0.695896091999941],
              [-46.95685787699995, -0.710137627999927],
              [-46.957020636999914, -0.735446872999944],
              [-46.96910559799994, -0.785251559999949],
              [-46.96165930899991, -0.785251559999949],
              [-46.95482337099992, -0.770928643999923],
              [-46.94627844999991, -0.776055596999925],
              [-46.94249426999994, -0.782403252999927],
              [-46.94286048099991, -0.790134372999944],
              [-46.947377081999946, -0.798923434999949],
              [-46.92808997299994, -0.798923434999949],
              [-46.93150794199994, -0.804945570999962],
              [-46.93785559799994, -0.820407809999949],
              [-46.94115149599992, -0.826267184999949],
              [-46.93309485599991, -0.823011976999908],
              [-46.931304490999935, -0.82195403399993],
              [-46.92808997299994, -0.819431247999944],
              [-46.92223059799994, -0.834567966999941],
              [-46.93032792899993, -0.842868747999944],
              [-46.94395911399994, -0.847832940999922],
              [-46.95482337099992, -0.853610934999949],
              [-46.963002081999946, -0.865004164999959],
              [-46.96837317599994, -0.879652601999908],
              [-46.96499589799993, -0.893324476999908],
              [-46.947377081999946, -0.901299737999921],
              [-46.94863847599993, -0.884698174999926],
              [-46.95164954299992, -0.871677341999941],
              [-46.94912675699993, -0.861504815999922],
              [-46.93431555899991, -0.853610934999949],
              [-46.911773240999935, -0.860039971999925],
              [-46.90078691299993, -0.857354424999926],
              [-46.90021725199995, -0.839288018999923],
              [-46.89273027299993, -0.846774997999944],
              [-46.89134680899991, -0.834161065999922],
              [-46.89273027299993, -0.785251559999949],
              [-46.884022589999915, -0.789971612999921],
              [-46.87767493399991, -0.795668226999908],
              [-46.873931443999936, -0.802911065999922],
              [-46.87287350199995, -0.812595309999949],
              [-46.86538652299993, -0.812595309999949],
              [-46.86168372299994, -0.806084893999923],
              [-46.85899817599994, -0.802504164999959],
              [-46.85464433499993, -0.800551039999959],
              [-46.84557044199994, -0.798923434999949],
              [-46.84984290299991, -0.791273695999962],
              [-46.85594641799992, -0.785577080999929],
              [-46.86363684799994, -0.781345309999949],
              [-46.87287350199995, -0.778415622999944],
              [-46.858631964999915, -0.765720309999949],
              [-46.832915818999936, -0.730075778999947],
              [-46.81822669199994, -0.723239841999941],
              [-46.81822669199994, -0.716403903999947],
              [-46.831288214999915, -0.709567966999941],
              [-46.819203253999945, -0.711683851999908],
              [-46.80919348899994, -0.717217705999929],
              [-46.80150305899991, -0.725762627999927],
              [-46.796538865999935, -0.736911716999941],
              [-46.80809485599991, -0.740004164999959],
              [-46.81086178299995, -0.746677341999941],
              [-46.80638587099992, -0.755466403999947],
              [-46.796538865999935, -0.764743747999944],
              [-46.811431443999936, -0.770684502999927],
              [-46.81822669199994, -0.770928643999923],
              [-46.81822669199994, -0.778415622999944],
              [-46.81191972599993, -0.78484465899993],
              [-46.813343878999945, -0.790785414999959],
              [-46.82046464799993, -0.795668226999908],
              [-46.831288214999915, -0.798923434999949],
              [-46.831288214999915, -0.805108330999929],
              [-46.82127844999991, -0.807793877999927],
              [-46.81786048099991, -0.81414153399993],
              [-46.81944739499994, -0.822930596999925],
              [-46.82445227799991, -0.833103122999944],
              [-46.81297766799992, -0.829847914999959],
              [-46.80443274599992, -0.825127862999921],
              [-46.798939581999946, -0.817152601999908],
              [-46.796538865999935, -0.805108330999929],
              [-46.790353969999956, -0.805108330999929],
              [-46.79759680899991, -0.860528252999927],
              [-46.79930579299992, -0.862481377999927],
              [-46.799672003999945, -0.865166924999926],
              [-46.796538865999935, -0.874607028999947],
              [-46.78555253799993, -0.893975518999923],
              [-46.782866990999935, -0.901299737999921],
              [-46.778635219999956, -0.885837497999944],
              [-46.78335527299993, -0.874444268999923],
              [-46.786366339999915, -0.862725518999923],
              [-46.776682094999956, -0.846774997999944],
              [-46.76988684799994, -0.846774997999944],
              [-46.76988684799994, -0.867120049999926],
              [-46.75963294199994, -0.861504815999922],
              [-46.75560462099992, -0.850192966999941],
              [-46.755523240999935, -0.819431247999944],
              [-46.74510657499991, -0.829278252999927],
              [-46.719634568999936, -0.864841403999947],
              [-46.71458899599992, -0.877699476999908],
              [-46.718739386999914, -0.894626559999949],
              [-46.74937903599994, -0.942966403999947],
              [-46.733265753999945, -0.93092213299991],
              [-46.70929928299995, -0.889825127999927],
              [-46.69786536399994, -0.880791924999926],
              [-46.69904537699995, -0.86842213299991],
              [-46.69762122299994, -0.843845309999949],
              [-46.688710089999915, -0.825778903999947],
              [-46.66738847599993, -0.833103122999944],
              [-46.66063391799992, -0.844903252999927],
              [-46.65990149599992, -0.855889580999929],
              [-46.65697180899991, -0.863946221999925],
              [-46.64321855399993, -0.867120049999926],
              [-46.63267981699994, -0.863213799999926],
              [-46.63516191299993, -0.853285414999959],
              [-46.65673278699995, -0.81397299799994],
              [-46.655913408999936, -0.80182041799992],
              [-46.63808735999993, -0.801853370999936],
              [-46.6137962329999, -0.81323567499993],
              [-46.598540818999936, -0.867120049999926],
              [-46.62246660099993, -0.898044528999947],
              [-46.62645423099991, -0.908786716999941],
              [-46.61900794199994, -0.908786716999941],
              [-46.611398891999954, -0.903903903999947],
              [-46.60875403599994, -0.911065362999921],
              [-46.611317511999914, -0.924004815999922],
              [-46.61900794199994, -0.935479424999926],
              [-46.63263912699995, -0.943454684999949],
              [-46.64622962099992, -0.945407809999949],
              [-46.65656490799995, -0.93914153399993],
              [-46.66002356699994, -0.922458591999941],
              [-46.66738847599993, -0.922458591999941],
              [-46.673085089999915, -0.936618747999944],
              [-46.68228105399993, -0.946709893999923],
              [-46.723540818999936, -0.972832940999922],
              [-46.73745683499993, -0.984307549999926],
              [-46.74705969999991, -0.999118747999944],
              [-46.74937903599994, -1.018649997999944],
              [-46.73814856699994, -1.001560153999947],
              [-46.720692511999914, -0.983982028999947],
              [-46.700428839999915, -0.969903252999927],
              [-46.68106035099993, -0.963474216999941],
              [-46.67723548099991, -0.965590101999908],
              [-46.653664335999906, -0.967025346999947],
              [-46.626116777999925, -0.962203237999915],
              [-46.605054684999914, -0.956563928999913],
              [-46.58159082599991, -0.970355834999907],
              [-46.56456228499991, -0.95095041299993],
              [-46.56129463399992, -0.928289615999915],
              [-46.5458934909999, -0.913739662999944],
              [-46.51835175499991, -0.900823914999933],
              [-46.502948111999956, -0.883843570999943],
              [-46.48755809799991, -0.879005632999906],
              [-46.475422039999955, -0.883877274999918],
              [-46.465696289999926, -0.876602409999919],
              [-46.44706800599994, -0.872575887999915],
              [-46.4276291299999, -0.868549980999944],
              [-46.416309164999916, -0.880708042999913],
              [-46.42118662599995, -0.894466062999925],
              [-46.438201798999955, -0.902541997999947],
              [-46.46087818199993, -0.906561914999941],
              [-46.48032684499992, -0.919490906999954],
              [-46.47306314499991, -0.936498756999924],
              [-46.47713306199995, -0.952682196999945],
              [-46.489292390999935, -0.964806755999916],
              [-46.48849712599991, -0.976139198999931],
              [-46.471506992999934, -0.98587640799991],
              [-46.47558130199991, -1.006917264999913],
              [-46.48009192599994, -1.022230726999908],
              [-46.466786261999914, -1.02312590899993],
              [-46.46271725199995, -1.031670830999929],
              [-46.47500566299993, -1.045342705999929],
              [-46.46458899599992, -1.045830987999921],
              [-46.453195766999954, -1.043552341999941],
              [-46.44408118399991, -1.037774346999925],
              [-46.440297003999945, -1.028252862999921],
              [-46.435658331999946, -1.023858330999929],
              [-46.425119594999956, -1.028741143999923],
              [-46.413726365999935, -1.036065362999921],
              [-46.40672766799992, -1.039157809999949],
              [-46.392689581999946, -1.027113539999959],
              [-46.38451087099992, -1.009860934999949],
              [-46.364898240999935, -1.008396091999941],
              [-46.36705481699994, -1.025485934999949],
              [-46.365793423999946, -1.045342705999929],
              [-46.36119544199994, -1.067315362999921],
              [-46.35651607999995, -1.075290622999944],
              [-46.35293535099993, -1.069105726999908],
              [-46.35147050699993, -1.049004815999922],
              [-46.34618079299992, -1.033949476999908],
              [-46.33446204299992, -1.022149346999925],
              [-46.32266191299993, -1.020277601999908],
              [-46.31737219999991, -1.035332940999922],
              [-46.31737219999991, -1.073337497999944],
              [-46.31899980399993, -1.081475518999923],
              [-46.324330206999946, -1.09734465899993],
              [-46.32481848899994, -1.107354424999926],
              [-46.30955969999991, -1.095879815999922],
              [-46.30125891799992, -1.079196872999944],
              [-46.29767818899995, -1.057712497999944],
              [-46.296864386999914, -1.031670830999929],
              [-46.29002844999991, -1.031670830999929],
              [-46.28062903599994, -1.048923434999949],
              [-46.25625566299993, -1.077080987999921],
              [-46.24844316299993, -1.093682549999926],
              [-46.254017706999946, -1.07740650799991],
              [-46.27110755099994, -1.053643487999921],
              [-46.27635657499991, -1.039157809999949],
              [-46.27904212099992, -1.036553643999923],
              [-46.283314581999946, -1.029392184999949],
              [-46.283314581999946, -1.022067966999941],
              [-46.26414954299992, -1.016696872999944],
              [-46.27465078999995, -1.005538991999913],
              [-46.28147903099995, -0.997448503999919],
              [-46.278978511999924, -0.986260995999942],
              [-46.267769363999946, -0.971353688999955],
              [-46.26214681399995, -0.950220064999939],
              [-46.25030825999994, -0.93095483299993],
              [-46.23424231699994, -0.917087497999944],
              [-46.20030676999994, -0.907647393999923],
              [-46.17178300699993, -0.920993747999944],
              [-46.173939581999946, -0.956638278999947],
              [-46.18016516799992, -0.956638278999947],
              [-46.190012173999946, -0.959161065999922],
              [-46.20348059799994, -0.976332289999959],
              [-46.21556555899991, -0.99732838299991],
              [-46.22118079299992, -1.011163018999923],
              [-46.20571855399993, -1.006605726999908],
              [-46.19859778599994, -1.010511976999908],
              [-46.201242641999954, -1.018243096999925],
              [-46.214955206999946, -1.024834893999923],
              [-46.21328691299993, -1.02857838299991],
              [-46.21231035099993, -1.031833591999941],
              [-46.21080481699994, -1.035088799999926],
              [-46.20750891799992, -1.039157809999949],
              [-46.211781378999945, -1.04420338299991],
              [-46.21703040299991, -1.053887627999927],
              [-46.22118079299992, -1.059014580999929],
              [-46.211496548999946, -1.074802341999941],
              [-46.26211503799993, -1.183200778999947],
              [-46.230539516999954, -1.14771900799991],
              [-46.22118079299992, -1.141534112999921],
              [-46.20885169199994, -1.143161716999941],
              [-46.19603430899991, -1.149346612999921],
              [-46.18211829299992, -1.153252862999921],
              [-46.16649329299992, -1.148370049999926],
              [-46.15542558499993, -1.126153252999927],
              [-46.14708411399994, -1.114190362999921],
              [-46.139230923999946, -1.113539320999962],
              [-46.13630123599995, -1.126071872999944],
              [-46.144520636999914, -1.16139088299991],
              [-46.14606686099995, -1.176364841999941],
              [-46.132801886999914, -1.163995049999926],
              [-46.12682044199994, -1.146091403999947],
              [-46.12559973899994, -1.103936455999929],
              [-46.12262936099995, -1.095310153999947],
              [-46.11571204299992, -1.085056247999944],
              [-46.10773678299995, -1.076755466999941],
              [-46.101673956999946, -1.073337497999944],
              [-46.09390214799993, -1.07586028399993],
              [-46.09048417899993, -1.082452080999929],
              [-46.08836829299992, -1.091241143999923],
              [-46.08458411399994, -1.100518487999921],
              [-46.068470831999946, -1.130466403999947],
              [-46.06468665299991, -1.147637627999927],
              [-46.07408606699994, -1.155205987999921],
              [-46.08556067599994, -1.162041924999926],
              [-46.09410559799994, -1.178317966999941],
              [-46.09532630099994, -1.19654713299991],
              [-46.08458411399994, -1.210381768999923],
              [-46.072377081999946, -1.201592705999929],
              [-46.06358801999994, -1.189629815999922],
              [-46.050445115999935, -1.162692966999941],
              [-46.04059811099995, -1.175225518999923],
              [-46.03970292899993, -1.187107028999947],
              [-46.044260219999956, -1.19850025799991],
              [-46.050445115999935, -1.210381768999923],
              [-46.03221594999991, -1.200778903999947],
              [-46.03010006399995, -1.184665622999944],
              [-46.03453528599994, -1.165785414999959],
              [-46.03620357999995, -1.148370049999926],
              [-46.031320766999954, -1.138441664999959],
              [-46.02330481699994, -1.127536716999941],
              [-46.01667232999995, -1.113213799999926],
              [-46.015736456999946, -1.093682549999926],
              [-46.00890051999994, -1.093682549999926],
              [-46.00885982999995, -1.098239841999941],
              [-46.00739498599995, -1.101169528999947],
              [-46.005116339999915, -1.103773695999962],
              [-46.00267493399991, -1.107354424999926],
              [-45.99083411399994, -1.104261976999908],
              [-45.9931339499999, -1.079090408999946],
              [-45.99258341099994, -1.067618006999908],
              [-45.97945403199992, -1.055083617999912],
              [-45.96415000199994, -1.063860776999945],
              [-45.964701454999954, -1.072598918999915],
              [-45.96108964799993, -1.086195570999962],
              [-45.969627068999955, -1.08679014899991],
              [-45.97443600199995, -1.091241143999923],
              [-45.96108964799993, -1.107354424999926],
              [-45.971913214999915, -1.111097914999959],
              [-45.97671464799993, -1.119398695999962],
              [-45.98159745999993, -1.141534112999921],
              [-45.971913214999915, -1.136976820999962],
              [-45.96275794199994, -1.135430596999925],
              [-45.95470130099994, -1.136895440999922],
              [-45.94806881399995, -1.141534112999921],
              [-45.96080481699994, -1.146091403999947],
              [-45.998890753999945, -1.151788018999923],
              [-46.00267493399991, -1.192803643999923],
              [-45.99795488199993, -1.201429945999962],
              [-45.98664303299995, -1.204034112999921],
              [-45.97297115799995, -1.205254815999922],
              [-45.96108964799993, -1.210381768999923],
              [-45.95571855399993, -1.21998463299991],
              [-45.955962693999936, -1.240411065999922],
              [-45.94806881399995, -1.251397393999923],
              [-45.93903561099995, -1.246270440999922],
              [-45.934478318999936, -1.240004164999959],
              [-45.93492591099994, -1.232517184999949],
              [-45.940663214999915, -1.223402601999908],
              [-45.936105923999946, -1.222751559999949],
              [-45.93301347599993, -1.221123955999929],
              [-45.930246548999946, -1.219008070999962],
              [-45.92638098899994, -1.217217705999929],
              [-45.930531378999945, -1.200941664999959],
              [-45.92332923099991, -1.173028252999927],
              [-45.91012489399992, -1.14094186899996],
              [-45.88988956299994, -1.090745169999934],
              [-45.867486913999926, -1.06347055699996],
              [-45.8538424219999, -1.067859856999917],
              [-45.853868819999946, -1.101172137999924],
              [-45.88524329299992, -1.140883070999962],
              [-45.89000403599994, -1.154392184999949],
              [-45.90021725199995, -1.167575778999947],
              [-45.90587317599994, -1.172539971999925],
              [-45.90721594999991, -1.197523695999962],
              [-45.90587317599994, -1.210381768999923],
              [-45.89801998599995, -1.183038018999923],
              [-45.891835089999915, -1.172051690999922],
              [-45.87922115799995, -1.162692966999941],
              [-45.882801886999914, -1.178806247999944],
              [-45.88536536399994, -1.183200778999947],
              [-45.87279212099992, -1.202243747999944],
              [-45.88060462099992, -1.219414971999925],
              [-45.89427649599992, -1.237074476999908],
              [-45.899647589999915, -1.257582289999959],
              [-45.87385006399995, -1.235446872999944],
              [-45.86485755099994, -1.230889580999929],
              [-45.86485755099994, -1.237074476999908],
              [-45.868478969999956, -1.244235934999949],
              [-45.86485755099994, -1.251397393999923],
              [-45.86485755099994, -1.257582289999959],
              [-45.87092037699995, -1.26336028399993],
              [-45.88145911399994, -1.277601820999962],
              [-45.88536536399994, -1.28484465899993],
              [-45.862538214999915, -1.27312590899993],
              [-45.84666907499991, -1.257012627999927],
              [-45.83836829299992, -1.234307549999926],
              [-45.83820553299995, -1.202894789999959],
              [-45.827381964999915, -1.218519789999959],
              [-45.82095292899993, -1.241794528999947],
              [-45.82054602799991, -1.262790622999944],
              [-45.82762610599991, -1.271905205999929],
              [-45.84056555899991, -1.279554945999962],
              [-45.83458411399994, -1.297133070999962],
              [-45.82095292899993, -1.31568775799991],
              [-45.81090247299994, -1.326429945999962],
              [-45.81948808499993, -1.29615650799991],
              [-45.809803839999915, -1.27507903399993],
              [-45.79369055899991, -1.267673434999949],
              [-45.78294837099992, -1.278008721999925],
              [-45.774322068999936, -1.264255466999941],
              [-45.768422003999945, -1.228773695999962],
              [-45.76244055899991, -1.210381768999923],
              [-45.74791419199994, -1.204034112999921],
              [-45.721587693999936, -1.134942315999922],
              [-45.70103919199994, -1.134698174999926],
              [-45.69603430899991, -1.160577080999929],
              [-45.72736568899995, -1.225681247999944],
              [-45.73452714799993, -1.251397393999923],
              [-45.72834225199995, -1.251397393999923],
              [-45.72691809799994, -1.247002862999921],
              [-45.72150631399995, -1.237074476999908],
              [-45.702951954999946, -1.222355766999954],
              [-45.68856755699994, -1.202188508999939],
              [-45.67965000599992, -1.209955486999945],
              [-45.6754049889999, -1.229359376999923],
              [-45.67269832699992, -1.24410116699994],
              [-45.67504797999993, -1.259230025999955],
              [-45.6645885179999, -1.268550851999919],
              [-45.654118224999934, -1.274379938999914],
              [-45.65957126299992, -1.29299218299991],
              [-45.65180882899995, -1.299986027999921],
              [-45.651054048999924, -1.317441322999912],
              [-45.6561057749999, -1.333347875999948],
              [-45.66348406199995, -1.346540233999917],
              [-45.67008578399992, -1.353910465999945],
              [-45.675535442999944, -1.366316418999929],
              [-45.640736456999946, -1.370538018999923],
              [-45.63231360599991, -1.367364190999922],
              [-45.62157141799992, -1.357191664999959],
              [-45.61636308499993, -1.348321221999925],
              [-45.61172441299993, -1.334567966999941],
              [-45.61046301999994, -1.320082289999959],
              [-45.61510169199994, -1.309177341999941],
              [-45.62295488199993, -1.295993747999944],
              [-45.619984503999945, -1.284274997999944],
              [-45.610259568999936, -1.275648695999962],
              [-45.59801184799994, -1.271905205999929],
              [-45.583241339999915, -1.274346612999921],
              [-45.57921301999994, -1.281508070999962],
              [-45.58462480399993, -1.289157809999949],
              [-45.59801184799994, -1.292413018999923],
              [-45.59410559799994, -1.294122002999927],
              [-45.59129798099991, -1.295993747999944],
              [-45.58824622299994, -1.297539971999925],
              [-45.58372962099992, -1.29851653399993],
              [-45.588002081999946, -1.307061455999929],
              [-45.58946692599994, -1.314222914999959],
              [-45.58812415299991, -1.320733330999929],
              [-45.58372962099992, -1.326429945999962],
              [-45.559803839999915, -1.283135674999926],
              [-45.543853318999936, -1.270277601999908],
              [-45.52969316299993, -1.28484465899993],
              [-45.54214433499993, -1.284763278999947],
              [-45.549387173999946, -1.289727471999925],
              [-45.55186926999994, -1.299411716999941],
              [-45.55020097599993, -1.31218840899993],
              [-45.54515540299991, -1.309991143999923],
              [-45.53551184799994, -1.30828215899993],
              [-45.52969316299993, -1.30592213299991],
              [-45.53673255099994, -1.318617445999962],
              [-45.54515540299991, -1.32740650799991],
              [-45.55101477799991, -1.337497653999947],
              [-45.55020097599993, -1.353773695999962],
              [-45.54637610599991, -1.351169528999947],
              [-45.53652910099993, -1.346368096999925],
              [-45.535715298999946, -1.336846612999921],
              [-45.52521725199995, -1.324883721999925],
              [-45.52285722599993, -1.31218840899993],
              [-45.51545162699995, -1.31218840899993],
              [-45.511789516999954, -1.353692315999922],
              [-45.51231848899994, -1.36060963299991],
              [-45.523426886999914, -1.385674737999921],
              [-45.529286261999914, -1.404473565999922],
              [-45.52969316299993, -1.415785414999959],
              [-45.51398678299995, -1.403497002999927],
              [-45.47134355399993, -1.350192966999941],
              [-45.46898352799991, -1.343194268999923],
              [-45.46849524599992, -1.33367278399993],
              [-45.466786261999914, -1.323011976999908],
              [-45.46080481699994, -1.31218840899993],
              [-45.45327714799993, -1.307061455999929],
              [-45.41982988199993, -1.292413018999923],
              [-45.44713294199994, -1.292413018999923],
              [-45.42837480399993, -1.28679778399993],
              [-45.415679490999935, -1.287692966999941],
              [-45.40851803299995, -1.296807549999926],
              [-45.40615800699993, -1.316013278999947],
              [-45.40721594999991, -1.325372002999927],
              [-45.41197669199994, -1.342705987999921],
              [-45.412993943999936, -1.350192966999941],
              [-45.417307094999956, -1.354180596999925],
              [-45.43602454299992, -1.353285414999959],
              [-45.440297003999945, -1.357191664999959],
              [-45.46304277299993, -1.36492278399993],
              [-45.46825110599991, -1.367445570999962],
              [-45.47305253799993, -1.375664971999925],
              [-45.473947719999956, -1.383721612999921],
              [-45.473500128999945, -1.392185153999947],
              [-45.47447669199994, -1.40162525799991],
              [-45.48452714799993, -1.430108330999929],
              [-45.48672441299993, -1.447198174999926],
              [-45.481312628999945, -1.463636976999908],
              [-45.50422115799995, -1.45867278399993],
              [-45.51829993399991, -1.46453215899993],
              [-45.54271399599992, -1.490980726999908],
              [-45.53107662699995, -1.489678643999923],
              [-45.52220618399991, -1.484144789999959],
              [-45.516835089999915, -1.475274346999925],
              [-45.51545162699995, -1.463636976999908],
              [-45.50177975199995, -1.46998463299991],
              [-45.496164516999954, -1.480889580999929],
              [-45.49864661399994, -1.493340752999927],
              [-45.50926673099991, -1.504571221999925],
              [-45.49840247299994, -1.50514088299991],
              [-45.49132239499994, -1.503350518999923],
              [-45.48619544199994, -1.498711846999925],
              [-45.481312628999945, -1.490980726999908],
              [-45.464507615999935, -1.500583591999941],
              [-45.46141516799992, -1.516289971999925],
              [-45.46312415299991, -1.533135674999926],
              [-45.46080481699994, -1.54615650799991],
              [-45.44912675699993, -1.528090101999908],
              [-45.44823157499991, -1.505059502999927],
              [-45.45457923099991, -1.460056247999944],
              [-45.45103919199994, -1.453708591999941],
              [-45.44249426999994, -1.443129164999959],
              [-45.43211829299992, -1.43328215899993],
              [-45.42332923099991, -1.428887627999927],
              [-45.418080206999946, -1.433851820999962],
              [-45.42031816299993, -1.44500090899993],
              [-45.42642167899993, -1.456801039999959],
              [-45.432932094999956, -1.463636976999908],
              [-45.423491990999935, -1.459079684999949],
              [-45.40851803299995, -1.445489190999922],
              [-45.40274003799993, -1.442559502999927],
              [-45.401275193999936, -1.437920830999929],
              [-45.38573157499991, -1.412204684999949],
              [-45.37954667899993, -1.393731377999927],
              [-45.355580206999946, -1.349541924999926],
              [-45.35464433499993, -1.336358330999929],
              [-45.360218878999945, -1.320245049999926],
              [-45.34683183499993, -1.311700127999927],
              [-45.326161261999914, -1.312920830999929],
              [-45.30996660099993, -1.326429945999962],
              [-45.30728105399993, -1.336032809999949],
              [-45.29629472599993, -1.415785414999959],
              [-45.30614173099991, -1.41139088299991],
              [-45.30996660099993, -1.408379815999922],
              [-45.322377081999946, -1.43678150799991],
              [-45.341867641999954, -1.453057549999926],
              [-45.36587480399993, -1.465915622999944],
              [-45.39195716099994, -1.484144789999959],
              [-45.38573157499991, -1.490980726999908],
              [-45.377837693999936, -1.479424737999921],
              [-45.369252081999946, -1.472832940999922],
              [-45.36017818899995, -1.471774997999944],
              [-45.35094153599994, -1.476739190999922],
              [-45.35850989499994, -1.489353122999944],
              [-45.36510169199994, -1.503838799999926],
              [-45.369699673999946, -1.519626559999949],
              [-45.37144934799994, -1.535332940999922],
              [-45.37873287699995, -1.540785414999959],
              [-45.392567511999914, -1.548028252999927],
              [-45.400949673999946, -1.560153903999947],
              [-45.39195716099994, -1.580336195999962],
              [-45.38621985599991, -1.564385674999926],
              [-45.38499915299991, -1.555840752999927],
              [-45.38573157499991, -1.54615650799991],
              [-45.35106360599991, -1.559991143999923],
              [-45.34019934799994, -1.583184502999927],
              [-45.34337317599994, -1.611586195999962],
              [-45.35537675699993, -1.654229424999926],
              [-45.361398891999954, -1.668226820999962],
              [-45.36558997299994, -1.684747002999927],
              [-45.36461341099994, -1.703871351999908],
              [-45.35887610599991, -1.719414971999925],
              [-45.350168423999946, -1.730075778999947],
              [-45.33836829299992, -1.737888278999947],
              [-45.32363847599993, -1.744805596999925],
              [-45.284413214999915, -1.732191664999959],
              [-45.27122962099992, -1.721612237999921],
              [-45.27647864499994, -1.703871351999908],
              [-45.26207434799994, -1.695896091999941],
              [-45.22789466099994, -1.683038018999923],
              [-45.221262173999946, -1.672784112999921],
              [-45.22630774599992, -1.656508070999962],
              [-45.24941972599993, -1.62468840899993],
              [-45.25536048099991, -1.607598565999922],
              [-45.24746660099993, -1.579278252999927],
              [-45.22728430899991, -1.547458591999941],
              [-45.20417232999995, -1.525160414999959],
              [-45.179676886999914, -1.525648695999962],
              [-45.175852016999954, -1.500420830999929],
              [-45.16319739499994, -1.482842705999929],
              [-45.14867102799991, -1.481540622999944],
              [-45.138661261999914, -1.504571221999925],
              [-45.13182532499991, -1.504571221999925],
              [-45.12767493399991, -1.486993096999925],
              [-45.11583411399994, -1.47779713299991],
              [-45.10342363199993, -1.472588799999926],
              [-45.097727016999954, -1.467054945999962],
              [-45.09137936099995, -1.46412525799991],
              [-45.08141028599994, -1.471612237999921],
              [-45.08120683499993, -1.481133721999925],
              [-45.10456295499995, -1.484144789999959],
              [-45.07892818899995, -1.483575127999927],
              [-45.07184811099995, -1.47039153399993],
              [-45.07066809799994, -1.450290622999944],
              [-45.06297766799992, -1.428887627999927],
              [-45.06151282499991, -1.466403903999947],
              [-45.056752081999946, -1.476739190999922],
              [-45.049712693999936, -1.482191664999959],
              [-45.03868567599994, -1.48756275799991],
              [-45.02721106699994, -1.490166924999926],
              [-45.01891028599994, -1.48756275799991],
              [-45.006743943999936, -1.490655205999929],
              [-44.99644934799994, -1.508721612999921],
              [-44.998036261999914, -1.524021091999941],
              [-45.02196204299992, -1.518243096999925],
              [-45.00967363199993, -1.533298434999949],
              [-44.99522864499994, -1.535414320999962],
              [-44.980458136999914, -1.536065362999921],
              [-44.967355923999946, -1.54615650799991],
              [-44.967355923999946, -1.55242278399993],
              [-44.98497473899994, -1.561211846999925],
              [-45.00536048099991, -1.567559502999927],
              [-45.020375128999945, -1.578708591999941],
              [-45.02196204299992, -1.60084400799991],
              [-45.015736456999946, -1.60084400799991],
              [-45.00894120999993, -1.582696221999925],
              [-44.99583899599992, -1.581963799999926],
              [-44.967355923999946, -1.594008070999962],
              [-44.97175045499995, -1.57935963299991],
              [-44.96727454299992, -1.564629815999922],
              [-44.95946204299992, -1.549086195999962],
              [-44.95372473899994, -1.531914971999925],
              [-44.95384680899991, -1.501722914999959],
              [-44.94713294199994, -1.492771091999941],
              [-44.92638098899994, -1.490980726999908],
              [-44.92638098899994, -1.484144789999959],
              [-44.93382727799991, -1.484144789999959],
              [-44.93382727799991, -1.476739190999922],
              [-44.91563880099994, -1.468682549999926],
              [-44.895090298999946, -1.456231377999927],
              [-44.878244594999956, -1.441176039999959],
              [-44.871205206999946, -1.42546965899993],
              [-44.868031378999945, -1.421319268999923],
              [-44.86119544199994, -1.426934502999927],
              [-44.854359503999945, -1.437107028999947],
              [-44.85130774599992, -1.446221612999921],
              [-44.84951738199993, -1.47625090899993],
              [-44.85130774599992, -1.484144789999959],
              [-44.856678839999915, -1.489353122999944],
              [-44.87572180899991, -1.498467705999929],
              [-44.88536536399994, -1.504571221999925],
              [-44.891468878999945, -1.512139580999929],
              [-44.897043423999946, -1.528008721999925],
              [-44.91307532499991, -1.547946872999944],
              [-44.91950436099995, -1.562758070999962],
              [-44.91978919199994, -1.580336195999962],
              [-44.912098761999914, -1.60084400799991],
              [-44.92625891799992, -1.601169528999947],
              [-44.943918423999946, -1.59734465899993],
              [-44.95372473899994, -1.60084400799991],
              [-44.93932044199994, -1.61101653399993],
              [-44.92174231699994, -1.629571221999925],
              [-44.915272589999915, -1.647230726999908],
              [-44.93382727799991, -1.655450127999927],
              [-44.91812089799993, -1.65748463299991],
              [-44.91193600199995, -1.65357838299991],
              [-44.90306555899991, -1.62468840899993],
              [-44.90371660099993, -1.617120049999926],
              [-44.90029863199993, -1.609795830999929],
              [-44.88536536399994, -1.60084400799991],
              [-44.873158331999946, -1.612888278999947],
              [-44.86115475199995, -1.63014088299991],
              [-44.84740149599992, -1.641289971999925],
              [-44.830189581999946, -1.634942315999922],
              [-44.84740149599992, -1.629001559999949],
              [-44.85069739499994, -1.616143487999921],
              [-44.84544837099992, -1.600681247999944],
              [-44.83702551999994, -1.586602471999925],
              [-44.84447180899991, -1.586602471999925],
              [-44.84239661399994, -1.581475518999923],
              [-44.84007727799991, -1.57740650799991],
              [-44.83804277299993, -1.572849216999941],
              [-44.83702551999994, -1.56609465899993],
              [-44.82290605399993, -1.57586028399993],
              [-44.81407630099994, -1.591241143999923],
              [-44.80996660099993, -1.609470309999949],
              [-44.81037350199995, -1.628106377999927],
              [-44.803618943999936, -1.609307549999926],
              [-44.80288652299993, -1.60084400799991],
              [-44.79181881399995, -1.61842213299991],
              [-44.79572506399995, -1.630059502999927],
              [-44.80508378799993, -1.639743747999944],
              [-44.81037350199995, -1.65203215899993],
              [-44.80638587099992, -1.65943775799991],
              [-44.787953253999945, -1.673028252999927],
              [-44.78237870999993, -1.682793877999927],
              [-44.78538977799991, -1.684177341999941],
              [-44.80288652299993, -1.703871351999908],
              [-44.79552161399994, -1.710137627999927],
              [-44.77749589799993, -1.720635674999926],
              [-44.77318274599992, -1.72429778399993],
              [-44.786366339999915, -1.737725518999923],
              [-44.794992641999954, -1.742771091999941],
              [-44.80288652299993, -1.75164153399993],
              [-44.80768795499995, -1.748467705999929],
              [-44.81078040299991, -1.74773528399993],
              [-44.82404537699995, -1.75164153399993],
              [-44.823150193999936, -1.756280205999929],
              [-44.821929490999935, -1.759209893999923],
              [-44.816517706999946, -1.76531340899993],
              [-44.773996548999946, -1.740655205999929],
              [-44.76781165299991, -1.726983330999929],
              [-44.77554277299993, -1.703871351999908],
              [-44.74205481699994, -1.719496351999908],
              [-44.72496497299994, -1.723402601999908],
              [-44.707875128999945, -1.717461846999925],
              [-44.72061113199993, -1.749607028999947],
              [-44.750843878999945, -1.77312590899993],
              [-44.81037350199995, -1.805759372999944],
              [-44.81037350199995, -1.813164971999925],
              [-44.79515540299991, -1.807549737999921],
              [-44.75682532499991, -1.801853122999944],
              [-44.74449622299994, -1.796075127999927],
              [-44.730458136999914, -1.785821221999925],
              [-44.72305253799993, -1.791273695999962],
              [-44.717355923999946, -1.803480726999908],
              [-44.707875128999945, -1.813164971999925],
              [-44.679351365999935, -1.811130466999941],
              [-44.66258704299992, -1.785414320999962],
              [-44.65465247299994, -1.749769789999959],
              [-44.65269934799994, -1.717461846999925],
              [-44.59801184799994, -1.744805596999925],
              [-44.61424719999991, -1.753676039999959],
              [-44.62523352799991, -1.76336028399993],
              [-44.632883266999954, -1.775648695999962],
              [-44.63902747299994, -1.79265715899993],
              [-44.640736456999946, -1.808200778999947],
              [-44.640614386999914, -1.821872653999947],
              [-44.64476477799991, -1.831149997999944],
              [-44.65953528599994, -1.833591403999947],
              [-44.65953528599994, -1.839776299999926],
              [-44.648996548999946, -1.837009372999944],
              [-44.63267981699994, -1.828057549999926],
              [-44.62100175699993, -1.826104424999926],
              [-44.61237545499995, -1.82976653399993],
              [-44.60680091099994, -1.837497653999947],
              [-44.60265051999994, -1.844821872999944],
              [-44.59801184799994, -1.847263278999947],
              [-44.591867641999954, -1.840427341999941],
              [-44.58922278599994, -1.828871351999908],
              [-44.584828253999945, -1.817966403999947],
              [-44.57323157499991, -1.813164971999925],
              [-44.565012173999946, -1.818454684999949],
              [-44.564442511999914, -1.830743096999925],
              [-44.56899980399993, -1.844414971999925],
              [-44.57632402299993, -1.854099216999941],
              [-44.57013912699995, -1.860935153999947],
              [-44.56236731699994, -1.850681247999944],
              [-44.55382239499994, -1.844414971999925],
              [-44.546538865999935, -1.837823174999926],
              [-44.54283606699994, -1.826104424999926],
              [-44.53575598899994, -1.82935963299991],
              [-44.530181443999936, -1.833754164999959],
              [-44.52570553299995, -1.839776299999926],
              [-44.52171790299991, -1.847263278999947],
              [-44.537668423999946, -1.86492278399993],
              [-44.578236456999946, -1.886814059999949],
              [-44.59064693899995, -1.901788018999923],
              [-44.571156378999945, -1.900567315999922],
              [-44.53661048099991, -1.89185963299991],
              [-44.52171790299991, -1.895114841999941],
              [-44.51309160099993, -1.904554945999962],
              [-44.50666256399995, -1.920098565999922],
              [-44.50259355399993, -1.937595309999949],
              [-44.501210089999915, -1.953383070999962],
              [-44.49913489499994, -1.961521091999941],
              [-44.490223761999914, -1.977959893999923],
              [-44.48814856699994, -1.987481377999927],
              [-44.490223761999914, -1.99537525799991],
              [-44.494699673999946, -2.000095309999949],
              [-44.49913489499994, -2.003838799999926],
              [-44.501210089999915, -2.008396091999941],
              [-44.50959225199995, -2.015557549999926],
              [-44.528553839999915, -2.017754815999922],
              [-44.549387173999946, -2.016045830999929],
              [-44.56330318899995, -2.011651299999926],
              [-44.57457434799994, -2.024021091999941],
              [-44.58812415299991, -2.030694268999923],
              [-44.617298956999946, -2.038995049999926],
              [-44.611439581999946, -2.039808851999908],
              [-44.60680091099994, -2.039808851999908],
              [-44.60265051999994, -2.041192315999922],
              [-44.59801184799994, -2.045830987999921],
              [-44.580962693999936, -2.034763278999947],
              [-44.56135006399995, -2.029554945999962],
              [-44.541005011999914, -2.029229424999926],
              [-44.52171790299991, -2.032321872999944],
              [-44.50450598899994, -2.031996351999908],
              [-44.49624589799993, -2.035577080999929],
              [-44.49437415299991, -2.045830987999921],
              [-44.500559048999946, -2.054457289999959],
              [-44.53538977799991, -2.080010674999926],
              [-44.55406653599994, -2.08717213299991],
              [-44.57884680899991, -2.12232838299991],
              [-44.60789954299992, -2.153741143999923],
              [-44.63902747299994, -2.148858330999929],
              [-44.64525305899991, -2.155694268999923],
              [-44.63219153599994, -2.159763278999947],
              [-44.616444464999915, -2.159356377999927],
              [-44.60338294199994, -2.157159112999921],
              [-44.59801184799994, -2.155694268999923],
              [-44.58861243399991, -2.165459893999923],
              [-44.594309048999946, -2.174248955999929],
              [-44.617298956999946, -2.189873955999929],
              [-44.65542558499993, -2.231133721999925],
              [-44.67625891799992, -2.239841403999947],
              [-44.707875128999945, -2.23756275799991],
              [-44.70103919199994, -2.244398695999962],
              [-44.69749915299991, -2.250420830999929],
              [-44.69359290299991, -2.265557549999926],
              [-44.733265753999945, -2.253350518999923],
              [-44.75137285099993, -2.252048434999949],
              [-44.76968339799993, -2.259698174999926],
              [-44.78473873599995, -2.275160414999959],
              [-44.80117753799993, -2.285739841999941],
              [-44.82404537699995, -2.279229424999926],
              [-44.80431067599994, -2.291436455999929],
              [-44.759429490999935, -2.274834893999923],
              [-44.71784420499995, -2.265557549999926],
              [-44.707875128999945, -2.299737237999921],
              [-44.700510219999956, -2.299737237999921],
              [-44.69322669199994, -2.285414320999962],
              [-44.67926998599995, -2.273858330999929],
              [-44.66563880099994, -2.270928643999923],
              [-44.65953528599994, -2.282647393999923],
              [-44.66185462099992, -2.296482028999947],
              [-44.66746985599991, -2.305271091999941],
              [-44.67418372299994, -2.31218840899993],
              [-44.68000240799995, -2.320896091999941],
              [-44.68809973899994, -2.34343840899993],
              [-44.69212805899991, -2.348077080999929],
              [-44.70421301999994, -2.358086846999925],
              [-44.71084550699993, -2.368340752999927],
              [-44.71519934799994, -2.392836195999962],
              [-44.72093665299991, -2.402113539999959],
              [-44.714100714999915, -2.408949476999908],
              [-44.71129309799994, -2.396905205999929],
              [-44.70718339799993, -2.388441664999959],
              [-44.70140540299991, -2.381768487999921],
              [-44.67430579299992, -2.360121351999908],
              [-44.66397050699993, -2.35670338299991],
              [-44.65953528599994, -2.364353122999944],
              [-44.66470292899993, -2.40398528399993],
              [-44.66348222599993, -2.420586846999925],
              [-44.65269934799994, -2.429457289999959],
              [-44.655588344999956, -2.420179945999962],
              [-44.656239386999914, -2.40748463299991],
              [-44.65416419199994, -2.394463799999926],
              [-44.64403235599991, -2.374769789999959],
              [-44.64598548099991, -2.36646900799991],
              [-44.65025794199994, -2.358819268999923],
              [-44.65269934799994, -2.35125090899993],
              [-44.65225175699993, -2.327894789999959],
              [-44.64976966099994, -2.308770440999922],
              [-44.64354407499991, -2.290785414999959],
              [-44.63158118399991, -2.271742445999962],
              [-44.584828253999945, -2.23015715899993],
              [-44.57323157499991, -2.224053643999923],
              [-44.56224524599992, -2.221774997999944],
              [-44.554025844999956, -2.216403903999947],
              [-44.54283606699994, -2.203545830999929],
              [-44.54515540299991, -2.204034112999921],
              [-44.54283606699994, -2.189873955999929],
              [-44.53978430899991, -2.185723565999922],
              [-44.533273891999954, -2.181084893999923],
              [-44.52916419199994, -2.176202080999929],
              [-44.497303839999915, -2.147881768999923],
              [-44.46165930899991, -2.144626559999949],
              [-44.42711341099994, -2.162367445999962],
              [-44.39879309799994, -2.197360934999949],
              [-44.38975989499994, -2.218357028999947],
              [-44.385609503999945, -2.23796965899993],
              [-44.38451087099992, -2.275567315999922],
              [-44.38182532499991, -2.277601820999962],
              [-44.36896725199995, -2.292738539999959],
              [-44.36465410099993, -2.299737237999921],
              [-44.36245683499993, -2.310316664999959],
              [-44.36359615799995, -2.333916924999926],
              [-44.37340247299994, -2.377373955999929],
              [-44.38231360599991, -2.394789320999962],
              [-44.395375128999945, -2.402113539999959],
              [-44.43073482999995, -2.406914971999925],
              [-44.45343990799995, -2.40748463299991],
              [-44.473947719999956, -2.402113539999959],
              [-44.48021399599992, -2.396579684999949],
              [-44.49071204299992, -2.383070570999962],
              [-44.49779212099992, -2.380466403999947],
              [-44.500111456999946, -2.379164320999962],
              [-44.50381425699993, -2.376397393999923],
              [-44.50719153599994, -2.373223565999922],
              [-44.508656378999945, -2.371189059999949],
              [-44.510650193999936, -2.367120049999926],
              [-44.51545162699995, -2.36882903399993],
              [-44.52098548099991, -2.37273528399993],
              [-44.53807532499991, -2.379652601999908],
              [-44.55142167899993, -2.391045830999929],
              [-44.56297766799992, -2.404717705999929],
              [-44.57013912699995, -2.416436455999929],
              [-44.52334550699993, -2.387139580999929],
              [-44.50743567599994, -2.389825127999927],
              [-44.501210089999915, -2.419528903999947],
              [-44.51085364499994, -2.46998463299991],
              [-44.521595831999946, -2.500095309999949],
              [-44.53538977799991, -2.518243096999925],
              [-44.54710852799991, -2.521416924999926],
              [-44.55626380099994, -2.519952080999929],
              [-44.56517493399991, -2.52117278399993],
              [-44.57632402299993, -2.53248463299991],
              [-44.58804277299993, -2.56218840899993],
              [-44.59434973899994, -2.566582940999922],
              [-44.612945115999935, -2.570245049999926],
              [-44.63707434799994, -2.579847914999959],
              [-44.65599524599992, -2.593194268999923],
              [-44.65953528599994, -2.608168226999908],
              [-44.64476477799991, -2.59303150799991],
              [-44.59902910099993, -2.57390715899993],
              [-44.580067511999914, -2.563571872999944],
              [-44.57127844999991, -2.552341403999947],
              [-44.56745357999995, -2.54225025799991],
              [-44.561431443999936, -2.535251559999949],
              [-44.54625403599994, -2.53248463299991],
              [-44.54039466099994, -2.538262627999927],
              [-44.545033331999946, -2.550551039999959],
              [-44.552845831999946, -2.562432549999926],
              [-44.55650794199994, -2.566582940999922],
              [-44.607533331999946, -2.669691664999959],
              [-44.63158118399991, -2.69695403399993],
              [-44.62523352799991, -2.706638278999947],
              [-44.626942511999914, -2.718845309999949],
              [-44.63902747299994, -2.744805596999925],
              [-44.64622962099992, -2.768243096999925],
              [-44.647694464999915, -2.787286065999922],
              [-44.64525305899991, -2.830743096999925],
              [-44.65013587099992, -2.854668877999927],
              [-44.68614661399994, -2.916680596999925],
              [-44.68732662699995, -2.924411716999941],
              [-44.68614661399994, -2.953871351999908],
              [-44.68736731699994, -2.965427341999941],
              [-44.69249426999994, -2.984633070999962],
              [-44.69359290299991, -2.994886976999908],
              [-44.68431555899991, -3.012627862999921],
              [-44.662953253999945, -3.017673434999949],
              [-44.63975989499994, -3.018975518999923],
              [-44.62474524599992, -3.025974216999941],
              [-44.62222245999993, -3.051039320999962],
              [-44.63975989499994, -3.069024346999925],
              [-44.66173255099994, -3.08326588299991],
              [-44.67251542899993, -3.097914320999962],
              [-44.67674719999991, -3.111748955999929],
              [-44.686838344999956, -3.12078215899993],
              [-44.698475714999915, -3.127862237999921],
              [-44.707875128999945, -3.135837497999944],
              [-44.711822068999936, -3.145114841999941],
              [-44.71715247299994, -3.168877862999921],
              [-44.72093665299991, -3.176853122999944],
              [-44.74058997299994, -3.186944268999923],
              [-44.76305091099994, -3.19068775799991],
              [-44.78156490799995, -3.19695403399993],
              [-44.78921464799993, -3.214613539999959],
              [-44.787098761999914, -3.233330987999921],
              [-44.78115800699993, -3.251722914999959],
              [-44.772328253999945, -3.269463799999926],
              [-44.76130123599995, -3.286065362999921],
              [-44.79600989499994, -3.300225518999923],
              [-44.76158606699994, -3.305596612999921],
              [-44.75373287699995, -3.289808851999908],
              [-44.76130123599995, -3.238213799999926],
              [-44.755197719999956, -3.220147393999923],
              [-44.74278723899994, -3.207452080999929],
              [-44.72541256399995, -3.199802341999941],
              [-44.67955481699994, -3.194024346999925],
              [-44.65998287699995, -3.184665622999944],
              [-44.64435787699995, -3.169691664999959],
              [-44.63158118399991, -3.149509372999944],
              [-44.61359615799995, -3.111993096999925],
              [-44.60008704299992, -3.104099216999941],
              [-44.57323157499991, -3.101657809999949],
              [-44.52916419199994, -3.032159112999921],
              [-44.48192298099991, -3.007419528999947],
              [-44.473947719999956, -3.001722914999959],
              [-44.46861731699994, -2.986586195999962],
              [-44.43297278599994, -2.950290622999944],
              [-44.42418372299994, -2.934502862999921],
              [-44.41543535099993, -2.913995049999926],
              [-44.40884355399993, -2.892185153999947],
              [-44.406239386999914, -2.872002862999921],
              [-44.40807044199994, -2.826348565999922],
              [-44.404286261999914, -2.804864190999922],
              [-44.39195716099994, -2.793145440999922],
              [-44.39533443899995, -2.789157809999949],
              [-44.39708411399994, -2.785332940999922],
              [-44.39997311099995, -2.781914971999925],
              [-44.406239386999914, -2.778903903999947],
              [-44.37096106699994, -2.667575778999947],
              [-44.36465410099993, -2.628676039999959],
              [-44.36107337099992, -2.636814059999949],
              [-44.35855058499993, -2.644626559999949],
              [-44.35732988199993, -2.652764580999929],
              [-44.35781816299993, -2.662774346999925],
              [-44.35098222599993, -2.662774346999925],
              [-44.368072068999936, -2.549574476999908],
              [-44.357492641999954, -2.536553643999923],
              [-44.35265051999994, -2.529066664999959],
              [-44.34520423099991, -2.525811455999929],
              [-44.32648678299995, -2.52507903399993],
              [-44.31224524599992, -2.531914971999925],
              [-44.30186926999994, -2.548028252999927],
              [-44.28892981699994, -2.580254815999922],
              [-44.28823808499993, -2.551446221999925],
              [-44.29198157499991, -2.539808851999908],
              [-44.30260169199994, -2.53248463299991],
              [-44.29979407499991, -2.521254164999959],
              [-44.30109615799995, -2.508477471999925],
              [-44.30064856699994, -2.494805596999925],
              [-44.292632615999935, -2.481052341999941],
              [-44.278960740999935, -2.475518487999921],
              [-44.22008216099994, -2.47039153399993],
              [-44.11148027299993, -2.415785414999959],
              [-44.082875128999945, -2.416436455999929],
              [-44.07298743399991, -2.399509372999944],
              [-44.05304928299995, -2.399997653999947],
              [-44.034413214999915, -2.415215752999927],
              [-44.02892005099994, -2.44304778399993],
              [-44.04637610599991, -2.438653252999927],
              [-44.07140051999994, -2.438083591999941],
              [-44.09215247299994, -2.443454684999949],
              [-44.09715735599991, -2.45671965899993],
              [-44.06973222599993, -2.460870049999926],
              [-44.06362870999993, -2.462985934999949],
              [-44.060617641999954, -2.471612237999921],
              [-44.06012936099995, -2.494886976999908],
              [-44.05622311099995, -2.50514088299991],
              [-44.05565344999991, -2.494317315999922],
              [-44.054351365999935, -2.486586195999962],
              [-44.049387173999946, -2.47039153399993],
              [-44.041900193999936, -2.47039153399993],
              [-44.03433183499993, -2.493340752999927],
              [-44.03270423099991, -2.513278903999947],
              [-44.03746497299994, -2.532403252999927],
              [-44.049387173999946, -2.552911065999922],
              [-44.06554114499994, -2.551364841999941],
              [-44.082875128999945, -2.560316664999959],
              [-44.09715735599991, -2.580254815999922],
              [-44.10334225199995, -2.583428643999923],
              [-44.110259568999936, -2.584730726999908],
              [-44.11758378799993, -2.587497653999947],
              [-44.12441972599993, -2.594496351999908],
              [-44.10655676999994, -2.602308851999908],
              [-44.11107337099992, -2.622002862999921],
              [-44.13719641799992, -2.670179945999962],
              [-44.15103105399993, -2.680108330999929],
              [-44.16714433499993, -2.687269789999959],
              [-44.179676886999914, -2.690118096999925],
              [-44.191070115999935, -2.688897393999923],
              [-44.197824673999946, -2.685153903999947],
              [-44.21385657499991, -2.669040622999944],
              [-44.21031653599994, -2.686455987999921],
              [-44.206695115999935, -2.692315362999921],
              [-44.20018469999991, -2.69695403399993],
              [-44.212228969999956, -2.707696221999925],
              [-44.23985755099994, -2.71453215899993],
              [-44.25169837099992, -2.721123955999929],
              [-44.27993730399993, -2.748304945999962],
              [-44.28551184799994, -2.752211195999962],
              [-44.31309973899994, -2.762139580999929],
              [-44.33849036399994, -2.784926039999959],
              [-44.348500128999945, -2.81023528399993],
              [-44.32994544199994, -2.827325127999927],
              [-44.32835852799991, -2.804131768999923],
              [-44.32274329299992, -2.785088799999926],
              [-44.312489386999914, -2.778741143999923],
              [-44.29637610599991, -2.793145440999922],
              [-44.305531378999945, -2.81023528399993],
              [-44.31004798099991, -2.814222914999959],
              [-44.31004798099991, -2.820489190999922],
              [-44.29637610599991, -2.834161065999922],
              [-44.28892981699994, -2.806817315999922],
              [-44.284047003999945, -2.805596612999921],
              [-44.27717037699995, -2.806898695999962],
              [-44.27106686099995, -2.807305596999925],
              [-44.268462693999936, -2.803399346999925],
              [-44.26781165299991, -2.790215752999927],
              [-44.26549231699994, -2.78053150799991],
              [-44.26146399599992, -2.772637627999927],
              [-44.25544186099995, -2.76531340899993],
              [-44.246164516999954, -2.774021091999941],
              [-44.22008216099994, -2.793145440999922],
              [-44.22614498599995, -2.776950778999947],
              [-44.21837317599994, -2.767754815999922],
              [-44.18651282499991, -2.75904713299991],
              [-44.18854732999995, -2.778090101999908],
              [-44.174712693999936, -2.807061455999929],
              [-44.18309485599991, -2.82390715899993],
              [-44.19115149599992, -2.829685153999947],
              [-44.207020636999914, -2.835870049999926],
              [-44.21385657499991, -2.840997002999927],
              [-44.218861456999946, -2.848239841999941],
              [-44.21849524599992, -2.851739190999922],
              [-44.214100714999915, -2.851739190999922],
              [-44.207020636999914, -2.848402601999908],
              [-44.20494544199994, -2.853448174999926],
              [-44.202463344999956, -2.857517184999949],
              [-44.20055091099994, -2.862074476999908],
              [-44.20018469999991, -2.868910414999959],
              [-44.16665605399993, -2.838067315999922],
              [-44.15925045499995, -2.827325127999927],
              [-44.15587317599994, -2.829522393999923],
              [-44.15477454299992, -2.82976653399993],
              [-44.153960740999935, -2.830498955999929],
              [-44.15176347599993, -2.834161065999922],
              [-44.141468878999945, -2.820407809999949],
              [-44.13272050699993, -2.803643487999921],
              [-44.12669837099992, -2.785902601999908],
              [-44.12441972599993, -2.768975518999923],
              [-44.118072068999936, -2.757745049999926],
              [-44.106027798999946, -2.749607028999947],
              [-44.09813391799992, -2.748711846999925],
              [-44.10460364499994, -2.75904713299991],
              [-44.10460364499994, -2.76531340899993],
              [-44.092640753999945, -2.761651299999926],
              [-44.08897864499994, -2.75904713299991],
              [-44.082875128999945, -2.752211195999962],
              [-44.07664954299992, -2.75904713299991],
              [-44.07945716099994, -2.766289971999925],
              [-44.07966061099995, -2.769301039999959],
              [-44.07835852799991, -2.772149346999925],
              [-44.07664954299992, -2.778903903999947],
              [-44.074208136999914, -2.772067966999941],
              [-44.07262122299994, -2.768975518999923],
              [-44.06981360599991, -2.76531340899993],
              [-44.06867428299995, -2.779066664999959],
              [-44.071929490999935, -2.789483330999929],
              [-44.082875128999945, -2.806817315999922],
              [-44.06810462099992, -2.795179945999962],
              [-44.06285559799994, -2.77703215899993],
              [-44.06362870999993, -2.734795830999929],
              [-44.06037350199995, -2.717705987999921],
              [-44.05247962099992, -2.701918226999908],
              [-44.035715298999946, -2.676446221999925],
              [-44.02293860599991, -2.648858330999929],
              [-44.01414954299992, -2.634698174999926],
              [-43.98399817599994, -2.615492445999962],
              [-43.980458136999914, -2.611586195999962],
              [-43.975900844999956, -2.610284112999921],
              [-43.94635982999995, -2.628676039999959],
              [-43.94635982999995, -2.621270440999922],
              [-43.95775305899991, -2.612399997999944],
              [-43.95836341099994, -2.600681247999944],
              [-43.94635982999995, -2.573988539999959],
              [-43.93260657499991, -2.555840752999927],
              [-43.92324785099993, -2.546807549999926],
              [-43.91905676999994, -2.549574476999908],
              [-43.89175370999993, -2.600518487999921],
              [-43.87804114499994, -2.634942315999922],
              [-43.87437903599994, -2.622816664999959],
              [-43.87726803299995, -2.611260674999926],
              [-43.88223222599993, -2.598565362999921],
              [-43.884877081999946, -2.58367278399993],
              [-43.879465298999946, -2.571221612999921],
              [-43.85326087099992, -2.559340101999908],
              [-43.84631565199993, -2.55633849599991],
              [-43.83853105399993, -2.556247653999947],
              [-43.834055141999954, -2.554945570999962],
              [-43.827618414999904, -2.551052755999933],
              [-43.82138426699993, -2.551054004999912],
              [-43.815744594999956, -2.551527601999908],
              [-43.80492102799991, -2.549248955999929],
              [-43.78184973899994, -2.53248463299991],
              [-43.76695716099994, -2.526299737999921],
              [-43.752797003999945, -2.524021091999941],
              [-43.74640865799995, -2.529229424999926],
              [-43.73856418199995, -2.517207448999955],
              [-43.74010169199994, -2.486911716999941],
              [-43.72411048099991, -2.477227471999925],
              [-43.71251380099994, -2.488539320999962],
              [-43.70653235599991, -2.513848565999922],
              [-43.70856686099995, -2.539727471999925],
              [-43.72105872299994, -2.552911065999922],
              [-43.72105872299994, -2.560316664999959],
              [-43.71361243399991, -2.560316664999959],
              [-43.71361243399991, -2.552911065999922],
              [-43.706695115999935, -2.552911065999922],
              [-43.706695115999935, -2.560316664999959],
              [-43.699289516999954, -2.560316664999959],
              [-43.69912675699993, -2.553643487999921],
              [-43.69762122299994, -2.549004815999922],
              [-43.69310462099992, -2.539320570999962],
              [-43.68464107999995, -2.543389580999929],
              [-43.67674719999991, -2.545586846999925],
              [-43.658314581999946, -2.54615650799991],
              [-43.680978969999956, -2.529554945999962],
              [-43.68244381399995, -2.504652601999908],
              [-43.66844641799992, -2.483330987999921],
              [-43.644642706999946, -2.477227471999925],
              [-43.65196692599994, -2.485446872999944],
              [-43.65733801999994, -2.493910414999959],
              [-43.66576087099992, -2.511976820999962],
              [-43.652414516999954, -2.50164153399993],
              [-43.63573157499991, -2.498304945999962],
              [-43.621978318999936, -2.505303643999923],
              [-43.61733964799993, -2.52507903399993],
              [-43.59748287699995, -2.516208591999941],
              [-43.55817623599995, -2.530857028999947],
              [-43.542225714999915, -2.52507903399993],
              [-43.54845130099994, -2.518243096999925],
              [-43.56045488199993, -2.519301039999959],
              [-43.563059048999946, -2.509535414999959],
              [-43.558257615999935, -2.49578215899993],
              [-43.54845130099994, -2.484633070999962],
              [-43.54845130099994, -2.50514088299991],
              [-43.539133266999954, -2.491143487999921],
              [-43.53673255099994, -2.47820403399993],
              [-43.54210364499994, -2.466566664999959],
              [-43.555897589999915, -2.45671965899993],
              [-43.53734290299991, -2.435967705999929],
              [-43.52367102799991, -2.44264088299991],
              [-43.51748613199993, -2.464939059999949],
              [-43.52183997299994, -2.49146900799991],
              [-43.50841223899994, -2.491631768999923],
              [-43.49982662699995, -2.524834893999923],
              [-43.48704993399991, -2.53248463299991],
              [-43.49449622299994, -2.54615650799991],
              [-43.48420162699995, -2.543715101999908],
              [-43.47695878799993, -2.537692966999941],
              [-43.471547003999945, -2.528903903999947],
              [-43.46654212099992, -2.518243096999925],
              [-43.45836341099994, -2.535088799999926],
              [-43.45287024599992, -2.552911065999922],
              [-43.44562740799995, -2.544854424999926],
              [-43.444203253999945, -2.530857028999947],
              [-43.44806881399995, -2.514825127999927],
              [-43.465402798999946, -2.48601653399993],
              [-43.45250403599994, -2.483819268999923],
              [-43.41877193899995, -2.49146900799991],
              [-43.41877193899995, -2.484633070999962],
              [-43.43504798099991, -2.482598565999922],
              [-43.447255011999914, -2.471612237999921],
              [-43.45547441299993, -2.456801039999959],
              [-43.45978756399995, -2.44304778399993],
              [-43.45287024599992, -2.44304778399993],
              [-43.448109503999945, -2.451918226999908],
              [-43.43862870999993, -2.45671965899993],
              [-43.42609615799995, -2.458184502999927],
              [-43.41193600199995, -2.45671965899993],
              [-43.42808997299994, -2.441664320999962],
              [-43.47402910099993, -2.417738539999959],
              [-43.48704993399991, -2.395277601999908],
              [-43.48273678299995, -2.379082940999922],
              [-43.47529216499993, -2.365923445999954],
              [-43.46736941599994, -2.353685655999925],
              [-43.467372921999925, -2.34576732499994],
              [-43.45440102099991, -2.341448772999911],
              [-43.441429360999905, -2.339290006999931],
              [-43.42629772999993, -2.337849610999911],
              [-43.40756544499993, -2.337129653999909],
              [-43.38523264699995, -2.340005775999941],
              [-43.36362079199995, -2.342883044999951],
              [-43.34057294799993, -2.345037583999954],
              [-43.311766409999905, -2.346467356999938],
              [-43.251263656999924, -2.36730597299993],
              [-43.19939548299993, -2.379510988999925],
              [-43.11865894099992, -2.416888538999956],
              [-43.01402747299994, -2.457207940999922],
              [-42.943106411999906, -2.481628121999961],
              [-42.91630469499995, -2.492436685999905],
              [-42.88284532599994, -2.510329143999911],
              [-42.85790785899991, -2.522171855999943],
              [-42.82384192599994, -2.543226820999962],
              [-42.81916256399995, -2.54615650799991],
              [-42.810658331999946, -2.548028252999927],
              [-42.775054490999935, -2.560316664999959],
              [-42.76598059799994, -2.561293226999908],
              [-42.70995032499991, -2.560316664999959],
              [-42.70002193899995, -2.563571872999944],
              [-42.69310462099992, -2.570407809999949],
              [-42.68781490799995, -2.577243747999944],
              [-42.68228105399993, -2.580254815999922],
              [-42.67284094999991, -2.58912525799991],
              [-42.63048255099994, -2.642347914999959],
              [-42.58088131399995, -2.672051690999922],
              [-42.56558183499993, -2.676446221999925],
              [-42.555572068999936, -2.677911065999922],
              [-42.53929602799991, -2.68328215899993],
              [-42.527455206999946, -2.68328215899993],
              [-42.51634680899991, -2.681084893999923],
              [-42.48713131399995, -2.669040622999944],
              [-42.48623613199993, -2.68678150799991],
              [-42.489491339999915, -2.699639580999929],
              [-42.49828040299991, -2.704196872999944],
              [-42.51439368399991, -2.69695403399993],
              [-42.50763912699995, -2.721856377999927],
              [-42.49351966099994, -2.731215101999908],
              [-42.47443600199995, -2.737399997999944],
              [-42.45299231699994, -2.752211195999962],
              [-42.44603430899991, -2.747002862999921],
              [-42.427398240999935, -2.738051039999959],
              [-42.41812089799993, -2.731133721999925],
              [-42.41197669199994, -2.738539320999962],
              [-42.40733801999994, -2.750176690999922],
              [-42.37840735599991, -2.756280205999929],
              [-42.26427161399994, -2.75904713299991],
              [-42.25450598899994, -2.766534112999921],
              [-42.253977016999954, -2.783461195999962],
              [-42.25934811099995, -2.80201588299991],
              [-42.26740475199995, -2.814222914999959],
              [-42.23863684799994, -2.804782809999949],
              [-42.23420162699995, -2.810723565999922],
              [-42.23940995999993, -2.834161065999922],
              [-42.233265753999945, -2.834161065999922],
              [-42.229359503999945, -2.822198174999926],
              [-42.22223873599995, -2.812432549999926],
              [-42.21369381399995, -2.804945570999962],
              [-42.205922003999945, -2.799981377999927],
              [-42.19310462099992, -2.809177341999941],
              [-42.17613684799994, -2.81178150799991],
              [-42.15953528599994, -2.809502862999921],
              [-42.14757239499994, -2.803399346999925],
              [-42.08238684799994, -2.799981377999927],
              [-42.08446204299992, -2.80396900799991],
              [-42.08551998599995, -2.804620049999926],
              [-42.086822068999936, -2.804620049999926],
              [-42.089833136999914, -2.806817315999922],
              [-42.08372962099992, -2.820977471999925],
              [-42.08238684799994, -2.827325127999927],
              [-42.06773841099994, -2.82000090899993],
              [-42.04718990799995, -2.821465752999927],
              [-42.02887936099995, -2.824965101999908],
              [-42.02090410099993, -2.82390715899993],
              [-42.01593990799995, -2.811293226999908],
              [-42.004017706999946, -2.812595309999949],
              [-41.96898352799991, -2.83367278399993],
              [-41.95543372299994, -2.839043877999927],
              [-41.943918423999946, -2.837660414999959],
              [-41.93903561099995, -2.82390715899993],
              [-41.936756964999915, -2.788018487999921],
              [-41.94041907499991, -2.773695570999962],
              [-41.95270748599995, -2.778903903999947],
              [-41.95889238199993, -2.778903903999947],
              [-41.97061113199993, -2.768243096999925],
              [-42.001616990999935, -2.749769789999959],
              [-42.01531402299992, -2.741134196999951],
              [-42.01040398899994, -2.727188783999907],
              [-41.99562321999991, -2.721434581999915],
              [-41.900274106999916, -2.725440723999952],
              [-41.838564525999914, -2.729480290999959],
              [-41.82126538099993, -2.73356698099991],
              [-41.84284420499995, -2.76531340899993],
              [-41.842681443999936, -2.765232028999947],
              [-41.832102016999954, -2.762465101999908],
              [-41.82396399599992, -2.757419528999947],
              [-41.808705206999946, -2.744805596999925],
              [-41.77867591099994, -2.782159112999921],
              [-41.69405618299993, -2.832881567999948],
              [-41.665061385999934, -2.855906813999923],
              [-41.65782630099994, -2.868910414999959],
              [-41.663726365999935, -2.865411065999922],
              [-41.67931067599994, -2.858168226999908],
              [-41.68517005099994, -2.854668877999927],
              [-41.682850714999915, -2.858005466999941],
              [-41.67833411399994, -2.868910414999959],
              [-41.688343878999945, -2.86492278399993],
              [-41.69884192599994, -2.862074476999908],
              [-41.69884192599994, -2.868910414999959],
              [-41.68614661399994, -2.875909112999921],
              [-41.675038214999915, -2.879571221999925],
              [-41.66392981699994, -2.877862237999921],
              [-41.65099036399994, -2.868910414999959],
              [-41.639881964999915, -2.884942315999922],
              [-41.62328040299991, -2.895603122999944],
              [-41.601551886999914, -2.901299737999921],
              [-41.51695716099994, -2.906996351999908],
              [-41.48961341099994, -2.90357838299991],
              [-41.46544348899994, -2.888767184999949],
              [-41.45494544199994, -2.897149346999925],
              [-41.448557094999956, -2.90593840899993],
              [-41.448882615999935, -2.916436455999929],
              [-41.45860755099994, -2.929782809999949],
              [-41.45579993399991, -2.930271091999941],
              [-41.44554602799991, -2.929782809999949],
              [-41.44762122299994, -2.933526299999926],
              [-41.44945227799991, -2.936130466999941],
              [-41.45091712099992, -2.938897393999923],
              [-41.45177161399994, -2.943454684999949],
              [-41.44469153599994, -2.94304778399993],
              [-41.44005286399994, -2.941664320999962],
              [-41.43187415299991, -2.936618747999944],
              [-41.44005286399994, -2.914239190999922],
              [-41.42210852799991, -2.908786716999941],
              [-41.343088344999956, -2.920342705999929],
              [-41.33568274599992, -2.922946872999944],
              [-41.329009568999936, -2.932224216999941],
              [-41.32787024599992, -2.941013278999947],
              [-41.332102016999954, -2.947442315999922],
              [-41.341908331999946, -2.950290622999944],
              [-41.33751380099994, -2.954522393999923],
              [-41.32754472599993, -2.961114190999922],
              [-41.32201087099992, -2.963799737999921],
              [-41.316477016999954, -2.960870049999926],
              [-41.310658331999946, -2.963474216999941],
              [-41.30528723899994, -2.969496351999908],
              [-41.30093339799993, -2.977634372999944],
              [-41.29474850199995, -2.977634372999944],
              [-41.29474850199995, -2.963799737999921],
              [-41.27391516799992, -2.980075778999947],
              [-41.25645911399994, -3.004815362999921],
              [-41.248117641999954, -3.012058200999945],
              [-41.24453691299993, -3.015232028999947],
              [-41.24010169199994, -2.988051039999959],
              [-41.24327551999994, -2.972751559999949],
              [-41.25690670499995, -2.949802341999941],
              [-41.26402747299994, -2.928399346999925],
              [-41.28237870999993, -2.91570403399993],
              [-41.28726152299993, -2.903008721999925],
              [-41.29629472599993, -2.907159112999921],
              [-41.30288652299993, -2.90789153399993],
              [-41.308583136999914, -2.906345309999949],
              [-41.31525631399995, -2.903008721999925],
              [-41.299712693999936, -2.896742445999962],
              [-41.273426886999914, -2.878838799999926],
              [-41.25690670499995, -2.875176690999922],
              [-41.198557094999956, -2.875176690999922],
              [-41.167958136999914, -2.878838799999926],
              [-41.13776607999995, -2.885837497999944],
              [-41.11070716099994, -2.89771900799991],
              [-41.08926347599993, -2.916680596999925],
              [-41.08250891799992, -2.916680596999925],
              [-41.08462480399993, -2.905205987999921],
              [-41.089955206999946, -2.894463799999926],
              [-41.10301673099991, -2.875176690999922],
              [-41.08926347599993, -2.88250090899993],
              [-41.08250891799992, -2.88250090899993],
              [-40.93846594999991, -2.868910414999959],
              [-40.92813066299993, -2.869805596999925],
              [-40.90855872299994, -2.874200127999927],
              [-40.90001380099994, -2.875176690999922],
              [-40.89195716099994, -2.873142184999949],
              [-40.887928839999915, -2.864027601999908],
              [-40.87950598899994, -2.862074476999908],
              [-40.84898841099994, -2.859307549999926],
              [-40.84137936099995, -2.864678643999923],
              [-40.83543860599991, -2.88250090899993],
              [-40.82860266799992, -2.88250090899993],
              [-40.818348761999914, -2.871677341999941],
              [-40.769195115999935, -2.846774997999944],
              [-40.75291907499991, -2.840997002999927],
              [-40.58161373599995, -2.827325127999927],
              [-40.527414516999954, -2.803399346999925],
              [-40.509877081999946, -2.799981377999927],
              [-40.506743943999936, -2.797946872999944],
              [-40.49962317599994, -2.786309502999927],
              [-40.49315344999991, -2.786716403999947],
              [-40.48810787699995, -2.788995049999926],
              [-40.483713344999956, -2.791680596999925],
              [-40.47911536399994, -2.793145440999922],
              [-40.40306555899991, -2.80592213299991],
              [-40.27375240799995, -2.806817315999922],
              [-40.188059048999946, -2.820489190999922],
              [-40.175038214999915, -2.824639580999929],
              [-40.15477454299992, -2.843519789999959],
              [-40.143422003999945, -2.848402601999908],
              [-40.13243567599994, -2.844008070999962],
              [-40.12686113199993, -2.834567966999941],
              [-40.12092037699995, -2.828383070999962],
              [-40.108631964999915, -2.834161065999922],
              [-40.09634355399993, -2.830743096999925],
              [-40.08218339799993, -2.836358330999929],
              [-40.06676184799994, -2.844414970999935],
              [-40.05060787699995, -2.848402601999908],
              [-40.00104732999995, -2.845635674999926],
              [-39.98570716099994, -2.848402601999908],
              [-39.90306555899991, -2.901788018999923],
              [-39.87242591099994, -2.90984465899993],
              [-39.86091061099995, -2.91570403399993],
              [-39.807484503999945, -2.967543226999908],
              [-39.79588782499991, -2.974704684999949],
              [-39.78335527299993, -2.977634372999944],
              [-39.76732337099992, -2.98560963299991],
              [-39.743031378999945, -3.003676039999959],
              [-39.72594153599994, -3.022393487999921],
              [-39.73184160099993, -3.032159112999921],
              [-39.725493943999936, -3.035332940999922],
              [-39.71910559799994, -3.037530205999929],
              [-39.712228969999956, -3.038995049999926],
              [-39.70457923099991, -3.039646091999941],
              [-39.71202551999994, -3.025974216999941],
              [-39.69790605399993, -3.017185153999947],
              [-39.68154863199993, -3.020440362999921],
              [-39.643137173999946, -3.039646091999941],
              [-39.63768469999991, -3.040622653999947],
              [-39.61888587099992, -3.039646091999941],
              [-39.614898240999935, -3.04225025799991],
              [-39.61074785099993, -3.055271091999941],
              [-39.608306443999936, -3.060153903999947],
              [-39.57111568899995, -3.090915622999944],
              [-39.49714107999995, -3.131117445999962],
              [-39.48546301999994, -3.14576588299991],
              [-39.39671790299991, -3.183526299999926],
              [-39.38394120999993, -3.186293226999908],
              [-39.37539628799993, -3.186130466999941],
              [-39.36782792899993, -3.184502862999921],
              [-39.358265753999945, -3.183526299999926],
              [-39.352772589999915, -3.18678150799991],
              [-39.34752356699994, -3.193780205999929],
              [-39.34089107999995, -3.20086028399993],
              [-39.32046464799993, -3.207614841999941],
              [-39.28685462099992, -3.232028903999947],
              [-39.27794348899994, -3.230401299999926],
              [-39.27257239499994, -3.232028903999947],
              [-39.26740475199995, -3.236423434999949],
              [-39.26406816299993, -3.241957289999959],
              [-39.26158606699994, -3.247653903999947],
              [-39.25890051999994, -3.251885674999926],
              [-39.19371497299994, -3.296807549999926],
              [-39.165272589999915, -3.322849216999941],
              [-39.15648352799991, -3.327569268999923],
              [-39.14565995999993, -3.32976653399993],
              [-39.12580318899995, -3.330498955999929],
              [-39.11554928299995, -3.334405205999929],
              [-39.10130774599992, -3.348565362999921],
              [-39.09243730399993, -3.364190362999921],
              [-39.08055579299992, -3.377048434999949],
              [-39.057199673999946, -3.382256768999923],
              [-39.01549231699994, -3.38404713299991],
              [-38.999663865999935, -3.388278903999947],
              [-38.98517818899995, -3.395928643999923],
              [-38.96035722599993, -3.418145440999922],
              [-38.94273841099994, -3.44459400799991],
              [-38.91633053299995, -3.505059502999927],
              [-38.89720618399991, -3.500258070999962],
              [-38.88329016799992, -3.507582289999959],
              [-38.87059485599991, -3.520684502999927],
              [-38.855458136999914, -3.532972914999959],
              [-38.807484503999945, -3.547295830999929],
              [-38.78954016799992, -3.573825778999947],
              [-38.76305091099994, -3.598239841999941],
              [-38.73200436099995, -3.619886976999908],
              [-38.707102016999954, -3.629164320999905],
              [-38.69440670499995, -3.636651299999926],
              [-38.671131964999915, -3.669040622999944],
              [-38.65965735599991, -3.676446221999925],
              [-38.59471594999991, -3.69068775799991],
              [-38.52619381399995, -3.71803150799991],
              [-38.49437415299991, -3.721286716999941],
              [-38.477406378999945, -3.697442315999922],
              [-38.46654212099992, -3.705498955999929],
              [-38.45734615799995, -3.71843840899993],
              [-38.43594316299993, -3.758396091999941],
              [-38.40977942599994, -3.793145440999922],
              [-38.40330969999991, -3.809340101999908],
              [-38.395822719999956, -3.840590101999908],
              [-38.38927161399994, -3.85515715899993],
              [-38.37804114499994, -3.869724216999941],
              [-38.32079016799992, -3.922784112999921],
              [-38.310210740999935, -3.929620049999926],
              [-38.26349850199995, -3.951592705999929],
              [-38.25133216099994, -3.961846612999921],
              [-38.18854732999995, -4.05201588299991],
              [-38.106678839999915, -4.15789153399993],
              [-38.02961178299995, -4.237399997999944],
              [-37.93455969999991, -4.307793877999927],
              [-37.91942298099991, -4.314548434999949],
              [-37.85423743399991, -4.375909112999921],
              [-37.83507239499994, -4.384942315999922],
              [-37.813710089999915, -4.391289971999925],
              [-37.79124915299991, -4.395196221999925],
              [-37.76862545499995, -4.396416924999926],
              [-37.71080481699994, -4.515394789999959],
              [-37.68374589799993, -4.548435153999947],
              [-37.64940344999991, -4.578789971999925],
              [-37.60724850199995, -4.608086846999925],
              [-37.56436113199993, -4.629489841999941],
              [-37.53734290299991, -4.638116143999923],
              [-37.52529863199993, -4.632582289999959],
              [-37.51382402299993, -4.623793226999908],
              [-37.48802649599992, -4.629978122999944],
              [-37.42711341099994, -4.661065362999921],
              [-37.32481848899994, -4.696465752999927],
              [-37.29255123599995, -4.717950127999927],
              [-37.27440344999991, -4.742364190999922],
              [-37.23110917899993, -4.842054945999905],
              [-37.182932094999956, -4.910902601999908],
              [-37.13491777299993, -4.931410414999959],
              [-37.11514238199993, -4.921970309999949],
              [-37.09813391799992, -4.920586846999925],
              [-37.08242753799993, -4.924493096999925],
              [-37.049387173999946, -4.937920830999929],
              [-37.03746497299994, -4.93873463299991],
              [-37.011382615999935, -4.931410414999959],
              [-36.982980923999946, -4.929782809999949],
              [-36.89875240799995, -4.938246351999908],
              [-36.88101152299993, -4.94850025799991],
              [-36.847645636999914, -4.985935153999947],
              [-36.84349524599992, -4.992852471999925],
              [-36.83311926999994, -4.99732838299991],
              [-36.82070878799993, -5.007745049999926],
              [-36.81029212099992, -5.020114841999941],
              [-36.805978969999956, -5.030043226999908],
              [-36.79088294199994, -5.051202080999929],
              [-36.75658118399991, -5.066827080999929],
              [-36.71955318899995, -5.075372002999927],
              [-36.69611568899995, -5.07545338299991],
              [-36.69570878799993, -5.089613539999959],
              [-36.68224036399994, -5.092217705999929],
              [-36.641468878999945, -5.089043877999927],
              [-36.60692298099991, -5.096368096999925],
              [-36.58999589799993, -5.102959893999923],
              [-36.56114661399994, -5.123223565999922],
              [-36.54442298099991, -5.127618096999925],
              [-36.530913865999935, -5.12273528399993],
              [-36.525380011999914, -5.105564059999949],
              [-36.53368079299992, -5.101006768999923],
              [-36.57054602799991, -5.091729424999926],
              [-36.57998613199993, -5.080987237999921],
              [-36.54507402299993, -5.089613539999959],
              [-36.42235266799992, -5.080987237999921],
              [-36.33975175699993, -5.089043877999927],
              [-36.300038214999915, -5.101169528999947],
              [-36.281361456999946, -5.104587497999944],
              [-36.25723222599993, -5.102146091999941],
              [-36.25723222599993, -5.095879815999922],
              [-36.29198157499991, -5.095879815999922],
              [-36.29198157499991, -5.089043877999927],
              [-36.13121497299994, -5.095879815999922],
              [-36.11359615799995, -5.091566664999959],
              [-36.07909094999991, -5.072360934999949],
              [-36.04283606699994, -5.064873955999929],
              [-36.01598059799994, -5.051039320999905],
              [-35.99718176999994, -5.047539971999925],
              [-35.91759192599994, -5.05828215899993],
              [-35.768422003999945, -5.086846612999921],
              [-35.659413214999915, -5.111260674999926],
              [-35.58193925699993, -5.118910414999959],
              [-35.548817511999914, -5.128350518999923],
              [-35.51056881399995, -5.143731377999927],
              [-35.49290930899991, -5.157403252999927],
              [-35.45490475199995, -5.19695403399993],
              [-35.43858801999994, -5.205173434999949],
              [-35.42052161399994, -5.211521091999941],
              [-35.40379798099991, -5.226495049999926],
              [-35.39004472599993, -5.244561455999929],
              [-35.371205206999946, -5.279066664999959],
              [-35.36241614499994, -5.300876559999949],
              [-35.356027798999946, -5.32350025799991],
              [-35.353505011999914, -5.345798434999949],
              [-35.34862219999991, -5.355645440999922],
              [-35.31875566299993, -5.383233330999929],
              [-35.262277798999946, -5.483330987999921],
              [-35.253895636999914, -5.524102471999925],
              [-35.24526933499993, -5.54615650799991],
              [-35.23412024599992, -5.566582940999922],
              [-35.22313391799992, -5.582614841999941],
              [-35.23062089799993, -5.588799737999921],
              [-35.22606360599991, -5.598565362999921],
              [-35.20677649599992, -5.668145440999922],
              [-35.20579993399991, -5.678806247999944],
              [-35.19566809799994, -5.689548434999949],
              [-35.19522050699993, -5.760023695999905],
              [-35.18773352799991, -5.773532809999949],
              [-35.17870032499991, -5.783461195999905],
              [-35.171131964999915, -5.796319268999923],
              [-35.167958136999914, -5.818454684999949],
              [-35.171213344999956, -5.833916924999926],
              [-35.171538865999935, -5.844333591999941],
              [-35.167958136999914, -5.856215101999908],
              [-35.15013587099992, -5.874769789999959],
              [-35.14745032499991, -5.876722914999959],
              [-35.145822719999956, -5.886814059999949],
              [-35.14745032499991, -5.921075127999927],
              [-35.14533443899995, -5.932061455999929],
              [-35.135975714999915, -5.945733330999929],
              [-35.13377844999991, -5.955254815999922],
              [-35.12999426999994, -5.959649346999925],
              [-35.112212693999936, -5.976657809999949],
              [-35.10651607999995, -5.98601653399993],
              [-35.10505123599995, -5.995538018999923],
              [-35.10651607999995, -6.027601820999905],
              [-35.11168372299994, -6.04851653399993],
              [-35.11119544199994, -6.057793877999927],
              [-35.102772589999915, -6.061700127999927],
              [-35.09935462099992, -6.066582940999922],
              [-35.09284420499995, -6.185804945999905],
              [-35.12071692599994, -6.164727471999925],
              [-35.124989386999914, -6.182793877999927],
              [-35.14976966099994, -6.206801039999959],
              [-35.15086829299992, -6.215997002999927],
              [-35.13426673099991, -6.22429778399993],
              [-35.12010657499991, -6.214613539999959],
              [-35.10757402299993, -6.199883721999925],
              [-35.09593665299991, -6.192071221999925],
              [-35.08706620999993, -6.197442315999922],
              [-35.07787024599992, -6.220879815999922],
              [-35.06895911399994, -6.226169528999947],
              [-35.048939581999946, -6.227227471999925],
              [-35.04124915299991, -6.230238539999959],
              [-35.03819739499994, -6.236504815999922],
              [-35.036000128999945, -6.258558851999908],
              [-35.02619381399995, -6.298923434999949],
              [-35.02391516799992, -6.31804778399993],
              [-35.025949673999946, -6.333916924999926],
              [-35.02424068899995, -6.342868747999944],
              [-35.01707923099991, -6.355889580999929],
              [-35.010609503999945, -6.362888278999947],
              [-34.99632727799991, -6.371026299999926],
              [-34.989165818999936, -6.377618096999925],
              [-34.98228919199994, -6.391371351999908],
              [-34.97227942599994, -6.433363539999959],
              [-34.958973761999914, -6.536879164999959],
              [-34.95848548099991, -6.582614841999941],
              [-34.969960089999915, -6.617282809999949],
              [-34.96080481699994, -6.638848565999922],
              [-34.957142706999946, -6.651299737999921],
              [-34.95327714799993, -6.674737237999921],
              [-34.94774329299992, -6.68482838299991],
              [-34.94098873599995, -6.694431247999944],
              [-34.93517005099994, -6.705987237999921],
              [-34.93492591099994, -6.724216403999947],
              [-34.94005286399994, -6.744561455999929],
              [-34.94273841099994, -6.766208591999941],
              [-34.93517005099994, -6.787855726999908],
              [-34.93517005099994, -6.781670830999929],
              [-34.91673743399991, -6.864190362999921],
              [-34.90416419199994, -6.887302341999941],
              [-34.89362545499995, -6.894301039999959],
              [-34.86571204299992, -6.907159112999921],
              [-34.86009680899991, -6.914646091999941],
              [-34.86009680899991, -6.962660414999959],
              [-34.86286373599995, -6.976006768999923],
              [-34.869252081999946, -6.982679945999905],
              [-34.876210089999915, -6.986993096999925],
              [-34.88060462099992, -6.993340752999927],
              [-34.88109290299991, -7.004571221999925],
              [-34.878163214999915, -7.028008721999925],
              [-34.88060462099992, -7.041192315999922],
              [-34.89635169199994, -7.08131275799991],
              [-34.894195115999935, -7.082777601999908],
              [-34.90184485599991, -7.090590101999908],
              [-34.90758216099994, -7.093194268999923],
              [-34.91348222599993, -7.090508721999925],
              [-34.92149817599994, -7.082777601999908],
              [-34.912220831999946, -7.092705987999921],
              [-34.90782630099994, -7.104180596999925],
              [-34.90851803299995, -7.11687590899993],
              [-34.91466223899994, -7.13054778399993],
              [-34.89606686099995, -7.117445570999905],
              [-34.87564042899993, -7.095635674999926],
              [-34.859364386999914, -7.071465752999927],
              [-34.85265051999994, -7.051690362999921],
              [-34.84878495999993, -7.030205987999921],
              [-34.83617102799991, -6.991794528999947],
              [-34.83958899599992, -6.972914320999905],
              [-34.82579505099994, -6.984470309999949],
              [-34.824208136999914, -7.003350518999923],
              [-34.83275305899991, -7.041192315999922],
              [-34.83275305899991, -7.099786065999922],
              [-34.82795162699995, -7.130059502999927],
              [-34.82530676999994, -7.137383721999925],
              [-34.81875566299993, -7.14421965899993],
              [-34.80211341099994, -7.154066664999959],
              [-34.79735266799992, -7.158461195999905],
              [-34.79360917899993, -7.176202080999929],
              [-34.79674231699994, -7.192966403999947],
              [-34.802072719999956, -7.208754164999959],
              [-34.804798956999946, -7.223321221999925],
              [-34.804798956999946, -7.37078215899993],
              [-34.814442511999914, -7.444512627999927],
              [-34.81460527299993, -7.483819268999923],
              [-34.804798956999946, -7.514092705999929],
              [-34.81550045499995, -7.542575778999947],
              [-34.81916256399995, -7.548272393999923],
              [-34.824289516999954, -7.54851653399993],
              [-34.833973761999914, -7.543064059999949],
              [-34.84162350199995, -7.541761976999908],
              [-34.88060462099992, -7.541599216999941],
              [-34.89338131399995, -7.542901299999926],
              [-34.897328253999945, -7.543226820999905],
              [-34.912668423999946, -7.547784112999921],
              [-34.928944464999915, -7.555759372999944],
              [-34.86546790299991, -7.553399346999925],
              [-34.835386111999924, -7.562727305999942],
              [-34.831400283999926, -7.582438221999951],
              [-34.82048871999996, -7.59968682799996],
              [-34.80894934799994, -7.613702080999929],
              [-34.80530386899994, -7.622716],
              [-34.81300378499992, -7.63851750099991],
              [-34.81993059899992, -7.653544653999916],
              [-34.8303042199999, -7.68088812499991],
              [-34.83729503099994, -7.679757011999925],
              [-34.83726966099994, -7.667087497999944],
              [-34.83958899599992, -7.65593840899993],
              [-34.83958899599992, -7.64381275799991],
              [-34.843739386999914, -7.650567315999922],
              [-34.84544837099992, -7.656996351999908],
              [-34.845814581999946, -7.671807549999926],
              [-34.86782792899993, -7.632419528999947],
              [-34.87376868399991, -7.617771091999941],
              [-34.87604732999995, -7.637302341999941],
              [-34.86017027799994, -7.685986614999933],
              [-34.86436844199994, -7.705229648999932],
              [-34.87679655099993, -7.70296385599994],
              [-34.8872571629999, -7.708382440999912],
              [-34.89999798799994, -7.718044655999961],
              [-34.90721594999991, -7.733819268999923],
              [-34.887928839999915, -7.723565362999921],
              [-34.87753100099991, -7.714503222999952],
              [-34.86938040199993, -7.714475870999934],
              [-34.86587616799994, -7.717540457999917],
              [-34.86933293199991, -7.727550290999943],
              [-34.875899132999905, -7.736416902999906],
              [-34.88440294599991, -7.745289878999927],
              [-34.8920957279999, -7.762618068999927],
              [-34.893524820999914, -7.804926799999919],
              [-34.88494418699992, -7.81566313299993],
              [-34.84803774099993, -7.822837699999923],
              [-34.847226673999955, -7.834375810999916],
              [-34.844079618999956, -7.848216296999908],
              [-34.845814581999946, -7.884698174999926],
              [-34.83275305899991, -7.857354424999926],
              [-34.82648678299995, -7.869235934999949],
              [-34.81777910099993, -7.89381275799991],
              [-34.81163489499994, -7.905857028999947],
              [-34.81700598899994, -7.91334400799991],
              [-34.81883704299992, -7.919040622999944],
              [-34.816965298999946, -7.924737237999921],
              [-34.81163489499994, -7.932549737999921],
              [-34.82144120999993, -7.952243747999944],
              [-34.845773891999954, -8.041680596999925],
              [-34.845814581999946, -8.059177341999941],
              [-34.85118567599994, -8.068617445999905],
              [-34.86367753799993, -8.07040780999995],
              [-34.88060462099992, -8.062758070999905],
              [-34.90086829299992, -8.04265715899993],
              [-34.912668423999946, -8.035414320999905],
              [-34.928944464999915, -8.03492603999996],
              [-34.91344153599994, -8.045505466999941],
              [-34.90684973899994, -8.052666924999926],
              [-34.90103105399993, -8.062758070999905],
              [-34.897694464999915, -8.074965101999908],
              [-34.89757239499994, -8.08489348799992],
              [-34.895741339999915, -8.09384530999995],
              [-34.88735917899993, -8.103773695999905],
              [-34.88353430899991, -8.09693775799991],
              [-34.88060462099992, -8.08953215899993],
              [-34.88133704299992, -8.105401299999926],
              [-34.894195115999935, -8.141371351999908],
              [-34.900380011999914, -8.179620049999926],
              [-34.90416419199994, -8.189385674999926],
              [-34.920765753999945, -8.214450778999947],
              [-34.93211829299992, -8.242120049999926],
              [-34.93887285099993, -8.272067966999941],
              [-34.942616339999915, -8.31023528399993],
              [-34.942250128999945, -8.337334893999923],
              [-34.93858801999994, -8.347100518999923],
              [-34.93993079299992, -8.350762627999927],
              [-34.94591223899994, -8.35670338299991],
              [-34.95250403599994, -8.364678643999923],
              [-34.95567786399994, -8.374444268999923],
              [-34.95734615799995, -8.38250090899993],
              [-35.026234503999945, -8.57586028399993],
              [-35.06969153599994, -8.662367445999905],
              [-35.06895911399994, -8.672295830999929],
              [-35.08023027299993, -8.681084893999923],
              [-35.08421790299991, -8.70126718499995],
              [-35.086008266999954, -8.740655205999929],
              [-35.09650631399995, -8.76148853999996],
              [-35.12734941299993, -8.806247653999947],
              [-35.13377844999991, -8.826918226999908],
              [-35.13805091099994, -8.871351820999905],
              [-35.14745032499991, -8.91187916499996],
              [-35.18887285099993, -8.990655205999929],
              [-35.23224850199995, -9.04778411299992],
              [-35.26048743399991, -9.114027601999908],
              [-35.28941809799994, -9.15357838299991],
              [-35.30508378799993, -9.19304778399993],
              [-35.39216061099995, -9.305759372999944],
              [-35.414947068999936, -9.323418877999927],
              [-35.414947068999936, -9.316582940999922],
              [-35.43781490799995, -9.328383070999905],
              [-35.46231035099993, -9.34661223799992],
              [-35.48204505099994, -9.367852471999925],
              [-35.49010169199994, -9.388929945999905],
              [-35.49323482999995, -9.40406666499996],
              [-35.57363847599993, -9.52271900799991],
              [-35.582590298999946, -9.53289153399993],
              [-35.63036048099991, -9.563653252999927],
              [-35.657541469999956, -9.57708098799992],
              [-35.675119594999956, -9.60865650799991],
              [-35.696156378999945, -9.672946872999944],
              [-35.70933997299994, -9.674574476999908],
              [-35.71910559799994, -9.67782968499995],
              [-35.74331620999993, -9.67978280999995],
              [-35.75230872299994, -9.682712497999944],
              [-35.76085364499994, -9.687107028999947],
              [-35.77806555899991, -9.70012786299992],
              [-35.76305091099994, -9.675713799999926],
              [-35.74909420499995, -9.65984465899993],
              [-35.74624589799993, -9.641778252999927],
              [-35.76504472599993, -9.610772393999923],
              [-35.773426886999914, -9.600355726999908],
              [-35.786040818999936, -9.588555596999925],
              [-35.79991614499994, -9.584730726999908],
              [-35.812163865999935, -9.597832940999922],
              [-35.809885219999956, -9.604587497999944],
              [-35.79523678299995, -9.629164320999905],
              [-35.79173743399991, -9.642185153999947],
              [-35.79173743399991, -9.669122002999927],
              [-35.794911261999914, -9.679131768999923],
              [-35.801991339999915, -9.684258721999925],
              [-35.80899003799993, -9.686944268999923],
              [-35.853179490999935, -9.731215101999908],
              [-35.85814368399991, -9.734551690999922],
              [-35.868397589999915, -9.71803150799991],
              [-35.87710527299993, -9.69695403399993],
              [-35.87734941299993, -9.686618747999944],
              [-35.90843665299991, -9.63876718499995],
              [-35.90542558499993, -9.62476978999996],
              [-35.919585740999935, -9.608086846999925],
              [-35.94188391799992, -9.599786065999922],
              [-35.96304277299993, -9.610772393999923],
              [-35.95156816299993, -9.627618096999925],
              [-35.92320716099994, -9.64576588299991],
              [-35.90843665299991, -9.659274997999944],
              [-35.90217037699995, -9.67115650799991],
              [-35.878977016999954, -9.749200127999927],
              [-35.87364661399994, -9.755466403999947],
              [-35.86091061099995, -9.760023695999905],
              [-35.857411261999914, -9.755303643999923],
              [-35.85692298099991, -9.74700286299992],
              [-35.853179490999935, -9.74114348799992],
              [-35.819569464999915, -9.735528252999927],
              [-35.805572068999936, -9.731052341999941],
              [-35.79857337099992, -9.720635674999926],
              [-35.810617641999954, -9.744805596999925],
              [-35.86204993399991, -9.794040622999944],
              [-35.88267981699994, -9.855645440999922],
              [-35.90392005099994, -9.87818775799991],
              [-35.94937089799993, -9.913181247999944],
              [-35.97329667899993, -9.96575286299992],
              [-35.98037675699993, -9.974541924999926],
              [-35.99201412699995, -9.980726820999905],
              [-36.00218665299991, -9.995538018999923],
              [-36.03628495999993, -10.06414153399993],
              [-36.050119594999956, -10.078545830999929],
              [-36.09032141799992, -10.09343840899993],
              [-36.141184048999946, -10.15943775799991],
              [-36.25104732999995, -10.248223565999922],
              [-36.280506964999915, -10.279961846999925],
              [-36.28897050699993, -10.297051690999922],
              [-36.29198157499991, -10.320245049999926],
              [-36.29092363199993, -10.332289320999905],
              [-36.289173956999946, -10.338962497999944],
              [-36.28880774599992, -10.344008070999905],
              [-36.29198157499991, -10.351983330999929],
              [-36.40807044199994, -10.502129815999922],
              [-36.420765753999945, -10.50872161299992],
              [-36.457915818999936, -10.52044036299992],
              [-36.48607337099992, -10.523370049999926],
              [-36.50499426999994, -10.527764580999929],
              [-36.52013098899994, -10.533786716999941],
              [-36.53844153599994, -10.543633721999925],
              [-36.57656816299993, -10.55046965899993],
              [-36.58193925699993, -10.553806247999944],
              [-36.591786261999914, -10.567803643999923],
              [-36.59675045499995, -10.570977471999925],
              [-36.61091061099995, -10.57512786299992],
              [-36.76838131399995, -10.672621351999908],
              [-36.90306555899991, -10.772881768999923],
              [-36.95270748599995, -10.836358330999929],
              [-36.96336829299992, -10.865411065999922],
              [-36.97887122299994, -10.88648853999996],
              [-37.029367641999954, -10.93564218499995],
              [-37.03966223899994, -10.949151299999926],
              [-37.04442298099991, -10.964450778999947],
              [-37.04552161399994, -10.98528411299992],
              [-37.050445115999935, -10.999607028999947],
              [-37.12401282499991, -11.11532968499995],
              [-37.13829505099994, -11.12590911299992],
              [-37.14761308499993, -11.121758721999925],
              [-37.147043423999946, -11.111993096999925],
              [-37.14281165299991, -11.100681247999944],
              [-37.14171301999994, -11.091729424999926],
              [-37.14663652299993, -11.08521900799991],
              [-37.15217037699995, -11.08367278399993],
              [-37.15758216099994, -11.08098723799992],
              [-37.162220831999946, -11.071384372999944],
              [-37.16966712099992, -11.071384372999944],
              [-37.17568925699993, -11.08570728999996],
              [-37.185210740999935, -11.074151299999926],
              [-37.200062628999945, -11.043389580999929],
              [-37.20685787699995, -11.03915780999995],
              [-37.24852454299992, -11.021661065999922],
              [-37.25841223899994, -11.019789320999905],
              [-37.26154537699995, -11.015232028999947],
              [-37.26838131399995, -11.016371351999908],
              [-37.27513587099992, -11.02271900799991],
              [-37.278228318999936, -11.033379815999922],
              [-37.27611243399991, -11.041761976999908],
              [-37.27086341099994, -11.053317966999941],
              [-37.26431230399993, -11.064385674999926],
              [-37.25841223899994, -11.071384372999944],
              [-37.25157630099994, -11.073011976999908],
              [-37.24461829299992, -11.070896091999941],
              [-37.236887173999946, -11.06959400799991],
              [-37.227406378999945, -11.074802341999941],
              [-37.219309048999946, -11.081149997999944],
              [-37.21129309799994, -11.085870049999926],
              [-37.19635982999995, -11.091729424999926],
              [-37.19635982999995, -11.09856536299992],
              [-37.21422278599994, -11.091729424999926],
              [-37.220692511999914, -11.096774997999944],
              [-37.216786261999914, -11.106133721999925],
              [-37.20376542899993, -11.11223723799992],
              [-37.19444739499994, -11.110528252999927],
              [-37.190337693999936, -11.10475025799991],
              [-37.18781490799995, -11.099541924999926],
              [-37.18268795499995, -11.09856536299992],
              [-37.17267818899995, -11.103122653999947],
              [-37.16563880099994, -11.108819268999923],
              [-37.16392981699994, -11.116387627999927],
              [-37.16966712099992, -11.12590911299992],
              [-37.163319464999915, -11.136163018999923],
              [-37.164051886999914, -11.170342705999929],
              [-37.15538489499994, -11.187432549999926],
              [-37.15538489499994, -11.181247653999947],
              [-37.14915930899991, -11.187432549999926],
              [-37.17247473899994, -11.203545830999929],
              [-37.19945227799991, -11.215264580999929],
              [-37.22179114499994, -11.229587497999944],
              [-37.23110917899993, -11.25286223799992],
              [-37.23542232999995, -11.260837497999944],
              [-37.245350714999915, -11.267022393999923],
              [-37.25658118399991, -11.272230726999908],
              [-37.26463782499991, -11.27743905999995],
              [-37.26976477799991, -11.28484465899993],
              [-37.28575598899994, -11.317071221999925],
              [-37.31602942599994, -11.406426690999922],
              [-37.330067511999914, -11.420668226999908],
              [-37.37486731699994, -11.429864190999922],
              [-37.38809160099993, -11.426934502999927],
              [-37.389881964999915, -11.419040622999944],
              [-37.384429490999935, -11.40943775799991],
              [-37.384429490999935, -11.401950778999947],
              [-37.402455206999946, -11.39967213299991],
              [-37.37437903599994, -11.362399997999944],
              [-37.36827551999994, -11.35125090899993],
              [-37.362172003999945, -11.324802341999941],
              [-37.358306443999936, -11.315850518999923],
              [-37.34715735599991, -11.303399346999925],
              [-37.305572068999936, -11.269952080999929],
              [-37.294992641999954, -11.258233330999929],
              [-37.29051673099991, -11.254327080999929],
              [-37.27208411399994, -11.249444268999923],
              [-37.28587805899991, -11.236993096999925],
              [-37.28844153599994, -11.208184502999927],
              [-37.299387173999946, -11.194756768999923],
              [-37.30333411399994, -11.219821872999944],
              [-37.30308997299994, -11.231215101999908],
              [-37.299387173999946, -11.242608330999929],
              [-37.305572068999936, -11.242608330999929],
              [-37.32412675699993, -11.208591403999947],
              [-37.336781378999945, -11.190524997999944],
              [-37.34410559799994, -11.184258721999925],
              [-37.34788977799991, -11.204196872999944],
              [-37.319976365999935, -11.24976978999996],
              [-37.319203253999945, -11.269952080999929],
              [-37.32559160099993, -11.263116143999923],
              [-37.34715735599991, -11.249444268999923],
              [-37.34618079299992, -11.26100025799991],
              [-37.34129798099991, -11.26767343499995],
              [-37.336048956999946, -11.272881768999923],
              [-37.33348548099991, -11.280450127999927],
              [-37.33629309799994, -11.290134372999944],
              [-37.34312903599994, -11.29273853999996],
              [-37.35204016799992, -11.293389580999929],
              [-37.36082923099991, -11.29656340899993],
              [-37.37144934799994, -11.30632903399993],
              [-37.379750128999945, -11.317152601999908],
              [-37.39557857999995, -11.34498463299991],
              [-37.408192511999914, -11.395684502999927],
              [-37.41539466099994, -11.406426690999922],
              [-37.42955481699994, -11.405043226999908],
              [-37.43626868399991, -11.38876718499995],
              [-37.443348761999914, -11.35125090899993],
              [-37.44566809799994, -11.364434502999927],
              [-37.45177161399994, -11.370538018999923],
              [-37.46043860599991, -11.36891041499996],
              [-37.47008216099994, -11.35865650799991],
              [-37.46035722599993, -11.391778252999927],
              [-37.45372473899994, -11.40357838299991],
              [-37.443348761999914, -11.413262627999927],
              [-37.40172278599994, -11.428887627999927],
              [-37.39557857999995, -11.437432549999926],
              [-37.40599524599992, -11.47047291499996],
              [-37.43138587099992, -11.492852471999925],
              [-37.462961391999954, -11.507419528999947],
              [-37.491851365999935, -11.516289971999925],
              [-37.47484290299991, -11.520114841999941],
              [-37.45384680899991, -11.51767343499995],
              [-37.43276933499993, -11.511163018999923],
              [-37.41539466099994, -11.50318775799991],
              [-37.40196692599994, -11.490980726999908],
              [-37.38975989499994, -11.47437916499996],
              [-37.37677975199995, -11.46021900799991],
              [-37.36082923099991, -11.45484791499996],
              [-37.36823482999995, -11.473809502999927],
              [-37.43472245999993, -11.56926848799992],
              [-37.50918535099993, -11.723809502999927],
              [-37.51341712099992, -11.76067473799992],
              [-37.52281653599994, -11.776136976999908],
              [-37.545765753999945, -11.80437590899993],
              [-37.60423743399991, -11.949965101999908],
              [-37.631743943999936, -11.995293877999927],
              [-37.65465247299994, -12.04973723799992],
              [-37.717640753999945, -12.13640715899993],
              [-37.78670973299995, -12.264634132999959],
              [-37.87117534899994, -12.382262528999945],
              [-37.9333901089999, -12.47537615999994],
              [-37.99852454299992, -12.56218840899993],
              [-38.050892706999946, -12.641045830999929],
              [-38.06346594999991, -12.647230726999908],
              [-38.07396399599992, -12.653903903999947],
              [-38.14549719999991, -12.735039971999925],
              [-38.21324622299994, -12.82000090899993],
              [-38.29137122299994, -12.894952080999929],
              [-38.320423956999946, -12.93523528399993],
              [-38.33999589799993, -12.950290622999944],
              [-38.361398891999954, -12.96184661299992],
              [-38.371937628999945, -12.965264580999929],
              [-38.39427649599992, -12.96843840899993],
              [-38.40611731699994, -12.96884530999995],
              [-38.41624915299991, -12.973077080999929],
              [-38.43700110599991, -12.992364190999922],
              [-38.464955206999946, -13.002373955999929],
              [-38.486439581999946, -13.01376718499995],
              [-38.50967363199993, -13.021416924999926],
              [-38.53270423099991, -13.01653411299992],
              [-38.538319464999915, -13.00400155999995],
              [-38.51838131399995, -12.96689218499995],
              [-38.507923956999946, -12.931817315999922],
              [-38.49779212099992, -12.918389580999929],
              [-38.48619544199994, -12.915948174999926],
              [-38.477406378999945, -12.93523528399993],
              [-38.479074673999946, -12.915948174999926],
              [-38.48704993399991, -12.898858330999929],
              [-38.49120032499991, -12.882012627999927],
              [-38.47565670499995, -12.85165780999995],
              [-38.48009192599994, -12.842217705999929],
              [-38.48766028599994, -12.834730726999908],
              [-38.49176998599995, -12.82935963299991],
              [-38.492298956999946, -12.822442315999922],
              [-38.494130011999914, -12.81764088299991],
              [-38.50226803299995, -12.80828215899993],
              [-38.50405839799993, -12.804131768999923],
              [-38.50226803299995, -12.80055103999996],
              [-38.49974524599992, -12.79656340899993],
              [-38.49913489499994, -12.791192315999922],
              [-38.50890051999994, -12.722914320999905],
              [-38.52696692599994, -12.723077080999929],
              [-38.54238847599993, -12.72161223799992],
              [-38.557484503999945, -12.715508721999925],
              [-38.574289516999954, -12.701836846999925],
              [-38.60594641799992, -12.713636976999908],
              [-38.626210089999915, -12.70240650799991],
              [-38.637603318999936, -12.680759372999944],
              [-38.64858964799993, -12.63836028399993],
              [-38.65615800699993, -12.63372161299992],
              [-38.66714433499993, -12.63404713299991],
              [-38.68346106699994, -12.62672291499996],
              [-38.694569464999915, -12.614027601999908],
              [-38.69517981699994, -12.60279713299991],
              [-38.69180253799993, -12.589776299999926],
              [-38.69098873599995, -12.571465752999927],
              [-38.69713294199994, -12.571465752999927],
              [-38.71580969999991, -12.605075778999947],
              [-38.72207597599993, -12.622491143999923],
              [-38.72447669199994, -12.64348723799992],
              [-38.72447669199994, -12.671075127999927],
              [-38.72630774599992, -12.678887627999927],
              [-38.73033606699994, -12.682386976999908],
              [-38.73497473899994, -12.68450286299992],
              [-38.73814856699994, -12.68759530999995],
              [-38.75096594999991, -12.712823174999926],
              [-38.75039628799993, -12.724541924999926],
              [-38.73814856699994, -12.736586195999905],
              [-38.77721106699994, -12.80754973799992],
              [-38.789947068999936, -12.818536065999922],
              [-38.795480923999946, -12.821465752999927],
              [-38.806630011999914, -12.835137627999927],
              [-38.81383216099994, -12.839043877999927],
              [-38.82445227799991, -12.838148695999905],
              [-38.83556067599994, -12.828383070999905],
              [-38.84487870999993, -12.82594166499996],
              [-38.85582434799994, -12.816827080999929],
              [-38.86400305899991, -12.795098565999922],
              [-38.88272050699993, -12.722100518999923],
              [-38.88117428299995, -12.705336195999905],
              [-38.86986243399991, -12.692071221999925],
              [-38.84801184799994, -12.674493096999925],
              [-38.86168372299994, -12.65406666499996],
              [-38.868478969999956, -12.65406666499996],
              [-38.863392706999946, -12.669854424999926],
              [-38.86986243399991, -12.67782968499995],
              [-38.88243567599994, -12.684177341999941],
              [-38.895822719999956, -12.69500090899993],
              [-38.903187628999945, -12.709405205999929],
              [-38.90583248599995, -12.721774997999944],
              [-38.91051184799994, -12.731052341999941],
              [-38.92369544199994, -12.736586195999905],
              [-38.91466223899994, -12.748467705999929],
              [-38.90367591099994, -12.77239348799992],
              [-38.895822719999956, -12.784356377999927],
              [-38.888010219999956, -12.790459893999923],
              [-38.88149980399993, -12.791680596999925],
              [-38.87535559799994, -12.794528903999947],
              [-38.868478969999956, -12.804864190999922],
              [-38.869211391999954, -12.809014580999929],
              [-38.869130011999914, -12.820570570999905],
              [-38.86701412699995, -12.834649346999925],
              [-38.86168372299994, -12.845879815999922],
              [-38.85399329299992, -12.85125090899993],
              [-38.83429928299995, -12.86060963299991],
              [-38.82750403599994, -12.86695728999996],
              [-38.81212317599994, -12.853692315999922],
              [-38.803618943999936, -12.848728122999944],
              [-38.79710852799991, -12.84929778399993],
              [-38.79279537699995, -12.85670338299991],
              [-38.78880774599992, -12.866631768999923],
              [-38.78368079299992, -12.872979424999926],
              [-38.77599036399994, -12.87004973799992],
              [-38.76545162699995, -12.864678643999923],
              [-38.75230872299994, -12.864434502999927],
              [-38.73802649599992, -12.867933851999908],
              [-38.72447669199994, -12.873223565999922],
              [-38.733713344999956, -12.879571221999925],
              [-38.736317511999914, -12.882745049999926],
              [-38.742176886999914, -12.897149346999925],
              [-38.746937628999945, -12.904554945999905],
              [-38.75080318899995, -12.912774346999925],
              [-38.75243079299992, -12.924981377999927],
              [-38.75133216099994, -12.946384372999944],
              [-38.75210527299993, -12.957289320999905],
              [-38.755848761999914, -12.965427341999941],
              [-38.76744544199994, -12.979180596999925],
              [-38.78685462099992, -13.008070570999905],
              [-38.800892706999946, -13.024021091999941],
              [-38.81554114499994, -13.036716403999947],
              [-38.83511308499993, -13.05006275799991],
              [-38.857085740999935, -13.06064218499995],
              [-38.879017706999946, -13.064873955999929],
              [-38.88927161399994, -13.069756768999923],
              [-38.89500891799992, -13.08098723799992],
              [-38.89688066299993, -13.09465911299992],
              [-38.895822719999956, -13.106540622999944],
              [-38.89338131399995, -13.113457940999922],
              [-38.88975989499994, -13.11842213299991],
              [-38.88414466099994, -13.12232838299991],
              [-38.87535559799994, -13.126397393999923],
              [-38.80699622299994, -13.14381275799991],
              [-38.810658331999946, -13.153497002999927],
              [-38.819569464999915, -13.156670830999929],
              [-38.830922003999945, -13.157810153999947],
              [-38.841786261999914, -13.161228122999944],
              [-38.85179602799991, -13.16887786299992],
              [-38.87535559799994, -13.19540780999995],
              [-38.931752081999946, -13.233005466999941],
              [-38.94762122299994, -13.246758721999925],
              [-38.95750891799992, -13.264825127999927],
              [-38.96349036399994, -13.305840752999927],
              [-38.97085527299993, -13.325616143999923],
              [-38.95685787699995, -13.356622002999927],
              [-38.95457923099991, -13.372491143999923],
              [-38.96471106699994, -13.380303643999923],
              [-38.98961341099994, -13.363946221999925],
              [-38.99885006399995, -13.360446872999944],
              [-39.00959225199995, -13.36028411299992],
              [-39.03978430899991, -13.366631768999923],
              [-39.037668423999946, -13.357842705999929],
              [-39.03697669199994, -13.350192966999941],
              [-39.03770911399994, -13.341973565999922],
              [-39.03978430899991, -13.332452080999929],
              [-39.062489386999914, -13.399997653999947],
              [-39.06822669199994, -13.440606377999927],
              [-39.06029212099992, -13.470310153999947],
              [-39.07103430899991, -13.480075778999947],
              [-39.07994544199994, -13.495293877999927],
              [-39.086008266999954, -13.514092705999929],
              [-39.08820553299995, -13.534274997999944],
              [-39.08421790299991, -13.578789971999925],
              [-39.09142005099994, -13.593682549999926],
              [-39.11554928299995, -13.59937916499996],
              [-39.11554928299995, -13.606133721999925],
              [-39.08665930899991, -13.603936455999929],
              [-39.077381964999915, -13.590020440999922],
              [-39.08079993399991, -13.54111093499995],
              [-39.07502193899995, -13.51726653399993],
              [-39.05968176999994, -13.494805596999925],
              [-39.037668423999946, -13.484551690999922],
              [-39.011830206999946, -13.49700286299992],
              [-39.007069464999915, -13.50481536299992],
              [-39.003163214999915, -13.522556247999944],
              [-38.995432094999956, -13.534274997999944],
              [-38.99299068899995, -13.54111093499995],
              [-38.996937628999945, -13.547051690999922],
              [-39.00267493399991, -13.553480726999908],
              [-39.00568600199995, -13.56178150799991],
              [-39.001942511999914, -13.588067315999922],
              [-38.99278723899994, -13.607679945999905],
              [-38.98143469999991, -13.625746351999908],
              [-38.97085527299993, -13.64771900799991],
              [-38.96784420499995, -13.674004815999922],
              [-38.97573808499993, -13.692559502999927],
              [-38.98656165299991, -13.71021900799991],
              [-38.99201412699995, -13.733086846999925],
              [-38.994211391999954, -13.79461028399993],
              [-38.99201412699995, -13.81226978999996],
              [-38.98184160099993, -13.827569268999923],
              [-38.97996985599991, -13.835870049999926],
              [-38.98859615799995, -13.83953215899993],
              [-39.00169837099992, -13.83766041499996],
              [-39.01121985599991, -13.832452080999929],
              [-39.02989661399994, -13.81536223799992],
              [-39.03734290299991, -13.805352471999925],
              [-39.04076087099992, -13.794040622999944],
              [-39.04287675699993, -13.782321872999944],
              [-39.04662024599992, -13.77125416499996],
              [-39.053578253999945, -13.760918877999927],
              [-39.06017005099994, -13.75514088299991],
              [-39.066965298999946, -13.750420830999929],
              [-39.07453365799995, -13.743340752999927],
              [-39.07957923099991, -13.740980726999908],
              [-39.083973761999914, -13.74195728999996],
              [-39.08702551999994, -13.74114348799992],
              [-39.09162350199995, -13.71266041499996],
              [-39.099680141999954, -13.708916924999926],
              [-39.11095130099994, -13.708184502999927],
              [-39.13255774599992, -13.709242445999905],
              [-39.14110266799992, -13.719170830999929],
              [-39.14875240799995, -13.736911716999941],
              [-39.14403235599991, -13.744317315999922],
              [-39.11554928299995, -13.72356536299992],
              [-39.11001542899993, -13.73170338299991],
              [-39.108265753999945, -13.740411065999922],
              [-39.11009680899991, -13.749118747999944],
              [-39.11554928299995, -13.75758228999996],
              [-39.071603969999956, -13.779554945999905],
              [-39.06029212099992, -13.791761976999908],
              [-39.04320227799991, -13.826348565999922],
              [-39.032134568999936, -13.840590101999908],
              [-38.997710740999935, -13.851739190999922],
              [-38.99445553299995, -13.863457940999922],
              [-38.999989386999914, -13.875176690999922],
              [-39.00877844999991, -13.88054778399993],
              [-39.03490149599992, -13.879652601999908],
              [-39.048939581999946, -13.87590911299992],
              [-39.06712805899991, -13.867445570999905],
              [-39.07453365799995, -13.89421965899993],
              [-39.071156378999945, -13.903090101999908],
              [-39.063710089999915, -13.935804945999905],
              [-39.057484503999945, -13.937920830999929],
              [-39.04124915299991, -13.947198174999926],
              [-39.021595831999946, -13.955661716999941],
              [-39.00739498599995, -13.96965911299992],
              [-38.99669348899994, -13.98560963299991],
              [-38.99201412699995, -13.997247002999927],
              [-38.99282792899993, -14.00904713299991],
              [-38.99559485599991, -14.019138278999947],
              [-38.99567623599995, -14.029229424999926],
              [-38.98281816299993, -14.050713799999926],
              [-38.97956295499995, -14.061130466999941],
              [-38.98082434799994, -14.069512627999927],
              [-38.98859615799995, -14.072930596999925],
              [-39.027902798999946, -14.078301690999922],
              [-39.03986568899995, -14.07512786299992],
              [-39.05406653599994, -14.059258721999925],
              [-39.07103430899991, -14.076348565999922],
              [-39.07286536399994, -14.085870049999926],
              [-39.06029212099992, -14.09970468499995],
              [-39.06680253799993, -14.105645440999922],
              [-39.07290605399993, -14.115166924999926],
              [-39.076242641999954, -14.127373955999929],
              [-39.07453365799995, -14.140557549999926],
              [-39.06672115799995, -14.15007903399993],
              [-39.055897589999915, -14.155043226999908],
              [-39.04564368399991, -14.16139088299991],
              [-39.03978430899991, -14.175388278999947],
              [-39.03359941299993, -14.175388278999947],
              [-39.05703691299993, -14.133558851999908],
              [-39.063384568999936, -14.109958591999941],
              [-39.04320227799991, -14.09970468499995],
              [-39.024281378999945, -14.096856377999927],
              [-39.002837693999936, -14.08953215899993],
              [-38.95726477799991, -14.06609465899993],
              [-38.959095831999946, -14.057305596999925],
              [-38.95836341099994, -14.045993747999944],
              [-38.95970618399991, -14.036228122999944],
              [-38.96784420499995, -14.031914971999925],
              [-38.97227942599994, -14.02662525799991],
              [-38.970692511999914, -14.014825127999927],
              [-38.96471106699994, -13.997247002999927],
              [-38.96532141799992, -13.99195728999996],
              [-38.96910559799994, -13.98919036299992],
              [-38.97142493399991, -13.986260674999926],
              [-38.96784420499995, -13.98056405999995],
              [-38.96304277299993, -13.97828541499996],
              [-38.95295162699995, -13.976983330999929],
              [-38.95103919199994, -13.97356536299992],
              [-38.95287024599992, -13.96257903399993],
              [-38.95807857999995, -13.95598723799992],
              [-38.96666419199994, -13.95208098799992],
              [-38.97834225199995, -13.949395440999922],
              [-38.97565670499995, -13.945733330999929],
              [-38.97085527299993, -13.935804945999905],
              [-38.987538214999915, -13.939873955999929],
              [-38.98997962099992, -13.930840752999927],
              [-38.98375403599994, -13.916273695999905],
              [-38.974598761999914, -13.904473565999922],
              [-38.96385657499991, -13.897067966999941],
              [-38.948882615999935, -13.89031340899993],
              [-38.935658331999946, -13.888929945999905],
              [-38.92992102799991, -13.897637627999927],
              [-38.92906653599994, -13.983168226999908],
              [-38.92369544199994, -14.004082940999922],
              [-38.94668535099993, -14.102308851999908],
              [-38.95929928299995, -14.122165622999944],
              [-38.96471106699994, -14.13372161299992],
              [-38.966867641999954, -14.145928643999923],
              [-38.96837317599994, -14.17001718499995],
              [-38.97085527299993, -14.181573174999926],
              [-38.98924719999991, -14.212334893999923],
              [-38.99201412699995, -14.22665780999995],
              [-38.99201412699995, -14.267836195999905],
              [-38.98420162699995, -14.299411716999941],
              [-38.98517818899995, -14.31259530999995],
              [-38.99209550699993, -14.324965101999908],
              [-39.00072180899991, -14.33570728999996],
              [-39.00499426999994, -14.346856377999927],
              [-38.99885006399995, -14.36028411299992],
              [-39.00694739499994, -14.370293877999927],
              [-39.00763912699995, -14.383233330999929],
              [-39.00560462099992, -14.39820728999996],
              [-39.00568600199995, -14.41497161299992],
              [-39.02611243399991, -14.463311455999929],
              [-39.03359941299993, -14.53915780999995],
              [-39.05142167899993, -14.591973565999922],
              [-39.05626380099994, -14.622247002999927],
              [-39.06558183499993, -14.654880466999941],
              [-39.06712805899991, -14.674981377999927],
              [-39.05406653599994, -14.754082940999922],
              [-39.050852016999954, -14.765801690999922],
              [-39.03673255099994, -14.779473565999922],
              [-39.03359941299993, -14.79225025799991],
              [-39.04564368399991, -14.796075127999927],
              [-39.05296790299991, -14.801364841999941],
              [-39.05406653599994, -14.81218840899993],
              [-39.04824785099993, -14.818617445999905],
              [-39.03921464799993, -14.817559502999927],
              [-39.02969316299993, -14.814629815999922],
              [-39.022694464999915, -14.815850518999923],
              [-39.02611243399991, -14.85719166499996],
              [-39.02293860599991, -14.900323174999926],
              [-39.00890051999994, -14.970879815999922],
              [-39.00182044199994, -15.232028903999947],
              [-38.97964433499993, -15.323663018999923],
              [-38.97325598899994, -15.409356377999927],
              [-38.94326738199993, -15.56536223799992],
              [-38.923898891999954, -15.715590101999908],
              [-38.90489661399994, -15.75750090899993],
              [-38.89240475199995, -15.774997653999947],
              [-38.88857988199993, -15.78289153399993],
              [-38.88272050699993, -15.812676690999922],
              [-38.87791907499991, -15.82236093499995],
              [-38.86436926999994, -15.843357028999947],
              [-38.86168372299994, -15.854261976999908],
              [-38.86701412699995, -15.869724216999941],
              [-38.89049231699994, -15.90439218499995],
              [-38.895822719999956, -15.91887786299992],
              [-38.89875240799995, -15.940036716999941],
              [-38.92369544199994, -16.00514088299991],
              [-38.92418372299994, -16.023614190999922],
              [-38.92955481699994, -16.03834400799991],
              [-38.944203253999945, -16.066582940999922],
              [-38.94786536399994, -16.081475518999923],
              [-38.95274817599994, -16.167087497999944],
              [-38.95726477799991, -16.18328215899993],
              [-38.998036261999914, -16.25286223799992],
              [-39.00536048099991, -16.27507903399993],
              [-39.00767981699994, -16.29924895599993],
              [-39.00568600199995, -16.32659270599993],
              [-39.00690670499995, -16.359307549999926],
              [-39.01838131399995, -16.383070570999905],
              [-39.05406653599994, -16.43645598799992],
              [-39.04963131399995, -16.44703541499996],
              [-39.05064856699994, -16.45671965899993],
              [-39.06029212099992, -16.478122653999947],
              [-39.09227454299992, -16.657810153999947],
              [-39.135975714999915, -16.800225518999923],
              [-39.135975714999915, -16.84465911299992],
              [-39.13377844999991, -16.855726820999905],
              [-39.12169348899994, -16.878513278999947],
              [-39.12157141799992, -16.892022393999923],
              [-39.123605923999946, -16.897881768999923],
              [-39.149647589999915, -16.95045338299991],
              [-39.168812628999945, -17.07594166499996],
              [-39.18374589799993, -17.11492278399993],
              [-39.202056443999936, -17.14421965899993],
              [-39.20860755099994, -17.16220468499995],
              [-39.217355923999946, -17.295098565999922],
              [-39.209055141999954, -17.38209400799991],
              [-39.190012173999946, -17.43027109199994],
              [-39.18626868399991, -17.45208098799992],
              [-39.188384568999936, -17.578383070999905],
              [-39.18374589799993, -17.60084400799991],
              [-39.16673743399991, -17.633965752999927],
              [-39.14696204299992, -17.65715911299992],
              [-39.13711503799993, -17.679620049999926],
              [-39.149647589999915, -17.71070728999996],
              [-39.25890051999994, -17.82073333099993],
              [-39.26821855399993, -17.83652109199994],
              [-39.27135169199994, -17.84628671699994],
              [-39.27257239499994, -17.858575127999927],
              [-39.275054490999935, -17.86687590899993],
              [-39.281361456999946, -17.871026299999926],
              [-39.28929602799991, -17.874118747999944],
              [-39.31419837099992, -17.89031340899993],
              [-39.38239498599995, -17.90325286299992],
              [-39.41783606699994, -17.920993747999944],
              [-39.45018469999991, -17.948011976999908],
              [-39.49909420499995, -18.00562916499996],
              [-39.624989386999914, -18.19264088299991],
              [-39.659413214999915, -18.273614190999922],
              [-39.67259680899991, -18.32317473799992],
              [-39.724680141999954, -18.518731377999927],
              [-39.74486243399991, -18.68173593499995],
              [-39.741078253999945, -18.90211353999996],
              [-39.71922766799992, -19.090508721999925],
              [-39.69806881399995, -19.23992278399993],
              [-39.70140540299991, -19.376153252999927],
              [-39.70978756399995, -19.41611093499995],
              [-39.78620357999995, -19.60198333099993],
              [-39.80699622299994, -19.636163018999923],
              [-39.834868943999936, -19.65715911299992],
              [-39.95099850199995, -19.70517343499995],
              [-40.009429490999935, -19.74700286299992],
              [-40.02684485599991, -19.764418226999908],
              [-40.083648240999935, -19.89544036299992],
              [-40.08812415299991, -19.91448333099993],
              [-40.09740149599992, -19.93059661299992],
              [-40.14167232999995, -19.945570570999905],
              [-40.15705318899995, -19.958916924999926],
              [-40.134429490999935, -19.958916924999926],
              [-40.13198808499993, -19.971856377999927],
              [-40.146473761999914, -20.023044528999947],
              [-40.15387936099995, -20.027601820999905],
              [-40.162668423999946, -20.029554945999905],
              [-40.170033331999946, -20.033949476999908],
              [-40.178618943999936, -20.04338958099993],
              [-40.17747962099992, -20.058526299999926],
              [-40.17540442599994, -20.06731536299992],
              [-40.166086391999954, -20.08652109199994],
              [-40.16388912699995, -20.09612395599993],
              [-40.16592363199993, -20.10588958099993],
              [-40.17540442599994, -20.125258070999905],
              [-40.19098873599995, -20.18987395599993],
              [-40.19489498599995, -20.19850025799991],
              [-40.20254472599993, -20.207696221999925],
              [-40.222767706999946, -20.251560153999947],
              [-40.23277747299994, -20.266778252999927],
              [-40.241525844999956, -20.275567315999922],
              [-40.24437415299991, -20.277520440999922],
              [-40.24722245999993, -20.27353280999995],
              [-40.25609290299991, -20.26376718499995],
              [-40.266184048999946, -20.260511976999908],
              [-40.273548956999946, -20.267510674999926],
              [-40.27993730399993, -20.276950778999947],
              [-40.28673255099994, -20.28101978999996],
              [-40.298085089999915, -20.273695570999905],
              [-40.29320227799991, -20.24504973799992],
              [-40.30040442599994, -20.232679945999905],
              [-40.316395636999914, -20.227959893999923],
              [-40.336048956999946, -20.227634372999944],
              [-40.36929277299993, -20.232679945999905],
              [-40.35619055899991, -20.243340752999927],
              [-40.350900844999956, -20.256524346999925],
              [-40.35655676999994, -20.266371351999908],
              [-40.37612870999993, -20.266778252999927],
              [-40.37612870999993, -20.274183851999908],
              [-40.37173417899993, -20.275567315999922],
              [-40.36872311099995, -20.276950778999947],
              [-40.361887173999946, -20.28101978999996],
              [-40.37047278599994, -20.301039320999905],
              [-40.365970776999916, -20.323231188999955],
              [-40.34787808599992, -20.32620552599991],
              [-40.323947852999936, -20.324838160999946],
              [-40.32539155499995, -20.337532439999904],
              [-40.314699902999905, -20.334268206999923],
              [-40.30064856699994, -20.319431247999944],
              [-40.282460089999915, -20.31422291499996],
              [-40.25951087099992, -20.321465752999927],
              [-40.275054490999935, -20.333916924999926],
              [-40.29063880099994, -20.350681247999944],
              [-40.30247962099992, -20.37086353999996],
              [-40.31265214799993, -20.41725025799991],
              [-40.33653723899994, -20.45566171699994],
              [-40.34874426999994, -20.50009530999995],
              [-40.396595831999946, -20.569024346999925],
              [-40.41832434799994, -20.61532968499995],
              [-40.43321692599994, -20.62867603999996],
              [-40.451283331999946, -20.61687590899993],
              [-40.47533118399991, -20.637790622999944],
              [-40.483631964999915, -20.64820728999996],
              [-40.52448482999995, -20.71575286299992],
              [-40.534413214999915, -20.726739190999922],
              [-40.55606035099993, -20.743584893999923],
              [-40.56517493399991, -20.753024997999944],
              [-40.58342363999992, -20.80197229199996],
              [-40.60939919099991, -20.80728935299993],
              [-40.619564501999946, -20.83390129199995],
              [-40.62843837799994, -20.83921762199992],
              [-40.63390051999994, -20.829522393999923],
              [-40.636830206999946, -20.81894296699994],
              [-40.64159094999991, -20.808200778999947],
              [-40.65208899599992, -20.808038018999923],
              [-40.66246497299994, -20.81259530999995],
              [-40.667225714999915, -20.815524997999944],
              [-40.701378348999924, -20.835956383999928],
              [-40.731724785999916, -20.843837977999954],
              [-40.74630356999995, -20.85288154299991],
              [-40.758463254999924, -20.864194032999933],
              [-40.760932717999935, -20.882329444999925],
              [-40.773084601999926, -20.889107640999953],
              [-40.779186533999905, -20.902699790999918],
              [-40.78893099599992, -20.91628473499992],
              [-40.80110878599993, -20.93099616099994],
              [-40.808479621999936, -20.962725390999935],
              [-40.807363256999906, -20.997874860999957],
              [-40.81138185799995, -21.018847518999905],
              [-40.81461323399992, -21.036611586999925],
              [-40.83067786399994, -21.04924895599993],
              [-40.83958899599992, -21.068291924999926],
              [-40.84166419199994, -21.079278252999927],
              [-40.846547003999945, -21.094496351999908],
              [-40.92234944899991, -21.190463834999946],
              [-40.95180979499992, -21.238104397999905],
              [-40.9651179679999, -21.27402109199994],
              [-40.96519934799994, -21.274834893999923],
              [-40.96007239499994, -21.287367445999905],
              [-40.95921790299991, -21.303399346999925],
              [-40.96129309799994, -21.320245049999926],
              [-40.96519934799994, -21.33562590899993],
              [-40.96350251399991, -21.364502600999913],
              [-40.98325178099992, -21.391306706999956],
              [-41.01816398799991, -21.441723795999906],
              [-41.04954993399991, -21.46933359199994],
              [-41.05724036399994, -21.483819268999923],
              [-41.071867555999916, -21.52333853199991],
              [-41.05934587899992, -21.56104476899992],
              [-41.01854407499991, -21.608086846999925],
              [-41.01353919199994, -21.651543877999927],
              [-41.02472895099993, -21.71919005299992],
              [-41.006743943999936, -21.823418877999927],
              [-40.96727454299992, -21.947523695999905],
              [-40.972645636999914, -21.98674895599993],
              [-40.99526933499993, -22.01425546699994],
              [-41.14126542899993, -22.096774997999944],
              [-41.24369487699994, -22.14521276699992],
              [-41.345692511999914, -22.172051690999922],
              [-41.465728318999936, -22.202569268999923],
              [-41.55516516799992, -22.232354424999926],
              [-41.66649329299992, -22.28183359199994],
              [-41.74136308499993, -22.32903411299992],
              [-41.770822719999956, -22.354180596999925],
              [-41.775949673999946, -22.36256275799991],
              [-41.778960740999935, -22.380303643999923],
              [-41.784494594999956, -22.388604424999926],
              [-41.80260169199994, -22.40203215899993],
              [-41.834828253999945, -22.419528903999947],
              [-41.849680141999954, -22.433038018999923],
              [-41.868478969999956, -22.46851978999996],
              [-41.87352454299992, -22.47389088299991],
              [-41.88255774599992, -22.47584400799991],
              [-41.892689581999946, -22.48023853999996],
              [-41.90086829299992, -22.485772393999923],
              [-41.904286261999914, -22.49065520599993],
              [-41.91197669199994, -22.507989190999922],
              [-41.93004309799994, -22.519707940999922],
              [-41.96629798099991, -22.535414320999905],
              [-41.98607337099992, -22.56487395599993],
              [-41.996205206999946, -22.609307549999926],
              [-41.998117641999954, -22.65789153399993],
              [-41.993031378999945, -22.699883721999925],
              [-41.98289954299992, -22.716241143999923],
              [-41.94688880099994, -22.75359465899993],
              [-41.93903561099995, -22.765069268999923],
              [-41.93455969999991, -22.768731377999927],
              [-41.92491614499994, -22.76181405999995],
              [-41.911040818999936, -22.747165622999944],
              [-41.901600714999915, -22.743584893999923],
              [-41.88003495999993, -22.73886484199994],
              [-41.87010657499991, -22.73406340899993],
              [-41.86978105399993, -22.752129815999922],
              [-41.87657630099994, -22.762383721999925],
              [-41.885324673999946, -22.770603122999944],
              [-41.890614386999914, -22.782403252999927],
              [-41.90957597599993, -22.77662525799991],
              [-41.92227128799993, -22.783379815999922],
              [-41.94522050699993, -22.809747002999927],
              [-41.97524980399993, -22.821872653999947],
              [-41.98306230399993, -22.823418877999927],
              [-41.98961341099994, -22.826348565999922],
              [-41.99120032499991, -22.83367278399993],
              [-41.99132239499994, -22.842868747999944],
              [-41.99478105399993, -22.85979583099993],
              [-41.995025193999936, -22.86842213299991],
              [-41.99689693899995, -22.875258070999905],
              [-42.003570115999935, -22.878024997999944],
              [-42.01414954299992, -22.878838799999926],
              [-42.01992753799993, -22.88128020599993],
              [-42.02367102799991, -22.88567473799992],
              [-42.02782141799992, -22.89226653399993],
              [-42.03307044199994, -22.91253020599993],
              [-42.03026282499991, -22.933770440999922],
              [-42.022694464999915, -22.944512627999927],
              [-42.01353919199994, -22.93328215899993],
              [-42.00731360599991, -22.93328215899993],
              [-42.00291907499991, -22.94768645599993],
              [-42.00373287699995, -22.959161065999922],
              [-42.01353919199994, -22.98170338299991],
              [-42.02717037699995, -22.97625090899993],
              [-42.04600989499994, -22.957777601999908],
              [-42.05821692599994, -22.953789971999925],
              [-42.17414303299995, -22.950778903999947],
              [-42.37612870999993, -22.937432549999926],
              [-42.53172766799992, -22.93417734199994],
              [-42.624256964999915, -22.93954843499995],
              [-42.656239386999914, -22.945977471999925],
              [-42.66860917899993, -22.94695403399993],
              [-42.67454993399991, -22.949965101999908],
              [-42.68708248599995, -22.963636976999908],
              [-42.69566809799994, -22.96689218499995],
              [-42.76935787699995, -22.96851978999996],
              [-42.86270097599993, -22.977227471999925],
              [-42.93224036399994, -22.972100518999923],
              [-43.03140214799993, -22.97429778399993],
              [-43.05650794199994, -22.953301690999922],
              [-43.07396399599992, -22.944919528999947],
              [-43.08975175699993, -22.953789971999925],
              [-43.101633266999954, -22.942966403999947],
              [-43.12144934799994, -22.929945570999905],
              [-43.13076738199993, -22.91961028399993],
              [-43.11636308499993, -22.92115650799991],
              [-43.110585089999915, -22.92278411299992],
              [-43.10342363199993, -22.926446221999925],
              [-43.091908331999946, -22.917087497999944],
              [-43.09129798099991, -22.90829843499995],
              [-43.09935462099992, -22.90162525799991],
              [-43.11363684799994, -22.899102471999925],
              [-43.129465298999946, -22.894138278999947],
              [-43.12653561099995, -22.882419528999947],
              [-43.110259568999936, -22.86060963299991],
              [-43.10171464799993, -22.83652109199994],
              [-43.08120683499993, -22.81414153399993],
              [-43.03453528599994, -22.775567315999922],
              [-43.05296790299991, -22.77776458099993],
              [-43.06114661399994, -22.77385833099993],
              [-43.061431443999936, -22.765801690999922],
              [-43.05626380099994, -22.75514088299991],
              [-43.03490149599992, -22.746270440999922],
              [-43.02839107999995, -22.74146900799991],
              [-43.02513587099992, -22.735528252999927],
              [-43.021473761999914, -22.713555596999925],
              [-43.02122962099992, -22.704196872999944],
              [-43.02513587099992, -22.67896900799991],
              [-43.02839107999995, -22.672539971999925],
              [-43.04092363199993, -22.669366143999923],
              [-43.06578528599994, -22.67164478999996],
              [-43.07555091099994, -22.66570403399993],
              [-43.08356686099995, -22.671807549999926],
              [-43.09479732999995, -22.68726978999996],
              [-43.10342363199993, -22.693617445999905],
              [-43.11485755099994, -22.69768645599993],
              [-43.12218176999994, -22.697198174999926],
              [-43.12954667899993, -22.69500090899993],
              [-43.14134680899991, -22.693617445999905],
              [-43.15184485599991, -22.695977471999925],
              [-43.17609615799995, -22.707777601999908],
              [-43.21670488199993, -22.73406340899993],
              [-43.23619544199994, -22.73406340899993],
              [-43.25560462099992, -22.737074476999908],
              [-43.27017167899993, -22.74700286299992],
              [-43.275380011999914, -22.76816171699994],
              [-43.27106686099995, -22.788995049999926],
              [-43.24058997299994, -22.843926690999922],
              [-43.23379472599993, -22.843926690999922],
              [-43.23062089799993, -22.838555596999925],
              [-43.22704016799992, -22.83521900799991],
              [-43.22345943899995, -22.832696221999925],
              [-43.22012285099993, -22.829685153999947],
              [-43.21922766799992, -22.83953215899993],
              [-43.21544348899994, -22.84693775799991],
              [-43.20885169199994, -22.852715752999927],
              [-43.19961503799993, -22.857028903999947],
              [-43.20445716099994, -22.857598565999922],
              [-43.207142706999946, -22.859307549999926],
              [-43.20946204299992, -22.86174895599993],
              [-43.21328691299993, -22.864434502999927],
              [-43.17332923099991, -22.886976820999905],
              [-43.162098761999914, -22.895684502999927],
              [-43.16063391799992, -22.90862395599993],
              [-43.16319739499994, -22.92742278399993],
              [-43.16246497299994, -22.939711195999905],
              [-43.151234503999945, -22.93328215899993],
              [-43.15221106699994, -22.951104424999926],
              [-43.170765753999945, -22.969821872999944],
              [-43.19676673099991, -22.985935153999947],
              [-43.22012285099993, -22.995293877999927],
              [-43.44758053299995, -23.01816171699994],
              [-43.49600175699993, -23.03101978999996],
              [-43.542225714999915, -23.04941171699994],
              [-43.54832923099991, -23.05478280999995],
              [-43.554351365999935, -23.06218840899993],
              [-43.56037350199995, -23.067478122999944],
              [-43.566517706999946, -23.066338799999926],
              [-43.57721920499995, -23.05136484199994],
              [-43.580067511999914, -23.04941171699994],
              [-43.620757615999935, -23.042575778999947],
              [-43.87189693899995, -23.069756768999923],
              [-43.914051886999914, -23.069756768999923],
              [-43.93472245999993, -23.07268645599993],
              [-43.950062628999945, -23.08017343499995],
              [-43.96898352799991, -23.09270598799992],
              [-43.98875891799992, -23.09742603999996],
              [-44.00373287699995, -23.09107838299991],
              [-44.00841223899994, -23.069756768999923],
              [-44.00145423099991, -23.04924895599993],
              [-43.98713131399995, -23.041680596999925],
              [-43.950062628999945, -23.042575778999947],
              [-43.940012173999946, -23.045586846999925],
              [-43.91633053299995, -23.05641041499996],
              [-43.90538489499994, -23.05559661299992],
              [-43.900461391999954, -23.05006275799991],
              [-43.89171301999994, -23.021416924999926],
              [-43.86900794199994, -23.03964609199994],
              [-43.832020636999914, -23.047621351999908],
              [-43.75112870999993, -23.04941171699994],
              [-43.66930091099994, -23.03720468499995],
              [-43.62547766799992, -23.02402109199994],
              [-43.60374915299991, -23.007745049999926],
              [-43.623605923999946, -23.00562916499996],
              [-43.64606686099995, -22.99863046699994],
              [-43.66441809799994, -22.988457940999922],
              [-43.671986456999946, -22.977959893999923],
              [-43.676665818999936, -22.979668877999927],
              [-43.687489386999914, -22.978773695999905],
              [-43.69912675699993, -22.97665780999995],
              [-43.706695115999935, -22.97429778399993],
              [-43.71637936099995, -22.96575286299992],
              [-43.72883053299995, -22.94589609199994],
              [-43.734038865999935, -22.93954843499995],
              [-43.748890753999945, -22.934340101999908],
              [-43.793527798999946, -22.92815520599993],
              [-43.80296790299991, -22.929864190999922],
              [-43.80899003799993, -22.909763278999947],
              [-43.82412675699993, -22.907647393999923],
              [-43.84410559799994, -22.91057708099993],
              [-43.86436926999994, -22.90593840899993],
              [-43.850168423999946, -22.899102471999925],
              [-43.850168423999946, -22.89226653399993],
              [-43.86436926999994, -22.89617278399993],
              [-43.89273027299993, -22.909356377999927],
              [-43.90196692599994, -22.91220468499995],
              [-43.95376542899993, -22.91961028399993],
              [-43.96642005099994, -22.923435153999947],
              [-43.99583899599992, -22.936700127999927],
              [-44.00470943899995, -22.93954843499995],
              [-44.01244055899991, -22.94573333099993],
              [-44.01976477799991, -22.959161065999922],
              [-44.03075110599991, -22.971368096999925],
              [-44.049387173999946, -22.97429778399993],
              [-44.04287675699993, -22.95875416499996],
              [-44.039173956999946, -22.944105726999908],
              [-44.042307094999956, -22.935804945999905],
              [-44.05622311099995, -22.93954843499995],
              [-44.06232662699995, -22.948418877999927],
              [-44.079741990999935, -22.98723723799992],
              [-44.089100714999915, -22.99382903399993],
              [-44.11510169199994, -23.02239348799992],
              [-44.12791907499991, -23.028903903999947],
              [-44.15176347599993, -23.028903903999947],
              [-44.15729732999995, -23.03183359199994],
              [-44.17292232999995, -23.042575778999947],
              [-44.18004309799994, -23.045098565999922],
              [-44.186390753999945, -23.049004815999922],
              [-44.19098873599995, -23.048760674999926],
              [-44.19273841099994, -23.03915780999995],
              [-44.196929490999935, -23.03362395599993],
              [-44.206369594999956, -23.037855726999908],
              [-44.22008216099994, -23.04941171699994],
              [-44.23729407499991, -23.04697030999995],
              [-44.24299068899995, -23.042575778999947],
              [-44.24046790299991, -23.008965752999927],
              [-44.24181067599994, -22.999932549999926],
              [-44.25047766799992, -22.99618905999995],
              [-44.271555141999954, -22.995293877999927],
              [-44.289621548999946, -23.010918877999927],
              [-44.29873613199993, -23.012872002999927],
              [-44.30260169199994, -22.995293877999927],
              [-44.31712805899991, -23.00286223799992],
              [-44.32384192599994, -23.00790780999995],
              [-44.32994544199994, -23.015232028999947],
              [-44.35265051999994, -22.99928150799991],
              [-44.35448157499991, -22.98642343499995],
              [-44.34154212099992, -22.97747161299992],
              [-44.319976365999935, -22.97429778399993],
              [-44.311838344999956, -22.970147393999923],
              [-44.31163489499994, -22.961114190999922],
              [-44.31688391799992, -22.94695403399993],
              [-44.32095292899993, -22.94378020599993],
              [-44.32762610599991, -22.940118096999925],
              [-44.328968878999945, -22.93482838299991],
              [-44.31688391799992, -22.926446221999925],
              [-44.32591712099992, -22.92164478999996],
              [-44.335926886999914, -22.919366143999923],
              [-44.346587693999936, -22.918715101999908],
              [-44.35781816299993, -22.91961028399993],
              [-44.351551886999914, -22.93531666499996],
              [-44.35570227799991, -22.944431247999944],
              [-44.36432857999995, -22.951429945999905],
              [-44.37149003799993, -22.961195570999905],
              [-44.375111456999946, -22.955254815999922],
              [-44.38219153599994, -22.945977471999925],
              [-44.38451087099992, -22.93954843499995],
              [-44.39175370999993, -22.94198984199994],
              [-44.39488684799994, -22.94345468499995],
              [-44.39879309799994, -22.94695403399993],
              [-44.411366339999915, -22.937432549999926],
              [-44.42324785099993, -22.947930596999925],
              [-44.43976803299995, -22.98170338299991],
              [-44.435658331999946, -22.996758721999925],
              [-44.45738684799994, -23.00945403399993],
              [-44.48664303299995, -23.018243096999925],
              [-44.534047003999945, -23.025323174999926],
              [-44.60423743399991, -23.05559661299992],
              [-44.60252844999991, -23.05046965899993],
              [-44.60057532499991, -23.04111093499995],
              [-44.59801184799994, -23.03573984199994],
              [-44.63036048099991, -23.035088799999926],
              [-44.65510006399995, -23.043145440999922],
              [-44.67320716099994, -23.059340101999908],
              [-44.700510219999956, -23.107679945999905],
              [-44.698475714999915, -23.11451588299991],
              [-44.69489498599995, -23.12078215899993],
              [-44.69318600199995, -23.12737395599993],
              [-44.702463344999956, -23.14462655999995],
              [-44.712147589999915, -23.174981377999927],
              [-44.714100714999915, -23.186618747999944],
              [-44.70799719999991, -23.21461353999996],
              [-44.68932044199994, -23.21103280999995],
              [-44.66576087099992, -23.195245049999926],
              [-44.64525305899991, -23.186618747999944],
              [-44.62677975199995, -23.195245049999926],
              [-44.67320716099994, -23.229587497999944],
              [-44.68000240799995, -23.24863046699994],
              [-44.67015540299991, -23.238539320999905],
              [-44.65599524599992, -23.230401299999926],
              [-44.64000403599994, -23.22779713299991],
              [-44.62474524599992, -23.23495859199994],
              [-44.639881964999915, -23.25042083099993],
              [-44.64875240799995, -23.26213958099993],
              [-44.65269934799994, -23.272149346999925],
              [-44.65135657499991, -23.284763278999947],
              [-44.647043423999946, -23.282810153999947],
              [-44.628163214999915, -23.25823333099993],
              [-44.61363684799994, -23.24382903399993],
              [-44.60057532499991, -23.234307549999926],
              [-44.58336341099994, -23.229180596999925],
              [-44.55650794199994, -23.22747161299992],
              [-44.56403561099995, -23.239678643999923],
              [-44.568470831999946, -23.244398695999905],
              [-44.57632402299993, -23.24863046699994],
              [-44.558257615999935, -23.26336028399993],
              [-44.53302975199995, -23.267022393999923],
              [-44.51056881399995, -23.273370049999926],
              [-44.501210089999915, -23.296482028999947],
              [-44.52379309799994, -23.29070403399993],
              [-44.54141191299993, -23.30315520599993],
              [-44.56330318899995, -23.337334893999923],
              [-44.58381100199995, -23.35320403399993],
              [-44.60098222599993, -23.35019296699994],
              [-44.616444464999915, -23.342461846999925],
              [-44.63158118399991, -23.344821872999944],
              [-44.647043423999946, -23.338636976999908],
              [-44.67442786399994, -23.338067315999922],
              [-44.70425370999993, -23.342461846999925],
              [-44.72716223899994, -23.351006768999923],
              [-44.7275691399999, -23.35206471099991],
              [-44.73289954299992, -23.36581796699994],
              [-44.74779212099992, -23.37086353999996],
              [-44.766184048999946, -23.372979424999926],
              [-44.78237870999993, -23.37900155999995],
              [-44.79979407499991, -23.371270440999922],
              [-44.81330318899995, -23.377129815999922],
              [-44.82697506399995, -23.385430596999925],
              [-44.84447180899991, -23.38518645599993],
              [-44.850453253999945, -23.37900155999995],
              [-44.85399329299992, -23.369805596999925],
              [-44.85855058499993, -23.361504815999922],
              [-44.868031378999945, -23.35784270599993],
              [-44.87743079299992, -23.358168226999908],
              [-44.88434811099995, -23.35947030999995],
              [-44.898508266999954, -23.364678643999923],
              [-44.89199785099993, -23.340997002999927],
              [-44.91930091099994, -23.348809502999927],
              [-44.95262610599991, -23.36809661299992],
              [-44.96422278599994, -23.37900155999995],
              [-44.96922766799992, -23.38144296699994],
              [-44.97569739499994, -23.39421965899993],
              [-44.981027798999946, -23.39934661299992],
              [-44.98814856699994, -23.40203215899993],
              [-45.00153561099995, -23.403741143999923],
              [-45.008371548999946, -23.40553150799991],
              [-45.02830969999991, -23.41611093499995],
              [-45.03624426999994, -23.415622653999947],
              [-45.043080206999946, -23.40553150799991],
              [-45.050770636999914, -23.42815520599993],
              [-45.03966223899994, -23.438653252999927],
              [-45.02163652299993, -23.446465752999927],
              [-45.008371548999946, -23.460870049999926],
              [-45.03473873599995, -23.462090752999927],
              [-45.05016028599994, -23.473321221999925],
              [-45.070423956999946, -23.51539478999996],
              [-45.080189581999946, -23.497653903999947],
              [-45.091786261999914, -23.49187590899993],
              [-45.097645636999914, -23.49781666499996],
              [-45.09024003799993, -23.51539478999996],
              [-45.10191809799994, -23.512790622999944],
              [-45.113392706999946, -23.507745049999926],
              [-45.12458248599995, -23.500664971999925],
              [-45.13524329299992, -23.49187590899993],
              [-45.147775844999956, -23.487399997999944],
              [-45.15217037699995, -23.498793226999908],
              [-45.15062415299991, -23.51604583099993],
              [-45.14549719999991, -23.52906666499996],
              [-45.16421464799993, -23.533135674999926],
              [-45.18321692599994, -23.52597421699994],
              [-45.20034745999993, -23.523695570999905],
              [-45.213734503999945, -23.54273853999996],
              [-45.203236456999946, -23.561211846999925],
              [-45.20067298099991, -23.57203541499996],
              [-45.21068274599992, -23.576918226999908],
              [-45.22288977799991, -23.579196872999944],
              [-45.251942511999914, -23.590590101999908],
              [-45.26414954299992, -23.587497653999947],
              [-45.27879798099991, -23.573663018999923],
              [-45.28954016799992, -23.57008228999996],
              [-45.30174719999991, -23.574151299999926],
              [-45.31240800699993, -23.58375416499996],
              [-45.32111568899995, -23.59351978999996],
              [-45.327056443999936, -23.59807708099993],
              [-45.34837805899991, -23.60442473799992],
              [-45.36778723899994, -23.616631768999923],
              [-45.38829505099994, -23.624444268999923],
              [-45.412993943999936, -23.617852471999925],
              [-45.41706295499995, -23.629082940999922],
              [-45.42845618399991, -23.64185963299991],
              [-45.432932094999956, -23.652601820999905],
              [-45.43350175699993, -23.664727471999925],
              [-45.42821204299992, -23.68613046699994],
              [-45.426665818999936, -23.69703541499996],
              [-45.423085089999915, -23.71062590899993],
              [-45.414906378999945, -23.714776299999926],
              [-45.40575110599991, -23.715915622999944],
              [-45.39940344999991, -23.720879815999922],
              [-45.39830481699994, -23.73414478999996],
              [-45.40611731699994, -23.756117445999905],
              [-45.40274003799993, -23.76531340899993],
              [-45.39305579299992, -23.783461195999905],
              [-45.39484615799995, -23.80315520599993],
              [-45.40660559799994, -23.82040780999995],
              [-45.426665818999936, -23.830743096999925],
              [-45.43887285099993, -23.83171965899993],
              [-45.44806881399995, -23.82903411299992],
              [-45.455962693999936, -23.825616143999923],
              [-45.464507615999935, -23.82390715899993],
              [-45.478505011999914, -23.826348565999922],
              [-45.49876868399991, -23.83635833099993],
              [-45.50926673099991, -23.83757903399993],
              [-45.52887936099995, -23.829522393999923],
              [-45.551991339999915, -23.80242278399993],
              [-45.57408606699994, -23.79664478999996],
              [-45.60802161399994, -23.80315520599993],
              [-45.618478969999956, -23.802911065999922],
              [-45.623036261999914, -23.800388278999947],
              [-45.62710527299993, -23.792575778999947],
              [-45.632150844999956, -23.789808851999908],
              [-45.65135657499991, -23.78915780999995],
              [-45.65265865799995, -23.789808851999908],
              [-45.71751868399991, -23.77076588299991],
              [-45.78294837099992, -23.768731377999927],
              [-45.794260219999956, -23.765883070999905],
              [-45.81554114499994, -23.757256768999923],
              [-45.823882615999935, -23.755059502999927],
              [-45.86436926999994, -23.75644296699994],
              [-45.955637173999946, -23.77711353999996],
              [-45.98900305899991, -23.789808851999908],
              [-46.00763912699995, -23.800957940999922],
              [-46.01797441299993, -23.81023528399993],
              [-46.02692623599995, -23.82854583099993],
              [-46.03746497299994, -23.82903411299992],
              [-46.060658331999946, -23.82390715899993],
              [-46.079741990999935, -23.82781340899993],
              [-46.098947719999956, -23.837090752999927],
              [-46.13630123599995, -23.851739190999922],
              [-46.13780676999994, -23.849541924999926],
              [-46.139230923999946, -23.844414971999925],
              [-46.14606686099995, -23.844414971999925],
              [-46.15953528599994, -23.870538018999923],
              [-46.17959550699993, -23.89031340899993],
              [-46.20523027299993, -23.904473565999922],
              [-46.23542232999995, -23.91269296699994],
              [-46.23542232999995, -23.920179945999905],
              [-46.21353105399993, -23.919366143999923],
              [-46.197377081999946, -23.91570403399993],
              [-46.18301347599993, -23.90715911299992],
              [-46.14549719999991, -23.87078215899993],
              [-46.13190670499995, -23.86492278399993],
              [-46.11192786399994, -23.86492278399993],
              [-46.14997311099995, -23.90553150799991],
              [-46.15973873599995, -23.920179945999905],
              [-46.16445878799993, -23.935153903999947],
              [-46.16832434799994, -23.954685153999947],
              [-46.16954505099994, -23.97234465899993],
              [-46.16649329299992, -23.981622002999927],
              [-46.175038214999915, -23.990899346999925],
              [-46.18663489499994, -23.99537525799991],
              [-46.19688880099994, -23.99391041499996],
              [-46.201283331999946, -23.985039971999925],
              [-46.20750891799992, -23.979913018999923],
              [-46.22109941299993, -23.98170338299991],
              [-46.23412024599992, -23.98601653399993],
              [-46.25304114499994, -23.99586353999996],
              [-46.26773027299993, -24.010511976999908],
              [-46.287668423999946, -24.02117278399993],
              [-46.31737219999991, -24.016371351999908],
              [-46.30992591099994, -24.001560153999947],
              [-46.284820115999935, -23.992852471999925],
              [-46.27635657499991, -23.981622002999927],
              [-46.27725175699993, -23.967543226999908],
              [-46.28457597599993, -23.95598723799992],
              [-46.292958136999914, -23.946058851999908],
              [-46.296864386999914, -23.93718840899993],
              [-46.29946855399993, -23.92506275799991],
              [-46.30699622299994, -23.91529713299991],
              [-46.31883704299992, -23.908868096999925],
              [-46.34618079299992, -23.904961846999925],
              [-46.35777747299994, -23.90081145599993],
              [-46.36375891799992, -23.89421965899993],
              [-46.358306443999936, -23.88600025799991],
              [-46.358306443999936, -23.87859465899993],
              [-46.38540605399993, -23.87346770599993],
              [-46.38927161399994, -23.88640715899993],
              [-46.38735917899993, -23.90398528399993],
              [-46.39679928299995, -23.91269296699994],
              [-46.40929114499994, -23.915948174999926],
              [-46.41038977799991, -23.923272393999923],
              [-46.40802975199995, -23.93059661299992],
              [-46.409820115999935, -23.933851820999905],
              [-46.43268795499995, -23.93173593499995],
              [-46.45392818899995, -23.926446221999925],
              [-46.44957434799994, -23.93840911299992],
              [-46.44041907499991, -23.944919528999947],
              [-46.431304490999935, -23.94817473799992],
              [-46.42723548099991, -23.95086028399993],
              [-46.42560787699995, -23.95671965899993],
              [-46.41698157499991, -23.976169528999947],
              [-46.412953253999945, -23.981622002999927],
              [-46.40192623599995, -23.98414478999996],
              [-46.38829505099994, -23.983982028999947],
              [-46.37682044199994, -23.985121351999908],
              [-46.371937628999945, -23.992120049999926],
              [-46.37205969999991, -24.015801690999922],
              [-46.37604732999995, -24.024509372999944],
              [-46.38630123599995, -24.030043226999908],
              [-46.38809160099993, -24.02157968499995],
              [-46.39175370999993, -24.01620859199994],
              [-46.39781653599994, -24.012465101999908],
              [-46.40672766799992, -24.008965752999927],
              [-46.46898352799991, -24.03997161299992],
              [-46.593413865999935, -24.08953215899993],
              [-46.743072068999936, -24.176853122999944],
              [-46.85496985599991, -24.228448174999926],
              [-46.93663489499994, -24.273370049999926],
              [-46.966460740999935, -24.299086195999905],
              [-46.98892167899993, -24.331149997999944],
              [-46.99990800699993, -24.366794528999947],
              [-47.00633704299992, -24.37200286299992],
              [-47.00999915299991, -24.376885674999926],
              [-46.99950110599991, -24.400567315999922],
              [-46.99950110599991, -24.40984465899993],
              [-47.01537024599992, -24.422946872999944],
              [-47.03502356699994, -24.431084893999923],
              [-47.04979407499991, -24.42782968499995],
              [-47.05101477799991, -24.406182549999926],
              [-47.07209225199995, -24.44850025799991],
              [-47.08141028599994, -24.453871351999908],
              [-47.096913214999915, -24.45940520599993],
              [-47.122710740999935, -24.48333098799992],
              [-47.13634192599994, -24.48870208099993],
              [-47.18138587099992, -24.533379815999922],
              [-47.44204667899993, -24.680433851999908],
              [-47.45482337099992, -24.67669036299992],
              [-47.46906490799995, -24.68092213299991],
              [-47.49669348899994, -24.693536065999922],
              [-47.518462693999936, -24.68808359199994],
              [-47.531320766999954, -24.688164971999925],
              [-47.54076087099992, -24.703383070999905],
              [-47.55992591099994, -24.71266041499996],
              [-47.58470618399991, -24.731622002999927],
              [-47.63385982999995, -24.75562916499996],
              [-47.82555091099994, -24.894138278999947],
              [-47.841786261999914, -24.90984465899993],
              [-47.86660722599993, -24.940606377999927],
              [-47.87340247299994, -24.94540780999995],
              [-47.87987219999991, -24.948663018999923],
              [-47.88630123599995, -24.953057549999926],
              [-47.89329993399991, -24.961114190999922],
              [-47.93374589799993, -25.033461195999905],
              [-47.96056067599994, -25.049899997999944],
              [-48.00999915299991, -25.04420338299991],
              [-48.00169837099992, -25.02792734199994],
              [-47.98810787699995, -25.02581145599993],
              [-47.973500128999945, -25.027601820999905],
              [-47.962147589999915, -25.02312590899993],
              [-47.96117102799991, -25.013116143999923],
              [-47.972727016999954, -25.009372653999947],
              [-48.016916469999956, -25.010837497999944],
              [-48.02358964799993, -25.015069268999923],
              [-48.02440344999991, -25.02239348799992],
              [-48.02358964799993, -25.03362395599993],
              [-48.027007615999935, -25.045179945999905],
              [-48.03490149599992, -25.048760674999926],
              [-48.044178839999915, -25.04550546699994],
              [-48.05158443899995, -25.03679778399993],
              [-48.051625128999945, -25.05282968499995],
              [-48.032460089999915, -25.063246351999908],
              [-48.00645911399994, -25.069105726999908],
              [-47.98607337099992, -25.070977471999925],
              [-47.963002081999946, -25.07822030999995],
              [-47.94969641799992, -25.080010674999926],
              [-47.93830318899995, -25.07463958099993],
              [-47.927723761999914, -25.065606377999927],
              [-47.915353969999956, -25.05950286299992],
              [-47.901682094999956, -25.056573174999926],
              [-47.88707434799994, -25.057305596999925],
              [-47.921986456999946, -25.15862395599993],
              [-47.95177161399994, -25.201348565999922],
              [-48.003163214999915, -25.214288018999923],
              [-48.02000891799992, -25.22633228999996],
              [-48.068348761999914, -25.280043226999908],
              [-48.076283331999946, -25.293226820999905],
              [-48.082102016999954, -25.307305596999925],
              [-48.08336341099994, -25.31031666499996],
              [-48.09154212099992, -25.325290622999944],
              [-48.16828365799995, -25.36923593499995],
              [-48.17345130099994, -25.381036065999922],
              [-48.196522589999915, -25.41692473799992],
              [-48.209055141999954, -25.45761484199994],
              [-48.22508704299992, -25.459730726999908],
              [-48.24160722599993, -25.44817473799992],
              [-48.25015214799993, -25.42782968499995],
              [-48.247303839999915, -25.410902601999908],
              [-48.22288977799991, -25.35214609199994],
              [-48.221994594999956, -25.343357028999947],
              [-48.22215735599991, -25.33912525799991],
              [-48.21922766799992, -25.33456796699994],
              [-48.20921790299991, -25.324151299999926],
              [-48.20152747299994, -25.318291924999926],
              [-48.18126380099994, -25.306817315999922],
              [-48.13711503799993, -25.28964609199994],
              [-48.12730872299994, -25.279961846999925],
              [-48.140288865999935, -25.26962655999995],
              [-48.15257727799991, -25.281996351999908],
              [-48.17422441299993, -25.290622653999947],
              [-48.19871985599991, -25.29534270599993],
              [-48.21914628799993, -25.296807549999926],
              [-48.22960364499994, -25.300388278999947],
              [-48.24254309799994, -25.31536223799992],
              [-48.25015214799993, -25.31804778399993],
              [-48.259429490999935, -25.313653252999927],
              [-48.274322068999936, -25.29656340899993],
              [-48.28433183499993, -25.28997161299992],
              [-48.28307044199994, -25.30641041499996],
              [-48.28368079299992, -25.316013278999947],
              [-48.28628495999993, -25.32284921699994],
              [-48.297434048999946, -25.341241143999923],
              [-48.306752081999946, -25.351006768999923],
              [-48.31871497299994, -25.357679945999905],
              [-48.33275305899991, -25.35833098799992],
              [-48.31908118399991, -25.324151299999926],
              [-48.32530676999994, -25.324151299999926],
              [-48.33372962099992, -25.329685153999947],
              [-48.33551998599995, -25.318617445999905],
              [-48.331369594999956, -25.270196221999925],
              [-48.32575436099995, -25.24382903399993],
              [-48.32530676999994, -25.22861093499995],
              [-48.338002081999946, -25.23674895599993],
              [-48.351226365999935, -25.250664971999925],
              [-48.360991990999935, -25.26376718499995],
              [-48.36314856699994, -25.26962655999995],
              [-48.37262936099995, -25.27157968499995],
              [-48.37267005099994, -25.276136976999908],
              [-48.36628170499995, -25.283868096999925],
              [-48.36408443899995, -25.283461195999905],
              [-48.359364386999914, -25.28557708099993],
              [-48.354725714999915, -25.289239190999922],
              [-48.35260982999995, -25.29338958099993],
              [-48.35374915299991, -25.29697030999995],
              [-48.35887610599991, -25.296807549999926],
              [-48.36009680899991, -25.300225518999923],
              [-48.36742102799991, -25.30478280999995],
              [-48.383697068999936, -25.29810963299991],
              [-48.40721594999991, -25.283868096999925],
              [-48.414133266999954, -25.27353280999995],
              [-48.423939581999946, -25.252211195999905],
              [-48.43455969999991, -25.24228280999995],
              [-48.43455969999991, -25.262790622999944],
              [-48.44200598899994, -25.262790622999944],
              [-48.44505774599992, -25.256605726999908],
              [-48.44798743399991, -25.25367603999996],
              [-48.451283331999946, -25.25172291499996],
              [-48.45567786399994, -25.24846770599993],
              [-48.45197506399995, -25.264743747999944],
              [-48.42833411399994, -25.324151299999926],
              [-48.446603969999956, -25.324476820999905],
              [-48.47891191299993, -25.331638278999947],
              [-48.49657141799992, -25.331638278999947],
              [-48.49657141799992, -25.33847421699994],
              [-48.46263587099992, -25.342868747999944],
              [-48.44566809799994, -25.34742603999996],
              [-48.43455969999991, -25.35833098799992],
              [-48.45221920499995, -25.368259372999944],
              [-48.45742753799993, -25.379652601999908],
              [-48.451283331999946, -25.38567473799992],
              [-48.43455969999991, -25.37948984199994],
              [-48.43028723899994, -25.389418226999908],
              [-48.416859503999945, -25.40439218499995],
              [-48.414051886999914, -25.410088799999926],
              [-48.41783606699994, -25.42831796699994],
              [-48.42690995999993, -25.432305596999925],
              [-48.43814042899993, -25.431247653999947],
              [-48.448150193999936, -25.43401458099993],
              [-48.45425370999993, -25.44589609199994],
              [-48.45616614499994, -25.45956796699994],
              [-48.460194464999915, -25.470879815999922],
              [-48.472727016999954, -25.475681247999944],
              [-48.48814856699994, -25.47389088299991],
              [-48.49791419199994, -25.468682549999926],
              [-48.51707923099991, -25.44703541499996],
              [-48.52684485599991, -25.45322030999995],
              [-48.53742428299995, -25.454522393999923],
              [-48.548085089999915, -25.452243747999944],
              [-48.55801347599993, -25.44703541499996],
              [-48.56273352799991, -25.45956796699994],
              [-48.575062628999945, -25.462009372999944],
              [-48.62364661399994, -25.44963958099993],
              [-48.63536536399994, -25.44459400799991],
              [-48.68382727799991, -25.412774346999925],
              [-48.691395636999914, -25.405694268999923],
              [-48.73094641799992, -25.359633070999905],
              [-48.743031378999945, -25.35214609199994],
              [-48.740223761999914, -25.367445570999905],
              [-48.72313391799992, -25.40667083099993],
              [-48.718820766999954, -25.422621351999908],
              [-48.715687628999945, -25.42782968499995],
              [-48.71011308499993, -25.433038018999923],
              [-48.69896399599992, -25.438164971999925],
              [-48.69522050699993, -25.440850518999923],
              [-48.683583136999914, -25.46266041499996],
              [-48.688710089999915, -25.473321221999925],
              [-48.70555579299992, -25.47437916499996],
              [-48.729359503999945, -25.468194268999923],
              [-48.71084550699993, -25.496351820999905],
              [-48.68333899599992, -25.498711846999925],
              [-48.65143795499995, -25.49277109199994],
              [-48.62010657499991, -25.49618905999995],
              [-48.622385219999956, -25.503106377999927],
              [-48.62413489499994, -25.506036065999922],
              [-48.626942511999914, -25.509698174999926],
              [-48.635650193999936, -25.503024997999944],
              [-48.64305579299992, -25.50237395599993],
              [-48.649281378999945, -25.507012627999927],
              [-48.654286261999914, -25.51653411299992],
              [-48.642241990999935, -25.521742445999905],
              [-48.62828528599994, -25.524509372999944],
              [-48.61538652299993, -25.529961846999925],
              [-48.60643469999991, -25.54387786299992],
              [-48.59544837099992, -25.52776458099993],
              [-48.578195766999954, -25.526055596999925],
              [-48.558664516999954, -25.527276299999926],
              [-48.52403723899994, -25.514825127999927],
              [-48.50503495999993, -25.52320728999996],
              [-48.48607337099992, -25.535902601999908],
              [-48.469309048999946, -25.54387786299992],
              [-48.479359503999945, -25.55510833099993],
              [-48.48289954299992, -25.558200778999947],
              [-48.47614498599995, -25.550713799999926],
              [-48.490345831999946, -25.564060153999947],
              [-48.496937628999945, -25.568536065999922],
              [-48.50340735599991, -25.571872653999947],
              [-48.482492641999954, -25.57984791499996],
              [-48.47134355399993, -25.572930596999925],
              [-48.46434485599991, -25.559991143999923],
              [-48.45567786399994, -25.550713799999926],
              [-48.44041907499991, -25.55006275799991],
              [-48.42406165299991, -25.554294528999947],
              [-48.406320766999954, -25.55510833099993],
              [-48.386708136999914, -25.54387786299992],
              [-48.36119544199994, -25.570977471999925],
              [-48.38890540299991, -25.59547291499996],
              [-48.43272864499994, -25.622491143999923],
              [-48.517567511999914, -25.770196221999925],
              [-48.51707923099991, -25.797133070999905],
              [-48.53502356699994, -25.839450778999947],
              [-48.541005011999914, -25.845472914999903],
              [-48.55850175699993, -25.840997002999927],
              [-48.57241777299993, -25.82154713299991],
              [-48.586008266999954, -25.817559502999927],
              [-48.58067786399994, -25.801853122999944],
              [-48.57852128799993, -25.797133070999905],
              [-48.591786261999914, -25.799004815999922],
              [-48.603505011999914, -25.802178643999923],
              [-48.61314856699994, -25.808038018999923],
              [-48.62010657499991, -25.817559502999927],
              [-48.608265753999945, -25.818617445999905],
              [-48.59935462099992, -25.82284921699994],
              [-48.59219316299993, -25.829278252999927],
              [-48.586008266999954, -25.838067315999922],
              [-48.57990475199995, -25.851169528999947],
              [-48.583241339999915, -25.854668877999927],
              [-48.651234503999945, -25.844496351999908],
              [-48.743031378999945, -25.851739190999922],
              [-48.75304114499994, -25.855075778999947],
              [-48.76268469999991, -25.85979583099993],
              [-48.76943925699993, -25.867364190999922],
              [-48.77033443899995, -25.879652601999908],
              [-48.76577714799993, -25.886651299999926],
              [-48.758656378999945, -25.883884372999944],
              [-48.75047766799992, -25.877211195999905],
              [-48.743031378999945, -25.872816664999903],
              [-48.57852128799993, -25.872816664999903],
              [-48.571156378999945, -25.869073174999926],
              [-48.56700598899994, -25.864434502999927],
              [-48.56346594999991, -25.86581796699994],
              [-48.55801347599993, -25.879652601999908],
              [-48.55650794199994, -25.89120859199994],
              [-48.558583136999914, -25.901788018999923],
              [-48.57852128799993, -25.961602471999925],
              [-48.586008266999954, -25.99578215899993],
              [-48.60456295499995, -26.023370049999926],
              [-48.61266028599994, -26.040622653999947],
              [-48.60985266799992, -26.05437590899993],
              [-48.60008704299992, -26.07122161299992],
              [-48.58263098899994, -26.15715911299992],
              [-48.582915818999936, -26.172621351999908],
              [-48.59251868399991, -26.183851820999905],
              [-48.61668860599991, -26.188164971999925],
              [-48.63491777299993, -26.194512627999927],
              [-48.646148240999935, -26.20907968499995],
              [-48.65542558499993, -26.225274346999925],
              [-48.66787675699993, -26.23601653399993],
              [-48.687163865999935, -26.237725518999923],
              [-48.712228969999956, -26.233575127999927],
              [-48.73379472599993, -26.22470468499995],
              [-48.743031378999945, -26.212090752999927],
              [-48.74522864499994, -26.18914153399993],
              [-48.75064042899993, -26.173597914999903],
              [-48.76414954299992, -26.147149346999925],
              [-48.76903235599991, -26.12981536299992],
              [-48.77033443899995, -26.109307549999926],
              [-48.77253170499995, -26.100681247999944],
              [-48.78184973899994, -26.090997002999927],
              [-48.78864498599995, -26.06340911299992],
              [-48.79645748599995, -26.06845468499995],
              [-48.79800370999993, -26.088067315999922],
              [-48.78400631399995, -26.113051039999903],
              [-48.79051673099991, -26.124769789999903],
              [-48.791127081999946, -26.13534921699994],
              [-48.78819739499994, -26.14511484199994],
              [-48.78400631399995, -26.15398528399993],
              [-48.78001868399991, -26.156914971999925],
              [-48.77330481699994, -26.15984465899993],
              [-48.76695716099994, -26.163995049999926],
              [-48.76414954299992, -26.171075127999927],
              [-48.76439368399991, -26.18206145599993],
              [-48.76349850199995, -26.18718840899993],
              [-48.760650193999936, -26.191582940999922],
              [-48.75609290299991, -26.20354583099993],
              [-48.76414954299992, -26.22820403399993],
              [-48.760650193999936, -26.239678643999923],
              [-48.75621497299994, -26.249444268999923],
              [-48.759755011999914, -26.25709400799991],
              [-48.76793372299994, -26.261976820999905],
              [-48.77774003799993, -26.263278903999947],
              [-48.75731360599991, -26.291192315999922],
              [-48.770375128999945, -26.289727471999925],
              [-48.782093878999945, -26.290948174999926],
              [-48.79161536399994, -26.295586846999925],
              [-48.79824785099993, -26.304864190999922],
              [-48.75731360599991, -26.31145598799992],
              [-48.73770097599993, -26.319105726999908],
              [-48.729359503999945, -26.33521900799991],
              [-48.72179114499994, -26.344821872999944],
              [-48.65977942599994, -26.370700778999947],
              [-48.65078691299993, -26.376560153999947],
              [-48.64362545499995, -26.38486093499995],
              [-48.640614386999914, -26.396742445999905],
              [-48.639556443999936, -26.40862395599993],
              [-48.63585364499994, -26.41855234199994],
              [-48.628570115999935, -26.425225518999923],
              [-48.61668860599991, -26.42782968499995],
              [-48.60789954299992, -26.436700127999927],
              [-48.61424719999991, -26.456801039999903],
              [-48.66445878799993, -26.556084893999923],
              [-48.675445115999935, -26.59465911299992],
              [-48.68333899599992, -26.662367445999905],
              [-48.682199673999946, -26.71917083099993],
              [-48.678944464999915, -26.73105234199994],
              [-48.671131964999915, -26.739434502999927],
              [-48.626942511999914, -26.770928643999923],
              [-48.614898240999935, -26.77044036299992],
              [-48.59215247299994, -26.763929945999905],
              [-48.58226477799991, -26.767510674999926],
              [-48.57795162699995, -26.776543877999927],
              [-48.57921301999994, -26.786553643999923],
              [-48.58372962099992, -26.794854424999926],
              [-48.597727016999954, -26.804457289999903],
              [-48.609486456999946, -26.819431247999944],
              [-48.62047278599994, -26.83717213299991],
              [-48.626942511999914, -26.852308851999908],
              [-48.62877356699994, -26.864841403999947],
              [-48.626942511999914, -26.89706796699994],
              [-48.62482662699995, -26.90276458099993],
              [-48.61538652299993, -26.912041924999926],
              [-48.613270636999914, -26.917738539999903],
              [-48.61436926999994, -26.92392343499995],
              [-48.61904863199993, -26.933038018999923],
              [-48.62010657499991, -26.93792083099993],
              [-48.62132727799991, -26.974379164999903],
              [-48.62010657499991, -26.982598565999922],
              [-48.61119544199994, -26.993910414999903],
              [-48.60195878799993, -26.99773528399993],
              [-48.59483801999994, -26.99732838299991],
              [-48.59219316299993, -26.996270440999922],
              [-48.57518469999991, -27.01620859199994],
              [-48.57713782499991, -27.032972914999903],
              [-48.58653723899994, -27.049574476999908],
              [-48.59630286399994, -27.086114190999922],
              [-48.60374915299991, -27.094414971999925],
              [-48.60716712099992, -27.10442473799992],
              [-48.58804277299993, -27.150648695999905],
              [-48.57949785099993, -27.158461195999905],
              [-48.56517493399991, -27.16139088299991],
              [-48.55138098899994, -27.158135674999926],
              [-48.54474850199995, -27.150160414999903],
              [-48.54059811099995, -27.140069268999923],
              [-48.534413214999915, -27.130466403999947],
              [-48.51622473899994, -27.12078215899993],
              [-48.50690670499995, -27.13250090899993],
              [-48.49681555899991, -27.149102471999925],
              [-48.47614498599995, -27.15398528399993],
              [-48.48387610599991, -27.165948174999926],
              [-48.48888098899994, -27.170668226999908],
              [-48.49657141799992, -27.17506275799991],
              [-48.48696855399993, -27.19850025799991],
              [-48.48591061099995, -27.210707289999903],
              [-48.49290930899991, -27.215997002999927],
              [-48.50536048099991, -27.218682549999926],
              [-48.51598059799994, -27.22234465899993],
              [-48.52456620999993, -27.22128671699994],
              [-48.531361456999946, -27.209161065999922],
              [-48.51622473899994, -27.20631275799991],
              [-48.512603318999936, -27.19817473799992],
              [-48.51829993399991, -27.18873463299991],
              [-48.531361456999946, -27.181898695999905],
              [-48.541859503999945, -27.182386976999908],
              [-48.56037350199995, -27.192966403999947],
              [-48.568918423999946, -27.195489190999922],
              [-48.57335364499994, -27.19963958099993],
              [-48.60643469999991, -27.223402601999908],
              [-48.61440995999993, -27.232028903999947],
              [-48.618478969999956, -27.238457940999922],
              [-48.619984503999945, -27.24667734199994],
              [-48.62010657499991, -27.26067473799992],
              [-48.61290442599994, -27.299493096999925],
              [-48.60985266799992, -27.305352471999925],
              [-48.60659745999993, -27.30632903399993],
              [-48.572336391999954, -27.31218840899993],
              [-48.56094316299993, -27.324965101999908],
              [-48.55483964799993, -27.342461846999925],
              [-48.55186926999994, -27.38730234199994],
              [-48.562611456999946, -27.372816664999903],
              [-48.56554114499994, -27.367445570999905],
              [-48.57144120999993, -27.37664153399993],
              [-48.575510219999956, -27.384942315999922],
              [-48.577788865999935, -27.39381275799991],
              [-48.57852128799993, -27.40471770599993],
              [-48.58193925699993, -27.416680596999925],
              [-48.59048417899993, -27.421644789999903],
              [-48.60179602799991, -27.424004815999922],
              [-48.613270636999914, -27.42831796699994],
              [-48.62612870999993, -27.43678150799991],
              [-48.63695227799991, -27.44695403399993],
              [-48.644602016999954, -27.46062590899993],
              [-48.64745032499991, -27.479587497999944],
              [-48.60985266799992, -27.55868905999995],
              [-48.59015865799995, -27.563653252999927],
              [-48.57909094999991, -27.576348565999922],
              [-48.57750403599994, -27.594008070999905],
              [-48.586008266999954, -27.613213799999926],
              [-48.59455318899995, -27.601169528999947],
              [-48.61424719999991, -27.612399997999944],
              [-48.63512122299994, -27.632582289999903],
              [-48.64745032499991, -27.64739348799992],
              [-48.63805091099994, -27.661309502999927],
              [-48.631703253999945, -27.67978280999995],
              [-48.62808183499993, -27.70012786299992],
              [-48.626942511999914, -27.71965911299992],
              [-48.623890753999945, -27.725274346999925],
              [-48.61009680899991, -27.74114348799992],
              [-48.60643469999991, -27.75042083099993],
              [-48.61196855399993, -27.752699476999908],
              [-48.62246660099993, -27.759942315999922],
              [-48.62922115799995, -27.767510674999926],
              [-48.62352454299992, -27.770928643999923],
              [-48.618031378999945, -27.778008721999925],
              [-48.58193925699993, -27.812758070999905],
              [-48.572336391999954, -27.82545338299991],
              [-48.57408606699994, -27.833428643999923],
              [-48.58112545499995, -27.83684661299992],
              [-48.58869381399995, -27.839043877999927],
              [-48.59219316299993, -27.842950127999927],
              [-48.58824622299994, -27.85361093499995],
              [-48.57949785099993, -27.85670338299991],
              [-48.570423956999946, -27.85751718499995],
              [-48.56554114499994, -27.86028411299992],
              [-48.56969153599994, -27.878024997999944],
              [-48.59935462099992, -27.916761976999908],
              [-48.60643469999991, -27.932305596999925],
              [-48.61656653599994, -27.99081796699994],
              [-48.613270636999914, -28.011163018999923],
              [-48.60952714799993, -28.017022393999923],
              [-48.604807094999956, -28.02157968499995],
              [-48.60073808499993, -28.028415622999944],
              [-48.59898841099994, -28.04159921699994],
              [-48.60228430899991, -28.050957940999922],
              [-48.60952714799993, -28.057712497999944],
              [-48.61681067599994, -28.06292083099993],
              [-48.62010657499991, -28.068536065999922],
              [-48.62169348899994, -28.076918226999908],
              [-48.63316809799994, -28.10670338299991],
              [-48.640614386999914, -28.147637627999927],
              [-48.65371660099993, -28.190199476999908],
              [-48.65526282499991, -28.212823174999926],
              [-48.63589433499993, -28.23015715899993],
              [-48.65172278599994, -28.247165622999944],
              [-48.688384568999936, -28.278008721999925],
              [-48.69155839799993, -28.28753020599993],
              [-48.69489498599995, -28.312269789999903],
              [-48.69513912699995, -28.33603280999995],
              [-48.69640051999994, -28.342054945999905],
              [-48.72447669199994, -28.371351820999905],
              [-48.73106848899994, -28.38445403399993],
              [-48.743031378999945, -28.422051690999922],
              [-48.75739498599995, -28.44459400799991],
              [-48.76305091099994, -28.456963799999926],
              [-48.760650193999936, -28.467054945999905],
              [-48.75666256399995, -28.477634372999944],
              [-48.76121985599991, -28.487399997999944],
              [-48.77061926999994, -28.491957289999903],
              [-48.78087317599994, -28.487481377999927],
              [-48.79405676999994, -28.47079843499995],
              [-48.80345618399991, -28.452325127999927],
              [-48.807525193999936, -28.43173593499995],
              [-48.80504309799994, -28.408379815999922],
              [-48.79466712099992, -28.39267343499995],
              [-48.79088294199994, -28.381524346999925],
              [-48.79482988199993, -28.370538018999923],
              [-48.82213294199994, -28.34628671699994],
              [-48.835275844999956, -28.337660414999903],
              [-48.85057532499991, -28.323663018999923],
              [-48.86461341099994, -28.32089609199994],
              [-48.87401282499991, -28.34628671699994],
              [-48.87267005099994, -28.35865650799991],
              [-48.86229407499991, -28.380466403999947],
              [-48.85973059799994, -28.391289971999925],
              [-48.86192786399994, -28.400567315999922],
              [-48.87173417899993, -28.409763278999947],
              [-48.87401282499991, -28.41887786299992],
              [-48.869252081999946, -28.42669036299992],
              [-48.85850989499994, -28.427341403999947],
              [-48.84683183499993, -28.426039320999905],
              [-48.83922278599994, -28.428887627999927],
              [-48.838449673999946, -28.43718840899993],
              [-48.843006964999915, -28.44573333099993],
              [-48.84911048099991, -28.454522393999923],
              [-48.85289466099994, -28.463636976999908],
              [-48.85456295499995, -28.47128671699994],
              [-48.85488847599993, -28.475274346999925],
              [-48.85179602799991, -28.479261976999908],
              [-48.843006964999915, -28.487481377999927],
              [-48.80846106699994, -28.504571221999925],
              [-48.79869544199994, -28.514336846999925],
              [-48.789173956999946, -28.521416924999926],
              [-48.77774003799993, -28.52507903399993],
              [-48.76927649599992, -28.51767343499995],
              [-48.76089433499993, -28.512790622999944],
              [-48.74986731699994, -28.51140715899993],
              [-48.75609290299991, -28.528415622999944],
              [-48.765288865999935, -28.543633721999925],
              [-48.79596920499995, -28.579522393999923],
              [-48.80711829299992, -28.60019296699994],
              [-48.815337693999936, -28.610446872999944],
              [-48.82591712099992, -28.615004164999903],
              [-48.87051347599993, -28.62004973799992],
              [-48.884103969999956, -28.623223565999922],
              [-48.91246497299994, -28.637872002999927],
              [-48.94058183499993, -28.64544036299992],
              [-48.95539303299995, -28.655694268999923],
              [-48.97638912699995, -28.675225518999923],
              [-49.05703691299993, -28.718519789999903],
              [-49.34276282499991, -28.92351653399993],
              [-49.55231686099995, -29.12737395599993],
              [-49.71353105399993, -29.324476820999905],
              [-49.810658331999946, -29.443129164999903],
              [-49.860259568999936, -29.52857838299991],
              [-49.933583136999914, -29.634372653999947],
              [-49.99742591099994, -29.76458098799992],
              [-50.04531816299993, -29.81454843499995],
              [-50.20689856699994, -30.201104424999926],
              [-50.25137285099993, -30.32284921699994],
              [-50.315663214999915, -30.46152109199994],
              [-50.58763587099992, -30.851006768999923],
              [-50.59333248599995, -30.87151458099993],
              [-50.59951738199993, -30.88144296699994],
              [-50.72142493399991, -31.044528903999947],
              [-50.82843990799995, -31.14267343499995],
              [-50.883656378999945, -31.219903252999927],
              [-51.03457597599993, -31.378024997999944],
              [-51.15184485599991, -31.481540622999944],
              [-51.32396399599992, -31.60393645599993],
              [-51.563343878999945, -31.77743905999995],
              [-51.86351477799991, -31.93173593499995],
              [-51.88927161399994, -31.953789971999925],
              [-52.03262285099993, -32.10898202899995],
              [-52.06859290299991, -32.162367445999905],
              [-52.077381964999915, -32.16725025799991],
              [-52.08446204299992, -32.14690520599993],
              [-52.07689368399991, -32.12379322699991],
              [-52.05313066299993, -32.087823174999926],
              [-52.04670162699995, -32.07431405999995],
              [-52.03892981699994, -32.051853122999944],
              [-52.03575598899994, -32.02792734199994],
              [-52.04287675699993, -32.0095354149999],
              [-52.056630011999914, -31.98837655999995],
              [-52.045033331999946, -31.976820570999905],
              [-52.024728969999956, -31.966973565999922],
              [-52.01219641799992, -31.950616143999923],
              [-52.02586829299992, -31.919691664999903],
              [-52.087961391999954, -31.858575127999927],
              [-52.08726966099994, -31.82781340899993],
              [-52.04845130099994, -31.80828215899993],
              [-52.00182044199994, -31.82154713299991],
              [-51.922759568999936, -31.868747653999947],
              [-51.87999426999994, -31.871270440999922],
              [-51.83633378799993, -31.854913018999923],
              [-51.813710089999915, -31.828383070999905],
              [-51.834095831999946, -31.80046965899993],
              [-51.786040818999936, -31.792087497999944],
              [-51.74372311099995, -31.794854424999926],
              [-51.70449785099993, -31.792738539999903],
              [-51.66616777299993, -31.769707940999922],
              [-51.560210740999935, -31.667575778999947],
              [-51.54539954299992, -31.639743747999944],
              [-51.512562628999945, -31.615980726999908],
              [-51.505116339999915, -31.59807708099993],
              [-51.49868730399993, -31.574883721999925],
              [-51.48412024599992, -31.58294036299992],
              [-51.45726477799991, -31.615492445999905],
              [-51.44762122299994, -31.612725518999923],
              [-51.45099850199995, -31.595310153999947],
              [-51.46349036399994, -31.55722421699994],
              [-51.459095831999946, -31.539320570999905],
              [-51.44835364499994, -31.51685963299991],
              [-51.43496660099993, -31.49651458099993],
              [-51.42251542899993, -31.485121351999908],
              [-51.41348222599993, -31.517836195999905],
              [-51.377797003999945, -31.526950778999947],
              [-51.334543423999946, -31.51921965899993],
              [-51.30304928299995, -31.502211195999905],
              [-51.28783118399991, -31.490004164999903],
              [-51.256703253999945, -31.472588799999926],
              [-51.244984503999945, -31.464043877999927],
              [-51.210275844999956, -31.416192315999922],
              [-51.17959550699993, -31.358982028999947],
              [-51.15855872299994, -31.28639088299991],
              [-51.15477454299992, -31.212090752999927],
              [-51.17613684799994, -31.14934661299992],
              [-51.17015540299991, -31.13534921699994],
              [-51.16283118399991, -31.092950127999927],
              [-51.16185462099992, -31.077732028999947],
              [-51.15339107999995, -31.067152601999908],
              [-51.13390051999994, -31.06959400799991],
              [-51.09727942599994, -31.08098723799992],
              [-51.07799231699994, -31.077894789999903],
              [-51.04784094999991, -31.064060153999947],
              [-51.03278561099995, -31.06064218499995],
              [-51.01398678299995, -31.062758070999905],
              [-51.006418423999946, -31.070489190999922],
              [-51.00576738199993, -31.124200127999927],
              [-51.003163214999915, -31.13290780999995],
              [-50.994252081999946, -31.136325778999947],
              [-50.98350989499994, -31.135023695999905],
              [-50.97594153599994, -31.13095468499995],
              [-50.97150631399995, -31.123304945999905],
              [-50.970041469999956, -31.11174895599993],
              [-50.96467037699995, -31.10125090899993],
              [-50.95287024599992, -31.095472914999903],
              [-50.941070115999935, -31.09189218499995],
              [-50.93590247299994, -31.087823174999926],
              [-50.93993079299992, -31.076429945999905],
              [-50.94871985599991, -31.07480234199994],
              [-50.95958411399994, -31.07626718499995],
              [-50.970041469999956, -31.07431405999995],
              [-50.98766028599994, -31.045586846999925],
              [-50.977447068999936, -31.008965752999927],
              [-50.96011308499993, -30.966973565999922],
              [-50.95641028599994, -30.92278411299992],
              [-50.97183183499993, -30.904066664999903],
              [-50.97842363199993, -30.893324476999908],
              [-50.97374426999994, -30.888604424999926],
              [-50.96304277299993, -30.889825127999927],
              [-50.950062628999945, -30.89495208099993],
              [-50.93932044199994, -30.896091403999947],
              [-50.91388912699995, -30.893324476999908],
              [-50.895415818999936, -30.885837497999944],
              [-50.819569464999915, -30.83131275799991],
              [-50.77969316299993, -30.823825778999947],
              [-50.76012122299994, -30.815118096999925],
              [-50.74388587099992, -30.803887627999927],
              [-50.73106848899994, -30.792413018999923],
              [-50.692616339999915, -30.726495049999926],
              [-50.67943274599992, -30.641696872999944],
              [-50.689523891999954, -30.464043877999927],
              [-50.69469153599994, -30.446058851999908],
              [-50.71336829299992, -30.408379815999922],
              [-50.72109941299993, -30.379082940999922],
              [-50.726633266999954, -30.37037525799991],
              [-50.72565670499995, -30.363051039999903],
              [-50.70995032499991, -30.354180596999925],
              [-50.69717363199993, -30.350762627999927],
              [-50.68993079299992, -30.35320403399993],
              [-50.675852016999954, -30.367852471999925],
              [-50.64513098899994, -30.392185153999947],
              [-50.642648891999954, -30.398370049999926],
              [-50.64631100199995, -30.404554945999905],
              [-50.65184485599991, -30.41139088299991],
              [-50.65469316299993, -30.419366143999923],
              [-50.64989173099991, -30.438571872999944],
              [-50.63805091099994, -30.457207940999922],
              [-50.62262936099995, -30.473728122999944],
              [-50.607533331999946, -30.485121351999908],
              [-50.57217363199993, -30.461114190999922],
              [-50.565012173999946, -30.45012786299992],
              [-50.56672115799995, -30.434258721999925],
              [-50.572824673999946, -30.40943775799991],
              [-50.56867428299995, -30.397637627999927],
              [-50.55516516799992, -30.378838799999926],
              [-50.53726152299993, -30.32040780999995],
              [-50.536773240999935, -30.294040622999944],
              [-50.53986568899995, -30.267510674999926],
              [-50.54552161399994, -30.251153252999927],
              [-50.58336341099994, -30.232028903999947],
              [-50.58771725199995, -30.226820570999905],
              [-50.59837805899991, -30.20240650799991],
              [-50.60387122299994, -30.19378020599993],
              [-50.61481686099995, -30.186211846999925],
              [-50.62559973899994, -30.183363539999903],
              [-50.63662675699993, -30.184991143999923],
              [-50.648548956999946, -30.19036223799992],
              [-50.67247473899994, -30.217054945999905],
              [-50.675852016999954, -30.21770598799992],
              [-50.678293423999946, -30.22820403399993],
              [-50.67617753799993, -30.231622002999927],
              [-50.669585740999935, -30.233982028999947],
              [-50.65843665299991, -30.24146900799991],
              [-50.65343176999994, -30.251560153999947],
              [-50.65526282499991, -30.261651299999926],
              [-50.662180141999954, -30.27548593499995],
              [-50.671986456999946, -30.288995049999926],
              [-50.69517981699994, -30.294366143999923],
              [-50.761057094999956, -30.29143645599993],
              [-50.77912350199995, -30.293226820999905],
              [-50.793527798999946, -30.302504164999903],
              [-50.799387173999946, -30.32350025799991],
              [-50.85716712099992, -30.317071221999925],
              [-50.87441972599993, -30.320082289999903],
              [-50.89753170499995, -30.310479424999926],
              [-50.912993943999936, -30.316664320999905],
              [-50.92292232999995, -30.333184502999927],
              [-50.92906653599994, -30.354180596999925],
              [-50.932850714999915, -30.380629164999903],
              [-50.93028723899994, -30.398614190999922],
              [-50.91539466099994, -30.436211846999925],
              [-50.936390753999945, -30.431573174999926],
              [-50.984364386999914, -30.395196221999925],
              [-51.003895636999914, -30.388116143999923],
              [-51.021473761999914, -30.38372161299992],
              [-51.034087693999936, -30.375664971999925],
              [-51.03892981699994, -30.357598565999922],
              [-51.040272589999915, -30.343519789999903],
              [-51.03868567599994, -30.338962497999944],
              [-51.03278561099995, -30.326918226999908],
              [-51.026275193999936, -30.317803643999923],
              [-51.01939856699994, -30.311293226999908],
              [-51.01390540299991, -30.304945570999905],
              [-51.01162675699993, -30.29615650799991],
              [-51.01480058499993, -30.27857838299991],
              [-51.023101365999935, -30.26376718499995],
              [-51.03416907499991, -30.257419528999947],
              [-51.045765753999945, -30.265394789999903],
              [-51.05260169199994, -30.265394789999903],
              [-51.05760657499991, -30.24187590899993],
              [-51.07945716099994, -30.237888278999947],
              [-51.10338294199994, -30.243259372999944],
              [-51.11465410099993, -30.24814218499995],
              [-51.12254798099991, -30.256036065999922],
              [-51.14077714799993, -30.247491143999923],
              [-51.17613684799994, -30.224541924999926],
              [-51.17145748599995, -30.20940520599993],
              [-51.18049068899995, -30.200372002999927],
              [-51.210275844999956, -30.19036223799992],
              [-51.21922766799992, -30.188897393999923],
              [-51.22687740799995, -30.190199476999908],
              [-51.23302161399994, -30.18987395599993],
              [-51.237538214999915, -30.183526299999926],
              [-51.235585089999915, -30.17815520599993],
              [-51.221262173999946, -30.16497161299992],
              [-51.21711178299995, -30.15634530999995],
              [-51.220366990999935, -30.13640715899993],
              [-51.23159745999993, -30.124769789999903],
              [-51.24404863199993, -30.11687590899993],
              [-51.251210089999915, -30.10784270599993],
              [-51.25047766799992, -30.091566664999903],
              [-51.23888098899994, -30.058526299999926],
              [-51.237538214999915, -30.03964609199994],
              [-51.25934811099995, -30.046807549999926],
              [-51.26280676999994, -30.032972914999903],
              [-51.26207434799994, -30.01376718499995],
              [-51.27171790299991, -30.00481536299992],
              [-51.28351803299995, -30.007419528999947],
              [-51.285267706999946, -30.01262786299992],
              [-51.28380286399994, -30.02076588299991],
              [-51.28595943899995, -30.03215911299992],
              [-51.303618943999936, -30.06340911299992],
              [-51.30646725199995, -30.070245049999926],
              [-51.30426998599995, -30.07626718499995],
              [-51.29930579299992, -30.078871351999908],
              [-51.29434160099993, -30.080743096999925],
              [-51.29214433499993, -30.083916924999926],
              [-51.29332434799994, -30.090101820999905],
              [-51.29845130099994, -30.09970468499995],
              [-51.29963131399995, -30.104668877999927],
              [-51.300038214999915, -30.12704843499995],
              [-51.30308997299994, -30.136325778999947],
              [-51.31017005099994, -30.145684502999927],
              [-51.31395423099991, -30.154554945999905],
              [-51.312163865999935, -30.165134372999944],
              [-51.30850175699993, -30.17620208099993],
              [-51.30646725199995, -30.186944268999923],
              [-51.30890865799995, -30.19736093499995],
              [-51.32697506399995, -30.224541924999926],
              [-51.316517706999946, -30.223321221999925],
              [-51.29865475199995, -30.21884530999995],
              [-51.289051886999914, -30.21770598799992],
              [-51.282460089999915, -30.221368096999925],
              [-51.264881964999915, -30.244886976999908],
              [-51.29214433499993, -30.271661065999922],
              [-51.28062903599994, -30.287367445999905],
              [-51.24718176999994, -30.297539971999925],
              [-51.237538214999915, -30.313246351999908],
              [-51.22813880099994, -30.30706145599993],
              [-51.208648240999935, -30.28875090899993],
              [-51.20409094999991, -30.285332940999922],
              [-51.19717363199993, -30.294691664999903],
              [-51.195301886999914, -30.30901458099993],
              [-51.196603969999956, -30.33717213299991],
              [-51.18773352799991, -30.360121351999908],
              [-51.166127081999946, -30.36296965899993],
              [-51.11465410099993, -30.34734465899993],
              [-51.093413865999935, -30.34498463299991],
              [-51.09064693899995, -30.35198333099993],
              [-51.09630286399994, -30.36614348799992],
              [-51.10041256399995, -30.38534921699994],
              [-51.104725714999915, -30.393243096999925],
              [-51.11481686099995, -30.401055596999925],
              [-51.12637285099993, -30.406996351999908],
              [-51.13512122299994, -30.40943775799991],
              [-51.14110266799992, -30.407810153999947],
              [-51.15330969999991, -30.398614190999922],
              [-51.16185462099992, -30.395196221999925],
              [-51.200428839999915, -30.399834893999923],
              [-51.22948157499991, -30.42587655999995],
              [-51.25047766799992, -30.462334893999923],
              [-51.27794348899994, -30.540134372999944],
              [-51.28697669199994, -30.581638278999947],
              [-51.29019120999993, -30.624444268999923],
              [-51.28595943899995, -30.66961028399993],
              [-51.267567511999914, -30.73495859199994],
              [-51.264881964999915, -30.75554778399993],
              [-51.26968339799993, -30.78183359199994],
              [-51.28172766799992, -30.79656340899993],
              [-51.29767818899995, -30.79534270599993],
              [-51.31395423099991, -30.773207289999903],
              [-51.28945878799993, -30.767347914999903],
              [-51.29116777299993, -30.73992278399993],
              [-51.31395423099991, -30.683770440999922],
              [-51.32249915299991, -30.642185153999947],
              [-51.33283443899995, -30.63640715899993],
              [-51.357980923999946, -30.635430596999925],
              [-51.37710527299993, -30.64226653399993],
              [-51.38329016799992, -30.658868096999925],
              [-51.38158118399991, -30.77629973799992],
              [-51.37877356699994, -30.794122002999927],
              [-51.36546790299991, -30.832289320999905],
              [-51.36107337099992, -30.854587497999944],
              [-51.361887173999946, -30.879164320999905],
              [-51.37071692599994, -30.886488539999903],
              [-51.41258704299992, -30.88250090899993],
              [-51.43712317599994, -30.883884372999944],
              [-51.45543372299994, -30.889418226999908],
              [-51.46861731699994, -30.90162525799991],
              [-51.477772589999915, -30.92278411299992],
              [-51.48570716099994, -30.967054945999905],
              [-51.48420162699995, -31.01295338299991],
              [-51.470814581999946, -31.05331796699994],
              [-51.443023240999935, -31.08098723799992],
              [-51.56969153599994, -31.11956145599993],
              [-51.590687628999945, -31.12200286299992],
              [-51.623605923999946, -31.13534921699994],
              [-51.64297441299993, -31.167087497999944],
              [-51.65086829299992, -31.20549895599993],
              [-51.64903723899994, -31.23870208099993],
              [-51.637603318999936, -31.250258070999905],
              [-51.63752193899995, -31.256524346999925],
              [-51.65282141799992, -31.259209893999923],
              [-51.663400844999956, -31.257256768999923],
              [-51.67430579299992, -31.253676039999903],
              [-51.68472245999993, -31.252129815999922],
              [-51.69375566299993, -31.255791924999926],
              [-51.712554490999935, -31.265883070999905],
              [-51.73501542899993, -31.269138278999947],
              [-51.779408331999946, -31.26604583099993],
              [-51.79588782499991, -31.267022393999923],
              [-51.81895911399994, -31.272230726999908],
              [-51.83946692599994, -31.28215911299992],
              [-51.85692298099991, -31.311211846999925],
              [-51.87755286399994, -31.311211846999925],
              [-51.90208899599992, -31.30673593499995],
              [-51.922759568999936, -31.306898695999905],
              [-51.92747962099992, -31.31145598799992],
              [-51.932199673999946, -31.318536065999922],
              [-51.940012173999946, -31.32512786299992],
              [-51.95384680899991, -31.328057549999926],
              [-51.96353105399993, -31.332289320999905],
              [-51.96369381399995, -31.341729424999926],
              [-51.95726477799991, -31.351169528999947],
              [-51.947336391999954, -31.355401299999926],
              [-51.94286048099991, -31.359307549999926],
              [-51.95140540299991, -31.36809661299992],
              [-51.98766028599994, -31.392510674999926],
              [-51.99351966099994, -31.398207289999903],
              [-51.99852454299992, -31.409356377999927],
              [-52.001616990999935, -31.429131768999923],
              [-51.99852454299992, -31.49537525799991],
              [-51.99982662699995, -31.507012627999927],
              [-52.004750128999945, -31.52792734199994],
              [-52.004750128999945, -31.539727471999925],
              [-52.00080318899995, -31.55120208099993],
              [-51.988392706999946, -31.56536223799992],
              [-51.98485266799992, -31.57390715899993],
              [-52.00153561099995, -31.62428150799991],
              [-52.004750128999945, -31.639743747999944],
              [-52.007923956999946, -31.64617278399993],
              [-52.014881964999915, -31.637465101999908],
              [-52.02586829299992, -31.615492445999905],
              [-52.030181443999936, -31.58912525799991],
              [-52.03262285099993, -31.58131275799991],
              [-52.04015051999994, -31.570245049999926],
              [-52.04596920499995, -31.566338799999926],
              [-52.052723761999914, -31.564060153999947],
              [-52.06309973899994, -31.55722421699994],
              [-52.07323157499991, -31.554294528999947],
              [-52.083322719999956, -31.55868905999995],
              [-52.091053839999915, -31.567559502999927],
              [-52.09410559799994, -31.577569268999923],
              [-52.089955206999946, -31.606133721999925],
              [-52.07909094999991, -31.610039971999925],
              [-52.063791469999956, -31.605238539999903],
              [-52.04629472599993, -31.608086846999925],
              [-52.04124915299991, -31.622653903999947],
              [-52.04914303299995, -31.643975518999923],
              [-52.063343878999945, -31.665459893999923],
              [-52.077381964999915, -31.68059661299992],
              [-52.095773891999954, -31.69109465899993],
              [-52.20372473899994, -31.727308851999908],
              [-52.21861731699994, -31.74065520599993],
              [-52.22447669199994, -31.762465101999908],
              [-52.22223873599995, -31.77434661299992],
              [-52.21239173099991, -31.794122002999927],
              [-52.210194464999915, -31.80046965899993],
              [-52.21304277299993, -31.809258721999925],
              [-52.21906490799995, -31.817966403999947],
              [-52.22419186099995, -31.82822030999995],
              [-52.22447669199994, -31.841403903999947],
              [-52.24559485599991, -31.840997002999927],
              [-52.24844316299993, -31.861993096999925],
              [-52.23570716099994, -31.879652601999908],
              [-52.210194464999915, -31.868747653999947],
              [-52.18667558499993, -31.894789320999905],
              [-52.18350175699993, -31.90007903399993],
              [-52.17886308499993, -31.90276458099993],
              [-52.156809048999946, -31.906914971999925],
              [-52.149322068999936, -31.909763278999947],
              [-52.14244544199994, -31.915459893999923],
              [-52.13609778599994, -31.922539971999925],
              [-52.13385982999995, -31.930840752999927],
              [-52.13906816299993, -31.940524997999944],
              [-52.14696204299992, -31.94182708099993],
              [-52.16978919199994, -31.93645598799992],
              [-52.18004309799994, -31.940524997999944],
              [-52.197255011999914, -31.949965101999908],
              [-52.21898352799991, -31.957207940999922],
              [-52.23766028599994, -31.966403903999947],
              [-52.24559485599991, -31.982028903999947],
              [-52.248117641999954, -32.01913827899995],
              [-52.252064581999946, -32.038181247999944],
              [-52.25861568899995, -32.05364348799992],
              [-52.22923743399991, -32.050713799999926],
              [-52.21117102799991, -32.05673593499995],
              [-52.21165930899991, -32.06796640399995],
              [-52.23810787699995, -32.08098723799992],
              [-52.21397864499994, -32.08611419099992],
              [-52.18211829299992, -32.07903411299992],
              [-52.154408331999946, -32.065118096999925],
              [-52.14248613199993, -32.05022551899992],
              [-52.13711503799993, -32.037774346999925],
              [-52.12409420499995, -32.02947356599992],
              [-52.10822506399995, -32.02556731599992],
              [-52.09410559799994, -32.026462497999944],
              [-52.08141028599994, -32.03199635199991],
              [-52.08145097599993, -32.03769296699994],
              [-52.09780839799993, -32.05022551899992],
              [-52.14745032499991, -32.0778947899999],
              [-52.16893469999991, -32.100681247999944],
              [-52.15615800699993, -32.12265390399995],
              [-52.13971920499995, -32.119073174999926],
              [-52.102853969999956, -32.07968515399995],
              [-52.08726966099994, -32.06731536299992],
              [-52.10057532499991, -32.10621510199991],
              [-52.101551886999914, -32.12265390399995],
              [-52.09117591099994, -32.15390390399995],
              [-52.09117591099994, -32.16611093499995],
              [-52.12743079299992, -32.1775041649999],
              [-52.228627081999946, -32.251071872999944],
              [-52.25340735599991, -32.28248463299991],
              [-52.37531490799995, -32.498711846999925],
              [-52.44318600199995, -32.68596770599993],
              [-52.47085527299993, -32.80095794099992],
              [-52.62169348899994, -33.10198333099993],
              [-52.64488684799994, -33.136976820999905],
              [-52.74404863199993, -33.24920012799993],
              [-52.81948808499993, -33.322523695999905],
              [-52.92088782499991, -33.403008721999925],
              [-53.09166419199994, -33.527276299999926],
              [-53.19440670499995, -33.61972421699994],
              [-53.26634680899991, -33.67669036299992],
              [-53.37881425699993, -33.740492445999905],
              [-53.379094569439076, -33.74067597231428],
              [-53.411282918999945, -33.74228037499992],
              [-53.42363358599991, -33.73101491299987],
              [-53.43081660999985, -33.713444925999895],
              [-53.44042842699986, -33.69711517399995],
              [-53.45670650299988, -33.68750335699994],
              [-53.47319128399997, -33.68740000399991],
              [-53.491071329999926, -33.6902938839999],
              [-53.51153519699997, -33.6902938839999],
              [-53.53964717599993, -33.64926279699995],
              [-53.53680497199994, -33.55986256899986],
              [-53.51401566599995, -33.394911396999944],
              [-53.53613317899996, -33.244636331999914],
              [-53.53685664899987, -33.17084238699995],
              [-53.52066175999988, -33.12497899199994],
              [-53.5116385499999, -33.09942555699986],
              [-53.511586872999885, -33.09932220499992],
              [-53.51153519699997, -33.09921885199991],
              [-53.48331986499991, -33.06728281599992],
              [-53.44911006699991, -33.042064716999874],
              [-53.32730871699994, -32.97364512199998],
              [-53.316301635999935, -32.96268971799991],
              [-53.309583699999905, -32.944396259999934],
              [-53.306999877999914, -32.90718922999993],
              [-53.29883500199989, -32.88910247799991],
              [-53.270826374999984, -32.86378102699993],
              [-53.2038537199999, -32.822439879999905],
              [-53.18283631199995, -32.799904104999925],
              [-53.163081013999914, -32.778721618999924],
              [-53.12685583499987, -32.75484710699993],
              [-53.11404007999997, -32.74058441099996],
              [-53.1108361419999, -32.72239430699992],
              [-53.119776164999934, -32.707408141999935],
              [-53.18612870399997, -32.646740010999864],
              [-53.201476603999936, -32.63723154699997],
              [-53.233722697999895, -32.62462249699986],
              [-53.26689896699992, -32.60736256899996],
              [-53.299093383999946, -32.60715586399991],
              [-53.31604325399988, -32.60271168999989],
              [-53.35908972199988, -32.58028411799991],
              [-53.415623738999926, -32.56416107199992],
              [-53.47463822399996, -32.508247171999926],
              [-53.537631795999886, -32.47021331799989],
              [-53.561299601999906, -32.44954274499989],
              [-53.581970174999924, -32.425771585999925],
              [-53.598920043999925, -32.3999333699999],
              [-53.609307006999956, -32.38784108499992],
              [-53.63478348899989, -32.368720804999924],
              [-53.643878539999946, -32.35559499099995],
              [-53.648684448999944, -32.33864512099994],
              [-53.6518367109999, -32.28831227599997],
              [-53.65855464699993, -32.254309183999936],
              [-53.670595255999984, -32.226403909999945],
              [-53.72144486499991, -32.16242848699996],
              [-53.750021931999896, -32.104034118999905],
              [-53.75136551899993, -32.06879079199993],
              [-53.75730830999996, -32.0550448609999],
              [-53.77182938699991, -32.04708668999993],
              [-53.830430460999935, -32.03644134499993],
              [-53.858077351999924, -32.0211967969999],
              [-53.87109981299997, -32.011481627999956],
              [-53.88143509999989, -32.00124969499997],
              [-53.88727453599998, -31.990500996999955],
              [-53.889755004999955, -31.98037241599991],
              [-53.894147501999925, -31.970140482999923],
              [-53.90582637599991, -31.959288431999965],
              [-53.93435176699995, -31.94254526799992],
              [-53.94876949099998, -31.93696421299991],
              [-53.96597774299994, -31.9325200399999],
              [-53.9988956309999, -31.929729511999938],
              [-54.008714152999886, -31.926525573999882],
              [-54.0177058509999, -31.919600931999895],
              [-54.02664587399994, -31.90482147199988],
              [-54.03264033999997, -31.89810353599995],
              [-54.04974523999991, -31.887148131999965],
              [-54.0688138429999, -31.87991343199991],
              [-54.08845088699994, -31.87815643299993],
              [-54.10731278499995, -31.883944192999905],
              [-54.12550288999989, -31.89851694799995],
              [-54.135063028999895, -31.908955586999895],
              [-54.146276814999936, -31.90988576299995],
              [-54.16958288599997, -31.895933124999956],
              [-54.21877884899993, -31.856659036999886],
              [-54.2742276619999, -31.82337941499995],
              [-54.3429573169999, -31.76932586599996],
              [-54.37349808799988, -31.73894012399991],
              [-54.40367712499997, -31.714652200999907],
              [-54.43649165799991, -31.694291686999875],
              [-54.463725138999905, -31.671864115999966],
              [-54.46722070599992, -31.664237422999904],
              [-54.47736771699991, -31.642098489999896],
              [-54.47896968699993, -31.601480813999956],
              [-54.48315547799987, -31.583910827999972],
              [-54.495041056999895, -31.565617369999913],
              [-54.50966548699998, -31.552284850999897],
              [-54.5623754479999, -31.51590464199991],
              [-54.57384761599991, -31.50246876999995],
              [-54.591520955999925, -31.471049498999918],
              [-54.604543416999945, -31.459784037999952],
              [-54.61968461099988, -31.455649921999935],
              [-54.65412695299992, -31.45575327499995],
              [-54.819775756999945, -31.435289407999903],
              [-54.84990311699991, -31.425057474999917],
              [-54.863364827999874, -31.417616068999905],
              [-54.87615474499995, -31.406350605999933],
              [-54.88780777999992, -31.39322479299996],
              [-54.90028763899991, -31.38206268299993],
              [-54.94080196099992, -31.365629577999883],
              [-54.96963741099995, -31.340824889999936],
              [-54.99534643599995, -31.311782734999937],
              [-55.01149532099993, -31.28780486999993],
              [-55.029375366999886, -31.26878794299995],
              [-55.04234615099992, -31.272611998999906],
              [-55.061104695999916, -31.30485809299995],
              [-55.07425634799998, -31.32056772799993],
              [-55.08725297099991, -31.32676889999992],
              [-55.10244584199995, -31.324288430999943],
              [-55.122237914999914, -31.313539732999914],
              [-55.169625203999885, -31.276436055999937],
              [-55.18828039599995, -31.266514179999945],
              [-55.22755448499993, -31.2534917199999],
              [-55.24434932499989, -31.24460337299989],
              [-55.259981445999955, -31.228687031999954],
              [-55.268740600999934, -31.21060028099994],
              [-55.282228149999895, -31.169052429999866],
              [-55.29370031699992, -31.153652851999965],
              [-55.32692826299993, -31.134945983999984],
              [-55.338038696999945, -31.125644225999878],
              [-55.344963338999946, -31.1084876499999],
              [-55.34842565899987, -31.07272755999989],
              [-55.35385168499994, -31.056294453999925],
              [-55.36857946799995, -31.037380878999983],
              [-55.44258011899987, -30.965550638999957],
              [-55.4890889079999, -30.92968719499993],
              [-55.511309773999926, -30.906122741999923],
              [-55.52748449699993, -30.894547220999883],
              [-55.5638647049999, -30.876460469999955],
              [-55.59187333199992, -30.848348490999925],
              [-55.61290563999992, -30.84338755299997],
              [-55.63404130099988, -30.847625019999924],
              [-55.64967342099993, -30.860957539999944],
              [-55.654582682999944, -30.87873423299989],
              [-55.6510686849999, -30.919972024999893],
              [-55.65274816899995, -30.93898895299995],
              [-55.66582230599991, -30.949324238999864],
              [-55.688301554999924, -30.94777394599994],
              [-55.71274450699988, -30.94343312599996],
              [-55.73189062499995, -30.945396829999893],
              [-55.74488724799991, -30.958625996999984],
              [-55.75550675499997, -30.992939147999905],
              [-55.76359411699988, -31.008442076999927],
              [-55.77814103199992, -31.020431009999882],
              [-55.81652184935517, -31.042550624978453],
              [-55.81672787464329, -31.0426693613776],
              [-55.832478800999894, -31.051746927999986],
              [-55.83839575199991, -31.058154805999934],
              [-55.84214229399993, -31.063942564999905],
              [-55.846586465999934, -31.06931691499996],
              [-55.854596313999906, -31.074587910999895],
              [-55.86425980699994, -31.07675832099997],
              [-55.88818599399994, -31.076965026999943],
              [-55.91934688399991, -31.082442728999922],
              [-55.98515681999987, -31.078825378999937],
              [-56.00987402099989, -31.08194549799991],
              [-56.011356770999896, -31.082132669999936],
              [-56.01701787399989, -31.074296298999926],
              [-56.022182983999926, -31.067146504999883],
              [-56.02238968899991, -31.04554575599991],
              [-56.01634354699985, -30.999863789999978],
              [-56.01551672399992, -30.934338073999896],
              [-56.011356770999896, -30.912633971999895],
              [-55.99386429899994, -30.8854521679999],
              [-55.98901646357994, -30.856161036811187],
              [-55.988955037999915, -30.855789896999937],
              [-55.98900402714959, -30.855558891245156],
              [-55.99531123899993, -30.825817566],
              [-56.011356770999896, -30.798222350999907],
              [-56.07685664899989, -30.752333678999932],
              [-56.09189449099998, -30.736107279999928],
              [-56.12504492199989, -30.68029673199996],
              [-56.13168534399989, -30.671925149999893],
              [-56.14031530799994, -30.664793801999863],
              [-56.159642293999894, -30.65394175199991],
              [-56.17080440299992, -30.64577687599997],
              [-56.17517106199992, -30.63606170699994],
              [-56.177832397999936, -30.625519713999978],
              [-56.18351680599997, -30.61456431099991],
              [-56.21509110499994, -30.581904805999926],
              [-56.235089884999894, -30.565368346999932],
              [-56.26795609599992, -30.55110565199996],
              [-56.32653133199992, -30.50831756599993],
              [-56.372600870999946, -30.485889993999933],
              [-56.38598506699989, -30.47576141399989],
              [-56.40045446799991, -30.458914896999914],
              [-56.424639038999885, -30.42356821699991],
              [-56.44127884999992, -30.408788756999897],
              [-56.494557250999975, -30.379333190999986],
              [-56.51130041499994, -30.366000671999956],
              [-56.523754435999905, -30.357319029999914],
              [-56.56078059899997, -30.320525410999906],
              [-56.56961726899988, -30.308019714999915],
              [-56.575017455999955, -30.30243866],
              [-56.58581783099987, -30.2965475459999],
              [-56.59561051399993, -30.295410664999892],
              [-56.60519649299994, -30.295617369999945],
              [-56.61540258799991, -30.293343606999926],
              [-56.631344766999945, -30.284661966999877],
              [-56.632429972999944, -30.278150736999905],
              [-56.62927770999988, -30.267712096999958],
              [-56.6325850019999, -30.24745493499995],
              [-56.64178340699988, -30.233915709999877],
              [-56.656821248999876, -30.221306660999943],
              [-56.67374527999996, -30.211281432999925],
              [-56.7047769779999, -30.19836232499992],
              [-56.76699540199991, -30.161362],
              [-56.776607218999914, -30.150923359999922],
              [-56.795159057999854, -30.12384490999996],
              [-56.831280884999956, -30.102037454999945],
              [-56.869211384999886, -30.102967630999984],
              [-56.90636673999998, -30.10854868599992],
              [-56.95452917499995, -30.096869811999937],
              [-56.9745796309999, -30.097489928999906],
              [-57.01126989799988, -30.10348439499994],
              [-57.01829789299998, -30.105758158999947],
              [-57.037883260999905, -30.114646504999968],
              [-57.048528605999905, -30.11454315199994],
              [-57.06723547399989, -30.10679168699994],
              [-57.07710567299995, -30.106068216999944],
              [-57.102272094999904, -30.121157735999944],
              [-57.12955725099991, -30.149993183999882],
              [-57.1508479419999, -30.182342630999955],
              [-57.158341023999924, -30.20787078799991],
              [-57.16381872599993, -30.23929005999993],
              [-57.183714152999926, -30.2675053909999],
              [-57.21260127799988, -30.287349140999893],
              [-57.24505407699991, -30.293343606999926],
              [-57.250066691999876, -30.290449726999938],
              [-57.262469034999924, -30.27866750099993],
              [-57.27037552899989, -30.27515350299997],
              [-57.27621496599997, -30.27773732499989],
              [-57.28861730999992, -30.290759785999924],
              [-57.29647212699987, -30.293343606999926],
              [-57.3109932049999, -30.288279316999947],
              [-57.321741902999946, -30.279804381999938],
              [-57.334299275999854, -30.272673033999908],
              [-57.35383296799995, -30.271949564999915],
              [-57.366597045999924, -30.277220560999936],
              [-57.38938635299991, -30.294893900999938],
              [-57.399256550999894, -30.299131367999905],
              [-57.41481115699992, -30.29572072299996],
              [-57.42979732299989, -30.27546356199987],
              [-57.44312984299992, -30.269469095999938],
              [-57.467211059999954, -30.26988250699995],
              [-57.51098099799995, -30.27670379699991],
              [-57.53599239099995, -30.27443003399989],
              [-57.567463338999914, -30.25634328199996],
              [-57.586842000999866, -30.204046731999952],
              [-57.602792548565105, -30.190516953885325],
            ],
          ],
          [
            [
              [-38.944203253999945, -13.39462655999995],
              [-38.91563880099994, -13.383477471999925],
              [-38.906239386999914, -13.388848565999922],
              [-38.89635169199994, -13.453545830999929],
              [-38.89940344999991, -13.471368096999925],
              [-38.91633053299995, -13.483982028999947],
              [-38.90953528599994, -13.495212497999944],
              [-38.91454016799992, -13.508558851999908],
              [-38.923817511999914, -13.52312590899993],
              [-38.92992102799991, -13.537855726999908],
              [-38.93439693899995, -13.556247653999947],
              [-38.93196224899992, -13.56833303399992],
              [-38.91739115999991, -13.580965886999934],
              [-38.91472879699995, -13.592517056999952],
              [-38.905043932999945, -13.599892475999923],
              [-38.90667943099993, -13.606185091999919],
              [-38.906719997999915, -13.621402905999958],
              [-38.89595201199995, -13.630357703999948],
              [-38.893275461999906, -13.639286114999948],
              [-38.90201319899995, -13.67181217399991],
              [-38.91281391699994, -13.671780756999908],
              [-38.918743958999926, -13.667042917999936],
              [-38.92033601399993, -13.655495273999918],
              [-38.937595932999955, -13.65595357999996],
              [-38.94948897499995, -13.658024097999942],
              [-38.957521828999916, -13.632290606999959],
              [-38.9790558599999, -13.59969488999991],
              [-38.98545262199991, -13.573429162999957],
              [-38.98377952699991, -13.558211539999945],
              [-38.980539516999954, -13.547295830999929],
              [-38.97834225199995, -13.51734791499996],
              [-38.973215298999946, -13.508477471999925],
              [-38.96788489499994, -13.503350518999923],
              [-38.96784420499995, -13.498304945999905],
              [-38.97834225199995, -13.490166924999926],
              [-39.02676347599993, -13.47234465899993],
              [-39.04588782499991, -13.458184502999927],
              [-39.03359941299993, -13.44231536299992],
              [-39.04255123599995, -13.42392343499995],
              [-39.041900193999936, -13.40593840899993],
              [-39.03258216099994, -13.392510674999926],
              [-39.01553300699993, -13.387139580999929],
              [-38.99958248599995, -13.389825127999927],
              [-38.98346920499995, -13.394789320999905],
              [-38.96564693899995, -13.397881768999923],
              [-38.944203253999945, -13.39462655999995],
            ],
          ],
          [
            [
              [-38.61461341099994, -12.924981377999927],
              [-38.59288489499994, -12.96461353999996],
              [-38.58747311099995, -12.986911716999941],
              [-38.60496985599991, -12.996677341999941],
              [-38.624989386999914, -13.00164153399993],
              [-38.64244544199994, -13.01376718499995],
              [-38.676665818999936, -13.044528903999947],
              [-38.71849524599992, -13.072849216999941],
              [-38.73737545499995, -13.08993905999995],
              [-38.75243079299992, -13.112725518999923],
              [-38.76268469999991, -13.116794528999947],
              [-38.77049719999991, -13.121026299999926],
              [-38.77586829299992, -13.126560153999947],
              [-38.77912350199995, -13.133884372999944],
              [-38.78652910099993, -13.133884372999944],
              [-38.78628495999993, -13.11842213299991],
              [-38.79336503799993, -13.07512786299992],
              [-38.79124915299991, -13.05836353999996],
              [-38.78490149599992, -13.04973723799992],
              [-38.75926673099991, -13.037041924999926],
              [-38.73192298099991, -13.017754815999922],
              [-38.669260219999956, -12.96184661299992],
              [-38.669260219999956, -12.955010674999926],
              [-38.67878170499995, -12.953057549999926],
              [-38.68333899599992, -12.949965101999908],
              [-38.68276933499993, -12.944512627999927],
              [-38.676665818999936, -12.93523528399993],
              [-38.67446855399993, -12.937920830999929],
              [-38.67430579299992, -12.939060153999947],
              [-38.67341061099995, -12.940036716999941],
              [-38.669260219999956, -12.942071221999925],
              [-38.67064368399991, -12.924981377999927],
              [-38.678944464999915, -12.910088799999926],
              [-38.689442511999914, -12.89576588299991],
              [-38.69713294199994, -12.88054778399993],
              [-38.68346106699994, -12.873223565999922],
              [-38.64077714799993, -12.892754815999922],
              [-38.622303839999915, -12.905368747999944],
              [-38.61461341099994, -12.924981377999927],
            ],
          ],
          [
            [
              [-44.49779212099992, -2.806817315999922],
              [-44.507801886999914, -2.808851820999962],
              [-44.513742641999954, -2.814629815999922],
              [-44.51593990799995, -2.823337497999944],
              [-44.514881964999915, -2.834161065999922],
              [-44.50719153599994, -2.822523695999962],
              [-44.48078365799995, -2.793145440999922],
              [-44.48814856699994, -2.872002862999921],
              [-44.49233964799993, -2.890801690999922],
              [-44.50047766799992, -2.90357838299991],
              [-44.50568600199995, -2.915134372999944],
              [-44.497303839999915, -2.949314059999949],
              [-44.51520748599995, -2.959730726999908],
              [-44.53819739499994, -2.96998463299991],
              [-44.55728105399993, -3.002862237999921],
              [-44.58535722599993, -3.035577080999929],
              [-44.58381100199995, -3.046482028999947],
              [-44.58853105399993, -3.052666924999926],
              [-44.589955206999946, -3.055433851999908],
              [-44.59064693899995, -3.060153903999947],
              [-44.59801184799994, -3.060153903999947],
              [-44.598500128999945, -3.051690362999921],
              [-44.60069739499994, -3.045017184999949],
              [-44.60313880099994, -3.039727471999925],
              [-44.60423743399991, -3.035902601999908],
              [-44.60411536399994, -3.025974216999941],
              [-44.60342363199993, -3.022149346999925],
              [-44.59089107999995, -2.999607028999947],
              [-44.58385169199994, -2.990411065999922],
              [-44.57848059799994, -2.981052341999941],
              [-44.574289516999954, -2.956963799999926],
              [-44.565337693999936, -2.932386976999908],
              [-44.56330318899995, -2.919854424999926],
              [-44.565663214999915, -2.902601820999962],
              [-44.58381100199995, -2.862074476999908],
              [-44.58568274599992, -2.845879815999922],
              [-44.584095831999946, -2.829522393999923],
              [-44.57632402299993, -2.799981377999927],
              [-44.54767818899995, -2.744073174999926],
              [-44.526600714999915, -2.72779713299991],
              [-44.48078365799995, -2.70435963299991],
              [-44.48395748599995, -2.761163018999923],
              [-44.49779212099992, -2.806817315999922],
            ],
          ],
          [
            [
              [-42.04141191299993, -2.70435963299991],
              [-42.035267706999946, -2.70435963299991],
              [-42.03595943899995, -2.715427341999941],
              [-42.03477942599994, -2.72584400799991],
              [-42.03197180899991, -2.735935153999947],
              [-42.02782141799992, -2.744805596999925],
              [-42.03530839799993, -2.749769789999959],
              [-42.043527798999946, -2.754001559999949],
              [-42.05235755099994, -2.75709400799991],
              [-42.07396399599992, -2.760511976999908],
              [-42.085194464999915, -2.758721612999921],
              [-42.094960089999915, -2.753513278999947],
              [-42.10289466099994, -2.744805596999925],
              [-42.08893795499995, -2.739027601999908],
              [-42.08238684799994, -2.738539320999962],
              [-42.08238684799994, -2.731133721999925],
              [-42.095692511999914, -2.729180596999925],
              [-42.10533606699994, -2.72429778399993],
              [-42.10875403599994, -2.71607838299991],
              [-42.10289466099994, -2.70435963299991],
              [-42.12368730399993, -2.707289320999962],
              [-42.14415442599994, -2.70086028399993],
              [-42.18602454299992, -2.676446221999925],
              [-42.17088782499991, -2.672946872999944],
              [-42.09137936099995, -2.678399346999925],
              [-42.073475714999915, -2.684502862999921],
              [-42.05931555899991, -2.695245049999926],
              [-42.04824785099993, -2.71062590899993],
              [-42.04454505099994, -2.707940362999921],
              [-42.043527798999946, -2.706963799999926],
              [-42.04141191299993, -2.70435963299991],
            ],
          ],
          [
            [
              [-43.62730872299994, -2.252048434999949],
              [-43.607020647999946, -2.256328864999944],
              [-43.60406073599995, -2.265954195999939],
              [-43.59999271899994, -2.283722246999957],
              [-43.60962694999995, -2.301491534999911],
              [-43.62629900899992, -2.316303511999934],
              [-43.629633493999904, -2.332951803999947],
              [-43.63074496699994, -2.359582284999931],
              [-43.63259507399994, -2.376224452999907],
              [-43.64110830099992, -2.382882079999945],
              [-43.63591753299994, -2.392867729999921],
              [-43.63480545199991, -2.399894920999941],
              [-43.639246442999934, -2.404333982999958],
              [-43.65590842899991, -2.400265989999923],
              [-43.67552721599992, -2.400267454999948],
              [-43.68663153099993, -2.40100782199994],
              [-43.692923040999915, -2.408775021999929],
              [-43.70106602599992, -2.411364528999911],
              [-43.70439713199994, -2.415433309999912],
              [-43.707728140999905, -2.425050590999945],
              [-43.712540185999956, -2.426530346999925],
              [-43.72475545399993, -2.422092164999924],
              [-43.73289990699993, -2.419874568999944],
              [-43.74252353799994, -2.411737906999917],
              [-43.74326263499995, -2.402861250999933],
              [-43.73659972999991, -2.395094483999912],
              [-43.730306414999916, -2.374755107999931],
              [-43.73401235599994, -2.354414812999948],
              [-43.736608077999904, -2.33407074899992],
              [-43.72716223899994, -2.31804778399993],
              [-43.715402798999946, -2.289239190999922],
              [-43.70156816299993, -2.27467213299991],
              [-43.684478318999936, -2.26336028399993],
              [-43.668853318999936, -2.258721612999921],
              [-43.65607662699995, -2.257745049999926],
              [-43.63882402299993, -2.253024997999944],
              [-43.62730872299994, -2.252048434999949],
            ],
          ],
          [
            [
              [-49.287953253999945, -1.758477471999925],
              [-49.277007615999935, -1.767022393999923],
              [-49.28189042899993, -1.785821221999925],
              [-49.29332434799994, -1.804620049999926],
              [-49.301625128999945, -1.813164971999925],
              [-49.310210740999935, -1.818454684999949],
              [-49.33263098899994, -1.854099216999941],
              [-49.35952714799993, -1.883965752999927],
              [-49.36742102799991, -1.895114841999941],
              [-49.38548743399991, -1.887790622999944],
              [-49.42625891799992, -1.877618096999925],
              [-49.44249426999994, -1.867771091999941],
              [-49.45299231699994, -1.850192966999941],
              [-49.44762122299994, -1.837090752999927],
              [-49.42202714799993, -1.813164971999925],
              [-49.418853318999936, -1.804620049999926],
              [-49.415679490999935, -1.783868096999925],
              [-49.41148841099994, -1.775567315999922],
              [-49.40192623599995, -1.767347914999959],
              [-49.37364661399994, -1.75164153399993],
              [-49.35216223899994, -1.722426039999959],
              [-49.33812415299991, -1.712660414999959],
              [-49.31899980399993, -1.717461846999925],
              [-49.31631425699993, -1.731133721999925],
              [-49.309803839999915, -1.744398695999962],
              [-49.300119594999956, -1.754489841999941],
              [-49.287953253999945, -1.758477471999925],
            ],
          ],
          [
            [
              [-44.892241990999935, -1.271905205999929],
              [-44.87865149599992, -1.285088799999926],
              [-44.87645423099991, -1.29615650799991],
              [-44.88536536399994, -1.326429945999962],
              [-44.892241990999935, -1.326429945999962],
              [-44.89635169199994, -1.32000090899993],
              [-44.90269934799994, -1.31414153399993],
              [-44.910715298999946, -1.309258721999925],
              [-44.91954505099994, -1.30592213299991],
              [-44.918080206999946, -1.314629815999922],
              [-44.914051886999914, -1.321709893999923],
              [-44.907460089999915, -1.327732028999947],
              [-44.898508266999954, -1.332696221999925],
              [-44.90689042899993, -1.338067315999922],
              [-44.91466223899994, -1.345147393999923],
              [-44.92125403599994, -1.353122653999947],
              [-44.92638098899994, -1.36060963299991],
              [-44.93468176999994, -1.366631768999923],
              [-44.94322669199994, -1.370863539999959],
              [-44.952015753999945, -1.371677341999941],
              [-44.96117102799991, -1.367445570999962],
              [-44.96385657499991, -1.390557549999926],
              [-44.98033606699994, -1.396091403999947],
              [-45.00169837099992, -1.389825127999927],
              [-45.01891028599994, -1.377699476999908],
              [-45.02696692599994, -1.360528252999927],
              [-45.02692623599995, -1.340915622999944],
              [-45.02196204299992, -1.323418877999927],
              [-45.015736456999946, -1.31218840899993],
              [-45.00328528599994, -1.317478122999944],
              [-44.99624589799993, -1.326348565999922],
              [-44.99388587099992, -1.338555596999925],
              [-44.99526933499993, -1.353773695999962],
              [-44.98033606699994, -1.320489190999922],
              [-44.97793535099993, -1.300957940999922],
              [-44.991851365999935, -1.292413018999923],
              [-44.98997962099992, -1.284763278999947],
              [-44.98460852799991, -1.269952080999929],
              [-44.97435462099992, -1.260349216999941],
              [-44.94741777299993, -1.272881768999923],
              [-44.93919837099992, -1.268649997999944],
              [-44.93138587099992, -1.261325778999947],
              [-44.92296301999994, -1.257582289999959],
              [-44.915679490999935, -1.258965752999927],
              [-44.90758216099994, -1.262383721999925],
              [-44.892241990999935, -1.271905205999929],
            ],
          ],
          [
            [
              [-48.33897864499994, -1.066501559999949],
              [-48.324208136999914, -1.07586028399993],
              [-48.310617641999954, -1.112481377999927],
              [-48.29735266799992, -1.128513278999947],
              [-48.315337693999936, -1.155205987999921],
              [-48.31944739499994, -1.15943775799991],
              [-48.31810462099992, -1.181247653999947],
              [-48.31908118399991, -1.189385674999926],
              [-48.334095831999946, -1.205010674999926],
              [-48.34874426999994, -1.20867278399993],
              [-48.36375891799992, -1.209730726999908],
              [-48.37987219999991, -1.217217705999929],
              [-48.38809160099993, -1.211602471999925],
              [-48.39244544199994, -1.20476653399993],
              [-48.39391028599994, -1.197198174999926],
              [-48.39354407499991, -1.189385674999926],
              [-48.402333136999914, -1.202894789999959],
              [-48.41429602799991, -1.198011976999908],
              [-48.43455969999991, -1.176364841999941],
              [-48.45026607999995, -1.168552341999941],
              [-48.46206620999993, -1.164483330999929],
              [-48.46544348899994, -1.157647393999923],
              [-48.45567786399994, -1.141534112999921],
              [-48.43195553299995, -1.123630466999941],
              [-48.42833411399994, -1.117282809999949],
              [-48.42149817599994, -1.079522393999923],
              [-48.40501868399991, -1.068780205999929],
              [-48.38345292899993, -1.065362237999921],
              [-48.33897864499994, -1.066501559999949],
            ],
          ],
          [
            [
              [-48.19493567599994, -0.819431247999944],
              [-48.16274980399993, -0.850192966999941],
              [-48.15587317599994, -0.866306247999944],
              [-48.18126380099994, -0.867120049999926],
              [-48.18126380099994, -0.874607028999947],
              [-48.15672766799992, -0.887790622999944],
              [-48.16246497299994, -0.920830987999921],
              [-48.19493567599994, -0.983819268999923],
              [-48.20189368399991, -1.011488539999959],
              [-48.20738684799994, -1.017836195999962],
              [-48.22288977799991, -1.024834893999923],
              [-48.23770097599993, -1.027927341999941],
              [-48.28770911399994, -1.024834893999923],
              [-48.30711829299992, -1.020684502999927],
              [-48.31627356699994, -1.009535414999959],
              [-48.31899980399993, -0.993340752999927],
              [-48.31908118399991, -0.973728122999944],
              [-48.31265214799993, -0.953301690999922],
              [-48.28453528599994, -0.921482028999947],
              [-48.27379309799994, -0.895277601999908],
              [-48.25454667899993, -0.863051039999959],
              [-48.25015214799993, -0.850192966999941],
              [-48.24356035099993, -0.841729424999926],
              [-48.19493567599994, -0.819431247999944],
            ],
          ],
          [
            [
              [-47.948557094999956, -0.641289971999925],
              [-47.93529212099992, -0.636651299999926],
              [-47.914621548999946, -0.641696872999944],
              [-47.89561926999994, -0.653497002999927],
              [-47.88707434799994, -0.669122002999927],
              [-47.89557857999995, -0.69109465899993],
              [-47.91637122299994, -0.708591403999947],
              [-47.962147589999915, -0.730645440999922],
              [-47.964100714999915, -0.715101820999962],
              [-47.977772589999915, -0.691664320999962],
              [-47.98265540299991, -0.676039320999962],
              [-47.978627081999946, -0.67310963299991],
              [-47.97105872299994, -0.665785414999959],
              [-47.966867641999954, -0.658298434999949],
              [-47.97793535099993, -0.651788018999923],
              [-47.97642981699994, -0.644707940999922],
              [-47.97207597599993, -0.637465101999908],
              [-47.96906490799995, -0.633884372999944],
              [-47.961496548999946, -0.632582289999959],
              [-47.95523027299993, -0.633070570999962],
              [-47.95079505099994, -0.635837497999944],
              [-47.948557094999956, -0.641289971999925],
            ],
          ],
          [
            [
              [-50.819203253999945, -0.620212497999944],
              [-50.81289628799993, -0.655043226999908],
              [-50.813059048999946, -0.669122002999927],
              [-50.822255011999914, -0.699883721999925],
              [-50.84312903599994, -0.715997002999927],
              [-50.87205969999991, -0.722263278999947],
              [-50.905506964999915, -0.723239841999941],
              [-50.93431555899991, -0.73170338299991],
              [-50.97618567599994, -0.769789320999962],
              [-51.00108801999994, -0.778415622999944],
              [-51.02672278599994, -0.783786716999941],
              [-51.054025844999956, -0.79656340899993],
              [-51.07803300699993, -0.812269789999959],
              [-51.09414628799993, -0.826267184999949],
              [-51.10041256399995, -0.826267184999949],
              [-51.10973059799994, -0.806735934999949],
              [-51.11168372299994, -0.782321872999944],
              [-51.10802161399994, -0.755954684999949],
              [-51.10041256399995, -0.730645440999922],
              [-51.08177649599992, -0.701104424999926],
              [-51.07677161399994, -0.695896091999941],
              [-51.073475714999915, -0.692966403999947],
              [-51.06859290299991, -0.679782809999949],
              [-51.06627356699994, -0.676039320999962],
              [-51.05882727799991, -0.67506275799991],
              [-51.04556230399993, -0.68132903399993],
              [-51.03892981699994, -0.681573174999926],
              [-51.016468878999945, -0.667901299999926],
              [-50.980132615999935, -0.626153252999927],
              [-50.95641028599994, -0.60711028399993],
              [-50.90953528599994, -0.58326588299991],
              [-50.86082923099991, -0.565606377999927],
              [-50.87913977799991, -0.600274346999925],
              [-50.88133704299992, -0.613946221999925],
              [-50.87441972599993, -0.613946221999925],
              [-50.84093176999994, -0.558689059999949],
              [-50.83674068899995, -0.56178150799991],
              [-50.83503170499995, -0.565036716999941],
              [-50.83348548099991, -0.572930596999925],
              [-50.82876542899993, -0.583428643999923],
              [-50.819203253999945, -0.620212497999944],
            ],
          ],
          [
            [
              [-47.66051184799994, -0.579196872999944],
              [-47.64915930899991, -0.591566664999959],
              [-47.64077714799993, -0.608493747999944],
              [-47.63898678299995, -0.627862237999921],
              [-47.64688066299993, -0.64812590899993],
              [-47.64281165299991, -0.657972914999959],
              [-47.641835089999915, -0.67546965899993],
              [-47.643422003999945, -0.692966403999947],
              [-47.64688066299993, -0.702732028999947],
              [-47.658314581999946, -0.707696221999925],
              [-47.685658331999946, -0.706801039999959],
              [-47.70152747299994, -0.709567966999941],
              [-47.69896399599992, -0.693942966999941],
              [-47.70421301999994, -0.674899997999944],
              [-47.71561993499995, -0.636554550999961],
              [-47.75153607099992, -0.622250038999937],
              [-47.75089354699992, -0.60676299499994],
              [-47.76137900999993, -0.575770896999927],
              [-47.755788192999944, -0.566485160999946],
              [-47.74524840899994, -0.562782513999935],
              [-47.74336543699991, -0.547294045999934],
              [-47.73468157099995, -0.541729848999921],
              [-47.71547858099996, -0.547333440999921],
              [-47.706821919999925, -0.559739231999913],
              [-47.70375236299992, -0.57771364499996],
              [-47.6876482479999, -0.584553094999933],
              [-47.66051184799994, -0.579196872999944],
            ],
          ],
          [
            [
              [-51.18602454299992, -0.613946221999925],
              [-51.16291256399995, -0.620538018999923],
              [-51.151600714999915, -0.637139580999929],
              [-51.14997311099995, -0.658949476999908],
              [-51.15562903599994, -0.681573174999926],
              [-51.217640753999945, -0.801853122999944],
              [-51.23070227799991, -0.839288018999923],
              [-51.25230872299994, -0.961846612999921],
              [-51.271148240999935, -1.017673434999949],
              [-51.27562415299991, -1.025160414999959],
              [-51.28595943899995, -1.031670830999929],
              [-51.31029212099992, -1.002129815999922],
              [-51.33145097599993, -1.009942315999922],
              [-51.41002356699994, -1.153090101999908],
              [-51.434803839999915, -1.186700127999927],
              [-51.55626380099994, -1.288669528999947],
              [-51.59756425699993, -1.31218840899993],
              [-51.610218878999945, -1.315606377999927],
              [-51.61888587099992, -1.323663018999923],
              [-51.626210089999915, -1.332940362999921],
              [-51.634836391999954, -1.340101820999962],
              [-51.66270911399994, -1.349867445999962],
              [-51.66954505099994, -1.353773695999962],
              [-51.67125403599994, -1.357598565999922],
              [-51.67414303299995, -1.37037525799991],
              [-51.675770636999914, -1.37428150799991],
              [-51.68101966099994, -1.377129815999922],
              [-51.69513912699995, -1.381117445999962],
              [-51.70055091099994, -1.38445403399993],
              [-51.74083411399994, -1.420017184999949],
              [-51.78563391799992, -1.449965101999908],
              [-51.806711391999954, -1.457289320999962],
              [-51.85195878799993, -1.464043877999927],
              [-51.89248613199993, -1.48365650799991],
              [-51.91270911399994, -1.481377862999921],
              [-51.93028723899994, -1.470798434999949],
              [-51.943918423999946, -1.456231377999927],
              [-51.95409094999991, -1.422458591999941],
              [-51.94188391799992, -1.391371351999908],
              [-51.90294348899994, -1.340101820999962],
              [-51.897368943999936, -1.325127862999921],
              [-51.89305579299992, -1.305596612999921],
              [-51.88927161399994, -1.268161716999941],
              [-51.88426673099991, -1.256280205999929],
              [-51.87246660099993, -1.243259372999944],
              [-51.80565344999991, -1.193942966999941],
              [-51.79649817599994, -1.189385674999926],
              [-51.79531816299993, -1.184177341999941],
              [-51.78746497299994, -1.162286065999922],
              [-51.78563391799992, -1.158868096999925],
              [-51.78160559799994, -1.153903903999947],
              [-51.772043423999946, -1.151462497999944],
              [-51.75145423099991, -1.148370049999926],
              [-51.71788489499994, -1.129652601999908],
              [-51.68394934799994, -1.09693775799991],
              [-51.66836503799993, -1.057549737999921],
              [-51.69005286399994, -1.018649997999944],
              [-51.686105923999946, -0.884372653999947],
              [-51.675770636999914, -0.846774997999944],
              [-51.623605923999946, -0.790215752999927],
              [-51.582142706999946, -0.698663018999923],
              [-51.559803839999915, -0.664971612999921],
              [-51.534047003999945, -0.634698174999926],
              [-51.505116339999915, -0.60711028399993],
              [-51.45466061099995, -0.574639580999929],
              [-51.43993079299992, -0.56218840899993],
              [-51.42479407499991, -0.553806247999944],
              [-51.370432094999956, -0.534274997999944],
              [-51.35484778599994, -0.531996351999908],
              [-51.34740149599992, -0.531996351999908],
              [-51.356678839999915, -0.544040622999944],
              [-51.36302649599992, -0.562269789999959],
              [-51.36668860599991, -0.581638278999947],
              [-51.36790930899991, -0.596286716999941],
              [-51.36693274599992, -0.601657809999949],
              [-51.36538652299993, -0.605564059999949],
              [-51.36510169199994, -0.61060963299991],
              [-51.36790930899991, -0.620212497999944],
              [-51.373036261999914, -0.629327080999929],
              [-51.384755011999914, -0.644789320999962],
              [-51.38841712099992, -0.654880466999941],
              [-51.38158118399991, -0.654880466999941],
              [-51.37385006399995, -0.644707940999922],
              [-51.354400193999936, -0.62623463299991],
              [-51.34740149599992, -0.613946221999925],
              [-51.34788977799991, -0.600762627999927],
              [-51.35313880099994, -0.589450778999947],
              [-51.35366777299993, -0.580173434999949],
              [-51.34064693899995, -0.572930596999925],
              [-51.34064693899995, -0.592868747999944],
              [-51.33311926999994, -0.592868747999944],
              [-51.33311926999994, -0.572930596999925],
              [-51.325835740999935, -0.580498955999929],
              [-51.31798255099994, -0.586358330999929],
              [-51.30931555899991, -0.590427341999941],
              [-51.29963131399995, -0.592868747999944],
              [-51.32164466099994, -0.562595309999949],
              [-51.32697506399995, -0.551853122999944],
              [-51.32921301999994, -0.538669528999947],
              [-51.32652747299994, -0.53248463299991],
              [-51.322336391999954, -0.528497002999927],
              [-51.32013912699995, -0.521416924999926],
              [-51.30833899599992, -0.518731377999927],
              [-51.25377356699994, -0.531508070999962],
              [-51.237538214999915, -0.538262627999927],
              [-51.22325598899994, -0.55787525799991],
              [-51.20327714799993, -0.604668877999927],
              [-51.18602454299992, -0.613946221999925],
            ],
          ],
          [
            [
              [-51.165272589999915, -0.14031340899993],
              [-51.12083899599992, -0.14031340899993],
              [-51.12026933499993, -0.145440362999921],
              [-51.121937628999945, -0.146742445999962],
              [-51.12474524599992, -0.146742445999962],
              [-51.12828528599994, -0.14771900799991],
              [-51.13394120999993, -0.160821221999925],
              [-51.13585364499994, -0.17937590899993],
              [-51.134877081999946, -0.195896091999941],
              [-51.131703253999945, -0.203057549999926],
              [-51.144195115999935, -0.211358330999929],
              [-51.14867102799991, -0.230564059999949],
              [-51.14883378799993, -0.263848565999922],
              [-51.16673743399991, -0.305596612999921],
              [-51.201283331999946, -0.343682549999926],
              [-51.278553839999915, -0.401055596999925],
              [-51.34219316299993, -0.433770440999922],
              [-51.37559973899994, -0.460544528999947],
              [-51.393788214999915, -0.46648528399993],
              [-51.40510006399995, -0.459649346999925],
              [-51.402007615999935, -0.435723565999922],
              [-51.391468878999945, -0.424411716999941],
              [-51.37559973899994, -0.416924737999921],
              [-51.36119544199994, -0.40748463299991],
              [-51.35484778599994, -0.391208591999941],
              [-51.35147050699993, -0.385918877999927],
              [-51.33653723899994, -0.375583591999941],
              [-51.33043372299994, -0.366143487999921],
              [-51.26427161399994, -0.219496351999908],
              [-51.24323482999995, -0.198663018999923],
              [-51.23265540299991, -0.179457289999959],
              [-51.22704016799992, -0.17506275799991],
              [-51.197824673999946, -0.170830987999921],
              [-51.18976803299995, -0.168226820999962],
              [-51.183583136999914, -0.163181247999944],
              [-51.16616777299993, -0.144463799999926],
              [-51.165272589999915, -0.14031340899993],
            ],
          ],
          [
            [
              [-48.46251380099994, -0.576104424999926],
              [-48.46532141799992, -0.590427341999941],
              [-48.48289954299992, -0.627618096999925],
              [-48.484364386999914, -0.65357838299991],
              [-48.487172003999945, -0.664727471999925],
              [-48.49657141799992, -0.676039320999962],
              [-48.48582923099991, -0.684747002999927],
              [-48.48802649599992, -0.701836846999925],
              [-48.49445553299995, -0.722832940999922],
              [-48.49657141799992, -0.743747653999947],
              [-48.517689581999946, -0.734795830999929],
              [-48.53750566299993, -0.718926690999922],
              [-48.572336391999954, -0.681573174999926],
              [-48.56086178299995, -0.713962497999944],
              [-48.53791256399995, -0.744805596999925],
              [-48.523548956999946, -0.773370049999926],
              [-48.53750566299993, -0.798923434999949],
              [-48.526234503999945, -0.820245049999926],
              [-48.523426886999914, -0.846368096999925],
              [-48.52765865799995, -0.872653903999947],
              [-48.53750566299993, -0.894463799999926],
              [-48.56012936099995, -0.914320570999962],
              [-48.612945115999935, -0.93287525799991],
              [-48.63316809799994, -0.949151299999926],
              [-48.62767493399991, -0.958754164999959],
              [-48.63072669199994, -0.968926690999922],
              [-48.64745032499991, -0.990655205999929],
              [-48.657541469999956, -0.999200127999927],
              [-48.66478430899991, -1.00123463299991],
              [-48.66510982999995, -1.003106377999927],
              [-48.654286261999914, -1.011163018999923],
              [-48.64533443899995, -1.011895440999922],
              [-48.63585364499994, -1.008396091999941],
              [-48.62877356699994, -1.009698174999926],
              [-48.626942511999914, -1.024834893999923],
              [-48.63068600199995, -1.029066664999959],
              [-48.654286261999914, -1.045342705999929],
              [-48.654286261999914, -1.052829684999949],
              [-48.62828528599994, -1.047784112999921],
              [-48.62877356699994, -1.063164971999925],
              [-48.64281165299991, -1.083591403999947],
              [-48.65733801999994, -1.093682549999926],
              [-48.672434048999946, -1.101169528999947],
              [-48.717681443999936, -1.13404713299991],
              [-48.739898240999935, -1.141534112999921],
              [-48.75829016799992, -1.150648695999962],
              [-48.796131964999915, -1.192071221999925],
              [-48.81871497299994, -1.202894789999959],
              [-48.849598761999914, -1.198011976999908],
              [-48.875884568999936, -1.181247653999947],
              [-48.897694464999915, -1.158135674999926],
              [-48.914947068999936, -1.134698174999926],
              [-48.921131964999915, -1.141534112999921],
              [-48.91128495999993, -1.161228122999944],
              [-48.89484615799995, -1.181247653999947],
              [-48.87531490799995, -1.196709893999923],
              [-48.856312628999945, -1.202894789999959],
              [-48.84203040299991, -1.213311455999929],
              [-48.837147589999915, -1.233982028999947],
              [-48.84455318899995, -1.24928150799991],
              [-48.867176886999914, -1.243910414999959],
              [-48.867176886999914, -1.251397393999923],
              [-48.85387122299994, -1.254327080999929],
              [-48.82481848899994, -1.254652601999908],
              [-48.81187903599994, -1.257582289999959],
              [-48.79625403599994, -1.268487237999921],
              [-48.793080206999946, -1.279717705999929],
              [-48.80235755099994, -1.339776299999926],
              [-48.83299719999991, -1.415785414999959],
              [-48.83922278599994, -1.415785414999959],
              [-48.85838782499991, -1.399183851999908],
              [-48.94220943899995, -1.295830987999921],
              [-48.963775193999936, -1.282972914999959],
              [-48.99006100199995, -1.292413018999923],
              [-48.95738684799994, -1.295505466999941],
              [-48.94603430899991, -1.309014580999929],
              [-48.95498613199993, -1.324151299999926],
              [-48.983265753999945, -1.332696221999925],
              [-48.983265753999945, -1.340101820999962],
              [-48.97720292899993, -1.347263278999947],
              [-48.976633266999954, -1.356133721999925],
              [-48.98094641799992, -1.365655205999929],
              [-48.99006100199995, -1.37428150799991],
              [-48.97691809799994, -1.369073174999926],
              [-48.953114386999914, -1.350355726999908],
              [-48.94505774599992, -1.346368096999925],
              [-48.93496660099993, -1.351495049999926],
              [-48.92983964799993, -1.363539320999962],
              [-48.926340298999946, -1.377536716999941],
              [-48.921131964999915, -1.387872002999927],
              [-48.89883378799993, -1.393649997999944],
              [-48.89757239499994, -1.394707940999922],
              [-48.89240475199995, -1.398044528999947],
              [-48.88719641799992, -1.412692966999941],
              [-48.88390051999994, -1.415785414999959],
              [-48.87401282499991, -1.419366143999923],
              [-48.83922278599994, -1.442559502999927],
              [-48.83922278599994, -1.449965101999908],
              [-48.85537675699993, -1.453545830999929],
              [-48.871937628999945, -1.458916924999926],
              [-48.887562628999945, -1.466729424999926],
              [-48.901275193999936, -1.476739190999922],
              [-48.90461178299995, -1.483493747999944],
              [-48.90689042899993, -1.492771091999941],
              [-48.91063391799992, -1.501071872999944],
              [-48.918080206999946, -1.504571221999925],
              [-48.93529212099992, -1.493340752999927],
              [-48.94444739499994, -1.490980726999908],
              [-48.948475714999915, -1.501153252999927],
              [-48.95616614499994, -1.508721612999921],
              [-48.973866339999915, -1.514092705999929],
              [-49.02489173099991, -1.521579684999949],
              [-49.03652910099993, -1.528252862999921],
              [-49.048085089999915, -1.533298434999949],
              [-49.06578528599994, -1.531914971999925],
              [-49.07217363199993, -1.526950778999947],
              [-49.07241777299993, -1.520114841999941],
              [-49.073475714999915, -1.513929945999962],
              [-49.08250891799992, -1.51140715899993],
              [-49.09080969999991, -1.511163018999923],
              [-49.096913214999915, -1.510186455999929],
              [-49.10187740799995, -1.507989190999922],
              [-49.106760219999956, -1.504571221999925],
              [-49.11278235599991, -1.495293877999927],
              [-49.124989386999914, -1.463311455999929],
              [-49.12726803299995, -1.453057549999926],
              [-49.14952551999994, -1.409274997999944],
              [-49.15143795499995, -1.40162525799991],
              [-49.18187415299991, -1.40162525799991],
              [-49.18724524599992, -1.397637627999927],
              [-49.191517706999946, -1.391289971999925],
              [-49.19774329299992, -1.38836028399993],
              [-49.209095831999946, -1.394707940999922],
              [-49.19163977799991, -1.408623955999929],
              [-49.18439693899995, -1.42937590899993],
              [-49.18439693899995, -1.453383070999962],
              [-49.20409094999991, -1.529066664999959],
              [-49.20152747299994, -1.553155205999929],
              [-49.18187415299991, -1.56609465899993],
              [-49.19163977799991, -1.57195403399993],
              [-49.19546464799993, -1.57350025799991],
              [-49.19644120999993, -1.568780205999929],
              [-49.19762122299994, -1.566013278999947],
              [-49.20299231699994, -1.55982838299991],
              [-49.207915818999936, -1.565524997999944],
              [-49.213449673999946, -1.569105726999908],
              [-49.22028561099995, -1.57154713299991],
              [-49.22960364499994, -1.57350025799991],
              [-49.22203528599994, -1.58326588299991],
              [-49.21153723899994, -1.584242445999962],
              [-49.20156816299993, -1.586602471999925],
              [-49.19546464799993, -1.60084400799991],
              [-49.18895423099991, -1.593519789999959],
              [-49.18297278599994, -1.590101820999962],
              [-49.16820227799991, -1.586602471999925],
              [-49.18773352799991, -1.607598565999922],
              [-49.222767706999946, -1.621189059999949],
              [-49.25625566299993, -1.620049737999921],
              [-49.27457206699995, -1.621593221999944],
              [-49.293729208999935, -1.61753105899993],
              [-49.313877875999935, -1.604393639999955],
              [-49.33200330999995, -1.588234402999944],
              [-49.353179490999935, -1.57350025799991],
              [-49.38902747299994, -1.538832289999959],
              [-49.39411373599995, -1.528903903999947],
              [-49.391468878999945, -1.514743747999944],
              [-49.38646399599992, -1.503838799999926],
              [-49.38353430899991, -1.494235934999949],
              [-49.38731848899994, -1.484144789999959],
              [-49.39354407499991, -1.496189059999949],
              [-49.40652225999992, -1.517515745999958],
              [-49.414631140999916, -1.541702350999913],
              [-49.40962243599995, -1.563897014999952],
              [-49.375365149999936, -1.586142333999931],
              [-49.354233190999935, -1.614407902999915],
              [-49.35830571799994, -1.637586679999913],
              [-49.37243884299994, -1.646635346999915],
              [-49.406714149999914, -1.637503328999912],
              [-49.42486220199993, -1.632430420999924],
              [-49.44302450799995, -1.635422489999939],
              [-49.468228275999934, -1.623277590999919],
              [-49.483332109999935, -1.60207371599995],
              [-49.48452714799993, -1.56804778399993],
              [-49.490305141999954, -1.556084893999923],
              [-49.49657141799992, -1.49773528399993],
              [-49.50487219999991, -1.501397393999923],
              [-49.51325436099995, -1.502373955999929],
              [-49.52196204299992, -1.501153252999927],
              [-49.531320766999954, -1.49773528399993],
              [-49.52489173099991, -1.505629164999959],
              [-49.515736456999946, -1.51336028399993],
              [-49.50755774599992, -1.522637627999927],
              [-49.503977016999954, -1.535332940999922],
              [-49.503977016999954, -1.586602471999925],
              [-49.50926673099991, -1.582452080999929],
              [-49.51398678299995, -1.581638278999947],
              [-49.518788214999915, -1.58171965899993],
              [-49.52440344999991, -1.580336195999962],
              [-49.51390540299991, -1.592217705999929],
              [-49.51406816299993, -1.608086846999925],
              [-49.52196204299992, -1.622165622999944],
              [-49.534413214999915, -1.628106377999927],
              [-49.55125891799992, -1.633070570999962],
              [-49.55654863199993, -1.645440362999921],
              [-49.55345618399991, -1.660902601999908],
              [-49.544911261999914, -1.675957940999922],
              [-49.55919348899994, -1.675957940999922],
              [-49.55919348899994, -1.682793877999927],
              [-49.54539954299992, -1.686700127999927],
              [-49.544260219999956, -1.698337497999944],
              [-49.55174719999991, -1.720879815999922],
              [-49.558705206999946, -1.724216403999947],
              [-49.60326087099992, -1.717461846999925],
              [-49.623605923999946, -1.724867445999962],
              [-49.65416419199994, -1.760023695999962],
              [-49.66905676999994, -1.772149346999925],
              [-49.688343878999945, -1.769301039999959],
              [-49.705922003999945, -1.750583591999941],
              [-49.718739386999914, -1.722832940999922],
              [-49.72752844999991, -1.677666924999926],
              [-49.745350714999915, -1.652764580999929],
              [-49.75104732999995, -1.641778252999927],
              [-49.750111456999946, -1.624932549999926],
              [-49.73997962099992, -1.595147393999923],
              [-49.744211391999954, -1.580336195999962],
              [-49.748036261999914, -1.597914320999962],
              [-49.76113847599993, -1.630059502999927],
              [-49.76402747299994, -1.645196221999925],
              [-49.759755011999914, -1.669366143999923],
              [-49.72988847599993, -1.730564059999949],
              [-49.728505011999914, -1.741794528999947],
              [-49.72964433499993, -1.752618096999925],
              [-49.73265540299991, -1.762872002999927],
              [-49.73672441299993, -1.772149346999925],
              [-49.74376380099994, -1.780043226999908],
              [-49.77643795499995, -1.807224216999941],
              [-49.80028235599991, -1.817315362999921],
              [-49.80907141799992, -1.819268487999921],
              [-49.823557094999956, -1.816582940999922],
              [-49.83307857999995, -1.80982838299991],
              [-49.84166419199994, -1.801202080999929],
              [-49.85342363199993, -1.79265715899993],
              [-49.863392706999946, -1.789483330999929],
              [-49.88438880099994, -1.788262627999927],
              [-49.89439856699994, -1.785821221999925],
              [-49.90599524599992, -1.778090101999908],
              [-49.915353969999956, -1.769138278999947],
              [-49.92540442599994, -1.761651299999926],
              [-49.948109503999945, -1.756280205999929],
              [-49.96812903599994, -1.747002862999921],
              [-49.98005123599995, -1.744805596999925],
              [-50.00230872299994, -1.745538018999923],
              [-50.00739498599995, -1.74146900799991],
              [-50.02847245999993, -1.720472914999959],
              [-50.03233801999994, -1.715590101999908],
              [-50.03233801999994, -1.709730726999908],
              [-50.025949673999946, -1.660739841999941],
              [-50.028187628999945, -1.655450127999927],
              [-50.05028235599991, -1.657403252999927],
              [-50.054798956999946, -1.664727471999925],
              [-50.051991339999915, -1.67937590899993],
              [-50.052072719999956, -1.703871351999908],
              [-50.059885219999956, -1.717868747999944],
              [-50.08706620999993, -1.739190362999921],
              [-50.093006964999915, -1.748223565999922],
              [-50.15501868399991, -1.77898528399993],
              [-50.170033331999946, -1.770440362999921],
              [-50.177723761999914, -1.758965752999927],
              [-50.18700110599991, -1.749118747999944],
              [-50.22451738199993, -1.739027601999908],
              [-50.23379472599993, -1.724379164999959],
              [-50.237172003999945, -1.705336195999962],
              [-50.23460852799991, -1.633965752999927],
              [-50.23766028599994, -1.621270440999922],
              [-50.24836178299995, -1.615411065999922],
              [-50.26187089799993, -1.614190362999921],
              [-50.27358964799993, -1.610528252999927],
              [-50.278553839999915, -1.597426039999959],
              [-50.276234503999945, -1.588474216999941],
              [-50.270415818999936, -1.585870049999926],
              [-50.263661261999914, -1.584893487999921],
              [-50.25816809799994, -1.580336195999962],
              [-50.24962317599994, -1.563083591999941],
              [-50.24990800699993, -1.559340101999908],
              [-50.25381425699993, -1.543389580999929],
              [-50.26219641799992, -1.527113539999959],
              [-50.264963344999956, -1.518243096999925],
              [-50.26447506399995, -1.510918877999927],
              [-50.259429490999935, -1.493340752999927],
              [-50.25816809799994, -1.484144789999959],
              [-50.275949673999946, -1.497002862999921],
              [-50.27684485599991, -1.514580987999921],
              [-50.263010219999956, -1.550713799999926],
              [-50.26008053299995, -1.552666924999926],
              [-50.257883266999954, -1.554864190999922],
              [-50.25816809799994, -1.55982838299991],
              [-50.26109778599994, -1.564873955999929],
              [-50.26471920499995, -1.564873955999929],
              [-50.268422003999945, -1.564060153999947],
              [-50.27179928299995, -1.56609465899993],
              [-50.278553839999915, -1.574476820999962],
              [-50.285227016999954, -1.580743096999925],
              [-50.290272589999915, -1.587334893999923],
              [-50.292225714999915, -1.597426039999959],
              [-50.281239386999914, -1.613051039999959],
              [-50.25926673099991, -1.627048434999949],
              [-50.24258378799993, -1.641534112999921],
              [-50.24762936099995, -1.658868096999925],
              [-50.25499426999994, -1.675225518999923],
              [-50.26024329299992, -1.725274346999925],
              [-50.264963344999956, -1.744805596999925],
              [-50.27179928299995, -1.744805596999925],
              [-50.274728969999956, -1.724704684999949],
              [-50.29906165299991, -1.655450127999927],
              [-50.30650794199994, -1.655450127999927],
              [-50.287220831999946, -1.730889580999929],
              [-50.28477942599994, -1.755059502999927],
              [-50.294178839999915, -1.77271900799991],
              [-50.31655839799993, -1.778497002999927],
              [-50.34357662699995, -1.776950778999947],
              [-50.36668860599991, -1.772149346999925],
              [-50.34288489499994, -1.784926039999959],
              [-50.31212317599994, -1.793715101999908],
              [-50.296986456999946, -1.803480726999908],
              [-50.319569464999915, -1.819268487999921],
              [-50.34874426999994, -1.828708591999941],
              [-50.37677975199995, -1.832207940999922],
              [-50.405181443999936, -1.830987237999921],
              [-50.55972245999993, -1.799493096999925],
              [-50.57339433499993, -1.793633721999925],
              [-50.59642493399991, -1.775811455999929],
              [-50.60387122299994, -1.772149346999925],
              [-50.606678839999915, -1.764825127999927],
              [-50.60008704299992, -1.74928150799991],
              [-50.586008266999954, -1.734633070999962],
              [-50.56655839799993, -1.730564059999949],
              [-50.587880011999914, -1.684502862999921],
              [-50.74233964799993, -1.531182549999926],
              [-50.757923956999946, -1.508477471999925],
              [-50.764556443999936, -1.48756275799991],
              [-50.76862545499995, -1.478448174999926],
              [-50.79596920499995, -1.446221612999921],
              [-50.80321204299992, -1.434991143999923],
              [-50.80418860599991, -1.424981377999927],
              [-50.799387173999946, -1.40162525799991],
              [-50.797434048999946, -1.401543877999927],
              [-50.787953253999945, -1.394707940999922],
              [-50.785715298999946, -1.394707940999922],
              [-50.787953253999945, -1.38836028399993],
              [-50.79238847599993, -1.384942315999922],
              [-50.796945766999954, -1.382907809999949],
              [-50.799387173999946, -1.381117445999962],
              [-50.81163489499994, -1.349867445999962],
              [-50.813059048999946, -1.336358330999929],
              [-50.81086178299995, -1.314711195999962],
              [-50.77961178299995, -1.193942966999941],
              [-50.778228318999936, -1.172539971999925],
              [-50.78563391799992, -1.152113539999959],
              [-50.79922441299993, -1.126560153999947],
              [-50.80581620999993, -1.102308851999908],
              [-50.79255123599995, -1.086195570999962],
              [-50.780140753999945, -1.088311455999929],
              [-50.73729407499991, -1.113539320999962],
              [-50.675852016999954, -1.141534112999921],
              [-50.62930253799993, -1.150160414999959],
              [-50.61375891799992, -1.155205987999921],
              [-50.55972245999993, -1.183200778999947],
              [-50.57184811099995, -1.158623955999929],
              [-50.61668860599991, -1.119886976999908],
              [-50.589833136999914, -1.111504815999922],
              [-50.57652747299994, -1.102634372999944],
              [-50.56969153599994, -1.100518487999921],
              [-50.542307094999956, -1.105726820999962],
              [-50.53929602799991, -1.107354424999926],
              [-50.52208411399994, -1.096449476999908],
              [-50.52220618399991, -1.086602471999925],
              [-50.53416907499991, -1.078545830999929],
              [-50.55235755099994, -1.073337497999944],
              [-50.54434160099993, -1.052178643999923],
              [-50.54552161399994, -1.052829684999949],
              [-50.53001868399991, -1.03875090899993],
              [-50.51537024599992, -1.036716403999947],
              [-50.49864661399994, -1.039320570999962],
              [-50.476633266999954, -1.039157809999949],
              [-50.494984503999945, -1.029229424999926],
              [-50.51244055899991, -1.023858330999929],
              [-50.52847245999993, -1.025323174999926],
              [-50.54238847599993, -1.035332940999922],
              [-50.55846106699994, -1.051202080999929],
              [-50.57677161399994, -1.063164971999925],
              [-50.596587693999936, -1.070570570999962],
              [-50.61750240799995, -1.073337497999944],
              [-50.62612870999993, -1.076104424999926],
              [-50.64565995999993, -1.089450778999947],
              [-50.65469316299993, -1.093682549999926],
              [-50.66380774599992, -1.094903252999927],
              [-50.73517818899995, -1.08953215899993],
              [-50.75576738199993, -1.082207940999922],
              [-50.764556443999936, -1.069919528999947],
              [-50.76829993399991, -1.061130466999941],
              [-50.78612219999991, -1.033379815999922],
              [-50.79255123599995, -1.018649997999944],
              [-50.79800370999993, -0.984307549999926],
              [-50.798166469999956, -0.911309502999927],
              [-50.79255123599995, -0.874607028999947],
              [-50.78648841099994, -0.857354424999926],
              [-50.778635219999956, -0.842543226999908],
              [-50.77415930899991, -0.829847914999959],
              [-50.778228318999936, -0.819431247999944],
              [-50.76927649599992, -0.807305596999925],
              [-50.75763912699995, -0.806817315999922],
              [-50.74600175699993, -0.814222914999959],
              [-50.73729407499991, -0.826267184999949],
              [-50.74058997299994, -0.80201588299991],
              [-50.75377356699994, -0.792413018999923],
              [-50.770741339999915, -0.785739841999941],
              [-50.785715298999946, -0.770928643999923],
              [-50.78734290299991, -0.763278903999947],
              [-50.785715298999946, -0.73365650799991],
              [-50.78355872299994, -0.728773695999962],
              [-50.77424068899995, -0.720635674999926],
              [-50.772043423999946, -0.716403903999947],
              [-50.77415930899991, -0.710870049999926],
              [-50.78351803299995, -0.707289320999962],
              [-50.785715298999946, -0.702732028999947],
              [-50.77989661399994, -0.660577080999929],
              [-50.73729407499991, -0.551853122999944],
              [-50.724680141999954, -0.563653252999927],
              [-50.71129309799994, -0.586521091999941],
              [-50.70059160099993, -0.611748955999929],
              [-50.69635982999995, -0.630629164999959],
              [-50.68407141799992, -0.639825127999927],
              [-50.607533331999946, -0.676039320999962],
              [-50.587961391999954, -0.68132903399993],
              [-50.577381964999915, -0.682224216999941],
              [-50.551991339999915, -0.679620049999926],
              [-50.54845130099994, -0.677829684999949],
              [-50.55040442599994, -0.673760674999926],
              [-50.55235755099994, -0.665459893999923],
              [-50.56037350199995, -0.659274997999944],
              [-50.61375891799992, -0.641289971999925],
              [-50.673491990999935, -0.631036065999922],
              [-50.68268795499995, -0.623793226999908],
              [-50.68504798099991, -0.607842705999929],
              [-50.690744594999956, -0.587090752999927],
              [-50.716460740999935, -0.521742445999962],
              [-50.721547003999945, -0.503350518999923],
              [-50.72362219999991, -0.479913018999923],
              [-50.72105872299994, -0.465020440999922],
              [-50.703195766999954, -0.408461195999962],
              [-50.69994055899991, -0.371514580999929],
              [-50.69635982999995, -0.360039971999925],
              [-50.69176184799994, -0.354180596999925],
              [-50.678578253999945, -0.34107838299991],
              [-50.675852016999954, -0.335870049999926],
              [-50.67369544199994, -0.319268487999921],
              [-50.66832434799994, -0.298760674999926],
              [-50.65469316299993, -0.263848565999922],
              [-50.646473761999914, -0.255629164999959],
              [-50.61359615799995, -0.229180596999925],
              [-50.60387122299994, -0.223402601999908],
              [-50.598947719999956, -0.219333591999941],
              [-50.58336341099994, -0.192152601999908],
              [-50.57445227799991, -0.188083591999941],
              [-50.562570766999954, -0.188083591999941],
              [-50.550038214999915, -0.189222914999959],
              [-50.53929602799991, -0.18873463299991],
              [-50.52196204299992, -0.180352471999925],
              [-50.507801886999914, -0.168877862999921],
              [-50.49128170499995, -0.158868096999925],
              [-50.46666419199994, -0.154554945999962],
              [-50.44371497299994, -0.157972914999959],
              [-50.42658443899995, -0.163506768999923],
              [-50.41148841099994, -0.164483330999929],
              [-50.394642706999946, -0.154554945999962],
              [-50.38463294199994, -0.138929945999962],
              [-50.377797003999945, -0.120700778999947],
              [-50.36815344999991, -0.105645440999922],
              [-50.34996497299994, -0.099379164999959],
              [-50.327381964999915, -0.10092538899994],
              [-50.27179928299995, -0.113702080999929],
              [-50.095773891999954, -0.132256768999923],
              [-50.03844153599994, -0.154554945999962],
              [-50.00812740799995, -0.153008721999925],
              [-49.79454505099994, -0.198825778999947],
              [-49.65347245999993, -0.241143487999921],
              [-49.51984615799995, -0.23560963299991],
              [-49.481312628999945, -0.22584400799991],
              [-49.45958411399994, -0.223402601999908],
              [-49.449330206999946, -0.224704684999949],
              [-49.42516028599994, -0.230401299999926],
              [-49.417958136999914, -0.234551690999922],
              [-49.398508266999954, -0.253513278999947],
              [-49.38731848899994, -0.257582289999959],
              [-49.386830206999946, -0.251560153999947],
              [-49.398101365999935, -0.236504815999922],
              [-49.40843665299991, -0.217461846999925],
              [-49.40501868399991, -0.199314059999949],
              [-49.386830206999946, -0.184747002999927],
              [-49.32648678299995, -0.154554945999962],
              [-49.31826738199993, -0.160088799999926],
              [-49.31285559799994, -0.160088799999926],
              [-49.30724036399994, -0.157321872999944],
              [-49.29857337099992, -0.154554945999962],
              [-49.28368079299992, -0.155205987999921],
              [-49.274647589999915, -0.154473565999922],
              [-49.26162675699993, -0.149021091999941],
              [-49.236439581999946, -0.14771900799991],
              [-49.215402798999946, -0.141208591999941],
              [-49.20604407499991, -0.14031340899993],
              [-49.19481360599991, -0.141534112999921],
              [-49.181711391999954, -0.149346612999921],
              [-49.16820227799991, -0.154554945999962],
              [-49.15762285099993, -0.154066664999959],
              [-49.14476477799991, -0.151299737999921],
              [-49.13158118399991, -0.15203215899993],
              [-49.120350714999915, -0.162041924999926],
              [-49.09137936099995, -0.153903903999947],
              [-49.02562415299991, -0.160088799999926],
              [-49.01060691099991, -0.159888876999958],
              [-48.992718631999935, -0.171848386999955],
              [-48.97960455799995, -0.186191328999939],
              [-48.9605013069999, -0.182636553999941],
              [-48.94735949699992, -0.17310486699995],
              [-48.927048843999955, -0.158808582999939],
              [-48.89361192799993, -0.152885719999915],
              [-48.88048935499995, -0.16364714599996],
              [-48.88171072599994, -0.191104082999914],
              [-48.89247107199992, -0.205416419999949],
              [-48.89195716099994, -0.215915622999944],
              [-48.85973059799994, -0.209242445999962],
              [-48.816517706999946, -0.207614841999941],
              [-48.702015753999945, -0.237237237999921],
              [-48.68423417899993, -0.236504815999922],
              [-48.64631100199995, -0.22625090899993],
              [-48.62352454299992, -0.223402601999908],
              [-48.60142981699994, -0.226169528999947],
              [-48.54442298099991, -0.244073174999926],
              [-48.42723548099991, -0.259942315999922],
              [-48.40099036399994, -0.271254164999959],
              [-48.39354407499991, -0.271254164999959],
              [-48.38438880099994, -0.281426690999922],
              [-48.375559048999946, -0.288506768999923],
              [-48.36888587099992, -0.297946872999944],
              [-48.36628170499995, -0.315362237999921],
              [-48.36978105399993, -0.36060963299991],
              [-48.373117641999954, -0.373711846999925],
              [-48.378895636999914, -0.38404713299991],
              [-48.38841712099992, -0.395603122999944],
              [-48.399728969999956, -0.404717705999929],
              [-48.41063391799992, -0.408461195999962],
              [-48.42064368399991, -0.414971612999921],
              [-48.43150794199994, -0.447198174999926],
              [-48.45470130099994, -0.48560963299991],
              [-48.46157792899993, -0.515557549999926],
              [-48.46251380099994, -0.576104424999926],
            ],
          ],
          [
            [
              [-50.97374426999994, -0.291192315999922],
              [-51.01280676999994, -0.273614190999922],
              [-51.037953253999945, -0.235935153999947],
              [-51.03868567599994, -0.200290622999944],
              [-51.004750128999945, -0.18873463299991],
              [-51.004750128999945, -0.182549737999921],
              [-51.01252193899995, -0.180108330999929],
              [-51.03278561099995, -0.168226820999962],
              [-50.98257402299993, -0.085544528999947],
              [-50.972405763999916, -0.04281351599991],
              [-50.94726590899995, -0.011973844999943],
              [-50.925145750999945, -0.00614894399996],
              [-50.88976759399992, 0.001108879000071],
              [-50.81753522799994, 0.034742430000051],
              [-50.76600372099995, 0.04636675800009],
              [-50.739550323999936, 0.03452468200004],
              [-50.72490564599991, 0.008007150000083],
              [-50.70230058499993, -0.00249602699995],
              [-50.675852016999954, -0.010674737999921],
              [-50.66454016799992, -0.015476169999943],
              [-50.65526282499991, -0.023776950999945],
              [-50.647694464999915, -0.034030856999948],
              [-50.64171301999994, -0.044732354999951],
              [-50.64085852799991, -0.049574476999908],
              [-50.64232337099992, -0.060479424999926],
              [-50.64171301999994, -0.065240166999956],
              [-50.62962805899991, -0.081597588999955],
              [-50.62743079299992, -0.085707289999959],
              [-50.628895636999914, -0.104099216999941],
              [-50.638783331999946, -0.121026299999926],
              [-50.675852016999954, -0.154554945999962],
              [-50.69517981699994, -0.167413018999923],
              [-50.75841223899994, -0.195570570999962],
              [-50.781239386999914, -0.210056247999944],
              [-50.837228969999956, -0.267673434999949],
              [-50.85594641799992, -0.28248463299991],
              [-50.89488684799994, -0.306247653999947],
              [-50.92341061099995, -0.330498955999929],
              [-50.93203691299993, -0.328301690999922],
              [-50.94115149599992, -0.322035414999959],
              [-50.964955206999946, -0.314222914999959],
              [-50.96898352799991, -0.304864190999922],
              [-50.970366990999935, -0.295505466999941],
              [-50.97374426999994, -0.291192315999922],
            ],
          ],
          [
            [
              [-49.83234615799995, -0.103122653999947],
              [-49.823475714999915, -0.070367119999958],
              [-49.80101477799991, -0.045953057999952],
              [-49.74046790299991, -0.000339450999945],
              [-49.67609615799995, 0.02806224200009],
              [-49.62808183499993, 0.057603257000039],
              [-49.52452551999994, 0.073879299000055],
              [-49.49657141799992, 0.085598049000055],
              [-49.49376380099994, 0.079820054000038],
              [-49.48570716099994, 0.069240627000056],
              [-49.48289954299992, 0.063788153000075],
              [-49.46979732999995, 0.069973049000055],
              [-49.45604407499991, 0.074611721000053],
              [-49.44204667899993, 0.075669664000088],
              [-49.42821204299992, 0.071275132000039],
              [-49.39126542899993, 0.05109284100007],
              [-49.38109290299991, 0.043931382000039],
              [-49.36986243399991, 0.028225002000056],
              [-49.369252081999946, 0.016099351000094],
              [-49.371978318999936, 0.006984768000052],
              [-49.37051347599993, -0.000339450999945],
              [-49.35912024599992, -0.00835540199995],
              [-49.351673956999946, -0.008477471999925],
              [-49.34752356699994, -0.009698174999926],
              [-49.34630286399994, -0.02084726399994],
              [-49.34898841099994, -0.030857028999947],
              [-49.35448157499991, -0.037163994999958],
              [-49.35928300699993, -0.044732354999951],
              [-49.35997473899994, -0.058444919999943],
              [-49.36473548099991, -0.056573174999926],
              [-49.37633216099994, -0.054131768999923],
              [-49.38109290299991, -0.052178643999923],
              [-49.38585364499994, -0.069634697999959],
              [-49.419992641999954, -0.095310153999947],
              [-49.42821204299992, -0.110202731999948],
              [-49.438710089999915, -0.120538018999923],
              [-49.46336829299992, -0.128024997999944],
              [-49.49201412699995, -0.132582289999959],
              [-49.68687903599994, -0.135430596999925],
              [-49.71621660099993, -0.14771900799991],
              [-49.83234615799995, -0.103122653999947],
            ],
          ],
          [
            [
              [-50.63426673099991, 0.071275132000039],
              [-50.63768469999991, 0.080552476000094],
              [-50.63662675699993, 0.08820221600007],
              [-50.634429490999935, 0.096096096000053],
              [-50.63426673099991, 0.10610586100006],
              [-50.637562628999945, 0.117661851000094],
              [-50.64671790299991, 0.138902085000041],
              [-50.648548956999946, 0.150458075000074],
              [-50.63687089799993, 0.165269273000092],
              [-50.610585089999915, 0.183417059000078],
              [-50.58300129599991, 0.184031959000038],
              [-50.56108574399991, 0.176257456000087],
              [-50.544329089999906, 0.17106992500004],
              [-50.514694291999945, 0.165850680000062],
              [-50.49022439499993, 0.159361790000048],
              [-50.46964079199995, 0.145176607000053],
              [-50.44649743499991, 0.125851108000063],
              [-50.44395459799995, 0.109147396000083],
              [-50.444006945999945, 0.080890753000062],
              [-50.44017917899993, 0.061617711000054],
              [-50.4325078789999, 0.035917328000039],
              [-50.43254671599993, 0.016653972000086],
              [-50.43772932799993, -0.000032628999918],
              [-50.44749915299991, -0.015150648999906],
              [-50.48745683499993, -0.017429294999943],
              [-50.49571692599994, -0.016615492999961],
              [-50.50572669199994, -0.014336846999925],
              [-50.51406816299993, -0.01108163899994],
              [-50.517567511999914, -0.007256768999923],
              [-50.52306067599994, -0.003838799999926],
              [-50.55972245999993, -0.003838799999926],
              [-50.57217363199993, 0.001654364000046],
              [-50.58812415299991, 0.012111721000053],
              [-50.60171464799993, 0.023993231000077],
              [-50.607533331999946, 0.033758856000077],
              [-50.60973059799994, 0.053412177000041],
              [-50.61546790299991, 0.058823960000041],
              [-50.623890753999945, 0.061224677000041],
              [-50.63426673099991, 0.071275132000039],
            ],
          ],
          [
            [
              [-50.0907842659999, 0.305944799000088],
              [-50.10733365099992, 0.292930690000048],
              [-50.16564773999994, 0.261734493000063],
              [-50.22046084099992, 0.24621170100005],
              [-50.21715247299994, 0.263088283000059],
              [-50.19937089799993, 0.28851959800005],
              [-50.13853919199994, 0.326564846000053],
              [-50.11332416899995, 0.338182138000093],
              [-50.09332056199992, 0.339012601000093],
              [-50.0864038869999, 0.320726597000089],
              [-50.0907842659999, 0.305944799000088],
            ],
          ],
          [
            [
              [-50.03688777499991, 0.299741052000059],
              [-50.00381158899995, 0.310122529000068],
              [-49.959450836999906, 0.308302756000046],
              [-49.92162215099995, 0.292785814000069],
              [-49.85955442399995, 0.30122358300008],
              [-49.82576028699992, 0.322207262000063],
              [-49.745915021999906, 0.353472638000085],
              [-49.65022746599993, 0.386373379000077],
              [-49.56015660899993, 0.385757444000092],
              [-49.53035630599993, 0.353779543000087],
              [-49.52894967799995, 0.300814630000048],
              [-49.60160336799993, 0.26598533400005],
              [-49.642473965999955, 0.232699301000082],
              [-49.69237219999991, 0.205023505000042],
              [-49.76402747299994, 0.133368231000077],
              [-49.78734290299991, 0.092352606000077],
              [-49.80614173099991, 0.048651434000078],
              [-49.82970130099994, 0.011297919000071],
              [-49.86705481699994, -0.010674737999921],
              [-49.93390865799995, -0.028741143999923],
              [-49.96312415299991, -0.032769463999955],
              [-49.97500566299993, -0.036879164999959],
              [-49.98615475199995, -0.042535088999955],
              [-49.99400794199994, -0.048435153999947],
              [-50.00450598899994, -0.052788994999958],
              [-50.012928839999915, -0.045342705999929],
              [-50.02476966099994, -0.024265231999948],
              [-50.04507402299993, -0.002862237999921],
              [-50.06944739499994, 0.016587632000039],
              [-50.09727942599994, 0.030910549000055],
              [-50.127797003999945, 0.037176825000074],
              [-50.174672003999945, 0.029282945000091],
              [-50.18236243399991, 0.033758856000077],
              [-50.19009355399993, 0.04132721600007],
              [-50.206695115999935, 0.039292710000041],
              [-50.22227942599994, 0.033596096000053],
              [-50.22679602799991, 0.030340887000079],
              [-50.24885006399995, 0.024644273000092],
              [-50.272694464999915, 0.014878648000092],
              [-50.29759680899991, 0.01203034100007],
              [-50.32262122299994, 0.026922919000071],
              [-50.34512285099993, 0.047430731000077],
              [-50.351551886999914, 0.05890534100007],
              [-50.35309811099995, 0.078111070000091],
              [-50.34203040299991, 0.115423895000049],
              [-50.34007727799991, 0.133368231000077],
              [-50.35033118399991, 0.126695054000038],
              [-50.357411261999914, 0.116522528000075],
              [-50.36668860599991, 0.091782945000091],
              [-50.37999426999994, 0.110744533000059],
              [-50.383656378999945, 0.129868882000039],
              [-50.380970831999946, 0.194647528000075],
              [-50.377797003999945, 0.208319403000075],
              [-50.36681067599994, 0.214504299000055],
              [-50.3049026459999, 0.216842620000079],
              [-50.279646278999905, 0.228089134000072],
              [-50.25441614999994, 0.22977054800009],
              [-50.23268400199993, 0.22450457900004],
              [-50.199636864999945, 0.222687356000051],
              [-50.12804114499994, 0.221584377000056],
              [-50.10728919199994, 0.222154039000088],
              [-50.062189873999955, 0.262391925000088],
              [-50.03688777499991, 0.299741052000059],
            ],
          ],
          [
            [
              [-50.37802102099994, 0.244989516000089],
              [-50.39519807399995, 0.240340940000067],
              [-50.413975180999955, 0.22634319000008],
              [-50.42030938599993, 0.202972625000086],
              [-50.41880199099995, 0.188943023000093],
              [-50.41513429299994, 0.176578859000074],
              [-50.41901965799991, 0.167944121000062],
              [-50.42625891799992, 0.168402411000045],
              [-50.45018469999991, 0.178656317000048],
              [-50.459828253999945, 0.18109772300005],
              [-50.48265540299991, 0.18235911700009],
              [-50.49315344999991, 0.185492255000042],
              [-50.50145423099991, 0.19171784100007],
              [-50.51675370999993, 0.208644924000055],
              [-50.51805579299992, 0.214911200000074],
              [-50.51634680899991, 0.243353583000044],
              [-50.512928839999915, 0.25649648600006],
              [-50.505970831999946, 0.266180731000077],
              [-50.49453691299993, 0.269924221000053],
              [-50.485259568999936, 0.268459377000056],
              [-50.480580206999946, 0.266017971000053],
              [-50.47687740799995, 0.265448309000078],
              [-50.470366990999935, 0.269924221000053],
              [-50.469960089999915, 0.274318752000056],
              [-50.43919837099992, 0.397650458000044],
              [-50.432525193999936, 0.413967190000051],
              [-50.43150794199994, 0.415594794000071],
              [-50.42251542899993, 0.419012762000079],
              [-50.41242428299995, 0.421576239000046],
              [-50.408314581999946, 0.420721747000073],
              [-50.407093878999945, 0.430650132000039],
              [-50.41087805899991, 0.436916408000059],
              [-50.416859503999945, 0.441961981000077],
              [-50.421986456999946, 0.44867584800005],
              [-50.42808997299994, 0.46548086100006],
              [-50.43008378799993, 0.478583075000074],
              [-50.42943274599992, 0.506659247000073],
              [-50.432484503999945, 0.534328518000052],
              [-50.43077551999994, 0.548000393000052],
              [-50.421986456999946, 0.56476471600007],
              [-50.379750128999945, 0.611802476000094],
              [-50.36668860599991, 0.619940497000073],
              [-50.36668860599991, 0.615179755000042],
              [-50.36506100199995, 0.612453518000052],
              [-50.36266028599994, 0.609930731000077],
              [-50.36050370999993, 0.606350002000056],
              [-50.347320115999935, 0.571275132000039],
              [-50.34605872299994, 0.527533270000049],
              [-50.35505123599995, 0.412543036000045],
              [-50.35309811099995, 0.400213934000078],
              [-50.348866339999915, 0.39008209800005],
              [-50.335926886999914, 0.368475653000075],
              [-50.323150193999936, 0.340643622000073],
              [-50.31696961499995, 0.30875123800007],
              [-50.32328549099992, 0.286960311000087],
              [-50.33893374999991, 0.271411345000047],
              [-50.34991904499992, 0.252735941000083],
              [-50.36397202899991, 0.248084005000067],
              [-50.37802102099994, 0.244989516000089],
            ],
          ],
          [
            [
              [-50.31212317599994, 0.413967190000051],
              [-50.317250128999945, 0.457993882000039],
              [-50.31505286399994, 0.497259833000044],
              [-50.30288652299993, 0.530991929000038],
              [-50.278553839999915, 0.558539130000042],
              [-50.25645911399994, 0.569728908000059],
              [-50.25157630099994, 0.575832424000055],
              [-50.25816809799994, 0.585191148000092],
              [-50.24209550699993, 0.592962958000044],
              [-50.18691972599993, 0.592230536000045],
              [-50.17491614499994, 0.595445054000038],
              [-50.16759192599994, 0.605414130000042],
              [-50.15062415299991, 0.59711334800005],
              [-50.120350714999915, 0.571600653000075],
              [-50.11510169199994, 0.58624909100007],
              [-50.134755011999914, 0.597560940000051],
              [-50.134022589999915, 0.612494208000044],
              [-50.12205969999991, 0.626776434000078],
              [-50.10289466099994, 0.639837958000044],
              [-50.08218339799993, 0.64789459800005],
              [-50.065663214999915, 0.647284247000073],
              [-50.03844153599994, 0.606350002000056],
              [-50.033273891999954, 0.593573309000078],
              [-50.031361456999946, 0.584865627000056],
              [-50.03156490799995, 0.561672268000052],
              [-50.030506964999915, 0.556789455000057],
              [-50.02574622299994, 0.547267971000053],
              [-50.02476966099994, 0.541164455000057],
              [-50.02684485599991, 0.535305080000057],
              [-50.03628495999993, 0.525946356000077],
              [-50.04271399599992, 0.510321356000077],
              [-50.166076622999924, 0.413848198000039],
              [-50.19948366999995, 0.392715551000094],
              [-50.229843381999956, 0.377637716000038],
              [-50.249595073999956, 0.361015578000092],
              [-50.28144590699992, 0.356551537000087],
              [-50.30068925699993, 0.375474351000094],
              [-50.31212317599994, 0.413967190000051],
            ],
          ],
          [
            [
              [-50.202416172999904, 0.749691605000066],
              [-50.241398947999926, 0.744597210000052],
              [-50.27527428399992, 0.745621947000075],
              [-50.283364272999904, 0.769186393000041],
              [-50.274951846999954, 0.809114176000094],
              [-50.22547644499991, 0.859200128000055],
              [-50.15880566499993, 0.886690241000053],
              [-50.13212269199994, 0.91421401100007],
              [-50.11166581799995, 0.918252711000093],
              [-50.08611409899993, 0.916156201000092],
              [-50.05857153099993, 0.901798794000058],
              [-50.02691645099992, 0.903755647000082],
              [-50.015722625999956, 0.89249256700009],
              [-50.022935283999914, 0.873105230000078],
              [-50.03628412699993, 0.852705365000077],
              [-50.049672898999916, 0.821062719000054],
              [-50.06811764899993, 0.807812338000076],
              [-50.076328513999954, 0.79862847000004],
              [-50.083565420999946, 0.779207005000046],
              [-50.10338294199994, 0.755682684000078],
              [-50.11192786399994, 0.752346096000053],
              [-50.12218176999994, 0.751206773000092],
              [-50.15121870899992, 0.749629965000054],
              [-50.202416172999904, 0.749691605000066],
            ],
          ],
          [
            [
              [-50.062584762999904, 0.923252138000066],
              [-50.07176302599993, 0.931437248000066],
              [-50.09934734299992, 0.938642789000085],
              [-50.10031737799994, 0.959062901000038],
              [-50.073692371999925, 0.977374878000091],
              [-50.04918372299994, 0.985581773000092],
              [-50.03844153599994, 1.006740627000056],
              [-50.03189042899993, 1.014960028000075],
              [-50.01667232999995, 1.025213934000078],
              [-49.99844316299993, 1.034002997000073],
              [-49.96703040299991, 1.043117580000057],
              [-49.94681709999992, 1.062770898000053],
              [-49.92638035099992, 1.069856741000081],
              [-49.9162084859999, 1.056562666000048],
              [-49.93667558499993, 1.023423570000091],
              [-49.94408118399991, 1.008246161000045],
              [-49.95250403599994, 0.996649481000077],
              [-49.95645097599993, 0.986517645000049],
              [-49.96401933499993, 0.973822333000044],
              [-49.997303839999915, 0.952460028000075],
              [-50.00487219999991, 0.945217190000051],
              [-50.00829016799992, 0.940985419000071],
              [-50.02525794199994, 0.936997789000088],
              [-50.03156490799995, 0.934637762000079],
              [-50.062584762999904, 0.923252138000066],
            ],
          ],
          [
            [
              [-50.45435769199992, 2.110940625000069],
              [-50.441517191999935, 2.108049102000052],
              [-50.42642770799995, 2.110742330000051],
              [-50.409641295999904, 2.112945047000039],
              [-50.39957760099992, 2.115108435000081],
              [-50.386839221999935, 2.097153077000087],
              [-50.366364087999955, 2.069679478000069],
              [-50.356934243999945, 2.059439787000088],
              [-50.35319764099995, 2.034323965000056],
              [-50.33885392499991, 2.009692265000069],
              [-50.32502810699992, 1.991759141000045],
              [-50.31402721899991, 1.968265657000074],
              [-50.312495585999955, 1.947065252000073],
              [-50.32093895599991, 1.935414237000089],
              [-50.33895114399991, 1.912667935000059],
              [-50.37657806999994, 1.878331518000039],
              [-50.394495571999926, 1.870635371000049],
              [-50.41911898399991, 1.862977863000083],
              [-50.44085207899991, 1.86981039300008],
              [-50.45860755099994, 1.881008205000057],
              [-50.476633266999954, 1.942694403000075],
              [-50.49550952599992, 1.967247660000055],
              [-50.49763213199992, 1.984560276000082],
              [-50.508188340999936, 1.995235034000075],
              [-50.5238127259999, 2.001482078000038],
              [-50.5208119159999, 2.031656131000091],
              [-50.51169695199991, 2.056155705000037],
              [-50.51134192599994, 2.079820054000038],
              [-50.504230245999906, 2.09569182000007],
              [-50.48854350699992, 2.098922196000046],
              [-50.47009353599992, 2.097662774000071],
              [-50.45435769199992, 2.110940625000069],
            ],
          ],
          [
            [
              [-50.54352144299992, 2.14619672300006],
              [-50.55299502999992, 2.15128285600008],
              [-50.553522751999935, 2.156309261000047],
              [-50.541704970999945, 2.167948347000049],
              [-50.513631087999954, 2.18728617700009],
              [-50.49240063299993, 2.186581474000093],
              [-50.46334761399993, 2.186938223000084],
              [-50.448334695999904, 2.176234837000038],
              [-50.430540436999934, 2.164958241000079],
              [-50.41783217599993, 2.144794625000088],
              [-50.41515808899993, 2.12693108600007],
              [-50.424692368999956, 2.119744763000085],
              [-50.44144522399995, 2.118182758000046],
              [-50.45762113199993, 2.120520425000052],
              [-50.46658644199994, 2.116117802000076],
              [-50.47334443699992, 2.107795926000051],
              [-50.48617926399993, 2.110110630000065],
              [-50.49793202699993, 2.107397909000042],
              [-50.50965321299992, 2.109705501000064],
              [-50.520237437999924, 2.115353448000064],
              [-50.525684748999936, 2.137707348000049],
              [-50.535705642999915, 2.144470345000059],
              [-50.54352144299992, 2.14619672300006],
            ],
          ],
          [
            [
              [-29.338246222999942, -20.584161065999922],
              [-29.348255988999938, -20.561293226999908],
              [-29.344309048999946, -20.550957940999922],
              [-29.332020636999914, -20.55331796699994],
              [-29.316883917999917, -20.56878020599993],
              [-29.323963995999918, -20.571465752999927],
              [-29.328602667999917, -20.575290622999944],
              [-29.332875128999945, -20.579685153999947],
              [-29.338246222999942, -20.584161065999922],
            ],
          ],
          [
            [
              [-28.883290167999917, -20.518731377999927],
              [-28.88190670499995, -20.51539478999996],
              [-28.881418423999946, -20.512383721999925],
              [-28.880482550999943, -20.510837497999944],
              [-28.877064581999946, -20.511651299999926],
              [-28.877837693999936, -20.51425546699994],
              [-28.879261847999942, -20.51572030999995],
              [-28.881255662999934, -20.51685963299991],
              [-28.883290167999917, -20.518731377999927],
            ],
          ],
          [
            [
              [-48.43455969999991, -27.40471770599993],
              [-48.42658443899995, -27.388929945999905],
              [-48.408762173999946, -27.399590752999927],
              [-48.39020748599995, -27.42050546699994],
              [-48.37987219999991, -27.435723565999922],
              [-48.37730872299994, -27.458184502999927],
              [-48.38524329299992, -27.477308851999908],
              [-48.395741339999915, -27.493584893999923],
              [-48.40306555899991, -27.512383721999925],
              [-48.407541469999956, -27.51726653399993],
              [-48.41197669199994, -27.523695570999905],
              [-48.414051886999914, -27.53411223799992],
              [-48.41250566299993, -27.546075127999927],
              [-48.40697180899991, -27.568617445999905],
              [-48.40721594999991, -27.579196872999944],
              [-48.41454016799992, -27.595147393999923],
              [-48.42756100199995, -27.613051039999903],
              [-48.44155839799993, -27.627699476999908],
              [-48.45197506399995, -27.63372161299992],
              [-48.49657141799992, -27.702732028999947],
              [-48.49746660099993, -27.72389088299991],
              [-48.48216712099992, -27.75945403399993],
              [-48.48607337099992, -27.77434661299992],
              [-48.49351966099994, -27.779066664999903],
              [-48.512562628999945, -27.783949476999908],
              [-48.52049719999991, -27.78834400799991],
              [-48.53465735599991, -27.80787525799991],
              [-48.54259192599994, -27.816664320999905],
              [-48.55186926999994, -27.819431247999944],
              [-48.559803839999915, -27.81845468499995],
              [-48.563791469999956, -27.81731536299992],
              [-48.56509355399993, -27.813653252999927],
              [-48.56354732999995, -27.739841403999947],
              [-48.55724036399994, -27.70794036299992],
              [-48.54442298099991, -27.681573174999926],
              [-48.55907141799992, -27.674493096999925],
              [-48.55016028599994, -27.65829843499995],
              [-48.52391516799992, -27.63372161299992],
              [-48.52599036399994, -27.61142343499995],
              [-48.54015051999994, -27.59148528399993],
              [-48.54710852799991, -27.577243747999944],
              [-48.52765865799995, -27.571709893999923],
              [-48.51577714799993, -27.57000090899993],
              [-48.50816809799994, -27.56487395599993],
              [-48.50426184799994, -27.556410414999903],
              [-48.50340735599991, -27.54501718499995],
              [-48.506703253999945, -27.53997161299992],
              [-48.513783331999946, -27.535414320999905],
              [-48.52391516799992, -27.530694268999923],
              [-48.52415930899991, -27.52353280999995],
              [-48.52163652299993, -27.517836195999905],
              [-48.51862545499995, -27.512872002999927],
              [-48.51707923099991, -27.50709400799991],
              [-48.520415818999936, -27.49578215899993],
              [-48.53490149599992, -27.484144789999903],
              [-48.53750566299993, -27.476169528999947],
              [-48.53083248599995, -27.463067315999922],
              [-48.51939856699994, -27.454522393999923],
              [-48.51207434799994, -27.444756768999923],
              [-48.51707923099991, -27.42831796699994],
              [-48.49941972599993, -27.426446221999925],
              [-48.44579016799992, -27.412367445999905],
              [-48.43455969999991, -27.40471770599993],
            ],
          ],
          [
            [
              [-48.54442298099991, -26.34189218499995],
              [-48.54792232999995, -26.351820570999905],
              [-48.575428839999915, -26.37623463299991],
              [-48.57909094999991, -26.385430596999925],
              [-48.57982337099992, -26.397556247999944],
              [-48.57852128799993, -26.420993747999944],
              [-48.583241339999915, -26.421075127999927],
              [-48.58629309799994, -26.41961028399993],
              [-48.59219316299993, -26.41415780999995],
              [-48.611317511999914, -26.412774346999925],
              [-48.62804114499994, -26.38795338299991],
              [-48.643137173999946, -26.35906340899993],
              [-48.65733801999994, -26.345310153999947],
              [-48.69969641799992, -26.316664320999905],
              [-48.70327714799993, -26.311944268999923],
              [-48.701161261999914, -26.30722421699994],
              [-48.684152798999946, -26.28134530999995],
              [-48.67528235599991, -26.27385833099993],
              [-48.664173956999946, -26.27076588299991],
              [-48.646473761999914, -26.268324476999908],
              [-48.63975989499994, -26.261651299999926],
              [-48.636708136999914, -26.251885674999926],
              [-48.63003495999993, -26.239678643999923],
              [-48.60724850199995, -26.227308851999908],
              [-48.57762610599991, -26.21843840899993],
              [-48.55809485599991, -26.20549895599993],
              [-48.56554114499994, -26.18132903399993],
              [-48.54759680899991, -26.16725025799991],
              [-48.53115800699993, -26.17034270599993],
              [-48.51634680899991, -26.18401458099993],
              [-48.493397589999915, -26.218926690999922],
              [-48.49014238199993, -26.22779713299991],
              [-48.489125128999945, -26.23601653399993],
              [-48.49282792899993, -26.24382903399993],
              [-48.50755774599992, -26.256605726999908],
              [-48.51610266799992, -26.28134530999995],
              [-48.539173956999946, -26.31894296699994],
              [-48.54442298099991, -26.34189218499995],
            ],
          ],
          [
            [
              [-47.51716061099995, -24.70094166499996],
              [-47.506703253999945, -24.69980234199994],
              [-47.48302161399994, -24.70094166499996],
              [-47.47325598899994, -24.69768645599993],
              [-47.459055141999954, -24.690199476999908],
              [-47.44831295499995, -24.686700127999927],
              [-47.44831295499995, -24.693536065999922],
              [-47.49518795499995, -24.72389088299991],
              [-47.53026282499991, -24.73251718499995],
              [-47.550038214999915, -24.742364190999922],
              [-47.78538977799991, -24.923760674999926],
              [-47.82274329299992, -24.941664320999905],
              [-47.83804277299993, -24.95826588299991],
              [-47.85912024599992, -24.989027601999908],
              [-47.87743079299992, -25.02711353999996],
              [-47.88829505099994, -25.041192315999922],
              [-47.90013587099992, -25.03679778399993],
              [-47.89976966099994, -25.01572030999995],
              [-47.88377844999991, -24.98211028399993],
              [-47.87962805899991, -24.964776299999926],
              [-47.87242591099994, -24.958591403999947],
              [-47.83185787699995, -24.913262627999927],
              [-47.71739661399994, -24.830336195999905],
              [-47.67357337099992, -24.81145598799992],
              [-47.612945115999935, -24.75448984199994],
              [-47.56167558499993, -24.73601653399993],
              [-47.53530839799993, -24.710056247999944],
              [-47.51716061099995, -24.70094166499996],
            ],
          ],
          [
            [
              [-46.32795162699995, -23.926446221999925],
              [-46.31948808499993, -23.927666924999926],
              [-46.31867428299995, -23.930840752999927],
              [-46.31989498599995, -23.93531666499996],
              [-46.31737219999991, -23.940606377999927],
              [-46.30256100199995, -23.958428643999923],
              [-46.29161536399994, -23.979180596999925],
              [-46.291859503999945, -23.990899346999925],
              [-46.34137936099995, -23.969903252999927],
              [-46.35537675699993, -23.970635674999926],
              [-46.365793423999946, -23.981622002999927],
              [-46.37450110599991, -23.977959893999923],
              [-46.39159094999991, -23.977308851999908],
              [-46.39989173099991, -23.974786065999922],
              [-46.40465247299994, -23.97047291499996],
              [-46.42039954299992, -23.947442315999922],
              [-46.40689042899993, -23.94182708099993],
              [-46.40196692599994, -23.942803643999923],
              [-46.39366614499994, -23.947442315999922],
              [-46.39004472599993, -23.940850518999923],
              [-46.388335740999935, -23.935723565999922],
              [-46.38939368399991, -23.92945728999996],
              [-46.39366614499994, -23.920179945999905],
              [-46.38145911399994, -23.92034270599993],
              [-46.34837805899991, -23.926446221999925],
              [-46.32795162699995, -23.926446221999925],
            ],
          ],
          [
            [
              [-45.213734503999945, -23.906508070999905],
              [-45.22647050699993, -23.909274997999944],
              [-45.22691809799994, -23.916761976999908],
              [-45.222645636999914, -23.927666924999926],
              [-45.221262173999946, -23.940606377999927],
              [-45.21784420499995, -23.944919528999947],
              [-45.21825110599991, -23.949476820999905],
              [-45.224598761999914, -23.957696221999925],
              [-45.22891191299993, -23.961114190999922],
              [-45.24168860599991, -23.967950127999927],
              [-45.24649003799993, -23.96347421699994],
              [-45.25104732999995, -23.962090752999927],
              [-45.25601152299993, -23.962090752999927],
              [-45.26219641799992, -23.961114190999922],
              [-45.27183997299994, -23.94622161299992],
              [-45.280506964999915, -23.925225518999923],
              [-45.29043535099993, -23.91187916499996],
              [-45.30378170499995, -23.920179945999905],
              [-45.30996660099993, -23.91269296699994],
              [-45.34605872299994, -23.92815520599993],
              [-45.38573157499991, -23.93808359199994],
              [-45.421864386999914, -23.93523528399993],
              [-45.44713294199994, -23.91269296699994],
              [-45.45295162699995, -23.891371351999908],
              [-45.447377081999946, -23.877211195999905],
              [-45.434803839999915, -23.86728280999995],
              [-45.41982988199993, -23.858086846999925],
              [-45.35537675699993, -23.80006275799991],
              [-45.34471594999991, -23.782403252999927],
              [-45.33771725199995, -23.752129815999922],
              [-45.33385169199994, -23.745212497999944],
              [-45.32860266799992, -23.737481377999927],
              [-45.327056443999936, -23.73088958099993],
              [-45.32469641799992, -23.725274346999925],
              [-45.31680253799993, -23.720879815999922],
              [-45.30846106699994, -23.721368096999925],
              [-45.29710852799991, -23.72429778399993],
              [-45.28701738199993, -23.72820403399993],
              [-45.23656165299991, -23.76181405999995],
              [-45.22809811099995, -23.77239348799992],
              [-45.23485266799992, -23.844414971999925],
              [-45.265736456999946, -23.839288018999923],
              [-45.27110755099994, -23.86891041499996],
              [-45.25499426999994, -23.89820728999996],
              [-45.221262173999946, -23.89226653399993],
              [-45.21642005099994, -23.899102471999925],
              [-45.21507727799991, -23.90203215899993],
              [-45.213734503999945, -23.906508070999905],
            ],
          ],
          [
            [
              [-44.100900844999956, -23.14902109199994],
              [-44.08543860599991, -23.16179778399993],
              [-44.08226477799991, -23.169528903999947],
              [-44.097767706999946, -23.17392343499995],
              [-44.10366777299993, -23.17864348799992],
              [-44.10773678299995, -23.179620049999926],
              [-44.11266028599994, -23.17742278399993],
              [-44.11628170499995, -23.172539971999925],
              [-44.118072068999936, -23.16765715899993],
              [-44.11827551999994, -23.165459893999923],
              [-44.12804114499994, -23.16497161299992],
              [-44.13536536399994, -23.165459893999923],
              [-44.14098059799994, -23.16773853999996],
              [-44.14557857999995, -23.17278411299992],
              [-44.15925045499995, -23.16578541499996],
              [-44.16820227799991, -23.17156340899993],
              [-44.17686926999994, -23.18132903399993],
              [-44.18968665299991, -23.186618747999944],
              [-44.23082434799994, -23.193536065999922],
              [-44.24120032499991, -23.19345468499995],
              [-44.255970831999946, -23.187676690999922],
              [-44.26585852799991, -23.180840752999927],
              [-44.276234503999945, -23.175225518999923],
              [-44.292632615999935, -23.17278411299992],
              [-44.301665818999936, -23.17831796699994],
              [-44.31114661399994, -23.191338799999926],
              [-44.318918423999946, -23.207207940999922],
              [-44.323109503999945, -23.220635674999926],
              [-44.32770748599995, -23.22128671699994],
              [-44.328968878999945, -23.21965911299992],
              [-44.329009568999936, -23.217054945999905],
              [-44.32994544199994, -23.21379973799992],
              [-44.337961391999954, -23.206638278999947],
              [-44.34170488199993, -23.198663018999923],
              [-44.34154212099992, -23.189629815999922],
              [-44.33739173099991, -23.179620049999926],
              [-44.35448157499991, -23.180352471999925],
              [-44.36070716099994, -23.17815520599993],
              [-44.36465410099993, -23.17278411299992],
              [-44.36709550699993, -23.165215752999927],
              [-44.36546790299991, -23.163995049999926],
              [-44.36001542899993, -23.16383228999996],
              [-44.323109503999945, -23.145603122999944],
              [-44.29637610599991, -23.11760833099993],
              [-44.28416907499991, -23.123223565999922],
              [-44.27086341099994, -23.115166924999926],
              [-44.248036261999914, -23.090997002999927],
              [-44.24486243399991, -23.08603280999995],
              [-44.24120032499991, -23.069756768999923],
              [-44.23509680899991, -23.06878020599993],
              [-44.230458136999914, -23.071465752999927],
              [-44.227772589999915, -23.074883721999925],
              [-44.22752844999991, -23.07675546699994],
              [-44.21910559799994, -23.077732028999947],
              [-44.20815995999993, -23.080743096999925],
              [-44.19668535099993, -23.08521900799991],
              [-44.18651282499991, -23.090997002999927],
              [-44.18651282499991, -23.097100518999923],
              [-44.19322669199994, -23.09807708099993],
              [-44.19774329299992, -23.10003020599993],
              [-44.20177161399994, -23.102308851999908],
              [-44.207020636999914, -23.104587497999944],
              [-44.18651282499991, -23.11760833099993],
              [-44.170765753999945, -23.110121351999908],
              [-44.16258704299992, -23.115899346999925],
              [-44.155140753999945, -23.12590911299992],
              [-44.141835089999915, -23.13128020599993],
              [-44.135324673999946, -23.128106377999927],
              [-44.13023841099994, -23.121026299999926],
              [-44.12669837099992, -23.113946221999925],
              [-44.12441972599993, -23.110772393999923],
              [-44.11302649599992, -23.114678643999923],
              [-44.11286373599995, -23.120700778999947],
              [-44.11693274599992, -23.12672291499996],
              [-44.11827551999994, -23.13128020599993],
              [-44.110585089999915, -23.14031340899993],
              [-44.100900844999956, -23.14902109199994],
            ],
          ],
          [
            [
              [-32.40339107999995, -3.837823174999926],
              [-32.39216061099995, -3.834161065999922],
              [-32.38658606699994, -3.841241143999923],
              [-32.38857988199993, -3.85279713299991],
              [-32.399728969999956, -3.861993096999925],
              [-32.41437740799995, -3.865492445999905],
              [-32.441517706999946, -3.880791924999926],
              [-32.45425370999993, -3.883070570999905],
              [-32.46279863199993, -3.878350518999923],
              [-32.457142706999946, -3.870863539999959],
              [-32.44676673099991, -3.863539320999905],
              [-32.44127356699994, -3.858575127999927],
              [-32.43691972599993, -3.849867445999905],
              [-32.426625128999945, -3.845798434999949],
              [-32.414173956999946, -3.842705987999921],
              [-32.40339107999995, -3.837823174999926],
            ],
          ],
          [
            [
              [-29.408029751999948, 0.884833075000074],
              [-29.381459113999938, 0.89134349200009],
              [-29.356190558999913, 0.882757880000042],
              [-29.345326300999943, 0.86664459800005],
              [-29.34902910099993, 0.852606512000079],
              [-29.35773678299995, 0.841131903000075],
              [-29.36937415299991, 0.833563544000071],
              [-29.39012610599991, 0.831732489000046],
              [-29.410267706999946, 0.834865627000056],
              [-29.421213344999956, 0.844712632000039],
              [-29.426380988999938, 0.858547268000052],
              [-29.42341061099995, 0.871568101000094],
              [-29.408029751999948, 0.884833075000074],
            ],
          ],
          [
            [
              [-48.322324189999904, -25.38370803999993],
              [-48.298471166999946, -25.366431598999952],
              [-48.26896122799991, -25.348155048999956],
              [-48.25537934099992, -25.348211939999942],
              [-48.250917057999914, -25.364586946999907],
              [-48.25667422999993, -25.389096555999913],
              [-48.26816225399995, -25.42686418799991],
              [-48.267119565999906, -25.44628500099992],
              [-48.25588271299995, -25.465745115999937],
              [-48.26952230299992, -25.475912485999913],
              [-48.29110736699994, -25.48911679899993],
              [-48.30922732599993, -25.485979611999937],
              [-48.323867434999954, -25.46752162799993],
              [-48.319268379999926, -25.454253025999947],
              [-48.32147495999993, -25.441977865999945],
              [-48.339524739999945, -25.425534653999932],
              [-48.33830429199992, -25.408171059999916],
              [-48.322324189999904, -25.38370803999993],
            ],
          ],
          [
            [
              [-34.8527498599999, -7.697378619999938],
              [-34.846145658999944, -7.695815070999913],
              [-34.83605204299994, -7.696932735999951],
              [-34.83019563999994, -7.703828228999953],
              [-34.83209211299993, -7.711901048999948],
              [-34.827811777999955, -7.724202802999912],
              [-34.82233131899994, -7.738796994999916],
              [-34.822296911999956, -7.749181162999946],
              [-34.82687987999992, -7.765328242999942],
              [-34.83381307499991, -7.778418282999951],
              [-34.83687652899994, -7.795756857999947],
              [-34.83801479999994, -7.810798622999926],
              [-34.84537289699995, -7.813504007999938],
              [-34.858181403999936, -7.813159570999915],
              [-34.87372202899991, -7.809366980999926],
              [-34.88422883399994, -7.804025585999909],
              [-34.88425892899994, -7.788236817999916],
              [-34.88277426999991, -7.76553737699993],
              [-34.880504068999926, -7.753620136999928],
              [-34.87084006199996, -7.742435084999954],
              [-34.86000424699995, -7.727775447999932],
              [-34.85773741199995, -7.714700707999953],
              [-34.856607621999956, -7.704313806999949],
              [-34.8527498599999, -7.697378619999938],
            ],
          ],
          [
            [
              [-42.22870271799991, -2.693310917999952],
              [-42.217182600999934, -2.70192368599993],
              [-42.19893911499992, -2.720112087999951],
              [-42.166309758999944, -2.72583411599993],
              [-42.1490237669999, -2.735402735999912],
              [-42.12692359499994, -2.754552514999943],
              [-42.10963028799995, -2.763166178999938],
              [-42.105775786999914, -2.772749115999943],
              [-42.13169710699992, -2.773725842999909],
              [-42.17009871399995, -2.76800241199993],
              [-42.1893071259999, -2.754599894999956],
              [-42.215222361999906, -2.744080221999923],
              [-42.24976710899995, -2.736440982999909],
              [-42.258415027999945, -2.720160523999937],
              [-42.258435548999955, -2.696209624999938],
              [-42.25077462799993, -2.681833347999941],
              [-42.23926495099994, -2.680865270999959],
              [-42.22870271799991, -2.693310917999952],
            ],
          ],
          [
            [
              [-43.83287907899995, -2.45407905199994],
              [-43.8338791459999, -2.44223779999993],
              [-43.84030644399991, -2.432368972999939],
              [-43.84870801099993, -2.423979565999957],
              [-43.84178343099995, -2.416582847999962],
              [-43.84030067099991, -2.415596687999937],
              [-43.82349856099995, -2.407710144999953],
              [-43.81312226099993, -2.409194079999907],
              [-43.80818172599993, -2.421033641999941],
              [-43.81213525399994, -2.435336330999917],
              [-43.813622221999935, -2.454079269999909],
              [-43.81362235799992, -2.454572549999909],
              [-43.803251744999955, -2.456545898999934],
              [-43.80078235399992, -2.455066167999917],
              [-43.79090708699994, -2.441748147999931],
              [-43.78991976099991, -2.439775075999933],
              [-43.77510569599991, -2.428924640999924],
              [-43.76424287499992, -2.428925300999936],
              [-43.756834204999905, -2.447668583999928],
              [-43.76127553999993, -2.460985253999922],
              [-43.7667059339999, -2.476274519999947],
              [-43.77065824199991, -2.496004145999962],
              [-43.781523585999935, -2.505377813999928],
              [-43.80917460799992, -2.512778049999952],
              [-43.825972856999954, -2.513768703999915],
              [-43.83832577499993, -2.507358061999923],
              [-43.842771898999956, -2.49354491899993],
              [-43.84277180099991, -2.492558215999907],
              [-43.84425354699994, -2.480224627999917],
              [-43.83783256499993, -2.463450991999935],
              [-43.83287907899995, -2.45407905199994],
            ],
          ],
          [
            [
              [-43.564763661999905, -2.361293080999928],
              [-43.54598306399993, -2.360292064999953],
              [-43.54203934499992, -2.371152828999925],
              [-43.54500221299992, -2.389905201999909],
              [-43.55587271099995, -2.403726598999924],
              [-43.56080935499995, -2.417049208999913],
              [-43.560809272999904, -2.418036008999934],
              [-43.57365589099993, -2.423468359999958],
              [-43.58551419499992, -2.415086180999936],
              [-43.601814634999926, -2.411638868999944],
              [-43.60724792099995, -2.396840930999929],
              [-43.611691659999906, -2.38500098499992],
              [-43.607745939999916, -2.373163356999953],
              [-43.59193637599992, -2.368711075999954],
              [-43.57958551999991, -2.364756042999943],
              [-43.564763661999905, -2.361293080999928],
            ],
          ],
          [
            [
              [-49.479513926999914, -1.655371806999938],
              [-49.46476861799994, -1.654265645999942],
              [-49.436434249999934, -1.664522553999916],
              [-49.42284369999993, -1.67418149599996],
              [-49.42172802399995, -1.684381510999913],
              [-49.42401842299995, -1.696843078999962],
              [-49.43197824099991, -1.708730287999913],
              [-49.444459422999955, -1.712676712999951],
              [-49.46828733399991, -1.719436272999928],
              [-49.48021824199992, -1.730750930999932],
              [-49.496124170999906, -1.74262639899996],
              [-49.50860929499993, -1.744872087999909],
              [-49.52277360599993, -1.735209881999936],
              [-49.52954501399995, -1.717057497999917],
              [-49.527816344999906, -1.704023309999911],
              [-49.52777519299991, -1.68418565099995],
              [-49.525482445999955, -1.672855280999954],
              [-49.51355587599994, -1.663241382999956],
              [-49.501637553999956, -1.658162209999944],
              [-49.49200020299992, -1.662151043999927],
              [-49.479513926999914, -1.655371806999938],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Uruguay',
        iso3: 'URY',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-57.602792548565105, -30.190516953885325],
            [-57.586842000999866, -30.204046731999952],
            [-57.567463338999914, -30.25634328199996],
            [-57.53599239099995, -30.27443003399989],
            [-57.51098099799995, -30.27670379699991],
            [-57.467211059999954, -30.26988250699995],
            [-57.44312984299992, -30.269469095999938],
            [-57.42979732299989, -30.27546356199987],
            [-57.41481115699992, -30.29572072299996],
            [-57.399256550999894, -30.299131367999905],
            [-57.38938635299991, -30.294893900999938],
            [-57.366597045999924, -30.277220560999936],
            [-57.35383296799995, -30.271949564999915],
            [-57.334299275999854, -30.272673033999908],
            [-57.321741902999946, -30.279804381999938],
            [-57.3109932049999, -30.288279316999947],
            [-57.29647212699987, -30.293343606999926],
            [-57.28861730999992, -30.290759785999924],
            [-57.27621496599997, -30.27773732499989],
            [-57.27037552899989, -30.27515350299997],
            [-57.262469034999924, -30.27866750099993],
            [-57.250066691999876, -30.290449726999938],
            [-57.24505407699991, -30.293343606999926],
            [-57.21260127799988, -30.287349140999893],
            [-57.183714152999926, -30.2675053909999],
            [-57.16381872599993, -30.23929005999993],
            [-57.158341023999924, -30.20787078799991],
            [-57.1508479419999, -30.182342630999955],
            [-57.12955725099991, -30.149993183999882],
            [-57.102272094999904, -30.121157735999944],
            [-57.07710567299995, -30.106068216999944],
            [-57.06723547399989, -30.10679168699994],
            [-57.048528605999905, -30.11454315199994],
            [-57.037883260999905, -30.114646504999968],
            [-57.01829789299998, -30.105758158999947],
            [-57.01126989799988, -30.10348439499994],
            [-56.9745796309999, -30.097489928999906],
            [-56.95452917499995, -30.096869811999937],
            [-56.90636673999998, -30.10854868599992],
            [-56.869211384999886, -30.102967630999984],
            [-56.831280884999956, -30.102037454999945],
            [-56.795159057999854, -30.12384490999996],
            [-56.776607218999914, -30.150923359999922],
            [-56.76699540199991, -30.161362],
            [-56.7047769779999, -30.19836232499992],
            [-56.67374527999996, -30.211281432999925],
            [-56.656821248999876, -30.221306660999943],
            [-56.64178340699988, -30.233915709999877],
            [-56.6325850019999, -30.24745493499995],
            [-56.62927770999988, -30.267712096999958],
            [-56.632429972999944, -30.278150736999905],
            [-56.631344766999945, -30.284661966999877],
            [-56.61540258799991, -30.293343606999926],
            [-56.60519649299994, -30.295617369999945],
            [-56.59561051399993, -30.295410664999892],
            [-56.58581783099987, -30.2965475459999],
            [-56.575017455999955, -30.30243866],
            [-56.56961726899988, -30.308019714999915],
            [-56.56078059899997, -30.320525410999906],
            [-56.523754435999905, -30.357319029999914],
            [-56.51130041499994, -30.366000671999956],
            [-56.494557250999975, -30.379333190999986],
            [-56.44127884999992, -30.408788756999897],
            [-56.424639038999885, -30.42356821699991],
            [-56.40045446799991, -30.458914896999914],
            [-56.38598506699989, -30.47576141399989],
            [-56.372600870999946, -30.485889993999933],
            [-56.32653133199992, -30.50831756599993],
            [-56.26795609599992, -30.55110565199996],
            [-56.235089884999894, -30.565368346999932],
            [-56.21509110499994, -30.581904805999926],
            [-56.18351680599997, -30.61456431099991],
            [-56.177832397999936, -30.625519713999978],
            [-56.17517106199992, -30.63606170699994],
            [-56.17080440299992, -30.64577687599997],
            [-56.159642293999894, -30.65394175199991],
            [-56.14031530799994, -30.664793801999863],
            [-56.13168534399989, -30.671925149999893],
            [-56.12504492199989, -30.68029673199996],
            [-56.09189449099998, -30.736107279999928],
            [-56.07685664899989, -30.752333678999932],
            [-56.011356770999896, -30.798222350999907],
            [-55.99531123899993, -30.825817566],
            [-55.98900402714959, -30.855558891245156],
            [-55.988955037999915, -30.855789896999937],
            [-55.98901646357994, -30.856161036811187],
            [-55.99386429899994, -30.8854521679999],
            [-56.011356770999896, -30.912633971999895],
            [-56.01551672399992, -30.934338073999896],
            [-56.01634354699985, -30.999863789999978],
            [-56.02238968899991, -31.04554575599991],
            [-56.022182983999926, -31.067146504999883],
            [-56.01701787399989, -31.074296298999926],
            [-56.011356770999896, -31.082132669999936],
            [-56.00987402099989, -31.08194549799991],
            [-55.98515681999987, -31.078825378999937],
            [-55.91934688399991, -31.082442728999922],
            [-55.88818599399994, -31.076965026999943],
            [-55.86425980699994, -31.07675832099997],
            [-55.854596313999906, -31.074587910999895],
            [-55.846586465999934, -31.06931691499996],
            [-55.84214229399993, -31.063942564999905],
            [-55.83839575199991, -31.058154805999934],
            [-55.832478800999894, -31.051746927999986],
            [-55.81672787464329, -31.0426693613776],
            [-55.81652184935517, -31.042550624978453],
            [-55.77814103199992, -31.020431009999882],
            [-55.76359411699988, -31.008442076999927],
            [-55.75550675499997, -30.992939147999905],
            [-55.74488724799991, -30.958625996999984],
            [-55.73189062499995, -30.945396829999893],
            [-55.71274450699988, -30.94343312599996],
            [-55.688301554999924, -30.94777394599994],
            [-55.66582230599991, -30.949324238999864],
            [-55.65274816899995, -30.93898895299995],
            [-55.6510686849999, -30.919972024999893],
            [-55.654582682999944, -30.87873423299989],
            [-55.64967342099993, -30.860957539999944],
            [-55.63404130099988, -30.847625019999924],
            [-55.61290563999992, -30.84338755299997],
            [-55.59187333199992, -30.848348490999925],
            [-55.5638647049999, -30.876460469999955],
            [-55.52748449699993, -30.894547220999883],
            [-55.511309773999926, -30.906122741999923],
            [-55.4890889079999, -30.92968719499993],
            [-55.44258011899987, -30.965550638999957],
            [-55.36857946799995, -31.037380878999983],
            [-55.35385168499994, -31.056294453999925],
            [-55.34842565899987, -31.07272755999989],
            [-55.344963338999946, -31.1084876499999],
            [-55.338038696999945, -31.125644225999878],
            [-55.32692826299993, -31.134945983999984],
            [-55.29370031699992, -31.153652851999965],
            [-55.282228149999895, -31.169052429999866],
            [-55.268740600999934, -31.21060028099994],
            [-55.259981445999955, -31.228687031999954],
            [-55.24434932499989, -31.24460337299989],
            [-55.22755448499993, -31.2534917199999],
            [-55.18828039599995, -31.266514179999945],
            [-55.169625203999885, -31.276436055999937],
            [-55.122237914999914, -31.313539732999914],
            [-55.10244584199995, -31.324288430999943],
            [-55.08725297099991, -31.32676889999992],
            [-55.07425634799998, -31.32056772799993],
            [-55.061104695999916, -31.30485809299995],
            [-55.04234615099992, -31.272611998999906],
            [-55.029375366999886, -31.26878794299995],
            [-55.01149532099993, -31.28780486999993],
            [-54.99534643599995, -31.311782734999937],
            [-54.96963741099995, -31.340824889999936],
            [-54.94080196099992, -31.365629577999883],
            [-54.90028763899991, -31.38206268299993],
            [-54.88780777999992, -31.39322479299996],
            [-54.87615474499995, -31.406350605999933],
            [-54.863364827999874, -31.417616068999905],
            [-54.84990311699991, -31.425057474999917],
            [-54.819775756999945, -31.435289407999903],
            [-54.65412695299992, -31.45575327499995],
            [-54.61968461099988, -31.455649921999935],
            [-54.604543416999945, -31.459784037999952],
            [-54.591520955999925, -31.471049498999918],
            [-54.57384761599991, -31.50246876999995],
            [-54.5623754479999, -31.51590464199991],
            [-54.50966548699998, -31.552284850999897],
            [-54.495041056999895, -31.565617369999913],
            [-54.48315547799987, -31.583910827999972],
            [-54.47896968699993, -31.601480813999956],
            [-54.47736771699991, -31.642098489999896],
            [-54.46722070599992, -31.664237422999904],
            [-54.463725138999905, -31.671864115999966],
            [-54.43649165799991, -31.694291686999875],
            [-54.40367712499997, -31.714652200999907],
            [-54.37349808799988, -31.73894012399991],
            [-54.3429573169999, -31.76932586599996],
            [-54.2742276619999, -31.82337941499995],
            [-54.21877884899993, -31.856659036999886],
            [-54.16958288599997, -31.895933124999956],
            [-54.146276814999936, -31.90988576299995],
            [-54.135063028999895, -31.908955586999895],
            [-54.12550288999989, -31.89851694799995],
            [-54.10731278499995, -31.883944192999905],
            [-54.08845088699994, -31.87815643299993],
            [-54.0688138429999, -31.87991343199991],
            [-54.04974523999991, -31.887148131999965],
            [-54.03264033999997, -31.89810353599995],
            [-54.02664587399994, -31.90482147199988],
            [-54.0177058509999, -31.919600931999895],
            [-54.008714152999886, -31.926525573999882],
            [-53.9988956309999, -31.929729511999938],
            [-53.96597774299994, -31.9325200399999],
            [-53.94876949099998, -31.93696421299991],
            [-53.93435176699995, -31.94254526799992],
            [-53.90582637599991, -31.959288431999965],
            [-53.894147501999925, -31.970140482999923],
            [-53.889755004999955, -31.98037241599991],
            [-53.88727453599998, -31.990500996999955],
            [-53.88143509999989, -32.00124969499997],
            [-53.87109981299997, -32.011481627999956],
            [-53.858077351999924, -32.0211967969999],
            [-53.830430460999935, -32.03644134499993],
            [-53.77182938699991, -32.04708668999993],
            [-53.75730830999996, -32.0550448609999],
            [-53.75136551899993, -32.06879079199993],
            [-53.750021931999896, -32.104034118999905],
            [-53.72144486499991, -32.16242848699996],
            [-53.670595255999984, -32.226403909999945],
            [-53.65855464699993, -32.254309183999936],
            [-53.6518367109999, -32.28831227599997],
            [-53.648684448999944, -32.33864512099994],
            [-53.643878539999946, -32.35559499099995],
            [-53.63478348899989, -32.368720804999924],
            [-53.609307006999956, -32.38784108499992],
            [-53.598920043999925, -32.3999333699999],
            [-53.581970174999924, -32.425771585999925],
            [-53.561299601999906, -32.44954274499989],
            [-53.537631795999886, -32.47021331799989],
            [-53.47463822399996, -32.508247171999926],
            [-53.415623738999926, -32.56416107199992],
            [-53.35908972199988, -32.58028411799991],
            [-53.31604325399988, -32.60271168999989],
            [-53.299093383999946, -32.60715586399991],
            [-53.26689896699992, -32.60736256899996],
            [-53.233722697999895, -32.62462249699986],
            [-53.201476603999936, -32.63723154699997],
            [-53.18612870399997, -32.646740010999864],
            [-53.119776164999934, -32.707408141999935],
            [-53.1108361419999, -32.72239430699992],
            [-53.11404007999997, -32.74058441099996],
            [-53.12685583499987, -32.75484710699993],
            [-53.163081013999914, -32.778721618999924],
            [-53.18283631199995, -32.799904104999925],
            [-53.2038537199999, -32.822439879999905],
            [-53.270826374999984, -32.86378102699993],
            [-53.29883500199989, -32.88910247799991],
            [-53.306999877999914, -32.90718922999993],
            [-53.309583699999905, -32.944396259999934],
            [-53.316301635999935, -32.96268971799991],
            [-53.32730871699994, -32.97364512199998],
            [-53.44911006699991, -33.042064716999874],
            [-53.48331986499991, -33.06728281599992],
            [-53.51153519699997, -33.09921885199991],
            [-53.511586872999885, -33.09932220499992],
            [-53.5116385499999, -33.09942555699986],
            [-53.52066175999988, -33.12497899199994],
            [-53.53685664899987, -33.17084238699995],
            [-53.53613317899996, -33.244636331999914],
            [-53.51401566599995, -33.394911396999944],
            [-53.53680497199994, -33.55986256899986],
            [-53.53964717599993, -33.64926279699995],
            [-53.51153519699997, -33.6902938839999],
            [-53.491071329999926, -33.6902938839999],
            [-53.47319128399997, -33.68740000399991],
            [-53.45670650299988, -33.68750335699994],
            [-53.44042842699986, -33.69711517399995],
            [-53.43081660999985, -33.713444925999895],
            [-53.42363358599991, -33.73101491299987],
            [-53.411282918999945, -33.74228037499992],
            [-53.379094569439076, -33.74067597231428],
            [-53.39635169199994, -33.75058359199994],
            [-53.41478430899991, -33.76441822699991],
            [-53.45091712099992, -33.80152760199991],
            [-53.47305253799993, -33.83456796699994],
            [-53.485585089999915, -33.86931731599992],
            [-53.505523240999935, -33.95232512799993],
            [-53.524647589999915, -34.00237395599993],
            [-53.52993730399993, -34.04810963299991],
            [-53.53945878799993, -34.062432549999926],
            [-53.57445227799991, -34.082696221999925],
            [-53.59121660099993, -34.0954729149999],
            [-53.639963344999956, -34.14763762799993],
            [-53.69359290299991, -34.18173593499995],
            [-53.711008266999954, -34.19882577899995],
            [-53.746652798999946, -34.25741952899995],
            [-53.755970831999946, -34.26767343499995],
            [-53.75829016799992, -34.27849700299993],
            [-53.77989661399994, -34.33603280999995],
            [-53.763661261999914, -34.37249114399992],
            [-53.764881964999915, -34.3903947899999],
            [-53.80577551999994, -34.40097421699994],
            [-53.89830481699994, -34.44394296699994],
            [-53.97223873599995, -34.48723723799992],
            [-54.12462317599994, -34.610446872999944],
            [-54.136789516999954, -34.62395598799992],
            [-54.14093990799995, -34.64104583099993],
            [-54.14049231699994, -34.65642669099992],
            [-54.14590410099993, -34.66757577899995],
            [-54.23680579299992, -34.68450286299992],
            [-54.25967363199993, -34.68596770599993],
            [-54.25560462099992, -34.6775041649999],
            [-54.24950110599991, -34.670993747999944],
            [-54.23232988199993, -34.658135674999926],
            [-54.23932857999995, -34.65309010199991],
            [-54.24567623599995, -34.64690520599993],
            [-54.25047766799992, -34.639336846999925],
            [-54.252837693999936, -34.630791924999926],
            [-54.251210089999915, -34.61834075299993],
            [-54.241078253999945, -34.594008070999905],
            [-54.23859615799995, -34.589776299999926],
            [-54.25328528599994, -34.57756926899992],
            [-54.28034420499995, -34.56796640399995],
            [-54.30894934799994, -34.56218840899993],
            [-54.32860266799992, -34.56178150799991],
            [-54.31737219999991, -34.568617445999905],
            [-54.280140753999945, -34.582289320999905],
            [-54.28815670499995, -34.594821872999944],
            [-54.30443274599992, -34.60857512799993],
            [-54.323109503999945, -34.619398695999905],
            [-54.33849036399994, -34.62395598799992],
            [-54.344634568999936, -34.6306291649999],
            [-54.34479732999995, -34.64421965899993],
            [-54.33739173099991, -34.65471770599993],
            [-54.321156378999945, -34.65252044099992],
            [-54.32258053299995, -34.64470794099992],
            [-54.30768795499995, -34.64739348799992],
            [-54.28921464799993, -34.66025155999995],
            [-54.280140753999945, -34.682305596999925],
            [-54.28807532499991, -34.69500090899993],
            [-54.30646725199995, -34.707696221999925],
            [-54.5307917959999, -34.806898695999905],
            [-54.54206295499995, -34.81178150799991],
            [-54.60415605399993, -34.826429945999905],
            [-54.63646399599992, -34.84880950299993],
            [-54.65689042899993, -34.85662200299993],
            [-54.69945227799991, -34.867445570999905],
            [-54.872710740999935, -34.936211846999925],
            [-54.89370683499993, -34.9392229149999],
            [-54.913726365999935, -34.945245049999926],
            [-54.93932044199994, -34.96990325299993],
            [-54.95860755099994, -34.97340260199991],
            [-54.953968878999945, -34.96331145599993],
            [-54.95181230399993, -34.956963799999926],
            [-54.95177161399994, -34.9528947899999],
            [-54.962228969999956, -34.93962981599992],
            [-54.97573808499993, -34.92848072699991],
            [-54.99356035099993, -34.920993747999944],
            [-55.03307044199994, -34.91676197699991],
            [-55.03547115799995, -34.91285572699991],
            [-55.03453528599994, -34.906508070999905],
            [-55.041127081999946, -34.89763762799993],
            [-55.05125891799992, -34.89137135199991],
            [-55.06037350199995, -34.887790622999944],
            [-55.082142706999946, -34.88396575299993],
            [-55.129790818999936, -34.88591887799993],
            [-55.22175045499995, -34.90374114399992],
            [-55.26024329299992, -34.89763762799993],
            [-55.28648841099994, -34.87623463299991],
            [-55.33828691299993, -34.81878020599993],
            [-55.376942511999914, -34.801446221999925],
            [-55.40192623599995, -34.79998137799993],
            [-55.46820360799995, -34.79540215299994],
            [-55.50963582199995, -34.79906453199993],
            [-55.56117305499993, -34.787834173999954],
            [-55.60179446399991, -34.77241464899993],
            [-55.64673084399993, -34.78109997799993],
            [-55.69344767599995, -34.76474114699994],
            [-55.75650301499991, -34.782666358999904],
            [-55.792050812999946, -34.774133854999945],
            [-55.8587864829999, -34.79306066999993],
            [-55.889101437999955, -34.80347481799993],
            [-55.95443152599995, -34.83940229199993],
            [-56.004051819999916, -34.86910175799994],
            [-56.06963449299991, -34.90100253399993],
            [-56.10519841799993, -34.89841612899994],
            [-56.13563268999991, -34.91282873699993],
            [-56.14989173099991, -34.92034270599993],
            [-56.15608835099994, -34.94118826299996],
            [-56.17728986599991, -34.91632450299994],
            [-56.194509927999945, -34.91350868799992],
            [-56.21300164399992, -34.90769323099994],
            [-56.20466061099995, -34.898695570999905],
            [-56.20345465699995, -34.88750262599996],
            [-56.214589163999904, -34.87958788599991],
            [-56.23055095899991, -34.877749998999946],
            [-56.23650847099992, -34.89288421099991],
            [-56.25633704299992, -34.906182549999926],
            [-56.26582366799994, -34.906266151999944],
            [-56.28797603899994, -34.90348919599995],
            [-56.31126868399991, -34.906182549999926],
            [-56.34276282499991, -34.88396575299993],
            [-56.40294348899994, -34.85475025799991],
            [-56.41844641799992, -34.84303150799991],
            [-56.420765753999945, -34.82822030999995],
            [-56.40375055599992, -34.81605142099994],
            [-56.38684753399991, -34.80187023499991],
            [-56.361281585999905, -34.796636049999904],
            [-56.376119660999905, -34.78272924599992],
            [-56.395738337999944, -34.77588006599996],
            [-56.448432032999904, -34.75827246199992],
            [-56.48508775499994, -34.75354986399992],
            [-56.52044438899992, -34.75482088499996],
            [-56.541900193999936, -34.76702239399992],
            [-56.55801347599993, -34.76506926899992],
            [-56.57359778599994, -34.75896575299993],
            [-56.61095130099994, -34.73943450299993],
            [-56.62852942599994, -34.73259856599992],
            [-56.646362077999925, -34.72264151799993],
            [-56.713544492999915, -34.70703725399994],
            [-56.79528944499992, -34.69849235399994],
            [-56.873890753999945, -34.670179945999905],
            [-56.890695766999954, -34.660088799999926],
            [-56.90416419199994, -34.63551197699991],
            [-56.91974850199995, -34.62322356599992],
            [-56.95287024599992, -34.603448174999926],
            [-56.97657717699991, -34.581045573999916],
            [-56.997417070999916, -34.56406881499993],
            [-57.01578753199993, -34.55209148499995],
            [-57.042717102999916, -34.53812484999992],
            [-57.05742538599992, -34.52712707199993],
            [-57.055897589999915, -34.5134416649999],
            [-57.06240800699993, -34.506524346999925],
            [-57.077015753999945, -34.49814218499995],
            [-57.08315995999993, -34.49358489399992],
            [-57.10195878799993, -34.47584400799991],
            [-57.120025193999936, -34.46298593499995],
            [-57.15196415799994, -34.45093220299992],
            [-57.20319801399995, -34.44207349299995],
            [-57.292158428999926, -34.44033264899991],
            [-57.34694166199995, -34.443459326999914],
            [-57.36519992199993, -34.43044041099995],
            [-57.41142825899993, -34.43150561999994],
            [-57.43697381399994, -34.444575562999944],
            [-57.44913018299991, -34.43153807199991],
            [-57.47466288499993, -34.42954124999994],
            [-57.502635281999915, -34.44058248299996],
            [-57.53791369999993, -34.453613687999905],
            [-57.56947545399993, -34.426503974999946],
            [-57.59499722499993, -34.42547296999993],
            [-57.62417745599993, -34.43045196199995],
            [-57.66432357799994, -34.445437727999945],
            [-57.72030011399994, -34.463373202999946],
            [-57.7385353919999, -34.461317668999925],
            [-57.76411482299994, -34.47429458499994],
            [-57.793302043999915, -34.47219671799991],
            [-57.82250955599994, -34.475108571999954],
            [-57.85535416199991, -34.47096708499993],
            [-57.8455846839999, -34.46297908699995],
            [-57.85404767099993, -34.44788164599993],
            [-57.8820192039999, -34.44072416999995],
            [-57.900189818999934, -34.41652468099994],
            [-57.89759955999995, -34.376338811999915],
            [-57.922759568999936, -34.35369231599992],
            [-57.94273841099994, -34.32626718499995],
            [-58.0169164699999, -34.25310637799993],
            [-58.04979407499991, -34.2400041649999],
            [-58.061390753999945, -34.22470468499995],
            [-58.07697506399995, -34.19198984199994],
            [-58.094593878999945, -34.17782968499995],
            [-58.11937415299991, -34.16920338299991],
            [-58.14590410099993, -34.165134372999944],
            [-58.16909745999993, -34.163995049999926],
            [-58.196197068999936, -34.15943775799991],
            [-58.20872962099992, -34.14763762799993],
            [-58.22032630099994, -34.110039971999925],
            [-58.23184160099993, -34.08879973799992],
            [-58.316517706999946, -33.98650481599992],
            [-58.334828253999945, -33.973321221999925],
            [-58.37242591099994, -33.95435963299991],
            [-58.38882402299993, -33.942071221999925],
            [-58.40269934799994, -33.92278411299992],
            [-58.41002356699994, -33.902276299999926],
            [-58.43464107999995, -33.7849260399999],
            [-58.43936113199993, -33.69850025799991],
            [-58.425770636999914, -33.61288827899995],
            [-58.4290258449999, -33.592054945999905],
            [-58.43504798099991, -33.57236093499995],
            [-58.438343878999945, -33.551446221999925],
            [-58.43321692599994, -33.52776458099993],
            [-58.419585740999935, -33.50823333099993],
            [-58.38536536399994, -33.47031015399995],
            [-58.378570115999935, -33.44866301899992],
            [-58.384877081999946, -33.42913176899992],
            [-58.41258704299992, -33.40960051899992],
            [-58.41893469999991, -33.38990650799991],
            [-58.41258704299992, -33.37167734199994],
            [-58.39720618399991, -33.35564544099992],
            [-58.36119544199994, -33.32577890399995],
            [-58.35073808499993, -33.305759372999944],
            [-58.34923255099994, -33.28281015399995],
            [-58.36603756399995, -33.19605885199991],
            [-58.36693274599992, -33.15374114399992],
            [-58.35138912699995, -33.12167734199994],
            [-58.31029212099992, -33.10881926899992],
            [-58.217355923999946, -33.113539320999905],
            [-58.17442786399994, -33.110446872999944],
            [-58.13776607999995, -33.09514739399992],
            [-58.100168423999946, -33.06560637799993],
            [-58.08372962099992, -33.047539971999925],
            [-58.07697506399995, -33.03069426899992],
            [-58.07530676999994, -33.00750090899993],
            [-58.07066809799994, -32.98951588299991],
            [-58.05581620999993, -32.951836846999925],
            [-58.048491990999935, -32.91171640399995],
            [-58.05711829299992, -32.88176848799992],
            [-58.07721920499995, -32.85784270599993],
            [-58.12047278599994, -32.81926848799992],
            [-58.13076738199993, -32.802666924999926],
            [-58.13613847599993, -32.78435637799993],
            [-58.13776607999995, -32.7634416649999],
            [-58.13585364499994, -32.71835702899995],
            [-58.13768469999991, -32.695570570999905],
            [-58.14517167899993, -32.67815520599993],
            [-58.13776607999995, -32.67066822699991],
            [-58.14622962099992, -32.64495208099993],
            [-58.15721594999991, -32.57512786299992],
            [-58.16909745999993, -32.560804945999905],
            [-58.17711341099994, -32.54501718499995],
            [-58.19741777299993, -32.469821872999944],
            [-58.20012361999997, -32.44720104199993],
            [-58.1997244879999, -32.44478851299989],
            [-58.18995764199994, -32.433936461999934],
            [-58.16494624899994, -32.38949472999987],
            [-58.101590942999934, -32.31135996499994],
            [-58.096526652999955, -32.28097422299989],
            [-58.10691361499997, -32.25182871499996],
            [-58.17522985899993, -32.17410736099994],
            [-58.18654699699991, -32.15292002399988],
            [-58.18086258999995, -32.13245615599992],
            [-58.15879675299996, -32.101553648999925],
            [-58.148306437999906, -32.06289967799992],
            [-58.145309203999915, -32.017889505999904],
            [-58.149029906999914, -31.975204772999902],
            [-58.15879675299996, -31.943888854999983],
            [-58.19031937699992, -31.913296406999876],
            [-58.202618367999975, -31.893142597999898],
            [-58.196003784999874, -31.872575377999908],
            [-58.16861527499992, -31.8460136919999],
            [-58.15285396399986, -31.83598846499997],
            [-58.13083980299987, -31.827823587999944],
            [-58.08345251499989, -31.819762063999875],
            [-58.05926794399991, -31.811493834999922],
            [-58.0488809819999, -31.79712778699991],
            [-57.98862626099992, -31.642821960999896],
            [-57.979582885999974, -31.598793639999926],
            [-57.986817585999944, -31.55414520299989],
            [-58.01332759699994, -31.525619811999945],
            [-58.03897801099987, -31.508637468999908],
            [-58.05079300899993, -31.500815124999903],
            [-58.07523596199988, -31.47518361399993],
            [-58.06257523599993, -31.44428110799994],
            [-58.04355830899996, -31.43063852999994],
            [-58.005937865999925, -31.4110014849999],
            [-57.990228230999975, -31.39932261199992],
            [-57.980513061999915, -31.38051238999992],
            [-57.975552123999876, -31.335140481999886],
            [-57.9663537189999, -31.314573262],
            [-57.95948075399991, -31.30795867899991],
            [-57.94299597199992, -31.29679656999987],
            [-57.93560624199992, -31.290285338999908],
            [-57.91483231599997, -31.252458190999917],
            [-57.90511714699994, -31.240986022999905],
            [-57.90501379399993, -31.21504445399995],
            [-57.911731730999946, -31.17060272199997],
            [-57.89901932799998, -31.12647104899989],
            [-57.873749552999925, -31.093088073999922],
            [-57.8552493899999, -31.058981627999955],
            [-57.86331091399998, -31.012266133999958],
            [-57.905478881999926, -30.95883270199994],
            [-57.911731730999946, -30.94736053499993],
            [-57.903980265999934, -30.92968719499993],
            [-57.88532507299996, -30.91883514399997],
            [-57.84279536999992, -30.909223326999964],
            [-57.819644327999924, -30.911600442999912],
            [-57.80724198499985, -30.907569681999917],
            [-57.80186763499998, -30.892480162999917],
            [-57.79613155099992, -30.86839894599997],
            [-57.79499466999991, -30.857960306999928],
            [-57.79602819899989, -30.816205748999977],
            [-57.79939710199994, -30.791460706999914],
            [-57.80186763499998, -30.773314309999932],
            [-57.80865916899995, -30.747331216999925],
            [-57.81788732999985, -30.71202606199998],
            [-57.82620723499991, -30.689701842999924],
            [-57.848531453999954, -30.647947285999876],
            [-57.86331091399998, -30.628620299999923],
            [-57.8857901609999, -30.589862975999978],
            [-57.889769246999975, -30.550795592999876],
            [-57.87710852099994, -30.514828795999904],
            [-57.84961665899996, -30.48526987799997],
            [-57.652729451999875, -30.329103698999944],
            [-57.6310770259999, -30.29706430999994],
            [-57.62373897299989, -30.25810028099994],
            [-57.63794999199985, -30.215105488999967],
            [-57.64246584634791, -30.193092102762034],
            [-57.602792548565105, -30.190516953885325],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Ecuador',
        iso3: 'ECU',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.82868404899995, 1.43431224200009],
              [-78.76996761099986, 1.394102072000067],
              [-78.74898697899997, 1.36485321000012],
              [-78.71947973599995, 1.341056214000062],
              [-78.70919612599994, 1.32415802000007],
              [-78.69935176599998, 1.302040507000058],
              [-78.68428808699989, 1.281886698000079],
              [-78.66467687999994, 1.266642151000042],
              [-78.6412674559999, 1.259407450000069],
              [-78.62555782099992, 1.261991272000074],
              [-78.61152766899991, 1.266435445000084],
              [-78.60214839699995, 1.263644918000111],
              [-78.6004430749999, 1.244421285000101],
              [-78.59661901899995, 1.234085998000083],
              [-78.57569006399987, 1.211968486000075],
              [-78.57005733299985, 1.19584543900001],
              [-78.55561376999992, 1.204113668000048],
              [-78.54060176699994, 1.205353902000084],
              [-78.4852046309999, 1.192641500000121],
              [-78.47812265099995, 1.18711995600006],
              [-78.46691117399993, 1.178378805000051],
              [-78.37280839099995, 1.073785705000134],
              [-78.34921809999994, 1.05580230700005],
              [-78.33007198099995, 1.046500550000118],
              [-78.27061824599988, 1.030480855000064],
              [-78.25015437899992, 1.019628804000121],
              [-78.12000728399997, 0.921236878000087],
              [-78.07794266799993, 0.900773011000126],
              [-78.00704260299997, 0.898189189000036],
              [-77.93903641799989, 0.872557678000064],
              [-77.92818436699994, 0.872350972000106],
              [-77.92306840099985, 0.875038147000041],
              [-77.91826249199994, 0.874418030000072],
              [-77.90854732299991, 0.864186096000083],
              [-77.90498164899995, 0.854005840000113],
              [-77.90529170799994, 0.842895406000096],
              [-77.90322464999986, 0.832095032000069],
              [-77.8926309819999, 0.823051656000104],
              [-77.86932491099995, 0.814059957000069],
              [-77.84798254399996, 0.809254048000057],
              [-77.82772538299994, 0.808892314000062],
              [-77.80762325099988, 0.813026428000086],
              [-77.72788651499991, 0.843308818000111],
              [-77.70318518099992, 0.843102112000054],
              [-77.6733162029999, 0.819641012000076],
              [-77.66680497299993, 0.747707418000047],
              [-77.64556595999994, 0.7162881470001],
              [-77.5798335369999, 0.670916239000078],
              [-77.54334997599997, 0.656446838000136],
              [-77.51413779499987, 0.660531216000038],
              [-77.50934688399994, 0.661201070000033],
              [-77.46805741399993, 0.650865784000118],
              [-77.45456986499997, 0.602393290000052],
              [-77.44816198799992, 0.497283427000099],
              [-77.43911861199987, 0.463693746000075],
              [-77.43472611599987, 0.433824769000054],
              [-77.42439082899995, 0.408296610000107],
              [-77.39746740699985, 0.387626038000093],
              [-77.36253413899996, 0.374810283000031],
              [-77.25613236599995, 0.353209534000143],
              [-77.23727046699992, 0.346388245000099],
              [-77.22254268499992, 0.338843486000144],
              [-77.20693640199997, 0.334192607000077],
              [-77.18518062399997, 0.335432841000028],
              [-77.13479610199997, 0.354346416000055],
              [-77.11743282099985, 0.357550354000125],
              [-77.1038560799999, 0.354140948000108],
              [-77.08286128799995, 0.348868713000073],
              [-77.04462072799987, 0.305667216000131],
              [-77.0149067799999, 0.295641988000099],
              [-76.97490921999994, 0.294918518000102],
              [-76.96245520099987, 0.292851461000055],
              [-76.94586706599995, 0.287063701000079],
              [-76.93568680799987, 0.279829000000106],
              [-76.91387935399985, 0.257814840000123],
              [-76.89682613199992, 0.245309143000043],
              [-76.88246008299993, 0.240141500000036],
              [-76.8673188889999, 0.239521382000063],
              [-76.79786576399994, 0.249960022000096],
              [-76.7852567139999, 0.248719788000059],
              [-76.74959997599993, 0.232700094000108],
              [-76.73435542799987, 0.233113505000119],
              [-76.73688757399987, 0.272904358000034],
              [-76.72453690599991, 0.277555237000087],
              [-76.68996537299992, 0.268150126000137],
              [-76.64123449699989, 0.262775778000076],
              [-76.62686844899989, 0.258538310000034],
              [-76.61105546099986, 0.247479553000119],
              [-76.58433874499991, 0.222571513000062],
              [-76.56542517199998, 0.21606028300009],
              [-76.5508007409999, 0.217920635000084],
              [-76.52491084799996, 0.231253154000115],
              [-76.42569209899992, 0.242725322000126],
              [-76.40801875799991, 0.254507548000035],
              [-76.41835404499992, 0.320860087000057],
              [-76.41587357699984, 0.395377503000105],
              [-76.41639033999988, 0.401888733000078],
              [-76.40693355399992, 0.400131735000102],
              [-76.38533280499985, 0.401475322000067],
              [-76.37468745999985, 0.403542378000026],
              [-76.36538570199991, 0.406953023000057],
              [-76.34052933799987, 0.436615296000113],
              [-76.33494828399995, 0.441679586000092],
              [-76.32972896399994, 0.444780172000122],
              [-76.3115905359999, 0.458526103000068],
              [-76.3004801029999, 0.461626689000099],
              [-76.29050655199987, 0.457182516000103],
              [-76.26291133699988, 0.428037008000075],
              [-76.24368770399985, 0.415427958000052],
              [-76.22374060099995, 0.406746318000089],
              [-76.20208817599985, 0.401785380000135],
              [-76.1775935469999, 0.400131735000102],
              [-76.1558377689999, 0.40126861600001],
              [-76.14467565999985, 0.400441793000084],
              [-76.13630407799988, 0.396721090000071],
              [-76.13030961099994, 0.386075745000085],
              [-76.12467688099991, 0.359617411000087],
              [-76.11956091399992, 0.351762594000149],
              [-76.10131913299998, 0.352692769000015],
              [-76.0759976809999, 0.360754293000099],
              [-76.05346675699988, 0.363544820000058],
              [-76.04385493999987, 0.34855865500009],
              [-76.0395141199999, 0.336673076000054],
              [-75.97248978699989, 0.251923727000118],
              [-75.96752884999992, 0.23931467700001],
              [-75.96298132399988, 0.220091044000085],
              [-75.9519742439999, 0.203967997000092],
              [-75.92711787899995, 0.181023662000072],
              [-75.86634639499994, 0.143506572000078],
              [-75.85797481299994, 0.129760640000129],
              [-75.81787390199986, 0.100098369000079],
              [-75.78971024599991, 0.084388733000111],
              [-75.77322546399992, 0.077774149000021],
              [-75.75384680199997, 0.073019918000028],
              [-75.73162593599992, 0.071159567000024],
              [-75.7086299239999, 0.0733299770001],
              [-75.66550594099996, 0.083148499000075],
              [-75.64666988099995, 0.085422262000094],
              [-75.62677445499995, 0.078911031000118],
              [-75.61096146699992, 0.064648336000047],
              [-75.59824906499998, 0.050385641000076],
              [-75.5879654549999, 0.0438744100001],
              [-75.57013708499994, 0.037983297000011],
              [-75.52311153199989, -0.003977965999908],
              [-75.46492386899988, -0.039738056999923],
              [-75.44089432899992, -0.048109638999989],
              [-75.42141231299993, -0.062165628999907],
              [-75.36544673699993, -0.072810973999907],
              [-75.30196223999988, -0.096065368999916],
              [-75.28348791499988, -0.107020771999899],
              [-75.29534765599988, -0.122316995999952],
              [-75.31795609599993, -0.138336689999903],
              [-75.3307460129999, -0.144641214999922],
              [-75.34405269399991, -0.149085387999932],
              [-75.36002071199997, -0.149912210999943],
              [-75.39423050999994, -0.145054625999933],
              [-75.40257625399991, -0.14577809599993],
              [-75.42949967499993, -0.163658141999889],
              [-75.45526037699995, -0.161177672999912],
              [-75.52574702999988, -0.123247171999907],
              [-75.53926041799986, -0.120043232999933],
              [-75.55329056799988, -0.119836527999979],
              [-75.57117061399993, -0.121696878999984],
              [-75.58677689599998, -0.118699645999882],
              [-75.60501867699992, -0.111361592999884],
              [-75.62300207599992, -0.106607360999888],
              [-75.63760066799998, -0.111464945999913],
              [-75.64320756099991, -0.128828226999929],
              [-75.63840165199989, -0.150945738999937],
              [-75.62863480699994, -0.170479430999933],
              [-75.61956559299998, -0.180918069999976],
              [-75.61013464399991, -0.182985127999942],
              [-75.5887147629999, -0.181331481999976],
              [-75.57897375499994, -0.182675068999856],
              [-75.56682979399994, -0.190013122999943],
              [-75.54590083899987, -0.209753518999918],
              [-75.53352433299989, -0.216058043999922],
              [-75.5121561279999, -0.223086038999938],
              [-75.49618811099995, -0.23311126699987],
              [-75.48476761999987, -0.247684020999912],
              [-75.45272823099995, -0.360648701999907],
              [-75.43422806899991, -0.403023375999922],
              [-75.40562516299985, -0.442400817999925],
              [-75.38699580999989, -0.459970804999898],
              [-75.37565283299992, -0.46699879899991],
              [-75.36539506099993, -0.468755797999975],
              [-75.35307023199996, -0.467722268999907],
              [-75.34735998599993, -0.470926208999884],
              [-75.3432775469999, -0.476817321999874],
              [-75.30428767899991, -0.50709971099991],
              [-75.30002437399986, -0.511750589999878],
              [-75.29485673099995, -0.523222757999889],
              [-75.2909809979999, -0.527976989999971],
              [-75.28591670799992, -0.52901051799995],
              [-75.27653743599987, -0.524152933999929],
              [-75.27204158499987, -0.525703225999948],
              [-75.26069860899989, -0.543479918999893],
              [-75.25702958199989, -0.56198008199992],
              [-75.2601301679999, -0.601254170999894],
              [-75.25930334499989, -0.609522399999932],
              [-75.25697790599986, -0.616757101],
              [-75.2555826419999, -0.624301858999942],
              [-75.25764969999994, -0.633190204999963],
              [-75.26664139799988, -0.642698668999941],
              [-75.27875952199989, -0.648899840999931],
              [-75.28943070599988, -0.656031188999876],
              [-75.29397823099993, -0.667916767999898],
              [-75.29294470299993, -0.677735289999958],
              [-75.28865555799987, -0.696132100999961],
              [-75.28813879399993, -0.706260680999918],
              [-75.2902575279999, -0.716492613999904],
              [-75.29661372899992, -0.734476012999977],
              [-75.29702713999984, -0.746981709999972],
              [-75.25261124699998, -0.897876891999971],
              [-75.2523011889999, -0.90686859099992],
              [-75.25390315799993, -0.924128519999911],
              [-75.25206864499992, -0.933430276999943],
              [-75.24434301799994, -0.944799092999929],
              [-75.23475703999992, -0.95317067499991],
              [-75.22749650099985, -0.963092549999899],
              [-75.2272639579999, -0.969810484999925],
              [-75.23620397999991, -0.970430602999983],
              [-75.28348791499988, -0.970430602999983],
              [-75.32594010499989, -0.975494892999961],
              [-75.34872941099988, -0.974978128999922],
              [-75.35859960999997, -0.966916604999938],
              [-75.36441320799995, -0.956891377999909],
              [-75.37805578699997, -0.941181741999941],
              [-75.40640030999995, -0.915136819999873],
              [-75.41257564299994, -0.92392181299995],
              [-75.42523636899998, -0.973324482999971],
              [-75.45526037699995, -1.091146748999989],
              [-75.4852843839999, -1.209072366999933],
              [-75.51530838999994, -1.326997985999881],
              [-75.54533239799991, -1.444820250999982],
              [-75.5600343429999, -1.502594501999894],
              [-75.57303096599992, -1.537321064999915],
              [-75.5807400969999, -1.546639795999923],
              [-75.59654374199991, -1.565743102999946],
              [-75.65147578999995, -1.616696064999886],
              [-75.69173173099998, -1.663618265999929],
              [-75.74162532599985, -1.721702575999913],
              [-75.79154475999991, -1.779890237999922],
              [-75.84154170699989, -1.838077900999934],
              [-75.89146114199986, -1.896265563999947],
              [-75.94138057499993, -1.954453226999959],
              [-75.9913516849999, -2.012640888999968],
              [-76.04127111899996, -2.070725198999952],
              [-76.09124222899993, -2.12891286199995],
              [-76.15087683199994, -2.174594827999968],
              [-76.21051143399984, -2.220276794999975],
              [-76.27024938999998, -2.265855406999961],
              [-76.32988399299998, -2.311537373999968],
              [-76.38962194899992, -2.357322692999915],
              [-76.4492565509999, -2.402901305999904],
              [-76.50894282999994, -2.448583271999922],
              [-76.56862910999985, -2.49426523899993],
              [-76.62526647999994, -2.537673441999928],
              [-76.66966155799986, -2.564588924999896],
              [-76.68459102499995, -2.5736402389999],
              [-76.77667842699987, -2.605782978999926],
              [-76.90245886199995, -2.649811299999982],
              [-77.0281876219999, -2.69373626699992],
              [-77.1540197349999, -2.737661234999962],
              [-77.27974849499986, -2.781689554999929],
              [-77.40547725399992, -2.825614522999956],
              [-77.53120601399988, -2.869642841999919],
              [-77.65698645099985, -2.913567809999947],
              [-77.7827152099999, -2.957492776999899],
              [-77.81036941199991, -2.967149115999945],
              [-77.84901607299994, -2.98064381899988],
              [-77.86782629399994, -2.990255634999897],
              [-77.94146520999996, -3.054541116999957],
              [-78.0425443119999, -3.189933369999949],
              [-78.09086177599994, -3.230034280999945],
              [-78.10491776599986, -3.245433857999927],
              [-78.13582027299987, -3.304655049999923],
              [-78.14817093899993, -3.322431742999939],
              [-78.18460282399991, -3.349510192999901],
              [-78.19641088899994, -3.363669534999943],
              [-78.19651424199995, -3.385580342999901],
              [-78.18496455899992, -3.403770446999943],
              [-78.16920324699993, -3.414932555999883],
              [-78.1566458739999, -3.429298603999882],
              [-78.15452714099985, -3.456790465999859],
              [-78.16372554599994, -3.477254332999919],
              [-78.17912512299992, -3.483765563999981],
              [-78.19685013899993, -3.487589619999923],
              [-78.21268896599994, -3.500508727999929],
              [-78.22630570499985, -3.507019958999905],
              [-78.23586584599994, -3.488829854999949],
              [-78.2496892909999, -3.424544371999986],
              [-78.25718237299992, -3.409558206999918],
              [-78.26968806999994, -3.399532978999986],
              [-78.3130187589999, -3.387440693999906],
              [-78.33397355199989, -3.384546813999918],
              [-78.35079423099995, -3.389611103999897],
              [-78.36172379599995, -3.408524677999935],
              [-78.3607936199999, -3.414932555999883],
              [-78.35469580099993, -3.434569600999922],
              [-78.35529007999989, -3.44552500399989],
              [-78.36293819199997, -3.488726500999931],
              [-78.37587184799995, -3.529348453999958],
              [-78.37725256399995, -3.533684997999941],
              [-78.39567521199987, -3.573785908999938],
              [-78.4023931479999, -3.594353128999927],
              [-78.40471858799992, -3.613783466999905],
              [-78.4042534999999, -3.649750263999891],
              [-78.40009354699987, -3.670110778999913],
              [-78.40073950199994, -3.679825947999859],
              [-78.40836177599991, -3.685613708999924],
              [-78.42110001699987, -3.687784118999915],
              [-78.42585424899997, -3.689437763999962],
              [-78.4264226889999, -3.69460540699987],
              [-78.42637101299991, -3.707214456999893],
              [-78.41358109499993, -3.771809996999949],
              [-78.41967891499988, -3.791033629999959],
              [-78.44407019099992, -3.814804788999922],
              [-78.45200252399988, -3.819869078999901],
              [-78.46432735299993, -3.82565683999988],
              [-78.47037349499996, -3.830204365999919],
              [-78.48068294299986, -3.849531351999957],
              [-78.48784012899992, -3.868651631999867],
              [-78.49771032699988, -3.942652282999873],
              [-78.49763281299997, -3.949576924999946],
              [-78.50176692699989, -3.95371103899987],
              [-78.51571956399988, -3.96135915099994],
              [-78.5286386729999, -3.965389912999939],
              [-78.54075679499988, -3.966320088999893],
              [-78.55189306699992, -3.969213968999981],
              [-78.56207332399987, -3.979755960999853],
              [-78.5669050699999, -3.996189065999914],
              [-78.56592321799991, -4.055720316999981],
              [-78.57662023999993, -4.10005869499993],
              [-78.63757259199988, -4.227389423999924],
              [-78.64710689399988, -4.271107685999908],
              [-78.65573685699994, -4.290641376999915],
              [-78.67413366799991, -4.305937600999883],
              [-78.68242773499989, -4.326918232999972],
              [-78.68121333899987, -4.364435322999967],
              [-78.67315181499995, -4.401539000999946],
              [-78.66098201599993, -4.420659280999942],
              [-78.63721085599988, -4.435128681999885],
              [-78.63989803099992, -4.451251728999949],
              [-78.65534928499991, -4.470165302999902],
              [-78.66979284699994, -4.493419697999911],
              [-78.67237666899985, -4.51181650799991],
              [-78.6714464929999, -4.531763609999928],
              [-78.67266088899993, -4.550987242999952],
              [-78.68167842699998, -4.567110290999935],
              [-78.7089347759999, -4.585108369999887],
              [-78.7197122799999, -4.592225036999949],
              [-78.8112829179999, -4.62870859799996],
              [-78.85306331499993, -4.652273049999877],
              [-78.89864192799993, -4.694234313999885],
              [-78.91734879599991, -4.719969177999872],
              [-78.92861425799987, -4.74746103899993],
              [-78.92789078799987, -4.774849547999878],
              [-78.90533402499995, -4.819808043999984],
              [-78.90021805899994, -4.843682555999891],
              [-78.91081172699992, -4.863526305999883],
              [-78.93396276899992, -4.868693948999876],
              [-78.96026607299987, -4.868900654999933],
              [-78.98034236699993, -4.873964944999912],
              [-78.99101354999993, -4.890398050999877],
              [-79.00209814499993, -4.939128926999913],
              [-79.00928116899988, -4.960109557999914],
              [-79.03509354699989, -4.987498066999947],
              [-79.06392899599993, -5.011372578999939],
              [-79.08245499699987, -4.993079121999884],
              [-79.09338456299994, -4.985120950999914],
              [-79.10415909799988, -4.980056660999935],
              [-79.11452022399988, -4.978816426999899],
              [-79.13066910899997, -4.982847187999894],
              [-79.14084936599994, -4.983260598999905],
              [-79.15831599899988, -4.979333190999938],
              [-79.19175065199997, -4.967654316999869],
              [-79.20932063799992, -4.964760436999882],
              [-79.23368869399991, -4.965647838999942],
              [-79.28027237999993, -4.967344257999883],
              [-79.30321671599995, -4.961246438999922],
              [-79.31716935299994, -4.944399921999945],
              [-79.32784053599994, -4.923264261999904],
              [-79.34104386399991, -4.904247333999933],
              [-79.34985469599991, -4.898459574999961],
              [-79.36936254899993, -4.89112151999997],
              [-79.37807002799988, -4.884816995999955],
              [-79.38341853899993, -4.876238707999931],
              [-79.3899297689999, -4.856498310999953],
              [-79.39532995699997, -4.847609964999947],
              [-79.41269323799989, -4.83479420999987],
              [-79.43331213499991, -4.823942158999913],
              [-79.4505720629999, -4.810196227999882],
              [-79.45775508599993, -4.789008890999924],
              [-79.46082314399985, -4.770455597999941],
              [-79.46103653999992, -4.769165139999927],
              [-79.48721065299995, -4.719969177999872],
              [-79.49870865899996, -4.660644632999947],
              [-79.5278541669999, -4.618063252999974],
              [-79.5271823729999, -4.596565856999931],
              [-79.50413468499994, -4.55563812199992],
              [-79.50162837699986, -4.540962015999924],
              [-79.50720943199988, -4.531556904999974],
              [-79.52754410799992, -4.519671324999948],
              [-79.55162532599985, -4.519878031999909],
              [-79.55777482199991, -4.516570739999906],
              [-79.57203751599988, -4.506028746999931],
              [-79.57984065799991, -4.502308043999932],
              [-79.63032853299993, -4.45249196399989],
              [-79.65797542299993, -4.438746031999955],
              [-79.69412308799986, -4.443603616999965],
              [-79.72859126899993, -4.464067483999941],
              [-79.79574479199997, -4.484738056999944],
              [-79.83287430899986, -4.478950296999884],
              [-79.8577306729999, -4.453318785999912],
              [-79.87873714199992, -4.422002867999907],
              [-79.9040844319999, -4.398645120999959],
              [-79.93033605999995, -4.392030537999872],
              [-79.95601924699992, -4.391720478999972],
              [-79.9820124929999, -4.388619892999941],
              [-80.00909094299993, -4.373840432999927],
              [-80.02927058999992, -4.359681090999885],
              [-80.06162003599991, -4.3244377649999],
              [-80.07965511099991, -4.309038187999917],
              [-80.0968633629999, -4.302837015999927],
              [-80.11722387799992, -4.299116312999914],
              [-80.13386368799985, -4.293948668999917],
              [-80.14024572799988, -4.283096617999959],
              [-80.14308793199984, -4.284130146999942],
              [-80.1838347979999, -4.289401142999878],
              [-80.1947643639999, -4.293121846999981],
              [-80.20504797399988, -4.298186136999959],
              [-80.21344539399988, -4.304904072999889],
              [-80.22194616699997, -4.318960062999906],
              [-80.23220393899996, -4.353996683999924],
              [-80.2396711829999, -4.369809671999931],
              [-80.25540665699987, -4.386759541999936],
              [-80.33230118899988, -4.445670673999942],
              [-80.37325476099988, -4.467581481999986],
              [-80.38286657799989, -4.476263121999949],
              [-80.39074723399995, -4.476986591999946],
              [-80.40849808799996, -4.477503355999886],
              [-80.42511206099988, -4.471508889999953],
              [-80.46996720399997, -4.446084085999942],
              [-80.48353226799995, -4.433991799999959],
              [-80.49229142299993, -4.413011168999958],
              [-80.4885448819999, -4.395957946999928],
              [-80.35630489199988, -4.220568134999965],
              [-80.34527197299988, -4.198450621999967],
              [-80.39141902699993, -4.204135029999918],
              [-80.43472387799989, -4.216950784999895],
              [-80.46960546899996, -4.213230081999882],
              [-80.49076696799992, -4.168995055999872],
              [-80.49068945399989, -4.159693297999937],
              [-80.48683955899995, -4.14067637099987],
              [-80.48717545599993, -4.13127125999992],
              [-80.49260148199991, -4.118455505999933],
              [-80.50906042499989, -4.095821227999892],
              [-80.51407303899995, -4.083418883999911],
              [-80.5122938559999, -4.065033996999929],
              [-80.51221268699993, -4.064195251999891],
              [-80.5035827239999, -4.039080504999959],
              [-80.49198136399994, -4.014895934999899],
              [-80.48107763699988, -3.99877288799992],
              [-80.46614314799993, -3.988127542999919],
              [-80.44769466199992, -3.982753193999955],
              [-80.42746333899993, -3.981306253999961],
              [-80.40710282399988, -3.982443135999887],
              [-80.38645808999988, -3.988954365999945],
              [-80.34426428299992, -4.011588642999897],
              [-80.32550573799992, -4.015412698999938],
              [-80.30462845899984, -4.005180765999867],
              [-80.28780778099988, -3.984406839999906],
              [-80.27328670299991, -3.961255797999925],
              [-80.25907568399987, -3.943685810999852],
              [-80.18114762399989, -3.907925719999923],
              [-80.16525712199987, -3.890045673999879],
              [-80.16507379399991, -3.880695936999885],
              [-80.16505041599993, -3.879503682999911],
              [-80.17109655799996, -3.873612568999903],
              [-80.18006241899991, -3.867824808999927],
              [-80.18876989799986, -3.857696226999892],
              [-80.1914570719999, -3.849117939999942],
              [-80.1914570719999, -3.830617776999929],
              [-80.19272314499995, -3.821626078999884],
              [-80.20155981499994, -3.801472269999906],
              [-80.22163610899989, -3.769432880999901],
              [-80.22631282599986, -3.749279072999926],
              [-80.22445247399986, -3.741630960999942],
              [-80.2201891689999, -3.734706318999955],
              [-80.21685603899991, -3.726954853999956],
              [-80.21786372899996, -3.717136331999896],
              [-80.22398738599992, -3.698429462999911],
              [-80.2249434009999, -3.690677998999902],
              [-80.2249434009999, -3.680652770999885],
              [-80.22328975399995, -3.671867776999889],
              [-80.21677852399998, -3.652437438999911],
              [-80.21520239299994, -3.642515563999922],
              [-80.21639095099997, -3.631560159999935],
              [-80.22212703499991, -3.61243987999994],
              [-80.22228206399987, -3.601277770999914],
              [-80.2249950769999, -3.59187265999995],
              [-80.23367671699987, -3.587841898999955],
              [-80.24354691599984, -3.584637959999981],
              [-80.2499806319999, -3.577713317999908],
              [-80.24990311699989, -3.56996185299991],
              [-80.24212581499995, -3.542986754999973],
              [-80.24026546299987, -3.523866475999881],
              [-80.24029130099987, -3.514047952999917],
              [-80.24266841699992, -3.505159606999896],
              [-80.24907629399985, -3.497924905999923],
              [-80.26556107599993, -3.491103616999879],
              [-80.27163305699989, -3.485522562999961],
              [-80.2738809819999, -3.464645282999896],
              [-80.26778316299993, -3.443871357999939],
              [-80.26566442899986, -3.426404723999894],
              [-80.27974625699997, -3.415552672999951],
              [-80.31762508199998, -3.405527444999919],
              [-80.33390315799988, -3.397052509999924],
              [-80.34072866667043, -3.393497653515368],
              [-80.34288489499994, -3.386325778999947],
              [-80.34410559799994, -3.378838799999926],
              [-80.34105383999992, -3.368584893999923],
              [-80.32762610599991, -3.360528252999927],
              [-80.32144120999993, -3.348728122999944],
              [-80.3164770169999, -3.334730726999908],
              [-80.30687415299991, -3.320733330999929],
              [-80.31700598899994, -3.348809502999927],
              [-80.32054602799991, -3.355564059999949],
              [-80.31432044199994, -3.376071872999944],
              [-80.30231686099995, -3.366794528999947],
              [-80.29670162699995, -3.335381768999923],
              [-80.2864477199999, -3.320733330999929],
              [-80.2591039699999, -3.348077080999929],
              [-80.24551347599993, -3.342380466999941],
              [-80.1731664699999, -3.327569268999923],
              [-80.16071529899995, -3.328789971999925],
              [-80.15249589799993, -3.330824476999908],
              [-80.14517167899993, -3.331231377999927],
              [-80.1355688139999, -3.327569268999923],
              [-80.11278235599991, -3.300713799999926],
              [-80.10826575399994, -3.296807549999926],
              [-80.07046464799993, -3.218194268999923],
              [-80.0598852199999, -3.204034112999921],
              [-80.03750566299993, -3.20826588299991],
              [-80.03286699099993, -3.23211028399993],
              [-80.03994706899994, -3.279880466999941],
              [-80.02920488199993, -3.273532809999949],
              [-80.02257239499994, -3.263848565999922],
              [-80.0169164699999, -3.252699476999908],
              [-80.00894120999993, -3.24187590899993],
              [-79.99982662699995, -3.234633070999962],
              [-79.96800696499992, -3.214613539999959],
              [-79.9531957669999, -3.197442315999922],
              [-79.94347083199995, -3.176527601999908],
              [-79.93797766799992, -3.15398528399993],
              [-79.93333899599992, -3.115411065999922],
              [-79.91706295499995, -3.079278252999927],
              [-79.88341223899994, -3.025485934999949],
              [-79.87486731699994, -3.005466403999947],
              [-79.8848363919999, -2.988051039999959],
              [-79.88121497299994, -2.965427341999941],
              [-79.86803137899994, -2.926364841999941],
              [-79.86583411399994, -2.908786716999941],
              [-79.83458411399994, -2.806817315999922],
              [-79.81346594999991, -2.768975518999923],
              [-79.81118730399993, -2.762383721999925],
              [-79.80138098899994, -2.740980726999908],
              [-79.7976781889999, -2.717705987999921],
              [-79.77643795499995, -2.65943775799991],
              [-79.7649633449999, -2.64226653399993],
              [-79.73497473899994, -2.611586195999962],
              [-79.72642981699994, -2.593845309999949],
              [-79.72508704299992, -2.569756768999923],
              [-79.73151607999995, -2.52507903399993],
              [-79.74502519399994, -2.490166924999926],
              [-79.74828040299991, -2.484633070999962],
              [-79.77017167899993, -2.485935153999947],
              [-79.78148352799991, -2.484958591999941],
              [-79.78954016799992, -2.481052341999941],
              [-79.80162512899994, -2.46257903399993],
              [-79.82091223899994, -2.408949476999908],
              [-79.83340410099993, -2.389255466999941],
              [-79.83946692599994, -2.377048434999949],
              [-79.84129798099991, -2.362888278999947],
              [-79.84044348899994, -2.304620049999926],
              [-79.84715735599991, -2.258070570999962],
              [-79.84756425699993, -2.245049737999921],
              [-79.84142005099994, -2.223077080999929],
              [-79.83983313699991, -2.209567966999941],
              [-79.84447180899991, -2.203545830999929],
              [-79.84609941299993, -2.199476820999962],
              [-79.85879472599993, -2.182386976999908],
              [-79.86188717399995, -2.179620049999926],
              [-79.86339270699995, -2.172784112999921],
              [-79.86636308499993, -2.167738539999959],
              [-79.86864173099991, -2.160902601999908],
              [-79.86803137899994, -2.148858330999929],
              [-79.86302649599992, -2.137872002999927],
              [-79.85643469999991, -2.129327080999929],
              [-79.85411536399994, -2.120293877999927],
              [-79.86188717399995, -2.108005466999941],
              [-79.84642493399991, -2.091729424999926],
              [-79.83063717399995, -2.087090752999927],
              [-79.81834876199991, -2.079847914999959],
              [-79.81346594999991, -2.056410414999959],
              [-79.80589758999992, -2.045179945999962],
              [-79.78937740799995, -2.037692966999941],
              [-79.77285722599993, -2.02662525799991],
              [-79.76561438699991, -2.004978122999944],
              [-79.82494055899991, -2.038669528999947],
              [-79.8313695949999, -2.043552341999941],
              [-79.83397376199991, -2.052341403999947],
              [-79.83458411399994, -2.07000090899993],
              [-79.84190833199995, -2.073174737999921],
              [-79.8743383449999, -2.075372002999927],
              [-79.88170325399994, -2.083754164999959],
              [-79.88341223899994, -2.091566664999959],
              [-79.89195716099994, -2.115899346999925],
              [-79.9004613919999, -2.15593840899993],
              [-79.90184485599991, -2.18482838299991],
              [-79.89574133999992, -2.213799737999921],
              [-79.8653051419999, -2.266778252999927],
              [-79.86302649599992, -2.297133070999962],
              [-79.87857011599993, -2.49187590899993],
              [-79.88914954299992, -2.53248463299991],
              [-79.89610755099994, -2.543389580999929],
              [-79.92349199099993, -2.57390715899993],
              [-79.93321692599994, -2.580254815999922],
              [-79.94933020699995, -2.585137627999927],
              [-79.98399817599994, -2.60515715899993],
              [-79.99840247299994, -2.608168226999908],
              [-80.00845292899993, -2.60320403399993],
              [-80.01431230399993, -2.589776299999926],
              [-80.0222875639999, -2.587090752999927],
              [-80.04369055899991, -2.589450778999947],
              [-80.0508520169999, -2.587009372999944],
              [-80.06358801999994, -2.577243747999944],
              [-80.06891842399995, -2.560804945999962],
              [-80.05553137899994, -2.545179945999962],
              [-80.02570553299995, -2.52507903399993],
              [-80.01659094999991, -2.504082940999922],
              [-80.01211503799993, -2.489027601999908],
              [-80.00177975199995, -2.48015715899993],
              [-79.97484290299991, -2.477227471999925],
              [-79.96849524599992, -2.481377862999921],
              [-79.96251380099994, -2.48992278399993],
              [-79.95494544199994, -2.497653903999947],
              [-79.94375566299993, -2.498304945999962],
              [-79.93419348899994, -2.492608330999929],
              [-79.92967688699991, -2.484144789999959],
              [-79.93040930899991, -2.47389088299991],
              [-79.9363500639999, -2.462985934999949],
              [-79.94082597599993, -2.483982028999947],
              [-79.95433508999992, -2.479587497999944],
              [-79.97793535099993, -2.45671965899993],
              [-79.99986731699994, -2.459242445999962],
              [-80.01984615799995, -2.469414971999925],
              [-80.03433183499993, -2.47389088299991],
              [-80.03994706899994, -2.459893487999921],
              [-80.03575598899994, -2.437920830999929],
              [-80.01695716099994, -2.395196221999925],
              [-80.01268469999991, -2.371189059999949],
              [-80.00894120999993, -2.358819268999923],
              [-79.99990800699993, -2.353936455999929],
              [-79.98851477799991, -2.351739190999922],
              [-79.97793535099993, -2.347426039999959],
              [-79.97036699099993, -2.339613539999959],
              [-79.9500219389999, -2.307224216999941],
              [-79.95921790299991, -2.309665622999944],
              [-79.96434485599991, -2.312758070999962],
              [-79.97484290299991, -2.323663018999923],
              [-79.98314368399991, -2.327080987999921],
              [-80.00340735599991, -2.32545338299991],
              [-80.01268469999991, -2.326429945999962],
              [-80.02399654899995, -2.334161065999922],
              [-80.03286699099993, -2.346368096999925],
              [-80.07603919199994, -2.457696221999925],
              [-80.14427649599992, -2.553317966999941],
              [-80.1751195949999, -2.586683851999908],
              [-80.20759029899995, -2.600762627999927],
              [-80.21507727799991, -2.613864841999941],
              [-80.22256425699993, -2.623223565999922],
              [-80.23180091099994, -2.628676039999959],
              [-80.24136308499993, -2.628513278999947],
              [-80.24657141799992, -2.624444268999923],
              [-80.25031490799995, -2.618259372999944],
              [-80.25536048099991, -2.611586195999962],
              [-80.27000891799992, -2.605075778999947],
              [-80.27961178299995, -2.61256275799991],
              [-80.28311113199993, -2.629082940999922],
              [-80.27961178299995, -2.649183851999908],
              [-80.27578691299993, -2.652113539999959],
              [-80.24852454299992, -2.679864190999922],
              [-80.24502519399994, -2.688164971999925],
              [-80.24425208199995, -2.699476820999962],
              [-80.2454320949999, -2.721123955999929],
              [-80.25548255099994, -2.730238539999959],
              [-80.27843176999994, -2.727146091999941],
              [-80.32054602799991, -2.71062590899993],
              [-80.36278235599991, -2.674737237999921],
              [-80.37751217399995, -2.666436455999929],
              [-80.39045162699995, -2.653741143999923],
              [-80.39631100199995, -2.649183851999908],
              [-80.40257727799991, -2.647393487999921],
              [-80.42039954299992, -2.644952080999929],
              [-80.42979895699995, -2.642347914999959],
              [-80.46788489499994, -2.617933851999908],
              [-80.57408606699994, -2.492852471999925],
              [-80.65664628799993, -2.415785414999959],
              [-80.68886411199992, -2.405296028999942],
              [-80.71805255999993, -2.391256953999914],
              [-80.75051539499992, -2.392357752999942],
              [-80.80345618399991, -2.374769789999959],
              [-80.82188880099994, -2.366387627999927],
              [-80.86392167899993, -2.329278252999927],
              [-80.88597571499992, -2.320896091999941],
              [-80.90172278599994, -2.321058851999908],
              [-80.91364498599995, -2.318780205999929],
              [-80.9212133449999, -2.309747002999927],
              [-80.92711341099994, -2.275974216999941],
              [-80.93480383999992, -2.260918877999927],
              [-80.95116126199991, -2.23756275799991],
              [-80.96499589799993, -2.223321221999925],
              [-81.00206458199995, -2.193617445999962],
              [-81.00617428299995, -2.18718840899993],
              [-81.01089433499993, -2.176690362999921],
              [-81.0130102199999, -2.166924737999921],
              [-81.00918535099993, -2.162530205999929],
              [-81.00121008999992, -2.164483330999929],
              [-80.99754798099991, -2.168715101999908],
              [-80.9954320949999, -2.173435153999947],
              [-80.99209550699993, -2.176202080999929],
              [-80.96666419199994, -2.182305596999925],
              [-80.95466061099995, -2.183038018999923],
              [-80.94933020699995, -2.186211846999925],
              [-80.9442953059999, -2.203276790999951],
              [-80.93128631899992, -2.217333015999941],
              [-80.9063429229999, -2.216258380999932],
              [-80.8705725499999, -2.203300895999917],
              [-80.81966152899992, -2.16226791899993],
              [-80.78070235699994, -2.142843412999923],
              [-80.74497918999992, -2.102914607999935],
              [-80.73744665699991, -2.043497173999924],
              [-80.75155230899992, -2.01320202799991],
              [-80.75951087099992, -1.982028903999947],
              [-80.7625219389999, -1.97389088299991],
              [-80.75807680499992, -1.963458463999928],
              [-80.74725887199992, -1.961306621999938],
              [-80.73318504399992, -1.953769676999912],
              [-80.73021399599992, -1.92937590899993],
              [-80.73302161399994, -1.90398528399993],
              [-80.76057227399991, -1.797547836999911],
              [-80.77562415299991, -1.755466403999947],
              [-80.78213456899994, -1.736993096999925],
              [-80.79092363199993, -1.721612237999921],
              [-80.80036373599995, -1.710137627999927],
              [-80.81224524599992, -1.691582940999922],
              [-80.83576412699995, -1.633558851999908],
              [-80.84951738199993, -1.615817966999941],
              [-80.85407467399995, -1.602959893999923],
              [-80.85558020699995, -1.588311455999929],
              [-80.85155188699991, -1.576918226999908],
              [-80.81648955599991, -1.552254752999943],
              [-80.82079016799992, -1.528903903999947],
              [-80.82054602799991, -1.499932549999926],
              [-80.81152079499992, -1.491621345999931],
              [-80.79962449899995, -1.480804758999909],
              [-80.78736971699993, -1.477706595999962],
              [-80.77086166499993, -1.477829952999912],
              [-80.76653414599991, -1.46488020299995],
              [-80.76704284099992, -1.450601601999949],
              [-80.76490687499995, -1.431131261999951],
              [-80.75978246199992, -1.413859530999957],
              [-80.76429015999992, -1.390887025999916],
              [-80.7600160369999, -1.376596628999948],
              [-80.74266293699992, -1.368161967999924],
              [-80.74425633599992, -1.343773381999938],
              [-80.77404088999992, -1.302542716999938],
              [-80.83358911199991, -1.231234576999952],
              [-80.8821508449999, -1.14576588299991],
              [-80.90324857699994, -1.094778514999916],
              [-80.91618021799991, -1.065524767999932],
              [-80.90961091499992, -1.044915051999908],
              [-80.89753888599995, -1.032872908999934],
              [-80.88351289799994, -1.021009453999909],
              [-80.87051183799991, -1.006936589999953],
              [-80.86287121499993, -0.997150887999908],
              [-80.85529091399991, -0.987413462999939],
              [-80.84235965699992, -0.973397790999911],
              [-80.83044574199994, -0.959330922999925],
              [-80.82718637599993, -0.950673189999918],
              [-80.8163651989999, -0.946343556999921],
              [-80.80227927199991, -0.95063633399991],
              [-80.78820442599994, -0.950615022999955],
              [-80.77413810199994, -0.941956099999913],
              [-80.76116686099994, -0.93655072599995],
              [-80.74602239599994, -0.939774388999922],
              [-80.73413742299994, -0.935453456999937],
              [-80.72224517699993, -0.931125513999916],
              [-80.72437466899993, -0.939885310999955],
              [-80.70600196499993, -0.94851514599992],
              [-80.69087493099994, -0.949588742999936],
              [-80.6789623759999, -0.939261472999931],
              [-80.67140005499994, -0.936020513999949],
              [-80.6638416699999, -0.926304456999958],
              [-80.65304171999992, -0.923064662999934],
              [-80.64332184299991, -0.937097954999956],
              [-80.63468061599991, -0.939254297999923],
              [-80.6163203989999, -0.941408096999908],
              [-80.59148470799994, -0.93168821799992],
              [-80.56988313499994, -0.912242570999922],
              [-80.54721196199995, -0.888489750999952],
              [-80.53282630099994, -0.826267184999949],
              [-80.52904212099992, -0.806735934999949],
              [-80.5159119139999, -0.742090066999936],
              [-80.49756162599994, -0.692437544999962],
              [-80.47489948299994, -0.647113444999945],
              [-80.46247311099995, -0.617933851999908],
              [-80.45760986899995, -0.612543677999952],
              [-80.44896909699992, -0.60606015299993],
              [-80.43493099799991, -0.60389805899996],
              [-80.42199164699991, -0.599599732999934],
              [-80.41983869299992, -0.62551297899995],
              [-80.40582460299993, -0.646034024999949],
              [-80.37879806299992, -0.657885419999957],
              [-80.35287163099991, -0.661117855999919],
              [-80.29900694999992, -0.66222862099994],
              [-80.29899604999991, -0.650355188999924],
              [-80.32694953299995, -0.642759213999909],
              [-80.35717556499992, -0.636277967999945],
              [-80.37770089799994, -0.636283700999911],
              [-80.39173722899994, -0.625486672999955],
              [-80.40253840999992, -0.597418192999953],
              [-80.4155596409999, -0.573753469999929],
              [-80.4295829969999, -0.568350740999961],
              [-80.43712541999992, -0.557538114999943],
              [-80.43821881999992, -0.533825280999906],
              [-80.44897657199994, -0.505675044999919],
              [-80.45205644399994, -0.476739190999922],
              [-80.4662389099999, -0.445170709999957],
              [-80.48459650899991, -0.423590783999941],
              [-80.49646354799995, -0.381374052999945],
              [-80.48565043199994, -0.367220490999955],
              [-80.46515615099992, -0.365253926999912],
              [-80.43272473999991, -0.339187023999955],
              [-80.40146946499993, -0.291919569999948],
              [-80.39134680899991, -0.274346612999921],
              [-80.38878333199995, -0.260837497999944],
              [-80.37988294999991, -0.239015817999928],
              [-80.37123233499995, -0.222830502999955],
              [-80.34965820699995, -0.215264482999942],
              [-80.33669524699991, -0.19475603199993],
              [-80.32369525199994, -0.173172607999959],
              [-80.30535045599993, -0.189366935999942],
              [-80.28372267899994, -0.178574946999959],
              [-80.25994325599993, -0.160218461999932],
              [-80.2318478599999, -0.139698740999961],
              [-80.17233461199993, -0.074876502999928],
              [-80.12482662699995, -0.013604424999926],
              [-80.10789954299992, 0.007066148000092],
              [-80.10081946499992, 0.026922919000071],
              [-80.09878495999993, 0.039211330000057],
              [-80.0938207669999, 0.043443101000094],
              [-80.08726966099994, 0.045599677000041],
              [-80.06645895699995, 0.052209779000066],
              [-80.05134909199995, 0.089992461000065],
              [-80.04272047699993, 0.123460201000057],
              [-80.03697669199994, 0.175970770000049],
              [-80.0384008449999, 0.200018622000073],
              [-80.0462133449999, 0.242621161000045],
              [-80.04849199099993, 0.318304755000042],
              [-80.03937740799995, 0.344712632000039],
              [-80.03905188699991, 0.353338934000078],
              [-80.03652910099993, 0.357082424000055],
              [-80.02570553299995, 0.35187409100007],
              [-80.02110755099994, 0.346909898000092],
              [-80.01732337099992, 0.339544989000046],
              [-80.01268469999991, 0.32453034100007],
              [-80.00523841099994, 0.32453034100007],
              [-80.00373287699995, 0.337062893000052],
              [-79.9934789699999, 0.356634833000044],
              [-79.99095618399991, 0.365464585000041],
              [-79.99331620999993, 0.378119208000044],
              [-79.99913489499994, 0.386908270000049],
              [-80.01268469999991, 0.400213934000078],
              [-80.0364477199999, 0.439154364000046],
              [-80.04356848899994, 0.458929755000042],
              [-80.0462133449999, 0.479071356000077],
              [-80.04336503799993, 0.501206773000092],
              [-80.0364477199999, 0.512681382000039],
              [-80.02757727799991, 0.52212148600006],
              [-80.01891028599994, 0.538031317000048],
              [-80.01695716099994, 0.55890534100007],
              [-80.02236894399994, 0.579169012000079],
              [-80.02953040299991, 0.596625067000048],
              [-80.03636633999992, 0.625230210000041],
              [-80.04539954299992, 0.637152411000045],
              [-80.05943762899994, 0.644680080000057],
              [-80.07750403599994, 0.647284247000073],
              [-80.09032141799992, 0.652167059000078],
              [-80.09919186099995, 0.664211330000057],
              [-80.10496985599991, 0.679673570000091],
              [-80.10826575399994, 0.695054429000038],
              [-80.10863196499992, 0.738104559000078],
              [-80.09727942599994, 0.780340887000079],
              [-80.07583574099993, 0.816148179000038],
              [-80.0462133449999, 0.839667059000078],
              [-80.02912350199995, 0.831040757000039],
              [-80.0144750639999, 0.829291083000044],
              [-79.98131262899994, 0.832220770000049],
              [-79.96642005099994, 0.836493231000077],
              [-79.94676673099991, 0.854803778000075],
              [-79.93321692599994, 0.858954169000071],
              [-79.91893469999991, 0.861232815000051],
              [-79.8938695949999, 0.871039130000042],
              [-79.86217200399994, 0.87641022300005],
              [-79.84333248599995, 0.890570380000042],
              [-79.83079993399991, 0.893744208000044],
              [-79.82339433499993, 0.897447007000039],
              [-79.79295813699991, 0.921616929000038],
              [-79.78575598899994, 0.929185289000088],
              [-79.77293860599991, 0.947821356000077],
              [-79.76561438699991, 0.955145575000074],
              [-79.74181067599994, 0.965969143000052],
              [-79.68195553299995, 0.984930731000077],
              [-79.65575110599991, 1.003607489000046],
              [-79.65038001199991, 0.993353583000044],
              [-79.64997311099995, 0.984198309000078],
              [-79.67007402299993, 0.921616929000038],
              [-79.66543535099993, 0.906683661000045],
              [-79.65713456899994, 0.897935289000088],
              [-79.64663652299993, 0.890692450000074],
              [-79.63532467399995, 0.880072333000044],
              [-79.62189693899995, 0.852932033000059],
              [-79.61485755099994, 0.845282294000071],
              [-79.63121497299994, 0.890122789000088],
              [-79.64411373599995, 0.901068427000041],
              [-79.64830481699994, 0.907416083000044],
              [-79.64826412699995, 0.912990627000056],
              [-79.64313717399995, 0.92218659100007],
              [-79.64216061099995, 0.927883205000057],
              [-79.64366614499994, 0.952948309000078],
              [-79.64142818899995, 0.971991278000075],
              [-79.63267981699994, 0.986029364000046],
              [-79.61485755099994, 0.996079820000091],
              [-79.57176673099991, 0.983710028000075],
              [-79.52448482999995, 1.010443427000041],
              [-79.45653235599991, 1.072455145000049],
              [-79.43504798099991, 1.078029690000051],
              [-79.36465410099993, 1.072455145000049],
              [-79.35594641799992, 1.07453034100007],
              [-79.33315995999993, 1.083482164000088],
              [-79.32339433499993, 1.085516669000071],
              [-79.29605058499993, 1.085028387000079],
              [-79.28343665299991, 1.087103583000044],
              [-79.27220618399991, 1.092962958000044],
              [-79.24815833199995, 1.080267645000049],
              [-79.21983801999994, 1.084214585000041],
              [-79.19115149599992, 1.094142971000053],
              [-79.16576087099992, 1.099798895000049],
              [-79.14732825399994, 1.109564520000049],
              [-79.07184811099995, 1.209540106000077],
              [-79.05724036399994, 1.21751536700009],
              [-79.03258216099994, 1.209051825000074],
              [-79.01305091099994, 1.192775783000059],
              [-79.00047766799992, 1.172308661000045],
              [-78.99376380099994, 1.14789459800005],
              [-78.99168860599991, 1.119696356000077],
              [-78.97256425699993, 1.129828192000048],
              [-78.96214758999992, 1.144680080000057],
              [-78.95775305899991, 1.163397528000075],
              [-78.95457923099991, 1.20734284100007],
              [-78.94839433499993, 1.218817450000074],
              [-78.9395238919999, 1.22797272300005],
              [-78.92894446499992, 1.243150132000039],
              [-78.92564856699994, 1.234605210000041],
              [-78.91978919199994, 1.230658270000049],
              [-78.91169186099995, 1.231268622000073],
              [-78.9016820949999, 1.236314195000091],
              [-78.8926488919999, 1.24477773600006],
              [-78.89122473899994, 1.251857815000051],
              [-78.89167232999995, 1.259711005000042],
              [-78.8880102199999, 1.270453192000048],
              [-78.87169348899994, 1.288967190000051],
              [-78.85505123599995, 1.29165273600006],
              [-78.81285559799994, 1.277289130000042],
              [-78.82013912699995, 1.29173411700009],
              [-78.83804277299993, 1.296454169000071],
              [-78.85895748599995, 1.298570054000038],
              [-78.87498938699991, 1.305243231000077],
              [-78.88194739499994, 1.319281317000048],
              [-78.87848873599995, 1.332464911000045],
              [-78.86969967399995, 1.344142971000053],
              [-78.83234615799995, 1.381333726000094],
              [-78.82656816299993, 1.394598700000074],
              [-78.82701575399994, 1.409735419000071],
              [-78.83055579299992, 1.423325914000088],
              [-78.82868404899995, 1.43431224200009],
            ],
          ],
          [
            [
              [-80.0598852199999, -2.662774346999925],
              [-80.01451575399994, -2.664239190999922],
              [-79.94579016799992, -2.706638278999947],
              [-79.90282141799992, -2.717461846999925],
              [-79.90440833199995, -2.725192966999941],
              [-79.90721594999991, -2.732354424999926],
              [-79.91124426999994, -2.738864841999941],
              [-79.91649329299992, -2.744805596999925],
              [-79.92764238199993, -2.754164320999962],
              [-79.97793535099993, -2.775811455999929],
              [-79.98110917899993, -2.784600518999923],
              [-79.99518795499995, -2.798028252999927],
              [-79.99840247299994, -2.803399346999925],
              [-80.00446529899995, -2.818780205999929],
              [-80.01268469999991, -2.834161065999922],
              [-80.02098548099991, -2.842868747999944],
              [-80.02310136599993, -2.84303150799991],
              [-80.03370921499993, -2.861226874999943],
              [-80.04571553799991, -2.885232936999955],
              [-80.05832398399991, -2.908038894999947],
              [-80.06492918499993, -2.924243592999915],
              [-80.08115258099991, -2.930851659999917],
              [-80.09437160899995, -2.94586165599992],
              [-80.09376325599993, -2.969266838999943],
              [-80.10899817599994, -2.983575127999927],
              [-80.11510169199994, -2.997979424999926],
              [-80.13103311999993, -3.020920851999961],
              [-80.1668188139999, -3.017347914999959],
              [-80.18675696499992, -3.02898528399993],
              [-80.20372473899994, -3.034112237999921],
              [-80.22809811099995, -3.032159112999921],
              [-80.25157630099994, -3.026055596999925],
              [-80.26593990799995, -3.018487237999921],
              [-80.27185378199994, -2.996405234999941],
              [-80.26579825999994, -2.960953252999957],
              [-80.26220378999994, -2.840848014999949],
              [-80.25865637899994, -2.827325127999927],
              [-80.22496497299994, -2.76531340899993],
              [-80.21068274599992, -2.724867445999962],
              [-80.19640051999994, -2.714613539999959],
              [-80.1355688139999, -2.69695403399993],
              [-80.0808813139999, -2.669854424999926],
              [-80.0598852199999, -2.662774346999925],
            ],
          ],
          [
            [
              [-89.66128495999993, -1.340101820999962],
              [-89.63467363199993, -1.348809502999927],
              [-89.6145727199999, -1.370049737999921],
              [-89.61327063699991, -1.391696872999944],
              [-89.64329993399991, -1.40162525799991],
              [-89.67609615799995, -1.397556247999944],
              [-89.75690670499995, -1.36060963299991],
              [-89.7363988919999, -1.340101820999962],
              [-89.72069251199991, -1.343194268999923],
              [-89.67369544199994, -1.342543226999908],
              [-89.66128495999993, -1.340101820999962],
            ],
          ],
          [
            [
              [-90.38068600199995, -1.254489841999941],
              [-90.37852942599994, -1.257256768999923],
              [-90.3738500639999, -1.260430596999925],
              [-90.36900794199994, -1.26490650799991],
              [-90.36636308499993, -1.271905205999929],
              [-90.36705481699994, -1.278741143999923],
              [-90.36949622299994, -1.282647393999923],
              [-90.37197831899994, -1.285414320999962],
              [-90.37319902299993, -1.288669528999947],
              [-90.37588456899994, -1.292413018999923],
              [-90.38898678299995, -1.29615650799991],
              [-90.39370683499993, -1.29851653399993],
              [-90.39476477799991, -1.302911065999922],
              [-90.39289303299995, -1.315036716999941],
              [-90.39370683499993, -1.31959400799991],
              [-90.39932206899994, -1.32586028399993],
              [-90.43211829299992, -1.345961195999962],
              [-90.43862870999993, -1.347426039999959],
              [-90.47520911399994, -1.342054945999962],
              [-90.48949133999992, -1.331638278999947],
              [-90.50316321499992, -1.318291924999926],
              [-90.52403723899994, -1.30592213299991],
              [-90.51480058499993, -1.295586846999925],
              [-90.50621497299994, -1.282403252999927],
              [-90.49986731699994, -1.268161716999941],
              [-90.49323482999995, -1.23796965899993],
              [-90.48346920499995, -1.222263278999947],
              [-90.47191321499992, -1.216729424999926],
              [-90.46255449099993, -1.230889580999929],
              [-90.4426977199999, -1.225681247999944],
              [-90.4153539699999, -1.231133721999925],
              [-90.39110266799992, -1.242445570999962],
              [-90.38068600199995, -1.254489841999941],
            ],
          ],
          [
            [
              [-89.30809485599991, -0.685642184999949],
              [-89.29564368399991, -0.693454684999949],
              [-89.28258216099994, -0.693291924999926],
              [-89.26943925699993, -0.688246351999908],
              [-89.25719153599994, -0.681573174999926],
              [-89.25479081899994, -0.719170830999929],
              [-89.27318274599992, -0.759942315999922],
              [-89.30211341099994, -0.795993747999944],
              [-89.33169511599993, -0.819431247999944],
              [-89.36729895699995, -0.82976653399993],
              [-89.37267005099994, -0.836114190999922],
              [-89.37458248599995, -0.845472914999959],
              [-89.38634192599994, -0.874607028999947],
              [-89.40660559799994, -0.905043226999908],
              [-89.42003333199995, -0.919366143999923],
              [-89.43472245999993, -0.929294528999947],
              [-89.45030676999994, -0.934258721999925],
              [-89.46556555899991, -0.935967705999929],
              [-89.49962317599994, -0.935479424999926],
              [-89.50999915299991, -0.93873463299991],
              [-89.53075110599991, -0.953301690999922],
              [-89.54458574099993, -0.956638278999947],
              [-89.55431067599994, -0.953708591999941],
              [-89.57591712099992, -0.940036716999941],
              [-89.58556067599994, -0.935479424999926],
              [-89.62120520699995, -0.930271091999941],
              [-89.62995357999995, -0.925876559999949],
              [-89.63141842399995, -0.916680596999925],
              [-89.62511145699995, -0.90593840899993],
              [-89.61290442599994, -0.891045830999929],
              [-89.60460364499994, -0.883070570999962],
              [-89.56480872299994, -0.864190362999921],
              [-89.55142167899993, -0.853610934999949],
              [-89.54088294199994, -0.819431247999944],
              [-89.53050696499992, -0.818291924999926],
              [-89.48892167899993, -0.808200778999947],
              [-89.47720292899993, -0.796807549999926],
              [-89.46202551999994, -0.764743747999944],
              [-89.45303300699993, -0.75318775799991],
              [-89.42662512899994, -0.728285414999959],
              [-89.42105058499993, -0.719821872999944],
              [-89.41323808499993, -0.713474216999941],
              [-89.37718665299991, -0.700290622999944],
              [-89.36644446499992, -0.689629815999922],
              [-89.35118567599994, -0.688897393999923],
              [-89.32022050699993, -0.680759372999944],
              [-89.30809485599991, -0.685642184999949],
            ],
          ],
          [
            [
              [-90.19196529899995, -0.538262627999927],
              [-90.18053137899994, -0.54851653399993],
              [-90.18297278599994, -0.572035414999959],
              [-90.19570878799993, -0.613946221999925],
              [-90.19522050699993, -0.625746351999908],
              [-90.18960527299993, -0.64031340899993],
              [-90.18822180899991, -0.651543877999927],
              [-90.19058183499993, -0.654392184999949],
              [-90.19920813699991, -0.676364841999941],
              [-90.19880123599995, -0.681573174999926],
              [-90.21556555899991, -0.688246351999908],
              [-90.22765051999994, -0.703871351999908],
              [-90.23818925699993, -0.722263278999947],
              [-90.25035559799994, -0.736911716999941],
              [-90.25951087099992, -0.743340752999927],
              [-90.26475989499994, -0.745049737999921],
              [-90.31362870999993, -0.74382903399993],
              [-90.31859290299991, -0.747165622999944],
              [-90.32384192599994, -0.76685963299991],
              [-90.33706620999993, -0.776950778999947],
              [-90.3548070949999, -0.779880466999941],
              [-90.37319902299993, -0.778415622999944],
              [-90.40729732999995, -0.766696872999944],
              [-90.42886308499993, -0.762465101999908],
              [-90.43553626199991, -0.757582289999959],
              [-90.44029700399994, -0.752699476999908],
              [-90.44554602799991, -0.750583591999941],
              [-90.45303300699993, -0.74382903399993],
              [-90.47435462099992, -0.71257903399993],
              [-90.48306230399993, -0.702732028999947],
              [-90.49767005099994, -0.70435963299991],
              [-90.51634680899991, -0.699965101999908],
              [-90.53380286399994, -0.691827080999929],
              [-90.54454505099994, -0.681573174999926],
              [-90.54625403599994, -0.668877862999921],
              [-90.54454505099994, -0.620212497999944],
              [-90.53868567599994, -0.594170830999929],
              [-90.52757727799991, -0.569919528999947],
              [-90.51309160099993, -0.548760674999926],
              [-90.4973852199999, -0.531996351999908],
              [-90.48770097599993, -0.525485934999949],
              [-90.46056067599994, -0.513848565999922],
              [-90.44896399599992, -0.510918877999927],
              [-90.43805904899995, -0.511325778999947],
              [-90.41551673099991, -0.516778252999927],
              [-90.40794837099992, -0.517754815999922],
              [-90.3985082669999, -0.515069268999923],
              [-90.38711503799993, -0.50750090899993],
              [-90.38068600199995, -0.504652601999908],
              [-90.28587805899991, -0.493910414999959],
              [-90.26398678299995, -0.483005466999941],
              [-90.25845292899993, -0.485121351999908],
              [-90.25251217399995, -0.488539320999962],
              [-90.24697831899994, -0.492771091999941],
              [-90.24282792899993, -0.497247002999927],
              [-90.24063066299993, -0.507012627999927],
              [-90.24156653599994, -0.518487237999921],
              [-90.24058997299994, -0.528008721999925],
              [-90.23298092399995, -0.531996351999908],
              [-90.22276770699995, -0.53289153399993],
              [-90.20311438699991, -0.537286065999922],
              [-90.19196529899995, -0.538262627999927],
            ],
          ],
          [
            [
              [-91.40111243399991, -0.452894789999959],
              [-91.41087805899991, -0.458428643999923],
              [-91.4800512359999, -0.486260674999926],
              [-91.49742591099994, -0.48992278399993],
              [-91.50755774599992, -0.490411065999922],
              [-91.51695716099994, -0.487237237999921],
              [-91.53819739499994, -0.473077080999929],
              [-91.5567113919999, -0.468357028999947],
              [-91.58665930899991, -0.45631275799991],
              [-91.5913793609999, -0.455661716999941],
              [-91.60187740799995, -0.456963799999926],
              [-91.60651607999995, -0.45631275799991],
              [-91.6113988919999, -0.45281340899993],
              [-91.61156165299991, -0.449639580999929],
              [-91.61082923099991, -0.446221612999921],
              [-91.6133520169999, -0.441989841999941],
              [-91.63052324099993, -0.424004815999922],
              [-91.64366614499994, -0.40357838299991],
              [-91.65196692599994, -0.381117445999962],
              [-91.65868079299992, -0.33521900799991],
              [-91.67137610599991, -0.297539971999925],
              [-91.66856848899994, -0.284926039999959],
              [-91.58096269399994, -0.287204684999949],
              [-91.54381262899994, -0.268243096999925],
              [-91.49730383999992, -0.257582289999959],
              [-91.4741918609999, -0.24928150799991],
              [-91.46739661399994, -0.250420830999929],
              [-91.45567786399994, -0.257582289999959],
              [-91.42088782499991, -0.293064059999949],
              [-91.41161048099991, -0.298597914999959],
              [-91.39952551999994, -0.30787525799991],
              [-91.39683997299994, -0.329034112999921],
              [-91.40111243399991, -0.36687590899993],
              [-91.40111243399991, -0.452894789999959],
            ],
          ],
          [
            [
              [-90.56501217399995, -0.284926039999959],
              [-90.55150305899991, -0.292738539999959],
              [-90.55817623599995, -0.310804945999962],
              [-90.57925370999993, -0.34303150799991],
              [-90.58678137899994, -0.363702080999929],
              [-90.60488847599993, -0.369805596999925],
              [-90.62751217399995, -0.36687590899993],
              [-90.67027747299994, -0.353936455999929],
              [-90.74006100199995, -0.353936455999929],
              [-90.75938880099994, -0.347832940999922],
              [-90.77717037699995, -0.336683851999908],
              [-90.79588782499991, -0.330661716999941],
              [-90.81822669199994, -0.339613539999959],
              [-90.8321020169999, -0.322686455999929],
              [-90.83861243399991, -0.297051690999922],
              [-90.8489477199999, -0.275648695999962],
              [-90.87413489499994, -0.271254164999959],
              [-90.83165442599994, -0.212660414999959],
              [-90.82909094999991, -0.199314059999949],
              [-90.83507239499994, -0.181573174999926],
              [-90.82681230399993, -0.164157809999949],
              [-90.81037350199995, -0.151299737999921],
              [-90.79157467399995, -0.14771900799991],
              [-90.78433183499993, -0.153008721999925],
              [-90.78136145699995, -0.152601820999962],
              [-90.77725175699993, -0.14771900799991],
              [-90.75755774599992, -0.16179778399993],
              [-90.68932044199994, -0.18482838299991],
              [-90.66494706899994, -0.18873463299991],
              [-90.63247636599993, -0.201267184999949],
              [-90.58043372299994, -0.259698174999926],
              [-90.55199133999992, -0.278090101999908],
              [-90.55626380099994, -0.279066664999959],
              [-90.55890865799995, -0.280450127999927],
              [-90.56501217399995, -0.284926039999959],
            ],
          ],
          [
            [
              [-90.81143144399994, -0.730645440999922],
              [-90.80211341099994, -0.735528252999927],
              [-90.79596920499995, -0.735528252999927],
              [-90.79259192599994, -0.738946221999925],
              [-90.79157467399995, -0.754001559999949],
              [-90.79653886599993, -0.759942315999922],
              [-90.82066809799994, -0.769789320999962],
              [-90.82909094999991, -0.77467213299991],
              [-90.86046301999994, -0.872653903999947],
              [-90.85655676999994, -0.897149346999925],
              [-90.85863196499992, -0.915459893999923],
              [-90.88027910099993, -0.908786716999941],
              [-90.8919164699999, -0.92546965899993],
              [-90.9175512359999, -0.954196872999944],
              [-90.92870032499991, -0.970310153999947],
              [-90.94562740799995, -0.962497653999947],
              [-90.96214758999992, -0.960870049999926],
              [-90.99388587099992, -0.963474216999941],
              [-91.01305091099994, -0.968682549999926],
              [-91.04515540299991, -0.992282809999949],
              [-91.15977942599994, -1.030205987999921],
              [-91.18199622299994, -1.024834893999923],
              [-91.19741777299993, -1.029554945999962],
              [-91.28726152299993, -1.01685963299991],
              [-91.3997289699999, -1.018487237999921],
              [-91.42080644399994, -1.011814059999949],
              [-91.43586178299995, -0.997491143999923],
              [-91.44017493399991, -0.986993096999925],
              [-91.44196529899995, -0.97625090899993],
              [-91.44200598899994, -0.95281340899993],
              [-91.44579016799992, -0.941501559999949],
              [-91.45498613199993, -0.938653252999927],
              [-91.46654212099992, -0.938571872999944],
              [-91.47740637899994, -0.935479424999926],
              [-91.50230872299994, -0.896254164999959],
              [-91.49323482999995, -0.850681247999944],
              [-91.46589107999995, -0.80787525799991],
              [-91.43586178299995, -0.778415622999944],
              [-91.3191625639999, -0.702732028999947],
              [-91.31387285099993, -0.69459400799991],
              [-91.31387285099993, -0.687920830999929],
              [-91.31045488199993, -0.68328215899993],
              [-91.29491126199991, -0.681573174999926],
              [-91.26952063699991, -0.671075127999927],
              [-91.23477128799993, -0.661879164999959],
              [-91.22297115799995, -0.661716403999947],
              [-91.21198482999995, -0.664727471999925],
              [-91.20567786399994, -0.669040622999944],
              [-91.20132402299993, -0.673028252999927],
              [-91.19619706899994, -0.676039320999962],
              [-91.17886308499993, -0.681898695999962],
              [-91.16808020699995, -0.682712497999944],
              [-91.1577856109999, -0.678806247999944],
              [-91.15265865799995, -0.672784112999921],
              [-91.14305579299992, -0.65789153399993],
              [-91.13756262899994, -0.654880466999941],
              [-91.13731848899994, -0.644301039999959],
              [-91.12832597599993, -0.623467705999929],
              [-91.11436926999994, -0.608005466999941],
              [-91.09943600199995, -0.613946221999925],
              [-91.08751380099994, -0.597426039999959],
              [-91.08678137899994, -0.582452080999929],
              [-91.09422766799992, -0.569431247999944],
              [-91.10684160099993, -0.558689059999949],
              [-91.12018795499995, -0.55242278399993],
              [-91.14964758999992, -0.543633721999925],
              [-91.16148841099994, -0.538262627999927],
              [-91.18517005099994, -0.516534112999921],
              [-91.20889238199993, -0.484633070999962],
              [-91.22789466099994, -0.448825778999947],
              [-91.23721269399994, -0.41529713299991],
              [-91.23570716099994, -0.38640715899993],
              [-91.23867753799993, -0.376153252999927],
              [-91.25084387899994, -0.36687590899993],
              [-91.25877844999991, -0.364353122999944],
              [-91.27188066299993, -0.36296965899993],
              [-91.27818762899994, -0.360039971999925],
              [-91.28172766799992, -0.355726820999962],
              [-91.29124915299991, -0.339613539999959],
              [-91.35195878799993, -0.307224216999941],
              [-91.37498938699991, -0.281914971999925],
              [-91.37376868399991, -0.250176690999922],
              [-91.39370683499993, -0.238376559999949],
              [-91.40648352799991, -0.216403903999947],
              [-91.40453040299991, -0.195896091999941],
              [-91.38060462099992, -0.18873463299991],
              [-91.39879309799994, -0.162855726999908],
              [-91.40575110599991, -0.148044528999947],
              [-91.40851803299995, -0.130791924999926],
              [-91.40851803299995, -0.096286716999941],
              [-91.40953528599994, -0.087497653999947],
              [-91.41372636599993, -0.071343682999952],
              [-91.41470292899993, -0.061822197999959],
              [-91.42332923099991, -0.02857838299991],
              [-91.44554602799991, -0.012058200999945],
              [-91.47642981699994, -0.01108163899994],
              [-91.51097571499992, -0.024265231999948],
              [-91.54552161399994, -0.047946872999944],
              [-91.56309973899994, -0.051771742999961],
              [-91.58291581899994, -0.041314385999954],
              [-91.60338294199994, -0.01421477699995],
              [-91.60651607999995, -0.007256768999923],
              [-91.60435950399994, 0.001450914000088],
              [-91.59874426999994, 0.005804755000042],
              [-91.5911352199999, 0.008856512000079],
              [-91.52354895699995, 0.046372789000088],
              [-91.50446529899995, 0.066148179000038],
              [-91.49730383999992, 0.10610586100006],
              [-91.47256425699993, 0.098211981000077],
              [-91.45274817599994, 0.103745835000041],
              [-91.43374589799993, 0.113714911000045],
              [-91.40111243399991, 0.12250397300005],
              [-91.39427649599992, 0.130560614000046],
              [-91.38833574099993, 0.139878648000092],
              [-91.38060462099992, 0.147040106000077],
              [-91.36876380099994, 0.150620835000041],
              [-91.35020911399994, 0.149888414000088],
              [-91.33967037699995, 0.153794664000088],
              [-91.32363847599993, 0.13930898600006],
              [-91.31602942599994, 0.116278387000079],
              [-91.31240800699993, 0.094916083000044],
              [-91.30858313699991, 0.085598049000055],
              [-91.29531816299993, 0.075913804000038],
              [-91.28351803299995, 0.033189195000091],
              [-91.27476966099994, 0.023504950000074],
              [-91.26854407499991, 0.019273179000038],
              [-91.25438391799992, 0.000433661000045],
              [-91.24742591099994, -0.003838799999926],
              [-91.22598222599993, -0.004733981999948],
              [-91.21597245999993, -0.006849867999961],
              [-91.20929928299995, -0.010674737999921],
              [-91.20221920499995, -0.028252862999921],
              [-91.20067298099991, -0.052788994999958],
              [-91.20303300699993, -0.099379164999959],
              [-91.18455969999991, -0.211032809999949],
              [-91.17357337099992, -0.228448174999926],
              [-91.13194739499994, -0.266208591999941],
              [-91.12804114499994, -0.27076588299991],
              [-91.12718665299991, -0.276543877999927],
              [-91.12734941299993, -0.288181247999944],
              [-91.12413489499994, -0.299574476999908],
              [-91.11709550699993, -0.304294528999947],
              [-91.11009680899991, -0.30592213299991],
              [-91.10684160099993, -0.308851820999962],
              [-91.00503495999993, -0.373142184999949],
              [-90.9976293609999, -0.384209893999923],
              [-90.99526933499993, -0.393487237999921],
              [-90.9895727199999, -0.40162525799991],
              [-90.97647050699993, -0.41529713299991],
              [-90.9719945949999, -0.418145440999922],
              [-90.95604407499991, -0.422133070999962],
              [-90.95571855399993, -0.427992445999962],
              [-90.95824133999992, -0.434014580999929],
              [-90.96108964799993, -0.439060153999947],
              [-90.96226966099994, -0.441989841999941],
              [-90.95335852799991, -0.480075778999947],
              [-90.94920813699991, -0.521416924999926],
              [-90.95506751199991, -0.54029713299991],
              [-90.98204505099994, -0.563409112999921],
              [-90.99014238199993, -0.579196872999944],
              [-90.96784420499995, -0.564548434999949],
              [-90.96125240799995, -0.573174737999921],
              [-90.96056067599994, -0.591892184999949],
              [-90.95604407499991, -0.60711028399993],
              [-90.91372636599993, -0.61492278399993],
              [-90.89297441299993, -0.625746351999908],
              [-90.8946020169999, -0.64812590899993],
              [-90.88060462099992, -0.649997653999947],
              [-90.86900794199994, -0.655368747999944],
              [-90.85973059799994, -0.664157809999949],
              [-90.85301673099991, -0.676039320999962],
              [-90.85985266799992, -0.689629815999922],
              [-90.84642493399991, -0.695245049999926],
              [-90.81143144399994, -0.730645440999922],
            ],
          ],
          [
            [
              [-90.51378333199995, 0.28351471600007],
              [-90.5235082669999, 0.287095445000091],
              [-90.53311113199993, 0.295314846000053],
              [-90.54084225199995, 0.304429429000038],
              [-90.54454505099994, 0.31085846600007],
              [-90.5423070949999, 0.333563544000071],
              [-90.52647864499994, 0.350287177000041],
              [-90.50446529899995, 0.361029364000046],
              [-90.48306230399993, 0.365464585000041],
              [-90.46043860599991, 0.358221747000073],
              [-90.43643144399994, 0.346625067000048],
              [-90.41698157499991, 0.330877997000073],
              [-90.40794837099992, 0.31085846600007],
              [-90.41454016799992, 0.296291408000059],
              [-90.43211829299992, 0.280096747000073],
              [-90.45457923099991, 0.267401434000078],
              [-90.47565670499995, 0.263088283000059],
              [-90.48766028599994, 0.267075914000088],
              [-90.5008031889999, 0.280666408000059],
              [-90.51378333199995, 0.28351471600007],
            ],
          ],
          [
            [
              [-90.79775956899994, 0.653509833000044],
              [-90.75698808499993, 0.630601304000038],
              [-90.74449622299994, 0.58539459800005],
              [-90.7605688139999, 0.553697007000039],
              [-90.80524654899995, 0.571600653000075],
              [-90.7981664699999, 0.592759507000039],
              [-90.80492102799991, 0.635565497000073],
              [-90.79775956899994, 0.653509833000044],
            ],
          ],
          [
            [
              [-78.9016820949999, 1.374172268000052],
              [-78.90151933499993, 1.364650783000059],
              [-78.90013587099992, 1.357977606000077],
              [-78.89541581899994, 1.346177476000094],
              [-78.89443925699993, 1.312648830000057],
              [-78.89928137899994, 1.271429755000042],
              [-78.91250566299993, 1.245266018000052],
              [-78.93639075399994, 1.256822007000039],
              [-78.94595292899993, 1.245591539000088],
              [-78.95689856699994, 1.236314195000091],
              [-78.97716223899994, 1.251776434000078],
              [-78.99209550699993, 1.26829661700009],
              [-78.9954320949999, 1.286810614000046],
              [-78.98078365799995, 1.308335679000038],
              [-78.9016820949999, 1.374172268000052],
            ],
          ],
          [
            [
              [-91.8191625639999, 1.386419989000046],
              [-91.81456458199995, 1.384711005000042],
              [-91.81094316299993, 1.377183335000041],
              [-91.81273352799991, 1.372381903000075],
              [-91.81773841099994, 1.368068752000056],
              [-91.82262122299994, 1.371039130000042],
              [-91.82530676999994, 1.377020575000074],
              [-91.82534745999993, 1.382717190000051],
              [-91.8191625639999, 1.386419989000046],
            ],
          ],
          [
            [
              [-91.82201087099992, 1.394476630000042],
              [-91.81753495999993, 1.394761460000041],
              [-91.82046464799993, 1.39134349200009],
              [-91.82201087099992, 1.394476630000042],
            ],
          ],
          [
            [
              [-92.01158606699994, 1.658636786000045],
              [-92.00609290299991, 1.66437409100007],
              [-91.99982662699995, 1.659979559000078],
              [-91.99982662699995, 1.651190497000073],
              [-92.0066625639999, 1.649603583000044],
              [-92.01158606699994, 1.658636786000045],
            ],
          ],
          [
            [
              [-79.81963971599993, -2.485910851999961],
              [-79.80900672999991, -2.511684664999962],
              [-79.78472090999992, -2.520767103999958],
              [-79.7725706949999, -2.541987347999907],
              [-79.79380542299992, -2.57384045099991],
              [-79.82870193999992, -2.592050637999932],
              [-79.83323667999991, -2.636017324999955],
              [-79.85751088699993, -2.651186078999956],
              [-79.87723938099992, -2.649677722999911],
              [-79.8818011269999, -2.62693980399996],
              [-79.86815874399991, -2.589033273999917],
              [-79.84693554699993, -2.534443061999923],
              [-79.81963971599993, -2.485910851999961],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Colombia',
        iso3: 'COL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-78.82868404899995, 1.43431224200009],
              [-78.81285559799994, 1.441799221000053],
              [-78.81956946499992, 1.45970286700009],
              [-78.83193925699993, 1.470363674000055],
              [-78.84520423099991, 1.47882721600007],
              [-78.85448157499991, 1.490179755000042],
              [-78.85562089799993, 1.505438544000071],
              [-78.85350501199991, 1.524400132000039],
              [-78.85334225199995, 1.543361721000053],
              [-78.86070716099994, 1.558498440000051],
              [-78.86709550699993, 1.560288804000038],
              [-78.87999426999994, 1.55414459800005],
              [-78.89959934699993, 1.545328417000064],
              [-78.90793175099992, 1.555049163000092],
              [-78.91811527899995, 1.564306070000043],
              [-78.9310786769999, 1.566157600000054],
              [-78.94080074399994, 1.574951140000053],
              [-78.9625709899999, 1.58698692300004],
              [-78.97151291499995, 1.591281121000065],
              [-78.99798007699991, 1.607936954000081],
              [-79.01268631199991, 1.623613374000058],
              [-79.02151154699993, 1.638310358000069],
              [-79.01661153399994, 1.654964673000052],
              [-79.0087697539999, 1.664760146000049],
              [-78.99308465999991, 1.670634053000072],
              [-78.97347963199991, 1.675526632000071],
              [-78.9558399359999, 1.692179301000067],
              [-78.94016326999991, 1.72255830000006],
              [-78.92644272699994, 1.741178241000057],
              [-78.90095847599991, 1.76666302700005],
              [-78.88037174499993, 1.790193196000075],
              [-78.86664505099992, 1.804905033000068],
              [-78.84605195599994, 1.82158548600006],
              [-78.79938717399995, 1.832017320000091],
              [-78.77684485599991, 1.82843659100007],
              [-78.75944780599991, 1.830547266000053],
              [-78.73760027599991, 1.82580073400004],
              [-78.7186044419999, 1.817256321000059],
              [-78.69725501199991, 1.812079169000071],
              [-78.66372636599993, 1.809759833000044],
              [-78.64159094999991, 1.804877020000049],
              [-78.61263584699992, 1.801310645000058],
              [-78.60753832099994, 1.798764066000047],
              [-78.6005273589999, 1.790488726000092],
              [-78.5909734199999, 1.783484927000075],
              [-78.58078814899994, 1.780299772000092],
              [-78.57123041799991, 1.782207066000069],
              [-78.57184861899992, 1.796212322000088],
              [-78.57056393599993, 1.803852028000051],
              [-78.56672671799993, 1.819768385000089],
              [-78.55332755199993, 1.83441235500004],
              [-78.54629561299993, 1.859884284000088],
              [-78.55406653599994, 1.876206773000092],
              [-78.55284583199995, 1.891180731000077],
              [-78.55117753799993, 1.894476630000042],
              [-78.54784094999991, 1.899318752000056],
              [-78.54515540299991, 1.905910549000055],
              [-78.54539954299992, 1.914740302000041],
              [-78.54835034699994, 1.920613375000073],
              [-78.55229957199992, 1.91664581200007],
              [-78.55848281499993, 1.904170269000076],
              [-78.57149668099993, 1.896806241000093],
              [-78.59136712399993, 1.896842641000092],
              [-78.59763030699992, 1.90988494000004],
              [-78.59820906099992, 1.928567313000087],
              [-78.5938207669999, 1.948879299000055],
              [-78.59251868399991, 1.964056708000044],
              [-78.58747311099995, 1.988470770000049],
              [-78.58633378799993, 2.000392971000053],
              [-78.58958899599992, 2.009100653000075],
              [-78.5977270169999, 2.019354559000078],
              [-78.60802161399994, 2.02798086100006],
              [-78.61799068899995, 2.031439520000049],
              [-78.62901770699995, 2.025336005000042],
              [-78.63719641799992, 2.01235586100006],
              [-78.64747413399994, 1.980641280000043],
              [-78.65824358599991, 1.974992279000048],
              [-78.66560577799993, 1.982915292000087],
              [-78.66734778599994, 2.003648179000038],
              [-78.6706835949999, 2.03099448200004],
              [-78.6829869199999, 2.065041284000074],
              [-78.69176876699993, 2.112479953000047],
              [-78.70054843799994, 2.146743957000069],
              [-78.70315874699992, 2.189805173000082],
              [-78.69170593399991, 2.214419156000076],
              [-78.6793610929999, 2.241683269000077],
              [-78.6722982789999, 2.267190010000093],
              [-78.64537512899994, 2.278265692000048],
              [-78.63695227799991, 2.306586005000042],
              [-78.60741126199991, 2.359808661000045],
              [-78.58568274599992, 2.403143622000073],
              [-78.57408606699994, 2.433172919000071],
              [-78.55899003799993, 2.449164130000042],
              [-78.56529700399994, 2.432562567000048],
              [-78.56627356699994, 2.415513414000088],
              [-78.56358801999994, 2.398342190000051],
              [-78.55899003799993, 2.381537177000041],
              [-78.54491126199991, 2.426743882000039],
              [-78.53620290799995, 2.47515151500005],
              [-78.52504513299994, 2.495506662000082],
              [-78.50645794499991, 2.490871279000089],
              [-78.48138847699994, 2.522313629000053],
              [-78.45633337399994, 2.551898515000062],
              [-78.4322158459999, 2.587028252000039],
              [-78.41088710399993, 2.595331203000057],
              [-78.39327648799991, 2.611963180000089],
              [-78.37196326799994, 2.632291167000062],
              [-78.34601823899993, 2.647985921000043],
              [-78.3339729839999, 2.647045418000062],
              [-78.32470669299994, 2.623909973000082],
              [-78.31359514999991, 2.597081555000045],
              [-78.29786003299995, 2.57118076200004],
              [-78.27750360599993, 2.542509370000062],
              [-78.25475012899994, 2.541896877000056],
              [-78.26546333399995, 2.575777132000042],
              [-78.27100939199994, 2.604440755000041],
              [-78.27007633099993, 2.634952070000054],
              [-78.26174337499992, 2.649741391000077],
              [-78.24693074399994, 2.663600774000088],
              [-78.2358255769999, 2.646015167000087],
              [-78.22843126999993, 2.615495700000054],
              [-78.23491746999991, 2.593315008000047],
              [-78.22474465599993, 2.576667705000091],
              [-78.21550105999995, 2.555402443000048],
              [-78.20775305899991, 2.537339585000041],
              [-78.19310462099992, 2.521429755000042],
              [-78.18439693899995, 2.515204169000071],
              [-78.14879309799994, 2.497544664000088],
              [-78.13247636599993, 2.492743231000077],
              [-78.12295488199993, 2.493638414000088],
              [-78.10655676999994, 2.504380601000094],
              [-78.08665930899991, 2.510565497000073],
              [-78.0852758449999, 2.516058661000045],
              [-78.08507239499994, 2.523586330000057],
              [-78.08576412699995, 2.529852606000077],
              [-78.08665930899991, 2.531683661000045],
              [-78.08311926999994, 2.537543036000045],
              [-78.08165442599994, 2.541489976000094],
              [-78.08136124599991, 2.577489655000079],
              [-78.08504930599992, 2.59228130200006],
              [-78.08966275699993, 2.607996460000038],
              [-78.09982697399994, 2.624637143000086],
              [-78.10536494399992, 2.642204308000089],
              [-78.09610490199992, 2.651451390000091],
              [-78.0739016249999, 2.646820263000052],
              [-78.0637179869999, 2.65421008900006],
              [-78.03965606999992, 2.65512674200005],
              [-78.02114699799995, 2.654194966000091],
              [-78.0044853899999, 2.655113608000079],
              [-77.99151711399992, 2.663432042000068],
              [-77.9692833549999, 2.676372319000052],
              [-77.94984012999993, 2.67451808800007],
              [-77.93586178299995, 2.662054755000042],
              [-77.92544511599993, 2.64321523600006],
              [-77.91759192599994, 2.63226959800005],
              [-77.90689042899993, 2.629461981000077],
              [-77.88805091099994, 2.634711005000042],
              [-77.89704342399995, 2.619086005000042],
              [-77.90542558499993, 2.598211981000077],
              [-77.90428626199991, 2.579982815000051],
              [-77.88434811099995, 2.572088934000078],
              [-77.87254798099991, 2.570786851000094],
              [-77.85236568899995, 2.566107489000046],
              [-77.83967037699995, 2.56586334800005],
              [-77.81383216099994, 2.571234442000048],
              [-77.80239824099993, 2.572088934000078],
              [-77.77794348899994, 2.577704169000071],
              [-77.76040605399993, 2.591620184000078],
              [-77.75121008999992, 2.609605210000041],
              [-77.75153561099995, 2.62726471600007],
              [-77.75763912699995, 2.639960028000075],
              [-77.76891028599994, 2.657171942000048],
              [-77.78335527299993, 2.671372789000088],
              [-77.79869544199994, 2.675726630000042],
              [-77.79869544199994, 2.681870835000041],
              [-77.77818762899994, 2.681870835000041],
              [-77.77818762899994, 2.689398505000042],
              [-77.79133053299995, 2.691961981000077],
              [-77.79759680899991, 2.698716539000088],
              [-77.79775956899994, 2.70766836100006],
              [-77.79246985599991, 2.716701565000051],
              [-77.80288652299993, 2.71938711100006],
              [-77.80630449099993, 2.725531317000048],
              [-77.80443274599992, 2.734076239000046],
              [-77.79869544199994, 2.743963934000078],
              [-77.80752519399994, 2.745794989000046],
              [-77.81175696499992, 2.748480536000045],
              [-77.81285559799994, 2.754095770000049],
              [-77.81236731699994, 2.764471747000073],
              [-77.79478919199994, 2.75726959800005],
              [-77.78091386599993, 2.763169664000088],
              [-77.76829993399991, 2.773342190000051],
              [-77.75462805899991, 2.77875397300005],
              [-77.74819902299993, 2.779527085000041],
              [-77.73924719999991, 2.782049872000073],
              [-77.73355058499993, 2.786118882000039],
              [-77.73721269399994, 2.79173411700009],
              [-77.74551347599993, 2.793158270000049],
              [-77.76195227799991, 2.785589911000045],
              [-77.77074133999992, 2.785589911000045],
              [-77.78575598899994, 2.794826565000051],
              [-77.78184973899994, 2.802150783000059],
              [-77.7708227199999, 2.808742580000057],
              [-77.76455644399994, 2.815659898000092],
              [-77.75763912699995, 2.813299872000073],
              [-77.74156653599994, 2.810044664000088],
              [-77.72321529899995, 2.808742580000057],
              [-77.70933997299994, 2.812241929000038],
              [-77.70518958199995, 2.805650132000039],
              [-77.69847571499992, 2.79751211100006],
              [-77.69627844999991, 2.79173411700009],
              [-77.68883216099994, 2.79173411700009],
              [-77.69859778599994, 2.81313711100006],
              [-77.73542232999995, 2.822495835000041],
              [-77.72354081899994, 2.84015534100007],
              [-77.70815995999993, 2.848456122000073],
              [-77.69359290299991, 2.850165106000077],
              [-77.68024654899995, 2.853664455000057],
              [-77.66832434799994, 2.86749909100007],
              [-77.65859941299993, 2.863470770000049],
              [-77.65070553299995, 2.859116929000038],
              [-77.64488684799994, 2.853745835000041],
              [-77.64171301999994, 2.846380927000041],
              [-77.6360570949999, 2.869614976000094],
              [-77.65770423099991, 2.876898505000042],
              [-77.68822180899991, 2.87250397300005],
              [-77.70933997299994, 2.860663153000075],
              [-77.7149145169999, 2.875677802000041],
              [-77.71568762899994, 2.897528387000079],
              [-77.71007239499994, 2.918117580000057],
              [-77.69627844999991, 2.928941148000092],
              [-77.68260657499991, 2.927313544000071],
              [-77.67345130099994, 2.919175523000092],
              [-77.66519120999993, 2.909247137000079],
              [-77.65465247299994, 2.901597398000092],
              [-77.64338131399995, 2.898138739000046],
              [-77.64012610599991, 2.900051174000055],
              [-77.63906816299993, 2.906154690000051],
              [-77.63418535099993, 2.915350653000075],
              [-77.6250707669999, 2.92446523600006],
              [-77.62071692599994, 2.927679755000042],
              [-77.61969967399995, 2.931586005000042],
              [-77.62051347599993, 2.942613023000092],
              [-77.62393144399994, 2.94798411700009],
              [-77.63768469999991, 2.951727606000077],
              [-77.64171301999994, 2.956244208000044],
              [-77.64146887899994, 2.961330471000053],
              [-77.63589433499993, 2.964829820000091],
              [-77.63109290299991, 2.97797272300005],
              [-77.62588456899994, 2.979681708000044],
              [-77.62315833199995, 2.981838283000059],
              [-77.62734941299993, 2.991034247000073],
              [-77.63390051999994, 2.99485911700009],
              [-77.64216061099995, 2.994289455000057],
              [-77.64976966099994, 2.99555084800005],
              [-77.65465247299994, 3.004706122000073],
              [-77.65611731699994, 2.99750397300005],
              [-77.6575414699999, 2.995835679000038],
              [-77.6575414699999, 2.995184637000079],
              [-77.65465247299994, 2.991034247000073],
              [-77.66543535099993, 2.984564520000049],
              [-77.67662512899994, 2.982326565000051],
              [-77.68541419199994, 2.985907294000071],
              [-77.68883216099994, 2.997259833000044],
              [-77.71393795499995, 2.974758205000057],
              [-77.72354081899994, 2.969916083000044],
              [-77.72179114499994, 2.982001044000071],
              [-77.68502328799991, 3.025839156000075],
              [-77.66225636699994, 3.058458759000075],
              [-77.64770684799993, 3.073852830000078],
              [-77.57142868499994, 3.13807513900008],
              [-77.5514370109999, 3.175148880000052],
              [-77.53962883999992, 3.196844681000073],
              [-77.52512071799993, 3.201353588000075],
              [-77.50865637899994, 3.194566148000092],
              [-77.50552324099993, 3.204575914000088],
              [-77.50450598899994, 3.21320221600007],
              [-77.50182044199994, 3.22337474200009],
              [-77.49486243399991, 3.223618882000039],
              [-77.48574785099993, 3.221380927000041],
              [-77.47968397499994, 3.227463768000064],
              [-77.4854364169999, 3.237703861000057],
              [-77.50079992199994, 3.24475811700006],
              [-77.51617724099992, 3.239661555000055],
              [-77.53860164799994, 3.237124141000038],
              [-77.54179451899995, 3.246080663000043],
              [-77.52960372199993, 3.261417016000053],
              [-77.50523863099994, 3.282491318000041],
              [-77.4885727649999, 3.292702895000048],
              [-77.46486434099995, 3.301625682000065],
              [-77.4776584039999, 3.313153257000067],
              [-77.47655188699991, 3.333644924000055],
              [-77.46865800699993, 3.344671942000048],
              [-77.45738684799994, 3.356146552000041],
              [-77.44546464799993, 3.363226630000042],
              [-77.4356176419999, 3.360988674000055],
              [-77.41905676999994, 3.365220445000091],
              [-77.40485592399995, 3.367173570000091],
              [-77.4004613919999, 3.370021877000056],
              [-77.38097083199995, 3.387640692000048],
              [-77.35850989499994, 3.345770575000074],
              [-77.34373938699991, 3.329413153000075],
              [-77.31891842399995, 3.319973049000055],
              [-77.32347571499992, 3.331122137000079],
              [-77.3567602199999, 3.370917059000078],
              [-77.36563066299993, 3.385646877000056],
              [-77.36705481699994, 3.402085679000038],
              [-77.36245683499993, 3.417792059000078],
              [-77.35301673099991, 3.429836330000057],
              [-77.34943600199995, 3.42133209800005],
              [-77.34268144399994, 3.412054755000042],
              [-77.33608964799993, 3.407171942000048],
              [-77.33315995999993, 3.411810614000046],
              [-77.33519446499992, 3.419256903000075],
              [-77.34414628799993, 3.432033596000053],
              [-77.34618079299992, 3.436021226000094],
              [-77.3411352199999, 3.456244208000044],
              [-77.33169511599993, 3.473334052000041],
              [-77.32628333199995, 3.490668036000045],
              [-77.33315995999993, 3.511786200000074],
              [-77.32290605399993, 3.512396552000041],
              [-77.31273352799991, 3.511786200000074],
              [-77.31582597599993, 3.506903387000079],
              [-77.31773841099994, 3.501776434000078],
              [-77.31867428299995, 3.49555084800005],
              [-77.31891842399995, 3.487616278000075],
              [-77.31615149599992, 3.480373440000051],
              [-77.30980383999992, 3.480210679000038],
              [-77.30028235599991, 3.486558335000041],
              [-77.28282630099994, 3.485174872000073],
              [-77.27818762899994, 3.482611395000049],
              [-77.26915442599994, 3.473944403000075],
              [-77.26427161399994, 3.470851955000057],
              [-77.26549231699994, 3.480414130000042],
              [-77.26943925699993, 3.487941799000055],
              [-77.27586829299992, 3.493475653000075],
              [-77.28477942599994, 3.49750397300005],
              [-77.28050696499992, 3.499701239000046],
              [-77.27586829299992, 3.502997137000079],
              [-77.27171790299991, 3.504950262000079],
              [-77.29051673099991, 3.511542059000078],
              [-77.29898027299993, 3.511786200000074],
              [-77.29478919199994, 3.521144924000055],
              [-77.29100501199991, 3.523667710000041],
              [-77.28595943899995, 3.521918036000045],
              [-77.27794348899994, 3.517971096000053],
              [-77.27489173099991, 3.532782294000071],
              [-77.28905188699991, 3.538072007000039],
              [-77.30955969999991, 3.536851304000038],
              [-77.32575436099995, 3.532212632000039],
              [-77.32176673099991, 3.547837632000039],
              [-77.31053626199991, 3.550197658000059],
              [-77.2949926419999, 3.547023830000057],
              [-77.27794348899994, 3.545884507000039],
              [-77.28319251199991, 3.548570054000038],
              [-77.29356848899994, 3.555894273000092],
              [-77.29898027299993, 3.558986721000053],
              [-77.29328365799995, 3.56118398600006],
              [-77.28990637899994, 3.563421942000048],
              [-77.28587805899991, 3.565334377000056],
              [-77.27794348899994, 3.566392320000091],
              [-77.28099524599992, 3.570461330000057],
              [-77.28477942599994, 3.580633856000077],
              [-77.26475989499994, 3.585028387000079],
              [-77.24376380099994, 3.586900132000039],
              [-77.24376380099994, 3.580633856000077],
              [-77.24860592399995, 3.571519273000092],
              [-77.23884029899995, 3.571682033000059],
              [-77.20962480399993, 3.580633856000077],
              [-77.22386633999992, 3.584214585000041],
              [-77.22716223899994, 3.591009833000044],
              [-77.22264563699991, 3.600165106000077],
              [-77.20490475199995, 3.621242580000057],
              [-77.19863847599993, 3.63353099200009],
              [-77.18919837099992, 3.662583726000094],
              [-77.17772376199991, 3.654445705000057],
              [-77.16954505099994, 3.652248440000051],
              [-77.16185462099992, 3.655951239000046],
              [-77.15127519399994, 3.665716864000046],
              [-77.14028886599993, 3.669826565000051],
              [-77.12486731699994, 3.673732815000051],
              [-77.11827551999994, 3.67804596600007],
              [-77.13394120999993, 3.68305084800005],
              [-77.14720618399991, 3.68109772300005],
              [-77.16055253799993, 3.676214911000045],
              [-77.17080644399994, 3.67719147300005],
              [-77.17491614499994, 3.692694403000075],
              [-77.16787675699993, 3.694973049000055],
              [-77.15221106699994, 3.697943427000041],
              [-77.13573157499991, 3.704413153000075],
              [-77.12645423099991, 3.717230536000045],
              [-77.14366614499994, 3.715073960000041],
              [-77.18541419199994, 3.703599351000094],
              [-77.19871985599991, 3.710028387000079],
              [-77.20295162699995, 3.725490627000056],
              [-77.20079505099994, 3.743475653000075],
              [-77.19542395699995, 3.758205471000053],
              [-77.16738847599993, 3.737941799000055],
              [-77.15233313699991, 3.733099677000041],
              [-77.1301977199999, 3.731512762000079],
              [-77.12564042899993, 3.733547268000052],
              [-77.1282445949999, 3.737982489000046],
              [-77.13536536399994, 3.74249909100007],
              [-77.14443925699993, 3.744533596000053],
              [-77.15526282499991, 3.74445221600007],
              [-77.16344153599994, 3.745347398000092],
              [-77.16978919199994, 3.749253648000092],
              [-77.17491614499994, 3.758205471000053],
              [-77.15843665299991, 3.756903387000079],
              [-77.14443925699993, 3.759588934000078],
              [-77.13365637899994, 3.766750393000052],
              [-77.12645423099991, 3.778713283000059],
              [-77.14199785099993, 3.788478908000059],
              [-77.15147864499994, 3.800441799000055],
              [-77.15038001199991, 3.813666083000044],
              [-77.13394120999993, 3.827093817000048],
              [-77.12612870999993, 3.821600653000075],
              [-77.12149003799993, 3.816351630000042],
              [-77.11969967399995, 3.809515692000048],
              [-77.12026933499993, 3.79913971600007],
              [-77.10562089799993, 3.813462632000039],
              [-77.11188717399995, 3.834051825000074],
              [-77.11449133999992, 3.852606512000079],
              [-77.06859290299991, 3.867743231000077],
              [-77.05630449099993, 3.884344794000071],
              [-77.04600989499994, 3.902777411000045],
              [-77.03156490799995, 3.915838934000078],
              [-77.03156490799995, 3.922064520000049],
              [-77.09300696499992, 3.909002997000073],
              [-77.09300696499992, 3.915838934000078],
              [-77.0860082669999, 3.918158270000049],
              [-77.07933508999992, 3.922064520000049],
              [-77.10464433499993, 3.921779690000051],
              [-77.11607825399994, 3.923814195000091],
              [-77.12645423099991, 3.929510809000078],
              [-77.12303626199991, 3.886135158000059],
              [-77.18114173099991, 3.85297272300005],
              [-77.25316321499992, 3.840806382000039],
              [-77.29161536399994, 3.860581773000092],
              [-77.28954016799992, 3.869818427000041],
              [-77.27521725199995, 3.877752997000073],
              [-77.27171790299991, 3.88540273600006],
              [-77.27525794199994, 3.889227606000077],
              [-77.29263261599993, 3.897772528000075],
              [-77.30479895699995, 3.905829169000071],
              [-77.30915279899995, 3.905951239000046],
              [-77.31175696499992, 3.908433335000041],
              [-77.31273352799991, 3.919012762000079],
              [-77.31163489499994, 3.927557684000078],
              [-77.30915279899995, 3.934800523000092],
              [-77.30524654899995, 3.943182684000078],
              [-77.30020097599993, 3.969142971000053],
              [-77.29507402299993, 3.97797272300005],
              [-77.28477942599994, 3.984076239000046],
              [-77.27041581899994, 3.986395575000074],
              [-77.26089433499993, 3.98314036700009],
              [-77.25999915299991, 3.975409247000073],
              [-77.27171790299991, 3.964260158000059],
              [-77.22398841099994, 3.971991278000075],
              [-77.20962480399993, 3.97728099200009],
              [-77.20962480399993, 3.984076239000046],
              [-77.24376380099994, 3.97728099200009],
              [-77.23924719999991, 3.989935614000046],
              [-77.23228919199994, 4.001206773000092],
              [-77.20539303299995, 4.032619533000059],
              [-77.18919837099992, 4.067328192000048],
              [-77.19981848899994, 4.066880601000094],
              [-77.20474199099993, 4.068101304000038],
              [-77.20693925699993, 4.072170315000051],
              [-77.20962480399993, 4.080308335000041],
              [-77.22492428299995, 4.076971747000073],
              [-77.23668372299994, 4.085353908000059],
              [-77.24860592399995, 4.098211981000077],
              [-77.26427161399994, 4.108221747000073],
              [-77.25999915299991, 4.098537502000056],
              [-77.25853430899991, 4.087632554000038],
              [-77.25999915299991, 4.07689036700009],
              [-77.26427161399994, 4.067328192000048],
              [-77.27293860599991, 4.072088934000078],
              [-77.28160559799994, 4.073553778000075],
              [-77.29039466099994, 4.071844794000071],
              [-77.29898027299993, 4.067328192000048],
              [-77.29898027299993, 4.059881903000075],
              [-77.29409745999993, 4.055487372000073],
              [-77.29377193899995, 4.05499909100007],
              [-77.29600989499994, 4.05337148600006],
              [-77.29898027299993, 4.045599677000041],
              [-77.30345618399991, 4.049790757000039],
              [-77.30650794199994, 4.050970770000049],
              [-77.31069902299993, 4.051255601000094],
              [-77.31891842399995, 4.05304596600007],
              [-77.31582597599993, 4.034247137000079],
              [-77.31891842399995, 4.006537177000041],
              [-77.32632402299993, 3.981390692000048],
              [-77.33653723899994, 3.970445054000038],
              [-77.33971106699994, 3.964422919000071],
              [-77.34325110599991, 3.93695709800005],
              [-77.34618079299992, 3.929510809000078],
              [-77.36213131399995, 3.92804596600007],
              [-77.37466386599993, 3.936428127000056],
              [-77.37979081899994, 3.950018622000073],
              [-77.37352454299992, 3.964260158000059],
              [-77.42503821499992, 4.004584052000041],
              [-77.43077551999994, 4.012640692000048],
              [-77.43517005099994, 4.029364325000074],
              [-77.43040930899991, 4.044012762000079],
              [-77.4082738919999, 4.045599677000041],
              [-77.41982988199993, 4.060207424000055],
              [-77.42398027299993, 4.067328192000048],
              [-77.43114173099991, 4.09438711100006],
              [-77.43504798099991, 4.124904690000051],
              [-77.43517005099994, 4.155218817000048],
              [-77.43285071499992, 4.169012762000079],
              [-77.42666581899994, 4.180365302000041],
              [-77.41510982999995, 4.19017161700009],
              [-77.40119381399995, 4.193304755000042],
              [-77.38776607999995, 4.19171784100007],
              [-77.37755286399994, 4.193589585000041],
              [-77.37352454299992, 4.206935940000051],
              [-77.36961829299992, 4.213934637000079],
              [-77.36009680899991, 4.221136786000045],
              [-77.34805253799993, 4.224676825000074],
              [-77.33653723899994, 4.220607815000051],
              [-77.31981360599991, 4.200832424000055],
              [-77.31309973899994, 4.198879299000055],
              [-77.29898027299993, 4.203192450000074],
              [-77.28099524599992, 4.213771877000056],
              [-77.2649633449999, 4.228745835000041],
              [-77.23631751199991, 4.265326239000046],
              [-77.32091223899994, 4.26634349200009],
              [-77.33653723899994, 4.268744208000044],
              [-77.35033118399991, 4.28579336100006],
              [-77.38719641799992, 4.347235419000071],
              [-77.35899817599994, 4.387193101000094],
              [-77.35301673099991, 4.402492580000057],
              [-77.34508216099994, 4.445542710000041],
              [-77.33511308499993, 4.460923570000091],
              [-77.31273352799991, 4.471380927000041],
              [-77.31273352799991, 4.478176174000055],
              [-77.33315995999993, 4.471380927000041],
              [-77.33043372299994, 4.499660549000055],
              [-77.31956946499992, 4.546616929000038],
              [-77.31891842399995, 4.683661200000074],
              [-77.31566321499992, 4.674383856000077],
              [-77.31167558499993, 4.667181708000044],
              [-77.30630449099993, 4.661200262000079],
              [-77.29898027299993, 4.65570709800005],
              [-77.29442298099991, 4.665716864000046],
              [-77.29161536399994, 4.682074286000045],
              [-77.2949926419999, 4.697333075000074],
              [-77.31883704299992, 4.709662177000041],
              [-77.32213294199994, 4.722845770000049],
              [-77.32310950399994, 4.738755601000094],
              [-77.32575436099995, 4.752508856000077],
              [-77.30333411399994, 4.749212958000044],
              [-77.28579667899993, 4.737005927000041],
              [-77.27293860599991, 4.720607815000051],
              [-77.26427161399994, 4.704087632000039],
              [-77.25804602799991, 4.704087632000039],
              [-77.26976477799991, 4.736070054000038],
              [-77.31216386599993, 4.787176825000074],
              [-77.31891842399995, 4.820868231000077],
              [-77.32359778599994, 4.818793036000045],
              [-77.33535722599993, 4.815497137000079],
              [-77.33999589799993, 4.813381252000056],
              [-77.34862219999991, 4.854193427000041],
              [-77.36050370999993, 4.982489325000074],
              [-77.36668860599991, 4.998928127000056],
              [-77.37287350199995, 5.14915599200009],
              [-77.36790930899991, 5.183254299000055],
              [-77.35899817599994, 5.215643622000073],
              [-77.34618079299992, 5.24477773600006],
              [-77.36058508999992, 5.253485419000071],
              [-77.36156165299991, 5.275213934000078],
              [-77.35920162699995, 5.297308661000045],
              [-77.36359615799995, 5.307440497000073],
              [-77.37303626199991, 5.315659898000092],
              [-77.3782445949999, 5.335191148000092],
              [-77.38097083199995, 5.375067450000074],
              [-77.39574133999992, 5.370347398000092],
              [-77.40465247299994, 5.374701239000046],
              [-77.40855872299994, 5.38617584800005],
              [-77.4082738919999, 5.403021552000041],
              [-77.40147864499994, 5.403021552000041],
              [-77.39696204299992, 5.398423570000091],
              [-77.39342200399994, 5.39594147300005],
              [-77.38878333199995, 5.397040106000077],
              [-77.38097083199995, 5.403021552000041],
              [-77.39126542899993, 5.409572658000059],
              [-77.39533443899995, 5.41868724200009],
              [-77.40257727799991, 5.449652411000045],
              [-77.40160071499992, 5.453111070000091],
              [-77.40225175699993, 5.457220770000049],
              [-77.4082738919999, 5.464504299000055],
              [-77.41291256399995, 5.466213283000059],
              [-77.42931067599994, 5.468939520000049],
              [-77.4356176419999, 5.47134023600006],
              [-77.44688880099994, 5.482082424000055],
              [-77.45396887899994, 5.492621161000045],
              [-77.46214758999992, 5.501044012000079],
              [-77.47655188699991, 5.505438544000071],
              [-77.49087480399993, 5.505438544000071],
              [-77.50133216099994, 5.502427476000094],
              [-77.50792395699995, 5.495754299000055],
              [-77.51065019399994, 5.484930731000077],
              [-77.52269446499992, 5.49555084800005],
              [-77.53453528599994, 5.494940497000073],
              [-77.54478919199994, 5.491115627000056],
              [-77.55223548099991, 5.491848049000055],
              [-77.55919348899994, 5.503078518000052],
              [-77.55687415299991, 5.511908270000049],
              [-77.54784094999991, 5.517645575000074],
              [-77.53490149599992, 5.519720770000049],
              [-77.52623450399994, 5.530178127000056],
              [-77.50275631399995, 5.579250393000052],
              [-77.49083411399994, 5.594794012000079],
              [-77.48184160099993, 5.597601630000042],
              [-77.45954342399995, 5.599025783000059],
              [-77.44981848899994, 5.601629950000074],
              [-77.43789628799993, 5.610174872000073],
              [-77.42910722599993, 5.618963934000078],
              [-77.41950436099995, 5.625677802000041],
              [-77.40485592399995, 5.62836334800005],
              [-77.38719641799992, 5.623195705000057],
              [-77.37218176999994, 5.613470770000049],
              [-77.35562089799993, 5.607896226000094],
              [-77.33315995999993, 5.615301825000074],
              [-77.32677161399994, 5.621283270000049],
              [-77.32445227799991, 5.627386786000045],
              [-77.32298743399991, 5.634426174000055],
              [-77.31891842399995, 5.642564195000091],
              [-77.31794186099995, 5.647040106000077],
              [-77.31973222599993, 5.65851471600007],
              [-77.31891842399995, 5.663031317000048],
              [-77.31444251199991, 5.664292710000041],
              [-77.30785071499992, 5.663031317000048],
              [-77.30166581899994, 5.662543036000045],
              [-77.29898027299993, 5.666164455000057],
              [-77.29430091099994, 5.676947333000044],
              [-77.2832738919999, 5.685777085000041],
              [-77.27061926999994, 5.693548895000049],
              [-77.26113847599993, 5.700913804000038],
              [-77.25450598899994, 5.710923570000091],
              [-77.24941972599993, 5.722316799000055],
              [-77.24592037699995, 5.734198309000078],
              [-77.24376380099994, 5.745672919000071],
              [-77.24644934799994, 5.787339585000041],
              [-77.26158606699994, 5.822495835000041],
              [-77.30239824099993, 5.888251044000071],
              [-77.30589758999992, 5.891506252000056],
              [-77.31273352799991, 5.896429755000042],
              [-77.31346594999991, 5.918402411000045],
              [-77.35301673099991, 6.026190497000073],
              [-77.36046301999994, 6.026190497000073],
              [-77.36046301999994, 5.998928127000056],
              [-77.36668860599991, 5.998928127000056],
              [-77.38280188699991, 6.042629299000055],
              [-77.40843665299991, 6.081976630000042],
              [-77.46971594999991, 6.156480210000041],
              [-77.48062089799993, 6.174058335000041],
              [-77.48436438699991, 6.188788153000075],
              [-77.48338782499991, 6.228501695000091],
              [-77.47655188699991, 6.264064846000053],
              [-77.47569739499994, 6.28156159100007],
              [-77.48338782499991, 6.294338283000059],
              [-77.47655188699991, 6.300523179000038],
              [-77.43903561099995, 6.269476630000042],
              [-77.41510982999995, 6.239081122000073],
              [-77.40501868399991, 6.246242580000057],
              [-77.39488684799994, 6.263576565000051],
              [-77.38097083199995, 6.300523179000038],
              [-77.37759355399993, 6.319240627000056],
              [-77.37669837099992, 6.336859442000048],
              [-77.37791907499991, 6.351792710000041],
              [-77.38097083199995, 6.362616278000075],
              [-77.39928137899994, 6.387640692000048],
              [-77.39647376199991, 6.395819403000075],
              [-77.37352454299992, 6.404201565000051],
              [-77.37083899599992, 6.397935289000088],
              [-77.36766516799992, 6.395086981000077],
              [-77.36412512899994, 6.393133856000077],
              [-77.36046301999994, 6.389878648000092],
              [-77.35631262899994, 6.405178127000056],
              [-77.35993404899995, 6.419175523000092],
              [-77.36880449099993, 6.430487372000073],
              [-77.38097083199995, 6.437689520000049],
              [-77.38097083199995, 6.444525458000044],
              [-77.36579342399995, 6.470038153000075],
              [-77.36082923099991, 6.486070054000038],
              [-77.36046301999994, 6.50657786700009],
              [-77.34752356699994, 6.521551825000074],
              [-77.34300696499992, 6.543768622000073],
              [-77.34536699099993, 6.566107489000046],
              [-77.35301673099991, 6.581732489000046],
              [-77.38719641799992, 6.609035549000055],
              [-77.39415442599994, 6.616685289000088],
              [-77.39883378799993, 6.62368398600006],
              [-77.40469316299993, 6.630113023000092],
              [-77.41510982999995, 6.636297919000071],
              [-77.41466223899994, 6.647447007000039],
              [-77.40953528599994, 6.66828034100007],
              [-77.4082738919999, 6.681057033000059],
              [-77.41124426999994, 6.693793036000045],
              [-77.41869055899991, 6.698716539000088],
              [-77.42870032499991, 6.701564846000053],
              [-77.46263587099992, 6.720689195000091],
              [-77.48615475199995, 6.715073960000041],
              [-77.50568600199995, 6.700140692000048],
              [-77.51748613199993, 6.684759833000044],
              [-77.51333574099993, 6.677923895000049],
              [-77.51065019399994, 6.671087958000044],
              [-77.51870683499993, 6.669582424000055],
              [-77.52428137899994, 6.667466539000088],
              [-77.53180904899995, 6.663641669000071],
              [-77.53799394399994, 6.663641669000071],
              [-77.53819739499994, 6.68891022300005],
              [-77.53648841099994, 6.700832424000055],
              [-77.53180904899995, 6.712062893000052],
              [-77.57335364499994, 6.801011460000041],
              [-77.59325110599991, 6.828111070000091],
              [-77.62181555899991, 6.855943101000094],
              [-77.63621985599991, 6.865423895000049],
              [-77.66250566299993, 6.871771552000041],
              [-77.66673743399991, 6.876857815000051],
              [-77.67105058499993, 6.879706122000073],
              [-77.68260657499991, 6.875921942000048],
              [-77.68602454299992, 6.870184637000079],
              [-77.68569902299993, 6.861883856000077],
              [-77.68736731699994, 6.853989976000094],
              [-77.69627844999991, 6.849188544000071],
              [-77.70132402299993, 6.918361721000053],
              [-77.69220943899995, 6.947251695000091],
              [-77.66466223899994, 6.959051825000074],
              [-77.65274003799993, 6.976629950000074],
              [-77.66502844999991, 7.015570380000042],
              [-77.69627844999991, 7.07453034100007],
              [-77.70311438699991, 7.07453034100007],
              [-77.69676673099991, 7.062689520000049],
              [-77.69371497299994, 7.058742580000057],
              [-77.68883216099994, 7.054632880000042],
              [-77.68883216099994, 7.04718659100007],
              [-77.69627844999991, 7.04718659100007],
              [-77.71324622299994, 7.070502020000049],
              [-77.78693600199995, 7.148871161000045],
              [-77.79767818899995, 7.15493398600006],
              [-77.81578528599994, 7.157049872000073],
              [-77.82559160099993, 7.162787177000041],
              [-77.83185787699995, 7.17523834800005],
              [-77.83958899599992, 7.187241929000038],
              [-77.85391191299993, 7.191839911000045],
              [-77.84707597599993, 7.198065497000073],
              [-77.85985266799992, 7.201849677000041],
              [-77.87140865799995, 7.211127020000049],
              [-77.88805091099994, 7.232814846000053],
              [-77.89583915073322, 7.235098056585514],
              [-77.85501053899986, 7.365391337000105],
              [-77.8201806239999, 7.476547343000107],
              [-77.79630611199991, 7.471276347000071],
              [-77.77424027499993, 7.474738668000029],
              [-77.75511999499992, 7.486107483000097],
              [-77.74023718299989, 7.504607645000121],
              [-77.73124548399994, 7.530342509000121],
              [-77.73424271699994, 7.551788228000049],
              [-77.7568253179999, 7.595558167000135],
              [-77.76581701699993, 7.626460674000043],
              [-77.7705195719999, 7.6689903770001],
              [-77.7642150479999, 7.705732320000081],
              [-77.74023718299989, 7.718858134000044],
              [-77.72990189699996, 7.713328756000053],
              [-77.6799307869999, 7.670954081000033],
              [-77.67021561799996, 7.659947001000134],
              [-77.67062902899997, 7.65731150400012],
              [-77.67476314299998, 7.64842315700011],
              [-77.67481481999991, 7.644650778000084],
              [-77.6718692629999, 7.64196360300005],
              [-77.6633943279999, 7.639948222000015],
              [-77.66075882999988, 7.63803619400008],
              [-77.63306026199987, 7.60067413400013],
              [-77.62546382699989, 7.587444967000039],
              [-77.6133198659999, 7.537473857000066],
              [-77.60267451999991, 7.526053365000067],
              [-77.57998856699993, 7.528378805000088],
              [-77.55492549699991, 7.548480937000051],
              [-77.50934688399994, 7.594111227000056],
              [-77.36909704599992, 7.680772603],
              [-77.33974483299997, 7.707230937000091],
              [-77.34599768099986, 7.725731099000114],
              [-77.36651322499992, 7.745109762000084],
              [-77.37989742099995, 7.774410299000039],
              [-77.37664180599998, 7.786605937000061],
              [-77.34718623899988, 7.82381296800007],
              [-77.32160640499984, 7.881018779000016],
              [-77.30041906799997, 7.90210276300013],
              [-77.26972326699993, 7.918122457000081],
              [-77.23613358599991, 7.92923289],
              [-77.20605790299993, 7.935485738000096],
              [-77.16900589999997, 7.935072326000096],
              [-77.16326981599991, 7.939258117000037],
              [-77.17107295799994, 7.954916077000078],
              [-77.1808398039999, 7.965148010000064],
              [-77.1915368249999, 7.972847799000064],
              [-77.2012003179999, 7.98199452700004],
              [-77.2077632239999, 7.996567281000097],
              [-77.2096235759999, 8.020700175000059],
              [-77.23106929499994, 8.098731588000064],
              [-77.26011144999993, 8.154025371000088],
              [-77.26943425099992, 8.167700643000046],
              [-77.29519974799987, 8.205495097000068],
              [-77.31690384999987, 8.250841166000086],
              [-77.32434525599987, 8.261202291000103],
              [-77.33716101099986, 8.26662831600008],
              [-77.3504935309999, 8.267403463000093],
              [-77.36320593299993, 8.27208018000006],
              [-77.37436804299998, 8.289314270000133],
              [-77.38299800599992, 8.324945171000124],
              [-77.39126623599986, 8.393545634000063],
              [-77.4057873139999, 8.428453064000053],
              [-77.4223237709999, 8.456410014000141],
              [-77.43271073499992, 8.465065816000092],
              [-77.44960892799992, 8.470646871000014],
              [-77.4796846109999, 8.46785634300005],
              [-77.48872798699995, 8.473644104000115],
              [-77.48867630999993, 8.496536764000055],
              [-77.48035640499995, 8.526199036],
              [-77.4693733009999, 8.537811606000105],
              [-77.44113399299991, 8.567669372000069],
              [-77.42909338499993, 8.59262909000006],
              [-77.43023026499995, 8.610457459000102],
              [-77.43503617399995, 8.620637716000061],
              [-77.43400264499988, 8.628259989000043],
              [-77.41767289299995, 8.638466085000104],
              [-77.40154984599985, 8.642031759000076],
              [-77.38537512199986, 8.643633728000111],
              [-77.37493648399993, 8.6509459440001],
              [-77.37352454299992, 8.664740302000041],
              [-77.37315833199995, 8.669338283000059],
              [-77.37144934799994, 8.67218659100007],
              [-77.36896725199995, 8.674750067000048],
              [-77.36668860599991, 8.678412177000041],
              [-77.35167395699995, 8.669338283000059],
              [-77.34137936099995, 8.632473049000055],
              [-77.32945716099994, 8.61351146000004],
              [-77.31712805899991, 8.601385809000078],
              [-77.30711829299992, 8.589016018000052],
              [-77.29881751199991, 8.574286200000074],
              [-77.29161536399994, 8.555487372000073],
              [-77.28319251199991, 8.516791083000044],
              [-77.2747289699999, 8.495794989000046],
              [-77.20962480399993, 8.451849677000041],
              [-77.15916907499991, 8.431708075000074],
              [-77.14443925699993, 8.421087958000044],
              [-77.13361568899995, 8.408392645000049],
              [-77.0528051419999, 8.276312567000048],
              [-77.03156490799995, 8.25999583500004],
              [-77.01773027299993, 8.257635809000078],
              [-76.98985755099994, 8.25726959800005],
              [-76.98542232999995, 8.25617096600007],
              [-76.97630774599992, 8.253851630000042],
              [-76.97012285099993, 8.266750393000052],
              [-76.96202551999994, 8.266546942000048],
              [-76.95612545499995, 8.256537177000041],
              [-76.95641028599994, 8.240179755000042],
              [-76.96263587099992, 8.240179755000042],
              [-76.96597245999993, 8.243353583000044],
              [-76.97008216099994, 8.24640534100007],
              [-76.97012285099993, 8.22134023600006],
              [-76.96312415299991, 8.203680731000077],
              [-76.95083574099993, 8.197088934000078],
              [-76.93529212099992, 8.20538971600007],
              [-76.93529212099992, 8.184963283000059],
              [-76.92170162699995, 8.19920482000009],
              [-76.91759192599994, 8.188950914000088],
              [-76.92711341099994, 8.172756252000056],
              [-76.92853756399995, 8.15766022300005],
              [-76.93301347599993, 8.15961334800005],
              [-76.94444739499994, 8.162543036000045],
              [-76.94896399599992, 8.164496161000045],
              [-76.94253495999993, 8.128851630000042],
              [-76.91832434799994, 8.11391836100006],
              [-76.89574133999992, 8.117254950000074],
              [-76.89370683499993, 8.136542059000078],
              [-76.83226477799991, 8.136542059000078],
              [-76.83836829299992, 8.127875067000048],
              [-76.84361731699994, 8.117987372000073],
              [-76.84675045499995, 8.107123114000046],
              [-76.84654700399994, 8.095526434000078],
              [-76.83910071499992, 8.095526434000078],
              [-76.83560136599993, 8.098334052000041],
              [-76.82542883999992, 8.103013414000088],
              [-76.82542883999992, 8.095526434000078],
              [-76.86021887899994, 8.082505601000037],
              [-76.86021887899994, 8.075669664000088],
              [-76.85122636599993, 8.074164130000042],
              [-76.84528561099995, 8.071519273000092],
              [-76.83706620999993, 8.06248607000009],
              [-76.83824622299994, 8.06077708500004],
              [-76.83812415299991, 8.057928778000075],
              [-76.83910071499992, 8.054632880000042],
              [-76.84341386599993, 8.059393622000073],
              [-76.84923255099994, 8.062323309000078],
              [-76.85680091099994, 8.063177802000041],
              [-76.86644446499992, 8.061997789000088],
              [-76.85826575399994, 8.053290106000077],
              [-76.84837805899991, 8.047023830000057],
              [-76.83897864499994, 8.039618231000077],
              [-76.83226477799991, 8.027289130000042],
              [-76.85728919199994, 8.039007880000042],
              [-76.88438880099994, 8.04633209800005],
              [-76.90770423099991, 8.044094143000052],
              [-76.92170162699995, 8.027289130000042],
              [-76.92202714799993, 8.023016669000071],
              [-76.92076575399994, 8.021918036000045],
              [-76.91832434799994, 8.021918036000045],
              [-76.91539466099994, 8.021063544000071],
              [-76.93370520699995, 7.964585679000038],
              [-76.90705318899995, 7.929510809000078],
              [-76.8535863919999, 7.91274648600006],
              [-76.79133053299995, 7.911200262000079],
              [-76.77961178299995, 7.913234768000052],
              [-76.7676488919999, 7.91742584800005],
              [-76.75723222599993, 7.923570054000038],
              [-76.75035559799994, 7.931708075000074],
              [-76.74714107999995, 7.940497137000079],
              [-76.74746660099993, 7.946437893000052],
              [-76.74925696499992, 7.952622789000088],
              [-76.75035559799994, 7.962103583000044],
              [-76.74819902299993, 7.970282294000071],
              [-76.73884029899995, 7.980292059000078],
              [-76.73668372299994, 7.989732164000088],
              [-76.73062089799993, 8.051336981000077],
              [-76.73200436099995, 8.079291083000044],
              [-76.74413001199991, 8.103013414000088],
              [-76.74665279899995, 8.09516022300005],
              [-76.74767005099994, 8.089992580000057],
              [-76.74693762899994, 8.084540106000077],
              [-76.74413001199991, 8.075669664000088],
              [-76.75035559799994, 8.075669664000088],
              [-76.75548255099994, 8.091620184000078],
              [-76.75918535099993, 8.11469147300005],
              [-76.75938880099994, 8.137884833000044],
              [-76.74791419199994, 8.171535549000055],
              [-76.75177975199995, 8.192938544000071],
              [-76.76463782499991, 8.225897528000075],
              [-76.77017167899993, 8.258490302000041],
              [-76.77009029899995, 8.398016669000071],
              [-76.77481035099993, 8.416693427000041],
              [-76.78791256399995, 8.424505927000041],
              [-76.8020727199999, 8.430161851000037],
              [-76.80842037699995, 8.444159247000073],
              [-76.81224524599992, 8.46198151200008],
              [-76.81859290299991, 8.47915273600006],
              [-76.83861243399991, 8.500433661000045],
              [-76.86998450399994, 8.521551825000074],
              [-76.90648352799991, 8.538641669000071],
              [-76.93529212099992, 8.541815497000073],
              [-76.93529212099992, 8.534369208000044],
              [-76.94717363199993, 8.545477606000077],
              [-76.93081620999993, 8.570705471000053],
              [-76.90636145699995, 8.599310614000046],
              [-76.89370683499993, 8.620347398000092],
              [-76.79474850199995, 8.651068427000041],
              [-76.77061926999994, 8.65298086100006],
              [-76.67320716099994, 8.68040599200009],
              [-76.6602270169999, 8.687445380000042],
              [-76.65477454299992, 8.695746161000045],
              [-76.65453040299991, 8.706529039000088],
              [-76.65294348899994, 8.718166408000059],
              [-76.64875240799995, 8.728013414000088],
              [-76.64049231699994, 8.733628648000092],
              [-76.64049231699994, 8.739813544000071],
              [-76.64732825399994, 8.739813544000071],
              [-76.64732825399994, 8.747300523000092],
              [-76.6282445949999, 8.750474351000037],
              [-76.56045488199993, 8.77537669500009],
              [-76.54686438699991, 8.784572658000059],
              [-76.50279700399994, 8.828802802000041],
              [-76.45099850199995, 8.864447333000044],
              [-76.42821204299992, 8.884466864000046],
              [-76.42821204299992, 8.890692450000074],
              [-76.43553626199991, 8.90257396000004],
              [-76.42686926999994, 8.910549221000053],
              [-76.36611894399994, 8.925441799000055],
              [-76.34251868399991, 8.939113674000055],
              [-76.32396399599992, 8.941351630000042],
              [-76.31554114499994, 8.947739976000037],
              [-76.31037350199995, 8.957464911000045],
              [-76.30125891799992, 8.96979401200008],
              [-76.26427161399994, 8.99632396000004],
              [-76.25625566299993, 9.007391669000071],
              [-76.26500403599994, 9.042181708000044],
              [-76.25495357999995, 9.070786851000037],
              [-76.23546301999994, 9.093573309000078],
              [-76.20181230399993, 9.123114325000074],
              [-76.19261633999992, 9.134914455000057],
              [-76.18651282499991, 9.149725653000075],
              [-76.17487545499995, 9.232855536000045],
              [-76.16812089799993, 9.246975002000056],
              [-76.16250566299993, 9.248114325000074],
              [-76.13442949099993, 9.258612372000073],
              [-76.12999426999994, 9.261216539000088],
              [-76.11693274599992, 9.265814520000049],
              [-76.11253821499992, 9.27635325700004],
              [-76.11290442599994, 9.294745184000078],
              [-76.11082923099991, 9.312160549000055],
              [-76.10704505099994, 9.321600653000075],
              [-76.09609941299993, 9.333197333000044],
              [-76.08657792899993, 9.339911200000074],
              [-76.07799231699994, 9.343817450000074],
              [-76.03750566299993, 9.356594143000052],
              [-76.00528580399993, 9.366241125000045],
              [-75.97692515699993, 9.382517238000048],
              [-75.9532846219999, 9.402296152000076],
              [-75.95090072999994, 9.42676263900006],
              [-75.9437980429999, 9.440734321000093],
              [-75.9213432869999, 9.438369571000067],
              [-75.90998287699995, 9.428168036000045],
              [-75.87743079299992, 9.42999909100007],
              [-75.84288489499994, 9.43650950700004],
              [-75.81867428299995, 9.446193752000056],
              [-75.81102454299992, 9.443548895000049],
              [-75.80329342399995, 9.43854401200008],
              [-75.79808508999992, 9.430365302000041],
              [-75.79820716099994, 9.41819896000004],
              [-75.81200110599991, 9.424221096000053],
              [-75.82673092399995, 9.42601146000004],
              [-75.84080969999991, 9.42251211100006],
              [-75.8528539699999, 9.412054755000042],
              [-75.84487870999993, 9.406724351000037],
              [-75.83885657499991, 9.404852606000077],
              [-75.83275305899991, 9.40656159100007],
              [-75.82485917899993, 9.412054755000042],
              [-75.81908118399991, 9.40615469000005],
              [-75.81525631399995, 9.40338776200008],
              [-75.81289628799993, 9.39984772300005],
              [-75.81187903599994, 9.391546942000048],
              [-75.78111731699994, 9.41242096600007],
              [-75.76203365799995, 9.421820380000042],
              [-75.73924719999991, 9.425726630000042],
              [-75.71678626199991, 9.422064520000049],
              [-75.6982722649999, 9.416896877000056],
              [-75.69737708199995, 9.41665273600006],
              [-75.67260785199994, 9.409990145000052],
              [-75.6586438729999, 9.41994333000008],
              [-75.6206327729999, 9.452853128000072],
              [-75.59657686899993, 9.49874942300005],
              [-75.57716746499995, 9.56221350900006],
              [-75.57636690399994, 9.62108590400004],
              [-75.58721384199993, 9.648615712000037],
              [-75.59961827099994, 9.663148619000083],
              [-75.60667883999992, 9.669256903000075],
              [-75.61803137899994, 9.689276434000078],
              [-75.63374166599993, 9.689159259000064],
              [-75.64736894399994, 9.699408270000049],
              [-75.65779442699994, 9.705232142000057],
              [-75.67797281199995, 9.704476967000062],
              [-75.69116558099995, 9.699126972000045],
              [-75.70280623999992, 9.690716519000091],
              [-75.70513735399993, 9.700661772000046],
              [-75.64925194099993, 9.756470368000066],
              [-75.63994506199992, 9.783262609000076],
              [-75.62286232299994, 9.83836415400009],
              [-75.62363949699994, 9.861348866000071],
              [-75.6174175619999, 9.882749292000085],
              [-75.60467505199995, 9.91035419900004],
              [-75.5936661149999, 9.943990109000083],
              [-75.58951592099993, 9.964189339000086],
              [-75.58995520699995, 9.984849351000037],
              [-75.57619138599995, 10.041847120000057],
              [-75.57384833999993, 10.07396026400005],
              [-75.58859107299992, 10.10837803600009],
              [-75.58936070599992, 10.128261433000091],
              [-75.5839208829999, 10.135911362000058],
              [-75.58006751199991, 10.139146226000037],
              [-75.5723363919999, 10.140814520000049],
              [-75.56550045499995, 10.144476630000042],
              [-75.56163489499994, 10.149969794000071],
              [-75.55113684799994, 10.172349351000037],
              [-75.54401607999995, 10.18268463700008],
              [-75.54088294199994, 10.18854401200008],
              [-75.53750566299993, 10.199693101000037],
              [-75.53620357999995, 10.211004950000074],
              [-75.53636633999992, 10.22101471600007],
              [-75.53551184799994, 10.230617580000057],
              [-75.53066972599993, 10.240668036000045],
              [-75.56285467299995, 10.223084992000054],
              [-75.60400224599994, 10.19612483800006],
              [-75.64378608699991, 10.154375703000085],
              [-75.6848801079999, 10.131519625000067],
              [-75.70357664599993, 10.134428033000063],
              [-75.6889223259999, 10.167966257000046],
              [-75.6601497389999, 10.184107151000092],
              [-75.64644230099992, 10.193508987000087],
              [-75.63768469999991, 10.203680731000077],
              [-75.63084876199991, 10.213446356000077],
              [-75.62535559799994, 10.225816148000092],
              [-75.61632239499994, 10.237534898000092],
              [-75.61363684799994, 10.24876536700009],
              [-75.61774654899995, 10.261135158000059],
              [-75.61510169199994, 10.26951732000009],
              [-75.59215247299994, 10.26862213700008],
              [-75.59752356699994, 10.277004299000055],
              [-75.59935462099992, 10.285630601000037],
              [-75.59752356699994, 10.29437897300005],
              [-75.59215247299994, 10.30272044500009],
              [-75.58381100199995, 10.282375393000052],
              [-75.56338456899994, 10.28709544500009],
              [-75.52725175699993, 10.30955638200004],
              [-75.5156957669999, 10.31899648600006],
              [-75.51642818899995, 10.341457424000055],
              [-75.52179928299995, 10.368394273000092],
              [-75.52383378799993, 10.391506252000056],
              [-75.53066972599993, 10.391506252000056],
              [-75.53917395699995, 10.386297919000071],
              [-75.54430091099994, 10.393011786000045],
              [-75.55113684799994, 10.419419664000088],
              [-75.55797278599994, 10.419419664000088],
              [-75.56094316299993, 10.409857489000046],
              [-75.56419837099992, 10.403713283000059],
              [-75.56940670499995, 10.400132554000038],
              [-75.57848059799994, 10.39834219000005],
              [-75.57469641799992, 10.40688711100006],
              [-75.56940670499995, 10.425279039000088],
              [-75.56550045499995, 10.43305084800005],
              [-75.55931555899991, 10.438950914000088],
              [-75.54710852799991, 10.444240627000056],
              [-75.54059811099995, 10.44985586100006],
              [-75.51211503799993, 10.481675523000092],
              [-75.50275631399995, 10.48773834800005],
              [-75.50796464799993, 10.470851955000057],
              [-75.51866614499994, 10.45026276200008],
              [-75.52220618399991, 10.432928778000075],
              [-75.50649980399993, 10.425604559000078],
              [-75.49327551999994, 10.43463776200008],
              [-75.48713131399995, 10.455877997000073],
              [-75.48631751199991, 10.480943101000037],
              [-75.48912512899994, 10.501369533000059],
              [-75.49327551999994, 10.505682684000078],
              [-75.50035559799994, 10.507391669000071],
              [-75.51024329299992, 10.508205471000053],
              [-75.50963294199994, 10.514105536000045],
              [-75.50413977799991, 10.526841539000088],
              [-75.50275631399995, 10.52928294500009],
              [-75.50438391799992, 10.540716864000046],
              [-75.50446529899995, 10.551581122000073],
              [-75.50812740799995, 10.55963776200008],
              [-75.52049719999991, 10.56281159100007],
              [-75.52452551999994, 10.567084052000041],
              [-75.5196020169999, 10.57648346600007],
              [-75.5098363919999, 10.58584219000005],
              [-75.49962317599994, 10.59007396000004],
              [-75.48802649599992, 10.591620184000078],
              [-75.47549394399994, 10.59601471600007],
              [-75.46385657499991, 10.602728583000044],
              [-75.45494544199994, 10.61123281500005],
              [-75.45482337099992, 10.616400458000044],
              [-75.46251380099994, 10.626450914000088],
              [-75.46182206899994, 10.631048895000049],
              [-75.45864824099993, 10.633002020000049],
              [-75.45099850199995, 10.635891018000052],
              [-75.44810950399994, 10.637884833000044],
              [-75.43956458199995, 10.64203522300005],
              [-75.43089758999992, 10.64134349200009],
              [-75.42418372299994, 10.64329661700009],
              [-75.42145748599995, 10.65525950700004],
              [-75.41771399599992, 10.65570709800005],
              [-75.41002356699994, 10.664618231000077],
              [-75.40367591099994, 10.675034898000092],
              [-75.40379798099991, 10.680121161000045],
              [-75.39757239499994, 10.68187083500004],
              [-75.37303626199991, 10.693101304000038],
              [-75.30728105399993, 10.709540106000077],
              [-75.29735266799992, 10.717352606000077],
              [-75.28746497299994, 10.73346588700008],
              [-75.27961178299995, 10.742743231000077],
              [-75.27375240799995, 10.744330145000049],
              [-75.26878821499992, 10.741400458000044],
              [-75.26305091099994, 10.739813544000071],
              [-75.25829016799992, 10.737127997000073],
              [-75.25633704299992, 10.731024481000077],
              [-75.25845292899993, 10.72719961100006],
              [-75.26203365799995, 10.724188544000071],
              [-75.26276607999995, 10.720282294000071],
              [-75.25633704299992, 10.71360911700009],
              [-75.25633704299992, 10.709336656000062],
              [-75.25633704299992, 10.706773179000038],
              [-75.24950110599991, 10.706773179000038],
              [-75.24376380099994, 10.71474844000005],
              [-75.22223873599995, 10.73468659100007],
              [-75.22638912699995, 10.74282461100006],
              [-75.22866777299993, 10.750067450000074],
              [-75.22972571499992, 10.75804271000004],
              [-75.22964433499993, 10.768255927000041],
              [-75.24518795499995, 10.75495026200008],
              [-75.24950110599991, 10.747748114000046],
              [-75.27000891799992, 10.759100653000075],
              [-75.27554277299993, 10.777777411000045],
              [-75.26740475199995, 10.795314846000053],
              [-75.23167883999992, 10.807318427000041],
              [-75.21568762899994, 10.826605536000045],
              [-75.20482337099992, 10.830959377000056],
              [-75.1934301419999, 10.831854559000078],
              [-75.18224036399994, 10.834540106000077],
              [-75.17137610599991, 10.838812567000048],
              [-75.10798092399995, 10.880438544000071],
              [-75.06989498599995, 10.889553127000056],
              [-75.04954993399991, 10.901190497000073],
              [-75.03595943899995, 10.916693427000041],
              [-75.03722083199995, 10.93268463700008],
              [-75.03282630099994, 10.942694403000075],
              [-75.02774003799993, 10.965521552000041],
              [-75.02358964799993, 10.974310614000046],
              [-75.01414954299992, 10.980414130000042],
              [-75.00039628799993, 10.986395575000074],
              [-74.98197123199992, 10.987428285000078],
              [-74.96280927999993, 10.994894226000042],
              [-74.95001692999995, 11.009460454000077],
              [-74.92571787299994, 11.028578244000073],
              [-74.92357057499993, 11.045671746000039],
              [-74.89550253899995, 11.045590797000045],
              [-74.86151017299994, 11.048833740000077],
              [-74.84533802499993, 11.062129538000079],
              [-74.84699246499991, 11.080480967000085],
              [-74.84822490999994, 11.09800148000005],
              [-74.8503366509999, 11.103430570000057],
              [-74.84437231499993, 11.10966965700004],
              [-74.81933586399992, 11.097919317000049],
              [-74.79675052199991, 11.090365157000065],
              [-74.7431737469999, 11.072652528000049],
              [-74.6454242339999, 11.033087540000054],
              [-74.5722998359999, 11.008623930000056],
              [-74.5229509159999, 10.99592434100009],
              [-74.47126217399995, 10.98969147300005],
              [-74.40347245999993, 10.982855536000045],
              [-74.33726966099994, 10.98696523600006],
              [-74.29782954799992, 10.991499283000053],
              [-74.31240800699993, 10.980943101000037],
              [-74.36180579299992, 10.97166575700004],
              [-74.45815995999993, 10.974310614000046],
              [-74.46983801999994, 10.976060289000088],
              [-74.48078365799995, 10.978949286000045],
              [-74.49156653599994, 10.97947825700004],
              [-74.50283769399994, 10.974310614000046],
              [-74.50576738199993, 10.965765692000048],
              [-74.50450598899994, 10.95416901200008],
              [-74.50503495999993, 10.943915106000077],
              [-74.51341712099992, 10.939601955000057],
              [-74.51744544199994, 10.926662502000056],
              [-74.50633704299992, 10.897772528000075],
              [-74.4817602199999, 10.850816148000092],
              [-74.49714107999995, 10.858954169000071],
              [-74.51170813699991, 10.87445709800005],
              [-74.52501380099994, 10.88344961100006],
              [-74.53636633999992, 10.871893622000073],
              [-74.54336503799993, 10.881415106000077],
              [-74.56720943899995, 10.881415106000077],
              [-74.5813695949999, 10.888088283000059],
              [-74.58922278599994, 10.88467031500005],
              [-74.5969945949999, 10.86782461100006],
              [-74.60289466099994, 10.84756094000005],
              [-74.60521399599992, 10.834051825000074],
              [-74.60635331899994, 10.803656317000048],
              [-74.60460364499994, 10.789007880000042],
              [-74.59845943899995, 10.781927802000041],
              [-74.58462480399993, 10.786851304000038],
              [-74.57872473899994, 10.802557684000078],
              [-74.57420813699991, 10.820135809000078],
              [-74.56427975199995, 10.830959377000056],
              [-74.56432044199994, 10.820502020000049],
              [-74.56090247299994, 10.813421942000048],
              [-74.5540258449999, 10.80955638200004],
              [-74.54381262899994, 10.80923086100006],
              [-74.54552161399994, 10.799383856000077],
              [-74.54381262899994, 10.76203034100007],
              [-74.52855383999992, 10.755275783000059],
              [-74.51231848899994, 10.756008205000057],
              [-74.49966386599993, 10.76471588700008],
              [-74.4954320949999, 10.781927802000041],
              [-74.50674394399994, 10.775783596000053],
              [-74.51561438699991, 10.778225002000056],
              [-74.52131100199995, 10.78774648600006],
              [-74.52330481699994, 10.80296458500004],
              [-74.51927649599992, 10.816066799000055],
              [-74.51146399599992, 10.825100002000056],
              [-74.50617428299995, 10.833482164000088],
              [-74.50963294199994, 10.844549872000073],
              [-74.48965410099993, 10.841050523000092],
              [-74.47712154899995, 10.82758209800005],
              [-74.47057044199994, 10.807847398000092],
              [-74.46568762899994, 10.75967031500005],
              [-74.45661373599995, 10.74803294500009],
              [-74.4414770169999, 10.745835679000038],
              [-74.40208899599992, 10.74803294500009],
              [-74.39509029899995, 10.749497789000088],
              [-74.38556881399995, 10.754584052000041],
              [-74.36656653599994, 10.772772528000075],
              [-74.36217200399994, 10.77570221600007],
              [-74.36001542899993, 10.784816799000055],
              [-74.33092200399994, 10.837144273000092],
              [-74.33006751199991, 10.844305731000077],
              [-74.33092200399994, 10.871893622000073],
              [-74.3196508449999, 10.893703518000052],
              [-74.31786048099991, 10.902004299000055],
              [-74.31460527299993, 10.907171942000048],
              [-74.30060787699995, 10.923488674000055],
              [-74.29735266799992, 10.929348049000055],
              [-74.28990637899994, 10.967474677000041],
              [-74.28042558499993, 10.989732164000088],
              [-74.21812903599994, 11.07908763200004],
              [-74.2149145169999, 11.08698151200008],
              [-74.21784420499995, 11.098822333000044],
              [-74.23180091099994, 11.115708726000037],
              [-74.23595130099994, 11.125148830000057],
              [-74.23570716099994, 11.135972398000092],
              [-74.22996985599991, 11.153021552000041],
              [-74.22850501199991, 11.16274648600006],
              [-74.23037675699993, 11.172674872000073],
              [-74.23932857999995, 11.190741278000075],
              [-74.24217688699991, 11.20026276200008],
              [-74.24034583199995, 11.204250393000052],
              [-74.23070227799991, 11.212836005000042],
              [-74.22850501199991, 11.217678127000056],
              [-74.22964433499993, 11.223537502000056],
              [-74.23224850199995, 11.226304429000038],
              [-74.23477128799993, 11.228013414000088],
              [-74.23595130099994, 11.230658270000049],
              [-74.23363196499992, 11.241156317000048],
              [-74.22813880099994, 11.250881252000056],
              [-74.2149145169999, 11.269110419000071],
              [-74.20962480399993, 11.27484772300005],
              [-74.20506751199991, 11.27765534100007],
              [-74.20177161399994, 11.282049872000073],
              [-74.20055091099994, 11.292710679000038],
              [-74.18748938699991, 11.316961981000077],
              [-74.17186438699991, 11.318101304000038],
              [-74.15900631399995, 11.315130927000041],
              [-74.15184485599991, 11.319728908000059],
              [-74.15339107999995, 11.34365469000005],
              [-74.14590410099993, 11.34365469000005],
              [-74.14533443899995, 11.337225653000075],
              [-74.14366614499994, 11.332953192000048],
              [-74.13906816299993, 11.323716539000088],
              [-74.12848873599995, 11.337836005000042],
              [-74.12608801999994, 11.34365469000005],
              [-74.12271074099993, 11.341538804000038],
              [-74.12149003799993, 11.341498114000046],
              [-74.12071692599994, 11.341009833000044],
              [-74.11864173099991, 11.337388414000088],
              [-74.11241614499994, 11.337388414000088],
              [-74.11241614499994, 11.357896226000037],
              [-74.10244706899994, 11.34992096600007],
              [-74.09487870999993, 11.334418036000045],
              [-74.08385169199994, 11.330633856000077],
              [-74.07412675699993, 11.33539459800005],
              [-74.06956946499992, 11.345770575000074],
              [-74.06541907499991, 11.351752020000049],
              [-74.05719967399995, 11.34365469000005],
              [-74.04971269399994, 11.34365469000005],
              [-74.04792232999995, 11.350816148000092],
              [-74.04401607999995, 11.354641018000052],
              [-74.03799394399994, 11.356390692000048],
              [-74.02989661399994, 11.357896226000037],
              [-74.00462805899991, 11.355292059000078],
              [-73.98525956899994, 11.347805080000057],
              [-73.96849524599992, 11.33592357000009],
              [-73.95103919199994, 11.32029857000009],
              [-73.94359290299991, 11.31736888200004],
              [-73.8977758449999, 11.30768463700008],
              [-73.86538652299993, 11.289007880000042],
              [-73.82603919199994, 11.276760158000059],
              [-73.7051488919999, 11.268255927000041],
              [-73.59239661399994, 11.277044989000046],
              [-73.56558183499993, 11.277085679000038],
              [-73.40249589799993, 11.27724844000005],
              [-73.29238847599993, 11.29401276200008],
              [-73.28258216099994, 11.29954661700009],
              [-73.27619381399995, 11.30805084800005],
              [-73.24575761599993, 11.330877997000073],
              [-73.2200414699999, 11.344875393000052],
              [-73.21495520699995, 11.348944403000075],
              [-73.20742753799993, 11.357896226000037],
              [-73.19566809799994, 11.38157786700009],
              [-73.19066321499992, 11.385199286000045],
              [-73.1790258449999, 11.388617255000042],
              [-73.17027747299994, 11.396877346000053],
              [-73.15623938699991, 11.41624583500004],
              [-73.14525305899991, 11.425523179000038],
              [-73.11188717399995, 11.44041575700004],
              [-73.05483964799993, 11.493963934000078],
              [-72.93399003799993, 11.556789455000057],
              [-72.75967363199993, 11.697088934000078],
              [-72.74132239499994, 11.707953192000048],
              [-72.70470130099994, 11.720363674000055],
              [-72.64391028599994, 11.733303127000056],
              [-72.62832597599993, 11.740423895000049],
              [-72.59797115799995, 11.76194896000004],
              [-72.5774633449999, 11.756048895000049],
              [-72.55626380099994, 11.76658763200004],
              [-72.53433183499993, 11.781642971000053],
              [-72.51162675699993, 11.789252020000049],
              [-72.45205644399994, 11.79132721600007],
              [-72.43346106699994, 11.796087958000044],
              [-72.41759192599994, 11.805121161000045],
              [-72.39199785099993, 11.826117255000042],
              [-72.35960852799991, 11.83397044500009],
              [-72.31615149599992, 11.864976304000038],
              [-72.26305091099994, 11.885972398000092],
              [-72.25055904899995, 11.901678778000075],
              [-72.23216712099992, 11.919745184000078],
              [-72.22801673099991, 11.930161851000037],
              [-72.22630774599992, 11.938950914000088],
              [-72.21373450399994, 11.97483958500004],
              [-72.17796790299991, 12.029852606000077],
              [-72.16787675699993, 12.063381252000056],
              [-72.14549719999991, 12.09251536700009],
              [-72.13866126199991, 12.10455963700008],
              [-72.13711503799993, 12.12409088700008],
              [-72.14122473899994, 12.18032461100006],
              [-72.14541581899994, 12.200832424000055],
              [-72.15111243399991, 12.208482164000088],
              [-72.16051184799994, 12.216538804000038],
              [-72.1692602199999, 12.221828518000052],
              [-72.17275956899994, 12.221258856000077],
              [-72.17052161399994, 12.23427969000005],
              [-72.16197669199994, 12.242865302000041],
              [-72.13866126199991, 12.256048895000049],
              [-72.10753333199995, 12.245021877000056],
              [-72.00487219999991, 12.262884833000044],
              [-71.96963456899994, 12.255113023000092],
              [-71.97354081899994, 12.23655833500004],
              [-72.01512610599991, 12.19399648600006],
              [-72.00015214799993, 12.186224677000041],
              [-71.98485266799992, 12.160956122000073],
              [-71.96727454299992, 12.153021552000041],
              [-71.93761145699995, 12.166449286000045],
              [-71.93252519399994, 12.169745184000078],
              [-71.92992102799991, 12.182766018000052],
              [-71.92324785099993, 12.19407786700009],
              [-71.91441809799994, 12.202785549000055],
              [-71.90526282499991, 12.20766836100006],
              [-71.89232337099992, 12.208319403000075],
              [-71.87877356699994, 12.206773179000038],
              [-71.86803137899994, 12.208238023000092],
              [-71.86363684799994, 12.21784088700008],
              [-71.86766516799992, 12.228094794000071],
              [-71.87486731699994, 12.237127997000073],
              [-71.87832597599993, 12.246039130000042],
              [-71.87108313699991, 12.256048895000049],
              [-71.88121497299994, 12.263861395000049],
              [-71.88658606699994, 12.271307684000078],
              [-71.89273027299993, 12.277777411000045],
              [-71.90526282499991, 12.282700914000088],
              [-71.91832434799994, 12.28392161700009],
              [-71.93065344999991, 12.28188711100006],
              [-71.9407445949999, 12.276922919000071],
              [-71.94684811099995, 12.269029039000088],
              [-71.95303300699993, 12.269029039000088],
              [-71.96051998599995, 12.282700914000088],
              [-71.91478430899991, 12.313625393000052],
              [-71.87791907499991, 12.34479401200008],
              [-71.87547766799992, 12.349554755000042],
              [-71.87124589799993, 12.362616278000075],
              [-71.86742102799991, 12.365301825000074],
              [-71.84943600199995, 12.36432526200008],
              [-71.84439042899993, 12.365301825000074],
              [-71.82909094999991, 12.376206773000092],
              [-71.82091223899994, 12.377875067000048],
              [-71.80907141799992, 12.37213776200008],
              [-71.82681230399993, 12.363348700000074],
              [-71.84007727799991, 12.351711330000057],
              [-71.84312903599994, 12.338080145000049],
              [-71.8301488919999, 12.32367584800005],
              [-71.82286536399994, 12.319810289000088],
              [-71.8176977199999, 12.319281317000048],
              [-71.80284583199995, 12.32367584800005],
              [-71.80182857999995, 12.32640208500004],
              [-71.80296790299991, 12.331244208000044],
              [-71.80321204299992, 12.335882880000042],
              [-71.79942786399994, 12.337958075000074],
              [-71.78538977799991, 12.337144273000092],
              [-71.78172766799992, 12.337958075000074],
              [-71.76329505099994, 12.347601630000042],
              [-71.75108801999994, 12.35618724200009],
              [-71.74404863199993, 12.367621161000045],
              [-71.74079342399995, 12.38572825700004],
              [-71.74339758999992, 12.387193101000037],
              [-71.74868730399993, 12.387844143000052],
              [-71.75182044199994, 12.390814520000049],
              [-71.74819902299993, 12.39940013200004],
              [-71.7415258449999, 12.405747789000088],
              [-71.73253333199995, 12.410223700000074],
              [-71.72276770699995, 12.412787177000041],
              [-71.71344967399995, 12.413723049000055],
              [-71.71983801999994, 12.395982164000088],
              [-71.71377519399994, 12.38703034100007],
              [-71.70421301999994, 12.37921784100007],
              [-71.69981848899994, 12.365301825000074],
              [-71.69359290299991, 12.365301825000074],
              [-71.69098873599995, 12.368963934000078],
              [-71.68708248599995, 12.375921942000048],
              [-71.68545488199993, 12.38271719000005],
              [-71.68984941299993, 12.38572825700004],
              [-71.69676673099991, 12.38812897300005],
              [-71.69163977799991, 12.393377997000073],
              [-71.68297278599994, 12.398138739000046],
              [-71.67931067599994, 12.39940013200004],
              [-71.66759192599994, 12.405747789000088],
              [-71.65379798099991, 12.41006094000005],
              [-71.64073645699995, 12.415961005000042],
              [-71.6309301419999, 12.427394924000055],
              [-71.64338131399995, 12.425970770000049],
              [-71.65387936099995, 12.421210028000075],
              [-71.66234290299991, 12.416083075000074],
              [-71.66877193899995, 12.413723049000055],
              [-71.67910722599993, 12.41697825700004],
              [-71.67731686099995, 12.42479075700004],
              [-71.66869055899991, 12.433742580000057],
              [-71.65880286399994, 12.440375067000048],
              [-71.67007402299993, 12.44041575700004],
              [-71.68008378799993, 12.438381252000056],
              [-71.68809973899994, 12.434068101000037],
              [-71.69359290299991, 12.427394924000055],
              [-71.69188391799992, 12.443426825000074],
              [-71.69025631399995, 12.449164130000042],
              [-71.68614661399994, 12.454657294000071],
              [-71.6992895169999, 12.44627513200004],
              [-71.72569739499994, 12.423488674000055],
              [-71.73452714799993, 12.413723049000055],
              [-71.74079342399995, 12.41990794500009],
              [-71.7305395169999, 12.438055731000077],
              [-71.71572831899994, 12.453517971000053],
              [-71.69725501199991, 12.46430084800005],
              [-71.67560787699995, 12.468329169000071],
              [-71.65615800699993, 12.465318101000037],
              [-71.62608801999994, 12.45148346600007],
              [-71.60415605399993, 12.447211005000042],
              [-71.53160559799994, 12.447211005000042],
              [-71.51130123599995, 12.44326406500005],
              [-71.49063066299993, 12.43382396000004],
              [-71.45958411399994, 12.413723049000055],
              [-71.44595292899993, 12.400580145000049],
              [-71.43907630099994, 12.396185614000046],
              [-71.42609615799995, 12.39256419500009],
              [-71.39024817599994, 12.39329661700009],
              [-71.38109290299991, 12.389146226000037],
              [-71.36123613199993, 12.37445709800005],
              [-71.34093176999994, 12.36717357000009],
              [-71.29515540299991, 12.35846588700008],
              [-71.26183020699995, 12.341864325000074],
              [-71.24229895699995, 12.327704169000071],
              [-71.23159745999993, 12.31085846600007],
              [-71.22716223899994, 12.30540599200009],
              [-71.22264563699991, 12.297308661000045],
              [-71.21906490799995, 12.278265692000048],
              [-71.15843665299991, 12.176703192000048],
              [-71.15172278599994, 12.149603583000044],
              [-71.11388098899994, 12.09438711100006],
              [-71.1074926419999, 12.07493724200009],
              [-71.11367753799993, 12.052394924000055],
              [-71.12608801999994, 12.031195380000042],
              [-71.13809160099993, 12.015814520000049],
              [-71.16490637899994, 11.996161200000074],
              [-71.23399817599994, 11.95888906500005],
              [-71.25413977799991, 11.93695709800005],
              [-71.26866614499994, 11.929185289000088],
              [-71.28563391799992, 11.92291901200008],
              [-71.29881751199991, 11.92023346600007],
              [-71.30357825399994, 11.911688544000071],
              [-71.32306881399995, 11.85814036700009],
              [-71.3274633449999, 11.850083726000037],
              [-71.32750653346986, 11.849997690578633],
              [-71.3576293539999, 11.850802307000023],
              [-71.37545772399992, 11.841087138000077],
              [-71.40966752199992, 11.812303365000062],
              [-71.44945837399993, 11.795456848000086],
              [-71.47648514899987, 11.788583883000115],
              [-71.5350862229999, 11.773546041000131],
              [-71.59363562099992, 11.758508199000048],
              [-71.65228837099994, 11.743573710000092],
              [-71.71088944499988, 11.728535868000094],
              [-71.76943884299988, 11.713549703000126],
              [-71.8280399169999, 11.698563538000059],
              [-71.88664099199991, 11.683525696000075],
              [-71.94524206599993, 11.668539530000103],
              [-71.97108028199995, 11.661924948000106],
              [-71.99061397399987, 11.649057516000099],
              [-72.00792557899987, 11.624614563000065],
              [-72.01800248299992, 11.606114400000138],
              [-72.0478197839999, 11.551311544000058],
              [-72.0776370849999, 11.496534526000062],
              [-72.1074543869999, 11.441757507000077],
              [-72.13727168799991, 11.386980489000095],
              [-72.16708898999991, 11.332203471000113],
              [-72.19690629099992, 11.27740061400003],
              [-72.22677526899994, 11.222571920000036],
              [-72.25659256999992, 11.16779490200014],
              [-72.26708288599988, 11.154901632000048],
              [-72.28465287299986, 11.150457458000034],
              [-72.32185990499997, 11.160095113000054],
              [-72.34134191899994, 11.162110494000103],
              [-72.36144405099992, 11.158002218000078],
              [-72.41699621599992, 11.137615865000043],
              [-72.45999100799989, 11.135807190000051],
              [-72.48148840299984, 11.132525737000066],
              [-72.49931677299989, 11.12079518700007],
              [-72.5038126229999, 11.111777649000118],
              [-72.50469112199994, 11.09270904500005],
              [-72.50748164899991, 11.082993876000103],
              [-72.51502640899986, 11.072477722000144],
              [-72.53393998199991, 11.052375590000082],
              [-72.5420531829999, 11.041084290000114],
              [-72.57646968599994, 10.957368469000073],
              [-72.59450476099994, 10.932977193000042],
              [-72.6131082769999, 10.915252177000127],
              [-72.65672318499995, 10.885202332000063],
              [-72.6829748129999, 10.855617575000025],
              [-72.70612585499987, 10.81125335700007],
              [-72.75439164199989, 10.674853414000012],
              [-72.78141841699994, 10.631316020000085],
              [-72.84301672399997, 10.560596822000065],
              [-72.86141353399995, 10.508093567000103],
              [-72.87541784699997, 10.489645081000091],
              [-72.89200598199997, 10.472927755000043],
              [-72.90756058799991, 10.452463888000082],
              [-72.9148986409999, 10.432904358000073],
              [-72.91523210499986, 10.428171730000088],
              [-72.91624222799996, 10.413835755000093],
              [-72.91551875899995, 10.39427622500007],
              [-72.93562089099993, 10.175193991000057],
              [-72.98771073399988, 9.999416606000082],
              [-72.98786576399993, 9.960426738000095],
              [-72.99618566899989, 9.921281840000063],
              [-72.99696081499991, 9.900714620000073],
              [-72.99044958499994, 9.874979757000077],
              [-72.98161291499991, 9.856557108000075],
              [-72.97763382999995, 9.838056946000052],
              [-72.98554032399989, 9.81216705300011],
              [-73.01690791899992, 9.748605041000047],
              [-73.07189164299987, 9.664088237000072],
              [-73.09716141799993, 9.596366272000083],
              [-73.10765173399997, 9.577995301000087],
              [-73.12361975099992, 9.56125213700004],
              [-73.1637206629999, 9.536344096000064],
              [-73.17844844599992, 9.523037415000147],
              [-73.19741369699994, 9.478673197000091],
              [-73.27740881299991, 9.361806946000044],
              [-73.31177364099995, 9.276230774000098],
              [-73.32438269099995, 9.255921936000078],
              [-73.3421593839999, 9.239178772000031],
              [-73.37910803299994, 9.213883159000147],
              [-73.39083858299992, 9.194504496000093],
              [-73.39114864099992, 9.172774556000078],
              [-73.37781612199987, 9.164687195000084],
              [-73.36364498199993, 9.165032761000077],
              [-73.25384436099989, 9.1677102660001],
              [-73.21224483299989, 9.173446350000063],
              [-73.17617468299989, 9.19093882300011],
              [-73.14186153199995, 9.223029887000038],
              [-73.12434322199991, 9.23447621700005],
              [-73.09876338799995, 9.241581727000082],
              [-73.07602575699988, 9.254268290000127],
              [-73.03266923099991, 9.294601746000083],
              [-73.00972489499986, 9.295376892000093],
              [-73.00357539899989, 9.287909648000067],
              [-72.9911213789999, 9.251684468000121],
              [-72.9914314369999, 9.247937927000109],
              [-72.9954621999999, 9.239101258000105],
              [-72.99561722799993, 9.235354716000089],
              [-72.99220658399992, 9.230342102000122],
              [-72.98285314999987, 9.220962830000076],
              [-72.9800626229999, 9.216518656000076],
              [-72.97603186099991, 9.192127380000045],
              [-72.97866735899993, 9.15014028000013],
              [-72.97318965699995, 9.128436178000044],
              [-72.95530961199998, 9.103993225000096],
              [-72.93639603699995, 9.099187317000087],
              [-72.91619055199996, 9.106964621000103],
              [-72.88198075399995, 9.129366353000094],
              [-72.87402258299988, 9.133422954000096],
              [-72.86172359299985, 9.137040304000081],
              [-72.85025142399994, 9.136730245000095],
              [-72.84151810799995, 9.133784688000091],
              [-72.83412837799995, 9.13362965900005],
              [-72.82668697199992, 9.141691182000045],
              [-72.80767004399988, 9.12373362200006],
              [-72.79103023299984, 9.113940939000102],
              [-72.78560420799997, 9.102442933000077],
              [-72.8000219329999, 9.079446920000123],
              [-72.78307206299988, 9.059939067000116],
              [-72.77805944899993, 9.04105133100009],
              [-72.7665872799999, 8.997384746000122],
              [-72.75506343599997, 8.953743998000078],
              [-72.74353959199993, 8.910051575000097],
              [-72.73206742399992, 8.866384990000128],
              [-72.7204919029999, 8.822744243000074],
              [-72.70901973499986, 8.779051819000102],
              [-72.69749589099993, 8.735385234000134],
              [-72.68602372299992, 8.691692810000077],
              [-72.67543005399995, 8.651514384000052],
              [-72.6554312749999, 8.617898865000114],
              [-72.63708614099991, 8.598184306000064],
              [-72.61734574499985, 8.577048645000033],
              [-72.59776037699993, 8.55596466100009],
              [-72.57807165599988, 8.534854839000062],
              [-72.55853796399987, 8.513719178000116],
              [-72.53884924399992, 8.492609355000084],
              [-72.51921219999988, 8.471525371000055],
              [-72.49952347899995, 8.450441386000122],
              [-72.47993811099991, 8.42933156300009],
              [-72.45627030499989, 8.403932597000079],
              [-72.44453975399989, 8.394114075000118],
              [-72.43441117399993, 8.390186666000147],
              [-72.42495438699987, 8.387706197000071],
              [-72.4156092069999, 8.382691114000082],
              [-72.4150841879999, 8.382409363000136],
              [-72.40325028599997, 8.3704979460001],
              [-72.39353511599995, 8.355382589000087],
              [-72.3867655029999, 8.33861358700004],
              [-72.38397497599993, 8.321792908000063],
              [-72.38583532799996, 8.305514831000053],
              [-72.39477535099988, 8.272803650000057],
              [-72.39596390799991, 8.256603088000062],
              [-72.39053788299992, 8.234330546000095],
              [-72.3572582599999, 8.172137960000015],
              [-72.33576086499994, 8.10389923100007],
              [-72.33384883599993, 8.065477804000125],
              [-72.35007523599992, 8.042585144000014],
              [-72.36723181199989, 8.042688497000128],
              [-72.38831579699993, 8.046176657000075],
              [-72.40707434199993, 8.043773702000124],
              [-72.41709956899984, 8.025764465000037],
              [-72.42185380099994, 8.006230774000116],
              [-72.43012202999998, 7.990521139000066],
              [-72.44190425699989, 7.977136942000115],
              [-72.45673539199993, 7.964941304000106],
              [-72.46743241399992, 7.959670309000074],
              [-72.47880122899991, 7.955536194000061],
              [-72.48779292899985, 7.949179993000115],
              [-72.49120357299998, 7.937501119000061],
              [-72.48665604699994, 7.928716126000069],
              [-72.46567541499985, 7.904583232000107],
              [-72.45864741999992, 7.893524475000106],
              [-72.45446162999991, 7.87616119400009],
              [-72.45177445499988, 7.832804667000104],
              [-72.45415157099993, 7.815234681000035],
              [-72.47415034999995, 7.754153137000046],
              [-72.48334875499995, 7.649353333000064],
              [-72.48040319899985, 7.628941142000116],
              [-72.46681229699996, 7.589873759000099],
              [-72.46340165199993, 7.570753479000103],
              [-72.46738073799992, 7.548739319000035],
              [-72.47590734899993, 7.528637187000058],
              [-72.48200516799997, 7.508018290000066],
              [-72.4786978759999, 7.484453837000061],
              [-72.45130936699994, 7.440218811000136],
              [-72.41461909999987, 7.413812155000059],
              [-72.39581243299989, 7.407491518000143],
              [-72.37079748599987, 7.399084371000058],
              [-72.32180822799995, 7.390040995000106],
              [-72.23969437699995, 7.391281230000047],
              [-72.20620804899994, 7.381876119000083],
              [-72.17168819199986, 7.337331034000087],
              [-72.16631384399992, 7.334075419000101],
              [-72.16404007999998, 7.328856099000078],
              [-72.17349686699995, 7.28818674700004],
              [-72.17422033799994, 7.279608460000091],
              [-72.17148148699991, 7.249894511000122],
              [-72.16414343299991, 7.22080068000011],
              [-72.15334305799988, 7.192585348000051],
              [-72.09825598199993, 7.086752014000098],
              [-72.08099605299992, 7.066598206000023],
              [-72.06957556199993, 7.059208476000023],
              [-72.04208369999995, 7.046909485000072],
              [-72.02869950399992, 7.038847962000077],
              [-72.00529007999995, 7.019107564000109],
              [-71.99399817999992, 7.012952970000072],
              [-71.99381791199994, 7.012854716000021],
              [-71.9640207169999, 7.005920692000061],
              [-71.8810082599999, 6.986603089000084],
              [-71.84819372599986, 6.983864238000137],
              [-71.83263911999995, 6.986448059000054],
              [-71.82189042199991, 6.992959290000016],
              [-71.81212357599986, 7.001175842000052],
              [-71.79961787899987, 7.009185689000034],
              [-71.78855912299989, 7.009702454000063],
              [-71.77775874899993, 7.007532044000072],
              [-71.77150589999994, 7.011149394000057],
              [-71.77403804599993, 7.028926086000084],
              [-71.74535762499994, 7.029339498000098],
              [-71.72168981999991, 7.03342193600011],
              [-71.69802201399997, 7.034972229000033],
              [-71.66959997599994, 7.027737529000063],
              [-71.67352738499991, 7.044222310000052],
              [-71.66701615399995, 7.051508688000112],
              [-71.65430375199989, 7.053369039000117],
              [-71.62040401299987, 7.052128805000095],
              [-71.61218745999994, 7.046341044000116],
              [-71.60650305199991, 7.038279521000035],
              [-71.5947208259999, 7.030114645000111],
              [-71.58779618299991, 7.029287821000082],
              [-71.58061315999987, 7.031561584000102],
              [-71.56707393499988, 7.039313050000104],
              [-71.55844396999993, 7.041225078000124],
              [-71.55358638599992, 7.037297668000065],
              [-71.55105423999993, 7.031819967000075],
              [-71.54934891799988, 7.02913279300013],
              [-71.54862544799997, 7.028305969000115],
              [-71.52883337499989, 7.027065735000079],
              [-71.52909175699997, 7.028305969000115],
              [-71.52805822799988, 7.029856262000038],
              [-71.50991979999986, 7.034610494000034],
              [-71.4876472579999, 7.028926086000084],
              [-71.4677001549999, 7.012441304000106],
              [-71.45576289899995, 7.015696920000096],
              [-71.42945959499991, 7.027737529000063],
              [-71.41390498899997, 7.030993144000135],
              [-71.39819535399991, 7.02949452700004],
              [-71.36600093599995, 7.020709534000062],
              [-71.34936112599993, 7.019469299000107],
              [-71.30776159799993, 7.027375793000061],
              [-71.29251704899988, 7.025773824000041],
              [-71.28352534999993, 7.018849183000057],
              [-71.2814582929999, 7.007221985000086],
              [-71.28068314699988, 6.994612936000067],
              [-71.27551550399997, 6.984381002000077],
              [-71.2620279539999, 6.97869659500013],
              [-71.21324540299995, 6.977508036000117],
              [-71.20151485199995, 6.971875305000083],
              [-71.19381506399986, 6.965312398],
              [-71.18404821799993, 6.962573547000062],
              [-71.16632320199992, 6.968102926000057],
              [-71.15361079899995, 6.977094625000106],
              [-71.14539424699993, 6.986189678000073],
              [-71.13604081299988, 6.99213246700009],
              [-71.06547664399992, 6.984536031000033],
              [-71.01126806599987, 6.99089223200005],
              [-70.96132279499992, 7.009444072000093],
              [-70.91881892899994, 7.039468079000059],
              [-70.90809606999994, 7.053369039000117],
              [-70.90344519099997, 7.063187561000092],
              [-70.89553869699992, 7.06851023300004],
              [-70.87481644699989, 7.069182027000124],
              [-70.83662756399991, 7.081894430000077],
              [-70.79306433199989, 7.085098369000136],
              [-70.73296463999995, 7.099309388000108],
              [-70.70330236899989, 7.099929504000073],
              [-70.69673946199993, 7.096673889000087],
              [-70.68260595799995, 7.084633281000023],
              [-70.6731750079999, 7.081170959000076],
              [-70.63927526899991, 7.073471171000094],
              [-70.62289383999985, 7.074091288000062],
              [-70.59467850799987, 7.082979635000072],
              [-70.57860713799991, 7.085821838000044],
              [-70.57147578999988, 7.079362284000084],
              [-70.52091040099992, 7.015593567000067],
              [-70.51070430599987, 7.009702454000063],
              [-70.49481380199995, 7.005516663000037],
              [-70.48414261999994, 7.005309957000065],
              [-70.46130163699985, 7.008307190000082],
              [-70.45166398199993, 7.007687073000113],
              [-70.44701310299988, 7.004741516000109],
              [-70.44096695999991, 6.995749817000075],
              [-70.43778885999987, 6.993010966000028],
              [-70.42293188499991, 6.987791646000105],
              [-70.31906225599991, 6.938285624000059],
              [-70.28761714699993, 6.936942037000094],
              [-70.23126399799995, 6.968516337000068],
              [-70.19501297999989, 6.977559713000034],
              [-70.15778011099988, 6.97952341800007],
              [-70.12920304399992, 6.972547099000067],
              [-70.09662105399985, 6.944435120000037],
              [-70.0794128019999, 6.922834371000064],
              [-70.00357763699989, 6.827362163000117],
              [-69.92771663499988, 6.731838278000069],
              [-69.85182979399994, 6.636314393000106],
              [-69.77596879099994, 6.540816345000067],
              [-69.70021114099987, 6.445292460000104],
              [-69.62435013799984, 6.349768575000056],
              [-69.54848913699993, 6.254296366000105],
              [-69.4726281339999, 6.158746643000057],
              [-69.44363765499995, 6.122237244000132],
              [-69.43201856899992, 6.122237244000132],
              [-69.43108028199993, 6.122237244000132],
              [-69.40614640399986, 6.12934275300006],
              [-69.3581648359999, 6.151615295000113],
              [-69.33139644399995, 6.15636952700001],
              [-69.31134598799989, 6.146215108000135],
              [-69.26858374099987, 6.097458395000103],
              [-69.24610449299988, 6.08066355400004],
              [-69.18915706399989, 6.112625427000111],
              [-69.12996171099991, 6.169934591000086],
              [-69.10841263899994, 6.182569479000037],
              [-69.08019730699988, 6.209389547000114],
              [-69.0611287029999, 6.217838644000011],
              [-69.03689245599992, 6.218768819000061],
              [-69.0161702069999, 6.21398875000007],
              [-68.97857560199989, 6.197323100000034],
              [-68.96090226299987, 6.202361553000102],
              [-68.93834549999994, 6.197116394000076],
              [-68.91447098799995, 6.188693135000094],
              [-68.89292191599989, 6.184326477000099],
              [-68.82912735999989, 6.187788798000042],
              [-68.80786250799989, 6.184326477000099],
              [-68.74409379099987, 6.164921977000034],
              [-68.72161454299996, 6.162519023000073],
              [-68.70089229399991, 6.157971497000048],
              [-68.65934444199993, 6.138670349000094],
              [-68.6353149009999, 6.135879822000049],
              [-68.62198238199989, 6.14192596400008],
              [-68.59567907699994, 6.164921977000034],
              [-68.58472367399986, 6.170012106000115],
              [-68.52250524999997, 6.173293559000101],
              [-68.4490213629999, 6.194997661000102],
              [-68.42742061399991, 6.197323100000034],
              [-68.4066983649999, 6.194894308000073],
              [-68.34112097199997, 6.17683339400007],
              [-68.30417232299993, 6.176988424000101],
              [-68.1902774669999, 6.217838644000011],
              [-68.14650752799989, 6.223781433000028],
              [-68.01902176999997, 6.211611634000107],
              [-67.97799068299992, 6.217838644000011],
              [-67.9433157959999, 6.229698385000034],
              [-67.93365230399988, 6.23145538300011],
              [-67.92414383999997, 6.234555970000144],
              [-67.91628902199994, 6.242229920000042],
              [-67.91106970299992, 6.252306824000073],
              [-67.9091576749999, 6.262512919000045],
              [-67.90430008999988, 6.275147807000081],
              [-67.89282792199987, 6.278300070000043],
              [-67.87928869699991, 6.277938334000041],
              [-67.86812658799997, 6.279876201000064],
              [-67.8576362709999, 6.288454488000099],
              [-67.8391361089999, 6.307523092000082],
              [-67.82719885299994, 6.313414205000072],
              [-67.81851721199988, 6.313750102000071],
              [-67.80079219599986, 6.308608297000077],
              [-67.73097733599991, 6.302691345000071],
              [-67.57398433499995, 6.266233622000058],
              [-67.54489050299992, 6.248069356000116],
              [-67.5182771399999, 6.222541199000091],
              [-67.49047521999995, 6.201638082000017],
              [-67.45097237199988, 6.198035463000096],
              [-67.44996089699993, 6.197943218000106],
              [-67.45629939999992, 6.193223721000052],
              [-67.47616084799995, 6.178435364000094],
              [-67.4869612219999, 6.166782328000039],
              [-67.49140539599989, 6.152958883000082],
              [-67.49119868999995, 6.114485779000034],
              [-67.45430171699991, 6.056789042000048],
              [-67.42856685399994, 6.038469747000079],
              [-67.42097041899987, 6.018341776000099],
              [-67.41859330299991, 5.995345764000149],
              [-67.42246903499998, 5.978240865000103],
              [-67.43476802599992, 5.968163961000073],
              [-67.47088985299993, 5.952841899000106],
              [-67.48520422399992, 5.944082743000124],
              [-67.53238480699994, 5.892561340000029],
              [-67.54158321099993, 5.876722514000036],
              [-67.60121781499993, 5.820576070000072],
              [-67.62514400299995, 5.784505921000076],
              [-67.6411636959999, 5.744844259000089],
              [-67.64912186699985, 5.70195282000013],
              [-67.64907019099994, 5.656089986000083],
              [-67.63775305199997, 5.597308045000105],
              [-67.6359960529999, 5.577593485000051],
              [-67.63258540899994, 5.573071798000029],
              [-67.6176509199999, 5.558524882000071],
              [-67.61429195199989, 5.55366729800005],
              [-67.61703080299992, 5.541600851000069],
              [-67.62297359199994, 5.533410136000043],
              [-67.63000158699995, 5.526898906000071],
              [-67.6359960529999, 5.51953501400007],
              [-67.64700313399987, 5.483361511000055],
              [-67.65248083499995, 5.477961324000077],
              [-67.66446976799992, 5.474912415000048],
              [-67.67527014199996, 5.467186788000049],
              [-67.69371862799997, 5.447213847000029],
              [-67.70214188699995, 5.441400248000136],
              [-67.73164912999988, 5.430134786000082],
              [-67.73702347799994, 5.425819804000113],
              [-67.74668697199988, 5.414321798000088],
              [-67.75211299699993, 5.409670919000121],
              [-67.75671219899988, 5.408792420000083],
              [-67.76792598499992, 5.410497742000047],
              [-67.77257686399989, 5.409670919000121],
              [-67.80978389599991, 5.378820089000044],
              [-67.83458858299994, 5.339313456000099],
              [-67.8436836349999, 5.29724884000008],
              [-67.8340201419999, 5.25887909000005],
              [-67.82497676599993, 5.242781881000084],
              [-67.81862056499992, 5.227821554000116],
              [-67.81474483299985, 5.210277405000056],
              [-67.81350459899991, 5.186557923000095],
              [-67.81557165499987, 5.177902120000056],
              [-67.82456335499992, 5.15433766700005],
              [-67.82719885299994, 5.142116191000127],
              [-67.82756058799993, 5.130695699000029],
              [-67.82663041299989, 5.120386251000113],
              [-67.82451167799991, 5.110593567000066],
              [-67.82099768099994, 5.100594177000048],
              [-67.81474483299985, 5.090956523000031],
              [-67.79676143399988, 5.070156759000071],
              [-67.79309240699988, 5.063335470000112],
              [-67.79521114199994, 5.052715963000125],
              [-67.79986201999992, 5.045868835000078],
              [-67.8045645759999, 5.040856221000112],
              [-67.8067349859999, 5.035714417000108],
              [-67.80497798699992, 4.991246846000124],
              [-67.80668330899996, 4.97225575700007],
              [-67.81960241799987, 4.933317566000099],
              [-67.8263720299999, 4.894844462000052],
              [-67.82719885299994, 4.871538391000101],
              [-67.8252351489999, 4.864897970000101],
              [-67.81614009599994, 4.847302145000114],
              [-67.81350459899991, 4.840506694000084],
              [-67.81386633399993, 4.828259379000144],
              [-67.8171219489999, 4.821515605000116],
              [-67.81862056499992, 4.815676168000039],
              [-67.81350459899991, 4.80634857200009],
              [-67.82053259399993, 4.787641704000109],
              [-67.82285803299996, 4.743587545000139],
              [-67.83060949699987, 4.72754201300009],
              [-67.8406347259999, 4.711496480000037],
              [-67.84564733899995, 4.689740703000027],
              [-67.84879960099991, 4.634188538000032],
              [-67.85515580299995, 4.607730204000035],
              [-67.85370886299995, 4.575820007000061],
              [-67.85515580299995, 4.566156515000046],
              [-67.86063350499992, 4.557965800000105],
              [-67.86760982299992, 4.553159892000096],
              [-67.87339758399989, 4.546519471000096],
              [-67.87505122899995, 4.532644348000119],
              [-67.87179561399995, 4.521559753000119],
              [-67.86507767699993, 4.512077128000044],
              [-67.85655106699991, 4.50417063400009],
              [-67.84766272099989, 4.497891948000088],
              [-67.84766272099989, 4.504687399000133],
              [-67.82905920399995, 4.491432394000128],
              [-67.82187618099991, 4.47822906500005],
              [-67.81350459899991, 4.443269959000048],
              [-67.80942215999991, 4.439290873000061],
              [-67.79707149299995, 4.43492421500008],
              [-67.79309240699988, 4.42898142500006],
              [-67.79267899599995, 4.42084238700005],
              [-67.7983634039999, 4.406915589000064],
              [-67.79986201999992, 4.398905741000092],
              [-67.79665808199994, 4.385805766000132],
              [-67.78265376899992, 4.363791606000049],
              [-67.77939815299996, 4.350794983000114],
              [-67.78198197499995, 4.338883565000089],
              [-67.79986201999992, 4.306069031000064],
              [-67.80492631099989, 4.268474426000054],
              [-67.79944860899991, 4.235323995000044],
              [-67.79076696799984, 4.20426645900011],
              [-67.78621944199992, 4.172976380000108],
              [-67.77774450699991, 4.153933614000039],
              [-67.75893428499998, 4.138559875000055],
              [-67.74017574099989, 4.118716126000066],
              [-67.73164912999988, 4.086366679000079],
              [-67.72064204899988, 4.074972026000083],
              [-67.71407914199992, 4.056497701000055],
              [-67.71693248199992, 4.039878247000033],
              [-67.7170246989999, 4.039341125000092],
              [-67.7104101159999, 4.035723775000108],
              [-67.70162512199991, 4.011952616000059],
              [-67.69857621299988, 3.949966736000107],
              [-67.69387365799992, 3.928598531000105],
              [-67.65387609899994, 3.859248759000067],
              [-67.64441931199988, 3.834624939000079],
              [-67.63878658099995, 3.785170594000135],
              [-67.63175858599993, 3.761864523000014],
              [-67.61413692199994, 3.740573832000024],
              [-67.5948099369999, 3.730910340000094],
              [-67.57651647999992, 3.730703633000132],
              [-67.55791296499987, 3.73416595500008],
              [-67.53744909699992, 3.735509542000045],
              [-67.4998286549999, 3.717913717000059],
              [-67.47140661699987, 3.680060730000079],
              [-67.40391719599992, 3.504464213000063],
              [-67.39011958899988, 3.485059713000098],
              [-67.37539180499988, 3.474905294000038],
              [-67.33782303899997, 3.46009999600011],
              [-67.30464676899996, 3.425709331000064],
              [-67.30945267799987, 3.383928935000114],
              [-67.33529089399988, 3.342096863000052],
              [-67.39580399599993, 3.266571757000037],
              [-67.40805130999985, 3.257270000000105],
              [-67.41838659699997, 3.253704325000044],
              [-67.4402457279999, 3.249415182000064],
              [-67.45218298399993, 3.243679098000101],
              [-67.47094152899984, 3.226315816000096],
              [-67.51383296799989, 3.186731670000128],
              [-67.55662105299993, 3.147044170000058],
              [-67.59951249299988, 3.107460022000097],
              [-67.64230057799989, 3.067824198000039],
              [-67.68514033999995, 3.028240052000072],
              [-67.72798010299988, 2.988604228000014],
              [-67.77076818899991, 2.948968404000126],
              [-67.81360795099994, 2.909332581000072],
              [-67.83861934499993, 2.886129863000065],
              [-67.85525915499997, 2.858172913000061],
              [-67.85593094899994, 2.789753316000073],
              [-67.84125484199987, 2.801432190000057],
              [-67.8333483479999, 2.81522979800009],
              [-67.8233231209999, 2.827322083000084],
              [-67.80332434099995, 2.832593078000116],
              [-67.78141353399991, 2.83150787400011],
              [-67.77019974799995, 2.832438050000079],
              [-67.75102779099984, 2.842101542000094],
              [-67.74255285699994, 2.838587545000053],
              [-67.73164912999988, 2.826340231000117],
              [-67.69041133699997, 2.80634145100008],
              [-67.66560664899993, 2.801328837000113],
              [-67.64565954699992, 2.808666891000115],
              [-67.62659094299994, 2.813421122000108],
              [-67.6084525149999, 2.798589986000081],
              [-67.59429317299995, 2.776110738000071],
              [-67.58705847199988, 2.758127340000087],
              [-67.58147741699989, 2.713065491000037],
              [-67.57558630399987, 2.691103007000066],
              [-67.56370072499993, 2.681749573000033],
              [-67.51879390499994, 2.681026103000121],
              [-67.50029374199991, 2.675341695000085],
              [-67.48520422399992, 2.661905823000041],
              [-67.48101843299989, 2.65353424100006],
              [-67.47502396699986, 2.634672343000133],
              [-67.47088985299993, 2.627127584000092],
              [-67.46174312299985, 2.620409647000059],
              [-67.44034908099994, 2.610022685000047],
              [-67.43616328999988, 2.603563130000083],
              [-67.43264929299994, 2.595398255000063],
              [-67.41699133299988, 2.575761210000039],
              [-67.41290889499987, 2.571885478000084],
              [-67.40035152299996, 2.568216451000083],
              [-67.39322017499993, 2.559328105000063],
              [-67.38810420799993, 2.548165996000122],
              [-67.38154130099986, 2.537779032000103],
              [-67.37203283699995, 2.530440979000019],
              [-67.34986364799994, 2.518452047000068],
              [-67.34061356599992, 2.510493876000098],
              [-67.33580765899993, 2.500313619000039],
              [-67.3312601319999, 2.486671041000122],
              [-67.3254206949999, 2.474630432000055],
              [-67.31663570199993, 2.469462789000147],
              [-67.30568029799994, 2.466207174000061],
              [-67.29472489499994, 2.45835235600012],
              [-67.2757079669999, 2.439387106000083],
              [-67.26656123899991, 2.433754375000134],
              [-67.23136958799995, 2.42233388300005],
              [-67.19762487799997, 2.402025045000116],
              [-67.18971838399992, 2.394376933000046],
              [-67.18610103399993, 2.384455058000057],
              [-67.18573929899995, 2.365489808000092],
              [-67.18015824399993, 2.356498108000054],
              [-67.1737503659999, 2.336447652000103],
              [-67.1870312099999, 2.315983785000057],
              [-67.20630651899992, 2.297793681000101],
              [-67.21767533399992, 2.284512838000097],
              [-67.21726192199992, 2.266064351000082],
              [-67.20134558099988, 2.22792714400012],
              [-67.19426591099997, 2.197024638000116],
              [-67.1778328049999, 2.15449493400007],
              [-67.16925451699987, 2.141162415000053],
              [-67.15411332199994, 2.132687480000044],
              [-67.13602657099995, 2.127132263000135],
              [-67.12098872899986, 2.119096578000054],
              [-67.11463252799993, 2.102999370000077],
              [-67.1111702069999, 2.048842469000064],
              [-67.11463252799993, 2.03129832000009],
              [-67.11902502499993, 2.023986105000105],
              [-67.13514807199991, 2.003341370000101],
              [-67.13261592599991, 1.990809835000093],
              [-67.12553625599989, 1.980500386000088],
              [-67.11809484899987, 1.972387187000095],
              [-67.11034338399986, 1.959519755000088],
              [-67.09158483899995, 1.946523133000071],
              [-67.08729569499991, 1.93882334400007],
              [-67.08481522699992, 1.927997132000129],
              [-67.06683182799995, 1.894123230000034],
              [-66.9808939209999, 1.66594594300004],
              [-66.97805171699991, 1.644293518000055],
              [-66.97805171699991, 1.599722596000035],
              [-66.97417598499996, 1.580033875000083],
              [-66.96446081599993, 1.558303935000083],
              [-66.94317012599993, 1.523189799000136],
              [-66.93360998599985, 1.501692403000092],
              [-66.92968257699988, 1.479497375000065],
              [-66.93650386599992, 1.438517965000131],
              [-66.93273148599991, 1.424642843000072],
              [-66.92337805199986, 1.414359232000066],
              [-66.91190588499995, 1.405186666000077],
              [-66.90172562699988, 1.394463806000061],
              [-66.89118363499992, 1.374542542000057],
              [-66.88353552199993, 1.349944560000068],
              [-66.88250199499996, 1.326018372000064],
              [-66.90089880399995, 1.288966370000097],
              [-66.89588618999989, 1.265298564000076],
              [-66.87506058799994, 1.222510478000046],
              [-66.91340450099995, 1.214862366000062],
              [-66.97820674699994, 1.196827291000062],
              [-67.06522985899991, 1.172694397000015],
              [-67.08610713699997, 1.176001689000103],
              [-67.09447871899994, 1.20121978800006],
              [-67.09819942199996, 1.253361308000123],
              [-67.07360144099988, 1.541199035000133],
              [-67.08295487499993, 1.604631856000069],
              [-67.11716467399992, 1.709793396000052],
              [-67.15571529199988, 1.788083191000112],
              [-67.2647525639999, 1.932544657000065],
              [-67.2886270759999, 1.974893494000071],
              [-67.32040808199994, 2.053079936000117],
              [-67.34061356599992, 2.090106100000071],
              [-67.36577998899986, 2.114962464000129],
              [-67.3817480059999, 2.122739767000041],
              [-67.42463944599987, 2.138113505000121],
              [-67.43972896299996, 2.139560445000114],
              [-67.44913407399991, 2.134134420000038],
              [-67.46608394399993, 2.116357727000107],
              [-67.47533402499994, 2.111861877000081],
              [-67.51026729399993, 2.107417705000074],
              [-67.52732051599986, 2.096591492000044],
              [-67.55439896699991, 2.073130392000067],
              [-67.59294958599989, 2.05481109600008],
              [-67.66974076299996, 1.973343201000148],
              [-67.79045690999996, 1.812577820000072],
              [-67.82084265199993, 1.784000753000015],
              [-67.86053015199991, 1.76152150500009],
              [-67.89318965699997, 1.749713440000093],
              [-67.92884639499997, 1.741290181000096],
              [-67.96486486899994, 1.740153300000088],
              [-67.99824784299992, 1.749971823000067],
              [-68.03178584899993, 1.777515361000042],
              [-68.05865759299994, 1.816401876000015],
              [-68.07922481299991, 1.859965109000143],
              [-68.10123897299991, 1.924121399000072],
              [-68.11110917199997, 1.942414856000141],
              [-68.12614701399988, 1.956212463000099],
              [-68.14914302699992, 1.965540060000123],
              [-68.1697619219999, 1.969725851000064],
              [-68.17709997599991, 1.973188172000107],
              [-68.18516149999991, 1.980758769000062],
              [-68.18728023299988, 1.988200175000088],
              [-68.18743526299991, 2.008250631000038],
              [-68.1921894939999, 2.014891052000038],
              [-68.20081945799987, 2.007837219000123],
              [-68.26081579699985, 1.858208110000064],
              [-68.28024613499994, 1.829398499000135],
              [-68.27368322799995, 1.825264385000111],
              [-68.24831009899995, 1.82211212100006],
              [-68.2389566649999, 1.810252380000037],
              [-68.24112707599991, 1.788341573000082],
              [-68.2389566649999, 1.770280660000083],
              [-68.20154292799995, 1.768678691000048],
              [-68.19353308199987, 1.763743592000097],
              [-68.19074255499993, 1.755010274000128],
              [-68.19172440599988, 1.742427063000108],
              [-68.18877884999998, 1.73583831800002],
              [-68.1804072679999, 1.729688823000046],
              [-68.16330236799988, 1.721291402000062],
              [-68.23859492999992, 1.721188049000133],
              [-68.28644730699992, 1.721136373000121],
              [-68.4126411549999, 1.721033021000096],
              [-68.59102819899988, 1.720877991000052],
              [-68.79548600299992, 1.720671285000094],
              [-68.9999954839999, 1.720464580000041],
              [-69.17838252799996, 1.720309550000096],
              [-69.30452469999994, 1.720206197000067],
              [-69.35240291399995, 1.720206197000067],
              [-69.39338232499998, 1.725270488000135],
              [-69.46919165099987, 1.757387390000076],
              [-69.54195206699987, 1.772709452000043],
              [-69.58029597999987, 1.770228983000067],
              [-69.64905147299996, 1.738938904000065],
              [-69.69008256099991, 1.735476583000121],
              [-69.71145076499991, 1.738525493000054],
              [-69.72914994299992, 1.738990581000081],
              [-69.74635819499989, 1.735166525000039],
              [-69.78919795799993, 1.712790629000054],
              [-69.8075430909999, 1.707364603000087],
              [-69.84118458799986, 1.707579109000065],
              [-69.85617061399992, 1.707674663000063],
              [-69.84880672299991, 1.668891500000129],
              [-69.84924597199995, 1.600187684000062],
              [-69.84960770699985, 1.531483866000087],
              [-69.84999527999994, 1.462805888000034],
              [-69.85035701499993, 1.39405039500005],
              [-69.85077042599994, 1.325346578000079],
              [-69.85110632399994, 1.256616923000109],
              [-69.85154557399997, 1.187990621000068],
              [-69.85193314599988, 1.119260966000084],
              [-69.85219152899995, 1.05941965700012],
              [-69.82935054599994, 1.057249248000048],
              [-69.78767350299992, 1.084224345000067],
              [-69.76255875699988, 1.091097310000038],
              [-69.7496654869999, 1.090528870000085],
              [-69.7368238929999, 1.088358459000091],
              [-69.72806473799992, 1.08298411100013],
              [-69.7265144459999, 1.061021627000073],
              [-69.71602412899995, 1.058592835000098],
              [-69.61990596599992, 1.072752177000055],
              [-69.59675492399992, 1.071925354000129],
              [-69.55329504399992, 1.056835836000033],
              [-69.54295975699992, 1.055595601000093],
              [-69.51009354699988, 1.056112366000121],
              [-69.47826086499995, 1.060659892000075],
              [-69.46872656299985, 1.05941965700012],
              [-69.45976070099991, 1.055182190000082],
              [-69.45541988199994, 1.050738017000072],
              [-69.4523709719999, 1.046242167000059],
              [-69.44728084399992, 1.041694641000021],
              [-69.42841894599991, 1.030480855000064],
              [-69.4181611729999, 1.02862050400006],
              [-69.37085139999996, 1.062985332000011],
              [-69.35496089799994, 1.067067770000108],
              [-69.33878617399995, 1.064122213000104],
              [-69.28881506399998, 1.038439026000034],
              [-69.27426814799992, 1.028207093000049],
              [-69.25718908699989, 1.006916402000073],
              [-69.24023921699995, 0.995650941000108],
              [-69.23284948799997, 0.988364563000033],
              [-69.23016231399993, 0.979114482000114],
              [-69.22912878499994, 0.967435608000045],
              [-69.22618322799985, 0.957203675000059],
              [-69.20432409699993, 0.943664449000082],
              [-69.20998266599995, 0.907542623000069],
              [-69.19388545699988, 0.892091370000074],
              [-69.1707344159999, 0.883151347000137],
              [-69.1589263519999, 0.876175028000134],
              [-69.1523892829999, 0.867803446000067],
              [-69.15233760599989, 0.854264221000093],
              [-69.15975317399992, 0.849613342000026],
              [-69.16931331399991, 0.848063049000103],
              [-69.17538529499987, 0.844445699000119],
              [-69.17760738099986, 0.823568421000047],
              [-69.16776302199989, 0.778971659000121],
              [-69.16776302199989, 0.756027323000097],
              [-69.17455847199992, 0.745433655000028],
              [-69.18502294999988, 0.737682190000015],
              [-69.19225764999993, 0.728948873000135],
              [-69.18926041699993, 0.715151266000092],
              [-69.18119889399992, 0.707503154000023],
              [-69.15949479199992, 0.697322897000049],
              [-69.15207922399992, 0.690553283000014],
              [-69.14120133499995, 0.668177388000032],
              [-69.13745479399995, 0.650142314000036],
              [-69.14365596599993, 0.637533265000101],
              [-69.16233699599991, 0.631435445000051],
              [-69.17140620899997, 0.632779033000105],
              [-69.19013891699987, 0.639703674000089],
              [-69.2006033939999, 0.639496969000035],
              [-69.20835485799992, 0.63463938400011],
              [-69.21905187999991, 0.619549866000114],
              [-69.22618322799985, 0.614795634000117],
              [-69.24238378899986, 0.613762106000138],
              [-69.2789965419999, 0.619239807000042],
              [-69.2970574549999, 0.618102925000116],
              [-69.29281998699986, 0.645594788000096],
              [-69.30214758399998, 0.656550191000065],
              [-69.32026017299992, 0.656343486000111],
              [-69.34232600899992, 0.650245667000149],
              [-69.36255733199991, 0.640943909000029],
              [-69.36893937199994, 0.644406230000072],
              [-69.43971024599998, 0.715771382000057],
              [-69.4578745119999, 0.728070374000097],
              [-69.4780799969999, 0.732824606000094],
              [-69.50371150799995, 0.72962066700012],
              [-69.52342606599993, 0.720939026000067],
              [-69.55564632199989, 0.700165100000021],
              [-69.574224, 0.697943014000117],
              [-69.59411942599993, 0.689313049000077],
              [-69.60458390299996, 0.667402242000108],
              [-69.61915665699993, 0.650659078000075],
              [-69.65127355999994, 0.65737701400009],
              [-69.67948889199991, 0.670037740000041],
              [-69.69468176299995, 0.668745829000088],
              [-69.73287064599992, 0.638980205000095],
              [-69.76754553299995, 0.620686748000125],
              [-69.80532100499991, 0.60694081600009],
              [-69.84591284199993, 0.598672587000053],
              [-69.91446162999995, 0.594538473000028],
              [-69.93389196799984, 0.588957418000106],
              [-69.9528572179999, 0.585753480000037],
              [-69.97649918599993, 0.5904043580001],
              [-69.99923681699991, 0.589784241000118],
              [-70.02065669799993, 0.579862366000043],
              [-70.03941524299992, 0.574591369000103],
              [-70.05424637899995, 0.588130595000081],
              [-70.05610673099994, 0.518574117000085],
              [-70.05683020099994, 0.493045960000046],
              [-70.05869055199994, 0.425866598000084],
              [-70.06137772599988, 0.330885315000089],
              [-70.06427160699988, 0.22195139600008],
              [-70.06726883999988, 0.113017477000085],
              [-70.06995601499992, 0.018036194000075],
              [-70.07181636599992, -0.049143167999972],
              [-70.07248815999989, -0.074671324999912],
              [-70.07380590799994, -0.124900817999958],
              [-70.0680439859999, -0.160144144999933],
              [-70.05636511299991, -0.181021422999905],
              [-70.01755611199988, -0.22566985999994],
              [-69.96665482599994, -0.272282002999901],
              [-69.94435644599989, -0.305458272999914],
              [-69.93363358599987, -0.314346618999934],
              [-69.91497839399992, -0.321684671999918],
              [-69.8752392179999, -0.330573017999939],
              [-69.85810848099996, -0.341425068999897],
              [-69.85167476399991, -0.350830179999946],
              [-69.84229549199995, -0.373154398999915],
              [-69.8347765709999, -0.383179625999929],
              [-69.82477718099989, -0.390207620999945],
              [-69.80175533099992, -0.40095631899996],
              [-69.79144588199995, -0.408191019999933],
              [-69.76157690499991, -0.440850524999902],
              [-69.74646154799993, -0.453046162999911],
              [-69.66649226999988, -0.482915140999935],
              [-69.64951656099987, -0.492010192999899],
              [-69.63207576499994, -0.506893005999942],
              [-69.61975093599989, -0.52456634499994],
              [-69.61171525099991, -0.544616800999989],
              [-69.60706437199994, -0.566837665999927],
              [-69.60657344599991, -0.596499938999983],
              [-69.60453222699994, -0.606318460999958],
              [-69.59926123099993, -0.616447040999915],
              [-69.59269832399994, -0.624095153999889],
              [-69.58696223999988, -0.63246673599987],
              [-69.58422338899993, -0.644559020999864],
              [-69.59076045799992, -0.66822682699997],
              [-69.6219730219999, -0.715355732999896],
              [-69.62838090099993, -0.733442483999909],
              [-69.61835567199992, -0.756903584999876],
              [-69.58068355399988, -0.79938161199992],
              [-69.57272538299992, -0.813540954999965],
              [-69.5756709389999, -0.839172464999933],
              [-69.57324214799985, -0.849197691999947],
              [-69.56419877199988, -0.863460387999922],
              [-69.55750667399988, -0.869454853999869],
              [-69.5502461349999, -0.873175556999868],
              [-69.5432956539999, -0.878653258999861],
              [-69.53732702699989, -0.889505309999905],
              [-69.53621598299989, -0.901184183999888],
              [-69.53861893799984, -0.910589293999934],
              [-69.53923905399992, -0.920614521999951],
              [-69.5325986329999, -0.934050394999915],
              [-69.52427872799984, -0.940975036999887],
              [-69.50247127399993, -0.950276793999919],
              [-69.49314367699989, -0.956167906999923],
              [-69.47123286999994, -0.988000589999956],
              [-69.46513505099998, -0.993064879999849],
              [-69.45508398499993, -0.994615172999957],
              [-69.44996801799996, -0.996785582999948],
              [-69.44691910799992, -1.000816344999947],
              [-69.44286250899992, -1.008361103999988],
              [-69.44503291899991, -1.010738219999936],
              [-69.43976192199997, -1.048668720999942],
              [-69.44193233299987, -1.059830830999886],
              [-69.44828853399991, -1.080398050999875],
              [-69.44815934299996, -1.092076924999944],
              [-69.41046138599992, -1.152745055999929],
              [-69.39945430499992, -1.182717386999883],
              [-69.4211067299999, -1.238631285999958],
              [-69.42106507199992, -1.239310156999906],
              [-69.41831620299988, -1.284106546999922],
              [-69.43469763199991, -1.376400654999898],
              [-69.43394832399991, -1.42218597399993],
              [-69.45226761899988, -1.4905022169999],
              [-69.45193172299989, -1.510862731999936],
              [-69.46642696099994, -1.561092223999879],
              [-69.47761490999997, -1.62248382599995],
              [-69.50696712299995, -1.783610940999935],
              [-69.5363193359999, -1.944841409999938],
              [-69.5656973879999, -2.105968525999927],
              [-69.59499792499986, -2.267095641999902],
              [-69.62435013799984, -2.428326110999919],
              [-69.65370235199993, -2.589453226999893],
              [-69.6830804039999, -2.750683694999907],
              [-69.71240677899996, -2.911810810999967],
              [-69.74173315499993, -3.072937926999955],
              [-69.77116288299993, -3.234168395999873],
              [-69.80046341999989, -3.395295511999947],
              [-69.82981563399997, -3.55652598099995],
              [-69.85916784699992, -3.717653095999935],
              [-69.88852006099992, -3.87878021199991],
              [-69.91784643599988, -4.040010680999913],
              [-69.94719864899986, -4.201137796999902],
              [-69.94833553099997, -4.203411559999921],
              [-69.94942073599987, -4.205581969999912],
              [-69.95055761799998, -4.207752379999903],
              [-69.95169449899987, -4.209922790999883],
              [-69.95277970399988, -4.212093199999885],
              [-69.95391658599988, -4.21436696299989],
              [-69.9550793059999, -4.216640725999909],
              [-69.95611283399998, -4.218811136999904],
              [-69.95719803899988, -4.220878193999866],
              [-69.95833492099987, -4.223151956999885],
              [-69.95942012499998, -4.225425719999905],
              [-69.96050533099987, -4.227596129999895],
              [-69.96164221299998, -4.229766539999972],
              [-69.96272741699997, -4.232040303999895],
              [-69.96386429899988, -4.234314066999914],
              [-69.96494950399997, -4.236484476999905],
              [-69.99275142399992, -4.180880634999895],
              [-70.01021805899998, -4.155145771999898],
              [-70.0305010589999, -4.131581318999906],
              [-70.06049922699995, -4.10719004299996],
              [-70.16170751999994, -4.055616963999867],
              [-70.1883983969999, -4.028951923999912],
              [-70.19894038899986, -3.995982360999946],
              [-70.20457312099998, -3.960118915999914],
              [-70.21697546399986, -3.924978942999957],
              [-70.24087581499995, -3.890872496999904],
              [-70.27356115699993, -3.856559345999884],
              [-70.31110408499993, -3.829274189999865],
              [-70.34957718999988, -3.815838317999905],
              [-70.37768916899992, -3.818835550999921],
              [-70.39921240299986, -3.831858011999955],
              [-70.43851232899993, -3.867721455999913],
              [-70.46424719299995, -3.87878021199991],
              [-70.49088639399989, -3.878470153999928],
              [-70.5442939859999, -3.865240986999936],
              [-70.55496516999989, -3.857902933999938],
              [-70.69064164299996, -3.78679616299992],
              [-70.73412735999997, -3.782041930999924],
              [-70.70056351799985, -3.729642027999887],
              [-70.62211869399994, -3.607272236999933],
              [-70.54372554499994, -3.485005797999918],
              [-70.46528072099991, -3.362532653999935],
              [-70.38683589699991, -3.240162861999892],
              [-70.30836523399998, -3.117793069999948],
              [-70.22994624899988, -2.99531992599988],
              [-70.15150142399997, -2.87305348699995],
              [-70.07305659999986, -2.750683694999907],
              [-70.05062902799995, -2.715130309999935],
              [-70.0504481609999, -2.71430348699991],
              [-70.05600337799993, -2.712443135999905],
              [-70.06747554499992, -2.703451435999867],
              [-70.07579545099989, -2.691359150999887],
              [-70.08212581399991, -2.676579690999873],
              [-70.0949674069999, -2.632551370999906],
              [-70.10579361999996, -2.625213316999904],
              [-70.12620581099989, -2.638752542999981],
              [-70.13194189499987, -2.647950947999973],
              [-70.13643774399989, -2.658596292999974],
              [-70.14183793199993, -2.666967874999955],
              [-70.15046789599998, -2.66924163799996],
              [-70.1597179769999, -2.663970641999938],
              [-70.16147497599988, -2.655185647999943],
              [-70.16113907899998, -2.6450570679999],
              [-70.1640846359999, -2.635031838999879],
              [-70.18387670999996, -2.619528910999875],
              [-70.20090409399998, -2.624386494999982],
              [-70.2175180669999, -2.632137959999895],
              [-70.23606990599984, -2.625109964999879],
              [-70.24730952999991, -2.60722991899992],
              [-70.26139135799991, -2.564751891999975],
              [-70.27394873099993, -2.546251728999948],
              [-70.2958853769999, -2.535399678999909],
              [-70.31508317099991, -2.541807555999938],
              [-70.33510778899995, -2.554003193999961],
              [-70.3596024169999, -2.560617777999951],
              [-70.36461503099989, -2.557620543999946],
              [-70.37091955599988, -2.550282490999948],
              [-70.3757254649999, -2.541084085999941],
              [-70.37634558099995, -2.532609150999946],
              [-70.37156551099986, -2.527958271999893],
              [-70.35453812699984, -2.521550393999945],
              [-70.3496288659999, -2.518346455999961],
              [-70.34492631099991, -2.496642353999974],
              [-70.35753536099995, -2.486927184999928],
              [-70.37877437399993, -2.484653421999923],
              [-70.40024593199985, -2.48486012799988],
              [-70.41133052599986, -2.487443948999967],
              [-70.43484330299995, -2.497675882999957],
              [-70.44525610399998, -2.498502705999968],
              [-70.45698665399996, -2.492714944999904],
              [-70.4625935469999, -2.484240009999908],
              [-70.46610754399995, -2.474008076999922],
              [-70.47192114299992, -2.463156025999879],
              [-70.48445267799994, -2.452510680999893],
              [-70.50199682699991, -2.443829039999926],
              [-70.52091040099992, -2.43804127999995],
              [-70.53773107899991, -2.435870869999874],
              [-70.55320817099991, -2.428119404999947],
              [-70.56553300099995, -2.413753356999948],
              [-70.57860713799991, -2.40548512799991],
              [-70.59607377099988, -2.416543883999907],
              [-70.59858007799994, -2.425845641999942],
              [-70.59775325499993, -2.437111103999896],
              [-70.59863175499996, -2.446619567999974],
              [-70.60635738099995, -2.450753682999903],
              [-70.64759517499996, -2.450753682999903],
              [-70.65446813999992, -2.445379332999948],
              [-70.6562509769999, -2.433080341999911],
              [-70.6562251389999, -2.419231058999941],
              [-70.65754288799988, -2.409102477999895],
              [-70.66371822199994, -2.398250426999937],
              [-70.69524084499992, -2.37210215199994],
              [-70.69903906299993, -2.370138447999906],
              [-70.69906490099993, -2.341096292999907],
              [-70.70144201699989, -2.33324147499988],
              [-70.70658382199989, -2.32828053799993],
              [-70.73247371499991, -2.324973245999928],
              [-70.75105139199988, -2.320529072999918],
              [-70.78787084999988, -2.307403258999955],
              [-70.82236486799985, -2.284768981999903],
              [-70.87419632999993, -2.229578551999907],
              [-70.90455623399987, -2.211078388999894],
              [-70.92525264499992, -2.220276794999975],
              [-70.9503157149999, -2.215419208999961],
              [-70.99271622799992, -2.197435811999881],
              [-71.02144832399995, -2.196712340999881],
              [-71.0319903159999, -2.210768330999898],
              [-71.02979406799992, -2.233505960999878],
              [-71.02062150099991, -2.258930765999892],
              [-71.02969071499987, -2.263995055999956],
              [-71.04142126499997, -2.265338642999922],
              [-71.05392696199996, -2.262651468999906],
              [-71.07911922199992, -2.247561949999906],
              [-71.09221919799995, -2.247251891999909],
              [-71.1199694419999, -2.252109476999934],
              [-71.14281042499991, -2.262858174999863],
              [-71.16193070599991, -2.310193785999914],
              [-71.1902493899999, -2.324559834999917],
              [-71.20905961199992, -2.339235940999913],
              [-71.21985998599985, -2.341509703999918],
              [-71.23045365399992, -2.337995706999962],
              [-71.2424425859999, -2.329107360999956],
              [-71.25334631399994, -2.326626891999879],
              [-71.26817744999997, -2.332414652999944],
              [-71.28905472899996, -2.343370055999927],
              [-71.3076065679999, -2.347814228999937],
              [-71.31546138499994, -2.334068297999906],
              [-71.38698156799995, -2.368898213999955],
              [-71.42082963099995, -2.3760295619999],
              [-71.43214676899993, -2.355152281999935],
              [-71.42816768399985, -2.347504170999855],
              [-71.41437007699989, -2.335101826999974],
              [-71.41163122599994, -2.326626891999879],
              [-71.41524857699994, -2.316291604999961],
              [-71.43896805899988, -2.286215921999897],
              [-71.45648636899995, -2.255106708999946],
              [-71.46666662699991, -2.251489358999962],
              [-71.48056758699988, -2.265752054999936],
              [-71.49043778599986, -2.303269143999927],
              [-71.49813757299995, -2.315051370999939],
              [-71.51405391499989, -2.307403258999955],
              [-71.52097855599996, -2.292107034999901],
              [-71.5222704679999, -2.25035247699995],
              [-71.52712805199994, -2.231542256999944],
              [-71.53839351399989, -2.22296396899992],
              [-71.59596105999992, -2.211078388999894],
              [-71.61663163299994, -2.199916279999854],
              [-71.6352351489999, -2.185550231999855],
              [-71.65492386899987, -2.173768004999943],
              [-71.67853999899998, -2.169530536999986],
              [-71.71202632699988, -2.186790465999891],
              [-71.73140498899994, -2.189891051999922],
              [-71.73998327699988, -2.172941181999917],
              [-71.73848465999995, -2.137697854999942],
              [-71.74613277299994, -2.132323506999896],
              [-71.76794022699997, -2.142245381999885],
              [-71.82612788899988, -2.179039000999879],
              [-71.83620479399991, -2.179762470999975],
              [-71.84106237899994, -2.19009775699989],
              [-71.87718420399995, -2.245288186999886],
              [-71.92441646299997, -2.281875101999916],
              [-71.93175451699997, -2.289626565999924],
              [-71.93635371999991, -2.311847431999865],
              [-71.94865270999986, -2.324146423999906],
              [-71.96627437399985, -2.328487242999884],
              [-72.02895788599989, -2.319598896999963],
              [-72.06151403899992, -2.320012307999974],
              [-72.0894193119999, -2.330967711999961],
              [-72.11737626099992, -2.355152281999935],
              [-72.16145625899989, -2.405691832999963],
              [-72.17639074699994, -2.410342711999931],
              [-72.24093461099997, -2.395459899999892],
              [-72.2509598399999, -2.396286721999914],
              [-72.2766947019999, -2.401557718999939],
              [-72.2818623449999, -2.405691832999963],
              [-72.28098384599986, -2.426155699999924],
              [-72.28382604999993, -2.433183694999926],
              [-72.29240433799987, -2.435870869999874],
              [-72.31565873199989, -2.438351337999933],
              [-72.35560461499995, -2.448893330999908],
              [-72.37803218699992, -2.450753682999903],
              [-72.39658402599989, -2.44651621499986],
              [-72.41425736499988, -2.437111103999896],
              [-72.42753820899989, -2.425018818999916],
              [-72.43265417499987, -2.412926533999922],
              [-72.4415941979999, -2.405175068999924],
              [-72.54412023899997, -2.389052021999944],
              [-72.56298213799988, -2.383057555999912],
              [-72.60840572199993, -2.346367288999943],
              [-72.62597570799991, -2.336858824999865],
              [-72.6443208419999, -2.334068297999906],
              [-72.65682653799988, -2.350191344999885],
              [-72.68318151899985, -2.404761657999913],
              [-72.69584224499988, -2.416543883999907],
              [-72.7124303789999, -2.422124938999929],
              [-72.7183214929999, -2.419851175999909],
              [-72.72173213699992, -2.393702900999912],
              [-72.72457434099988, -2.383470967999926],
              [-72.72876013199993, -2.374685973999931],
              [-72.73372106999997, -2.367554626999905],
              [-72.74607173699994, -2.373445739999909],
              [-72.75418493699993, -2.380680440999868],
              [-72.75904252099986, -2.389982197999899],
              [-72.76167801999986, -2.402281187999932],
              [-72.78798132399993, -2.383574319999951],
              [-72.80467281099996, -2.377786559999976],
              [-72.82947749899989, -2.390188902999853],
              [-72.85805456599985, -2.400317484999903],
              [-72.86999182199989, -2.411789651999925],
              [-72.88378942999995, -2.41675058899996],
              [-72.92616410399995, -2.42522552399987],
              [-72.93541418499987, -2.425328877999988],
              [-72.94326900199991, -2.419024352999884],
              [-72.9527774659999, -2.402281187999932],
              [-72.96977901299991, -2.356082457999975],
              [-72.98430008999986, -2.343370055999927],
              [-72.98755570599994, -2.337685648999894],
              [-73.05644038899996, -2.299858499999914],
              [-73.05886918199991, -2.310607197999929],
              [-73.07070308499993, -2.33324147499988],
              [-73.08382889899991, -2.345127054999907],
              [-73.08997839399987, -2.323836363999916],
              [-73.09886673999998, -2.31494801799991],
              [-73.14248164899993, -2.304095966999867],
              [-73.1589147549999, -2.293037210999955],
              [-73.16139522399988, -2.285389098999886],
              [-73.16630448399991, -2.255520120999961],
              [-73.16945674599987, -2.250145771999897],
              [-73.18309932499997, -2.239707132999868],
              [-73.18625158699993, -2.234746195999918],
              [-73.1883186449999, -2.228751729999885],
              [-73.19777543199987, -2.213558857999956],
              [-73.19984248899993, -2.203740335999981],
              [-73.19855057799987, -2.193818460999893],
              [-73.1952949629999, -2.187203877999906],
              [-73.18625158699993, -2.176351826999863],
              [-73.14992305499996, -2.14358896899995],
              [-73.1405179439999, -2.121884866999949],
              [-73.1110623779999, -2.073412373999886],
              [-73.12454992699986, -2.060803323999949],
              [-73.13235306899989, -2.039822692999863],
              [-73.13783076999997, -2.016878356999925],
              [-73.14460038299993, -1.99817148799994],
              [-73.16196366399993, -1.972436624999943],
              [-73.16873327699997, -1.959310810999881],
              [-73.1725573329999, -1.943601175999916],
              [-73.17116206899993, -1.929545185999899],
              [-73.16113684099992, -1.90443044099996],
              [-73.1589147549999, -1.895232034999964],
              [-73.16470251599989, -1.878488870999917],
              [-73.1883186449999, -1.850686950999958],
              [-73.19364131799995, -1.836837666999898],
              [-73.18625158699993, -1.799630635999989],
              [-73.19302119999986, -1.788675231999918],
              [-73.20139278199994, -1.783300882999953],
              [-73.21069453999988, -1.779270120999868],
              [-73.22030635699988, -1.772345478999881],
              [-73.24702307099994, -1.742373147999928],
              [-73.25725500599992, -1.742373147999928],
              [-73.26133744399993, -1.768831481999925],
              [-73.26769364399988, -1.772242125999952],
              [-73.30123164899987, -1.763560485999989],
              [-73.31657954999994, -1.765420836999894],
              [-73.33270259599993, -1.781130471999873],
              [-73.34029903199988, -1.792189228999874],
              [-73.35053096599995, -1.790638935999951],
              [-73.3745605069999, -1.768831481999925],
              [-73.3870662029999, -1.760873311999958],
              [-73.39915848799987, -1.759219664999918],
              [-73.4102172449999, -1.759736429999947],
              [-73.42442826399994, -1.75808278399991],
              [-73.43543534399993, -1.759529723999904],
              [-73.4400862219999, -1.758702900999964],
              [-73.44153316299989, -1.755292256999937],
              [-73.44484045399989, -1.741856383999988],
              [-73.4462873949999, -1.738135680999974],
              [-73.51093461199994, -1.698551533999932],
              [-73.5309850669999, -1.673746845999887],
              [-73.52881465699991, -1.635092874999884],
              [-73.5174200029999, -1.602019958999989],
              [-73.50881587699988, -1.586827086999961],
              [-73.48452795399987, -1.572461038999961],
              [-73.4835461019999, -1.55334075899988],
              [-73.49406225599995, -1.511586201999933],
              [-73.49545751999995, -1.498460387999955],
              [-73.49527665199989, -1.487918395999898],
              [-73.49716284199991, -1.477996520999909],
              [-73.5048884689999, -1.46724782299988],
              [-73.52597245399994, -1.451744892999969],
              [-73.53713456299997, -1.434278258999925],
              [-73.57421240299993, -1.416914977999909],
              [-73.58343664599994, -1.401722106999969],
              [-73.5677528489999, -1.382705179999917],
              [-73.56292110299998, -1.372163186999941],
              [-73.57857906099991, -1.364928486999887],
              [-73.58426346899998, -1.358313903999885],
              [-73.58896602399994, -1.350252379999901],
              [-73.59087805199997, -1.343431090999943],
              [-73.5920666099999, -1.321726988999941],
              [-73.59397863799992, -1.31335540699996],
              [-73.59713089999988, -1.306120706999906],
              [-73.6008774419999, -1.305190531999941],
              [-73.61418412299992, -1.307050882999945],
              [-73.6182148849999, -1.306120706999906],
              [-73.62002355999988, -1.301573180999867],
              [-73.62154801499992, -1.290617777999984],
              [-73.62880855399987, -1.275114847999888],
              [-73.63139237499988, -1.264056090999873],
              [-73.6365600179999, -1.255167744999952],
              [-73.66007279499988, -1.248346454999904],
              [-73.67911555999984, -1.234290465999976],
              [-73.69020015499987, -1.231086526999917],
              [-73.71340287399997, -1.22715911899985],
              [-73.73236812399992, -1.216513772999861],
              [-73.7463724369999, -1.201320901999921],
              [-73.7547181809999, -1.183337503999937],
              [-73.76978186099987, -1.188918557999955],
              [-73.78585323199985, -1.214240009999941],
              [-73.80254471899988, -1.22364512099989],
              [-73.81448197399993, -1.223335062999908],
              [-73.83047583099997, -1.219924417999977],
              [-73.85716670799991, -1.210519306999927],
              [-73.8710159909999, -1.201424255999953],
              [-73.88075699899994, -1.190985615999921],
              [-73.89876623599991, -1.162770283999947],
              [-73.91411413599991, -1.123082783999962],
              [-73.91990189699996, -1.113781025999941],
              [-73.93641251699995, -1.107786559999909],
              [-73.96762508199993, -1.114814554999924],
              [-73.98129349799984, -1.107476501999926],
              [-73.98268876099993, -1.099208271999885],
              [-73.97333532699989, -1.081638284999912],
              [-73.97447220899988, -1.073370055999959],
              [-73.98279211399995, -1.066238707999929],
              [-73.98783056699992, -1.068925882999864],
              [-73.99134456399989, -1.075333759999893],
              [-73.99496191499986, -1.079674580999963],
              [-74.00589147999992, -1.084842223999971],
              [-74.01111079999995, -1.090009866999893],
              [-74.01679520699989, -1.091560159999901],
              [-74.02909419799994, -1.086392516999908],
              [-74.03720739799994, -1.079674580999963],
              [-74.04203914399994, -1.07109629299994],
              [-74.06544856799991, -1.001436462999919],
              [-74.07689489799992, -0.990894469999944],
              [-74.09237198899993, -1.0201433309999],
              [-74.11963130699993, -1.020970153999926],
              [-74.1805319829999, -0.997715758999902],
              [-74.2401924239999, -0.986863708999863],
              [-74.26675410999991, -0.972290954999906],
              [-74.28913000599988, -0.943042093999864],
              [-74.30339269999988, -0.897773538999942],
              [-74.31336625199987, -0.884441019999926],
              [-74.33832596899995, -0.867697855999978],
              [-74.34442378799992, -0.858602802999911],
              [-74.33755082199994, -0.846820575999914],
              [-74.32514847899998, -0.844546813999983],
              [-74.30905126999991, -0.847337340999943],
              [-74.29512447199991, -0.847337340999943],
              [-74.28913000599988, -0.836278584999945],
              [-74.29460770699987, -0.823669534999922],
              [-74.30483964099994, -0.81312754299995],
              [-74.31060156299992, -0.801448668999882],
              [-74.30279842199991, -0.78542897599992],
              [-74.31057572499992, -0.782018330999989],
              [-74.32786149099991, -0.781501565999861],
              [-74.33755082199994, -0.778607685999873],
              [-74.3443204349999, -0.774060159999934],
              [-74.37819433699988, -0.736543069999939],
              [-74.3851448159999, -0.721970315999982],
              [-74.38475724399987, -0.702850035999887],
              [-74.38013220199991, -0.694271748999952],
              [-74.36726477099992, -0.683212991999952],
              [-74.36488765499988, -0.676184996999936],
              [-74.41266251699994, -0.573142191999949],
              [-74.4146778979999, -0.564150491999911],
              [-74.41471693699992, -0.563756555999902],
              [-74.4158147789999, -0.552678324999889],
              [-74.4179593509999, -0.542653095999867],
              [-74.42292028899993, -0.538312275999886],
              [-74.43653702899994, -0.537795511999946],
              [-74.44188553899988, -0.535521747999923],
              [-74.45056717899985, -0.521569111999938],
              [-74.46377050899994, -0.506789651999924],
              [-74.47563024999997, -0.496454365999909],
              [-74.53635005799995, -0.459970804999898],
              [-74.56239497899995, -0.439403584999909],
              [-74.60445959499987, -0.394961852999927],
              [-74.63272660399994, -0.347419534999915],
              [-74.64231258199996, -0.339771422999931],
              [-74.65308711799989, -0.341941833999925],
              [-74.66140702299992, -0.346799417999947],
              [-74.66771154799994, -0.351553649999943],
              [-74.67275000099991, -0.35403411899992],
              [-74.68657344599987, -0.353414000999948],
              [-74.6925162359999, -0.349693297999934],
              [-74.69564265999995, -0.34462900799987],
              [-74.70073278799993, -0.339771422999931],
              [-74.7076574299999, -0.334603779999938],
              [-74.71184322099995, -0.330262959999857],
              [-74.71812190799994, -0.32726572699994],
              [-74.7430041099999, -0.324888610999892],
              [-74.76269283099995, -0.319824319999924],
              [-74.77300227899985, -0.318687437999913],
              [-74.79070145699987, -0.312589618999951],
              [-74.78284663899984, -0.299153746999906],
              [-74.75532893899995, -0.278276468999934],
              [-74.78946122199994, -0.20903004999991],
              [-74.80369807999989, -0.18897959399996],
              [-74.8246528729999, -0.170479430999933],
              [-74.83653845299992, -0.173269957999906],
              [-74.8614723309999, -0.213164163999934],
              [-74.87271195499994, -0.221949156999926],
              [-74.88271134499988, -0.222775980999941],
              [-74.89932531799988, -0.216781513999919],
              [-74.93345760199986, -0.209443460999921],
              [-74.95487748199989, -0.200038349999971],
              [-74.96821000199989, -0.189703063999957],
              [-75.0091118979999, -0.145261331999976],
              [-75.0153647459999, -0.140507100999898],
              [-75.02469234299994, -0.137716572999935],
              [-75.04223649099993, -0.13730316099992],
              [-75.05073726399993, -0.134305928999908],
              [-75.06231278599995, -0.123143818999978],
              [-75.10163854999985, -0.06909026999989],
              [-75.12065547799992, -0.054104104999922],
              [-75.14168778599992, -0.043458759999922],
              [-75.18669795699986, -0.031263121999913],
              [-75.20674841399992, -0.029092711999922],
              [-75.22209631399988, -0.032400003999925],
              [-75.2317081299999, -0.0426319379999],
              [-75.23511877499993, -0.061958923999953],
              [-75.24013138899988, -0.07477467799994],
              [-75.25253373299995, -0.089554137999954],
              [-75.26834672099994, -0.101749775999878],
              [-75.28348791499988, -0.107020771999899],
              [-75.30196223999988, -0.096065368999916],
              [-75.36544673699993, -0.072810973999907],
              [-75.42141231299993, -0.062165628999907],
              [-75.44089432899992, -0.048109638999989],
              [-75.46492386899988, -0.039738056999923],
              [-75.52311153199989, -0.003977965999908],
              [-75.57013708499994, 0.037983297000011],
              [-75.5879654549999, 0.0438744100001],
              [-75.59824906499998, 0.050385641000076],
              [-75.61096146699992, 0.064648336000047],
              [-75.62677445499995, 0.078911031000118],
              [-75.64666988099995, 0.085422262000094],
              [-75.66550594099996, 0.083148499000075],
              [-75.7086299239999, 0.0733299770001],
              [-75.73162593599992, 0.071159567000024],
              [-75.75384680199997, 0.073019918000028],
              [-75.77322546399992, 0.077774149000021],
              [-75.78971024599991, 0.084388733000111],
              [-75.81787390199986, 0.100098369000079],
              [-75.85797481299994, 0.129760640000129],
              [-75.86634639499994, 0.143506572000078],
              [-75.92711787899995, 0.181023662000072],
              [-75.9519742439999, 0.203967997000092],
              [-75.96298132399988, 0.220091044000085],
              [-75.96752884999992, 0.23931467700001],
              [-75.97248978699989, 0.251923727000118],
              [-76.0395141199999, 0.336673076000054],
              [-76.04385493999987, 0.34855865500009],
              [-76.05346675699988, 0.363544820000058],
              [-76.0759976809999, 0.360754293000099],
              [-76.10131913299998, 0.352692769000015],
              [-76.11956091399992, 0.351762594000149],
              [-76.12467688099991, 0.359617411000087],
              [-76.13030961099994, 0.386075745000085],
              [-76.13630407799988, 0.396721090000071],
              [-76.14467565999985, 0.400441793000084],
              [-76.1558377689999, 0.40126861600001],
              [-76.1775935469999, 0.400131735000102],
              [-76.20208817599985, 0.401785380000135],
              [-76.22374060099995, 0.406746318000089],
              [-76.24368770399985, 0.415427958000052],
              [-76.26291133699988, 0.428037008000075],
              [-76.29050655199987, 0.457182516000103],
              [-76.3004801029999, 0.461626689000099],
              [-76.3115905359999, 0.458526103000068],
              [-76.32972896399994, 0.444780172000122],
              [-76.33494828399995, 0.441679586000092],
              [-76.34052933799987, 0.436615296000113],
              [-76.36538570199991, 0.406953023000057],
              [-76.37468745999985, 0.403542378000026],
              [-76.38533280499985, 0.401475322000067],
              [-76.40693355399992, 0.400131735000102],
              [-76.41639033999988, 0.401888733000078],
              [-76.41587357699984, 0.395377503000105],
              [-76.41835404499992, 0.320860087000057],
              [-76.40801875799991, 0.254507548000035],
              [-76.42569209899992, 0.242725322000126],
              [-76.52491084799996, 0.231253154000115],
              [-76.5508007409999, 0.217920635000084],
              [-76.56542517199998, 0.21606028300009],
              [-76.58433874499991, 0.222571513000062],
              [-76.61105546099986, 0.247479553000119],
              [-76.62686844899989, 0.258538310000034],
              [-76.64123449699989, 0.262775778000076],
              [-76.68996537299992, 0.268150126000137],
              [-76.72453690599991, 0.277555237000087],
              [-76.73688757399987, 0.272904358000034],
              [-76.73435542799987, 0.233113505000119],
              [-76.74959997599993, 0.232700094000108],
              [-76.7852567139999, 0.248719788000059],
              [-76.79786576399994, 0.249960022000096],
              [-76.8673188889999, 0.239521382000063],
              [-76.88246008299993, 0.240141500000036],
              [-76.89682613199992, 0.245309143000043],
              [-76.91387935399985, 0.257814840000123],
              [-76.93568680799987, 0.279829000000106],
              [-76.94586706599995, 0.287063701000079],
              [-76.96245520099987, 0.292851461000055],
              [-76.97490921999994, 0.294918518000102],
              [-77.0149067799999, 0.295641988000099],
              [-77.04462072799987, 0.305667216000131],
              [-77.08286128799995, 0.348868713000073],
              [-77.1038560799999, 0.354140948000108],
              [-77.11743282099985, 0.357550354000125],
              [-77.13479610199997, 0.354346416000055],
              [-77.18518062399997, 0.335432841000028],
              [-77.20693640199997, 0.334192607000077],
              [-77.22254268499992, 0.338843486000144],
              [-77.23727046699992, 0.346388245000099],
              [-77.25613236599995, 0.353209534000143],
              [-77.36253413899996, 0.374810283000031],
              [-77.39746740699985, 0.387626038000093],
              [-77.42439082899995, 0.408296610000107],
              [-77.43472611599987, 0.433824769000054],
              [-77.43911861199987, 0.463693746000075],
              [-77.44816198799992, 0.497283427000099],
              [-77.45456986499997, 0.602393290000052],
              [-77.46805741399993, 0.650865784000118],
              [-77.50934688399994, 0.661201070000033],
              [-77.51413779499987, 0.660531216000038],
              [-77.54334997599997, 0.656446838000136],
              [-77.5798335369999, 0.670916239000078],
              [-77.64556595999994, 0.7162881470001],
              [-77.66680497299993, 0.747707418000047],
              [-77.6733162029999, 0.819641012000076],
              [-77.70318518099992, 0.843102112000054],
              [-77.72788651499991, 0.843308818000111],
              [-77.80762325099988, 0.813026428000086],
              [-77.82772538299994, 0.808892314000062],
              [-77.84798254399996, 0.809254048000057],
              [-77.86932491099995, 0.814059957000069],
              [-77.8926309819999, 0.823051656000104],
              [-77.90322464999986, 0.832095032000069],
              [-77.90529170799994, 0.842895406000096],
              [-77.90498164899995, 0.854005840000113],
              [-77.90854732299991, 0.864186096000083],
              [-77.91826249199994, 0.874418030000072],
              [-77.92306840099985, 0.875038147000041],
              [-77.92818436699994, 0.872350972000106],
              [-77.93903641799989, 0.872557678000064],
              [-78.00704260299997, 0.898189189000036],
              [-78.07794266799993, 0.900773011000126],
              [-78.12000728399997, 0.921236878000087],
              [-78.25015437899992, 1.019628804000121],
              [-78.27061824599988, 1.030480855000064],
              [-78.33007198099995, 1.046500550000118],
              [-78.34921809999994, 1.05580230700005],
              [-78.37280839099995, 1.073785705000134],
              [-78.46691117399993, 1.178378805000051],
              [-78.47812265099995, 1.18711995600006],
              [-78.4852046309999, 1.192641500000121],
              [-78.54060176699994, 1.205353902000084],
              [-78.55561376999992, 1.204113668000048],
              [-78.57005733299985, 1.19584543900001],
              [-78.57569006399987, 1.211968486000075],
              [-78.59661901899995, 1.234085998000083],
              [-78.6004430749999, 1.244421285000101],
              [-78.60214839699995, 1.263644918000111],
              [-78.61152766899991, 1.266435445000084],
              [-78.62555782099992, 1.261991272000074],
              [-78.6412674559999, 1.259407450000069],
              [-78.66467687999994, 1.266642151000042],
              [-78.68428808699989, 1.281886698000079],
              [-78.69935176599998, 1.302040507000058],
              [-78.70919612599994, 1.32415802000007],
              [-78.71947973599995, 1.341056214000062],
              [-78.74898697899997, 1.36485321000012],
              [-78.76996761099986, 1.394102072000067],
              [-78.82868404899995, 1.43431224200009],
            ],
          ],
          [
            [
              [-78.13141842399995, 2.62726471600007],
              [-78.12999426999994, 2.622463283000059],
              [-78.10655676999994, 2.593817450000074],
              [-78.09727942599994, 2.572170315000051],
              [-78.09618079299992, 2.540025132000039],
              [-78.10728919199994, 2.512518622000073],
              [-78.13442949099993, 2.504380601000094],
              [-78.15758216099994, 2.518133856000077],
              [-78.18455969999991, 2.545396226000094],
              [-78.20702063699991, 2.575344143000052],
              [-78.21642005099994, 2.596869208000044],
              [-78.21328691299993, 2.610744533000059],
              [-78.20645097599993, 2.616848049000055],
              [-78.19969641799992, 2.621527411000045],
              [-78.19496592099995, 2.632143556000074],
              [-78.20220820299994, 2.643003083000053],
              [-78.21669624799995, 2.670149764000087],
              [-78.21486798099994, 2.681913849000068],
              [-78.20489061799992, 2.687339382000062],
              [-78.18767706799991, 2.678285431000063],
              [-78.16591935499991, 2.685515512000052],
              [-78.14508573499995, 2.673748199000045],
              [-78.13951575399994, 2.655422268000052],
              [-78.13170325399994, 2.646185614000046],
              [-78.1289770169999, 2.633693752000056],
              [-78.13141842399995, 2.62726471600007],
            ],
          ],
          [
            [
              [-77.90233313699991, 2.696234442000048],
              [-77.8880102199999, 2.687445380000042],
              [-77.85049394399994, 2.63812897300005],
              [-77.83531653599994, 2.626369533000059],
              [-77.80162512899994, 2.607082424000055],
              [-77.78502356699994, 2.593817450000074],
              [-77.80842037699995, 2.578599351000094],
              [-77.8399145169999, 2.577337958000044],
              [-77.86974036399994, 2.584418036000045],
              [-77.88805091099994, 2.593817450000074],
              [-77.88068600199995, 2.600002346000053],
              [-77.88805091099994, 2.607407945000091],
              [-77.86717688699991, 2.627183335000041],
              [-77.86750240799995, 2.639837958000044],
              [-77.88072669199994, 2.646429755000042],
              [-77.89858964799993, 2.648382880000042],
              [-77.91405188699991, 2.658677476000094],
              [-77.92023678299995, 2.679754950000074],
              [-77.91637122299994, 2.697211005000042],
              [-77.90233313699991, 2.696234442000048],
            ],
          ],
          [
            [
              [-77.80614173099991, 2.662054755000042],
              [-77.76768958199995, 2.632554429000038],
              [-77.75413977799991, 2.617987372000073],
              [-77.7591039699999, 2.603094794000071],
              [-77.77586829299992, 2.60101959800005],
              [-77.80174719999991, 2.613959052000041],
              [-77.84707597599993, 2.648382880000042],
              [-77.87458248599995, 2.684759833000044],
              [-77.88068600199995, 2.696234442000048],
              [-77.88390051999994, 2.707993882000039],
              [-77.88512122299994, 2.719631252000056],
              [-77.88255774599992, 2.724595445000091],
              [-77.87441972599993, 2.716701565000051],
              [-77.87132727799991, 2.71430084800005],
              [-77.86009680899991, 2.709865627000056],
              [-77.8574926419999, 2.716131903000075],
              [-77.85456295499995, 2.71906159100007],
              [-77.85106360599991, 2.720892645000049],
              [-77.84707597599993, 2.724107164000088],
              [-77.81920325399994, 2.696234442000048],
              [-77.81525631399995, 2.688462632000039],
              [-77.81053626199991, 2.669419664000088],
              [-77.80614173099991, 2.662054755000042],
            ],
          ],
          [
            [
              [-77.35301673099991, 4.265326239000046],
              [-77.33242753799993, 4.255031643000052],
              [-77.31163489499994, 4.257554429000038],
              [-77.29116777299993, 4.26235586100006],
              [-77.27171790299991, 4.258490302000041],
              [-77.29002844999991, 4.229437567000048],
              [-77.30296790299991, 4.217596747000073],
              [-77.31566321499992, 4.222723700000074],
              [-77.33315995999993, 4.244818427000041],
              [-77.35777747299994, 4.235541083000044],
              [-77.38158118399991, 4.231634833000044],
              [-77.43407141799992, 4.232123114000046],
              [-77.45376542899993, 4.236395575000074],
              [-77.46629798099991, 4.237372137000079],
              [-77.48167883999992, 4.234442450000074],
              [-77.49054928299995, 4.227362372000073],
              [-77.49681555899991, 4.218573309000078],
              [-77.50450598899994, 4.210638739000046],
              [-77.54133053299995, 4.199408270000049],
              [-77.54548092399995, 4.196356512000079],
              [-77.54954993399991, 4.204779364000046],
              [-77.54914303299995, 4.218654690000051],
              [-77.5442602199999, 4.231634833000044],
              [-77.53490149599992, 4.237372137000079],
              [-77.52159583199995, 4.241685289000088],
              [-77.49966386599993, 4.260972398000092],
              [-77.48713131399995, 4.265326239000046],
              [-77.47378495999993, 4.263739325000074],
              [-77.44953365799995, 4.258286851000094],
              [-77.4356176419999, 4.258490302000041],
              [-77.44029700399994, 4.266546942000048],
              [-77.45547441299993, 4.277004299000055],
              [-77.46288001199991, 4.28579336100006],
              [-77.42813066299993, 4.28579336100006],
              [-77.45201575399994, 4.291693427000041],
              [-77.44937089799993, 4.301255601000094],
              [-77.4329320949999, 4.311835028000075],
              [-77.41510982999995, 4.320502020000049],
              [-77.42056230399993, 4.322333075000074],
              [-77.4238988919999, 4.324367580000057],
              [-77.42788652299993, 4.326157945000091],
              [-77.4356176419999, 4.327337958000044],
              [-77.43431555899991, 4.331529039000088],
              [-77.43297278599994, 4.334418036000045],
              [-77.42813066299993, 4.341009833000044],
              [-77.40147864499994, 4.327337958000044],
              [-77.38613847599993, 4.314642645000049],
              [-77.37539628799993, 4.300441799000055],
              [-77.36729895699995, 4.284125067000048],
              [-77.35301673099991, 4.265326239000046],
            ],
          ],
          [
            [
              [-81.71149654899995, 12.522935289000088],
              [-81.71979732999995, 12.543158270000049],
              [-81.71694902299993, 12.56321849200009],
              [-81.7063695949999, 12.58030833500004],
              [-81.69102942599994, 12.59125397300005],
              [-81.68639075399994, 12.58006419500009],
              [-81.70474199099993, 12.504461981000077],
              [-81.71739661399994, 12.502427476000037],
              [-81.72370357999995, 12.511542059000078],
              [-81.71149654899995, 12.522935289000088],
            ],
          ],
          [
            [
              [-81.38263912699995, 13.319159247000073],
              [-81.38613847599993, 13.341457424000055],
              [-81.37873287699995, 13.362697658000059],
              [-81.36534583199995, 13.373968817000048],
              [-81.35138912699995, 13.36619700700004],
              [-81.34630286399994, 13.34870026200008],
              [-81.35216223899994, 13.334173895000049],
              [-81.36534583199995, 13.323879299000055],
              [-81.38263912699995, 13.319159247000073],
            ],
          ],
          [
            [
              [-81.61172441299993, 3.958970445000091],
              [-81.6153051419999, 3.961330471000053],
              [-81.61632239499994, 3.963812567000048],
              [-81.61465410099993, 3.969183661000045],
              [-81.60985266799992, 3.97492096600007],
              [-81.60411536399994, 3.97687409100007],
              [-81.60240637899994, 3.979559637000079],
              [-81.60142981699994, 3.988348700000074],
              [-81.59618079299992, 3.991197007000039],
              [-81.59056555899991, 3.990464585000041],
              [-81.58519446499992, 3.992377020000049],
              [-81.58226477799991, 3.991522528000075],
              [-81.57872473899994, 3.978176174000055],
              [-81.58031165299991, 3.97601959800005],
              [-81.58486894399994, 3.974595445000091],
              [-81.58901933499993, 3.970282294000071],
              [-81.59422766799992, 3.970770575000074],
              [-81.60631262899994, 3.960191148000092],
              [-81.61172441299993, 3.958970445000091],
            ],
          ],
          [
            [
              [-78.1866115759999, 2.990372525000055],
              [-78.17264338699994, 3.002495520000082],
              [-78.16426995299992, 3.001595525000084],
              [-78.16612955599993, 2.987616597000056],
              [-78.16613085499995, 2.973648910000065],
              [-78.16709082999995, 2.959704273000057],
              [-78.18202567499992, 2.94293530300007],
              [-78.19322349799995, 2.933616561000065],
              [-78.20815496299991, 2.92988917100007],
              [-78.22028891999992, 2.933616538000081],
              [-78.22029021999992, 2.94386796100008],
              [-78.20442330899994, 2.945731374000047],
              [-78.19972362399994, 2.960621378000042],
              [-78.19502830399995, 2.980156382000075],
              [-78.1866115759999, 2.990372525000055],
            ],
          ],
          [
            [
              [-75.58680116199992, 10.367791823000061],
              [-75.57583013499993, 10.377872464000063],
              [-75.56810808699993, 10.372799271000076],
              [-75.5559042989999, 10.367757667000092],
              [-75.5378878869999, 10.362673061000066],
              [-75.5353199189999, 10.350646060000088],
              [-75.54626327799991, 10.33926699300008],
              [-75.55591494999993, 10.340542755000058],
              [-75.56749790099991, 10.343719089000047],
              [-75.57586148699994, 10.338658252000073],
              [-75.5784327259999, 10.325996191000058],
              [-75.58229011199995, 10.319033361000038],
              [-75.59066132499993, 10.319043831000045],
              [-75.59452642899993, 10.331077056000083],
              [-75.59581281599992, 10.347537475000081],
              [-75.59259450699994, 10.360198024000056],
              [-75.58680116199992, 10.367791823000061],
            ],
          ],
          [
            [
              [-80.0899145169999, 13.57835521000004],
              [-80.0899145169999, 13.577704169000071],
              [-80.08934485599991, 13.577866929000038],
              [-80.08942623599995, 13.576849677000041],
              [-80.09040279899995, 13.576605536000045],
              [-80.09040279899995, 13.577297268000052],
              [-80.09089107999995, 13.577093817000048],
              [-80.09089107999995, 13.57802969000005],
              [-80.0899145169999, 13.57835521000004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Paraguay',
        iso3: 'PRY',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-62.65035721899994, -22.234455667999967],
            [-62.627516234999945, -22.184536233999907],
            [-62.59940425699992, -22.089865010999887],
            [-62.57284256999989, -22.000774840999966],
            [-62.529227661999954, -21.865072529999907],
            [-62.49279577699994, -21.751797789999927],
            [-62.44618363499998, -21.60689707399986],
            [-62.41197383699998, -21.50085703499994],
            [-62.375490275999965, -21.384481709999932],
            [-62.34040197799993, -21.272860615999903],
            [-62.30789750199992, -21.16930104599996],
            [-62.27570308499986, -21.06656829799995],
            [-62.271879027999915, -21.000939229999915],
            [-62.27188577399994, -21.000423652999885],
            [-62.273791056999926, -20.854798277999905],
            [-62.275031290999976, -20.758680115],
            [-62.27616817299989, -20.67072682699998],
            [-62.277305053999896, -20.579776305999886],
            [-62.26883011899989, -20.553111266999935],
            [-62.23239823499989, -20.501021422999983],
            [-62.21057310199993, -20.471305462999922],
            [-62.18966182499989, -20.442833760999875],
            [-62.14496171099992, -20.382062275999957],
            [-62.10020992099987, -20.321187438999928],
            [-62.055509806999936, -20.26041595399991],
            [-62.010809692999885, -20.19954111699988],
            [-61.99416988099995, -20.175666604999975],
            [-61.97758174699996, -20.1517920939999],
            [-61.96094193599993, -20.128020934999938],
            [-61.944250447999906, -20.104146422999946],
            [-61.931383016999916, -20.078308206999935],
            [-61.92473979899995, -20.06512763899987],
            [-61.918412231999895, -20.05257334399994],
            [-61.90554479999989, -20.026735127999913],
            [-61.892574015999855, -20.0008969109999],
            [-61.86441035999991, -19.927413024999936],
            [-61.83629838099998, -19.85382578499994],
            [-61.80818640099994, -19.780341897999875],
            [-61.7800744219999, -19.706961363999937],
            [-61.76121252499988, -19.657765400999963],
            [-61.753202677999894, -19.64587982199994],
            [-61.73723465999987, -19.639575296999922],
            [-61.648222005999884, -19.626759541999945],
            [-61.62672460999994, -19.623658954999897],
            [-61.57954402699991, -19.616837666999942],
            [-61.53228592999997, -19.610016377999983],
            [-61.510840210999845, -19.60691579099995],
            [-61.172359578999874, -19.53746266699997],
            [-60.83393062399992, -19.46790618899989],
            [-60.49547582999986, -19.39845306399991],
            [-60.15699519899991, -19.328999938999942],
            [-60.00638423699988, -19.298097431999935],
            [-59.92432206299989, -19.29706390399987],
            [-59.73585811399997, -19.294790140999936],
            [-59.547497517999886, -19.292413024999902],
            [-59.35908524599989, -19.290139261999883],
            [-59.170724649999926, -19.287762145999935],
            [-59.08954097499986, -19.28672861699995],
            [-59.06964554899986, -19.291482848999948],
            [-59.039673217999905, -19.311636657999927],
            [-59.01109615099995, -19.330963643999965],
            [-58.96065995299995, -19.3605225619999],
            [-58.86743566899992, -19.415299580999985],
            [-58.77410803299995, -19.47007659899988],
            [-58.6808320719999, -19.52475026399992],
            [-58.58750443499986, -19.57942392999989],
            [-58.49428015199993, -19.634200947999958],
            [-58.401004190999885, -19.688874612999925],
            [-58.30777990799996, -19.74365163199991],
            [-58.214452270999885, -19.798325296999863],
            [-58.175281534999954, -19.821372984999925],
            [-58.164429483999896, -19.83294850699987],
            [-58.161173868999924, -19.84721120199994],
            [-58.16422277899994, -19.88028411799992],
            [-58.16220739799991, -19.912323506999925],
            [-58.14515417599995, -19.969580992999894],
            [-58.141846883999875, -20.0008969109999],
            [-58.14448238199989, -20.02311777799993],
            [-58.143138793999924, -20.06528574699989],
            [-58.144740762999845, -20.086163024999877],
            [-58.15952022399995, -20.13907969199994],
            [-58.15879675299996, -20.165124612999918],
            [-58.158331664999935, -20.181144307999972],
            [-58.1523371989999, -20.184658304999928],
            [-58.144068969999864, -20.18352142399992],
            [-58.13704097499996, -20.18558847999988],
            [-58.12990962699993, -20.19251312199995],
            [-58.12050451699986, -20.203881937999952],
            [-58.118540812999925, -20.21442392999991],
            [-58.155282755999906, -20.226412861999876],
            [-58.162672485999934, -20.243156025999923],
            [-58.15631628499989, -20.26165618799986],
            [-58.13704097499996, -20.2743685909999],
            [-58.130943155999915, -20.27281829899998],
            [-58.12624060099992, -20.267030537999915],
            [-58.120039428999945, -20.261346129999964],
            [-58.10975581899993, -20.26072601299998],
            [-58.103089559999944, -20.26444671599991],
            [-58.095079712999876, -20.272198180999908],
            [-58.090325480999866, -20.2817066449999],
            [-58.09993729699997, -20.309198506999877],
            [-58.097715209999876, -20.334623310999874],
            [-58.09079056899989, -20.35942799899992],
            [-58.08298742799988, -20.376171161999963],
            [-58.06712276299996, -20.393534443999968],
            [-58.04562536699993, -20.409347431999976],
            [-58.023146118999904, -20.420716246999874],
            [-58.00418086799996, -20.425160420999973],
            [-57.989401407999935, -20.43311859199993],
            [-57.99214025899988, -20.450895283999955],
            [-58.00790157099996, -20.479834085999926],
            [-58.010020304999955, -20.50009124699993],
            [-58.008935099999945, -20.525722756999897],
            [-58.00474930899992, -20.549803974999932],
            [-57.993328816999906, -20.573781839999953],
            [-57.99255367099991, -20.58504730199992],
            [-57.99363887599989, -20.60675140399991],
            [-57.99095170099986, -20.62060068699988],
            [-57.9778258879999, -20.64013437899989],
            [-57.973123331999915, -20.65119313599989],
            [-57.97358841999994, -20.661941832999915],
            [-57.9810815029999, -20.681165465999925],
            [-57.98061641499996, -20.69274098699988],
            [-57.97441524299995, -20.704006448999934],
            [-57.96501013199992, -20.71103444399995],
            [-57.95638016799995, -20.709897561999938],
            [-57.947181762999975, -20.675067646999963],
            [-57.934004272999886, -20.667419534999894],
            [-57.918087930999974, -20.669796650999942],
            [-57.90429032399993, -20.678995055999934],
            [-57.90020788599992, -20.685196227999924],
            [-57.89447180199994, -20.699975687999938],
            [-57.8906477459999, -20.70638356499998],
            [-57.8843432219999, -20.711964619999904],
            [-57.868943644999916, -20.722196552999975],
            [-57.86021032699995, -20.730258076999874],
            [-57.85767818299985, -20.73986989299989],
            [-57.865274617999916, -20.747414651999932],
            [-57.8770051679999, -20.752375589999886],
            [-57.898760945999925, -20.756613056999925],
            [-57.906667439999865, -20.762194111999946],
            [-57.91793290299992, -20.77407969099997],
            [-57.933074096999945, -20.784621683999944],
            [-57.94041215099992, -20.793613382999894],
            [-57.93395259599987, -20.79971120199994],
            [-57.90801102699993, -20.80198496499996],
            [-57.8876505129999, -20.80591237399993],
            [-57.87070064399998, -20.816454365999988],
            [-57.85964188599988, -20.831647236999913],
            [-57.85710974199989, -20.849733987999926],
            [-57.86739335199991, -20.860069274999944],
            [-57.9086828209999, -20.881566670999888],
            [-57.91793290299992, -20.894382425999964],
            [-57.91483231599997, -20.905647888999923],
            [-57.90801102699993, -20.910505472999944],
            [-57.90113806199986, -20.91236582399995],
            [-57.898089151999926, -20.914846292999925],
            [-57.89302486199995, -20.914846292999925],
            [-57.86992549599998, -20.93272633899997],
            [-57.84703283699986, -20.955980732999905],
            [-57.84031490099994, -20.955980732999905],
            [-57.836025756999874, -20.938514098999946],
            [-57.81757726999987, -20.953603616999956],
            [-57.81602697799994, -20.975411070999968],
            [-57.82538041199987, -20.99856211399988],
            [-57.852458862999924, -21.037836201999937],
            [-57.85173539199994, -21.051995543999894],
            [-57.836025756999874, -21.082484638999873],
            [-57.829876261999914, -21.127029723999968],
            [-57.8339586999999, -21.173848571999898],
            [-57.84785966099989, -21.216223245999913],
            [-57.87070064399998, -21.247642516999946],
            [-57.89901932799998, -21.267176207999867],
            [-57.90429032399993, -21.27492767299995],
            [-57.9049104419999, -21.28743336999996],
            [-57.89994950399995, -21.29508148099994],
            [-57.89364497999992, -21.30035247799988],
            [-57.8906477459999, -21.305933531999884],
            [-57.88232784099995, -21.316372171999916],
            [-57.86630814599991, -21.320919697999955],
            [-57.85555944799998, -21.33073821999993],
            [-57.86331091399998, -21.356886494999927],
            [-57.929921834999874, -21.453108011999873],
            [-57.945269734999954, -21.487214456999936],
            [-57.9491454679999, -21.50829844099988],
            [-57.948111938999915, -21.53051930799991],
            [-57.93979203299995, -21.548192646999908],
            [-57.921601928999934, -21.555427346999878],
            [-57.91209346499994, -21.564005635999905],
            [-57.9193281659999, -21.583952737999923],
            [-57.93214392099989, -21.606690368999907],
            [-57.93901688699995, -21.623743590999936],
            [-57.934831095999925, -21.64069346099994],
            [-57.92434077999988, -21.658676858999925],
            [-57.91178340699986, -21.67304290799993],
            [-57.90113806199986, -21.678934020999932],
            [-57.895608682999864, -21.68844248499991],
            [-57.93901688699995, -21.755311787999887],
            [-57.93844844599991, -21.774638772999936],
            [-57.9347794199999, -21.792932229999906],
            [-57.93570959499996, -21.8120525099999],
            [-57.94893876099985, -21.83385996499993],
            [-57.955915079999954, -21.851119893999922],
            [-57.94666499899992, -21.86548594199992],
            [-57.932764037999874, -21.881919046999982],
            [-57.92537430899995, -21.90496673599995],
            [-57.929921834999874, -21.917369079999915],
            [-57.95322790499992, -21.958193460999908],
            [-57.96263301599987, -21.966978454999904],
            [-57.96485510299988, -21.976693623999935],
            [-57.986817585999944, -22.03529469799996],
            [-57.98836787999997, -22.04904062899989],
            [-57.98800614499996, -22.064130146999986],
            [-57.98624914599989, -22.074465433999904],
            [-57.973133663999874, -22.08104849399996],
            [-57.972864949999945, -22.08118336999992],
            [-57.96139278199993, -22.09007171599994],
            [-57.9524527589999, -22.105988056999962],
            [-57.93999873899992, -22.118390400999928],
            [-57.906254028999854, -22.128932392999985],
            [-57.895505330999924, -22.128932392999985],
            [-57.87819372599992, -22.12211110399994],
            [-57.87137243699988, -22.12118092899989],
            [-57.862845825999955, -22.125831806999955],
            [-57.84868648299991, -22.140301207999897],
            [-57.8438805749999, -22.143711852999914],
            [-57.831788289999906, -22.14112803099991],
            [-57.81576859499995, -22.128312276999935],
            [-57.80548498499988, -22.128622334999918],
            [-57.795304727999905, -22.13099945099995],
            [-57.787501587999884, -22.1296558639999],
            [-57.7754093019999, -22.12397145599995],
            [-57.77778641799995, -22.1223178099999],
            [-57.777424682999936, -22.117046813999963],
            [-57.77561600799996, -22.11115569999997],
            [-57.77365230299992, -22.107745055999942],
            [-57.76993159999992, -22.107434996999956],
            [-57.76026810699989, -22.11074228899996],
            [-57.756185669999894, -22.11063893599993],
            [-57.7363419189999, -22.103714293999943],
            [-57.72326778199994, -22.104747822999926],
            [-57.70993526299992, -22.10846852599994],
            [-57.6896264239999, -22.109295348999964],
            [-57.67851599199989, -22.106401468999977],
            [-57.67081620299987, -22.102370706999892],
            [-57.663684855999946, -22.100613709],
            [-57.65448644999995, -22.104541116999968],
            [-57.63893184499992, -22.14453867599994],
            [-57.627201294999935, -22.16510589599993],
            [-57.61407548099996, -22.176991474999866],
            [-57.59671219899985, -22.18102223699995],
            [-57.57273433399993, -22.17771494499995],
            [-57.56400101799994, -22.17440765399995],
            [-57.55997025599996, -22.1716171259999],
            [-57.55469925999992, -22.170273538999936],
            [-57.54229691599997, -22.17151377299996],
            [-57.53459712799989, -22.17440765399995],
            [-57.51118770399992, -22.18877370199995],
            [-57.472482055999905, -22.180298766999954],
            [-57.46395544499998, -22.180402119999982],
            [-57.44318151899992, -22.187946878999938],
            [-57.432277791999866, -22.188670348999935],
            [-57.417860066999935, -22.193837991999928],
            [-57.38499385599991, -22.21326833099991],
            [-57.37863765499989, -22.213371683999938],
            [-57.37502030399992, -22.20727386499989],
            [-57.36664872199992, -22.2091342169999],
            [-57.35124914599996, -22.21719573899989],
            [-57.339932006999874, -22.216989033999923],
            [-57.33481603999988, -22.211718037999987],
            [-57.33305904199992, -22.205413512999968],
            [-57.331767130999964, -22.202416279999866],
            [-57.316315877999955, -22.203656513999903],
            [-57.27166743999993, -22.21378509499995],
            [-57.252443807999896, -22.210581156999893],
            [-57.22748409099992, -22.191254170999926],
            [-57.213789835999904, -22.18815358499998],
            [-57.20944901599992, -22.192080992999948],
            [-57.206400105999904, -22.207480569999944],
            [-57.19952714099992, -22.2128549199999],
            [-57.189967, -22.213578388999906],
            [-57.18361079999991, -22.21089121499996],
            [-57.177926391999875, -22.207377216999916],
            [-57.17038163299992, -22.205723571999954],
            [-57.1541552329999, -22.207997334999973],
            [-57.12418290199986, -22.218539326999945],
            [-57.115036173999954, -22.222880146999927],
            [-57.114622761999954, -22.22505055799992],
            [-57.11327917499989, -22.229391376999985],
            [-57.10847326699988, -22.233525492999917],
            [-57.090748250999866, -22.2364193719999],
            [-57.085063842999915, -22.238073018999955],
            [-57.07922440599995, -22.23858978299998],
            [-57.07162796999998, -22.235695902999908],
            [-57.059484008999874, -22.2326986689999],
            [-57.027651326999916, -22.235075784999935],
            [-57.01116654499995, -22.2338355509999],
            [-56.98646521099994, -22.241380309999954],
            [-56.975716512999924, -22.24169036899994],
            [-56.96455440299988, -22.23486907999998],
            [-56.965484578999934, -22.25088877299993],
            [-56.96052364099998, -22.254816182],
            [-56.9521003829999, -22.253575947999963],
            [-56.94259191899991, -22.253989359999977],
            [-56.92494441799991, -22.262360941999944],
            [-56.914789998999964, -22.262877705999898],
            [-56.90367956599994, -22.236936136999944],
            [-56.892000691999954, -22.252232360999898],
            [-56.88171708199988, -22.277243753999898],
            [-56.87954667199989, -22.28995615699995],
            [-56.85605973299991, -22.29316009499992],
            [-56.84285640499991, -22.289025981],
            [-56.819653686999914, -22.265461526999985],
            [-56.81314245599995, -22.256159769999968],
            [-56.8119022219999, -22.249648538999907],
            [-56.808284871999916, -22.247994893999945],
            [-56.7945647789999, -22.252542419999983],
            [-56.786994180999926, -22.251818948999897],
            [-56.75436051499989, -22.24262054399989],
            [-56.746789916999916, -22.243964130999956],
            [-56.74560135899989, -22.248408304999955],
            [-56.743534301999944, -22.250372008999904],
            [-56.73319901599993, -22.244067484999974],
            [-56.72854813599986, -22.237452900999884],
            [-56.720538289999894, -22.2194695029999],
            [-56.71537064699987, -22.215438741],
            [-56.69860164399992, -22.223500263999895],
            [-56.66457271299987, -22.25998382599991],
            [-56.64881140199989, -22.263497822999867],
            [-56.644134684999926, -22.25543629999997],
            [-56.65470251499991, -22.237349547999955],
            [-56.648346313999866, -22.231355081999922],
            [-56.637184204999926, -22.22825449599989],
            [-56.629174356999954, -22.22474049799993],
            [-56.595739705999875, -22.201486103999912],
            [-56.58496516899996, -22.19053070099993],
            [-56.567911946999914, -22.16231536899997],
            [-56.565302286999895, -22.159938252999922],
            [-56.55801590999994, -22.156424254999962],
            [-56.554605265999896, -22.15208343499998],
            [-56.5490758869999, -22.136270446999987],
            [-56.54597530099994, -22.13006927499991],
            [-56.530679077999906, -22.10908864399991],
            [-56.52163570199994, -22.099890237999915],
            [-56.51130041499994, -22.09141530399991],
            [-56.49383378199988, -22.086557718999885],
            [-56.421796834999924, -22.074465433999904],
            [-56.407637491999964, -22.075809020999955],
            [-56.39730220599995, -22.086247660999987],
            [-56.370843872999956, -22.1473292029999],
            [-56.34733109599998, -22.180402119999982],
            [-56.316841999999895, -22.207687275999902],
            [-56.26108313099985, -22.23858978299998],
            [-56.23152421099991, -22.26535817399987],
            [-56.21426428299992, -22.27538340199989],
            [-56.19679764799989, -22.27931081199995],
            [-56.02471512899993, -22.28737233399994],
            [-56.011356770999896, -22.283858337999987],
            [-55.99856685399993, -22.277243753999898],
            [-55.985234334999916, -22.28323821999993],
            [-55.97086828699989, -22.293883564999916],
            [-55.95526200399988, -22.301324970999943],
            [-55.89294022599992, -22.306802673999925],
            [-55.87438838699998, -22.31734466499998],
            [-55.872011270999934, -22.31021331699995],
            [-55.86103002999994, -22.289542744999935],
            [-55.81077469899989, -22.35310475699991],
            [-55.77015702399987, -22.38142344099991],
            [-55.760235147999964, -22.391965433999957],
            [-55.751579345999914, -22.41625335699996],
            [-55.748297892999915, -22.500899352999866],
            [-55.74126989799993, -22.537176208999924],
            [-55.72393245399991, -22.569629006999932],
            [-55.69791337199993, -22.59557057699989],
            [-55.66468542599992, -22.612727151999948],
            [-55.64435074899998, -22.61954844199991],
            [-55.63119909699992, -22.62678314199988],
            [-55.623680175999965, -22.638668721999906],
            [-55.620476237999895, -22.65933929399992],
            [-55.62150976599989, -22.66709075899992],
            [-55.62701330599987, -22.683627217999913],
            [-55.62778845299988, -22.69210215199992],
            [-55.625669718999916, -22.700783792999886],
            [-55.61918432599995, -22.71690683999995],
            [-55.618331665999904, -22.725691833999946],
            [-55.6285894369999, -22.758971455999884],
            [-55.645926879999905, -22.78791025799994],
            [-55.659001017999856, -22.818296],
            [-55.656572224999906, -22.85570973699997],
            [-55.63429968299994, -22.93281097399992],
            [-55.634351359999954, -22.950070901999908],
            [-55.6399840899999, -22.98376393599996],
            [-55.63781367999991, -23.00071380599988],
            [-55.611458699999844, -23.029135843999896],
            [-55.600684163999915, -23.044535419999974],
            [-55.595232299999935, -23.064069111999885],
            [-55.60014156199986, -23.100552672999896],
            [-55.59939225299988, -23.11708913199989],
            [-55.58866939299995, -23.13011159199992],
            [-55.56086747299989, -23.145924579999928],
            [-55.55714676999989, -23.154709574999913],
            [-55.535235962999934, -23.229123635999926],
            [-55.535649373999945, -23.245866800999877],
            [-55.559007120999894, -23.291342060999938],
            [-55.562159383999955, -23.30787851999993],
            [-55.555596476999966, -23.330306090999926],
            [-55.52487483699991, -23.36048512699992],
            [-55.51386775799992, -23.37939870199996],
            [-55.51554724199988, -23.410197855999925],
            [-55.542470662999904, -23.465801696999932],
            [-55.53991267899991, -23.500528259999967],
            [-55.533795620999854, -23.53044413699986],
            [-55.533065551999954, -23.53401458699996],
            [-55.533892374999965, -23.569981383999945],
            [-55.53053340699995, -23.60346771199994],
            [-55.511309773999926, -23.629409280999894],
            [-55.46697139599988, -23.673230896],
            [-55.4453189699999, -23.7354493199999],
            [-55.430177774999976, -23.92856414799988],
            [-55.420669311999916, -23.954505715999915],
            [-55.398035033999946, -23.976829935999973],
            [-55.367184203999955, -23.98964569099988],
            [-55.30434566299991, -23.994089863999974],
            [-55.2727196859999, -24.00039438899998],
            [-55.27266800899989, -24.000497741999922],
            [-55.27256465699986, -24.000497741999922],
            [-55.272409627999934, -24.000601094999936],
            [-55.23683040399996, -24.01269337999993],
            [-55.20086360699989, -24.01951466799997],
            [-55.165439412999945, -24.016827493999955],
            [-55.131281290999965, -24.000601094999936],
            [-55.13107458499991, -24.000601094999936],
            [-55.13107458499991, -24.00039438899998],
            [-55.10557226599988, -23.988508809999956],
            [-55.0422944739999, -23.989025573999896],
            [-55.01149532099993, -23.9805506389999],
            [-54.994571289999925, -23.973109232999974],
            [-54.96105912299993, -23.971765644999905],
            [-54.94364416499991, -23.969181823999904],
            [-54.92674597199991, -23.959880065999883],
            [-54.90488684099995, -23.93300832099989],
            [-54.891916056999946, -23.92060597699991],
            [-54.827423868999915, -23.887016296999974],
            [-54.69683752399993, -23.84515838599991],
            [-54.679784301999916, -23.836683450999914],
            [-54.654592040999944, -23.811465351999956],
            [-54.63921830299998, -23.80443735699994],
            [-54.61255326399993, -23.81115529399996],
            [-54.4431579189999, -23.89993540399989],
            [-54.422900756999894, -23.913784688999954],
            [-54.36760697499997, -23.984684753999915],
            [-54.273607543999844, -24.03646453799989],
            [-54.24574984799989, -24.050393385999953],
            [-54.24528885899994, -24.050623880999936],
            [-54.26621781499992, -24.06592010499989],
            [-54.30104772999991, -24.08989796999991],
            [-54.32476721199993, -24.11821665399991],
            [-54.33463741099993, -24.148912454999945],
            [-54.33184688299988, -24.165035501999924],
            [-54.31897945199995, -24.19676483099994],
            [-54.314121866999955, -24.234178567999905],
            [-54.30626704899993, -24.246684264999914],
            [-54.282650919999895, -24.275313008999973],
            [-54.27433101399993, -24.298257344999925],
            [-54.26105017099994, -24.329469909],
            [-54.262187051999945, -24.358512064999985],
            [-54.27169551599991, -24.38941457099989],
            [-54.28409785999989, -24.411325377999944],
            [-54.32290685999993, -24.46434539799995],
            [-54.33453405799989, -24.496694843999933],
            [-54.33479243999997, -24.527287292999944],
            [-54.32068477399994, -24.595913593999896],
            [-54.3213048909999, -24.62836639399991],
            [-54.358429464999915, -24.73142174699997],
            [-54.37112097199994, -24.76665252699989],
            [-54.39974971599992, -24.80478973399994],
            [-54.40729447499987, -24.821222838999915],
            [-54.453286498999944, -25.00281382199995],
            [-54.46227819799989, -25.0372303259999],
            [-54.464190225999914, -25.055937194999984],
            [-54.463311726999876, -25.07278371199996],
            [-54.45519852699988, -25.09211069699991],
            [-54.429722045999966, -25.13055796299996],
            [-54.42662146099991, -25.149471537],
            [-54.43566483599997, -25.16704152399997],
            [-54.46940954599995, -25.1954635619999],
            [-54.48145015499992, -25.213240253999928],
            [-54.50356766799993, -25.2786626179999],
            [-54.528475708999906, -25.3143193559999],
            [-54.547079223999845, -25.336643574999954],
            [-54.575656290999916, -25.36031138099989],
            [-54.59798050999987, -25.397518411999982],
            [-54.609814412999896, -25.43276173899997],
            [-54.61182979299994, -25.444027200999926],
            [-54.61244991099991, -25.46552459699997],
            [-54.60852250199994, -25.487642109999882],
            [-54.598497273999925, -25.505832213999923],
            [-54.59146927899991, -25.524745788999965],
            [-54.59415645399994, -25.548620300999943],
            [-54.59994421499991, -25.5727015169999],
            [-54.60020261299988, -25.57494488399989],
            [-54.602217976999924, -25.592441914999952],
            [-54.58624995999989, -25.624688008999925],
            [-54.58335607899991, -25.6448418169999],
            [-54.598497273999925, -25.65383351699994],
            [-54.63371476299997, -25.652076516999955],
            [-54.64288732999998, -25.661584980999947],
            [-54.64314571099993, -25.687939961999902],
            [-54.62492976899989, -25.74023651099992],
            [-54.62206172699993, -25.75997690899989],
            [-54.61715246599988, -25.773516133999948],
            [-54.59451818899993, -25.798734232999905],
            [-54.58790360499992, -25.8108265179999],
            [-54.58955725099989, -25.832944029999908],
            [-54.59922074399992, -25.850720722999938],
            [-54.61007279499995, -25.866533711999935],
            [-54.61524043799997, -25.882863464999957],
            [-54.60733394399992, -25.927925312999918],
            [-54.60640376799995, -25.946632181999902],
            [-54.61524043799997, -25.9617216999999],
            [-54.623689533999965, -25.9643055209999],
            [-54.64795161999987, -25.96564910899987],
            [-54.65619401099988, -25.96916310599991],
            [-54.66226599099994, -25.97991180399994],
            [-54.66159419799996, -25.989937031999958],
            [-54.658261067999945, -26.0003756709999],
            [-54.65332596899992, -26.03076141299995],
            [-54.64252559499997, -26.06280080199987],
            [-54.64314571099993, -26.085228373999954],
            [-54.66381628399995, -26.149203796999927],
            [-54.65994055199991, -26.164396666999963],
            [-54.64185380099991, -26.1840337109999],
            [-54.638288126999925, -26.196952819999908],
            [-54.64469600499987, -26.208218281999876],
            [-54.65619401099988, -26.22299774199989],
            [-54.66433304899991, -26.236226908999882],
            [-54.66497381799991, -26.238863213999963],
            [-54.666141723999885, -26.24366831499991],
            [-54.66366125499991, -26.26330535899993],
            [-54.66366125499991, -26.30836720799998],
            [-54.67906083199992, -26.33988983199994],
            [-54.68043025799997, -26.34526418],
            [-54.6834016519999, -26.350845234999923],
            [-54.693065144999906, -26.411926777999923],
            [-54.69766434799996, -26.42815317799993],
            [-54.70647517899994, -26.441795755999934],
            [-54.737170980999906, -26.47321502699988],
            [-54.76530879799995, -26.494092305999942],
            [-54.78034663999992, -26.51042205799989],
            [-54.789829264999895, -26.528508808999987],
            [-54.78876989799991, -26.54256479899992],
            [-54.78349890199988, -26.55672414199995],
            [-54.78034663999992, -26.57522430399989],
            [-54.781276814999984, -26.598168639999926],
            [-54.78494584199987, -26.6227666219999],
            [-54.793059041999896, -26.64498748799994],
            [-54.807011678999885, -26.661213886999946],
            [-54.81732112699987, -26.66576141399989],
            [-54.82282466699988, -26.66328094499991],
            [-54.827423868999915, -26.658113301999904],
            [-54.83496862799987, -26.654392598999905],
            [-54.879358683999925, -26.654392598999905],
            [-54.903336548999846, -26.659870299999895],
            [-54.91989884499995, -26.67413299599987],
            [-54.930725056999876, -26.693976744999944],
            [-54.943876708999966, -26.73996877099995],
            [-54.951137247999924, -26.75753875699992],
            [-54.96100744599991, -26.772318216999935],
            [-54.975270141999886, -26.787821145999942],
            [-54.99178076199988, -26.794642435999904],
            [-55.040744181999884, -26.798466491999946],
            [-55.060897989999944, -26.805184427999876],
            [-55.12577775099987, -26.863578795999928],
            [-55.13267655499996, -26.880632018999876],
            [-55.1188789469999, -26.920009460999964],
            [-55.122315429999844, -26.941713561999876],
            [-55.13836096299991, -26.953702493999927],
            [-55.161563679999915, -26.9573198449999],
            [-55.201199503999874, -26.955459492999907],
            [-55.21665075699988, -26.95122202599994],
            [-55.23517675799991, -26.942230326],
            [-55.256544962999925, -26.93458221399993],
            [-55.28060034199984, -26.934272155999935],
            [-55.329408731999905, -26.95845672599991],
            [-55.37622757999992, -26.963831074999874],
            [-55.39632971199998, -26.969308776999952],
            [-55.414003051999885, -26.979850768999924],
            [-55.43084956899989, -26.996387226999914],
            [-55.4427609869999, -27.01550750699991],
            [-55.44883296699996, -27.035868021999946],
            [-55.451313435999936, -27.082066751999903],
            [-55.46185542899991, -27.097983092999925],
            [-55.486401733999884, -27.100050149999973],
            [-55.51399694899996, -27.097466328999886],
            [-55.53384069899994, -27.099430033999923],
            [-55.54536454299998, -27.115243021999916],
            [-55.54952449599992, -27.135810241999906],
            [-55.55533809499991, -27.153793639999975],
            [-55.571745361999945, -27.161545104999902],
            [-55.59828120999995, -27.16753957099992],
            [-55.59897884199995, -27.18262908999992],
            [-55.5748717859999, -27.223556823999942],
            [-55.57058264199995, -27.235339049999936],
            [-55.56867061399993, -27.245984394999937],
            [-55.570711832999876, -27.25642303499997],
            [-55.58407019099991, -27.276783549],
            [-55.583243367999984, -27.28350148499993],
            [-55.58076289899989, -27.29166636099994],
            [-55.58164139799993, -27.305515645999918],
            [-55.591330728999964, -27.328356627999923],
            [-55.60747961499996, -27.345513203999886],
            [-55.628718628999934, -27.35636525499993],
            [-55.6536266679999, -27.360085957999942],
            [-55.68171280999994, -27.379412943999895],
            [-55.71749873899995, -27.4173434449999],
            [-55.75473160799987, -27.44369842499995],
            [-55.81516719599989, -27.414139505999927],
            [-55.84209061699991, -27.407421569999897],
            [-55.85415706399988, -27.40122039799992],
            [-55.86278702799993, -27.391091816999875],
            [-55.877850708999915, -27.35357472699988],
            [-55.89283687399998, -27.334867858999885],
            [-55.913094034999915, -27.32783986399997],
            [-55.93637426799992, -27.32825327499998],
            [-55.960662190999926, -27.331560566999897],
            [-55.96609441599989, -27.33172306899992],
            [-55.984846760999886, -27.332284036999894],
            [-56.00689354499991, -27.328250904999962],
            [-56.07375606299985, -27.304895527999946],
            [-56.07424597799991, -27.304811111999882],
            [-56.098948323999906, -27.30055470699996],
            [-56.124553995999946, -27.298901061999914],
            [-56.14997879999996, -27.31182016999992],
            [-56.1688923749999, -27.32473927799994],
            [-56.20542761299993, -27.362153014999905],
            [-56.22801021299995, -27.371248066999968],
            [-56.25676814799988, -27.37827606199997],
            [-56.27984167499994, -27.38964487699988],
            [-56.28531937699992, -27.41134897799988],
            [-56.28146948299988, -27.438634134999887],
            [-56.28531937699992, -27.46095835299994],
            [-56.296998250999906, -27.480905456999963],
            [-56.3164802659999, -27.50043914799997],
            [-56.33598811899989, -27.525657246999927],
            [-56.34965653499992, -27.556353047999963],
            [-56.36753658099988, -27.580640970999966],
            [-56.39973099799991, -27.58684214299994],
            [-56.400298629999895, -27.586636240999965],
            [-56.431356974999915, -27.575369976999937],
            [-56.46148433499991, -27.553872577999897],
            [-56.48732255099992, -27.52720753899986],
            [-56.50621028699996, -27.5001290889999],
            [-56.54644038899988, -27.455067240999938],
            [-56.5469333449999, -27.455002941999865],
            [-56.61299963399995, -27.446385598999896],
            [-56.63801587499992, -27.45291157499993],
            [-56.683124552999914, -27.464679056999955],
            [-56.734232543999894, -27.50043914799997],
            [-56.771155354999934, -27.506743671999885],
            [-56.771510649999925, -27.506548448999908],
            [-56.807458048999905, -27.486796569999868],
            [-56.8692630619999, -27.431502786999943],
            [-56.90435135899992, -27.41868703199995],
            [-56.90444715299995, -27.418695948999897],
            [-56.940989949999874, -27.422097675999893],
            [-56.97731848199996, -27.435326842999885],
            [-57.07622717399994, -27.48400604299991],
            [-57.108990030999934, -27.49062062599991],
            [-57.148160766999865, -27.488966979999958],
            [-57.1566873779999, -27.48772674599992],
            [-57.18009680199995, -27.487313333999907],
            [-57.1804525069999, -27.48721406699987],
            [-57.191207234999865, -27.484212747999962],
            [-57.20040563999987, -27.478941751999926],
            [-57.22707067899992, -27.458684590999923],
            [-57.23709590699994, -27.454240417999927],
            [-57.23758762399984, -27.454120240999927],
            [-57.283026316999894, -27.443014888999883],
            [-57.292493041999904, -27.44070119299994],
            [-57.30298335799995, -27.435533548999942],
            [-57.31011574999988, -27.429207701999943],
            [-57.32628942999989, -27.414862975999924],
            [-57.33522945099989, -27.409488626999874],
            [-57.35646609699995, -27.40434299199991],
            [-57.36039587499994, -27.403390807999912],
            [-57.3866991779999, -27.403494160999927],
            [-57.487674926999915, -27.416413268999946],
            [-57.513358113999914, -27.414139505999927],
            [-57.51993790499995, -27.412098551999904],
            [-57.535682332999954, -27.40721486399994],
            [-57.69779130099991, -27.33352427199992],
            [-57.69818345599995, -27.333398221999886],
            [-57.709366821999964, -27.329803568999907],
            [-57.811582803999926, -27.31068328899991],
            [-57.81191292999998, -27.31058298799988],
            [-57.85478430199987, -27.297557474999863],
            [-57.8550884709999, -27.29749900199991],
            [-57.89950352199989, -27.288960658999898],
            [-57.91338537599998, -27.286292012999894],
            [-57.9440295009999, -27.27461313899991],
            [-57.94435643399987, -27.274551133999935],
            [-58.00366413399993, -27.26330312199991],
            [-58.02195755999989, -27.259833678999897],
            [-58.02204621299995, -27.25983135699998],
            [-58.05353186099995, -27.259006855999885],
            [-58.113993285999896, -27.268928730999875],
            [-58.12882442299991, -27.269652200999957],
            [-58.238223428999845, -27.257043151999937],
            [-58.510764932999905, -27.278437194999952],
            [-58.60016516099989, -27.31295705199993],
            [-58.60419592299988, -27.31626434299993],
            [-58.60413463399988, -27.315548077999907],
            [-58.59990677999991, -27.266138203999915],
            [-58.601560424999974, -27.245674336999954],
            [-58.61401444499995, -27.226657409999888],
            [-58.63871577999987, -27.210120950999894],
            [-58.65235835799987, -27.198028665999914],
            [-58.658404499999904, -27.185109557999894],
            [-58.65328853399993, -27.156274108999952],
            [-58.638819132999885, -27.135913594999934],
            [-58.61613317899992, -27.12382130999994],
            [-58.56549027499997, -27.11596649099991],
            [-58.560529337999924, -27.10552785299997],
            [-58.56238968999992, -27.090128275999888],
            [-58.56218298299987, -27.0721448769999],
            [-58.55970251499991, -27.063359883999922],
            [-58.556395223999914, -27.05550506599988],
            [-58.55169266799993, -27.048167011999894],
            [-58.54543981999993, -27.041035664999953],
            [-58.536258596999915, -27.03629371399991],
            [-58.536034708999864, -27.036178079999928],
            [-58.53050533099986, -27.040518900999913],
            [-58.52802486199988, -27.047753600999968],
            [-58.52802486199988, -27.05168100999994],
            [-58.527043009999915, -27.054161478999916],
            [-58.5200320939999, -27.05836802799989],
            [-58.519808308999956, -27.058502298999898],
            [-58.51154007999992, -27.06015594499995],
            [-58.50756099499992, -27.05509165499997],
            [-58.50673417199991, -27.038451842999862],
            [-58.504873819999915, -27.031527200999875],
            [-58.501359822999945, -27.023672383999937],
            [-58.49236812399991, -27.009719746999934],
            [-58.47453975499985, -26.990082702999914],
            [-58.46663326099991, -26.975923359999868],
            [-58.48161942599998, -26.963831074999874],
            [-58.48368648299993, -26.950601907999967],
            [-58.47546993099991, -26.937992858999863],
            [-58.45981197099985, -26.928174336999888],
            [-58.415525268999914, -26.9175289919999],
            [-58.39387284299994, -26.90967417399996],
            [-58.38467443899995, -26.897065124999926],
            [-58.37470088699993, -26.887556660999863],
            [-58.3289155679999, -26.884146015999917],
            [-58.31578975399992, -26.874120788999903],
            [-58.32214595599996, -26.85675750699997],
            [-58.3403877369999, -26.844458515999932],
            [-58.35237666799986, -26.830505879999947],
            [-58.34002600199992, -26.808595071999903],
            [-58.32333451299988, -26.803840839999907],
            [-58.305506143999935, -26.809111836999932],
            [-58.288556274999934, -26.81148895299988],
            [-58.27481034399989, -26.798363138999918],
            [-58.2784793699999, -26.790198261999905],
            [-58.28654089399987, -26.778726094999882],
            [-58.28793615799995, -26.76859751399992],
            [-58.27139969899986, -26.76425669399994],
            [-58.25925573699996, -26.764463398999908],
            [-58.251762654999936, -26.763223164999957],
            [-58.24793859899998, -26.758158874999893],
            [-58.24519974799995, -26.680230814999916],
            [-58.24065222199991, -26.661213886999946],
            [-58.235536254999914, -26.649845072999952],
            [-58.23228063999994, -26.648604837999926],
            [-58.22716467299995, -26.652015482999943],
            [-58.19569372599989, -26.657493183999932],
            [-58.18385982299989, -26.65676971499994],
            [-58.17864050299997, -26.65067189499989],
            [-58.181379353999915, -26.64157684299991],
            [-58.18716711499988, -26.633618671999955],
            [-58.1920763759999, -26.62462697399991],
            [-58.192283081999875, -26.61284474699991],
            [-58.188510701999945, -26.609744160999966],
            [-58.17150915499991, -26.598582050999937],
            [-58.16494624899994, -26.592277526999922],
            [-58.17052730299986, -26.58679982499993],
            [-58.17931229699994, -26.572640482999887],
            [-58.1854101159999, -26.564992369999914],
            [-58.20799271699994, -26.55021291099989],
            [-58.213367065999904, -26.54452850299994],
            [-58.21734615099987, -26.527578632999933],
            [-58.214193888999915, -26.512385762999912],
            [-58.208716186999936, -26.4968828329999],
            [-58.20592565999988, -26.479416197999868],
            [-58.202721719999914, -26.471561380999916],
            [-58.1886657309999, -26.462052916999937],
            [-58.1854101159999, -26.451717630999923],
            [-58.209594686999964, -26.431253762999873],
            [-58.21305700699992, -26.41864471399994],
            [-58.20618404199985, -26.402728372999917],
            [-58.17269771399995, -26.349294942999904],
            [-58.16763342299987, -26.33503224699993],
            [-58.16494624899994, -26.31859914099995],
            [-58.17001053899992, -26.28655975299995],
            [-58.16995886299989, -26.270333353999945],
            [-58.161845662999895, -26.26330535899993],
            [-58.145980997999885, -26.260101419999955],
            [-58.12329504399992, -26.25152313199993],
            [-58.105983438999914, -26.23953419999988],
            [-58.106603556999886, -26.22609832699993],
            [-58.12122798699997, -26.21669321699997],
            [-58.13714432799989, -26.209458516999902],
            [-58.14892655499989, -26.199329935999955],
            [-58.15130366999992, -26.181449889999982],
            [-58.14117508999988, -26.1847571819999],
            [-58.13321691899992, -26.18899464999994],
            [-58.12763586499992, -26.1946790559999],
            [-58.12401851499993, -26.201913756999957],
            [-58.115233520999936, -26.190958352999886],
            [-58.1062934979999, -26.170287780999956],
            [-58.09668168099989, -26.136698099999933],
            [-58.08650142399992, -26.127189635999954],
            [-58.02159582599998, -26.10569223999991],
            [-57.98821284999991, -26.088535664999952],
            [-57.87271602399994, -26.010297546],
            [-57.859693562999894, -25.99427785199994],
            [-57.859590210999954, -25.980945332999923],
            [-57.90584061799984, -25.96864634199997],
            [-57.89824418199987, -25.953556822999886],
            [-57.86331091399998, -25.92761525499992],
            [-57.85710974199989, -25.91986378899992],
            [-57.851373656999925, -25.90839162199991],
            [-57.85240718599991, -25.897952981999964],
            [-57.875351521999875, -25.89020151799987],
            [-57.87819372599992, -25.883173522999954],
            [-57.875351521999875, -25.876145527999938],
            [-57.854215860999915, -25.86891082699988],
            [-57.8332352299999, -25.858782246999922],
            [-57.81966196599987, -25.84977922099992],
            [-57.812823039999955, -25.84524302199995],
            [-57.80186763499998, -25.83139373799989],
            [-57.81706050699992, -25.797493997999965],
            [-57.82062617999989, -25.77827036499994],
            [-57.80558833899991, -25.769898782999874],
            [-57.787243204999925, -25.7641110229999],
            [-57.767916219999876, -25.75067514999995],
            [-57.7510697029999, -25.734862161999956],
            [-57.74037268099988, -25.72214975999991],
            [-57.7511213789999, -25.719565937999903],
            [-57.760578165999874, -25.715638528999932],
            [-57.76848465999993, -25.709954121999985],
            [-57.774582478999974, -25.701685891999944],
            [-57.7537051999999, -25.672747089999888],
            [-57.74125118099991, -25.66189503899993],
            [-57.71990881299993, -25.65383351699994],
            [-57.70869502799988, -25.652903340999984],
            [-57.69820471199992, -25.65362681099988],
            [-57.68833451399985, -25.652696634999927],
            [-57.678981079999915, -25.647012226999976],
            [-57.6752603759999, -25.639260762999882],
            [-57.67004105699996, -25.616936543999913],
            [-57.668077351999926, -25.612285664999945],
            [-57.638776814999886, -25.6157996619999],
            [-57.62306717999991, -25.61538625099989],
            [-57.616297566999975, -25.609185078999914],
            [-57.611646687999894, -25.585930683999976],
            [-57.600691283999936, -25.578799336999865],
            [-57.58715205899995, -25.575698750999905],
            [-57.57531815699994, -25.56443328899995],
            [-57.570047159999916, -25.54665659599992],
            [-57.55692134599994, -25.459840189999923],
            [-57.55810990499995, -25.4435104369999],
            [-57.565292927999906, -25.430384622999924],
            [-57.57872879999988, -25.41674204499992],
            [-57.64079219599992, -25.372610371999926],
            [-57.64120560799992, -25.360518086999946],
            [-57.67148799699996, -25.290134785999925],
            [-57.671975553999886, -25.289830980999923],
            [-57.70233882699995, -25.2709111529999],
            [-57.72176916499993, -25.246106465999958],
            [-57.75406693499991, -25.18089080799993],
            [-57.76600419199994, -25.167868346999896],
            [-57.79732010999996, -25.153915709999907],
            [-57.812409627999955, -25.14368377699992],
            [-57.85648962399992, -25.096761575999977],
            [-57.87070064399998, -25.08528940799995],
            [-57.89049271599987, -25.078674824999965],
            [-57.9697643639999, -25.07846811999991],
            [-57.983768676999915, -25.074230651999954],
            [-57.98986649599996, -25.06410207099991],
            [-57.99363887599989, -25.05273325599991],
            [-58.000460164999936, -25.044361673999944],
            [-58.0098135989999, -25.04250132299994],
            [-58.03213781699995, -25.04508514399994],
            [-58.04205969299994, -25.044361673999944],
            [-58.11151281799991, -25.01232228599993],
            [-58.12401851499993, -25.01294240299991],
            [-58.13388871299989, -24.9978528849999],
            [-58.22406408799989, -24.94121551499991],
            [-58.242512572999914, -24.94173227899995],
            [-58.259152384999936, -24.952997741999923],
            [-58.28726436399998, -24.979766133999888],
            [-58.29930497299995, -24.987724303999954],
            [-58.3119656989999, -24.993615416999944],
            [-58.32328283699988, -24.995269064],
            [-58.335995238999914, -24.991858418999882],
            [-58.34131791199988, -24.98617401099993],
            [-58.34436682099988, -24.978319193999894],
            [-58.350567992999885, -24.96860402399996],
            [-58.41480179899992, -24.903078307999948],
            [-58.43852128099988, -24.872795918999927],
            [-58.450768595999904, -24.861737161999926],
            [-58.47340287299994, -24.851298522999883],
            [-58.694216267999934, -24.812024434999913],
            [-58.699383911999945, -24.807270202999916],
            [-58.701916055999845, -24.79931203199996],
            [-58.708117227999935, -24.795074564999908],
            [-58.71597204599996, -24.791870625999934],
            [-58.72325842399994, -24.786702982999927],
            [-58.737469441999906, -24.782775572999967],
            [-58.78847408099995, -24.78163869199996],
            [-58.80919632999988, -24.776781106999934],
            [-59.000915893999974, -24.644179381999905],
            [-59.032696899999905, -24.63704803499988],
            [-59.04241206899985, -24.630536803999902],
            [-59.062462524999916, -24.61234669999996],
            [-59.07217769399995, -24.60676564499994],
            [-59.078327189999925, -24.605628762999928],
            [-59.097189087999936, -24.60542205799989],
            [-59.11698116099993, -24.598807474999973],
            [-59.15439489799988, -24.57627654999996],
            [-59.17790767499989, -24.568731790999905],
            [-59.20648474199993, -24.55023162899998],
            [-59.248084269999936, -24.537209167999947],
            [-59.25764440899994, -24.53018117299993],
            [-59.263122111999934, -24.523463235999913],
            [-59.27046016499992, -24.518192239999877],
            [-59.28560135999993, -24.516125182999915],
            [-59.29505814599989, -24.512921244999944],
            [-59.30808060699994, -24.498761901999984],
            [-59.34097265699998, -24.48759979299996],
            [-59.35740576199993, -24.468996276999917],
            [-59.377766276999864, -24.43354624399997],
            [-59.387093871999895, -24.42383107499994],
            [-59.4260320649999, -24.392515156999934],
            [-59.450268310999974, -24.382386575999888],
            [-59.45380814699993, -24.374531758999936],
            [-59.45628861499992, -24.365436705999883],
            [-59.45972509799995, -24.358512064999985],
            [-59.46590043199993, -24.353551126999946],
            [-59.48765620899994, -24.34476613299995],
            [-59.51041967799992, -24.33267384799997],
            [-59.521142537999935, -24.32502573699989],
            [-59.53202042699988, -24.31407033299992],
            [-59.53997859799995, -24.308799335999893],
            [-59.558427082999856, -24.30538869199995],
            [-59.57540279199986, -24.295880228999877],
            [-59.600517537999906, -24.292882994999957],
            [-59.610516927999925, -24.289575703999958],
            [-59.61772578999995, -24.28347788499991],
            [-59.63532161499995, -24.261463724999928],
            [-59.673639688999856, -24.225393574999927],
            [-60.03366939299988, -24.007008971999895],
            [-60.0517303069999, -24.002874857999956],
            [-60.0723750409999, -24.004838561999904],
            [-60.119297241999845, -24.02023813899997],
            [-60.14324926799986, -24.02519907599992],
            [-60.218128418999896, -24.027369486999916],
            [-60.29641821299987, -24.016414082999944],
            [-60.328018350999855, -24.017964375999952],
            [-60.33737178599989, -24.016414082999944],
            [-60.34804296899989, -24.010833027999922],
            [-60.36757665999991, -23.994709980999943],
            [-60.378351196999944, -23.988508809999956],
            [-60.38742041099991, -23.987165221999902],
            [-60.42305131099988, -23.988508809999956],
            [-60.48488216199988, -23.977346699999927],
            [-60.517722533999915, -23.95574595199996],
            [-60.535964314999944, -23.94758107499993],
            [-60.5717502439999, -23.946030781999923],
            [-60.57753800499995, -23.944170430999918],
            [-60.593583536999915, -23.912234394999928],
            [-60.5946170659999, -23.906549987999895],
            [-60.603841308999904, -23.904689635999972],
            [-60.62115291399991, -23.895801289999966],
            [-60.63215999399989, -23.89228729299991],
            [-60.64370967699995, -23.891357116999956],
            [-60.689675862999934, -23.89363087999989],
            [-60.69941687099987, -23.891253763999927],
            [-60.71985489899993, -23.87502736399992],
            [-60.72928584899998, -23.87213348399993],
            [-60.787776137999884, -23.873445156999935],
            [-60.81685156299997, -23.874097187999965],
            [-60.83762548799993, -23.871823424999945],
            [-60.86635758499992, -23.855907083999924],
            [-60.899947265999856, -23.830482279999927],
            [-60.93666337099992, -23.813842467999905],
            [-60.97482641699992, -23.82407440199998],
            [-61.00634903999986, -23.805470885999924],
            [-61.01580582699992, -23.796685892999932],
            [-61.03022355099995, -23.774620055999947],
            [-61.036243855999885, -23.76883229599987],
            [-61.03805253099998, -23.755396422999922],
            [-61.04998978699993, -23.734725850999908],
            [-61.066216186999924, -23.715708922999937],
            [-61.09251949099988, -23.701859638999878],
            [-61.109650227999936, -23.67560801199994],
            [-61.11884863299994, -23.666409606999935],
            [-61.10975358099995, -23.649976500999884],
            [-61.10623958399992, -23.627238871999907],
            [-61.10985693399991, -23.606981709999985],
            [-61.122233439999945, -23.598196715999904],
            [-61.13949336799993, -23.592719013999925],
            [-61.154453694999916, -23.58031667099995],
            [-61.16781205199993, -23.566570738999914],
            [-61.18024023399991, -23.557165628999954],
            [-61.18773331699995, -23.556235453999903],
            [-61.20768042099988, -23.55757904099997],
            [-61.21439835599989, -23.557165628999954],
            [-61.22357092299998, -23.55127451599995],
            [-61.24292374699985, -23.533084411999923],
            [-61.25194128399991, -23.529260354999877],
            [-61.2726118569999, -23.52357594799993],
            [-61.282947143999934, -23.509933369999928],
            [-61.288967448999955, -23.49412038099993],
            [-61.29695145699992, -23.481407979999886],
            [-61.36177954099995, -23.454742940999935],
            [-61.3848530679999, -23.453709411999952],
            [-61.39867651399996, -23.450092061999968],
            [-61.40872757999989, -23.443580830999906],
            [-61.42050980699989, -23.433658955999903],
            [-61.43570267799993, -23.423737080999913],
            [-61.45192907799992, -23.417432555999895],
            [-61.47030004899992, -23.414125264999896],
            [-61.49184912199988, -23.41319508899994],
            [-61.50107336399989, -23.40782073999989],
            [-61.5103751229999, -23.38435963899991],
            [-61.52634313999994, -23.374747823],
            [-61.52546463999991, -23.36472259499996],
            [-61.52078792399993, -23.35325042699995],
            [-61.51605952999995, -23.34498219799991],
            [-61.53396541399994, -23.344568785999897],
            [-61.545773478999934, -23.342605082999867],
            [-61.55463598599994, -23.33836761499991],
            [-61.605149699999885, -23.28927500399996],
            [-61.6196191009999, -23.28286712599993],
            [-61.666851359999924, -23.28286712599993],
            [-61.68031306999998, -23.279249775999943],
            [-61.68876216699988, -23.274495543999947],
            [-61.70442012499984, -23.258372497999886],
            [-61.71852779199989, -23.249277444999905],
            [-61.7329971929999, -23.2433863319999],
            [-61.74426265499997, -23.234808043999877],
            [-61.7488101809999, -23.21734141099992],
            [-61.749481974999895, -23.198841246999905],
            [-61.752272501999926, -23.187059020999897],
            [-61.75847367399993, -23.177447204999893],
            [-61.76927404899996, -23.165561624999953],
            [-61.78002274699989, -23.156879984999904],
            [-61.80265702299994, -23.144994404999878],
            [-61.814284219999905, -23.135175882999903],
            [-61.83697017499995, -23.104686787999924],
            [-61.84498002199993, -23.097245381999898],
            [-61.956446085999914, -23.034406839999917],
            [-61.99205114799989, -22.998129984999963],
            [-62.00590043099996, -22.97890635199994],
            [-62.0060554609999, -22.97435882499991],
            [-62.008949340999976, -22.969707945999943],
            [-62.00378169799998, -22.946350198999895],
            [-62.0060554609999, -22.93684173599992],
            [-62.0171658939999, -22.92175221799991],
            [-62.035821085999885, -22.884855244999898],
            [-62.050445515999854, -22.86449473099995],
            [-62.071632853999915, -22.84392751099996],
            [-62.08083125899992, -22.832351988999918],
            [-62.08460363799995, -22.82015635099991],
            [-62.08935786999993, -22.819949645999955],
            [-62.099228068999906, -22.81374847399988],
            [-62.107858031999854, -22.80651377399991],
            [-62.10878820799991, -22.80299977599995],
            [-62.11586787999994, -22.799795836999877],
            [-62.119743611999894, -22.792147724999907],
            [-62.12253413999994, -22.783156026999862],
            [-62.12615148999993, -22.77571461999993],
            [-62.15348832299995, -22.747809345999954],
            [-62.15974116999985, -22.737164000999954],
            [-62.16408199099993, -22.725898538999985],
            [-62.17079992699988, -22.71732025099996],
            [-62.18418412299991, -22.71370290099989],
            [-62.18826656099989, -22.70832855299993],
            [-62.17591589399984, -22.68486745199995],
            [-62.19503617399994, -22.67360198999998],
            [-62.19462276299993, -22.66057952899986],
            [-62.18764644399994, -22.638565368999963],
            [-62.192969116999876, -22.62823008199996],
            [-62.19658646699986, -22.626473083999983],
            [-62.202529256999895, -22.62719655299989],
            [-62.21493159999994, -22.624302672999903],
            [-62.239736287999904, -22.61376068099993],
            [-62.25281042499995, -22.603632100999974],
            [-62.252965454999895, -22.59112640299989],
            [-62.23885778899995, -22.573039651999878],
            [-62.23322505699991, -22.556296487999916],
            [-62.24118322799998, -22.53841644299986],
            [-62.26335241699991, -22.51443857799994],
            [-62.26883011899989, -22.51299163899995],
            [-62.27559973199993, -22.513508401999985],
            [-62.28138749199991, -22.512061463],
            [-62.28381628499997, -22.504826761999936],
            [-62.283609578999915, -22.493768005999925],
            [-62.284539753999866, -22.488703714999943],
            [-62.2872269289999, -22.48394948299996],
            [-62.29451330599997, -22.479815368999937],
            [-62.30572709199993, -22.476714781999902],
            [-62.34135696699991, -22.472261048],
            [-62.3487218839999, -22.471340433999927],
            [-62.36825557499992, -22.464415791999954],
            [-62.43807043499987, -22.4196640009999],
            [-62.454968627999875, -22.403851013],
            [-62.46194494699995, -22.388761493999894],
            [-62.470574910999915, -22.38183685299991],
            [-62.51072749899993, -22.37015797899994],
            [-62.52338822499988, -22.364886982999906],
            [-62.54762447099995, -22.335328063999967],
            [-62.56467769399998, -22.321995543999947],
            [-62.5882938229999, -22.31641448899994],
            [-62.59961096199987, -22.315174254999903],
            [-62.613150186999945, -22.31145355199989],
            [-62.62529414899984, -22.305045674999946],
            [-62.63268387899987, -22.295950622999968],
            [-62.63082352699985, -22.28768239399993],
            [-62.624208943999946, -22.278897398999945],
            [-62.620281534999975, -22.268458760999906],
            [-62.62643103099995, -22.255022887999957],
            [-62.61960974099989, -22.255022887999957],
            [-62.62482906099993, -22.247271422999944],
            [-62.63180537899993, -22.240760192999886],
            [-62.64038366799994, -22.23621266699986],
            [-62.65035721899994, -22.234455667999967],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Brazilian I.',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-57.64246584634791, -30.193092102762034],
            [-57.63397090699996, -30.183582864999906],
            [-57.61169836499991, -30.182962747999937],
            [-57.602792548565105, -30.190516953885325],
            [-57.64246584634791, -30.193092102762034],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Venezuela',
        iso3: 'VEN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-60.02098548099991, 8.558010158000059],
              [-59.95969458099998, 8.46816640300004],
              [-59.8556182449999, 8.352126974000015],
              [-59.81559484899992, 8.287763977000026],
              [-59.81665421599993, 8.267196757000121],
              [-59.82928910299995, 8.245105083000041],
              [-59.84846105999986, 8.227741801000107],
              [-59.86920914699991, 8.22112721800002],
              [-59.88975052899988, 8.21988698300008],
              [-59.939721638999856, 8.208440654000071],
              [-59.95705908199997, 8.200146587000106],
              [-59.967678588999945, 8.188390198000121],
              [-59.99331009899993, 8.168520609000026],
              [-60.00067399099993, 8.15294016500009],
              [-60.000544799999886, 8.138548279000076],
              [-59.99801265499991, 8.127050273000052],
              [-59.99933040399995, 8.115397237000082],
              [-60.01100927799993, 8.100436911000116],
              [-60.019458373999925, 8.060310161000118],
              [-60.02958695499987, 8.04281768800007],
              [-60.046485148999864, 8.032921652000084],
              [-60.06800838299992, 8.03175893200006],
              [-60.10790258899996, 8.035557150000088],
              [-60.129219116999934, 8.02881337500007],
              [-60.14978633699994, 8.013465475000089],
              [-60.16572851599997, 7.997032369000124],
              [-60.18309179699989, 7.982666321000124],
              [-60.23112504099993, 7.964114482000085],
              [-60.24301061999995, 7.950575256000107],
              [-60.253294229999966, 7.934555562000057],
              [-60.267998436999875, 7.921262469000098],
              [-60.271871907999895, 7.917760722000082],
              [-60.32034440099997, 7.884739482000029],
              [-60.34241023799987, 7.864792379000093],
              [-60.35042008499994, 7.841796367000143],
              [-60.37475968499987, 7.823606263000016],
              [-60.418503784999956, 7.819368795000059],
              [-60.50327897199989, 7.820867412000069],
              [-60.52575821999989, 7.813374329000027],
              [-60.53984004799992, 7.800093486000023],
              [-60.55958044499988, 7.763041483000052],
              [-60.582085530999905, 7.736324769000092],
              [-60.58699479199993, 7.727126363000096],
              [-60.587718261999925, 7.718341370000104],
              [-60.58441096999994, 7.69937611900005],
              [-60.58451432299995, 7.688524068000106],
              [-60.599862223999935, 7.661548971000073],
              [-60.59745926999997, 7.646717834000043],
              [-60.60125748699991, 7.633850403000054],
              [-60.61066259799986, 7.626822408000038],
              [-60.625157836999904, 7.629457906000056],
              [-60.63169490599998, 7.624600322000035],
              [-60.64148758999994, 7.610906067000116],
              [-60.65562109399988, 7.585222880000046],
              [-60.67114986199991, 7.566050924000123],
              [-60.7164959319999, 7.551581523000095],
              [-60.73057775899994, 7.525433248000084],
              [-60.729699259999904, 7.510343730000088],
              [-60.723833984999914, 7.495822652000044],
              [-60.70065710499992, 7.453499655000144],
              [-60.6881255699999, 7.448642070000034],
              [-60.674198771999926, 7.445489807000072],
              [-60.66063370799992, 7.436136373000124],
              [-60.65626704999994, 7.428798320000041],
              [-60.65582779999994, 7.422855530000021],
              [-60.65691300499992, 7.416551005000102],
              [-60.657274739999934, 7.408127747000023],
              [-60.65324397799992, 7.398464254000089],
              [-60.64515661699994, 7.393399963000107],
              [-60.63608740299986, 7.389834290000053],
              [-60.628981892999946, 7.38435658800006],
              [-60.622005574999946, 7.371540833000083],
              [-60.61055924499993, 7.343635559000091],
              [-60.60177425199993, 7.330148011000034],
              [-60.599862223999935, 7.321879781000078],
              [-60.59996557699995, 7.313921610000122],
              [-60.60223933999987, 7.306531881000112],
              [-60.60676102799991, 7.299452209000094],
              [-60.63110062699991, 7.277696432000084],
              [-60.64355464699989, 7.250669658000035],
              [-60.64306372099986, 7.22090403200005],
              [-60.62841345299998, 7.191138408000057],
              [-60.61763891599995, 7.180389710000043],
              [-60.54800492399994, 7.125509338000128],
              [-60.53490494799988, 7.125767721000102],
              [-60.51286494999988, 7.165196839000103],
              [-60.49661271199997, 7.1805964160001],
              [-60.47532202199989, 7.188502910000054],
              [-60.449509643999875, 7.18834788],
              [-60.43713313799992, 7.183748678000057],
              [-60.42674617499998, 7.176875713000086],
              [-60.41581660999992, 7.171346334000077],
              [-60.40147640099991, 7.170881246000064],
              [-60.3851724859999, 7.17331003800011],
              [-60.372020833999926, 7.172276509000127],
              [-60.360109416999876, 7.16576527900007],
              [-60.34827287499991, 7.152684071000053],
              [-60.34757788099998, 7.151915995000095],
              [-60.31282548099992, 7.132589009000057],
              [-60.29993221099994, 7.121013489000106],
              [-60.292335774999884, 7.105252177000125],
              [-60.291586466999945, 7.088302307000021],
              [-60.29579809599991, 7.070732321000051],
              [-60.303575398999925, 7.054144185000041],
              [-60.3134197599999, 7.040243225000069],
              [-60.32755326399993, 7.028564352000089],
              [-60.34458064799986, 7.017608948000102],
              [-60.35969600399997, 7.004896546000055],
              [-60.368093424999955, 6.988101705000091],
              [-60.37734350599996, 6.938544007000118],
              [-60.394190022999936, 6.948465881000033],
              [-60.420958414999916, 6.942213034000119],
              [-60.54872839399994, 6.863096415000129],
              [-60.62068782599988, 6.845888164000058],
              [-60.63954972399992, 6.837723287000131],
              [-60.65580196199991, 6.824571635000069],
              [-60.68414648499993, 6.784031474000045],
              [-60.70034704699992, 6.76708160400004],
              [-60.72153438299998, 6.75969187400004],
              [-60.73646887199993, 6.764782003000022],
              [-60.77305578599987, 6.788423971000043],
              [-60.79351965299995, 6.793824158000106],
              [-60.80525020399992, 6.792480571000041],
              [-60.8282978929999, 6.787132059000086],
              [-60.83762548799993, 6.786356913000077],
              [-60.8496144209999, 6.789948426000052],
              [-60.85852860499992, 6.796459656000124],
              [-60.86571162999985, 6.803306783000082],
              [-60.872403727999966, 6.808112692000094],
              [-60.89457291699989, 6.81415883400004],
              [-60.90756953999994, 6.815244039000035],
              [-60.913383137999915, 6.811213277000121],
              [-60.9111610519999, 6.800025329000093],
              [-60.90129085299992, 6.786021016000092],
              [-60.89906876699993, 6.776770935000073],
              [-60.89948217799994, 6.768554383000051],
              [-60.90123917699992, 6.764420268000023],
              [-60.92836930399997, 6.735869039000065],
              [-60.93382116699988, 6.73173492500004],
              [-60.9545950939999, 6.728737691000035],
              [-61.0002512209999, 6.734370422000055],
              [-61.01867386999993, 6.720443624000069],
              [-61.04006791199993, 6.726980693000144],
              [-61.06122941099997, 6.730081279000089],
              [-61.07040197799998, 6.711865336000045],
              [-61.08905716999993, 6.717498067000065],
              [-61.11096797699989, 6.719513449000118],
              [-61.12982987499993, 6.715844421000028],
              [-61.1393124999999, 6.704449768000117],
              [-61.17065425599992, 6.668508810000063],
              [-61.19018794799993, 6.632877909000072],
              [-61.2047865399999, 6.595825908000108],
              [-61.211969563999844, 6.561435242000073],
              [-61.209669962999925, 6.540971375000098],
              [-61.20008398499991, 6.531101176000035],
              [-61.18613134799992, 6.523323873000024],
              [-61.17086096199995, 6.509242045000079],
              [-61.16303198299994, 6.49428171800011],
              [-61.15347184299995, 6.464361064000087],
              [-61.1425939529999, 6.449426575000132],
              [-61.1397517499999, 6.441261698000105],
              [-61.13856319199991, 6.433070984000082],
              [-61.13897660299992, 6.42480275500013],
              [-61.14109533799987, 6.416457011000077],
              [-61.14993200799998, 6.404442241000112],
              [-61.1548154299999, 6.390567119000139],
              [-61.16091324899986, 6.342353007000042],
              [-61.159492146999895, 6.331268412000028],
              [-61.15197322599994, 6.303363139000055],
              [-61.1467022299999, 6.294216411000065],
              [-61.1290805669999, 6.283312683000091],
              [-61.124145467999966, 6.276233012000077],
              [-61.12135493999992, 6.269463400000035],
              [-61.11794429499989, 6.267241313000042],
              [-61.11479203299993, 6.264011536000055],
              [-61.11285416699991, 6.254141337000078],
              [-61.11804764899992, 6.216236674000072],
              [-61.118357706999916, 6.202568258000056],
              [-61.12156164499987, 6.18665191600013],
              [-61.13269791699989, 6.183551331000089],
              [-61.14734818499997, 6.185049948000099],
              [-61.16111995499992, 6.182879537000105],
              [-61.173987386999926, 6.171639913000149],
              [-61.18473608499994, 6.146008403000096],
              [-61.19447709099998, 6.132856750000116],
              [-61.20651770099994, 6.125777079000088],
              [-61.222924967999916, 6.120531921000065],
              [-61.25610123699994, 6.114382426000091],
              [-61.26938208099995, 6.107225240000062],
              [-61.278554646999936, 6.093040060000092],
              [-61.291189534999944, 6.061155701000132],
              [-61.3380858969999, 5.986793314000039],
              [-61.352762003999885, 5.975191956000074],
              [-61.38627417099991, 5.956588440000118],
              [-61.39671280899992, 5.945581360000034],
              [-61.37960791099988, 5.905299581000094],
              [-61.34736181699992, 5.869668681000107],
              [-61.271604166999936, 5.786107890000011],
              [-61.19582067899995, 5.702676290000042],
              [-61.12001135299994, 5.619115499000131],
              [-61.04425370299987, 5.535606385000051],
              [-60.9684960539999, 5.452071432000139],
              [-60.89266088899987, 5.368562317000055],
              [-60.8169032399999, 5.285079041000074],
              [-60.73985367899988, 5.202138367000131],
              [-60.71101822899993, 5.198159282000063],
              [-60.684869954999925, 5.188314921000085],
              [-60.66430273499992, 5.170254008000072],
              [-60.59867366599991, 4.996879578000062],
              [-60.59192989199997, 4.949724834000051],
              [-60.6126263029999, 4.9005805460001],
              [-60.68006404699992, 4.817949931000058],
              [-60.71814957699988, 4.784282735000104],
              [-60.76367651399994, 4.755085552000068],
              [-60.8600272219999, 4.712426656000076],
              [-60.86868302499997, 4.711186422000139],
              [-60.887958333999904, 4.711134745000038],
              [-60.89581315199993, 4.708525085000119],
              [-60.90343542499991, 4.699585062000082],
              [-60.9310564779999, 4.637392477000091],
              [-60.94040991199995, 4.594061788000118],
              [-60.94779964299997, 4.573597921000058],
              [-60.97728104699988, 4.534969788000069],
              [-61.01195593299988, 4.518304138000133],
              [-61.095465046999976, 4.507684631000046],
              [-61.151198079999915, 4.492052510000093],
              [-61.168587198999944, 4.490243835000101],
              [-61.18592464199986, 4.494119568000059],
              [-61.22010860299994, 4.510681865000066],
              [-61.23806616299993, 4.515875346000072],
              [-61.29726151599991, 4.523730164000099],
              [-61.315580810999904, 4.52078460700011],
              [-61.322944702999905, 4.508847351000071],
              [-61.29584041399991, 4.469004822000045],
              [-61.29304988599995, 4.448050029000044],
              [-61.3082427569999, 4.433322246000046],
              [-61.33322831299998, 4.423865459000069],
              [-61.36002254299987, 4.418930359000043],
              [-61.3810806889999, 4.417741801000105],
              [-61.43862239699993, 4.421152446000036],
              [-61.458181925999924, 4.419137064000083],
              [-61.501874348999905, 4.401851298000096],
              [-61.51642126499988, 4.374772848000134],
              [-61.52236405499988, 4.297774964000027],
              [-61.52673071299995, 4.285501811000074],
              [-61.53350032599991, 4.273590393000049],
              [-61.54210445199993, 4.263022562000074],
              [-61.55215551799995, 4.254961040000083],
              [-61.56727087499988, 4.248527324000037],
              [-61.57657263199991, 4.249715881000057],
              [-61.5854093019999, 4.253410746000057],
              [-61.599077717999904, 4.254392599000127],
              [-61.61018815099993, 4.251627909000078],
              [-61.62822322599993, 4.243463033000054],
              [-61.64052221799997, 4.241912740000132],
              [-61.64915218099992, 4.243411357000042],
              [-61.68054561399995, 4.252480571000106],
              [-61.71888952599997, 4.254650980000093],
              [-61.73780310099991, 4.252067159000092],
              [-61.75635493999994, 4.246356914000046],
              [-61.77919592299986, 4.232688497000126],
              [-61.83102738499994, 4.176929627000078],
              [-61.84704707899991, 4.166051737000117],
              [-61.866890828999885, 4.157034200000069],
              [-61.88812984199987, 4.150161235000013],
              [-61.908231973999904, 4.146156311000112],
              [-61.93148636999993, 4.146414693000082],
              [-61.95034826699995, 4.152228292000075],
              [-61.96859004699991, 4.160083110000102],
              [-61.990190795999894, 4.166413473000119],
              [-62.03504593999989, 4.159876404000045],
              [-62.111113647999844, 4.104841004000093],
              [-62.15359167499989, 4.09029408800005],
              [-62.19265905799989, 4.094738261000145],
              [-62.38417191599993, 4.173467306000134],
              [-62.42809688399987, 4.183182475000081],
              [-62.46297847499994, 4.174707540000071],
              [-62.4665441489999, 4.168738912000052],
              [-62.46985144099992, 4.151608175000092],
              [-62.47517411299995, 4.143882548000093],
              [-62.48370072499998, 4.139179993000113],
              [-62.51491328999995, 4.133108012000079],
              [-62.53697912599995, 4.125408224000083],
              [-62.546435913999915, 4.113910218000058],
              [-62.548606322999916, 4.098071391000062],
              [-62.54881302999988, 4.077452494000056],
              [-62.56095699099987, 4.037790833000074],
              [-62.5886555589999, 4.03071116200006],
              [-62.67066605699998, 4.043656108000064],
              [-62.72745845599991, 4.038514302000067],
              [-62.74435664899991, 4.034018453000058],
              [-62.766215779999925, 4.020711772000126],
              [-62.77065995299995, 4.005389710000074],
              [-62.76740433799995, 3.9870962520001],
              [-62.76626745599995, 3.964694520000108],
              [-62.77319209899994, 3.939941508000089],
              [-62.78280391499993, 3.920046081000081],
              [-62.788798380999964, 3.899401347000079],
              [-62.78512935399988, 3.8722970580001],
              [-62.77980668199993, 3.861289978000116],
              [-62.774277302999934, 3.854856262000069],
              [-62.77019486499992, 3.847828267000068],
              [-62.76683589699991, 3.822041727000055],
              [-62.74957596899992, 3.783568624000097],
              [-62.74042924099993, 3.741943258000092],
              [-62.73991247599989, 3.700447083000114],
              [-62.74957596899992, 3.660372010000032],
              [-62.77102168799985, 3.623345846000063],
              [-62.78631791299989, 3.604406434000026],
              [-62.79644649299985, 3.597300924000095],
              [-62.80776363199993, 3.596680807000027],
              [-62.822336385999876, 3.5988253780001],
              [-62.83158646699991, 3.594872131000031],
              [-62.85127518799993, 3.577224630000046],
              [-62.871997436999976, 3.565468241000048],
              [-62.88941239499991, 3.56081736200008],
              [-62.90770585199988, 3.560972392000025],
              [-62.931011922999915, 3.563762919000084],
              [-62.951062377999875, 3.570170797000117],
              [-62.975143595999896, 3.583064067000123],
              [-62.997054402999964, 3.599135437000086],
              [-63.01069698099988, 3.614974263000093],
              [-63.02495967699994, 3.637763571000079],
              [-63.130844685999904, 3.762122905000069],
              [-63.19321813999994, 3.806745504000091],
              [-63.2511990969999, 3.886559754000089],
              [-63.28597733599986, 3.920821229000097],
              [-63.35170975799991, 3.958725891000086],
              [-63.391448933999925, 3.97156748500008],
              [-63.42540034999985, 3.968363546000106],
              [-63.44824133299994, 3.939373068000037],
              [-63.455372680999886, 3.900589905000089],
              [-63.46886022999985, 3.867232768000036],
              [-63.51066646399991, 3.854546204000087],
              [-63.554229695999936, 3.875371806000132],
              [-63.622804321999894, 3.935213114000106],
              [-63.67158687399993, 3.946246033000094],
              [-63.690758829999936, 3.943998108000088],
              [-63.74589758399992, 3.93027801500007],
              [-63.77101232999985, 3.928805237000063],
              [-63.79059769699995, 3.93304270500002],
              [-63.83111201999989, 3.949449971000078],
              [-63.875140340999934, 3.949811707000066],
              [-63.916843221999954, 3.929373678000019],
              [-63.956944132999865, 3.901881816000056],
              [-63.99642492699991, 3.880797832000027],
              [-64.0376627199999, 3.882503154000077],
              [-64.0638109949999, 3.911596985000088],
              [-64.07902970399994, 3.953093160000066],
              [-64.0957728679999, 4.024380799000127],
              [-64.10814937299995, 4.05809967000009],
              [-64.12509924299985, 4.088485412000054],
              [-64.14669999199992, 4.110551249000139],
              [-64.17269323699989, 4.123392843000133],
              [-64.24059606999992, 4.142022197000088],
              [-64.36498124199994, 4.151866557000076],
              [-64.58967036999988, 4.118871155000107],
              [-64.60822220899993, 4.126493429000078],
              [-64.62106380299991, 4.146879781000024],
              [-64.6369026289999, 4.191114808000037],
              [-64.64802418899987, 4.207904544000115],
              [-64.66098384699995, 4.227469177000017],
              [-64.69987036199993, 4.264159444000086],
              [-64.74593990099993, 4.287620545000053],
              [-64.79162186699995, 4.284416606000079],
              [-64.80505773899989, 4.271885071000085],
              [-64.81291255799994, 4.252790629000089],
              [-64.81554805499985, 4.231034851000075],
              [-64.81304174899986, 4.210570984000114],
              [-64.80125952199995, 4.188530985000043],
              [-64.78366369699998, 4.177084656000119],
              [-64.76294144699995, 4.168997294000121],
              [-64.74190913899994, 4.157189230000114],
              [-64.72710384199993, 4.140781962000062],
              [-64.71953324399996, 4.123237813000088],
              [-64.70744095899988, 4.082956034000048],
              [-64.66289587499998, 3.996992290000094],
              [-64.66279252199985, 3.996992290000094],
              [-64.64289709499994, 3.972962748000057],
              [-64.59610408599994, 3.935884908000091],
              [-64.57496842499998, 3.914206645000093],
              [-64.53143103099995, 3.853512675000104],
              [-64.43453771999992, 3.77847849600002],
              [-64.39448848499995, 3.75607676200012],
              [-64.34735957899994, 3.738300069000104],
              [-64.32415685999985, 3.724114889000049],
              [-64.26555578699993, 3.652207133000019],
              [-64.2220959069999, 3.616214498000119],
              [-64.20297562699992, 3.594717102000089],
              [-64.19574092599996, 3.570067444000088],
              [-64.19563757299991, 3.532912089000092],
              [-64.19785965999992, 3.51508372000005],
              [-64.20506852299988, 3.497074483000063],
              [-64.23212113499994, 3.461133525000093],
              [-64.24214636299988, 3.442969259000066],
              [-64.24560868299989, 3.418939717000029],
              [-64.21987381999992, 3.292875062000078],
              [-64.21630814699992, 3.251430562000024],
              [-64.2253773599999, 3.165596009000097],
              [-64.22292272999994, 3.123996481000091],
              [-64.20530106699994, 3.089166565000127],
              [-64.1734683839999, 3.051907857000103],
              [-64.13750158799994, 2.987260640000045],
              [-64.10595312599995, 2.947211405000061],
              [-64.02908443299987, 2.797969869000013],
              [-64.01223791599989, 2.744019674000057],
              [-64.0008690999999, 2.725364482000074],
              [-63.997561808999905, 2.714925842000042],
              [-63.9978718669999, 2.705985819000105],
              [-64.00443477399998, 2.679527486000026],
              [-64.00769038899995, 2.622786763000107],
              [-64.01218623899987, 2.603769837000044],
              [-64.05053015199991, 2.534678447000076],
              [-64.05781652899987, 2.510442200000085],
              [-64.05662797099987, 2.48853139300013],
              [-64.0479721689999, 2.471323140000052],
              [-64.03249507699991, 2.463003235000087],
              [-64.0107909759999, 2.468170878000095],
              [-63.95182816599987, 2.461504618000092],
              [-63.83131872599992, 2.428638408000054],
              [-63.76703324399995, 2.429310201000135],
              [-63.70409134999997, 2.437578431000091],
              [-63.57381506399986, 2.434374491000113],
              [-63.51066646399991, 2.424659322000082],
              [-63.38483435099991, 2.42057688400007],
              [-63.36488724799989, 2.413083802000131],
              [-63.36111486899998, 2.400009664000081],
              [-63.371243448999934, 2.365128073000093],
              [-63.37279374199994, 2.349108378000054],
              [-63.370519979999926, 2.281153870000082],
              [-63.3726387129999, 2.266839498000095],
              [-63.38654594199997, 2.235888844000016],
              [-63.400595662999905, 2.204621074000087],
              [-63.4039029539999, 2.188498026000019],
              [-63.40219763199994, 2.17051462800012],
              [-63.41175777199993, 2.149378967000075],
              [-63.44343542599995, 2.137183329000067],
              [-63.51066646399991, 2.124600119000135],
              [-63.5205366619999, 2.124496765000117],
              [-63.5489586999999, 2.128372498000076],
              [-63.56198116099995, 2.126357117000026],
              [-63.617533324999954, 2.101164856000082],
              [-63.76264074799988, 1.985668030000099],
              [-63.78320796799994, 1.974996847000099],
              [-63.802276570999936, 1.972309672000065],
              [-63.920822305999934, 1.974325053000115],
              [-63.958339396999946, 1.97070770300013],
              [-63.99502966299991, 1.958021139000081],
              [-64.03662919099992, 1.927273661000129],
              [-64.05360489999993, 1.893709819000108],
              [-64.06029699799984, 1.807461853000078],
              [-64.07595495599989, 1.745372620000111],
              [-64.07254431199988, 1.684575297000094],
              [-64.07541235399995, 1.665429179000085],
              [-64.08086421799993, 1.647394104000085],
              [-64.09295650299993, 1.622615255000056],
              [-64.10954463699991, 1.598456523000095],
              [-64.1297242839999, 1.578070170000061],
              [-64.17708573399997, 1.55114674900004],
              [-64.23214697299994, 1.497144877000068],
              [-64.30152258399988, 1.446657003000055],
              [-64.32188309799992, 1.424436137000015],
              [-64.34074499599984, 1.384206034000073],
              [-64.35294063399996, 1.365835063000091],
              [-64.37009720899991, 1.358729554000149],
              [-64.3895792239999, 1.369297384000035],
              [-64.39477270599991, 1.392190044000046],
              [-64.39136206099991, 1.417718201000085],
              [-64.38503169799989, 1.436399232000056],
              [-64.3638185229999, 1.477352803000088],
              [-64.36459366899993, 1.497093201000055],
              [-64.38642696199986, 1.510244853000117],
              [-64.4090095629999, 1.507506002000085],
              [-64.43309077999993, 1.494044292000112],
              [-64.47505204299995, 1.463012594000091],
              [-64.52791703299991, 1.435727437000082],
              [-64.55119726599992, 1.419526876000077],
              [-64.57026586899991, 1.395497335000044],
              [-64.5911689859999, 1.350099589000109],
              [-64.60421728599994, 1.3312893680001],
              [-64.73087622099985, 1.247573548000062],
              [-64.75121089799995, 1.243336080000105],
              [-64.77131302999993, 1.246746724000033],
              [-64.82143916799996, 1.270569559000094],
              [-64.83929337599992, 1.270827942000068],
              [-64.85531306999985, 1.258683981000075],
              [-64.87771480399994, 1.234912822000112],
              [-64.89740352399988, 1.219668274000071],
              [-64.91466345299997, 1.214759013000048],
              [-64.93293107099996, 1.213002015000058],
              [-64.95605627399993, 1.206800843000082],
              [-64.96646907599995, 1.200599670000088],
              [-64.9993611249999, 1.171970927000103],
              [-65.00334020999989, 1.169387106000016],
              [-65.01321040899995, 1.165769756000117],
              [-65.01744787599992, 1.162979228000069],
              [-65.01969580199992, 1.157708232000047],
              [-65.02070349199991, 1.144013977000029],
              [-65.02248632899997, 1.139983216000118],
              [-65.05961584499997, 1.132386780000061],
              [-65.10051774199988, 1.136107483000075],
              [-65.13676875899992, 1.126909078000068],
              [-65.16017818299989, 1.080193584000071],
              [-65.16844641199992, 0.996477763000129],
              [-65.17898840299989, 0.955395],
              [-65.20304378299994, 0.923820699000089],
              [-65.22314591499989, 0.914363912000027],
              [-65.2433772389999, 0.913123678000076],
              [-65.28438248699985, 0.919376526000079],
              [-65.31027237999987, 0.918653056000082],
              [-65.32719641099987, 0.910281474000016],
              [-65.38902726199987, 0.835660706000041],
              [-65.40000850399986, 0.816540426000046],
              [-65.40962032099986, 0.792149150000114],
              [-65.41083471699989, 0.783880921000062],
              [-65.40943945399991, 0.755252177000088],
              [-65.41388362599992, 0.741609599000085],
              [-65.43274552499994, 0.720939026000067],
              [-65.45121984899987, 0.690139872000088],
              [-65.47287227499996, 0.672518209000103],
              [-65.49783199099994, 0.658720601000056],
              [-65.51969112099997, 0.650865784000118],
              [-65.54266129599992, 0.64931549100001],
              [-65.56048966599985, 0.656033427000125],
              [-65.57431311099992, 0.670244446000083],
              [-65.58521683799998, 0.691483459000068],
              [-65.58733557199986, 0.73912913],
              [-65.56328019299991, 0.777938130000052],
              [-65.53317867099994, 0.816333720000088],
              [-65.51700394699995, 0.862790833000105],
              [-65.51850256399985, 0.886510315000052],
              [-65.52511714699995, 0.908317769000078],
              [-65.53581416899996, 0.928471578000057],
              [-65.55984370999988, 0.957978821000069],
              [-65.57085078999998, 0.968572490000057],
              [-65.58294307499995, 0.97766754200012],
              [-65.59604305099992, 0.983610331000122],
              [-65.6081094969999, 0.985263977000088],
              [-65.62872839399989, 0.982008362000101],
              [-65.70104956099993, 0.984385478000135],
              [-65.72097082599996, 0.981905009000073],
              [-65.74543961599991, 0.974153545000064],
              [-65.78541133699989, 0.949142151000075],
              [-65.87196936099988, 0.908989563000063],
              [-65.89176143399996, 0.895605368000119],
              [-65.91424068199987, 0.87462473600003],
              [-65.95266210999992, 0.827960917000041],
              [-65.97408199099993, 0.806980286000041],
              [-65.99418412299991, 0.794732971000116],
              [-66.01384700599993, 0.789668681000137],
              [-66.0574619139999, 0.786981506000103],
              [-66.0791918539999, 0.777576396000057],
              [-66.11112788899987, 0.741816305000043],
              [-66.13438228399988, 0.73111928400003],
              [-66.15634476699995, 0.733031311000047],
              [-66.1730620939999, 0.743056539000079],
              [-66.18903011099994, 0.754942119000106],
              [-66.2087446699999, 0.76310699500003],
              [-66.2282783609999, 0.762796936000129],
              [-66.28507076099993, 0.745847066000039],
              [-66.34620397999993, 0.759386292000016],
              [-66.4070788169999, 0.802071025000103],
              [-66.4494534909999, 0.840208232000066],
              [-66.46769527199987, 0.856641337000042],
              [-66.51590938399994, 0.899946187000097],
              [-66.58407059799987, 0.961131083000026],
              [-66.66220536299991, 1.031411031000118],
              [-66.74039180599993, 1.101587626000082],
              [-66.80855301999986, 1.162772522000111],
              [-66.85676713099988, 1.206077372000081],
              [-66.87506058799994, 1.222510478000046],
              [-66.89588618999989, 1.265298564000076],
              [-66.90089880399995, 1.288966370000097],
              [-66.88250199499996, 1.326018372000064],
              [-66.88353552199993, 1.349944560000068],
              [-66.89118363499992, 1.374542542000057],
              [-66.90172562699988, 1.394463806000061],
              [-66.91190588499995, 1.405186666000077],
              [-66.92337805199986, 1.414359232000066],
              [-66.93273148599991, 1.424642843000072],
              [-66.93650386599992, 1.438517965000131],
              [-66.92968257699988, 1.479497375000065],
              [-66.93360998599985, 1.501692403000092],
              [-66.94317012599993, 1.523189799000136],
              [-66.96446081599993, 1.558303935000083],
              [-66.97417598499996, 1.580033875000083],
              [-66.97805171699991, 1.599722596000035],
              [-66.97805171699991, 1.644293518000055],
              [-66.9808939209999, 1.66594594300004],
              [-67.06683182799995, 1.894123230000034],
              [-67.08481522699992, 1.927997132000129],
              [-67.08729569499991, 1.93882334400007],
              [-67.09158483899995, 1.946523133000071],
              [-67.11034338399986, 1.959519755000088],
              [-67.11809484899987, 1.972387187000095],
              [-67.12553625599989, 1.980500386000088],
              [-67.13261592599991, 1.990809835000093],
              [-67.13514807199991, 2.003341370000101],
              [-67.11902502499993, 2.023986105000105],
              [-67.11463252799993, 2.03129832000009],
              [-67.1111702069999, 2.048842469000064],
              [-67.11463252799993, 2.102999370000077],
              [-67.12098872899986, 2.119096578000054],
              [-67.13602657099995, 2.127132263000135],
              [-67.15411332199994, 2.132687480000044],
              [-67.16925451699987, 2.141162415000053],
              [-67.1778328049999, 2.15449493400007],
              [-67.19426591099997, 2.197024638000116],
              [-67.20134558099988, 2.22792714400012],
              [-67.21726192199992, 2.266064351000082],
              [-67.21767533399992, 2.284512838000097],
              [-67.20630651899992, 2.297793681000101],
              [-67.1870312099999, 2.315983785000057],
              [-67.1737503659999, 2.336447652000103],
              [-67.18015824399993, 2.356498108000054],
              [-67.18573929899995, 2.365489808000092],
              [-67.18610103399993, 2.384455058000057],
              [-67.18971838399992, 2.394376933000046],
              [-67.19762487799997, 2.402025045000116],
              [-67.23136958799995, 2.42233388300005],
              [-67.26656123899991, 2.433754375000134],
              [-67.2757079669999, 2.439387106000083],
              [-67.29472489499994, 2.45835235600012],
              [-67.30568029799994, 2.466207174000061],
              [-67.31663570199993, 2.469462789000147],
              [-67.3254206949999, 2.474630432000055],
              [-67.3312601319999, 2.486671041000122],
              [-67.33580765899993, 2.500313619000039],
              [-67.34061356599992, 2.510493876000098],
              [-67.34986364799994, 2.518452047000068],
              [-67.37203283699995, 2.530440979000019],
              [-67.38154130099986, 2.537779032000103],
              [-67.38810420799993, 2.548165996000122],
              [-67.39322017499993, 2.559328105000063],
              [-67.40035152299996, 2.568216451000083],
              [-67.41290889499987, 2.571885478000084],
              [-67.41699133299988, 2.575761210000039],
              [-67.43264929299994, 2.595398255000063],
              [-67.43616328999988, 2.603563130000083],
              [-67.44034908099994, 2.610022685000047],
              [-67.46174312299985, 2.620409647000059],
              [-67.47088985299993, 2.627127584000092],
              [-67.47502396699986, 2.634672343000133],
              [-67.48101843299989, 2.65353424100006],
              [-67.48520422399992, 2.661905823000041],
              [-67.50029374199991, 2.675341695000085],
              [-67.51879390499994, 2.681026103000121],
              [-67.56370072499993, 2.681749573000033],
              [-67.57558630399987, 2.691103007000066],
              [-67.58147741699989, 2.713065491000037],
              [-67.58705847199988, 2.758127340000087],
              [-67.59429317299995, 2.776110738000071],
              [-67.6084525149999, 2.798589986000081],
              [-67.62659094299994, 2.813421122000108],
              [-67.64565954699992, 2.808666891000115],
              [-67.66560664899993, 2.801328837000113],
              [-67.69041133699997, 2.80634145100008],
              [-67.73164912999988, 2.826340231000117],
              [-67.74255285699994, 2.838587545000053],
              [-67.75102779099984, 2.842101542000094],
              [-67.77019974799995, 2.832438050000079],
              [-67.78141353399991, 2.83150787400011],
              [-67.80332434099995, 2.832593078000116],
              [-67.8233231209999, 2.827322083000084],
              [-67.8333483479999, 2.81522979800009],
              [-67.84125484199987, 2.801432190000057],
              [-67.85593094899994, 2.789753316000073],
              [-67.85525915499997, 2.858172913000061],
              [-67.83861934499993, 2.886129863000065],
              [-67.81360795099994, 2.909332581000072],
              [-67.77076818899991, 2.948968404000126],
              [-67.72798010299988, 2.988604228000014],
              [-67.68514033999995, 3.028240052000072],
              [-67.64230057799989, 3.067824198000039],
              [-67.59951249299988, 3.107460022000097],
              [-67.55662105299993, 3.147044170000058],
              [-67.51383296799989, 3.186731670000128],
              [-67.47094152899984, 3.226315816000096],
              [-67.45218298399993, 3.243679098000101],
              [-67.4402457279999, 3.249415182000064],
              [-67.41838659699997, 3.253704325000044],
              [-67.40805130999985, 3.257270000000105],
              [-67.39580399599993, 3.266571757000037],
              [-67.33529089399988, 3.342096863000052],
              [-67.30945267799987, 3.383928935000114],
              [-67.30464676899996, 3.425709331000064],
              [-67.33782303899997, 3.46009999600011],
              [-67.37539180499988, 3.474905294000038],
              [-67.39011958899988, 3.485059713000098],
              [-67.40391719599992, 3.504464213000063],
              [-67.47140661699987, 3.680060730000079],
              [-67.4998286549999, 3.717913717000059],
              [-67.53744909699992, 3.735509542000045],
              [-67.55791296499987, 3.73416595500008],
              [-67.57651647999992, 3.730703633000132],
              [-67.5948099369999, 3.730910340000094],
              [-67.61413692199994, 3.740573832000024],
              [-67.63175858599993, 3.761864523000014],
              [-67.63878658099995, 3.785170594000135],
              [-67.64441931199988, 3.834624939000079],
              [-67.65387609899994, 3.859248759000067],
              [-67.69387365799992, 3.928598531000105],
              [-67.69857621299988, 3.949966736000107],
              [-67.70162512199991, 4.011952616000059],
              [-67.7104101159999, 4.035723775000108],
              [-67.7170246989999, 4.039341125000092],
              [-67.71693248199992, 4.039878247000033],
              [-67.71407914199992, 4.056497701000055],
              [-67.72064204899988, 4.074972026000083],
              [-67.73164912999988, 4.086366679000079],
              [-67.74017574099989, 4.118716126000066],
              [-67.75893428499998, 4.138559875000055],
              [-67.77774450699991, 4.153933614000039],
              [-67.78621944199992, 4.172976380000108],
              [-67.79076696799984, 4.20426645900011],
              [-67.79944860899991, 4.235323995000044],
              [-67.80492631099989, 4.268474426000054],
              [-67.79986201999992, 4.306069031000064],
              [-67.78198197499995, 4.338883565000089],
              [-67.77939815299996, 4.350794983000114],
              [-67.78265376899992, 4.363791606000049],
              [-67.79665808199994, 4.385805766000132],
              [-67.79986201999992, 4.398905741000092],
              [-67.7983634039999, 4.406915589000064],
              [-67.79267899599995, 4.42084238700005],
              [-67.79309240699988, 4.42898142500006],
              [-67.79707149299995, 4.43492421500008],
              [-67.80942215999991, 4.439290873000061],
              [-67.81350459899991, 4.443269959000048],
              [-67.82187618099991, 4.47822906500005],
              [-67.82905920399995, 4.491432394000128],
              [-67.84766272099989, 4.504687399000133],
              [-67.84766272099989, 4.497891948000088],
              [-67.85655106699991, 4.50417063400009],
              [-67.86507767699993, 4.512077128000044],
              [-67.87179561399995, 4.521559753000119],
              [-67.87505122899995, 4.532644348000119],
              [-67.87339758399989, 4.546519471000096],
              [-67.86760982299992, 4.553159892000096],
              [-67.86063350499992, 4.557965800000105],
              [-67.85515580299995, 4.566156515000046],
              [-67.85370886299995, 4.575820007000061],
              [-67.85515580299995, 4.607730204000035],
              [-67.84879960099991, 4.634188538000032],
              [-67.84564733899995, 4.689740703000027],
              [-67.8406347259999, 4.711496480000037],
              [-67.83060949699987, 4.72754201300009],
              [-67.82285803299996, 4.743587545000139],
              [-67.82053259399993, 4.787641704000109],
              [-67.81350459899991, 4.80634857200009],
              [-67.81862056499992, 4.815676168000039],
              [-67.8171219489999, 4.821515605000116],
              [-67.81386633399993, 4.828259379000144],
              [-67.81350459899991, 4.840506694000084],
              [-67.81614009599994, 4.847302145000114],
              [-67.8252351489999, 4.864897970000101],
              [-67.82719885299994, 4.871538391000101],
              [-67.8263720299999, 4.894844462000052],
              [-67.81960241799987, 4.933317566000099],
              [-67.80668330899996, 4.97225575700007],
              [-67.80497798699992, 4.991246846000124],
              [-67.8067349859999, 5.035714417000108],
              [-67.8045645759999, 5.040856221000112],
              [-67.79986201999992, 5.045868835000078],
              [-67.79521114199994, 5.052715963000125],
              [-67.79309240699988, 5.063335470000112],
              [-67.79676143399988, 5.070156759000071],
              [-67.81474483299985, 5.090956523000031],
              [-67.82099768099994, 5.100594177000048],
              [-67.82451167799991, 5.110593567000066],
              [-67.82663041299989, 5.120386251000113],
              [-67.82756058799993, 5.130695699000029],
              [-67.82719885299994, 5.142116191000127],
              [-67.82456335499992, 5.15433766700005],
              [-67.81557165499987, 5.177902120000056],
              [-67.81350459899991, 5.186557923000095],
              [-67.81474483299985, 5.210277405000056],
              [-67.81862056499992, 5.227821554000116],
              [-67.82497676599993, 5.242781881000084],
              [-67.8340201419999, 5.25887909000005],
              [-67.8436836349999, 5.29724884000008],
              [-67.83458858299994, 5.339313456000099],
              [-67.80978389599991, 5.378820089000044],
              [-67.77257686399989, 5.409670919000121],
              [-67.76792598499992, 5.410497742000047],
              [-67.75671219899988, 5.408792420000083],
              [-67.75211299699993, 5.409670919000121],
              [-67.74668697199988, 5.414321798000088],
              [-67.73702347799994, 5.425819804000113],
              [-67.73164912999988, 5.430134786000082],
              [-67.70214188699995, 5.441400248000136],
              [-67.69371862799997, 5.447213847000029],
              [-67.67527014199996, 5.467186788000049],
              [-67.66446976799992, 5.474912415000048],
              [-67.65248083499995, 5.477961324000077],
              [-67.64700313399987, 5.483361511000055],
              [-67.6359960529999, 5.51953501400007],
              [-67.63000158699995, 5.526898906000071],
              [-67.62297359199994, 5.533410136000043],
              [-67.61703080299992, 5.541600851000069],
              [-67.61429195199989, 5.55366729800005],
              [-67.6176509199999, 5.558524882000071],
              [-67.63258540899994, 5.573071798000029],
              [-67.6359960529999, 5.577593485000051],
              [-67.63775305199997, 5.597308045000105],
              [-67.64907019099994, 5.656089986000083],
              [-67.64912186699985, 5.70195282000013],
              [-67.6411636959999, 5.744844259000089],
              [-67.62514400299995, 5.784505921000076],
              [-67.60121781499993, 5.820576070000072],
              [-67.54158321099993, 5.876722514000036],
              [-67.53238480699994, 5.892561340000029],
              [-67.48520422399992, 5.944082743000124],
              [-67.47088985299993, 5.952841899000106],
              [-67.43476802599992, 5.968163961000073],
              [-67.42246903499998, 5.978240865000103],
              [-67.41859330299991, 5.995345764000149],
              [-67.42097041899987, 6.018341776000099],
              [-67.42856685399994, 6.038469747000079],
              [-67.45430171699991, 6.056789042000048],
              [-67.49119868999995, 6.114485779000034],
              [-67.49140539599989, 6.152958883000082],
              [-67.4869612219999, 6.166782328000039],
              [-67.47616084799995, 6.178435364000094],
              [-67.45629939999992, 6.193223721000052],
              [-67.44996089699993, 6.197943218000106],
              [-67.45097237199988, 6.198035463000096],
              [-67.49047521999995, 6.201638082000017],
              [-67.5182771399999, 6.222541199000091],
              [-67.54489050299992, 6.248069356000116],
              [-67.57398433499995, 6.266233622000058],
              [-67.73097733599991, 6.302691345000071],
              [-67.80079219599986, 6.308608297000077],
              [-67.81851721199988, 6.313750102000071],
              [-67.82719885299994, 6.313414205000072],
              [-67.8391361089999, 6.307523092000082],
              [-67.8576362709999, 6.288454488000099],
              [-67.86812658799997, 6.279876201000064],
              [-67.87928869699991, 6.277938334000041],
              [-67.89282792199987, 6.278300070000043],
              [-67.90430008999988, 6.275147807000081],
              [-67.9091576749999, 6.262512919000045],
              [-67.91106970299992, 6.252306824000073],
              [-67.91628902199994, 6.242229920000042],
              [-67.92414383999997, 6.234555970000144],
              [-67.93365230399988, 6.23145538300011],
              [-67.9433157959999, 6.229698385000034],
              [-67.97799068299992, 6.217838644000011],
              [-68.01902176999997, 6.211611634000107],
              [-68.14650752799989, 6.223781433000028],
              [-68.1902774669999, 6.217838644000011],
              [-68.30417232299993, 6.176988424000101],
              [-68.34112097199997, 6.17683339400007],
              [-68.4066983649999, 6.194894308000073],
              [-68.42742061399991, 6.197323100000034],
              [-68.4490213629999, 6.194997661000102],
              [-68.52250524999997, 6.173293559000101],
              [-68.58472367399986, 6.170012106000115],
              [-68.59567907699994, 6.164921977000034],
              [-68.62198238199989, 6.14192596400008],
              [-68.6353149009999, 6.135879822000049],
              [-68.65934444199993, 6.138670349000094],
              [-68.70089229399991, 6.157971497000048],
              [-68.72161454299996, 6.162519023000073],
              [-68.74409379099987, 6.164921977000034],
              [-68.80786250799989, 6.184326477000099],
              [-68.82912735999989, 6.187788798000042],
              [-68.89292191599989, 6.184326477000099],
              [-68.91447098799995, 6.188693135000094],
              [-68.93834549999994, 6.197116394000076],
              [-68.96090226299987, 6.202361553000102],
              [-68.97857560199989, 6.197323100000034],
              [-69.0161702069999, 6.21398875000007],
              [-69.03689245599992, 6.218768819000061],
              [-69.0611287029999, 6.217838644000011],
              [-69.08019730699988, 6.209389547000114],
              [-69.10841263899994, 6.182569479000037],
              [-69.12996171099991, 6.169934591000086],
              [-69.18915706399989, 6.112625427000111],
              [-69.24610449299988, 6.08066355400004],
              [-69.26858374099987, 6.097458395000103],
              [-69.31134598799989, 6.146215108000135],
              [-69.33139644399995, 6.15636952700001],
              [-69.3581648359999, 6.151615295000113],
              [-69.40614640399986, 6.12934275300006],
              [-69.43108028199993, 6.122237244000132],
              [-69.43201856899992, 6.122237244000132],
              [-69.44363765499995, 6.122237244000132],
              [-69.4726281339999, 6.158746643000057],
              [-69.54848913699993, 6.254296366000105],
              [-69.62435013799984, 6.349768575000056],
              [-69.70021114099987, 6.445292460000104],
              [-69.77596879099994, 6.540816345000067],
              [-69.85182979399994, 6.636314393000106],
              [-69.92771663499988, 6.731838278000069],
              [-70.00357763699989, 6.827362163000117],
              [-70.0794128019999, 6.922834371000064],
              [-70.09662105399985, 6.944435120000037],
              [-70.12920304399992, 6.972547099000067],
              [-70.15778011099988, 6.97952341800007],
              [-70.19501297999989, 6.977559713000034],
              [-70.23126399799995, 6.968516337000068],
              [-70.28761714699993, 6.936942037000094],
              [-70.31906225599991, 6.938285624000059],
              [-70.42293188499991, 6.987791646000105],
              [-70.43778885999987, 6.993010966000028],
              [-70.44096695999991, 6.995749817000075],
              [-70.44701310299988, 7.004741516000109],
              [-70.45166398199993, 7.007687073000113],
              [-70.46130163699985, 7.008307190000082],
              [-70.48414261999994, 7.005309957000065],
              [-70.49481380199995, 7.005516663000037],
              [-70.51070430599987, 7.009702454000063],
              [-70.52091040099992, 7.015593567000067],
              [-70.57147578999988, 7.079362284000084],
              [-70.57860713799991, 7.085821838000044],
              [-70.59467850799987, 7.082979635000072],
              [-70.62289383999985, 7.074091288000062],
              [-70.63927526899991, 7.073471171000094],
              [-70.6731750079999, 7.081170959000076],
              [-70.68260595799995, 7.084633281000023],
              [-70.69673946199993, 7.096673889000087],
              [-70.70330236899989, 7.099929504000073],
              [-70.73296463999995, 7.099309388000108],
              [-70.79306433199989, 7.085098369000136],
              [-70.83662756399991, 7.081894430000077],
              [-70.87481644699989, 7.069182027000124],
              [-70.89553869699992, 7.06851023300004],
              [-70.90344519099997, 7.063187561000092],
              [-70.90809606999994, 7.053369039000117],
              [-70.91881892899994, 7.039468079000059],
              [-70.96132279499992, 7.009444072000093],
              [-71.01126806599987, 6.99089223200005],
              [-71.06547664399992, 6.984536031000033],
              [-71.13604081299988, 6.99213246700009],
              [-71.14539424699993, 6.986189678000073],
              [-71.15361079899995, 6.977094625000106],
              [-71.16632320199992, 6.968102926000057],
              [-71.18404821799993, 6.962573547000062],
              [-71.19381506399986, 6.965312398],
              [-71.20151485199995, 6.971875305000083],
              [-71.21324540299995, 6.977508036000117],
              [-71.2620279539999, 6.97869659500013],
              [-71.27551550399997, 6.984381002000077],
              [-71.28068314699988, 6.994612936000067],
              [-71.2814582929999, 7.007221985000086],
              [-71.28352534999993, 7.018849183000057],
              [-71.29251704899988, 7.025773824000041],
              [-71.30776159799993, 7.027375793000061],
              [-71.34936112599993, 7.019469299000107],
              [-71.36600093599995, 7.020709534000062],
              [-71.39819535399991, 7.02949452700004],
              [-71.41390498899997, 7.030993144000135],
              [-71.42945959499991, 7.027737529000063],
              [-71.45576289899995, 7.015696920000096],
              [-71.4677001549999, 7.012441304000106],
              [-71.4876472579999, 7.028926086000084],
              [-71.50991979999986, 7.034610494000034],
              [-71.52805822799988, 7.029856262000038],
              [-71.52909175699997, 7.028305969000115],
              [-71.52883337499989, 7.027065735000079],
              [-71.54862544799997, 7.028305969000115],
              [-71.54934891799988, 7.02913279300013],
              [-71.55105423999993, 7.031819967000075],
              [-71.55358638599992, 7.037297668000065],
              [-71.55844396999993, 7.041225078000124],
              [-71.56707393499988, 7.039313050000104],
              [-71.58061315999987, 7.031561584000102],
              [-71.58779618299991, 7.029287821000082],
              [-71.5947208259999, 7.030114645000111],
              [-71.60650305199991, 7.038279521000035],
              [-71.61218745999994, 7.046341044000116],
              [-71.62040401299987, 7.052128805000095],
              [-71.65430375199989, 7.053369039000117],
              [-71.66701615399995, 7.051508688000112],
              [-71.67352738499991, 7.044222310000052],
              [-71.66959997599994, 7.027737529000063],
              [-71.69802201399997, 7.034972229000033],
              [-71.72168981999991, 7.03342193600011],
              [-71.74535762499994, 7.029339498000098],
              [-71.77403804599993, 7.028926086000084],
              [-71.77150589999994, 7.011149394000057],
              [-71.77775874899993, 7.007532044000072],
              [-71.78855912299989, 7.009702454000063],
              [-71.79961787899987, 7.009185689000034],
              [-71.81212357599986, 7.001175842000052],
              [-71.82189042199991, 6.992959290000016],
              [-71.83263911999995, 6.986448059000054],
              [-71.84819372599986, 6.983864238000137],
              [-71.8810082599999, 6.986603089000084],
              [-71.9640207169999, 7.005920692000061],
              [-71.99381791199994, 7.012854716000021],
              [-71.99399817999992, 7.012952970000072],
              [-72.00529007999995, 7.019107564000109],
              [-72.02869950399992, 7.038847962000077],
              [-72.04208369999995, 7.046909485000072],
              [-72.06957556199993, 7.059208476000023],
              [-72.08099605299992, 7.066598206000023],
              [-72.09825598199993, 7.086752014000098],
              [-72.15334305799988, 7.192585348000051],
              [-72.16414343299991, 7.22080068000011],
              [-72.17148148699991, 7.249894511000122],
              [-72.17422033799994, 7.279608460000091],
              [-72.17349686699995, 7.28818674700004],
              [-72.16404007999998, 7.328856099000078],
              [-72.16631384399992, 7.334075419000101],
              [-72.17168819199986, 7.337331034000087],
              [-72.20620804899994, 7.381876119000083],
              [-72.23969437699995, 7.391281230000047],
              [-72.32180822799995, 7.390040995000106],
              [-72.37079748599987, 7.399084371000058],
              [-72.39581243299989, 7.407491518000143],
              [-72.41461909999987, 7.413812155000059],
              [-72.45130936699994, 7.440218811000136],
              [-72.4786978759999, 7.484453837000061],
              [-72.48200516799997, 7.508018290000066],
              [-72.47590734899993, 7.528637187000058],
              [-72.46738073799992, 7.548739319000035],
              [-72.46340165199993, 7.570753479000103],
              [-72.46681229699996, 7.589873759000099],
              [-72.48040319899985, 7.628941142000116],
              [-72.48334875499995, 7.649353333000064],
              [-72.47415034999995, 7.754153137000046],
              [-72.45415157099993, 7.815234681000035],
              [-72.45177445499988, 7.832804667000104],
              [-72.45446162999991, 7.87616119400009],
              [-72.45864741999992, 7.893524475000106],
              [-72.46567541499985, 7.904583232000107],
              [-72.48665604699994, 7.928716126000069],
              [-72.49120357299998, 7.937501119000061],
              [-72.48779292899985, 7.949179993000115],
              [-72.47880122899991, 7.955536194000061],
              [-72.46743241399992, 7.959670309000074],
              [-72.45673539199993, 7.964941304000106],
              [-72.44190425699989, 7.977136942000115],
              [-72.43012202999998, 7.990521139000066],
              [-72.42185380099994, 8.006230774000116],
              [-72.41709956899984, 8.025764465000037],
              [-72.40707434199993, 8.043773702000124],
              [-72.38831579699993, 8.046176657000075],
              [-72.36723181199989, 8.042688497000128],
              [-72.35007523599992, 8.042585144000014],
              [-72.33384883599993, 8.065477804000125],
              [-72.33576086499994, 8.10389923100007],
              [-72.3572582599999, 8.172137960000015],
              [-72.39053788299992, 8.234330546000095],
              [-72.39596390799991, 8.256603088000062],
              [-72.39477535099988, 8.272803650000057],
              [-72.38583532799996, 8.305514831000053],
              [-72.38397497599993, 8.321792908000063],
              [-72.3867655029999, 8.33861358700004],
              [-72.39353511599995, 8.355382589000087],
              [-72.40325028599997, 8.3704979460001],
              [-72.4150841879999, 8.382409363000136],
              [-72.4156092069999, 8.382691114000082],
              [-72.42495438699987, 8.387706197000071],
              [-72.43441117399993, 8.390186666000147],
              [-72.44453975399989, 8.394114075000118],
              [-72.45627030499989, 8.403932597000079],
              [-72.47993811099991, 8.42933156300009],
              [-72.49952347899995, 8.450441386000122],
              [-72.51921219999988, 8.471525371000055],
              [-72.53884924399992, 8.492609355000084],
              [-72.55853796399987, 8.513719178000116],
              [-72.57807165599988, 8.534854839000062],
              [-72.59776037699993, 8.55596466100009],
              [-72.61734574499985, 8.577048645000033],
              [-72.63708614099991, 8.598184306000064],
              [-72.6554312749999, 8.617898865000114],
              [-72.67543005399995, 8.651514384000052],
              [-72.68602372299992, 8.691692810000077],
              [-72.69749589099993, 8.735385234000134],
              [-72.70901973499986, 8.779051819000102],
              [-72.7204919029999, 8.822744243000074],
              [-72.73206742399992, 8.866384990000128],
              [-72.74353959199993, 8.910051575000097],
              [-72.75506343599997, 8.953743998000078],
              [-72.7665872799999, 8.997384746000122],
              [-72.77805944899993, 9.04105133100009],
              [-72.78307206299988, 9.059939067000116],
              [-72.8000219329999, 9.079446920000123],
              [-72.78560420799997, 9.102442933000077],
              [-72.79103023299984, 9.113940939000102],
              [-72.80767004399988, 9.12373362200006],
              [-72.82668697199992, 9.141691182000045],
              [-72.83412837799995, 9.13362965900005],
              [-72.84151810799995, 9.133784688000091],
              [-72.85025142399994, 9.136730245000095],
              [-72.86172359299985, 9.137040304000081],
              [-72.87402258299988, 9.133422954000096],
              [-72.88198075399995, 9.129366353000094],
              [-72.91619055199996, 9.106964621000103],
              [-72.93639603699995, 9.099187317000087],
              [-72.95530961199998, 9.103993225000096],
              [-72.97318965699995, 9.128436178000044],
              [-72.97866735899993, 9.15014028000013],
              [-72.97603186099991, 9.192127380000045],
              [-72.9800626229999, 9.216518656000076],
              [-72.98285314999987, 9.220962830000076],
              [-72.99220658399992, 9.230342102000122],
              [-72.99561722799993, 9.235354716000089],
              [-72.9954621999999, 9.239101258000105],
              [-72.9914314369999, 9.247937927000109],
              [-72.9911213789999, 9.251684468000121],
              [-73.00357539899989, 9.287909648000067],
              [-73.00972489499986, 9.295376892000093],
              [-73.03266923099991, 9.294601746000083],
              [-73.07602575699988, 9.254268290000127],
              [-73.09876338799995, 9.241581727000082],
              [-73.12434322199991, 9.23447621700005],
              [-73.14186153199995, 9.223029887000038],
              [-73.17617468299989, 9.19093882300011],
              [-73.21224483299989, 9.173446350000063],
              [-73.25384436099989, 9.1677102660001],
              [-73.36364498199993, 9.165032761000077],
              [-73.37781612199987, 9.164687195000084],
              [-73.39114864099992, 9.172774556000078],
              [-73.39083858299992, 9.194504496000093],
              [-73.37910803299994, 9.213883159000147],
              [-73.3421593839999, 9.239178772000031],
              [-73.32438269099995, 9.255921936000078],
              [-73.31177364099995, 9.276230774000098],
              [-73.27740881299991, 9.361806946000044],
              [-73.19741369699994, 9.478673197000091],
              [-73.17844844599992, 9.523037415000147],
              [-73.1637206629999, 9.536344096000064],
              [-73.12361975099992, 9.56125213700004],
              [-73.10765173399997, 9.577995301000087],
              [-73.09716141799993, 9.596366272000083],
              [-73.07189164299987, 9.664088237000072],
              [-73.01690791899992, 9.748605041000047],
              [-72.98554032399989, 9.81216705300011],
              [-72.97763382999995, 9.838056946000052],
              [-72.98161291499991, 9.856557108000075],
              [-72.99044958499994, 9.874979757000077],
              [-72.99696081499991, 9.900714620000073],
              [-72.99618566899989, 9.921281840000063],
              [-72.98786576399993, 9.960426738000095],
              [-72.98771073399988, 9.999416606000082],
              [-72.93562089099993, 10.175193991000057],
              [-72.91551875899995, 10.39427622500007],
              [-72.91624222799996, 10.413835755000093],
              [-72.91523210499986, 10.428171730000088],
              [-72.9148986409999, 10.432904358000073],
              [-72.90756058799991, 10.452463888000082],
              [-72.89200598199997, 10.472927755000043],
              [-72.87541784699997, 10.489645081000091],
              [-72.86141353399995, 10.508093567000103],
              [-72.84301672399997, 10.560596822000065],
              [-72.78141841699994, 10.631316020000085],
              [-72.75439164199989, 10.674853414000012],
              [-72.70612585499987, 10.81125335700007],
              [-72.6829748129999, 10.855617575000025],
              [-72.65672318499995, 10.885202332000063],
              [-72.6131082769999, 10.915252177000127],
              [-72.59450476099994, 10.932977193000042],
              [-72.57646968599994, 10.957368469000073],
              [-72.5420531829999, 11.041084290000114],
              [-72.53393998199991, 11.052375590000082],
              [-72.51502640899986, 11.072477722000144],
              [-72.50748164899991, 11.082993876000103],
              [-72.50469112199994, 11.09270904500005],
              [-72.5038126229999, 11.111777649000118],
              [-72.49931677299989, 11.12079518700007],
              [-72.48148840299984, 11.132525737000066],
              [-72.45999100799989, 11.135807190000051],
              [-72.41699621599992, 11.137615865000043],
              [-72.36144405099992, 11.158002218000078],
              [-72.34134191899994, 11.162110494000103],
              [-72.32185990499997, 11.160095113000054],
              [-72.28465287299986, 11.150457458000034],
              [-72.26708288599988, 11.154901632000048],
              [-72.25659256999992, 11.16779490200014],
              [-72.22677526899994, 11.222571920000036],
              [-72.19690629099992, 11.27740061400003],
              [-72.16708898999991, 11.332203471000113],
              [-72.13727168799991, 11.386980489000095],
              [-72.1074543869999, 11.441757507000077],
              [-72.0776370849999, 11.496534526000062],
              [-72.0478197839999, 11.551311544000058],
              [-72.01800248299992, 11.606114400000138],
              [-72.00792557899987, 11.624614563000065],
              [-71.99061397399987, 11.649057516000099],
              [-71.97108028199995, 11.661924948000106],
              [-71.94524206599993, 11.668539530000103],
              [-71.88664099199991, 11.683525696000075],
              [-71.8280399169999, 11.698563538000059],
              [-71.76943884299988, 11.713549703000126],
              [-71.71088944499988, 11.728535868000094],
              [-71.65228837099994, 11.743573710000092],
              [-71.59363562099992, 11.758508199000048],
              [-71.5350862229999, 11.773546041000131],
              [-71.47648514899987, 11.788583883000115],
              [-71.44945837399993, 11.795456848000086],
              [-71.40966752199992, 11.812303365000062],
              [-71.37545772399992, 11.841087138000077],
              [-71.3576293539999, 11.850802307000023],
              [-71.32750653346986, 11.849997690578633],
              [-71.34064693899995, 11.825506903000075],
              [-71.34386145699995, 11.807521877000056],
              [-71.33604895699995, 11.789252020000049],
              [-71.36359615799995, 11.78620026200008],
              [-71.37144934799994, 11.78310781500005],
              [-71.37547766799992, 11.775580145000049],
              [-71.37584387899994, 11.76634349200009],
              [-71.37816321499992, 11.75844961100006],
              [-71.38784745999993, 11.755113023000092],
              [-71.40998287699995, 11.751166083000044],
              [-71.46711178299995, 11.721625067000048],
              [-71.50706946499992, 11.709784247000073],
              [-71.67442786399994, 11.684719143000052],
              [-71.86180579299992, 11.628159898000092],
              [-71.90070553299995, 11.62132396000004],
              [-71.92516028599994, 11.612779039000088],
              [-71.94758053299995, 11.60179271000004],
              [-71.96051998599995, 11.59125397300005],
              [-71.97130286399994, 11.554836330000057],
              [-71.97012285099993, 11.511379299000055],
              [-71.93932044199994, 11.38076406500005],
              [-71.85692298099991, 11.216986395000049],
              [-71.79600989499994, 11.131984768000052],
              [-71.76976477799991, 11.106350002000056],
              [-71.65290279899995, 11.041205145000049],
              [-71.63780676999994, 11.029038804000038],
              [-71.62645423099991, 11.014960028000075],
              [-71.62466386599993, 11.00096263200004],
              [-71.63247636599993, 10.998236395000049],
              [-71.67931067599994, 10.987982489000046],
              [-71.67528235599991, 11.003607489000046],
              [-71.68224036399994, 11.01666901200008],
              [-71.69713294199994, 11.025580145000049],
              [-71.72427324099993, 11.030829169000071],
              [-71.73477128799993, 11.034369208000044],
              [-71.7442113919999, 11.035956122000073],
              [-71.74819902299993, 11.032375393000052],
              [-71.75080318899995, 11.027777411000045],
              [-71.75670325399994, 11.022609768000052],
              [-71.76866614499994, 11.015285549000055],
              [-71.75987708199995, 11.00381094000005],
              [-71.72370357999995, 10.970892645000049],
              [-71.71568762899994, 10.95774974200009],
              [-71.71605383999992, 10.94562409100007],
              [-71.71947180899991, 10.933172919000071],
              [-71.72032630099994, 10.919094143000052],
              [-71.71043860599991, 10.878607489000046],
              [-71.69359290299991, 10.837144273000092],
              [-71.67406165299991, 10.802394924000055],
              [-71.64997311099995, 10.770819403000075],
              [-71.61831620999993, 10.743475653000075],
              [-71.57628333199995, 10.721096096000053],
              [-71.58649654899995, 10.698879299000055],
              [-71.59496008999992, 10.65961334800005],
              [-71.61042232999995, 10.637884833000044],
              [-71.60533606699994, 10.630072333000044],
              [-71.60366777299993, 10.61977773600006],
              [-71.60537675699993, 10.60838450700004],
              [-71.61042232999995, 10.59756094000005],
              [-71.60558020699995, 10.581854559000078],
              [-71.61343339799993, 10.561224677000041],
              [-71.62498938699991, 10.53896719000005],
              [-71.6309301419999, 10.518459377000056],
              [-71.62954667899993, 10.46352773600006],
              [-71.62800045499995, 10.457709052000041],
              [-71.62954667899993, 10.454006252000056],
              [-71.63776607999995, 10.446112372000073],
              [-71.64468339799993, 10.442328192000048],
              [-71.67186438699991, 10.43305084800005],
              [-71.69416256399995, 10.409369208000044],
              [-71.69668535099993, 10.405178127000056],
              [-71.71300208199995, 10.401068427000041],
              [-71.72972571499992, 10.391506252000056],
              [-71.75446529899995, 10.37099844000005],
              [-71.77904212099992, 10.341742255000042],
              [-71.83698482999995, 10.234442450000074],
              [-71.89159094999991, 10.162176825000074],
              [-71.89769446499992, 10.139227606000077],
              [-71.91291256399995, 10.128973700000074],
              [-71.95303300699993, 10.117743231000077],
              [-71.96906490799995, 10.10569896000004],
              [-71.9824926419999, 10.088283596000053],
              [-71.99181067599994, 10.06745026200008],
              [-72.00047766799992, 10.02529531500005],
              [-72.02354895699995, 9.98541901200008],
              [-72.04369055899991, 9.92959219000005],
              [-72.1094457669999, 9.856146552000041],
              [-72.12437903599994, 9.82607656500005],
              [-72.12132727799991, 9.812201239000046],
              [-72.10244706899994, 9.772772528000075],
              [-72.09024003799993, 9.75462474200009],
              [-72.02196204299992, 9.685736395000049],
              [-71.99893144399994, 9.654730536000045],
              [-71.94684811099995, 9.541164455000057],
              [-71.96483313699991, 9.55109284100007],
              [-71.97321529899995, 9.569728908000059],
              [-71.97866777299993, 9.59125397300005],
              [-71.98786373599995, 9.610052802000041],
              [-71.99522864499994, 9.60382721600007],
              [-71.99205481699994, 9.59983958500004],
              [-71.99038652299993, 9.59674713700008],
              [-71.98786373599995, 9.589544989000046],
              [-71.99697831899994, 9.587713934000078],
              [-72.00096594999991, 9.585150458000044],
              [-72.00352942599994, 9.581284898000092],
              [-72.00829016799992, 9.575873114000046],
              [-71.99351966099994, 9.569240627000056],
              [-71.97789466099994, 9.555894273000092],
              [-71.96548417899993, 9.53815338700008],
              [-71.96051998599995, 9.51788971600007],
              [-71.96751868399991, 9.498236395000049],
              [-71.9837133449999, 9.497463283000059],
              [-72.0020238919999, 9.507757880000042],
              [-72.01512610599991, 9.521307684000078],
              [-72.01927649599992, 9.502875067000048],
              [-72.01097571499992, 9.483343817000048],
              [-71.99522864499994, 9.45921458500004],
              [-71.97984778599994, 9.470119533000059],
              [-71.95726477799991, 9.490301825000074],
              [-71.93639075399994, 9.500189520000049],
              [-71.92638098899994, 9.480292059000078],
              [-71.91893469999991, 9.480292059000078],
              [-71.91893469999991, 9.500189520000049],
              [-71.90855872299994, 9.493353583000044],
              [-71.88166256399995, 9.462958075000074],
              [-71.87140865799995, 9.456203518000052],
              [-71.86172441299993, 9.453599351000037],
              [-71.85277258999992, 9.44985586100006],
              [-71.84439042899993, 9.43935781500005],
              [-71.87474524599992, 9.445257880000042],
              [-71.90074622299994, 9.43455638200004],
              [-71.91380774599992, 9.412583726000037],
              [-71.90526282499991, 9.384711005000042],
              [-71.89476477799991, 9.418850002000056],
              [-71.89159094999991, 9.425726630000042],
              [-71.83356686099995, 9.425726630000042],
              [-71.80825761599993, 9.41046784100007],
              [-71.78473873599995, 9.381781317000048],
              [-71.76085364499994, 9.364732164000088],
              [-71.73452714799993, 9.384711005000042],
              [-71.73814856699994, 9.368109442000048],
              [-71.74079342399995, 9.36359284100007],
              [-71.73037675699993, 9.355414130000042],
              [-71.72801673099991, 9.348089911000045],
              [-71.73395748599995, 9.343451239000046],
              [-71.74819902299993, 9.343166408000059],
              [-71.74819902299993, 9.336330471000053],
              [-71.73582923099991, 9.32485586100006],
              [-71.73448645699995, 9.30760325700004],
              [-71.73997962099992, 9.28937409100007],
              [-71.74819902299993, 9.27484772300005],
              [-71.75820878799993, 9.283392645000049],
              [-71.77806555899991, 9.268866278000075],
              [-71.81651770699995, 9.233303127000056],
              [-71.80703691299993, 9.225490627000056],
              [-71.79613196499992, 9.233872789000088],
              [-71.78506425699993, 9.240301825000074],
              [-71.77550208199995, 9.22646719000005],
              [-71.76773027299993, 9.230129299000055],
              [-71.76211503799993, 9.23383209800005],
              [-71.75792395699995, 9.238959052000041],
              [-71.75446529899995, 9.246975002000056],
              [-71.74469967399995, 9.237616278000075],
              [-71.74787350199995, 9.22719961100006],
              [-71.74937903599994, 9.216294664000088],
              [-71.73452714799993, 9.206000067000048],
              [-71.7532445949999, 9.204250393000052],
              [-71.75182044199994, 9.190741278000075],
              [-71.73452714799993, 9.16502513200004],
              [-71.75816809799994, 9.13898346600007],
              [-71.76187089799993, 9.13084544500009],
              [-71.75885982999995, 9.120062567000048],
              [-71.75153561099995, 9.115708726000037],
              [-71.74413001199991, 9.112982489000046],
              [-71.74079342399995, 9.106919664000088],
              [-71.73473059799994, 9.106350002000056],
              [-71.72252356699994, 9.10024648600006],
              [-71.71349036399994, 9.093247789000088],
              [-71.7168676419999, 9.089911200000074],
              [-71.71837317599994, 9.08584219000005],
              [-71.70856686099995, 9.076727606000077],
              [-71.68614661399994, 9.06195709800005],
              [-71.64590410099993, 9.049627997000073],
              [-71.60220292899993, 9.042303778000075],
              [-71.55768795499995, 9.041571356000077],
              [-71.51480058499993, 9.048976955000057],
              [-71.37140865799995, 9.093329169000071],
              [-71.27354895699995, 9.13507721600007],
              [-71.24103756399995, 9.155747789000088],
              [-71.22061113199993, 9.179266669000071],
              [-71.20641028599994, 9.232163804000038],
              [-71.18748938699991, 9.246486721000053],
              [-71.16185462099992, 9.27875397300005],
              [-71.15172278599994, 9.28851959800005],
              [-71.14305579299992, 9.29124583500004],
              [-71.11701412699995, 9.294745184000078],
              [-71.10973059799994, 9.29828522300005],
              [-71.10301673099991, 9.302883205000057],
              [-71.09569251199991, 9.306708075000074],
              [-71.08657792899993, 9.308417059000078],
              [-71.07282467399995, 9.31354401200008],
              [-71.06240800699993, 9.326646226000037],
              [-71.05650794199994, 9.34446849200009],
              [-71.05614173099991, 9.36359284100007],
              [-71.07335364499994, 9.41901276200008],
              [-71.07925370999993, 9.502508856000077],
              [-71.08283443899995, 9.521307684000078],
              [-71.08824622299994, 9.53416575700004],
              [-71.09080969999991, 9.544094143000052],
              [-71.09024003799993, 9.55540599200009],
              [-71.08568274599992, 9.563421942000048],
              [-71.06607011599993, 9.589544989000046],
              [-71.06627356699994, 9.601996161000045],
              [-71.04869544199994, 9.672756252000056],
              [-71.04869544199994, 9.719916083000044],
              [-71.04214433499993, 9.726507880000042],
              [-71.03758704299992, 9.732814846000053],
              [-71.03506425699993, 9.740383205000057],
              [-71.03563391799992, 9.744086005000042],
              [-71.04185950399994, 9.760891018000052],
              [-71.05455481699994, 9.776516018000052],
              [-71.07184811099995, 9.792792059000078],
              [-71.08617102799991, 9.811997789000088],
              [-71.09024003799993, 9.836615302000041],
              [-71.07974199099993, 9.83812083500004],
              [-71.07282467399995, 9.841620184000078],
              [-71.06981360599991, 9.85024648600006],
              [-71.07241777299993, 9.857855536000045],
              [-71.09024003799993, 9.87759023600006],
              [-71.10846920499995, 9.90534088700008],
              [-71.16246497299994, 9.97093333500004],
              [-71.18390865799995, 9.985296942000048],
              [-71.20693925699993, 9.980617580000057],
              [-71.22850501199991, 10.070054429000038],
              [-71.24567623599995, 10.114569403000075],
              [-71.26781165299991, 10.151922919000071],
              [-71.3059789699999, 10.19049713700008],
              [-71.32843990799995, 10.206732489000046],
              [-71.36388098899994, 10.219956773000092],
              [-71.37319902299993, 10.23623281500005],
              [-71.38442949099993, 10.27537669500009],
              [-71.39317786399994, 10.288641669000071],
              [-71.41441809799994, 10.31346263200004],
              [-71.42259680899991, 10.343166408000059],
              [-71.43219967399995, 10.359523830000057],
              [-71.45335852799991, 10.38467031500005],
              [-71.46450761599993, 10.39524974200009],
              [-71.46934973899994, 10.40180084800005],
              [-71.47386633999992, 10.41201406500005],
              [-71.47508704299992, 10.421576239000046],
              [-71.46886145699995, 10.43748607000009],
              [-71.46275794199994, 10.489081122000073],
              [-71.46629798099991, 10.502142645000049],
              [-71.48131262899994, 10.515041408000059],
              [-71.52647864499994, 10.544745184000078],
              [-71.54157467399995, 10.564886786000045],
              [-71.54214433499993, 10.59007396000004],
              [-71.53746497299994, 10.59796784100007],
              [-71.50283769399994, 10.62693919500009],
              [-71.50011145699995, 10.62799713700008],
              [-71.50475012899994, 10.630601304000038],
              [-71.53286699099993, 10.67649974200009],
              [-71.53530839799993, 10.686346747000073],
              [-71.53384355399993, 10.699774481000077],
              [-71.52798417899993, 10.725897528000075],
              [-71.52790279899995, 10.74095286700009],
              [-71.53136145699995, 10.75267161700009],
              [-71.53795325399994, 10.76048411700009],
              [-71.55577551999994, 10.77570221600007],
              [-71.5664770169999, 10.792222398000092],
              [-71.57306881399995, 10.799302476000037],
              [-71.58311926999994, 10.80296458500004],
              [-71.58311926999994, 10.80923086100006],
              [-71.50999915299991, 10.812648830000057],
              [-71.47813880099994, 10.809393622000073],
              [-71.44591223899994, 10.796210028000075],
              [-71.43529212099992, 10.818915106000077],
              [-71.43984941299993, 10.83885325700004],
              [-71.44937089799993, 10.856390692000048],
              [-71.45335852799991, 10.871893622000073],
              [-71.44640051999994, 10.886908270000049],
              [-71.42202714799993, 10.902777411000045],
              [-71.41246497299994, 10.919094143000052],
              [-71.43822180899991, 10.91868724200009],
              [-71.44766191299993, 10.920396226000037],
              [-71.45958411399994, 10.925930080000057],
              [-71.46959387899994, 10.934027411000045],
              [-71.48859615799995, 10.953802802000041],
              [-71.50112870999993, 10.96002838700008],
              [-71.4583227199999, 10.97492096600007],
              [-71.41844641799992, 10.980047919000071],
              [-71.33604895699995, 10.980536200000074],
              [-71.29393469999991, 10.98663971600007],
              [-71.2820124989999, 10.991441148000092],
              [-71.17593339799993, 11.034125067000048],
              [-71.13125566299993, 11.06000397300005],
              [-71.12222245999993, 11.06834544500009],
              [-71.06236731699994, 11.090399481000077],
              [-70.86969967399995, 11.19627513200004],
              [-70.71320553299995, 11.23704661700009],
              [-70.6856176419999, 11.24803294500009],
              [-70.6641332669999, 11.238714911000045],
              [-70.62975012899994, 11.239203192000048],
              [-70.51390540299991, 11.253159898000092],
              [-70.49608313699991, 11.263861395000049],
              [-70.48013261599993, 11.289007880000042],
              [-70.48981686099995, 11.285305080000057],
              [-70.49787350199995, 11.27928294500009],
              [-70.50389563699991, 11.271307684000078],
              [-70.50743567599994, 11.261664130000042],
              [-70.51060950399994, 11.286363023000092],
              [-70.48643958199995, 11.295111395000049],
              [-70.43394834899993, 11.287597019000088],
              [-70.40098671999993, 11.296984251000083],
              [-70.32433020699995, 11.332831122000073],
              [-70.28795325399994, 11.357082424000055],
              [-70.26861178899992, 11.356336830000089],
              [-70.2310674979999, 11.351587093000091],
              [-70.18000240799995, 11.376369533000059],
              [-70.15900631399995, 11.40143463700008],
              [-70.14517167899993, 11.428941148000092],
              [-70.14435787699995, 11.44725169500009],
              [-70.14600377799991, 11.454411962000052],
              [-70.1532101169999, 11.460920558000055],
              [-70.1644029489999, 11.462932823000074],
              [-70.15446600299992, 11.469974238000077],
              [-70.14129050999992, 11.46859478500005],
              [-70.12683243499993, 11.462037248000058],
              [-70.11900805199991, 11.449709059000043],
              [-70.10919754199995, 11.438659169000061],
              [-70.0993738649999, 11.429547051000043],
              [-70.08812415299991, 11.434027411000045],
              [-70.08291581899994, 11.443833726000037],
              [-70.07900956899994, 11.45734284100007],
              [-70.06969153599994, 11.45693594000005],
              [-70.05846106699994, 11.450832424000055],
              [-70.04873613199993, 11.44725169500009],
              [-70.04116777299993, 11.44086334800005],
              [-70.03652910099993, 11.440904039000088],
              [-70.0344945949999, 11.450384833000044],
              [-70.03453528599994, 11.459906317000048],
              [-70.03587805899991, 11.466538804000038],
              [-70.04010982999995, 11.47093333500004],
              [-70.04873613199993, 11.473944403000075],
              [-70.04759680899991, 11.47850169500009],
              [-70.04637610599991, 11.48151276200008],
              [-70.04133053299995, 11.488226630000042],
              [-70.05587947899994, 11.49320190900005],
              [-70.05390927299993, 11.506482221000056],
              [-70.09679114499994, 11.520697333000044],
              [-70.11986243399991, 11.522406317000048],
              [-70.12315833199995, 11.525213934000078],
              [-70.11856035099993, 11.530951239000046],
              [-70.11127350599992, 11.530708229000084],
              [-70.09630131999995, 11.53106622000007],
              [-70.1046657139999, 11.538916444000051],
              [-70.11617193299992, 11.54327876800005],
              [-70.12955532099994, 11.54731114000009],
              [-70.1415792709999, 11.553962930000068],
              [-70.16159753499994, 11.568545162000078],
              [-70.12276539399994, 11.559097438000038],
              [-70.0952731619999, 11.543896980000056],
              [-70.06823908899992, 11.529960113000072],
              [-70.0505253959999, 11.521128887000089],
              [-70.04212047399994, 11.518779432000088],
              [-70.02437386899993, 11.51407335500005],
              [-70.00780188699991, 11.515570380000042],
              [-69.99032078199991, 11.510885619000078],
              [-69.97562495199992, 11.502896389000057],
              [-69.95677770599991, 11.510652434000065],
              [-69.94597799799993, 11.519773538000038],
              [-69.92589882399994, 11.513060548000055],
              [-69.92064516799991, 11.497254248000047],
              [-69.91262248299995, 11.493254027000091],
              [-69.89917497699992, 11.495788909000055],
              [-69.8926173939999, 11.478645437000068],
              [-69.8765813519999, 11.469328099000052],
              [-69.85652453499995, 11.458665455000073],
              [-69.84460451299992, 11.436231517000067],
              [-69.81407630099994, 11.425604559000078],
              [-69.79491126199991, 11.436712958000044],
              [-69.78921464799993, 11.450995184000078],
              [-69.75999915299991, 11.468085028000075],
              [-69.74714107999995, 11.48078034100007],
              [-69.74364173099991, 11.50336334800005],
              [-69.76475989499994, 11.537665106000077],
              [-69.76081295499995, 11.557114976000037],
              [-69.76915442599994, 11.56858958500004],
              [-69.78514563699991, 11.615668036000045],
              [-69.79137122299994, 11.645331122000073],
              [-69.81602942599994, 11.69367096600007],
              [-69.82217363199993, 11.69367096600007],
              [-69.82502193899995, 11.67523834800005],
              [-69.83299719999991, 11.677232164000088],
              [-69.84235592399995, 11.687567450000074],
              [-69.84951738199993, 11.69367096600007],
              [-69.8626195949999, 11.690375067000048],
              [-69.87100175699993, 11.683335679000038],
              [-69.87637285099993, 11.67641836100006],
              [-69.88023841099994, 11.673244533000059],
              [-69.92772376199991, 11.65843333500004],
              [-69.95006262899994, 11.656683661000045],
              [-69.94513912699995, 11.673244533000059],
              [-69.98550370999993, 11.65525950700004],
              [-69.99693762899994, 11.652736721000053],
              [-70.02676347599993, 11.65180084800005],
              [-70.04149329299992, 11.648627020000049],
              [-70.05186926999994, 11.642157294000071],
              [-70.07380123599995, 11.63190338700008],
              [-70.13833574099993, 11.62596263200004],
              [-70.18651282499991, 11.602687893000052],
              [-70.21178137899994, 11.609076239000046],
              [-70.22988847599993, 11.627875067000048],
              [-70.23314368399991, 11.652736721000053],
              [-70.22935950399994, 11.659491278000075],
              [-70.21735592399995, 11.672674872000073],
              [-70.21324622299994, 11.680080471000053],
              [-70.21239173099991, 11.687201239000046],
              [-70.21442623599995, 11.691839911000045],
              [-70.21735592399995, 11.695868231000077],
              [-70.21947180899991, 11.701117255000042],
              [-70.21947180899991, 11.727850653000075],
              [-70.22142493399991, 11.72947825700004],
              [-70.2305395169999, 11.742010809000078],
              [-70.23314368399991, 11.74835846600007],
              [-70.22716223899994, 11.744818427000041],
              [-70.21174068899995, 11.738023179000038],
              [-70.20579993399991, 11.73468659100007],
              [-70.20592200399994, 11.762518622000073],
              [-70.20799719999991, 11.774318752000056],
              [-70.21324622299994, 11.78310781500005],
              [-70.2239477199999, 11.788397528000075],
              [-70.22899329299992, 11.781195380000042],
              [-70.23302161399994, 11.769720770000049],
              [-70.24058997299994, 11.76194896000004],
              [-70.24535071499992, 11.779364325000074],
              [-70.26724199099993, 11.816595770000049],
              [-70.27212480399993, 11.822821356000077],
              [-70.27651933499993, 11.825669664000088],
              [-70.27969316299993, 11.830145575000074],
              [-70.28160559799994, 11.851141669000071],
              [-70.28453528599994, 11.85732656500005],
              [-70.29100501199991, 11.85960521000004],
              [-70.30199133999992, 11.85814036700009],
              [-70.29678300699993, 11.871893622000073],
              [-70.28897050699993, 11.908677476000037],
              [-70.28774980399993, 11.923325914000088],
              [-70.28355872299994, 11.939642645000049],
              [-70.26520748599995, 11.971625067000048],
              [-70.2610570949999, 11.99164459800005],
              [-70.25462805899991, 12.00682200700004],
              [-70.22378495999993, 12.041815497000073],
              [-70.21324622299994, 12.056789455000057],
              [-70.21003170499995, 12.073553778000075],
              [-70.21129309799994, 12.102728583000044],
              [-70.20579993399991, 12.112005927000041],
              [-70.16209876199991, 12.113104559000078],
              [-70.14427649599992, 12.117987372000073],
              [-70.1270238919999, 12.12881094000005],
              [-70.06456458199995, 12.181463934000078],
              [-70.04133053299995, 12.19399648600006],
              [-70.01773027299993, 12.198919989000046],
              [-70.00348873599995, 12.193508205000057],
              [-69.9903051419999, 12.184800523000092],
              [-69.94420325399994, 12.174505927000041],
              [-69.92536373599995, 12.15961334800005],
              [-69.83531653599994, 12.015204169000071],
              [-69.82217363199993, 11.97483958500004],
              [-69.81676184799994, 11.932440497000073],
              [-69.81590735599991, 11.846380927000041],
              [-69.80858313699991, 11.803615627000056],
              [-69.74714107999995, 11.63226959800005],
              [-69.70030676999994, 11.540187893000052],
              [-69.66584225199995, 11.497748114000046],
              [-69.62360592399995, 11.46775950700004],
              [-69.58869381399995, 11.463039455000057],
              [-69.56338456899994, 11.47842031500005],
              [-69.53726152299993, 11.49868398600006],
              [-69.5000707669999, 11.508734442000048],
              [-69.41551673099991, 11.495591539000088],
              [-69.37669837099992, 11.49404531500005],
              [-69.33560136599993, 11.508734442000048],
              [-69.30760657499991, 11.526556708000044],
              [-69.29092363199993, 11.533351955000057],
              [-69.27041581899994, 11.536037502000056],
              [-69.26024329299992, 11.532863674000055],
              [-69.23985755099994, 11.518744208000044],
              [-69.22948157499991, 11.515570380000042],
              [-69.19554602799991, 11.517075914000088],
              [-69.18541419199994, 11.515570380000042],
              [-69.12100175699993, 11.489894924000055],
              [-69.10903886599993, 11.491359768000052],
              [-69.10342363199993, 11.480861721000053],
              [-69.09015865799995, 11.469305731000077],
              [-69.07445227799991, 11.459377346000053],
              [-69.06187903599994, 11.453517971000053],
              [-69.01992753799993, 11.446234442000048],
              [-68.86318925699993, 11.452866929000038],
              [-68.84439042899993, 11.447414455000057],
              [-68.82892818899995, 11.435695705000057],
              [-68.79596920499995, 11.40062083500004],
              [-68.77623450399994, 11.386216539000088],
              [-68.75438391799992, 11.37409088700008],
              [-68.72028561099995, 11.361761786000045],
              [-68.70433508999992, 11.35805898600006],
              [-68.69041907499991, 11.357001044000071],
              [-68.68447831899994, 11.36163971600007],
              [-68.67918860599991, 11.358303127000056],
              [-68.65566972599993, 11.34788646000004],
              [-68.65038001199991, 11.340521552000041],
              [-68.6399633449999, 11.322211005000042],
              [-68.61522376199991, 11.303412177000041],
              [-68.54051673099991, 11.265041408000059],
              [-68.51797441299993, 11.249335028000075],
              [-68.50007076699995, 11.23240794500009],
              [-68.49274654899995, 11.217678127000056],
              [-68.48350989499994, 11.20693594000005],
              [-68.41759192599994, 11.17914459800005],
              [-68.41266842399995, 11.188869533000059],
              [-68.41104081899994, 11.19334544500009],
              [-68.41075598899994, 11.20026276200008],
              [-68.40330969999991, 11.20026276200008],
              [-68.40038001199991, 11.194159247000073],
              [-68.39028886599993, 11.17914459800005],
              [-68.39028886599993, 11.17291901200008],
              [-68.39793860599991, 11.153998114000046],
              [-68.38866126199991, 11.128241278000075],
              [-68.34968014199995, 11.071844794000071],
              [-68.28823808499993, 10.953314520000049],
              [-68.27843176999994, 10.925482489000046],
              [-68.28726152299993, 10.91282786700009],
              [-68.29478919199994, 10.917141018000052],
              [-68.30504309799994, 10.926703192000048],
              [-68.31834876199991, 10.935980536000045],
              [-68.33507239499994, 10.939601955000057],
              [-68.34776770699995, 10.93695709800005],
              [-68.35952714799993, 10.931708075000074],
              [-68.36953691299993, 10.92523834800005],
              [-68.37661699099993, 10.919094143000052],
              [-68.34341386599993, 10.91038646000004],
              [-68.26268469999991, 10.903143622000073],
              [-68.23884029899995, 10.884955145000049],
              [-68.24982662699995, 10.865912177000041],
              [-68.26618404899995, 10.858099677000041],
              [-68.31143144399994, 10.857611395000049],
              [-68.32656816299993, 10.849269924000055],
              [-68.33193925699993, 10.829575914000088],
              [-68.33145097599993, 10.806830145000049],
              [-68.31834876199991, 10.74518463700008],
              [-68.28709876199991, 10.657904364000046],
              [-68.27375240799995, 10.63422272300005],
              [-68.2517390619999, 10.595119533000059],
              [-68.24233964799993, 10.57843659100007],
              [-68.20958411399994, 10.537258205000057],
              [-68.17113196499992, 10.503729559000078],
              [-68.12954667899993, 10.48773834800005],
              [-68.00645911399994, 10.488470770000049],
              [-67.98875891799992, 10.48468659100007],
              [-67.96515865799995, 10.47406647300005],
              [-67.94123287699995, 10.466457424000055],
              [-67.92442786399994, 10.46971263200004],
              [-67.90998287699995, 10.47687409100007],
              [-67.89281165299991, 10.480861721000053],
              [-67.88060462099992, 10.479966539000088],
              [-67.87328040299991, 10.47646719000005],
              [-67.86986243399991, 10.469183661000045],
              [-67.86921139199995, 10.46124909100007],
              [-67.86888587099992, 10.456976630000042],
              [-67.86538652299993, 10.45221588700008],
              [-67.85781816299993, 10.45929596600007],
              [-67.85069739499994, 10.46946849200009],
              [-67.84837805899991, 10.47406647300005],
              [-67.81777910099993, 10.487616278000075],
              [-67.77757727799991, 10.49599844000005],
              [-67.64500891799992, 10.506008205000057],
              [-67.56017005099994, 10.528265692000048],
              [-67.47817949099993, 10.534084377000056],
              [-67.39175370999993, 10.543076890000066],
              [-67.32607988199993, 10.549953518000052],
              [-67.24339758999992, 10.546616929000038],
              [-67.17003333199995, 10.555975653000075],
              [-67.11302649599992, 10.585516669000071],
              [-67.07408606699994, 10.593410549000055],
              [-67.03465735599991, 10.607977606000077],
              [-67.01235917899993, 10.61123281500005],
              [-66.88585364499994, 10.609523830000057],
              [-66.77660071499992, 10.61904531500005],
              [-66.54157467399995, 10.63271719000005],
              [-66.42784583199995, 10.63084544500009],
              [-66.41649329299992, 10.62799713700008],
              [-66.40485592399995, 10.620835679000038],
              [-66.35045325399994, 10.611151434000078],
              [-66.33397376199991, 10.61123281500005],
              [-66.3216039699999, 10.620428778000075],
              [-66.30947831899994, 10.634182033000059],
              [-66.29515540299991, 10.64671458500004],
              [-66.27586829299992, 10.652167059000078],
              [-66.25177975199995, 10.648586330000057],
              [-66.19058183499993, 10.61741771000004],
              [-66.12458248599995, 10.601955471000053],
              [-66.10440019399994, 10.584418036000045],
              [-66.05797278599994, 10.579046942000048],
              [-66.04653886599993, 10.57648346600007],
              [-66.05382239499994, 10.56240469000005],
              [-66.07616126199991, 10.548895575000074],
              [-66.10240637899994, 10.540757554000038],
              [-66.12169348899994, 10.54295482000009],
              [-66.12083899599992, 10.531317450000074],
              [-66.12222245999993, 10.507025458000044],
              [-66.11827551999994, 10.49795156500005],
              [-66.08751380099994, 10.466620184000078],
              [-66.01183020699995, 10.408596096000053],
              [-66.00426184799994, 10.398993231000077],
              [-65.97093665299991, 10.378851630000042],
              [-65.95287024599992, 10.351629950000074],
              [-65.88206946499992, 10.30955638200004],
              [-65.89635169199994, 10.309068101000037],
              [-65.91014563699991, 10.311672268000052],
              [-65.92186438699991, 10.316555080000057],
              [-65.92992102799991, 10.323187567000048],
              [-65.93761145699995, 10.316961981000077],
              [-65.94416256399995, 10.30955638200004],
              [-65.92300370999993, 10.28221263200004],
              [-65.89696204299992, 10.287990627000056],
              [-65.87132727799991, 10.272935289000088],
              [-65.82750403599994, 10.234442450000074],
              [-65.80211341099994, 10.22565338700008],
              [-65.77501380099994, 10.221502997000073],
              [-65.71764075399994, 10.22016022300005],
              [-65.74730383999992, 10.23924388200004],
              [-65.84732011599993, 10.281398830000057],
              [-65.8684789699999, 10.30955638200004],
              [-65.58043372299994, 10.18545156500005],
              [-65.45909583199995, 10.149359442000048],
              [-65.42577063699991, 10.143418687000064],
              [-65.31012936099995, 10.122870184000078],
              [-65.16954505099994, 10.097316799000055],
              [-65.12857011599993, 10.07615794500009],
              [-65.09146074099993, 10.066880601000037],
              [-65.08018958199995, 10.062567450000074],
              [-65.08018958199995, 10.05565013200004],
              [-65.15575110599991, 10.079901434000078],
              [-65.17568925699993, 10.083644924000055],
              [-65.16698157499991, 10.06940338700008],
              [-65.14891516799992, 10.058417059000078],
              [-65.12800045499995, 10.051336981000077],
              [-65.08397376199991, 10.04751211100006],
              [-65.07335364499994, 10.048895575000074],
              [-65.06395423099991, 10.05219147300005],
              [-65.04710852799991, 10.06077708500004],
              [-65.01683508999992, 10.067084052000041],
              [-64.98094641799992, 10.089260158000059],
              [-64.96349036399994, 10.097316799000055],
              [-64.94359290299991, 10.099798895000049],
              [-64.88833574099993, 10.08982982000009],
              [-64.81419837099992, 10.085109768000052],
              [-64.77660071499992, 10.090399481000077],
              [-64.74811764199995, 10.10687897300005],
              [-64.73704993399991, 10.121039130000042],
              [-64.72862708199995, 10.136053778000075],
              [-64.71703040299991, 10.172349351000037],
              [-64.71670488199993, 10.187974351000037],
              [-64.72183183499993, 10.214016018000052],
              [-64.71703040299991, 10.22760651200008],
              [-64.70913652299993, 10.218939520000049],
              [-64.69933020699995, 10.213812567000048],
              [-64.68809973899994, 10.212062893000052],
              [-64.67609615799995, 10.213324286000045],
              [-64.68346106699994, 10.203680731000077],
              [-64.68757076699995, 10.201361395000049],
              [-64.6966039699999, 10.199693101000037],
              [-64.68517005099994, 10.186021226000037],
              [-64.66763261599993, 10.187323309000078],
              [-64.65762285099993, 10.196682033000059],
              [-64.66860917899993, 10.207098700000074],
              [-64.65709387899994, 10.215236721000053],
              [-64.63141842399995, 10.248114325000074],
              [-64.61676998599995, 10.250474351000037],
              [-64.58828691299993, 10.260321356000077],
              [-64.57241777299993, 10.26170482000009],
              [-64.57510331899994, 10.254828192000048],
              [-64.57673092399995, 10.252020575000074],
              [-64.57990475199995, 10.248114325000074],
              [-64.57433020699995, 10.249741929000038],
              [-64.56505286399994, 10.251369533000059],
              [-64.55939693899995, 10.254339911000045],
              [-64.55223548099991, 10.242336330000057],
              [-64.54637610599991, 10.243841864000046],
              [-64.54002844999991, 10.250555731000077],
              [-64.53608150899993, 10.252305406000062],
              [-64.53148352799991, 10.254339911000045],
              [-64.52098548099991, 10.251776434000078],
              [-64.49901282499991, 10.242336330000057],
              [-64.49054928299995, 10.240668036000045],
              [-64.46837317599994, 10.248602606000077],
              [-64.44017493399991, 10.276271877000056],
              [-64.40859941299993, 10.284369208000044],
              [-64.39028886599993, 10.293768622000073],
              [-64.38438880099994, 10.29588450700004],
              [-64.37669837099992, 10.30076732000009],
              [-64.37669837099992, 10.310248114000046],
              [-64.38223222599993, 10.316961981000077],
              [-64.40957597599993, 10.30467357000009],
              [-64.43276933499993, 10.305975653000075],
              [-64.45494544199994, 10.313421942000048],
              [-64.4700414699999, 10.323187567000048],
              [-64.46336829299992, 10.332831122000073],
              [-64.45303300699993, 10.331447658000059],
              [-64.44102942599994, 10.325913804000038],
              [-64.42906653599994, 10.323187567000048],
              [-64.41665605399993, 10.326727606000077],
              [-64.39533443899995, 10.339504299000055],
              [-64.38060462099992, 10.343695380000042],
              [-64.38353430899991, 10.35651276200008],
              [-64.38304602799991, 10.361517645000049],
              [-64.38060462099992, 10.37099844000005],
              [-64.40241451699995, 10.37099844000005],
              [-64.40241451699995, 10.378485419000071],
              [-64.38125566299993, 10.386216539000088],
              [-64.37108313699991, 10.382228908000059],
              [-64.36782792899993, 10.37010325700004],
              [-64.36754309799994, 10.353949286000045],
              [-64.36461341099994, 10.338324286000045],
              [-64.35741126199991, 10.338690497000073],
              [-64.34825598899994, 10.349188544000071],
              [-64.33971106699994, 10.364203192000048],
              [-64.3391820949999, 10.390692450000074],
              [-64.29918372299994, 10.40648021000004],
              [-64.24718176999994, 10.419867255000042],
              [-64.21056067599994, 10.439276434000078],
              [-64.20213782499991, 10.45538971600007],
              [-64.19774329299992, 10.46865469000005],
              [-64.18854732999995, 10.47760651200008],
              [-64.16559811099995, 10.480861721000053],
              [-64.14346269399994, 10.480129299000055],
              [-64.12767493399991, 10.47760651200008],
              [-64.11461341099994, 10.473211981000077],
              [-64.07038326699995, 10.452622789000088],
              [-64.05182857999995, 10.447943427000041],
              [-64.02843176999994, 10.446112372000073],
              [-64.00487219999991, 10.44790273600006],
              [-63.943023240999935, 10.46039459800005],
              [-63.9231664699999, 10.459418036000045],
              [-63.884022589999915, 10.448716539000088],
              [-63.86363684799994, 10.446112372000073],
              [-63.820383266999954, 10.44757721600007],
              [-63.68346106699994, 10.479722398000092],
              [-63.65501868399991, 10.494533596000053],
              [-63.67808997299994, 10.496975002000056],
              [-63.703684048999946, 10.495306708000044],
              [-63.729725714999915, 10.49750397300005],
              [-63.75405839799993, 10.51162344000005],
              [-63.77183997299994, 10.525051174000055],
              [-63.823150193999936, 10.549383856000077],
              [-63.84683183499993, 10.555975653000075],
              [-63.8997289699999, 10.557114976000037],
              [-63.92373613199993, 10.560288804000038],
              [-63.94644120999993, 10.573391018000052],
              [-63.96666419199994, 10.581366278000075],
              [-63.9934789699999, 10.58079661700009],
              [-64.04548092399995, 10.570257880000042],
              [-64.04051673099991, 10.575140692000048],
              [-64.03184973899994, 10.59007396000004],
              [-64.04629472599993, 10.589585679000038],
              [-64.05671139199995, 10.583482164000088],
              [-64.06484941299993, 10.575751044000071],
              [-64.07274329299992, 10.570257880000042],
              [-64.08617102799991, 10.56712474200009],
              [-64.15550696499992, 10.572699286000045],
              [-64.16905676999994, 10.570257880000042],
              [-64.19953365799995, 10.55219147300005],
              [-64.20685787699995, 10.54913971600007],
              [-64.21540279899995, 10.543768622000073],
              [-64.22427324099993, 10.520412502000056],
              [-64.23387610599991, 10.515041408000059],
              [-64.24913489499994, 10.520453192000048],
              [-64.25609290299991, 10.533351955000057],
              [-64.25788326699995, 10.548041083000044],
              [-64.25772050699993, 10.559393622000073],
              [-64.26671301999994, 10.57908763200004],
              [-64.28457597599993, 10.599798895000049],
              [-64.29767818899995, 10.61985911700009],
              [-64.29255123599995, 10.637884833000044],
              [-64.28189042899993, 10.64362213700008],
              [-64.2747289699999, 10.650580145000049],
              [-64.27098548099991, 10.659898179000038],
              [-64.27074133999992, 10.672674872000073],
              [-64.26455644399994, 10.672674872000073],
              [-64.25475012899994, 10.65493398600006],
              [-64.24079342399995, 10.646063544000071],
              [-64.19627844999991, 10.637884833000044],
              [-64.18390865799995, 10.633490302000041],
              [-64.15721594999991, 10.62018463700008],
              [-64.14476477799991, 10.61741771000004],
              [-64.13121497299994, 10.619696356000077],
              [-64.07249915299991, 10.64789459800005],
              [-64.06261145699995, 10.65102773600006],
              [-64.04889889199995, 10.652167059000078],
              [-64.04271399599992, 10.650213934000078],
              [-64.03937740799995, 10.645738023000092],
              [-64.03648841099994, 10.641017971000053],
              [-64.03184973899994, 10.637884833000044],
              [-63.93732662699995, 10.63890208500004],
              [-63.91510982999995, 10.631048895000049],
              [-63.900380011999914, 10.638251044000071],
              [-63.86164303299995, 10.646307684000078],
              [-63.84683183499993, 10.652167059000078],
              [-63.836822068999936, 10.66233958500004],
              [-63.82835852799991, 10.67682526200008],
              [-63.822377081999946, 10.69440338700008],
              [-63.819569464999915, 10.71360911700009],
              [-63.81212317599994, 10.71360911700009],
              [-63.799672003999945, 10.691148179000038],
              [-63.78066972599993, 10.675848700000074],
              [-63.75694739499994, 10.665594794000071],
              [-63.653187628999945, 10.64126211100006],
              [-63.55333411399994, 10.62913646000004],
              [-63.53156490799995, 10.631048895000049],
              [-63.490223761999914, 10.657619533000059],
              [-63.46617591099994, 10.667629299000055],
              [-63.44904537699995, 10.658392645000049],
              [-63.44220943899995, 10.658392645000049],
              [-63.43895423099991, 10.671372789000088],
              [-63.42992102799991, 10.67259349200009],
              [-63.417632615999935, 10.66860586100006],
              [-63.40489661399994, 10.665838934000078],
              [-63.39940344999991, 10.669989325000074],
              [-63.393462693999936, 10.690904039000088],
              [-63.387562628999945, 10.699367580000057],
              [-63.380930141999954, 10.69245026200008],
              [-63.374256964999915, 10.688788153000075],
              [-63.36742102799991, 10.68891022300005],
              [-63.360218878999945, 10.693101304000038],
              [-63.35399329299992, 10.686346747000073],
              [-63.360218878999945, 10.680121161000045],
              [-63.33975175699993, 10.672674872000073],
              [-63.33153235599991, 10.685370184000078],
              [-63.31773841099994, 10.68423086100006],
              [-63.301340298999946, 10.677313544000071],
              [-63.285145636999914, 10.672674872000073],
              [-63.28453528599994, 10.676459052000041],
              [-63.27989661399994, 10.683661200000074],
              [-63.27171790299991, 10.687933661000045],
              [-63.260609503999945, 10.683254299000055],
              [-63.2512914699999, 10.680568752000056],
              [-63.24087480399993, 10.685126044000071],
              [-63.17129472599993, 10.731594143000052],
              [-63.16161048099991, 10.73468659100007],
              [-63.15859941299993, 10.729681708000044],
              [-63.1555883449999, 10.72016022300005],
              [-63.14948482999995, 10.71092357000009],
              [-63.13744055899991, 10.706773179000038],
              [-63.125884568999936, 10.706854559000078],
              [-63.11620032499991, 10.708156643000052],
              [-63.107533331999946, 10.71234772300005],
              [-63.09951738199993, 10.721096096000053],
              [-63.08250891799992, 10.715521552000041],
              [-63.014230923999946, 10.721096096000053],
              [-62.99176998599995, 10.71784088700008],
              [-62.951730923999946, 10.703314520000049],
              [-62.92821204299992, 10.699367580000057],
              [-62.904286261999914, 10.70221588700008],
              [-62.863392706999946, 10.71751536700009],
              [-62.82770748599995, 10.72329336100006],
              [-62.719634568999936, 10.75999583500004],
              [-62.70567786399994, 10.76203034100007],
              [-62.68301347599993, 10.74998607000009],
              [-62.671538865999935, 10.747748114000046],
              [-62.65925045499995, 10.746893622000073],
              [-62.63805091099994, 10.742621161000045],
              [-62.541574673999946, 10.74095286700009],
              [-62.397043423999946, 10.71548086100006],
              [-62.31875566299993, 10.704738674000055],
              [-62.27391516799992, 10.698879299000055],
              [-62.202056443999936, 10.69672272300005],
              [-62.170765753999945, 10.68650950700004],
              [-62.15420488199993, 10.686346747000073],
              [-62.141835089999915, 10.691799221000053],
              [-62.11510169199994, 10.70970286700009],
              [-62.102406378999945, 10.71360911700009],
              [-62.03624426999994, 10.714016018000052],
              [-62.007069464999915, 10.719916083000044],
              [-61.98232988199993, 10.73468659100007],
              [-61.971262173999946, 10.723089911000045],
              [-61.944203253999945, 10.731756903000075],
              [-61.93517005099994, 10.721096096000053],
              [-61.91869055899991, 10.73118724200009],
              [-61.89220130099994, 10.740423895000049],
              [-61.86481686099995, 10.744818427000041],
              [-61.845773891999954, 10.74095286700009],
              [-61.86196855399993, 10.73346588700008],
              [-61.87686113199993, 10.722723700000074],
              [-61.88491777299993, 10.707424221000053],
              [-61.88048255099994, 10.686346747000073],
              [-61.886708136999914, 10.680121161000045],
              [-61.897694464999915, 10.690375067000048],
              [-61.90684973899994, 10.684068101000037],
              [-61.918812628999945, 10.67218659100007],
              [-61.93822180899991, 10.665838934000078],
              [-61.941965298999946, 10.664007880000042],
              [-61.95457923099991, 10.65525950700004],
              [-61.96247311099995, 10.652167059000078],
              [-61.97443600199995, 10.65180084800005],
              [-61.98399817599994, 10.653550523000092],
              [-61.99315344999991, 10.652777411000045],
              [-62.004017706999946, 10.644720770000049],
              [-62.06700598899994, 10.63812897300005],
              [-62.08893795499995, 10.631293036000045],
              [-62.17446855399993, 10.642279364000046],
              [-62.23985755099994, 10.637884833000044],
              [-62.25267493399991, 10.632391669000071],
              [-62.26480058499993, 10.619289455000057],
              [-62.31362870999993, 10.54783763200004],
              [-62.33495032499991, 10.530218817000048],
              [-62.35594641799992, 10.532375393000052],
              [-62.37913977799991, 10.545070705000057],
              [-62.39834550699993, 10.544256903000075],
              [-62.41783606699994, 10.538275458000044],
              [-62.44163977799991, 10.53546784100007],
              [-62.453114386999914, 10.537787177000041],
              [-62.47227942599994, 10.546454169000071],
              [-62.48322506399995, 10.54913971600007],
              [-62.49258378799993, 10.54881419500009],
              [-62.50938880099994, 10.544134833000044],
              [-62.52106686099995, 10.54295482000009],
              [-62.541859503999945, 10.545314846000053],
              [-62.6067602199999, 10.56281159100007],
              [-62.66234290299991, 10.56704336100006],
              [-62.89586341099994, 10.537543036000045],
              [-62.92332923099991, 10.530829169000071],
              [-62.93512936099995, 10.518459377000056],
              [-62.945383266999954, 10.502427476000037],
              [-62.96890214799993, 10.483628648000092],
              [-62.99445553299995, 10.467678127000056],
              [-63.01081295499995, 10.46039459800005],
              [-63.01081295499995, 10.453558661000045],
              [-62.98029537699995, 10.46580638200004],
              [-62.9251195949999, 10.511786200000074],
              [-62.89411373599995, 10.52928294500009],
              [-62.85700436099995, 10.53156159100007],
              [-62.84117591099994, 10.511786200000074],
              [-62.838002081999946, 10.48265208500004],
              [-62.83885657499991, 10.456976630000042],
              [-62.83275305899991, 10.425848700000074],
              [-62.83112545499995, 10.406805731000077],
              [-62.83576412699995, 10.39834219000005],
              [-62.84406490799995, 10.397040106000077],
              [-62.859445766999954, 10.39203522300005],
              [-62.866118943999936, 10.391506252000056],
              [-62.87474524599992, 10.39549388200004],
              [-62.88971920499995, 10.409002997000073],
              [-62.89781653599994, 10.41201406500005],
              [-62.96401933499993, 10.415187893000052],
              [-62.99518795499995, 10.407863674000055],
              [-63.003977016999954, 10.38467031500005],
              [-62.99722245999993, 10.389593817000048],
              [-62.97598222599993, 10.39834219000005],
              [-62.97057044199994, 10.373968817000048],
              [-62.96556555899991, 10.364162502000056],
              [-62.95616614499994, 10.357367255000042],
              [-62.96788489499994, 10.350490627000056],
              [-62.98375403599994, 10.330511786000045],
              [-62.99714107999995, 10.323187567000048],
              [-62.978586391999954, 10.310980536000045],
              [-62.98078365799995, 10.30023834800005],
              [-62.99278723899994, 10.28904857000009],
              [-63.003977016999954, 10.27537669500009],
              [-62.94591223899994, 10.278143622000073],
              [-62.931630011999914, 10.285630601000037],
              [-62.92715410099993, 10.30337148600006],
              [-62.94762122299994, 10.342718817000048],
              [-62.94249426999994, 10.364203192000048],
              [-62.953684048999946, 10.371527411000045],
              [-62.957102016999954, 10.38377513200004],
              [-62.953236456999946, 10.396551825000074],
              [-62.94249426999994, 10.405178127000056],
              [-62.924672003999945, 10.405666408000059],
              [-62.90782630099994, 10.39712148600006],
              [-62.879790818999936, 10.37099844000005],
              [-62.869984503999945, 10.37836334800005],
              [-62.86034094999991, 10.38084544500009],
              [-62.850168423999946, 10.38182200700004],
              [-62.83885657499991, 10.38467031500005],
              [-62.80797278599994, 10.402492580000057],
              [-62.801625128999945, 10.405178127000056],
              [-62.78425045499995, 10.402289130000042],
              [-62.76447506399995, 10.395331122000073],
              [-62.746937628999945, 10.386664130000042],
              [-62.736439581999946, 10.378485419000071],
              [-62.73314368399991, 10.370672919000071],
              [-62.73224850199995, 10.353013414000088],
              [-62.72899329299992, 10.343695380000042],
              [-62.722320115999935, 10.335598049000055],
              [-62.698882615999935, 10.320135809000078],
              [-62.6848852199999, 10.306708075000074],
              [-62.67495683499993, 10.293361721000053],
              [-62.66930091099994, 10.276922919000071],
              [-62.66812089799993, 10.254339911000045],
              [-62.67495683499993, 10.22483958500004],
              [-62.67495683499993, 10.213324286000045],
              [-62.663319464999915, 10.190619208000044],
              [-62.661366339999915, 10.182318427000041],
              [-62.65802975199995, 10.179103908000059],
              [-62.65074622299994, 10.17609284100007],
              [-62.64354407499991, 10.171210028000075],
              [-62.63805091099994, 10.153998114000046],
              [-62.62877356699994, 10.136379299000055],
              [-62.62657630099994, 10.130804755000042],
              [-62.63072669199994, 10.114488023000092],
              [-62.64195716099994, 10.096625067000048],
              [-62.65660559799994, 10.082180080000057],
              [-62.671538865999935, 10.07615794500009],
              [-62.682850714999915, 10.075100002000056],
              [-62.7024633449999, 10.070461330000057],
              [-62.712554490999935, 10.06932200700004],
              [-62.725493943999936, 10.071234442000048],
              [-62.73281816299993, 10.075506903000075],
              [-62.73770097599993, 10.080267645000049],
              [-62.74327551999994, 10.083644924000055],
              [-62.75959225199995, 10.086818752000056],
              [-62.777455206999946, 10.086493231000077],
              [-62.79198157499991, 10.080267645000049],
              [-62.79792232999995, 10.065904039000088],
              [-62.8001195949999, 10.057114976000037],
              [-62.805897589999915, 10.049505927000041],
              [-62.81387285099993, 10.044094143000052],
              [-62.82274329299992, 10.04205963700008],
              [-62.82770748599995, 10.046047268000052],
              [-62.83275305899991, 10.06549713700008],
              [-62.83576412699995, 10.072739976000037],
              [-62.85138912699995, 10.08038971600007],
              [-62.878977016999954, 10.066229559000078],
              [-62.89411373599995, 10.06932200700004],
              [-62.896473761999914, 10.076727606000077],
              [-62.894602016999954, 10.086737372000073],
              [-62.89435787699995, 10.096625067000048],
              [-62.90151933499993, 10.103461005000042],
              [-62.91120357999995, 10.10350169500009],
              [-62.92056230399993, 10.09870026200008],
              [-62.92886308499993, 10.09125397300005],
              [-62.93512936099995, 10.083644924000055],
              [-62.93846594999991, 10.09406159100007],
              [-62.944569464999915, 10.101304429000038],
              [-62.95287024599992, 10.10651276200008],
              [-62.963002081999946, 10.110296942000048],
              [-62.978505011999914, 10.098089911000045],
              [-62.98932857999995, 10.096258856000077],
              [-63.017648891999954, 10.103461005000042],
              [-63.01309160099993, 10.097398179000038],
              [-63.00999915299991, 10.09320709800005],
              [-62.99583899599992, 10.078802802000041],
              [-62.98216712099992, 10.06907786700009],
              [-62.97598222599993, 10.072739976000037],
              [-62.97179114499994, 10.082220770000049],
              [-62.96231035099993, 10.088039455000057],
              [-62.95299231699994, 10.088080145000049],
              [-62.94871985599991, 10.079901434000078],
              [-62.94444739499994, 10.02960846600007],
              [-62.93602454299992, 10.008246161000045],
              [-62.920765753999945, 10.007961330000057],
              [-62.932484503999945, 10.022650458000044],
              [-62.93040930899991, 10.034816799000055],
              [-62.92617753799993, 10.046291408000059],
              [-62.931630011999914, 10.059068101000037],
              [-62.931711391999954, 10.065008856000077],
              [-62.92821204299992, 10.074652411000045],
              [-62.92218990799995, 10.08266836100006],
              [-62.914621548999946, 10.083644924000055],
              [-62.90990149599992, 10.07721588700008],
              [-62.91486568899995, 10.06118398600006],
              [-62.91120357999995, 10.052313544000071],
              [-62.89557857999995, 10.04401276200008],
              [-62.881703253999945, 10.047430731000077],
              [-62.868031378999945, 10.05414459800005],
              [-62.85313880099994, 10.05565013200004],
              [-62.84048417899993, 10.048773505000042],
              [-62.830922003999945, 10.038804429000038],
              [-62.81867428299995, 10.030666408000059],
              [-62.79792232999995, 10.028998114000046],
              [-62.809803839999915, 10.003729559000078],
              [-62.80109615799995, 9.99599844000005],
              [-62.785715298999946, 10.002020575000074],
              [-62.777414516999954, 10.018459377000056],
              [-62.78734290299991, 10.051459052000041],
              [-62.78498287699995, 10.06976959800005],
              [-62.76431230399993, 10.07615794500009],
              [-62.75772050699993, 10.072007554000038],
              [-62.73965410099993, 10.054266669000071],
              [-62.72899329299992, 10.048895575000074],
              [-62.71670488199993, 10.048407294000071],
              [-62.66356360599991, 10.06085846600007],
              [-62.63939368399991, 10.074042059000078],
              [-62.61851966099994, 10.091620184000078],
              [-62.6067602199999, 10.110296942000048],
              [-62.60594641799992, 10.133246161000045],
              [-62.62218176999994, 10.175726630000042],
              [-62.62657630099994, 10.19627513200004],
              [-62.61953691299993, 10.224432684000078],
              [-62.60216223899994, 10.230943101000037],
              [-62.57994544199994, 10.224432684000078],
              [-62.558257615999935, 10.213324286000045],
              [-62.517567511999914, 10.184149481000077],
              [-62.49494381399995, 10.15180084800005],
              [-62.46955318899995, 10.06932200700004],
              [-62.46084550699993, 10.051906643000052],
              [-62.45002193899995, 10.036851304000038],
              [-62.44188391799992, 10.021063544000071],
              [-62.44163977799991, 10.00104401200008],
              [-62.42943274599992, 9.980861721000053],
              [-62.42617753799993, 9.96751536700009],
              [-62.43065344999991, 9.953924872000073],
              [-62.44163977799991, 9.932806708000044],
              [-62.423491990999935, 9.932318427000041],
              [-62.40892493399991, 9.924017645000049],
              [-62.39696204299992, 9.911444403000075],
              [-62.37759355399993, 9.88467031500005],
              [-62.324289516999954, 9.785630601000037],
              [-62.31871497299994, 9.76829661700009],
              [-62.32005774599992, 9.751613674000055],
              [-62.325062628999945, 9.736517645000049],
              [-62.32697506399995, 9.721828518000052],
              [-62.32534745999993, 9.718817450000074],
              [-62.31871497299994, 9.706244208000044],
              [-62.29076087099992, 9.733303127000056],
              [-62.27049719999991, 9.76666901200008],
              [-62.24299068899995, 9.84284088700008],
              [-62.24095618399991, 9.874945380000042],
              [-62.25772050699993, 9.93781159100007],
              [-62.25723222599993, 9.974351304000038],
              [-62.23936926999994, 9.96084219000005],
              [-62.2219945949999, 9.938381252000056],
              [-62.18492591099994, 9.867743231000077],
              [-62.17870032499991, 9.846136786000045],
              [-62.175892706999946, 9.70498281500005],
              [-62.187611456999946, 9.662665106000077],
              [-62.215687628999945, 9.637925523000092],
              [-62.18187415299991, 9.648871161000045],
              [-62.16242428299995, 9.68227773600006],
              [-62.154286261999914, 9.726141669000071],
              [-62.16047115799995, 9.85024648600006],
              [-62.16641191299993, 9.873439846000053],
              [-62.18781490799995, 9.911688544000071],
              [-62.19517981699994, 9.932806708000044],
              [-62.136830206999946, 9.925970770000049],
              [-62.11945553299995, 9.921454169000071],
              [-62.11245683499993, 9.910345770000049],
              [-62.10822506399995, 9.896551825000074],
              [-62.09898841099994, 9.883734442000048],
              [-62.088449673999946, 9.879299221000053],
              [-62.05650794199994, 9.871975002000056],
              [-62.03693600199995, 9.870306708000044],
              [-62.02867591099994, 9.870672919000071],
              [-62.027333136999914, 9.874416408000059],
              [-62.03750566299993, 9.883734442000048],
              [-62.04625403599994, 9.887925523000092],
              [-62.076161261999914, 9.896429755000042],
              [-62.08901933499993, 9.898098049000055],
              [-62.09032141799992, 9.903265692000048],
              [-62.11945553299995, 9.932806708000044],
              [-62.135609503999945, 9.940619208000044],
              [-62.14867102799991, 9.944647528000075],
              [-62.20836341099994, 9.94603099200009],
              [-62.22142493399991, 9.95180898600006],
              [-62.23680579299992, 9.966945705000057],
              [-62.223215298999946, 9.987005927000041],
              [-62.216786261999914, 10.003851630000042],
              [-62.20653235599991, 10.014349677000041],
              [-62.19647551199995, 10.019677793000085],
              [-62.11085605199992, 9.99769470700005],
              [-62.061284806999936, 9.977875020000056],
              [-62.0253828459999, 9.957357139000067],
              [-61.924975359999905, 9.879634937000048],
              [-61.90697213899995, 9.864044232000083],
              [-61.87676478299994, 9.82368213500007],
              [-61.84800627199991, 9.803851244000043],
              [-61.83145097599993, 9.791937567000048],
              [-61.83071855399993, 9.778469143000052],
              [-61.828195766999954, 9.771063544000071],
              [-61.81476803299995, 9.757757880000042],
              [-61.81037350199995, 9.748195705000057],
              [-61.81191972599993, 9.738023179000038],
              [-61.822336391999954, 9.708482164000088],
              [-61.84170488199993, 9.671942450000074],
              [-61.845773891999954, 9.65102773600006],
              [-61.83893795499995, 9.65102773600006],
              [-61.81163489499994, 9.706244208000044],
              [-61.79735266799992, 9.760891018000052],
              [-61.78010006399995, 9.75922272300005],
              [-61.76549231699994, 9.738674221000053],
              [-61.75328528599994, 9.713771877000056],
              [-61.74331620999993, 9.699408270000049],
              [-61.74864661399994, 9.680080471000053],
              [-61.74331620999993, 9.596380927000041],
              [-61.73424231699994, 9.616603908000059],
              [-61.73033606699994, 9.638861395000049],
              [-61.72964433499993, 9.68235911700009],
              [-61.731027798999946, 9.694037177000041],
              [-61.73473059799994, 9.70302969000005],
              [-61.74010169199994, 9.710191148000092],
              [-61.74644934799994, 9.71678294500009],
              [-61.75328528599994, 9.72752513200004],
              [-61.757923956999946, 9.75031159100007],
              [-61.76317298099991, 9.760891018000052],
              [-61.76992753799993, 9.764837958000044],
              [-61.78954016799992, 9.769598700000074],
              [-61.79735266799992, 9.774562893000052],
              [-61.79857337099992, 9.780951239000046],
              [-61.81515287399992, 9.80255401100004],
              [-61.82165200599991, 9.812894288000052],
              [-61.82382201599995, 9.820737273000077],
              [-61.828171711999914, 9.827158454000084],
              [-61.819095475999916, 9.829639643000064],
              [-61.79009955299995, 9.830667120000044],
              [-61.75217154199993, 9.823155497000073],
              [-61.67442786399994, 9.79873281500005],
              [-61.66270911399994, 9.797430731000077],
              [-61.59251868399991, 9.78196849200009],
              [-61.57380123599995, 9.794582424000055],
              [-61.578114386999914, 9.80882396000004],
              [-61.59117591099994, 9.822455145000049],
              [-61.60204016799992, 9.836737372000073],
              [-61.60924231699994, 9.839544989000046],
              [-61.6165258449999, 9.844183661000045],
              [-61.63334276099994, 9.854776602000072],
              [-61.63472899499993, 9.86256016200008],
              [-61.6370594629999, 9.870351289000041],
              [-61.651450249999925, 9.873572056000057],
              [-61.66491982999992, 9.885037500000067],
              [-61.6709656729999, 9.896498654000084],
              [-61.66536544799993, 9.900144688000069],
              [-61.63673469899993, 9.898770728000045],
              [-61.62695207299993, 9.894534815000043],
              [-61.61167174099995, 9.887279259000081],
              [-61.58293137399994, 9.87216310000008],
              [-61.54269543599992, 9.846855951000066],
              [-61.50979709699993, 9.825775999000086],
              [-61.47570063899991, 9.80170127100007],
              [-61.46111806499994, 9.783685156000047],
              [-61.422265394999954, 9.736261109000054],
              [-61.42708333899992, 9.763835590000042],
              [-61.45135390999991, 9.794448017000093],
              [-61.45804239699993, 9.812458040000081],
              [-61.487872540999945, 9.823326474000055],
              [-61.50309831099992, 9.839566517000037],
              [-61.499440911999955, 9.841957867000076],
              [-61.484826478999935, 9.82992067400005],
              [-61.47082532899992, 9.826890462000051],
              [-61.45195376299995, 9.825046339000039],
              [-61.439167779999934, 9.818411300000037],
              [-61.4288390669999, 9.806995450000045],
              [-61.402141394999944, 9.777575385000091],
              [-61.38574081699994, 9.761352697000063],
              [-61.3699677809999, 9.747537967000085],
              [-61.354801418999955, 9.731326294000041],
              [-61.33782151299994, 9.712114966000058],
              [-61.32508227099993, 9.701898305000043],
              [-61.3056675009999, 9.686275329000068],
              [-61.25834840199991, 9.649007465000068],
              [-61.236507977999906, 9.632169292000071],
              [-61.22624811399993, 9.60096655700005],
              [-61.20604407499991, 9.577378648000092],
              [-61.191965298999946, 9.583319403000075],
              [-61.2083227199999, 9.60382721600007],
              [-61.18419348899994, 9.604071356000077],
              [-61.130116339999915, 9.57249583500004],
              [-61.11204993399991, 9.583319403000075],
              [-61.105539516999954, 9.580145575000074],
              [-61.068023240999935, 9.583319403000075],
              [-61.05321204299992, 9.581284898000092],
              [-61.016468878999945, 9.562892971000053],
              [-60.97704016799992, 9.549627997000073],
              [-60.960601365999935, 9.538723049000055],
              [-60.955067511999914, 9.521307684000078],
              [-60.96174068899995, 9.522365627000056],
              [-60.964914516999954, 9.525458075000074],
              [-60.96865800699993, 9.534979559000078],
              [-60.97061113199993, 9.50193919500009],
              [-60.96865800699993, 9.493963934000078],
              [-60.96129309799994, 9.487453518000052],
              [-60.95425370999993, 9.48818594000005],
              [-60.94668535099993, 9.491766669000071],
              [-60.93765214799993, 9.493963934000078],
              [-60.92072506399995, 9.490301825000074],
              [-60.89976966099994, 9.481146552000041],
              [-60.879017706999946, 9.468898830000057],
              [-60.86229407499991, 9.45612213700008],
              [-60.853586391999954, 9.446437893000052],
              [-60.83824622299994, 9.425197658000059],
              [-60.82335364499994, 9.410549221000053],
              [-60.82013912699995, 9.406195380000042],
              [-60.818430141999954, 9.401190497000073],
              [-60.81786048099991, 9.394680080000057],
              [-60.815297003999945, 9.392279364000046],
              [-60.802398240999935, 9.38890208500004],
              [-60.797434048999946, 9.384711005000042],
              [-60.789051886999914, 9.36424388200004],
              [-60.78380286399994, 9.33860911700009],
              [-60.78538977799991, 9.31354401200008],
              [-60.797434048999946, 9.294745184000078],
              [-60.799387173999946, 9.303168036000045],
              [-60.801991339999915, 9.30768463700008],
              [-60.81041419199994, 9.31586334800005],
              [-60.8157445949999, 9.301581122000073],
              [-60.81749426999994, 9.285630601000037],
              [-60.82188880099994, 9.272772528000075],
              [-60.8352758449999, 9.267401434000078],
              [-60.85065670499995, 9.264227606000077],
              [-60.873605923999946, 9.250148830000057],
              [-60.88304602799991, 9.246975002000056],
              [-60.894642706999946, 9.245794989000046],
              [-60.90697180899991, 9.24282461100006],
              [-60.91836503799993, 9.238470770000049],
              [-60.92711341099994, 9.233303127000056],
              [-60.93342037699995, 9.222357489000046],
              [-60.93797766799992, 9.216131903000075],
              [-60.944203253999945, 9.213446356000077],
              [-60.94554602799991, 9.21234772300005],
              [-60.96865800699993, 9.206000067000048],
              [-61.02415930899991, 9.153265692000048],
              [-61.04723059799994, 9.14516836100006],
              [-61.06676184799994, 9.132310289000088],
              [-61.08543860599991, 9.102443752000056],
              [-61.11204993399991, 9.041489976000037],
              [-61.097645636999914, 9.04718659100007],
              [-61.084543423999946, 9.059393622000073],
              [-61.07481848899994, 9.073919989000046],
              [-61.071156378999945, 9.086493231000077],
              [-61.06627356699994, 9.095119533000059],
              [-60.98399817599994, 9.167385158000059],
              [-60.95913652299993, 9.182521877000056],
              [-60.955067511999914, 9.16502513200004],
              [-60.96003170499995, 9.155096747000073],
              [-60.975168423999946, 9.139960028000075],
              [-60.98232988199993, 9.13084544500009],
              [-60.985218878999945, 9.12213776200008],
              [-60.98875891799992, 9.100409247000073],
              [-60.99258378799993, 9.093003648000092],
              [-60.99901282499991, 9.085272528000075],
              [-61.00182044199994, 9.077378648000092],
              [-61.00226803299995, 9.058539130000042],
              [-61.00658118399991, 9.048773505000042],
              [-61.016835089999915, 9.043158270000049],
              [-61.02843176999994, 9.039496161000045],
              [-61.03697669199994, 9.035305080000057],
              [-61.07188880099994, 8.997748114000046],
              [-61.07852128799993, 8.997463283000059],
              [-61.08218339799993, 8.988430080000057],
              [-61.099680141999954, 8.960353908000059],
              [-61.10586503799993, 8.94529857000009],
              [-61.117746548999946, 8.903713283000059],
              [-61.11953691299993, 8.887600002000056],
              [-61.11266028599994, 8.867254950000074],
              [-61.11204993399991, 8.857123114000046],
              [-61.12682044199994, 8.814520575000074],
              [-61.18008378799993, 8.735825914000088],
              [-61.19399980399993, 8.692694403000075],
              [-61.19871985599991, 8.644680080000057],
              [-61.20946204299992, 8.609035549000055],
              [-61.233306443999936, 8.58930084800005],
              [-61.27721106699994, 8.589016018000052],
              [-61.33551998599995, 8.607489325000074],
              [-61.348540818999936, 8.61009349200009],
              [-61.52306067599994, 8.596625067000048],
              [-61.56688391799992, 8.606594143000052],
              [-61.605539516999954, 8.630560614000046],
              [-61.62535559799994, 8.630194403000075],
              [-61.64517167899993, 8.626654364000046],
              [-61.659047003999945, 8.616522528000075],
              [-61.66075598899994, 8.59642161700009],
              [-61.65196692599994, 8.58584219000005],
              [-61.59874426999994, 8.555487372000073],
              [-61.56114661399994, 8.548041083000044],
              [-61.55190995999993, 8.544989325000074],
              [-61.54564368399991, 8.538234768000052],
              [-61.54116777299993, 8.53123607000009],
              [-61.53726152299993, 8.52757396000004],
              [-61.526600714999915, 8.527167059000078],
              [-61.50918535099993, 8.532863674000055],
              [-61.499663865999935, 8.534369208000044],
              [-61.498158331999946, 8.53148021000004],
              [-61.48664303299995, 8.51829661700009],
              [-61.470773891999954, 8.50413646000004],
              [-61.4641820949999, 8.501288153000075],
              [-61.45164954299992, 8.50023021000004],
              [-61.446522589999915, 8.497259833000044],
              [-61.43789628799993, 8.48314036700009],
              [-61.43423417899993, 8.47915273600006],
              [-61.41466223899994, 8.47679271000004],
              [-61.37596594999991, 8.485988674000055],
              [-61.35912024599992, 8.48655833500004],
              [-61.34911048099991, 8.479315497000073],
              [-61.34251868399991, 8.46580638200004],
              [-61.33751380099994, 8.45062897300005],
              [-61.33177649599992, 8.438177802000041],
              [-61.321156378999945, 8.428208726000037],
              [-61.29527747299994, 8.41233958500004],
              [-61.284047003999945, 8.39720286700009],
              [-61.252797003999945, 8.41860586100006],
              [-61.24014238199993, 8.432114976000037],
              [-61.23497473899994, 8.448716539000088],
              [-61.22838294199994, 8.460598049000055],
              [-61.212880011999914, 8.474188544000071],
              [-61.19489498599995, 8.486273505000042],
              [-61.18101966099994, 8.493394273000092],
              [-61.159047003999945, 8.49827708500004],
              [-61.09508216099994, 8.493394273000092],
              [-61.04857337099992, 8.501776434000078],
              [-61.026600714999915, 8.500921942000048],
              [-61.02391516799992, 8.48655833500004],
              [-61.04015051999994, 8.472845770000049],
              [-61.07799231699994, 8.466457424000055],
              [-61.08543860599991, 8.448716539000088],
              [-61.08657792899993, 8.426947333000044],
              [-61.08576412699995, 8.415594794000071],
              [-61.082020636999914, 8.407782294000071],
              [-61.07188880099994, 8.40330638200004],
              [-61.069569464999915, 8.412665106000077],
              [-61.071156378999945, 8.438177802000041],
              [-61.06655839799993, 8.456284898000092],
              [-61.06191972599993, 8.459865627000056],
              [-61.05064856699994, 8.466131903000075],
              [-61.04084225199995, 8.468085028000075],
              [-61.02965247299994, 8.46751536700009],
              [-61.020375128999945, 8.468817450000074],
              [-61.016468878999945, 8.47601959800005],
              [-61.01447506399995, 8.484849351000037],
              [-61.00951087099992, 8.495062567000048],
              [-61.00381425699993, 8.503566799000055],
              [-60.99242102799991, 8.512193101000037],
              [-60.99038652299993, 8.52415599200009],
              [-60.98924719999991, 8.548041083000044],
              [-60.98729407499991, 8.557806708000044],
              [-60.987212693999936, 8.564886786000045],
              [-60.98477128799993, 8.57054271000004],
              [-60.97557532499991, 8.575995184000078],
              [-60.95661373599995, 8.56899648600006],
              [-60.93712317599994, 8.572211005000042],
              [-60.91710364499994, 8.579046942000048],
              [-60.81798255099994, 8.590277411000045],
              [-60.69245357999995, 8.604681708000044],
              [-60.673898891999954, 8.592718817000048],
              [-60.66787675699993, 8.582586981000077],
              [-60.653960740999935, 8.571193752000056],
              [-60.63805091099994, 8.56118398600006],
              [-60.62608801999994, 8.555487372000073],
              [-60.606312628999945, 8.55109284100007],
              [-60.544178839999915, 8.548041083000044],
              [-60.47891191299993, 8.532375393000052],
              [-60.46157792899993, 8.534369208000044],
              [-60.458241339999915, 8.538885809000078],
              [-60.447336391999954, 8.561712958000044],
              [-60.42686926999994, 8.582831122000073],
              [-60.40371660099993, 8.62250397300005],
              [-60.37189693899995, 8.63540273600006],
              [-60.197824673999946, 8.623846747000073],
              [-60.157460089999915, 8.613348700000074],
              [-60.11900794199994, 8.59642161700009],
              [-60.08360755099994, 8.573716539000088],
              [-60.06436113199993, 8.565130927000041],
              [-60.02098548099991, 8.558010158000059],
            ],
          ],
          [
            [
              [-61.016468878999945, 8.61009349200009],
              [-61.010975714999915, 8.60805898600006],
              [-61.00772050699993, 8.605902411000045],
              [-61.00373287699995, 8.603989976000037],
              [-60.99600175699993, 8.602687893000052],
              [-60.99254309799994, 8.576727606000077],
              [-61.00568600199995, 8.553534247000073],
              [-61.02769934799994, 8.543117580000057],
              [-61.05064856699994, 8.555487372000073],
              [-61.051991339999915, 8.541937567000048],
              [-61.04377193899995, 8.528631903000075],
              [-61.041574673999946, 8.51854075700004],
              [-61.12637285099993, 8.507066148000092],
              [-61.23281816299993, 8.516058661000045],
              [-61.270375128999945, 8.514553127000056],
              [-61.259429490999935, 8.536851304000038],
              [-61.246083136999914, 8.55727773600006],
              [-61.22760982999995, 8.571600653000075],
              [-61.20148678299995, 8.575995184000078],
              [-61.180246548999946, 8.569647528000075],
              [-61.14818274599992, 8.543850002000056],
              [-61.12637285099993, 8.534369208000044],
              [-61.13817298099991, 8.55068594000005],
              [-61.14000403599994, 8.55174388200004],
              [-61.13784745999993, 8.559759833000044],
              [-61.13316809799994, 8.565375067000048],
              [-61.12852942599994, 8.569281317000048],
              [-61.12637285099993, 8.57257721600007],
              [-61.09845943899995, 8.602687893000052],
              [-61.08674068899995, 8.606838283000059],
              [-61.02179928299995, 8.610988674000055],
              [-61.016468878999945, 8.61009349200009],
            ],
          ],
          [
            [
              [-60.92027747299994, 9.028469143000052],
              [-60.89757239499994, 9.033392645000049],
              [-60.87547766799992, 9.02798086100006],
              [-60.85533606699994, 9.015814520000049],
              [-60.83836829299992, 9.000555731000077],
              [-60.85928300699993, 8.994696356000077],
              [-60.86571204299992, 8.994330145000049],
              [-60.850819464999915, 8.970648505000042],
              [-60.86497962099992, 8.941229559000078],
              [-60.89167232999995, 8.91437409100007],
              [-60.933583136999914, 8.883937893000052],
              [-61.06773841099994, 8.828070380000042],
              [-61.09162350199995, 8.822414455000057],
              [-61.035267706999946, 8.86318594000005],
              [-61.01671301999994, 8.88031647300005],
              [-60.98281816299993, 8.930161851000037],
              [-60.97134355399993, 8.963324286000045],
              [-60.96129309799994, 8.973130601000037],
              [-60.94884192599994, 8.981146552000041],
              [-60.93765214799993, 8.990627346000053],
              [-60.933705206999946, 9.000881252000056],
              [-60.93492591099994, 9.009833075000074],
              [-60.933257615999935, 9.018744208000044],
              [-60.92027747299994, 9.028469143000052],
            ],
          ],
          [
            [
              [-61.08543860599991, 8.890692450000074],
              [-61.096587693999936, 8.900580145000049],
              [-61.09288489499994, 8.920070705000057],
              [-61.08372962099992, 8.942938544000071],
              [-61.07852128799993, 8.962958075000074],
              [-61.06932532499991, 8.97882721600007],
              [-61.04751542899993, 8.98729075700004],
              [-61.02212480399993, 8.993068752000056],
              [-61.00226803299995, 9.000555731000077],
              [-60.98412024599992, 9.018947658000059],
              [-60.94688880099994, 9.066107489000046],
              [-60.93081620999993, 9.07562897300005],
              [-60.906361456999946, 9.077704169000071],
              [-60.85204016799992, 9.096136786000045],
              [-60.85204016799992, 9.086737372000073],
              [-60.85309811099995, 9.077948309000078],
              [-60.85533606699994, 9.069647528000075],
              [-60.85887610599991, 9.06195709800005],
              [-60.85887610599991, 9.06940338700008],
              [-60.86656653599994, 9.05174388200004],
              [-60.87564042899993, 9.043646552000041],
              [-60.88927161399994, 9.041408596000053],
              [-60.910715298999946, 9.041489976000037],
              [-60.9270727199999, 9.036851304000038],
              [-60.94298255099994, 9.025824286000045],
              [-61.02708899599992, 8.94867584800005],
              [-61.03221594999991, 8.939886786000045],
              [-61.03844153599994, 8.919867255000042],
              [-61.043812628999945, 8.911769924000055],
              [-61.07713782499991, 8.893133856000077],
              [-61.08543860599991, 8.890692450000074],
            ],
          ],
          [
            [
              [-60.873158331999946, 9.116603908000059],
              [-60.88971920499995, 9.098578192000048],
              [-60.93968665299991, 9.082098700000074],
              [-60.96129309799994, 9.06940338700008],
              [-60.94383704299992, 9.103989976000037],
              [-60.942290818999936, 9.13662344000005],
              [-60.936756964999915, 9.164618231000077],
              [-60.90729732999995, 9.185492255000042],
              [-60.87214107999995, 9.19476959800005],
              [-60.85334225199995, 9.194037177000041],
              [-60.84520423099991, 9.18235911700009],
              [-60.84748287699995, 9.163031317000048],
              [-60.853586391999954, 9.143866278000075],
              [-60.86245683499993, 9.125921942000048],
              [-60.873158331999946, 9.11041901200008],
              [-60.873158331999946, 9.116603908000059],
            ],
          ],
          [
            [
              [-60.81786048099991, 9.206000067000048],
              [-60.80288652299993, 9.217596747000073],
              [-60.780506964999915, 9.22874583500004],
              [-60.757923956999946, 9.230414130000042],
              [-60.742176886999914, 9.213446356000077],
              [-60.73900305899991, 9.208929755000042],
              [-60.733631964999915, 9.198797919000071],
              [-60.728505011999914, 9.192938544000071],
              [-60.73924719999991, 9.188177802000041],
              [-60.752837693999936, 9.187323309000078],
              [-60.769520636999914, 9.189195054000038],
              [-60.797434048999946, 9.171820380000042],
              [-60.80516516799992, 9.15721263200004],
              [-60.81224524599992, 9.138251044000071],
              [-60.82380123599995, 9.122300523000092],
              [-60.84520423099991, 9.116603908000059],
              [-60.83690344999991, 9.14203522300005],
              [-60.828968878999945, 9.187689520000049],
              [-60.81786048099991, 9.206000067000048],
            ],
          ],
          [
            [
              [-63.976551886999914, 10.80923086100006],
              [-63.95665442599994, 10.799953518000052],
              [-63.92833411399994, 10.790838934000078],
              [-63.9036352199999, 10.777289130000042],
              [-63.894642706999946, 10.754584052000041],
              [-63.90916907499991, 10.735541083000044],
              [-63.935536261999914, 10.733710028000075],
              [-63.95677649599992, 10.74412669500009],
              [-63.95612545499995, 10.76203034100007],
              [-63.98277747299994, 10.764349677000041],
              [-63.99644934799994, 10.768459377000056],
              [-64.00450598899994, 10.77570221600007],
              [-64.00536048099991, 10.788397528000075],
              [-63.998890753999945, 10.799261786000045],
              [-63.988270636999914, 10.806708075000074],
              [-63.976551886999914, 10.80923086100006],
            ],
          ],
          [
            [
              [-65.22760982999995, 10.953802802000041],
              [-65.21983801999994, 10.954291083000044],
              [-65.21133378799993, 10.95384349200009],
              [-65.20824133999992, 10.949896552000041],
              [-65.21670488199993, 10.939601955000057],
              [-65.20197506399995, 10.918158270000049],
              [-65.20494544199994, 10.904364325000074],
              [-65.22081458199995, 10.89451732000009],
              [-65.24461829299992, 10.884955145000049],
              [-65.24071204299992, 10.89484284100007],
              [-65.23786373599995, 10.898586330000057],
              [-65.25877844999991, 10.891424872000073],
              [-65.27696692599994, 10.889553127000056],
              [-65.31663977799991, 10.891099351000037],
              [-65.33657792899993, 10.89594147300005],
              [-65.35505123599995, 10.905178127000056],
              [-65.37218176999994, 10.910956122000073],
              [-65.38805091099994, 10.905462958000044],
              [-65.41177324099993, 10.924750067000048],
              [-65.40192623599995, 10.948431708000044],
              [-65.37669837099992, 10.966050523000092],
              [-65.35448157499991, 10.967474677000041],
              [-65.32990475199995, 10.97760651200008],
              [-65.30626380099994, 10.97646719000005],
              [-65.25495357999995, 10.956529039000088],
              [-65.24469967399995, 10.954657294000071],
              [-65.22760982999995, 10.953802802000041],
            ],
          ],
          [
            [
              [-63.84683183499993, 11.13540273600006],
              [-63.84357662699995, 11.114894924000055],
              [-63.829009568999936, 11.077785549000055],
              [-63.82575436099995, 11.06000397300005],
              [-63.79344641799992, 11.001125393000052],
              [-63.787668423999946, 10.973781643000052],
              [-63.819569464999915, 10.980536200000074],
              [-63.81908118399991, 10.973944403000075],
              [-63.82005774599992, 10.96039459800005],
              [-63.819569464999915, 10.953802802000041],
              [-63.83421790299991, 10.964422919000071],
              [-63.84292558499993, 10.96775950700004],
              [-63.84683183499993, 10.963771877000056],
              [-63.84996497299994, 10.957505601000037],
              [-63.87169348899994, 10.93740469000005],
              [-63.89806067599994, 10.884955145000049],
              [-63.955637173999946, 10.894354559000078],
              [-63.976551886999914, 10.891099351000037],
              [-64.04263261599993, 10.868475653000075],
              [-64.05972245999993, 10.857611395000049],
              [-64.05687415299991, 10.887111721000053],
              [-64.07420813699991, 10.89093659100007],
              [-64.09609941299993, 10.89093659100007],
              [-64.11636308499993, 10.928615627000056],
              [-64.13784745999993, 10.94358958500004],
              [-64.16112219999991, 10.955959377000056],
              [-64.17585201699995, 10.967474677000041],
              [-64.20295162699995, 10.94440338700008],
              [-64.22435462099992, 10.93935781500005],
              [-64.29751542899993, 10.947414455000057],
              [-64.30260169199994, 10.949693101000037],
              [-64.30663001199991, 10.95213450700004],
              [-64.31236731699994, 10.953802802000041],
              [-64.33800208199995, 10.952948309000078],
              [-64.34715735599991, 10.953802802000041],
              [-64.38902747299994, 10.966050523000092],
              [-64.40855872299994, 10.967474677000041],
              [-64.38394120999993, 11.01984284100007],
              [-64.38060462099992, 11.032375393000052],
              [-64.37832597599993, 11.053534247000073],
              [-64.37059485599991, 11.06248607000009],
              [-64.35606848899994, 11.064195054000038],
              [-64.33348548099991, 11.063666083000044],
              [-64.32262122299994, 11.065741278000075],
              [-64.31476803299995, 11.069525458000044],
              [-64.30211341099994, 11.080471096000053],
              [-64.29185950399994, 11.083929755000042],
              [-64.27139238199993, 11.076971747000073],
              [-64.24445553299995, 11.08812083500004],
              [-64.22008216099994, 11.091538804000038],
              [-64.19831295499995, 11.087632554000038],
              [-64.18883216099994, 11.073635158000059],
              [-64.18936113199993, 11.061021226000037],
              [-64.18830318899995, 11.04633209800005],
              [-64.18163001199991, 11.034084377000056],
              [-64.14753170499995, 11.023586330000057],
              [-64.11070716099994, 11.000189520000049],
              [-64.08983313699991, 10.994818427000041],
              [-64.04906165299991, 10.990708726000037],
              [-64.03197180899991, 10.99599844000005],
              [-64.01756751199991, 11.015285549000055],
              [-64.01573645699995, 11.02570221600007],
              [-64.01756751199991, 11.056219794000071],
              [-64.01134192599994, 11.065252997000073],
              [-63.996937628999945, 11.076727606000077],
              [-63.99083411399994, 11.083563544000071],
              [-63.98672441299993, 11.094549872000073],
              [-63.987172003999945, 11.102240302000041],
              [-63.98582923099991, 11.10927969000005],
              [-63.976551886999914, 11.118312893000052],
              [-63.9680883449999, 11.12107982000009],
              [-63.94505774599992, 11.122381903000075],
              [-63.935617641999954, 11.125148830000057],
              [-63.92096920499995, 11.137640692000048],
              [-63.89610755099994, 11.168036200000074],
              [-63.880970831999946, 11.17914459800005],
              [-63.87743079299992, 11.16120026200008],
              [-63.86546790299991, 11.151597398000092],
              [-63.8528539699999, 11.14484284100007],
              [-63.84683183499993, 11.13540273600006],
            ],
          ],
          [
            [
              [-66.60826575399994, 11.78310781500005],
              [-66.59276282499991, 11.782538153000075],
              [-66.58779863199993, 11.78310781500005],
              [-66.60651607999995, 11.767238674000055],
              [-66.64183508999992, 11.761460679000038],
              [-66.67943274599992, 11.766546942000048],
              [-66.70449785099993, 11.78310781500005],
              [-66.67414303299995, 11.77602773600006],
              [-66.65086829299992, 11.780178127000056],
              [-66.63198808499993, 11.79596588700008],
              [-66.61510169199994, 11.824042059000078],
              [-66.60627193899995, 11.81736888200004],
              [-66.60138912699995, 11.806708075000074],
              [-66.60167395699995, 11.794501044000071],
              [-66.60826575399994, 11.78310781500005],
            ],
          ],
          [
            [
              [-66.13219153599994, 11.824042059000078],
              [-66.10850989499994, 11.825832424000055],
              [-66.10293535099993, 11.819281317000048],
              [-66.10118567599994, 11.79979075700004],
              [-66.11400305899991, 11.77993398600006],
              [-66.14313717399995, 11.781805731000077],
              [-66.17454993399991, 11.79710521000004],
              [-66.19432532499991, 11.817694403000075],
              [-66.17955481699994, 11.823187567000048],
              [-66.16197669199994, 11.824774481000077],
              [-66.13219153599994, 11.824042059000078],
            ],
          ],
          [
            [
              [-64.60716712099992, 11.899115302000041],
              [-64.59463456899994, 11.89248281500005],
              [-64.56285559799994, 11.868109442000048],
              [-64.55679277299993, 11.85732656500005],
              [-64.55215410099993, 11.839911200000074],
              [-64.55284583199995, 11.823716539000088],
              [-64.56285559799994, 11.816595770000049],
              [-64.60558020699995, 11.818019924000055],
              [-64.62930253799993, 11.821966864000046],
              [-64.64879309799994, 11.830267645000049],
              [-64.64590410099993, 11.838283596000053],
              [-64.64439856699994, 11.840725002000056],
              [-64.64509029899995, 11.84320709800005],
              [-64.64879309799994, 11.851304429000038],
              [-64.63565019399994, 11.861395575000074],
              [-64.61888587099992, 11.889227606000077],
              [-64.60716712099992, 11.899115302000041],
            ],
          ],
          [
            [
              [-66.74998938699991, 11.77757396000004],
              [-66.73582923099991, 11.78310781500005],
              [-66.72850501199991, 11.783596096000053],
              [-66.72801673099991, 11.782049872000073],
              [-66.77521725199995, 11.76276276200008],
              [-66.77993730399993, 11.75853099200009],
              [-66.80842037699995, 11.751206773000092],
              [-66.81712805899991, 11.748968817000048],
              [-66.82778886599993, 11.746242580000057],
              [-66.85106360599991, 11.747015692000048],
              [-66.85460364499994, 11.751369533000059],
              [-66.83315995999993, 11.74909088700008],
              [-66.81818600199995, 11.75104401200008],
              [-66.81309973899994, 11.75226471600007],
              [-66.80955969999991, 11.752956447000088],
              [-66.74998938699991, 11.77757396000004],
            ],
          ],
          [
            [
              [-66.73338782499991, 11.869940497000073],
              [-66.71605383999992, 11.870591539000088],
              [-66.71178137899994, 11.86790599200009],
              [-66.73704993399991, 11.865301825000074],
              [-66.74058997299994, 11.86587148600006],
              [-66.75381425699993, 11.86237213700008],
              [-66.77106686099995, 11.86587148600006],
              [-66.78042558499993, 11.86587148600006],
              [-66.78709876199991, 11.868353583000044],
              [-66.81786048099991, 11.87107982000009],
              [-66.81480872299994, 11.873236395000049],
              [-66.73338782499991, 11.869940497000073],
            ],
          ],
          [
            [
              [-67.65802975199995, 11.984930731000077],
              [-67.64899654899995, 11.983954169000071],
              [-67.63760331899994, 11.980047919000071],
              [-67.64622962099992, 11.978664455000057],
              [-67.66588294199994, 11.982001044000071],
              [-67.67365475199995, 11.98533763200004],
              [-67.67487545499995, 11.989650783000059],
              [-67.67198645699995, 11.993109442000048],
              [-67.66714433499993, 11.991766669000071],
              [-67.66266842399995, 11.987534898000092],
              [-67.65802975199995, 11.984930731000077],
            ],
          ],
          [
            [
              [-67.68040930899991, 12.025051174000055],
              [-67.68154863199993, 12.025783596000053],
              [-67.67906653599994, 12.028143622000073],
              [-67.68040930899991, 12.025051174000055],
            ],
          ],
          [
            [
              [-67.67760169199994, 12.027818101000037],
              [-67.67723548099991, 12.03001536700009],
              [-67.67638098899994, 12.027818101000037],
              [-67.67666581899994, 12.026922919000071],
              [-67.67760169199994, 12.027818101000037],
            ],
          ],
          [
            [
              [-67.67723548099991, 12.05023834800005],
              [-67.67467200399994, 12.048407294000071],
              [-67.67609615799995, 12.044419664000088],
              [-67.67699133999992, 12.04633209800005],
              [-67.67723548099991, 12.05023834800005],
            ],
          ],
          [
            [
              [-67.68138587099992, 12.063706773000092],
              [-67.68101966099994, 12.061835028000075],
              [-67.68443762899994, 12.06346263200004],
              [-67.68138587099992, 12.063706773000092],
            ],
          ],
          [
            [
              [-67.68732662699995, 12.065578518000052],
              [-67.68883216099994, 12.06899648600006],
              [-67.68708248599995, 12.067531643000052],
              [-67.68732662699995, 12.065578518000052],
            ],
          ],
          [
            [
              [-63.639881964999915, 15.69603099200009],
              [-63.64362545499995, 15.700588283000059],
              [-63.63963782499991, 15.702948309000078],
              [-63.63459225199995, 15.700588283000059],
              [-63.63394120999993, 15.696193752000056],
              [-63.63548743399991, 15.694037177000041],
              [-63.639881964999915, 15.69603099200009],
            ],
          ],
          [
            [
              [-61.390271415999905, 8.580580853000072],
              [-61.36986396599991, 8.571331386000054],
              [-61.34435088399994, 8.57300921600006],
              [-61.314602598999954, 8.571314151000081],
              [-61.30526326899991, 8.552818554000055],
              [-61.30442238299992, 8.536009002000071],
              [-61.302737306999916, 8.514990475000047],
              [-61.29084843299995, 8.502370953000081],
              [-61.27640426399995, 8.496478163000063],
              [-61.2602641119999, 8.486377083000093],
              [-61.259425508999925, 8.472074035000048],
              [-61.26368803799994, 8.456088496000064],
              [-61.276442879999934, 8.450201880000066],
              [-61.29343794399995, 8.456939487000056],
              [-61.317223413999955, 8.475457410000047],
              [-61.32570680899994, 8.494808830000068],
              [-61.33844429599992, 8.50995247700007],
              [-61.36563463099992, 8.509972194000056],
              [-61.40050395199995, 8.50828382800006],
              [-61.4336875919999, 8.514154007000059],
              [-61.45412019199995, 8.530957661000059],
              [-61.46858495899994, 8.541046091000055],
              [-61.48986341199992, 8.551132446000054],
              [-61.50859634699992, 8.552807635000079],
              [-61.54011635099994, 8.565410528000086],
              [-61.535847478999926, 8.575509178000061],
              [-61.515397281999924, 8.572994857000083],
              [-61.47623033199994, 8.56711839400009],
              [-61.438769420999904, 8.568810347000067],
              [-61.41578787199995, 8.58226482100008],
              [-61.390271415999905, 8.580580853000072],
            ],
          ],
          [
            [
              [-60.745023913999944, 8.719358815000078],
              [-60.727162181999915, 8.721844549000082],
              [-60.71438111099991, 8.73442493500005],
              [-60.69735372899993, 8.744474456000091],
              [-60.683719728999904, 8.757891580000091],
              [-60.676055937999934, 8.762917274000074],
              [-60.67181168199994, 8.75954695300004],
              [-60.67693730399992, 8.748633526000049],
              [-60.68718168399994, 8.73016589000008],
              [-60.687225294999905, 8.709995234000075],
              [-60.67875695899994, 8.693167068000037],
              [-60.66602201399991, 8.68641794000007],
              [-60.635410985999954, 8.68718918400009],
              [-60.61161087799991, 8.683771178000086],
              [-60.60484456899991, 8.671150497000042],
              [-60.608288530999914, 8.654354408000074],
              [-60.61767711099992, 8.636722733000056],
              [-60.632135116999905, 8.633391557000039],
              [-60.65083410999995, 8.634270601000082],
              [-60.673771536999936, 8.641887719000067],
              [-60.69417239099994, 8.642770614000085],
              [-60.71373770999992, 8.637763759000052],
              [-60.735844810999936, 8.636966033000078],
              [-60.75710067299991, 8.637844547000043],
              [-60.77157084999993, 8.63114407800009],
              [-60.790279934999944, 8.631175717000076],
              [-60.80813447999992, 8.632888276000074],
              [-60.809813764999944, 8.642141443000071],
              [-60.79787763199994, 8.656413876000045],
              [-60.78678239899995, 8.674889663000044],
              [-60.77312928899994, 8.696720227000071],
              [-60.760332588999916, 8.717707751000091],
              [-60.745023913999944, 8.719358815000078],
            ],
          ],
          [
            [
              [-60.9513611509999, 8.827825132000044],
              [-60.904834799999946, 8.833714344000043],
              [-60.883289077999905, 8.84048914300007],
              [-60.872061034999945, 8.857493833000092],
              [-60.86169945599994, 8.87024514400008],
              [-60.8315409569999, 8.870194079000044],
              [-60.77810632899991, 8.870097702000066],
              [-60.75652808099994, 8.88282868500005],
              [-60.73236547899995, 8.892149504000088],
              [-60.72808456599995, 8.878516473000047],
              [-60.737598057999946, 8.86661349800005],
              [-60.73158261799995, 8.858086618000073],
              [-60.717794829999946, 8.852949484000078],
              [-60.71352477699992, 8.835058079000078],
              [-60.71096389199994, 8.823980968000058],
              [-60.6980484959999, 8.811179049000089],
              [-60.68604288599994, 8.789014680000037],
              [-60.6989941679999, 8.777972864000049],
              [-60.724022231999925, 8.762701467000056],
              [-60.74816269199994, 8.760202839000044],
              [-60.76973496699992, 8.741511392000064],
              [-60.783567476999906, 8.715139664000048],
              [-60.799111911999944, 8.693879172000038],
              [-60.806895744999906, 8.672588730000086],
              [-60.827604289999954, 8.651323661000049],
              [-60.84657600499992, 8.63771526000005],
              [-60.88448476499991, 8.635226289000059],
              [-60.920658458999924, 8.639546060000043],
              [-60.9473720499999, 8.63447094500009],
              [-60.96891464599992, 8.629395142000078],
              [-61.003353664999906, 8.639670676000037],
              [-61.0542071939999, 8.638842688000068],
              [-61.09387413799993, 8.63374413300005],
              [-61.11201351999995, 8.623504618000084],
              [-61.130166165999924, 8.60984708500007],
              [-61.14227043199992, 8.602158043000088],
              [-61.15264592799991, 8.596175548000076],
              [-61.16991475099991, 8.595313593000071],
              [-61.17679995199995, 8.603848377000077],
              [-61.174165614999936, 8.624329849000048],
              [-61.17154765899994, 8.637980656000082],
              [-61.16976975999995, 8.663570018000087],
              [-61.16710822099992, 8.699385415000052],
              [-61.15498147599993, 8.722399798000083],
              [-61.12643995399992, 8.75647809800006],
              [-61.09534312499994, 8.77946074600004],
              [-61.05996897299991, 8.798163462000048],
              [-61.03151540399995, 8.80834937800006],
              [-60.997029434999945, 8.821077896000077],
              [-60.973764236999955, 8.824451649000082],
              [-60.9513611509999, 8.827825132000044],
            ],
          ],
          [
            [
              [-62.33112545499995, 9.92055898600006],
              [-62.32274329299992, 9.91006094000005],
              [-62.316395636999914, 9.885646877000056],
              [-62.32005774599992, 9.862250067000048],
              [-62.32575436099995, 9.844183661000045],
              [-62.33861243399991, 9.84568919500009],
              [-62.34935462099992, 9.872300523000092],
              [-62.3509008449999, 9.897365627000056],
              [-62.34878495999993, 9.913723049000055],
              [-62.34337317599994, 9.924221096000053],
              [-62.33535722599993, 9.923570054000038],
              [-62.33112545499995, 9.92055898600006],
            ],
          ],
          [
            [
              [-62.40330969999991, 10.006293036000045],
              [-62.39761308499993, 10.003851630000042],
              [-62.39110266799992, 9.993353583000044],
              [-62.39606686099995, 9.978094794000071],
              [-62.40892493399991, 9.97256094000005],
              [-62.42052161399994, 9.98265208500004],
              [-62.42756100199995, 10.000392971000053],
              [-62.435658331999946, 10.03318919500009],
              [-62.43618730399993, 10.046576239000046],
              [-62.42686926999994, 10.049221096000053],
              [-62.41563880099994, 10.035101630000042],
              [-62.40330969999991, 10.006293036000045],
            ],
          ],
          [
            [
              [-62.24083411399994, 10.05149974200009],
              [-62.23570716099994, 10.044256903000075],
              [-62.23062089799993, 10.028143622000073],
              [-62.23534094999991, 10.013861395000049],
              [-62.24518795499995, 10.003607489000046],
              [-62.257923956999946, 9.994289455000057],
              [-62.27391516799992, 9.989935614000046],
              [-62.2884008449999, 9.988023179000038],
              [-62.29800370999993, 9.983710028000075],
              [-62.29857337099992, 9.996649481000077],
              [-62.286366339999915, 10.02440013200004],
              [-62.267567511999914, 10.04490794500009],
              [-62.24937903599994, 10.052069403000075],
              [-62.24083411399994, 10.05149974200009],
            ],
          ],
          [
            [
              [-62.66515051999994, 10.366359768000052],
              [-62.658273891999954, 10.360174872000073],
              [-62.64940344999991, 10.344916083000044],
              [-62.65099036399994, 10.325873114000046],
              [-62.659820115999935, 10.31000397300005],
              [-62.66559811099995, 10.31000397300005],
              [-62.66584225199995, 10.321600653000075],
              [-62.66954505099994, 10.33112213700008],
              [-62.68594316299993, 10.345770575000074],
              [-62.69286048099991, 10.35455963700008],
              [-62.71031653599994, 10.372015692000048],
              [-62.74103756399995, 10.394924221000053],
              [-62.76968339799993, 10.411607164000088],
              [-62.78758704299992, 10.430121161000045],
              [-62.793080206999946, 10.447943427000041],
              [-62.791574673999946, 10.466131903000075],
              [-62.79019120999993, 10.47264232000009],
              [-62.78620357999995, 10.485174872000073],
              [-62.78111731699994, 10.49290599200009],
              [-62.77696692599994, 10.492621161000045],
              [-62.74718176999994, 10.460272528000075],
              [-62.72252356699994, 10.427801825000074],
              [-62.66515051999994, 10.366359768000052],
            ],
          ],
          [
            [
              [-64.16860917899993, 10.827948309000078],
              [-64.15953528599994, 10.824896552000041],
              [-64.15587317599994, 10.81195709800005],
              [-64.17479407499991, 10.799221096000053],
              [-64.20181230399993, 10.797064520000049],
              [-64.22093665299991, 10.806463934000078],
              [-64.21825110599991, 10.82103099200009],
              [-64.20343990799995, 10.827297268000052],
              [-64.19029700399994, 10.82811107000009],
              [-64.17218990799995, 10.82680898600006],
              [-64.16860917899993, 10.827948309000078],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Southern Patagonian Ice Field',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-73.4650976159999, -49.759959004999935],
            [-73.49261531599987, -49.727816264],
            [-73.49626512648797, -49.72534201500291],
            [-73.5247838949999, -49.70600880999988],
            [-73.5395116789999, -49.69267628899986],
            [-73.54638464399997, -49.67675994899993],
            [-73.54072607499995, -49.65950001999994],
            [-73.52809118699992, -49.644410501999936],
            [-73.51819514999991, -49.628494160999914],
            [-73.52111486899992, -49.60896046999991],
            [-73.53294877199994, -49.59397430499993],
            [-73.56219763199988, -49.5717534379999],
            [-73.57555598999991, -49.559247741999904],
            [-73.58803584899991, -49.54054087299992],
            [-73.5865889079999, -49.52999888099995],
            [-73.55594478399988, -49.50808807299999],
            [-73.54258642699995, -49.49103485099996],
            [-73.54434342499994, -49.477598978999914],
            [-73.55072546499986, -49.46323292999991],
            [-73.55113887599987, -49.444009296999894],
            [-73.54044185499987, -49.42778289799988],
            [-73.52227758799992, -49.41672414199988],
            [-73.48380448499998, -49.400704446999924],
            [-73.46672542399995, -49.387578632999954],
            [-73.46204870599988, -49.37496958399993],
            [-73.47047196499994, -49.34220672599993],
            [-73.47111791999993, -49.31719533299993],
            [-73.45786291499994, -49.307686868999944],
            [-73.14501379499993, -49.30365610799995],
            [-73.14129309199993, -49.28556935599994],
            [-73.13064774599991, -49.27874806699989],
            [-73.09824662299991, -49.272753600999955],
            [-73.10892593437559, -49.31051813919908],
            [-73.11865150724658, -49.39242714177951],
            [-73.08433530448258, -49.42261495378312],
            [-73.05742351085179, -49.475919864136046],
            [-73.05974467458955, -49.5549707924146],
            [-73.13351656426859, -49.62101455329142],
            [-73.1967496125649, -49.682423211773184],
            [-73.4650976159999, -49.759959004999935],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Falkland Is.',
        iso3: 'FLK',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-59.69444739499994, -52.208103122999944],
              [-59.67686926999994, -52.21559010199991],
              [-59.67918860599991, -52.22926197699991],
              [-59.69326738199993, -52.242445570999905],
              [-59.71125240799995, -52.248304945999905],
              [-59.71971594999991, -52.24968840899993],
              [-59.72996985599991, -52.25335051899992],
              [-59.73859615799995, -52.258884372999944],
              [-59.74669348899994, -52.27402109199994],
              [-59.75601152299993, -52.27361419099992],
              [-59.764230923999946, -52.26637135199991],
              [-59.76500403599994, -52.25432708099993],
              [-59.76549231699994, -52.25269947699991],
              [-59.76634680899991, -52.25123463299991],
              [-59.767567511999914, -52.2497697899999],
              [-59.769520636999914, -52.248304945999905],
              [-59.758697068999936, -52.24081796699994],
              [-59.74950110599991, -52.22779713299991],
              [-59.744984503999945, -52.21152109199994],
              [-59.74840247299994, -52.19378020599993],
              [-59.760975714999915, -52.18092213299991],
              [-59.777007615999935, -52.174493096999925],
              [-59.791005011999914, -52.166680596999925],
              [-59.796864386999914, -52.149509372999944],
              [-59.79214433499993, -52.13054778399993],
              [-59.781809048999946, -52.13876718499995],
              [-59.76585852799991, -52.16643645599993],
              [-59.71654212099992, -52.16301848799992],
              [-59.69517981699994, -52.166273695999905],
              [-59.68016516799992, -52.1794572899999],
              [-59.684803839999915, -52.184258721999925],
              [-59.68887285099993, -52.19109465899993],
              [-59.692250128999945, -52.199151299999926],
              [-59.69444739499994, -52.208103122999944],
            ],
          ],
          [
            [
              [-61.19399980399993, -51.817071221999925],
              [-61.20498613199993, -51.81926848799992],
              [-61.23497473899994, -51.83131275799991],
              [-61.23497473899994, -51.83749765399995],
              [-61.22565670499995, -51.840915622999944],
              [-61.21556555899991, -51.84189218499995],
              [-61.20494544199994, -51.84059010199991],
              [-61.19399980399993, -51.83749765399995],
              [-61.21751868399991, -51.86207447699991],
              [-61.25226803299995, -51.861993096999925],
              [-61.28880774599992, -51.846368096999925],
              [-61.31818600199995, -51.824476820999905],
              [-61.31330318899995, -51.821384372999944],
              [-61.30833899599992, -51.81926848799992],
              [-61.29767818899995, -51.817071221999925],
              [-61.288726365999935, -51.81975676899992],
              [-61.26732337099992, -51.82366301899992],
              [-61.25064042899993, -51.8337541649999],
              [-61.246083136999914, -51.82968515399995],
              [-61.24242102799991, -51.817071221999925],
              [-61.239165818999936, -51.81218840899993],
              [-61.237212693999936, -51.805352471999925],
              [-61.23289954299992, -51.799086195999905],
              [-61.22227942599994, -51.79656340899993],
              [-61.21353105399993, -51.797946872999944],
              [-61.20616614499994, -51.80193450299993],
              [-61.19969641799992, -51.808526299999926],
              [-61.19399980399993, -51.817071221999925],
            ],
          ],
          [
            [
              [-60.94762122299994, -51.94736093499995],
              [-60.97642981699994, -51.953383070999905],
              [-60.99669348899994, -51.95273202899995],
              [-61.043812628999945, -51.94060637799993],
              [-61.03954016799992, -51.93059661299992],
              [-61.03697669199994, -51.92693450299993],
              [-61.051340298999946, -51.92669036299992],
              [-61.05760657499991, -51.92034270599993],
              [-61.060536261999914, -51.91220468499995],
              [-61.06493079299992, -51.90642669099992],
              [-61.07481848899994, -51.90390390399995],
              [-61.09593665299991, -51.90252044099992],
              [-61.10586503799993, -51.89959075299993],
              [-61.109486456999946, -51.897149346999925],
              [-61.11180579299992, -51.89462655999995],
              [-61.11461341099994, -51.89275481599992],
              [-61.11953691299993, -51.89275481599992],
              [-61.11180579299992, -51.87078215899993],
              [-61.11864173099991, -51.856540622999944],
              [-61.13434811099995, -51.848321221999925],
              [-61.15306555899991, -51.84490325299993],
              [-61.135650193999936, -51.83171965899993],
              [-61.12189693899995, -51.82586028399993],
              [-61.10594641799992, -51.82431405999995],
              [-61.06525631399995, -51.82480234199994],
              [-61.059478318999936, -51.82390715899993],
              [-61.04723059799994, -51.80706145599993],
              [-61.02839107999995, -51.78850676899992],
              [-61.01667232999995, -51.781182549999926],
              [-61.00226803299995, -51.77662525799991],
              [-60.99767005099994, -51.776055596999925],
              [-60.986887173999946, -51.776055596999925],
              [-60.98232988199993, -51.77662525799991],
              [-60.974598761999914, -51.78004322699991],
              [-60.97183183499993, -51.783868096999925],
              [-60.97093665299991, -51.78728606599992],
              [-60.96865800699993, -51.789727471999925],
              [-60.94839433499993, -51.79607512799993],
              [-60.93980872299994, -51.803399346999925],
              [-60.944203253999945, -51.81389739399992],
              [-60.96312415299991, -51.82390715899993],
              [-61.01219641799992, -51.8415666649999],
              [-61.030181443999936, -51.85857512799993],
              [-61.03262285099993, -51.86687590899993],
              [-61.027455206999946, -51.86923593499995],
              [-60.95494544199994, -51.853773695999905],
              [-60.92454993399991, -51.83652109199994],
              [-60.904855923999946, -51.82968515399995],
              [-60.88853919199994, -51.81926848799992],
              [-60.87930253799993, -51.79656340899993],
              [-60.883656378999945, -51.78826262799993],
              [-60.89329993399991, -51.785088799999926],
              [-60.89793860599991, -51.78085702899995],
              [-60.886789516999954, -51.76921965899993],
              [-60.87401282499991, -51.76189544099992],
              [-60.86286373599995, -51.76091887799993],
              [-60.85505123599995, -51.766696872999944],
              [-60.85204016799992, -51.77988046699994],
              [-60.85391191299993, -51.78875090899993],
              [-60.85855058499993, -51.79892343499995],
              [-60.86432857999995, -51.80803801899992],
              [-60.86937415299991, -51.81389739399992],
              [-60.874989386999914, -51.82301197699991],
              [-60.87710527299993, -51.847588799999926],
              [-60.87930253799993, -51.85857512799993],
              [-60.885650193999936, -51.87037525799991],
              [-60.90729732999995, -51.89959075299993],
              [-60.86571204299992, -51.89959075299993],
              [-60.873605923999946, -51.90878671699994],
              [-60.88060462099992, -51.92701588299991],
              [-60.886789516999954, -51.93434010199991],
              [-60.90078691299993, -51.94060637799993],
              [-60.94762122299994, -51.94736093499995],
            ],
          ],
          [
            [
              [-61.270375128999945, -51.68043385199991],
              [-61.24885006399995, -51.68010833099993],
              [-61.212961391999954, -51.69085051899992],
              [-61.19399980399993, -51.69353606599992],
              [-61.21117102799991, -51.699883721999925],
              [-61.25047766799992, -51.698337497999944],
              [-61.26667232999995, -51.70403411299992],
              [-61.274322068999936, -51.71404387799993],
              [-61.277333136999914, -51.725681247999944],
              [-61.27721106699994, -51.75554778399993],
              [-61.28954016799992, -51.75253671699994],
              [-61.30211341099994, -51.74765390399995],
              [-61.31240800699993, -51.73992278399993],
              [-61.31818600199995, -51.72820403399993],
              [-61.31200110599991, -51.70826588299991],
              [-61.304351365999935, -51.69491952899995],
              [-61.29181881399995, -51.686211846999925],
              [-61.270375128999945, -51.68043385199991],
            ],
          ],
          [
            [
              [-59.63239498599995, -51.741306247999944],
              [-59.65953528599994, -51.761651299999926],
              [-59.72565670499995, -51.79924895599993],
              [-59.8313695949999, -51.89495208099993],
              [-59.85147050699993, -51.92066822699991],
              [-59.86095130099994, -51.936211846999925],
              [-59.87173417899993, -51.9489885399999],
              [-59.88703365799995, -51.95777760199991],
              [-59.93106035099993, -51.96502044099992],
              [-59.99486243399991, -51.99456145599993],
              [-60.002512173999946, -51.96526458099993],
              [-60.00572669199994, -51.96103280999995],
              [-60.030913865999935, -51.95867278399993],
              [-60.04430091099994, -51.95566171699994],
              [-60.0501195949999, -51.951104424999926],
              [-60.054351365999935, -51.94019947699991],
              [-60.06419837099992, -51.94060637799993],
              [-60.07461503799993, -51.945977471999925],
              [-60.08088131399995, -51.951104424999926],
              [-60.08315995999993, -51.96152109199994],
              [-60.07127844999991, -51.98202890399995],
              [-60.07404537699995, -51.99146900799991],
              [-60.09410559799994, -51.998711846999925],
              [-60.18040930899991, -51.99456145599993],
              [-60.20360266799992, -52.00269947699991],
              [-60.21544348899994, -52.00359465899993],
              [-60.22142493399991, -51.99456145599993],
              [-60.2180883449999, -51.988539320999905],
              [-60.200103318999936, -51.97665780999995],
              [-60.19408118399991, -51.96843840899993],
              [-60.259877081999946, -51.985446872999944],
              [-60.27603105399993, -51.99456145599993],
              [-60.28652910099993, -52.012790622999944],
              [-60.28066972599993, -52.02809010199991],
              [-60.269195115999935, -52.044854424999926],
              [-60.2630102199999, -52.06715260199991],
              [-60.268137173999946, -52.08212655999995],
              [-60.28034420499995, -52.09449635199991],
              [-60.36042232999995, -52.15357838299991],
              [-60.37222245999993, -52.15960051899992],
              [-60.39427649599992, -52.15878671699994],
              [-60.42536373599995, -52.144789320999905],
              [-60.447336391999954, -52.14592864399992],
              [-60.44322669199994, -52.14739348799992],
              [-60.44188391799992, -52.152601820999905],
              [-60.44253495999993, -52.158868096999925],
              [-60.444243943999936, -52.16301848799992],
              [-60.45103919199994, -52.16562265399995],
              [-60.457915818999936, -52.16155364399992],
              [-60.46475175699993, -52.15585702899995],
              [-60.48143469999991, -52.14853280999995],
              [-60.500111456999946, -52.12981536299992],
              [-60.505970831999946, -52.12558359199994],
              [-60.517567511999914, -52.12273528399993],
              [-60.537098761999914, -52.111993096999925],
              [-60.55036373599995, -52.11191171699994],
              [-60.55654863199993, -52.11614348799992],
              [-60.55833899599992, -52.122979424999926],
              [-60.55528723899994, -52.12948984199994],
              [-60.52839107999995, -52.13787200299993],
              [-60.51317298099991, -52.15162525799991],
              [-60.50218665299991, -52.16936614399992],
              [-60.495757615999935, -52.18694426899992],
              [-60.53661048099991, -52.217054945999905],
              [-60.59276282499991, -52.23674895599993],
              [-60.64671790299991, -52.233086846999925],
              [-60.681304490999935, -52.19378020599993],
              [-60.66832434799994, -52.19459400799991],
              [-60.65851803299995, -52.19687265399995],
              [-60.64956620999993, -52.197523695999905],
              [-60.63906816299993, -52.19378020599993],
              [-60.657866990999935, -52.18482838299991],
              [-60.682525193999936, -52.16757577899995],
              [-60.70449785099993, -52.14812590899993],
              [-60.714833136999914, -52.13241952899995],
              [-60.70726477799991, -52.12932708099993],
              [-60.69399980399993, -52.11956145599993],
              [-60.68858801999994, -52.1091447899999],
              [-60.70425370999993, -52.10442473799992],
              [-60.80492102799991, -52.10173919099992],
              [-60.81786048099991, -52.10442473799992],
              [-60.82607988199993, -52.11174895599993],
              [-60.82013912699995, -52.11598072699991],
              [-60.80711829299992, -52.11809661299992],
              [-60.79430091099994, -52.11874765399995],
              [-60.77407792899993, -52.1247697899999],
              [-60.75145423099991, -52.139743747999944],
              [-60.73224850199995, -52.15789153399993],
              [-60.72227942599994, -52.17392343499995],
              [-60.78034420499995, -52.17392343499995],
              [-60.79678300699993, -52.17205169099992],
              [-60.80504309799994, -52.16725025799991],
              [-60.810210740999935, -52.160414320999905],
              [-60.855458136999914, -52.122165622999944],
              [-60.867298956999946, -52.115166924999926],
              [-60.88023841099994, -52.11386484199994],
              [-60.893788214999915, -52.11419036299992],
              [-60.90729732999995, -52.11191171699994],
              [-60.92491614499994, -52.1013322899999],
              [-60.957590298999946, -52.07301197699991],
              [-60.97557532499991, -52.06406015399995],
              [-61.021595831999946, -52.05754973799992],
              [-61.03693600199995, -52.04656340899993],
              [-61.030181443999936, -52.022556247999944],
              [-61.01976477799991, -52.01246510199991],
              [-60.994699673999946, -52.015883070999905],
              [-60.94078528599994, -52.029961846999925],
              [-60.89720618399991, -52.031914971999925],
              [-60.886789516999954, -52.036228122999944],
              [-60.88239498599995, -52.045993747999944],
              [-60.882883266999954, -52.057305596999925],
              [-60.87832597599993, -52.06519947699991],
              [-60.85887610599991, -52.06406015399995],
              [-60.873158331999946, -52.029961846999925],
              [-60.80549068899995, -52.02434661299992],
              [-60.742176886999914, -52.008884372999944],
              [-60.742176886999914, -52.00204843499995],
              [-60.773996548999946, -51.99081796699994],
              [-60.80101477799991, -51.98772551899992],
              [-60.82437089799993, -51.97991301899992],
              [-60.84520423099991, -51.95476653399993],
              [-60.75841223899994, -51.95427825299993],
              [-60.712961391999954, -51.96135833099993],
              [-60.69440670499995, -51.98211028399993],
              [-60.687570766999954, -51.98211028399993],
              [-60.683664516999954, -51.97478606599992],
              [-60.67951412699995, -51.97014739399992],
              [-60.66706295499995, -51.96103280999995],
              [-60.66539466099994, -51.971368096999925],
              [-60.660267706999946, -51.98015715899993],
              [-60.652455206999946, -51.98381926899992],
              [-60.642567511999914, -51.97869231599992],
              [-60.63219153599994, -51.971774997999944],
              [-60.62254798099991, -51.97128671699994],
              [-60.61192786399994, -51.973728122999944],
              [-60.584055141999954, -51.97665780999995],
              [-60.57380123599995, -51.97991301899992],
              [-60.557199673999946, -51.98837655999995],
              [-60.54063880099994, -51.99968840899993],
              [-60.53205318899995, -51.999932549999926],
              [-60.52306067599994, -51.98837655999995],
              [-60.53673255099994, -51.98211028399993],
              [-60.53673255099994, -51.975274346999925],
              [-60.51130123599995, -51.975681247999944],
              [-60.48302161399994, -51.97226327899995],
              [-60.45604407499991, -51.965101820999905],
              [-60.43431555899991, -51.95476653399993],
              [-60.40843665299991, -51.92522551899992],
              [-60.40294348899994, -51.92066822699991],
              [-60.39989173099991, -51.91659921699994],
              [-60.405506964999915, -51.90878671699994],
              [-60.41665605399993, -51.904229424999926],
              [-60.430572068999936, -51.90984465899993],
              [-60.466786261999914, -51.93043385199991],
              [-60.51471920499995, -51.94182708099993],
              [-60.56432044199994, -51.9411760399999],
              [-60.605580206999946, -51.92693450299993],
              [-60.52619381399995, -51.93027109199994],
              [-60.505970831999946, -51.923760674999926],
              [-60.49864661399994, -51.92050546699994],
              [-60.47923743399991, -51.91521575299993],
              [-60.47524980399993, -51.90984465899993],
              [-60.47203528599994, -51.90081145599993],
              [-60.46442623599995, -51.89177825299993],
              [-60.455189581999946, -51.88404713299991],
              [-60.447336391999954, -51.87908294099992],
              [-60.45665442599994, -51.86728280999995],
              [-60.455637173999946, -51.85947030999995],
              [-60.450428839999915, -51.85295989399992],
              [-60.447336391999954, -51.84490325299993],
              [-60.4485570949999, -51.83538176899992],
              [-60.453684048999946, -51.81365325299993],
              [-60.454741990999935, -51.79998137799993],
              [-60.44448808499993, -51.78289153399993],
              [-60.42031816299993, -51.77044036299992],
              [-60.39289303299995, -51.76531340899993],
              [-60.37222245999993, -51.76921965899993],
              [-60.37995357999995, -51.777601820999905],
              [-60.388335740999935, -51.7849260399999],
              [-60.406361456999946, -51.79656340899993],
              [-60.37572180899991, -51.79192473799992],
              [-60.36310787699995, -51.79192473799992],
              [-60.357980923999946, -51.79998137799993],
              [-60.36070716099994, -51.80934010199991],
              [-60.37970943899995, -51.83749765399995],
              [-60.36799068899995, -51.84221770599993],
              [-60.338734503999945, -51.85857512799993],
              [-60.3372289699999, -51.84238046699994],
              [-60.329335089999915, -51.830010674999926],
              [-60.31582597599993, -51.82341887799993],
              [-60.29710852799991, -51.824476820999905],
              [-60.30899003799993, -51.80974700299993],
              [-60.31265214799993, -51.79827239399992],
              [-60.31078040299991, -51.76580169099992],
              [-60.30699622299994, -51.75644296699994],
              [-60.297759568999936, -51.75042083099993],
              [-60.286366339999915, -51.747979424999926],
              [-60.27603105399993, -51.748711846999925],
              [-60.26943925699993, -51.75335051899992],
              [-60.26231848899994, -51.7693010399999],
              [-60.25617428299995, -51.77662525799991],
              [-60.2493383449999, -51.77556731599992],
              [-60.240223761999914, -51.77076588299991],
              [-60.23228919199994, -51.76970794099992],
              [-60.22887122299994, -51.77988046699994],
              [-60.22451738199993, -51.78248463299991],
              [-60.21471106699994, -51.77849700299993],
              [-60.18407141799992, -51.76116301899992],
              [-60.18122311099995, -51.74277109199994],
              [-60.18236243399991, -51.72185637799993],
              [-60.18040930899991, -51.70720794099992],
              [-60.20718339799993, -51.70134856599992],
              [-60.23184160099993, -51.70468515399995],
              [-60.25568600199995, -51.71111419099992],
              [-60.27977454299992, -51.7146135399999],
              [-60.338449673999946, -51.70916106599992],
              [-60.36400305899991, -51.71412525799991],
              [-60.357980923999946, -51.735039971999925],
              [-60.36595618399991, -51.74651458099993],
              [-60.37328040299991, -51.74651458099993],
              [-60.381703253999945, -51.74236419099992],
              [-60.392689581999946, -51.741306247999944],
              [-60.437570766999954, -51.7595354149999],
              [-60.45103919199994, -51.762383721999925],
              [-60.496083136999914, -51.762383721999925],
              [-60.51016191299993, -51.765883070999905],
              [-60.51773027299993, -51.774102471999925],
              [-60.52306067599994, -51.783135674999926],
              [-60.530506964999915, -51.789727471999925],
              [-60.55064856699994, -51.78980885199991],
              [-60.56090247299994, -51.77499765399995],
              [-60.570383266999954, -51.75725676899992],
              [-60.58824622299994, -51.748711846999925],
              [-60.61017818899995, -51.74277109199994],
              [-60.628977016999954, -51.72747161299992],
              [-60.64012610599991, -51.707289320999905],
              [-60.63906816299993, -51.68670012799993],
              [-60.624989386999914, -51.66961028399993],
              [-60.60887610599991, -51.67148202899995],
              [-60.58999589799993, -51.68092213299991],
              [-60.49010169199994, -51.70037200299993],
              [-60.46157792899993, -51.7009416649999],
              [-60.43797766799992, -51.69426848799992],
              [-60.39199785099993, -51.6716447899999],
              [-60.368804490999935, -51.66676197699991],
              [-60.289947068999936, -51.671807549999926],
              [-60.219593878999945, -51.654229424999926],
              [-60.19884192599994, -51.65642669099992],
              [-60.15697180899991, -51.68279387799993],
              [-60.13312740799995, -51.68987395599993],
              [-60.077381964999915, -51.69353606599992],
              [-60.09194902299993, -51.67498137799993],
              [-60.11603756399995, -51.664727471999925],
              [-60.1438695949999, -51.66033294099992],
              [-60.169911261999914, -51.65935637799993],
              [-60.18980872299994, -51.65325286299992],
              [-60.24876868399991, -51.611586195999905],
              [-60.25938880099994, -51.607679945999905],
              [-60.27961178299995, -51.60279713299991],
              [-60.290272589999915, -51.59734465899993],
              [-60.317616339999915, -51.570570570999905],
              [-60.34357662699995, -51.56878020599993],
              [-60.49038652299993, -51.526462497999944],
              [-60.50255286399994, -51.51913827899995],
              [-60.51305091099994, -51.49846770599993],
              [-60.515288865999935, -51.48650481599992],
              [-60.505970831999946, -51.48121510199991],
              [-60.447336391999954, -51.48121510199991],
              [-60.39924068899995, -51.48919036299992],
              [-60.388783331999946, -51.48447030999995],
              [-60.40294348899994, -51.46412525799991],
              [-60.423491990999935, -51.45061614399992],
              [-60.450103318999936, -51.44150155999995],
              [-60.47801673099991, -51.43572356599992],
              [-60.51610266799992, -51.43254973799992],
              [-60.54377193899995, -51.43401458099993],
              [-60.557199673999946, -51.43279387799993],
              [-60.58853105399993, -51.42148202899995],
              [-60.60216223899994, -51.4196916649999],
              [-60.61204993399991, -51.41741301899992],
              [-60.62319902299993, -51.41139088299991],
              [-60.63072669199994, -51.40357838299991],
              [-60.62950598899994, -51.39592864399992],
              [-60.625843878999945, -51.385023695999905],
              [-60.630970831999946, -51.372979424999926],
              [-60.64598548099991, -51.351495049999926],
              [-60.63467363199993, -51.352227471999925],
              [-60.624256964999915, -51.35165780999995],
              [-60.61461341099994, -51.34905364399992],
              [-60.605580206999946, -51.344008070999905],
              [-60.57266191299993, -51.35816822699991],
              [-60.46157792899993, -51.38567473799992],
              [-60.42674719999991, -51.399102471999925],
              [-60.32445227799991, -51.45330169099992],
              [-60.24290930899991, -51.47893645599993],
              [-60.15314693899995, -51.48748137799993],
              [-59.98863684799994, -51.46754322699991],
              [-60.01268469999991, -51.449883721999925],
              [-60.08360755099994, -51.445977471999925],
              [-60.07404537699995, -51.42327239399992],
              [-60.05308997299994, -51.40593840899993],
              [-60.02961178299995, -51.392510674999926],
              [-60.02403723899994, -51.37932708099993],
              [-60.01748613199993, -51.37517669099992],
              [-60.00572669199994, -51.38225676899992],
              [-60.002064581999946, -51.38836028399993],
              [-59.99486243399991, -51.41350676899992],
              [-59.934437628999945, -51.38176848799992],
              [-59.90147864499994, -51.3728166649999],
              [-59.871937628999945, -51.378838799999926],
              [-59.871937628999945, -51.38567473799992],
              [-59.87759355399993, -51.38884856599992],
              [-59.88044186099995, -51.39202239399992],
              [-59.88243567599994, -51.395603122999944],
              [-59.885609503999945, -51.39934661299992],
              [-59.79161536399994, -51.41057708099993],
              [-59.76207434799994, -51.4196916649999],
              [-59.777902798999946, -51.42457447699991],
              [-59.79478919199994, -51.42669036299992],
              [-59.83039303299995, -51.42669036299992],
              [-59.80182857999995, -51.4470354149999],
              [-59.74852454299992, -51.4470354149999],
              [-59.56037350199995, -51.4196916649999],
              [-59.54255123599995, -51.415134372999944],
              [-59.50885982999995, -51.39568450299993],
              [-59.488392706999946, -51.392510674999926],
              [-59.488392706999946, -51.39934661299992],
              [-59.55874589799993, -51.43132903399993],
              [-59.58458411399994, -51.43962981599992],
              [-59.53929602799991, -51.455743096999925],
              [-59.49132239499994, -51.45623137799993],
              [-59.39281165299991, -51.43279387799993],
              [-59.399647589999915, -51.42343515399995],
              [-59.41161048099991, -51.41480885199991],
              [-59.42536373599995, -51.408461195999905],
              [-59.437489386999914, -51.4060197899999],
              [-59.44395911399994, -51.400323174999926],
              [-59.444569464999915, -51.3708635399999],
              [-59.447377081999946, -51.35833098799992],
              [-59.43895423099991, -51.35898202899995],
              [-59.42162024599992, -51.35759856599992],
              [-59.41323808499993, -51.35833098799992],
              [-59.41510982999995, -51.353773695999905],
              [-59.417632615999935, -51.342461846999925],
              [-59.41950436099995, -51.337823174999926],
              [-59.40526282499991, -51.3376604149999],
              [-59.38707434799994, -51.340101820999905],
              [-59.37149003799993, -51.345635674999926],
              [-59.36485755099994, -51.35491301899992],
              [-59.35732988199993, -51.36142343499995],
              [-59.255970831999946, -51.387383721999925],
              [-59.229074673999946, -51.399102471999925],
              [-59.21401933499993, -51.41350676899992],
              [-59.25690670499995, -51.412041924999926],
              [-59.27448482999995, -51.41716887799993],
              [-59.282866990999935, -51.43279387799993],
              [-59.27916419199994, -51.44784921699994],
              [-59.26634680899991, -51.44841887799993],
              [-59.24986731699994, -51.44491952899995],
              [-59.23517818899995, -51.4470354149999],
              [-59.261830206999946, -51.456963799999926],
              [-59.30821692599994, -51.4900041649999],
              [-59.3313695949999, -51.5017229149999],
              [-59.338002081999946, -51.49065520599993],
              [-59.34845943899995, -51.48707447699991],
              [-59.360585089999915, -51.48919036299992],
              [-59.372303839999915, -51.49488697699991],
              [-59.372303839999915, -51.5017229149999],
              [-59.36864173099991, -51.50701262799993],
              [-59.36986243399991, -51.51287200299993],
              [-59.37852942599994, -51.52898528399993],
              [-59.37140865799995, -51.52629973799992],
              [-59.35057532499991, -51.52271900799991],
              [-59.35057532499991, -51.52898528399993],
              [-59.38223222599993, -51.556898695999905],
              [-59.38581295499995, -51.56324635199991],
              [-59.38906816299993, -51.59099700299993],
              [-59.396148240999935, -51.59734465899993],
              [-59.40851803299995, -51.601820570999905],
              [-59.43317623599995, -51.621351820999905],
              [-59.447377081999946, -51.62517669099992],
              [-59.45860755099994, -51.62118905999995],
              [-59.464100714999915, -51.61248137799993],
              [-59.464507615999935, -51.60165780999995],
              [-59.46043860599991, -51.59107838299991],
              [-59.49156653599994, -51.61443450299993],
              [-59.50861568899995, -51.62314218499995],
              [-59.52253170499995, -51.61834075299993],
              [-59.57713782499991, -51.65252044099992],
              [-59.54942786399994, -51.65113697699991],
              [-59.553578253999945, -51.662041924999926],
              [-59.588002081999946, -51.690118096999925],
              [-59.63239498599995, -51.741306247999944],
            ],
          ],
          [
            [
              [-59.899281378999945, -51.30364348799992],
              [-59.91380774599992, -51.30950286299992],
              [-59.92031816299993, -51.30999114399992],
              [-59.92031816299993, -51.317478122999944],
              [-59.90648352799991, -51.329196872999944],
              [-59.918039516999954, -51.338962497999944],
              [-59.94098873599995, -51.34449635199991],
              [-59.96133378799993, -51.344008070999905],
              [-59.98086503799993, -51.33635833099993],
              [-59.99819902299993, -51.32512786299992],
              [-60.01252193899995, -51.31145598799992],
              [-60.02281653599994, -51.29615650799991],
              [-59.97573808499993, -51.2868791649999],
              [-59.96031653599994, -51.28679778399993],
              [-59.94493567599994, -51.28948333099993],
              [-59.90587317599994, -51.303399346999925],
              [-59.899281378999945, -51.30364348799992],
            ],
          ],
          [
            [
              [-60.169911261999914, -51.392510674999926],
              [-60.24128170499995, -51.40113697699991],
              [-60.25609290299991, -51.39959075299993],
              [-60.27440344999991, -51.394463799999926],
              [-60.28868567599994, -51.38518645599993],
              [-60.29149329299992, -51.37167734199994],
              [-60.277455206999946, -51.357354424999926],
              [-60.25275631399995, -51.34905364399992],
              [-60.20466061099995, -51.344008070999905],
              [-60.19367428299995, -51.34840260199991],
              [-60.17345130099994, -51.36760833099993],
              [-60.16307532499991, -51.37200286299992],
              [-60.14830481699994, -51.37127044099992],
              [-60.13540605399993, -51.369073174999926],
              [-60.12344316299993, -51.36484140399995],
              [-60.11156165299991, -51.35833098799992],
              [-60.12970943899995, -51.34726327899995],
              [-60.18455969999991, -51.32756926899992],
              [-60.22297115799995, -51.31991952899995],
              [-60.26988684799994, -51.29827239399992],
              [-60.28351803299995, -51.28948333099993],
              [-60.29979407499991, -51.27499765399995],
              [-60.300892706999946, -51.268243096999925],
              [-60.290272589999915, -51.26213958099993],
              [-60.27391516799992, -51.26091887799993],
              [-60.2649633449999, -51.2673479149999],
              [-60.25914466099994, -51.277276299999926],
              [-60.25243079299992, -51.28630950299993],
              [-60.23180091099994, -51.29729583099993],
              [-60.20579993399991, -51.30291106599992],
              [-60.178293423999946, -51.30478280999995],
              [-60.15314693899995, -51.30364348799992],
              [-60.09919186099995, -51.295586846999925],
              [-60.074289516999954, -51.29998137799993],
              [-60.063710089999915, -51.32073333099993],
              [-60.05923417899993, -51.324883721999925],
              [-60.05150305899991, -51.33554452899995],
              [-60.04914303299995, -51.34644947699991],
              [-60.060658331999946, -51.351495049999926],
              [-60.098500128999945, -51.378838799999926],
              [-60.114165818999936, -51.40195077899995],
              [-60.11900794199994, -51.4060197899999],
              [-60.12938391799992, -51.40545012799993],
              [-60.15835527299993, -51.39511484199994],
              [-60.169911261999914, -51.392510674999926],
            ],
          ],
          [
            [
              [-57.81623287699995, -51.69353606599992],
              [-57.77643795499995, -51.684665622999944],
              [-57.75690670499995, -51.68303801899992],
              [-57.73428300699993, -51.68670012799993],
              [-57.73428300699993, -51.69353606599992],
              [-57.76235917899993, -51.69500090899993],
              [-57.863840298999946, -51.72625090899993],
              [-57.884429490999935, -51.72869231599992],
              [-57.95230058499993, -51.729587497999944],
              [-57.96556555899991, -51.73259856599992],
              [-57.96642005099994, -51.74032968499995],
              [-57.97911536399994, -51.74749114399992],
              [-57.99242102799991, -51.751071872999944],
              [-58.14439856699994, -51.76230234199994],
              [-58.22203528599994, -51.754571221999925],
              [-58.26130123599995, -51.75554778399993],
              [-58.26130123599995, -51.762383721999925],
              [-58.24901282499991, -51.763929945999905],
              [-58.214100714999915, -51.77662525799991],
              [-58.19762122299994, -51.780368747999944],
              [-58.14517167899993, -51.78289153399993],
              [-58.14517167899993, -51.789727471999925],
              [-58.17320716099994, -51.79509856599992],
              [-58.23216712099992, -51.7927385399999],
              [-58.26130123599995, -51.79656340899993],
              [-58.330637173999946, -51.82382577899995],
              [-58.357492641999954, -51.824476820999905],
              [-58.335926886999914, -51.83098723799992],
              [-58.315337693999936, -51.830010674999926],
              [-58.253163214999915, -51.81113046699994],
              [-58.18614661399994, -51.810804945999905],
              [-58.19985917899993, -51.8220354149999],
              [-58.22496497299994, -51.83318450299993],
              [-58.25226803299995, -51.8415666649999],
              [-58.295033331999946, -51.84929778399993],
              [-58.371164516999954, -51.87908294099992],
              [-58.41905676999994, -51.89218515399995],
              [-58.51121985599991, -51.88298919099992],
              [-58.56289628799993, -51.88534921699994],
              [-58.5989477199999, -51.89275481599992],
              [-58.757801886999914, -51.891289971999925],
              [-58.782093878999945, -51.88534921699994],
              [-58.81615149599992, -51.86541106599992],
              [-58.86241614499994, -51.854587497999944],
              [-58.88467363199993, -51.84254322699991],
              [-58.906239386999914, -51.83513762799993],
              [-58.91637122299994, -51.8278947899999],
              [-58.92137610599991, -51.819431247999944],
              [-58.925038214999915, -51.80917734199994],
              [-58.93040930899991, -51.8005510399999],
              [-58.940297003999945, -51.79656340899993],
              [-58.952788865999935, -51.80242278399993],
              [-58.963734503999945, -51.81650155999995],
              [-58.97150631399995, -51.83171965899993],
              [-58.97443600199995, -51.84124114399992],
              [-58.96910559799994, -51.853773695999905],
              [-58.955962693999936, -51.86598072699991],
              [-58.939116990999935, -51.87542083099993],
              [-58.892567511999914, -51.88437265399995],
              [-58.85216223899994, -51.897556247999944],
              [-58.81550045499995, -51.91529713299991],
              [-58.79629472599993, -51.93434010199991],
              [-58.81041419199994, -51.95191822699991],
              [-58.78416907499991, -51.95712655999995],
              [-58.727406378999945, -51.94736093499995],
              [-58.698475714999915, -51.94850025799991],
              [-58.660715298999946, -51.955010674999926],
              [-58.63231360599991, -51.96795012799993],
              [-58.63182532499991, -51.98837655999995],
              [-58.60448157499991, -52.00204843499995],
              [-58.65648352799991, -52.02402109199994],
              [-58.67284094999991, -52.036228122999944],
              [-58.66112219999991, -52.04314544099992],
              [-58.65387936099995, -52.05217864399992],
              [-58.649281378999945, -52.063571872999944],
              [-58.64077714799993, -52.09775155999995],
              [-58.64122473899994, -52.10784270599993],
              [-58.64891516799992, -52.11142343499995],
              [-58.66592363199993, -52.11191171699994],
              [-58.6751195949999, -52.10711028399993],
              [-58.706288214999915, -52.070245049999926],
              [-58.71776282499991, -52.05974700299993],
              [-58.729400193999936, -52.051039320999905],
              [-58.7434789699999, -52.04509856599992],
              [-58.761830206999946, -52.04306405999995],
              [-58.770741339999915, -52.040948174999926],
              [-58.78278561099995, -52.031914971999925],
              [-58.789173956999946, -52.029961846999925],
              [-58.79527747299994, -52.031914971999925],
              [-58.79792232999995, -52.03639088299991],
              [-58.80211341099994, -52.040948174999926],
              [-58.81309973899994, -52.04306405999995],
              [-58.82188880099994, -52.04192473799992],
              [-58.83653723899994, -52.03720468499995],
              [-58.84410559799994, -52.036228122999944],
              [-58.857085740999935, -52.03964609199994],
              [-58.85643469999991, -52.04745859199994],
              [-58.85118567599994, -52.05681731599992],
              [-58.85094153599994, -52.06406015399995],
              [-58.864491339999915, -52.07317473799992],
              [-58.89561926999994, -52.08513762799993],
              [-58.90929114499994, -52.094414971999925],
              [-58.925770636999914, -52.10165780999995],
              [-58.93626868399991, -52.09002044099992],
              [-58.94774329299992, -52.056573174999926],
              [-58.96857662699995, -52.070977471999925],
              [-58.97988847599993, -52.06259530999995],
              [-58.98696855399993, -52.04452890399995],
              [-58.99494381399995, -52.029961846999925],
              [-59.016509568999936, -52.02312590899993],
              [-59.03864498599995, -52.02654387799993],
              [-59.055897589999915, -52.02629973799992],
              [-59.06322180899991, -52.008884372999944],
              [-59.0813695949999, -52.01490650799991],
              [-59.09618079299992, -52.01213958099993],
              [-59.12531490799995, -51.99456145599993],
              [-59.13267981699994, -51.98707447699991],
              [-59.13829505099994, -51.98333098799992],
              [-59.145741339999915, -51.98211028399993],
              [-59.15778561099995, -51.98528411299992],
              [-59.16234290299991, -51.99041106599992],
              [-59.16543535099993, -51.996351820999905],
              [-59.173085089999915, -52.00204843499995],
              [-59.18740800699993, -52.006524346999925],
              [-59.20026607999995, -52.0075822899999],
              [-59.21312415299991, -52.005791924999926],
              [-59.22765051999994, -52.00204843499995],
              [-59.23656165299991, -51.99814218499995],
              [-59.24323482999995, -51.99342213299991],
              [-59.250843878999945, -51.98984140399995],
              [-59.26244055899991, -51.98837655999995],
              [-59.269602016999954, -51.990492445999905],
              [-59.28425045499995, -51.9997697899999],
              [-59.29283606699994, -52.00204843499995],
              [-59.303293423999946, -52.00790780999995],
              [-59.29751542899993, -52.01921965899993],
              [-59.28258216099994, -52.02613697699991],
              [-59.25308183499993, -52.014336846999925],
              [-59.20067298099991, -52.022556247999944],
              [-59.18602454299992, -52.02898528399993],
              [-59.18407141799992, -52.043226820999905],
              [-59.184478318999936, -52.05754973799992],
              [-59.17682857999995, -52.06406015399995],
              [-59.157134568999936, -52.06178150799991],
              [-59.14362545499995, -52.05803801899992],
              [-59.13036048099991, -52.05722421699994],
              [-59.11164303299995, -52.06406015399995],
              [-59.145741339999915, -52.09075286299992],
              [-59.109445766999954, -52.08928801899992],
              [-59.09166419199994, -52.09124114399992],
              [-59.07681230399993, -52.09823984199994],
              [-59.09361731699994, -52.108086846999925],
              [-59.13255774599992, -52.11793385199991],
              [-59.145741339999915, -52.12558359199994],
              [-59.15343176999994, -52.14421965899993],
              [-59.13890540299991, -52.1501604149999],
              [-59.115793423999946, -52.14885833099993],
              [-59.05846106699994, -52.1364885399999],
              [-59.03888912699995, -52.135837497999944],
              [-59.03587805899991, -52.14592864399992],
              [-59.04649817599994, -52.15439218499995],
              [-59.09797115799995, -52.17392343499995],
              [-59.08531653599994, -52.18710702899995],
              [-59.06265214799993, -52.19931405999995],
              [-59.04898027299993, -52.21249765399995],
              [-59.06322180899991, -52.22861093499995],
              [-59.08470618399991, -52.231540622999944],
              [-59.10952714799993, -52.22503020599993],
              [-59.15257727799991, -52.208103122999944],
              [-59.17870032499991, -52.206149997999944],
              [-59.201283331999946, -52.20859140399995],
              [-59.22166907499991, -52.20720794099992],
              [-59.24132239499994, -52.19378020599993],
              [-59.24644934799994, -52.18515390399995],
              [-59.24868730399993, -52.176853122999944],
              [-59.252512173999946, -52.16855234199994],
              [-59.26244055899991, -52.15960051899992],
              [-59.27403723899994, -52.155368747999944],
              [-59.28620357999995, -52.15357838299991],
              [-59.2981664699999, -52.14967213299991],
              [-59.30955969999991, -52.13909270599993],
              [-59.32689368399991, -52.14397551899992],
              [-59.366851365999935, -52.115166924999926],
              [-59.385975714999915, -52.11191171699994],
              [-59.39024817599994, -52.11809661299992],
              [-59.39468339799993, -52.129978122999944],
              [-59.399647589999915, -52.149509372999944],
              [-59.404855923999946, -52.15593840899993],
              [-59.41633053299995, -52.149102471999925],
              [-59.43374589799993, -52.13241952899995],
              [-59.45604407499991, -52.14218515399995],
              [-59.44635982999995, -52.1599260399999],
              [-59.41323808499993, -52.18694426899992],
              [-59.41698157499991, -52.18678150799991],
              [-59.423939581999946, -52.19296640399995],
              [-59.43077551999994, -52.20208098799992],
              [-59.43374589799993, -52.211195570999905],
              [-59.428578253999945, -52.21795012799993],
              [-59.41649329299992, -52.22031015399995],
              [-59.39281165299991, -52.221774997999944],
              [-59.368072068999936, -52.230726820999905],
              [-59.35216223899994, -52.242120049999926],
              [-59.34593665299991, -52.256931247999944],
              [-59.35057532499991, -52.27629973799992],
              [-59.356678839999915, -52.279961846999925],
              [-59.368397589999915, -52.289320570999905],
              [-59.373890753999945, -52.299086195999905],
              [-59.361439581999946, -52.30364348799992],
              [-59.35924231699994, -52.30754973799992],
              [-59.336781378999945, -52.322930596999925],
              [-59.3313695949999, -52.324151299999926],
              [-59.33893795499995, -52.341729424999926],
              [-59.35895748599995, -52.3357072899999],
              [-59.39281165299991, -52.310479424999926],
              [-59.41584225199995, -52.30201588299991],
              [-59.46670488199993, -52.29566822699991],
              [-59.488392706999946, -52.28378671699994],
              [-59.484445766999954, -52.26441822699991],
              [-59.49681555899991, -52.25204843499995],
              [-59.516835089999915, -52.24504973799992],
              [-59.56281490799995, -52.23788827899995],
              [-59.580189581999946, -52.22966887799993],
              [-59.580637173999946, -52.21721770599993],
              [-59.556630011999914, -52.20061614399992],
              [-59.57359778599994, -52.1950822899999],
              [-59.60802161399994, -52.202243747999944],
              [-59.62218176999994, -52.197198174999926],
              [-59.62462317599994, -52.19158294099992],
              [-59.623931443999936, -52.17864348799992],
              [-59.625559048999946, -52.17392343499995],
              [-59.65684973899994, -52.15195077899995],
              [-59.69383704299992, -52.1345354149999],
              [-59.70335852799991, -52.12835051899992],
              [-59.71442623599995, -52.11874765399995],
              [-59.721547003999945, -52.10759856599992],
              [-59.71934973899994, -52.09685637799993],
              [-59.712554490999935, -52.09343840899993],
              [-59.70384680899991, -52.09433359199994],
              [-59.694976365999935, -52.0974260399999],
              [-59.68797766799992, -52.10100676899992],
              [-59.66698157499991, -52.115899346999925],
              [-59.65965735599991, -52.11874765399995],
              [-59.64122473899994, -52.11793385199991],
              [-59.62828528599994, -52.11060963299991],
              [-59.62596594999991, -52.09889088299991],
              [-59.639230923999946, -52.08456796699994],
              [-59.59801184799994, -52.079196872999944],
              [-59.57966061099995, -52.071384372999944],
              [-59.570301886999914, -52.056573174999926],
              [-59.58824622299994, -52.05120208099993],
              [-59.60822506399995, -52.04192473799992],
              [-59.62474524599992, -52.02988046699994],
              [-59.63239498599995, -52.01572030999995],
              [-59.63117428299995, -52.00676848799992],
              [-59.62612870999993, -52.002618096999925],
              [-59.61823482999995, -52.00400155999995],
              [-59.60814368399991, -52.01230234199994],
              [-59.598500128999945, -52.01637135199991],
              [-59.583973761999914, -52.01718515399995],
              [-59.556630011999914, -52.01572030999995],
              [-59.572336391999954, -51.99618905999995],
              [-59.58047441299993, -51.98902760199991],
              [-59.59142005099994, -51.98211028399993],
              [-59.574777798999946, -51.97698333099993],
              [-59.539173956999946, -51.973321221999925],
              [-59.52253170499995, -51.96843840899993],
              [-59.52253170499995, -51.96103280999995],
              [-59.57860266799992, -51.95126718499995],
              [-59.604725714999915, -51.940524997999944],
              [-59.60509192599994, -51.92066822699991],
              [-59.581288214999915, -51.91130950299993],
              [-59.54820716099994, -51.91887786299992],
              [-59.51431230399993, -51.93084075299993],
              [-59.488392706999946, -51.93434010199991],
              [-59.46739661399994, -51.922133070999905],
              [-59.48224850199995, -51.90976327899995],
              [-59.508656378999945, -51.89739348799992],
              [-59.52253170499995, -51.88534921699994],
              [-59.51667232999995, -51.87428150799991],
              [-59.50377356699994, -51.87363046699994],
              [-59.488352016999954, -51.87558359199994],
              [-59.474720831999946, -51.87224700299993],
              [-59.46849524599992, -51.86402760199991],
              [-59.46890214799993, -51.8552385399999],
              [-59.47565670499995, -51.848321221999925],
              [-59.488392706999946, -51.84490325299993],
              [-59.47105872299994, -51.83806731599992],
              [-59.396148240999935, -51.82073333099993],
              [-59.37608801999994, -51.83294036299992],
              [-59.36375891799992, -51.82236093499995],
              [-59.35057532499991, -51.77662525799991],
              [-59.334868943999936, -51.78655364399992],
              [-59.31875566299993, -51.78850676899992],
              [-59.282866990999935, -51.78289153399993],
              [-59.29979407499991, -51.75920989399992],
              [-59.30337480399993, -51.748711846999925],
              [-59.20718339799993, -51.70720794099992],
              [-59.19054114499994, -51.72087981599992],
              [-59.17764238199993, -51.71445077899995],
              [-59.16502844999991, -51.7009416649999],
              [-59.14915930899991, -51.69353606599992],
              [-59.072824673999946, -51.684665622999944],
              [-59.05638587099992, -51.68670012799993],
              [-59.05064856699994, -51.694431247999944],
              [-59.050445115999935, -51.70330169099992],
              [-59.051665818999936, -51.71249765399995],
              [-59.05016028599994, -51.72144947699991],
              [-59.04478919199994, -51.72893645599993],
              [-59.037953253999945, -51.73560963299991],
              [-59.032093878999945, -51.74293385199991],
              [-59.02965247299994, -51.75212981599992],
              [-59.03258216099994, -51.7614885399999],
              [-59.03807532499991, -51.77044036299992],
              [-59.041900193999936, -51.77874114399992],
              [-59.03612219999991, -51.79338958099993],
              [-59.036773240999935, -51.801853122999944],
              [-59.03954016799992, -51.81023528399993],
              [-59.04271399599992, -51.817071221999925],
              [-59.025949673999946, -51.81267669099992],
              [-59.006743943999936, -51.80974700299993],
              [-58.99010169199994, -51.80364348799992],
              [-58.98127193899995, -51.789727471999925],
              [-58.985991990999935, -51.775323174999926],
              [-58.998036261999914, -51.75798919099992],
              [-59.00755774599992, -51.7400041649999],
              [-59.003895636999914, -51.71363697699991],
              [-59.01695716099994, -51.705336195999905],
              [-59.02830969999991, -51.69378020599993],
              [-59.02220618399991, -51.67302825299993],
              [-59.013335740999935, -51.667901299999926],
              [-59.001942511999914, -51.66692473799992],
              [-58.992258266999954, -51.66464609199994],
              [-58.98810787699995, -51.65593840899993],
              [-58.99120032499991, -51.64657968499995],
              [-58.99913489499994, -51.645603122999944],
              [-59.00914466099994, -51.646416924999926],
              [-59.03010006399995, -51.638604424999926],
              [-59.10069739499994, -51.621758721999925],
              [-59.145741339999915, -51.59734465899993],
              [-59.16783606699994, -51.57366301899992],
              [-59.150054490999935, -51.55681731599992],
              [-59.121652798999946, -51.536228122999944],
              [-59.11164303299995, -51.5017229149999],
              [-59.06094316299993, -51.562758070999905],
              [-59.02912350199995, -51.583916924999926],
              [-59.00796464799993, -51.556898695999905],
              [-59.03457597599993, -51.53362395599993],
              [-59.041127081999946, -51.510837497999944],
              [-59.02611243399991, -51.49895598799992],
              [-58.98810787699995, -51.508477471999925],
              [-59.01427161399994, -51.49179452899995],
              [-59.10537675699993, -51.46575286299992],
              [-59.12531490799995, -51.456963799999926],
              [-59.12169348899994, -51.44182708099993],
              [-59.112172003999945, -51.425713799999926],
              [-59.09902910099993, -51.41253020599993],
              [-59.08429928299995, -51.4060197899999],
              [-59.078195766999954, -51.40781015399995],
              [-59.05850175699993, -51.417087497999944],
              [-59.05016028599994, -51.4196916649999],
              [-59.03770911399994, -51.419854424999926],
              [-59.00487219999991, -51.41350676899992],
              [-58.996164516999954, -51.409274997999944],
              [-58.991078253999945, -51.39959075299993],
              [-58.98778235599991, -51.38990650799991],
              [-58.98468990799995, -51.38567473799992],
              [-58.91706295499995, -51.38445403399993],
              [-58.893462693999936, -51.38005950299993],
              [-58.873605923999946, -51.371758721999925],
              [-58.86461341099994, -51.35833098799992],
              [-58.87047278599994, -51.34465911299992],
              [-58.89903723899994, -51.31804778399993],
              [-58.90957597599993, -51.300713799999926],
              [-58.91893469999991, -51.292901299999926],
              [-58.92951412699995, -51.28606536299992],
              [-58.93687903599994, -51.28329843499995],
              [-58.94176184799994, -51.27890390399995],
              [-58.953968878999945, -51.24846770599993],
              [-58.93276933499993, -51.253838799999926],
              [-58.90086829299992, -51.27776458099993],
              [-58.885650193999936, -51.28329843499995],
              [-58.86367753799993, -51.28525155999995],
              [-58.816477016999954, -51.2966447899999],
              [-58.73350989499994, -51.32830169099992],
              [-58.71003170499995, -51.33098723799992],
              [-58.659087693999936, -51.33098723799992],
              [-58.64761308499993, -51.33416106599992],
              [-58.637603318999936, -51.33928801899992],
              [-58.62645423099991, -51.34343840899993],
              [-58.611398891999954, -51.344008070999905],
              [-58.611398891999954, -51.337823174999926],
              [-58.61514238199993, -51.32545338299991],
              [-58.59992428299995, -51.31462981599992],
              [-58.57652747299994, -51.30673593499995],
              [-58.48143469999991, -51.30095794099992],
              [-58.46393795499995, -51.30681731599992],
              [-58.447377081999946, -51.31519947699991],
              [-58.40660559799994, -51.32382577899995],
              [-58.38882402299993, -51.33440520599993],
              [-58.34361731699994, -51.36842213299991],
              [-58.33702551999994, -51.38225676899992],
              [-58.33336341099994, -51.40252044099992],
              [-58.32909094999991, -51.416273695999905],
              [-58.33381100199995, -51.4275041649999],
              [-58.357492641999954, -51.43962981599992],
              [-58.377023891999954, -51.4450822899999],
              [-58.402902798999946, -51.44939544099992],
              [-58.42833411399994, -51.45061614399992],
              [-58.44688880099994, -51.4470354149999],
              [-58.456695115999935, -51.43564218499995],
              [-58.47345943899995, -51.40162525799991],
              [-58.48786373599995, -51.392510674999926],
              [-58.504750128999945, -51.39527760199991],
              [-58.520741339999915, -51.40642669099992],
              [-58.54922441299993, -51.43279387799993],
              [-58.51545162699995, -51.4333635399999],
              [-58.50934811099995, -51.44687265399995],
              [-58.52196204299992, -51.49114348799992],
              [-58.50890051999994, -51.49822356599992],
              [-58.44546464799993, -51.47625090899993],
              [-58.42235266799992, -51.47779713299991],
              [-58.417958136999914, -51.488213799999926],
              [-58.41966712099992, -51.50090911299992],
              [-58.42357337099992, -51.51409270599993],
              [-58.425770636999914, -51.52597421699994],
              [-58.424672003999945, -51.543226820999905],
              [-58.4212133449999, -51.54941171699994],
              [-58.405913865999935, -51.549493096999925],
              [-58.402007615999935, -51.547946872999944],
              [-58.39500891799992, -51.53866952899995],
              [-58.38882402299993, -51.53655364399992],
              [-58.38467363199993, -51.53964609199994],
              [-58.37840735599991, -51.5544572899999],
              [-58.37486731699994, -51.56015390399995],
              [-58.361439581999946, -51.56568775799991],
              [-58.34561113199993, -51.565118096999925],
              [-58.33165442599994, -51.55934010199991],
              [-58.32396399599992, -51.549493096999925],
              [-58.30296790299991, -51.557305596999925],
              [-58.29039466099994, -51.56755950299993],
              [-58.284047003999945, -51.58163827899995],
              [-58.28237870999993, -51.60100676899992],
              [-58.27647864499994, -51.61451588299991],
              [-58.26235917899993, -51.63160572699991],
              [-58.245350714999915, -51.646416924999926],
              [-58.23086503799993, -51.65252044099992],
              [-58.21336829299992, -51.64609140399995],
              [-58.221587693999936, -51.631117445999905],
              [-58.24762936099995, -51.60475025799991],
              [-58.23692786399994, -51.59254322699991],
              [-58.215402798999946, -51.59531015399995],
              [-58.17251542899993, -51.611586195999905],
              [-58.17992102799991, -51.58806731599992],
              [-58.203968878999945, -51.578057549999926],
              [-58.22956295499995, -51.57187265399995],
              [-58.241444464999915, -51.56015390399995],
              [-58.23468990799995, -51.55282968499995],
              [-58.22142493399991, -51.54656340899993],
              [-58.2122289699999, -51.53850676899992],
              [-58.21719316299993, -51.52597421699994],
              [-58.23005123599995, -51.52157968499995],
              [-58.260609503999945, -51.53045012799993],
              [-58.275502081999946, -51.52898528399993],
              [-58.28547115799995, -51.52109140399995],
              [-58.286366339999915, -51.5134416649999],
              [-58.28530839799993, -51.50514088299991],
              [-58.289173956999946, -51.49488697699991],
              [-58.29393469999991, -51.489353122999944],
              [-58.30101477799991, -51.483086846999925],
              [-58.307484503999945, -51.48186614399992],
              [-58.31029212099992, -51.49114348799992],
              [-58.31436113199993, -51.50074635199991],
              [-58.324208136999914, -51.50603606599992],
              [-58.33653723899994, -51.50823333099993],
              [-58.34780839799993, -51.508477471999925],
              [-58.359364386999914, -51.50465260199991],
              [-58.35464433499993, -51.49578215899993],
              [-58.33702551999994, -51.48121510199991],
              [-58.29124915299991, -51.422539971999925],
              [-58.278960740999935, -51.41350676899992],
              [-58.267689581999946, -51.41033294099992],
              [-58.24087480399993, -51.39568450299993],
              [-58.227447068999936, -51.392510674999926],
              [-58.01789303299995, -51.382745049999926],
              [-57.962880011999914, -51.37184010199991],
              [-57.9329320949999, -51.37200286299992],
              [-57.90640214799993, -51.37664153399993],
              [-57.89525305899991, -51.38225676899992],
              [-57.88451087099992, -51.392510674999926],
              [-57.86758378799993, -51.433526299999926],
              [-57.86095130099994, -51.43962981599992],
              [-57.85041256399995, -51.44491952899995],
              [-57.8196508449999, -51.47779713299991],
              [-57.80907141799992, -51.484633070999905],
              [-57.79515540299991, -51.48967864399992],
              [-57.76781165299991, -51.49488697699991],
              [-57.77599036399994, -51.50481536299992],
              [-57.79515540299991, -51.51230234199994],
              [-57.80260169199994, -51.52271900799991],
              [-57.77708899599992, -51.522556247999944],
              [-57.76915442599994, -51.53167083099993],
              [-57.77794348899994, -51.54306405999995],
              [-57.80260169199994, -51.549493096999925],
              [-57.92723548099991, -51.5388322899999],
              [-58.01134192599994, -51.50725676899992],
              [-58.032093878999945, -51.50432708099993],
              [-58.04088294199994, -51.51230234199994],
              [-58.028553839999915, -51.53655364399992],
              [-58.08193925699993, -51.52239348799992],
              [-58.14517167899993, -51.54265715899993],
              [-58.127512173999946, -51.56113046699994],
              [-58.093820766999954, -51.57634856599992],
              [-58.056711391999954, -51.58684661299992],
              [-58.028553839999915, -51.59107838299991],
              [-57.97105872299994, -51.58220794099992],
              [-57.94310462099992, -51.59303150799991],
              [-57.849680141999954, -51.59905364399992],
              [-57.81232662699995, -51.60588958099993],
              [-57.78099524599992, -51.619398695999905],
              [-57.76781165299991, -51.64226653399993],
              [-57.78620357999995, -51.65504322699991],
              [-57.82774817599994, -51.66464609199994],
              [-57.89879309799994, -51.67302825299993],
              [-57.89879309799994, -51.68043385199991],
              [-57.83869381399995, -51.69410572699991],
              [-57.81623287699995, -51.69353606599992],
            ],
          ],
          [
            [
              [-59.74840247299994, -51.28329843499995],
              [-59.79051673099991, -51.27662525799991],
              [-59.79995683499993, -51.27304452899995],
              [-59.806630011999914, -51.26458098799992],
              [-59.80874589799993, -51.25595468499995],
              [-59.80386308499993, -51.24968840899993],
              [-59.78941809799994, -51.24846770599993],
              [-59.76675370999993, -51.24114348799992],
              [-59.74120032499991, -51.24684010199991],
              [-59.71499589799993, -51.256931247999944],
              [-59.6907445949999, -51.26213958099993],
              [-59.588002081999946, -51.25530364399992],
              [-59.57917232999995, -51.25676848799992],
              [-59.57848059799994, -51.260430596999925],
              [-59.57982337099992, -51.26523202899995],
              [-59.57713782499991, -51.270196221999925],
              [-59.57054602799991, -51.27703215899993],
              [-59.567250128999945, -51.28329843499995],
              [-59.56118730399993, -51.287774346999925],
              [-59.54645748599995, -51.28948333099993],
              [-59.53954016799992, -51.28679778399993],
              [-59.535227016999954, -51.28053150799991],
              [-59.53229732999995, -51.274102471999925],
              [-59.529367641999954, -51.270196221999925],
              [-59.51915442599994, -51.26506926899992],
              [-59.51187089799993, -51.26295338299991],
              [-59.502023891999954, -51.26213958099993],
              [-59.47948157499991, -51.267510674999926],
              [-59.46251380099994, -51.28167083099993],
              [-59.45164954299992, -51.30152760199991],
              [-59.447377081999946, -51.324151299999926],
              [-59.47166907499991, -51.3278947899999],
              [-59.494984503999945, -51.33603280999995],
              [-59.55321204299992, -51.337823174999926],
              [-59.57677161399994, -51.33025481599992],
              [-59.61009680899991, -51.29705169099992],
              [-59.63581295499995, -51.28948333099993],
              [-59.74840247299994, -51.28329843499995],
            ],
          ],
          [
            [
              [-59.768427766999935, -52.32696079999994],
              [-59.75168766799993, -52.30922812499995],
              [-59.72628867199995, -52.303902329999914],
              [-59.692320889999905, -52.30371251899993],
              [-59.688744570999916, -52.315111361999925],
              [-59.71246747999993, -52.319399131999944],
              [-59.71226365299992, -52.332894508999914],
              [-59.73079020299991, -52.344414800999914],
              [-59.74249485099995, -52.35797257999991],
              [-59.720248753999954, -52.367199659999926],
              [-59.68117300499995, -52.36386960699991],
              [-59.65409245299992, -52.35540539899995],
              [-59.641989457999955, -52.36779029999991],
              [-59.6673089059999, -52.37936640899994],
              [-59.68752066199994, -52.391940769999906],
              [-59.69582188299995, -52.406522725999935],
              [-59.72317708499992, -52.39836827799991],
              [-59.74544368599993, -52.3891360259999],
              [-59.76090801299995, -52.37882987899991],
              [-59.786389895999946, -52.38103391899995],
              [-59.798459005999916, -52.36863427499992],
              [-59.820693795999944, -52.3583565319999],
              [-59.79030471599992, -52.342641708999906],
              [-59.76487166499993, -52.338362641999936],
              [-59.768427766999935, -52.32696079999994],
            ],
          ],
          [
            [
              [-58.41559811099995, -51.994073174999926],
              [-58.40221106699994, -52.00212981599992],
              [-58.402007615999935, -52.00351327899995],
              [-58.40648352799991, -52.00505950299993],
              [-58.40782630099994, -52.01213958099993],
              [-58.41079667899993, -52.020196221999925],
              [-58.42247473899994, -52.02044036299992],
              [-58.44127356699994, -52.0153947899999],
              [-58.45026607999995, -52.015557549999926],
              [-58.45026607999995, -52.01970794099992],
              [-58.444203253999945, -52.029554945999905],
              [-58.44896399599992, -52.03378671699994],
              [-58.46007239499994, -52.03289153399993],
              [-58.46125240799995, -52.03557708099993],
              [-58.45075436099995, -52.03997161299992],
              [-58.43984941299993, -52.0368791649999],
              [-58.431304490999935, -52.03085702899995],
              [-58.42951412699995, -52.0329729149999],
              [-58.43419348899994, -52.042087497999944],
              [-58.436431443999936, -52.05169036299992],
              [-58.43472245999993, -52.06096770599993],
              [-58.42617753799993, -52.072523695999905],
              [-58.4270727199999, -52.078383070999905],
              [-58.43004309799994, -52.08261484199994],
              [-58.429351365999935, -52.08879973799992],
              [-58.422759568999936, -52.096368096999925],
              [-58.42760169199994, -52.100681247999944],
              [-58.44831295499995, -52.098321221999925],
              [-58.45616614499994, -52.09303150799991],
              [-58.44896399599992, -52.08757903399993],
              [-58.44835364499994, -52.080743096999925],
              [-58.454009568999936, -52.08066171699994],
              [-58.46475175699993, -52.08294036299992],
              [-58.480580206999946, -52.07773202899995],
              [-58.494984503999945, -52.070977471999925],
              [-58.51797441299993, -52.06365325299993],
              [-58.520415818999936, -52.058526299999926],
              [-58.520741339999915, -52.04973723799992],
              [-58.52562415299991, -52.041680596999925],
              [-58.5384008449999, -52.034274997999944],
              [-58.54674231699994, -52.02556731599992],
              [-58.539621548999946, -52.01897551899992],
              [-58.527333136999914, -52.0134416649999],
              [-58.513335740999935, -52.00872161299992],
              [-58.49885006399995, -52.00628020599993],
              [-58.48892167899993, -52.00212981599992],
              [-58.47964433499993, -52.00090911299992],
              [-58.47695878799993, -51.99960702899995],
              [-58.48412024599992, -51.99504973799992],
              [-58.480580206999946, -51.99228280999995],
              [-58.46564693899995, -51.99277109199994],
              [-58.453968878999945, -51.99578215899993],
              [-58.44823157499991, -52.00058359199994],
              [-58.44399980399993, -52.004978122999944],
              [-58.43854732999995, -52.00554778399993],
              [-58.42951412699995, -52.00465260199991],
              [-58.423817511999914, -52.00009530999995],
              [-58.4251195949999, -51.99334075299993],
              [-58.420806443999936, -51.99236419099992],
              [-58.41559811099995, -51.994073174999926],
            ],
          ],
          [
            [
              [-59.67992102799991, -51.96559010199991],
              [-59.67398027299993, -51.97039153399993],
              [-59.67170162699995, -51.98056405999995],
              [-59.68028723899994, -51.98772551899992],
              [-59.69017493399991, -51.98992278399993],
              [-59.695871548999946, -51.98870208099993],
              [-59.69762122299994, -51.98577239399992],
              [-59.700062628999945, -51.98251718499995],
              [-59.70376542899993, -51.97966887799993],
              [-59.70885169199994, -51.97942473799992],
              [-59.714833136999914, -51.98015715899993],
              [-59.71890214799993, -51.97616952899995],
              [-59.713002081999946, -51.963962497999944],
              [-59.714914516999954, -51.95631275799991],
              [-59.71129309799994, -51.94589609199994],
              [-59.698882615999935, -51.93840911299992],
              [-59.688710089999915, -51.94060637799993],
              [-59.68830318899995, -51.947198174999926],
              [-59.69163977799991, -51.955336195999905],
              [-59.68635006399995, -51.962823174999926],
              [-59.67992102799991, -51.96559010199991],
            ],
          ],
          [
            [
              [-59.74423908999995, -51.328977582999926],
              [-59.73052254899994, -51.3385313629999],
              [-59.71680840099992, -51.347017197999946],
              [-59.68939829999994, -51.35971971999993],
              [-59.6878480769999, -51.33945805399992],
              [-59.665640896999946, -51.34151192499991],
              [-59.660383786999944, -51.35748447099991],
              [-59.63810181699995, -51.3659289119999],
              [-59.60048060999992, -51.36897728899993],
              [-59.596946214999946, -51.380689702999916],
              [-59.62596728799991, -51.38507109599993],
              [-59.66347015999992, -51.39693560199993],
              [-59.694150735999926, -51.40769648899993],
              [-59.7231866379999, -51.40991809199994],
              [-59.7523104199999, -51.39828142999994],
              [-59.748993983999924, -51.38335371599993],
              [-59.728575780999904, -51.37263651799992],
              [-59.75250827499991, -51.368443362999926],
              [-59.79174030099995, -51.372807604999934],
              [-59.82252847299992, -51.361152114999925],
              [-59.829411414999925, -51.350506595999946],
              [-59.802122727999915, -51.348316248999936],
              [-59.773132268999916, -51.346115469999916],
              [-59.76471820499995, -51.32797103099995],
              [-59.74423908999995, -51.328977582999926],
            ],
          ],
          [
            [
              [-60.53343665299991, -51.28337981599992],
              [-60.52017167899993, -51.2927385399999],
              [-60.51659094999991, -51.30478280999995],
              [-60.52110755099994, -51.31503671699994],
              [-60.527007615999935, -51.31658294099992],
              [-60.530181443999936, -51.31096770599993],
              [-60.53115800699993, -51.305352471999925],
              [-60.534413214999915, -51.30095794099992],
              [-60.54649817599994, -51.29802825299993],
              [-60.566070115999935, -51.29501718499995],
              [-60.58629309799994, -51.28460051899992],
              [-60.59666907499991, -51.26336028399993],
              [-60.582875128999945, -51.254978122999944],
              [-60.555246548999946, -51.2693010399999],
              [-60.54124915299991, -51.27988046699994],
              [-60.53343665299991, -51.28337981599992],
            ],
          ],
          [
            [
              [-61.055572068999936, -51.070977471999925],
              [-61.04963131399995, -51.07537200299993],
              [-61.04869544199994, -51.080336195999905],
              [-61.05654863199993, -51.08171965899993],
              [-61.07022050699993, -51.079196872999944],
              [-61.10309811099995, -51.06959400799991],
              [-61.11681067599994, -51.06764088299991],
              [-61.12580318899995, -51.06519947699991],
              [-61.12633216099994, -51.05999114399992],
              [-61.118031378999945, -51.05527109199994],
              [-61.112212693999936, -51.05087655999995],
              [-61.112945115999935, -51.04607512799993],
              [-61.11978105399993, -51.03639088299991],
              [-61.119211391999954, -51.02776458099993],
              [-61.10562089799993, -51.029961846999925],
              [-61.09239661399994, -51.03834400799991],
              [-61.07852128799993, -51.05095794099992],
              [-61.073882615999935, -51.05673593499995],
              [-61.06989498599995, -51.06340911299992],
              [-61.067616339999915, -51.06650155999995],
              [-61.055572068999936, -51.070977471999925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Ethiopia',
        iso3: 'ETH',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [34.070697863000134, 9.454592111000068],
            [34.06689172400007, 9.531176453000072],
            [34.09820764200009, 9.679720358000026],
            [34.22192102100007, 10.026029968000032],
            [34.28083215300012, 10.080109355000019],
            [34.30346643000013, 10.113544006000097],
            [34.30501672400004, 10.124602763000013],
            [34.30160607900012, 10.14899403900003],
            [34.301812785000095, 10.160285340000101],
            [34.30460331200004, 10.165633850000049],
            [34.31421512800006, 10.175452372000024],
            [34.31741906800005, 10.181265971000101],
            [34.32589400200004, 10.223563131000091],
            [34.32486047400005, 10.26865081800014],
            [34.276181275000056, 10.488714905000037],
            [34.27173710100004, 10.530081889000073],
            [34.279488566000055, 10.565506083000102],
            [34.36558150200011, 10.685782980000084],
            [34.40423547400013, 10.759835307000102],
            [34.420048462000125, 10.780815938000103],
            [34.43730839000011, 10.795672913000132],
            [34.55781783000015, 10.877786763000046],
            [34.57476770000005, 10.88414296500008],
            [34.587066691000075, 10.879285380000056],
            [34.708092896000096, 10.774072164000074],
            [34.73744510900008, 10.755391134000092],
            [34.75067427600004, 10.74394480400008],
            [34.75697880000007, 10.728803609000067],
            [34.752948039000046, 10.6987279250001],
            [34.75439497900004, 10.684129334000119],
            [34.764833618000125, 10.680253601000075],
            [34.772895142000095, 10.688263448000058],
            [34.78622766100011, 10.718985087000092],
            [34.79852665200008, 10.729656271000096],
            [34.815373169000054, 10.731309916000058],
            [34.827568807000034, 10.727770080000084],
            [34.83852421100005, 10.729139506000067],
            [34.851339966000126, 10.745753479000072],
            [34.85733443200013, 10.763556010000102],
            [34.85743778500006, 10.775674134000013],
            [34.86157189900007, 10.78758555100005],
            [34.87976200300005, 10.80461293600007],
            [34.93381555200011, 10.84530812600012],
            [34.95066206900009, 10.869182638000012],
            [34.95831018000007, 10.903418274000018],
            [34.95283247900011, 10.918430278000088],
            [34.92317020700011, 10.939927674000032],
            [34.913558390000105, 10.952975972000075],
            [34.91428186100012, 10.963957214000061],
            [34.98032434100014, 11.155263367000131],
            [34.98414839700007, 11.186398417000092],
            [34.971435994000046, 11.20688812300007],
            [34.95396936100008, 11.226111756000094],
            [34.94425419100014, 11.253241883000058],
            [34.94714807100013, 11.274868470000044],
            [35.07313521400005, 11.548960266000108],
            [35.0768559170001, 11.56864898700006],
            [35.074375448000126, 11.587355855000041],
            [35.053498169000136, 11.628076884000109],
            [35.04626346800006, 11.648644104000098],
            [35.04812382000006, 11.689520163000097],
            [35.04057906100013, 11.727398987000086],
            [35.04119917800011, 11.747604472000077],
            [35.0482271730001, 11.771375630000136],
            [35.05907922400007, 11.7958702600001],
            [35.072721802000046, 11.81886627200005],
            [35.0880180260001, 11.83819325800009],
            [35.12667199700013, 11.862946269000119],
            [35.14855575200005, 11.871229016000115],
            [35.215555461000065, 11.89658762700006],
            [35.24573449700006, 11.929867248000107],
            [35.247801554000034, 11.939634094000056],
            [35.248378775000106, 11.957857794000034],
            [35.248525024000116, 11.962475078000068],
            [35.251418904000104, 11.971725159000073],
            [35.26041060400007, 11.980406799000036],
            [35.29782434100014, 12.001594137000097],
            [35.31735803200013, 12.023711650000095],
            [35.32603967300008, 12.047482809000059],
            [35.33596154800006, 12.102311503000067],
            [35.3537382400001, 12.146029765000037],
            [35.361283, 12.157346904000107],
            [35.37110152200012, 12.16551178000013],
            [35.39290897600006, 12.176725566000073],
            [35.40334761500009, 12.185097148000054],
            [35.41254602000009, 12.198636373000042],
            [35.41543990000008, 12.211142070000037],
            [35.418127076000076, 12.238995667000097],
            [35.42877242000009, 12.266952616000097],
            [35.61687463300012, 12.575150859000132],
            [35.62586633300015, 12.585124410000049],
            [35.63444462100006, 12.588586731000078],
            [35.653771606000134, 12.590033671000072],
            [35.66245324700009, 12.593651021000056],
            [35.67237512300011, 12.604296366000057],
            [35.675992473000065, 12.614528300000131],
            [35.67743941300006, 12.625225322000048],
            [35.684260701000085, 12.650753479000073],
            [35.684053996000046, 12.65607615200011],
            [35.68767134600006, 12.659228414000083],
            [35.70137031500008, 12.665421098000067],
            [35.70276086500013, 12.666049703000041],
            [35.72839237500011, 12.674369608000092],
            [36.02997603300014, 12.717157695000111],
            [36.03845096800006, 12.717467753000093],
            [36.05064660600004, 12.715452373000062],
            [36.05726119000008, 12.71214508100006],
            [36.06304895000005, 12.707907614000106],
            [36.07214400200013, 12.703050029000082],
            [36.099429159000124, 12.695660299000082],
            [36.115035441000146, 12.701809795000145],
            [36.12361372900011, 12.72144683900008],
            [36.143250773000034, 12.832551168000066],
            [36.14304406800005, 12.856942444000097],
            [36.13870324700008, 12.87185109400005],
            [36.115345500000046, 12.911719463000082],
            [36.114415324000106, 12.933888652000107],
            [36.12599084500005, 12.95096771200005],
            [36.1408736570001, 12.965540467000011],
            [36.149865356000134, 12.980242411000091],
            [36.14955529800005, 12.988820700000119],
            [36.14635135900005, 12.997373149000055],
            [36.13839318800012, 13.01331532800009],
            [36.13694624900012, 13.032435608000085],
            [36.233581177000076, 13.361640320000035],
            [36.38209924300014, 13.571033224000118],
            [36.391297648000034, 13.599351909000106],
            [36.39481164600005, 13.655937602000094],
            [36.398428996000064, 13.676039734000057],
            [36.439941586000145, 13.776176290000109],
            [36.45816695100007, 13.8201394660001],
            [36.45537642400012, 13.870007222000055],
            [36.4380131420001, 13.919952495000118],
            [36.43253544100014, 13.944498799000087],
            [36.43212203000013, 13.969923604000101],
            [36.43656620300004, 13.991214295000091],
            [36.52637984200004, 14.263523254000077],
            [36.54570682800005, 14.263161519000079],
            [36.55304488100006, 14.282772726000104],
            [36.56565393000011, 14.29292714400006],
            [36.582500447000086, 14.296751200000102],
            [36.603791138000076, 14.297319641000058],
            [36.61764042100009, 14.300446066000106],
            [36.64854292800004, 14.314579570000134],
            [36.668593384000076, 14.31778350800002],
            [36.71365523300011, 14.31778350800002],
            [36.722130168000035, 14.320057271000039],
            [36.73835656800014, 14.329798279000087],
            [36.748071737000146, 14.332072042000092],
            [36.816387980000115, 14.332072042000092],
            [36.848530721000145, 14.327782898000038],
            [36.91374637900009, 14.30902435300004],
            [36.9469226490001, 14.304735210000075],
            [36.95281376100007, 14.300962830000046],
            [36.97090051200013, 14.276829936000084],
            [36.978858683000055, 14.271119690000134],
            [36.98671350100011, 14.26683054600008],
            [36.99539514200006, 14.264091695000033],
            [37.00562707500006, 14.263161519000079],
            [37.01151818800014, 14.265073548000089],
            [37.02609094200011, 14.276829936000084],
            [37.03425581900012, 14.277501730000068],
            [37.05244592300005, 14.275331320000078],
            [37.06019738700007, 14.276829936000084],
            [37.07270308400007, 14.285304871000093],
            [37.08345178200011, 14.297733053000073],
            [37.09099654100004, 14.31421783500005],
            [37.0937870680001, 14.335172628000052],
            [37.09440718600007, 14.359150492000055],
            [37.0978178310001, 14.37951100700009],
            [37.10587935400008, 14.399225566000055],
            [37.121072225000034, 14.420826315000113],
            [37.149700969000094, 14.441936137000056],
            [37.18422082500007, 14.449558411000027],
            [37.25822147700006, 14.448111470000129],
            [37.28002893100012, 14.455449524000116],
            [37.293774862000134, 14.457439067000067],
            [37.31816613700005, 14.437130228000044],
            [37.337079712000104, 14.426355693000119],
            [37.37490686000007, 14.373025615000117],
            [37.39020308400012, 14.358168640000088],
            [37.39402714000005, 14.350081279000094],
            [37.39547408000004, 14.335172628000052],
            [37.394957316000045, 14.312383321000056],
            [37.397747843000104, 14.301737976000055],
            [37.41221724400009, 14.293598938000045],
            [37.45262821500012, 14.260577698000077],
            [37.45696903400005, 14.254609070000058],
            [37.464307089000044, 14.235824687000047],
            [37.46937137900005, 14.210813294000062],
            [37.475365845000056, 14.199573670000092],
            [37.488181600000075, 14.194896952000121],
            [37.49851688600006, 14.193088277000044],
            [37.50874882000005, 14.188127340000094],
            [37.51650028500006, 14.180556742000121],
            [37.51949751800004, 14.170996603000034],
            [37.52063439900007, 14.145442607000092],
            [37.525285278000126, 14.128828634000072],
            [37.53572391800009, 14.116839702000021],
            [37.55370731600004, 14.105496724000133],
            [37.56497277800014, 14.116684672000076],
            [37.60104292800014, 14.200917257000071],
            [37.65850712100013, 14.335172628000052],
            [37.72124231000009, 14.481752828000069],
            [37.78563114400009, 14.632182923000045],
            [37.85064009600012, 14.783879090000056],
            [37.891464478000046, 14.879532166000047],
            [37.90882775900013, 14.864726868000034],
            [37.92092004400013, 14.847518616000059],
            [37.94004032400005, 14.810880025000088],
            [37.94438114400003, 14.807340189000044],
            [37.95409631400014, 14.806254985000038],
            [37.95761031100011, 14.802844340000107],
            [37.95812707500005, 14.798761902000095],
            [37.95781701700014, 14.788194072000039],
            [37.95843713300013, 14.78509348500009],
            [37.96226119000005, 14.77785878500012],
            [37.96443160000007, 14.771192525000103],
            [37.96877242000005, 14.766386617000109],
            [37.98003788200009, 14.764552104000103],
            [37.98985640400008, 14.757317403000044],
            [37.992026815000145, 14.749514262000034],
            [37.99275028500006, 14.74075510700004],
            [37.99843469300009, 14.730910747000067],
            [38.006702921000056, 14.72439951600009],
            [38.11522342900014, 14.68101715100002],
            [38.13331018000014, 14.677761536000034],
            [38.19025760900013, 14.687321676000124],
            [38.21392541500006, 14.68587473600013],
            [38.229324992000045, 14.679725240000067],
            [38.239556926000034, 14.667555440000058],
            [38.24584072200008, 14.652474329000128],
            [38.247825154000054, 14.647711691000069],
            [38.25268273900008, 14.620219829000092],
            [38.25764367700009, 14.610427144000127],
            [38.26715214000012, 14.601771342000077],
            [38.278831014000104, 14.595466818000062],
            [38.28926965400012, 14.587741191000063],
            [38.29567753100014, 14.57487375900007],
            [38.305185995000045, 14.536917420000066],
            [38.31335087100007, 14.519347433000078],
            [38.32502974400012, 14.504593812000081],
            [38.34063602700007, 14.492682394000042],
            [38.39427616400013, 14.464312032000038],
            [38.402337688000046, 14.45687062600011],
            [38.40905562300014, 14.435269877000039],
            [38.41442997300004, 14.426304016000103],
            [38.426832316000116, 14.417183126000026],
            [38.435203898000054, 14.416304627000088],
            [38.44367883300009, 14.418655904000033],
            [38.492978150000056, 14.41829416900012],
            [38.56935591600012, 14.426820781000046],
            [38.606562948000146, 14.436484273000076],
            [38.668471313000055, 14.467722677000054],
            [38.688005005000036, 14.467102559000082],
            [38.70619510900008, 14.46115977000008],
            [38.72438521400005, 14.4594027710001],
            [38.74288537600006, 14.461056417000052],
            [38.761902303000056, 14.465448914000135],
            [38.82153690600012, 14.489478454000064],
            [38.866081990000055, 14.493664246],
            [38.88458215300005, 14.506247457000114],
            [38.91755171700004, 14.535703023000039],
            [38.95920292100004, 14.55464243600008],
            [38.97966678800009, 14.567122295000061],
            [38.99382613100005, 14.585157369000072],
            [38.99682336500007, 14.60358001700007],
            [38.99527307100004, 14.622261048000055],
            [38.99682336500007, 14.638900859000074],
            [39.009742472000084, 14.65122568800011],
            [39.01118941200008, 14.647763367000081],
            [39.046949504000054, 14.643758444000085],
            [39.07547489400014, 14.637402242000064],
            [39.08550012200004, 14.633474834000097],
            [39.107307576000096, 14.620116476000064],
            [39.12746138500006, 14.602210592000091],
            [39.14472131300005, 14.581565857000086],
            [39.158467245000054, 14.560145976000072],
            [39.18750940000007, 14.47720530200013],
            [39.208179973000085, 14.440179138000076],
            [39.233191366000085, 14.440437520000046],
            [39.25499882000008, 14.47441477500007],
            [39.26853804500007, 14.486429545000135],
            [39.293446086000074, 14.490305278000093],
            [39.34760298600008, 14.481804504000081],
            [39.366619914000125, 14.48291554800008],
            [39.448578735000126, 14.505110575000117],
            [39.48940311700011, 14.524489238000086],
            [39.50717981000014, 14.547821147000022],
            [39.51503462700009, 14.567819926000055],
            [39.53229455600007, 14.567587382000085],
            [39.55213830600013, 14.556683655000128],
            [39.567331177000085, 14.544307149000062],
            [39.58769169200008, 14.520277609000047],
            [39.59378951000008, 14.51456736200008],
            [39.599473917000125, 14.511647644000092],
            [39.65094364400011, 14.496583965000099],
            [39.67771203600006, 14.49423268600006],
            [39.722985, 14.501717001000074],
            [39.73507287600006, 14.50371531200004],
            [39.766905558000076, 14.504774679000036],
            [39.79687788900014, 14.495111186000102],
            [39.82447310400005, 14.478135478000084],
            [39.877079712000125, 14.433616232000091],
            [39.89227258300008, 14.426562399000076],
            [39.91118615700009, 14.423410136000115],
            [39.93071984900013, 14.42878448500008],
            [39.96151900300009, 14.45420928900009],
            [39.97981246000006, 14.458730977000116],
            [39.99983947100009, 14.455238171000133],
            [40.02322066300013, 14.451160380000061],
            [40.03748335800009, 14.45152211500006],
            [40.08688602700005, 14.465758972000032],
            [40.104559367000036, 14.465965678000074],
            [40.19437300700014, 14.444649150000089],
            [40.23767785700011, 14.427440898000015],
            [40.27705529800011, 14.404574076000102],
            [40.35368741900004, 14.335240904000102],
            [40.42164595500009, 14.273755188000052],
            [40.4798336180001, 14.244402974000081],
            [40.585873657000036, 14.194690247000068],
            [40.614088990000084, 14.185801901000062],
            [40.70441939300014, 14.173218689000038],
            [40.772322225000096, 14.148362325000079],
            [40.833197062000124, 14.10596181200006],
            [40.93779016100012, 13.989922384000039],
            [41.04362349500008, 13.872487691000032],
            [41.121344848000035, 13.738180644000039],
            [41.19203820800004, 13.615862529000097],
            [41.222217244000035, 13.586613668000055],
            [41.35709273300006, 13.502277730000046],
            [41.53072554500005, 13.393783061000065],
            [41.63552535000014, 13.309343770000027],
            [41.711799764000034, 13.247926330000041],
            [41.750763794000136, 13.208316346000075],
            [41.784766887000046, 13.164572246000077],
            [41.81659956900012, 13.112792460000023],
            [41.894320922000134, 12.947970480000038],
            [41.94661747300006, 12.876166077000022],
            [42.024648886000136, 12.826970113000058],
            [42.081699667000066, 12.803922424000092],
            [42.13730350800006, 12.773329977000074],
            [42.18494917800007, 12.73304819700013],
            [42.250164836000124, 12.623985087000094],
            [42.33171024600006, 12.51546457900011],
            [42.37945926900005, 12.465906880000148],
            [42.31920454900006, 12.38637685200004],
            [42.2887154550001, 12.321006165000085],
            [42.1554936120001, 12.142257386000026],
            [42.14030074000004, 12.105825501000112],
            [42.132342570000105, 12.093474833000059],
            [42.1087781170001, 12.082106019000065],
            [42.0977193600001, 12.070168762000037],
            [42.057308391000106, 11.996271464000046],
            [41.97468025400008, 11.880909874000068],
            [41.93638553800008, 11.827444560000075],
            [41.92532678200007, 11.81643748000009],
            [41.911477499000114, 11.80594716400013],
            [41.897524862000125, 11.799384257000057],
            [41.88625940000014, 11.796025289000042],
            [41.87778446500005, 11.790134176000038],
            [41.87220341000011, 11.775871481000067],
            [41.862281535000136, 11.763055725000086],
            [41.82300744600008, 11.74610585600007],
            [41.80822798700012, 11.736235657000094],
            [41.79241499800014, 11.704454651000063],
            [41.77866906800011, 11.628645325000065],
            [41.74911014800006, 11.537953186000024],
            [41.74983361900007, 11.483382874000085],
            [41.77567183400009, 11.368428650000055],
            [41.78797082500006, 11.259727275000031],
            [41.78559370900007, 11.067387594000067],
            [41.779289185000096, 11.024677023000066],
            [41.761305786000094, 10.99620330800012],
            [41.76652309800011, 10.989466077000102],
            [41.77381148300009, 10.980054423000041],
            [41.798719523000045, 10.97067515100008],
            [41.916851847000146, 10.947059022000076],
            [41.92026249200006, 10.941943055000081],
            [41.92284631300009, 10.936026103000074],
            [41.92884078000009, 10.93106516500012],
            [41.93752242000005, 10.929824931000084],
            [41.942793417000075, 10.933545634000097],
            [41.94734094200004, 10.93853241000005],
            [41.95416223100011, 10.941271261000097],
            [42.01079960100009, 10.943596700000029],
            [42.03839481600005, 10.95044382800009],
            [42.0694006760001, 10.981501363000035],
            [42.096272420000105, 10.990260518000099],
            [42.151359497000044, 10.99620330800012],
            [42.20272587100004, 10.984550273000053],
            [42.22163944500005, 10.984343567000096],
            [42.23517867000004, 10.987702535000025],
            [42.27083540900014, 11.003515523000104],
            [42.27941369600006, 11.004394022000056],
            [42.297293742000136, 11.003773906000077],
            [42.305872030000046, 11.004600729000103],
            [42.33853153500013, 11.015504456000073],
            [42.36116581300007, 11.011887105000085],
            [42.37666874100006, 11.006667786000065],
            [42.391758260000074, 11.005892639000052],
            [42.41325565600005, 11.015943705000083],
            [42.47971154800007, 11.05911936400011],
            [42.56973189300004, 11.086146139000064],
            [42.60814508900012, 11.089087690000085],
            [42.615620565000086, 11.089660136000106],
            [42.686520630000075, 11.0730461630001],
            [42.71039514100005, 11.072115987000046],
            [42.72961877400007, 11.065010478000119],
            [42.754836873000045, 11.01054351800012],
            [42.771786743000064, 10.996461691000093],
            [42.794110962000104, 10.991604106000068],
            [42.83545210800014, 10.987444153000041],
            [42.86015344200007, 10.980416159000129],
            [42.873279256000046, 10.978245748000049],
            [42.888058716000046, 10.983568421000086],
            [42.898083944000064, 10.99568654400008],
            [42.90810917100009, 11.004187317000088],
            [42.923715454000046, 10.998787130000025],
            [42.91131311100014, 10.977367248000107],
            [42.90118452900009, 10.93659454400003],
            [42.89353641800011, 10.919670512000039],
            [42.87679325300007, 10.905743714000053],
            [42.834831990000055, 10.888406270000132],
            [42.81943241400006, 10.872567444000126],
            [42.81157759600006, 10.852620341000105],
            [42.80765018700009, 10.836109721000113],
            [42.801242310000134, 10.820787659000061],
            [42.78563602700012, 10.804406230000012],
            [42.74987593600008, 10.77582916200005],
            [42.73809370900011, 10.759783630000086],
            [42.72858524600008, 10.735495707000084],
            [42.71897342900007, 10.694852194000049],
            [42.71163537600012, 10.675163473000097],
            [42.69964644300006, 10.658549500000078],
            [42.680216105000056, 10.64767161100012],
            [42.66026900300005, 10.641625469000076],
            [42.64724654100013, 10.632220358000026],
            [42.64859012900007, 10.611033020000065],
            [42.66853723200006, 10.566229554000088],
            [42.69520227100014, 10.524707540000108],
            [42.750392700000134, 10.47163584400009],
            [42.765792277000116, 10.451947123000139],
            [42.776644328000145, 10.424610290000118],
            [42.78946008300005, 10.333323873000026],
            [42.808166951000146, 10.269115906000067],
            [42.836278931000095, 10.208086040000083],
            [42.862323852000145, 10.177157694000087],
            [42.958235311000124, 10.115559387000047],
            [42.98190311700006, 10.091633199000043],
            [42.99988651500013, 10.06197092700009],
            [43.012598918000094, 10.029285583000103],
            [43.02076379400012, 9.99641937300008],
            [43.03988407300011, 9.949988098000063],
            [43.06768599500003, 9.922522075000089],
            [43.10427290900009, 9.90792348200003],
            [43.14985152200006, 9.899991150000076],
            [43.18721358200014, 9.883325501000044],
            [43.20633386200012, 9.851208598000113],
            [43.23527266400009, 9.691786804000103],
            [43.24881188900014, 9.652331848000088],
            [43.27067102100011, 9.628353984000071],
            [43.29769779500003, 9.621532695000028],
            [43.3059660240001, 9.61755361000013],
            [43.315577841000106, 9.60765757200005],
            [43.32508630400008, 9.58590179500004],
            [43.33175256400011, 9.575075582000096],
            [43.34136438000007, 9.566393941000044],
            [43.361518188000105, 9.553164774000038],
            [43.370664917000056, 9.54422475200002],
            [43.39335087100005, 9.498930359000013],
            [43.3994486900001, 9.480946960000026],
            [43.401980835000074, 9.447408956000103],
            [43.406321655000056, 9.428650411000106],
            [43.41903405700003, 9.413018290000068],
            [43.47122725500009, 9.382012431000135],
            [43.548225139000124, 9.336072083000147],
            [43.56682865400006, 9.334315084000082],
            [43.59121993000008, 9.3435910030001],
            [43.607239624000044, 9.344624532000083],
            [43.621502319000115, 9.336898906000073],
            [43.69844852700004, 9.267161560000119],
            [43.78759037300006, 9.186701355000068],
            [43.91492110200005, 9.071488749000068],
            [43.98478763900005, 9.008314311000092],
            [44.023855021000145, 8.98552500400011],
            [44.104056845000116, 8.959221701000061],
            [44.19221683800009, 8.93028289900009],
            [44.280376831000126, 8.901395772000058],
            [44.36853682500009, 8.872456970000087],
            [44.45669681800007, 8.843544007000034],
            [44.54475345900005, 8.814605205000063],
            [44.63301680500007, 8.785718078000116],
            [44.72107344500006, 8.75677927600006],
            [44.80923343900014, 8.72784047400009],
            [44.89729007900007, 8.698927511000136],
            [44.98555342700013, 8.670040385000092],
            [45.07355839000007, 8.641153259000134],
            [45.16177006100014, 8.612136943000053],
            [45.24987837700007, 8.583275655000108],
            [45.33809004700004, 8.554414368000067],
            [45.426146688000074, 8.525475566000111],
            [45.514410034000036, 8.496536764000055],
            [45.59843591300006, 8.468424784000106],
            [45.68235843900004, 8.440312805000076],
            [45.76638431800012, 8.412226664000045],
            [45.85020349200005, 8.3841146850001],
            [45.9341260170001, 8.35600270600007],
            [46.01804854400007, 8.32789072600012],
            [46.10191939300006, 8.299727072000067],
            [46.185893595000096, 8.271640930000046],
            [46.269816122000066, 8.243554790000104],
            [46.3538420000001, 8.215468648000083],
            [46.43771285000008, 8.187356670000042],
            [46.52168705200012, 8.15924469],
            [46.60571293100014, 8.131132711000063],
            [46.689532105000126, 8.102969055000102],
            [46.773557983000046, 8.074908752000084],
            [46.857377157000144, 8.046745097000041],
            [46.920525757000064, 8.025609437000085],
            [46.97923018400013, 7.996567281000097],
            [47.068113648000065, 7.996515605000084],
            [47.21058557100008, 7.996515605000084],
            [47.366079956000135, 7.996515605000084],
            [47.523589721000064, 7.996515605000084],
            [47.653917684000135, 7.996515605000084],
            [47.83669722500014, 7.996515605000084],
            [47.97916914900014, 7.996567281000097],
            [47.93059330300014, 7.949696757000069],
            [47.88181075000006, 7.902826233000042],
            [47.83318322800005, 7.855955709000099],
            [47.7846590580001, 7.809136862000074],
            [47.73603153500005, 7.762214661000115],
            [47.6875073650001, 7.715395813000015],
            [47.638931519000096, 7.668525289000073],
            [47.59025232000005, 7.62165476500013],
            [47.54167647300005, 7.574835917000115],
            [47.5323881060001, 7.565863750000091],
            [47.49310062700005, 7.527913717000061],
            [47.44452478000005, 7.481043193000033],
            [47.395948934000046, 7.434172669000091],
            [47.34737308700005, 7.38730214400006],
            [47.298797241000045, 7.340379944000105],
            [47.250118042000054, 7.293509420000078],
            [47.20143884300012, 7.246690572000148],
            [47.15286299700011, 7.199820048000021],
            [47.10428715000012, 7.153001201000095],
            [47.05560795100007, 7.106079],
            [47.007032105000064, 7.059208476000023],
            [46.95855961100011, 7.012286276000069],
            [46.909983765000106, 6.965467428000053],
            [46.86140791800011, 6.918596903000108],
            [46.81272871900012, 6.871674704000057],
            [46.76410119600007, 6.824881694000055],
            [46.71557702600012, 6.777985331000096],
            [46.66700118000011, 6.731114807000068],
            [46.61842533400011, 6.684244284000044],
            [46.59806482000005, 6.664633077000104],
            [46.55320967600011, 6.621457418000077],
            [46.5084062090001, 6.578307597000048],
            [46.488045695000096, 6.558644715000099],
            [46.46696287700007, 6.538292406000039],
            [46.423915242000135, 6.496736348000084],
            [46.36293705300011, 6.434259542000106],
            [46.302062215000035, 6.371731059000112],
            [46.24098067300014, 6.309228414000046],
            [46.179899129000034, 6.246725769000065],
            [46.118817586000034, 6.18422312400007],
            [46.05783939600008, 6.121720480000093],
            [45.99680953000012, 6.05919199600001],
            [45.93598636900009, 5.996689352000118],
            [45.82870609600013, 5.879513042000085],
            [45.72142582200007, 5.762336731000048],
            [45.61414554900006, 5.645057068000085],
            [45.51847745300006, 5.540564097000086],
            [45.50686527500011, 5.527880758000052],
            [45.39958500200004, 5.410704448000104],
            [45.29235640400009, 5.293476461000054],
            [45.18502445500013, 5.176248474000104],
            [45.07774418100007, 5.059072164000071],
            [45.020900106000056, 4.996879578000062],
            [45.020641724000086, 4.996879578000062],
            [44.941525106000086, 4.91148427300007],
            [44.912586304000115, 4.899391988000076],
            [44.85837772700006, 4.902544251000037],
            [44.80654626500012, 4.905541484000054],
            [44.754766479000125, 4.908564555000069],
            [44.70288334100013, 4.911561788000085],
            [44.651103556000066, 4.914507345000089],
            [44.59922041800007, 4.917504578000091],
            [44.596807717000104, 4.917643031000097],
            [44.54744063300012, 4.920475972000105],
            [44.49555749500013, 4.923473206000025],
            [44.44372603400012, 4.926444601000128],
            [44.391997925000055, 4.929467672000058],
            [44.34011478700006, 4.932439067000061],
            [44.28833500100012, 4.935487977000079],
            [44.23645186300013, 4.938485209000092],
            [44.18467207800012, 4.941430766000096],
            [44.132788940000125, 4.944479675000125],
            [44.08100915500006, 4.947451071000046],
            [44.02912601700007, 4.950448303000144],
            [43.96897465000012, 4.953962301000104],
            [43.93228438300008, 4.945203146000026],
            [43.84515791900009, 4.914352316000048],
            [43.81518558800013, 4.907479350000074],
            [43.71648360200004, 4.884793396000106],
            [43.64051924600011, 4.867352600000075],
            [43.52848474100006, 4.841566060000062],
            [43.459341675000076, 4.808829041000067],
            [43.34699711100012, 4.755653991000116],
            [43.232792196000105, 4.701497091000107],
            [43.11925907400007, 4.647701924000089],
            [43.035439901000075, 4.578894755000093],
            [42.960405721000086, 4.517373962000079],
            [42.952550903000144, 4.507581279000121],
            [42.945936320000044, 4.496858419000105],
            [42.93250044700011, 4.463217061000066],
            [42.91472375500007, 4.393298849000075],
            [42.8996342370001, 4.361104432000033],
            [42.8701948640001, 4.328170991000121],
            [42.868938436000064, 4.326765442000095],
            [42.8316280520001, 4.302322490000051],
            [42.78977014200012, 4.285605164000103],
            [42.718663371000105, 4.273487040000106],
            [42.568284952000056, 4.247855530000052],
            [42.41501265400012, 4.221707255000055],
            [42.297293742000136, 4.20173431400012],
            [42.221846151000136, 4.200959167000107],
            [42.135339803000136, 4.200080668000069],
            [42.10288700300009, 4.191889954000132],
            [42.06836714700012, 4.174552511000044],
            [42.01183313000007, 4.129490662000094],
            [41.941243123000106, 4.086211650000038],
            [41.923466431000065, 4.070553691000072],
            [41.91664514200011, 4.051097514000091],
            [41.91747196500012, 4.020453389000068],
            [41.91220096800009, 4.007973532000079],
            [41.898455038000066, 3.996914774000075],
            [41.885019165000074, 3.977226054000113],
            [41.83592655400008, 3.949449971000078],
            [41.79138147000009, 3.958157450000044],
            [41.747353150000095, 3.981411845000054],
            [41.69981083200008, 3.996914774000075],
            [41.65743615700006, 3.972704367000091],
            [41.642966756000135, 3.969448751000101],
            [41.628704061000064, 3.972084249000119],
            [41.60224572700008, 3.983065491000104],
            [41.586329386000045, 3.9841506960001],
            [41.506230917000096, 3.964384460000119],
            [41.47977258300011, 3.962937520000125],
            [41.42954309100014, 3.948881531000026],
            [41.3174052330001, 3.942421977000066],
            [41.215292602000034, 3.936608378000088],
            [41.16299605300014, 3.942680359000036],
            [41.114523560000066, 3.96234324100007],
            [41.07008182800007, 3.996914774000075],
            [41.005899699000054, 4.086676737000062],
            [40.97975142400014, 4.110757955000096],
            [40.96362837800007, 4.120369771000114],
            [40.91587935400008, 4.136647847000035],
            [40.89768925000004, 4.145923767000056],
            [40.88735396300012, 4.156052348000102],
            [40.870610799000076, 4.186980693000109],
            [40.84601281700009, 4.214989319000026],
            [40.78575809700004, 4.255839539000121],
            [40.76374393700013, 4.284933370000118],
            [40.70069869000014, 4.243514710000071],
            [40.617499634000126, 4.211604512000093],
            [40.51187300600009, 4.171064352000087],
            [40.38268192600009, 4.121377462000083],
            [40.37699751800005, 4.116080627000144],
            [40.371106404000045, 4.099931742000066],
            [40.36573205600013, 4.094867452000088],
            [40.286873820000096, 4.067453104000037],
            [40.18558801200004, 4.032158102000054],
            [40.182797485000094, 4.032003072000094],
            [40.17980025300011, 4.03282989500012],
            [40.17680301900009, 4.034535218000087],
            [40.16719120300007, 4.035465393000052],
            [40.166261027000076, 4.031486308000069],
            [40.1669844970001, 4.025259298000066],
            [40.16243697100009, 4.019394023000075],
            [40.11716841700007, 3.996914774000075],
            [40.02022342900011, 3.950121765000063],
            [39.934130493000055, 3.9087031050001],
            [39.848450969000055, 3.867284444000049],
            [39.82829716000009, 3.842583110000135],
            [39.808660116000055, 3.790286560000126],
            [39.78075484200008, 3.716570130000093],
            [39.76421838400006, 3.685745138000115],
            [39.74509810400008, 3.660578715000085],
            [39.66644657400008, 3.588722636000057],
            [39.600817505000066, 3.52890716600011],
            [39.574979289000055, 3.497901306000088],
            [39.553171834000125, 3.431316223000096],
            [39.536325317000035, 3.405012920000047],
            [39.50438928200009, 3.403333435000093],
            [39.488472941000055, 3.413901266000067],
            [39.48092818200007, 3.427259624000087],
            [39.47565718600009, 3.440798849000075],
            [39.46697554500008, 3.452012635000116],
            [39.43617639200005, 3.46237375900003],
            [39.3113261310001, 3.466094462000044],
            [39.32052453600011, 3.484542948000055],
            [39.315873657000054, 3.494904073000072],
            [39.30274784300008, 3.495679220000085],
            [39.296337554000104, 3.491990003000097],
            [39.2575826420001, 3.469685975000118],
            [39.219445434000136, 3.468704122000048],
            [39.18048140500008, 3.476998190000103],
            [39.09044144500007, 3.518334305000067],
            [39.077541951000114, 3.524256287000043],
            [39.0679301350001, 3.526581726000074],
            [39.01046594300004, 3.514463603000081],
            [38.994963013000074, 3.514256897000038],
            [38.97997684800009, 3.519812114000047],
            [38.963233684000045, 3.522085877000052],
            [38.92127242000004, 3.513998515000054],
            [38.895227498000054, 3.513585103000139],
            [38.82071008300011, 3.533738912000032],
            [38.72200809800012, 3.560403951000069],
            [38.703714640000044, 3.570429179000087],
            [38.68810835700009, 3.586293844000096],
            [38.66102990700011, 3.621950582000082],
            [38.661443318000124, 3.615335999000095],
            [38.66009973100006, 3.601305847000077],
            [38.660306437000145, 3.594458720000119],
            [38.601912069000036, 3.598670349000059],
            [38.596641073000114, 3.602132670000103],
            [38.59560754400013, 3.607507019000067],
            [38.59374719200014, 3.610840149000069],
            [38.57958784900012, 3.605310771000063],
            [38.5741101480001, 3.604561462000063],
            [38.561087687000054, 3.606008403000061],
            [38.547135051000055, 3.609522400000102],
            [38.54320764100004, 3.615387676000097],
            [38.541243937000104, 3.623294170000051],
            [38.533182414000066, 3.632828471000053],
            [38.51426883900007, 3.648512269000108],
            [38.50899784300009, 3.650811869000037],
            [38.49938602700013, 3.646910299000069],
            [38.49731896900005, 3.638590393000101],
            [38.49814579300005, 3.629676208000092],
            [38.49690555800004, 3.623940125000033],
            [38.4459525960001, 3.601667582000076],
            [38.38993534300005, 3.59688751200008],
            [38.28306848200015, 3.608902283000049],
            [38.17692509000011, 3.620917054000103],
            [38.14560917200009, 3.61843658500004],
            [38.11408654700011, 3.610607605000013],
            [38.10189091000012, 3.612648824000061],
            [38.07884322100006, 3.632673442000097],
            [38.048974243000146, 3.641846009000091],
            [38.036158488000126, 3.648925680000019],
            [38.020758911000144, 3.667167461000076],
            [37.99533410600014, 3.70791432700014],
            [37.97673059100009, 3.726440328000081],
            [37.94593143700013, 3.746232402000061],
            [37.84619592300004, 3.810337016000076],
            [37.751007934000086, 3.871521912000091],
            [37.647758423000084, 3.937874451000127],
            [37.55608443200009, 3.996888937000065],
            [37.4750557860001, 4.048978780000112],
            [37.36095422400007, 4.122204285000109],
            [37.26349247200011, 4.184887798000133],
            [37.16603072100014, 4.247545471000066],
            [37.111873820000085, 4.2822978720001],
            [37.10598270600008, 4.283848165000038],
            [37.09998824000007, 4.283693136000082],
            [37.09482059700008, 4.284881694000106],
            [37.091616659000124, 4.29025604300007],
            [37.086449015000085, 4.312476909000111],
            [37.08252160600006, 4.32216623900004],
            [37.07590702300013, 4.331080424000064],
            [37.06846561700013, 4.333457540000012],
            [37.048415161000094, 4.331958924000105],
            [37.04107710800008, 4.336816508000112],
            [37.025367473000074, 4.363274842000109],
            [37.01565230400007, 4.370587057000094],
            [36.97482792200009, 4.379940491000042],
            [36.90372115100007, 4.415778097000072],
            [36.844086548000064, 4.43223704100005],
            [36.6513334550001, 4.430583394000095],
            [36.64885675900007, 4.431179636000138],
            [36.642961873000104, 4.432598775000145],
            [36.628182414000094, 4.441461284000056],
            [36.61950077300014, 4.443373312000077],
            [36.463024536000034, 4.440169372000099],
            [36.27719608600012, 4.436448669000086],
            [36.26427697700012, 4.43820566900007],
            [36.24608687300008, 4.446990662000061],
            [36.23626835100009, 4.449651998000078],
            [36.225726359000134, 4.449600322000066],
            [36.1913098550001, 4.444923604000095],
            [36.04532476700007, 4.443716285000036],
            [36.04134484800005, 4.443683370000059],
            [36.018400512000085, 4.449135234000039],
            [35.99710982300013, 4.462958680000099],
            [35.958352499000114, 4.496858419000105],
            [35.94047245300004, 4.508046367000048],
            [35.93375451600008, 4.522179871000091],
            [35.93406457600008, 4.539207255000107],
            [35.937061808000124, 4.559257711000058],
            [35.93602827900014, 4.578533020000094],
            [35.92279911300005, 4.602071635000087],
            [35.92083540900012, 4.619331563000088],
            [35.784512981000034, 4.764180603000042],
            [35.7600183510001, 4.805728455000036],
            [35.75164676900005, 4.85435597700004],
            [35.75588423700009, 5.063438823000055],
            [35.76094852700004, 5.076332093000062],
            [35.79918908700006, 5.12462371800008],
            [35.80735396300008, 5.144674174000031],
            [35.80714725700011, 5.165267232000119],
            [35.79825891100006, 5.189270936000042],
            [35.77841516100011, 5.227149760000131],
            [35.77531457500004, 5.246580099000113],
            [35.78203251100007, 5.269860332000036],
            [35.809110962000034, 5.309108581000103],
            [35.80415002500007, 5.318022767000031],
            [35.7493730060001, 5.339158427000072],
            [35.683640584000045, 5.379595235000053],
            [35.65831913300008, 5.386416525000101],
            [35.639818970000135, 5.38207570400003],
            [35.62193892400006, 5.373781636000075],
            [35.59816776500014, 5.368743185000099],
            [35.57387984200011, 5.375331930000087],
            [35.53078169800011, 5.410084330000132],
            [35.50804406700013, 5.423416850000066],
            [35.490164021000055, 5.428041890000117],
            [35.46928674300011, 5.43075490300015],
            [35.44820275900008, 5.43075490300015],
            [35.43021936100007, 5.427215068000095],
            [35.40820520000011, 5.412564799000108],
            [35.36748417200005, 5.368045553000115],
            [35.344953247000035, 5.35236175600005],
            [35.320768677000046, 5.348718567000063],
            [35.30237186700003, 5.357374369000112],
            [35.287489054000105, 5.374091696000065],
            [35.25462284300011, 5.425923157000042],
            [35.250695435000125, 5.435147400000048],
            [35.25183231600005, 5.44736887600007],
            [35.25896366400008, 5.458143412000098],
            [35.26764530400004, 5.468556214000031],
            [35.273639771000035, 5.479873352000098],
            [35.26929895000006, 5.491784769000034],
            [35.26196089700005, 5.5118869020001],
            [35.223410278000074, 5.542996114000047],
            [35.143311808000135, 5.589659933000036],
            [35.0986633710001, 5.622474467000046],
            [35.08822473100008, 5.641749777000086],
            [35.07954309100012, 5.699782409000051],
            [35.06528039500006, 5.726447449000091],
            [34.98435510300004, 5.84101409900012],
            [34.974433228000066, 5.863105774000118],
            [34.97267622900006, 5.876257426000095],
            [34.97453658100005, 5.88723866800008],
            [34.977740519000065, 5.89865915900009],
            [34.97991092900014, 5.912844340000049],
            [34.976810344000114, 5.924032288000078],
            [34.960377238000035, 5.941705627000076],
            [34.95531294800014, 5.952557678000034],
            [34.955726359000096, 5.964210714000089],
            [34.95924035600012, 5.975502014000071],
            [34.96978234900007, 5.996689352000118],
            [34.96796399900012, 6.008131317000036],
            [34.959447062000095, 6.061724142000088],
            [34.95148889200004, 6.081180319000083],
            [34.934435669000095, 6.102367656000041],
            [34.91552209500014, 6.119705099000043],
            [34.898882283000034, 6.138670349000094],
            [34.87996870900008, 6.187633769000101],
            [34.844725382000036, 6.248689474000088],
            [34.83976444500007, 6.268688253000036],
            [34.839040975000046, 6.327599386000131],
            [34.83263309700004, 6.353540955000085],
            [34.7927388920001, 6.421676330000096],
            [34.784263957000064, 6.441830139000075],
            [34.77609908000005, 6.499449361000117],
            [34.75387821500004, 6.556422628000107],
            [34.743542928000124, 6.596807760000075],
            [34.73351770000011, 6.637606303000069],
            [34.726593058000105, 6.641947124000041],
            [34.71450077300011, 6.655667216000069],
            [34.709643188000086, 6.674012349000051],
            [34.70354536900004, 6.684916077000111],
            [34.635539185000084, 6.729822896000115],
            [34.618485962000136, 6.736540833000049],
            [34.596678507000036, 6.739202169000066],
            [34.553993774000105, 6.739253845000079],
            [34.53632043400012, 6.743077901000021],
            [34.52474491400005, 6.752870586000085],
            [34.51792362500004, 6.793824158000106],
            [34.51668339000008, 6.798061626000063],
            [34.51213586400013, 6.808267720000032],
            [34.511102335000146, 6.814313863000081],
            [34.51327274600004, 6.815295715000047],
            [34.52257450400009, 6.82178110800001],
            [34.52474491400005, 6.824571635000069],
            [34.52329797400006, 6.844182841000091],
            [34.51906050600013, 6.861649475000135],
            [34.5123425700001, 6.876842346000061],
            [34.503660929000034, 6.89001983600005],
            [34.439168742000106, 6.934874979000128],
            [34.29757531700005, 6.96856801300008],
            [34.29447473200008, 6.972237040000081],
            [34.287653442000135, 6.975285950000114],
            [34.28072880000008, 6.980091858000023],
            [34.27566451000007, 6.997403463000111],
            [34.270806925000045, 7.003397929000059],
            [34.229879191000066, 7.033370260000098],
            [34.219957316000034, 7.046134338000059],
            [34.21375614400006, 7.051973776000054],
            [34.206004679000046, 7.05450592000004],
            [34.19825321500008, 7.064376119000116],
            [34.1957727460001, 7.086958720000055],
            [34.1957727460001, 7.09773974800008],
            [34.1957727460001, 7.129023336000088],
            [34.19091516100008, 7.149538880000065],
            [34.1814066980001, 7.167212219000064],
            [34.16776412000007, 7.175377096000076],
            [34.151124308000135, 7.167470602000037],
            [34.13241743900005, 7.163388163000121],
            [34.11319380700013, 7.177547506000067],
            [34.085908651000125, 7.211498922000089],
            [34.04001997900008, 7.247259013000104],
            [34.03361210100013, 7.250256247000024],
            [34.03113163200004, 7.255372213000015],
            [34.0306148680001, 7.348699850000074],
            [34.02369022600004, 7.382444560000039],
            [34.00653365100004, 7.409936422000015],
            [33.88240686000006, 7.536078593000084],
            [33.852537882000036, 7.553545228000118],
            [33.842099243000064, 7.555922344000081],
            [33.821428670000046, 7.558402812000054],
            [33.81150679500007, 7.560986634000059],
            [33.76107059700007, 7.598141988000052],
            [33.729444621000084, 7.642118632000091],
            [33.71606042500014, 7.657156474000075],
            [33.70655196200005, 7.661859029000055],
            [33.675029338000115, 7.670850729000094],
            [33.647744181000064, 7.688627422000124],
            [33.63720218900011, 7.691314596000069],
            [33.572296590000064, 7.685216777000107],
            [33.55085087100014, 7.691314596000069],
            [33.54036055500012, 7.698911032000126],
            [33.52651127100006, 7.717101136000068],
            [33.516796102000114, 7.726092835000102],
            [33.506822551000084, 7.730950419000038],
            [33.48847741700013, 7.736169739000047],
            [33.47953739400009, 7.743146057000047],
            [33.4623291420001, 7.749502258000078],
            [33.43649092600009, 7.748572082000109],
            [33.39328942900005, 7.739735412000115],
            [33.384401083000114, 7.73544626900005],
            [33.359803100000136, 7.719271545000055],
            [33.34714237500009, 7.718961487000072],
            [33.29159021000004, 7.733069153000102],
            [33.273503459000096, 7.749192200000081],
            [33.257793824000146, 7.76743398000005],
            [33.24239424700005, 7.780714824000057],
            [33.233919312000126, 7.783195292000116],
            [33.20146651200014, 7.78815623000007],
            [33.172941121000065, 7.799628398000095],
            [33.16451786300007, 7.801127014000102],
            [33.13211674000007, 7.793943990000045],
            [33.12694909700008, 7.791566874000097],
            [33.12085127800009, 7.783298645000059],
            [33.10751875800008, 7.78521067300008],
            [33.08540124500007, 7.794977519000028],
            [33.05832279400005, 7.797974752000044],
            [33.05129480000011, 7.801127014000102],
            [33.04767744900005, 7.807276510000065],
            [33.04462854000013, 7.816423238000056],
            [33.040752808000036, 7.824846497000053],
            [33.02349287900006, 7.835078430000124],
            [33.01501794400008, 7.850633036000147],
            [32.98979984500011, 7.917243958000142],
            [32.99357222500004, 7.928147685000113],
            [33.00680139200006, 7.9424620570001],
            [33.00756888300015, 7.944057830000062],
            [33.01202071100005, 7.953314107000054],
            [33.016774943000144, 7.958326722000024],
            [33.021632528000055, 7.965251363000093],
            [33.02607670000009, 7.986283671000109],
            [33.03114099200013, 7.996308899000041],
            [33.04385339300012, 8.013465475000089],
            [33.10059411600014, 8.07103302000013],
            [33.10658858200014, 8.080489807000106],
            [33.111342814000125, 8.090644226000066],
            [33.11340987200009, 8.099093322000058],
            [33.117543986000044, 8.10415761400013],
            [33.147516317000054, 8.109066874000064],
            [33.16477624500004, 8.117050883000047],
            [33.177281942000036, 8.127101949000064],
            [33.1851367590001, 8.141080424000066],
            [33.18782393400011, 8.16089833600006],
            [33.18472334800009, 8.166246846000107],
            [33.17108077000006, 8.175962016000142],
            [33.167980184000044, 8.18136220300002],
            [33.168290242000126, 8.195392355000124],
            [33.16994388900008, 8.205495097000068],
            [33.17397465000005, 8.214590149000045],
            [33.18162276200013, 8.225726420000072],
            [33.190511109000056, 8.232418518000088],
            [33.1998645430001, 8.235519105000037],
            [33.20689253800009, 8.240738423000053],
            [33.208287802000086, 8.253683370000061],
            [33.19485192800005, 8.25923858700007],
            [33.185756877000074, 8.264509583000105],
            [33.17841882300007, 8.275671692000046],
            [33.171390829000075, 8.283113099000062],
            [33.164362834000144, 8.292776591000077],
            [33.161158894000096, 8.304584656000088],
            [33.163122599000076, 8.312051901000117],
            [33.171804240000085, 8.330887960000041],
            [33.17407800300009, 8.34305776000005],
            [33.17232100500013, 8.34652008100008],
            [33.16332930500005, 8.35295379700004],
            [33.161158894000096, 8.356106059000084],
            [33.161882365000054, 8.361506246000062],
            [33.16684330200013, 8.368275859000093],
            [33.167980184000044, 8.372823385000032],
            [33.167876831000115, 8.389721579000124],
            [33.16953047700014, 8.397421366000117],
            [33.17407800300009, 8.404475200000121],
            [33.18782393400011, 8.41103810700011],
            [33.20291345200013, 8.414112854000052],
            [33.21035485800013, 8.42077911400007],
            [33.207357626000146, 8.426592712000044],
            [33.20642745000009, 8.430571798000116],
            [33.23515954600009, 8.455634867000128],
            [33.252729533000036, 8.458167013000121],
            [33.36135339300006, 8.43429250100013],
            [33.370861857000136, 8.437393087000075],
            [33.384607788000096, 8.448012594000062],
            [33.392100870000036, 8.451862488000103],
            [33.40016239400012, 8.452637635000116],
            [33.41313317800012, 8.449717916000026],
            [33.48051924600014, 8.457650249000082],
            [33.48992435700012, 8.462921245000103],
            [33.49033776800013, 8.466512756000085],
            [33.48475671400007, 8.474005839000114],
            [33.50511722800013, 8.474884338000066],
            [33.52196374500011, 8.465324199000065],
            [33.537053263000075, 8.453206075000068],
            [33.55214278200009, 8.446824036000038],
            [33.571159708000096, 8.450131327000037],
            [33.58537072800004, 8.458115336000105],
            [33.60009851000012, 8.463954773000097],
            [33.62040734900006, 8.46069915800011],
            [33.651671590000035, 8.434499206000083],
            [33.67130863400007, 8.400289409000095],
            [33.695544881000046, 8.372875062000048],
            [33.74102014200014, 8.367087301000069],
            [33.751872193000054, 8.368792623000047],
            [33.756213012000046, 8.370136211000101],
            [33.797657512000114, 8.405612081000044],
            [33.80809615000004, 8.412614238000046],
            [33.82411584500011, 8.419487203000102],
            [33.84085900900004, 8.42398305200004],
            [33.87517216000009, 8.427936299000109],
            [33.93170617700014, 8.42814300600007],
            [33.950309692000076, 8.433207296000134],
            [33.970773559000065, 8.445377096000044],
            [34.06957889800009, 8.533614604000121],
            [34.09024947100011, 8.556507263000043],
            [34.10316857900011, 8.579322408000039],
            [34.1072506590001, 8.601530867000122],
            [34.111850219000075, 8.626554667000079],
            [34.09747332200004, 8.915836019000068],
            [34.083096425000065, 9.205117371000057],
            [34.070697863000134, 9.454592111000068],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'S. Sudan',
        iso3: 'SSD',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [35.92083540900012, 4.619331563000088],
            [35.85653615027104, 4.619603495646345],
            [35.781221547358086, 4.619922014081439],
            [35.77843910060807, 4.678338213018733],
            [35.73940198963447, 4.681126578088339],
            [35.71151833893896, 4.661608022601527],
            [35.705938713505645, 4.619962448315007],
            [35.70584560472605, 4.619447080539359],
            [35.705811861646545, 4.619260306395809],
            [35.700364878660764, 4.589110530793306],
            [35.612139970604176, 4.619497383178029],
            [35.61064126820912, 4.620013573553891],
            [35.61020111305869, 4.620811910080414],
            [35.56260657344876, 4.707137060193645],
            [35.52218008136725, 4.780461080681945],
            [35.57083604882183, 4.904312634202668],
            [35.495640462755716, 4.926428983045639],
            [35.396116892962254, 4.926428983045639],
            [35.43371468599531, 5.00383620399613],
            [35.41159833715233, 5.030375822607695],
            [35.33356251052038, 4.987281410885544],
            [35.26341879990434, 4.94854533188861],
            [35.24572572082997, 4.981719855153159],
            [35.17618886728741, 4.955563790976555],
            [35.09429820157402, 4.924760880020145],
            [35.00272001408649, 4.890314038855152],
            [34.92082934837316, 4.859511127898742],
            [34.844751195724314, 4.830894575067546],
            [34.76358931605273, 4.800365794640612],
            [34.66627738114357, 4.764979636491859],
            [34.59815902670721, 4.730920459273577],
            [34.52915601831711, 4.696418955078556],
            [34.45967393766716, 4.660608951185623],
            [34.381187785000066, 4.620158386000099],
            [34.280108683000094, 4.520061137000113],
            [34.17913293400005, 4.419912212000099],
            [34.07815718600011, 4.319840800000108],
            [33.97707808500007, 4.219691875000095],
            [33.896049438000034, 4.138353170000101],
            [33.81367720500015, 4.056032614000031],
            [33.70190108200012, 3.944075623000103],
            [33.60619632900011, 3.848086650000127],
            [33.53260909000011, 3.774292705000079],
            [33.527716349000116, 3.771430572000057],
            [33.49064782700009, 3.749746399000102],
            [33.44734297700012, 3.744372051000056],
            [33.28652591900004, 3.752536926000076],
            [33.19542036900009, 3.757058614000101],
            [33.164466186000084, 3.76305308000012],
            [33.1434855550001, 3.774085999000121],
            [33.017240031000085, 3.877180481000039],
            [32.99724125100005, 3.885526225000106],
            [32.97956791200005, 3.879195862000088],
            [32.91889978100005, 3.834159851000052],
            [32.8403516030001, 3.794291484000027],
            [32.75642907700012, 3.769021708000054],
            [32.59928104700009, 3.756283468000092],
            [32.41557133000009, 3.74129730300011],
            [32.371801391000076, 3.731065369000135],
            [32.18778161600011, 3.619160054000119],
            [32.175947713000085, 3.605594991000132],
            [32.1748625080001, 3.592650045000127],
            [32.179203328000085, 3.556864115000096],
            [32.1789966230001, 3.541361185000085],
            [32.17592855800012, 3.527233818000113],
            [32.17455244900009, 3.520897318000038],
            [32.16798954200004, 3.512241516000074],
            [32.15584558100011, 3.511776428000061],
            [32.093007040000145, 3.5244629930001],
            [32.076160523000055, 3.533170471000062],
            [32.060864299000116, 3.548957621000056],
            [32.05422597800009, 3.559571835000057],
            [32.04153731300005, 3.57986012800005],
            [32.03016849700009, 3.585932109000098],
            [32.022235907000095, 3.586420195000073],
            [31.94366215000008, 3.591254781000146],
            [31.93001957200005, 3.598360290000073],
            [31.923094930000104, 3.615284323000083],
            [31.920046021000076, 3.661302185000082],
            [31.916273641000146, 3.680267436000037],
            [31.901907593000146, 3.70429697700007],
            [31.830697469000086, 3.783878683000083],
            [31.807029663000037, 3.803722433000075],
            [31.801106597000057, 3.806472428000063],
            [31.780984741000054, 3.81581471800007],
            [31.777884155000038, 3.816434835000038],
            [31.775713745000132, 3.810698751000075],
            [31.696132039000133, 3.721272685000073],
            [31.686830282000074, 3.712823589000081],
            [31.668536825000103, 3.705020447000066],
            [31.564770549000116, 3.689801737000025],
            [31.547200562000057, 3.680990906000119],
            [31.535521688000074, 3.666443990000076],
            [31.534519828000043, 3.665562968000103],
            [31.523739461000048, 3.656082866000062],
            [31.505446004000078, 3.659855245000088],
            [31.377701863000084, 3.729308370000055],
            [31.295019572000115, 3.77418935200005],
            [31.255745483000055, 3.786669210000042],
            [31.214817749000133, 3.792353617000089],
            [31.16758549000008, 3.792405294000105],
            [31.14148889200004, 3.785118917000119],
            [31.104408487000114, 3.756175184000099],
            [31.077668498000094, 3.735302836000088],
            [31.068676798000126, 3.731737162000115],
            [31.049659871000074, 3.727990621000103],
            [31.040358114000128, 3.724218242000077],
            [31.00955896000005, 3.699775289000044],
            [30.995968058000074, 3.693522440000038],
            [30.98578780100013, 3.69212717700006],
            [30.96599572700012, 3.692618103000086],
            [30.955505412000093, 3.689000753000101],
            [30.944446655000093, 3.679285583000066],
            [30.939382365000085, 3.668407695000013],
            [30.93628177900007, 3.656858012000072],
            [30.931734253000116, 3.645101624000077],
            [30.865691773000094, 3.548957621000056],
            [30.84378096600011, 3.505911153000056],
            [30.83954349800007, 3.490201518000092],
            [30.827657918000057, 3.511104635000066],
            [30.837683147000064, 3.562677714000088],
            [30.823213746000135, 3.580428569000105],
            [30.7921045330001, 3.59270172100014],
            [30.77908207200005, 3.60259775800003],
            [30.772260783000092, 3.617558085000098],
            [30.769160197000133, 3.651845398000106],
            [30.765129435000063, 3.661715597000097],
            [30.746939331000135, 3.674867248000069],
            [30.731333048000067, 3.663498434000076],
            [30.71464156100012, 3.643809713000039],
            [30.693350870000074, 3.631949972000101],
            [30.665393921000145, 3.632053324000125],
            [30.653766724000093, 3.630606384000131],
            [30.636455119000118, 3.624095154000074],
            [30.604932496000117, 3.606680197000045],
            [30.592426798000133, 3.603527934000084],
            [30.572634725000057, 3.601047465000107],
            [30.56224776200014, 3.601357524000093],
            [30.553462769000134, 3.604509786000051],
            [30.543024129000116, 3.61290720700012],
            [30.543437541000117, 3.617868144000084],
            [30.549328654000135, 3.624095154000074],
            [30.55490970900013, 3.636394145000111],
            [30.56224776200014, 3.675332336000096],
            [30.562867880000113, 3.694866028000092],
            [30.538890015000106, 3.841549581000052],
            [30.525247436000086, 3.867542827000108],
            [30.51553226700014, 3.870850118000106],
            [30.505507039000122, 3.869764913000026],
            [30.495481812000094, 3.867077739000095],
            [30.485869995000087, 3.865579122000085],
            [30.465716186000122, 3.866095887000114],
            [30.456827840000074, 3.867594502000131],
            [30.418949015000067, 3.879712626000114],
            [30.337920370000063, 3.927875061000108],
            [30.270947713000055, 3.949449971000078],
            [30.205887085000086, 3.950380147000118],
            [30.189350627000124, 3.956090394000071],
            [30.18211592600005, 3.965521342000045],
            [30.180462280000086, 3.975649923000091],
            [30.180358927000043, 3.986217753000062],
            [30.17808516500014, 3.997095642000119],
            [30.171573934000094, 4.008180237000118],
            [30.147492716000045, 4.036653951000062],
            [30.138501018000113, 4.059701640000128],
            [30.133023315000116, 4.082801005000107],
            [30.122688029000074, 4.102463888000045],
            [30.099795369000105, 4.115098775000078],
            [30.057782430000145, 4.123651225000103],
            [30.042899617000046, 4.133108012000079],
            [30.027913452000064, 4.154450379000068],
            [30.00476241100006, 4.199279683000057],
            [29.989362834000076, 4.217779847000074],
            [29.966005087000042, 4.231809998000088],
            [29.954171183000085, 4.233825379000038],
            [29.942647339000075, 4.233773702000121],
            [29.932157023000116, 4.23615081800007],
            [29.924147176000076, 4.245581767000132],
            [29.923217, 4.257751567000042],
            [29.92931481900007, 4.268371073000125],
            [29.93685957800011, 4.278318787000032],
            [29.9401151940001, 4.28834401400006],
            [29.930348348000052, 4.308652853000069],
            [29.908489217000124, 4.329194234000056],
            [29.8827026780001, 4.344025371000086],
            [29.860688517000085, 4.347280986000072],
            [29.81485152200014, 4.346764222000033],
            [29.787824748000105, 4.368804220000115],
            [29.776197551000052, 4.405623678000026],
            [29.776765991000104, 4.449341939000092],
            [29.78565433700004, 4.479365947000062],
            [29.786997925000094, 4.489675395000063],
            [29.785447632000057, 4.498563741000069],
            [29.778522990000113, 4.515100199000059],
            [29.777696167000045, 4.523859355000042],
            [29.783690633000106, 4.533832906000058],
            [29.78829525200007, 4.539365877000094],
            [29.793302449000123, 4.545382589000084],
            [29.79671309400004, 4.556027934000085],
            [29.784620809000046, 4.563288472000053],
            [29.7744922280001, 4.567500102000096],
            [29.751754598000105, 4.581271871000041],
            [29.74514001400013, 4.583907369000059],
            [29.722919149000063, 4.578197123000109],
            [29.715322713000035, 4.579669901000017],
            [29.70080163600005, 4.588299866000057],
            [29.67186283400008, 4.613983053000126],
            [29.660287313000083, 4.622122091000051],
            [29.618532755000103, 4.641578268000032],
            [29.606750529000124, 4.643903707000064],
            [29.57667484600006, 4.644446309000017],
            [29.546392456000035, 4.657365418000026],
            [29.535023641000123, 4.660698547000024],
            [29.528822469000147, 4.659871725000102],
            [29.513267863000124, 4.652146098000102],
            [29.508461955000087, 4.655350037000076],
            [29.4981266690001, 4.665607809000065],
            [29.494095906000098, 4.668294983000081],
            [29.47259851000007, 4.672196554000053],
            [29.457612345000086, 4.669535217000117],
            [29.449240763000034, 4.657055359000125],
            [29.446760295000047, 4.622122091000051],
            [29.443659708000098, 4.604707133000105],
            [29.444589884000038, 4.59447519900003],
            [29.442729533000147, 4.583442281000131],
            [29.423919311000134, 4.566053162000102],
            [29.417304729000136, 4.555485331000042],
            [29.410896850000086, 4.532282613000035],
            [29.402628621000076, 4.512077128000044],
            [29.390226278000057, 4.49375783300006],
            [29.338859904000117, 4.44954864500005],
            [29.328938029000142, 4.43492421500008],
            [29.31870609600014, 4.411075542000091],
            [29.303926636000142, 4.387149353000098],
            [29.287390178000066, 4.383583679000125],
            [29.26744307400014, 4.387872823000095],
            [29.242845093000142, 4.387356059000055],
            [29.231579631000102, 4.375547994000044],
            [29.228685750000068, 4.356711935000121],
            [29.221296021000057, 4.340692240000081],
            [29.19612959800014, 4.337074890000096],
            [29.173495320000086, 4.348004456000069],
            [29.109829956000084, 4.412367452000055],
            [29.09856449400013, 4.420532328000064],
            [29.05887699300007, 4.437688904000126],
            [29.05598311400007, 4.436500346000102],
            [29.053192587000098, 4.450788879000086],
            [29.04234053600007, 4.455336405000125],
            [28.99407474800006, 4.487453308000056],
            [28.986219930000118, 4.495928243000051],
            [28.925551799000118, 4.480812887000056],
            [28.903640992000078, 4.478590800000049],
            [28.85620202600009, 4.482466532000089],
            [28.825712931000112, 4.478384094000091],
            [28.815274292000055, 4.478280741000063],
            [28.789952840000097, 4.488590190000068],
            [28.785095255000073, 4.507994690000132],
            [28.78364831500008, 4.530370585000114],
            [28.769178914000037, 4.549775086000082],
            [28.755432984000095, 4.553986714000118],
            [28.74685469600007, 4.549309998000055],
            [28.738173055000118, 4.540886739000072],
            [28.724530477000116, 4.533987935000098],
            [28.70406661000004, 4.533987935000098],
            [28.69517826400005, 4.532592672000106],
            [28.653733764000066, 4.452700907000107],
            [28.638644247000087, 4.432082011000105],
            [28.623658081000087, 4.422366842000073],
            [28.582420288000094, 4.412625834000025],
            [28.570534708000082, 4.405106914000072],
            [28.56671065200004, 4.394125672000087],
            [28.56428186100007, 4.382601828000062],
            [28.55730554200008, 4.373532613000094],
            [28.548210490000088, 4.370819601000065],
            [28.538495321000056, 4.371827291000045],
            [28.52878015200011, 4.37384267200008],
            [28.519271688000032, 4.374411113000036],
            [28.496844116000148, 4.369010926000072],
            [28.482426392000036, 4.35898569800014],
            [28.443927449000057, 4.308497823000039],
            [28.425427287000048, 4.290824483000037],
            [28.404136596000058, 4.277827860000087],
            [28.381502320000095, 4.275295716000102],
            [28.357421102000075, 4.282866313000071],
            [28.349101196000106, 4.292348938000131],
            [28.345845581000106, 4.30637909000005],
            [28.33685388200007, 4.327488912000092],
            [28.303160848000118, 4.352241923000108],
            [28.26104455500007, 4.350381572000103],
            [28.216964559000104, 4.342035827000046],
            [28.177587117000087, 4.34722931000006],
            [28.158725219000075, 4.360794373000132],
            [28.140225057000066, 4.379320374000073],
            [28.112371460000077, 4.414641215000074],
            [28.10834069800009, 4.433994039000126],
            [28.101726115000076, 4.442133077000037],
            [28.0855513920001, 4.443321635000061],
            [28.076301310000076, 4.437688904000126],
            [28.059764852000086, 4.420067240000051],
            [28.04973962400007, 4.419137064000083],
            [28.019043823000118, 4.462751974000042],
            [28.01418623900011, 4.472208761000019],
            [28.011240682000107, 4.480141093000071],
            [28.00958703600014, 4.488383484000096],
            [28.008915243000075, 4.499080505000109],
            [28.01211918100006, 4.52176646000008],
            [28.01708011800008, 4.539052226000067],
            [28.014031209000052, 4.550033467000063],
            [27.96250980600007, 4.557449036000065],
            [27.951244344000088, 4.555950419000069],
            [27.944526408000087, 4.557294006000035],
            [27.934294475000087, 4.568171896000081],
            [27.92923018400012, 4.569980571000073],
            [27.92034183700011, 4.565278016000093],
            [27.91610437000014, 4.562151591000145],
            [27.917861369000036, 4.560756328000068],
            [27.91703454600011, 4.558430888000132],
            [27.916414429000042, 4.553573303000107],
            [27.91403731300008, 4.549309998000055],
            [27.907939494000033, 4.548689880000083],
            [27.890989624000042, 4.555847066000041],
            [27.885511922000035, 4.556673890000056],
            [27.856934855000077, 4.552462260000112],
            [27.849131714000066, 4.553211568000023],
            [27.837659546000054, 4.559981181000055],
            [27.81946944100011, 4.579566549000077],
            [27.80923750800011, 4.587989808000074],
            [27.801382690000082, 4.590573629000076],
            [27.776888061000136, 4.595741272000069],
            [27.77244388800011, 4.595818786000095],
            [27.765209187000067, 4.612071025000105],
            [27.76076501500006, 4.63599721300011],
            [27.75880131000011, 4.677157491000088],
            [27.766862834000108, 4.735448507000044],
            [27.76314213100008, 4.757100932000114],
            [27.75921472200011, 4.766273499000107],
            [27.752600138000048, 4.777668152000103],
            [27.744228556000053, 4.787848409000077],
            [27.734823445000103, 4.793196920000113],
            [27.725831747000143, 4.792783508000113],
            [27.706504761000105, 4.787434997000062],
            [27.699063355000078, 4.787434997000062],
            [27.685937541000015, 4.797899475000094],
            [27.679736369000125, 4.8144876100001],
            [27.671881551000098, 4.855906271000066],
            [27.658755737000035, 4.879651592000116],
            [27.64097904400009, 4.890942892000083],
            [27.552715698000014, 4.900528870000088],
            [27.53256189000004, 4.907582702000099],
            [27.514578492000055, 4.922439677000042],
            [27.5092041420001, 4.932439067000061],
            [27.505018351000075, 4.953858948000075],
            [27.501349325000064, 4.963289897000038],
            [27.492822713000038, 4.973030904000083],
            [27.461558472000064, 4.996879578000062],
            [27.45453047700005, 4.999799297000067],
            [27.44786421700013, 5.003468323000064],
            [27.441818074000082, 5.007964172000072],
            [27.436340373000093, 5.013157654000082],
            [27.443058309000037, 5.057780253000104],
            [27.441301310000142, 5.070725199000037],
            [27.43117272900008, 5.083618469000044],
            [27.402130574000097, 5.104495748000105],
            [27.38580082200008, 5.14384735100009],
            [27.35851566500014, 5.166765849000029],
            [27.301309855000113, 5.205187277000064],
            [27.280897664000065, 5.230560404000059],
            [27.26446455900009, 5.2601451620001],
            [27.237799520000067, 5.323190410000038],
            [27.23366540600003, 5.338279927000116],
            [27.228239380000048, 5.387605082000036],
            [27.220126180000136, 5.413081564000052],
            [27.218059123000103, 5.425509746000031],
            [27.220126180000136, 5.440883484000011],
            [27.26074385600009, 5.550256653000119],
            [27.258883505000085, 5.559971822000065],
            [27.261053914000087, 5.577593485000051],
            [27.257126505000116, 5.586068420000061],
            [27.2475146890001, 5.592605490000039],
            [27.240073283000072, 5.591985372000067],
            [27.234595581000093, 5.588833110000095],
            [27.231081584000037, 5.58759287500007],
            [27.227309204000107, 5.586714376000117],
            [27.222606649000113, 5.584363098000082],
            [27.217335653000106, 5.585396627000065],
            [27.211341186000055, 5.594879252000055],
            [27.210669393000074, 5.601623027000073],
            [27.215165242000097, 5.616144104000028],
            [27.216715536000038, 5.633455709000117],
            [27.21919600400011, 5.639992777000103],
            [27.21836918100007, 5.645315450000055],
            [27.201109253000084, 5.656968486000025],
            [27.1964066970001, 5.661464335000048],
            [27.194287964000125, 5.667303772000125],
            [27.193822876000098, 5.676321310000077],
            [27.19077396600008, 5.691824239000084],
            [27.182350708000087, 5.707456360000037],
            [27.170413452000048, 5.720349630000044],
            [27.156254109000088, 5.72748097700007],
            [27.136307007000084, 5.734018047000049],
            [27.13144942200006, 5.741459453000076],
            [27.130932657000102, 5.752130635000071],
            [27.12380131100008, 5.768744608000091],
            [27.114809611000055, 5.77528167800007],
            [27.072744995000107, 5.791223857000091],
            [27.06354659100012, 5.790862122000092],
            [27.04535648600006, 5.784919332000086],
            [27.036054728000124, 5.78512603700004],
            [27.029543497000077, 5.789880269000122],
            [27.021998738000036, 5.805098979000064],
            [27.003498576000084, 5.819284159000119],
            [26.991819702000015, 5.847706197000136],
            [26.981071004000086, 5.859204203000061],
            [26.937456095000044, 5.848507182000063],
            [26.916475464000143, 5.849644064000074],
            [26.90376306100009, 5.866981506000073],
            [26.894254598000117, 5.889667461000045],
            [26.88205896000011, 5.891941224000064],
            [26.86531579600006, 5.885972595000041],
            [26.842164754000066, 5.884267273000077],
            [26.81891036000013, 5.894628398000094],
            [26.810848836000048, 5.912379253000026],
            [26.805061076000072, 5.957182719000087],
            [26.794364054000084, 5.970489401000094],
            [26.776328979000084, 5.981884054000091],
            [26.705015503000084, 6.009789327000078],
            [26.634322144000095, 6.006482035000076],
            [26.602179403000065, 6.010616150000104],
            [26.543578328000137, 6.030847474000012],
            [26.527972045000098, 6.043172303000048],
            [26.518050171000084, 6.061155701000132],
            [26.50988529400007, 6.082678935000089],
            [26.49882653800006, 6.099835510000048],
            [26.481049846000133, 6.104951477000043],
            [26.440638875000076, 6.076994528000043],
            [26.424825887000054, 6.072447002000104],
            [26.421311890000112, 6.093660177000075],
            [26.429270061000068, 6.113090515000053],
            [26.445599813000115, 6.130221253000101],
            [26.46534020900006, 6.144303080000029],
            [26.48353031400012, 6.154457499000088],
            [26.50006677200011, 6.167970887000067],
            [26.50947188300006, 6.186393535000065],
            [26.50895511900012, 6.205462138000144],
            [26.495829305000143, 6.22114593500001],
            [26.479499552000107, 6.22507334400008],
            [26.46492679800005, 6.224401551000085],
            [26.455625040000115, 6.230473531000129],
            [26.45531498200006, 6.25445139600015],
            [26.452007690000045, 6.280289612000075],
            [26.436194702000137, 6.291710103000085],
            [26.39464685100006, 6.300546774000082],
            [26.375836629000048, 6.312587382000061],
            [26.351755411000113, 6.344368388000092],
            [26.335218954000112, 6.3605947880001],
            [26.31578861400004, 6.371576030000085],
            [26.300699097000034, 6.377828878000074],
            [26.28964034000012, 6.387208150000035],
            [26.282819051000075, 6.40785288500004],
            [26.28509281400011, 6.42588796000004],
            [26.290673869000102, 6.444672343000136],
            [26.289123575000104, 6.459425964000047],
            [26.270210002000056, 6.465652974000136],
            [26.27703129000011, 6.477357687000023],
            [26.28643640100006, 6.484178975000077],
            [26.296461629000078, 6.489527486000028],
            [26.305039917000016, 6.496917216000043],
            [26.324366903000083, 6.537198995000082],
            [26.356096232000084, 6.579496155000072],
            [26.372322631000088, 6.609804382000107],
            [26.37986739100006, 6.619777934000112],
            [26.37922433500006, 6.631361872000056],
            [26.37800703900004, 6.653290100000035],
            [26.329741252000133, 6.68057525600004],
            [26.270623413000067, 6.702486064000084],
            [26.236206909000117, 6.720030213000058],
            [26.21946374500007, 6.737522685000016],
            [26.17874271700009, 6.765918884000115],
            [26.147633504000055, 6.804702047000063],
            [26.13182051600006, 6.811730042000079],
            [26.113733765000035, 6.816458435000058],
            [26.091202840000108, 6.830333557000117],
            [26.08097090700005, 6.842348328000085],
            [26.077353557000066, 6.853329570000071],
            [26.07569991000011, 6.864646709000056],
            [26.071565796000073, 6.877462463000128],
            [26.07115238500006, 6.88356028200009],
            [26.07311608900011, 6.889709778000068],
            [26.07363285300005, 6.89513580300013],
            [26.06918868000014, 6.899063212000101],
            [26.06340091900006, 6.899063212000101],
            [26.056889689000087, 6.89740956600005],
            [26.050585165000086, 6.896686096000053],
            [26.045417521000076, 6.899683330000073],
            [26.03580570400007, 6.92226593],
            [26.0322917070001, 6.97409739200009],
            [26.026090535000037, 6.996679993000029],
            [25.9811320390001, 7.000297343000099],
            [25.969453165000033, 7.003552958000085],
            [25.966765991000102, 7.009857483000104],
            [25.966249227000077, 7.017453919000076],
            [25.9604614670001, 7.024481914000077],
            [25.950436238000066, 7.028564352000089],
            [25.930385783000105, 7.031509909000093],
            [25.920257202000073, 7.034145406000107],
            [25.88873457800011, 7.051870423000111],
            [25.884083699000143, 7.061068827000028],
            [25.881706583000096, 7.079827372000111],
            [25.877469116000043, 7.087733866000065],
            [25.86072595200008, 7.095537008000079],
            [25.81576745600009, 7.099774476000036],
            [25.800781290000117, 7.104942118000039],
            [25.79168623900003, 7.121116842000035],
            [25.7915828860001, 7.134397685000053],
            [25.78620853600006, 7.142665914000091],
            [25.761300497000093, 7.143751119000086],
            [25.750241739000074, 7.146541646000045],
            [25.73442875100008, 7.162406312000059],
            [25.724506876000078, 7.166695455000109],
            [25.7050765380001, 7.166385396000038],
            [25.6970150140001, 7.168607483000045],
            [25.672727091000098, 7.187831116000069],
            [25.654020223000117, 7.19537587500011],
            [25.59242191600009, 7.211240540000119],
            [25.57660892700011, 7.219818828000058],
            [25.531650431000088, 7.260694885000063],
            [25.516767619000035, 7.269944966000068],
            [25.50033451300007, 7.272787170000043],
            [25.48116255700006, 7.266172587000142],
            [25.45511763500008, 7.27821319600011],
            [25.41615360500009, 7.307772115000148],
            [25.360032999000055, 7.335574036000096],
            [25.346803833000052, 7.345030823000073],
            [25.33595178200011, 7.359603577000129],
            [25.330577433000144, 7.374124655000074],
            [25.3241695560001, 7.402908427000099],
            [25.316211385000145, 7.417222799000086],
            [25.309700155000087, 7.422028707000095],
            [25.29295699100004, 7.427196350000102],
            [25.285102173000098, 7.431588847000086],
            [25.27921105900009, 7.438358460000131],
            [25.269599243000073, 7.454223124000052],
            [25.263294718000083, 7.461044414000099],
            [25.249962199000038, 7.469984436000033],
            [25.190430949000074, 7.501197002000097],
            [25.169036906000144, 7.551168112000084],
            [25.164592732000045, 7.567342834000073],
            [25.165212850000017, 7.579900207000094],
            [25.186503540000103, 7.600105693000074],
            [25.25254602000004, 7.622429911000054],
            [25.274973592000038, 7.64196360300005],
            [25.279417765000062, 7.659481913000107],
            [25.276420532000117, 7.674261373000121],
            [25.270632772000056, 7.688162334000097],
            [25.266808716000128, 7.703096823000067],
            [25.270632772000056, 7.746143291000067],
            [25.26990930200006, 7.760767720000032],
            [25.264534953000094, 7.777717590000037],
            [25.24965214000005, 7.804330953000076],
            [25.23942020600009, 7.835956929000062],
            [25.229705037000144, 7.851614889000118],
            [25.216889283000057, 7.864068909000096],
            [25.19156783100007, 7.872388814000061],
            [25.18547001200011, 7.87791819300007],
            [25.18050907300008, 7.884016012000117],
            [25.17317102000007, 7.888563538000056],
            [25.148573039000098, 7.892594299000052],
            [25.134413696000138, 7.89254262300004],
            [25.103407837000134, 7.885773011000097],
            [25.089558553000074, 7.884894511000056],
            [25.05917281100011, 7.896108297000097],
            [25.029303833000085, 7.918845927000078],
            [24.981244751000133, 7.97233103500011],
            [24.97266646300011, 7.976981914000078],
            [24.964811646000072, 7.982614645000112],
            [24.95809370900014, 7.989177552000086],
            [24.952616007000046, 7.996567281000097],
            [24.950548950000098, 8.014395651000143],
            [24.93008508300005, 8.03545379600007],
            [24.927811320000103, 8.070955505000114],
            [24.917992798000057, 8.087026876000081],
            [24.832106568000114, 8.165730082000067],
            [24.80017053200004, 8.18027699800011],
            [24.742292928000097, 8.186839905000099],
            [24.710563599000096, 8.204306539000044],
            [24.690409790000103, 8.206631978000075],
            [24.67087609900011, 8.206838684000033],
            [24.61485884600009, 8.217148132000133],
            [24.54468225100001, 8.206115214000135],
            [24.512849569000082, 8.207148743000118],
            [24.48132694500009, 8.226656596000026],
            [24.471508422000028, 8.228930359000046],
            [24.46427372200006, 8.233193665000087],
            [24.458899373000094, 8.239756572000076],
            [24.454868612000013, 8.248670756000095],
            [24.431097453000064, 8.271408386000076],
            [24.39657759600007, 8.267816874000104],
            [24.332085409000058, 8.245725199000091],
            [24.326814412000118, 8.248567403000067],
            [24.310277954000128, 8.261564026000102],
            [24.302733195000087, 8.26543975900006],
            [24.295498495000118, 8.266524963000052],
            [24.281029094000075, 8.266524963000052],
            [24.263185621000048, 8.268505435000051],
            [24.25705122900007, 8.269186300000072],
            [24.222428019000063, 8.277196147000055],
            [24.20661503100007, 8.283268127000099],
            [24.179949992000104, 8.297711690000114],
            [24.152871541000053, 8.317891337000106],
            [24.13137414500011, 8.34305776000005],
            [24.121555623000063, 8.372306621000092],
            [24.125172973000133, 8.404888611000047],
            [24.137161906000102, 8.438865865000082],
            [24.193179159000096, 8.532426046000097],
            [24.20320438600004, 8.543458965000099],
            [24.243718710000053, 8.570175680000148],
            [24.250539998000107, 8.579632467000124],
            [24.245579061000058, 8.591802267000034],
            [24.218397258000067, 8.613041280000104],
            [24.211265910000122, 8.627071432000022],
            [24.21508996600008, 8.641359965000092],
            [24.233486776000063, 8.667766622000073],
            [24.23576053900007, 8.682003479000045],
            [24.21767378700008, 8.691511943000123],
            [24.180466756000072, 8.690710958000096],
            [24.170328031000054, 8.689327330000111],
            [24.17478234800012, 8.695646057000133],
            [24.176952759000102, 8.709857076000105],
            [24.182998902000037, 8.7179185990001],
            [24.240566446000088, 8.761533508000056],
            [24.270848837000102, 8.7757186890001],
            [24.380092814000108, 8.844215800000114],
            [24.40288212100009, 8.848892518000085],
            [24.493832642000086, 8.858349304000058],
            [24.54287357600012, 8.87465321900008],
            [24.552795450000104, 8.880079244000058],
            [24.558376505000126, 8.886745504000075],
            [24.558376505000126, 8.993353984000038],
            [24.559306681000095, 8.999865214000096],
            [24.56535282400003, 9.014851379000078],
            [24.65599328600007, 9.167296855000089],
            [24.65986901800011, 9.176986186000121],
            [24.660954224000108, 9.182283020000071],
            [24.680177857000047, 9.373356629000085],
            [24.686999145000073, 9.391365866000072],
            [24.694957316000057, 9.40291554800011],
            [24.72394779400011, 9.429218852000062],
            [24.785236043000083, 9.497509257000019],
            [24.79252242000007, 9.520401917000044],
            [24.794382772000063, 9.532184143000038],
            [24.79267744900011, 9.798369446000066],
            [24.79639815200011, 9.818859151000126],
            [24.79980879700014, 9.825215353000061],
            [24.803684530000083, 9.829168600000031],
            [24.807301880000068, 9.830047099000069],
            [24.816758667000045, 9.830744731000067],
            [24.827610717000084, 9.832682597000087],
            [24.836292358000065, 9.836635844000057],
            [24.844818970000063, 9.841674296000036],
            [24.87928715000004, 9.869915466000094],
            [24.913858683000115, 9.890715230000055],
            [24.926932821000065, 9.905210470000085],
            [24.95437300600014, 9.942236634000054],
            [24.9678605550001, 9.955956726000082],
            [24.976283813000094, 9.967351379000078],
            [24.984965454000132, 9.985593160000036],
            [24.99070153800011, 10.00305979400008],
            [25.016901489000105, 10.056751607000066],
            [25.027753540000077, 10.086155497000064],
            [25.028993775000117, 10.092046610000054],
            [25.029303833000085, 10.098247782000044],
            [25.028683716000018, 10.103906352000081],
            [25.025583130000086, 10.11416412400007],
            [25.017366577000132, 10.133000183000078],
            [25.01581628400004, 10.138038635000058],
            [25.013645874000133, 10.14907155400006],
            [25.014421021000146, 10.157365621000096],
            [25.01705651800006, 10.168010966000097],
            [25.067027628000034, 10.274929504000056],
            [25.07694950400014, 10.286866761000084],
            [25.084080851000067, 10.293222962000115],
            [25.09028202300007, 10.295755107000105],
            [25.10599165900004, 10.30035431000006],
            [25.120564413000096, 10.306090393000105],
            [25.131261434000095, 10.308286641000109],
            [25.15689294400005, 10.30624542200006],
            [25.16836511200009, 10.308131613000072],
            [25.19254968300004, 10.317433370000089],
            [25.19828576600011, 10.317588399000044],
            [25.209964640000067, 10.316115621000037],
            [25.216630900000098, 10.316968283000065],
            [25.225622599000133, 10.32061147000006],
            [25.232753947000077, 10.322316793000113],
            [25.23957523600012, 10.32301442500011],
            [25.251512492000074, 10.320999044000061],
            [25.25699019400014, 10.319216207000082],
            [25.267067098000098, 10.314797872000085],
            [25.272803182000047, 10.313015036000095],
            [25.278694295000065, 10.312007344000023],
            [25.284740437000096, 10.311852316000085],
            [25.290166463000077, 10.313092550000107],
            [25.299778279000094, 10.31665822300009],
            [25.305359334000087, 10.317123311000017],
            [25.316211385000145, 10.315573019000084],
            [25.32199914600011, 10.31565053300011],
            [25.3274251710001, 10.316580709000064],
            [25.34602868600004, 10.325262349000113],
            [25.351144653000034, 10.32681264200005],
            [25.362926880000146, 10.328130392000105],
            [25.369334757000075, 10.328207906000031],
            [25.381272013000114, 10.329448141000057],
            [25.391503947000103, 10.332652080000031],
            [25.40096073400008, 10.336992899000109],
            [25.415843547000122, 10.342031352000078],
            [25.42721236200009, 10.344124247000053],
            [25.439304647000085, 10.345209453000052],
            [25.47950891100001, 10.34381418900007],
            [25.490826049000077, 10.345597025000046],
            [25.503383423000088, 10.349162700000107],
            [25.506484009000133, 10.34962778800005],
            [25.580329631000097, 10.37531097400003],
            [25.62332442200008, 10.385852966000087],
            [25.629060506000144, 10.386705628000115],
            [25.66135827700012, 10.387015686000012],
            [25.68414758300011, 10.390684713000098],
            [25.699960571000105, 10.39502553300008],
            [25.7057483320001, 10.39595570900012],
            [25.745900920000082, 10.394405416000012],
            [25.75396244300009, 10.395335592000066],
            [25.762799113000085, 10.397738546000113],
            [25.78377974500009, 10.407892965000073],
            [25.828479858000037, 10.419546000000139],
            [25.839331909000094, 10.420553691000109],
            [25.843052612000093, 10.417814839000073],
            [25.886512492000094, 10.364303894000031],
            [25.89162845900009, 10.355983988000077],
            [25.89364384000004, 10.351333110000013],
            [25.89488407400009, 10.345829569000017],
            [25.90093021600012, 10.191058655000063],
            [25.902790568000114, 10.185529276000054],
            [25.905426066000132, 10.181265971000101],
            [25.911937296000104, 10.174212138000087],
            [25.919688761000117, 10.167855937000056],
            [25.95570723500009, 10.146901144000068],
            [25.970900105000027, 10.140312398000077],
            [25.99808190900012, 10.13245758100004],
            [26.000872436000066, 10.131062317000058],
            [26.0072286380001, 10.12599802700008],
            [26.01079431200006, 10.122690735000077],
            [26.01668542400006, 10.114861755000064],
            [26.076423381000097, 10.017710063000067],
            [26.088205607000106, 10.002827251000028],
            [26.102313341000126, 9.98816329800006],
            [26.10262333200012, 9.987841085000042],
            [26.1794661860001, 9.958979797000012],
            [26.36816267900008, 9.739716695000027],
            [26.556859172000145, 9.520453593000056],
            [26.600887491000094, 9.491979879000027],
            [26.62574385600007, 9.480662740000042],
            [26.68362146000007, 9.476011861000075],
            [26.694318482000085, 9.476942037000128],
            [27.080393107000077, 9.606830750000114],
            [27.339240357000108, 9.612799378000133],
            [27.38512902800008, 9.604789531000065],
            [27.528066040000112, 9.605357972000121],
            [27.609301392000106, 9.595177714000059],
            [27.61508915200008, 9.595797831000112],
            [27.63591475400011, 9.601378886000134],
            [27.641495809000048, 9.60194732700009],
            [27.769601685000055, 9.58331797300012],
            [27.86835534700009, 9.588511455000045],
            [27.884788452000038, 9.59137949600003],
            [27.895072062000054, 9.595410258000115],
            [27.997075859000063, 9.384930027000038],
            [28.04510953300013, 9.331406789000141],
            [28.44382985350012, 9.32798135700014],
            [28.84255017400011, 9.324555925000126],
            [28.843840924000062, 9.3245448360001],
            [28.83148940700002, 9.349247868000077],
            [28.82737223500007, 9.384930027000038],
            [28.828744626000116, 9.427474139000125],
            [28.849330486000042, 9.465901079000076],
            [28.91383284900013, 9.529031051000104],
            [28.98947554500009, 9.587090352000061],
            [29.009474324000024, 9.603239237000139],
            [29.132257527000093, 9.66773142500007],
            [29.252353556000116, 9.711165467000072],
            [29.48308882700013, 9.761679179000097],
            [29.567321412000126, 9.841364238000054],
            [29.61388187700004, 9.914460551000104],
            [29.615432170000076, 10.058146871000048],
            [29.645869589000142, 10.081711325000057],
            [29.700956665000035, 10.115016785000094],
            [29.967813762000105, 10.243329366000069],
            [30.01297896300008, 10.270485332000135],
            [30.248778523500107, 10.12125671450005],
            [30.484578084000134, 9.972028097000049],
            [30.749264771000128, 9.735763448000057],
            [30.765284465000093, 9.724291281000134],
            [30.77908207200005, 9.719872946000038],
            [30.79303470900004, 9.728011984000133],
            [30.804816935000133, 9.738941549000117],
            [30.824092245000088, 9.746176249000087],
            [30.83695967600005, 9.749354350000132],
            [30.949909851000086, 9.752446052000067],
            [30.950234416000058, 9.752454936000092],
            [31.164381551000133, 9.76400461800003],
            [31.234816528000067, 9.79232330400012],
            [31.449816324500034, 10.003279419500089],
            [31.664816121000115, 10.214235535000057],
            [31.77421512900014, 10.348775126000106],
            [31.801965373000087, 10.37624115000007],
            [31.864183797000067, 10.472126770000031],
            [31.92986454300012, 10.636922913000106],
            [31.942887004000056, 10.655552266000072],
            [32.17847985850011, 10.853201700500108],
            [32.41407271300011, 11.050851135000073],
            [32.430712524000114, 11.08219289100009],
            [32.43536340300005, 11.10702341800004],
            [32.36415328000004, 11.240012716000066],
            [32.34875370300006, 11.307579651000125],
            [32.345704793000095, 11.4116301480001],
            [32.359812459000125, 11.573480733000068],
            [32.354851522000104, 11.675774231000062],
            [32.3529911710001, 11.68737559100012],
            [32.34834029100011, 11.70316274000001],
            [32.3452397050001, 11.70910553000003],
            [32.082206665000115, 11.999811300000104],
            [32.414434448000065, 12.001271159000098],
            [32.74666223100007, 12.002731018000105],
            [32.74821252400005, 12.026812236000055],
            [32.74759240700013, 12.039524638000103],
            [32.74557702700014, 12.051125997000057],
            [32.73301965300004, 12.085981750000116],
            [32.725733276000085, 12.132335510000118],
            [32.72526818800014, 12.145254619000127],
            [32.72619836400008, 12.157941183000077],
            [32.730074097000056, 12.18189320900008],
            [32.73038415500014, 12.194863993000098],
            [32.72971236200004, 12.201065165000088],
            [32.72852380400013, 12.206852926000067],
            [32.7288338620001, 12.211917216000046],
            [32.73177941900008, 12.216154684000088],
            [33.20921797700004, 12.210366923000024],
            [33.20301680500006, 12.128098043000065],
            [33.14498417200008, 11.934673157000105],
            [33.14601770000007, 11.818659566000093],
            [33.132426799000086, 11.686212871000095],
            [33.129016154000055, 11.675490011000093],
            [33.11599369300012, 11.646938782000035],
            [33.10457320100011, 11.630583191000085],
            [33.09144738800012, 11.61479604100009],
            [33.08772668500012, 11.608853251000085],
            [33.08323083500011, 11.599163920000052],
            [33.08292077700008, 11.584565328000082],
            [33.132504313500135, 11.213903198500034],
            [33.18208785000007, 10.843241069000058],
            [33.17836714700013, 10.824534200000073],
            [33.17464644400013, 10.812286886000052],
            [33.14823978700008, 10.766036479000078],
            [33.14141849800012, 10.750817770000054],
            [33.140023234000125, 10.739035543000057],
            [33.15072025600006, 10.730974019000058],
            [33.37060347500005, 10.650901387000104],
            [33.38130049600011, 10.645785421000113],
            [33.38982710800008, 10.639248353000127],
            [33.46899540200013, 10.543905335000119],
            [33.68554549150008, 10.367972921000117],
            [33.90209558100008, 10.19204050700003],
            [33.916978393000136, 10.174522197000073],
            [33.96178186000009, 10.064037984000052],
            [33.966794475000086, 10.04726898200009],
            [33.968344767000076, 10.020810648000094],
            [33.967259562000095, 10.000269267000121],
            [33.95609745300004, 9.933994242000026],
            [33.9598181560001, 9.904202779000116],
            [33.967259562000095, 9.884514058000065],
            [33.97325402800004, 9.861776428000084],
            [33.97325402800004, 9.8548517870001],
            [33.97237552900009, 9.848883158000092],
            [33.96911991400009, 9.838341167000124],
            [33.90488610800014, 9.710700379000045],
            [33.88390547700004, 9.619853210000059],
            [33.877704305000066, 9.543423768000096],
            [33.881425008000065, 9.499214580000086],
            [33.888711385000136, 9.470818380000068],
            [33.89201867700007, 9.464281312000082],
            [33.894809204000126, 9.459475403000084],
            [33.89775476000011, 9.456581523000096],
            [33.90085534700006, 9.455289612000044],
            [34.070697863000134, 9.454592111000068],
            [34.083096425000065, 9.205117371000057],
            [34.09747332200004, 8.915836019000068],
            [34.111850219000075, 8.626554667000079],
            [34.1072506590001, 8.601530867000122],
            [34.10316857900011, 8.579322408000039],
            [34.09024947100011, 8.556507263000043],
            [34.06957889800009, 8.533614604000121],
            [33.970773559000065, 8.445377096000044],
            [33.950309692000076, 8.433207296000134],
            [33.93170617700014, 8.42814300600007],
            [33.87517216000009, 8.427936299000109],
            [33.84085900900004, 8.42398305200004],
            [33.82411584500011, 8.419487203000102],
            [33.80809615000004, 8.412614238000046],
            [33.797657512000114, 8.405612081000044],
            [33.756213012000046, 8.370136211000101],
            [33.751872193000054, 8.368792623000047],
            [33.74102014200014, 8.367087301000069],
            [33.695544881000046, 8.372875062000048],
            [33.67130863400007, 8.400289409000095],
            [33.651671590000035, 8.434499206000083],
            [33.62040734900006, 8.46069915800011],
            [33.60009851000012, 8.463954773000097],
            [33.58537072800004, 8.458115336000105],
            [33.571159708000096, 8.450131327000037],
            [33.55214278200009, 8.446824036000038],
            [33.537053263000075, 8.453206075000068],
            [33.52196374500011, 8.465324199000065],
            [33.50511722800013, 8.474884338000066],
            [33.48475671400007, 8.474005839000114],
            [33.49033776800013, 8.466512756000085],
            [33.48992435700012, 8.462921245000103],
            [33.48051924600014, 8.457650249000082],
            [33.41313317800012, 8.449717916000026],
            [33.40016239400012, 8.452637635000116],
            [33.392100870000036, 8.451862488000103],
            [33.384607788000096, 8.448012594000062],
            [33.370861857000136, 8.437393087000075],
            [33.36135339300006, 8.43429250100013],
            [33.252729533000036, 8.458167013000121],
            [33.23515954600009, 8.455634867000128],
            [33.20642745000009, 8.430571798000116],
            [33.207357626000146, 8.426592712000044],
            [33.21035485800013, 8.42077911400007],
            [33.20291345200013, 8.414112854000052],
            [33.18782393400011, 8.41103810700011],
            [33.17407800300009, 8.404475200000121],
            [33.16953047700014, 8.397421366000117],
            [33.167876831000115, 8.389721579000124],
            [33.167980184000044, 8.372823385000032],
            [33.16684330200013, 8.368275859000093],
            [33.161882365000054, 8.361506246000062],
            [33.161158894000096, 8.356106059000084],
            [33.16332930500005, 8.35295379700004],
            [33.17232100500013, 8.34652008100008],
            [33.17407800300009, 8.34305776000005],
            [33.171804240000085, 8.330887960000041],
            [33.163122599000076, 8.312051901000117],
            [33.161158894000096, 8.304584656000088],
            [33.164362834000144, 8.292776591000077],
            [33.171390829000075, 8.283113099000062],
            [33.17841882300007, 8.275671692000046],
            [33.185756877000074, 8.264509583000105],
            [33.19485192800005, 8.25923858700007],
            [33.208287802000086, 8.253683370000061],
            [33.20689253800009, 8.240738423000053],
            [33.1998645430001, 8.235519105000037],
            [33.190511109000056, 8.232418518000088],
            [33.18162276200013, 8.225726420000072],
            [33.17397465000005, 8.214590149000045],
            [33.16994388900008, 8.205495097000068],
            [33.168290242000126, 8.195392355000124],
            [33.167980184000044, 8.18136220300002],
            [33.17108077000006, 8.175962016000142],
            [33.18472334800009, 8.166246846000107],
            [33.18782393400011, 8.16089833600006],
            [33.1851367590001, 8.141080424000066],
            [33.177281942000036, 8.127101949000064],
            [33.16477624500004, 8.117050883000047],
            [33.147516317000054, 8.109066874000064],
            [33.117543986000044, 8.10415761400013],
            [33.11340987200009, 8.099093322000058],
            [33.111342814000125, 8.090644226000066],
            [33.10658858200014, 8.080489807000106],
            [33.10059411600014, 8.07103302000013],
            [33.04385339300012, 8.013465475000089],
            [33.03114099200013, 7.996308899000041],
            [33.02607670000009, 7.986283671000109],
            [33.021632528000055, 7.965251363000093],
            [33.016774943000144, 7.958326722000024],
            [33.01202071100005, 7.953314107000054],
            [33.00756888300015, 7.944057830000062],
            [33.00680139200006, 7.9424620570001],
            [32.99357222500004, 7.928147685000113],
            [32.98979984500011, 7.917243958000142],
            [33.01501794400008, 7.850633036000147],
            [33.02349287900006, 7.835078430000124],
            [33.040752808000036, 7.824846497000053],
            [33.04462854000013, 7.816423238000056],
            [33.04767744900005, 7.807276510000065],
            [33.05129480000011, 7.801127014000102],
            [33.05832279400005, 7.797974752000044],
            [33.08540124500007, 7.794977519000028],
            [33.10751875800008, 7.78521067300008],
            [33.12085127800009, 7.783298645000059],
            [33.12694909700008, 7.791566874000097],
            [33.13211674000007, 7.793943990000045],
            [33.16451786300007, 7.801127014000102],
            [33.172941121000065, 7.799628398000095],
            [33.20146651200014, 7.78815623000007],
            [33.233919312000126, 7.783195292000116],
            [33.24239424700005, 7.780714824000057],
            [33.257793824000146, 7.76743398000005],
            [33.273503459000096, 7.749192200000081],
            [33.29159021000004, 7.733069153000102],
            [33.34714237500009, 7.718961487000072],
            [33.359803100000136, 7.719271545000055],
            [33.384401083000114, 7.73544626900005],
            [33.39328942900005, 7.739735412000115],
            [33.43649092600009, 7.748572082000109],
            [33.4623291420001, 7.749502258000078],
            [33.47953739400009, 7.743146057000047],
            [33.48847741700013, 7.736169739000047],
            [33.506822551000084, 7.730950419000038],
            [33.516796102000114, 7.726092835000102],
            [33.52651127100006, 7.717101136000068],
            [33.54036055500012, 7.698911032000126],
            [33.55085087100014, 7.691314596000069],
            [33.572296590000064, 7.685216777000107],
            [33.63720218900011, 7.691314596000069],
            [33.647744181000064, 7.688627422000124],
            [33.675029338000115, 7.670850729000094],
            [33.70655196200005, 7.661859029000055],
            [33.71606042500014, 7.657156474000075],
            [33.729444621000084, 7.642118632000091],
            [33.76107059700007, 7.598141988000052],
            [33.81150679500007, 7.560986634000059],
            [33.821428670000046, 7.558402812000054],
            [33.842099243000064, 7.555922344000081],
            [33.852537882000036, 7.553545228000118],
            [33.88240686000006, 7.536078593000084],
            [34.00653365100004, 7.409936422000015],
            [34.02369022600004, 7.382444560000039],
            [34.0306148680001, 7.348699850000074],
            [34.03113163200004, 7.255372213000015],
            [34.03361210100013, 7.250256247000024],
            [34.04001997900008, 7.247259013000104],
            [34.085908651000125, 7.211498922000089],
            [34.11319380700013, 7.177547506000067],
            [34.13241743900005, 7.163388163000121],
            [34.151124308000135, 7.167470602000037],
            [34.16776412000007, 7.175377096000076],
            [34.1814066980001, 7.167212219000064],
            [34.19091516100008, 7.149538880000065],
            [34.1957727460001, 7.129023336000088],
            [34.1957727460001, 7.09773974800008],
            [34.1957727460001, 7.086958720000055],
            [34.19825321500008, 7.064376119000116],
            [34.206004679000046, 7.05450592000004],
            [34.21375614400006, 7.051973776000054],
            [34.219957316000034, 7.046134338000059],
            [34.229879191000066, 7.033370260000098],
            [34.270806925000045, 7.003397929000059],
            [34.27566451000007, 6.997403463000111],
            [34.28072880000008, 6.980091858000023],
            [34.287653442000135, 6.975285950000114],
            [34.29447473200008, 6.972237040000081],
            [34.29757531700005, 6.96856801300008],
            [34.439168742000106, 6.934874979000128],
            [34.503660929000034, 6.89001983600005],
            [34.5123425700001, 6.876842346000061],
            [34.51906050600013, 6.861649475000135],
            [34.52329797400006, 6.844182841000091],
            [34.52474491400005, 6.824571635000069],
            [34.52257450400009, 6.82178110800001],
            [34.51327274600004, 6.815295715000047],
            [34.511102335000146, 6.814313863000081],
            [34.51213586400013, 6.808267720000032],
            [34.51668339000008, 6.798061626000063],
            [34.51792362500004, 6.793824158000106],
            [34.52474491400005, 6.752870586000085],
            [34.53632043400012, 6.743077901000021],
            [34.553993774000105, 6.739253845000079],
            [34.596678507000036, 6.739202169000066],
            [34.618485962000136, 6.736540833000049],
            [34.635539185000084, 6.729822896000115],
            [34.70354536900004, 6.684916077000111],
            [34.709643188000086, 6.674012349000051],
            [34.71450077300011, 6.655667216000069],
            [34.726593058000105, 6.641947124000041],
            [34.73351770000011, 6.637606303000069],
            [34.743542928000124, 6.596807760000075],
            [34.75387821500004, 6.556422628000107],
            [34.77609908000005, 6.499449361000117],
            [34.784263957000064, 6.441830139000075],
            [34.7927388920001, 6.421676330000096],
            [34.83263309700004, 6.353540955000085],
            [34.839040975000046, 6.327599386000131],
            [34.83976444500007, 6.268688253000036],
            [34.844725382000036, 6.248689474000088],
            [34.87996870900008, 6.187633769000101],
            [34.898882283000034, 6.138670349000094],
            [34.91552209500014, 6.119705099000043],
            [34.934435669000095, 6.102367656000041],
            [34.95148889200004, 6.081180319000083],
            [34.959447062000095, 6.061724142000088],
            [34.96796399900012, 6.008131317000036],
            [34.96978234900007, 5.996689352000118],
            [34.95924035600012, 5.975502014000071],
            [34.955726359000096, 5.964210714000089],
            [34.95531294800014, 5.952557678000034],
            [34.960377238000035, 5.941705627000076],
            [34.976810344000114, 5.924032288000078],
            [34.97991092900014, 5.912844340000049],
            [34.977740519000065, 5.89865915900009],
            [34.97453658100005, 5.88723866800008],
            [34.97267622900006, 5.876257426000095],
            [34.974433228000066, 5.863105774000118],
            [34.98435510300004, 5.84101409900012],
            [35.06528039500006, 5.726447449000091],
            [35.07954309100012, 5.699782409000051],
            [35.08822473100008, 5.641749777000086],
            [35.0986633710001, 5.622474467000046],
            [35.143311808000135, 5.589659933000036],
            [35.223410278000074, 5.542996114000047],
            [35.26196089700005, 5.5118869020001],
            [35.26929895000006, 5.491784769000034],
            [35.273639771000035, 5.479873352000098],
            [35.26764530400004, 5.468556214000031],
            [35.25896366400008, 5.458143412000098],
            [35.25183231600005, 5.44736887600007],
            [35.250695435000125, 5.435147400000048],
            [35.25462284300011, 5.425923157000042],
            [35.287489054000105, 5.374091696000065],
            [35.30237186700003, 5.357374369000112],
            [35.320768677000046, 5.348718567000063],
            [35.344953247000035, 5.35236175600005],
            [35.36748417200005, 5.368045553000115],
            [35.40820520000011, 5.412564799000108],
            [35.43021936100007, 5.427215068000095],
            [35.44820275900008, 5.43075490300015],
            [35.46928674300011, 5.43075490300015],
            [35.490164021000055, 5.428041890000117],
            [35.50804406700013, 5.423416850000066],
            [35.53078169800011, 5.410084330000132],
            [35.57387984200011, 5.375331930000087],
            [35.59816776500014, 5.368743185000099],
            [35.62193892400006, 5.373781636000075],
            [35.639818970000135, 5.38207570400003],
            [35.65831913300008, 5.386416525000101],
            [35.683640584000045, 5.379595235000053],
            [35.7493730060001, 5.339158427000072],
            [35.80415002500007, 5.318022767000031],
            [35.809110962000034, 5.309108581000103],
            [35.78203251100007, 5.269860332000036],
            [35.77531457500004, 5.246580099000113],
            [35.77841516100011, 5.227149760000131],
            [35.79825891100006, 5.189270936000042],
            [35.80714725700011, 5.165267232000119],
            [35.80735396300008, 5.144674174000031],
            [35.79918908700006, 5.12462371800008],
            [35.76094852700004, 5.076332093000062],
            [35.75588423700009, 5.063438823000055],
            [35.75164676900005, 4.85435597700004],
            [35.7600183510001, 4.805728455000036],
            [35.784512981000034, 4.764180603000042],
            [35.92083540900012, 4.619331563000088],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Somalia',
        iso3: 'SOM',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [46.46696287700007, 6.538292406000039],
            [46.488045695000096, 6.558644715000099],
            [46.5084062090001, 6.578307597000048],
            [46.55320967600011, 6.621457418000077],
            [46.59806482000005, 6.664633077000104],
            [46.61842533400011, 6.684244284000044],
            [46.66700118000011, 6.731114807000068],
            [46.71557702600012, 6.777985331000096],
            [46.76410119600007, 6.824881694000055],
            [46.81272871900012, 6.871674704000057],
            [46.86140791800011, 6.918596903000108],
            [46.909983765000106, 6.965467428000053],
            [46.95855961100011, 7.012286276000069],
            [47.007032105000064, 7.059208476000023],
            [47.05560795100007, 7.106079],
            [47.10428715000012, 7.153001201000095],
            [47.15286299700011, 7.199820048000021],
            [47.20143884300012, 7.246690572000148],
            [47.250118042000054, 7.293509420000078],
            [47.298797241000045, 7.340379944000105],
            [47.34737308700005, 7.38730214400006],
            [47.395948934000046, 7.434172669000091],
            [47.44452478000005, 7.481043193000033],
            [47.49310062700005, 7.527913717000061],
            [47.5323881060001, 7.565863750000091],
            [47.54167647300005, 7.574835917000115],
            [47.59025232000005, 7.62165476500013],
            [47.638931519000096, 7.668525289000073],
            [47.6875073650001, 7.715395813000015],
            [47.73603153500005, 7.762214661000115],
            [47.7846590580001, 7.809136862000074],
            [47.83318322800005, 7.855955709000099],
            [47.88181075000006, 7.902826233000042],
            [47.93059330300014, 7.949696757000069],
            [47.97916914900014, 7.996567281000097],
            [48.03911381000012, 8.087491964],
            [48.09905847200008, 8.178519999000045],
            [48.15900313300011, 8.269418844000128],
            [48.219154500000116, 8.360317689000041],
            [48.279099162000136, 8.45116485600002],
            [48.33914717600004, 8.542089539000116],
            [48.39929854400009, 8.633117574000053],
            [48.459243205000064, 8.72388722700012],
            [48.51918786600004, 8.81491526300006],
            [48.57918420400006, 8.905839946000057],
            [48.63933557100012, 8.996661275000037],
            [48.699228556000094, 9.087689311000062],
            [48.759224895000045, 9.178510641000045],
            [48.81932458500012, 9.26938364700004],
            [48.87911421700005, 9.360308329000134],
            [48.93911055500007, 9.451233012000046],
            [48.93911055500007, 9.562700993000107],
            [48.93911055500007, 9.56360341400007],
            [48.93911055500007, 9.675999655000112],
            [48.93911055500007, 9.788421733000064],
            [48.93911055500007, 9.900714620000073],
            [48.93911055500007, 10.013033346000086],
            [48.93911055500007, 10.125429586000038],
            [48.93911055500007, 10.237799988000063],
            [48.93911055500007, 10.350118713000072],
            [48.93911055500007, 10.46256663100013],
            [48.93911055500007, 10.574937032000065],
            [48.93911055500007, 10.687333272000103],
            [48.93911055500007, 10.799600322000103],
            [48.93911055500007, 10.912022401000058],
            [48.93911055500007, 11.02436696400008],
            [48.93911055500007, 11.136737366000105],
            [48.939111999918396, 11.249129976167438],
            [48.97681725400008, 11.25141022300005],
            [49.108409050000034, 11.276597398000092],
            [49.23959394600007, 11.300279039000088],
            [49.278086785000085, 11.316961981000077],
            [49.293304884000065, 11.337958075000074],
            [49.303477410000085, 11.345445054000038],
            [49.31592858200008, 11.340521552000041],
            [49.32545006600009, 11.335109768000052],
            [49.33570397200003, 11.33462148600006],
            [49.40007571700005, 11.340521552000041],
            [49.41920006600009, 11.34479401200008],
            [49.43506920700008, 11.351060289000088],
            [49.488617384000065, 11.381740627000056],
            [49.50733483200008, 11.385199286000045],
            [49.52173912900008, 11.393784898000092],
            [49.54444420700008, 11.436712958000044],
            [49.558604363000086, 11.453517971000053],
            [49.576833530000044, 11.46002838700008],
            [49.599619988000086, 11.461737372000073],
            [49.644541863000086, 11.460353908000059],
            [49.65007571700005, 11.462144273000092],
            [49.666026238000086, 11.471136786000045],
            [49.67530358200008, 11.473944403000075],
            [49.68677819100009, 11.474351304000038],
            [49.71631920700008, 11.46775950700004],
            [49.80486087300005, 11.458400783000059],
            [49.85124759200005, 11.464911200000074],
            [49.88070722700007, 11.488226630000042],
            [49.88851972700007, 11.48729075700004],
            [49.90642337300005, 11.498724677000041],
            [49.917979363000086, 11.501898505000042],
            [49.921885613000086, 11.503851630000042],
            [49.93441816500007, 11.512884833000044],
            [49.942149285000085, 11.515570380000042],
            [49.94947350400008, 11.514960028000075],
            [49.95630944100009, 11.512518622000073],
            [49.96111087300005, 11.509955145000049],
            [49.96265709700003, 11.508734442000048],
            [50.05388431100005, 11.511379299000055],
            [50.07252037900008, 11.508734442000048],
            [50.131521030000044, 11.539943752000056],
            [50.151133660000085, 11.557928778000075],
            [50.16187584700003, 11.563381252000056],
            [50.197601759000065, 11.562648830000057],
            [50.20655358200008, 11.566799221000053],
            [50.21436608200008, 11.572658596000053],
            [50.22543379000007, 11.57811107000009],
            [50.268321160000085, 11.58930084800005],
            [50.28891035200007, 11.602443752000056],
            [50.37232506600009, 11.66893138200004],
            [50.41814212300005, 11.67804596600007],
            [50.43702233200008, 11.690619208000044],
            [50.47038821700005, 11.727850653000075],
            [50.50082441500007, 11.754828192000048],
            [50.512705925000034, 11.771226304000038],
            [50.517588738000086, 11.792669989000046],
            [50.51889082100007, 11.815252997000073],
            [50.52295983200008, 11.837958075000074],
            [50.52947024800005, 11.859523830000057],
            [50.53858483200008, 11.878648179000038],
            [50.561208530000044, 11.907904364000046],
            [50.57593834700003, 11.92096588700008],
            [50.589854363000086, 11.926459052000041],
            [50.60206139400003, 11.92796458500004],
            [50.62745201900003, 11.940130927000041],
            [50.63209069100009, 11.946763414000088],
            [50.63648522200003, 11.951605536000045],
            [50.64112389400003, 11.954413153000075],
            [50.647146030000044, 11.954046942000048],
            [50.65593509200005, 11.948431708000044],
            [50.66146894600007, 11.94757721600007],
            [50.68295332100007, 11.95335521000004],
            [50.72486412900008, 11.971136786000045],
            [50.76156660200007, 11.97874583500004],
            [50.77198326900003, 11.98578522300005],
            [50.79786358500007, 11.989118646000065],
            [50.86705530800003, 11.942890981000062],
            [50.97008258900007, 11.932322507000038],
            [51.029307488000086, 11.88507721600007],
            [51.048838738000086, 11.878648179000038],
            [51.127696160000085, 11.878648179000038],
            [51.147227410000085, 11.873602606000077],
            [51.18116295700008, 11.85537344000005],
            [51.19971764400003, 11.851304429000038],
            [51.22291100400008, 11.850775458000044],
            [51.247080925000034, 11.84756094000005],
            [51.26734459700003, 11.839422919000071],
            [51.29269816200008, 11.833107906000066],
            [51.277354363000086, 11.800604559000078],
            [51.266380566000066, 11.759286141000075],
            [51.249359010000035, 11.728775444000064],
            [51.255707715000085, 11.68165454700005],
            [51.24780098200006, 11.652391025000043],
            [51.22954044100004, 11.635896993000074],
            [51.21252904600004, 11.607946950000041],
            [51.18124454700006, 11.578828739000073],
            [51.14812259200005, 11.536037502000056],
            [51.12476647200003, 11.511786200000074],
            [51.12086022200003, 11.50531647300005],
            [51.12191816500007, 11.49412669500009],
            [51.12663821700005, 11.47882721600007],
            [51.127696160000085, 11.470892645000049],
            [51.125010613000086, 11.44798411700009],
            [51.11841881600009, 11.426255601000037],
            [51.08619225400008, 11.357163804000038],
            [51.08130944100009, 11.341498114000046],
            [51.07935631600009, 11.275946356000077],
            [51.07252037900008, 11.233791408000059],
            [51.085948113000086, 11.187974351000037],
            [51.13094468600008, 11.160751984000058],
            [51.174439663000044, 11.15876364400009],
            [51.189504078000084, 11.138306071000045],
            [51.164398634000065, 11.116766669000071],
            [51.14226321700005, 11.068426825000074],
            [51.13135826900003, 11.052883205000057],
            [51.123789910000085, 11.038763739000046],
            [51.11833743600005, 11.016913153000075],
            [51.11508222700007, 10.993353583000044],
            [51.12452233200008, 10.85455963700008],
            [51.13819420700008, 10.67674388200004],
            [51.16065514400003, 10.598456122000073],
            [51.154307488000086, 10.587713934000078],
            [51.13135826900003, 10.583929755000042],
            [51.107432488000086, 10.576564846000053],
            [51.101898634000065, 10.55857982000009],
            [51.10718834700003, 10.515041408000059],
            [51.102224155000044, 10.494696356000077],
            [51.09229576900003, 10.482163804000038],
            [51.076914910000085, 10.475816148000092],
            [51.055674675000034, 10.47406647300005],
            [51.035817905000044, 10.46751536700009],
            [51.018321160000085, 10.452093817000048],
            [51.010101759000065, 10.434027411000045],
            [51.01840254000007, 10.419419664000088],
            [51.038096550000034, 10.416083075000074],
            [51.190440300000034, 10.446112372000073],
            [51.20093834700003, 10.44476959800005],
            [51.211924675000034, 10.441839911000045],
            [51.22038821700005, 10.44204336100006],
            [51.22388756600009, 10.44985586100006],
            [51.21957441500007, 10.461004950000074],
            [51.21021569100009, 10.46710846600007],
            [51.20085696700005, 10.471502997000073],
            [51.19654381600009, 10.477443752000056],
            [51.19581139400003, 10.50031159100007],
            [51.19304446700005, 10.521185614000046],
            [51.18677819100009, 10.541571356000077],
            [51.176117384000065, 10.56281159100007],
            [51.191742384000065, 10.548976955000057],
            [51.20733970800006, 10.538096169000085],
            [51.22064688800003, 10.524928378000084],
            [51.237965935000034, 10.515024253000092],
            [51.24661989700007, 10.509089677000077],
            [51.25794208900004, 10.503801198000076],
            [51.28055649500004, 10.487330051000072],
            [51.29253239700006, 10.480075168000042],
            [51.31120017600006, 10.476054565000084],
            [51.32587915300007, 10.472679851000066],
            [51.33587133100008, 10.47461426600006],
            [51.34587485700007, 10.48049388600009],
            [51.35720966700006, 10.483740236000074],
            [51.377855941000064, 10.481689558000085],
            [51.39517347200007, 10.479022816000054],
            [51.403077385000074, 10.456707060000042],
            [51.41703781100006, 10.447485379000057],
            [51.41096496500006, 10.429813657000068],
            [51.397508902000084, 10.395793167000079],
            [51.38502037900008, 10.391506252000056],
            [51.380154238000046, 10.387339056000087],
            [51.37256920700008, 10.381415106000077],
            [51.37608015300003, 10.367693175000056],
            [51.36741919200006, 10.367725742000061],
            [51.34945834900009, 10.375001636000093],
            [51.33613051300006, 10.374395207000077],
            [51.32007897200003, 10.378485419000071],
            [51.300831439000035, 10.372565974000054],
            [51.27287252700006, 10.37790465800009],
            [51.26539147200003, 10.396877346000053],
            [51.26295006600009, 10.408596096000053],
            [51.256602410000085, 10.420314846000053],
            [51.240977410000085, 10.425604559000078],
            [51.09009880800005, 10.407313042000055],
            [51.01712538900006, 10.38191604800005],
            [50.92738876300007, 10.327844449000054],
            [50.90987987600005, 10.295634720000066],
            [50.90170332100007, 10.234442450000074],
            [50.912813862000064, 10.176853487000074],
            [50.883799675000034, 10.101263739000046],
            [50.888682488000086, 10.05565013200004],
            [50.900401238000086, 10.02407461100006],
            [50.90170332100007, 10.011664130000042],
            [50.89975019600007, 10.00071849200009],
            [50.89079837300005, 9.986029364000046],
            [50.877696160000085, 9.91665273600006],
            [50.881195509000065, 9.905462958000044],
            [50.86963951900003, 9.884466864000046],
            [50.86312910200007, 9.866034247000073],
            [50.85401451900003, 9.816107489000046],
            [50.840586785000085, 9.779771226000037],
            [50.83326256600009, 9.768784898000092],
            [50.838633660000085, 9.740912177000041],
            [50.836924675000034, 9.73078034100007],
            [50.83171634200005, 9.712062893000052],
            [50.82447350400008, 9.651068427000041],
            [50.80616295700008, 9.62445709800005],
            [50.80551191500007, 9.593939520000049],
            [50.81299889400003, 9.541164455000057],
            [50.83676191500007, 9.477036851000037],
            [50.84034264400003, 9.45612213700008],
            [50.83741295700008, 9.437201239000046],
            [50.83033287900008, 9.419623114000046],
            [50.768321160000085, 9.319281317000048],
            [50.74830162900008, 9.303534247000073],
            [50.70630944100009, 9.285711981000077],
            [50.689463738000086, 9.27484772300005],
            [50.676768425000034, 9.259182033000059],
            [50.64698326900003, 9.211371161000045],
            [50.64112389400003, 9.19635651200008],
            [50.649180535000085, 9.132513739000046],
            [50.648448113000086, 9.11041901200008],
            [50.63363691500007, 9.073187567000048],
            [50.604502800000034, 9.037909247000073],
            [50.494883660000085, 8.951971747000073],
            [50.46412194100009, 8.92055898600006],
            [50.43970787900008, 8.888169664000088],
            [50.42204837300005, 8.857123114000046],
            [50.40796959700003, 8.816351630000042],
            [50.38982181100005, 8.733547268000052],
            [50.37427819100009, 8.698879299000055],
            [50.326508009000065, 8.641099351000037],
            [50.31959069100009, 8.620347398000092],
            [50.322601759000065, 8.559759833000044],
            [50.31959069100009, 8.541815497000073],
            [50.303477410000085, 8.504584052000041],
            [50.29021243600005, 8.486761786000045],
            [50.27491295700008, 8.47915273600006],
            [50.256195509000065, 8.47256094000005],
            [50.246104363000086, 8.456447658000059],
            [50.23910566500007, 8.436346747000073],
            [50.23015384200005, 8.417669989000046],
            [50.166026238000086, 8.333360093000067],
            [50.15642337300005, 8.32062409100007],
            [50.141368035000085, 8.287990627000056],
            [50.11304772200003, 8.19953034100007],
            [50.09107506600009, 8.161037502000056],
            [50.05827884200005, 8.13031647300005],
            [49.92937259200005, 8.05174388200004],
            [49.84205162900008, 7.962713934000078],
            [49.824229363000086, 7.93390534100007],
            [49.812510613000086, 7.897528387000079],
            [49.80323326900003, 7.82689036700009],
            [49.808604363000086, 7.815008856000077],
            [49.82341556100005, 7.80532461100006],
            [49.82764733200008, 7.782904364000046],
            [49.82504316500007, 7.757757880000042],
            [49.819346550000034, 7.739935614000046],
            [49.79078209700003, 7.69953034100007],
            [49.76091556100005, 7.667303778000075],
            [49.75220787900008, 7.650295315000051],
            [49.74830162900008, 7.606634833000044],
            [49.744151238000086, 7.589056708000044],
            [49.64079837300005, 7.409125067000048],
            [49.586599155000044, 7.31476471600007],
            [49.520518425000034, 7.239650783000059],
            [49.36703535200007, 7.02570221600007],
            [49.29322350400008, 6.880926825000074],
            [49.24732506600009, 6.810614325000074],
            [49.197927280000044, 6.673570054000038],
            [49.07471764400009, 6.415269273000092],
            [49.07203209700003, 6.39329661700009],
            [49.07406660200007, 6.370794989000046],
            [49.08350670700008, 6.329046942000048],
            [49.08562259200005, 6.30735911700009],
            [49.071299675000034, 6.219916083000044],
            [49.036143425000034, 6.144232489000046],
            [48.95149109296996, 5.998720092006307],
            [48.85010826900009, 5.824448960000041],
            [48.69581139400009, 5.58734772300005],
            [48.64673912900008, 5.480047919000071],
            [48.620127800000034, 5.44399648600006],
            [48.54810631600009, 5.375067450000074],
            [48.448008660000085, 5.208726304000038],
            [48.328868035000085, 5.079657294000071],
            [48.20240319100009, 4.90892161700009],
            [48.055674675000034, 4.612941799000055],
            [47.94849694100009, 4.457098700000074],
            [47.840586785000085, 4.341376044000071],
            [47.57797285200007, 4.059881903000075],
            [47.489268425000034, 3.936346747000073],
            [47.33562259200005, 3.77875397300005],
            [47.20671634200005, 3.644598700000074],
            [47.039805535000085, 3.469265041000085],
            [47.01295006600009, 3.441066799000055],
            [46.83423912900008, 3.232489325000074],
            [46.70004316500007, 3.113267320000091],
            [46.625743035000085, 3.023911851000094],
            [46.48780358200008, 2.90884023600006],
            [46.41431725400008, 2.83344147300005],
            [46.351573113000086, 2.788641669000071],
            [46.349619988000086, 2.780178127000056],
            [46.34489993600005, 2.770086981000077],
            [46.33920332100007, 2.761704820000091],
            [46.33448326900009, 2.758246161000045],
            [46.31763756600009, 2.751898505000042],
            [46.307627800000034, 2.736029364000046],
            [46.299815300000034, 2.715765692000048],
            [46.289398634000065, 2.696234442000048],
            [46.275401238000086, 2.68585846600007],
            [46.23650149800005, 2.667629299000055],
            [46.14234459700003, 2.568915106000077],
            [46.130869988000086, 2.554022528000075],
            [46.11451256600009, 2.523260809000078],
            [46.10499108200008, 2.510565497000073],
            [46.06299889400009, 2.484035549000055],
            [46.047618035000085, 2.455064195000091],
            [46.02702884200005, 2.43813711100006],
            [45.82634524800005, 2.308823960000041],
            [45.711924675000034, 2.244330145000049],
            [45.60564212300005, 2.18305084800005],
            [45.26620527400007, 1.987290757000039],
            [45.23218834700003, 1.967678127000056],
            [45.21070397200003, 1.963120835000041],
            [45.19971764400009, 1.95962148600006],
            [45.00147545700008, 1.866359768000052],
            [44.83155358200008, 1.749701239000046],
            [44.82398522200003, 1.740301825000074],
            [44.81218509200005, 1.735581773000092],
            [44.67628014400009, 1.637600002000056],
            [44.55005944100009, 1.559068101000094],
            [44.332774285000085, 1.389960028000075],
            [44.221364780000044, 1.275620835000041],
            [44.19841556100005, 1.265692450000074],
            [44.15788821700005, 1.240790106000077],
            [44.145518425000034, 1.229559637000079],
            [44.14210045700008, 1.221380927000041],
            [44.139659050000034, 1.211167710000041],
            [44.13803144600007, 1.191595770000049],
            [44.13396243600005, 1.187567450000074],
            [44.11500084700003, 1.182033596000053],
            [44.11085045700008, 1.178290106000077],
            [44.10377037900008, 1.168361721000053],
            [44.03288821700005, 1.097479559000078],
            [44.01254316500007, 1.084214585000041],
            [43.990977410000085, 1.078599351000094],
            [43.97877037900008, 1.06867096600007],
            [43.932627800000034, 1.009833075000074],
            [43.81983483200008, 0.949448960000041],
            [43.781911655000044, 0.921616929000038],
            [43.73422285200007, 0.854966539000088],
            [43.71729576900009, 0.845282294000071],
            [43.703461134000065, 0.840521552000041],
            [43.658946160000085, 0.804917710000041],
            [43.46762129000007, 0.62055084800005],
            [43.285492384000065, 0.414984442000048],
            [43.18490644600007, 0.31627024900007],
            [43.090179884000065, 0.22337474200009],
            [42.89112389400009, 0.003078518000052],
            [42.770274285000085, -0.129327080999929],
            [42.71208743600005, -0.176690362999921],
            [42.64779707100007, -0.228936455999929],
            [42.58033287900008, -0.297539971999925],
            [42.55591881600009, -0.332126559999949],
            [42.55355879000007, -0.342380466999941],
            [42.55396569100009, -0.35125090899993],
            [42.550791863000086, -0.357598565999922],
            [42.52662194100009, -0.362725518999923],
            [42.51929772200003, -0.369317315999922],
            [42.47974694100009, -0.422051690999922],
            [42.47445722700007, -0.438653252999927],
            [42.48650149800005, -0.449395440999922],
            [42.47641035200007, -0.465997002999927],
            [42.47282962300005, -0.469903252999927],
            [42.47291100400008, -0.463799737999921],
            [42.47242272200003, -0.45867278399993],
            [42.47046959700003, -0.454034112999921],
            [42.46599368600005, -0.449395440999922],
            [42.41260826900009, -0.490980726999908],
            [42.40455162900008, -0.500909112999921],
            [42.39795983200008, -0.517347914999959],
            [42.38266035200007, -0.535251559999949],
            [42.34986412900008, -0.565606377999927],
            [42.25025475400008, -0.685642184999949],
            [42.246755405000044, -0.694268487999921],
            [42.246755405000044, -0.701918226999908],
            [42.24529056100005, -0.707452080999929],
            [42.236338738000086, -0.709567966999941],
            [42.23259524800005, -0.713067315999922],
            [42.19223066500007, -0.776136976999908],
            [42.16651451900009, -0.802666924999926],
            [42.15162194100009, -0.813897393999923],
            [42.135508660000085, -0.821709893999923],
            [42.11646569100009, -0.826267184999949],
            [42.086599155000044, -0.825616143999923],
            [42.07154381600009, -0.828708591999941],
            [42.062510613000086, -0.839288018999923],
            [42.08171634200005, -0.84343840899993],
            [42.08090254000007, -0.862888278999947],
            [42.07195071700005, -0.88445403399993],
            [42.06568444100009, -0.894463799999926],
            [42.051442905000044, -0.90203215899993],
            [42.03695722700007, -0.920017184999949],
            [42.02556399800005, -0.941582940999922],
            [42.02084394600007, -0.960056247999944],
            [42.016368035000085, -0.96803150799991],
            [41.983164910000085, -0.994073174999926],
            [41.97193444100009, -0.999769789999959],
            [41.96794681100005, -0.992852471999925],
            [41.963633660000085, -0.95086028399993],
            [41.96469160200007, -0.911553643999923],
            [41.95883222700007, -0.894463799999926],
            [41.95281009200005, -0.894463799999926],
            [41.955414259000065, -0.909600518999923],
            [41.95240319100009, -0.920830987999921],
            [41.94752037900008, -0.930840752999927],
            [41.94516035200007, -0.942966403999947],
            [41.94646243600005, -0.95476653399993],
            [41.95142662900008, -0.969414971999925],
            [41.95281009200005, -0.980401299999926],
            [41.95557701900009, -0.992933851999908],
            [41.96225019600007, -0.998955987999921],
            [41.96924889400009, -1.00318775799991],
            [41.97315514400009, -1.011163018999923],
            [41.971690300000034, -1.023614190999922],
            [41.96143639400009, -1.044122002999927],
            [41.95883222700007, -1.055840752999927],
            [41.953461134000065, -1.068617445999962],
            [41.930023634000065, -1.089939059999949],
            [41.92465254000007, -1.097100518999923],
            [41.92302493600005, -1.110121351999908],
            [41.918304884000065, -1.121026299999926],
            [41.91163170700008, -1.130954684999949],
            [41.87387129000007, -1.176039320999962],
            [41.869476759000065, -1.186211846999925],
            [41.87289472700007, -1.195489190999922],
            [41.88070722700007, -1.194919528999947],
            [41.89014733200008, -1.189385674999926],
            [41.897471550000034, -1.183200778999947],
            [41.885427280000044, -1.209649346999925],
            [41.86280358200008, -1.212334893999923],
            [41.84197024800005, -1.19695403399993],
            [41.83529707100007, -1.168877862999921],
            [41.829112175000034, -1.168877862999921],
            [41.83025149800005, -1.189222914999959],
            [41.84197024800005, -1.224867445999962],
            [41.842784050000034, -1.243910414999959],
            [41.836599155000044, -1.262302341999941],
            [41.73226972700007, -1.431084893999923],
            [41.70875084700003, -1.460056247999944],
            [41.68970787900008, -1.48951588299991],
            [41.65211022200003, -1.565118096999925],
            [41.63331139400009, -1.580336195999962],
            [41.61060631600009, -1.593194268999923],
            [41.57504316500007, -1.652601820999962],
            [41.55486087300005, -1.669691664999959],
            [41.56104576900009, -1.669691664999959],
            [41.535085483000046, -1.696302992999961],
            [41.535943705000136, -1.676312018999866],
            [41.53858036300005, -1.613698831999969],
            [41.534963012000105, -1.594785257999931],
            [41.52287072700011, -1.572771097999947],
            [41.484526815000095, -1.523161721999969],
            [41.43419397000008, -1.458049417999888],
            [41.38375777200008, -1.393040465999917],
            [41.33218469200011, -1.326377867999909],
            [41.282988728000134, -1.262815855999932],
            [41.237306763000106, -1.203904723999926],
            [41.18221968600005, -1.132694600999884],
            [41.13106001800014, -1.066445413999887],
            [41.08155399500009, -1.002573343999927],
            [41.05612919100008, -0.969603779999957],
            [41.03060103300004, -0.936737568999931],
            [41.00527958200007, -0.903768004999975],
            [40.97975142400014, -0.87079844099992],
            [40.97882124800009, -0.794834085999881],
            [40.977891072000034, -0.724347431999931],
            [40.97696089700008, -0.653860777999881],
            [40.9755139560001, -0.545236917999958],
            [40.974067016000106, -0.436716409999889],
            [40.97262007600011, -0.328299254999919],
            [40.97117313700011, -0.219675393999907],
            [40.970449666000036, -0.152185973999877],
            [40.96962284400007, -0.08469655299993],
            [40.9684859620001, -0.002737730999868],
            [40.9684859620001, 0.122319234000116],
            [40.9684859620001, 0.247272848000065],
            [40.9684859620001, 0.372329814000054],
            [40.9684859620001, 0.497283427000099],
            [40.9684859620001, 0.622340393000073],
            [40.9684859620001, 0.747242330000105],
            [40.9684859620001, 0.872247620000081],
            [40.9684859620001, 0.997201233000027],
            [40.9684859620001, 1.122206523000088],
            [40.9684859620001, 1.230295056000045],
            [40.9684859620001, 1.24721181200006],
            [40.9684859620001, 1.372191264000108],
            [40.9684859620001, 1.497144877000068],
            [40.9684859620001, 1.622150167000129],
            [40.9684859620001, 1.747181295000104],
            [40.9684859620001, 1.872134908000049],
            [40.9684859620001, 1.997166036000124],
            [40.9684859620001, 2.103619487000046],
            [40.9684859620001, 2.210047099000064],
            [40.9684859620001, 2.316500550000086],
            [40.9684859620001, 2.422954000000104],
            [40.9684859620001, 2.497109680000065],
            [40.96714237500004, 2.631726786000044],
            [40.96590214000008, 2.76060780800006],
            [40.96538537600014, 2.814144593],
            [40.97975142400014, 2.841894836000051],
            [41.013961222000034, 2.875794576000146],
            [41.096126749000064, 2.957081604000038],
            [41.178395630000125, 3.038420309000045],
            [41.26066451000008, 3.119810690000051],
            [41.34272668500006, 3.201149394000055],
            [41.394506470000124, 3.275150045000061],
            [41.44618290200009, 3.349047343000038],
            [41.49796268700004, 3.423073832000057],
            [41.54963912000005, 3.49702280700005],
            [41.6335616450001, 3.617092998000075],
            [41.71738081900014, 3.737163188000096],
            [41.801303344000075, 3.857181702000105],
            [41.885019165000074, 3.977226054000113],
            [41.898455038000066, 3.996914774000075],
            [41.91220096800009, 4.007973532000079],
            [41.91747196500012, 4.020453389000068],
            [41.91664514200011, 4.051097514000091],
            [41.923466431000065, 4.070553691000072],
            [41.941243123000106, 4.086211650000038],
            [42.01183313000007, 4.129490662000094],
            [42.06836714700012, 4.174552511000044],
            [42.10288700300009, 4.191889954000132],
            [42.135339803000136, 4.200080668000069],
            [42.221846151000136, 4.200959167000107],
            [42.297293742000136, 4.20173431400012],
            [42.41501265400012, 4.221707255000055],
            [42.568284952000056, 4.247855530000052],
            [42.718663371000105, 4.273487040000106],
            [42.78977014200012, 4.285605164000103],
            [42.8316280520001, 4.302322490000051],
            [42.868938436000064, 4.326765442000095],
            [42.8701948640001, 4.328170991000121],
            [42.8996342370001, 4.361104432000033],
            [42.91472375500007, 4.393298849000075],
            [42.93250044700011, 4.463217061000066],
            [42.945936320000044, 4.496858419000105],
            [42.952550903000144, 4.507581279000121],
            [42.960405721000086, 4.517373962000079],
            [43.035439901000075, 4.578894755000093],
            [43.11925907400007, 4.647701924000089],
            [43.232792196000105, 4.701497091000107],
            [43.34699711100012, 4.755653991000116],
            [43.459341675000076, 4.808829041000067],
            [43.52848474100006, 4.841566060000062],
            [43.64051924600011, 4.867352600000075],
            [43.71648360200004, 4.884793396000106],
            [43.81518558800013, 4.907479350000074],
            [43.84515791900009, 4.914352316000048],
            [43.93228438300008, 4.945203146000026],
            [43.96897465000012, 4.953962301000104],
            [44.02912601700007, 4.950448303000144],
            [44.08100915500006, 4.947451071000046],
            [44.132788940000125, 4.944479675000125],
            [44.18467207800012, 4.941430766000096],
            [44.23645186300013, 4.938485209000092],
            [44.28833500100012, 4.935487977000079],
            [44.34011478700006, 4.932439067000061],
            [44.391997925000055, 4.929467672000058],
            [44.44372603400012, 4.926444601000128],
            [44.49555749500013, 4.923473206000025],
            [44.54744063300012, 4.920475972000105],
            [44.596807717000104, 4.917643031000097],
            [44.59922041800007, 4.917504578000091],
            [44.651103556000066, 4.914507345000089],
            [44.70288334100013, 4.911561788000085],
            [44.754766479000125, 4.908564555000069],
            [44.80654626500012, 4.905541484000054],
            [44.85837772700006, 4.902544251000037],
            [44.912586304000115, 4.899391988000076],
            [44.941525106000086, 4.91148427300007],
            [45.020641724000086, 4.996879578000062],
            [45.020900106000056, 4.996879578000062],
            [45.07774418100007, 5.059072164000071],
            [45.18502445500013, 5.176248474000104],
            [45.29235640400009, 5.293476461000054],
            [45.39958500200004, 5.410704448000104],
            [45.50686527500011, 5.527880758000052],
            [45.51847745300006, 5.540564097000086],
            [45.61414554900006, 5.645057068000085],
            [45.72142582200007, 5.762336731000048],
            [45.82870609600013, 5.879513042000085],
            [45.93598636900009, 5.996689352000118],
            [45.99680953000012, 6.05919199600001],
            [46.05783939600008, 6.121720480000093],
            [46.118817586000034, 6.18422312400007],
            [46.179899129000034, 6.246725769000065],
            [46.24098067300014, 6.309228414000046],
            [46.302062215000035, 6.371731059000112],
            [46.36293705300011, 6.434259542000106],
            [46.423915242000135, 6.496736348000084],
            [46.46696287700007, 6.538292406000039],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Kenya',
        iso3: 'KEN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [35.70584560472605, 4.619447080539359],
              [35.705938713505645, 4.619962448315007],
              [35.71151833893896, 4.661608022601527],
              [35.73940198963447, 4.681126578088339],
              [35.77843910060807, 4.678338213018733],
              [35.781221547358086, 4.619922014081439],
              [35.85653615027104, 4.619603495646345],
              [35.92083540900012, 4.619331563000088],
              [35.92279911300005, 4.602071635000087],
              [35.93602827900014, 4.578533020000094],
              [35.937061808000124, 4.559257711000058],
              [35.93406457600008, 4.539207255000107],
              [35.93375451600008, 4.522179871000091],
              [35.94047245300004, 4.508046367000048],
              [35.958352499000114, 4.496858419000105],
              [35.99710982300013, 4.462958680000099],
              [36.018400512000085, 4.449135234000039],
              [36.04134484800005, 4.443683370000059],
              [36.04532476700007, 4.443716285000036],
              [36.1913098550001, 4.444923604000095],
              [36.225726359000134, 4.449600322000066],
              [36.23626835100009, 4.449651998000078],
              [36.24608687300008, 4.446990662000061],
              [36.26427697700012, 4.43820566900007],
              [36.27719608600012, 4.436448669000086],
              [36.463024536000034, 4.440169372000099],
              [36.61950077300014, 4.443373312000077],
              [36.628182414000094, 4.441461284000056],
              [36.642961873000104, 4.432598775000145],
              [36.64885675900007, 4.431179636000138],
              [36.6513334550001, 4.430583394000095],
              [36.844086548000064, 4.43223704100005],
              [36.90372115100007, 4.415778097000072],
              [36.97482792200009, 4.379940491000042],
              [37.01565230400007, 4.370587057000094],
              [37.025367473000074, 4.363274842000109],
              [37.04107710800008, 4.336816508000112],
              [37.048415161000094, 4.331958924000105],
              [37.06846561700013, 4.333457540000012],
              [37.07590702300013, 4.331080424000064],
              [37.08252160600006, 4.32216623900004],
              [37.086449015000085, 4.312476909000111],
              [37.091616659000124, 4.29025604300007],
              [37.09482059700008, 4.284881694000106],
              [37.09998824000007, 4.283693136000082],
              [37.10598270600008, 4.283848165000038],
              [37.111873820000085, 4.2822978720001],
              [37.16603072100014, 4.247545471000066],
              [37.26349247200011, 4.184887798000133],
              [37.36095422400007, 4.122204285000109],
              [37.4750557860001, 4.048978780000112],
              [37.55608443200009, 3.996888937000065],
              [37.647758423000084, 3.937874451000127],
              [37.751007934000086, 3.871521912000091],
              [37.84619592300004, 3.810337016000076],
              [37.94593143700013, 3.746232402000061],
              [37.97673059100009, 3.726440328000081],
              [37.99533410600014, 3.70791432700014],
              [38.020758911000144, 3.667167461000076],
              [38.036158488000126, 3.648925680000019],
              [38.048974243000146, 3.641846009000091],
              [38.07884322100006, 3.632673442000097],
              [38.10189091000012, 3.612648824000061],
              [38.11408654700011, 3.610607605000013],
              [38.14560917200009, 3.61843658500004],
              [38.17692509000011, 3.620917054000103],
              [38.28306848200015, 3.608902283000049],
              [38.38993534300005, 3.59688751200008],
              [38.4459525960001, 3.601667582000076],
              [38.49690555800004, 3.623940125000033],
              [38.49814579300005, 3.629676208000092],
              [38.49731896900005, 3.638590393000101],
              [38.49938602700013, 3.646910299000069],
              [38.50899784300009, 3.650811869000037],
              [38.51426883900007, 3.648512269000108],
              [38.533182414000066, 3.632828471000053],
              [38.541243937000104, 3.623294170000051],
              [38.54320764100004, 3.615387676000097],
              [38.547135051000055, 3.609522400000102],
              [38.561087687000054, 3.606008403000061],
              [38.5741101480001, 3.604561462000063],
              [38.57958784900012, 3.605310771000063],
              [38.59374719200014, 3.610840149000069],
              [38.59560754400013, 3.607507019000067],
              [38.596641073000114, 3.602132670000103],
              [38.601912069000036, 3.598670349000059],
              [38.660306437000145, 3.594458720000119],
              [38.66009973100006, 3.601305847000077],
              [38.661443318000124, 3.615335999000095],
              [38.66102990700011, 3.621950582000082],
              [38.68810835700009, 3.586293844000096],
              [38.703714640000044, 3.570429179000087],
              [38.72200809800012, 3.560403951000069],
              [38.82071008300011, 3.533738912000032],
              [38.895227498000054, 3.513585103000139],
              [38.92127242000004, 3.513998515000054],
              [38.963233684000045, 3.522085877000052],
              [38.97997684800009, 3.519812114000047],
              [38.994963013000074, 3.514256897000038],
              [39.01046594300004, 3.514463603000081],
              [39.0679301350001, 3.526581726000074],
              [39.077541951000114, 3.524256287000043],
              [39.09044144500007, 3.518334305000067],
              [39.18048140500008, 3.476998190000103],
              [39.219445434000136, 3.468704122000048],
              [39.2575826420001, 3.469685975000118],
              [39.296337554000104, 3.491990003000097],
              [39.30274784300008, 3.495679220000085],
              [39.315873657000054, 3.494904073000072],
              [39.32052453600011, 3.484542948000055],
              [39.3113261310001, 3.466094462000044],
              [39.43617639200005, 3.46237375900003],
              [39.46697554500008, 3.452012635000116],
              [39.47565718600009, 3.440798849000075],
              [39.48092818200007, 3.427259624000087],
              [39.488472941000055, 3.413901266000067],
              [39.50438928200009, 3.403333435000093],
              [39.536325317000035, 3.405012920000047],
              [39.553171834000125, 3.431316223000096],
              [39.574979289000055, 3.497901306000088],
              [39.600817505000066, 3.52890716600011],
              [39.66644657400008, 3.588722636000057],
              [39.74509810400008, 3.660578715000085],
              [39.76421838400006, 3.685745138000115],
              [39.78075484200008, 3.716570130000093],
              [39.808660116000055, 3.790286560000126],
              [39.82829716000009, 3.842583110000135],
              [39.848450969000055, 3.867284444000049],
              [39.934130493000055, 3.9087031050001],
              [40.02022342900011, 3.950121765000063],
              [40.11716841700007, 3.996914774000075],
              [40.16243697100009, 4.019394023000075],
              [40.1669844970001, 4.025259298000066],
              [40.166261027000076, 4.031486308000069],
              [40.16719120300007, 4.035465393000052],
              [40.17680301900009, 4.034535218000087],
              [40.17980025300011, 4.03282989500012],
              [40.182797485000094, 4.032003072000094],
              [40.18558801200004, 4.032158102000054],
              [40.286873820000096, 4.067453104000037],
              [40.36573205600013, 4.094867452000088],
              [40.371106404000045, 4.099931742000066],
              [40.37699751800005, 4.116080627000144],
              [40.38268192600009, 4.121377462000083],
              [40.51187300600009, 4.171064352000087],
              [40.617499634000126, 4.211604512000093],
              [40.70069869000014, 4.243514710000071],
              [40.76374393700013, 4.284933370000118],
              [40.78575809700004, 4.255839539000121],
              [40.84601281700009, 4.214989319000026],
              [40.870610799000076, 4.186980693000109],
              [40.88735396300012, 4.156052348000102],
              [40.89768925000004, 4.145923767000056],
              [40.91587935400008, 4.136647847000035],
              [40.96362837800007, 4.120369771000114],
              [40.97975142400014, 4.110757955000096],
              [41.005899699000054, 4.086676737000062],
              [41.07008182800007, 3.996914774000075],
              [41.114523560000066, 3.96234324100007],
              [41.16299605300014, 3.942680359000036],
              [41.215292602000034, 3.936608378000088],
              [41.3174052330001, 3.942421977000066],
              [41.42954309100014, 3.948881531000026],
              [41.47977258300011, 3.962937520000125],
              [41.506230917000096, 3.964384460000119],
              [41.586329386000045, 3.9841506960001],
              [41.60224572700008, 3.983065491000104],
              [41.628704061000064, 3.972084249000119],
              [41.642966756000135, 3.969448751000101],
              [41.65743615700006, 3.972704367000091],
              [41.69981083200008, 3.996914774000075],
              [41.747353150000095, 3.981411845000054],
              [41.79138147000009, 3.958157450000044],
              [41.83592655400008, 3.949449971000078],
              [41.885019165000074, 3.977226054000113],
              [41.801303344000075, 3.857181702000105],
              [41.71738081900014, 3.737163188000096],
              [41.6335616450001, 3.617092998000075],
              [41.54963912000005, 3.49702280700005],
              [41.49796268700004, 3.423073832000057],
              [41.44618290200009, 3.349047343000038],
              [41.394506470000124, 3.275150045000061],
              [41.34272668500006, 3.201149394000055],
              [41.26066451000008, 3.119810690000051],
              [41.178395630000125, 3.038420309000045],
              [41.096126749000064, 2.957081604000038],
              [41.013961222000034, 2.875794576000146],
              [40.97975142400014, 2.841894836000051],
              [40.96538537600014, 2.814144593],
              [40.96590214000008, 2.76060780800006],
              [40.96714237500004, 2.631726786000044],
              [40.9684859620001, 2.497109680000065],
              [40.9684859620001, 2.422954000000104],
              [40.9684859620001, 2.316500550000086],
              [40.9684859620001, 2.210047099000064],
              [40.9684859620001, 2.103619487000046],
              [40.9684859620001, 1.997166036000124],
              [40.9684859620001, 1.872134908000049],
              [40.9684859620001, 1.747181295000104],
              [40.9684859620001, 1.622150167000129],
              [40.9684859620001, 1.497144877000068],
              [40.9684859620001, 1.372191264000108],
              [40.9684859620001, 1.24721181200006],
              [40.9684859620001, 1.230295056000045],
              [40.9684859620001, 1.122206523000088],
              [40.9684859620001, 0.997201233000027],
              [40.9684859620001, 0.872247620000081],
              [40.9684859620001, 0.747242330000105],
              [40.9684859620001, 0.622340393000073],
              [40.9684859620001, 0.497283427000099],
              [40.9684859620001, 0.372329814000054],
              [40.9684859620001, 0.247272848000065],
              [40.9684859620001, 0.122319234000116],
              [40.9684859620001, -0.002737730999868],
              [40.96962284400007, -0.08469655299993],
              [40.970449666000036, -0.152185973999877],
              [40.97117313700011, -0.219675393999907],
              [40.97262007600011, -0.328299254999919],
              [40.974067016000106, -0.436716409999889],
              [40.9755139560001, -0.545236917999958],
              [40.97696089700008, -0.653860777999881],
              [40.977891072000034, -0.724347431999931],
              [40.97882124800009, -0.794834085999881],
              [40.97975142400014, -0.87079844099992],
              [41.00527958200007, -0.903768004999975],
              [41.03060103300004, -0.936737568999931],
              [41.05612919100008, -0.969603779999957],
              [41.08155399500009, -1.002573343999927],
              [41.13106001800014, -1.066445413999887],
              [41.18221968600005, -1.132694600999884],
              [41.237306763000106, -1.203904723999926],
              [41.282988728000134, -1.262815855999932],
              [41.33218469200011, -1.326377867999909],
              [41.38375777200008, -1.393040465999917],
              [41.43419397000008, -1.458049417999888],
              [41.484526815000095, -1.523161721999969],
              [41.52287072700011, -1.572771097999947],
              [41.534963012000105, -1.594785257999931],
              [41.53858036300005, -1.613698831999969],
              [41.535943705000136, -1.676312018999866],
              [41.535085483000046, -1.696302992999961],
              [41.53451582100007, -1.696872653999947],
              [41.45834394600007, -1.774834893999923],
              [41.42237389400009, -1.82976653399993],
              [41.41765384200005, -1.847263278999947],
              [41.39600670700008, -1.86060963299991],
              [41.33912194100009, -1.912367445999962],
              [41.303477410000085, -1.956149997999944],
              [41.28272545700008, -1.968519789999959],
              [41.26734459700003, -1.949639580999929],
              [41.248708530000044, -1.957289320999962],
              [41.231455925000034, -1.955498955999929],
              [41.21998131600009, -1.944024346999925],
              [41.21900475400008, -1.922458591999941],
              [41.19898522200003, -1.943129164999959],
              [41.19507897200003, -1.967054945999962],
              [41.18580162900008, -1.990166924999926],
              [41.156911655000044, -1.987481377999927],
              [41.117849155000044, -1.978285414999959],
              [41.10914147200003, -1.977634372999944],
              [41.09685306100005, -1.985284112999921],
              [41.07699629000007, -2.00709400799991],
              [41.04997806100005, -2.018487237999921],
              [41.03956139400009, -2.031996351999908],
              [41.02865644600007, -2.043226820999962],
              [41.01295006600009, -2.042413018999923],
              [40.99976647200003, -2.035577080999929],
              [40.990244988000086, -2.028903903999947],
              [40.98365319100009, -2.019301039999959],
              [40.979502800000034, -2.004978122999944],
              [40.98023522200003, -1.990166924999926],
              [40.99008222700007, -1.962497653999947],
              [40.98943118600005, -1.950290622999944],
              [40.986989780000044, -1.936455987999921],
              [40.99105879000007, -1.924086195999962],
              [41.00611412900008, -1.901788018999923],
              [40.970713738000086, -1.92896900799991],
              [40.96664472700007, -2.04656340899993],
              [40.945323113000086, -2.073174737999921],
              [40.926768425000034, -2.059258721999925],
              [40.908213738000086, -1.99773528399993],
              [40.88998457100007, -1.983819268999923],
              [40.879567905000044, -1.97779713299991],
              [40.87037194100009, -1.967217705999929],
              [40.86101321700005, -1.963474216999941],
              [40.84913170700008, -1.977634372999944],
              [40.85564212300005, -1.992608330999929],
              [40.85857181100005, -2.005791924999926],
              [40.85596764400009, -2.018487237999921],
              [40.87224368600005, -2.01140715899993],
              [40.885101759000065, -2.014825127999927],
              [40.89380944100009, -2.026055596999925],
              [40.896820509000065, -2.042413018999923],
              [40.89470462300005, -2.049086195999962],
              [40.885427280000044, -2.054457289999959],
              [40.883148634000065, -2.060153903999947],
              [40.88648522200003, -2.069756768999923],
              [40.89380944100009, -2.072035414999959],
              [40.901133660000085, -2.073663018999923],
              [40.904307488000086, -2.080336195999962],
              [40.90601647200003, -2.153252862999921],
              [40.91195722700007, -2.191989841999941],
              [40.924815300000034, -2.217217705999929],
              [40.93376712300005, -2.219659112999921],
              [40.94467207100007, -2.218357028999947],
              [40.95687910200007, -2.218926690999922],
              [40.969493035000085, -2.227715752999927],
              [40.979258660000085, -2.242120049999926],
              [40.98072350400008, -2.253024997999944],
              [40.969493035000085, -2.27898528399993],
              [40.94483483200008, -2.309340101999908],
              [40.922618035000085, -2.31373463299991],
              [40.91944420700008, -2.30242278399993],
              [40.952159050000034, -2.286065362999921],
              [40.93490644600007, -2.279880466999941],
              [40.92107181100005, -2.270603122999944],
              [40.896820509000065, -2.245049737999921],
              [40.89307701900009, -2.237074476999908],
              [40.89437910200007, -2.232028903999947],
              [40.89372806100005, -2.22820403399993],
              [40.883148634000065, -2.224053643999923],
              [40.88445071700005, -2.226332289999959],
              [40.877696160000085, -2.228692315999922],
              [40.86304772200003, -2.231377862999921],
              [40.83806399800005, -2.245049737999921],
              [40.81568444100009, -2.271905205999929],
              [40.79468834700003, -2.290459893999923],
              [40.77393639400009, -2.279229424999926],
              [40.77458743600005, -2.287774346999925],
              [40.77719160200007, -2.296807549999926],
              [40.78256269600007, -2.304294528999947],
              [40.79078209700003, -2.307224216999941],
              [40.795583530000044, -2.309991143999923],
              [40.793711785000085, -2.316501559999949],
              [40.78695722700007, -2.327325127999927],
              [40.79346764400009, -2.341973565999922],
              [40.82178795700008, -2.360772393999923],
              [40.82862389400009, -2.374769789999959],
              [40.81690514400009, -2.397881768999923],
              [40.78931725400008, -2.424981377999927],
              [40.758148634000065, -2.447442315999922],
              [40.71176191500007, -2.466566664999959],
              [40.65056399800005, -2.539320570999962],
              [40.615896030000044, -2.552504164999959],
              [40.58521569100009, -2.545830987999921],
              [40.555430535000085, -2.532403252999927],
              [40.52361087300005, -2.52507903399993],
              [40.490896030000044, -2.528497002999927],
              [40.38982181100005, -2.560316664999959],
              [40.348317905000044, -2.590101820999962],
              [40.32309004000007, -2.598077080999929],
              [40.293711785000085, -2.616387627999927],
              [40.24390709700003, -2.656670830999929],
              [40.23210696700005, -2.669040622999944],
              [40.223317905000044, -2.683038018999923],
              [40.20484459700003, -2.724867445999962],
              [40.17497806100005, -2.762627862999921],
              [40.170664910000085, -2.779473565999922],
              [40.172618035000085, -2.787204684999949],
              [40.187510613000086, -2.807061455999929],
              [40.18864993600005, -2.813571872999944],
              [40.18482506600009, -2.828871351999908],
              [40.18376712300005, -2.83757903399993],
              [40.16488691500007, -2.901462497999944],
              [40.16260826900009, -2.934258721999925],
              [40.18376712300005, -2.950290622999944],
              [40.17855879000007, -2.976495049999926],
              [40.19068444100009, -2.988051039999959],
              [40.211273634000065, -2.98601653399993],
              [40.23210696700005, -2.970635674999926],
              [40.23292076900009, -2.981866143999923],
              [40.22510826900009, -2.993747653999947],
              [40.190114780000044, -3.02703215899993],
              [40.16920006600009, -3.054945570999962],
              [40.16382897200003, -3.066989841999941],
              [40.15951582100007, -3.117771091999941],
              [40.15316816500007, -3.135186455999929],
              [40.119151238000086, -3.183526299999926],
              [40.11841881600009, -3.19695403399993],
              [40.129242384000065, -3.233330987999921],
              [40.12907962300005, -3.251885674999926],
              [40.12289472700007, -3.267347914999959],
              [40.114024285000085, -3.281670830999929],
              [40.10238691500007, -3.29420338299991],
              [40.08814537900008, -3.303643487999921],
              [40.039805535000085, -3.325616143999923],
              [40.02662194100009, -3.334405205999929],
              [40.002614780000044, -3.362481377999927],
              [39.98910566500007, -3.373223565999922],
              [39.971446160000085, -3.376071872999944],
              [39.979258660000085, -3.35906340899993],
              [39.99008222700007, -3.320896091999941],
              [39.99195397200003, -3.307061455999929],
              [39.97396894600007, -3.311455987999921],
              [39.96607506600009, -3.321221612999921],
              [39.96436608200008, -3.334242445999962],
              [39.96461022200003, -3.348321221999925],
              [39.963633660000085, -3.357598565999922],
              [39.957774285000085, -3.382256768999923],
              [39.959646030000044, -3.387790622999944],
              [39.96338951900009, -3.393243096999925],
              [39.965179884000065, -3.399183851999908],
              [39.947601759000065, -3.427992445999962],
              [39.92725670700008, -3.481377862999921],
              [39.90056399800005, -3.524183851999908],
              [39.89014733200008, -3.58171965899993],
              [39.87867272200003, -3.605075778999947],
              [39.865977410000085, -3.61646900799991],
              [39.85726972700007, -3.618259372999944],
              [39.83562259200005, -3.608819268999923],
              [39.830821160000085, -3.605889580999929],
              [39.81771894600007, -3.590752862999921],
              [39.81299889400009, -3.589776299999926],
              [39.78638756600009, -3.58757903399993],
              [39.79053795700008, -3.578871351999908],
              [39.79127037900008, -3.574883721999925],
              [39.78093509200005, -3.566582940999922],
              [39.77312259200005, -3.584893487999921],
              [39.77588951900009, -3.600192966999941],
              [39.78793379000007, -3.609144789999959],
              [39.80811608200008, -3.608819268999923],
              [39.79607181100005, -3.622979424999926],
              [39.80014082100007, -3.634698174999926],
              [39.81421959700003, -3.639336846999925],
              [39.84896894600007, -3.625176690999922],
              [39.860118035000085, -3.633233330999929],
              [39.86646569100009, -3.648532809999949],
              [39.86898847700007, -3.66334400799991],
              [39.86703535200007, -3.694919528999947],
              [39.78638756600009, -3.917168877999927],
              [39.760752800000034, -3.941827080999929],
              [39.73210696700005, -3.946384372999944],
              [39.711924675000034, -3.93132903399993],
              [39.71208743600005, -3.897393487999921],
              [39.68995201900009, -3.909600518999923],
              [39.68376712300005, -3.917168877999927],
              [39.68734785200007, -3.927178643999923],
              [39.694102410000085, -3.937269789999959],
              [39.69752037900008, -3.946709893999923],
              [39.70199629000007, -3.955824476999908],
              [39.71208743600005, -3.965020440999922],
              [39.73422285200007, -3.963311455999929],
              [39.74529056100005, -3.968682549999926],
              [39.74244225400008, -3.985935153999947],
              [39.721364780000044, -4.009209893999923],
              [39.71827233200008, -4.016289971999925],
              [39.715505405000044, -4.025160414999959],
              [39.70834394600007, -4.037530205999929],
              [39.69947350400008, -4.048435153999947],
              [39.69076582100007, -4.053155205999929],
              [39.68116295700008, -4.047946872999944],
              [39.674489780000044, -4.024997653999947],
              [39.666677280000044, -4.019707940999922],
              [39.65984134200005, -4.007582289999959],
              [39.66195722700007, -3.984633070999905],
              [39.660492384000065, -3.970798434999949],
              [39.64307701900009, -3.985528252999927],
              [39.61736087300005, -3.971449476999908],
              [39.60572350400008, -3.969659112999921],
              [39.594737175000034, -3.978692315999922],
              [39.60466556100005, -3.988213799999926],
              [39.61646569100009, -3.992852471999925],
              [39.64307701900009, -3.999200127999927],
              [39.63559004000007, -4.017022393999923],
              [39.62614993600005, -4.025485934999949],
              [39.594737175000034, -4.032647393999923],
              [39.58448326900009, -4.03289153399993],
              [39.573252800000034, -4.031833591999941],
              [39.56421959700003, -4.03289153399993],
              [39.560557488000086, -4.039808851999908],
              [39.561289910000085, -4.060967705999929],
              [39.563243035000085, -4.070896091999941],
              [39.567393425000034, -4.081149997999944],
              [39.58187910200007, -4.061618747999944],
              [39.61508222700007, -4.059340101999908],
              [39.65007571700005, -4.06959400799991],
              [39.66968834700003, -4.087985934999949],
              [39.66586347700007, -4.112074476999908],
              [39.615896030000044, -4.197849216999941],
              [39.58383222700007, -4.279392184999949],
              [39.551117384000065, -4.402113539999959],
              [39.540049675000034, -4.430433851999908],
              [39.53109785200007, -4.417413018999923],
              [39.522471550000034, -4.418145440999922],
              [39.514008009000065, -4.426853122999944],
              [39.50603274800005, -4.438083591999941],
              [39.50440514400009, -4.443536065999922],
              [39.50538170700008, -4.455987237999921],
              [39.50220787900008, -4.461602471999925],
              [39.48796634200005, -4.474541924999926],
              [39.48487389400009, -4.478936455999929],
              [39.45069420700008, -4.581963799999926],
              [39.444346550000034, -4.563409112999921],
              [39.44743899800005, -4.534274997999944],
              [39.44385826900009, -4.519952080999929],
              [39.43100019600007, -4.529961846999925],
              [39.423838738000086, -4.543877862999921],
              [39.41781660200007, -4.559502862999921],
              [39.40967858200008, -4.574476820999905],
              [39.40479576900009, -4.57390715899993],
              [39.39771569100009, -4.570082289999959],
              [39.391368035000085, -4.571058851999908],
              [39.388682488000086, -4.585137627999927],
              [39.390635613000086, -4.59343840899993],
              [39.406260613000086, -4.615166924999926],
              [39.39616946700005, -4.629001559999949],
              [39.36247806100005, -4.633965752999927],
              [39.32439212300005, -4.624607028999947],
              [39.30046634200005, -4.59498463299991],
              [39.29965254000007, -4.600762627999927],
              [39.293711785000085, -4.615492445999905],
              [39.264333530000044, -4.606622002999927],
              [39.24268639400009, -4.627373955999929],
              [39.22437584700003, -4.655857028999947],
              [39.20484459700003, -4.670098565999922],
              [39.20069420700008, -4.671482028999947],
              [39.19711347700007, -4.671807549999926],
              [39.19385826900009, -4.673272393999923],
              [39.19060306100005, -4.677504164999959],
              [39.10575728400005, -4.616306253999909],
              [39.020387817000085, -4.554914652999926],
              [38.93501835100005, -4.493419697999911],
              [38.84964888500008, -4.4319247439999],
              [38.764279419000104, -4.370533141999928],
              [38.678806600000144, -4.309038187999917],
              [38.5935404870001, -4.247543232999902],
              [38.50827437300012, -4.18615163199992],
              [38.4228015540001, -4.124760029999948],
              [38.41617485900008, -4.119980776999924],
              [38.337535441000114, -4.063265075999936],
              [38.252062622000096, -4.00187347399995],
              [38.16679650900005, -3.940378519999854],
              [38.08153039500007, -3.878986917999967],
              [37.996057577000045, -3.817491962999952],
              [37.910791463000066, -3.755997008999941],
              [37.82542199700009, -3.694502054999944],
              [37.77095503800007, -3.655434671999927],
              [37.75720910600006, -3.637451273999943],
              [37.747183878000044, -3.616987405999879],
              [37.72982059800012, -3.555389098999939],
              [37.722275839000076, -3.539989521999956],
              [37.70832320200009, -3.52717376699988],
              [37.689409627000146, -3.518078714999902],
              [37.66832564300012, -3.51249765999998],
              [37.64693160000007, -3.510637308999975],
              [37.5990792230001, -3.513427835999934],
              [37.596185343000116, -3.499681904999903],
              [37.60414351400004, -3.480148212999907],
              [37.60817427600006, -3.463611755999906],
              [37.603109986000106, -3.455756936999876],
              [37.586676880000084, -3.453689879999914],
              [37.57944217900007, -3.446351826999916],
              [37.577891887000135, -3.435809834999944],
              [37.58047570800005, -3.424130960999975],
              [37.58522994000003, -3.412968851999949],
              [37.5902942300001, -3.404080504999925],
              [37.60486698400007, -3.387957457999946],
              [37.62719120300011, -3.370284117999944],
              [37.6509623610001, -3.357571715999896],
              [37.66987593600004, -3.356124775999902],
              [37.668428996000046, -3.338244730999946],
              [37.67194299300007, -3.324292093999944],
              [37.681864868000105, -3.31571380599992],
              [37.70005497200009, -3.314370218999954],
              [37.67999554300013, -3.192147645999924],
              [37.67783410700008, -3.178977966999881],
              [37.66016076700009, -3.070560811999911],
              [37.64486454200005, -3.045962828999933],
              [37.56228560400007, -2.999867451999904],
              [37.42421187500008, -2.922753572999881],
              [37.34762170400006, -2.879978128999923],
              [37.13285445200012, -2.760088805999956],
              [36.918190552000056, -2.640302835999904],
              [36.70352665200005, -2.520413512999937],
              [36.488862753000035, -2.400627542999885],
              [36.2740955000001, -2.280841572999933],
              [36.05953495300008, -2.160952249999866],
              [35.84487105300008, -2.041062926999899],
              [35.63020715400012, -1.921173603999918],
              [35.41564660700004, -1.801284280999937],
              [35.24636655100005, -1.706823238999988],
              [35.200982707000094, -1.681498310999899],
              [34.986215454000046, -1.561608987999918],
              [34.77155155400004, -1.44182301799988],
              [34.71889334500014, -1.412413522999955],
              [34.55688765400009, -1.321933694999899],
              [34.342120402000035, -1.202147724999946],
              [34.12745650200014, -1.082258402999884],
              [34.05252567500008, -1.040400491999904],
              [34.01542199700009, -1.037506611999916],
              [34.00198612400004, -1.028721617999935],
              [34.0000224210001, -1.002573343999927],
              [33.98451949100007, -1.002056578999884],
              [33.98038537600007, -1.002573343999927],
              [33.90421431500005, -1.002573343999927],
              [33.898529907000125, -0.799071553999937],
              [33.894809204000126, -0.662749124999891],
              [33.91134566200009, -0.519295348999918],
              [33.935116821000065, -0.313106383999894],
              [33.95351363100008, -0.154356383999954],
              [33.952480102000095, -0.115702412999951],
              [33.92157759600008, -0.012969664999943],
              [33.890468384000144, 0.090073140000058],
              [33.89356896900006, 0.109813538000111],
              [33.95175663300006, 0.187328186000073],
              [33.96026592400011, 0.198677206000113],
              [34.04064009600012, 0.305873921000085],
              [34.076606893000076, 0.333779196000066],
              [34.08518518000005, 0.347008362000068],
              [34.0879757080001, 0.3673688760001],
              [34.07671024600012, 0.403852438000101],
              [34.075676717000135, 0.42224924700011],
              [34.080120890000046, 0.431344300000077],
              [34.09738081800015, 0.451808166000134],
              [34.10440881300008, 0.462246806000081],
              [34.10750940000008, 0.470721741000077],
              [34.13158774800007, 0.569432983000056],
              [34.13241743900005, 0.572834371000027],
              [34.149574016000145, 0.603633524000088],
              [34.17913293400005, 0.623890686000095],
              [34.21975061100011, 0.638566793000081],
              [34.252100057000064, 0.654999898000142],
              [34.276181275000056, 0.680838114000068],
              [34.29230432100013, 0.723729553000027],
              [34.29625187600004, 0.746745807000053],
              [34.298402140000064, 0.759282938000084],
              [34.30667037000012, 0.768067932000065],
              [34.37085249800015, 0.800210673],
              [34.38800907400014, 0.815816955000045],
              [34.40237512200014, 0.856072896000086],
              [34.431210571000065, 0.893538310000068],
              [34.45715214100011, 0.95761708600007],
              [34.46304325400013, 0.978080953000131],
              [34.46366337100005, 1.022936096000109],
              [34.4688310140001, 1.044226787000099],
              [34.47720259600004, 1.064587301000131],
              [34.48702111800009, 1.08246734700009],
              [34.507484985000076, 1.102517802000136],
              [34.524021444000084, 1.098642069000093],
              [34.54035119700012, 1.089391988000074],
              [34.5600649320001, 1.093149310000101],
              [34.561228475000064, 1.093371074000061],
              [34.56688291800015, 1.103021686000076],
              [34.57197717300011, 1.111716207000129],
              [34.57363081800014, 1.134247131000066],
              [34.58045210800009, 1.15254058900004],
              [34.62892460100005, 1.163599345000137],
              [34.66303104600013, 1.196362203000135],
              [34.683804973000065, 1.209074606000087],
              [34.76607385300014, 1.21749786400008],
              [34.797906535000095, 1.231915588000092],
              [34.81051558500013, 1.272533264000046],
              [34.80007694500006, 1.312324117000045],
              [34.78271366400014, 1.352993469000097],
              [34.78074667700014, 1.371789122000052],
              [34.77899296100014, 1.388546855000058],
              [34.83842085800012, 1.437174378000066],
              [34.859504842000035, 1.517918803000015],
              [34.88255253000011, 1.552231954000121],
              [34.89257775900012, 1.5572704060001],
              [34.913558390000105, 1.561559550000069],
              [34.92348026500008, 1.566107076000094],
              [34.93371219900007, 1.575693054000098],
              [34.94094689900004, 1.587036031000082],
              [34.97267622900006, 1.654241231000057],
              [34.97867069500012, 1.675945333000044],
              [34.9797042240001, 1.870300395000058],
              [34.984045044000084, 1.882470194000064],
              [35.002751912000065, 1.906138001000087],
              [35.006472615000064, 1.916860860000014],
              [35.00140832500006, 1.927997132000129],
              [34.977947225000094, 1.949907939000084],
              [34.96916223100004, 1.960294902000015],
              [34.96203088300007, 1.977813212000072],
              [34.95789676900006, 1.997837830000108],
              [34.956656535000036, 2.018508403000027],
              [34.95820682800013, 2.037964580000107],
              [34.96761193800012, 2.082561340000026],
              [34.967508586000065, 2.101914164000078],
              [34.92234338300011, 2.210718893000134],
              [34.904284074000145, 2.254255316000084],
              [34.86560266100008, 2.347506409000104],
              [34.85909143100008, 2.386780497000089],
              [34.86787642400009, 2.411481832000092],
              [34.885963175000086, 2.425434469000081],
              [34.90611698400011, 2.436906637000106],
              [34.92089644300012, 2.454631653000121],
              [34.923583619000055, 2.477317607000089],
              [34.91438521300006, 2.494370829000019],
              [34.88710005700011, 2.522379456000124],
              [34.88131229600015, 2.541448059000103],
              [34.8756278890001, 2.591212464000122],
              [34.86560266100008, 2.60485504200004],
              [34.85650760900012, 2.603459778000058],
              [34.849893025000085, 2.59513987200009],
              [34.84183150300004, 2.58775014200009],
              [34.82808557100009, 2.588783671000073],
              [34.81868046100004, 2.597982076000065],
              [34.77651249200005, 2.685625306000077],
              [34.76131962100004, 2.772493388000086],
              [34.740959106000105, 2.835538635000106],
              [34.73692834500014, 2.844375305000113],
              [34.730107056000065, 2.852850240000109],
              [34.72483606000014, 2.854142151000076],
              [34.69651737400005, 2.867733053000066],
              [34.69465702300005, 2.870420227000096],
              [34.692693319000114, 2.872228903000078],
              [34.691039673000034, 2.875691223000032],
              [34.68886926300007, 2.879153545000065],
              [34.685045207000144, 2.880962220000058],
              [34.68256473800005, 2.879360250000033],
              [34.67812056500014, 2.871557109000094],
              [34.67564009600005, 2.869800110000114],
              [34.67150598100005, 2.867784729000078],
              [34.66034387200011, 2.858638001000088],
              [34.654142700000136, 2.85651926700011],
              [34.640500122000105, 2.860136617000094],
              [34.63140507000014, 2.869541728000058],
              [34.6164189050001, 2.893416239000132],
              [34.58468957500014, 2.928711243000038],
              [34.57466434700012, 2.946126200000066],
              [34.54562219200005, 3.097383118000067],
              [34.5455563430001, 3.097500953000036],
              [34.53383996600013, 3.118467102000082],
              [34.51285933400004, 3.132368063000072],
              [34.46573042800014, 3.14585561100003],
              [34.44485315000014, 3.159136455000038],
              [34.43400109900011, 3.182029114000059],
              [34.424079223000035, 3.304812317000113],
              [34.411160116000076, 3.344706523000056],
              [34.40382206200013, 3.355403544000069],
              [34.39441695200014, 3.365661316000057],
              [34.386562134000144, 3.376384176000073],
              [34.383978312000124, 3.388347270000025],
              [34.386975546000144, 3.399664409000096],
              [34.39700077300006, 3.424159037000052],
              [34.398551066000095, 3.433641662000113],
              [34.39441695200014, 3.444622904000099],
              [34.38211796000013, 3.466042786000031],
              [34.38129113800011, 3.476868998000072],
              [34.38687219200011, 3.48562815300005],
              [34.395967244000076, 3.489607239000037],
              [34.406199178000065, 3.492294414000057],
              [34.41550093600006, 3.49702280700005],
              [34.43451786300005, 3.526219991000076],
              [34.44392297400009, 3.566295065000062],
              [34.446403443000065, 3.646703593000026],
              [34.439685506000046, 3.667735901000128],
              [34.42500939900009, 3.67719268800009],
              [34.40630253100011, 3.682928772000054],
              [34.387492310000084, 3.692747294000114],
              [34.35503951000004, 3.72737050400012],
              [34.337056112000084, 3.734579366000091],
              [34.309874309000065, 3.726698710000051],
              [34.29943566900005, 3.716931864000088],
              [34.295094848000076, 3.707345886000084],
              [34.29044396900008, 3.703160095000058],
              [34.27886844900007, 3.709723002000132],
              [34.26377893000006, 3.750056457000099],
              [34.24155806500005, 3.778736878000089],
              [34.24093794700008, 3.783620300000024],
              [34.23039595600011, 3.782741801000071],
              [34.21055220500011, 3.77713490800005],
              [34.19091516100008, 3.775842997000012],
              [34.17365523300009, 3.771398824000087],
              [34.16518029800005, 3.770830383000131],
              [34.152467895000086, 3.775636292000044],
              [34.15908247900012, 3.783361919000043],
              [34.179029582000055, 3.796100159000105],
              [34.16652388500006, 3.811318868000043],
              [34.15081425000005, 3.817209981000047],
              [34.14895389800006, 3.822687683000126],
              [34.19670292200004, 3.847389018000044],
              [34.20755497300007, 3.860876567000105],
              [34.20497115100011, 3.874544983000121],
              [34.18285363700005, 3.886094666000062],
              [34.1634232990001, 3.886198019000091],
              [34.12373579900009, 3.872038676000045],
              [34.10802616400014, 3.868938091000089],
              [34.08477176900004, 3.87733551000008],
              [34.086218709000036, 3.894672953000082],
              [34.09893111200006, 3.917720642000049],
              [34.10957645600007, 3.943352152000017],
              [34.10709598800008, 3.959501037000095],
              [34.09552046700014, 3.970999044000038],
              [34.08084436100006, 3.980791728000085],
              [34.06895878100005, 3.991876323000099],
              [34.06110396300011, 4.007766825000118],
              [34.06151737500011, 4.017921245000082],
              [34.06585819500009, 4.027429708000057],
              [34.06978560300007, 4.041356506000042],
              [34.07267948400005, 4.064662577000078],
              [34.07236942600014, 4.076418966000077],
              [34.06926883900013, 4.088020325000031],
              [34.060897257000136, 4.099259949000071],
              [34.04973514800008, 4.109466044000058],
              [34.04095015500013, 4.12042144800003],
              [34.03970992100005, 4.13403818700003],
              [34.04105350800006, 4.164811503000081],
              [34.02854781100007, 4.188014221000088],
              [34.006016887000044, 4.205713399000103],
              [33.97707808500007, 4.219691875000095],
              [34.07815718600011, 4.319840800000108],
              [34.17913293400005, 4.419912212000099],
              [34.280108683000094, 4.520061137000113],
              [34.381187785000066, 4.620158386000099],
              [34.45967393766716, 4.660608951185623],
              [34.52915601831711, 4.696418955078556],
              [34.59815902670721, 4.730920459273577],
              [34.66627738114357, 4.764979636491859],
              [34.76358931605273, 4.800365794640612],
              [34.844751195724314, 4.830894575067546],
              [34.92082934837316, 4.859511127898742],
              [35.00272001408649, 4.890314038855152],
              [35.09429820157402, 4.924760880020145],
              [35.17618886728741, 4.955563790976555],
              [35.24572572082997, 4.981719855153159],
              [35.26341879990434, 4.94854533188861],
              [35.33356251052038, 4.987281410885544],
              [35.41159833715233, 5.030375822607695],
              [35.43371468599531, 5.00383620399613],
              [35.396116892962254, 4.926428983045639],
              [35.495640462755716, 4.926428983045639],
              [35.57083604882183, 4.904312634202668],
              [35.52218008136725, 4.780461080681945],
              [35.56260657344876, 4.707137060193645],
              [35.61020111305869, 4.620811910080414],
              [35.61064126820912, 4.620013573553891],
              [35.612139970604176, 4.619497383178029],
              [35.700364878660764, 4.589110530793306],
              [35.705811861646545, 4.619260306395809],
              [35.70584560472605, 4.619447080539359],
            ],
          ],
          [
            [
              [41.05396569100009, -2.049574476999908],
              [41.06568444100009, -2.036309502999927],
              [41.092784050000034, -2.038018487999921],
              [41.12273196700005, -2.047784112999921],
              [41.143321160000085, -2.059502862999921],
              [41.162771030000044, -2.090915622999944],
              [41.155284050000034, -2.112074476999908],
              [41.13689212300005, -2.115492445999962],
              [41.123383009000065, -2.093682549999926],
              [41.12427819100009, -2.104668877999927],
              [41.12281334700003, -2.115899346999925],
              [41.11890709700003, -2.12428150799991],
              [41.11255944100009, -2.127699476999908],
              [41.10962975400008, -2.129001559999949],
              [41.107758009000065, -2.131524346999925],
              [41.10482832100007, -2.13404713299991],
              [41.09888756600009, -2.135349216999941],
              [41.09197024800005, -2.132989190999922],
              [41.08643639400009, -2.128350518999923],
              [41.08285566500007, -2.123711846999925],
              [41.08179772200003, -2.121514580999929],
              [41.06861412900008, -2.123467705999929],
              [41.050791863000086, -2.129489841999941],
              [41.01351972700007, -2.148858330999929],
              [41.00440514400009, -2.142185153999947],
              [40.99561608200008, -2.14381275799991],
              [40.988942905000044, -2.152276299999926],
              [40.98617597700007, -2.165948174999926],
              [40.99154707100007, -2.173760674999926],
              [41.002289259000065, -2.180108330999929],
              [41.00993899800005, -2.18718840899993],
              [41.00611412900008, -2.197360934999949],
              [40.99366295700008, -2.197198174999926],
              [40.98585045700008, -2.191338799999926],
              [40.981455925000034, -2.181573174999926],
              [40.979502800000034, -2.169366143999923],
              [40.95728600400008, -2.174004815999922],
              [40.957367384000065, -2.151299737999921],
              [40.96924889400009, -2.119805596999925],
              [40.98292076900009, -2.09734465899993],
              [41.00114993600005, -2.08717213299991],
              [41.02466881600009, -2.080173434999949],
              [41.04517662900008, -2.069756768999923],
              [41.05396569100009, -2.049574476999908],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Malawi',
        iso3: 'MWI',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [34.96461470600008, -11.573556009999933],
              [34.651248820000035, -11.570042012999878],
              [34.61672896300007, -11.57831024199993],
              [34.607117147000054, -11.591125995999903],
              [34.607220500000096, -11.609316100999948],
              [34.613938436000126, -11.652724303999946],
              [34.61197473100009, -11.693135273999928],
              [34.604429972000105, -11.732616068999945],
              [34.563812296000094, -11.83090464199995],
              [34.48764123500007, -11.944076028999902],
              [34.38005090400014, -12.103859557999925],
              [34.358760213000096, -12.154399108999954],
              [34.35400598100006, -12.199460957999904],
              [34.35558101700008, -12.20493961299988],
              [34.380360962000054, -12.291134948999911],
              [34.439168742000106, -12.495050149999912],
              [34.49446252500013, -12.687389831999965],
              [34.507484985000076, -12.799424335999916],
              [34.52391809100004, -12.939674173999919],
              [34.5377673750001, -13.059356790999928],
              [34.54934289500005, -13.159092305999934],
              [34.54283166500011, -13.243789977999938],
              [34.54531213400014, -13.32574879899991],
              [34.57817834500008, -13.398405863999955],
              [34.57941857900005, -13.400369567999888],
              [34.5827597330001, -13.403625920999943],
              [34.59977909300005, -13.420213317999881],
              [34.611457967000035, -13.43581960099992],
              [34.63171512800005, -13.47116627999992],
              [34.636469360000035, -13.482225035999932],
              [34.63760624200012, -13.488219502999954],
              [34.640603475000034, -13.492353617999882],
              [34.65135217300008, -13.497831318999971],
              [34.66747522000014, -13.500931904999916],
              [34.79542606600012, -13.498761494999926],
              [34.829635865000114, -13.503929137999933],
              [34.863122192000105, -13.515814716999955],
              [34.86389759600013, -13.516283029999983],
              [34.894438110000124, -13.534728291999983],
              [34.99655074100008, -13.625988871],
              [35.08409061700013, -13.704226988999949],
              [35.17111372900007, -13.805719501999931],
              [35.27870406100004, -13.930879820999934],
              [35.370067993000134, -14.037229918999927],
              [35.45574751800012, -14.136965433999933],
              [35.52282352700007, -14.262745869],
              [35.60943322700007, -14.369406025999893],
              [35.714439738000124, -14.49870045999991],
              [35.750539409000055, -14.543142707999934],
              [35.78689009600009, -14.58789398199994],
              [35.83556929500014, -14.635849710999977],
              [35.847248169000125, -14.650422464999934],
              [35.8530359290001, -14.667475686999879],
              [35.86326786300015, -14.876661885999908],
              [35.86988244600013, -14.885550231999929],
              [35.88280155400008, -14.887513936999952],
              [35.90429895000011, -14.886893818999894],
              [35.866781861000106, -14.973090108999912],
              [35.83928999800014, -15.0363420609999],
              [35.790817505000064, -15.14682627399992],
              [35.78420292100009, -15.171837665999917],
              [35.784512981000034, -15.195195413999954],
              [35.78858250500008, -15.211427612999913],
              [35.812004842000135, -15.30485280399995],
              [35.840530233000095, -15.417197366999886],
              [35.83762321100005, -15.458280937999916],
              [35.837558283000135, -15.459198533],
              [35.83195194500013, -15.538430276999918],
              [35.82306359800015, -15.663383890999867],
              [35.81675907400012, -15.75195729599993],
              [35.8067338460001, -15.895824482999927],
              [35.796591428000056, -15.933197758999924],
              [35.78968062400014, -15.958663024999893],
              [35.790094035000095, -15.974476012999986],
              [35.79567509000009, -16.00496510799988],
              [35.794641561000105, -16.020674742999944],
              [35.78513309700014, -16.042275491999916],
              [35.77004358000005, -16.05881195099991],
              [35.697593221000034, -16.107491148999927],
              [35.687051229000076, -16.112658792999937],
              [35.67785282400007, -16.113485615999963],
              [35.65893924900013, -16.110074970999932],
              [35.64860396300014, -16.110591735999975],
              [35.553209269000035, -16.138393655999934],
              [35.52902469900005, -16.140770771999968],
              [35.52406376200008, -16.146661885999976],
              [35.52106652800006, -16.162164814999898],
              [35.51455529800012, -16.17136321999989],
              [35.502049601000124, -16.17084645599995],
              [35.48871708200011, -16.16464528399996],
              [35.48013879400014, -16.156893818999947],
              [35.47290409300007, -16.140150654999914],
              [35.456367635000106, -16.129401957999974],
              [35.43580041500013, -16.123924254999906],
              [35.41606001800005, -16.122890726999913],
              [35.39342574000011, -16.12857513399996],
              [35.37461552000008, -16.140977477999925],
              [35.30495568900005, -16.202059020999926],
              [35.299156139000104, -16.20872095699994],
              [35.27715376800012, -16.233995055999912],
              [35.258756958000106, -16.271512145999907],
              [35.251935669000034, -16.31781422899988],
              [35.254209432000096, -16.32835622199994],
              [35.26619836500004, -16.356468200999885],
              [35.262270955000076, -16.366596780999927],
              [35.23870650200007, -16.394088642999904],
              [35.2372534590001, -16.39909046299995],
              [35.233332153000106, -16.41258880599993],
              [35.23364221200006, -16.452379658999945],
              [35.22816451000011, -16.4702597039999],
              [35.21441857900004, -16.48421234099989],
              [35.144655396000076, -16.529067483999967],
              [35.13194299300005, -16.537645771999905],
              [35.14837609900013, -16.582087503999972],
              [35.16439579200005, -16.6067888379999],
              [35.168529908000096, -16.617124124999904],
              [35.17431766700008, -16.625495706999885],
              [35.18547977700007, -16.62900970499993],
              [35.194678182000075, -16.63055999699995],
              [35.21658899000005, -16.638724873999962],
              [35.22299686700006, -16.642135518999908],
              [35.22754439300013, -16.646889749999985],
              [35.23271203600012, -16.6572250359999],
              [35.236639445000094, -16.662599385999954],
              [35.23974003100005, -16.664563089999902],
              [35.248214966000035, -16.668180439999972],
              [35.25100549300009, -16.67004079199998],
              [35.27508671100014, -16.69546559599989],
              [35.2781872970001, -16.700736591999927],
              [35.28108117700009, -16.766882425999896],
              [35.28511193800006, -16.786726175999974],
              [35.305162394000035, -16.825690205999962],
              [35.3102266840001, -16.850598246999937],
              [35.2852152910001, -16.871062113999898],
              [35.28283817500005, -16.892146097999927],
              [35.28511193800006, -16.930076598999932],
              [35.2819080000001, -16.934727477999985],
              [35.275810181000054, -16.93917165099991],
              [35.270952596000086, -16.94423594099989],
              [35.27136600800014, -16.950540466999897],
              [35.27601688700008, -16.95519134499996],
              [35.308366333000095, -16.973691507999973],
              [35.31436080000009, -16.982269795999912],
              [35.309296508000045, -16.995292256999946],
              [35.298651164000034, -17.01358571399993],
              [35.297410930000126, -17.029708759999906],
              [35.306195923000075, -17.06732920299993],
              [35.30753951000014, -17.087586364999936],
              [35.30495568900005, -17.104226175999955],
              [35.299477986000056, -17.117972106999986],
              [35.29193322800012, -17.129340921999884],
              [35.29167287300004, -17.129368228999923],
              [35.23477909400009, -17.135335387999902],
              [35.13390669800009, -17.132028095999914],
              [35.08130008900008, -17.124069924999944],
              [35.06600386600013, -17.109807230999962],
              [35.0691044510001, -17.084072366999877],
              [35.03654829900012, -17.035909931999896],
              [35.04440311700006, -17.004697366999906],
              [35.06610721900006, -16.98733408599989],
              [35.09142867000014, -16.97534515399994],
              [35.11344283000011, -16.96025563599993],
              [35.125121704000094, -16.93286712699998],
              [35.128118937000124, -16.90072438499996],
              [35.12749882000014, -16.864447529999907],
              [35.118300415000135, -16.83344166999997],
              [35.09576949000012, -16.817318623999896],
              [35.06279992700007, -16.81638844799994],
              [35.0330343010001, -16.819178975999904],
              [35.00450891100013, -16.81463144899996],
              [34.975053345000106, -16.792100524999938],
              [34.956656535000036, -16.76832936599989],
              [34.94807824700007, -16.75933766699994],
              [34.934435669000095, -16.749725849999933],
              [34.927614380000136, -16.74724538199996],
              [34.91231815600008, -16.744558206999926],
              [34.905496867000124, -16.740837503999913],
              [34.90094934100006, -16.733292744999872],
              [34.89774540200011, -16.71396575899992],
              [34.89350793500006, -16.705697529999966],
              [34.886613111000145, -16.700848911999884],
              [34.877488240000105, -16.694432067999912],
              [34.859918254000036, -16.68719736699994],
              [34.844622030000096, -16.678412373999947],
              [34.83480350800011, -16.663116149999908],
              [34.827568807000034, -16.641515400999936],
              [34.819507283000064, -16.627769469999905],
              [34.77299849500014, -16.589735615999956],
              [34.76286991400008, -16.576403095999936],
              [34.74498986800012, -16.54291676799994],
              [34.73207076000011, -16.52917083699991],
              [34.66871545400011, -16.496614684999955],
              [34.66117069500012, -16.493927510999924],
              [34.654969523000034, -16.489379983999896],
              [34.642670533000114, -16.45971771199993],
              [34.63739953600009, -16.45051930799994],
              [34.63068160000006, -16.443387959999896],
              [34.59833215400005, -16.419720152999957],
              [34.58582645600006, -16.407834573999935],
              [34.57507775900007, -16.392331644999928],
              [34.54706913200005, -16.323085224999915],
              [34.52474491400005, -16.30076100699995],
              [34.48040653500004, -16.294456480999926],
              [34.445990031000065, -16.293216246999904],
              [34.42645633900008, -16.273889260999937],
              [34.38521854600015, -16.186452738999975],
              [34.389249308000046, -16.15244964599995],
              [34.40898970600011, -16.087854104999906],
              [34.4045455320001, -16.05974212699995],
              [34.38769901500012, -16.03700449599998],
              [34.30429325400007, -15.95215179499992],
              [34.2897205000001, -15.943470152999879],
              [34.256440877000045, -15.928173929999915],
              [34.24403853400008, -15.917631937999943],
              [34.233186483000054, -15.88983001699998],
              [34.23132613100006, -15.854173277999905],
              [34.23639042200011, -15.819240009999916],
              [34.24713912000004, -15.794125263999987],
              [34.275561157000084, -15.76435963999991],
              [34.293337850000114, -15.751130472999904],
              [34.310287720000076, -15.743275654999962],
              [34.33095829300004, -15.737074482999986],
              [34.34181034300008, -15.730873310999911],
              [34.34221782200012, -15.730323010999939],
              [34.404028768000046, -15.646847431999973],
              [34.415914348000115, -15.615118102999944],
              [34.41911828600007, -15.575327249999944],
              [34.41002323400011, -15.51496917699994],
              [34.410126587000036, -15.481276142999974],
              [34.42263228300004, -15.46453297899994],
              [34.4406156820001, -15.455541279999892],
              [34.460252726000135, -15.424845478999956],
              [34.48040653500004, -15.412856546999905],
              [34.48702111800009, -15.400454202999924],
              [34.49198205600004, -15.375132750999938],
              [34.49663293400005, -15.362730407999976],
              [34.50800175000012, -15.348054300999891],
              [34.52030074000004, -15.339786071999939],
              [34.533323202000076, -15.33306813499992],
              [34.546759074000136, -15.323249612999945],
              [34.565155884000035, -15.297308043999905],
              [34.56908329300012, -15.271159769999898],
              [34.559085120000134, -15.200177714],
              [34.54830936700006, -15.123675230999922],
              [34.55068648200012, -15.106622008999892],
              [34.55988488800011, -15.09566660499992],
              [34.557301066000036, -15.084297790999926],
              [34.55099654200012, -15.071792092999928],
              [34.54872277900006, -15.05763275199989],
              [34.55461389200008, -15.043576761999958],
              [34.57497440600014, -15.016084899999981],
              [34.58231246000008, -15.001305439999967],
              [34.58417281100009, -14.984458922999906],
              [34.57693811000007, -14.969266051999881],
              [34.565982707000046, -14.954279886999899],
              [34.556991008000125, -14.938260192999948],
              [34.55109989500005, -14.918313089999927],
              [34.54872277900006, -14.90156992599988],
              [34.54841271900011, -14.827775979999927],
              [34.54283166500011, -14.796253356999955],
              [34.532082967000065, -14.76679779099996],
              [34.51533980300013, -14.734551696999901],
              [34.50583133900005, -14.700341897999905],
              [34.5193705640001, -14.640810647999928],
              [34.518130330000076, -14.607427672999862],
              [34.50180057800014, -14.575698343999932],
              [34.449710734000064, -14.525468850999886],
              [34.42645633900008, -14.497563577999912],
              [34.39379683400011, -14.432347920999888],
              [34.38043631000005, -14.413643186999906],
              [34.3720927330001, -14.401962178999923],
              [34.34408410600008, -14.387389424999881],
              [34.335299113000076, -14.388836364999875],
              [34.327754353000046, -14.393590595999868],
              [34.320519653000076, -14.399378356999932],
              [34.312871541000106, -14.404235941999943],
              [34.30491337000012, -14.405786233999962],
              [34.28889367700009, -14.4040292359999],
              [34.28134891800005, -14.404959410999936],
              [34.18244022600004, -14.439479267999928],
              [34.10957645600007, -14.441442972999951],
              [34.07753706900007, -14.454672139999943],
              [34.07019901500007, -14.464904072999929],
              [34.05862349400013, -14.490122171999886],
              [34.050768677000065, -14.49518646199995],
              [33.945555460000094, -14.481440530999919],
              [33.91630660000004, -14.481337178999894],
              [33.88891809000012, -14.488158466999948],
              [33.83083378100014, -14.522678323999926],
              [33.80241174300011, -14.532806904999887],
              [33.77419641100005, -14.530016377999928],
              [33.72040124500012, -14.489708760999875],
              [33.69921390800005, -14.496219990999933],
              [33.68407271400014, -14.51875091599996],
              [33.675546102000055, -14.547793069999955],
              [33.675442749000126, -14.582312927999936],
              [33.672238810000124, -14.600192971999988],
              [33.66242028800008, -14.607014261999936],
              [33.644850302000066, -14.601743265999914],
              [33.632964722000054, -14.59140797899991],
              [33.62448978700007, -14.57807545999988],
              [33.61840558200009, -14.56184056699989],
              [33.604232625000066, -14.524021910999892],
              [33.595757691000074, -14.511412861999958],
              [33.58428552200013, -14.502627867999891],
              [33.557413778000125, -14.490432229999968],
              [33.54594161000011, -14.481647236999976],
              [33.537466674000086, -14.46872812899997],
              [33.53235070800014, -14.456222431999961],
              [33.525787801000035, -14.444336852999939],
              [33.51245528200013, -14.432968037999956],
              [33.470287313000085, -14.414467874999929],
              [33.45736820500014, -14.404339293999968],
              [33.43917810100004, -14.380671487999948],
              [33.388586874000055, -14.280625914999874],
              [33.37101688600006, -14.25675140399997],
              [33.35710549200013, -14.230565247999934],
              [33.35432539900006, -14.225332131999934],
              [33.34714237500009, -14.218820901999962],
              [33.3382540290001, -14.215410257999935],
              [33.32393965600011, -14.20631520599997],
              [33.31556807400011, -14.197116800999964],
              [33.290556682000044, -14.15691253699994],
              [33.28621586100007, -14.138929137999952],
              [33.29128015100014, -14.089216410999953],
              [33.280221395000126, -14.060794371999933],
              [33.257793824000146, -14.043637796999874],
              [33.202706747000036, -14.013872171999893],
              [33.185653524000145, -13.993821715999928],
              [33.1545443120001, -13.93656422899997],
              [33.140281616000095, -13.92498870799993],
              [33.13025638900007, -13.930569762999951],
              [33.12064457200006, -13.955891214999923],
              [33.111601196000095, -13.964572854999886],
              [33.07692631100008, -13.974494729999975],
              [33.0629736730001, -13.981729430999863],
              [33.04943444800011, -13.996612244],
              [33.018170206000036, -14.046221618999965],
              [32.99982507400006, -14.050459085999918],
              [32.97646732600009, -14.021106871999862],
              [32.9712996830001, -14.005914000999923],
              [32.974813680000125, -13.955477803999912],
              [32.97667403100013, -13.949793395999876],
              [32.97626062000012, -13.94452239999994],
              [32.97057621200008, -13.93604746499993],
              [32.9625146890001, -13.932016702999945],
              [32.9444279380001, -13.9329468789999],
              [32.93615970900004, -13.92622894199988],
              [32.930061890000104, -13.910519306999987],
              [32.927891480000085, -13.895636494999863],
              [32.923912394000126, -13.880443622999934],
              [32.8741479900001, -13.820602314999874],
              [32.859420207000085, -13.80809661799988],
              [32.82877608300004, -13.797037861999868],
              [32.79187911000014, -13.78980316099991],
              [32.76304366000011, -13.777194111999876],
              [32.75735925300006, -13.750219013999939],
              [32.76810795000006, -13.739056904999913],
              [32.80484989400014, -13.72200368199988],
              [32.813376506000054, -13.711151631999925],
              [32.80779545000007, -13.69916269899997],
              [32.769864950000056, -13.646866149999966],
              [32.74340661600007, -13.63539398199994],
              [32.70671635000008, -13.635083922999868],
              [32.67509037200011, -13.628055927999952],
              [32.66330814700012, -13.596326598999937],
              [32.66764896600006, -13.575552673999894],
              [32.677260783000065, -13.567801207999892],
              [32.69162683100012, -13.569144794999943],
              [32.71023034600006, -13.575345966999933],
              [32.7228393960001, -13.5733822629999],
              [32.74981449400008, -13.550851338999877],
              [32.76319869000014, -13.542479755999906],
              [32.80004398600005, -13.537105407999945],
              [32.8130664470001, -13.528217060999921],
              [32.81751062000012, -13.50558278399997],
              [32.81689050300014, -13.487392678999939],
              [32.819060913000044, -13.471683043999874],
              [32.827432495000096, -13.460830992999917],
              [32.84582930500011, -13.458040465999957],
              [32.874251342000036, -13.443157653999918],
              [32.89213138800005, -13.404813740999899],
              [32.90548718000008, -13.351390573999936],
              [32.91962325000014, -13.294846292999921],
              [32.937865031000115, -13.255882262999933],
              [32.962721395000074, -13.224979756999929],
              [32.99279707900013, -13.216401468999905],
              [32.9981714270001, -13.202448831999916],
              [32.99507084200013, -13.190873311999965],
              [32.979051147000064, -13.167877298999926],
              [32.9712996830001, -13.150927428999921],
              [32.96711389200004, -13.13418426499996],
              [32.96592533400013, -13.116820983999943],
              [32.98153161600004, -13.006130065999884],
              [33.00892012500009, -12.945048522999883],
              [33.013571004000084, -12.91724660199992],
              [33.00504439200006, -12.892958678999918],
              [32.980498088000104, -12.870737813999895],
              [32.95352299000007, -12.854098001999958],
              [32.947011760000066, -12.843245950999915],
              [32.94112064600006, -12.769865416999977],
              [32.94463464400013, -12.752398782999933],
              [32.95807051600008, -12.725216979999942],
              [32.99414066600008, -12.672507018999923],
              [33.024836466000124, -12.612665710999877],
              [33.03537845900007, -12.599126484999985],
              [33.04953780100004, -12.586827493999948],
              [33.057702678000055, -12.583416848999917],
              [33.06462731900007, -12.584967142999943],
              [33.07000166800009, -12.590444843999933],
              [33.07423913500014, -12.59829966199996],
              [33.08126713000007, -12.604810892999936],
              [33.08994877100014, -12.600780130999937],
              [33.0990438230001, -12.593235370999892],
              [33.10700199400014, -12.588687845999942],
              [33.122814982000136, -12.584553730999929],
              [33.13035974100012, -12.583726908999907],
              [33.13991988100008, -12.586310729999909],
              [33.14689620000007, -12.593235370999892],
              [33.15878177900004, -12.615352884999893],
              [33.16301924600009, -12.620417174999972],
              [33.17325118000008, -12.62000376399996],
              [33.17800541100007, -12.615042826999911],
              [33.18131270300006, -12.608221536999864],
              [33.187307169000064, -12.602330423999959],
              [33.19237146000006, -12.599023131999957],
              [33.19681563300014, -12.595405781999972],
              [33.20291345200013, -12.591788430999898],
              [33.21299035700014, -12.588584492999928],
              [33.22699467000007, -12.57907602999994],
              [33.24363448100007, -12.544762877999915],
              [33.255106648000094, -12.531947122999938],
              [33.263168172000064, -12.52853647899991],
              [33.2897298580001, -12.524195657999925],
              [33.302235555000095, -12.52512583399988],
              [33.31195072400004, -12.529880065999876],
              [33.32032230600004, -12.535047708999883],
              [33.32828047700008, -12.53763152999997],
              [33.35039799000009, -12.532670592999935],
              [33.37323897300007, -12.518511249999975],
              [33.39375451700005, -12.49825408999989],
              [33.409412475000124, -12.475206400999923],
              [33.42078129100008, -12.464974466999934],
              [33.45111535600006, -12.452985533999879],
              [33.45995202600005, -12.441099954999856],
              [33.460778849000064, -12.416501972999868],
              [33.46532637600012, -12.40906056699994],
              [33.48051924600014, -12.40637339199992],
              [33.4877539470001, -12.38983693499992],
              [33.51388714300009, -12.37428145999992],
              [33.518139689000066, -12.371750182999904],
              [33.5271313880001, -12.355627135999924],
              [33.52558109600011, -12.335266621999892],
              [33.51410892700005, -12.33102915399985],
              [33.49736576300012, -12.331545917999975],
              [33.45829838100008, -12.31811004599993],
              [33.384607788000096, -12.340020852999885],
              [33.349467814000036, -12.327928567999905],
              [33.33014082900007, -12.298266295999937],
              [33.312467489000085, -12.228606465999917],
              [33.29996179200009, -12.195946959999944],
              [33.288386271000036, -12.182201029999902],
              [33.26027429200008, -12.155742695999919],
              [33.252729533000036, -12.139516295999911],
              [33.25128259300004, -12.105823261999944],
              [33.254899943000055, -12.072646992999935],
              [33.29422570800011, -11.981283060999914],
              [33.30357914300009, -11.930226745999946],
              [33.30931522600014, -11.91431040399992],
              [33.312674194000124, -11.89870412099988],
              [33.308746786000086, -11.8844414269999],
              [33.29748132300011, -11.86253061899994],
              [33.29737797000007, -11.846510924999905],
              [33.31060713700009, -11.808787129999942],
              [33.314017781000075, -11.772200215999902],
              [33.30264896700004, -11.609729512999962],
              [33.29675785300009, -11.59360646499988],
              [33.28321862800004, -11.578413594999859],
              [33.26688887500012, -11.5756230679999],
              [33.24931888900005, -11.577793476999886],
              [33.232679077000114, -11.577690123999957],
              [33.21593591300007, -11.571592304999896],
              [33.21262862100008, -11.563840840999902],
              [33.227304728000036, -11.532731627999937],
              [33.23381595900008, -11.514024758999952],
              [33.23495284100011, -11.501725768999918],
              [33.230301961000066, -11.416563008999972],
              [33.2397070720001, -11.402403665999927],
              [33.26518355300004, -11.423074238999945],
              [33.27360681200014, -11.409431660999942],
              [33.273813517000065, -11.396615905999866],
              [33.27184981300013, -11.383696796999942],
              [33.273503459000096, -11.369640807999929],
              [33.27805098400012, -11.364266458999879],
              [33.2933472090001, -11.357755228999906],
              [33.2989282640001, -11.353104349999938],
              [33.30027185100005, -11.347006530999877],
              [33.29680952900014, -11.335741068999923],
              [33.298308146000124, -11.329229837999947],
              [33.36848474100009, -11.222673034999985],
              [33.38223067200005, -11.194664408999884],
              [33.390912313000115, -11.164795430999959],
              [33.35887292400008, -11.10939829499992],
              [33.33660038200014, -11.087384134999937],
              [33.31810022000013, -11.062269388999908],
              [33.30368249500009, -11.034570820999889],
              [33.29396732600014, -11.00449513799991],
              [33.29096019900004, -10.975086452999975],
              [33.287869507000096, -10.944860533999915],
              [33.280324747000066, -10.913337910999942],
              [33.26585534600014, -10.901142272999934],
              [33.25210941600011, -10.903105976999967],
              [33.23960371900006, -10.903105976999967],
              [33.23169722500006, -10.897628274999889],
              [33.23257572500006, -10.883262226999875],
              [33.241412394000065, -10.865692240999905],
              [33.250765829000045, -10.862488300999928],
              [33.26120446700014, -10.865278827999887],
              [33.273400106000054, -10.865588887999877],
              [33.288127889000066, -10.856700540999952],
              [33.30688643400009, -10.828588561999922],
              [33.31908207200007, -10.81814992199989],
              [33.33262129800005, -10.81360239699994],
              [33.357839397000134, -10.80874481199993],
              [33.37174035700008, -10.803267109999936],
              [33.38553796400004, -10.800889993999903],
              [33.41866255700006, -10.807297870999932],
              [33.4340104580001, -10.808124694999961],
              [33.44713627200008, -10.802233580999953],
              [33.46532637600012, -10.784353535999898],
              [33.48051924600014, -10.781563008999939],
              [33.500983113000075, -10.769160664999973],
              [33.51199019400008, -10.751797382999953],
              [33.528268270000126, -10.711593118999929],
              [33.57694746900006, -10.657642923999973],
              [33.59027998800008, -10.64896128299992],
              [33.60309574400014, -10.64327687499987],
              [33.642266479000114, -10.615268248999953],
              [33.65776940900008, -10.601315612999969],
              [33.67420251500005, -10.577027688999877],
              [33.673849293000046, -10.57304805899993],
              [33.67352257400012, -10.56936702499992],
              [33.67265222200007, -10.559561054999918],
              [33.665572550000036, -10.541370950999891],
              [33.6654175220001, -10.51511932399994],
              [33.63818404200009, -10.511605325999895],
              [33.622732788000064, -10.494035339999925],
              [33.60319909700007, -10.44918019599993],
              [33.5955509850001, -10.440601907999906],
              [33.567645712000115, -10.41600392699992],
              [33.55917077600009, -10.404325052999937],
              [33.532919149000065, -10.342623392999883],
              [33.52930179900011, -10.318645527999962],
              [33.53560632300008, -10.262731628999873],
              [33.53328088400008, -10.231209004999911],
              [33.51896651200008, -10.214982604999904],
              [33.49912276200007, -10.201236673999873],
              [33.48051924600014, -10.177052103999898],
              [33.45457767800008, -10.168060403999945],
              [33.43649092600009, -10.153280944999935],
              [33.420161173000054, -10.135607604999933],
              [33.39918054200007, -10.117934264999931],
              [33.317531779000035, -10.082070820999888],
              [33.30409590700009, -10.063777363999918],
              [33.30471602300008, -10.037939147999893],
              [33.30998702000011, -10.012721048999936],
              [33.32879724100013, -9.96548878999991],
              [33.35845951300007, -9.91991017599993],
              [33.365590861000044, -9.898826191999902],
              [33.359182984000086, -9.870920918999914],
              [33.34347334800009, -9.831440123999897],
              [33.33696211700004, -9.823688659999974],
              [33.29996179200009, -9.810252786999925],
              [33.28776615400005, -9.803844908999892],
              [33.27577722100011, -9.79330291699992],
              [33.26719893400008, -9.78121063199994],
              [33.252729533000036, -9.75402882899995],
              [33.24177412900008, -9.74234995499998],
              [33.21671106000008, -9.727053730999927],
              [33.2072542730001, -9.712894388999885],
              [33.20456709800004, -9.698114928999956],
              [33.207822714000145, -9.68870981899991],
              [33.21299035700014, -9.680648294999912],
              [33.21578088400008, -9.669899596999898],
              [33.2142822670001, -9.654706725999873],
              [33.20983809400008, -9.641374205999853],
              [33.19542036900009, -9.616259460999927],
              [33.17542159000004, -9.602306823999925],
              [33.12147139500007, -9.59951629699988],
              [33.09832035300008, -9.58845753999988],
              [33.092532593000044, -9.614399108999919],
              [33.08922530100011, -9.643958027999943],
              [33.08044030700006, -9.662251484999913],
              [33.05832279400005, -9.654293313999858],
              [33.053051799000116, -9.644784850999969],
              [33.050778036000054, -9.63269256599989],
              [33.0467472740001, -9.622047219999985],
              [33.035740194000084, -9.61698292999992],
              [33.02225264500004, -9.620290221999923],
              [33.01119388800004, -9.627834980999879],
              [33.00013513200014, -9.632795917999914],
              [32.98690596500012, -9.628455098999936],
              [32.97471032700008, -9.601273294999942],
              [32.99238366700013, -9.52913299499994],
              [32.991970255000126, -9.50184783999994],
              [32.98308190900008, -9.497713723999908],
              [32.968612508000035, -9.484381204999892],
              [32.96189457200012, -9.480350443999896],
              [32.95026737500007, -9.480867206999932],
              [32.943601115000035, -9.485724791999957],
              [32.9375032960001, -9.487791849999923],
              [32.92778812700004, -9.479833678999867],
              [32.92303389500006, -9.466294453999879],
              [32.9208634850001, -9.407900085999913],
              [32.93626306200008, -9.391673684999901],
              [32.95527998900013, -9.382061868999898],
              [32.97471032700008, -9.381235046999876],
              [32.992280314000084, -9.391363626999919],
              [33.04230310100007, -9.440662942999907],
              [33.10390140800013, -9.487895201999947],
              [33.11299646000009, -9.491512552999922],
              [33.13991988100008, -9.497403665999926],
              [33.169220418000066, -9.508875833999937],
              [33.172941121000065, -9.511046243999928],
              [33.18203617400013, -9.507945657999898],
              [33.1957821040001, -9.496680195999929],
              [33.20239668800008, -9.493476256999955],
              [33.21634932400008, -9.49337290499993],
              [33.23712325000008, -9.499574075999917],
              [33.24911218200009, -9.500710957999928],
              [33.257690470000114, -9.498023783999898],
              [33.273503459000096, -9.487688496999894],
              [33.28239180500009, -9.486034850999943],
              [33.30027185100005, -9.492236022999919],
              [33.35649580900014, -9.531820169999975],
              [33.37499597200008, -9.549080097999962],
              [33.39220422400007, -9.586183776999945],
              [33.40424483200013, -9.604890644999927],
              [33.419644409000114, -9.615639342999955],
              [33.43897139500007, -9.621530455999945],
              [33.48051924600014, -9.624424335999933],
              [33.51162845900012, -9.61698292999992],
              [33.53519291200007, -9.603340351999918],
              [33.5594808350001, -9.59331512499989],
              [33.59338057500008, -9.596829120999942],
              [33.6238696690001, -9.60633758499992],
              [33.65013541400015, -9.610901131999952],
              [33.65063806100005, -9.610988463999888],
              [33.67606286600005, -9.607681171999985],
              [33.702521199000046, -9.592901712999975],
              [33.73461226400008, -9.584116719999898],
              [33.762000773000125, -9.60096323599987],
              [33.787528930000065, -9.626491393999899],
              [33.81347050000011, -9.643337910999975],
              [33.83693160000007, -9.652846373999864],
              [33.86525028500006, -9.669589538999915],
              [33.88933150200012, -9.68974334699989],
              [33.90018355300009, -9.709587096999883],
              [33.91186242600014, -9.717958678999949],
              [33.92829553200011, -9.700285338999947],
              [33.92829553200011, -9.693464050999907],
              [33.94307499200005, -9.683852233999886],
              [33.95134322100006, -9.67362029999991],
              [33.95485721800014, -9.660597838999962],
              [33.955580689000044, -9.642304381999907],
              [33.962608684000145, -9.6121253459999],
              [33.964469035000036, -9.594658711999955],
              [33.94586551900011, -9.550010273999916],
              [33.96074833200004, -9.524895527999902],
              [33.98431278500004, -9.505568542999939],
              [33.99650842300014, -9.491822610999918],
              [34.01273482200014, -9.477456562999905],
              [34.04746138500008, -9.489962259999913],
              [34.0784906880001, -9.510185830999973],
              [34.07981083200008, -9.511046243999928],
              [34.08931929600004, -9.522208353999872],
              [34.10316857900011, -9.529856465999941],
              [34.13706831800005, -9.570577493999906],
              [34.14461307800008, -9.574918313999888],
              [34.161873006000064, -9.593625182999872],
              [34.190811808000035, -9.606750996999935],
              [34.288066853000146, -9.70845021599996],
              [34.31793583100006, -9.719198912999985],
              [34.324240356000075, -9.732428079999892],
              [34.32672082600004, -9.750308125999936],
              [34.33168176300012, -9.769221699999974],
              [34.337469523000095, -9.77717986999994],
              [34.359690389000036, -9.799917500999925],
              [34.36423791500005, -9.802397968999898],
              [34.38232466700009, -9.819657897999889],
              [34.38346154800007, -9.823792012999917],
              [34.48330041500009, -9.946161803999956],
              [34.49466923000011, -9.966729023999946],
              [34.52474491400005, -10.00879363999988],
              [34.53642378700005, -10.043003437999872],
              [34.5377673750001, -10.053855488999915],
              [34.53570031800007, -10.06532765699994],
              [34.52681197100014, -10.084861347999947],
              [34.52474491400005, -10.094783222999936],
              [34.532393026000136, -10.128889668999904],
              [34.565569296000035, -10.202683613999866],
              [34.57507775900007, -10.255806985999897],
              [34.58344934000013, -10.277614440999912],
              [34.58561975100008, -10.290016783999889],
              [34.58530969200012, -10.300662128999889],
              [34.565052531000106, -10.40980275499993],
              [34.56949670400013, -10.431403503999903],
              [34.58872033700004, -10.463132832999918],
              [34.59295780400009, -10.481736347999885],
              [34.59078739500012, -10.491244811999962],
              [34.58148563700007, -10.513672383999946],
              [34.57941857900005, -10.526488137999934],
              [34.580088163000084, -10.531844811999946],
              [34.58107222500007, -10.539717304999925],
              [34.585723104000124, -10.553566588999985],
              [34.592337687000054, -10.566692402999962],
              [34.60039921100014, -10.578061217999945],
              [34.60887414600012, -10.581988626999916],
              [34.61755578600008, -10.581471862999877],
              [34.62085892300007, -10.582422765999866],
              [34.62437707500004, -10.58343556699991],
              [34.62716760300009, -10.59511443999989],
              [34.62634078000008, -10.614338072999914],
              [34.629027954000094, -10.620229186999907],
              [34.650525350000066, -10.645343932999936],
              [34.660033814000144, -10.665497741999914],
              [34.66086063700004, -10.687305195999926],
              [34.64763147000008, -10.708389179999955],
              [34.6539359950001, -10.717587584999961],
              [34.65569299300006, -10.722031758999961],
              [34.6599304610001, -10.727716165999908],
              [34.666441691000045, -10.732367044999876],
              [34.67243615700011, -10.73949839299992],
              [34.67501997800008, -10.752417500999925],
              [34.66282434100009, -10.76140919999996],
              [34.65672652200004, -10.76988413499987],
              [34.660550577000095, -10.796032409999967],
              [34.64763147000008, -10.85856089299996],
              [34.64763147000008, -10.902899271999914],
              [34.64546106000006, -10.913234557999914],
              [34.627064250000046, -10.954058938999907],
              [34.61783828200009, -10.965738620999957],
              [34.59791874100006, -10.990955911999933],
              [34.59295780400009, -11.016174011999894],
              [34.597298625000064, -11.03663787899994],
              [34.61063114400008, -11.077668965999905],
              [34.61352502400007, -11.10216359499995],
              [34.62106978400004, -11.11973358099992],
              [34.66871545400011, -11.160144551999906],
              [34.67398645100013, -11.169963073999966],
              [34.677087036000046, -11.178748066999958],
              [34.68184126800014, -11.185052591999877],
              [34.69992801900008, -11.189496764999973],
              [34.707886190000124, -11.194974466999966],
              [34.7140873620001, -11.202725930999875],
              [34.71656783100008, -11.211717630999914],
              [34.71977176900015, -11.234558613999923],
              [34.72866011600007, -11.253988952999904],
              [34.74168257700012, -11.2686650589999],
              [34.75749556500011, -11.277553404999907],
              [34.75749556500011, -11.283754576999897],
              [34.751604452000095, -11.287061868999984],
              [34.74302616400007, -11.29367645299989],
              [34.73703169800007, -11.29677703799993],
              [34.759149210000146, -11.337498066999984],
              [34.765557088000094, -11.345146178999883],
              [34.77217167200007, -11.344422708999971],
              [34.78488407300006, -11.333467305999903],
              [34.792325480000045, -11.330883483999898],
              [34.80049035600007, -11.331917011999877],
              [34.84369185400004, -11.346283059999891],
              [34.86787642400009, -11.35878875699997],
              [34.88658329300006, -11.375428567999904],
              [34.89412805200004, -11.395995788999898],
              [34.898365520000084, -11.403540547999938],
              [34.917072388000065, -11.418836770999903],
              [34.9256506750001, -11.445915221999954],
              [34.935055786000135, -11.456457214999915],
              [34.94446089700011, -11.464415384999882],
              [34.94869836400005, -11.471753437999965],
              [34.95097212700006, -11.477747903999898],
              [34.955726359000096, -11.486739603999936],
              [34.96068729600012, -11.498521830999948],
              [34.96296105900012, -11.513094583999901],
              [34.96296105900012, -11.564874369999885],
              [34.96461470600008, -11.573556009999933],
            ],
          ],
          [
            [
              [34.69414025900011, -12.00040334099991],
              [34.71563765500014, -12.001643574999946],
              [34.73827193200009, -12.00949839199997],
              [34.754188273000125, -12.020143737999973],
              [34.76235315000014, -12.040297545999948],
              [34.759252563000075, -12.065618997999934],
              [34.748193807000064, -12.090423684999877],
              [34.73248417200011, -12.109027200999918],
              [34.71160689300012, -12.12080942799993],
              [34.688972616000115, -12.12453013099993],
              [34.669025512000076, -12.117812194999914],
              [34.6562097580001, -12.097244974999924],
              [34.65589969900009, -12.07626434299992],
              [34.66241092900009, -12.052803242999943],
              [34.68091109200009, -12.009395039999944],
              [34.69414025900011, -12.00040334099991],
            ],
          ],
          [
            [
              [34.561641886000075, -11.978595885999894],
              [34.56257206200013, -11.977975768999912],
              [34.5984355060001, -11.970534362999985],
              [34.62747766100006, -11.987277526999947],
              [34.64122359200013, -12.01786997399995],
              [34.63171512800005, -12.052493183999957],
              [34.611147908000135, -12.072543639999907],
              [34.59605839000005, -12.071923522999938],
              [34.58355269400005, -12.058901061999904],
              [34.570736939000085, -12.041021015999945],
              [34.54407190000012, -12.011358743999978],
              [34.541798136000125, -11.99461557999993],
              [34.561641886000075, -11.978595885999894],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Tanzania',
        iso3: 'TZA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [32.9208634850001, -9.407900085999913],
              [32.905463908000115, -9.398184915999963],
              [32.830739786000095, -9.37017628999996],
              [32.7843343510001, -9.339687194999968],
              [32.776996297000096, -9.338240254999974],
              [32.759633016000066, -9.339997252999865],
              [32.752294962000065, -9.337413430999959],
              [32.74650720300008, -9.329972024999933],
              [32.74340661600007, -9.314985859999865],
              [32.73968591300007, -9.30733774799998],
              [32.72583662900007, -9.292558287999967],
              [32.71322758000008, -9.28584035299994],
              [32.64160404500012, -9.279845885999919],
              [32.55561446100006, -9.261242369999962],
              [32.518045695000126, -9.25824513799995],
              [32.504454793000036, -9.249253437999911],
              [32.49008874500004, -9.227342630999942],
              [32.470658407000144, -9.181867369999893],
              [32.45970300300007, -9.168018086999936],
              [32.423426148000146, -9.143833516999862],
              [32.38301517700006, -9.133911641999958],
              [32.25273889200014, -9.13649546299996],
              [32.23144820200008, -9.13380828799994],
              [32.21129439300006, -9.126780293999929],
              [32.19160567200004, -9.112207539999872],
              [32.15481205300006, -9.075207213999917],
              [32.14557447900012, -9.070265111999916],
              [32.13414148000004, -9.064148457999906],
              [32.12504642700014, -9.063735045999906],
              [32.10582279400012, -9.06828257199993],
              [32.09641768400007, -9.069109394999955],
              [32.08603072100004, -9.06611216199994],
              [32.057246948000056, -9.049575703999949],
              [32.03171879100012, -9.045958353999964],
              [32.01580245000008, -9.052676289999894],
              [32.00138472500004, -9.063321634999895],
              [31.980559122000102, -9.071899921999915],
              [31.938081095000143, -9.061771341999957],
              [31.91772058100014, -9.022497252999898],
              [31.91782393400007, -8.973094583999881],
              [31.936634155000036, -8.932580260999956],
              [31.78759932400004, -8.892169290999973],
              [31.76434493000005, -8.894132995999911],
              [31.730238485000086, -8.912426452999895],
              [31.70977461800004, -8.91966115299995],
              [31.689620809000132, -8.919557799999922],
              [31.672670939000056, -8.913046568999945],
              [31.57644942200011, -8.839666035999912],
              [31.553350057000046, -8.809073587999904],
              [31.54585697400006, -8.766285501999974],
              [31.545960327000103, -8.728975117999937],
              [31.539035685000044, -8.703550312999937],
              [31.519088583000098, -8.687013854999933],
              [31.48064131700005, -8.67616180399989],
              [31.464724976000127, -8.666136576999875],
              [31.443227580000098, -8.641538593999883],
              [31.427517945000147, -8.633477070999987],
              [31.412428426000133, -8.632340189999894],
              [31.398837524000044, -8.633787129999888],
              [31.38597009300014, -8.632546894999848],
              [31.372637573000134, -8.623865254999885],
              [31.369226928000103, -8.616837259999969],
              [31.365919637000104, -8.598647155999927],
              [31.362198934000105, -8.592342630999923],
              [31.353310587000067, -8.587174987999916],
              [31.35010664800012, -8.588518574999881],
              [31.34752282700009, -8.592445983999937],
              [31.34039147900006, -8.59523651099991],
              [31.32881595900011, -8.597716979999888],
              [31.277087850000044, -8.616010436999943],
              [31.269388062000075, -8.621074726999922],
              [31.260913127000038, -8.623968607999913],
              [31.248045695000087, -8.621901549999947],
              [31.237348674000145, -8.613943378999892],
              [31.21843509900009, -8.588725279999935],
              [31.20675622600004, -8.580767109999968],
              [31.182675008000103, -8.580767109999968],
              [31.161384318000046, -8.591722513999855],
              [31.1410238040001, -8.606191914999968],
              [31.11983646700014, -8.616630553999912],
              [31.077823527000135, -8.616320494999925],
              [31.03364017700011, -8.600300800999975],
              [30.992350708000117, -8.575909525999947],
              [30.95953617400005, -8.550484720999947],
              [30.891891724000118, -8.479171244999876],
              [30.828278036000086, -8.388117369999932],
              [30.77825524900004, -8.289105325999927],
              [30.752106975000117, -8.194124042999917],
              [30.72812911000011, -8.10410369899995],
              [30.654955282000117, -7.927370299999936],
              [30.441634969000063, -7.596331074999895],
              [30.414711548000128, -7.501969908999868],
              [30.40494470200008, -7.436030780999943],
              [30.369598022000105, -7.310250345999876],
              [30.294460490000063, -7.149433288999958],
              [30.23467085800013, -7.057139179999893],
              [30.09085534600007, -6.89001759899989],
              [30.01272058100011, -6.825215351999887],
              [29.969112805000123, -6.803040265999911],
              [29.873090861000094, -6.754211933999983],
              [29.73862878400007, -6.652409362999919],
              [29.70700280800014, -6.619336445999934],
              [29.684368530000086, -6.581509297999958],
              [29.633932332000086, -6.446943867999906],
              [29.56602950000007, -6.35950734499994],
              [29.53771081500014, -6.312378438999929],
              [29.525515177000045, -6.273104349999869],
              [29.5088236900001, -6.153731790999927],
              [29.478696330000048, -6.041800637999913],
              [29.476112508000142, -6.002113137999928],
              [29.496059611000135, -5.938654479999897],
              [29.570887085000095, -5.83798878999994],
              [29.603029826000125, -5.781661478999936],
              [29.612434936000056, -5.704353534999925],
              [29.593521363000036, -5.620327657],
              [29.496369669000046, -5.391711119999883],
              [29.45564864100004, -5.22996388699994],
              [29.377823934000105, -5.087543639999936],
              [29.34423425300008, -5.005998229999889],
              [29.342792981000116, -4.999952894999922],
              [29.323770386000035, -4.920163675999959],
              [29.32103153500009, -4.836344502999893],
              [29.34082360800005, -4.751698506999986],
              [29.401336711000113, -4.586850686999895],
              [29.410896850000086, -4.502308043999932],
              [29.40727950000013, -4.462620543999947],
              [29.404178915000102, -4.449804788999955],
              [29.638273153000057, -4.446807555999939],
              [29.687469117000035, -4.458383076999894],
              [29.72829349800014, -4.461587014999864],
              [29.73284102300005, -4.463344014999933],
              [29.744364868000105, -4.454455667999923],
              [29.747413777000133, -4.443190205999954],
              [29.747930542000063, -4.430271096999945],
              [29.751651245000062, -4.416111755999907],
              [29.75795577000008, -4.410220641999913],
              [29.77500899200004, -4.402262470999943],
              [29.780176636000135, -4.393684183999909],
              [29.7822953700001, -4.377354430999972],
              [29.784104045000106, -4.373840432999927],
              [29.80033044400011, -4.363918557999924],
              [29.81097578900011, -4.365262145999893],
              [29.82182784000014, -4.370739847999886],
              [29.838571004000073, -4.37353037499993],
              [29.84735599700008, -4.370533141999928],
              [29.90047937000014, -4.345625101999957],
              [29.936342814000056, -4.31203541999993],
              [29.970655965000105, -4.292605081999852],
              [29.980784546000052, -4.284440204999925],
              [30.00300541100006, -4.271934508999934],
              [30.015614461000098, -4.256018167999912],
              [30.04114261900014, -4.19503997799994],
              [30.05147790600006, -4.180157165999987],
              [30.119587443000057, -4.123519795999911],
              [30.14976647900005, -4.086829527999939],
              [30.173227579000127, -4.046315205999932],
              [30.175852307000127, -4.039991996999973],
              [30.1914176840001, -4.002493591999922],
              [30.208780965000074, -3.93045664499995],
              [30.22076989800007, -3.909992777999889],
              [30.273273152000115, -3.856249287999987],
              [30.31172041800005, -3.789896748999865],
              [30.336990194000123, -3.773773701999886],
              [30.381586954000056, -3.788346455999942],
              [30.384997599000087, -3.770776467999966],
              [30.381897014000117, -3.75517018599993],
              [30.37621260600008, -3.739770609999937],
              [30.37197513800004, -3.722924092999961],
              [30.373068378000085, -3.704339017999928],
              [30.373112020000065, -3.703597106999908],
              [30.380140015000052, -3.685613708999924],
              [30.421377807000056, -3.620811461999921],
              [30.4288708900001, -3.602207946999954],
              [30.42923262500011, -3.583914488999895],
              [30.426855510000053, -3.563864033999948],
              [30.43228153500013, -3.551875101999897],
              [30.460135131000072, -3.531927997999958],
              [30.46261560000005, -3.527897236999877],
              [30.466336304000095, -3.516115009999879],
              [30.468920126000057, -3.513014424999923],
              [30.48555993700012, -3.510533955999946],
              [30.487523641000053, -3.510740661999918],
              [30.488040406000096, -3.512601012999923],
              [30.507160685000144, -3.511050719999986],
              [30.50824589000007, -3.50888030999991],
              [30.509951213000136, -3.500198668999943],
              [30.511501505000126, -3.497718200999969],
              [30.538114869000083, -3.491620381999923],
              [30.54498783400004, -3.489139912999946],
              [30.55294600400009, -3.482215270999873],
              [30.56596846500014, -3.466712340999948],
              [30.612890666000112, -3.444904886999922],
              [30.639142293000134, -3.419480081999922],
              [30.640434204000087, -3.392815042999871],
              [30.610250154000084, -3.376358647999936],
              [30.603278849000105, -3.372557880999878],
              [30.62167565900006, -3.350440368999955],
              [30.640537557000073, -3.332870380999893],
              [30.662603393000097, -3.31922780399988],
              [30.689940227000136, -3.308892516999961],
              [30.702239217000056, -3.307342223999854],
              [30.712006063000047, -3.30186452199996],
              [30.71841394100005, -3.292872822999911],
              [30.72146285000008, -3.280987242999885],
              [30.747921184000063, -3.294113056999947],
              [30.775671427000134, -3.291012470999917],
              [30.79975264500007, -3.274579365999941],
              [30.814842163000037, -3.247707621999936],
              [30.81432539900004, -3.241919860999872],
              [30.809881225000083, -3.224143167999941],
              [30.809364461000087, -3.216805114999943],
              [30.823523804000047, -3.196651305999879],
              [30.832205444000067, -3.172776793999972],
              [30.833962443000075, -3.160271097999981],
              [30.832928915000082, -3.147662048999962],
              [30.82879480000014, -3.140530700999918],
              [30.815824015000146, -3.131022236999939],
              [30.812258341000074, -3.123477477999899],
              [30.813085164000086, -3.117689717999923],
              [30.817839396000068, -3.104357197999903],
              [30.817684366000037, -3.099086201999867],
              [30.80781416800005, -3.085236917999907],
              [30.78321618600006, -3.062085876999916],
              [30.77825524900004, -3.047409768999927],
              [30.78486983300013, -3.031493427999905],
              [30.815824015000146, -2.995836689999905],
              [30.81881462400014, -2.990495174999907],
              [30.825487508000037, -2.978576760999914],
              [30.802129761000117, -2.97837005599996],
              [30.755414266000116, -2.991392516999909],
              [30.732056519000082, -2.993459573999957],
              [30.718879029000107, -2.989532164999986],
              [30.69598636900008, -2.974546],
              [30.683687378000116, -2.969998473999894],
              [30.671336711000095, -2.970825296999919],
              [30.661363159000075, -2.974752705999975],
              [30.650924520000046, -2.977336526999892],
              [30.637592001000087, -2.974442646999904],
              [30.634904825000092, -2.970101826999922],
              [30.63211429800009, -2.953772073999886],
              [30.629530477000117, -2.947674254999924],
              [30.625189656000146, -2.944780374999937],
              [30.611960490000058, -2.939199320999919],
              [30.547003215000075, -2.900338642999955],
              [30.538890015000106, -2.898995055999904],
              [30.524937378000118, -2.904162699999901],
              [30.51305179800005, -2.913981221999961],
              [30.493259725000087, -2.941266376999891],
              [30.488453817000106, -2.943540139999897],
              [30.488325079000106, -2.94316005799989],
              [30.48411299600008, -2.930724385999923],
              [30.47543135600006, -2.922146097999885],
              [30.469643595000093, -2.914187926999929],
              [30.474191121000104, -2.903232523999947],
              [30.456001017000062, -2.898271585999908],
              [30.44080814600005, -2.884008890999922],
              [30.415796753000052, -2.851659443999935],
              [30.413626343000146, -2.834399515999849],
              [30.425098510000055, -2.812178648999904],
              [30.4469059650001, -2.782723082999908],
              [30.44726770000011, -2.757298278999897],
              [30.450523315000055, -2.741795348999887],
              [30.458584839000082, -2.728669534999923],
              [30.516100708000067, -2.66831146199992],
              [30.52256026200007, -2.649397887999967],
              [30.499615926000104, -2.657872822999892],
              [30.463752482000075, -2.674202575999914],
              [30.442668498000046, -2.681127217999901],
              [30.42323815900005, -2.680920511999943],
              [30.41212772600005, -2.670171813999929],
              [30.41600345900008, -2.64557383199994],
              [30.424168335000104, -2.633171487999959],
              [30.448042846000078, -2.610537210999922],
              [30.457654663000085, -2.598031514999917],
              [30.461995483000067, -2.587489521999956],
              [30.47016036000008, -2.555760192999941],
              [30.508090861000085, -2.463466083999961],
              [30.521475057000146, -2.442278747999907],
              [30.554599650000057, -2.400627542999885],
              [30.573926636000124, -2.389258727999987],
              [30.59521732500008, -2.391945901999932],
              [30.61692142700008, -2.398147073999908],
              [30.637850382000067, -2.3970101929999],
              [30.64906416800011, -2.387605081999951],
              [30.663326864000112, -2.360733336999942],
              [30.674799031000134, -2.351741637999908],
              [30.68771813900014, -2.349984638999928],
              [30.698466837000126, -2.353395283999944],
              [30.750660034000134, -2.379130146999941],
              [30.758824910000044, -2.381093851999879],
              [30.76791996300011, -2.378613382999902],
              [30.77515466300008, -2.374479267999973],
              [30.78910730000007, -2.371068623999861],
              [30.80455855300005, -2.362180276999936],
              [30.82135339400014, -2.354738870999924],
              [30.834375855000076, -2.34533375999996],
              [30.84471114100006, -2.326626891999879],
              [30.848948608000114, -2.306266377999947],
              [30.84471114100006, -2.23784678099986],
              [30.853392782000128, -2.193818460999893],
              [30.88780928500006, -2.08250742599995],
              [30.87943770300012, -2.053465270999951],
              [30.868740682000123, -2.038995869999923],
              [30.853496135000057, -2.02369964499988],
              [30.835461059000068, -2.014707946999934],
              [30.816754191000086, -2.01873870799993],
              [30.829931681000062, -1.960551044999917],
              [30.826934449000134, -1.934092711999924],
              [30.796962118000124, -1.929338479999927],
              [30.801923055000145, -1.921276956999947],
              [30.80802087400008, -1.914765725999885],
              [30.82424727300014, -1.902053324999926],
              [30.816599162000045, -1.884173278999867],
              [30.822231893000094, -1.86877370199997],
              [30.83241215000004, -1.853787536999903],
              [30.837889852000046, -1.836837666999898],
              [30.829931681000062, -1.796736754999912],
              [30.826417684000035, -1.786194762999941],
              [30.837889852000046, -1.758702900999964],
              [30.83540938300007, -1.749504495999872],
              [30.826521037000134, -1.735861917999955],
              [30.82424727300014, -1.730694273999873],
              [30.824557333000087, -1.719945576999933],
              [30.837476440000103, -1.641087340999917],
              [30.838303263000057, -1.61535247799992],
              [30.831016887000146, -1.594165139999873],
              [30.80724572800011, -1.60326019299994],
              [30.791587768000056, -1.590961201999988],
              [30.78197595200004, -1.568430276999962],
              [30.772260783000092, -1.532463479999905],
              [30.767816610000068, -1.524815368999924],
              [30.755414266000116, -1.511586201999933],
              [30.73887780800004, -1.489468687999917],
              [30.732935018000035, -1.476446227999887],
              [30.73825769000007, -1.470658467999911],
              [30.741358277000074, -1.458876240999913],
              [30.74321862800008, -1.432831318999931],
              [30.737534220000043, -1.406683043999919],
              [30.718103881000104, -1.394900817999925],
              [30.698466837000126, -1.392110290999966],
              [30.632424357000104, -1.367615660999917],
              [30.623225952000098, -1.362034606999899],
              [30.608239787000116, -1.347771911999914],
              [30.597697795000045, -1.340330504999898],
              [30.568242228000145, -1.328134867999978],
              [30.55532312000014, -1.318419697999943],
              [30.54994877100006, -1.302400003999892],
              [30.550982300000044, -1.294958597999965],
              [30.553359416000035, -1.289067483999872],
              [30.55563317900004, -1.284726663999891],
              [30.556615031000092, -1.281626077999945],
              [30.554599650000057, -1.273461201999922],
              [30.54529789200012, -1.261368915999938],
              [30.539406779000046, -1.241008401999906],
              [30.521216675000062, -1.210829365999913],
              [30.51511885600013, -1.196256611999942],
              [30.511191447000044, -1.170418395999931],
              [30.506953979000116, -1.164217223999941],
              [30.494654989000082, -1.155328876999931],
              [30.49052087400014, -1.156465758999943],
              [30.484009643000093, -1.159979755999899],
              [30.476051473000098, -1.161219990999925],
              [30.467266479000045, -1.155328876999931],
              [30.46561283400007, -1.149334410999899],
              [30.468300008000085, -1.14333994499988],
              [30.47207238800013, -1.137655537999933],
              [30.474191121000104, -1.131764424999929],
              [30.470883829000115, -1.118121845999923],
              [30.456311076000134, -1.108096617999905],
              [30.453003785000135, -1.097347919999976],
              [30.456156047000093, -1.086082457999922],
              [30.463855835000118, -1.075127054999939],
              [30.471785843000134, -1.066836591999916],
              [30.47295088700008, -1.065618590999861],
              [30.48101241100005, -1.059107360999889],
              [30.493414754000128, -1.060244241999897],
              [30.50085616000007, -1.06520517999985],
              [30.506023803000062, -1.070786233999868],
              [30.5116565350001, -1.073370055999959],
              [30.52369714300005, -1.072439880999909],
              [30.54230066000008, -1.068099059999923],
              [30.592736857000034, -1.063448180999956],
              [30.614544311000145, -1.065825296999918],
              [30.63862552900008, -1.073370055999959],
              [30.651337931000057, -1.062828063999902],
              [30.687098023000146, -1.025000914999922],
              [30.701567424000075, -1.017456155999881],
              [30.73949792500008, -1.005467223999915],
              [30.777118367000128, -0.98583017999988],
              [30.812465048000035, -0.9947185259999],
              [30.82838138800014, -1.002573343999927],
              [30.89297692800011, -1.002573343999927],
              [31.076118204000068, -1.002573343999927],
              [31.259156128000086, -1.002573343999927],
              [31.280492691000063, -1.002573343999927],
              [31.442245727000056, -1.002573343999927],
              [31.625335327000073, -1.002573343999927],
              [31.808373251000035, -1.002573343999927],
              [31.986192661000075, -1.002573343999927],
              [31.99141117300013, -1.002573343999927],
              [32.17455244900009, -1.002573343999927],
              [32.35764205000004, -1.002573343999927],
              [32.54083500200005, -1.002573343999927],
              [32.722267718000126, -1.002573343999927],
              [32.72387292500008, -1.002573343999927],
              [32.84722537600004, -1.002573343999927],
              [32.90696252400011, -1.002573343999927],
              [33.08994877100014, -1.002573343999927],
              [33.273090047000096, -1.002573343999927],
              [33.426414846000114, -1.002573343999927],
              [33.456127970000125, -1.002573343999927],
              [33.631776971000136, -1.002573343999927],
              [33.63926924600008, -1.002573343999927],
              [33.822255493000114, -1.002573343999927],
              [33.90421431500005, -1.002573343999927],
              [33.98038537600007, -1.002573343999927],
              [33.98451949100007, -1.002056578999884],
              [34.0000224210001, -1.002573343999927],
              [34.00198612400004, -1.028721617999935],
              [34.01542199700009, -1.037506611999916],
              [34.05252567500008, -1.040400491999904],
              [34.12745650200014, -1.082258402999884],
              [34.342120402000035, -1.202147724999946],
              [34.55688765400009, -1.321933694999899],
              [34.71889334500014, -1.412413522999955],
              [34.77155155400004, -1.44182301799988],
              [34.986215454000046, -1.561608987999918],
              [35.200982707000094, -1.681498310999899],
              [35.24636655100005, -1.706823238999988],
              [35.41564660700004, -1.801284280999937],
              [35.63020715400012, -1.921173603999918],
              [35.84487105300008, -2.041062926999899],
              [36.05953495300008, -2.160952249999866],
              [36.2740955000001, -2.280841572999933],
              [36.488862753000035, -2.400627542999885],
              [36.70352665200005, -2.520413512999937],
              [36.918190552000056, -2.640302835999904],
              [37.13285445200012, -2.760088805999956],
              [37.34762170400006, -2.879978128999923],
              [37.42421187500008, -2.922753572999881],
              [37.56228560400007, -2.999867451999904],
              [37.64486454200005, -3.045962828999933],
              [37.66016076700009, -3.070560811999911],
              [37.67783410700008, -3.178977966999881],
              [37.67999554300013, -3.192147645999924],
              [37.70005497200009, -3.314370218999954],
              [37.681864868000105, -3.31571380599992],
              [37.67194299300007, -3.324292093999944],
              [37.668428996000046, -3.338244730999946],
              [37.66987593600004, -3.356124775999902],
              [37.6509623610001, -3.357571715999896],
              [37.62719120300011, -3.370284117999944],
              [37.60486698400007, -3.387957457999946],
              [37.5902942300001, -3.404080504999925],
              [37.58522994000003, -3.412968851999949],
              [37.58047570800005, -3.424130960999975],
              [37.577891887000135, -3.435809834999944],
              [37.57944217900007, -3.446351826999916],
              [37.586676880000084, -3.453689879999914],
              [37.603109986000106, -3.455756936999876],
              [37.60817427600006, -3.463611755999906],
              [37.60414351400004, -3.480148212999907],
              [37.596185343000116, -3.499681904999903],
              [37.5990792230001, -3.513427835999934],
              [37.64693160000007, -3.510637308999975],
              [37.66832564300012, -3.51249765999998],
              [37.689409627000146, -3.518078714999902],
              [37.70832320200009, -3.52717376699988],
              [37.722275839000076, -3.539989521999956],
              [37.72982059800012, -3.555389098999939],
              [37.747183878000044, -3.616987405999879],
              [37.75720910600006, -3.637451273999943],
              [37.77095503800007, -3.655434671999927],
              [37.82542199700009, -3.694502054999944],
              [37.910791463000066, -3.755997008999941],
              [37.996057577000045, -3.817491962999952],
              [38.08153039500007, -3.878986917999967],
              [38.16679650900005, -3.940378519999854],
              [38.252062622000096, -4.00187347399995],
              [38.337535441000114, -4.063265075999936],
              [38.41617485900008, -4.119980776999924],
              [38.4228015540001, -4.124760029999948],
              [38.50827437300012, -4.18615163199992],
              [38.5935404870001, -4.247543232999902],
              [38.678806600000144, -4.309038187999917],
              [38.764279419000104, -4.370533141999928],
              [38.84964888500008, -4.4319247439999],
              [38.93501835100005, -4.493419697999911],
              [39.020387817000085, -4.554914652999926],
              [39.10575728400005, -4.616306253999909],
              [39.19060306100005, -4.677504164999959],
              [39.19743899800005, -4.683770440999922],
              [39.21509850400008, -4.688653252999927],
              [39.22152754000007, -4.716729424999926],
              [39.21607506600009, -4.749118747999944],
              [39.19743899800005, -4.766289971999925],
              [39.17017662900008, -4.779961846999925],
              [39.19223066500007, -4.788832289999959],
              [39.20728600400008, -4.790134372999944],
              [39.21599368600005, -4.795668226999908],
              [39.21851647200003, -4.817803643999923],
              [39.21729576900009, -4.839043877999927],
              [39.213552280000044, -4.856377862999921],
              [39.207041863000086, -4.87232838299991],
              [39.17514082100007, -4.926446221999925],
              [39.16228274800005, -4.938653252999927],
              [39.15650475400008, -4.924004815999922],
              [39.15992272200003, -4.904229424999926],
              [39.166351759000065, -4.884860934999949],
              [39.16960696700005, -4.865899346999925],
              [39.16334069100009, -4.848321221999925],
              [39.14568118600005, -4.899834893999923],
              [39.13038170700008, -4.918145440999922],
              [39.10865319100009, -4.916599216999941],
              [39.125987175000034, -4.943454684999949],
              [39.12867272200003, -4.953383070999905],
              [39.13217207100007, -5.010186455999929],
              [39.12916100400008, -5.020196221999925],
              [39.12232506600009, -5.024509372999944],
              [39.10678144600007, -5.019626559999949],
              [39.09815514400009, -5.023370049999926],
              [39.094411655000044, -5.028415622999944],
              [39.08448326900009, -5.047784112999921],
              [39.082774285000085, -5.061455987999921],
              [39.09717858200008, -5.060642184999949],
              [39.12916100400008, -5.047539971999925],
              [39.129893425000034, -5.062595309999949],
              [39.14087975400008, -5.086602471999925],
              [39.14275149800005, -5.095879815999922],
              [39.138682488000086, -5.10320403399993],
              [39.100596550000034, -5.13640715899993],
              [39.094086134000065, -5.144952080999929],
              [39.074229363000086, -5.186293226999908],
              [39.043630405000044, -5.232191664999959],
              [39.04037519600007, -5.239353122999944],
              [39.04818769600007, -5.246677341999941],
              [39.05909264400009, -5.238376559999949],
              [39.074554884000065, -5.218845309999949],
              [39.08057701900009, -5.231133721999925],
              [39.03728274800005, -5.356540622999944],
              [39.026377800000034, -5.378513278999947],
              [39.012461785000085, -5.397067966999941],
              [39.001963738000086, -5.40398528399993],
              [38.99040774800005, -5.409600518999923],
              [38.98129316500007, -5.417413018999923],
              [38.97828209700003, -5.431084893999923],
              [38.98259524800005, -5.439548434999949],
              [38.99048912900008, -5.443291924999926],
              [38.99740644600007, -5.449395440999922],
              [38.998789910000085, -5.465264580999929],
              [38.985362175000034, -5.504978122999944],
              [38.95655358200008, -5.563653252999927],
              [38.92164147200003, -5.616306247999944],
              [38.88892662900008, -5.637139580999929],
              [38.90259850400008, -5.643324476999908],
              [38.89600670700008, -5.663995049999926],
              [38.895192905000044, -5.710544528999947],
              [38.885508660000085, -5.729099216999941],
              [38.87281334700003, -5.745049737999921],
              [38.85466556100005, -5.782159112999921],
              [38.83253014400009, -5.815606377999927],
              [38.82536868600005, -5.83717213299991],
              [38.82162519600007, -5.860528252999927],
              [38.821299675000034, -5.924981377999927],
              [38.817067905000044, -5.934747002999927],
              [38.810557488000086, -5.941664320999905],
              [38.80494225400008, -5.950372002999927],
              [38.80103600400008, -5.959730726999908],
              [38.80030358200008, -5.963067315999922],
              [38.794932488000086, -5.988539320999905],
              [38.78541100400008, -6.008884372999944],
              [38.778005405000044, -6.030694268999923],
              [38.77906334700003, -6.054864190999922],
              [38.78272545700008, -6.061293226999908],
              [38.79517662900008, -6.075616143999923],
              [38.799571160000085, -6.082207940999922],
              [38.80909264400009, -6.120700778999947],
              [38.813243035000085, -6.130629164999959],
              [38.819102410000085, -6.13640715899993],
              [38.84115644600007, -6.150485934999949],
              [38.85678144600007, -6.163669528999947],
              [38.85857181100005, -6.169854424999926],
              [38.86247806100005, -6.207614841999941],
              [38.860036655000044, -6.231622002999927],
              [38.85303795700008, -6.25318775799991],
              [38.84115644600007, -6.267754815999922],
              [38.84880618600005, -6.29265715899993],
              [38.852224155000044, -6.348728122999944],
              [38.86475670700008, -6.373630466999941],
              [38.875661655000044, -6.381524346999925],
              [38.88795006600009, -6.387872002999927],
              [38.89828535200007, -6.394707940999922],
              [38.90259850400008, -6.404392184999949],
              [38.90414472700007, -6.415134372999944],
              [38.908539259000065, -6.426364841999941],
              [38.915049675000034, -6.436700127999927],
              [38.92310631600009, -6.445245049999926],
              [38.92888431100005, -6.449395440999922],
              [38.933929884000065, -6.451429945999905],
              [38.94703209700003, -6.452080987999921],
              [38.953868035000085, -6.455010674999926],
              [38.95728600400008, -6.461521091999941],
              [38.96013431100005, -6.468519789999959],
              [38.96469160200007, -6.473239841999941],
              [38.977305535000085, -6.475518487999921],
              [39.00505618600005, -6.476983330999929],
              [39.01587975400008, -6.483168226999908],
              [39.026052280000044, -6.486993096999925],
              [39.03687584700003, -6.483168226999908],
              [39.035899285000085, -6.475192966999941],
              [39.02719160200007, -6.471368096999925],
              [39.01107832100007, -6.465101820999905],
              [38.99138431100005, -6.452080987999921],
              [39.02003014400009, -6.460870049999926],
              [39.04086347700007, -6.470147393999923],
              [39.09620201900009, -6.522393487999921],
              [39.12916100400008, -6.561944268999923],
              [39.15552819100009, -6.580743096999925],
              [39.16334069100009, -6.589288018999923],
              [39.178396030000044, -6.615004164999959],
              [39.18726647200003, -6.624200127999927],
              [39.20427493600005, -6.634372653999947],
              [39.21273847700007, -6.641778252999927],
              [39.219411655000044, -6.653090101999908],
              [39.223399285000085, -6.666110934999949],
              [39.22478274800005, -6.678806247999944],
              [39.23096764400009, -6.703708591999941],
              [39.24586022200003, -6.731052341999941],
              [39.26392662900008, -6.744398695999905],
              [39.280039910000085, -6.727146091999941],
              [39.28443444100009, -6.756117445999905],
              [39.27979576900009, -6.795098565999922],
              [39.280284050000034, -6.830498955999929],
              [39.30046634200005, -6.849379164999959],
              [39.299815300000034, -6.831149997999944],
              [39.29818769600007, -6.823418877999927],
              [39.293711785000085, -6.815199476999908],
              [39.31202233200008, -6.816338799999926],
              [39.326508009000065, -6.82195403399993],
              [39.35499108200008, -6.83912525799991],
              [39.37029056100005, -6.843194268999923],
              [39.40056399800005, -6.845879815999922],
              [39.413096550000034, -6.85279713299991],
              [39.42790774800005, -6.858086846999925],
              [39.46452884200005, -6.857679945999905],
              [39.471690300000034, -6.863376559999949],
              [39.47592207100007, -6.877129815999922],
              [39.49431399800005, -6.901299737999921],
              [39.502696160000085, -6.930840752999927],
              [39.55054772200003, -6.99382903399993],
              [39.553721550000034, -7.000746351999908],
              [39.55258222700007, -7.010430596999925],
              [39.54769941500007, -7.016534112999921],
              [39.54249108200008, -7.021742445999905],
              [39.540049675000034, -7.028090101999908],
              [39.54859459700003, -7.091892184999949],
              [39.547536655000044, -7.118259372999944],
              [39.53256269600007, -7.11687590899993],
              [39.522471550000034, -7.129571221999925],
              [39.51490319100009, -7.156670830999929],
              [39.50904381600009, -7.168389580999929],
              [39.49789472700007, -7.177178643999923],
              [39.48845462300005, -7.176934502999927],
              [39.48129316500007, -7.168064059999949],
              [39.47787519600007, -7.151055596999925],
              [39.435883009000065, -7.180271091999941],
              [39.43474368600005, -7.181735934999949],
              [39.426768425000034, -7.192315362999921],
              [39.42115319100009, -7.210137627999927],
              [39.41879316500007, -7.226169528999947],
              [39.414398634000065, -7.240899346999925],
              [39.40284264400009, -7.254652601999908],
              [39.38990319100009, -7.264825127999927],
              [39.38363691500007, -7.267347914999959],
              [39.37525475400008, -7.268324476999908],
              [39.36744225400008, -7.271416924999926],
              [39.36841881600009, -7.278903903999947],
              [39.37289472700007, -7.287774346999925],
              [39.375661655000044, -7.295586846999925],
              [39.369802280000044, -7.306898695999905],
              [39.35596764400009, -7.309502862999921],
              [39.34009850400008, -7.308526299999926],
              [39.32781009200005, -7.309258721999925],
              [39.33757571700005, -7.325372002999927],
              [39.34750410200007, -7.336521091999941],
              [39.354258660000085, -7.34929778399993],
              [39.35434004000007, -7.37078215899993],
              [39.349945509000065, -7.385430596999925],
              [39.34107506600009, -7.40593840899993],
              [39.330414259000065, -7.424248955999929],
              [39.30396569100009, -7.44850025799991],
              [39.29232832100007, -7.486260674999926],
              [39.27475019600007, -7.596449476999908],
              [39.27588951900009, -7.616957289999959],
              [39.280039910000085, -7.637627862999921],
              [39.29281660200007, -7.669691664999959],
              [39.29623457100007, -7.688409112999921],
              [39.29029381600009, -7.703383070999905],
              [39.28687584700003, -7.717543226999908],
              [39.30201256600009, -7.754082940999922],
              [39.29712975400008, -7.771661065999922],
              [39.252614780000044, -7.823337497999944],
              [39.283213738000086, -7.816582940999922],
              [39.305023634000065, -7.791761976999908],
              [39.319346550000034, -7.758558851999908],
              [39.32781009200005, -7.726332289999959],
              [39.34327233200008, -7.738946221999925],
              [39.35523522200003, -7.752536716999941],
              [39.35670006600009, -7.76685963299991],
              [39.340830925000034, -7.781670830999929],
              [39.37842858200008, -7.778008721999925],
              [39.395518425000034, -7.779880466999941],
              [39.413096550000034, -7.792168877999927],
              [39.44027754000007, -7.818536065999922],
              [39.44353274800005, -7.832614841999941],
              [39.43702233200008, -7.857354424999926],
              [39.422211134000065, -7.889743747999944],
              [39.420909050000034, -7.90203215899993],
              [39.431651238000086, -7.936944268999923],
              [39.432627800000034, -7.976006768999923],
              [39.43702233200008, -7.993910414999959],
              [39.45240319100009, -7.984470309999949],
              [39.45753014400009, -7.979668877999927],
              [39.45435631600009, -8.010430596999925],
              [39.44190514400009, -8.038669528999947],
              [39.40967858200008, -8.08953215899993],
              [39.37647545700008, -8.17945728999996],
              [39.36182701900009, -8.20680103999996],
              [39.35499108200008, -8.203545830999929],
              [39.351898634000065, -8.203789971999925],
              [39.348643425000034, -8.205498955999929],
              [39.340830925000034, -8.20680103999996],
              [39.34782962300005, -8.22161223799992],
              [39.34555097700007, -8.257419528999947],
              [39.348317905000044, -8.27507903399993],
              [39.333994988000086, -8.26881275799991],
              [39.33383222700007, -8.276788018999923],
              [39.32781009200005, -8.295586846999925],
              [39.311534050000034, -8.277764580999929],
              [39.30323326900009, -8.271661065999922],
              [39.293711785000085, -8.26881275799991],
              [39.30160566500007, -8.283379815999922],
              [39.30209394600007, -8.295098565999922],
              [39.294932488000086, -8.303806247999944],
              [39.280039910000085, -8.309258721999925],
              [39.29273522200003, -8.33489348799992],
              [39.30095462300005, -8.36109791499996],
              [39.305349155000044, -8.388929945999905],
              [39.306651238000086, -8.419366143999923],
              [39.29997806100005, -8.477308851999908],
              [39.303070509000065, -8.505466403999947],
              [39.33643639400009, -8.539483330999929],
              [39.34896894600007, -8.56259530999995],
              [39.35767662900008, -8.588311455999929],
              [39.36182701900009, -8.610935153999947],
              [39.360036655000044, -8.694431247999944],
              [39.35434004000007, -8.713962497999944],
              [39.389333530000044, -8.723809502999927],
              [39.395274285000085, -8.730075778999947],
              [39.39812259200005, -8.73805103999996],
              [39.40219160200007, -8.74504973799992],
              [39.413096550000034, -8.74814218499995],
              [39.43311608200008, -8.749607028999947],
              [39.43913821700005, -8.755466403999947],
              [39.43962649800005, -8.767836195999905],
              [39.44385826900009, -8.788995049999926],
              [39.45264733200008, -8.805352471999925],
              [39.463633660000085, -8.812758070999905],
              [39.475596550000034, -8.817966403999947],
              [39.48853600400008, -8.826918226999908],
              [39.497080925000034, -8.840915622999944],
              [39.508555535000085, -8.87590911299992],
              [39.519541863000086, -8.892022393999923],
              [39.54769941500007, -8.913181247999944],
              [39.553721550000034, -8.922295830999929],
              [39.539724155000044, -8.926202080999929],
              [39.52784264400009, -8.92546965899993],
              [39.52068118600005, -8.923028252999927],
              [39.50603274800005, -8.91187916499996],
              [39.50407962300005, -8.909763278999947],
              [39.48487389400009, -8.892022393999923],
              [39.46461022200003, -8.867445570999905],
              [39.44939212300005, -8.85865650799991],
              [39.43018639400009, -8.861260674999926],
              [39.418955925000034, -8.865817966999941],
              [39.413096550000034, -8.867364190999922],
              [39.408946160000085, -8.870212497999944],
              [39.388682488000086, -8.898858330999929],
              [39.40381920700008, -8.904554945999905],
              [39.46420332100007, -8.898858330999929],
              [39.45093834700003, -8.915134372999944],
              [39.447601759000065, -8.92555103999996],
              [39.45533287900008, -8.93132903399993],
              [39.47486412900008, -8.933038018999923],
              [39.49187259200005, -8.93840911299992],
              [39.49203535200007, -8.952325127999927],
              [39.48617597700007, -8.972100518999923],
              [39.48487389400009, -8.994398695999905],
              [39.487315300000034, -8.99814218499995],
              [39.49626712300005, -9.004978122999944],
              [39.49854576900009, -9.00872161299992],
              [39.498789910000085, -9.027601820999905],
              [39.49854576900009, -9.029229424999926],
              [39.493174675000034, -9.039320570999905],
              [39.49236087300005, -9.042901299999926],
              [39.494476759000065, -9.045342705999929],
              [39.49919681100005, -9.047133070999905],
              [39.50375410200007, -9.050225518999923],
              [39.50603274800005, -9.056247653999947],
              [39.50310306100005, -9.065850518999923],
              [39.49732506600009, -9.07236093499995],
              [39.49333743600005, -9.079522393999923],
              [39.49537194100009, -9.090590101999908],
              [39.502696160000085, -9.106622002999927],
              [39.502696160000085, -9.11419036299992],
              [39.49854576900009, -9.124200127999927],
              [39.512705925000034, -9.12118905999995],
              [39.529958530000044, -9.11305103999996],
              [39.54607181100005, -9.102959893999923],
              [39.55713951900009, -9.09384530999995],
              [39.56918379000007, -9.09303150799991],
              [39.58366946700005, -9.106215101999908],
              [39.62671959700003, -9.160332940999922],
              [39.64380944100009, -9.189060153999947],
              [39.64861087300005, -9.219903252999927],
              [39.632823113000086, -9.251397393999923],
              [39.63209069100009, -9.258477471999925],
              [39.63795006600009, -9.266696872999944],
              [39.645518425000034, -9.274997653999947],
              [39.64991295700008, -9.28248463299991],
              [39.64991295700008, -9.293633721999925],
              [39.64437910200007, -9.31373463299991],
              [39.64307701900009, -9.323418877999927],
              [39.64625084700003, -9.356622002999927],
              [39.64283287900008, -9.368584893999923],
              [39.62940514400009, -9.385511976999908],
              [39.615977410000085, -9.397149346999925],
              [39.60718834700003, -9.399102471999925],
              [39.59742272200003, -9.397637627999927],
              [39.58155358200008, -9.399183851999908],
              [39.569102410000085, -9.404961846999925],
              [39.56397545700008, -9.414239190999922],
              [39.56421959700003, -9.428155205999929],
              [39.567393425000034, -9.447523695999905],
              [39.57634524800005, -9.44312916499996],
              [39.58773847700007, -9.44109465899993],
              [39.608409050000034, -9.440118096999925],
              [39.61085045700008, -9.429131768999923],
              [39.615896030000044, -9.424899997999944],
              [39.625743035000085, -9.429864190999922],
              [39.63209069100009, -9.43645598799992],
              [39.635508660000085, -9.43914153399993],
              [39.639659050000034, -9.440118096999925],
              [39.650726759000065, -9.444756768999923],
              [39.652354363000086, -9.45517343499995],
              [39.65015709700003, -9.46656666499996],
              [39.64991295700008, -9.47429778399993],
              [39.65674889400009, -9.483493747999944],
              [39.680674675000034, -9.505303643999923],
              [39.68913821700005, -9.524997653999947],
              [39.70093834700003, -9.579522393999923],
              [39.71143639400009, -9.59465911299992],
              [39.724945509000065, -9.604099216999941],
              [39.72234134200005, -9.610528252999927],
              [39.71436608200008, -9.616794528999947],
              [39.71208743600005, -9.62509530999995],
              [39.71705162900008, -9.635918877999927],
              [39.72193444100009, -9.642836195999905],
              [39.73519941500007, -9.655857028999947],
              [39.740896030000044, -9.666761976999908],
              [39.73747806100005, -9.687107028999947],
              [39.74659264400009, -9.706475518999923],
              [39.73845462300005, -9.71298593499995],
              [39.71827233200008, -9.720635674999926],
              [39.70142662900008, -9.73642343499995],
              [39.69695071700005, -9.744886976999908],
              [39.705088738000086, -9.748630466999941],
              [39.744802280000044, -9.74773528399993],
              [39.752289259000065, -9.748630466999941],
              [39.75554446700005, -9.755791924999926],
              [39.76343834700003, -9.782810153999947],
              [39.76970462300005, -9.79306405999995],
              [39.786143425000034, -9.804945570999905],
              [39.793955925000034, -9.812432549999926],
              [39.80062910200007, -9.823825778999947],
              [39.807302280000044, -9.852227471999925],
              [39.80005944100009, -9.872653903999947],
              [39.781260613000086, -9.882419528999947],
              [39.752289259000065, -9.87900155999995],
              [39.760752800000034, -9.892510674999926],
              [39.78923587300005, -9.914239190999922],
              [39.79021243600005, -9.923028252999927],
              [39.77947024800005, -9.930108330999929],
              [39.74496504000007, -9.94459400799991],
              [39.71420332100007, -9.95208098799992],
              [39.71371504000007, -9.963555596999925],
              [39.72632897200003, -9.988864841999941],
              [39.72437584700003, -10.00750090899993],
              [39.71705162900008, -10.02157968499995],
              [39.705414259000065, -10.03289153399993],
              [39.69076582100007, -10.043389580999929],
              [39.71648196700005, -10.03875090899993],
              [39.76319420700008, -9.982842705999929],
              [39.78370201900009, -9.985039971999925],
              [39.79704837300005, -9.992445570999905],
              [39.826914910000085, -9.99032968499995],
              [39.84815514400009, -10.01140715899993],
              [39.861338738000086, -10.013116143999923],
              [39.875987175000034, -10.012465101999908],
              [39.889414910000085, -10.01490650799991],
              [39.91431725400008, -10.033868096999925],
              [39.974945509000065, -10.133396091999941],
              [39.97681725400008, -10.191013278999947],
              [39.985118035000085, -10.220961195999905],
              [39.99537194100009, -10.20907968499995],
              [40.00049889400009, -10.19264088299991],
              [40.000661655000044, -10.175225518999923],
              [39.99561608200008, -10.15984465899993],
              [39.98658287900008, -10.139743747999944],
              [39.98878014400009, -10.131280205999929],
              [40.000661655000044, -10.13014088299991],
              [40.01978600400008, -10.13290780999995],
              [40.03435306100005, -10.137139580999929],
              [40.06527754000007, -10.15048593499995],
              [40.08480879000007, -10.155043226999908],
              [40.12476647200003, -10.169366143999923],
              [40.129649285000085, -10.168226820999905],
              [40.13266035200007, -10.16969166499996],
              [40.13591556100005, -10.18059661299992],
              [40.13404381600009, -10.193536065999922],
              [40.12745201900009, -10.206963799999926],
              [40.12427819100009, -10.22161223799992],
              [40.13249759200005, -10.23837655999995],
              [40.135508660000085, -10.247653903999947],
              [40.12810306100005, -10.252699476999908],
              [40.11841881600009, -10.256931247999944],
              [40.11540774800005, -10.263116143999923],
              [40.12061608200008, -10.27117278399993],
              [40.12582441500007, -10.271742445999905],
              [40.13111412900008, -10.269463799999926],
              [40.13591556100005, -10.268731377999927],
              [40.15259850400008, -10.278903903999947],
              [40.16041100400008, -10.280450127999927],
              [40.16382897200003, -10.272556247999944],
              [40.16456139400009, -10.262139580999929],
              [40.16765384200005, -10.256280205999929],
              [40.173838738000086, -10.25514088299991],
              [40.184336785000085, -10.25945403399993],
              [40.19654381600009, -10.267754815999922],
              [40.219737175000034, -10.288181247999944],
              [40.23210696700005, -10.29664478999996],
              [40.23194420700008, -10.287530205999929],
              [40.23365319100009, -10.281182549999926],
              [40.236338738000086, -10.275811455999929],
              [40.238942905000044, -10.268731377999927],
              [40.246836785000085, -10.274102471999925],
              [40.25277754000007, -10.275567315999922],
              [40.258799675000034, -10.273695570999905],
              [40.26685631600009, -10.268731377999927],
              [40.24984785200007, -10.263848565999922],
              [40.198008660000085, -10.242120049999926],
              [40.23210696700005, -10.20045338299991],
              [40.24537194100009, -10.204685153999947],
              [40.25114993600005, -10.215997002999927],
              [40.25416100400008, -10.229913018999923],
              [40.25945071700005, -10.242120049999926],
              [40.268239780000044, -10.249200127999927],
              [40.29070071700005, -10.259942315999922],
              [40.30103600400008, -10.268731377999927],
              [40.30648847700007, -10.277601820999905],
              [40.33871504000007, -10.348809502999927],
              [40.34880618600005, -10.358086846999925],
              [40.35132897200003, -10.35637786299992],
              [40.38502037900008, -10.36305103999996],
              [40.38982181100005, -10.36492278399993],
              [40.42212975400008, -10.355645440999922],
              [40.426768425000034, -10.335870049999926],
              [40.414805535000085, -10.32040780999995],
              [40.397227410000085, -10.32390715899993],
              [40.392588738000086, -10.312107028999947],
              [40.39600670700008, -10.303480726999908],
              [40.40512129000007, -10.298435153999947],
              [40.41773522200003, -10.29664478999996],
              [40.42701256600009, -10.30006275799991],
              [40.43140709700003, -10.30828215899993],
              [40.43482506600009, -10.31845468499995],
              [40.44068444100009, -10.327325127999927],
              [40.44939212300005, -10.34539153399993],
              [40.440196160000085, -10.36142343499995],
              [40.42367597700007, -10.376560153999947],
              [40.410899285000085, -10.39226653399993],
              [40.41724694100009, -10.391696872999944],
              [40.43051191500007, -10.392754815999922],
              [40.43685957100007, -10.39226653399993],
              [40.42603600400008, -10.426202080999929],
              [40.424571160000085, -10.43718840899993],
              [40.42725670700008, -10.444756768999923],
              [40.43287194100009, -10.452325127999927],
              [40.437510613000086, -10.461602471999925],
              [40.43685957100007, -10.474786065999922],
              [40.42102583900004, -10.503750508999957],
              [40.38919315600009, -10.53527313199993],
              [40.35332971100013, -10.56069793699993],
              [40.28852746600012, -10.583022154999895],
              [40.25070031700005, -10.610927428999972],
              [40.19158247900009, -10.668805032999913],
              [40.172772258000066, -10.693092956999905],
              [40.16109338400008, -10.70435841899996],
              [40.133188110000106, -10.714590351999945],
              [40.00813114400006, -10.811121927999878],
              [39.989114217000065, -10.820940449999938],
              [39.88596805800006, -10.864452005999865],
              [39.78581913300013, -10.932561542999878],
              [39.76049768100006, -10.943103535999938],
              [39.592755982000085, -10.979380390999893],
              [39.51565474500012, -10.985064798999929],
              [39.49849816900007, -10.990645852999947],
              [39.48268518000009, -10.999224141999974],
              [39.286624797000115, -11.154150084999884],
              [39.263267049000035, -11.166759133999903],
              [39.23815230300005, -11.17420054099992],
              [39.21159061700013, -11.173890481999933],
              [39.19050663200011, -11.166242369999864],
              [39.149785604000044, -11.14433156299991],
              [39.12622115100004, -11.139680683999941],
              [39.095421997000074, -11.153426614999972],
              [39.06079878800006, -11.160144551999906],
              [38.93005741400009, -11.160041198999878],
              [38.89626102700004, -11.167689309999957],
              [38.869492635000086, -11.190736998999924],
              [38.851922648000084, -11.202829283999904],
              [38.83104536900004, -11.207996927999915],
              [38.81781620300012, -11.216265156999953],
              [38.77802535000012, -11.253678893999918],
              [38.75973189300004, -11.263187356999907],
              [38.74867313700014, -11.262773945999896],
              [38.72707238800007, -11.257709655999918],
              [38.715083456000116, -11.256469420999878],
              [38.704231405000144, -11.258536478999943],
              [38.68397424300008, -11.26783823599996],
              [38.6542086180001, -11.27579640699993],
              [38.63818892400013, -11.28923227899989],
              [38.61565799900012, -11.317240904999892],
              [38.517162720000044, -11.383076680999878],
              [38.49225467900004, -11.413462422999928],
              [38.49168788800006, -11.413136860999913],
              [38.46238570100007, -11.396305846999965],
              [38.383114055000135, -11.37666880299993],
              [38.34766402200006, -11.35878875699997],
              [38.29247359200008, -11.301634622999941],
              [38.25661014800005, -11.277139993999896],
              [38.2104114170001, -11.270008645999951],
              [38.20048954300012, -11.272695820999985],
              [38.178372030000105, -11.281790872999863],
              [38.16689986100005, -11.283754576999897],
              [38.15501428200014, -11.280550638999927],
              [38.1353772380001, -11.266391295999966],
              [38.12566206900004, -11.263187356999907],
              [38.1224581300001, -11.26122365299996],
              [38.11718713400006, -11.252025247999967],
              [38.115430135000054, -11.249544778999905],
              [38.10933231700011, -11.249648131999919],
              [38.10426802500007, -11.252025247999967],
              [38.1011674400001, -11.254919128999859],
              [38.1011674400001, -11.256469420999878],
              [38.09335726900014, -11.256310029999923],
              [38.07078169800013, -11.25584930399991],
              [38.013627563000114, -11.265461119999927],
              [38.00422245300007, -11.275279641999887],
              [37.99533410600014, -11.277553404999907],
              [37.95461307800008, -11.280033873999884],
              [37.93807661900007, -11.283961283999943],
              [37.87523807700012, -11.3191012569999],
              [37.868416789000094, -11.327782897999953],
              [37.86583296800006, -11.342459003999934],
              [37.85043339000009, -11.387624206999917],
              [37.841028280000046, -11.399819844999925],
              [37.84247522000004, -11.41780324299991],
              [37.81849735500009, -11.459867858999942],
              [37.813226359000055, -11.482295429999937],
              [37.81725712100007, -11.495627949999871],
              [37.82325158700007, -11.507926939999905],
              [37.825111939000124, -11.520225931999946],
              [37.816947062000054, -11.533558451999866],
              [37.804441366000106, -11.544513854999934],
              [37.783667439000055, -11.558879902999948],
              [37.71090702300006, -11.59040252699991],
              [37.66636193800008, -11.625542500999956],
              [37.647758423000084, -11.635981139999984],
              [37.6263643800001, -11.639701842999912],
              [37.59463505100007, -11.640011901999898],
              [37.57293094900007, -11.644146015999908],
              [37.53675744700007, -11.662956237999921],
              [37.51588016700009, -11.667297057999903],
              [37.5037878820001, -11.672671406999953],
              [37.496036418000074, -11.68507374999993],
              [37.49035201000004, -11.698923034999893],
              [37.484770956000034, -11.708844909999897],
              [37.47639937400004, -11.715976256999923],
              [37.46968143700013, -11.719490254999883],
              [37.45066451000008, -11.722590839999924],
              [37.427823527000044, -11.722590839999924],
              [37.3783175050001, -11.708844909999897],
              [37.370152628000085, -11.704814147999898],
              [37.352375936000044, -11.68631398499987],
              [37.3408004150001, -11.680939635999906],
              [37.33139530400007, -11.681559752999888],
              [37.323643840000045, -11.685280455999887],
              [37.315789021000114, -11.69024139399994],
              [37.306073852000054, -11.694582213999922],
              [37.27021040900013, -11.698406269999865],
              [37.2265954990001, -11.693755390999897],
              [37.14163944500007, -11.674738464999919],
              [37.10649947100006, -11.65809865299991],
              [37.071566203000145, -11.62915985099994],
              [37.04438439900008, -11.595673522999945],
              [37.03239546700013, -11.564874369999885],
              [37.01668583100013, -11.573969420999944],
              [37.00779748500014, -11.580584004999935],
              [36.998392375000094, -11.58461476599993],
              [36.90589156000004, -11.592779642999858],
              [36.89111210100015, -11.589989114999895],
              [36.86630741400006, -11.574176126999902],
              [36.84656701600011, -11.572729186999908],
              [36.83705855300013, -11.567974954999912],
              [36.82010868300006, -11.573556009999933],
              [36.77484012900004, -11.626265970999953],
              [36.747038208000106, -11.666470234999878],
              [36.73804650900013, -11.674738464999919],
              [36.726574341000116, -11.680732930999866],
              [36.689677368000105, -11.694582213999922],
              [36.679962199000045, -11.70243703199995],
              [36.67458785000008, -11.708844909999897],
              [36.667249797000125, -11.713392435999921],
              [36.640584757000056, -11.716286315999909],
              [36.62570194500012, -11.721350605999888],
              [36.562966756000094, -11.73127248199998],
              [36.54570682800005, -11.729412129999972],
              [36.520592082000064, -11.717113138999935],
              [36.51501102700013, -11.715046080999883],
              [36.50870650200011, -11.709775085999937],
              [36.502712036000105, -11.68631398499987],
              [36.49485721900004, -11.680939635999906],
              [36.37806848200012, -11.680939635999906],
              [36.373314250000135, -11.6831100469999],
              [36.36814660700014, -11.687760925999953],
              [36.36122196500014, -11.692411803999931],
              [36.329802694000136, -11.697062682999984],
              [36.293422486000054, -11.70729461699996],
              [36.27874637800005, -11.708844909999897],
              [36.26841109200012, -11.705951029999909],
              [36.25290816200004, -11.696649271999974],
              [36.240919230000145, -11.694582213999922],
              [36.19968143700004, -11.701506855999895],
              [36.18820926900014, -11.693652037999868],
              [36.179217570000105, -11.675565286999941],
              [36.176220337000075, -11.654998066999951],
              [36.182628215000136, -11.640011901999898],
              [36.17591027800012, -11.620064798999877],
              [36.173636515000055, -11.597430521999925],
              [36.16805546100005, -11.57872365299994],
              [36.1519324140001, -11.571075540999871],
              [36.14283736200014, -11.569008483999895],
              [36.136016073000064, -11.563840840999902],
              [36.129504842000074, -11.557122903999868],
              [36.121133260000136, -11.550611673999896],
              [36.11152144400012, -11.54658091199991],
              [36.08940393000012, -11.540896504999864],
              [36.07958540800013, -11.53696909499999],
              [36.043101847000116, -11.514851582999881],
              [36.02222456900006, -11.505653176999886],
              [36.00785852100006, -11.50658335299994],
              [35.98853153500011, -11.512164407999947],
              [35.96982466600008, -11.502449238999915],
              [35.960832967000044, -11.483535664999877],
              [35.970341431000065, -11.461211445999908],
              [35.953081502000146, -11.440644225999918],
              [35.93974898300013, -11.434132994999857],
              [35.902025187000106, -11.434546406999871],
              [35.895617310000034, -11.432789407999891],
              [35.867298625000046, -11.420903828999954],
              [35.826370890000135, -11.413462422999928],
              [35.81314172300006, -11.422350768999948],
              [35.78192915800014, -11.461211445999908],
              [35.76425581900014, -11.47485402399991],
              [35.71402632600012, -11.483845722999959],
              [35.6956295170001, -11.494594420999888],
              [35.70338098100012, -11.516505227999929],
              [35.69128869600013, -11.524256692999941],
              [35.68022994000012, -11.537589212999961],
              [35.671858358000065, -11.551438495999918],
              [35.664830363000135, -11.57200571699991],
              [35.65480513500012, -11.57831024199993],
              [35.60085494000003, -11.592262877999914],
              [35.599718058000065, -11.592159524999886],
              [35.576256958000045, -11.60518198599992],
              [35.55982385200008, -11.60104787199991],
              [35.54370080600012, -11.594743346999891],
              [35.532745402000046, -11.595570169999917],
              [35.53150516800008, -11.612726744999875],
              [35.52013635200012, -11.60910939499989],
              [35.51558882600011, -11.603528340999972],
              [35.51300500500008, -11.596603698999985],
              [35.50763065600012, -11.589058939999944],
              [35.498742310000125, -11.582341002999925],
              [35.49409143100013, -11.581824238999971],
              [35.490164021000055, -11.584098001999905],
              [35.48365279100011, -11.58595835299991],
              [35.48344608600007, -11.586888528999864],
              [35.47011356600012, -11.592159524999886],
              [35.46577274600014, -11.5925729369999],
              [35.441174764000095, -11.591436055999893],
              [35.431873006000046, -11.588438821999972],
              [35.42525842300006, -11.582030944999929],
              [35.42350142400005, -11.57655324299995],
              [35.38174686600013, -11.577690123999957],
              [34.96461470600008, -11.573556009999933],
              [34.96296105900012, -11.564874369999885],
              [34.96296105900012, -11.513094583999901],
              [34.96068729600012, -11.498521830999948],
              [34.955726359000096, -11.486739603999936],
              [34.95097212700006, -11.477747903999898],
              [34.94869836400005, -11.471753437999965],
              [34.94446089700011, -11.464415384999882],
              [34.935055786000135, -11.456457214999915],
              [34.9256506750001, -11.445915221999954],
              [34.917072388000065, -11.418836770999903],
              [34.898365520000084, -11.403540547999938],
              [34.89412805200004, -11.395995788999898],
              [34.88658329300006, -11.375428567999904],
              [34.86787642400009, -11.35878875699997],
              [34.84369185400004, -11.346283059999891],
              [34.80049035600007, -11.331917011999877],
              [34.792325480000045, -11.330883483999898],
              [34.78488407300006, -11.333467305999903],
              [34.77217167200007, -11.344422708999971],
              [34.765557088000094, -11.345146178999883],
              [34.759149210000146, -11.337498066999984],
              [34.73703169800007, -11.29677703799993],
              [34.74302616400007, -11.29367645299989],
              [34.751604452000095, -11.287061868999984],
              [34.75749556500011, -11.283754576999897],
              [34.75749556500011, -11.277553404999907],
              [34.74168257700012, -11.2686650589999],
              [34.72866011600007, -11.253988952999904],
              [34.71977176900015, -11.234558613999923],
              [34.71656783100008, -11.211717630999914],
              [34.7140873620001, -11.202725930999875],
              [34.707886190000124, -11.194974466999966],
              [34.69992801900008, -11.189496764999973],
              [34.68184126800014, -11.185052591999877],
              [34.677087036000046, -11.178748066999958],
              [34.67398645100013, -11.169963073999966],
              [34.66871545400011, -11.160144551999906],
              [34.62106978400004, -11.11973358099992],
              [34.61352502400007, -11.10216359499995],
              [34.61063114400008, -11.077668965999905],
              [34.597298625000064, -11.03663787899994],
              [34.59295780400009, -11.016174011999894],
              [34.59791874100006, -10.990955911999933],
              [34.61783828200009, -10.965738620999957],
              [34.627064250000046, -10.954058938999907],
              [34.64546106000006, -10.913234557999914],
              [34.64763147000008, -10.902899271999914],
              [34.64763147000008, -10.85856089299996],
              [34.660550577000095, -10.796032409999967],
              [34.65672652200004, -10.76988413499987],
              [34.66282434100009, -10.76140919999996],
              [34.67501997800008, -10.752417500999925],
              [34.67243615700011, -10.73949839299992],
              [34.666441691000045, -10.732367044999876],
              [34.6599304610001, -10.727716165999908],
              [34.65569299300006, -10.722031758999961],
              [34.6539359950001, -10.717587584999961],
              [34.64763147000008, -10.708389179999955],
              [34.66086063700004, -10.687305195999926],
              [34.660033814000144, -10.665497741999914],
              [34.650525350000066, -10.645343932999936],
              [34.629027954000094, -10.620229186999907],
              [34.62634078000008, -10.614338072999914],
              [34.62716760300009, -10.59511443999989],
              [34.62437707500004, -10.58343556699991],
              [34.62085892300007, -10.582422765999866],
              [34.61755578600008, -10.581471862999877],
              [34.60887414600012, -10.581988626999916],
              [34.60039921100014, -10.578061217999945],
              [34.592337687000054, -10.566692402999962],
              [34.585723104000124, -10.553566588999985],
              [34.58107222500007, -10.539717304999925],
              [34.580088163000084, -10.531844811999946],
              [34.57941857900005, -10.526488137999934],
              [34.58148563700007, -10.513672383999946],
              [34.59078739500012, -10.491244811999962],
              [34.59295780400009, -10.481736347999885],
              [34.58872033700004, -10.463132832999918],
              [34.56949670400013, -10.431403503999903],
              [34.565052531000106, -10.40980275499993],
              [34.58530969200012, -10.300662128999889],
              [34.58561975100008, -10.290016783999889],
              [34.58344934000013, -10.277614440999912],
              [34.57507775900007, -10.255806985999897],
              [34.565569296000035, -10.202683613999866],
              [34.532393026000136, -10.128889668999904],
              [34.52474491400005, -10.094783222999936],
              [34.52681197100014, -10.084861347999947],
              [34.53570031800007, -10.06532765699994],
              [34.5377673750001, -10.053855488999915],
              [34.53642378700005, -10.043003437999872],
              [34.52474491400005, -10.00879363999988],
              [34.49466923000011, -9.966729023999946],
              [34.48330041500009, -9.946161803999956],
              [34.38346154800007, -9.823792012999917],
              [34.38232466700009, -9.819657897999889],
              [34.36423791500005, -9.802397968999898],
              [34.359690389000036, -9.799917500999925],
              [34.337469523000095, -9.77717986999994],
              [34.33168176300012, -9.769221699999974],
              [34.32672082600004, -9.750308125999936],
              [34.324240356000075, -9.732428079999892],
              [34.31793583100006, -9.719198912999985],
              [34.288066853000146, -9.70845021599996],
              [34.190811808000035, -9.606750996999935],
              [34.161873006000064, -9.593625182999872],
              [34.14461307800008, -9.574918313999888],
              [34.13706831800005, -9.570577493999906],
              [34.10316857900011, -9.529856465999941],
              [34.08931929600004, -9.522208353999872],
              [34.07981083200008, -9.511046243999928],
              [34.0784906880001, -9.510185830999973],
              [34.04746138500008, -9.489962259999913],
              [34.01273482200014, -9.477456562999905],
              [33.99650842300014, -9.491822610999918],
              [33.98431278500004, -9.505568542999939],
              [33.96074833200004, -9.524895527999902],
              [33.94586551900011, -9.550010273999916],
              [33.964469035000036, -9.594658711999955],
              [33.962608684000145, -9.6121253459999],
              [33.955580689000044, -9.642304381999907],
              [33.95485721800014, -9.660597838999962],
              [33.95134322100006, -9.67362029999991],
              [33.94307499200005, -9.683852233999886],
              [33.92829553200011, -9.693464050999907],
              [33.92829553200011, -9.700285338999947],
              [33.91186242600014, -9.717958678999949],
              [33.90018355300009, -9.709587096999883],
              [33.88933150200012, -9.68974334699989],
              [33.86525028500006, -9.669589538999915],
              [33.83693160000007, -9.652846373999864],
              [33.81347050000011, -9.643337910999975],
              [33.787528930000065, -9.626491393999899],
              [33.762000773000125, -9.60096323599987],
              [33.73461226400008, -9.584116719999898],
              [33.702521199000046, -9.592901712999975],
              [33.67606286600005, -9.607681171999985],
              [33.65063806100005, -9.610988463999888],
              [33.65013541400015, -9.610901131999952],
              [33.6238696690001, -9.60633758499992],
              [33.59338057500008, -9.596829120999942],
              [33.5594808350001, -9.59331512499989],
              [33.53519291200007, -9.603340351999918],
              [33.51162845900012, -9.61698292999992],
              [33.48051924600014, -9.624424335999933],
              [33.43897139500007, -9.621530455999945],
              [33.419644409000114, -9.615639342999955],
              [33.40424483200013, -9.604890644999927],
              [33.39220422400007, -9.586183776999945],
              [33.37499597200008, -9.549080097999962],
              [33.35649580900014, -9.531820169999975],
              [33.30027185100005, -9.492236022999919],
              [33.28239180500009, -9.486034850999943],
              [33.273503459000096, -9.487688496999894],
              [33.257690470000114, -9.498023783999898],
              [33.24911218200009, -9.500710957999928],
              [33.23712325000008, -9.499574075999917],
              [33.21634932400008, -9.49337290499993],
              [33.20239668800008, -9.493476256999955],
              [33.1957821040001, -9.496680195999929],
              [33.18203617400013, -9.507945657999898],
              [33.172941121000065, -9.511046243999928],
              [33.169220418000066, -9.508875833999937],
              [33.13991988100008, -9.497403665999926],
              [33.11299646000009, -9.491512552999922],
              [33.10390140800013, -9.487895201999947],
              [33.04230310100007, -9.440662942999907],
              [32.992280314000084, -9.391363626999919],
              [32.97471032700008, -9.381235046999876],
              [32.95527998900013, -9.382061868999898],
              [32.93626306200008, -9.391673684999901],
              [32.9208634850001, -9.407900085999913],
            ],
          ],
          [
            [
              [39.89568118600005, -7.637627862999921],
              [39.91098066500007, -7.654473565999922],
              [39.90935306100005, -7.686700127999927],
              [39.89340254000007, -7.754082940999922],
              [39.86491946700005, -7.819024346999925],
              [39.851573113000086, -7.837090752999927],
              [39.849619988000086, -7.844496351999908],
              [39.84978274800005, -7.85084400799991],
              [39.84848066500007, -7.857354424999926],
              [39.84164472700007, -7.877862237999921],
              [39.838633660000085, -7.883233330999929],
              [39.82992597700007, -7.894952080999929],
              [39.828135613000086, -7.90203215899993],
              [39.823252800000034, -7.913995049999926],
              [39.81137129000007, -7.913995049999926],
              [39.78370201900009, -7.905857028999947],
              [39.754649285000085, -7.91529713299991],
              [39.74195397200003, -7.936944268999923],
              [39.73585045700008, -7.959893487999921],
              [39.72632897200003, -7.973402601999908],
              [39.68677819100009, -7.988864841999941],
              [39.66651451900009, -7.99342213299991],
              [39.64991295700008, -7.993910414999959],
              [39.62973066500007, -7.985772393999923],
              [39.60328209700003, -7.957696221999925],
              [39.58716881600009, -7.945489190999922],
              [39.59652754000007, -7.943291924999926],
              [39.61345462300005, -7.94264088299991],
              [39.62191816500007, -7.939222914999959],
              [39.622080925000034, -7.936455987999921],
              [39.62468509200005, -7.929294528999947],
              [39.627940300000034, -7.922784112999921],
              [39.62940514400009, -7.922539971999925],
              [39.63168379000007, -7.914971612999921],
              [39.637380405000044, -7.913181247999944],
              [39.64421634200005, -7.913669528999947],
              [39.64991295700008, -7.911879164999959],
              [39.69304446700005, -7.870293877999927],
              [39.70753014400009, -7.847426039999959],
              [39.698252800000034, -7.836195570999905],
              [39.703868035000085, -7.819431247999944],
              [39.71534264400009, -7.811618747999944],
              [39.73096764400009, -7.809502862999921],
              [39.74927819100009, -7.809665622999944],
              [39.765961134000065, -7.80632903399993],
              [39.797211134000065, -7.791924737999921],
              [39.81430097700007, -7.788506768999923],
              [39.80876712300005, -7.780450127999927],
              [39.79932701900009, -7.77898528399993],
              [39.773448113000086, -7.781670830999929],
              [39.773448113000086, -7.775485934999949],
              [39.785492384000065, -7.772556247999944],
              [39.79607181100005, -7.767022393999923],
              [39.81430097700007, -7.754327080999929],
              [39.83570397200003, -7.745538018999923],
              [39.84489993600005, -7.737725518999923],
              [39.85181725400008, -7.712090752999927],
              [39.85987389400009, -7.697198174999926],
              [39.869802280000044, -7.684177341999941],
              [39.87867272200003, -7.678643487999921],
              [39.883555535000085, -7.673435153999947],
              [39.89372806100005, -7.647637627999927],
              [39.89568118600005, -7.637627862999921],
            ],
          ],
          [
            [
              [39.54346764400009, -6.321221612999921],
              [39.54712975400008, -6.330254815999922],
              [39.57406660200007, -6.377618096999925],
              [39.56950931100005, -6.420830987999921],
              [39.54428144600007, -6.45086028399993],
              [39.508474155000044, -6.462823174999926],
              [39.471690300000034, -6.452080987999921],
              [39.45720462300005, -6.43914153399993],
              [39.443695509000065, -6.42156340899993],
              [39.433929884000065, -6.401543877999927],
              [39.41423587300005, -6.316338799999926],
              [39.41651451900009, -6.301364841999941],
              [39.39405358200008, -6.308200778999947],
              [39.39421634200005, -6.319024346999925],
              [39.40357506600009, -6.332207940999922],
              [39.40967858200008, -6.345798434999949],
              [39.40845787900008, -6.368259372999944],
              [39.40357506600009, -6.373711846999925],
              [39.375661655000044, -6.363376559999949],
              [39.38005618600005, -6.344170830999929],
              [39.37435957100007, -6.328789971999925],
              [39.348317905000044, -6.301364841999941],
              [39.31690514400009, -6.253024997999944],
              [39.30811608200008, -6.245700778999947],
              [39.30046634200005, -6.239353122999944],
              [39.28687584700003, -6.246758721999925],
              [39.28687584700003, -6.254082940999922],
              [39.29273522200003, -6.254978122999944],
              [39.29346764400009, -6.257907809999949],
              [39.29265384200005, -6.262302341999941],
              [39.293711785000085, -6.267754815999922],
              [39.280284050000034, -6.258477471999925],
              [39.276052280000044, -6.274102471999925],
              [39.27955162900008, -6.296644789999959],
              [39.29029381600009, -6.308200778999947],
              [39.287852410000085, -6.309502862999921],
              [39.28630618600005, -6.311700127999927],
              [39.28248131600009, -6.31218840899993],
              [39.27320397200003, -6.308200778999947],
              [39.26417076900009, -6.30242278399993],
              [39.260752800000034, -6.298597914999959],
              [39.258474155000044, -6.294528903999947],
              [39.208018425000034, -6.236504815999922],
              [39.19857832100007, -6.220798434999949],
              [39.18580162900008, -6.175876559999949],
              [39.17701256600009, -6.15789153399993],
              [39.212901238000086, -6.114190362999921],
              [39.20476321700005, -6.056410414999959],
              [39.186208530000044, -5.994317315999922],
              [39.19060306100005, -5.938164971999925],
              [39.189463738000086, -5.925957940999922],
              [39.190440300000034, -5.914239190999922],
              [39.19320722700007, -5.904066664999959],
              [39.19743899800005, -5.896661065999922],
              [39.20045006600009, -5.901950778999947],
              [39.20818118600005, -5.912204684999949],
              [39.21111087300005, -5.917738539999959],
              [39.22779381600009, -5.890720309999949],
              [39.26351972700007, -5.861097914999959],
              [39.280039910000085, -5.841973565999922],
              [39.28825931100005, -5.810479424999926],
              [39.295258009000065, -5.736504815999922],
              [39.313487175000034, -5.71843840899993],
              [39.325205925000034, -5.748955987999921],
              [39.35572350400008, -5.803806247999944],
              [39.36182701900009, -5.838962497999944],
              [39.35474694100009, -5.881036065999922],
              [39.35434004000007, -5.896661065999922],
              [39.357432488000086, -5.912041924999926],
              [39.366221550000034, -5.940524997999944],
              [39.36801191500007, -5.955254815999922],
              [39.37256920700008, -5.970798434999949],
              [39.39177493600005, -6.002211195999905],
              [39.40284264400009, -6.048028252999927],
              [39.408946160000085, -6.051527601999908],
              [39.43018639400009, -6.054864190999922],
              [39.432383660000085, -6.068291924999926],
              [39.42986087300005, -6.080498955999929],
              [39.42554772200003, -6.092868747999944],
              [39.42335045700008, -6.106377862999921],
              [39.423838738000086, -6.12232838299991],
              [39.425791863000086, -6.13445403399993],
              [39.42986087300005, -6.145603122999944],
              [39.43702233200008, -6.15789153399993],
              [39.42505944100009, -6.172621351999908],
              [39.419932488000086, -6.180759372999944],
              [39.41651451900009, -6.192071221999925],
              [39.43100019600007, -6.185967705999929],
              [39.43995201900009, -6.192071221999925],
              [39.44752037900008, -6.203301690999922],
              [39.45753014400009, -6.212009372999944],
              [39.45826256600009, -6.197198174999926],
              [39.464854363000086, -6.187432549999926],
              [39.47291100400008, -6.186700127999927],
              [39.47787519600007, -6.19890715899993],
              [39.482432488000086, -6.198337497999944],
              [39.48365319100009, -6.197686455999929],
              [39.48365319100009, -6.195977471999925],
              [39.48487389400009, -6.192071221999925],
              [39.500987175000034, -6.196221612999921],
              [39.50114993600005, -6.175388278999947],
              [39.496429884000065, -6.145684502999927],
              [39.49854576900009, -6.123793226999908],
              [39.515961134000065, -6.146661065999922],
              [39.52491295700008, -6.17506275799991],
              [39.54346764400009, -6.321221612999921],
            ],
          ],
          [
            [
              [39.64307701900009, -5.413995049999926],
              [39.643565300000034, -5.379001559999949],
              [39.647471550000034, -5.363051039999959],
              [39.65674889400009, -5.349216403999947],
              [39.65056399800005, -5.338474216999941],
              [39.663096550000034, -5.336358330999929],
              [39.698252800000034, -5.342380466999941],
              [39.690196160000085, -5.328220309999949],
              [39.66928144600007, -5.302666924999926],
              [39.66358483200008, -5.287204684999949],
              [39.67920983200008, -5.291192315999922],
              [39.69890384200005, -5.29265715899993],
              [39.71656334700003, -5.289646091999941],
              [39.72632897200003, -5.280368747999944],
              [39.714854363000086, -5.277764580999929],
              [39.705088738000086, -5.274102471999925],
              [39.69703209700003, -5.268487237999921],
              [39.69076582100007, -5.259860934999949],
              [39.70639082100007, -5.260023695999905],
              [39.73031660200007, -5.253838799999926],
              [39.746104363000086, -5.253024997999944],
              [39.76417076900009, -5.262383721999925],
              [39.774099155000044, -5.259535414999959],
              [39.78093509200005, -5.239353122999944],
              [39.760752800000034, -5.246840101999908],
              [39.736338738000086, -5.240004164999959],
              [39.69076582100007, -5.211358330999929],
              [39.68091881600009, -5.217705987999921],
              [39.668711785000085, -5.213962497999944],
              [39.65739993600005, -5.203789971999925],
              [39.64991295700008, -5.190850518999923],
              [39.66065514400009, -5.195245049999926],
              [39.66773522200003, -5.200372002999927],
              [39.674489780000044, -5.202325127999927],
              [39.683929884000065, -5.197686455999929],
              [39.69353274800005, -5.200616143999923],
              [39.727549675000034, -5.205743096999925],
              [39.746104363000086, -5.205173434999949],
              [39.738617384000065, -5.197686455999929],
              [39.74626712300005, -5.178317966999941],
              [39.742523634000065, -5.16179778399993],
              [39.73178144600007, -5.156508070999905],
              [39.71827233200008, -5.170505466999941],
              [39.72348066500007, -5.150160414999959],
              [39.72632897200003, -5.143731377999927],
              [39.72046959700003, -5.136325778999947],
              [39.71265709700003, -5.131442966999941],
              [39.70264733200008, -5.131036065999922],
              [39.69076582100007, -5.137465101999908],
              [39.69304446700005, -5.126397393999923],
              [39.69459069100009, -5.121840101999908],
              [39.698252800000034, -5.115817966999941],
              [39.69418379000007, -5.103936455999929],
              [39.69548587300005, -5.089776299999926],
              [39.70069420700008, -5.079196872999944],
              [39.70826256600009, -5.078301690999922],
              [39.72006269600007, -5.083916924999926],
              [39.72543379000007, -5.080498955999929],
              [39.724619988000086, -5.071872653999947],
              [39.71827233200008, -5.06178150799991],
              [39.709646030000044, -5.056735934999949],
              [39.67725670700008, -5.044366143999923],
              [39.68018639400009, -5.03484465899993],
              [39.694021030000044, -5.023695570999905],
              [39.698252800000034, -5.01336028399993],
              [39.683929884000065, -5.020196221999925],
              [39.675791863000086, -5.001722914999959],
              [39.68116295700008, -4.987237237999921],
              [39.69467207100007, -4.982517184999949],
              [39.71208743600005, -4.992852471999925],
              [39.71599368600005, -4.976820570999905],
              [39.70476321700005, -4.967461846999925],
              [39.688487175000034, -4.958754164999959],
              [39.67725670700008, -4.945082289999959],
              [39.676768425000034, -4.933526299999926],
              [39.68287194100009, -4.90553150799991],
              [39.68409264400009, -4.89031340899993],
              [39.68637129000007, -4.895440362999921],
              [39.68873131600009, -4.899590752999927],
              [39.69157962300005, -4.902520440999922],
              [39.69459069100009, -4.903497002999927],
              [39.70232181100005, -4.90789153399993],
              [39.707774285000085, -4.917413018999923],
              [39.71111087300005, -4.92701588299991],
              [39.71208743600005, -4.931410414999959],
              [39.72315514400009, -4.929864190999922],
              [39.726898634000065, -4.922458591999941],
              [39.72901451900009, -4.914239190999922],
              [39.73519941500007, -4.910332940999922],
              [39.740244988000086, -4.913832289999959],
              [39.75635826900009, -4.929864190999922],
              [39.759776238000086, -4.934502862999921],
              [39.80591881600009, -4.960870049999926],
              [39.81430097700007, -4.968682549999926],
              [39.81495201900009, -4.98015715899993],
              [39.817393425000034, -4.990166924999926],
              [39.82154381600009, -4.99382903399993],
              [39.828135613000086, -4.98601653399993],
              [39.82740319100009, -4.977959893999923],
              [39.82357832100007, -4.968357028999947],
              [39.82374108200008, -4.957207940999922],
              [39.83562259200005, -4.945082289999959],
              [39.836680535000085, -4.95240650799991],
              [39.840179884000065, -4.959893487999921],
              [39.84164472700007, -4.965590101999908],
              [39.84986412900008, -4.949151299999926],
              [39.85572350400008, -4.929131768999923],
              [39.85792076900009, -4.910251559999949],
              [39.85596764400009, -4.897230726999908],
              [39.869476759000065, -4.906019789999959],
              [39.869476759000065, -4.926446221999925],
              [39.86687259200005, -4.950290622999944],
              [39.87818444100009, -4.987725518999923],
              [39.86695397200003, -5.005791924999926],
              [39.84913170700008, -5.019789320999905],
              [39.83562259200005, -5.026462497999944],
              [39.840586785000085, -5.04420338299991],
              [39.83741295700008, -5.063571872999944],
              [39.83130944100009, -5.083184502999927],
              [39.828135613000086, -5.102146091999941],
              [39.83773847700007, -5.13209400799991],
              [39.838633660000085, -5.137465101999908],
              [39.84782962300005, -5.133233330999929],
              [39.848643425000034, -5.123711846999925],
              [39.84685306100005, -5.113946221999925],
              [39.84848066500007, -5.108982028999947],
              [39.86117597700007, -5.11451588299991],
              [39.86280358200008, -5.13209400799991],
              [39.85596764400009, -5.170505466999941],
              [39.85564212300005, -5.229424737999921],
              [39.84848066500007, -5.245538018999923],
              [39.85596764400009, -5.253024997999944],
              [39.84400475400008, -5.267022393999923],
              [39.81430097700007, -5.355401299999926],
              [39.806651238000086, -5.366143487999921],
              [39.80250084700003, -5.37037525799991],
              [39.80103600400008, -5.376722914999959],
              [39.80062910200007, -5.393649997999944],
              [39.79607181100005, -5.406833591999941],
              [39.78728274800005, -5.409112237999921],
              [39.78150475400008, -5.401055596999925],
              [39.78638756600009, -5.383233330999929],
              [39.78093509200005, -5.383233330999929],
              [39.774180535000085, -5.399509372999944],
              [39.77068118600005, -5.405450127999927],
              [39.765961134000065, -5.410577080999929],
              [39.76929772200003, -5.42115650799991],
              [39.764008009000065, -5.432305596999925],
              [39.75277754000007, -5.44264088299991],
              [39.738617384000065, -5.451592705999929],
              [39.72901451900009, -5.454196872999944],
              [39.72632897200003, -5.45045338299991],
              [39.72974694100009, -5.444105726999908],
              [39.738617384000065, -5.438571872999944],
              [39.738617384000065, -5.431084893999923],
              [39.72437584700003, -5.434665622999944],
              [39.713633660000085, -5.441338799999926],
              [39.705414259000065, -5.442966403999947],
              [39.698252800000034, -5.431084893999923],
              [39.66342207100007, -5.432224216999941],
              [39.64893639400009, -5.427504164999959],
              [39.64307701900009, -5.413995049999926],
            ],
          ],
          [
            [
              [39.742039582000075, -7.994825358999947],
              [39.77414428900005, -7.991282750999915],
              [39.79673735700004, -7.992453303999923],
              [39.80149239800005, -8.006587496999941],
              [39.79078625200009, -8.019550418999927],
              [39.74916454600009, -8.065492432999918],
              [39.71943949300004, -8.092571979999946],
              [39.70279590600006, -8.091392800999927],
              [39.69685274500006, -8.074907909999922],
              [39.702799990000074, -8.049004459999935],
              [39.71469191500006, -8.027809271999956],
              [39.742039582000075, -7.994825358999947],
            ],
          ],
          [
            [
              [39.226103773000034, -5.769169180999938],
              [39.22542619900008, -5.782854045999954],
              [39.23025897300005, -5.800642367999956],
              [39.23852092200008, -5.812955063999937],
              [39.23164807400008, -5.823216742999932],
              [39.23784843800007, -5.83621185699991],
              [39.23786221900008, -5.856047416999957],
              [39.225479447000055, -5.858786935999944],
              [39.214469664000035, -5.858106438999926],
              [39.212396425000065, -5.843742043999953],
              [39.21444891500005, -5.825955824999937],
              [39.21718089700005, -5.797906566999927],
              [39.214411734000066, -5.777379968999924],
              [39.226103773000034, -5.769169180999938],
            ],
          ],
          [
            [
              [39.57545756500008, -5.394548057999941],
              [39.58424333900007, -5.399198032999948],
              [39.59888730400007, -5.408500949999961],
              [39.609437418000084, -5.42304671699992],
              [39.62116135100007, -5.44108327999993],
              [39.63696710600004, -5.446886161999942],
              [39.65218105900004, -5.45094311999992],
              [39.662138334000076, -5.463739503999932],
              [39.65981088400008, -5.475969573999919],
              [39.63289955500005, -5.47775174599991],
              [39.61533097700004, -5.463799254999913],
              [39.600097264000055, -5.445766500999923],
              [39.59130389100005, -5.43296590999995],
              [39.579584810000085, -5.42074789499992],
              [39.56902873700005, -5.406201067999916],
              [39.57545756500008, -5.394548057999941],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Somaliland',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [48.939111999918396, 11.249129976167438],
            [48.93911055500007, 11.136737366000105],
            [48.93911055500007, 11.02436696400008],
            [48.93911055500007, 10.912022401000058],
            [48.93911055500007, 10.799600322000103],
            [48.93911055500007, 10.687333272000103],
            [48.93911055500007, 10.574937032000065],
            [48.93911055500007, 10.46256663100013],
            [48.93911055500007, 10.350118713000072],
            [48.93911055500007, 10.237799988000063],
            [48.93911055500007, 10.125429586000038],
            [48.93911055500007, 10.013033346000086],
            [48.93911055500007, 9.900714620000073],
            [48.93911055500007, 9.788421733000064],
            [48.93911055500007, 9.675999655000112],
            [48.93911055500007, 9.56360341400007],
            [48.93911055500007, 9.562700993000107],
            [48.93911055500007, 9.451233012000046],
            [48.87911421700005, 9.360308329000134],
            [48.81932458500012, 9.26938364700004],
            [48.759224895000045, 9.178510641000045],
            [48.699228556000094, 9.087689311000062],
            [48.63933557100012, 8.996661275000037],
            [48.57918420400006, 8.905839946000057],
            [48.51918786600004, 8.81491526300006],
            [48.459243205000064, 8.72388722700012],
            [48.39929854400009, 8.633117574000053],
            [48.33914717600004, 8.542089539000116],
            [48.279099162000136, 8.45116485600002],
            [48.219154500000116, 8.360317689000041],
            [48.15900313300011, 8.269418844000128],
            [48.09905847200008, 8.178519999000045],
            [48.03911381000012, 8.087491964],
            [47.97916914900014, 7.996567281000097],
            [47.83669722500014, 7.996515605000084],
            [47.653917684000135, 7.996515605000084],
            [47.523589721000064, 7.996515605000084],
            [47.366079956000135, 7.996515605000084],
            [47.21058557100008, 7.996515605000084],
            [47.068113648000065, 7.996515605000084],
            [46.97923018400013, 7.996567281000097],
            [46.920525757000064, 8.025609437000085],
            [46.857377157000144, 8.046745097000041],
            [46.773557983000046, 8.074908752000084],
            [46.689532105000126, 8.102969055000102],
            [46.60571293100014, 8.131132711000063],
            [46.52168705200012, 8.15924469],
            [46.43771285000008, 8.187356670000042],
            [46.3538420000001, 8.215468648000083],
            [46.269816122000066, 8.243554790000104],
            [46.185893595000096, 8.271640930000046],
            [46.10191939300006, 8.299727072000067],
            [46.01804854400007, 8.32789072600012],
            [45.9341260170001, 8.35600270600007],
            [45.85020349200005, 8.3841146850001],
            [45.76638431800012, 8.412226664000045],
            [45.68235843900004, 8.440312805000076],
            [45.59843591300006, 8.468424784000106],
            [45.514410034000036, 8.496536764000055],
            [45.426146688000074, 8.525475566000111],
            [45.33809004700004, 8.554414368000067],
            [45.24987837700007, 8.583275655000108],
            [45.16177006100014, 8.612136943000053],
            [45.07355839000007, 8.641153259000134],
            [44.98555342700013, 8.670040385000092],
            [44.89729007900007, 8.698927511000136],
            [44.80923343900014, 8.72784047400009],
            [44.72107344500006, 8.75677927600006],
            [44.63301680500007, 8.785718078000116],
            [44.54475345900005, 8.814605205000063],
            [44.45669681800007, 8.843544007000034],
            [44.36853682500009, 8.872456970000087],
            [44.280376831000126, 8.901395772000058],
            [44.19221683800009, 8.93028289900009],
            [44.104056845000116, 8.959221701000061],
            [44.023855021000145, 8.98552500400011],
            [43.98478763900005, 9.008314311000092],
            [43.91492110200005, 9.071488749000068],
            [43.78759037300006, 9.186701355000068],
            [43.69844852700004, 9.267161560000119],
            [43.621502319000115, 9.336898906000073],
            [43.607239624000044, 9.344624532000083],
            [43.59121993000008, 9.3435910030001],
            [43.56682865400006, 9.334315084000082],
            [43.548225139000124, 9.336072083000147],
            [43.47122725500009, 9.382012431000135],
            [43.41903405700003, 9.413018290000068],
            [43.406321655000056, 9.428650411000106],
            [43.401980835000074, 9.447408956000103],
            [43.3994486900001, 9.480946960000026],
            [43.39335087100005, 9.498930359000013],
            [43.370664917000056, 9.54422475200002],
            [43.361518188000105, 9.553164774000038],
            [43.34136438000007, 9.566393941000044],
            [43.33175256400011, 9.575075582000096],
            [43.32508630400008, 9.58590179500004],
            [43.315577841000106, 9.60765757200005],
            [43.3059660240001, 9.61755361000013],
            [43.29769779500003, 9.621532695000028],
            [43.27067102100011, 9.628353984000071],
            [43.24881188900014, 9.652331848000088],
            [43.23527266400009, 9.691786804000103],
            [43.20633386200012, 9.851208598000113],
            [43.18721358200014, 9.883325501000044],
            [43.14985152200006, 9.899991150000076],
            [43.10427290900009, 9.90792348200003],
            [43.06768599500003, 9.922522075000089],
            [43.03988407300011, 9.949988098000063],
            [43.02076379400012, 9.99641937300008],
            [43.012598918000094, 10.029285583000103],
            [42.99988651500013, 10.06197092700009],
            [42.98190311700006, 10.091633199000043],
            [42.958235311000124, 10.115559387000047],
            [42.862323852000145, 10.177157694000087],
            [42.836278931000095, 10.208086040000083],
            [42.808166951000146, 10.269115906000067],
            [42.78946008300005, 10.333323873000026],
            [42.776644328000145, 10.424610290000118],
            [42.765792277000116, 10.451947123000139],
            [42.750392700000134, 10.47163584400009],
            [42.69520227100014, 10.524707540000108],
            [42.66853723200006, 10.566229554000088],
            [42.64859012900007, 10.611033020000065],
            [42.64724654100013, 10.632220358000026],
            [42.66026900300005, 10.641625469000076],
            [42.680216105000056, 10.64767161100012],
            [42.69964644300006, 10.658549500000078],
            [42.71163537600012, 10.675163473000097],
            [42.71897342900007, 10.694852194000049],
            [42.72858524600008, 10.735495707000084],
            [42.73809370900011, 10.759783630000086],
            [42.74987593600008, 10.77582916200005],
            [42.78563602700012, 10.804406230000012],
            [42.801242310000134, 10.820787659000061],
            [42.80765018700009, 10.836109721000113],
            [42.81157759600006, 10.852620341000105],
            [42.81943241400006, 10.872567444000126],
            [42.834831990000055, 10.888406270000132],
            [42.87679325300007, 10.905743714000053],
            [42.89353641800011, 10.919670512000039],
            [42.90118452900009, 10.93659454400003],
            [42.91131311100014, 10.977367248000107],
            [42.923715454000046, 10.998787130000025],
            [43.18881468300009, 11.407763994000035],
            [43.24073326900009, 11.4878604190001],
            [43.252696160000085, 11.473089911000045],
            [43.26693769600007, 11.46234772300005],
            [43.28834069100009, 11.460353908000059],
            [43.28272545700008, 11.498928127000056],
            [43.29712975400008, 11.482245184000078],
            [43.32007897200003, 11.446112372000073],
            [43.33961022200003, 11.426174221000053],
            [43.35238691500007, 11.419745184000078],
            [43.375987175000034, 11.39158763200004],
            [43.39421634200005, 11.385199286000045],
            [43.41382897200003, 11.380926825000074],
            [43.443369988000086, 11.359564520000049],
            [43.459727410000085, 11.351060289000088],
            [43.46631920700008, 11.36790599200009],
            [43.47820071700005, 11.37995026200008],
            [43.48943118600005, 11.380926825000074],
            [43.49439537900008, 11.364732164000088],
            [43.47901451900009, 11.27179596600007],
            [43.48812910200007, 11.23891836100006],
            [43.50635826900009, 11.20897044500009],
            [43.529307488000086, 11.18659088700008],
            [43.53565514400009, 11.183742580000057],
            [43.55193118600005, 11.179836330000057],
            [43.55909264400009, 11.17601146000004],
            [43.56299889400009, 11.170314846000053],
            [43.56820722700007, 11.155422268000052],
            [43.58318118600005, 11.135158596000053],
            [43.59164472700007, 11.107489325000074],
            [43.61744225400008, 11.070786851000037],
            [43.658946160000085, 10.987982489000046],
            [43.75562584700003, 10.894232489000046],
            [43.82960045700008, 10.80296458500004],
            [43.92212975400008, 10.724188544000071],
            [44.02816816500007, 10.652167059000078],
            [44.09750410200007, 10.589260158000059],
            [44.14958743600005, 10.559149481000077],
            [44.27426191500007, 10.456732489000046],
            [44.303721550000034, 10.439846096000053],
            [44.34755429100005, 10.41451141400006],
            [44.389199603000066, 10.397206508000068],
            [44.46525798500005, 10.401480570000047],
            [44.541423242000064, 10.39274339800005],
            [44.58614884900004, 10.383584652000081],
            [44.627328970000065, 10.390612546000057],
            [44.661857276000035, 10.402411162000078],
            [44.72106328700005, 10.419384066000077],
            [44.750662429000045, 10.427865496000038],
            [44.79032435500005, 10.42348407500009],
            [44.854784437000035, 10.41452909600008],
            [44.89936564300007, 10.411813712000082],
            [44.96200868800008, 10.415799432000085],
            [44.994151238000086, 10.442694403000075],
            [44.98796634200005, 10.46039459800005],
            [45.00147545700008, 10.46039459800005],
            [45.111338738000086, 10.525580145000049],
            [45.12671959700003, 10.53196849200009],
            [45.157237175000034, 10.541083075000074],
            [45.252289259000065, 10.600531317000048],
            [45.32056725400008, 10.66209544500009],
            [45.33725019600007, 10.670843817000048],
            [45.35474694100009, 10.668850002000056],
            [45.37322024800005, 10.66242096600007],
            [45.39242597700007, 10.658392645000049],
            [45.409190300000034, 10.659491278000075],
            [45.445323113000086, 10.667792059000078],
            [45.487071160000085, 10.684719143000052],
            [45.516612175000034, 10.701971747000073],
            [45.542979363000086, 10.72166575700004],
            [45.573008660000085, 10.75812409100007],
            [45.58611087300005, 10.76585521000004],
            [45.66228274800005, 10.790594794000071],
            [45.67310631600009, 10.796210028000075],
            [45.68490644600007, 10.80890534100007],
            [45.69459069100009, 10.82225169500009],
            [45.70639082100007, 10.832831122000073],
            [45.724619988000086, 10.837144273000092],
            [45.73796634200005, 10.843573309000078],
            [45.75359134200005, 10.87173086100006],
            [45.76929772200003, 10.878119208000044],
            [45.78736412900008, 10.877752997000073],
            [45.802744988000086, 10.87531159100007],
            [45.81690514400009, 10.869208075000074],
            [45.83130944100009, 10.857611395000049],
            [45.840179884000065, 10.844671942000048],
            [45.846690300000034, 10.83226146000004],
            [45.85564212300005, 10.823960679000038],
            [45.87232506600009, 10.823472398000092],
            [45.868174675000034, 10.841376044000071],
            [45.88445071700005, 10.841213283000059],
            [45.977549675000034, 10.79913971600007],
            [46.01254316500007, 10.794745184000078],
            [46.047618035000085, 10.785305080000057],
            [46.06373131600009, 10.778794664000088],
            [46.102224155000044, 10.770656643000052],
            [46.13721764400009, 10.776312567000048],
            [46.207367384000065, 10.796210028000075],
            [46.23755944100009, 10.79242584800005],
            [46.26319420700008, 10.776841539000088],
            [46.30713951900009, 10.731024481000077],
            [46.33513431100005, 10.70970286700009],
            [46.370127800000034, 10.696844794000071],
            [46.40870201900009, 10.691595770000049],
            [46.44776451900009, 10.693101304000038],
            [46.482432488000086, 10.701361395000049],
            [46.49984785200007, 10.708482164000088],
            [46.527679884000065, 10.726223049000055],
            [46.56072024800005, 10.731675523000092],
            [46.58871504000007, 10.743312893000052],
            [46.62916100400008, 10.745062567000048],
            [46.64625084700003, 10.747748114000046],
            [46.65967858200008, 10.754339911000045],
            [46.694102410000085, 10.781927802000041],
            [46.782237175000034, 10.82172272300005],
            [46.82195071700005, 10.85260651200008],
            [46.865977410000085, 10.871893622000073],
            [46.871836785000085, 10.878078518000052],
            [46.88135826900009, 10.893133856000077],
            [46.88648522200003, 10.898586330000057],
            [46.893565300000034, 10.901556708000044],
            [46.90739993600005, 10.903143622000073],
            [46.91382897200003, 10.905462958000044],
            [47.00806725400008, 10.938950914000088],
            [47.082774285000085, 10.995266018000052],
            [47.13233483200008, 11.03579336100006],
            [47.16765384200005, 11.072088934000078],
            [47.180674675000034, 11.080471096000053],
            [47.22673587300005, 11.093817450000074],
            [47.23878014400009, 11.101263739000046],
            [47.26335696700005, 11.120794989000046],
            [47.36687259200005, 11.172796942000048],
            [47.38624108200008, 11.180121161000045],
            [47.40593509200005, 11.18463776200008],
            [47.43702233200008, 11.179836330000057],
            [47.48951256600009, 11.19281647300005],
            [47.52271569100009, 11.18695709800005],
            [47.677744988000086, 11.107977606000077],
            [47.71045983200008, 11.101263739000046],
            [47.76734459700003, 11.130194403000075],
            [47.89283287900008, 11.132554429000038],
            [47.948252800000034, 11.125148830000057],
            [48.13038170700008, 11.136664130000042],
            [48.160817905000044, 11.145656643000052],
            [48.17351321700005, 11.157131252000056],
            [48.19581139400009, 11.186835028000075],
            [48.215586785000085, 11.196234442000048],
            [48.21729576900009, 11.203680731000077],
            [48.21989993600005, 11.211127020000049],
            [48.22934004000007, 11.214504299000055],
            [48.24659264400009, 11.214260158000059],
            [48.25513756600009, 11.21507396000004],
            [48.27361087300005, 11.220404364000046],
            [48.29420006600009, 11.222601630000042],
            [48.30420983200008, 11.22752513200004],
            [48.310557488000086, 11.234767971000053],
            [48.31332441500007, 11.242010809000078],
            [48.31495201900009, 11.24900950700004],
            [48.318369988000086, 11.255519924000055],
            [48.33130944100009, 11.268703518000052],
            [48.342784050000034, 11.275458075000074],
            [48.373057488000086, 11.282171942000048],
            [48.444346550000034, 11.289252020000049],
            [48.478526238000086, 11.29633209800005],
            [48.506846550000034, 11.31354401200008],
            [48.52198326900009, 11.319281317000048],
            [48.585948113000086, 11.316961981000077],
            [48.63689212300005, 11.329413153000075],
            [48.65479576900009, 11.330633856000077],
            [48.72388756600009, 11.315252997000073],
            [48.762461785000085, 11.30101146000004],
            [48.80062910200007, 11.279038804000038],
            [48.88884524800005, 11.250555731000077],
            [48.90406334700003, 11.247748114000046],
            [48.92115319100009, 11.24803294500009],
            [48.939111999918396, 11.249129976167438],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Morocco',
        iso3: 'MAR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-8.817034779999915, 27.661464011000092],
            [-8.818449258999863, 27.659398092000018],
            [-8.812919880999885, 27.6133543910001],
            [-8.783619343999902, 27.53036204000007],
            [-8.77338741099993, 27.460030416000066],
            [-8.7880118409999, 27.416053772000012],
            [-8.801706094999929, 27.360424092000088],
            [-8.795840819999938, 27.307688294000073],
            [-8.77338741099993, 27.2500690720001],
            [-8.752871866999953, 27.190486146000026],
            [-8.752871866999953, 27.150462749000056],
            [-8.79390295399989, 27.120180359000116],
            [-8.888109089999887, 27.10356638600011],
            [-9.000918741999953, 27.089923808],
            [-9.083446003999882, 27.089923808],
            [-9.207469441999876, 27.099690654000042],
            [-9.284622354999925, 27.097726949000034],
            [-9.352008422999859, 27.097726949000034],
            [-9.412056436999961, 27.08796010400006],
            [-9.486315469999852, 27.04987457300011],
            [-9.56884273299994, 26.990291647000035],
            [-9.672350625999883, 26.910219015000067],
            [-9.734362345999926, 26.860428773000038],
            [-9.81686376999994, 26.849680075000023],
            [-9.89936519399987, 26.849680075000023],
            [-9.979928751999864, 26.88972930900009],
            [-10.031708536999929, 26.910219015000067],
            [-10.06586665799989, 26.908281148000057],
            [-10.122038939999868, 26.87996246400006],
            [-10.18844315599992, 26.860428773000038],
            [-10.250454873999956, 26.860428773000038],
            [-10.353962768999878, 26.900478007000018],
            [-10.477986206999958, 26.960035095000094],
            [-10.550281534999925, 26.990291647000035],
            [-10.653272664999918, 27.000058492000065],
            [-10.756780557999917, 27.019592184000075],
            [-10.829075886999874, 27.009825338000027],
            [-10.921835082999877, 27.009825338000027],
            [-11.045858520999957, 26.969801941000057],
            [-11.1493664139999, 26.940501404000102],
            [-11.26264115399988, 26.910219015000067],
            [-11.391573852999898, 26.882908021000063],
            [-11.360309610999906, 26.793042705000047],
            [-11.315867878999939, 26.744208476000054],
            [-11.315867878999939, 26.683643697000022],
            [-11.336900186999856, 26.632897441000026],
            [-11.39891190599991, 26.583081360000094],
            [-11.469708618999931, 26.519596863000046],
            [-11.51068802899988, 26.46980662],
            [-11.552210042999945, 26.400456849000065],
            [-11.582983356999904, 26.360407614000067],
            [-11.636210083999885, 26.294985250000096],
            [-11.68354569499985, 26.212974752000022],
            [-11.698221801999921, 26.162176819000123],
            [-11.717238728999888, 26.1035757450001],
            [-11.75387731999993, 26.08600575800004],
            [-11.879864460999983, 26.070399475000087],
            [-11.959911254999923, 26.049883932000014],
            [-12.029751952999902, 26.030350241000107],
            [-12.055823329999953, 25.995829570000055],
            [-12.060008504999928, 25.990301005000035],
            [-12.080058959999889, 25.91996938100003],
            [-12.080058959999889, 25.870204976000096],
            [-12.100057738999908, 25.830155742],
            [-12.129849202999907, 25.73054941900004],
            [-12.169872599999877, 25.63972808800007],
            [-12.200154988999913, 25.519580384000037],
            [-12.229946451999893, 25.419999899000075],
            [-12.269969848999978, 25.259802958000037],
            [-12.310019083999862, 25.110432230000058],
            [-12.35983516399989, 24.969794821000036],
            [-12.399884399999877, 24.87995534300005],
            [-12.430140949999895, 24.830165101000105],
            [-12.499981648999949, 24.769600322000045],
            [-12.56002966299988, 24.730532939000042],
            [-12.62984452399985, 24.67976084400003],
            [-12.709942992999913, 24.629970602000114],
            [-12.819781249999949, 24.57038767500002],
            [-12.910137491999905, 24.519589742000036],
            [-12.946880247999957, 24.496748253000064],
            [-12.990184285999874, 24.469799500000093],
            [-13.060024983999938, 24.400475566000054],
            [-13.120098836999944, 24.299861552000024],
            [-13.160122233999942, 24.219814758000055],
            [-13.229962931999921, 24.08990020700007],
            [-13.279753173999922, 24.019594421000065],
            [-13.310009724999873, 23.98055287700005],
            [-13.390108194999925, 23.94050364200008],
            [-13.479947671999923, 23.910221253000046],
            [-13.580044921999928, 23.870197856000075],
            [-13.660117553999982, 23.83012278200009],
            [-13.76998164899993, 23.790125224000022],
            [-13.83979650899991, 23.750075989000052],
            [-13.890129353999981, 23.690493063000062],
            [-13.930126912999953, 23.620187277000056],
            [-13.97994299299998, 23.519599101000026],
            [-14.019992227999865, 23.410251771],
            [-14.039991007999902, 23.339920146000097],
            [-14.100064860999908, 23.099676412000022],
            [-14.120089477999954, 22.96004669200009],
            [-14.140088256999888, 22.870181376000076],
            [-14.169905558999886, 22.75985219300007],
            [-14.189904337999934, 22.589914246000106],
            [-14.189904337999934, 22.450258687000073],
            [-14.209954793999884, 22.370186055000104],
            [-14.220186726999941, 22.30964711500006],
            [-14.270002806999884, 22.240297343000023],
            [-14.310052042999871, 22.190507101],
            [-14.379841064999937, 22.120201315000074],
            [-14.439914916999953, 22.080152079000115],
            [-14.459913695999887, 22.04010284400003],
            [-14.519987548999922, 21.990338440000087],
            [-14.580035563999928, 21.910239970000035],
            [-14.62985164399987, 21.860423889000103],
            [-14.620084797999908, 21.820374654000105],
            [-14.60982702599992, 21.750068868000128],
            [-14.64010941599986, 21.67976308200012],
            [-14.669875040999926, 21.59966461200007],
            [-14.749973510999894, 21.500084127],
            [-14.83981298899991, 21.450268046000062],
            [-14.970166788999848, 21.440501201000117],
            [-15.149871581999946, 21.440501201000117],
            [-15.289992227999932, 21.450268046000062],
            [-15.459930175999915, 21.450268046000062],
            [-15.60981766799992, 21.469801737000083],
            [-15.749964151999905, 21.49031728100006],
            [-15.919876260999956, 21.500084127],
            [-16.04002396599992, 21.500084127],
            [-16.189885620999945, 21.480550435000097],
            [-16.58004268399995, 21.480550435000097],
            [-16.729956013999896, 21.469801737000083],
            [-16.950149291999907, 21.429752503000074],
            [-17.013743325393165, 21.419971097583428],
            [-17.01280676999994, 21.44521719000005],
            [-16.971058722999942, 21.592596747000073],
            [-16.966908331999946, 21.636542059000078],
            [-16.970326300999943, 21.67446523600006],
            [-16.968006964999915, 21.69725169500009],
            [-16.95107988199993, 21.724758205000057],
            [-16.947661912999934, 21.736029364000046],
            [-16.94640051999994, 21.74827708500004],
            [-16.947010870999918, 21.75999583500004],
            [-16.95026607999995, 21.765366929000038],
            [-16.963246222999942, 21.77562083500004],
            [-16.966908331999946, 21.78115469000005],
            [-16.961537238999938, 21.795803127000056],
            [-16.95693925699993, 21.82566966400009],
            [-16.93781490799995, 21.86660390800006],
            [-16.929798956999946, 21.907945054000038],
            [-16.92100989499994, 21.931301174000055],
            [-16.81663977799991, 22.130560614000046],
            [-16.78066972599993, 22.165716864000046],
            [-16.775054490999935, 22.174953518000052],
            [-16.773426886999914, 22.180975653000075],
            [-16.762074347999942, 22.205023505000042],
            [-16.756337042999917, 22.210191148000035],
            [-16.739898240999935, 22.221136786000045],
            [-16.734120245999918, 22.22675202000005],
            [-16.71788489499994, 22.260972398000035],
            [-16.706776495999918, 22.275458075000074],
            [-16.68260657499991, 22.284084377000056],
            [-16.67715410099993, 22.289536851000037],
            [-16.670318162999934, 22.29441966400009],
            [-16.659006313999953, 22.295070705000057],
            [-16.65025794199994, 22.29169342700004],
            [-16.642648891999954, 22.285956122000073],
            [-16.631703253999945, 22.273911851000037],
            [-16.521839972999942, 22.314886786000045],
            [-16.50218665299991, 22.329901434000078],
            [-16.482167120999918, 22.35228099200009],
            [-16.466623501999948, 22.377386786000045],
            [-16.43150794199994, 22.493068752000056],
            [-16.429351365999935, 22.51044342700004],
            [-16.419545050999943, 22.52179596600007],
            [-16.36978105399993, 22.56826406500005],
            [-16.35728919199994, 22.58307526200008],
            [-16.34439042899993, 22.646958726000037],
            [-16.34137936099995, 22.73200104400007],
            [-16.336822068999936, 22.753729559000078],
            [-16.32485917899993, 22.789496161000045],
            [-16.316477016999954, 22.80605703300006],
            [-16.29645748599995, 22.832098700000074],
            [-16.296254035999937, 22.842189846000053],
            [-16.299956834999932, 22.850165106000077],
            [-16.302113410999937, 22.856756903000075],
            [-16.30215410099993, 22.868312893000052],
            [-16.300607876999948, 22.875067450000074],
            [-16.291737433999913, 22.893459377000056],
            [-16.289621548999946, 22.89980703300006],
            [-16.284779425999943, 22.90338776200008],
            [-16.262603318999936, 22.905585028000075],
            [-16.238636847999942, 22.91156647300005],
            [-16.20645097599993, 22.937974351000037],
            [-16.17296301999994, 22.973456122000073],
            [-16.163238084999932, 22.99323151200008],
            [-16.15648352799991, 23.013495184000078],
            [-16.15257727799991, 23.035223700000074],
            [-16.151275193999936, 23.059068101000037],
            [-16.159535285999937, 23.082464911000045],
            [-16.179066535999937, 23.08612702000005],
            [-16.22020423099991, 23.075873114000046],
            [-16.21312415299991, 23.09442780200004],
            [-16.196034308999913, 23.126166083000044],
            [-16.186675584999932, 23.137925523000035],
            [-16.139271613999938, 23.178534247000073],
            [-16.135121222999942, 23.18512604400007],
            [-16.06041419199994, 23.344549872000073],
            [-16.04914303299995, 23.35809967700004],
            [-16.038319464999915, 23.36391836100006],
            [-16.025542772999927, 23.374945380000042],
            [-15.981190558999913, 23.445786851000037],
            [-15.967193162999934, 23.512925523000035],
            [-15.956450975999928, 23.531724351000037],
            [-15.94131425699993, 23.551336981000077],
            [-15.905506964999915, 23.610296942000048],
            [-15.857085740999935, 23.661810614000046],
            [-15.853871222999942, 23.667914130000042],
            [-15.837391730999911, 23.679348049000055],
            [-15.83039303299995, 23.685980536000045],
            [-15.825062628999945, 23.69672272300005],
            [-15.820057745999918, 23.717230536000045],
            [-15.816070115999935, 23.72760651200008],
            [-15.80064856699994, 23.75063711100006],
            [-15.784820115999935, 23.76898834800005],
            [-15.772613084999932, 23.78782786700009],
            [-15.767689581999946, 23.812648830000057],
            [-15.765451626999948, 23.856756903000075],
            [-15.769154425999943, 23.87567780200004],
            [-15.781971808999913, 23.898260809000078],
            [-15.778675910999937, 23.90371328300006],
            [-15.775135870999918, 23.911932684000078],
            [-15.786773240999935, 23.90387604400007],
            [-15.787953253999945, 23.89215729400007],
            [-15.786000128999945, 23.87836334800005],
            [-15.78819739499994, 23.864162502000056],
            [-15.795318162999934, 23.856634833000044],
            [-15.820871548999946, 23.840277411000045],
            [-15.83039303299995, 23.83624909100007],
            [-15.843576626999948, 23.835882880000042],
            [-15.85220292899993, 23.83812083500004],
            [-15.861724412999934, 23.83616771000004],
            [-15.877552863999938, 23.823187567000048],
            [-15.888172980999911, 23.81073639500005],
            [-15.895334438999953, 23.798773505000042],
            [-15.91038977799991, 23.765326239000046],
            [-15.923329230999911, 23.74359772300005],
            [-15.925933397999927, 23.737250067000048],
            [-15.928089972999942, 23.725165106000077],
            [-15.937489386999914, 23.705226955000057],
            [-15.939605272999927, 23.696234442000048],
            [-15.948231574999909, 23.68431224200009],
            [-15.994862433999913, 23.645005601000037],
            [-16.009755011999914, 23.655422268000052],
            [-16.003163214999915, 23.67210521000004],
            [-15.981190558999913, 23.696234442000048],
            [-15.975819464999915, 23.710760809000078],
            [-15.939605272999927, 23.77480703300006],
            [-15.877552863999938, 23.853583075000074],
            [-15.871245897999927, 23.869208075000074],
            [-15.856800910999937, 23.88694896000004],
            [-15.84093176999994, 23.90265534100007],
            [-15.768137173999946, 23.959865627000056],
            [-15.735747850999928, 23.971177476000037],
            [-15.692616339999915, 23.995794989000046],
            [-15.67955481699994, 24.007513739000046],
            [-15.646636522999927, 24.01040273600006],
            [-15.620106574999909, 24.026271877000056],
            [-15.599232550999943, 24.04832591400009],
            [-15.583322719999956, 24.070257880000042],
            [-15.542347785999937, 24.11424388200004],
            [-15.514393683999913, 24.152167059000078],
            [-15.476063605999911, 24.177801825000074],
            [-15.459706183999913, 24.191880601000037],
            [-15.45303300699993, 24.210191148000035],
            [-15.444691535999937, 24.221869208000044],
            [-15.35338294199994, 24.291083075000074],
            [-15.298247850999928, 24.34516022300005],
            [-15.229562954999949, 24.440741278000075],
            [-15.203968878999945, 24.46747467700004],
            [-15.171864386999914, 24.49412669500009],
            [-15.153553839999915, 24.505601304000038],
            [-15.133412238999938, 24.51463450700004],
            [-15.112700975999928, 24.52057526200008],
            [-15.069406704999949, 24.527289130000042],
            [-15.048329230999911, 24.538275458000044],
            [-15.014800584999932, 24.562445380000042],
            [-15.015370245999918, 24.585679429000038],
            [-15.012237107999908, 24.591538804000038],
            [-14.999989386999914, 24.614488023000035],
            [-14.976226365999935, 24.641424872000073],
            [-14.952137824999909, 24.65924713700008],
            [-14.926991339999915, 24.67177969000005],
            [-14.907826300999943, 24.685492255000042],
            [-14.89561926999994, 24.70571523600006],
            [-14.88585364499994, 24.770738023000035],
            [-14.861927863999938, 24.830145575000074],
            [-14.85342363199993, 24.876613674000055],
            [-14.839670376999948, 24.90534088700008],
            [-14.836048956999946, 24.91868724200009],
            [-14.837961391999954, 24.93512604400007],
            [-14.84203040299991, 24.95026276200008],
            [-14.843169725999928, 24.965277411000045],
            [-14.836048956999946, 24.981390692000048],
            [-14.843495245999918, 24.987616278000075],
            [-14.837228969999956, 25.001695054000038],
            [-14.832590298999946, 25.01756419500009],
            [-14.829741990999935, 25.03424713700008],
            [-14.82921301999994, 25.05023834800005],
            [-14.83189856699994, 25.065741278000075],
            [-14.841420050999943, 25.087551174000055],
            [-14.843495245999918, 25.100531317000048],
            [-14.84243730399993, 25.18903229400007],
            [-14.849720831999946, 25.214178778000075],
            [-14.819243943999936, 25.330226955000057],
            [-14.812123175999943, 25.346096096000053],
            [-14.782053188999953, 25.446926174000055],
            [-14.73619544199994, 25.505519924000055],
            [-14.723133917999917, 25.51581452000005],
            [-14.714914516999954, 25.52558014500005],
            [-14.685170050999943, 25.59088776200008],
            [-14.678334113999938, 25.635565497000073],
            [-14.676258917999917, 25.641913153000075],
            [-14.666859503999945, 25.65973541900007],
            [-14.661366339999915, 25.69131094000005],
            [-14.62096106699994, 25.783596096000053],
            [-14.546457485999952, 25.87921784100007],
            [-14.519520636999914, 25.923773505000042],
            [-14.51390540299991, 25.93695709800005],
            [-14.511057094999956, 25.956854559000078],
            [-14.494984503999945, 26.001613674000055],
            [-14.48656165299991, 26.015448309000078],
            [-14.490345831999946, 26.03148021000004],
            [-14.48037675699993, 26.08779531500005],
            [-14.483306443999936, 26.102484442000048],
            [-14.49282792899993, 26.13271719000005],
            [-14.490061001999948, 26.142726955000057],
            [-14.48228919199994, 26.15387604400007],
            [-14.47179114499994, 26.18305084800005],
            [-14.466135219999956, 26.194240627000056],
            [-14.410145636999914, 26.26007721600007],
            [-14.400746222999942, 26.26630280200004],
            [-14.353179490999935, 26.275946356000077],
            [-14.298939581999946, 26.30223216400009],
            [-14.21593176999994, 26.375474351000037],
            [-14.202056443999936, 26.392238674000055],
            [-14.192779100999928, 26.409491278000075],
            [-14.180246548999946, 26.424383856000077],
            [-14.157053188999953, 26.43378327000005],
            [-14.046864386999914, 26.44440338700008],
            [-14.027740037999934, 26.452378648000035],
            [-13.92373613199993, 26.500881252000056],
            [-13.742014126999948, 26.618109442000048],
            [-13.619984503999945, 26.68891022300005],
            [-13.561105923999946, 26.74909088700008],
            [-13.500884568999936, 26.858303127000056],
            [-13.48033606699994, 26.91168854400007],
            [-13.461048956999946, 26.992743231000077],
            [-13.431996222999942, 27.05076732000009],
            [-13.402455206999946, 27.17719147300005],
            [-13.383656378999945, 27.215277411000045],
            [-13.30109615799995, 27.32444896000004],
            [-13.300770636999914, 27.330023505000042],
            [-13.307769334999932, 27.33934153900009],
            [-13.307932094999956, 27.344956773000035],
            [-13.294260219999956, 27.35175202000005],
            [-13.240834113999938, 27.465399481000077],
            [-13.207590298999946, 27.56745026200008],
            [-13.205433722999942, 27.58856842700004],
            [-13.200795050999943, 27.60651276200008],
            [-13.180978969999956, 27.64484284100007],
            [-13.17825448787525, 27.66249098107005],
            [-13.178212042999917, 27.66278717700004],
            [-13.177561001999948, 27.667141018000052],
            [-13.171254035999937, 27.68500397300005],
            [-13.160511847999942, 27.694647528000075],
            [-13.130360480999911, 27.70807526200008],
            [-13.09797115799995, 27.732245184000078],
            [-13.061431443999936, 27.74290599200009],
            [-13.04515540299991, 27.759833075000074],
            [-13.003000454999949, 27.82103099200009],
            [-12.979562954999949, 27.893703518000052],
            [-12.968088344999956, 27.914618231000077],
            [-12.952381964999915, 27.928615627000056],
            [-12.933094855999911, 27.938706773000035],
            [-12.838937954999949, 27.970404364000046],
            [-12.657826300999943, 27.99803294500009],
            [-12.51353919199994, 27.995428778000075],
            [-12.335031704999949, 28.047267971000053],
            [-12.061431443999936, 28.089016018000052],
            [-12.050404425999943, 28.09601471600007],
            [-12.027902798999946, 28.116888739000046],
            [-12.023101365999935, 28.119574286000045],
            [-12.005604620999918, 28.123195705000057],
            [-11.782378709999932, 28.210109768000052],
            [-11.485585089999915, 28.32562897300005],
            [-11.452788865999935, 28.348456122000073],
            [-11.42882239499994, 28.375921942000048],
            [-11.38931230399993, 28.434881903000075],
            [-11.374012824999909, 28.449774481000077],
            [-11.355946417999917, 28.46385325700004],
            [-11.340972459999932, 28.479681708000044],
            [-11.334706183999913, 28.499741929000038],
            [-11.325917120999918, 28.51520416900007],
            [-11.266468878999945, 28.551581122000073],
            [-11.219634568999936, 28.602484442000048],
            [-11.211822068999936, 28.61676666900007],
            [-11.170318162999934, 28.63971588700008],
            [-11.162464972999942, 28.647406317000048],
            [-11.15420488199993, 28.661078192000048],
            [-11.149159308999913, 28.667669989000046],
            [-11.114979620999918, 28.691839911000045],
            [-11.11156165299991, 28.695746161000045],
            [-11.091053839999915, 28.726304429000038],
            [-11.063099738999938, 28.752386786000045],
            [-11.047596808999913, 28.76170482000009],
            [-10.762603318999936, 28.89020416900007],
            [-10.694203253999945, 28.930568752000056],
            [-10.61241614499994, 28.967718817000048],
            [-10.573801235999952, 28.99042389500005],
            [-10.450917120999918, 29.092189846000053],
            [-10.34788977799991, 29.229396877000056],
            [-10.320871548999946, 29.257961330000057],
            [-10.301991339999915, 29.271877346000053],
            [-10.264027472999942, 29.284125067000048],
            [-10.248402472999942, 29.299383856000077],
            [-10.224354620999918, 29.33307526200008],
            [-10.19912675699993, 29.361273505000042],
            [-10.187570766999954, 29.378973700000074],
            [-10.18272864499994, 29.397284247000073],
            [-10.17764238199993, 29.40582916900007],
            [-10.141753709999932, 29.428615627000056],
            [-10.13703365799995, 29.43496328300006],
            [-10.128163214999915, 29.455959377000056],
            [-10.086984829999949, 29.50995514500005],
            [-10.080922003999945, 29.521144924000055],
            [-10.078684048999946, 29.542303778000075],
            [-10.072621222999942, 29.56468333500004],
            [-10.063628709999932, 29.58494700700004],
            [-10.05296790299991, 29.59992096600007],
            [-10.005279100999928, 29.638413804000038],
            [-9.997792120999918, 29.650824286000045],
            [-9.991688605999911, 29.666815497000073],
            [-9.949940558999913, 29.716009833000044],
            [-9.82022050699993, 29.83893463700008],
            [-9.717925584999932, 29.996568101000037],
            [-9.655140753999945, 30.126898505000042],
            [-9.645253058999913, 30.164007880000042],
            [-9.628407355999911, 30.291408596000053],
            [-9.61001542899993, 30.357814846000053],
            [-9.60732988199993, 30.37763092700004],
            [-9.61164303299995, 30.404364325000074],
            [-9.622710740999935, 30.41742584800005],
            [-9.638172980999911, 30.426662502000056],
            [-9.655140753999945, 30.442206122000073],
            [-9.66624915299991, 30.45929596600007],
            [-9.691761847999942, 30.509588934000078],
            [-9.700062628999945, 30.542710679000038],
            [-9.708404100999928, 30.54751211100006],
            [-9.719553188999953, 30.548529364000046],
            [-9.730824347999942, 30.552069403000075],
            [-9.739816860999952, 30.559881903000075],
            [-9.758168097999942, 30.586818752000056],
            [-9.829660610999952, 30.628607489000046],
            [-9.850941535999937, 30.62962474200009],
            [-9.874012824999909, 30.633978583000044],
            [-9.88853919199994, 30.648260809000078],
            [-9.886708136999914, 30.686672268000052],
            [-9.865630662999934, 30.724269924000055],
            [-9.839019334999932, 30.759833075000074],
            [-9.82022050699993, 30.792303778000075],
            [-9.813710089999915, 30.81468333500004],
            [-9.812896287999934, 30.82713450700004],
            [-9.816802537999934, 30.83665599200009],
            [-9.823841925999943, 30.845648505000042],
            [-9.824370897999927, 30.851955471000053],
            [-9.821888800999943, 30.859116929000038],
            [-9.82022050699993, 30.871079820000034],
            [-9.827707485999952, 31.06745026200008],
            [-9.831450975999928, 31.08535390800006],
            [-9.84752356699994, 31.12128327000005],
            [-9.835031704999949, 31.14476146000004],
            [-9.808949347999942, 31.28620026200008],
            [-9.806630011999914, 31.343451239000046],
            [-9.810902472999942, 31.366848049000055],
            [-9.821522589999915, 31.379461981000077],
            [-9.834787563999953, 31.388820705000057],
            [-9.84752356699994, 31.402411200000074],
            [-9.816232876999948, 31.436835028000075],
            [-9.792958136999914, 31.47134023600006],
            [-9.769642706999946, 31.53148021000004],
            [-9.758168097999942, 31.545803127000056],
            [-9.739613410999937, 31.56000397300005],
            [-9.733265753999945, 31.56736888200004],
            [-9.72765051999994, 31.585150458000044],
            [-9.713612433999913, 31.59784577000005],
            [-9.707630988999938, 31.609320380000042],
            [-9.694203253999945, 31.62571849200009],
            [-9.689279751999948, 31.635199286000045],
            [-9.675200975999928, 31.715399481000077],
            [-9.667307094999956, 31.73114655200004],
            [-9.575795050999943, 31.816107489000046],
            [-9.53538977799991, 31.864488023000035],
            [-9.527943488999938, 31.871242580000057],
            [-9.513295050999943, 31.880845445000034],
            [-9.504953579999949, 31.888413804000038],
            [-9.497425910999937, 31.898138739000046],
            [-9.488677537999934, 31.915350653000075],
            [-9.483794725999928, 31.92255280200004],
            [-9.366118943999936, 32.02631256700005],
            [-9.354074673999946, 32.04669830900008],
            [-9.346424933999913, 32.06150950700004],
            [-9.334828253999945, 32.101629950000074],
            [-9.333078579999949, 32.118068752000056],
            [-9.328114386999914, 32.13043854400007],
            [-9.291981574999909, 32.16893138200004],
            [-9.277740037999934, 32.196600653000075],
            [-9.270008917999917, 32.22748444200005],
            [-9.26475989499994, 32.33063385600008],
            [-9.268950975999928, 32.33551666900007],
            [-9.28774980399993, 32.34349192900004],
            [-9.291981574999909, 32.350816148000035],
            [-9.289662238999938, 32.37246328300006],
            [-9.283355272999927, 32.38776276200008],
            [-9.256255662999934, 32.43256256700005],
            [-9.248850063999953, 32.45254140800006],
            [-9.246937628999945, 32.472316799000055],
            [-9.254790818999936, 32.488267320000034],
            [-9.263661261999914, 32.498480536000045],
            [-9.272368943999936, 32.512925523000035],
            [-9.278309699999909, 32.52952708500004],
            [-9.278960740999935, 32.54633209800005],
            [-9.259917772999927, 32.57689036700009],
            [-9.112172003999945, 32.682847398000035],
            [-8.998524542999917, 32.79710521000004],
            [-8.901682094999956, 32.854803778000075],
            [-8.867787238999938, 32.88190338700008],
            [-8.754709438999953, 33.010646877000056],
            [-8.62913977799991, 33.12763092700004],
            [-8.621490037999934, 33.13934967700004],
            [-8.620350714999915, 33.152004299000055],
            [-8.62100175699993, 33.173529364000046],
            [-8.611887173999946, 33.18626536700009],
            [-8.52916419199994, 33.26870351800005],
            [-8.521148240999935, 33.27252838700008],
            [-8.512521938999953, 33.27049388200004],
            [-8.502797003999945, 33.26154205900008],
            [-8.494130011999914, 33.25950755400004],
            [-8.469797329999949, 33.260646877000056],
            [-8.451649542999917, 33.26422760600008],
            [-8.415028449999909, 33.28001536700009],
            [-8.37877356699994, 33.304673570000034],
            [-8.32022050699993, 33.36538320500006],
            [-8.284657355999911, 33.389837958000044],
            [-8.243153449999909, 33.40452708500004],
            [-8.10655676999994, 33.430853583000044],
            [-8.011545376999948, 33.46641673400006],
            [-7.962554490999935, 33.484808661000045],
            [-7.91624915299991, 33.494574286000045],
            [-7.891428188999953, 33.50336334800005],
            [-7.869740363999938, 33.526556708000044],
            [-7.844797329999949, 33.53595612200007],
            [-7.77798417899993, 33.55329010600008],
            [-7.738189256999931, 33.57062409100007],
            [-7.719471808999913, 33.574204820000034],
            [-7.700998501999948, 33.58274974200009],
            [-7.684437628999945, 33.59992096600007],
            [-7.667551235999952, 33.61269765800006],
            [-7.647857225999928, 33.60834381700005],
            [-7.636219855999911, 33.614569403000075],
            [-7.626616990999935, 33.61322663000004],
            [-7.617258266999954, 33.609361070000034],
            [-7.606190558999913, 33.60834381700005],
            [-7.596669074999909, 33.61155833500004],
            [-7.579253709999932, 33.620754299000055],
            [-7.549956834999932, 33.62555573100008],
            [-7.529123501999948, 33.63263580900008],
            [-7.510243292999917, 33.64154694200005],
            [-7.497059699999909, 33.64996979400007],
            [-7.463286912999934, 33.68650950700004],
            [-7.434315558999913, 33.69822825700004],
            [-7.406361456999946, 33.726996161000045],
            [-7.387115037999934, 33.732489325000074],
            [-7.393950975999928, 33.725043036000045],
            [-7.373850063999953, 33.71930573100008],
            [-7.352609829999949, 33.724676825000074],
            [-7.341135219999956, 33.73110586100006],
            [-7.267486131999931, 33.77240631700005],
            [-7.229318813999953, 33.80093008000006],
            [-7.192941860999952, 33.817694403000075],
            [-7.15257727799991, 33.830064195000034],
            [-7.117014126999948, 33.834865627000056],
            [-7.116566535999937, 33.83490631700005],
            [-7.099476691999939, 33.840277411000045],
            [-7.067860480999911, 33.86367422100005],
            [-7.031809048999946, 33.874253648000035],
            [-6.927357550999943, 33.94415924700007],
            [-6.822092251999948, 34.03961823100008],
            [-6.733754035999937, 34.16258372600004],
            [-6.667795376999948, 34.280503648000035],
            [-6.557932094999956, 34.41771067900004],
            [-6.547759568999936, 34.43471914300005],
            [-6.530913865999935, 34.47402578300006],
            [-6.507923956999946, 34.504787502000056],
            [-6.292103644999941, 34.88080475500004],
            [-6.20539303299995, 35.12457916900007],
            [-6.023915167999917, 35.501166083000044],
            [-6.018544074999909, 35.52020905200004],
            [-6.016672329999949, 35.544623114000046],
            [-6.012318488999938, 35.55882396000004],
            [-5.990834113999938, 35.598537502000056],
            [-5.970041469999956, 35.65253327000005],
            [-5.968251105999911, 35.66095612200007],
            [-5.965240037999934, 35.67023346600007],
            [-5.952056443999936, 35.68549225500004],
            [-5.949045376999948, 35.695379950000074],
            [-5.943104620999918, 35.74237702000005],
            [-5.93618730399993, 35.765611070000034],
            [-5.927235480999911, 35.78074778900009],
            [-5.908029751999948, 35.79734935100004],
            [-5.873402472999942, 35.801988023000035],
            [-5.781402147999927, 35.79092031500005],
            [-5.769276495999918, 35.79279205900008],
            [-5.742339647999927, 35.814886786000045],
            [-5.729888475999928, 35.82265859600005],
            [-5.711740688999953, 35.83063385600008],
            [-5.693511522999927, 35.83429596600007],
            [-5.680897589999915, 35.82916901200008],
            [-5.663441535999937, 35.83588288000004],
            [-5.639719204999949, 35.836371161000045],
            [-5.615956183999913, 35.83152903900009],
            [-5.598988410999937, 35.822333075000074],
            [-5.540028449999909, 35.85097890800006],
            [-5.523264126999948, 35.863267320000034],
            [-5.487456834999932, 35.89695872600004],
            [-5.468861456999946, 35.91034577000005],
            [-5.448109503999945, 35.91852448100008],
            [-5.440027099999952, 35.918106383000065],
            [-5.435451735999948, 35.91441657300004],
            [-5.423496752999938, 35.90895565500006],
            [-5.414198431999921, 35.909398432000046],
            [-5.410361029999933, 35.91707323600008],
            [-5.407999551999922, 35.92474804100004],
            [-5.405490480999958, 35.92651914900006],
            [-5.399322068999936, 35.92446523600006],
            [-5.398858678999886, 35.924503853000076],
            [-5.389717976999862, 35.90204742500002],
            [-5.378400837999891, 35.881686910000084],
            [-5.362897908999884, 35.863806865000114],
            [-5.340728318999936, 35.847357489000046],
            [-5.340809699999909, 35.84711334800005],
            [-5.345692511999914, 35.83258698100008],
            [-5.342355923999946, 35.80768463700008],
            [-5.327381964999915, 35.755845445000034],
            [-5.322621222999942, 35.713771877000056],
            [-5.318755662999934, 35.70172760600008],
            [-5.312652147999927, 35.69245026200008],
            [-5.304798956999946, 35.685207424000055],
            [-5.298898891999954, 35.68431224200009],
            [-5.28189042899993, 35.68650950700004],
            [-5.276763475999928, 35.685207424000055],
            [-5.275380011999914, 35.679388739000046],
            [-5.277455206999946, 35.66421133000006],
            [-5.276763475999928, 35.657904364000046],
            [-5.25999915299991, 35.604722398000035],
            [-5.249419725999928, 35.58462148600006],
            [-5.228423631999931, 35.56850820500006],
            [-5.18618730399993, 35.54376862200007],
            [-5.150786912999934, 35.51609935100004],
            [-5.066273566999939, 35.41746653900009],
            [-5.050852016999954, 35.407538153000075],
            [-5.026356574999909, 35.403998114000046],
            [-5.008208787999934, 35.39923737200007],
            [-4.98851477799991, 35.387884833000044],
            [-4.954701300999943, 35.36245351800005],
            [-4.926503058999913, 35.33030833500004],
            [-4.909331834999932, 35.314520575000074],
            [-4.864979620999918, 35.301988023000035],
            [-4.810617641999954, 35.25999583500004],
            [-4.770497199999909, 35.24103424700007],
            [-4.628285285999937, 35.20538971600007],
            [-4.495432094999956, 35.18077220300006],
            [-4.494252081999946, 35.180568752000056],
            [-4.376047329999949, 35.15184153900009],
            [-4.347645636999914, 35.15013255400004],
            [-4.327056443999936, 35.15477122600004],
            [-4.269398566999939, 35.184881903000075],
            [-4.130604620999918, 35.204779364000046],
            [-4.046701626999948, 35.23590729400007],
            [-3.961293097999942, 35.250433661000045],
            [-3.919341600999928, 35.266831773000035],
            [-3.909413214999915, 35.25527578300006],
            [-3.91253041899995, 35.25091829400009],
            [-3.924672585999929, 35.24755584700006],
            [-3.92952945299993, 35.24381979600008],
            [-3.925046190999922, 35.237842114000046],
            [-3.918467005999958, 35.23089340100006],
            [-3.903901018999932, 35.214172586000075],
            [-3.889257349999923, 35.20840659900006],
            [-3.868560350999928, 35.20734284100007],
            [-3.840891079999949, 35.20538971600007],
            [-3.821929490999935, 35.20677317900004],
            [-3.787464972999942, 35.20921458500004],
            [-3.764800584999932, 35.218451239000046],
            [-3.755523240999935, 35.236395575000074],
            [-3.747141079999949, 35.263657945000034],
            [-3.726226365999935, 35.28229401200008],
            [-3.699574347999942, 35.29083893400008],
            [-3.673573370999918, 35.28790924700007],
            [-3.654204881999931, 35.277004299000055],
            [-3.612212693999936, 35.245347398000035],
            [-3.590972459999932, 35.233303127000056],
            [-3.516021287999934, 35.223537502000056],
            [-3.489328579999949, 35.211004950000074],
            [-3.477406378999945, 35.21067942900004],
            [-3.464751756999931, 35.211818752000056],
            [-3.453846808999913, 35.21161530200004],
            [-3.442860480999911, 35.208644924000055],
            [-3.423247850999928, 35.200832424000055],
            [-3.412912563999953, 35.19794342700004],
            [-3.362049933999913, 35.194525458000044],
            [-3.319243943999936, 35.20180898600006],
            [-3.195139126999948, 35.23822663000004],
            [-3.173939581999946, 35.24909088700008],
            [-3.128651495999918, 35.28856028900009],
            [-3.118031378999945, 35.294134833000044],
            [-3.109730597999942, 35.29364655200004],
            [-3.100412563999953, 35.28953685100004],
            [-3.089670376999948, 35.28628164300005],
            [-3.077056443999936, 35.28790924700007],
            [-3.045399542999917, 35.314439195000034],
            [-3.006255662999934, 35.39354075700004],
            [-2.980824347999942, 35.42450592700004],
            [-2.982818162999934, 35.43500397300005],
            [-2.977935350999928, 35.44330475500004],
            [-2.968576626999948, 35.44643789300005],
            [-2.956654425999943, 35.44122955900008],
            [-2.952219204999949, 35.43305084800005],
            [-2.957590298999946, 35.41583893400008],
            [-2.952951626999948, 35.403998114000046],
            [-2.963042772999927, 35.373480536000045],
            [-2.949777798999946, 35.33494700700004],
            [-2.948109503999945, 35.33026764500005],
            [-2.947824673999946, 35.329779364000046],
            [-2.966920125999877, 35.313866272],
            [-2.963767862999902, 35.286219381000095],
            [-2.943045613999885, 35.2678742480001],
            [-2.912912563999953, 35.27692291900007],
            [-2.899037238999938, 35.25999583500004],
            [-2.907948370999918, 35.25096263200004],
            [-2.91234290299991, 35.23578522300005],
            [-2.913319464999915, 35.21906159100007],
            [-2.909820115999935, 35.186712958000044],
            [-2.905140753999945, 35.17357005400004],
            [-2.896392381999931, 35.161810614000046],
            [-2.881988084999932, 35.14671458500004],
            [-2.856068488999938, 35.131293036000045],
            [-2.82095292899993, 35.12189362200007],
            [-2.748117641999954, 35.11595286700009],
            [-2.791818813999953, 35.14516836100006],
            [-2.868275519999941, 35.21735260600008],
            [-2.883168097999942, 35.23851146000004],
            [-2.878407355999911, 35.24632396000004],
            [-2.864857550999943, 35.237616278000075],
            [-2.816395636999914, 35.194525458000044],
            [-2.808664516999954, 35.18378327000005],
            [-2.761097785999937, 35.14325592700004],
            [-2.718332485999952, 35.12299225500004],
            [-2.666737433999913, 35.10822174700007],
            [-2.563221808999913, 35.096136786000045],
            [-2.517486131999931, 35.09935130400004],
            [-2.493316209999932, 35.104396877000056],
            [-2.47720292899993, 35.112616278000075],
            [-2.456125454999949, 35.132473049000055],
            [-2.437123175999943, 35.14508698100008],
            [-2.416737433999913, 35.14915599200009],
            [-2.321441209999932, 35.118841864000046],
            [-2.29906165299991, 35.11595286700009],
            [-2.275257941999939, 35.10956452000005],
            [-2.24868730399993, 35.09723541900007],
            [-2.222564256999931, 35.089300848000065],
            [-2.22112585499994, 35.04995473300009],
            [-2.211669067999878, 35.02344472300008],
            [-2.193789021999919, 35.003600973000104],
            [-2.163299926999912, 34.994040833],
            [-2.126041218999887, 34.97192332000007],
            [-2.094932006999954, 34.94768707300001],
            [-2.061238972999888, 34.92970367400001],
            [-2.016280476999981, 34.926241354000084],
            [-2.003619750999945, 34.918179830000085],
            [-1.999692341999975, 34.90634592700006],
            [-1.998400430999908, 34.89270334900006],
            [-1.993491170999988, 34.878854065],
            [-1.979745238999953, 34.86526316400001],
            [-1.926725218999934, 34.83808136000003],
            [-1.892825479999942, 34.811674704000055],
            [-1.787715616999975, 34.75669097900003],
            [-1.769525512999849, 34.74134307900003],
            [-1.773142862999919, 34.734056702000046],
            [-1.786113646999922, 34.72584014900012],
            [-1.810504923999872, 34.68072662400006],
            [-1.862956502999907, 34.61359893800004],
            [-1.871121377999941, 34.59664906900012],
            [-1.750663614999894, 34.49417470300007],
            [-1.714231729999909, 34.48505381300002],
            [-1.702966267999955, 34.47967946400006],
            [-1.80962642399993, 34.37245086700001],
            [-1.771334187999912, 34.33470123300005],
            [-1.746064412999942, 34.290311178000096],
            [-1.674750935999981, 34.105955506],
            [-1.672085147999951, 34.09202070500008],
            [-1.669634968999901, 34.07921295200005],
            [-1.672115437999878, 34.0591883340001],
            [-1.718727579999921, 33.89808705600002],
            [-1.722086547999936, 33.85116485700006],
            [-1.713043172999988, 33.80199473],
            [-1.702501179999928, 33.772823385],
            [-1.703224650999914, 33.761816305000096],
            [-1.710821084999878, 33.747062683000095],
            [-1.720949666999928, 33.73636566200007],
            [-1.732576863999896, 33.72786488900006],
            [-1.742240355999911, 33.71776214700013],
            [-1.746787881999865, 33.70238840800006],
            [-1.740741739999919, 33.68660125700005],
            [-1.725393838999935, 33.67771291100006],
            [-1.69071895299993, 33.6673259490001],
            [-1.67325231999996, 33.65649973600007],
            [-1.662400268999932, 33.644691671000075],
            [-1.617338418999879, 33.55443878200005],
            [-1.612739216999927, 33.52146921800009],
            [-1.625399942999877, 33.494235738],
            [-1.640386107999859, 33.475528870000105],
            [-1.659144653999931, 33.41977],
            [-1.67283890799996, 33.39460357700001],
            [-1.683225869999887, 33.36923044900003],
            [-1.683380899999918, 33.2708385210001],
            [-1.674234171999927, 33.237972311000064],
            [-1.623591267999871, 33.19660532700003],
            [-1.605607869999886, 33.16802826000007],
            [-1.592068643999909, 33.13660898900012],
            [-1.571398071999909, 33.11198516900002],
            [-1.545508178999881, 33.09183136000006],
            [-1.516362670999854, 33.073977153],
            [-1.499516153999878, 33.06020538400007],
            [-1.493056599999903, 33.03948313400004],
            [-1.493366658999889, 33.016151225],
            [-1.496518920999961, 32.99429209500006],
            [-1.498844360999897, 32.98400848500005],
            [-1.502978474999907, 32.974629212000096],
            [-1.508869587999897, 32.96630930600004],
            [-1.516362670999854, 32.95948801700008],
            [-1.558789021999871, 32.93364980100007],
            [-1.423345092999881, 32.74239532500012],
            [-1.390530558999956, 32.718779196000085],
            [-1.327020223999909, 32.69890960700009],
            [-1.047502400999861, 32.51700856600006],
            [-1.031999470999949, 32.49440012700002],
            [-1.089980428999894, 32.439442241000094],
            [-1.123156697999917, 32.417944845000065],
            [-1.160260375999883, 32.40494822200013],
            [-1.201704874999933, 32.39985809300005],
            [-1.217982950999954, 32.39262339300008],
            [-1.23415767399996, 32.37461415600008],
            [-1.244131225999894, 32.35691497800006],
            [-1.257515420999908, 32.32084482800006],
            [-1.273423460999879, 32.22944217200005],
            [-1.27549881999991, 32.2175178020001],
            [-1.275188760999924, 32.209068706],
            [-1.276635700999918, 32.20085215300007],
            [-1.282991902999925, 32.19018096900008],
            [-1.289193074999929, 32.18485829700002],
            [-1.305677855999903, 32.17372202600011],
            [-1.309553588999961, 32.167443339],
            [-1.305161091999963, 32.15116526300007],
            [-1.288986368999872, 32.1509068810001],
            [-1.251831013999976, 32.16351593100002],
            [-1.23271073399988, 32.16372263600009],
            [-1.211833455999908, 32.15834828800003],
            [-1.195607055999886, 32.14604929600007],
            [-1.190594440999917, 32.12522369400001],
            [-1.210334838999898, 32.089670309000056],
            [-1.249557250999942, 32.08166046200007],
            [-1.324953165999943, 32.0847093710001],
            [-1.333428100999924, 32.08507110600003],
            [-1.357405965999959, 32.08605295800008],
            [-1.395388142999877, 32.08755157500009],
            [-1.445617634999934, 32.089515280000015],
            [-1.506337442999921, 32.09194407200009],
            [-1.575790567999888, 32.094734599000034],
            [-1.652375039999896, 32.09783518500008],
            [-1.734333861999886, 32.10109080000005],
            [-1.819961710999934, 32.104501445],
            [-1.907553262999926, 32.10796376500004],
            [-1.995454873999904, 32.111477763],
            [-2.081857869999908, 32.114940084000025],
            [-2.165108601999918, 32.11829905200004],
            [-2.243398396999879, 32.121399639000074],
            [-2.315176960999878, 32.12429351800007],
            [-2.378635620999916, 32.12677398700005],
            [-2.516146605999893, 32.13220001300003],
            [-2.695567178999852, 32.089670309000056],
            [-2.881188923999957, 32.07628611300002],
            [-2.938730631999903, 32.0486392210001],
            [-2.869768686121859, 31.89243012266293],
            [-2.827835693118061, 31.794586472320745],
            [-3.002556497300333, 31.77361997581893],
            [-3.219210294486487, 31.717709318480544],
            [-3.511563883999941, 31.672744853000083],
            [-3.548745076999865, 31.669954326000024],
            [-3.591378132999949, 31.678274232],
            [-3.659506721025934, 31.647820996807653],
            [-3.673484385360553, 31.389234206617786],
            [-3.747466796999959, 31.385165507000053],
            [-3.8025021979999, 31.35064565100005],
            [-3.815188761999934, 31.337158102],
            [-3.81921952299993, 31.318864645000033],
            [-3.812914998999929, 31.243365377000103],
            [-3.814982054999888, 31.220524394],
            [-3.836169392999864, 31.18977691700006],
            [-3.842835652999952, 31.170191549000023],
            [-3.839321654999907, 31.15282826800002],
            [-3.827461913999883, 31.143836568000083],
            [-3.810796263999862, 31.142906393000104],
            [-3.792967895999908, 31.149676006000064],
            [-3.763719034999951, 31.173447164000024],
            [-3.748862059999936, 31.18021677600005],
            [-3.731421264999881, 31.176341045000086],
            [-3.717106892999908, 31.16326690700005],
            [-3.689718383999946, 31.125594788000015],
            [-3.671941690999915, 31.11086700500003],
            [-3.635871541999933, 31.095674133000088],
            [-3.624140991999951, 31.086527405000098],
            [-3.614529174999916, 31.06802724200007],
            [-3.61008500199992, 31.050302226000056],
            [-3.60874141499994, 31.03087188800008],
            [-3.554674238516554, 30.955926612245648],
            [-3.610584895854856, 30.879049458405362],
            [-3.659506721025934, 30.837116465401678],
            [-3.652517888858654, 30.774216975895982],
            [-3.645529056691345, 30.7113174863904],
            [-3.834227525208235, 30.627451500382804],
            [-4.001959497223311, 30.5925073395464],
            [-4.155713804903684, 30.585518507379092],
            [-4.274523951747767, 30.557563178709913],
            [-4.372367602089838, 30.50864135353892],
            [-4.484188916766527, 30.38284237452764],
            [-4.62396556011231, 30.28499872418554],
            [-4.770731035625488, 30.229088066847154],
            [-4.875563518134896, 30.180166241676076],
            [-4.959429504142378, 30.124255584337774],
            [-5.071250818819067, 30.040389598330265],
            [-5.176083301328532, 29.977490108824597],
            [-5.273926951670632, 29.886635290649807],
            [-5.343815273343523, 29.76782514380581],
            [-5.434670091518313, 29.64202616479453],
            [-5.539502574027694, 29.52321601795056],
            [-5.637346224369793, 29.495260689281352],
            [-5.721212210377359, 29.52321601795056],
            [-5.756156371213876, 29.61407083612535],
            [-5.881955350225155, 29.600093171790732],
            [-6.00076549706904, 29.579126675288947],
            [-6.126564476080318, 29.579126675288947],
            [-6.273329951593496, 29.579126675288947],
            [-6.413106594939393, 29.56514901095433],
            [-6.55987207045257, 29.53020485011784],
            [-6.699648713798354, 29.51622718578325],
            [-6.78351469980592, 29.44633886411036],
            [-6.95823550398822, 29.50923835361594],
            [-7.070056818664909, 29.51622718578325],
            [-7.146933972505082, 29.50923835361594],
            [-7.258755287181771, 29.467305360612258],
            [-7.349610105356646, 29.383439374604663],
            [-7.463286498999878, 29.389137472000115],
            [-7.48406042499991, 29.382445374],
            [-7.506126260999906, 29.380223287],
            [-7.528502156999878, 29.380946757000075],
            [-7.572685506999989, 29.387613017],
            [-7.619452677999902, 29.389421692000084],
            [-7.653610798999892, 29.376192525000093],
            [-7.714666503999865, 29.321828918000037],
            [-7.729988565999918, 29.311157736000027],
            [-7.777995970999882, 29.289324443000098],
            [-7.839129191999888, 29.239043275000128],
            [-7.945014200999935, 29.176230570000072],
            [-8.03632645699986, 29.099852804000093],
            [-8.069657754999923, 29.07933726000003],
            [-8.18231237799992, 29.035541484000035],
            [-8.250473591999935, 28.99476877900007],
            [-8.316774454999859, 28.939061584000015],
            [-8.333259235999947, 28.93037994400005],
            [-8.36845088699991, 28.916530661000095],
            [-8.383488728999879, 28.90578196300008],
            [-8.4178018799999, 28.85234853100006],
            [-8.430410929999937, 28.84100555500008],
            [-8.475834512999882, 28.818758851000027],
            [-8.520818847999891, 28.787081198000024],
            [-8.648847208999882, 28.72594797800012],
            [-8.66760575399988, 28.71168528300005],
            [-8.678767862999905, 28.69282338500001],
            [-8.68238521299989, 28.665899964000104],
            [-8.68238521299989, 28.620217998000086],
            [-8.68238521299989, 28.560273336000094],
            [-8.68238521299989, 28.50040618900003],
            [-8.68238521299989, 28.440487366000056],
            [-8.68238521299989, 28.380542704000064],
            [-8.68238521299989, 28.32062388100009],
            [-8.68238521299989, 28.26067922],
            [-8.68238521299989, 28.200760397000025],
            [-8.68238521299989, 28.140893250000047],
            [-8.68238521299989, 28.080948588000055],
            [-8.68238521299989, 28.02102976600007],
            [-8.68238521299989, 27.961085104000105],
            [-8.68238521299989, 27.901140442000028],
            [-8.68238521299989, 27.841221619000024],
            [-8.68238521299989, 27.781354472000075],
            [-8.68238521299989, 27.72143564900007],
            [-8.68238521299989, 27.66143931100008],
            [-8.752561807999882, 27.66143931100008],
            [-8.816537230999955, 27.661465149],
            [-8.817034779999915, 27.661464011000092],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'W. Sahara',
        iso3: 'ESH',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-8.817034779999915, 27.661464011000092],
            [-8.816537230999955, 27.661465149],
            [-8.752561807999882, 27.66143931100008],
            [-8.68238521299989, 27.66143931100008],
            [-8.68238521299989, 27.56741404200004],
            [-8.68238521299989, 27.47346628800001],
            [-8.68238521299989, 27.37946685800007],
            [-8.68238521299989, 27.285415751000116],
            [-8.682281860999865, 27.27166982100009],
            [-8.682230183999962, 27.232705790000082],
            [-8.682230183999962, 27.17214101200004],
            [-8.682075154999922, 27.093696188000123],
            [-8.681920124999891, 27.00083363800009],
            [-8.681816772999952, 26.89717071500003],
            [-8.681661742999893, 26.786324768],
            [-8.681558389999879, 26.671913147000012],
            [-8.681455036999864, 26.557449850000026],
            [-8.681300008999898, 26.446603902],
            [-8.681144978999953, 26.34299265600005],
            [-8.681041625999853, 26.25018178300003],
            [-8.680938272999896, 26.1716336060001],
            [-8.68086075799988, 26.111120504000056],
            [-8.68086075799988, 26.072208150000066],
            [-8.680809081999882, 26.058410543000022],
            [-8.680809081999882, 26.013141989000033],
            [-8.687656208999925, 26.000016175000056],
            [-8.707215738999935, 25.99500356],
            [-8.792042602999885, 25.99500356],
            [-8.892863321999897, 25.994951884000088],
            [-8.993580688999941, 25.994951884000088],
            [-9.094246378999912, 25.994951884000088],
            [-9.195015421999898, 25.994951884000088],
            [-9.295732787999953, 25.994951884000088],
            [-9.396450154999911, 25.994951884000088],
            [-9.49716752099988, 25.994951884000088],
            [-9.597884887999953, 25.994951884000088],
            [-9.698653930999939, 25.994951884000088],
            [-9.799371297999897, 25.994951884000088],
            [-9.90003698699985, 25.994951884000088],
            [-10.000806030999911, 25.994951884000088],
            [-10.10152339699988, 25.994951884000088],
            [-10.202292439999951, 25.994951884000088],
            [-10.302958129999922, 25.994951884000088],
            [-10.403675496999881, 25.994951884000088],
            [-10.504444539999952, 25.994951884000088],
            [-10.605161905999921, 25.994951884000088],
            [-10.705879272999908, 25.994951884000088],
            [-10.806596639999952, 25.994951884000088],
            [-10.907314005999922, 25.994951884000088],
            [-11.008083047999918, 25.994951884000088],
            [-11.108748738999878, 25.994951884000088],
            [-11.20951778199995, 25.994951884000088],
            [-11.310235147999919, 25.994951884000088],
            [-11.410952514999877, 25.994951884000088],
            [-11.511721557999863, 25.994951884000088],
            [-11.612438923999918, 25.994951884000088],
            [-11.713207966999903, 25.994951884000088],
            [-11.813821980999933, 25.994951884000088],
            [-11.914591023999918, 25.994951884000088],
            [-12.015308389999888, 25.99490020800006],
            [-12.015308389999888, 25.9192459100001],
            [-12.015308389999888, 25.843694967000076],
            [-12.015308389999888, 25.768092347000035],
            [-12.015308389999888, 25.69248972600009],
            [-12.015308389999888, 25.616938782000076],
            [-12.015308389999888, 25.541336162000036],
            [-12.015308389999888, 25.46573354100009],
            [-12.015308389999888, 25.390182597000077],
            [-12.015308389999888, 25.314579977000037],
            [-12.015308389999888, 25.238925680000065],
            [-12.015308389999888, 25.163323060000025],
            [-12.015308389999888, 25.08779795400001],
            [-12.015308389999888, 25.012247009000063],
            [-12.015308389999888, 24.936618551000024],
            [-12.015308389999888, 24.861015931000097],
            [-12.015308389999888, 24.785464986000065],
            [-12.015308389999888, 24.709862366000024],
            [-12.015308389999888, 24.63425974600007],
            [-12.015308389999888, 24.558631287000125],
            [-12.015308389999888, 24.483080343],
            [-12.015308389999888, 24.407477722000053],
            [-12.015308389999888, 24.33190094100003],
            [-12.015308389999888, 24.256298319000066],
            [-12.015308389999888, 24.180695699000054],
            [-12.015308389999888, 24.1050930790001],
            [-12.015308389999888, 24.029542135000057],
            [-12.015308389999888, 23.953939514000027],
            [-12.015308389999888, 23.878311056000072],
            [-12.015308389999888, 23.80273427400006],
            [-12.015308389999888, 23.727105815000087],
            [-12.015308389999888, 23.651477356000058],
            [-12.015308389999888, 23.575926412000015],
            [-12.015308389999888, 23.495181986000077],
            [-12.019339151999873, 23.460998027000088],
            [-12.032723347999905, 23.444978333000037],
            [-12.1345775959999, 23.419346822000065],
            [-12.353892374999873, 23.32247935000005],
            [-12.389910847999943, 23.31253163700005],
            [-12.558376017999933, 23.29028493300011],
            [-12.619431721999916, 23.27082875600003],
            [-12.68221858699988, 23.23075368300003],
            [-12.789938109999866, 23.16186899800003],
            [-12.915098428999954, 23.082054749000022],
            [-13.015247354999872, 23.018001811000133],
            [-13.034341796999854, 22.995212504000037],
            [-13.119892130999915, 22.88353973400008],
            [-13.152293253999915, 22.82000356000013],
            [-13.16549658199989, 22.752695008000032],
            [-13.15498042799993, 22.68879709900007],
            [-13.106352904999909, 22.560226135000036],
            [-13.093330444999879, 22.495475566000053],
            [-13.076832743499864, 22.24543914850007],
            [-13.060335041999906, 21.995402731000084],
            [-13.032092883999951, 21.581939241],
            [-13.026176920999944, 21.495329896],
            [-13.015247354999872, 21.333427633000028],
            [-13.161724202999949, 21.333427633000028],
            [-13.203091186999899, 21.333375956000012],
            [-13.31985408599985, 21.333375956000012],
            [-13.501419229999954, 21.333375956000012],
            [-13.736908731999932, 21.3333242800001],
            [-14.015496378999927, 21.333272603000083],
            [-14.295597564999923, 21.33322605900004],
            [-14.32648514899995, 21.333220927000056],
            [-14.658971312999881, 21.333169251000058],
            [-15.002257853999936, 21.333169251000058],
            [-15.345544392999926, 21.3330658980001],
            [-15.678082234999891, 21.3330658980001],
            [-15.98901932799987, 21.333014222000102],
            [-16.26771032699989, 21.33291086800007],
            [-16.503148152999955, 21.33291086800007],
            [-16.684635782999862, 21.33291086800007],
            [-16.801424519999898, 21.332859192000072],
            [-16.84281734299995, 21.332859192000072],
            [-16.958830932999973, 21.332859192000072],
            [-16.968339395999863, 21.324590963000034],
            [-16.985702677999967, 21.237826233000035],
            [-17.004926309999888, 21.141914775000075],
            [-17.047378499999922, 21.027399801000072],
            [-17.054018920999937, 20.9954637660001],
            [-17.077428344999902, 20.904513245000075],
            [-17.0811748859999, 20.874747620000093],
            [-17.05687415299991, 20.766913153000075],
            [-17.068348761999914, 20.79246653900009],
            [-17.100209113999938, 20.837591864000046],
            [-17.104644334999932, 20.862494208000044],
            [-17.101389126999948, 20.876166083000044],
            [-17.092274542999917, 20.89988841400009],
            [-17.090402798999946, 20.914007880000042],
            [-17.090402798999946, 20.961818752000056],
            [-17.086293097999942, 20.979315497000073],
            [-17.06786048099991, 21.030910549000055],
            [-17.02676347599993, 21.328924872000073],
            [-17.01744544199994, 21.365057684000078],
            [-17.015248175999943, 21.379828192000048],
            [-17.013743325393165, 21.419971097583428],
            [-16.950149291999907, 21.429752503000074],
            [-16.729956013999896, 21.469801737000083],
            [-16.58004268399995, 21.480550435000097],
            [-16.189885620999945, 21.480550435000097],
            [-16.04002396599992, 21.500084127],
            [-15.919876260999956, 21.500084127],
            [-15.749964151999905, 21.49031728100006],
            [-15.60981766799992, 21.469801737000083],
            [-15.459930175999915, 21.450268046000062],
            [-15.289992227999932, 21.450268046000062],
            [-15.149871581999946, 21.440501201000117],
            [-14.970166788999848, 21.440501201000117],
            [-14.83981298899991, 21.450268046000062],
            [-14.749973510999894, 21.500084127],
            [-14.669875040999926, 21.59966461200007],
            [-14.64010941599986, 21.67976308200012],
            [-14.60982702599992, 21.750068868000128],
            [-14.620084797999908, 21.820374654000105],
            [-14.62985164399987, 21.860423889000103],
            [-14.580035563999928, 21.910239970000035],
            [-14.519987548999922, 21.990338440000087],
            [-14.459913695999887, 22.04010284400003],
            [-14.439914916999953, 22.080152079000115],
            [-14.379841064999937, 22.120201315000074],
            [-14.310052042999871, 22.190507101],
            [-14.270002806999884, 22.240297343000023],
            [-14.220186726999941, 22.30964711500006],
            [-14.209954793999884, 22.370186055000104],
            [-14.189904337999934, 22.450258687000073],
            [-14.189904337999934, 22.589914246000106],
            [-14.169905558999886, 22.75985219300007],
            [-14.140088256999888, 22.870181376000076],
            [-14.120089477999954, 22.96004669200009],
            [-14.100064860999908, 23.099676412000022],
            [-14.039991007999902, 23.339920146000097],
            [-14.019992227999865, 23.410251771],
            [-13.97994299299998, 23.519599101000026],
            [-13.930126912999953, 23.620187277000056],
            [-13.890129353999981, 23.690493063000062],
            [-13.83979650899991, 23.750075989000052],
            [-13.76998164899993, 23.790125224000022],
            [-13.660117553999982, 23.83012278200009],
            [-13.580044921999928, 23.870197856000075],
            [-13.479947671999923, 23.910221253000046],
            [-13.390108194999925, 23.94050364200008],
            [-13.310009724999873, 23.98055287700005],
            [-13.279753173999922, 24.019594421000065],
            [-13.229962931999921, 24.08990020700007],
            [-13.160122233999942, 24.219814758000055],
            [-13.120098836999944, 24.299861552000024],
            [-13.060024983999938, 24.400475566000054],
            [-12.990184285999874, 24.469799500000093],
            [-12.946880247999957, 24.496748253000064],
            [-12.910137491999905, 24.519589742000036],
            [-12.819781249999949, 24.57038767500002],
            [-12.709942992999913, 24.629970602000114],
            [-12.62984452399985, 24.67976084400003],
            [-12.56002966299988, 24.730532939000042],
            [-12.499981648999949, 24.769600322000045],
            [-12.430140949999895, 24.830165101000105],
            [-12.399884399999877, 24.87995534300005],
            [-12.35983516399989, 24.969794821000036],
            [-12.310019083999862, 25.110432230000058],
            [-12.269969848999978, 25.259802958000037],
            [-12.229946451999893, 25.419999899000075],
            [-12.200154988999913, 25.519580384000037],
            [-12.169872599999877, 25.63972808800007],
            [-12.129849202999907, 25.73054941900004],
            [-12.100057738999908, 25.830155742],
            [-12.080058959999889, 25.870204976000096],
            [-12.080058959999889, 25.91996938100003],
            [-12.060008504999928, 25.990301005000035],
            [-12.055823329999953, 25.995829570000055],
            [-12.029751952999902, 26.030350241000107],
            [-11.959911254999923, 26.049883932000014],
            [-11.879864460999983, 26.070399475000087],
            [-11.75387731999993, 26.08600575800004],
            [-11.717238728999888, 26.1035757450001],
            [-11.698221801999921, 26.162176819000123],
            [-11.68354569499985, 26.212974752000022],
            [-11.636210083999885, 26.294985250000096],
            [-11.582983356999904, 26.360407614000067],
            [-11.552210042999945, 26.400456849000065],
            [-11.51068802899988, 26.46980662],
            [-11.469708618999931, 26.519596863000046],
            [-11.39891190599991, 26.583081360000094],
            [-11.336900186999856, 26.632897441000026],
            [-11.315867878999939, 26.683643697000022],
            [-11.315867878999939, 26.744208476000054],
            [-11.360309610999906, 26.793042705000047],
            [-11.391573852999898, 26.882908021000063],
            [-11.26264115399988, 26.910219015000067],
            [-11.1493664139999, 26.940501404000102],
            [-11.045858520999957, 26.969801941000057],
            [-10.921835082999877, 27.009825338000027],
            [-10.829075886999874, 27.009825338000027],
            [-10.756780557999917, 27.019592184000075],
            [-10.653272664999918, 27.000058492000065],
            [-10.550281534999925, 26.990291647000035],
            [-10.477986206999958, 26.960035095000094],
            [-10.353962768999878, 26.900478007000018],
            [-10.250454873999956, 26.860428773000038],
            [-10.18844315599992, 26.860428773000038],
            [-10.122038939999868, 26.87996246400006],
            [-10.06586665799989, 26.908281148000057],
            [-10.031708536999929, 26.910219015000067],
            [-9.979928751999864, 26.88972930900009],
            [-9.89936519399987, 26.849680075000023],
            [-9.81686376999994, 26.849680075000023],
            [-9.734362345999926, 26.860428773000038],
            [-9.672350625999883, 26.910219015000067],
            [-9.56884273299994, 26.990291647000035],
            [-9.486315469999852, 27.04987457300011],
            [-9.412056436999961, 27.08796010400006],
            [-9.352008422999859, 27.097726949000034],
            [-9.284622354999925, 27.097726949000034],
            [-9.207469441999876, 27.099690654000042],
            [-9.083446003999882, 27.089923808],
            [-9.000918741999953, 27.089923808],
            [-8.888109089999887, 27.10356638600011],
            [-8.79390295399989, 27.120180359000116],
            [-8.752871866999953, 27.150462749000056],
            [-8.752871866999953, 27.190486146000026],
            [-8.77338741099993, 27.2500690720001],
            [-8.795840819999938, 27.307688294000073],
            [-8.801706094999929, 27.360424092000088],
            [-8.7880118409999, 27.416053772000012],
            [-8.77338741099993, 27.460030416000066],
            [-8.783619343999902, 27.53036204000007],
            [-8.812919880999885, 27.6133543910001],
            [-8.818449258999863, 27.659398092000018],
            [-8.817034779999915, 27.661464011000092],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Congo',
        iso3: 'COG',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.626387166000086, 3.476868998000072],
            [18.6345520430001, 3.449222108000058],
            [18.642406860000023, 3.323829244000081],
            [18.631141398000068, 3.178980204000126],
            [18.621839640000132, 3.156655986000061],
            [18.619669230000056, 3.144770406000134],
            [18.61305464700007, 3.128182272000032],
            [18.597345011000073, 3.114643046000054],
            [18.5621016850001, 3.096814677000097],
            [18.541431112000083, 3.082810364000096],
            [18.528408651000063, 3.064775289000096],
            [18.495335734000065, 2.966073304000076],
            [18.479626098000097, 2.941371969000073],
            [18.475802042000055, 2.931191711000096],
            [18.47177128100006, 2.909229227000125],
            [18.467327108000063, 2.898893942000129],
            [18.449240356000132, 2.873004049000087],
            [18.4251591390001, 2.822154440000077],
            [18.421851847000113, 2.808821920000057],
            [18.418337850000057, 2.781743469000091],
            [18.39322310400013, 2.713685608000105],
            [18.316741984000146, 2.584339498000062],
            [18.313744751000115, 2.575967916000081],
            [18.30351281700004, 2.572557272000068],
            [18.246151978000057, 2.518917135000081],
            [18.23302616400011, 2.502587382000058],
            [18.225171346000053, 2.486464335000065],
            [18.214112589000052, 2.427656556000088],
            [18.20780806500005, 2.407967835000136],
            [18.1991264240001, 2.38910593700011],
            [18.187964314000055, 2.370915833000069],
            [18.174011678000056, 2.336137594000121],
            [18.163779744000095, 2.321048076000125],
            [18.14672652200005, 2.31593210900013],
            [18.142695760000066, 2.305700175000055],
            [18.11861454300012, 2.276968079000142],
            [18.111173137000094, 2.265289205000073],
            [18.072415812000145, 2.160024312000075],
            [18.072415812000145, 2.145193176000049],
            [18.078306926000067, 2.114807434000085],
            [18.08078739500013, 2.084163310000065],
            [18.076033163000147, 1.988484396000061],
            [18.08171757000008, 1.942414856000141],
            [18.081510864000023, 1.926550192000136],
            [18.078306926000067, 1.909290263000045],
            [18.068178345000092, 1.876217347000065],
            [18.06611128700004, 1.858983256000073],
            [18.0736560470001, 1.572334086000097],
            [18.071382284000066, 1.551456808000111],
            [18.012264445000113, 1.421955668000038],
            [18.00668339000009, 1.402396138000114],
            [18.00203251100004, 1.365783386000075],
            [17.966995890000106, 1.253723043000122],
            [17.96337854000012, 1.191452942000097],
            [17.95624719200009, 1.171660868000032],
            [17.91480269400003, 1.102001038000097],
            [17.892478475000075, 1.077403056000108],
            [17.87325484200005, 1.039627584000058],
            [17.866640259000064, 1.016631572000108],
            [17.87821578000009, 0.947178446000038],
            [17.877905721000104, 0.8679068000001],
            [17.907671346000086, 0.740472718000078],
            [17.90756799300007, 0.713084208000041],
            [17.8925818270001, 0.635879618000061],
            [17.893201945000072, 0.607664287000091],
            [17.89929976400012, 0.58327301100006],
            [17.9184200440001, 0.535213929000093],
            [17.933096151000115, 0.527049052000081],
            [17.943638143000072, 0.510822652000073],
            [17.94994266800009, 0.491495666000034],
            [17.95200972500004, 0.474339091000061],
            [17.945498494000077, 0.377290752000093],
            [17.939917440000073, 0.361271057000039],
            [17.85403121000013, 0.241071676000075],
            [17.77537967900014, 0.026407776000056],
            [17.757086222000083, -0.009455667999887],
            [17.716365193000115, -0.195800882999919],
            [17.7136780190001, -0.220915628999947],
            [17.71626184100009, -0.246237079999929],
            [17.740756470000036, -0.346179300999978],
            [17.749541463000128, -0.523429462999943],
            [17.741996704000087, -0.533351338999935],
            [17.7280440670001, -0.553091735999899],
            [17.66417199700004, -0.612726337999902],
            [17.658694296000135, -0.619754332999918],
            [17.654456828000093, -0.62750579899992],
            [17.652493123000056, -0.642181904999902],
            [17.650942830000133, -0.646316018999926],
            [17.647635538000145, -0.649933369999914],
            [17.63585331200005, -0.658511656999849],
            [17.623037557000146, -0.673291117999952],
            [17.60216027900009, -0.688690693999945],
            [17.545863410000038, -0.756491041999936],
            [17.41147424300007, -0.918340758999932],
            [17.38542932100009, -0.942421976999881],
            [17.364965454000128, -0.967226663999924],
            [17.357317342000073, -0.973531188999928],
            [17.33044559700005, -0.986553648999873],
            [17.327655070000105, -0.991721292999969],
            [17.30801802600007, -1.014975687999893],
            [17.297682739000066, -1.021073506999954],
            [17.245386190000147, -1.035852965999965],
            [17.194846639000104, -1.042984313999909],
            [17.17541630100004, -1.048255309999931],
            [17.10865035000009, -1.075643818999879],
            [17.060487915000095, -1.089183043999952],
            [17.028655233000052, -1.094454040999892],
            [17.02255741400009, -1.097037861999894],
            [17.012015421000058, -1.104272562999952],
            [17.005917602000096, -1.106753030999926],
            [17.003127075000123, -1.112850849999887],
            [16.979562622000117, -1.140239359999924],
            [16.940495239000114, -1.174759215999913],
            [16.909179321000096, -1.211139424999899],
            [16.862567179000052, -1.248863219999947],
            [16.83972619600013, -1.26250579799995],
            [16.83321496600007, -1.269017028999926],
            [16.828667440000117, -1.276251729999984],
            [16.81781538900009, -1.304157002999958],
            [16.794664347000094, -1.345498147999905],
            [16.77926477000011, -1.382395120999931],
            [16.762728312, -1.405856220999908],
            [16.725521281000084, -1.479960225999932],
            [16.69255171700013, -1.522955016999916],
            [16.66950402800009, -1.569360452999931],
            [16.65597112900008, -1.590290215999886],
            [16.636224406000053, -1.62083017899991],
            [16.628886352000052, -1.637263284999975],
            [16.623822062000073, -1.653799743999869],
            [16.622478475000094, -1.665168557999948],
            [16.623098592000076, -1.699171650999901],
            [16.617207479000058, -1.728730569999925],
            [16.604185018000123, -1.754052021999911],
            [16.524970535000108, -1.858534921999961],
            [16.522536255000148, -1.861745706999969],
            [16.517161906000098, -1.87373463899992],
            [16.513957967000124, -1.887377216999937],
            [16.50775679500012, -1.890271097999914],
            [16.490290161000075, -1.903603616999945],
            [16.474787232000068, -1.910114846999917],
            [16.470033, -1.912698668999909],
            [16.460937947000104, -1.920863544999932],
            [16.44564172400007, -1.940500588999967],
            [16.382596476000117, -2.002202249999925],
            [16.340221802000116, -2.034138284999912],
            [16.284411255000037, -2.087571715999928],
            [16.256092570000135, -2.106795348999952],
            [16.231287883000107, -2.129016214999893],
            [16.206793253000058, -2.160952249999866],
            [16.194597615000134, -2.182036234999899],
            [16.18736291500008, -2.204567157999918],
            [16.1886031490001, -2.227718200999902],
            [16.190050090000113, -2.235469664999911],
            [16.18994673600008, -2.241877542999944],
            [16.176924276000136, -2.28683603899988],
            [16.174857218000085, -2.303062438999888],
            [16.178267863000116, -2.318462015999955],
            [16.187466267000104, -2.332311298999926],
            [16.189843383000067, -2.337478942999923],
            [16.191703735000146, -2.346884053999887],
            [16.19232385200013, -2.395149841999896],
            [16.22560347500007, -2.635238545999925],
            [16.204519491000042, -2.782723082999908],
            [16.180851685000107, -2.854139912999912],
            [16.178164510000073, -2.868092549999901],
            [16.177027629000065, -2.8824585979999],
            [16.183981404000065, -2.940449251999951],
            [16.188293091000048, -2.976406351999927],
            [16.18446903500009, -3.02611907999993],
            [16.189843383000067, -3.082343036999916],
            [16.185709269000114, -3.136396585999904],
            [16.18994673600008, -3.153036396999923],
            [16.199248494000102, -3.171846618999936],
            [16.199455200000074, -3.194790954999874],
            [16.193357381000112, -3.238405862999912],
            [16.19862837700012, -3.259489846999941],
            [16.210410603000128, -3.271065368999899],
            [16.22208947700011, -3.27912689199988],
            [16.227463827000065, -3.289875589999909],
            [16.22560347500007, -3.313233336999943],
            [16.220745890000046, -3.331733499999885],
            [16.20772342900011, -3.361912535999878],
            [16.15842411300011, -3.44728200299997],
            [16.13785689300002, -3.500715432999897],
            [16.115532674000065, -3.54422698899991],
            [16.053314249000067, -3.619984638999895],
            [16.012696573000113, -3.702253519999942],
            [16.005255167000087, -3.72478444399988],
            [15.991095826000048, -3.738943786999911],
            [15.974249309000072, -3.786486103999934],
            [15.943140096000036, -3.840746357999876],
            [15.936112101000106, -3.848497822999974],
            [15.93032434100013, -3.858626402999931],
            [15.912134237000089, -3.917434183999916],
            [15.888019273000111, -3.940522978999908],
            [15.88298872900009, -3.945339456999903],
            [15.84423140500013, -3.965596618999896],
            [15.799996378000117, -3.978825784999898],
            [15.755141235000053, -3.985647074999946],
            [15.711216267000111, -3.992158304999919],
            [15.566832316000074, -4.038046976999894],
            [15.549055623000129, -4.046211852999903],
            [15.533759399000076, -4.057994079999901],
            [15.521150350000056, -4.07680430099991],
            [15.490351196000091, -4.175196227999947],
            [15.484976847000041, -4.183877868999915],
            [15.462859334000115, -4.20713226299992],
            [15.458931925000059, -4.21385019899995],
            [15.450250285000095, -4.217260843999966],
            [15.42544559700005, -4.230179951999986],
            [15.386584920000104, -4.244339293999928],
            [15.275273885000047, -4.30035654699995],
            [15.255740194000055, -4.313068948999913],
            [15.228351684000103, -4.32485117599991],
            [15.203960409000075, -4.339010518999956],
            [15.193418416000014, -4.358750914999916],
            [15.188044068000067, -4.37218678799988],
            [15.150677777000112, -4.425150932999969],
            [15.097920370000082, -4.499930927999884],
            [15.076112915000039, -4.520084736999948],
            [15.022782837000136, -4.547059834999885],
            [15.014617961000027, -4.558015237999953],
            [15.00821008300008, -4.571037698999902],
            [14.931005493000015, -4.646898701999916],
            [14.849046671000053, -4.783737893999984],
            [14.841398559000083, -4.800170999999864],
            [14.831166626000083, -4.815053811999903],
            [14.815456991000104, -4.827972920999912],
            [14.76843143700006, -4.848230081999915],
            [14.702182251000039, -4.889571227999852],
            [14.672726684000054, -4.899906514999955],
            [14.634486125000137, -4.903627217999968],
            [14.623324015000037, -4.899493102999941],
            [14.592111450000033, -4.880579528999903],
            [14.579605754000056, -4.876342060999946],
            [14.575058227000113, -4.87365488699993],
            [14.56689335100009, -4.860529072999952],
            [14.562139120000097, -4.855878193999985],
            [14.553870891000145, -4.855154723999902],
            [14.532476847000027, -4.856188252999885],
            [14.528032674000116, -4.852157490999971],
            [14.519867797000103, -4.841305439999928],
            [14.501470988000108, -4.84068532299996],
            [14.481937296000098, -4.845852965999967],
            [14.470051717000075, -4.852157490999971],
            [14.449484497000071, -4.873964944999912],
            [14.437288859000063, -4.880166116999902],
            [14.418168579000081, -4.883163349999904],
            [14.400701945000037, -4.886263935999949],
            [14.39646447700008, -4.855878193999985],
            [14.41258752400006, -4.778156839999966],
            [14.408763468000103, -4.767821552999877],
            [14.40369917800004, -4.758829853999927],
            [14.399668416000054, -4.749321390999938],
            [14.399048299000071, -4.737539163999941],
            [14.401528768000048, -4.728134052999891],
            [14.409176880000132, -4.710564066999908],
            [14.410933878, -4.701055602999929],
            [14.406903117000098, -4.67604420999993],
            [14.395844361000115, -4.660127868999908],
            [14.380961548000073, -4.646175231999919],
            [14.365768677000034, -4.627261657999966],
            [14.357500448000081, -4.589124450999918],
            [14.349955689000126, -4.566903584999878],
            [14.350782511000148, -4.559048766999936],
            [14.358947388000075, -4.544579365999908],
            [14.374760376000069, -4.530213317999909],
            [14.41258752400006, -4.51450368199994],
            [14.424576456000125, -4.502308043999932],
            [14.435738566000055, -4.486701761999896],
            [14.452481730000102, -4.467994893999901],
            [14.466537719000115, -4.44804778999989],
            [14.469741659000078, -4.429340921999909],
            [14.463230428000116, -4.42262298599988],
            [14.4286072190001, -4.400402119999939],
            [14.40907352700009, -4.37756113699993],
            [14.392743774000081, -4.352756448999898],
            [14.386025838000137, -4.338287047999955],
            [14.385715779000066, -4.332912699999909],
            [14.389126424000096, -4.327538349999941],
            [14.393467245000068, -4.313172301999941],
            [14.395224243000143, -4.30035654699995],
            [14.395327596000072, -4.289711201999864],
            [14.392847127000095, -4.281753030999909],
            [14.38705936600013, -4.277102151999941],
            [14.368559204000093, -4.278445738999906],
            [14.325461059000077, -4.301803486999944],
            [14.279985800000134, -4.31275889099993],
            [14.259625285000084, -4.326918232999972],
            [14.222211548000132, -4.359784443999899],
            [14.18469445700012, -4.377457782999912],
            [14.146350545000104, -4.389860127999967],
            [14.058397258000127, -4.400505472999967],
            [14.021086873000087, -4.415388284999906],
            [13.991631307000091, -4.455075784999892],
            [13.989874308000111, -4.457969664999979],
            [13.98770389800012, -4.460140075999959],
            [13.971787557000084, -4.471612243999886],
            [13.954941040000108, -4.491869404999889],
            [13.94450240000009, -4.498070576999879],
            [13.934580526000076, -4.49848398799989],
            [13.90543582500004, -4.490099896999951],
            [13.904401489000094, -4.489802347999927],
            [13.87628951000005, -4.491662698999932],
            [13.867091105000043, -4.489285582999898],
            [13.856135701000056, -4.479673766999966],
            [13.842079712000043, -4.45342213899994],
            [13.832881307000065, -4.441226500999932],
            [13.810453735000067, -4.426653746999875],
            [13.789989868000106, -4.424586690999917],
            [13.726531210000047, -4.446704202999925],
            [13.714955688000117, -4.453008727999929],
            [13.71102828000005, -4.464480895999941],
            [13.721776978000065, -4.561012471999973],
            [13.71815962800008, -4.580339456999923],
            [13.702605021000068, -4.620750426999905],
            [13.699091023000108, -4.642661233999959],
            [13.712475220000044, -4.685656025999947],
            [13.705860636000125, -4.69433766599991],
            [13.6983675540001, -4.693510843999974],
            [13.690099325000062, -4.691133727999926],
            [13.68193444800005, -4.695371194999979],
            [13.677800334000011, -4.706326598999865],
            [13.68059086100007, -4.72472340799996],
            [13.675319865000034, -4.731751402999876],
            [13.666534871000067, -4.732681578999916],
            [13.643693888000143, -4.726273701999972],
            [13.633978719000112, -4.725653583999915],
            [13.613101440000037, -4.739192809999892],
            [13.591397339000139, -4.779397073999917],
            [13.579859863000138, -4.78303137899988],
            [13.57072676600012, -4.785908304999893],
            [13.558634481000126, -4.780430602999985],
            [13.53889408300006, -4.759966735999939],
            [13.52618168100011, -4.754282327999888],
            [13.5147095130001, -4.755935973999939],
            [13.482256713000083, -4.774849547999878],
            [13.492385295000133, -4.78353118899993],
            [13.496416056000044, -4.792109475999965],
            [13.493522176000056, -4.799654235999924],
            [13.482256713000083, -4.805545348999914],
            [13.43078698700009, -4.843372497999894],
            [13.403191772000099, -4.876858825999904],
            [13.392649780000028, -4.885333760999899],
            [13.371359090000055, -4.841718851999943],
            [13.364124389000096, -4.806888936999883],
            [13.358750041000121, -4.794796650999899],
            [13.349344930000058, -4.785598245999907],
            [13.334565470000143, -4.777536721999908],
            [13.2740006920001, -4.755832620999911],
            [13.255810588000145, -4.74394704099997],
            [13.208785034000073, -4.703122660999981],
            [13.18211999500005, -4.686069436999958],
            [13.172404825000086, -4.676147561999954],
            [13.160002482000039, -4.643384703999871],
            [13.14212243600008, -4.617339781999888],
            [13.13406091300007, -4.602353616999906],
            [13.112356812000087, -4.57692881299991],
            [13.087965535000137, -4.579512633999911],
            [13.071532430000076, -4.601630146999909],
            [13.073702840000067, -4.635323180999961],
            [13.027194051000038, -4.612172138999881],
            [12.961564982000112, -4.533830667999894],
            [12.921980835000056, -4.502308043999932],
            [12.902447144000035, -4.480190531999924],
            [12.884463745000062, -4.432131448999954],
            [12.86989099100009, -4.411977640999893],
            [12.85428470900007, -4.403089294999873],
            [12.84229577700009, -4.404329528999909],
            [12.830306844000035, -4.40970387699987],
            [12.814803914000038, -4.412907816999933],
            [12.801057984000096, -4.410013935999942],
            [12.782655684000076, -4.40007075799987],
            [12.775426473000039, -4.396164651999896],
            [12.761680542000107, -4.391203714999932],
            [12.737909383000044, -4.404949645999878],
            [12.726540568000132, -4.42799733399994],
            [12.718479044000048, -4.451871845999918],
            [12.704939819000089, -4.467994893999901],
            [12.686853068000062, -4.478330179999915],
            [12.67052331500011, -4.491352640999949],
            [12.65657067900014, -4.507372333999911],
            [12.634866577000139, -4.547679951999953],
            [12.623807821000128, -4.559255472],
            [12.608098185000074, -4.565043232999884],
            [12.497200562000046, -4.585300394999877],
            [12.429091024000115, -4.607521259999913],
            [12.414104859000048, -4.608864846999978],
            [12.38702640800011, -4.605454203999955],
            [12.377621297000132, -4.61940683999994],
            [12.37886153100007, -4.662298278999899],
            [12.374107299000087, -4.683175556999871],
            [12.332352743000058, -4.765857848999929],
            [12.321914103000097, -4.778156839999966],
            [12.307651407000037, -4.78363454099987],
            [12.273751668000017, -4.787148538999915],
            [12.258558797000092, -4.7907658889999],
            [12.244089396000078, -4.796346943999922],
            [12.23520104900004, -4.803995055999906],
            [12.222592000000105, -4.780637308999943],
            [12.213496948000056, -4.769165139999927],
            [12.204091837000107, -4.763480732999895],
            [12.192206258000056, -4.763480732999895],
            [12.187555379000088, -4.768028258999919],
            [12.157169637000038, -4.870554299999881],
            [12.130814657000087, -4.912928975999904],
            [12.01807177200007, -5.008599787999941],
            [12.009607691000042, -5.019630835999919],
            [11.994313998000052, -5.005791924999926],
            [11.980479363000086, -4.989434502999927],
            [11.957855665000068, -4.951918226999908],
            [11.920258009000065, -4.906426690999922],
            [11.89572791200004, -4.882644647999939],
            [11.886241082000083, -4.855238539999959],
            [11.83058609200009, -4.797021810999922],
            [11.82021023100009, -4.78479997799991],
            [11.81926603900007, -4.779159595999943],
            [11.824069031000079, -4.772359804999951],
            [11.829960630000073, -4.773532557999943],
            [11.843318628000077, -4.788782951999906],
            [11.848424341000054, -4.786043506999931],
            [11.853137400000037, -4.773918075999916],
            [11.850366514000086, -4.752839362999907],
            [11.824066602000073, -4.718682549999926],
            [11.781633493000072, -4.68040908699993],
            [11.776905990000046, -4.66787809099992],
            [11.777687864000086, -4.657700805999923],
            [11.801320592000081, -4.657938397999942],
            [11.820162917000061, -4.637281174999941],
            [11.824624412000048, -4.614767169999936],
            [11.806408668000074, -4.577117894999958],
            [11.69298234200005, -4.463491196999939],
            [11.589121941000087, -4.37468840899993],
            [11.497894727000073, -4.294040622999944],
            [11.450587436000092, -4.264729609999961],
            [11.401403362000053, -4.22136637899996],
            [11.38249759200005, -4.191013278999947],
            [11.377696160000085, -4.184665622999944],
            [11.364756707000083, -4.162774346999925],
            [11.362071160000085, -4.153090101999908],
            [11.363129102000073, -4.131117445999905],
            [11.362152540000068, -4.119805596999925],
            [11.358246290000068, -4.111911716999941],
            [11.270180621000065, -4.041725062999944],
            [11.172424592000084, -3.97747374699992],
            [11.139094570000054, -3.953100456999948],
            [11.114016304109821, -3.936856189796041],
            [11.12962271300006, -3.907856984999924],
            [11.196091349000113, -3.728815205999865],
            [11.212524455000079, -3.697292581999903],
            [11.238569377000147, -3.675071715999962],
            [11.27267582200011, -3.65295420299995],
            [11.30244144700012, -3.628459573999905],
            [11.334687540000061, -3.608615823999912],
            [11.375821981000058, -3.60034759499996],
            [11.41395918800012, -3.587635191999908],
            [11.436283407000076, -3.559006448999924],
            [11.454990275000057, -3.528207294999959],
            [11.482585490000048, -3.509293721999924],
            [11.53271162900009, -3.516528421999894],
            [11.569815307000056, -3.54495045999991],
            [11.649190307000111, -3.673314717999887],
            [11.665933471000073, -3.691401468999899],
            [11.687637573000075, -3.698739522999901],
            [11.74210453200007, -3.691711527999885],
            [11.762154989000123, -3.693985290999905],
            [11.81972253400005, -3.710418395999866],
            [11.83832605000012, -3.710935159999906],
            [11.840807756000089, -3.709988529999919],
            [11.85837650600007, -3.703287047999922],
            [11.879977254000039, -3.687164000999942],
            [11.89765059400014, -3.666080016999913],
            [11.905505412000082, -3.643549092999905],
            [11.898477417000066, -3.622361754999943],
            [11.879253784000127, -3.612026468999929],
            [11.855585978000107, -3.604378355999955],
            [11.834915405000089, -3.592079365999908],
            [11.824993530000086, -3.571202086999932],
            [11.827784057000144, -3.548051045999941],
            [11.884834839000064, -3.413278909999931],
            [11.898374064000024, -3.389197692999886],
            [11.94147220900004, -3.356951598999927],
            [11.954908081000099, -3.335454202999884],
            [11.944366089000113, -3.303208109999929],
            [11.905712117000121, -3.285121357999913],
            [11.858273153000141, -3.272098896999879],
            [11.82189294400004, -3.254838967999973],
            [11.781585327000101, -3.221662698999879],
            [11.760501343000072, -3.209053649999944],
            [11.703863973000068, -3.18538584399991],
            [11.696112508000084, -3.179598082999931],
            [11.687534220000146, -3.171019795999911],
            [11.68567386900014, -3.167195739999968],
            [11.687327515000078, -3.161511331999918],
            [11.688257691000047, -3.092264912999909],
            [11.693218628000096, -3.074694925999935],
            [11.706447795000088, -3.049890238999893],
            [11.716886433000127, -3.043585712999885],
            [11.730632365000048, -3.044722594999897],
            [11.753680054000114, -3.042345478999948],
            [11.778381388000128, -3.027152607999923],
            [11.778381388000128, -3.00565521199988],
            [11.763705281000057, -2.982607523999917],
            [11.687637573000075, -2.901785583999953],
            [11.6531177170001, -2.851659443999935],
            [11.636787964000064, -2.833262633999936],
            [11.616840861000128, -2.82675140299996],
            [11.588418823000012, -2.835433044999931],
            [11.5479045000001, -2.863855081999944],
            [11.530747925000128, -2.866748962999935],
            [11.525580282000135, -2.843287861999954],
            [11.535565759000065, -2.804995726999962],
            [11.537465861000072, -2.797709247999876],
            [11.61032963000008, -2.678853454999881],
            [11.619528036000077, -2.65353200299991],
            [11.624385620000083, -2.632758076999949],
            [11.624385620000083, -2.611984150999916],
            [11.619011271000119, -2.586455992999973],
            [11.609606160000084, -2.564028421999893],
            [11.584284708000098, -2.523617451999911],
            [11.576533244000075, -2.502533467999882],
            [11.576119833000064, -2.485066832999934],
            [11.583354533000119, -2.429669697999969],
            [11.579737183000049, -2.407655537999901],
            [11.558239787000105, -2.349364522999863],
            [11.566197957000071, -2.329727477999924],
            [11.568368367000062, -2.329107360999956],
            [11.605368693000116, -2.330347594999893],
            [11.655908244000045, -2.345643818999946],
            [11.66965417500009, -2.352671813999947],
            [11.675855346000077, -2.360423278999875],
            [11.67988610900008, -2.368794860999941],
            [11.687534220000146, -2.377683206999947],
            [11.721330607000112, -2.404141539999941],
            [11.739520711000068, -2.413753356999948],
            [11.756057170000076, -2.415096943999913],
            [11.772696981000081, -2.405381774999881],
            [11.806596720000101, -2.374169209999906],
            [11.828817586000127, -2.365280863999885],
            [11.864887736000128, -2.358149515999941],
            [11.90705570500009, -2.344610290999867],
            [11.938371623000108, -2.329107360999956],
            [11.948706909000094, -2.335205179999917],
            [11.96679366100011, -2.348537698999934],
            [12.000693400000046, -2.390602314999867],
            [12.031285848000039, -2.411582945999953],
            [12.062291707000071, -2.414993590999899],
            [12.459270060000023, -2.329934182999878],
            [12.44790124500014, -2.307920022999895],
            [12.455135946000098, -2.275570576999911],
            [12.468571818000072, -2.241154072999947],
            [12.475496460000045, -2.212421976999863],
            [12.46836511300009, -2.171080830999912],
            [12.470225464000094, -2.156301370999898],
            [12.47735681100005, -2.141108499999874],
            [12.495340210000023, -2.112789814999886],
            [12.499784383000133, -2.095529886999898],
            [12.460820353000145, -2.077856546999982],
            [12.440046427000112, -2.045817158999881],
            [12.431468140000078, -2.005406188999899],
            [12.423096557000093, -1.897609150999912],
            [12.42692061300005, -1.884069925999938],
            [12.438082722000075, -1.886653747999929],
            [12.45000933300011, -1.899298347999974],
            [12.468985229000083, -1.919416604999938],
            [12.486555217000046, -1.924894307999921],
            [12.499474324000062, -1.917866312999919],
            [12.503815145000118, -1.907737731999958],
            [12.504538615000115, -1.896885680999915],
            [12.506295613000106, -1.888204039999948],
            [12.512393432000067, -1.8754916379999],
            [12.517354370000106, -1.868980406999938],
            [12.523452189000068, -1.863295999999892],
            [12.572441447000074, -1.83042978899995],
            [12.583190145000088, -1.826502379999894],
            [12.632386109000066, -1.825158792999929],
            [12.67496748900004, -1.842832131999927],
            [12.741014228000068, -1.890672439999904],
            [12.745454142000085, -1.893888447999899],
            [12.787725463000072, -1.907531025999916],
            [12.804571980000048, -1.919106546999956],
            [12.816147502000092, -1.943497822999888],
            [12.838161661000072, -2.016051533999899],
            [12.84715336100004, -2.037238870999943],
            [12.85294112200009, -2.044576924999944],
            [12.868547403000036, -2.059873147999909],
            [12.87299157700005, -2.065867613999927],
            [12.876918986000106, -2.088708596999936],
            [12.875161987000126, -2.089122008999951],
            [12.875161987000126, -2.093772887999918],
            [12.874128458000143, -2.09976735499994],
            [12.876298869000038, -2.104934997999948],
            [12.895109091000052, -2.109792581999955],
            [12.89448897300008, -2.115580342999934],
            [12.890561564000109, -2.122194925999935],
            [12.888701212000115, -2.126949156999927],
            [12.884463745000062, -2.134493915999968],
            [12.882706746000082, -2.140798441999891],
            [12.885083862000045, -2.147413024999892],
            [12.898209676000079, -2.160228779999969],
            [12.90203373200012, -2.16725677499997],
            [12.902757202000117, -2.177592060999885],
            [12.907098022000099, -2.195368753999915],
            [12.921360717000084, -2.194851988999886],
            [12.945648640000087, -2.18244964599991],
            [12.954330282000058, -2.190924580999905],
            [12.973037150000039, -2.221517028999926],
            [12.982442261000074, -2.232989196999938],
            [12.987506551000138, -2.259964293999872],
            [12.990193725000097, -2.268025817999956],
            [12.997325073000127, -2.275673928999936],
            [13.003422892000088, -2.275467223999968],
            [13.00817712400007, -2.276500752999951],
            [13.010657592000143, -2.287766213999916],
            [13.002286010000063, -2.29665456099994],
            [12.996704956000144, -2.304819437999953],
            [12.994637899000082, -2.31494801799991],
            [12.993914428000096, -2.323526305999934],
            [12.991123901000037, -2.332311298999926],
            [12.987093140000127, -2.340682880999907],
            [12.982442261000074, -2.347710875999908],
            [12.971280152000134, -2.357115986999958],
            [12.966112508000037, -2.366417744999893],
            [12.96900638800011, -2.372412210999926],
            [12.982442261000074, -2.371688740999929],
            [12.994008157000025, -2.360122844999879],
            [13.012104533000127, -2.342026467999872],
            [13.025023641000132, -2.338202412999919],
            [13.049828329000093, -2.34264658599993],
            [13.114320516000106, -2.371895445999883],
            [13.135197795000096, -2.37695973699995],
            [13.14615319800015, -2.374685973999931],
            [13.165273478000046, -2.363523863999902],
            [13.1768489990001, -2.361973571999982],
            [13.18666752100006, -2.364143981999874],
            [13.361023804000126, -2.428842874999944],
            [13.378800497000071, -2.430909931999921],
            [13.398024130000096, -2.426155699999924],
            [13.419728231000079, -2.429669697999969],
            [13.4248958740001, -2.429773050999913],
            [13.438951864000103, -2.425432230999931],
            [13.445359741000061, -2.427085875999879],
            [13.453731323000028, -2.439384866999916],
            [13.45889896600005, -2.441038512999867],
            [13.46944095900011, -2.435044046999934],
            [13.47398848500012, -2.426982523999939],
            [13.476779012000094, -2.417680764999915],
            [13.482256713000083, -2.408068948999912],
            [13.492178589000076, -2.398457132999894],
            [13.524631389000092, -2.3760295619999],
            [13.533106323000084, -2.367657978999929],
            [13.547679077000055, -2.349364522999863],
            [13.557600952000143, -2.340476175999939],
            [13.56948653200007, -2.334481708999917],
            [13.593361044000062, -2.326833597999936],
            [13.60338627100009, -2.320012307999974],
            [13.607830445000104, -2.311123961999968],
            [13.610724324000074, -2.28993662499991],
            [13.617442261000122, -2.27960133899991],
            [13.693509969000075, -2.205910745999887],
            [13.701571492000085, -2.194748635999943],
            [13.705240519000057, -2.184309997999918],
            [13.706790812000094, -2.16456959999995],
            [13.70947798600011, -2.153510843999939],
            [13.720019979000085, -2.133563740999918],
            [13.740897257000142, -2.102454528999971],
            [13.743171020000062, -2.097080178999917],
            [13.746374959000036, -2.098320413999943],
            [13.756916952000097, -2.105865173999902],
            [13.770662882000039, -2.11909433999989],
            [13.782755167000118, -2.138007913999928],
            [13.7914368080001, -2.159091898999861],
            [13.800531860000149, -2.200433043999894],
            [13.823269491000133, -2.246838480999898],
            [13.835568481000081, -2.265235290999897],
            [13.853861938000136, -2.283838805999949],
            [13.86057987500007, -2.293657327999924],
            [13.863887166000069, -2.321459247999968],
            [13.871638631000081, -2.328797302999874],
            [13.882180624000057, -2.333861592999938],
            [13.892515910000043, -2.341199645999936],
            [13.906158487000141, -2.359803160999903],
            [13.901921020000117, -2.366314391999964],
            [13.890035441000066, -2.373652445999952],
            [13.875876098000049, -2.403831481999958],
            [13.855102173000091, -2.414270120999987],
            [13.847660767000065, -2.423055114999968],
            [13.846937296000078, -2.461605732999956],
            [13.84580041500007, -2.46656667099991],
            [13.862130168000107, -2.48093271899991],
            [13.884971151000087, -2.48847747799995],
            [13.909465779000072, -2.489717711999987],
            [13.930446411000048, -2.48537689199992],
            [13.947706339000149, -2.474938252999976],
            [13.95731815600007, -2.470597431999906],
            [13.967033325000102, -2.470597431999906],
            [13.976231730000109, -2.477315368999925],
            [13.97922896300011, -2.495608825999895],
            [13.985636840000069, -2.501499938999899],
            [13.993284953000028, -2.501603291999928],
            [14.039276978000117, -2.487237243999914],
            [14.045581502000033, -2.486100361999917],
            [14.055606730000079, -2.486927184999928],
            [14.071006307000061, -2.495815530999948],
            [14.080928181000047, -2.499949644999973],
            [14.090023234000114, -2.498606057999908],
            [14.096017700000061, -2.491061298999867],
            [14.100553460000071, -2.478064601999918],
            [14.106766398000076, -2.460262145999891],
            [14.115241333000057, -2.451373798999967],
            [14.124853149000074, -2.443829039999926],
            [14.13188114400009, -2.435147399999963],
            [14.13146773200009, -2.408895771999937],
            [14.136015259000118, -2.39876719199988],
            [14.144180135000028, -2.390188902999853],
            [14.163300415000037, -2.373962503999849],
            [14.172395467000086, -2.367864684999887],
            [14.18231734200009, -2.363317158999948],
            [14.230066365000056, -2.352155049999922],
            [14.234407186000055, -2.354945576999881],
            [14.226965780000114, -2.323112894999923],
            [14.151208130000043, -2.259034118999921],
            [14.14800419100007, -2.224824319999925],
            [14.161543416000143, -2.214282328999957],
            [14.195856568000067, -2.201776630999859],
            [14.209189087000084, -2.187203877999906],
            [14.209395793000056, -2.179865823999904],
            [14.20319462100008, -2.161985778999849],
            [14.204331502000088, -2.152167256999888],
            [14.209705851000137, -2.147413024999892],
            [14.226965780000114, -2.141315205999931],
            [14.233787068000083, -2.134493915999968],
            [14.238437947000136, -2.120231221999902],
            [14.244019002000073, -2.067521260999882],
            [14.25063358500006, -2.047780862999915],
            [14.251667114000043, -2.037858987999925],
            [14.246809530000121, -2.029384052999916],
            [14.238644653000108, -2.023389586999897],
            [14.233477010000087, -2.018221943999976],
            [14.232856892000115, -2.0120207719999],
            [14.238127889000054, -2.002615660999936],
            [14.237611124000125, -1.991143492999925],
            [14.240091593000102, -1.982255146999918],
            [14.245052531000056, -1.974813740999892],
            [14.252183878000068, -1.967579039999919],
            [14.36857050200004, -1.922120271999901],
            [14.370729614000084, -1.921276956999947],
            [14.39729130100011, -1.906807555999919],
            [14.404526001000079, -1.893061624999888],
            [14.39687788900008, -1.849446715999932],
            [14.397498006000149, -1.840971780999922],
            [14.40359582500011, -1.815236917999925],
            [14.40669641100007, -1.735551859999887],
            [14.413104289000103, -1.713951110999915],
            [14.425196574000097, -1.700515237999866],
            [14.448761027000074, -1.686252542999895],
            [14.441112915000105, -1.679637959999894],
            [14.420028931000076, -1.676123961999934],
            [14.402975708000042, -1.670852965999899],
            [14.390883422000059, -1.630338642999988],
            [14.37145308400008, -1.619486591999944],
            [14.364838501000094, -1.612045185999918],
            [14.373830200000043, -1.604087014999962],
            [14.39429406700009, -1.596852314999893],
            [14.40369917800004, -1.592201436999929],
            [14.413207642000117, -1.585276793999952],
            [14.419925578000061, -1.575148212999906],
            [14.423956340000132, -1.563572692999855],
            [14.43036421700009, -1.554891051999988],
            [14.463127075000102, -1.548689880999916],
            [14.462713664000091, -1.533600361999916],
            [14.451551554000048, -1.515616962999928],
            [14.438425741000088, -1.502594501999894],
            [14.451034790000108, -1.473655699999924],
            [14.452688436000045, -1.449574482999878],
            [14.456305786000144, -1.440169372999918],
            [14.467881307000084, -1.429007262999988],
            [14.480593709000033, -1.420842386999965],
            [14.487725057000063, -1.409370218999953],
            [14.48214400200007, -1.388596292999907],
            [14.447004028, -1.365341897999897],
            [14.432327922000127, -1.350149026999958],
            [14.426333455000105, -1.331028746999962],
            [14.429123982000135, -1.319969990999965],
            [14.436048625000126, -1.312735290999896],
            [14.444316854000078, -1.306327412999863],
            [14.451551554000048, -1.298162536999939],
            [14.45713260900007, -1.287620543999878],
            [14.460749959000054, -1.278008727999875],
            [14.464780721000125, -1.255581155999963],
            [14.465814250000108, -1.224368591999976],
            [14.464160604000085, -1.215376891999938],
            [14.456409139000073, -1.202457782999929],
            [14.439434821000077, -1.185733087999907],
            [14.435325154000054, -1.1816838579999],
            [14.428297160000113, -1.169488219999977],
            [14.427987101000042, -1.160909931999939],
            [14.433568156000149, -1.143650003999952],
            [14.434394979000075, -1.135071716999931],
            [14.430984334000073, -1.123392842999948],
            [14.420338989000072, -1.101792093999975],
            [14.391813598000113, -1.023347269999874],
            [14.392020304000084, -1.008981220999956],
            [14.402562296000042, -0.987690530999885],
            [14.407523234000081, -0.94448903299994],
            [14.412794230000117, -0.921544697999906],
            [14.42819380600011, -0.896946715999931],
            [14.445867147000087, -0.877516377999939],
            [14.45713260900007, -0.856122333999934],
            [14.452895142000102, -0.82573659199997],
            [14.446177205000083, -0.800311787999874],
            [14.445970499000026, -0.775713805999885],
            [14.451551554000048, -0.751219176999925],
            [14.492169230000087, -0.663369241999959],
            [14.498990519000131, -0.630916441999943],
            [14.489998820000096, -0.600944111999908],
            [14.466537719000115, -0.552678324999889],
            [14.454238729000082, -0.539552510999926],
            [14.414447876000054, -0.512164000999888],
            [14.39233036300007, -0.482398375999892],
            [14.35863732900009, -0.461314391999863],
            [14.32060347500007, -0.444467874999887],
            [14.292698201000093, -0.436406350999988],
            [14.27554162600012, -0.439093525999922],
            [14.260038696, -0.44643157899992],
            [14.24474247200007, -0.451599222999917],
            [14.228516073000037, -0.44777516699989],
            [14.210222616000067, -0.440333759999959],
            [14.193066040000105, -0.440437112999888],
            [14.176529582000114, -0.446121520999938],
            [14.159683065000138, -0.455113219999888],
            [14.157926066000073, -0.417699482999907],
            [14.150588012000071, -0.376461689999914],
            [14.138289022000038, -0.336360778999918],
            [14.121442505000061, -0.302150980999912],
            [14.095397583000079, -0.276622822999883],
            [14.058810669000138, -0.258846129999952],
            [14.018709758000057, -0.252644958999966],
            [13.98232954900007, -0.262256774999884],
            [13.9750948490001, -0.252541605999937],
            [13.967033325000102, -0.245823668999918],
            [13.95731815600007, -0.241999612999962],
            [13.921558064000038, -0.237865497999948],
            [13.913806600000044, -0.240552672999883],
            [13.909982544000087, -0.247167255999969],
            [13.907295369000082, -0.254401956999942],
            [13.903057902000114, -0.258846129999952],
            [13.889828735000037, -0.263703714999878],
            [13.883420858000079, -0.264943948999914],
            [13.877426392000046, -0.260499775999989],
            [13.8312276610001, -0.205412699999926],
            [13.832157837000068, -0.177094013999934],
            [13.84269982900011, -0.152289325999988],
            [13.888053549000063, -0.092088146999913],
            [13.900474081000112, -0.075601500999952],
            [13.910706014000084, -0.06588633199992],
            [13.921144653000027, -0.052967223999914],
            [13.920111125000062, -0.042425230999939],
            [13.91494348200004, -0.031263121999913],
            [13.912979777000118, -0.016587015999932],
            [13.917217245000074, -0.006665140999928],
            [13.931376586000113, 0.011628316000042],
            [13.932926880000139, 0.022066956000074],
            [13.925072062000083, 0.034365946000108],
            [13.913083130000132, 0.036536357000017],
            [13.901404257000081, 0.036846415000085],
            [13.894893025000101, 0.043667704000143],
            [13.890655559000038, 0.115911357000073],
            [13.885901327000056, 0.140302633000104],
            [13.87618615700012, 0.171308492000122],
            [13.87122522000007, 0.196423239000055],
            [13.875772745000091, 0.220297750000043],
            [13.909775838000144, 0.270940653000096],
            [13.945225871000076, 0.350419006000095],
            [13.966516561000049, 0.373053284000136],
            [14.040413859000125, 0.413774313000104],
            [14.059120727000106, 0.435271709000048],
            [14.063048137000095, 0.455942281000063],
            [14.056846964000101, 0.476406149000113],
            [14.045581502000033, 0.497283427000099],
            [14.075967244000083, 0.539451396000061],
            [14.125473266000142, 0.546169332000076],
            [14.181593872000093, 0.539864808000061],
            [14.231823365000139, 0.542551982000091],
            [14.245259237000084, 0.547719625000099],
            [14.250943644000131, 0.551853739000123],
            [14.254664348000063, 0.557124736000063],
            [14.328768351000093, 0.621203512000065],
            [14.33538293400008, 0.64259755500008],
            [14.3383801680001, 0.693912252000118],
            [14.36731897000007, 0.735511780000124],
            [14.41341434700007, 0.775044251000068],
            [14.447624146000067, 0.81623036700006],
            [14.44100956200009, 0.862790833000105],
            [14.43759891700006, 0.875141500000069],
            [14.4451436760001, 0.883254700000066],
            [14.457029256000027, 0.890334371000094],
            [14.466227661000119, 0.899636129000029],
            [14.468088013000056, 0.913227031000105],
            [14.460439900000068, 0.921236878000087],
            [14.436565389000066, 0.933277486000065],
            [14.417548462000099, 0.950589091000069],
            [14.400805298000051, 0.970329489000036],
            [14.386749308000049, 0.992240296000077],
            [14.375690552000037, 1.015598043000125],
            [14.360084269000083, 1.066757710000033],
            [14.34644169100008, 1.087118225000054],
            [14.298485962000143, 1.10923573900007],
            [14.282879679000104, 1.130113017000042],
            [14.274714803000109, 1.155641174000081],
            [14.275748332000092, 1.23108876600007],
            [14.273061157000143, 1.257237040000078],
            [14.2581783440001, 1.319662170000043],
            [14.252183878000068, 1.330824280000073],
            [14.241435181000071, 1.339195862000054],
            [14.230066365000056, 1.343950093000046],
            [14.22148807800005, 1.349479472000041],
            [14.219938873000103, 1.355017878000083],
            [14.218387491000101, 1.360564066000052],
            [14.206501913000068, 1.362837830000075],
            [14.198957153, 1.368315532000068],
            [14.19254927600008, 1.374955953000068],
            [14.183867635000098, 1.380847066000072],
            [14.14449019300011, 1.39162160300009],
            [14.124439738000149, 1.393585307000123],
            [14.10645634000008, 1.38893442800007],
            [14.070696248000075, 1.375110983000098],
            [14.049508911000117, 1.376402893000062],
            [14.03379927500012, 1.387642517000103],
            [14.01901981600011, 1.402137757000048],
            [14.000829712000069, 1.413015645000101],
            [13.983569784000082, 1.416839702000047],
            [13.794744100000088, 1.434435527000034],
            [13.780584757000042, 1.431024882000102],
            [13.779757935000106, 1.426270650000106],
            [13.77035282400007, 1.400432435000084],
            [13.758157186000062, 1.376506246000091],
            [13.754849894000131, 1.3743358360001],
            [13.744101196000116, 1.370279236000087],
            [13.741103963000114, 1.371312764000081],
            [13.72942508900013, 1.376919658000091],
            [13.724360799000067, 1.377953187000074],
            [13.717539510000108, 1.375369364000079],
            [13.705550578000043, 1.365990092000033],
            [13.699091023000108, 1.362786154000062],
            [13.680694214000084, 1.359401347000045],
            [13.671495808000088, 1.358781230000076],
            [13.662090699000146, 1.359194641000087],
            [13.64224694800015, 1.357385966000095],
            [13.628087605000104, 1.348135884000072],
            [13.615065145000074, 1.337438863000074],
            [13.579201701000017, 1.323486226000085],
            [13.556360718000121, 1.292790426000039],
            [13.543441609000098, 1.283488668000103],
            [13.509955281000117, 1.277287496000028],
            [13.479776245000096, 1.277132466000083],
            [13.448873739000106, 1.283075257000093],
            [13.413940470000114, 1.295529277000085],
            [13.398747599000103, 1.296924540000063],
            [13.376940145000077, 1.294444071000086],
            [13.357406453000067, 1.289069723000125],
            [13.349344930000058, 1.281576640000097],
            [13.34293705200011, 1.263851624000083],
            [13.325987183000109, 1.259304098000129],
            [13.307797079000068, 1.256720276000038],
            [13.289193562000037, 1.233982646000058],
            [13.270900106000056, 1.226024476000092],
            [13.250229533000038, 1.221787008000135],
            [13.215813028000099, 1.224370829000051],
            [13.195452515000056, 1.221115214000065],
            [13.184910523000099, 1.222510478000046],
            [13.184885479000059, 1.222623178000049],
            [13.181809936000064, 1.236463114000045],
            [13.172301473000061, 1.242870993000082],
            [13.160312540000092, 1.247728577000089],
            [13.15018396000005, 1.256616923000109],
            [13.169200887000017, 1.258580628000047],
            [13.176642293000043, 1.270879619000084],
            [13.18036299600007, 1.284832255000083],
            [13.188321167000112, 1.291446839000074],
            [13.202377156000125, 1.293410543000107],
            [13.219327026000144, 1.299198303000082],
            [13.233589721000016, 1.308810120000089],
            [13.242994832000079, 1.328860576000039],
            [13.249092651000126, 1.332374573000095],
            [13.251263062000106, 1.337645569000117],
            [13.242891479000036, 1.349789531000027],
            [13.239584188000038, 1.356507467000057],
            [13.239170776000037, 1.36418141700004],
            [13.239790893000105, 1.372346293000064],
            [13.238447306000126, 1.419630229000106],
            [13.239480835000109, 1.427975973000073],
            [13.223461141000058, 1.438001200000087],
            [13.205477743000074, 1.48637034100004],
            [13.184910523000099, 1.496886495000098],
            [13.190904989000018, 1.511071676000142],
            [13.189664754000091, 1.524740092000059],
            [13.182636759000076, 1.53654815700007],
            [13.171267945000096, 1.545255636000135],
            [13.16444665500012, 1.537840068000122],
            [13.14594649300011, 1.563419902000078],
            [13.129616740000074, 1.592462057000063],
            [13.146773315000132, 1.612254130000039],
            [13.149977254000106, 1.636283671000072],
            [13.143982788000073, 1.681810608000134],
            [13.147806844000115, 1.702868754000065],
            [13.154628133000074, 1.721653137000061],
            [13.157522013000062, 1.739145609000019],
            [13.15018396000005, 1.756302186000084],
            [13.162793010000087, 1.763640239000068],
            [13.173024943000144, 1.776946920000086],
            [13.180673055000057, 1.792010600000083],
            [13.191008341000042, 1.828726705000065],
            [13.192455281000036, 1.844746399000101],
            [13.188321167000112, 1.856580302000026],
            [13.183153523000101, 1.864047546000052],
            [13.17509200000012, 1.882108460000069],
            [13.162172892000115, 1.899833476000083],
            [13.166307006000125, 1.904381002000108],
            [13.17819258600008, 1.907791646000135],
            [13.184910523000099, 1.923449606000091],
            [13.191731812000057, 1.935076803000058],
            [13.198449748000058, 1.94311248800004],
            [13.205064331000074, 1.949339498000128],
            [13.210231974000067, 1.956315816000114],
            [13.212299032000118, 1.966418559000076],
            [13.206614624000082, 1.985151266000059],
            [13.206924682000079, 1.993574524000053],
            [13.216019735000145, 1.997166036000124],
            [13.221290731000067, 2.000835062000121],
            [13.239480835000109, 2.020730489000115],
            [13.245475301000056, 2.025303854000072],
            [13.281132040000045, 2.044966736000021],
            [13.291363973000102, 2.068944601000027],
            [13.294877970000073, 2.101087342000056],
            [13.294567912000076, 2.161057841000058],
            [13.466547078000104, 2.159507548000121],
            [13.62033614100011, 2.158112284000055],
            [13.662266290000105, 2.157761182000044],
            [13.823992960000027, 2.156406962000091],
            [14.002793417000106, 2.154804993000056],
            [14.161750122000115, 2.153409729000074],
            [14.266963338000096, 2.152427877000108],
            [14.276265096000117, 2.153564758000115],
            [14.320293416000084, 2.170669658000065],
            [14.383648722000089, 2.162091370000041],
            [14.399358358000057, 2.153151347000104],
            [14.41868534400001, 2.135271301000046],
            [14.432948038000092, 2.132119039000088],
            [14.438735799000057, 2.133979391000096],
            [14.459199666000131, 2.1465367630001],
            [14.538057902000048, 2.16338328000009],
            [14.547049601000083, 2.166535543000052],
            [14.550253540000057, 2.175165507000088],
            [14.547979777000137, 2.18436391200008],
            [14.547773072000098, 2.193665670000115],
            [14.557074829000015, 2.20239898700008],
            [14.562139120000097, 2.208806865000028],
            [14.587873983000094, 2.201727193000096],
            [14.620946899000074, 2.164830221000074],
            [14.644821411000066, 2.154184876000087],
            [14.636346476000142, 2.138320211000078],
            [14.646061645000088, 2.133359273000039],
            [14.672003215000132, 2.134341125000091],
            [14.68595585100013, 2.125866190000096],
            [14.705696249000084, 2.105531514000063],
            [14.720475708, 2.099588725000061],
            [14.71365441900005, 2.123980001000078],
            [14.72088911900002, 2.127597351000063],
            [14.747864217000142, 2.11320546500005],
            [14.733498169000143, 2.102017517000107],
            [14.727296997000082, 2.099588725000061],
            [14.737115519000042, 2.09607472800009],
            [14.74755415800007, 2.097185771000099],
            [14.756339152000066, 2.099588725000061],
            [14.76140344300012, 2.099588725000061],
            [14.762540324000042, 2.092534892000046],
            [14.761610148000102, 2.070184835000063],
            [14.764814087000076, 2.065456442000084],
            [14.826309042000076, 2.072251893000029],
            [14.841191854000101, 2.075920919000026],
            [14.848219849000117, 2.085196838000044],
            [14.85018355300005, 2.097366638000054],
            [14.85018355300005, 2.109794820000033],
            [14.857004842, 2.115944316000096],
            [14.871474243000137, 2.101655782000108],
            [14.884600057000114, 2.082096253000103],
            [14.887803996000088, 2.072251893000029],
            [14.90733768700008, 2.058893535000095],
            [14.896588989000065, 2.030936585000092],
            [14.892454874000038, 2.006390279000129],
            [14.932142374000108, 2.003341370000101],
            [14.953846476000109, 2.005821838000074],
            [14.963044881000116, 2.010421041000114],
            [14.971003052000071, 2.034450582000147],
            [14.980718221000132, 2.033106995000082],
            [15.028260539000144, 1.995305684000115],
            [15.043660116000126, 1.990861512000023],
            [15.063090454000104, 1.997166036000124],
            [15.074872681000102, 1.97936350500008],
            [15.091615845000149, 1.984427796000062],
            [15.107635539000114, 2.000835062000121],
            [15.117764119000071, 2.017009786000116],
            [15.123861938000118, 2.017009786000116],
            [15.138538046000093, 2.01150624600011],
            [15.151663859000081, 2.040987651000123],
            [15.183599894000054, 2.029334615000067],
            [15.197035766000084, 2.034967346000087],
            [15.212642049000124, 2.039618225000055],
            [15.233726033000067, 2.03129832000009],
            [15.238686971000106, 2.025303854000072],
            [15.244164673000114, 2.010059306000116],
            [15.248092081000067, 2.003341370000101],
            [15.253569784000149, 2.000318299000085],
            [15.287572876000098, 1.987786764000077],
            [15.295427694000125, 1.981533915000071],
            [15.301112101000086, 1.973756612000059],
            [15.303282511000077, 1.966418559000076],
            [15.301938924000098, 1.953318584000016],
            [15.300181926000022, 1.947660014000078],
            [15.301628866000016, 1.943577576000067],
            [15.309483683000053, 1.935076803000058],
            [15.314341268000078, 1.934249979000128],
            [15.337802368000041, 1.923759664000073],
            [15.33738895600004, 1.921460063000055],
            [15.349171183000124, 1.92329457600006],
            [15.367981405000137, 1.932854716000051],
            [15.388135214000016, 1.939546815000071],
            [15.439191528000094, 1.969829204000092],
            [15.482909790000065, 1.97584950700012],
            [15.526628051000046, 1.967813822000053],
            [15.611790812000095, 1.942544047000084],
            [15.706772095000105, 1.931976217000113],
            [15.711112915000086, 1.927377014000058],
            [15.721551554000115, 1.921615092000096],
            [15.73405725100011, 1.916705831000058],
            [15.757414999000048, 1.912985128000059],
            [15.764649699000131, 1.908721822000089],
            [15.802890258000104, 1.859965109000143],
            [15.815395955000099, 1.853428039000065],
            [15.842060994000065, 1.844152120000047],
            [15.865935506000142, 1.828468323000081],
            [15.875650676000078, 1.823765768000015],
            [15.882368611000118, 1.816711934000097],
            [15.884952434000098, 1.801648254000099],
            [15.889913371000148, 1.793276672000033],
            [15.901798951000075, 1.79374176000006],
            [15.915234823000048, 1.798961080000069],
            [15.925880167000116, 1.804748840000045],
            [15.928980753000076, 1.788961691000054],
            [15.943760213000076, 1.781623637000067],
            [15.963190551000082, 1.777360331000096],
            [15.980450480000059, 1.770590719000069],
            [15.990785766000073, 1.776171774000076],
            [16.002774699000042, 1.775913391000103],
            [16.013833455000025, 1.771314189000066],
            [16.021998331000134, 1.763795268000109],
            [16.02633915200002, 1.752297262000084],
            [16.024892212000026, 1.742478740000124],
            [16.021998331000134, 1.733047790000057],
            [16.021998331000134, 1.722790019000072],
            [16.030473266000058, 1.705400900000143],
            [16.069850708000047, 1.654551290000128],
            [16.114809204000068, 1.719069316000059],
            [16.123594197000045, 1.721601461000148],
            [16.145091593000103, 1.714315084000077],
            [16.155840291000118, 1.719069316000059],
            [16.15904423000009, 1.734804790000041],
            [16.135066366000075, 1.845314840000071],
            [16.101373332, 1.932803040000039],
            [16.08349328600005, 1.963007914000045],
            [16.07491499800011, 1.970604350000102],
            [16.068713826000135, 1.973601583000118],
            [16.06488977100011, 1.978950094000069],
            [16.063752889000085, 2.015872904000105],
            [16.06644006300013, 2.025484721000026],
            [16.081736288000087, 2.046827088000029],
            [16.081529582000115, 2.055637920000024],
            [16.078118937000085, 2.063441061000034],
            [16.07667199700009, 2.072251893000029],
            [16.076155233000065, 2.072820333000081],
            [16.075535116000083, 2.075455831000099],
            [16.075535116000083, 2.079951680000107],
            [16.07667199700009, 2.085920309000045],
            [16.079669230000036, 2.090261129000027],
            [16.08411340400002, 2.091604716000077],
            [16.088144165000102, 2.091759745000033],
            [16.090314575, 2.092741597000085],
            [16.092484986000102, 2.106900940000045],
            [16.08979781000008, 2.11615102100005],
            [16.08556034300011, 2.124910177000032],
            [16.08349328600005, 2.137751770000122],
            [16.085767049000083, 2.149172262000121],
            [16.09775598100012, 2.171548157000103],
            [16.104370565000124, 2.193562317000087],
            [16.12039025900009, 2.203329163000134],
            [16.140647421000097, 2.199815165000089],
            [16.15925093600012, 2.182090149000075],
            [16.199455200000074, 2.212165833000128],
            [16.20772342900011, 2.223069560000098],
            [16.202349081000136, 2.232009582000032],
            [16.1966646730001, 2.236453756000046],
            [16.24803104700007, 2.345594381000097],
            [16.293506307000115, 2.442074280000014],
            [16.32564904800006, 2.510493876000098],
            [16.371124308000105, 2.606922099000101],
            [16.41370568800008, 2.697200826000127],
            [16.42749236600011, 2.726492689000082],
            [16.45060266100009, 2.775593974000031],
            [16.479128051000146, 2.83631378100003],
            [16.483778930000113, 2.860394999000064],
            [16.474993937000136, 2.878378397000063],
            [16.460524536000094, 2.89460479800006],
            [16.448328898000085, 2.913466695000082],
            [16.445538370000122, 2.957650045000094],
            [16.484192342000114, 3.031909078000069],
            [16.49080692500013, 3.067824198000039],
            [16.48315881400015, 3.090148417000094],
            [16.472720174000102, 3.110612285000059],
            [16.464762003000146, 3.131799622000102],
            [16.465485474000047, 3.156500956000031],
            [16.4770609950001, 3.179393616000141],
            [16.511477498000147, 3.22724599200005],
            [16.517161906000098, 3.248691711000077],
            [16.517782023000052, 3.27323801700004],
            [16.542793416000052, 3.336154073000046],
            [16.551681762000072, 3.419766541000058],
            [16.567701457000112, 3.46438914000008],
            [16.598500610000087, 3.501673686000103],
            [16.639428344000095, 3.528597107000024],
            [16.686350545000067, 3.542213847000113],
            [16.709398234000105, 3.543712464000038],
            [16.729552043000098, 3.542213847000113],
            [16.81192427500008, 3.521672466000041],
            [16.8330082600001, 3.522861023000061],
            [16.852645304000134, 3.532808736000064],
            [16.854609009000086, 3.541335348000089],
            [16.851818481000123, 3.55190317800006],
            [16.853162068000074, 3.560093893000086],
            [16.867838176000078, 3.56154083300008],
            [16.877243286000123, 3.559163717000033],
            [16.895536743000093, 3.552368266000087],
            [16.9047351480001, 3.550637105000106],
            [16.932433716000105, 3.553918559000095],
            [16.942252238000094, 3.553091736000084],
            [16.953207641000063, 3.546890565000098],
            [16.960545695000064, 3.538441467000098],
            [16.968607218000045, 3.533480530000048],
            [16.98193973800008, 3.537976379000071],
            [16.989691203000064, 3.539474996000081],
            [17.003127075000123, 3.537717998000105],
            [17.009224894000084, 3.538131409000115],
            [17.01759647600005, 3.541800436000102],
            [17.02886193800012, 3.551541443000062],
            [17.035786580000092, 3.556140646000102],
            [17.052426392000115, 3.563969625000126],
            [17.061418091000064, 3.566140035000032],
            [17.0883931890001, 3.564434713000068],
            [17.102139119000128, 3.566605123000059],
            [17.129010864000122, 3.57706960100009],
            [17.142756795000054, 3.580841980000116],
            [17.182857707000068, 3.57960174600008],
            [17.197223755000067, 3.581720479000055],
            [17.213966919000114, 3.589291076000023],
            [17.222958618000064, 3.598515320000033],
            [17.231123494000087, 3.609108988000102],
            [17.24497277800012, 3.620606994000113],
            [17.259442179000075, 3.625903829000066],
            [17.272257934000066, 3.624560241000097],
            [17.298096150000077, 3.615904439000047],
            [17.334373007000124, 3.618514099000052],
            [17.355767049000036, 3.638435364000074],
            [17.375714152000057, 3.66344675700006],
            [17.414488944000112, 3.683414614000114],
            [17.427493937000122, 3.690111797000014],
            [17.442686808000047, 3.70127390600004],
            [17.45891320800007, 3.708276062000053],
            [17.481857544000093, 3.704762065000082],
            [17.486198364000074, 3.700292054000073],
            [17.490125773000045, 3.687140402000097],
            [17.49498335800007, 3.683212993000041],
            [17.50893599400007, 3.681766052000043],
            [17.51348352000008, 3.679182231000127],
            [17.550483846000134, 3.648150533000106],
            [17.586760702000106, 3.632234192000084],
            [17.627275024000113, 3.626317241000081],
            [17.709130493000146, 3.626420593000105],
            [17.71450484200011, 3.627505798000101],
            [17.72608036300005, 3.631846619000072],
            [17.73321171000009, 3.63220835400007],
            [17.73992964700011, 3.629159445000141],
            [17.749644816000057, 3.618074850000127],
            [17.755949341000075, 3.614509175000066],
            [17.765147746000082, 3.614354147000114],
            [17.78447473200012, 3.618229879000083],
            [17.793156372000084, 3.617506409000086],
            [17.808349243000094, 3.608592225000066],
            [17.821164998000086, 3.593993632000092],
            [17.830570109000064, 3.575674337000109],
            [17.835324341000046, 3.555830587000031],
            [17.84214563000009, 3.540146790000065],
            [17.856408325000075, 3.53730458600009],
            [17.875321899000113, 3.542730611000067],
            [17.913562459000104, 3.561334127000109],
            [17.91924686700014, 3.565597433000079],
            [17.924517863000062, 3.563452861000087],
            [17.959864542000076, 3.54107696600002],
            [17.969476359000083, 3.537511292000133],
            [17.981878703000064, 3.538803202000096],
            [18.01309126700005, 3.553970235000108],
            [18.04709436100009, 3.563142802000101],
            [18.082027629000066, 3.563452861000087],
            [18.11644413200011, 3.552006531000089],
            [18.134014120000103, 3.534824117000113],
            [18.14672652200005, 3.494904073000072],
            [18.15985233500001, 3.480305482000105],
            [18.181556437000012, 3.477385762000011],
            [18.2025370690001, 3.487333476000103],
            [18.220003703000145, 3.503947449000123],
            [18.231579224000114, 3.521155701000097],
            [18.235403280000128, 3.53092254700006],
            [18.242534627000083, 3.561127422000069],
            [18.248529094000105, 3.574899191000014],
            [18.25586714700009, 3.577224630000046],
            [18.26485884600004, 3.574744161000069],
            [18.27591760200005, 3.574382426000071],
            [18.35560266100009, 3.581462098000088],
            [18.36159712700004, 3.580170186000132],
            [18.372862590000096, 3.574537455000012],
            [18.379890585000112, 3.574382426000071],
            [18.38371464000005, 3.577999776000055],
            [18.38784875500008, 3.591668192000057],
            [18.392292928000074, 3.595853983000097],
            [18.40366174300007, 3.597352600000107],
            [18.420611613000062, 3.596370748000126],
            [18.42970666500014, 3.600220642000082],
            [18.44800012200011, 3.618023173000026],
            [18.45905887800012, 3.631381531000059],
            [18.472081339000056, 3.632053324000125],
            [18.497092733000045, 3.611460266000037],
            [18.513422485000092, 3.592236633000113],
            [18.5543502190001, 3.526375020000032],
            [18.57026656100004, 3.489607239000037],
            [18.582462199000133, 3.477385762000011],
            [18.626387166000086, 3.476868998000072],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Dem. Rep. Congo',
        iso3: 'COD',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [18.626387166000086, 3.476868998000072],
              [18.59300419100009, 3.709774679000049],
              [18.612847941000098, 3.833746440000127],
              [18.612023983000142, 3.866611157000122],
              [18.61171106000009, 3.87909250900006],
              [18.61367476300012, 3.901468404000042],
              [18.6345520430001, 3.93572987900005],
              [18.641580038000114, 3.958260803000073],
              [18.645300741000113, 3.982445373000132],
              [18.64654097500005, 4.045981547000096],
              [18.632691691000076, 4.130420837000131],
              [18.619669230000056, 4.169565735000077],
              [18.583909139000127, 4.235789083000071],
              [18.578638142000102, 4.254857687000055],
              [18.572540323000055, 4.265683899000095],
              [18.545048462000068, 4.289015808000045],
              [18.537090291000112, 4.306069031000064],
              [18.54194787600005, 4.327850647000091],
              [18.556830688000076, 4.354153951000043],
              [18.5764677330001, 4.372757467000085],
              [18.595794719000054, 4.371258850000075],
              [18.61429488100009, 4.359812520000077],
              [18.633931925000127, 4.355962626000121],
              [18.65408573400009, 4.357228699000075],
              [18.6743428960001, 4.361311137000072],
              [18.7210583910001, 4.377356669000037],
              [18.75330448400007, 4.40061106400006],
              [18.77697229000009, 4.433451437000073],
              [18.82823531000011, 4.559981181000055],
              [18.85241988100009, 4.594061788000118],
              [18.88652632700007, 4.621398621000139],
              [18.89789514100005, 4.650647481000092],
              [18.900168904000054, 4.652146098000102],
              [18.90450972500014, 4.655866801000101],
              [18.923836711000092, 4.662868957000114],
              [18.928177531000074, 4.666434632000076],
              [18.96228397700014, 4.724441427000045],
              [18.980474081000096, 4.739401754000099],
              [18.998044067000052, 4.750641378000068],
              [19.011583292000125, 4.765033265000071],
              [19.019748169000138, 4.803299662000072],
              [19.026879516000093, 4.811516215000012],
              [19.035767863000103, 4.81800160700007],
              [19.04413944400008, 4.82688995400008],
              [19.048997030000095, 4.836527608000097],
              [19.0577820230001, 4.867791850000089],
              [19.069047485000056, 4.891252950000066],
              [19.083310181000115, 4.909339702000082],
              [19.106741180000085, 4.931518101000066],
              [19.116176391000067, 4.940448914000044],
              [19.133022908000044, 4.946934306000088],
              [19.179014933000133, 4.946417542000063],
              [19.195654744000137, 4.95034495000003],
              [19.214671672000122, 4.976131490000029],
              [19.229761189000016, 5.002176412000011],
              [19.236995890000088, 5.010780538000049],
              [19.283814738000103, 5.032277934000078],
              [19.373111613000077, 5.0875458780001],
              [19.394195597000106, 5.116975606000096],
              [19.408975057000106, 5.130385640000043],
              [19.431505982000118, 5.13596669500015],
              [19.49651493400009, 5.133796285000074],
              [19.517082154000093, 5.13596669500015],
              [19.548604777000065, 5.151366272000047],
              [19.568758586000115, 5.155190328000074],
              [19.605552205000038, 5.138292135000086],
              [19.7195504150001, 5.13596669500015],
              [19.728748820000106, 5.133847962000075],
              [19.748799276000057, 5.124417012000023],
              [19.779185018000106, 5.118164165000024],
              [19.824660278000067, 5.096976827000063],
              [19.838612915000056, 5.0875458780001],
              [19.85018843600008, 5.073748271000056],
              [19.858163068000096, 5.06030532000004],
              [19.875509888000067, 5.031063538000055],
              [19.880367472000103, 5.015534769000041],
              [19.89090946500005, 5.002124736000084],
              [19.91540409300012, 4.993107198000047],
              [20.00397749800007, 4.974477845000081],
              [20.03105594900012, 4.957993063000103],
              [20.054620402000126, 4.937813416000026],
              [20.086349732000144, 4.916264344000069],
              [20.152598918000052, 4.890684509000025],
              [20.171719198000062, 4.878359680000059],
              [20.217194458000108, 4.82244578100007],
              [20.236624796000086, 4.80634857200009],
              [20.254814901000117, 4.797124329000084],
              [20.30173710100007, 4.78164723800009],
              [20.322511027000132, 4.779063415000081],
              [20.33894413200008, 4.771906230000042],
              [20.354033651000094, 4.755395610000051],
              [20.373670695000044, 4.724441427000045],
              [20.39547814900004, 4.677105814000086],
              [20.403746378000108, 4.669845276000018],
              [20.420592895000084, 4.662352193000075],
              [20.44022993900012, 4.644110413000107],
              [20.456456340000017, 4.621501973000079],
              [20.463070923000117, 4.600934753000089],
              [20.45717980900011, 4.586439514000048],
              [20.447051229000067, 4.569670512000087],
              [20.442090291000113, 4.550498555000075],
              [20.452322225000103, 4.52892364500012],
              [20.456712867000107, 4.524815862000054],
              [20.55980920400009, 4.428361308000092],
              [20.58027307100005, 4.415002950000073],
              [20.60311405400006, 4.409731954000037],
              [20.688380168000037, 4.422780253000084],
              [20.767858520000118, 4.422780253000084],
              [20.79183638500004, 4.426190898000101],
              [20.807029256000078, 4.4342524220001],
              [20.81870813000006, 4.443528341000018],
              [20.832350708000064, 4.450685526000058],
              [20.87152144400008, 4.453372702000095],
              [20.9635054930001, 4.433735657000057],
              [21.05962365700009, 4.39859568300011],
              [21.076056763000082, 4.395469259000066],
              [21.084221639000077, 4.388234558000093],
              [21.103445271000112, 4.353275452000091],
              [21.113573853000076, 4.340847270000026],
              [21.137965129000094, 4.332682393000098],
              [21.150057414000088, 4.326713766000083],
              [21.15811893700007, 4.310203145000088],
              [21.165560344000085, 4.307154236000059],
              [21.18561079900013, 4.306069031000064],
              [21.195739380000077, 4.302916769000106],
              [21.202974080000047, 4.296638082000101],
              [21.210932251000116, 4.291573792000037],
              [21.22343794800011, 4.292452291000075],
              [21.23242964700006, 4.297826640000039],
              [21.23914758300009, 4.305603943000051],
              [21.24462528400008, 4.313768820000064],
              [21.25072310300004, 4.320357564000048],
              [21.258371216000114, 4.325990295000082],
              [21.26591597500007, 4.330072733000094],
              [21.275321086000105, 4.332527365000061],
              [21.28834354700004, 4.333380025000082],
              [21.298885538, 4.330227763000039],
              [21.305500122000097, 4.32314809200011],
              [21.310357707000037, 4.316094259000096],
              [21.35831343600006, 4.285553487000087],
              [21.374849894000135, 4.278163757000087],
              [21.39769087700006, 4.271626689000101],
              [21.416914510000083, 4.270076396000093],
              [21.460219360000053, 4.271936748000087],
              [21.47313846800006, 4.26930124900008],
              [21.482440227000097, 4.263125916000092],
              [21.489881633000095, 4.256252950000132],
              [21.497219686000108, 4.251472881000041],
              [21.508071737000137, 4.249405823000075],
              [21.5278121340001, 4.24925079300003],
              [21.538147420000115, 4.244651591000078],
              [21.63416223100012, 4.29420929000014],
              [21.65111210100011, 4.295656230000134],
              [21.68893925000009, 4.292452291000075],
              [21.722942342000124, 4.295139465000091],
              [21.737308390000123, 4.293382467000114],
              [21.7584957280001, 4.285605164000103],
              [21.763249959000092, 4.281677755000132],
              [21.766040487000055, 4.277207744000123],
              [21.771001424000076, 4.273487040000106],
              [21.782060181000105, 4.271936748000087],
              [21.810998983000047, 4.273176982000038],
              [21.819887329000068, 4.271936748000087],
              [21.8380774340001, 4.26325510600013],
              [21.851926717000083, 4.251679586000094],
              [21.867739705000076, 4.241551005000133],
              [21.89161421700007, 4.237184347000053],
              [21.949905232000106, 4.233463644000039],
              [21.970782512000085, 4.237184347000053],
              [21.98029097400007, 4.240620830000083],
              [21.984528442000112, 4.242946269000115],
              [21.98959273300008, 4.244238180000067],
              [22.001478312000103, 4.244651591000078],
              [22.00891971800013, 4.242377828000059],
              [22.036612824000144, 4.229438766000087],
              [22.05780562400011, 4.219536845000064],
              [22.108448527000064, 4.209847514000032],
              [22.12787886600006, 4.203077902000089],
              [22.133046509000053, 4.198659567000078],
              [22.151650025, 4.179461772000067],
              [22.161881958000095, 4.173183085000062],
              [22.184722941000103, 4.164604797000038],
              [22.207253866000116, 4.150316264000054],
              [22.3032686760001, 4.128715516000085],
              [22.42264123500013, 4.13478749600003],
              [22.431839640000135, 4.138559875000055],
              [22.451532021000048, 4.146672020000068],
              [22.457367798000092, 4.149076029000113],
              [22.492714477000078, 4.17403574700009],
              [22.51049117000011, 4.191269836000075],
              [22.518242635000036, 4.206798605000088],
              [22.52217004400009, 4.211346131000127],
              [22.540463501000147, 4.227262472000064],
              [22.546147909000098, 4.237184347000053],
              [22.545734497000097, 4.245943502000031],
              [22.539740030000075, 4.266924134000121],
              [22.539326619000065, 4.278163757000087],
              [22.568575480000106, 4.331545512000091],
              [22.576533651000148, 4.340847270000026],
              [22.588005818000084, 4.344180399000024],
              [22.599891398000096, 4.35255198100009],
              [22.609296509000075, 4.363352356000036],
              [22.61374068200007, 4.374359437000123],
              [22.611260213000094, 4.381852519000063],
              [22.59400028400009, 4.402316386000024],
              [22.589039347000067, 4.421953430000059],
              [22.58697229000009, 4.449393616000108],
              [22.59244999200007, 4.473707378000114],
              [22.61033003700004, 4.484223532000073],
              [22.654358357000092, 4.482828268000091],
              [22.675649048000082, 4.484740296000027],
              [22.68949833200014, 4.491664938000099],
              [22.69507938600006, 4.50148346000006],
              [22.697146444000026, 4.512025452000032],
              [22.697043091000097, 4.535744934000078],
              [22.70014367600004, 4.541067607000116],
              [22.71368290200013, 4.551222026000076],
              [22.716783488000146, 4.556518860000025],
              [22.718953898000052, 4.562771709000117],
              [22.728669067000084, 4.580290019000074],
              [22.73114953600006, 4.587266337000074],
              [22.72980594900011, 4.596748962000049],
              [22.723811483000077, 4.617031962000056],
              [22.723604777000105, 4.628840027000066],
              [22.73786747300008, 4.637754211000086],
              [22.748719523000148, 4.648270365000144],
              [22.7574011640001, 4.660801901000056],
              [22.765152628000095, 4.67602061000008],
              [22.776418091000068, 4.710101216000055],
              [22.786029907000085, 4.724648133000102],
              [22.802876424000146, 4.73064259900012],
              [22.818069295000072, 4.724596456000086],
              [22.837292928000096, 4.714235331000069],
              [22.853829386000086, 4.711263936000066],
              [22.865301554000013, 4.738678284000102],
              [22.887315715000085, 4.755498963000079],
              [22.895583944000037, 4.765394999000065],
              [22.88679895000007, 4.776686299000048],
              [22.882354777000046, 4.788494365000048],
              [22.8828715410001, 4.800741679000069],
              [22.88876265500008, 4.813221537000061],
              [22.898374471000096, 4.823582663000082],
              [22.905919230000052, 4.824202779000046],
              [22.915220988000073, 4.821153870000032],
              [22.929690389000115, 4.820611267000075],
              [22.941472616000112, 4.824719544000089],
              [22.953048136000064, 4.830791525000038],
              [22.965037069000118, 4.83528737400006],
              [22.97743941200008, 4.834305522000093],
              [22.98570764100012, 4.826424866000053],
              [22.996249634000094, 4.799501445000132],
              [23.007205037000062, 4.778443299000116],
              [23.011132446000147, 4.763638001000089],
              [23.017333619000112, 4.750512187000126],
              [23.029322550000074, 4.744931132000104],
              [23.042758423000123, 4.742967428000071],
              [23.055160767000103, 4.737799784000075],
              [23.06663293400004, 4.730177511000093],
              [23.07738163200014, 4.721056621000031],
              [23.099395793000042, 4.711651510000067],
              [23.123890422000073, 4.71563059500005],
              [23.16874556500008, 4.738109843000061],
              [23.183731731000137, 4.725268249000067],
              [23.208639770000104, 4.690541687000035],
              [23.220835408000113, 4.683513693000123],
              [23.22424605300006, 4.680051371000076],
              [23.251841268000135, 4.662972310000043],
              [23.26486372900007, 4.635067037000056],
              [23.273131958000135, 4.632018127000038],
              [23.295146118000105, 4.627599792000126],
              [23.29959029200012, 4.625119324000053],
              [23.301967408000053, 4.621708679000037],
              [23.313026164000064, 4.610210673000012],
              [23.316436809000095, 4.607730204000035],
              [23.335867147000073, 4.60680002800008],
              [23.3539538980001, 4.603570252000097],
              [23.371213826000087, 4.597265727000092],
              [23.388370402000135, 4.587266337000074],
              [23.396018514000104, 4.591607158000059],
              [23.414518677000046, 4.590832011000131],
              [23.42258020100013, 4.594061788000118],
              [23.427437785000052, 4.60134816500009],
              [23.428367960000116, 4.608608704000076],
              [23.428264607000074, 4.617342021000042],
              [23.43002160700007, 4.628840027000066],
              [23.437152954000084, 4.646565044000084],
              [23.448315063000024, 4.659406637000075],
              [23.46505822800009, 4.667209778000085],
              [23.488415975000123, 4.669845276000018],
              [23.50608931500011, 4.676434021000091],
              [23.566550741000043, 4.724441427000045],
              [23.5880481370001, 4.733949890000119],
              [23.634040161000087, 4.745137838000062],
              [23.67269413200009, 4.767203674000058],
              [23.692847941000082, 4.773404846000048],
              [23.737909790000117, 4.779063415000081],
              [23.76002730300013, 4.787434997000062],
              [23.798474568000074, 4.814745992000084],
              [23.816664672000115, 4.820611267000075],
              [23.828240194000045, 4.819345195000039],
              [23.84787723800008, 4.813996684000074],
              [23.855215291000093, 4.813221537000061],
              [23.86441369600007, 4.816089580000053],
              [23.874748983000103, 4.824977926000059],
              [23.881880330000115, 4.82688995400008],
              [23.924358358000063, 4.817794902000102],
              [23.948336223000098, 4.817691549000074],
              [23.94740604700013, 4.83058481900008],
              [23.942755168000076, 4.840506694000084],
              [23.943168579000087, 4.851694641000023],
              [23.946475871000075, 4.861642355000114],
              [23.950816691000057, 4.867791850000089],
              [23.957121216000075, 4.870814921000104],
              [23.963115682000108, 4.86869618700004],
              [23.977998494000133, 4.854149272000086],
              [23.995775187000078, 4.865052999000056],
              [24.046934855000075, 4.888927511000134],
              [24.072463013000117, 4.910269878000037],
              [24.089619588000062, 4.920217591000039],
              [24.108429809000086, 4.9230597950001],
              [24.119901978000087, 4.918899841000083],
              [24.13922896300005, 4.905438130000022],
              [24.15276818800004, 4.90259592700005],
              [24.16289677000009, 4.90778940900006],
              [24.19090539600009, 4.944169617000043],
              [24.20961226400007, 4.956184388000111],
              [24.229766073000064, 4.96117116300006],
              [24.246199178000012, 4.954065653000043],
              [24.253020467000084, 4.929881083000069],
              [24.259221639000145, 4.929881083000069],
              [24.267696573000052, 4.93572052100005],
              [24.269556925000074, 4.943187765000076],
              [24.26966027800009, 4.952463684000094],
              [24.272967570000077, 4.964013367000035],
              [24.284646444000145, 4.992435405000066],
              [24.286506795000065, 4.99507090300007],
              [24.29663537600004, 5.003261617000092],
              [24.36846561700014, 5.012434184000085],
              [24.386138957000128, 5.022356059000089],
              [24.398644653000133, 5.036024475000104],
              [24.396887655000057, 5.0481942750001],
              [24.371979614000082, 5.053387757000024],
              [24.361230916000068, 5.062947896000111],
              [24.367845500000072, 5.084548645000083],
              [24.382521607000058, 5.107854716000119],
              [24.396370890000128, 5.122298279000049],
              [24.401641887000068, 5.111472067000093],
              [24.411460409000114, 5.081861471000053],
              [24.416938110000103, 5.073257345000115],
              [24.430684042000053, 5.067417908000039],
              [24.43347456900011, 5.075531108000035],
              [24.4330611580001, 5.089328715000079],
              [24.436678508000085, 5.100594177000048],
              [24.45962284400011, 5.107441304000105],
              [24.480844127000125, 5.102334685000088],
              [24.4872180590001, 5.100800883000105],
              [24.513676391000104, 5.087235819000114],
              [24.533003377000057, 5.073257345000115],
              [24.538687785000093, 5.06555755600003],
              [24.547369425000056, 5.046488953000051],
              [24.553467244000103, 5.039099223000036],
              [24.563389120000096, 5.034887593000093],
              [24.588607219000068, 5.031063538000055],
              [24.601216268000087, 5.026102600000101],
              [24.61010461400008, 5.016723328000054],
              [24.610001261000065, 4.99672454900012],
              [24.615478963000044, 4.985097351000064],
              [24.6274678960001, 4.976906637000042],
              [24.656923462000123, 4.967268982000121],
              [24.67077274600007, 4.95721791600009],
              [24.657440226000062, 4.939777120000144],
              [24.65423628700009, 4.929415995000042],
              [24.66436486800012, 4.924403382000079],
              [24.73061405400003, 4.917504578000091],
              [24.749837687000053, 4.918744812000043],
              [24.766374145000043, 4.929881083000069],
              [24.778259725000083, 4.918538107000074],
              [24.78942183400011, 4.919855856000126],
              [24.80006717900011, 4.928899231000088],
              [24.811022583000096, 4.940448914000044],
              [24.819497518000077, 4.944479675000125],
              [24.8276623940001, 4.941921692000037],
              [24.836860799000107, 4.937710063000083],
              [24.84833296700012, 4.93672821100003],
              [24.86817671700001, 4.9443763230001],
              [24.904350219000037, 4.966803895000098],
              [24.927087850000106, 4.971480611000061],
              [24.932358846000056, 4.974426168000065],
              [24.950859009000084, 4.98768117300007],
              [24.95809370900014, 4.991350199000067],
              [24.969359171000093, 4.991401876000083],
              [25.006462850000077, 4.980937399000126],
              [25.04056929500007, 4.962101339000114],
              [25.0761226810001, 4.951843567000125],
              [25.084804321000064, 4.954220683000074],
              [25.0904887290001, 4.974477845000081],
              [25.100927368000043, 4.994554138000041],
              [25.10526818800014, 4.998765768000084],
              [25.114259888000078, 5.001840516000115],
              [25.121701294000104, 5.00863596700006],
              [25.12945275900009, 5.018635356000075],
              [25.140201457000018, 5.017963562000091],
              [25.147642863000044, 5.014139506000063],
              [25.154567505000045, 5.009307760000041],
              [25.163662556000105, 5.005638733000055],
              [25.227534627000068, 5.009566142000025],
              [25.239316854000066, 5.015534769000041],
              [25.248515259000044, 5.024138895000078],
              [25.292336873000067, 5.028273011000095],
              [25.30763309700012, 5.032277934000078],
              [25.316831503000117, 5.042251485000094],
              [25.320965617000127, 5.052250875000112],
              [25.321895793000095, 5.077003886000043],
              [25.324996378000037, 5.088114319000056],
              [25.339155721000083, 5.105167542000089],
              [25.342359660000056, 5.111472067000093],
              [25.34380660000005, 5.121884868000038],
              [25.349284301000125, 5.1416769410001],
              [25.348560832000118, 5.149014995000101],
              [25.341222779000134, 5.155603739000085],
              [25.321482381000067, 5.159169414000061],
              [25.31445438700007, 5.163251852000073],
              [25.30773645000005, 5.185291850000056],
              [25.316211385000145, 5.20224172000006],
              [25.32892378800011, 5.216013489000105],
              [25.335538371000098, 5.228441671000084],
              [25.33719201600013, 5.251747742000106],
              [25.34339318900004, 5.271927388000094],
              [25.355898885000045, 5.286448466000138],
              [25.376466105000105, 5.293011373000127],
              [25.36365035000003, 5.310555522000087],
              [25.370678345000044, 5.316834208000103],
              [25.385354451000126, 5.32148508700007],
              [25.395689738000044, 5.333964946000052],
              [25.413363078000145, 5.323552145000122],
              [25.435067180000146, 5.328693949000112],
              [25.47992232300004, 5.353188579000076],
              [25.481989379000083, 5.356857605000073],
              [25.484934936000087, 5.35530731200015],
              [25.495580281000088, 5.344532776000037],
              [25.504468628000097, 5.342284851000016],
              [25.528963257000044, 5.351896668000037],
              [25.540848836000094, 5.354428813000112],
              [25.532787313000085, 5.372231344000056],
              [25.543742716000082, 5.375280253000085],
              [25.56182946800007, 5.373006490000066],
              [25.575058634000072, 5.374918518000086],
              [25.581259806000077, 5.374918518000086],
              [25.58901127100006, 5.362283630000135],
              [25.59231856200006, 5.34918365500009],
              [25.600483439000072, 5.340450338000025],
              [25.62291101100007, 5.340760396000093],
              [25.61981042500014, 5.337220561000038],
              [25.61722660300012, 5.333551534000051],
              [25.614229370000118, 5.329934184000066],
              [25.609165079000036, 5.326523539000036],
              [25.609165079000036, 5.320296529000046],
              [25.62342777500004, 5.309935404000029],
              [25.631075887000094, 5.311821594000136],
              [25.637897176000138, 5.3179710900001],
              [25.65009281400006, 5.320296529000046],
              [25.655777222000097, 5.317764384000057],
              [25.66311527500011, 5.309160258000105],
              [25.667559448000105, 5.307248230000098],
              [25.668903035000085, 5.30613718700009],
              [25.69112390100011, 5.299806824000072],
              [25.7050765380001, 5.289600728000011],
              [25.732775106000133, 5.25887909000005],
              [25.743730509000102, 5.250610860000108],
              [25.757993205000076, 5.244435527000036],
              [25.771739135000104, 5.2454690550001],
              [25.781144246000082, 5.25887909000005],
              [25.769258667000145, 5.265157776000066],
              [25.77835371900011, 5.26913686100005],
              [25.792306355000107, 5.26283233700012],
              [25.79468347100004, 5.238389384000087],
              [25.799437703000137, 5.240094706000136],
              [25.810186401000067, 5.242678528000056],
              [25.81463057500008, 5.244590556000077],
              [25.811426636000107, 5.230922140000061],
              [25.814217163000052, 5.221620381000122],
              [25.818971394000044, 5.214566549000025],
              [25.826102742000074, 5.194696961000105],
              [25.83623132300005, 5.200019633000068],
              [25.846049845000096, 5.211672668000034],
              [25.849357137000112, 5.217873841000113],
              [25.872404826000064, 5.2170986940001],
              [25.88356693500009, 5.203533630000024],
              [25.892972046000068, 5.18521433500004],
              [25.910852092000113, 5.170098979000031],
              [25.91250573700006, 5.190381979000051],
              [25.925631551000038, 5.201776632000133],
              [25.943201538000096, 5.204102071000065],
              [25.95860111500008, 5.19738413500005],
              [25.95839440900005, 5.214824931000081],
              [25.962838583000035, 5.224514262000113],
              [25.97193363400001, 5.227666524000071],
              [25.985989624000126, 5.225341085000139],
              [25.996634969000127, 5.219243266000078],
              [26.013894897000114, 5.199244486000055],
              [26.02691735800005, 5.189968567000037],
              [26.037355998000095, 5.197952576000091],
              [26.050998576000097, 5.200226339000025],
              [26.06267745000008, 5.200122986000082],
              [26.067845093000074, 5.200846456000079],
              [26.07053226700009, 5.212241109000075],
              [26.077146851000094, 5.216323547000087],
              [26.086035197000115, 5.215238343000095],
              [26.09523360200012, 5.211052552000055],
              [26.091719605000065, 5.219062398000034],
              [26.08841231300005, 5.244590556000077],
              [26.0933732500001, 5.241438294000105],
              [26.098437540000077, 5.239577942000011],
              [26.104535359000124, 5.238596090000044],
              [26.11249353000011, 5.238389384000087],
              [26.11962487800014, 5.24154164600013],
              [26.125102579000043, 5.248595480000063],
              [26.12996016400004, 5.25887909000005],
              [26.14422285900011, 5.251799418000118],
              [26.150837443000114, 5.239965515000023],
              [26.157348673000087, 5.23247243200008],
              [26.170887898000075, 5.238389384000087],
              [26.17533207200009, 5.233686829000106],
              [26.181739949000104, 5.229578552000092],
              [26.184530477000067, 5.225341085000139],
              [26.195175822000067, 5.234772034000102],
              [26.198276408000112, 5.238389384000087],
              [26.207164754000132, 5.20769358400014],
              [26.21357263200008, 5.19914113400003],
              [26.2261816810001, 5.20425710100011],
              [26.225664917000046, 5.199037781000087],
              [26.2261816810001, 5.183147278000078],
              [26.23072920700011, 5.185162659000113],
              [26.242098022000107, 5.188056539000101],
              [26.24664554800006, 5.189968567000037],
              [26.253983602000062, 5.172321066000038],
              [26.27248376500006, 5.159066061000132],
              [26.291810751000128, 5.150978699000035],
              [26.317338908000067, 5.146431173000096],
              [26.33635583500012, 5.148601583000087],
              [26.35330570500014, 5.147774760000061],
              [26.3627108150001, 5.13596669500015],
              [26.36942875200012, 5.140565897000016],
              [26.390616089000076, 5.149014995000101],
              [26.400124552000136, 5.133641256000118],
              [26.414283895000096, 5.12271169000006],
              [26.429373413000093, 5.113797506000125],
              [26.441879110000087, 5.104289042000048],
              [26.46068933100011, 5.066022644000057],
              [26.46265303500013, 5.059640605000112],
              [26.475158732000125, 5.057263489000078],
              [26.502547241000087, 5.047470805000017],
              [26.519807170000064, 5.045972188000107],
              [26.528282105000073, 5.048090922000085],
              [26.541511271000076, 5.053129374000136],
              [26.55422367300011, 5.05984731000008],
              [26.561355021000054, 5.067056173000125],
              [26.568176310000098, 5.059640605000112],
              [26.57985518300009, 5.074342550000026],
              [26.59835534700011, 5.080621237000116],
              [26.61551192200008, 5.078244121000068],
              [26.623470093000037, 5.067056173000125],
              [26.629671265000127, 5.067056173000125],
              [26.635665731000046, 5.077624003000011],
              [26.644037313000126, 5.078347473000093],
              [26.657576538000114, 5.073257345000115],
              [26.667601766000132, 5.078347473000093],
              [26.68124434400005, 5.089277039000066],
              [26.691682983000078, 5.094393006000061],
              [26.73943200700006, 5.094393006000061],
              [26.753694702000104, 5.092274272000083],
              [26.760619344000105, 5.088114319000056],
              [26.8018571370001, 5.044525248000113],
              [26.80836836800009, 5.039099223000036],
              [26.815706421000073, 5.040184428000131],
              [26.8261450600001, 5.050752259000106],
              [26.832656291000063, 5.053387757000024],
              [26.839477580000022, 5.051165670000017],
              [26.844955281000125, 5.046282247000093],
              [26.848365926000042, 5.041372986000056],
              [26.849296102000096, 5.039099223000036],
              [26.867072795000126, 5.037548930000114],
              [26.87265384900013, 5.041786397000067],
              [26.884126017000142, 5.053387757000024],
              [26.889603719000064, 5.062121073000085],
              [26.899215535000053, 5.085995585000077],
              [26.903969767000063, 5.094393006000061],
              [26.933683715000114, 5.126587423000018],
              [26.961640666000108, 5.151185404000088],
              [26.991716349000086, 5.171287537000055],
              [27.02747644100012, 5.189968567000037],
              [27.073675171000076, 5.203326925000056],
              [27.116359904000063, 5.200303854000126],
              [27.157494344000042, 5.185421041000097],
              [27.239711548000088, 5.144880880000073],
              [27.262810913000067, 5.138447164000127],
              [27.28441166200011, 5.13596669500015],
              [27.30187829600007, 5.131987610000081],
              [27.315727580000043, 5.122401632000077],
              [27.32864668700003, 5.110800273000024],
              [27.34275435400008, 5.100594177000048],
              [27.351384318000015, 5.097338562000061],
              [27.36120284000009, 5.095478210000053],
              [27.38032312000007, 5.094393006000061],
              [27.391381876000082, 5.092222595000067],
              [27.40533451300007, 5.08284332300012],
              [27.414842977000063, 5.080724589000056],
              [27.441301310000142, 5.070725199000037],
              [27.443058309000037, 5.057780253000104],
              [27.436340373000093, 5.013157654000082],
              [27.441818074000082, 5.007964172000072],
              [27.44786421700013, 5.003468323000064],
              [27.45453047700005, 4.999799297000067],
              [27.461558472000064, 4.996879578000062],
              [27.492822713000038, 4.973030904000083],
              [27.501349325000064, 4.963289897000038],
              [27.505018351000075, 4.953858948000075],
              [27.5092041420001, 4.932439067000061],
              [27.514578492000055, 4.922439677000042],
              [27.53256189000004, 4.907582702000099],
              [27.552715698000014, 4.900528870000088],
              [27.64097904400009, 4.890942892000083],
              [27.658755737000035, 4.879651592000116],
              [27.671881551000098, 4.855906271000066],
              [27.679736369000125, 4.8144876100001],
              [27.685937541000015, 4.797899475000094],
              [27.699063355000078, 4.787434997000062],
              [27.706504761000105, 4.787434997000062],
              [27.725831747000143, 4.792783508000113],
              [27.734823445000103, 4.793196920000113],
              [27.744228556000053, 4.787848409000077],
              [27.752600138000048, 4.777668152000103],
              [27.75921472200011, 4.766273499000107],
              [27.76314213100008, 4.757100932000114],
              [27.766862834000108, 4.735448507000044],
              [27.75880131000011, 4.677157491000088],
              [27.76076501500006, 4.63599721300011],
              [27.765209187000067, 4.612071025000105],
              [27.77244388800011, 4.595818786000095],
              [27.776888061000136, 4.595741272000069],
              [27.801382690000082, 4.590573629000076],
              [27.80923750800011, 4.587989808000074],
              [27.81946944100011, 4.579566549000077],
              [27.837659546000054, 4.559981181000055],
              [27.849131714000066, 4.553211568000023],
              [27.856934855000077, 4.552462260000112],
              [27.885511922000035, 4.556673890000056],
              [27.890989624000042, 4.555847066000041],
              [27.907939494000033, 4.548689880000083],
              [27.91403731300008, 4.549309998000055],
              [27.916414429000042, 4.553573303000107],
              [27.91703454600011, 4.558430888000132],
              [27.917861369000036, 4.560756328000068],
              [27.91610437000014, 4.562151591000145],
              [27.92034183700011, 4.565278016000093],
              [27.92923018400012, 4.569980571000073],
              [27.934294475000087, 4.568171896000081],
              [27.944526408000087, 4.557294006000035],
              [27.951244344000088, 4.555950419000069],
              [27.96250980600007, 4.557449036000065],
              [28.014031209000052, 4.550033467000063],
              [28.01708011800008, 4.539052226000067],
              [28.01211918100006, 4.52176646000008],
              [28.008915243000075, 4.499080505000109],
              [28.00958703600014, 4.488383484000096],
              [28.011240682000107, 4.480141093000071],
              [28.01418623900011, 4.472208761000019],
              [28.019043823000118, 4.462751974000042],
              [28.04973962400007, 4.419137064000083],
              [28.059764852000086, 4.420067240000051],
              [28.076301310000076, 4.437688904000126],
              [28.0855513920001, 4.443321635000061],
              [28.101726115000076, 4.442133077000037],
              [28.10834069800009, 4.433994039000126],
              [28.112371460000077, 4.414641215000074],
              [28.140225057000066, 4.379320374000073],
              [28.158725219000075, 4.360794373000132],
              [28.177587117000087, 4.34722931000006],
              [28.216964559000104, 4.342035827000046],
              [28.26104455500007, 4.350381572000103],
              [28.303160848000118, 4.352241923000108],
              [28.33685388200007, 4.327488912000092],
              [28.345845581000106, 4.30637909000005],
              [28.349101196000106, 4.292348938000131],
              [28.357421102000075, 4.282866313000071],
              [28.381502320000095, 4.275295716000102],
              [28.404136596000058, 4.277827860000087],
              [28.425427287000048, 4.290824483000037],
              [28.443927449000057, 4.308497823000039],
              [28.482426392000036, 4.35898569800014],
              [28.496844116000148, 4.369010926000072],
              [28.519271688000032, 4.374411113000036],
              [28.52878015200011, 4.37384267200008],
              [28.538495321000056, 4.371827291000045],
              [28.548210490000088, 4.370819601000065],
              [28.55730554200008, 4.373532613000094],
              [28.56428186100007, 4.382601828000062],
              [28.56671065200004, 4.394125672000087],
              [28.570534708000082, 4.405106914000072],
              [28.582420288000094, 4.412625834000025],
              [28.623658081000087, 4.422366842000073],
              [28.638644247000087, 4.432082011000105],
              [28.653733764000066, 4.452700907000107],
              [28.69517826400005, 4.532592672000106],
              [28.70406661000004, 4.533987935000098],
              [28.724530477000116, 4.533987935000098],
              [28.738173055000118, 4.540886739000072],
              [28.74685469600007, 4.549309998000055],
              [28.755432984000095, 4.553986714000118],
              [28.769178914000037, 4.549775086000082],
              [28.78364831500008, 4.530370585000114],
              [28.785095255000073, 4.507994690000132],
              [28.789952840000097, 4.488590190000068],
              [28.815274292000055, 4.478280741000063],
              [28.825712931000112, 4.478384094000091],
              [28.85620202600009, 4.482466532000089],
              [28.903640992000078, 4.478590800000049],
              [28.925551799000118, 4.480812887000056],
              [28.986219930000118, 4.495928243000051],
              [28.99407474800006, 4.487453308000056],
              [29.04234053600007, 4.455336405000125],
              [29.053192587000098, 4.450788879000086],
              [29.05598311400007, 4.436500346000102],
              [29.05887699300007, 4.437688904000126],
              [29.09856449400013, 4.420532328000064],
              [29.109829956000084, 4.412367452000055],
              [29.173495320000086, 4.348004456000069],
              [29.19612959800014, 4.337074890000096],
              [29.221296021000057, 4.340692240000081],
              [29.228685750000068, 4.356711935000121],
              [29.231579631000102, 4.375547994000044],
              [29.242845093000142, 4.387356059000055],
              [29.26744307400014, 4.387872823000095],
              [29.287390178000066, 4.383583679000125],
              [29.303926636000142, 4.387149353000098],
              [29.31870609600014, 4.411075542000091],
              [29.328938029000142, 4.43492421500008],
              [29.338859904000117, 4.44954864500005],
              [29.390226278000057, 4.49375783300006],
              [29.402628621000076, 4.512077128000044],
              [29.410896850000086, 4.532282613000035],
              [29.417304729000136, 4.555485331000042],
              [29.423919311000134, 4.566053162000102],
              [29.442729533000147, 4.583442281000131],
              [29.444589884000038, 4.59447519900003],
              [29.443659708000098, 4.604707133000105],
              [29.446760295000047, 4.622122091000051],
              [29.449240763000034, 4.657055359000125],
              [29.457612345000086, 4.669535217000117],
              [29.47259851000007, 4.672196554000053],
              [29.494095906000098, 4.668294983000081],
              [29.4981266690001, 4.665607809000065],
              [29.508461955000087, 4.655350037000076],
              [29.513267863000124, 4.652146098000102],
              [29.528822469000147, 4.659871725000102],
              [29.535023641000123, 4.660698547000024],
              [29.546392456000035, 4.657365418000026],
              [29.57667484600006, 4.644446309000017],
              [29.606750529000124, 4.643903707000064],
              [29.618532755000103, 4.641578268000032],
              [29.660287313000083, 4.622122091000051],
              [29.67186283400008, 4.613983053000126],
              [29.70080163600005, 4.588299866000057],
              [29.715322713000035, 4.579669901000017],
              [29.722919149000063, 4.578197123000109],
              [29.74514001400013, 4.583907369000059],
              [29.751754598000105, 4.581271871000041],
              [29.7744922280001, 4.567500102000096],
              [29.784620809000046, 4.563288472000053],
              [29.79671309400004, 4.556027934000085],
              [29.793302449000123, 4.545382589000084],
              [29.78829525200007, 4.539365877000094],
              [29.783690633000106, 4.533832906000058],
              [29.777696167000045, 4.523859355000042],
              [29.778522990000113, 4.515100199000059],
              [29.785447632000057, 4.498563741000069],
              [29.786997925000094, 4.489675395000063],
              [29.78565433700004, 4.479365947000062],
              [29.776765991000104, 4.449341939000092],
              [29.776197551000052, 4.405623678000026],
              [29.787824748000105, 4.368804220000115],
              [29.81485152200014, 4.346764222000033],
              [29.860688517000085, 4.347280986000072],
              [29.8827026780001, 4.344025371000086],
              [29.908489217000124, 4.329194234000056],
              [29.930348348000052, 4.308652853000069],
              [29.9401151940001, 4.28834401400006],
              [29.93685957800011, 4.278318787000032],
              [29.92931481900007, 4.268371073000125],
              [29.923217, 4.257751567000042],
              [29.924147176000076, 4.245581767000132],
              [29.932157023000116, 4.23615081800007],
              [29.942647339000075, 4.233773702000121],
              [29.954171183000085, 4.233825379000038],
              [29.966005087000042, 4.231809998000088],
              [29.989362834000076, 4.217779847000074],
              [30.00476241100006, 4.199279683000057],
              [30.027913452000064, 4.154450379000068],
              [30.042899617000046, 4.133108012000079],
              [30.057782430000145, 4.123651225000103],
              [30.099795369000105, 4.115098775000078],
              [30.122688029000074, 4.102463888000045],
              [30.133023315000116, 4.082801005000107],
              [30.138501018000113, 4.059701640000128],
              [30.147492716000045, 4.036653951000062],
              [30.171573934000094, 4.008180237000118],
              [30.17808516500014, 3.997095642000119],
              [30.180358927000043, 3.986217753000062],
              [30.180462280000086, 3.975649923000091],
              [30.18211592600005, 3.965521342000045],
              [30.189350627000124, 3.956090394000071],
              [30.205887085000086, 3.950380147000118],
              [30.270947713000055, 3.949449971000078],
              [30.337920370000063, 3.927875061000108],
              [30.418949015000067, 3.879712626000114],
              [30.456827840000074, 3.867594502000131],
              [30.465716186000122, 3.866095887000114],
              [30.485869995000087, 3.865579122000085],
              [30.495481812000094, 3.867077739000095],
              [30.505507039000122, 3.869764913000026],
              [30.51553226700014, 3.870850118000106],
              [30.525247436000086, 3.867542827000108],
              [30.538890015000106, 3.841549581000052],
              [30.562867880000113, 3.694866028000092],
              [30.56224776200014, 3.675332336000096],
              [30.55490970900013, 3.636394145000111],
              [30.549328654000135, 3.624095154000074],
              [30.543437541000117, 3.617868144000084],
              [30.543024129000116, 3.61290720700012],
              [30.553462769000134, 3.604509786000051],
              [30.56224776200014, 3.601357524000093],
              [30.572634725000057, 3.601047465000107],
              [30.592426798000133, 3.603527934000084],
              [30.604932496000117, 3.606680197000045],
              [30.636455119000118, 3.624095154000074],
              [30.653766724000093, 3.630606384000131],
              [30.665393921000145, 3.632053324000125],
              [30.693350870000074, 3.631949972000101],
              [30.71464156100012, 3.643809713000039],
              [30.731333048000067, 3.663498434000076],
              [30.746939331000135, 3.674867248000069],
              [30.765129435000063, 3.661715597000097],
              [30.769160197000133, 3.651845398000106],
              [30.772260783000092, 3.617558085000098],
              [30.77908207200005, 3.60259775800003],
              [30.7921045330001, 3.59270172100014],
              [30.823213746000135, 3.580428569000105],
              [30.837683147000064, 3.562677714000088],
              [30.827657918000057, 3.511104635000066],
              [30.83954349800007, 3.490201518000092],
              [30.86124759900008, 3.498211365000074],
              [30.88016117400008, 3.514411927000069],
              [30.89638757300014, 3.519967143000073],
              [30.909306681000146, 3.496144307000108],
              [30.909616740000104, 3.487178447000076],
              [30.902898804000074, 3.458911438000086],
              [30.90444909700011, 3.447465108000074],
              [30.91447432400014, 3.426484477000074],
              [30.916334676000133, 3.414805603000104],
              [30.910030152000047, 3.393411560000089],
              [30.904932931000076, 3.386035094000121],
              [30.89731774900008, 3.375014750000091],
              [30.86848230000004, 3.343337097000088],
              [30.848690226000144, 3.309256490000038],
              [30.84688155100008, 3.304398906000102],
              [30.845641317000116, 3.293908589000054],
              [30.842437377000067, 3.288740946000061],
              [30.837786499000117, 3.286415507000115],
              [30.82574589000012, 3.283676656000083],
              [30.82212854000005, 3.281402893000063],
              [30.804196818000094, 3.246004537000132],
              [30.763415783000085, 3.12343695000007],
              [30.747869507000075, 3.076712545000049],
              [30.743838745000062, 3.055473531000075],
              [30.74507898000013, 3.036301575000067],
              [30.757067912000082, 3.021470439000041],
              [30.80362837700011, 2.989069316000041],
              [30.82093998200014, 2.973152975000104],
              [30.843987671000093, 2.932793681000135],
              [30.854839722000122, 2.893209534000079],
              [30.853392782000128, 2.853367005000067],
              [30.82869144700004, 2.786084290000076],
              [30.82187015700009, 2.776162415000087],
              [30.81794274900011, 2.77419871000005],
              [30.805850464000116, 2.771873271000118],
              [30.801612997000063, 2.769082743000055],
              [30.799132528000086, 2.763450012000121],
              [30.798925822000058, 2.753528138000121],
              [30.797685587000103, 2.748360495000028],
              [30.76430261300004, 2.658391825000081],
              [30.762013299000046, 2.645781198000108],
              [30.76125370300008, 2.64159698500012],
              [30.758928263000087, 2.633793844000095],
              [30.739394572000037, 2.603304749000117],
              [30.73526045800014, 2.593072815000127],
              [30.734020223000073, 2.574469300000075],
              [30.737844279000058, 2.53746897400012],
              [30.737017456000103, 2.519537252000063],
              [30.729369344000133, 2.503465882000086],
              [30.71676029400004, 2.483105367000064],
              [30.707665243000065, 2.46227976500009],
              [30.710559123000053, 2.445123189000043],
              [30.724925171000052, 2.440782369000061],
              [30.794998413000087, 2.440110575000077],
              [30.804920288000062, 2.434374491000113],
              [30.80714237500007, 2.422178853000105],
              [30.80698734500004, 2.40698598200008],
              [30.809674520000044, 2.392361552000096],
              [30.819803101000105, 2.375980123000147],
              [30.836339559000123, 2.356343078000108],
              [30.85494307500005, 2.339703268000093],
              [30.87178959200014, 2.332055155000106],
              [30.900573364000138, 2.345956116000096],
              [30.91447432400014, 2.378150534000042],
              [30.930907430000104, 2.405590719000088],
              [30.968011109000088, 2.405435689000058],
              [30.984857626000064, 2.394635315000116],
              [31.04128828900008, 2.331228333000084],
              [31.043562052000084, 2.327042542000058],
              [31.045939168000075, 2.319652812000044],
              [31.04438887500004, 2.313916728000081],
              [31.038807820000102, 2.310971171000091],
              [31.035500529000103, 2.306940409000092],
              [31.04066817200004, 2.297897033000126],
              [31.055240926000067, 2.29024892200006],
              [31.09906254000009, 2.282704163000105],
              [31.11260176600007, 2.282084045000133],
              [31.129241577000073, 2.284667868000042],
              [31.17755904100011, 2.302909648000096],
              [31.17905765800009, 2.259759827000067],
              [31.18246830200013, 2.238727519000065],
              [31.190116415000034, 2.221519267000076],
              [31.21089034000005, 2.205344543000081],
              [31.267476033000037, 2.173253479000067],
              [31.27873986900005, 2.156021156000051],
              [31.280446818000087, 2.153409729000074],
              [31.280095681000034, 2.151441144000088],
              [31.271455119000052, 2.102999370000077],
              [31.24282637600004, 2.051167908000096],
              [31.183295125000086, 1.976211243000122],
              [31.119112996000126, 1.89536346400007],
              [31.096017547000145, 1.866363001000053],
              [31.025837036000098, 1.778238831000039],
              [30.954420207000112, 1.720671285000094],
              [30.817012573000056, 1.609515279000092],
              [30.68172367300008, 1.500348816000042],
              [30.597284383000044, 1.391673279000102],
              [30.55370445300008, 1.335632478000093],
              [30.478273560000105, 1.238633525000125],
              [30.458274780000067, 1.221683655000021],
              [30.445562378000147, 1.2127953090001],
              [30.431609741000045, 1.207007548000121],
              [30.412696167000092, 1.202046611000085],
              [30.399260295000147, 1.200599670000088],
              [30.376626017000092, 1.203080140000068],
              [30.36494714300011, 1.202046611000085],
              [30.34820398000005, 1.189024150000051],
              [30.33606001800007, 1.168870341000073],
              [30.323812703000044, 1.155847880000039],
              [30.306552775000057, 1.163909404000123],
              [30.295700724000085, 1.172642721000088],
              [30.28650231900008, 1.17429636600005],
              [30.2779757080001, 1.171609192000105],
              [30.269345744000134, 1.167268371000134],
              [30.23885664900007, 1.136004130000046],
              [30.236169475000054, 1.129492900000074],
              [30.234102417000088, 1.108098857000059],
              [30.231518596000058, 1.097763570000055],
              [30.22800459800004, 1.089030253000075],
              [30.215292195000075, 1.077092997000122],
              [30.215602255000135, 1.057766012000087],
              [30.22097660300011, 1.017096660000036],
              [30.21405196100011, 0.998544820000092],
              [30.191521037000086, 0.974877014000057],
              [30.186870158000147, 0.958753968000082],
              [30.183769572000074, 0.955136617000093],
              [30.165682820000086, 0.921443583000041],
              [30.154830770000046, 0.90867950500008],
              [30.14511560000011, 0.903150126000071],
              [30.038352092000082, 0.878913879000081],
              [29.996390829000063, 0.859948629000129],
              [29.982194040000138, 0.849017102000076],
              [29.960217326000077, 0.832095032000069],
              [29.947298218000128, 0.82460195000003],
              [29.928281290000086, 0.78501780200007],
              [29.926834350000092, 0.774889221000123],
              [29.93231205300009, 0.723161113000074],
              [29.920013061000134, 0.63867014500002],
              [29.91949629700008, 0.618102925000116],
              [29.937996460000136, 0.537280985000066],
              [29.940476928000066, 0.498316956000082],
              [29.92608285600005, 0.467073351000096],
              [29.92290694200011, 0.460179748000115],
              [29.903908655000066, 0.438229209000056],
              [29.851076701000125, 0.377187399000064],
              [29.839604533000056, 0.35848053000008],
              [29.832628215000113, 0.336983134000135],
              [29.80064050200008, 0.172445374000034],
              [29.79712650600004, 0.164797261000061],
              [29.787204630000133, 0.158492737000046],
              [29.780383342000107, 0.161179911000076],
              [29.773045288000105, 0.16748443600008],
              [29.76126306200007, 0.172135315000048],
              [29.75578535900013, 0.160869853000094],
              [29.711808715000075, 0.099581604000136],
              [29.703075399000113, 0.072503154000074],
              [29.701628458000073, 0.055243226000087],
              [29.713462362000087, 0.011628316000042],
              [29.71434086100004, -0.00749196299995],
              [29.709018188000073, -0.026302184999878],
              [29.694032023000148, -0.063095804999961],
              [29.67661706600012, -0.165105081999883],
              [29.670569225000122, -0.200867429999903],
              [29.653982788000064, -0.298947041999938],
              [29.650980745000084, -0.316454752999917],
              [29.629384806000076, -0.442400817999925],
              [29.631865275000052, -0.461211038999934],
              [29.634614925000108, -0.466968118999944],
              [29.64509444200013, -0.488909606999954],
              [29.64974532000008, -0.504309182999947],
              [29.653052612000067, -0.565597431999905],
              [29.650882202000105, -0.579550068999893],
              [29.642820679000124, -0.585027770999972],
              [29.632175334000124, -0.585751240999883],
              [29.622873576000075, -0.588438414999899],
              [29.618842814000118, -0.599393818999971],
              [29.62049646000014, -0.605388284999904],
              [29.62824792500004, -0.616033629999905],
              [29.6305733640001, -0.622028095999923],
              [29.629281453000146, -0.629779560999935],
              [29.62442386800012, -0.634843851999918],
              [29.618842814000118, -0.638977965999928],
              [29.615535522000073, -0.644145608999935],
              [29.603029826000125, -0.722900491999937],
              [29.602203003000056, -0.743777770999912],
              [29.611091349000105, -0.782741799999897],
              [29.61336511200011, -0.80382578499993],
              [29.61078129100008, -0.863977152999965],
              [29.607990764000135, -0.878446553999908],
              [29.596725301000106, -0.891882425999952],
              [29.56716638200004, -0.90190765399997],
              [29.556004273000042, -0.919477640999943],
              [29.554660686000148, -0.928572691999918],
              [29.55528080200014, -0.938494567999911],
              [29.559156535000056, -0.95730478899992],
              [29.56034509300008, -0.972084247999945],
              [29.556521037000095, -0.981799417999881],
              [29.55151757200008, -0.990305308999964],
              [29.551353394000046, -0.990584411999876],
              [29.54845951300007, -1.002573343999927],
              [29.55119836400013, -1.0201433309999],
              [29.56592614800013, -1.058590595999945],
              [29.57006026200014, -1.077917581999898],
              [29.569130087000076, -1.095900979999982],
              [29.556934448000106, -1.15770599299988],
              [29.557037801000035, -1.181787210999914],
              [29.565254354000047, -1.197910257999908],
              [29.575537964000034, -1.213206480999958],
              [29.581429077000053, -1.23480722999993],
              [29.580447225000057, -1.243282164999925],
              [29.57099043800008, -1.268603616999911],
              [29.571507202000134, -1.279248961999897],
              [29.583186076000118, -1.299299417999947],
              [29.5871134840001, -1.310564879999916],
              [29.58732019100006, -1.329685159999912],
              [29.577915080000082, -1.388389587999953],
              [29.53864099100008, -1.402342223999938],
              [29.498746785000094, -1.431074319999951],
              [29.464330282000105, -1.466937764999898],
              [29.445065226000054, -1.497286823999929],
              [29.44169600400005, -1.502594501999894],
              [29.43962894700013, -1.504764912999875],
              [29.437406861000113, -1.506211852999868],
              [29.434926392000136, -1.506831969999936],
              [29.358496948000038, -1.509932555999882],
              [29.342787313000088, -1.516547138999968],
              [29.331211792000147, -1.531429951999925],
              [29.30382328200011, -1.587860615999944],
              [29.29369470200004, -1.600986429999921],
              [29.24542891400006, -1.640983987999974],
              [29.233336629000064, -1.65865732799989],
              [29.212252645000035, -1.698654886999861],
              [29.18664003500004, -1.739618238999896],
              [29.14931075000004, -1.799320575999914],
              [29.130500529000102, -1.84334889699997],
              [29.12553959200008, -1.879108988999889],
              [29.12771000100014, -1.915695901999925],
              [29.15427168700006, -2.072688903999975],
              [29.15633874500014, -2.108655700999861],
              [29.150550984000063, -2.150410257999908],
              [29.134841349000084, -2.197745869999963],
              [29.109829956000084, -2.236709899999951],
              [29.075413452000134, -2.263891702999928],
              [29.03092004400014, -2.275673928999936],
              [29.00213627100004, -2.274743753999886],
              [28.99366133600003, -2.277740986999987],
              [28.98337772600013, -2.287352802999905],
              [28.982189168000104, -2.296034443999872],
              [28.97877852400009, -2.306783141999887],
              [28.971233765000136, -2.321665954999929],
              [28.95965824400008, -2.339752705999942],
              [28.945447225000123, -2.35422210699997],
              [28.928135620000035, -2.364454039999956],
              [28.907258342000063, -2.370551858999917],
              [28.88038659600005, -2.379853616999938],
              [28.866330607000123, -2.391945901999932],
              [28.85883752400011, -2.418197529999958],
              [28.86085290500006, -2.439591572999873],
              [28.864573608000057, -2.459435322999866],
              [28.874702189000118, -2.477522073999879],
              [28.878216187000078, -2.489717711999987],
              [28.86085290500006, -2.505220641999912],
              [28.857235555000074, -2.518346455999961],
              [28.860956258000073, -2.531162210999952],
              [28.869844605000083, -2.537260029999914],
              [28.881058390000135, -2.542634378999963],
              [28.891342000000122, -2.553073017999907],
              [28.89805993700014, -2.57632741299993],
              [28.891342000000122, -2.65270517999997],
              [28.899093465000135, -2.66066335099994],
              [28.936403849000072, -2.685054625999967],
              [28.949736369000107, -2.690325621999904],
              [28.979605347000103, -2.693529560999963],
              [29.00012089000009, -2.703658141999924],
              [29.015365438000117, -2.720711364999957],
              [29.02859460400012, -2.744895934999931],
              [29.008234090000087, -2.747479756999923],
              [28.995521688000053, -2.758435159999905],
              [28.988803751000034, -2.775488382999939],
              [28.9868917230001, -2.796779072999925],
              [28.99490157000008, -2.813625589999901],
              [29.013143351000025, -2.818896585999937],
              [29.034072306000013, -2.820860290999875],
              [29.04905847100008, -2.827474873999961],
              [29.053502645000094, -2.835433044999931],
              [29.0627010500001, -2.862201435999907],
              [29.07758386200004, -2.884008890999922],
              [29.081717977000068, -2.893930764999922],
              [29.083268270000076, -2.910053812999905],
              [29.089779500000134, -2.926073506999955],
              [29.10507572500009, -2.934135029999936],
              [29.123369181000072, -2.940232848999898],
              [29.13840702300007, -2.950361429999944],
              [29.144246460000147, -2.966277770999881],
              [29.1481738680001, -2.986948342999895],
              [29.156752157000142, -3.004828388999954],
              [29.175975789000063, -3.012476500999924],
              [29.19447595200009, -3.014646910999915],
              [29.211529175000123, -3.021158141999891],
              [29.22537845800008, -3.031803486999891],
              [29.23462854000013, -3.046582946999905],
              [29.241539256000067, -3.104187711999913],
              [29.2423283280001, -3.110765075999936],
              [29.237780803000078, -3.122237243999948],
              [29.225016724000113, -3.129368590999889],
              [29.21752364100007, -3.146215107999879],
              [29.21411299600004, -3.166472268999968],
              [29.2169035230001, -3.23313486699989],
              [29.22382816600009, -3.2526685589999],
              [29.240881388000105, -3.266311136999903],
              [29.23611684100007, -3.270703730999898],
              [29.213079468000046, -3.291942646999956],
              [29.208738648000065, -3.305275165999888],
              [29.2066715900001, -3.334524027999933],
              [29.22517175300004, -3.588565367999948],
              [29.223259725000105, -3.667010191999879],
              [29.217122763000134, -3.709265928999912],
              [29.206568237000056, -3.781938578999899],
              [29.215043172000094, -3.899864195999939],
              [29.224551636000058, -3.926529235999894],
              [29.239796183000124, -3.948026630999919],
              [29.27772668400013, -3.988954365999945],
              [29.3394800210001, -4.093237405999972],
              [29.36722380600014, -4.189048239999877],
              [29.37275964400004, -4.208165791999903],
              [29.404178915000102, -4.449804788999955],
              [29.40727950000013, -4.462620543999947],
              [29.410896850000086, -4.502308043999932],
              [29.401336711000113, -4.586850686999895],
              [29.34082360800005, -4.751698506999986],
              [29.32103153500009, -4.836344502999893],
              [29.323770386000035, -4.920163675999959],
              [29.342792981000116, -4.999952894999922],
              [29.34423425300008, -5.005998229999889],
              [29.377823934000105, -5.087543639999936],
              [29.45564864100004, -5.22996388699994],
              [29.496369669000046, -5.391711119999883],
              [29.593521363000036, -5.620327657],
              [29.612434936000056, -5.704353534999925],
              [29.603029826000125, -5.781661478999936],
              [29.570887085000095, -5.83798878999994],
              [29.496059611000135, -5.938654479999897],
              [29.476112508000142, -6.002113137999928],
              [29.478696330000048, -6.041800637999913],
              [29.5088236900001, -6.153731790999927],
              [29.525515177000045, -6.273104349999869],
              [29.53771081500014, -6.312378438999929],
              [29.56602950000007, -6.35950734499994],
              [29.633932332000086, -6.446943867999906],
              [29.684368530000086, -6.581509297999958],
              [29.70700280800014, -6.619336445999934],
              [29.73862878400007, -6.652409362999919],
              [29.873090861000094, -6.754211933999983],
              [29.969112805000123, -6.803040265999911],
              [30.01272058100011, -6.825215351999887],
              [30.09085534600007, -6.89001759899989],
              [30.23467085800013, -7.057139179999893],
              [30.294460490000063, -7.149433288999958],
              [30.369598022000105, -7.310250345999876],
              [30.40494470200008, -7.436030780999943],
              [30.414711548000128, -7.501969908999868],
              [30.441634969000063, -7.596331074999895],
              [30.654955282000117, -7.927370299999936],
              [30.72812911000011, -8.10410369899995],
              [30.752106975000117, -8.194124042999917],
              [30.581781453000133, -8.219962259999932],
              [30.32494958500007, -8.25892628999992],
              [30.123618204000138, -8.289518736999938],
              [29.858104695000122, -8.329826354999895],
              [29.59228112800008, -8.370237324999962],
              [29.57584432400006, -8.372729113999895],
              [29.365938354000093, -8.404550475999898],
              [29.208118530000093, -8.428528340999904],
              [29.03510583500008, -8.45477996799994],
              [28.91526818900013, -8.472866718999867],
              [28.889171590000046, -8.483098652999928],
              [28.89278894100002, -8.501908873999938],
              [28.93547367300002, -8.5907923379999],
              [28.930461059000066, -8.679882506999903],
              [28.893098999000102, -8.76576873699993],
              [28.765406534000107, -8.93402720099995],
              [28.599060099000013, -9.09639455099996],
              [28.5061975510001, -9.164400736999951],
              [28.41509200000013, -9.20708546899995],
              [28.3723039140001, -9.235094094999866],
              [28.35246016500011, -9.271991067999892],
              [28.368531535000074, -9.308577981999917],
              [28.41137129700013, -9.324907734999954],
              [28.460463908000065, -9.335036314999911],
              [28.49539717600007, -9.353226419999956],
              [28.51596439600013, -9.378341165999885],
              [28.518134806000035, -9.39746144599988],
              [28.51627445400004, -9.415548196999893],
              [28.514724162000107, -9.430017597999921],
              [28.519685099000043, -9.44562388099996],
              [28.531570679000083, -9.456889342999915],
              [28.555600219000098, -9.474459329999902],
              [28.56278324400006, -9.484897969999935],
              [28.56686568200007, -9.495956725999932],
              [28.568726033000075, -9.50897918699988],
              [28.569191121000102, -9.525929056999885],
              [28.574100383000143, -9.539158223999962],
              [28.586296021000067, -9.544015807999898],
              [28.617766968000097, -9.543292337999986],
              [28.611100708000095, -9.5510438029999],
              [28.58862146000007, -9.558278503999873],
              [28.583557169000102, -9.563756204999947],
              [28.587587931000087, -9.573161315999911],
              [28.60650150500004, -9.594348652999969],
              [28.610842326000125, -9.607887878999946],
              [28.612909383000073, -9.61749969499995],
              [28.621797730000083, -9.638273620999911],
              [28.62386478700006, -9.64912567099995],
              [28.625156697000108, -9.69563445999998],
              [28.63125451600007, -9.715581562999915],
              [28.644948771000088, -9.735115253999922],
              [28.654973999000106, -9.74193654399997],
              [28.66365564000006, -9.745037128999911],
              [28.669960165000077, -9.750928242999919],
              [28.672337280000136, -9.765500995999972],
              [28.698485555000047, -9.791959329999955],
              [28.696521851000085, -9.796506855999894],
              [28.678073364000085, -9.803844908999892],
              [28.668461548000067, -9.821621601999922],
              [28.65869470200002, -9.864823099999867],
              [28.62794722400008, -9.92941863999991],
              [28.62386478700006, -9.951019388999967],
              [28.63125451600007, -10.02305633499995],
              [28.628515665000123, -10.102741393999906],
              [28.619627319000102, -10.141912129999938],
              [28.60402103700008, -10.172711282999913],
              [28.57931970200005, -10.20113332099993],
              [28.56991459200009, -10.219633483999957],
              [28.60402103700008, -10.24836557999987],
              [28.6059847410001, -10.252913106999912],
              [28.608051798000076, -10.263558450999895],
              [28.610842326000125, -10.268829447999934],
              [28.6133227950001, -10.270689798999939],
              [28.62210778800008, -10.275857441999932],
              [28.62386478700006, -10.276374205999971],
              [28.62923913600011, -10.295907897999896],
              [28.62644860900005, -10.311410826999904],
              [28.620712524000112, -10.327327167999925],
              [28.617766968000097, -10.34830779999993],
              [28.620867554000142, -10.373319192999915],
              [28.62861901900004, -10.391095885999945],
              [28.63771407100012, -10.407012226999967],
              [28.644948771000088, -10.426545918999892],
              [28.646085653000085, -10.438431497999915],
              [28.644535360000077, -10.451040547999938],
              [28.640607950000117, -10.462616067999889],
              [28.634716838000116, -10.471607767999927],
              [28.630479370000046, -10.481012878999891],
              [28.638747599000112, -10.496205748999913],
              [28.634716838000116, -10.50571421299989],
              [28.63492354300007, -10.519460143999922],
              [28.648049357000048, -10.537650247999878],
              [28.672337280000136, -10.564315286999914],
              [28.67269901600011, -10.576097513999912],
              [28.667169637000114, -10.597388203999898],
              [28.665515991000063, -10.608963724999853],
              [28.67089034100013, -10.619092304999896],
              [28.69424808800008, -10.636765644999898],
              [28.69962243600014, -10.643173522999945],
              [28.694351440000105, -10.66332733099992],
              [28.681535685000114, -10.681930846999876],
              [28.665877726000076, -10.697433776999972],
              [28.65187341300006, -10.708389179999955],
              [28.64618900500011, -10.709836120999867],
              [28.633476604000066, -10.708905944999898],
              [28.627585490000058, -10.711696471999872],
              [28.623244670000076, -10.716864114999865],
              [28.608051798000076, -10.741358744999914],
              [28.600920451000036, -10.76316619899994],
              [28.593479044000105, -10.772881367999972],
              [28.576529174000086, -10.790658060999917],
              [28.56350671400014, -10.811948750999903],
              [28.554411662000092, -10.834996438999951],
              [28.549450724000053, -10.85856089299996],
              [28.549450724000053, -10.902899271999914],
              [28.54717696100002, -10.913751322999957],
              [28.53735843900006, -10.93411183699989],
              [28.535084676000054, -10.944447122999904],
              [28.53136397300011, -10.95509246799989],
              [28.513793986000053, -10.97286916099992],
              [28.507851196000047, -10.982067565999927],
              [28.50666263800011, -10.992092793999944],
              [28.50862634300006, -11.01348683599987],
              [28.507851196000047, -11.023615417999906],
              [28.504078816000117, -11.034364115999935],
              [28.49095300300013, -11.058652038999924],
              [28.4767936610001, -11.077979023999973],
              [28.47617354300013, -11.087694193999923],
              [28.48692224100006, -11.140920918999882],
              [28.48733565200007, -11.153426614999972],
              [28.484751831000068, -11.162831725999936],
              [28.47622522000006, -11.17544077599996],
              [28.473693074000067, -11.181228534999931],
              [28.472452840000102, -11.191977232999946],
              [28.473693074000067, -11.225670266999913],
              [28.4550895590001, -11.263704121999936],
              [28.445581096000126, -11.274556172999894],
              [28.436175985000148, -11.28912892699995],
              [28.431990194000036, -11.311039733999905],
              [28.439586629000075, -11.348246764999914],
              [28.434212280000025, -11.35124399799993],
              [28.411991414000084, -11.368400573999892],
              [28.40858077000007, -11.372431334999888],
              [28.357007690000046, -11.446948750999937],
              [28.354423869000044, -11.464725443999953],
              [28.355664103000095, -11.518158874999884],
              [28.360314982000148, -11.533558451999866],
              [28.36558597800007, -11.541619973999957],
              [28.377419881000094, -11.571075540999871],
              [28.38491296300012, -11.581307473999942],
              [28.399589071000037, -11.596086933999857],
              [28.405480183000122, -11.60518198599992],
              [28.4227401120001, -11.664713235999898],
              [28.42211999500006, -11.674738464999919],
              [28.418399292000117, -11.678872578999943],
              [28.425117228000147, -11.68807098399995],
              [28.439586629000075, -11.701506855999895],
              [28.442687215000035, -11.711635436999941],
              [28.45250573700011, -11.78077850399994],
              [28.460670613000104, -11.79338755299996],
              [28.4767936610001, -11.798245136999881],
              [28.488885946000096, -11.808683776999914],
              [28.49715417500005, -11.857362975999948],
              [28.507851196000047, -11.87276255299993],
              [28.521132039000037, -11.865734557999915],
              [28.531570679000083, -11.866458027999911],
              [28.54056237700013, -11.87203908199993],
              [28.549450724000053, -11.879583841999889],
              [28.554204956000035, -11.885061543999967],
              [28.566090536000075, -11.904491881999945],
              [28.569191121000102, -11.913690286999952],
              [28.592652222000083, -11.90046112099995],
              [28.60619144700007, -11.910279642999924],
              [28.62386478700006, -11.947796731999915],
              [28.63688724700009, -11.95761525399989],
              [28.68603153500004, -11.984073587999973],
              [28.70706384300007, -11.989447936999937],
              [28.741997111000046, -11.984280292999927],
              [28.751092163000123, -11.992238463999897],
              [28.754192749000083, -12.020143737999973],
              [28.7598771560001, -12.035233255999884],
              [28.773623088000136, -12.04587860099987],
              [28.808866414000107, -12.064585468999951],
              [28.82147546300004, -12.07574757899988],
              [28.835014689000047, -12.092180683999942],
              [28.84597009300009, -12.111300963999938],
              [28.850414266000115, -12.130007831999919],
              [28.85950931800008, -12.14179005899993],
              [28.918730509000085, -12.174346211999875],
              [28.944672079000043, -12.20607554099989],
              [29.026114136000047, -12.353043313999919],
              [29.02859460400012, -12.36306854299994],
              [29.0303516030001, -12.376194355999914],
              [29.03510583500008, -12.378881530999948],
              [29.042650594000037, -12.37877817799992],
              [29.052779175000097, -12.383842467999983],
              [29.067248576000026, -12.384772643999938],
              [29.0844051520001, -12.376401061999971],
              [29.100218140000095, -12.374023945999923],
              [29.111070191000124, -12.393454284999905],
              [29.128123413000083, -12.382808939999919],
              [29.14894901600013, -12.373713886999937],
              [29.17339196700007, -12.36761606799989],
              [29.254989054000134, -12.366169127999896],
              [29.265065958000093, -12.370923359999978],
              [29.28304935700004, -12.390457050999899],
              [29.295503377000045, -12.400999043999946],
              [29.304856811000093, -12.404823099999902],
              [29.316432332000147, -12.406683450999907],
              [29.356533244000047, -12.407613626999947],
              [29.364388062000046, -12.409267272999898],
              [29.405935913000064, -12.431694843999892],
              [29.432600952000087, -12.44130665999991],
              [29.43921553600012, -12.44203013099991],
              [29.453323202000036, -12.44078989699996],
              [29.459886108000035, -12.44130665999991],
              [29.465260457000056, -12.444200540999901],
              [29.46877445400014, -12.44843800799994],
              [29.47301192200007, -12.452468770999943],
              [29.480453328000124, -12.454949238999916],
              [29.499676961000034, -12.453088886999907],
              [29.514663126000073, -12.443890482999905],
              [29.524688355000137, -12.429214374999916],
              [29.52820235200005, -12.410507506999934],
              [29.52344812000007, -12.392524108999865],
              [29.511459188000117, -12.387356465999943],
              [29.496059611000135, -12.38632293699996],
              [29.480453328000124, -12.380535175999896],
              [29.450377645000117, -12.342914733999876],
              [29.446553589000075, -12.335059915999935],
              [29.448155559000043, -12.326791685999893],
              [29.45182458500011, -12.317799987999948],
              [29.455907023000123, -12.294338887999885],
              [29.46794763200012, -12.25527150399995],
              [29.474252157000137, -12.24266245499993],
              [29.489548381000077, -12.231500344999901],
              [29.533473348000086, -12.21672088599989],
              [29.553058716000123, -12.20514536599994],
              [29.56757979300005, -12.191709491999887],
              [29.576726522000058, -12.188092141999903],
              [29.590317423000045, -12.188092141999903],
              [29.603184855000052, -12.192846373999899],
              [29.621116577000123, -12.210209655999918],
              [29.631865275000052, -12.215997415999894],
              [29.648918498000057, -12.21279347699992],
              [29.701266724000106, -12.189022317999957],
              [29.73490808100013, -12.164837747999897],
              [29.756095419000076, -12.157603046999924],
              [29.799296915000127, -12.154089049999868],
              [29.799396783000134, -12.155820078999923],
              [29.799582314000133, -12.159035937999903],
              [29.79960697500013, -12.159463398999932],
              [29.799400268000056, -12.265813496999925],
              [29.799141887000076, -12.38229217599988],
              [29.798986857000045, -12.548690286999886],
              [29.798676799000077, -12.698345234999948],
              [29.798470093000105, -12.87301157599991],
              [29.798211711000135, -13.022769876999902],
              [29.797953328000062, -13.164363300999966],
              [29.79774662300008, -13.313759866999959],
              [29.797643270000094, -13.424244078999976],
              [29.78224369300011, -13.45566334999991],
              [29.767154175000087, -13.45835052399994],
              [29.70286869300014, -13.457627054999946],
              [29.663077840000142, -13.446878356999932],
              [29.64147709200006, -13.43850677499995],
              [29.626077515000077, -13.429825133999898],
              [29.617395874000124, -13.421246846999864],
              [29.610677938000094, -13.411014912999889],
              [29.6055102950001, -13.399956155999888],
              [29.60168623900006, -13.388380634999933],
              [29.60168623900006, -13.374427998999934],
              [29.60943770300014, -13.36905364999997],
              [29.618946167000047, -13.367296650999904],
              [29.625147339000137, -13.364196064999959],
              [29.62700769100013, -13.354894307999928],
              [29.625043986000094, -13.334843851999977],
              [29.62659427900013, -13.326368916999883],
              [29.633622274000118, -13.31892751099987],
              [29.651502319000087, -13.31458668999997],
              [29.658892049000087, -13.309522399999906],
              [29.66359460500007, -13.301874287999922],
              [29.667522013000053, -13.29195241199993],
              [29.669175659000075, -13.281203713999915],
              [29.666591837000055, -13.271178486999887],
              [29.65749678600008, -13.26011973099989],
              [29.64974532000008, -13.259913024999932],
              [29.64106368000006, -13.26280690499992],
              [29.629074748000107, -13.26146331799994],
              [29.60985111500014, -13.2494743849999],
              [29.592797892000135, -13.23562510199993],
              [29.574401082000122, -13.22539316799994],
              [29.551043335000088, -13.224152933999918],
              [29.527995646000136, -13.234074807999903],
              [29.47001468900004, -13.287818297999905],
              [29.449550822000106, -13.300323994999914],
              [29.308267456000124, -13.353654072999902],
              [29.25018314600004, -13.391584573999907],
              [29.227445516000046, -13.400782979999903],
              [29.2140096440001, -13.408327737999954],
              [29.194786011000076, -13.43096201599991],
              [29.184140665000086, -13.4368531289999],
              [29.168947795000065, -13.433855895999983],
              [29.16016280100007, -13.422073668999886],
              [29.153393188000052, -13.406984150999975],
              [29.1444531650001, -13.394478453999895],
              [29.122128947000135, -13.384349873999938],
              [29.098047730000104, -13.38465993199992],
              [29.072932983000072, -13.388587341999894],
              [29.065386147000112, -13.388676477999894],
              [29.046681356000136, -13.388897399999877],
              [29.028491251000105, -13.395511982999963],
              [29.010301147000064, -13.399439391999934],
              [28.993971395000102, -13.395925394999978],
              [28.980845581000068, -13.380215759999913],
              [28.95035648600006, -13.350966897999868],
              [28.934130086000067, -13.309625752999935],
              [28.903434285000117, -13.162296243999904],
              [28.89185876500008, -13.147310078999936],
              [28.8827120360001, -13.143589375999923],
              [28.863230021000106, -13.14265919999987],
              [28.853669881000087, -13.137078144999947],
              [28.844213094000025, -13.102351582999916],
              [28.840905803000027, -13.100077819999896],
              [28.835428101000048, -13.098940937999899],
              [28.829743693000097, -13.097183938999919],
              [28.82581628400004, -13.092843118999937],
              [28.82462772700009, -13.087262063999916],
              [28.826022990000098, -13.076823424999887],
              [28.8252995200001, -13.072379251999877],
              [28.82550622600013, -13.067831725999937],
              [28.830260458000055, -13.056876321999951],
              [28.830880574000105, -13.051812031999887],
              [28.827056518000063, -13.04757456399993],
              [28.813620646000118, -13.042820331999934],
              [28.80943485500009, -13.038376159999927],
              [28.80059818500007, -13.00240936299987],
              [28.7933634850001, -12.991557311999912],
              [28.775690144000095, -12.97657114599994],
              [28.707994018000107, -12.889754739999944],
              [28.66789310700011, -12.849343769999876],
              [28.621177612000025, -12.839421895999877],
              [28.60815515200008, -12.847896829999883],
              [28.593685751000066, -12.876732279999914],
              [28.583970581000102, -12.888721210999876],
              [28.568467652000095, -12.895542500999923],
              [28.55337813300011, -12.894922383999955],
              [28.542836141000038, -12.885620625999934],
              [28.53942549700011, -12.833840840999954],
              [28.523612508000014, -12.81017303399993],
              [28.50159834800013, -12.788468932999933],
              [28.48092777500011, -12.762113951999964],
              [28.474003133000053, -12.736482441999911],
              [28.48397668400014, -12.722219745999936],
              [28.500151408000136, -12.710954284999971],
              [28.511623575000073, -12.694417825999977],
              [28.51229537000006, -12.668372905],
              [28.502011760000045, -12.6495626829999],
              [28.468267049000076, -12.614629414999897],
              [28.45591638200011, -12.59209848999997],
              [28.436434367000118, -12.542799173999882],
              [28.4227401120001, -12.521301777999938],
              [28.33974776200006, -12.450505065999906],
              [28.32248783400007, -12.441099954999856],
              [28.303677612000058, -12.43541554799991],
              [28.28383386300007, -12.43407195999994],
              [28.26388675900006, -12.436965840999932],
              [28.23753177900008, -12.437069192999957],
              [28.220065145000035, -12.425390319999892],
              [28.204975626000135, -12.41081756599992],
              [28.185751994000015, -12.40244598399994],
              [28.160740601000043, -12.40875050799987],
              [28.1459611410001, -12.423116555999869],
              [28.131285034000115, -12.429214374999916],
              [28.106997111000112, -12.410197448999952],
              [28.102449585000073, -12.401205748999914],
              [28.100434204000123, -12.391490579999882],
              [28.09686853100007, -12.383015644999958],
              [28.087670125000074, -12.377537943999883],
              [28.014031209000052, -12.370509948999967],
              [27.998993367000082, -12.371440124999921],
              [27.981009969000098, -12.374540709999877],
              [27.958685750000114, -12.367822774999937],
              [27.952226196000083, -12.346532083999946],
              [27.94845381600004, -12.321417337999932],
              [27.933881062000097, -12.30333058699992],
              [27.877036987000054, -12.26994761099985],
              [27.856676473000107, -12.262402851999894],
              [27.831406698000137, -12.259922383999921],
              [27.818280884000075, -12.267777201999948],
              [27.807273803000072, -12.281419778999876],
              [27.788308553000036, -12.296509296999957],
              [27.756734252000058, -12.30426076299996],
              [27.710742228000072, -12.306327819999936],
              [27.666197143000147, -12.302710469999852],
              [27.63818851700006, -12.29361541699997],
              [27.59529707900009, -12.247313333999898],
              [27.589836216000066, -12.242957985999865],
              [27.536075887000095, -12.200081074999957],
              [27.520469605000073, -12.179617206999907],
              [27.471790405000036, -12.041641133999917],
              [27.46755293800007, -12.001643574999946],
              [27.420734090000053, -11.921958516999894],
              [27.234182169000064, -11.809097187999924],
              [27.209997599000104, -11.72197072299987],
              [27.211961304000027, -11.688277689999907],
              [27.20762048300014, -11.639391783999926],
              [27.197181844000113, -11.593709818999912],
              [27.18012862100008, -11.569628600999877],
              [27.173617391000107, -11.570558775999913],
              [27.144988647000048, -11.581307473999942],
              [27.10220056200012, -11.584924824999916],
              [27.064373413000027, -11.59712046299994],
              [27.054451538000137, -11.59753387499994],
              [27.032437378000054, -11.594329935999966],
              [27.02375573800009, -11.595570169999917],
              [27.010268189000044, -11.609832864999888],
              [27.010836629000096, -11.628849792999858],
              [27.023238973000048, -11.671121113999945],
              [27.021481975000086, -11.69788950599991],
              [27.011146688000082, -11.713185729999879],
              [26.996367228000054, -11.727035013999938],
              [26.981071004000086, -11.749049173999921],
              [26.971355835000054, -11.788529967999935],
              [26.96732507300007, -11.870385436999882],
              [26.94768802900012, -11.909142760999913],
              [26.912754761000144, -11.942525736999883],
              [26.87420414300007, -11.964333190999909],
              [26.831726115000038, -11.973324889999944],
              [26.785010620000037, -11.968363951999905],
              [26.759379109000065, -11.96867401099989],
              [26.744186239000044, -11.981179707999985],
              [26.732559042000076, -11.998336282999944],
              [26.717417847000064, -12.013012389999929],
              [26.697057333000117, -12.01745656299994],
              [26.679797404000055, -12.009601744999912],
              [26.662744181000107, -11.996579284999967],
              [26.643520548000083, -11.985520527999967],
              [26.605900106000064, -11.977769062999954],
              [26.524871460000043, -11.972291360999876],
              [26.489111369000028, -11.960819192999864],
              [26.470714559000044, -11.94696990899999],
              [26.455418335000076, -11.931983743999922],
              [26.438365112000042, -11.919064635999916],
              [26.414593953000093, -11.911829934999943],
              [26.37635339400009, -11.912863463999926],
              [26.339146362000093, -11.918961282999888],
              [26.32881107600008, -11.923302103999958],
              [26.309174032000044, -11.936531269999946],
              [26.298011922000114, -11.941182148999914],
              [26.286229696000106, -11.940562031999946],
              [26.265559123000088, -11.930846862999914],
              [26.229592326000017, -11.933120625999933],
              [26.209335164, -11.923612161999941],
              [26.189078003000105, -11.910899759999893],
              [26.166650431000107, -11.902424824999898],
              [25.99405114800004, -11.904801940999931],
              [25.9811320390001, -11.903044941999951],
              [25.963562052000043, -11.895086770999896],
              [25.94981612100011, -11.863977559999938],
              [25.935553426000126, -11.853642272999934],
              [25.91415938300011, -11.84558074899985],
              [25.859589070000084, -11.801965839999895],
              [25.855765015000145, -11.797211608999902],
              [25.850700724000063, -11.79380096399997],
              [25.83984867400011, -11.791940612999966],
              [25.832510620000022, -11.79380096399997],
              [25.812666870000044, -11.802999368999878],
              [25.801608114000118, -11.804239602999914],
              [25.744040568000088, -11.803826191999903],
              [25.725643758000103, -11.8005188999999],
              [25.687403198000112, -11.778711445999875],
              [25.655777222000097, -11.750496113999915],
              [25.621464071000077, -11.728895365999932],
              [25.575678752000044, -11.72734507199992],
              [25.567823934000103, -11.733752949999953],
              [25.564930054000115, -11.74398488299994],
              [25.561002645000144, -11.75328664099996],
              [25.550253947000044, -11.756593932999877],
              [25.53764489700012, -11.758350931999942],
              [25.530616902000105, -11.764242044999946],
              [25.524519083000143, -11.77095998199988],
              [25.515217326000112, -11.775817565999887],
              [25.495580281000088, -11.776541035999884],
              [25.480439087000065, -11.769823099999954],
              [25.474134562000046, -11.756180520999948],
              [25.482816203000112, -11.731169128999866],
              [25.48328129100014, -11.725794778999898],
              [25.482816203000112, -11.720420430999937],
              [25.48116255700006, -11.715252786999926],
              [25.46359257000009, -11.700059915999901],
              [25.406335083000045, -11.673084817999964],
              [25.39755008900005, -11.664919942999859],
              [25.392795858000056, -11.656445007999949],
              [25.38638798000011, -11.649830423999958],
              [25.373158813000117, -11.647143249999928],
              [25.360446411000055, -11.647246601999953],
              [25.351971477000063, -11.646109720999945],
              [25.344943482000048, -11.642182311999889],
              [25.33677860500012, -11.633500671999926],
              [25.327373494000085, -11.616654154999935],
              [25.300398397000066, -11.53500539099987],
              [25.29750451600006, -11.51722869899993],
              [25.297711223000107, -11.507926939999905],
              [25.301741984000103, -11.498418476999916],
              [25.315384562000105, -11.482502135999894],
              [25.316728149000085, -11.472993671999916],
              [25.309286743000058, -11.455423685999932],
              [25.286652465000117, -11.416563008999972],
              [25.27900435400005, -11.396305846999965],
              [25.277970825000068, -11.37181121799992],
              [25.28634240700012, -11.36064910899998],
              [25.298021281000103, -11.351450703999888],
              [25.306496216000113, -11.333053893999889],
              [25.30132857300009, -11.324475605999865],
              [25.290166463000077, -11.315897317999926],
              [25.28468876100007, -11.307319030999892],
              [25.29626428200004, -11.298430684999886],
              [25.317141561000085, -11.290472513999916],
              [25.324893025000108, -11.283651223999868],
              [25.325409790000037, -11.273936054999922],
              [25.32334273300009, -11.25347218799996],
              [25.32458296700011, -11.227840677999907],
              [25.32251591000005, -11.20541310599991],
              [25.31032027200004, -11.194767760999909],
              [25.27879764800008, -11.199935403999916],
              [25.184023071000126, -11.246650898999917],
              [25.124285116000095, -11.259156595999912],
              [24.981244751000133, -11.27186899799996],
              [24.9429008380001, -11.26856170699996],
              [24.901042928000038, -11.28127410799992],
              [24.826732218000046, -11.317550963999878],
              [24.787974894000115, -11.325819192999916],
              [24.712527303000115, -11.326025899999877],
              [24.674080037000067, -11.341632180999923],
              [24.66333134000007, -11.351657409999945],
              [24.645037882000082, -11.376048685999962],
              [24.63521936000012, -11.385867207999937],
              [24.624677369000068, -11.390828144999887],
              [24.60224979700007, -11.395685729999911],
              [24.593258097000103, -11.399613138999968],
              [24.584576456000065, -11.407364603999966],
              [24.578581990000117, -11.415632832999918],
              [24.574447876000107, -11.42514129699991],
              [24.571243937000133, -11.436406757999876],
              [24.564732707000076, -11.444674987999917],
              [24.5541907140001, -11.446328632999965],
              [24.542511840000117, -11.445398457999914],
              [24.53269331800007, -11.446121927999911],
              [24.490938762000013, -11.461521504999894],
              [24.469648071000023, -11.46555226599989],
              [24.446497030000046, -11.463588561999956],
              [24.426446574000096, -11.454080098999967],
              [24.392546834000086, -11.423384296999927],
              [24.370222615000102, -11.41015513099994],
              [24.351722453000093, -11.407054544999895],
              [24.31007124900006, -11.40664113299988],
              [24.29394820100009, -11.399199726999953],
              [24.285473266000082, -11.381216328999884],
              [24.298289022000063, -11.37057098299988],
              [24.339940226000095, -11.358065286999889],
              [24.35244592300009, -11.34504282599994],
              [24.384485311000077, -11.295226745999912],
              [24.39223677600009, -11.279103698999933],
              [24.396060832000046, -11.259673359999852],
              [24.397817830000122, -11.238279316999936],
              [24.39657759600007, -11.21740203799996],
              [24.391306600000036, -11.199832051999891],
              [24.384381958000063, -11.191253763999953],
              [24.367432088000072, -11.176267597999896],
              [24.36174768000012, -11.164692077999945],
              [24.362471151000108, -11.150532734999985],
              [24.369912557000134, -11.140920918999882],
              [24.3782841390001, -11.1321359249999],
              [24.38179813600007, -11.120560403999946],
              [24.37053267400009, -11.100199889999914],
              [24.345314575000145, -11.078289082999959],
              [24.31637577300009, -11.060098978999918],
              [24.293844848000077, -11.050280456999957],
              [24.275137980000068, -11.047903340999909],
              [24.238034302000102, -11.048006692999934],
              [24.21829390400012, -11.04521616599989],
              [24.181293579000084, -11.03446746799996],
              [24.16455041500012, -11.03395070399992],
              [24.144396606000072, -11.040358581999953],
              [24.12424279700008, -11.043252461999941],
              [24.117731567000106, -11.030850117999876],
              [24.119385213000072, -10.997570494999934],
              [24.117524862000067, -10.986098327999912],
              [24.11049686700005, -10.965944518999933],
              [24.108016398000075, -10.954989114999961],
              [24.10873986800007, -10.94579070999987],
              [24.114320923000093, -10.92791066399991],
              [24.11421757000005, -10.919229023999947],
              [24.091479939000067, -10.897834980999932],
              [24.048381796000058, -10.882332051999924],
              [24.001459595000114, -10.873443704999914],
              [23.96745650200009, -10.872306822999903],
              [23.948646281000066, -10.881505228999899],
              [23.940584757000067, -10.901555684999948],
              [23.93614058400007, -10.925223489999965],
              [23.927975708000048, -10.945377298999858],
              [23.918570597000098, -10.954058938999907],
              [23.897279907000012, -10.966461282999973],
              [23.887771443000133, -10.974419453999943],
              [23.8817769770001, -10.9845480339999],
              [23.874128865000017, -11.006872252999955],
              [23.8674109290001, -11.016380716999947],
              [23.833717896000053, -11.028473001999927],
              [23.79372033700008, -11.02113494899993],
              [23.752275838000116, -11.008215840999924],
              [23.71413863100014, -11.003875019999938],
              [23.67486454300007, -11.006975605999898],
              [23.641584920000128, -11.00449513799991],
              [23.55704227700008, -10.98134409599993],
              [23.49482385300007, -10.9642908739999],
              [23.455963175000107, -10.960983581999898],
              [23.4154488530001, -10.963257344999917],
              [23.373280884000053, -10.97514292399994],
              [23.306514933000102, -11.01172983799998],
              [23.196754191000082, -11.071881204999926],
              [23.114692016000078, -11.085523782999928],
              [23.014336385, -11.102473652999933],
              [22.969584595000043, -11.102473652999933],
              [22.93113732900011, -11.096789244999897],
              [22.911190226000087, -11.088314309999888],
              [22.87356978300008, -11.063716328999902],
              [22.85310591600009, -11.053070983999916],
              [22.829231405000115, -11.052140807999962],
              [22.806907186000046, -11.06309621099993],
              [22.785306437000088, -11.078495787999927],
              [22.76422245300006, -11.090484720999882],
              [22.727738891000058, -11.096789244999897],
              [22.6889815670001, -11.092965188999955],
              [22.65094771300008, -11.082319843999954],
              [22.61363732900014, -11.067540384999944],
              [22.537569621000074, -11.03715464299998],
              [22.500982706000116, -11.042425637999926],
              [22.46935673000013, -11.122420755999954],
              [22.44031457500006, -11.146915384999915],
              [22.34026900200007, -11.180195007999956],
              [22.3256962480001, -11.190323587999913],
              [22.28177128100006, -11.236729023999914],
              [22.26306441200009, -11.248201191999925],
              [22.23763960800008, -11.249544778999905],
              [22.25200565600008, -11.208617044999883],
              [22.255519654000125, -11.16655242899995],
              [22.243840780000056, -11.078289082999959],
              [22.237329549000094, -11.059375507999931],
              [22.220586385000047, -11.03002329499995],
              [22.21717574100012, -11.012763366999962],
              [22.213971801000042, -11.007905781999938],
              [22.199295695000075, -10.997363789999966],
              [22.1960917560001, -10.992299499999902],
              [22.1960917560001, -10.954162291999936],
              [22.1748010660001, -10.884295755999858],
              [22.165706014000136, -10.868792825999947],
              [22.16549930800008, -10.852359720999885],
              [22.182759236000066, -10.83044891399993],
              [22.206013631000076, -10.809881692999937],
              [22.223997030000078, -10.797065937999946],
              [22.265854939000036, -10.779909362999902],
              [22.290659627000082, -10.772674662999933],
              [22.309676555000067, -10.769780781999941],
              [22.319495077000113, -10.761305846999932],
              [22.32238895600011, -10.742185566999936],
              [22.319495077000113, -10.70384165499992],
              [22.321045369000046, -10.70074106799997],
              [22.326419719000086, -10.694643248999924],
              [22.310089966000078, -10.668805032999913],
              [22.3076094970001, -10.633561705999924],
              [22.308573272000075, -10.612519276999876],
              [22.309469848000106, -10.592944030999902],
              [22.305955852000125, -10.550672708999912],
              [22.296447388000047, -10.529692076999908],
              [22.284045044000095, -10.51646291099992],
              [22.274019816000077, -10.503027037999871],
              [22.271849406000086, -10.481736347999885],
              [22.27867069500013, -10.460962421999938],
              [22.301098267000015, -10.424892272999926],
              [22.305955852000125, -10.40980275499993],
              [22.307092733000047, -10.399570820999955],
              [22.31226037600007, -10.37993377699992],
              [22.313397258000066, -10.368564960999933],
              [22.310089966000078, -10.356989440999882],
              [22.295517212000107, -10.33931610099998],
              [22.286938924000083, -10.309137063999884],
              [22.26347782400009, -10.268209329999962],
              [22.24570113200008, -10.221183776999894],
              [22.221103149000072, -10.176225280999873],
              [22.202809692000102, -10.13064666699998],
              [22.209734334000103, -10.098193867999967],
              [22.204876750000068, -10.085791523999902],
              [22.1960917560001, -10.04362355499994],
              [22.175627889000026, -9.988949889999972],
              [22.16756636600013, -9.953706562999912],
              [22.159918253000058, -9.931485696999871],
              [22.14627567500014, -9.915672708999878],
              [22.107621704000053, -9.891384785999975],
              [22.09098189300005, -9.877122090999904],
              [22.07992313600002, -9.871644387999908],
              [22.072791789000092, -9.878879088999966],
              [22.065763794000077, -9.881049498999872],
              [22.055841919000073, -9.87536509099992],
              [21.998377726000058, -9.809115905999917],
              [21.986285441000092, -9.781107278999912],
              [21.984425090000087, -9.748757831999924],
              [21.978223918000083, -9.752168476999941],
              [21.962720988000086, -9.75847300199996],
              [21.956519816000082, -9.761780292999958],
              [21.942360474000054, -9.722919616999903],
              [21.878901814000102, -9.657083840999917],
              [21.854097127000074, -9.617809752999946],
              [21.84365848800013, -9.576158548999928],
              [21.83218632000012, -9.488411966999891],
              [21.819887329000068, -9.447690937999923],
              [21.813169393000038, -9.437459003999933],
              [21.796219523000048, -9.417098489999916],
              [21.79198205500009, -9.406143085999929],
              [21.79332564200007, -9.39353403699991],
              [21.80376428200009, -9.37296681699992],
              [21.810172159000047, -9.33813690199986],
              [21.841074666000026, -9.27581512399992],
              [21.851616659000086, -9.233750507999986],
              [21.851926717000083, -9.192926126999907],
              [21.839731079000074, -9.09236378999988],
              [21.854097127000074, -8.977848815999963],
              [21.85172001100011, -8.92586232499994],
              [21.859884888000124, -8.846383971999941],
              [21.870116821000124, -8.822302753999907],
              [21.877764933000094, -8.789229837999912],
              [21.88479292800011, -8.782305195999925],
              [21.895128215000113, -8.718743183999962],
              [21.906910441000036, -8.645466003999942],
              [21.917762492000065, -8.615183613999918],
              [21.935952596000106, -8.583144225999916],
              [21.928407836000048, -8.582524108999863],
              [21.924377075000052, -8.580767109999968],
              [21.92127649000011, -8.578596699999892],
              [21.916212199000142, -8.576839701999901],
              [21.93998335800009, -8.499945169999918],
              [21.943910766000073, -8.455916848999948],
              [21.935952596000106, -8.413025410999893],
              [21.911457967000047, -8.374268086999876],
              [21.899882446000106, -8.348843281999862],
              [21.90525679500007, -8.337267760999907],
              [21.91314632600003, -8.333003149999925],
              [21.920553019000124, -8.328999531999955],
              [21.910631144000035, -8.310499368999942],
              [21.88138228300008, -8.282077330999911],
              [21.873217407000055, -8.264093932999927],
              [21.86246870900004, -8.216448262999975],
              [21.860194946000036, -8.173763528999885],
              [21.857301066000048, -8.156917011999909],
              [21.851203247000086, -8.143481139999949],
              [21.825985148000115, -8.114438984999964],
              [21.815133098000075, -8.096765644999962],
              [21.80851851400007, -8.076715189999916],
              [21.80634810400008, -8.052427266999914],
              [21.79963016800008, -8.04085174499997],
              [21.76821089700013, -8.023178404999967],
              [21.7584957280001, -8.015116881999887],
              [21.75394820200006, -7.997340188999942],
              [21.751054321000083, -7.929230651999944],
              [21.75436161300007, -7.919618835999927],
              [21.768831014000085, -7.899878437999874],
              [21.7721383060001, -7.888199563999905],
              [21.770898071000147, -7.876520690999925],
              [21.76459354700006, -7.85068247399991],
              [21.770484659000147, -7.806757506999872],
              [21.776169067000097, -7.790324400999907],
              [21.787227824000098, -7.758595071999892],
              [21.795082642000125, -7.736270852999922],
              [21.807898397000116, -7.6993738809999],
              [21.81957727000008, -7.66547414199988],
              [21.826558136000102, -7.645600686999927],
              [21.83104943900011, -7.632814635999907],
              [21.832909790000116, -7.61421111999995],
              [21.836217082000104, -7.608320006999946],
              [21.850789835000057, -7.593643899999961],
              [21.854097127000074, -7.585995788999895],
              [21.854097127000074, -7.548375345999958],
              [21.851513306000072, -7.53845346999988],
              [21.848206014000056, -7.532975768999975],
              [21.845932251000136, -7.5267745969999],
              [21.846655721000047, -7.514268899999905],
              [21.849963012000046, -7.502900084999908],
              [21.859058065000113, -7.482642923999904],
              [21.860918416000118, -7.469827168999927],
              [21.858644654000102, -7.464039407999863],
              [21.848929484000053, -7.454841002999942],
              [21.846655721000047, -7.449053242999881],
              [21.847792603000045, -7.444092304999927],
              [21.852960246000066, -7.434997253999953],
              [21.854097127000074, -7.428899434999906],
              [21.851616659000086, -7.416497089999936],
              [21.84572554500008, -7.40905568399991],
              [21.83869755000009, -7.402027688999908],
              [21.832909790000116, -7.390762226999939],
              [21.834976847000064, -7.385284524999946],
              [21.839937785000103, -7.37815317799992],
              [21.84241825300009, -7.369884948999868],
              [21.8369405520001, -7.360583190999932],
              [21.83135949700008, -7.354175313999903],
              [21.808828572000067, -7.306426289999919],
              [21.802524048000066, -7.298881530999964],
              [21.794772583000054, -7.294023945999953],
              [21.78826135200009, -7.291750182999934],
              [21.784644002000107, -7.286892598999913],
              [21.784954060000075, -7.283378600999868],
              [21.764490194000103, -7.282758482999895],
              [21.73090051300008, -7.282965189999857],
              [21.658243448000064, -7.28317189499991],
              [21.58548303200007, -7.283378600999868],
              [21.51261926300009, -7.283585306999925],
              [21.439962198000046, -7.283792011999878],
              [21.367098429000038, -7.283998717999935],
              [21.294338013000072, -7.284205423999893],
              [21.22178430100007, -7.284412129999851],
              [21.148920532000147, -7.284618834999904],
              [21.07626346900011, -7.284722187999932],
              [21.003503051000052, -7.284928893999975],
              [20.930742635000087, -7.285238951999872],
              [20.85798221900012, -7.285342306],
              [20.785221801000148, -7.285549010999944],
              [20.71256473800011, -7.28585906999993],
              [20.639804321000042, -7.285962422999958],
              [20.56704390400006, -7.286169127999926],
              [20.520535116000133, -7.286375833999969],
              [20.519398234000107, -7.23717987099991],
              [20.51826135200011, -7.189740904999923],
              [20.524462524000086, -7.143128763999954],
              [20.54544315600009, -7.088558450999926],
              [20.560946085000097, -7.047837422999876],
              [20.588127889000106, -6.976834004999972],
              [20.611485636000054, -6.915959166999926],
              [20.553711385000042, -6.916165872999983],
              [20.467308390000056, -6.91637257899994],
              [20.383695922000044, -6.916682637999926],
              [20.33108931500007, -6.916785989999951],
              [20.319513794000102, -6.918542988999931],
              [20.311245564000075, -6.925054219999907],
              [20.303184042000083, -6.9401437369999],
              [20.298636515000055, -6.954509785999903],
              [20.294192342000116, -6.987479349999958],
              [20.294295695000073, -7.001948750999901],
              [20.246236613000093, -7.001948750999901],
              [20.20406864400013, -7.001948750999901],
              [20.162107381000055, -7.001948750999901],
              [20.120146118000036, -7.001948750999901],
              [20.07818485500013, -7.001948750999901],
              [20.0361202390001, -7.001948750999901],
              [19.994055623000094, -7.001948750999901],
              [19.963079168000093, -7.001948750999901],
              [19.952094360000075, -7.001948750999901],
              [19.910029745000145, -7.001948750999901],
              [19.86806848200004, -7.001948750999901],
              [19.82610721800006, -7.001948750999901],
              [19.784042602000113, -7.001948750999901],
              [19.74197798600008, -7.001948750999901],
              [19.70001672300009, -7.001948750999901],
              [19.65805546100009, -7.001948750999901],
              [19.6160941980001, -7.001948750999901],
              [19.574029582000065, -7.001948750999901],
              [19.521836385000086, -7.001948750999901],
              [19.54023319500007, -7.041636249999968],
              [19.542610311000118, -7.052281595999972],
              [19.536202434000074, -7.068404642999951],
              [19.508607219000083, -7.103234557999912],
              [19.497031697000125, -7.121734720999939],
              [19.48721317500008, -7.153877461999883],
              [19.47636112500004, -7.315934752999908],
              [19.479461711000056, -7.347664082999927],
              [19.48721317500008, -7.381977233999947],
              [19.513774862000076, -7.448433125999912],
              [19.513154744000104, -7.479438984999931],
              [19.48473270700009, -7.501969908999868],
              [19.48390588400008, -7.502383320999868],
              [19.48307906100004, -7.502900084999908],
              [19.482355591000044, -7.503520201999976],
              [19.468713013000126, -7.521090188999949],
              [19.45827437300011, -7.560260925999984],
              [19.44390832500011, -7.575247090999966],
              [19.424684692000085, -7.579691263999877],
              [19.355644979000118, -7.574110208999869],
              [19.35368127400008, -7.600258483999951],
              [19.361846151000094, -7.627026875999931],
              [19.373214965000102, -7.653795267999911],
              [19.380966431000104, -7.67973683699995],
              [19.381379842000115, -7.703921406999925],
              [19.377762492000045, -7.730069680999932],
              [19.35802209500008, -7.791564635999933],
              [19.34851363100009, -7.821536966999886],
              [19.333837525000092, -7.867322285999919],
              [19.330943644000115, -7.898638203999937],
              [19.334044230000046, -7.924269713999905],
              [19.355541626000104, -8.001991068999914],
              [19.32825647000007, -8.001991068999914],
              [19.20061568200009, -8.001991068999914],
              [19.07307824700004, -8.001991068999914],
              [18.94543746000008, -8.001991068999914],
              [18.81800337700014, -8.001991068999914],
              [18.773768351000115, -8.001991068999914],
              [18.758265421000118, -7.978219908999947],
              [18.752064249000114, -7.965920918999913],
              [18.74731001800012, -7.937808939999883],
              [18.73852502400004, -7.932331237999975],
              [18.666901490000072, -7.932331237999975],
              [18.588663371000024, -7.932331237999975],
              [18.516523071000023, -7.932227884999861],
              [18.5043274330001, -7.940702819999956],
              [18.502260376000066, -7.960133157999849],
              [18.507634725000116, -7.997546894999914],
              [18.48789432800004, -7.998270364999911],
              [18.481796509000077, -7.997340188999942],
              [18.420508260000133, -7.998270364999911],
              [18.4038684490001, -8.000647480999945],
              [18.38195764100007, -8.012326353999924],
              [18.366558065000078, -8.016770527999924],
              [18.353638957000072, -8.015943704999913],
              [18.316225220000092, -8.001681009999928],
              [18.26733931400011, -7.999820657999919],
              [18.192718546000037, -7.996926777999931],
              [18.176595500000076, -7.999200540999951],
              [18.135771118000065, -8.018527526999904],
              [18.120371541000083, -8.022454935999875],
              [18.10218143700004, -8.033306986999918],
              [18.092879680000124, -8.056354674999895],
              [18.091742798000098, -8.084156595999943],
              [18.098150675000056, -8.109271341999957],
              [18.008543742000114, -8.111235045999905],
              [17.981878703000064, -8.1053439329999],
              [17.93082238700009, -8.06214243599996],
              [17.901366821000096, -8.048086445999942],
              [17.8679838460001, -8.044469095999958],
              [17.851757447000097, -8.047776387999946],
              [17.7895390220001, -8.081779479999895],
              [17.777240031000048, -8.083329772999917],
              [17.74334029200014, -8.070720722999894],
              [17.713264608000088, -8.06834360799985],
              [17.62841190500012, -8.0980058789999],
              [17.60019657400005, -8.098522643999942],
              [17.544282674000073, -8.084776712999911],
              [17.536531209000145, -8.075991718999916],
              [17.536218704000134, -8.07540231099992],
              [17.528366333000122, -8.060592141999933],
              [17.540045207000105, -8.032066751999892],
              [17.536531209000145, -8.015116881999887],
              [17.528366333000122, -8.007778828999975],
              [17.506352173000067, -7.996513365999931],
              [17.496223592000092, -7.9872116089999],
              [17.490952596000085, -7.977496439999953],
              [17.481857544000093, -7.945663756999906],
              [17.47720666500004, -7.950521341999931],
              [17.471108846000078, -7.955585631999909],
              [17.46831831900002, -7.959926452999895],
              [17.465217733000088, -7.952588398999893],
              [17.46304732200008, -7.949797871999934],
              [17.463564087000123, -7.946903990999942],
              [17.46831831900002, -7.93946258499993],
              [17.446820923000075, -7.928920592999958],
              [17.43782922300005, -7.9224093629999],
              [17.434108520000024, -7.915794778999896],
              [17.43937951700005, -7.902152200999893],
              [17.44868127400008, -7.892850442999958],
              [17.452401977000108, -7.883962096999937],
              [17.440929810000085, -7.871146341999875],
              [17.426357056000114, -7.875487161999942],
              [17.42304976400004, -7.867942402999901],
              [17.423566529000055, -7.85512664799991],
              [17.420569295000064, -7.843861185999856],
              [17.410854126000118, -7.841484069999908],
              [17.397624959000012, -7.841380716999879],
              [17.39070031700004, -7.839210306999888],
              [17.400002075000145, -7.830218606999935],
              [17.400002075000145, -7.823397318999895],
              [17.380985148000093, -7.823190612999937],
              [17.376127563000068, -7.814095560999959],
              [17.376954386000108, -7.801693216999894],
              [17.37540409400009, -7.79228810599993],
              [17.365482218000068, -7.787327168999894],
              [17.342434529000116, -7.784019876999892],
              [17.337887003000077, -7.778645527999927],
              [17.334062947000035, -7.769653828999893],
              [17.315976196000122, -7.753634134999928],
              [17.310601847000072, -7.740818378999947],
              [17.314219198000046, -7.731826680999916],
              [17.32062707500009, -7.722421569999952],
              [17.320420369000118, -7.713636575999956],
              [17.303780558000113, -7.706711933999884],
              [17.308121379000085, -7.702371113999902],
              [17.308121379000085, -7.701854349999877],
              [17.305950968000104, -7.700097350999982],
              [17.303780558000113, -7.692449238999913],
              [17.28889774600006, -7.699477233999914],
              [17.28652063000004, -7.683664245999921],
              [17.287450806000066, -7.660203144999855],
              [17.282696574000084, -7.643976745999936],
              [17.286417277000083, -7.625166523999923],
              [17.266573527000105, -7.610387063999909],
              [17.217790975000042, -7.585995788999895],
              [17.202908163000103, -7.564291686999894],
              [17.18626835100008, -7.516335957999956],
              [17.172832479000135, -7.49380503299993],
              [17.16342736800007, -7.485226744999906],
              [17.15495243300009, -7.479128925999944],
              [17.14854455500003, -7.472617695999887],
              [17.146167439000095, -7.463109232999898],
              [17.151541789000134, -7.451223652999957],
              [17.163117310000104, -7.445539244999921],
              [17.174899536000083, -7.441611836999954],
              [17.180273885000048, -7.435410664999964],
              [17.176553182000134, -7.428175963999905],
              [17.167458130000085, -7.423525084999937],
              [17.146167439000095, -7.418047383999948],
              [17.13820926900013, -7.413706562999963],
              [17.132214803000096, -7.409572448999953],
              [17.126220337000063, -7.411432799999957],
              [17.118158813000093, -7.425488789999875],
              [17.103999471000122, -7.416083678999925],
              [17.098108358000047, -7.402337747999894],
              [17.097894948000146, -7.378293566999986],
              [17.097798299000146, -7.367404479999891],
              [17.093354126000037, -7.352314961999895],
              [17.082502075000093, -7.342289733999877],
              [17.056663859000082, -7.329887389999897],
              [17.022867472000087, -7.306012878999908],
              [16.996099080000107, -7.297951354999924],
              [16.99165490700011, -7.286065774999898],
              [16.99165490700011, -7.270562844999887],
              [16.98907108500009, -7.254853209999908],
              [16.972844686000087, -7.232218932999956],
              [16.960545695000064, -7.219093119999897],
              [16.9508305250001, -7.213202005999989],
              [16.945662882000107, -7.204623718999869],
              [16.9475232340001, -7.15108693399992],
              [16.92705936700014, -7.085664570999938],
              [16.929126424000117, -7.060653177999939],
              [16.96116581200002, -7.069231464999888],
              [16.96230269400013, -7.047424010999947],
              [16.96933068900006, -7.030370787999914],
              [16.973154744000084, -7.014764505999977],
              [16.964576457000135, -6.997194518999905],
              [16.959305461000014, -6.989443053999906],
              [16.955274699000114, -6.98148488399994],
              [16.949073527000053, -6.975387063999975],
              [16.93760135900004, -6.97300994899993],
              [16.928713012000117, -6.968669127999945],
              [16.92860966000009, -6.959264017999899],
              [16.93212365700012, -6.94985890699985],
              [16.93450077300008, -6.945724791999922],
              [16.92695601400004, -6.888570657999892],
              [16.91496708200006, -6.864076028999932],
              [16.8907825120001, -6.847126158999927],
              [16.879413696000114, -6.844645690999954],
              [16.855332479000083, -6.842165221999977],
              [16.84448042800011, -6.838444518999964],
              [16.832904907000085, -6.827799173999978],
              [16.828564087000103, -6.814363301999933],
              [16.826910441000052, -6.799790547999876],
              [16.823086385000096, -6.785114440999891],
              [16.768102661000057, -6.708323261999922],
              [16.760351197000148, -6.691993508999886],
              [16.75590702300005, -6.67411346499992],
              [16.75301314200007, -6.637216491999894],
              [16.74867232300008, -6.619543150999988],
              [16.733996216000094, -6.586056823999897],
              [16.73079227700012, -6.569830423999889],
              [16.734512980000147, -6.552363789999944],
              [16.746811971000085, -6.531589863999898],
              [16.747328736000043, -6.521978046999976],
              [16.738337036000075, -6.510609231999894],
              [16.72800175000006, -6.501100768999919],
              [16.721697224000053, -6.491799010999983],
              [16.721283813000042, -6.480533548999929],
              [16.727795044000118, -6.465960794999958],
              [16.706090943000106, -6.465030618999918],
              [16.706090943000106, -6.455212096999944],
              [16.71518599400008, -6.441362813999973],
              [16.720973755000074, -6.42834035199985],
              [16.718906697000108, -6.415317890999901],
              [16.71363570200006, -6.413974303999936],
              [16.707021118000085, -6.41542124399993],
              [16.70040653500007, -6.411287129999906],
              [16.69472212700012, -6.402192076999938],
              [16.692965129000044, -6.3983680219999],
              [16.69358524600011, -6.359817402999923],
              [16.69740930100005, -6.349792174999905],
              [16.706090943000106, -6.34669158899996],
              [16.715289347000123, -6.345968118999863],
              [16.720973755000074, -6.342350767999974],
              [16.722317342000025, -6.332428893999889],
              [16.72014693200012, -6.322610371999914],
              [16.716942994000078, -6.313308613999894],
              [16.715392700000052, -6.304833678999984],
              [16.71477258300007, -6.231556497999875],
              [16.717253052000046, -6.215123392999914],
              [16.724384400000076, -6.202410989999862],
              [16.726761516000124, -6.189181822999956],
              [16.717873169000114, -6.174092304999959],
              [16.70040653500007, -6.154351908999899],
              [16.69585900900003, -6.140916034999947],
              [16.685110311000102, -6.134301452999949],
              [16.671777791000096, -6.130167337999922],
              [16.660098917000113, -6.123966165999946],
              [16.643045695000097, -6.100711770999922],
              [16.630953410000103, -6.091720072999891],
              [16.611109660000096, -6.089756367999939],
              [16.63219364400004, -6.065261738999894],
              [16.628369588000112, -6.055339864],
              [16.61948124200009, -6.05658009899993],
              [16.610076131000113, -6.061230976999894],
              [16.604288371000052, -6.061851094999966],
              [16.601187785000036, -6.050585632999912],
              [16.597157023000108, -5.98785044399996],
              [16.595296672000103, -5.978548685999925],
              [16.590335734000064, -5.968006692999964],
              [16.580723918000047, -5.955397643999945],
              [16.580620564000128, -5.948989765999897],
              [16.59405643700009, -5.933176777999904],
              [16.59736372800009, -5.924701842999909],
              [16.560260051000085, -5.906408385999924],
              [16.552921997000112, -5.902377624999929],
              [16.515094848000018, -5.887081399999971],
              [16.49731815600009, -5.882843932999933],
              [16.479334757000117, -5.882223815999865],
              [16.45949100700011, -5.885221048999966],
              [16.427451619000095, -5.894626158999927],
              [16.41246545400014, -5.896796569999921],
              [16.396135701000105, -5.894109394999887],
              [16.37432824700008, -5.882843932999933],
              [16.358515258000068, -5.870234883999899],
              [16.34125533000008, -5.859796243999966],
              [16.31572717300014, -5.854628600999959],
              [16.257022746000104, -5.855558776999914],
              [16.16565881300008, -5.857005716999907],
              [16.100855892000112, -5.858107807999971],
              [16.0745015870001, -5.85855600999993],
              [15.983241007000117, -5.860106302999952],
              [15.892083780000064, -5.861656595999875],
              [15.800719849000131, -5.863206888999898],
              [15.70956262200005, -5.864757180999916],
              [15.618302042000067, -5.866204121999914],
              [15.527041463000074, -5.867754414999922],
              [15.435780884000081, -5.869201354999916],
              [15.34452030400007, -5.87075164699985],
              [15.253363078000092, -5.872198587999932],
              [15.16210249800011, -5.873748880999955],
              [15.070841919000117, -5.875299173999878],
              [14.97958134000001, -5.876746113999971],
              [14.888424113000042, -5.878296406999894],
              [14.79716353300006, -5.879846699999916],
              [14.759651665000149, -5.880469130999899],
              [14.703732544000076, -5.881396992999939],
              [14.57660852100011, -5.904651387999948],
              [14.545706014000132, -5.901654153999942],
              [14.48214400200007, -5.885531107999952],
              [14.43666874100009, -5.893385925],
              [14.346131632000095, -5.891525573999985],
              [14.241848592000082, -5.889561868999948],
              [14.222211548000132, -5.886978047999946],
              [14.163093710000084, -5.866100768999971],
              [14.140149374000117, -5.86351694699988],
              [14.021190226000101, -5.872508646999918],
              [14.006307414000077, -5.866927591999911],
              [13.98232954900007, -5.853285013999894],
              [13.94357222500011, -5.841606139999925],
              [13.80714644300005, -5.852458190999883],
              [13.641523479000057, -5.865790709999899],
              [13.562561890000097, -5.857419127999918],
              [13.553053426000105, -5.859382832999955],
              [13.53475996900005, -5.867030943999936],
              [13.522667684000055, -5.867547708999965],
              [13.493212118000145, -5.858452656999901],
              [13.413320353000046, -5.857005716999907],
              [13.380454142000104, -5.856385598999935],
              [13.373839559000118, -5.860933124999875],
              [13.353582398000128, -5.882637226999876],
              [13.3425236410001, -5.890595397999931],
              [13.311001017000137, -5.873955586999912],
              [13.269349813000133, -5.86351694699988],
              [13.184910523000099, -5.856385598999935],
              [13.183848504000082, -5.856459242999961],
              [13.184336785000085, -5.856215101999908],
              [13.170664910000085, -5.849867445999905],
              [13.154795769000089, -5.852146091999941],
              [13.122894727000073, -5.862481377999927],
              [13.107758009000065, -5.86296965899993],
              [13.089854363000086, -5.86060963299991],
              [13.067227051000089, -5.862628662999953],
              [13.036351319000062, -5.857208592999939],
              [12.989268425000091, -5.835707289999959],
              [12.975840691000087, -5.832777601999908],
              [12.940928582000083, -5.819105726999908],
              [12.924327019000089, -5.814629815999922],
              [12.89616946700005, -5.814548434999949],
              [12.85873457100007, -5.819512627999927],
              [12.822438998000052, -5.82976653399993],
              [12.797129754000082, -5.84539153399993],
              [12.789235873000052, -5.849216403999947],
              [12.766479691000086, -5.865310251999915],
              [12.75439270600009, -5.88175175799995],
              [12.743410145000041, -5.900381638999932],
              [12.717539910000085, -5.93132903399993],
              [12.72260678300006, -5.979262694999932],
              [12.671981501000062, -6.000131711999927],
              [12.607011962000058, -5.998019437999915],
              [12.556376680000085, -6.025471702999937],
              [12.475952902000074, -6.045311734999927],
              [12.449497608000058, -6.051928236999913],
              [12.435164161000046, -6.050852776999932],
              [12.43185370100008, -6.034414028999947],
              [12.436262598000042, -6.026734250999937],
              [12.45720425400009, -6.013552440999945],
              [12.457367384000065, -5.989678643999923],
              [12.457193527000072, -5.981772430999911],
              [12.447273435000056, -5.976305633999914],
              [12.430746089000081, -5.975226715999952],
              [12.414201357000081, -5.978539887999943],
              [12.410895146000087, -5.986215485999935],
              [12.404280244000063, -5.99060770299991],
              [12.39656304500005, -6.005962561999922],
              [12.384776238000086, -5.984307549999926],
              [12.379567905000044, -5.96607838299991],
              [12.376231316000087, -5.95867278399993],
              [12.371104363000086, -5.954196872999944],
              [12.358897332000083, -5.947686455999929],
              [12.35515384200005, -5.94500090899993],
              [12.334157748000052, -5.918389580999929],
              [12.266612175000091, -5.85084400799991],
              [12.249278191000087, -5.828789971999925],
              [12.210541212000066, -5.763441664999959],
              [12.258972209000092, -5.736702981999926],
              [12.344445028000024, -5.724610696999932],
              [12.435498901000074, -5.725540872999886],
              [12.50898278800014, -5.726264343999972],
              [12.512496785000081, -5.633660176999925],
              [12.514977254000058, -5.568754577999897],
              [12.519731486000069, -5.444214375999948],
              [12.524382365000122, -5.324738464999896],
              [12.52768965700011, -5.239472350999918],
              [12.530686889000037, -5.162681171999864],
              [12.52407230600005, -5.129091490999926],
              [12.511980021000056, -5.120513203999906],
              [12.450381714000116, -5.098809102],
              [12.44469730600008, -5.093538105999869],
              [12.440769898000099, -5.08402964299998],
              [12.438909546000104, -5.073280944999865],
              [12.439426310000044, -5.064806009999955],
              [12.444387248000083, -5.055090840999924],
              [12.450691772000084, -5.053127135999887],
              [12.458133179000129, -5.05416066499987],
              [12.466504761000095, -5.053127135999887],
              [12.550427287000105, -5.02418833399993],
              [12.587737671000127, -5.000313822999942],
              [12.603964070000131, -4.962590026999891],
              [12.606961304000066, -4.942229511999955],
              [12.615849650000087, -4.935459899999913],
              [12.654400269000064, -4.932566019999925],
              [12.678894897000106, -4.924297789999883],
              [12.68623295000009, -4.912825621999957],
              [12.688300008000056, -4.897012633999879],
              [12.696981648000104, -4.875618591999867],
              [12.711967814000076, -4.863319599999912],
              [12.756926310000097, -4.837274678999933],
              [12.766228068000117, -4.825182392999949],
              [12.768295125000094, -4.801927998999929],
              [12.774806356000056, -4.779500426999945],
              [12.786175171000139, -4.758416441999913],
              [12.8029183350001, -4.73981292699996],
              [12.833200724000022, -4.722656351999902],
              [13.029571167000086, -4.676871032999955],
              [13.0653312580001, -4.663951923999946],
              [13.073702840000067, -4.635323180999961],
              [13.071532430000076, -4.601630146999909],
              [13.087965535000137, -4.579512633999911],
              [13.112356812000087, -4.57692881299991],
              [13.13406091300007, -4.602353616999906],
              [13.14212243600008, -4.617339781999888],
              [13.160002482000039, -4.643384703999871],
              [13.172404825000086, -4.676147561999954],
              [13.18211999500005, -4.686069436999958],
              [13.208785034000073, -4.703122660999981],
              [13.255810588000145, -4.74394704099997],
              [13.2740006920001, -4.755832620999911],
              [13.334565470000143, -4.777536721999908],
              [13.349344930000058, -4.785598245999907],
              [13.358750041000121, -4.794796650999899],
              [13.364124389000096, -4.806888936999883],
              [13.371359090000055, -4.841718851999943],
              [13.392649780000028, -4.885333760999899],
              [13.403191772000099, -4.876858825999904],
              [13.43078698700009, -4.843372497999894],
              [13.482256713000083, -4.805545348999914],
              [13.493522176000056, -4.799654235999924],
              [13.496416056000044, -4.792109475999965],
              [13.492385295000133, -4.78353118899993],
              [13.482256713000083, -4.774849547999878],
              [13.5147095130001, -4.755935973999939],
              [13.52618168100011, -4.754282327999888],
              [13.53889408300006, -4.759966735999939],
              [13.558634481000126, -4.780430602999985],
              [13.57072676600012, -4.785908304999893],
              [13.579859863000138, -4.78303137899988],
              [13.591397339000139, -4.779397073999917],
              [13.613101440000037, -4.739192809999892],
              [13.633978719000112, -4.725653583999915],
              [13.643693888000143, -4.726273701999972],
              [13.666534871000067, -4.732681578999916],
              [13.675319865000034, -4.731751402999876],
              [13.68059086100007, -4.72472340799996],
              [13.677800334000011, -4.706326598999865],
              [13.68193444800005, -4.695371194999979],
              [13.690099325000062, -4.691133727999926],
              [13.6983675540001, -4.693510843999974],
              [13.705860636000125, -4.69433766599991],
              [13.712475220000044, -4.685656025999947],
              [13.699091023000108, -4.642661233999959],
              [13.702605021000068, -4.620750426999905],
              [13.71815962800008, -4.580339456999923],
              [13.721776978000065, -4.561012471999973],
              [13.71102828000005, -4.464480895999941],
              [13.714955688000117, -4.453008727999929],
              [13.726531210000047, -4.446704202999925],
              [13.789989868000106, -4.424586690999917],
              [13.810453735000067, -4.426653746999875],
              [13.832881307000065, -4.441226500999932],
              [13.842079712000043, -4.45342213899994],
              [13.856135701000056, -4.479673766999966],
              [13.867091105000043, -4.489285582999898],
              [13.87628951000005, -4.491662698999932],
              [13.904401489000094, -4.489802347999927],
              [13.90543582500004, -4.490099896999951],
              [13.934580526000076, -4.49848398799989],
              [13.94450240000009, -4.498070576999879],
              [13.954941040000108, -4.491869404999889],
              [13.971787557000084, -4.471612243999886],
              [13.98770389800012, -4.460140075999959],
              [13.989874308000111, -4.457969664999979],
              [13.991631307000091, -4.455075784999892],
              [14.021086873000087, -4.415388284999906],
              [14.058397258000127, -4.400505472999967],
              [14.146350545000104, -4.389860127999967],
              [14.18469445700012, -4.377457782999912],
              [14.222211548000132, -4.359784443999899],
              [14.259625285000084, -4.326918232999972],
              [14.279985800000134, -4.31275889099993],
              [14.325461059000077, -4.301803486999944],
              [14.368559204000093, -4.278445738999906],
              [14.38705936600013, -4.277102151999941],
              [14.392847127000095, -4.281753030999909],
              [14.395327596000072, -4.289711201999864],
              [14.395224243000143, -4.30035654699995],
              [14.393467245000068, -4.313172301999941],
              [14.389126424000096, -4.327538349999941],
              [14.385715779000066, -4.332912699999909],
              [14.386025838000137, -4.338287047999955],
              [14.392743774000081, -4.352756448999898],
              [14.40907352700009, -4.37756113699993],
              [14.4286072190001, -4.400402119999939],
              [14.463230428000116, -4.42262298599988],
              [14.469741659000078, -4.429340921999909],
              [14.466537719000115, -4.44804778999989],
              [14.452481730000102, -4.467994893999901],
              [14.435738566000055, -4.486701761999896],
              [14.424576456000125, -4.502308043999932],
              [14.41258752400006, -4.51450368199994],
              [14.374760376000069, -4.530213317999909],
              [14.358947388000075, -4.544579365999908],
              [14.350782511000148, -4.559048766999936],
              [14.349955689000126, -4.566903584999878],
              [14.357500448000081, -4.589124450999918],
              [14.365768677000034, -4.627261657999966],
              [14.380961548000073, -4.646175231999919],
              [14.395844361000115, -4.660127868999908],
              [14.406903117000098, -4.67604420999993],
              [14.410933878, -4.701055602999929],
              [14.409176880000132, -4.710564066999908],
              [14.401528768000048, -4.728134052999891],
              [14.399048299000071, -4.737539163999941],
              [14.399668416000054, -4.749321390999938],
              [14.40369917800004, -4.758829853999927],
              [14.408763468000103, -4.767821552999877],
              [14.41258752400006, -4.778156839999966],
              [14.39646447700008, -4.855878193999985],
              [14.400701945000037, -4.886263935999949],
              [14.418168579000081, -4.883163349999904],
              [14.437288859000063, -4.880166116999902],
              [14.449484497000071, -4.873964944999912],
              [14.470051717000075, -4.852157490999971],
              [14.481937296000098, -4.845852965999967],
              [14.501470988000108, -4.84068532299996],
              [14.519867797000103, -4.841305439999928],
              [14.528032674000116, -4.852157490999971],
              [14.532476847000027, -4.856188252999885],
              [14.553870891000145, -4.855154723999902],
              [14.562139120000097, -4.855878193999985],
              [14.56689335100009, -4.860529072999952],
              [14.575058227000113, -4.87365488699993],
              [14.579605754000056, -4.876342060999946],
              [14.592111450000033, -4.880579528999903],
              [14.623324015000037, -4.899493102999941],
              [14.634486125000137, -4.903627217999968],
              [14.672726684000054, -4.899906514999955],
              [14.702182251000039, -4.889571227999852],
              [14.76843143700006, -4.848230081999915],
              [14.815456991000104, -4.827972920999912],
              [14.831166626000083, -4.815053811999903],
              [14.841398559000083, -4.800170999999864],
              [14.849046671000053, -4.783737893999984],
              [14.931005493000015, -4.646898701999916],
              [15.00821008300008, -4.571037698999902],
              [15.014617961000027, -4.558015237999953],
              [15.022782837000136, -4.547059834999885],
              [15.076112915000039, -4.520084736999948],
              [15.097920370000082, -4.499930927999884],
              [15.150677777000112, -4.425150932999969],
              [15.188044068000067, -4.37218678799988],
              [15.193418416000014, -4.358750914999916],
              [15.203960409000075, -4.339010518999956],
              [15.228351684000103, -4.32485117599991],
              [15.255740194000055, -4.313068948999913],
              [15.275273885000047, -4.30035654699995],
              [15.386584920000104, -4.244339293999928],
              [15.42544559700005, -4.230179951999986],
              [15.450250285000095, -4.217260843999966],
              [15.458931925000059, -4.21385019899995],
              [15.462859334000115, -4.20713226299992],
              [15.484976847000041, -4.183877868999915],
              [15.490351196000091, -4.175196227999947],
              [15.521150350000056, -4.07680430099991],
              [15.533759399000076, -4.057994079999901],
              [15.549055623000129, -4.046211852999903],
              [15.566832316000074, -4.038046976999894],
              [15.711216267000111, -3.992158304999919],
              [15.755141235000053, -3.985647074999946],
              [15.799996378000117, -3.978825784999898],
              [15.84423140500013, -3.965596618999896],
              [15.88298872900009, -3.945339456999903],
              [15.888019273000111, -3.940522978999908],
              [15.912134237000089, -3.917434183999916],
              [15.93032434100013, -3.858626402999931],
              [15.936112101000106, -3.848497822999974],
              [15.943140096000036, -3.840746357999876],
              [15.974249309000072, -3.786486103999934],
              [15.991095826000048, -3.738943786999911],
              [16.005255167000087, -3.72478444399988],
              [16.012696573000113, -3.702253519999942],
              [16.053314249000067, -3.619984638999895],
              [16.115532674000065, -3.54422698899991],
              [16.13785689300002, -3.500715432999897],
              [16.15842411300011, -3.44728200299997],
              [16.20772342900011, -3.361912535999878],
              [16.220745890000046, -3.331733499999885],
              [16.22560347500007, -3.313233336999943],
              [16.227463827000065, -3.289875589999909],
              [16.22208947700011, -3.27912689199988],
              [16.210410603000128, -3.271065368999899],
              [16.19862837700012, -3.259489846999941],
              [16.193357381000112, -3.238405862999912],
              [16.199455200000074, -3.194790954999874],
              [16.199248494000102, -3.171846618999936],
              [16.18994673600008, -3.153036396999923],
              [16.185709269000114, -3.136396585999904],
              [16.189843383000067, -3.082343036999916],
              [16.18446903500009, -3.02611907999993],
              [16.188293091000048, -2.976406351999927],
              [16.183981404000065, -2.940449251999951],
              [16.177027629000065, -2.8824585979999],
              [16.178164510000073, -2.868092549999901],
              [16.180851685000107, -2.854139912999912],
              [16.204519491000042, -2.782723082999908],
              [16.22560347500007, -2.635238545999925],
              [16.19232385200013, -2.395149841999896],
              [16.191703735000146, -2.346884053999887],
              [16.189843383000067, -2.337478942999923],
              [16.187466267000104, -2.332311298999926],
              [16.178267863000116, -2.318462015999955],
              [16.174857218000085, -2.303062438999888],
              [16.176924276000136, -2.28683603899988],
              [16.18994673600008, -2.241877542999944],
              [16.190050090000113, -2.235469664999911],
              [16.1886031490001, -2.227718200999902],
              [16.18736291500008, -2.204567157999918],
              [16.194597615000134, -2.182036234999899],
              [16.206793253000058, -2.160952249999866],
              [16.231287883000107, -2.129016214999893],
              [16.256092570000135, -2.106795348999952],
              [16.284411255000037, -2.087571715999928],
              [16.340221802000116, -2.034138284999912],
              [16.382596476000117, -2.002202249999925],
              [16.44564172400007, -1.940500588999967],
              [16.460937947000104, -1.920863544999932],
              [16.470033, -1.912698668999909],
              [16.474787232000068, -1.910114846999917],
              [16.490290161000075, -1.903603616999945],
              [16.50775679500012, -1.890271097999914],
              [16.513957967000124, -1.887377216999937],
              [16.517161906000098, -1.87373463899992],
              [16.522536255000148, -1.861745706999969],
              [16.524970535000108, -1.858534921999961],
              [16.604185018000123, -1.754052021999911],
              [16.617207479000058, -1.728730569999925],
              [16.623098592000076, -1.699171650999901],
              [16.622478475000094, -1.665168557999948],
              [16.623822062000073, -1.653799743999869],
              [16.628886352000052, -1.637263284999975],
              [16.636224406000053, -1.62083017899991],
              [16.65597112900008, -1.590290215999886],
              [16.66950402800009, -1.569360452999931],
              [16.69255171700013, -1.522955016999916],
              [16.725521281000084, -1.479960225999932],
              [16.762728312, -1.405856220999908],
              [16.77926477000011, -1.382395120999931],
              [16.794664347000094, -1.345498147999905],
              [16.81781538900009, -1.304157002999958],
              [16.828667440000117, -1.276251729999984],
              [16.83321496600007, -1.269017028999926],
              [16.83972619600013, -1.26250579799995],
              [16.862567179000052, -1.248863219999947],
              [16.909179321000096, -1.211139424999899],
              [16.940495239000114, -1.174759215999913],
              [16.979562622000117, -1.140239359999924],
              [17.003127075000123, -1.112850849999887],
              [17.005917602000096, -1.106753030999926],
              [17.012015421000058, -1.104272562999952],
              [17.02255741400009, -1.097037861999894],
              [17.028655233000052, -1.094454040999892],
              [17.060487915000095, -1.089183043999952],
              [17.10865035000009, -1.075643818999879],
              [17.17541630100004, -1.048255309999931],
              [17.194846639000104, -1.042984313999909],
              [17.245386190000147, -1.035852965999965],
              [17.297682739000066, -1.021073506999954],
              [17.30801802600007, -1.014975687999893],
              [17.327655070000105, -0.991721292999969],
              [17.33044559700005, -0.986553648999873],
              [17.357317342000073, -0.973531188999928],
              [17.364965454000128, -0.967226663999924],
              [17.38542932100009, -0.942421976999881],
              [17.41147424300007, -0.918340758999932],
              [17.545863410000038, -0.756491041999936],
              [17.60216027900009, -0.688690693999945],
              [17.623037557000146, -0.673291117999952],
              [17.63585331200005, -0.658511656999849],
              [17.647635538000145, -0.649933369999914],
              [17.650942830000133, -0.646316018999926],
              [17.652493123000056, -0.642181904999902],
              [17.654456828000093, -0.62750579899992],
              [17.658694296000135, -0.619754332999918],
              [17.66417199700004, -0.612726337999902],
              [17.7280440670001, -0.553091735999899],
              [17.741996704000087, -0.533351338999935],
              [17.749541463000128, -0.523429462999943],
              [17.740756470000036, -0.346179300999978],
              [17.71626184100009, -0.246237079999929],
              [17.7136780190001, -0.220915628999947],
              [17.716365193000115, -0.195800882999919],
              [17.757086222000083, -0.009455667999887],
              [17.77537967900014, 0.026407776000056],
              [17.85403121000013, 0.241071676000075],
              [17.939917440000073, 0.361271057000039],
              [17.945498494000077, 0.377290752000093],
              [17.95200972500004, 0.474339091000061],
              [17.94994266800009, 0.491495666000034],
              [17.943638143000072, 0.510822652000073],
              [17.933096151000115, 0.527049052000081],
              [17.9184200440001, 0.535213929000093],
              [17.89929976400012, 0.58327301100006],
              [17.893201945000072, 0.607664287000091],
              [17.8925818270001, 0.635879618000061],
              [17.90756799300007, 0.713084208000041],
              [17.907671346000086, 0.740472718000078],
              [17.877905721000104, 0.8679068000001],
              [17.87821578000009, 0.947178446000038],
              [17.866640259000064, 1.016631572000108],
              [17.87325484200005, 1.039627584000058],
              [17.892478475000075, 1.077403056000108],
              [17.91480269400003, 1.102001038000097],
              [17.95624719200009, 1.171660868000032],
              [17.96337854000012, 1.191452942000097],
              [17.966995890000106, 1.253723043000122],
              [18.00203251100004, 1.365783386000075],
              [18.00668339000009, 1.402396138000114],
              [18.012264445000113, 1.421955668000038],
              [18.071382284000066, 1.551456808000111],
              [18.0736560470001, 1.572334086000097],
              [18.06611128700004, 1.858983256000073],
              [18.068178345000092, 1.876217347000065],
              [18.078306926000067, 1.909290263000045],
              [18.081510864000023, 1.926550192000136],
              [18.08171757000008, 1.942414856000141],
              [18.076033163000147, 1.988484396000061],
              [18.08078739500013, 2.084163310000065],
              [18.078306926000067, 2.114807434000085],
              [18.072415812000145, 2.145193176000049],
              [18.072415812000145, 2.160024312000075],
              [18.111173137000094, 2.265289205000073],
              [18.11861454300012, 2.276968079000142],
              [18.142695760000066, 2.305700175000055],
              [18.14672652200005, 2.31593210900013],
              [18.163779744000095, 2.321048076000125],
              [18.174011678000056, 2.336137594000121],
              [18.187964314000055, 2.370915833000069],
              [18.1991264240001, 2.38910593700011],
              [18.20780806500005, 2.407967835000136],
              [18.214112589000052, 2.427656556000088],
              [18.225171346000053, 2.486464335000065],
              [18.23302616400011, 2.502587382000058],
              [18.246151978000057, 2.518917135000081],
              [18.30351281700004, 2.572557272000068],
              [18.313744751000115, 2.575967916000081],
              [18.316741984000146, 2.584339498000062],
              [18.39322310400013, 2.713685608000105],
              [18.418337850000057, 2.781743469000091],
              [18.421851847000113, 2.808821920000057],
              [18.4251591390001, 2.822154440000077],
              [18.449240356000132, 2.873004049000087],
              [18.467327108000063, 2.898893942000129],
              [18.47177128100006, 2.909229227000125],
              [18.475802042000055, 2.931191711000096],
              [18.479626098000097, 2.941371969000073],
              [18.495335734000065, 2.966073304000076],
              [18.528408651000063, 3.064775289000096],
              [18.541431112000083, 3.082810364000096],
              [18.5621016850001, 3.096814677000097],
              [18.597345011000073, 3.114643046000054],
              [18.61305464700007, 3.128182272000032],
              [18.619669230000056, 3.144770406000134],
              [18.621839640000132, 3.156655986000061],
              [18.631141398000068, 3.178980204000126],
              [18.642406860000023, 3.323829244000081],
              [18.6345520430001, 3.449222108000058],
              [18.626387166000086, 3.476868998000072],
            ],
          ],
          [
            [
              [12.905290483000044, -5.869487836999951],
              [12.933938671000078, -5.87382275199991],
              [12.953781894000088, -5.871599569999944],
              [12.972521871000083, -5.868281448999937],
              [12.99458990900007, -5.868244252999943],
              [12.969298816000048, -5.888014362999911],
              [12.94063080300009, -5.896823945999927],
              [12.884423287000061, -5.907861518999937],
              [12.87011427100009, -5.917740778999928],
              [12.839276059000042, -5.927639893999924],
              [12.80737329100009, -5.953969799999925],
              [12.78315099200006, -5.960571545999926],
              [12.761119136000048, -5.958406460999925],
              [12.745127800000091, -5.940199476999908],
              [12.765463596000075, -5.920066897999959],
              [12.795161178000058, -5.897029728999939],
              [12.828160887000081, -5.871794391999913],
              [12.854595119000066, -5.86846996099996],
              [12.905290483000044, -5.869487836999951],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Namibia',
        iso3: 'NAM',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [16.487071160000085, -28.572930596999925],
            [16.46851647200009, -28.585137627999927],
            [16.458506707000083, -28.60051848799992],
            [16.44581139400009, -28.610528252999927],
            [16.419444207000083, -28.607028903999947],
            [16.40788821700005, -28.60051848799992],
            [16.346853061000047, -28.556084893999923],
            [16.315928582000083, -28.52434661299992],
            [16.301036004000082, -28.50448984199994],
            [16.193369988000086, -28.40878671699994],
            [16.175791863000086, -28.402113539999903],
            [16.167979363000086, -28.39576588299991],
            [16.107676629000082, -28.323337497999944],
            [16.043630405000044, -28.25709400799991],
            [15.911143425000091, -28.171319268999923],
            [15.884287957000083, -28.147637627999927],
            [15.833181186000047, -28.089288018999923],
            [15.76148522200009, -28.03834400799991],
            [15.74781334700009, -28.024590752999927],
            [15.716807488000086, -27.980401299999926],
            [15.684255405000044, -27.949883721999925],
            [15.678884311000047, -27.942803643999923],
            [15.677989129000082, -27.931247653999947],
            [15.684580925000091, -27.910821221999925],
            [15.685801629000082, -27.90129973799992],
            [15.673024936000047, -27.869886976999908],
            [15.646006707000083, -27.836602471999925],
            [15.54623457100007, -27.747816664999903],
            [15.533539259000065, -27.73015715899993],
            [15.52865644600007, -27.706149997999944],
            [15.52906334700009, -27.654229424999926],
            [15.526866082000083, -27.64617278399993],
            [15.520681186000047, -27.63372161299992],
            [15.425059441000087, -27.49651458099993],
            [15.408946160000085, -27.46453215899993],
            [15.396820509000065, -27.448663018999923],
            [15.380381707000083, -27.44198984199994],
            [15.371755405000044, -27.433038018999923],
            [15.342458530000044, -27.38054778399993],
            [15.301605665000068, -27.333103122999944],
            [15.295258009000065, -27.322442315999922],
            [15.281748894000089, -27.243340752999927],
            [15.276215040000068, -27.233575127999927],
            [15.269541863000086, -27.226332289999903],
            [15.263682488000086, -27.218357028999947],
            [15.261241082000083, -27.205743096999925],
            [15.268077019000089, -27.164808851999908],
            [15.254161004000082, -27.10019296699994],
            [15.261241082000083, -27.08562590899993],
            [15.241221550000091, -27.048760674999926],
            [15.235362175000091, -27.029473565999922],
            [15.233246290000068, -27.006931247999944],
            [15.234222852000073, -26.96542734199994],
            [15.228526238000086, -26.945570570999905],
            [15.212738477000073, -26.927992445999905],
            [15.205739780000044, -26.925551039999903],
            [15.187510613000086, -26.92424895599993],
            [15.178558790000068, -26.92115650799991],
            [15.176605665000068, -26.916761976999908],
            [15.16968834700009, -26.906182549999926],
            [15.162364129000082, -26.89706796699994],
            [15.158864780000044, -26.89706796699994],
            [15.15593509200005, -26.87509530999995],
            [15.148936394000089, -26.85637786299992],
            [15.11687259200005, -26.79615650799991],
            [15.111664259000065, -26.779229424999926],
            [15.116221550000091, -26.75204843499995],
            [15.105723504000082, -26.732354424999926],
            [15.09156334700009, -26.71217213299991],
            [15.083018425000091, -26.695245049999926],
            [15.080821160000085, -26.672133070999905],
            [15.083506707000083, -26.652113539999903],
            [15.091807488000086, -26.63795338299991],
            [15.106618686000047, -26.632582289999903],
            [15.11695397200009, -26.630303643999923],
            [15.127126498000052, -26.626722914999903],
            [15.134613477000073, -26.627129815999922],
            [15.137705925000091, -26.636651299999926],
            [15.137705925000091, -26.674899997999944],
            [15.144541863000086, -26.674899997999944],
            [15.148448113000086, -26.655043226999908],
            [15.168142123000052, -26.60279713299991],
            [15.168711785000085, -26.59221770599993],
            [15.162282748000052, -26.57903411299992],
            [15.14193769600007, -26.51799895599993],
            [15.128754102000073, -26.45761484199994],
            [15.105642123000052, -26.420586846999925],
            [15.072520379000082, -26.389743747999944],
            [15.034678582000083, -26.366306247999944],
            [14.975271030000044, -26.34417083099993],
            [14.966319207000083, -26.33521900799991],
            [14.958832227000073, -26.257012627999927],
            [14.96265709700009, -26.18132903399993],
            [14.942556186000047, -26.153903903999947],
            [14.93913821700005, -26.147149346999925],
            [14.94312584700009, -26.13534921699994],
            [14.949066602000073, -26.135023695999905],
            [14.956879102000073, -26.13762786299992],
            [14.966319207000083, -26.133558851999908],
            [14.97982832100007, -26.10165780999995],
            [14.979014519000089, -26.058770440999922],
            [14.968272332000083, -26.015801690999922],
            [14.952647332000083, -25.982679945999905],
            [14.907725457000083, -25.91529713299991],
            [14.90211022200009, -25.88250090899993],
            [14.918630405000044, -25.845472914999903],
            [14.911143425000091, -25.845472914999903],
            [14.859873894000089, -25.79029713299991],
            [14.842784050000091, -25.763604424999926],
            [14.840342644000089, -25.751722914999903],
            [14.840342644000089, -25.743340752999927],
            [14.842784050000091, -25.72942473799992],
            [14.842784050000091, -25.650323174999926],
            [14.846934441000087, -25.62981536299992],
            [14.876963738000086, -25.578057549999926],
            [14.879730665000068, -25.56145598799992],
            [14.879567905000044, -25.538669528999947],
            [14.875336134000065, -25.51848723799992],
            [14.85328209700009, -25.498711846999925],
            [14.84701582100007, -25.473321221999925],
            [14.842784050000091, -25.42782968499995],
            [14.81804446700005, -25.36695728999996],
            [14.812510613000086, -25.32008228999996],
            [14.80241946700005, -25.28289153399993],
            [14.801280144000089, -25.262790622999944],
            [14.832286004000082, -25.188164971999925],
            [14.829356316000087, -25.176446221999925],
            [14.849619988000086, -25.105075778999947],
            [14.85328209700009, -25.06422291499996],
            [14.843272332000083, -25.026055596999925],
            [14.82943769600007, -25.00009530999995],
            [14.808767123000052, -24.961114190999922],
            [14.796153191000087, -24.92197030999995],
            [14.792979363000086, -24.84189218499995],
            [14.780772332000083, -24.803399346999925],
            [14.723480665000068, -24.70354583099993],
            [14.699473504000082, -24.673028252999927],
            [14.65015709700009, -24.628838799999926],
            [14.63607832100007, -24.59889088299991],
            [14.601898634000065, -24.562432549999926],
            [14.595876498000052, -24.53720468499995],
            [14.599619988000086, -24.526543877999927],
            [14.613780144000089, -24.511651299999926],
            [14.61695397200009, -24.505791924999926],
            [14.61695397200009, -24.464776299999926],
            [14.612315300000091, -24.44573333099993],
            [14.590098504000082, -24.408379815999922],
            [14.56812584700009, -24.357679945999905],
            [14.513926629000082, -24.26148853999996],
            [14.493174675000091, -24.19231536299992],
            [14.473643425000091, -24.15911223799992],
            [14.466807488000086, -24.113213799999926],
            [14.459239129000082, -24.098321221999925],
            [14.46420332100007, -24.07822030999995],
            [14.464121941000087, -24.04469166499996],
            [14.459646030000044, -24.010430596999925],
            [14.451914910000085, -23.988457940999922],
            [14.459239129000082, -23.974541924999926],
            [14.465830925000091, -23.947198174999926],
            [14.472911004000082, -23.933851820999905],
            [14.479177280000044, -23.931084893999923],
            [14.488291863000086, -23.929620049999926],
            [14.496592644000089, -23.925957940999922],
            [14.500254754000082, -23.91643645599993],
            [14.513926629000082, -23.89226653399993],
            [14.506032748000052, -23.880059502999927],
            [14.507090691000087, -23.82390715899993],
            [14.489512566000087, -23.776055596999925],
            [14.486582879000082, -23.758477471999925],
            [14.500254754000082, -23.614434502999927],
            [14.495290561000047, -23.57854583099993],
            [14.48406009200005, -23.551039320999905],
            [14.44695071700005, -23.460381768999923],
            [14.434336785000085, -23.415215752999927],
            [14.435069207000083, -23.40553150799991],
            [14.44312584700009, -23.396661065999922],
            [14.467458530000044, -23.35605234199994],
            [14.479746941000087, -23.344821872999944],
            [14.479502800000091, -23.36581796699994],
            [14.484385613000086, -23.374932549999926],
            [14.490407748000052, -23.36972421699994],
            [14.493418816000087, -23.347832940999922],
            [14.49195397200009, -23.30917734199994],
            [14.473480665000068, -23.192803643999923],
            [14.462738477000073, -23.157403252999927],
            [14.445567254000082, -23.13128020599993],
            [14.43132571700005, -23.10328541499996],
            [14.420664910000085, -23.070977471999925],
            [14.41382897200009, -23.036228122999944],
            [14.410166863000086, -22.97079843499995],
            [14.411387566000087, -22.961195570999905],
            [14.416026238000086, -22.95159270599993],
            [14.42904707100007, -22.93254973799992],
            [14.431895379000082, -22.923028252999927],
            [14.431895379000082, -22.88176848799992],
            [14.435069207000083, -22.87981536299992],
            [14.440928582000083, -22.87981536299992],
            [14.443858269000089, -22.883477471999925],
            [14.438161655000044, -22.89226653399993],
            [14.44271894600007, -22.89853280999995],
            [14.448090040000068, -22.908135674999926],
            [14.451914910000085, -22.91220468499995],
            [14.445974155000044, -22.932386976999908],
            [14.444346550000091, -22.95281340899993],
            [14.451670769000089, -22.96331145599993],
            [14.472911004000082, -22.953789971999925],
            [14.471446160000085, -22.965101820999905],
            [14.459239129000082, -22.995293877999927],
            [14.47429446700005, -22.98219166499996],
            [14.496836785000085, -22.94182708099993],
            [14.510508660000085, -22.93328215899993],
            [14.521983269000089, -22.923435153999947],
            [14.529307488000086, -22.90016041499996],
            [14.534353061000047, -22.854180596999925],
            [14.527517123000052, -22.67945728999996],
            [14.508555535000085, -22.548028252999927],
            [14.485118035000085, -22.512383721999925],
            [14.47429446700005, -22.467868747999944],
            [14.438161655000044, -22.39885833099993],
            [14.418711785000085, -22.339776299999926],
            [14.38648522200009, -22.276462497999944],
            [14.380381707000083, -22.26848723799992],
            [14.315196160000085, -22.200290622999944],
            [14.29428144600007, -22.167413018999923],
            [14.293467644000089, -22.143324476999908],
            [14.291351759000065, -22.13445403399993],
            [14.137217644000089, -21.946384372999944],
            [14.062022332000083, -21.88095468499995],
            [14.054209832000083, -21.864678643999923],
            [13.971690300000091, -21.79273853999996],
            [13.952321811000047, -21.783949476999908],
            [13.952159050000091, -21.773370049999926],
            [13.95639082100007, -21.76295338299991],
            [13.958994988000086, -21.75839609199994],
            [13.965179884000065, -21.733168226999908],
            [13.965830925000091, -21.726739190999922],
            [13.96265709700009, -21.714043877999927],
            [13.958262566000087, -21.70484791499996],
            [13.877940300000091, -21.59221770599993],
            [13.862803582000083, -21.528008721999925],
            [13.83171634200005, -21.456475518999923],
            [13.729258660000085, -21.330254815999922],
            [13.666840040000068, -21.232354424999926],
            [13.628103061000047, -21.18759530999995],
            [13.602712436000047, -21.158135674999926],
            [13.51335696700005, -21.00790780999995],
            [13.471934441000087, -20.955010674999926],
            [13.459157748000052, -20.91806405999995],
            [13.444834832000083, -20.90406666499996],
            [13.41773522200009, -20.883884372999944],
            [13.397634311000047, -20.84929778399993],
            [13.387217644000089, -20.81609465899993],
            [13.37671959700009, -20.733575127999927],
            [13.349457227000073, -20.644463799999926],
            [13.262705925000091, -20.485121351999908],
            [13.239024285000085, -20.397149346999925],
            [13.233571811000047, -20.354668877999927],
            [13.213063998000052, -20.273370049999926],
            [13.177744988000086, -20.18922291499996],
            [13.154633009000065, -20.154229424999926],
            [13.11442526500008, -20.142572715999904],
            [13.070880462000048, -20.11422853399995],
            [13.037345391000088, -20.059464634999927],
            [13.005381707000083, -19.935479424999926],
            [12.927744988000086, -19.79469166499996],
            [12.918467644000089, -19.765557549999926],
            [12.875987175000091, -19.712009372999944],
            [12.80250084700009, -19.584730726999908],
            [12.793955925000091, -19.561700127999927],
            [12.783050977000073, -19.54697030999995],
            [12.75757897200009, -19.496840101999908],
            [12.749278191000087, -19.48601653399993],
            [12.704600457000083, -19.410821221999925],
            [12.69109134200005, -19.37900155999995],
            [12.686045769000089, -19.35979583099993],
            [12.679698113000086, -19.314060153999947],
            [12.668304884000065, -19.292413018999923],
            [12.636241082000083, -19.252618096999925],
            [12.615733269000089, -19.217543226999908],
            [12.567393425000091, -19.102308851999908],
            [12.546722852000073, -19.071465752999927],
            [12.516449415000068, -19.03753020599993],
            [12.480316602000073, -19.01100025799991],
            [12.47038821700005, -18.997653903999947],
            [12.45866946700005, -18.92555103999996],
            [12.450043165000068, -18.904554945999905],
            [12.28687584700009, -18.69768645599993],
            [12.174730934000081, -18.62793892399992],
            [12.125743035000085, -18.57480234199994],
            [12.119639519000089, -18.569512627999927],
            [12.102061394000089, -18.545993747999944],
            [12.091644727000073, -18.54070403399993],
            [12.082041863000086, -18.534356377999927],
            [12.03188937100009, -18.505350000999954],
            [12.015961134000065, -18.45289478999996],
            [12.012461785000085, -18.43450286299992],
            [11.999522332000083, -18.403497002999927],
            [11.998220248000052, -18.39185963299991],
            [11.998545769000089, -18.38176848799992],
            [11.997569207000083, -18.37200286299992],
            [11.999522332000083, -18.36191171699994],
            [11.976084832000083, -18.32976653399993],
            [11.937347852000073, -18.23211028399993],
            [11.931162957000083, -18.225355726999908],
            [11.849081614000056, -18.143183241999907],
            [11.83363984400006, -18.098044690999927],
            [11.82652435600005, -18.039220163999914],
            [11.808498804000067, -17.991541785999914],
            [11.796911021000085, -17.956088842999918],
            [11.784036598000057, -17.859645117999946],
            [11.760941181000078, -17.78642440199991],
            [11.74555201000004, -17.68394836199991],
            [11.734030611000037, -17.63272066199994],
            [11.726735873000052, -17.599867445999905],
            [11.717621290000068, -17.546319268999923],
            [11.721690300000091, -17.467868747999944],
            [11.755137566000087, -17.266696872999944],
            [11.766123894000089, -17.252699476999908],
            [11.766183862000048, -17.25275074599992],
            [11.77951826900005, -17.254914651999897],
            [11.79688155100007, -17.263802998999907],
            [11.807630249000084, -17.265870055999883],
            [11.822409709000084, -17.26442311599989],
            [11.827473999000063, -17.260082294999904],
            [11.829644409000139, -17.253467712999907],
            [11.835535523000146, -17.245406188999908],
            [11.853932332000056, -17.233417256999957],
            [11.894963419000106, -17.214607035999947],
            [11.942092326000108, -17.180500589999966],
            [11.983020060000115, -17.161897073999924],
            [12.028908732000104, -17.14897796599992],
            [12.075210816000066, -17.14298349999997],
            [12.082238810000092, -17.141329853999935],
            [12.088129923000082, -17.139159443999944],
            [12.095261271000112, -17.139676207999884],
            [12.10559655800003, -17.14608408599993],
            [12.139909708000062, -17.15600596099992],
            [12.151278524000134, -17.15362884499997],
            [12.156652873000098, -17.149081318999933],
            [12.161510457000134, -17.146290791999974],
            [12.170708862000112, -17.14918467199996],
            [12.17711674000006, -17.154765726999884],
            [12.179493856000107, -17.16158701599994],
            [12.181147501000055, -17.16923512799991],
            [12.185074911000129, -17.17708994499995],
            [12.190655965000133, -17.182567646999942],
            [12.200474487000122, -17.18928558399996],
            [12.211739950000066, -17.195176695999876],
            [12.222281942000052, -17.19765716499994],
            [12.231790405000112, -17.201894632999895],
            [12.236544637000122, -17.211299743999945],
            [12.239335165000085, -17.22070485499991],
            [12.242642456000084, -17.22483896899992],
            [12.314679402000138, -17.2181210319999],
            [12.379481649000041, -17.22039479499992],
            [12.393951050000084, -17.214710387999972],
            [12.407593628000086, -17.20406504299997],
            [12.4179289140001, -17.203444925999918],
            [12.44170007300005, -17.21698415099989],
            [12.460510294000073, -17.223081970999942],
            [12.5192147220001, -17.22783620099993],
            [12.554561401000115, -17.235587666999947],
            [12.567170451000038, -17.234554137999865],
            [12.591458374000041, -17.222565205999913],
            [12.63621016400009, -17.185151468999933],
            [12.660704793000065, -17.17708994499995],
            [12.685922892000121, -17.173575948],
            [12.704733114000106, -17.164274189999958],
            [12.739873088000081, -17.13554209399996],
            [12.784314820000134, -17.1150782269999],
            [12.818317912000083, -17.104846292999923],
            [12.82493249500007, -17.096371357999914],
            [12.833097371000093, -17.08179860399987],
            [12.84229577700009, -17.074047138999944],
            [12.84994388800007, -17.07084319999997],
            [12.8677205810001, -17.065572204999953],
            [12.876402222000081, -17.059784443999973],
            [12.880536336000091, -17.05079274499994],
            [12.882293335000071, -17.039527281999966],
            [12.887150920000096, -17.029812112999934],
            [12.91102543100007, -17.02350758899992],
            [12.930455770000066, -17.0142058309999],
            [12.961668335000127, -17.00738454199994],
            [13.014274943000117, -16.97792897499994],
            [13.121761922000132, -16.959842223999928],
            [13.144499552000099, -16.9524008179999],
            [13.166307006000125, -16.951057230999936],
            [13.184910523000099, -16.9641830449999],
            [13.198139689000072, -16.95736175499995],
            [13.205477743000074, -16.963046162999902],
            [13.212092325000071, -16.972761331999934],
            [13.222841023000086, -16.97792897499994],
            [13.245268595000084, -16.981339619999872],
            [13.25715417500004, -16.98164967799994],
            [13.26748946100011, -16.97792897499994],
            [13.26748946100011, -16.985370380999953],
            [13.293017619000068, -16.973794860999917],
            [13.308417195000061, -16.97017751099993],
            [13.315238485000094, -16.974414977999885],
            [13.32154300900001, -16.974931742999928],
            [13.345946539000096, -16.96871123499993],
            [13.363710978000086, -16.9641830449999],
            [13.382004435000056, -16.970384215999985],
            [13.417247762000017, -16.993741962999934],
            [13.435127807000072, -16.99901295999996],
            [13.45889896600005, -17.00180348699992],
            [13.479776245000096, -17.010278421999928],
            [13.494659058000138, -17.02402435299996],
            [13.507784872000116, -17.063505146999987],
            [13.522254273000044, -17.076941018999932],
            [13.530935913000093, -17.093270771999883],
            [13.521324097000104, -17.121899515999957],
            [13.60648685700005, -17.167374775999917],
            [13.694130086000143, -17.23662119599993],
            [13.790403279000117, -17.28809092199991],
            [13.884351033000115, -17.33852711999991],
            [13.896856730000138, -17.349069111999967],
            [13.9427454020001, -17.408186950999934],
            [13.95731815600007, -17.419142353999916],
            [13.98057255000009, -17.42358652799993],
            [13.992974894000042, -17.421312763999907],
            [14.008891236000068, -17.411494241999932],
            [14.017882934000113, -17.409220478999927],
            [14.029148396000068, -17.410460713999953],
            [14.047441854000056, -17.416041768999975],
            [14.069145956000057, -17.418625589999877],
            [14.085372355000061, -17.42358652799993],
            [14.097257935000073, -17.42358652799993],
            [14.10821333800007, -17.420485940999882],
            [14.12392297300002, -17.41159759499996],
            [14.130744263000082, -17.409220478999927],
            [14.174979288000088, -17.41624847399993],
            [14.197096802000118, -17.412941181999926],
            [14.206501913000068, -17.393097432999937],
            [14.207432088000104, -17.388033141999955],
            [14.218800903000101, -17.388136494999898],
            [14.219111804000079, -17.388136494999898],
            [14.287427206000046, -17.388136494999898],
            [14.543949015000067, -17.388239846999923],
            [14.80057417800009, -17.38834320099994],
            [15.057199341000114, -17.38834320099994],
            [15.313721151000095, -17.388446553999884],
            [15.559114346000086, -17.388545422999897],
            [15.570242961000105, -17.388549906999913],
            [15.826764770000096, -17.388653258999938],
            [16.08338993300012, -17.388653258999938],
            [16.339808390000087, -17.388653258999938],
            [16.596330200000097, -17.388756611999952],
            [16.852852010000106, -17.388756611999952],
            [17.10947717300013, -17.388859964999895],
            [17.278972034000105, -17.38892822699995],
            [17.36610233600004, -17.388963317999924],
            [17.622624146000135, -17.388963317999924],
            [17.87914595500004, -17.38906666999995],
            [18.000482986000094, -17.389115556999897],
            [18.13566776500005, -17.389170022999878],
            [18.392292928000074, -17.389273375999906],
            [18.445726359000076, -17.389273375999906],
            [18.453581177000018, -17.389893493999878],
            [18.455028117000012, -17.395991312999925],
            [18.45864546700011, -17.405293070999946],
            [18.465156697000083, -17.409220478999927],
            [18.471667928000045, -17.414284769999895],
            [18.488101033000106, -17.45211191799997],
            [18.489858032000086, -17.46244720399997],
            [18.492751912000074, -17.464514261999938],
            [18.516626424000066, -17.471335549999907],
            [18.550939575000086, -17.535310973999884],
            [18.554143514000145, -17.546369730999885],
            [18.567476033000077, -17.553294371999968],
            [18.619669230000056, -17.594842223999947],
            [18.622873169000115, -17.602180276999945],
            [18.627937459000094, -17.61985361799995],
            [18.633311808000144, -17.628948668999925],
            [18.64282027200005, -17.638043721999892],
            [18.66132043400006, -17.646725361999955],
            [18.670932251000067, -17.653133239999903],
            [18.72829309100007, -17.7109074909999],
            [18.74824019400009, -17.736332295],
            [18.761986124000117, -17.7477011109999],
            [18.80084680200008, -17.756589456999905],
            [18.89004032400001, -17.799274189999906],
            [19.020574992000093, -17.822321878999958],
            [19.105117635000056, -17.818187763999944],
            [19.139327433000062, -17.805268655999924],
            [19.16082482900009, -17.800927835999943],
            [19.172090292000064, -17.80123789499993],
            [19.201855916000028, -17.807129007999933],
            [19.246607706000106, -17.804028421999902],
            [19.26242069500009, -17.81395029699989],
            [19.421274048000043, -17.859425556999938],
            [19.59283980300006, -17.857255146999947],
            [19.64978723200005, -17.84495615599991],
            [19.672628215000145, -17.842682392999905],
            [19.69319543500012, -17.847746683999972],
            [19.70218713400007, -17.86573008199987],
            [19.711282186000062, -17.872964781999926],
            [19.732056112000095, -17.882059835],
            [19.75520715300007, -17.88908782999991],
            [19.771020141000093, -17.890328063999945],
            [19.775981079000132, -17.88505706799991],
            [19.787659953000087, -17.866453551999953],
            [19.793964477000117, -17.86231943799993],
            [19.95199100700006, -17.86231943799993],
            [19.989508097000055, -17.88278330499989],
            [20.024544719000062, -17.894565530999984],
            [20.034259888000093, -17.895909118999953],
            [20.09255090300013, -17.890328063999945],
            [20.119939413000083, -17.890741474999956],
            [20.132961873000113, -17.888777770999923],
            [20.147121216000073, -17.88278330499989],
            [20.1545626220001, -17.890328063999945],
            [20.169238729000085, -17.878132425999922],
            [20.19311324000006, -17.872137959999904],
            [20.219881633000057, -17.87337819399994],
            [20.24344608500013, -17.88278330499989],
            [20.278172648000066, -17.854878030999913],
            [20.28892134600011, -17.86159596699993],
            [20.302770630000055, -17.860769143999917],
            [20.33615360500005, -17.854878030999913],
            [20.347729126000075, -17.858908792999912],
            [20.386796509000078, -17.890328063999945],
            [20.412634725000117, -17.884126891999955],
            [20.437542765000074, -17.89446217799987],
            [20.460073690000087, -17.913685810999894],
            [20.479504028000093, -17.934356383999912],
            [20.48952925600011, -17.94210784899991],
            [20.52394576000006, -17.95854095399997],
            [20.552884562000116, -17.979108174999865],
            [20.565493611000136, -17.985205993999926],
            [20.590711710000107, -17.97879811599998],
            [20.630089152000096, -17.976937764999974],
            [20.66626265500011, -17.980245055999973],
            [20.68217899600006, -17.98861663799994],
            [20.68962040200006, -17.99698821999992],
            [20.70615686000008, -18.003809508999964],
            [20.722486613000086, -18.00649668299991],
            [20.729928020000017, -18.00236256899997],
            [20.73747277800007, -17.993474221999875],
            [20.754422648000087, -17.997918395999974],
            [20.78460168500007, -18.012594501999956],
            [20.80620243300004, -18.031404723999884],
            [20.83193729600012, -18.029337666999908],
            [20.861599569000106, -18.018795673999946],
            [20.894465780000132, -18.012594501999956],
            [20.90831506300009, -17.986136168999877],
            [20.986454526000074, -17.965770962999912],
            [21.000712524000107, -17.96205495199993],
            [21.093109986000087, -17.93807708699991],
            [21.10943973800005, -17.945001728999983],
            [21.126079549000053, -17.941074319999927],
            [21.143132772000087, -17.93373626699993],
            [21.161322876000042, -17.930635680999984],
            [21.175792277000056, -17.9332195019999],
            [21.21661665800005, -17.930635680999984],
            [21.23273970600013, -17.934459736999926],
            [21.27811161300008, -17.95854095399997],
            [21.335059041000136, -17.977971292999953],
            [21.364824666000118, -17.99202728199988],
            [21.38115441900007, -18.012594501999956],
            [21.386838826000115, -18.014454853999965],
            [21.405545695000086, -18.009287210999958],
            [21.477582642000073, -17.99605804499997],
            [21.72852339700006, -17.949859313999923],
            [21.979464152000048, -17.90376393599989],
            [22.230508260000136, -17.857565205999933],
            [22.481449015000123, -17.811366474999986],
            [22.68567427500011, -17.77281585599991],
            [22.889796183000072, -17.734058531999978],
            [23.09391809100012, -17.69540456099989],
            [23.298039998000093, -17.656853942999902],
            [23.381652466000105, -17.641144306999934],
            [23.422373494000084, -17.633496194999864],
            [23.4574101150001, -17.626778258999934],
            [23.476220337000115, -17.626364847999923],
            [23.505985962000096, -17.620473733999916],
            [23.54877404800004, -17.611998799999924],
            [23.5917688400001, -17.603523864999914],
            [23.634556925000112, -17.59504892999992],
            [23.677241659000117, -17.586677347999938],
            [23.720029744000044, -17.57820241299993],
            [23.762817831000092, -17.569727477999933],
            [23.805605916000104, -17.561355895999952],
            [23.848497355000063, -17.552880960999957],
            [23.891388794000108, -17.544406025999947],
            [23.934176880000052, -17.536034443999966],
            [23.976964965000064, -17.52755950899997],
            [24.01964969900007, -17.519084573999876],
            [24.06254113700001, -17.510712991999895],
            [24.10532922400006, -17.5022380569999],
            [24.14811730900007, -17.49376312199989],
            [24.19090539600009, -17.4852881879999],
            [24.22046431400011, -17.47950042699992],
            [24.23875777100008, -17.478156839999954],
            [24.257361287000066, -17.48084401399997],
            [24.310277954000128, -17.482601012999865],
            [24.32133671100013, -17.488698831999912],
            [24.32939823400011, -17.485081481999927],
            [24.371256144000085, -17.47371266599994],
            [24.3889294840001, -17.471335549999907],
            [24.4070162350001, -17.47453948999997],
            [24.449287557000105, -17.489112242999923],
            [24.47925988800006, -17.49448659299989],
            [24.498173462000068, -17.503478291999926],
            [24.523598267000096, -17.507819111999908],
            [24.531659790000077, -17.513400165999926],
            [24.537860962000053, -17.520324808999916],
            [24.54654260300012, -17.526525979999903],
            [24.562458944000042, -17.53221038799994],
            [24.571243937000133, -17.53345062299988],
            [24.580752401000012, -17.532830504999907],
            [24.591294393000084, -17.528386331999897],
            [24.606487264000094, -17.51515716599991],
            [24.61744266800008, -17.509162698999972],
            [24.622817017000045, -17.50234140999993],
            [24.629741659000047, -17.49552012099987],
            [24.63945682800008, -17.492419534999925],
            [24.68441532400007, -17.492419534999925],
            [24.769784790000074, -17.50544199599996],
            [24.77505578600011, -17.507612405999865],
            [24.780016723000074, -17.512263284999918],
            [24.786838013000107, -17.51691416399997],
            [24.797380005000065, -17.519084573999876],
            [24.829522745000105, -17.51774098699991],
            [24.898252400000075, -17.53107350699993],
            [24.924917439000126, -17.542959085999954],
            [24.937629842000092, -17.5607357789999],
            [24.95799035600001, -17.551744078999945],
            [24.969987330000038, -17.55996247899995],
            [24.971116170000073, -17.5607357789999],
            [24.982588338000085, -17.576548766999892],
            [24.99850468000011, -17.588020934999903],
            [25.008013142000095, -17.588537699999947],
            [25.026720011000094, -17.582749938999967],
            [25.036951945000084, -17.581199645999945],
            [25.04056929500007, -17.584506936999944],
            [25.03385135900004, -17.60156015999989],
            [25.03385135900004, -17.608484801999865],
            [25.0400525310001, -17.616132913999934],
            [25.04532352700005, -17.61995696999989],
            [25.052558227000105, -17.621403909999884],
            [25.06423710100009, -17.621507263],
            [25.067027628000034, -17.62533131899994],
            [25.085217732000075, -17.64093760199998],
            [25.08852502400009, -17.64269460099996],
            [25.096896606000143, -17.672150166999955],
            [25.098756958000052, -17.676801045999923],
            [25.107955363000144, -17.678868102999985],
            [25.1150867100001, -17.68424245199995],
            [25.12004764800014, -17.69106374099991],
            [25.122631469000055, -17.697885029999952],
            [25.13141646300005, -17.686516214999955],
            [25.13854781100008, -17.686102803999944],
            [25.15332727100008, -17.700985615999898],
            [25.15642785600005, -17.706670023999934],
            [25.155290975000128, -17.719382425999896],
            [25.15684126800005, -17.725170185999957],
            [25.161182088000118, -17.729407652999924],
            [25.17244755100009, -17.73509206099996],
            [25.177821899000037, -17.738812763999974],
            [25.19074100700007, -17.755349222999968],
            [25.198182414000087, -17.758449808999913],
            [25.215132283000088, -17.759276630999935],
            [25.228878215000123, -17.762480570999912],
            [25.242417440000082, -17.770335387999936],
            [25.253476196000094, -17.78149749799988],
            [25.259780721000112, -17.794106546999984],
            [25.194151652000073, -17.7823243199999],
            [25.153947387000073, -17.781807555999947],
            [25.120874471000064, -17.813536884999877],
            [25.08790490700011, -17.826766051999883],
            [25.05700240100012, -17.827696227999922],
            [25.047493937000127, -17.807129007999933],
            [25.01969201600008, -17.82376881899995],
            [25.007082967000144, -17.8257325229999],
            [24.99850468000011, -17.81395029699989],
            [24.98331180800008, -17.820461526999864],
            [24.975146932000087, -17.81632741299994],
            [24.968635702000114, -17.807645771999972],
            [24.95809370900014, -17.800927835999943],
            [24.964294881000114, -17.786665140999972],
            [24.953339477000043, -17.788422138999948],
            [24.94858524600005, -17.793279723999973],
            [24.945174601000133, -17.799997659999903],
            [24.937629842000092, -17.807129007999933],
            [24.93111861200012, -17.810539652999964],
            [24.8574280200001, -17.833587340999927],
            [24.838101033000044, -17.83503428099992],
            [24.820841105000056, -17.839271748999877],
            [24.797380005000065, -17.858081969999972],
            [24.776916138000104, -17.86231943799993],
            [24.770714966000128, -17.8655233759999],
            [24.76451379300005, -17.879682718999945],
            [24.756038859000057, -17.88278330499989],
            [24.74684045400005, -17.884230244999884],
            [24.738158814000087, -17.887640889999915],
            [24.73071740700007, -17.891878356999953],
            [24.725343058000107, -17.895909118999953],
            [24.698471314000102, -17.928878682999922],
            [24.66405480900005, -17.949859313999923],
            [24.64917199700011, -17.96277842199993],
            [24.598632446000067, -18.020759378999884],
            [24.595015096000083, -18.022826435999946],
            [24.59181115700011, -18.028407490999953],
            [24.577755168000095, -18.04442718499992],
            [24.57455122900012, -18.050421650999937],
            [24.56442264800009, -18.052798766999985],
            [24.518430623000086, -18.057346292999924],
            [24.505614868000094, -18.06034352599994],
            [24.471508422000028, -18.02995778399989],
            [24.469751424000066, -18.014454853999965],
            [24.465100545000098, -18.008667093999904],
            [24.458485962000083, -18.005773213999916],
            [24.451044556000085, -17.998951924999957],
            [24.433887980000122, -17.96722259499994],
            [24.42158898900007, -17.95647389699991],
            [24.399471476000144, -17.952339781999896],
            [24.36526167800008, -17.950789489999877],
            [24.350585571000067, -17.95606048499991],
            [24.334255819000134, -17.97156341499992],
            [24.30583378100002, -18.01941579199992],
            [24.29642867000007, -18.026237080999877],
            [24.28743697100012, -18.024480081999897],
            [24.2700736890001, -18.015798441999934],
            [24.259221639000145, -18.012594501999956],
            [24.238241007000056, -18.009907327999926],
            [24.21829390400012, -18.012594501999956],
            [24.183050578000064, -18.029441018999933],
            [24.135094848000023, -18.085458271999954],
            [24.101608521000117, -18.108816019999907],
            [24.065124959000116, -18.11522389699995],
            [24.056960083000092, -18.119047953999896],
            [24.02812463400008, -18.145816344999957],
            [24.020269816000024, -18.151604105999937],
            [23.991744426000082, -18.16338633199993],
            [23.979652141000088, -18.17186126699994],
            [23.974897909000106, -18.177028910999937],
            [23.97117720600008, -18.183850199],
            [23.966733032000093, -18.18064626099992],
            [23.961978800000082, -18.17785573299996],
            [23.956604451000118, -18.176615498999922],
            [23.950816691000057, -18.177649026999916],
            [23.915986776000096, -18.20121348099991],
            [23.91288619000005, -18.2357333369999],
            [23.89696984900013, -18.250202737999928],
            [23.86751428300002, -18.269426370999938],
            [23.855215291000093, -18.280071715999938],
            [23.83723189200009, -18.305806578999935],
            [23.82555301900004, -18.317072041999978],
            [23.809843384000146, -18.321722920999946],
            [23.715792277000105, -18.419081318999915],
            [23.700909464000063, -18.427969665999925],
            [23.680135539000105, -18.431483662999966],
            [23.656467733000085, -18.458252054999946],
            [23.64985314900008, -18.463419697999953],
            [23.645408976000084, -18.46600351899987],
            [23.609855591000013, -18.477682392999924],
            [23.59218225100011, -18.478199156999963],
            [23.57915979000009, -18.467863870999864],
            [23.571304972000036, -18.426005960999888],
            [23.555491984000042, -18.383114522999932],
            [23.546603637000118, -18.369471943999926],
            [23.560762980000078, -18.348491312999926],
            [23.551461222000057, -18.32751068099992],
            [23.518801717000088, -18.29371429399994],
            [23.52727665200007, -18.27769459999989],
            [23.521695597000075, -18.268186136999915],
            [23.511256958000047, -18.260331318999974],
            [23.5056759040001, -18.249375915999906],
            [23.5015417890001, -18.237490335999965],
            [23.49130985500011, -18.233149515999898],
            [23.477770630000123, -18.230875751999875],
            [23.464128052000035, -18.225501403999914],
            [23.45875370300007, -18.217646585999972],
            [23.444284302000113, -18.200696715999882],
            [23.4294014890001, -18.18850107799996],
            [23.418859497000113, -18.198422952999948],
            [23.41028120900009, -18.197389424999884],
            [23.40128951000014, -18.194288838999924],
            [23.395811808000076, -18.191394958999936],
            [23.394468221000096, -18.18622731499994],
            [23.39632857300009, -18.169380797999864],
            [23.395811808000076, -18.16338633199993],
            [23.389713989000114, -18.15325775099997],
            [23.359534952000104, -18.11915130599992],
            [23.34806278500008, -18.094449970999904],
            [23.33659061700007, -18.07936045399991],
            [23.333800090000096, -18.073986103999943],
            [23.332559855000085, -18.06706146199987],
            [23.333800090000096, -18.04329030399991],
            [23.330596150000133, -18.039983011999908],
            [23.323258097000064, -18.039156188999883],
            [23.315920044000052, -18.03708913199992],
            [23.312716105000078, -18.02995778399989],
            [23.312819458, -18.01652191199993],
            [23.311475870000038, -18.00980397499991],
            [23.30568811100008, -18.00546315499993],
            [23.292769002000057, -17.998951924999957],
            [23.254941854000094, -17.997401631999935],
            [23.185798787000095, -18.003086038999882],
            [23.09960249900007, -18.010217386999912],
            [22.98136682200007, -18.020035908999972],
            [22.89403365000004, -18.036158955999966],
            [22.809697713000105, -18.05186859099993],
            [22.72525842300007, -18.067474873999885],
            [22.640922485000146, -18.083184508999935],
            [22.556483195000112, -18.09879079199989],
            [22.472147257000103, -18.114500426999953],
            [22.387811320000083, -18.13021006299992],
            [22.303475383000148, -18.145816344999957],
            [22.219036092000124, -18.161525980999926],
            [22.13459680100007, -18.177235615999905],
            [22.05026086500007, -18.19284189899993],
            [21.966028280000074, -18.20855153399991],
            [21.88148563700011, -18.22415781699995],
            [21.7971496990001, -18.239867451999913],
            [21.712710409000067, -18.25557708799998],
            [21.628477824000072, -18.271183369999918],
            [21.544038534000038, -18.28678965299987],
            [21.52698531100009, -18.289993590999927],
            [21.509828735000042, -18.2931975299999],
            [21.492878865000108, -18.296401468999974],
            [21.47572229000005, -18.29950205499992],
            [21.456808715000108, -18.300225524999917],
            [21.437895142000087, -18.301052347999942],
            [21.3908695880001, -18.302912698999947],
            [21.34394738800006, -18.30477305099994],
            [21.29681848200005, -18.306633401999946],
            [21.249896281000105, -18.308493753999954],
            [21.193465617000072, -18.31076751699989],
            [21.13693160000011, -18.312937926999965],
            [21.080604288000103, -18.315211689999984],
            [21.02417362500006, -18.317382099999875],
            [20.993436476000085, -18.318611585999918],
            [20.975081014000125, -18.319345804999912],
            [20.975081014000125, -18.347767841999925],
            [20.975081014000125, -18.38859222399992],
            [20.975081014000125, -18.42931325299989],
            [20.975081014000125, -18.470137633999883],
            [20.975081014000125, -18.51106536899991],
            [20.975081014000125, -18.551993102999916],
            [20.975081014000125, -18.592714130999894],
            [20.975081014000125, -18.633538512999877],
            [20.975081014000125, -18.67436289499996],
            [20.975081014000125, -18.715187275999952],
            [20.975081014000125, -18.75601165799995],
            [20.975081014000125, -18.796836038999942],
            [20.975081014000125, -18.83766042099994],
            [20.975081014000125, -18.87838144899999],
            [20.975081014000125, -18.9192058309999],
            [20.975081014000125, -18.960030211999893],
            [20.975081014000125, -19.000957946999904],
            [20.975494425000136, -19.125911559999864],
            [20.97560905200004, -19.172106009999908],
            [20.975804484000037, -19.25086517299991],
            [20.976321248000062, -19.375818786999957],
            [20.97673466000009, -19.50087575299993],
            [20.97704471800006, -19.625829365999977],
            [20.977561483000102, -19.750782978999936],
            [20.977974894000113, -19.875839944999925],
            [20.9782849530001, -20.00079355899996],
            [20.97869836400011, -20.125850524999947],
            [20.979111775000035, -20.250804137999907],
            [20.979360470000103, -20.351028106999905],
            [20.979421834000107, -20.375757750999952],
            [20.97983524600002, -20.5007113649999],
            [20.980248657000033, -20.625768329999886],
            [20.980662068000044, -20.750721943999935],
            [20.981075480000072, -20.87577890999991],
            [20.98148632900012, -20.999958183999922],
            [20.981488891000083, -21.000732522999954],
            [20.981592244000097, -21.058403421999927],
            [20.981902303000084, -21.116074319999896],
            [20.982109009000055, -21.17364186599994],
            [20.98221236200007, -21.23120941199997],
            [20.98241906700011, -21.288880309999954],
            [20.98262577300008, -21.34644785499998],
            [20.982832479000137, -21.404118753999867],
            [20.98303918400009, -21.461789652999926],
            [20.98314253800004, -21.51935719799988],
            [20.98345259600009, -21.577028095999935],
            [20.98365930200015, -21.63469899499991],
            [20.983866007000103, -21.692369892999892],
            [20.984072713000074, -21.75004079199995],
            [20.984279418000114, -21.807608337999895],
            [20.984486125000075, -21.865175882999935],
            [20.98469283100013, -21.922846780999905],
            [20.98479618300007, -21.963981220999884],
            [20.97198042800008, -22.00067148899994],
            [20.914722941000036, -22.00067148899994],
            [20.68062870300011, -22.00067148899994],
            [20.446534465000127, -22.00067148899994],
            [20.212440226000126, -22.00067148899994],
            [19.978345988000115, -22.00067148899994],
            [19.978449340000054, -22.08676442499994],
            [19.978656046000083, -22.23724619599993],
            [19.978862753000044, -22.387624613999975],
            [19.97896610500007, -22.538106383999974],
            [19.979172811000126, -22.688588154999962],
            [19.979276164000055, -22.860670674999923],
            [19.979586222000137, -23.032546487999923],
            [19.97979292800011, -23.20452565499994],
            [19.979855443000133, -23.308551120999894],
            [19.979896281000038, -23.376504821999973],
            [19.980102987000095, -23.54858734099993],
            [19.98030969200005, -23.720566507999948],
            [19.980482728000055, -23.864488701999875],
            [19.980516398000105, -23.89249399799988],
            [19.98072310400005, -24.064473164999896],
            [19.980826456000074, -24.236555683999953],
            [19.981136516000078, -24.408431497999956],
            [19.981343221000117, -24.58041066499989],
            [19.981446574000046, -24.75249318399993],
            [19.981756632000042, -24.76499888099994],
            [19.981756632000042, -24.821016132999958],
            [19.981756632000042, -24.87713673899991],
            [19.981756632000042, -24.933257343999955],
            [19.981859985000057, -24.989274596999877],
            [19.9819633380001, -25.045395201999924],
            [19.9819633380001, -25.101412455999935],
            [19.9819633380001, -25.157429707999952],
            [19.9819633380001, -25.213550313999917],
            [19.9819633380001, -25.269670918999864],
            [19.9819633380001, -25.32568817199997],
            [19.9819633380001, -25.381705423999904],
            [19.982066691000114, -25.43782602999994],
            [19.982066691000114, -25.493843281999958],
            [19.982066691000114, -25.549963887999922],
            [19.982066691000114, -25.60608449299987],
            [19.982066691000114, -25.618988071999922],
            [19.982066691000114, -25.66210174599989],
            [19.982066691000114, -25.71811899799991],
            [19.982066691000114, -25.77413625099993],
            [19.982066691000114, -25.830256855999963],
            [19.982170044000043, -25.8862741089999],
            [19.982273396000068, -25.942394713999946],
            [19.982273396000068, -25.998515319999896],
            [19.982273396000068, -26.054532571999914],
            [19.982273396000068, -26.110549824999936],
            [19.982273396000068, -26.166670429999968],
            [19.9823767500001, -26.222687682999904],
            [19.9823767500001, -26.27880828799995],
            [19.9823767500001, -26.334825541999876],
            [19.9823767500001, -26.390946146999923],
            [19.9823767500001, -26.44696339999993],
            [19.9823767500001, -26.503084004999977],
            [19.98248010300003, -26.559101257999913],
            [19.98258345600007, -26.61511850999993],
            [19.98258345600007, -26.67123911599988],
            [19.98258345600007, -26.7272563679999],
            [19.98258345600007, -26.783376973999935],
            [19.98258345600007, -26.839394225999868],
            [19.982686808000096, -26.895514831999918],
            [19.982686808000096, -26.951532083999936],
            [19.982686808000096, -27.007652689999887],
            [19.982686808000096, -27.063669941999905],
            [19.982686808000096, -27.119687193999923],
            [19.982686808000096, -27.175807799999873],
            [19.98279016100011, -27.231928405999923],
            [19.98289351400004, -27.28794565799994],
            [19.98289351400004, -27.344066262999974],
            [19.98289351400004, -27.40018686899994],
            [19.98289351400004, -27.45610076899993],
            [19.98289351400004, -27.51211802199994],
            [19.98289351400004, -27.5682386269999],
            [19.98289351400004, -27.624359232999936],
            [19.982996867000082, -27.680376484999954],
            [19.982996867000082, -27.73649709099992],
            [19.982996867000082, -27.79261769599995],
            [19.982996867000082, -27.848531595999944],
            [19.982996867000082, -27.904652200999905],
            [19.982996867000082, -27.96077280699994],
            [19.982996867000082, -28.01679005899996],
            [19.982996867000082, -28.072910664999924],
            [19.983100219000107, -28.129031269999956],
            [19.983203572000036, -28.185048522999892],
            [19.983203572000036, -28.24106577499991],
            [19.983203572000036, -28.29718638099986],
            [19.983203572000036, -28.35320363299988],
            [19.983203572000036, -28.39268442799991],
            [19.981653280000103, -28.422346699999963],
            [19.950544067000067, -28.429271340999946],
            [19.940208781000138, -28.4302015169999],
            [19.90785933400005, -28.426480813999973],
            [19.89669722500011, -28.427721048999928],
            [19.870342245000074, -28.44084686299989],
            [19.825590454000093, -28.476710306999934],
            [19.79634159300005, -28.48415171299986],
            [19.748075805000042, -28.487148945999962],
            [19.725338175000076, -28.49417694099988],
            [19.70559777800011, -28.508026224999938],
            [19.68833785000001, -28.515984394999904],
            [19.58798221900014, -28.522702331999923],
            [19.579197225000144, -28.52518279999991],
            [19.568758586000115, -28.53117726599993],
            [19.562350708000082, -28.53810190899992],
            [19.556459594000074, -28.54616343099991],
            [19.547571248000082, -28.555878600999947],
            [19.542196900000107, -28.564043476999956],
            [19.533721965000097, -28.582440286999955],
            [19.52741743900009, -28.58595428399991],
            [19.517805623000072, -28.58936492899994],
            [19.51170780400011, -28.598046568999905],
            [19.482872355000097, -28.67824839299989],
            [19.47243371600007, -28.69271779399992],
            [19.45507043400005, -28.705223489999923],
            [19.43460656700009, -28.71349171899996],
            [19.353474569000127, -28.73188852899996],
            [19.339005168000085, -28.73746958399998],
            [19.328359822000095, -28.735815938999934],
            [19.304485310000103, -28.718659361999883],
            [19.29001590900009, -28.719692890999866],
            [19.277303508000045, -28.729408059999898],
            [19.265934692000144, -28.74263722699989],
            [19.248571411000114, -28.77157602899986],
            [19.244954061000044, -28.79245330799992],
            [19.251568645000134, -28.81426076299995],
            [19.288879028000082, -28.871001484999866],
            [19.288362264000057, -28.88309376999986],
            [19.276580037000144, -28.889501647999893],
            [19.243713826000118, -28.89187876399994],
            [19.237616007000042, -28.89559946699994],
            [19.226660604000074, -28.91151580799996],
            [19.21849572700006, -28.91885386099996],
            [19.16154829900009, -28.945415547999886],
            [19.120207154000042, -28.95750783299988],
            [19.081656535000064, -28.959368183999885],
            [19.064706665000074, -28.93983449299988],
            [19.060055786000106, -28.935700377999936],
            [19.048997030000095, -28.932393086999937],
            [19.013960408000088, -28.928465676999878],
            [19.00693241400006, -28.92629526799989],
            [18.996390422000104, -28.91554656999996],
            [18.971172323000047, -28.880509948999944],
            [18.95453251100014, -28.866660664999884],
            [18.74565637200007, -28.83989227299992],
            [18.55393680800009, -28.86469696099995],
            [18.517659953000134, -28.88226694699992],
            [18.496162557000105, -28.888261412999952],
            [18.491615031000066, -28.88629770899992],
            [18.479419393000057, -28.8762724809999],
            [18.474975219000044, -28.873998717999967],
            [18.46939416500004, -28.874928893999936],
            [18.460712525000076, -28.87988983099997],
            [18.45523482200008, -28.88144012399991],
            [18.43570113100006, -28.884230651999957],
            [18.42474572800009, -28.887227884999973],
            [18.416994262000088, -28.891672057999884],
            [18.39756392400011, -28.898906758999942],
            [18.37306929500005, -28.89518605599993],
            [18.331004679000017, -28.88144012399991],
            [18.30868046100005, -28.879993183999915],
            [18.220727173000057, -28.891258646999873],
            [18.185070434000068, -28.902214050999945],
            [18.1664669190001, -28.901903990999955],
            [18.082441040000077, -28.87596242299992],
            [18.04409712700007, -28.858392434999942],
            [17.983325643000057, -28.813743997999907],
            [17.949529256000062, -28.79472707099994],
            [17.913252401000108, -28.78129119799989],
            [17.74633752400007, -28.748631692999922],
            [17.71409143000011, -28.7511121619999],
            [17.703239379000138, -28.755556334999895],
            [17.683395630000064, -28.76754526799995],
            [17.673783813000057, -28.77157602899986],
            [17.660968058000066, -28.772299499999946],
            [17.628721965000096, -28.764134622999933],
            [17.607121216000053, -28.755659687999923],
            [17.6025736900001, -28.73540252699992],
            [17.60340051300011, -28.71080454499993],
            [17.59802616300007, -28.689617206999884],
            [17.582936646000064, -28.680212097999927],
            [17.565986776000074, -28.683519388999926],
            [17.546969849000078, -28.691374206999868],
            [17.526609334000057, -28.695818379999963],
            [17.48516483600011, -28.700159199999945],
            [17.440929810000085, -28.70956431099991],
            [17.403619425000045, -28.704293314999873],
            [17.40175907300005, -28.674217630999905],
            [17.41426477100012, -28.63266977899991],
            [17.420569295000064, -28.59339569099994],
            [17.409613892000067, -28.571381529999954],
            [17.37302697800004, -28.559392597999903],
            [17.36527551200004, -28.542546080999927],
            [17.359487752000064, -28.519808451999936],
            [17.332409302000087, -28.488595885999956],
            [17.324244425000074, -28.470509134999944],
            [17.328171834000045, -28.456143086999944],
            [17.341194295000093, -28.442810566999924],
            [17.358557577000084, -28.432785338999906],
            [17.37540409400009, -28.42896128299995],
            [17.391320435000097, -28.418832702999907],
            [17.399692017000064, -28.395268248999912],
            [17.40206913300011, -28.367776386999935],
            [17.400002075000145, -28.346382344999924],
            [17.394834432000067, -28.335116881999866],
            [17.378918090000127, -28.316306660999942],
            [17.37199344900006, -28.306074726999967],
            [17.368066040000087, -28.29377573599993],
            [17.367032512000094, -28.283543802999944],
            [17.364138631000117, -28.27331186899997],
            [17.35504357900004, -28.26101287799993],
            [17.35121952300011, -28.251401061999914],
            [17.349772583000117, -28.238688658999962],
            [17.345741821000104, -28.22762990299995],
            [17.334476359000064, -28.222875670999954],
            [17.308638143000053, -28.224115904999906],
            [17.24517948400009, -28.237448424999926],
            [17.213140096000075, -28.23207407599996],
            [17.191952758000127, -28.20881968199994],
            [17.18709517400012, -28.162000833999926],
            [17.18978234900004, -28.139366556999875],
            [17.189989054000108, -28.116835631999948],
            [17.180894002000116, -28.099472350999932],
            [17.155779256000102, -28.092547708999945],
            [17.136348917000106, -28.08469289199992],
            [17.123223103000072, -28.06650278799988],
            [17.111750936000135, -28.046038919999916],
            [17.097798299000146, -28.031156106999973],
            [17.086532837000078, -28.02702199299995],
            [17.076404256000046, -28.02681528699989],
            [17.056663859000082, -28.031156106999973],
            [17.0453983970001, -28.03632375099997],
            [17.012015421000058, -28.058337910999867],
            [16.985350382000092, -28.052240091999906],
            [16.97377486200014, -28.05503061899995],
            [16.95951216700007, -28.06856984399994],
            [16.9475232340001, -28.072703958999867],
            [16.937498006000084, -28.071050312999915],
            [16.927472778000066, -28.060198261999872],
            [16.919617961000142, -28.058337910999867],
            [16.913520142000067, -28.062678730999934],
            [16.896466919000147, -28.079938659999925],
            [16.892952921000102, -28.082625833999955],
            [16.885511515000076, -28.162000833999926],
            [16.878173462000063, -28.172026061999944],
            [16.87383264200008, -28.171509297999904],
            [16.8686649980001, -28.16789194799992],
            [16.852025188000084, -28.16830535899993],
            [16.847787720000014, -28.165411478999943],
            [16.843756958000114, -28.16386118499993],
            [16.837659139000067, -28.168202005999916],
            [16.83569543400003, -28.174196471999934],
            [16.838382609000064, -28.17946746799997],
            [16.855952596000122, -28.199414570999892],
            [16.856366007000133, -28.20664927199995],
            [16.84106978300008, -28.209853210999924],
            [16.819779094000097, -28.209749856999906],
            [16.81430139100013, -28.21347056099991],
            [16.81027063000002, -28.222875670999954],
            [16.813267863000135, -28.229903665999885],
            [16.82081262200009, -28.24003224699993],
            [16.826600382000066, -28.251917825999953],
            [16.824636678000047, -28.26452687599989],
            [16.81523156700007, -28.270831399999892],
            [16.80510298700011, -28.26773081499995],
            [16.79518111100012, -28.261219583999974],
            [16.78649947100007, -28.257602233999904],
            [16.76872277800004, -28.265353698999903],
            [16.764381958000058, -28.283233743999872],
            [16.76841271900014, -28.30369761099992],
            [16.775544067000084, -28.319097187999915],
            [16.796834758000074, -28.347829284999918],
            [16.80386275300009, -28.366122741999888],
            [16.7932174070001, -28.37428761799991],
            [16.778541301000104, -28.382969258999964],
            [16.773373657000093, -28.402916361999885],
            [16.77213342300007, -28.425757344999894],
            [16.769342895000108, -28.442603861999956],
            [16.758387492000026, -28.459657083999986],
            [16.740404093000052, -28.480947773999972],
            [16.720456990000116, -28.496037292999887],
            [16.7038171800001, -28.494487],
            [16.699683065000073, -28.48518524199993],
            [16.696789185000085, -28.47247283899989],
            [16.69234501100007, -28.46110402399998],
            [16.68345666500008, -28.456246439999873],
            [16.673121378000076, -28.45976043699993],
            [16.59736372800009, -28.526216328999894],
            [16.559123169000088, -28.537068379999937],
            [16.531527954000097, -28.549677428999956],
            [16.50537967900007, -28.56538706399992],
            [16.487071160000085, -28.572930596999925],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'South Africa',
        iso3: 'ZAF',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [19.981446574000046, -24.75249318399993],
              [19.986407511000095, -24.768822936999882],
              [19.992918742000086, -24.775850931999884],
              [20.010488729000144, -24.788046569999906],
              [20.029298950000054, -24.815228372999883],
              [20.08107873500012, -24.852642109999948],
              [20.10784712800009, -24.880340677999882],
              [20.1189058840001, -24.887368672999884],
              [20.128414348000092, -24.889745787999928],
              [20.149084920000092, -24.890986022999968],
              [20.159316853000092, -24.8936731969999],
              [20.23569462100005, -24.936047870999914],
              [20.364885702000038, -25.033199564999904],
              [20.375531047000038, -25.046118672999924],
              [20.406846965000057, -25.107820332999978],
              [20.43392541500009, -25.146784362999966],
              [20.444777466000062, -25.168385110999935],
              [20.44322717300011, -25.18306121799992],
              [20.434442179000143, -25.199804381999883],
              [20.443847290000093, -25.213343606999956],
              [20.46245080600005, -25.22367889399996],
              [20.481674439000074, -25.23050018299992],
              [20.48353479000008, -25.256648456999926],
              [20.485498495000115, -25.263159687999888],
              [20.491803019000116, -25.269050801999896],
              [20.509889770000143, -25.27752573699989],
              [20.516401001000105, -25.283623555999952],
              [20.518571411000096, -25.293028666999902],
              [20.514850708000097, -25.29912648499996],
              [20.510406534000083, -25.30470753999988],
              [20.510509888000115, -25.312252298999923],
              [20.514644002000125, -25.319280292999935],
              [20.525082642000058, -25.332199401999944],
              [20.529216756000096, -25.34005421999997],
              [20.535831340000072, -25.37116343099993],
              [20.542239217000116, -25.382222188999933],
              [20.55877567600004, -25.392040710999908],
              [20.588024536000148, -25.40402964299996],
              [20.593605590000095, -25.413228046999876],
              [20.596912882000083, -25.4328650919999],
              [20.61200240100007, -25.431004739999892],
              [20.611382283000097, -25.43937632199996],
              [20.605904582000022, -25.45177866599994],
              [20.606628051000115, -25.462010599999914],
              [20.616549927000108, -25.466144713999938],
              [20.6256449790001, -25.46273406999991],
              [20.634429972000078, -25.457669778999943],
              [20.64352502400004, -25.457359720999946],
              [20.65654748600008, -25.46779835999989],
              [20.626885213000037, -25.484748229999894],
              [20.620373983000064, -25.50056121899989],
              [20.61851363100004, -25.528466491999964],
              [20.66336877400005, -25.564743346999933],
              [20.671430298000132, -25.591201680999916],
              [20.665229126000042, -25.60102020299989],
              [20.643318319000088, -25.6132158409999],
              [20.637943969000048, -25.62034718799994],
              [20.641044556000082, -25.631199238999983],
              [20.65137984200007, -25.634609883999914],
              [20.663058716000137, -25.636263528999876],
              [20.670810181000064, -25.642257994999895],
              [20.671430298000132, -25.653316751999895],
              [20.662748657000066, -25.674917500999968],
              [20.66285201000011, -25.685252786999882],
              [20.67101688700012, -25.695484720999957],
              [20.69654504400006, -25.707060242],
              [20.706880330000075, -25.714811705999907],
              [20.71669885300011, -25.732588398999937],
              [20.737782837000054, -25.79894093799996],
              [20.727137492000054, -25.818164570999983],
              [20.7265173750001, -25.82736297599989],
              [20.740056600000088, -25.823125507999933],
              [20.749978475000063, -25.81847462899988],
              [20.75576623500004, -25.81899139399991],
              [20.766928344000064, -25.83067026699989],
              [20.767135050000036, -25.834390970999905],
              [20.794110148000073, -25.893922220999883],
              [20.80279178900011, -25.980531921999912],
              [20.800518026000105, -26.052465514999952],
              [20.80392867000012, -26.071275735999862],
              [20.841445760000113, -26.131323750999883],
              [20.837931763000057, -26.146826680999894],
              [20.794730265000027, -26.201913756999957],
              [20.776230103000103, -26.24056772799996],
              [20.75328576700008, -26.27622446699995],
              [20.695511515000078, -26.341956887999913],
              [20.665952596000125, -26.391772969999934],
              [20.652103312000065, -26.4077926639999],
              [20.622544392000037, -26.42753305999996],
              [20.618203573000073, -26.43972869899997],
              [20.60528446400005, -26.493265482999917],
              [20.602287232000037, -26.522204284999887],
              [20.60528446400005, -26.547732441999912],
              [20.611485636000054, -26.559928079999935],
              [20.627712036000048, -26.58080535899991],
              [20.6323629150001, -26.59527475999994],
              [20.63070926900008, -26.618322448999905],
              [20.608901815000138, -26.68612192799992],
              [20.60921187300002, -26.71619761199989],
              [20.614689575000114, -26.75319793699994],
              [20.62481815600006, -26.78937143899988],
              [20.63866744000012, -26.81696665399997],
              [20.64486861200001, -26.824511413999915],
              [20.650553019000142, -26.82967905699992],
              [20.665642537000053, -26.83908416799997],
              [20.675461059000042, -26.85003957099987],
              [20.68569299300009, -26.88176889999997],
              [20.690757283000067, -26.891794127999987],
              [20.69354781000004, -26.889003600999942],
              [20.714941854000045, -26.875050964999943],
              [20.779434042000076, -26.84807586699992],
              [20.82604618300013, -26.818827005999964],
              [20.851884400000074, -26.806528014999927],
              [20.90769494600002, -26.800016783999965],
              [20.950172973000065, -26.81603647899992],
              [20.990377238000093, -26.838567402999942],
              [21.12246219900007, -26.865335794999908],
              [21.1534680580001, -26.86450897199998],
              [21.240594523000084, -26.84197804799996],
              [21.25485721800004, -26.841771341999916],
              [21.28286584500006, -26.84497528099989],
              [21.296921834000074, -26.844458515999932],
              [21.380844360000083, -26.823994648999886],
              [21.426629679000115, -26.82265106199992],
              [21.449470662000124, -26.82637176499992],
              [21.4986666260001, -26.84642222099997],
              [21.583932739000147, -26.848385924999903],
              [21.643360636000097, -26.862751972999916],
              [21.664547974000072, -26.863062031999903],
              [21.68718225100011, -26.85520721399986],
              [21.743819620000096, -26.82048065199993],
              [21.762319784000027, -26.804460957999964],
              [21.773378540000124, -26.786787617999963],
              [21.77751265400005, -26.768494160999907],
              [21.776479126000083, -26.74916717499994],
              [21.76748742700005, -26.704312031999862],
              [21.76872766100007, -26.688705748999922],
              [21.78061324100011, -26.67816375699995],
              [21.807278280000048, -26.669585468999927],
              [21.838800903000106, -26.664521178999863],
              [21.935849243000092, -26.66390106199988],
              [21.99899784300004, -26.650258483999963],
              [22.057702271000096, -26.617598978999908],
              [22.108138469000096, -26.571917011999886],
              [22.14617232200004, -26.519207050999867],
              [22.17831506400006, -26.43993540499993],
              [22.19743534400007, -26.404071959999982],
              [22.237742961000095, -26.366761575999945],
              [22.24828495300008, -26.346917826999956],
              [22.257276652000115, -26.340923360999923],
              [22.303165324000076, -26.333585305999932],
              [22.31877160600004, -26.32883107499994],
              [22.342852824000147, -26.317358906999928],
              [22.395046020000052, -26.271883645999964],
              [22.428842407000047, -26.226511738999932],
              [22.45085656800012, -26.21007863399997],
              [22.482585897000035, -26.204807637999934],
              [22.527957805000142, -26.21369598399987],
              [22.545114380000115, -26.207391458999936],
              [22.563821248000096, -26.18113983099991],
              [22.58025435400006, -26.146516621999908],
              [22.59151981600013, -26.133184101999888],
              [22.61115686100007, -26.120575052999953],
              [22.62086310300006, -26.11153248499997],
              [22.62324914600015, -26.10930958999998],
              [22.665003702000092, -26.05143198599997],
              [22.665830526000036, -26.039856465999918],
              [22.662109823, -26.0298312379999],
              [22.66159305800008, -26.020942890999976],
              [22.67223840300005, -26.012881367999896],
              [22.700660441000082, -26.003269551999978],
              [22.710478963000043, -25.996861673999945],
              [22.719367309000063, -25.98425262499991],
              [22.724224894000088, -25.967509459999874],
              [22.72722212700009, -25.94394500699987],
              [22.72680871600008, -25.921620788999903],
              [22.721641072000097, -25.909011738999965],
              [22.708825318000095, -25.89102833999989],
              [22.719470662000106, -25.874285176999933],
              [22.73952111800014, -25.858472187999936],
              [22.754713989000066, -25.84338266999994],
              [22.76546268700008, -25.826536152999964],
              [22.76411910000013, -25.82033498099989],
              [22.75791792800004, -25.805968932999875],
              [22.750889934000043, -25.79604705799997],
              [22.74499882000012, -25.794083353999937],
              [22.74117476400008, -25.790879413999875],
              [22.74045129400008, -25.77703013099992],
              [22.746445760000114, -25.755326028999917],
              [22.75977828000015, -25.734862161999956],
              [22.80442671700007, -25.687216490999916],
              [22.810214478000148, -25.67739796899994],
              [22.812798299000065, -25.667062682999926],
              [22.81496871000013, -25.65279998799987],
              [22.81341841600002, -25.641947936999912],
              [22.80959436000009, -25.63326629699995],
              [22.810834594000113, -25.625308125999894],
              [22.8243738190001, -25.6157996619999],
              [22.83336551900004, -25.60608449299987],
              [22.828714640000072, -25.595542499999908],
              [22.819206177000098, -25.58489715599991],
              [22.81341841600002, -25.575078632999933],
              [22.814038534000076, -25.566603697999938],
              [22.816829061000135, -25.558438822999918],
              [22.824683879000077, -25.543039245999935],
              [22.84463098100011, -25.48113087999991],
              [22.851348918000042, -25.471312356999945],
              [22.876773722000053, -25.462010599999914],
              [22.88762577300008, -25.450228372999916],
              [22.903645467000047, -25.411367695999957],
              [22.911913696000084, -25.39906870499992],
              [22.92049198400011, -25.390490416999896],
              [22.93093062300005, -25.384289244999906],
              [22.94477990700011, -25.378708190999888],
              [22.95614872200011, -25.372093606999982],
              [22.960282837000108, -25.364342142999888],
              [22.96255660000014, -25.355763854999864],
              [22.968034302000035, -25.34687550799994],
              [23.00699833200011, -25.31080535899993],
              [23.030666138000043, -25.299436543999946],
              [23.054540649000046, -25.302537128999887],
              [23.061155233000136, -25.310702005999914],
              [23.065496053000118, -25.32083058699996],
              [23.071697225000094, -25.325998229999954],
              [23.083892863000102, -25.319693705999953],
              [23.093401327000095, -25.312459004999894],
              [23.16853885900011, -25.280006204999964],
              [23.216081176000046, -25.267190449999887],
              [23.26569055100009, -25.263986510999914],
              [23.320364217000076, -25.273391621999878],
              [23.36594283100004, -25.2893079629999],
              [23.381445760000048, -25.292615253999898],
              [23.39922245300008, -25.291375019999947],
              [23.4319853100001, -25.280316263999865],
              [23.444904419000096, -25.278145852999955],
              [23.459270467000096, -25.28217661599996],
              [23.468158813000116, -25.29023813899994],
              [23.483455037000084, -25.311528828999926],
              [23.496580851000147, -25.32424123099989],
              [23.50660607900008, -25.330959166999918],
              [23.53585494, -25.343258157999955],
              [23.561073038000075, -25.357314147999972],
              [23.666699666000056, -25.432658385999943],
              [23.674244425000012, -25.442580261999936],
              [23.686750122, -25.45436248699994],
              [23.7426640220001, -25.46996876999988],
              [23.75206913300005, -25.477616882999953],
              [23.762301066000134, -25.498494160999925],
              [23.76901900200008, -25.507382506999946],
              [23.7783207600001, -25.512550150999942],
              [23.79857792100009, -25.51854461699989],
              [23.8074662680001, -25.523608906999954],
              [23.845396769000104, -25.569084166999914],
              [23.89066532400011, -25.598849792],
              [23.905754842000107, -25.61848683599993],
              [23.924771769000074, -25.629235533999946],
              [23.976448202000114, -25.61755666099988],
              [23.988023723000083, -25.619520364999914],
              [23.99825565600014, -25.625308125999894],
              [24.008694296000073, -25.63316294399992],
              [24.009624471000052, -25.64132781899994],
              [24.004250122000087, -25.649906107999882],
              [24.00569706200008, -25.654660338999875],
              [24.027091105000096, -25.651766458999887],
              [24.130960734000098, -25.626238301999933],
              [24.183463990000064, -25.625928242999947],
              [24.2276990150001, -25.648975931999914],
              [24.29673872900014, -25.723493347999877],
              [24.338906698000102, -25.75181203199996],
              [24.38923954200007, -25.75946014399993],
              [24.416731405000064, -25.753052265999898],
              [24.4367818610001, -25.74530080199989],
              [24.456728963000018, -25.743027038999884],
              [24.50085111700011, -25.757848433999897],
              [24.576721639000112, -25.783334655999923],
              [24.62963830600009, -25.81609751299993],
              [24.664984985000103, -25.823332214],
              [24.737952107000126, -25.815890807999963],
              [24.770714966000128, -25.822608743999893],
              [24.798620239000115, -25.829223326999895],
              [24.82890262900014, -25.826019388999924],
              [24.888537231000043, -25.811653340999925],
              [24.90838098200004, -25.80410858099988],
              [24.9679122310001, -25.762870787999958],
              [25.013284139000035, -25.743027038999884],
              [25.051731405000083, -25.73785939499996],
              [25.09028202300007, -25.743647154999934],
              [25.13596399000008, -25.756566263999943],
              [25.177821899000037, -25.763284199999887],
              [25.386491333000038, -25.74354380299991],
              [25.458424927000095, -25.711194355999922],
              [25.58725427200008, -25.619520364999914],
              [25.608855021000068, -25.55926564499994],
              [25.652837702000085, -25.463318549999954],
              [25.66352868700011, -25.43999643899994],
              [25.695464722000082, -25.309978535999917],
              [25.782901245000062, -25.131384784999895],
              [25.804915405000116, -25.064825540999905],
              [25.835197795000056, -25.016353047999928],
              [25.83705814600006, -24.979146015999916],
              [25.86620365400009, -24.918167826999948],
              [25.87674564600013, -24.886025084999915],
              [25.87726241100009, -24.84571746899988],
              [25.866927124000085, -24.77264699299991],
              [25.86837406400008, -24.748152363999864],
              [25.874058472000115, -24.74339813299987],
              [25.881706583000096, -24.74215789799993],
              [25.91467614800007, -24.731822610999927],
              [25.966042521000105, -24.733579610999897],
              [25.9811320390001, -24.726344909999938],
              [26.013584839000117, -24.704537455999912],
              [26.165910617000094, -24.660846194999948],
              [26.27878829000008, -24.628469745999936],
              [26.32571049000012, -24.62237192799998],
              [26.344520711000143, -24.62402557399993],
              [26.36353763800011, -24.628056334999926],
              [26.381624390000127, -24.62950327499992],
              [26.404001092000073, -24.63275806799993],
              [26.404362020000093, -24.63281056699992],
              [26.469474325000107, -24.57141896599994],
              [26.47681237800009, -24.559946797999928],
              [26.506061238000143, -24.48884002699991],
              [26.53117598500006, -24.458660990999903],
              [26.558357788000137, -24.438197122999938],
              [26.623470093000037, -24.399439798999907],
              [26.684086547000106, -24.341458841999952],
              [26.692923218000118, -24.32657602899991],
              [26.714007202000033, -24.315930683999923],
              [26.802270549000127, -24.289679055999983],
              [26.823251180000113, -24.278827005999943],
              [26.83916752200014, -24.265597838999938],
              [26.849709513000107, -24.248131204999908],
              [26.86893314600013, -24.16038462299987],
              [26.870896851000055, -24.115839537999946],
              [26.941176798000072, -23.85022267699989],
              [26.945000854000085, -23.823247578999954],
              [26.938127889000043, -23.802887064999922],
              [26.966601603000072, -23.755189717999954],
              [26.964542365000028, -23.74713996999988],
              [26.96205407700012, -23.737413024999938],
              [26.967170044000113, -23.718706155999953],
              [26.986548706000093, -23.686976826999924],
              [27.004170370000082, -23.645842386999945],
              [27.013833862000098, -23.63850433399996],
              [27.024272502000144, -23.642535094999957],
              [27.029853557000138, -23.654730732999965],
              [27.037605021000076, -23.665686135999948],
              [27.05476159600002, -23.666409606999935],
              [27.07005782100009, -23.65607431999993],
              [27.06943770300012, -23.641708272999935],
              [27.0631331780001, -23.624241637999972],
              [27.061531209000066, -23.604397887999895],
              [27.068404175000126, -23.607291767999882],
              [27.075225464000084, -23.61121917699994],
              [27.078326050000044, -23.60202077299995],
              [27.084113811000094, -23.596026305999914],
              [27.10251062000009, -23.583830667999905],
              [27.09579268400006, -23.583830667999905],
              [27.103750855000044, -23.571738382999925],
              [27.11336267100006, -23.564296975999895],
              [27.124421427000044, -23.563160094999986],
              [27.136720418000095, -23.570188089999903],
              [27.14116459100009, -23.558302509999876],
              [27.135686889000112, -23.551894632999932],
              [27.127418661000064, -23.54528004999993],
              [27.123077840000093, -23.53298105799989],
              [27.127418661000064, -23.525022887999924],
              [27.137650594000036, -23.523369241999973],
              [27.149122762000076, -23.5275033569999],
              [27.15718428500014, -23.536701761999907],
              [27.161525106000028, -23.52988047299995],
              [27.168966512000054, -23.521612243999897],
              [27.171446981000116, -23.51561777699996],
              [27.178681681000086, -23.52357594799993],
              [27.18663985200007, -23.527296650999943],
              [27.195631551000105, -23.52708994599989],
              [27.205656779000037, -23.52305918399989],
              [27.191497437000066, -23.503835550999966],
              [27.202504516000147, -23.49205332399997],
              [27.239711548000088, -23.481407979999886],
              [27.27810713700009, -23.46363128699994],
              [27.295573771000136, -23.451745706999915],
              [27.312006877000016, -23.43706959999993],
              [27.335571330000107, -23.402446390999927],
              [27.349989055000037, -23.39149098699994],
              [27.36120284000009, -23.422496846999962],
              [27.371331421000036, -23.41701914399998],
              [27.380839885000114, -23.405340270999915],
              [27.383733765000102, -23.39955251099994],
              [27.395826050000096, -23.39407480899986],
              [27.410502156000092, -23.38932057699995],
              [27.418460327000048, -23.391284280999898],
              [27.411122274000064, -23.405753681999926],
              [27.425178263000078, -23.412678324999902],
              [27.434996786000028, -23.40658050599994],
              [27.443161661000147, -23.395108336999925],
              [27.452670125000054, -23.385289814999865],
              [27.465692586000074, -23.380432230999943],
              [27.507240438000053, -23.37908864399988],
              [27.528841186000136, -23.373094176999942],
              [27.548891642000086, -23.36079518699991],
              [27.563671102000086, -23.34281178799992],
              [27.569355509000047, -23.320384215999923],
              [27.567753540000098, -23.31376963299992],
              [27.564911336000137, -23.305811461999966],
              [27.5633093670001, -23.29919687899988],
              [27.565893189000093, -23.29650970399993],
              [27.56961389200012, -23.294856058999898],
              [27.573076212000046, -23.290515237999912],
              [27.575246623000055, -23.284830830999866],
              [27.576073446000066, -23.279146422999915],
              [27.580414266000048, -23.26385019899996],
              [27.599224487000072, -23.244626565999937],
              [27.60800948100004, -23.21672129299995],
              [27.619171590000064, -23.217031350999946],
              [27.633434285000135, -23.223439229999983],
              [27.647128540000068, -23.227573343999907],
              [27.658755737000035, -23.223439229999983],
              [27.698443237000106, -23.193466898999944],
              [27.725728394000043, -23.221682229999914],
              [27.739164266000074, -23.227573343999907],
              [27.753633667000116, -23.220752053999945],
              [27.75942142800008, -23.211450296999928],
              [27.77420088700009, -23.17300303099998],
              [27.775751180000015, -23.17248626699994],
              [27.783295939000084, -23.16690521299992],
              [27.784587850000037, -23.165561624999953],
              [27.789290405000088, -23.163804625999973],
              [27.787378377000067, -23.15977386499989],
              [27.783037557000085, -23.155433043999906],
              [27.781022176000135, -23.15253916399992],
              [27.779058472000116, -23.147681579999897],
              [27.774614298000103, -23.14075693699992],
              [27.771720418000115, -23.133005472999912],
              [27.77420088700009, -23.125150654999885],
              [27.784949585000106, -23.127011006999894],
              [27.80644698100005, -23.128354593999944],
              [27.822259969000072, -23.12298024499998],
              [27.81574873800008, -23.104686787999924],
              [27.85378259300012, -23.09559173599986],
              [27.89553715000008, -23.079468688999967],
              [27.93005700700013, -23.057041117999873],
              [27.946076700000106, -23.029032490999953],
              [27.93791182500007, -22.986657815999948],
              [27.93749841300007, -22.96381683299994],
              [27.949177287000055, -22.95389495799995],
              [27.96840092000008, -22.951001077999962],
              [27.989381551000065, -22.943766377999893],
              [28.008295125000103, -22.934774677999954],
              [28.02183435000009, -22.926609802999934],
              [28.03744063300013, -22.911416930999906],
              [28.04973962400007, -22.891366474999955],
              [28.053977091000036, -22.86914560999992],
              [28.045398804000087, -22.847751565999914],
              [28.047155802000077, -22.83689951599986],
              [28.06575931800012, -22.82883799199996],
              [28.08880700700007, -22.82263681999997],
              [28.103689819000124, -22.81674570699998],
              [28.10772058100011, -22.81064788799992],
              [28.113198283000116, -22.795351663999966],
              [28.117435751000073, -22.789460550999962],
              [28.12560062600008, -22.785533141999906],
              [28.135625855000086, -22.783362731999915],
              [28.145857788000086, -22.77974538199993],
              [28.154952840000135, -22.77199391599993],
              [28.16249759900009, -22.758971455999884],
              [28.162704305000148, -22.751013284999928],
              [28.15970707200006, -22.743261819999915],
              [28.15774336700011, -22.731066181999907],
              [28.15970707200006, -22.71814707499989],
              [28.1646680100001, -22.708638610999913],
              [28.19619063300007, -22.671638284999958],
              [28.205492391000092, -22.665953876999907],
              [28.216344442000036, -22.663163349999948],
              [28.240684041000037, -22.66088958699993],
              [28.250554240000042, -22.655618590999907],
              [28.286831095000082, -22.615827738999897],
              [28.301817261000053, -22.603838805999928],
              [28.338559204000035, -22.584615172999918],
              [28.376851441000042, -22.575003356999986],
              [28.459378703000056, -22.569629006999932],
              [28.5224756260001, -22.58482187899996],
              [28.538495321000056, -22.580274352999936],
              [28.559837687000055, -22.563014424999935],
              [28.57756270300007, -22.560017191999933],
              [28.597199747000104, -22.56270436599995],
              [28.62386478700006, -22.562807718999892],
              [28.65900476100009, -22.551955667999934],
              [28.731351766000074, -22.513921814],
              [28.77475996900006, -22.501416116999906],
              [28.79677412900014, -22.498212177999932],
              [28.81682458500009, -22.49294118199991],
              [28.83119063400008, -22.48229583699991],
              [28.836771688000113, -22.463175556999914],
              [28.846590210000073, -22.449946390999926],
              [28.869379517000056, -22.448912861999943],
              [28.9125293380001, -22.453667093999925],
              [28.93040938300004, -22.44085133899995],
              [28.953457072000106, -22.40075042699995],
              [28.96337894700011, -22.392172138999925],
              [28.967926473000148, -22.380389912999917],
              [28.960226685000066, -22.31021331699995],
              [28.98373946100014, -22.281997985999894],
              [29.00275638800011, -22.263394470999927],
              [29.018052612000076, -22.255022887999957],
              [29.017845906000105, -22.250372008999904],
              [29.038723186000084, -22.22391367599991],
              [29.047818237000058, -22.220296325999925],
              [29.168844442000136, -22.213991800999906],
              [29.186621134000063, -22.207687275999902],
              [29.20279585800006, -22.19445810899991],
              [29.22207116700008, -22.18215911799996],
              [29.248219441000117, -22.179265238999875],
              [29.302893107000045, -22.190220641999943],
              [29.33152185000006, -22.19280446399995],
              [29.350073689000055, -22.186706644999987],
              [29.356946656000048, -22.19094411199994],
              [29.363251180000077, -22.19228769999991],
              [29.378030640000077, -22.192907815999973],
              [29.399528036000106, -22.18215911799996],
              [29.436114949000057, -22.163142190999892],
              [29.456888875000118, -22.15880137099991],
              [29.506911662000107, -22.17006683299988],
              [29.531819703000053, -22.172443948999927],
              [29.542516724000052, -22.162522073999924],
              [29.551043335000088, -22.145985615999933],
              [29.57016361500007, -22.141954853999934],
              [29.603960001000075, -22.14505543999988],
              [29.64106368000006, -22.129242451999886],
              [29.661424194000062, -22.126451924999927],
              [29.679614298000104, -22.13833750399995],
              [29.691448201000128, -22.134100035999907],
              [29.758885946000134, -22.130896097999937],
              [29.77924646000008, -22.136373798999927],
              [29.83733077000005, -22.172443948999927],
              [29.87148889200006, -22.179265238999875],
              [29.896035197000117, -22.191357523999955],
              [29.932105347000117, -22.194354755999967],
              [29.94667810100009, -22.19828216599994],
              [29.973963257000094, -22.213991800999906],
              [29.98378177900014, -22.21771250399992],
              [30.005279175000112, -22.22226002999996],
              [30.0155111090001, -22.22701426099995],
              [30.03452803500005, -22.246134541999936],
              [30.035871623000105, -22.25057871499986],
              [30.03814538500012, -22.25378265399992],
              [30.067911011000035, -22.25708994499992],
              [30.082587117000116, -22.262877705999898],
              [30.111112508000076, -22.28230804399996],
              [30.135090373000082, -22.293573506999934],
              [30.152660359000038, -22.29481374099997],
              [30.196998738000104, -22.289129333999924],
              [30.22170007300008, -22.290886332],
              [30.240406942000106, -22.296157327999936],
              [30.255289755000035, -22.30473561599996],
              [30.269345744000134, -22.31641448899994],
              [30.300765014000092, -22.336981709999932],
              [30.334974813000088, -22.34473317499993],
              [30.37207849100008, -22.343492939999905],
              [30.412696167000092, -22.3368783559999],
              [30.431713094000145, -22.331193949999957],
              [30.46923018400014, -22.315070901999974],
              [30.488453817000106, -22.31021331699995],
              [30.507367391000116, -22.309593200999885],
              [30.572169637000115, -22.3166211959999],
              [30.601108439000086, -22.31641448899994],
              [30.610306844000092, -22.31868825199996],
              [30.625551391000045, -22.32861012799995],
              [30.632424357000104, -22.330677184999914],
              [30.647410523000076, -22.326439717999875],
              [30.67428226700008, -22.3085596719999],
              [30.693919311000116, -22.302771910999937],
              [30.805282023000075, -22.294503681999885],
              [30.837889852000046, -22.28230804399996],
              [30.867087036000044, -22.28964609699996],
              [30.927186727000105, -22.29574391599992],
              [31.036120646000086, -22.319618427999913],
              [31.070330444000092, -22.33367441799993],
              [31.087642049000067, -22.3368783559999],
              [31.097047967000037, -22.334922385999974],
              [31.104540243000088, -22.333364359999948],
              [31.13771651200011, -22.318481546999905],
              [31.15259932500004, -22.31641448899994],
              [31.16334802300014, -22.32261566199992],
              [31.1836568600001, -22.345559997999956],
              [31.190684855000086, -22.350624287999935],
              [31.197867879000057, -22.352587991999968],
              [31.213474162000068, -22.361889749999904],
              [31.22153568500005, -22.364886982999906],
              [31.229597209000076, -22.363956806999866],
              [31.24572025600014, -22.357548929999922],
              [31.255642130000126, -22.357962340999933],
              [31.265615682000146, -22.365507099999974],
              [31.288921753000068, -22.39733978299992],
              [31.27910323100008, -22.41532318199991],
              [31.323338257000046, -22.542860615999956],
              [31.37491133600014, -22.69158538799988],
              [31.42638106300012, -22.840103454999934],
              [31.467618856000115, -22.95895924799993],
              [31.536348511000085, -23.156983337999932],
              [31.542446330000075, -23.187265726999954],
              [31.521465699000146, -23.415572203999986],
              [31.527615193000145, -23.456809996999894],
              [31.546270386000117, -23.492363382999955],
              [31.642285197000092, -23.587861429999904],
              [31.662025594000056, -23.62403493199993],
              [31.700627889000145, -23.749091898999907],
              [31.741193888000055, -23.836786803999928],
              [31.755198202000145, -23.85776743499993],
              [31.77406009900011, -23.874097187999965],
              [31.838655640000127, -23.91781544999995],
              [31.85043786600005, -23.930631204999926],
              [31.85581221500007, -23.946547545999948],
              [31.856491137000035, -23.962958052999923],
              [31.863046916000087, -24.121420592999883],
              [31.869454793000102, -24.163795267999973],
              [31.926310767000075, -24.276739754999895],
              [31.961335490000067, -24.346316425999888],
              [31.98655358900004, -24.42310760499994],
              [31.99192793800006, -24.500415546999946],
              [31.983763062000094, -24.569145201999916],
              [31.984589885000105, -24.708464863999964],
              [31.9856234130001, -24.87693003299995],
              [31.98629520700007, -24.99630259099989],
              [31.987225382000076, -25.1553626499999],
              [31.988723999000115, -25.372610371999926],
              [31.971670776000053, -25.421496276999918],
              [31.967640015000086, -25.44681772899989],
              [31.966399781000064, -25.479683938999926],
              [31.970120484000063, -25.510896503999987],
              [31.980559122000102, -25.53156707699992],
              [31.986398560000055, -25.552444356999985],
              [31.995648641000116, -25.615179544999933],
              [31.995751994000045, -25.636883646999934],
              [31.991617880000092, -25.65021616599995],
              [31.984796590000144, -25.656313984999912],
              [31.975081421000084, -25.661688333999876],
              [31.96226566600012, -25.672850443999906],
              [31.954410848000066, -25.6849427289999],
              [31.91193282000006, -25.785298359999956],
              [31.90583500100007, -25.81299692799989],
              [31.909969116000127, -25.84296925899993],
              [31.949243204000084, -25.958104349999914],
              [31.891882365000072, -25.98383921299991],
              [31.863356974000055, -25.989937031999958],
              [31.834573202000115, -25.98208221399993],
              [31.746966320000126, -25.930789517999926],
              [31.7306002200001, -25.92120737799989],
              [31.63877120000012, -25.86746388799989],
              [31.53283451300007, -25.805555521999864],
              [31.42689782700006, -25.743647154999934],
              [31.40147302200006, -25.735999043999954],
              [31.372017456000037, -25.736412454999964],
              [31.337394246000144, -25.744680683999917],
              [31.309282268000118, -25.757393086999883],
              [31.20840987100007, -25.838628437999944],
              [31.11983646700014, -25.910045266999944],
              [31.106865682000034, -25.930922546999923],
              [31.091621134000093, -25.98363250699994],
              [31.03777429200005, -26.100111185999893],
              [30.969871460000093, -26.209148457999916],
              [30.89731774900008, -26.29172739699996],
              [30.80455855300005, -26.397457376999895],
              [30.782906128000093, -26.47238820399994],
              [30.784146362000115, -26.578841654999877],
              [30.785696655000038, -26.71692108099998],
              [30.795670207000057, -26.785547382999937],
              [30.802439819000085, -26.80890513099989],
              [30.819803101000105, -26.80797495499992],
              [30.836442912000052, -26.805081074999933],
              [30.853392782000128, -26.796606139999938],
              [30.868740682000123, -26.784927266999958],
              [30.880212850000134, -26.772214863999906],
              [30.885294444000124, -26.785640599999923],
              [30.902588745000116, -26.83133270199997],
              [30.91581791100009, -26.849419453999886],
              [30.944446655000093, -26.87660125699996],
              [30.955092, -26.891380716999976],
              [30.960983114000044, -26.91122446699997],
              [30.959742879000146, -26.93613250699994],
              [30.949407593000046, -26.975406595999914],
              [30.9536450600001, -27.000314635999885],
              [30.97607263200007, -27.035041197999917],
              [31.078753703000075, -27.11824025399993],
              [31.12650272700006, -27.18262908999992],
              [31.14195398000004, -27.19647837299989],
              [31.15704349700013, -27.205573425999958],
              [31.24470661200013, -27.23258632399991],
              [31.280136759000072, -27.243503925999875],
              [31.356669555000053, -27.267068379999955],
              [31.459453979000102, -27.298694355999956],
              [31.52652998900004, -27.31088999399988],
              [31.636910848000127, -27.31223358099993],
              [31.78253503400009, -27.313990580999914],
              [31.87860152200011, -27.31523081499995],
              [31.96826013200007, -27.31626434299993],
              [31.96774336800013, -27.303035175999938],
              [31.964849487000038, -27.29166636099994],
              [31.959785197000144, -27.281021015999954],
              [31.952963907000083, -27.27016896499991],
              [31.94738285300008, -27.255492858999915],
              [31.944850708000104, -27.181388854999895],
              [31.9442043090001, -27.162338388999984],
              [31.942111857000043, -27.100670267999945],
              [31.959681844000045, -27.008789570999895],
              [31.975288127000056, -26.92662404299996],
              [31.992237996000085, -26.838257344999946],
              [31.990067586000066, -26.808285013999907],
              [32.05714359600012, -26.808595071999903],
              [32.073163289000036, -26.81138559999995],
              [32.09776127200013, -26.833503112999963],
              [32.11388431800009, -26.840014342999936],
              [32.14318485500007, -26.845698750999887],
              [32.19408614100013, -26.840324401999922],
              [32.2230249430001, -26.841357930999905],
              [32.29583703600008, -26.852003274999987],
              [32.352216024000086, -26.86027150399994],
              [32.46890140800008, -26.85737762499994],
              [32.59809248800008, -26.853966979999925],
              [32.73844567900011, -26.85024627699991],
              [32.89307701900009, -26.84612395599993],
              [32.88054446700005, -26.886895440999922],
              [32.865244988000086, -27.017347914999903],
              [32.84693444100009, -27.08098723799992],
              [32.84457441500007, -27.102715752999927],
              [32.83936608200008, -27.12363046699994],
              [32.803721550000034, -27.168226820999905],
              [32.80103600400008, -27.176853122999944],
              [32.796885613000086, -27.205743096999925],
              [32.79468834700009, -27.214288018999923],
              [32.78541100400008, -27.229668877999927],
              [32.78101647200009, -27.25595468499995],
              [32.676524285000085, -27.520684502999927],
              [32.60718834700009, -27.81373463299991],
              [32.60572350400008, -27.836114190999922],
              [32.60377037900008, -27.846368096999925],
              [32.594411655000044, -27.87004973799992],
              [32.59148196700005, -27.880791924999926],
              [32.59131920700008, -27.89299895599993],
              [32.59693444100009, -27.91179778399993],
              [32.598317905000044, -27.92245859199994],
              [32.55054772200009, -28.17156340899993],
              [32.543955925000034, -28.190118096999925],
              [32.459971550000034, -28.30673593499995],
              [32.45427493600005, -28.32268645599993],
              [32.45036868600005, -28.345635674999926],
              [32.43921959700009, -28.366631768999923],
              [32.42204837300005, -28.381931247999944],
              [32.39966881600009, -28.387872002999927],
              [32.403330925000034, -28.397556247999944],
              [32.406993035000085, -28.400323174999926],
              [32.412119988000086, -28.398695570999905],
              [32.42017662900008, -28.394707940999922],
              [32.42823326900009, -28.42937590899993],
              [32.41724694100009, -28.46648528399993],
              [32.400726759000065, -28.502699476999908],
              [32.39210045700008, -28.535332940999922],
              [32.37940514400009, -28.55282968499995],
              [32.29314212300005, -28.63095468499995],
              [32.280039910000085, -28.640069268999923],
              [32.24789472700007, -28.653903903999947],
              [32.235118035000085, -28.661553643999923],
              [32.22543379000007, -28.672621351999908],
              [32.20679772200009, -28.701348565999922],
              [32.19361412900008, -28.716241143999923],
              [32.08375084700009, -28.799493096999925],
              [32.05632571700005, -28.779473565999922],
              [32.01685631600009, -28.784926039999903],
              [31.993988477000073, -28.806247653999947],
              [32.01612389400009, -28.833591403999947],
              [32.024099155000044, -28.824965101999908],
              [32.03736412900008, -28.814711195999905],
              [32.053396030000044, -28.80706145599993],
              [32.07007897200009, -28.80559661299992],
              [32.05103600400008, -28.837823174999926],
              [32.012054884000065, -28.86646900799991],
              [31.88835696700005, -28.92473723799992],
              [31.85206139400009, -28.93132903399993],
              [31.813731316000087, -28.93010833099993],
              [31.769053582000083, -28.92229583099993],
              [31.770355665000068, -28.930840752999927],
              [31.772308790000068, -28.936618747999944],
              [31.776052280000044, -28.940524997999944],
              [31.782725457000083, -28.94345468499995],
              [31.782725457000083, -28.94963958099993],
              [31.752126498000052, -28.966241143999923],
              [31.557465040000068, -29.161879164999903],
              [31.51026451900009, -29.198988539999903],
              [31.494476759000065, -29.20566171699994],
              [31.488454623000052, -29.209649346999925],
              [31.48609459700009, -29.21575286299992],
              [31.48218834700009, -29.23333098799992],
              [31.47820071700005, -29.236993096999925],
              [31.46534264400009, -29.244886976999908],
              [31.427012566000087, -29.292168877999927],
              [31.41260826900009, -29.30315520599993],
              [31.37859134200005, -29.321872653999947],
              [31.36500084700009, -29.33261484199994],
              [31.360036655000044, -29.342461846999925],
              [31.354665561000047, -29.36337655999995],
              [31.342133009000065, -29.37004973799992],
              [31.333994988000086, -29.376397393999923],
              [31.326508009000065, -29.384209893999923],
              [31.318614129000082, -29.40203215899993],
              [31.18685957100007, -29.560316664999903],
              [31.055511915000068, -29.789808851999908],
              [31.045258009000065, -29.829522393999923],
              [31.055837436000047, -29.868259372999944],
              [31.015798373000052, -29.86809661299992],
              [31.006114129000082, -29.876153252999927],
              [31.001231316000087, -29.90243905999995],
              [31.016368035000085, -29.895196221999925],
              [31.05046634200005, -29.88518645599993],
              [31.063324415000068, -29.874444268999923],
              [31.063324415000068, -29.881931247999944],
              [31.061534050000034, -29.888929945999905],
              [31.05827884200005, -29.895928643999923],
              [31.049571160000085, -29.90862395599993],
              [31.023773634000065, -29.935804945999905],
              [30.919932488000086, -30.01848723799992],
              [30.890635613000086, -30.05006275799991],
              [30.842539910000085, -30.123304945999905],
              [30.78646894600007, -30.237481377999927],
              [30.641612175000034, -30.45956796699994],
              [30.621429884000065, -30.50009530999995],
              [30.61768639400009, -30.51531340899993],
              [30.609548373000052, -30.529554945999905],
              [30.562347852000073, -30.57390715899993],
              [30.39234459700009, -30.847100518999923],
              [30.364024285000085, -30.882256768999923],
              [30.34815514400009, -30.89657968499995],
              [30.33375084700009, -30.902276299999926],
              [30.320323113000086, -30.912286065999922],
              [30.28874759200005, -30.97112395599993],
              [30.195974155000044, -31.077894789999903],
              [30.123383009000065, -31.161553643999923],
              [30.09506269600007, -31.17864348799992],
              [30.062754754000082, -31.23870208099993],
              [30.009938998000052, -31.29225025799991],
              [29.864105665000068, -31.411553643999923],
              [29.84620201900009, -31.41961028399993],
              [29.78451582100007, -31.434747002999927],
              [29.761729363000086, -31.44394296699994],
              [29.742035352000073, -31.45745208099993],
              [29.73373457100007, -31.474867445999905],
              [29.67237389400009, -31.539727471999925],
              [29.650401238000086, -31.54778411299992],
              [29.641368035000085, -31.55331796699994],
              [29.634613477000073, -31.572442315999922],
              [29.627696160000085, -31.580254815999922],
              [29.619883660000085, -31.58603280999995],
              [29.614431186000047, -31.588148695999905],
              [29.592051629000082, -31.59303150799991],
              [29.574066602000073, -31.605401299999926],
              [29.542002800000034, -31.635918877999927],
              [29.526052280000044, -31.643975518999923],
              [29.486664259000065, -31.656426690999922],
              [29.460785352000073, -31.67229583099993],
              [29.452159050000034, -31.674004815999922],
              [29.44271894600007, -31.67473723799992],
              [29.43213951900009, -31.677504164999903],
              [29.427256707000083, -31.677992445999905],
              [29.416188998000052, -31.676527601999908],
              [29.411631707000083, -31.677504164999903],
              [29.405528191000087, -31.68417734199994],
              [29.406911655000044, -31.689385674999926],
              [29.41065514400009, -31.69378020599993],
              [29.411631707000083, -31.698011976999908],
              [29.391856316000087, -31.735528252999927],
              [29.362478061000047, -31.749769789999903],
              [29.356944207000083, -31.755791924999926],
              [29.35287519600007, -31.780368747999944],
              [29.342051629000082, -31.79355234199994],
              [29.309255405000044, -31.814060153999947],
              [29.27670332100007, -31.84465911299992],
              [29.261241082000083, -31.863539320999905],
              [29.254567905000044, -31.879571221999925],
              [29.251963738000086, -31.88909270599993],
              [29.23414147200009, -31.91659921699994],
              [29.223399285000085, -31.92197030999995],
              [29.22046959700009, -31.924004815999922],
              [29.218760613000086, -31.927911065999922],
              [29.215505405000044, -31.940118096999925],
              [29.213633660000085, -31.94378020599993],
              [29.147634311000047, -31.969821872999944],
              [29.137950066000087, -31.982028903999947],
              [29.133799675000034, -31.99846770599993],
              [29.123789910000085, -32.01702239399992],
              [29.096364780000044, -32.05364348799992],
              [28.973317905000044, -32.166680596999925],
              [28.870371941000087, -32.287041924999926],
              [28.817149285000085, -32.315118096999925],
              [28.80836022200009, -32.324883721999925],
              [28.674082879000082, -32.43059661299992],
              [28.651215040000068, -32.45907968499995],
              [28.642751498000052, -32.465508721999925],
              [28.626231316000087, -32.47234465899993],
              [28.617198113000086, -32.47820403399993],
              [28.580332879000082, -32.51116301899992],
              [28.562673373000052, -32.53199635199991],
              [28.555023634000065, -32.55046965899993],
              [28.54859459700009, -32.562432549999926],
              [28.437510613000086, -32.63600025799991],
              [28.411957227000073, -32.64763762799993],
              [28.37940514400009, -32.670993747999944],
              [28.363291863000086, -32.67815520599993],
              [28.360118035000085, -32.69394296699994],
              [28.336924675000034, -32.70940520599993],
              [28.28760826900009, -32.73211028399993],
              [28.240570509000065, -32.76091887799993],
              [28.210785352000073, -32.77467213299991],
              [28.155528191000087, -32.78850676899992],
              [28.130137566000087, -32.808851820999905],
              [28.110850457000083, -32.83652109199994],
              [28.10328209700009, -32.86614348799992],
              [28.094004754000082, -32.88746510199991],
              [28.072276238000086, -32.90829843499995],
              [27.969899936000047, -32.98056405999995],
              [27.939626498000052, -32.98984140399995],
              [27.930674675000034, -32.99765390399995],
              [27.91765384200005, -33.01384856599992],
              [27.90398196700005, -33.02068450299993],
              [27.902354363000086, -33.02434661299992],
              [27.90211022200009, -33.02947356599992],
              [27.901133660000085, -33.0349260399999],
              [27.897146030000044, -33.03997161299992],
              [27.84929446700005, -33.058526299999926],
              [27.82984459700009, -33.077243747999944],
              [27.818695509000065, -33.08163827899995],
              [27.79932701900009, -33.084242445999905],
              [27.749847852000073, -33.09978606599992],
              [27.732676629000082, -33.10881926899992],
              [27.643239780000044, -33.18865325299993],
              [27.60987389400009, -33.21184661299992],
              [27.539235873000052, -33.23455169099992],
              [27.52784264400009, -33.24293385199991],
              [27.523285352000073, -33.244398695999905],
              [27.500010613000086, -33.273370049999926],
              [27.492360873000052, -33.27703215899993],
              [27.484711134000065, -33.27898528399993],
              [27.47632897200009, -33.27809010199991],
              [27.465668165000068, -33.273370049999926],
              [27.458506707000083, -33.29892343499995],
              [27.434580925000034, -33.32073333099993],
              [27.38021894600007, -33.357354424999926],
              [27.355804884000065, -33.36956145599993],
              [27.351735873000052, -33.36956145599993],
              [27.347504102000073, -33.367120049999926],
              [27.34424889400009, -33.36443450299993],
              [27.34229576900009, -33.36337655999995],
              [27.33887780000009, -33.36638762799993],
              [27.334808790000068, -33.37704843499995],
              [27.22828209700009, -33.43889739399992],
              [27.218760613000086, -33.44866301899992],
              [27.14307701900009, -33.47942473799992],
              [27.12745201900009, -33.48984140399995],
              [27.119802280000044, -33.496758721999925],
              [27.116384311000047, -33.50359465899993],
              [27.114431186000047, -33.51116301899992],
              [27.108897332000083, -33.51913827899995],
              [27.10092207100007, -33.525323174999926],
              [27.091807488000086, -33.52776458099993],
              [27.07129967500009, -33.53085702899995],
              [26.984629754000082, -33.570245049999926],
              [26.96534264400009, -33.57431405999995],
              [26.941254102000073, -33.57561614399992],
              [26.919118686000047, -33.58147551899992],
              [26.86304772200009, -33.62273528399993],
              [26.84278405000009, -33.62737395599993],
              [26.79460696700005, -33.63225676899992],
              [26.761241082000083, -33.64902109199994],
              [26.66537519600007, -33.68368905999995],
              [26.65333092500009, -33.68482838299991],
              [26.64551842500009, -33.68914153399993],
              [26.638926629000082, -33.70777760199991],
              [26.63257897200009, -33.71217213299991],
              [26.610850457000083, -33.71493905999995],
              [26.515147332000083, -33.75530364399992],
              [26.476084832000083, -33.76425546699994],
              [26.434825066000087, -33.76604583099993],
              [26.349864129000082, -33.75554778399993],
              [26.323415561000047, -33.75644296699994],
              [26.304209832000083, -33.76376718499995],
              [26.286631707000083, -33.76637135199991],
              [26.263194207000083, -33.75798919099992],
              [26.22559655000009, -33.73943450299993],
              [26.092539910000085, -33.717054945999905],
              [25.955251498000052, -33.710870049999926],
              [25.867442254000082, -33.72185637799993],
              [25.785411004000082, -33.74358489399992],
              [25.711110873000052, -33.77418385199991],
              [25.67904707100007, -33.795179945999905],
              [25.653086785000085, -33.82268645599993],
              [25.634043816000087, -33.85515715899993],
              [25.617523634000065, -33.91139088299991],
              [25.61491946700005, -33.93499114399992],
              [25.619395379000082, -33.94589609199994],
              [25.638926629000082, -33.953789971999925],
              [25.643402540000068, -33.96257903399993],
              [25.64820397200009, -33.968682549999926],
              [25.677012566000087, -33.98650481599992],
              [25.695648634000065, -34.01181405999995],
              [25.704356316000087, -34.02068450299993],
              [25.70289147200009, -34.02849700299993],
              [25.701019727000073, -34.03167083099993],
              [25.697520379000082, -34.0349260399999],
              [25.666026238000086, -34.02654387799993],
              [25.64429772200009, -34.03248463299991],
              [25.624196811000047, -34.04306405999995],
              [25.59815514400009, -34.04851653399993],
              [25.56690514400009, -34.04550546699994],
              [25.513926629000082, -34.031508070999905],
              [25.485199415000068, -34.02752044099992],
              [25.435394727000073, -34.03289153399993],
              [25.410492384000065, -34.0329729149999],
              [25.383555535000085, -34.01962655999995],
              [25.347992384000065, -34.01441822699991],
              [25.31381269600007, -33.99334075299993],
              [25.277517123000052, -33.981133721999925],
              [25.192637566000087, -33.96217213299991],
              [25.101084832000083, -33.96054452899995],
              [25.01148522200009, -33.970961195999905],
              [24.95289147200009, -33.98512135199991],
              [24.92904707100007, -33.9958635399999],
              [24.913340691000087, -34.01132577899995],
              [24.92741946700005, -34.05234140399995],
              [24.916351759000065, -34.07236093499995],
              [24.899261915000068, -34.0896135399999],
              [24.888682488000086, -34.096368096999925],
              [24.841075066000087, -34.13250090899993],
              [24.834157748000052, -34.14763762799993],
              [24.838226759000065, -34.15976327899995],
              [24.847666863000086, -34.166273695999905],
              [24.85710696700005, -34.17115650799991],
              [24.861338738000086, -34.17831796699994],
              [24.85792076900009, -34.18694426899992],
              [24.84083092500009, -34.19801197699991],
              [24.834157748000052, -34.20566171699994],
              [24.827321811000047, -34.20566171699994],
              [24.814707879000082, -34.19068775799991],
              [24.793711785000085, -34.18474700299993],
              [24.725352410000085, -34.18328215899993],
              [24.670258009000065, -34.17083098799992],
              [24.647227410000085, -34.168226820999905],
              [24.583994988000086, -34.17831796699994],
              [24.56495201900009, -34.17693450299993],
              [24.478526238000086, -34.15781015399995],
              [24.43523196700005, -34.138929945999905],
              [24.40015709700009, -34.11256275799991],
              [24.380869988000086, -34.10637786299992],
              [24.25912519600007, -34.09417083099993],
              [24.241709832000083, -34.08611419099992],
              [24.22787519600007, -34.0778947899999],
              [24.16309655000009, -34.05478280999995],
              [23.984222852000073, -34.04111093499995],
              [23.96265709700009, -34.0368791649999],
              [23.91960696700005, -34.02353280999995],
              [23.81299889400009, -34.01441822699991],
              [23.635508660000085, -33.97966887799993],
              [23.588552280000044, -33.98121510199991],
              [23.427582227000073, -34.012383721999925],
              [23.406097852000073, -34.02044036299992],
              [23.386892123000052, -34.031182549999926],
              [23.37086022200009, -34.044854424999926],
              [23.361175977000073, -34.066664320999905],
              [23.367930535000085, -34.086602471999925],
              [23.385590040000068, -34.100274346999925],
              [23.408376498000052, -34.10320403399993],
              [23.408376498000052, -34.110039971999925],
              [23.062836134000065, -34.082696221999925],
              [23.057465040000068, -34.07626718499995],
              [23.051524285000085, -34.04762135199991],
              [23.049001498000052, -34.04111093499995],
              [23.01889082100007, -34.03915780999995],
              [23.006521030000044, -34.035088799999926],
              [22.998057488000086, -34.02752044099992],
              [23.00163821700005, -34.04257577899995],
              [23.009043816000087, -34.04851653399993],
              [23.018728061000047, -34.05169036299992],
              [23.028819207000083, -34.058526299999926],
              [23.03874759200005, -34.07244231599992],
              [23.038910352000073, -34.07976653399993],
              [23.03223717500009, -34.08611419099992],
              [23.026215040000068, -34.08098723799992],
              [23.01221764400009, -34.07740650799991],
              [22.984548373000052, -34.075290622999944],
              [22.97169030000009, -34.07773202899995],
              [22.962087436000047, -34.08131275799991],
              [22.951508009000065, -34.083916924999926],
              [22.93604576900009, -34.082696221999925],
              [22.856211785000085, -34.06178150799991],
              [22.824229363000086, -34.045179945999905],
              [22.811371290000068, -34.04176197699991],
              [22.80014082100007, -34.03557708099993],
              [22.79200280000009, -34.02068450299993],
              [22.789805535000085, -34.01132577899995],
              [22.790537957000083, -34.00432708099993],
              [22.797211134000065, -34.00058359199994],
              [22.812510613000086, -34.00074635199991],
              [22.796722852000073, -33.98951588299991],
              [22.774587436000047, -33.98357512799993],
              [22.730479363000086, -33.97966887799993],
              [22.73991946700005, -33.99472421699994],
              [22.753184441000087, -34.0095354149999],
              [22.76889082100007, -34.021416924999926],
              [22.785166863000086, -34.02752044099992],
              [22.766774936000047, -34.03289153399993],
              [22.742523634000065, -34.02890390399995],
              [22.62989342500009, -33.99578215899993],
              [22.60987389400009, -33.99334075299993],
              [22.58366946700005, -33.994073174999926],
              [22.563975457000083, -33.99724700299993],
              [22.547699415000068, -34.00359465899993],
              [22.49586022200009, -34.03923919099992],
              [22.455414259000065, -34.05706145599993],
              [22.410492384000065, -34.06560637799993],
              [22.317067905000044, -34.056898695999905],
              [22.27515709700009, -34.057712497999944],
              [22.18921959700009, -34.075290622999944],
              [22.169200066000087, -34.08318450299993],
              [22.15284264400009, -34.093682549999926],
              [22.12354576900009, -34.12053801899992],
              [22.11101321700005, -34.14153411299992],
              [22.115407748000052, -34.15781015399995],
              [22.12989342500009, -34.1696916649999],
              [22.147715691000087, -34.17831796699994],
              [22.134043816000087, -34.18808359199994],
              [22.114105665000068, -34.19394296699994],
              [21.98406009200005, -34.21013762799993],
              [21.94695071700005, -34.223728122999944],
              [21.921722852000073, -34.24667734199994],
              [21.918711785000085, -34.26295338299991],
              [21.923838738000086, -34.29566822699991],
              [21.914317254000082, -34.30681731599992],
              [21.894541863000086, -34.33603280999995],
              [21.888682488000086, -34.3396135399999],
              [21.829600457000083, -34.36858489399992],
              [21.78874759200005, -34.38128020599993],
              [21.746104363000086, -34.38836028399993],
              [21.702647332000083, -34.390557549999926],
              [21.597178582000083, -34.37265390399995],
              [21.559743686000047, -34.353448174999926],
              [21.53760826900009, -34.34889088299991],
              [21.515879754000082, -34.352227471999925],
              [21.474131707000083, -34.36679452899995],
              [21.438975457000083, -34.37232838299991],
              [21.431895379000082, -34.37786223799992],
              [21.42750084700009, -34.3845354149999],
              [21.422129754000082, -34.390557549999926],
              [21.415537957000083, -34.39495208099993],
              [21.34896894600007, -34.41920338299991],
              [21.305918816000087, -34.42457447699991],
              [21.262461785000085, -34.42156340899993],
              [21.098399285000085, -34.37078215899993],
              [21.05836022200009, -34.36337655999995],
              [20.961273634000065, -34.35605234199994],
              [20.91342207100007, -34.360446872999944],
              [20.87354576900009, -34.376885674999926],
              [20.880869988000086, -34.376885674999926],
              [20.823741082000083, -34.39031340899993],
              [20.80518639400009, -34.39804452899995],
              [20.832204623000052, -34.40178801899992],
              [20.856130405000044, -34.41692473799992],
              [20.86817467500009, -34.43792083099993],
              [20.85987389400009, -34.4587541649999],
              [20.841075066000087, -34.46502044099992],
              [20.664317254000082, -34.43840911299992],
              [20.52442467500009, -34.45427825299993],
              [20.482676629000082, -34.4704729149999],
              [20.448008660000085, -34.49334075299993],
              [20.393239780000044, -34.55478280999995],
              [20.374522332000083, -34.56975676899992],
              [20.355479363000086, -34.576104424999926],
              [20.34115644600007, -34.57870859199994],
              [20.334320509000065, -34.58521900799991],
              [20.328868035000085, -34.594008070999905],
              [20.318614129000082, -34.603448174999926],
              [20.310069207000083, -34.6071916649999],
              [20.277598504000082, -34.61777109199994],
              [20.26148522200009, -34.62704843499995],
              [20.243337436000047, -34.64104583099993],
              [20.228526238000086, -34.65781015399995],
              [20.22242272200009, -34.67506275799991],
              [20.211680535000085, -34.67205169099992],
              [20.18726647200009, -34.67742278399993],
              [20.146657748000052, -34.69215260199991],
              [20.072601759000065, -34.73691171699994],
              [20.044444207000083, -34.76832447699991],
              [20.057871941000087, -34.795179945999905],
              [20.057871941000087, -34.801446221999925],
              [20.041758660000085, -34.80510833099993],
              [20.015635613000086, -34.81894296699994],
              [19.999278191000087, -34.82195403399993],
              [19.983571811000047, -34.8200822899999],
              [19.967946811000047, -34.81519947699991],
              [19.953461134000065, -34.80868905999995],
              [19.890472852000073, -34.76970794099992],
              [19.87598717500009, -34.75741952899995],
              [19.85840905000009, -34.74968840899993],
              [19.698090040000068, -34.7536760399999],
              [19.683604363000086, -34.75660572699991],
              [19.66700280000009, -34.77044036299992],
              [19.653168165000068, -34.774102471999925],
              [19.642425977000073, -34.77206796699994],
              [19.63575280000009, -34.765883070999905],
              [19.631114129000082, -34.758884372999944],
              [19.626475457000083, -34.7536760399999],
              [19.576019727000073, -34.72795989399992],
              [19.49968509200005, -34.66423919099992],
              [19.448496941000087, -34.64006926899992],
              [19.43295332100007, -34.629978122999944],
              [19.41732832100007, -34.61402760199991],
              [19.398692254000082, -34.601820570999905],
              [19.37476647200009, -34.59929778399993],
              [19.350759311000047, -34.60491301899992],
              [19.33171634200005, -34.61777109199994],
              [19.323008660000085, -34.61248137799993],
              [19.31421959700009, -34.61093515399995],
              [19.305511915000068, -34.61272551899992],
              [19.296885613000086, -34.61777109199994],
              [19.300629102000073, -34.60662200299993],
              [19.360118035000085, -34.53866952899995],
              [19.365082227000073, -34.52776458099993],
              [19.360199415000068, -34.50042083099993],
              [19.344411655000044, -34.46843840899993],
              [19.32390384200005, -34.43865325299993],
              [19.30437259200005, -34.417901299999926],
              [19.29037519600007, -34.40911223799992],
              [19.277679884000065, -34.406508070999905],
              [19.207774285000085, -34.41855234199994],
              [19.146494988000086, -34.41497161299992],
              [19.133067254000082, -34.41171640399995],
              [19.119313998000052, -34.40056731599992],
              [19.101084832000083, -34.37232838299991],
              [19.085215691000087, -34.36337655999995],
              [19.085215691000087, -34.356540622999944],
              [19.11101321700005, -34.352634372999944],
              [19.122894727000073, -34.33798593499995],
              [19.129567905000044, -34.317071221999925],
              [19.139903191000087, -34.29436614399992],
              [19.122569207000083, -34.302666924999926],
              [19.09896894600007, -34.33554452899995],
              [19.08838951900009, -34.34270598799992],
              [19.011973504000082, -34.338555596999925],
              [18.99903405000009, -34.33928801899992],
              [18.970225457000083, -34.34823984199994],
              [18.872894727000073, -34.36191171699994],
              [18.851898634000065, -34.37346770599993],
              [18.847911004000082, -34.38160572699991],
              [18.838226759000065, -34.383884372999944],
              [18.826996290000068, -34.38176848799992],
              [18.817637566000087, -34.376885674999926],
              [18.80827884200005, -34.36467864399992],
              [18.809418165000068, -34.35491301899992],
              [18.817637566000087, -34.34270598799992],
              [18.810883009000065, -34.30974700299993],
              [18.81031334700009, -34.301853122999944],
              [18.813731316000087, -34.2907854149999],
              [18.818369988000086, -34.28606536299992],
              [18.824229363000086, -34.28240325299993],
              [18.83139082100007, -34.27385833099993],
              [18.839691602000073, -34.25432708099993],
              [18.838226759000065, -34.23967864399992],
              [18.82390384200005, -34.20566171699994],
              [18.822520379000082, -34.18499114399992],
              [18.83139082100007, -34.17587655999995],
              [18.84506269600007, -34.16765715899993],
              [18.858164910000085, -34.150323174999926],
              [18.81617272200009, -34.09710051899992],
              [18.800059441000087, -34.08953215899993],
              [18.74073326900009, -34.07740650799991],
              [18.647227410000085, -34.07000090899993],
              [18.555023634000065, -34.07382577899995],
              [18.540293816000087, -34.07903411299992],
              [18.53174889400009, -34.083916924999926],
              [18.495616082000083, -34.096368096999925],
              [18.478363477000073, -34.10686614399992],
              [18.47006269600007, -34.11402760199991],
              [18.460785352000073, -34.12428150799991],
              [18.446055535000085, -34.13713958099993],
              [18.441661004000082, -34.14421965899993],
              [18.440277540000068, -34.15781015399995],
              [18.44271894600007, -34.16814544099992],
              [18.44776451900009, -34.1735979149999],
              [18.454356316000087, -34.17791106599992],
              [18.460785352000073, -34.18450286299992],
              [18.474457227000073, -34.22616952899995],
              [18.47592207100007, -34.23593515399995],
              [18.476573113000086, -34.24504973799992],
              [18.467621290000068, -34.31129322699991],
              [18.47169030000009, -34.33171965899993],
              [18.48878014400009, -34.34270598799992],
              [18.47006269600007, -34.3474260399999],
              [18.445160352000073, -34.33652109199994],
              [18.421397332000083, -34.31845468499995],
              [18.406260613000086, -34.301853122999944],
              [18.38217207100007, -34.26213958099993],
              [18.378916863000086, -34.250258070999905],
              [18.380056186000047, -34.2439104149999],
              [18.384613477000073, -34.23015715899993],
              [18.38575280000009, -34.22234465899993],
              [18.38379967500009, -34.218682549999926],
              [18.379567905000044, -34.21640390399995],
              [18.37476647200009, -34.21453215899993],
              [18.37208092500009, -34.21249765399995],
              [18.362478061000047, -34.186211846999925],
              [18.354340040000068, -34.17538827899995],
              [18.325450066000087, -34.16716887799993],
              [18.316254102000073, -34.15748463299991],
              [18.31381269600007, -34.14462655999995],
              [18.31690514400009, -34.13054778399993],
              [18.324229363000086, -34.12265390399995],
              [18.333506707000083, -34.11988697699991],
              [18.341319207000083, -34.11467864399992],
              [18.34473717500009, -34.09978606599992],
              [18.345225457000083, -34.08611419099992],
              [18.347178582000083, -34.07545338299991],
              [18.351410352000073, -34.06560637799993],
              [18.35840905000009, -34.05478280999995],
              [18.343760613000086, -34.056573174999926],
              [18.337901238000086, -34.05828215899993],
              [18.330414259000065, -34.06218840899993],
              [18.31617272200009, -34.04355234199994],
              [18.314789259000065, -34.0290666649999],
              [18.323090040000068, -34.015883070999905],
              [18.337901238000086, -34.00074635199991],
              [18.351817254000082, -33.9821916649999],
              [18.362559441000087, -33.94646575299993],
              [18.37208092500009, -33.92506275799991],
              [18.404551629000082, -33.90325286299992],
              [18.44304446700005, -33.9040666649999],
              [18.475352410000085, -33.89983489399992],
              [18.48878014400009, -33.86296965899993],
              [18.484385613000086, -33.84392669099992],
              [18.465098504000082, -33.81796640399995],
              [18.460785352000073, -33.804945570999905],
              [18.45834394600007, -33.78525155999995],
              [18.431813998000052, -33.69670989399992],
              [18.40560957100007, -33.65292734199994],
              [18.40007571700005, -33.63339609199994],
              [18.390961134000065, -33.62948984199994],
              [18.34473717500009, -33.58245208099993],
              [18.328298373000052, -33.57341887799993],
              [18.320323113000086, -33.567478122999944],
              [18.31690514400009, -33.558526299999926],
              [18.31690514400009, -33.51726653399993],
              [18.314300977000073, -33.49651458099993],
              [18.307383660000085, -33.47926197699991],
              [18.282725457000083, -33.445245049999926],
              [18.254161004000082, -33.41936614399992],
              [18.14616946700005, -33.35588958099993],
              [18.15601647200009, -33.33904387799993],
              [18.15015709700009, -33.31926848799992],
              [18.125010613000086, -33.28004322699991],
              [18.111989780000044, -33.25351327899995],
              [18.087738477000073, -33.22584400799991],
              [18.084727410000085, -33.21526458099993],
              [18.07520592500009, -33.202243747999944],
              [18.029307488000086, -33.16497161299992],
              [18.012380405000044, -33.157321872999944],
              [17.991709832000083, -33.150323174999926],
              [17.977793816000087, -33.13420989399992],
              [17.966644727000073, -33.11581796699994],
              [17.954925977000073, -33.10198333099993],
              [17.980479363000086, -33.09124114399992],
              [17.995290561000047, -33.088148695999905],
              [18.005869988000086, -33.091729424999926],
              [18.013682488000086, -33.10320403399993],
              [18.01921634200005, -33.11402760199991],
              [18.026052280000044, -33.12346770599993],
              [18.037445509000065, -33.129978122999944],
              [18.03296959700009, -33.140883070999905],
              [18.040212436000047, -33.149102471999925],
              [18.067637566000087, -33.16757577899995],
              [18.086110873000052, -33.189385674999926],
              [18.099131707000083, -33.2009416649999],
              [18.111989780000044, -33.205010674999926],
              [18.12745201900009, -33.19736093499995],
              [18.123383009000065, -33.18613046699994],
              [18.101817254000082, -33.16757577899995],
              [18.096527540000068, -33.15911223799992],
              [18.094493035000085, -33.14226653399993],
              [18.09156334700009, -33.13551197699991],
              [18.087168816000087, -33.133070570999905],
              [18.07593834700009, -33.13201262799993],
              [18.071055535000085, -33.129978122999944],
              [18.049082879000082, -33.11142343499995],
              [18.040863477000073, -33.10165780999995],
              [18.037445509000065, -33.091729424999926],
              [18.040537957000083, -33.04851653399993],
              [18.037445509000065, -33.03378671699994],
              [18.02320397200009, -33.014336846999925],
              [17.999522332000083, -33.00448984199994],
              [17.970550977000073, -33.00237395599993],
              [17.940684441000087, -33.00644296699994],
              [17.94971764400009, -33.02223072699991],
              [17.954925977000073, -33.02752044099992],
              [17.94271894600007, -33.029961846999925],
              [17.932302280000044, -33.03435637799993],
              [17.912771030000044, -33.04745859199994],
              [17.901866082000083, -33.0368791649999],
              [17.89584394600007, -33.026462497999944],
              [17.893402540000068, -33.01718515399995],
              [17.892832879000082, -33.01018645599993],
              [17.889008009000065, -33.00156015399995],
              [17.882090691000087, -32.99260833099993],
              [17.87859134200005, -32.981540622999944],
              [17.885508660000085, -32.96607838299991],
              [17.880707227000073, -32.95818450299993],
              [17.86850019600007, -32.92929452899995],
              [17.862478061000047, -32.90715911299992],
              [17.861664259000065, -32.89902109199994],
              [17.865082227000073, -32.890557549999926],
              [17.875254754000082, -32.87981536299992],
              [17.881032748000052, -32.86760833099993],
              [17.87549889400009, -32.85588958099993],
              [17.852386915000068, -32.82968515399995],
              [17.846853061000047, -32.82708098799992],
              [17.843028191000087, -32.823337497999944],
              [17.843923373000052, -32.81462981599992],
              [17.847829623000052, -32.81340911299992],
              [17.85515384200005, -32.814711195999905],
              [17.86182701900009, -32.81519947699991],
              [17.86500084700009, -32.811211846999925],
              [17.86817467500009, -32.80820077899995],
              [17.883555535000085, -32.7966447899999],
              [17.88917076900009, -32.79412200299993],
              [17.897308790000068, -32.7927385399999],
              [17.899099155000044, -32.78923919099992],
              [17.89942467500009, -32.78394947699991],
              [17.90284264400009, -32.77703215899993],
              [17.903575066000087, -32.76921965899993],
              [17.902679884000065, -32.73837655999995],
              [17.90593509200005, -32.72584400799991],
              [17.91968834700009, -32.7165666649999],
              [17.943369988000086, -32.70826588299991],
              [17.967458530000044, -32.70354583099993],
              [17.982269727000073, -32.70476653399993],
              [17.974864129000082, -32.71217213299991],
              [17.986582879000082, -32.72698333099993],
              [18.037445509000065, -32.76677825299993],
              [18.08057701900009, -32.78134530999995],
              [18.11882571700005, -32.77304452899995],
              [18.15211022200009, -32.75123463299991],
              [18.27312259200005, -32.647556247999944],
              [18.296397332000083, -32.60857512799993],
              [18.310801629000082, -32.57284921699994],
              [18.334157748000052, -32.491306247999944],
              [18.337901238000086, -32.45159270599993],
              [18.333181186000047, -32.38201262799993],
              [18.327403191000087, -32.36614348799992],
              [18.31544030000009, -32.343682549999926],
              [18.321055535000085, -32.32732512799993],
              [18.34473717500009, -32.300713799999926],
              [18.34937584700009, -32.26034921699994],
              [18.310720248000052, -32.12948984199994],
              [18.299489780000044, -32.02263762799993],
              [18.28174889400009, -31.979180596999925],
              [18.27588951900009, -31.95745208099993],
              [18.27833092500009, -31.91375090899993],
              [18.276866082000083, -31.89267343499995],
              [18.265635613000086, -31.87232838299991],
              [18.253103061000047, -31.85833098799992],
              [18.241709832000083, -31.841403903999947],
              [18.23568769600007, -31.828057549999926],
              [18.23487389400009, -31.819105726999908],
              [18.235850457000083, -31.81113046699994],
              [18.23487389400009, -31.80046965899993],
              [18.213715040000068, -31.730645440999922],
              [18.196787957000083, -31.69736093499995],
              [18.17286217500009, -31.663262627999927],
              [18.126231316000087, -31.61223723799992],
              [18.11882571700005, -31.59807708099993],
              [18.116709832000083, -31.590590101999908],
              [18.071055535000085, -31.533461195999905],
              [18.023285352000073, -31.490411065999922],
              [18.015798373000052, -31.474867445999905],
              [18.00945071700005, -31.456638278999947],
              [17.994151238000086, -31.441338799999926],
              [17.961192254000082, -31.416192315999922],
              [17.922211134000065, -31.363946221999925],
              [17.893728061000047, -31.344821872999944],
              [17.88379967500009, -31.320082289999903],
              [17.871836785000085, -31.272881768999923],
              [17.859385613000086, -31.26034921699994],
              [17.818614129000082, -31.23211028399993],
              [17.809743686000047, -31.22161223799992],
              [17.80437259200005, -31.208591403999947],
              [17.750254754000082, -31.131931247999944],
              [17.745290561000047, -31.128838799999926],
              [17.735036655000044, -31.104261976999908],
              [17.731211785000085, -31.097832940999922],
              [17.718272332000083, -31.08066171699994],
              [17.697113477000073, -31.035821221999925],
              [17.686778191000087, -31.018975518999923],
              [17.617198113000086, -30.93401458099993],
              [17.561696811000047, -30.838067315999922],
              [17.556488477000073, -30.823825778999947],
              [17.54818769600007, -30.78720468499995],
              [17.535980665000068, -30.752129815999922],
              [17.477224155000044, -30.682386976999908],
              [17.450368686000047, -30.63909270599993],
              [17.45411217500009, -30.60125090899993],
              [17.429535352000073, -30.57675546699994],
              [17.37354576900009, -30.48723723799992],
              [17.36459394600007, -30.464043877999927],
              [17.34620201900009, -30.444512627999927],
              [17.281993035000085, -30.34775155999995],
              [17.277517123000052, -30.33757903399993],
              [17.27442467500009, -30.311700127999927],
              [17.265879754000082, -30.279961846999925],
              [17.261729363000086, -30.271661065999922],
              [17.25945071700005, -30.24504973799992],
              [17.206879102000073, -30.16529713299991],
              [17.193369988000086, -30.132012627999927],
              [17.189626498000052, -30.09303150799991],
              [17.166351759000065, -30.012872002999927],
              [17.103688998000052, -29.884942315999922],
              [17.097178582000083, -29.85084400799991],
              [17.094981316000087, -29.845879815999922],
              [17.09034264400009, -29.84075286299992],
              [17.08570397200009, -29.833754164999903],
              [17.083506707000083, -29.823337497999944],
              [17.082774285000085, -29.812758070999905],
              [17.05632571700005, -29.730401299999926],
              [17.062510613000086, -29.730401299999926],
              [17.05762780000009, -29.717461846999925],
              [17.057790561000047, -29.690606377999927],
              [17.05632571700005, -29.676446221999925],
              [17.031586134000065, -29.61882903399993],
              [17.032074415000068, -29.608168226999908],
              [17.018809441000087, -29.598728122999944],
              [17.011973504000082, -29.57708098799992],
              [17.007823113000086, -29.539239190999922],
              [16.97828209700009, -29.467868747999944],
              [16.970876498000052, -29.45671965899993],
              [16.933929884000065, -29.357679945999905],
              [16.929698113000086, -29.35125090899993],
              [16.910329623000052, -29.332777601999908],
              [16.90601647200009, -29.322930596999925],
              [16.903168165000068, -29.318291924999926],
              [16.884938998000052, -29.299004815999922],
              [16.86378014400009, -29.23870208099993],
              [16.858083530000044, -29.229587497999944],
              [16.847666863000086, -29.219903252999927],
              [16.843272332000083, -29.21135833099993],
              [16.84424889400009, -29.18840911299992],
              [16.840586785000085, -29.178887627999927],
              [16.831228061000047, -29.163832289999903],
              [16.822927280000044, -29.14072030999995],
              [16.819183790000068, -29.11728280999995],
              [16.824066602000073, -29.101006768999923],
              [16.808767123000052, -29.078301690999922],
              [16.744965040000068, -29.028741143999923],
              [16.73568769600007, -29.01620859199994],
              [16.72046959700009, -28.977634372999944],
              [16.712738477000073, -28.963962497999944],
              [16.66773522200009, -28.90862395599993],
              [16.600352410000085, -28.85751718499995],
              [16.58952884200005, -28.835870049999926],
              [16.57943769600007, -28.800388278999947],
              [16.57390384200005, -28.765069268999923],
              [16.576996290000068, -28.74423593499995],
              [16.572927280000044, -28.73756275799991],
              [16.564300977000073, -28.720310153999947],
              [16.562754754000082, -28.712823174999926],
              [16.558929884000065, -28.70761484199994],
              [16.55054772200009, -28.705824476999908],
              [16.541188998000052, -28.705254815999922],
              [16.53484134200005, -28.70322030999995],
              [16.513519727000073, -28.660902601999908],
              [16.49708092500009, -28.64934661299992],
              [16.471853061000047, -28.62542083099993],
              [16.469981316000087, -28.62004973799992],
              [16.480316602000073, -28.613539320999905],
              [16.486664259000065, -28.598809502999927],
              [16.488942905000044, -28.58294036299992],
              [16.487071160000085, -28.572930596999925],
              [16.50537967900007, -28.56538706399992],
              [16.531527954000097, -28.549677428999956],
              [16.559123169000088, -28.537068379999937],
              [16.59736372800009, -28.526216328999894],
              [16.673121378000076, -28.45976043699993],
              [16.68345666500008, -28.456246439999873],
              [16.69234501100007, -28.46110402399998],
              [16.696789185000085, -28.47247283899989],
              [16.699683065000073, -28.48518524199993],
              [16.7038171800001, -28.494487],
              [16.720456990000116, -28.496037292999887],
              [16.740404093000052, -28.480947773999972],
              [16.758387492000026, -28.459657083999986],
              [16.769342895000108, -28.442603861999956],
              [16.77213342300007, -28.425757344999894],
              [16.773373657000093, -28.402916361999885],
              [16.778541301000104, -28.382969258999964],
              [16.7932174070001, -28.37428761799991],
              [16.80386275300009, -28.366122741999888],
              [16.796834758000074, -28.347829284999918],
              [16.775544067000084, -28.319097187999915],
              [16.76841271900014, -28.30369761099992],
              [16.764381958000058, -28.283233743999872],
              [16.76872277800004, -28.265353698999903],
              [16.78649947100007, -28.257602233999904],
              [16.79518111100012, -28.261219583999974],
              [16.80510298700011, -28.26773081499995],
              [16.81523156700007, -28.270831399999892],
              [16.824636678000047, -28.26452687599989],
              [16.826600382000066, -28.251917825999953],
              [16.82081262200009, -28.24003224699993],
              [16.813267863000135, -28.229903665999885],
              [16.81027063000002, -28.222875670999954],
              [16.81430139100013, -28.21347056099991],
              [16.819779094000097, -28.209749856999906],
              [16.84106978300008, -28.209853210999924],
              [16.856366007000133, -28.20664927199995],
              [16.855952596000122, -28.199414570999892],
              [16.838382609000064, -28.17946746799997],
              [16.83569543400003, -28.174196471999934],
              [16.837659139000067, -28.168202005999916],
              [16.843756958000114, -28.16386118499993],
              [16.847787720000014, -28.165411478999943],
              [16.852025188000084, -28.16830535899993],
              [16.8686649980001, -28.16789194799992],
              [16.87383264200008, -28.171509297999904],
              [16.878173462000063, -28.172026061999944],
              [16.885511515000076, -28.162000833999926],
              [16.892952921000102, -28.082625833999955],
              [16.896466919000147, -28.079938659999925],
              [16.913520142000067, -28.062678730999934],
              [16.919617961000142, -28.058337910999867],
              [16.927472778000066, -28.060198261999872],
              [16.937498006000084, -28.071050312999915],
              [16.9475232340001, -28.072703958999867],
              [16.95951216700007, -28.06856984399994],
              [16.97377486200014, -28.05503061899995],
              [16.985350382000092, -28.052240091999906],
              [17.012015421000058, -28.058337910999867],
              [17.0453983970001, -28.03632375099997],
              [17.056663859000082, -28.031156106999973],
              [17.076404256000046, -28.02681528699989],
              [17.086532837000078, -28.02702199299995],
              [17.097798299000146, -28.031156106999973],
              [17.111750936000135, -28.046038919999916],
              [17.123223103000072, -28.06650278799988],
              [17.136348917000106, -28.08469289199992],
              [17.155779256000102, -28.092547708999945],
              [17.180894002000116, -28.099472350999932],
              [17.189989054000108, -28.116835631999948],
              [17.18978234900004, -28.139366556999875],
              [17.18709517400012, -28.162000833999926],
              [17.191952758000127, -28.20881968199994],
              [17.213140096000075, -28.23207407599996],
              [17.24517948400009, -28.237448424999926],
              [17.308638143000053, -28.224115904999906],
              [17.334476359000064, -28.222875670999954],
              [17.345741821000104, -28.22762990299995],
              [17.349772583000117, -28.238688658999962],
              [17.35121952300011, -28.251401061999914],
              [17.35504357900004, -28.26101287799993],
              [17.364138631000117, -28.27331186899997],
              [17.367032512000094, -28.283543802999944],
              [17.368066040000087, -28.29377573599993],
              [17.37199344900006, -28.306074726999967],
              [17.378918090000127, -28.316306660999942],
              [17.394834432000067, -28.335116881999866],
              [17.400002075000145, -28.346382344999924],
              [17.40206913300011, -28.367776386999935],
              [17.399692017000064, -28.395268248999912],
              [17.391320435000097, -28.418832702999907],
              [17.37540409400009, -28.42896128299995],
              [17.358557577000084, -28.432785338999906],
              [17.341194295000093, -28.442810566999924],
              [17.328171834000045, -28.456143086999944],
              [17.324244425000074, -28.470509134999944],
              [17.332409302000087, -28.488595885999956],
              [17.359487752000064, -28.519808451999936],
              [17.36527551200004, -28.542546080999927],
              [17.37302697800004, -28.559392597999903],
              [17.409613892000067, -28.571381529999954],
              [17.420569295000064, -28.59339569099994],
              [17.41426477100012, -28.63266977899991],
              [17.40175907300005, -28.674217630999905],
              [17.403619425000045, -28.704293314999873],
              [17.440929810000085, -28.70956431099991],
              [17.48516483600011, -28.700159199999945],
              [17.526609334000057, -28.695818379999963],
              [17.546969849000078, -28.691374206999868],
              [17.565986776000074, -28.683519388999926],
              [17.582936646000064, -28.680212097999927],
              [17.59802616300007, -28.689617206999884],
              [17.60340051300011, -28.71080454499993],
              [17.6025736900001, -28.73540252699992],
              [17.607121216000053, -28.755659687999923],
              [17.628721965000096, -28.764134622999933],
              [17.660968058000066, -28.772299499999946],
              [17.673783813000057, -28.77157602899986],
              [17.683395630000064, -28.76754526799995],
              [17.703239379000138, -28.755556334999895],
              [17.71409143000011, -28.7511121619999],
              [17.74633752400007, -28.748631692999922],
              [17.913252401000108, -28.78129119799989],
              [17.949529256000062, -28.79472707099994],
              [17.983325643000057, -28.813743997999907],
              [18.04409712700007, -28.858392434999942],
              [18.082441040000077, -28.87596242299992],
              [18.1664669190001, -28.901903990999955],
              [18.185070434000068, -28.902214050999945],
              [18.220727173000057, -28.891258646999873],
              [18.30868046100005, -28.879993183999915],
              [18.331004679000017, -28.88144012399991],
              [18.37306929500005, -28.89518605599993],
              [18.39756392400011, -28.898906758999942],
              [18.416994262000088, -28.891672057999884],
              [18.42474572800009, -28.887227884999973],
              [18.43570113100006, -28.884230651999957],
              [18.45523482200008, -28.88144012399991],
              [18.460712525000076, -28.87988983099997],
              [18.46939416500004, -28.874928893999936],
              [18.474975219000044, -28.873998717999967],
              [18.479419393000057, -28.8762724809999],
              [18.491615031000066, -28.88629770899992],
              [18.496162557000105, -28.888261412999952],
              [18.517659953000134, -28.88226694699992],
              [18.55393680800009, -28.86469696099995],
              [18.74565637200007, -28.83989227299992],
              [18.95453251100014, -28.866660664999884],
              [18.971172323000047, -28.880509948999944],
              [18.996390422000104, -28.91554656999996],
              [19.00693241400006, -28.92629526799989],
              [19.013960408000088, -28.928465676999878],
              [19.048997030000095, -28.932393086999937],
              [19.060055786000106, -28.935700377999936],
              [19.064706665000074, -28.93983449299988],
              [19.081656535000064, -28.959368183999885],
              [19.120207154000042, -28.95750783299988],
              [19.16154829900009, -28.945415547999886],
              [19.21849572700006, -28.91885386099996],
              [19.226660604000074, -28.91151580799996],
              [19.237616007000042, -28.89559946699994],
              [19.243713826000118, -28.89187876399994],
              [19.276580037000144, -28.889501647999893],
              [19.288362264000057, -28.88309376999986],
              [19.288879028000082, -28.871001484999866],
              [19.251568645000134, -28.81426076299995],
              [19.244954061000044, -28.79245330799992],
              [19.248571411000114, -28.77157602899986],
              [19.265934692000144, -28.74263722699989],
              [19.277303508000045, -28.729408059999898],
              [19.29001590900009, -28.719692890999866],
              [19.304485310000103, -28.718659361999883],
              [19.328359822000095, -28.735815938999934],
              [19.339005168000085, -28.73746958399998],
              [19.353474569000127, -28.73188852899996],
              [19.43460656700009, -28.71349171899996],
              [19.45507043400005, -28.705223489999923],
              [19.47243371600007, -28.69271779399992],
              [19.482872355000097, -28.67824839299989],
              [19.51170780400011, -28.598046568999905],
              [19.517805623000072, -28.58936492899994],
              [19.52741743900009, -28.58595428399991],
              [19.533721965000097, -28.582440286999955],
              [19.542196900000107, -28.564043476999956],
              [19.547571248000082, -28.555878600999947],
              [19.556459594000074, -28.54616343099991],
              [19.562350708000082, -28.53810190899992],
              [19.568758586000115, -28.53117726599993],
              [19.579197225000144, -28.52518279999991],
              [19.58798221900014, -28.522702331999923],
              [19.68833785000001, -28.515984394999904],
              [19.70559777800011, -28.508026224999938],
              [19.725338175000076, -28.49417694099988],
              [19.748075805000042, -28.487148945999962],
              [19.79634159300005, -28.48415171299986],
              [19.825590454000093, -28.476710306999934],
              [19.870342245000074, -28.44084686299989],
              [19.89669722500011, -28.427721048999928],
              [19.90785933400005, -28.426480813999973],
              [19.940208781000138, -28.4302015169999],
              [19.950544067000067, -28.429271340999946],
              [19.981653280000103, -28.422346699999963],
              [19.983203572000036, -28.39268442799991],
              [19.983203572000036, -28.35320363299988],
              [19.983203572000036, -28.29718638099986],
              [19.983203572000036, -28.24106577499991],
              [19.983203572000036, -28.185048522999892],
              [19.983100219000107, -28.129031269999956],
              [19.982996867000082, -28.072910664999924],
              [19.982996867000082, -28.01679005899996],
              [19.982996867000082, -27.96077280699994],
              [19.982996867000082, -27.904652200999905],
              [19.982996867000082, -27.848531595999944],
              [19.982996867000082, -27.79261769599995],
              [19.982996867000082, -27.73649709099992],
              [19.982996867000082, -27.680376484999954],
              [19.98289351400004, -27.624359232999936],
              [19.98289351400004, -27.5682386269999],
              [19.98289351400004, -27.51211802199994],
              [19.98289351400004, -27.45610076899993],
              [19.98289351400004, -27.40018686899994],
              [19.98289351400004, -27.344066262999974],
              [19.98289351400004, -27.28794565799994],
              [19.98279016100011, -27.231928405999923],
              [19.982686808000096, -27.175807799999873],
              [19.982686808000096, -27.119687193999923],
              [19.982686808000096, -27.063669941999905],
              [19.982686808000096, -27.007652689999887],
              [19.982686808000096, -26.951532083999936],
              [19.982686808000096, -26.895514831999918],
              [19.98258345600007, -26.839394225999868],
              [19.98258345600007, -26.783376973999935],
              [19.98258345600007, -26.7272563679999],
              [19.98258345600007, -26.67123911599988],
              [19.98258345600007, -26.61511850999993],
              [19.98248010300003, -26.559101257999913],
              [19.9823767500001, -26.503084004999977],
              [19.9823767500001, -26.44696339999993],
              [19.9823767500001, -26.390946146999923],
              [19.9823767500001, -26.334825541999876],
              [19.9823767500001, -26.27880828799995],
              [19.9823767500001, -26.222687682999904],
              [19.982273396000068, -26.166670429999968],
              [19.982273396000068, -26.110549824999936],
              [19.982273396000068, -26.054532571999914],
              [19.982273396000068, -25.998515319999896],
              [19.982273396000068, -25.942394713999946],
              [19.982170044000043, -25.8862741089999],
              [19.982066691000114, -25.830256855999963],
              [19.982066691000114, -25.77413625099993],
              [19.982066691000114, -25.71811899799991],
              [19.982066691000114, -25.66210174599989],
              [19.982066691000114, -25.618988071999922],
              [19.982066691000114, -25.60608449299987],
              [19.982066691000114, -25.549963887999922],
              [19.982066691000114, -25.493843281999958],
              [19.982066691000114, -25.43782602999994],
              [19.9819633380001, -25.381705423999904],
              [19.9819633380001, -25.32568817199997],
              [19.9819633380001, -25.269670918999864],
              [19.9819633380001, -25.213550313999917],
              [19.9819633380001, -25.157429707999952],
              [19.9819633380001, -25.101412455999935],
              [19.9819633380001, -25.045395201999924],
              [19.981859985000057, -24.989274596999877],
              [19.981756632000042, -24.933257343999955],
              [19.981756632000042, -24.87713673899991],
              [19.981756632000042, -24.821016132999958],
              [19.981756632000042, -24.76499888099994],
              [19.981446574000046, -24.75249318399993],
            ],
            [
              [28.980845581000068, -28.909035338999985],
              [28.925861857000115, -28.85952931699994],
              [28.885657593000076, -28.797207539999917],
              [28.872841837000095, -28.78356496099991],
              [28.859013629000117, -28.772990447999916],
              [28.858785848000082, -28.772816262999896],
              [28.843696330000085, -28.764754740999905],
              [28.827936586000135, -28.759534324999976],
              [28.827159871000106, -28.759277037999908],
              [28.7959473060001, -28.754316100999873],
              [28.787679077000064, -28.748735045999936],
              [28.75863692200008, -28.700469257999927],
              [28.74385746200005, -28.689513854999944],
              [28.699519083000013, -28.68848032599996],
              [28.688977092000044, -28.674424336999948],
              [28.681742391000085, -28.633393249999912],
              [28.675644572000124, -28.61375620499996],
              [28.666549520000046, -28.59721974699997],
              [28.653217, -28.583060403999923],
              [28.634303426000088, -28.570761413999975],
              [28.619420614000063, -28.572415058999937],
              [28.562473185000073, -28.6065215039999],
              [28.542629435000094, -28.610758971999957],
              [28.40341312700005, -28.61892384899997],
              [28.38294926000009, -28.626468607999925],
              [28.363518921000036, -28.643625182999884],
              [28.33644047000007, -28.684656269999934],
              [28.317216837000046, -28.700055846999916],
              [28.29706302900007, -28.70687713599996],
              [28.273911987000076, -28.70956431099991],
              [28.250864298000096, -28.707393899999914],
              [28.230710490000035, -28.699539082999976],
              [28.218116094000067, -28.700652075999955],
              [28.164047892000042, -28.705430195999966],
              [28.154952840000135, -28.702329609999936],
              [28.145030965000046, -28.7147319539999],
              [28.13169844500004, -28.729304707999873],
              [28.104103231000124, -28.765064798999973],
              [28.100899292000065, -28.770852559999952],
              [28.056560913000112, -28.81250376399997],
              [28.018733765000036, -28.856842142999923],
              [28.01449629700008, -28.86480031399988],
              [28.014806355000076, -28.872551777999973],
              [28.013566121000053, -28.878442890999892],
              [28.00467777500012, -28.880716655],
              [27.977495972000042, -28.880716655],
              [27.96623050900007, -28.875652363999933],
              [27.956928751000135, -28.86511037199996],
              [27.945043173000016, -28.855498555999944],
              [27.926232951000117, -28.853431497999892],
              [27.91166019700006, -28.86076955099989],
              [27.903598673000147, -28.873998717999967],
              [27.89729414900006, -28.889811705999975],
              [27.887992391000125, -28.904901224999975],
              [27.861327352000075, -28.915443216999932],
              [27.747432495000112, -28.908621927999974],
              [27.754770549000114, -28.925468444999964],
              [27.744073527000097, -28.93321990899996],
              [27.72831221500013, -28.937974140999955],
              [27.720147339000107, -28.945932311999925],
              [27.720043986000093, -28.959781594999896],
              [27.71901045700011, -28.967843118999966],
              [27.716685018000078, -28.973217468999934],
              [27.71446293100007, -28.976421406999904],
              [27.71337772600006, -28.97952199299995],
              [27.713326049000074, -28.986860045999947],
              [27.711672404000097, -28.99099416099996],
              [27.707641642000112, -28.99068410199989],
              [27.70288741100012, -28.989340514999924],
              [27.699063355000078, -28.99058074999995],
              [27.679736369000125, -29.015075377999906],
              [27.6674890540001, -29.026650898999947],
              [27.655035034000036, -29.031508483999886],
              [27.639170369000112, -29.035332539999914],
              [27.643769572000053, -29.04453094499992],
              [27.65627526800006, -29.055796406999974],
              [27.664956909000125, -29.065718281999878],
              [27.65860070800008, -29.06675181099986],
              [27.649350626000086, -29.070885925999875],
              [27.644389689000036, -29.072539570999922],
              [27.63751672400005, -29.065718281999878],
              [27.63074711100012, -29.072539570999922],
              [27.634479067000086, -29.091040540999927],
              [27.635604696000144, -29.096620788999957],
              [27.61297041800009, -29.13382781999988],
              [27.55571293200012, -29.19542612699992],
              [27.548478231000075, -29.19894012499988],
              [27.538246297000086, -29.202350768999892],
              [27.52816939300004, -29.207621764999928],
              [27.521503133000124, -29.216510110999934],
              [27.5209863690001, -29.226121927999955],
              [27.5272392170001, -29.24937632299988],
              [27.52889286300004, -29.260951842999916],
              [27.518919311000047, -29.268393248999942],
              [27.510686378000088, -29.270752951999953],
              [27.4698783770001, -29.28244923899986],
              [27.45329024300011, -29.291647643999866],
              [27.45029300900009, -29.299709166999946],
              [27.448329305000073, -29.322963561999956],
              [27.445848837000085, -29.331955260999905],
              [27.436133667000036, -29.34353078199986],
              [27.426831909000015, -29.347974954999955],
              [27.417633504000037, -29.35066212999989],
              [27.408641805000087, -29.357070006999933],
              [27.406264689000125, -29.36399464999991],
              [27.41029545100011, -29.369782408999896],
              [27.416186564000043, -29.37598358199996],
              [27.419080444000116, -29.383838398999913],
              [27.417633504000037, -29.39655080199995],
              [27.413706095000066, -29.402545267999898],
              [27.407091512000136, -29.40688608799988],
              [27.36554366000007, -29.44667694099988],
              [27.35448490400006, -29.462283222999915],
              [27.350247436000103, -29.480266621999903],
              [27.344873088000043, -29.48450408999996],
              [27.32141198700006, -29.483573913999905],
              [27.316037638000097, -29.48719126399989],
              [27.314073934000078, -29.498663430999912],
              [27.309112996000124, -29.50920542399996],
              [27.302498413000137, -29.51809376999998],
              [27.300306527000146, -29.520119603999902],
              [27.295677124000093, -29.524398294999898],
              [27.263120972000138, -29.54114145999995],
              [27.241830281000148, -29.548996276999972],
              [27.213718302000103, -29.554060566999866],
              [27.195838257000048, -29.56263885499989],
              [27.1857096760001, -29.565946145999888],
              [27.15635746300012, -29.568633320999922],
              [27.12814213000007, -29.57855519599991],
              [27.122767782000096, -29.581759134999885],
              [27.09041833500001, -29.611628112999895],
              [27.085870809000085, -29.614418639999954],
              [27.07770593200007, -29.61131805399991],
              [27.07512211100007, -29.605116882999923],
              [27.07202152500011, -29.599949238999926],
              [27.062203002000047, -29.600155944999884],
              [27.05682865400007, -29.604393411999936],
              [27.0491805420001, -29.620516458999916],
              [27.042359253000143, -29.628061218999875],
              [27.032954142000108, -29.616175638999934],
              [27.022412150000036, -29.616175638999934],
              [27.01486739100008, -29.625580749999898],
              [27.01445398000007, -29.64170379599996],
              [27.002154989000132, -29.666508483999905],
              [27.010216512000113, -29.669919127999933],
              [27.024530884000114, -29.68004770899998],
              [27.037656698000063, -29.686455586999926],
              [27.050989217000108, -29.69679087399993],
              [27.080134725000107, -29.735134785999946],
              [27.088661336000115, -29.750017598999904],
              [27.088661336000115, -29.75012095099993],
              [27.088764690000062, -29.75012095099993],
              [27.171350065000098, -29.92149529799991],
              [27.19883549000008, -29.97853078199998],
              [27.21795577000006, -29.9980644729999],
              [27.265911499000083, -30.03330780099988],
              [27.280174194000068, -30.05346160799995],
              [27.29371341900014, -30.100900573999937],
              [27.300431356000075, -30.114956562999865],
              [27.312782023000125, -30.131596373999884],
              [27.32203210400013, -30.134800312999943],
              [27.33443444800011, -30.13221649199994],
              [27.356655314000136, -30.13221649199994],
              [27.371951538000104, -30.135937194999954],
              [27.381356649000054, -30.142655130999884],
              [27.380529825000053, -30.152577005999973],
              [27.36554366000007, -30.16580617299988],
              [27.343684529000114, -30.212935078999877],
              [27.345544881000137, -30.241563821999947],
              [27.367817424000094, -30.295410664999892],
              [27.366163778000043, -30.311016946999928],
              [27.377015829000072, -30.31215382899994],
              [27.37770772900012, -30.31232376899996],
              [27.397634725000074, -30.317218118999918],
              [27.407814982000048, -30.318561705999883],
              [27.414842977000063, -30.3175281769999],
              [27.436030314000107, -30.30988006599992],
              [27.45210168400007, -30.310086770999973],
              [27.459388062000073, -30.316598001999935],
              [27.466726115000142, -30.341092630999896],
              [27.47747481300007, -30.35628550199992],
              [27.493184448000136, -30.367654316999918],
              [27.529668009000147, -30.382227070999974],
              [27.53336382400005, -30.393424839999923],
              [27.536592651000035, -30.403207701999875],
              [27.56274092600006, -30.425531920999944],
              [27.58682214400008, -30.45498748699994],
              [27.59012943500008, -30.463875833999865],
              [27.590646200000037, -30.4728675329999],
              [27.59229984500007, -30.481859232999938],
              [27.59860437000009, -30.490334167999947],
              [27.65953088300006, -30.53053843199997],
              [27.71353275600012, -30.58376515699993],
              [27.7436084390001, -30.60030161499992],
              [27.77843835400006, -30.60970672599997],
              [27.820399617000135, -30.61456431099991],
              [27.830424846000085, -30.613117370999916],
              [27.849545125000077, -30.60495249399989],
              [27.858226766000115, -30.603712259999952],
              [27.869802287000084, -30.607122904999883],
              [27.878277221000076, -30.612910663999955],
              [27.88613204000012, -30.619731953999903],
              [27.895640503000095, -30.626243183999875],
              [27.915587606000116, -30.634924824999928],
              [27.93656823800012, -30.640815938999935],
              [28.054700562000107, -30.64970428499994],
              [28.078781779000053, -30.658799335999916],
              [28.07898848500011, -30.63926564499991],
              [28.076508016000048, -30.62324595099996],
              [28.075836223000067, -30.607019551999954],
              [28.081572306000112, -30.586865742999876],
              [28.088031861000076, -30.57756398499994],
              [28.096351766000026, -30.572396341999948],
              [28.104878378000137, -30.56836557999995],
              [28.112836548000104, -30.562474466999944],
              [28.120846394000097, -30.553379414999966],
              [28.1242570390001, -30.54728159599992],
              [28.14120690900012, -30.500772805999887],
              [28.14244714300014, -30.492607930999966],
              [28.13924320500007, -30.48268605499996],
              [28.127564331000116, -30.465116068999905],
              [28.125393921000125, -30.457261250999963],
              [28.133248739000067, -30.445375670999937],
              [28.21820479300004, -30.387394713999882],
              [28.231433960000118, -30.373855488999908],
              [28.238461955000048, -30.352254739999935],
              [28.2357747800001, -30.329413756999926],
              [28.22409590700005, -30.320525410999906],
              [28.209419800000063, -30.314634297999916],
              [28.198464396000077, -30.301095072999928],
              [28.200634807000057, -30.282491555999883],
              [28.216034383000135, -30.267402038999975],
              [28.237015015000054, -30.25634328199996],
              [28.25530847200011, -30.249935403999928],
              [28.284712362000107, -30.246214700999914],
              [28.294375854000123, -30.242493997999915],
              [28.301300496000124, -30.236499531999883],
              [28.313702840000076, -30.220789895999914],
              [28.323004598000097, -30.214692076999953],
              [28.338662557000077, -30.20104949999994],
              [28.355596048000052, -30.173240026999892],
              [28.364087362000078, -30.159294941999903],
              [28.383879436000143, -30.144205423999907],
              [28.40796065300009, -30.140898131999904],
              [28.456226441000098, -30.14699595099995],
              [28.48092777500011, -30.139347839999886],
              [28.524335978000124, -30.11671356199993],
              [28.54056237700013, -30.113302916999913],
              [28.55730554200008, -30.114956562999865],
              [28.605881389000075, -30.1312863159999],
              [28.639677775000052, -30.13149302099994],
              [28.72949141400005, -30.10183074999989],
              [28.795637248000048, -30.08942840499992],
              [28.86002608200002, -30.06638071699996],
              [28.976298055000115, -29.99992482499991],
              [29.01578602900011, -29.97858746299997],
              [29.094120321000048, -29.936259459999903],
              [29.106315959000142, -29.931505227999907],
              [29.132774292000136, -29.924683939999866],
              [29.144246460000147, -29.919723002999916],
              [29.150654337000077, -29.91114471399989],
              [29.148277221000058, -29.901326191999914],
              [29.13732181800006, -29.88210255899989],
              [29.13515140800007, -29.86804656999996],
              [29.135771525000052, -29.85915822299995],
              [29.13298099800008, -29.852026874999922],
              [29.12037194800007, -29.843448587999973],
              [29.1057991940001, -29.825568541999928],
              [29.106315959000142, -29.80159067799991],
              [29.11231042500006, -29.775132344999918],
              [29.113599444000045, -29.752850734999924],
              [29.113757365000055, -29.75012095099993],
              [29.132412557000123, -29.720251972999918],
              [29.145073283000073, -29.69193328899992],
              [29.161299682000077, -29.666921894999916],
              [29.190341837000062, -29.646871438999966],
              [29.2673397210001, -29.626097513999923],
              [29.27860518400007, -29.613591817999932],
              [29.2783984780001, -29.59705535899994],
              [29.279948771000136, -29.581449075999984],
              [29.29627852400006, -29.571630553999924],
              [29.282015828000056, -29.556127623999913],
              [29.275142863000042, -29.532253112999925],
              [29.27519872500011, -29.52829489199989],
              [29.27550459800011, -29.506621601999967],
              [29.28273929800008, -29.485640970999967],
              [29.30382328200011, -29.466830749999957],
              [29.3320386150001, -29.455978698999914],
              [29.361804240000083, -29.447917174999915],
              [29.388159220000034, -29.437788594999873],
              [29.399528036000106, -29.430347188999946],
              [29.4078996180001, -29.42145884199992],
              [29.41255049700004, -29.410296732999896],
              [29.41187870300007, -29.395827330999865],
              [29.413739054000075, -29.380117695999985],
              [29.432239217000074, -29.35696665499991],
              [29.435908244000075, -29.342393900999937],
              [29.43280765700007, -29.336606139999972],
              [29.419475138000053, -29.325030618999932],
              [29.415030965000142, -29.31893279999987],
              [29.413997437000035, -29.311698098999912],
              [29.41492761300009, -29.296401875999948],
              [29.413997437000035, -29.290304056999986],
              [29.4038688550001, -29.268703307999928],
              [29.37596358200011, -29.235527037999915],
              [29.36500817800004, -29.20028371199993],
              [29.3574634200001, -29.183333841999925],
              [29.34371748900014, -29.16979461699995],
              [29.328059530000075, -29.15935597699992],
              [29.316845744000148, -29.147367044999953],
              [29.311781453000094, -29.08979949899991],
              [29.28139571100013, -29.078637389999884],
              [29.241398153000034, -29.07770721399993],
              [29.208428589000107, -29.068922220999937],
              [29.12595300300009, -28.992441100999955],
              [29.091536499000114, -28.978591816999895],
              [29.06900557500009, -28.97332082099996],
              [29.0557764080001, -28.965362649999904],
              [29.049988647000134, -28.952650248999944],
              [29.049678589000052, -28.93301320399992],
              [29.040531861000062, -28.922987975999987],
              [29.018982788000102, -28.91399627599995],
              [28.995418335000096, -28.908311868999903],
              [28.980845581000068, -28.909035338999985],
            ],
          ],
          [
            [
              [37.662445509000065, -46.82854583099993],
              [37.69483483200008, -46.8220354149999],
              [37.728526238000086, -46.825290622999944],
              [37.821055535000085, -46.84417083099993],
              [37.86841881600009, -46.88209400799991],
              [37.89576256600009, -46.88990650799991],
              [37.88493899800005, -46.91643645599993],
              [37.86378014400009, -46.94085051899992],
              [37.83643639400009, -46.95867278399993],
              [37.80648847700007, -46.96575286299992],
              [37.79810631600009, -46.96453215899993],
              [37.78109785200007, -46.95940520599993],
              [37.67017662900008, -46.95598723799992],
              [37.655039910000085, -46.95826588299991],
              [37.61882571700005, -46.95435963299991],
              [37.60206139400009, -46.94866301899992],
              [37.58741295700008, -46.93840911299992],
              [37.58253014400009, -46.930759372999944],
              [37.57667076900009, -46.91676197699991],
              [37.57536868600005, -46.90349700299993],
              [37.59359785200007, -46.89202239399992],
              [37.61540774800005, -46.86874765399995],
              [37.62484785200007, -46.86337655999995],
              [37.63111412900008, -46.85857512799993],
              [37.652354363000086, -46.83611419099992],
              [37.662445509000065, -46.82854583099993],
            ],
          ],
          [
            [
              [37.86109459700009, -46.63616301899992],
              [37.86491946700005, -46.61419036299992],
              [37.900401238000086, -46.59970468499995],
              [37.94556725400008, -46.598321221999925],
              [37.97779381600009, -46.61565520599993],
              [37.97641035200007, -46.64470794099992],
              [37.93864993600005, -46.65439218499995],
              [37.89112389400009, -46.64967213299991],
              [37.86109459700009, -46.63616301899992],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Libya',
        iso3: 'LBY',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [11.505111803000148, 33.18122531500005],
            [11.525889519000089, 33.176947333000044],
            [11.56023196700005, 33.16592031500005],
            [11.574961785000085, 33.15794505400004],
            [11.58765709700009, 33.13231028900009],
            [11.603037957000083, 33.12148672100005],
            [11.635752800000091, 33.108710028000075],
            [11.756602410000085, 33.09251536700009],
            [11.793467644000089, 33.08075592700004],
            [11.772959832000083, 33.09935130400004],
            [11.707774285000085, 33.117173570000034],
            [11.69109134200005, 33.135972398000035],
            [11.739268425000091, 33.112982489000046],
            [11.84701582100007, 33.08283112200007],
            [12.080739780000044, 32.95783112200007],
            [12.12240644600007, 32.92133209800005],
            [12.160655144000089, 32.91168854400007],
            [12.224864129000082, 32.87592194200005],
            [12.303884311000047, 32.843085028000075],
            [12.348317905000044, 32.83266836100006],
            [12.72982832100007, 32.79857005400004],
            [12.824392123000052, 32.804348049000055],
            [13.074473504000082, 32.86635976800005],
            [13.115489129000082, 32.882147528000075],
            [13.147715691000087, 32.903998114000046],
            [13.164724155000044, 32.91274648600006],
            [13.187754754000082, 32.91624583500004],
            [13.257090691000087, 32.91864655200004],
            [13.351735873000052, 32.90424225500004],
            [13.363129102000073, 32.89956289300005],
            [13.373545769000089, 32.89203522300005],
            [13.571462436000047, 32.802801825000074],
            [13.61695397200009, 32.793402411000045],
            [13.787119988000086, 32.79962799700007],
            [13.830332879000082, 32.79409414300005],
            [13.915293816000087, 32.772772528000075],
            [13.991221550000091, 32.744574286000045],
            [14.17554772200009, 32.717678127000056],
            [14.18531334700009, 32.714504299000055],
            [14.203379754000082, 32.70034414300005],
            [14.209320509000065, 32.69721100500004],
            [14.22632897200009, 32.69090403900009],
            [14.262461785000085, 32.66030508000006],
            [14.317149285000085, 32.63043854400007],
            [14.40406334700009, 32.566839911000045],
            [14.449392123000052, 32.525376695000034],
            [14.469493035000085, 32.51902903900009],
            [14.631602410000085, 32.49567291900007],
            [14.647634311000047, 32.488267320000034],
            [14.662933790000068, 32.47675202000005],
            [14.70671634200005, 32.456284898000035],
            [14.726817254000082, 32.45075104400007],
            [14.911143425000091, 32.44391510600008],
            [15.114756707000083, 32.41278717700004],
            [15.160004102000073, 32.39866771000004],
            [15.181976759000065, 32.39549388200004],
            [15.195974155000044, 32.38979726800005],
            [15.233246290000068, 32.34711334800005],
            [15.269704623000052, 32.32884349200009],
            [15.283050977000073, 32.317287502000056],
            [15.292165561000047, 32.280910549000055],
            [15.300791863000086, 32.26080963700008],
            [15.322601759000065, 32.22418854400007],
            [15.364512566000087, 32.174709377000056],
            [15.37045332100007, 32.159084377000056],
            [15.368662957000083, 32.138006903000075],
            [15.359629754000082, 32.10211823100008],
            [15.356862826000054, 32.06167226800005],
            [15.35523522200009, 32.03851959800005],
            [15.36109459700009, 31.965318101000037],
            [15.37045332100007, 31.929388739000046],
            [15.490407748000052, 31.664862372000073],
            [15.514414910000085, 31.62836334800005],
            [15.62281334700009, 31.497259833000044],
            [15.687510613000086, 31.43781159100007],
            [15.76148522200009, 31.38812897300005],
            [16.04460696700005, 31.275539455000057],
            [16.358653191000087, 31.227118231000077],
            [16.728037957000083, 31.223822333000044],
            [16.94190514400009, 31.183294989000046],
            [17.160329623000052, 31.118801174000055],
            [17.33057701900009, 31.086493231000077],
            [17.365896030000044, 31.08661530200004],
            [17.375010613000086, 31.08307526200008],
            [17.382009311000047, 31.07876211100006],
            [17.418630405000044, 31.062160549000055],
            [17.447276238000086, 31.038723049000055],
            [17.457774285000085, 31.033351955000057],
            [17.466807488000086, 31.02997467700004],
            [17.613942905000044, 30.99249909100007],
            [17.691742384000065, 30.95966217700004],
            [17.776052280000044, 30.935207424000055],
            [17.84864342500009, 30.923651434000078],
            [17.861664259000065, 30.91364166900007],
            [17.88917076900009, 30.87791575700004],
            [17.907481316000087, 30.86351146000004],
            [17.92676842500009, 30.855169989000046],
            [18.016856316000087, 30.837876695000034],
            [18.175303582000083, 30.786078192000048],
            [18.20834394600007, 30.769232489000046],
            [18.23568769600007, 30.74681224200009],
            [18.324229363000086, 30.65688711100006],
            [18.568369988000086, 30.500067450000074],
            [18.623301629000082, 30.445746161000045],
            [18.653168165000068, 30.422308661000045],
            [18.71924889400009, 30.391506252000056],
            [18.760996941000087, 30.38422272300005],
            [18.780528191000087, 30.375921942000048],
            [18.925954623000052, 30.293361721000053],
            [18.968028191000087, 30.277736721000053],
            [19.056813998000052, 30.266180731000077],
            [19.146006707000083, 30.26471588700008],
            [19.239756707000083, 30.273993231000077],
            [19.291677280000044, 30.287054755000042],
            [19.338552280000044, 30.298814195000034],
            [19.41895592500009, 30.333238023000035],
            [19.530528191000087, 30.39679596600007],
            [19.551036004000082, 30.40493398600006],
            [19.596039259000065, 30.41201406500005],
            [19.616384311000047, 30.42137278900009],
            [19.748871290000068, 30.510931708000044],
            [19.914317254000082, 30.682928778000075],
            [19.958181186000047, 30.749701239000046],
            [19.98218834700009, 30.778631903000075],
            [20.018728061000047, 30.80377838700008],
            [20.03646894600007, 30.81907786700009],
            [20.099864129000082, 30.93500397300005],
            [20.146657748000052, 31.04555898600006],
            [20.152354363000086, 31.08820221600007],
            [20.146657748000052, 31.216782945000034],
            [20.128103061000047, 31.242987372000073],
            [20.10328209700009, 31.308742580000057],
            [20.082204623000052, 31.33661530200004],
            [20.038340691000087, 31.375881252000056],
            [20.022227410000085, 31.39679596600007],
            [19.95484459700009, 31.559475002000056],
            [19.94890384200005, 31.60101959800005],
            [19.948008660000085, 31.645086981000077],
            [19.94434655000009, 31.661444403000075],
            [19.926931186000047, 31.699164130000042],
            [19.920664910000085, 31.717718817000048],
            [19.917246941000087, 31.75922272300005],
            [19.91968834700009, 31.804673570000034],
            [19.934336785000085, 31.888413804000038],
            [19.948008660000085, 31.92597077000005],
            [19.94581139400009, 31.935980536000045],
            [19.941742384000065, 31.946926174000055],
            [19.940114780000044, 31.95774974200009],
            [19.944590691000087, 31.96751536700009],
            [19.957204623000052, 31.98273346600007],
            [20.048024936000047, 32.14606354400007],
            [20.071543816000087, 32.17641836100006],
            [20.261729363000086, 32.339544989000046],
            [20.277191602000073, 32.36082591400009],
            [20.325450066000087, 32.409816799000055],
            [20.345713738000086, 32.419907945000034],
            [20.385508660000085, 32.43463776200008],
            [20.40333092500009, 32.447333075000074],
            [20.416758660000085, 32.45945872600004],
            [20.562673373000052, 32.557847398000035],
            [20.79656009200005, 32.643011786000045],
            [20.93409264400009, 32.72260163000004],
            [21.050954623000052, 32.77228424700007],
            [21.09669030000009, 32.78107330900008],
            [21.28679446700005, 32.771144924000055],
            [21.331879102000073, 32.774644273000035],
            [21.414805535000085, 32.793402411000045],
            [21.454600457000083, 32.812567450000074],
            [21.608653191000087, 32.93073151200008],
            [21.623220248000052, 32.936753648000035],
            [21.671722852000073, 32.939886786000045],
            [21.716319207000083, 32.950384833000044],
            [21.743662957000083, 32.930853583000044],
            [21.787445509000065, 32.91596100500004],
            [21.836110873000052, 32.90656159100007],
            [21.87745201900009, 32.903225002000056],
            [22.09620201900009, 32.923081773000035],
            [22.10132897200009, 32.92641836100006],
            [22.11182701900009, 32.94090403900009],
            [22.116709832000083, 32.94415924700007],
            [22.138845248000052, 32.94757721600007],
            [22.149587436000047, 32.94794342700004],
            [22.161387566000087, 32.94415924700007],
            [22.169444207000083, 32.93821849200009],
            [22.171071811000047, 32.932928778000075],
            [22.171071811000047, 32.92625560100004],
            [22.175059441000087, 32.91624583500004],
            [22.20679772200009, 32.88812897300005],
            [22.247325066000087, 32.880845445000034],
            [22.33961022200009, 32.882147528000075],
            [22.379161004000082, 32.870347398000035],
            [22.477305535000085, 32.807074286000045],
            [22.496755405000044, 32.797308661000045],
            [22.513845248000052, 32.79096100500004],
            [22.53223717500009, 32.787543036000045],
            [22.578868035000085, 32.78461334800005],
            [22.812510613000086, 32.72451406500005],
            [22.866709832000083, 32.69415924700007],
            [22.88453209700009, 32.68976471600007],
            [22.89584394600007, 32.68817780200004],
            [22.929209832000083, 32.67670319200005],
            [22.942637566000087, 32.675034898000035],
            [22.976898634000065, 32.67670319200005],
            [22.99968509200005, 32.67055898600006],
            [23.041351759000065, 32.65253327000005],
            [23.08643639400009, 32.646470445000034],
            [23.106130405000044, 32.639837958000044],
            [23.118662957000083, 32.629339911000045],
            [23.120941602000073, 32.615220445000034],
            [23.115244988000086, 32.60492584800005],
            [23.097911004000082, 32.58665599200009],
            [23.094411655000044, 32.577378648000035],
            [23.103851759000065, 32.51634349200009],
            [23.113291863000086, 32.50079987200007],
            [23.12867272200009, 32.48847077000005],
            [23.14893639400009, 32.47809479400007],
            [23.140961134000065, 32.45856354400007],
            [23.128428582000083, 32.39549388200004],
            [23.108653191000087, 32.402329820000034],
            [23.112152540000068, 32.41193268400008],
            [23.10987389400009, 32.42031484600005],
            [23.103363477000073, 32.428168036000045],
            [23.094411655000044, 32.43646881700005],
            [23.07911217500009, 32.35443756700005],
            [23.08057701900009, 32.334051825000074],
            [23.095550977000073, 32.323553778000075],
            [23.156504754000082, 32.30353424700007],
            [23.178965691000087, 32.29995351800005],
            [23.19507897200009, 32.29165273600006],
            [23.21452884200005, 32.27240631700005],
            [23.230804884000065, 32.25063711100006],
            [23.24350019600007, 32.22060781500005],
            [23.257334832000083, 32.213771877000056],
            [23.27320397200009, 32.20970286700009],
            [23.285411004000082, 32.20376211100006],
            [23.293223504000082, 32.19232819200005],
            [23.30250084700009, 32.17072174700007],
            [23.31218509200005, 32.16274648600006],
            [23.310394727000073, 32.17926666900007],
            [23.299082879000082, 32.22418854400007],
            [23.318369988000086, 32.21784088700008],
            [23.361989780000044, 32.21710846600007],
            [23.37086022200009, 32.21401601800005],
            [23.39893639400009, 32.19403717700004],
            [23.40528405000009, 32.190659898000035],
            [23.531097852000073, 32.18138255400004],
            [23.66968834700009, 32.183254299000055],
            [23.84034264400009, 32.14911530200004],
            [23.998708530000044, 32.09389883000006],
            [23.975271030000044, 32.074204820000034],
            [23.970713738000086, 32.06659577000005],
            [23.978770379000082, 32.06224192900004],
            [24.00489342500009, 32.05292389500005],
            [24.067881707000083, 32.01117584800005],
            [24.090668165000068, 32.00576406500005],
            [24.28093509200005, 32.00755442900004],
            [24.546071811000047, 31.991441148000035],
            [24.636241082000083, 32.014878648000035],
            [24.658539259000065, 32.028631903000075],
            [24.670258009000065, 32.032416083000044],
            [24.71062259200005, 32.02558014500005],
            [24.718597852000073, 32.02753327000005],
            [24.72632897200009, 32.031317450000074],
            [24.73373457100007, 32.03314850500004],
            [24.74187259200005, 32.028998114000046],
            [24.74586022200009, 32.02619049700007],
            [24.758067254000082, 32.019964911000045],
            [24.77198326900009, 32.01675039300005],
            [24.791758660000085, 32.00775788000004],
            [24.824392123000052, 32.00299713700008],
            [24.865407748000052, 31.98932526200008],
            [24.981700066000087, 31.967922268000052],
            [25.017914259000065, 31.949042059000078],
            [25.033376498000052, 31.91632721600007],
            [25.02442467500009, 31.876613674000055],
            [25.022227410000085, 31.854681708000044],
            [25.029551629000082, 31.83690013200004],
            [25.063731316000087, 31.80410390800006],
            [25.11687259200005, 31.737982489000046],
            [25.12208092500009, 31.720851955000057],
            [25.136729363000086, 31.692572333000044],
            [25.156260613000086, 31.66307200700004],
            [25.152517123000052, 31.659816799000055],
            [25.15088951900009, 31.656480210000026],
            [25.08842167100005, 31.613523661000087],
            [25.060413045000132, 31.579365539000023],
            [25.023722778000064, 31.49440948500002],
            [24.86125207500004, 31.38035959900013],
            [24.8489530840001, 31.348630270000015],
            [24.848643025000115, 31.312043355000085],
            [24.85856490000009, 31.227914124],
            [24.859495076000144, 31.145955303000036],
            [24.88264611800014, 31.039088440000015],
            [24.88957076000011, 31.018831279000025],
            [24.924607381000044, 30.95676788300004],
            [24.937629842000092, 30.905763245000074],
            [24.981244751000133, 30.825406392000062],
            [24.99488732900005, 30.785098776],
            [24.988582804000117, 30.75057891900012],
            [24.97359663900005, 30.7162657680001],
            [24.961194296000087, 30.676268210000032],
            [24.950652303000112, 30.621232808000073],
            [24.920369914000105, 30.55234812500005],
            [24.91706262200009, 30.532452698000057],
            [24.90765751100014, 30.49865631200008],
            [24.888123820000118, 30.46434316000004],
            [24.829729452000066, 30.38755198200009],
            [24.799447062000127, 30.360835266000024],
            [24.772368612000093, 30.331017965000015],
            [24.7628601480001, 30.317065328000027],
            [24.74611698400014, 30.28275217700009],
            [24.70467248500009, 30.217898254000076],
            [24.68865279200014, 30.182758280000044],
            [24.688342732000137, 30.144155986000058],
            [24.697334432000105, 30.122606913000098],
            [24.72554976400005, 30.078371888000063],
            [24.811642701000068, 29.89088979100005],
            [24.81619022600009, 29.868410543000024],
            [24.814949992000066, 29.84856679300013],
            [24.798206827000087, 29.796425273000082],
            [24.804924764000134, 29.75479990700005],
            [24.85618778400007, 29.6794815060001],
            [24.870657185000084, 29.638347066000037],
            [24.870553833000145, 29.614007467000093],
            [24.86156213400011, 29.54155710900004],
            [24.86383589700003, 29.502903137000104],
            [24.87375777200012, 29.468331604000028],
            [24.956646769000145, 29.292683411],
            [24.974320109000047, 29.238939922],
            [24.981244751000133, 29.181372376000056],
            [24.981244751000133, 29.057917379000017],
            [24.981244751000133, 28.89017568000004],
            [24.981244751000133, 28.49154368100004],
            [24.981244751000133, 28.096700613000067],
            [24.981244751000133, 28.018549296000018],
            [24.981244751000133, 27.666502794000067],
            [24.981244751000133, 27.627823792000058],
            [24.981244751000133, 27.475455831000048],
            [24.981244751000133, 27.138034567000076],
            [24.981244751000133, 27.04923943200005],
            [24.981244751000133, 26.859963685000096],
            [24.981244751000133, 26.66452341800003],
            [24.981244751000133, 26.37270660400013],
            [24.981244751000133, 26.08083811500002],
            [24.981244751000133, 25.788969625000036],
            [24.981244751000133, 25.497256165000053],
            [24.981244751000133, 25.205439352000056],
            [24.981244751000133, 24.91357086200007],
            [24.981244751000133, 24.621728211000075],
            [24.981244751000133, 24.329963074000105],
            [24.981244751000133, 24.038146261000108],
            [24.981244751000133, 23.74627777100001],
            [24.981244751000133, 23.4544351200001],
            [24.981244751000133, 23.162669983000043],
            [24.981244751000133, 22.870801494000133],
            [24.981244751000133, 22.578984680000033],
            [24.981244751000133, 22.287167867000065],
            [24.981244751000133, 21.995351054000068],
            [24.981244751000133, 21.870810852000133],
            [24.98114139800009, 21.74616729800006],
            [24.98114139800009, 21.62157541900011],
            [24.98114139800009, 21.49703521800008],
            [24.98114139800009, 21.3724433390001],
            [24.981038045000076, 21.247851461000053],
            [24.980934692000062, 21.123311260000023],
            [24.980934692000062, 20.998719381000072],
            [24.980934692000062, 20.874127503000025],
            [24.980831340000123, 20.749535624000075],
            [24.980831340000123, 20.624943746000028],
            [24.980831340000123, 20.500351868000067],
            [24.98072798700008, 20.40531890900006],
            [24.980624634000065, 20.310234273],
            [24.980624634000065, 20.21509796200006],
            [24.98052128100005, 20.120013326000034],
            [24.98052128100005, 20.00839082700007],
            [24.98052128100005, 20.002061870000077],
            [24.979591105000083, 20.00051157600005],
            [24.97866092900003, 19.99901296000006],
            [24.97773075300009, 19.997462667000022],
            [24.976800578000024, 19.995964050000012],
            [24.974526815000104, 19.99565399200013],
            [24.972356405000113, 19.995421448000073],
            [24.970185994000133, 19.995188904000102],
            [24.968015584000057, 19.994956360000046],
            [24.867246542000146, 19.994956360000046],
            [24.72131229700011, 19.99503387500006],
            [24.59914921000012, 19.99505971300006],
            [24.47460900900009, 19.995188904000102],
            [24.340870402000036, 19.99529225700003],
            [24.22790572100004, 19.99531809500006],
            [24.14243290200011, 19.995421448000073],
            [23.981305786000036, 19.995421448000073],
            [23.981305786000036, 19.870597025000066],
            [23.981305786000036, 19.745824280000065],
            [23.981305786000036, 19.621025696000046],
            [23.981305786000036, 19.496123759000014],
            [23.857799113000084, 19.5571794640001],
            [23.734292440000047, 19.61813181600006],
            [23.610785767000067, 19.67911000600013],
            [23.487279093000012, 19.740165710000028],
            [23.363772420000146, 19.801169739],
            [23.240162394000066, 19.862096253000047],
            [23.11675907400013, 19.923151958000048],
            [22.993149047000145, 19.984104309000102],
            [22.869642375000097, 20.045108338000077],
            [22.746135702000032, 20.106060690000035],
            [22.62262902800009, 20.16709055600002],
            [22.49912235500011, 20.22809458400009],
            [22.375615682000074, 20.289124451000063],
            [22.252109009, 20.35007680300005],
            [22.128602335000068, 20.411054992000103],
            [22.005095662000087, 20.47203318300008],
            [21.88148563700011, 20.533063049000063],
            [21.75808231600007, 20.593989563000022],
            [21.634472290000105, 20.654967754000083],
            [21.510965617000124, 20.716049296000065],
            [21.387458944000088, 20.77702748600005],
            [21.263952270000118, 20.838005677000112],
            [21.140342244000124, 20.899035543000096],
            [21.0169389240001, 20.959962057000055],
            [20.893328898000107, 21.020940247000013],
            [20.769925578000084, 21.081970113000082],
            [20.646418904000114, 21.14289662700004],
            [20.522808879000138, 21.203926493000026],
            [20.399405558000126, 21.265008036000026],
            [20.27579553200013, 21.32593455000007],
            [20.152288859000066, 21.386912741000046],
            [20.028782186000115, 21.44794260700003],
            [19.90527551300005, 21.508869121000075],
            [19.781665486000065, 21.56989898700006],
            [19.658262166000043, 21.630877178000034],
            [19.53465214000005, 21.691855367000088],
            [19.411145467000097, 21.75288523400009],
            [19.287638793000042, 21.813915100000074],
            [19.185837030000073, 21.864177059000056],
            [19.16413212100008, 21.87489329000003],
            [19.040728801000057, 21.935871481],
            [18.917118774000073, 21.996849671000078],
            [18.79361210100012, 22.057879537000062],
            [18.670105428000056, 22.11880605100002],
            [18.546598755000105, 22.17983591700009],
            [18.42298872800012, 22.240865784000064],
            [18.29958540800007, 22.30184397400005],
            [18.175975383000093, 22.36282216500011],
            [18.05246870900004, 22.423852031000095],
            [17.928962036000087, 22.484778545000054],
            [17.805455363000107, 22.545756734000022],
            [17.68194869000007, 22.60678660100008],
            [17.5584420160001, 22.667764791000067],
            [17.434831991000124, 22.72879465800004],
            [17.3114286710001, 22.789798686000026],
            [17.187921997000046, 22.85075103800007],
            [17.064311971000052, 22.911755067000072],
            [16.94090865000004, 22.972733256000126],
            [16.81729862500012, 23.033659770000085],
            [16.693791951000065, 23.09466379900006],
            [16.570285278000114, 23.155719503000043],
            [16.446778605000077, 23.216723532000017],
            [16.323168579000082, 23.277727560000088],
            [16.19976525900006, 23.338705750000074],
            [16.076155233000065, 23.399632264000033],
            [15.985101359000112, 23.444719951000067],
            [15.964637492000065, 23.44221364400009],
            [15.920195760000098, 23.4220339970001],
            [15.862524862000015, 23.395937398000015],
            [15.804853963000141, 23.369789124000093],
            [15.747183064000069, 23.34364084900001],
            [15.689615520000132, 23.317518412000098],
            [15.63194462100006, 23.2913443],
            [15.5742737220001, 23.265196025000094],
            [15.516499471000088, 23.239047750000097],
            [15.45882857200013, 23.21289947600009],
            [15.401157674000075, 23.186751201000064],
            [15.343486775000088, 23.160577087000078],
            [15.285815878000108, 23.13445465200006],
            [15.228144979000149, 23.10835805200007],
            [15.170370728000137, 23.08226145400009],
            [15.112906535000036, 23.056113180000082],
            [15.055235636000077, 23.029964905000085],
            [14.997461385000065, 23.00381663000006],
            [14.979909027000133, 22.995663760000085],
            [14.97927128000012, 22.995367534000067],
            [14.979167928000095, 22.99531585700005],
            [14.808015584000088, 22.908887024000066],
            [14.637069947000043, 22.82253570600001],
            [14.46602095600008, 22.73618438800007],
            [14.294868612000073, 22.64983306900008],
            [14.231720011000107, 22.61794871100004],
            [14.2162170820001, 22.616295064000084],
            [14.201644328000043, 22.623219706000057],
            [14.156169067000093, 22.66073679600005],
            [14.03100874800009, 22.763702087000027],
            [13.906055135000116, 22.866615703],
            [13.780894816000114, 22.96963267100007],
            [13.655786173000138, 23.072623799000056],
            [13.599562215000049, 23.119029236000088],
            [13.482256713000083, 23.17967153000005],
            [13.380660848000076, 23.202383322000017],
            [13.292397502000085, 23.22209788],
            [13.204134155000105, 23.241709087000018],
            [13.115870809000029, 23.261449483000078],
            [13.027607462000049, 23.281138204000015],
            [12.9394474690001, 23.300826925000067],
            [12.85118412300011, 23.320489808000033],
            [12.763024129000144, 23.340178528000067],
            [12.674657430000138, 23.35989308700003],
            [12.586497437000105, 23.379581808000083],
            [12.498337443000139, 23.39924469000003],
            [12.409970744000134, 23.41888173400004],
            [12.321810750000083, 23.438622132000106],
            [12.233650757000134, 23.458285014000055],
            [12.145284058000101, 23.477947897],
            [12.05702071100012, 23.497610779000055],
            [11.96886071700007, 23.517351176000105],
            [11.892379598000105, 23.66005564400008],
            [11.82230635600007, 23.790641989000065],
            [11.710140444000075, 24.000137321000082],
            [11.708618205000079, 24.00298044800006],
            [11.636477905000078, 24.137649231000054],
            [11.56712813300004, 24.266840312000042],
            [11.541393270000128, 24.29751027500008],
            [11.50863041200003, 24.313814189000098],
            [11.467240356000048, 24.326338558000046],
            [11.149995971000095, 24.422334697000096],
            [10.911354207000045, 24.494500834000107],
            [10.720668172000046, 24.552300924000107],
            [10.69906742300006, 24.556124980000035],
            [10.677363322000076, 24.55385121700003],
            [10.56677575700013, 24.516463318000078],
            [10.450193726000066, 24.476930848000038],
            [10.410506225000063, 24.473287659000036],
            [10.391799357000082, 24.479979757000066],
            [10.260334513000146, 24.576640524000126],
            [10.242247762000147, 24.59511484800005],
            [10.229742065000067, 24.629944763000097],
            [10.212172079000084, 24.722858989000045],
            [10.19336185700007, 24.74993744000001],
            [10.044533732000048, 24.829622498000063],
            [10.032028035000025, 24.856339213000112],
            [10.029960978000076, 24.99506459600009],
            [10.025516805000052, 25.136399638000015],
            [10.021382690000053, 25.268019511000077],
            [10.007946818000079, 25.331426493],
            [9.969499552000059, 25.395401917000086],
            [9.816744019000055, 25.588465068000048],
            [9.693960816000072, 25.743494364000057],
            [9.541308634000103, 25.936350810000064],
            [9.401162150000118, 26.11339426700006],
            [9.377804403000084, 26.168946432000055],
            [9.402505737000098, 26.216178691],
            [9.416458374000086, 26.232250062000062],
            [9.434751831000142, 26.271989238000046],
            [9.468858276000105, 26.30103139300006],
            [9.477643269000112, 26.3155524700001],
            [9.48136397200011, 26.33260569300002],
            [9.482604207000065, 26.35255279500005],
            [9.83576094500009, 26.504223125000053],
            [9.854571167000103, 26.524376933000028],
            [9.896325725000054, 26.65279286700003],
            [9.89405196100006, 26.673980205000092],
            [9.88257979300002, 26.701782125000037],
            [9.88547367400011, 26.7366120410001],
            [9.910588419000135, 26.843117168000035],
            [9.906661010000079, 26.857483216000034],
            [9.890848022000085, 26.86957550100003],
            [9.846096232000122, 26.891951396000096],
            [9.835140828000135, 26.90099477200006],
            [9.825529012000118, 26.920580139],
            [9.806098674000054, 27.025121562],
            [9.721349324000101, 27.29187530600008],
            [9.72186608900006, 27.308463440000068],
            [9.726516968000112, 27.32468984000009],
            [9.743053426000102, 27.364118958000105],
            [9.756282592000105, 27.423030091],
            [9.77054528800008, 27.444217428000073],
            [9.813643432000106, 27.48648874900006],
            [9.821601603000147, 27.505686544000056],
            [9.811679728000058, 27.52653798500002],
            [9.797106974000087, 27.54891388],
            [9.793903036000131, 27.56973948200006],
            [9.818501017000102, 27.585733337000093],
            [9.846612996000147, 27.599298401000098],
            [9.863356160000109, 27.619245504000034],
            [9.931273724000022, 27.81864196800008],
            [9.93425622500007, 27.827398173000077],
            [9.93590987100012, 27.866723939000067],
            [9.789872273000128, 28.209442037000073],
            [9.776953166000112, 28.26757802300007],
            [9.827275804000067, 28.618646663],
            [9.851263875000114, 28.785995992000025],
            [9.848266642000112, 28.975726013000084],
            [9.8261491290001, 29.128533224000094],
            [9.746929158500109, 29.368428141500132],
            [9.66770918800006, 29.608323059000057],
            [9.54968021600007, 29.802316386000072],
            [9.42172937, 29.968714498000068],
            [9.369486582000093, 30.02279375700006],
            [9.310004923000065, 30.08436635400001],
            [9.286543823000073, 30.11712921200011],
            [9.519707885000116, 30.22890533500008],
            [9.743466838000131, 30.331328024000115],
            [9.772922404000042, 30.338097636000057],
            [9.845786174000125, 30.342283427000083],
            [9.871314331000065, 30.35515085900009],
            [9.995647827000141, 30.494522196000062],
            [10.10117110100012, 30.641696676000052],
            [10.192224976000148, 30.73125193300008],
            [10.25392663600013, 30.841787821000096],
            [10.269739624000124, 30.88214711500008],
            [10.270153036000124, 30.91563344300006],
            [10.245038289000092, 30.985706686000114],
            [10.240594116000096, 31.021156719000132],
            [10.246175171000118, 31.05955230700006],
            [10.244831584000053, 31.07815582300013],
            [10.213205607000049, 31.135361633000073],
            [10.18271651200007, 31.240781556000016],
            [10.10809574400011, 31.411830547000093],
            [10.106235392000087, 31.42919382800001],
            [10.116880737000088, 31.49440948500002],
            [10.132590373000141, 31.517560527000015],
            [10.196462442000097, 31.578590393000084],
            [10.263951863000045, 31.680496318000095],
            [10.315421590000113, 31.715842997],
            [10.427766154000068, 31.71460276300006],
            [10.482543172000135, 31.73310292500007],
            [10.498872924000068, 31.744316711000025],
            [10.513549031000053, 31.757029114000076],
            [10.525537963000119, 31.772066956000074],
            [10.542384480000095, 31.806638489000065],
            [10.584552449000057, 31.840279846],
            [10.597574910000105, 31.87350779200004],
            [10.605946492000072, 31.953606263],
            [10.628477417000084, 31.97412180600007],
            [10.647287638000108, 31.97195139600008],
            [10.665271036000092, 31.9632180790001],
            [10.683564493000063, 31.957016907000124],
            [10.703098185000073, 31.962184550000117],
            [10.736584513000054, 31.985387269000043],
            [10.772861369000111, 32.004507549000024],
            [10.805624227000123, 32.032361145],
            [10.845931844000063, 32.11178782200007],
            [10.873217, 32.13669586200005],
            [11.182341254000079, 32.26222336900004],
            [11.44403487100007, 32.36849049900012],
            [11.513901408000066, 32.407997131000045],
            [11.526085437000091, 32.4178627030001],
            [11.546354207000093, 32.4342745980001],
            [11.564130900000123, 32.46548716300008],
            [11.560616903000067, 32.507577616],
            [11.537362508000058, 32.54351857500008],
            [11.47038985200004, 32.59927744600013],
            [11.449925985000078, 32.637957255000046],
            [11.449202514000092, 32.6930184940001],
            [11.463775268000063, 32.79846425400005],
            [11.456540567000076, 32.90210133900011],
            [11.474420613000035, 32.96987498000003],
            [11.474937378000078, 33.025840556000034],
            [11.47741784700014, 33.0412142950001],
            [11.50604659000004, 33.13637644500007],
            [11.505111803000148, 33.18122531500005],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Tunisia',
        iso3: 'TUN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [11.505111803000148, 33.18122531500005],
              [11.50604659000004, 33.13637644500007],
              [11.47741784700014, 33.0412142950001],
              [11.474937378000078, 33.025840556000034],
              [11.474420613000035, 32.96987498000003],
              [11.456540567000076, 32.90210133900011],
              [11.463775268000063, 32.79846425400005],
              [11.449202514000092, 32.6930184940001],
              [11.449925985000078, 32.637957255000046],
              [11.47038985200004, 32.59927744600013],
              [11.537362508000058, 32.54351857500008],
              [11.560616903000067, 32.507577616],
              [11.564130900000123, 32.46548716300008],
              [11.546354207000093, 32.4342745980001],
              [11.526085437000091, 32.4178627030001],
              [11.513901408000066, 32.407997131000045],
              [11.44403487100007, 32.36849049900012],
              [11.182341254000079, 32.26222336900004],
              [10.873217, 32.13669586200005],
              [10.845931844000063, 32.11178782200007],
              [10.805624227000123, 32.032361145],
              [10.772861369000111, 32.004507549000024],
              [10.736584513000054, 31.985387269000043],
              [10.703098185000073, 31.962184550000117],
              [10.683564493000063, 31.957016907000124],
              [10.665271036000092, 31.9632180790001],
              [10.647287638000108, 31.97195139600008],
              [10.628477417000084, 31.97412180600007],
              [10.605946492000072, 31.953606263],
              [10.597574910000105, 31.87350779200004],
              [10.584552449000057, 31.840279846],
              [10.542384480000095, 31.806638489000065],
              [10.525537963000119, 31.772066956000074],
              [10.513549031000053, 31.757029114000076],
              [10.498872924000068, 31.744316711000025],
              [10.482543172000135, 31.73310292500007],
              [10.427766154000068, 31.71460276300006],
              [10.315421590000113, 31.715842997],
              [10.263951863000045, 31.680496318000095],
              [10.196462442000097, 31.578590393000084],
              [10.132590373000141, 31.517560527000015],
              [10.116880737000088, 31.49440948500002],
              [10.106235392000087, 31.42919382800001],
              [10.10809574400011, 31.411830547000093],
              [10.18271651200007, 31.240781556000016],
              [10.213205607000049, 31.135361633000073],
              [10.244831584000053, 31.07815582300013],
              [10.246175171000118, 31.05955230700006],
              [10.240594116000096, 31.021156719000132],
              [10.245038289000092, 30.985706686000114],
              [10.270153036000124, 30.91563344300006],
              [10.269739624000124, 30.88214711500008],
              [10.25392663600013, 30.841787821000096],
              [10.192224976000148, 30.73125193300008],
              [10.10117110100012, 30.641696676000052],
              [9.995647827000141, 30.494522196000062],
              [9.871314331000065, 30.35515085900009],
              [9.845786174000125, 30.342283427000083],
              [9.772922404000042, 30.338097636000057],
              [9.743466838000131, 30.331328024000115],
              [9.519707885000116, 30.22890533500008],
              [9.491389201000032, 30.338976135000095],
              [9.46307051600013, 30.44904693700009],
              [9.434751831000142, 30.55906606000009],
              [9.406329793000111, 30.66908518500007],
              [9.377907756000099, 30.779155985000088],
              [9.349589070000093, 30.889175110000068],
              [9.321270386, 30.999245911000074],
              [9.292951701000106, 31.10931671200008],
              [9.26442631100008, 31.21933583600007],
              [9.236210978000088, 31.329406637000076],
              [9.207788941000075, 31.439425761000095],
              [9.179470255000098, 31.5494965620001],
              [9.1511515710001, 31.659567363000107],
              [9.122729533000069, 31.76953481000008],
              [9.094514201000095, 31.879605611000088],
              [9.065988810000135, 31.989676412000094],
              [9.063303822000108, 32.00019151300005],
              [9.045008179000149, 32.07184194000011],
              [9.033742716000091, 32.090755514000065],
              [9.019893433000021, 32.104863180000095],
              [8.851531616000074, 32.20824188200008],
              [8.642345419000037, 32.336657817000074],
              [8.482665242000053, 32.43479136200004],
              [8.359985392000112, 32.50101470900002],
              [8.33262728000011, 32.526355407],
              [8.331253296000114, 32.52762807200007],
              [8.31957442200013, 32.56059763600011],
              [8.309962606000028, 32.66387298600007],
              [8.296423381000068, 32.80440704300007],
              [8.28288415600008, 32.83636891700006],
              [8.181391642000108, 32.96982330300001],
              [8.086823771000098, 33.094285991000035],
              [8.064499552000143, 33.105783997000046],
              [8.043622274000057, 33.10183074900006],
              [8.022641642000082, 33.1030451460001],
              [8.002177775000092, 33.10836781900004],
              [7.982747437000114, 33.11681691500006],
              [7.871953166000111, 33.18412546800003],
              [7.83546960400011, 33.19453826900006],
              [7.787513875000087, 33.19831064900008],
              [7.75072025500009, 33.20766408300004],
              [7.724985392000093, 33.231409404000075],
              [7.709689168000125, 33.278150737000075],
              [7.70828622300013, 33.41070398400008],
              [7.708242228000131, 33.41486073800003],
              [7.69315270900006, 33.45410898900009],
              [7.616568237000138, 33.565962626000086],
              [7.553006225000075, 33.65874766100008],
              [7.544427938000126, 33.68424998000002],
              [7.534196004000137, 33.736236471000055],
              [7.505463908000138, 33.78284861300001],
              [7.49853926600008, 33.79997935000007],
              [7.484896688000049, 33.855014750000024],
              [7.47983239800007, 33.89390126500008],
              [7.500606323000113, 33.994256898000046],
              [7.503706909000073, 34.067973328000065],
              [7.51745284000009, 34.09502594000013],
              [7.539228219000051, 34.11375783900006],
              [7.579567911000083, 34.14845937200006],
              [7.604062541000133, 34.175486145],
              [7.631451049000077, 34.1991022750001],
              [7.670311727000126, 34.21530283600002],
              [7.733873738000113, 34.223777771000115],
              [7.752787313000056, 34.23214935300008],
              [7.765293009000061, 34.2447067260001],
              [7.774284709000085, 34.26095896400001],
              [7.811905151000104, 34.379272156000056],
              [7.831542195000054, 34.41438629200009],
              [7.870609579000075, 34.437899068],
              [7.957322632000114, 34.46942169200007],
              [7.999077189000076, 34.49417470300007],
              [8.094058472000086, 34.530141500000056],
              [8.102483160000105, 34.53635470800005],
              [8.143667846000142, 34.56672841400008],
              [8.167232300000137, 34.57856231700002],
              [8.175190470000103, 34.58528025300005],
              [8.179531291000103, 34.59215321900011],
              [8.18655928600009, 34.609568176000025],
              [8.19286381000012, 34.617733053000066],
              [8.228830607000077, 34.63643992200004],
              [8.236478719000075, 34.64765370800008],
              [8.21064050300015, 34.681191712],
              [8.213431030000095, 34.696746318000024],
              [8.225213257000092, 34.711680807000064],
              [8.257355997000047, 34.73974111000011],
              [8.258714460000078, 34.741298],
              [8.266554403000043, 34.75028310200007],
              [8.269344930000102, 34.763874003000055],
              [8.25074141400006, 34.864746399000055],
              [8.248881062000123, 34.90195343100008],
              [8.259009644000088, 34.9406590790001],
              [8.28288415600008, 34.994040833],
              [8.300454142000149, 35.06767974900002],
              [8.313683309000055, 35.10307810500002],
              [8.360915568000081, 35.14591786800007],
              [8.42137699300011, 35.222088929000066],
              [8.431298869000102, 35.2417259730001],
              [8.396882365000067, 35.26368845700007],
              [8.35523116100012, 35.274333802000044],
              [8.317404012000054, 35.28947499600007],
              [8.294356323000102, 35.32508005800004],
              [8.287948446000144, 35.366059469000064],
              [8.290015502000102, 35.4025947060001],
              [8.300867553000074, 35.43747629900007],
              [8.336730997000103, 35.50837636300004],
              [8.33704105600009, 35.53793528300007],
              [8.327225481000085, 35.621405428000045],
              [8.323605184000144, 35.652191874000025],
              [8.30655196100011, 35.68490305600001],
              [8.257666057000023, 35.750325419],
              [8.245780477000096, 35.7853103640001],
              [8.241439656000125, 35.827736715000114],
              [8.24722741700009, 35.907318421000056],
              [8.268423401000064, 35.969863948000025],
              [8.272445516000033, 35.98173248300007],
              [8.27564945500012, 36.036819560000126],
              [8.296733439000121, 36.11040680000012],
              [8.307998901000104, 36.126994934000024],
              [8.317093953000068, 36.14590850900008],
              [8.314510132000066, 36.16394358300006],
              [8.30706872600004, 36.18249542300002],
              [8.302314494000143, 36.202339172],
              [8.30706872600004, 36.243628642000104],
              [8.354404338000109, 36.35090891500006],
              [8.355423113000114, 36.356115986000034],
              [8.358125041000108, 36.36992584300013],
              [8.359675333000041, 36.41121531200007],
              [8.357711629000107, 36.430387268000075],
              [8.349236695000116, 36.44878407800006],
              [8.333837118000105, 36.45638051400003],
              [8.314923543000077, 36.46061798200007],
              [8.295596557000124, 36.468679504000065],
              [8.208780151000042, 36.477826233000044],
              [8.16785241700012, 36.49136545900002],
              [8.167890169000145, 36.49199497900007],
              [8.169919474000096, 36.525833639],
              [8.193483927000074, 36.548984681],
              [8.222319376000115, 36.56376414],
              [8.286914917000075, 36.58340118400004],
              [8.40794112100005, 36.642622376000034],
              [8.430368693000048, 36.66262115500005],
              [8.453209676000142, 36.69765777600007],
              [8.46178796400008, 36.73279775000013],
              [8.441634155000116, 36.753209941000065],
              [8.406700887000113, 36.767989400000076],
              [8.41310876500006, 36.783905742000016],
              [8.44401127100005, 36.79620473300007],
              [8.482665242000053, 36.79997711300008],
              [8.520078979000118, 36.79791005500003],
              [8.554495483000068, 36.803646139000065],
              [8.623845255000106, 36.82607371100006],
              [8.641725301000065, 36.83635732100008],
              [8.642552124000105, 36.84850128200007],
              [8.608238973000084, 36.89072092700003],
              [8.604828329000043, 36.90097869900002],
              [8.605655151000065, 36.9130451460001],
              [8.60251042862123, 36.93951076359987],
              [8.621104363000086, 36.94578685100004],
              [8.692149285000085, 36.96938711100006],
              [8.71656334700009, 36.973089911000045],
              [8.802012566000087, 36.973089911000045],
              [8.824392123000052, 36.97947825700004],
              [8.865733269000089, 37.00763580900008],
              [8.896006707000083, 37.018866278000075],
              [8.90365644600007, 37.02167389500005],
              [8.925791863000086, 37.03888580900008],
              [8.956879102000073, 37.06928131700005],
              [8.98764082100007, 37.116848049000055],
              [9.000987175000091, 37.12396881700005],
              [9.010752800000091, 37.127834377000056],
              [9.03874759200005, 37.15184153900009],
              [9.049327019000089, 37.15696849200009],
              [9.07943769600007, 37.16681549700007],
              [9.159190300000091, 37.19281647300005],
              [9.171397332000083, 37.19879791900007],
              [9.192393425000091, 37.22614166900007],
              [9.21070397200009, 37.23383209800005],
              [9.342539910000085, 37.23533763200004],
              [9.380707227000073, 37.24746328300006],
              [9.405121290000068, 37.26850006700005],
              [9.419118686000047, 37.275824286000045],
              [9.432627800000091, 37.27138906500005],
              [9.442881707000083, 37.26654694200005],
              [9.453868035000085, 37.26829661700009],
              [9.46452884200005, 37.27244700700004],
              [9.49390709700009, 37.27814362200007],
              [9.51734459700009, 37.28668854400007],
              [9.538584832000083, 37.29800039300005],
              [9.552744988000086, 37.30951569200005],
              [9.573090040000068, 37.30023834800005],
              [9.59148196700005, 37.30292389500005],
              [9.628428582000083, 37.323146877000056],
              [9.649261915000068, 37.33185455900008],
              [9.666270379000082, 37.33543528900009],
              [9.71029707100007, 37.33616771000004],
              [9.732432488000086, 37.34332916900007],
              [9.744639519000089, 37.34520091400009],
              [9.755137566000087, 37.339911200000074],
              [9.763194207000083, 37.333644924000055],
              [9.773448113000086, 37.330511786000045],
              [9.858897332000083, 37.32880280200004],
              [9.85906009200005, 37.325873114000046],
              [9.861175977000073, 37.31635163000004],
              [9.861664259000065, 37.271185614000046],
              [9.830739780000044, 37.251206773000035],
              [9.79273522200009, 37.23802317900004],
              [9.771820509000065, 37.213324286000045],
              [9.77507571700005, 37.20579661700009],
              [9.79070071700005, 37.17841217700004],
              [9.795664910000085, 37.17234935100004],
              [9.801524285000085, 37.169134833000044],
              [9.807790561000047, 37.15501536700009],
              [9.815928582000083, 37.15184153900009],
              [9.859711134000065, 37.14704010600008],
              [9.879893425000091, 37.150091864000046],
              [9.90211022200009, 37.16486237200007],
              [9.914317254000082, 37.17829010600008],
              [9.925303582000083, 37.19676341400009],
              [9.924978061000047, 37.21312083500004],
              [9.861175977000073, 37.23383209800005],
              [9.851573113000086, 37.232855536000045],
              [9.831065300000091, 37.227728583000044],
              [9.819590691000087, 37.22760651200008],
              [9.819590691000087, 37.23383209800005],
              [9.843923373000052, 37.24746328300006],
              [9.853526238000086, 37.24949778900009],
              [9.859629754000082, 37.25413646000004],
              [9.863942905000044, 37.259019273000035],
              [9.867442254000082, 37.261704820000034],
              [9.88249759200005, 37.26357656500005],
              [9.97982832100007, 37.24603913000004],
              [9.99781334700009, 37.24746328300006],
              [10.051280144000089, 37.26658763200004],
              [10.059825066000087, 37.264837958000044],
              [10.07585696700005, 37.24494049700007],
              [10.14625084700009, 37.23651764500005],
              [10.178721550000091, 37.21271393400008],
              [10.253103061000047, 37.191392320000034],
              [10.272146030000044, 37.17853424700007],
              [10.240082227000073, 37.17177969000005],
              [10.225271030000044, 37.16673411700009],
              [10.211273634000065, 37.15867747600004],
              [10.205821160000085, 37.175116278000075],
              [10.177989129000082, 37.17796458500004],
              [10.146006707000083, 37.171210028000075],
              [10.128103061000047, 37.15867747600004],
              [10.135427280000044, 37.14232005400004],
              [10.161631707000083, 37.13434479400007],
              [10.191905144000089, 37.133246161000045],
              [10.211273634000065, 37.137600002000056],
              [10.218190951000054, 37.12893301000008],
              [10.227061394000089, 37.11766185100004],
              [10.230316602000073, 37.10809967700004],
              [10.22437584700009, 37.09593333500004],
              [10.217539910000085, 37.11029694200005],
              [10.174327019000089, 37.076239325000074],
              [10.182383660000085, 37.027044989000046],
              [10.22006269600007, 36.976629950000074],
              [10.265879754000082, 36.93891022300005],
              [10.303233269000089, 36.92438385600008],
              [10.313731316000087, 36.91844310100004],
              [10.337006056000064, 36.891831773000035],
              [10.347178582000083, 36.88027578300006],
              [10.341970248000052, 36.86859772300005],
              [10.319021030000044, 36.85024648600006],
              [10.309336785000085, 36.829779364000046],
              [10.298838738000086, 36.82176341400009],
              [10.285166863000086, 36.819973049000055],
              [10.272146030000044, 36.82908763200004],
              [10.279551629000082, 36.84430573100008],
              [10.270192905000044, 36.84845612200007],
              [10.252940300000091, 36.84634023600006],
              [10.22046959700009, 36.83779531500005],
              [10.21070397200009, 36.83185455900008],
              [10.193614129000082, 36.81232330900008],
              [10.188487175000091, 36.79759349200009],
              [10.20289147200009, 36.792629299000055],
              [10.234222852000073, 36.791896877000056],
              [10.247243686000047, 36.78628164300005],
              [10.253916863000086, 36.791449286000045],
              [10.257009311000047, 36.793850002000056],
              [10.272146030000044, 36.816066799000055],
              [10.293630405000044, 36.77773672100005],
              [10.32007897200009, 36.74876536700009],
              [10.355316602000073, 36.73118724200009],
              [10.403005405000044, 36.72671133000006],
              [10.416758660000085, 36.72955963700008],
              [10.43699532700009, 36.72883941200007],
              [10.487727274000065, 36.749651543000084],
              [10.51871348900005, 36.755796726000085],
              [10.53823286800008, 36.77202591000008],
              [10.546049949000064, 36.799921159000064],
              [10.552598455000066, 36.822920654000086],
              [10.566905144000089, 36.86322663000004],
              [10.584971550000091, 36.876166083000044],
              [10.606130405000044, 36.87970612200007],
              [10.652598504000082, 36.87689850500004],
              [10.69467207100007, 36.88344961100006],
              [10.733465667000075, 36.89581225100005],
              [10.783205036000084, 36.92441792600005],
              [10.813975457000083, 36.950384833000044],
              [10.823090040000068, 36.95392487200007],
              [10.826914910000085, 36.96320221600007],
              [10.830088738000086, 36.96824778900009],
              [10.887543165000068, 37.00600820500006],
              [10.89584394600007, 37.014105536000045],
              [10.898448113000086, 37.02521393400008],
              [10.894704623000052, 37.03217194200005],
              [10.892914259000065, 37.03864166900007],
              [10.90211022200009, 37.048814195000034],
              [10.923675977000073, 37.05703359600005],
              [10.974131707000083, 37.06126536700009],
              [11.012705925000091, 37.08478424700007],
              [11.033376498000052, 37.08746979400007],
              [11.051036004000082, 37.08030833500004],
              [11.06031334700009, 37.062486070000034],
              [11.058929884000065, 37.053900458000044],
              [11.04859459700009, 37.04197825700004],
              [11.046071811000047, 37.03143952000005],
              [11.048350457000083, 37.02033112200007],
              [11.058116082000083, 37.00600820500006],
              [11.06031334700009, 36.99701569200005],
              [11.063975457000083, 36.99005768400008],
              [11.081309441000087, 36.96938711100006],
              [11.087738477000073, 36.959418036000045],
              [11.090098504000082, 36.94961172100005],
              [11.091807488000086, 36.92820872600004],
              [11.094493035000085, 36.91844310100004],
              [11.099131707000083, 36.910589911000045],
              [11.105967644000089, 36.901597398000035],
              [11.113129102000073, 36.894232489000046],
              [11.118418816000087, 36.89118073100008],
              [11.124278191000087, 36.88568756700005],
              [11.136226578000048, 36.87053012100006],
              [11.130545149000056, 36.85403879800003],
              [11.11676691200006, 36.838411877000055],
              [11.07673522600004, 36.82518839800008],
              [11.022139533000086, 36.788276075000056],
              [10.992547829000046, 36.74406445600005],
              [10.949929815000075, 36.69387774100005],
              [10.879519360000074, 36.58847499400008],
              [10.825662358000045, 36.47981078300006],
              [10.79992857500008, 36.45188523500008],
              [10.71715353400009, 36.43455123600006],
              [10.620440907000045, 36.39028039700008],
              [10.585564369000053, 36.398132016000034],
              [10.550928289000069, 36.37725579600004],
              [10.519085115000053, 36.33747245900008],
              [10.504844912000067, 36.29935472200009],
              [10.491067929000053, 36.258065642000076],
              [10.47926689500008, 36.216961997000055],
              [10.476855707000084, 36.16552186000007],
              [10.474694877000047, 36.112485958000036],
              [10.479527532000077, 36.07932730400006],
              [10.49239345400008, 36.04534081400004],
              [10.499847852000073, 36.02728913000004],
              [10.504730665000068, 36.02094147300005],
              [10.50912519600007, 36.01117584800005],
              [10.514821811000047, 35.98908112200007],
              [10.518565300000091, 35.97996653900009],
              [10.540537957000083, 35.952826239000046],
              [10.556488477000073, 35.93797435100004],
              [10.570323113000086, 35.93158600500004],
              [10.582286004000082, 35.92182038000004],
              [10.608571811000047, 35.85586172100005],
              [10.622080925000091, 35.84259674700007],
              [10.691335483000046, 35.78961823100008],
              [10.693695509000065, 35.78778717700004],
              [10.713063998000052, 35.77924225500004],
              [10.74361966300006, 35.76967207600006],
              [10.803721550000091, 35.78693268400008],
              [10.81381269600007, 35.78497955900008],
              [10.823090040000068, 35.780462958000044],
              [10.841420439000046, 35.76654761700007],
              [10.830339690000073, 35.75323354400007],
              [10.824522355000056, 35.73338913400005],
              [10.829600457000083, 35.71312083500004],
              [10.84115644600007, 35.69879791900007],
              [10.881521030000044, 35.68301015800006],
              [10.971815894000088, 35.654138114000034],
              [11.011973504000082, 35.657904364000046],
              [11.040998050000042, 35.637730383000076],
              [11.055021624000062, 35.61447632200009],
              [11.017100457000083, 35.60228099200009],
              [11.011973504000082, 35.57904694200005],
              [11.013926629000082, 35.56289297100005],
              [11.014903191000087, 35.55516185100004],
              [11.023936394000089, 35.53375885600008],
              [11.039235873000052, 35.51850006700005],
              [11.085057411000037, 35.506785421000075],
              [11.057689731000039, 35.48673347200008],
              [11.050666014000058, 35.45978174600009],
              [11.045530315000065, 35.43475466400008],
              [11.049412181000037, 35.39125527200008],
              [11.037187780000068, 35.37082139200004],
              [11.042232667000064, 35.33443539400008],
              [11.065890552000042, 35.303268366000054],
              [11.10132897200009, 35.266831773000035],
              [11.122080925000091, 35.25364817900004],
              [11.147103928000092, 35.24400540100004],
              [11.160781762000056, 35.23823214000004],
              [11.15915960600006, 35.218757087000085],
              [11.131352161000052, 35.217959043000064],
              [11.111577776000047, 35.20559467000004],
              [11.092315530000064, 35.173938785000075],
              [11.062912201000074, 35.15363892500005],
              [11.04883026400006, 35.131223359000046],
              [11.034990274000052, 35.10705557600005],
              [11.015879754000082, 35.09284088700008],
              [11.022452540000074, 35.064502308000044],
              [11.018105253000044, 35.03419091400008],
              [10.984366015000091, 34.999413969000045],
              [10.945862975000068, 34.98353119900008],
              [10.91765384200005, 34.95742422100005],
              [10.92495113700005, 34.93412198900006],
              [10.916514519000089, 34.913316148000035],
              [10.916335641000046, 34.873569140000086],
              [10.875498894000089, 34.84906647300005],
              [10.866709832000083, 34.84125397300005],
              [10.860362175000091, 34.836818752000056],
              [10.856293165000068, 34.83087799700007],
              [10.867357628000093, 34.81103313700004],
              [10.871421001000044, 34.79736697100009],
              [10.83488490500008, 34.78339816000005],
              [10.811262290000059, 34.76888012300009],
              [10.779042135000054, 34.73950137500009],
              [10.763468906000071, 34.71344816000004],
              [10.743988477000073, 34.69867584800005],
              [10.734711134000065, 34.680853583000044],
              [10.717295769000089, 34.66474030200004],
              [10.701182488000086, 34.655951239000046],
              [10.634287957000083, 34.637884833000044],
              [10.625254754000082, 34.633246161000045],
              [10.621429884000065, 34.626288153000075],
              [10.619883660000085, 34.61587148600006],
              [10.61500084700009, 34.603583075000074],
              [10.607432488000086, 34.59332916900007],
              [10.605709539000088, 34.57366825200006],
              [10.598751836000076, 34.56245346500009],
              [10.597023266000065, 34.544713234000085],
              [10.58161459900009, 34.532679159000054],
              [10.55937636200008, 34.52349048900004],
              [10.465993686000047, 34.51194896000004],
              [10.431895379000082, 34.49632396000004],
              [10.378723611000055, 34.42308031500005],
              [10.330414259000065, 34.41258372600004],
              [10.320485873000052, 34.41323476800005],
              [10.311289910000085, 34.41681549700007],
              [10.300059441000087, 34.41771067900004],
              [10.288096550000091, 34.41400788000004],
              [10.281993035000085, 34.40888092700004],
              [10.278005405000044, 34.40273672100005],
              [10.256602410000085, 34.37909577000005],
              [10.247243686000047, 34.37213776200008],
              [10.234222852000073, 34.36933014500005],
              [10.186778191000087, 34.35195547100005],
              [10.166677280000044, 34.33881256700005],
              [10.12671959700009, 34.32562897300005],
              [10.102161376000083, 34.304074944000035],
              [10.089778403000082, 34.27297450300006],
              [10.054033834000052, 34.21316323500008],
              [10.032777141000054, 34.18465492200005],
              [10.018809441000087, 34.180568752000056],
              [10.010264519000089, 34.173163153000075],
              [10.010101759000065, 34.173081773000035],
              [10.00521894600007, 34.17064036700009],
              [10.014659050000091, 34.15338776200008],
              [10.018402540000068, 34.13349030200004],
              [10.018239780000044, 34.09153880400004],
              [10.021494988000086, 34.07330963700008],
              [10.036143425000091, 34.034491278000075],
              [10.039317254000082, 34.01609935100004],
              [10.048838738000086, 33.98346588700008],
              [10.071299675000091, 33.94623444200005],
              [10.163096550000091, 33.83624909100007],
              [10.172699415000068, 33.82807038000004],
              [10.18685957100007, 33.82176341400009],
              [10.330251498000052, 33.702826239000046],
              [10.367686394000089, 33.68406810100004],
              [10.446055535000085, 33.65542226800005],
              [10.460215691000087, 33.65269603100006],
              [10.489268425000091, 33.64712148600006],
              [10.558372869000038, 33.65572112000007],
              [10.634071727000048, 33.67362765800004],
              [10.697618425000087, 33.70259674300007],
              [10.716644727000073, 33.70693594000005],
              [10.73999196300008, 33.67157842600005],
              [10.736923596000054, 33.60285031400008],
              [10.707530144000089, 33.581691799000055],
              [10.691416863000086, 33.57611725500004],
              [10.67904707100007, 33.562567450000074],
              [10.674082879000082, 33.54559967700004],
              [10.679942254000082, 33.52985260600008],
              [10.703623894000089, 33.49603913000004],
              [10.717133009000065, 33.48354726800005],
              [10.738129102000073, 33.47801341400009],
              [10.780528191000087, 33.48574453300006],
              [10.856211785000085, 33.524318752000056],
              [10.89226321700005, 33.533270575000074],
              [10.909434441000087, 33.53961823100008],
              [10.92514082100007, 33.55508047100005],
              [10.932790561000047, 33.57404205900008],
              [10.926280144000089, 33.59125397300005],
              [10.909190300000091, 33.607855536000045],
              [10.906504754000082, 33.616441148000035],
              [10.936208530000044, 33.63629791900007],
              [10.947927280000044, 33.62946198100008],
              [10.96062259200005, 33.62767161700009],
              [10.971446160000085, 33.63190338700008],
              [10.97787519600007, 33.64313385600008],
              [10.984629754000082, 33.64313385600008],
              [11.000661655000044, 33.63418203300006],
              [11.042816602000073, 33.61786530200004],
              [11.06031334700009, 33.60834381700005],
              [11.07357832100007, 33.59446849200009],
              [11.108164910000085, 33.54962799700007],
              [11.111582879000082, 33.54002513200004],
              [11.11662117800006, 33.489972830000056],
              [11.089929354000049, 33.45414871200006],
              [11.11078342400009, 33.392970468000044],
              [11.102073675000042, 33.36408087500007],
              [11.131114129000082, 33.371527411000045],
              [11.150889519000089, 33.353949286000045],
              [11.170664910000085, 33.33177317900004],
              [11.193858269000089, 33.32099030200004],
              [11.217784050000091, 33.31631094000005],
              [11.269053582000083, 33.294256903000075],
              [11.293711785000085, 33.286810614000046],
              [11.287364129000082, 33.28204987200007],
              [11.284434441000087, 33.28082916900007],
              [11.280039910000085, 33.28001536700009],
              [11.181895379000082, 33.30678945500006],
              [11.133636915000068, 33.311428127000056],
              [11.121836785000085, 33.28001536700009],
              [11.131521030000044, 33.26805247600004],
              [11.147715691000087, 33.25690338700008],
              [11.163340691000087, 33.242621161000045],
              [11.170176629000082, 33.22101471600007],
              [11.179535352000073, 33.21108633000006],
              [11.201508009000065, 33.21116771000004],
              [11.245371941000087, 33.21792226800005],
              [11.287852410000085, 33.21010976800005],
              [11.372243686000047, 33.18378327000005],
              [11.416758660000085, 33.18378327000005],
              [11.433116082000083, 33.19354889500005],
              [11.427582227000073, 33.207017320000034],
              [11.410655144000089, 33.21893952000005],
              [11.392751498000052, 33.22410716400009],
              [11.381358269000089, 33.23069896000004],
              [11.367442254000082, 33.24526601800005],
              [11.351898634000065, 33.25885651200008],
              [11.442393425000091, 33.20465729400007],
              [11.49781334700009, 33.18268463700008],
              [11.504567905000044, 33.181341864000046],
              [11.505111803000148, 33.18122531500005],
            ],
          ],
          [
            [
              [10.991465691000087, 33.84170156500005],
              [11.010996941000087, 33.83161041900007],
              [11.031097852000073, 33.823879299000055],
              [11.04851321700005, 33.81476471600007],
              [11.06031334700009, 33.80072663000004],
              [10.993988477000073, 33.74974192900004],
              [10.977305535000085, 33.74315013200004],
              [10.971039259000065, 33.738714911000045],
              [10.96648196700005, 33.73041413000004],
              [10.95671634200005, 33.69773997600004],
              [10.950450066000087, 33.69773997600004],
              [10.953623894000089, 33.72418854400007],
              [10.95671634200005, 33.732489325000074],
              [10.94109134200005, 33.728216864000046],
              [10.92848441600006, 33.696630334000076],
              [10.910529617000066, 33.67387880000007],
              [10.893709349000062, 33.65824746900006],
              [10.88778564900008, 33.640141510000035],
              [10.871056089000092, 33.65433343700005],
              [10.870746171000064, 33.67184023500005],
              [10.876920793000068, 33.68821779000007],
              [10.858994649000067, 33.71106080200008],
              [10.842133009000065, 33.717962958000044],
              [10.826182488000086, 33.729803778000075],
              [10.808929884000065, 33.73432038000004],
              [10.790349198000058, 33.718572065000046],
              [10.781921657000055, 33.70369624300008],
              [10.76341962400005, 33.700162711000075],
              [10.740153798000051, 33.715477692000036],
              [10.733791155000063, 33.73066575300004],
              [10.727803848000065, 33.75818071900005],
              [10.728314245000092, 33.78456820300005],
              [10.747592736000058, 33.81274840200007],
              [10.735479486000088, 33.85375440000007],
              [10.73601321700005, 33.884751695000034],
              [10.772959832000083, 33.89630768400008],
              [10.854258660000085, 33.88165924700007],
              [10.89779707100007, 33.879339911000045],
              [10.929942254000082, 33.89630768400008],
              [10.959727410000085, 33.866115627000056],
              [10.991465691000087, 33.84170156500005],
            ],
          ],
          [
            [
              [10.964121941000087, 34.656683661000045],
              [10.973837248000052, 34.66301031900008],
              [10.987152540000068, 34.67177969000005],
              [11.10132897200009, 34.67096588700008],
              [11.110841855000047, 34.659505685000056],
              [11.09588940000009, 34.64698075100006],
              [11.055708400000071, 34.62096231500004],
              [11.036498549000044, 34.62431056500009],
              [11.016612175000091, 34.632513739000046],
              [10.983498786000041, 34.64591741800007],
              [10.964121941000087, 34.656683661000045],
            ],
          ],
          [
            [
              [11.265798373000052, 34.77338288000004],
              [11.274848702000043, 34.77037578300008],
              [11.280528191000087, 34.762884833000044],
              [11.304795511000066, 34.74229444700006],
              [11.297035294000068, 34.72869316500004],
              [11.199657131000038, 34.69471998800009],
              [11.14909644100004, 34.66928671000005],
              [11.130745834000038, 34.66329127900008],
              [11.122306398000092, 34.68042576800008],
              [11.136155401000053, 34.69388767200007],
              [11.152686646000063, 34.706877370000086],
              [11.170646589000057, 34.728592269000046],
              [11.173119716000087, 34.74243277900007],
              [11.172251904000063, 34.74880135900008],
              [11.173024936000047, 34.75800202000005],
              [11.180948085000068, 34.76178175200005],
              [11.183116082000083, 34.75218333500004],
              [11.198188775000062, 34.74401980400006],
              [11.222110581000038, 34.74764501000004],
              [11.224303473000077, 34.77005737600007],
              [11.217501767000044, 34.78161536500005],
              [11.225252312000066, 34.795221962000085],
              [11.237124579000067, 34.804189586000064],
              [11.24526469600005, 34.81496621800005],
              [11.25427006700005, 34.825822422000044],
              [11.270762566000087, 34.81785716400009],
              [11.299484176000078, 34.81417858800006],
              [11.30417118300005, 34.80528897000005],
              [11.278086785000085, 34.79767487200007],
              [11.274424675000091, 34.79173411700009],
              [11.268239780000044, 34.78534577000005],
              [11.265798373000052, 34.77338288000004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Zambia',
        iso3: 'ZMB',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [32.9208634850001, -9.407900085999913],
            [32.92303389500006, -9.466294453999879],
            [32.92778812700004, -9.479833678999867],
            [32.9375032960001, -9.487791849999923],
            [32.943601115000035, -9.485724791999957],
            [32.95026737500007, -9.480867206999932],
            [32.96189457200012, -9.480350443999896],
            [32.968612508000035, -9.484381204999892],
            [32.98308190900008, -9.497713723999908],
            [32.991970255000126, -9.50184783999994],
            [32.99238366700013, -9.52913299499994],
            [32.97471032700008, -9.601273294999942],
            [32.98690596500012, -9.628455098999936],
            [33.00013513200014, -9.632795917999914],
            [33.01119388800004, -9.627834980999879],
            [33.02225264500004, -9.620290221999923],
            [33.035740194000084, -9.61698292999992],
            [33.0467472740001, -9.622047219999985],
            [33.050778036000054, -9.63269256599989],
            [33.053051799000116, -9.644784850999969],
            [33.05832279400005, -9.654293313999858],
            [33.08044030700006, -9.662251484999913],
            [33.08922530100011, -9.643958027999943],
            [33.092532593000044, -9.614399108999919],
            [33.09832035300008, -9.58845753999988],
            [33.12147139500007, -9.59951629699988],
            [33.17542159000004, -9.602306823999925],
            [33.19542036900009, -9.616259460999927],
            [33.20983809400008, -9.641374205999853],
            [33.2142822670001, -9.654706725999873],
            [33.21578088400008, -9.669899596999898],
            [33.21299035700014, -9.680648294999912],
            [33.207822714000145, -9.68870981899991],
            [33.20456709800004, -9.698114928999956],
            [33.2072542730001, -9.712894388999885],
            [33.21671106000008, -9.727053730999927],
            [33.24177412900008, -9.74234995499998],
            [33.252729533000036, -9.75402882899995],
            [33.26719893400008, -9.78121063199994],
            [33.27577722100011, -9.79330291699992],
            [33.28776615400005, -9.803844908999892],
            [33.29996179200009, -9.810252786999925],
            [33.33696211700004, -9.823688659999974],
            [33.34347334800009, -9.831440123999897],
            [33.359182984000086, -9.870920918999914],
            [33.365590861000044, -9.898826191999902],
            [33.35845951300007, -9.91991017599993],
            [33.32879724100013, -9.96548878999991],
            [33.30998702000011, -10.012721048999936],
            [33.30471602300008, -10.037939147999893],
            [33.30409590700009, -10.063777363999918],
            [33.317531779000035, -10.082070820999888],
            [33.39918054200007, -10.117934264999931],
            [33.420161173000054, -10.135607604999933],
            [33.43649092600009, -10.153280944999935],
            [33.45457767800008, -10.168060403999945],
            [33.48051924600014, -10.177052103999898],
            [33.49912276200007, -10.201236673999873],
            [33.51896651200008, -10.214982604999904],
            [33.53328088400008, -10.231209004999911],
            [33.53560632300008, -10.262731628999873],
            [33.52930179900011, -10.318645527999962],
            [33.532919149000065, -10.342623392999883],
            [33.55917077600009, -10.404325052999937],
            [33.567645712000115, -10.41600392699992],
            [33.5955509850001, -10.440601907999906],
            [33.60319909700007, -10.44918019599993],
            [33.622732788000064, -10.494035339999925],
            [33.63818404200009, -10.511605325999895],
            [33.6654175220001, -10.51511932399994],
            [33.665572550000036, -10.541370950999891],
            [33.67265222200007, -10.559561054999918],
            [33.67352257400012, -10.56936702499992],
            [33.673849293000046, -10.57304805899993],
            [33.67420251500005, -10.577027688999877],
            [33.65776940900008, -10.601315612999969],
            [33.642266479000114, -10.615268248999953],
            [33.60309574400014, -10.64327687499987],
            [33.59027998800008, -10.64896128299992],
            [33.57694746900006, -10.657642923999973],
            [33.528268270000126, -10.711593118999929],
            [33.51199019400008, -10.751797382999953],
            [33.500983113000075, -10.769160664999973],
            [33.48051924600014, -10.781563008999939],
            [33.46532637600012, -10.784353535999898],
            [33.44713627200008, -10.802233580999953],
            [33.4340104580001, -10.808124694999961],
            [33.41866255700006, -10.807297870999932],
            [33.38553796400004, -10.800889993999903],
            [33.37174035700008, -10.803267109999936],
            [33.357839397000134, -10.80874481199993],
            [33.33262129800005, -10.81360239699994],
            [33.31908207200007, -10.81814992199989],
            [33.30688643400009, -10.828588561999922],
            [33.288127889000066, -10.856700540999952],
            [33.273400106000054, -10.865588887999877],
            [33.26120446700014, -10.865278827999887],
            [33.250765829000045, -10.862488300999928],
            [33.241412394000065, -10.865692240999905],
            [33.23257572500006, -10.883262226999875],
            [33.23169722500006, -10.897628274999889],
            [33.23960371900006, -10.903105976999967],
            [33.25210941600011, -10.903105976999967],
            [33.26585534600014, -10.901142272999934],
            [33.280324747000066, -10.913337910999942],
            [33.287869507000096, -10.944860533999915],
            [33.29096019900004, -10.975086452999975],
            [33.29396732600014, -11.00449513799991],
            [33.30368249500009, -11.034570820999889],
            [33.31810022000013, -11.062269388999908],
            [33.33660038200014, -11.087384134999937],
            [33.35887292400008, -11.10939829499992],
            [33.390912313000115, -11.164795430999959],
            [33.38223067200005, -11.194664408999884],
            [33.36848474100009, -11.222673034999985],
            [33.298308146000124, -11.329229837999947],
            [33.29680952900014, -11.335741068999923],
            [33.30027185100005, -11.347006530999877],
            [33.2989282640001, -11.353104349999938],
            [33.2933472090001, -11.357755228999906],
            [33.27805098400012, -11.364266458999879],
            [33.273503459000096, -11.369640807999929],
            [33.27184981300013, -11.383696796999942],
            [33.273813517000065, -11.396615905999866],
            [33.27360681200014, -11.409431660999942],
            [33.26518355300004, -11.423074238999945],
            [33.2397070720001, -11.402403665999927],
            [33.230301961000066, -11.416563008999972],
            [33.23495284100011, -11.501725768999918],
            [33.23381595900008, -11.514024758999952],
            [33.227304728000036, -11.532731627999937],
            [33.21262862100008, -11.563840840999902],
            [33.21593591300007, -11.571592304999896],
            [33.232679077000114, -11.577690123999957],
            [33.24931888900005, -11.577793476999886],
            [33.26688887500012, -11.5756230679999],
            [33.28321862800004, -11.578413594999859],
            [33.29675785300009, -11.59360646499988],
            [33.30264896700004, -11.609729512999962],
            [33.314017781000075, -11.772200215999902],
            [33.31060713700009, -11.808787129999942],
            [33.29737797000007, -11.846510924999905],
            [33.29748132300011, -11.86253061899994],
            [33.308746786000086, -11.8844414269999],
            [33.312674194000124, -11.89870412099988],
            [33.30931522600014, -11.91431040399992],
            [33.30357914300009, -11.930226745999946],
            [33.29422570800011, -11.981283060999914],
            [33.254899943000055, -12.072646992999935],
            [33.25128259300004, -12.105823261999944],
            [33.252729533000036, -12.139516295999911],
            [33.26027429200008, -12.155742695999919],
            [33.288386271000036, -12.182201029999902],
            [33.29996179200009, -12.195946959999944],
            [33.312467489000085, -12.228606465999917],
            [33.33014082900007, -12.298266295999937],
            [33.349467814000036, -12.327928567999905],
            [33.384607788000096, -12.340020852999885],
            [33.45829838100008, -12.31811004599993],
            [33.49736576300012, -12.331545917999975],
            [33.51410892700005, -12.33102915399985],
            [33.52558109600011, -12.335266621999892],
            [33.5271313880001, -12.355627135999924],
            [33.518139689000066, -12.371750182999904],
            [33.51388714300009, -12.37428145999992],
            [33.4877539470001, -12.38983693499992],
            [33.48051924600014, -12.40637339199992],
            [33.46532637600012, -12.40906056699994],
            [33.460778849000064, -12.416501972999868],
            [33.45995202600005, -12.441099954999856],
            [33.45111535600006, -12.452985533999879],
            [33.42078129100008, -12.464974466999934],
            [33.409412475000124, -12.475206400999923],
            [33.39375451700005, -12.49825408999989],
            [33.37323897300007, -12.518511249999975],
            [33.35039799000009, -12.532670592999935],
            [33.32828047700008, -12.53763152999997],
            [33.32032230600004, -12.535047708999883],
            [33.31195072400004, -12.529880065999876],
            [33.302235555000095, -12.52512583399988],
            [33.2897298580001, -12.524195657999925],
            [33.263168172000064, -12.52853647899991],
            [33.255106648000094, -12.531947122999938],
            [33.24363448100007, -12.544762877999915],
            [33.22699467000007, -12.57907602999994],
            [33.21299035700014, -12.588584492999928],
            [33.20291345200013, -12.591788430999898],
            [33.19681563300014, -12.595405781999972],
            [33.19237146000006, -12.599023131999957],
            [33.187307169000064, -12.602330423999959],
            [33.18131270300006, -12.608221536999864],
            [33.17800541100007, -12.615042826999911],
            [33.17325118000008, -12.62000376399996],
            [33.16301924600009, -12.620417174999972],
            [33.15878177900004, -12.615352884999893],
            [33.14689620000007, -12.593235370999892],
            [33.13991988100008, -12.586310729999909],
            [33.13035974100012, -12.583726908999907],
            [33.122814982000136, -12.584553730999929],
            [33.10700199400014, -12.588687845999942],
            [33.0990438230001, -12.593235370999892],
            [33.08994877100014, -12.600780130999937],
            [33.08126713000007, -12.604810892999936],
            [33.07423913500014, -12.59829966199996],
            [33.07000166800009, -12.590444843999933],
            [33.06462731900007, -12.584967142999943],
            [33.057702678000055, -12.583416848999917],
            [33.04953780100004, -12.586827493999948],
            [33.03537845900007, -12.599126484999985],
            [33.024836466000124, -12.612665710999877],
            [32.99414066600008, -12.672507018999923],
            [32.95807051600008, -12.725216979999942],
            [32.94463464400013, -12.752398782999933],
            [32.94112064600006, -12.769865416999977],
            [32.947011760000066, -12.843245950999915],
            [32.95352299000007, -12.854098001999958],
            [32.980498088000104, -12.870737813999895],
            [33.00504439200006, -12.892958678999918],
            [33.013571004000084, -12.91724660199992],
            [33.00892012500009, -12.945048522999883],
            [32.98153161600004, -13.006130065999884],
            [32.96592533400013, -13.116820983999943],
            [32.96711389200004, -13.13418426499996],
            [32.9712996830001, -13.150927428999921],
            [32.979051147000064, -13.167877298999926],
            [32.99507084200013, -13.190873311999965],
            [32.9981714270001, -13.202448831999916],
            [32.99279707900013, -13.216401468999905],
            [32.962721395000074, -13.224979756999929],
            [32.937865031000115, -13.255882262999933],
            [32.91962325000014, -13.294846292999921],
            [32.90548718000008, -13.351390573999936],
            [32.89213138800005, -13.404813740999899],
            [32.874251342000036, -13.443157653999918],
            [32.84582930500011, -13.458040465999957],
            [32.827432495000096, -13.460830992999917],
            [32.819060913000044, -13.471683043999874],
            [32.81689050300014, -13.487392678999939],
            [32.81751062000012, -13.50558278399997],
            [32.8130664470001, -13.528217060999921],
            [32.80004398600005, -13.537105407999945],
            [32.76319869000014, -13.542479755999906],
            [32.74981449400008, -13.550851338999877],
            [32.7228393960001, -13.5733822629999],
            [32.71023034600006, -13.575345966999933],
            [32.69162683100012, -13.569144794999943],
            [32.677260783000065, -13.567801207999892],
            [32.66764896600006, -13.575552673999894],
            [32.66330814700012, -13.596326598999937],
            [32.67509037200011, -13.628055927999952],
            [32.70671635000008, -13.635083922999868],
            [32.74340661600007, -13.63539398199994],
            [32.769864950000056, -13.646866149999966],
            [32.80779545000007, -13.69916269899997],
            [32.813376506000054, -13.711151631999925],
            [32.80484989400014, -13.72200368199988],
            [32.76810795000006, -13.739056904999913],
            [32.75735925300006, -13.750219013999939],
            [32.76304366000011, -13.777194111999876],
            [32.79187911000014, -13.78980316099991],
            [32.82877608300004, -13.797037861999868],
            [32.859420207000085, -13.80809661799988],
            [32.8741479900001, -13.820602314999874],
            [32.923912394000126, -13.880443622999934],
            [32.927891480000085, -13.895636494999863],
            [32.930061890000104, -13.910519306999987],
            [32.93615970900004, -13.92622894199988],
            [32.9444279380001, -13.9329468789999],
            [32.9625146890001, -13.932016702999945],
            [32.97057621200008, -13.93604746499993],
            [32.97626062000012, -13.94452239999994],
            [32.97667403100013, -13.949793395999876],
            [32.974813680000125, -13.955477803999912],
            [32.9712996830001, -14.005914000999923],
            [32.97646732600009, -14.021106871999862],
            [32.99982507400006, -14.050459085999918],
            [33.018170206000036, -14.046221618999965],
            [33.04943444800011, -13.996612244],
            [33.0629736730001, -13.981729430999863],
            [33.07692631100008, -13.974494729999975],
            [33.111601196000095, -13.964572854999886],
            [33.12064457200006, -13.955891214999923],
            [33.13025638900007, -13.930569762999951],
            [33.140281616000095, -13.92498870799993],
            [33.1545443120001, -13.93656422899997],
            [33.185653524000145, -13.993821715999928],
            [33.202706747000036, -14.013872171999893],
            [33.13004968300004, -14.038056741999952],
            [33.042923217000066, -14.067098896999937],
            [32.9171427820001, -14.109060159999942],
            [32.74495690900011, -14.166421],
            [32.57680179900012, -14.222541604999975],
            [32.42549320400008, -14.272977802999975],
            [32.32038334100014, -14.30801442499991],
            [32.22736576300014, -14.339020283999929],
            [32.147060587000055, -14.353386331999928],
            [32.10876835100004, -14.36485849999994],
            [32.03326908400004, -14.39875823899996],
            [31.932913452000037, -14.431107685999862],
            [31.801345256000104, -14.473585712999892],
            [31.658408244000043, -14.519577737999981],
            [31.589678589000073, -14.554821064999956],
            [31.49666101100013, -14.602570087999936],
            [31.410878133000097, -14.633575947999958],
            [31.30680179900014, -14.658173928999943],
            [31.17802412900005, -14.688559671999897],
            [31.07446455900009, -14.713054300999957],
            [31.056584513000132, -14.714397887999922],
            [30.91509444200011, -14.746023863999909],
            [30.815772339000034, -14.768244730999953],
            [30.676969441000097, -14.81764739999997],
            [30.591806682000083, -14.848136494999949],
            [30.48555993700012, -14.88596364299994],
            [30.39249068200013, -14.931025492999979],
            [30.31843835500007, -14.96699228999995],
            [30.230898478000086, -14.977224222999936],
            [30.214465373000053, -14.981461690999893],
            [30.214420897000082, -14.981965750999933],
            [30.21384525500008, -14.988489684999891],
            [30.22097660300011, -15.018358662999916],
            [30.22097660300011, -15.063007099999936],
            [30.225834188000135, -15.10631195099991],
            [30.263144572000044, -15.231265563999955],
            [30.28794926000012, -15.278911233999906],
            [30.320505412000045, -15.299478453999896],
            [30.334871460000045, -15.304749450999921],
            [30.347480509000093, -15.317875264999898],
            [30.35791914900011, -15.335651956999925],
            [30.36494714300011, -15.354152119999938],
            [30.369184611000094, -15.374719339999928],
            [30.371768432000067, -15.439831644999927],
            [30.374920695000128, -15.451303811999935],
            [30.38964847800014, -15.471147562999931],
            [30.392852417000086, -15.480759378999949],
            [30.39016524200008, -15.490784606999881],
            [30.371768432000067, -15.525407816999888],
            [30.365257202000123, -15.547421976999956],
            [30.367427613000075, -15.561271259999927],
            [30.395953003000045, -15.590623473999898],
            [30.40122399900008, -15.598478291999925],
            [30.412696167000092, -15.627933857999935],
            [30.410370728000146, -15.630414326999912],
            [30.396263061000127, -15.63599538099993],
            [30.35667891500009, -15.65149831099994],
            [30.328050171000086, -15.65242848699998],
            [30.29619621200004, -15.639041585999905],
            [30.280094442000063, -15.632274677999916],
            [30.254876343000035, -15.628864033999974],
            [30.24609134900004, -15.632067972999948],
            [30.23100183100013, -15.644677022999886],
            [30.223147013000073, -15.64974131299995],
            [30.207230672000094, -15.653151956999892],
            [30.19555179800011, -15.649121194999893],
            [30.169920288000128, -15.632171324999973],
            [30.13012943500013, -15.623696390999982],
            [30.090028523000115, -15.629380797999929],
            [30.050237670000115, -15.640129495999943],
            [30.010653524000077, -15.646227314999905],
            [29.967503702000045, -15.641473083999912],
            [29.881772502000047, -15.618838805999957],
            [29.83733077000005, -15.614808044999876],
            [29.8142830810001, -15.619665628999897],
            [29.773251994000077, -15.638062438999981],
            [29.730050496000104, -15.644677022999886],
            [29.672793009000145, -15.663280537999938],
            [29.648505086000057, -15.66658782999994],
            [29.62798954300007, -15.66359059599992],
            [29.60855920400013, -15.658422952999913],
            [29.58721683800013, -15.655735778999897],
            [29.56344567900004, -15.662143655999927],
            [29.526238647000127, -15.692839456999963],
            [29.508461955000087, -15.703588154999892],
            [29.42205896000013, -15.711029561999908],
            [29.406969442000047, -15.714233499999892],
            [29.186311076000067, -15.812832132999873],
            [29.150964396000063, -15.848798929999944],
            [29.1418693440001, -15.854483337999895],
            [29.121715535000135, -15.859340921999916],
            [29.102181844000114, -15.870916442999956],
            [29.086162150000064, -15.884559019999955],
            [29.076343628000103, -15.895411070999913],
            [29.055052938000102, -15.934375101999905],
            [29.04234053600007, -15.946260680999927],
            [29.018052612000076, -15.950601500999909],
            [28.97278405800006, -15.951428323999934],
            [28.951286662000115, -15.955252379999962],
            [28.9468615990001, -15.957235194999981],
            [28.932373087000087, -15.963727314999872],
            [28.898886760000096, -15.995456643999901],
            [28.877182658000095, -16.02201832999991],
            [28.874082072000135, -16.0289429729999],
            [28.86033614100012, -16.04940683999986],
            [28.857235555000074, -16.060465595999958],
            [28.859302612000135, -16.069560648999925],
            [28.86385013900008, -16.07658864399994],
            [28.868501017000114, -16.082169697999944],
            [28.87098148600009, -16.087233988999927],
            [28.865400431000097, -16.12123708099996],
            [28.852481323000063, -16.162784931999866],
            [28.847106975000116, -16.202679138],
            [28.864160197000047, -16.23120452899994],
            [28.840285685000055, -16.284741311999895],
            [28.836771688000113, -16.306342060999953],
            [28.84049239100011, -16.323601989999943],
            [28.857028849000102, -16.36545989999992],
            [28.857235555000074, -16.38819753],
            [28.833050985000085, -16.42643808999989],
            [28.829123576000114, -16.43460296699992],
            [28.822508992000024, -16.470776468999944],
            [28.808866414000107, -16.486279397999866],
            [28.76928226700008, -16.51521819999992],
            [28.76111739100014, -16.532271423999944],
            [28.741376994000092, -16.55066823299994],
            [28.732850382000066, -16.558109638999966],
            [28.718794393000053, -16.56028004999996],
            [28.690734090000035, -16.56028004999996],
            [28.643295126000055, -16.568754984999956],
            [28.28011316000007, -16.706524352999892],
            [28.21252038500009, -16.748588968999925],
            [28.113921753000113, -16.827550557999885],
            [28.022992543000072, -16.865393042999884],
            [27.86856205200013, -16.929663186999917],
            [27.816885620000107, -16.95963551799987],
            [27.777301473000136, -17.00118336999995],
            [27.64118575100005, -17.198483987999865],
            [27.624855998000015, -17.233313903999928],
            [27.60449548300008, -17.312792256999927],
            [27.57731368000009, -17.3631251019999],
            [27.524293661000087, -17.41511159299992],
            [27.422077677000118, -17.504821878999905],
            [27.157080932000042, -17.769301859999956],
            [27.146952352000085, -17.783874613999913],
            [27.14529870600012, -17.794106546999984],
            [27.14653894000014, -17.81891123499993],
            [27.14901940900012, -17.842475686999933],
            [27.115429728000095, -17.882163186999918],
            [27.07817102000007, -17.916993102999896],
            [27.048457072000105, -17.944278259999905],
            [27.021275269000114, -17.95854095399997],
            [27.006289103000142, -17.9626750689999],
            [26.95916019700013, -17.964742126999866],
            [26.948669881000086, -17.96887624099989],
            [26.912031291000034, -17.99202728199988],
            [26.888260132000084, -17.984585875999954],
            [26.79400231900007, -18.026237080999877],
            [26.76971439600007, -18.02902760799992],
            [26.75359135000008, -18.032955017],
            [26.740568889000144, -18.040499775999947],
            [26.711940145000085, -18.06582122799992],
            [26.70000288900013, -18.069231871999946],
            [26.68568851700013, -18.066751403999973],
            [26.628844442000087, -18.0491814169999],
            [26.612721395000108, -18.041223245999944],
            [26.59887211100005, -18.02995778399989],
            [26.583369181000137, -18.01321461999993],
            [26.570243367000074, -18.002879332999925],
            [26.553603557000145, -17.99647145599998],
            [26.527145223000076, -17.99202728199988],
            [26.485494018000054, -17.979314880999922],
            [26.40859948700006, -17.939007262999965],
            [26.3627108150001, -17.930635680999984],
            [26.32550378500008, -17.93601002999995],
            [26.31826908400012, -17.934356383999912],
            [26.311964559000103, -17.928361917999965],
            [26.30379968300008, -17.92278086399996],
            [26.294291219000087, -17.918543395999905],
            [26.24829919400011, -17.91337575299991],
            [26.23920414200012, -17.910171813999938],
            [26.233933146000084, -17.903970641999948],
            [26.228248739000065, -17.894668883999927],
            [26.22111739100012, -17.88629730299995],
            [26.211918986000114, -17.88278330499989],
            [26.203030640000094, -17.8872274779999],
            [26.167477254000033, -17.91358245799995],
            [26.158588908000127, -17.918336689999947],
            [26.13543786600013, -17.922574157999904],
            [26.11859134900007, -17.93156585699994],
            [26.101228068000125, -17.935803324999895],
            [26.09523360200012, -17.93807708699991],
            [26.094200073000138, -17.941901143999957],
            [26.096163777000072, -17.954613544999916],
            [26.09523360200012, -17.95854095399997],
            [26.08117761200009, -17.962365010999918],
            [26.06247074300012, -17.962881774999957],
            [26.046554402000083, -17.96629241899997],
            [26.04055993600005, -17.978488056999893],
            [26.03373864800011, -17.97156341499992],
            [25.9785482180001, -17.998951924999957],
            [25.966972697000074, -18.000502216999877],
            [25.924494670000115, -17.998951924999957],
            [25.86361983200007, -17.97156341499992],
            [25.85349125200011, -17.95998789499997],
            [25.846153198000138, -17.943658141999933],
            [25.84749678500009, -17.92939544599996],
            [25.86361983200007, -17.92381439199994],
            [25.849667196000098, -17.906657815999978],
            [25.80439864100009, -17.888157653999954],
            [25.79468347100004, -17.872654723999943],
            [25.78600183100008, -17.8622160849999],
            [25.765951375000043, -17.849813740999934],
            [25.743833862000116, -17.839375101999906],
            [25.70642012500008, -17.829866637999913],
            [25.69422448700007, -17.819427998999885],
            [25.68140873200008, -17.811469827999915],
            [25.657017456000062, -17.81395029699989],
            [25.603997436000043, -17.836171162999932],
            [25.53681807400008, -17.848676858999923],
            [25.53092696200008, -17.850950621999942],
            [25.522141967000096, -17.860149027999938],
            [25.516457561000067, -17.86231943799993],
            [25.510153035000144, -17.861182555999918],
            [25.5007479250001, -17.85601491199992],
            [25.495580281000088, -17.854878030999913],
            [25.420287719000044, -17.854878030999913],
            [25.409539021000114, -17.85301767999991],
            [25.376466105000105, -17.84123545299991],
            [25.345253540000044, -17.842579039999876],
            [25.335538371000098, -17.84123545299991],
            [25.315901327000063, -17.832140400999933],
            [25.285412231000066, -17.809299417999924],
            [25.266705363000085, -17.800927835999943],
            [25.259780721000112, -17.794106546999984],
            [25.253476196000094, -17.78149749799988],
            [25.242417440000082, -17.770335387999936],
            [25.228878215000123, -17.762480570999912],
            [25.215132283000088, -17.759276630999935],
            [25.198182414000087, -17.758449808999913],
            [25.19074100700007, -17.755349222999968],
            [25.177821899000037, -17.738812763999974],
            [25.17244755100009, -17.73509206099996],
            [25.161182088000118, -17.729407652999924],
            [25.15684126800005, -17.725170185999957],
            [25.155290975000128, -17.719382425999896],
            [25.15642785600005, -17.706670023999934],
            [25.15332727100008, -17.700985615999898],
            [25.13854781100008, -17.686102803999944],
            [25.13141646300005, -17.686516214999955],
            [25.122631469000055, -17.697885029999952],
            [25.12004764800014, -17.69106374099991],
            [25.1150867100001, -17.68424245199995],
            [25.107955363000144, -17.678868102999985],
            [25.098756958000052, -17.676801045999923],
            [25.096896606000143, -17.672150166999955],
            [25.08852502400009, -17.64269460099996],
            [25.085217732000075, -17.64093760199998],
            [25.067027628000034, -17.62533131899994],
            [25.06423710100009, -17.621507263],
            [25.052558227000105, -17.621403909999884],
            [25.04532352700005, -17.61995696999989],
            [25.0400525310001, -17.616132913999934],
            [25.03385135900004, -17.608484801999865],
            [25.03385135900004, -17.60156015999989],
            [25.04056929500007, -17.584506936999944],
            [25.036951945000084, -17.581199645999945],
            [25.026720011000094, -17.582749938999967],
            [25.008013142000095, -17.588537699999947],
            [24.99850468000011, -17.588020934999903],
            [24.982588338000085, -17.576548766999892],
            [24.971116170000073, -17.5607357789999],
            [24.969987330000038, -17.55996247899995],
            [24.95799035600001, -17.551744078999945],
            [24.937629842000092, -17.5607357789999],
            [24.924917439000126, -17.542959085999954],
            [24.898252400000075, -17.53107350699993],
            [24.829522745000105, -17.51774098699991],
            [24.797380005000065, -17.519084573999876],
            [24.786838013000107, -17.51691416399997],
            [24.780016723000074, -17.512263284999918],
            [24.77505578600011, -17.507612405999865],
            [24.769784790000074, -17.50544199599996],
            [24.68441532400007, -17.492419534999925],
            [24.63945682800008, -17.492419534999925],
            [24.629741659000047, -17.49552012099987],
            [24.622817017000045, -17.50234140999993],
            [24.61744266800008, -17.509162698999972],
            [24.606487264000094, -17.51515716599991],
            [24.591294393000084, -17.528386331999897],
            [24.580752401000012, -17.532830504999907],
            [24.571243937000133, -17.53345062299988],
            [24.562458944000042, -17.53221038799994],
            [24.54654260300012, -17.526525979999903],
            [24.537860962000053, -17.520324808999916],
            [24.531659790000077, -17.513400165999926],
            [24.523598267000096, -17.507819111999908],
            [24.498173462000068, -17.503478291999926],
            [24.47925988800006, -17.49448659299989],
            [24.449287557000105, -17.489112242999923],
            [24.4070162350001, -17.47453948999997],
            [24.3889294840001, -17.471335549999907],
            [24.371256144000085, -17.47371266599994],
            [24.32939823400011, -17.485081481999927],
            [24.32133671100013, -17.488698831999912],
            [24.310277954000128, -17.482601012999865],
            [24.257361287000066, -17.48084401399997],
            [24.23875777100008, -17.478156839999954],
            [24.22046431400011, -17.47950042699992],
            [24.19090539600009, -17.4852881879999],
            [24.14811730900007, -17.49376312199989],
            [24.10532922400006, -17.5022380569999],
            [24.06254113700001, -17.510712991999895],
            [24.01964969900007, -17.519084573999876],
            [23.976964965000064, -17.52755950899997],
            [23.934176880000052, -17.536034443999966],
            [23.891388794000108, -17.544406025999947],
            [23.848497355000063, -17.552880960999957],
            [23.805605916000104, -17.561355895999952],
            [23.762817831000092, -17.569727477999933],
            [23.720029744000044, -17.57820241299993],
            [23.677241659000117, -17.586677347999938],
            [23.634556925000112, -17.59504892999992],
            [23.5917688400001, -17.603523864999914],
            [23.54877404800004, -17.611998799999924],
            [23.505985962000096, -17.620473733999916],
            [23.476220337000115, -17.626364847999923],
            [23.4574101150001, -17.626778258999934],
            [23.422373494000084, -17.633496194999864],
            [23.381652466000105, -17.641144306999934],
            [23.37596805800007, -17.62822519999993],
            [23.375141235000058, -17.615409443999937],
            [23.382272583000088, -17.601043395999938],
            [23.35943160000008, -17.582853291999896],
            [23.340621379000055, -17.5607357789999],
            [23.320157512000094, -17.546369730999885],
            [23.305378051000076, -17.539548441999926],
            [23.290805298000123, -17.535414326999913],
            [23.258352498000107, -17.532830504999907],
            [23.241299275000074, -17.535104267999927],
            [23.22424605300006, -17.539341735999884],
            [23.20698612500007, -17.54120208699989],
            [23.189726196000066, -17.53655120799992],
            [23.177530558000058, -17.524045511999915],
            [23.176910441000075, -17.50978281599994],
            [23.179080852000084, -17.494176533999905],
            [23.176186971000078, -17.478156839999954],
            [23.165748332000135, -17.467408141999925],
            [23.121513306000026, -17.45087168299993],
            [23.097638794000147, -17.432164814999865],
            [23.073040812000073, -17.4050863639999],
            [23.054127238000035, -17.375320739999907],
            [23.046375773000108, -17.34844899399991],
            [23.040381307000075, -17.337080179999916],
            [22.998626750000142, -17.293775328999956],
            [22.9841573490001, -17.28581715899989],
            [22.936511678000073, -17.273311461999896],
            [22.87615360500007, -17.24809336299994],
            [22.84917850700012, -17.23104014099991],
            [22.80938765500011, -17.196416930999902],
            [22.778278442000072, -17.18039723699995],
            [22.765152628000095, -17.169648538999922],
            [22.755850871000092, -17.154869079999912],
            [22.744792114000063, -17.10825693699995],
            [22.73073612500005, -17.0815918979999],
            [22.710478963000043, -17.055443623999906],
            [22.665623820000064, -17.008624775999877],
            [22.651671183000076, -16.998702900999973],
            [22.59203658100006, -16.975448505999864],
            [22.579324178000036, -16.97534515399994],
            [22.573433064000113, -16.971004332999954],
            [22.569195597000146, -16.96242604499993],
            [22.569298950000103, -16.944959411999974],
            [22.56723189300004, -16.93689788799989],
            [22.554519491000065, -16.924185485999928],
            [22.52289351400009, -16.91467702199995],
            [22.50852746600009, -16.906202087999944],
            [22.499742472000094, -16.893489684999892],
            [22.489097127000093, -16.865377705999947],
            [22.416646769000124, -16.75448008199993],
            [22.40889530400011, -16.745798441999867],
            [22.39959354600009, -16.740424091999913],
            [22.383573853000115, -16.737530211999925],
            [22.377992798, -16.73484303799998],
            [22.372618449000043, -16.72884857199996],
            [22.365797160000085, -16.71685963999991],
            [22.350087524000116, -16.69629241999992],
            [22.34347294100013, -16.683166605999943],
            [22.333654419000055, -16.673658141999866],
            [22.30698937900013, -16.669213968999955],
            [22.303061971000147, -16.666940205999936],
            [22.295620565000036, -16.659188740999937],
            [22.290762980000096, -16.65639821399988],
            [22.287352335000094, -16.658258564999883],
            [22.28373498500011, -16.661359150999928],
            [22.27412316900009, -16.663632914999937],
            [22.259033651000095, -16.669213968999955],
            [22.251282186000083, -16.67004079199998],
            [22.237742961000095, -16.66549326599994],
            [22.151650025, -16.597693786999926],
            [22.145138794000047, -16.584051208999924],
            [22.142451619000013, -16.56710133899992],
            [22.13811079900003, -16.55263193799989],
            [22.127258748000088, -16.546430764999897],
            [22.108138469000096, -16.543950296999924],
            [22.104004354000068, -16.536715595999866],
            [22.10658817500007, -16.525966897999936],
            [22.107311646000056, -16.512324319999934],
            [22.10173059100015, -16.49795827199992],
            [22.0845740150001, -16.47015635199996],
            [22.07992313600002, -16.45775400799991],
            [22.08074995900006, -16.441010843999948],
            [22.086020955000095, -16.422303974999878],
            [22.094289184000047, -16.404733987999904],
            [22.103590943000142, -16.391918232999913],
            [22.105554646000087, -16.379412536999922],
            [22.089121542000044, -16.37197113099998],
            [22.055841919000073, -16.364633076999908],
            [22.054188273000136, -16.35863861099996],
            [22.053671508000093, -16.33652109699996],
            [22.05201786300006, -16.326805927999928],
            [22.048607218000114, -16.32236175599992],
            [22.03661828600005, -16.31223317399987],
            [22.032174113000053, -16.306342060999953],
            [22.027729940000143, -16.291665953999967],
            [22.025972941000077, -16.278953552999923],
            [22.022355590000075, -16.2663445029999],
            [22.011710246000092, -16.252288512999968],
            [22.019875122000116, -16.253115335999908],
            [22.0451965740001, -16.252288512999968],
            [22.010366658000123, -16.198131611999955],
            [21.983804972000115, -16.1658855189999],
            [21.9815312100001, -16.144284769999928],
            [21.9815312100001, -16.128161721999945],
            [21.9815312100001, -16.06749359099996],
            [21.9815312100001, -16.00403493299993],
            [21.98060103400013, -16.001244404999866],
            [21.980807739000085, -15.956079202999902],
            [21.980911092000042, -15.853966572999951],
            [21.981221150000096, -15.75195729599993],
            [21.981427856000067, -15.649948017999918],
            [21.9815312100001, -15.547835387999967],
            [21.9815312100001, -15.503807067999915],
            [21.9815312100001, -15.47352467899988],
            [21.9815312100001, -15.452337340999918],
            [21.9815312100001, -15.412546487999919],
            [21.981427856000067, -15.261858011999962],
            [21.981324503000053, -15.11116953499993],
            [21.981221150000096, -14.960481058999974],
            [21.98111779800007, -14.809792581999943],
            [21.98101444500014, -14.659104104999898],
            [21.980911092000042, -14.508415628999956],
            [21.980807739000085, -14.357623798999981],
            [21.98070438600007, -14.20693532299994],
            [21.98060103400013, -14.056350198999922],
            [21.980497681000116, -13.905558369999952],
            [21.980394328000074, -13.754973245999935],
            [21.98035310000006, -13.694822054999918],
            [21.98029097400007, -13.60418141599996],
            [21.98018762200013, -13.453492939999919],
            [21.980084269000088, -13.302701109999944],
            [21.979980916000073, -13.152167663999947],
            [21.97987756300006, -13.001479186999916],
            [22.104211059000107, -13.001479186999916],
            [22.2285445550001, -13.001479186999916],
            [22.352774698000076, -13.001479186999916],
            [22.477004842000014, -13.001479186999916],
            [22.601234985000076, -13.001479186999916],
            [22.72546512800011, -13.001479186999916],
            [22.84979862500009, -13.001479186999916],
            [22.974028768000068, -13.001479186999916],
            [23.09836226400006, -13.001479186999916],
            [23.222695760000107, -13.001479186999916],
            [23.346925903000084, -13.001479186999916],
            [23.471259399000076, -13.001479186999916],
            [23.59559289500004, -13.001479186999916],
            [23.71982303900009, -13.001479186999916],
            [23.84415653500008, -13.001479186999916],
            [23.9682833250001, -13.001479186999916],
            [24.000632772000102, -13.001479186999916],
            [23.988850545000105, -12.965098978999919],
            [23.97179732200007, -12.933369649999904],
            [23.94957645700012, -12.904637552999901],
            [23.895109497000107, -12.849757181999891],
            [23.874748983000103, -12.82174855499997],
            [23.86565393100011, -12.78970916699997],
            [23.872268514000012, -12.750125020999917],
            [23.891698853000094, -12.705063170999964],
            [23.91071577900007, -12.631269225999915],
            [23.928699178000045, -12.561609394999891],
            [23.94079146300004, -12.532773945999864],
            [23.986060018000046, -12.467661640999964],
            [24.019856405000013, -12.419189147999901],
            [24.02802128100012, -12.402135924999868],
            [24.030811808000095, -12.385082702999924],
            [24.020993286000135, -12.340020852999885],
            [24.016859171000107, -12.278939310999888],
            [24.006627238000107, -12.253721211999931],
            [23.981305786000036, -12.227676289999863],
            [23.959601685000052, -12.19667043099993],
            [23.954330689000102, -12.151918639999877],
            [23.961048624000057, -12.011668802999878],
            [23.96704309100008, -11.882891132999887],
            [23.988540487000108, -11.834211933999953],
            [23.990194132000056, -11.82408335399991],
            [23.98554325300009, -11.799485371999921],
            [23.981305786000036, -11.724761250999919],
            [23.972727498000012, -11.70057667999994],
            [23.96228885900007, -11.681559752999888],
            [23.9546407470001, -11.66223276699992],
            [23.9546407470001, -11.636911315999939],
            [23.959911743000134, -11.61717091899989],
            [23.97768843600005, -11.577276712999947],
            [24.005387004000085, -11.535212096999913],
            [24.009727824000066, -11.523429869999916],
            [24.00983117700008, -11.507203470999912],
            [24.00724735500009, -11.483122252999863],
            [24.007557414000075, -11.470513203999928],
            [24.009934530000123, -11.459454446999928],
            [24.020786581000067, -11.444571634999889],
            [24.052102499000085, -11.42049041699994],
            [24.061714315000103, -11.406951191999966],
            [24.061094197000017, -11.394962259999915],
            [24.016962525000025, -11.298430684999886],
            [24.011174764000145, -11.272902525999939],
            [24.01530887800007, -11.13048227899995],
            [23.995775187000078, -11.127381693999908],
            [23.990090779000127, -11.113532408999944],
            [23.99453495300014, -11.074981790999871],
            [23.9937081300001, -11.019584654999917],
            [23.997325480000086, -11.001704609999948],
            [24.00373335800012, -10.982480977999927],
            [24.000012654000045, -10.967804869999938],
            [23.98058231600004, -10.938349303999942],
            [23.974277791000134, -10.921399433999937],
            [23.96745650200009, -10.872306822999903],
            [24.001459595000114, -10.873443704999914],
            [24.048381796000058, -10.882332051999924],
            [24.091479939000067, -10.897834980999932],
            [24.11421757000005, -10.919229023999947],
            [24.114320923000093, -10.92791066399991],
            [24.10873986800007, -10.94579070999987],
            [24.108016398000075, -10.954989114999961],
            [24.11049686700005, -10.965944518999933],
            [24.117524862000067, -10.986098327999912],
            [24.119385213000072, -10.997570494999934],
            [24.117731567000106, -11.030850117999876],
            [24.12424279700008, -11.043252461999941],
            [24.144396606000072, -11.040358581999953],
            [24.16455041500012, -11.03395070399992],
            [24.181293579000084, -11.03446746799996],
            [24.21829390400012, -11.04521616599989],
            [24.238034302000102, -11.048006692999934],
            [24.275137980000068, -11.047903340999909],
            [24.293844848000077, -11.050280456999957],
            [24.31637577300009, -11.060098978999918],
            [24.345314575000145, -11.078289082999959],
            [24.37053267400009, -11.100199889999914],
            [24.38179813600007, -11.120560403999946],
            [24.3782841390001, -11.1321359249999],
            [24.369912557000134, -11.140920918999882],
            [24.362471151000108, -11.150532734999985],
            [24.36174768000012, -11.164692077999945],
            [24.367432088000072, -11.176267597999896],
            [24.384381958000063, -11.191253763999953],
            [24.391306600000036, -11.199832051999891],
            [24.39657759600007, -11.21740203799996],
            [24.397817830000122, -11.238279316999936],
            [24.396060832000046, -11.259673359999852],
            [24.39223677600009, -11.279103698999933],
            [24.384485311000077, -11.295226745999912],
            [24.35244592300009, -11.34504282599994],
            [24.339940226000095, -11.358065286999889],
            [24.298289022000063, -11.37057098299988],
            [24.285473266000082, -11.381216328999884],
            [24.29394820100009, -11.399199726999953],
            [24.31007124900006, -11.40664113299988],
            [24.351722453000093, -11.407054544999895],
            [24.370222615000102, -11.41015513099994],
            [24.392546834000086, -11.423384296999927],
            [24.426446574000096, -11.454080098999967],
            [24.446497030000046, -11.463588561999956],
            [24.469648071000023, -11.46555226599989],
            [24.490938762000013, -11.461521504999894],
            [24.53269331800007, -11.446121927999911],
            [24.542511840000117, -11.445398457999914],
            [24.5541907140001, -11.446328632999965],
            [24.564732707000076, -11.444674987999917],
            [24.571243937000133, -11.436406757999876],
            [24.574447876000107, -11.42514129699991],
            [24.578581990000117, -11.415632832999918],
            [24.584576456000065, -11.407364603999966],
            [24.593258097000103, -11.399613138999968],
            [24.60224979700007, -11.395685729999911],
            [24.624677369000068, -11.390828144999887],
            [24.63521936000012, -11.385867207999937],
            [24.645037882000082, -11.376048685999962],
            [24.66333134000007, -11.351657409999945],
            [24.674080037000067, -11.341632180999923],
            [24.712527303000115, -11.326025899999877],
            [24.787974894000115, -11.325819192999916],
            [24.826732218000046, -11.317550963999878],
            [24.901042928000038, -11.28127410799992],
            [24.9429008380001, -11.26856170699996],
            [24.981244751000133, -11.27186899799996],
            [25.124285116000095, -11.259156595999912],
            [25.184023071000126, -11.246650898999917],
            [25.27879764800008, -11.199935403999916],
            [25.31032027200004, -11.194767760999909],
            [25.32251591000005, -11.20541310599991],
            [25.32458296700011, -11.227840677999907],
            [25.32334273300009, -11.25347218799996],
            [25.325409790000037, -11.273936054999922],
            [25.324893025000108, -11.283651223999868],
            [25.317141561000085, -11.290472513999916],
            [25.29626428200004, -11.298430684999886],
            [25.28468876100007, -11.307319030999892],
            [25.290166463000077, -11.315897317999926],
            [25.30132857300009, -11.324475605999865],
            [25.306496216000113, -11.333053893999889],
            [25.298021281000103, -11.351450703999888],
            [25.28634240700012, -11.36064910899998],
            [25.277970825000068, -11.37181121799992],
            [25.27900435400005, -11.396305846999965],
            [25.286652465000117, -11.416563008999972],
            [25.309286743000058, -11.455423685999932],
            [25.316728149000085, -11.472993671999916],
            [25.315384562000105, -11.482502135999894],
            [25.301741984000103, -11.498418476999916],
            [25.297711223000107, -11.507926939999905],
            [25.29750451600006, -11.51722869899993],
            [25.300398397000066, -11.53500539099987],
            [25.327373494000085, -11.616654154999935],
            [25.33677860500012, -11.633500671999926],
            [25.344943482000048, -11.642182311999889],
            [25.351971477000063, -11.646109720999945],
            [25.360446411000055, -11.647246601999953],
            [25.373158813000117, -11.647143249999928],
            [25.38638798000011, -11.649830423999958],
            [25.392795858000056, -11.656445007999949],
            [25.39755008900005, -11.664919942999859],
            [25.406335083000045, -11.673084817999964],
            [25.46359257000009, -11.700059915999901],
            [25.48116255700006, -11.715252786999926],
            [25.482816203000112, -11.720420430999937],
            [25.48328129100014, -11.725794778999898],
            [25.482816203000112, -11.731169128999866],
            [25.474134562000046, -11.756180520999948],
            [25.480439087000065, -11.769823099999954],
            [25.495580281000088, -11.776541035999884],
            [25.515217326000112, -11.775817565999887],
            [25.524519083000143, -11.77095998199988],
            [25.530616902000105, -11.764242044999946],
            [25.53764489700012, -11.758350931999942],
            [25.550253947000044, -11.756593932999877],
            [25.561002645000144, -11.75328664099996],
            [25.564930054000115, -11.74398488299994],
            [25.567823934000103, -11.733752949999953],
            [25.575678752000044, -11.72734507199992],
            [25.621464071000077, -11.728895365999932],
            [25.655777222000097, -11.750496113999915],
            [25.687403198000112, -11.778711445999875],
            [25.725643758000103, -11.8005188999999],
            [25.744040568000088, -11.803826191999903],
            [25.801608114000118, -11.804239602999914],
            [25.812666870000044, -11.802999368999878],
            [25.832510620000022, -11.79380096399997],
            [25.83984867400011, -11.791940612999966],
            [25.850700724000063, -11.79380096399997],
            [25.855765015000145, -11.797211608999902],
            [25.859589070000084, -11.801965839999895],
            [25.91415938300011, -11.84558074899985],
            [25.935553426000126, -11.853642272999934],
            [25.94981612100011, -11.863977559999938],
            [25.963562052000043, -11.895086770999896],
            [25.9811320390001, -11.903044941999951],
            [25.99405114800004, -11.904801940999931],
            [26.166650431000107, -11.902424824999898],
            [26.189078003000105, -11.910899759999893],
            [26.209335164, -11.923612161999941],
            [26.229592326000017, -11.933120625999933],
            [26.265559123000088, -11.930846862999914],
            [26.286229696000106, -11.940562031999946],
            [26.298011922000114, -11.941182148999914],
            [26.309174032000044, -11.936531269999946],
            [26.32881107600008, -11.923302103999958],
            [26.339146362000093, -11.918961282999888],
            [26.37635339400009, -11.912863463999926],
            [26.414593953000093, -11.911829934999943],
            [26.438365112000042, -11.919064635999916],
            [26.455418335000076, -11.931983743999922],
            [26.470714559000044, -11.94696990899999],
            [26.489111369000028, -11.960819192999864],
            [26.524871460000043, -11.972291360999876],
            [26.605900106000064, -11.977769062999954],
            [26.643520548000083, -11.985520527999967],
            [26.662744181000107, -11.996579284999967],
            [26.679797404000055, -12.009601744999912],
            [26.697057333000117, -12.01745656299994],
            [26.717417847000064, -12.013012389999929],
            [26.732559042000076, -11.998336282999944],
            [26.744186239000044, -11.981179707999985],
            [26.759379109000065, -11.96867401099989],
            [26.785010620000037, -11.968363951999905],
            [26.831726115000038, -11.973324889999944],
            [26.87420414300007, -11.964333190999909],
            [26.912754761000144, -11.942525736999883],
            [26.94768802900012, -11.909142760999913],
            [26.96732507300007, -11.870385436999882],
            [26.971355835000054, -11.788529967999935],
            [26.981071004000086, -11.749049173999921],
            [26.996367228000054, -11.727035013999938],
            [27.011146688000082, -11.713185729999879],
            [27.021481975000086, -11.69788950599991],
            [27.023238973000048, -11.671121113999945],
            [27.010836629000096, -11.628849792999858],
            [27.010268189000044, -11.609832864999888],
            [27.02375573800009, -11.595570169999917],
            [27.032437378000054, -11.594329935999966],
            [27.054451538000137, -11.59753387499994],
            [27.064373413000027, -11.59712046299994],
            [27.10220056200012, -11.584924824999916],
            [27.144988647000048, -11.581307473999942],
            [27.173617391000107, -11.570558775999913],
            [27.18012862100008, -11.569628600999877],
            [27.197181844000113, -11.593709818999912],
            [27.20762048300014, -11.639391783999926],
            [27.211961304000027, -11.688277689999907],
            [27.209997599000104, -11.72197072299987],
            [27.234182169000064, -11.809097187999924],
            [27.420734090000053, -11.921958516999894],
            [27.46755293800007, -12.001643574999946],
            [27.471790405000036, -12.041641133999917],
            [27.520469605000073, -12.179617206999907],
            [27.536075887000095, -12.200081074999957],
            [27.589836216000066, -12.242957985999865],
            [27.59529707900009, -12.247313333999898],
            [27.63818851700006, -12.29361541699997],
            [27.666197143000147, -12.302710469999852],
            [27.710742228000072, -12.306327819999936],
            [27.756734252000058, -12.30426076299996],
            [27.788308553000036, -12.296509296999957],
            [27.807273803000072, -12.281419778999876],
            [27.818280884000075, -12.267777201999948],
            [27.831406698000137, -12.259922383999921],
            [27.856676473000107, -12.262402851999894],
            [27.877036987000054, -12.26994761099985],
            [27.933881062000097, -12.30333058699992],
            [27.94845381600004, -12.321417337999932],
            [27.952226196000083, -12.346532083999946],
            [27.958685750000114, -12.367822774999937],
            [27.981009969000098, -12.374540709999877],
            [27.998993367000082, -12.371440124999921],
            [28.014031209000052, -12.370509948999967],
            [28.087670125000074, -12.377537943999883],
            [28.09686853100007, -12.383015644999958],
            [28.100434204000123, -12.391490579999882],
            [28.102449585000073, -12.401205748999914],
            [28.106997111000112, -12.410197448999952],
            [28.131285034000115, -12.429214374999916],
            [28.1459611410001, -12.423116555999869],
            [28.160740601000043, -12.40875050799987],
            [28.185751994000015, -12.40244598399994],
            [28.204975626000135, -12.41081756599992],
            [28.220065145000035, -12.425390319999892],
            [28.23753177900008, -12.437069192999957],
            [28.26388675900006, -12.436965840999932],
            [28.28383386300007, -12.43407195999994],
            [28.303677612000058, -12.43541554799991],
            [28.32248783400007, -12.441099954999856],
            [28.33974776200006, -12.450505065999906],
            [28.4227401120001, -12.521301777999938],
            [28.436434367000118, -12.542799173999882],
            [28.45591638200011, -12.59209848999997],
            [28.468267049000076, -12.614629414999897],
            [28.502011760000045, -12.6495626829999],
            [28.51229537000006, -12.668372905],
            [28.511623575000073, -12.694417825999977],
            [28.500151408000136, -12.710954284999971],
            [28.48397668400014, -12.722219745999936],
            [28.474003133000053, -12.736482441999911],
            [28.48092777500011, -12.762113951999964],
            [28.50159834800013, -12.788468932999933],
            [28.523612508000014, -12.81017303399993],
            [28.53942549700011, -12.833840840999954],
            [28.542836141000038, -12.885620625999934],
            [28.55337813300011, -12.894922383999955],
            [28.568467652000095, -12.895542500999923],
            [28.583970581000102, -12.888721210999876],
            [28.593685751000066, -12.876732279999914],
            [28.60815515200008, -12.847896829999883],
            [28.621177612000025, -12.839421895999877],
            [28.66789310700011, -12.849343769999876],
            [28.707994018000107, -12.889754739999944],
            [28.775690144000095, -12.97657114599994],
            [28.7933634850001, -12.991557311999912],
            [28.80059818500007, -13.00240936299987],
            [28.80943485500009, -13.038376159999927],
            [28.813620646000118, -13.042820331999934],
            [28.827056518000063, -13.04757456399993],
            [28.830880574000105, -13.051812031999887],
            [28.830260458000055, -13.056876321999951],
            [28.82550622600013, -13.067831725999937],
            [28.8252995200001, -13.072379251999877],
            [28.826022990000098, -13.076823424999887],
            [28.82462772700009, -13.087262063999916],
            [28.82581628400004, -13.092843118999937],
            [28.829743693000097, -13.097183938999919],
            [28.835428101000048, -13.098940937999899],
            [28.840905803000027, -13.100077819999896],
            [28.844213094000025, -13.102351582999916],
            [28.853669881000087, -13.137078144999947],
            [28.863230021000106, -13.14265919999987],
            [28.8827120360001, -13.143589375999923],
            [28.89185876500008, -13.147310078999936],
            [28.903434285000117, -13.162296243999904],
            [28.934130086000067, -13.309625752999935],
            [28.95035648600006, -13.350966897999868],
            [28.980845581000068, -13.380215759999913],
            [28.993971395000102, -13.395925394999978],
            [29.010301147000064, -13.399439391999934],
            [29.028491251000105, -13.395511982999963],
            [29.046681356000136, -13.388897399999877],
            [29.065386147000112, -13.388676477999894],
            [29.072932983000072, -13.388587341999894],
            [29.098047730000104, -13.38465993199992],
            [29.122128947000135, -13.384349873999938],
            [29.1444531650001, -13.394478453999895],
            [29.153393188000052, -13.406984150999975],
            [29.16016280100007, -13.422073668999886],
            [29.168947795000065, -13.433855895999983],
            [29.184140665000086, -13.4368531289999],
            [29.194786011000076, -13.43096201599991],
            [29.2140096440001, -13.408327737999954],
            [29.227445516000046, -13.400782979999903],
            [29.25018314600004, -13.391584573999907],
            [29.308267456000124, -13.353654072999902],
            [29.449550822000106, -13.300323994999914],
            [29.47001468900004, -13.287818297999905],
            [29.527995646000136, -13.234074807999903],
            [29.551043335000088, -13.224152933999918],
            [29.574401082000122, -13.22539316799994],
            [29.592797892000135, -13.23562510199993],
            [29.60985111500014, -13.2494743849999],
            [29.629074748000107, -13.26146331799994],
            [29.64106368000006, -13.26280690499992],
            [29.64974532000008, -13.259913024999932],
            [29.65749678600008, -13.26011973099989],
            [29.666591837000055, -13.271178486999887],
            [29.669175659000075, -13.281203713999915],
            [29.667522013000053, -13.29195241199993],
            [29.66359460500007, -13.301874287999922],
            [29.658892049000087, -13.309522399999906],
            [29.651502319000087, -13.31458668999997],
            [29.633622274000118, -13.31892751099987],
            [29.62659427900013, -13.326368916999883],
            [29.625043986000094, -13.334843851999977],
            [29.62700769100013, -13.354894307999928],
            [29.625147339000137, -13.364196064999959],
            [29.618946167000047, -13.367296650999904],
            [29.60943770300014, -13.36905364999997],
            [29.60168623900006, -13.374427998999934],
            [29.60168623900006, -13.388380634999933],
            [29.6055102950001, -13.399956155999888],
            [29.610677938000094, -13.411014912999889],
            [29.617395874000124, -13.421246846999864],
            [29.626077515000077, -13.429825133999898],
            [29.64147709200006, -13.43850677499995],
            [29.663077840000142, -13.446878356999932],
            [29.70286869300014, -13.457627054999946],
            [29.767154175000087, -13.45835052399994],
            [29.78224369300011, -13.45566334999991],
            [29.797643270000094, -13.424244078999976],
            [29.79774662300008, -13.313759866999959],
            [29.797953328000062, -13.164363300999966],
            [29.798211711000135, -13.022769876999902],
            [29.798470093000105, -12.87301157599991],
            [29.798676799000077, -12.698345234999948],
            [29.798986857000045, -12.548690286999886],
            [29.799141887000076, -12.38229217599988],
            [29.799400268000056, -12.265813496999925],
            [29.79960697500013, -12.159463398999932],
            [29.799582314000133, -12.159035937999903],
            [29.799396783000134, -12.155820078999923],
            [29.799296915000127, -12.154089049999868],
            [29.756095419000076, -12.157603046999924],
            [29.73490808100013, -12.164837747999897],
            [29.701266724000106, -12.189022317999957],
            [29.648918498000057, -12.21279347699992],
            [29.631865275000052, -12.215997415999894],
            [29.621116577000123, -12.210209655999918],
            [29.603184855000052, -12.192846373999899],
            [29.590317423000045, -12.188092141999903],
            [29.576726522000058, -12.188092141999903],
            [29.56757979300005, -12.191709491999887],
            [29.553058716000123, -12.20514536599994],
            [29.533473348000086, -12.21672088599989],
            [29.489548381000077, -12.231500344999901],
            [29.474252157000137, -12.24266245499993],
            [29.46794763200012, -12.25527150399995],
            [29.455907023000123, -12.294338887999885],
            [29.45182458500011, -12.317799987999948],
            [29.448155559000043, -12.326791685999893],
            [29.446553589000075, -12.335059915999935],
            [29.450377645000117, -12.342914733999876],
            [29.480453328000124, -12.380535175999896],
            [29.496059611000135, -12.38632293699996],
            [29.511459188000117, -12.387356465999943],
            [29.52344812000007, -12.392524108999865],
            [29.52820235200005, -12.410507506999934],
            [29.524688355000137, -12.429214374999916],
            [29.514663126000073, -12.443890482999905],
            [29.499676961000034, -12.453088886999907],
            [29.480453328000124, -12.454949238999916],
            [29.47301192200007, -12.452468770999943],
            [29.46877445400014, -12.44843800799994],
            [29.465260457000056, -12.444200540999901],
            [29.459886108000035, -12.44130665999991],
            [29.453323202000036, -12.44078989699996],
            [29.43921553600012, -12.44203013099991],
            [29.432600952000087, -12.44130665999991],
            [29.405935913000064, -12.431694843999892],
            [29.364388062000046, -12.409267272999898],
            [29.356533244000047, -12.407613626999947],
            [29.316432332000147, -12.406683450999907],
            [29.304856811000093, -12.404823099999902],
            [29.295503377000045, -12.400999043999946],
            [29.28304935700004, -12.390457050999899],
            [29.265065958000093, -12.370923359999978],
            [29.254989054000134, -12.366169127999896],
            [29.17339196700007, -12.36761606799989],
            [29.14894901600013, -12.373713886999937],
            [29.128123413000083, -12.382808939999919],
            [29.111070191000124, -12.393454284999905],
            [29.100218140000095, -12.374023945999923],
            [29.0844051520001, -12.376401061999971],
            [29.067248576000026, -12.384772643999938],
            [29.052779175000097, -12.383842467999983],
            [29.042650594000037, -12.37877817799992],
            [29.03510583500008, -12.378881530999948],
            [29.0303516030001, -12.376194355999914],
            [29.02859460400012, -12.36306854299994],
            [29.026114136000047, -12.353043313999919],
            [28.944672079000043, -12.20607554099989],
            [28.918730509000085, -12.174346211999875],
            [28.85950931800008, -12.14179005899993],
            [28.850414266000115, -12.130007831999919],
            [28.84597009300009, -12.111300963999938],
            [28.835014689000047, -12.092180683999942],
            [28.82147546300004, -12.07574757899988],
            [28.808866414000107, -12.064585468999951],
            [28.773623088000136, -12.04587860099987],
            [28.7598771560001, -12.035233255999884],
            [28.754192749000083, -12.020143737999973],
            [28.751092163000123, -11.992238463999897],
            [28.741997111000046, -11.984280292999927],
            [28.70706384300007, -11.989447936999937],
            [28.68603153500004, -11.984073587999973],
            [28.63688724700009, -11.95761525399989],
            [28.62386478700006, -11.947796731999915],
            [28.60619144700007, -11.910279642999924],
            [28.592652222000083, -11.90046112099995],
            [28.569191121000102, -11.913690286999952],
            [28.566090536000075, -11.904491881999945],
            [28.554204956000035, -11.885061543999967],
            [28.549450724000053, -11.879583841999889],
            [28.54056237700013, -11.87203908199993],
            [28.531570679000083, -11.866458027999911],
            [28.521132039000037, -11.865734557999915],
            [28.507851196000047, -11.87276255299993],
            [28.49715417500005, -11.857362975999948],
            [28.488885946000096, -11.808683776999914],
            [28.4767936610001, -11.798245136999881],
            [28.460670613000104, -11.79338755299996],
            [28.45250573700011, -11.78077850399994],
            [28.442687215000035, -11.711635436999941],
            [28.439586629000075, -11.701506855999895],
            [28.425117228000147, -11.68807098399995],
            [28.418399292000117, -11.678872578999943],
            [28.42211999500006, -11.674738464999919],
            [28.4227401120001, -11.664713235999898],
            [28.405480183000122, -11.60518198599992],
            [28.399589071000037, -11.596086933999857],
            [28.38491296300012, -11.581307473999942],
            [28.377419881000094, -11.571075540999871],
            [28.36558597800007, -11.541619973999957],
            [28.360314982000148, -11.533558451999866],
            [28.355664103000095, -11.518158874999884],
            [28.354423869000044, -11.464725443999953],
            [28.357007690000046, -11.446948750999937],
            [28.40858077000007, -11.372431334999888],
            [28.411991414000084, -11.368400573999892],
            [28.434212280000025, -11.35124399799993],
            [28.439586629000075, -11.348246764999914],
            [28.431990194000036, -11.311039733999905],
            [28.436175985000148, -11.28912892699995],
            [28.445581096000126, -11.274556172999894],
            [28.4550895590001, -11.263704121999936],
            [28.473693074000067, -11.225670266999913],
            [28.472452840000102, -11.191977232999946],
            [28.473693074000067, -11.181228534999931],
            [28.47622522000006, -11.17544077599996],
            [28.484751831000068, -11.162831725999936],
            [28.48733565200007, -11.153426614999972],
            [28.48692224100006, -11.140920918999882],
            [28.47617354300013, -11.087694193999923],
            [28.4767936610001, -11.077979023999973],
            [28.49095300300013, -11.058652038999924],
            [28.504078816000117, -11.034364115999935],
            [28.507851196000047, -11.023615417999906],
            [28.50862634300006, -11.01348683599987],
            [28.50666263800011, -10.992092793999944],
            [28.507851196000047, -10.982067565999927],
            [28.513793986000053, -10.97286916099992],
            [28.53136397300011, -10.95509246799989],
            [28.535084676000054, -10.944447122999904],
            [28.53735843900006, -10.93411183699989],
            [28.54717696100002, -10.913751322999957],
            [28.549450724000053, -10.902899271999914],
            [28.549450724000053, -10.85856089299996],
            [28.554411662000092, -10.834996438999951],
            [28.56350671400014, -10.811948750999903],
            [28.576529174000086, -10.790658060999917],
            [28.593479044000105, -10.772881367999972],
            [28.600920451000036, -10.76316619899994],
            [28.608051798000076, -10.741358744999914],
            [28.623244670000076, -10.716864114999865],
            [28.627585490000058, -10.711696471999872],
            [28.633476604000066, -10.708905944999898],
            [28.64618900500011, -10.709836120999867],
            [28.65187341300006, -10.708389179999955],
            [28.665877726000076, -10.697433776999972],
            [28.681535685000114, -10.681930846999876],
            [28.694351440000105, -10.66332733099992],
            [28.69962243600014, -10.643173522999945],
            [28.69424808800008, -10.636765644999898],
            [28.67089034100013, -10.619092304999896],
            [28.665515991000063, -10.608963724999853],
            [28.667169637000114, -10.597388203999898],
            [28.67269901600011, -10.576097513999912],
            [28.672337280000136, -10.564315286999914],
            [28.648049357000048, -10.537650247999878],
            [28.63492354300007, -10.519460143999922],
            [28.634716838000116, -10.50571421299989],
            [28.638747599000112, -10.496205748999913],
            [28.630479370000046, -10.481012878999891],
            [28.634716838000116, -10.471607767999927],
            [28.640607950000117, -10.462616067999889],
            [28.644535360000077, -10.451040547999938],
            [28.646085653000085, -10.438431497999915],
            [28.644948771000088, -10.426545918999892],
            [28.63771407100012, -10.407012226999967],
            [28.62861901900004, -10.391095885999945],
            [28.620867554000142, -10.373319192999915],
            [28.617766968000097, -10.34830779999993],
            [28.620712524000112, -10.327327167999925],
            [28.62644860900005, -10.311410826999904],
            [28.62923913600011, -10.295907897999896],
            [28.62386478700006, -10.276374205999971],
            [28.62210778800008, -10.275857441999932],
            [28.6133227950001, -10.270689798999939],
            [28.610842326000125, -10.268829447999934],
            [28.608051798000076, -10.263558450999895],
            [28.6059847410001, -10.252913106999912],
            [28.60402103700008, -10.24836557999987],
            [28.56991459200009, -10.219633483999957],
            [28.57931970200005, -10.20113332099993],
            [28.60402103700008, -10.172711282999913],
            [28.619627319000102, -10.141912129999938],
            [28.628515665000123, -10.102741393999906],
            [28.63125451600007, -10.02305633499995],
            [28.62386478700006, -9.951019388999967],
            [28.62794722400008, -9.92941863999991],
            [28.65869470200002, -9.864823099999867],
            [28.668461548000067, -9.821621601999922],
            [28.678073364000085, -9.803844908999892],
            [28.696521851000085, -9.796506855999894],
            [28.698485555000047, -9.791959329999955],
            [28.672337280000136, -9.765500995999972],
            [28.669960165000077, -9.750928242999919],
            [28.66365564000006, -9.745037128999911],
            [28.654973999000106, -9.74193654399997],
            [28.644948771000088, -9.735115253999922],
            [28.63125451600007, -9.715581562999915],
            [28.625156697000108, -9.69563445999998],
            [28.62386478700006, -9.64912567099995],
            [28.621797730000083, -9.638273620999911],
            [28.612909383000073, -9.61749969499995],
            [28.610842326000125, -9.607887878999946],
            [28.60650150500004, -9.594348652999969],
            [28.587587931000087, -9.573161315999911],
            [28.583557169000102, -9.563756204999947],
            [28.58862146000007, -9.558278503999873],
            [28.611100708000095, -9.5510438029999],
            [28.617766968000097, -9.543292337999986],
            [28.586296021000067, -9.544015807999898],
            [28.574100383000143, -9.539158223999962],
            [28.569191121000102, -9.525929056999885],
            [28.568726033000075, -9.50897918699988],
            [28.56686568200007, -9.495956725999932],
            [28.56278324400006, -9.484897969999935],
            [28.555600219000098, -9.474459329999902],
            [28.531570679000083, -9.456889342999915],
            [28.519685099000043, -9.44562388099996],
            [28.514724162000107, -9.430017597999921],
            [28.51627445400004, -9.415548196999893],
            [28.518134806000035, -9.39746144599988],
            [28.51596439600013, -9.378341165999885],
            [28.49539717600007, -9.353226419999956],
            [28.460463908000065, -9.335036314999911],
            [28.41137129700013, -9.324907734999954],
            [28.368531535000074, -9.308577981999917],
            [28.35246016500011, -9.271991067999892],
            [28.3723039140001, -9.235094094999866],
            [28.41509200000013, -9.20708546899995],
            [28.5061975510001, -9.164400736999951],
            [28.599060099000013, -9.09639455099996],
            [28.765406534000107, -8.93402720099995],
            [28.893098999000102, -8.76576873699993],
            [28.930461059000066, -8.679882506999903],
            [28.93547367300002, -8.5907923379999],
            [28.89278894100002, -8.501908873999938],
            [28.889171590000046, -8.483098652999928],
            [28.91526818900013, -8.472866718999867],
            [29.03510583500008, -8.45477996799994],
            [29.208118530000093, -8.428528340999904],
            [29.365938354000093, -8.404550475999898],
            [29.57584432400006, -8.372729113999895],
            [29.59228112800008, -8.370237324999962],
            [29.858104695000122, -8.329826354999895],
            [30.123618204000138, -8.289518736999938],
            [30.32494958500007, -8.25892628999992],
            [30.581781453000133, -8.219962259999932],
            [30.752106975000117, -8.194124042999917],
            [30.77825524900004, -8.289105325999927],
            [30.828278036000086, -8.388117369999932],
            [30.891891724000118, -8.479171244999876],
            [30.95953617400005, -8.550484720999947],
            [30.992350708000117, -8.575909525999947],
            [31.03364017700011, -8.600300800999975],
            [31.077823527000135, -8.616320494999925],
            [31.11983646700014, -8.616630553999912],
            [31.1410238040001, -8.606191914999968],
            [31.161384318000046, -8.591722513999855],
            [31.182675008000103, -8.580767109999968],
            [31.20675622600004, -8.580767109999968],
            [31.21843509900009, -8.588725279999935],
            [31.237348674000145, -8.613943378999892],
            [31.248045695000087, -8.621901549999947],
            [31.260913127000038, -8.623968607999913],
            [31.269388062000075, -8.621074726999922],
            [31.277087850000044, -8.616010436999943],
            [31.32881595900011, -8.597716979999888],
            [31.34039147900006, -8.59523651099991],
            [31.34752282700009, -8.592445983999937],
            [31.35010664800012, -8.588518574999881],
            [31.353310587000067, -8.587174987999916],
            [31.362198934000105, -8.592342630999923],
            [31.365919637000104, -8.598647155999927],
            [31.369226928000103, -8.616837259999969],
            [31.372637573000134, -8.623865254999885],
            [31.38597009300014, -8.632546894999848],
            [31.398837524000044, -8.633787129999888],
            [31.412428426000133, -8.632340189999894],
            [31.427517945000147, -8.633477070999987],
            [31.443227580000098, -8.641538593999883],
            [31.464724976000127, -8.666136576999875],
            [31.48064131700005, -8.67616180399989],
            [31.519088583000098, -8.687013854999933],
            [31.539035685000044, -8.703550312999937],
            [31.545960327000103, -8.728975117999937],
            [31.54585697400006, -8.766285501999974],
            [31.553350057000046, -8.809073587999904],
            [31.57644942200011, -8.839666035999912],
            [31.672670939000056, -8.913046568999945],
            [31.689620809000132, -8.919557799999922],
            [31.70977461800004, -8.91966115299995],
            [31.730238485000086, -8.912426452999895],
            [31.76434493000005, -8.894132995999911],
            [31.78759932400004, -8.892169290999973],
            [31.936634155000036, -8.932580260999956],
            [31.91782393400007, -8.973094583999881],
            [31.91772058100014, -9.022497252999898],
            [31.938081095000143, -9.061771341999957],
            [31.980559122000102, -9.071899921999915],
            [32.00138472500004, -9.063321634999895],
            [32.01580245000008, -9.052676289999894],
            [32.03171879100012, -9.045958353999964],
            [32.057246948000056, -9.049575703999949],
            [32.08603072100004, -9.06611216199994],
            [32.09641768400007, -9.069109394999955],
            [32.10582279400012, -9.06828257199993],
            [32.12504642700014, -9.063735045999906],
            [32.13414148000004, -9.064148457999906],
            [32.14557447900012, -9.070265111999916],
            [32.15481205300006, -9.075207213999917],
            [32.19160567200004, -9.112207539999872],
            [32.21129439300006, -9.126780293999929],
            [32.23144820200008, -9.13380828799994],
            [32.25273889200014, -9.13649546299996],
            [32.38301517700006, -9.133911641999958],
            [32.423426148000146, -9.143833516999862],
            [32.45970300300007, -9.168018086999936],
            [32.470658407000144, -9.181867369999893],
            [32.49008874500004, -9.227342630999942],
            [32.504454793000036, -9.249253437999911],
            [32.518045695000126, -9.25824513799995],
            [32.55561446100006, -9.261242369999962],
            [32.64160404500012, -9.279845885999919],
            [32.71322758000008, -9.28584035299994],
            [32.72583662900007, -9.292558287999967],
            [32.73968591300007, -9.30733774799998],
            [32.74340661600007, -9.314985859999865],
            [32.74650720300008, -9.329972024999933],
            [32.752294962000065, -9.337413430999959],
            [32.759633016000066, -9.339997252999865],
            [32.776996297000096, -9.338240254999974],
            [32.7843343510001, -9.339687194999968],
            [32.830739786000095, -9.37017628999996],
            [32.905463908000115, -9.398184915999963],
            [32.9208634850001, -9.407900085999913],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Sierra Leone',
        iso3: 'SLE',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-10.282235879999888, 8.4846253460001],
              [-10.282907673999887, 8.432948914000065],
              [-10.31365515099992, 8.310346578000065],
              [-10.33127681499991, 8.272286885000113],
              [-10.333292195999945, 8.249755962000094],
              [-10.326005818999874, 8.221540629000032],
              [-10.318151001999865, 8.201645203000027],
              [-10.320941528999896, 8.183119202000086],
              [-10.345539509999895, 8.159348043000122],
              [-10.364918172999865, 8.148211772000096],
              [-10.3845552169999, 8.142113953000134],
              [-10.405070760999877, 8.139271749000073],
              [-10.485737670999896, 8.138858338000063],
              [-10.505736449999915, 8.135835266000043],
              [-10.529249226999895, 8.124285584000106],
              [-10.543977009999907, 8.106069642000051],
              [-10.567179728999918, 8.063204041000105],
              [-10.5778250729999, 8.053152975000074],
              [-10.603146524999886, 8.039226176000085],
              [-10.612138224999939, 8.031862284000084],
              [-10.616220662999922, 8.022508850000051],
              [-10.617667602999916, 8.01077830000007],
              [-10.615187133999939, 7.769035950000074],
              [-10.638131469999905, 7.765521952000114],
              [-10.645417845999873, 7.763041483000052],
              [-10.6925984289999, 7.737565003000029],
              [-10.730580606999922, 7.7054739390001],
              [-10.864025142999935, 7.543683809000072],
              [-10.874602823999851, 7.530859273000061],
              [-10.885713256999878, 7.522177633000098],
              [-10.898994099999868, 7.516493225000062],
              [-10.937027953999916, 7.507759909000086],
              [-10.977904011999897, 7.484918925000088],
              [-11.126318725999852, 7.368026836000112],
              [-11.144213025999932, 7.345193486000127],
              [-11.20925939999995, 7.262193502000073],
              [-11.217889363999916, 7.254080302000062],
              [-11.300209919999872, 7.217079977000111],
              [-11.317211466999908, 7.213565979000052],
              [-11.352041381999868, 7.159254049000097],
              [-11.370128132999895, 7.142614238000078],
              [-11.373228718999911, 7.138841858000148],
              [-11.370593220999893, 7.128403218000116],
              [-11.356433878999951, 7.105355530000054],
              [-11.353126586999878, 7.092798157000047],
              [-11.355141967999913, 7.084064840000067],
              [-11.36046464099985, 7.07863881500009],
              [-11.367906046999877, 7.075951640000071],
              [-11.389713500999903, 7.07352284800001],
              [-11.392917439999877, 7.066856588000093],
              [-11.389300089999892, 7.046702779000029],
              [-11.391522175999881, 7.031768290000059],
              [-11.397723347999886, 7.012803040000108],
              [-11.407283487999877, 6.996369934000128],
              [-11.434671996999924, 6.980815328000105],
              [-11.43885778799995, 6.963865458000015],
              [-11.436739053999872, 6.938544007000118],
              [-11.444490519999874, 6.933944804000078],
              [-11.476185675999943, 6.919419664000088],
              [-11.492787238999938, 6.932766018000052],
              [-11.533924933999913, 6.94212474200009],
              [-11.553944464999915, 6.952541408000059],
              [-11.57290605399993, 6.965806382000039],
              [-11.588002081999946, 6.978949286000045],
              [-11.578968878999945, 6.980414130000042],
              [-11.574289516999954, 6.982611395000049],
              [-11.571278449999909, 6.986314195000091],
              [-11.56749426999994, 6.992621161000045],
              [-11.595529751999948, 6.993312893000052],
              [-11.60773678299995, 6.991400458000044],
              [-11.61587480399993, 6.98578522300005],
              [-11.622141079999949, 6.98578522300005],
              [-11.631214972999942, 7.008246161000045],
              [-11.64517167899993, 7.022772528000075],
              [-11.698150193999936, 7.06704336100006],
              [-11.839588995999918, 7.148993231000077],
              [-12.073719855999911, 7.233587958000044],
              [-12.314849412999934, 7.329006252000056],
              [-12.506581183999913, 7.389837958000044],
              [-12.476185675999943, 7.415106512000079],
              [-12.439605272999927, 7.416489976000094],
              [-12.402170376999948, 7.40460846600007],
              [-12.36945553299995, 7.389837958000044],
              [-12.371083136999914, 7.398627020000049],
              [-12.375884568999936, 7.40501536700009],
              [-12.383412238999938, 7.409002997000073],
              [-12.393299933999913, 7.410345770000049],
              [-12.40103105399993, 7.412543036000045],
              [-12.409169074999909, 7.424709377000056],
              [-12.417225714999915, 7.430812893000052],
              [-12.435902472999942, 7.438177802000041],
              [-12.446522589999915, 7.439113674000055],
              [-12.464263475999928, 7.429632880000042],
              [-12.472767706999946, 7.433986721000053],
              [-12.480946417999917, 7.441229559000078],
              [-12.489247199999909, 7.445054429000038],
              [-12.49242102799991, 7.453599351000094],
              [-12.483631964999915, 7.472357489000046],
              [-12.470773891999954, 7.491156317000048],
              [-12.451975063999953, 7.507513739000046],
              [-12.441517706999946, 7.522853908000059],
              [-12.428334113999938, 7.533596096000053],
              [-12.41038977799991, 7.52765534100007],
              [-12.399403449999909, 7.532863674000055],
              [-12.38780676999994, 7.534572658000059],
              [-12.362660285999937, 7.534409898000092],
              [-12.357533331999946, 7.535549221000053],
              [-12.345448370999918, 7.539740302000041],
              [-12.338734503999945, 7.540676174000055],
              [-12.331450975999928, 7.538560289000088],
              [-12.319325324999909, 7.529527085000041],
              [-12.314808722999942, 7.52765534100007],
              [-12.295074022999927, 7.533107815000051],
              [-12.278065558999913, 7.543402411000045],
              [-12.258859829999949, 7.552394924000055],
              [-12.232248501999948, 7.553697007000039],
              [-12.23428300699993, 7.557114976000094],
              [-12.23656165299991, 7.564520575000074],
              [-12.238433397999927, 7.568019924000055],
              [-12.220204230999911, 7.573472398000092],
              [-12.201771613999938, 7.575995184000078],
              [-12.188099738999938, 7.583075262000079],
              [-12.18382727799991, 7.602728583000044],
              [-12.19127356699994, 7.602728583000044],
              [-12.19749915299991, 7.601223049000055],
              [-12.204253709999932, 7.600816148000092],
              [-12.211293097999942, 7.599758205000057],
              [-12.218006964999915, 7.595892645000049],
              [-12.223866339999915, 7.604966539000088],
              [-12.225453253999945, 7.608954169000071],
              [-12.235340949999909, 7.607082424000055],
              [-12.24673417899993, 7.606756903000075],
              [-12.256255662999934, 7.605169989000046],
              [-12.260161912999934, 7.599310614000046],
              [-12.262766079999949, 7.590643622000073],
              [-12.269276495999918, 7.586371161000045],
              [-12.286854620999918, 7.581610419000071],
              [-12.298654751999948, 7.575995184000078],
              [-12.317860480999911, 7.575425523000092],
              [-12.327707485999952, 7.573187567000048],
              [-12.348255988999938, 7.563421942000048],
              [-12.370025193999936, 7.559271552000041],
              [-12.391346808999913, 7.550482489000046],
              [-12.403553839999915, 7.54751211100006],
              [-12.41002356699994, 7.548163153000075],
              [-12.430083787999934, 7.552679755000042],
              [-12.441070115999935, 7.553697007000039],
              [-12.463734503999945, 7.561997789000088],
              [-12.471058722999942, 7.581122137000079],
              [-12.476307745999918, 7.60219961100006],
              [-12.492990688999953, 7.616400458000044],
              [-12.492990688999953, 7.622544664000088],
              [-12.488026495999918, 7.627142645000049],
              [-12.485218878999945, 7.633002020000049],
              [-12.484486456999946, 7.640692450000074],
              [-12.485503709999932, 7.650539455000057],
              [-12.493031378999945, 7.643744208000044],
              [-12.500355597999942, 7.639105536000045],
              [-12.506988084999932, 7.638576565000051],
              [-12.51280676999994, 7.644273179000038],
              [-12.519642706999946, 7.644273179000038],
              [-12.519642706999946, 7.630072333000044],
              [-12.543934699999909, 7.653550523000092],
              [-12.531402147999927, 7.687079169000071],
              [-12.492990688999953, 7.739935614000046],
              [-12.476633266999954, 7.731268622000073],
              [-12.471262173999946, 7.726263739000046],
              [-12.464995897999927, 7.733099677000041],
              [-12.47093665299991, 7.746161200000074],
              [-12.47179114499994, 7.759955145000049],
              [-12.46593176999994, 7.770575262000079],
              [-12.451975063999953, 7.77407461100006],
              [-12.472157355999911, 7.787665106000077],
              [-12.49014238199993, 7.771918036000045],
              [-12.519642706999946, 7.726263739000046],
              [-12.569488084999932, 7.695542710000041],
              [-12.60187740799995, 7.683783270000049],
              [-12.616444464999915, 7.695217190000051],
              [-12.624175584999932, 7.69476959800005],
              [-12.688384568999936, 7.706935940000051],
              [-12.694813605999911, 7.707098700000074],
              [-12.701242641999954, 7.708075262000079],
              [-12.711415167999917, 7.711981512000079],
              [-12.751210089999915, 7.739976304000038],
              [-12.765736456999946, 7.746568101000037],
              [-12.778065558999913, 7.755804755000042],
              [-12.787180141999954, 7.77407461100006],
              [-12.790516730999911, 7.792385158000059],
              [-12.787505662999934, 7.804592190000051],
              [-12.777455206999946, 7.813421942000048],
              [-12.759836391999954, 7.821844794000071],
              [-12.777902798999946, 7.81899648600006],
              [-12.828724738999938, 7.79828522300005],
              [-12.875884568999936, 7.828680731000077],
              [-12.88931230399993, 7.854803778000075],
              [-12.898589647999927, 7.865708726000037],
              [-12.913726365999935, 7.870266018000052],
              [-12.924631313999953, 7.874945380000042],
              [-12.937855597999942, 7.886379299000055],
              [-12.959095831999946, 7.911200262000079],
              [-12.939442511999914, 7.915106512000079],
              [-12.905506964999915, 7.934149481000077],
              [-12.886708136999914, 7.938544012000079],
              [-12.87100175699993, 7.936509507000039],
              [-12.854481574999909, 7.931586005000042],
              [-12.821278449999909, 7.91742584800005],
              [-12.841460740999935, 7.937974351000037],
              [-12.866851365999935, 7.955471096000053],
              [-12.888417120999918, 7.975287177000041],
              [-12.905262824999909, 8.02407461100006],
              [-12.907215949999909, 8.027289130000042],
              [-12.911773240999935, 8.030666408000059],
              [-12.91006425699993, 8.038275458000044],
              [-12.903797980999911, 8.05149974200009],
              [-12.90147864499994, 8.065659898000092],
              [-12.89517167899993, 8.079575914000088],
              [-12.886301235999952, 8.092352606000077],
              [-12.875884568999936, 8.103013414000088],
              [-12.90807044199994, 8.10740794500009],
              [-12.921498175999943, 8.119940497000073],
              [-12.929432745999918, 8.139349677000041],
              [-12.944813605999911, 8.164496161000045],
              [-12.956206834999932, 8.17218659100007],
              [-12.969715949999909, 8.177801825000074],
              [-12.981068488999938, 8.186224677000041],
              [-12.985707160999937, 8.202337958000044],
              [-12.985096808999913, 8.21670156500005],
              [-12.982980923999946, 8.229803778000075],
              [-12.97874915299991, 8.242010809000078],
              [-12.972075975999928, 8.253851630000042],
              [-12.98110917899993, 8.252101955000057],
              [-12.986887173999946, 8.248236395000049],
              [-12.99205481699994, 8.243841864000046],
              [-12.999419725999928, 8.240179755000042],
              [-13.006337042999917, 8.238714911000045],
              [-13.010609503999945, 8.23891836100006],
              [-13.015370245999918, 8.23969147300005],
              [-13.023589647999927, 8.240179755000042],
              [-13.067697719999956, 8.233343817000048],
              [-13.090443488999938, 8.22459544500009],
              [-13.117909308999913, 8.208807684000078],
              [-13.142730272999927, 8.18976471600007],
              [-13.157704230999911, 8.171291408000059],
              [-13.16392981699994, 8.171291408000059],
              [-13.161732550999943, 8.187160549000055],
              [-13.16392981699994, 8.229641018000052],
              [-13.16828365799995, 8.25071849200009],
              [-13.168812628999945, 8.263006903000075],
              [-13.16392981699994, 8.274359442000048],
              [-13.17564856699994, 8.283758856000077],
              [-13.210275844999956, 8.339056708000044],
              [-13.212269660999937, 8.339504299000055],
              [-13.214466925999943, 8.343085028000075],
              [-13.219146287999934, 8.343695380000042],
              [-13.223866339999915, 8.345648505000042],
              [-13.225941535999937, 8.353176174000055],
              [-13.231027798999946, 8.363836981000077],
              [-13.256418423999946, 8.39720286700009],
              [-13.263661261999914, 8.401678778000075],
              [-13.268055792999917, 8.411444403000075],
              [-13.274159308999913, 8.42088450700004],
              [-13.286773240999935, 8.424505927000041],
              [-13.272938605999911, 8.441880601000037],
              [-13.268544074999909, 8.449896552000041],
              [-13.266957160999937, 8.462713934000078],
              [-13.269683397999927, 8.47211334800005],
              [-13.282704230999911, 8.49095286700009],
              [-13.286773240999935, 8.50023021000004],
              [-13.26549231699994, 8.497015692000048],
              [-13.259510870999918, 8.493394273000092],
              [-13.252674933999913, 8.497544664000088],
              [-13.250355597999942, 8.49510325700004],
              [-13.245838995999918, 8.48655833500004],
              [-13.228911912999934, 8.493719794000071],
              [-13.210764126999948, 8.493394273000092],
              [-13.192982550999943, 8.487779039000088],
              [-13.177561001999948, 8.47915273600006],
              [-13.164865688999953, 8.464992580000057],
              [-13.14439856699994, 8.431219794000071],
              [-13.11001542899993, 8.413234768000052],
              [-13.085682745999918, 8.390448309000078],
              [-13.060373501999948, 8.372707424000055],
              [-13.04242916599992, 8.375392971000053],
              [-13.033558722999942, 8.376695054000038],
              [-13.033558722999942, 8.38353099200009],
              [-13.045765753999945, 8.386216539000088],
              [-13.056263800999943, 8.391180731000077],
              [-13.063832160999937, 8.39915599200009],
              [-13.067697719999956, 8.41087474200009],
              [-13.054066535999937, 8.41087474200009],
              [-13.054066535999937, 8.417669989000046],
              [-13.083363410999937, 8.424383856000077],
              [-13.110951300999943, 8.43382396000004],
              [-13.125599738999938, 8.449042059000078],
              [-13.116118943999936, 8.47296784100007],
              [-13.104359503999945, 8.481634833000044],
              [-13.074330206999946, 8.49315013200004],
              [-13.061512824999909, 8.50023021000004],
              [-13.054025844999956, 8.510199286000045],
              [-13.047922329999949, 8.521063544000071],
              [-13.039947068999936, 8.526760158000059],
              [-13.026722785999937, 8.520697333000044],
              [-13.027088995999918, 8.53221263200004],
              [-13.024159308999913, 8.54319896000004],
              [-13.019154425999943, 8.553127346000053],
              [-13.013050910999937, 8.561712958000044],
              [-13.003285285999937, 8.559068101000037],
              [-12.937123175999943, 8.554348049000055],
              [-12.918324347999942, 8.549221096000053],
              [-12.907215949999909, 8.548041083000044],
              [-12.898996548999946, 8.550970770000049],
              [-12.878977016999954, 8.564846096000053],
              [-12.869699673999946, 8.569159247000073],
              [-12.888050910999937, 8.573065497000073],
              [-12.909331834999932, 8.570502020000049],
              [-12.928089972999942, 8.57217031500005],
              [-12.93032792899993, 8.58344147300005],
              [-12.931141730999911, 8.582831122000073],
              [-12.911936001999948, 8.606838283000059],
              [-12.875884568999936, 8.685207424000055],
              [-12.900868292999917, 8.654852606000077],
              [-12.916900193999936, 8.627630927000041],
              [-12.936431443999936, 8.607001044000071],
              [-12.972075975999928, 8.59642161700009],
              [-12.989857550999943, 8.597316799000055],
              [-13.004872199999909, 8.600165106000077],
              [-13.018055792999917, 8.600165106000077],
              [-13.043934699999909, 8.58470286700009],
              [-13.061838344999956, 8.583197333000044],
              [-13.078480597999942, 8.589016018000052],
              [-13.088775193999936, 8.602687893000052],
              [-13.06627356699994, 8.606838283000059],
              [-13.054432745999918, 8.618963934000078],
              [-13.044341600999928, 8.633368231000077],
              [-13.026722785999937, 8.644232489000046],
              [-13.026722785999937, 8.651068427000041],
              [-13.035633917999917, 8.652492580000057],
              [-13.041086391999954, 8.65428294500009],
              [-13.044667120999918, 8.658026434000078],
              [-13.047840949999909, 8.664740302000041],
              [-13.054066535999937, 8.664740302000041],
              [-13.063547329999949, 8.633937893000052],
              [-13.07062740799995, 8.621975002000056],
              [-13.08193925699993, 8.616929429000038],
              [-13.098011847999942, 8.621893622000073],
              [-13.112172003999945, 8.633937893000052],
              [-13.130360480999911, 8.657904364000046],
              [-13.140614386999914, 8.65224844000005],
              [-13.148426886999914, 8.65338776200008],
              [-13.154042120999918, 8.660101630000042],
              [-13.157704230999911, 8.67096588700008],
              [-13.162587042999917, 8.653998114000046],
              [-13.154286261999914, 8.643052476000037],
              [-13.139149542999917, 8.636053778000075],
              [-13.12291419199994, 8.630560614000046],
              [-13.13658606699994, 8.62376536700009],
              [-13.109038865999935, 8.603338934000078],
              [-13.107492641999954, 8.581000067000048],
              [-13.122141079999949, 8.55955638200004],
              [-13.143422003999945, 8.541815497000073],
              [-13.139230923999946, 8.533392645000049],
              [-13.139271613999938, 8.52448151200008],
              [-13.144113735999952, 8.517401434000078],
              [-13.154286261999914, 8.514553127000056],
              [-13.16242428299995, 8.517645575000074],
              [-13.168527798999946, 8.525213934000078],
              [-13.195057745999918, 8.569159247000073],
              [-13.202504035999937, 8.58494700700004],
              [-13.20885169199994, 8.61432526200008],
              [-13.216908331999946, 8.632554429000038],
              [-13.227162238999938, 8.649644273000092],
              [-13.23656165299991, 8.661322333000044],
              [-13.241200324999909, 8.67218659100007],
              [-13.242014126999948, 8.688625393000052],
              [-13.240223761999914, 8.71938711100006],
              [-13.235218878999945, 8.719916083000044],
              [-13.240223761999914, 8.825832424000055],
              [-13.212269660999937, 8.857123114000046],
              [-13.200917120999918, 8.859808661000045],
              [-13.196522589999915, 8.856350002000056],
              [-13.193186001999948, 8.849798895000049],
              [-13.184966600999928, 8.843491929000038],
              [-13.108143683999913, 8.84406159100007],
              [-13.092193162999934, 8.846625067000048],
              [-13.071848110999952, 8.855536200000074],
              [-13.043080206999946, 8.858343817000048],
              [-12.985707160999937, 8.857123114000046],
              [-13.026966925999943, 8.869696356000077],
              [-13.033558722999942, 8.866766669000071],
              [-13.041086391999954, 8.86123281500005],
              [-13.058216925999943, 8.861151434000078],
              [-13.076771613999938, 8.864732164000088],
              [-13.088775193999936, 8.87018463700008],
              [-13.09984290299991, 8.865423895000049],
              [-13.115834113999938, 8.86237213700008],
              [-13.130360480999911, 8.864081122000073],
              [-13.13658606699994, 8.873928127000056],
              [-13.13975989499994, 8.881415106000077],
              [-13.14671790299991, 8.88344961100006],
              [-13.153920050999943, 8.883286851000037],
              [-13.157704230999911, 8.884466864000046],
              [-13.15843665299991, 8.892279364000046],
              [-13.155873175999943, 8.895331122000073],
              [-13.15257727799991, 8.89712148600006],
              [-13.142648891999954, 8.91673411700009],
              [-13.122629360999952, 8.92601146000004],
              [-13.097767706999946, 8.930487372000073],
              [-13.075103318999936, 8.93162669500009],
              [-13.075103318999936, 8.939113674000055],
              [-13.092518683999913, 8.944647528000075],
              [-13.11510169199994, 8.940619208000044],
              [-13.157704230999911, 8.925441799000055],
              [-13.180978969999956, 8.923041083000044],
              [-13.206125454999949, 8.92837148600006],
              [-13.225738084999932, 8.942531643000052],
              [-13.232818162999934, 8.966376044000071],
              [-13.236683722999942, 8.96190013200004],
              [-13.23892167899993, 8.961371161000045],
              [-13.239979620999918, 8.959784247000073],
              [-13.240223761999914, 8.952093817000048],
              [-13.254872199999909, 8.966376044000071],
              [-13.260487433999913, 8.965277411000045],
              [-13.262318488999938, 8.96124909100007],
              [-13.264556443999936, 8.957912502000056],
              [-13.266957160999937, 8.952093817000048],
              [-13.288441535999937, 8.96946849200009],
              [-13.28502356699994, 9.01703522300005],
              [-13.30109615799995, 9.035305080000057],
              [-13.30109615799995, 9.041489976000037],
              [-13.277376057999902, 9.058595479000061],
              [-13.233631957999904, 9.072057190000109],
              [-13.207535359999923, 9.076708069000077],
              [-13.191774047999928, 9.072987366000078],
              [-13.153843546999923, 9.049319560000043],
              [-13.13105423999994, 9.041464742000102],
              [-13.115913045999918, 9.043945211000079],
              [-13.085578979999894, 9.065985209000075],
              [-13.04700252299989, 9.084537049000105],
              [-13.02886409499996, 9.095983379000117],
              [-13.015247354999872, 9.112752380000074],
              [-13.002044026999982, 9.144119975000095],
              [-12.993801635999944, 9.158692729000066],
              [-12.98416398099991, 9.172309469000055],
              [-12.978479573999891, 9.175203349000043],
              [-12.962795775999922, 9.176701966000053],
              [-12.959152588999928, 9.17783884700006],
              [-12.96021195499992, 9.1860812380001],
              [-12.973932047999938, 9.202798564000133],
              [-12.97835038299985, 9.212849630000079],
              [-12.973751179999908, 9.241581727000082],
              [-12.957912352999898, 9.272432557000059],
              [-12.93700923599991, 9.287082825000141],
              [-12.917527221999904, 9.267006531000092],
              [-12.89564225199996, 9.278504537000103],
              [-12.876108560999882, 9.279848124000083],
              [-12.856884927999943, 9.278504537000103],
              [-12.835826781999913, 9.281966858000146],
              [-12.819135294999882, 9.295790304000107],
              [-12.79526078299989, 9.33509023100008],
              [-12.777923339999887, 9.343849386000073],
              [-12.764151570999928, 9.3476734420001],
              [-12.763557291999888, 9.355347392000084],
              [-12.767562214999884, 9.364390767000145],
              [-12.76779475899994, 9.372323100000102],
              [-12.759759073999959, 9.38283925400006],
              [-12.754074666999912, 9.38780019100011],
              [-12.737228149999936, 9.397231141000077],
              [-12.732939005999867, 9.396507670000076],
              [-12.727848876999872, 9.393122864000063],
              [-12.722939615999849, 9.39208933500008],
              [-12.719038045999895, 9.398368022000085],
              [-12.716454222999886, 9.40441416400003],
              [-12.713121093999888, 9.408160706000047],
              [-12.706196451999887, 9.413948466000107],
              [-12.70159724999985, 9.420227152000024],
              [-12.667516641999896, 9.528695984000095],
              [-12.667309936999942, 9.533708598000146],
              [-12.669273640999876, 9.538230285000083],
              [-12.668627685999894, 9.542364400000096],
              [-12.660953734999907, 9.546033427000097],
              [-12.65526932799986, 9.547738749000061],
              [-12.652065388999887, 9.549444071000039],
              [-12.649920816999895, 9.55210540800006],
              [-12.647285318999906, 9.556627096000085],
              [-12.638552001999926, 9.589415792000082],
              [-12.633849446999932, 9.597864889000078],
              [-12.624599364999938, 9.601275533000106],
              [-12.614858357999879, 9.600086975000082],
              [-12.606822671999907, 9.600707093000054],
              [-12.602766072999884, 9.609362895000103],
              [-12.601551676999861, 9.65171173200011],
              [-12.598580281999944, 9.654863994000067],
              [-12.582250528999907, 9.683363546000109],
              [-12.573077962999918, 9.692561951000116],
              [-12.542020426999898, 9.711320496000013],
              [-12.538764810999908, 9.711914775000068],
              [-12.537472900999944, 9.715712992000107],
              [-12.537653767999899, 9.727934469000033],
              [-12.53569006399988, 9.73279205300014],
              [-12.530729125999926, 9.732843730000056],
              [-12.525561482999905, 9.732068584000046],
              [-12.522460896999888, 9.734471537000104],
              [-12.522874308999889, 9.739432475000058],
              [-12.526646687999914, 9.750620423000086],
              [-12.527266804999982, 9.753617656000102],
              [-12.513624226999866, 9.827825013000066],
              [-12.513727579999909, 9.838341167000124],
              [-12.514993652999863, 9.845110779000066],
              [-12.51432185899995, 9.851311951000056],
              [-12.508327392999945, 9.860381165000106],
              [-12.47233475799996, 9.881258443000078],
              [-12.426988687999938, 9.897614034000128],
              [-12.27673946099992, 9.929265849000032],
              [-12.253588419999915, 9.928413188000093],
              [-12.235605020999941, 9.916760152000037],
              [-12.2173890789999, 9.900559591000032],
              [-12.193643757999922, 9.886064351000087],
              [-12.174833536999927, 9.87919138600003],
              [-12.15834875499985, 9.875599874000045],
              [-12.141347208999917, 9.874876404000048],
              [-12.109807050999933, 9.88167583600007],
              [-11.921774047999861, 9.922212016000103],
              [-11.914952758999902, 9.931487936000039],
              [-11.910095174999896, 9.992517802000108],
              [-11.484874922999893, 9.99484470600008],
              [-11.272666381999898, 9.996005961000066],
              [-11.247293253999914, 9.993396301000061],
              [-11.21344519099992, 9.983371074000033],
              [-11.199595906999946, 9.982156677000091],
              [-11.188537149999945, 9.972596538000104],
              [-11.181250772999874, 9.950375672000064],
              [-11.167659871999973, 9.884462383000056],
              [-11.160270141999945, 9.87275767000007],
              [-11.085959431999868, 9.826171366000025],
              [-11.044928344999931, 9.78712982200011],
              [-11.010098428999868, 9.742739766000057],
              [-10.986327270999908, 9.697755432000122],
              [-10.974596719999909, 9.663778178000086],
              [-10.968498900999862, 9.654243876000095],
              [-10.962917846999943, 9.65078155600007],
              [-10.946639770999923, 9.644838765000145],
              [-10.940128539999932, 9.639696961000055],
              [-10.93578771999995, 9.631893819000126],
              [-10.92906978399995, 9.605693868000102],
              [-10.921680053999921, 9.595901184000056],
              [-10.89604854299995, 9.578305359000069],
              [-10.886333373999918, 9.568409323000083],
              [-10.88281937699989, 9.56016693100014],
              [-10.877703409999896, 9.532675070000067],
              [-10.87057206299994, 9.52339915000006],
              [-10.86018509999991, 9.51854156500012],
              [-10.852588663999967, 9.512082011000075],
              [-10.853673868999863, 9.49787099300002],
              [-10.85909989399994, 9.472988790000059],
              [-10.854862426999887, 9.455263773000041],
              [-10.843958699999916, 9.44025177000006],
              [-10.829075886999874, 9.423947855000037],
              [-10.813417927999922, 9.413896789000091],
              [-10.811454223999874, 9.408264058000071],
              [-10.822151244999901, 9.400900167000074],
              [-10.831763061999908, 9.392141012000081],
              [-10.819360717999928, 9.388058574000084],
              [-10.80168737799994, 9.387283427000071],
              [-10.79522782399988, 9.388523662000097],
              [-10.78540930199992, 9.387231750000055],
              [-10.77476395699992, 9.387335103000083],
              [-10.765462199999888, 9.385216370000109],
              [-10.753473266999919, 9.367568868000106],
              [-10.74153601099988, 9.357052714000062],
              [-10.728203490999874, 9.34819020600014],
              [-10.717764851999931, 9.343332622000034],
              [-10.675131795999931, 9.306461487000107],
              [-10.673839884999893, 9.293981628000026],
              [-10.677663939999917, 9.2828970340001],
              [-10.68345170099991, 9.271812439000087],
              [-10.688050902999862, 9.259280904000093],
              [-10.687947549999933, 9.250702617000059],
              [-10.683916788999937, 9.233752747000054],
              [-10.685208698999872, 9.224502666000134],
              [-10.693166869999857, 9.212849630000079],
              [-10.703760538999916, 9.20631256100009],
              [-10.714974324999957, 9.201351624000054],
              [-10.72474117099992, 9.194504496000093],
              [-10.742569539999863, 9.163291931000103],
              [-10.753473266999919, 9.120116272000075],
              [-10.746341918999889, 9.083813578000019],
              [-10.71042679799993, 9.072987366000078],
              [-10.669085652999911, 9.074434306000072],
              [-10.629346476999899, 9.070351867000056],
              [-10.60598872899996, 9.063763123000072],
              [-10.59410314899992, 9.054099630000039],
              [-10.593100657999855, 9.047616856000033],
              [-10.592179110999894, 9.041657513000061],
              [-10.591777709999889, 9.039061788000055],
              [-10.607125609999883, 8.979840597000063],
              [-10.61187984199995, 8.945139872000127],
              [-10.610122843999875, 8.872301941000046],
              [-10.60846919699992, 8.862302552000116],
              [-10.599374145999946, 8.834035543000141],
              [-10.5991157629999, 8.829617208000045],
              [-10.600200967999882, 8.819023540000074],
              [-10.599684203999857, 8.815380351000073],
              [-10.59627355999993, 8.811246237000148],
              [-10.589090535999958, 8.806595358000095],
              [-10.58630000799991, 8.804089051000105],
              [-10.545320597999876, 8.750035502000031],
              [-10.53023107899989, 8.739157613000074],
              [-10.524753377999986, 8.729545797000057],
              [-10.481861937999923, 8.672469177000053],
              [-10.489665079999952, 8.65104929600004],
              [-10.50330765799987, 8.631567281000045],
              [-10.52211787899995, 8.618570659000099],
              [-10.54516556799993, 8.616761983000103],
              [-10.565422729999852, 8.61278289800012],
              [-10.584646361999944, 8.596840719000099],
              [-10.600511026999868, 8.575653382000041],
              [-10.616479043999902, 8.546507874000028],
              [-10.631878620999885, 8.532012635000086],
              [-10.638854939999902, 8.51989451100009],
              [-10.641180378999906, 8.506639506000084],
              [-10.64107702699988, 8.494779765000075],
              [-10.64386755399994, 8.486873271000121],
              [-10.654667928999885, 8.485503845000054],
              [-10.669085652999911, 8.399075013000072],
              [-10.683813435999895, 8.37486460400008],
              [-10.70200353999985, 8.353573914],
              [-10.7249995519999, 8.319855042000128],
              [-10.735283161999888, 8.287298890000088],
              [-10.715181029999911, 8.269599711000083],
              [-10.707894653999858, 8.30313771500009],
              [-10.688154255999876, 8.324066671000082],
              [-10.65978389499989, 8.333265076000089],
              [-10.626710977999892, 8.331508077000109],
              [-10.61187984199995, 8.325255229000106],
              [-10.583251097999891, 8.30691009500012],
              [-10.572657429999907, 8.304584656000088],
              [-10.554363972999937, 8.311845194000071],
              [-10.519275674999903, 8.334789530000094],
              [-10.460209513999956, 8.392150370000081],
              [-10.447962198999932, 8.407627462000093],
              [-10.423777628999858, 8.456565043000083],
              [-10.414062458999922, 8.470181783000086],
              [-10.402383584999939, 8.481007996000116],
              [-10.38977453599992, 8.489095357000025],
              [-10.37473669499991, 8.494779765000075],
              [-10.344299275999958, 8.49906890900013],
              [-10.337581339999929, 8.49855214500009],
              [-10.310244506999908, 8.490361430000064],
              [-10.302234659999925, 8.485865580000052],
              [-10.293708048999918, 8.483075053000093],
              [-10.282235879999888, 8.4846253460001],
            ],
          ],
          [
            [
              [-12.492990688999953, 7.568019924000055],
              [-12.504383917999917, 7.561021226000094],
              [-12.505360480999911, 7.54954661700009],
              [-12.49913489499994, 7.520209052000041],
              [-12.50182044199994, 7.502386786000045],
              [-12.508656378999945, 7.491848049000055],
              [-12.517567511999914, 7.481756903000075],
              [-12.526437954999949, 7.46556224200009],
              [-12.527455206999946, 7.449693101000094],
              [-12.518869594999956, 7.416571356000077],
              [-12.519642706999946, 7.404120184000078],
              [-12.53233801999994, 7.392482815000051],
              [-12.549672003999945, 7.389634507000039],
              [-12.565785285999937, 7.395656643000052],
              [-12.57485917899993, 7.410345770000049],
              [-12.554432745999918, 7.410345770000049],
              [-12.568023240999935, 7.435370184000078],
              [-12.585560675999943, 7.459906317000048],
              [-12.605539516999954, 7.478664455000057],
              [-12.62608801999994, 7.486029364000046],
              [-12.640614386999914, 7.487290757000039],
              [-12.731800910999937, 7.511297919000071],
              [-12.764393683999913, 7.52798086100006],
              [-12.849232550999943, 7.540676174000055],
              [-12.951649542999917, 7.568019924000055],
              [-12.951649542999917, 7.575425523000092],
              [-12.91429602799991, 7.584418036000045],
              [-12.910308397999927, 7.598089911000045],
              [-12.898060675999943, 7.610744533000059],
              [-12.883290167999917, 7.616400458000044],
              [-12.844797329999949, 7.62250397300005],
              [-12.735666469999956, 7.622544664000088],
              [-12.718902147999927, 7.624904690000051],
              [-12.681141730999911, 7.634670315000051],
              [-12.62140865799995, 7.639715887000079],
              [-12.60069739499994, 7.638169664000088],
              [-12.581125454999949, 7.630072333000044],
              [-12.595855272999927, 7.61273834800005],
              [-12.586048956999946, 7.607611395000049],
              [-12.54751542899993, 7.608954169000071],
              [-12.529652472999942, 7.60382721600007],
              [-12.515370245999918, 7.594875393000052],
              [-12.503529425999943, 7.582586981000077],
              [-12.492990688999953, 7.568019924000055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Guinea',
        iso3: 'GIN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-13.30109615799995, 9.041489976000037],
            [-13.31236731699994, 9.048325914000088],
            [-13.321603969999956, 9.05662669500009],
            [-13.325795050999943, 9.067775783000059],
            [-13.32217363199993, 9.08307526200008],
            [-13.31944739499994, 9.083563544000071],
            [-13.304514126999948, 9.08307526200008],
            [-13.30064856699994, 9.08462148600006],
            [-13.300933397999927, 9.08820221600007],
            [-13.302154100999928, 9.09251536700009],
            [-13.30109615799995, 9.096136786000045],
            [-13.273793097999942, 9.12400950700004],
            [-13.254872199999909, 9.15493398600006],
            [-13.243072068999936, 9.169745184000078],
            [-13.225941535999937, 9.179266669000071],
            [-13.208241339999915, 9.180080471000053],
            [-13.176136847999942, 9.173651434000078],
            [-13.157704230999911, 9.179266669000071],
            [-13.157704230999911, 9.185492255000042],
            [-13.218495245999918, 9.183254299000055],
            [-13.247303839999915, 9.186021226000037],
            [-13.259510870999918, 9.19635651200008],
            [-13.25767981699994, 9.20026276200008],
            [-13.248890753999945, 9.208319403000075],
            [-13.245838995999918, 9.213446356000077],
            [-13.245838995999918, 9.22646719000005],
            [-13.237904425999943, 9.246649481000077],
            [-13.232818162999934, 9.267401434000078],
            [-13.254872199999909, 9.244818427000041],
            [-13.264556443999936, 9.220445054000038],
            [-13.270375128999945, 9.194037177000041],
            [-13.280629035999937, 9.16502513200004],
            [-13.30492102799991, 9.175482489000046],
            [-13.315297003999945, 9.182074286000045],
            [-13.32217363199993, 9.192938544000071],
            [-13.31358801999994, 9.197943427000041],
            [-13.31163489499994, 9.207220770000049],
            [-13.31468665299991, 9.233303127000056],
            [-13.31358801999994, 9.23314036700009],
            [-13.31118730399993, 9.237982489000046],
            [-13.308949347999942, 9.24477773600006],
            [-13.307932094999956, 9.25031159100007],
            [-13.310047980999911, 9.25381094000005],
            [-13.319650844999956, 9.259263414000088],
            [-13.32217363199993, 9.261216539000088],
            [-13.325062628999945, 9.281317450000074],
            [-13.325347459999932, 9.311021226000037],
            [-13.31867428299995, 9.329494533000059],
            [-13.30109615799995, 9.31586334800005],
            [-13.30382239499994, 9.33779531500005],
            [-13.30337480399993, 9.34711334800005],
            [-13.30109615799995, 9.356838283000059],
            [-13.307932094999956, 9.356838283000059],
            [-13.313954230999911, 9.349554755000042],
            [-13.32217363199993, 9.345404364000046],
            [-13.332834438999953, 9.343573309000078],
            [-13.345773891999954, 9.343166408000059],
            [-13.352853969999956, 9.338771877000056],
            [-13.357818162999934, 9.32843659100007],
            [-13.367909308999913, 9.282171942000048],
            [-13.374501105999911, 9.272772528000075],
            [-13.397531704999949, 9.28384023600006],
            [-13.407785610999952, 9.28701406500005],
            [-13.41197669199994, 9.293402411000045],
            [-13.404123501999948, 9.308417059000078],
            [-13.414051886999914, 9.317206122000073],
            [-13.423817511999914, 9.332912502000056],
            [-13.430816209999932, 9.352036851000037],
            [-13.431996222999942, 9.37107982000009],
            [-13.425160285999937, 9.389878648000092],
            [-13.403309699999909, 9.418158270000049],
            [-13.396636522999927, 9.43935781500005],
            [-13.404123501999948, 9.43935781500005],
            [-13.42837480399993, 9.420721747000073],
            [-13.465402798999946, 9.418158270000049],
            [-13.499175584999932, 9.42877838700008],
            [-13.51398678299995, 9.449611721000053],
            [-13.520863410999937, 9.47947825700004],
            [-13.520741339999915, 9.49510325700004],
            [-13.510243292999917, 9.511053778000075],
            [-13.50064042899993, 9.52179596600007],
            [-13.493234829999949, 9.534857489000046],
            [-13.488392706999946, 9.550604559000078],
            [-13.486683722999942, 9.56907786700009],
            [-13.493519660999937, 9.56907786700009],
            [-13.515614386999914, 9.52448151200008],
            [-13.529042120999918, 9.505682684000078],
            [-13.547474738999938, 9.500189520000049],
            [-13.561390753999945, 9.508978583000044],
            [-13.575266079999949, 9.52724844000005],
            [-13.585519985999952, 9.54913971600007],
            [-13.588449673999946, 9.56907786700009],
            [-13.61900794199994, 9.556382554000038],
            [-13.643259243999921, 9.542547919000071],
            [-13.67796790299991, 9.522691148000092],
            [-13.705799933999913, 9.514471747000073],
            [-13.707102016999954, 9.512152411000045],
            [-13.714344855999911, 9.507635809000078],
            [-13.722401495999918, 9.505804755000042],
            [-13.726226365999935, 9.511053778000075],
            [-13.724110480999911, 9.51951732000009],
            [-13.718902147999927, 9.522284247000073],
            [-13.712310350999928, 9.52366771000004],
            [-13.705799933999913, 9.52806224200009],
            [-13.673329230999911, 9.573797919000071],
            [-13.65265865799995, 9.597154039000088],
            [-13.640777147999927, 9.623724677000041],
            [-13.625803188999953, 9.647284247000073],
            [-13.623036261999914, 9.662909247000073],
            [-13.624379035999937, 9.720282294000071],
            [-13.623199022999927, 9.727362372000073],
            [-13.618560350999928, 9.732082424000055],
            [-13.604888475999928, 9.73737213700008],
            [-13.602162238999938, 9.743801174000055],
            [-13.595448370999918, 9.755031643000052],
            [-13.58071855399993, 9.76203034100007],
            [-13.566517706999946, 9.771063544000071],
            [-13.561105923999946, 9.788234768000052],
            [-13.581776495999918, 9.777167059000078],
            [-13.594309048999946, 9.774237372000073],
            [-13.604115363999938, 9.780178127000056],
            [-13.647775844999956, 9.83148834800005],
            [-13.651193813999953, 9.84284088700008],
            [-13.655181443999936, 9.841742255000042],
            [-13.65811113199993, 9.840521552000041],
            [-13.664784308999913, 9.836615302000041],
            [-13.653797980999911, 9.805243231000077],
            [-13.650542772999927, 9.777004299000055],
            [-13.661284959999932, 9.75454336100006],
            [-13.692128058999913, 9.740383205000057],
            [-13.728911912999934, 9.744086005000042],
            [-13.74718176999994, 9.767767645000049],
            [-13.749826626999948, 9.79987213700008],
            [-13.739898240999935, 9.82916901200008],
            [-13.698312954999949, 9.88076406500005],
            [-13.681996222999942, 9.913478908000059],
            [-13.685292120999918, 9.946478583000044],
            [-13.693959113999938, 9.953802802000041],
            [-13.69749915299991, 9.94041575700004],
            [-13.699208136999914, 9.92133209800005],
            [-13.702015753999945, 9.911688544000071],
            [-13.71275794199994, 9.905178127000056],
            [-13.732492641999954, 9.876776434000078],
            [-13.746693488999938, 9.870754299000055],
            [-13.745432094999956, 9.866522528000075],
            [-13.749745245999918, 9.863470770000049],
            [-13.784657355999911, 9.85024648600006],
            [-13.788685675999943, 9.850043036000045],
            [-13.80968176999994, 9.851629950000074],
            [-13.827707485999952, 9.85537344000005],
            [-13.842844204999949, 9.86078522300005],
            [-13.849191860999952, 9.867621161000045],
            [-13.855051235999952, 9.878851630000042],
            [-13.869130011999914, 9.896226304000038],
            [-13.886097785999937, 9.912176825000074],
            [-13.90062415299991, 9.919134833000044],
            [-13.92764238199993, 9.935939846000053],
            [-13.933176235999952, 9.94334544500009],
            [-13.945383266999954, 9.966945705000057],
            [-13.954253709999932, 9.97093333500004],
            [-13.971099412999934, 9.971828518000052],
            [-13.979481574999909, 9.974351304000038],
            [-13.987049933999913, 9.980414130000042],
            [-14.006743943999936, 10.00104401200008],
            [-14.02171790299991, 10.00726959800005],
            [-14.032297329999949, 10.008978583000044],
            [-14.042958136999914, 10.012844143000052],
            [-14.058338995999918, 10.02529531500005],
            [-14.061879035999937, 10.050116278000075],
            [-14.046131964999915, 10.079494533000059],
            [-14.020334438999953, 10.094427802000041],
            [-13.993763800999943, 10.07615794500009],
            [-14.00108801999994, 10.08820221600007],
            [-14.014800584999932, 10.104803778000075],
            [-14.028187628999945, 10.116603908000059],
            [-14.034087693999936, 10.11399974200009],
            [-14.041615363999938, 10.101304429000038],
            [-14.056752081999946, 10.106594143000052],
            [-14.068348761999914, 10.118109442000048],
            [-14.065500454999949, 10.124579169000071],
            [-14.043812628999945, 10.133246161000045],
            [-14.026966925999943, 10.153957424000055],
            [-13.99990800699993, 10.199693101000037],
            [-14.014515753999945, 10.192775783000059],
            [-14.024891730999911, 10.183742580000057],
            [-14.044667120999918, 10.162176825000074],
            [-14.055490688999953, 10.15534088700008],
            [-14.082834438999953, 10.14288971600007],
            [-14.089344855999911, 10.138251044000071],
            [-14.091175910999937, 10.12604401200008],
            [-14.089344855999911, 10.079901434000078],
            [-14.092274542999917, 10.06858958500004],
            [-14.100575324999909, 10.058294989000046],
            [-14.113433397999927, 10.05101146000004],
            [-14.130279100999928, 10.048895575000074],
            [-14.153187628999945, 10.05565013200004],
            [-14.170480923999946, 10.070786851000037],
            [-14.179798956999946, 10.090277411000045],
            [-14.178781704999949, 10.110296942000048],
            [-14.16274980399993, 10.126613674000055],
            [-14.138172980999911, 10.144476630000042],
            [-14.123646613999938, 10.162583726000037],
            [-14.137766079999949, 10.179185289000088],
            [-14.141672329999949, 10.164536851000037],
            [-14.153146938999953, 10.156317450000074],
            [-14.16860917899993, 10.152736721000053],
            [-14.184925910999937, 10.151922919000071],
            [-14.182484503999945, 10.12954336100006],
            [-14.200184699999909, 10.11273834800005],
            [-14.222401495999918, 10.10610586100006],
            [-14.233387824999909, 10.11399974200009],
            [-14.23656165299991, 10.120917059000078],
            [-14.243560350999928, 10.129380601000037],
            [-14.250599738999938, 10.14052969000005],
            [-14.25381425699993, 10.15534088700008],
            [-14.250477667999917, 10.162583726000037],
            [-14.24404863199993, 10.168890692000048],
            [-14.240061001999948, 10.175116278000075],
            [-14.243885870999918, 10.182318427000041],
            [-14.249256964999915, 10.184271552000041],
            [-14.254750128999945, 10.182847398000092],
            [-14.259022589999915, 10.17959219000005],
            [-14.260650193999936, 10.17576732000009],
            [-14.270130988999938, 10.159735419000071],
            [-14.29210364499994, 10.17177969000005],
            [-14.352365688999953, 10.226223049000055],
            [-14.362700975999928, 10.23118724200009],
            [-14.376698370999918, 10.234442450000074],
            [-14.391835089999915, 10.23338450700004],
            [-14.405506964999915, 10.229396877000056],
            [-14.418568488999938, 10.22797272300005],
            [-14.43195553299995, 10.234442450000074],
            [-14.452544725999928, 10.214585679000038],
            [-14.462635870999918, 10.225165106000077],
            [-14.465891079999949, 10.249701239000046],
            [-14.466135219999956, 10.272040106000077],
            [-14.458241339999915, 10.304266669000071],
            [-14.458607550999943, 10.316961981000077],
            [-14.463042772999927, 10.330023505000042],
            [-14.46861731699994, 10.33624909100007],
            [-14.475331183999913, 10.340318101000037],
            [-14.537261522999927, 10.403631903000075],
            [-14.548003709999932, 10.425604559000078],
            [-14.550892706999946, 10.446600653000075],
            [-14.550526495999918, 10.47211334800005],
            [-14.545521613999938, 10.495021877000056],
            [-14.535593227999925, 10.507473049000055],
            [-14.53502356699994, 10.508205471000053],
            [-14.535430467999959, 10.508164781000062],
            [-14.55142167899993, 10.506781317000048],
            [-14.56240800699993, 10.499335028000075],
            [-14.571603969999956, 10.489447333000044],
            [-14.582834438999953, 10.480861721000053],
            [-14.596424933999913, 10.475978908000059],
            [-14.61351477799991, 10.47337474200009],
            [-14.628977016999954, 10.476263739000046],
            [-14.637440558999913, 10.48773834800005],
            [-14.644276495999918, 10.48773834800005],
            [-14.651193813999953, 10.475083726000037],
            [-14.657785610999952, 10.47955963700008],
            [-14.662709113999938, 10.49412669500009],
            [-14.66470292899993, 10.51162344000005],
            [-14.663807745999918, 10.52920156500005],
            [-14.661122199999909, 10.542629299000055],
            [-14.650461391999954, 10.570257880000042],
            [-14.639393683999913, 10.56663646000004],
            [-14.625965949999909, 10.577378648000092],
            [-14.611398891999954, 10.592962958000044],
            [-14.596424933999913, 10.60374583500004],
            [-14.620594855999911, 10.604315497000073],
            [-14.628651495999918, 10.617254950000074],
            [-14.627430792999917, 10.63548411700009],
            [-14.615223761999914, 10.69131094000005],
            [-14.60728919199994, 10.70538971600007],
            [-14.596424933999913, 10.699367580000057],
            [-14.590240037999934, 10.699367580000057],
            [-14.588286912999934, 10.71430084800005],
            [-14.58071855399993, 10.722072658000059],
            [-14.572417772999927, 10.726304429000038],
            [-14.568511522999927, 10.731024481000077],
            [-14.555490688999953, 10.77570221600007],
            [-14.531320766999954, 10.823472398000092],
            [-14.51744544199994, 10.829046942000048],
            [-14.50967363199993, 10.842474677000041],
            [-14.508371548999946, 10.85846588700008],
            [-14.51390540299991, 10.871893622000073],
            [-14.50999915299991, 10.876450914000088],
            [-14.50023352799991, 10.891099351000037],
            [-14.519927537999934, 10.88540273600006],
            [-14.52257239499994, 10.877630927000041],
            [-14.519154425999943, 10.866522528000075],
            [-14.52135169199994, 10.850816148000092],
            [-14.55492102799991, 10.827622789000088],
            [-14.55890865799995, 10.823472398000092],
            [-14.573475714999915, 10.81240469000005],
            [-14.590402798999946, 10.787258205000057],
            [-14.604359503999945, 10.760443427000041],
            [-14.615956183999913, 10.728013414000088],
            [-14.629709438999953, 10.706447658000059],
            [-14.657866990999935, 10.672674872000073],
            [-14.686105923999946, 10.648179429000038],
            [-14.699818488999938, 10.643133856000077],
            [-14.70571855399993, 10.65525950700004],
            [-14.703724738999938, 10.670843817000048],
            [-14.698109503999945, 10.681830145000049],
            [-14.689442511999914, 10.688950914000088],
            [-14.678334113999938, 10.693101304000038],
            [-14.68578040299991, 10.694728908000059],
            [-14.691761847999942, 10.694484768000052],
            [-14.697865363999938, 10.691839911000045],
            [-14.70571855399993, 10.686346747000073],
            [-14.719349738999938, 10.699367580000057],
            [-14.70689856699994, 10.739203192000048],
            [-14.69908606699994, 10.756252346000053],
            [-14.688384568999936, 10.771958726000037],
            [-14.682199673999946, 10.777777411000045],
            [-14.668080206999946, 10.78709544500009],
            [-14.661284959999932, 10.792792059000078],
            [-14.655995245999918, 10.800604559000078],
            [-14.653309699999909, 10.80760325700004],
            [-14.651356574999909, 10.809963283000059],
            [-14.65656490799995, 10.81195709800005],
            [-14.66470292899993, 10.81663646000004],
            [-14.67796790299991, 10.799627997000073],
            [-14.723133917999917, 10.765122789000088],
            [-14.734771287999934, 10.748114325000074],
            [-14.746449347999942, 10.710760809000078],
            [-14.760324673999946, 10.699367580000057],
            [-14.770008917999917, 10.718817450000074],
            [-14.782704230999911, 10.731268622000073],
            [-14.79283606699994, 10.745021877000056],
            [-14.795074022999927, 10.768255927000041],
            [-14.781605597999942, 10.767767645000049],
            [-14.770008917999917, 10.776922919000071],
            [-14.760812954999949, 10.790432033000059],
            [-14.75413977799991, 10.80296458500004],
            [-14.749256964999915, 10.816107489000046],
            [-14.746083136999914, 10.831203518000052],
            [-14.744984503999945, 10.84406159100007],
            [-14.746693488999938, 10.850816148000092],
            [-14.743885870999918, 10.856594143000052],
            [-14.74242102799991, 10.860988674000055],
            [-14.74046790299991, 10.871893622000073],
            [-14.75890051999994, 10.85846588700008],
            [-14.765288865999935, 10.85032786700009],
            [-14.767730272999927, 10.84088776200008],
            [-14.77257239499994, 10.836493231000077],
            [-14.801258917999917, 10.823472398000092],
            [-14.808705206999946, 10.823472398000092],
            [-14.80968176999994, 10.834784247000073],
            [-14.809071417999917, 10.84560781500005],
            [-14.80650794199994, 10.85545482000009],
            [-14.801258917999917, 10.864447333000044],
            [-14.80728105399993, 10.873602606000077],
            [-14.807972785999937, 10.882473049000055],
            [-14.80382239499994, 10.890814520000049],
            [-14.795074022999927, 10.898586330000057],
            [-14.813872850999928, 10.900336005000042],
            [-14.819732225999928, 10.91201406500005],
            [-14.816761847999942, 10.92719147300005],
            [-14.808705206999946, 10.939601955000057],
            [-14.796131964999915, 10.94757721600007],
            [-14.778635219999956, 10.95408763200004],
            [-14.759917772999927, 10.95844147300005],
            [-14.743560350999928, 10.96002838700008],
            [-14.731760219999956, 10.966457424000055],
            [-14.724964972999942, 10.980536200000074],
            [-14.72061113199993, 10.994574286000045],
            [-14.716297980999911, 11.00096263200004],
            [-14.69945227799991, 11.005519924000055],
            [-14.68077551999994, 11.027492580000057],
            [-14.66470292899993, 11.03579336100006],
            [-14.672230597999942, 11.041449286000045],
            [-14.677235480999911, 11.04759349200009],
            [-14.685170050999943, 11.063666083000044],
            [-14.687001105999911, 11.054266669000071],
            [-14.69009355399993, 11.04523346600007],
            [-14.694976365999935, 11.038478908000059],
            [-14.70225989499994, 11.03579336100006],
            [-14.707875128999945, 11.034491278000075],
            [-14.723540818999936, 11.028265692000048],
            [-14.72679602799991, 11.025824286000045],
            [-14.730824347999942, 11.00584544500009],
            [-14.741525844999956, 10.989081122000073],
            [-14.756825324999909, 10.98118724200009],
            [-14.774566209999932, 10.987982489000046],
            [-14.779449022999927, 10.983303127000056],
            [-14.784575975999928, 10.98110586100006],
            [-14.791411912999934, 10.98037344000005],
            [-14.801258917999917, 10.980536200000074],
            [-14.795480923999946, 10.999701239000046],
            [-14.801258917999917, 11.011908270000049],
            [-14.810658331999946, 11.014471747000073],
            [-14.81554114499994, 11.004706122000073],
            [-14.843495245999918, 10.967474677000041],
            [-14.874623175999943, 10.97329336100006],
            [-14.89443925699993, 11.03025950700004],
            [-14.918568488999938, 11.028957424000055],
            [-14.90147864499994, 11.011664130000042],
            [-14.898793097999942, 10.99323151200008],
            [-14.904123501999948, 10.975490627000056],
            [-14.911122199999909, 10.96002838700008],
            [-14.93195553299995, 10.97565338700008],
            [-14.943918423999946, 10.980047919000071],
            [-14.959584113999938, 10.980536200000074],
            [-14.926380988999938, 10.955552476000037],
            [-14.914418097999942, 10.942328192000048],
            [-14.911122199999909, 10.925930080000057],
            [-14.920887824999909, 10.90766022300005],
            [-14.939808722999942, 10.889105536000045],
            [-14.95811926999994, 10.876206773000092],
            [-14.966420050999943, 10.87498607000009],
            [-14.968495245999918, 10.877875067000048],
            [-14.973215298999946, 10.878851630000042],
            [-14.977894660999937, 10.877875067000048],
            [-14.980051235999952, 10.87498607000009],
            [-14.978993292999917, 10.868841864000046],
            [-14.974232550999943, 10.85927969000005],
            [-14.973215298999946, 10.854193427000041],
            [-14.973215298999946, 10.820054429000038],
            [-14.96898352799991, 10.81435781500005],
            [-14.959584113999938, 10.809963283000059],
            [-14.950184699999909, 10.80377838700008],
            [-14.945912238999938, 10.792792059000078],
            [-14.947661912999934, 10.787583726000037],
            [-14.959584113999938, 10.768255927000041],
            [-14.977528449999909, 10.777044989000046],
            [-15.01390540299991, 10.782619533000059],
            [-15.03156490799995, 10.792792059000078],
            [-15.05260169199994, 10.814398505000042],
            [-15.06944739499994, 10.837144273000092],
            [-15.079457160999937, 10.858710028000075],
            [-15.081125454999949, 10.878241278000075],
            [-15.074330206999946, 10.896877346000053],
            [-15.05890865799995, 10.915961005000042],
            [-15.051625128999945, 10.919623114000046],
            [-15.03189042899993, 10.925482489000046],
            [-15.027821417999917, 10.929348049000055],
            [-15.026682094999956, 10.936672268000052],
            [-15.023589647999927, 10.94358958500004],
            [-15.01939856699994, 10.94953034100007],
            [-15.014800584999932, 10.953802802000041],
            [-15.014800584999932, 10.96002838700008],
            [-15.019276495999918, 10.95970286700009],
            [-15.020334438999953, 10.961371161000045],
            [-15.020130988999938, 10.964178778000075],
            [-15.020985480999911, 10.967474677000041],
            [-14.992594359999913, 10.99620330800012],
            [-14.992594359999913, 10.99635833700006],
            [-14.959056355999905, 11.035761617000077],
            [-14.863144896999955, 11.218644511000065],
            [-14.84324947099995, 11.297192688000095],
            [-14.828211628999952, 11.334787293000119],
            [-14.728992878999918, 11.478008525000035],
            [-14.711061157999922, 11.497568055000045],
            [-14.686773234999919, 11.510719706000117],
            [-14.645380411999895, 11.515060527000102],
            [-14.562258870999898, 11.505603740000126],
            [-14.520943562999975, 11.512890116000108],
            [-14.432267985999886, 11.560575461000056],
            [-14.339223388999898, 11.610610250000065],
            [-14.32648514899995, 11.620583801000066],
            [-14.31979304999993, 11.630505677000073],
            [-14.308217528999876, 11.654535217000088],
            [-14.300388549999951, 11.663165182000043],
            [-14.289691527999935, 11.66884958900009],
            [-14.284472208999915, 11.668177795000105],
            [-14.278736124999881, 11.665077210000064],
            [-14.195020304999929, 11.65970286000001],
            [-14.171972615999948, 11.662751770000028],
            [-14.161844034999916, 11.660943095000036],
            [-14.153084879999938, 11.654845276000074],
            [-14.144480753999886, 11.647403870000062],
            [-14.134920612999906, 11.641771139000127],
            [-14.11856502299986, 11.637998759000098],
            [-14.104664062999888, 11.638567200000054],
            [-14.074640055999907, 11.643734843000061],
            [-14.058827066999925, 11.644044902000047],
            [-14.015134643999943, 11.63712026000006],
            [-13.996453612999886, 11.64383819600009],
            [-13.95335546899986, 11.6696764120001],
            [-13.945423136999892, 11.675670878000048],
            [-13.923744872999919, 11.665025533000048],
            [-13.903642740999942, 11.665387268000046],
            [-13.886408650999954, 11.675567525000105],
            [-13.873515380999947, 11.69453277600006],
            [-13.870673176999901, 11.704144592000077],
            [-13.86852860499991, 11.727037252000088],
            [-13.873050292999949, 11.738354391000072],
            [-13.870053059999918, 11.743677063000106],
            [-13.855041055999948, 11.743418681000051],
            [-13.84628190099997, 11.737269185000073],
            [-13.84297460999997, 11.71727040600004],
            [-13.83455135099996, 11.712102763000132],
            [-13.820133625999858, 11.708072001000048],
            [-13.819513509999894, 11.701664124000104],
            [-13.82168391899998, 11.694222718000077],
            [-13.815766967999878, 11.686832987000074],
            [-13.795690673999928, 11.684042460000114],
            [-13.77000748699993, 11.688693339000082],
            [-13.745771240999943, 11.69820180300006],
            [-13.729932413999848, 11.709829000000113],
            [-13.724764770999855, 11.723109843000117],
            [-13.719571289999948, 11.766104635000104],
            [-13.719364582999987, 11.784036356000087],
            [-13.734634968999927, 11.901858622000091],
            [-13.731327677999928, 11.943406474000085],
            [-13.722594360999949, 11.983869121000083],
            [-13.723937947999929, 12.002782694000118],
            [-13.734919189999914, 12.0192674770001],
            [-13.744427652999889, 12.023918355000063],
            [-13.779645141999964, 12.029344381000044],
            [-13.795897378999882, 12.036269023000017],
            [-13.807757120999895, 12.044278870000085],
            [-13.829642089999936, 12.068101706000064],
            [-13.835197306999959, 12.077765198000094],
            [-13.837729450999944, 12.085413310000064],
            [-13.8424061689999, 12.091304423000068],
            [-13.869717162999848, 12.100709534000117],
            [-13.879768228999865, 12.107685852000117],
            [-13.89930192099996, 12.126237691000057],
            [-13.918396362999943, 12.137761536000085],
            [-13.93865352399996, 12.14427276700006],
            [-13.964853474999899, 12.14789011700013],
            [-13.972527424999953, 12.151559143000043],
            [-13.968367472999944, 12.162566223000042],
            [-13.968264119999901, 12.183960267000131],
            [-13.965731973999908, 12.194243877000133],
            [-13.94392451999991, 12.218635152000061],
            [-13.883153035999982, 12.246437073000024],
            [-13.858968464999919, 12.265970764000116],
            [-13.840003213999864, 12.277132873000056],
            [-13.812640543999919, 12.283592428000105],
            [-13.795690673999928, 12.278734843000095],
            [-13.808558104999918, 12.256100565000054],
            [-13.740836141999921, 12.256927389000069],
            [-13.711819823999917, 12.267521057000053],
            [-13.695024983999872, 12.292945862000053],
            [-13.691020059999886, 12.319300842000118],
            [-13.683010212999903, 12.338679505000087],
            [-13.682028360999936, 12.35030670200004],
            [-13.685154784999895, 12.379193828000083],
            [-13.6841470949999, 12.392009583000075],
            [-13.682028360999936, 12.400329489000043],
            [-13.664432535999964, 12.44151560500012],
            [-13.660711832999937, 12.458672180000079],
            [-13.663399007999885, 12.47577707900004],
            [-13.674690307999953, 12.496085917000059],
            [-13.725074828999936, 12.558149312000111],
            [-13.734634968999927, 12.585331116000091],
            [-13.736314453999881, 12.607603658000059],
            [-13.72827876799991, 12.673387757000029],
            [-13.404758463999912, 12.661760559000072],
            [-13.359801389999916, 12.649736595000135],
            [-13.356647704999915, 12.648893128000068],
            [-13.352048502999878, 12.646981100000048],
            [-13.343444376999855, 12.64098663400003],
            [-13.338612630999933, 12.63922963500005],
            [-13.332773192999952, 12.639643047000064],
            [-13.330034342999909, 12.642071839000025],
            [-13.32770890299986, 12.644914042000082],
            [-13.322877156999937, 12.64651601200012],
            [-13.292930663999925, 12.65271718400001],
            [-13.28414567099992, 12.653337300000075],
            [-13.275722411999936, 12.651063537000056],
            [-13.263397582999886, 12.643208720000118],
            [-13.254690103999934, 12.641813456000051],
            [-13.24600846399997, 12.643157043000102],
            [-13.229084432999883, 12.64780792200007],
            [-13.22153967299991, 12.648376363000125],
            [-13.216010294999904, 12.645740866000025],
            [-13.206450154999914, 12.635663961000077],
            [-13.201902628999989, 12.633390198000058],
            [-13.19787186699989, 12.634061992000042],
            [-13.185211140999854, 12.637782695000055],
            [-13.17627111899992, 12.63773101800004],
            [-13.169217284999917, 12.638764547000022],
            [-13.162628540999918, 12.638144430000054],
            [-13.154696207999876, 12.632821757000102],
            [-13.145316935999915, 12.643932191000118],
            [-13.127307698999914, 12.634837138000051],
            [-13.108988402999927, 12.635405579000107],
            [-13.091702636999855, 12.638196106000066],
            [-13.076458089999903, 12.635922343000047],
            [-13.063642333999923, 12.62227976500013],
            [-13.059327351999855, 12.603469544000035],
            [-13.06041255699995, 12.583367411000069],
            [-13.064210774999879, 12.566159160000083],
            [-13.079093586999903, 12.53215606700006],
            [-13.082710936999888, 12.515671285000067],
            [-13.078266764999881, 12.49624094700009],
            [-13.066742919999854, 12.480117900000025],
            [-13.051989297999853, 12.472263082000083],
            [-13.034626017999926, 12.470557760000105],
            [-13.015247354999872, 12.472676494000083],
            [-12.997418985999929, 12.465855205000125],
            [-12.981037556999866, 12.466992086000047],
            [-12.969513712999856, 12.476810608000022],
            [-12.966232258999867, 12.496085917000059],
            [-12.949489094999905, 12.535928447000074],
            [-12.913134724999935, 12.536341858000085],
            [-12.874041503999905, 12.516394755000064],
            [-12.84921097799986, 12.495000712000149],
            [-12.849650227999888, 12.491073304000082],
            [-12.851252196999923, 12.484355367000063],
            [-12.84913346399992, 12.475828756000055],
            [-12.838617309999876, 12.466371968000075],
            [-12.82905716899998, 12.46275461800009],
            [-12.799420735999917, 12.46063588500003],
            [-12.78347855699991, 12.453091126000075],
            [-12.779163574999927, 12.4432726040001],
            [-12.77327246099992, 12.435056050000071],
            [-12.752653563999928, 12.432420553000057],
            [-12.688058024999862, 12.43598622600011],
            [-12.667516641999896, 12.433660787000093],
            [-12.648008788999988, 12.42575429300004],
            [-12.631549845999928, 12.41268015500009],
            [-12.603412027999866, 12.381932678000041],
            [-12.598063517999918, 12.372424215000052],
            [-12.597314208999904, 12.365447896000148],
            [-12.59367102099992, 12.361572164000094],
            [-12.57940832599985, 12.361158753000083],
            [-12.578129722999932, 12.361528379000035],
            [-12.570649169999882, 12.363690898000073],
            [-12.541451985999942, 12.379452209000064],
            [-12.521918293999931, 12.38689361600008],
            [-12.505071776999955, 12.390252584000095],
            [-12.487760172999856, 12.389477438000085],
            [-12.466753702999938, 12.38446482400012],
            [-12.423397175999867, 12.369116924000053],
            [-12.405517130999897, 12.356456198000018],
            [-12.377120930999894, 12.313668111000084],
            [-12.360920369999889, 12.305606588000089],
            [-12.192041788999887, 12.348756409000117],
            [-12.155041462999861, 12.369013571000025],
            [-12.12191686999995, 12.39872751900009],
            [-12.103985148999868, 12.407357483000041],
            [-12.07918046099985, 12.408132630000054],
            [-12.018874063999931, 12.388443909000102],
            [-11.997583373999873, 12.38637685200004],
            [-11.984302530999855, 12.389012350000058],
            [-11.946268676999921, 12.409424540000103],
            [-11.93520992099991, 12.417020976000074],
            [-11.930869099999938, 12.418726298000124],
            [-11.923944457999937, 12.41877797400005],
            [-11.921980753999918, 12.417692770000144],
            [-11.920637166999938, 12.416039124000093],
            [-11.860175739999931, 12.39107940700012],
            [-11.839608519999928, 12.386686910000037],
            [-11.757804727999911, 12.383327942000022],
            [-11.720029255999862, 12.389477438000085],
            [-11.643083048999927, 12.417641093000043],
            [-11.601535196999862, 12.425237528000096],
            [-11.515390583999931, 12.431645407000047],
            [-11.481645873999895, 12.428234762000017],
            [-11.41601680599993, 12.404980367000093],
            [-11.38842159099994, 12.403895162000097],
            [-11.388628295999894, 12.38446482400012],
            [-11.407593546999863, 12.381932678000041],
            [-11.431674763999894, 12.382966207000024],
            [-11.447229369999917, 12.37454294900003],
            [-11.451466837999874, 12.352115377000132],
            [-11.444903930999885, 12.312531230000076],
            [-11.444593872999917, 12.289483541000024],
            [-11.463249064999985, 12.24995107000008],
            [-11.491671101999913, 12.220908916000084],
            [-11.507794148999892, 12.191608378000112],
            [-11.48960404499985, 12.15119740800013],
            [-11.470793822999923, 12.134609273000123],
            [-11.409557250999882, 12.107892558000074],
            [-11.391728881999938, 12.093733216000118],
            [-11.351317911999956, 12.040403138000045],
            [-11.334678100999952, 12.026192118000083],
            [-11.315144408999856, 12.013324687000079],
            [-11.294680541999895, 12.003092754000093],
            [-11.27499182099993, 11.996271464000046],
            [-11.25550980599985, 11.996168111000117],
            [-11.223315388999879, 12.00929392500008],
            [-11.206985636999946, 12.010172425000121],
            [-11.191172648999952, 12.014409892000074],
            [-11.176341511999937, 12.02949941000007],
            [-11.16564448999992, 12.048619690000066],
            [-11.159391642999907, 12.07750681500002],
            [-11.152725382999904, 12.080865784000125],
            [-11.144250447999895, 12.081330872000066],
            [-11.136292276999939, 12.085103251000078],
            [-11.122081258999884, 12.107272441000106],
            [-11.11747712499988, 12.112701843000096],
            [-11.116603555999887, 12.113731995000066],
            [-11.08430578599993, 12.136572978000075],
            [-11.072781941999892, 12.14949208600008],
            [-11.059811157999945, 12.192435202000055],
            [-11.052318074999931, 12.202512106000086],
            [-11.038778849999858, 12.205250956000029],
            [-11.015472778999907, 12.204424134000107],
            [-10.972012898999907, 12.218583476000049],
            [-10.952117471999912, 12.21946197600009],
            [-10.927674519999869, 12.212950745000029],
            [-10.909794474999899, 12.200134990000038],
            [-10.869641886999887, 12.13843332900008],
            [-10.846387491999877, 12.12138010700005],
            [-10.822926391999914, 12.11047638000008],
            [-10.804942992999912, 12.095955302000036],
            [-10.798535115999869, 12.068101706000064],
            [-10.801222289999913, 12.059213359000054],
            [-10.811040811999874, 12.041540019000053],
            [-10.812436075999955, 12.033426819000042],
            [-10.807785196999902, 12.022833150000068],
            [-10.781016804999922, 11.996219787000129],
            [-10.740347452999856, 11.919893698000095],
            [-10.711356973999898, 11.890386455000083],
            [-10.669964151999949, 11.892040100000116],
            [-10.655081339999896, 11.898964742000103],
            [-10.645159464999892, 11.908369853000067],
            [-10.634152384999908, 11.9254230760001],
            [-10.625264038999887, 11.943871562000112],
            [-10.621543334999984, 11.957669169000056],
            [-10.613791869999886, 11.967694397000088],
            [-10.595653442999946, 11.979890035000096],
            [-10.574982869999928, 11.990328675000043],
            [-10.559479939999932, 11.995186260000054],
            [-10.566507934999919, 12.017252095000046],
            [-10.555449177999918, 12.029344381000044],
            [-10.535398722999957, 12.038697815000077],
            [-10.515089883999877, 12.052908834000036],
            [-10.514883178999895, 12.060143535000094],
            [-10.517673706999858, 12.070737203000078],
            [-10.517311970999856, 12.080349019000096],
            [-10.507958536999922, 12.084586487000138],
            [-10.504444539999952, 12.088358866000064],
            [-10.512661091999888, 12.10846099900003],
            [-10.511627563999923, 12.118072815000048],
            [-10.49348913599988, 12.124429016000065],
            [-10.445688435999898, 12.120708313000065],
            [-10.435973266999952, 12.135177714000093],
            [-10.42894527199985, 12.143394267000119],
            [-10.394580443999928, 12.171609599000092],
            [-10.381402953999924, 12.1801362100001],
            [-10.37484004699985, 12.174813538000066],
            [-10.368225463999863, 12.171506246000064],
            [-10.353394327999922, 12.166493632000098],
            [-10.354117797999919, 12.180859680000097],
            [-10.348433390999958, 12.184787089000068],
            [-10.33933833799992, 12.185458883000052],
            [-10.329881550999943, 12.190419820000102],
            [-10.325592407999864, 12.199773255000139],
            [-10.323577026999914, 12.201995341000043],
            [-10.31649735499991, 12.196879374000062],
            [-10.313603474999923, 12.191143290000099],
            [-10.31101965399992, 12.191039938000074],
            [-10.304973510999957, 12.20287384000008],
            [-10.266939656999853, 12.217808329000135],
            [-10.258981485999868, 12.213777568000054],
            [-10.254123901999947, 12.207214661000066],
            [-10.247819376999928, 12.201065165000088],
            [-10.214849812999887, 12.194605611000043],
            [-10.179761515999957, 12.17822418200008],
            [-10.160227823999946, 12.17450347900008],
            [-10.1358365479999, 12.17548533200005],
            [-10.128653523999958, 12.17450347900008],
            [-10.118835001999884, 12.170162659000098],
            [-10.105192422999892, 12.15863881500006],
            [-10.097285928999923, 12.153677877000106],
            [-10.090340013999878, 12.151583631000022],
            [-10.08700231899985, 12.150577291000076],
            [-10.07036250899992, 12.149853821000079],
            [-10.060182251999947, 12.147528382000047],
            [-10.048089965999878, 12.14137888600007],
            [-10.027677774999916, 12.125669250000016],
            [-10.015533813999923, 12.11988149000004],
            [-9.996413533999942, 12.114145406000077],
            [-9.961583617999878, 12.096006979000052],
            [-9.941533161999928, 12.092751363000062],
            [-9.923188028999931, 12.087583720000055],
            [-9.888771524999896, 12.060556946000105],
            [-9.870736450999885, 12.052082011000024],
            [-9.861124633999879, 12.051875305000053],
            [-9.840660766999918, 12.055027568000114],
            [-9.833684447999929, 12.055130920000039],
            [-9.823039102999928, 12.050893453000086],
            [-9.806812703999924, 12.038439433000107],
            [-9.796632445999933, 12.032341614000046],
            [-9.778649047999863, 12.02665720600001],
            [-9.72299352999994, 12.025416972000073],
            [-9.698808959999951, 12.050996806000114],
            [-9.686303262999957, 12.068153381000073],
            [-9.681549031999879, 12.080814107000023],
            [-9.683667764999939, 12.101484680000041],
            [-9.682272501999876, 12.118537903000075],
            [-9.675141153999931, 12.133989157000073],
            [-9.659999959999936, 12.149802145000066],
            [-9.628167276999875, 12.170162659000098],
            [-9.51561600799991, 12.207059631000021],
            [-9.495875610999917, 12.22468129500001],
            [-9.479597534999897, 12.23584340500014],
            [-9.438876505999929, 12.254756978000074],
            [-9.421513223999938, 12.257082418000024],
            [-9.360173298999968, 12.246643779000081],
            [-9.336815551999905, 12.269846497000074],
            [-9.331906290999882, 12.282765605000094],
            [-9.335006876999927, 12.306536763000054],
            [-9.321829385999933, 12.310205791000044],
            [-9.312889362999925, 12.32607045500015],
            [-9.308496866999917, 12.345035706000104],
            [-9.309168659999898, 12.357748108000067],
            [-9.314801390999918, 12.36265736900009],
            [-9.331647907999923, 12.36632639600009],
            [-9.339166829999954, 12.370615539000056],
            [-9.343946899999935, 12.380124003000049],
            [-9.344463663999903, 12.389012350000058],
            [-9.34715083799992, 12.396453756000085],
            [-9.374694376999912, 12.41112986300007],
            [-9.39278112799991, 12.428028056000059],
            [-9.407250528999953, 12.445132955000105],
            [-9.41257320199989, 12.45536488900008],
            [-9.398155476999875, 12.473244935000139],
            [-9.350871540999918, 12.484613749000033],
            [-9.334180053999887, 12.496292623000016],
            [-9.32730708899993, 12.497532858000042],
            [-9.321519327999852, 12.496602682000088],
            [-9.308186807999931, 12.488954570000104],
            [-9.294079142999891, 12.483786926000107],
            [-9.286379353999905, 12.488127747000092],
            [-9.278937947999879, 12.494432271000093],
            [-9.265863809999928, 12.495207418000106],
            [-9.189486042999874, 12.479239400000068],
            [-9.14731807499993, 12.465493469000137],
            [-9.027765492999919, 12.40475109700013],
            [-8.993839070999911, 12.387513733000048],
            [-8.97590734799985, 12.368703511000135],
            [-8.96474523899991, 12.346275940000055],
            [-8.963091593999877, 12.324210104000144],
            [-8.972134968999939, 12.301989238000104],
            [-8.985260782999887, 12.282093812000099],
            [-8.995906127999888, 12.26100982700008],
            [-8.997559773999853, 12.234809876000057],
            [-8.994278320999854, 12.224836324000051],
            [-8.98453731299989, 12.20891998300003],
            [-8.981178344999876, 12.198946432000113],
            [-8.973840291999892, 12.18757761700003],
            [-8.961696329999882, 12.187991028000042],
            [-8.942007608999859, 12.195845845000079],
            [-8.927021443999877, 12.18737091000007],
            [-8.9138956299999, 12.169852600000112],
            [-8.906040811999958, 12.1477350870001],
            [-8.906970987999927, 12.125359192000118],
            [-8.921957153999898, 12.086033427000132],
            [-8.92629797399988, 12.064277649000118],
            [-8.922112182999854, 12.04536407500008],
            [-8.903715372999926, 12.030377909000023],
            [-8.88164953599994, 12.029189352000088],
            [-8.858756876999934, 12.031824849000103],
            [-8.837982950999958, 12.028155823000105],
            [-8.819792845999928, 12.012652893000094],
            [-8.815452026999964, 11.99570302300009],
            [-8.81643387899993, 11.976841126000068],
            [-8.814909423999922, 11.95539540700014],
            [-8.809974323999882, 11.944440002000064],
            [-8.803204711999939, 11.934931539000075],
            [-8.797830362999974, 11.925113017000115],
            [-8.797003539999935, 11.913227438000078],
            [-8.847233032999895, 11.657945862000119],
            [-8.828526163999896, 11.659186096000056],
            [-8.81167964699992, 11.651744690000044],
            [-8.795194864999957, 11.641926168000069],
            [-8.777211466999859, 11.63593170200005],
            [-8.756540893999954, 11.638825582000038],
            [-8.740366169999959, 11.646163635000022],
            [-8.726516886999889, 11.649470927000024],
            [-8.712874307999897, 11.64006581600006],
            [-8.690705118999858, 11.568028870000092],
            [-8.687346150999957, 11.55001963300009],
            [-8.679026245999893, 11.529839986000113],
            [-8.667967488999892, 11.510874736000062],
            [-8.656753702999936, 11.496431173000133],
            [-8.602183389999908, 11.472091573000029],
            [-8.57520829299989, 11.470282898000036],
            [-8.549576782999907, 11.490126648000029],
            [-8.543995727999913, 11.477646790000037],
            [-8.539424991999908, 11.456312043000139],
            [-8.535520792999904, 11.43808848100008],
            [-8.527562622999938, 11.423386536000095],
            [-8.51578039599994, 11.418968201000084],
            [-8.488133503999933, 11.418193055000074],
            [-8.427723754999903, 11.400080465000059],
            [-8.397648071999924, 11.385895285000103],
            [-8.375323851999951, 11.367653504000145],
            [-8.393358927999884, 11.363002625000078],
            [-8.414132852999927, 11.353468323000087],
            [-8.426070108999852, 11.340471700000066],
            [-8.41795690899994, 11.325511373000097],
            [-8.39956009999986, 11.322152405000082],
            [-8.38126664299989, 11.325097961000083],
            [-8.3710347089999, 11.320550436000048],
            [-8.376719115999947, 11.294660543000106],
            [-8.38839798999993, 11.281405538000115],
            [-8.4066914469999, 11.275281881000055],
            [-8.426896931999892, 11.27419667600006],
            [-8.44457027199988, 11.276263733000107],
            [-8.4832242439999, 11.284919536000075],
            [-8.492577677999918, 11.27778818800003],
            [-8.503119669999904, 11.255412293000049],
            [-8.50234452399988, 11.251639913000119],
            [-8.499243936999932, 11.246704814000083],
            [-8.497021850999943, 11.240710348000064],
            [-8.498778848999905, 11.233501486000094],
            [-8.502137817999937, 11.231176046000073],
            [-8.512059692999912, 11.23029754700012],
            [-8.515625365999881, 11.229057312000094],
            [-8.52410030099989, 11.223760478000145],
            [-8.544615844999953, 11.214975485000068],
            [-8.551798868999924, 11.210738017000025],
            [-8.563942830999906, 11.193426412000107],
            [-8.569678914999884, 11.157795512000035],
            [-8.578153848999875, 11.142060039000057],
            [-8.586990518999897, 11.137460836000102],
            [-8.607221842999877, 11.13715077700003],
            [-8.6154125569999, 11.134050191000071],
            [-8.624610961999906, 11.122035421000106],
            [-8.624921019999903, 11.112191061000132],
            [-8.622388875999889, 11.102605083000128],
            [-8.623112344999896, 11.091262106000059],
            [-8.63368017599987, 11.071289165000024],
            [-8.679801391999888, 11.025193786000102],
            [-8.688689737999908, 11.01255889900007],
            [-8.696906290999948, 10.996048279000078],
            [-8.700730346999876, 10.978452454000092],
            [-8.696234496999864, 10.962742819000127],
            [-8.680938272999896, 10.952304179000095],
            [-8.665228637999945, 10.956955058000062],
            [-8.64796870899994, 10.96581756600007],
            [-8.62822831199989, 10.967832947000105],
            [-8.611381794999915, 10.965145773000089],
            [-8.593346720999904, 10.964706522000071],
            [-8.5756217039999, 10.966747742000024],
            [-8.559550333999937, 10.97160532600013],
            [-8.541566935999924, 10.983775127000044],
            [-8.531645059999931, 10.999045512000095],
            [-8.505755167999922, 11.052789001000093],
            [-8.489063679999958, 11.05273732500008],
            [-8.469013224999912, 11.046381124000064],
            [-8.448704385999918, 11.04710459500005],
            [-8.438162393999932, 11.049740092000064],
            [-8.429067341999883, 11.04829315200007],
            [-8.410463825999926, 11.04191111300014],
            [-8.400645303999852, 11.04333221500012],
            [-8.381318318999888, 11.053925883000105],
            [-8.369329385999947, 11.054235941000087],
            [-8.347315225999864, 11.043125509000077],
            [-8.326592976999848, 11.023850199000037],
            [-8.311141723999924, 11.000802511000074],
            [-8.305095581999893, 10.978245748000049],
            [-8.30364864099991, 10.874892883000058],
            [-8.305870727999888, 10.856289368000105],
            [-8.311813516999905, 10.847245993000058],
            [-8.318893188999937, 10.839520366000059],
            [-8.339822142999935, 10.783864848000036],
            [-8.341940877999889, 10.76324595200012],
            [-8.315585896999949, 10.75309153200007],
            [-8.311141723999924, 10.73528900200003],
            [-8.295535440999885, 10.53744578000007],
            [-8.284425007999886, 10.511245830000064],
            [-8.25388423699988, 10.469827169000013],
            [-8.22887284399988, 10.423421733000097],
            [-8.21057938699991, 10.41406829900005],
            [-8.189030313999865, 10.413629048000132],
            [-8.165982624999884, 10.418099060000145],
            [-8.150583047999902, 10.424532776000092],
            [-8.142056436999894, 10.429648743000087],
            [-8.135441853999907, 10.427323303000051],
            [-8.125416625999975, 10.411665345000102],
            [-8.122109333999958, 10.39949554400009],
            [-8.120920776999952, 10.373037212000014],
            [-8.115494750999886, 10.360247295000121],
            [-8.096116088999906, 10.346733907000058],
            [-8.070071166999924, 10.341876322000132],
            [-8.015707560999942, 10.339344178000147],
            [-7.996277220999986, 10.328259583000133],
            [-7.981549438999878, 10.307020569000073],
            [-7.971214151999959, 10.281802470000116],
            [-7.964599568999887, 10.258935649000094],
            [-7.962584187999937, 10.233252462000024],
            [-7.968010213999889, 10.209998068000104],
            [-7.989662638999988, 10.161990662000065],
            [-7.999842895999933, 10.150699361000093],
            [-8.007232625999961, 10.13832285600003],
            [-8.012348591999853, 10.124861145000068],
            [-8.015707560999942, 10.110365906000126],
            [-8.034879516999865, 10.085793763000055],
            [-8.057875529999905, 10.073081360000103],
            [-8.108776814999942, 10.054193624000078],
            [-8.127535359999854, 10.037114563000031],
            [-8.14774084499993, 10.01003611300007],
            [-8.15848954299986, 9.984921367000055],
            [-8.148877726999928, 9.973888449000057],
            [-8.136268676999919, 9.969444275000043],
            [-8.14009273299996, 9.959703268000098],
            [-8.152391722999909, 9.949988098000063],
            [-8.173837442999911, 9.941874899000055],
            [-8.174715942999882, 9.933038229000147],
            [-8.17151200299989, 9.922832133000085],
            [-8.167894652999905, 9.914693095000075],
            [-8.16453568499989, 9.912677714000026],
            [-8.158954629999897, 9.912367656000043],
            [-8.15321854699991, 9.91092071600005],
            [-8.149549519999937, 9.905339661000127],
            [-8.147224079999887, 9.887924703000095],
            [-8.145673787999954, 9.882498678000033],
            [-8.14732743299993, 9.88012156200007],
            [-8.152133341999928, 9.878829651000032],
            [-8.155078898999932, 9.875238139000146],
            [-8.15099645999993, 9.866143087000083],
            [-8.146862344999903, 9.864696146000085],
            [-8.128103799999906, 9.866246440000097],
            [-8.123504597999954, 9.844852397000096],
            [-8.160292859999856, 9.584813799000074],
            [-8.161590128999904, 9.575644023000052],
            [-8.161021687999948, 9.553604024000066],
            [-8.157611042999918, 9.530866395000075],
            [-8.152856810999936, 9.513115540000058],
            [-8.145363728999882, 9.49714752200012],
            [-8.08717606599987, 9.415395406000101],
            [-8.070432901999936, 9.39754119900006],
            [-8.054051472999959, 9.389092102000063],
            [-8.03229569499996, 9.384647929000053],
            [-8.009868122999876, 9.38361440000007],
            [-7.991574665999906, 9.385319723000038],
            [-7.971059122999918, 9.392967835000107],
            [-7.933025268999899, 9.414258525],
            [-7.911889607999854, 9.418651021000088],
            [-7.870600137999929, 9.418599345000075],
            [-7.86538081799992, 9.409917705000026],
            [-7.891735798999889, 9.330232645000066],
            [-7.894939737999948, 9.307133281000091],
            [-7.930648152999936, 9.220291036000091],
            [-7.929562947999955, 9.183884990000095],
            [-7.878713337999926, 9.163912049000075],
            [-7.866310993999974, 9.16603078200005],
            [-7.85623408999993, 9.17021657300009],
            [-7.847914184999865, 9.168562928000128],
            [-7.834219929999932, 9.142983093000083],
            [-7.823367878999903, 9.131976013000099],
            [-7.801043660999937, 9.114793599000038],
            [-7.759392455999915, 9.091668396000046],
            [-7.746783406999896, 9.076449687000107],
            [-7.748202714999906, 9.075403105000106],
            [-7.764198364999913, 9.063608093000113],
            [-7.788072875999916, 9.060042420000059],
            [-7.807813273999955, 9.060042420000059],
            [-7.827036905999904, 9.057820333000052],
            [-7.916747192999878, 9.012345073000091],
            [-7.93183671099996, 8.996557922000108],
            [-7.931888386999987, 8.996454570000083],
            [-7.941603555999933, 8.972218323000092],
            [-7.946461140999929, 8.94860219300007],
            [-7.950698608999886, 8.899535421000053],
            [-7.968940388999954, 8.812848205000094],
            [-7.958915160999936, 8.781997375000103],
            [-7.913129841999904, 8.768225606000073],
            [-7.890960652999865, 8.765693462000073],
            [-7.831015990999958, 8.747658386000083],
            [-7.826571817999877, 8.748226827000039],
            [-7.816055663999919, 8.753523661000074],
            [-7.810190388999928, 8.753368633000122],
            [-7.803679157999852, 8.749053650000064],
            [-7.795695149999887, 8.736470439000044],
            [-7.790915079999877, 8.730941061000038],
            [-7.772053181999866, 8.714533793000072],
            [-7.765128539999893, 8.70608469700008],
            [-7.741202351999959, 8.662909038000052],
            [-7.731823079999913, 8.652082825000107],
            [-7.703943644999868, 8.633479309000052],
            [-7.696812296999923, 8.624849346000104],
            [-7.691592976999885, 8.606142477000034],
            [-7.693970092999848, 8.567772725000097],
            [-7.691696329999928, 8.546662903000069],
            [-7.67924230999995, 8.505089213000076],
            [-7.679293986999937, 8.48772593200006],
            [-7.686477009999919, 8.462585348000118],
            [-7.689577596999953, 8.438659160000029],
            [-7.683221394999919, 8.417316793000026],
            [-7.662447469999961, 8.37486460400008],
            [-7.720738484999913, 8.368534241000063],
            [-7.748333699999904, 8.372306621000092],
            [-7.771019652999883, 8.386517639000147],
            [-7.802438923999915, 8.449201151000082],
            [-7.82383296699993, 8.477855734000073],
            [-7.845743773999885, 8.474315898000015],
            [-7.849412801999961, 8.4592005410001],
            [-7.846777302999953, 8.44268992100011],
            [-7.84858597799996, 8.428633931000093],
            [-7.865587524999881, 8.420882467000084],
            [-7.882330687999911, 8.421450908000054],
            [-7.898582926999921, 8.426282654000062],
            [-7.912871459999906, 8.434189148000101],
            [-7.923826862999903, 8.44377512600002],
            [-7.931578328999905, 8.45703013100011],
            [-7.93695267699988, 8.471422018000027],
            [-7.943877318999853, 8.4846253460001],
            [-7.956279662999918, 8.494366354000064],
            [-7.970542357999904, 8.496950175000066],
            [-7.985890258999859, 8.494934795000106],
            [-8.015707560999942, 8.487209168000021],
            [-8.02490596499996, 8.488604432000088],
            [-8.042475952999922, 8.487157492000094],
            [-8.05066666699986, 8.487674256000048],
            [-8.057203735999849, 8.490852356000104],
            [-8.068107462999905, 8.500464173000111],
            [-8.076634073999912, 8.50325470000007],
            [-8.09689123499993, 8.501704407000148],
            [-8.130119180999941, 8.488604432000088],
            [-8.150531371999904, 8.48648569800011],
            [-8.186343139999934, 8.49369456000008],
            [-8.200295776999923, 8.491834208000071],
            [-8.2488716229999, 8.45356781100007],
            [-8.254401000999906, 8.446513977000052],
            [-8.254297647999891, 8.434499206000083],
            [-8.249078328999872, 8.423776347000071],
            [-8.242102009999883, 8.412769267000087],
            [-8.236882690999948, 8.400082703000038],
            [-8.235280720999924, 8.379515483000148],
            [-8.247631388999878, 8.322568055000076],
            [-8.247631388999878, 8.303835347000089],
            [-8.245305949999931, 8.285076803000095],
            [-8.248251504999928, 8.27357879700007],
            [-8.264581257999879, 8.256499736000123],
            [-8.26597652199996, 8.245983582000065],
            [-8.182932494999903, 8.19167165200011],
            [-8.085522419999933, 8.162035218000057],
            [-8.075962280999931, 8.163378805000121],
            [-8.015707560999942, 8.183894348000095],
            [-8.003305215999887, 8.18404937800004],
            [-8.002426716999935, 8.174308370000091],
            [-8.008266153999926, 8.160433248000032],
            [-8.015707560999942, 8.148160095000094],
            [-8.02170202699989, 8.117722677000117],
            [-8.02128861499989, 8.102658997000034],
            [-8.015707560999942, 8.088473816000075],
            [-7.997052368999903, 8.077337545000134],
            [-7.98041255699988, 8.058992411000062],
            [-7.968216918999872, 8.037029928000095],
            [-7.965637541999882, 8.026927369000063],
            [-7.962635863999935, 8.015170797000053],
            [-7.980360879999864, 8.016566061000034],
            [-7.99250484199996, 8.024162496000102],
            [-8.00216833499988, 8.032430725000054],
            [-8.011986857999943, 8.035557150000088],
            [-8.05384476699993, 8.028761699000142],
            [-8.069089314999871, 8.029278463000082],
            [-8.067228963999867, 8.020751852000075],
            [-8.0688826089999, 7.996567281000097],
            [-8.07911454299989, 7.957654928000125],
            [-8.128878946999919, 7.882569072000123],
            [-8.131204386999855, 7.842416484000111],
            [-8.123762980999913, 7.832029521000095],
            [-8.10143876099994, 7.812805888000071],
            [-8.096322793999946, 7.801902161000015],
            [-8.098260660999898, 7.791876933000083],
            [-8.103919229999917, 7.786347555000077],
            [-8.110482136999906, 7.782420146000021],
            [-8.115133015999959, 7.776890768000015],
            [-8.119008748999931, 7.760819397000134],
            [-8.122626098999916, 7.727488098000094],
            [-8.127380330999898, 7.713018697000066],
            [-8.159523070999853, 7.676328430000083],
            [-8.160194864999909, 7.672194316000073],
            [-8.157404337999964, 7.662375794000098],
            [-8.158024454999918, 7.658241679000071],
            [-8.162106893999947, 7.65415924000007],
            [-8.17342403099991, 7.647803040000042],
            [-8.177868204999925, 7.643875630000068],
            [-8.197866983999859, 7.618554179000085],
            [-8.202621215999955, 7.607185364000102],
            [-8.203034626999852, 7.599588928000045],
            [-8.19977901199988, 7.583362529000041],
            [-8.200244099999907, 7.576334534000111],
            [-8.228976195999905, 7.54429514600011],
            [-8.265356404999892, 7.560056458000091],
            [-8.303235229999899, 7.589305318000044],
            [-8.336773233999907, 7.597831930000069],
            [-8.372274942999951, 7.587289937],
            [-8.390878458999907, 7.585791321000087],
            [-8.414804646999897, 7.612921448000066],
            [-8.440022745999954, 7.599898987000117],
            [-8.485446329999888, 7.557989400000039],
            [-8.515625365999881, 7.577161357000051],
            [-8.547819782999852, 7.600777487000059],
            [-8.566526651999908, 7.623411763000107],
            [-8.572779500999928, 7.650748597000046],
            [-8.567405150999946, 7.68821401000011],
            [-8.686571003999944, 7.694363505000084],
            [-8.694477498999987, 7.674416402000077],
            [-8.720677449999897, 7.642738750000063],
            [-8.727576252999881, 7.622016500000129],
            [-8.73003088399986, 7.587444967000039],
            [-8.731477823999853, 7.581760559000088],
            [-8.737368937999946, 7.571425272000084],
            [-8.739177612999924, 7.565689189000125],
            [-8.738040730999927, 7.559488017000135],
            [-8.734009968999914, 7.557679342000057],
            [-8.72951411999992, 7.556387431000104],
            [-8.726826944999885, 7.551839905000065],
            [-8.725741739999876, 7.528533834000129],
            [-8.729617471999944, 7.508690084000136],
            [-8.73953934699992, 7.490551656000108],
            [-8.756489216999853, 7.472413228000079],
            [-8.784394490999915, 7.455721741000048],
            [-8.790388956999948, 7.45081248000011],
            [-8.793954630999906, 7.441510722000089],
            [-8.795453246999926, 7.421098531000041],
            [-8.799225625999952, 7.412210185000035],
            [-8.807700560999933, 7.404510397000124],
            [-8.824030313999884, 7.399807842000058],
            [-8.83340958699992, 7.393865051000134],
            [-8.851625528999875, 7.371489156000067],
            [-8.860617227999938, 7.357639873000011],
            [-8.86537145999992, 7.346891175000081],
            [-8.863304402999859, 7.32988962800006],
            [-8.855914672999859, 7.311854554000064],
            [-8.851367146999905, 7.292889302000106],
            [-8.85782670099988, 7.273045553000117],
            [-8.868885456999891, 7.266637675000069],
            [-8.912190307999936, 7.250152893000092],
            [-8.925419473999852, 7.248602600000069],
            [-8.944384724999878, 7.278678284000051],
            [-8.95720047999987, 7.286481425000062],
            [-8.96257482899992, 7.262968648000083],
            [-8.973116820999905, 7.267671203000063],
            [-8.977716023999932, 7.266224263000069],
            [-8.98102331499993, 7.250566305000106],
            [-8.98546748899986, 7.250049540000063],
            [-9.00763667799987, 7.243486633000089],
            [-9.015698200999879, 7.238887431000123],
            [-9.032854777999916, 7.240282695000104],
            [-9.046652384999959, 7.232737936000063],
            [-9.059261433999893, 7.221369120000077],
            [-9.073110717999953, 7.211343893000048],
            [-9.086391560999886, 7.207209778000035],
            [-9.100447550999888, 7.204832662000086],
            [-9.106085323999906, 7.202975005000027],
            [-9.113935098999946, 7.200388489000076],
            [-9.125407267999975, 7.190208232000103],
            [-9.116053833999928, 7.224676412000079],
            [-9.119619506999896, 7.237957255000083],
            [-9.139153197999917, 7.247879131000076],
            [-9.14690466399992, 7.254080302000062],
            [-9.147473103999886, 7.271391907000066],
            [-9.153079996999907, 7.275474345000077],
            [-9.175430053999946, 7.27459584600004],
            [-9.18147619699991, 7.275681051000035],
            [-9.206280883999852, 7.298367005000088],
            [-9.219871784999924, 7.360998841000111],
            [-9.234341185999881, 7.381307678000042],
            [-9.249714924999864, 7.383064677000107],
            [-9.283795532999903, 7.374072978000072],
            [-9.299505167999882, 7.376605123000061],
            [-9.305499633999915, 7.383478089000022],
            [-9.312424274999898, 7.40332183800011],
            [-9.319400593999887, 7.411951803000065],
            [-9.327772176999872, 7.417067770000045],
            [-9.335006876999927, 7.419651591000047],
            [-9.349217895999885, 7.421563619000068],
            [-9.365961059999933, 7.421098531000041],
            [-9.375159464999939, 7.419289856000148],
            [-9.379241901999933, 7.415827535000105],
            [-9.381412312999942, 7.404975485000065],
            [-9.38647660299992, 7.401668193000063],
            [-9.392264363999885, 7.399859518000071],
            [-9.407353881999882, 7.378052063000055],
            [-9.418722696999879, 7.387767232000087],
            [-9.438101358999944, 7.421563619000068],
            [-9.449263468999959, 7.40507883700009],
            [-9.478357299999885, 7.376915182000047],
            [-9.486625528999923, 7.372832743000032],
            [-9.487098760999913, 7.373204140000027],
            [-9.490707966999935, 7.376036682000091],
            [-9.479700886999922, 7.385390116000039],
            [-9.473499715999935, 7.395570374000016],
            [-9.470864216999928, 7.40735260000011],
            [-9.470244099999974, 7.420995178000112],
            [-9.466213337999875, 7.433449199000094],
            [-9.4567048749999, 7.443061015000112],
            [-9.436085978999898, 7.458563945000023],
            [-9.413400023999912, 7.492256979000075],
            [-9.40492508999992, 7.513599345000074],
            [-9.408697468999947, 7.527448629000048],
            [-9.390817423999891, 7.548222555000081],
            [-9.383660237999948, 7.559539694000065],
            [-9.378776814999924, 7.586256409000029],
            [-9.372989054999948, 7.601345927000111],
            [-9.364410766999924, 7.614265035000116],
            [-9.353507039999954, 7.622429911000054],
            [-9.374694376999912, 7.6469245400001],
            [-9.37624466999992, 7.68056589800004],
            [-9.366374470999858, 7.716170960000113],
            [-9.355470743999888, 7.74190582300011],
            [-9.38099890199993, 7.774410299000039],
            [-9.38968054199998, 7.791463522000072],
            [-9.415673787999935, 7.824433085000038],
            [-9.4386697999999, 7.866239319000087],
            [-9.44843664499993, 7.907838847000093],
            [-9.446007853999987, 7.950058492000068],
            [-9.433092532999922, 7.993468319000016],
            [-9.431745157999899, 7.996567281000097],
            [-9.42456213399987, 8.005817363000105],
            [-9.422340046999864, 8.015790914000121],
            [-9.424148721999927, 8.026177877000052],
            [-9.429264688999922, 8.036900737000067],
            [-9.440943562999905, 8.050569153000069],
            [-9.451537231999879, 8.051757711000093],
            [-9.46218257699988, 8.043463644000042],
            [-9.474223184999857, 8.02881337500007],
            [-9.472776244999864, 8.040363058000096],
            [-9.461872517999893, 8.058423970000106],
            [-9.459805460999917, 8.068785096000028],
            [-9.4780472409999, 8.141287130000123],
            [-9.478098917999915, 8.152785137000052],
            [-9.481406209999903, 8.164696554000088],
            [-9.491328084999907, 8.16996755000011],
            [-9.51561600799991, 8.174876811000047],
            [-9.530137085999854, 8.185496318000034],
            [-9.53189408399993, 8.212316386000026],
            [-9.52543452999987, 8.240790100000055],
            [-9.51561600799991, 8.256603088000062],
            [-9.510810099999901, 8.261047262000062],
            [-9.509156453999935, 8.2655947880001],
            [-9.510758422999885, 8.27006479900011],
            [-9.51561600799991, 8.274405620000095],
            [-9.52124873899993, 8.28440500900011],
            [-9.525124470999884, 8.295437928000098],
            [-9.530188761999852, 8.305979919000066],
            [-9.539387166999859, 8.314584045000103],
            [-9.5284834389999, 8.325720317000034],
            [-9.522282266999895, 8.330681254000083],
            [-9.51561600799991, 8.334376119000083],
            [-9.511481892999882, 8.336133118000063],
            [-9.499131225999918, 8.343471172000065],
            [-9.504350545999927, 8.346158346000081],
            [-9.511481892999882, 8.353780619000062],
            [-9.52905187999994, 8.36631215500006],
            [-9.579178019999858, 8.38729278600006],
            [-9.592045450999876, 8.405095317000104],
            [-9.600158650999958, 8.41088307700008],
            [-9.60734167499993, 8.402924907000113],
            [-9.61214758299991, 8.396336161000121],
            [-9.619537312999938, 8.392718811000037],
            [-9.628063923999946, 8.391633607000045],
            [-9.636125447999945, 8.392563782000096],
            [-9.653385375999932, 8.392098694000069],
            [-9.668371541999903, 8.388739726000054],
            [-9.677259887999924, 8.391530254000116],
            [-9.675916300999859, 8.409642843000128],
            [-9.666511189999909, 8.422381084000094],
            [-9.653385375999932, 8.431450297000069],
            [-9.645117146999894, 8.44341339200011],
            [-9.650543171999857, 8.464807434000122],
            [-9.663513956999878, 8.477855734000073],
            [-9.683512735999926, 8.487054138000076],
            [-9.70325313299989, 8.487260844000033],
            [-9.715500447999915, 8.473334046000048],
            [-9.717980916999892, 8.45268931000004],
            [-9.718187621999931, 8.438271586000027],
            [-9.722115030999902, 8.435636088000095],
            [-9.735912637999945, 8.450493063000039],
            [-9.74629960099989, 8.468063049000108],
            [-9.750898803999917, 8.485865580000052],
            [-9.757306681999864, 8.53271026700007],
            [-9.76304276499991, 8.549970195000071],
            [-9.773584757999885, 8.5630184930001],
            [-9.790586303999902, 8.565395609000063],
            [-9.790017863999935, 8.553070780000013],
            [-9.79482377099987, 8.54454416900009],
            [-9.802006795999915, 8.537180278000093],
            [-9.808853922999958, 8.528472799000028],
            [-9.808828083999856, 8.520462952000045],
            [-9.80546911699986, 8.512789002000062],
            [-9.806812703999924, 8.506251933000087],
            [-9.831617391999941, 8.499017233000117],
            [-9.849704142999883, 8.48968963600008],
            [-9.858644164999902, 8.487054138000076],
            [-9.863501749999926, 8.493539531000039],
            [-9.868152627999876, 8.498087057000063],
            [-9.87280350699993, 8.500360820000083],
            [-9.886911172999874, 8.49664011700007],
            [-9.89187211199993, 8.495916646000083],
            [-9.911354125999907, 8.495658264000014],
            [-9.928148966999885, 8.493436178000096],
            [-9.944168660999935, 8.488346049000114],
            [-9.961118529999851, 8.479561056000122],
            [-10.000185912999939, 8.44930450400011],
            [-10.040390177999882, 8.425662537000093],
            [-10.06168086699995, 8.422174377000132],
            [-10.075013386999899, 8.42664438900006],
            [-10.07935420799987, 8.439951070000077],
            [-10.069277302999922, 8.486873271000121],
            [-10.07609859199988, 8.50149770100009],
            [-10.091084756999862, 8.510101828000131],
            [-10.147980509999911, 8.524287008000087],
            [-10.164878702999914, 8.524648743000085],
            [-10.181828571999915, 8.519584453000107],
            [-10.2156249599999, 8.486589051000053],
            [-10.232419799999946, 8.477054749000061],
            [-10.240274616999898, 8.493746236000092],
            [-10.260841837999891, 8.485917257000068],
            [-10.271332153999936, 8.484108582000076],
            [-10.282235879999888, 8.4846253460001],
            [-10.293708048999918, 8.483075053000093],
            [-10.302234659999925, 8.485865580000052],
            [-10.310244506999908, 8.490361430000064],
            [-10.337581339999929, 8.49855214500009],
            [-10.344299275999958, 8.49906890900013],
            [-10.37473669499991, 8.494779765000075],
            [-10.38977453599992, 8.489095357000025],
            [-10.402383584999939, 8.481007996000116],
            [-10.414062458999922, 8.470181783000086],
            [-10.423777628999858, 8.456565043000083],
            [-10.447962198999932, 8.407627462000093],
            [-10.460209513999956, 8.392150370000081],
            [-10.519275674999903, 8.334789530000094],
            [-10.554363972999937, 8.311845194000071],
            [-10.572657429999907, 8.304584656000088],
            [-10.583251097999891, 8.30691009500012],
            [-10.61187984199995, 8.325255229000106],
            [-10.626710977999892, 8.331508077000109],
            [-10.65978389499989, 8.333265076000089],
            [-10.688154255999876, 8.324066671000082],
            [-10.707894653999858, 8.30313771500009],
            [-10.715181029999911, 8.269599711000083],
            [-10.735283161999888, 8.287298890000088],
            [-10.7249995519999, 8.319855042000128],
            [-10.70200353999985, 8.353573914],
            [-10.683813435999895, 8.37486460400008],
            [-10.669085652999911, 8.399075013000072],
            [-10.654667928999885, 8.485503845000054],
            [-10.64386755399994, 8.486873271000121],
            [-10.64107702699988, 8.494779765000075],
            [-10.641180378999906, 8.506639506000084],
            [-10.638854939999902, 8.51989451100009],
            [-10.631878620999885, 8.532012635000086],
            [-10.616479043999902, 8.546507874000028],
            [-10.600511026999868, 8.575653382000041],
            [-10.584646361999944, 8.596840719000099],
            [-10.565422729999852, 8.61278289800012],
            [-10.54516556799993, 8.616761983000103],
            [-10.52211787899995, 8.618570659000099],
            [-10.50330765799987, 8.631567281000045],
            [-10.489665079999952, 8.65104929600004],
            [-10.481861937999923, 8.672469177000053],
            [-10.524753377999986, 8.729545797000057],
            [-10.53023107899989, 8.739157613000074],
            [-10.545320597999876, 8.750035502000031],
            [-10.58630000799991, 8.804089051000105],
            [-10.589090535999958, 8.806595358000095],
            [-10.59627355999993, 8.811246237000148],
            [-10.599684203999857, 8.815380351000073],
            [-10.600200967999882, 8.819023540000074],
            [-10.5991157629999, 8.829617208000045],
            [-10.599374145999946, 8.834035543000141],
            [-10.60846919699992, 8.862302552000116],
            [-10.610122843999875, 8.872301941000046],
            [-10.61187984199995, 8.945139872000127],
            [-10.607125609999883, 8.979840597000063],
            [-10.591777709999889, 9.039061788000055],
            [-10.592179110999894, 9.041657513000061],
            [-10.593100657999855, 9.047616856000033],
            [-10.59410314899992, 9.054099630000039],
            [-10.60598872899996, 9.063763123000072],
            [-10.629346476999899, 9.070351867000056],
            [-10.669085652999911, 9.074434306000072],
            [-10.71042679799993, 9.072987366000078],
            [-10.746341918999889, 9.083813578000019],
            [-10.753473266999919, 9.120116272000075],
            [-10.742569539999863, 9.163291931000103],
            [-10.72474117099992, 9.194504496000093],
            [-10.714974324999957, 9.201351624000054],
            [-10.703760538999916, 9.20631256100009],
            [-10.693166869999857, 9.212849630000079],
            [-10.685208698999872, 9.224502666000134],
            [-10.683916788999937, 9.233752747000054],
            [-10.687947549999933, 9.250702617000059],
            [-10.688050902999862, 9.259280904000093],
            [-10.68345170099991, 9.271812439000087],
            [-10.677663939999917, 9.2828970340001],
            [-10.673839884999893, 9.293981628000026],
            [-10.675131795999931, 9.306461487000107],
            [-10.717764851999931, 9.343332622000034],
            [-10.728203490999874, 9.34819020600014],
            [-10.74153601099988, 9.357052714000062],
            [-10.753473266999919, 9.367568868000106],
            [-10.765462199999888, 9.385216370000109],
            [-10.77476395699992, 9.387335103000083],
            [-10.78540930199992, 9.387231750000055],
            [-10.79522782399988, 9.388523662000097],
            [-10.80168737799994, 9.387283427000071],
            [-10.819360717999928, 9.388058574000084],
            [-10.831763061999908, 9.392141012000081],
            [-10.822151244999901, 9.400900167000074],
            [-10.811454223999874, 9.408264058000071],
            [-10.813417927999922, 9.413896789000091],
            [-10.829075886999874, 9.423947855000037],
            [-10.843958699999916, 9.44025177000006],
            [-10.854862426999887, 9.455263773000041],
            [-10.85909989399994, 9.472988790000059],
            [-10.853673868999863, 9.49787099300002],
            [-10.852588663999967, 9.512082011000075],
            [-10.86018509999991, 9.51854156500012],
            [-10.87057206299994, 9.52339915000006],
            [-10.877703409999896, 9.532675070000067],
            [-10.88281937699989, 9.56016693100014],
            [-10.886333373999918, 9.568409323000083],
            [-10.89604854299995, 9.578305359000069],
            [-10.921680053999921, 9.595901184000056],
            [-10.92906978399995, 9.605693868000102],
            [-10.93578771999995, 9.631893819000126],
            [-10.940128539999932, 9.639696961000055],
            [-10.946639770999923, 9.644838765000145],
            [-10.962917846999943, 9.65078155600007],
            [-10.968498900999862, 9.654243876000095],
            [-10.974596719999909, 9.663778178000086],
            [-10.986327270999908, 9.697755432000122],
            [-11.010098428999868, 9.742739766000057],
            [-11.044928344999931, 9.78712982200011],
            [-11.085959431999868, 9.826171366000025],
            [-11.160270141999945, 9.87275767000007],
            [-11.167659871999973, 9.884462383000056],
            [-11.181250772999874, 9.950375672000064],
            [-11.188537149999945, 9.972596538000104],
            [-11.199595906999946, 9.982156677000091],
            [-11.21344519099992, 9.983371074000033],
            [-11.247293253999914, 9.993396301000061],
            [-11.272666381999898, 9.996005961000066],
            [-11.484874922999893, 9.99484470600008],
            [-11.910095174999896, 9.992517802000108],
            [-11.914952758999902, 9.931487936000039],
            [-11.921774047999861, 9.922212016000103],
            [-12.109807050999933, 9.88167583600007],
            [-12.141347208999917, 9.874876404000048],
            [-12.15834875499985, 9.875599874000045],
            [-12.174833536999927, 9.87919138600003],
            [-12.193643757999922, 9.886064351000087],
            [-12.2173890789999, 9.900559591000032],
            [-12.235605020999941, 9.916760152000037],
            [-12.253588419999915, 9.928413188000093],
            [-12.27673946099992, 9.929265849000032],
            [-12.426988687999938, 9.897614034000128],
            [-12.47233475799996, 9.881258443000078],
            [-12.508327392999945, 9.860381165000106],
            [-12.51432185899995, 9.851311951000056],
            [-12.514993652999863, 9.845110779000066],
            [-12.513727579999909, 9.838341167000124],
            [-12.513624226999866, 9.827825013000066],
            [-12.527266804999982, 9.753617656000102],
            [-12.526646687999914, 9.750620423000086],
            [-12.522874308999889, 9.739432475000058],
            [-12.522460896999888, 9.734471537000104],
            [-12.525561482999905, 9.732068584000046],
            [-12.530729125999926, 9.732843730000056],
            [-12.53569006399988, 9.73279205300014],
            [-12.537653767999899, 9.727934469000033],
            [-12.537472900999944, 9.715712992000107],
            [-12.538764810999908, 9.711914775000068],
            [-12.542020426999898, 9.711320496000013],
            [-12.573077962999918, 9.692561951000116],
            [-12.582250528999907, 9.683363546000109],
            [-12.598580281999944, 9.654863994000067],
            [-12.601551676999861, 9.65171173200011],
            [-12.602766072999884, 9.609362895000103],
            [-12.606822671999907, 9.600707093000054],
            [-12.614858357999879, 9.600086975000082],
            [-12.624599364999938, 9.601275533000106],
            [-12.633849446999932, 9.597864889000078],
            [-12.638552001999926, 9.589415792000082],
            [-12.647285318999906, 9.556627096000085],
            [-12.649920816999895, 9.55210540800006],
            [-12.652065388999887, 9.549444071000039],
            [-12.65526932799986, 9.547738749000061],
            [-12.660953734999907, 9.546033427000097],
            [-12.668627685999894, 9.542364400000096],
            [-12.669273640999876, 9.538230285000083],
            [-12.667309936999942, 9.533708598000146],
            [-12.667516641999896, 9.528695984000095],
            [-12.70159724999985, 9.420227152000024],
            [-12.706196451999887, 9.413948466000107],
            [-12.713121093999888, 9.408160706000047],
            [-12.716454222999886, 9.40441416400003],
            [-12.719038045999895, 9.398368022000085],
            [-12.722939615999849, 9.39208933500008],
            [-12.727848876999872, 9.393122864000063],
            [-12.732939005999867, 9.396507670000076],
            [-12.737228149999936, 9.397231141000077],
            [-12.754074666999912, 9.38780019100011],
            [-12.759759073999959, 9.38283925400006],
            [-12.76779475899994, 9.372323100000102],
            [-12.767562214999884, 9.364390767000145],
            [-12.763557291999888, 9.355347392000084],
            [-12.764151570999928, 9.3476734420001],
            [-12.777923339999887, 9.343849386000073],
            [-12.79526078299989, 9.33509023100008],
            [-12.819135294999882, 9.295790304000107],
            [-12.835826781999913, 9.281966858000146],
            [-12.856884927999943, 9.278504537000103],
            [-12.876108560999882, 9.279848124000083],
            [-12.89564225199996, 9.278504537000103],
            [-12.917527221999904, 9.267006531000092],
            [-12.93700923599991, 9.287082825000141],
            [-12.957912352999898, 9.272432557000059],
            [-12.973751179999908, 9.241581727000082],
            [-12.97835038299985, 9.212849630000079],
            [-12.973932047999938, 9.202798564000133],
            [-12.96021195499992, 9.1860812380001],
            [-12.959152588999928, 9.17783884700006],
            [-12.962795775999922, 9.176701966000053],
            [-12.978479573999891, 9.175203349000043],
            [-12.98416398099991, 9.172309469000055],
            [-12.993801635999944, 9.158692729000066],
            [-13.002044026999982, 9.144119975000095],
            [-13.015247354999872, 9.112752380000074],
            [-13.02886409499996, 9.095983379000117],
            [-13.04700252299989, 9.084537049000105],
            [-13.085578979999894, 9.065985209000075],
            [-13.115913045999918, 9.043945211000079],
            [-13.13105423999994, 9.041464742000102],
            [-13.153843546999923, 9.049319560000043],
            [-13.191774047999928, 9.072987366000078],
            [-13.207535359999923, 9.076708069000077],
            [-13.233631957999904, 9.072057190000109],
            [-13.277376057999902, 9.058595479000061],
            [-13.30109615799995, 9.041489976000037],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Liberia',
        iso3: 'LBR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-11.476185675999943, 6.919419664000088],
            [-11.444490519999874, 6.933944804000078],
            [-11.436739053999872, 6.938544007000118],
            [-11.43885778799995, 6.963865458000015],
            [-11.434671996999924, 6.980815328000105],
            [-11.407283487999877, 6.996369934000128],
            [-11.397723347999886, 7.012803040000108],
            [-11.391522175999881, 7.031768290000059],
            [-11.389300089999892, 7.046702779000029],
            [-11.392917439999877, 7.066856588000093],
            [-11.389713500999903, 7.07352284800001],
            [-11.367906046999877, 7.075951640000071],
            [-11.36046464099985, 7.07863881500009],
            [-11.355141967999913, 7.084064840000067],
            [-11.353126586999878, 7.092798157000047],
            [-11.356433878999951, 7.105355530000054],
            [-11.370593220999893, 7.128403218000116],
            [-11.373228718999911, 7.138841858000148],
            [-11.370128132999895, 7.142614238000078],
            [-11.352041381999868, 7.159254049000097],
            [-11.317211466999908, 7.213565979000052],
            [-11.300209919999872, 7.217079977000111],
            [-11.217889363999916, 7.254080302000062],
            [-11.20925939999995, 7.262193502000073],
            [-11.144213025999932, 7.345193486000127],
            [-11.126318725999852, 7.368026836000112],
            [-10.977904011999897, 7.484918925000088],
            [-10.937027953999916, 7.507759909000086],
            [-10.898994099999868, 7.516493225000062],
            [-10.885713256999878, 7.522177633000098],
            [-10.874602823999851, 7.530859273000061],
            [-10.864025142999935, 7.543683809000072],
            [-10.730580606999922, 7.7054739390001],
            [-10.6925984289999, 7.737565003000029],
            [-10.645417845999873, 7.763041483000052],
            [-10.638131469999905, 7.765521952000114],
            [-10.615187133999939, 7.769035950000074],
            [-10.617667602999916, 8.01077830000007],
            [-10.616220662999922, 8.022508850000051],
            [-10.612138224999939, 8.031862284000084],
            [-10.603146524999886, 8.039226176000085],
            [-10.5778250729999, 8.053152975000074],
            [-10.567179728999918, 8.063204041000105],
            [-10.543977009999907, 8.106069642000051],
            [-10.529249226999895, 8.124285584000106],
            [-10.505736449999915, 8.135835266000043],
            [-10.485737670999896, 8.138858338000063],
            [-10.405070760999877, 8.139271749000073],
            [-10.3845552169999, 8.142113953000134],
            [-10.364918172999865, 8.148211772000096],
            [-10.345539509999895, 8.159348043000122],
            [-10.320941528999896, 8.183119202000086],
            [-10.318151001999865, 8.201645203000027],
            [-10.326005818999874, 8.221540629000032],
            [-10.333292195999945, 8.249755962000094],
            [-10.33127681499991, 8.272286885000113],
            [-10.31365515099992, 8.310346578000065],
            [-10.282907673999887, 8.432948914000065],
            [-10.282235879999888, 8.4846253460001],
            [-10.271332153999936, 8.484108582000076],
            [-10.260841837999891, 8.485917257000068],
            [-10.240274616999898, 8.493746236000092],
            [-10.232419799999946, 8.477054749000061],
            [-10.2156249599999, 8.486589051000053],
            [-10.181828571999915, 8.519584453000107],
            [-10.164878702999914, 8.524648743000085],
            [-10.147980509999911, 8.524287008000087],
            [-10.091084756999862, 8.510101828000131],
            [-10.07609859199988, 8.50149770100009],
            [-10.069277302999922, 8.486873271000121],
            [-10.07935420799987, 8.439951070000077],
            [-10.075013386999899, 8.42664438900006],
            [-10.06168086699995, 8.422174377000132],
            [-10.040390177999882, 8.425662537000093],
            [-10.000185912999939, 8.44930450400011],
            [-9.961118529999851, 8.479561056000122],
            [-9.944168660999935, 8.488346049000114],
            [-9.928148966999885, 8.493436178000096],
            [-9.911354125999907, 8.495658264000014],
            [-9.89187211199993, 8.495916646000083],
            [-9.886911172999874, 8.49664011700007],
            [-9.87280350699993, 8.500360820000083],
            [-9.868152627999876, 8.498087057000063],
            [-9.863501749999926, 8.493539531000039],
            [-9.858644164999902, 8.487054138000076],
            [-9.849704142999883, 8.48968963600008],
            [-9.831617391999941, 8.499017233000117],
            [-9.806812703999924, 8.506251933000087],
            [-9.80546911699986, 8.512789002000062],
            [-9.808828083999856, 8.520462952000045],
            [-9.808853922999958, 8.528472799000028],
            [-9.802006795999915, 8.537180278000093],
            [-9.79482377099987, 8.54454416900009],
            [-9.790017863999935, 8.553070780000013],
            [-9.790586303999902, 8.565395609000063],
            [-9.773584757999885, 8.5630184930001],
            [-9.76304276499991, 8.549970195000071],
            [-9.757306681999864, 8.53271026700007],
            [-9.750898803999917, 8.485865580000052],
            [-9.74629960099989, 8.468063049000108],
            [-9.735912637999945, 8.450493063000039],
            [-9.722115030999902, 8.435636088000095],
            [-9.718187621999931, 8.438271586000027],
            [-9.717980916999892, 8.45268931000004],
            [-9.715500447999915, 8.473334046000048],
            [-9.70325313299989, 8.487260844000033],
            [-9.683512735999926, 8.487054138000076],
            [-9.663513956999878, 8.477855734000073],
            [-9.650543171999857, 8.464807434000122],
            [-9.645117146999894, 8.44341339200011],
            [-9.653385375999932, 8.431450297000069],
            [-9.666511189999909, 8.422381084000094],
            [-9.675916300999859, 8.409642843000128],
            [-9.677259887999924, 8.391530254000116],
            [-9.668371541999903, 8.388739726000054],
            [-9.653385375999932, 8.392098694000069],
            [-9.636125447999945, 8.392563782000096],
            [-9.628063923999946, 8.391633607000045],
            [-9.619537312999938, 8.392718811000037],
            [-9.61214758299991, 8.396336161000121],
            [-9.60734167499993, 8.402924907000113],
            [-9.600158650999958, 8.41088307700008],
            [-9.592045450999876, 8.405095317000104],
            [-9.579178019999858, 8.38729278600006],
            [-9.52905187999994, 8.36631215500006],
            [-9.511481892999882, 8.353780619000062],
            [-9.504350545999927, 8.346158346000081],
            [-9.499131225999918, 8.343471172000065],
            [-9.511481892999882, 8.336133118000063],
            [-9.51561600799991, 8.334376119000083],
            [-9.522282266999895, 8.330681254000083],
            [-9.5284834389999, 8.325720317000034],
            [-9.539387166999859, 8.314584045000103],
            [-9.530188761999852, 8.305979919000066],
            [-9.525124470999884, 8.295437928000098],
            [-9.52124873899993, 8.28440500900011],
            [-9.51561600799991, 8.274405620000095],
            [-9.510758422999885, 8.27006479900011],
            [-9.509156453999935, 8.2655947880001],
            [-9.510810099999901, 8.261047262000062],
            [-9.51561600799991, 8.256603088000062],
            [-9.52543452999987, 8.240790100000055],
            [-9.53189408399993, 8.212316386000026],
            [-9.530137085999854, 8.185496318000034],
            [-9.51561600799991, 8.174876811000047],
            [-9.491328084999907, 8.16996755000011],
            [-9.481406209999903, 8.164696554000088],
            [-9.478098917999915, 8.152785137000052],
            [-9.4780472409999, 8.141287130000123],
            [-9.459805460999917, 8.068785096000028],
            [-9.461872517999893, 8.058423970000106],
            [-9.472776244999864, 8.040363058000096],
            [-9.474223184999857, 8.02881337500007],
            [-9.46218257699988, 8.043463644000042],
            [-9.451537231999879, 8.051757711000093],
            [-9.440943562999905, 8.050569153000069],
            [-9.429264688999922, 8.036900737000067],
            [-9.424148721999927, 8.026177877000052],
            [-9.422340046999864, 8.015790914000121],
            [-9.42456213399987, 8.005817363000105],
            [-9.431745157999899, 7.996567281000097],
            [-9.433092532999922, 7.993468319000016],
            [-9.446007853999987, 7.950058492000068],
            [-9.44843664499993, 7.907838847000093],
            [-9.4386697999999, 7.866239319000087],
            [-9.415673787999935, 7.824433085000038],
            [-9.38968054199998, 7.791463522000072],
            [-9.38099890199993, 7.774410299000039],
            [-9.355470743999888, 7.74190582300011],
            [-9.366374470999858, 7.716170960000113],
            [-9.37624466999992, 7.68056589800004],
            [-9.374694376999912, 7.6469245400001],
            [-9.353507039999954, 7.622429911000054],
            [-9.364410766999924, 7.614265035000116],
            [-9.372989054999948, 7.601345927000111],
            [-9.378776814999924, 7.586256409000029],
            [-9.383660237999948, 7.559539694000065],
            [-9.390817423999891, 7.548222555000081],
            [-9.408697468999947, 7.527448629000048],
            [-9.40492508999992, 7.513599345000074],
            [-9.413400023999912, 7.492256979000075],
            [-9.436085978999898, 7.458563945000023],
            [-9.4567048749999, 7.443061015000112],
            [-9.466213337999875, 7.433449199000094],
            [-9.470244099999974, 7.420995178000112],
            [-9.470864216999928, 7.40735260000011],
            [-9.473499715999935, 7.395570374000016],
            [-9.479700886999922, 7.385390116000039],
            [-9.490707966999935, 7.376036682000091],
            [-9.487098760999913, 7.373204140000027],
            [-9.486625528999923, 7.372832743000032],
            [-9.478357299999885, 7.376915182000047],
            [-9.449263468999959, 7.40507883700009],
            [-9.438101358999944, 7.421563619000068],
            [-9.418722696999879, 7.387767232000087],
            [-9.407353881999882, 7.378052063000055],
            [-9.392264363999885, 7.399859518000071],
            [-9.38647660299992, 7.401668193000063],
            [-9.381412312999942, 7.404975485000065],
            [-9.379241901999933, 7.415827535000105],
            [-9.375159464999939, 7.419289856000148],
            [-9.365961059999933, 7.421098531000041],
            [-9.349217895999885, 7.421563619000068],
            [-9.335006876999927, 7.419651591000047],
            [-9.327772176999872, 7.417067770000045],
            [-9.319400593999887, 7.411951803000065],
            [-9.312424274999898, 7.40332183800011],
            [-9.305499633999915, 7.383478089000022],
            [-9.299505167999882, 7.376605123000061],
            [-9.283795532999903, 7.374072978000072],
            [-9.249714924999864, 7.383064677000107],
            [-9.234341185999881, 7.381307678000042],
            [-9.219871784999924, 7.360998841000111],
            [-9.206280883999852, 7.298367005000088],
            [-9.18147619699991, 7.275681051000035],
            [-9.175430053999946, 7.27459584600004],
            [-9.153079996999907, 7.275474345000077],
            [-9.147473103999886, 7.271391907000066],
            [-9.14690466399992, 7.254080302000062],
            [-9.139153197999917, 7.247879131000076],
            [-9.119619506999896, 7.237957255000083],
            [-9.116053833999928, 7.224676412000079],
            [-9.125407267999975, 7.190208232000103],
            [-9.113935098999946, 7.200388489000076],
            [-9.106085323999906, 7.202975005000027],
            [-9.100447550999888, 7.204832662000086],
            [-9.086391560999886, 7.207209778000035],
            [-9.073110717999953, 7.211343893000048],
            [-9.059261433999893, 7.221369120000077],
            [-9.046652384999959, 7.232737936000063],
            [-9.032854777999916, 7.240282695000104],
            [-9.015698200999879, 7.238887431000123],
            [-9.00763667799987, 7.243486633000089],
            [-8.98546748899986, 7.250049540000063],
            [-8.98102331499993, 7.250566305000106],
            [-8.977716023999932, 7.266224263000069],
            [-8.973116820999905, 7.267671203000063],
            [-8.96257482899992, 7.262968648000083],
            [-8.95720047999987, 7.286481425000062],
            [-8.944384724999878, 7.278678284000051],
            [-8.925419473999852, 7.248602600000069],
            [-8.912190307999936, 7.250152893000092],
            [-8.868885456999891, 7.266637675000069],
            [-8.85782670099988, 7.273045553000117],
            [-8.851367146999905, 7.292889302000106],
            [-8.855914672999859, 7.311854554000064],
            [-8.863304402999859, 7.32988962800006],
            [-8.86537145999992, 7.346891175000081],
            [-8.860617227999938, 7.357639873000011],
            [-8.851625528999875, 7.371489156000067],
            [-8.83340958699992, 7.393865051000134],
            [-8.824030313999884, 7.399807842000058],
            [-8.807700560999933, 7.404510397000124],
            [-8.799225625999952, 7.412210185000035],
            [-8.795453246999926, 7.421098531000041],
            [-8.793954630999906, 7.441510722000089],
            [-8.790388956999948, 7.45081248000011],
            [-8.784394490999915, 7.455721741000048],
            [-8.756489216999853, 7.472413228000079],
            [-8.73953934699992, 7.490551656000108],
            [-8.729617471999944, 7.508690084000136],
            [-8.725741739999876, 7.528533834000129],
            [-8.726826944999885, 7.551839905000065],
            [-8.72951411999992, 7.556387431000104],
            [-8.734009968999914, 7.557679342000057],
            [-8.738040730999927, 7.559488017000135],
            [-8.739177612999924, 7.565689189000125],
            [-8.737368937999946, 7.571425272000084],
            [-8.731477823999853, 7.581760559000088],
            [-8.73003088399986, 7.587444967000039],
            [-8.727576252999881, 7.622016500000129],
            [-8.720677449999897, 7.642738750000063],
            [-8.694477498999987, 7.674416402000077],
            [-8.686571003999944, 7.694363505000084],
            [-8.567405150999946, 7.68821401000011],
            [-8.572779500999928, 7.650748597000046],
            [-8.566526651999908, 7.623411763000107],
            [-8.547819782999852, 7.600777487000059],
            [-8.515625365999881, 7.577161357000051],
            [-8.485446329999888, 7.557989400000039],
            [-8.443640095999939, 7.537112122000067],
            [-8.425605021999928, 7.501920471000105],
            [-8.405141154999882, 7.431278788000014],
            [-8.393048868999898, 7.334333802000074],
            [-8.387674519999933, 7.314955139000105],
            [-8.381059936999918, 7.303017884000056],
            [-8.364006713999885, 7.278884989000105],
            [-8.357547159999854, 7.265707500000119],
            [-8.349692341999912, 7.234701640000097],
            [-8.344989786999918, 7.226795146000143],
            [-8.33300085499988, 7.211860657000088],
            [-8.328970092999981, 7.204005839000061],
            [-8.328453328999927, 7.19739125600006],
            [-8.330572061999902, 7.18473053000011],
            [-8.32974523999988, 7.178322652000077],
            [-8.32623124199992, 7.172069804000074],
            [-8.311503458999937, 7.15729034400006],
            [-8.305353962999959, 7.146903382000048],
            [-8.302615112999916, 7.137601624000112],
            [-8.30121984899992, 7.113210348000081],
            [-8.28411494999989, 7.017867330000087],
            [-8.286647094999893, 6.993786112000038],
            [-8.294140177999907, 6.984381002000077],
            [-8.314552367999852, 6.96856801300008],
            [-8.319978393999918, 6.95998972600006],
            [-8.321218627999883, 6.942264710000046],
            [-8.319978393999918, 6.925831604000081],
            [-8.320908569999887, 6.910173645000029],
            [-8.333672647999947, 6.882578430000123],
            [-8.328763386999924, 6.875085347000081],
            [-8.3205985109999, 6.869659322000103],
            [-8.315715087999877, 6.863819885000026],
            [-8.31496577999988, 6.850280660000053],
            [-8.316619425999932, 6.836276347000137],
            [-8.324991007999898, 6.806252340000086],
            [-8.337496703999904, 6.777261862000017],
            [-8.351759399999878, 6.755351054000059],
            [-8.441645673999943, 6.65531017500011],
            [-8.461313435999926, 6.633420512000029],
            [-8.53355708899997, 6.576343892000111],
            [-8.547147989999871, 6.560039978000091],
            [-8.549473429999892, 6.560143331000106],
            [-8.566113240999897, 6.5509190880001],
            [-8.567198445999907, 6.550609029000029],
            [-8.566113240999897, 6.549058737000095],
            [-8.570609090999938, 6.53513193800012],
            [-8.572727823999912, 6.530842794000051],
            [-8.577327025999864, 6.528026429000093],
            [-8.589367634999917, 6.526062724000056],
            [-8.594121866999927, 6.523892314000065],
            [-8.618719848999916, 6.492834778000116],
            [-8.601847492999923, 6.491749572000032],
            [-8.592106486999882, 6.489682516000073],
            [-8.56807694499986, 6.490405985000066],
            [-8.556501424999908, 6.487021179000052],
            [-8.545339314999865, 6.477202657000078],
            [-8.515625365999881, 6.437592672000022],
            [-8.497228556999886, 6.431365662000118],
            [-8.484774535999918, 6.441571757000091],
            [-8.47691971899988, 6.460149435000048],
            [-8.472372192999927, 6.478649597000071],
            [-8.46751460799993, 6.487072856000069],
            [-8.461210083999902, 6.482887065000028],
            [-8.449634561999858, 6.467926737000056],
            [-8.418266967999926, 6.451209412000111],
            [-8.405089477999866, 6.436326599000068],
            [-8.406484741999947, 6.430538839000093],
            [-8.413874470999929, 6.424182638000076],
            [-8.419042114999854, 6.407646179000082],
            [-8.417233439999961, 6.398189392000106],
            [-8.408241739999909, 6.379921774000053],
            [-8.405967976999904, 6.37224782400007],
            [-8.41098059099994, 6.363178610000091],
            [-8.420153157999948, 6.358088481000024],
            [-8.423692992999918, 6.351990662000063],
            [-8.411807413999895, 6.340027568000011],
            [-8.40105871599988, 6.35044036900004],
            [-8.38881140199993, 6.355091247000104],
            [-8.376564086999906, 6.354729513000095],
            [-8.365970417999932, 6.350078634000042],
            [-8.352947956999884, 6.361059876000112],
            [-8.342612670999898, 6.356951599000098],
            [-8.332949177999865, 6.345970357000027],
            [-8.32235550999988, 6.336461894000138],
            [-8.317497924999941, 6.336978659000081],
            [-8.314190632999953, 6.341526184000116],
            [-8.310004841999927, 6.344626770000062],
            [-8.30271846599993, 6.340647685000079],
            [-8.297705850999876, 6.33258616100008],
            [-8.296568969999953, 6.324395447000057],
            [-8.296568969999953, 6.317496643000084],
            [-8.295070352999858, 6.313362529000059],
            [-8.285975301999883, 6.310055237000071],
            [-8.208486490999945, 6.2925369270001],
            [-8.196575073999895, 6.288144430000017],
            [-8.185723022999866, 6.281839905000098],
            [-8.179056762999949, 6.276853130000049],
            [-8.170581827999854, 6.274010926000074],
            [-8.154355427999917, 6.274217631000027],
            [-8.14060949799989, 6.277576599000042],
            [-8.118285277999917, 6.289901428000093],
            [-8.106606403999962, 6.294681499000092],
            [-8.060097615999922, 6.301141053000052],
            [-8.033019164999871, 6.301761169000102],
            [-8.015707560999942, 6.297782084000033],
            [-7.999377807999934, 6.286697489000119],
            [-7.934885620999893, 6.271427104000068],
            [-7.929511270999853, 6.270755310000084],
            [-7.92522212699987, 6.272512309000064],
            [-7.920545409999903, 6.273804219000112],
            [-7.914370076999916, 6.271737163000054],
            [-7.912664753999877, 6.268429871000052],
            [-7.910029255999859, 6.256776835000082],
            [-7.906566934999915, 6.251996765000086],
            [-7.86212520299992, 6.216391703000113],
            [-7.846622273999913, 6.197478130000079],
            [-7.844141804999936, 6.1839647420001],
            [-7.857370971999927, 6.145388286000113],
            [-7.862021850999895, 6.124381815000021],
            [-7.864502318999882, 6.101695862000057],
            [-7.861815144999952, 6.081490377000065],
            [-7.850911416999878, 6.067563578000076],
            [-7.850498005999953, 6.072240296000047],
            [-7.840886189999964, 6.077356262000137],
            [-7.828380493999873, 6.080715231000056],
            [-7.819388793999906, 6.080095113000084],
            [-7.809673624999959, 6.071206767000064],
            [-7.805694538999887, 6.06203420000007],
            [-7.802438923999915, 6.039244893000088],
            [-7.799234985999931, 6.035679220000105],
            [-7.793860635999891, 6.034077250000081],
            [-7.788744668999897, 6.031493429000079],
            [-7.786470905999892, 6.025111390000049],
            [-7.788589640999959, 6.019788717000097],
            [-7.797736368999921, 6.014750265000117],
            [-7.799958454999853, 6.010151062000077],
            [-7.800681925999925, 5.98172902400006],
            [-7.799648396999942, 5.974468486000077],
            [-7.786625935999922, 5.958164572000058],
            [-7.747145140999891, 5.937597352000068],
            [-7.734949503999871, 5.925634258000116],
            [-7.717172810999955, 5.900752055000055],
            [-7.703220173999853, 5.907883403000085],
            [-7.691541299999898, 5.927727153000077],
            [-7.680482543999887, 5.940930481000066],
            [-7.674022989999912, 5.935737],
            [-7.663119262999942, 5.923102112000038],
            [-7.648339802999942, 5.911294047000112],
            [-7.630614786999928, 5.908606873000082],
            [-7.629116169999918, 5.904937846000095],
            [-7.608497273999916, 5.89369822200004],
            [-7.605758422999884, 5.893129781000084],
            [-7.584157673999897, 5.883698832000022],
            [-7.579093383999918, 5.877187602000049],
            [-7.587206583999944, 5.866774801000119],
            [-7.579506794999929, 5.860341085000073],
            [-7.566277627999852, 5.843727112000067],
            [-7.559146280999897, 5.83985137900001],
            [-7.547570759999871, 5.845432434000116],
            [-7.53519425399989, 5.855845235000061],
            [-7.527778686999881, 5.858842468000063],
            [-7.531085978999897, 5.842021790000089],
            [-7.515583048999872, 5.839231263000045],
            [-7.50881343599994, 5.826182963000093],
            [-7.503904174999889, 5.812101136000067],
            [-7.494395710999925, 5.80618418400006],
            [-7.486644246999901, 5.81380645800003],
            [-7.481683308999948, 5.830213725000092],
            [-7.478582722999931, 5.859875997000046],
            [-7.446543335999905, 5.845949198000071],
            [-7.442047484999904, 5.811274312000137],
            [-7.448558715999866, 5.769054668000066],
            [-7.44948889199992, 5.732364400000094],
            [-7.431040405999909, 5.653971253000094],
            [-7.417962620999901, 5.627756685000122],
            [-7.396675577999872, 5.585086568000079],
            [-7.384118204999936, 5.568963522000104],
            [-7.405098835999866, 5.57240000400013],
            [-7.411920125999899, 5.560359396000067],
            [-7.407114216999901, 5.541394145000112],
            [-7.393626668999929, 5.52397918700008],
            [-7.413470417999918, 5.522816468000073],
            [-7.419981648999908, 5.523126526000055],
            [-7.409851859999918, 5.513416970000037],
            [-7.408147745999884, 5.511783550000075],
            [-7.413470417999918, 5.503489482000106],
            [-7.425149291999901, 5.494161885000082],
            [-7.43238399299986, 5.479563294000116],
            [-7.43171219899989, 5.441917013000079],
            [-7.436208048999902, 5.431323344000106],
            [-7.450212361999917, 5.438713074000106],
            [-7.449953978999929, 5.422770895000085],
            [-7.446026570999976, 5.404916687000124],
            [-7.439101928999889, 5.387811788000079],
            [-7.429696818999929, 5.374298401000104],
            [-7.414865681999913, 5.365978495000149],
            [-7.404375366999943, 5.367993877000103],
            [-7.396933959999927, 5.366443583000077],
            [-7.391456257999948, 5.34768503800008],
            [-7.38882075999993, 5.328383891000044],
            [-7.389750935999899, 5.317144267000089],
            [-7.395590372999976, 5.306783142000072],
            [-7.407682657999942, 5.289859111000069],
            [-7.410111449999903, 5.283167013000053],
            [-7.413780476999904, 5.266708069000074],
            [-7.418793090999884, 5.260455221000086],
            [-7.428508259999916, 5.256140239000018],
            [-7.430833699999937, 5.259990133000059],
            [-7.430885375999964, 5.2675348920001],
            [-7.434089314999937, 5.274071960000086],
            [-7.435174519999919, 5.279291280000095],
            [-7.430110229999855, 5.284252217000045],
            [-7.428508259999916, 5.288153789000106],
            [-7.439928751999929, 5.290169169000052],
            [-7.442409219999888, 5.287378642000093],
            [-7.468247436999917, 5.273451844000107],
            [-7.475688842999944, 5.264227600000098],
            [-7.479926309999883, 5.255158387000051],
            [-7.490468302999943, 5.222188822000078],
            [-7.482251749999904, 5.17505991600008],
            [-7.483026895999927, 5.158239238000107],
            [-7.488918009999935, 5.140669251000133],
            [-7.515841430999927, 5.091809184000056],
            [-7.529923258999872, 5.097390238000074],
            [-7.54684728999996, 5.097700298000063],
            [-7.563228718999909, 5.090155538000104],
            [-7.57578609199993, 5.072068786000088],
            [-7.578163207999893, 5.054731344000089],
            [-7.570360066999854, 4.996879578000062],
            [-7.570205037999926, 4.996879578000062],
            [-7.571600300999904, 4.975382182000118],
            [-7.564623982999905, 4.961584575000074],
            [-7.555322224999884, 4.948432922000094],
            [-7.549586140999907, 4.929054261000132],
            [-7.54953446399989, 4.913887228000107],
            [-7.553461873999879, 4.914248963000105],
            [-7.561781778999915, 4.920165914000023],
            [-7.574959269999908, 4.921561178000104],
            [-7.605500039999896, 4.897428284000043],
            [-7.605965127999923, 4.88799733500008],
            [-7.598833780999882, 4.857094828000086],
            [-7.600229044999878, 4.845803528000118],
            [-7.605861775999898, 4.8251329550001],
            [-7.605996506999958, 4.81736342500011],
            [-7.606016804999854, 4.816192932000078],
            [-7.601004190999987, 4.804643250000126],
            [-7.59340775499993, 4.797434387000081],
            [-7.585552937999893, 4.791543274000077],
            [-7.57955847199986, 4.784282735000104],
            [-7.576871297999929, 4.775291036000056],
            [-7.572478800999932, 4.723356222000049],
            [-7.576871297999929, 4.509338277000097],
            [-7.575424356999918, 4.500346578000062],
            [-7.572737182999902, 4.491122335000057],
            [-7.570928506999905, 4.480709534000113],
            [-7.572840534999926, 4.455388082000042],
            [-7.565709187999886, 4.435208435000064],
            [-7.564313924999908, 4.425829163000103],
            [-7.567414509999963, 4.415933126000112],
            [-7.577853149999896, 4.397277934000059],
            [-7.579196736999961, 4.387149353000098],
            [-7.573770710999895, 4.375392965000103],
            [-7.540666124213715, 4.352844581897472],
            [-7.541005011999914, 4.352769273000092],
            [-7.593251105999911, 4.347235419000071],
            [-7.608225063999953, 4.349432684000078],
            [-7.631662563999953, 4.359279690000051],
            [-7.644439256999931, 4.361517645000049],
            [-7.712717251999948, 4.361517645000049],
            [-7.72101803299995, 4.36469147300005],
            [-7.725412563999953, 4.371771552000041],
            [-7.728627081999946, 4.378810940000051],
            [-7.733225063999953, 4.382025458000044],
            [-7.749501105999911, 4.383246161000045],
            [-7.788726365999935, 4.398911851000094],
            [-7.80101477799991, 4.406317450000074],
            [-7.812326626999948, 4.416083075000074],
            [-7.818267381999931, 4.42719147300005],
            [-7.823801235999952, 4.440741278000075],
            [-7.832875128999945, 4.452215887000079],
            [-7.862904425999943, 4.461371161000045],
            [-7.886830206999946, 4.480169989000046],
            [-7.898019985999952, 4.484442450000074],
            [-7.914540167999917, 4.486517645000049],
            [-7.924427863999938, 4.491685289000088],
            [-7.932199673999946, 4.49835846600007],
            [-7.942005988999938, 4.504868882000039],
            [-7.959868943999936, 4.51203034100007],
            [-8.003163214999915, 4.523504950000074],
            [-8.037505662999934, 4.52875397300005],
            [-8.100331183999913, 4.553290106000077],
            [-8.222035285999937, 4.568060614000046],
            [-8.257313605999911, 4.579982815000051],
            [-8.300200975999928, 4.62726471600007],
            [-8.316029425999943, 4.635199286000045],
            [-8.335357225999928, 4.638820705000057],
            [-8.438547329999949, 4.676174221000053],
            [-8.549956834999932, 4.754868882000039],
            [-8.607533331999946, 4.786932684000078],
            [-8.747059699999909, 4.837713934000078],
            [-8.778146938999953, 4.854315497000073],
            [-8.84829667899993, 4.913560289000088],
            [-8.874338344999956, 4.930121161000045],
            [-8.905100063999953, 4.944322007000039],
            [-8.915516730999911, 4.946275132000039],
            [-8.936105923999946, 4.95538971600007],
            [-8.966786261999914, 4.960109768000052],
            [-8.99132239499994, 4.96751536700009],
            [-9.014800584999932, 4.978461005000042],
            [-9.031971808999913, 4.991441148000092],
            [-9.028716600999928, 4.993638414000088],
            [-9.028065558999913, 4.994289455000057],
            [-9.027821417999917, 4.995428778000075],
            [-9.025786912999934, 4.998928127000056],
            [-9.069650844999956, 5.010972398000092],
            [-9.104969855999911, 5.03156159100007],
            [-9.162261522999927, 5.080877997000073],
            [-9.178089972999942, 5.091009833000044],
            [-9.21275794199994, 5.107407945000091],
            [-9.243967251999948, 5.130560614000046],
            [-9.26195227799991, 5.137274481000077],
            [-9.278716600999928, 5.145738023000092],
            [-9.291981574999909, 5.163478908000059],
            [-9.278960740999935, 5.163478908000059],
            [-9.292144334999932, 5.181626695000091],
            [-9.312245245999918, 5.192613023000092],
            [-9.334462042999917, 5.200995184000078],
            [-9.354074673999946, 5.211167710000041],
            [-9.470814581999946, 5.320461330000057],
            [-9.477935350999928, 5.335353908000059],
            [-9.48851477799991, 5.371649481000077],
            [-9.497466600999928, 5.38939036700009],
            [-9.50804602799991, 5.399603583000044],
            [-9.524281378999945, 5.41079336100006],
            [-9.541818813999953, 5.419826565000051],
            [-9.55650794199994, 5.423488674000055],
            [-9.559396938999953, 5.425034898000092],
            [-9.587635870999918, 5.430731512000079],
            [-9.59365800699993, 5.43032461100006],
            [-9.594960089999915, 5.440008856000077],
            [-9.583078579999949, 5.454901434000078],
            [-9.58071855399993, 5.464504299000055],
            [-9.596994594999956, 5.488348700000074],
            [-9.696766730999911, 5.546372789000088],
            [-9.84211178299995, 5.685451565000051],
            [-9.979644334999932, 5.798081773000092],
            [-10.015207485999952, 5.838120835000041],
            [-10.022613084999932, 5.844224351000094],
            [-10.039947068999936, 5.854315497000073],
            [-10.046213344999956, 5.861721096000053],
            [-10.04906165299991, 5.871771552000041],
            [-10.04478919199994, 5.884466864000046],
            [-10.046213344999956, 5.896429755000042],
            [-10.055531378999945, 5.911769924000055],
            [-10.071278449999909, 5.924790757000039],
            [-10.089100714999915, 5.933986721000053],
            [-10.104237433999913, 5.937445380000042],
            [-10.114979620999918, 5.943304755000042],
            [-10.185699022999927, 5.999090887000079],
            [-10.226551886999914, 6.04360586100006],
            [-10.279896613999938, 6.076971747000073],
            [-10.298166469999956, 6.084906317000048],
            [-10.336008266999954, 6.092230536000045],
            [-10.353667772999927, 6.102362372000073],
            [-10.364125128999945, 6.115668036000045],
            [-10.361480272999927, 6.12921784100007],
            [-10.352284308999913, 6.123521226000094],
            [-10.344471808999913, 6.122707424000055],
            [-10.33812415299991, 6.126776434000078],
            [-10.333566860999952, 6.136053778000075],
            [-10.353627081999946, 6.140611070000091],
            [-10.367990688999953, 6.15180084800005],
            [-10.380604620999918, 6.165350653000075],
            [-10.39561926999994, 6.176988023000092],
            [-10.428130662999934, 6.197007554000038],
            [-10.444691535999937, 6.20384349200009],
            [-10.463937954999949, 6.204982815000051],
            [-10.463937954999949, 6.197495835000041],
            [-10.412180141999954, 6.171047268000052],
            [-10.389393683999913, 6.152167059000078],
            [-10.38194739499994, 6.12921784100007],
            [-10.39712480399993, 6.147853908000059],
            [-10.424875454999949, 6.164618231000077],
            [-10.456695115999935, 6.177476304000038],
            [-10.659413214999915, 6.227484442000048],
            [-10.788319464999915, 6.292954820000091],
            [-10.807850714999915, 6.31085846600007],
            [-10.800363735999952, 6.327826239000046],
            [-10.79556230399993, 6.319647528000075],
            [-10.790353969999956, 6.31391022300005],
            [-10.78307044199994, 6.31000397300005],
            [-10.772368943999936, 6.30735911700009],
            [-10.789051886999914, 6.334947007000039],
            [-10.792347785999937, 6.359035549000055],
            [-10.78233801999994, 6.381415106000077],
            [-10.759388800999943, 6.404201565000051],
            [-10.77367102799991, 6.404201565000051],
            [-10.784087693999936, 6.401271877000056],
            [-10.792347785999937, 6.396226304000038],
            [-10.800363735999952, 6.389878648000092],
            [-10.824330206999946, 6.437730210000041],
            [-10.85732988199993, 6.472845770000049],
            [-10.895904100999928, 6.499009507000039],
            [-11.053618943999936, 6.584173895000049],
            [-11.23306230399993, 6.648098049000055],
            [-11.353179490999935, 6.701157945000091],
            [-11.37486731699994, 6.72687409100007],
            [-11.375721808999913, 6.766669012000079],
            [-11.369943813999953, 6.788885809000078],
            [-11.368641730999911, 6.798244533000059],
            [-11.36827551999994, 6.811346747000073],
            [-11.38194739499994, 6.836818752000056],
            [-11.385609503999945, 6.841782945000091],
            [-11.404408331999946, 6.847072658000059],
            [-11.424224412999934, 6.859320380000042],
            [-11.441070115999935, 6.873277085000041],
            [-11.450795050999943, 6.883368231000077],
            [-11.476185675999943, 6.919419664000088],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Central African Rep.',
        iso3: 'CAF',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.861064087000074, 10.919153747000081],
            [22.863234497000064, 10.891816915000064],
            [23.005551392000115, 10.686816508000064],
            [23.10942102100006, 10.614495342000112],
            [23.291218710000038, 10.43972564800012],
            [23.457616822000062, 10.173747050500097],
            [23.62401493400006, 9.907768453000088],
            [23.6447888590001, 9.863068339000051],
            [23.674037720000058, 9.690339864000109],
            [23.669076782000104, 9.652021790000092],
            [23.655537557000116, 9.622462870000064],
            [23.61853723100009, 9.566083883000147],
            [23.6061348880001, 9.53717091900009],
            [23.606755005000082, 9.52624135400012],
            [23.616470174000114, 9.501462504000088],
            [23.61853723100009, 9.488310852000026],
            [23.61719364400011, 9.457175802000066],
            [23.619984171000084, 9.44771901500009],
            [23.627528931000114, 9.435084127000053],
            [23.63497033700014, 9.43539418500005],
            [23.640861450000045, 9.43312042200003],
            [23.646339152000024, 9.425033061000121],
            [23.646855917000067, 9.418392640000121],
            [23.621844523000078, 9.340619609000086],
            [23.6205009360001, 9.322868755000073],
            [23.6307328690001, 9.292172953000119],
            [23.632179809000093, 9.277574361000063],
            [23.623291463000072, 9.265637106000028],
            [23.61006229600008, 9.255456848000051],
            [23.57140832500008, 9.20729441300007],
            [23.549497518000123, 9.185254415000074],
            [23.53792199700007, 9.178148906000047],
            [23.52179895000009, 9.175358379000087],
            [23.48944950300009, 9.176701966000053],
            [23.474256632000078, 9.170681661000117],
            [23.462821145000078, 9.153724977000081],
            [23.457720174000087, 9.146161194000058],
            [23.43570601400009, 9.01893381700009],
            [23.43828983600011, 8.994542542000062],
            [23.451415650000058, 8.974182027000026],
            [23.47808068900011, 8.958911641000071],
            [23.50546919700014, 8.961082052000066],
            [23.542572876000122, 8.997281393],
            [23.560142863000095, 8.996454570000083],
            [23.567480917000097, 8.974827982000093],
            [23.56593062300007, 8.940023905000132],
            [23.553631632000133, 8.883153991000086],
            [23.53668176200003, 8.85561045300011],
            [23.495443970000025, 8.80943756200007],
            [23.482318156000076, 8.783392639000084],
            [23.481801392000108, 8.759363099000055],
            [23.49006962100006, 8.732594706000086],
            [23.5052624920001, 8.710735576000047],
            [23.525726359000146, 8.701485495000043],
            [23.54050581800007, 8.704792786000041],
            [23.564070272000066, 8.7226986700001],
            [23.578022908000065, 8.730475973000111],
            [23.596419719000068, 8.734145],
            [23.61336958800007, 8.73223297200009],
            [23.629079224000037, 8.725592550000087],
            [23.644065389000104, 8.715153911000044],
            [23.657087850000067, 8.710012105000146],
            [23.68912723800014, 8.710683899000031],
            [23.721269979000084, 8.702002258000078],
            [23.737496379000106, 8.706859843000089],
            [23.768915650000054, 8.721251730000105],
            [23.803435506000113, 8.722130229000044],
            [23.866687459000104, 8.707790019000043],
            [23.922291300000097, 8.713448588000077],
            [23.96208215300004, 8.697015483000115],
            [23.981305786000036, 8.694173279000054],
            [24.009624471000052, 8.698875835000123],
            [24.114010864000107, 8.681641744000046],
            [24.170328031000054, 8.689327330000111],
            [24.180466756000072, 8.690710958000096],
            [24.21767378700008, 8.691511943000123],
            [24.23576053900007, 8.682003479000045],
            [24.233486776000063, 8.667766622000073],
            [24.21508996600008, 8.641359965000092],
            [24.211265910000122, 8.627071432000022],
            [24.218397258000067, 8.613041280000104],
            [24.245579061000058, 8.591802267000034],
            [24.250539998000107, 8.579632467000124],
            [24.243718710000053, 8.570175680000148],
            [24.20320438600004, 8.543458965000099],
            [24.193179159000096, 8.532426046000097],
            [24.137161906000102, 8.438865865000082],
            [24.125172973000133, 8.404888611000047],
            [24.121555623000063, 8.372306621000092],
            [24.13137414500011, 8.34305776000005],
            [24.152871541000053, 8.317891337000106],
            [24.179949992000104, 8.297711690000114],
            [24.20661503100007, 8.283268127000099],
            [24.222428019000063, 8.277196147000055],
            [24.25705122900007, 8.269186300000072],
            [24.263185621000048, 8.268505435000051],
            [24.281029094000075, 8.266524963000052],
            [24.295498495000118, 8.266524963000052],
            [24.302733195000087, 8.26543975900006],
            [24.310277954000128, 8.261564026000102],
            [24.326814412000118, 8.248567403000067],
            [24.332085409000058, 8.245725199000091],
            [24.39657759600007, 8.267816874000104],
            [24.431097453000064, 8.271408386000076],
            [24.454868612000013, 8.248670756000095],
            [24.458899373000094, 8.239756572000076],
            [24.46427372200006, 8.233193665000087],
            [24.471508422000028, 8.228930359000046],
            [24.48132694500009, 8.226656596000026],
            [24.512849569000082, 8.207148743000118],
            [24.54468225100001, 8.206115214000135],
            [24.61485884600009, 8.217148132000133],
            [24.67087609900011, 8.206838684000033],
            [24.690409790000103, 8.206631978000075],
            [24.710563599000096, 8.204306539000044],
            [24.742292928000097, 8.186839905000099],
            [24.80017053200004, 8.18027699800011],
            [24.832106568000114, 8.165730082000067],
            [24.917992798000057, 8.087026876000081],
            [24.927811320000103, 8.070955505000114],
            [24.93008508300005, 8.03545379600007],
            [24.950548950000098, 8.014395651000143],
            [24.952616007000046, 7.996567281000097],
            [24.95809370900014, 7.989177552000086],
            [24.964811646000072, 7.982614645000112],
            [24.97266646300011, 7.976981914000078],
            [24.981244751000133, 7.97233103500011],
            [25.029303833000085, 7.918845927000078],
            [25.05917281100011, 7.896108297000097],
            [25.089558553000074, 7.884894511000056],
            [25.103407837000134, 7.885773011000097],
            [25.134413696000138, 7.89254262300004],
            [25.148573039000098, 7.892594299000052],
            [25.17317102000007, 7.888563538000056],
            [25.18050907300008, 7.884016012000117],
            [25.18547001200011, 7.87791819300007],
            [25.19156783100007, 7.872388814000061],
            [25.216889283000057, 7.864068909000096],
            [25.229705037000144, 7.851614889000118],
            [25.23942020600009, 7.835956929000062],
            [25.24965214000005, 7.804330953000076],
            [25.264534953000094, 7.777717590000037],
            [25.26990930200006, 7.760767720000032],
            [25.270632772000056, 7.746143291000067],
            [25.266808716000128, 7.703096823000067],
            [25.270632772000056, 7.688162334000097],
            [25.276420532000117, 7.674261373000121],
            [25.279417765000062, 7.659481913000107],
            [25.274973592000038, 7.64196360300005],
            [25.25254602000004, 7.622429911000054],
            [25.186503540000103, 7.600105693000074],
            [25.165212850000017, 7.579900207000094],
            [25.164592732000045, 7.567342834000073],
            [25.169036906000144, 7.551168112000084],
            [25.190430949000074, 7.501197002000097],
            [25.249962199000038, 7.469984436000033],
            [25.263294718000083, 7.461044414000099],
            [25.269599243000073, 7.454223124000052],
            [25.27921105900009, 7.438358460000131],
            [25.285102173000098, 7.431588847000086],
            [25.29295699100004, 7.427196350000102],
            [25.309700155000087, 7.422028707000095],
            [25.316211385000145, 7.417222799000086],
            [25.3241695560001, 7.402908427000099],
            [25.330577433000144, 7.374124655000074],
            [25.33595178200011, 7.359603577000129],
            [25.346803833000052, 7.345030823000073],
            [25.360032999000055, 7.335574036000096],
            [25.41615360500009, 7.307772115000148],
            [25.45511763500008, 7.27821319600011],
            [25.48116255700006, 7.266172587000142],
            [25.50033451300007, 7.272787170000043],
            [25.516767619000035, 7.269944966000068],
            [25.531650431000088, 7.260694885000063],
            [25.57660892700011, 7.219818828000058],
            [25.59242191600009, 7.211240540000119],
            [25.654020223000117, 7.19537587500011],
            [25.672727091000098, 7.187831116000069],
            [25.6970150140001, 7.168607483000045],
            [25.7050765380001, 7.166385396000038],
            [25.724506876000078, 7.166695455000109],
            [25.73442875100008, 7.162406312000059],
            [25.750241739000074, 7.146541646000045],
            [25.761300497000093, 7.143751119000086],
            [25.78620853600006, 7.142665914000091],
            [25.7915828860001, 7.134397685000053],
            [25.79168623900003, 7.121116842000035],
            [25.800781290000117, 7.104942118000039],
            [25.81576745600009, 7.099774476000036],
            [25.86072595200008, 7.095537008000079],
            [25.877469116000043, 7.087733866000065],
            [25.881706583000096, 7.079827372000111],
            [25.884083699000143, 7.061068827000028],
            [25.88873457800011, 7.051870423000111],
            [25.920257202000073, 7.034145406000107],
            [25.930385783000105, 7.031509909000093],
            [25.950436238000066, 7.028564352000089],
            [25.9604614670001, 7.024481914000077],
            [25.966249227000077, 7.017453919000076],
            [25.966765991000102, 7.009857483000104],
            [25.969453165000033, 7.003552958000085],
            [25.9811320390001, 7.000297343000099],
            [26.026090535000037, 6.996679993000029],
            [26.0322917070001, 6.97409739200009],
            [26.03580570400007, 6.92226593],
            [26.045417521000076, 6.899683330000073],
            [26.050585165000086, 6.896686096000053],
            [26.056889689000087, 6.89740956600005],
            [26.06340091900006, 6.899063212000101],
            [26.06918868000014, 6.899063212000101],
            [26.07363285300005, 6.89513580300013],
            [26.07311608900011, 6.889709778000068],
            [26.07115238500006, 6.88356028200009],
            [26.071565796000073, 6.877462463000128],
            [26.07569991000011, 6.864646709000056],
            [26.077353557000066, 6.853329570000071],
            [26.08097090700005, 6.842348328000085],
            [26.091202840000108, 6.830333557000117],
            [26.113733765000035, 6.816458435000058],
            [26.13182051600006, 6.811730042000079],
            [26.147633504000055, 6.804702047000063],
            [26.17874271700009, 6.765918884000115],
            [26.21946374500007, 6.737522685000016],
            [26.236206909000117, 6.720030213000058],
            [26.270623413000067, 6.702486064000084],
            [26.329741252000133, 6.68057525600004],
            [26.37800703900004, 6.653290100000035],
            [26.37922433500006, 6.631361872000056],
            [26.37986739100006, 6.619777934000112],
            [26.372322631000088, 6.609804382000107],
            [26.356096232000084, 6.579496155000072],
            [26.324366903000083, 6.537198995000082],
            [26.305039917000016, 6.496917216000043],
            [26.296461629000078, 6.489527486000028],
            [26.28643640100006, 6.484178975000077],
            [26.27703129000011, 6.477357687000023],
            [26.270210002000056, 6.465652974000136],
            [26.289123575000104, 6.459425964000047],
            [26.290673869000102, 6.444672343000136],
            [26.28509281400011, 6.42588796000004],
            [26.282819051000075, 6.40785288500004],
            [26.28964034000012, 6.387208150000035],
            [26.300699097000034, 6.377828878000074],
            [26.31578861400004, 6.371576030000085],
            [26.335218954000112, 6.3605947880001],
            [26.351755411000113, 6.344368388000092],
            [26.375836629000048, 6.312587382000061],
            [26.39464685100006, 6.300546774000082],
            [26.436194702000137, 6.291710103000085],
            [26.452007690000045, 6.280289612000075],
            [26.45531498200006, 6.25445139600015],
            [26.455625040000115, 6.230473531000129],
            [26.46492679800005, 6.224401551000085],
            [26.479499552000107, 6.22507334400008],
            [26.495829305000143, 6.22114593500001],
            [26.50895511900012, 6.205462138000144],
            [26.50947188300006, 6.186393535000065],
            [26.50006677200011, 6.167970887000067],
            [26.48353031400012, 6.154457499000088],
            [26.46534020900006, 6.144303080000029],
            [26.445599813000115, 6.130221253000101],
            [26.429270061000068, 6.113090515000053],
            [26.421311890000112, 6.093660177000075],
            [26.424825887000054, 6.072447002000104],
            [26.440638875000076, 6.076994528000043],
            [26.481049846000133, 6.104951477000043],
            [26.49882653800006, 6.099835510000048],
            [26.50988529400007, 6.082678935000089],
            [26.518050171000084, 6.061155701000132],
            [26.527972045000098, 6.043172303000048],
            [26.543578328000137, 6.030847474000012],
            [26.602179403000065, 6.010616150000104],
            [26.634322144000095, 6.006482035000076],
            [26.705015503000084, 6.009789327000078],
            [26.776328979000084, 5.981884054000091],
            [26.794364054000084, 5.970489401000094],
            [26.805061076000072, 5.957182719000087],
            [26.810848836000048, 5.912379253000026],
            [26.81891036000013, 5.894628398000094],
            [26.842164754000066, 5.884267273000077],
            [26.86531579600006, 5.885972595000041],
            [26.88205896000011, 5.891941224000064],
            [26.894254598000117, 5.889667461000045],
            [26.90376306100009, 5.866981506000073],
            [26.916475464000143, 5.849644064000074],
            [26.937456095000044, 5.848507182000063],
            [26.981071004000086, 5.859204203000061],
            [26.991819702000015, 5.847706197000136],
            [27.003498576000084, 5.819284159000119],
            [27.021998738000036, 5.805098979000064],
            [27.029543497000077, 5.789880269000122],
            [27.036054728000124, 5.78512603700004],
            [27.04535648600006, 5.784919332000086],
            [27.06354659100012, 5.790862122000092],
            [27.072744995000107, 5.791223857000091],
            [27.114809611000055, 5.77528167800007],
            [27.12380131100008, 5.768744608000091],
            [27.130932657000102, 5.752130635000071],
            [27.13144942200006, 5.741459453000076],
            [27.136307007000084, 5.734018047000049],
            [27.156254109000088, 5.72748097700007],
            [27.170413452000048, 5.720349630000044],
            [27.182350708000087, 5.707456360000037],
            [27.19077396600008, 5.691824239000084],
            [27.193822876000098, 5.676321310000077],
            [27.194287964000125, 5.667303772000125],
            [27.1964066970001, 5.661464335000048],
            [27.201109253000084, 5.656968486000025],
            [27.21836918100007, 5.645315450000055],
            [27.21919600400011, 5.639992777000103],
            [27.216715536000038, 5.633455709000117],
            [27.215165242000097, 5.616144104000028],
            [27.210669393000074, 5.601623027000073],
            [27.211341186000055, 5.594879252000055],
            [27.217335653000106, 5.585396627000065],
            [27.222606649000113, 5.584363098000082],
            [27.227309204000107, 5.586714376000117],
            [27.231081584000037, 5.58759287500007],
            [27.234595581000093, 5.588833110000095],
            [27.240073283000072, 5.591985372000067],
            [27.2475146890001, 5.592605490000039],
            [27.257126505000116, 5.586068420000061],
            [27.261053914000087, 5.577593485000051],
            [27.258883505000085, 5.559971822000065],
            [27.26074385600009, 5.550256653000119],
            [27.220126180000136, 5.440883484000011],
            [27.218059123000103, 5.425509746000031],
            [27.220126180000136, 5.413081564000052],
            [27.228239380000048, 5.387605082000036],
            [27.23366540600003, 5.338279927000116],
            [27.237799520000067, 5.323190410000038],
            [27.26446455900009, 5.2601451620001],
            [27.280897664000065, 5.230560404000059],
            [27.301309855000113, 5.205187277000064],
            [27.35851566500014, 5.166765849000029],
            [27.38580082200008, 5.14384735100009],
            [27.402130574000097, 5.104495748000105],
            [27.43117272900008, 5.083618469000044],
            [27.441301310000142, 5.070725199000037],
            [27.414842977000063, 5.080724589000056],
            [27.40533451300007, 5.08284332300012],
            [27.391381876000082, 5.092222595000067],
            [27.38032312000007, 5.094393006000061],
            [27.36120284000009, 5.095478210000053],
            [27.351384318000015, 5.097338562000061],
            [27.34275435400008, 5.100594177000048],
            [27.32864668700003, 5.110800273000024],
            [27.315727580000043, 5.122401632000077],
            [27.30187829600007, 5.131987610000081],
            [27.28441166200011, 5.13596669500015],
            [27.262810913000067, 5.138447164000127],
            [27.239711548000088, 5.144880880000073],
            [27.157494344000042, 5.185421041000097],
            [27.116359904000063, 5.200303854000126],
            [27.073675171000076, 5.203326925000056],
            [27.02747644100012, 5.189968567000037],
            [26.991716349000086, 5.171287537000055],
            [26.961640666000108, 5.151185404000088],
            [26.933683715000114, 5.126587423000018],
            [26.903969767000063, 5.094393006000061],
            [26.899215535000053, 5.085995585000077],
            [26.889603719000064, 5.062121073000085],
            [26.884126017000142, 5.053387757000024],
            [26.87265384900013, 5.041786397000067],
            [26.867072795000126, 5.037548930000114],
            [26.849296102000096, 5.039099223000036],
            [26.848365926000042, 5.041372986000056],
            [26.844955281000125, 5.046282247000093],
            [26.839477580000022, 5.051165670000017],
            [26.832656291000063, 5.053387757000024],
            [26.8261450600001, 5.050752259000106],
            [26.815706421000073, 5.040184428000131],
            [26.80836836800009, 5.039099223000036],
            [26.8018571370001, 5.044525248000113],
            [26.760619344000105, 5.088114319000056],
            [26.753694702000104, 5.092274272000083],
            [26.73943200700006, 5.094393006000061],
            [26.691682983000078, 5.094393006000061],
            [26.68124434400005, 5.089277039000066],
            [26.667601766000132, 5.078347473000093],
            [26.657576538000114, 5.073257345000115],
            [26.644037313000126, 5.078347473000093],
            [26.635665731000046, 5.077624003000011],
            [26.629671265000127, 5.067056173000125],
            [26.623470093000037, 5.067056173000125],
            [26.61551192200008, 5.078244121000068],
            [26.59835534700011, 5.080621237000116],
            [26.57985518300009, 5.074342550000026],
            [26.568176310000098, 5.059640605000112],
            [26.561355021000054, 5.067056173000125],
            [26.55422367300011, 5.05984731000008],
            [26.541511271000076, 5.053129374000136],
            [26.528282105000073, 5.048090922000085],
            [26.519807170000064, 5.045972188000107],
            [26.502547241000087, 5.047470805000017],
            [26.475158732000125, 5.057263489000078],
            [26.46265303500013, 5.059640605000112],
            [26.46068933100011, 5.066022644000057],
            [26.441879110000087, 5.104289042000048],
            [26.429373413000093, 5.113797506000125],
            [26.414283895000096, 5.12271169000006],
            [26.400124552000136, 5.133641256000118],
            [26.390616089000076, 5.149014995000101],
            [26.36942875200012, 5.140565897000016],
            [26.3627108150001, 5.13596669500015],
            [26.35330570500014, 5.147774760000061],
            [26.33635583500012, 5.148601583000087],
            [26.317338908000067, 5.146431173000096],
            [26.291810751000128, 5.150978699000035],
            [26.27248376500006, 5.159066061000132],
            [26.253983602000062, 5.172321066000038],
            [26.24664554800006, 5.189968567000037],
            [26.242098022000107, 5.188056539000101],
            [26.23072920700011, 5.185162659000113],
            [26.2261816810001, 5.183147278000078],
            [26.225664917000046, 5.199037781000087],
            [26.2261816810001, 5.20425710100011],
            [26.21357263200008, 5.19914113400003],
            [26.207164754000132, 5.20769358400014],
            [26.198276408000112, 5.238389384000087],
            [26.195175822000067, 5.234772034000102],
            [26.184530477000067, 5.225341085000139],
            [26.181739949000104, 5.229578552000092],
            [26.17533207200009, 5.233686829000106],
            [26.170887898000075, 5.238389384000087],
            [26.157348673000087, 5.23247243200008],
            [26.150837443000114, 5.239965515000023],
            [26.14422285900011, 5.251799418000118],
            [26.12996016400004, 5.25887909000005],
            [26.125102579000043, 5.248595480000063],
            [26.11962487800014, 5.24154164600013],
            [26.11249353000011, 5.238389384000087],
            [26.104535359000124, 5.238596090000044],
            [26.098437540000077, 5.239577942000011],
            [26.0933732500001, 5.241438294000105],
            [26.08841231300005, 5.244590556000077],
            [26.091719605000065, 5.219062398000034],
            [26.09523360200012, 5.211052552000055],
            [26.086035197000115, 5.215238343000095],
            [26.077146851000094, 5.216323547000087],
            [26.07053226700009, 5.212241109000075],
            [26.067845093000074, 5.200846456000079],
            [26.06267745000008, 5.200122986000082],
            [26.050998576000097, 5.200226339000025],
            [26.037355998000095, 5.197952576000091],
            [26.02691735800005, 5.189968567000037],
            [26.013894897000114, 5.199244486000055],
            [25.996634969000127, 5.219243266000078],
            [25.985989624000126, 5.225341085000139],
            [25.97193363400001, 5.227666524000071],
            [25.962838583000035, 5.224514262000113],
            [25.95839440900005, 5.214824931000081],
            [25.95860111500008, 5.19738413500005],
            [25.943201538000096, 5.204102071000065],
            [25.925631551000038, 5.201776632000133],
            [25.91250573700006, 5.190381979000051],
            [25.910852092000113, 5.170098979000031],
            [25.892972046000068, 5.18521433500004],
            [25.88356693500009, 5.203533630000024],
            [25.872404826000064, 5.2170986940001],
            [25.849357137000112, 5.217873841000113],
            [25.846049845000096, 5.211672668000034],
            [25.83623132300005, 5.200019633000068],
            [25.826102742000074, 5.194696961000105],
            [25.818971394000044, 5.214566549000025],
            [25.814217163000052, 5.221620381000122],
            [25.811426636000107, 5.230922140000061],
            [25.81463057500008, 5.244590556000077],
            [25.810186401000067, 5.242678528000056],
            [25.799437703000137, 5.240094706000136],
            [25.79468347100004, 5.238389384000087],
            [25.792306355000107, 5.26283233700012],
            [25.77835371900011, 5.26913686100005],
            [25.769258667000145, 5.265157776000066],
            [25.781144246000082, 5.25887909000005],
            [25.771739135000104, 5.2454690550001],
            [25.757993205000076, 5.244435527000036],
            [25.743730509000102, 5.250610860000108],
            [25.732775106000133, 5.25887909000005],
            [25.7050765380001, 5.289600728000011],
            [25.69112390100011, 5.299806824000072],
            [25.668903035000085, 5.30613718700009],
            [25.667559448000105, 5.307248230000098],
            [25.66311527500011, 5.309160258000105],
            [25.655777222000097, 5.317764384000057],
            [25.65009281400006, 5.320296529000046],
            [25.637897176000138, 5.3179710900001],
            [25.631075887000094, 5.311821594000136],
            [25.62342777500004, 5.309935404000029],
            [25.609165079000036, 5.320296529000046],
            [25.609165079000036, 5.326523539000036],
            [25.614229370000118, 5.329934184000066],
            [25.61722660300012, 5.333551534000051],
            [25.61981042500014, 5.337220561000038],
            [25.62291101100007, 5.340760396000093],
            [25.600483439000072, 5.340450338000025],
            [25.59231856200006, 5.34918365500009],
            [25.58901127100006, 5.362283630000135],
            [25.581259806000077, 5.374918518000086],
            [25.575058634000072, 5.374918518000086],
            [25.56182946800007, 5.373006490000066],
            [25.543742716000082, 5.375280253000085],
            [25.532787313000085, 5.372231344000056],
            [25.540848836000094, 5.354428813000112],
            [25.528963257000044, 5.351896668000037],
            [25.504468628000097, 5.342284851000016],
            [25.495580281000088, 5.344532776000037],
            [25.484934936000087, 5.35530731200015],
            [25.481989379000083, 5.356857605000073],
            [25.47992232300004, 5.353188579000076],
            [25.435067180000146, 5.328693949000112],
            [25.413363078000145, 5.323552145000122],
            [25.395689738000044, 5.333964946000052],
            [25.385354451000126, 5.32148508700007],
            [25.370678345000044, 5.316834208000103],
            [25.36365035000003, 5.310555522000087],
            [25.376466105000105, 5.293011373000127],
            [25.355898885000045, 5.286448466000138],
            [25.34339318900004, 5.271927388000094],
            [25.33719201600013, 5.251747742000106],
            [25.335538371000098, 5.228441671000084],
            [25.32892378800011, 5.216013489000105],
            [25.316211385000145, 5.20224172000006],
            [25.30773645000005, 5.185291850000056],
            [25.31445438700007, 5.163251852000073],
            [25.321482381000067, 5.159169414000061],
            [25.341222779000134, 5.155603739000085],
            [25.348560832000118, 5.149014995000101],
            [25.349284301000125, 5.1416769410001],
            [25.34380660000005, 5.121884868000038],
            [25.342359660000056, 5.111472067000093],
            [25.339155721000083, 5.105167542000089],
            [25.324996378000037, 5.088114319000056],
            [25.321895793000095, 5.077003886000043],
            [25.320965617000127, 5.052250875000112],
            [25.316831503000117, 5.042251485000094],
            [25.30763309700012, 5.032277934000078],
            [25.292336873000067, 5.028273011000095],
            [25.248515259000044, 5.024138895000078],
            [25.239316854000066, 5.015534769000041],
            [25.227534627000068, 5.009566142000025],
            [25.163662556000105, 5.005638733000055],
            [25.154567505000045, 5.009307760000041],
            [25.147642863000044, 5.014139506000063],
            [25.140201457000018, 5.017963562000091],
            [25.12945275900009, 5.018635356000075],
            [25.121701294000104, 5.00863596700006],
            [25.114259888000078, 5.001840516000115],
            [25.10526818800014, 4.998765768000084],
            [25.100927368000043, 4.994554138000041],
            [25.0904887290001, 4.974477845000081],
            [25.084804321000064, 4.954220683000074],
            [25.0761226810001, 4.951843567000125],
            [25.04056929500007, 4.962101339000114],
            [25.006462850000077, 4.980937399000126],
            [24.969359171000093, 4.991401876000083],
            [24.95809370900014, 4.991350199000067],
            [24.950859009000084, 4.98768117300007],
            [24.932358846000056, 4.974426168000065],
            [24.927087850000106, 4.971480611000061],
            [24.904350219000037, 4.966803895000098],
            [24.86817671700001, 4.9443763230001],
            [24.84833296700012, 4.93672821100003],
            [24.836860799000107, 4.937710063000083],
            [24.8276623940001, 4.941921692000037],
            [24.819497518000077, 4.944479675000125],
            [24.811022583000096, 4.940448914000044],
            [24.80006717900011, 4.928899231000088],
            [24.78942183400011, 4.919855856000126],
            [24.778259725000083, 4.918538107000074],
            [24.766374145000043, 4.929881083000069],
            [24.749837687000053, 4.918744812000043],
            [24.73061405400003, 4.917504578000091],
            [24.66436486800012, 4.924403382000079],
            [24.65423628700009, 4.929415995000042],
            [24.657440226000062, 4.939777120000144],
            [24.67077274600007, 4.95721791600009],
            [24.656923462000123, 4.967268982000121],
            [24.6274678960001, 4.976906637000042],
            [24.615478963000044, 4.985097351000064],
            [24.610001261000065, 4.99672454900012],
            [24.61010461400008, 5.016723328000054],
            [24.601216268000087, 5.026102600000101],
            [24.588607219000068, 5.031063538000055],
            [24.563389120000096, 5.034887593000093],
            [24.553467244000103, 5.039099223000036],
            [24.547369425000056, 5.046488953000051],
            [24.538687785000093, 5.06555755600003],
            [24.533003377000057, 5.073257345000115],
            [24.513676391000104, 5.087235819000114],
            [24.4872180590001, 5.100800883000105],
            [24.480844127000125, 5.102334685000088],
            [24.45962284400011, 5.107441304000105],
            [24.436678508000085, 5.100594177000048],
            [24.4330611580001, 5.089328715000079],
            [24.43347456900011, 5.075531108000035],
            [24.430684042000053, 5.067417908000039],
            [24.416938110000103, 5.073257345000115],
            [24.411460409000114, 5.081861471000053],
            [24.401641887000068, 5.111472067000093],
            [24.396370890000128, 5.122298279000049],
            [24.382521607000058, 5.107854716000119],
            [24.367845500000072, 5.084548645000083],
            [24.361230916000068, 5.062947896000111],
            [24.371979614000082, 5.053387757000024],
            [24.396887655000057, 5.0481942750001],
            [24.398644653000133, 5.036024475000104],
            [24.386138957000128, 5.022356059000089],
            [24.36846561700014, 5.012434184000085],
            [24.29663537600004, 5.003261617000092],
            [24.286506795000065, 4.99507090300007],
            [24.284646444000145, 4.992435405000066],
            [24.272967570000077, 4.964013367000035],
            [24.26966027800009, 4.952463684000094],
            [24.269556925000074, 4.943187765000076],
            [24.267696573000052, 4.93572052100005],
            [24.259221639000145, 4.929881083000069],
            [24.253020467000084, 4.929881083000069],
            [24.246199178000012, 4.954065653000043],
            [24.229766073000064, 4.96117116300006],
            [24.20961226400007, 4.956184388000111],
            [24.19090539600009, 4.944169617000043],
            [24.16289677000009, 4.90778940900006],
            [24.15276818800004, 4.90259592700005],
            [24.13922896300005, 4.905438130000022],
            [24.119901978000087, 4.918899841000083],
            [24.108429809000086, 4.9230597950001],
            [24.089619588000062, 4.920217591000039],
            [24.072463013000117, 4.910269878000037],
            [24.046934855000075, 4.888927511000134],
            [23.995775187000078, 4.865052999000056],
            [23.977998494000133, 4.854149272000086],
            [23.963115682000108, 4.86869618700004],
            [23.957121216000075, 4.870814921000104],
            [23.950816691000057, 4.867791850000089],
            [23.946475871000075, 4.861642355000114],
            [23.943168579000087, 4.851694641000023],
            [23.942755168000076, 4.840506694000084],
            [23.94740604700013, 4.83058481900008],
            [23.948336223000098, 4.817691549000074],
            [23.924358358000063, 4.817794902000102],
            [23.881880330000115, 4.82688995400008],
            [23.874748983000103, 4.824977926000059],
            [23.86441369600007, 4.816089580000053],
            [23.855215291000093, 4.813221537000061],
            [23.84787723800008, 4.813996684000074],
            [23.828240194000045, 4.819345195000039],
            [23.816664672000115, 4.820611267000075],
            [23.798474568000074, 4.814745992000084],
            [23.76002730300013, 4.787434997000062],
            [23.737909790000117, 4.779063415000081],
            [23.692847941000082, 4.773404846000048],
            [23.67269413200009, 4.767203674000058],
            [23.634040161000087, 4.745137838000062],
            [23.5880481370001, 4.733949890000119],
            [23.566550741000043, 4.724441427000045],
            [23.50608931500011, 4.676434021000091],
            [23.488415975000123, 4.669845276000018],
            [23.46505822800009, 4.667209778000085],
            [23.448315063000024, 4.659406637000075],
            [23.437152954000084, 4.646565044000084],
            [23.43002160700007, 4.628840027000066],
            [23.428264607000074, 4.617342021000042],
            [23.428367960000116, 4.608608704000076],
            [23.427437785000052, 4.60134816500009],
            [23.42258020100013, 4.594061788000118],
            [23.414518677000046, 4.590832011000131],
            [23.396018514000104, 4.591607158000059],
            [23.388370402000135, 4.587266337000074],
            [23.371213826000087, 4.597265727000092],
            [23.3539538980001, 4.603570252000097],
            [23.335867147000073, 4.60680002800008],
            [23.316436809000095, 4.607730204000035],
            [23.313026164000064, 4.610210673000012],
            [23.301967408000053, 4.621708679000037],
            [23.29959029200012, 4.625119324000053],
            [23.295146118000105, 4.627599792000126],
            [23.273131958000135, 4.632018127000038],
            [23.26486372900007, 4.635067037000056],
            [23.251841268000135, 4.662972310000043],
            [23.22424605300006, 4.680051371000076],
            [23.220835408000113, 4.683513693000123],
            [23.208639770000104, 4.690541687000035],
            [23.183731731000137, 4.725268249000067],
            [23.16874556500008, 4.738109843000061],
            [23.123890422000073, 4.71563059500005],
            [23.099395793000042, 4.711651510000067],
            [23.07738163200014, 4.721056621000031],
            [23.06663293400004, 4.730177511000093],
            [23.055160767000103, 4.737799784000075],
            [23.042758423000123, 4.742967428000071],
            [23.029322550000074, 4.744931132000104],
            [23.017333619000112, 4.750512187000126],
            [23.011132446000147, 4.763638001000089],
            [23.007205037000062, 4.778443299000116],
            [22.996249634000094, 4.799501445000132],
            [22.98570764100012, 4.826424866000053],
            [22.97743941200008, 4.834305522000093],
            [22.965037069000118, 4.83528737400006],
            [22.953048136000064, 4.830791525000038],
            [22.941472616000112, 4.824719544000089],
            [22.929690389000115, 4.820611267000075],
            [22.915220988000073, 4.821153870000032],
            [22.905919230000052, 4.824202779000046],
            [22.898374471000096, 4.823582663000082],
            [22.88876265500008, 4.813221537000061],
            [22.8828715410001, 4.800741679000069],
            [22.882354777000046, 4.788494365000048],
            [22.88679895000007, 4.776686299000048],
            [22.895583944000037, 4.765394999000065],
            [22.887315715000085, 4.755498963000079],
            [22.865301554000013, 4.738678284000102],
            [22.853829386000086, 4.711263936000066],
            [22.837292928000096, 4.714235331000069],
            [22.818069295000072, 4.724596456000086],
            [22.802876424000146, 4.73064259900012],
            [22.786029907000085, 4.724648133000102],
            [22.776418091000068, 4.710101216000055],
            [22.765152628000095, 4.67602061000008],
            [22.7574011640001, 4.660801901000056],
            [22.748719523000148, 4.648270365000144],
            [22.73786747300008, 4.637754211000086],
            [22.723604777000105, 4.628840027000066],
            [22.723811483000077, 4.617031962000056],
            [22.72980594900011, 4.596748962000049],
            [22.73114953600006, 4.587266337000074],
            [22.728669067000084, 4.580290019000074],
            [22.718953898000052, 4.562771709000117],
            [22.716783488000146, 4.556518860000025],
            [22.71368290200013, 4.551222026000076],
            [22.70014367600004, 4.541067607000116],
            [22.697043091000097, 4.535744934000078],
            [22.697146444000026, 4.512025452000032],
            [22.69507938600006, 4.50148346000006],
            [22.68949833200014, 4.491664938000099],
            [22.675649048000082, 4.484740296000027],
            [22.654358357000092, 4.482828268000091],
            [22.61033003700004, 4.484223532000073],
            [22.59244999200007, 4.473707378000114],
            [22.58697229000009, 4.449393616000108],
            [22.589039347000067, 4.421953430000059],
            [22.59400028400009, 4.402316386000024],
            [22.611260213000094, 4.381852519000063],
            [22.61374068200007, 4.374359437000123],
            [22.609296509000075, 4.363352356000036],
            [22.599891398000096, 4.35255198100009],
            [22.588005818000084, 4.344180399000024],
            [22.576533651000148, 4.340847270000026],
            [22.568575480000106, 4.331545512000091],
            [22.539326619000065, 4.278163757000087],
            [22.539740030000075, 4.266924134000121],
            [22.545734497000097, 4.245943502000031],
            [22.546147909000098, 4.237184347000053],
            [22.540463501000147, 4.227262472000064],
            [22.52217004400009, 4.211346131000127],
            [22.518242635000036, 4.206798605000088],
            [22.51049117000011, 4.191269836000075],
            [22.492714477000078, 4.17403574700009],
            [22.457367798000092, 4.149076029000113],
            [22.451532021000048, 4.146672020000068],
            [22.431839640000135, 4.138559875000055],
            [22.42264123500013, 4.13478749600003],
            [22.3032686760001, 4.128715516000085],
            [22.207253866000116, 4.150316264000054],
            [22.184722941000103, 4.164604797000038],
            [22.161881958000095, 4.173183085000062],
            [22.151650025, 4.179461772000067],
            [22.133046509000053, 4.198659567000078],
            [22.12787886600006, 4.203077902000089],
            [22.108448527000064, 4.209847514000032],
            [22.05780562400011, 4.219536845000064],
            [22.036612824000144, 4.229438766000087],
            [22.00891971800013, 4.242377828000059],
            [22.001478312000103, 4.244651591000078],
            [21.98959273300008, 4.244238180000067],
            [21.984528442000112, 4.242946269000115],
            [21.98029097400007, 4.240620830000083],
            [21.970782512000085, 4.237184347000053],
            [21.949905232000106, 4.233463644000039],
            [21.89161421700007, 4.237184347000053],
            [21.867739705000076, 4.241551005000133],
            [21.851926717000083, 4.251679586000094],
            [21.8380774340001, 4.26325510600013],
            [21.819887329000068, 4.271936748000087],
            [21.810998983000047, 4.273176982000038],
            [21.782060181000105, 4.271936748000087],
            [21.771001424000076, 4.273487040000106],
            [21.766040487000055, 4.277207744000123],
            [21.763249959000092, 4.281677755000132],
            [21.7584957280001, 4.285605164000103],
            [21.737308390000123, 4.293382467000114],
            [21.722942342000124, 4.295139465000091],
            [21.68893925000009, 4.292452291000075],
            [21.65111210100011, 4.295656230000134],
            [21.63416223100012, 4.29420929000014],
            [21.538147420000115, 4.244651591000078],
            [21.5278121340001, 4.24925079300003],
            [21.508071737000137, 4.249405823000075],
            [21.497219686000108, 4.251472881000041],
            [21.489881633000095, 4.256252950000132],
            [21.482440227000097, 4.263125916000092],
            [21.47313846800006, 4.26930124900008],
            [21.460219360000053, 4.271936748000087],
            [21.416914510000083, 4.270076396000093],
            [21.39769087700006, 4.271626689000101],
            [21.374849894000135, 4.278163757000087],
            [21.35831343600006, 4.285553487000087],
            [21.310357707000037, 4.316094259000096],
            [21.305500122000097, 4.32314809200011],
            [21.298885538, 4.330227763000039],
            [21.28834354700004, 4.333380025000082],
            [21.275321086000105, 4.332527365000061],
            [21.26591597500007, 4.330072733000094],
            [21.258371216000114, 4.325990295000082],
            [21.25072310300004, 4.320357564000048],
            [21.24462528400008, 4.313768820000064],
            [21.23914758300009, 4.305603943000051],
            [21.23242964700006, 4.297826640000039],
            [21.22343794800011, 4.292452291000075],
            [21.210932251000116, 4.291573792000037],
            [21.202974080000047, 4.296638082000101],
            [21.195739380000077, 4.302916769000106],
            [21.18561079900013, 4.306069031000064],
            [21.165560344000085, 4.307154236000059],
            [21.15811893700007, 4.310203145000088],
            [21.150057414000088, 4.326713766000083],
            [21.137965129000094, 4.332682393000098],
            [21.113573853000076, 4.340847270000026],
            [21.103445271000112, 4.353275452000091],
            [21.084221639000077, 4.388234558000093],
            [21.076056763000082, 4.395469259000066],
            [21.05962365700009, 4.39859568300011],
            [20.9635054930001, 4.433735657000057],
            [20.87152144400008, 4.453372702000095],
            [20.832350708000064, 4.450685526000058],
            [20.81870813000006, 4.443528341000018],
            [20.807029256000078, 4.4342524220001],
            [20.79183638500004, 4.426190898000101],
            [20.767858520000118, 4.422780253000084],
            [20.688380168000037, 4.422780253000084],
            [20.60311405400006, 4.409731954000037],
            [20.58027307100005, 4.415002950000073],
            [20.55980920400009, 4.428361308000092],
            [20.456712867000107, 4.524815862000054],
            [20.452322225000103, 4.52892364500012],
            [20.442090291000113, 4.550498555000075],
            [20.447051229000067, 4.569670512000087],
            [20.45717980900011, 4.586439514000048],
            [20.463070923000117, 4.600934753000089],
            [20.456456340000017, 4.621501973000079],
            [20.44022993900012, 4.644110413000107],
            [20.420592895000084, 4.662352193000075],
            [20.403746378000108, 4.669845276000018],
            [20.39547814900004, 4.677105814000086],
            [20.373670695000044, 4.724441427000045],
            [20.354033651000094, 4.755395610000051],
            [20.33894413200008, 4.771906230000042],
            [20.322511027000132, 4.779063415000081],
            [20.30173710100007, 4.78164723800009],
            [20.254814901000117, 4.797124329000084],
            [20.236624796000086, 4.80634857200009],
            [20.217194458000108, 4.82244578100007],
            [20.171719198000062, 4.878359680000059],
            [20.152598918000052, 4.890684509000025],
            [20.086349732000144, 4.916264344000069],
            [20.054620402000126, 4.937813416000026],
            [20.03105594900012, 4.957993063000103],
            [20.00397749800007, 4.974477845000081],
            [19.91540409300012, 4.993107198000047],
            [19.89090946500005, 5.002124736000084],
            [19.880367472000103, 5.015534769000041],
            [19.875509888000067, 5.031063538000055],
            [19.858163068000096, 5.06030532000004],
            [19.85018843600008, 5.073748271000056],
            [19.838612915000056, 5.0875458780001],
            [19.824660278000067, 5.096976827000063],
            [19.779185018000106, 5.118164165000024],
            [19.748799276000057, 5.124417012000023],
            [19.728748820000106, 5.133847962000075],
            [19.7195504150001, 5.13596669500015],
            [19.605552205000038, 5.138292135000086],
            [19.568758586000115, 5.155190328000074],
            [19.548604777000065, 5.151366272000047],
            [19.517082154000093, 5.13596669500015],
            [19.49651493400009, 5.133796285000074],
            [19.431505982000118, 5.13596669500015],
            [19.408975057000106, 5.130385640000043],
            [19.394195597000106, 5.116975606000096],
            [19.373111613000077, 5.0875458780001],
            [19.283814738000103, 5.032277934000078],
            [19.236995890000088, 5.010780538000049],
            [19.229761189000016, 5.002176412000011],
            [19.214671672000122, 4.976131490000029],
            [19.195654744000137, 4.95034495000003],
            [19.179014933000133, 4.946417542000063],
            [19.133022908000044, 4.946934306000088],
            [19.116176391000067, 4.940448914000044],
            [19.106741180000085, 4.931518101000066],
            [19.083310181000115, 4.909339702000082],
            [19.069047485000056, 4.891252950000066],
            [19.0577820230001, 4.867791850000089],
            [19.048997030000095, 4.836527608000097],
            [19.04413944400008, 4.82688995400008],
            [19.035767863000103, 4.81800160700007],
            [19.026879516000093, 4.811516215000012],
            [19.019748169000138, 4.803299662000072],
            [19.011583292000125, 4.765033265000071],
            [18.998044067000052, 4.750641378000068],
            [18.980474081000096, 4.739401754000099],
            [18.96228397700014, 4.724441427000045],
            [18.928177531000074, 4.666434632000076],
            [18.923836711000092, 4.662868957000114],
            [18.90450972500014, 4.655866801000101],
            [18.900168904000054, 4.652146098000102],
            [18.89789514100005, 4.650647481000092],
            [18.88652632700007, 4.621398621000139],
            [18.85241988100009, 4.594061788000118],
            [18.82823531000011, 4.559981181000055],
            [18.77697229000009, 4.433451437000073],
            [18.75330448400007, 4.40061106400006],
            [18.7210583910001, 4.377356669000037],
            [18.6743428960001, 4.361311137000072],
            [18.65408573400009, 4.357228699000075],
            [18.633931925000127, 4.355962626000121],
            [18.61429488100009, 4.359812520000077],
            [18.595794719000054, 4.371258850000075],
            [18.5764677330001, 4.372757467000085],
            [18.556830688000076, 4.354153951000043],
            [18.54194787600005, 4.327850647000091],
            [18.537090291000112, 4.306069031000064],
            [18.545048462000068, 4.289015808000045],
            [18.572540323000055, 4.265683899000095],
            [18.578638142000102, 4.254857687000055],
            [18.583909139000127, 4.235789083000071],
            [18.619669230000056, 4.169565735000077],
            [18.632691691000076, 4.130420837000131],
            [18.64654097500005, 4.045981547000096],
            [18.645300741000113, 3.982445373000132],
            [18.641580038000114, 3.958260803000073],
            [18.6345520430001, 3.93572987900005],
            [18.61367476300012, 3.901468404000042],
            [18.61171106000009, 3.87909250900006],
            [18.612023983000142, 3.866611157000122],
            [18.612847941000098, 3.833746440000127],
            [18.59300419100009, 3.709774679000049],
            [18.626387166000086, 3.476868998000072],
            [18.582462199000133, 3.477385762000011],
            [18.57026656100004, 3.489607239000037],
            [18.5543502190001, 3.526375020000032],
            [18.513422485000092, 3.592236633000113],
            [18.497092733000045, 3.611460266000037],
            [18.472081339000056, 3.632053324000125],
            [18.45905887800012, 3.631381531000059],
            [18.44800012200011, 3.618023173000026],
            [18.42970666500014, 3.600220642000082],
            [18.420611613000062, 3.596370748000126],
            [18.40366174300007, 3.597352600000107],
            [18.392292928000074, 3.595853983000097],
            [18.38784875500008, 3.591668192000057],
            [18.38371464000005, 3.577999776000055],
            [18.379890585000112, 3.574382426000071],
            [18.372862590000096, 3.574537455000012],
            [18.36159712700004, 3.580170186000132],
            [18.35560266100009, 3.581462098000088],
            [18.27591760200005, 3.574382426000071],
            [18.26485884600004, 3.574744161000069],
            [18.25586714700009, 3.577224630000046],
            [18.248529094000105, 3.574899191000014],
            [18.242534627000083, 3.561127422000069],
            [18.235403280000128, 3.53092254700006],
            [18.231579224000114, 3.521155701000097],
            [18.220003703000145, 3.503947449000123],
            [18.2025370690001, 3.487333476000103],
            [18.181556437000012, 3.477385762000011],
            [18.15985233500001, 3.480305482000105],
            [18.14672652200005, 3.494904073000072],
            [18.134014120000103, 3.534824117000113],
            [18.11644413200011, 3.552006531000089],
            [18.082027629000066, 3.563452861000087],
            [18.04709436100009, 3.563142802000101],
            [18.01309126700005, 3.553970235000108],
            [17.981878703000064, 3.538803202000096],
            [17.969476359000083, 3.537511292000133],
            [17.959864542000076, 3.54107696600002],
            [17.924517863000062, 3.563452861000087],
            [17.91924686700014, 3.565597433000079],
            [17.913562459000104, 3.561334127000109],
            [17.875321899000113, 3.542730611000067],
            [17.856408325000075, 3.53730458600009],
            [17.84214563000009, 3.540146790000065],
            [17.835324341000046, 3.555830587000031],
            [17.830570109000064, 3.575674337000109],
            [17.821164998000086, 3.593993632000092],
            [17.808349243000094, 3.608592225000066],
            [17.793156372000084, 3.617506409000086],
            [17.78447473200012, 3.618229879000083],
            [17.765147746000082, 3.614354147000114],
            [17.755949341000075, 3.614509175000066],
            [17.749644816000057, 3.618074850000127],
            [17.73992964700011, 3.629159445000141],
            [17.73321171000009, 3.63220835400007],
            [17.72608036300005, 3.631846619000072],
            [17.71450484200011, 3.627505798000101],
            [17.709130493000146, 3.626420593000105],
            [17.627275024000113, 3.626317241000081],
            [17.586760702000106, 3.632234192000084],
            [17.550483846000134, 3.648150533000106],
            [17.51348352000008, 3.679182231000127],
            [17.50893599400007, 3.681766052000043],
            [17.49498335800007, 3.683212993000041],
            [17.490125773000045, 3.687140402000097],
            [17.486198364000074, 3.700292054000073],
            [17.481857544000093, 3.704762065000082],
            [17.45891320800007, 3.708276062000053],
            [17.442686808000047, 3.70127390600004],
            [17.427493937000122, 3.690111797000014],
            [17.414488944000112, 3.683414614000114],
            [17.375714152000057, 3.66344675700006],
            [17.355767049000036, 3.638435364000074],
            [17.334373007000124, 3.618514099000052],
            [17.298096150000077, 3.615904439000047],
            [17.272257934000066, 3.624560241000097],
            [17.259442179000075, 3.625903829000066],
            [17.24497277800012, 3.620606994000113],
            [17.231123494000087, 3.609108988000102],
            [17.222958618000064, 3.598515320000033],
            [17.213966919000114, 3.589291076000023],
            [17.197223755000067, 3.581720479000055],
            [17.182857707000068, 3.57960174600008],
            [17.142756795000054, 3.580841980000116],
            [17.129010864000122, 3.57706960100009],
            [17.102139119000128, 3.566605123000059],
            [17.0883931890001, 3.564434713000068],
            [17.061418091000064, 3.566140035000032],
            [17.052426392000115, 3.563969625000126],
            [17.035786580000092, 3.556140646000102],
            [17.02886193800012, 3.551541443000062],
            [17.01759647600005, 3.541800436000102],
            [17.009224894000084, 3.538131409000115],
            [17.003127075000123, 3.537717998000105],
            [16.989691203000064, 3.539474996000081],
            [16.98193973800008, 3.537976379000071],
            [16.968607218000045, 3.533480530000048],
            [16.960545695000064, 3.538441467000098],
            [16.953207641000063, 3.546890565000098],
            [16.942252238000094, 3.553091736000084],
            [16.932433716000105, 3.553918559000095],
            [16.9047351480001, 3.550637105000106],
            [16.895536743000093, 3.552368266000087],
            [16.877243286000123, 3.559163717000033],
            [16.867838176000078, 3.56154083300008],
            [16.853162068000074, 3.560093893000086],
            [16.851818481000123, 3.55190317800006],
            [16.854609009000086, 3.541335348000089],
            [16.852645304000134, 3.532808736000064],
            [16.8330082600001, 3.522861023000061],
            [16.81192427500008, 3.521672466000041],
            [16.729552043000098, 3.542213847000113],
            [16.709398234000105, 3.543712464000038],
            [16.686350545000067, 3.542213847000113],
            [16.639428344000095, 3.528597107000024],
            [16.598500610000087, 3.501673686000103],
            [16.567701457000112, 3.46438914000008],
            [16.551681762000072, 3.419766541000058],
            [16.542793416000052, 3.336154073000046],
            [16.517782023000052, 3.27323801700004],
            [16.517161906000098, 3.248691711000077],
            [16.511477498000147, 3.22724599200005],
            [16.4770609950001, 3.179393616000141],
            [16.465485474000047, 3.156500956000031],
            [16.464762003000146, 3.131799622000102],
            [16.472720174000102, 3.110612285000059],
            [16.48315881400015, 3.090148417000094],
            [16.49080692500013, 3.067824198000039],
            [16.484192342000114, 3.031909078000069],
            [16.445538370000122, 2.957650045000094],
            [16.448328898000085, 2.913466695000082],
            [16.460524536000094, 2.89460479800006],
            [16.474993937000136, 2.878378397000063],
            [16.483778930000113, 2.860394999000064],
            [16.479128051000146, 2.83631378100003],
            [16.45060266100009, 2.775593974000031],
            [16.42749236600011, 2.726492689000082],
            [16.41370568800008, 2.697200826000127],
            [16.371124308000105, 2.606922099000101],
            [16.32564904800006, 2.510493876000098],
            [16.293506307000115, 2.442074280000014],
            [16.24803104700007, 2.345594381000097],
            [16.1966646730001, 2.236453756000046],
            [16.19284061700006, 2.239502665000074],
            [16.17971480300011, 2.246995748000103],
            [16.181265096000118, 2.256555888000094],
            [16.18694950400007, 2.269319967000072],
            [16.18653609200007, 2.277691549000053],
            [16.182918742000084, 2.281153870000082],
            [16.16906945800011, 2.289887187000062],
            [16.165968872000064, 2.294796448000085],
            [16.164728638000042, 2.314795227000033],
            [16.16286828600002, 2.323838603000084],
            [16.15925093600012, 2.332933655000147],
            [16.152326294000147, 2.343268941000062],
            [16.13341272000011, 2.364818013000018],
            [16.120907023000115, 2.389571025000052],
            [16.112948853000148, 2.410448304000113],
            [16.11150191200008, 2.41856150300012],
            [16.11150191200008, 2.455871887000058],
            [16.10705773900014, 2.474165344000127],
            [16.094345337000107, 2.49752309200008],
            [16.090314575, 2.510493876000098],
            [16.091244751000147, 2.532766419000055],
            [16.1068510340001, 2.567027894000063],
            [16.11150191200008, 2.586199850000071],
            [16.108504679000134, 2.606612040000115],
            [16.093105102000067, 2.641493632000092],
            [16.090314575, 2.661905823000041],
            [16.093725220000124, 2.673119609000082],
            [16.101373332, 2.68784739200008],
            [16.110468384000086, 2.701438294000084],
            [16.0990995680001, 2.703970439000074],
            [16.086283814000097, 2.704952291000041],
            [16.072847941000077, 2.702833557000062],
            [16.062616008000077, 2.703195292000061],
            [16.05930871600009, 2.7118252570001],
            [16.060032186000086, 2.725829570000101],
            [16.05620813000013, 2.759832662000051],
            [16.059928833000043, 2.786187643000105],
            [16.08690393100008, 2.813162740000038],
            [16.095172160000118, 2.836778869000057],
            [16.09238163300006, 2.863288880000056],
            [16.082459757000066, 2.885664775000038],
            [16.07016076600013, 2.906593730000026],
            [16.05538130700012, 2.939769999000134],
            [16.034193969000057, 2.970620829000026],
            [16.02623579900009, 2.978992411000092],
            [16.015797160000147, 2.983488261000019],
            [16.00608199000004, 2.983953349000046],
            [15.99543664500004, 2.981472880000069],
            [15.982000773000067, 2.976718648000073],
            [15.977763306000043, 2.980956116000115],
            [15.974249309000072, 2.985762024000039],
            [15.971562133000134, 2.991188049000101],
            [15.958229614000118, 3.041520894000087],
            [15.950064738000094, 3.06100291000007],
            [15.93342492700009, 3.081776835000113],
            [15.913994588000094, 3.097951559000109],
            [15.8977681880001, 3.10353261400013],
            [15.854773397000116, 3.098985087000088],
            [15.850949340000085, 3.100432027000082],
            [15.840200642000042, 3.107408345000081],
            [15.834206176000123, 3.108545227000093],
            [15.829141886000059, 3.106633199000072],
            [15.817566366000108, 3.100121969000014],
            [15.813535603000105, 3.098985087000088],
            [15.8010299070001, 3.100897115000109],
            [15.793175089000073, 3.103274231000057],
            [15.785630330000117, 3.107976786000037],
            [15.710699503000058, 3.187455139000036],
            [15.616855102000073, 3.286777243000117],
            [15.517946411000082, 3.391602885000097],
            [15.413973429000038, 3.501880392000061],
            [15.32974084500006, 3.590996399000076],
            [15.2623059310001, 3.662589498000102],
            [15.252639608000095, 3.672851868000109],
            [15.171300904000105, 3.758970642000108],
            [15.08489790800013, 3.885836283000089],
            [15.02598677500012, 4.026086120000087],
            [15.043143351000083, 4.026137797000018],
            [15.075182739000098, 4.017972921000094],
            [15.091719198000078, 4.015854187000116],
            [15.111252889000099, 4.019936625000113],
            [15.150423624000041, 4.038514302000067],
            [15.172437785000113, 4.043811137000105],
            [15.192074829000148, 4.052234395000099],
            [15.189801066000115, 4.063112285000059],
            [15.177708781000149, 4.071458028000023],
            [15.162412557000096, 4.0739384970001],
            [15.148459920000107, 4.0739384970001],
            [15.142568807000089, 4.080449728000062],
            [15.1392615150001, 4.094583231000101],
            [15.132853638000142, 4.108535868000089],
            [15.117764119000071, 4.114323629000069],
            [15.10257124900005, 4.112411601000048],
            [15.091202433000149, 4.121790874000098],
            [15.084484497000119, 4.14861094200009],
            [15.082934204000082, 4.205506693000046],
            [15.072805623000136, 4.265942282000069],
            [15.063813924000101, 4.293434143000042],
            [15.048517700000048, 4.3216494750001],
            [15.013894490000041, 4.364256694000076],
            [15.007383260000069, 4.377770080000047],
            [15.00056197100011, 4.403194885000062],
            [14.993947388000038, 4.413297628000095],
            [14.982061808000083, 4.420480652000052],
            [14.938343546000112, 4.435931905000061],
            [14.7796968990001, 4.545046692000099],
            [14.743730102000114, 4.579979961000092],
            [14.717271769000149, 4.622018738000108],
            [14.7042493080001, 4.669354350000077],
            [14.697324667000117, 4.745215353000091],
            [14.690710083000113, 4.762139384000079],
            [14.69184696400012, 4.768702291000068],
            [14.696084432000077, 4.779735209000066],
            [14.700631958000116, 4.804281514000124],
            [14.701458781000042, 4.814384257000086],
            [14.686989380000114, 4.908874614000055],
            [14.681615031000149, 4.920941060000132],
            [14.675827271000088, 4.930759582000093],
            [14.67210656800006, 4.940810649000127],
            [14.674483683000119, 4.967579041000107],
            [14.669832804000066, 4.977113342000095],
            [14.663424927000108, 4.985717468000132],
            [14.659497518000137, 4.997034607000018],
            [14.660132450000106, 5.011439624000047],
            [14.660324341000063, 5.0157931520001],
            [14.667455689000093, 5.052767639000052],
            [14.663011515000107, 5.091447449000057],
            [14.66321822100005, 5.141831970000055],
            [14.658877401000069, 5.164543762000022],
            [14.651539348000085, 5.187513936000059],
            [14.640480590000067, 5.208236186000093],
            [14.62446089700012, 5.224049174000086],
            [14.603583618000044, 5.234255270000062],
            [14.560485473000142, 5.248595480000063],
            [14.5397115480001, 5.261798808000052],
            [14.523898560000106, 5.279678854000096],
            [14.519867797000103, 5.290582580000063],
            [14.528032674000116, 5.293011373000127],
            [14.539608195000085, 5.303579203000098],
            [14.548393188000148, 5.320503235000089],
            [14.553974243000084, 5.338228251000103],
            [14.555937947000103, 5.351328227000067],
            [14.560795532000043, 5.355462341000091],
            [14.57082076000006, 5.370939433000103],
            [14.57929569500007, 5.387605082000036],
            [14.579605754000056, 5.395382385000048],
            [14.592834920000115, 5.400033264000101],
            [14.597279094000044, 5.411479594000113],
            [14.59624556500006, 5.440108338000087],
            [14.599552857000049, 5.456644796000091],
            [14.614125611000105, 5.48486012800015],
            [14.617432902000104, 5.495298767000094],
            [14.618879842000098, 5.525451966000077],
            [14.617226196000075, 5.537880148000056],
            [14.61061161300006, 5.55366729800005],
            [14.596555623000143, 5.577231751000056],
            [14.591491333000079, 5.590951843000084],
            [14.590147746000099, 5.60828928700009],
            [14.592834920000115, 5.623869731000113],
            [14.61061161300006, 5.66913828600012],
            [14.624357544000105, 5.72360524500003],
            [14.631075480000021, 5.738048808000144],
            [14.62404748500012, 5.758305970000052],
            [14.617432902000104, 5.864966125000123],
            [14.60296350100009, 5.883388774000124],
            [14.598002563000136, 5.903490906000101],
            [14.58477339600006, 5.923412170000105],
            [14.572474406000111, 5.924187317000118],
            [14.54539595600005, 5.907573344000099],
            [14.530616495000118, 5.905919698000062],
            [14.499197225000103, 5.909537049000051],
            [14.48214400200007, 5.909640401000075],
            [14.465710897000093, 5.920673319000073],
            [14.458166137000148, 5.936408793000041],
            [14.45382531800007, 5.953875428000089],
            [14.44690067500008, 5.970024313000081],
            [14.432327922000127, 5.985449727000073],
            [14.417548462000099, 5.99725779200007],
            [14.406076294000087, 6.011029561000029],
            [14.39770471200012, 6.019168600000029],
            [14.389436482000065, 6.031054179000066],
            [14.387266072000074, 6.039038188000035],
            [14.390263306000094, 6.045781963000067],
            [14.39770471200012, 6.053946838000073],
            [14.402458944000102, 6.054877014000041],
            [14.412897583000131, 6.047022197000089],
            [14.418168579000081, 6.047125550000118],
            [14.422509400000138, 6.051363017000071],
            [14.426023397000108, 6.05986379000008],
            [14.429123982000135, 6.064178772000062],
            [14.433568156000149, 6.073868103000095],
            [14.43270924500004, 6.079122618000085],
            [14.431811157000084, 6.084616801000024],
            [14.430570922000129, 6.088079122000053],
            [14.443903442000078, 6.100248922000063],
            [14.467054484000073, 6.122598979000131],
            [14.48214400200007, 6.127068991000044],
            [14.510979451000082, 6.15533599900003],
            [14.525965617000054, 6.174068706000114],
            [14.534957316000117, 6.190088399000075],
            [14.576401814000064, 6.189778341000078],
            [14.719028768000015, 6.257862041000081],
            [14.734841756000037, 6.270445251000098],
            [14.772255493000074, 6.318323466000024],
            [14.78238407400005, 6.336771952000035],
            [14.784657837000054, 6.347804871000022],
            [14.784347778000068, 6.358682760000079],
            [14.780006958000087, 6.382221374000068],
            [14.782177368000077, 6.393616028000068],
            [14.807292114000091, 6.427799988000061],
            [14.92187418000006, 6.686413886000054],
            [14.932452434000112, 6.710289205000024],
            [14.946095011000125, 6.725740459000107],
            [14.962321411000119, 6.73669586200009],
            [15.022369425000136, 6.766539002000087],
            [15.03456506300006, 6.776770935000073],
            [15.042213176000132, 6.790775248000074],
            [15.059059693000108, 6.836276347000137],
            [15.080247029000077, 6.878082581000101],
            [15.113216594000022, 6.964692282000044],
            [15.128926229000086, 7.026497294000123],
            [15.136160930000074, 7.045307516000136],
            [15.147012980000113, 7.061843974000041],
            [15.156108032000077, 7.067786764000047],
            [15.1790523680001, 7.078380432000117],
            [15.18752730300011, 7.088612365000102],
            [15.19021447700004, 7.098792623000065],
            [15.185356893000119, 7.156876933000149],
            [15.186597127000056, 7.166333720000111],
            [15.191248006000109, 7.177340801000113],
            [15.205097290000083, 7.200233460000035],
            [15.223907511000107, 7.247517395000074],
            [15.246563660000078, 7.26673131200009],
            [15.261321248000058, 7.279246725000093],
            [15.338215779000052, 7.322189840000064],
            [15.385344686000053, 7.358363342000089],
            [15.389168741000105, 7.364151103000069],
            [15.397436971000047, 7.380739237000071],
            [15.403224731000108, 7.386371968000105],
            [15.409632609000056, 7.387663880000062],
            [15.42844283000008, 7.38880076100007],
            [15.432783651000136, 7.38973093700011],
            [15.434954060000052, 7.402908427000099],
            [15.415523722000074, 7.420840150000075],
            [15.41945113100013, 7.436549785000039],
            [15.473297973000058, 7.509103496000051],
            [15.48104943900006, 7.523262838000093],
            [15.515569295000148, 7.512204081000093],
            [15.551949503000117, 7.509878642000061],
            [15.624813273000115, 7.519748841000052],
            [15.668531535000113, 7.516286519000104],
            [15.720001262000096, 7.468640849000067],
            [15.758345174000112, 7.455566711000102],
            [15.79389855900007, 7.457995504000067],
            [15.925260050000077, 7.488174541000063],
            [15.943140096000036, 7.495305888000104],
            [15.975696248000077, 7.515201315000112],
            [15.990372355000147, 7.529412333000067],
            [16.012283162000102, 7.560314840000075],
            [16.02633915200002, 7.574887594000117],
            [16.042978964000042, 7.583930970000083],
            [16.06519982900008, 7.591217346000064],
            [16.12876184100014, 7.599485575000102],
            [16.162661580000076, 7.611112773000073],
            [16.1856059160001, 7.610751037000071],
            [16.207206665000058, 7.613541565000034],
            [16.227257120000104, 7.625582174000101],
            [16.26188033000011, 7.651885478000054],
            [16.2827576090001, 7.660102031000079],
            [16.37081424900012, 7.672504374000056],
            [16.383009888000032, 7.680669251000069],
            [16.38714400200007, 7.69467356400007],
            [16.387040649000113, 7.762628072000041],
            [16.392208292000134, 7.783608703000127],
            [16.407401164000078, 7.796062724000123],
            [16.418149862000092, 7.795856018000066],
            [16.427244913000067, 7.791463522000072],
            [16.437373495000116, 7.788362935000038],
            [16.450912720000076, 7.792083638000051],
            [16.457217244000105, 7.799628398000095],
            [16.469412882000114, 7.825828349000105],
            [16.47571740700002, 7.83580190100011],
            [16.49173710100007, 7.84923777300007],
            [16.509203735000114, 7.858281149000035],
            [16.54868453000006, 7.870011699000116],
            [16.550131469000036, 7.861691793000148],
            [16.550751587, 7.852700094000113],
            [16.55023482200008, 7.843501689000021],
            [16.544860474000103, 7.813012594000028],
            [16.54930464600011, 7.794719137000058],
            [16.56015669700008, 7.77973297200009],
            [16.576383097000075, 7.767795715000133],
            [16.586821737, 7.763558248000095],
            [16.59643355300011, 7.761129456000035],
            [16.605218547000106, 7.757202047000064],
            [16.61307336400006, 7.748210347000025],
            [16.618137655000112, 7.734309387000053],
            [16.616173950000075, 7.72387074800011],
            [16.611833129000104, 7.713897197000094],
            [16.609869426000074, 7.701598206000057],
            [16.614210245000066, 7.679584046000073],
            [16.62454553200007, 7.668680318000014],
            [16.663199504000147, 7.657414856000059],
            [16.686867310000082, 7.645787659000092],
            [16.70981164600005, 7.627752584000092],
            [16.74670861800007, 7.586566467000097],
            [16.76861942500011, 7.55023793600013],
            [16.78236535700006, 7.541142883000063],
            [16.805516398000123, 7.543675029000056],
            [16.812854451000135, 7.547705790000052],
            [16.815071257000056, 7.549543532000129],
            [16.836728963000013, 7.567497864000117],
            [16.839622843000086, 7.567446188000105],
            [16.85037154100013, 7.565895894000079],
            [16.85388553900009, 7.567497864000117],
            [16.855849243000108, 7.575404358000071],
            [16.852438599000095, 7.580261943000082],
            [16.848097778000096, 7.584706116000092],
            [16.84716760300006, 7.591579081000063],
            [16.854815715000115, 7.611474508000072],
            [16.865461060000115, 7.62444529200009],
            [16.88065393000005, 7.632868551000087],
            [16.919617961000142, 7.644082337000029],
            [16.96271610500014, 7.650696920000115],
            [16.98193973800008, 7.648733215000092],
            [16.988967733000067, 7.66077382400006],
            [16.9975460200001, 7.66671661400008],
            [17.008294718000116, 7.667646790000035],
            [17.038990519000066, 7.662479147000028],
            [17.04209110500011, 7.667026673000066],
            [17.041057576000128, 7.675501608000062],
            [17.04560510200008, 7.684700012000064],
            [17.059351033000098, 7.696533916000078],
            [17.07909143100008, 7.689919332000088],
            [17.090253540000106, 7.683821513000026],
            [17.095524536000113, 7.678240458000104],
            [17.10193241400006, 7.677723694000065],
            [17.11629846200009, 7.686870422000055],
            [17.135522095000084, 7.705112203000112],
            [17.1705587160001, 7.747538554000045],
            [17.18864546700013, 7.764126689000051],
            [17.19639693200014, 7.765160218000034],
            [17.20456180800005, 7.763816630000065],
            [17.211073038000023, 7.768312480000077],
            [17.21448368300014, 7.786812643000104],
            [17.22068485500003, 7.798181457000098],
            [17.233790206000094, 7.810801425000136],
            [17.234637492000047, 7.811617330000047],
            [17.25086389100005, 7.822831116000089],
            [17.385739380000075, 7.870476787000129],
            [17.405996541000093, 7.883034160000051],
            [17.41912235500007, 7.898227030000086],
            [17.466354614000096, 7.884119364000057],
            [17.478343547000037, 7.891819153000128],
            [17.487231893000057, 7.914453430000094],
            [17.50366499800012, 7.926235657000092],
            [17.52381880700011, 7.930989889000088],
            [17.55978560300008, 7.934710592000087],
            [17.580766235000084, 7.940601706000095],
            [17.599989868000108, 7.950368551000054],
            [17.620660441000012, 7.978738912000054],
            [17.639884074000122, 7.985043437000073],
            [17.661794881000077, 7.986283671000109],
            [17.67977828000008, 7.985198466000014],
            [17.817237589000115, 7.962099101000135],
            [17.858785441000123, 7.960445455000084],
            [17.89785282400004, 7.967473450000099],
            [17.977227824000096, 7.997187398000065],
            [18.07045210800004, 8.019201558000049],
            [18.50825484200007, 8.030673727000064],
            [18.589283488000092, 8.047881979000053],
            [18.617912231000076, 8.090127462000027],
            [18.618635702000063, 8.138651632000105],
            [18.638582804000094, 8.177641500000092],
            [18.672585896000044, 8.207510478000117],
            [18.715063924000077, 8.228671977000062],
            [18.773768351000115, 8.248619080000083],
            [18.791234986000063, 8.257378235000061],
            [18.81304244000009, 8.276421001000045],
            [18.854900350000065, 8.33980214400006],
            [18.887456503000095, 8.370963033000123],
            [18.90130578600008, 8.38863637300004],
            [18.910400839000147, 8.412975973000044],
            [18.920529419000104, 8.43212209000005],
            [19.02047163900005, 8.545577698000073],
            [19.061296021000146, 8.625624492000028],
            [19.072261297000125, 8.631872473000072],
            [19.081656535000064, 8.637225851000068],
            [19.09147505700014, 8.652857972000021],
            [19.12413456200011, 8.675078837000058],
            [19.10387740100012, 8.698049011000094],
            [19.07349165900007, 8.720528259000105],
            [19.0577820230001, 8.729700826000098],
            [19.04868697100011, 8.745668844000136],
            [18.929107707000128, 8.796544292000064],
            [18.917325480000045, 8.805148418000101],
            [18.912467895000106, 8.818403422000102],
            [18.909677368000132, 8.835327454],
            [18.902959432000017, 8.84481007900007],
            [18.88652632700007, 8.835844218000133],
            [18.869783162000118, 8.849409282000124],
            [18.869679810000093, 8.864111227000109],
            [18.892727498000056, 8.897933452000103],
            [18.901409139000094, 8.893980205000034],
            [18.9106075440001, 8.8942385860001],
            [18.917738892000045, 8.898811951000141],
            [18.920736124000143, 8.907855327000107],
            [18.92290653500004, 8.91821645100012],
            [18.928590943000074, 8.921678772000064],
            [18.93644576000011, 8.923358256000114],
            [18.952052042000076, 8.931988220000065],
            [18.971895793000044, 8.938215230000054],
            [18.97592655400004, 8.941987610000083],
            [18.978510376000145, 8.949454855000099],
            [18.98481490000006, 8.956431173000098],
            [18.999491007000046, 8.969634501000087],
            [19.021918579000044, 8.985214946000028],
            [19.06067590300009, 9.004180196000078],
            [19.100570109000103, 9.015264791000092],
            [19.126718384000128, 9.007177429000095],
            [19.1336430260001, 9.007177429000095],
            [19.14211796100011, 9.00867604600009],
            [19.168783000000133, 9.002216492000045],
            [19.17457076000011, 9.003766784000064],
            [19.179635051000105, 9.015264791000092],
            [19.192037394000067, 9.020174052000115],
            [19.23286177600005, 9.022292786],
            [19.25342899600014, 9.02795135600013],
            [19.2632475180001, 9.028261414000028],
            [19.27523645000008, 9.021982727000108],
            [19.285778442000037, 9.012810160000114],
            [19.295493612000087, 9.009502869000116],
            [19.304795370000107, 9.020845845000096],
            [19.316267537000016, 9.0131202190001],
            [19.33332076000005, 9.006557312000027],
            [19.352234334000087, 9.002061463000103],
            [19.36939091000005, 9.00038197800005],
            [19.382620076000137, 9.003198345000015],
            [19.420963989000057, 9.017435202000073],
            [19.430162394000064, 9.012861837000045],
            [19.50664351400013, 9.013998718000053],
            [19.511811157000068, 9.012293396000075],
            [19.515841919000138, 9.0094511920001],
            [19.521319621000117, 9.008831075000046],
            [19.53082808400012, 9.013998718000053],
            [19.553772420000143, 9.013326925000058],
            [19.583124633000125, 9.025341696000027],
            [19.61361372900012, 9.031672059000044],
            [19.640072062000087, 9.013998718000053],
            [19.65640181400005, 9.021259257000025],
            [19.70001672300009, 9.02058746400013],
            [19.70900842300003, 9.024566548000024],
            [19.71396936000008, 9.029139913000066],
            [19.738153931000056, 9.03937184700004],
            [19.746835571000105, 9.04130971300006],
            [19.758411092000046, 9.041981506000056],
            [19.784662720000085, 9.048751120000091],
            [19.805539998000143, 9.051128235000121],
            [19.889462525000056, 9.046374004000128],
            [19.902174927000118, 9.05180002900002],
            [19.914473917000066, 9.069266663000064],
            [19.928736613000126, 9.062574565000133],
            [19.932091369000148, 9.063330566000076],
            [19.943412719000037, 9.065881856000132],
            [19.969044231000083, 9.082883403000068],
            [19.97648563700011, 9.084175313000102],
            [19.98547733500004, 9.08319346100005],
            [19.99302209400011, 9.084588725000032],
            [19.9963293860001, 9.09283111600007],
            [19.99715620900011, 9.098618876000046],
            [19.999533325000073, 9.104303284000082],
            [20.002943970000103, 9.108514913000121],
            [20.006871379000074, 9.110220236000089],
            [20.014416137000097, 9.106344503000045],
            [20.017930135000057, 9.091048279000077],
            [20.0243380120001, 9.089756368000039],
            [20.030332478000048, 9.09386464400005],
            [20.029919067000037, 9.098980611000044],
            [20.028368775000104, 9.104561666000052],
            [20.031159302000077, 9.110220236000089],
            [20.060511515000144, 9.134353129000132],
            [20.068676391000054, 9.138125509000076],
            [20.07694462100011, 9.136730245000095],
            [20.09058719900011, 9.131123352000074],
            [20.099372193000107, 9.130709941000063],
            [20.100509074000115, 9.13414642300009],
            [20.09957889800006, 9.141174418000091],
            [20.101025838000055, 9.148073222000079],
            [20.10960412600008, 9.15117380800011],
            [20.11714888500012, 9.145747782000043],
            [20.12572717200007, 9.133784688000091],
            [20.13761275200008, 9.12182159400004],
            [20.1545626220001, 9.116421407000075],
            [20.16954878800007, 9.120891418000085],
            [20.197970825000084, 9.14050262500011],
            [20.21264693200007, 9.14497263600012],
            [20.222982218000084, 9.141949565000104],
            [20.234454387000085, 9.134559835000104],
            [20.256985311000108, 9.116421407000075],
            [20.276829061000115, 9.120736390000047],
            [20.35940799900004, 9.116421407000075],
            [20.378321574000097, 9.120064596000063],
            [20.384419393000144, 9.123578593000019],
            [20.402919555000068, 9.136988627000065],
            [20.41242801900006, 9.142052918000047],
            [20.42307336400006, 9.143241476000057],
            [20.435165649000027, 9.138125509000076],
            [20.455422811000034, 9.15931284600012],
            [20.467618449000042, 9.18414337200008],
            [20.481777792000088, 9.204658915000053],
            [20.5072025960001, 9.21326304100009],
            [20.512990357000092, 9.223882548000077],
            [20.50265507000006, 9.24742116300007],
            [20.496143840000087, 9.270882264000136],
            [20.514230591000114, 9.281501771000123],
            [20.526426229000037, 9.283620504000098],
            [20.53366093000008, 9.289640809000048],
            [20.537278280000066, 9.299200948000134],
            [20.53820845600012, 9.3119391890001],
            [20.541825806000105, 9.321628520000033],
            [20.550920858000097, 9.320259095000054],
            [20.572314901000084, 9.308218485000083],
            [20.57355513500005, 9.309148661000037],
            [20.592262003000116, 9.308063457000046],
            [20.592882121000088, 9.308218485000083],
            [20.609728638000064, 9.302792460000106],
            [20.616653280000037, 9.302017314000096],
            [20.667916300000087, 9.302017314000096],
            [20.654893839000124, 9.34297088700012],
            [20.695821574000064, 9.363460592000095],
            [20.7408834230001, 9.37712900800011],
            [20.750495240000106, 9.384544576000025],
            [20.757936646000132, 9.37712900800011],
            [20.766618286000096, 9.386559957000074],
            [20.77106246000011, 9.398057963000099],
            [20.7765401610001, 9.407798970000044],
            [20.788322388000097, 9.41188140900006],
            [20.792353149000093, 9.41400014200012],
            [20.798244262000082, 9.42337941500007],
            [20.8019649660001, 9.425549825000061],
            [20.806719197000092, 9.423327739000058],
            [20.813230428000054, 9.419116109000115],
            [20.81388430900006, 9.418846864000045],
            [20.82025842200008, 9.416222229000127],
            [20.82614953600006, 9.418082580000132],
            [20.83266076700005, 9.437254537000044],
            [20.834314412000083, 9.4624726360001],
            [20.841445760000113, 9.484409282000058],
            [20.863769979000097, 9.493788554000105],
            [20.874208618000125, 9.502496033000071],
            [20.91265588400006, 9.544328105000133],
            [20.921234171000094, 9.558978373000116],
            [20.925058227000136, 9.569597880000103],
            [20.934256632000142, 9.577065125000033],
            [20.955960734000143, 9.589415792000082],
            [20.96050826000007, 9.598123271000063],
            [20.96226525900005, 9.606934103000057],
            [20.9676396080001, 9.61060312900014],
            [20.98314253800004, 9.603678488000071],
            [20.98179895000007, 9.616778463000031],
            [20.980145304000104, 9.619930726000078],
            [20.975804484000037, 9.624168193000031],
            [20.975804484000037, 9.630963643000072],
            [20.989963826000064, 9.63561452200014],
            [20.996061645000026, 9.648301087000092],
            [20.996888468000066, 9.682174988000085],
            [21.000092408000114, 9.697393697000038],
            [21.014251749000067, 9.724472148000089],
            [21.017352336000016, 9.743592428000085],
            [21.019936157000103, 9.747933248000066],
            [21.025620565000054, 9.7532559200001],
            [21.032338501000083, 9.758010152000097],
            [21.03781620300009, 9.760671489000117],
            [21.039056437000113, 9.762170105000038],
            [21.040089966000096, 9.764753927000129],
            [21.042673787000098, 9.767079366000061],
            [21.04835819500005, 9.768164571000057],
            [21.052905721000087, 9.765890809000041],
            [21.062207479000108, 9.756201477000104],
            [21.065824829000093, 9.75449615500014],
            [21.073162882000076, 9.757648417000098],
            [21.080294230000106, 9.762609355000052],
            [21.093109986000087, 9.774339905000133],
            [21.09703739400007, 9.775373434000116],
            [21.101584920000107, 9.774236552000104],
            [21.10520227100008, 9.774029847000051],
            [21.1067525630001, 9.778060608000132],
            [21.10592574000009, 9.791884054000093],
            [21.1067525630001, 9.795449728000065],
            [21.121738728000082, 9.831907451000077],
            [21.13197066200007, 9.849425761000134],
            [21.187264445000096, 9.885134176000037],
            [21.19542932200011, 9.887304586000127],
            [21.198426554000037, 9.902988383000093],
            [21.20566125500008, 9.916837667000053],
            [21.25692427600012, 9.975748800000062],
            [21.271290323000102, 9.987246806000087],
            [21.285139608000065, 9.978591004000037],
            [21.3260673420001, 9.962752177000127],
            [21.339503214000047, 9.959909973000052],
            [21.37433313000011, 9.97311330100004],
            [21.406889282000066, 10.005566101000056],
            [21.43334761600005, 10.046054586000068],
            [21.48543745900011, 10.164316101000097],
            [21.513239380000044, 10.20051544200004],
            [21.544968709000074, 10.219997457000119],
            [21.55447717200005, 10.218653870000054],
            [21.566672810000085, 10.214493917000127],
            [21.579281860000094, 10.212271831000123],
            [21.589720500000027, 10.216612650000101],
            [21.593441203000054, 10.214545594000043],
            [21.625273885000098, 10.224493307000046],
            [21.630648234000148, 10.22743886400005],
            [21.65627974500012, 10.233665873000035],
            [21.668888794000054, 10.24919464100006],
            [21.67695031700012, 10.26916758200008],
            [21.68893925000009, 10.288907980000133],
            [21.6974141850001, 10.292421977000103],
            [21.708886352, 10.293533020000012],
            [21.718808228000114, 10.296633606000043],
            [21.723045695000053, 10.30598704100008],
            [21.722115519000113, 10.314177755000102],
            [21.71777469900013, 10.328983053000044],
            [21.716844523000077, 10.33980926500007],
            [21.720461873000147, 10.360815735000088],
            [21.751054321000083, 10.41182037300004],
            [21.743612915000142, 10.418977559000083],
            [21.74278609300012, 10.425773010000043],
            [21.744439738000068, 10.432439270000131],
            [21.744233032000125, 10.439105530000063],
            [21.738031861000138, 10.448019714000083],
            [21.720461873000147, 10.468018494000106],
            [21.716844523000077, 10.477320252000126],
            [21.714674113000086, 10.49370168100009],
            [21.70547570800008, 10.532019755000093],
            [21.70330529800009, 10.552406108000042],
            [21.70547570800008, 10.571810608000106],
            [21.714674113000086, 10.601395365000144],
            [21.716844523000077, 10.621006572000084],
            [21.722632284000042, 10.636716207000049],
            [21.736481567000112, 10.646172994000025],
            [21.753431437000103, 10.65072052000005],
            [21.768417603000074, 10.651986593000089],
            [21.77420536300005, 10.655164694000064],
            [21.77875288900009, 10.66227020300009],
            [21.784850708000135, 10.669324036000106],
            [21.795392700000036, 10.672476299000067],
            [21.80355757700005, 10.673664856000087],
            [21.8225745040001, 10.678754985000069],
            [21.832909790000116, 10.679943543000093],
            [21.852753540000094, 10.670150859000032],
            [21.863605591000066, 10.667928772000039],
            [21.86835982300005, 10.676222839000076],
            [21.872080526000047, 10.677592265000058],
            [21.8950248620001, 10.699193013000112],
            [21.925617309000103, 10.720121969000019],
            [21.943083944000136, 10.728261007000114],
            [22.003855428000065, 10.743273010000095],
            [22.01460412600008, 10.754564310000063],
            [22.00488895700005, 10.775519104000068],
            [22.011400187000106, 10.789290873000098],
            [22.01832482900008, 10.80988393200009],
            [22.02948693800002, 10.828745829000113],
            [22.048607218000114, 10.836988220000066],
            [22.1324263920001, 10.828539124000073],
            [22.148239380000092, 10.830761210000077],
            [22.17635135900011, 10.816214295000108],
            [22.189787231000082, 10.837298279000052],
            [22.20063928200011, 10.868665873000069],
            [22.229371378000025, 10.891971944000105],
            [22.240120076000068, 10.90589874300008],
            [22.253039185000148, 10.915303854000044],
            [22.26843876100014, 10.90899932900004],
            [22.276500285000054, 10.908534241000012],
            [22.28724898300007, 10.915949809000026],
            [22.305955852000125, 10.932563782000031],
            [22.31877160600004, 10.939359233000076],
            [22.33944217900003, 10.947730815000057],
            [22.361146281000032, 10.95364776600006],
            [22.364690321000097, 10.954208607000098],
            [22.391842082000068, 10.958505351000085],
            [22.40703495200009, 10.963052877000024],
            [22.419230590000012, 10.970726827000092],
            [22.437627401000015, 10.991552429000066],
            [22.447135865000092, 10.998270366000085],
            [22.46046838400011, 11.000828349000074],
            [22.476281372000102, 10.997960307000099],
            [22.49075077300006, 10.99315439900009],
            [22.502843058000053, 10.992172547000038],
            [22.511938110000102, 11.000828349000074],
            [22.534675740000097, 10.980519511000068],
            [22.555759725000115, 10.978969218000131],
            [22.577050415000087, 10.985118714000109],
            [22.600821574000065, 10.987805888000139],
            [22.609089803000103, 10.985222066000048],
            [22.628210083000084, 10.97612701400007],
            [22.63833866300004, 10.974137472000038],
            [22.673168579000105, 10.975067648000078],
            [22.682677043000098, 10.974137472000038],
            [22.719884074000106, 10.964654846000144],
            [22.74510217300005, 10.943803406000086],
            [22.805977010000106, 10.924502258000047],
            [22.861064087000074, 10.919153747000081],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Sudan',
        iso3: 'SDN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [22.861064087000074, 10.919153747000081],
              [22.9002348220001, 11.059894511000039],
              [22.90653934800011, 11.069893901000043],
              [22.922352336000102, 11.087076315000019],
              [22.925142863000076, 11.097954204000075],
              [22.9256596270001, 11.11813385000005],
              [22.928966919000118, 11.13792592400003],
              [22.935168090000104, 11.1558834840001],
              [22.95201460700008, 11.19104929600006],
              [22.956458781000094, 11.20880015100009],
              [22.954535630000123, 11.237843295000076],
              [22.953668254000036, 11.250942281000036],
              [22.928346802000135, 11.325149638000099],
              [22.914807576000072, 11.396101379000072],
              [22.900441529000148, 11.408245341000082],
              [22.87698042800008, 11.408839621000126],
              [22.781792440000117, 11.398891907000035],
              [22.771870565000114, 11.403181051000104],
              [22.771560506000043, 11.433308411000084],
              [22.76876997800008, 11.442325948000132],
              [22.743035115000083, 11.466097107000095],
              [22.66252323400002, 11.493072204000029],
              [22.62810673000007, 11.509841207000079],
              [22.59234663900014, 11.543663432000073],
              [22.561754191000148, 11.586012268000076],
              [22.541703735000084, 11.632986145000046],
              [22.537052856000116, 11.680890198000057],
              [22.59286340300008, 11.988933411000062],
              [22.610536743000097, 12.039627991000117],
              [22.613533977000117, 12.057249655000106],
              [22.61239709500009, 12.072804261000044],
              [22.607332804000123, 12.077713522000082],
              [22.598857869000113, 12.063244121000139],
              [22.585525350000097, 12.07135732100005],
              [22.546457967000094, 12.064432678000074],
              [22.481449015000123, 12.044278870000085],
              [22.47049361200004, 12.036113994000075],
              [22.464499145000104, 12.032961731000114],
              [22.45809126800009, 12.030429586000125],
              [22.483826131000058, 12.140345357000086],
              [22.48475630700011, 12.152540996000099],
              [22.484032837000115, 12.164736634000121],
              [22.481449015000123, 12.176673889000071],
              [22.407965128000058, 12.399761048000073],
              [22.374892212000077, 12.450869039000068],
              [22.3728251550001, 12.463116353000089],
              [22.395872843000063, 12.496085917000059],
              [22.44568892400011, 12.611065979000088],
              [22.432459757000117, 12.623830058000067],
              [22.330140422000113, 12.661450501000076],
              [22.204876750000068, 12.743357646000035],
              [22.176248006000094, 12.70149973500007],
              [22.144105265000064, 12.67126902300005],
              [22.105864706000062, 12.650391744000075],
              [22.05873580000008, 12.63669749000006],
              [22.01966841600006, 12.631426493000035],
              [21.9771903890001, 12.631839905000035],
              [21.935952596000106, 12.639539693000117],
              [21.900812622000075, 12.656437887000024],
              [21.880142049000142, 12.676281636000112],
              [21.84086796100007, 12.748938701000057],
              [21.81368615700009, 12.782295838000024],
              [21.809448690000124, 12.793664653000107],
              [21.811825806000087, 12.799969177000023],
              [21.827845500000137, 12.831104228000072],
              [21.852960246000066, 12.90572499600006],
              [21.935125773000095, 13.059152323000134],
              [21.964064575000037, 13.098348898000083],
              [21.998377726000058, 13.130594991000052],
              [22.016051066000074, 13.140232646000072],
              [22.123434692000046, 13.182168071000063],
              [22.139971151000054, 13.193511048000047],
              [22.232265258000012, 13.28903493300001],
              [22.26761193900012, 13.33456186900007],
              [22.275983521000086, 13.376316427000106],
              [22.26399458800003, 13.399183248000028],
              [22.22864790800014, 13.441118672000115],
              [22.215625448000083, 13.464993184000022],
              [22.211181274000097, 13.484190979000033],
              [22.210561157000114, 13.54173268600006],
              [22.19588505000013, 13.580464173000081],
              [22.132116333000113, 13.63865183500009],
              [22.114339641000072, 13.677383321000022],
              [22.114339641000072, 13.699707540000077],
              [22.1163033440001, 13.715184632000089],
              [22.11289270000009, 13.729834900000071],
              [22.097079712000095, 13.749756165000079],
              [22.07372196400013, 13.771356913000147],
              [22.074962199000083, 13.780322775000087],
              [22.0993534750001, 13.819415996000103],
              [22.180762493000145, 13.920554946000053],
              [22.190614054000093, 13.932794088000023],
              [22.214695272000142, 13.956616923000084],
              [22.24353072100007, 13.975427145000097],
              [22.402280721000096, 14.049298604000072],
              [22.421607706000145, 14.062140198000066],
              [22.45871138500013, 14.096117452000087],
              [22.481449015000123, 14.108545634000066],
              [22.508217407000103, 14.113635763000048],
              [22.531471802000112, 14.122627462000096],
              [22.54635461400005, 14.139706523000129],
              [22.547698201000117, 14.169032898000097],
              [22.540876912000073, 14.201175639000041],
              [22.531885213000123, 14.220631816000022],
              [22.514108520000093, 14.231458028000063],
              [22.457677856000146, 14.241147359000095],
              [22.44103804600013, 14.249854838000061],
              [22.429049113000076, 14.264608460000076],
              [22.419954061000112, 14.286235046000044],
              [22.417060181000124, 14.298094787000068],
              [22.418093710000107, 14.305949606000098],
              [22.426982056000043, 14.323002828000128],
              [22.43132287600011, 14.327214458000086],
              [22.44486210100007, 14.333363952000056],
              [22.449926392000066, 14.338376567000111],
              [22.45095992000003, 14.34579213400012],
              [22.447342570000046, 14.351631572000116],
              [22.44238163300011, 14.356928406000051],
              [22.439074341, 14.362922872000084],
              [22.424914998000077, 14.470435690000087],
              [22.417163534000053, 14.484104106000103],
              [22.38636438000009, 14.506531678000101],
              [22.36352339600009, 14.543532003000053],
              [22.382333618000104, 14.579111226000123],
              [22.422744588000086, 14.609083557000062],
              [22.465429321000073, 14.629289043000057],
              [22.666347290000147, 14.681740622000106],
              [22.676579224000136, 14.688975322000076],
              [22.681436808000058, 14.70292795800006],
              [22.679679809000078, 14.711816305000085],
              [22.66459029100008, 14.743752340000057],
              [22.65900923600006, 14.761270650000114],
              [22.650844361000054, 14.816151022000028],
              [22.650844361000054, 14.841937561000037],
              [22.658905883000045, 14.857414653000134],
              [22.69549279800009, 14.881470032000081],
              [22.715336548000067, 14.899427592000052],
              [22.721020956000103, 14.915938212000043],
              [22.721951132000072, 14.934670919000041],
              [22.72722212700009, 14.959036357000059],
              [22.738901001000073, 14.979810283000091],
              [22.82902469900006, 15.071639302000051],
              [22.848765096000108, 15.08750396700006],
              [22.871606079000117, 15.099699605000069],
              [22.90550581900004, 15.112567037000062],
              [22.913257283000064, 15.121687928000142],
              [22.958009074000103, 15.201631368000065],
              [22.965657186000072, 15.223903910000018],
              [22.978369588000135, 15.340201722000117],
              [22.976405884000116, 15.373636373000096],
              [22.966484008000094, 15.404823100000073],
              [22.944986613000083, 15.433115947000076],
              [22.923592570000068, 15.455569356000055],
              [22.906849406000106, 15.481407572000094],
              [22.899511353, 15.510191346000013],
              [22.90674605300009, 15.541403911000074],
              [22.9256596270001, 15.563934835000012],
              [23.004517863000046, 15.611425476000093],
              [23.06849328600012, 15.686692199000063],
              [23.094641561000117, 15.704262187000026],
              [23.119249041000103, 15.707223545000105],
              [23.16678186000013, 15.712943827000103],
              [23.320570923000105, 15.681317851000088],
              [23.395811808000076, 15.688345846000018],
              [23.52706994600004, 15.735164694000034],
              [23.59269901600007, 15.749013977000104],
              [23.707524048000067, 15.748858948000063],
              [23.829067017000085, 15.731030579],
              [23.945545695000135, 15.692221579000076],
              [23.972624146000072, 15.69108469700005],
              [23.98440637200008, 15.721160381000018],
              [23.98440637200008, 15.721939934000048],
              [23.98440637200008, 15.779658102000027],
              [23.984303019000066, 16.011943665000032],
              [23.98399296000008, 16.244229228000037],
              [23.983786255000012, 16.47651479100007],
              [23.983682902000083, 16.708800355000065],
              [23.98347619600014, 16.94113759400001],
              [23.983269491000073, 17.173371481000103],
              [23.98306278400011, 17.405657044000023],
              [23.982856079000072, 17.637942607000028],
              [23.98275272600003, 17.870228170000033],
              [23.982442668000147, 18.102513733000066],
              [23.98223596200009, 18.33479929700006],
              [23.982132609000075, 18.567033183000078],
              [23.981925903000104, 18.799292908000083],
              [23.981719197000047, 19.03155263300009],
              [23.981512492000093, 19.263838196000094],
              [23.981305786000036, 19.496123759000014],
              [23.981305786000036, 19.621025696000046],
              [23.981305786000036, 19.745824280000065],
              [23.981305786000036, 19.870597025000066],
              [23.981305786000036, 19.995421448000073],
              [24.14243290200011, 19.995421448000073],
              [24.22790572100004, 19.99531809500006],
              [24.340870402000036, 19.99529225700003],
              [24.47460900900009, 19.995188904000102],
              [24.59914921000012, 19.99505971300006],
              [24.72131229700011, 19.99503387500006],
              [24.867246542000146, 19.994956360000046],
              [24.968015584000057, 19.994956360000046],
              [24.970185994000133, 19.995188904000102],
              [24.972356405000113, 19.995421448000073],
              [24.974526815000104, 19.99565399200013],
              [24.976800578000024, 19.995964050000012],
              [24.97773075300009, 19.997462667000022],
              [24.97866092900003, 19.99901296000006],
              [24.979591105000083, 20.00051157600005],
              [24.98052128100005, 20.002061870000077],
              [24.98052128100005, 20.00839082700007],
              [24.98052128100005, 20.120013326000034],
              [24.980624634000065, 20.21509796200006],
              [24.980624634000065, 20.310234273],
              [24.98072798700008, 20.40531890900006],
              [24.980831340000123, 20.500351868000067],
              [24.980831340000123, 20.624943746000028],
              [24.980831340000123, 20.749535624000075],
              [24.980934692000062, 20.874127503000025],
              [24.980934692000062, 20.998719381000072],
              [24.980934692000062, 21.123311260000023],
              [24.981038045000076, 21.247851461000053],
              [24.98114139800009, 21.3724433390001],
              [24.98114139800009, 21.49703521800008],
              [24.98114139800009, 21.62157541900011],
              [24.98114139800009, 21.74616729800006],
              [24.981244751000133, 21.870810852000133],
              [24.981244751000133, 21.995351054000068],
              [25.078499797000063, 21.99529937800004],
              [25.175858195000103, 21.99529937800004],
              [25.273216593000058, 21.99529937800004],
              [25.370678345000044, 21.99529937800004],
              [25.46793339000007, 21.99529937800004],
              [25.56524011200011, 21.995247701000054],
              [25.662598511000056, 21.995247701000054],
              [25.75985355600008, 21.995247701000054],
              [25.85710860200001, 21.995247701000054],
              [25.954467, 21.995196025000027],
              [26.051928752000038, 21.99514434800001],
              [26.149183797000063, 21.99514434800001],
              [26.24654219600012, 21.99514434800001],
              [26.34379724100006, 21.995092672000098],
              [26.441052286000087, 21.995092672000098],
              [26.538410685000116, 21.995092672000098],
              [26.63576908400009, 21.995092672000098],
              [26.733127482000043, 21.995040995000082],
              [26.83038252700007, 21.994989320000073],
              [26.927740926000098, 21.994989320000073],
              [27.024995972000028, 21.994989320000073],
              [27.122354370000096, 21.994989320000073],
              [27.219712768000136, 21.994989320000073],
              [27.316967814000066, 21.994937643000057],
              [27.414326212000105, 21.994937643000057],
              [27.511684611000078, 21.994937643000057],
              [27.609043009000118, 21.994937643000057],
              [27.70640140800009, 21.994937643000057],
              [27.803656453000087, 21.994937643000057],
              [27.90101485200006, 21.99488596600004],
              [27.9983732500001, 21.994834290000128],
              [28.095731649000072, 21.994834290000128],
              [28.19293501800007, 21.994834290000128],
              [28.29034509300004, 21.994782613000027],
              [28.38770349100008, 21.994782613000027],
              [28.48490686000011, 21.994782613000027],
              [28.58231693500008, 21.994782613000027],
              [28.67967533400011, 21.994782613000027],
              [28.777033732000064, 21.994782613000027],
              [28.874392130000047, 21.994730937],
              [28.971647176000147, 21.99467926000007],
              [29.06900557500009, 21.99467926000007],
              [29.166363973000074, 21.99467926000007],
              [29.2636190180001, 21.99467926000007],
              [29.3608223870001, 21.99467926000007],
              [29.45823246300006, 21.99462758400007],
              [29.55559086100004, 21.99462758400007],
              [29.65294925900008, 21.99462758400007],
              [29.75030765800011, 21.99462758400007],
              [29.84756270300005, 21.994575907000055],
              [29.944817749000094, 21.994524232000046],
              [30.042176148000124, 21.994524232000046],
              [30.139379517000123, 21.994524232000046],
              [30.236892944000147, 21.994524232000046],
              [30.334251343000062, 21.994524232000046],
              [30.431506389000106, 21.99447255500003],
              [30.528761434000046, 21.99447255500003],
              [30.626119832000086, 21.99447255500003],
              [30.72347823100006, 21.99447255500003],
              [30.820733276000055, 21.99447255500003],
              [30.91814335100014, 21.99447255500003],
              [31.01555342600011, 21.994420879000117],
              [31.11291182500014, 21.9943692020001],
              [31.210115194000082, 21.9943692020001],
              [31.248407430000043, 21.9943692020001],
              [31.261636597000063, 22.0017589320001],
              [31.310935913000037, 22.095706686000128],
              [31.314388101000134, 22.10227318800004],
              [31.359511759000043, 22.188104146000043],
              [31.3853499760001, 22.214459127000097],
              [31.404056844000138, 22.223760885000033],
              [31.423280477000105, 22.226964823000102],
              [31.442504110000073, 22.224174296000044],
              [31.460900919000096, 22.21549265600008],
              [31.482915080000055, 22.195442200000045],
              [31.491803426000104, 22.173221334000104],
              [31.49056319200008, 22.148209941000104],
              [31.467412150000087, 22.084131165000073],
              [31.435476115000085, 21.995351054000068],
              [31.494719176000046, 21.995386529000072],
              [31.521775757000057, 21.995402731000084],
              [31.62409509300005, 21.995402731000084],
              [31.726517782000087, 21.995402731000084],
              [31.82883711800008, 21.995402731000084],
              [31.93125980600007, 21.995402731000084],
              [32.03357914200012, 21.995402731000084],
              [32.136001831000044, 21.995402731000084],
              [32.23832116700004, 21.995402731000084],
              [32.340743856000074, 21.995402731000084],
              [32.44306319200007, 21.995402731000084],
              [32.52451879000006, 21.995402731000084],
              [32.54543420400006, 21.995402731000084],
              [32.647856893000096, 21.995402731000084],
              [32.75033125800013, 21.995402731000084],
              [32.85265059400007, 21.995402731000084],
              [32.955073283000104, 21.995402731000084],
              [33.05739261800005, 21.995402731000084],
              [33.15872764107581, 21.995402731000084],
              [33.15976042200009, 21.995402731000084],
              [33.181135614000084, 21.995409469000037],
              [33.303681019419614, 21.90302223794743],
              [33.43957709632496, 21.80056990843564],
              [33.558441969291756, 21.71095743830486],
              [33.56088243000005, 21.709117570000046],
              [33.866456470948165, 21.749723959413306],
              [33.99911757000007, 21.76735270900008],
              [34.08417936900008, 21.995454407000068],
              [34.09045617700008, 21.995454407000082],
              [34.323103475000096, 21.995454407000082],
              [34.55575077300011, 21.99550608300011],
              [34.78850142400012, 21.99555776000004],
              [35.021148722000135, 21.99555776000004],
              [35.25379602000004, 21.99555776000004],
              [35.486443318000056, 21.99555776000004],
              [35.719193969000116, 21.995609436000038],
              [35.95184126800012, 21.995609436000038],
              [36.18459191900007, 21.995609436000038],
              [36.41723921700009, 21.995661113000054],
              [36.649886515000105, 21.995712789000052],
              [36.88363691500007, 21.99571360900005],
              [36.88062584700009, 21.98069896000004],
              [36.877940300000034, 21.97601959800005],
              [36.873708530000044, 21.97406647300005],
              [36.857758009000065, 21.971991278000075],
              [36.84009850400008, 21.966131903000075],
              [36.863942905000044, 21.949367580000057],
              [36.87354576900009, 21.936102606000077],
              [36.87419681100005, 21.815252997000073],
              [36.896820509000065, 21.677883205000057],
              [36.88786868600005, 21.650132554000038],
              [36.90202884200005, 21.641058661000045],
              [36.905284050000034, 21.629380601000037],
              [36.90593509200005, 21.61709219000005],
              [36.912119988000086, 21.60610586100006],
              [36.92318769600007, 21.595526434000078],
              [36.930430535000085, 21.58592357000009],
              [36.98406009200005, 21.46580638200004],
              [37.113617384000065, 21.27806224200009],
              [37.19898522200009, 21.20213450700004],
              [37.305430535000085, 21.07444896000004],
              [37.31299889400009, 21.05768463700008],
              [37.310883009000065, 21.03815338700008],
              [37.30396569100009, 21.02090078300006],
              [37.291351759000065, 21.012640692000048],
              [37.272146030000044, 21.02016836100006],
              [37.251963738000086, 21.00604889500005],
              [37.23389733200008, 21.02024974200009],
              [37.20655358200008, 21.064886786000045],
              [37.19971764400009, 21.073553778000075],
              [37.19223066500007, 21.086086330000057],
              [37.18930097700007, 21.09723541900007],
              [37.196299675000034, 21.102118231000077],
              [37.209320509000065, 21.09861888200004],
              [37.21648196700005, 21.090399481000077],
              [37.221039259000065, 21.08038971600007],
              [37.22706139400009, 21.07168203300006],
              [37.250010613000086, 21.05499909100007],
              [37.26351972700007, 21.049750067000048],
              [37.272146030000044, 21.05426666900007],
              [37.27003014400009, 21.062567450000074],
              [37.24537194100009, 21.089056708000044],
              [37.22974694100009, 21.127834377000056],
              [37.21892337300005, 21.141750393000052],
              [37.203135613000086, 21.136867580000057],
              [37.17514082100007, 21.156724351000037],
              [37.167002800000034, 21.146185614000046],
              [37.159190300000034, 21.14801666900007],
              [37.152679884000065, 21.15778229400007],
              [37.14861087300005, 21.17096588700008],
              [37.151052280000044, 21.18305084800005],
              [37.15756269600007, 21.194647528000075],
              [37.15951582100007, 21.20644765800006],
              [37.14861087300005, 21.21873607000009],
              [37.121429884000065, 21.224269924000055],
              [37.10499108200008, 21.207505601000037],
              [37.098399285000085, 21.180894273000035],
              [37.10075931100005, 21.156724351000037],
              [37.105804884000065, 21.15110911700009],
              [37.118174675000034, 21.150336005000042],
              [37.12061608200008, 21.143703518000052],
              [37.117198113000086, 21.131781317000048],
              [37.11378014400009, 21.12323639500005],
              [37.118174675000034, 21.09784577000005],
              [37.117849155000044, 21.08612702000005],
              [37.11378014400009, 21.074774481000077],
              [37.10377037900008, 21.065334377000056],
              [37.09359785200007, 21.06240469000005],
              [37.086680535000085, 21.057114976000037],
              [37.08643639400009, 21.04059479400007],
              [37.09156334700009, 21.031642971000053],
              [37.12061608200008, 20.999701239000046],
              [37.14730879000007, 20.94086334800005],
              [37.16000410200007, 20.878241278000075],
              [37.16911868600005, 20.74640534100007],
              [37.183604363000086, 20.684393622000073],
              [37.22803795700008, 20.565008856000077],
              [37.230479363000086, 20.49998607000009],
              [37.22771243600005, 20.484076239000046],
              [37.22242272200009, 20.46824778900009],
              [37.21273847700007, 20.458685614000046],
              [37.182302280000044, 20.462836005000042],
              [37.17888431100005, 20.44993724200009],
              [37.182627800000034, 20.42023346600007],
              [37.17514082100007, 20.34918854400007],
              [37.182302280000044, 20.308742580000057],
              [37.182627800000034, 20.29393138200004],
              [37.206233516000054, 20.23537089000007],
              [37.21424811500009, 20.200115676000053],
              [37.219579672000066, 20.16742867700009],
              [37.22489193700005, 20.119531530000074],
              [37.209646030000044, 20.08161041900007],
              [37.209971550000034, 20.07485586100006],
              [37.20630944100009, 20.06386953300006],
              [37.194102410000085, 20.04950592700004],
              [37.189463738000086, 20.04010651200008],
              [37.18881269600007, 20.01316966400009],
              [37.19613691500007, 19.97915273600006],
              [37.25945071700005, 19.820705471000053],
              [37.26531009200005, 19.786851304000038],
              [37.26531009200005, 19.72166575700004],
              [37.26335696700005, 19.70376211100006],
              [37.25806725400008, 19.69285716400009],
              [37.24138431100005, 19.670477606000077],
              [37.238291863000086, 19.65525950700004],
              [37.24537194100009, 19.595038153000075],
              [37.24382571700005, 19.57615794500009],
              [37.24537194100009, 19.56777578300006],
              [37.24927819100009, 19.558294989000046],
              [37.26531009200005, 19.532375393000052],
              [37.285817905000044, 19.47528717700004],
              [37.32545006600009, 19.262844143000052],
              [37.33350670700008, 19.15965403900009],
              [37.33716881600009, 19.147691148000035],
              [37.34555097700007, 19.14081452000005],
              [37.35474694100009, 19.13548411700009],
              [37.36085045700008, 19.12832265800006],
              [37.36085045700008, 19.121649481000077],
              [37.35564212300005, 19.108547268000052],
              [37.35523522200009, 19.101629950000074],
              [37.37956242200005, 19.069300759000043],
              [37.391576229000066, 19.019452520000073],
              [37.41236412900008, 18.95526764500005],
              [37.42595462300005, 18.91347890800006],
              [37.434336785000085, 18.861721096000053],
              [37.447601759000065, 18.843573309000078],
              [37.46917665800004, 18.805424189000064],
              [37.49228602000005, 18.767509544000063],
              [37.52523847700007, 18.73851146000004],
              [37.53077233200008, 18.72687409100007],
              [37.539805535000085, 18.71588776200008],
              [37.55103600400008, 18.70994700700004],
              [37.563161655000044, 18.713690497000073],
              [37.57439212300005, 18.719916083000044],
              [37.58179772200009, 18.71816640800006],
              [37.64151233300004, 18.726744016000055],
              [37.674724823000076, 18.740953414000046],
              [37.67937080300004, 18.722502233000057],
              [37.70167076900009, 18.71116771000004],
              [37.72022545700008, 18.707831122000073],
              [37.74073326900009, 18.70917389500005],
              [37.74712498900004, 18.69768040300005],
              [37.74946852100004, 18.68138920100006],
              [37.76557256700005, 18.66729473500004],
              [37.75806725400008, 18.628648179000038],
              [37.77361087300005, 18.636664130000042],
              [37.78515923000003, 18.64016048900004],
              [37.79639733200008, 18.631740627000056],
              [37.81275475400008, 18.615627346000053],
              [37.92550470300006, 18.58504362000008],
              [37.96693626400008, 18.54696352900004],
              [37.994883660000085, 18.502020575000074],
              [38.03819766000004, 18.461086012000067],
              [38.065715915000055, 18.443710184000054],
              [38.10925101400005, 18.42742548800004],
              [38.12185765000004, 18.41330100400006],
              [38.10927509000004, 18.395923966000055],
              [38.08295699200005, 18.382879332000073],
              [38.07611938600007, 18.34811933700007],
              [38.10362425900007, 18.291662560000077],
              [38.15167416600008, 18.249330884000074],
              [38.20541725600009, 18.237394462000054],
              [38.24543388300009, 18.24390564500004],
              [38.25116077200005, 18.28082459500007],
              [38.27125084700009, 18.28660716400009],
              [38.30616295700008, 18.30654531500005],
              [38.31234785200007, 18.29596588700008],
              [38.30388431100005, 18.287543036000045],
              [38.289805535000085, 18.280218817000048],
              [38.27947024800005, 18.27301666900007],
              [38.278005405000044, 18.264960028000075],
              [38.27881920700008, 18.253973700000074],
              [38.27621504000007, 18.242010809000078],
              [38.26449629000007, 18.23078034100007],
              [38.24935957100007, 18.226629950000074],
              [38.23601321700005, 18.227443752000056],
              [38.22486412900008, 18.22654857000009],
              [38.21729576900009, 18.217718817000048],
              [38.23031660200007, 18.21784088700008],
              [38.26514733200008, 18.223944403000075],
              [38.278330925000034, 18.22166575700004],
              [38.28736412900008, 18.21629466400009],
              [38.295664910000085, 18.209784247000073],
              [38.30616295700008, 18.20408763200004],
              [38.319346550000034, 18.200873114000046],
              [38.34750410200007, 18.19757721600007],
              [38.36109459700009, 18.193182684000078],
              [38.37623131600009, 18.190619208000044],
              [38.38656660200007, 18.195257880000042],
              [38.38803144600007, 18.203192450000074],
              [38.375661655000044, 18.21035390800006],
              [38.39144941500007, 18.22418854400007],
              [38.411143425000034, 18.204901434000078],
              [38.44320722700007, 18.15570709800005],
              [38.43384850400008, 18.142279364000046],
              [38.45045006600009, 18.13239166900007],
              [38.475596550000034, 18.130560614000046],
              [38.49170983200008, 18.141424872000073],
              [38.502289259000065, 18.12604401200008],
              [38.50570722700007, 18.086371161000045],
              [38.51221764400009, 18.07371653900009],
              [38.531993035000085, 18.070705471000053],
              [38.541677280000044, 18.085882880000042],
              [38.540049675000034, 18.108710028000075],
              [38.52588951900009, 18.12836334800005],
              [38.54281660200007, 18.118394273000092],
              [38.58448326900009, 18.07713450700004],
              [38.59107506600009, 18.061753648000092],
              [38.59099368600005, 18.04596588700008],
              [38.59343509200005, 18.03620026200008],
              [38.603851759000065, 18.01386139500005],
              [38.601573113000086, 18.004828192000048],
              [38.4592851160001, 17.89074371400001],
              [38.4315865480001, 17.85198639],
              [38.37133182800011, 17.698817444000056],
              [38.34373661300009, 17.655926005000097],
              [38.32347945100008, 17.640888163000042],
              [38.27387007700014, 17.617788798000063],
              [38.25661014800005, 17.60254425],
              [38.25154585700005, 17.582803854000062],
              [38.25278609200012, 17.561616516000086],
              [38.2502022700001, 17.54182444200002],
              [38.233355753000126, 17.52570139600003],
              [38.20968794800007, 17.522290751000114],
              [38.19201460800008, 17.532729391000046],
              [38.17682173600008, 17.547560527000073],
              [38.160595337000075, 17.55732737200013],
              [38.125352010000086, 17.54652699800009],
              [38.11946089700007, 17.545596822000036],
              [38.11491337100006, 17.536656799000113],
              [38.11615360500008, 17.530300598000068],
              [38.11873742600005, 17.523427633000026],
              [38.118427368000084, 17.512937317000066],
              [38.107988728000066, 17.493817037000056],
              [38.091452271000094, 17.480019430000127],
              [38.076466105000065, 17.479864401000086],
              [38.07078169800013, 17.501465149000055],
              [38.07222863800013, 17.52146392900009],
              [38.07119510900014, 17.538103739000107],
              [38.06178999800011, 17.548077291000098],
              [38.038845662000085, 17.548180644000055],
              [38.01538456300011, 17.539964091000016],
              [38.01442444300005, 17.53934428500007],
              [37.94686161300007, 17.495729065000077],
              [37.91554569500005, 17.457023418000077],
              [37.89590865100013, 17.442554017000035],
              [37.87203413900005, 17.43728302000001],
              [37.849193156000126, 17.44400095700003],
              [37.819220825000116, 17.471699524000073],
              [37.798860311000055, 17.477125550000025],
              [37.76392704300008, 17.459090474000035],
              [37.72041548700014, 17.383849589000093],
              [37.67959110500004, 17.363437399000034],
              [37.63918013500006, 17.35801137400007],
              [37.50678511600012, 17.318478902000024],
              [37.496036418000074, 17.312174378000023],
              [37.49355594900004, 17.30075388600001],
              [37.50471805800004, 17.254968567000063],
              [37.50564823400009, 17.23677846300002],
              [37.50099735500004, 17.195075582000086],
              [37.49469283100012, 17.17461171500004],
              [37.47278202300009, 17.13699127200003],
              [37.4680277920001, 17.114667053000048],
              [37.459759562000045, 17.094719951000044],
              [37.40343225100014, 17.029917705000017],
              [37.30979455500011, 17.055342509000027],
              [37.28095910700006, 17.052965393000093],
              [37.233416789000046, 17.024646709000095],
              [37.20313439900008, 17.022786357000072],
              [37.18825158700008, 17.024905090000075],
              [37.13399133300004, 17.016430155000066],
              [37.12406945800012, 17.018032125],
              [37.085415486000045, 17.0408731080001],
              [37.075080200000116, 17.0445421350001],
              [37.049345337000034, 17.04877960200004],
              [37.031465292000064, 17.055807597000054],
              [37.01637577300005, 17.065832825000072],
              [37.00045943200013, 17.072602437000015],
              [36.980098918000124, 17.070018616000127],
              [36.97348433500008, 17.062525533000084],
              [36.973370420000094, 17.062083434],
              [36.97131392400013, 17.054102275],
              [36.97358768800012, 17.04521392900007],
              [36.99343143700014, 17.018652243000062],
              [36.9970487870001, 16.99953196300008],
              [36.992397908000044, 16.9802049770001],
              [36.96810998500007, 16.946615296000076],
              [36.9715206300001, 16.935814921000045],
              [36.98195927000012, 16.925996399],
              [36.99064091000008, 16.913645732000035],
              [36.99312137900006, 16.900933330000086],
              [36.99126102700012, 16.860780741000056],
              [36.99260461400007, 16.856956686000032],
              [36.99849572700009, 16.847964987000083],
              [36.999735962000045, 16.8421255490001],
              [36.99787561100004, 16.837991435000063],
              [36.99064091000008, 16.82998158800011],
              [36.988780558000144, 16.825537415],
              [36.984956502000045, 16.76569610600005],
              [36.960358521000046, 16.705648092000033],
              [36.94960982300012, 16.691850485000074],
              [36.91664025800014, 16.66895782500005],
              [36.90144738800012, 16.655728658000058],
              [36.892352335000055, 16.63686676000013],
              [36.890698690000136, 16.619141744000032],
              [36.89255904100014, 16.58653391500006],
              [36.88956180800011, 16.56720693000001],
              [36.87726281800008, 16.527312724000055],
              [36.87653934700006, 16.513566793000038],
              [36.88336063700012, 16.490415752000033],
              [36.89638309800006, 16.472742412000045],
              [36.91209273300012, 16.456619364000048],
              [36.92625207500009, 16.43827423100008],
              [36.92731307200012, 16.435393330000082],
              [36.93369348200008, 16.418068747000078],
              [36.93317671700004, 16.400395406000072],
              [36.929662720000124, 16.382463684000115],
              [36.92821578000013, 16.361121317000098],
              [36.93338342300012, 16.34008901],
              [36.95157352700005, 16.29957468700009],
              [36.954260702000056, 16.278283997000088],
              [36.94402876800012, 16.252859192000088],
              [36.902170857000044, 16.211001282000026],
              [36.88594445800004, 16.18485300800002],
              [36.8526648350001, 16.093644104000035],
              [36.80749963400012, 15.969310608000043],
              [36.7595439050001, 15.837484030000027],
              [36.73267216000005, 15.794747620000024],
              [36.683269491000146, 15.745189921000062],
              [36.670970500000124, 15.723124085000066],
              [36.61671024600008, 15.531533712000012],
              [36.61412642500005, 15.489262390000121],
              [36.62787235500008, 15.445621643000052],
              [36.595109497000124, 15.42433095300008],
              [36.575575806000074, 15.393428447000076],
              [36.524932902000046, 15.247907613000038],
              [36.50674279700007, 15.22033823700005],
              [36.43315555800007, 15.15085927400007],
              [36.425094035000086, 15.133444316000038],
              [36.423647095000035, 15.111507671000084],
              [36.43511926300005, 15.016629741000102],
              [36.45547977700005, 14.849068909000067],
              [36.462199033000104, 14.793766434000133],
              [36.473979940000106, 14.6968043010001],
              [36.48917281100012, 14.571230571000086],
              [36.504262329000085, 14.44733632400002],
              [36.52637984200004, 14.263523254000077],
              [36.43656620300004, 13.991214295000091],
              [36.43212203000013, 13.969923604000101],
              [36.43253544100014, 13.944498799000087],
              [36.4380131420001, 13.919952495000118],
              [36.45537642400012, 13.870007222000055],
              [36.45816695100007, 13.8201394660001],
              [36.439941586000145, 13.776176290000109],
              [36.398428996000064, 13.676039734000057],
              [36.39481164600005, 13.655937602000094],
              [36.391297648000034, 13.599351909000106],
              [36.38209924300014, 13.571033224000118],
              [36.233581177000076, 13.361640320000035],
              [36.13694624900012, 13.032435608000085],
              [36.13839318800012, 13.01331532800009],
              [36.14635135900005, 12.997373149000055],
              [36.14955529800005, 12.988820700000119],
              [36.149865356000134, 12.980242411000091],
              [36.1408736570001, 12.965540467000011],
              [36.12599084500005, 12.95096771200005],
              [36.114415324000106, 12.933888652000107],
              [36.115345500000046, 12.911719463000082],
              [36.13870324700008, 12.87185109400005],
              [36.14304406800005, 12.856942444000097],
              [36.143250773000034, 12.832551168000066],
              [36.12361372900011, 12.72144683900008],
              [36.115035441000146, 12.701809795000145],
              [36.099429159000124, 12.695660299000082],
              [36.07214400200013, 12.703050029000082],
              [36.06304895000005, 12.707907614000106],
              [36.05726119000008, 12.71214508100006],
              [36.05064660600004, 12.715452373000062],
              [36.03845096800006, 12.717467753000093],
              [36.02997603300014, 12.717157695000111],
              [35.72839237500011, 12.674369608000092],
              [35.70276086500013, 12.666049703000041],
              [35.70137031500008, 12.665421098000067],
              [35.68767134600006, 12.659228414000083],
              [35.684053996000046, 12.65607615200011],
              [35.684260701000085, 12.650753479000073],
              [35.67743941300006, 12.625225322000048],
              [35.675992473000065, 12.614528300000131],
              [35.67237512300011, 12.604296366000057],
              [35.66245324700009, 12.593651021000056],
              [35.653771606000134, 12.590033671000072],
              [35.63444462100006, 12.588586731000078],
              [35.62586633300015, 12.585124410000049],
              [35.61687463300012, 12.575150859000132],
              [35.42877242000009, 12.266952616000097],
              [35.418127076000076, 12.238995667000097],
              [35.41543990000008, 12.211142070000037],
              [35.41254602000009, 12.198636373000042],
              [35.40334761500009, 12.185097148000054],
              [35.39290897600006, 12.176725566000073],
              [35.37110152200012, 12.16551178000013],
              [35.361283, 12.157346904000107],
              [35.3537382400001, 12.146029765000037],
              [35.33596154800006, 12.102311503000067],
              [35.32603967300008, 12.047482809000059],
              [35.31735803200013, 12.023711650000095],
              [35.29782434100014, 12.001594137000097],
              [35.26041060400007, 11.980406799000036],
              [35.251418904000104, 11.971725159000073],
              [35.248525024000116, 11.962475078000068],
              [35.248378775000106, 11.957857794000034],
              [35.247801554000034, 11.939634094000056],
              [35.24573449700006, 11.929867248000107],
              [35.215555461000065, 11.89658762700006],
              [35.14855575200005, 11.871229016000115],
              [35.12667199700013, 11.862946269000119],
              [35.0880180260001, 11.83819325800009],
              [35.072721802000046, 11.81886627200005],
              [35.05907922400007, 11.7958702600001],
              [35.0482271730001, 11.771375630000136],
              [35.04119917800011, 11.747604472000077],
              [35.04057906100013, 11.727398987000086],
              [35.04812382000006, 11.689520163000097],
              [35.04626346800006, 11.648644104000098],
              [35.053498169000136, 11.628076884000109],
              [35.074375448000126, 11.587355855000041],
              [35.0768559170001, 11.56864898700006],
              [35.07313521400005, 11.548960266000108],
              [34.94714807100013, 11.274868470000044],
              [34.94425419100014, 11.253241883000058],
              [34.95396936100008, 11.226111756000094],
              [34.971435994000046, 11.20688812300007],
              [34.98414839700007, 11.186398417000092],
              [34.98032434100014, 11.155263367000131],
              [34.91428186100012, 10.963957214000061],
              [34.913558390000105, 10.952975972000075],
              [34.92317020700011, 10.939927674000032],
              [34.95283247900011, 10.918430278000088],
              [34.95831018000007, 10.903418274000018],
              [34.95066206900009, 10.869182638000012],
              [34.93381555200011, 10.84530812600012],
              [34.87976200300005, 10.80461293600007],
              [34.86157189900007, 10.78758555100005],
              [34.85743778500006, 10.775674134000013],
              [34.85733443200013, 10.763556010000102],
              [34.851339966000126, 10.745753479000072],
              [34.83852421100005, 10.729139506000067],
              [34.827568807000034, 10.727770080000084],
              [34.815373169000054, 10.731309916000058],
              [34.79852665200008, 10.729656271000096],
              [34.78622766100011, 10.718985087000092],
              [34.772895142000095, 10.688263448000058],
              [34.764833618000125, 10.680253601000075],
              [34.75439497900004, 10.684129334000119],
              [34.752948039000046, 10.6987279250001],
              [34.75697880000007, 10.728803609000067],
              [34.75067427600004, 10.74394480400008],
              [34.73744510900008, 10.755391134000092],
              [34.708092896000096, 10.774072164000074],
              [34.587066691000075, 10.879285380000056],
              [34.57476770000005, 10.88414296500008],
              [34.55781783000015, 10.877786763000046],
              [34.43730839000011, 10.795672913000132],
              [34.420048462000125, 10.780815938000103],
              [34.40423547400013, 10.759835307000102],
              [34.36558150200011, 10.685782980000084],
              [34.279488566000055, 10.565506083000102],
              [34.27173710100004, 10.530081889000073],
              [34.276181275000056, 10.488714905000037],
              [34.32486047400005, 10.26865081800014],
              [34.32589400200004, 10.223563131000091],
              [34.31741906800005, 10.181265971000101],
              [34.31421512800006, 10.175452372000024],
              [34.30460331200004, 10.165633850000049],
              [34.301812785000095, 10.160285340000101],
              [34.30160607900012, 10.14899403900003],
              [34.30501672400004, 10.124602763000013],
              [34.30346643000013, 10.113544006000097],
              [34.28083215300012, 10.080109355000019],
              [34.22192102100007, 10.026029968000032],
              [34.09820764200009, 9.679720358000026],
              [34.06689172400007, 9.531176453000072],
              [34.070697863000134, 9.454592111000068],
              [33.90085534700006, 9.455289612000044],
              [33.89775476000011, 9.456581523000096],
              [33.894809204000126, 9.459475403000084],
              [33.89201867700007, 9.464281312000082],
              [33.888711385000136, 9.470818380000068],
              [33.881425008000065, 9.499214580000086],
              [33.877704305000066, 9.543423768000096],
              [33.88390547700004, 9.619853210000059],
              [33.90488610800014, 9.710700379000045],
              [33.96911991400009, 9.838341167000124],
              [33.97237552900009, 9.848883158000092],
              [33.97325402800004, 9.8548517870001],
              [33.97325402800004, 9.861776428000084],
              [33.967259562000095, 9.884514058000065],
              [33.9598181560001, 9.904202779000116],
              [33.95609745300004, 9.933994242000026],
              [33.967259562000095, 10.000269267000121],
              [33.968344767000076, 10.020810648000094],
              [33.966794475000086, 10.04726898200009],
              [33.96178186000009, 10.064037984000052],
              [33.916978393000136, 10.174522197000073],
              [33.90209558100008, 10.19204050700003],
              [33.68554549150008, 10.367972921000117],
              [33.46899540200013, 10.543905335000119],
              [33.38982710800008, 10.639248353000127],
              [33.38130049600011, 10.645785421000113],
              [33.37060347500005, 10.650901387000104],
              [33.15072025600006, 10.730974019000058],
              [33.140023234000125, 10.739035543000057],
              [33.14141849800012, 10.750817770000054],
              [33.14823978700008, 10.766036479000078],
              [33.17464644400013, 10.812286886000052],
              [33.17836714700013, 10.824534200000073],
              [33.18208785000007, 10.843241069000058],
              [33.132504313500135, 11.213903198500034],
              [33.08292077700008, 11.584565328000082],
              [33.08323083500011, 11.599163920000052],
              [33.08772668500012, 11.608853251000085],
              [33.09144738800012, 11.61479604100009],
              [33.10457320100011, 11.630583191000085],
              [33.11599369300012, 11.646938782000035],
              [33.129016154000055, 11.675490011000093],
              [33.132426799000086, 11.686212871000095],
              [33.14601770000007, 11.818659566000093],
              [33.14498417200008, 11.934673157000105],
              [33.20301680500006, 12.128098043000065],
              [33.20921797700004, 12.210366923000024],
              [32.73177941900008, 12.216154684000088],
              [32.7288338620001, 12.211917216000046],
              [32.72852380400013, 12.206852926000067],
              [32.72971236200004, 12.201065165000088],
              [32.73038415500014, 12.194863993000098],
              [32.730074097000056, 12.18189320900008],
              [32.72619836400008, 12.157941183000077],
              [32.72526818800014, 12.145254619000127],
              [32.725733276000085, 12.132335510000118],
              [32.73301965300004, 12.085981750000116],
              [32.74557702700014, 12.051125997000057],
              [32.74759240700013, 12.039524638000103],
              [32.74821252400005, 12.026812236000055],
              [32.74666223100007, 12.002731018000105],
              [32.414434448000065, 12.001271159000098],
              [32.082206665000115, 11.999811300000104],
              [32.3452397050001, 11.70910553000003],
              [32.34834029100011, 11.70316274000001],
              [32.3529911710001, 11.68737559100012],
              [32.354851522000104, 11.675774231000062],
              [32.359812459000125, 11.573480733000068],
              [32.345704793000095, 11.4116301480001],
              [32.34875370300006, 11.307579651000125],
              [32.36415328000004, 11.240012716000066],
              [32.43536340300005, 11.10702341800004],
              [32.430712524000114, 11.08219289100009],
              [32.41407271300011, 11.050851135000073],
              [32.17847985850011, 10.853201700500108],
              [31.942887004000056, 10.655552266000072],
              [31.92986454300012, 10.636922913000106],
              [31.864183797000067, 10.472126770000031],
              [31.801965373000087, 10.37624115000007],
              [31.77421512900014, 10.348775126000106],
              [31.664816121000115, 10.214235535000057],
              [31.449816324500034, 10.003279419500089],
              [31.234816528000067, 9.79232330400012],
              [31.164381551000133, 9.76400461800003],
              [30.950234416000058, 9.752454936000092],
              [30.949909851000086, 9.752446052000067],
              [30.83695967600005, 9.749354350000132],
              [30.824092245000088, 9.746176249000087],
              [30.804816935000133, 9.738941549000117],
              [30.79303470900004, 9.728011984000133],
              [30.77908207200005, 9.719872946000038],
              [30.765284465000093, 9.724291281000134],
              [30.749264771000128, 9.735763448000057],
              [30.484578084000134, 9.972028097000049],
              [30.248778523500107, 10.12125671450005],
              [30.01297896300008, 10.270485332000135],
              [29.967813762000105, 10.243329366000069],
              [29.700956665000035, 10.115016785000094],
              [29.645869589000142, 10.081711325000057],
              [29.615432170000076, 10.058146871000048],
              [29.61388187700004, 9.914460551000104],
              [29.567321412000126, 9.841364238000054],
              [29.48308882700013, 9.761679179000097],
              [29.252353556000116, 9.711165467000072],
              [29.132257527000093, 9.66773142500007],
              [29.009474324000024, 9.603239237000139],
              [28.98947554500009, 9.587090352000061],
              [28.91383284900013, 9.529031051000104],
              [28.849330486000042, 9.465901079000076],
              [28.828744626000116, 9.427474139000125],
              [28.82737223500007, 9.384930027000038],
              [28.83148940700002, 9.349247868000077],
              [28.843840924000062, 9.3245448360001],
              [28.84255017400011, 9.324555925000126],
              [28.44382985350012, 9.32798135700014],
              [28.04510953300013, 9.331406789000141],
              [27.997075859000063, 9.384930027000038],
              [27.895072062000054, 9.595410258000115],
              [27.884788452000038, 9.59137949600003],
              [27.86835534700009, 9.588511455000045],
              [27.769601685000055, 9.58331797300012],
              [27.641495809000048, 9.60194732700009],
              [27.63591475400011, 9.601378886000134],
              [27.61508915200008, 9.595797831000112],
              [27.609301392000106, 9.595177714000059],
              [27.528066040000112, 9.605357972000121],
              [27.38512902800008, 9.604789531000065],
              [27.339240357000108, 9.612799378000133],
              [27.080393107000077, 9.606830750000114],
              [26.694318482000085, 9.476942037000128],
              [26.68362146000007, 9.476011861000075],
              [26.62574385600007, 9.480662740000042],
              [26.600887491000094, 9.491979879000027],
              [26.556859172000145, 9.520453593000056],
              [26.36816267900008, 9.739716695000027],
              [26.1794661860001, 9.958979797000012],
              [26.10262333200012, 9.987841085000042],
              [26.102313341000126, 9.98816329800006],
              [26.088205607000106, 10.002827251000028],
              [26.076423381000097, 10.017710063000067],
              [26.01668542400006, 10.114861755000064],
              [26.01079431200006, 10.122690735000077],
              [26.0072286380001, 10.12599802700008],
              [26.000872436000066, 10.131062317000058],
              [25.99808190900012, 10.13245758100004],
              [25.970900105000027, 10.140312398000077],
              [25.95570723500009, 10.146901144000068],
              [25.919688761000117, 10.167855937000056],
              [25.911937296000104, 10.174212138000087],
              [25.905426066000132, 10.181265971000101],
              [25.902790568000114, 10.185529276000054],
              [25.90093021600012, 10.191058655000063],
              [25.89488407400009, 10.345829569000017],
              [25.89364384000004, 10.351333110000013],
              [25.89162845900009, 10.355983988000077],
              [25.886512492000094, 10.364303894000031],
              [25.843052612000093, 10.417814839000073],
              [25.839331909000094, 10.420553691000109],
              [25.828479858000037, 10.419546000000139],
              [25.78377974500009, 10.407892965000073],
              [25.762799113000085, 10.397738546000113],
              [25.75396244300009, 10.395335592000066],
              [25.745900920000082, 10.394405416000012],
              [25.7057483320001, 10.39595570900012],
              [25.699960571000105, 10.39502553300008],
              [25.68414758300011, 10.390684713000098],
              [25.66135827700012, 10.387015686000012],
              [25.629060506000144, 10.386705628000115],
              [25.62332442200008, 10.385852966000087],
              [25.580329631000097, 10.37531097400003],
              [25.506484009000133, 10.34962778800005],
              [25.503383423000088, 10.349162700000107],
              [25.490826049000077, 10.345597025000046],
              [25.47950891100001, 10.34381418900007],
              [25.439304647000085, 10.345209453000052],
              [25.42721236200009, 10.344124247000053],
              [25.415843547000122, 10.342031352000078],
              [25.40096073400008, 10.336992899000109],
              [25.391503947000103, 10.332652080000031],
              [25.381272013000114, 10.329448141000057],
              [25.369334757000075, 10.328207906000031],
              [25.362926880000146, 10.328130392000105],
              [25.351144653000034, 10.32681264200005],
              [25.34602868600004, 10.325262349000113],
              [25.3274251710001, 10.316580709000064],
              [25.32199914600011, 10.31565053300011],
              [25.316211385000145, 10.315573019000084],
              [25.305359334000087, 10.317123311000017],
              [25.299778279000094, 10.31665822300009],
              [25.290166463000077, 10.313092550000107],
              [25.284740437000096, 10.311852316000085],
              [25.278694295000065, 10.312007344000023],
              [25.272803182000047, 10.313015036000095],
              [25.267067098000098, 10.314797872000085],
              [25.25699019400014, 10.319216207000082],
              [25.251512492000074, 10.320999044000061],
              [25.23957523600012, 10.32301442500011],
              [25.232753947000077, 10.322316793000113],
              [25.225622599000133, 10.32061147000006],
              [25.216630900000098, 10.316968283000065],
              [25.209964640000067, 10.316115621000037],
              [25.19828576600011, 10.317588399000044],
              [25.19254968300004, 10.317433370000089],
              [25.16836511200009, 10.308131613000072],
              [25.15689294400005, 10.30624542200006],
              [25.131261434000095, 10.308286641000109],
              [25.120564413000096, 10.306090393000105],
              [25.10599165900004, 10.30035431000006],
              [25.09028202300007, 10.295755107000105],
              [25.084080851000067, 10.293222962000115],
              [25.07694950400014, 10.286866761000084],
              [25.067027628000034, 10.274929504000056],
              [25.01705651800006, 10.168010966000097],
              [25.014421021000146, 10.157365621000096],
              [25.013645874000133, 10.14907155400006],
              [25.01581628400004, 10.138038635000058],
              [25.017366577000132, 10.133000183000078],
              [25.025583130000086, 10.11416412400007],
              [25.028683716000018, 10.103906352000081],
              [25.029303833000085, 10.098247782000044],
              [25.028993775000117, 10.092046610000054],
              [25.027753540000077, 10.086155497000064],
              [25.016901489000105, 10.056751607000066],
              [24.99070153800011, 10.00305979400008],
              [24.984965454000132, 9.985593160000036],
              [24.976283813000094, 9.967351379000078],
              [24.9678605550001, 9.955956726000082],
              [24.95437300600014, 9.942236634000054],
              [24.926932821000065, 9.905210470000085],
              [24.913858683000115, 9.890715230000055],
              [24.87928715000004, 9.869915466000094],
              [24.844818970000063, 9.841674296000036],
              [24.836292358000065, 9.836635844000057],
              [24.827610717000084, 9.832682597000087],
              [24.816758667000045, 9.830744731000067],
              [24.807301880000068, 9.830047099000069],
              [24.803684530000083, 9.829168600000031],
              [24.79980879700014, 9.825215353000061],
              [24.79639815200011, 9.818859151000126],
              [24.79267744900011, 9.798369446000066],
              [24.794382772000063, 9.532184143000038],
              [24.79252242000007, 9.520401917000044],
              [24.785236043000083, 9.497509257000019],
              [24.72394779400011, 9.429218852000062],
              [24.694957316000057, 9.40291554800011],
              [24.686999145000073, 9.391365866000072],
              [24.680177857000047, 9.373356629000085],
              [24.660954224000108, 9.182283020000071],
              [24.65986901800011, 9.176986186000121],
              [24.65599328600007, 9.167296855000089],
              [24.56535282400003, 9.014851379000078],
              [24.559306681000095, 8.999865214000096],
              [24.558376505000126, 8.993353984000038],
              [24.558376505000126, 8.886745504000075],
              [24.552795450000104, 8.880079244000058],
              [24.54287357600012, 8.87465321900008],
              [24.493832642000086, 8.858349304000058],
              [24.40288212100009, 8.848892518000085],
              [24.380092814000108, 8.844215800000114],
              [24.270848837000102, 8.7757186890001],
              [24.240566446000088, 8.761533508000056],
              [24.182998902000037, 8.7179185990001],
              [24.176952759000102, 8.709857076000105],
              [24.17478234800012, 8.695646057000133],
              [24.170328031000054, 8.689327330000111],
              [24.114010864000107, 8.681641744000046],
              [24.009624471000052, 8.698875835000123],
              [23.981305786000036, 8.694173279000054],
              [23.96208215300004, 8.697015483000115],
              [23.922291300000097, 8.713448588000077],
              [23.866687459000104, 8.707790019000043],
              [23.803435506000113, 8.722130229000044],
              [23.768915650000054, 8.721251730000105],
              [23.737496379000106, 8.706859843000089],
              [23.721269979000084, 8.702002258000078],
              [23.68912723800014, 8.710683899000031],
              [23.657087850000067, 8.710012105000146],
              [23.644065389000104, 8.715153911000044],
              [23.629079224000037, 8.725592550000087],
              [23.61336958800007, 8.73223297200009],
              [23.596419719000068, 8.734145],
              [23.578022908000065, 8.730475973000111],
              [23.564070272000066, 8.7226986700001],
              [23.54050581800007, 8.704792786000041],
              [23.525726359000146, 8.701485495000043],
              [23.5052624920001, 8.710735576000047],
              [23.49006962100006, 8.732594706000086],
              [23.481801392000108, 8.759363099000055],
              [23.482318156000076, 8.783392639000084],
              [23.495443970000025, 8.80943756200007],
              [23.53668176200003, 8.85561045300011],
              [23.553631632000133, 8.883153991000086],
              [23.56593062300007, 8.940023905000132],
              [23.567480917000097, 8.974827982000093],
              [23.560142863000095, 8.996454570000083],
              [23.542572876000122, 8.997281393],
              [23.50546919700014, 8.961082052000066],
              [23.47808068900011, 8.958911641000071],
              [23.451415650000058, 8.974182027000026],
              [23.43828983600011, 8.994542542000062],
              [23.43570601400009, 9.01893381700009],
              [23.457720174000087, 9.146161194000058],
              [23.462821145000078, 9.153724977000081],
              [23.474256632000078, 9.170681661000117],
              [23.48944950300009, 9.176701966000053],
              [23.52179895000009, 9.175358379000087],
              [23.53792199700007, 9.178148906000047],
              [23.549497518000123, 9.185254415000074],
              [23.57140832500008, 9.20729441300007],
              [23.61006229600008, 9.255456848000051],
              [23.623291463000072, 9.265637106000028],
              [23.632179809000093, 9.277574361000063],
              [23.6307328690001, 9.292172953000119],
              [23.6205009360001, 9.322868755000073],
              [23.621844523000078, 9.340619609000086],
              [23.646855917000067, 9.418392640000121],
              [23.646339152000024, 9.425033061000121],
              [23.640861450000045, 9.43312042200003],
              [23.63497033700014, 9.43539418500005],
              [23.627528931000114, 9.435084127000053],
              [23.619984171000084, 9.44771901500009],
              [23.61719364400011, 9.457175802000066],
              [23.61853723100009, 9.488310852000026],
              [23.616470174000114, 9.501462504000088],
              [23.606755005000082, 9.52624135400012],
              [23.6061348880001, 9.53717091900009],
              [23.61853723100009, 9.566083883000147],
              [23.655537557000116, 9.622462870000064],
              [23.669076782000104, 9.652021790000092],
              [23.674037720000058, 9.690339864000109],
              [23.6447888590001, 9.863068339000051],
              [23.62401493400006, 9.907768453000088],
              [23.457616822000062, 10.173747050500097],
              [23.291218710000038, 10.43972564800012],
              [23.10942102100006, 10.614495342000112],
              [23.005551392000115, 10.686816508000064],
              [22.863234497000064, 10.891816915000064],
              [22.861064087000074, 10.919153747000081],
            ],
          ],
          [
            [
              [37.26531009200005, 20.85504791900007],
              [37.27564537900008, 20.848049221000053],
              [37.27914472700007, 20.845648505000042],
              [37.283539259000065, 20.83274974200009],
              [37.271820509000065, 20.766099351000037],
              [37.26449629000007, 20.74998607000009],
              [37.25440514400009, 20.749823309000078],
              [37.244151238000086, 20.772650458000044],
              [37.24341881600009, 20.804022528000075],
              [37.25082441500007, 20.83466217700004],
              [37.26531009200005, 20.85504791900007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Djibouti',
        iso3: 'DJI',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [43.24073326900009, 11.4878604190001],
            [43.18881468300009, 11.407763994000035],
            [42.923715454000046, 10.998787130000025],
            [42.90810917100009, 11.004187317000088],
            [42.898083944000064, 10.99568654400008],
            [42.888058716000046, 10.983568421000086],
            [42.873279256000046, 10.978245748000049],
            [42.86015344200007, 10.980416159000129],
            [42.83545210800014, 10.987444153000041],
            [42.794110962000104, 10.991604106000068],
            [42.771786743000064, 10.996461691000093],
            [42.754836873000045, 11.01054351800012],
            [42.72961877400007, 11.065010478000119],
            [42.71039514100005, 11.072115987000046],
            [42.686520630000075, 11.0730461630001],
            [42.615620565000086, 11.089660136000106],
            [42.60814508900012, 11.089087690000085],
            [42.56973189300004, 11.086146139000064],
            [42.47971154800007, 11.05911936400011],
            [42.41325565600005, 11.015943705000083],
            [42.391758260000074, 11.005892639000052],
            [42.37666874100006, 11.006667786000065],
            [42.36116581300007, 11.011887105000085],
            [42.33853153500013, 11.015504456000073],
            [42.305872030000046, 11.004600729000103],
            [42.297293742000136, 11.003773906000077],
            [42.27941369600006, 11.004394022000056],
            [42.27083540900014, 11.003515523000104],
            [42.23517867000004, 10.987702535000025],
            [42.22163944500005, 10.984343567000096],
            [42.20272587100004, 10.984550273000053],
            [42.151359497000044, 10.99620330800012],
            [42.096272420000105, 10.990260518000099],
            [42.0694006760001, 10.981501363000035],
            [42.03839481600005, 10.95044382800009],
            [42.01079960100009, 10.943596700000029],
            [41.95416223100011, 10.941271261000097],
            [41.94734094200004, 10.93853241000005],
            [41.942793417000075, 10.933545634000097],
            [41.93752242000005, 10.929824931000084],
            [41.92884078000009, 10.93106516500012],
            [41.92284631300009, 10.936026103000074],
            [41.92026249200006, 10.941943055000081],
            [41.916851847000146, 10.947059022000076],
            [41.798719523000045, 10.97067515100008],
            [41.77381148300009, 10.980054423000041],
            [41.76652309800011, 10.989466077000102],
            [41.761305786000094, 10.99620330800012],
            [41.779289185000096, 11.024677023000066],
            [41.78559370900007, 11.067387594000067],
            [41.78797082500006, 11.259727275000031],
            [41.77567183400009, 11.368428650000055],
            [41.74983361900007, 11.483382874000085],
            [41.74911014800006, 11.537953186000024],
            [41.77866906800011, 11.628645325000065],
            [41.79241499800014, 11.704454651000063],
            [41.80822798700012, 11.736235657000094],
            [41.82300744600008, 11.74610585600007],
            [41.862281535000136, 11.763055725000086],
            [41.87220341000011, 11.775871481000067],
            [41.87778446500005, 11.790134176000038],
            [41.88625940000014, 11.796025289000042],
            [41.897524862000125, 11.799384257000057],
            [41.911477499000114, 11.80594716400013],
            [41.92532678200007, 11.81643748000009],
            [41.93638553800008, 11.827444560000075],
            [41.97468025400008, 11.880909874000068],
            [42.057308391000106, 11.996271464000046],
            [42.0977193600001, 12.070168762000037],
            [42.1087781170001, 12.082106019000065],
            [42.132342570000105, 12.093474833000059],
            [42.14030074000004, 12.105825501000112],
            [42.1554936120001, 12.142257386000026],
            [42.2887154550001, 12.321006165000085],
            [42.31920454900006, 12.38637685200004],
            [42.37945926900005, 12.465906880000148],
            [42.430928995000045, 12.520322164000035],
            [42.44849898300009, 12.523371074000067],
            [42.4756807870001, 12.516343079000052],
            [42.521569458000045, 12.49624094700009],
            [42.67825240100012, 12.360021871000086],
            [42.69148156800014, 12.378832093000085],
            [42.6961871260001, 12.380125786000107],
            [42.72775842300007, 12.3888056440001],
            [42.7414010010001, 12.408080953000137],
            [42.74987593600008, 12.417072652000087],
            [42.779744914000105, 12.422602031000082],
            [42.79225061000011, 12.429164937000067],
            [42.798038371000075, 12.456088358000088],
            [42.78873661300014, 12.487455953000108],
            [42.785222615000066, 12.51722157800009],
            [42.82883752400005, 12.557632548000072],
            [42.852091919000145, 12.611737772000069],
            [42.868835083000135, 12.626155498000088],
            [42.87772342900013, 12.625070292000089],
            [42.89012577300008, 12.615406800000073],
            [42.90035770700007, 12.61638865200004],
            [43.11768639400009, 12.707912502000056],
            [43.13396243600005, 12.697211005000042],
            [43.143321160000085, 12.679510809000078],
            [43.151133660000085, 12.659735419000071],
            [43.16179446700005, 12.642726955000057],
            [43.25961347700007, 12.533351955000057],
            [43.283213738000086, 12.496527411000045],
            [43.29737389400009, 12.482001044000071],
            [43.31299889400009, 12.477687893000052],
            [43.32935631600009, 12.488755601000037],
            [43.32935631600009, 12.453558661000045],
            [43.33122806100005, 12.436712958000044],
            [43.33619225400008, 12.41990794500009],
            [43.344086134000065, 12.40615469000005],
            [43.35320071700005, 12.395209052000041],
            [43.36052493600005, 12.383002020000049],
            [43.36353600400008, 12.365301825000074],
            [43.36475670700008, 12.32713450700004],
            [43.367849155000044, 12.30687083500004],
            [43.374034050000034, 12.29295482000009],
            [43.41138756600009, 12.241766669000071],
            [43.41431725400008, 12.22492096600007],
            [43.41138756600009, 12.16665273600006],
            [43.418711785000085, 12.09125397300005],
            [43.41334069100009, 12.059271552000041],
            [43.398773634000065, 12.02952708500004],
            [43.37712649800005, 12.004828192000048],
            [43.35043379000007, 11.987941799000055],
            [43.342539910000085, 11.985663153000075],
            [43.31568444100009, 11.98110586100006],
            [43.28834069100009, 11.96743398600006],
            [43.26840254000007, 11.963812567000048],
            [43.22543379000007, 11.96287669500009],
            [43.20655358200008, 11.957831122000073],
            [43.17400149800005, 11.93500397300005],
            [43.09717858200008, 11.844549872000073],
            [43.09197024800005, 11.841294664000088],
            [43.08602949300007, 11.83885325700004],
            [43.076182488000086, 11.83470286700009],
            [43.06918379000007, 11.830267645000049],
            [43.06470787900008, 11.823431708000044],
            [43.060883009000065, 11.80955638200004],
            [43.05551191500007, 11.803615627000056],
            [43.04151451900009, 11.798529364000046],
            [42.98682701900009, 11.796087958000044],
            [42.97250410200007, 11.790838934000078],
            [42.95753014400009, 11.780462958000044],
            [42.94263756600009, 11.773830471000053],
            [42.91553795700008, 11.783596096000053],
            [42.896494988000086, 11.780585028000075],
            [42.803396030000044, 11.747992255000042],
            [42.77719160200007, 11.732245184000078],
            [42.75407962300005, 11.707953192000048],
            [42.68409264400009, 11.58226146000004],
            [42.67741946700005, 11.57367584800005],
            [42.667979363000086, 11.568548895000049],
            [42.63697350400008, 11.55955638200004],
            [42.627696160000085, 11.559068101000037],
            [42.60377037900008, 11.563381252000056],
            [42.57740319100009, 11.56240469000005],
            [42.569021030000044, 11.563381252000056],
            [42.563487175000034, 11.567206122000073],
            [42.55404707100007, 11.580267645000049],
            [42.54859459700003, 11.583807684000078],
            [42.52686608200008, 11.582464911000045],
            [42.51514733200008, 11.57412344000005],
            [42.51498457100007, 11.567206122000073],
            [42.528086785000085, 11.57021719000005],
            [42.53248131600009, 11.548488674000055],
            [42.53248131600009, 11.547471421000068],
            [42.53305097700007, 11.523504950000074],
            [42.53874759200005, 11.50299713700008],
            [42.57162519600007, 11.49046458500004],
            [42.59156334700003, 11.472479559000078],
            [42.60377037900008, 11.46775950700004],
            [42.61768639400009, 11.470282294000071],
            [42.633555535000085, 11.484808661000045],
            [42.64478600400008, 11.488226630000042],
            [42.65349368600005, 11.485907294000071],
            [42.662852410000085, 11.481634833000044],
            [42.672536655000044, 11.479722398000092],
            [42.681651238000086, 11.484523830000057],
            [42.687510613000086, 11.497219143000052],
            [42.680674675000034, 11.504787502000056],
            [42.67042076900009, 11.509955145000049],
            [42.66529381600009, 11.515570380000042],
            [42.67408287900008, 11.532131252000056],
            [42.694102410000085, 11.54596588700008],
            [42.73975670700008, 11.563381252000056],
            [42.80746504000007, 11.57127513200004],
            [42.829112175000034, 11.576971747000073],
            [42.83952884200005, 11.584458726000037],
            [42.84750410200007, 11.592718817000048],
            [42.855804884000065, 11.595770575000074],
            [42.86695397200003, 11.587591864000046],
            [42.87517337300005, 11.583685614000046],
            [42.900726759000065, 11.584051825000074],
            [43.04053795700008, 11.58592357000009],
            [43.06185957100007, 11.59015534100007],
            [43.08179772200003, 11.589544989000046],
            [43.10336347700007, 11.576971747000073],
            [43.123057488000086, 11.58148834800005],
            [43.133555535000085, 11.595282294000071],
            [43.14112389400009, 11.608587958000044],
            [43.15186608200008, 11.611761786000045],
            [43.15788821700005, 11.601304429000038],
            [43.172211134000065, 11.54287344000005],
            [43.17310631600009, 11.54165273600006],
            [43.18384850400008, 11.526556708000044],
            [43.19516035200007, 11.51829661700009],
            [43.22632897200003, 11.501898505000042],
            [43.24073326900009, 11.4878604190001],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Eritrea',
        iso3: 'ERI',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [43.11768639400009, 12.707912502000056],
              [42.90035770700007, 12.61638865200004],
              [42.89012577300008, 12.615406800000073],
              [42.87772342900013, 12.625070292000089],
              [42.868835083000135, 12.626155498000088],
              [42.852091919000145, 12.611737772000069],
              [42.82883752400005, 12.557632548000072],
              [42.785222615000066, 12.51722157800009],
              [42.78873661300014, 12.487455953000108],
              [42.798038371000075, 12.456088358000088],
              [42.79225061000011, 12.429164937000067],
              [42.779744914000105, 12.422602031000082],
              [42.74987593600008, 12.417072652000087],
              [42.7414010010001, 12.408080953000137],
              [42.72775842300007, 12.3888056440001],
              [42.6961871260001, 12.380125786000107],
              [42.69148156800014, 12.378832093000085],
              [42.67825240100012, 12.360021871000086],
              [42.521569458000045, 12.49624094700009],
              [42.4756807870001, 12.516343079000052],
              [42.44849898300009, 12.523371074000067],
              [42.430928995000045, 12.520322164000035],
              [42.37945926900005, 12.465906880000148],
              [42.33171024600006, 12.51546457900011],
              [42.250164836000124, 12.623985087000094],
              [42.18494917800007, 12.73304819700013],
              [42.13730350800006, 12.773329977000074],
              [42.081699667000066, 12.803922424000092],
              [42.024648886000136, 12.826970113000058],
              [41.94661747300006, 12.876166077000022],
              [41.894320922000134, 12.947970480000038],
              [41.81659956900012, 13.112792460000023],
              [41.784766887000046, 13.164572246000077],
              [41.750763794000136, 13.208316346000075],
              [41.711799764000034, 13.247926330000041],
              [41.63552535000014, 13.309343770000027],
              [41.53072554500005, 13.393783061000065],
              [41.35709273300006, 13.502277730000046],
              [41.222217244000035, 13.586613668000055],
              [41.19203820800004, 13.615862529000097],
              [41.121344848000035, 13.738180644000039],
              [41.04362349500008, 13.872487691000032],
              [40.93779016100012, 13.989922384000039],
              [40.833197062000124, 14.10596181200006],
              [40.772322225000096, 14.148362325000079],
              [40.70441939300014, 14.173218689000038],
              [40.614088990000084, 14.185801901000062],
              [40.585873657000036, 14.194690247000068],
              [40.4798336180001, 14.244402974000081],
              [40.42164595500009, 14.273755188000052],
              [40.35368741900004, 14.335240904000102],
              [40.27705529800011, 14.404574076000102],
              [40.23767785700011, 14.427440898000015],
              [40.19437300700014, 14.444649150000089],
              [40.104559367000036, 14.465965678000074],
              [40.08688602700005, 14.465758972000032],
              [40.03748335800009, 14.45152211500006],
              [40.02322066300013, 14.451160380000061],
              [39.99983947100009, 14.455238171000133],
              [39.97981246000006, 14.458730977000116],
              [39.96151900300009, 14.45420928900009],
              [39.93071984900013, 14.42878448500008],
              [39.91118615700009, 14.423410136000115],
              [39.89227258300008, 14.426562399000076],
              [39.877079712000125, 14.433616232000091],
              [39.82447310400005, 14.478135478000084],
              [39.79687788900014, 14.495111186000102],
              [39.766905558000076, 14.504774679000036],
              [39.73507287600006, 14.50371531200004],
              [39.722985, 14.501717001000074],
              [39.67771203600006, 14.49423268600006],
              [39.65094364400011, 14.496583965000099],
              [39.599473917000125, 14.511647644000092],
              [39.59378951000008, 14.51456736200008],
              [39.58769169200008, 14.520277609000047],
              [39.567331177000085, 14.544307149000062],
              [39.55213830600013, 14.556683655000128],
              [39.53229455600007, 14.567587382000085],
              [39.51503462700009, 14.567819926000055],
              [39.50717981000014, 14.547821147000022],
              [39.48940311700011, 14.524489238000086],
              [39.448578735000126, 14.505110575000117],
              [39.366619914000125, 14.48291554800008],
              [39.34760298600008, 14.481804504000081],
              [39.293446086000074, 14.490305278000093],
              [39.26853804500007, 14.486429545000135],
              [39.25499882000008, 14.47441477500007],
              [39.233191366000085, 14.440437520000046],
              [39.208179973000085, 14.440179138000076],
              [39.18750940000007, 14.47720530200013],
              [39.158467245000054, 14.560145976000072],
              [39.14472131300005, 14.581565857000086],
              [39.12746138500006, 14.602210592000091],
              [39.107307576000096, 14.620116476000064],
              [39.08550012200004, 14.633474834000097],
              [39.07547489400014, 14.637402242000064],
              [39.046949504000054, 14.643758444000085],
              [39.01118941200008, 14.647763367000081],
              [39.009742472000084, 14.65122568800011],
              [38.99682336500007, 14.638900859000074],
              [38.99527307100004, 14.622261048000055],
              [38.99682336500007, 14.60358001700007],
              [38.99382613100005, 14.585157369000072],
              [38.97966678800009, 14.567122295000061],
              [38.95920292100004, 14.55464243600008],
              [38.91755171700004, 14.535703023000039],
              [38.88458215300005, 14.506247457000114],
              [38.866081990000055, 14.493664246],
              [38.82153690600012, 14.489478454000064],
              [38.761902303000056, 14.465448914000135],
              [38.74288537600006, 14.461056417000052],
              [38.72438521400005, 14.4594027710001],
              [38.70619510900008, 14.46115977000008],
              [38.688005005000036, 14.467102559000082],
              [38.668471313000055, 14.467722677000054],
              [38.606562948000146, 14.436484273000076],
              [38.56935591600012, 14.426820781000046],
              [38.492978150000056, 14.41829416900012],
              [38.44367883300009, 14.418655904000033],
              [38.435203898000054, 14.416304627000088],
              [38.426832316000116, 14.417183126000026],
              [38.41442997300004, 14.426304016000103],
              [38.40905562300014, 14.435269877000039],
              [38.402337688000046, 14.45687062600011],
              [38.39427616400013, 14.464312032000038],
              [38.34063602700007, 14.492682394000042],
              [38.32502974400012, 14.504593812000081],
              [38.31335087100007, 14.519347433000078],
              [38.305185995000045, 14.536917420000066],
              [38.29567753100014, 14.57487375900007],
              [38.28926965400012, 14.587741191000063],
              [38.278831014000104, 14.595466818000062],
              [38.26715214000012, 14.601771342000077],
              [38.25764367700009, 14.610427144000127],
              [38.25268273900008, 14.620219829000092],
              [38.247825154000054, 14.647711691000069],
              [38.24584072200008, 14.652474329000128],
              [38.239556926000034, 14.667555440000058],
              [38.229324992000045, 14.679725240000067],
              [38.21392541500006, 14.68587473600013],
              [38.19025760900013, 14.687321676000124],
              [38.13331018000014, 14.677761536000034],
              [38.11522342900014, 14.68101715100002],
              [38.006702921000056, 14.72439951600009],
              [37.99843469300009, 14.730910747000067],
              [37.99275028500006, 14.74075510700004],
              [37.992026815000145, 14.749514262000034],
              [37.98985640400008, 14.757317403000044],
              [37.98003788200009, 14.764552104000103],
              [37.96877242000005, 14.766386617000109],
              [37.96443160000007, 14.771192525000103],
              [37.96226119000005, 14.77785878500012],
              [37.95843713300013, 14.78509348500009],
              [37.95781701700014, 14.788194072000039],
              [37.95812707500005, 14.798761902000095],
              [37.95761031100011, 14.802844340000107],
              [37.95409631400014, 14.806254985000038],
              [37.94438114400003, 14.807340189000044],
              [37.94004032400005, 14.810880025000088],
              [37.92092004400013, 14.847518616000059],
              [37.90882775900013, 14.864726868000034],
              [37.891464478000046, 14.879532166000047],
              [37.85064009600012, 14.783879090000056],
              [37.78563114400009, 14.632182923000045],
              [37.72124231000009, 14.481752828000069],
              [37.65850712100013, 14.335172628000052],
              [37.60104292800014, 14.200917257000071],
              [37.56497277800014, 14.116684672000076],
              [37.55370731600004, 14.105496724000133],
              [37.53572391800009, 14.116839702000021],
              [37.525285278000126, 14.128828634000072],
              [37.52063439900007, 14.145442607000092],
              [37.51949751800004, 14.170996603000034],
              [37.51650028500006, 14.180556742000121],
              [37.50874882000005, 14.188127340000094],
              [37.49851688600006, 14.193088277000044],
              [37.488181600000075, 14.194896952000121],
              [37.475365845000056, 14.199573670000092],
              [37.46937137900005, 14.210813294000062],
              [37.464307089000044, 14.235824687000047],
              [37.45696903400005, 14.254609070000058],
              [37.45262821500012, 14.260577698000077],
              [37.41221724400009, 14.293598938000045],
              [37.397747843000104, 14.301737976000055],
              [37.394957316000045, 14.312383321000056],
              [37.39547408000004, 14.335172628000052],
              [37.39402714000005, 14.350081279000094],
              [37.39020308400012, 14.358168640000088],
              [37.37490686000007, 14.373025615000117],
              [37.337079712000104, 14.426355693000119],
              [37.31816613700005, 14.437130228000044],
              [37.293774862000134, 14.457439067000067],
              [37.28002893100012, 14.455449524000116],
              [37.25822147700006, 14.448111470000129],
              [37.18422082500007, 14.449558411000027],
              [37.149700969000094, 14.441936137000056],
              [37.121072225000034, 14.420826315000113],
              [37.10587935400008, 14.399225566000055],
              [37.0978178310001, 14.37951100700009],
              [37.09440718600007, 14.359150492000055],
              [37.0937870680001, 14.335172628000052],
              [37.09099654100004, 14.31421783500005],
              [37.08345178200011, 14.297733053000073],
              [37.07270308400007, 14.285304871000093],
              [37.06019738700007, 14.276829936000084],
              [37.05244592300005, 14.275331320000078],
              [37.03425581900012, 14.277501730000068],
              [37.02609094200011, 14.276829936000084],
              [37.01151818800014, 14.265073548000089],
              [37.00562707500006, 14.263161519000079],
              [36.99539514200006, 14.264091695000033],
              [36.98671350100011, 14.26683054600008],
              [36.978858683000055, 14.271119690000134],
              [36.97090051200013, 14.276829936000084],
              [36.95281376100007, 14.300962830000046],
              [36.9469226490001, 14.304735210000075],
              [36.91374637900009, 14.30902435300004],
              [36.848530721000145, 14.327782898000038],
              [36.816387980000115, 14.332072042000092],
              [36.748071737000146, 14.332072042000092],
              [36.73835656800014, 14.329798279000087],
              [36.722130168000035, 14.320057271000039],
              [36.71365523300011, 14.31778350800002],
              [36.668593384000076, 14.31778350800002],
              [36.64854292800004, 14.314579570000134],
              [36.61764042100009, 14.300446066000106],
              [36.603791138000076, 14.297319641000058],
              [36.582500447000086, 14.296751200000102],
              [36.56565393000011, 14.29292714400006],
              [36.55304488100006, 14.282772726000104],
              [36.54570682800005, 14.263161519000079],
              [36.52637984200004, 14.263523254000077],
              [36.504262329000085, 14.44733632400002],
              [36.48917281100012, 14.571230571000086],
              [36.473979940000106, 14.6968043010001],
              [36.462199033000104, 14.793766434000133],
              [36.45547977700005, 14.849068909000067],
              [36.43511926300005, 15.016629741000102],
              [36.423647095000035, 15.111507671000084],
              [36.425094035000086, 15.133444316000038],
              [36.43315555800007, 15.15085927400007],
              [36.50674279700007, 15.22033823700005],
              [36.524932902000046, 15.247907613000038],
              [36.575575806000074, 15.393428447000076],
              [36.595109497000124, 15.42433095300008],
              [36.62787235500008, 15.445621643000052],
              [36.61412642500005, 15.489262390000121],
              [36.61671024600008, 15.531533712000012],
              [36.670970500000124, 15.723124085000066],
              [36.683269491000146, 15.745189921000062],
              [36.73267216000005, 15.794747620000024],
              [36.7595439050001, 15.837484030000027],
              [36.80749963400012, 15.969310608000043],
              [36.8526648350001, 16.093644104000035],
              [36.88594445800004, 16.18485300800002],
              [36.902170857000044, 16.211001282000026],
              [36.94402876800012, 16.252859192000088],
              [36.954260702000056, 16.278283997000088],
              [36.95157352700005, 16.29957468700009],
              [36.93338342300012, 16.34008901],
              [36.92821578000013, 16.361121317000098],
              [36.929662720000124, 16.382463684000115],
              [36.93317671700004, 16.400395406000072],
              [36.93369348200008, 16.418068747000078],
              [36.92731307200012, 16.435393330000082],
              [36.92625207500009, 16.43827423100008],
              [36.91209273300012, 16.456619364000048],
              [36.89638309800006, 16.472742412000045],
              [36.88336063700012, 16.490415752000033],
              [36.87653934700006, 16.513566793000038],
              [36.87726281800008, 16.527312724000055],
              [36.88956180800011, 16.56720693000001],
              [36.89255904100014, 16.58653391500006],
              [36.890698690000136, 16.619141744000032],
              [36.892352335000055, 16.63686676000013],
              [36.90144738800012, 16.655728658000058],
              [36.91664025800014, 16.66895782500005],
              [36.94960982300012, 16.691850485000074],
              [36.960358521000046, 16.705648092000033],
              [36.984956502000045, 16.76569610600005],
              [36.988780558000144, 16.825537415],
              [36.99064091000008, 16.82998158800011],
              [36.99787561100004, 16.837991435000063],
              [36.999735962000045, 16.8421255490001],
              [36.99849572700009, 16.847964987000083],
              [36.99260461400007, 16.856956686000032],
              [36.99126102700012, 16.860780741000056],
              [36.99312137900006, 16.900933330000086],
              [36.99064091000008, 16.913645732000035],
              [36.98195927000012, 16.925996399],
              [36.9715206300001, 16.935814921000045],
              [36.96810998500007, 16.946615296000076],
              [36.992397908000044, 16.9802049770001],
              [36.9970487870001, 16.99953196300008],
              [36.99343143700014, 17.018652243000062],
              [36.97358768800012, 17.04521392900007],
              [36.97131392400013, 17.054102275],
              [36.973370420000094, 17.062083434],
              [36.97348433500008, 17.062525533000084],
              [36.980098918000124, 17.070018616000127],
              [37.00045943200013, 17.072602437000015],
              [37.01637577300005, 17.065832825000072],
              [37.031465292000064, 17.055807597000054],
              [37.049345337000034, 17.04877960200004],
              [37.075080200000116, 17.0445421350001],
              [37.085415486000045, 17.0408731080001],
              [37.12406945800012, 17.018032125],
              [37.13399133300004, 17.016430155000066],
              [37.18825158700008, 17.024905090000075],
              [37.20313439900008, 17.022786357000072],
              [37.233416789000046, 17.024646709000095],
              [37.28095910700006, 17.052965393000093],
              [37.30979455500011, 17.055342509000027],
              [37.40343225100014, 17.029917705000017],
              [37.459759562000045, 17.094719951000044],
              [37.4680277920001, 17.114667053000048],
              [37.47278202300009, 17.13699127200003],
              [37.49469283100012, 17.17461171500004],
              [37.50099735500004, 17.195075582000086],
              [37.50564823400009, 17.23677846300002],
              [37.50471805800004, 17.254968567000063],
              [37.49355594900004, 17.30075388600001],
              [37.496036418000074, 17.312174378000023],
              [37.50678511600012, 17.318478902000024],
              [37.63918013500006, 17.35801137400007],
              [37.67959110500004, 17.363437399000034],
              [37.72041548700014, 17.383849589000093],
              [37.76392704300008, 17.459090474000035],
              [37.798860311000055, 17.477125550000025],
              [37.819220825000116, 17.471699524000073],
              [37.849193156000126, 17.44400095700003],
              [37.87203413900005, 17.43728302000001],
              [37.89590865100013, 17.442554017000035],
              [37.91554569500005, 17.457023418000077],
              [37.94686161300007, 17.495729065000077],
              [38.01442444300005, 17.53934428500007],
              [38.01538456300011, 17.539964091000016],
              [38.038845662000085, 17.548180644000055],
              [38.06178999800011, 17.548077291000098],
              [38.07119510900014, 17.538103739000107],
              [38.07222863800013, 17.52146392900009],
              [38.07078169800013, 17.501465149000055],
              [38.076466105000065, 17.479864401000086],
              [38.091452271000094, 17.480019430000127],
              [38.107988728000066, 17.493817037000056],
              [38.118427368000084, 17.512937317000066],
              [38.11873742600005, 17.523427633000026],
              [38.11615360500008, 17.530300598000068],
              [38.11491337100006, 17.536656799000113],
              [38.11946089700007, 17.545596822000036],
              [38.125352010000086, 17.54652699800009],
              [38.160595337000075, 17.55732737200013],
              [38.17682173600008, 17.547560527000073],
              [38.19201460800008, 17.532729391000046],
              [38.20968794800007, 17.522290751000114],
              [38.233355753000126, 17.52570139600003],
              [38.2502022700001, 17.54182444200002],
              [38.25278609200012, 17.561616516000086],
              [38.25154585700005, 17.582803854000062],
              [38.25661014800005, 17.60254425],
              [38.27387007700014, 17.617788798000063],
              [38.32347945100008, 17.640888163000042],
              [38.34373661300009, 17.655926005000097],
              [38.37133182800011, 17.698817444000056],
              [38.4315865480001, 17.85198639],
              [38.4592851160001, 17.89074371400001],
              [38.601573113000086, 18.004828192000048],
              [38.60368899800005, 17.99437083500004],
              [38.61304772200003, 17.98346588700008],
              [38.62037194100009, 17.95258209800005],
              [38.66293379000007, 17.894964911000045],
              [38.66627037900008, 17.88495514500005],
              [38.66749108200008, 17.864447333000044],
              [38.66976972700007, 17.853989976000037],
              [38.687836134000065, 17.829413153000075],
              [38.69092858200008, 17.82363515800006],
              [38.69581139400009, 17.80662669500009],
              [38.789724155000044, 17.668890692000048],
              [38.85962975400008, 17.51325104400007],
              [38.92904707100007, 17.39712148600006],
              [38.95329837300005, 17.312241929000038],
              [38.96469160200007, 17.292303778000075],
              [38.95264733200008, 17.25348541900007],
              [38.97120201900009, 17.22333405200004],
              [38.99854576900009, 17.19594961100006],
              [39.012461785000085, 17.165350653000075],
              [39.017588738000086, 17.126695054000038],
              [39.026133660000085, 17.093085028000075],
              [39.05591881600009, 17.034125067000048],
              [39.06031334700003, 17.014837958000044],
              [39.06364993600005, 16.974269924000055],
              [39.06885826900009, 16.953924872000073],
              [39.08448326900009, 16.92487213700008],
              [39.09001712300005, 16.88422272300005],
              [39.09498131600009, 16.867743231000077],
              [39.127940300000034, 16.794867255000042],
              [39.14966881600009, 16.716945705000057],
              [39.13599694100009, 16.723781643000052],
              [39.15593509200005, 16.67914459800005],
              [39.16138756600009, 16.657171942000048],
              [39.16334069100009, 16.628159898000092],
              [39.144867384000065, 16.60936107000009],
              [39.16098066500007, 16.563788153000075],
              [39.15650475400008, 16.53815338700008],
              [39.14966881600009, 16.544989325000074],
              [39.15088951900009, 16.529445705000057],
              [39.16065514400009, 16.525132554000038],
              [39.17164147200003, 16.52484772300005],
              [39.17701256600009, 16.521429755000042],
              [39.17554772200003, 16.48663971600007],
              [39.17701256600009, 16.477362372000073],
              [39.180674675000034, 16.46820709800005],
              [39.18506920700008, 16.46051666900007],
              [39.18897545700008, 16.45180898600006],
              [39.19060306100005, 16.43943919500009],
              [39.18921959700003, 16.39988841400009],
              [39.19060306100005, 16.38735586100006],
              [39.194102410000085, 16.378119208000044],
              [39.203135613000086, 16.362209377000056],
              [39.20484459700003, 16.34979889500005],
              [39.20337975400008, 16.337551174000055],
              [39.197276238000086, 16.31281159100007],
              [39.19743899800005, 16.298570054000038],
              [39.22803795700008, 16.168036200000074],
              [39.23218834700003, 16.123846747000073],
              [39.23560631600009, 16.108710028000075],
              [39.25896243600005, 16.058986721000053],
              [39.29411868600005, 15.92877838700008],
              [39.313487175000034, 15.893947658000059],
              [39.37322024800005, 15.85846588700008],
              [39.38249759200005, 15.842962958000044],
              [39.39039147200003, 15.836330471000053],
              [39.42701256600009, 15.820379950000074],
              [39.43702233200008, 15.81195709800005],
              [39.437510613000086, 15.799017645000049],
              [39.432627800000034, 15.78815338700008],
              [39.426442905000044, 15.778143622000073],
              [39.42335045700008, 15.76756419500009],
              [39.426524285000085, 15.755804755000042],
              [39.44068444100009, 15.740912177000041],
              [39.44385826900009, 15.73314036700009],
              [39.445323113000086, 15.706529039000088],
              [39.45085696700005, 15.69049713700008],
              [39.47787519600007, 15.66111888200004],
              [39.46062259200005, 15.65961334800005],
              [39.44874108200008, 15.649807033000059],
              [39.44459069100009, 15.635239976000037],
              [39.45069420700008, 15.619574286000045],
              [39.45492597700007, 15.628119208000044],
              [39.46404056100005, 15.638332424000055],
              [39.474945509000065, 15.642645575000074],
              [39.48487389400009, 15.63385651200008],
              [39.482758009000065, 15.614935614000046],
              [39.46338951900009, 15.605902411000045],
              [39.44092858200008, 15.603176174000055],
              [39.43018639400009, 15.603094794000071],
              [39.43246504000007, 15.59365469000005],
              [39.45069420700008, 15.565578518000052],
              [39.45525149800005, 15.53188711100006],
              [39.45753014400009, 15.524603583000044],
              [39.471690300000034, 15.51943594000005],
              [39.494883660000085, 15.517523505000042],
              [39.51685631600009, 15.520086981000077],
              [39.526377800000034, 15.528021552000041],
              [39.533946160000085, 15.53978099200009],
              [39.551768425000034, 15.542303778000075],
              [39.57203209700003, 15.538397528000075],
              [39.58716881600009, 15.531398830000057],
              [39.611338738000086, 15.49998607000009],
              [39.66358483200008, 15.33616771000004],
              [39.66773522200003, 15.332505601000037],
              [39.686534050000034, 15.32562897300005],
              [39.69076582100007, 15.322211005000042],
              [39.69304446700005, 15.30467357000009],
              [39.69898522200003, 15.288031317000048],
              [39.707692905000044, 15.273871161000045],
              [39.71827233200008, 15.26390208500004],
              [39.70337975400008, 15.209377346000053],
              [39.698252800000034, 15.123602606000077],
              [39.70045006600009, 15.119533596000053],
              [39.70980879000007, 15.113023179000038],
              [39.71208743600005, 15.109320380000042],
              [39.715586785000085, 15.09406159100007],
              [39.72510826900009, 15.08616771000004],
              [39.73812910200007, 15.085638739000046],
              [39.752289259000065, 15.092596747000073],
              [39.76221764400009, 15.073919989000046],
              [39.77369225400008, 15.07103099200009],
              [39.789398634000065, 15.075588283000059],
              [39.811289910000085, 15.078924872000073],
              [39.81820722700007, 15.08397044500009],
              [39.82374108200008, 15.095648505000042],
              [39.826182488000086, 15.108221747000073],
              [39.82471764400009, 15.116522528000075],
              [39.81967207100007, 15.125799872000073],
              [39.82349694100009, 15.13226959800005],
              [39.83562259200005, 15.140366929000038],
              [39.85466556100005, 15.173488674000055],
              [39.85678144600007, 15.192938544000071],
              [39.83676191500007, 15.22679271000004],
              [39.82593834700003, 15.266913153000075],
              [39.81771894600007, 15.28123607000009],
              [39.80445397200003, 15.281439520000049],
              [39.79639733200008, 15.266017971000053],
              [39.789724155000044, 15.257473049000055],
              [39.78093509200005, 15.278143622000073],
              [39.77849368600005, 15.29759349200009],
              [39.78093509200005, 15.349269924000055],
              [39.779633009000065, 15.36041901200008],
              [39.77458743600005, 15.379380601000037],
              [39.773448113000086, 15.39052969000005],
              [39.775726759000065, 15.402736721000053],
              [39.781260613000086, 15.406724351000037],
              [39.78793379000007, 15.408677476000037],
              [39.79379316500007, 15.414740302000041],
              [39.80046634200005, 15.448919989000046],
              [39.80713951900009, 15.45888906500005],
              [39.821299675000034, 15.448879299000055],
              [39.828135613000086, 15.448879299000055],
              [39.829112175000034, 15.456854559000078],
              [39.83562259200005, 15.476141669000071],
              [39.84164472700007, 15.476141669000071],
              [39.84205162900008, 15.47296784100007],
              [39.84164472700007, 15.46312083500004],
              [39.85271243600005, 15.471584377000056],
              [39.865977410000085, 15.492987372000073],
              [39.87525475400008, 15.504095770000049],
              [39.88998457100007, 15.478216864000046],
              [39.91000410200007, 15.457424221000053],
              [40.00513756600009, 15.381008205000057],
              [40.01978600400008, 15.37376536700009],
              [40.04281660200007, 15.368882554000038],
              [40.050791863000086, 15.366115627000056],
              [40.06080162900008, 15.36009349200009],
              [40.07243899800005, 15.350734768000052],
              [40.07992597700007, 15.340725002000056],
              [40.08318118600005, 15.330226955000057],
              [40.08130944100009, 15.319159247000073],
              [40.07406660200007, 15.30727773600006],
              [40.05616295700008, 15.293402411000045],
              [40.047211134000065, 15.284369208000044],
              [40.041758660000085, 15.27484772300005],
              [40.02662194100009, 15.237209377000056],
              [40.037771030000044, 15.23818594000005],
              [40.04623457100007, 15.23578522300005],
              [40.05201256600009, 15.22955963700008],
              [40.05396569100009, 15.219224351000037],
              [40.051524285000085, 15.21625397300005],
              [40.04127037900008, 15.212469794000071],
              [40.039724155000044, 15.20929596600007],
              [40.04151451900009, 15.20498281500005],
              [40.04623457100007, 15.200995184000078],
              [40.047211134000065, 15.198431708000044],
              [40.05250084700003, 15.190130927000041],
              [40.07593834700003, 15.173163153000075],
              [40.08130944100009, 15.164536851000037],
              [40.08415774800005, 15.15180084800005],
              [40.09717858200008, 15.125881252000056],
              [40.10181725400008, 15.113023179000038],
              [40.10124759200005, 15.10187409100007],
              [40.09848066500007, 15.088812567000048],
              [40.09750410200007, 15.075832424000055],
              [40.10181725400008, 15.064642645000049],
              [40.114268425000034, 15.069037177000041],
              [40.127940300000034, 15.066229559000078],
              [40.13892662900008, 15.058661200000074],
              [40.143321160000085, 15.048529364000046],
              [40.145274285000085, 15.040187893000052],
              [40.14966881600009, 15.038316148000092],
              [40.154307488000086, 15.037298895000049],
              [40.15707441500007, 15.03115469000005],
              [40.15650475400008, 15.022040106000077],
              [40.15088951900009, 15.007066148000092],
              [40.14958743600005, 15.000067450000074],
              [40.15943444100009, 14.982245184000078],
              [40.182627800000034, 14.970851955000057],
              [40.256602410000085, 14.945257880000042],
              [40.27263431100005, 14.937567450000074],
              [40.279958530000044, 14.931830145000049],
              [40.28679446700005, 14.913478908000059],
              [40.301768425000034, 14.916896877000056],
              [40.324554884000065, 14.93553294500009],
              [40.34717858200008, 14.94407786700009],
              [40.36296634200005, 14.964097398000092],
              [40.375743035000085, 14.986721096000053],
              [40.38982181100005, 15.003241278000075],
              [40.38851972700007, 14.98737213700008],
              [40.39210045700008, 14.973578192000048],
              [40.401377800000034, 14.966131903000075],
              [40.41773522200003, 14.96906159100007],
              [40.42302493600005, 14.977850653000075],
              [40.42074629000007, 14.98924388200004],
              [40.42269941500007, 14.99900950700004],
              [40.44068444100009, 15.003241278000075],
              [40.45142662900008, 15.003851630000042],
              [40.45443769600007, 15.004461981000077],
              [40.464854363000086, 14.997015692000048],
              [40.463226759000065, 14.99359772300005],
              [40.46111087300005, 14.98655833500004],
              [40.46314537900008, 14.979681708000044],
              [40.475352410000085, 14.976507880000042],
              [40.48259524800005, 14.973578192000048],
              [40.48560631600009, 14.967678127000056],
              [40.48951256600009, 14.962551174000055],
              [40.499034050000034, 14.962225653000075],
              [40.50562584700003, 14.965277411000045],
              [40.51148522200003, 14.970526434000078],
              [40.516368035000085, 14.976629950000074],
              [40.520192905000044, 14.98273346600007],
              [40.51514733200008, 14.990790106000077],
              [40.51295006600009, 14.99876536700009],
              [40.512705925000034, 15.01748281500005],
              [40.518321160000085, 15.012518622000073],
              [40.52312259200005, 15.001695054000038],
              [40.52702884200005, 14.997015692000048],
              [40.55420983200008, 14.990179755000042],
              [40.556651238000086, 14.981675523000092],
              [40.55583743600005, 14.97296784100007],
              [40.55591881600009, 14.964097398000092],
              [40.56104576900009, 14.95538971600007],
              [40.568695509000065, 14.950506903000075],
              [40.57374108200008, 14.95148346600007],
              [40.57935631600009, 14.954413153000075],
              [40.58838951900009, 14.95538971600007],
              [40.60670006600009, 14.952948309000078],
              [40.61638431100005, 14.94867584800005],
              [40.62061608200008, 14.939276434000078],
              [40.62427819100009, 14.900091864000046],
              [40.627696160000085, 14.891994533000059],
              [40.656586134000065, 14.88031647300005],
              [40.65202884200005, 14.89712148600006],
              [40.66041100400008, 14.90257396000004],
              [40.68767337300005, 14.900824286000045],
              [40.69450931100005, 14.896226304000038],
              [40.69743899800005, 14.887396552000041],
              [40.69271894600007, 14.88190338700008],
              [40.67709394600007, 14.887152411000045],
              [40.670909050000034, 14.88031647300005],
              [40.718760613000086, 14.831854559000078],
              [40.71924889400009, 14.834173895000049],
              [40.722666863000086, 14.83592357000009],
              [40.72738691500007, 14.834133205000057],
              [40.732432488000086, 14.825669664000088],
              [40.73373457100007, 14.818182684000078],
              [40.732432488000086, 14.790961005000042],
              [40.72413170700008, 14.768255927000041],
              [40.72388756600009, 14.757066148000092],
              [40.732432488000086, 14.743719794000071],
              [40.75798587300005, 14.72601959800005],
              [40.766368035000085, 14.714585679000038],
              [40.76644941500007, 14.69529857000009],
              [40.77702884200005, 14.70180898600006],
              [40.78663170700008, 14.70604075700004],
              [40.796885613000086, 14.706773179000038],
              [40.80811608200008, 14.702826239000046],
              [40.80811608200008, 14.722072658000059],
              [40.831065300000034, 14.712225653000075],
              [40.88445071700005, 14.714544989000046],
              [40.91391035200007, 14.69912344000005],
              [40.94467207100007, 14.677313544000071],
              [40.972666863000086, 14.669623114000046],
              [41.04021243600005, 14.66742584800005],
              [41.15609785200007, 14.64158763200004],
              [41.16749108200008, 14.63694896000004],
              [41.17953535200007, 14.621771552000041],
              [41.195648634000065, 14.585109768000052],
              [41.20875084700003, 14.568101304000038],
              [41.25318444100009, 14.537665106000077],
              [41.28296959700003, 14.51756419500009],
              [41.30681399800005, 14.48891836100006],
              [41.32252037900008, 14.45453522300005],
              [41.32829837300005, 14.417629299000055],
              [41.335948113000086, 14.402004299000055],
              [41.35238691500007, 14.392157294000071],
              [41.36898847700007, 14.38475169500009],
              [41.37663821700005, 14.376288153000075],
              [41.38103274800005, 14.368801174000055],
              [41.39966881600009, 14.34666575700004],
              [41.412771030000044, 14.30654531500005],
              [41.433604363000086, 14.282131252000056],
              [41.47966556100005, 14.242865302000041],
              [41.505869988000086, 14.213446356000077],
              [41.51449629000007, 14.19920482000009],
              [41.52133222700007, 14.181382554000038],
              [41.52898196700005, 14.148830471000053],
              [41.53345787900008, 14.13694896000004],
              [41.541758660000085, 14.126166083000044],
              [41.555430535000085, 14.115912177000041],
              [41.588633660000085, 14.096177476000037],
              [41.60596764400009, 14.081773179000038],
              [41.62094160200007, 14.063625393000052],
              [41.657237175000034, 13.996486721000053],
              [41.66781660200007, 13.955145575000074],
              [41.676524285000085, 13.940252997000073],
              [41.74008222700007, 13.921535549000055],
              [41.75342858200008, 13.920721747000073],
              [41.78565514400009, 13.932806708000044],
              [41.79810631600009, 13.934393622000073],
              [41.80600019600007, 13.92967357000009],
              [41.82545006600009, 13.89679596600007],
              [41.84156334700003, 13.88031647300005],
              [41.84896894600007, 13.876166083000044],
              [41.863291863000086, 13.87295156500005],
              [41.87427819100009, 13.873195705000057],
              [41.896494988000086, 13.87881094000005],
              [41.904307488000086, 13.879787502000056],
              [41.92156009200005, 13.873114325000074],
              [41.95679772200003, 13.850531317000048],
              [41.969737175000034, 13.845648505000042],
              [41.98096764400009, 13.83779531500005],
              [41.98601321700005, 13.819484768000052],
              [41.988942905000044, 13.798773505000042],
              [41.99366295700008, 13.783596096000053],
              [42.03492272200003, 13.75226471600007],
              [42.041351759000065, 13.739162502000056],
              [42.04574629000007, 13.73899974200009],
              [42.068695509000065, 13.70844147300005],
              [42.07553144600007, 13.69476959800005],
              [42.07781009200005, 13.693426825000074],
              [42.08676191500007, 13.689520575000074],
              [42.08920332100007, 13.687974351000037],
              [42.09359785200007, 13.676459052000041],
              [42.099619988000086, 13.654364325000074],
              [42.10661868600005, 13.64354075700004],
              [42.11695397200003, 13.640773830000057],
              [42.129242384000065, 13.64557526200008],
              [42.13949629000007, 13.651190497000073],
              [42.14380944100009, 13.65037669500009],
              [42.14730879000007, 13.644110419000071],
              [42.16456139400009, 13.632391669000071],
              [42.17115319100009, 13.626532294000071],
              [42.17514082100007, 13.617254950000074],
              [42.18083743600005, 13.594142971000053],
              [42.18482506600009, 13.585598049000055],
              [42.208018425000034, 13.568548895000049],
              [42.21216881600009, 13.567572333000044],
              [42.21599368600005, 13.553859768000052],
              [42.22388756600009, 13.553941148000092],
              [42.23023522200003, 13.56000397300005],
              [42.229502800000034, 13.563869533000059],
              [42.22429446700005, 13.567613023000092],
              [42.209971550000034, 13.585760809000078],
              [42.20655358200008, 13.591742255000042],
              [42.20460045700008, 13.593491929000038],
              [42.20142662900008, 13.59516022300005],
              [42.19874108200008, 13.59870026200008],
              [42.19849694100009, 13.606024481000077],
              [42.20167076900009, 13.606390692000048],
              [42.215586785000085, 13.605658270000049],
              [42.21900475400008, 13.606024481000077],
              [42.219737175000034, 13.632554429000038],
              [42.20630944100009, 13.643866278000075],
              [42.18921959700003, 13.652736721000053],
              [42.16773522200003, 13.653794664000088],
              [42.15992272200003, 13.65656159100007],
              [42.16236412900008, 13.662298895000049],
              [42.17164147200003, 13.667181708000044],
              [42.18482506600009, 13.667466539000088],
              [42.21900475400008, 13.640204169000071],
              [42.255869988000086, 13.591986395000049],
              [42.27035566500007, 13.585598049000055],
              [42.28842207100007, 13.574611721000053],
              [42.29476972700007, 13.549953518000052],
              [42.29468834700003, 13.50922272300005],
              [42.30591881600009, 13.476141669000071],
              [42.314789259000065, 13.461004950000074],
              [42.32545006600009, 13.454575914000088],
              [42.33521569100009, 13.443508205000057],
              [42.342539910000085, 13.418117580000057],
              [42.358083530000044, 13.302476304000038],
              [42.37232506600009, 13.278631903000075],
              [42.377696160000085, 13.230047919000071],
              [42.37680097700007, 13.225490627000056],
              [42.37940514400009, 13.22264232000009],
              [42.410166863000086, 13.204575914000088],
              [42.43132571700005, 13.198391018000052],
              [42.47681725400008, 13.194525458000044],
              [42.49594160200007, 13.19790273600006],
              [42.50749759200005, 13.206976630000042],
              [42.514414910000085, 13.220038153000075],
              [42.52068118600005, 13.235500393000052],
              [42.533946160000085, 13.232570705000057],
              [42.537771030000044, 13.226263739000046],
              [42.538096550000034, 13.217718817000048],
              [42.541758660000085, 13.208197333000044],
              [42.54769941500007, 13.203273830000057],
              [42.55445397200003, 13.199652411000045],
              [42.55990644600007, 13.19432200700004],
              [42.56218509200005, 13.183986721000053],
              [42.57007897200003, 13.17096588700008],
              [42.62045332100007, 13.129339911000045],
              [42.65544681100005, 13.072333075000074],
              [42.668304884000065, 13.064154364000046],
              [42.688243035000085, 13.061346747000073],
              [42.70460045700008, 13.054022528000075],
              [42.71827233200008, 13.04401276200008],
              [42.72974694100009, 13.033148505000042],
              [42.73764082100007, 13.017726955000057],
              [42.74724368600005, 12.961737372000073],
              [42.763682488000086, 12.92523834800005],
              [42.767588738000086, 12.90648021000004],
              [42.770192905000044, 12.878159898000092],
              [42.77393639400009, 12.862127997000073],
              [42.781260613000086, 12.85187409100007],
              [42.79542076900009, 12.84837474200009],
              [42.80844160200007, 12.85228099200009],
              [42.82154381600009, 12.859320380000042],
              [42.83578535200007, 12.864935614000046],
              [42.84929446700005, 12.837836005000042],
              [42.86890709700003, 12.82135651200008],
              [42.89625084700003, 12.813177802000041],
              [42.93213951900009, 12.810939846000053],
              [42.92741946700005, 12.805853583000044],
              [42.91846764400009, 12.79047272300005],
              [42.92798912900008, 12.789740302000041],
              [42.93572024800005, 12.791937567000048],
              [42.945648634000065, 12.797308661000045],
              [42.94459069100009, 12.798488674000055],
              [42.963226759000065, 12.81045156500005],
              [42.96631920700008, 12.810939846000053],
              [42.97803795700008, 12.823960679000038],
              [42.987315300000034, 12.83820221600007],
              [42.98991946700005, 12.847357489000046],
              [42.98951256600009, 12.854071356000077],
              [42.99146569100009, 12.85960521000004],
              [43.000987175000034, 12.864935614000046],
              [42.994883660000085, 12.87490469000005],
              [42.99350019600007, 12.884588934000078],
              [42.99586022200003, 12.89329661700009],
              [43.000987175000034, 12.90029531500005],
              [43.02947024800005, 12.878851630000042],
              [43.04314212300005, 12.865627346000053],
              [43.048838738000086, 12.855292059000078],
              [43.05323326900009, 12.844875393000052],
              [43.06364993600005, 12.836371161000045],
              [43.076182488000086, 12.82876211100006],
              [43.08643639400009, 12.820868231000077],
              [43.09327233200008, 12.807766018000052],
              [43.09457441500007, 12.777533270000049],
              [43.09717858200008, 12.762518622000073],
              [43.12387129000007, 12.715318101000037],
              [43.11768639400009, 12.707912502000056],
            ],
          ],
          [
            [
              [40.38640384200005, 15.64126211100006],
              [40.401133660000085, 15.640773830000057],
              [40.406260613000086, 15.63812897300005],
              [40.41423587300005, 15.59829336100006],
              [40.40805097700007, 15.580023505000042],
              [40.39389082100007, 15.572333075000074],
              [40.393565300000034, 15.57249583500004],
              [40.37289472700007, 15.582586981000077],
              [40.365896030000044, 15.584133205000057],
              [40.35661868600005, 15.58616771000004],
              [40.30811608200008, 15.57453034100007],
              [40.28736412900008, 15.57298411700009],
              [40.265961134000065, 15.57998281500005],
              [40.231130405000044, 15.59642161700009],
              [40.20826256600009, 15.599676825000074],
              [40.15870201900009, 15.589544989000046],
              [40.148773634000065, 15.59125397300005],
              [40.143321160000085, 15.592230536000045],
              [40.139333530000044, 15.595851955000057],
              [40.13339277400007, 15.603257554000038],
              [40.12940514400009, 15.608303127000056],
              [40.12704511800007, 15.61033763200004],
              [40.12289472700007, 15.613877671000068],
              [40.12281334700003, 15.613959052000041],
              [40.11378014400009, 15.59756094000005],
              [40.102224155000044, 15.589056708000044],
              [40.08529707100007, 15.587632554000038],
              [40.06080162900008, 15.592230536000045],
              [40.02035566500007, 15.607570705000057],
              [40.01514733200008, 15.608587958000044],
              [40.00147545700008, 15.611273505000042],
              [39.97901451900009, 15.60651276200008],
              [39.978851759000065, 15.60651276200008],
              [39.97038821700005, 15.617661851000037],
              [39.963877800000034, 15.626288153000075],
              [39.93734785200007, 15.702093817000048],
              [39.94874108200008, 15.701849677000041],
              [39.955739780000044, 15.699693101000037],
              [39.95671634200005, 15.69594961100006],
              [39.95687910200007, 15.695379950000074],
              [39.95093834700003, 15.688421942000048],
              [39.958994988000086, 15.68390534100007],
              [39.96509850400008, 15.677923895000049],
              [39.96729576900009, 15.67373281500005],
              [39.96900475400008, 15.670396226000037],
              [39.971446160000085, 15.66111888200004],
              [39.97152754000007, 15.66111888200004],
              [39.978851759000065, 15.66111888200004],
              [39.988291863000086, 15.66469961100006],
              [40.00147545700008, 15.65961334800005],
              [40.01539147200003, 15.651922919000071],
              [40.02662194100009, 15.64744700700004],
              [40.02670332100007, 15.647487697000088],
              [40.03931725400008, 15.648098049000055],
              [40.08130944100009, 15.66111888200004],
              [40.06299889400009, 15.692857164000088],
              [40.03858483200008, 15.71898021000004],
              [40.008799675000034, 15.73655833500004],
              [39.97510826900009, 15.743068752000056],
              [39.942149285000085, 15.736395575000074],
              [39.930430535000085, 15.739569403000075],
              [39.92359459700003, 15.757310289000088],
              [39.92497806100005, 15.777044989000046],
              [39.93376712300005, 15.788234768000052],
              [39.94678795700008, 15.789862372000073],
              [39.97055097700007, 15.77484772300005],
              [39.97673587300005, 15.770982164000088],
              [39.99000084700003, 15.769924221000053],
              [39.99390709700003, 15.777899481000077],
              [39.98194420700008, 15.79523346600007],
              [39.97641035200007, 15.81195709800005],
              [39.975271030000044, 15.815334377000056],
              [39.99496504000007, 15.824693101000037],
              [40.02125084700003, 15.827053127000056],
              [40.03215579500005, 15.826320705000057],
              [40.03345787900008, 15.826239325000074],
              [40.037445509000065, 15.838405666000085],
              [40.03077233200008, 15.854315497000073],
              [40.01937910200007, 15.868109442000048],
              [40.00936933700007, 15.873968817000048],
              [40.00928795700008, 15.87400950700004],
              [39.97437584700003, 15.871771552000041],
              [39.96314537900008, 15.877101955000057],
              [39.95101972700007, 15.893866278000075],
              [39.95093834700003, 15.893947658000059],
              [39.98747806100005, 15.891058661000045],
              [40.02621504000007, 15.882635809000078],
              [40.06267337300005, 15.868841864000046],
              [40.08480879000007, 15.854315497000073],
              [40.09156334700003, 15.84983958500004],
              [40.101003451000054, 15.835638739000046],
              [40.10564212300005, 15.828680731000077],
              [40.10556074300007, 15.828640041000085],
              [40.100596550000034, 15.814154364000046],
              [40.090179884000065, 15.803127346000053],
              [40.08814537900008, 15.792141018000052],
              [40.095713738000086, 15.78461334800005],
              [40.10515384200005, 15.78424713700008],
              [40.11459394600007, 15.787787177000041],
              [40.12281334700003, 15.792141018000052],
              [40.121104363000086, 15.795803127000056],
              [40.116221550000034, 15.802557684000078],
              [40.11540774800005, 15.809027411000045],
              [40.125987175000034, 15.81195709800005],
              [40.13648522200003, 15.806219794000071],
              [40.13876386800007, 15.793321031000062],
              [40.13892662900008, 15.792222398000092],
              [40.13306725400008, 15.71116771000004],
              [40.13591556100005, 15.695868231000077],
              [40.141286655000044, 15.684108791000085],
              [40.14242597700007, 15.681463934000078],
              [40.160166863000086, 15.652411200000074],
              [40.16382897200003, 15.644354559000078],
              [40.17359459700003, 15.64362213700008],
              [40.23210696700005, 15.627020575000074],
              [40.24740644600007, 15.65501536700009],
              [40.25318444100009, 15.66111888200004],
              [40.26156660200007, 15.663234768000052],
              [40.248057488000086, 15.668117580000057],
              [40.22779381600009, 15.674017645000049],
              [40.21916751400005, 15.685329494000086],
              [40.219086134000065, 15.685370184000078],
              [40.226573113000086, 15.696478583000044],
              [40.244476759000065, 15.702093817000048],
              [40.26693769600007, 15.703517971000053],
              [40.28736412900008, 15.702093817000048],
              [40.29859459700003, 15.700018622000073],
              [40.307627800000034, 15.697211005000042],
              [40.31145267000005, 15.695257880000042],
              [40.315114780000044, 15.693426825000074],
              [40.32154381600009, 15.688421942000048],
              [40.32545006600009, 15.680853583000044],
              [40.326914910000085, 15.671820380000042],
              [40.32992597700007, 15.664252020000049],
              [40.338552280000044, 15.66111888200004],
              [40.35271243600005, 15.658026434000078],
              [40.37354576900009, 15.644354559000078],
              [40.38640384200005, 15.64126211100006],
            ],
          ],
          [
            [
              [40.09538821700005, 16.047349351000037],
              [40.08057701900009, 16.03416575700004],
              [40.07740319100009, 16.01902903900009],
              [40.08366946700005, 16.013332424000055],
              [40.09229576900009, 16.00877513200004],
              [40.09937584700003, 16.002101955000057],
              [40.10962975400008, 15.99510325700004],
              [40.11451256600009, 15.985907294000071],
              [40.096690300000034, 15.981024481000077],
              [40.067393425000034, 15.99046458500004],
              [40.042979363000086, 16.00340403900009],
              [40.000010613000086, 16.007757880000042],
              [39.99000084700003, 16.017726955000057],
              [39.990244988000086, 16.03424713700008],
              [39.99822024800005, 16.049627997000073],
              [40.01587975400008, 16.05613841400009],
              [40.03834069100009, 16.057928778000075],
              [40.047211134000065, 16.06346263200004],
              [40.04379316500007, 16.07184479400007],
              [40.041758660000085, 16.08161041900007],
              [40.041351759000065, 16.09210846600007],
              [40.04322350400008, 16.10309479400007],
              [40.05046634200005, 16.107245184000078],
              [40.07569420700008, 16.08808014500005],
              [40.083018425000034, 16.08397044500009],
              [40.09294681100005, 16.081732489000046],
              [40.11101321700005, 16.073960679000038],
              [40.11882571700005, 16.06199778900009],
              [40.111989780000044, 16.052883205000057],
              [40.09538821700005, 16.047349351000037],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: "Côte d'Ivoire",
        iso3: 'CIV',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7.989662638999988, 10.161990662000065],
              [-7.970904093999877, 10.155066020000078],
              [-7.94987178599996, 10.155427755000076],
              [-7.929046182999912, 10.160957133000082],
              [-7.910959431999913, 10.169406230000078],
              [-7.892252563999904, 10.18483164400007],
              [-7.882847452999954, 10.190826111000092],
              [-7.857215942999886, 10.194417623000078],
              [-7.847423257999935, 10.197931621000123],
              [-7.838664103999861, 10.203719381000099],
              [-7.829000609999923, 10.211651713000052],
              [-7.805074421999933, 10.241830749000059],
              [-7.801250366999881, 10.249453024000033],
              [-7.797736368999921, 10.260279236000073],
              [-7.791225137999959, 10.265782776000066],
              [-7.783835408999948, 10.270433655000119],
              [-7.778254353999927, 10.278340149000073],
              [-7.776342325999934, 10.29273203600009],
              [-7.764405069999981, 10.312911682000063],
              [-7.777582559999871, 10.329861552000068],
              [-7.757428750999878, 10.334047343000108],
              [-7.735337076999883, 10.347095642000056],
              [-7.723994099999913, 10.363606262000047],
              [-7.736034708999881, 10.378282369000118],
              [-7.726784626999859, 10.382881571000084],
              [-7.722288777999921, 10.384483541000108],
              [-7.722288777999921, 10.39133066900007],
              [-7.708646199999919, 10.402466939000092],
              [-7.699809529999925, 10.404533997000058],
              [-7.687923949999913, 10.403087057000064],
              [-7.679035603999893, 10.40592926100004],
              [-7.673971313999914, 10.416393738000082],
              [-7.670043903999925, 10.428770244000049],
              [-7.664411172999905, 10.437141825000111],
              [-7.643688924999879, 10.440474955000127],
              [-7.607773803999919, 10.418719177000114],
              [-7.584416056999885, 10.416522929000024],
              [-7.574339151999936, 10.417530620000093],
              [-7.556381591999866, 10.41727223700012],
              [-7.547415730999916, 10.420502015000096],
              [-7.539612588999915, 10.427633362000037],
              [-7.515841430999927, 10.457812399000133],
              [-7.501475382999928, 10.45863922100007],
              [-7.489848184999886, 10.45610707600008],
              [-7.480236368999954, 10.450293477000088],
              [-7.471606404999932, 10.441095072000095],
              [-7.466180379999855, 10.429493713000042],
              [-7.465353555999911, 10.41799570800012],
              [-7.466180379999855, 10.407479554000062],
              [-7.465456908999954, 10.398617045000051],
              [-7.461477823999871, 10.388643493000046],
              [-7.444682983999911, 10.360815735000088],
              [-7.443287719999915, 10.349963685000134],
              [-7.445768187999903, 10.340377706000126],
              [-7.444424600999923, 10.33420237200005],
              [-7.431402140999893, 10.333737284000037],
              [-7.422203735999915, 10.336088562000072],
              [-7.395021931999906, 10.346217143000018],
              [-7.372335977999853, 10.344770203000024],
              [-7.366341511999934, 10.329448141000057],
              [-7.372697713999855, 10.288597921000061],
              [-7.371819213999913, 10.264516704000116],
              [-7.36339595499993, 10.252191875000065],
              [-7.346962850999944, 10.247902731000096],
              [-7.28402095499996, 10.246559143000042],
              [-7.204749308999908, 10.23449269600006],
              [-7.106357380999896, 10.207259216000068],
              [-7.089459187999893, 10.19756988600004],
              [-7.073129434999942, 10.178527120000055],
              [-7.058246622999917, 10.155970358000033],
              [-7.040521605999885, 10.140054017000097],
              [-7.015768594999884, 10.140880839000118],
              [-6.992410847999935, 10.149097392000058],
              [-6.971636922999892, 10.164419454000026],
              [-6.959389607999867, 10.185503439000058],
              [-6.961611693999942, 10.211031596000083],
              [-6.97117183499995, 10.222064514000081],
              [-6.984297648999927, 10.23038442000005],
              [-6.994891316999912, 10.239401958000087],
              [-6.997113402999901, 10.25276031600012],
              [-6.973135537999894, 10.332290344000043],
              [-6.961249959999861, 10.344873556000053],
              [-6.938719034999849, 10.348335877000096],
              [-6.882029987999942, 10.341256206000068],
              [-6.86275467999991, 10.34384002700007],
              [-6.803895222999898, 10.370866801000105],
              [-6.782087768999872, 10.373037212000014],
              [-6.760228637999944, 10.366112570000027],
              [-6.722556518999909, 10.344046733000127],
              [-6.700335652999883, 10.341669617000079],
              [-6.677391316999916, 10.34903350900008],
              [-6.668916381999935, 10.361022441000046],
              [-6.668270003999908, 10.365839977000036],
              [-6.663955444999885, 10.397996928000083],
              [-6.659614623999914, 10.405360820000084],
              [-6.653051716999926, 10.41306060800008],
              [-6.647935749999931, 10.421871440000075],
              [-6.647780721999879, 10.43269765300002],
              [-6.653981892999866, 10.440035706000103],
              [-6.664627237999866, 10.444557394000043],
              [-6.675634317999936, 10.447864686000045],
              [-6.683075723999877, 10.45168874100007],
              [-6.695788126999929, 10.471196594000077],
              [-6.69754512499992, 10.488301494000027],
              [-6.687778279999861, 10.520470072000066],
              [-6.682817342999897, 10.56597117100003],
              [-6.685607869999956, 10.5740068570001],
              [-6.689225219999855, 10.580931498000083],
              [-6.691085571999849, 10.589432271000092],
              [-6.688966836999981, 10.607854919000104],
              [-6.684212605999988, 10.626561788000089],
              [-6.681938842999955, 10.627388611000114],
              [-6.667882853999856, 10.650901387000104],
              [-6.669174763999905, 10.65415700300008],
              [-6.647108927999909, 10.661340027000037],
              [-6.633983113999932, 10.653020122000072],
              [-6.6136225999999, 10.618474426000091],
              [-6.59858475799993, 10.604909363000104],
              [-6.578069213999953, 10.59113759400006],
              [-6.537554890999928, 10.569691874000043],
              [-6.521380167999951, 10.56421417200005],
              [-6.466964883999964, 10.553542990000054],
              [-6.445984252999949, 10.552251078000097],
              [-6.421489623999889, 10.556591899000082],
              [-6.402782755999908, 10.569123434000076],
              [-6.39921708199995, 10.59248118100004],
              [-6.406658487999977, 10.601860453000072],
              [-6.419060831999928, 10.607699891000067],
              [-6.430688028999896, 10.614960429000035],
              [-6.435855671999917, 10.628706360000066],
              [-6.433995320999912, 10.667928772000039],
              [-6.427019002999913, 10.686093038000067],
              [-6.409810750999924, 10.694387106000107],
              [-6.388054971999907, 10.69552398700003],
              [-6.367539428999947, 10.692268372000044],
              [-6.341701211999919, 10.691441549000018],
              [-6.322219197999914, 10.700484925000069],
              [-6.303564005999874, 10.713171489000032],
              [-6.279999551999964, 10.723274231000062],
              [-6.255970011999921, 10.726478170000036],
              [-6.245841430999889, 10.720742086000072],
              [-6.244446166999893, 10.706866964000099],
              [-6.249458780999873, 10.665603332000089],
              [-6.246616576999884, 10.657619324000038],
              [-6.227754678999872, 10.650849711000092],
              [-6.2169026279999, 10.64508778900003],
              [-6.207807576999926, 10.637543030000074],
              [-6.204448607999922, 10.629610698000107],
              [-6.209771280999888, 10.617750957000098],
              [-6.219796508999906, 10.61185984300009],
              [-6.230700235999961, 10.606924744000054],
              [-6.238658406999917, 10.597984721000032],
              [-6.232870645999867, 10.584109599000058],
              [-6.230028441999877, 10.572043152000077],
              [-6.231372028999942, 10.56023508800007],
              [-6.237934935999931, 10.551941020000115],
              [-6.256228392999901, 10.537239075000116],
              [-6.260930948999885, 10.529151714000122],
              [-6.261292683999955, 10.514088033000036],
              [-6.256021687999947, 10.511607565000062],
              [-6.247650105999867, 10.513829651000066],
              [-6.238658406999917, 10.51274444600007],
              [-6.233490763999924, 10.50757680200006],
              [-6.228168090999873, 10.50057464600006],
              [-6.222432006999924, 10.494631857000044],
              [-6.215662393999878, 10.492616476000094],
              [-6.204190226999856, 10.49437347400007],
              [-6.196128702999971, 10.494683533000057],
              [-6.190289265999894, 10.491143698000087],
              [-6.185793416999957, 10.481325176000027],
              [-6.187498737999931, 10.47540822400012],
              [-6.198195759999919, 10.457398987000118],
              [-6.200366170999928, 10.448769023000082],
              [-6.196903848999881, 10.439157207000065],
              [-6.180574096999948, 10.420217794000024],
              [-6.195663614999944, 10.389211934000102],
              [-6.198764200999989, 10.370815125000092],
              [-6.183933064999849, 10.358852031000055],
              [-6.208324340999894, 10.331980286000146],
              [-6.207807576999926, 10.328517965000103],
              [-6.20537878399989, 10.32262685100011],
              [-6.203983520999913, 10.316038107000026],
              [-6.206153929999886, 10.310818787000102],
              [-6.214370483999915, 10.307795716000072],
              [-6.221140095999971, 10.310353699000075],
              [-6.225894327999868, 10.314487813000099],
              [-6.228323119999914, 10.316089783000038],
              [-6.240673787999867, 10.302576396000063],
              [-6.243309285999885, 10.289011333000076],
              [-6.240001993999897, 10.251933492000092],
              [-6.224809122999943, 10.255034078000051],
              [-6.21400874899993, 10.247851054000094],
              [-6.194320027999879, 10.22418324800006],
              [-6.180884154999916, 10.215837504000092],
              [-6.105333210999902, 10.18927581800007],
              [-6.015932982999914, 10.189870097000039],
              [-5.997122762999908, 10.208189392000108],
              [-5.985237182999867, 10.227283834000104],
              [-5.978312540999895, 10.248626200000103],
              [-5.974746866999908, 10.273637594000093],
              [-5.963016316999926, 10.282732645000067],
              [-5.916404174999883, 10.26663543700009],
              [-5.9047253009999, 10.275291239000055],
              [-5.908962767999952, 10.33006825800004],
              [-5.904828653999914, 10.348284201000084],
              [-5.893304809999989, 10.365027364000127],
              [-5.878060261999849, 10.376060283000115],
              [-5.80628169799985, 10.413474020000095],
              [-5.677555704999861, 10.44150848400011],
              [-5.621796834999913, 10.446934510000077],
              [-5.594046589999891, 10.45393666600009],
              [-5.584383097999961, 10.454246725000075],
              [-5.571722371999925, 10.449880066000077],
              [-5.549708211999928, 10.435643209000105],
              [-5.522578084999878, 10.42548879000006],
              [-5.505111449999902, 10.415566915000056],
              [-5.48748978699993, 10.392932638000019],
              [-5.475294148999922, 10.367714539000062],
              [-5.474157267999914, 10.350325419000043],
              [-5.459946248999927, 10.345157776000036],
              [-5.453021606999869, 10.343943380000098],
              [-5.443771525999864, 10.343529969000087],
              [-5.437828734999925, 10.340015971000128],
              [-5.433487915999962, 10.331876933000032],
              [-5.430077270999931, 10.322936910000095],
              [-5.426976684999886, 10.316864929000047],
              [-5.416227986999957, 10.307537333000099],
              [-5.402533731999938, 10.300561015000113],
              [-5.385738891999893, 10.296478577000101],
              [-5.365533406999901, 10.295703431000092],
              [-5.360830850999918, 10.29875234000012],
              [-5.357058471999892, 10.304385071000056],
              [-5.353337768999978, 10.308260804000014],
              [-5.348170124999882, 10.30598704100008],
              [-5.343777628999874, 10.303093160000103],
              [-5.338506632999952, 10.302214661000065],
              [-5.327086140999938, 10.302576396000063],
              [-5.315510619999912, 10.305263570000093],
              [-5.309206094999894, 10.311490580000083],
              [-5.304141804999915, 10.31841522300006],
              [-5.296648721999873, 10.323040263000024],
              [-5.279802204999896, 10.322420146000056],
              [-5.233551797999922, 10.315676371000023],
              [-5.217583780999888, 10.319939677000079],
              [-5.168439493999927, 10.291336772000108],
              [-5.159499470999918, 10.292318624000075],
              [-5.152058064999892, 10.305625305000092],
              [-5.135676635999943, 10.304281718000112],
              [-5.11988239199988, 10.293983277000052],
              [-5.119191853999951, 10.293533020000012],
              [-5.111802123999951, 10.278650208000059],
              [-5.111802123999951, 10.223718160000132],
              [-5.114411783999856, 10.218292134000066],
              [-5.118210001999898, 10.212478536000077],
              [-5.117073120999891, 10.208034363000067],
              [-5.104903319999977, 10.206949158000072],
              [-5.097849487999952, 10.209274597000018],
              [-5.091906696999928, 10.214338887000082],
              [-5.087333333999908, 10.220824280000045],
              [-5.084413614999903, 10.22743886400005],
              [-5.08159724999993, 10.20689748100007],
              [-5.09014969899988, 10.188810730000057],
              [-5.090718139999922, 10.177932841000086],
              [-5.063949747999857, 10.179043885000098],
              [-5.070719360999902, 10.161008809000094],
              [-5.06472489499987, 10.150802714000122],
              [-5.039455118999882, 10.134343770000058],
              [-5.037594767999877, 10.126488953000106],
              [-5.061030028999937, 10.118453268000039],
              [-5.07009924299993, 10.110159200000084],
              [-5.061701822999851, 10.110055847000055],
              [-5.055138916999852, 10.108040467000095],
              [-5.049376993999886, 10.105353292000075],
              [-5.042865762999924, 10.103337911000025],
              [-5.056482503999916, 10.097110901000036],
              [-5.04834346599992, 10.085354512000038],
              [-5.037233031999989, 10.083752544000106],
              [-5.025528320999911, 10.088739319000055],
              [-5.015580607999908, 10.097110901000036],
              [-5.01051631699994, 10.079049988000122],
              [-4.999793456999925, 10.069464010000033],
              [-4.986641805999852, 10.063262838000043],
              [-4.974523681999955, 10.055537211000043],
              [-4.963335733999912, 10.040318502000105],
              [-4.956411091999939, 10.021999207000121],
              [-4.960209309999868, 10.008485819000057],
              [-4.981396646999912, 10.007736511000047],
              [-4.976926634999899, 9.99760793100009],
              [-4.96571284999996, 9.98311269100006],
              [-4.954809122999905, 9.959703268000098],
              [-4.9529487719999, 9.95337290500008],
              [-4.967314819999899, 9.912367656000043],
              [-4.966074584999944, 9.90102467900006],
              [-4.936670694999862, 9.873997904000106],
              [-4.928014892999926, 9.870948995000077],
              [-4.922356322999889, 9.877460226000053],
              [-4.917085326999938, 9.886477763000102],
              [-4.909385538999857, 9.89105112700014],
              [-4.898016723999945, 9.888906555000062],
              [-4.893495035999933, 9.884204],
              [-4.890058552999903, 9.879501445000102],
              [-4.881738647999924, 9.877408549000037],
              [-4.858329223999874, 9.875703227000074],
              [-4.838459634999879, 9.869450378000082],
              [-4.824274454999937, 9.85697052000009],
              [-4.81755651799989, 9.836454976000113],
              [-4.798462076999925, 9.842526958000064],
              [-4.790323038999901, 9.827514953000076],
              [-4.785413777999878, 9.804829],
              [-4.775905313999885, 9.78800832100005],
              [-4.791899169999937, 9.782349752000101],
              [-4.800399942999945, 9.781109518000079],
              [-4.810115111999892, 9.78178131100006],
              [-4.810115111999892, 9.774339905000133],
              [-4.801226765999957, 9.766459249000093],
              [-4.79931473799985, 9.762531840000122],
              [-4.796446695999862, 9.75449615500014],
              [-4.783191690999956, 9.758371887000095],
              [-4.76996252399988, 9.737365418000081],
              [-4.754769653999858, 9.740207622000057],
              [-4.760454061, 9.745323588000048],
              [-4.762133544999926, 9.749948629000102],
              [-4.758593709999985, 9.753307597000116],
              [-4.74864599599988, 9.75449615500014],
              [-4.738336547999978, 9.753152568000075],
              [-4.733323933999912, 9.74963857000003],
              [-4.730016642999914, 9.744238383000052],
              [-4.724383911999894, 9.737107035000108],
              [-4.71280838999985, 9.726849264000037],
              [-4.709087686999936, 9.720312195000062],
              [-4.707640747999932, 9.70977020300009],
              [-4.705470336999952, 9.702096253000107],
              [-4.700095987999902, 9.697910462000067],
              [-4.686608439999929, 9.692406922000075],
              [-4.681544148999933, 9.686722514000039],
              [-4.681802530999903, 9.68284678100008],
              [-4.681079060999906, 9.68207163500007],
              [-4.672914184999911, 9.685585633000116],
              [-4.664826822999913, 9.690856628000049],
              [-4.658263915999925, 9.69760040300008],
              [-4.65472408099987, 9.703543193000101],
              [-4.655809284999862, 9.70607533800009],
              [-4.641107339999877, 9.706023661000074],
              [-4.628730834999885, 9.707703145000039],
              [-4.616948608999905, 9.713852641000102],
              [-4.604029499999882, 9.727159322000105],
              [-4.592712360999911, 9.717831727000075],
              [-4.578320475999902, 9.696515198000085],
              [-4.566719115999945, 9.692406922000075],
              [-4.552198038999904, 9.696463522000073],
              [-4.548425658999889, 9.706798808000087],
              [-4.547960570999862, 9.720260518000131],
              [-4.543051310999914, 9.73400645000008],
              [-4.539899047999967, 9.740776062000108],
              [-4.539098063999859, 9.74470347100008],
              [-4.535945800999883, 9.7466154990001],
              [-4.517781534999955, 9.7466154990001],
              [-4.509952554999927, 9.745065206000078],
              [-4.503958089999884, 9.742016297000049],
              [-4.501606810999959, 9.737107035000108],
              [-4.50382889899987, 9.719898783000048],
              [-4.513647420999916, 9.69400889100011],
              [-4.51592118399995, 9.675689595000037],
              [-4.501710163999888, 9.655019023000108],
              [-4.469205688999864, 9.651763407000118],
              [-4.43336808299992, 9.653468730000085],
              [-4.409105997999916, 9.647732646000037],
              [-4.400165974999908, 9.633134054000067],
              [-4.391587687999959, 9.600293681000053],
              [-4.38486975099994, 9.589415792000082],
              [-4.371175495999921, 9.582956238000037],
              [-4.367816528999896, 9.591973775000085],
              [-4.368023233999878, 9.608381043000051],
              [-4.365026001999951, 9.624168193000031],
              [-4.349678099999977, 9.620034078000103],
              [-4.322547973999917, 9.608897807000076],
              [-4.322476993999885, 9.608980710000097],
              [-4.315933390999902, 9.616623434000076],
              [-4.30298844399988, 9.641712341000101],
              [-4.300482137999921, 9.654295553000026],
              [-4.303453531999907, 9.677911682000044],
              [-4.303298502999979, 9.686722514000039],
              [-4.297794961999983, 9.695843404000101],
              [-4.267512572999863, 9.727262675000048],
              [-4.279191446999931, 9.731138408000092],
              [-4.283635620999917, 9.732016907000045],
              [-4.27032893899991, 9.74392832500007],
              [-4.253094848999922, 9.750051982000045],
              [-4.215422729999887, 9.75485789000004],
              [-4.196974242999886, 9.764960633000086],
              [-4.168293823999903, 9.804829],
              [-4.150258747999885, 9.818290711000074],
              [-4.133050496999914, 9.820409444000049],
              [-4.07615474499994, 9.803795471000043],
              [-4.065716104999922, 9.798085226000083],
              [-4.05987666799993, 9.79627655100009],
              [-4.053675496999858, 9.797620138000056],
              [-4.051711791999907, 9.80234853100005],
              [-4.051350056999922, 9.807567851000059],
              [-4.050316528999929, 9.810306702000105],
              [-4.034968627999973, 9.81761891700009],
              [-4.026674560999908, 9.82030609100012],
              [-3.994609333999904, 9.820771179000047],
              [-3.988253133999876, 9.834801331000065],
              [-3.984041503999919, 9.851156921000012],
              [-3.969184529999893, 9.85898590100004],
              [-3.947738809999862, 9.86436025000009],
              [-3.91009252899994, 9.888493144000051],
              [-3.891624633999925, 9.893900095000049],
              [-3.889706176999908, 9.89446177200007],
              [-3.823482828999914, 9.895702006000107],
              [-3.80425919599989, 9.901386414000058],
              [-3.795758422999882, 9.90766510000006],
              [-3.779738728999916, 9.92469248500008],
              [-3.769610147999884, 9.931332906000094],
              [-3.755037394999903, 9.935880433000122],
              [-3.706461547999908, 9.941823222000039],
              [-3.698994302999893, 9.940789693000056],
              [-3.68594600499992, 9.933451640000072],
              [-3.67964147999993, 9.932211405000118],
              [-3.674318806999878, 9.935260315000065],
              [-3.665042887999959, 9.946603292000134],
              [-3.661658080999928, 9.948928731000066],
              [-3.648170531999881, 9.944587911000085],
              [-3.64054825799991, 9.937379048000125],
              [-3.63401118999991, 9.92924001000003],
              [-3.623340006999911, 9.92174692800009],
              [-3.606260945999878, 9.918181254000018],
              [-3.546471313999945, 9.926139425000073],
              [-3.389168253999912, 9.913246155000081],
              [-3.376559203999875, 9.908491923000085],
              [-3.359015055999919, 9.892498068000037],
              [-3.348343871999901, 9.886994527000041],
              [-3.339248819999852, 9.890095113000086],
              [-3.327518269999956, 9.897303976000046],
              [-3.317182983999942, 9.901334737000042],
              [-3.312738809999928, 9.894513449000087],
              [-3.313565632999939, 9.874566345000062],
              [-3.311808634999892, 9.854128316000114],
              [-3.301731730999933, 9.841131694000083],
              [-3.277857218999941, 9.843457133000115],
              [-3.264059610999908, 9.857073873000019],
              [-3.230237385999914, 9.904719543000056],
              [-3.214760294999905, 9.915623271000115],
              [-3.202564656999897, 9.908233541000115],
              [-3.202228759999912, 9.888958232000078],
              [-3.204399169999903, 9.865367941000073],
              [-3.200006673999894, 9.845369161000036],
              [-3.182565877999878, 9.835163066000064],
              [-3.16011246799988, 9.834697978000037],
              [-3.136935587999858, 9.829530335000129],
              [-3.116910969999935, 9.805294088000053],
              [-3.104379435999931, 9.757131653000059],
              [-3.094560912999953, 9.733851420000036],
              [-3.077094278999908, 9.71940785800011],
              [-3.059059203999908, 9.718555196000082],
              [-3.024642699999958, 9.728606262000099],
              [-3.005677449999894, 9.724162090000092],
              [-2.989993651999924, 9.708426616000025],
              [-2.977823852999933, 9.685172221000101],
              [-2.959892130999947, 9.638611755000056],
              [-2.91015356499986, 9.542726136000098],
              [-2.810418049999953, 9.411106262000132],
              [-2.787602905999933, 9.393717143000117],
              [-2.763676717999942, 9.391882629000108],
              [-2.744918171999956, 9.408109030000034],
              [-2.720475219999912, 9.459217020000025],
              [-2.68921097799992, 9.488724263000037],
              [-2.675671752999932, 9.471722718000109],
              [-2.674586547999951, 9.457485861000052],
              [-2.678668986999867, 9.425549825000061],
              [-2.677377074999896, 9.41777252200005],
              [-2.67241613799996, 9.4010035190001],
              [-2.67241613799996, 9.374028422000066],
              [-2.677532104999926, 9.357001038000135],
              [-2.689417683999864, 9.34953379400011],
              [-2.70306026199998, 9.343255107000104],
              [-2.713343871999882, 9.329922587000084],
              [-2.714997517999933, 9.311060689000058],
              [-2.707142700999896, 9.295635275000066],
              [-2.692983357999935, 9.285325826000062],
              [-2.675516722999902, 9.281501771000123],
              [-2.659807087999923, 9.272897645000086],
              [-2.661150674999902, 9.253906556000032],
              [-2.67308793199993, 9.234889628000062],
              [-2.70481726099996, 9.218404847000087],
              [-2.716496134999915, 9.200266418000055],
              [-2.733911091999857, 9.164842225000129],
              [-2.755201781999858, 9.143138123000128],
              [-2.759387572999884, 9.134818217000074],
              [-2.761299601999895, 9.084795431000074],
              [-2.765433715999933, 9.06911163300012],
              [-2.774838826999883, 9.054978129000077],
              [-2.76507198099992, 9.049474589000084],
              [-2.758664102999887, 9.042860006000083],
              [-2.750809284999946, 9.037408142000103],
              [-2.736960001999904, 9.035134379000084],
              [-2.711328491999922, 9.033894145000147],
              [-2.686058715999962, 9.028261414000028],
              [-2.660788940999907, 9.014903056000094],
              [-2.654329386999933, 8.998831685000113],
              [-2.653295857999865, 8.978393657000069],
              [-2.637689574999911, 8.931471456000025],
              [-2.631746785999894, 8.926975607000102],
              [-2.625028848999875, 8.925993754000032],
              [-2.619447793999967, 8.923616639000088],
              [-2.617174031999951, 8.91501251300005],
              [-2.615933796999911, 8.897830099000075],
              [-2.595573282999879, 8.828066915000122],
              [-2.596658487999974, 8.81439849900002],
              [-2.60725215599993, 8.808559062000114],
              [-2.614641886999948, 8.801918640000025],
              [-2.617225707999864, 8.789180400000063],
              [-2.612381685999907, 8.781321221000027],
              [-2.612161417999886, 8.780963847000123],
              [-2.60311804199992, 8.785149638000064],
              [-2.598363809999938, 8.769465841000098],
              [-2.552345946999935, 8.489366659000098],
              [-2.506328083999932, 8.209267477000097],
              [-2.513201049999907, 8.194022929000056],
              [-2.558107869999901, 8.16769378700009],
              [-2.571750446999914, 8.163120422000063],
              [-2.583274291999942, 8.164334818000086],
              [-2.59598669499988, 8.17027760900001],
              [-2.604254923999918, 8.170794373000135],
              [-2.610662800999876, 8.164851583000114],
              [-2.617639118999875, 8.151493225000095],
              [-2.621876586999917, 8.135731913000114],
              [-2.619447793999967, 8.123097026000082],
              [-2.60621862799988, 8.094313253000067],
              [-2.599759073999905, 8.070387064000059],
              [-2.600689249999959, 8.052946269000117],
              [-2.610559447999947, 8.040001322000094],
              [-2.631178344999853, 8.029588521000079],
              [-2.690864624999961, 8.009744772000076],
              [-2.70926143399987, 7.996722310000052],
              [-2.754891723999947, 7.944374084000117],
              [-2.771221476999898, 7.930731507000104],
              [-2.772616739999876, 7.933935446000078],
              [-2.777681030999958, 7.939619853000124],
              [-2.784347289999857, 7.944012349000033],
              [-2.790625976999877, 7.943288880000125],
              [-2.793545694999864, 7.935950826000038],
              [-2.797886515999949, 7.861278381000133],
              [-2.801193806999947, 7.850219625000136],
              [-2.809151976999914, 7.841693014000029],
              [-2.831398680999939, 7.828360494],
              [-2.840002806999877, 7.820247294000097],
              [-2.840829630999906, 7.815234681000035],
              [-2.83790991199993, 7.802263896000099],
              [-2.838168294999889, 7.796837870000033],
              [-2.84201818799994, 7.790274963000059],
              [-2.852069254999947, 7.778131002000052],
              [-2.85594498699993, 7.771568095000063],
              [-2.928162800999928, 7.617675679000058],
              [-2.941521158999876, 7.577161357000051],
              [-2.990458739999951, 7.270668437000069],
              [-2.989528564999915, 7.258937887000087],
              [-2.983224039999897, 7.244985250000084],
              [-2.976531941999895, 7.236717021000047],
              [-2.97208776899987, 7.228603821000135],
              [-2.972811237999878, 7.214961243000033],
              [-2.981699584999888, 7.195530905000055],
              [-3.027536579999946, 7.138428447000138],
              [-3.032600870999914, 7.128351542000104],
              [-3.040869099999952, 7.078328755000101],
              [-3.045933390999949, 7.07124908500009],
              [-3.095465249999904, 7.055177714000109],
              [-3.096592622999907, 7.054476971000042],
              [-3.097274113999902, 7.05405337500008],
              [-3.109598754999922, 7.046392721000132],
              [-3.224940551999879, 6.8494021610001],
              [-3.241683715999926, 6.810903219000053],
              [-3.243078979999893, 6.774755554000123],
              [-3.238738158999922, 6.76462697400008],
              [-3.226232462999917, 6.748581441000113],
              [-3.21274491399987, 6.722665711000076],
              [-3.210419474999924, 6.715999451000059],
              [-3.230056518999959, 6.661119080000049],
              [-3.23548254399995, 6.654582011000073],
              [-3.253905191999934, 6.644427592000113],
              [-3.261114053999904, 6.633937277000072],
              [-3.262509317999985, 6.617142436000094],
              [-3.183599405999928, 6.263908183000126],
              [-3.171721890999947, 6.249584688000084],
              [-3.168794107999929, 6.24605397600007],
              [-3.139364379999932, 6.219285584000104],
              [-3.118073689999932, 6.16347503700004],
              [-3.087765462999897, 5.996689352000118],
              [-3.073244384999953, 5.960955099000017],
              [-3.034719604999907, 5.890700989000024],
              [-3.02252396699987, 5.854501648000081],
              [-3.019965982999878, 5.818353984000069],
              [-3.029758666999953, 5.704252421000064],
              [-2.964801390999895, 5.709781799000069],
              [-2.974904133999928, 5.647279155000078],
              [-2.969503946999879, 5.621440938000063],
              [-2.945861978999858, 5.60828928700009],
              [-2.926302449999923, 5.610718078000048],
              [-2.893746296999893, 5.630355123000086],
              [-2.877494059999975, 5.636814677000046],
              [-2.806258097999915, 5.618495382000063],
              [-2.793442341999935, 5.608134257000046],
              [-2.785587524999897, 5.595034282000086],
              [-2.781815144999882, 5.578885397000093],
              [-2.77943802899992, 5.52648549400007],
              [-2.761713012999905, 5.454913636000114],
              [-2.734427855999911, 5.391144918000094],
              [-2.730138712999945, 5.373161520000096],
              [-2.732670857999921, 5.355720724000065],
              [-2.742592732999924, 5.343137512000055],
              [-2.755873575999914, 5.34070872000008],
              [-2.789566608999877, 5.346858216000058],
              [-2.796129515999951, 5.284975688000131],
              [-2.793287312999894, 5.271100566000072],
              [-2.779334675999905, 5.251075948000036],
              [-2.774890502999909, 5.239577942000011],
              [-2.775407267999924, 5.231025492000086],
              [-2.779644734999891, 5.210122376000101],
              [-2.77881791199988, 5.201001486000038],
              [-2.775665648999905, 5.197539164000091],
              [-2.762488158999929, 5.186299540000036],
              [-2.757010456999922, 5.179865825000078],
              [-2.766622272999939, 5.161029765000066],
              [-2.780884968999914, 5.150875346000106],
              [-2.803855142999879, 5.147568054000104],
              [-2.843698696999923, 5.149115302000041],
              [-2.846180792999917, 5.176988023000092],
              [-2.879383917999917, 5.181341864000046],
              [-2.920399542999917, 5.17649974200009],
              [-2.946685350999928, 5.177069403000075],
              [-2.938465949999909, 5.156927802000041],
              [-2.943511522999927, 5.136786200000074],
              [-2.957997199999909, 5.121161200000074],
              [-2.977772589999915, 5.114976304000038],
              [-2.993397589999915, 5.119533596000053],
              [-3.046294725999928, 5.144110419000071],
              [-3.06281490799995, 5.156642971000053],
              [-3.082753058999913, 5.151068427000041],
              [-3.122385219999956, 5.149969794000071],
              [-3.139149542999917, 5.142320054000038],
              [-3.146839972999942, 5.161322333000044],
              [-3.162464972999942, 5.184149481000077],
              [-3.180897589999915, 5.203192450000074],
              [-3.196888800999943, 5.211167710000041],
              [-3.205067511999914, 5.218654690000051],
              [-3.194325324999909, 5.234442450000074],
              [-3.178822394999941, 5.248846747000073],
              [-3.172718878999945, 5.252183335000041],
              [-3.167958136999914, 5.266302802000041],
              [-3.165028449999909, 5.295884507000039],
              [-3.159087693999936, 5.307440497000073],
              [-3.145375128999945, 5.315985419000071],
              [-3.134755011999914, 5.318589585000041],
              [-3.127919074999909, 5.324896552000041],
              [-3.125477667999917, 5.344631252000056],
              [-3.127756313999953, 5.359605210000041],
              [-3.134429490999935, 5.366766669000071],
              [-3.146066860999952, 5.368841864000046],
              [-3.16274980399993, 5.368841864000046],
              [-3.167388475999928, 5.36664459800005],
              [-3.173329230999911, 5.361761786000045],
              [-3.180734829999949, 5.356838283000059],
              [-3.18976803299995, 5.354641018000052],
              [-3.198109503999945, 5.355902411000045],
              [-3.211822068999936, 5.361476955000057],
              [-3.220529751999948, 5.36204661700009],
              [-3.230213995999918, 5.358628648000092],
              [-3.249419725999928, 5.345363674000055],
              [-3.262074347999942, 5.340887762000079],
              [-3.252064581999946, 5.318101304000038],
              [-3.246937628999945, 5.29759349200009],
              [-3.254302537999934, 5.283596096000053],
              [-3.282622850999928, 5.280178127000056],
              [-3.278187628999945, 5.272528387000079],
              [-3.278187628999945, 5.265448309000078],
              [-3.282134568999936, 5.258734442000048],
              [-3.289418097999942, 5.252183335000041],
              [-3.280262824999909, 5.246161200000074],
              [-3.275786912999934, 5.24477773600006],
              [-3.282622850999928, 5.24477773600006],
              [-3.273060675999943, 5.241156317000048],
              [-3.262806769999941, 5.238836981000077],
              [-3.252023891999954, 5.237860419000071],
              [-3.240956183999913, 5.238511460000041],
              [-3.240956183999913, 5.231675523000092],
              [-3.250396287999934, 5.227362372000073],
              [-3.265695766999954, 5.228705145000049],
              [-3.275786912999934, 5.225490627000056],
              [-3.284291144999941, 5.21906159100007],
              [-3.291981574999909, 5.210516669000071],
              [-3.298329230999911, 5.200669664000088],
              [-3.30304928299995, 5.190130927000041],
              [-3.313588019999941, 5.197251695000091],
              [-3.320708787999934, 5.193508205000057],
              [-3.31899980399993, 5.184800523000092],
              [-3.30304928299995, 5.177069403000075],
              [-3.308990037999934, 5.163763739000046],
              [-3.303089972999942, 5.15570709800005],
              [-3.290516730999911, 5.151353257000039],
              [-3.275786912999934, 5.149115302000041],
              [-3.312163865999935, 5.119940497000073],
              [-3.378041144999941, 5.123195705000057],
              [-3.631988084999932, 5.177069403000075],
              [-3.678537563999953, 5.179836330000057],
              [-3.710113084999932, 5.186102606000077],
              [-3.718006964999915, 5.188706773000092],
              [-3.721424933999913, 5.193833726000094],
              [-3.719634568999936, 5.203111070000091],
              [-3.717274542999917, 5.210191148000092],
              [-3.718902147999927, 5.217027085000041],
              [-3.728871222999942, 5.225490627000056],
              [-3.721424933999913, 5.238511460000041],
              [-3.731678839999915, 5.230047919000071],
              [-3.739654100999928, 5.21710846600007],
              [-3.745228644999941, 5.202704169000071],
              [-3.748036261999914, 5.190130927000041],
              [-3.755523240999935, 5.190130927000041],
              [-3.767486131999931, 5.197007554000038],
              [-3.786854620999918, 5.198960679000038],
              [-3.827504035999937, 5.19757721600007],
              [-3.840891079999949, 5.201157945000091],
              [-3.885853644999941, 5.225490627000056],
              [-3.955799933999913, 5.234564520000049],
              [-3.987049933999913, 5.243963934000078],
              [-4.001942511999914, 5.266506252000056],
              [-3.983387824999909, 5.260321356000077],
              [-3.962310350999928, 5.26243724200009],
              [-3.943837042999917, 5.27179596600007],
              [-3.932972785999937, 5.286932684000078],
              [-3.918446417999917, 5.26898834800005],
              [-3.911284959999932, 5.261867580000057],
              [-3.902902798999946, 5.258978583000044],
              [-3.896351691999939, 5.261542059000078],
              [-3.893666144999941, 5.267482815000051],
              [-3.89484615799995, 5.274481512000079],
              [-3.899525519999941, 5.280178127000056],
              [-3.899525519999941, 5.286932684000078],
              [-3.885731574999909, 5.283880927000041],
              [-3.851185675999943, 5.269761460000041],
              [-3.844309048999946, 5.269598700000074],
              [-3.834136522999927, 5.272853908000059],
              [-3.811634894999941, 5.264105536000045],
              [-3.775380011999914, 5.24477773600006],
              [-3.777740037999934, 5.251206773000092],
              [-3.779449022999927, 5.26117584800005],
              [-3.782215949999909, 5.266506252000056],
              [-3.766672329999949, 5.266058661000045],
              [-3.739816860999952, 5.262396552000041],
              [-3.728871222999942, 5.266506252000056],
              [-3.715687628999945, 5.282294012000079],
              [-3.721913214999915, 5.291001695000091],
              [-3.734771287999934, 5.298529364000046],
              [-3.741851365999935, 5.310532945000091],
              [-3.753325975999928, 5.343817450000074],
              [-3.755523240999935, 5.358343817000048],
              [-3.758900519999941, 5.366197007000039],
              [-3.767241990999935, 5.371527411000045],
              [-3.778146938999953, 5.372788804000038],
              [-3.788970506999931, 5.368841864000046],
              [-3.795521613999938, 5.373195705000057],
              [-3.80492102799991, 5.375962632000039],
              [-3.813303188999953, 5.374416408000059],
              [-3.816965298999946, 5.365464585000041],
              [-3.814035610999952, 5.359808661000045],
              [-3.792713995999918, 5.344631252000056],
              [-3.767404751999948, 5.310614325000074],
              [-3.752349412999934, 5.294582424000055],
              [-3.73501542899993, 5.286932684000078],
              [-3.743967251999948, 5.273993231000077],
              [-3.759429490999935, 5.275376695000091],
              [-3.776275193999936, 5.279038804000038],
              [-3.788970506999931, 5.272691148000092],
              [-3.796498175999943, 5.272691148000092],
              [-3.808990037999934, 5.287787177000041],
              [-3.818348761999914, 5.291693427000041],
              [-3.828684048999946, 5.291205145000049],
              [-3.844309048999946, 5.293158270000049],
              [-3.854888475999928, 5.296861070000091],
              [-3.866688605999911, 5.303615627000056],
              [-3.875884568999936, 5.313421942000048],
              [-3.878407355999911, 5.326646226000094],
              [-3.883168097999942, 5.322211005000042],
              [-3.889149542999917, 5.317775783000059],
              [-3.891997850999928, 5.313625393000052],
              [-3.896148240999935, 5.321844794000071],
              [-3.898833787999934, 5.329657294000071],
              [-3.900054490999935, 5.338039455000057],
              [-3.899525519999941, 5.34837474200009],
              [-3.906320766999954, 5.34837474200009],
              [-3.907704230999911, 5.33429596600007],
              [-3.912587042999917, 5.322211005000042],
              [-3.920969204999949, 5.316229559000078],
              [-3.932972785999937, 5.320461330000057],
              [-3.940744594999956, 5.314601955000057],
              [-3.951649542999917, 5.312933661000045],
              [-3.96353105399993, 5.314927476000094],
              [-3.974598761999914, 5.320461330000057],
              [-3.997954881999931, 5.316839911000045],
              [-4.009348110999952, 5.313625393000052],
              [-3.999623175999943, 5.304632880000042],
              [-3.983998175999943, 5.300930080000057],
              [-3.96743730399993, 5.301947333000044],
              [-3.954741990999935, 5.307440497000073],
              [-3.940541144999941, 5.293158270000049],
              [-3.953846808999913, 5.282904364000046],
              [-3.97101803299995, 5.273016669000071],
              [-3.989084438999953, 5.269110419000071],
              [-4.005604620999918, 5.276434637000079],
              [-4.018137173999946, 5.283636786000045],
              [-4.040028449999909, 5.293402411000045],
              [-4.060902472999942, 5.29954661700009],
              [-4.070220506999931, 5.296576239000046],
              [-4.078521287999934, 5.287787177000041],
              [-4.096913214999915, 5.292669989000046],
              [-4.125477667999917, 5.307440497000073],
              [-4.138742641999954, 5.303412177000041],
              [-4.149403449999909, 5.296576239000046],
              [-4.160145636999914, 5.293402411000045],
              [-4.173898891999954, 5.299994208000044],
              [-4.179676886999914, 5.294175523000092],
              [-4.18618730399993, 5.294094143000052],
              [-4.193267381999931, 5.298814195000091],
              [-4.200550910999937, 5.307440497000073],
              [-4.227772589999915, 5.289048570000091],
              [-4.241037563999953, 5.28392161700009],
              [-4.255767381999931, 5.286932684000078],
              [-4.253773566999939, 5.291489976000094],
              [-4.250884568999936, 5.302964585000041],
              [-4.248931443999936, 5.307440497000073],
              [-4.274566209999932, 5.312404690000051],
              [-4.285633917999917, 5.310532945000091],
              [-4.297352667999917, 5.299994208000044],
              [-4.304798956999946, 5.306830145000049],
              [-4.313832160999937, 5.311224677000041],
              [-4.321441209999932, 5.310980536000045],
              [-4.327626105999911, 5.29523346600007],
              [-4.343495245999918, 5.282619533000059],
              [-4.351307745999918, 5.272691148000092],
              [-4.358469204999949, 5.28001536700009],
              [-4.370472785999937, 5.289211330000057],
              [-4.383290167999917, 5.297023830000057],
              [-4.392404751999948, 5.299994208000044],
              [-4.402902798999946, 5.294338283000059],
              [-4.413400844999956, 5.285060940000051],
              [-4.423817511999914, 5.28156159100007],
              [-4.43390865799995, 5.293158270000049],
              [-4.430897589999915, 5.295396226000094],
              [-4.429676886999914, 5.29564036700009],
              [-4.428700324999909, 5.296372789000088],
              [-4.426503058999913, 5.299994208000044],
              [-4.46353105399993, 5.298244533000059],
              [-4.477691209999932, 5.29132721600007],
              [-4.481678839999915, 5.272691148000092],
              [-4.472157355999911, 5.277492580000057],
              [-4.463775193999936, 5.27610911700009],
              [-4.457386847999942, 5.269598700000074],
              [-4.453724738999938, 5.258978583000044],
              [-4.472767706999946, 5.263373114000046],
              [-4.543771938999953, 5.266506252000056],
              [-4.547678188999953, 5.27602773600006],
              [-4.552479620999918, 5.284491278000075],
              [-4.563628709999932, 5.299994208000044],
              [-4.569325324999909, 5.290432033000059],
              [-4.569691535999937, 5.282538153000075],
              [-4.565541144999941, 5.276516018000052],
              [-4.557484503999945, 5.272691148000092],
              [-4.557484503999945, 5.266506252000056],
              [-4.575510219999956, 5.263006903000075],
              [-4.589182094999956, 5.25657786700009],
              [-4.612131313999953, 5.238511460000041],
              [-4.630604620999918, 5.250555731000077],
              [-4.651966925999943, 5.249172268000052],
              [-4.67056230399993, 5.240708726000094],
              [-4.680287238999938, 5.231675523000092],
              [-4.687163865999935, 5.231675523000092],
              [-4.693837042999917, 5.234605210000041],
              [-4.702463344999956, 5.239894924000055],
              [-4.710194464999915, 5.246161200000074],
              [-4.714466925999943, 5.252183335000041],
              [-4.702788865999935, 5.257391669000071],
              [-4.693023240999935, 5.256252346000053],
              [-4.682118292999917, 5.252997137000079],
              [-4.667307094999956, 5.252183335000041],
              [-4.669422980999911, 5.261867580000057],
              [-4.672596808999913, 5.268052476000094],
              [-4.678130662999934, 5.271389065000051],
              [-4.687163865999935, 5.272691148000092],
              [-4.687163865999935, 5.280178127000056],
              [-4.676909959999932, 5.284816799000055],
              [-4.670399542999917, 5.291896877000056],
              [-4.667307094999956, 5.301459052000041],
              [-4.667307094999956, 5.313625393000052],
              [-4.673451300999943, 5.313625393000052],
              [-4.68578040299991, 5.290594794000071],
              [-4.702504035999937, 5.278306382000039],
              [-4.723622199999909, 5.273504950000074],
              [-4.749256964999915, 5.272691148000092],
              [-4.722157355999911, 5.25226471600007],
              [-4.742176886999914, 5.234564520000049],
              [-4.779367641999954, 5.218898830000057],
              [-4.803822394999941, 5.204413153000075],
              [-4.810047980999911, 5.189927476000094],
              [-4.808583136999914, 5.180487372000073],
              [-4.799549933999913, 5.174505927000041],
              [-4.783355272999927, 5.170314846000053],
              [-4.765451626999948, 5.169338283000059],
              [-4.747670050999943, 5.172349351000094],
              [-4.737456834999932, 5.179348049000055],
              [-4.74242102799991, 5.190130927000041],
              [-4.74242102799991, 5.19757721600007],
              [-4.717152472999942, 5.204413153000075],
              [-4.704741990999935, 5.211330471000053],
              [-4.700306769999941, 5.206732489000046],
              [-4.695383266999954, 5.200181382000039],
              [-4.687163865999935, 5.19757721600007],
              [-4.674794074999909, 5.200669664000088],
              [-4.65453040299991, 5.209418036000045],
              [-4.639393683999913, 5.211167710000041],
              [-4.608306443999936, 5.211167710000041],
              [-4.598866339999915, 5.209173895000049],
              [-4.592518683999913, 5.204779364000046],
              [-4.58820553299995, 5.200140692000048],
              [-4.584787563999953, 5.19757721600007],
              [-4.569935675999943, 5.195502020000049],
              [-4.559559699999909, 5.196966864000046],
              [-4.536366339999915, 5.204413153000075],
              [-4.546701626999948, 5.203192450000074],
              [-4.55882727799991, 5.204169012000079],
              [-4.568348761999914, 5.208726304000038],
              [-4.571034308999913, 5.218003648000092],
              [-4.564930792999917, 5.223211981000077],
              [-4.530140753999945, 5.231675523000092],
              [-4.530140753999945, 5.218003648000092],
              [-4.522694464999915, 5.218003648000092],
              [-4.500599738999938, 5.228705145000049],
              [-4.44163977799991, 5.225043036000045],
              [-4.412831183999913, 5.238511460000041],
              [-4.408070441999939, 5.223618882000039],
              [-4.400298631999931, 5.229681708000044],
              [-4.392079230999911, 5.243557033000059],
              [-4.385568813999953, 5.252183335000041],
              [-4.367258266999954, 5.251695054000038],
              [-4.351673956999946, 5.244370835000041],
              [-4.337757941999939, 5.24087148600006],
              [-4.324696417999917, 5.252183335000041],
              [-4.305816209999932, 5.244574286000045],
              [-4.286284959999932, 5.247870184000078],
              [-4.26626542899993, 5.255031643000052],
              [-4.225209113999938, 5.26235586100006],
              [-4.199574347999942, 5.276841539000088],
              [-4.18382727799991, 5.280178127000056],
              [-4.060454881999931, 5.283351955000057],
              [-4.029204881999931, 5.272691148000092],
              [-4.038563605999911, 5.268377997000073],
              [-4.048573370999918, 5.266180731000077],
              [-4.059193488999938, 5.265692450000074],
              [-4.070220506999931, 5.266506252000056],
              [-3.995757615999935, 5.231675523000092],
              [-4.308135545999932, 5.206203517500086],
              [-4.620513475999928, 5.180731512000079],
              [-4.784657355999911, 5.143947658000059],
              [-4.875355597999942, 5.136216539000088],
              [-4.892648891999954, 5.128648179000038],
              [-4.903472459999932, 5.134344794000071],
              [-4.915191209999932, 5.136379299000055],
              [-4.969105597999942, 5.137396552000041],
              [-4.982004360999952, 5.136135158000059],
              [-4.982004360999952, 5.142320054000038],
              [-4.97874915299991, 5.142564195000091],
              [-4.972157355999911, 5.14203522300005],
              [-4.96898352799991, 5.142320054000038],
              [-4.96898352799991, 5.149115302000041],
              [-4.997059699999909, 5.14874909100007],
              [-5.003773566999939, 5.160589911000045],
              [-5.003285285999937, 5.178778387000079],
              [-5.009917772999927, 5.19757721600007],
              [-4.997059699999909, 5.212795315000051],
              [-5.009755011999914, 5.216050523000092],
              [-5.064279751999948, 5.209214585000041],
              [-5.082142706999946, 5.203599351000094],
              [-5.098703579999949, 5.19476959800005],
              [-5.112294074999909, 5.183294989000046],
              [-5.129017706999946, 5.197699286000045],
              [-5.157866990999935, 5.212225653000075],
              [-5.191395636999914, 5.219224351000094],
              [-5.221587693999936, 5.211167710000041],
              [-5.225453253999945, 5.21548086100006],
              [-5.232329881999931, 5.220770575000074],
              [-5.234038865999935, 5.223049221000053],
              [-5.235829230999911, 5.225490627000056],
              [-5.242054816999939, 5.225490627000056],
              [-5.253041144999941, 5.214097398000092],
              [-5.270863410999937, 5.21938711100006],
              [-5.289906378999945, 5.227728583000044],
              [-5.304798956999946, 5.225490627000056],
              [-5.310943162999934, 5.225490627000056],
              [-5.321522589999915, 5.230210679000038],
              [-5.327259894999941, 5.226060289000088],
              [-5.328195766999954, 5.216457424000055],
              [-5.323963995999918, 5.204413153000075],
              [-5.327056443999936, 5.205511786000045],
              [-5.338286912999934, 5.211167710000041],
              [-5.337757941999939, 5.200669664000088],
              [-5.338286912999934, 5.19757721600007],
              [-5.330067511999914, 5.199896552000041],
              [-5.328521287999934, 5.196844794000071],
              [-5.32445227799991, 5.190781968000067],
              [-5.323963995999918, 5.190130927000041],
              [-5.316965298999946, 5.194159247000073],
              [-5.311512824999909, 5.195786851000094],
              [-5.297352667999917, 5.19757721600007],
              [-5.297352667999917, 5.190130927000041],
              [-5.30500240799995, 5.181626695000091],
              [-5.32843990799995, 5.170070705000057],
              [-5.338286912999934, 5.163478908000059],
              [-5.338286912999934, 5.183294989000046],
              [-5.352528449999909, 5.141831773000092],
              [-5.359364386999914, 5.128648179000038],
              [-5.39289303299995, 5.177069403000075],
              [-5.400380011999914, 5.177069403000075],
              [-5.400786912999934, 5.173976955000057],
              [-5.400380011999914, 5.163478908000059],
              [-5.413929816999939, 5.170314846000053],
              [-5.398996548999946, 5.141994533000059],
              [-5.357899542999917, 5.123521226000094],
              [-5.30882727799991, 5.118150132000039],
              [-5.269398566999939, 5.128648179000038],
              [-5.28547115799995, 5.140773830000057],
              [-5.302357550999943, 5.140448309000078],
              [-5.320139126999948, 5.137640692000048],
              [-5.338286912999934, 5.142320054000038],
              [-5.338286912999934, 5.149115302000041],
              [-5.328114386999914, 5.148504950000074],
              [-5.319935675999943, 5.149807033000059],
              [-5.312570766999954, 5.152573960000041],
              [-5.304798956999946, 5.156642971000053],
              [-5.29946855399993, 5.160956122000073],
              [-5.286854620999918, 5.174058335000041],
              [-5.283070441999939, 5.177069403000075],
              [-5.268137173999946, 5.173732815000051],
              [-5.251616990999935, 5.165432033000059],
              [-5.235463019999941, 5.161322333000044],
              [-5.221587693999936, 5.170314846000053],
              [-5.209339972999942, 5.16282786700009],
              [-5.197132941999939, 5.160142320000091],
              [-5.186919725999928, 5.164252020000049],
              [-5.180653449999909, 5.177069403000075],
              [-5.198963995999918, 5.174383856000077],
              [-5.207020636999914, 5.182440497000073],
              [-5.213775193999936, 5.193019924000055],
              [-5.228423631999931, 5.19757721600007],
              [-5.228423631999931, 5.204413153000075],
              [-5.214751756999931, 5.19757721600007],
              [-5.181385870999918, 5.202337958000044],
              [-5.120757615999935, 5.166978257000039],
              [-5.094960089999915, 5.173732815000051],
              [-5.080922003999945, 5.184759833000044],
              [-5.067738410999937, 5.18695709800005],
              [-5.033192511999914, 5.183294989000046],
              [-5.029123501999948, 5.175726630000042],
              [-5.023426886999914, 5.15851471600007],
              [-5.014881964999915, 5.14008209800005],
              [-5.002430792999917, 5.128648179000038],
              [-5.255360480999911, 5.121039130000042],
              [-5.294300910999937, 5.106024481000077],
              [-5.495676235999952, 5.095282294000071],
              [-5.524810350999928, 5.099798895000049],
              [-5.550526495999918, 5.114976304000038],
              [-5.57843990799995, 5.094549872000073],
              [-5.557687954999949, 5.088446356000077],
              [-5.550526495999918, 5.087713934000078],
              [-5.630238410999937, 5.06321849200009],
              [-5.851307745999918, 5.029974677000041],
              [-5.858672654999907, 5.027696031000062],
              [-5.971424933999913, 4.992621161000045],
              [-5.988433397999927, 4.983872789000088],
              [-5.995594855999911, 4.974758205000057],
              [-6.007435675999943, 4.97524648600006],
              [-6.059722459999932, 4.95579661700009],
              [-6.138579881999931, 4.915228583000044],
              [-6.412220831999946, 4.823879299000055],
              [-6.420765753999945, 4.81712474200009],
              [-6.426625128999945, 4.801988023000092],
              [-6.441517706999946, 4.793931382000039],
              [-6.54718990799995, 4.768011786000045],
              [-6.567860480999911, 4.765570380000042],
              [-6.583851691999939, 4.76040273600006],
              [-6.610747850999928, 4.734767971000053],
              [-6.626820441999939, 4.724595445000091],
              [-6.753325975999928, 4.687323309000078],
              [-6.853667772999927, 4.680609442000048],
              [-6.879505988999938, 4.667914130000042],
              [-6.903146938999953, 4.662014065000051],
              [-6.914173956999946, 4.65570709800005],
              [-6.942128058999913, 4.621568101000094],
              [-6.996001756999931, 4.57648346600007],
              [-7.058216925999943, 4.539007880000042],
              [-7.099191860999952, 4.526516018000052],
              [-7.173451300999943, 4.518784898000092],
              [-7.232818162999934, 4.493312893000052],
              [-7.245228644999941, 4.484930731000077],
              [-7.255238410999937, 4.465521552000041],
              [-7.266021287999934, 4.46360911700009],
              [-7.278472459999932, 4.463771877000056],
              [-7.288156704999949, 4.460516669000071],
              [-7.306019660999937, 4.445461330000057],
              [-7.359852667999917, 4.416083075000074],
              [-7.438710089999915, 4.350978908000059],
              [-7.456776495999918, 4.34406159100007],
              [-7.480865037999934, 4.346136786000045],
              [-7.524322068999936, 4.354681708000044],
              [-7.540666124213715, 4.352844581897472],
              [-7.573770710999895, 4.375392965000103],
              [-7.579196736999961, 4.387149353000098],
              [-7.577853149999896, 4.397277934000059],
              [-7.567414509999963, 4.415933126000112],
              [-7.564313924999908, 4.425829163000103],
              [-7.565709187999886, 4.435208435000064],
              [-7.572840534999926, 4.455388082000042],
              [-7.570928506999905, 4.480709534000113],
              [-7.572737182999902, 4.491122335000057],
              [-7.575424356999918, 4.500346578000062],
              [-7.576871297999929, 4.509338277000097],
              [-7.572478800999932, 4.723356222000049],
              [-7.576871297999929, 4.775291036000056],
              [-7.57955847199986, 4.784282735000104],
              [-7.585552937999893, 4.791543274000077],
              [-7.59340775499993, 4.797434387000081],
              [-7.601004190999987, 4.804643250000126],
              [-7.606016804999854, 4.816192932000078],
              [-7.605996506999958, 4.81736342500011],
              [-7.605861775999898, 4.8251329550001],
              [-7.600229044999878, 4.845803528000118],
              [-7.598833780999882, 4.857094828000086],
              [-7.605965127999923, 4.88799733500008],
              [-7.605500039999896, 4.897428284000043],
              [-7.574959269999908, 4.921561178000104],
              [-7.561781778999915, 4.920165914000023],
              [-7.553461873999879, 4.914248963000105],
              [-7.54953446399989, 4.913887228000107],
              [-7.549586140999907, 4.929054261000132],
              [-7.555322224999884, 4.948432922000094],
              [-7.564623982999905, 4.961584575000074],
              [-7.571600300999904, 4.975382182000118],
              [-7.570205037999926, 4.996879578000062],
              [-7.570360066999854, 4.996879578000062],
              [-7.578163207999893, 5.054731344000089],
              [-7.57578609199993, 5.072068786000088],
              [-7.563228718999909, 5.090155538000104],
              [-7.54684728999996, 5.097700298000063],
              [-7.529923258999872, 5.097390238000074],
              [-7.515841430999927, 5.091809184000056],
              [-7.488918009999935, 5.140669251000133],
              [-7.483026895999927, 5.158239238000107],
              [-7.482251749999904, 5.17505991600008],
              [-7.490468302999943, 5.222188822000078],
              [-7.479926309999883, 5.255158387000051],
              [-7.475688842999944, 5.264227600000098],
              [-7.468247436999917, 5.273451844000107],
              [-7.442409219999888, 5.287378642000093],
              [-7.439928751999929, 5.290169169000052],
              [-7.428508259999916, 5.288153789000106],
              [-7.430110229999855, 5.284252217000045],
              [-7.435174519999919, 5.279291280000095],
              [-7.434089314999937, 5.274071960000086],
              [-7.430885375999964, 5.2675348920001],
              [-7.430833699999937, 5.259990133000059],
              [-7.428508259999916, 5.256140239000018],
              [-7.418793090999884, 5.260455221000086],
              [-7.413780476999904, 5.266708069000074],
              [-7.410111449999903, 5.283167013000053],
              [-7.407682657999942, 5.289859111000069],
              [-7.395590372999976, 5.306783142000072],
              [-7.389750935999899, 5.317144267000089],
              [-7.38882075999993, 5.328383891000044],
              [-7.391456257999948, 5.34768503800008],
              [-7.396933959999927, 5.366443583000077],
              [-7.404375366999943, 5.367993877000103],
              [-7.414865681999913, 5.365978495000149],
              [-7.429696818999929, 5.374298401000104],
              [-7.439101928999889, 5.387811788000079],
              [-7.446026570999976, 5.404916687000124],
              [-7.449953978999929, 5.422770895000085],
              [-7.450212361999917, 5.438713074000106],
              [-7.436208048999902, 5.431323344000106],
              [-7.43171219899989, 5.441917013000079],
              [-7.43238399299986, 5.479563294000116],
              [-7.425149291999901, 5.494161885000082],
              [-7.413470417999918, 5.503489482000106],
              [-7.408147745999884, 5.511783550000075],
              [-7.409851859999918, 5.513416970000037],
              [-7.419981648999908, 5.523126526000055],
              [-7.413470417999918, 5.522816468000073],
              [-7.393626668999929, 5.52397918700008],
              [-7.407114216999901, 5.541394145000112],
              [-7.411920125999899, 5.560359396000067],
              [-7.405098835999866, 5.57240000400013],
              [-7.384118204999936, 5.568963522000104],
              [-7.396675577999872, 5.585086568000079],
              [-7.417962620999901, 5.627756685000122],
              [-7.431040405999909, 5.653971253000094],
              [-7.44948889199992, 5.732364400000094],
              [-7.448558715999866, 5.769054668000066],
              [-7.442047484999904, 5.811274312000137],
              [-7.446543335999905, 5.845949198000071],
              [-7.478582722999931, 5.859875997000046],
              [-7.481683308999948, 5.830213725000092],
              [-7.486644246999901, 5.81380645800003],
              [-7.494395710999925, 5.80618418400006],
              [-7.503904174999889, 5.812101136000067],
              [-7.50881343599994, 5.826182963000093],
              [-7.515583048999872, 5.839231263000045],
              [-7.531085978999897, 5.842021790000089],
              [-7.527778686999881, 5.858842468000063],
              [-7.53519425399989, 5.855845235000061],
              [-7.547570759999871, 5.845432434000116],
              [-7.559146280999897, 5.83985137900001],
              [-7.566277627999852, 5.843727112000067],
              [-7.579506794999929, 5.860341085000073],
              [-7.587206583999944, 5.866774801000119],
              [-7.579093383999918, 5.877187602000049],
              [-7.584157673999897, 5.883698832000022],
              [-7.605758422999884, 5.893129781000084],
              [-7.608497273999916, 5.89369822200004],
              [-7.629116169999918, 5.904937846000095],
              [-7.630614786999928, 5.908606873000082],
              [-7.648339802999942, 5.911294047000112],
              [-7.663119262999942, 5.923102112000038],
              [-7.674022989999912, 5.935737],
              [-7.680482543999887, 5.940930481000066],
              [-7.691541299999898, 5.927727153000077],
              [-7.703220173999853, 5.907883403000085],
              [-7.717172810999955, 5.900752055000055],
              [-7.734949503999871, 5.925634258000116],
              [-7.747145140999891, 5.937597352000068],
              [-7.786625935999922, 5.958164572000058],
              [-7.799648396999942, 5.974468486000077],
              [-7.800681925999925, 5.98172902400006],
              [-7.799958454999853, 6.010151062000077],
              [-7.797736368999921, 6.014750265000117],
              [-7.788589640999959, 6.019788717000097],
              [-7.786470905999892, 6.025111390000049],
              [-7.788744668999897, 6.031493429000079],
              [-7.793860635999891, 6.034077250000081],
              [-7.799234985999931, 6.035679220000105],
              [-7.802438923999915, 6.039244893000088],
              [-7.805694538999887, 6.06203420000007],
              [-7.809673624999959, 6.071206767000064],
              [-7.819388793999906, 6.080095113000084],
              [-7.828380493999873, 6.080715231000056],
              [-7.840886189999964, 6.077356262000137],
              [-7.850498005999953, 6.072240296000047],
              [-7.850911416999878, 6.067563578000076],
              [-7.861815144999952, 6.081490377000065],
              [-7.864502318999882, 6.101695862000057],
              [-7.862021850999895, 6.124381815000021],
              [-7.857370971999927, 6.145388286000113],
              [-7.844141804999936, 6.1839647420001],
              [-7.846622273999913, 6.197478130000079],
              [-7.86212520299992, 6.216391703000113],
              [-7.906566934999915, 6.251996765000086],
              [-7.910029255999859, 6.256776835000082],
              [-7.912664753999877, 6.268429871000052],
              [-7.914370076999916, 6.271737163000054],
              [-7.920545409999903, 6.273804219000112],
              [-7.92522212699987, 6.272512309000064],
              [-7.929511270999853, 6.270755310000084],
              [-7.934885620999893, 6.271427104000068],
              [-7.999377807999934, 6.286697489000119],
              [-8.015707560999942, 6.297782084000033],
              [-8.033019164999871, 6.301761169000102],
              [-8.060097615999922, 6.301141053000052],
              [-8.106606403999962, 6.294681499000092],
              [-8.118285277999917, 6.289901428000093],
              [-8.14060949799989, 6.277576599000042],
              [-8.154355427999917, 6.274217631000027],
              [-8.170581827999854, 6.274010926000074],
              [-8.179056762999949, 6.276853130000049],
              [-8.185723022999866, 6.281839905000098],
              [-8.196575073999895, 6.288144430000017],
              [-8.208486490999945, 6.2925369270001],
              [-8.285975301999883, 6.310055237000071],
              [-8.295070352999858, 6.313362529000059],
              [-8.296568969999953, 6.317496643000084],
              [-8.296568969999953, 6.324395447000057],
              [-8.297705850999876, 6.33258616100008],
              [-8.30271846599993, 6.340647685000079],
              [-8.310004841999927, 6.344626770000062],
              [-8.314190632999953, 6.341526184000116],
              [-8.317497924999941, 6.336978659000081],
              [-8.32235550999988, 6.336461894000138],
              [-8.332949177999865, 6.345970357000027],
              [-8.342612670999898, 6.356951599000098],
              [-8.352947956999884, 6.361059876000112],
              [-8.365970417999932, 6.350078634000042],
              [-8.376564086999906, 6.354729513000095],
              [-8.38881140199993, 6.355091247000104],
              [-8.40105871599988, 6.35044036900004],
              [-8.411807413999895, 6.340027568000011],
              [-8.423692992999918, 6.351990662000063],
              [-8.420153157999948, 6.358088481000024],
              [-8.41098059099994, 6.363178610000091],
              [-8.405967976999904, 6.37224782400007],
              [-8.408241739999909, 6.379921774000053],
              [-8.417233439999961, 6.398189392000106],
              [-8.419042114999854, 6.407646179000082],
              [-8.413874470999929, 6.424182638000076],
              [-8.406484741999947, 6.430538839000093],
              [-8.405089477999866, 6.436326599000068],
              [-8.418266967999926, 6.451209412000111],
              [-8.449634561999858, 6.467926737000056],
              [-8.461210083999902, 6.482887065000028],
              [-8.46751460799993, 6.487072856000069],
              [-8.472372192999927, 6.478649597000071],
              [-8.47691971899988, 6.460149435000048],
              [-8.484774535999918, 6.441571757000091],
              [-8.497228556999886, 6.431365662000118],
              [-8.515625365999881, 6.437592672000022],
              [-8.545339314999865, 6.477202657000078],
              [-8.556501424999908, 6.487021179000052],
              [-8.56807694499986, 6.490405985000066],
              [-8.592106486999882, 6.489682516000073],
              [-8.601847492999923, 6.491749572000032],
              [-8.618719848999916, 6.492834778000116],
              [-8.594121866999927, 6.523892314000065],
              [-8.589367634999917, 6.526062724000056],
              [-8.577327025999864, 6.528026429000093],
              [-8.572727823999912, 6.530842794000051],
              [-8.570609090999938, 6.53513193800012],
              [-8.566113240999897, 6.549058737000095],
              [-8.567198445999907, 6.550609029000029],
              [-8.566113240999897, 6.5509190880001],
              [-8.549473429999892, 6.560143331000106],
              [-8.547147989999871, 6.560039978000091],
              [-8.53355708899997, 6.576343892000111],
              [-8.461313435999926, 6.633420512000029],
              [-8.441645673999943, 6.65531017500011],
              [-8.351759399999878, 6.755351054000059],
              [-8.337496703999904, 6.777261862000017],
              [-8.324991007999898, 6.806252340000086],
              [-8.316619425999932, 6.836276347000137],
              [-8.31496577999988, 6.850280660000053],
              [-8.315715087999877, 6.863819885000026],
              [-8.3205985109999, 6.869659322000103],
              [-8.328763386999924, 6.875085347000081],
              [-8.333672647999947, 6.882578430000123],
              [-8.320908569999887, 6.910173645000029],
              [-8.319978393999918, 6.925831604000081],
              [-8.321218627999883, 6.942264710000046],
              [-8.319978393999918, 6.95998972600006],
              [-8.314552367999852, 6.96856801300008],
              [-8.294140177999907, 6.984381002000077],
              [-8.286647094999893, 6.993786112000038],
              [-8.28411494999989, 7.017867330000087],
              [-8.30121984899992, 7.113210348000081],
              [-8.302615112999916, 7.137601624000112],
              [-8.305353962999959, 7.146903382000048],
              [-8.311503458999937, 7.15729034400006],
              [-8.32623124199992, 7.172069804000074],
              [-8.32974523999988, 7.178322652000077],
              [-8.330572061999902, 7.18473053000011],
              [-8.328453328999927, 7.19739125600006],
              [-8.328970092999981, 7.204005839000061],
              [-8.33300085499988, 7.211860657000088],
              [-8.344989786999918, 7.226795146000143],
              [-8.349692341999912, 7.234701640000097],
              [-8.357547159999854, 7.265707500000119],
              [-8.364006713999885, 7.278884989000105],
              [-8.381059936999918, 7.303017884000056],
              [-8.387674519999933, 7.314955139000105],
              [-8.393048868999898, 7.334333802000074],
              [-8.405141154999882, 7.431278788000014],
              [-8.425605021999928, 7.501920471000105],
              [-8.443640095999939, 7.537112122000067],
              [-8.485446329999888, 7.557989400000039],
              [-8.440022745999954, 7.599898987000117],
              [-8.414804646999897, 7.612921448000066],
              [-8.390878458999907, 7.585791321000087],
              [-8.372274942999951, 7.587289937],
              [-8.336773233999907, 7.597831930000069],
              [-8.303235229999899, 7.589305318000044],
              [-8.265356404999892, 7.560056458000091],
              [-8.228976195999905, 7.54429514600011],
              [-8.200244099999907, 7.576334534000111],
              [-8.19977901199988, 7.583362529000041],
              [-8.203034626999852, 7.599588928000045],
              [-8.202621215999955, 7.607185364000102],
              [-8.197866983999859, 7.618554179000085],
              [-8.177868204999925, 7.643875630000068],
              [-8.17342403099991, 7.647803040000042],
              [-8.162106893999947, 7.65415924000007],
              [-8.158024454999918, 7.658241679000071],
              [-8.157404337999964, 7.662375794000098],
              [-8.160194864999909, 7.672194316000073],
              [-8.159523070999853, 7.676328430000083],
              [-8.127380330999898, 7.713018697000066],
              [-8.122626098999916, 7.727488098000094],
              [-8.119008748999931, 7.760819397000134],
              [-8.115133015999959, 7.776890768000015],
              [-8.110482136999906, 7.782420146000021],
              [-8.103919229999917, 7.786347555000077],
              [-8.098260660999898, 7.791876933000083],
              [-8.096322793999946, 7.801902161000015],
              [-8.10143876099994, 7.812805888000071],
              [-8.123762980999913, 7.832029521000095],
              [-8.131204386999855, 7.842416484000111],
              [-8.128878946999919, 7.882569072000123],
              [-8.07911454299989, 7.957654928000125],
              [-8.0688826089999, 7.996567281000097],
              [-8.067228963999867, 8.020751852000075],
              [-8.069089314999871, 8.029278463000082],
              [-8.05384476699993, 8.028761699000142],
              [-8.011986857999943, 8.035557150000088],
              [-8.00216833499988, 8.032430725000054],
              [-7.99250484199996, 8.024162496000102],
              [-7.980360879999864, 8.016566061000034],
              [-7.962635863999935, 8.015170797000053],
              [-7.965637541999882, 8.026927369000063],
              [-7.968216918999872, 8.037029928000095],
              [-7.98041255699988, 8.058992411000062],
              [-7.997052368999903, 8.077337545000134],
              [-8.015707560999942, 8.088473816000075],
              [-8.02128861499989, 8.102658997000034],
              [-8.02170202699989, 8.117722677000117],
              [-8.015707560999942, 8.148160095000094],
              [-8.008266153999926, 8.160433248000032],
              [-8.002426716999935, 8.174308370000091],
              [-8.003305215999887, 8.18404937800004],
              [-8.015707560999942, 8.183894348000095],
              [-8.075962280999931, 8.163378805000121],
              [-8.085522419999933, 8.162035218000057],
              [-8.182932494999903, 8.19167165200011],
              [-8.26597652199996, 8.245983582000065],
              [-8.264581257999879, 8.256499736000123],
              [-8.248251504999928, 8.27357879700007],
              [-8.245305949999931, 8.285076803000095],
              [-8.247631388999878, 8.303835347000089],
              [-8.247631388999878, 8.322568055000076],
              [-8.235280720999924, 8.379515483000148],
              [-8.236882690999948, 8.400082703000038],
              [-8.242102009999883, 8.412769267000087],
              [-8.249078328999872, 8.423776347000071],
              [-8.254297647999891, 8.434499206000083],
              [-8.254401000999906, 8.446513977000052],
              [-8.2488716229999, 8.45356781100007],
              [-8.200295776999923, 8.491834208000071],
              [-8.186343139999934, 8.49369456000008],
              [-8.150531371999904, 8.48648569800011],
              [-8.130119180999941, 8.488604432000088],
              [-8.09689123499993, 8.501704407000148],
              [-8.076634073999912, 8.50325470000007],
              [-8.068107462999905, 8.500464173000111],
              [-8.057203735999849, 8.490852356000104],
              [-8.05066666699986, 8.487674256000048],
              [-8.042475952999922, 8.487157492000094],
              [-8.02490596499996, 8.488604432000088],
              [-8.015707560999942, 8.487209168000021],
              [-7.985890258999859, 8.494934795000106],
              [-7.970542357999904, 8.496950175000066],
              [-7.956279662999918, 8.494366354000064],
              [-7.943877318999853, 8.4846253460001],
              [-7.93695267699988, 8.471422018000027],
              [-7.931578328999905, 8.45703013100011],
              [-7.923826862999903, 8.44377512600002],
              [-7.912871459999906, 8.434189148000101],
              [-7.898582926999921, 8.426282654000062],
              [-7.882330687999911, 8.421450908000054],
              [-7.865587524999881, 8.420882467000084],
              [-7.84858597799996, 8.428633931000093],
              [-7.846777302999953, 8.44268992100011],
              [-7.849412801999961, 8.4592005410001],
              [-7.845743773999885, 8.474315898000015],
              [-7.82383296699993, 8.477855734000073],
              [-7.802438923999915, 8.449201151000082],
              [-7.771019652999883, 8.386517639000147],
              [-7.748333699999904, 8.372306621000092],
              [-7.720738484999913, 8.368534241000063],
              [-7.662447469999961, 8.37486460400008],
              [-7.683221394999919, 8.417316793000026],
              [-7.689577596999953, 8.438659160000029],
              [-7.686477009999919, 8.462585348000118],
              [-7.679293986999937, 8.48772593200006],
              [-7.67924230999995, 8.505089213000076],
              [-7.691696329999928, 8.546662903000069],
              [-7.693970092999848, 8.567772725000097],
              [-7.691592976999885, 8.606142477000034],
              [-7.696812296999923, 8.624849346000104],
              [-7.703943644999868, 8.633479309000052],
              [-7.731823079999913, 8.652082825000107],
              [-7.741202351999959, 8.662909038000052],
              [-7.765128539999893, 8.70608469700008],
              [-7.772053181999866, 8.714533793000072],
              [-7.790915079999877, 8.730941061000038],
              [-7.795695149999887, 8.736470439000044],
              [-7.803679157999852, 8.749053650000064],
              [-7.810190388999928, 8.753368633000122],
              [-7.816055663999919, 8.753523661000074],
              [-7.826571817999877, 8.748226827000039],
              [-7.831015990999958, 8.747658386000083],
              [-7.890960652999865, 8.765693462000073],
              [-7.913129841999904, 8.768225606000073],
              [-7.958915160999936, 8.781997375000103],
              [-7.968940388999954, 8.812848205000094],
              [-7.950698608999886, 8.899535421000053],
              [-7.946461140999929, 8.94860219300007],
              [-7.941603555999933, 8.972218323000092],
              [-7.931888386999987, 8.996454570000083],
              [-7.93183671099996, 8.996557922000108],
              [-7.916747192999878, 9.012345073000091],
              [-7.827036905999904, 9.057820333000052],
              [-7.807813273999955, 9.060042420000059],
              [-7.788072875999916, 9.060042420000059],
              [-7.764198364999913, 9.063608093000113],
              [-7.748202714999906, 9.075403105000106],
              [-7.746783406999896, 9.076449687000107],
              [-7.759392455999915, 9.091668396000046],
              [-7.801043660999937, 9.114793599000038],
              [-7.823367878999903, 9.131976013000099],
              [-7.834219929999932, 9.142983093000083],
              [-7.847914184999865, 9.168562928000128],
              [-7.85623408999993, 9.17021657300009],
              [-7.866310993999974, 9.16603078200005],
              [-7.878713337999926, 9.163912049000075],
              [-7.929562947999955, 9.183884990000095],
              [-7.930648152999936, 9.220291036000091],
              [-7.894939737999948, 9.307133281000091],
              [-7.891735798999889, 9.330232645000066],
              [-7.86538081799992, 9.409917705000026],
              [-7.870600137999929, 9.418599345000075],
              [-7.911889607999854, 9.418651021000088],
              [-7.933025268999899, 9.414258525],
              [-7.971059122999918, 9.392967835000107],
              [-7.991574665999906, 9.385319723000038],
              [-8.009868122999876, 9.38361440000007],
              [-8.03229569499996, 9.384647929000053],
              [-8.054051472999959, 9.389092102000063],
              [-8.070432901999936, 9.39754119900006],
              [-8.08717606599987, 9.415395406000101],
              [-8.145363728999882, 9.49714752200012],
              [-8.152856810999936, 9.513115540000058],
              [-8.157611042999918, 9.530866395000075],
              [-8.161021687999948, 9.553604024000066],
              [-8.161590128999904, 9.575644023000052],
              [-8.160292859999856, 9.584813799000074],
              [-8.123504597999954, 9.844852397000096],
              [-8.128103799999906, 9.866246440000097],
              [-8.146862344999903, 9.864696146000085],
              [-8.15099645999993, 9.866143087000083],
              [-8.155078898999932, 9.875238139000146],
              [-8.152133341999928, 9.878829651000032],
              [-8.14732743299993, 9.88012156200007],
              [-8.145673787999954, 9.882498678000033],
              [-8.147224079999887, 9.887924703000095],
              [-8.149549519999937, 9.905339661000127],
              [-8.15321854699991, 9.91092071600005],
              [-8.158954629999897, 9.912367656000043],
              [-8.16453568499989, 9.912677714000026],
              [-8.167894652999905, 9.914693095000075],
              [-8.17151200299989, 9.922832133000085],
              [-8.174715942999882, 9.933038229000147],
              [-8.173837442999911, 9.941874899000055],
              [-8.152391722999909, 9.949988098000063],
              [-8.14009273299996, 9.959703268000098],
              [-8.136268676999919, 9.969444275000043],
              [-8.148877726999928, 9.973888449000057],
              [-8.15848954299986, 9.984921367000055],
              [-8.14774084499993, 10.01003611300007],
              [-8.127535359999854, 10.037114563000031],
              [-8.108776814999942, 10.054193624000078],
              [-8.057875529999905, 10.073081360000103],
              [-8.034879516999865, 10.085793763000055],
              [-8.015707560999942, 10.110365906000126],
              [-8.012348591999853, 10.124861145000068],
              [-8.007232625999961, 10.13832285600003],
              [-7.999842895999933, 10.150699361000093],
              [-7.989662638999988, 10.161990662000065],
            ],
          ],
          [
            [
              [-3.115305141999954, 5.107814846000053],
              [-3.119618292999917, 5.09133535400008],
              [-3.120228644999941, 5.091498114000046],
              [-3.163807745999918, 5.101548570000091],
              [-3.262074347999942, 5.110988674000055],
              [-3.276356574999909, 5.118109442000048],
              [-3.272328253999945, 5.132391669000071],
              [-3.253285285999937, 5.149603583000044],
              [-3.234120245999918, 5.163478908000059],
              [-3.207386847999942, 5.156642971000053],
              [-3.200306769999941, 5.15180084800005],
              [-3.197417772999927, 5.145900783000059],
              [-3.19595292899993, 5.140204169000071],
              [-3.193186001999948, 5.136135158000059],
              [-3.184966600999928, 5.13226959800005],
              [-3.163400844999956, 5.125474351000094],
              [-3.159087693999936, 5.125555731000077],
              [-3.155140753999945, 5.127875067000048],
              [-3.146351691999939, 5.121568101000094],
              [-3.131703253999945, 5.10814036700009],
              [-3.118316209999932, 5.107001044000071],
              [-3.115305141999954, 5.107814846000053],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Mali',
        iso3: 'MLI',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-12.2641304119999, 14.774939067000034],
            [-12.246792968999955, 14.767006734000077],
            [-12.2247788089999, 14.763441061],
            [-12.203255573999854, 14.766179912000055],
            [-12.160209105999854, 14.781011047000078],
            [-12.138866739999855, 14.784525045000038],
            [-12.12367386899993, 14.776644389000097],
            [-12.081454223999856, 14.740031637000044],
            [-12.07039546799993, 14.73439890600011],
            [-12.06233394399996, 14.746258647000047],
            [-12.057062947999924, 14.761942444000098],
            [-12.049673217999924, 14.76721344000012],
            [-12.031069702999957, 14.762820943000037],
            [-12.01107092299992, 14.76274342900011],
            [-11.991485554999912, 14.76804026300006],
            [-11.973967244999955, 14.779848328000071],
            [-11.950299438999906, 14.811551819000073],
            [-11.935985066999933, 14.823618266000054],
            [-11.895729125999878, 14.83206736300005],
            [-11.87748734499985, 14.841524150000026],
            [-11.862604532999882, 14.854081523000033],
            [-11.854698038999857, 14.867310690000124],
            [-11.850822305999884, 14.876483256000114],
            [-11.84560298699995, 14.883227031000061],
            [-11.840487019999983, 14.888498027000082],
            [-11.837076375999857, 14.893097229000134],
            [-11.833097289999955, 14.894699199000073],
            [-11.826069294999854, 14.896559550000077],
            [-11.820384887999921, 14.899970195],
            [-11.82043656399992, 14.906403910000051],
            [-11.82736120699991, 14.915576477000045],
            [-11.830100056999868, 14.92033070900004],
            [-11.830926879999879, 14.926428528000088],
            [-11.825810912999884, 14.962472839000085],
            [-11.820591593999978, 14.980275371000118],
            [-11.81320186399995, 14.995933329000081],
            [-11.81320186399995, 14.996088359000026],
            [-11.8110831299999, 15.01430430200007],
            [-11.813770304999906, 15.028541159000042],
            [-11.821160034999934, 15.03975494400008],
            [-11.8328389079999, 15.049005026000088],
            [-11.839195108999917, 15.049005026000088],
            [-11.844466104999867, 15.044328308000033],
            [-11.851029011999856, 15.041951192000084],
            [-11.860899210999918, 15.049005026000088],
            [-11.859142212999956, 15.054069316000067],
            [-11.856765096999908, 15.084248352000074],
            [-11.845137898999951, 15.124555969000113],
            [-11.844207723999887, 15.134839579000115],
            [-11.847308308999942, 15.148740539000087],
            [-11.848186807999866, 15.158145650000051],
            [-11.845654662999891, 15.179074606000128],
            [-11.826792765999869, 15.232559713000072],
            [-11.821056680999902, 15.28010203000008],
            [-11.816922566999978, 15.29609588700012],
            [-11.783487914999881, 15.365884908000098],
            [-11.767674926999888, 15.437198385000059],
            [-11.754859171999925, 15.469082744000033],
            [-11.729434366999897, 15.496057841000052],
            [-11.727057250999877, 15.50698740600005],
            [-11.727057250999877, 15.541171367000018],
            [-11.701739990999954, 15.537424767000104],
            [-11.69755000799995, 15.536804708000133],
            [-11.670833292999873, 15.528407288000054],
            [-11.64411657799991, 15.526443583000017],
            [-11.614867715999878, 15.541171367000018],
            [-11.579210978999896, 15.577964986000026],
            [-11.562571166999874, 15.587240906000133],
            [-11.53595780399985, 15.594914856000017],
            [-11.524278930999856, 15.600289205000095],
            [-11.515390583999931, 15.610081889000057],
            [-11.513116821999915, 15.615042826000078],
            [-11.51234167499993, 15.62018463200009],
            [-11.513116821999915, 15.625274760000067],
            [-11.515390583999931, 15.630261536000134],
            [-11.5195763749999, 15.632742005000111],
            [-11.522987019999903, 15.635248312000087],
            [-11.52562251799992, 15.638348897000029],
            [-11.527327840999902, 15.642560527000072],
            [-11.524382283999898, 15.643464864000023],
            [-11.515390583999931, 15.644420878000076],
            [-11.45823644999993, 15.632948710000065],
            [-11.434827025999965, 15.623388570000074],
            [-11.409557250999882, 15.602201233000088],
            [-11.316901407999922, 15.471666565000035],
            [-11.29819453999994, 15.451047669000033],
            [-11.04539343299993, 15.270205994],
            [-11.012733927999875, 15.239587708000073],
            [-10.985190388999882, 15.187497864000122],
            [-10.9480350339999, 15.151996155000077],
            [-10.915168822999874, 15.102903544000043],
            [-10.906228799999923, 15.119775900000036],
            [-10.890880899999956, 15.176749166],
            [-10.882250935999906, 15.192846375000073],
            [-10.855327514999914, 15.217651062000115],
            [-10.844062051999856, 15.234549255000019],
            [-10.834398559999926, 15.271394552000118],
            [-10.82721553499988, 15.287698466000052],
            [-10.811040811999874, 15.303123882000136],
            [-10.80018876099993, 15.30684458500005],
            [-10.790111856999886, 15.30684458500005],
            [-10.781740275999908, 15.308420716000086],
            [-10.770681517999918, 15.32467295300009],
            [-10.754506794999912, 15.333638815000128],
            [-10.746807006999916, 15.341131897000068],
            [-10.738900511999873, 15.362164205000084],
            [-10.740140747999902, 15.403582866000136],
            [-10.736368367999887, 15.422625630000113],
            [-10.725361286999885, 15.43306427000006],
            [-10.709186563999907, 15.433865255000072],
            [-10.64888016799992, 15.424873556000122],
            [-10.607125609999883, 15.424434306000094],
            [-10.587385213999909, 15.42725067200007],
            [-10.584746267999947, 15.428127152000016],
            [-10.551521768999862, 15.439162089000106],
            [-10.534985310999957, 15.4416942350001],
            [-10.515503295999878, 15.437740988000101],
            [-10.500413777999881, 15.440350647000045],
            [-10.398404500999959, 15.43869700100008],
            [-10.370757608999952, 15.433503520000059],
            [-10.322646850999973, 15.437095032000045],
            [-10.308745890999887, 15.435208842000023],
            [-10.223221394999939, 15.402032573000028],
            [-10.214488077999874, 15.401980896000097],
            [-10.19609126799989, 15.4052881880001],
            [-10.188391478999904, 15.404719747000044],
            [-10.16797928899993, 15.395185445000052],
            [-10.131599080999877, 15.372628683000116],
            [-10.108293009999926, 15.365884908000098],
            [-10.067623657999889, 15.364748026000086],
            [-9.951403360999905, 15.381206971000054],
            [-9.835596475999921, 15.371104228000107],
            [-9.797355916999948, 15.380302633000014],
            [-9.740718546999858, 15.412600403000084],
            [-9.720823120999853, 15.420920309000053],
            [-9.67211808299993, 15.430661316000098],
            [-9.423890339999957, 15.440531515000075],
            [-9.435879271999937, 15.49590281200004],
            [-9.451847289999876, 15.559206441000029],
            [-9.45169225999993, 15.588326111000029],
            [-9.437016153999934, 15.614887798000055],
            [-9.375934610999934, 15.68591705300004],
            [-9.35645259599994, 15.697854310000096],
            [-9.332423055999925, 15.6875707],
            [-9.32932246899989, 15.655247091000106],
            [-9.342965046999893, 15.586930847000062],
            [-9.349217895999885, 15.495644430000041],
            [-9.17584346599989, 15.495592753000054],
            [-9.141378708999923, 15.49558142700009],
            [-9.018592081999941, 15.495541076000038],
            [-9.003215638999933, 15.495526284000036],
            [-8.911156778999953, 15.495437724000098],
            [-8.843408976999854, 15.495437724000098],
            [-8.769253296999892, 15.495437724000098],
            [-8.68930985599988, 15.495437724000098],
            [-8.603940388999888, 15.495386048000071],
            [-8.470201781999947, 15.495282695000057],
            [-8.327006388999848, 15.495282695000057],
            [-8.175801146999959, 15.495205180000127],
            [-8.017826293999946, 15.495127665000027],
            [-7.854528767999881, 15.495075989],
            [-7.687200480999905, 15.495024313000087],
            [-7.517236693999934, 15.494972636000071],
            [-7.34587764499986, 15.494920960000044],
            [-7.174518595999899, 15.49481760700003],
            [-7.004503132999901, 15.49481760700003],
            [-6.837174844999936, 15.49474009300009],
            [-6.673928995999887, 15.494662577000085],
            [-6.516005818999872, 15.494610901000058],
            [-6.364748900999899, 15.49455922500006],
            [-6.320144864999889, 15.49454312300007],
            [-6.221605183999884, 15.494507549000033],
            [-6.087814900999945, 15.494455872000046],
            [-6.010817015999919, 15.494378357000116],
            [-5.938211629999898, 15.494352519000088],
            [-5.870257120999923, 15.494352519000088],
            [-5.807315226999918, 15.494352519000088],
            [-5.673163207999977, 15.494300842000072],
            [-5.515963500999874, 15.494249166000074],
            [-5.515601765999861, 15.49414581300006],
            [-5.515291707999893, 15.494042461000035],
            [-5.514981648999907, 15.493913269000089],
            [-5.514671589999921, 15.493835755000063],
            [-5.514361531999924, 15.493732401000031],
            [-5.514051472999938, 15.493629049],
            [-5.513741414999856, 15.493525696000077],
            [-5.513379679999957, 15.493422343000063],
            [-5.513121296999884, 15.493422343000063],
            [-5.512966267999957, 15.493422343000063],
            [-5.5127595619999, 15.493422343000063],
            [-5.512552855999928, 15.493422343000063],
            [-5.512294473999873, 15.493422343000063],
            [-5.512191120999944, 15.493422343000063],
            [-5.511932739999878, 15.493422343000063],
            [-5.511726033999906, 15.493422343000063],
            [-5.511622679999988, 15.493525696000077],
            [-5.511519327999849, 15.493680725000033],
            [-5.511364298999922, 15.493732401000031],
            [-5.511312621999906, 15.493887431000061],
            [-5.511260945999879, 15.493990784000104],
            [-5.511105916999952, 15.494042461000035],
            [-5.510950886999893, 15.494197489000058],
            [-5.510950886999893, 15.494300842000072],
            [-5.510950886999893, 15.494507549000033],
            [-5.510950886999893, 15.494662577000085],
            [-5.510950886999893, 15.49481760700003],
            [-5.510950886999893, 15.495075989],
            [-5.510950886999893, 15.495282695000057],
            [-5.510950886999893, 15.495437724000098],
            [-5.510950886999893, 15.495670268000069],
            [-5.510950886999893, 15.49590281200004],
            [-5.509917358999928, 15.500812073000063],
            [-5.508987182999874, 15.505695496000087],
            [-5.508761370999935, 15.506899828000073],
            [-5.508057006999906, 15.51065643400004],
            [-5.507075154999939, 15.515539857000064],
            [-5.488368285999883, 15.612665710000059],
            [-5.469558064999944, 15.709791565000032],
            [-5.450799519999862, 15.806839905000103],
            [-5.431989298999952, 15.903939922000077],
            [-5.41379919499991, 15.998559469],
            [-5.395454060999924, 16.09317901700011],
            [-5.377212279999867, 16.187798564000033],
            [-5.358918822999897, 16.2823664350001],
            [-5.353286091999877, 16.31197703100007],
            [-5.354267943999929, 16.318384908],
            [-5.355301472999912, 16.32479278600003],
            [-5.36010738199991, 16.329908752000037],
            [-5.364913288999929, 16.334921367000092],
            [-5.404962524999917, 16.361689758000054],
            [-5.445941934999922, 16.389026591000075],
            [-5.485371053999955, 16.41543324800007],
            [-5.529709431999891, 16.44499216700008],
            [-5.566503051999888, 16.469486797000044],
            [-5.605880493999905, 16.495893453000022],
            [-5.614562133999868, 16.511861471000074],
            [-5.623347126999931, 16.527829489000013],
            [-5.627687947999931, 16.568137106000066],
            [-5.637609822999906, 16.658364156000076],
            [-5.647583373999936, 16.7486428830001],
            [-5.657453571999895, 16.838818257000085],
            [-5.6673237709999, 16.929096985000044],
            [-5.677297322999891, 17.019324036000043],
            [-5.687167521999896, 17.109499410000055],
            [-5.697037719999855, 17.199726461000054],
            [-5.706959594999944, 17.289953512000082],
            [-5.71693314599986, 17.380180562000092],
            [-5.726803344999951, 17.470355937000093],
            [-5.736673543999927, 17.560582988000093],
            [-5.746647094999929, 17.650758362000104],
            [-5.756465616999918, 17.741037089000045],
            [-5.766387491999893, 17.831264140000044],
            [-5.776361042999923, 17.921439514000056],
            [-5.786179565999873, 18.011666565000084],
            [-5.796359822999932, 18.10437408500006],
            [-5.806540079999905, 18.197081604000047],
            [-5.816772013999895, 18.289892477000066],
            [-5.826952270999868, 18.382548320000055],
            [-5.837080850999911, 18.475333354000057],
            [-5.847364460999898, 18.56806671200006],
            [-5.857544717999872, 18.660800070000036],
            [-5.867673299999922, 18.753585104000067],
            [-5.877801879999879, 18.846318462000042],
            [-5.888033813999868, 18.939051819000056],
            [-5.898214070999927, 19.03178517700006],
            [-5.9083943279999, 19.124570211000062],
            [-5.914802205999933, 19.182887065],
            [-5.921210082999977, 19.241229757000056],
            [-5.927566283999909, 19.299546611],
            [-5.934025838999958, 19.357940980000066],
            [-5.949115355999936, 19.49552948000006],
            [-5.949115355999936, 19.495632833000073],
            [-5.963533080999866, 19.620612285000036],
            [-5.977847452999868, 19.745617574],
            [-5.992161823999936, 19.870597025000066],
            [-6.006579548999866, 19.995524801],
            [-6.020945597999884, 20.120530091000077],
            [-6.035363321999881, 20.245483704000023],
            [-6.049677693999882, 20.37048899300008],
            [-6.064095417999908, 20.49544260700013],
            [-6.076756143999944, 20.60334299700004],
            [-6.083577433999892, 20.661892395000066],
            [-6.098615274999872, 20.79072174100007],
            [-6.113704792999954, 20.919551087000073],
            [-6.12052608299993, 20.978203837000095],
            [-6.134633747999942, 21.098868307000075],
            [-6.148741413999886, 21.219532776000065],
            [-6.162900756999932, 21.340197246000045],
            [-6.177008422999961, 21.460861715000036],
            [-6.191116088999905, 21.581577861000042],
            [-6.205223754999849, 21.702242330000033],
            [-6.219383096999877, 21.822855123000082],
            [-6.233490763999924, 21.94357126900009],
            [-6.247598429999869, 22.064235738],
            [-6.261706095999898, 22.184951884000085],
            [-6.275865437999926, 22.305616354000065],
            [-6.289973103999955, 22.426280823000056],
            [-6.304132446999915, 22.546996969000062],
            [-6.318188435999929, 22.667661438000053],
            [-6.332296101999873, 22.788300070000034],
            [-6.346455443999901, 22.90896453900011],
            [-6.36056310999993, 23.02965484700009],
            [-6.371634199999903, 23.123981336],
            [-6.37472245299989, 23.150293477000062],
            [-6.388778442999921, 23.27095794700007],
            [-6.402937784999949, 23.39167409300005],
            [-6.417045450999893, 23.512338563000057],
            [-6.431204793999939, 23.633028870000132],
            [-6.445312459999883, 23.753719177000036],
            [-6.459420125999912, 23.874409485000015],
            [-6.466603148999866, 23.936240337000115],
            [-6.48257116699989, 24.072304383000088],
            [-6.498435831999899, 24.20836842800007],
            [-6.505670532999886, 24.270276795000072],
            [-6.50633795899995, 24.27596685500005],
            [-6.515850789999945, 24.35706736300007],
            [-6.525514281999961, 24.436726583],
            [-6.53517777499988, 24.516359965000035],
            [-6.544789591999916, 24.59599334700009],
            [-6.554453083999931, 24.675549215],
            [-6.564168252999877, 24.755234274000046],
            [-6.573780069999884, 24.83486765600007],
            [-6.583391885999902, 24.914423523],
            [-6.593107055999923, 24.994134420000066],
            [-6.371673542999872, 24.99423777300008],
            [-6.150188354999898, 24.99434112500002],
            [-5.928754841999933, 24.99444447900005],
            [-5.707321329999957, 24.994599508000093],
            [-5.485939493999894, 24.994702861000107],
            [-5.26445430499993, 24.994806213000047],
            [-5.043072468999867, 24.99490956600006],
            [-4.821613117999902, 24.99506459600009],
            [-4.821535603999877, 24.994961243000077],
            [-4.821354736999922, 24.994806213000047],
            [-4.821225545999908, 24.99475453700002],
            [-4.744925292999881, 24.947057190000052],
            [-4.668676716999954, 24.899334005000085],
            [-4.592350626999917, 24.85168833400006],
            [-4.516024536999879, 24.80399098700009],
            [-4.404946044999889, 24.731308085000038],
            [-4.325235148999923, 24.67921824200009],
            [-4.24549841299995, 24.627076721000023],
            [-4.165865030999925, 24.574986878000075],
            [-4.086154134999958, 24.522897034000025],
            [-4.006494913999916, 24.47080719000006],
            [-3.926732340999962, 24.418717347000026],
            [-3.846995604999904, 24.366575826000044],
            [-3.767336384999851, 24.31443430600008],
            [-3.687625487999895, 24.26234446200003],
            [-3.608017943999869, 24.210202942000066],
            [-3.528281209999903, 24.1581130980001],
            [-3.448544473999931, 24.10602325500004],
            [-3.368807738999863, 24.0539592490001],
            [-3.289122680999924, 24.00184356700005],
            [-3.20948929899987, 23.949702047000088],
            [-3.129649210999986, 23.897612203000037],
            [-3.043065347999857, 23.84092315700012],
            [-2.956403971999919, 23.784234110000014],
            [-2.869768432999876, 23.727622579000027],
            [-2.78310705599992, 23.67098520900005],
            [-2.696445678999879, 23.614347839000047],
            [-2.609835977999865, 23.55768463200006],
            [-2.523226277999925, 23.50099558500007],
            [-2.436513224999942, 23.444358216000083],
            [-2.349851846999911, 23.387746684],
            [-2.263190470999859, 23.331109314000102],
            [-2.176632446999861, 23.2744461060001],
            [-2.089919392999889, 23.21775706000001],
            [-2.003309692999949, 23.161042175000077],
            [-1.916648315999907, 23.10445648200003],
            [-1.830038614999864, 23.047819112000028],
            [-1.74332556199991, 22.99118174300004],
            [-1.656715860999981, 22.934570211000064],
            [-1.570054484999929, 22.877881165000062],
            [-1.483496459999913, 22.821166280000043],
            [-1.39678340599994, 22.764554749000055],
            [-1.310122029999917, 22.707969055],
            [-1.223512328999959, 22.651280009000075],
            [-1.136902627999859, 22.59464264000009],
            [-1.050189575999894, 22.537953593000097],
            [-0.963579874999937, 22.481264547000094],
            [-0.876918497999895, 22.424627177],
            [-0.790308796999881, 22.368041483000027],
            [-0.703647419999925, 22.31140411400004],
            [-0.616934366999971, 22.254766744000065],
            [-0.530324665999927, 22.198077698000063],
            [-0.443663289999989, 22.141388651000042],
            [-0.357027749999929, 22.084751282000056],
            [-0.270392211999905, 22.02811391300007],
            [-0.183730834999949, 21.971476543000065],
            [-0.097043619999909, 21.91483917300009],
            [-0.010408080999866, 21.858150126000098],
            [0.003734557000115, 21.84889880000007],
            [0.07625329600009, 21.801461081000085],
            [0.162966350000147, 21.744823711],
            [0.249498535000043, 21.688238017000018],
            [0.336159912000085, 21.631600647000127],
            [0.422795451000127, 21.574963277000037],
            [0.509456827000093, 21.518274231000035],
            [0.596066528000108, 21.461585185000033],
            [0.682676229000151, 21.40489613900003],
            [0.769389282000105, 21.348310445000052],
            [0.855998983000035, 21.291673075000077],
            [0.942608683000088, 21.23503570600009],
            [1.029321737000117, 21.178346660000088],
            [1.146523885000079, 21.101710511000064],
            [1.15933964000007, 21.081505025000055],
            [1.177943156000111, 21.01732289600004],
            [1.180113566000102, 20.99530873600004],
            [1.167504516000093, 20.886013082000048],
            [1.145283651000057, 20.795889384000063],
            [1.144560180000042, 20.776252340000028],
            [1.147247355000076, 20.751447652000095],
            [1.154585408000059, 20.73878692600006],
            [1.168538045000076, 20.73346425400011],
            [1.191275675000043, 20.730570374000123],
            [1.212463012000086, 20.730880432],
            [1.252253865000114, 20.73899363200009],
            [1.273337850000132, 20.739407044000117],
            [1.296695597000081, 20.73346425400011],
            [1.310544881000055, 20.722715556000068],
            [1.331525512000042, 20.687937317000134],
            [1.346925089000138, 20.66912709500012],
            [1.363978312000057, 20.65770660500003],
            [1.407179810000088, 20.64504587900008],
            [1.447487426000066, 20.63874135300007],
            [1.465780884000111, 20.633522034000052],
            [1.483454223000109, 20.622618307],
            [1.520351196000149, 20.61698557600006],
            [1.559728637000148, 20.597503561000067],
            [1.623704060000136, 20.551253154000094],
            [1.643961222000144, 20.522676087000022],
            [1.650059041000105, 20.487019348000032],
            [1.649232219000083, 20.412088521000086],
            [1.659154093000069, 20.39751576700003],
            [1.778113241000085, 20.304291484000103],
            [1.799197225000114, 20.29488637300004],
            [1.820901326000097, 20.293594463000076],
            [1.838884725000099, 20.295919902000023],
            [1.855007771000089, 20.29483469700004],
            [1.870614054000015, 20.28354339600007],
            [1.880329223000075, 20.263053691],
            [1.88384322100012, 20.244140117000043],
            [1.891387980000076, 20.23178944900009],
            [1.91340214000013, 20.231091817],
            [1.924254191000102, 20.23613027000006],
            [1.941204061000093, 20.251116435000043],
            [1.955260050000106, 20.254914653000085],
            [1.967145629000044, 20.253416036000075],
            [1.975620564000053, 20.248429260000123],
            [1.983372030000055, 20.241918030000036],
            [1.993397257000083, 20.23594940200003],
            [2.056339152000078, 20.215046285000042],
            [2.07122196500012, 20.213263448000063],
            [2.097473592000142, 20.224193013000033],
            [2.138194620000121, 20.26072825100006],
            [2.161345662000116, 20.274939271000036],
            [2.182429647000049, 20.27850494400009],
            [2.200826456000129, 20.273905742000053],
            [2.218189738000149, 20.264087220000064],
            [2.279581339000032, 20.217940166000048],
            [2.316478312000072, 20.180164693000066],
            [2.348207641000073, 20.137634989],
            [2.388721964000098, 20.06740671800013],
            [2.400400838000081, 20.05655466700007],
            [2.415697062000021, 20.051283671000064],
            [2.439881632000095, 20.046090190000044],
            [2.459311970000073, 20.03877797500006],
            [2.495382120000073, 20.020096944000088],
            [2.514812459000069, 20.01593699200005],
            [2.525664510000098, 20.015161845000037],
            [2.616925089000091, 19.99836700400006],
            [2.671805461000105, 19.996222433000085],
            [2.946000610000112, 19.941652120000057],
            [3.072607869000109, 19.888890483000026],
            [3.130485473000135, 19.84522389800007],
            [3.147021932000115, 19.837937520000068],
            [3.183195435000073, 19.827731425000096],
            [3.198801717000094, 19.82052256200005],
            [3.212754353000093, 19.807758484000075],
            [3.216785116000096, 19.794064230000075],
            [3.198284952000051, 19.592396953000062],
            [3.199421834000077, 19.55376881900007],
            [3.21223758900004, 19.51715606700013],
            [3.217508585000076, 19.511161601000097],
            [3.222882935000143, 19.508061015000052],
            [3.228050578000136, 19.504159444],
            [3.232288046000093, 19.495477804000032],
            [3.231667928000121, 19.489044088000085],
            [3.226190226000142, 19.46920033800008],
            [3.225983520000085, 19.45969187400003],
            [3.234768514000081, 19.441346741000032],
            [3.247480916000114, 19.426463928000075],
            [3.258229614000129, 19.41039255800011],
            [3.260813436000149, 19.38832672200003],
            [3.250994914000074, 19.36545990000009],
            [3.232701457000104, 19.351843161000104],
            [3.211514119000043, 19.34086191900012],
            [3.192910604000105, 19.325798238000047],
            [3.183815551000123, 19.307504782000066],
            [3.178854614000073, 19.268721619000118],
            [3.174410441000077, 19.251642558000086],
            [3.152706340000066, 19.230196839000044],
            [3.139270467000131, 19.22192861000009],
            [3.134206176000134, 19.21285939600004],
            [3.126558065000069, 19.19335154300005],
            [3.111778605000069, 19.17133738200006],
            [3.102683553000077, 19.15356069000005],
            [3.104130493000071, 19.13552561500005],
            [3.120873657000118, 19.112813823000053],
            [3.138753703000077, 19.096044820000103],
            [3.158597452000066, 19.08154958100006],
            [3.179784790000042, 19.069999899000024],
            [3.225983520000085, 19.051060486000083],
            [3.284894653000094, 18.995740866000048],
            [3.308355754000075, 18.98168487600013],
            [3.318380981000075, 18.97770579000006],
            [3.333057088000089, 18.975561218000067],
            [3.358688598000128, 18.97685312900002],
            [3.439717245000054, 18.99563751300012],
            [3.439820598000097, 18.99563751300012],
            [3.544620402000049, 19.015067851000097],
            [3.715566040000112, 19.046900533000056],
            [3.790290968000079, 19.060770275000024],
            [3.886511678000147, 19.078629862000085],
            [4.057560669000026, 19.11043670700012],
            [4.228609660000103, 19.14224355100005],
            [4.229023071000114, 19.018581849000057],
            [4.22943648200004, 18.894945984000074],
            [4.22984989400004, 18.771284281000064],
            [4.230263305000051, 18.64764841700007],
            [4.230270912000066, 18.645373847000073],
            [4.23067671700008, 18.524038392000094],
            [4.23109012900008, 18.400325012000067],
            [4.231503540000091, 18.2767408240001],
            [4.231916952000091, 18.153104960000107],
            [4.232227010000088, 18.029443258000086],
            [4.232408236000083, 17.975233873],
            [4.232640421000099, 17.905781556000093],
            [4.23305383200011, 17.782119853],
            [4.233363892000085, 17.658458151],
            [4.233777303000096, 17.534796448000108],
            [4.234294067000064, 17.411186422000114],
            [4.234707479000065, 17.287524719000103],
            [4.235017537000147, 17.163914694000127],
            [4.235327596000047, 17.10081777000009],
            [4.235637655000119, 16.995862935000062],
            [4.222305135000084, 16.98656117700004],
            [4.211659790000084, 16.9860444130001],
            [4.203701619000128, 16.982788798000016],
            [4.197810506000053, 16.965218811000042],
            [4.196570272000088, 16.947132060000044],
            [4.202047974000095, 16.848895162000034],
            [4.197603800000081, 16.83850819900003],
            [4.184581339000147, 16.81850942000007],
            [4.181997518000031, 16.809621074000077],
            [4.182307576000113, 16.746472473000026],
            [4.18303104600011, 16.612682190000058],
            [4.183444458000025, 16.52653757800006],
            [4.183961222000079, 16.416053365000025],
            [4.17589969900007, 16.39264394100006],
            [4.161740356000053, 16.379983215000024],
            [4.118228800000111, 16.35833079000004],
            [4.094767700000119, 16.340812480000082],
            [4.075647420000053, 16.321072083000033],
            [4.060557902000141, 16.298334453000038],
            [3.971157674000068, 16.086099345],
            [3.966920207000101, 16.058504130000088],
            [3.970847615000082, 16.03085723900007],
            [3.983249959000119, 16.00134999600006],
            [3.983973429000031, 16.000109762000122],
            [3.984490193000084, 15.998766175000057],
            [3.984696899000113, 15.997370911000061],
            [3.984593546000099, 15.995923971000067],
            [3.98480025300006, 15.989826152000106],
            [3.984180135000088, 15.986880595000017],
            [3.983249959000119, 15.983986715000029],
            [3.925062296000135, 15.927607727000023],
            [3.909869425000096, 15.9047667440001],
            [3.903461548000053, 15.886318258000088],
            [3.894469849000103, 15.788649801000062],
            [3.886511678000147, 15.750099183000074],
            [3.873849402000076, 15.720881837000078],
            [3.871215454000094, 15.714804179000097],
            [3.84610070800008, 15.685296936000086],
            [3.808376912000114, 15.66558237700012],
            [3.728898559000129, 15.650880432000022],
            [3.69220829300005, 15.631450094000044],
            [3.61407352700013, 15.547734274],
            [3.526533651000136, 15.495954489000027],
            [3.516508423000118, 15.469186097000076],
            [3.507103312000055, 15.353973491000062],
            [3.488809855000085, 15.35753916400003],
            [3.483332153000106, 15.359296163000096],
            [3.380392700000129, 15.376323547000126],
            [3.192290486000047, 15.407510274000103],
            [3.07302128000012, 15.427198995000055],
            [3.033540487000096, 15.426449687000058],
            [3.017520792000141, 15.422832337000074],
            [3.010286092000086, 15.417664693000063],
            [3.00780562300011, 15.407665304000133],
            [3.005841919000062, 15.389294332000063],
            [3.005738566000048, 15.352319844000107],
            [3.000157511000111, 15.339116516000033],
            [2.95065148900008, 15.33746287100007],
            [2.854119914000137, 15.334207256000084],
            [2.757484985000076, 15.331080831000037],
            [2.660953410000076, 15.32782521600005],
            [2.564215128000086, 15.324595439000078],
            [2.467683553000143, 15.321417338000103],
            [2.371048624000082, 15.318239238000046],
            [2.274517049000053, 15.31498362300006],
            [2.177882121000096, 15.311831360000014],
            [2.081350545000078, 15.308575744000024],
            [1.984612264000106, 15.305397645000056],
            [1.888080689000077, 15.302193706000082],
            [1.791445760000101, 15.298989766000119],
            [1.694914185000073, 15.295734151000133],
            [1.598382608000065, 15.292607728000078],
            [1.501747680000108, 15.289352112000103],
            [1.405216105000079, 15.286148173000129],
            [1.331525512000042, 15.28361602800004],
            [1.297832478000089, 15.2757353720001],
            [1.27085738100007, 15.259896546000093],
            [1.203161255000083, 15.198789165000093],
            [1.123062784000098, 15.126312968],
            [1.057537069000091, 15.067117615000114],
            [0.973717895000021, 14.9912566120001],
            [0.94932661900009, 14.979551900000033],
            [0.922144816000099, 14.97397084500011],
            [0.769182577000066, 14.969061585000077],
            [0.73993371600011, 14.958338725000061],
            [0.71140832500015, 14.947460836000104],
            [0.683813110000074, 14.940872091000116],
            [0.670067180000018, 14.939735209000105],
            [0.514831177000133, 14.993556213000119],
            [0.483515259000029, 14.992109274000128],
            [0.418790527000056, 14.969888408000102],
            [0.387035359000038, 14.963247986000098],
            [0.353187297000119, 14.963428854000142],
            [0.221257365000071, 14.995933329000081],
            [0.2131958410001, 14.985417175000109],
            [0.21278243000009, 14.960715841000109],
            [0.21846683800004, 14.910977275000093],
            [-0.033197387999962, 14.995933329000081],
            [-0.033404092999916, 14.995933329000081],
            [-0.166987670999902, 15.049676819000084],
            [-0.236699177999867, 15.065618999000023],
            [-0.29917598499992, 15.054741110000052],
            [-0.361471923999943, 15.017740784000097],
            [-0.3976712649999, 15.002134501000057],
            [-0.425731567999918, 15.002599589000084],
            [-0.435601765999905, 15.015156962000091],
            [-0.458649454999943, 15.075463359000082],
            [-0.46789953699988, 15.079907532000092],
            [-0.500343259999852, 15.079721112000115],
            [-0.719718790999906, 15.078460592000098],
            [-0.752895059999901, 15.06972727400003],
            [-0.771271818999935, 15.056619155000107],
            [-0.782815714999941, 15.048384908000031],
            [-0.836249145999943, 14.996088359000026],
            [-0.836404174999899, 14.995985006000083],
            [-1.043138154, 14.818061606000114],
            [-1.04331660999992, 14.817908020000104],
            [-1.078559936999881, 14.796358948000147],
            [-1.116697143999943, 14.780442606000122],
            [-1.307744913999954, 14.73465728700009],
            [-1.350274617999929, 14.714968567000128],
            [-1.696920124999906, 14.496118877000072],
            [-1.766683308999859, 14.483173930000063],
            [-1.836963256999866, 14.479582418000078],
            [-1.919128784999884, 14.48586110400008],
            [-1.967032836999891, 14.483742371000105],
            [-1.997056843999957, 14.470694072000072],
            [-2.005015014999913, 14.444235739000078],
            [-2.023411824999926, 14.198643494000052],
            [-2.02728755699988, 14.188127340000094],
            [-2.035917520999902, 14.18122853600002],
            [-2.085007889999929, 14.159668076000102],
            [-2.104337116999915, 14.151178691000055],
            [-2.119840046999911, 14.14877573600009],
            [-2.151879435999916, 14.15613962800009],
            [-2.385611938999915, 14.26471181300009],
            [-2.461679646999897, 14.280912374000096],
            [-2.516146605999893, 14.267864075000148],
            [-2.597381958999961, 14.222311300000072],
            [-2.619757853999943, 14.203604431000088],
            [-2.676264864999894, 14.141729055000056],
            [-2.693190063999907, 14.123195903000052],
            [-2.840855468999905, 14.042994080000057],
            [-2.8672879639999, 14.000541891000111],
            [-2.861551879999951, 14.001730449000135],
            [-2.858606323999936, 14.00023183200004],
            [-2.857030191999911, 13.997777201000076],
            [-2.855376545999945, 13.996175232000041],
            [-2.89446976699989, 13.866570740000029],
            [-2.912168945999895, 13.83794199600004],
            [-2.928059447999914, 13.799623922000123],
            [-2.923382731999936, 13.746035462000066],
            [-2.895244913999903, 13.651648458000125],
            [-2.930473113999966, 13.638522692000066],
            [-2.965008096999952, 13.625655213000059],
            [-2.972320312999926, 13.624466655000049],
            [-2.979322468999925, 13.62756724100008],
            [-2.986402139999967, 13.632063090000102],
            [-2.994773721999934, 13.634982808000089],
            [-3.019113321999953, 13.637514954000082],
            [-3.026968139, 13.635344543000087],
            [-3.038621174999946, 13.62958262100004],
            [-3.05601029399989, 13.610849915000045],
            [-3.06750830099989, 13.606767477000034],
            [-3.074510457999907, 13.622141215000099],
            [-3.07730098499988, 13.636791483000081],
            [-3.082210245999903, 13.646222433000048],
            [-3.100038614999931, 13.66273305300004],
            [-3.125101683999958, 13.677279968000093],
            [-3.146030639999935, 13.67665985100011],
            [-3.16794144699989, 13.672112325000086],
            [-3.195820882999953, 13.674902852000045],
            [-3.240417642999887, 13.707975769000129],
            [-3.26705684399991, 13.717044984000097],
            [-3.286952269999915, 13.697769674000057],
            [-3.266281696999897, 13.682344258000072],
            [-3.259718789999937, 13.658314718000042],
            [-3.263904581999952, 13.602659200000105],
            [-3.269175577999903, 13.579094747000113],
            [-3.283955037999903, 13.542197774000087],
            [-3.248634195999927, 13.292781474000023],
            [-3.26240596599996, 13.283918966000016],
            [-3.426530314999866, 13.274229635000083],
            [-3.448544473999931, 13.265780539000076],
            [-3.45226517699993, 13.2375135300001],
            [-3.440586303999879, 13.202838643000078],
            [-3.439475259999881, 13.184855245000094],
            [-3.449474649999985, 13.16880971300013],
            [-3.461592773999882, 13.165760803000097],
            [-3.473921513999898, 13.167601349000066],
            [-3.516111409, 13.173899841000022],
            [-3.538487304999876, 13.173408916000085],
            [-3.54505021099996, 13.174494120000077],
            [-3.553912719999857, 13.180256043000043],
            [-3.569958251999907, 13.196766663000034],
            [-3.576598672999921, 13.199298808000023],
            [-3.589802001999914, 13.197386780000102],
            [-3.596881673999945, 13.199402161000052],
            [-3.678711303999876, 13.261749776000087],
            [-3.724419108999882, 13.288828227000053],
            [-3.798626464999955, 13.347145081000093],
            [-3.81710078999987, 13.354689840000049],
            [-3.858080199999904, 13.365516052000075],
            [-3.892600056999896, 13.378926087000124],
            [-3.908878133999906, 13.381974996000054],
            [-3.928825235999938, 13.38026967400009],
            [-3.948410603999946, 13.380838115000046],
            [-3.971613321999939, 13.386755066000148],
            [-3.984041503999919, 13.396470235000095],
            [-3.971613321999939, 13.408329977000022],
            [-3.963009195999916, 13.413161723000115],
            [-3.94272619599991, 13.43194610700003],
            [-3.934923054999985, 13.43489166300013],
            [-3.92554378199992, 13.43631276500011],
            [-3.918593302999852, 13.440317689000011],
            [-3.91797318499988, 13.451066386000036],
            [-3.923399210999946, 13.453753561000056],
            [-3.947480427999892, 13.458197733000063],
            [-3.956058715999916, 13.46166005500001],
            [-3.959288492999917, 13.467938741000111],
            [-3.964481974999927, 13.487808329000103],
            [-3.965467786999852, 13.489217255000057],
            [-3.970321410999901, 13.496154074000074],
            [-3.974093790999916, 13.498944601000034],
            [-3.977736979999918, 13.4999264530001],
            [-3.981250976999974, 13.498970439000047],
            [-3.984480753999947, 13.496050721000046],
            [-3.997968302999908, 13.480521953000036],
            [-3.992232217999856, 13.476232809000066],
            [-3.979468139999881, 13.475380147000038],
            [-3.971613321999939, 13.469954122000061],
            [-3.976910155999889, 13.460626526000027],
            [-3.990216837999895, 13.449128520000102],
            [-4.005358031999918, 13.439516704000084],
            [-4.016029215999907, 13.435770162000068],
            [-4.028199014999927, 13.431532694000026],
            [-4.043495239999885, 13.414453634000083],
            [-4.052538614999946, 13.409001771000092],
            [-4.079307006999926, 13.402128804000128],
            [-4.087549397999851, 13.397994690000104],
            [-4.104266723999899, 13.38269846600005],
            [-4.114653685999912, 13.364534200000023],
            [-4.131577718999921, 13.323839010000057],
            [-4.147106485999927, 13.299602763000067],
            [-4.16602005999988, 13.278157044000054],
            [-4.176872110999909, 13.272369283000074],
            [-4.186458088999927, 13.272834371000101],
            [-4.195837361999878, 13.27469472300001],
            [-4.205500854999912, 13.272989401000046],
            [-4.220667887999923, 13.262834982000086],
            [-4.238780476999949, 13.246789450000023],
            [-4.253508259999933, 13.229090271000103],
            [-4.258107461999884, 13.214129944000135],
            [-4.251208658999929, 13.204750671000099],
            [-4.230021321999857, 13.193149312000045],
            [-4.227773396999851, 13.184441834000083],
            [-4.234801391999952, 13.175605164000075],
            [-4.246170206999864, 13.17247874000013],
            [-4.310197306999953, 13.175553488000062],
            [-4.327043823999929, 13.16855133100006],
            [-4.339601195999933, 13.135297547000036],
            [-4.345905720999951, 13.127132670000023],
            [-4.351073363999944, 13.118321839000117],
            [-4.351073363999944, 13.106074524000093],
            [-4.345363117999909, 13.09705698700013],
            [-4.316398478999929, 13.07085703600012],
            [-4.289733439999878, 13.013470358000035],
            [-4.276917683999898, 12.996236267000143],
            [-4.247849690999914, 12.971948344000054],
            [-4.229323689999887, 12.9489523310001],
            [-4.221313842999905, 12.92125376400007],
            [-4.224646971999903, 12.864513041000052],
            [-4.211882893999928, 12.819192810000047],
            [-4.213278157999923, 12.807178039000078],
            [-4.234129597999896, 12.742349955000066],
            [-4.243973957999856, 12.72992177400009],
            [-4.245471962999915, 12.728936319000084],
            [-4.257642373999971, 12.720930074000137],
            [-4.276297565999926, 12.714677226000049],
            [-4.297226521999931, 12.71214508100006],
            [-4.310920775999932, 12.7160208130001],
            [-4.339446166999892, 12.732789816000064],
            [-4.368850056999889, 12.738990988000054],
            [-4.402026325999913, 12.73656219500009],
            [-4.435254271999924, 12.72842315700008],
            [-4.464370141999893, 12.717250671000073],
            [-4.474941771999909, 12.71576243100013],
            [-4.481711384999954, 12.717416077000081],
            [-4.485251220999913, 12.714677226000049],
            [-4.491323200999943, 12.662794088000055],
            [-4.48253820799988, 12.64625763000005],
            [-4.43907832799988, 12.613288066000095],
            [-4.422490193999863, 12.597216695000029],
            [-4.401406209999919, 12.550397848000017],
            [-4.392647053999951, 12.53742706300008],
            [-4.387246866999874, 12.533964742000137],
            [-4.38688513199989, 12.530192363000111],
            [-4.393448038999878, 12.516446431000077],
            [-4.407607380999906, 12.497946269000053],
            [-4.426624308999891, 12.479652812000083],
            [-4.443677530999906, 12.459447327000092],
            [-4.451635700999873, 12.43531443300013],
            [-4.415358845999918, 12.35030670200004],
            [-4.406134602999913, 12.307466939000093],
            [-4.43582271299988, 12.301730856000049],
            [-4.444814412999932, 12.30943064400013],
            [-4.452669229999856, 12.320282695000088],
            [-4.46248775199993, 12.328189189000042],
            [-4.477189696999915, 12.32731069000009],
            [-4.4881709389999, 12.3206961060001],
            [-4.490703084999893, 12.313823141000029],
            [-4.490496378999921, 12.30576161700013],
            [-4.494010376999881, 12.290103659000081],
            [-4.492253376999912, 12.278838196000024],
            [-4.493545288999968, 12.27284373000009],
            [-4.497421019999905, 12.268709615000077],
            [-4.585529337999958, 12.19724110900006],
            [-4.560466267999857, 12.14949208600008],
            [-4.570233113999905, 12.138898417000092],
            [-4.600308796999883, 12.137554830000042],
            [-4.636120564999914, 12.117556051000093],
            [-4.646662556999956, 12.098022360000087],
            [-4.648677937999906, 12.081950989000035],
            [-4.652736852999851, 12.071626775000055],
            [-4.653716389999886, 12.069135233000054],
            [-4.673585977999892, 12.059730123000094],
            [-4.683714558999924, 12.059058330000099],
            [-4.704023396999958, 12.061487122000074],
            [-4.714617065999931, 12.059006653000097],
            [-4.72513321999989, 12.050118307000076],
            [-4.732280930999934, 12.03726309400011],
            [-4.73898250299996, 12.025210266000016],
            [-4.7468889969999, 12.015081686000059],
            [-4.761280883999916, 12.006606751000064],
            [-4.789522053999889, 12.001800842000051],
            [-4.80680781999996, 11.996271464000046],
            [-4.826238159999946, 12.012704570000025],
            [-4.847244628999874, 12.013066304000105],
            [-4.889955199999889, 11.997925110000097],
            [-4.910677449999895, 11.998131816000054],
            [-4.93207149199992, 12.003144430000106],
            [-4.953749755999894, 12.005108134000054],
            [-4.975453857999895, 11.996271464000046],
            [-4.984523070999956, 11.988571676000063],
            [-4.994238239999902, 11.983249003000111],
            [-5.004702717999862, 11.98066518200011],
            [-5.016045694999917, 11.981285299000078],
            [-5.034313313999888, 11.979269918000028],
            [-5.073768269999903, 11.980510152000065],
            [-5.089322875999926, 11.979269918000028],
            [-5.103947306999913, 11.972758688000056],
            [-5.136994383999905, 11.95312164400012],
            [-5.167819376999972, 11.943664856000055],
            [-5.182908894999883, 11.93090077700009],
            [-5.209470580999891, 11.901496887000093],
            [-5.248227904999908, 11.870439351000059],
            [-5.268226684999945, 11.84305084200011],
            [-5.275151325999929, 11.83741811100009],
            [-5.28248937999993, 11.836436259000024],
            [-5.288018757999936, 11.839123433000054],
            [-5.293444782999899, 11.843205872000055],
            [-5.300162719999918, 11.846358134000113],
            [-5.306518920999849, 11.84604807600003],
            [-5.311066446999888, 11.84289581300007],
            [-5.314838825999914, 11.839330139000097],
            [-5.319024616999855, 11.83741811100009],
            [-5.353802856999891, 11.831733704000044],
            [-5.357058471999892, 11.829614970000065],
            [-5.364551553999917, 11.821760153000128],
            [-5.369874226999883, 11.820158183000089],
            [-5.375610310999917, 11.822225241000055],
            [-5.387909301999883, 11.83080352800009],
            [-5.392301798999966, 11.832353821000112],
            [-5.405944376999884, 11.830441793000091],
            [-5.412352254999917, 11.82852976500007],
            [-5.412197224999971, 11.82356882800012],
            [-5.405996052999882, 11.812303365000062],
            [-5.40041499799986, 11.810184631000084],
            [-5.374525105999851, 11.795250142000029],
            [-5.370649373999896, 11.791064351000088],
            [-5.353286091999877, 11.794526673000036],
            [-5.344656127999912, 11.793906555000063],
            [-5.33426916499991, 11.790805970000122],
            [-5.314787150999905, 11.782486064000068],
            [-5.298974161999894, 11.772667542000093],
            [-5.287140258999898, 11.758921611000062],
            [-5.279543822999926, 11.739026185000057],
            [-5.278561970999874, 11.72145619700008],
            [-5.280680704999924, 11.699493713000024],
            [-5.289258992999862, 11.660426331000096],
            [-5.294788370999868, 11.65029775000005],
            [-5.302281452999893, 11.639859111000106],
            [-5.307810831999916, 11.629007060000063],
            [-5.307604125999944, 11.617638244000076],
            [-5.299956013999889, 11.606424459000024],
            [-5.29096431499994, 11.60446075500009],
            [-5.28073238099995, 11.605752666000043],
            [-5.269466918999882, 11.604099019000088],
            [-5.233913533999925, 11.575987040000058],
            [-5.224663451999902, 11.540769551000082],
            [-5.224611775999904, 11.458009746000101],
            [-5.219185749999923, 11.43514292400009],
            [-5.218307250999885, 11.42219797800007],
            [-5.226420450999882, 11.413490499000105],
            [-5.24817622899991, 11.403181051000104],
            [-5.263472452999878, 11.390184428000069],
            [-5.267864949999961, 11.372020162000041],
            [-5.260940307999874, 11.2677371220001],
            [-5.262852335999895, 11.251588237000107],
            [-5.275254678999943, 11.230710958000131],
            [-5.306725626999906, 11.199395040000127],
            [-5.316182413999883, 11.176321513000062],
            [-5.322331908999956, 11.135548808000081],
            [-5.332512166999919, 11.12157033300008],
            [-5.356283325999868, 11.106894227000097],
            [-5.373026488999926, 11.099762879000068],
            [-5.390131387999872, 11.094698589000089],
            [-5.48976354999985, 11.082115377000065],
            [-5.504232950999977, 11.072684428000102],
            [-5.507333536999909, 11.056948954000035],
            [-5.505602479999965, 11.047984824000054],
            [-5.495602986999927, 10.99620330800012],
            [-5.501804157999914, 10.970210063000067],
            [-5.47911820499985, 10.975532736000105],
            [-5.46557897999989, 10.947885844000098],
            [-5.447027140999921, 10.877993470000106],
            [-5.435089883999893, 10.856909485000074],
            [-5.431420857999882, 10.844688009000052],
            [-5.445321817999883, 10.786991273000083],
            [-5.445011759999886, 10.778568014000086],
            [-5.44645869999988, 10.76869781500011],
            [-5.452969929999938, 10.763969421000112],
            [-5.461186482999892, 10.76004201300006],
            [-5.467956095999909, 10.75267812100006],
            [-5.473072061999915, 10.737872823000131],
            [-5.482632201999905, 10.684232687000062],
            [-5.48211543799988, 10.67521514900011],
            [-5.477154499999926, 10.658807882000048],
            [-5.475914265999961, 10.650384623000065],
            [-5.46056636599991, 10.644571024000086],
            [-5.470488239999895, 10.63560516400014],
            [-5.477412882999886, 10.61955963200009],
            [-5.478549763999894, 10.60423756900012],
            [-5.471056680999965, 10.597364604000063],
            [-5.46811112499995, 10.587830302000071],
            [-5.481650349999938, 10.535327047000095],
            [-5.505163126999918, 10.499179383000083],
            [-5.508987182999874, 10.490936992000044],
            [-5.517100382999956, 10.439984029000087],
            [-5.522578084999878, 10.42548879000006],
            [-5.549708211999928, 10.435643209000105],
            [-5.571722371999925, 10.449880066000077],
            [-5.584383097999961, 10.454246725000075],
            [-5.594046589999891, 10.45393666600009],
            [-5.621796834999913, 10.446934510000077],
            [-5.677555704999861, 10.44150848400011],
            [-5.80628169799985, 10.413474020000095],
            [-5.878060261999849, 10.376060283000115],
            [-5.893304809999989, 10.365027364000127],
            [-5.904828653999914, 10.348284201000084],
            [-5.908962767999952, 10.33006825800004],
            [-5.9047253009999, 10.275291239000055],
            [-5.916404174999883, 10.26663543700009],
            [-5.963016316999926, 10.282732645000067],
            [-5.974746866999908, 10.273637594000093],
            [-5.978312540999895, 10.248626200000103],
            [-5.985237182999867, 10.227283834000104],
            [-5.997122762999908, 10.208189392000108],
            [-6.015932982999914, 10.189870097000039],
            [-6.105333210999902, 10.18927581800007],
            [-6.180884154999916, 10.215837504000092],
            [-6.194320027999879, 10.22418324800006],
            [-6.21400874899993, 10.247851054000094],
            [-6.224809122999943, 10.255034078000051],
            [-6.240001993999897, 10.251933492000092],
            [-6.243309285999885, 10.289011333000076],
            [-6.240673787999867, 10.302576396000063],
            [-6.228323119999914, 10.316089783000038],
            [-6.225894327999868, 10.314487813000099],
            [-6.221140095999971, 10.310353699000075],
            [-6.214370483999915, 10.307795716000072],
            [-6.206153929999886, 10.310818787000102],
            [-6.203983520999913, 10.316038107000026],
            [-6.20537878399989, 10.32262685100011],
            [-6.207807576999926, 10.328517965000103],
            [-6.208324340999894, 10.331980286000146],
            [-6.183933064999849, 10.358852031000055],
            [-6.198764200999989, 10.370815125000092],
            [-6.195663614999944, 10.389211934000102],
            [-6.180574096999948, 10.420217794000024],
            [-6.196903848999881, 10.439157207000065],
            [-6.200366170999928, 10.448769023000082],
            [-6.198195759999919, 10.457398987000118],
            [-6.187498737999931, 10.47540822400012],
            [-6.185793416999957, 10.481325176000027],
            [-6.190289265999894, 10.491143698000087],
            [-6.196128702999971, 10.494683533000057],
            [-6.204190226999856, 10.49437347400007],
            [-6.215662393999878, 10.492616476000094],
            [-6.222432006999924, 10.494631857000044],
            [-6.228168090999873, 10.50057464600006],
            [-6.233490763999924, 10.50757680200006],
            [-6.238658406999917, 10.51274444600007],
            [-6.247650105999867, 10.513829651000066],
            [-6.256021687999947, 10.511607565000062],
            [-6.261292683999955, 10.514088033000036],
            [-6.260930948999885, 10.529151714000122],
            [-6.256228392999901, 10.537239075000116],
            [-6.237934935999931, 10.551941020000115],
            [-6.231372028999942, 10.56023508800007],
            [-6.230028441999877, 10.572043152000077],
            [-6.232870645999867, 10.584109599000058],
            [-6.238658406999917, 10.597984721000032],
            [-6.230700235999961, 10.606924744000054],
            [-6.219796508999906, 10.61185984300009],
            [-6.209771280999888, 10.617750957000098],
            [-6.204448607999922, 10.629610698000107],
            [-6.207807576999926, 10.637543030000074],
            [-6.2169026279999, 10.64508778900003],
            [-6.227754678999872, 10.650849711000092],
            [-6.246616576999884, 10.657619324000038],
            [-6.249458780999873, 10.665603332000089],
            [-6.244446166999893, 10.706866964000099],
            [-6.245841430999889, 10.720742086000072],
            [-6.255970011999921, 10.726478170000036],
            [-6.279999551999964, 10.723274231000062],
            [-6.303564005999874, 10.713171489000032],
            [-6.322219197999914, 10.700484925000069],
            [-6.341701211999919, 10.691441549000018],
            [-6.367539428999947, 10.692268372000044],
            [-6.388054971999907, 10.69552398700003],
            [-6.409810750999924, 10.694387106000107],
            [-6.427019002999913, 10.686093038000067],
            [-6.433995320999912, 10.667928772000039],
            [-6.435855671999917, 10.628706360000066],
            [-6.430688028999896, 10.614960429000035],
            [-6.419060831999928, 10.607699891000067],
            [-6.406658487999977, 10.601860453000072],
            [-6.39921708199995, 10.59248118100004],
            [-6.402782755999908, 10.569123434000076],
            [-6.421489623999889, 10.556591899000082],
            [-6.445984252999949, 10.552251078000097],
            [-6.466964883999964, 10.553542990000054],
            [-6.521380167999951, 10.56421417200005],
            [-6.537554890999928, 10.569691874000043],
            [-6.578069213999953, 10.59113759400006],
            [-6.59858475799993, 10.604909363000104],
            [-6.6136225999999, 10.618474426000091],
            [-6.633983113999932, 10.653020122000072],
            [-6.647108927999909, 10.661340027000037],
            [-6.669174763999905, 10.65415700300008],
            [-6.667882853999856, 10.650901387000104],
            [-6.681938842999955, 10.627388611000114],
            [-6.684212605999988, 10.626561788000089],
            [-6.688966836999981, 10.607854919000104],
            [-6.691085571999849, 10.589432271000092],
            [-6.689225219999855, 10.580931498000083],
            [-6.685607869999956, 10.5740068570001],
            [-6.682817342999897, 10.56597117100003],
            [-6.687778279999861, 10.520470072000066],
            [-6.69754512499992, 10.488301494000027],
            [-6.695788126999929, 10.471196594000077],
            [-6.683075723999877, 10.45168874100007],
            [-6.675634317999936, 10.447864686000045],
            [-6.664627237999866, 10.444557394000043],
            [-6.653981892999866, 10.440035706000103],
            [-6.647780721999879, 10.43269765300002],
            [-6.647935749999931, 10.421871440000075],
            [-6.653051716999926, 10.41306060800008],
            [-6.659614623999914, 10.405360820000084],
            [-6.663955444999885, 10.397996928000083],
            [-6.668270003999908, 10.365839977000036],
            [-6.668916381999935, 10.361022441000046],
            [-6.677391316999916, 10.34903350900008],
            [-6.700335652999883, 10.341669617000079],
            [-6.722556518999909, 10.344046733000127],
            [-6.760228637999944, 10.366112570000027],
            [-6.782087768999872, 10.373037212000014],
            [-6.803895222999898, 10.370866801000105],
            [-6.86275467999991, 10.34384002700007],
            [-6.882029987999942, 10.341256206000068],
            [-6.938719034999849, 10.348335877000096],
            [-6.961249959999861, 10.344873556000053],
            [-6.973135537999894, 10.332290344000043],
            [-6.997113402999901, 10.25276031600012],
            [-6.994891316999912, 10.239401958000087],
            [-6.984297648999927, 10.23038442000005],
            [-6.97117183499995, 10.222064514000081],
            [-6.961611693999942, 10.211031596000083],
            [-6.959389607999867, 10.185503439000058],
            [-6.971636922999892, 10.164419454000026],
            [-6.992410847999935, 10.149097392000058],
            [-7.015768594999884, 10.140880839000118],
            [-7.040521605999885, 10.140054017000097],
            [-7.058246622999917, 10.155970358000033],
            [-7.073129434999942, 10.178527120000055],
            [-7.089459187999893, 10.19756988600004],
            [-7.106357380999896, 10.207259216000068],
            [-7.204749308999908, 10.23449269600006],
            [-7.28402095499996, 10.246559143000042],
            [-7.346962850999944, 10.247902731000096],
            [-7.36339595499993, 10.252191875000065],
            [-7.371819213999913, 10.264516704000116],
            [-7.372697713999855, 10.288597921000061],
            [-7.366341511999934, 10.329448141000057],
            [-7.372335977999853, 10.344770203000024],
            [-7.395021931999906, 10.346217143000018],
            [-7.422203735999915, 10.336088562000072],
            [-7.431402140999893, 10.333737284000037],
            [-7.444424600999923, 10.33420237200005],
            [-7.445768187999903, 10.340377706000126],
            [-7.443287719999915, 10.349963685000134],
            [-7.444682983999911, 10.360815735000088],
            [-7.461477823999871, 10.388643493000046],
            [-7.465456908999954, 10.398617045000051],
            [-7.466180379999855, 10.407479554000062],
            [-7.465353555999911, 10.41799570800012],
            [-7.466180379999855, 10.429493713000042],
            [-7.471606404999932, 10.441095072000095],
            [-7.480236368999954, 10.450293477000088],
            [-7.489848184999886, 10.45610707600008],
            [-7.501475382999928, 10.45863922100007],
            [-7.515841430999927, 10.457812399000133],
            [-7.539612588999915, 10.427633362000037],
            [-7.547415730999916, 10.420502015000096],
            [-7.556381591999866, 10.41727223700012],
            [-7.574339151999936, 10.417530620000093],
            [-7.584416056999885, 10.416522929000024],
            [-7.607773803999919, 10.418719177000114],
            [-7.643688924999879, 10.440474955000127],
            [-7.664411172999905, 10.437141825000111],
            [-7.670043903999925, 10.428770244000049],
            [-7.673971313999914, 10.416393738000082],
            [-7.679035603999893, 10.40592926100004],
            [-7.687923949999913, 10.403087057000064],
            [-7.699809529999925, 10.404533997000058],
            [-7.708646199999919, 10.402466939000092],
            [-7.722288777999921, 10.39133066900007],
            [-7.722288777999921, 10.384483541000108],
            [-7.726784626999859, 10.382881571000084],
            [-7.736034708999881, 10.378282369000118],
            [-7.723994099999913, 10.363606262000047],
            [-7.735337076999883, 10.347095642000056],
            [-7.757428750999878, 10.334047343000108],
            [-7.777582559999871, 10.329861552000068],
            [-7.764405069999981, 10.312911682000063],
            [-7.776342325999934, 10.29273203600009],
            [-7.778254353999927, 10.278340149000073],
            [-7.783835408999948, 10.270433655000119],
            [-7.791225137999959, 10.265782776000066],
            [-7.797736368999921, 10.260279236000073],
            [-7.801250366999881, 10.249453024000033],
            [-7.805074421999933, 10.241830749000059],
            [-7.829000609999923, 10.211651713000052],
            [-7.838664103999861, 10.203719381000099],
            [-7.847423257999935, 10.197931621000123],
            [-7.857215942999886, 10.194417623000078],
            [-7.882847452999954, 10.190826111000092],
            [-7.892252563999904, 10.18483164400007],
            [-7.910959431999913, 10.169406230000078],
            [-7.929046182999912, 10.160957133000082],
            [-7.94987178599996, 10.155427755000076],
            [-7.970904093999877, 10.155066020000078],
            [-7.989662638999988, 10.161990662000065],
            [-7.968010213999889, 10.209998068000104],
            [-7.962584187999937, 10.233252462000024],
            [-7.964599568999887, 10.258935649000094],
            [-7.971214151999959, 10.281802470000116],
            [-7.981549438999878, 10.307020569000073],
            [-7.996277220999986, 10.328259583000133],
            [-8.015707560999942, 10.339344178000147],
            [-8.070071166999924, 10.341876322000132],
            [-8.096116088999906, 10.346733907000058],
            [-8.115494750999886, 10.360247295000121],
            [-8.120920776999952, 10.373037212000014],
            [-8.122109333999958, 10.39949554400009],
            [-8.125416625999975, 10.411665345000102],
            [-8.135441853999907, 10.427323303000051],
            [-8.142056436999894, 10.429648743000087],
            [-8.150583047999902, 10.424532776000092],
            [-8.165982624999884, 10.418099060000145],
            [-8.189030313999865, 10.413629048000132],
            [-8.21057938699991, 10.41406829900005],
            [-8.22887284399988, 10.423421733000097],
            [-8.25388423699988, 10.469827169000013],
            [-8.284425007999886, 10.511245830000064],
            [-8.295535440999885, 10.53744578000007],
            [-8.311141723999924, 10.73528900200003],
            [-8.315585896999949, 10.75309153200007],
            [-8.341940877999889, 10.76324595200012],
            [-8.339822142999935, 10.783864848000036],
            [-8.318893188999937, 10.839520366000059],
            [-8.311813516999905, 10.847245993000058],
            [-8.305870727999888, 10.856289368000105],
            [-8.30364864099991, 10.874892883000058],
            [-8.305095581999893, 10.978245748000049],
            [-8.311141723999924, 11.000802511000074],
            [-8.326592976999848, 11.023850199000037],
            [-8.347315225999864, 11.043125509000077],
            [-8.369329385999947, 11.054235941000087],
            [-8.381318318999888, 11.053925883000105],
            [-8.400645303999852, 11.04333221500012],
            [-8.410463825999926, 11.04191111300014],
            [-8.429067341999883, 11.04829315200007],
            [-8.438162393999932, 11.049740092000064],
            [-8.448704385999918, 11.04710459500005],
            [-8.469013224999912, 11.046381124000064],
            [-8.489063679999958, 11.05273732500008],
            [-8.505755167999922, 11.052789001000093],
            [-8.531645059999931, 10.999045512000095],
            [-8.541566935999924, 10.983775127000044],
            [-8.559550333999937, 10.97160532600013],
            [-8.5756217039999, 10.966747742000024],
            [-8.593346720999904, 10.964706522000071],
            [-8.611381794999915, 10.965145773000089],
            [-8.62822831199989, 10.967832947000105],
            [-8.64796870899994, 10.96581756600007],
            [-8.665228637999945, 10.956955058000062],
            [-8.680938272999896, 10.952304179000095],
            [-8.696234496999864, 10.962742819000127],
            [-8.700730346999876, 10.978452454000092],
            [-8.696906290999948, 10.996048279000078],
            [-8.688689737999908, 11.01255889900007],
            [-8.679801391999888, 11.025193786000102],
            [-8.63368017599987, 11.071289165000024],
            [-8.623112344999896, 11.091262106000059],
            [-8.622388875999889, 11.102605083000128],
            [-8.624921019999903, 11.112191061000132],
            [-8.624610961999906, 11.122035421000106],
            [-8.6154125569999, 11.134050191000071],
            [-8.607221842999877, 11.13715077700003],
            [-8.586990518999897, 11.137460836000102],
            [-8.578153848999875, 11.142060039000057],
            [-8.569678914999884, 11.157795512000035],
            [-8.563942830999906, 11.193426412000107],
            [-8.551798868999924, 11.210738017000025],
            [-8.544615844999953, 11.214975485000068],
            [-8.52410030099989, 11.223760478000145],
            [-8.515625365999881, 11.229057312000094],
            [-8.512059692999912, 11.23029754700012],
            [-8.502137817999937, 11.231176046000073],
            [-8.498778848999905, 11.233501486000094],
            [-8.497021850999943, 11.240710348000064],
            [-8.499243936999932, 11.246704814000083],
            [-8.50234452399988, 11.251639913000119],
            [-8.503119669999904, 11.255412293000049],
            [-8.492577677999918, 11.27778818800003],
            [-8.4832242439999, 11.284919536000075],
            [-8.44457027199988, 11.276263733000107],
            [-8.426896931999892, 11.27419667600006],
            [-8.4066914469999, 11.275281881000055],
            [-8.38839798999993, 11.281405538000115],
            [-8.376719115999947, 11.294660543000106],
            [-8.3710347089999, 11.320550436000048],
            [-8.38126664299989, 11.325097961000083],
            [-8.39956009999986, 11.322152405000082],
            [-8.41795690899994, 11.325511373000097],
            [-8.426070108999852, 11.340471700000066],
            [-8.414132852999927, 11.353468323000087],
            [-8.393358927999884, 11.363002625000078],
            [-8.375323851999951, 11.367653504000145],
            [-8.397648071999924, 11.385895285000103],
            [-8.427723754999903, 11.400080465000059],
            [-8.488133503999933, 11.418193055000074],
            [-8.51578039599994, 11.418968201000084],
            [-8.527562622999938, 11.423386536000095],
            [-8.535520792999904, 11.43808848100008],
            [-8.539424991999908, 11.456312043000139],
            [-8.543995727999913, 11.477646790000037],
            [-8.549576782999907, 11.490126648000029],
            [-8.57520829299989, 11.470282898000036],
            [-8.602183389999908, 11.472091573000029],
            [-8.656753702999936, 11.496431173000133],
            [-8.667967488999892, 11.510874736000062],
            [-8.679026245999893, 11.529839986000113],
            [-8.687346150999957, 11.55001963300009],
            [-8.690705118999858, 11.568028870000092],
            [-8.712874307999897, 11.64006581600006],
            [-8.726516886999889, 11.649470927000024],
            [-8.740366169999959, 11.646163635000022],
            [-8.756540893999954, 11.638825582000038],
            [-8.777211466999859, 11.63593170200005],
            [-8.795194864999957, 11.641926168000069],
            [-8.81167964699992, 11.651744690000044],
            [-8.828526163999896, 11.659186096000056],
            [-8.847233032999895, 11.657945862000119],
            [-8.797003539999935, 11.913227438000078],
            [-8.797830362999974, 11.925113017000115],
            [-8.803204711999939, 11.934931539000075],
            [-8.809974323999882, 11.944440002000064],
            [-8.814909423999922, 11.95539540700014],
            [-8.81643387899993, 11.976841126000068],
            [-8.815452026999964, 11.99570302300009],
            [-8.819792845999928, 12.012652893000094],
            [-8.837982950999958, 12.028155823000105],
            [-8.858756876999934, 12.031824849000103],
            [-8.88164953599994, 12.029189352000088],
            [-8.903715372999926, 12.030377909000023],
            [-8.922112182999854, 12.04536407500008],
            [-8.92629797399988, 12.064277649000118],
            [-8.921957153999898, 12.086033427000132],
            [-8.906970987999927, 12.125359192000118],
            [-8.906040811999958, 12.1477350870001],
            [-8.9138956299999, 12.169852600000112],
            [-8.927021443999877, 12.18737091000007],
            [-8.942007608999859, 12.195845845000079],
            [-8.961696329999882, 12.187991028000042],
            [-8.973840291999892, 12.18757761700003],
            [-8.981178344999876, 12.198946432000113],
            [-8.98453731299989, 12.20891998300003],
            [-8.994278320999854, 12.224836324000051],
            [-8.997559773999853, 12.234809876000057],
            [-8.995906127999888, 12.26100982700008],
            [-8.985260782999887, 12.282093812000099],
            [-8.972134968999939, 12.301989238000104],
            [-8.963091593999877, 12.324210104000144],
            [-8.96474523899991, 12.346275940000055],
            [-8.97590734799985, 12.368703511000135],
            [-8.993839070999911, 12.387513733000048],
            [-9.027765492999919, 12.40475109700013],
            [-9.14731807499993, 12.465493469000137],
            [-9.189486042999874, 12.479239400000068],
            [-9.265863809999928, 12.495207418000106],
            [-9.278937947999879, 12.494432271000093],
            [-9.286379353999905, 12.488127747000092],
            [-9.294079142999891, 12.483786926000107],
            [-9.308186807999931, 12.488954570000104],
            [-9.321519327999852, 12.496602682000088],
            [-9.32730708899993, 12.497532858000042],
            [-9.334180053999887, 12.496292623000016],
            [-9.350871540999918, 12.484613749000033],
            [-9.398155476999875, 12.473244935000139],
            [-9.41257320199989, 12.45536488900008],
            [-9.407250528999953, 12.445132955000105],
            [-9.39278112799991, 12.428028056000059],
            [-9.374694376999912, 12.41112986300007],
            [-9.34715083799992, 12.396453756000085],
            [-9.344463663999903, 12.389012350000058],
            [-9.343946899999935, 12.380124003000049],
            [-9.339166829999954, 12.370615539000056],
            [-9.331647907999923, 12.36632639600009],
            [-9.314801390999918, 12.36265736900009],
            [-9.309168659999898, 12.357748108000067],
            [-9.308496866999917, 12.345035706000104],
            [-9.312889362999925, 12.32607045500015],
            [-9.321829385999933, 12.310205791000044],
            [-9.335006876999927, 12.306536763000054],
            [-9.331906290999882, 12.282765605000094],
            [-9.336815551999905, 12.269846497000074],
            [-9.360173298999968, 12.246643779000081],
            [-9.421513223999938, 12.257082418000024],
            [-9.438876505999929, 12.254756978000074],
            [-9.479597534999897, 12.23584340500014],
            [-9.495875610999917, 12.22468129500001],
            [-9.51561600799991, 12.207059631000021],
            [-9.628167276999875, 12.170162659000098],
            [-9.659999959999936, 12.149802145000066],
            [-9.675141153999931, 12.133989157000073],
            [-9.682272501999876, 12.118537903000075],
            [-9.683667764999939, 12.101484680000041],
            [-9.681549031999879, 12.080814107000023],
            [-9.686303262999957, 12.068153381000073],
            [-9.698808959999951, 12.050996806000114],
            [-9.72299352999994, 12.025416972000073],
            [-9.778649047999863, 12.02665720600001],
            [-9.796632445999933, 12.032341614000046],
            [-9.806812703999924, 12.038439433000107],
            [-9.823039102999928, 12.050893453000086],
            [-9.833684447999929, 12.055130920000039],
            [-9.840660766999918, 12.055027568000114],
            [-9.861124633999879, 12.051875305000053],
            [-9.870736450999885, 12.052082011000024],
            [-9.888771524999896, 12.060556946000105],
            [-9.923188028999931, 12.087583720000055],
            [-9.941533161999928, 12.092751363000062],
            [-9.961583617999878, 12.096006979000052],
            [-9.996413533999942, 12.114145406000077],
            [-10.015533813999923, 12.11988149000004],
            [-10.027677774999916, 12.125669250000016],
            [-10.048089965999878, 12.14137888600007],
            [-10.060182251999947, 12.147528382000047],
            [-10.07036250899992, 12.149853821000079],
            [-10.08700231899985, 12.150577291000076],
            [-10.090340013999878, 12.151583631000022],
            [-10.097285928999923, 12.153677877000106],
            [-10.105192422999892, 12.15863881500006],
            [-10.118835001999884, 12.170162659000098],
            [-10.128653523999958, 12.17450347900008],
            [-10.1358365479999, 12.17548533200005],
            [-10.160227823999946, 12.17450347900008],
            [-10.179761515999957, 12.17822418200008],
            [-10.214849812999887, 12.194605611000043],
            [-10.247819376999928, 12.201065165000088],
            [-10.254123901999947, 12.207214661000066],
            [-10.258981485999868, 12.213777568000054],
            [-10.266939656999853, 12.217808329000135],
            [-10.304973510999957, 12.20287384000008],
            [-10.31101965399992, 12.191039938000074],
            [-10.313603474999923, 12.191143290000099],
            [-10.31649735499991, 12.196879374000062],
            [-10.323577026999914, 12.201995341000043],
            [-10.325592407999864, 12.199773255000139],
            [-10.329881550999943, 12.190419820000102],
            [-10.33933833799992, 12.185458883000052],
            [-10.348433390999958, 12.184787089000068],
            [-10.354117797999919, 12.180859680000097],
            [-10.353394327999922, 12.166493632000098],
            [-10.368225463999863, 12.171506246000064],
            [-10.37484004699985, 12.174813538000066],
            [-10.381402953999924, 12.1801362100001],
            [-10.394580443999928, 12.171609599000092],
            [-10.42894527199985, 12.143394267000119],
            [-10.435973266999952, 12.135177714000093],
            [-10.445688435999898, 12.120708313000065],
            [-10.49348913599988, 12.124429016000065],
            [-10.511627563999923, 12.118072815000048],
            [-10.512661091999888, 12.10846099900003],
            [-10.504444539999952, 12.088358866000064],
            [-10.507958536999922, 12.084586487000138],
            [-10.517311970999856, 12.080349019000096],
            [-10.517673706999858, 12.070737203000078],
            [-10.514883178999895, 12.060143535000094],
            [-10.515089883999877, 12.052908834000036],
            [-10.535398722999957, 12.038697815000077],
            [-10.555449177999918, 12.029344381000044],
            [-10.566507934999919, 12.017252095000046],
            [-10.559479939999932, 11.995186260000054],
            [-10.574982869999928, 11.990328675000043],
            [-10.595653442999946, 11.979890035000096],
            [-10.613791869999886, 11.967694397000088],
            [-10.621543334999984, 11.957669169000056],
            [-10.625264038999887, 11.943871562000112],
            [-10.634152384999908, 11.9254230760001],
            [-10.645159464999892, 11.908369853000067],
            [-10.655081339999896, 11.898964742000103],
            [-10.669964151999949, 11.892040100000116],
            [-10.711356973999898, 11.890386455000083],
            [-10.740347452999856, 11.919893698000095],
            [-10.781016804999922, 11.996219787000129],
            [-10.807785196999902, 12.022833150000068],
            [-10.812436075999955, 12.033426819000042],
            [-10.811040811999874, 12.041540019000053],
            [-10.801222289999913, 12.059213359000054],
            [-10.798535115999869, 12.068101706000064],
            [-10.804942992999912, 12.095955302000036],
            [-10.822926391999914, 12.11047638000008],
            [-10.846387491999877, 12.12138010700005],
            [-10.869641886999887, 12.13843332900008],
            [-10.909794474999899, 12.200134990000038],
            [-10.927674519999869, 12.212950745000029],
            [-10.952117471999912, 12.21946197600009],
            [-10.972012898999907, 12.218583476000049],
            [-11.015472778999907, 12.204424134000107],
            [-11.038778849999858, 12.205250956000029],
            [-11.052318074999931, 12.202512106000086],
            [-11.059811157999945, 12.192435202000055],
            [-11.072781941999892, 12.14949208600008],
            [-11.08430578599993, 12.136572978000075],
            [-11.116603555999887, 12.113731995000066],
            [-11.11747712499988, 12.112701843000096],
            [-11.122081258999884, 12.107272441000106],
            [-11.136292276999939, 12.085103251000078],
            [-11.144250447999895, 12.081330872000066],
            [-11.152725382999904, 12.080865784000125],
            [-11.159391642999907, 12.07750681500002],
            [-11.16564448999992, 12.048619690000066],
            [-11.176341511999937, 12.02949941000007],
            [-11.191172648999952, 12.014409892000074],
            [-11.206985636999946, 12.010172425000121],
            [-11.223315388999879, 12.00929392500008],
            [-11.25550980599985, 11.996168111000117],
            [-11.27499182099993, 11.996271464000046],
            [-11.294680541999895, 12.003092754000093],
            [-11.315144408999856, 12.013324687000079],
            [-11.334678100999952, 12.026192118000083],
            [-11.351317911999956, 12.040403138000045],
            [-11.391728881999938, 12.093733216000118],
            [-11.409557250999882, 12.107892558000074],
            [-11.470793822999923, 12.134609273000123],
            [-11.48960404499985, 12.15119740800013],
            [-11.507794148999892, 12.191608378000112],
            [-11.491671101999913, 12.220908916000084],
            [-11.463249064999985, 12.24995107000008],
            [-11.444593872999917, 12.289483541000024],
            [-11.444903930999885, 12.312531230000076],
            [-11.451466837999874, 12.352115377000132],
            [-11.447229369999917, 12.37454294900003],
            [-11.431674763999894, 12.382966207000024],
            [-11.407593546999863, 12.381932678000041],
            [-11.388628295999894, 12.38446482400012],
            [-11.38842159099994, 12.403895162000097],
            [-11.386561238999946, 12.43045684800012],
            [-11.3797916259999, 12.456863505000086],
            [-11.37777624499995, 12.480221253000138],
            [-11.3904369709999, 12.497532858000042],
            [-11.39260738199988, 12.491848450000091],
            [-11.400513875999934, 12.479549459000054],
            [-11.402374226999939, 12.488541158000103],
            [-11.408678750999854, 12.504922587000053],
            [-11.410849161999948, 12.51334584600005],
            [-11.416998657999926, 12.529313864000073],
            [-11.42475012199992, 12.526368307000084],
            [-11.430382852999855, 12.515722962000083],
            [-11.4298144119999, 12.508333232000084],
            [-11.437875935999898, 12.515361227000085],
            [-11.449451456999924, 12.535204976000074],
            [-11.456686157999911, 12.539752502000113],
            [-11.46779658999992, 12.543524882000042],
            [-11.46061356599995, 12.549829407000061],
            [-11.439839640999907, 12.559286194000023],
            [-11.43735917199993, 12.57075836200005],
            [-11.438599405999895, 12.577993063000108],
            [-11.440924844999927, 12.584866028000079],
            [-11.441803344999869, 12.595511373000065],
            [-11.436635701999933, 12.627085674000043],
            [-11.436842406999915, 12.63747263600007],
            [-11.441751668999927, 12.647756246000057],
            [-11.449554809999967, 12.653182272000038],
            [-11.45715124599991, 12.655972799000097],
            [-11.460975300999877, 12.658401592000061],
            [-11.461905476999902, 12.673129374000055],
            [-11.455755981999857, 12.680622457000084],
            [-11.447952839999914, 12.685945130000036],
            [-11.43735917199993, 12.712248433000084],
            [-11.42418168099988, 12.716382549000102],
            [-11.410332397999895, 12.718811340000073],
            [-11.402167520999882, 12.731730449000082],
            [-11.404027872999905, 12.741213074000058],
            [-11.414569864999862, 12.759713236000081],
            [-11.414569864999862, 12.764209087000012],
            [-11.407593546999863, 12.77146962500008],
            [-11.405423135999882, 12.782347514000037],
            [-11.406353311999908, 12.794284770000075],
            [-11.4084720459999, 12.804490865000048],
            [-11.411675984999874, 12.812888286000117],
            [-11.41601680599993, 12.820071309000085],
            [-11.419685831999857, 12.824670512000125],
            [-11.420977742999895, 12.82557485000008],
            [-11.423458211999957, 12.826401672000102],
            [-11.428160766999952, 12.827021790000074],
            [-11.432088174999905, 12.829347229000092],
            [-11.432501586999933, 12.835522563000083],
            [-11.430021118999946, 12.841051941000075],
            [-11.427023884999926, 12.84523773200003],
            [-11.425473591999918, 12.849552715000087],
            [-11.428625854999979, 12.865804952000104],
            [-11.424905151999951, 12.876166077000022],
            [-11.41932409699993, 12.886501364000125],
            [-11.415138305999903, 12.896655782000082],
            [-11.417308715999894, 12.901952617000035],
            [-11.423096476999973, 12.907068584000115],
            [-11.427954060999895, 12.912494609000092],
            [-11.427230590999898, 12.918618266000053],
            [-11.420667683999909, 12.92202891000008],
            [-11.413588012999895, 12.919703471000048],
            [-11.407283487999877, 12.916292826000117],
            [-11.402890991999897, 12.91639617900006],
            [-11.394209349999926, 12.923320821000033],
            [-11.387801472999882, 12.927119039000061],
            [-11.384442504999868, 12.933113505000094],
            [-11.386561238999946, 12.95910675000006],
            [-11.38883500199995, 12.970553080000073],
            [-11.393434203999902, 12.980810852000062],
            [-11.401805785999898, 12.989492493000114],
            [-11.404234578999933, 12.972103373000081],
            [-11.41152095499993, 12.960708720000085],
            [-11.423096476999973, 12.956006165000105],
            [-11.43870275899991, 12.958900045000092],
            [-11.435963907999877, 12.96884775800001],
            [-11.433535115999916, 12.988355612000106],
            [-11.433431761999884, 12.996959738000044],
            [-11.430124470999885, 13.00099049900004],
            [-11.424543415999949, 13.005202129000082],
            [-11.42299312399993, 13.009413757000033],
            [-11.431674763999894, 13.013470358000035],
            [-11.43565384999988, 13.016725973000106],
            [-11.43952958199992, 13.023004659000023],
            [-11.445162312999884, 13.035226135000045],
            [-11.458959920999916, 13.054682312000125],
            [-11.456944538999949, 13.060444234000087],
            [-11.451415160999971, 13.068066509000062],
            [-11.45027827899986, 13.075094503000074],
            [-11.460820271999921, 13.079176941000085],
            [-11.477098347999856, 13.0832852180001],
            [-11.48970739799995, 13.09077830000004],
            [-11.50154130099989, 13.099589132000034],
            [-11.515390583999931, 13.107754008000143],
            [-11.533063923999862, 13.111810608000056],
            [-11.538076538999917, 13.128011169000047],
            [-11.538541625999926, 13.162970276000053],
            [-11.547843383999862, 13.17619944300013],
            [-11.559728962999884, 13.186922302000056],
            [-11.56934077999992, 13.199195456000083],
            [-11.572338012999921, 13.217101339000052],
            [-11.568565632999906, 13.227901714000083],
            [-11.555801554999931, 13.24591095000008],
            [-11.554251261999894, 13.256866353000063],
            [-11.558540405999878, 13.266504008000084],
            [-11.581174681999926, 13.286141052000104],
            [-11.60582434099993, 13.319653219000116],
            [-11.613007364999874, 13.339057719000095],
            [-11.613110717999888, 13.360813497],
            [-11.620345418999875, 13.357532044000024],
            [-11.632902791999868, 13.354379782000052],
            [-11.64396154799988, 13.355594177000086],
            [-11.646597045999897, 13.365516052000075],
            [-11.645253458999917, 13.379752909000047],
            [-11.649800984999956, 13.38411956800013],
            [-11.674967407999901, 13.383215231000094],
            [-11.694501098999922, 13.37918446800009],
            [-11.704009561999897, 13.380373027000118],
            [-11.714034789999914, 13.388098653000029],
            [-11.719770873999892, 13.397891337000075],
            [-11.726902221999921, 13.405797832000118],
            [-11.741216593999894, 13.407813212000079],
            [-11.756512816999873, 13.399803365000096],
            [-11.766589721999907, 13.383163554000078],
            [-11.772532511999913, 13.362673848000014],
            [-11.775116332999914, 13.343346863000065],
            [-11.817077596999923, 13.312341004000132],
            [-11.822555297999912, 13.306708272],
            [-11.828136352999934, 13.307276713000064],
            [-11.840021931999956, 13.316888529000067],
            [-11.844569457999881, 13.323839010000057],
            [-11.850770629999886, 13.343140157000093],
            [-11.8545946859999, 13.350555726000024],
            [-11.862346150999912, 13.35608510400003],
            [-11.888804483999905, 13.368875021000093],
            [-11.897589476999883, 13.371174622000112],
            [-11.899966592999931, 13.38218170200011],
            [-11.885652221999862, 13.435770162000068],
            [-11.883481811999957, 13.453546855000099],
            [-11.89040645399993, 13.465148214000052],
            [-11.898467976999939, 13.468507182000067],
            [-11.907718058999933, 13.469644063000075],
            [-11.918156696999887, 13.474708354000143],
            [-11.923841104999923, 13.4811420690001],
            [-11.932729451999933, 13.496050721000046],
            [-11.939033976999951, 13.502949524000115],
            [-11.99680822799985, 13.54416147900011],
            [-12.015153360999932, 13.564444478000041],
            [-12.037322549999942, 13.598266703000121],
            [-12.04982824799987, 13.63436269100012],
            [-12.07039546799993, 13.673249207000097],
            [-12.083883015999902, 13.692963766000048],
            [-12.097628946999862, 13.704410095000057],
            [-12.012311157999875, 13.751177267000074],
            [-11.978824829999951, 13.78481862400011],
            [-11.962908488999858, 13.829467062000049],
            [-11.95696569799992, 13.870007222000055],
            [-11.956810669999896, 13.890341898000074],
            [-11.962908488999858, 13.909152120000087],
            [-11.980375121999884, 13.929641826000065],
            [-11.999030313999867, 13.943568624000136],
            [-12.015308389999888, 13.959304097000114],
            [-12.025333617999905, 13.985245667000072],
            [-12.025230264999976, 14.026741842000135],
            [-12.002751016999866, 14.103455505000085],
            [-11.995412963999883, 14.144021505000097],
            [-11.997583373999873, 14.166164856000123],
            [-12.034480345999896, 14.250268249000072],
            [-12.04429886899996, 14.264918518000059],
            [-12.058354857999888, 14.274091085000052],
            [-12.097783975999988, 14.288069560000054],
            [-12.1099796149999, 14.298146464000084],
            [-12.119591430999918, 14.310574646000063],
            [-12.12780798399993, 14.32429473900008],
            [-12.11302852399993, 14.329591573000116],
            [-12.108687703999863, 14.342019755000095],
            [-12.11561234599992, 14.355119731000059],
            [-12.208836628999876, 14.388761088000095],
            [-12.221729898999882, 14.391241557000072],
            [-12.21986954699986, 14.434598084000058],
            [-12.222427530999937, 14.454932760000077],
            [-12.23418391999985, 14.498573507000046],
            [-12.236431843999867, 14.519450785000103],
            [-12.230385700999904, 14.536684876000095],
            [-12.211472127999883, 14.547976176000063],
            [-12.204185749999908, 14.554254862000064],
            [-12.201446898999848, 14.565184428000038],
            [-12.20046504699988, 14.577354228000047],
            [-12.198397989999933, 14.587560324000023],
            [-12.191008260999922, 14.597998962000062],
            [-12.17152624499991, 14.61642161000006],
            [-12.165945189999917, 14.625180766000128],
            [-12.165015014999938, 14.641872253000074],
            [-12.17261144999992, 14.647918396000108],
            [-12.182791706999893, 14.650243835000055],
            [-12.189819701999909, 14.655954082000093],
            [-12.192196817999928, 14.666883647000077],
            [-12.190284789999907, 14.67365325900002],
            [-12.185840616999911, 14.680810446000052],
            [-12.180311237999916, 14.692825216000116],
            [-12.191421671999933, 14.693445333000085],
            [-12.207648071999927, 14.696597595000043],
            [-12.222815103999949, 14.703289693000059],
            [-12.230489053999861, 14.714555155000113],
            [-12.236612711999896, 14.728456116000103],
            [-12.256508137999901, 14.74579355900002],
            [-12.2641304119999, 14.774939067000034],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Senegal',
        iso3: 'SEN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-12.2641304119999, 14.774939067000034],
            [-12.256508137999901, 14.74579355900002],
            [-12.236612711999896, 14.728456116000103],
            [-12.230489053999861, 14.714555155000113],
            [-12.222815103999949, 14.703289693000059],
            [-12.207648071999927, 14.696597595000043],
            [-12.191421671999933, 14.693445333000085],
            [-12.180311237999916, 14.692825216000116],
            [-12.185840616999911, 14.680810446000052],
            [-12.190284789999907, 14.67365325900002],
            [-12.192196817999928, 14.666883647000077],
            [-12.189819701999909, 14.655954082000093],
            [-12.182791706999893, 14.650243835000055],
            [-12.17261144999992, 14.647918396000108],
            [-12.165015014999938, 14.641872253000074],
            [-12.165945189999917, 14.625180766000128],
            [-12.17152624499991, 14.61642161000006],
            [-12.191008260999922, 14.597998962000062],
            [-12.198397989999933, 14.587560324000023],
            [-12.20046504699988, 14.577354228000047],
            [-12.201446898999848, 14.565184428000038],
            [-12.204185749999908, 14.554254862000064],
            [-12.211472127999883, 14.547976176000063],
            [-12.230385700999904, 14.536684876000095],
            [-12.236431843999867, 14.519450785000103],
            [-12.23418391999985, 14.498573507000046],
            [-12.222427530999937, 14.454932760000077],
            [-12.21986954699986, 14.434598084000058],
            [-12.221729898999882, 14.391241557000072],
            [-12.208836628999876, 14.388761088000095],
            [-12.11561234599992, 14.355119731000059],
            [-12.108687703999863, 14.342019755000095],
            [-12.11302852399993, 14.329591573000116],
            [-12.12780798399993, 14.32429473900008],
            [-12.119591430999918, 14.310574646000063],
            [-12.1099796149999, 14.298146464000084],
            [-12.097783975999988, 14.288069560000054],
            [-12.058354857999888, 14.274091085000052],
            [-12.04429886899996, 14.264918518000059],
            [-12.034480345999896, 14.250268249000072],
            [-11.997583373999873, 14.166164856000123],
            [-11.995412963999883, 14.144021505000097],
            [-12.002751016999866, 14.103455505000085],
            [-12.025230264999976, 14.026741842000135],
            [-12.025333617999905, 13.985245667000072],
            [-12.015308389999888, 13.959304097000114],
            [-11.999030313999867, 13.943568624000136],
            [-11.980375121999884, 13.929641826000065],
            [-11.962908488999858, 13.909152120000087],
            [-11.956810669999896, 13.890341898000074],
            [-11.95696569799992, 13.870007222000055],
            [-11.962908488999858, 13.829467062000049],
            [-11.978824829999951, 13.78481862400011],
            [-12.012311157999875, 13.751177267000074],
            [-12.097628946999862, 13.704410095000057],
            [-12.083883015999902, 13.692963766000048],
            [-12.07039546799993, 13.673249207000097],
            [-12.04982824799987, 13.63436269100012],
            [-12.037322549999942, 13.598266703000121],
            [-12.015153360999932, 13.564444478000041],
            [-11.99680822799985, 13.54416147900011],
            [-11.939033976999951, 13.502949524000115],
            [-11.932729451999933, 13.496050721000046],
            [-11.923841104999923, 13.4811420690001],
            [-11.918156696999887, 13.474708354000143],
            [-11.907718058999933, 13.469644063000075],
            [-11.898467976999939, 13.468507182000067],
            [-11.89040645399993, 13.465148214000052],
            [-11.883481811999957, 13.453546855000099],
            [-11.885652221999862, 13.435770162000068],
            [-11.899966592999931, 13.38218170200011],
            [-11.897589476999883, 13.371174622000112],
            [-11.888804483999905, 13.368875021000093],
            [-11.862346150999912, 13.35608510400003],
            [-11.8545946859999, 13.350555726000024],
            [-11.850770629999886, 13.343140157000093],
            [-11.844569457999881, 13.323839010000057],
            [-11.840021931999956, 13.316888529000067],
            [-11.828136352999934, 13.307276713000064],
            [-11.822555297999912, 13.306708272],
            [-11.817077596999923, 13.312341004000132],
            [-11.775116332999914, 13.343346863000065],
            [-11.772532511999913, 13.362673848000014],
            [-11.766589721999907, 13.383163554000078],
            [-11.756512816999873, 13.399803365000096],
            [-11.741216593999894, 13.407813212000079],
            [-11.726902221999921, 13.405797832000118],
            [-11.719770873999892, 13.397891337000075],
            [-11.714034789999914, 13.388098653000029],
            [-11.704009561999897, 13.380373027000118],
            [-11.694501098999922, 13.37918446800009],
            [-11.674967407999901, 13.383215231000094],
            [-11.649800984999956, 13.38411956800013],
            [-11.645253458999917, 13.379752909000047],
            [-11.646597045999897, 13.365516052000075],
            [-11.64396154799988, 13.355594177000086],
            [-11.632902791999868, 13.354379782000052],
            [-11.620345418999875, 13.357532044000024],
            [-11.613110717999888, 13.360813497],
            [-11.613007364999874, 13.339057719000095],
            [-11.60582434099993, 13.319653219000116],
            [-11.581174681999926, 13.286141052000104],
            [-11.558540405999878, 13.266504008000084],
            [-11.554251261999894, 13.256866353000063],
            [-11.555801554999931, 13.24591095000008],
            [-11.568565632999906, 13.227901714000083],
            [-11.572338012999921, 13.217101339000052],
            [-11.56934077999992, 13.199195456000083],
            [-11.559728962999884, 13.186922302000056],
            [-11.547843383999862, 13.17619944300013],
            [-11.538541625999926, 13.162970276000053],
            [-11.538076538999917, 13.128011169000047],
            [-11.533063923999862, 13.111810608000056],
            [-11.515390583999931, 13.107754008000143],
            [-11.50154130099989, 13.099589132000034],
            [-11.48970739799995, 13.09077830000004],
            [-11.477098347999856, 13.0832852180001],
            [-11.460820271999921, 13.079176941000085],
            [-11.45027827899986, 13.075094503000074],
            [-11.451415160999971, 13.068066509000062],
            [-11.456944538999949, 13.060444234000087],
            [-11.458959920999916, 13.054682312000125],
            [-11.445162312999884, 13.035226135000045],
            [-11.43952958199992, 13.023004659000023],
            [-11.43565384999988, 13.016725973000106],
            [-11.431674763999894, 13.013470358000035],
            [-11.42299312399993, 13.009413757000033],
            [-11.424543415999949, 13.005202129000082],
            [-11.430124470999885, 13.00099049900004],
            [-11.433431761999884, 12.996959738000044],
            [-11.433535115999916, 12.988355612000106],
            [-11.435963907999877, 12.96884775800001],
            [-11.43870275899991, 12.958900045000092],
            [-11.423096476999973, 12.956006165000105],
            [-11.41152095499993, 12.960708720000085],
            [-11.404234578999933, 12.972103373000081],
            [-11.401805785999898, 12.989492493000114],
            [-11.393434203999902, 12.980810852000062],
            [-11.38883500199995, 12.970553080000073],
            [-11.386561238999946, 12.95910675000006],
            [-11.384442504999868, 12.933113505000094],
            [-11.387801472999882, 12.927119039000061],
            [-11.394209349999926, 12.923320821000033],
            [-11.402890991999897, 12.91639617900006],
            [-11.407283487999877, 12.916292826000117],
            [-11.413588012999895, 12.919703471000048],
            [-11.420667683999909, 12.92202891000008],
            [-11.427230590999898, 12.918618266000053],
            [-11.427954060999895, 12.912494609000092],
            [-11.423096476999973, 12.907068584000115],
            [-11.417308715999894, 12.901952617000035],
            [-11.415138305999903, 12.896655782000082],
            [-11.41932409699993, 12.886501364000125],
            [-11.424905151999951, 12.876166077000022],
            [-11.428625854999979, 12.865804952000104],
            [-11.425473591999918, 12.849552715000087],
            [-11.427023884999926, 12.84523773200003],
            [-11.430021118999946, 12.841051941000075],
            [-11.432501586999933, 12.835522563000083],
            [-11.432088174999905, 12.829347229000092],
            [-11.428160766999952, 12.827021790000074],
            [-11.423458211999957, 12.826401672000102],
            [-11.420977742999895, 12.82557485000008],
            [-11.419685831999857, 12.824670512000125],
            [-11.41601680599993, 12.820071309000085],
            [-11.411675984999874, 12.812888286000117],
            [-11.4084720459999, 12.804490865000048],
            [-11.406353311999908, 12.794284770000075],
            [-11.405423135999882, 12.782347514000037],
            [-11.407593546999863, 12.77146962500008],
            [-11.414569864999862, 12.764209087000012],
            [-11.414569864999862, 12.759713236000081],
            [-11.404027872999905, 12.741213074000058],
            [-11.402167520999882, 12.731730449000082],
            [-11.410332397999895, 12.718811340000073],
            [-11.42418168099988, 12.716382549000102],
            [-11.43735917199993, 12.712248433000084],
            [-11.447952839999914, 12.685945130000036],
            [-11.455755981999857, 12.680622457000084],
            [-11.461905476999902, 12.673129374000055],
            [-11.460975300999877, 12.658401592000061],
            [-11.45715124599991, 12.655972799000097],
            [-11.449554809999967, 12.653182272000038],
            [-11.441751668999927, 12.647756246000057],
            [-11.436842406999915, 12.63747263600007],
            [-11.436635701999933, 12.627085674000043],
            [-11.441803344999869, 12.595511373000065],
            [-11.440924844999927, 12.584866028000079],
            [-11.438599405999895, 12.577993063000108],
            [-11.43735917199993, 12.57075836200005],
            [-11.439839640999907, 12.559286194000023],
            [-11.46061356599995, 12.549829407000061],
            [-11.46779658999992, 12.543524882000042],
            [-11.456686157999911, 12.539752502000113],
            [-11.449451456999924, 12.535204976000074],
            [-11.437875935999898, 12.515361227000085],
            [-11.4298144119999, 12.508333232000084],
            [-11.430382852999855, 12.515722962000083],
            [-11.42475012199992, 12.526368307000084],
            [-11.416998657999926, 12.529313864000073],
            [-11.410849161999948, 12.51334584600005],
            [-11.408678750999854, 12.504922587000053],
            [-11.402374226999939, 12.488541158000103],
            [-11.400513875999934, 12.479549459000054],
            [-11.39260738199988, 12.491848450000091],
            [-11.3904369709999, 12.497532858000042],
            [-11.37777624499995, 12.480221253000138],
            [-11.3797916259999, 12.456863505000086],
            [-11.386561238999946, 12.43045684800012],
            [-11.38842159099994, 12.403895162000097],
            [-11.41601680599993, 12.404980367000093],
            [-11.481645873999895, 12.428234762000017],
            [-11.515390583999931, 12.431645407000047],
            [-11.601535196999862, 12.425237528000096],
            [-11.643083048999927, 12.417641093000043],
            [-11.720029255999862, 12.389477438000085],
            [-11.757804727999911, 12.383327942000022],
            [-11.839608519999928, 12.386686910000037],
            [-11.860175739999931, 12.39107940700012],
            [-11.920637166999938, 12.416039124000093],
            [-11.921980753999918, 12.417692770000144],
            [-11.923944457999937, 12.41877797400005],
            [-11.930869099999938, 12.418726298000124],
            [-11.93520992099991, 12.417020976000074],
            [-11.946268676999921, 12.409424540000103],
            [-11.984302530999855, 12.389012350000058],
            [-11.997583373999873, 12.38637685200004],
            [-12.018874063999931, 12.388443909000102],
            [-12.07918046099985, 12.408132630000054],
            [-12.103985148999868, 12.407357483000041],
            [-12.12191686999995, 12.39872751900009],
            [-12.155041462999861, 12.369013571000025],
            [-12.192041788999887, 12.348756409000117],
            [-12.360920369999889, 12.305606588000089],
            [-12.377120930999894, 12.313668111000084],
            [-12.405517130999897, 12.356456198000018],
            [-12.423397175999867, 12.369116924000053],
            [-12.466753702999938, 12.38446482400012],
            [-12.487760172999856, 12.389477438000085],
            [-12.505071776999955, 12.390252584000095],
            [-12.521918293999931, 12.38689361600008],
            [-12.541451985999942, 12.379452209000064],
            [-12.570649169999882, 12.363690898000073],
            [-12.578129722999932, 12.361528379000035],
            [-12.57940832599985, 12.361158753000083],
            [-12.59367102099992, 12.361572164000094],
            [-12.597314208999904, 12.365447896000148],
            [-12.598063517999918, 12.372424215000052],
            [-12.603412027999866, 12.381932678000041],
            [-12.631549845999928, 12.41268015500009],
            [-12.648008788999988, 12.42575429300004],
            [-12.667516641999896, 12.433660787000093],
            [-12.688058024999862, 12.43598622600011],
            [-12.752653563999928, 12.432420553000057],
            [-12.77327246099992, 12.435056050000071],
            [-12.779163574999927, 12.4432726040001],
            [-12.78347855699991, 12.453091126000075],
            [-12.799420735999917, 12.46063588500003],
            [-12.82905716899998, 12.46275461800009],
            [-12.838617309999876, 12.466371968000075],
            [-12.84913346399992, 12.475828756000055],
            [-12.851252196999923, 12.484355367000063],
            [-12.849650227999888, 12.491073304000082],
            [-12.84921097799986, 12.495000712000149],
            [-12.874041503999905, 12.516394755000064],
            [-12.913134724999935, 12.536341858000085],
            [-12.949489094999905, 12.535928447000074],
            [-12.966232258999867, 12.496085917000059],
            [-12.969513712999856, 12.476810608000022],
            [-12.981037556999866, 12.466992086000047],
            [-12.997418985999929, 12.465855205000125],
            [-13.015247354999872, 12.472676494000083],
            [-13.034626017999926, 12.470557760000105],
            [-13.051989297999853, 12.472263082000083],
            [-13.066742919999854, 12.480117900000025],
            [-13.078266764999881, 12.49624094700009],
            [-13.082710936999888, 12.515671285000067],
            [-13.079093586999903, 12.53215606700006],
            [-13.064210774999879, 12.566159160000083],
            [-13.06041255699995, 12.583367411000069],
            [-13.059327351999855, 12.603469544000035],
            [-13.063642333999923, 12.62227976500013],
            [-13.076458089999903, 12.635922343000047],
            [-13.091702636999855, 12.638196106000066],
            [-13.108988402999927, 12.635405579000107],
            [-13.127307698999914, 12.634837138000051],
            [-13.145316935999915, 12.643932191000118],
            [-13.154696207999876, 12.632821757000102],
            [-13.162628540999918, 12.638144430000054],
            [-13.169217284999917, 12.638764547000022],
            [-13.17627111899992, 12.63773101800004],
            [-13.185211140999854, 12.637782695000055],
            [-13.19787186699989, 12.634061992000042],
            [-13.201902628999989, 12.633390198000058],
            [-13.206450154999914, 12.635663961000077],
            [-13.216010294999904, 12.645740866000025],
            [-13.22153967299991, 12.648376363000125],
            [-13.229084432999883, 12.64780792200007],
            [-13.24600846399997, 12.643157043000102],
            [-13.254690103999934, 12.641813456000051],
            [-13.263397582999886, 12.643208720000118],
            [-13.275722411999936, 12.651063537000056],
            [-13.28414567099992, 12.653337300000075],
            [-13.292930663999925, 12.65271718400001],
            [-13.322877156999937, 12.64651601200012],
            [-13.32770890299986, 12.644914042000082],
            [-13.330034342999909, 12.642071839000025],
            [-13.332773192999952, 12.639643047000064],
            [-13.338612630999933, 12.63922963500005],
            [-13.343444376999855, 12.64098663400003],
            [-13.352048502999878, 12.646981100000048],
            [-13.356647704999915, 12.648893128000068],
            [-13.359801389999916, 12.649736595000135],
            [-13.404758463999912, 12.661760559000072],
            [-13.72827876799991, 12.673387757000029],
            [-14.082753255999904, 12.674834696000119],
            [-14.343107647999943, 12.675897212000095],
            [-14.437305256999934, 12.676281636000112],
            [-14.79172806799994, 12.677780253000023],
            [-14.872159687999954, 12.6781085450001],
            [-15.146228393999877, 12.679227193000102],
            [-15.195114298999954, 12.679433900000063],
            [-15.223794718999955, 12.675196432000106],
            [-15.249736286999905, 12.663620910000077],
            [-15.307820597999893, 12.622693176000055],
            [-15.368643757999905, 12.595356344000024],
            [-15.42173078199994, 12.557121923000096],
            [-15.42460933399991, 12.55504872700007],
            [-15.677048705999908, 12.439293518000028],
            [-15.711516885999856, 12.4322138470001],
            [-15.883964190999905, 12.442182464000055],
            [-15.893883015999904, 12.442755839000057],
            [-15.973258015999875, 12.437226461000066],
            [-15.992481648999899, 12.440688782000095],
            [-16.055010131999893, 12.461204326000072],
            [-16.090511840999852, 12.464304912000017],
            [-16.16606278499995, 12.45143747900002],
            [-16.172832396999894, 12.448543600000036],
            [-16.177173217999893, 12.445236308000034],
            [-16.181875772999945, 12.443375957000029],
            [-16.1900923259999, 12.444771220000106],
            [-16.211693074999857, 12.453142802000087],
            [-16.222390095999884, 12.455054830000094],
            [-16.23288041199993, 12.452884420000103],
            [-16.301920124999896, 12.416194153000049],
            [-16.382018595999853, 12.37381947800013],
            [-16.412300984999973, 12.361727193000135],
            [-16.462685505999957, 12.361313782000124],
            [-16.51487870299985, 12.348549704000064],
            [-16.533327188999863, 12.347826233000063],
            [-16.668874470999896, 12.356714579000084],
            [-16.705616413999877, 12.34803293900012],
            [-16.728436776914492, 12.332530837090502],
            [-16.73501542899993, 12.34516022300005],
            [-16.73973548099991, 12.35838450700004],
            [-16.744130011999914, 12.378851630000042],
            [-16.750477667999917, 12.385646877000056],
            [-16.76549231699994, 12.395982164000088],
            [-16.78848222599993, 12.41795482000009],
            [-16.79873613199993, 12.430894273000092],
            [-16.80296790299991, 12.443793036000045],
            [-16.80296790299991, 12.48541901200008],
            [-16.800770636999914, 12.49445221600007],
            [-16.79092363199993, 12.503241278000075],
            [-16.788685675999943, 12.512396552000041],
            [-16.781361456999946, 12.522935289000088],
            [-16.731678839999915, 12.552069403000075],
            [-16.709868943999936, 12.552801825000074],
            [-16.67882239499994, 12.55023834800005],
            [-16.645375128999945, 12.570746161000045],
            [-16.63467363199993, 12.579494533000059],
            [-16.628977016999954, 12.587632554000038],
            [-16.624623175999943, 12.59601471600007],
            [-16.618031378999945, 12.60545482000009],
            [-16.579741990999935, 12.63279857000009],
            [-16.561350063999953, 12.611802476000037],
            [-16.54718990799995, 12.573879299000055],
            [-16.533314581999946, 12.565334377000056],
            [-16.53270423099991, 12.580877997000073],
            [-16.52245032499991, 12.593085028000075],
            [-16.504750128999945, 12.598049221000053],
            [-16.485096808999913, 12.59373607000009],
            [-16.451568162999934, 12.575018622000073],
            [-16.42145748599995, 12.566880601000037],
            [-16.388335740999935, 12.551581122000073],
            [-16.37096106699994, 12.55023834800005],
            [-16.351307745999918, 12.559515692000048],
            [-16.32725989499994, 12.588690497000073],
            [-16.30955969999991, 12.598049221000053],
            [-16.286284959999932, 12.597072658000059],
            [-16.266468878999945, 12.590033270000049],
            [-16.246693488999938, 12.587958075000074],
            [-16.223866339999915, 12.601752020000049],
            [-16.212228969999956, 12.606350002000056],
            [-16.204457160999937, 12.597601630000042],
            [-16.198597785999937, 12.584906317000048],
            [-16.19286048099991, 12.57758209800005],
            [-16.114979620999918, 12.60610586100006],
            [-16.09707597599993, 12.610256252000056],
            [-16.073109503999945, 12.611721096000053],
            [-16.05760657499991, 12.61619700700004],
            [-16.044667120999918, 12.625474351000037],
            [-16.029774542999917, 12.632961330000057],
            [-16.007883266999954, 12.632147528000075],
            [-15.990345831999946, 12.622870184000078],
            [-15.963856574999909, 12.602240302000041],
            [-15.947987433999913, 12.58982982000009],
            [-15.939605272999927, 12.580633856000077],
            [-15.92796790299991, 12.578599351000037],
            [-15.863880988999938, 12.57758209800005],
            [-15.85773678299995, 12.573187567000048],
            [-15.844797329999949, 12.559881903000075],
            [-15.839995897999927, 12.557074286000045],
            [-15.83116614499994, 12.558254299000055],
            [-15.805531378999945, 12.564520575000074],
            [-15.79405676999994, 12.571478583000044],
            [-15.782948370999918, 12.584662177000041],
            [-15.768788214999915, 12.592596747000073],
            [-15.747873501999948, 12.583726304000038],
            [-15.74242102799991, 12.588324286000045],
            [-15.736073370999918, 12.591376044000071],
            [-15.72960364499994, 12.591498114000046],
            [-15.71593176999994, 12.581773179000038],
            [-15.710113084999932, 12.58274974200009],
            [-15.70498613199993, 12.585191148000092],
            [-15.69945227799991, 12.583726304000038],
            [-15.69163977799991, 12.574896552000041],
            [-15.684925910999937, 12.557928778000075],
            [-15.67955481699994, 12.55023834800005],
            [-15.673085089999915, 12.544419664000088],
            [-15.66592363199993, 12.540187893000052],
            [-15.65689042899993, 12.537583726000037],
            [-15.64476477799991, 12.537258205000057],
            [-15.633412238999938, 12.539536851000037],
            [-15.587717251999948, 12.558010158000059],
            [-15.569406704999949, 12.576320705000057],
            [-15.538685675999943, 12.615423895000049],
            [-15.52725175699993, 12.623724677000041],
            [-15.517079230999911, 12.628851630000042],
            [-15.509836391999954, 12.63580963700008],
            [-15.507069464999915, 12.649562893000052],
            [-15.51280676999994, 12.655666408000059],
            [-15.52375240799995, 12.660345770000049],
            [-15.529855923999946, 12.665757554000038],
            [-15.521311001999948, 12.673773505000042],
            [-15.531076626999948, 12.696437893000052],
            [-15.540191209999932, 12.72687409100007],
            [-15.543446417999917, 12.75804271000004],
            [-15.534901495999918, 12.783026434000078],
            [-15.52334550699993, 12.789862372000073],
            [-15.509022589999915, 12.790350653000075],
            [-15.49400794199994, 12.78904857000009],
            [-15.48033606699994, 12.79047272300005],
            [-15.466420050999943, 12.796454169000071],
            [-15.45693925699993, 12.803656317000048],
            [-15.450672980999911, 12.81281159100007],
            [-15.446156378999945, 12.824611721000053],
            [-15.425607876999948, 12.80499909100007],
            [-15.406809048999946, 12.799709377000056],
            [-15.394032355999911, 12.810248114000046],
            [-15.391590949999909, 12.83820221600007],
            [-15.407053188999953, 12.822333075000074],
            [-15.42178300699993, 12.822821356000077],
            [-15.436879035999937, 12.829291083000044],
            [-15.45303300699993, 12.831447658000059],
            [-15.468129035999937, 12.824896552000041],
            [-15.492787238999938, 12.807114976000037],
            [-15.510731574999909, 12.80345286700009],
            [-15.520863410999937, 12.803412177000041],
            [-15.535878058999913, 12.801336981000077],
            [-15.54946855399993, 12.794338283000059],
            [-15.555409308999913, 12.77960846600007],
            [-15.555409308999913, 12.721584377000056],
            [-15.544097459999932, 12.684068101000037],
            [-15.542347785999937, 12.673773505000042],
            [-15.541737433999913, 12.657456773000092],
            [-15.542469855999911, 12.64940013200004],
            [-15.545480923999946, 12.642726955000057],
            [-15.569691535999937, 12.622259833000044],
            [-15.577381964999915, 12.612494208000044],
            [-15.627756313999953, 12.567613023000092],
            [-15.641021287999934, 12.559475002000056],
            [-15.652902798999946, 12.55890534100007],
            [-15.663319464999915, 12.56346263200004],
            [-15.67210852799991, 12.570746161000045],
            [-15.666411912999934, 12.60065338700008],
            [-15.696766730999911, 12.614162502000056],
            [-15.767689581999946, 12.625392971000053],
            [-15.815825975999928, 12.595363674000055],
            [-15.833485480999911, 12.59125397300005],
            [-15.836903449999909, 12.594427802000041],
            [-15.841297980999911, 12.60146719000005],
            [-15.848500128999945, 12.608547268000052],
            [-15.86046301999994, 12.611721096000053],
            [-15.872670050999943, 12.609564520000049],
            [-15.889556443999936, 12.600165106000077],
            [-15.901722785999937, 12.598049221000053],
            [-15.913319464999915, 12.601223049000055],
            [-15.92837480399993, 12.608872789000088],
            [-15.953277147999927, 12.625392971000053],
            [-15.954457160999937, 12.63031647300005],
            [-15.953195766999954, 12.637396552000041],
            [-15.952707485999952, 12.643744208000044],
            [-15.956450975999928, 12.646429755000042],
            [-15.969715949999909, 12.648179429000038],
            [-15.976673956999946, 12.650213934000078],
            [-15.981190558999913, 12.65265534100007],
            [-15.987456834999932, 12.660956122000073],
            [-16.00108801999994, 12.687445380000042],
            [-16.004750128999945, 12.690822658000059],
            [-16.00934811099995, 12.692694403000075],
            [-16.01317298099991, 12.696193752000056],
            [-16.016957160999937, 12.71751536700009],
            [-16.02212480399993, 12.728989976000037],
            [-16.02830969999991, 12.728989976000037],
            [-16.02830969999991, 12.721584377000056],
            [-16.029774542999917, 12.717474677000041],
            [-16.04051673099991, 12.696966864000046],
            [-16.04515540299991, 12.69049713700008],
            [-16.048898891999954, 12.656398830000057],
            [-16.07681230399993, 12.63898346600007],
            [-16.117746548999946, 12.632147528000075],
            [-16.12832597599993, 12.62767161700009],
            [-16.148915167999917, 12.614447333000044],
            [-16.155018683999913, 12.611721096000053],
            [-16.16559811099995, 12.612860419000071],
            [-16.189808722999942, 12.61912669500009],
            [-16.22760982999995, 12.61912669500009],
            [-16.238840298999946, 12.616522528000075],
            [-16.257923956999946, 12.608221747000073],
            [-16.26862545499995, 12.60545482000009],
            [-16.28066972599993, 12.60545482000009],
            [-16.312977667999917, 12.611721096000053],
            [-16.323841925999943, 12.609564520000049],
            [-16.33775794199994, 12.600165106000077],
            [-16.34679114499994, 12.598049221000053],
            [-16.350209113999938, 12.593329169000071],
            [-16.355132615999935, 12.582586981000077],
            [-16.36196855399993, 12.571234442000048],
            [-16.37096106699994, 12.564520575000074],
            [-16.41197669199994, 12.57758209800005],
            [-16.44517981699994, 12.596136786000045],
            [-16.460682745999918, 12.608872789000088],
            [-16.467193162999934, 12.622259833000044],
            [-16.471180792999917, 12.624579169000071],
            [-16.48033606699994, 12.627386786000045],
            [-16.489572719999956, 12.63182200700004],
            [-16.494496222999942, 12.63898346600007],
            [-16.49282792899993, 12.648911851000037],
            [-16.486480272999927, 12.657782294000071],
            [-16.477284308999913, 12.664129950000074],
            [-16.467193162999934, 12.66632721600007],
            [-16.467193162999934, 12.673773505000042],
            [-16.482574022999927, 12.67413971600007],
            [-16.492298956999946, 12.681708075000074],
            [-16.49791419199994, 12.693833726000037],
            [-16.501332160999937, 12.707912502000056],
            [-16.508168097999942, 12.625392971000053],
            [-16.515695766999954, 12.625392971000053],
            [-16.528920050999943, 12.642767645000049],
            [-16.565663214999915, 12.673895575000074],
            [-16.57022050699993, 12.69358958500004],
            [-16.58193925699993, 12.684393622000073],
            [-16.589670376999948, 12.67328522300005],
            [-16.598784959999932, 12.664007880000042],
            [-16.614613410999937, 12.660101630000042],
            [-16.626576300999943, 12.662543036000045],
            [-16.63467363199993, 12.66937897300005],
            [-16.638661261999914, 12.67999909100007],
            [-16.637928839999915, 12.69358958500004],
            [-16.623768683999913, 12.71971263200004],
            [-16.60383053299995, 12.73932526200008],
            [-16.590728318999936, 12.76203034100007],
            [-16.596913214999915, 12.797308661000045],
            [-16.601389126999948, 12.770209052000041],
            [-16.60374915299991, 12.762518622000073],
            [-16.609120245999918, 12.753729559000078],
            [-16.613758917999917, 12.749416408000059],
            [-16.618519660999937, 12.746527411000045],
            [-16.638417120999918, 12.72850169500009],
            [-16.646880662999934, 12.71820709800005],
            [-16.65103105399993, 12.705267645000049],
            [-16.65225175699993, 12.684027411000045],
            [-16.645090298999946, 12.648586330000057],
            [-16.647206183999913, 12.632228908000059],
            [-16.67731686099995, 12.619574286000045],
            [-16.721058722999942, 12.583726304000038],
            [-16.754628058999913, 12.572211005000042],
            [-16.773101365999935, 12.582953192000048],
            [-16.780873175999943, 12.60883209800005],
            [-16.782541469999956, 12.642726955000057],
            [-16.777088995999918, 12.67804596600007],
            [-16.76121985599991, 12.71320221600007],
            [-16.73546301999994, 12.732896226000037],
            [-16.700550910999937, 12.721584377000056],
            [-16.698963995999918, 12.736395575000074],
            [-16.713246222999942, 12.747300523000092],
            [-16.73395748599995, 12.751369533000059],
            [-16.75153561099995, 12.745428778000075],
            [-16.77212480399993, 12.720648505000042],
            [-16.783558722999942, 12.712591864000046],
            [-16.796213344999956, 12.715318101000037],
            [-16.790272589999915, 12.723456122000073],
            [-16.788238084999932, 12.732082424000055],
            [-16.790272589999915, 12.74054596600007],
            [-16.796213344999956, 12.748846747000073],
            [-16.77448482999995, 12.778550523000092],
            [-16.770130988999938, 12.793361721000053],
            [-16.775054490999935, 12.810939846000053],
            [-16.782541469999956, 12.810939846000053],
            [-16.787220831999946, 12.79987213700008],
            [-16.79405676999994, 12.794989325000074],
            [-16.80028235599991, 12.79881419500009],
            [-16.80296790299991, 12.814032294000071],
            [-16.800526495999918, 12.825995184000078],
            [-16.794545050999943, 12.838771877000056],
            [-16.75885982999995, 12.890773830000057],
            [-16.755238410999937, 12.903469143000052],
            [-16.756255662999934, 12.91624583500004],
            [-16.760975714999915, 12.93968333500004],
            [-16.762074347999942, 12.95115794500009],
            [-16.759836391999954, 12.972072658000059],
            [-16.749989386999914, 13.013617255000042],
            [-16.747792120999918, 13.040269273000092],
            [-16.749338344999956, 13.05662669500009],
            [-16.753651495999918, 13.065008856000077],
            [-16.752125203999896, 13.088039449000092],
            [-16.74850785399991, 13.099227397000035],
            [-16.742151651999905, 13.107392273000045],
            [-16.72633866399991, 13.122636821000086],
            [-16.723186401999925, 13.132248637000103],
            [-16.708406941999925, 13.156691590000051],
            [-16.67352534999995, 13.164313863000103],
            [-16.63001379399992, 13.163900452000092],
            [-16.46521765199995, 13.1624276740001],
            [-16.313288940999968, 13.161084087000035],
            [-16.092062133999946, 13.159120382000097],
            [-15.96173417199995, 13.157983500000086],
            [-15.897441198999985, 13.157399018000135],
            [-15.870783650999925, 13.157156677000074],
            [-15.833318237999947, 13.156846619000078],
            [-15.826600300999928, 13.1616783650001],
            [-15.824739949999923, 13.23291432700006],
            [-15.824367246999913, 13.248511948000086],
            [-15.822672891999957, 13.31942067500006],
            [-15.818693806999875, 13.33352834100009],
            [-15.807118286999923, 13.339781189000092],
            [-15.737406778999912, 13.346344096000067],
            [-15.692499959999907, 13.360348409000082],
            [-15.67989090999987, 13.360658468000068],
            [-15.612453165999852, 13.354224752000022],
            [-15.596123412999901, 13.355826721000142],
            [-15.566047729999923, 13.36567108200012],
            [-15.542948364999859, 13.37799591100007],
            [-15.519538940999894, 13.386600037000107],
            [-15.488326375999918, 13.385256450000043],
            [-15.379237426999879, 13.362518820000062],
            [-15.342392130999968, 13.362570496000075],
            [-15.309835978999928, 13.368435770000076],
            [-15.277073120999916, 13.380295513000092],
            [-15.248341023999927, 13.39897654200007],
            [-15.227773803999924, 13.425176493000095],
            [-15.221727660999875, 13.452823385000102],
            [-15.217955281999963, 13.5146800750001],
            [-15.203950967999958, 13.536900940000052],
            [-15.181331441999873, 13.559843218000083],
            [-15.160491088999947, 13.580980937000035],
            [-15.137650105999853, 13.58997263600007],
            [-15.110158243999877, 13.572480163000108],
            [-15.065251423999968, 13.531268209000118],
            [-15.01559037299998, 13.496050721000046],
            [-15.01543534399994, 13.49599904400013],
            [-15.015228637999883, 13.495844014000085],
            [-15.015073607999938, 13.49574066200006],
            [-14.949702921999886, 13.463081156000086],
            [-14.915906534999891, 13.454425354000136],
            [-14.877614297999884, 13.451376445000108],
            [-14.862576456999903, 13.44706146300004],
            [-14.82914180499992, 13.42701100700009],
            [-14.810796670999935, 13.421171570000098],
            [-14.790332803999974, 13.41734751400007],
            [-14.779635782999947, 13.41088796000011],
            [-14.759481973999897, 13.383370260000035],
            [-14.73157670099991, 13.359004822000102],
            [-14.698142048999927, 13.345181376000056],
            [-14.661606811999889, 13.34091807100009],
            [-14.624554809999921, 13.345181376000056],
            [-14.592153686999922, 13.353139547000112],
            [-14.580733195999926, 13.349160462000043],
            [-14.552109139999885, 13.323094217000076],
            [-14.542854370999919, 13.314666443000064],
            [-14.529573526999911, 13.307276713000064],
            [-14.515104125999898, 13.30316843700004],
            [-14.483633178999924, 13.301928203000102],
            [-14.470326496999917, 13.298259176000016],
            [-14.459138549999892, 13.286916199000117],
            [-14.451490437999894, 13.276865132000097],
            [-14.442033650999946, 13.268545227000033],
            [-14.431439981999858, 13.261439718000105],
            [-14.39498225999995, 13.242965393000077],
            [-14.368833984999952, 13.235704855000108],
            [-14.3417813719999, 13.233637797000142],
            [-14.284911457999954, 13.23854705800008],
            [-14.230625366999902, 13.228573507000078],
            [-14.201686564999932, 13.229555359000045],
            [-14.1798274329999, 13.240123190000105],
            [-14.131794189999937, 13.275573222000048],
            [-14.116808024999955, 13.282161968000125],
            [-14.099496419999866, 13.281955261000078],
            [-14.056579141999919, 13.297173971000106],
            [-14.016271524999866, 13.297639059000048],
            [-13.976118936999853, 13.308206889000104],
            [-13.900567992999925, 13.314563090000135],
            [-13.851036132999866, 13.335750428000097],
            [-13.822562418999922, 13.378202617000028],
            [-13.818712524999881, 13.42936228400012],
            [-13.842690388999898, 13.476646220000077],
            [-13.852793131999931, 13.484811096000087],
            [-13.87547908499991, 13.49791107200005],
            [-13.882503706999898, 13.503781507000028],
            [-13.884599975999976, 13.505533346000036],
            [-13.889793456999882, 13.513956604000015],
            [-13.896175495999927, 13.532921855000069],
            [-13.901343139999938, 13.541629333000031],
            [-13.918086303999871, 13.554987691000065],
            [-13.942090006999905, 13.566924948000107],
            [-13.967488972999888, 13.575580750000057],
            [-13.98849544299992, 13.579146423000026],
            [-14.001905476999951, 13.577027690000051],
            [-14.022265990999898, 13.565322978000069],
            [-14.034022379999982, 13.560207011000074],
            [-14.044461018999925, 13.558605042000053],
            [-14.061850138999944, 13.560051982000047],
            [-14.072598836999958, 13.559690247000049],
            [-14.092881835999975, 13.554729309000095],
            [-14.13913224299992, 13.531552429000087],
            [-14.196828979999907, 13.518788350000122],
            [-14.215794229999858, 13.510752665000041],
            [-14.271217203999925, 13.47695627800006],
            [-14.329947468999876, 13.456440735000086],
            [-14.347284912999896, 13.452358297000075],
            [-14.365552530999963, 13.454838766000051],
            [-14.3895820729999, 13.465871684000135],
            [-14.462134595999885, 13.516656128000093],
            [-14.470274820999919, 13.522354025000098],
            [-14.480377562999962, 13.533128561000112],
            [-14.486862955999925, 13.546538595000072],
            [-14.50022131399993, 13.58997263600007],
            [-14.509729777999922, 13.60909291700007],
            [-14.523243163999894, 13.625655213000059],
            [-14.54259598799996, 13.640822246000084],
            [-14.585539102999917, 13.66045929000012],
            [-14.626673542999896, 13.663508199000134],
            [-14.66718786699991, 13.652888692000062],
            [-14.728579467999907, 13.61932485000004],
            [-14.740930134999957, 13.615449117000082],
            [-14.754934448999848, 13.620384217000037],
            [-14.796017211999924, 13.644697978000039],
            [-14.802941853999897, 13.65232025200001],
            [-14.822372192999893, 13.717200012000134],
            [-14.831312214999912, 13.735622660000047],
            [-14.843972940999947, 13.75267588300008],
            [-14.86031381199993, 13.765595458000035],
            [-14.879267944999924, 13.780581156000054],
            [-14.915803181999962, 13.79244089800008],
            [-15.016778930999891, 13.79688507100009],
            [-15.076310180999883, 13.818950908000076],
            [-15.097704223999898, 13.81998443600007],
            [-15.170619669999894, 13.793784485000046],
            [-15.24596390799988, 13.746733094000064],
            [-15.267254597999852, 13.741797995000113],
            [-15.275729532999947, 13.748050842000026],
            [-15.295108194999926, 13.773191427000143],
            [-15.304461628999945, 13.781873067000106],
            [-15.347766479999933, 13.788642680000052],
            [-15.394068562999905, 13.771511943000093],
            [-15.43633988499991, 13.741177877000055],
            [-15.46750077299987, 13.708285828000015],
            [-15.478611206999886, 13.691258444000084],
            [-15.488946491999883, 13.67032948900001],
            [-15.496801310999928, 13.648341166000122],
            [-15.4980300899999, 13.641522305000095],
            [-15.50047033699991, 13.62798065200009],
            [-15.502485717999974, 13.588267314000106],
            [-15.518195353999943, 13.583099670000095],
            [-15.567132934999847, 13.58325470000004],
            [-15.6291963299999, 13.58351308200011],
            [-15.691363077999881, 13.583719788000067],
            [-15.753426473999951, 13.583978170000137],
            [-15.815593221999848, 13.584184876000094],
            [-15.877708292999927, 13.584443258000064],
            [-15.93977168799998, 13.584649964000022],
            [-16.001938435999875, 13.584908345000088],
            [-16.06405350799986, 13.585115052000049],
            [-16.085382943999946, 13.585168331000105],
            [-16.12611690299991, 13.58527008100009],
            [-16.188231973999905, 13.58552846300006],
            [-16.250295369999947, 13.585735169000117],
            [-16.312462117999928, 13.585993551000087],
            [-16.37457718999991, 13.58620025700013],
            [-16.43664058499988, 13.586458639000114],
            [-16.498755655999958, 13.586665345000071],
            [-16.56139916999996, 13.586914159000045],
            [-16.56151282499991, 13.587103583000044],
            [-16.57135982999995, 13.60179271000004],
            [-16.57640540299991, 13.612250067000048],
            [-16.57575436099995, 13.640326239000046],
            [-16.558664516999954, 13.655910549000055],
            [-16.53351803299995, 13.66860586100006],
            [-16.508168097999942, 13.687974351000037],
            [-16.513498501999948, 13.69086334800005],
            [-16.523793097999942, 13.698391018000052],
            [-16.529286261999914, 13.700995184000078],
            [-16.51659094999991, 13.712836005000042],
            [-16.50723222599993, 13.728094794000071],
            [-16.50890051999994, 13.74022044500009],
            [-16.529286261999914, 13.742621161000045],
            [-16.526600714999915, 13.726629950000074],
            [-16.53148352799991, 13.70726146000004],
            [-16.54210364499994, 13.69367096600007],
            [-16.55654863199993, 13.69476959800005],
            [-16.563710089999915, 13.673773505000042],
            [-16.579253709999932, 13.659572658000059],
            [-16.598866339999915, 13.65420156500005],
            [-16.618031378999945, 13.66006094000005],
            [-16.635568813999953, 13.67804596600007],
            [-16.640004035999937, 13.696478583000044],
            [-16.631703253999945, 13.73578522300005],
            [-16.629750128999945, 13.76048411700009],
            [-16.627105272999927, 13.770453192000048],
            [-16.618031378999945, 13.783596096000053],
            [-16.582508917999917, 13.824693101000037],
            [-16.57640540299991, 13.838812567000048],
            [-16.57054602799991, 13.835109768000052],
            [-16.55492102799991, 13.827948309000078],
            [-16.54914303299995, 13.82453034100007],
            [-16.551380988999938, 13.82908763200004],
            [-16.55654863199993, 13.845648505000042],
            [-16.521839972999942, 13.85179271000004],
            [-16.520130988999938, 13.83201732000009],
            [-16.512928839999915, 13.813299872000073],
            [-16.501576300999943, 13.801988023000092],
            [-16.487049933999913, 13.804632880000042],
            [-16.494618292999917, 13.827460028000075],
            [-16.49632727799991, 13.852728583000044],
            [-16.500599738999938, 13.872707424000055],
            [-16.515695766999954, 13.879787502000056],
            [-16.510365363999938, 13.89329661700009],
            [-16.488677537999934, 13.986395575000074],
            [-16.487049933999913, 14.002630927000041],
            [-16.50890051999994, 13.971380927000041],
            [-16.518055792999917, 13.951849677000041],
            [-16.525949673999946, 13.91046784100007],
            [-16.53620357999995, 13.88572825700004],
            [-16.549427863999938, 13.869289455000057],
            [-16.56281490799995, 13.87295156500005],
            [-16.57022050699993, 13.87295156500005],
            [-16.580230272999927, 13.859523830000057],
            [-16.59788977799991, 13.854315497000073],
            [-16.61864173099991, 13.851629950000074],
            [-16.637928839999915, 13.845648505000042],
            [-16.64867102799991, 13.836859442000048],
            [-16.65225175699993, 13.828558661000045],
            [-16.653920050999943, 13.820054429000038],
            [-16.659006313999953, 13.81085846600007],
            [-16.664458787999934, 13.805975653000075],
            [-16.675933397999927, 13.79954661700009],
            [-16.682525193999936, 13.794094143000052],
            [-16.69249426999994, 13.77570221600007],
            [-16.700062628999945, 13.769029039000088],
            [-16.710194464999915, 13.773627020000049],
            [-16.713368292999917, 13.783351955000057],
            [-16.713449673999946, 13.795721747000073],
            [-16.715321417999917, 13.806341864000046],
            [-16.72447669199994, 13.81085846600007],
            [-16.737212693999936, 13.819647528000075],
            [-16.74242102799991, 13.839422919000071],
            [-16.741078253999945, 13.86041901200008],
            [-16.734120245999918, 13.87295156500005],
            [-16.740223761999914, 13.88662344000005],
            [-16.74445553299995, 13.902167059000078],
            [-16.747792120999918, 13.934393622000073],
            [-16.746815558999913, 13.951361395000049],
            [-16.743397589999915, 13.961086330000057],
            [-16.737212693999936, 13.967678127000056],
            [-16.714222785999937, 13.985581773000092],
            [-16.702504035999937, 13.989976304000038],
            [-16.68968665299991, 13.99054596600007],
            [-16.660267706999946, 13.987250067000048],
            [-16.646311001999948, 13.982977606000077],
            [-16.636789516999954, 13.97492096600007],
            [-16.637928839999915, 13.96165599200009],
            [-16.623931443999936, 13.973944403000075],
            [-16.612904425999943, 13.988714911000045],
            [-16.598988410999937, 13.99681224200009],
            [-16.57640540299991, 13.988959052000041],
            [-16.576771613999938, 14.010972398000092],
            [-16.568918423999946, 14.020819403000075],
            [-16.556263800999943, 14.026922919000071],
            [-16.542347785999937, 14.03733958500004],
            [-16.554798956999946, 14.03310781500005],
            [-16.568348761999914, 14.03034088700008],
            [-16.580962693999936, 14.032782294000071],
            [-16.590728318999936, 14.04360586100006],
            [-16.545521613999938, 14.070990302000041],
            [-16.529286261999914, 14.085191148000092],
            [-16.50332597599993, 14.11627838700008],
            [-16.489125128999945, 14.128241278000075],
            [-16.457020636999914, 14.13735586100006],
            [-16.441477016999954, 14.15656159100007],
            [-16.429351365999935, 14.160956122000073],
            [-16.42100989499994, 14.157131252000056],
            [-16.412993943999936, 14.149807033000059],
            [-16.404693162999934, 14.145412502000056],
            [-16.394886847999942, 14.15037669500009],
            [-16.388824022999927, 14.154852606000077],
            [-16.37262936099995, 14.16242096600007],
            [-16.36473548099991, 14.167792059000078],
            [-16.427723761999914, 14.170111395000049],
            [-16.454741990999935, 14.180161851000037],
            [-16.452951626999948, 14.201849677000041],
            [-16.468739386999914, 14.193833726000037],
            [-16.474598761999914, 14.179388739000046],
            [-16.471506313999953, 14.164252020000049],
            [-16.46035722599993, 14.154120184000078],
            [-16.472767706999946, 14.147365627000056],
            [-16.48306230399993, 14.148138739000046],
            [-16.493072068999936, 14.151841539000088],
            [-16.504750128999945, 14.154120184000078],
            [-16.51317298099991, 14.15102773600006],
            [-16.516753709999932, 14.143459377000056],
            [-16.518788214999915, 14.134263414000088],
            [-16.521839972999942, 14.126166083000044],
            [-16.54751542899993, 14.081854559000078],
            [-16.55654863199993, 14.071519273000092],
            [-16.566802537999934, 14.066961981000077],
            [-16.588449673999946, 14.06195709800005],
            [-16.600331183999913, 14.054185289000088],
            [-16.609120245999918, 14.04319896000004],
            [-16.621571417999917, 14.019964911000045],
            [-16.631703253999945, 14.01007721600007],
            [-16.65416419199994, 14.002752997000073],
            [-16.675404425999943, 14.00690338700008],
            [-16.697010870999918, 14.014227606000077],
            [-16.721058722999942, 14.016302802000041],
            [-16.69758053299995, 14.057440497000073],
            [-16.69684811099995, 14.06468333500004],
            [-16.68000240799995, 14.06940338700008],
            [-16.65225175699993, 14.09951406500005],
            [-16.665638800999943, 14.095648505000042],
            [-16.678578253999945, 14.076117255000042],
            [-16.68968665299991, 14.071519273000092],
            [-16.711781378999945, 14.070868231000077],
            [-16.720529751999948, 14.068915106000077],
            [-16.727894660999937, 14.06468333500004],
            [-16.716135219999956, 14.051336981000077],
            [-16.71711178299995, 14.042385158000059],
            [-16.734120245999918, 14.023138739000046],
            [-16.737049933999913, 14.015448309000078],
            [-16.739613410999937, 14.001125393000052],
            [-16.744699673999946, 13.992743231000077],
            [-16.764556443999936, 13.97060781500005],
            [-16.768869594999956, 13.96165599200009],
            [-16.773426886999914, 13.93357982000009],
            [-16.768869594999956, 13.838812567000048],
            [-16.775054490999935, 13.838812567000048],
            [-16.780995245999918, 14.030747789000088],
            [-16.786000128999945, 14.059719143000052],
            [-16.802561001999948, 14.107855536000045],
            [-16.820790167999917, 14.143459377000056],
            [-16.829701300999943, 14.154120184000078],
            [-16.84276282499991, 14.16006094000005],
            [-16.868804490999935, 14.165757554000038],
            [-16.878732876999948, 14.17454661700009],
            [-16.88390051999994, 14.188950914000088],
            [-16.892404751999948, 14.242865302000041],
            [-16.898915167999917, 14.259955145000049],
            [-16.906971808999913, 14.27252838700008],
            [-16.925892706999946, 14.29124583500004],
            [-16.93455969999991, 14.29588450700004],
            [-16.941151495999918, 14.297267971000053],
            [-16.945464647999927, 14.30141836100006],
            [-16.947010870999918, 14.314520575000074],
            [-16.945790167999917, 14.324774481000077],
            [-16.940744594999956, 14.344427802000041],
            [-16.939564581999946, 14.355861721000053],
            [-16.94444739499994, 14.372381903000075],
            [-16.95653235599991, 14.390122789000088],
            [-16.987945115999935, 14.421047268000052],
            [-17.059478318999936, 14.453924872000073],
            [-17.070464647999927, 14.465399481000077],
            [-17.076161261999914, 14.478583075000074],
            [-17.111480272999927, 14.530218817000048],
            [-17.137847459999932, 14.599025783000059],
            [-17.178212042999917, 14.653143622000073],
            [-17.20693925699993, 14.678900458000044],
            [-17.22411048099991, 14.69041575700004],
            [-17.243763800999943, 14.699286200000074],
            [-17.265451626999948, 14.702826239000046],
            [-17.281646287999934, 14.70726146000004],
            [-17.324045376999948, 14.728908596000053],
            [-17.330555792999917, 14.73631419500009],
            [-17.36359615799995, 14.735907294000071],
            [-17.392323370999918, 14.73932526200008],
            [-17.41738847599993, 14.737697658000059],
            [-17.439808722999942, 14.722072658000059],
            [-17.431385870999918, 14.712469794000071],
            [-17.41934160099993, 14.70897044500009],
            [-17.42682857999995, 14.69440338700008],
            [-17.439808722999942, 14.68846263200004],
            [-17.436390753999945, 14.685288804000038],
            [-17.430246548999946, 14.67804596600007],
            [-17.42682857999995, 14.67487213700008],
            [-17.43301347599993, 14.660549221000053],
            [-17.436390753999945, 14.659572658000059],
            [-17.439808722999942, 14.65375397300005],
            [-17.452951626999948, 14.662054755000042],
            [-17.52017167899993, 14.743068752000056],
            [-17.536040818999936, 14.757391669000071],
            [-17.37096106699994, 14.800279039000088],
            [-17.32213294199994, 14.839016018000052],
            [-17.17296301999994, 14.900824286000045],
            [-17.138661261999914, 14.92772044500009],
            [-16.979725714999915, 15.111883856000077],
            [-16.94790605399993, 15.157863674000055],
            [-16.878244594999956, 15.233099677000041],
            [-16.739165818999936, 15.472398179000038],
            [-16.669667120999918, 15.561835028000075],
            [-16.53892981699994, 15.774359442000048],
            [-16.53429114499994, 15.784369208000044],
            [-16.536000128999945, 15.794663804000038],
            [-16.542347785999937, 15.80882396000004],
            [-16.51973628799996, 15.846372376000048],
            [-16.509917764999898, 15.901511129000127],
            [-16.50754064899985, 16.01039337200011],
            [-16.50159785999992, 16.02186553900013],
            [-16.487800251999886, 16.066048890000033],
            [-16.470436970999884, 16.106356507000086],
            [-16.465992797999945, 16.174052633000073],
            [-16.45875809799989, 16.19415476500005],
            [-16.44418534399992, 16.206298727000032],
            [-16.407288370999908, 16.214825338000068],
            [-16.391682087999868, 16.224747213000043],
            [-16.385377563999953, 16.234927470000017],
            [-16.381088419999884, 16.246658020000027],
            [-16.340160684999972, 16.415898336000097],
            [-16.33494136499985, 16.455792542000026],
            [-16.327396606999912, 16.474551087000023],
            [-16.313547322999852, 16.493309632000106],
            [-16.295098836999927, 16.510621237000024],
            [-16.27380814599985, 16.523178610000045],
            [-16.25101883999986, 16.52762278200005],
            [-16.217945922999945, 16.52152496300009],
            [-16.20673213799992, 16.520749817000066],
            [-16.195363321999935, 16.522713522000018],
            [-16.18518306499996, 16.527312724000055],
            [-16.15577917499988, 16.547518209000046],
            [-16.144307006999952, 16.552685853000057],
            [-16.132266397999985, 16.554752909000015],
            [-16.11965734899985, 16.55237579300008],
            [-16.11045894399996, 16.546949768],
            [-16.10306921399996, 16.539560039],
            [-16.09097692899988, 16.52219675700006],
            [-16.074027058999945, 16.504885153000075],
            [-16.053769897999956, 16.49542836500011],
            [-16.031187295999928, 16.492896220000105],
            [-16.007312784999925, 16.496151836000095],
            [-16.000181437999885, 16.501061096000043],
            [-15.993101765999882, 16.504626770000087],
            [-15.985608683999942, 16.50586700500004],
            [-15.977288777999973, 16.503954977000106],
            [-15.964369669999968, 16.498994039000067],
            [-15.958065144999864, 16.4984255990001],
            [-15.950675415999854, 16.499820862000078],
            [-15.911039590999877, 16.516874084000037],
            [-15.89693192599995, 16.518424378000063],
            [-15.861998656999958, 16.51025950100002],
            [-15.85357539899988, 16.51025950100002],
            [-15.828925740999864, 16.514548645],
            [-15.812957722999926, 16.513773499000095],
            [-15.767740844999935, 16.499459127000094],
            [-15.735288044999919, 16.497702128000114],
            [-15.726813110999927, 16.495273336000068],
            [-15.703196980999905, 16.48442128600003],
            [-15.687539021999953, 16.480545553000056],
            [-15.672191120999884, 16.481372376000067],
            [-15.657411661999959, 16.486178284000076],
            [-15.643614054999915, 16.494653219],
            [-15.621496541999903, 16.514238587000094],
            [-15.60966263799989, 16.52131825800005],
            [-15.594418090999852, 16.523643698000072],
            [-15.55147497599998, 16.515117086000046],
            [-15.536695515999952, 16.516512350000127],
            [-15.52480993699993, 16.52219675700006],
            [-15.515198119999923, 16.53093007400004],
            [-15.49091019699992, 16.564519755000063],
            [-15.478507853999957, 16.575165100000063],
            [-15.4639867759999, 16.581469625000082],
            [-15.448845580999887, 16.580177714000044],
            [-15.439440469999852, 16.572684632000076],
            [-15.433704386999892, 16.562504375000017],
            [-15.426883096999916, 16.553150941000084],
            [-15.41453243099997, 16.54803497400009],
            [-15.399804646999968, 16.548345032000086],
            [-15.385748656999851, 16.551755677000088],
            [-15.343632364999905, 16.568705546],
            [-15.328026082999969, 16.571961161],
            [-15.295935017999852, 16.57304636700009],
            [-15.248599405999897, 16.565811666000016],
            [-15.232476358999918, 16.566380107000086],
            [-15.125092732999917, 16.582709859000104],
            [-15.104008748999888, 16.590357971000103],
            [-15.097497517999926, 16.594492086000017],
            [-15.093208373999857, 16.600176494000053],
            [-15.092846638999958, 16.6076179],
            [-15.096153930999947, 16.61397410100001],
            [-15.112328653999953, 16.629218649000066],
            [-15.118271443999959, 16.64260284400008],
            [-15.116256062999923, 16.655521953000104],
            [-15.107574421999885, 16.66539215100009],
            [-15.0933117269999, 16.66916453],
            [-15.07889400299996, 16.664978739000063],
            [-15.069850626999909, 16.65526357000003],
            [-15.061995808999882, 16.643791403000094],
            [-15.051557169999853, 16.634179586000087],
            [-15.04437414599991, 16.631905823000082],
            [-15.036932739999884, 16.632577617000052],
            [-15.029853068999955, 16.63547149700004],
            [-15.023651895999876, 16.63996734700008],
            [-15.018742634999938, 16.64611684200004],
            [-15.016520547999932, 16.6525763960001],
            [-15.013368285999974, 16.666580709000087],
            [-15.006908731999914, 16.67583079000012],
            [-14.996625121999926, 16.68244537400001],
            [-14.97430090399996, 16.691385397000047],
            [-14.962932088999878, 16.685804342000026],
            [-14.949857950999927, 16.672316793000064],
            [-14.948934022999936, 16.670552930000056],
            [-14.941331339999891, 16.656038717000044],
            [-14.930944375999957, 16.643377991000094],
            [-14.912495890999963, 16.64063914000006],
            [-14.882006794999882, 16.64766713400006],
            [-14.711216185999973, 16.635781556000026],
            [-14.699692341999935, 16.637125143],
            [-14.665895954999968, 16.6456517540001],
            [-14.655974080999954, 16.645910136000097],
            [-14.647189086999958, 16.64353302000005],
            [-14.619077107999942, 16.63066558900006],
            [-14.608070027999958, 16.628805237000037],
            [-14.597011271999946, 16.62916697200005],
            [-14.555127522999953, 16.640587464000035],
            [-14.544456338999879, 16.640845846],
            [-14.50391617799994, 16.632680969000077],
            [-14.4930899659999, 16.632474264000038],
            [-14.482392944999901, 16.633662821000073],
            [-14.471954304999969, 16.636401672000105],
            [-14.462058267999879, 16.640794169000102],
            [-14.435832478999941, 16.655987041000017],
            [-14.426246500999952, 16.659604391000116],
            [-14.406635294999916, 16.660792948000037],
            [-14.343254149999893, 16.636660055000064],
            [-14.335528523999898, 16.63154408800007],
            [-14.331342732999872, 16.62410268200007],
            [-14.331756143999883, 16.613147278000085],
            [-14.337027139999918, 16.594130351000032],
            [-14.335321818999944, 16.586482239000034],
            [-14.325968383999907, 16.582399801000022],
            [-14.287650308999986, 16.58570709300004],
            [-14.277960977999953, 16.581262919000025],
            [-14.27457617199994, 16.573511454000098],
            [-14.273258422999959, 16.55563140900007],
            [-14.268064941999882, 16.54787994400006],
            [-14.257652140999937, 16.543177389000064],
            [-14.233674275999931, 16.54157541900004],
            [-14.222279622999935, 16.539611715000106],
            [-14.21416642199992, 16.534960836000053],
            [-14.197190713999902, 16.51346344000011],
            [-14.190085204999889, 16.507107239000064],
            [-14.166391560999926, 16.49088083900007],
            [-14.132440144999919, 16.452640280000068],
            [-14.073038085999883, 16.40065378900006],
            [-14.039835977999957, 16.38210195],
            [-14.033066364999911, 16.37605580700007],
            [-14.01559973199997, 16.35585032200008],
            [-14.00671138599995, 16.35026926700006],
            [-13.987048501999908, 16.34287953700006],
            [-13.97785009799992, 16.33797027600012],
            [-13.971855631999887, 16.331200663000075],
            [-13.971157999999889, 16.324224345000076],
            [-13.977462523999918, 16.308824768000093],
            [-13.979322875999912, 16.300349833],
            [-13.977281656999963, 16.293838602000037],
            [-13.96743729699989, 16.281384583000047],
            [-13.963044799999892, 16.27239288300011],
            [-13.962683064999908, 16.263969625000115],
            [-13.967799031999988, 16.246037903000044],
            [-13.96407832899996, 16.230069886000095],
            [-13.947050943999955, 16.22112986300006],
            [-13.907828531999883, 16.21001943000006],
            [-13.899586140999958, 16.205316875000065],
            [-13.883824829999867, 16.19374135400004],
            [-13.877236083999975, 16.186868388000065],
            [-13.872275146999925, 16.178755189000057],
            [-13.863826049999943, 16.151831767000047],
            [-13.85907181899995, 16.142271627000056],
            [-13.852767292999914, 16.13348663400005],
            [-13.84483496199988, 16.126045227000034],
            [-13.835765746999897, 16.120567525000055],
            [-13.827316649999915, 16.118500469000097],
            [-13.819203449999918, 16.119275615],
            [-13.811322794999882, 16.122066142000065],
            [-13.794941365999904, 16.131212870000056],
            [-13.778818318999924, 16.143201803000082],
            [-13.77199702999988, 16.15043650300005],
            [-13.754246174999963, 16.175344544000026],
            [-13.746701416999912, 16.182372539000042],
            [-13.738226481999902, 16.187126770000035],
            [-13.729415649999908, 16.189503886000082],
            [-13.720139729999886, 16.18996897400011],
            [-13.710579589999895, 16.1888837690001],
            [-13.712620808999958, 16.176068013000034],
            [-13.718305709999925, 16.15928815200006],
            [-13.722775227999904, 16.14609568300007],
            [-13.719571289999948, 16.135605367000025],
            [-13.714842894999947, 16.132763163000064],
            [-13.704481770999848, 16.128835754000093],
            [-13.699960082999922, 16.125631816000023],
            [-13.698849039999914, 16.12392649400006],
            [-13.697298746999877, 16.1203608200001],
            [-13.696006835999924, 16.11891388],
            [-13.693578043999878, 16.117518616000027],
            [-13.687454386999917, 16.115244853000107],
            [-13.684689696999953, 16.113797913000028],
            [-13.67812678999988, 16.108216859],
            [-13.67593054199989, 16.106924947000053],
            [-13.668954222999986, 16.10573639000002],
            [-13.6624171549999, 16.107441711000078],
            [-13.635028645999881, 16.12160105400004],
            [-13.629266723999905, 16.122789612000062],
            [-13.610482340999909, 16.122892965000077],
            [-13.606968343999938, 16.12325470000009],
            [-13.59939774599988, 16.125476787000068],
            [-13.569063679999942, 16.138189188000027],
            [-13.516405395999925, 16.149041239000084],
            [-13.502788654999932, 16.15441558900004],
            [-13.497259276999927, 16.1560692340001],
            [-13.491549031999881, 16.156275940000043],
            [-13.484934447999876, 16.154984029],
            [-13.483099935999888, 16.141031392000016],
            [-13.499868936999945, 16.110645650000052],
            [-13.501703450999855, 16.095142721000045],
            [-13.491549031999881, 16.0884247850001],
            [-13.455091308999982, 16.10222239200006],
            [-13.4400276289999, 16.101860657000074],
            [-13.435066690999946, 16.096537985000012],
            [-13.427031005999936, 16.08305043500006],
            [-13.422095906999914, 16.07721099900006],
            [-13.394578206999938, 16.059279276],
            [-13.388557901999889, 16.052096253000045],
            [-13.386051594999913, 16.04439646400006],
            [-13.385043904999861, 16.0268781540001],
            [-13.383674478999865, 16.019178365000087],
            [-13.369773518999892, 15.98548533100005],
            [-13.36333980299986, 15.975098368000104],
            [-13.355795043999905, 15.965538229000018],
            [-13.34701004999991, 15.95675323500005],
            [-13.321766113999956, 15.938149719000094],
            [-13.315926675999947, 15.930449931000098],
            [-13.313730427999872, 15.922130026000033],
            [-13.314350544999854, 15.913603414000121],
            [-13.318174601999885, 15.896705221000033],
            [-13.318174601999885, 15.888488668],
            [-13.316030028999904, 15.881770732000078],
            [-13.311766723999938, 15.875776266000045],
            [-13.293654133999922, 15.855312399000084],
            [-13.284765787999902, 15.839912822000102],
            [-13.279959879999893, 15.822859599000068],
            [-13.279675658999906, 15.803532613000115],
            [-13.281897745999913, 15.795109355000122],
            [-13.285230875999929, 15.786634420000027],
            [-13.287452961999918, 15.778159485000018],
            [-13.28613521299988, 15.769632874000095],
            [-13.28096756999986, 15.762811585000051],
            [-13.27396541399986, 15.757488912],
            [-13.258669189999921, 15.748807272000036],
            [-13.250659342999938, 15.742761129000101],
            [-13.24394140599992, 15.73578481],
            [-13.232546752999923, 15.719610087000106],
            [-13.228257608999854, 15.711290182000042],
            [-13.227120727999932, 15.70395212800004],
            [-13.228877725999922, 15.696614075000056],
            [-13.243993082999907, 15.673721415000031],
            [-13.247662108999918, 15.665608216000024],
            [-13.248747314999918, 15.656719870000117],
            [-13.247300373999906, 15.648296611000134],
            [-13.237843586999958, 15.623440247000062],
            [-13.22280574499996, 15.623853658000073],
            [-13.192807576999911, 15.628969625000067],
            [-13.178234821999865, 15.628194479000072],
            [-13.171051798999912, 15.625352275000083],
            [-13.152551635999885, 15.612407329000078],
            [-13.145239419999882, 15.60953928700009],
            [-13.122217569999918, 15.603493143000051],
            [-13.109711873999942, 15.596413473000027],
            [-13.099014851999925, 15.586879171000035],
            [-13.091805989999955, 15.575122782000037],
            [-13.08945471199985, 15.561040955000024],
            [-13.095087442999954, 15.5234205120001],
            [-13.094958251999913, 15.514713033000035],
            [-13.093097900999908, 15.506212260000027],
            [-13.089583902999948, 15.497039693000133],
            [-13.083845013999849, 15.492750019000098],
            [-13.053229532999893, 15.485102438000084],
            [-13.038889322999893, 15.486885274000073],
            [-13.023773966999897, 15.495954489000027],
            [-13.010544799999906, 15.506289774000052],
            [-12.995842854999893, 15.514222107000094],
            [-12.980184895999855, 15.51628916500006],
            [-12.964320230999931, 15.50915781700003],
            [-12.95801570699993, 15.501742249000117],
            [-12.954940958999885, 15.49306060800005],
            [-12.9509101969999, 15.465413717000033],
            [-12.9476029059999, 15.458618266000101],
            [-12.937551839999855, 15.445776673000111],
            [-12.933055988999854, 15.438283590000069],
            [-12.931169799999935, 15.430532125000056],
            [-12.931014769999877, 15.397045797000061],
            [-12.927216552999937, 15.380741883000042],
            [-12.918974161999898, 15.365368144000058],
            [-12.906830199999916, 15.352681580000109],
            [-12.847273111999925, 15.3132783],
            [-12.83453487199995, 15.30023000100006],
            [-12.828049478999901, 15.28387441000011],
            [-12.833449666999883, 15.26999928800005],
            [-12.850037801999889, 15.267389629000121],
            [-12.884195922999965, 15.270826111000062],
            [-12.894376180999927, 15.263358866000132],
            [-12.888355875999906, 15.25087900800014],
            [-12.86548905399988, 15.228683980000113],
            [-12.856781575999918, 15.221991882000097],
            [-12.847893229999897, 15.218942973000068],
            [-12.838333088999889, 15.218762106000028],
            [-12.816964883999901, 15.223077088000096],
            [-12.806397053999916, 15.223077088000096],
            [-12.7963201499999, 15.220286560000133],
            [-12.787225096999919, 15.214162903000073],
            [-12.7819799399999, 15.207289937000013],
            [-12.779473632999895, 15.199615987000115],
            [-12.779266926999867, 15.19139943500008],
            [-12.784667113999916, 15.166026306000091],
            [-12.78399532099985, 15.158145650000051],
            [-12.78092057299989, 15.149076436000087],
            [-12.779757852999893, 15.146389262000056],
            [-12.754565591999949, 15.138560282000128],
            [-12.746639016999922, 15.1311359420001],
            [-12.717048502999944, 15.103420308000082],
            [-12.690305948999878, 15.092387390000084],
            [-12.689585456999879, 15.092478506000077],
            [-12.679273029999877, 15.093782654000066],
            [-12.64764705399989, 15.103161927000102],
            [-12.632273314999907, 15.105435689000032],
            [-12.622945719999876, 15.102257589000061],
            [-12.615065062999946, 15.094609477000091],
            [-12.60214595599993, 15.07877065000008],
            [-12.547058878999877, 15.047170512],
            [-12.529592244999918, 15.034354757000116],
            [-12.518972736999928, 15.028282776000069],
            [-12.495563313999867, 15.023011780000033],
            [-12.484892130999867, 15.01727569600007],
            [-12.476262165999913, 15.007741395000082],
            [-12.47150793399993, 14.998000387000047],
            [-12.448201863999913, 14.918211976000066],
            [-12.447633422999928, 14.90743743900012],
            [-12.433835815999885, 14.899427592000052],
            [-12.400091104999916, 14.860386047000048],
            [-12.382495279999944, 14.846019999000049],
            [-12.319579223999938, 14.817184550000022],
            [-12.2641304119999, 14.774939067000034],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Nigeria',
        iso3: 'NGA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [3.596400187000114, 11.69577301000001],
              [3.647766561000083, 11.726003723000105],
              [3.659858846000077, 11.738096009000103],
              [3.666990194000107, 11.759696757000071],
              [3.662029256000068, 11.779488831000052],
              [3.649730265000102, 11.797833964000034],
              [3.626269165000053, 11.822535299000052],
              [3.622031698000086, 11.825015768000114],
              [3.618621053000055, 11.828374736000029],
              [3.612936645000019, 11.838968405000102],
              [3.609732707000148, 11.848786927000077],
              [3.60394494600007, 11.905579325000105],
              [3.608492473000098, 11.921960754000054],
              [3.619551229000109, 11.936275127000044],
              [3.636604452000142, 11.953586732000048],
              [3.653554321000058, 11.986814677000083],
              [3.648903442000091, 12.021024475000075],
              [3.62399540200002, 12.094249980000072],
              [3.624512166000073, 12.13765818300007],
              [3.651487264000082, 12.269019674000063],
              [3.641565389000107, 12.517996725000103],
              [3.645699503000117, 12.528538716000071],
              [3.864394165000135, 12.68966583300005],
              [3.92909305800012, 12.750385641000051],
              [4.088773234000115, 12.996236267000143],
              [4.120324552000056, 13.210607869000043],
              [4.12370650200009, 13.23358612100013],
              [4.125773559000066, 13.47297719400008],
              [4.190472453000041, 13.475018413000043],
              [4.220548136000104, 13.48062530500006],
              [4.248453409000092, 13.49413869200012],
              [4.405756470000142, 13.641235657000095],
              [4.452575318000072, 13.673765971000122],
              [4.506732218000082, 13.694669088000111],
              [4.625844677000089, 13.7231508200001],
              [4.824852335000116, 13.770736797000083],
              [4.856891724000121, 13.774095765000098],
              [4.879836060000059, 13.764018860000064],
              [4.902366984000082, 13.742986552000048],
              [4.925104614000134, 13.733090516000061],
              [4.983188924000046, 13.729679871000116],
              [5.084371378000128, 13.747534078000072],
              [5.227618449000147, 13.741332907000086],
              [5.262034953000096, 13.747740784000129],
              [5.273507120000119, 13.75252085400004],
              [5.304202922000059, 13.773940735000053],
              [5.3180522050001, 13.78993459100009],
              [5.334795369000062, 13.826702372000085],
              [5.346267538000092, 13.841559347000029],
              [5.374069458000122, 13.855253601000044],
              [5.521760701000062, 13.880290832000057],
              [5.554316854000092, 13.873417867000086],
              [5.837348673500145, 13.76374755900008],
              [6.120380493000113, 13.65407725100009],
              [6.129475545000076, 13.649064637000023],
              [6.135780069000106, 13.64366445000006],
              [6.142394653000082, 13.640822246000084],
              [6.152833293000128, 13.643561097000116],
              [6.210607543000037, 13.675264587000044],
              [6.229831176000062, 13.679191996000014],
              [6.284207679000104, 13.667656410000077],
              [6.302178181000102, 13.663844096000048],
              [6.368944133000042, 13.626275330000041],
              [6.509297322000094, 13.496050721000046],
              [6.672543172000132, 13.321177673000122],
              [6.753879129000069, 13.174899667000062],
              [6.778686564000083, 13.13028493300007],
              [6.83790775500006, 13.06349314400012],
              [6.874184611000118, 13.030497742000051],
              [6.906637410000144, 13.00685577400013],
              [6.937126505000037, 12.995409444000117],
              [6.970509481000107, 12.991843771000049],
              [7.04492354300001, 12.992205506000047],
              [7.062920948000112, 12.995139865000098],
              [7.068694702000073, 12.996081238000102],
              [7.090088745000088, 13.006390686000103],
              [7.137424357000043, 13.047240906000098],
              [7.198195841000143, 13.117391663000063],
              [7.220520061000116, 13.121577454000104],
              [7.324803100000054, 13.102844747000105],
              [7.3606665450001, 13.102638042000052],
              [7.391982463000119, 13.112534078000053],
              [7.755577840000115, 13.32714630200006],
              [7.789684286000067, 13.341977437000082],
              [7.823997436000099, 13.345284729000085],
              [8.077522013000078, 13.310015564000096],
              [8.105117228000069, 13.299654440000083],
              [8.11658939600008, 13.291050314000046],
              [8.140050496000072, 13.269113668000088],
              [8.167645711000148, 13.25237050400004],
              [8.201442098000143, 13.22637725800007],
              [8.216014852000114, 13.219607646000043],
              [8.245677124000082, 13.211778666000015],
              [8.246727828000132, 13.211291661000047],
              [8.25983646600011, 13.205215759000026],
              [8.273065633000101, 13.193872783000046],
              [8.297973673000087, 13.16462392200009],
              [8.397812541000093, 13.07540456200006],
              [8.405150594000105, 13.07085703600012],
              [8.415175822000037, 13.067058817000088],
              [8.418999877000147, 13.066697083000093],
              [8.423133993000079, 13.069487610000053],
              [8.434502807000086, 13.075094503000074],
              [8.445974976000088, 13.078711853000058],
              [8.470779663000116, 13.081657410000062],
              [8.482665242000053, 13.081554057000034],
              [8.50964034000009, 13.075921326000099],
              [8.533514851000064, 13.064630025000028],
              [8.577233114000137, 13.032435608000085],
              [8.596766805000073, 13.011403300000069],
              [8.62549890200006, 12.964791158000097],
              [8.642655477000119, 12.944353129000135],
              [8.679345743000084, 12.923579204000106],
              [8.942792196000084, 12.847201436000148],
              [8.977871813000093, 12.843182822000088],
              [9.269387248000015, 12.809787699000083],
              [9.306490926000095, 12.809839376000099],
              [9.359821004000082, 12.82459299700011],
              [9.377907756000099, 12.825781555000034],
              [9.590297892000109, 12.801390280000106],
              [9.611485229000067, 12.802940572000125],
              [9.61840987100004, 12.8057827760001],
              [9.629261922000097, 12.812784933000103],
              [9.640734090000109, 12.822525940000048],
              [9.647657343000077, 12.830537962000037],
              [9.819327840000142, 13.029205831000098],
              [9.852814169000055, 13.060444234000087],
              [9.872037801000147, 13.072562358000084],
              [9.882683146000147, 13.076231384000081],
              [9.88774743600004, 13.075507915000088],
              [9.891778198000111, 13.076231384000081],
              [9.899736368000077, 13.08431874600008],
              [9.904387247000045, 13.094343974000097],
              [9.908211303000087, 13.11878692700013],
              [9.912448771000129, 13.129199728000074],
              [9.93012211100006, 13.145968729000032],
              [10.119774618000065, 13.250096741000021],
              [10.161529175000112, 13.267201640000067],
              [10.647881836000067, 13.36940618400007],
              [10.674986206000113, 13.375102030000079],
              [10.771311076000103, 13.38269846600005],
              [10.953005412000067, 13.36189870200009],
              [11.440004110000075, 13.364430848000083],
              [11.742311238000127, 13.289448344000022],
              [11.852795451000134, 13.245394186000041],
              [11.99190840600005, 13.1620917770001],
              [12.038003784000068, 13.126357524000099],
              [12.057640828000103, 13.116771546000095],
              [12.116448609000088, 13.102844747000105],
              [12.149624878000083, 13.105583598000052],
              [12.163784220000139, 13.1079607140001],
              [12.18476485100004, 13.122094218000129],
              [12.201404663000062, 13.125427348000045],
              [12.251840861000062, 13.108012390000113],
              [12.263209676000145, 13.101862895000053],
              [12.267033732000101, 13.095170797000037],
              [12.267447143000112, 13.089641419000117],
              [12.269204142000092, 13.085869039000102],
              [12.277162313000133, 13.08447377500002],
              [12.280883016000075, 13.086850891000068],
              [12.285327189000071, 13.092018535000065],
              [12.291528361000047, 13.096824443000074],
              [12.30103682500004, 13.098116354000126],
              [12.310958699000139, 13.092638652000048],
              [12.318400105000137, 13.083853658000052],
              [12.325738159000139, 13.078815206000087],
              [12.335246622000028, 13.08447377500002],
              [12.35157637500015, 13.079797058000054],
              [12.386741699000083, 13.078580465000115],
              [12.414311564000116, 13.077626648000063],
              [12.437255900000139, 13.074009298000078],
              [12.456376180000035, 13.06742055300009],
              [12.472705932000082, 13.0641649370001],
              [12.48665856900007, 13.070805359000104],
              [12.491206096000099, 13.08263926200003],
              [12.499784383000133, 13.135969340000102],
              [12.504331909000086, 13.139612529000104],
              [12.526966186000038, 13.1436432900001],
              [12.53451094500008, 13.145917054000023],
              [12.542572469000078, 13.154779561000026],
              [12.547946818000128, 13.16545074500003],
              [12.554251343000118, 13.187542420000028],
              [12.53833500200011, 13.193356018000102],
              [12.54515629000008, 13.208212993000046],
              [12.5581787510001, 13.22653228800003],
              [12.561072631000087, 13.242758687000034],
              [12.597556193000088, 13.276503398000088],
              [12.60272383600011, 13.279991557000045],
              [12.60613448100014, 13.274229635000083],
              [12.613265829000085, 13.276503398000088],
              [12.620190471000058, 13.281438497000039],
              [12.626805054000044, 13.288259786000083],
              [12.628768758000092, 13.2941767370001],
              [12.630008993000018, 13.31037729900001],
              [12.640654337000115, 13.30239329100003],
              [12.649232626000128, 13.293608297000048],
              [12.659154500000056, 13.286606140000046],
              [12.674347371000067, 13.283712260000058],
              [12.683132365000063, 13.288931580000067],
              [12.690057006000131, 13.311979269000034],
              [12.701735880000115, 13.317250264000066],
              [12.724370158000056, 13.322288717000035],
              [12.740803264000107, 13.334820252000043],
              [12.766538127000103, 13.36567108200012],
              [12.773256062000144, 13.382233378000123],
              [12.774599650000113, 13.38269846600005],
              [12.777390177000058, 13.386703390000037],
              [12.783281291000065, 13.382336731000052],
              [12.788965698000112, 13.375463765000077],
              [12.791136108000103, 13.371846415000093],
              [12.805192098000106, 13.372983297000104],
              [12.804778687000095, 13.376859029000059],
              [12.798474161000087, 13.384274597000072],
              [12.794546753000134, 13.396056824000084],
              [12.797337280000079, 13.399648336000055],
              [12.810669799000095, 13.404299215000023],
              [12.815010620000095, 13.406624655000144],
              [12.817594441000097, 13.40729644800004],
              [12.82627608200005, 13.406056214000088],
              [12.829273315000052, 13.406624655000144],
              [12.829996786000066, 13.409363505000087],
              [12.828549845000055, 13.417450867000085],
              [12.829273315000052, 13.42029307100006],
              [12.8570752360001, 13.45065297500011],
              [12.870201050000077, 13.461246643000095],
              [12.863896525000058, 13.469282328000077],
              [12.857592, 13.475328471000111],
              [12.850564006000042, 13.47938507100011],
              [12.84229577700009, 13.481684673000046],
              [12.84229577700009, 13.489126079000073],
              [12.857798706000011, 13.484914449000115],
              [12.870614461000088, 13.478868307000084],
              [12.87970951300008, 13.479695129000106],
              [12.88384362800008, 13.49599904400013],
              [12.911748901000067, 13.489901225000082],
              [12.939344116000058, 13.495068868000075],
              [13.029261109000089, 13.539174703000072],
              [13.054892619000071, 13.548373108000064],
              [13.082487834000062, 13.55062103300007],
              [13.082487834000062, 13.54439402300008],
              [13.077010131000065, 13.534678854000049],
              [13.088275594000038, 13.530596415000034],
              [13.107085815000062, 13.531552429000087],
              [13.123518921000112, 13.536952617000068],
              [13.12382897900008, 13.533438619],
              [13.123518921000112, 13.52266408300008],
              [13.130960327000139, 13.529821269000124],
              [13.138401733000137, 13.546538595000072],
              [13.143982788000073, 13.55062103300007],
              [13.153697957000105, 13.548760681000076],
              [13.155868368000085, 13.54077667300001],
              [13.153697957000105, 13.530699768000062],
              [13.15018396000005, 13.52266408300008],
              [13.176952352000114, 13.534472148000091],
              [13.203927450000066, 13.539381409000029],
              [13.228112020000111, 13.548037212000068],
              [13.24640547700011, 13.57108490000013],
              [13.23224613400015, 13.572893575000123],
              [13.230179077000088, 13.577751160000048],
              [13.239480835000109, 13.591574605000105],
              [13.24382165500009, 13.593254090000059],
              [13.250849650000106, 13.592763163000114],
              [13.257257528000139, 13.594235942000125],
              [13.260048055000112, 13.60214243600008],
              [13.258601115000118, 13.607801005000113],
              [13.25353682500014, 13.614880676000041],
              [13.253846883000108, 13.61891143900003],
              [13.259221232000073, 13.628962505000061],
              [13.266145874000074, 13.638031719000125],
              [13.306040079000098, 13.674644471000079],
              [13.321232951000127, 13.685108948000021],
              [13.320716186000084, 13.702291362000082],
              [13.32991459100009, 13.709422709000123],
              [13.358919718000038, 13.714231979000132],
              [13.359990275000143, 13.714409485000076],
              [13.607313680000061, 13.704100037000075],
              [13.836111084000123, 13.391044210000018],
              [14.0649084880001, 13.077988383000061],
              [14.121132446000075, 12.811790161500085],
              [14.177356404000136, 12.545591940000094],
              [14.178699992000105, 12.468335673000112],
              [14.180216224000048, 12.463530383000062],
              [14.18541792800005, 12.447044983000126],
              [14.185107870000138, 12.427873027000118],
              [14.179113403000116, 12.397280579000011],
              [14.179836873000113, 12.385601705000042],
              [14.188931925000077, 12.370408834000102],
              [14.202161092000097, 12.362502340000063],
              [14.217560669000079, 12.359298402000078],
              [14.423129516000131, 12.353148906000115],
              [14.48710493900009, 12.33780100600005],
              [14.514390096000113, 12.323538310000075],
              [14.517594035000087, 12.313358053000101],
              [14.512426391000076, 12.2986302690001],
              [14.514390096000113, 12.28938018800008],
              [14.521521444000143, 12.28235219300008],
              [14.551183715000036, 12.260441386000124],
              [14.562139120000097, 12.255842184000073],
              [14.562139120000097, 12.248400778000061],
              [14.558315063000066, 12.246902161000051],
              [14.548496541000077, 12.241579488000099],
              [14.568133585000112, 12.22773020400004],
              [14.588287394000105, 12.217188213000071],
              [14.604100382000098, 12.204320781000078],
              [14.61061161300006, 12.183546855000131],
              [14.616296020000107, 12.178947652000076],
              [14.629318481000041, 12.183495179000118],
              [14.6431677650001, 12.19062652600006],
              [14.651539348000085, 12.193778789000106],
              [14.663424927000108, 12.18757761700003],
              [14.668282512000133, 12.178069153000138],
              [14.66993615700008, 12.167423808000052],
              [14.650609172000117, 12.148096822000099],
              [14.648128703000054, 12.141843974000011],
              [14.6431677650001, 12.135849508000078],
              [14.637173299000068, 12.124222311000025],
              [14.619913370000091, 12.052495423000025],
              [14.622187133000097, 12.042005106000076],
              [14.604307088000041, 12.030429586000125],
              [14.606270792000089, 12.011257629000028],
              [14.625184367000116, 11.968107809000088],
              [14.626941365000107, 11.957204082000132],
              [14.62714807100005, 11.950072734000088],
              [14.623427368000137, 11.916534729000077],
              [14.612058553000054, 11.884960429000103],
              [14.590664510000039, 11.783157857000049],
              [14.583223104000126, 11.766363017000074],
              [14.546532837000143, 11.718613993000105],
              [14.54188195800009, 11.709829000000113],
              [14.543328898000084, 11.701095683000048],
              [14.552423950000048, 11.689003398000068],
              [14.556454712000061, 11.687504781000058],
              [14.573507935000094, 11.6877114870001],
              [14.580949341000093, 11.683267314000105],
              [14.58508345600012, 11.676807760000145],
              [14.588597452000073, 11.6696764120001],
              [14.593868449000098, 11.663010152000098],
              [14.61019820100006, 11.646835429000106],
              [14.621360311000075, 11.629782206000073],
              [14.62714807100005, 11.60968007400001],
              [14.627561483000079, 11.584358623000128],
              [14.623840780000052, 11.563481344000053],
              [14.616192667000092, 11.538676656000106],
              [14.605754029000138, 11.514724630000018],
              [14.593765096000084, 11.496431173000133],
              [14.57660852100011, 11.48733612100007],
              [14.524932088000071, 11.468835958000042],
              [14.503951456000095, 11.456304424000038],
              [14.467261190000102, 11.423851624000108],
              [14.446280558000097, 11.411681824000112],
              [14.38705936600013, 11.393388367000043],
              [14.36824914600001, 11.383001404000112],
              [14.279158976000105, 11.301843567000063],
              [14.271304158000078, 11.298639628000089],
              [14.244329061000144, 11.295435690000119],
              [14.232133423000022, 11.290293884000036],
              [14.204641561000074, 11.262130229000078],
              [14.186761515000086, 11.249236959000072],
              [14.165470826000103, 11.238333232000102],
              [14.143249959000087, 11.232726338000091],
              [14.12257938600007, 11.235723572000012],
              [14.05250614400012, 11.265153300000094],
              [14.01312870300012, 11.27636708600005],
              [13.98232954900007, 11.276263733000107],
              [13.943882284000097, 11.245722962000116],
              [13.906261841000088, 11.208025004000078],
              [13.87318892400009, 11.166502991000087],
              [13.849211059000083, 11.124567566000096],
              [13.83205448400011, 11.084802551000095],
              [13.820065552000074, 11.069273783000071],
              [13.78203169800014, 11.047518006000061],
              [13.765908650000142, 11.033901265000068],
              [13.754849894000131, 11.016718852000096],
              [13.75040572100005, 10.99620330800012],
              [13.757020304000037, 10.9582469690001],
              [13.749838822000129, 10.942441823000138],
              [13.744411254000113, 10.930496725000069],
              [13.566282593000011, 10.679013367000039],
              [13.53879073000013, 10.621419983000095],
              [13.50127364100004, 10.496337179000108],
              [13.467167196000077, 10.307589010000115],
              [13.444842976000103, 10.245473938000131],
              [13.44453291800005, 10.232477315000025],
              [13.451354207000094, 10.212116801000079],
              [13.453007853000116, 10.20051544200004],
              [13.45083744300004, 10.187157084000091],
              [13.434921102000118, 10.153412374000126],
              [13.423242229000039, 10.138477886000075],
              [13.401951538000077, 10.122380677000095],
              [13.392671966000108, 10.116957418000084],
              [13.378387085000071, 10.108608907000061],
              [13.359783569000115, 10.100547384000066],
              [13.281338745000085, 10.09209828700007],
              [13.247955770000118, 10.07941172300012],
              [13.230179077000088, 10.045331116000071],
              [13.230489136000074, 10.025358175000036],
              [13.242478068000139, 9.992672831000064],
              [13.24640547700011, 9.973475037000043],
              [13.242271362000082, 9.949755554000092],
              [13.218706909000076, 9.913039449000024],
              [13.211058798000096, 9.892756449000018],
              [13.212712443000044, 9.870148010000065],
              [13.222944376000044, 9.854128316000114],
              [13.251986531000114, 9.82423350000009],
              [13.26294193600009, 9.80172841500007],
              [13.260461467000113, 9.78570872000003],
              [13.251056356000078, 9.769249777000056],
              [13.241341187000017, 9.745323588000048],
              [13.228422078000108, 9.677911682000044],
              [13.223461141000058, 9.613135275000033],
              [13.195452515000056, 9.54220937100007],
              [13.130340210000071, 9.516526184000085],
              [13.051688680000098, 9.50451141400012],
              [12.982442261000074, 9.474590759000094],
              [12.96900638800011, 9.464074605000036],
              [12.940067586000055, 9.427100119000087],
              [12.929008830000072, 9.416118877000102],
              [12.92074060100012, 9.410486146000068],
              [12.86203617300015, 9.382890931000077],
              [12.855421590000077, 9.378110860000078],
              [12.848393595000061, 9.35994659500004],
              [12.853147827000043, 9.356639303000051],
              [12.881569865000074, 9.35222096800004],
              [12.891285034000106, 9.33198964500005],
              [12.899346557000086, 9.302017314000096],
              [12.89841638200005, 9.26243316600005],
              [12.894592326000094, 9.243958842000026],
              [12.888391154000118, 9.226724752000052],
              [12.842192424000075, 9.144430033000077],
              [12.82214196800004, 9.096810201000054],
              [12.821005086000099, 9.056425070000074],
              [12.828239787000086, 9.019967346000072],
              [12.805708862000074, 8.831503397000063],
              [12.794546753000134, 8.788611959000107],
              [12.772946004000062, 8.75905303900008],
              [12.759613484000027, 8.753420309000134],
              [12.747211141000065, 8.753627014000102],
              [12.734498738000099, 8.755900777000107],
              [12.720236043000028, 8.756469218000078],
              [12.708867228000145, 8.75091400100007],
              [12.70163252800009, 8.739157613000074],
              [12.692847534000094, 8.710890605000088],
              [12.678171428000098, 8.678696187000043],
              [12.660394735000068, 8.65931752600008],
              [12.557972046000145, 8.605677389000093],
              [12.542572469000078, 8.602008362000106],
              [12.52779300900005, 8.604850565000078],
              [12.49554691500009, 8.619552510000076],
              [12.482524454000043, 8.62324737600008],
              [12.464334350000115, 8.6211544800001],
              [12.45182865400011, 8.614694926000055],
              [12.440253133000056, 8.606607565000061],
              [12.424440145000062, 8.599786275000099],
              [12.410590861000088, 8.59849436500005],
              [12.396328166000046, 8.60076812800007],
              [12.36883630400007, 8.609578960000064],
              [12.377001180000065, 8.595109559000122],
              [12.400462280000056, 8.538420512000116],
              [12.403252808000104, 8.524235332000075],
              [12.403872925000087, 8.496536764000055],
              [12.395191284000106, 8.487338359000134],
              [12.365115601000042, 8.466564433000102],
              [12.357570842000086, 8.456358338000129],
              [12.35116296300015, 8.444240214000047],
              [12.343204793000098, 8.432742208000107],
              [12.331319214000075, 8.42429311200003],
              [12.310235229000028, 8.42134755500011],
              [12.271787964000083, 8.427781271000072],
              [12.249980510000057, 8.41876373300002],
              [12.227036173000045, 8.386310934000093],
              [12.219284709000107, 8.343161112000075],
              [12.221765177000094, 8.297660014000101],
              [12.237681518000016, 8.216889750000064],
              [12.236751343000066, 8.196994324000059],
              [12.233713188000138, 8.188454644000032],
              [12.229103231000096, 8.175496928000115],
              [12.188278849000085, 8.11777435300013],
              [12.182594442000067, 8.093486430000041],
              [12.182697795000081, 8.05465159100008],
              [12.18817549600007, 8.016256002000148],
              [12.195100138000043, 7.991709696000086],
              [12.197787313000077, 7.975173239000085],
              [12.19210290600003, 7.960652161000041],
              [12.15427575700005, 7.921326396000055],
              [12.054953654000087, 7.783918763000116],
              [12.018986857000101, 7.718858134000044],
              [12.012165568000057, 7.69834259100007],
              [12.009064982000098, 7.676328430000083],
              [12.010718628000063, 7.655244446000069],
              [12.024981323000134, 7.596591696000118],
              [12.021053915000067, 7.576231181000097],
              [12.008548217000055, 7.564862366000099],
              [11.992838582000104, 7.554010315000056],
              [11.966173543000139, 7.514426168000099],
              [11.903545283000057, 7.453556830000068],
              [11.84473392700005, 7.396397197000042],
              [11.782722209000099, 7.304516500000062],
              [11.762465047000092, 7.285551249000108],
              [11.744585001000132, 7.272167054000079],
              [11.73662683100008, 7.263278707000069],
              [11.742414592000046, 7.257439270000077],
              [11.766185750000119, 7.252943421000055],
              [11.780241740000122, 7.241057841000028],
              [11.82995446800004, 7.169382630000143],
              [11.868918497000038, 7.127111308000067],
              [11.881320842000093, 7.102048239000055],
              [11.872225789000112, 7.079362284000084],
              [11.862613973000123, 7.075434876000116],
              [11.854139038000113, 7.077811992000065],
              [11.845147339000079, 7.081946106000089],
              [11.833985230000053, 7.082979635000072],
              [11.820342651000118, 7.078793843000128],
              [11.808870484000096, 7.071920878000071],
              [11.766392456000062, 7.033525289000039],
              [11.751509643000134, 7.023965149000048],
              [11.748615764000135, 7.014973450000099],
              [11.746858764000052, 7.005361634000081],
              [11.741071004000077, 6.997506815000051],
              [11.734249715000118, 6.995078024000094],
              [11.718643433000096, 6.994457906000122],
              [11.70748132400007, 6.991822408000104],
              [11.697249389000092, 6.992855937000087],
              [11.6924951580001, 6.991615703000136],
              [11.688464396000086, 6.986913147000067],
              [11.684847046000101, 6.97383901000012],
              [11.681126343000102, 6.968619690000097],
              [11.623248739000076, 6.932291158000041],
              [11.561753784000075, 6.876067200000051],
              [11.543667033000048, 6.850694071000063],
              [11.53808597800014, 6.823899841000085],
              [11.544597209000102, 6.808939515000105],
              [11.5666113690001, 6.78418650400009],
              [11.571468954000096, 6.766228943000016],
              [11.568885132000105, 6.739098816000137],
              [11.56237390100003, 6.712485454000017],
              [11.533435099000087, 6.645099386000098],
              [11.509767294000142, 6.612310689000083],
              [11.482585490000048, 6.597169495000074],
              [11.443104695000045, 6.593267924000116],
              [11.416749715000066, 6.572003073000133],
              [11.401763550000084, 6.538180848000053],
              [11.395665731000037, 6.496736348000084],
              [11.389361206000046, 6.473921204000092],
              [11.369827515000111, 6.45575693800015],
              [11.344196004000139, 6.443122050000028],
              [11.31949467000004, 6.437282613000122],
              [11.308539266000082, 6.437902731000094],
              [11.28683516500007, 6.443225403000056],
              [11.275879761000084, 6.444207255000023],
              [11.272159058000085, 6.442036845000118],
              [11.261513713000085, 6.432554220000057],
              [11.255519247000052, 6.429970398000052],
              [11.248284546000093, 6.431003927000035],
              [11.237122437000068, 6.438057759000046],
              [11.231748087000113, 6.439814759000029],
              [11.202276467000104, 6.436739242000016],
              [11.140384155000078, 6.430280456000034],
              [11.113512410000084, 6.434001160000136],
              [11.097079305000108, 6.44911651700005],
              [11.077442261000073, 6.496736348000084],
              [11.060595744000096, 6.573966777000066],
              [11.057391804000133, 6.613008321000081],
              [11.059045451000088, 6.652721659000065],
              [11.055944865000129, 6.700367330000105],
              [11.036721232000104, 6.740545757000035],
              [11.002614787000141, 6.767262471000095],
              [10.909390503000111, 6.784264018000016],
              [10.877454467000035, 6.81609670000006],
              [10.857404012000103, 6.85978912400013],
              [10.848205607000097, 6.905316061000093],
              [10.831875854000145, 6.945210266000046],
              [10.799112996000048, 6.967327779000058],
              [10.716947469000047, 6.998126933000023],
              [10.646977580000112, 7.035075582000061],
              [10.620622599000058, 7.04375722200011],
              [10.602535848000059, 7.058071595000101],
              [10.597161499000094, 7.107267558000075],
              [10.578661336000067, 7.130832011000081],
              [10.56419193500011, 7.102668355000034],
              [10.551789591000045, 7.066339824000053],
              [10.543314656000064, 7.02871938100013],
              [10.537423543000045, 6.952134908000119],
              [10.533186076000106, 6.94882761700012],
              [10.52750166800007, 6.947484029000066],
              [10.521197144000041, 6.942781474000085],
              [10.508898153000104, 6.926348369000024],
              [10.50073327600009, 6.912809144000036],
              [10.496599161000063, 6.89715118400008],
              [10.495979045000098, 6.87467193600007],
              [10.238423706000106, 6.871002910000072],
              [10.210828491000115, 6.879167786000096],
              [10.1898478600001, 6.895445862000116],
              [10.179409220000082, 6.91492787700011],
              [10.165043172000082, 6.988515117000105],
              [10.156878296000059, 7.004741516000109],
              [10.14292565900007, 7.007687073000113],
              [10.119464559000079, 6.99440623000001],
              [9.874621623000053, 6.787700500000142],
              [9.8511605220001, 6.777881978000082],
              [9.831730184, 6.783566386000118],
              [9.812299845000041, 6.793049011000093],
              [9.788528686000063, 6.794754334000061],
              [9.769821818000082, 6.773722026000144],
              [9.69397999000006, 6.534304786000064],
              [9.693030640000131, 6.531307882000078],
              [9.680524943000108, 6.521437683000102],
              [9.644805968000128, 6.521225530000038],
              [9.632672567000043, 6.521153463000118],
              [9.603010294000057, 6.515184835000099],
              [9.588127482000118, 6.502730814000117],
              [9.564769735000084, 6.458599142000125],
              [9.54895674700009, 6.44317372600004],
              [9.52859623200004, 6.43301930800007],
              [9.488590226000099, 6.418208095000097],
              [9.482604207000065, 6.415991923000135],
              [9.453148641000041, 6.397672628000066],
              [9.42286625200012, 6.339355774000126],
              [9.394960978000142, 6.322535095000148],
              [9.37914799000012, 6.321604920000098],
              [9.366538940000112, 6.322690125000094],
              [9.354756713000114, 6.32150156700007],
              [9.341010783000087, 6.313982646000042],
              [9.327368205000084, 6.298505554000116],
              [9.298842814000125, 6.238431701000096],
              [9.273314657000071, 6.202774964000113],
              [9.136165405000014, 6.092523295000063],
              [9.043871297000038, 5.996844381000059],
              [9.043871297000038, 5.996689352000118],
              [9.022477254000137, 5.965812683000124],
              [9.0098682040001, 5.95235097300008],
              [8.993848511000067, 5.944082743000124],
              [8.988474162000102, 5.937287292000079],
              [8.986303752000111, 5.908813578000135],
              [8.982686401000109, 5.895765280000091],
              [8.965013061000121, 5.893594869000111],
              [8.943205607000095, 5.901423849000125],
              [8.921708211000066, 5.904472758000068],
              [8.904654988000118, 5.888117167000118],
              [8.891219116000059, 5.871115621000101],
              [8.855872437000073, 5.847499492000082],
              [8.845227091000083, 5.831040548000104],
              [8.847087443000078, 5.810757548000097],
              [8.857836141000092, 5.794892883000088],
              [8.866621135000088, 5.777452087000057],
              [8.862176961000074, 5.752337342000118],
              [8.8446069740001, 5.730865783000098],
              [8.826933635000103, 5.717817485000054],
              [8.819285522000115, 5.703451437000055],
              [8.832411336000092, 5.678155823000068],
              [8.852565145000057, 5.658673808000074],
              [8.874889363000136, 5.6414397180001],
              [8.893699585000121, 5.621750997000049],
              [8.90393151900011, 5.595085958000098],
              [8.899487345000097, 5.570953064000136],
              [8.884294474000086, 5.551445211000043],
              [8.865484253000062, 5.533461813000059],
              [8.85049808700009, 5.514005636000078],
              [8.844296915000115, 5.49235321000009],
              [8.845743855000109, 5.47279368100007],
              [8.849257853000069, 5.453466695000117],
              [8.849774618000112, 5.432356873000089],
              [8.843160034000107, 5.409980977000103],
              [8.821662638000078, 5.367683817000113],
              [8.81525476100012, 5.343499247000054],
              [8.816391642000042, 5.33029591900015],
              [8.82465987100008, 5.30613718700009],
              [8.825693400000148, 5.295491842000104],
              [8.798925008000083, 5.159634502000088],
              [8.791690307000124, 5.146741232000082],
              [8.781251668000095, 5.141987],
              [8.769469442000087, 5.139945781000037],
              [8.758307332000044, 5.134881490000069],
              [8.748282104000026, 5.12421030700007],
              [8.728851765000059, 5.094548035000102],
              [8.722650594000072, 5.081189677000069],
              [8.707871134000044, 5.037548930000114],
              [8.698569376000108, 5.01780853300005],
              [8.683686564000084, 4.997034607000018],
              [8.683686564000084, 4.996879578000062],
              [8.64441247500011, 4.934867859000107],
              [8.638314656000148, 4.916781108000094],
              [8.611029501000132, 4.896653137000044],
              [8.602244506000147, 4.881331075000077],
              [8.605448445000121, 4.86004038500009],
              [8.608445679000027, 4.84621693900003],
              [8.612166382000055, 4.831876729000044],
              [8.595113159000107, 4.815314433000125],
              [8.594167514000048, 4.815293687000064],
              [8.594574415000068, 4.815497137000079],
              [8.592458530000044, 4.820217190000051],
              [8.58570397200009, 4.824896552000041],
              [8.576670769000089, 4.827053127000056],
              [8.568614129000082, 4.823187567000048],
              [8.558116082000083, 4.814439195000091],
              [8.549164259000065, 4.804185289000088],
              [8.545258009000065, 4.796291408000059],
              [8.543304884000065, 4.787502346000053],
              [8.534434441000087, 4.76829661700009],
              [8.531748894000089, 4.75812409100007],
              [8.53256269600007, 4.748236395000049],
              [8.539073113000086, 4.733791408000059],
              [8.538584832000083, 4.724595445000091],
              [8.529795769000089, 4.708889065000051],
              [8.518321160000085, 4.704046942000048],
              [8.504893425000091, 4.706122137000079],
              [8.49000084700009, 4.711004950000074],
              [8.485524936000047, 4.709784247000073],
              [8.475840691000087, 4.708929755000042],
              [8.469004754000082, 4.71165599200009],
              [8.473317905000044, 4.721177476000094],
              [8.477549675000091, 4.727769273000092],
              [8.482269727000073, 4.738348700000074],
              [8.484385613000086, 4.748195705000057],
              [8.48015384200005, 4.752508856000077],
              [8.471202019000089, 4.750230210000041],
              [8.451833530000044, 4.74054596600007],
              [8.43881269600007, 4.738267320000091],
              [8.409190300000091, 4.749335028000075],
              [8.407399936000047, 4.776841539000088],
              [8.417246941000087, 4.812445380000042],
              [8.421885613000086, 4.847479559000078],
              [8.41570071700005, 4.847479559000078],
              [8.409027540000068, 4.813381252000056],
              [8.386973504000082, 4.795803127000056],
              [8.358409050000091, 4.797349351000094],
              [8.332367384000065, 4.820868231000077],
              [8.33562259200005, 4.824693101000094],
              [8.339854363000086, 4.834458726000094],
              [8.332041863000086, 4.836411851000094],
              [8.312022332000083, 4.847479559000078],
              [8.316579623000052, 4.860988674000055],
              [8.30836022200009, 4.872137762000079],
              [8.281260613000086, 4.892482815000051],
              [8.257334832000083, 4.905829169000071],
              [8.256195509000065, 4.906724351000094],
              [8.250498894000089, 4.923244533000059],
              [8.239268425000091, 4.94476959800005],
              [8.23210696700005, 4.953680731000077],
              [8.219737175000091, 4.95734284100007],
              [8.20875084700009, 4.962103583000044],
              [8.19662519600007, 4.972845770000049],
              [8.186696811000047, 4.984361070000091],
              [8.181651238000086, 4.991441148000092],
              [8.17546634200005, 4.991441148000092],
              [8.17546634200005, 4.985296942000048],
              [8.23023522200009, 4.933661200000074],
              [8.243662957000083, 4.916408596000053],
              [8.269704623000052, 4.868719794000071],
              [8.273610873000052, 4.845445054000038],
              [8.257334832000083, 4.834458726000094],
              [8.263845248000052, 4.820746161000045],
              [8.273936394000089, 4.804836330000057],
              [8.285329623000052, 4.791571356000077],
              [8.294932488000086, 4.786078192000048],
              [8.304942254000082, 4.777329820000091],
              [8.31999759200005, 4.734361070000091],
              [8.332367384000065, 4.717759507000039],
              [8.328949415000068, 4.711493231000077],
              [8.320974155000044, 4.689154364000046],
              [8.319509311000047, 4.679917710000041],
              [8.323496941000087, 4.665594794000071],
              [8.333181186000047, 4.659979559000078],
              [8.344493035000085, 4.65656159100007],
              [8.353526238000086, 4.648871161000045],
              [8.356455925000091, 4.625555731000077],
              [8.341075066000087, 4.611558335000041],
              [8.321543816000087, 4.599839585000041],
              [8.312022332000083, 4.583685614000046],
              [8.298350457000083, 4.553290106000077],
              [8.288584832000083, 4.548570054000038],
              [8.27906334700009, 4.546820380000042],
              [8.235524936000047, 4.546861070000091],
              [8.178558790000068, 4.553290106000077],
              [8.092946811000047, 4.553290106000077],
              [8.051280144000089, 4.559393622000073],
              [8.031993035000085, 4.558783270000049],
              [7.998708530000044, 4.541408596000053],
              [7.979340040000068, 4.539007880000042],
              [7.93531334700009, 4.539007880000042],
              [7.764496290000068, 4.519191799000055],
              [7.755056186000047, 4.524807033000059],
              [7.742360873000052, 4.526312567000048],
              [7.730479363000086, 4.522365627000056],
              [7.722911004000082, 4.511704820000091],
              [7.733653191000087, 4.512193101000094],
              [7.742930535000085, 4.511216539000088],
              [7.750661655000044, 4.508775132000039],
              [7.757090691000087, 4.504868882000039],
              [7.735524936000047, 4.499212958000044],
              [7.703135613000086, 4.497544664000088],
              [7.673838738000086, 4.502183335000041],
              [7.660899285000085, 4.515448309000078],
              [7.646983269000089, 4.519110419000071],
              [7.558441602000073, 4.525336005000042],
              [7.561778191000087, 4.529527085000041],
              [7.563649936000047, 4.532782294000071],
              [7.566416863000086, 4.535711981000077],
              [7.57203209700009, 4.539007880000042],
              [7.559336785000085, 4.542914130000042],
              [7.547618035000085, 4.541164455000057],
              [7.539317254000082, 4.541815497000073],
              [7.537364129000082, 4.553290106000077],
              [7.54078209700009, 4.559149481000077],
              [7.547618035000085, 4.563625393000052],
              [7.554535352000073, 4.569484768000052],
              [7.558441602000073, 4.579982815000051],
              [7.555511915000068, 4.584906317000048],
              [7.537364129000082, 4.607896226000094],
              [7.540293816000087, 4.611761786000045],
              [7.544769727000073, 4.621568101000094],
              [7.529633009000065, 4.638861395000049],
              [7.533050977000073, 4.664292710000041],
              [7.551036004000082, 4.711004950000074],
              [7.544769727000073, 4.711004950000074],
              [7.533539259000065, 4.702704169000071],
              [7.527842644000089, 4.698553778000075],
              [7.520518425000091, 4.68976471600007],
              [7.517425977000073, 4.679917710000041],
              [7.519704623000052, 4.665106512000079],
              [7.52279707100007, 4.654120184000078],
              [7.522715691000087, 4.644110419000071],
              [7.514414910000085, 4.632147528000075],
              [7.514170769000089, 4.625921942000048],
              [7.527842644000089, 4.609564520000049],
              [7.531097852000073, 4.601141669000071],
              [7.527842644000089, 4.598618882000039],
              [7.511241082000083, 4.579982815000051],
              [7.501963738000086, 4.572699286000045],
              [7.490489129000082, 4.566310940000051],
              [7.479177280000044, 4.56517161700009],
              [7.469574415000068, 4.573797919000071],
              [7.462738477000073, 4.573797919000071],
              [7.454112175000091, 4.553168036000045],
              [7.432383660000085, 4.55540599200009],
              [7.397715691000087, 4.573797919000071],
              [7.37273196700005, 4.575140692000048],
              [7.346690300000091, 4.580308335000041],
              [7.324554884000065, 4.590765692000048],
              [7.312022332000083, 4.607896226000094],
              [7.305918816000087, 4.60415273600006],
              [7.299082879000082, 4.602036851000094],
              [7.28101647200009, 4.601141669000071],
              [7.277842644000089, 4.598049221000053],
              [7.276621941000087, 4.591050523000092],
              [7.27320397200009, 4.583929755000042],
              [7.263682488000086, 4.579982815000051],
              [7.263682488000086, 4.573797919000071],
              [7.270274285000085, 4.569728908000059],
              [7.277354363000086, 4.566351630000042],
              [7.27116946700005, 4.560044664000088],
              [7.284027540000068, 4.55540599200009],
              [7.301036004000082, 4.541815497000073],
              [7.328379754000082, 4.536200262000079],
              [7.333262566000087, 4.529364325000074],
              [7.33179772200009, 4.520493882000039],
              [7.325694207000083, 4.511704820000091],
              [7.28101647200009, 4.504868882000039],
              [7.276133660000085, 4.510158596000053],
              [7.25367272200009, 4.542710679000038],
              [7.190440300000091, 4.61163971600007],
              [7.181651238000086, 4.632147528000075],
              [7.181651238000086, 4.659409898000092],
              [7.178884311000047, 4.668850002000056],
              [7.172373894000089, 4.668890692000048],
              [7.158213738000086, 4.662014065000051],
              [7.13640384200005, 4.661810614000046],
              [7.133148634000065, 4.663153387000079],
              [7.124847852000073, 4.672349351000094],
              [7.10678144600007, 4.687079169000071],
              [7.099131707000083, 4.697251695000091],
              [7.082692905000044, 4.742743231000077],
              [7.071787957000083, 4.75812409100007],
              [7.070485873000052, 4.74835846600007],
              [7.065440300000091, 4.738674221000053],
              [7.06023196700005, 4.731919664000088],
              [7.057627800000091, 4.730861721000053],
              [7.060394727000073, 4.720689195000091],
              [7.065684441000087, 4.718939520000049],
              [7.072276238000086, 4.718085028000075],
              [7.078623894000089, 4.711004950000074],
              [7.088633660000085, 4.676459052000041],
              [7.097911004000082, 4.661810614000046],
              [7.116221550000091, 4.65570709800005],
              [7.147227410000085, 4.640041408000059],
              [7.16968834700009, 4.605943101000094],
              [7.173350457000083, 4.57290273600006],
              [7.147471550000091, 4.560044664000088],
              [7.160329623000052, 4.550930080000057],
              [7.17554772200009, 4.536444403000075],
              [7.184580925000091, 4.519029039000088],
              [7.178233269000089, 4.501450914000088],
              [7.150645379000082, 4.470607815000051],
              [7.133555535000085, 4.463039455000057],
              [7.112803582000083, 4.471380927000041],
              [7.112315300000091, 4.455877997000073],
              [7.112803582000083, 4.450873114000046],
              [7.094248894000089, 4.459377346000053],
              [7.080577019000089, 4.470445054000038],
              [7.074554884000065, 4.485256252000056],
              [7.078623894000089, 4.504868882000039],
              [7.065277540000068, 4.492987372000073],
              [7.062673373000052, 4.476263739000046],
              [7.06812584700009, 4.458482164000088],
              [7.078623894000089, 4.443426825000074],
              [7.051442905000044, 4.436590887000079],
              [7.043955925000091, 4.436590887000079],
              [7.031911655000044, 4.459906317000048],
              [7.025889519000089, 4.484930731000077],
              [7.023285352000073, 4.53587474200009],
              [7.007009311000047, 4.56313711100006],
              [7.002207879000082, 4.579901434000078],
              [7.01343834700009, 4.587388414000088],
              [7.017832879000082, 4.595607815000051],
              [7.022959832000083, 4.614243882000039],
              [7.025726759000065, 4.634914455000057],
              [7.023285352000073, 4.648871161000045],
              [7.028493686000047, 4.646429755000042],
              [7.037771030000044, 4.644720770000049],
              [7.043955925000091, 4.642645575000074],
              [7.037364129000082, 4.65375397300005],
              [7.01726321700005, 4.676214911000045],
              [7.01303144600007, 4.687201239000046],
              [7.008067254000082, 4.708807684000078],
              [7.00359134200005, 4.717759507000039],
              [6.984873894000089, 4.692084052000041],
              [6.978526238000086, 4.692368882000039],
              [6.974457227000073, 4.708644924000055],
              [6.96265709700009, 4.730861721000053],
              [6.957774285000085, 4.715521552000041],
              [6.960215691000087, 4.69171784100007],
              [6.955821160000085, 4.683661200000074],
              [6.966970248000052, 4.667466539000088],
              [6.989268425000091, 4.607896226000094],
              [6.978851759000065, 4.607896226000094],
              [6.971853061000047, 4.609076239000046],
              [6.966644727000073, 4.612982489000046],
              [6.96265709700009, 4.621568101000094],
              [6.95866946700005, 4.618801174000055],
              [6.94898522200009, 4.614732164000088],
              [6.940196160000085, 4.634100653000075],
              [6.929535352000073, 4.651068427000041],
              [6.900563998000052, 4.683661200000074],
              [6.902598504000082, 4.666937567000048],
              [6.907481316000087, 4.653631903000075],
              [6.92156009200005, 4.629055080000057],
              [6.929860873000052, 4.618638414000088],
              [6.933604363000086, 4.612494208000044],
              [6.93531334700009, 4.604559637000079],
              [6.931488477000073, 4.595933335000041],
              [6.924571160000085, 4.591050523000092],
              [6.92123457100007, 4.585191148000092],
              [6.928477410000085, 4.573797919000071],
              [6.938487175000091, 4.589260158000059],
              [6.957041863000086, 4.59406159100007],
              [6.974945509000065, 4.589667059000078],
              [6.983083530000044, 4.576849677000041],
              [6.973480665000068, 4.508002020000049],
              [6.975596550000091, 4.484442450000074],
              [7.010996941000087, 4.414129950000074],
              [7.023692254000082, 4.398138739000046],
              [7.022146030000044, 4.388495184000078],
              [7.016286655000044, 4.378892320000091],
              [7.006602410000085, 4.374579169000071],
              [6.99350019600007, 4.376288153000075],
              [6.982758009000065, 4.381048895000049],
              [6.964121941000087, 4.389553127000056],
              [6.964691602000073, 4.384995835000041],
              [6.966075066000087, 4.380438544000071],
              [6.969493035000085, 4.374579169000071],
              [6.947438998000052, 4.38149648600006],
              [6.92546634200005, 4.391546942000048],
              [6.903086785000085, 4.396551825000074],
              [6.880056186000047, 4.388169664000088],
              [6.868662957000083, 4.39984772300005],
              [6.860850457000083, 4.415716864000046],
              [6.859222852000073, 4.433539130000042],
              [6.866384311000047, 4.450873114000046],
              [6.84929446700005, 4.45970286700009],
              [6.833832227000073, 4.485907294000071],
              [6.822927280000044, 4.517523505000042],
              [6.818614129000082, 4.542710679000038],
              [6.820485873000052, 4.56085846600007],
              [6.825450066000087, 4.570746161000045],
              [6.832286004000082, 4.577785549000055],
              [6.839691602000073, 4.587388414000088],
              [6.844248894000089, 4.597479559000078],
              [6.848399285000085, 4.61359284100007],
              [6.84546959700009, 4.628607489000046],
              [6.828868035000085, 4.635199286000045],
              [6.803233269000089, 4.649807033000059],
              [6.785492384000065, 4.683294989000046],
              [6.770192905000044, 4.745062567000048],
              [6.76726321700005, 4.769680080000057],
              [6.770681186000047, 4.782416083000044],
              [6.78101647200009, 4.796291408000059],
              [6.787852410000085, 4.808417059000078],
              [6.785329623000052, 4.81704336100006],
              [6.776215040000068, 4.81781647300005],
              [6.763926629000082, 4.806545315000051],
              [6.754405144000089, 4.817938544000071],
              [6.751231316000087, 4.825100002000056],
              [6.74968509200005, 4.834458726000094],
              [6.741058790000068, 4.830145575000074],
              [6.732758009000065, 4.828680731000077],
              [6.72429446700005, 4.830145575000074],
              [6.715586785000085, 4.834458726000094],
              [6.719981316000087, 4.817531643000052],
              [6.721934441000087, 4.79946523600006],
              [6.726817254000082, 4.785101630000042],
              [6.739512566000087, 4.779201565000051],
              [6.748383009000065, 4.771673895000049],
              [6.75562584700009, 4.753851630000042],
              [6.763926629000082, 4.717759507000039],
              [6.767832879000082, 4.680365302000041],
              [6.772227410000085, 4.663031317000048],
              [6.78101647200009, 4.65570709800005],
              [6.793711785000085, 4.648993231000077],
              [6.806813998000052, 4.633246161000045],
              [6.825450066000087, 4.601141669000071],
              [6.802989129000082, 4.581976630000042],
              [6.798106316000087, 4.573797919000071],
              [6.796153191000087, 4.559719143000052],
              [6.81609134200005, 4.461371161000045],
              [6.826019727000073, 4.43195221600007],
              [6.839691602000073, 4.416083075000074],
              [6.83757571700005, 4.39288971600007],
              [6.857920769000089, 4.37531159100007],
              [6.87077884200005, 4.36078522300005],
              [6.845957879000082, 4.347235419000071],
              [6.814626498000052, 4.341620184000078],
              [6.774587436000047, 4.338934637000079],
              [6.737559441000087, 4.342230536000045],
              [6.715586785000085, 4.354681708000044],
              [6.71257571700005, 4.369086005000042],
              [6.716319207000083, 4.428127346000053],
              [6.721202019000089, 4.435370184000078],
              [6.72242272200009, 4.440008856000077],
              [6.720225457000083, 4.445257880000042],
              [6.710948113000086, 4.453070380000042],
              [6.70875084700009, 4.457098700000074],
              [6.70875084700009, 4.491888739000046],
              [6.712412957000083, 4.508002020000049],
              [6.734873894000089, 4.56781647300005],
              [6.737071160000085, 4.578558661000045],
              [6.73609459700009, 4.607896226000094],
              [6.717133009000065, 4.58462148600006],
              [6.701833530000044, 4.542547919000071],
              [6.69507897200009, 4.497219143000052],
              [6.701914910000085, 4.463934637000079],
              [6.697520379000082, 4.455633856000077],
              [6.69703209700009, 4.435980536000045],
              [6.69507897200009, 4.422919012000079],
              [6.685720248000052, 4.445461330000057],
              [6.682627800000091, 4.459214585000041],
              [6.679860873000052, 4.520575262000079],
              [6.674571160000085, 4.532782294000071],
              [6.670746290000068, 4.52602773600006],
              [6.666188998000052, 4.52024974200009],
              [6.660817905000044, 4.515570380000042],
              [6.65406334700009, 4.511704820000091],
              [6.659434441000087, 4.497544664000088],
              [6.660329623000052, 4.450873114000046],
              [6.664317254000082, 4.434637762000079],
              [6.676442905000044, 4.412909247000073],
              [6.684418165000068, 4.393703518000052],
              [6.694509311000047, 4.359076239000046],
              [6.69507897200009, 4.347235419000071],
              [6.687673373000052, 4.33657461100006],
              [6.67750084700009, 4.333075262000079],
              [6.646657748000052, 4.333563544000071],
              [6.61850019600007, 4.330755927000041],
              [6.61264082100007, 4.336737372000073],
              [6.601735873000052, 4.369045315000051],
              [6.598806186000047, 4.399969794000071],
              [6.600108269000089, 4.445502020000049],
              [6.595876498000052, 4.482082424000055],
              [6.580821160000085, 4.507879950000074],
              [6.55046634200005, 4.504868882000039],
              [6.578379754000082, 4.482855536000045],
              [6.588389519000089, 4.447658596000053],
              [6.584727410000085, 4.406927802000041],
              [6.571543816000087, 4.368353583000044],
              [6.569590691000087, 4.334906317000048],
              [6.519867384000065, 4.323146877000056],
              [6.461761915000068, 4.328680731000077],
              [6.434336785000085, 4.347235419000071],
              [6.420909050000091, 4.344875393000052],
              [6.407725457000083, 4.341009833000044],
              [6.415293816000087, 4.322251695000091],
              [6.398936394000089, 4.315985419000071],
              [6.373871290000068, 4.314398505000042],
              [6.355479363000086, 4.309637762000079],
              [6.336273634000065, 4.301214911000045],
              [6.290293816000087, 4.299953518000052],
              [6.270518425000091, 4.292629299000055],
              [6.246836785000085, 4.320502020000049],
              [6.267100457000083, 4.362982489000046],
              [6.332530144000089, 4.436590887000079],
              [6.319509311000047, 4.437689520000049],
              [6.311371290000068, 4.439601955000057],
              [6.305186394000089, 4.439927476000094],
              [6.297211134000065, 4.436590887000079],
              [6.26303144600007, 4.395656643000052],
              [6.258474155000044, 4.44953034100007],
              [6.242523634000065, 4.498032945000091],
              [6.236338738000086, 4.498032945000091],
              [6.235199415000068, 4.478176174000055],
              [6.236989780000044, 4.452785549000055],
              [6.241709832000083, 4.427923895000049],
              [6.24935957100007, 4.409898179000038],
              [6.23959394600007, 4.419623114000046],
              [6.231211785000085, 4.430487372000073],
              [6.219899936000047, 4.439398505000042],
              [6.201670769000089, 4.443426825000074],
              [6.212412957000083, 4.420111395000049],
              [6.223317905000044, 4.40460846600007],
              [6.23015384200005, 4.388006903000075],
              [6.228851759000065, 4.361517645000049],
              [6.22234134200005, 4.341945705000057],
              [6.215179884000065, 4.327337958000044],
              [6.208994988000086, 4.322739976000094],
              [6.200694207000083, 4.320054429000038],
              [6.19467207100007, 4.314195054000038],
              [6.194834832000083, 4.300034898000092],
              [6.20281009200005, 4.303900458000044],
              [6.209157748000052, 4.303900458000044],
              [6.222666863000086, 4.300034898000092],
              [6.217051629000082, 4.290594794000071],
              [6.188731316000087, 4.280991929000038],
              [6.151621941000087, 4.278998114000046],
              [6.126475457000083, 4.28579336100006],
              [6.123057488000086, 4.280951239000046],
              [6.11654707100007, 4.276353257000039],
              [6.112803582000083, 4.272162177000041],
              [6.096690300000091, 4.278143622000073],
              [6.087738477000073, 4.288234768000052],
              [6.084320509000065, 4.302313544000071],
              [6.084971550000091, 4.320502020000049],
              [6.089121941000087, 4.337144273000092],
              [6.102549675000091, 4.360907294000071],
              [6.105316602000073, 4.374579169000071],
              [6.100759311000047, 4.372626044000071],
              [6.089691602000073, 4.370021877000056],
              [6.084971550000091, 4.368353583000044],
              [6.085134311000047, 4.384100653000075],
              [6.088715040000068, 4.411118882000039],
              [6.07781009200005, 4.412298895000049],
              [6.067393425000091, 4.414984442000048],
              [6.055430535000085, 4.419867255000042],
              [6.043304884000065, 4.416083075000074],
              [6.040293816000087, 4.405910549000055],
              [6.042165561000047, 4.391180731000077],
              [6.04656009200005, 4.377020575000074],
              [6.050791863000086, 4.368353583000044],
              [6.04656009200005, 4.355210679000038],
              [6.051931186000047, 4.344224351000094],
              [6.060069207000083, 4.332424221000053],
              [6.064463738000086, 4.316799221000053],
              [6.061778191000087, 4.29523346600007],
              [6.053965691000087, 4.296291408000059],
              [6.042165561000047, 4.306626695000091],
              [6.02702884200005, 4.313055731000077],
              [6.004893425000091, 4.314113674000055],
              [5.996918165000068, 4.319403387000079],
              [5.99545332100007, 4.354681708000044],
              [6.001475457000083, 4.356268622000073],
              [6.00326582100007, 4.359198309000078],
              [5.990244988000086, 4.378566799000055],
              [5.988617384000065, 4.382025458000044],
              [5.987478061000047, 4.398911851000094],
              [5.988617384000065, 4.416083075000074],
              [5.982595248000052, 4.416083075000074],
              [5.975108269000089, 4.382025458000044],
              [5.969981316000087, 4.386419989000046],
              [5.954600457000083, 4.395656643000052],
              [5.969737175000091, 4.361517645000049],
              [5.972829623000052, 4.344794012000079],
              [5.961436394000089, 4.333563544000071],
              [5.946299675000091, 4.335191148000092],
              [5.930918816000087, 4.345119533000059],
              [5.918142123000052, 4.35618724200009],
              [5.910166863000086, 4.361517645000049],
              [5.889903191000087, 4.368841864000046],
              [5.867523634000065, 4.387274481000077],
              [5.855642123000052, 4.411607164000088],
              [5.865896030000044, 4.436590887000079],
              [5.854665561000047, 4.437486070000091],
              [5.847504102000073, 4.434393622000073],
              [5.844493035000085, 4.42719147300005],
              [5.84538821700005, 4.416083075000074],
              [5.839121941000087, 4.416083075000074],
              [5.822764519000089, 4.432847398000092],
              [5.782399936000047, 4.455959377000056],
              [5.770274285000085, 4.471380927000041],
              [5.777191602000073, 4.466986395000049],
              [5.79037519600007, 4.461167710000041],
              [5.797536655000044, 4.457098700000074],
              [5.789805535000085, 4.469712632000039],
              [5.777679884000065, 4.475531317000048],
              [5.763682488000086, 4.478949286000045],
              [5.74976647200009, 4.484442450000074],
              [5.728363477000073, 4.507635809000078],
              [5.720713738000086, 4.518255927000041],
              [5.694021030000044, 4.545599677000041],
              [5.687673373000052, 4.549872137000079],
              [5.594899936000047, 4.636460679000038],
              [5.566905144000089, 4.67523834800005],
              [5.557302280000044, 4.717759507000039],
              [5.561534050000091, 4.716376044000071],
              [5.564626498000052, 4.715033270000049],
              [5.571543816000087, 4.711004950000074],
              [5.571462436000047, 4.729559637000079],
              [5.527679884000065, 4.75649648600006],
              [5.516368035000085, 4.775783596000053],
              [5.51148522200009, 4.791815497000073],
              [5.486338738000086, 4.835028387000079],
              [5.475433790000068, 4.847479559000078],
              [5.50953209700009, 4.827053127000056],
              [5.500987175000091, 4.850897528000075],
              [5.469004754000082, 4.886786200000074],
              [5.441254102000073, 4.964178778000075],
              [5.432383660000085, 5.010891018000052],
              [5.427012566000087, 5.026271877000056],
              [5.414235873000052, 5.052435614000046],
              [5.408864780000044, 5.067572333000044],
              [5.406504754000082, 5.08429596600007],
              [5.403330925000091, 5.091864325000074],
              [5.39625084700009, 5.099514065000051],
              [5.389333530000044, 5.109767971000053],
              [5.385996941000087, 5.125555731000077],
              [5.390879754000082, 5.137681382000039],
              [5.402842644000089, 5.142401434000078],
              [5.418467644000089, 5.14126211100006],
              [5.433848504000082, 5.136135158000059],
              [5.44467207100007, 5.127101955000057],
              [5.462738477000073, 5.10228099200009],
              [5.475433790000068, 5.094549872000073],
              [5.460215691000087, 5.133775132000039],
              [5.454274936000047, 5.149115302000041],
              [5.475596550000091, 5.147040106000077],
              [5.49586022200009, 5.142320054000038],
              [5.488536004000082, 5.154201565000051],
              [5.461192254000082, 5.184149481000077],
              [5.45085696700005, 5.190130927000041],
              [5.447113477000073, 5.185939846000053],
              [5.448008660000085, 5.167629299000055],
              [5.444346550000091, 5.163478908000059],
              [5.43490644600007, 5.163153387000079],
              [5.427907748000052, 5.162054755000042],
              [5.413340691000087, 5.156642971000053],
              [5.40015709700009, 5.162339585000041],
              [5.376149936000047, 5.158189195000091],
              [5.365570509000065, 5.163478908000059],
              [5.363617384000065, 5.171576239000046],
              [5.365570509000065, 5.20774974200009],
              [5.36109459700009, 5.253973700000074],
              [5.340179884000065, 5.343939520000049],
              [5.345713738000086, 5.357163804000038],
              [5.368988477000073, 5.36204661700009],
              [5.43531334700009, 5.363348700000074],
              [5.454274936000047, 5.368841864000046],
              [5.45679772200009, 5.359564520000049],
              [5.459483269000089, 5.35297272300005],
              [5.468028191000087, 5.340887762000079],
              [5.476084832000083, 5.347316799000055],
              [5.483653191000087, 5.362290757000039],
              [5.489105665000068, 5.368841864000046],
              [5.494883660000085, 5.372870184000078],
              [5.529633009000065, 5.386379299000055],
              [5.546071811000047, 5.389471747000073],
              [5.561289910000085, 5.388861395000049],
              [5.571543816000087, 5.381984768000052],
              [5.57789147200009, 5.381984768000052],
              [5.570323113000086, 5.394680080000057],
              [5.546397332000083, 5.415513414000088],
              [5.53687584700009, 5.43032461100006],
              [5.533213738000086, 5.444240627000056],
              [5.531911655000044, 5.460638739000046],
              [5.533946160000085, 5.476385809000078],
              [5.540293816000087, 5.488348700000074],
              [5.553558790000068, 5.496893622000073],
              [5.568695509000065, 5.499904690000051],
              [5.602061394000089, 5.499253648000092],
              [5.614024285000085, 5.504950262000079],
              [5.625743035000085, 5.51788971600007],
              [5.639903191000087, 5.540187893000052],
              [5.623871290000068, 5.533596096000053],
              [5.610524936000047, 5.521918036000045],
              [5.596202019000089, 5.514227606000077],
              [5.57789147200009, 5.519720770000049],
              [5.575205925000091, 5.514837958000044],
              [5.568858269000089, 5.510443427000041],
              [5.56413821700005, 5.505438544000071],
              [5.541026238000086, 5.51048411700009],
              [5.517100457000083, 5.498602606000077],
              [5.503184441000087, 5.476467190000051],
              [5.50953209700009, 5.450751044000071],
              [5.498057488000086, 5.42641836100006],
              [5.484873894000089, 5.411525783000059],
              [5.468597852000073, 5.407782294000071],
              [5.447438998000052, 5.416693427000041],
              [5.441579623000052, 5.423488674000055],
              [5.439952019000089, 5.429877020000049],
              [5.436045769000089, 5.434637762000079],
              [5.42359459700009, 5.436509507000039],
              [5.418304884000065, 5.430812893000052],
              [5.421071811000047, 5.417792059000078],
              [5.42750084700009, 5.403957424000055],
              [5.433848504000082, 5.395575262000079],
              [5.375987175000091, 5.398830471000053],
              [5.263194207000083, 5.436509507000039],
              [5.258474155000044, 5.441839911000045],
              [5.253916863000086, 5.452785549000055],
              [5.250173373000052, 5.458197333000044],
              [5.218597852000073, 5.487127997000073],
              [5.198008660000085, 5.501450914000088],
              [5.190603061000047, 5.522853908000059],
              [5.188487175000091, 5.544134833000044],
              [5.19117272200009, 5.553859768000052],
              [5.197927280000044, 5.557562567000048],
              [5.21420332100007, 5.575140692000048],
              [5.222829623000052, 5.581203518000052],
              [5.23023522200009, 5.582505601000094],
              [5.328135613000086, 5.57843659100007],
              [5.365244988000086, 5.572333075000074],
              [5.385996941000087, 5.560614325000074],
              [5.392832879000082, 5.560614325000074],
              [5.402598504000082, 5.574774481000077],
              [5.419200066000087, 5.610541083000044],
              [5.427012566000087, 5.622137762000079],
              [5.439952019000089, 5.62767161700009],
              [5.455821160000085, 5.627386786000045],
              [5.471039259000065, 5.622788804000038],
              [5.481700066000087, 5.615301825000074],
              [5.484385613000086, 5.607977606000077],
              [5.49000084700009, 5.585842190000051],
              [5.492523634000065, 5.581203518000052],
              [5.502940300000091, 5.581773179000038],
              [5.508067254000082, 5.584540106000077],
              [5.509613477000073, 5.590643622000073],
              [5.50953209700009, 5.601629950000074],
              [5.502126498000052, 5.617254950000074],
              [5.485118035000085, 5.634344794000071],
              [5.464854363000086, 5.648627020000049],
              [5.447438998000052, 5.656236070000091],
              [5.428477410000085, 5.655829169000071],
              [5.418955925000091, 5.645900783000059],
              [5.406504754000082, 5.615301825000074],
              [5.396006707000083, 5.605902411000045],
              [5.379649285000085, 5.59796784100007],
              [5.361501498000052, 5.593654690000051],
              [5.344981316000087, 5.594794012000079],
              [5.326019727000073, 5.605414130000042],
              [5.317881707000083, 5.619574286000045],
              [5.318207227000073, 5.636664130000042],
              [5.336924675000091, 5.691148179000038],
              [5.33920332100007, 5.705877997000073],
              [5.33757571700005, 5.724554755000042],
              [5.33139082100007, 5.724554755000042],
              [5.30404707100007, 5.650051174000055],
              [5.293223504000082, 5.63031647300005],
              [5.280284050000091, 5.61749909100007],
              [5.26303144600007, 5.610541083000044],
              [5.239105665000068, 5.608465887000079],
              [5.22828209700009, 5.605617580000057],
              [5.204925977000073, 5.591986395000049],
              [5.179698113000086, 5.582586981000077],
              [5.17359459700009, 5.58539459800005],
              [5.160166863000086, 5.594794012000079],
              [5.144867384000065, 5.608628648000092],
              [5.129161004000082, 5.628119208000044],
              [5.116709832000083, 5.648830471000053],
              [5.107269727000073, 5.676988023000092],
              [5.097829623000052, 5.69086334800005],
              [5.088633660000085, 5.708726304000038],
              [5.084971550000091, 5.732001044000071],
              [5.087412957000083, 5.752101955000057],
              [5.09343509200005, 5.774725653000075],
              [5.102712436000047, 5.793198960000041],
              [5.11500084700009, 5.800930080000057],
              [5.126475457000083, 5.797023830000057],
              [5.146494988000086, 5.781073309000078],
              [5.15398196700005, 5.779201565000051],
              [5.159190300000091, 5.785589911000045],
              [5.156993035000085, 5.794501044000071],
              [5.153086785000085, 5.804632880000042],
              [5.15398196700005, 5.814520575000074],
              [5.185394727000073, 5.842027085000041],
              [5.267425977000073, 5.871893622000073],
              [5.29037519600007, 5.910101630000042],
              [5.269541863000086, 5.906398830000057],
              [5.235362175000091, 5.875921942000048],
              [5.195811394000089, 5.86399974200009],
              [5.119965040000068, 5.824164130000042],
              [5.105479363000086, 5.813666083000044],
              [5.055023634000065, 5.766587632000039],
              [5.04468834700009, 5.767482815000051],
              [5.007334832000083, 5.849188544000071],
              [4.885915561000047, 6.006537177000041],
              [4.865489129000082, 6.025620835000041],
              [4.826182488000086, 6.042547919000071],
              [4.80795332100007, 6.063055731000077],
              [4.782725457000083, 6.102525132000039],
              [4.74781334700009, 6.138861395000049],
              [4.717051629000082, 6.163641669000071],
              [4.641856316000087, 6.210882880000042],
              [4.60873457100007, 6.231756903000075],
              [4.547373894000089, 6.289048570000091],
              [4.509043816000087, 6.313544012000079],
              [4.493011915000068, 6.320542710000041],
              [4.405528191000087, 6.358872789000088],
              [4.341970248000052, 6.370591539000088],
              [4.125824415000068, 6.410345770000049],
              [3.870290561000047, 6.431626695000091],
              [3.443614129000082, 6.410345770000049],
              [3.421153191000087, 6.414007880000042],
              [3.408864780000044, 6.422919012000079],
              [3.399099155000044, 6.434027411000045],
              [3.384938998000052, 6.444525458000044],
              [3.39429772200009, 6.449367580000057],
              [3.401052280000044, 6.450995184000078],
              [3.406911655000044, 6.449448960000041],
              [3.412852410000085, 6.444525458000044],
              [3.428477410000085, 6.458726304000038],
              [3.434255405000044, 6.453355210000041],
              [3.436289910000085, 6.438299872000073],
              [3.440196160000085, 6.423407294000071],
              [3.475352410000085, 6.455552476000094],
              [3.481211785000085, 6.454779364000046],
              [3.484629754000082, 6.446844794000071],
              [3.492442254000082, 6.446478583000044],
              [3.505381707000083, 6.451361395000049],
              [3.524424675000091, 6.45180898600006],
              [3.541351759000065, 6.454820054000038],
              [3.556813998000052, 6.462958075000074],
              [3.570567254000082, 6.478705145000049],
              [3.572438998000052, 6.489569403000075],
              [3.570160352000073, 6.500677802000041],
              [3.570811394000089, 6.509344794000071],
              [3.580821160000085, 6.512844143000052],
              [3.621348504000082, 6.512844143000052],
              [3.642751498000052, 6.517075914000088],
              [3.686778191000087, 6.531073309000078],
              [3.700205925000091, 6.527085679000038],
              [3.722666863000086, 6.535956122000073],
              [3.742686394000089, 6.547796942000048],
              [3.756846550000091, 6.563788153000075],
              [3.762217644000089, 6.585150458000044],
              [3.774668816000087, 6.590073960000041],
              [3.857920769000089, 6.60219961100006],
              [3.850271030000044, 6.608099677000041],
              [3.844004754000082, 6.610825914000088],
              [3.837901238000086, 6.610988674000055],
              [3.830577019000089, 6.609035549000055],
              [3.773692254000082, 6.622381903000075],
              [3.717458530000044, 6.601141669000071],
              [3.66382897200009, 6.570217190000051],
              [3.615244988000086, 6.554388739000046],
              [3.59701582100007, 6.554266669000071],
              [3.586680535000085, 6.552883205000057],
              [3.551524285000085, 6.534165757000039],
              [3.540049675000091, 6.530096747000073],
              [3.528330925000091, 6.527777411000045],
              [3.51531009200005, 6.527085679000038],
              [3.512950066000087, 6.529445705000057],
              [3.500254754000082, 6.53392161700009],
              [3.48804772200009, 6.533270575000074],
              [3.481618686000047, 6.538316148000092],
              [3.478526238000086, 6.541449286000045],
              [3.47437584700009, 6.554388739000046],
              [3.473317905000044, 6.566636460000041],
              [3.48023522200009, 6.588080145000049],
              [3.481211785000085, 6.60219961100006],
              [3.464040561000047, 6.592230536000045],
              [3.451914910000085, 6.581773179000038],
              [3.429942254000082, 6.557806708000044],
              [3.421885613000086, 6.554754950000074],
              [3.411306186000047, 6.554348049000055],
              [3.402354363000086, 6.552150783000059],
              [3.398610873000052, 6.543850002000056],
              [3.40007571700005, 6.536810614000046],
              [3.40560957100007, 6.52212148600006],
              [3.40601647200009, 6.512844143000052],
              [3.40202884200005, 6.502183335000041],
              [3.387950066000087, 6.480698960000041],
              [3.384938998000052, 6.468695380000042],
              [3.381114129000082, 6.461615302000041],
              [3.373871290000068, 6.456122137000079],
              [3.369802280000044, 6.450018622000073],
              [3.375010613000086, 6.441107489000046],
              [3.379893425000091, 6.43585846600007],
              [3.38257897200009, 6.430731512000079],
              [3.38412519600007, 6.424790757000039],
              [3.389496290000068, 6.419989325000074],
              [3.38453209700009, 6.397691148000092],
              [3.326182488000086, 6.391424872000073],
              [3.21420332100007, 6.396714585000041],
              [3.082367384000065, 6.38149648600006],
              [2.927744988000086, 6.389105536000045],
              [2.703841289342392, 6.368351672675914],
              [2.704258260000131, 6.429298605000071],
              [2.71192043500011, 6.474047835000079],
              [2.715420369000071, 6.494488424000082],
              [2.718803181000084, 6.504297780000087],
              [2.737331177000101, 6.558024597000042],
              [2.739398234000078, 6.579186096000086],
              [2.730819946000054, 6.621354065000048],
              [2.731130005000125, 6.641843771000111],
              [2.742602172000147, 6.663341167000056],
              [2.76068892400005, 6.679386699000105],
              [2.772987915000101, 6.687474060000113],
              [2.778568969000105, 6.698765361000085],
              [2.775261677000117, 6.744886576000113],
              [2.773297974000087, 6.755040995000073],
              [2.767406860000079, 6.759562683000098],
              [2.755004517000117, 6.760725403000023],
              [2.744772583000042, 6.763774312000052],
              [2.736297648000118, 6.769846293000086],
              [2.728649536000148, 6.780000713000049],
              [2.723585246000084, 6.79971527100011],
              [2.7262724200001, 6.821367697000085],
              [2.736917765000101, 6.863303121000087],
              [2.731956828000136, 6.905212708000079],
              [2.718417602000073, 6.943556621000084],
              [2.715110311000075, 6.979833476000053],
              [2.741051880000043, 7.01580027300011],
              [2.752730754000083, 7.021329651000116],
              [2.765546508000085, 7.025102030000141],
              [2.775778442000075, 7.030528056000023],
              [2.779705851000131, 7.041328431000053],
              [2.773918090000052, 7.050785217000026],
              [2.747666463000115, 7.072230937000057],
              [2.739088175000091, 7.082979635000072],
              [2.735264119000135, 7.096002096000106],
              [2.736297648000118, 7.102926738000093],
              [2.7406384680001, 7.109592998000011],
              [2.749836873000106, 7.128558248000061],
              [2.757795044000062, 7.138893535000065],
              [2.761102336000079, 7.148350322000042],
              [2.762135864000044, 7.162199606000101],
              [2.741155232000068, 7.408179424000124],
              [2.74363570100013, 7.419238180000136],
              [2.751283814000089, 7.423630677000034],
              [2.761722452000129, 7.423527324000105],
              [2.783323201000115, 7.419238180000136],
              [2.786527140000089, 7.421253561000086],
              [2.787250610000086, 7.426886292000106],
              [2.78962772600002, 7.435826315000043],
              [2.792314901000054, 7.477632548000102],
              [2.770197387000053, 7.514271139000058],
              [2.7406384680001, 7.549359437000092],
              [2.720588012000064, 7.586566467000097],
              [2.715317017000132, 7.625788879000055],
              [2.717641139000136, 7.658548898000092],
              [2.727202596000069, 7.793323873000077],
              [2.724412068000106, 7.807689921000076],
              [2.715523722000086, 7.82205596900009],
              [2.691545858000069, 7.848669332000028],
              [2.680280396000114, 7.877349752000015],
              [2.672218872000116, 7.889597067000039],
              [2.671694505000062, 7.893434477000113],
              [2.671081990000118, 7.89791697200009],
              [2.673355753000124, 7.905565084000074],
              [2.683587687000113, 7.924633688000057],
              [2.687101684000055, 7.933522034000077],
              [2.690925741000115, 7.996567281000097],
              [2.703534790000049, 8.059896749000103],
              [2.705705200000125, 8.11968638100005],
              [2.708392375000045, 8.13797983800012],
              [2.716143839000068, 8.154903870000027],
              [2.726582479000086, 8.171595357000058],
              [2.734437297000113, 8.189966329000057],
              [2.734954061000082, 8.211902975000015],
              [2.728132771000105, 8.233193665000087],
              [2.70849572700007, 8.274819031000106],
              [2.700744263000075, 8.296884868000092],
              [2.697126913000091, 8.320707703000068],
              [2.698367147000113, 8.339853821000077],
              [2.706015259000111, 8.381272481000039],
              [2.706015259000111, 8.390548401000046],
              [2.703534790000049, 8.409022726000074],
              [2.703741495000088, 8.417885233000078],
              [2.709012492000113, 8.430390931000076],
              [2.728959595000049, 8.45274098700014],
              [2.736917765000101, 8.464523214000053],
              [2.744772583000042, 8.498293762000031],
              [2.742438669000109, 8.52748144300007],
              [2.722948943000091, 8.77121793800012],
              [2.722861776000087, 8.772308045000074],
              [2.723171834000055, 8.782927551000057],
              [2.72885624200012, 8.790472310000013],
              [2.745702759000096, 8.798146260000095],
              [2.751077107000043, 8.80341725700012],
              [2.752317342000083, 8.812279765000127],
              [2.74714969900009, 8.827653503000107],
              [2.745909464000135, 8.836516012000118],
              [2.749630167000049, 8.851941427000014],
              [2.762135864000044, 8.880415141000057],
              [2.762549276000072, 8.895685527000097],
              [2.758725220000116, 8.902661845000097],
              [2.753764282000077, 8.904418843000073],
              [2.74952681500011, 8.906615092000067],
              [2.747769816000044, 8.91480580600009],
              [2.750250285000021, 8.916872864000055],
              [2.76151574700009, 8.933693542000114],
              [2.764719686000149, 8.93976552400008],
              [2.770197387000053, 8.967154032000025],
              [2.772367798000118, 9.030535177000047],
              [2.769163859000059, 9.057045186000039],
              [2.84626509600011, 9.050766500000037],
              [2.859700969000073, 9.052626851000042],
              [2.869312784000073, 9.05970652300006],
              [2.877787720000072, 9.068543192000064],
              [2.888433064000083, 9.075364482000026],
              [2.899181762000097, 9.077379862000072],
              [2.929877564000122, 9.078361715000128],
              [2.940729614000077, 9.077069804000075],
              [2.951685018000148, 9.071902161000082],
              [2.961400187000095, 9.06531341600008],
              [2.971425415000112, 9.060507508000086],
              [2.983104289000096, 9.060610861000015],
              [3.051420533000055, 9.078206686000087],
              [3.076018514000054, 9.095156555000088],
              [3.091314738000079, 9.12642079600009],
              [3.124594360000032, 9.228998515000058],
              [3.145161580000121, 9.267859192000117],
              [3.151362752000097, 9.28863311700006],
              [3.151466105000054, 9.353564555000105],
              [3.148055461000098, 9.370256042000051],
              [3.135343058000046, 9.401675313000084],
              [3.12862512200013, 9.42958058700006],
              [3.132552531000101, 9.45727915500008],
              [3.151776164000125, 9.48815582300007],
              [3.159010864000095, 9.493478495000119],
              [3.175133911000074, 9.498878683000086],
              [3.182575317000101, 9.505338236000043],
              [3.243553507000058, 9.58440317800003],
              [3.244690389000056, 9.589570821000038],
              [3.23941939200003, 9.602309062000089],
              [3.238179158000094, 9.609052836000032],
              [3.245723918000039, 9.633702495000122],
              [3.261846964000114, 9.638611755000056],
              [3.281380656000124, 9.634994405000072],
              [3.299053996000055, 9.633960877000092],
              [3.331610148000095, 9.652021790000092],
              [3.338638143000082, 9.678221741000115],
              [3.330679972000041, 9.708633321000079],
              [3.318380981000075, 9.739432475000058],
              [3.314866984000048, 9.759095358000096],
              [3.317140747000053, 9.781729634000044],
              [3.325925740000031, 9.80172841500007],
              [3.342048788000113, 9.813588156],
              [3.413982381000068, 9.842837016000132],
              [3.452946411000141, 9.85309478800012],
              [3.513097778000088, 9.846609395000073],
              [3.530771118000104, 9.862964987000112],
              [3.557126099000072, 9.910558981000051],
              [3.589475545000141, 9.948825378000052],
              [3.599604126000088, 9.968694966000044],
              [3.605805297000074, 10.054116110000052],
              [3.612316528000065, 10.070290833000044],
              [3.627819458000147, 10.084992778000043],
              [3.642392212000118, 10.091891582000116],
              [3.654897908000123, 10.101115825000122],
              [3.663992961000105, 10.123052470000076],
              [3.664830075000083, 10.128653750000083],
              [3.667506957000057, 10.14656524700007],
              [3.664613078000059, 10.162197368000108],
              [3.65562137900011, 10.174780578000124],
              [3.587615193000147, 10.244182027000093],
              [3.573352498000077, 10.266997173000092],
              [3.572422323000097, 10.285704041000074],
              [3.592989543000101, 10.330946757000063],
              [3.618207642000044, 10.369342346000096],
              [3.622135050000111, 10.381227926000037],
              [3.623168579000094, 10.400916647000074],
              [3.625959106000067, 10.407272848000105],
              [3.632573689000139, 10.416652120000052],
              [3.652107381000064, 10.43579823800006],
              [3.671744425000099, 10.442076925000066],
              [3.692828409000128, 10.438382059000062],
              [3.75690718600012, 10.405257467000055],
              [3.772513469000074, 10.4076345820001],
              [3.787706339000096, 10.426367290000087],
              [3.7943209230001, 10.444867452000025],
              [3.795354451000094, 10.49649220800005],
              [3.804346151000118, 10.52315724800009],
              [3.829874308000058, 10.57307668100006],
              [3.837419067000013, 10.599896749000052],
              [3.83724571500008, 10.630609017000026],
              [3.83710900900013, 10.654828797000064],
              [3.832148071000091, 10.683922628000076],
              [3.822949666000085, 10.703249613000125],
              [3.810237264000136, 10.710484314000084],
              [3.796077921000091, 10.713119812000102],
              [3.7832621660001, 10.716969706000057],
              [3.773857056000054, 10.728054301000071],
              [3.764451945000076, 10.760868836000085],
              [3.759491008000055, 10.771591696000087],
              [3.751946248000081, 10.780169983000121],
              [3.743161255000103, 10.787456360000107],
              [3.735099731000105, 10.795776266000061],
              [3.730035441000041, 10.80771352100001],
              [3.731275675000063, 10.825025126000114],
              [3.752979777000064, 10.87768341100012],
              [3.754116658000072, 10.90713897700003],
              [3.733549438000097, 10.99620330800012],
              [3.733549438000097, 10.996461691000093],
              [3.723317505000097, 11.013540751000036],
              [3.715876099000099, 11.031885885000108],
              [3.711845337000085, 11.051858826000043],
              [3.711845337000085, 11.073511251000127],
              [3.722077271000074, 11.112346090000074],
              [3.713705689000108, 11.12030426000004],
              [3.705583311000055, 11.120732942000075],
              [3.704403930000069, 11.12079518700007],
              [3.694998820000109, 11.11911570300012],
              [3.686730590000082, 11.120485128000084],
              [3.662546020000093, 11.143145244000053],
              [3.483332153000106, 11.392303162000047],
              [3.468449340000063, 11.419484965000038],
              [3.466692342000073, 11.442480978000077],
              [3.486742798000137, 11.496276144000092],
              [3.493047323000042, 11.51149485300003],
              [3.504932902000064, 11.55655670200008],
              [3.57438602700006, 11.67303538000003],
              [3.596400187000114, 11.69577301000001],
            ],
          ],
          [
            [
              [7.541026238000086, 4.484442450000074],
              [7.574229363000086, 4.487860419000071],
              [7.584483269000089, 4.484605210000041],
              [7.578868035000085, 4.471380927000041],
              [7.56999759200005, 4.459418036000045],
              [7.552582227000073, 4.455552476000094],
              [7.514414910000085, 4.457098700000074],
              [7.499034050000091, 4.454494533000059],
              [7.449229363000086, 4.436590887000079],
              [7.431813998000052, 4.434800523000092],
              [7.358164910000085, 4.439276434000078],
              [7.342784050000091, 4.447088934000078],
              [7.336924675000091, 4.460150458000044],
              [7.346202019000089, 4.478176174000055],
              [7.356211785000085, 4.483303127000056],
              [7.404551629000082, 4.498032945000091],
              [7.416351759000065, 4.493841864000046],
              [7.451914910000085, 4.475531317000048],
              [7.469574415000068, 4.471380927000041],
              [7.487803582000083, 4.47337474200009],
              [7.523773634000065, 4.482367255000042],
              [7.541026238000086, 4.484442450000074],
            ],
          ],
          [
            [
              [7.274180535000085, 4.491888739000046],
              [7.31967207100007, 4.496527411000045],
              [7.332530144000089, 4.491888739000046],
              [7.320485873000052, 4.481024481000077],
              [7.314300977000073, 4.469142971000053],
              [7.31226647200009, 4.455633856000077],
              [7.312022332000083, 4.440008856000077],
              [7.307790561000047, 4.424505927000041],
              [7.298350457000083, 4.414740302000041],
              [7.28484134200005, 4.406195380000042],
              [7.270681186000047, 4.400376695000091],
              [7.181651238000086, 4.382025458000044],
              [7.147715691000087, 4.38507721600007],
              [7.13803144600007, 4.397040106000077],
              [7.147715691000087, 4.415920315000051],
              [7.179698113000086, 4.449774481000077],
              [7.202159050000091, 4.484442450000074],
              [7.221446160000085, 4.506659247000073],
              [7.225596550000091, 4.516180731000077],
              [7.229502800000091, 4.532782294000071],
              [7.243174675000091, 4.524400132000039],
              [7.258555535000085, 4.497544664000088],
              [7.274180535000085, 4.491888739000046],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Benin',
        iso3: 'BEN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3.596400187000114, 11.69577301000001],
            [3.57438602700006, 11.67303538000003],
            [3.504932902000064, 11.55655670200008],
            [3.493047323000042, 11.51149485300003],
            [3.486742798000137, 11.496276144000092],
            [3.466692342000073, 11.442480978000077],
            [3.468449340000063, 11.419484965000038],
            [3.483332153000106, 11.392303162000047],
            [3.662546020000093, 11.143145244000053],
            [3.686730590000082, 11.120485128000084],
            [3.694998820000109, 11.11911570300012],
            [3.704403930000069, 11.12079518700007],
            [3.705583311000055, 11.120732942000075],
            [3.713705689000108, 11.12030426000004],
            [3.722077271000074, 11.112346090000074],
            [3.711845337000085, 11.073511251000127],
            [3.711845337000085, 11.051858826000043],
            [3.715876099000099, 11.031885885000108],
            [3.723317505000097, 11.013540751000036],
            [3.733549438000097, 10.996461691000093],
            [3.733549438000097, 10.99620330800012],
            [3.754116658000072, 10.90713897700003],
            [3.752979777000064, 10.87768341100012],
            [3.731275675000063, 10.825025126000114],
            [3.730035441000041, 10.80771352100001],
            [3.735099731000105, 10.795776266000061],
            [3.743161255000103, 10.787456360000107],
            [3.751946248000081, 10.780169983000121],
            [3.759491008000055, 10.771591696000087],
            [3.764451945000076, 10.760868836000085],
            [3.773857056000054, 10.728054301000071],
            [3.7832621660001, 10.716969706000057],
            [3.796077921000091, 10.713119812000102],
            [3.810237264000136, 10.710484314000084],
            [3.822949666000085, 10.703249613000125],
            [3.832148071000091, 10.683922628000076],
            [3.83710900900013, 10.654828797000064],
            [3.83724571500008, 10.630609017000026],
            [3.837419067000013, 10.599896749000052],
            [3.829874308000058, 10.57307668100006],
            [3.804346151000118, 10.52315724800009],
            [3.795354451000094, 10.49649220800005],
            [3.7943209230001, 10.444867452000025],
            [3.787706339000096, 10.426367290000087],
            [3.772513469000074, 10.4076345820001],
            [3.75690718600012, 10.405257467000055],
            [3.692828409000128, 10.438382059000062],
            [3.671744425000099, 10.442076925000066],
            [3.652107381000064, 10.43579823800006],
            [3.632573689000139, 10.416652120000052],
            [3.625959106000067, 10.407272848000105],
            [3.623168579000094, 10.400916647000074],
            [3.622135050000111, 10.381227926000037],
            [3.618207642000044, 10.369342346000096],
            [3.592989543000101, 10.330946757000063],
            [3.572422323000097, 10.285704041000074],
            [3.573352498000077, 10.266997173000092],
            [3.587615193000147, 10.244182027000093],
            [3.65562137900011, 10.174780578000124],
            [3.664613078000059, 10.162197368000108],
            [3.667506957000057, 10.14656524700007],
            [3.664830075000083, 10.128653750000083],
            [3.663992961000105, 10.123052470000076],
            [3.654897908000123, 10.101115825000122],
            [3.642392212000118, 10.091891582000116],
            [3.627819458000147, 10.084992778000043],
            [3.612316528000065, 10.070290833000044],
            [3.605805297000074, 10.054116110000052],
            [3.599604126000088, 9.968694966000044],
            [3.589475545000141, 9.948825378000052],
            [3.557126099000072, 9.910558981000051],
            [3.530771118000104, 9.862964987000112],
            [3.513097778000088, 9.846609395000073],
            [3.452946411000141, 9.85309478800012],
            [3.413982381000068, 9.842837016000132],
            [3.342048788000113, 9.813588156],
            [3.325925740000031, 9.80172841500007],
            [3.317140747000053, 9.781729634000044],
            [3.314866984000048, 9.759095358000096],
            [3.318380981000075, 9.739432475000058],
            [3.330679972000041, 9.708633321000079],
            [3.338638143000082, 9.678221741000115],
            [3.331610148000095, 9.652021790000092],
            [3.299053996000055, 9.633960877000092],
            [3.281380656000124, 9.634994405000072],
            [3.261846964000114, 9.638611755000056],
            [3.245723918000039, 9.633702495000122],
            [3.238179158000094, 9.609052836000032],
            [3.23941939200003, 9.602309062000089],
            [3.244690389000056, 9.589570821000038],
            [3.243553507000058, 9.58440317800003],
            [3.182575317000101, 9.505338236000043],
            [3.175133911000074, 9.498878683000086],
            [3.159010864000095, 9.493478495000119],
            [3.151776164000125, 9.48815582300007],
            [3.132552531000101, 9.45727915500008],
            [3.12862512200013, 9.42958058700006],
            [3.135343058000046, 9.401675313000084],
            [3.148055461000098, 9.370256042000051],
            [3.151466105000054, 9.353564555000105],
            [3.151362752000097, 9.28863311700006],
            [3.145161580000121, 9.267859192000117],
            [3.124594360000032, 9.228998515000058],
            [3.091314738000079, 9.12642079600009],
            [3.076018514000054, 9.095156555000088],
            [3.051420533000055, 9.078206686000087],
            [2.983104289000096, 9.060610861000015],
            [2.971425415000112, 9.060507508000086],
            [2.961400187000095, 9.06531341600008],
            [2.951685018000148, 9.071902161000082],
            [2.940729614000077, 9.077069804000075],
            [2.929877564000122, 9.078361715000128],
            [2.899181762000097, 9.077379862000072],
            [2.888433064000083, 9.075364482000026],
            [2.877787720000072, 9.068543192000064],
            [2.869312784000073, 9.05970652300006],
            [2.859700969000073, 9.052626851000042],
            [2.84626509600011, 9.050766500000037],
            [2.769163859000059, 9.057045186000039],
            [2.772367798000118, 9.030535177000047],
            [2.770197387000053, 8.967154032000025],
            [2.764719686000149, 8.93976552400008],
            [2.76151574700009, 8.933693542000114],
            [2.750250285000021, 8.916872864000055],
            [2.747769816000044, 8.91480580600009],
            [2.74952681500011, 8.906615092000067],
            [2.753764282000077, 8.904418843000073],
            [2.758725220000116, 8.902661845000097],
            [2.762549276000072, 8.895685527000097],
            [2.762135864000044, 8.880415141000057],
            [2.749630167000049, 8.851941427000014],
            [2.745909464000135, 8.836516012000118],
            [2.74714969900009, 8.827653503000107],
            [2.752317342000083, 8.812279765000127],
            [2.751077107000043, 8.80341725700012],
            [2.745702759000096, 8.798146260000095],
            [2.72885624200012, 8.790472310000013],
            [2.723171834000055, 8.782927551000057],
            [2.722861776000087, 8.772308045000074],
            [2.722948943000091, 8.77121793800012],
            [2.742438669000109, 8.52748144300007],
            [2.744772583000042, 8.498293762000031],
            [2.736917765000101, 8.464523214000053],
            [2.728959595000049, 8.45274098700014],
            [2.709012492000113, 8.430390931000076],
            [2.703741495000088, 8.417885233000078],
            [2.703534790000049, 8.409022726000074],
            [2.706015259000111, 8.390548401000046],
            [2.706015259000111, 8.381272481000039],
            [2.698367147000113, 8.339853821000077],
            [2.697126913000091, 8.320707703000068],
            [2.700744263000075, 8.296884868000092],
            [2.70849572700007, 8.274819031000106],
            [2.728132771000105, 8.233193665000087],
            [2.734954061000082, 8.211902975000015],
            [2.734437297000113, 8.189966329000057],
            [2.726582479000086, 8.171595357000058],
            [2.716143839000068, 8.154903870000027],
            [2.708392375000045, 8.13797983800012],
            [2.705705200000125, 8.11968638100005],
            [2.703534790000049, 8.059896749000103],
            [2.690925741000115, 7.996567281000097],
            [2.687101684000055, 7.933522034000077],
            [2.683587687000113, 7.924633688000057],
            [2.673355753000124, 7.905565084000074],
            [2.671081990000118, 7.89791697200009],
            [2.671694505000062, 7.893434477000113],
            [2.672218872000116, 7.889597067000039],
            [2.680280396000114, 7.877349752000015],
            [2.691545858000069, 7.848669332000028],
            [2.715523722000086, 7.82205596900009],
            [2.724412068000106, 7.807689921000076],
            [2.727202596000069, 7.793323873000077],
            [2.717641139000136, 7.658548898000092],
            [2.715317017000132, 7.625788879000055],
            [2.720588012000064, 7.586566467000097],
            [2.7406384680001, 7.549359437000092],
            [2.770197387000053, 7.514271139000058],
            [2.792314901000054, 7.477632548000102],
            [2.78962772600002, 7.435826315000043],
            [2.787250610000086, 7.426886292000106],
            [2.786527140000089, 7.421253561000086],
            [2.783323201000115, 7.419238180000136],
            [2.761722452000129, 7.423527324000105],
            [2.751283814000089, 7.423630677000034],
            [2.74363570100013, 7.419238180000136],
            [2.741155232000068, 7.408179424000124],
            [2.762135864000044, 7.162199606000101],
            [2.761102336000079, 7.148350322000042],
            [2.757795044000062, 7.138893535000065],
            [2.749836873000106, 7.128558248000061],
            [2.7406384680001, 7.109592998000011],
            [2.736297648000118, 7.102926738000093],
            [2.735264119000135, 7.096002096000106],
            [2.739088175000091, 7.082979635000072],
            [2.747666463000115, 7.072230937000057],
            [2.773918090000052, 7.050785217000026],
            [2.779705851000131, 7.041328431000053],
            [2.775778442000075, 7.030528056000023],
            [2.765546508000085, 7.025102030000141],
            [2.752730754000083, 7.021329651000116],
            [2.741051880000043, 7.01580027300011],
            [2.715110311000075, 6.979833476000053],
            [2.718417602000073, 6.943556621000084],
            [2.731956828000136, 6.905212708000079],
            [2.736917765000101, 6.863303121000087],
            [2.7262724200001, 6.821367697000085],
            [2.723585246000084, 6.79971527100011],
            [2.728649536000148, 6.780000713000049],
            [2.736297648000118, 6.769846293000086],
            [2.744772583000042, 6.763774312000052],
            [2.755004517000117, 6.760725403000023],
            [2.767406860000079, 6.759562683000098],
            [2.773297974000087, 6.755040995000073],
            [2.775261677000117, 6.744886576000113],
            [2.778568969000105, 6.698765361000085],
            [2.772987915000101, 6.687474060000113],
            [2.76068892400005, 6.679386699000105],
            [2.742602172000147, 6.663341167000056],
            [2.731130005000125, 6.641843771000111],
            [2.730819946000054, 6.621354065000048],
            [2.739398234000078, 6.579186096000086],
            [2.737331177000101, 6.558024597000042],
            [2.718803181000084, 6.504297780000087],
            [2.715420369000071, 6.494488424000082],
            [2.71192043500011, 6.474047835000079],
            [2.704258260000131, 6.429298605000071],
            [2.703841289342392, 6.368351672675914],
            [2.703298373000052, 6.368312893000052],
            [2.306976759000065, 6.33148834800005],
            [2.226817254000082, 6.313666083000044],
            [1.88453209700009, 6.274807033000059],
            [1.619639519000089, 6.213893947000088],
            [1.612438598000068, 6.234762675000098],
            [1.633109171000086, 6.245692240000082],
            [1.761576782000105, 6.276026306000119],
            [1.782350708000138, 6.27726654100006],
            [1.763540486000124, 6.350647075000097],
            [1.744110148000061, 6.425732930000095],
            [1.71837528500015, 6.466996561000101],
            [1.709796997000126, 6.473404440000053],
            [1.688299601000097, 6.484437358000136],
            [1.681685018000081, 6.489837545000114],
            [1.67951460800009, 6.498570862000079],
            [1.681995077000067, 6.520016581000021],
            [1.680754842000027, 6.530067648000042],
            [1.674450318000112, 6.538594259000064],
            [1.657810506000089, 6.55226267500008],
            [1.655226685000088, 6.559213156000069],
            [1.653883098000051, 6.570659485000078],
            [1.646648397000149, 6.573191630000068],
            [1.636829874000085, 6.572261454000099],
            [1.62742476400004, 6.573346660000098],
            [1.619569946000098, 6.577997539000066],
            [1.611198364000131, 6.584689636000078],
            [1.603343547000094, 6.592596130000032],
            [1.597349081000061, 6.600812684000061],
            [1.594145141000098, 6.611044617000047],
            [1.594765258000081, 6.620268860000053],
            [1.596522257000061, 6.628640443000037],
            [1.596315552000078, 6.636417745000045],
            [1.58536014800012, 6.656442363000082],
            [1.572441040000115, 6.666906840000124],
            [1.566033163000071, 6.678146465000083],
            [1.574301392000109, 6.700574036000077],
            [1.589182290000082, 6.72046032800003],
            [1.597039021000086, 6.730959778000027],
            [1.601069784000089, 6.746436869000121],
            [1.595178670000081, 6.770569763000083],
            [1.587530558000111, 6.791033631000047],
            [1.583189738000044, 6.808267720000032],
            [1.582569620000072, 6.825346781000079],
            [1.590114380000102, 6.867333883000086],
            [1.58804732300004, 6.881234843000058],
            [1.579055623000102, 6.892035217000085],
            [1.564223443000088, 6.903089389000073],
            [1.562622518000126, 6.90428253200011],
            [1.551357055000068, 6.920870666000027],
            [1.53192671700009, 6.991925761000033],
            [1.607477661000132, 6.991408996000089],
            [1.62566776500006, 6.996783346000058],
            [1.624944296000081, 7.143647767000061],
            [1.624324178000109, 7.288806865000097],
            [1.623704060000136, 7.438100078000062],
            [1.623251367000051, 7.536384757000107],
            [1.622854912000122, 7.622459699000032],
            [1.622773885000072, 7.640051575000129],
            [1.621947062000061, 7.838282369000098],
            [1.621326945000078, 7.996567281000097],
            [1.623807414000055, 8.155885722000093],
            [1.625564412000131, 8.270478210000121],
            [1.61491906700013, 8.356261089000043],
            [1.609854777000066, 8.365485331000045],
            [1.603944873000017, 8.367476215000096],
            [1.601069784000089, 8.371634827000022],
            [1.606030721000138, 8.39602610300004],
            [1.606030721000138, 8.413389384000055],
            [1.607581014000061, 8.421864319000065],
            [1.64044722400007, 8.475814514000106],
            [1.644167928000087, 8.493487855000112],
            [1.639930461000034, 8.50325470000007],
            [1.614092245000109, 8.535785014000112],
            [1.609027954000055, 8.546972961000051],
            [1.607581014000061, 8.558755188000049],
            [1.607204026000119, 8.588617302000031],
            [1.605513956000095, 8.722491964000127],
            [1.604273722000045, 8.815225321000042],
            [1.602826782000051, 8.924391785000097],
            [1.601173136000114, 9.0495262660001],
            [1.595798787000149, 9.07681142200002],
            [1.587840617000097, 9.100892639000051],
            [1.567273397000093, 9.136730245000095],
            [1.50515832500011, 9.201454977000083],
            [1.425266561000115, 9.28449900300005],
            [1.4201460190001, 9.292317169000057],
            [1.401185343000066, 9.32126678500012],
            [1.386715942000137, 9.36113515200006],
            [1.379894653000093, 9.4624726360001],
            [1.368422485000082, 9.490842998000105],
            [1.351265910000109, 9.48254893000005],
            [1.336486450000081, 9.497509257000019],
            [1.326357869000049, 9.521952209000062],
            [1.323153930000075, 9.542312724000084],
            [1.327288045000103, 9.55530934600003],
            [1.345064737000115, 9.58238779700008],
            [1.351265910000109, 9.595074362000034],
            [1.352506144000131, 9.605280456000102],
            [1.35219608500006, 9.625356751000055],
            [1.354573201000107, 9.635304464000058],
            [1.356020141000101, 9.647474264000067],
            [1.348165324000149, 9.694163920000051],
            [1.346925089000138, 9.771833598000057],
            [1.345064737000115, 9.881103414000052],
            [1.34394169300009, 9.954756420000066],
            [1.343824503000093, 9.962442119000045],
            [1.331008748000102, 9.996471049000093],
            [1.225485473000049, 10.066053365000087],
            [1.082238403000105, 10.160440369000042],
            [0.997105905000097, 10.216553226000073],
            [0.939508097000044, 10.254517314000097],
            [0.844423462000094, 10.317174988000119],
            [0.768769164000048, 10.36709442100009],
            [0.760707642000057, 10.382158102000076],
            [0.759880818000113, 10.405154114000126],
            [0.773833456000119, 10.508145243000115],
            [0.788509562000115, 10.563852438000055],
            [0.789233032000112, 10.60294565900007],
            [0.781274862000146, 10.693043519000057],
            [0.795640910000145, 10.726478170000036],
            [0.850004517000116, 10.777689514000144],
            [0.862923625000121, 10.796086324000058],
            [0.866024210000148, 10.80636993400013],
            [0.8675745030001, 10.829210917000054],
            [0.869538208000108, 10.839907938000053],
            [0.885144490000073, 10.86938934400007],
            [0.883697551000068, 10.88021555600011],
            [0.875325968000084, 10.90052439400003],
            [0.872948853000139, 10.911298930000058],
            [0.875842732000137, 10.93116851800005],
            [0.901474243000109, 10.992740987000076],
            [0.931963338000088, 10.976101176000057],
            [0.945399211000051, 10.974292501000065],
            [0.963279256000078, 10.974137472000038],
            [0.967516723000131, 10.979485983000075],
            [0.969997192000108, 10.991164856000054],
            [0.969067017000071, 11.00289540700004],
            [0.963279256000078, 11.0082697550001],
            [0.955321085000122, 11.011990458000113],
            [0.951807088000066, 11.02108551100008],
            [0.951290324000126, 11.032299297000037],
            [0.952427205000049, 11.04240203900008],
            [0.955941203000094, 11.044727479000102],
            [0.964416138000104, 11.057414042000062],
            [0.970307251000094, 11.069480490000032],
            [0.976921834000109, 11.078368836000053],
            [0.981366008000094, 11.080125834000029],
            [0.986016887000062, 11.07849802700008],
            [1.007927694000017, 11.07506154400005],
            [1.014645629000142, 11.07035898900007],
            [1.019709920000111, 11.0656822710001],
            [1.025084269000075, 11.063511861000109],
            [1.027978149000063, 11.061341452000121],
            [1.033249146000088, 11.05157460500007],
            [1.035006144000079, 11.049275004000052],
            [1.041310669000097, 11.049585063000038],
            [1.052162720000126, 11.055011089000104],
            [1.056090129000097, 11.056070455000082],
            [1.086889282000072, 11.05273732500008],
            [1.097017863000133, 11.049275004000052],
            [1.099705037000149, 11.0443657430001],
            [1.106836385000094, 11.034418030000012],
            [1.114174438000077, 11.027674255000079],
            [1.117481730000094, 11.032195943000104],
            [1.118618612000091, 11.048241476000058],
            [1.107249796000104, 11.059791158000095],
            [1.100945272000104, 11.070410665000082],
            [1.099291626000138, 11.081288554000139],
            [1.099084920000081, 11.092605693000024],
            [1.097017863000133, 11.104491272000047],
            [1.09515751100011, 11.10443959500013],
            [1.085649047000032, 11.1087287390001],
            [1.082755168000062, 11.110692444000037],
            [1.08213505000009, 11.115291646000074],
            [1.08389204900007, 11.127719828000053],
            [1.082755168000062, 11.131802266000065],
            [1.073350057000084, 11.133946838000057],
            [1.067045532000094, 11.128339946000025],
            [1.063324829000067, 11.126970520000057],
            [1.062291300000084, 11.142060039000057],
            [1.067458943000105, 11.14428212500006],
            [1.10042850800005, 11.151620178000144],
            [1.106216267000121, 11.155650940000044],
            [1.113037557000069, 11.173866882000098],
            [1.117481730000094, 11.178982849000079],
            [1.128127076000084, 11.178879497000054],
            [1.148074178000087, 11.169500224000018],
            [1.158409465000119, 11.16593455000013],
            [1.153241821000108, 11.183168640000119],
            [1.149314412000138, 11.217249247000083],
            [1.130607544000071, 11.24758331300012],
            [1.13556848200011, 11.260114848000029],
            [1.145903768000011, 11.269855855000074],
            [1.156342407000039, 11.28553965200004],
            [1.165954224000075, 11.277994894000088],
            [1.173498982000098, 11.266600240000088],
            [1.172155395000061, 11.261484273000093],
            [1.180940389000028, 11.261355082000065],
            [1.186211385000149, 11.263887228000058],
            [1.191379028000057, 11.267013652000102],
            [1.200060669000038, 11.268977356000036],
            [1.218974243000076, 11.268047180000082],
            [1.235200642000081, 11.263473816000044],
            [1.268376912000093, 11.247893371000103],
            [1.281089314000042, 11.271096090000114],
            [1.282639608000068, 11.278873393000126],
            [1.280365845000063, 11.288691915000086],
            [1.270547323000073, 11.298277894000094],
            [1.268376912000093, 11.306210225000058],
            [1.273337850000132, 11.318224996000112],
            [1.284499959000073, 11.31272145600012],
            [1.296178833000056, 11.29962148100006],
            [1.302483358000046, 11.288846944000042],
            [1.309304647000118, 11.29708933500008],
            [1.316332642000106, 11.29987986200004],
            [1.323463989000061, 11.29708933500008],
            [1.330388631000034, 11.288846944000042],
            [1.347855265000078, 11.303497213000114],
            [1.345891561000144, 11.316338806000104],
            [1.336176391, 11.330033061000037],
            [1.330388631000034, 11.347163798000082],
            [1.339070271000082, 11.366103211000038],
            [1.359017375000121, 11.378893127000097],
            [1.381651652000073, 11.388685812000062],
            [1.398084757000049, 11.398685201000077],
            [1.388576293000142, 11.420001730000067],
            [1.389816529000086, 11.428399150000061],
            [1.398084757000049, 11.440310567000083],
            [1.411107218000069, 11.449844869000074],
            [1.423215479000135, 11.453747532000136],
            [1.423612915000149, 11.453875631000074],
            [1.433844848000149, 11.45940500900008],
            [1.439632609000114, 11.473771057000079],
            [1.455962361000047, 11.464701843000114],
            [1.475289347000114, 11.460774434000143],
            [1.56934045400007, 11.453307190000118],
            [1.567273397000093, 11.446692607000031],
            [1.564999634000088, 11.4326366170001],
            [1.563242635000108, 11.426022034000098],
            [1.58060591600011, 11.427055562000092],
            [1.601586548000114, 11.388685812000062],
            [1.621120239000049, 11.39527455700005],
            [1.638173461000065, 11.404214579000083],
            [1.684372192000126, 11.413852234000103],
            [1.703492472000107, 11.422921448000068],
            [1.719098755000061, 11.427779033000078],
            [1.763333781000085, 11.42467844600013],
            [1.78224735500001, 11.426022034000098],
            [1.821521444000069, 11.44160247800005],
            [1.84064172300009, 11.44547821000009],
            [1.858005005000081, 11.440310567000083],
            [1.867616821000098, 11.446615092000101],
            [1.879812459000107, 11.444858094000026],
            [1.905754028000075, 11.432843323000057],
            [1.948025349000147, 11.416720276000078],
            [1.983372030000055, 11.414007264000048],
            [2.010760538000085, 11.426900533000051],
            [2.015428661000072, 11.431589907000088],
            [2.146979614000116, 11.563739726000037],
            [2.220050089000068, 11.622547506000103],
            [2.273586873000113, 11.65205474900003],
            [2.287436157000087, 11.665283915000117],
            [2.291053507000072, 11.674792379000095],
            [2.290226684000118, 11.685747783000082],
            [2.29084680200009, 11.703214416000023],
            [2.301595500000104, 11.731533102000114],
            [2.340042766000067, 11.773856100000017],
            [2.354098755000081, 11.799849345000084],
            [2.390168904000092, 11.896535950000057],
            [2.388205201000062, 11.906767884000118],
            [2.376526327000079, 11.924079489000036],
            [2.37518273900011, 11.935034892000104],
            [2.380867146000071, 11.947902324000012],
            [2.389342081000052, 11.950072734000088],
            [2.398747192000116, 11.94878082300005],
            [2.407428832000079, 11.9512096160001],
            [2.414146769000098, 11.958702698000138],
            [2.422001587000125, 11.973172099000067],
            [2.428926228000108, 11.980355123000024],
            [2.438951457000144, 11.981285299000078],
            [2.449390096000087, 11.977512919000048],
            [2.456728149000071, 11.97906321200007],
            [2.457348267000043, 11.996219787000129],
            [2.455281209000077, 12.008673808000111],
            [2.448769979000105, 12.013376364000095],
            [2.439261515000112, 12.015598450000098],
            [2.428616170000026, 12.020352682000095],
            [2.418280883000108, 12.02867258700006],
            [2.411149536000096, 12.03678578800006],
            [2.405568481000074, 12.04670766200006],
            [2.371875447000122, 12.140448711000118],
            [2.362056925000047, 12.196155905000055],
            [2.361230102000121, 12.218893535000035],
            [2.370015096000117, 12.23625681600005],
            [2.394199666000077, 12.247212219000033],
            [2.407945597000122, 12.248917542000086],
            [2.43088993300006, 12.247987366000046],
            [2.443705689000126, 12.249227600000083],
            [2.446082805000088, 12.251811422000074],
            [2.454351033000108, 12.26302520800003],
            [2.459518677000119, 12.266745911000044],
            [2.46696008300006, 12.265040588000076],
            [2.472644491000096, 12.259252829000104],
            [2.477708781000075, 12.257599182000149],
            [2.483393188000122, 12.268037822000082],
            [2.488044067000089, 12.280388489000046],
            [2.495072062000077, 12.283230692000117],
            [2.504477173000055, 12.28183542900004],
            [2.516259400000138, 12.281422017000125],
            [2.519049927000111, 12.27914825500011],
            [2.52060021900013, 12.27367055300003],
            [2.523700806000079, 12.26917470300009],
            [2.53124556500012, 12.26969146700013],
            [2.536929972000053, 12.273050436000048],
            [2.54602502400013, 12.281628724000086],
            [2.550572550000084, 12.284522604000074],
            [2.586125936000116, 12.294031067000049],
            [2.590053345000086, 12.293307597000052],
            [2.598631632000121, 12.288346659000098],
            [2.603592570000075, 12.287829895000073],
            [2.609690389000122, 12.290775452000062],
            [2.621679321000101, 12.299508769000042],
            [2.628603963000074, 12.300800680000094],
            [2.663847290000149, 12.291550598000072],
            [2.672942342000113, 12.296718241000079],
            [2.686894979000101, 12.31842234300008],
            [2.6902022700001, 12.326173808000078],
            [2.692165975000137, 12.33402862600012],
            [2.695059855000125, 12.341211650000076],
            [2.700434204000089, 12.347102763000066],
            [2.711286254000129, 12.351236878000094],
            [2.721828247000104, 12.344260560000095],
            [2.732266886000048, 12.34679270400008],
            [2.741465291000054, 12.354130758000082],
            [2.757484985000076, 12.372940979000091],
            [2.768543742000105, 12.380072327000036],
            [2.778155558000094, 12.381932678000041],
            [2.798412720000101, 12.381209209000133],
            [2.808644653000101, 12.38322458900008],
            [2.832415812000136, 12.384051413000108],
            [2.844301392000091, 12.39924428300013],
            [2.892257121000114, 12.357076314000082],
            [2.912617635000032, 12.346327616000067],
            [2.922642863000078, 12.335630595000055],
            [2.930394328000062, 12.323331604000103],
            [2.936802205000106, 12.300852357000096],
            [2.944967081000129, 12.292480774000126],
            [2.95602583800013, 12.286848043000091],
            [2.967808064000053, 12.282558899000037],
            [3.000984334000066, 12.278889873000125],
            [3.009355917000022, 12.276306051000034],
            [3.013076620000049, 12.27108673100011],
            [3.022895142000095, 12.252483215000069],
            [3.063409464000102, 12.193778789000106],
            [3.23538863100012, 12.039524638000103],
            [3.23848921700008, 12.034201965000051],
            [3.252028442000068, 12.024125062000024],
            [3.255129028000113, 12.018750712000056],
            [3.25760949700009, 11.997408346000057],
            [3.262570435000043, 11.97472239200009],
            [3.269908488000112, 11.956532288000048],
            [3.292749471000121, 11.918653463000055],
            [3.307012166000106, 11.902375387000035],
            [3.315487102000105, 11.894572246000024],
            [3.327786092000053, 11.886407369000096],
            [3.341635376000113, 11.88289337200004],
            [3.355071248000058, 11.889042868000018],
            [3.36912723800009, 11.897311096000067],
            [3.380909465000087, 11.895037334000051],
            [3.391658163000102, 11.888836161000057],
            [3.402820272000042, 11.885270488000089],
            [3.447675415000106, 11.85798533100008],
            [3.484262329000074, 11.845169577000092],
            [3.495424439000089, 11.837521464000105],
            [3.503485961000081, 11.829976705000064],
            [3.53697229000008, 11.782899476000068],
            [3.543690226000109, 11.777060038000087],
            [3.549271280000113, 11.773752746000085],
            [3.553715454000042, 11.769670309000077],
            [3.557436157000041, 11.76181549100005],
            [3.562500447000104, 11.746002503000057],
            [3.566221150000047, 11.738354391000072],
            [3.568184855000055, 11.729517721000065],
            [3.571698852000111, 11.721869608000091],
            [3.580070435000096, 11.717373759000068],
            [3.589372193000116, 11.701509095000063],
            [3.596400187000114, 11.69577301000001],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Angola',
        iso3: 'AGO',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [13.073702840000067, -4.635323180999961],
              [13.0653312580001, -4.663951923999946],
              [13.029571167000086, -4.676871032999955],
              [12.833200724000022, -4.722656351999902],
              [12.8029183350001, -4.73981292699996],
              [12.786175171000139, -4.758416441999913],
              [12.774806356000056, -4.779500426999945],
              [12.768295125000094, -4.801927998999929],
              [12.766228068000117, -4.825182392999949],
              [12.756926310000097, -4.837274678999933],
              [12.711967814000076, -4.863319599999912],
              [12.696981648000104, -4.875618591999867],
              [12.688300008000056, -4.897012633999879],
              [12.68623295000009, -4.912825621999957],
              [12.678894897000106, -4.924297789999883],
              [12.654400269000064, -4.932566019999925],
              [12.615849650000087, -4.935459899999913],
              [12.606961304000066, -4.942229511999955],
              [12.603964070000131, -4.962590026999891],
              [12.587737671000127, -5.000313822999942],
              [12.550427287000105, -5.02418833399993],
              [12.466504761000095, -5.053127135999887],
              [12.458133179000129, -5.05416066499987],
              [12.450691772000084, -5.053127135999887],
              [12.444387248000083, -5.055090840999924],
              [12.439426310000044, -5.064806009999955],
              [12.438909546000104, -5.073280944999865],
              [12.440769898000099, -5.08402964299998],
              [12.44469730600008, -5.093538105999869],
              [12.450381714000116, -5.098809102],
              [12.511980021000056, -5.120513203999906],
              [12.52407230600005, -5.129091490999926],
              [12.530686889000037, -5.162681171999864],
              [12.52768965700011, -5.239472350999918],
              [12.524382365000122, -5.324738464999896],
              [12.519731486000069, -5.444214375999948],
              [12.514977254000058, -5.568754577999897],
              [12.512496785000081, -5.633660176999925],
              [12.50898278800014, -5.726264343999972],
              [12.435498901000074, -5.725540872999886],
              [12.344445028000024, -5.724610696999932],
              [12.258972209000092, -5.736702981999926],
              [12.210541212000066, -5.763441664999959],
              [12.21029707100007, -5.763116143999923],
              [12.16179446700005, -5.681247653999947],
              [12.147227410000085, -5.617933851999908],
              [12.170176629000082, -5.554620049999926],
              [12.182383660000085, -5.543226820999905],
              [12.193369988000086, -5.540622653999947],
              [12.20484459700009, -5.539808851999908],
              [12.218597852000073, -5.534112237999921],
              [12.22828209700009, -5.523695570999905],
              [12.23218834700009, -5.510918877999927],
              [12.23218834700009, -5.479587497999944],
              [12.229258660000085, -5.466892184999949],
              [12.214121941000087, -5.431247653999947],
              [12.196389975000045, -5.396096918999945],
              [12.17136229600004, -5.329088242999944],
              [12.17209074100009, -5.302094889999921],
              [12.13234859000005, -5.232529128999943],
              [12.12461191400007, -5.184828052999933],
              [12.069737322000037, -5.119782870999927],
              [12.02312259200005, -5.045993747999944],
              [12.023285352000073, -5.035251559999949],
              [12.03515088100005, -5.038468946999956],
              [12.054771436000067, -5.042353816999935],
              [12.067822632000059, -5.046252994999918],
              [12.074346011000046, -5.052105853999933],
              [12.080891585000074, -5.075509125999929],
              [12.100527406000083, -5.080022217999954],
              [12.11681516300007, -5.069629422999924],
              [12.127259263000042, -5.053366311999923],
              [12.128561266000077, -5.039711413999953],
              [12.137714746000086, -5.034497411999951],
              [12.13705413100007, -5.014996054999926],
              [12.132475939000074, -5.005899218999957],
              [12.123330939000084, -5.002654564999943],
              [12.112884833000066, -5.00200981699993],
              [12.105050408000068, -5.013067071999956],
              [12.103085313000065, -5.027375522999932],
              [12.103738391000093, -5.048835580999935],
              [12.097859004000043, -5.054042887999913],
              [12.090669889000083, -5.05079759399996],
              [12.086108343000092, -5.030635647999929],
              [12.07958768800006, -5.020231727999942],
              [12.071751654000082, -5.01763449099991],
              [12.066529096000068, -5.026740248999943],
              [12.056727353000042, -5.027396764999935],
              [12.044960248000052, -5.020901671999923],
              [12.030556093000087, -5.022866506999947],
              [12.009607691000042, -5.019630835999919],
              [12.01807177200007, -5.008599787999941],
              [12.130814657000087, -4.912928975999904],
              [12.157169637000038, -4.870554299999881],
              [12.187555379000088, -4.768028258999919],
              [12.192206258000056, -4.763480732999895],
              [12.204091837000107, -4.763480732999895],
              [12.213496948000056, -4.769165139999927],
              [12.222592000000105, -4.780637308999943],
              [12.23520104900004, -4.803995055999906],
              [12.244089396000078, -4.796346943999922],
              [12.258558797000092, -4.7907658889999],
              [12.273751668000017, -4.787148538999915],
              [12.307651407000037, -4.78363454099987],
              [12.321914103000097, -4.778156839999966],
              [12.332352743000058, -4.765857848999929],
              [12.374107299000087, -4.683175556999871],
              [12.37886153100007, -4.662298278999899],
              [12.377621297000132, -4.61940683999994],
              [12.38702640800011, -4.605454203999955],
              [12.414104859000048, -4.608864846999978],
              [12.429091024000115, -4.607521259999913],
              [12.497200562000046, -4.585300394999877],
              [12.608098185000074, -4.565043232999884],
              [12.623807821000128, -4.559255472],
              [12.634866577000139, -4.547679951999953],
              [12.65657067900014, -4.507372333999911],
              [12.67052331500011, -4.491352640999949],
              [12.686853068000062, -4.478330179999915],
              [12.704939819000089, -4.467994893999901],
              [12.718479044000048, -4.451871845999918],
              [12.726540568000132, -4.42799733399994],
              [12.737909383000044, -4.404949645999878],
              [12.761680542000107, -4.391203714999932],
              [12.775426473000039, -4.396164651999896],
              [12.782655684000076, -4.40007075799987],
              [12.801057984000096, -4.410013935999942],
              [12.814803914000038, -4.412907816999933],
              [12.830306844000035, -4.40970387699987],
              [12.84229577700009, -4.404329528999909],
              [12.85428470900007, -4.403089294999873],
              [12.86989099100009, -4.411977640999893],
              [12.884463745000062, -4.432131448999954],
              [12.902447144000035, -4.480190531999924],
              [12.921980835000056, -4.502308043999932],
              [12.961564982000112, -4.533830667999894],
              [13.027194051000038, -4.612172138999881],
              [13.073702840000067, -4.635323180999961],
            ],
          ],
          [
            [
              [23.96745650200009, -10.872306822999903],
              [23.974277791000134, -10.921399433999937],
              [23.98058231600004, -10.938349303999942],
              [24.000012654000045, -10.967804869999938],
              [24.00373335800012, -10.982480977999927],
              [23.997325480000086, -11.001704609999948],
              [23.9937081300001, -11.019584654999917],
              [23.99453495300014, -11.074981790999871],
              [23.990090779000127, -11.113532408999944],
              [23.995775187000078, -11.127381693999908],
              [24.01530887800007, -11.13048227899995],
              [24.011174764000145, -11.272902525999939],
              [24.016962525000025, -11.298430684999886],
              [24.061094197000017, -11.394962259999915],
              [24.061714315000103, -11.406951191999966],
              [24.052102499000085, -11.42049041699994],
              [24.020786581000067, -11.444571634999889],
              [24.009934530000123, -11.459454446999928],
              [24.007557414000075, -11.470513203999928],
              [24.00724735500009, -11.483122252999863],
              [24.00983117700008, -11.507203470999912],
              [24.009727824000066, -11.523429869999916],
              [24.005387004000085, -11.535212096999913],
              [23.97768843600005, -11.577276712999947],
              [23.959911743000134, -11.61717091899989],
              [23.9546407470001, -11.636911315999939],
              [23.9546407470001, -11.66223276699992],
              [23.96228885900007, -11.681559752999888],
              [23.972727498000012, -11.70057667999994],
              [23.981305786000036, -11.724761250999919],
              [23.98554325300009, -11.799485371999921],
              [23.990194132000056, -11.82408335399991],
              [23.988540487000108, -11.834211933999953],
              [23.96704309100008, -11.882891132999887],
              [23.961048624000057, -12.011668802999878],
              [23.954330689000102, -12.151918639999877],
              [23.959601685000052, -12.19667043099993],
              [23.981305786000036, -12.227676289999863],
              [24.006627238000107, -12.253721211999931],
              [24.016859171000107, -12.278939310999888],
              [24.020993286000135, -12.340020852999885],
              [24.030811808000095, -12.385082702999924],
              [24.02802128100012, -12.402135924999868],
              [24.019856405000013, -12.419189147999901],
              [23.986060018000046, -12.467661640999964],
              [23.94079146300004, -12.532773945999864],
              [23.928699178000045, -12.561609394999891],
              [23.91071577900007, -12.631269225999915],
              [23.891698853000094, -12.705063170999964],
              [23.872268514000012, -12.750125020999917],
              [23.86565393100011, -12.78970916699997],
              [23.874748983000103, -12.82174855499997],
              [23.895109497000107, -12.849757181999891],
              [23.94957645700012, -12.904637552999901],
              [23.97179732200007, -12.933369649999904],
              [23.988850545000105, -12.965098978999919],
              [24.000632772000102, -13.001479186999916],
              [23.9682833250001, -13.001479186999916],
              [23.84415653500008, -13.001479186999916],
              [23.71982303900009, -13.001479186999916],
              [23.59559289500004, -13.001479186999916],
              [23.471259399000076, -13.001479186999916],
              [23.346925903000084, -13.001479186999916],
              [23.222695760000107, -13.001479186999916],
              [23.09836226400006, -13.001479186999916],
              [22.974028768000068, -13.001479186999916],
              [22.84979862500009, -13.001479186999916],
              [22.72546512800011, -13.001479186999916],
              [22.601234985000076, -13.001479186999916],
              [22.477004842000014, -13.001479186999916],
              [22.352774698000076, -13.001479186999916],
              [22.2285445550001, -13.001479186999916],
              [22.104211059000107, -13.001479186999916],
              [21.97987756300006, -13.001479186999916],
              [21.979980916000073, -13.152167663999947],
              [21.980084269000088, -13.302701109999944],
              [21.98018762200013, -13.453492939999919],
              [21.98029097400007, -13.60418141599996],
              [21.98035310000006, -13.694822054999918],
              [21.980394328000074, -13.754973245999935],
              [21.980497681000116, -13.905558369999952],
              [21.98060103400013, -14.056350198999922],
              [21.98070438600007, -14.20693532299994],
              [21.980807739000085, -14.357623798999981],
              [21.980911092000042, -14.508415628999956],
              [21.98101444500014, -14.659104104999898],
              [21.98111779800007, -14.809792581999943],
              [21.981221150000096, -14.960481058999974],
              [21.981324503000053, -15.11116953499993],
              [21.981427856000067, -15.261858011999962],
              [21.9815312100001, -15.412546487999919],
              [21.9815312100001, -15.452337340999918],
              [21.9815312100001, -15.47352467899988],
              [21.9815312100001, -15.503807067999915],
              [21.9815312100001, -15.547835387999967],
              [21.981427856000067, -15.649948017999918],
              [21.981221150000096, -15.75195729599993],
              [21.980911092000042, -15.853966572999951],
              [21.980807739000085, -15.956079202999902],
              [21.98060103400013, -16.001244404999866],
              [21.9815312100001, -16.00403493299993],
              [21.9815312100001, -16.06749359099996],
              [21.9815312100001, -16.128161721999945],
              [21.9815312100001, -16.144284769999928],
              [21.983804972000115, -16.1658855189999],
              [22.010366658000123, -16.198131611999955],
              [22.0451965740001, -16.252288512999968],
              [22.019875122000116, -16.253115335999908],
              [22.011710246000092, -16.252288512999968],
              [22.022355590000075, -16.2663445029999],
              [22.025972941000077, -16.278953552999923],
              [22.027729940000143, -16.291665953999967],
              [22.032174113000053, -16.306342060999953],
              [22.03661828600005, -16.31223317399987],
              [22.048607218000114, -16.32236175599992],
              [22.05201786300006, -16.326805927999928],
              [22.053671508000093, -16.33652109699996],
              [22.054188273000136, -16.35863861099996],
              [22.055841919000073, -16.364633076999908],
              [22.089121542000044, -16.37197113099998],
              [22.105554646000087, -16.379412536999922],
              [22.103590943000142, -16.391918232999913],
              [22.094289184000047, -16.404733987999904],
              [22.086020955000095, -16.422303974999878],
              [22.08074995900006, -16.441010843999948],
              [22.07992313600002, -16.45775400799991],
              [22.0845740150001, -16.47015635199996],
              [22.10173059100015, -16.49795827199992],
              [22.107311646000056, -16.512324319999934],
              [22.10658817500007, -16.525966897999936],
              [22.104004354000068, -16.536715595999866],
              [22.108138469000096, -16.543950296999924],
              [22.127258748000088, -16.546430764999897],
              [22.13811079900003, -16.55263193799989],
              [22.142451619000013, -16.56710133899992],
              [22.145138794000047, -16.584051208999924],
              [22.151650025, -16.597693786999926],
              [22.237742961000095, -16.66549326599994],
              [22.251282186000083, -16.67004079199998],
              [22.259033651000095, -16.669213968999955],
              [22.27412316900009, -16.663632914999937],
              [22.28373498500011, -16.661359150999928],
              [22.287352335000094, -16.658258564999883],
              [22.290762980000096, -16.65639821399988],
              [22.295620565000036, -16.659188740999937],
              [22.303061971000147, -16.666940205999936],
              [22.30698937900013, -16.669213968999955],
              [22.333654419000055, -16.673658141999866],
              [22.34347294100013, -16.683166605999943],
              [22.350087524000116, -16.69629241999992],
              [22.365797160000085, -16.71685963999991],
              [22.372618449000043, -16.72884857199996],
              [22.377992798, -16.73484303799998],
              [22.383573853000115, -16.737530211999925],
              [22.39959354600009, -16.740424091999913],
              [22.40889530400011, -16.745798441999867],
              [22.416646769000124, -16.75448008199993],
              [22.489097127000093, -16.865377705999947],
              [22.499742472000094, -16.893489684999892],
              [22.50852746600009, -16.906202087999944],
              [22.52289351400009, -16.91467702199995],
              [22.554519491000065, -16.924185485999928],
              [22.56723189300004, -16.93689788799989],
              [22.569298950000103, -16.944959411999974],
              [22.569195597000146, -16.96242604499993],
              [22.573433064000113, -16.971004332999954],
              [22.579324178000036, -16.97534515399994],
              [22.59203658100006, -16.975448505999864],
              [22.651671183000076, -16.998702900999973],
              [22.665623820000064, -17.008624775999877],
              [22.710478963000043, -17.055443623999906],
              [22.73073612500005, -17.0815918979999],
              [22.744792114000063, -17.10825693699995],
              [22.755850871000092, -17.154869079999912],
              [22.765152628000095, -17.169648538999922],
              [22.778278442000072, -17.18039723699995],
              [22.80938765500011, -17.196416930999902],
              [22.84917850700012, -17.23104014099991],
              [22.87615360500007, -17.24809336299994],
              [22.936511678000073, -17.273311461999896],
              [22.9841573490001, -17.28581715899989],
              [22.998626750000142, -17.293775328999956],
              [23.040381307000075, -17.337080179999916],
              [23.046375773000108, -17.34844899399991],
              [23.054127238000035, -17.375320739999907],
              [23.073040812000073, -17.4050863639999],
              [23.097638794000147, -17.432164814999865],
              [23.121513306000026, -17.45087168299993],
              [23.165748332000135, -17.467408141999925],
              [23.176186971000078, -17.478156839999954],
              [23.179080852000084, -17.494176533999905],
              [23.176910441000075, -17.50978281599994],
              [23.177530558000058, -17.524045511999915],
              [23.189726196000066, -17.53655120799992],
              [23.20698612500007, -17.54120208699989],
              [23.22424605300006, -17.539341735999884],
              [23.241299275000074, -17.535104267999927],
              [23.258352498000107, -17.532830504999907],
              [23.290805298000123, -17.535414326999913],
              [23.305378051000076, -17.539548441999926],
              [23.320157512000094, -17.546369730999885],
              [23.340621379000055, -17.5607357789999],
              [23.35943160000008, -17.582853291999896],
              [23.382272583000088, -17.601043395999938],
              [23.375141235000058, -17.615409443999937],
              [23.37596805800007, -17.62822519999993],
              [23.381652466000105, -17.641144306999934],
              [23.298039998000093, -17.656853942999902],
              [23.09391809100012, -17.69540456099989],
              [22.889796183000072, -17.734058531999978],
              [22.68567427500011, -17.77281585599991],
              [22.481449015000123, -17.811366474999986],
              [22.230508260000136, -17.857565205999933],
              [21.979464152000048, -17.90376393599989],
              [21.72852339700006, -17.949859313999923],
              [21.477582642000073, -17.99605804499997],
              [21.405545695000086, -18.009287210999958],
              [21.386838826000115, -18.014454853999965],
              [21.38115441900007, -18.012594501999956],
              [21.364824666000118, -17.99202728199988],
              [21.335059041000136, -17.977971292999953],
              [21.27811161300008, -17.95854095399997],
              [21.23273970600013, -17.934459736999926],
              [21.21661665800005, -17.930635680999984],
              [21.175792277000056, -17.9332195019999],
              [21.161322876000042, -17.930635680999984],
              [21.143132772000087, -17.93373626699993],
              [21.126079549000053, -17.941074319999927],
              [21.10943973800005, -17.945001728999983],
              [21.093109986000087, -17.93807708699991],
              [21.000712524000107, -17.96205495199993],
              [20.986454526000074, -17.965770962999912],
              [20.90831506300009, -17.986136168999877],
              [20.894465780000132, -18.012594501999956],
              [20.861599569000106, -18.018795673999946],
              [20.83193729600012, -18.029337666999908],
              [20.80620243300004, -18.031404723999884],
              [20.78460168500007, -18.012594501999956],
              [20.754422648000087, -17.997918395999974],
              [20.73747277800007, -17.993474221999875],
              [20.729928020000017, -18.00236256899997],
              [20.722486613000086, -18.00649668299991],
              [20.70615686000008, -18.003809508999964],
              [20.68962040200006, -17.99698821999992],
              [20.68217899600006, -17.98861663799994],
              [20.66626265500011, -17.980245055999973],
              [20.630089152000096, -17.976937764999974],
              [20.590711710000107, -17.97879811599998],
              [20.565493611000136, -17.985205993999926],
              [20.552884562000116, -17.979108174999865],
              [20.52394576000006, -17.95854095399997],
              [20.48952925600011, -17.94210784899991],
              [20.479504028000093, -17.934356383999912],
              [20.460073690000087, -17.913685810999894],
              [20.437542765000074, -17.89446217799987],
              [20.412634725000117, -17.884126891999955],
              [20.386796509000078, -17.890328063999945],
              [20.347729126000075, -17.858908792999912],
              [20.33615360500005, -17.854878030999913],
              [20.302770630000055, -17.860769143999917],
              [20.28892134600011, -17.86159596699993],
              [20.278172648000066, -17.854878030999913],
              [20.24344608500013, -17.88278330499989],
              [20.219881633000057, -17.87337819399994],
              [20.19311324000006, -17.872137959999904],
              [20.169238729000085, -17.878132425999922],
              [20.1545626220001, -17.890328063999945],
              [20.147121216000073, -17.88278330499989],
              [20.132961873000113, -17.888777770999923],
              [20.119939413000083, -17.890741474999956],
              [20.09255090300013, -17.890328063999945],
              [20.034259888000093, -17.895909118999953],
              [20.024544719000062, -17.894565530999984],
              [19.989508097000055, -17.88278330499989],
              [19.95199100700006, -17.86231943799993],
              [19.793964477000117, -17.86231943799993],
              [19.787659953000087, -17.866453551999953],
              [19.775981079000132, -17.88505706799991],
              [19.771020141000093, -17.890328063999945],
              [19.75520715300007, -17.88908782999991],
              [19.732056112000095, -17.882059835],
              [19.711282186000062, -17.872964781999926],
              [19.70218713400007, -17.86573008199987],
              [19.69319543500012, -17.847746683999972],
              [19.672628215000145, -17.842682392999905],
              [19.64978723200005, -17.84495615599991],
              [19.59283980300006, -17.857255146999947],
              [19.421274048000043, -17.859425556999938],
              [19.26242069500009, -17.81395029699989],
              [19.246607706000106, -17.804028421999902],
              [19.201855916000028, -17.807129007999933],
              [19.172090292000064, -17.80123789499993],
              [19.16082482900009, -17.800927835999943],
              [19.139327433000062, -17.805268655999924],
              [19.105117635000056, -17.818187763999944],
              [19.020574992000093, -17.822321878999958],
              [18.89004032400001, -17.799274189999906],
              [18.80084680200008, -17.756589456999905],
              [18.761986124000117, -17.7477011109999],
              [18.74824019400009, -17.736332295],
              [18.72829309100007, -17.7109074909999],
              [18.670932251000067, -17.653133239999903],
              [18.66132043400006, -17.646725361999955],
              [18.64282027200005, -17.638043721999892],
              [18.633311808000144, -17.628948668999925],
              [18.627937459000094, -17.61985361799995],
              [18.622873169000115, -17.602180276999945],
              [18.619669230000056, -17.594842223999947],
              [18.567476033000077, -17.553294371999968],
              [18.554143514000145, -17.546369730999885],
              [18.550939575000086, -17.535310973999884],
              [18.516626424000066, -17.471335549999907],
              [18.492751912000074, -17.464514261999938],
              [18.489858032000086, -17.46244720399997],
              [18.488101033000106, -17.45211191799997],
              [18.471667928000045, -17.414284769999895],
              [18.465156697000083, -17.409220478999927],
              [18.45864546700011, -17.405293070999946],
              [18.455028117000012, -17.395991312999925],
              [18.453581177000018, -17.389893493999878],
              [18.445726359000076, -17.389273375999906],
              [18.392292928000074, -17.389273375999906],
              [18.13566776500005, -17.389170022999878],
              [18.000482986000094, -17.389115556999897],
              [17.87914595500004, -17.38906666999995],
              [17.622624146000135, -17.388963317999924],
              [17.36610233600004, -17.388963317999924],
              [17.278972034000105, -17.38892822699995],
              [17.10947717300013, -17.388859964999895],
              [16.852852010000106, -17.388756611999952],
              [16.596330200000097, -17.388756611999952],
              [16.339808390000087, -17.388653258999938],
              [16.08338993300012, -17.388653258999938],
              [15.826764770000096, -17.388653258999938],
              [15.570242961000105, -17.388549906999913],
              [15.559114346000086, -17.388545422999897],
              [15.313721151000095, -17.388446553999884],
              [15.057199341000114, -17.38834320099994],
              [14.80057417800009, -17.38834320099994],
              [14.543949015000067, -17.388239846999923],
              [14.287427206000046, -17.388136494999898],
              [14.219111804000079, -17.388136494999898],
              [14.218800903000101, -17.388136494999898],
              [14.207432088000104, -17.388033141999955],
              [14.206501913000068, -17.393097432999937],
              [14.197096802000118, -17.412941181999926],
              [14.174979288000088, -17.41624847399993],
              [14.130744263000082, -17.409220478999927],
              [14.12392297300002, -17.41159759499996],
              [14.10821333800007, -17.420485940999882],
              [14.097257935000073, -17.42358652799993],
              [14.085372355000061, -17.42358652799993],
              [14.069145956000057, -17.418625589999877],
              [14.047441854000056, -17.416041768999975],
              [14.029148396000068, -17.410460713999953],
              [14.017882934000113, -17.409220478999927],
              [14.008891236000068, -17.411494241999932],
              [13.992974894000042, -17.421312763999907],
              [13.98057255000009, -17.42358652799993],
              [13.95731815600007, -17.419142353999916],
              [13.9427454020001, -17.408186950999934],
              [13.896856730000138, -17.349069111999967],
              [13.884351033000115, -17.33852711999991],
              [13.790403279000117, -17.28809092199991],
              [13.694130086000143, -17.23662119599993],
              [13.60648685700005, -17.167374775999917],
              [13.521324097000104, -17.121899515999957],
              [13.530935913000093, -17.093270771999883],
              [13.522254273000044, -17.076941018999932],
              [13.507784872000116, -17.063505146999987],
              [13.494659058000138, -17.02402435299996],
              [13.479776245000096, -17.010278421999928],
              [13.45889896600005, -17.00180348699992],
              [13.435127807000072, -16.99901295999996],
              [13.417247762000017, -16.993741962999934],
              [13.382004435000056, -16.970384215999985],
              [13.363710978000086, -16.9641830449999],
              [13.345946539000096, -16.96871123499993],
              [13.32154300900001, -16.974931742999928],
              [13.315238485000094, -16.974414977999885],
              [13.308417195000061, -16.97017751099993],
              [13.293017619000068, -16.973794860999917],
              [13.26748946100011, -16.985370380999953],
              [13.26748946100011, -16.97792897499994],
              [13.25715417500004, -16.98164967799994],
              [13.245268595000084, -16.981339619999872],
              [13.222841023000086, -16.97792897499994],
              [13.212092325000071, -16.972761331999934],
              [13.205477743000074, -16.963046162999902],
              [13.198139689000072, -16.95736175499995],
              [13.184910523000099, -16.9641830449999],
              [13.166307006000125, -16.951057230999936],
              [13.144499552000099, -16.9524008179999],
              [13.121761922000132, -16.959842223999928],
              [13.014274943000117, -16.97792897499994],
              [12.961668335000127, -17.00738454199994],
              [12.930455770000066, -17.0142058309999],
              [12.91102543100007, -17.02350758899992],
              [12.887150920000096, -17.029812112999934],
              [12.882293335000071, -17.039527281999966],
              [12.880536336000091, -17.05079274499994],
              [12.876402222000081, -17.059784443999973],
              [12.8677205810001, -17.065572204999953],
              [12.84994388800007, -17.07084319999997],
              [12.84229577700009, -17.074047138999944],
              [12.833097371000093, -17.08179860399987],
              [12.82493249500007, -17.096371357999914],
              [12.818317912000083, -17.104846292999923],
              [12.784314820000134, -17.1150782269999],
              [12.739873088000081, -17.13554209399996],
              [12.704733114000106, -17.164274189999958],
              [12.685922892000121, -17.173575948],
              [12.660704793000065, -17.17708994499995],
              [12.63621016400009, -17.185151468999933],
              [12.591458374000041, -17.222565205999913],
              [12.567170451000038, -17.234554137999865],
              [12.554561401000115, -17.235587666999947],
              [12.5192147220001, -17.22783620099993],
              [12.460510294000073, -17.223081970999942],
              [12.44170007300005, -17.21698415099989],
              [12.4179289140001, -17.203444925999918],
              [12.407593628000086, -17.20406504299997],
              [12.393951050000084, -17.214710387999972],
              [12.379481649000041, -17.22039479499992],
              [12.314679402000138, -17.2181210319999],
              [12.242642456000084, -17.22483896899992],
              [12.239335165000085, -17.22070485499991],
              [12.236544637000122, -17.211299743999945],
              [12.231790405000112, -17.201894632999895],
              [12.222281942000052, -17.19765716499994],
              [12.211739950000066, -17.195176695999876],
              [12.200474487000122, -17.18928558399996],
              [12.190655965000133, -17.182567646999942],
              [12.185074911000129, -17.17708994499995],
              [12.181147501000055, -17.16923512799991],
              [12.179493856000107, -17.16158701599994],
              [12.17711674000006, -17.154765726999884],
              [12.170708862000112, -17.14918467199996],
              [12.161510457000134, -17.146290791999974],
              [12.156652873000098, -17.149081318999933],
              [12.151278524000134, -17.15362884499997],
              [12.139909708000062, -17.15600596099992],
              [12.10559655800003, -17.14608408599993],
              [12.095261271000112, -17.139676207999884],
              [12.088129923000082, -17.139159443999944],
              [12.082238810000092, -17.141329853999935],
              [12.075210816000066, -17.14298349999997],
              [12.028908732000104, -17.14897796599992],
              [11.983020060000115, -17.161897073999924],
              [11.942092326000108, -17.180500589999966],
              [11.894963419000106, -17.214607035999947],
              [11.853932332000056, -17.233417256999957],
              [11.835535523000146, -17.245406188999908],
              [11.829644409000139, -17.253467712999907],
              [11.827473999000063, -17.260082294999904],
              [11.822409709000084, -17.26442311599989],
              [11.807630249000084, -17.265870055999883],
              [11.79688155100007, -17.263802998999907],
              [11.77951826900005, -17.254914651999897],
              [11.766183862000048, -17.25275074599992],
              [11.766123894000089, -17.252699476999908],
              [11.766123894000089, -17.245293877999927],
              [11.757985873000052, -17.23919036299992],
              [11.752777540000068, -17.229180596999925],
              [11.750743035000085, -17.21689218499995],
              [11.751800977000073, -17.20370859199994],
              [11.758636915000068, -17.165215752999927],
              [11.759287957000083, -17.03297291499996],
              [11.772114401000067, -16.947025539999913],
              [11.780013158000088, -16.86946740299993],
              [11.76814401100006, -16.798520396999947],
              [11.768141038000067, -16.76825133299991],
              [11.785921415000075, -16.76352011399996],
              [11.79086998400004, -16.806082244999914],
              [11.803709509000043, -16.824033303999954],
              [11.82047405600008, -16.781471608999937],
              [11.817637566000087, -16.704685153999947],
              [11.823090040000068, -16.67896900799991],
              [11.81381269600007, -16.583916924999926],
              [11.82195071700005, -16.47909921699994],
              [11.779144727000073, -16.099867445999905],
              [11.779795769000089, -16.080254815999922],
              [11.78451582100007, -16.064060153999947],
              [11.806976759000065, -16.01881275799991],
              [11.784356030000083, -15.972633182999914],
              [11.736618369000041, -15.900203222999949],
              [11.735524936000047, -15.85711028399993],
              [11.751800977000073, -15.799086195999905],
              [11.763519727000073, -15.78997161299992],
              [11.784678582000083, -15.777276299999926],
              [11.804942254000082, -15.76921965899993],
              [11.81381269600007, -15.774997653999947],
              [11.818369988000086, -15.792413018999923],
              [11.82984459700009, -15.79778411299992],
              [11.844248894000089, -15.793552341999941],
              [11.894704623000052, -15.746677341999941],
              [11.903330925000091, -15.73137786299992],
              [11.906504754000082, -15.717950127999927],
              [11.907481316000087, -15.690036716999941],
              [11.910166863000086, -15.676202080999929],
              [11.930511915000068, -15.65243905999995],
              [11.992035352000073, -15.61728280999995],
              [12.005137566000087, -15.594333591999941],
              [12.008474155000044, -15.56536223799992],
              [12.028493686000047, -15.490166924999926],
              [12.04037519600007, -15.463311455999929],
              [12.030039910000085, -15.436944268999923],
              [12.033457879000082, -15.407403252999927],
              [12.04664147200009, -15.350681247999944],
              [12.05640709700009, -15.233086846999925],
              [12.061778191000087, -15.217868747999944],
              [12.070567254000082, -15.204685153999947],
              [12.104991082000083, -15.17278411299992],
              [12.112478061000047, -15.170993747999944],
              [12.127777540000068, -15.17896900799991],
              [12.135996941000087, -15.17896900799991],
              [12.145274285000085, -15.168633721999925],
              [12.14975019600007, -15.151950778999947],
              [12.148936394000089, -15.134209893999923],
              [12.142832879000082, -15.120700778999947],
              [12.127940300000091, -15.11337655999995],
              [12.117360873000052, -15.116631768999923],
              [12.112478061000047, -15.115166924999926],
              [12.11500084700009, -15.093926690999922],
              [12.124847852000073, -15.06218840899993],
              [12.151133660000085, -15.00204843499995],
              [12.156504754000082, -14.967054945999905],
              [12.160492384000065, -14.953545830999929],
              [12.170095248000052, -14.942478122999944],
              [12.18140709700009, -14.932305596999925],
              [12.190603061000047, -14.922051690999922],
              [12.196136915000068, -14.908461195999905],
              [12.205332879000082, -14.85361093499995],
              [12.205414259000065, -14.840427341999941],
              [12.207774285000085, -14.83326588299991],
              [12.215179884000065, -14.824151299999926],
              [12.221934441000087, -14.82398853999996],
              [12.228526238000086, -14.82586028399993],
              [12.235606316000087, -14.823011976999908],
              [12.244313998000052, -14.809991143999923],
              [12.252777540000068, -14.782321872999944],
              [12.272715691000087, -14.750583591999941],
              [12.272308790000068, -14.732842705999929],
              [12.268077019000089, -14.714776299999926],
              [12.266368035000085, -14.696058851999908],
              [12.268728061000047, -14.683526299999926],
              [12.276621941000087, -14.660739841999941],
              [12.29273522200009, -14.587497653999947],
              [12.299001498000052, -14.50758228999996],
              [12.303884311000047, -14.494073174999926],
              [12.31967207100007, -14.468682549999926],
              [12.331309441000087, -14.433526299999926],
              [12.342133009000065, -14.367120049999926],
              [12.34538821700005, -14.302992445999905],
              [12.342133009000065, -14.27044036299992],
              [12.331553582000083, -14.236748955999929],
              [12.324229363000086, -14.220635674999926],
              [12.322113477000073, -14.213067315999922],
              [12.321055535000085, -14.202732028999947],
              [12.31967207100007, -14.197442315999922],
              [12.315196160000085, -14.187920830999929],
              [12.31421959700009, -14.182224216999941],
              [12.315603061000047, -14.174981377999927],
              [12.319021030000044, -14.175388278999947],
              [12.32357832100007, -14.17750416499996],
              [12.332204623000052, -14.173435153999947],
              [12.344248894000089, -14.171319268999923],
              [12.348887566000087, -14.168552341999941],
              [12.353037957000083, -14.160902601999908],
              [12.35523522200009, -14.151788018999923],
              [12.355804884000065, -14.14234791499996],
              [12.35515384200005, -14.13372161299992],
              [12.347178582000083, -14.119886976999908],
              [12.334971550000091, -14.10637786299992],
              [12.328786655000044, -14.092217705999929],
              [12.344737175000091, -14.066827080999929],
              [12.349782748000052, -14.045505466999941],
              [12.369883660000085, -14.021905205999929],
              [12.374522332000083, -14.00758228999996],
              [12.377289259000065, -13.992445570999905],
              [12.383067254000082, -13.977308851999908],
              [12.399912957000083, -13.951592705999929],
              [12.402842644000089, -13.941338799999926],
              [12.404144727000073, -13.90634530999995],
              [12.407237175000091, -13.890557549999926],
              [12.415537957000083, -13.87859465899993],
              [12.439300977000073, -13.871270440999922],
              [12.44507897200009, -13.86614348799992],
              [12.45053144600007, -13.862481377999927],
              [12.458181186000047, -13.863864841999941],
              [12.471853061000047, -13.874444268999923],
              [12.478363477000073, -13.878024997999944],
              [12.48568769600007, -13.877129815999922],
              [12.502452019000089, -13.85523853999996],
              [12.508962436000047, -13.81959400799991],
              [12.516286655000044, -13.715101820999905],
              [12.512705925000091, -13.616794528999947],
              [12.515879754000082, -13.604913018999923],
              [12.530121290000068, -13.578708591999941],
              [12.533864780000044, -13.565199476999908],
              [12.523610873000052, -13.551202080999929],
              [12.522146030000044, -13.54420338299991],
              [12.523936394000089, -13.53997161299992],
              [12.526540561000047, -13.536228122999944],
              [12.52702884200005, -13.504489841999941],
              [12.524587436000047, -13.489353122999944],
              [12.514903191000087, -13.457614841999941],
              [12.512705925000091, -13.442071221999925],
              [12.51531009200005, -13.425957940999922],
              [12.522146030000044, -13.410577080999929],
              [12.53296959700009, -13.399021091999941],
              [12.547211134000065, -13.39462655999995],
              [12.56804446700005, -13.39234791499996],
              [12.575450066000087, -13.385918877999927],
              [12.580821160000085, -13.375258070999905],
              [12.594737175000091, -13.360446872999944],
              [12.61109459700009, -13.351983330999929],
              [12.624196811000047, -13.349216403999947],
              [12.63445071700005, -13.343357028999947],
              [12.642425977000073, -13.325616143999923],
              [12.643239780000044, -13.316338799999926],
              [12.640879754000082, -13.308851820999905],
              [12.637868686000047, -13.30201588299991],
              [12.636241082000083, -13.29461028399993],
              [12.63843834700009, -13.28801848799992],
              [12.647715691000087, -13.278090101999908],
              [12.65007571700005, -13.271091403999947],
              [12.656504754000082, -13.25562916499996],
              [12.685069207000083, -13.240817966999941],
              [12.691579623000052, -13.22942473799992],
              [12.694102410000085, -13.218357028999947],
              [12.699961785000085, -13.217868747999944],
              [12.70679772200009, -13.221449476999908],
              [12.712087436000047, -13.222588799999926],
              [12.730642123000052, -13.210544528999947],
              [12.73178144600007, -13.208916924999926],
              [12.74976647200009, -13.201348565999922],
              [12.76148522200009, -13.192966403999947],
              [12.827159050000091, -13.109795830999929],
              [12.855723504000082, -13.08953215899993],
              [12.865977410000085, -13.078708591999941],
              [12.883148634000065, -13.05201588299991],
              [12.944834832000083, -12.982354424999926],
              [12.95866946700005, -12.955498955999929],
              [12.958832227000073, -12.929131768999923],
              [12.949473504000082, -12.90211353999996],
              [12.934825066000087, -12.873793226999908],
              [12.92750084700009, -12.842054945999905],
              [12.939463738000086, -12.816664320999905],
              [12.98568769600007, -12.770114841999941],
              [13.009613477000073, -12.756524346999925],
              [13.075043165000068, -12.69500090899993],
              [13.101084832000083, -12.68141041499996],
              [13.109222852000073, -12.674493096999925],
              [13.126475457000083, -12.644463799999926],
              [13.132823113000086, -12.636651299999926],
              [13.161631707000083, -12.611260674999926],
              [13.178558790000068, -12.601739190999922],
              [13.198008660000085, -12.59937916499996],
              [13.19890384200005, -12.60361093499995],
              [13.221039259000065, -12.60719166499996],
              [13.232758009000065, -12.61305103999996],
              [13.264414910000085, -12.582614841999941],
              [13.276866082000083, -12.578301690999922],
              [13.29428144600007, -12.581149997999944],
              [13.311534050000091, -12.594496351999908],
              [13.328379754000082, -12.59937916499996],
              [13.364024285000085, -12.59270598799992],
              [13.392914259000065, -12.57040780999995],
              [13.437673373000052, -12.523695570999905],
              [13.459727410000085, -12.507256768999923],
              [13.469248894000089, -12.494805596999925],
              [13.472992384000065, -12.479099216999941],
              [13.474945509000065, -12.437758070999905],
              [13.479014519000089, -12.419122002999927],
              [13.486582879000082, -12.400811455999929],
              [13.50562584700009, -12.371351820999905],
              [13.568614129000082, -12.31145598799992],
              [13.575450066000087, -12.31145598799992],
              [13.575450066000087, -12.318291924999926],
              [13.564952019000089, -12.32203541499996],
              [13.55827884200005, -12.328301690999922],
              [13.556813998000052, -12.336602471999925],
              [13.561778191000087, -12.346123955999929],
              [13.57748457100007, -12.33098723799992],
              [13.597504102000073, -12.298760674999926],
              [13.63021894600007, -12.26344166499996],
              [13.639821811000047, -12.248711846999925],
              [13.663584832000083, -12.16961028399993],
              [13.693369988000086, -12.11028411299992],
              [13.705088738000086, -12.078057549999926],
              [13.715179884000065, -12.008396091999941],
              [13.722504102000073, -11.992771091999941],
              [13.736989780000044, -11.977715752999927],
              [13.748789910000085, -11.961195570999905],
              [13.758555535000085, -11.942478122999944],
              [13.766449415000068, -11.920505466999941],
              [13.782481316000087, -11.820896091999941],
              [13.792246941000087, -11.790948174999926],
              [13.79460696700005, -11.770196221999925],
              [13.777679884000065, -11.58912525799991],
              [13.781911655000044, -11.481052341999941],
              [13.785980665000068, -11.45826588299991],
              [13.79460696700005, -11.440606377999927],
              [13.786631707000083, -11.431573174999926],
              [13.787364129000082, -11.420342705999929],
              [13.791840040000068, -11.40797291499996],
              [13.79460696700005, -11.395928643999923],
              [13.794200066000087, -11.34148528399993],
              [13.795258009000065, -11.332207940999922],
              [13.80014082100007, -11.321384372999944],
              [13.819021030000044, -11.295586846999925],
              [13.82162519600007, -11.283623955999929],
              [13.821787957000083, -11.256280205999929],
              [13.846527540000068, -11.113702080999929],
              [13.84742272200009, -11.055433851999908],
              [13.848480665000068, -10.98211028399993],
              [13.84343509200005, -10.945733330999929],
              [13.828623894000089, -10.913669528999947],
              [13.739268425000091, -10.783379815999922],
              [13.731455925000091, -10.764255466999941],
              [13.731130405000044, -10.747165622999944],
              [13.739431186000047, -10.73023853999996],
              [13.769786004000082, -10.69426848799992],
              [13.771739129000082, -10.677911065999922],
              [13.76498457100007, -10.662041924999926],
              [13.752940300000091, -10.64617278399993],
              [13.711436394000089, -10.612074476999908],
              [13.705088738000086, -10.601983330999929],
              [13.70085696700005, -10.590915622999944],
              [13.606130405000044, -10.47820403399993],
              [13.54232832100007, -10.42669036299992],
              [13.527598504000082, -10.406508070999905],
              [13.522634311000047, -10.387790622999944],
              [13.520762566000087, -10.320245049999926],
              [13.51734459700009, -10.298435153999947],
              [13.508962436000047, -10.27703215899993],
              [13.455088738000086, -10.201755466999941],
              [13.442637566000087, -10.17937590899993],
              [13.431162957000083, -10.13054778399993],
              [13.415293816000087, -10.110039971999925],
              [13.37671959700009, -10.070733330999929],
              [13.317393425000091, -9.97633228999996],
              [13.319834832000083, -9.961602471999925],
              [13.329112175000091, -9.947523695999905],
              [13.335215691000087, -9.92669036299992],
              [13.327159050000091, -9.88600025799991],
              [13.305430535000085, -9.842461846999925],
              [13.278005405000044, -9.80169036299992],
              [13.19857832100007, -9.70867278399993],
              [13.19117272200009, -9.690036716999941],
              [13.196136915000068, -9.67278411299992],
              [13.218597852000073, -9.649183851999908],
              [13.225352410000085, -9.631280205999929],
              [13.223887566000087, -9.61419036299992],
              [13.217784050000091, -9.594170830999929],
              [13.209646030000044, -9.57740650799991],
              [13.201426629000082, -9.570489190999922],
              [13.202403191000087, -9.559014580999929],
              [13.169932488000086, -9.466403903999947],
              [13.168304884000065, -9.44736093499995],
              [13.170664910000085, -9.402520440999922],
              [13.166514519000089, -9.387139580999929],
              [13.147715691000087, -9.352146091999941],
              [13.143402540000068, -9.330254815999922],
              [13.120616082000083, -9.313083591999941],
              [13.045420769000089, -9.189060153999947],
              [13.016856316000087, -9.12281666499996],
              [12.996348504000082, -9.09384530999995],
              [12.992360873000052, -9.03801848799992],
              [13.030284050000091, -8.959567966999941],
              [13.086436394000089, -8.89234791499996],
              [13.136566602000073, -8.871026299999926],
              [13.114756707000083, -8.902927341999941],
              [13.042816602000073, -8.962497653999947],
              [13.006846550000091, -9.045586846999925],
              [13.000173373000052, -9.07203541499996],
              [13.01303144600007, -9.08375416499996],
              [13.023448113000086, -9.074965101999908],
              [13.079600457000083, -8.980645440999922],
              [13.081879102000073, -8.97047291499996],
              [13.086924675000091, -8.959730726999908],
              [13.098887566000087, -8.956475518999923],
              [13.112478061000047, -8.956149997999944],
              [13.122894727000073, -8.954196872999944],
              [13.137461785000085, -8.940850518999923],
              [13.148285352000073, -8.90797291499996],
              [13.160411004000082, -8.88795338299991],
              [13.185557488000086, -8.861586195999905],
              [13.19117272200009, -8.85051848799992],
              [13.192149285000085, -8.83953215899993],
              [13.190603061000047, -8.81609465899993],
              [13.194590691000087, -8.806084893999923],
              [13.224131707000083, -8.773858330999929],
              [13.24154707100007, -8.76067473799992],
              [13.25953209700009, -8.75481536299992],
              [13.209727410000085, -8.804294528999947],
              [13.198008660000085, -8.82317473799992],
              [13.212168816000087, -8.814873955999929],
              [13.245371941000087, -8.80006275799991],
              [13.263682488000086, -8.788262627999927],
              [13.271657748000052, -8.786553643999923],
              [13.278005405000044, -8.78248463299991],
              [13.280528191000087, -8.771661065999922],
              [13.28101647200009, -8.764743747999944],
              [13.28296959700009, -8.75945403399993],
              [13.287119988000086, -8.756036065999922],
              [13.294200066000087, -8.75481536299992],
              [13.356130405000044, -8.763604424999926],
              [13.380137566000087, -8.755059502999927],
              [13.393321160000085, -8.704278252999927],
              [13.408050977000073, -8.66692473799992],
              [13.410899285000085, -8.651950778999947],
              [13.406097852000073, -8.637139580999929],
              [13.37671959700009, -8.59661223799992],
              [13.365407748000052, -8.566827080999929],
              [13.352061394000089, -8.49968840899993],
              [13.342051629000082, -8.467461846999925],
              [13.355479363000086, -8.46461353999996],
              [13.36500084700009, -8.465915622999944],
              [13.372569207000083, -8.464450778999947],
              [13.379893425000091, -8.453789971999925],
              [13.38257897200009, -8.444024346999925],
              [13.383555535000085, -8.368747653999947],
              [13.378916863000086, -8.347100518999923],
              [13.369395379000082, -8.32350025799991],
              [13.276866082000083, -8.178887627999927],
              [13.264903191000087, -8.16969166499996],
              [13.250824415000068, -8.124444268999923],
              [13.242442254000082, -8.10719166499996],
              [13.234548373000052, -8.095961195999905],
              [13.222504102000073, -8.06959400799991],
              [13.215505405000044, -8.059177341999941],
              [13.198008660000085, -8.02157968499995],
              [13.189300977000073, -7.975762627999927],
              [13.122894727000073, -7.857354424999926],
              [12.986308166000072, -7.55066086699992],
              [12.939282648000074, -7.435969127999954],
              [12.911472618000062, -7.335110615999952],
              [12.883894998000073, -7.305754470999943],
              [12.869054690000041, -7.288986325999929],
              [12.849963117000073, -7.265918980999913],
              [12.85519191700007, -7.231279022999956],
              [12.849857033000092, -7.205052670999919],
              [12.833262566000087, -7.005791924999926],
              [12.823415561000047, -6.975192966999941],
              [12.821299675000091, -6.959161065999922],
              [12.81967207100007, -6.954034112999921],
              [12.816661004000082, -6.950372002999927],
              [12.815196160000085, -6.94695403399993],
              [12.817881707000083, -6.942152601999908],
              [12.824554884000065, -6.934258721999925],
              [12.82748457100007, -6.929131768999923],
              [12.829925977000073, -6.918877862999921],
              [12.832774285000085, -6.915785414999959],
              [12.833506707000083, -6.912286065999922],
              [12.828786655000044, -6.904554945999905],
              [12.799571160000085, -6.923272393999923],
              [12.779633009000065, -6.914727471999925],
              [12.706879102000073, -6.814222914999959],
              [12.62042535900008, -6.734822774999941],
              [12.550631775000056, -6.632638645999918],
              [12.458181186000047, -6.465752862999921],
              [12.421954225000093, -6.380987645999937],
              [12.395575572000041, -6.324452741999949],
              [12.36882571700005, -6.287692966999941],
              [12.344543400000077, -6.254146508999952],
              [12.319149310000057, -6.220139812999946],
              [12.27944673400009, -6.147704837999925],
              [12.275060383000039, -6.114769137999929],
              [12.290293816000087, -6.096612237999921],
              [12.312654793000092, -6.090545471999917],
              [12.333647693000046, -6.078436268999951],
              [12.32701159800007, -6.093810969999936],
              [12.324780829000076, -6.122353132999933],
              [12.346872992000044, -6.120113032999939],
              [12.38220672500006, -6.110167640999919],
              [12.43295871500004, -6.108983566999939],
              [12.496927621000054, -6.094594274999906],
              [12.527768302000084, -6.074826207999934],
              [12.549799001000054, -6.067123489999915],
              [12.580642199000067, -6.062695452999947],
              [12.632823113000086, -6.034356377999927],
              [12.645518425000091, -6.02898528399993],
              [12.669816611000044, -6.029709683999954],
              [12.69075162300004, -6.037358136999956],
              [12.716095005000057, -6.045002077999925],
              [12.742537742000081, -6.049356248999914],
              [12.771169528000087, -6.04165865899995],
              [12.817430848000072, -6.031749810999941],
              [12.861468549000051, -6.01634694899991],
              [12.88238597500009, -6.000986464999926],
              [12.92756902800005, -5.981218325999919],
              [12.946270106000043, -5.955990676999932],
              [12.966073962000053, -5.931853386999933],
              [12.972659519000047, -5.913214391999929],
              [12.985879637000039, -5.901139782999905],
              [13.011138846000051, -5.895605731999922],
              [13.029867360000082, -5.893380573999934],
              [13.046372105000046, -5.885679232999905],
              [13.064015031000054, -5.887838356999907],
              [13.100596550000091, -5.891208591999941],
              [13.111827019000089, -5.890232028999947],
              [13.129161004000082, -5.883558851999908],
              [13.16968834700009, -5.861748955999929],
              [13.183848504000082, -5.856459242999961],
              [13.184910523000099, -5.856385598999935],
              [13.269349813000133, -5.86351694699988],
              [13.311001017000137, -5.873955586999912],
              [13.3425236410001, -5.890595397999931],
              [13.353582398000128, -5.882637226999876],
              [13.373839559000118, -5.860933124999875],
              [13.380454142000104, -5.856385598999935],
              [13.413320353000046, -5.857005716999907],
              [13.493212118000145, -5.858452656999901],
              [13.522667684000055, -5.867547708999965],
              [13.53475996900005, -5.867030943999936],
              [13.553053426000105, -5.859382832999955],
              [13.562561890000097, -5.857419127999918],
              [13.641523479000057, -5.865790709999899],
              [13.80714644300005, -5.852458190999883],
              [13.94357222500011, -5.841606139999925],
              [13.98232954900007, -5.853285013999894],
              [14.006307414000077, -5.866927591999911],
              [14.021190226000101, -5.872508646999918],
              [14.140149374000117, -5.86351694699988],
              [14.163093710000084, -5.866100768999971],
              [14.222211548000132, -5.886978047999946],
              [14.241848592000082, -5.889561868999948],
              [14.346131632000095, -5.891525573999985],
              [14.43666874100009, -5.893385925],
              [14.48214400200007, -5.885531107999952],
              [14.545706014000132, -5.901654153999942],
              [14.57660852100011, -5.904651387999948],
              [14.703732544000076, -5.881396992999939],
              [14.759651665000149, -5.880469130999899],
              [14.79716353300006, -5.879846699999916],
              [14.888424113000042, -5.878296406999894],
              [14.97958134000001, -5.876746113999971],
              [15.070841919000117, -5.875299173999878],
              [15.16210249800011, -5.873748880999955],
              [15.253363078000092, -5.872198587999932],
              [15.34452030400007, -5.87075164699985],
              [15.435780884000081, -5.869201354999916],
              [15.527041463000074, -5.867754414999922],
              [15.618302042000067, -5.866204121999914],
              [15.70956262200005, -5.864757180999916],
              [15.800719849000131, -5.863206888999898],
              [15.892083780000064, -5.861656595999875],
              [15.983241007000117, -5.860106302999952],
              [16.0745015870001, -5.85855600999993],
              [16.100855892000112, -5.858107807999971],
              [16.16565881300008, -5.857005716999907],
              [16.257022746000104, -5.855558776999914],
              [16.31572717300014, -5.854628600999959],
              [16.34125533000008, -5.859796243999966],
              [16.358515258000068, -5.870234883999899],
              [16.37432824700008, -5.882843932999933],
              [16.396135701000105, -5.894109394999887],
              [16.41246545400014, -5.896796569999921],
              [16.427451619000095, -5.894626158999927],
              [16.45949100700011, -5.885221048999966],
              [16.479334757000117, -5.882223815999865],
              [16.49731815600009, -5.882843932999933],
              [16.515094848000018, -5.887081399999971],
              [16.552921997000112, -5.902377624999929],
              [16.560260051000085, -5.906408385999924],
              [16.59736372800009, -5.924701842999909],
              [16.59405643700009, -5.933176777999904],
              [16.580620564000128, -5.948989765999897],
              [16.580723918000047, -5.955397643999945],
              [16.590335734000064, -5.968006692999964],
              [16.595296672000103, -5.978548685999925],
              [16.597157023000108, -5.98785044399996],
              [16.601187785000036, -6.050585632999912],
              [16.604288371000052, -6.061851094999966],
              [16.610076131000113, -6.061230976999894],
              [16.61948124200009, -6.05658009899993],
              [16.628369588000112, -6.055339864],
              [16.63219364400004, -6.065261738999894],
              [16.611109660000096, -6.089756367999939],
              [16.630953410000103, -6.091720072999891],
              [16.643045695000097, -6.100711770999922],
              [16.660098917000113, -6.123966165999946],
              [16.671777791000096, -6.130167337999922],
              [16.685110311000102, -6.134301452999949],
              [16.69585900900003, -6.140916034999947],
              [16.70040653500007, -6.154351908999899],
              [16.717873169000114, -6.174092304999959],
              [16.726761516000124, -6.189181822999956],
              [16.724384400000076, -6.202410989999862],
              [16.717253052000046, -6.215123392999914],
              [16.71477258300007, -6.231556497999875],
              [16.715392700000052, -6.304833678999984],
              [16.716942994000078, -6.313308613999894],
              [16.72014693200012, -6.322610371999914],
              [16.722317342000025, -6.332428893999889],
              [16.720973755000074, -6.342350767999974],
              [16.715289347000123, -6.345968118999863],
              [16.706090943000106, -6.34669158899996],
              [16.69740930100005, -6.349792174999905],
              [16.69358524600011, -6.359817402999923],
              [16.692965129000044, -6.3983680219999],
              [16.69472212700012, -6.402192076999938],
              [16.70040653500007, -6.411287129999906],
              [16.707021118000085, -6.41542124399993],
              [16.71363570200006, -6.413974303999936],
              [16.718906697000108, -6.415317890999901],
              [16.720973755000074, -6.42834035199985],
              [16.71518599400008, -6.441362813999973],
              [16.706090943000106, -6.455212096999944],
              [16.706090943000106, -6.465030618999918],
              [16.727795044000118, -6.465960794999958],
              [16.721283813000042, -6.480533548999929],
              [16.721697224000053, -6.491799010999983],
              [16.72800175000006, -6.501100768999919],
              [16.738337036000075, -6.510609231999894],
              [16.747328736000043, -6.521978046999976],
              [16.746811971000085, -6.531589863999898],
              [16.734512980000147, -6.552363789999944],
              [16.73079227700012, -6.569830423999889],
              [16.733996216000094, -6.586056823999897],
              [16.74867232300008, -6.619543150999988],
              [16.75301314200007, -6.637216491999894],
              [16.75590702300005, -6.67411346499992],
              [16.760351197000148, -6.691993508999886],
              [16.768102661000057, -6.708323261999922],
              [16.823086385000096, -6.785114440999891],
              [16.826910441000052, -6.799790547999876],
              [16.828564087000103, -6.814363301999933],
              [16.832904907000085, -6.827799173999978],
              [16.84448042800011, -6.838444518999964],
              [16.855332479000083, -6.842165221999977],
              [16.879413696000114, -6.844645690999954],
              [16.8907825120001, -6.847126158999927],
              [16.91496708200006, -6.864076028999932],
              [16.92695601400004, -6.888570657999892],
              [16.93450077300008, -6.945724791999922],
              [16.93212365700012, -6.94985890699985],
              [16.92860966000009, -6.959264017999899],
              [16.928713012000117, -6.968669127999945],
              [16.93760135900004, -6.97300994899993],
              [16.949073527000053, -6.975387063999975],
              [16.955274699000114, -6.98148488399994],
              [16.959305461000014, -6.989443053999906],
              [16.964576457000135, -6.997194518999905],
              [16.973154744000084, -7.014764505999977],
              [16.96933068900006, -7.030370787999914],
              [16.96230269400013, -7.047424010999947],
              [16.96116581200002, -7.069231464999888],
              [16.929126424000117, -7.060653177999939],
              [16.92705936700014, -7.085664570999938],
              [16.9475232340001, -7.15108693399992],
              [16.945662882000107, -7.204623718999869],
              [16.9508305250001, -7.213202005999989],
              [16.960545695000064, -7.219093119999897],
              [16.972844686000087, -7.232218932999956],
              [16.98907108500009, -7.254853209999908],
              [16.99165490700011, -7.270562844999887],
              [16.99165490700011, -7.286065774999898],
              [16.996099080000107, -7.297951354999924],
              [17.022867472000087, -7.306012878999908],
              [17.056663859000082, -7.329887389999897],
              [17.082502075000093, -7.342289733999877],
              [17.093354126000037, -7.352314961999895],
              [17.097798299000146, -7.367404479999891],
              [17.097894948000146, -7.378293566999986],
              [17.098108358000047, -7.402337747999894],
              [17.103999471000122, -7.416083678999925],
              [17.118158813000093, -7.425488789999875],
              [17.126220337000063, -7.411432799999957],
              [17.132214803000096, -7.409572448999953],
              [17.13820926900013, -7.413706562999963],
              [17.146167439000095, -7.418047383999948],
              [17.167458130000085, -7.423525084999937],
              [17.176553182000134, -7.428175963999905],
              [17.180273885000048, -7.435410664999964],
              [17.174899536000083, -7.441611836999954],
              [17.163117310000104, -7.445539244999921],
              [17.151541789000134, -7.451223652999957],
              [17.146167439000095, -7.463109232999898],
              [17.14854455500003, -7.472617695999887],
              [17.15495243300009, -7.479128925999944],
              [17.16342736800007, -7.485226744999906],
              [17.172832479000135, -7.49380503299993],
              [17.18626835100008, -7.516335957999956],
              [17.202908163000103, -7.564291686999894],
              [17.217790975000042, -7.585995788999895],
              [17.266573527000105, -7.610387063999909],
              [17.286417277000083, -7.625166523999923],
              [17.282696574000084, -7.643976745999936],
              [17.287450806000066, -7.660203144999855],
              [17.28652063000004, -7.683664245999921],
              [17.28889774600006, -7.699477233999914],
              [17.303780558000113, -7.692449238999913],
              [17.305950968000104, -7.700097350999982],
              [17.308121379000085, -7.701854349999877],
              [17.308121379000085, -7.702371113999902],
              [17.303780558000113, -7.706711933999884],
              [17.320420369000118, -7.713636575999956],
              [17.32062707500009, -7.722421569999952],
              [17.314219198000046, -7.731826680999916],
              [17.310601847000072, -7.740818378999947],
              [17.315976196000122, -7.753634134999928],
              [17.334062947000035, -7.769653828999893],
              [17.337887003000077, -7.778645527999927],
              [17.342434529000116, -7.784019876999892],
              [17.365482218000068, -7.787327168999894],
              [17.37540409400009, -7.79228810599993],
              [17.376954386000108, -7.801693216999894],
              [17.376127563000068, -7.814095560999959],
              [17.380985148000093, -7.823190612999937],
              [17.400002075000145, -7.823397318999895],
              [17.400002075000145, -7.830218606999935],
              [17.39070031700004, -7.839210306999888],
              [17.397624959000012, -7.841380716999879],
              [17.410854126000118, -7.841484069999908],
              [17.420569295000064, -7.843861185999856],
              [17.423566529000055, -7.85512664799991],
              [17.42304976400004, -7.867942402999901],
              [17.426357056000114, -7.875487161999942],
              [17.440929810000085, -7.871146341999875],
              [17.452401977000108, -7.883962096999937],
              [17.44868127400008, -7.892850442999958],
              [17.43937951700005, -7.902152200999893],
              [17.434108520000024, -7.915794778999896],
              [17.43782922300005, -7.9224093629999],
              [17.446820923000075, -7.928920592999958],
              [17.46831831900002, -7.93946258499993],
              [17.463564087000123, -7.946903990999942],
              [17.46304732200008, -7.949797871999934],
              [17.465217733000088, -7.952588398999893],
              [17.46831831900002, -7.959926452999895],
              [17.471108846000078, -7.955585631999909],
              [17.47720666500004, -7.950521341999931],
              [17.481857544000093, -7.945663756999906],
              [17.490952596000085, -7.977496439999953],
              [17.496223592000092, -7.9872116089999],
              [17.506352173000067, -7.996513365999931],
              [17.528366333000122, -8.007778828999975],
              [17.536531209000145, -8.015116881999887],
              [17.540045207000105, -8.032066751999892],
              [17.528366333000122, -8.060592141999933],
              [17.536218704000134, -8.07540231099992],
              [17.536531209000145, -8.075991718999916],
              [17.544282674000073, -8.084776712999911],
              [17.60019657400005, -8.098522643999942],
              [17.62841190500012, -8.0980058789999],
              [17.713264608000088, -8.06834360799985],
              [17.74334029200014, -8.070720722999894],
              [17.777240031000048, -8.083329772999917],
              [17.7895390220001, -8.081779479999895],
              [17.851757447000097, -8.047776387999946],
              [17.8679838460001, -8.044469095999958],
              [17.901366821000096, -8.048086445999942],
              [17.93082238700009, -8.06214243599996],
              [17.981878703000064, -8.1053439329999],
              [18.008543742000114, -8.111235045999905],
              [18.098150675000056, -8.109271341999957],
              [18.091742798000098, -8.084156595999943],
              [18.092879680000124, -8.056354674999895],
              [18.10218143700004, -8.033306986999918],
              [18.120371541000083, -8.022454935999875],
              [18.135771118000065, -8.018527526999904],
              [18.176595500000076, -7.999200540999951],
              [18.192718546000037, -7.996926777999931],
              [18.26733931400011, -7.999820657999919],
              [18.316225220000092, -8.001681009999928],
              [18.353638957000072, -8.015943704999913],
              [18.366558065000078, -8.016770527999924],
              [18.38195764100007, -8.012326353999924],
              [18.4038684490001, -8.000647480999945],
              [18.420508260000133, -7.998270364999911],
              [18.481796509000077, -7.997340188999942],
              [18.48789432800004, -7.998270364999911],
              [18.507634725000116, -7.997546894999914],
              [18.502260376000066, -7.960133157999849],
              [18.5043274330001, -7.940702819999956],
              [18.516523071000023, -7.932227884999861],
              [18.588663371000024, -7.932331237999975],
              [18.666901490000072, -7.932331237999975],
              [18.73852502400004, -7.932331237999975],
              [18.74731001800012, -7.937808939999883],
              [18.752064249000114, -7.965920918999913],
              [18.758265421000118, -7.978219908999947],
              [18.773768351000115, -8.001991068999914],
              [18.81800337700014, -8.001991068999914],
              [18.94543746000008, -8.001991068999914],
              [19.07307824700004, -8.001991068999914],
              [19.20061568200009, -8.001991068999914],
              [19.32825647000007, -8.001991068999914],
              [19.355541626000104, -8.001991068999914],
              [19.334044230000046, -7.924269713999905],
              [19.330943644000115, -7.898638203999937],
              [19.333837525000092, -7.867322285999919],
              [19.34851363100009, -7.821536966999886],
              [19.35802209500008, -7.791564635999933],
              [19.377762492000045, -7.730069680999932],
              [19.381379842000115, -7.703921406999925],
              [19.380966431000104, -7.67973683699995],
              [19.373214965000102, -7.653795267999911],
              [19.361846151000094, -7.627026875999931],
              [19.35368127400008, -7.600258483999951],
              [19.355644979000118, -7.574110208999869],
              [19.424684692000085, -7.579691263999877],
              [19.44390832500011, -7.575247090999966],
              [19.45827437300011, -7.560260925999984],
              [19.468713013000126, -7.521090188999949],
              [19.482355591000044, -7.503520201999976],
              [19.48307906100004, -7.502900084999908],
              [19.48390588400008, -7.502383320999868],
              [19.48473270700009, -7.501969908999868],
              [19.513154744000104, -7.479438984999931],
              [19.513774862000076, -7.448433125999912],
              [19.48721317500008, -7.381977233999947],
              [19.479461711000056, -7.347664082999927],
              [19.47636112500004, -7.315934752999908],
              [19.48721317500008, -7.153877461999883],
              [19.497031697000125, -7.121734720999939],
              [19.508607219000083, -7.103234557999912],
              [19.536202434000074, -7.068404642999951],
              [19.542610311000118, -7.052281595999972],
              [19.54023319500007, -7.041636249999968],
              [19.521836385000086, -7.001948750999901],
              [19.574029582000065, -7.001948750999901],
              [19.6160941980001, -7.001948750999901],
              [19.65805546100009, -7.001948750999901],
              [19.70001672300009, -7.001948750999901],
              [19.74197798600008, -7.001948750999901],
              [19.784042602000113, -7.001948750999901],
              [19.82610721800006, -7.001948750999901],
              [19.86806848200004, -7.001948750999901],
              [19.910029745000145, -7.001948750999901],
              [19.952094360000075, -7.001948750999901],
              [19.963079168000093, -7.001948750999901],
              [19.994055623000094, -7.001948750999901],
              [20.0361202390001, -7.001948750999901],
              [20.07818485500013, -7.001948750999901],
              [20.120146118000036, -7.001948750999901],
              [20.162107381000055, -7.001948750999901],
              [20.20406864400013, -7.001948750999901],
              [20.246236613000093, -7.001948750999901],
              [20.294295695000073, -7.001948750999901],
              [20.294192342000116, -6.987479349999958],
              [20.298636515000055, -6.954509785999903],
              [20.303184042000083, -6.9401437369999],
              [20.311245564000075, -6.925054219999907],
              [20.319513794000102, -6.918542988999931],
              [20.33108931500007, -6.916785989999951],
              [20.383695922000044, -6.916682637999926],
              [20.467308390000056, -6.91637257899994],
              [20.553711385000042, -6.916165872999983],
              [20.611485636000054, -6.915959166999926],
              [20.588127889000106, -6.976834004999972],
              [20.560946085000097, -7.047837422999876],
              [20.54544315600009, -7.088558450999926],
              [20.524462524000086, -7.143128763999954],
              [20.51826135200011, -7.189740904999923],
              [20.519398234000107, -7.23717987099991],
              [20.520535116000133, -7.286375833999969],
              [20.56704390400006, -7.286169127999926],
              [20.639804321000042, -7.285962422999958],
              [20.71256473800011, -7.28585906999993],
              [20.785221801000148, -7.285549010999944],
              [20.85798221900012, -7.285342306],
              [20.930742635000087, -7.285238951999872],
              [21.003503051000052, -7.284928893999975],
              [21.07626346900011, -7.284722187999932],
              [21.148920532000147, -7.284618834999904],
              [21.22178430100007, -7.284412129999851],
              [21.294338013000072, -7.284205423999893],
              [21.367098429000038, -7.283998717999935],
              [21.439962198000046, -7.283792011999878],
              [21.51261926300009, -7.283585306999925],
              [21.58548303200007, -7.283378600999868],
              [21.658243448000064, -7.28317189499991],
              [21.73090051300008, -7.282965189999857],
              [21.764490194000103, -7.282758482999895],
              [21.784954060000075, -7.283378600999868],
              [21.784644002000107, -7.286892598999913],
              [21.78826135200009, -7.291750182999934],
              [21.794772583000054, -7.294023945999953],
              [21.802524048000066, -7.298881530999964],
              [21.808828572000067, -7.306426289999919],
              [21.83135949700008, -7.354175313999903],
              [21.8369405520001, -7.360583190999932],
              [21.84241825300009, -7.369884948999868],
              [21.839937785000103, -7.37815317799992],
              [21.834976847000064, -7.385284524999946],
              [21.832909790000116, -7.390762226999939],
              [21.83869755000009, -7.402027688999908],
              [21.84572554500008, -7.40905568399991],
              [21.851616659000086, -7.416497089999936],
              [21.854097127000074, -7.428899434999906],
              [21.852960246000066, -7.434997253999953],
              [21.847792603000045, -7.444092304999927],
              [21.846655721000047, -7.449053242999881],
              [21.848929484000053, -7.454841002999942],
              [21.858644654000102, -7.464039407999863],
              [21.860918416000118, -7.469827168999927],
              [21.859058065000113, -7.482642923999904],
              [21.849963012000046, -7.502900084999908],
              [21.846655721000047, -7.514268899999905],
              [21.845932251000136, -7.5267745969999],
              [21.848206014000056, -7.532975768999975],
              [21.851513306000072, -7.53845346999988],
              [21.854097127000074, -7.548375345999958],
              [21.854097127000074, -7.585995788999895],
              [21.850789835000057, -7.593643899999961],
              [21.836217082000104, -7.608320006999946],
              [21.832909790000116, -7.61421111999995],
              [21.83104943900011, -7.632814635999907],
              [21.826558136000102, -7.645600686999927],
              [21.81957727000008, -7.66547414199988],
              [21.807898397000116, -7.6993738809999],
              [21.795082642000125, -7.736270852999922],
              [21.787227824000098, -7.758595071999892],
              [21.776169067000097, -7.790324400999907],
              [21.770484659000147, -7.806757506999872],
              [21.76459354700006, -7.85068247399991],
              [21.770898071000147, -7.876520690999925],
              [21.7721383060001, -7.888199563999905],
              [21.768831014000085, -7.899878437999874],
              [21.75436161300007, -7.919618835999927],
              [21.751054321000083, -7.929230651999944],
              [21.75394820200006, -7.997340188999942],
              [21.7584957280001, -8.015116881999887],
              [21.76821089700013, -8.023178404999967],
              [21.79963016800008, -8.04085174499997],
              [21.80634810400008, -8.052427266999914],
              [21.80851851400007, -8.076715189999916],
              [21.815133098000075, -8.096765644999962],
              [21.825985148000115, -8.114438984999964],
              [21.851203247000086, -8.143481139999949],
              [21.857301066000048, -8.156917011999909],
              [21.860194946000036, -8.173763528999885],
              [21.86246870900004, -8.216448262999975],
              [21.873217407000055, -8.264093932999927],
              [21.88138228300008, -8.282077330999911],
              [21.910631144000035, -8.310499368999942],
              [21.920553019000124, -8.328999531999955],
              [21.91314632600003, -8.333003149999925],
              [21.90525679500007, -8.337267760999907],
              [21.899882446000106, -8.348843281999862],
              [21.911457967000047, -8.374268086999876],
              [21.935952596000106, -8.413025410999893],
              [21.943910766000073, -8.455916848999948],
              [21.93998335800009, -8.499945169999918],
              [21.916212199000142, -8.576839701999901],
              [21.92127649000011, -8.578596699999892],
              [21.924377075000052, -8.580767109999968],
              [21.928407836000048, -8.582524108999863],
              [21.935952596000106, -8.583144225999916],
              [21.917762492000065, -8.615183613999918],
              [21.906910441000036, -8.645466003999942],
              [21.895128215000113, -8.718743183999962],
              [21.88479292800011, -8.782305195999925],
              [21.877764933000094, -8.789229837999912],
              [21.870116821000124, -8.822302753999907],
              [21.859884888000124, -8.846383971999941],
              [21.85172001100011, -8.92586232499994],
              [21.854097127000074, -8.977848815999963],
              [21.839731079000074, -9.09236378999988],
              [21.851926717000083, -9.192926126999907],
              [21.851616659000086, -9.233750507999986],
              [21.841074666000026, -9.27581512399992],
              [21.810172159000047, -9.33813690199986],
              [21.80376428200009, -9.37296681699992],
              [21.79332564200007, -9.39353403699991],
              [21.79198205500009, -9.406143085999929],
              [21.796219523000048, -9.417098489999916],
              [21.813169393000038, -9.437459003999933],
              [21.819887329000068, -9.447690937999923],
              [21.83218632000012, -9.488411966999891],
              [21.84365848800013, -9.576158548999928],
              [21.854097127000074, -9.617809752999946],
              [21.878901814000102, -9.657083840999917],
              [21.942360474000054, -9.722919616999903],
              [21.956519816000082, -9.761780292999958],
              [21.962720988000086, -9.75847300199996],
              [21.978223918000083, -9.752168476999941],
              [21.984425090000087, -9.748757831999924],
              [21.986285441000092, -9.781107278999912],
              [21.998377726000058, -9.809115905999917],
              [22.055841919000073, -9.87536509099992],
              [22.065763794000077, -9.881049498999872],
              [22.072791789000092, -9.878879088999966],
              [22.07992313600002, -9.871644387999908],
              [22.09098189300005, -9.877122090999904],
              [22.107621704000053, -9.891384785999975],
              [22.14627567500014, -9.915672708999878],
              [22.159918253000058, -9.931485696999871],
              [22.16756636600013, -9.953706562999912],
              [22.175627889000026, -9.988949889999972],
              [22.1960917560001, -10.04362355499994],
              [22.204876750000068, -10.085791523999902],
              [22.209734334000103, -10.098193867999967],
              [22.202809692000102, -10.13064666699998],
              [22.221103149000072, -10.176225280999873],
              [22.24570113200008, -10.221183776999894],
              [22.26347782400009, -10.268209329999962],
              [22.286938924000083, -10.309137063999884],
              [22.295517212000107, -10.33931610099998],
              [22.310089966000078, -10.356989440999882],
              [22.313397258000066, -10.368564960999933],
              [22.31226037600007, -10.37993377699992],
              [22.307092733000047, -10.399570820999955],
              [22.305955852000125, -10.40980275499993],
              [22.301098267000015, -10.424892272999926],
              [22.27867069500013, -10.460962421999938],
              [22.271849406000086, -10.481736347999885],
              [22.274019816000077, -10.503027037999871],
              [22.284045044000095, -10.51646291099992],
              [22.296447388000047, -10.529692076999908],
              [22.305955852000125, -10.550672708999912],
              [22.309469848000106, -10.592944030999902],
              [22.308573272000075, -10.612519276999876],
              [22.3076094970001, -10.633561705999924],
              [22.310089966000078, -10.668805032999913],
              [22.326419719000086, -10.694643248999924],
              [22.321045369000046, -10.70074106799997],
              [22.319495077000113, -10.70384165499992],
              [22.32238895600011, -10.742185566999936],
              [22.319495077000113, -10.761305846999932],
              [22.309676555000067, -10.769780781999941],
              [22.290659627000082, -10.772674662999933],
              [22.265854939000036, -10.779909362999902],
              [22.223997030000078, -10.797065937999946],
              [22.206013631000076, -10.809881692999937],
              [22.182759236000066, -10.83044891399993],
              [22.16549930800008, -10.852359720999885],
              [22.165706014000136, -10.868792825999947],
              [22.1748010660001, -10.884295755999858],
              [22.1960917560001, -10.954162291999936],
              [22.1960917560001, -10.992299499999902],
              [22.199295695000075, -10.997363789999966],
              [22.213971801000042, -11.007905781999938],
              [22.21717574100012, -11.012763366999962],
              [22.220586385000047, -11.03002329499995],
              [22.237329549000094, -11.059375507999931],
              [22.243840780000056, -11.078289082999959],
              [22.255519654000125, -11.16655242899995],
              [22.25200565600008, -11.208617044999883],
              [22.23763960800008, -11.249544778999905],
              [22.26306441200009, -11.248201191999925],
              [22.28177128100006, -11.236729023999914],
              [22.3256962480001, -11.190323587999913],
              [22.34026900200007, -11.180195007999956],
              [22.44031457500006, -11.146915384999915],
              [22.46935673000013, -11.122420755999954],
              [22.500982706000116, -11.042425637999926],
              [22.537569621000074, -11.03715464299998],
              [22.61363732900014, -11.067540384999944],
              [22.65094771300008, -11.082319843999954],
              [22.6889815670001, -11.092965188999955],
              [22.727738891000058, -11.096789244999897],
              [22.76422245300006, -11.090484720999882],
              [22.785306437000088, -11.078495787999927],
              [22.806907186000046, -11.06309621099993],
              [22.829231405000115, -11.052140807999962],
              [22.85310591600009, -11.053070983999916],
              [22.87356978300008, -11.063716328999902],
              [22.911190226000087, -11.088314309999888],
              [22.93113732900011, -11.096789244999897],
              [22.969584595000043, -11.102473652999933],
              [23.014336385, -11.102473652999933],
              [23.114692016000078, -11.085523782999928],
              [23.196754191000082, -11.071881204999926],
              [23.306514933000102, -11.01172983799998],
              [23.373280884000053, -10.97514292399994],
              [23.4154488530001, -10.963257344999917],
              [23.455963175000107, -10.960983581999898],
              [23.49482385300007, -10.9642908739999],
              [23.55704227700008, -10.98134409599993],
              [23.641584920000128, -11.00449513799991],
              [23.67486454300007, -11.006975605999898],
              [23.71413863100014, -11.003875019999938],
              [23.752275838000116, -11.008215840999924],
              [23.79372033700008, -11.02113494899993],
              [23.833717896000053, -11.028473001999927],
              [23.8674109290001, -11.016380716999947],
              [23.874128865000017, -11.006872252999955],
              [23.8817769770001, -10.9845480339999],
              [23.887771443000133, -10.974419453999943],
              [23.897279907000012, -10.966461282999973],
              [23.918570597000098, -10.954058938999907],
              [23.927975708000048, -10.945377298999858],
              [23.93614058400007, -10.925223489999965],
              [23.940584757000067, -10.901555684999948],
              [23.948646281000066, -10.881505228999899],
              [23.96745650200009, -10.872306822999903],
            ],
          ],
          [
            [
              [11.725759311000047, -16.61842213299991],
              [11.726658696000072, -16.656626827999958],
              [11.737519451000082, -16.69257798299992],
              [11.738506688000086, -16.705822075999947],
              [11.715793545000054, -16.685006365999925],
              [11.701973057000089, -16.65567360999995],
              [11.66939414300009, -16.55720957899996],
              [11.671369885000047, -16.529743735999944],
              [11.68124365600005, -16.517436197999928],
              [11.701977019000083, -16.500393411999937],
              [11.71974593200008, -16.506082592999917],
              [11.721527540000068, -16.555433851999908],
              [11.725759311000047, -16.577325127999927],
              [11.725759311000047, -16.61842213299991],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Botswana',
        iso3: 'BWA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.259780721000112, -17.794106546999984],
            [25.219369751000045, -17.879786071999973],
            [25.219369751000045, -17.908001403999947],
            [25.226087687000074, -17.931875914999935],
            [25.255026489000016, -18.00112233499995],
            [25.296367635000138, -18.06861175599998],
            [25.323446086000104, -18.096620381999898],
            [25.357449178000138, -18.11584401399992],
            [25.387524861000117, -18.138995055999914],
            [25.408815552000107, -18.175995381999954],
            [25.440854939000104, -18.253199971999933],
            [25.473204386000106, -18.303429462999887],
            [25.48116255700006, -18.323376565999908],
            [25.49051599100011, -18.36554453499987],
            [25.495580281000088, -18.37887705499989],
            [25.508499390000082, -18.399134215999894],
            [25.574438518000107, -18.465693460999972],
            [25.608441610000057, -18.487707620999956],
            [25.622084188000144, -18.5011434929999],
            [25.669523153000057, -18.566049091999943],
            [25.698255249000056, -18.590233662999907],
            [25.736909220000143, -18.608733825999934],
            [25.761920613000143, -18.630334574999907],
            [25.77339278200006, -18.665577900999978],
            [25.779490601000106, -18.738751728999958],
            [25.81525069100013, -18.813992614999904],
            [25.94072106900012, -18.921272887999947],
            [25.967448582000088, -18.999925225999988],
            [25.967799520000085, -19.000957946999904],
            [25.964388875000054, -19.021628519999922],
            [25.94805912300012, -19.058732197999902],
            [25.944855184000062, -19.079196064999877],
            [25.94857588700006, -19.103277282999912],
            [25.956534058000045, -19.12208750399992],
            [25.9811320390001, -19.161775003999907],
            [26.011414429000126, -19.19980885799994],
            [26.034358765000064, -19.243733824999964],
            [26.13027022300014, -19.501082458999903],
            [26.155488322000082, -19.537152608999904],
            [26.19445235200007, -19.56020029699995],
            [26.239100789000105, -19.57146575899992],
            [26.292637573000064, -19.572499287999904],
            [26.303489624000093, -19.5772535199999],
            [26.313204793000125, -19.584178161999972],
            [26.321059611000067, -19.59203297899991],
            [26.33098148600007, -19.604952086999916],
            [26.333461955000132, -19.613013610999914],
            [26.326330607000102, -19.63389088999989],
            [26.319095906000143, -19.646293232999952],
            [26.312481323000043, -19.64960052499994],
            [26.312171264000142, -19.65135752299993],
            [26.324366903000083, -19.659108988999932],
            [26.33232507300005, -19.66241627999993],
            [26.3627108150001, -19.66758392299994],
            [26.38524174000011, -19.67905609099995],
            [26.412836955000103, -19.71957041399996],
            [26.43185388200007, -19.736520283999965],
            [26.450250692000083, -19.743341572999924],
            [26.489731486000096, -19.751919860999948],
            [26.508851766000106, -19.759257913999946],
            [26.549262736000088, -19.784062600999974],
            [26.566315958000104, -19.800805764999936],
            [26.574790893000113, -19.81951263399992],
            [26.581922241000143, -19.842146911999876],
            [26.59556481900006, -19.85558278399992],
            [26.614064982000087, -19.863437600999944],
            [26.65943688900012, -19.87573659199998],
            [26.67380293700012, -19.88338470499987],
            [26.67716996900009, -19.886815264999953],
            [26.684758341000077, -19.89454681399991],
            [26.698607625000136, -19.912530211999893],
            [26.713903850000094, -19.927413024999936],
            [26.730957072000137, -19.935887958999928],
            [26.750800822000116, -19.939608662999944],
            [26.77446862800008, -19.939815368999902],
            [26.811882365000116, -19.94642995199999],
            [26.925053752000082, -20.0008969109999],
            [26.961072225000066, -20.007201435999917],
            [26.994300171000106, -20.006788024999906],
            [27.02664961700009, -20.010095316999895],
            [27.060135946000088, -20.027561949999935],
            [27.069230997000147, -20.03738047199991],
            [27.08649092600004, -20.06053151499991],
            [27.097342977000096, -20.068903096999875],
            [27.10964196800012, -20.073243916999957],
            [27.119770548000076, -20.073864033999925],
            [27.12969242300008, -20.07293385799997],
            [27.141888062000106, -20.07334726899998],
            [27.16292037000011, -20.076551207999955],
            [27.183745971000064, -20.08233896899992],
            [27.201781047000082, -20.09298431399992],
            [27.214906861000117, -20.110450947999965],
            [27.266014852000126, -20.23416432699989],
            [27.28399825000011, -20.35146982799995],
            [27.26839196700007, -20.49575042799995],
            [27.306012411000097, -20.47735361699995],
            [27.340738973000043, -20.473012796999882],
            [27.453910359000076, -20.473322855999953],
            [27.534112183000076, -20.4830380249999],
            [27.590852905000077, -20.473322855999953],
            [27.62578617400007, -20.48861907999992],
            [27.665990438000108, -20.489135843999946],
            [27.68376713100011, -20.496060485999934],
            [27.698133179000138, -20.509082946999882],
            [27.705574585000136, -20.52665293299995],
            [27.702629028000047, -20.56613372799997],
            [27.690381713000107, -20.60148040699997],
            [27.682475219000082, -20.63734385199993],
            [27.70733158300004, -20.7167188519999],
            [27.709605346000046, -20.756716409999868],
            [27.69441247600011, -20.837745055999875],
            [27.68903812600007, -20.849010518999933],
            [27.6818034260001, -20.857588805999868],
            [27.676015666000126, -20.86668385799993],
            [27.674775431000086, -20.879913024999937],
            [27.675085490000072, -20.89128183999992],
            [27.672605021000095, -20.913709410999914],
            [27.672656697, -20.923527932999974],
            [27.680356486000107, -20.979648538999925],
            [27.67896122200011, -21.000732522999954],
            [27.66681726100012, -21.053752542999874],
            [27.666610555000148, -21.071219176999918],
            [27.674775431000086, -21.090132751999946],
            [27.709191935000035, -21.13447113],
            [27.724384807000064, -21.14966400099992],
            [27.79383793100004, -21.197413023999985],
            [27.82360355600011, -21.231726175999924],
            [27.849131714000066, -21.26965667699993],
            [27.884995158000095, -21.310171],
            [27.894400269000073, -21.324330342999886],
            [27.896674032000078, -21.33239186599988],
            [27.896157267000035, -21.347894794999974],
            [27.897810913000086, -21.355439554999933],
            [27.90421879100012, -21.364741311999964],
            [27.920548543000052, -21.38117441799993],
            [27.95021081500002, -21.43832855199996],
            [27.953001343000068, -21.448663838999963],
            [27.94964237500008, -21.456518655999986],
            [27.941942586000067, -21.468507587999866],
            [27.93987552900012, -21.478016051999944],
            [27.943337850000063, -21.47987640399994],
            [27.950417521000077, -21.48204681399993],
            [27.954448282000072, -21.487834573999905],
            [27.94928063900008, -21.500753681999925],
            [27.953208048000135, -21.51046885199996],
            [27.958065633000047, -21.51150237999994],
            [27.963698365000084, -21.51046885199996],
            [27.97057133000007, -21.514396259999927],
            [27.975738973000148, -21.52256113699994],
            [27.984730673000087, -21.542921650999887],
            [27.99041507900006, -21.55191334999992],
            [28.00255904100004, -21.564212341999863],
            [28.016563355000045, -21.572893981999925],
            [28.032893107000092, -21.57785491899996],
            [28.09077071100012, -21.581265563999892],
            [28.165701538000064, -21.59521819999989],
            [28.284867391000063, -21.59687184699993],
            [28.321919393000115, -21.603486429999933],
            [28.36176192200014, -21.61630218499991],
            [28.443100627000035, -21.65578297999994],
            [28.464598023000093, -21.660330504999976],
            [28.481392863000053, -21.65743662499999],
            [28.49730920400006, -21.6515455119999],
            [28.532500855000137, -21.643070576999975],
            [28.542939493000063, -21.638316344999893],
            [28.55399825100008, -21.636559346999917],
            [28.585934285000064, -21.644414163999954],
            [28.615699911000036, -21.647101337999885],
            [28.629704224000136, -21.651338805999927],
            [28.66840987200007, -21.679967549999915],
            [28.714195190000112, -21.69350677499999],
            [28.86085290500006, -21.75737884499995],
            [28.89103194200004, -21.764923603999904],
            [28.951906779000097, -21.76833424899992],
            [28.980845581000068, -21.774845478999893],
            [28.998725626000095, -21.786007588999922],
            [29.038723186000084, -21.797893167999945],
            [29.055259643000085, -21.809985453999943],
            [29.057636759000104, -21.829209085999963],
            [29.045441121000096, -21.852566833999916],
            [29.028904663000105, -21.87664805099986],
            [29.01794925900012, -21.89814544699989],
            [29.01381514500011, -21.94041676899988],
            [29.021566609000104, -21.982791442999897],
            [29.040531861000062, -22.020928648999956],
            [29.07076257300008, -22.051004332999923],
            [29.10796960400009, -22.06919443699988],
            [29.1448665770001, -22.07529225699993],
            [29.239331095000068, -22.072605081999896],
            [29.244395386000065, -22.07570566799994],
            [29.254110555000125, -22.087074482999924],
            [29.259588257000075, -22.096066182999962],
            [29.2673397210001, -22.115806578999937],
            [29.273644246000117, -22.125108336999872],
            [29.350073689000055, -22.186706644999987],
            [29.33152185000006, -22.19280446399995],
            [29.302893107000045, -22.190220641999943],
            [29.248219441000117, -22.179265238999875],
            [29.22207116700008, -22.18215911799996],
            [29.20279585800006, -22.19445810899991],
            [29.186621134000063, -22.207687275999902],
            [29.168844442000136, -22.213991800999906],
            [29.047818237000058, -22.220296325999925],
            [29.038723186000084, -22.22391367599991],
            [29.017845906000105, -22.250372008999904],
            [29.018052612000076, -22.255022887999957],
            [29.00275638800011, -22.263394470999927],
            [28.98373946100014, -22.281997985999894],
            [28.960226685000066, -22.31021331699995],
            [28.967926473000148, -22.380389912999917],
            [28.96337894700011, -22.392172138999925],
            [28.953457072000106, -22.40075042699995],
            [28.93040938300004, -22.44085133899995],
            [28.9125293380001, -22.453667093999925],
            [28.869379517000056, -22.448912861999943],
            [28.846590210000073, -22.449946390999926],
            [28.836771688000113, -22.463175556999914],
            [28.83119063400008, -22.48229583699991],
            [28.81682458500009, -22.49294118199991],
            [28.79677412900014, -22.498212177999932],
            [28.77475996900006, -22.501416116999906],
            [28.731351766000074, -22.513921814],
            [28.65900476100009, -22.551955667999934],
            [28.62386478700006, -22.562807718999892],
            [28.597199747000104, -22.56270436599995],
            [28.57756270300007, -22.560017191999933],
            [28.559837687000055, -22.563014424999935],
            [28.538495321000056, -22.580274352999936],
            [28.5224756260001, -22.58482187899996],
            [28.459378703000056, -22.569629006999932],
            [28.376851441000042, -22.575003356999986],
            [28.338559204000035, -22.584615172999918],
            [28.301817261000053, -22.603838805999928],
            [28.286831095000082, -22.615827738999897],
            [28.250554240000042, -22.655618590999907],
            [28.240684041000037, -22.66088958699993],
            [28.216344442000036, -22.663163349999948],
            [28.205492391000092, -22.665953876999907],
            [28.19619063300007, -22.671638284999958],
            [28.1646680100001, -22.708638610999913],
            [28.15970707200006, -22.71814707499989],
            [28.15774336700011, -22.731066181999907],
            [28.15970707200006, -22.743261819999915],
            [28.162704305000148, -22.751013284999928],
            [28.16249759900009, -22.758971455999884],
            [28.154952840000135, -22.77199391599993],
            [28.145857788000086, -22.77974538199993],
            [28.135625855000086, -22.783362731999915],
            [28.12560062600008, -22.785533141999906],
            [28.117435751000073, -22.789460550999962],
            [28.113198283000116, -22.795351663999966],
            [28.10772058100011, -22.81064788799992],
            [28.103689819000124, -22.81674570699998],
            [28.08880700700007, -22.82263681999997],
            [28.06575931800012, -22.82883799199996],
            [28.047155802000077, -22.83689951599986],
            [28.045398804000087, -22.847751565999914],
            [28.053977091000036, -22.86914560999992],
            [28.04973962400007, -22.891366474999955],
            [28.03744063300013, -22.911416930999906],
            [28.02183435000009, -22.926609802999934],
            [28.008295125000103, -22.934774677999954],
            [27.989381551000065, -22.943766377999893],
            [27.96840092000008, -22.951001077999962],
            [27.949177287000055, -22.95389495799995],
            [27.93749841300007, -22.96381683299994],
            [27.93791182500007, -22.986657815999948],
            [27.946076700000106, -23.029032490999953],
            [27.93005700700013, -23.057041117999873],
            [27.89553715000008, -23.079468688999967],
            [27.85378259300012, -23.09559173599986],
            [27.81574873800008, -23.104686787999924],
            [27.822259969000072, -23.12298024499998],
            [27.80644698100005, -23.128354593999944],
            [27.784949585000106, -23.127011006999894],
            [27.77420088700009, -23.125150654999885],
            [27.771720418000115, -23.133005472999912],
            [27.774614298000103, -23.14075693699992],
            [27.779058472000116, -23.147681579999897],
            [27.781022176000135, -23.15253916399992],
            [27.783037557000085, -23.155433043999906],
            [27.787378377000067, -23.15977386499989],
            [27.789290405000088, -23.163804625999973],
            [27.784587850000037, -23.165561624999953],
            [27.783295939000084, -23.16690521299992],
            [27.775751180000015, -23.17248626699994],
            [27.77420088700009, -23.17300303099998],
            [27.75942142800008, -23.211450296999928],
            [27.753633667000116, -23.220752053999945],
            [27.739164266000074, -23.227573343999907],
            [27.725728394000043, -23.221682229999914],
            [27.698443237000106, -23.193466898999944],
            [27.658755737000035, -23.223439229999983],
            [27.647128540000068, -23.227573343999907],
            [27.633434285000135, -23.223439229999983],
            [27.619171590000064, -23.217031350999946],
            [27.60800948100004, -23.21672129299995],
            [27.599224487000072, -23.244626565999937],
            [27.580414266000048, -23.26385019899996],
            [27.576073446000066, -23.279146422999915],
            [27.575246623000055, -23.284830830999866],
            [27.573076212000046, -23.290515237999912],
            [27.56961389200012, -23.294856058999898],
            [27.565893189000093, -23.29650970399993],
            [27.5633093670001, -23.29919687899988],
            [27.564911336000137, -23.305811461999966],
            [27.567753540000098, -23.31376963299992],
            [27.569355509000047, -23.320384215999923],
            [27.563671102000086, -23.34281178799992],
            [27.548891642000086, -23.36079518699991],
            [27.528841186000136, -23.373094176999942],
            [27.507240438000053, -23.37908864399988],
            [27.465692586000074, -23.380432230999943],
            [27.452670125000054, -23.385289814999865],
            [27.443161661000147, -23.395108336999925],
            [27.434996786000028, -23.40658050599994],
            [27.425178263000078, -23.412678324999902],
            [27.411122274000064, -23.405753681999926],
            [27.418460327000048, -23.391284280999898],
            [27.410502156000092, -23.38932057699995],
            [27.395826050000096, -23.39407480899986],
            [27.383733765000102, -23.39955251099994],
            [27.380839885000114, -23.405340270999915],
            [27.371331421000036, -23.41701914399998],
            [27.36120284000009, -23.422496846999962],
            [27.349989055000037, -23.39149098699994],
            [27.335571330000107, -23.402446390999927],
            [27.312006877000016, -23.43706959999993],
            [27.295573771000136, -23.451745706999915],
            [27.27810713700009, -23.46363128699994],
            [27.239711548000088, -23.481407979999886],
            [27.202504516000147, -23.49205332399997],
            [27.191497437000066, -23.503835550999966],
            [27.205656779000037, -23.52305918399989],
            [27.195631551000105, -23.52708994599989],
            [27.18663985200007, -23.527296650999943],
            [27.178681681000086, -23.52357594799993],
            [27.171446981000116, -23.51561777699996],
            [27.168966512000054, -23.521612243999897],
            [27.161525106000028, -23.52988047299995],
            [27.15718428500014, -23.536701761999907],
            [27.149122762000076, -23.5275033569999],
            [27.137650594000036, -23.523369241999973],
            [27.127418661000064, -23.525022887999924],
            [27.123077840000093, -23.53298105799989],
            [27.127418661000064, -23.54528004999993],
            [27.135686889000112, -23.551894632999932],
            [27.14116459100009, -23.558302509999876],
            [27.136720418000095, -23.570188089999903],
            [27.124421427000044, -23.563160094999986],
            [27.11336267100006, -23.564296975999895],
            [27.103750855000044, -23.571738382999925],
            [27.09579268400006, -23.583830667999905],
            [27.10251062000009, -23.583830667999905],
            [27.084113811000094, -23.596026305999914],
            [27.078326050000044, -23.60202077299995],
            [27.075225464000084, -23.61121917699994],
            [27.068404175000126, -23.607291767999882],
            [27.061531209000066, -23.604397887999895],
            [27.0631331780001, -23.624241637999972],
            [27.06943770300012, -23.641708272999935],
            [27.07005782100009, -23.65607431999993],
            [27.05476159600002, -23.666409606999935],
            [27.037605021000076, -23.665686135999948],
            [27.029853557000138, -23.654730732999965],
            [27.024272502000144, -23.642535094999957],
            [27.013833862000098, -23.63850433399996],
            [27.004170370000082, -23.645842386999945],
            [26.986548706000093, -23.686976826999924],
            [26.967170044000113, -23.718706155999953],
            [26.96205407700012, -23.737413024999938],
            [26.964542365000028, -23.74713996999988],
            [26.966601603000072, -23.755189717999954],
            [26.938127889000043, -23.802887064999922],
            [26.945000854000085, -23.823247578999954],
            [26.941176798000072, -23.85022267699989],
            [26.870896851000055, -24.115839537999946],
            [26.86893314600013, -24.16038462299987],
            [26.849709513000107, -24.248131204999908],
            [26.83916752200014, -24.265597838999938],
            [26.823251180000113, -24.278827005999943],
            [26.802270549000127, -24.289679055999983],
            [26.714007202000033, -24.315930683999923],
            [26.692923218000118, -24.32657602899991],
            [26.684086547000106, -24.341458841999952],
            [26.623470093000037, -24.399439798999907],
            [26.558357788000137, -24.438197122999938],
            [26.53117598500006, -24.458660990999903],
            [26.506061238000143, -24.48884002699991],
            [26.47681237800009, -24.559946797999928],
            [26.469474325000107, -24.57141896599994],
            [26.404362020000093, -24.63281056699992],
            [26.404001092000073, -24.63275806799993],
            [26.381624390000127, -24.62950327499992],
            [26.36353763800011, -24.628056334999926],
            [26.344520711000143, -24.62402557399993],
            [26.32571049000012, -24.62237192799998],
            [26.27878829000008, -24.628469745999936],
            [26.165910617000094, -24.660846194999948],
            [26.013584839000117, -24.704537455999912],
            [25.9811320390001, -24.726344909999938],
            [25.966042521000105, -24.733579610999897],
            [25.91467614800007, -24.731822610999927],
            [25.881706583000096, -24.74215789799993],
            [25.874058472000115, -24.74339813299987],
            [25.86837406400008, -24.748152363999864],
            [25.866927124000085, -24.77264699299991],
            [25.87726241100009, -24.84571746899988],
            [25.87674564600013, -24.886025084999915],
            [25.86620365400009, -24.918167826999948],
            [25.83705814600006, -24.979146015999916],
            [25.835197795000056, -25.016353047999928],
            [25.804915405000116, -25.064825540999905],
            [25.782901245000062, -25.131384784999895],
            [25.695464722000082, -25.309978535999917],
            [25.66352868700011, -25.43999643899994],
            [25.652837702000085, -25.463318549999954],
            [25.608855021000068, -25.55926564499994],
            [25.58725427200008, -25.619520364999914],
            [25.458424927000095, -25.711194355999922],
            [25.386491333000038, -25.74354380299991],
            [25.177821899000037, -25.763284199999887],
            [25.13596399000008, -25.756566263999943],
            [25.09028202300007, -25.743647154999934],
            [25.051731405000083, -25.73785939499996],
            [25.013284139000035, -25.743027038999884],
            [24.9679122310001, -25.762870787999958],
            [24.90838098200004, -25.80410858099988],
            [24.888537231000043, -25.811653340999925],
            [24.82890262900014, -25.826019388999924],
            [24.798620239000115, -25.829223326999895],
            [24.770714966000128, -25.822608743999893],
            [24.737952107000126, -25.815890807999963],
            [24.664984985000103, -25.823332214],
            [24.62963830600009, -25.81609751299993],
            [24.576721639000112, -25.783334655999923],
            [24.50085111700011, -25.757848433999897],
            [24.456728963000018, -25.743027038999884],
            [24.4367818610001, -25.74530080199989],
            [24.416731405000064, -25.753052265999898],
            [24.38923954200007, -25.75946014399993],
            [24.338906698000102, -25.75181203199996],
            [24.29673872900014, -25.723493347999877],
            [24.2276990150001, -25.648975931999914],
            [24.183463990000064, -25.625928242999947],
            [24.130960734000098, -25.626238301999933],
            [24.027091105000096, -25.651766458999887],
            [24.00569706200008, -25.654660338999875],
            [24.004250122000087, -25.649906107999882],
            [24.009624471000052, -25.64132781899994],
            [24.008694296000073, -25.63316294399992],
            [23.99825565600014, -25.625308125999894],
            [23.988023723000083, -25.619520364999914],
            [23.976448202000114, -25.61755666099988],
            [23.924771769000074, -25.629235533999946],
            [23.905754842000107, -25.61848683599993],
            [23.89066532400011, -25.598849792],
            [23.845396769000104, -25.569084166999914],
            [23.8074662680001, -25.523608906999954],
            [23.79857792100009, -25.51854461699989],
            [23.7783207600001, -25.512550150999942],
            [23.76901900200008, -25.507382506999946],
            [23.762301066000134, -25.498494160999925],
            [23.75206913300005, -25.477616882999953],
            [23.7426640220001, -25.46996876999988],
            [23.686750122, -25.45436248699994],
            [23.674244425000012, -25.442580261999936],
            [23.666699666000056, -25.432658385999943],
            [23.561073038000075, -25.357314147999972],
            [23.53585494, -25.343258157999955],
            [23.50660607900008, -25.330959166999918],
            [23.496580851000147, -25.32424123099989],
            [23.483455037000084, -25.311528828999926],
            [23.468158813000116, -25.29023813899994],
            [23.459270467000096, -25.28217661599996],
            [23.444904419000096, -25.278145852999955],
            [23.4319853100001, -25.280316263999865],
            [23.39922245300008, -25.291375019999947],
            [23.381445760000048, -25.292615253999898],
            [23.36594283100004, -25.2893079629999],
            [23.320364217000076, -25.273391621999878],
            [23.26569055100009, -25.263986510999914],
            [23.216081176000046, -25.267190449999887],
            [23.16853885900011, -25.280006204999964],
            [23.093401327000095, -25.312459004999894],
            [23.083892863000102, -25.319693705999953],
            [23.071697225000094, -25.325998229999954],
            [23.065496053000118, -25.32083058699996],
            [23.061155233000136, -25.310702005999914],
            [23.054540649000046, -25.302537128999887],
            [23.030666138000043, -25.299436543999946],
            [23.00699833200011, -25.31080535899993],
            [22.968034302000035, -25.34687550799994],
            [22.96255660000014, -25.355763854999864],
            [22.960282837000108, -25.364342142999888],
            [22.95614872200011, -25.372093606999982],
            [22.94477990700011, -25.378708190999888],
            [22.93093062300005, -25.384289244999906],
            [22.92049198400011, -25.390490416999896],
            [22.911913696000084, -25.39906870499992],
            [22.903645467000047, -25.411367695999957],
            [22.88762577300008, -25.450228372999916],
            [22.876773722000053, -25.462010599999914],
            [22.851348918000042, -25.471312356999945],
            [22.84463098100011, -25.48113087999991],
            [22.824683879000077, -25.543039245999935],
            [22.816829061000135, -25.558438822999918],
            [22.814038534000076, -25.566603697999938],
            [22.81341841600002, -25.575078632999933],
            [22.819206177000098, -25.58489715599991],
            [22.828714640000072, -25.595542499999908],
            [22.83336551900004, -25.60608449299987],
            [22.8243738190001, -25.6157996619999],
            [22.810834594000113, -25.625308125999894],
            [22.80959436000009, -25.63326629699995],
            [22.81341841600002, -25.641947936999912],
            [22.81496871000013, -25.65279998799987],
            [22.812798299000065, -25.667062682999926],
            [22.810214478000148, -25.67739796899994],
            [22.80442671700007, -25.687216490999916],
            [22.75977828000015, -25.734862161999956],
            [22.746445760000114, -25.755326028999917],
            [22.74045129400008, -25.77703013099992],
            [22.74117476400008, -25.790879413999875],
            [22.74499882000012, -25.794083353999937],
            [22.750889934000043, -25.79604705799997],
            [22.75791792800004, -25.805968932999875],
            [22.76411910000013, -25.82033498099989],
            [22.76546268700008, -25.826536152999964],
            [22.754713989000066, -25.84338266999994],
            [22.73952111800014, -25.858472187999936],
            [22.719470662000106, -25.874285176999933],
            [22.708825318000095, -25.89102833999989],
            [22.721641072000097, -25.909011738999965],
            [22.72680871600008, -25.921620788999903],
            [22.72722212700009, -25.94394500699987],
            [22.724224894000088, -25.967509459999874],
            [22.719367309000063, -25.98425262499991],
            [22.710478963000043, -25.996861673999945],
            [22.700660441000082, -26.003269551999978],
            [22.67223840300005, -26.012881367999896],
            [22.66159305800008, -26.020942890999976],
            [22.662109823, -26.0298312379999],
            [22.665830526000036, -26.039856465999918],
            [22.665003702000092, -26.05143198599997],
            [22.62324914600015, -26.10930958999998],
            [22.62086310300006, -26.11153248499997],
            [22.61115686100007, -26.120575052999953],
            [22.59151981600013, -26.133184101999888],
            [22.58025435400006, -26.146516621999908],
            [22.563821248000096, -26.18113983099991],
            [22.545114380000115, -26.207391458999936],
            [22.527957805000142, -26.21369598399987],
            [22.482585897000035, -26.204807637999934],
            [22.45085656800012, -26.21007863399997],
            [22.428842407000047, -26.226511738999932],
            [22.395046020000052, -26.271883645999964],
            [22.342852824000147, -26.317358906999928],
            [22.31877160600004, -26.32883107499994],
            [22.303165324000076, -26.333585305999932],
            [22.257276652000115, -26.340923360999923],
            [22.24828495300008, -26.346917826999956],
            [22.237742961000095, -26.366761575999945],
            [22.19743534400007, -26.404071959999982],
            [22.17831506400006, -26.43993540499993],
            [22.14617232200004, -26.519207050999867],
            [22.108138469000096, -26.571917011999886],
            [22.057702271000096, -26.617598978999908],
            [21.99899784300004, -26.650258483999963],
            [21.935849243000092, -26.66390106199988],
            [21.838800903000106, -26.664521178999863],
            [21.807278280000048, -26.669585468999927],
            [21.78061324100011, -26.67816375699995],
            [21.76872766100007, -26.688705748999922],
            [21.76748742700005, -26.704312031999862],
            [21.776479126000083, -26.74916717499994],
            [21.77751265400005, -26.768494160999907],
            [21.773378540000124, -26.786787617999963],
            [21.762319784000027, -26.804460957999964],
            [21.743819620000096, -26.82048065199993],
            [21.68718225100011, -26.85520721399986],
            [21.664547974000072, -26.863062031999903],
            [21.643360636000097, -26.862751972999916],
            [21.583932739000147, -26.848385924999903],
            [21.4986666260001, -26.84642222099997],
            [21.449470662000124, -26.82637176499992],
            [21.426629679000115, -26.82265106199992],
            [21.380844360000083, -26.823994648999886],
            [21.296921834000074, -26.844458515999932],
            [21.28286584500006, -26.84497528099989],
            [21.25485721800004, -26.841771341999916],
            [21.240594523000084, -26.84197804799996],
            [21.1534680580001, -26.86450897199998],
            [21.12246219900007, -26.865335794999908],
            [20.990377238000093, -26.838567402999942],
            [20.950172973000065, -26.81603647899992],
            [20.90769494600002, -26.800016783999965],
            [20.851884400000074, -26.806528014999927],
            [20.82604618300013, -26.818827005999964],
            [20.779434042000076, -26.84807586699992],
            [20.714941854000045, -26.875050964999943],
            [20.69354781000004, -26.889003600999942],
            [20.690757283000067, -26.891794127999987],
            [20.68569299300009, -26.88176889999997],
            [20.675461059000042, -26.85003957099987],
            [20.665642537000053, -26.83908416799997],
            [20.650553019000142, -26.82967905699992],
            [20.64486861200001, -26.824511413999915],
            [20.63866744000012, -26.81696665399997],
            [20.62481815600006, -26.78937143899988],
            [20.614689575000114, -26.75319793699994],
            [20.60921187300002, -26.71619761199989],
            [20.608901815000138, -26.68612192799992],
            [20.63070926900008, -26.618322448999905],
            [20.6323629150001, -26.59527475999994],
            [20.627712036000048, -26.58080535899991],
            [20.611485636000054, -26.559928079999935],
            [20.60528446400005, -26.547732441999912],
            [20.602287232000037, -26.522204284999887],
            [20.60528446400005, -26.493265482999917],
            [20.618203573000073, -26.43972869899997],
            [20.622544392000037, -26.42753305999996],
            [20.652103312000065, -26.4077926639999],
            [20.665952596000125, -26.391772969999934],
            [20.695511515000078, -26.341956887999913],
            [20.75328576700008, -26.27622446699995],
            [20.776230103000103, -26.24056772799996],
            [20.794730265000027, -26.201913756999957],
            [20.837931763000057, -26.146826680999894],
            [20.841445760000113, -26.131323750999883],
            [20.80392867000012, -26.071275735999862],
            [20.800518026000105, -26.052465514999952],
            [20.80279178900011, -25.980531921999912],
            [20.794110148000073, -25.893922220999883],
            [20.767135050000036, -25.834390970999905],
            [20.766928344000064, -25.83067026699989],
            [20.75576623500004, -25.81899139399991],
            [20.749978475000063, -25.81847462899988],
            [20.740056600000088, -25.823125507999933],
            [20.7265173750001, -25.82736297599989],
            [20.727137492000054, -25.818164570999983],
            [20.737782837000054, -25.79894093799996],
            [20.71669885300011, -25.732588398999937],
            [20.706880330000075, -25.714811705999907],
            [20.69654504400006, -25.707060242],
            [20.67101688700012, -25.695484720999957],
            [20.66285201000011, -25.685252786999882],
            [20.662748657000066, -25.674917500999968],
            [20.671430298000132, -25.653316751999895],
            [20.670810181000064, -25.642257994999895],
            [20.663058716000137, -25.636263528999876],
            [20.65137984200007, -25.634609883999914],
            [20.641044556000082, -25.631199238999983],
            [20.637943969000048, -25.62034718799994],
            [20.643318319000088, -25.6132158409999],
            [20.665229126000042, -25.60102020299989],
            [20.671430298000132, -25.591201680999916],
            [20.66336877400005, -25.564743346999933],
            [20.61851363100004, -25.528466491999964],
            [20.620373983000064, -25.50056121899989],
            [20.626885213000037, -25.484748229999894],
            [20.65654748600008, -25.46779835999989],
            [20.64352502400004, -25.457359720999946],
            [20.634429972000078, -25.457669778999943],
            [20.6256449790001, -25.46273406999991],
            [20.616549927000108, -25.466144713999938],
            [20.606628051000115, -25.462010599999914],
            [20.605904582000022, -25.45177866599994],
            [20.611382283000097, -25.43937632199996],
            [20.61200240100007, -25.431004739999892],
            [20.596912882000083, -25.4328650919999],
            [20.593605590000095, -25.413228046999876],
            [20.588024536000148, -25.40402964299996],
            [20.55877567600004, -25.392040710999908],
            [20.542239217000116, -25.382222188999933],
            [20.535831340000072, -25.37116343099993],
            [20.529216756000096, -25.34005421999997],
            [20.525082642000058, -25.332199401999944],
            [20.514644002000125, -25.319280292999935],
            [20.510509888000115, -25.312252298999923],
            [20.510406534000083, -25.30470753999988],
            [20.514850708000097, -25.29912648499996],
            [20.518571411000096, -25.293028666999902],
            [20.516401001000105, -25.283623555999952],
            [20.509889770000143, -25.27752573699989],
            [20.491803019000116, -25.269050801999896],
            [20.485498495000115, -25.263159687999888],
            [20.48353479000008, -25.256648456999926],
            [20.481674439000074, -25.23050018299992],
            [20.46245080600005, -25.22367889399996],
            [20.443847290000093, -25.213343606999956],
            [20.434442179000143, -25.199804381999883],
            [20.44322717300011, -25.18306121799992],
            [20.444777466000062, -25.168385110999935],
            [20.43392541500009, -25.146784362999966],
            [20.406846965000057, -25.107820332999978],
            [20.375531047000038, -25.046118672999924],
            [20.364885702000038, -25.033199564999904],
            [20.23569462100005, -24.936047870999914],
            [20.159316853000092, -24.8936731969999],
            [20.149084920000092, -24.890986022999968],
            [20.128414348000092, -24.889745787999928],
            [20.1189058840001, -24.887368672999884],
            [20.10784712800009, -24.880340677999882],
            [20.08107873500012, -24.852642109999948],
            [20.029298950000054, -24.815228372999883],
            [20.010488729000144, -24.788046569999906],
            [19.992918742000086, -24.775850931999884],
            [19.986407511000095, -24.768822936999882],
            [19.981446574000046, -24.75249318399993],
            [19.981343221000117, -24.58041066499989],
            [19.981136516000078, -24.408431497999956],
            [19.980826456000074, -24.236555683999953],
            [19.98072310400005, -24.064473164999896],
            [19.980516398000105, -23.89249399799988],
            [19.980482728000055, -23.864488701999875],
            [19.98030969200005, -23.720566507999948],
            [19.980102987000095, -23.54858734099993],
            [19.979896281000038, -23.376504821999973],
            [19.979855443000133, -23.308551120999894],
            [19.97979292800011, -23.20452565499994],
            [19.979586222000137, -23.032546487999923],
            [19.979276164000055, -22.860670674999923],
            [19.979172811000126, -22.688588154999962],
            [19.97896610500007, -22.538106383999974],
            [19.978862753000044, -22.387624613999975],
            [19.978656046000083, -22.23724619599993],
            [19.978449340000054, -22.08676442499994],
            [19.978345988000115, -22.00067148899994],
            [20.212440226000126, -22.00067148899994],
            [20.446534465000127, -22.00067148899994],
            [20.68062870300011, -22.00067148899994],
            [20.914722941000036, -22.00067148899994],
            [20.97198042800008, -22.00067148899994],
            [20.98479618300007, -21.963981220999884],
            [20.98469283100013, -21.922846780999905],
            [20.984486125000075, -21.865175882999935],
            [20.984279418000114, -21.807608337999895],
            [20.984072713000074, -21.75004079199995],
            [20.983866007000103, -21.692369892999892],
            [20.98365930200015, -21.63469899499991],
            [20.98345259600009, -21.577028095999935],
            [20.98314253800004, -21.51935719799988],
            [20.98303918400009, -21.461789652999926],
            [20.982832479000137, -21.404118753999867],
            [20.98262577300008, -21.34644785499998],
            [20.98241906700011, -21.288880309999954],
            [20.98221236200007, -21.23120941199997],
            [20.982109009000055, -21.17364186599994],
            [20.981902303000084, -21.116074319999896],
            [20.981592244000097, -21.058403421999927],
            [20.981488891000083, -21.000732522999954],
            [20.98148632900012, -20.999958183999922],
            [20.981075480000072, -20.87577890999991],
            [20.980662068000044, -20.750721943999935],
            [20.980248657000033, -20.625768329999886],
            [20.97983524600002, -20.5007113649999],
            [20.979421834000107, -20.375757750999952],
            [20.979360470000103, -20.351028106999905],
            [20.979111775000035, -20.250804137999907],
            [20.97869836400011, -20.125850524999947],
            [20.9782849530001, -20.00079355899996],
            [20.977974894000113, -19.875839944999925],
            [20.977561483000102, -19.750782978999936],
            [20.97704471800006, -19.625829365999977],
            [20.97673466000009, -19.50087575299993],
            [20.976321248000062, -19.375818786999957],
            [20.975804484000037, -19.25086517299991],
            [20.97560905200004, -19.172106009999908],
            [20.975494425000136, -19.125911559999864],
            [20.975081014000125, -19.000957946999904],
            [20.975081014000125, -18.960030211999893],
            [20.975081014000125, -18.9192058309999],
            [20.975081014000125, -18.87838144899999],
            [20.975081014000125, -18.83766042099994],
            [20.975081014000125, -18.796836038999942],
            [20.975081014000125, -18.75601165799995],
            [20.975081014000125, -18.715187275999952],
            [20.975081014000125, -18.67436289499996],
            [20.975081014000125, -18.633538512999877],
            [20.975081014000125, -18.592714130999894],
            [20.975081014000125, -18.551993102999916],
            [20.975081014000125, -18.51106536899991],
            [20.975081014000125, -18.470137633999883],
            [20.975081014000125, -18.42931325299989],
            [20.975081014000125, -18.38859222399992],
            [20.975081014000125, -18.347767841999925],
            [20.975081014000125, -18.319345804999912],
            [20.993436476000085, -18.318611585999918],
            [21.02417362500006, -18.317382099999875],
            [21.080604288000103, -18.315211689999984],
            [21.13693160000011, -18.312937926999965],
            [21.193465617000072, -18.31076751699989],
            [21.249896281000105, -18.308493753999954],
            [21.29681848200005, -18.306633401999946],
            [21.34394738800006, -18.30477305099994],
            [21.3908695880001, -18.302912698999947],
            [21.437895142000087, -18.301052347999942],
            [21.456808715000108, -18.300225524999917],
            [21.47572229000005, -18.29950205499992],
            [21.492878865000108, -18.296401468999974],
            [21.509828735000042, -18.2931975299999],
            [21.52698531100009, -18.289993590999927],
            [21.544038534000038, -18.28678965299987],
            [21.628477824000072, -18.271183369999918],
            [21.712710409000067, -18.25557708799998],
            [21.7971496990001, -18.239867451999913],
            [21.88148563700011, -18.22415781699995],
            [21.966028280000074, -18.20855153399991],
            [22.05026086500007, -18.19284189899993],
            [22.13459680100007, -18.177235615999905],
            [22.219036092000124, -18.161525980999926],
            [22.303475383000148, -18.145816344999957],
            [22.387811320000083, -18.13021006299992],
            [22.472147257000103, -18.114500426999953],
            [22.556483195000112, -18.09879079199989],
            [22.640922485000146, -18.083184508999935],
            [22.72525842300007, -18.067474873999885],
            [22.809697713000105, -18.05186859099993],
            [22.89403365000004, -18.036158955999966],
            [22.98136682200007, -18.020035908999972],
            [23.09960249900007, -18.010217386999912],
            [23.185798787000095, -18.003086038999882],
            [23.254941854000094, -17.997401631999935],
            [23.292769002000057, -17.998951924999957],
            [23.30568811100008, -18.00546315499993],
            [23.311475870000038, -18.00980397499991],
            [23.312819458, -18.01652191199993],
            [23.312716105000078, -18.02995778399989],
            [23.315920044000052, -18.03708913199992],
            [23.323258097000064, -18.039156188999883],
            [23.330596150000133, -18.039983011999908],
            [23.333800090000096, -18.04329030399991],
            [23.332559855000085, -18.06706146199987],
            [23.333800090000096, -18.073986103999943],
            [23.33659061700007, -18.07936045399991],
            [23.34806278500008, -18.094449970999904],
            [23.359534952000104, -18.11915130599992],
            [23.389713989000114, -18.15325775099997],
            [23.395811808000076, -18.16338633199993],
            [23.39632857300009, -18.169380797999864],
            [23.394468221000096, -18.18622731499994],
            [23.395811808000076, -18.191394958999936],
            [23.40128951000014, -18.194288838999924],
            [23.41028120900009, -18.197389424999884],
            [23.418859497000113, -18.198422952999948],
            [23.4294014890001, -18.18850107799996],
            [23.444284302000113, -18.200696715999882],
            [23.45875370300007, -18.217646585999972],
            [23.464128052000035, -18.225501403999914],
            [23.477770630000123, -18.230875751999875],
            [23.49130985500011, -18.233149515999898],
            [23.5015417890001, -18.237490335999965],
            [23.5056759040001, -18.249375915999906],
            [23.511256958000047, -18.260331318999974],
            [23.521695597000075, -18.268186136999915],
            [23.52727665200007, -18.27769459999989],
            [23.518801717000088, -18.29371429399994],
            [23.551461222000057, -18.32751068099992],
            [23.560762980000078, -18.348491312999926],
            [23.546603637000118, -18.369471943999926],
            [23.555491984000042, -18.383114522999932],
            [23.571304972000036, -18.426005960999888],
            [23.57915979000009, -18.467863870999864],
            [23.59218225100011, -18.478199156999963],
            [23.609855591000013, -18.477682392999924],
            [23.645408976000084, -18.46600351899987],
            [23.64985314900008, -18.463419697999953],
            [23.656467733000085, -18.458252054999946],
            [23.680135539000105, -18.431483662999966],
            [23.700909464000063, -18.427969665999925],
            [23.715792277000105, -18.419081318999915],
            [23.809843384000146, -18.321722920999946],
            [23.82555301900004, -18.317072041999978],
            [23.83723189200009, -18.305806578999935],
            [23.855215291000093, -18.280071715999938],
            [23.86751428300002, -18.269426370999938],
            [23.89696984900013, -18.250202737999928],
            [23.91288619000005, -18.2357333369999],
            [23.915986776000096, -18.20121348099991],
            [23.950816691000057, -18.177649026999916],
            [23.956604451000118, -18.176615498999922],
            [23.961978800000082, -18.17785573299996],
            [23.966733032000093, -18.18064626099992],
            [23.97117720600008, -18.183850199],
            [23.974897909000106, -18.177028910999937],
            [23.979652141000088, -18.17186126699994],
            [23.991744426000082, -18.16338633199993],
            [24.020269816000024, -18.151604105999937],
            [24.02812463400008, -18.145816344999957],
            [24.056960083000092, -18.119047953999896],
            [24.065124959000116, -18.11522389699995],
            [24.101608521000117, -18.108816019999907],
            [24.135094848000023, -18.085458271999954],
            [24.183050578000064, -18.029441018999933],
            [24.21829390400012, -18.012594501999956],
            [24.238241007000056, -18.009907327999926],
            [24.259221639000145, -18.012594501999956],
            [24.2700736890001, -18.015798441999934],
            [24.28743697100012, -18.024480081999897],
            [24.29642867000007, -18.026237080999877],
            [24.30583378100002, -18.01941579199992],
            [24.334255819000134, -17.97156341499992],
            [24.350585571000067, -17.95606048499991],
            [24.36526167800008, -17.950789489999877],
            [24.399471476000144, -17.952339781999896],
            [24.42158898900007, -17.95647389699991],
            [24.433887980000122, -17.96722259499994],
            [24.451044556000085, -17.998951924999957],
            [24.458485962000083, -18.005773213999916],
            [24.465100545000098, -18.008667093999904],
            [24.469751424000066, -18.014454853999965],
            [24.471508422000028, -18.02995778399989],
            [24.505614868000094, -18.06034352599994],
            [24.518430623000086, -18.057346292999924],
            [24.56442264800009, -18.052798766999985],
            [24.57455122900012, -18.050421650999937],
            [24.577755168000095, -18.04442718499992],
            [24.59181115700011, -18.028407490999953],
            [24.595015096000083, -18.022826435999946],
            [24.598632446000067, -18.020759378999884],
            [24.64917199700011, -17.96277842199993],
            [24.66405480900005, -17.949859313999923],
            [24.698471314000102, -17.928878682999922],
            [24.725343058000107, -17.895909118999953],
            [24.73071740700007, -17.891878356999953],
            [24.738158814000087, -17.887640889999915],
            [24.74684045400005, -17.884230244999884],
            [24.756038859000057, -17.88278330499989],
            [24.76451379300005, -17.879682718999945],
            [24.770714966000128, -17.8655233759999],
            [24.776916138000104, -17.86231943799993],
            [24.797380005000065, -17.858081969999972],
            [24.820841105000056, -17.839271748999877],
            [24.838101033000044, -17.83503428099992],
            [24.8574280200001, -17.833587340999927],
            [24.93111861200012, -17.810539652999964],
            [24.937629842000092, -17.807129007999933],
            [24.945174601000133, -17.799997659999903],
            [24.94858524600005, -17.793279723999973],
            [24.953339477000043, -17.788422138999948],
            [24.964294881000114, -17.786665140999972],
            [24.95809370900014, -17.800927835999943],
            [24.968635702000114, -17.807645771999972],
            [24.975146932000087, -17.81632741299994],
            [24.98331180800008, -17.820461526999864],
            [24.99850468000011, -17.81395029699989],
            [25.007082967000144, -17.8257325229999],
            [25.01969201600008, -17.82376881899995],
            [25.047493937000127, -17.807129007999933],
            [25.05700240100012, -17.827696227999922],
            [25.08790490700011, -17.826766051999883],
            [25.120874471000064, -17.813536884999877],
            [25.153947387000073, -17.781807555999947],
            [25.194151652000073, -17.7823243199999],
            [25.259780721000112, -17.794106546999984],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Zimbabwe',
        iso3: 'ZWE',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [25.259780721000112, -17.794106546999984],
            [25.266705363000085, -17.800927835999943],
            [25.285412231000066, -17.809299417999924],
            [25.315901327000063, -17.832140400999933],
            [25.335538371000098, -17.84123545299991],
            [25.345253540000044, -17.842579039999876],
            [25.376466105000105, -17.84123545299991],
            [25.409539021000114, -17.85301767999991],
            [25.420287719000044, -17.854878030999913],
            [25.495580281000088, -17.854878030999913],
            [25.5007479250001, -17.85601491199992],
            [25.510153035000144, -17.861182555999918],
            [25.516457561000067, -17.86231943799993],
            [25.522141967000096, -17.860149027999938],
            [25.53092696200008, -17.850950621999942],
            [25.53681807400008, -17.848676858999923],
            [25.603997436000043, -17.836171162999932],
            [25.657017456000062, -17.81395029699989],
            [25.68140873200008, -17.811469827999915],
            [25.69422448700007, -17.819427998999885],
            [25.70642012500008, -17.829866637999913],
            [25.743833862000116, -17.839375101999906],
            [25.765951375000043, -17.849813740999934],
            [25.78600183100008, -17.8622160849999],
            [25.79468347100004, -17.872654723999943],
            [25.80439864100009, -17.888157653999954],
            [25.849667196000098, -17.906657815999978],
            [25.86361983200007, -17.92381439199994],
            [25.84749678500009, -17.92939544599996],
            [25.846153198000138, -17.943658141999933],
            [25.85349125200011, -17.95998789499997],
            [25.86361983200007, -17.97156341499992],
            [25.924494670000115, -17.998951924999957],
            [25.966972697000074, -18.000502216999877],
            [25.9785482180001, -17.998951924999957],
            [26.03373864800011, -17.97156341499992],
            [26.04055993600005, -17.978488056999893],
            [26.046554402000083, -17.96629241899997],
            [26.06247074300012, -17.962881774999957],
            [26.08117761200009, -17.962365010999918],
            [26.09523360200012, -17.95854095399997],
            [26.096163777000072, -17.954613544999916],
            [26.094200073000138, -17.941901143999957],
            [26.09523360200012, -17.93807708699991],
            [26.101228068000125, -17.935803324999895],
            [26.11859134900007, -17.93156585699994],
            [26.13543786600013, -17.922574157999904],
            [26.158588908000127, -17.918336689999947],
            [26.167477254000033, -17.91358245799995],
            [26.203030640000094, -17.8872274779999],
            [26.211918986000114, -17.88278330499989],
            [26.22111739100012, -17.88629730299995],
            [26.228248739000065, -17.894668883999927],
            [26.233933146000084, -17.903970641999948],
            [26.23920414200012, -17.910171813999938],
            [26.24829919400011, -17.91337575299991],
            [26.294291219000087, -17.918543395999905],
            [26.30379968300008, -17.92278086399996],
            [26.311964559000103, -17.928361917999965],
            [26.31826908400012, -17.934356383999912],
            [26.32550378500008, -17.93601002999995],
            [26.3627108150001, -17.930635680999984],
            [26.40859948700006, -17.939007262999965],
            [26.485494018000054, -17.979314880999922],
            [26.527145223000076, -17.99202728199988],
            [26.553603557000145, -17.99647145599998],
            [26.570243367000074, -18.002879332999925],
            [26.583369181000137, -18.01321461999993],
            [26.59887211100005, -18.02995778399989],
            [26.612721395000108, -18.041223245999944],
            [26.628844442000087, -18.0491814169999],
            [26.68568851700013, -18.066751403999973],
            [26.70000288900013, -18.069231871999946],
            [26.711940145000085, -18.06582122799992],
            [26.740568889000144, -18.040499775999947],
            [26.75359135000008, -18.032955017],
            [26.76971439600007, -18.02902760799992],
            [26.79400231900007, -18.026237080999877],
            [26.888260132000084, -17.984585875999954],
            [26.912031291000034, -17.99202728199988],
            [26.948669881000086, -17.96887624099989],
            [26.95916019700013, -17.964742126999866],
            [27.006289103000142, -17.9626750689999],
            [27.021275269000114, -17.95854095399997],
            [27.048457072000105, -17.944278259999905],
            [27.07817102000007, -17.916993102999896],
            [27.115429728000095, -17.882163186999918],
            [27.14901940900012, -17.842475686999933],
            [27.14653894000014, -17.81891123499993],
            [27.14529870600012, -17.794106546999984],
            [27.146952352000085, -17.783874613999913],
            [27.157080932000042, -17.769301859999956],
            [27.422077677000118, -17.504821878999905],
            [27.524293661000087, -17.41511159299992],
            [27.57731368000009, -17.3631251019999],
            [27.60449548300008, -17.312792256999927],
            [27.624855998000015, -17.233313903999928],
            [27.64118575100005, -17.198483987999865],
            [27.777301473000136, -17.00118336999995],
            [27.816885620000107, -16.95963551799987],
            [27.86856205200013, -16.929663186999917],
            [28.022992543000072, -16.865393042999884],
            [28.113921753000113, -16.827550557999885],
            [28.21252038500009, -16.748588968999925],
            [28.28011316000007, -16.706524352999892],
            [28.643295126000055, -16.568754984999956],
            [28.690734090000035, -16.56028004999996],
            [28.718794393000053, -16.56028004999996],
            [28.732850382000066, -16.558109638999966],
            [28.741376994000092, -16.55066823299994],
            [28.76111739100014, -16.532271423999944],
            [28.76928226700008, -16.51521819999992],
            [28.808866414000107, -16.486279397999866],
            [28.822508992000024, -16.470776468999944],
            [28.829123576000114, -16.43460296699992],
            [28.833050985000085, -16.42643808999989],
            [28.857235555000074, -16.38819753],
            [28.857028849000102, -16.36545989999992],
            [28.84049239100011, -16.323601989999943],
            [28.836771688000113, -16.306342060999953],
            [28.840285685000055, -16.284741311999895],
            [28.864160197000047, -16.23120452899994],
            [28.847106975000116, -16.202679138],
            [28.852481323000063, -16.162784931999866],
            [28.865400431000097, -16.12123708099996],
            [28.87098148600009, -16.087233988999927],
            [28.868501017000114, -16.082169697999944],
            [28.86385013900008, -16.07658864399994],
            [28.859302612000135, -16.069560648999925],
            [28.857235555000074, -16.060465595999958],
            [28.86033614100012, -16.04940683999986],
            [28.874082072000135, -16.0289429729999],
            [28.877182658000095, -16.02201832999991],
            [28.898886760000096, -15.995456643999901],
            [28.932373087000087, -15.963727314999872],
            [28.9468615990001, -15.957235194999981],
            [28.951286662000115, -15.955252379999962],
            [28.97278405800006, -15.951428323999934],
            [29.018052612000076, -15.950601500999909],
            [29.04234053600007, -15.946260680999927],
            [29.055052938000102, -15.934375101999905],
            [29.076343628000103, -15.895411070999913],
            [29.086162150000064, -15.884559019999955],
            [29.102181844000114, -15.870916442999956],
            [29.121715535000135, -15.859340921999916],
            [29.1418693440001, -15.854483337999895],
            [29.150964396000063, -15.848798929999944],
            [29.186311076000067, -15.812832132999873],
            [29.406969442000047, -15.714233499999892],
            [29.42205896000013, -15.711029561999908],
            [29.508461955000087, -15.703588154999892],
            [29.526238647000127, -15.692839456999963],
            [29.56344567900004, -15.662143655999927],
            [29.58721683800013, -15.655735778999897],
            [29.60855920400013, -15.658422952999913],
            [29.62798954300007, -15.66359059599992],
            [29.648505086000057, -15.66658782999994],
            [29.672793009000145, -15.663280537999938],
            [29.730050496000104, -15.644677022999886],
            [29.773251994000077, -15.638062438999981],
            [29.8142830810001, -15.619665628999897],
            [29.83733077000005, -15.614808044999876],
            [29.881772502000047, -15.618838805999957],
            [29.967503702000045, -15.641473083999912],
            [30.010653524000077, -15.646227314999905],
            [30.050237670000115, -15.640129495999943],
            [30.090028523000115, -15.629380797999929],
            [30.13012943500013, -15.623696390999982],
            [30.169920288000128, -15.632171324999973],
            [30.19555179800011, -15.649121194999893],
            [30.207230672000094, -15.653151956999892],
            [30.223147013000073, -15.64974131299995],
            [30.23100183100013, -15.644677022999886],
            [30.24609134900004, -15.632067972999948],
            [30.254876343000035, -15.628864033999974],
            [30.280094442000063, -15.632274677999916],
            [30.29619621200004, -15.639041585999905],
            [30.328050171000086, -15.65242848699998],
            [30.35667891500009, -15.65149831099994],
            [30.396263061000127, -15.63599538099993],
            [30.39771000200011, -15.71681732099998],
            [30.399260295000147, -15.812005309999861],
            [30.401327352000123, -15.931687927999874],
            [30.402567587000135, -16.001244404999866],
            [30.514808797000057, -16.000417582999944],
            [30.586587362000046, -16.000004169999926],
            [30.74972985900007, -15.998867288999918],
            [30.85742354300004, -15.998143818999921],
            [30.901865275000034, -16.007135517999956],
            [30.942172892000144, -16.034524027999908],
            [30.95829594000014, -16.051060485999898],
            [30.973075399000038, -16.06201588999997],
            [30.989766886000098, -16.064289652999904],
            [31.01203942900014, -16.05488454199994],
            [31.023718303000123, -16.045169372999908],
            [31.042218465000133, -16.024912210999986],
            [31.056894572000147, -16.017574157999903],
            [31.06542118300007, -16.019641214999965],
            [31.073327677000066, -16.025532327999954],
            [31.08087243600005, -16.02594573999997],
            [31.089037313000063, -16.011889749999867],
            [31.11410038200006, -15.996903584999885],
            [31.158490438000058, -16.000210875999883],
            [31.259982951000097, -16.023465270999907],
            [31.27889652500005, -16.03028655999995],
            [31.295329630000083, -16.041655374999948],
            [31.309592326000086, -16.059018655999964],
            [31.32835087100011, -16.092815042999945],
            [31.340908244000104, -16.106664326999905],
            [31.360338582000054, -16.11689625999989],
            [31.370260457000086, -16.123717549999938],
            [31.374601278000057, -16.13291595399994],
            [31.37775354000013, -16.14221771199996],
            [31.384006389000035, -16.148832295999867],
            [31.387727092000034, -16.14955576499996],
            [31.395581909000043, -16.147695413999955],
            [31.399612671000057, -16.14728200199994],
            [31.40431522600005, -16.149865823999946],
            [31.404056844000138, -16.154516702999913],
            [31.402713257000073, -16.159374286999935],
            [31.404573609000067, -16.162268167999912],
            [31.424107300000117, -16.164748636999988],
            [31.445708049000075, -16.164955342999946],
            [31.465655151000078, -16.167745869999905],
            [31.48064131700005, -16.177977803999894],
            [31.519191935000038, -16.196477965999918],
            [31.686106811000116, -16.207226663999933],
            [31.710704794000094, -16.21787200899992],
            [31.738196655000138, -16.239782815999973],
            [31.798761434000085, -16.303654886999936],
            [31.818088420000038, -16.31957122799996],
            [31.860049682000067, -16.340758564999916],
            [31.87193526200008, -16.350370381999923],
            [31.880720256000075, -16.36804372099992],
            [31.885629516000108, -16.406284280999913],
            [31.89436283400005, -16.42147715299994],
            [31.910279175000085, -16.428918558999968],
            [32.014148804000115, -16.444938251999915],
            [32.211759481000115, -16.440184020999922],
            [32.290462687000115, -16.451759541999962],
            [32.39366052300005, -16.491757099999944],
            [32.55210046400009, -16.553355407999973],
            [32.671783081000115, -16.599760843999974],
            [32.683100219000096, -16.609889424999935],
            [32.687906128000066, -16.624255472999934],
            [32.68862959800009, -16.647303162],
            [32.69865482600011, -16.68678395599993],
            [32.725216512000145, -16.706420999999878],
            [32.73095033900006, -16.708656220999984],
            [32.73131433100008, -16.70879811599991],
            [32.7398926190001, -16.703217060999904],
            [32.75384525600009, -16.697946064999954],
            [32.769348185000126, -16.69546559599989],
            [32.800664103000145, -16.697325947999985],
            [32.862004028000115, -16.71045176099996],
            [32.89337162200013, -16.712415465999896],
            [32.909598023000115, -16.708074645999915],
            [32.93957035300008, -16.689781188999945],
            [32.95621016400008, -16.683063252999915],
            [32.96850915600004, -16.68161631199993],
            [32.96158451300005, -16.710348408999934],
            [32.93336918200009, -16.815768330999973],
            [32.916212606000045, -16.847911070999913],
            [32.90050297000005, -16.86775482199991],
            [32.82877608300004, -16.935140889999914],
            [32.830119670000045, -16.941548766999944],
            [32.886757040000134, -17.038183694999915],
            [32.92851159600008, -17.10949717199989],
            [32.95414310700005, -17.167168069999946],
            [32.96778568500014, -17.228869729999914],
            [32.96908967500008, -17.266114927999894],
            [32.9694393310001, -17.276101989999944],
            [32.97321171100009, -17.297909443999885],
            [32.98359867300013, -17.317753193999877],
            [32.99238366700013, -17.32467783599995],
            [33.014656209000066, -17.336666768999905],
            [33.021632528000055, -17.345555114999925],
            [33.02245935000008, -17.361471455999947],
            [33.0162581780001, -17.377181090999912],
            [33.01165099000008, -17.383990615999963],
            [32.997447958000066, -17.40498301099997],
            [32.95817386900012, -17.478466897999937],
            [32.95166263900006, -17.48621836399994],
            [32.94298099700006, -17.4915927119999],
            [32.93657312000005, -17.498310648999933],
            [32.93667647300009, -17.50936940499993],
            [32.94721846500005, -17.54316579199991],
            [32.95166263900006, -17.551434020999963],
            [32.96912927200009, -17.564559834999926],
            [33.00664636200008, -17.580992939999902],
            [33.020392294000146, -17.59856292699996],
            [33.02452640800004, -17.61923349999998],
            [33.02059899900007, -17.638457132999903],
            [33.00406254100011, -17.675560810999897],
            [33.00023848500007, -17.713904723999903],
            [33.003184041000054, -17.757726338999916],
            [32.99910160300004, -17.794313251999952],
            [32.9735734460001, -17.81064300499989],
            [32.95703698700004, -17.81798105899989],
            [32.946081584000126, -17.834724222999938],
            [32.939673706000065, -17.855498148999885],
            [32.93688317800013, -17.87503183999989],
            [32.93843347200004, -17.894565530999984],
            [32.95026737500007, -17.922574157999904],
            [32.95212772700006, -17.940247496999902],
            [32.9481486410001, -17.953269957999936],
            [32.94039717600009, -17.95998789499997],
            [32.93243900600004, -17.96494883199992],
            [32.927374716000145, -17.97290700199997],
            [32.92897668400008, -17.982312112999935],
            [32.9412239990001, -17.996264749999924],
            [32.94029382300005, -18.004843037999947],
            [32.93491947400008, -18.024583434999926],
            [32.93708988500009, -18.047114359999938],
            [32.972281535000036, -18.150260517999968],
            [32.97553715000004, -18.183333434999952],
            [32.974865356000066, -18.190774840999964],
            [32.96592533400013, -18.212168883999894],
            [32.95817386900012, -18.22539805099997],
            [32.95228275500011, -18.233046162999955],
            [32.95052575700004, -18.241314391999907],
            [32.95496993000006, -18.25630055699989],
            [32.97016280100007, -18.277487894999936],
            [33.01687829600007, -18.313661396999876],
            [33.03496504700007, -18.332885029999986],
            [33.04276818900013, -18.352005309999882],
            [33.038065633000144, -18.363064066999897],
            [33.0092301840001, -18.383941344999954],
            [32.98819787600007, -18.41319020599991],
            [32.98535567300013, -18.412466735999914],
            [32.986802612000076, -18.42228525799989],
            [32.99951501400005, -18.436651305999888],
            [33.00302901200013, -18.44688323899996],
            [32.99641442900008, -18.467140400999966],
            [32.978586060000055, -18.48005950899997],
            [32.956623576000084, -18.489878030999947],
            [32.93714156100009, -18.501040139999887],
            [32.91931319200006, -18.510031839999925],
            [32.900296265000065, -18.515302835999947],
            [32.88313968900013, -18.522124124999905],
            [32.870737346000055, -18.535766702999908],
            [32.86825687700008, -18.552613219999984],
            [32.87166752100012, -18.573180439999888],
            [32.88448327600008, -18.609043883999917],
            [32.91455896000008, -18.66588795999988],
            [32.9223104240001, -18.693173115999883],
            [32.920243368000115, -18.726246032999967],
            [32.913267049000126, -18.753014423999943],
            [32.90251835100008, -18.774511819999887],
            [32.8852067470001, -18.787844339999907],
            [32.85885176600004, -18.790014749999983],
            [32.81792403200012, -18.78701751699988],
            [32.787641643000086, -18.791254983999934],
            [32.691420125000036, -18.834249775999908],
            [32.689869833000046, -18.843241474999957],
            [32.696794474000114, -18.897191670999916],
            [32.70320235200006, -18.911867776999898],
            [32.715759725000055, -18.919825947999954],
            [32.70506270300007, -18.927474059999938],
            [32.69224694900009, -18.934295348999896],
            [32.682531779000044, -18.942666930999877],
            [32.68108483900005, -18.954965921999914],
            [32.68862959800009, -18.97729013999988],
            [32.69028324400006, -18.988245543999952],
            [32.68862959800009, -19.000957946999904],
            [32.69105839000014, -19.014290465999935],
            [32.69896488400008, -19.02224863699989],
            [32.71028202300005, -19.025969339999904],
            [32.72387292500008, -19.02658945699997],
            [32.78598799600013, -19.01770111099995],
            [32.80335127800004, -19.019561461999956],
            [32.81420332900012, -19.023798929999913],
            [32.81999108800005, -19.02834645599995],
            [32.82298832200007, -19.03516774499991],
            [32.82526208500008, -19.046846618999965],
            [32.83022302200004, -19.059145608999913],
            [32.838129517000084, -19.06689707499993],
            [32.84748295100013, -19.073925068999927],
            [32.85590621000006, -19.083743591999905],
            [32.862262411000074, -19.118056741999922],
            [32.83322025500007, -19.241976826999903],
            [32.83218672700008, -19.266678161],
            [32.82867273000005, -19.284558206999876],
            [32.820714559000066, -19.30130137099991],
            [32.80614180500004, -19.32341888399992],
            [32.76883142100007, -19.36362314899995],
            [32.76645430500014, -19.37344167099991],
            [32.768521362000115, -19.402793883999976],
            [32.762216838000086, -19.44341155999993],
            [32.763353719000065, -19.46397877999992],
            [32.77394738800007, -19.475864359999946],
            [32.79311934400005, -19.47669118199987],
            [32.81130944800009, -19.474520772999966],
            [32.82536543800012, -19.479171651999934],
            [32.83218672700008, -19.50087575299993],
            [32.83249678600009, -19.51927256299993],
            [32.82536543800012, -19.5916195679999],
            [32.82567549600009, -19.600817971999987],
            [32.828155965000064, -19.61063649499995],
            [32.82960290500006, -19.623658954999897],
            [32.82536543800012, -19.633270771999918],
            [32.819474324000055, -19.64195241299997],
            [32.81627038500005, -19.652080993999917],
            [32.819629354000085, -19.67430185899987],
            [32.8310498460001, -19.68515390999991],
            [32.8491365970001, -19.689081318999882],
            [32.87218428600005, -19.690218200999894],
            [32.89471521000007, -19.68432708799989],
            [32.9245841880001, -19.65528493299989],
            [32.94318770400014, -19.649290466999958],
            [32.960964396000065, -19.658798929999946],
            [32.96241133700005, -19.67905609099995],
            [32.95414310700005, -19.71781341499988],
            [32.96241133700005, -19.73538340199987],
            [32.979051147000064, -19.751403095999905],
            [33.00060022000014, -19.764322204999914],
            [33.02276940900009, -19.773107197999906],
            [33.03279463700011, -19.784165953999917],
            [33.02964237500004, -19.803389586999927],
            [33.02287276200008, -19.826850687999908],
            [33.0213224690001, -19.868088479999912],
            [33.001995483000144, -19.92699961299992],
            [32.99837813300013, -20.0008969109999],
            [33.00437259900008, -20.024254658999936],
            [33.007266480000055, -20.032006123999864],
            [32.953729695000106, -20.03024912499997],
            [32.940087117000076, -20.041514586999938],
            [32.93429935700004, -20.072107034999945],
            [32.926547892000144, -20.086473082999944],
            [32.910683227000106, -20.091123961999912],
            [32.894405151000115, -20.0940178419999],
            [32.88531010000014, -20.10300954199994],
            [32.877868693000096, -20.15168874099996],
            [32.87290775500014, -20.16719167099997],
            [32.859265177000054, -20.19085947699992],
            [32.857094767000035, -20.20057464599995],
            [32.858335001000114, -20.207499287999937],
            [32.86505293800013, -20.22093516099997],
            [32.86556970200007, -20.228893330999938],
            [32.85843835400004, -20.25948577899996],
            [32.85296065300014, -20.27385182699996],
            [32.84520918700014, -20.286667581999936],
            [32.800767456000074, -20.338550719999944],
            [32.73586185700009, -20.4142050169999],
            [32.704442587000074, -20.47177256299993],
            [32.671783081000115, -20.531820576999863],
            [32.64646163000015, -20.557968850999956],
            [32.60367354300007, -20.564790140999918],
            [32.556544637000115, -20.559312438999925],
            [32.5131364340001, -20.564583434999946],
            [32.481613810000056, -20.60303070099991],
            [32.4710718180001, -20.64550872799994],
            [32.46910811300006, -20.686849873999876],
            [32.48347416100006, -20.794233499999862],
            [32.49722009300007, -20.898103128999963],
            [32.49101892100009, -20.936343688999955],
            [32.46766117300007, -20.98016530299988],
            [32.41712162200008, -21.040936787999982],
            [32.33981368000008, -21.134057718999983],
            [32.34534305800008, -21.14284271199996],
            [32.359864136000056, -21.151421],
            [32.36885583500009, -21.16299652099994],
            [32.373351685000046, -21.163616637999922],
            [32.37774418200013, -21.16340993199995],
            [32.38063806100007, -21.165476989999917],
            [32.380534709000074, -21.172194925999946],
            [32.37686568200007, -21.17849945099995],
            [32.37298995000009, -21.18397715199994],
            [32.37174971500008, -21.187904561999915],
            [32.444613485000104, -21.30469329799986],
            [32.44584926100009, -21.308993799999968],
            [32.44719730600008, -21.3136849979999],
            [32.408543335000104, -21.290327250999937],
            [32.37298995000009, -21.327947692999956],
            [32.32451745600014, -21.378177184999913],
            [32.27222090600014, -21.43254079099998],
            [32.2197176520001, -21.48690439899987],
            [32.16731774900006, -21.541268005999925],
            [32.114814494000086, -21.595631611999906],
            [32.06241459100005, -21.649995218999962],
            [32.010014689000116, -21.704462177999872],
            [31.95761478600008, -21.758825784999942],
            [31.905214885000134, -21.813189391999913],
            [31.852711629000055, -21.86755299899997],
            [31.80031172700012, -21.92201995799988],
            [31.74780847100004, -21.976383565999953],
            [31.695511922000037, -22.03074717199992],
            [31.643112019000114, -22.08521413199992],
            [31.590712117000066, -22.13957773899999],
            [31.53820886200009, -22.193941344999956],
            [31.485808960000043, -22.248304951999927],
            [31.433822469000063, -22.30204844199993],
            [31.36871016400005, -22.345043232999913],
            [31.288921753000068, -22.39733978299992],
            [31.265615682000146, -22.365507099999974],
            [31.255642130000126, -22.357962340999933],
            [31.24572025600014, -22.357548929999922],
            [31.229597209000076, -22.363956806999866],
            [31.22153568500005, -22.364886982999906],
            [31.213474162000068, -22.361889749999904],
            [31.197867879000057, -22.352587991999968],
            [31.190684855000086, -22.350624287999935],
            [31.1836568600001, -22.345559997999956],
            [31.16334802300014, -22.32261566199992],
            [31.15259932500004, -22.31641448899994],
            [31.13771651200011, -22.318481546999905],
            [31.104540243000088, -22.333364359999948],
            [31.097047967000037, -22.334922385999974],
            [31.087642049000067, -22.3368783559999],
            [31.070330444000092, -22.33367441799993],
            [31.036120646000086, -22.319618427999913],
            [30.927186727000105, -22.29574391599992],
            [30.867087036000044, -22.28964609699996],
            [30.837889852000046, -22.28230804399996],
            [30.805282023000075, -22.294503681999885],
            [30.693919311000116, -22.302771910999937],
            [30.67428226700008, -22.3085596719999],
            [30.647410523000076, -22.326439717999875],
            [30.632424357000104, -22.330677184999914],
            [30.625551391000045, -22.32861012799995],
            [30.610306844000092, -22.31868825199996],
            [30.601108439000086, -22.31641448899994],
            [30.572169637000115, -22.3166211959999],
            [30.507367391000116, -22.309593200999885],
            [30.488453817000106, -22.31021331699995],
            [30.46923018400014, -22.315070901999974],
            [30.431713094000145, -22.331193949999957],
            [30.412696167000092, -22.3368783559999],
            [30.37207849100008, -22.343492939999905],
            [30.334974813000088, -22.34473317499993],
            [30.300765014000092, -22.336981709999932],
            [30.269345744000134, -22.31641448899994],
            [30.255289755000035, -22.30473561599996],
            [30.240406942000106, -22.296157327999936],
            [30.22170007300008, -22.290886332],
            [30.196998738000104, -22.289129333999924],
            [30.152660359000038, -22.29481374099997],
            [30.135090373000082, -22.293573506999934],
            [30.111112508000076, -22.28230804399996],
            [30.082587117000116, -22.262877705999898],
            [30.067911011000035, -22.25708994499992],
            [30.03814538500012, -22.25378265399992],
            [30.035871623000105, -22.25057871499986],
            [30.03452803500005, -22.246134541999936],
            [30.0155111090001, -22.22701426099995],
            [30.005279175000112, -22.22226002999996],
            [29.98378177900014, -22.21771250399992],
            [29.973963257000094, -22.213991800999906],
            [29.94667810100009, -22.19828216599994],
            [29.932105347000117, -22.194354755999967],
            [29.896035197000117, -22.191357523999955],
            [29.87148889200006, -22.179265238999875],
            [29.83733077000005, -22.172443948999927],
            [29.77924646000008, -22.136373798999927],
            [29.758885946000134, -22.130896097999937],
            [29.691448201000128, -22.134100035999907],
            [29.679614298000104, -22.13833750399995],
            [29.661424194000062, -22.126451924999927],
            [29.64106368000006, -22.129242451999886],
            [29.603960001000075, -22.14505543999988],
            [29.57016361500007, -22.141954853999934],
            [29.551043335000088, -22.145985615999933],
            [29.542516724000052, -22.162522073999924],
            [29.531819703000053, -22.172443948999927],
            [29.506911662000107, -22.17006683299988],
            [29.456888875000118, -22.15880137099991],
            [29.436114949000057, -22.163142190999892],
            [29.399528036000106, -22.18215911799996],
            [29.378030640000077, -22.192907815999973],
            [29.363251180000077, -22.19228769999991],
            [29.356946656000048, -22.19094411199994],
            [29.350073689000055, -22.186706644999987],
            [29.273644246000117, -22.125108336999872],
            [29.2673397210001, -22.115806578999937],
            [29.259588257000075, -22.096066182999962],
            [29.254110555000125, -22.087074482999924],
            [29.244395386000065, -22.07570566799994],
            [29.239331095000068, -22.072605081999896],
            [29.1448665770001, -22.07529225699993],
            [29.10796960400009, -22.06919443699988],
            [29.07076257300008, -22.051004332999923],
            [29.040531861000062, -22.020928648999956],
            [29.021566609000104, -21.982791442999897],
            [29.01381514500011, -21.94041676899988],
            [29.01794925900012, -21.89814544699989],
            [29.028904663000105, -21.87664805099986],
            [29.045441121000096, -21.852566833999916],
            [29.057636759000104, -21.829209085999963],
            [29.055259643000085, -21.809985453999943],
            [29.038723186000084, -21.797893167999945],
            [28.998725626000095, -21.786007588999922],
            [28.980845581000068, -21.774845478999893],
            [28.951906779000097, -21.76833424899992],
            [28.89103194200004, -21.764923603999904],
            [28.86085290500006, -21.75737884499995],
            [28.714195190000112, -21.69350677499999],
            [28.66840987200007, -21.679967549999915],
            [28.629704224000136, -21.651338805999927],
            [28.615699911000036, -21.647101337999885],
            [28.585934285000064, -21.644414163999954],
            [28.55399825100008, -21.636559346999917],
            [28.542939493000063, -21.638316344999893],
            [28.532500855000137, -21.643070576999975],
            [28.49730920400006, -21.6515455119999],
            [28.481392863000053, -21.65743662499999],
            [28.464598023000093, -21.660330504999976],
            [28.443100627000035, -21.65578297999994],
            [28.36176192200014, -21.61630218499991],
            [28.321919393000115, -21.603486429999933],
            [28.284867391000063, -21.59687184699993],
            [28.165701538000064, -21.59521819999989],
            [28.09077071100012, -21.581265563999892],
            [28.032893107000092, -21.57785491899996],
            [28.016563355000045, -21.572893981999925],
            [28.00255904100004, -21.564212341999863],
            [27.99041507900006, -21.55191334999992],
            [27.984730673000087, -21.542921650999887],
            [27.975738973000148, -21.52256113699994],
            [27.97057133000007, -21.514396259999927],
            [27.963698365000084, -21.51046885199996],
            [27.958065633000047, -21.51150237999994],
            [27.953208048000135, -21.51046885199996],
            [27.94928063900008, -21.500753681999925],
            [27.954448282000072, -21.487834573999905],
            [27.950417521000077, -21.48204681399993],
            [27.943337850000063, -21.47987640399994],
            [27.93987552900012, -21.478016051999944],
            [27.941942586000067, -21.468507587999866],
            [27.94964237500008, -21.456518655999986],
            [27.953001343000068, -21.448663838999963],
            [27.95021081500002, -21.43832855199996],
            [27.920548543000052, -21.38117441799993],
            [27.90421879100012, -21.364741311999964],
            [27.897810913000086, -21.355439554999933],
            [27.896157267000035, -21.347894794999974],
            [27.896674032000078, -21.33239186599988],
            [27.894400269000073, -21.324330342999886],
            [27.884995158000095, -21.310171],
            [27.849131714000066, -21.26965667699993],
            [27.82360355600011, -21.231726175999924],
            [27.79383793100004, -21.197413023999985],
            [27.724384807000064, -21.14966400099992],
            [27.709191935000035, -21.13447113],
            [27.674775431000086, -21.090132751999946],
            [27.666610555000148, -21.071219176999918],
            [27.66681726100012, -21.053752542999874],
            [27.67896122200011, -21.000732522999954],
            [27.680356486000107, -20.979648538999925],
            [27.672656697, -20.923527932999974],
            [27.672605021000095, -20.913709410999914],
            [27.675085490000072, -20.89128183999992],
            [27.674775431000086, -20.879913024999937],
            [27.676015666000126, -20.86668385799993],
            [27.6818034260001, -20.857588805999868],
            [27.68903812600007, -20.849010518999933],
            [27.69441247600011, -20.837745055999875],
            [27.709605346000046, -20.756716409999868],
            [27.70733158300004, -20.7167188519999],
            [27.682475219000082, -20.63734385199993],
            [27.690381713000107, -20.60148040699997],
            [27.702629028000047, -20.56613372799997],
            [27.705574585000136, -20.52665293299995],
            [27.698133179000138, -20.509082946999882],
            [27.68376713100011, -20.496060485999934],
            [27.665990438000108, -20.489135843999946],
            [27.62578617400007, -20.48861907999992],
            [27.590852905000077, -20.473322855999953],
            [27.534112183000076, -20.4830380249999],
            [27.453910359000076, -20.473322855999953],
            [27.340738973000043, -20.473012796999882],
            [27.306012411000097, -20.47735361699995],
            [27.26839196700007, -20.49575042799995],
            [27.28399825000011, -20.35146982799995],
            [27.266014852000126, -20.23416432699989],
            [27.214906861000117, -20.110450947999965],
            [27.201781047000082, -20.09298431399992],
            [27.183745971000064, -20.08233896899992],
            [27.16292037000011, -20.076551207999955],
            [27.141888062000106, -20.07334726899998],
            [27.12969242300008, -20.07293385799997],
            [27.119770548000076, -20.073864033999925],
            [27.10964196800012, -20.073243916999957],
            [27.097342977000096, -20.068903096999875],
            [27.08649092600004, -20.06053151499991],
            [27.069230997000147, -20.03738047199991],
            [27.060135946000088, -20.027561949999935],
            [27.02664961700009, -20.010095316999895],
            [26.994300171000106, -20.006788024999906],
            [26.961072225000066, -20.007201435999917],
            [26.925053752000082, -20.0008969109999],
            [26.811882365000116, -19.94642995199999],
            [26.77446862800008, -19.939815368999902],
            [26.750800822000116, -19.939608662999944],
            [26.730957072000137, -19.935887958999928],
            [26.713903850000094, -19.927413024999936],
            [26.698607625000136, -19.912530211999893],
            [26.684758341000077, -19.89454681399991],
            [26.67716996900009, -19.886815264999953],
            [26.67380293700012, -19.88338470499987],
            [26.65943688900012, -19.87573659199998],
            [26.614064982000087, -19.863437600999944],
            [26.59556481900006, -19.85558278399992],
            [26.581922241000143, -19.842146911999876],
            [26.574790893000113, -19.81951263399992],
            [26.566315958000104, -19.800805764999936],
            [26.549262736000088, -19.784062600999974],
            [26.508851766000106, -19.759257913999946],
            [26.489731486000096, -19.751919860999948],
            [26.450250692000083, -19.743341572999924],
            [26.43185388200007, -19.736520283999965],
            [26.412836955000103, -19.71957041399996],
            [26.38524174000011, -19.67905609099995],
            [26.3627108150001, -19.66758392299994],
            [26.33232507300005, -19.66241627999993],
            [26.324366903000083, -19.659108988999932],
            [26.312171264000142, -19.65135752299993],
            [26.312481323000043, -19.64960052499994],
            [26.319095906000143, -19.646293232999952],
            [26.326330607000102, -19.63389088999989],
            [26.333461955000132, -19.613013610999914],
            [26.33098148600007, -19.604952086999916],
            [26.321059611000067, -19.59203297899991],
            [26.313204793000125, -19.584178161999972],
            [26.303489624000093, -19.5772535199999],
            [26.292637573000064, -19.572499287999904],
            [26.239100789000105, -19.57146575899992],
            [26.19445235200007, -19.56020029699995],
            [26.155488322000082, -19.537152608999904],
            [26.13027022300014, -19.501082458999903],
            [26.034358765000064, -19.243733824999964],
            [26.011414429000126, -19.19980885799994],
            [25.9811320390001, -19.161775003999907],
            [25.956534058000045, -19.12208750399992],
            [25.94857588700006, -19.103277282999912],
            [25.944855184000062, -19.079196064999877],
            [25.94805912300012, -19.058732197999902],
            [25.964388875000054, -19.021628519999922],
            [25.967799520000085, -19.000957946999904],
            [25.967448582000088, -18.999925225999988],
            [25.94072106900012, -18.921272887999947],
            [25.81525069100013, -18.813992614999904],
            [25.779490601000106, -18.738751728999958],
            [25.77339278200006, -18.665577900999978],
            [25.761920613000143, -18.630334574999907],
            [25.736909220000143, -18.608733825999934],
            [25.698255249000056, -18.590233662999907],
            [25.669523153000057, -18.566049091999943],
            [25.622084188000144, -18.5011434929999],
            [25.608441610000057, -18.487707620999956],
            [25.574438518000107, -18.465693460999972],
            [25.508499390000082, -18.399134215999894],
            [25.495580281000088, -18.37887705499989],
            [25.49051599100011, -18.36554453499987],
            [25.48116255700006, -18.323376565999908],
            [25.473204386000106, -18.303429462999887],
            [25.440854939000104, -18.253199971999933],
            [25.408815552000107, -18.175995381999954],
            [25.387524861000117, -18.138995055999914],
            [25.357449178000138, -18.11584401399992],
            [25.323446086000104, -18.096620381999898],
            [25.296367635000138, -18.06861175599998],
            [25.255026489000016, -18.00112233499995],
            [25.226087687000074, -17.931875914999935],
            [25.219369751000045, -17.908001403999947],
            [25.219369751000045, -17.879786071999973],
            [25.259780721000112, -17.794106546999984],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Chad',
        iso3: 'TCD',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [14.0649084880001, 13.077988383000061],
            [13.836111084000123, 13.391044210000018],
            [13.607313680000061, 13.704100037000075],
            [13.600182332000117, 13.735984396000049],
            [13.592947632000062, 13.767842916000092],
            [13.585816284000117, 13.799727275000066],
            [13.578581583000044, 13.831534119000096],
            [13.571450236000118, 13.86341847800007],
            [13.564318889000077, 13.895225321000098],
            [13.557187541000133, 13.927161357000088],
            [13.549952840000088, 13.958994039000032],
            [13.542821493000133, 13.99085255900009],
            [13.535690145000103, 14.02273691800005],
            [13.528455444000116, 14.05451792400008],
            [13.521324097000104, 14.086428121000054],
            [13.514192749000074, 14.118234965000099],
            [13.506958048000087, 14.150119324000059],
            [13.499723348000117, 14.18197784500012],
            [13.492695353000016, 14.21386220400008],
            [13.482256713000083, 14.259776713000065],
            [13.468304077000084, 14.310677999000092],
            [13.449183797000103, 14.380131124000059],
            [13.449493855000071, 14.439042257000068],
            [13.482256713000083, 14.483587341000074],
            [13.507784872000116, 14.495963847000041],
            [13.543855021000127, 14.510562439000097],
            [13.584369344000038, 14.513818054000083],
            [13.608052035000128, 14.518266228000059],
            [13.62426355000008, 14.521311137000026],
            [13.657853231000104, 14.548725484000073],
            [13.665604695000098, 14.566889751000105],
            [13.666741577000096, 14.58551910400007],
            [13.660333699000148, 14.623733826000134],
            [13.657026407000075, 14.629650777000052],
            [13.64627770900006, 14.639055888000101],
            [13.644727417000126, 14.644249369000121],
            [13.648344767000111, 14.649417013000033],
            [13.668085165000065, 14.662878723000077],
            [13.700021199000048, 14.697734477000054],
            [13.709994751000067, 14.705124207000068],
            [13.730045206000113, 14.709645895000094],
            [13.749165486000095, 14.711247864000114],
            [13.764358358000038, 14.719076843000053],
            [13.773246704000144, 14.74251210600002],
            [13.772006469000104, 14.762872620000053],
            [13.75795048000009, 14.805531514000052],
            [13.753919718000105, 14.82594370600009],
            [13.755159952000042, 14.847208558000062],
            [13.760534302000082, 14.866354675000068],
            [13.77541711400005, 14.897438049000115],
            [13.808076619000104, 14.965573426000034],
            [13.833914836000133, 15.019601136000105],
            [13.862956991000118, 15.059056092000034],
            [13.892825968000125, 15.099699605000069],
            [13.922591593000021, 15.140498149000052],
            [13.95256392400006, 15.181219177000116],
            [13.98232954900007, 15.221991882000097],
            [14.012198527000066, 15.262687073000052],
            [14.042067505000091, 15.303433940000033],
            [14.071833130000073, 15.344180806000097],
            [14.101702108000097, 15.384875997000051],
            [14.131571085000104, 15.425545350000107],
            [14.161440063000015, 15.46629221600007],
            [14.19120568800011, 15.507039083000038],
            [14.221178019000149, 15.547734274],
            [14.250943644000131, 15.58845530300006],
            [14.280709269000113, 15.629253846000054],
            [14.310681600000066, 15.669949036],
            [14.340447225000048, 15.710721741],
            [14.368972615000104, 15.749634095000076],
            [14.423542928000131, 15.806323141000078],
            [14.48214400200007, 15.867249654000105],
            [14.520797973000072, 15.907557272000062],
            [14.576918579000107, 15.96579661],
            [14.633142537000083, 16.024242655000066],
            [14.689263143000119, 16.08253367100012],
            [14.74538374800008, 16.14087636400008],
            [14.801401001000102, 16.199219056000018],
            [14.85741825300002, 16.25761342400007],
            [14.913538859000084, 16.315904439000022],
            [14.969659464000102, 16.374247131000075],
            [15.025780070000081, 16.432538148],
            [15.081797322000085, 16.49088083900007],
            [15.137917928000121, 16.549275208000026],
            [15.194038534000072, 16.607566223000063],
            [15.250159139000118, 16.66590891500003],
            [15.306279745000069, 16.724199931000058],
            [15.362400350000115, 16.78264597600004],
            [15.418417603000137, 16.84088531500005],
            [15.452420695000086, 16.876231994000065],
            [15.465546509000148, 16.894680481000066],
            [15.468517058000089, 16.904909712000105],
            [15.471954386000107, 16.91674631800008],
            [15.474124797000087, 16.942067770000065],
            [15.478258911000097, 16.987698059000067],
            [15.48228967300011, 17.033276672000042],
            [15.486217082000081, 17.07890696300005],
            [15.490247843000077, 17.124537252000025],
            [15.494278605000147, 17.170115866000017],
            [15.498309367000047, 17.215746155000105],
            [15.502340128000043, 17.26137644400002],
            [15.506370891000131, 17.30705841100003],
            [15.510505005000084, 17.352637024],
            [15.51453576600008, 17.39826731300009],
            [15.518566529000054, 17.443845927],
            [15.52259729000005, 17.4895278930001],
            [15.526628051000046, 17.535106507000094],
            [15.530658814000049, 17.580736796000096],
            [15.53468957500013, 17.626367086000087],
            [15.5386169840001, 17.672049052000105],
            [15.542647746000114, 17.717679342000096],
            [15.546781860000124, 17.763309631000098],
            [15.550812622000109, 17.808888245000063],
            [15.554843384000037, 17.85457021100008],
            [15.558874145000118, 17.900148825000073],
            [15.562904907000103, 17.945779114000075],
            [15.566935669000088, 17.991409403000077],
            [15.567697927000012, 18.00003856000005],
            [15.570966430000084, 18.037039694000057],
            [15.574997192000097, 18.08264414500006],
            [15.579027954000082, 18.128248597000052],
            [15.58316206800012, 18.173878886000054],
            [15.587192831000095, 18.21948333800013],
            [15.591120239000077, 18.26508778900002],
            [15.595151001000062, 18.310718079000125],
            [15.599181763000075, 18.35634836900003],
            [15.603212524000071, 18.402004496000032],
            [15.607243286000141, 18.447583110000025],
            [15.611274048000041, 18.493239238000015],
            [15.615304810000055, 18.538817851000104],
            [15.619438924000065, 18.584473979],
            [15.623469686000078, 18.630078430000097],
            [15.627500447000074, 18.67570872],
            [15.631531209000059, 18.72131317100009],
            [15.635561971000044, 18.76694346200007],
            [15.639592733000143, 18.8125995890001],
            [15.643520141000096, 18.858178203000065],
            [15.647550904000099, 18.903834331000084],
            [15.651581665000094, 18.94938710600006],
            [15.655715779000019, 18.995069072000078],
            [15.659746541000118, 19.040647685000053],
            [15.663777303000103, 19.08630381300007],
            [15.667808064000099, 19.131882426000047],
            [15.671838827000101, 19.177538554000037],
            [15.675869588000097, 19.223168844000057],
            [15.679900349000093, 19.268747457000032],
            [15.683931112000096, 19.31440358500005],
            [15.687961873000091, 19.360008036000025],
            [15.69209598800012, 19.40563832700012],
            [15.69602339700009, 19.451242778],
            [15.700054158000086, 19.496873068000113],
            [15.70408492100006, 19.542529196000103],
            [15.708115682000056, 19.58810780800009],
            [15.712146443000051, 19.633763937000097],
            [15.716177206000054, 19.679316712000073],
            [15.720207967000135, 19.72499867800009],
            [15.72434208100006, 19.770577291000066],
            [15.728372844000148, 19.816259257000084],
            [15.732403605000059, 19.861837871000077],
            [15.736020955000129, 19.903540751000023],
            [15.767233521000037, 19.98203725200004],
            [15.78232303800013, 20.008030498],
            [15.82232059800009, 20.07699269700005],
            [15.862318156000072, 20.145954896000077],
            [15.902419067000068, 20.214942932000028],
            [15.942519979000053, 20.28395680800007],
            [15.9629838460001, 20.31922597300006],
            [15.970321899000112, 20.3363308710001],
            [15.96815149000011, 20.352815654000082],
            [15.953992147000065, 20.374571432],
            [15.93032434100013, 20.39932444300011],
            [15.872033325000103, 20.460199280000055],
            [15.81384566300008, 20.521074117000083],
            [15.755554647000054, 20.582000631000042],
            [15.697263631000112, 20.6428754680001],
            [15.669461711000054, 20.671865946000068],
            [15.588123006000075, 20.732792460000027],
            [15.570242961000105, 20.751912740000122],
            [15.55608361800006, 20.773668519000026],
            [15.544198039000037, 20.798989970000022],
            [15.536033162000109, 20.844051819000057],
            [15.544301391000147, 20.890302226000117],
            [15.569002727000054, 20.928904521],
            [15.609310343000118, 20.950660299000035],
            [15.592773885000042, 20.974793192000064],
            [15.576134073000105, 20.999339498000055],
            [15.559287556000129, 21.02378245000007],
            [15.542544393000071, 21.048277079000044],
            [15.525801229000109, 21.072771709000094],
            [15.50905806500009, 21.09726633700005],
            [15.492211548000085, 21.12176096600011],
            [15.475571737000081, 21.146255595000056],
            [15.45882857200013, 21.170750224000116],
            [15.441982055000068, 21.195193177000064],
            [15.42534224400012, 21.219791158000035],
            [15.408495727000059, 21.24423411100007],
            [15.391752564000114, 21.268728739000053],
            [15.375009400000067, 21.293223369000103],
            [15.358266235000116, 21.31771799800005],
            [15.341419719000044, 21.342160950000093],
            [15.324779907000107, 21.366707255000065],
            [15.301008748000044, 21.401330465000072],
            [15.266592245000083, 21.440656230000045],
            [15.247471965000102, 21.453265280000082],
            [15.200239706000076, 21.476467998000075],
            [15.184530070000108, 21.49119578000007],
            [15.18039595500008, 21.50726715100005],
            [15.180085897000083, 21.533467102000074],
            [15.179775838000097, 21.553207500000028],
            [15.178845662000072, 21.60529734300009],
            [15.177502075000092, 21.678987936000013],
            [15.176055135000098, 21.763427226000047],
            [15.174608195000104, 21.847918193000012],
            [15.173264607000135, 21.921557109000034],
            [15.172437785000113, 21.973646952000067],
            [15.172024373000113, 21.993387350000134],
            [15.164479614000044, 22.033694967000073],
            [15.156314738000049, 22.076172994000032],
            [15.148149861000036, 22.118651022000066],
            [15.136057576000042, 22.1813345340001],
            [15.12406864500008, 22.243966370000024],
            [15.11207971200011, 22.306598206000032],
            [15.099987427000116, 22.369281718000067],
            [15.087998495000079, 22.431913554000076],
            [15.075906210000085, 22.4945970670001],
            [15.064020630000073, 22.55717722600012],
            [15.051928345000078, 22.61986073900006],
            [15.039939413000099, 22.682544251000067],
            [15.027950480000072, 22.745176087000104],
            [15.015858195000078, 22.80778208400001],
            [15.003972616000055, 22.87043975800013],
            [14.991983683000086, 22.93309743300007],
            [14.979909027000133, 22.995663760000085],
            [14.997461385000065, 23.00381663000006],
            [15.055235636000077, 23.029964905000085],
            [15.112906535000036, 23.056113180000082],
            [15.170370728000137, 23.08226145400009],
            [15.228144979000149, 23.10835805200007],
            [15.285815878000108, 23.13445465200006],
            [15.343486775000088, 23.160577087000078],
            [15.401157674000075, 23.186751201000064],
            [15.45882857200013, 23.21289947600009],
            [15.516499471000088, 23.239047750000097],
            [15.5742737220001, 23.265196025000094],
            [15.63194462100006, 23.2913443],
            [15.689615520000132, 23.317518412000098],
            [15.747183064000069, 23.34364084900001],
            [15.804853963000141, 23.369789124000093],
            [15.862524862000015, 23.395937398000015],
            [15.920195760000098, 23.4220339970001],
            [15.964637492000065, 23.44221364400009],
            [15.985101359000112, 23.444719951000067],
            [16.076155233000065, 23.399632264000033],
            [16.19976525900006, 23.338705750000074],
            [16.323168579000082, 23.277727560000088],
            [16.446778605000077, 23.216723532000017],
            [16.570285278000114, 23.155719503000043],
            [16.693791951000065, 23.09466379900006],
            [16.81729862500012, 23.033659770000085],
            [16.94090865000004, 22.972733256000126],
            [17.064311971000052, 22.911755067000072],
            [17.187921997000046, 22.85075103800007],
            [17.3114286710001, 22.789798686000026],
            [17.434831991000124, 22.72879465800004],
            [17.5584420160001, 22.667764791000067],
            [17.68194869000007, 22.60678660100008],
            [17.805455363000107, 22.545756734000022],
            [17.928962036000087, 22.484778545000054],
            [18.05246870900004, 22.423852031000095],
            [18.175975383000093, 22.36282216500011],
            [18.29958540800007, 22.30184397400005],
            [18.42298872800012, 22.240865784000064],
            [18.546598755000105, 22.17983591700009],
            [18.670105428000056, 22.11880605100002],
            [18.79361210100012, 22.057879537000062],
            [18.917118774000073, 21.996849671000078],
            [19.040728801000057, 21.935871481],
            [19.16413212100008, 21.87489329000003],
            [19.185837030000073, 21.864177059000056],
            [19.287638793000042, 21.813915100000074],
            [19.411145467000097, 21.75288523400009],
            [19.53465214000005, 21.691855367000088],
            [19.658262166000043, 21.630877178000034],
            [19.781665486000065, 21.56989898700006],
            [19.90527551300005, 21.508869121000075],
            [20.028782186000115, 21.44794260700003],
            [20.152288859000066, 21.386912741000046],
            [20.27579553200013, 21.32593455000007],
            [20.399405558000126, 21.265008036000026],
            [20.522808879000138, 21.203926493000026],
            [20.646418904000114, 21.14289662700004],
            [20.769925578000084, 21.081970113000082],
            [20.893328898000107, 21.020940247000013],
            [21.0169389240001, 20.959962057000055],
            [21.140342244000124, 20.899035543000096],
            [21.263952270000118, 20.838005677000112],
            [21.387458944000088, 20.77702748600005],
            [21.510965617000124, 20.716049296000065],
            [21.634472290000105, 20.654967754000083],
            [21.75808231600007, 20.593989563000022],
            [21.88148563700011, 20.533063049000063],
            [22.005095662000087, 20.47203318300008],
            [22.128602335000068, 20.411054992000103],
            [22.252109009, 20.35007680300005],
            [22.375615682000074, 20.289124451000063],
            [22.49912235500011, 20.22809458400009],
            [22.62262902800009, 20.16709055600002],
            [22.746135702000032, 20.106060690000035],
            [22.869642375000097, 20.045108338000077],
            [22.993149047000145, 19.984104309000102],
            [23.11675907400013, 19.923151958000048],
            [23.240162394000066, 19.862096253000047],
            [23.363772420000146, 19.801169739],
            [23.487279093000012, 19.740165710000028],
            [23.610785767000067, 19.67911000600013],
            [23.734292440000047, 19.61813181600006],
            [23.857799113000084, 19.5571794640001],
            [23.981305786000036, 19.496123759000014],
            [23.981512492000093, 19.263838196000094],
            [23.981719197000047, 19.03155263300009],
            [23.981925903000104, 18.799292908000083],
            [23.982132609000075, 18.567033183000078],
            [23.98223596200009, 18.33479929700006],
            [23.982442668000147, 18.102513733000066],
            [23.98275272600003, 17.870228170000033],
            [23.982856079000072, 17.637942607000028],
            [23.98306278400011, 17.405657044000023],
            [23.983269491000073, 17.173371481000103],
            [23.98347619600014, 16.94113759400001],
            [23.983682902000083, 16.708800355000065],
            [23.983786255000012, 16.47651479100007],
            [23.98399296000008, 16.244229228000037],
            [23.984303019000066, 16.011943665000032],
            [23.98440637200008, 15.779658102000027],
            [23.98440637200008, 15.721939934000048],
            [23.98440637200008, 15.721160381000018],
            [23.972624146000072, 15.69108469700005],
            [23.945545695000135, 15.692221579000076],
            [23.829067017000085, 15.731030579],
            [23.707524048000067, 15.748858948000063],
            [23.59269901600007, 15.749013977000104],
            [23.52706994600004, 15.735164694000034],
            [23.395811808000076, 15.688345846000018],
            [23.320570923000105, 15.681317851000088],
            [23.16678186000013, 15.712943827000103],
            [23.119249041000103, 15.707223545000105],
            [23.094641561000117, 15.704262187000026],
            [23.06849328600012, 15.686692199000063],
            [23.004517863000046, 15.611425476000093],
            [22.9256596270001, 15.563934835000012],
            [22.90674605300009, 15.541403911000074],
            [22.899511353, 15.510191346000013],
            [22.906849406000106, 15.481407572000094],
            [22.923592570000068, 15.455569356000055],
            [22.944986613000083, 15.433115947000076],
            [22.966484008000094, 15.404823100000073],
            [22.976405884000116, 15.373636373000096],
            [22.978369588000135, 15.340201722000117],
            [22.965657186000072, 15.223903910000018],
            [22.958009074000103, 15.201631368000065],
            [22.913257283000064, 15.121687928000142],
            [22.90550581900004, 15.112567037000062],
            [22.871606079000117, 15.099699605000069],
            [22.848765096000108, 15.08750396700006],
            [22.82902469900006, 15.071639302000051],
            [22.738901001000073, 14.979810283000091],
            [22.72722212700009, 14.959036357000059],
            [22.721951132000072, 14.934670919000041],
            [22.721020956000103, 14.915938212000043],
            [22.715336548000067, 14.899427592000052],
            [22.69549279800009, 14.881470032000081],
            [22.658905883000045, 14.857414653000134],
            [22.650844361000054, 14.841937561000037],
            [22.650844361000054, 14.816151022000028],
            [22.65900923600006, 14.761270650000114],
            [22.66459029100008, 14.743752340000057],
            [22.679679809000078, 14.711816305000085],
            [22.681436808000058, 14.70292795800006],
            [22.676579224000136, 14.688975322000076],
            [22.666347290000147, 14.681740622000106],
            [22.465429321000073, 14.629289043000057],
            [22.422744588000086, 14.609083557000062],
            [22.382333618000104, 14.579111226000123],
            [22.36352339600009, 14.543532003000053],
            [22.38636438000009, 14.506531678000101],
            [22.417163534000053, 14.484104106000103],
            [22.424914998000077, 14.470435690000087],
            [22.439074341, 14.362922872000084],
            [22.44238163300011, 14.356928406000051],
            [22.447342570000046, 14.351631572000116],
            [22.45095992000003, 14.34579213400012],
            [22.449926392000066, 14.338376567000111],
            [22.44486210100007, 14.333363952000056],
            [22.43132287600011, 14.327214458000086],
            [22.426982056000043, 14.323002828000128],
            [22.418093710000107, 14.305949606000098],
            [22.417060181000124, 14.298094787000068],
            [22.419954061000112, 14.286235046000044],
            [22.429049113000076, 14.264608460000076],
            [22.44103804600013, 14.249854838000061],
            [22.457677856000146, 14.241147359000095],
            [22.514108520000093, 14.231458028000063],
            [22.531885213000123, 14.220631816000022],
            [22.540876912000073, 14.201175639000041],
            [22.547698201000117, 14.169032898000097],
            [22.54635461400005, 14.139706523000129],
            [22.531471802000112, 14.122627462000096],
            [22.508217407000103, 14.113635763000048],
            [22.481449015000123, 14.108545634000066],
            [22.45871138500013, 14.096117452000087],
            [22.421607706000145, 14.062140198000066],
            [22.402280721000096, 14.049298604000072],
            [22.24353072100007, 13.975427145000097],
            [22.214695272000142, 13.956616923000084],
            [22.190614054000093, 13.932794088000023],
            [22.180762493000145, 13.920554946000053],
            [22.0993534750001, 13.819415996000103],
            [22.074962199000083, 13.780322775000087],
            [22.07372196400013, 13.771356913000147],
            [22.097079712000095, 13.749756165000079],
            [22.11289270000009, 13.729834900000071],
            [22.1163033440001, 13.715184632000089],
            [22.114339641000072, 13.699707540000077],
            [22.114339641000072, 13.677383321000022],
            [22.132116333000113, 13.63865183500009],
            [22.19588505000013, 13.580464173000081],
            [22.210561157000114, 13.54173268600006],
            [22.211181274000097, 13.484190979000033],
            [22.215625448000083, 13.464993184000022],
            [22.22864790800014, 13.441118672000115],
            [22.26399458800003, 13.399183248000028],
            [22.275983521000086, 13.376316427000106],
            [22.26761193900012, 13.33456186900007],
            [22.232265258000012, 13.28903493300001],
            [22.139971151000054, 13.193511048000047],
            [22.123434692000046, 13.182168071000063],
            [22.016051066000074, 13.140232646000072],
            [21.998377726000058, 13.130594991000052],
            [21.964064575000037, 13.098348898000083],
            [21.935125773000095, 13.059152323000134],
            [21.852960246000066, 12.90572499600006],
            [21.827845500000137, 12.831104228000072],
            [21.811825806000087, 12.799969177000023],
            [21.809448690000124, 12.793664653000107],
            [21.81368615700009, 12.782295838000024],
            [21.84086796100007, 12.748938701000057],
            [21.880142049000142, 12.676281636000112],
            [21.900812622000075, 12.656437887000024],
            [21.935952596000106, 12.639539693000117],
            [21.9771903890001, 12.631839905000035],
            [22.01966841600006, 12.631426493000035],
            [22.05873580000008, 12.63669749000006],
            [22.105864706000062, 12.650391744000075],
            [22.144105265000064, 12.67126902300005],
            [22.176248006000094, 12.70149973500007],
            [22.204876750000068, 12.743357646000035],
            [22.330140422000113, 12.661450501000076],
            [22.432459757000117, 12.623830058000067],
            [22.44568892400011, 12.611065979000088],
            [22.395872843000063, 12.496085917000059],
            [22.3728251550001, 12.463116353000089],
            [22.374892212000077, 12.450869039000068],
            [22.407965128000058, 12.399761048000073],
            [22.481449015000123, 12.176673889000071],
            [22.484032837000115, 12.164736634000121],
            [22.48475630700011, 12.152540996000099],
            [22.483826131000058, 12.140345357000086],
            [22.45809126800009, 12.030429586000125],
            [22.464499145000104, 12.032961731000114],
            [22.47049361200004, 12.036113994000075],
            [22.481449015000123, 12.044278870000085],
            [22.546457967000094, 12.064432678000074],
            [22.585525350000097, 12.07135732100005],
            [22.598857869000113, 12.063244121000139],
            [22.607332804000123, 12.077713522000082],
            [22.61239709500009, 12.072804261000044],
            [22.613533977000117, 12.057249655000106],
            [22.610536743000097, 12.039627991000117],
            [22.59286340300008, 11.988933411000062],
            [22.537052856000116, 11.680890198000057],
            [22.541703735000084, 11.632986145000046],
            [22.561754191000148, 11.586012268000076],
            [22.59234663900014, 11.543663432000073],
            [22.62810673000007, 11.509841207000079],
            [22.66252323400002, 11.493072204000029],
            [22.743035115000083, 11.466097107000095],
            [22.76876997800008, 11.442325948000132],
            [22.771560506000043, 11.433308411000084],
            [22.771870565000114, 11.403181051000104],
            [22.781792440000117, 11.398891907000035],
            [22.87698042800008, 11.408839621000126],
            [22.900441529000148, 11.408245341000082],
            [22.914807576000072, 11.396101379000072],
            [22.928346802000135, 11.325149638000099],
            [22.953668254000036, 11.250942281000036],
            [22.954535630000123, 11.237843295000076],
            [22.956458781000094, 11.20880015100009],
            [22.95201460700008, 11.19104929600006],
            [22.935168090000104, 11.1558834840001],
            [22.928966919000118, 11.13792592400003],
            [22.9256596270001, 11.11813385000005],
            [22.925142863000076, 11.097954204000075],
            [22.922352336000102, 11.087076315000019],
            [22.90653934800011, 11.069893901000043],
            [22.9002348220001, 11.059894511000039],
            [22.861064087000074, 10.919153747000081],
            [22.805977010000106, 10.924502258000047],
            [22.74510217300005, 10.943803406000086],
            [22.719884074000106, 10.964654846000144],
            [22.682677043000098, 10.974137472000038],
            [22.673168579000105, 10.975067648000078],
            [22.63833866300004, 10.974137472000038],
            [22.628210083000084, 10.97612701400007],
            [22.609089803000103, 10.985222066000048],
            [22.600821574000065, 10.987805888000139],
            [22.577050415000087, 10.985118714000109],
            [22.555759725000115, 10.978969218000131],
            [22.534675740000097, 10.980519511000068],
            [22.511938110000102, 11.000828349000074],
            [22.502843058000053, 10.992172547000038],
            [22.49075077300006, 10.99315439900009],
            [22.476281372000102, 10.997960307000099],
            [22.46046838400011, 11.000828349000074],
            [22.447135865000092, 10.998270366000085],
            [22.437627401000015, 10.991552429000066],
            [22.419230590000012, 10.970726827000092],
            [22.40703495200009, 10.963052877000024],
            [22.391842082000068, 10.958505351000085],
            [22.364690321000097, 10.954208607000098],
            [22.361146281000032, 10.95364776600006],
            [22.33944217900003, 10.947730815000057],
            [22.31877160600004, 10.939359233000076],
            [22.305955852000125, 10.932563782000031],
            [22.28724898300007, 10.915949809000026],
            [22.276500285000054, 10.908534241000012],
            [22.26843876100014, 10.90899932900004],
            [22.253039185000148, 10.915303854000044],
            [22.240120076000068, 10.90589874300008],
            [22.229371378000025, 10.891971944000105],
            [22.20063928200011, 10.868665873000069],
            [22.189787231000082, 10.837298279000052],
            [22.17635135900011, 10.816214295000108],
            [22.148239380000092, 10.830761210000077],
            [22.1324263920001, 10.828539124000073],
            [22.048607218000114, 10.836988220000066],
            [22.02948693800002, 10.828745829000113],
            [22.01832482900008, 10.80988393200009],
            [22.011400187000106, 10.789290873000098],
            [22.00488895700005, 10.775519104000068],
            [22.01460412600008, 10.754564310000063],
            [22.003855428000065, 10.743273010000095],
            [21.943083944000136, 10.728261007000114],
            [21.925617309000103, 10.720121969000019],
            [21.8950248620001, 10.699193013000112],
            [21.872080526000047, 10.677592265000058],
            [21.86835982300005, 10.676222839000076],
            [21.863605591000066, 10.667928772000039],
            [21.852753540000094, 10.670150859000032],
            [21.832909790000116, 10.679943543000093],
            [21.8225745040001, 10.678754985000069],
            [21.80355757700005, 10.673664856000087],
            [21.795392700000036, 10.672476299000067],
            [21.784850708000135, 10.669324036000106],
            [21.77875288900009, 10.66227020300009],
            [21.77420536300005, 10.655164694000064],
            [21.768417603000074, 10.651986593000089],
            [21.753431437000103, 10.65072052000005],
            [21.736481567000112, 10.646172994000025],
            [21.722632284000042, 10.636716207000049],
            [21.716844523000077, 10.621006572000084],
            [21.714674113000086, 10.601395365000144],
            [21.70547570800008, 10.571810608000106],
            [21.70330529800009, 10.552406108000042],
            [21.70547570800008, 10.532019755000093],
            [21.714674113000086, 10.49370168100009],
            [21.716844523000077, 10.477320252000126],
            [21.720461873000147, 10.468018494000106],
            [21.738031861000138, 10.448019714000083],
            [21.744233032000125, 10.439105530000063],
            [21.744439738000068, 10.432439270000131],
            [21.74278609300012, 10.425773010000043],
            [21.743612915000142, 10.418977559000083],
            [21.751054321000083, 10.41182037300004],
            [21.720461873000147, 10.360815735000088],
            [21.716844523000077, 10.33980926500007],
            [21.71777469900013, 10.328983053000044],
            [21.722115519000113, 10.314177755000102],
            [21.723045695000053, 10.30598704100008],
            [21.718808228000114, 10.296633606000043],
            [21.708886352, 10.293533020000012],
            [21.6974141850001, 10.292421977000103],
            [21.68893925000009, 10.288907980000133],
            [21.67695031700012, 10.26916758200008],
            [21.668888794000054, 10.24919464100006],
            [21.65627974500012, 10.233665873000035],
            [21.630648234000148, 10.22743886400005],
            [21.625273885000098, 10.224493307000046],
            [21.593441203000054, 10.214545594000043],
            [21.589720500000027, 10.216612650000101],
            [21.579281860000094, 10.212271831000123],
            [21.566672810000085, 10.214493917000127],
            [21.55447717200005, 10.218653870000054],
            [21.544968709000074, 10.219997457000119],
            [21.513239380000044, 10.20051544200004],
            [21.48543745900011, 10.164316101000097],
            [21.43334761600005, 10.046054586000068],
            [21.406889282000066, 10.005566101000056],
            [21.37433313000011, 9.97311330100004],
            [21.339503214000047, 9.959909973000052],
            [21.3260673420001, 9.962752177000127],
            [21.285139608000065, 9.978591004000037],
            [21.271290323000102, 9.987246806000087],
            [21.25692427600012, 9.975748800000062],
            [21.20566125500008, 9.916837667000053],
            [21.198426554000037, 9.902988383000093],
            [21.19542932200011, 9.887304586000127],
            [21.187264445000096, 9.885134176000037],
            [21.13197066200007, 9.849425761000134],
            [21.121738728000082, 9.831907451000077],
            [21.1067525630001, 9.795449728000065],
            [21.10592574000009, 9.791884054000093],
            [21.1067525630001, 9.778060608000132],
            [21.10520227100008, 9.774029847000051],
            [21.101584920000107, 9.774236552000104],
            [21.09703739400007, 9.775373434000116],
            [21.093109986000087, 9.774339905000133],
            [21.080294230000106, 9.762609355000052],
            [21.073162882000076, 9.757648417000098],
            [21.065824829000093, 9.75449615500014],
            [21.062207479000108, 9.756201477000104],
            [21.052905721000087, 9.765890809000041],
            [21.04835819500005, 9.768164571000057],
            [21.042673787000098, 9.767079366000061],
            [21.040089966000096, 9.764753927000129],
            [21.039056437000113, 9.762170105000038],
            [21.03781620300009, 9.760671489000117],
            [21.032338501000083, 9.758010152000097],
            [21.025620565000054, 9.7532559200001],
            [21.019936157000103, 9.747933248000066],
            [21.017352336000016, 9.743592428000085],
            [21.014251749000067, 9.724472148000089],
            [21.000092408000114, 9.697393697000038],
            [20.996888468000066, 9.682174988000085],
            [20.996061645000026, 9.648301087000092],
            [20.989963826000064, 9.63561452200014],
            [20.975804484000037, 9.630963643000072],
            [20.975804484000037, 9.624168193000031],
            [20.980145304000104, 9.619930726000078],
            [20.98179895000007, 9.616778463000031],
            [20.98314253800004, 9.603678488000071],
            [20.9676396080001, 9.61060312900014],
            [20.96226525900005, 9.606934103000057],
            [20.96050826000007, 9.598123271000063],
            [20.955960734000143, 9.589415792000082],
            [20.934256632000142, 9.577065125000033],
            [20.925058227000136, 9.569597880000103],
            [20.921234171000094, 9.558978373000116],
            [20.91265588400006, 9.544328105000133],
            [20.874208618000125, 9.502496033000071],
            [20.863769979000097, 9.493788554000105],
            [20.841445760000113, 9.484409282000058],
            [20.834314412000083, 9.4624726360001],
            [20.83266076700005, 9.437254537000044],
            [20.82614953600006, 9.418082580000132],
            [20.82025842200008, 9.416222229000127],
            [20.81388430900006, 9.418846864000045],
            [20.813230428000054, 9.419116109000115],
            [20.806719197000092, 9.423327739000058],
            [20.8019649660001, 9.425549825000061],
            [20.798244262000082, 9.42337941500007],
            [20.792353149000093, 9.41400014200012],
            [20.788322388000097, 9.41188140900006],
            [20.7765401610001, 9.407798970000044],
            [20.77106246000011, 9.398057963000099],
            [20.766618286000096, 9.386559957000074],
            [20.757936646000132, 9.37712900800011],
            [20.750495240000106, 9.384544576000025],
            [20.7408834230001, 9.37712900800011],
            [20.695821574000064, 9.363460592000095],
            [20.654893839000124, 9.34297088700012],
            [20.667916300000087, 9.302017314000096],
            [20.616653280000037, 9.302017314000096],
            [20.609728638000064, 9.302792460000106],
            [20.592882121000088, 9.308218485000083],
            [20.592262003000116, 9.308063457000046],
            [20.57355513500005, 9.309148661000037],
            [20.572314901000084, 9.308218485000083],
            [20.550920858000097, 9.320259095000054],
            [20.541825806000105, 9.321628520000033],
            [20.53820845600012, 9.3119391890001],
            [20.537278280000066, 9.299200948000134],
            [20.53366093000008, 9.289640809000048],
            [20.526426229000037, 9.283620504000098],
            [20.514230591000114, 9.281501771000123],
            [20.496143840000087, 9.270882264000136],
            [20.50265507000006, 9.24742116300007],
            [20.512990357000092, 9.223882548000077],
            [20.5072025960001, 9.21326304100009],
            [20.481777792000088, 9.204658915000053],
            [20.467618449000042, 9.18414337200008],
            [20.455422811000034, 9.15931284600012],
            [20.435165649000027, 9.138125509000076],
            [20.42307336400006, 9.143241476000057],
            [20.41242801900006, 9.142052918000047],
            [20.402919555000068, 9.136988627000065],
            [20.384419393000144, 9.123578593000019],
            [20.378321574000097, 9.120064596000063],
            [20.35940799900004, 9.116421407000075],
            [20.276829061000115, 9.120736390000047],
            [20.256985311000108, 9.116421407000075],
            [20.234454387000085, 9.134559835000104],
            [20.222982218000084, 9.141949565000104],
            [20.21264693200007, 9.14497263600012],
            [20.197970825000084, 9.14050262500011],
            [20.16954878800007, 9.120891418000085],
            [20.1545626220001, 9.116421407000075],
            [20.13761275200008, 9.12182159400004],
            [20.12572717200007, 9.133784688000091],
            [20.11714888500012, 9.145747782000043],
            [20.10960412600008, 9.15117380800011],
            [20.101025838000055, 9.148073222000079],
            [20.09957889800006, 9.141174418000091],
            [20.100509074000115, 9.13414642300009],
            [20.099372193000107, 9.130709941000063],
            [20.09058719900011, 9.131123352000074],
            [20.07694462100011, 9.136730245000095],
            [20.068676391000054, 9.138125509000076],
            [20.060511515000144, 9.134353129000132],
            [20.031159302000077, 9.110220236000089],
            [20.028368775000104, 9.104561666000052],
            [20.029919067000037, 9.098980611000044],
            [20.030332478000048, 9.09386464400005],
            [20.0243380120001, 9.089756368000039],
            [20.017930135000057, 9.091048279000077],
            [20.014416137000097, 9.106344503000045],
            [20.006871379000074, 9.110220236000089],
            [20.002943970000103, 9.108514913000121],
            [19.999533325000073, 9.104303284000082],
            [19.99715620900011, 9.098618876000046],
            [19.9963293860001, 9.09283111600007],
            [19.99302209400011, 9.084588725000032],
            [19.98547733500004, 9.08319346100005],
            [19.97648563700011, 9.084175313000102],
            [19.969044231000083, 9.082883403000068],
            [19.943412719000037, 9.065881856000132],
            [19.932091369000148, 9.063330566000076],
            [19.928736613000126, 9.062574565000133],
            [19.914473917000066, 9.069266663000064],
            [19.902174927000118, 9.05180002900002],
            [19.889462525000056, 9.046374004000128],
            [19.805539998000143, 9.051128235000121],
            [19.784662720000085, 9.048751120000091],
            [19.758411092000046, 9.041981506000056],
            [19.746835571000105, 9.04130971300006],
            [19.738153931000056, 9.03937184700004],
            [19.71396936000008, 9.029139913000066],
            [19.70900842300003, 9.024566548000024],
            [19.70001672300009, 9.02058746400013],
            [19.65640181400005, 9.021259257000025],
            [19.640072062000087, 9.013998718000053],
            [19.61361372900012, 9.031672059000044],
            [19.583124633000125, 9.025341696000027],
            [19.553772420000143, 9.013326925000058],
            [19.53082808400012, 9.013998718000053],
            [19.521319621000117, 9.008831075000046],
            [19.515841919000138, 9.0094511920001],
            [19.511811157000068, 9.012293396000075],
            [19.50664351400013, 9.013998718000053],
            [19.430162394000064, 9.012861837000045],
            [19.420963989000057, 9.017435202000073],
            [19.382620076000137, 9.003198345000015],
            [19.36939091000005, 9.00038197800005],
            [19.352234334000087, 9.002061463000103],
            [19.33332076000005, 9.006557312000027],
            [19.316267537000016, 9.0131202190001],
            [19.304795370000107, 9.020845845000096],
            [19.295493612000087, 9.009502869000116],
            [19.285778442000037, 9.012810160000114],
            [19.27523645000008, 9.021982727000108],
            [19.2632475180001, 9.028261414000028],
            [19.25342899600014, 9.02795135600013],
            [19.23286177600005, 9.022292786],
            [19.192037394000067, 9.020174052000115],
            [19.179635051000105, 9.015264791000092],
            [19.17457076000011, 9.003766784000064],
            [19.168783000000133, 9.002216492000045],
            [19.14211796100011, 9.00867604600009],
            [19.1336430260001, 9.007177429000095],
            [19.126718384000128, 9.007177429000095],
            [19.100570109000103, 9.015264791000092],
            [19.06067590300009, 9.004180196000078],
            [19.021918579000044, 8.985214946000028],
            [18.999491007000046, 8.969634501000087],
            [18.98481490000006, 8.956431173000098],
            [18.978510376000145, 8.949454855000099],
            [18.97592655400004, 8.941987610000083],
            [18.971895793000044, 8.938215230000054],
            [18.952052042000076, 8.931988220000065],
            [18.93644576000011, 8.923358256000114],
            [18.928590943000074, 8.921678772000064],
            [18.92290653500004, 8.91821645100012],
            [18.920736124000143, 8.907855327000107],
            [18.917738892000045, 8.898811951000141],
            [18.9106075440001, 8.8942385860001],
            [18.901409139000094, 8.893980205000034],
            [18.892727498000056, 8.897933452000103],
            [18.869679810000093, 8.864111227000109],
            [18.869783162000118, 8.849409282000124],
            [18.88652632700007, 8.835844218000133],
            [18.902959432000017, 8.84481007900007],
            [18.909677368000132, 8.835327454],
            [18.912467895000106, 8.818403422000102],
            [18.917325480000045, 8.805148418000101],
            [18.929107707000128, 8.796544292000064],
            [19.04868697100011, 8.745668844000136],
            [19.0577820230001, 8.729700826000098],
            [19.07349165900007, 8.720528259000105],
            [19.10387740100012, 8.698049011000094],
            [19.12413456200011, 8.675078837000058],
            [19.09147505700014, 8.652857972000021],
            [19.081656535000064, 8.637225851000068],
            [19.072261297000125, 8.631872473000072],
            [19.061296021000146, 8.625624492000028],
            [19.02047163900005, 8.545577698000073],
            [18.920529419000104, 8.43212209000005],
            [18.910400839000147, 8.412975973000044],
            [18.90130578600008, 8.38863637300004],
            [18.887456503000095, 8.370963033000123],
            [18.854900350000065, 8.33980214400006],
            [18.81304244000009, 8.276421001000045],
            [18.791234986000063, 8.257378235000061],
            [18.773768351000115, 8.248619080000083],
            [18.715063924000077, 8.228671977000062],
            [18.672585896000044, 8.207510478000117],
            [18.638582804000094, 8.177641500000092],
            [18.618635702000063, 8.138651632000105],
            [18.617912231000076, 8.090127462000027],
            [18.589283488000092, 8.047881979000053],
            [18.50825484200007, 8.030673727000064],
            [18.07045210800004, 8.019201558000049],
            [17.977227824000096, 7.997187398000065],
            [17.89785282400004, 7.967473450000099],
            [17.858785441000123, 7.960445455000084],
            [17.817237589000115, 7.962099101000135],
            [17.67977828000008, 7.985198466000014],
            [17.661794881000077, 7.986283671000109],
            [17.639884074000122, 7.985043437000073],
            [17.620660441000012, 7.978738912000054],
            [17.599989868000108, 7.950368551000054],
            [17.580766235000084, 7.940601706000095],
            [17.55978560300008, 7.934710592000087],
            [17.52381880700011, 7.930989889000088],
            [17.50366499800012, 7.926235657000092],
            [17.487231893000057, 7.914453430000094],
            [17.478343547000037, 7.891819153000128],
            [17.466354614000096, 7.884119364000057],
            [17.41912235500007, 7.898227030000086],
            [17.405996541000093, 7.883034160000051],
            [17.385739380000075, 7.870476787000129],
            [17.25086389100005, 7.822831116000089],
            [17.234637492000047, 7.811617330000047],
            [17.233790206000094, 7.810801425000136],
            [17.22068485500003, 7.798181457000098],
            [17.21448368300014, 7.786812643000104],
            [17.211073038000023, 7.768312480000077],
            [17.20456180800005, 7.763816630000065],
            [17.19639693200014, 7.765160218000034],
            [17.18864546700013, 7.764126689000051],
            [17.1705587160001, 7.747538554000045],
            [17.135522095000084, 7.705112203000112],
            [17.11629846200009, 7.686870422000055],
            [17.10193241400006, 7.677723694000065],
            [17.095524536000113, 7.678240458000104],
            [17.090253540000106, 7.683821513000026],
            [17.07909143100008, 7.689919332000088],
            [17.059351033000098, 7.696533916000078],
            [17.04560510200008, 7.684700012000064],
            [17.041057576000128, 7.675501608000062],
            [17.04209110500011, 7.667026673000066],
            [17.038990519000066, 7.662479147000028],
            [17.008294718000116, 7.667646790000035],
            [16.9975460200001, 7.66671661400008],
            [16.988967733000067, 7.66077382400006],
            [16.98193973800008, 7.648733215000092],
            [16.96271610500014, 7.650696920000115],
            [16.919617961000142, 7.644082337000029],
            [16.88065393000005, 7.632868551000087],
            [16.865461060000115, 7.62444529200009],
            [16.854815715000115, 7.611474508000072],
            [16.84716760300006, 7.591579081000063],
            [16.848097778000096, 7.584706116000092],
            [16.852438599000095, 7.580261943000082],
            [16.855849243000108, 7.575404358000071],
            [16.85388553900009, 7.567497864000117],
            [16.85037154100013, 7.565895894000079],
            [16.839622843000086, 7.567446188000105],
            [16.836728963000013, 7.567497864000117],
            [16.815071257000056, 7.549543532000129],
            [16.812854451000135, 7.547705790000052],
            [16.805516398000123, 7.543675029000056],
            [16.78236535700006, 7.541142883000063],
            [16.76861942500011, 7.55023793600013],
            [16.74670861800007, 7.586566467000097],
            [16.70981164600005, 7.627752584000092],
            [16.686867310000082, 7.645787659000092],
            [16.663199504000147, 7.657414856000059],
            [16.62454553200007, 7.668680318000014],
            [16.614210245000066, 7.679584046000073],
            [16.609869426000074, 7.701598206000057],
            [16.611833129000104, 7.713897197000094],
            [16.616173950000075, 7.72387074800011],
            [16.618137655000112, 7.734309387000053],
            [16.61307336400006, 7.748210347000025],
            [16.605218547000106, 7.757202047000064],
            [16.59643355300011, 7.761129456000035],
            [16.586821737, 7.763558248000095],
            [16.576383097000075, 7.767795715000133],
            [16.56015669700008, 7.77973297200009],
            [16.54930464600011, 7.794719137000058],
            [16.544860474000103, 7.813012594000028],
            [16.55023482200008, 7.843501689000021],
            [16.550751587, 7.852700094000113],
            [16.550131469000036, 7.861691793000148],
            [16.54868453000006, 7.870011699000116],
            [16.509203735000114, 7.858281149000035],
            [16.49173710100007, 7.84923777300007],
            [16.47571740700002, 7.83580190100011],
            [16.469412882000114, 7.825828349000105],
            [16.457217244000105, 7.799628398000095],
            [16.450912720000076, 7.792083638000051],
            [16.437373495000116, 7.788362935000038],
            [16.427244913000067, 7.791463522000072],
            [16.418149862000092, 7.795856018000066],
            [16.407401164000078, 7.796062724000123],
            [16.392208292000134, 7.783608703000127],
            [16.387040649000113, 7.762628072000041],
            [16.38714400200007, 7.69467356400007],
            [16.383009888000032, 7.680669251000069],
            [16.37081424900012, 7.672504374000056],
            [16.2827576090001, 7.660102031000079],
            [16.26188033000011, 7.651885478000054],
            [16.227257120000104, 7.625582174000101],
            [16.207206665000058, 7.613541565000034],
            [16.1856059160001, 7.610751037000071],
            [16.162661580000076, 7.611112773000073],
            [16.12876184100014, 7.599485575000102],
            [16.06519982900008, 7.591217346000064],
            [16.042978964000042, 7.583930970000083],
            [16.02633915200002, 7.574887594000117],
            [16.012283162000102, 7.560314840000075],
            [15.990372355000147, 7.529412333000067],
            [15.975696248000077, 7.515201315000112],
            [15.943140096000036, 7.495305888000104],
            [15.925260050000077, 7.488174541000063],
            [15.79389855900007, 7.457995504000067],
            [15.758345174000112, 7.455566711000102],
            [15.720001262000096, 7.468640849000067],
            [15.668531535000113, 7.516286519000104],
            [15.624813273000115, 7.519748841000052],
            [15.551949503000117, 7.509878642000061],
            [15.515569295000148, 7.512204081000093],
            [15.48104943900006, 7.523262838000093],
            [15.521977173000096, 7.576076151000052],
            [15.548952271000104, 7.630801493000121],
            [15.562181437000106, 7.690177714000058],
            [15.562904907000103, 7.792445374000039],
            [15.540787394000091, 7.796837870000033],
            [15.509368123000058, 7.804020895000079],
            [15.487870727000114, 7.804951071000048],
            [15.440741821000103, 7.83941925100001],
            [15.406532023000125, 7.921584778000124],
            [15.345347127000082, 8.135990296000088],
            [15.21070621600009, 8.421822448000057],
            [15.183703247000068, 8.479147644000122],
            [15.168510376000143, 8.498603821000103],
            [15.110736124000141, 8.555137838000064],
            [15.068568155000094, 8.623867493000134],
            [15.051928345000078, 8.643788758000056],
            [15.03125777200006, 8.65874908500011],
            [15.00583296700006, 8.666629741000065],
            [14.968522583, 8.67215911900007],
            [14.955086710000074, 8.67621571900007],
            [14.95146936000009, 8.68283030200007],
            [14.95146936000009, 8.692106222000078],
            [14.949092244000042, 8.704276022000087],
            [14.940100545000092, 8.729649149000082],
            [14.934416137000142, 8.739002584000033],
            [14.927284790000101, 8.745074565000081],
            [14.9199467360001, 8.747710063000085],
            [14.913332153000113, 8.752438457000082],
            [14.908267863000049, 8.764840800000044],
            [14.899379516000124, 8.77432342500012],
            [14.859898722000082, 8.803313904000092],
            [14.846049438000136, 8.81098785400009],
            [14.836747680000116, 8.81300323500004],
            [14.82796268700011, 8.81315826500007],
            [14.819177694000132, 8.811607971000058],
            [14.809875936000111, 8.808610738000127],
            [14.79385624200006, 8.813623353000096],
            [14.571699259500036, 8.990989787000089],
            [14.349542277000126, 9.168356221000082],
            [14.331145467000027, 9.200214743000046],
            [14.321326945000067, 9.243157858000103],
            [14.03648645000007, 9.568771057000077],
            [13.947602987000039, 9.637759094000032],
            [13.945949340000084, 9.652641907000074],
            [14.006720825000087, 9.739277446000102],
            [14.088472941000106, 9.809634909000124],
            [14.119788859000096, 9.85200958300004],
            [14.168364705000101, 9.947740174000046],
            [14.170638468000107, 9.95784291600009],
            [14.171155232000075, 9.967609762000052],
            [14.173532348000094, 9.975025329000061],
            [14.181697225000022, 9.978177593000026],
            [14.196340538000072, 9.979146894000024],
            [14.440492798000037, 9.995308329000068],
            [14.732464640000074, 9.923813985000052],
            [14.77256555200006, 9.92174692800009],
            [14.898139282000074, 9.960478414000107],
            [14.944131307000077, 9.958824768000056],
            [15.002422323000104, 9.945052999000026],
            [15.033014770000136, 9.942856751000122],
            [15.06123010200011, 9.949238790000052],
            [15.071668742000043, 9.955956726000082],
            [15.089445435000073, 9.97218312600009],
            [15.100710897000113, 9.978901062000105],
            [15.109599244000037, 9.981536560000038],
            [15.155487915, 9.98652333600009],
            [15.214915812000072, 9.984094543000126],
            [15.382967570000119, 9.930196025000086],
            [15.439398234000066, 9.931694641000092],
            [15.663777303000103, 9.986109924000075],
            [15.681243937000147, 9.991277568000072],
            [15.637939087000092, 10.029957378000091],
            [15.60279911300006, 10.04099029600009],
            [15.536136515000123, 10.08052276600003],
            [15.49014449000012, 10.120106913000086],
            [15.490661255000077, 10.124447734000057],
            [15.476398560000092, 10.132741801000108],
            [15.439191528000094, 10.185245057000074],
            [15.301422160000072, 10.311748963000056],
            [15.2905701090001, 10.328983053000044],
            [15.28426558400011, 10.34929189100005],
            [15.282198527000048, 10.374587504000118],
            [15.278374471000092, 10.39427622500007],
            [15.268762655000074, 10.40634267200005],
            [15.255636841000126, 10.417039693000063],
            [15.241167440000083, 10.432904358000073],
            [15.227214803000095, 10.470137228000084],
            [15.218326457000074, 10.487216288000127],
            [15.19817264800011, 10.49649220800005],
            [15.193315063000085, 10.501194764000033],
            [15.186597127000056, 10.505871480000096],
            [15.176055135000098, 10.507990214000074],
            [15.1646863200001, 10.50907541900007],
            [15.1536275630001, 10.511969300000146],
            [15.144429158000094, 10.516310120000128],
            [15.138227986000118, 10.52165863100008],
            [15.13171675600006, 10.54070139600006],
            [15.132336873000014, 10.565402731000077],
            [15.13843469200009, 10.589690654000066],
            [15.148459920000107, 10.607338155000065],
            [15.149906860000101, 10.623125305000059],
            [15.14225874900012, 10.647206523000094],
            [15.065880981000078, 10.79311492900004],
            [15.063090454000104, 10.830761210000077],
            [15.07559615000011, 10.87349762000008],
            [15.079006795000026, 10.898147278000081],
            [15.072702270000036, 10.915768941000067],
            [15.062470336000047, 10.930703430000037],
            [15.035185181000116, 10.994627177000098],
            [15.028830281000126, 11.08021826600013],
            [15.021232544000043, 11.182548523000051],
            [15.028260539000144, 11.244482727000076],
            [15.033324829000037, 11.26026987700007],
            [15.056372517000085, 11.293420309000084],
            [15.063090454000104, 11.30993092900006],
            [15.062263631000093, 11.320033671000104],
            [15.057819458000068, 11.325356344000056],
            [15.052548462000033, 11.329800517000066],
            [15.049447876000102, 11.337267762000096],
            [15.049447876000102, 11.348714091000105],
            [15.054305461000126, 11.364087829000084],
            [15.060609985000042, 11.416125997000023],
            [15.067017863000075, 11.4355563350001],
            [15.076112915000039, 11.453307190000118],
            [15.122311645000082, 11.503226624000078],
            [15.135644165000116, 11.53082183800008],
            [15.123861938000118, 11.563171285000067],
            [15.095749959000074, 11.598156230000072],
            [15.085207967000116, 11.615881246000086],
            [15.069394979000037, 11.660788066000094],
            [15.06650109900005, 11.680631816000087],
            [15.068258097000097, 11.700113831000081],
            [15.076112915000039, 11.72145619700008],
            [15.079833618000066, 11.722593079000092],
            [15.086344848000124, 11.72217966800008],
            [15.093062785000143, 11.722903137000074],
            [15.097196899000068, 11.72765736900007],
            [15.09595666500013, 11.73411692300003],
            [15.08531132000013, 11.744038798000105],
            [15.083554321000065, 11.748172913000133],
            [15.089135376000087, 11.757629700000109],
            [15.10536177600008, 11.772719219000109],
            [15.110942831000102, 11.782899476000068],
            [15.086344848000124, 11.840467021000023],
            [15.079833618000066, 11.851215719000038],
            [15.062780396000107, 11.853489482000057],
            [15.05099816900011, 11.861602681000065],
            [15.044176880000066, 11.877312317000118],
            [15.042006469000086, 11.902375387000035],
            [15.046967408000114, 11.91017852800006],
            [15.056579224000131, 11.918446757000098],
            [15.0634005120001, 11.927283427000106],
            [15.059369751000105, 11.936791891000084],
            [15.055545695000148, 11.94247629800013],
            [15.050584758000099, 11.952863261000061],
            [15.048310995000094, 11.96278513600005],
            [15.052548462000033, 11.96722930900006],
            [15.081177205000103, 11.97167348300006],
            [15.07683638500012, 11.9828355920001],
            [15.059679809000073, 11.997304993000029],
            [15.049447876000102, 12.011929423000097],
            [15.051204875000082, 12.02422841400005],
            [15.05368534300004, 12.031876526000119],
            [15.053065226000086, 12.038026022000096],
            [15.045727173000074, 12.046087545000077],
            [15.040559529000092, 12.055647685000082],
            [15.040869589000067, 12.06758494100012],
            [15.044590292000066, 12.078385316000066],
            [15.049447876000102, 12.084586487000138],
            [15.03043094900005, 12.100916239000085],
            [15.011827433000065, 12.108616028000071],
            [14.99384403500008, 12.10670400000015],
            [14.976790812000047, 12.094146627000043],
            [14.964801879000106, 12.09244130500008],
            [14.950745890000093, 12.10334503200005],
            [14.928731730000095, 12.128614807000105],
            [14.903100219000123, 12.145874736000096],
            [14.89803592900006, 12.152799377000079],
            [14.894831990000085, 12.167372131000135],
            [14.899896281000053, 12.171764629000037],
            [14.90744104, 12.173469950000097],
            [14.911575154000047, 12.1801362100001],
            [14.910128214000054, 12.19036814400009],
            [14.905890747000086, 12.195639140000111],
            [14.900929809000047, 12.200031636000105],
            [14.89803592900006, 12.207473043000036],
            [14.89803592900006, 12.21946197600009],
            [14.903100219000123, 12.23625681600005],
            [14.904857219000121, 12.248400778000061],
            [14.906304159000115, 12.317957255000053],
            [14.908267863000049, 12.326897278000075],
            [14.8912146400001, 12.40265492800006],
            [14.877468709000084, 12.427201233000034],
            [14.876848592000101, 12.431593730000117],
            [14.878502238000067, 12.443065897000054],
            [14.877468709000084, 12.447044983000126],
            [14.872404419000105, 12.450403952000045],
            [14.865893188000115, 12.452574361000117],
            [14.86186242700012, 12.452005920000076],
            [14.863826131000053, 12.447044983000126],
            [14.855454549000086, 12.454538066000069],
            [14.85101037600009, 12.455158183000037],
            [14.849563436000096, 12.457018534000042],
            [14.85018355300005, 12.468128968000059],
            [14.852043905000073, 12.474691875000133],
            [14.860105428000054, 12.490091451000112],
            [14.863826131000053, 12.495465800000076],
            [14.830753214000083, 12.618249003000045],
            [14.819177694000132, 12.638816223000035],
            [14.786208130000063, 12.631219788000067],
            [14.768844849000061, 12.633235168000112],
            [14.76140344300012, 12.649358216000095],
            [14.758716268000114, 12.658815003000072],
            [14.75210168400011, 12.66894358300003],
            [14.743316691000103, 12.677160136000055],
            [14.734118286000125, 12.68041575100004],
            [14.72884729000009, 12.677211812000067],
            [14.71365441900005, 12.652510478000053],
            [14.70207889800011, 12.66899526000013],
            [14.716755005000095, 12.701809795000145],
            [14.709933716000137, 12.718242900000106],
            [14.694017375000044, 12.7237206020001],
            [14.664458455000101, 12.715969136000098],
            [14.648128703000054, 12.725115865000078],
            [14.641720826000011, 12.730903626000057],
            [14.624254191000063, 12.741884867000039],
            [14.62074019400012, 12.747853495000058],
            [14.620326782000092, 12.754054667000048],
            [14.618363078000073, 12.759196472000042],
            [14.61061161300006, 12.762348735000089],
            [14.603997029000055, 12.76079844200008],
            [14.584876749000074, 12.746354879000052],
            [14.575264933000142, 12.744907939000058],
            [14.570717407000132, 12.750385641000051],
            [14.569373820000067, 12.759609884000056],
            [14.569373820000067, 12.769402568000103],
            [14.560692179000085, 12.766224467000143],
            [14.554801066000095, 12.766896261000042],
            [14.551080363000096, 12.771572978000094],
            [14.54901330600012, 12.78046132400003],
            [14.54901330600012, 12.81821095800008],
            [14.531029907000033, 12.83624603300008],
            [14.500437459000125, 12.859112854000088],
            [14.49010217300011, 12.873608094000119],
            [14.49061893700005, 12.88634633400008],
            [14.506121867000076, 12.932079977000114],
            [14.507672159000094, 12.952440491000047],
            [14.504674927000082, 12.969002788000054],
            [14.496303345000115, 12.983808085000064],
            [14.48214400200007, 12.998820089000048],
            [14.481040720000067, 13.00050796300009],
            [14.435428507000069, 13.070288595000065],
            [14.418168579000081, 13.081140646000023],
            [14.0649084880001, 13.077988383000061],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Algeria',
        iso3: 'DZA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-4.821613117999902, 24.99506459600009],
            [-4.995194254999973, 25.10208648700008],
            [-5.168749552999913, 25.209160055000083],
            [-5.34233068899988, 25.31618194600007],
            [-5.515963500999874, 25.423255514000047],
            [-5.636989704999849, 25.49446563700009],
            [-5.661524745999969, 25.508881108000097],
            [-5.804628051999885, 25.59296091800006],
            [-5.972266397999931, 25.691611226000063],
            [-6.139904743999892, 25.790209859000058],
            [-6.30749141499993, 25.88880849300004],
            [-6.505412149999898, 26.005183818000077],
            [-6.703332885999885, 26.121559144000074],
            [-6.901201944999855, 26.237934469000024],
            [-7.099122680999926, 26.354361471000047],
            [-7.297043415999894, 26.470736796000054],
            [-7.494912475999854, 26.587163798000077],
            [-7.692781534999909, 26.703487447],
            [-7.890753946999922, 26.819914449000024],
            [-8.088623006999882, 26.93623809900005],
            [-8.28644038999991, 27.052665100000084],
            [-8.484412800999905, 27.168988750000082],
            [-8.68238521299989, 27.285415751000116],
            [-8.68238521299989, 27.37946685800007],
            [-8.68238521299989, 27.47346628800001],
            [-8.68238521299989, 27.56741404200004],
            [-8.68238521299989, 27.66143931100008],
            [-8.68238521299989, 27.72143564900007],
            [-8.68238521299989, 27.781354472000075],
            [-8.68238521299989, 27.841221619000024],
            [-8.68238521299989, 27.901140442000028],
            [-8.68238521299989, 27.961085104000105],
            [-8.68238521299989, 28.02102976600007],
            [-8.68238521299989, 28.080948588000055],
            [-8.68238521299989, 28.140893250000047],
            [-8.68238521299989, 28.200760397000025],
            [-8.68238521299989, 28.26067922],
            [-8.68238521299989, 28.32062388100009],
            [-8.68238521299989, 28.380542704000064],
            [-8.68238521299989, 28.440487366000056],
            [-8.68238521299989, 28.50040618900003],
            [-8.68238521299989, 28.560273336000094],
            [-8.68238521299989, 28.620217998000086],
            [-8.68238521299989, 28.665899964000104],
            [-8.678767862999905, 28.69282338500001],
            [-8.66760575399988, 28.71168528300005],
            [-8.648847208999882, 28.72594797800012],
            [-8.520818847999891, 28.787081198000024],
            [-8.475834512999882, 28.818758851000027],
            [-8.430410929999937, 28.84100555500008],
            [-8.4178018799999, 28.85234853100006],
            [-8.383488728999879, 28.90578196300008],
            [-8.36845088699991, 28.916530661000095],
            [-8.333259235999947, 28.93037994400005],
            [-8.316774454999859, 28.939061584000015],
            [-8.250473591999935, 28.99476877900007],
            [-8.18231237799992, 29.035541484000035],
            [-8.069657754999923, 29.07933726000003],
            [-8.03632645699986, 29.099852804000093],
            [-7.945014200999935, 29.176230570000072],
            [-7.839129191999888, 29.239043275000128],
            [-7.777995970999882, 29.289324443000098],
            [-7.729988565999918, 29.311157736000027],
            [-7.714666503999865, 29.321828918000037],
            [-7.653610798999892, 29.376192525000093],
            [-7.619452677999902, 29.389421692000084],
            [-7.572685506999989, 29.387613017],
            [-7.528502156999878, 29.380946757000075],
            [-7.506126260999906, 29.380223287],
            [-7.48406042499991, 29.382445374],
            [-7.463286498999878, 29.389137472000115],
            [-7.349610105356646, 29.383439374604663],
            [-7.258755287181771, 29.467305360612258],
            [-7.146933972505082, 29.50923835361594],
            [-7.070056818664909, 29.51622718578325],
            [-6.95823550398822, 29.50923835361594],
            [-6.78351469980592, 29.44633886411036],
            [-6.699648713798354, 29.51622718578325],
            [-6.55987207045257, 29.53020485011784],
            [-6.413106594939393, 29.56514901095433],
            [-6.273329951593496, 29.579126675288947],
            [-6.126564476080318, 29.579126675288947],
            [-6.00076549706904, 29.579126675288947],
            [-5.881955350225155, 29.600093171790732],
            [-5.756156371213876, 29.61407083612535],
            [-5.721212210377359, 29.52321601795056],
            [-5.637346224369793, 29.495260689281352],
            [-5.539502574027694, 29.52321601795056],
            [-5.434670091518313, 29.64202616479453],
            [-5.343815273343523, 29.76782514380581],
            [-5.273926951670632, 29.886635290649807],
            [-5.176083301328532, 29.977490108824597],
            [-5.071250818819067, 30.040389598330265],
            [-4.959429504142378, 30.124255584337774],
            [-4.875563518134896, 30.180166241676076],
            [-4.770731035625488, 30.229088066847154],
            [-4.62396556011231, 30.28499872418554],
            [-4.484188916766527, 30.38284237452764],
            [-4.372367602089838, 30.50864135353892],
            [-4.274523951747767, 30.557563178709913],
            [-4.155713804903684, 30.585518507379092],
            [-4.001959497223311, 30.5925073395464],
            [-3.834227525208235, 30.627451500382804],
            [-3.645529056691345, 30.7113174863904],
            [-3.652517888858654, 30.774216975895982],
            [-3.659506721025934, 30.837116465401678],
            [-3.610584895854856, 30.879049458405362],
            [-3.554674238516554, 30.955926612245648],
            [-3.60874141499994, 31.03087188800008],
            [-3.61008500199992, 31.050302226000056],
            [-3.614529174999916, 31.06802724200007],
            [-3.624140991999951, 31.086527405000098],
            [-3.635871541999933, 31.095674133000088],
            [-3.671941690999915, 31.11086700500003],
            [-3.689718383999946, 31.125594788000015],
            [-3.717106892999908, 31.16326690700005],
            [-3.731421264999881, 31.176341045000086],
            [-3.748862059999936, 31.18021677600005],
            [-3.763719034999951, 31.173447164000024],
            [-3.792967895999908, 31.149676006000064],
            [-3.810796263999862, 31.142906393000104],
            [-3.827461913999883, 31.143836568000083],
            [-3.839321654999907, 31.15282826800002],
            [-3.842835652999952, 31.170191549000023],
            [-3.836169392999864, 31.18977691700006],
            [-3.814982054999888, 31.220524394],
            [-3.812914998999929, 31.243365377000103],
            [-3.81921952299993, 31.318864645000033],
            [-3.815188761999934, 31.337158102],
            [-3.8025021979999, 31.35064565100005],
            [-3.747466796999959, 31.385165507000053],
            [-3.673484385360553, 31.389234206617786],
            [-3.659506721025934, 31.647820996807653],
            [-3.591378132999949, 31.678274232],
            [-3.548745076999865, 31.669954326000024],
            [-3.511563883999941, 31.672744853000083],
            [-3.219210294486487, 31.717709318480544],
            [-3.002556497300333, 31.77361997581893],
            [-2.827835693118061, 31.794586472320745],
            [-2.869768686121859, 31.89243012266293],
            [-2.938730631999903, 32.0486392210001],
            [-2.881188923999957, 32.07628611300002],
            [-2.695567178999852, 32.089670309000056],
            [-2.516146605999893, 32.13220001300003],
            [-2.378635620999916, 32.12677398700005],
            [-2.315176960999878, 32.12429351800007],
            [-2.243398396999879, 32.121399639000074],
            [-2.165108601999918, 32.11829905200004],
            [-2.081857869999908, 32.114940084000025],
            [-1.995454873999904, 32.111477763],
            [-1.907553262999926, 32.10796376500004],
            [-1.819961710999934, 32.104501445],
            [-1.734333861999886, 32.10109080000005],
            [-1.652375039999896, 32.09783518500008],
            [-1.575790567999888, 32.094734599000034],
            [-1.506337442999921, 32.09194407200009],
            [-1.445617634999934, 32.089515280000015],
            [-1.395388142999877, 32.08755157500009],
            [-1.357405965999959, 32.08605295800008],
            [-1.333428100999924, 32.08507110600003],
            [-1.324953165999943, 32.0847093710001],
            [-1.249557250999942, 32.08166046200007],
            [-1.210334838999898, 32.089670309000056],
            [-1.190594440999917, 32.12522369400001],
            [-1.195607055999886, 32.14604929600007],
            [-1.211833455999908, 32.15834828800003],
            [-1.23271073399988, 32.16372263600009],
            [-1.251831013999976, 32.16351593100002],
            [-1.288986368999872, 32.1509068810001],
            [-1.305161091999963, 32.15116526300007],
            [-1.309553588999961, 32.167443339],
            [-1.305677855999903, 32.17372202600011],
            [-1.289193074999929, 32.18485829700002],
            [-1.282991902999925, 32.19018096900008],
            [-1.276635700999918, 32.20085215300007],
            [-1.275188760999924, 32.209068706],
            [-1.27549881999991, 32.2175178020001],
            [-1.273423460999879, 32.22944217200005],
            [-1.257515420999908, 32.32084482800006],
            [-1.244131225999894, 32.35691497800006],
            [-1.23415767399996, 32.37461415600008],
            [-1.217982950999954, 32.39262339300008],
            [-1.201704874999933, 32.39985809300005],
            [-1.160260375999883, 32.40494822200013],
            [-1.123156697999917, 32.417944845000065],
            [-1.089980428999894, 32.439442241000094],
            [-1.031999470999949, 32.49440012700002],
            [-1.047502400999861, 32.51700856600006],
            [-1.327020223999909, 32.69890960700009],
            [-1.390530558999956, 32.718779196000085],
            [-1.423345092999881, 32.74239532500012],
            [-1.558789021999871, 32.93364980100007],
            [-1.516362670999854, 32.95948801700008],
            [-1.508869587999897, 32.96630930600004],
            [-1.502978474999907, 32.974629212000096],
            [-1.498844360999897, 32.98400848500005],
            [-1.496518920999961, 32.99429209500006],
            [-1.493366658999889, 33.016151225],
            [-1.493056599999903, 33.03948313400004],
            [-1.499516153999878, 33.06020538400007],
            [-1.516362670999854, 33.073977153],
            [-1.545508178999881, 33.09183136000006],
            [-1.571398071999909, 33.11198516900002],
            [-1.592068643999909, 33.13660898900012],
            [-1.605607869999886, 33.16802826000007],
            [-1.623591267999871, 33.19660532700003],
            [-1.674234171999927, 33.237972311000064],
            [-1.683380899999918, 33.2708385210001],
            [-1.683225869999887, 33.36923044900003],
            [-1.67283890799996, 33.39460357700001],
            [-1.659144653999931, 33.41977],
            [-1.640386107999859, 33.475528870000105],
            [-1.625399942999877, 33.494235738],
            [-1.612739216999927, 33.52146921800009],
            [-1.617338418999879, 33.55443878200005],
            [-1.662400268999932, 33.644691671000075],
            [-1.67325231999996, 33.65649973600007],
            [-1.69071895299993, 33.6673259490001],
            [-1.725393838999935, 33.67771291100006],
            [-1.740741739999919, 33.68660125700005],
            [-1.746787881999865, 33.70238840800006],
            [-1.742240355999911, 33.71776214700013],
            [-1.732576863999896, 33.72786488900006],
            [-1.720949666999928, 33.73636566200007],
            [-1.710821084999878, 33.747062683000095],
            [-1.703224650999914, 33.761816305000096],
            [-1.702501179999928, 33.772823385],
            [-1.713043172999988, 33.80199473],
            [-1.722086547999936, 33.85116485700006],
            [-1.718727579999921, 33.89808705600002],
            [-1.672115437999878, 34.0591883340001],
            [-1.669634968999901, 34.07921295200005],
            [-1.672085147999951, 34.09202070500008],
            [-1.674750935999981, 34.105955506],
            [-1.746064412999942, 34.290311178000096],
            [-1.771334187999912, 34.33470123300005],
            [-1.80962642399993, 34.37245086700001],
            [-1.702966267999955, 34.47967946400006],
            [-1.714231729999909, 34.48505381300002],
            [-1.750663614999894, 34.49417470300007],
            [-1.871121377999941, 34.59664906900012],
            [-1.862956502999907, 34.61359893800004],
            [-1.810504923999872, 34.68072662400006],
            [-1.786113646999922, 34.72584014900012],
            [-1.773142862999919, 34.734056702000046],
            [-1.769525512999849, 34.74134307900003],
            [-1.787715616999975, 34.75669097900003],
            [-1.892825479999942, 34.811674704000055],
            [-1.926725218999934, 34.83808136000003],
            [-1.979745238999953, 34.86526316400001],
            [-1.993491170999988, 34.878854065],
            [-1.998400430999908, 34.89270334900006],
            [-1.999692341999975, 34.90634592700006],
            [-2.003619750999945, 34.918179830000085],
            [-2.016280476999981, 34.926241354000084],
            [-2.061238972999888, 34.92970367400001],
            [-2.094932006999954, 34.94768707300001],
            [-2.126041218999887, 34.97192332000007],
            [-2.163299926999912, 34.994040833],
            [-2.193789021999919, 35.003600973000104],
            [-2.211669067999878, 35.02344472300008],
            [-2.22112585499994, 35.04995473300009],
            [-2.222564256999931, 35.089300848000065],
            [-2.200103318999936, 35.096136786000045],
            [-2.196115688999953, 35.09487539300005],
            [-2.192616339999915, 35.09446849200009],
            [-2.189442511999914, 35.093003648000035],
            [-2.186390753999945, 35.08869049700007],
            [-2.15689042899993, 35.10097890800006],
            [-2.122222459999932, 35.09467194200005],
            [-2.086089647999927, 35.08197663000004],
            [-2.052357550999943, 35.07501862200007],
            [-1.987700975999928, 35.082464911000045],
            [-1.964751756999931, 35.076239325000074],
            [-1.956450975999928, 35.07501862200007],
            [-1.949818488999938, 35.07713450700004],
            [-1.932484503999945, 35.08869049700007],
            [-1.838693813999953, 35.11090729400007],
            [-1.81273352799991, 35.12653229400007],
            [-1.804351365999935, 35.128119208000044],
            [-1.774240688999953, 35.12734609600005],
            [-1.761138475999928, 35.12962474200009],
            [-1.745594855999911, 35.13882070500006],
            [-1.712798631999931, 35.17059967700004],
            [-1.648833787999934, 35.18842194200005],
            [-1.637684699999909, 35.194525458000044],
            [-1.629505988999938, 35.212225653000075],
            [-1.510365363999938, 35.29547760600008],
            [-1.49087480399993, 35.30097077000005],
            [-1.395904100999928, 35.30939362200007],
            [-1.369536912999934, 35.31586334800005],
            [-1.364003058999913, 35.318345445000034],
            [-1.358957485999952, 35.32221100500004],
            [-1.33267167899993, 35.34935130400004],
            [-1.313791469999956, 35.35374583500004],
            [-1.294829881999931, 35.364569403000075],
            [-1.278635219999956, 35.37799713700008],
            [-1.267730272999927, 35.390326239000046],
            [-1.259185350999928, 35.41030508000006],
            [-1.247303839999915, 35.45774974200009],
            [-1.237049933999913, 35.47573476800005],
            [-1.225412563999953, 35.49127838700008],
            [-1.190337693999936, 35.56614817900004],
            [-1.183338995999918, 35.57648346600007],
            [-1.171538865999935, 35.58104075700004],
            [-1.148019985999952, 35.582098700000074],
            [-1.14281165299991, 35.58690013200004],
            [-1.117014126999948, 35.616888739000046],
            [-1.106353318999936, 35.62323639500005],
            [-1.082753058999913, 35.63735586100006],
            [-1.052072719999956, 35.66095612200007],
            [-1.040394660999937, 35.67641836100006],
            [-1.032948370999918, 35.68260325700004],
            [-0.996693488999938, 35.68960195500006],
            [-0.977650519999941, 35.69977448100008],
            [-0.961537238999938, 35.71124909100007],
            [-0.946278449999909, 35.71930573100008],
            [-0.922678188999953, 35.72516510600008],
            [-0.910227016999954, 35.724310614000046],
            [-0.904693162999934, 35.71588776200008],
            [-0.899403449999909, 35.711818752000056],
            [-0.887562628999945, 35.71596914300005],
            [-0.849476691999939, 35.73432038000004],
            [-0.825021938999953, 35.76854075700004],
            [-0.801665818999936, 35.77391185100004],
            [-0.793527798999946, 35.77008698100008],
            [-0.786122199999909, 35.76312897300005],
            [-0.777170376999948, 35.75641510600008],
            [-0.764027472999942, 35.75340403900009],
            [-0.754017706999946, 35.75226471600007],
            [-0.734486456999946, 35.74721914300005],
            [-0.723133917999917, 35.74599844000005],
            [-0.711293097999942, 35.74298737200007],
            [-0.705881313999953, 35.735663153000075],
            [-0.701324022999927, 35.72687409100007],
            [-0.692453579999949, 35.71930573100008],
            [-0.682606574999909, 35.71735260600008],
            [-0.644520636999914, 35.71930573100008],
            [-0.626454230999911, 35.72296784100007],
            [-0.60610917899993, 35.73094310100004],
            [-0.589344855999911, 35.74249909100007],
            [-0.577259894999941, 35.770819403000075],
            [-0.565052863999938, 35.77244700700004],
            [-0.551258917999917, 35.76902903900009],
            [-0.540923631999931, 35.76776764500005],
            [-0.530425584999932, 35.77289459800005],
            [-0.523426886999914, 35.77968984600005],
            [-0.477040167999917, 35.859361070000034],
            [-0.476063605999911, 35.87010325700004],
            [-0.478423631999931, 35.87287018400008],
            [-0.480336066999939, 35.87909577000005],
            [-0.480824347999942, 35.88572825700004],
            [-0.479481574999909, 35.89004140800006],
            [-0.473784959999932, 35.89126211100006],
            [-0.468006964999915, 35.888739325000074],
            [-0.462880011999914, 35.885199286000045],
            [-0.459055141999954, 35.88377513200004],
            [-0.448963995999918, 35.88434479400007],
            [-0.428130662999934, 35.882798570000034],
            [-0.418039516999954, 35.88377513200004],
            [-0.376128709999932, 35.90033600500004],
            [-0.348540818999936, 35.90704987200007],
            [-0.33617102799991, 35.900824286000045],
            [-0.331450975999928, 35.889553127000056],
            [-0.320708787999934, 35.884100653000075],
            [-0.309193488999938, 35.88117096600007],
            [-0.301909959999932, 35.87759023600006],
            [-0.298491990999935, 35.867173570000034],
            [-0.304595506999931, 35.853501695000034],
            [-0.301909959999932, 35.84284088700008],
            [-0.285552537999934, 35.82827383000006],
            [-0.259429490999935, 35.81753164300005],
            [-0.188059048999946, 35.80524323100008],
            [-0.145090298999946, 35.790350653000075],
            [-0.123890753999945, 35.78693268400008],
            [-0.113677537999934, 35.78880442900004],
            [-0.083078579999949, 35.79437897300005],
            [-0.038482225999928, 35.81329987200007],
            [0.002940300000091, 35.83803945500006],
            [0.03451582100007, 35.863267320000034],
            [0.069956902000058, 35.92182038000004],
            [0.080170118000069, 35.94700755400004],
            [0.114024285000085, 36.010199286000045],
            [0.12240644600007, 36.03335195500006],
            [0.123789910000085, 36.044582424000055],
            [0.127289259000065, 36.050767320000034],
            [0.135590040000068, 36.05560944200005],
            [0.145518425000091, 36.05996328300006],
            [0.15398196700005, 36.06500885600008],
            [0.202159050000091, 36.10651276200008],
            [0.219493035000085, 36.116522528000075],
            [0.283457879000082, 36.134426174000055],
            [0.294444207000083, 36.14077383000006],
            [0.299082879000082, 36.14740631700005],
            [0.321055535000085, 36.15888092700004],
            [0.329274936000047, 36.16498444200005],
            [0.332774285000085, 36.173814195000034],
            [0.33757571700005, 36.19749583500004],
            [0.342295769000089, 36.205959377000056],
            [0.360036655000044, 36.21385325700004],
            [0.38445071700005, 36.217962958000044],
            [0.428396030000044, 36.219631252000056],
            [0.451345248000052, 36.22321198100008],
            [0.468272332000083, 36.23224518400008],
            [0.483164910000085, 36.24359772300005],
            [0.556651238000086, 36.284084377000056],
            [0.594574415000068, 36.29315827000005],
            [0.611827019000089, 36.30548737200007],
            [0.627207879000082, 36.319240627000056],
            [0.644053582000083, 36.32884349200009],
            [0.663259311000047, 36.33258698100008],
            [0.740407748000052, 36.33775462400007],
            [0.75326582100007, 36.33860911700009],
            [0.768728061000047, 36.34471263200004],
            [0.802256707000083, 36.36359284100007],
            [0.864756707000083, 36.377386786000045],
            [0.88054446700005, 36.387152411000045],
            [0.890879754000082, 36.39638906500005],
            [0.91382897200009, 36.40912506700005],
            [0.92514082100007, 36.41815827000005],
            [0.929535352000073, 36.42593008000006],
            [0.932139519000089, 36.43455638200004],
            [0.936289910000085, 36.44358958500004],
            [0.945567254000082, 36.452337958000044],
            [0.96257571700005, 36.45815664300005],
            [1.007090691000087, 36.466864325000074],
            [1.044769727000073, 36.48688385600008],
            [1.11695397200009, 36.48712799700007],
            [1.138845248000052, 36.493394273000035],
            [1.178721550000091, 36.51089101800005],
            [1.202647332000083, 36.51439036700009],
            [1.24545332100007, 36.51357656500005],
            [1.265472852000073, 36.515326239000046],
            [1.288259311000047, 36.52122630400004],
            [1.346690300000091, 36.544989325000074],
            [1.367686394000089, 36.54791901200008],
            [1.385996941000087, 36.54515208500004],
            [1.429535352000073, 36.53221263200004],
            [1.45281009200005, 36.52802155200004],
            [1.47632897200009, 36.528957424000055],
            [1.517425977000073, 36.538723049000055],
            [1.70093834700009, 36.54718659100007],
            [1.71656334700009, 36.54791901200008],
            [1.726735873000052, 36.549994208000044],
            [1.750173373000052, 36.55914948100008],
            [1.761241082000083, 36.56159088700008],
            [1.770030144000089, 36.56049225500004],
            [1.791514519000089, 36.55548737200007],
            [1.802907748000052, 36.55536530200004],
            [1.857595248000052, 36.56745026200008],
            [1.91382897200009, 36.57021719000005],
            [1.960459832000083, 36.562201239000046],
            [1.972829623000052, 36.56159088700008],
            [2.05990644600007, 36.57013580900008],
            [2.309825066000087, 36.630519924000055],
            [2.329600457000083, 36.63727448100008],
            [2.351573113000086, 36.638332424000055],
            [2.373301629000082, 36.63385651200008],
            [2.391856316000087, 36.624253648000035],
            [2.39820397200009, 36.615301825000074],
            [2.40015709700009, 36.60618724200009],
            [2.40406334700009, 36.59918854400007],
            [2.416026238000086, 36.59634023600006],
            [2.426768425000091, 36.59528229400007],
            [2.447276238000086, 36.59056224200009],
            [2.457041863000086, 36.589504299000055],
            [2.600759311000047, 36.59634023600006],
            [2.632985873000052, 36.605129299000055],
            [2.727549675000091, 36.665228583000044],
            [2.792979363000086, 36.69293854400007],
            [2.818695509000065, 36.71088288000004],
            [2.843597852000073, 36.74038320500006],
            [2.849864129000082, 36.75405508000006],
            [2.875661655000044, 36.77480703300006],
            [2.933116082000083, 36.808579820000034],
            [2.977061394000089, 36.81586334800005],
            [2.984873894000089, 36.814968166000085],
            [3.014170769000089, 36.811712958000044],
            [3.047862175000091, 36.794989325000074],
            [3.07398522200009, 36.77138906500005],
            [3.101817254000082, 36.75189850500004],
            [3.140147332000083, 36.74164459800005],
            [3.173269076000054, 36.742621161000045],
            [3.17937259200005, 36.74282461100006],
            [3.210459832000083, 36.75739166900007],
            [3.221202019000089, 36.77142975500004],
            [3.226084832000083, 36.78620026200008],
            [3.227305535000085, 36.81232330900008],
            [3.237803582000083, 36.81305573100008],
            [3.302989129000082, 36.788763739000046],
            [3.340505405000044, 36.78070709800005],
            [3.46070397200009, 36.775091864000046],
            [3.480479363000086, 36.77724844000005],
            [3.519053582000083, 36.78660716400009],
            [3.539805535000085, 36.788763739000046],
            [3.55046634200005, 36.791449286000045],
            [3.558116082000083, 36.79767487200007],
            [3.564300977000073, 36.804348049000055],
            [3.570567254000082, 36.808579820000034],
            [3.580414259000065, 36.80996328300006],
            [3.601817254000082, 36.80809153900009],
            [3.612071160000085, 36.808579820000034],
            [3.649668816000087, 36.82396067900004],
            [3.709483269000089, 36.87319570500006],
            [3.74187259200005, 36.89118073100008],
            [3.82748457100007, 36.91290924700007],
            [3.873871290000068, 36.917222398000035],
            [3.912608269000089, 36.91160716400009],
            [3.948252800000091, 36.89329661700009],
            [3.964040561000047, 36.89118073100008],
            [3.974864129000082, 36.892279364000046],
            [3.996429884000065, 36.896918036000045],
            [4.031423373000052, 36.897772528000075],
            [4.039480014000048, 36.896918036000045],
            [4.085459832000083, 36.89207591400009],
            [4.10482832100007, 36.88373444200005],
            [4.146494988000086, 36.90180084800005],
            [4.15951582100007, 36.90420156500005],
            [4.17156009200005, 36.90216705900008],
            [4.19703209700009, 36.89325592700004],
            [4.210459832000083, 36.89118073100008],
            [4.222829623000052, 36.894191799000055],
            [4.249278191000087, 36.907863674000055],
            [4.261973504000082, 36.91160716400009],
            [4.278575066000087, 36.91046784100007],
            [4.30600019600007, 36.900458075000074],
            [4.320323113000086, 36.89801666900007],
            [4.440684441000087, 36.91160716400009],
            [4.452972852000073, 36.91006094000005],
            [4.46810957100007, 36.90599192900004],
            [4.482432488000086, 36.900458075000074],
            [4.49195397200009, 36.894598700000074],
            [4.504079623000052, 36.88930898600006],
            [4.536387566000087, 36.88857656500005],
            [4.55054772200009, 36.88373444200005],
            [4.581553582000083, 36.89492422100005],
            [4.59148196700005, 36.89524974200009],
            [4.622894727000073, 36.89638906500005],
            [4.698008660000085, 36.89118073100008],
            [4.769053582000083, 36.89801666900007],
            [4.787119988000086, 36.895412502000056],
            [4.949880405000044, 36.83978913000004],
            [4.968272332000083, 36.82566966400009],
            [4.973643425000091, 36.81891510600008],
            [4.98568769600007, 36.81708405200004],
            [4.999522332000083, 36.81712474200009],
            [5.009287957000083, 36.816066799000055],
            [5.016449415000068, 36.810980536000045],
            [5.025238477000073, 36.79865143400008],
            [5.029144727000073, 36.794989325000074],
            [5.045909050000091, 36.78851959800005],
            [5.065603061000047, 36.78351471600007],
            [5.086192254000082, 36.78082916900007],
            [5.10482832100007, 36.781317450000074],
            [5.084808790000068, 36.73261139500005],
            [5.090179884000065, 36.716782945000034],
            [5.118418816000087, 36.69936758000006],
            [5.235850457000083, 36.65094635600008],
            [5.269053582000083, 36.64411041900007],
            [5.30437259200005, 36.643011786000045],
            [5.37240644600007, 36.65094635600008],
            [5.428070509000065, 36.66388580900008],
            [5.433848504000082, 36.665228583000044],
            [5.464854363000086, 36.665228583000044],
            [5.469574415000068, 36.66771067900004],
            [5.48218834700009, 36.68024323100008],
            [5.489105665000068, 36.68512604400007],
            [5.529144727000073, 36.69765859600005],
            [5.549001498000052, 36.70970286700009],
            [5.562754754000082, 36.74599844000005],
            [5.576182488000086, 36.761379299000055],
            [5.593923373000052, 36.773871161000045],
            [5.611989780000044, 36.781317450000074],
            [5.65593509200005, 36.79181549700007],
            [5.674571160000085, 36.79962799700007],
            [5.710459832000083, 36.825506903000075],
            [5.73373457100007, 36.83234284100007],
            [5.758799675000091, 36.83340078300006],
            [5.82781009200005, 36.82176341400009],
            [5.86882571700005, 36.82294342700004],
            [6.037119988000086, 36.853583075000074],
            [6.19703209700009, 36.902329820000034],
            [6.23568769600007, 36.921210028000075],
            [6.256846550000091, 36.94578685100004],
            [6.258555535000085, 36.966782945000034],
            [6.254730665000068, 36.983303127000056],
            [6.254405144000089, 36.99896881700005],
            [6.266856316000087, 37.01776764500005],
            [6.274424675000091, 37.02423737200007],
            [6.314626498000052, 37.04865143400008],
            [6.328868035000085, 37.06191640800006],
            [6.338715040000068, 37.06928131700005],
            [6.371592644000089, 37.08348216400009],
            [6.41578209700009, 37.092962958000044],
            [6.462412957000083, 37.09393952000005],
            [6.502696160000085, 37.08295319200005],
            [6.538584832000083, 37.06037018400008],
            [6.544200066000087, 37.05878327000005],
            [6.54468834700009, 37.04857005400004],
            [6.547048373000052, 37.04120514500005],
            [6.552256707000083, 37.03668854400007],
            [6.561289910000085, 37.035142320000034],
            [6.572764519000089, 37.027777411000045],
            [6.583262566000087, 36.98981354400007],
            [6.599457227000073, 36.973089911000045],
            [6.614105665000068, 36.977850653000075],
            [6.631602410000085, 36.97239817900004],
            [6.651133660000085, 36.96385325700004],
            [6.671153191000087, 36.959418036000045],
            [6.82203209700009, 36.95262278900009],
            [6.834808790000068, 36.94912344000005],
            [6.852793816000087, 36.940334377000056],
            [6.869639519000089, 36.92918528900009],
            [6.880056186000047, 36.91844310100004],
            [6.879649285000085, 36.90208567900004],
            [6.909434441000087, 36.89305247600004],
            [6.94857832100007, 36.89004140800006],
            [6.975596550000091, 36.89118073100008],
            [7.064463738000086, 36.913316148000035],
            [7.092295769000089, 36.92593008000006],
            [7.108083530000044, 36.92031484600005],
            [7.133311394000089, 36.915269273000035],
            [7.156993035000085, 36.91469961100006],
            [7.167491082000083, 36.92218659100007],
            [7.176442905000044, 36.93187083500004],
            [7.218760613000086, 36.96084219000005],
            [7.232920769000089, 36.966864325000074],
            [7.239024285000085, 36.97150299700007],
            [7.247080925000091, 36.98232656500005],
            [7.254242384000065, 36.99469635600008],
            [7.257334832000083, 37.00413646000004],
            [7.25554446700005, 37.01536692900004],
            [7.250498894000089, 37.023138739000046],
            [7.211110873000052, 37.05703359600005],
            [7.181651238000086, 37.07672760600008],
            [7.181651238000086, 37.08295319200005],
            [7.19271894600007, 37.08429596600007],
            [7.212168816000087, 37.08930084800005],
            [7.222666863000086, 37.08978913000004],
            [7.232758009000065, 37.087225653000075],
            [7.25131269600007, 37.07859935100004],
            [7.260508660000085, 37.07672760600008],
            [7.262705925000091, 37.07599518400008],
            [7.266449415000068, 37.07469310100004],
            [7.270681186000047, 37.07103099200009],
            [7.27475019600007, 37.06932200700004],
            [7.28101647200009, 37.07306549700007],
            [7.288259311000047, 37.08026764500005],
            [7.29265384200005, 37.08250560100004],
            [7.297699415000068, 37.08295319200005],
            [7.307302280000044, 37.080145575000074],
            [7.32585696700005, 37.071193752000056],
            [7.335948113000086, 37.06928131700005],
            [7.344411655000044, 37.07143789300005],
            [7.369965040000068, 37.08295319200005],
            [7.383474155000044, 37.08299388200004],
            [7.386241082000083, 37.082098700000074],
            [7.386892123000052, 37.078111070000034],
            [7.394053582000083, 37.06928131700005],
            [7.39820397200009, 37.05801015800006],
            [7.404633009000065, 37.05158112200007],
            [7.418223504000082, 37.048814195000034],
            [7.438324415000068, 37.04857005400004],
            [7.447113477000073, 37.04661692900004],
            [7.456065300000091, 37.04197825700004],
            [7.47242272200009, 37.050034898000035],
            [7.490244988000086, 37.05499909100007],
            [7.526133660000085, 37.03314850500004],
            [7.555918816000087, 37.007879950000074],
            [7.588877800000091, 36.987616278000075],
            [7.633555535000085, 36.980536200000074],
            [7.643402540000068, 36.98265208500004],
            [7.652191602000073, 36.98623281500005],
            [7.66187584700009, 36.98847077000005],
            [7.674489780000044, 36.986761786000045],
            [7.685801629000082, 36.982407945000034],
            [7.695974155000044, 36.976996161000045],
            [7.70484459700009, 36.97052643400008],
            [7.712738477000073, 36.96320221600007],
            [7.760752800000091, 36.966864325000074],
            [7.770762566000087, 36.97011953300006],
            [7.789073113000086, 36.98655833500004],
            [7.79859459700009, 36.99359772300005],
            [7.791026238000086, 36.97321198100008],
            [7.778575066000087, 36.95111725500004],
            [7.774261915000068, 36.93146393400008],
            [7.791188998000052, 36.91844310100004],
            [7.773448113000086, 36.889960028000075],
            [7.773773634000065, 36.88975657800006],
            [7.80990644600007, 36.86815013200004],
            [7.866465691000087, 36.854396877000056],
            [7.908457879000082, 36.84955475500004],
            [8.049978061000047, 36.87759023600006],
            [8.073008660000085, 36.88739655200004],
            [8.093028191000087, 36.90180084800005],
            [8.233164910000085, 36.95807526200008],
            [8.251149936000047, 36.94867584800005],
            [8.268728061000047, 36.93374258000006],
            [8.288096550000091, 36.92593008000006],
            [8.333262566000087, 36.927801825000074],
            [8.355967644000089, 36.92593008000006],
            [8.374034050000091, 36.91844310100004],
            [8.388845248000052, 36.92324453300006],
            [8.401621941000087, 36.91860586100006],
            [8.414398634000065, 36.910223700000074],
            [8.428721550000091, 36.90420156500005],
            [8.463226759000065, 36.901556708000044],
            [8.497569207000083, 36.90420156500005],
            [8.601898634000065, 36.93935781500005],
            [8.60251042862123, 36.93951076359987],
            [8.605655151000065, 36.9130451460001],
            [8.604828329000043, 36.90097869900002],
            [8.608238973000084, 36.89072092700003],
            [8.642552124000105, 36.84850128200007],
            [8.641725301000065, 36.83635732100008],
            [8.623845255000106, 36.82607371100006],
            [8.554495483000068, 36.803646139000065],
            [8.520078979000118, 36.79791005500003],
            [8.482665242000053, 36.79997711300008],
            [8.44401127100005, 36.79620473300007],
            [8.41310876500006, 36.783905742000016],
            [8.406700887000113, 36.767989400000076],
            [8.441634155000116, 36.753209941000065],
            [8.46178796400008, 36.73279775000013],
            [8.453209676000142, 36.69765777600007],
            [8.430368693000048, 36.66262115500005],
            [8.40794112100005, 36.642622376000034],
            [8.286914917000075, 36.58340118400004],
            [8.222319376000115, 36.56376414],
            [8.193483927000074, 36.548984681],
            [8.169919474000096, 36.525833639],
            [8.167890169000145, 36.49199497900007],
            [8.16785241700012, 36.49136545900002],
            [8.208780151000042, 36.477826233000044],
            [8.295596557000124, 36.468679504000065],
            [8.314923543000077, 36.46061798200007],
            [8.333837118000105, 36.45638051400003],
            [8.349236695000116, 36.44878407800006],
            [8.357711629000107, 36.430387268000075],
            [8.359675333000041, 36.41121531200007],
            [8.358125041000108, 36.36992584300013],
            [8.355423113000114, 36.356115986000034],
            [8.354404338000109, 36.35090891500006],
            [8.30706872600004, 36.243628642000104],
            [8.302314494000143, 36.202339172],
            [8.30706872600004, 36.18249542300002],
            [8.314510132000066, 36.16394358300006],
            [8.317093953000068, 36.14590850900008],
            [8.307998901000104, 36.126994934000024],
            [8.296733439000121, 36.11040680000012],
            [8.27564945500012, 36.036819560000126],
            [8.272445516000033, 35.98173248300007],
            [8.268423401000064, 35.969863948000025],
            [8.24722741700009, 35.907318421000056],
            [8.241439656000125, 35.827736715000114],
            [8.245780477000096, 35.7853103640001],
            [8.257666057000023, 35.750325419],
            [8.30655196100011, 35.68490305600001],
            [8.323605184000144, 35.652191874000025],
            [8.327225481000085, 35.621405428000045],
            [8.33704105600009, 35.53793528300007],
            [8.336730997000103, 35.50837636300004],
            [8.300867553000074, 35.43747629900007],
            [8.290015502000102, 35.4025947060001],
            [8.287948446000144, 35.366059469000064],
            [8.294356323000102, 35.32508005800004],
            [8.317404012000054, 35.28947499600007],
            [8.35523116100012, 35.274333802000044],
            [8.396882365000067, 35.26368845700007],
            [8.431298869000102, 35.2417259730001],
            [8.42137699300011, 35.222088929000066],
            [8.360915568000081, 35.14591786800007],
            [8.313683309000055, 35.10307810500002],
            [8.300454142000149, 35.06767974900002],
            [8.28288415600008, 34.994040833],
            [8.259009644000088, 34.9406590790001],
            [8.248881062000123, 34.90195343100008],
            [8.25074141400006, 34.864746399000055],
            [8.269344930000102, 34.763874003000055],
            [8.266554403000043, 34.75028310200007],
            [8.258714460000078, 34.741298],
            [8.257355997000047, 34.73974111000011],
            [8.225213257000092, 34.711680807000064],
            [8.213431030000095, 34.696746318000024],
            [8.21064050300015, 34.681191712],
            [8.236478719000075, 34.64765370800008],
            [8.228830607000077, 34.63643992200004],
            [8.19286381000012, 34.617733053000066],
            [8.18655928600009, 34.609568176000025],
            [8.179531291000103, 34.59215321900011],
            [8.175190470000103, 34.58528025300005],
            [8.167232300000137, 34.57856231700002],
            [8.143667846000142, 34.56672841400008],
            [8.102483160000105, 34.53635470800005],
            [8.094058472000086, 34.530141500000056],
            [7.999077189000076, 34.49417470300007],
            [7.957322632000114, 34.46942169200007],
            [7.870609579000075, 34.437899068],
            [7.831542195000054, 34.41438629200009],
            [7.811905151000104, 34.379272156000056],
            [7.774284709000085, 34.26095896400001],
            [7.765293009000061, 34.2447067260001],
            [7.752787313000056, 34.23214935300008],
            [7.733873738000113, 34.223777771000115],
            [7.670311727000126, 34.21530283600002],
            [7.631451049000077, 34.1991022750001],
            [7.604062541000133, 34.175486145],
            [7.579567911000083, 34.14845937200006],
            [7.539228219000051, 34.11375783900006],
            [7.51745284000009, 34.09502594000013],
            [7.503706909000073, 34.067973328000065],
            [7.500606323000113, 33.994256898000046],
            [7.47983239800007, 33.89390126500008],
            [7.484896688000049, 33.855014750000024],
            [7.49853926600008, 33.79997935000007],
            [7.505463908000138, 33.78284861300001],
            [7.534196004000137, 33.736236471000055],
            [7.544427938000126, 33.68424998000002],
            [7.553006225000075, 33.65874766100008],
            [7.616568237000138, 33.565962626000086],
            [7.69315270900006, 33.45410898900009],
            [7.708242228000131, 33.41486073800003],
            [7.70828622300013, 33.41070398400008],
            [7.709689168000125, 33.278150737000075],
            [7.724985392000093, 33.231409404000075],
            [7.75072025500009, 33.20766408300004],
            [7.787513875000087, 33.19831064900008],
            [7.83546960400011, 33.19453826900006],
            [7.871953166000111, 33.18412546800003],
            [7.982747437000114, 33.11681691500006],
            [8.002177775000092, 33.10836781900004],
            [8.022641642000082, 33.1030451460001],
            [8.043622274000057, 33.10183074900006],
            [8.064499552000143, 33.105783997000046],
            [8.086823771000098, 33.094285991000035],
            [8.181391642000108, 32.96982330300001],
            [8.28288415600008, 32.83636891700006],
            [8.296423381000068, 32.80440704300007],
            [8.309962606000028, 32.66387298600007],
            [8.31957442200013, 32.56059763600011],
            [8.331253296000114, 32.52762807200007],
            [8.33262728000011, 32.526355407],
            [8.359985392000112, 32.50101470900002],
            [8.482665242000053, 32.43479136200004],
            [8.642345419000037, 32.336657817000074],
            [8.851531616000074, 32.20824188200008],
            [9.019893433000021, 32.104863180000095],
            [9.033742716000091, 32.090755514000065],
            [9.045008179000149, 32.07184194000011],
            [9.063303822000108, 32.00019151300005],
            [9.065988810000135, 31.989676412000094],
            [9.094514201000095, 31.879605611000088],
            [9.122729533000069, 31.76953481000008],
            [9.1511515710001, 31.659567363000107],
            [9.179470255000098, 31.5494965620001],
            [9.207788941000075, 31.439425761000095],
            [9.236210978000088, 31.329406637000076],
            [9.26442631100008, 31.21933583600007],
            [9.292951701000106, 31.10931671200008],
            [9.321270386, 30.999245911000074],
            [9.349589070000093, 30.889175110000068],
            [9.377907756000099, 30.779155985000088],
            [9.406329793000111, 30.66908518500007],
            [9.434751831000142, 30.55906606000009],
            [9.46307051600013, 30.44904693700009],
            [9.491389201000032, 30.338976135000095],
            [9.519707885000116, 30.22890533500008],
            [9.286543823000073, 30.11712921200011],
            [9.310004923000065, 30.08436635400001],
            [9.369486582000093, 30.02279375700006],
            [9.42172937, 29.968714498000068],
            [9.54968021600007, 29.802316386000072],
            [9.66770918800006, 29.608323059000057],
            [9.746929158500109, 29.368428141500132],
            [9.8261491290001, 29.128533224000094],
            [9.848266642000112, 28.975726013000084],
            [9.851263875000114, 28.785995992000025],
            [9.827275804000067, 28.618646663],
            [9.776953166000112, 28.26757802300007],
            [9.789872273000128, 28.209442037000073],
            [9.93590987100012, 27.866723939000067],
            [9.93425622500007, 27.827398173000077],
            [9.931273724000022, 27.81864196800008],
            [9.863356160000109, 27.619245504000034],
            [9.846612996000147, 27.599298401000098],
            [9.818501017000102, 27.585733337000093],
            [9.793903036000131, 27.56973948200006],
            [9.797106974000087, 27.54891388],
            [9.811679728000058, 27.52653798500002],
            [9.821601603000147, 27.505686544000056],
            [9.813643432000106, 27.48648874900006],
            [9.77054528800008, 27.444217428000073],
            [9.756282592000105, 27.423030091],
            [9.743053426000102, 27.364118958000105],
            [9.726516968000112, 27.32468984000009],
            [9.72186608900006, 27.308463440000068],
            [9.721349324000101, 27.29187530600008],
            [9.806098674000054, 27.025121562],
            [9.825529012000118, 26.920580139],
            [9.835140828000135, 26.90099477200006],
            [9.846096232000122, 26.891951396000096],
            [9.890848022000085, 26.86957550100003],
            [9.906661010000079, 26.857483216000034],
            [9.910588419000135, 26.843117168000035],
            [9.88547367400011, 26.7366120410001],
            [9.88257979300002, 26.701782125000037],
            [9.89405196100006, 26.673980205000092],
            [9.896325725000054, 26.65279286700003],
            [9.854571167000103, 26.524376933000028],
            [9.83576094500009, 26.504223125000053],
            [9.482604207000065, 26.35255279500005],
            [9.48136397200011, 26.33260569300002],
            [9.477643269000112, 26.3155524700001],
            [9.468858276000105, 26.30103139300006],
            [9.434751831000142, 26.271989238000046],
            [9.416458374000086, 26.232250062000062],
            [9.402505737000098, 26.216178691],
            [9.377804403000084, 26.168946432000055],
            [9.401162150000118, 26.11339426700006],
            [9.541308634000103, 25.936350810000064],
            [9.693960816000072, 25.743494364000057],
            [9.816744019000055, 25.588465068000048],
            [9.969499552000059, 25.395401917000086],
            [10.007946818000079, 25.331426493],
            [10.021382690000053, 25.268019511000077],
            [10.025516805000052, 25.136399638000015],
            [10.029960978000076, 24.99506459600009],
            [10.032028035000025, 24.856339213000112],
            [10.044533732000048, 24.829622498000063],
            [10.19336185700007, 24.74993744000001],
            [10.212172079000084, 24.722858989000045],
            [10.229742065000067, 24.629944763000097],
            [10.242247762000147, 24.59511484800005],
            [10.260334513000146, 24.576640524000126],
            [10.391799357000082, 24.479979757000066],
            [10.410506225000063, 24.473287659000036],
            [10.450193726000066, 24.476930848000038],
            [10.56677575700013, 24.516463318000078],
            [10.677363322000076, 24.55385121700003],
            [10.69906742300006, 24.556124980000035],
            [10.720668172000046, 24.552300924000107],
            [10.911354207000045, 24.494500834000107],
            [11.149995971000095, 24.422334697000096],
            [11.467240356000048, 24.326338558000046],
            [11.50863041200003, 24.313814189000098],
            [11.541393270000128, 24.29751027500008],
            [11.56712813300004, 24.266840312000042],
            [11.636477905000078, 24.137649231000054],
            [11.708618205000079, 24.00298044800006],
            [11.710140444000075, 24.000137321000082],
            [11.82230635600007, 23.790641989000065],
            [11.892379598000105, 23.66005564400008],
            [11.96886071700007, 23.517351176000105],
            [11.900854533000114, 23.477172750000094],
            [11.832744995000098, 23.43704600100007],
            [11.76473881000004, 23.396945089],
            [11.696732626000141, 23.3568441770001],
            [11.62862308700005, 23.316717428000075],
            [11.560513550000024, 23.27659067800009],
            [11.492610717000076, 23.236515605000093],
            [11.424501180000078, 23.196414693000108],
            [11.356391642000062, 23.156262106],
            [11.288488810000018, 23.1161611940001],
            [11.220379273000106, 23.076060283000103],
            [11.1522697340001, 23.035881857000092],
            [11.084366903000074, 22.99575510600009],
            [11.016257364000069, 22.955654195000093],
            [10.948147827000042, 22.91552744600007],
            [10.88003828900014, 22.875374857000068],
            [10.812032104000053, 22.835325623000088],
            [10.74392256700014, 22.795198873000075],
            [10.675813029000068, 22.75504628500009],
            [10.607806844000066, 22.714945374000095],
            [10.539800659000093, 22.674896139000012],
            [10.471691122000095, 22.634743551],
            [10.403788289000147, 22.59464264000009],
            [10.33567875200012, 22.554541728000103],
            [10.267569213000115, 22.514337463000075],
            [10.199563029000046, 22.474236552],
            [10.131556844000073, 22.434135641000083],
            [10.063447306000057, 22.394034729000097],
            [9.995441122000102, 22.353882142000074],
            [9.927434936000111, 22.31378123000009],
            [9.859325399000113, 22.273680318000075],
            [9.791319214000026, 22.233579407],
            [9.723313029000053, 22.193426819000095],
            [9.655203491000037, 22.1533259080001],
            [9.587197306000064, 22.113224997000103],
            [9.519087769000066, 22.073072408000073],
            [9.451081583000075, 22.03291982000006],
            [9.383075399000091, 21.992818909000064],
            [9.314965860000086, 21.952717997],
            [9.246959676000131, 21.912565410000084],
            [9.17895349100013, 21.872516175],
            [9.110843953000142, 21.832363587000074],
            [9.042837769000073, 21.79226267500009],
            [8.974831583000082, 21.752110087000077],
            [8.906722046000084, 21.712060852],
            [8.838612508000068, 21.671908265000084],
            [8.770606323000095, 21.6318073530001],
            [8.702496786000097, 21.591654765000087],
            [8.634490600000106, 21.551502177000074],
            [8.566381063000108, 21.511349589000062],
            [8.498374878000021, 21.471300354000064],
            [8.430265340000119, 21.43114776600008],
            [8.36225915500006, 21.391046855000084],
            [8.29425297000006, 21.350945944000088],
            [8.226143432000072, 21.310845032000074],
            [8.158033895000045, 21.27074412000009],
            [8.090131063000115, 21.230591533000066],
            [8.022021525000099, 21.19049062100008],
            [7.953911987000083, 21.150389710000084],
            [7.886009155000039, 21.110237122000072],
            [7.817899617000137, 21.07008453400006],
            [7.749790079000121, 21.029983622000074],
            [7.681887247000077, 20.989831034000062],
            [7.613777710000079, 20.949730123000066],
            [7.482726278000058, 20.872577210000102],
            [7.383610881000038, 20.791651917000095],
            [7.312297404000077, 20.73346425400011],
            [7.240880574000073, 20.675173238000056],
            [7.169463745000144, 20.61698557600006],
            [7.098046916000044, 20.558746236000033],
            [7.020532267000078, 20.49544260700013],
            [6.982808471000055, 20.463609925000085],
            [6.925137574000075, 20.414000549000022],
            [6.862092326000038, 20.359740295000066],
            [6.799047078000115, 20.30553171800004],
            [6.73610518400011, 20.25132314000011],
            [6.672956583000143, 20.197114563000085],
            [6.60996301300014, 20.14285430900013],
            [6.546917765000103, 20.088645732000103],
            [6.483769165000041, 20.03438547800006],
            [6.420930623000061, 19.980176900000046],
            [6.357782023000112, 19.92591664600009],
            [6.294736775000075, 19.871682231000065],
            [6.231691528000056, 19.81747365300002],
            [6.168646281000122, 19.763213399000065],
            [6.105601033000084, 19.70900482200004],
            [6.04255578600015, 19.654744568000112],
            [5.979407186000117, 19.600535991000086],
            [5.91636193800008, 19.54627573700013],
            [5.837607055000092, 19.478631287000056],
            [5.794302205000122, 19.449795838000014],
            [5.749343709000101, 19.433698629000062],
            [5.620462687000071, 19.40899729400003],
            [5.520830525000093, 19.389902853000038],
            [5.301825806000096, 19.347993266000074],
            [5.082821085000091, 19.306006165000056],
            [4.983188924000046, 19.286963399000072],
            [4.794466593000067, 19.250764059000048],
            [4.605847616000091, 19.214616394000117],
            [4.417228637000051, 19.178417054000093],
            [4.228609660000103, 19.14224355100005],
            [4.057560669000026, 19.11043670700012],
            [3.886511678000147, 19.078629862000085],
            [3.790290968000079, 19.060770275000024],
            [3.715566040000112, 19.046900533000056],
            [3.544620402000049, 19.015067851000097],
            [3.439820598000097, 18.99563751300012],
            [3.439717245000054, 18.99563751300012],
            [3.358688598000128, 18.97685312900002],
            [3.333057088000089, 18.975561218000067],
            [3.318380981000075, 18.97770579000006],
            [3.308355754000075, 18.98168487600013],
            [3.284894653000094, 18.995740866000048],
            [3.225983520000085, 19.051060486000083],
            [3.179784790000042, 19.069999899000024],
            [3.158597452000066, 19.08154958100006],
            [3.138753703000077, 19.096044820000103],
            [3.120873657000118, 19.112813823000053],
            [3.104130493000071, 19.13552561500005],
            [3.102683553000077, 19.15356069000005],
            [3.111778605000069, 19.17133738200006],
            [3.126558065000069, 19.19335154300005],
            [3.134206176000134, 19.21285939600004],
            [3.139270467000131, 19.22192861000009],
            [3.152706340000066, 19.230196839000044],
            [3.174410441000077, 19.251642558000086],
            [3.178854614000073, 19.268721619000118],
            [3.183815551000123, 19.307504782000066],
            [3.192910604000105, 19.325798238000047],
            [3.211514119000043, 19.34086191900012],
            [3.232701457000104, 19.351843161000104],
            [3.250994914000074, 19.36545990000009],
            [3.260813436000149, 19.38832672200003],
            [3.258229614000129, 19.41039255800011],
            [3.247480916000114, 19.426463928000075],
            [3.234768514000081, 19.441346741000032],
            [3.225983520000085, 19.45969187400003],
            [3.226190226000142, 19.46920033800008],
            [3.231667928000121, 19.489044088000085],
            [3.232288046000093, 19.495477804000032],
            [3.228050578000136, 19.504159444],
            [3.222882935000143, 19.508061015000052],
            [3.217508585000076, 19.511161601000097],
            [3.21223758900004, 19.51715606700013],
            [3.199421834000077, 19.55376881900007],
            [3.198284952000051, 19.592396953000062],
            [3.216785116000096, 19.794064230000075],
            [3.212754353000093, 19.807758484000075],
            [3.198801717000094, 19.82052256200005],
            [3.183195435000073, 19.827731425000096],
            [3.147021932000115, 19.837937520000068],
            [3.130485473000135, 19.84522389800007],
            [3.072607869000109, 19.888890483000026],
            [2.946000610000112, 19.941652120000057],
            [2.671805461000105, 19.996222433000085],
            [2.616925089000091, 19.99836700400006],
            [2.525664510000098, 20.015161845000037],
            [2.514812459000069, 20.01593699200005],
            [2.495382120000073, 20.020096944000088],
            [2.459311970000073, 20.03877797500006],
            [2.439881632000095, 20.046090190000044],
            [2.415697062000021, 20.051283671000064],
            [2.400400838000081, 20.05655466700007],
            [2.388721964000098, 20.06740671800013],
            [2.348207641000073, 20.137634989],
            [2.316478312000072, 20.180164693000066],
            [2.279581339000032, 20.217940166000048],
            [2.218189738000149, 20.264087220000064],
            [2.200826456000129, 20.273905742000053],
            [2.182429647000049, 20.27850494400009],
            [2.161345662000116, 20.274939271000036],
            [2.138194620000121, 20.26072825100006],
            [2.097473592000142, 20.224193013000033],
            [2.07122196500012, 20.213263448000063],
            [2.056339152000078, 20.215046285000042],
            [1.993397257000083, 20.23594940200003],
            [1.983372030000055, 20.241918030000036],
            [1.975620564000053, 20.248429260000123],
            [1.967145629000044, 20.253416036000075],
            [1.955260050000106, 20.254914653000085],
            [1.941204061000093, 20.251116435000043],
            [1.924254191000102, 20.23613027000006],
            [1.91340214000013, 20.231091817],
            [1.891387980000076, 20.23178944900009],
            [1.88384322100012, 20.244140117000043],
            [1.880329223000075, 20.263053691],
            [1.870614054000015, 20.28354339600007],
            [1.855007771000089, 20.29483469700004],
            [1.838884725000099, 20.295919902000023],
            [1.820901326000097, 20.293594463000076],
            [1.799197225000114, 20.29488637300004],
            [1.778113241000085, 20.304291484000103],
            [1.659154093000069, 20.39751576700003],
            [1.649232219000083, 20.412088521000086],
            [1.650059041000105, 20.487019348000032],
            [1.643961222000144, 20.522676087000022],
            [1.623704060000136, 20.551253154000094],
            [1.559728637000148, 20.597503561000067],
            [1.520351196000149, 20.61698557600006],
            [1.483454223000109, 20.622618307],
            [1.465780884000111, 20.633522034000052],
            [1.447487426000066, 20.63874135300007],
            [1.407179810000088, 20.64504587900008],
            [1.363978312000057, 20.65770660500003],
            [1.346925089000138, 20.66912709500012],
            [1.331525512000042, 20.687937317000134],
            [1.310544881000055, 20.722715556000068],
            [1.296695597000081, 20.73346425400011],
            [1.273337850000132, 20.739407044000117],
            [1.252253865000114, 20.73899363200009],
            [1.212463012000086, 20.730880432],
            [1.191275675000043, 20.730570374000123],
            [1.168538045000076, 20.73346425400011],
            [1.154585408000059, 20.73878692600006],
            [1.147247355000076, 20.751447652000095],
            [1.144560180000042, 20.776252340000028],
            [1.145283651000057, 20.795889384000063],
            [1.167504516000093, 20.886013082000048],
            [1.180113566000102, 20.99530873600004],
            [1.177943156000111, 21.01732289600004],
            [1.15933964000007, 21.081505025000055],
            [1.146523885000079, 21.101710511000064],
            [1.029321737000117, 21.178346660000088],
            [0.942608683000088, 21.23503570600009],
            [0.855998983000035, 21.291673075000077],
            [0.769389282000105, 21.348310445000052],
            [0.682676229000151, 21.40489613900003],
            [0.596066528000108, 21.461585185000033],
            [0.509456827000093, 21.518274231000035],
            [0.422795451000127, 21.574963277000037],
            [0.336159912000085, 21.631600647000127],
            [0.249498535000043, 21.688238017000018],
            [0.162966350000147, 21.744823711],
            [0.07625329600009, 21.801461081000085],
            [0.003734557000115, 21.84889880000007],
            [-0.010408080999866, 21.858150126000098],
            [-0.097043619999909, 21.91483917300009],
            [-0.183730834999949, 21.971476543000065],
            [-0.270392211999905, 22.02811391300007],
            [-0.357027749999929, 22.084751282000056],
            [-0.443663289999989, 22.141388651000042],
            [-0.530324665999927, 22.198077698000063],
            [-0.616934366999971, 22.254766744000065],
            [-0.703647419999925, 22.31140411400004],
            [-0.790308796999881, 22.368041483000027],
            [-0.876918497999895, 22.424627177],
            [-0.963579874999937, 22.481264547000094],
            [-1.050189575999894, 22.537953593000097],
            [-1.136902627999859, 22.59464264000009],
            [-1.223512328999959, 22.651280009000075],
            [-1.310122029999917, 22.707969055],
            [-1.39678340599994, 22.764554749000055],
            [-1.483496459999913, 22.821166280000043],
            [-1.570054484999929, 22.877881165000062],
            [-1.656715860999981, 22.934570211000064],
            [-1.74332556199991, 22.99118174300004],
            [-1.830038614999864, 23.047819112000028],
            [-1.916648315999907, 23.10445648200003],
            [-2.003309692999949, 23.161042175000077],
            [-2.089919392999889, 23.21775706000001],
            [-2.176632446999861, 23.2744461060001],
            [-2.263190470999859, 23.331109314000102],
            [-2.349851846999911, 23.387746684],
            [-2.436513224999942, 23.444358216000083],
            [-2.523226277999925, 23.50099558500007],
            [-2.609835977999865, 23.55768463200006],
            [-2.696445678999879, 23.614347839000047],
            [-2.78310705599992, 23.67098520900005],
            [-2.869768432999876, 23.727622579000027],
            [-2.956403971999919, 23.784234110000014],
            [-3.043065347999857, 23.84092315700012],
            [-3.129649210999986, 23.897612203000037],
            [-3.20948929899987, 23.949702047000088],
            [-3.289122680999924, 24.00184356700005],
            [-3.368807738999863, 24.0539592490001],
            [-3.448544473999931, 24.10602325500004],
            [-3.528281209999903, 24.1581130980001],
            [-3.608017943999869, 24.210202942000066],
            [-3.687625487999895, 24.26234446200003],
            [-3.767336384999851, 24.31443430600008],
            [-3.846995604999904, 24.366575826000044],
            [-3.926732340999962, 24.418717347000026],
            [-4.006494913999916, 24.47080719000006],
            [-4.086154134999958, 24.522897034000025],
            [-4.165865030999925, 24.574986878000075],
            [-4.24549841299995, 24.627076721000023],
            [-4.325235148999923, 24.67921824200009],
            [-4.404946044999889, 24.731308085000038],
            [-4.516024536999879, 24.80399098700009],
            [-4.592350626999917, 24.85168833400006],
            [-4.668676716999954, 24.899334005000085],
            [-4.744925292999881, 24.947057190000052],
            [-4.821225545999908, 24.99475453700002],
            [-4.821354736999922, 24.994806213000047],
            [-4.821535603999877, 24.994961243000077],
            [-4.821613117999902, 24.99506459600009],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Mozambique',
        iso3: 'MOZ',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [32.11388431800009, -26.840014342999936],
              [32.11739831600005, -26.582252298999904],
              [32.107063029000074, -26.500293477999932],
              [32.05983077000013, -26.41482065799991],
              [32.05233768700009, -26.386812031999895],
              [32.03988366700008, -26.283665872999876],
              [32.04474125200005, -26.254520364999863],
              [32.07781416800009, -26.175455423999964],
              [32.08143151900009, -26.148790384999927],
              [32.074558553000145, -26.11416717599991],
              [32.06272465000012, -26.07716684999987],
              [32.057453654000085, -26.041200052999983],
              [32.07057946800006, -26.00978078199995],
              [32.004020223000055, -25.99438120499987],
              [31.975288127000056, -25.980428568999884],
              [31.949243204000084, -25.958104349999914],
              [31.909969116000127, -25.84296925899993],
              [31.90583500100007, -25.81299692799989],
              [31.91193282000006, -25.785298359999956],
              [31.954410848000066, -25.6849427289999],
              [31.96226566600012, -25.672850443999906],
              [31.975081421000084, -25.661688333999876],
              [31.984796590000144, -25.656313984999912],
              [31.991617880000092, -25.65021616599995],
              [31.995751994000045, -25.636883646999934],
              [31.995648641000116, -25.615179544999933],
              [31.986398560000055, -25.552444356999985],
              [31.980559122000102, -25.53156707699992],
              [31.970120484000063, -25.510896503999987],
              [31.966399781000064, -25.479683938999926],
              [31.967640015000086, -25.44681772899989],
              [31.971670776000053, -25.421496276999918],
              [31.988723999000115, -25.372610371999926],
              [31.987225382000076, -25.1553626499999],
              [31.98629520700007, -24.99630259099989],
              [31.9856234130001, -24.87693003299995],
              [31.984589885000105, -24.708464863999964],
              [31.983763062000094, -24.569145201999916],
              [31.99192793800006, -24.500415546999946],
              [31.98655358900004, -24.42310760499994],
              [31.961335490000067, -24.346316425999888],
              [31.926310767000075, -24.276739754999895],
              [31.869454793000102, -24.163795267999973],
              [31.863046916000087, -24.121420592999883],
              [31.856491137000035, -23.962958052999923],
              [31.85581221500007, -23.946547545999948],
              [31.85043786600005, -23.930631204999926],
              [31.838655640000127, -23.91781544999995],
              [31.77406009900011, -23.874097187999965],
              [31.755198202000145, -23.85776743499993],
              [31.741193888000055, -23.836786803999928],
              [31.700627889000145, -23.749091898999907],
              [31.662025594000056, -23.62403493199993],
              [31.642285197000092, -23.587861429999904],
              [31.546270386000117, -23.492363382999955],
              [31.527615193000145, -23.456809996999894],
              [31.521465699000146, -23.415572203999986],
              [31.542446330000075, -23.187265726999954],
              [31.536348511000085, -23.156983337999932],
              [31.467618856000115, -22.95895924799993],
              [31.42638106300012, -22.840103454999934],
              [31.37491133600014, -22.69158538799988],
              [31.323338257000046, -22.542860615999956],
              [31.27910323100008, -22.41532318199991],
              [31.288921753000068, -22.39733978299992],
              [31.36871016400005, -22.345043232999913],
              [31.433822469000063, -22.30204844199993],
              [31.485808960000043, -22.248304951999927],
              [31.53820886200009, -22.193941344999956],
              [31.590712117000066, -22.13957773899999],
              [31.643112019000114, -22.08521413199992],
              [31.695511922000037, -22.03074717199992],
              [31.74780847100004, -21.976383565999953],
              [31.80031172700012, -21.92201995799988],
              [31.852711629000055, -21.86755299899997],
              [31.905214885000134, -21.813189391999913],
              [31.95761478600008, -21.758825784999942],
              [32.010014689000116, -21.704462177999872],
              [32.06241459100005, -21.649995218999962],
              [32.114814494000086, -21.595631611999906],
              [32.16731774900006, -21.541268005999925],
              [32.2197176520001, -21.48690439899987],
              [32.27222090600014, -21.43254079099998],
              [32.32451745600014, -21.378177184999913],
              [32.37298995000009, -21.327947692999956],
              [32.408543335000104, -21.290327250999937],
              [32.44719730600008, -21.3136849979999],
              [32.44584926100009, -21.308993799999968],
              [32.444613485000104, -21.30469329799986],
              [32.37174971500008, -21.187904561999915],
              [32.37298995000009, -21.18397715199994],
              [32.37686568200007, -21.17849945099995],
              [32.380534709000074, -21.172194925999946],
              [32.38063806100007, -21.165476989999917],
              [32.37774418200013, -21.16340993199995],
              [32.373351685000046, -21.163616637999922],
              [32.36885583500009, -21.16299652099994],
              [32.359864136000056, -21.151421],
              [32.34534305800008, -21.14284271199996],
              [32.33981368000008, -21.134057718999983],
              [32.41712162200008, -21.040936787999982],
              [32.46766117300007, -20.98016530299988],
              [32.49101892100009, -20.936343688999955],
              [32.49722009300007, -20.898103128999963],
              [32.48347416100006, -20.794233499999862],
              [32.46910811300006, -20.686849873999876],
              [32.4710718180001, -20.64550872799994],
              [32.481613810000056, -20.60303070099991],
              [32.5131364340001, -20.564583434999946],
              [32.556544637000115, -20.559312438999925],
              [32.60367354300007, -20.564790140999918],
              [32.64646163000015, -20.557968850999956],
              [32.671783081000115, -20.531820576999863],
              [32.704442587000074, -20.47177256299993],
              [32.73586185700009, -20.4142050169999],
              [32.800767456000074, -20.338550719999944],
              [32.84520918700014, -20.286667581999936],
              [32.85296065300014, -20.27385182699996],
              [32.85843835400004, -20.25948577899996],
              [32.86556970200007, -20.228893330999938],
              [32.86505293800013, -20.22093516099997],
              [32.858335001000114, -20.207499287999937],
              [32.857094767000035, -20.20057464599995],
              [32.859265177000054, -20.19085947699992],
              [32.87290775500014, -20.16719167099997],
              [32.877868693000096, -20.15168874099996],
              [32.88531010000014, -20.10300954199994],
              [32.894405151000115, -20.0940178419999],
              [32.910683227000106, -20.091123961999912],
              [32.926547892000144, -20.086473082999944],
              [32.93429935700004, -20.072107034999945],
              [32.940087117000076, -20.041514586999938],
              [32.953729695000106, -20.03024912499997],
              [33.007266480000055, -20.032006123999864],
              [33.00437259900008, -20.024254658999936],
              [32.99837813300013, -20.0008969109999],
              [33.001995483000144, -19.92699961299992],
              [33.0213224690001, -19.868088479999912],
              [33.02287276200008, -19.826850687999908],
              [33.02964237500004, -19.803389586999927],
              [33.03279463700011, -19.784165953999917],
              [33.02276940900009, -19.773107197999906],
              [33.00060022000014, -19.764322204999914],
              [32.979051147000064, -19.751403095999905],
              [32.96241133700005, -19.73538340199987],
              [32.95414310700005, -19.71781341499988],
              [32.96241133700005, -19.67905609099995],
              [32.960964396000065, -19.658798929999946],
              [32.94318770400014, -19.649290466999958],
              [32.9245841880001, -19.65528493299989],
              [32.89471521000007, -19.68432708799989],
              [32.87218428600005, -19.690218200999894],
              [32.8491365970001, -19.689081318999882],
              [32.8310498460001, -19.68515390999991],
              [32.819629354000085, -19.67430185899987],
              [32.81627038500005, -19.652080993999917],
              [32.819474324000055, -19.64195241299997],
              [32.82536543800012, -19.633270771999918],
              [32.82960290500006, -19.623658954999897],
              [32.828155965000064, -19.61063649499995],
              [32.82567549600009, -19.600817971999987],
              [32.82536543800012, -19.5916195679999],
              [32.83249678600009, -19.51927256299993],
              [32.83218672700008, -19.50087575299993],
              [32.82536543800012, -19.479171651999934],
              [32.81130944800009, -19.474520772999966],
              [32.79311934400005, -19.47669118199987],
              [32.77394738800007, -19.475864359999946],
              [32.763353719000065, -19.46397877999992],
              [32.762216838000086, -19.44341155999993],
              [32.768521362000115, -19.402793883999976],
              [32.76645430500014, -19.37344167099991],
              [32.76883142100007, -19.36362314899995],
              [32.80614180500004, -19.32341888399992],
              [32.820714559000066, -19.30130137099991],
              [32.82867273000005, -19.284558206999876],
              [32.83218672700008, -19.266678161],
              [32.83322025500007, -19.241976826999903],
              [32.862262411000074, -19.118056741999922],
              [32.85590621000006, -19.083743591999905],
              [32.84748295100013, -19.073925068999927],
              [32.838129517000084, -19.06689707499993],
              [32.83022302200004, -19.059145608999913],
              [32.82526208500008, -19.046846618999965],
              [32.82298832200007, -19.03516774499991],
              [32.81999108800005, -19.02834645599995],
              [32.81420332900012, -19.023798929999913],
              [32.80335127800004, -19.019561461999956],
              [32.78598799600013, -19.01770111099995],
              [32.72387292500008, -19.02658945699997],
              [32.71028202300005, -19.025969339999904],
              [32.69896488400008, -19.02224863699989],
              [32.69105839000014, -19.014290465999935],
              [32.68862959800009, -19.000957946999904],
              [32.69028324400006, -18.988245543999952],
              [32.68862959800009, -18.97729013999988],
              [32.68108483900005, -18.954965921999914],
              [32.682531779000044, -18.942666930999877],
              [32.69224694900009, -18.934295348999896],
              [32.70506270300007, -18.927474059999938],
              [32.715759725000055, -18.919825947999954],
              [32.70320235200006, -18.911867776999898],
              [32.696794474000114, -18.897191670999916],
              [32.689869833000046, -18.843241474999957],
              [32.691420125000036, -18.834249775999908],
              [32.787641643000086, -18.791254983999934],
              [32.81792403200012, -18.78701751699988],
              [32.85885176600004, -18.790014749999983],
              [32.8852067470001, -18.787844339999907],
              [32.90251835100008, -18.774511819999887],
              [32.913267049000126, -18.753014423999943],
              [32.920243368000115, -18.726246032999967],
              [32.9223104240001, -18.693173115999883],
              [32.91455896000008, -18.66588795999988],
              [32.88448327600008, -18.609043883999917],
              [32.87166752100012, -18.573180439999888],
              [32.86825687700008, -18.552613219999984],
              [32.870737346000055, -18.535766702999908],
              [32.88313968900013, -18.522124124999905],
              [32.900296265000065, -18.515302835999947],
              [32.91931319200006, -18.510031839999925],
              [32.93714156100009, -18.501040139999887],
              [32.956623576000084, -18.489878030999947],
              [32.978586060000055, -18.48005950899997],
              [32.99641442900008, -18.467140400999966],
              [33.00302901200013, -18.44688323899996],
              [32.99951501400005, -18.436651305999888],
              [32.986802612000076, -18.42228525799989],
              [32.98535567300013, -18.412466735999914],
              [32.98819787600007, -18.41319020599991],
              [33.0092301840001, -18.383941344999954],
              [33.038065633000144, -18.363064066999897],
              [33.04276818900013, -18.352005309999882],
              [33.03496504700007, -18.332885029999986],
              [33.01687829600007, -18.313661396999876],
              [32.97016280100007, -18.277487894999936],
              [32.95496993000006, -18.25630055699989],
              [32.95052575700004, -18.241314391999907],
              [32.95228275500011, -18.233046162999955],
              [32.95817386900012, -18.22539805099997],
              [32.96592533400013, -18.212168883999894],
              [32.974865356000066, -18.190774840999964],
              [32.97553715000004, -18.183333434999952],
              [32.972281535000036, -18.150260517999968],
              [32.93708988500009, -18.047114359999938],
              [32.93491947400008, -18.024583434999926],
              [32.94029382300005, -18.004843037999947],
              [32.9412239990001, -17.996264749999924],
              [32.92897668400008, -17.982312112999935],
              [32.927374716000145, -17.97290700199997],
              [32.93243900600004, -17.96494883199992],
              [32.94039717600009, -17.95998789499997],
              [32.9481486410001, -17.953269957999936],
              [32.95212772700006, -17.940247496999902],
              [32.95026737500007, -17.922574157999904],
              [32.93843347200004, -17.894565530999984],
              [32.93688317800013, -17.87503183999989],
              [32.939673706000065, -17.855498148999885],
              [32.946081584000126, -17.834724222999938],
              [32.95703698700004, -17.81798105899989],
              [32.9735734460001, -17.81064300499989],
              [32.99910160300004, -17.794313251999952],
              [33.003184041000054, -17.757726338999916],
              [33.00023848500007, -17.713904723999903],
              [33.00406254100011, -17.675560810999897],
              [33.02059899900007, -17.638457132999903],
              [33.02452640800004, -17.61923349999998],
              [33.020392294000146, -17.59856292699996],
              [33.00664636200008, -17.580992939999902],
              [32.96912927200009, -17.564559834999926],
              [32.95166263900006, -17.551434020999963],
              [32.94721846500005, -17.54316579199991],
              [32.93667647300009, -17.50936940499993],
              [32.93657312000005, -17.498310648999933],
              [32.94298099700006, -17.4915927119999],
              [32.95166263900006, -17.48621836399994],
              [32.95817386900012, -17.478466897999937],
              [32.997447958000066, -17.40498301099997],
              [33.01165099000008, -17.383990615999963],
              [33.0162581780001, -17.377181090999912],
              [33.02245935000008, -17.361471455999947],
              [33.021632528000055, -17.345555114999925],
              [33.014656209000066, -17.336666768999905],
              [32.99238366700013, -17.32467783599995],
              [32.98359867300013, -17.317753193999877],
              [32.97321171100009, -17.297909443999885],
              [32.9694393310001, -17.276101989999944],
              [32.96908967500008, -17.266114927999894],
              [32.96778568500014, -17.228869729999914],
              [32.95414310700005, -17.167168069999946],
              [32.92851159600008, -17.10949717199989],
              [32.886757040000134, -17.038183694999915],
              [32.830119670000045, -16.941548766999944],
              [32.82877608300004, -16.935140889999914],
              [32.90050297000005, -16.86775482199991],
              [32.916212606000045, -16.847911070999913],
              [32.93336918200009, -16.815768330999973],
              [32.96158451300005, -16.710348408999934],
              [32.96850915600004, -16.68161631199993],
              [32.95621016400008, -16.683063252999915],
              [32.93957035300008, -16.689781188999945],
              [32.909598023000115, -16.708074645999915],
              [32.89337162200013, -16.712415465999896],
              [32.862004028000115, -16.71045176099996],
              [32.800664103000145, -16.697325947999985],
              [32.769348185000126, -16.69546559599989],
              [32.75384525600009, -16.697946064999954],
              [32.7398926190001, -16.703217060999904],
              [32.73131433100008, -16.70879811599991],
              [32.73095033900006, -16.708656220999984],
              [32.725216512000145, -16.706420999999878],
              [32.69865482600011, -16.68678395599993],
              [32.68862959800009, -16.647303162],
              [32.687906128000066, -16.624255472999934],
              [32.683100219000096, -16.609889424999935],
              [32.671783081000115, -16.599760843999974],
              [32.55210046400009, -16.553355407999973],
              [32.39366052300005, -16.491757099999944],
              [32.290462687000115, -16.451759541999962],
              [32.211759481000115, -16.440184020999922],
              [32.014148804000115, -16.444938251999915],
              [31.910279175000085, -16.428918558999968],
              [31.89436283400005, -16.42147715299994],
              [31.885629516000108, -16.406284280999913],
              [31.880720256000075, -16.36804372099992],
              [31.87193526200008, -16.350370381999923],
              [31.860049682000067, -16.340758564999916],
              [31.818088420000038, -16.31957122799996],
              [31.798761434000085, -16.303654886999936],
              [31.738196655000138, -16.239782815999973],
              [31.710704794000094, -16.21787200899992],
              [31.686106811000116, -16.207226663999933],
              [31.519191935000038, -16.196477965999918],
              [31.48064131700005, -16.177977803999894],
              [31.465655151000078, -16.167745869999905],
              [31.445708049000075, -16.164955342999946],
              [31.424107300000117, -16.164748636999988],
              [31.404573609000067, -16.162268167999912],
              [31.402713257000073, -16.159374286999935],
              [31.404056844000138, -16.154516702999913],
              [31.40431522600005, -16.149865823999946],
              [31.399612671000057, -16.14728200199994],
              [31.395581909000043, -16.147695413999955],
              [31.387727092000034, -16.14955576499996],
              [31.384006389000035, -16.148832295999867],
              [31.37775354000013, -16.14221771199996],
              [31.374601278000057, -16.13291595399994],
              [31.370260457000086, -16.123717549999938],
              [31.360338582000054, -16.11689625999989],
              [31.340908244000104, -16.106664326999905],
              [31.32835087100011, -16.092815042999945],
              [31.309592326000086, -16.059018655999964],
              [31.295329630000083, -16.041655374999948],
              [31.27889652500005, -16.03028655999995],
              [31.259982951000097, -16.023465270999907],
              [31.158490438000058, -16.000210875999883],
              [31.11410038200006, -15.996903584999885],
              [31.089037313000063, -16.011889749999867],
              [31.08087243600005, -16.02594573999997],
              [31.073327677000066, -16.025532327999954],
              [31.06542118300007, -16.019641214999965],
              [31.056894572000147, -16.017574157999903],
              [31.042218465000133, -16.024912210999986],
              [31.023718303000123, -16.045169372999908],
              [31.01203942900014, -16.05488454199994],
              [30.989766886000098, -16.064289652999904],
              [30.973075399000038, -16.06201588999997],
              [30.95829594000014, -16.051060485999898],
              [30.942172892000144, -16.034524027999908],
              [30.901865275000034, -16.007135517999956],
              [30.85742354300004, -15.998143818999921],
              [30.74972985900007, -15.998867288999918],
              [30.586587362000046, -16.000004169999926],
              [30.514808797000057, -16.000417582999944],
              [30.402567587000135, -16.001244404999866],
              [30.401327352000123, -15.931687927999874],
              [30.399260295000147, -15.812005309999861],
              [30.39771000200011, -15.71681732099998],
              [30.396263061000127, -15.63599538099993],
              [30.410370728000146, -15.630414326999912],
              [30.412696167000092, -15.627933857999935],
              [30.40122399900008, -15.598478291999925],
              [30.395953003000045, -15.590623473999898],
              [30.367427613000075, -15.561271259999927],
              [30.365257202000123, -15.547421976999956],
              [30.371768432000067, -15.525407816999888],
              [30.39016524200008, -15.490784606999881],
              [30.392852417000086, -15.480759378999949],
              [30.38964847800014, -15.471147562999931],
              [30.374920695000128, -15.451303811999935],
              [30.371768432000067, -15.439831644999927],
              [30.369184611000094, -15.374719339999928],
              [30.36494714300011, -15.354152119999938],
              [30.35791914900011, -15.335651956999925],
              [30.347480509000093, -15.317875264999898],
              [30.334871460000045, -15.304749450999921],
              [30.320505412000045, -15.299478453999896],
              [30.28794926000012, -15.278911233999906],
              [30.263144572000044, -15.231265563999955],
              [30.225834188000135, -15.10631195099991],
              [30.22097660300011, -15.063007099999936],
              [30.22097660300011, -15.018358662999916],
              [30.21384525500008, -14.988489684999891],
              [30.214420897000082, -14.981965750999933],
              [30.214465373000053, -14.981461690999893],
              [30.230898478000086, -14.977224222999936],
              [30.31843835500007, -14.96699228999995],
              [30.39249068200013, -14.931025492999979],
              [30.48555993700012, -14.88596364299994],
              [30.591806682000083, -14.848136494999949],
              [30.676969441000097, -14.81764739999997],
              [30.815772339000034, -14.768244730999953],
              [30.91509444200011, -14.746023863999909],
              [31.056584513000132, -14.714397887999922],
              [31.07446455900009, -14.713054300999957],
              [31.17802412900005, -14.688559671999897],
              [31.30680179900014, -14.658173928999943],
              [31.410878133000097, -14.633575947999958],
              [31.49666101100013, -14.602570087999936],
              [31.589678589000073, -14.554821064999956],
              [31.658408244000043, -14.519577737999981],
              [31.801345256000104, -14.473585712999892],
              [31.932913452000037, -14.431107685999862],
              [32.03326908400004, -14.39875823899996],
              [32.10876835100004, -14.36485849999994],
              [32.147060587000055, -14.353386331999928],
              [32.22736576300014, -14.339020283999929],
              [32.32038334100014, -14.30801442499991],
              [32.42549320400008, -14.272977802999975],
              [32.57680179900012, -14.222541604999975],
              [32.74495690900011, -14.166421],
              [32.9171427820001, -14.109060159999942],
              [33.042923217000066, -14.067098896999937],
              [33.13004968300004, -14.038056741999952],
              [33.202706747000036, -14.013872171999893],
              [33.257793824000146, -14.043637796999874],
              [33.280221395000126, -14.060794371999933],
              [33.29128015100014, -14.089216410999953],
              [33.28621586100007, -14.138929137999952],
              [33.290556682000044, -14.15691253699994],
              [33.31556807400011, -14.197116800999964],
              [33.32393965600011, -14.20631520599997],
              [33.3382540290001, -14.215410257999935],
              [33.34714237500009, -14.218820901999962],
              [33.35432539900006, -14.225332131999934],
              [33.35710549200013, -14.230565247999934],
              [33.37101688600006, -14.25675140399997],
              [33.388586874000055, -14.280625914999874],
              [33.43917810100004, -14.380671487999948],
              [33.45736820500014, -14.404339293999968],
              [33.470287313000085, -14.414467874999929],
              [33.51245528200013, -14.432968037999956],
              [33.525787801000035, -14.444336852999939],
              [33.53235070800014, -14.456222431999961],
              [33.537466674000086, -14.46872812899997],
              [33.54594161000011, -14.481647236999976],
              [33.557413778000125, -14.490432229999968],
              [33.58428552200013, -14.502627867999891],
              [33.595757691000074, -14.511412861999958],
              [33.604232625000066, -14.524021910999892],
              [33.61840558200009, -14.56184056699989],
              [33.62448978700007, -14.57807545999988],
              [33.632964722000054, -14.59140797899991],
              [33.644850302000066, -14.601743265999914],
              [33.66242028800008, -14.607014261999936],
              [33.672238810000124, -14.600192971999988],
              [33.675442749000126, -14.582312927999936],
              [33.675546102000055, -14.547793069999955],
              [33.68407271400014, -14.51875091599996],
              [33.69921390800005, -14.496219990999933],
              [33.72040124500012, -14.489708760999875],
              [33.77419641100005, -14.530016377999928],
              [33.80241174300011, -14.532806904999887],
              [33.83083378100014, -14.522678323999926],
              [33.88891809000012, -14.488158466999948],
              [33.91630660000004, -14.481337178999894],
              [33.945555460000094, -14.481440530999919],
              [34.050768677000065, -14.49518646199995],
              [34.05862349400013, -14.490122171999886],
              [34.07019901500007, -14.464904072999929],
              [34.07753706900007, -14.454672139999943],
              [34.10957645600007, -14.441442972999951],
              [34.18244022600004, -14.439479267999928],
              [34.28134891800005, -14.404959410999936],
              [34.28889367700009, -14.4040292359999],
              [34.30491337000012, -14.405786233999962],
              [34.312871541000106, -14.404235941999943],
              [34.320519653000076, -14.399378356999932],
              [34.327754353000046, -14.393590595999868],
              [34.335299113000076, -14.388836364999875],
              [34.34408410600008, -14.387389424999881],
              [34.3720927330001, -14.401962178999923],
              [34.38043631000005, -14.413643186999906],
              [34.39379683400011, -14.432347920999888],
              [34.42645633900008, -14.497563577999912],
              [34.449710734000064, -14.525468850999886],
              [34.50180057800014, -14.575698343999932],
              [34.518130330000076, -14.607427672999862],
              [34.5193705640001, -14.640810647999928],
              [34.50583133900005, -14.700341897999905],
              [34.51533980300013, -14.734551696999901],
              [34.532082967000065, -14.76679779099996],
              [34.54283166500011, -14.796253356999955],
              [34.54841271900011, -14.827775979999927],
              [34.54872277900006, -14.90156992599988],
              [34.55109989500005, -14.918313089999927],
              [34.556991008000125, -14.938260192999948],
              [34.565982707000046, -14.954279886999899],
              [34.57693811000007, -14.969266051999881],
              [34.58417281100009, -14.984458922999906],
              [34.58231246000008, -15.001305439999967],
              [34.57497440600014, -15.016084899999981],
              [34.55461389200008, -15.043576761999958],
              [34.54872277900006, -15.05763275199989],
              [34.55099654200012, -15.071792092999928],
              [34.557301066000036, -15.084297790999926],
              [34.55988488800011, -15.09566660499992],
              [34.55068648200012, -15.106622008999892],
              [34.54830936700006, -15.123675230999922],
              [34.559085120000134, -15.200177714],
              [34.56908329300012, -15.271159769999898],
              [34.565155884000035, -15.297308043999905],
              [34.546759074000136, -15.323249612999945],
              [34.533323202000076, -15.33306813499992],
              [34.52030074000004, -15.339786071999939],
              [34.50800175000012, -15.348054300999891],
              [34.49663293400005, -15.362730407999976],
              [34.49198205600004, -15.375132750999938],
              [34.48702111800009, -15.400454202999924],
              [34.48040653500004, -15.412856546999905],
              [34.460252726000135, -15.424845478999956],
              [34.4406156820001, -15.455541279999892],
              [34.42263228300004, -15.46453297899994],
              [34.410126587000036, -15.481276142999974],
              [34.41002323400011, -15.51496917699994],
              [34.41911828600007, -15.575327249999944],
              [34.415914348000115, -15.615118102999944],
              [34.404028768000046, -15.646847431999973],
              [34.34221782200012, -15.730323010999939],
              [34.34181034300008, -15.730873310999911],
              [34.33095829300004, -15.737074482999986],
              [34.310287720000076, -15.743275654999962],
              [34.293337850000114, -15.751130472999904],
              [34.275561157000084, -15.76435963999991],
              [34.24713912000004, -15.794125263999987],
              [34.23639042200011, -15.819240009999916],
              [34.23132613100006, -15.854173277999905],
              [34.233186483000054, -15.88983001699998],
              [34.24403853400008, -15.917631937999943],
              [34.256440877000045, -15.928173929999915],
              [34.2897205000001, -15.943470152999879],
              [34.30429325400007, -15.95215179499992],
              [34.38769901500012, -16.03700449599998],
              [34.4045455320001, -16.05974212699995],
              [34.40898970600011, -16.087854104999906],
              [34.389249308000046, -16.15244964599995],
              [34.38521854600015, -16.186452738999975],
              [34.42645633900008, -16.273889260999937],
              [34.445990031000065, -16.293216246999904],
              [34.48040653500004, -16.294456480999926],
              [34.52474491400005, -16.30076100699995],
              [34.54706913200005, -16.323085224999915],
              [34.57507775900007, -16.392331644999928],
              [34.58582645600006, -16.407834573999935],
              [34.59833215400005, -16.419720152999957],
              [34.63068160000006, -16.443387959999896],
              [34.63739953600009, -16.45051930799994],
              [34.642670533000114, -16.45971771199993],
              [34.654969523000034, -16.489379983999896],
              [34.66117069500012, -16.493927510999924],
              [34.66871545400011, -16.496614684999955],
              [34.73207076000011, -16.52917083699991],
              [34.74498986800012, -16.54291676799994],
              [34.76286991400008, -16.576403095999936],
              [34.77299849500014, -16.589735615999956],
              [34.819507283000064, -16.627769469999905],
              [34.827568807000034, -16.641515400999936],
              [34.83480350800011, -16.663116149999908],
              [34.844622030000096, -16.678412373999947],
              [34.859918254000036, -16.68719736699994],
              [34.877488240000105, -16.694432067999912],
              [34.886613111000145, -16.700848911999884],
              [34.89350793500006, -16.705697529999966],
              [34.89774540200011, -16.71396575899992],
              [34.90094934100006, -16.733292744999872],
              [34.905496867000124, -16.740837503999913],
              [34.91231815600008, -16.744558206999926],
              [34.927614380000136, -16.74724538199996],
              [34.934435669000095, -16.749725849999933],
              [34.94807824700007, -16.75933766699994],
              [34.956656535000036, -16.76832936599989],
              [34.975053345000106, -16.792100524999938],
              [35.00450891100013, -16.81463144899996],
              [35.0330343010001, -16.819178975999904],
              [35.06279992700007, -16.81638844799994],
              [35.09576949000012, -16.817318623999896],
              [35.118300415000135, -16.83344166999997],
              [35.12749882000014, -16.864447529999907],
              [35.128118937000124, -16.90072438499996],
              [35.125121704000094, -16.93286712699998],
              [35.11344283000011, -16.96025563599993],
              [35.09142867000014, -16.97534515399994],
              [35.06610721900006, -16.98733408599989],
              [35.04440311700006, -17.004697366999906],
              [35.03654829900012, -17.035909931999896],
              [35.0691044510001, -17.084072366999877],
              [35.06600386600013, -17.109807230999962],
              [35.08130008900008, -17.124069924999944],
              [35.13390669800009, -17.132028095999914],
              [35.23477909400009, -17.135335387999902],
              [35.29167287300004, -17.129368228999923],
              [35.29193322800012, -17.129340921999884],
              [35.299477986000056, -17.117972106999986],
              [35.30495568900005, -17.104226175999955],
              [35.30753951000014, -17.087586364999936],
              [35.306195923000075, -17.06732920299993],
              [35.297410930000126, -17.029708759999906],
              [35.298651164000034, -17.01358571399993],
              [35.309296508000045, -16.995292256999946],
              [35.31436080000009, -16.982269795999912],
              [35.308366333000095, -16.973691507999973],
              [35.27601688700008, -16.95519134499996],
              [35.27136600800014, -16.950540466999897],
              [35.270952596000086, -16.94423594099989],
              [35.275810181000054, -16.93917165099991],
              [35.2819080000001, -16.934727477999985],
              [35.28511193800006, -16.930076598999932],
              [35.28283817500005, -16.892146097999927],
              [35.2852152910001, -16.871062113999898],
              [35.3102266840001, -16.850598246999937],
              [35.305162394000035, -16.825690205999962],
              [35.28511193800006, -16.786726175999974],
              [35.28108117700009, -16.766882425999896],
              [35.2781872970001, -16.700736591999927],
              [35.27508671100014, -16.69546559599989],
              [35.25100549300009, -16.67004079199998],
              [35.248214966000035, -16.668180439999972],
              [35.23974003100005, -16.664563089999902],
              [35.236639445000094, -16.662599385999954],
              [35.23271203600012, -16.6572250359999],
              [35.22754439300013, -16.646889749999985],
              [35.22299686700006, -16.642135518999908],
              [35.21658899000005, -16.638724873999962],
              [35.194678182000075, -16.63055999699995],
              [35.18547977700007, -16.62900970499993],
              [35.17431766700008, -16.625495706999885],
              [35.168529908000096, -16.617124124999904],
              [35.16439579200005, -16.6067888379999],
              [35.14837609900013, -16.582087503999972],
              [35.13194299300005, -16.537645771999905],
              [35.144655396000076, -16.529067483999967],
              [35.21441857900004, -16.48421234099989],
              [35.22816451000011, -16.4702597039999],
              [35.23364221200006, -16.452379658999945],
              [35.233332153000106, -16.41258880599993],
              [35.2372534590001, -16.39909046299995],
              [35.23870650200007, -16.394088642999904],
              [35.262270955000076, -16.366596780999927],
              [35.26619836500004, -16.356468200999885],
              [35.254209432000096, -16.32835622199994],
              [35.251935669000034, -16.31781422899988],
              [35.258756958000106, -16.271512145999907],
              [35.27715376800012, -16.233995055999912],
              [35.299156139000104, -16.20872095699994],
              [35.30495568900005, -16.202059020999926],
              [35.37461552000008, -16.140977477999925],
              [35.39342574000011, -16.12857513399996],
              [35.41606001800005, -16.122890726999913],
              [35.43580041500013, -16.123924254999906],
              [35.456367635000106, -16.129401957999974],
              [35.47290409300007, -16.140150654999914],
              [35.48013879400014, -16.156893818999947],
              [35.48871708200011, -16.16464528399996],
              [35.502049601000124, -16.17084645599995],
              [35.51455529800012, -16.17136321999989],
              [35.52106652800006, -16.162164814999898],
              [35.52406376200008, -16.146661885999976],
              [35.52902469900005, -16.140770771999968],
              [35.553209269000035, -16.138393655999934],
              [35.64860396300014, -16.110591735999975],
              [35.65893924900013, -16.110074970999932],
              [35.67785282400007, -16.113485615999963],
              [35.687051229000076, -16.112658792999937],
              [35.697593221000034, -16.107491148999927],
              [35.77004358000005, -16.05881195099991],
              [35.78513309700014, -16.042275491999916],
              [35.794641561000105, -16.020674742999944],
              [35.79567509000009, -16.00496510799988],
              [35.790094035000095, -15.974476012999986],
              [35.78968062400014, -15.958663024999893],
              [35.796591428000056, -15.933197758999924],
              [35.8067338460001, -15.895824482999927],
              [35.81675907400012, -15.75195729599993],
              [35.82306359800015, -15.663383890999867],
              [35.83195194500013, -15.538430276999918],
              [35.837558283000135, -15.459198533],
              [35.83762321100005, -15.458280937999916],
              [35.840530233000095, -15.417197366999886],
              [35.812004842000135, -15.30485280399995],
              [35.78858250500008, -15.211427612999913],
              [35.784512981000034, -15.195195413999954],
              [35.78420292100009, -15.171837665999917],
              [35.790817505000064, -15.14682627399992],
              [35.83928999800014, -15.0363420609999],
              [35.866781861000106, -14.973090108999912],
              [35.90429895000011, -14.886893818999894],
              [35.88280155400008, -14.887513936999952],
              [35.86988244600013, -14.885550231999929],
              [35.86326786300015, -14.876661885999908],
              [35.8530359290001, -14.667475686999879],
              [35.847248169000125, -14.650422464999934],
              [35.83556929500014, -14.635849710999977],
              [35.78689009600009, -14.58789398199994],
              [35.750539409000055, -14.543142707999934],
              [35.714439738000124, -14.49870045999991],
              [35.60943322700007, -14.369406025999893],
              [35.52282352700007, -14.262745869],
              [35.45574751800012, -14.136965433999933],
              [35.370067993000134, -14.037229918999927],
              [35.27870406100004, -13.930879820999934],
              [35.17111372900007, -13.805719501999931],
              [35.08409061700013, -13.704226988999949],
              [34.99655074100008, -13.625988871],
              [34.894438110000124, -13.534728291999983],
              [34.86389759600013, -13.516283029999983],
              [34.863122192000105, -13.515814716999955],
              [34.829635865000114, -13.503929137999933],
              [34.79542606600012, -13.498761494999926],
              [34.66747522000014, -13.500931904999916],
              [34.65135217300008, -13.497831318999971],
              [34.640603475000034, -13.492353617999882],
              [34.63760624200012, -13.488219502999954],
              [34.636469360000035, -13.482225035999932],
              [34.63171512800005, -13.47116627999992],
              [34.611457967000035, -13.43581960099992],
              [34.59977909300005, -13.420213317999881],
              [34.5827597330001, -13.403625920999943],
              [34.57941857900005, -13.400369567999888],
              [34.57817834500008, -13.398405863999955],
              [34.54531213400014, -13.32574879899991],
              [34.54283166500011, -13.243789977999938],
              [34.54934289500005, -13.159092305999934],
              [34.5377673750001, -13.059356790999928],
              [34.52391809100004, -12.939674173999919],
              [34.507484985000076, -12.799424335999916],
              [34.49446252500013, -12.687389831999965],
              [34.439168742000106, -12.495050149999912],
              [34.380360962000054, -12.291134948999911],
              [34.35558101700008, -12.20493961299988],
              [34.35400598100006, -12.199460957999904],
              [34.358760213000096, -12.154399108999954],
              [34.38005090400014, -12.103859557999925],
              [34.48764123500007, -11.944076028999902],
              [34.563812296000094, -11.83090464199995],
              [34.604429972000105, -11.732616068999945],
              [34.61197473100009, -11.693135273999928],
              [34.613938436000126, -11.652724303999946],
              [34.607220500000096, -11.609316100999948],
              [34.607117147000054, -11.591125995999903],
              [34.61672896300007, -11.57831024199993],
              [34.651248820000035, -11.570042012999878],
              [34.96461470600008, -11.573556009999933],
              [35.38174686600013, -11.577690123999957],
              [35.42350142400005, -11.57655324299995],
              [35.42525842300006, -11.582030944999929],
              [35.431873006000046, -11.588438821999972],
              [35.441174764000095, -11.591436055999893],
              [35.46577274600014, -11.5925729369999],
              [35.47011356600012, -11.592159524999886],
              [35.48344608600007, -11.586888528999864],
              [35.48365279100011, -11.58595835299991],
              [35.490164021000055, -11.584098001999905],
              [35.49409143100013, -11.581824238999971],
              [35.498742310000125, -11.582341002999925],
              [35.50763065600012, -11.589058939999944],
              [35.51300500500008, -11.596603698999985],
              [35.51558882600011, -11.603528340999972],
              [35.52013635200012, -11.60910939499989],
              [35.53150516800008, -11.612726744999875],
              [35.532745402000046, -11.595570169999917],
              [35.54370080600012, -11.594743346999891],
              [35.55982385200008, -11.60104787199991],
              [35.576256958000045, -11.60518198599992],
              [35.599718058000065, -11.592159524999886],
              [35.60085494000003, -11.592262877999914],
              [35.65480513500012, -11.57831024199993],
              [35.664830363000135, -11.57200571699991],
              [35.671858358000065, -11.551438495999918],
              [35.68022994000012, -11.537589212999961],
              [35.69128869600013, -11.524256692999941],
              [35.70338098100012, -11.516505227999929],
              [35.6956295170001, -11.494594420999888],
              [35.71402632600012, -11.483845722999959],
              [35.76425581900014, -11.47485402399991],
              [35.78192915800014, -11.461211445999908],
              [35.81314172300006, -11.422350768999948],
              [35.826370890000135, -11.413462422999928],
              [35.867298625000046, -11.420903828999954],
              [35.895617310000034, -11.432789407999891],
              [35.902025187000106, -11.434546406999871],
              [35.93974898300013, -11.434132994999857],
              [35.953081502000146, -11.440644225999918],
              [35.970341431000065, -11.461211445999908],
              [35.960832967000044, -11.483535664999877],
              [35.96982466600008, -11.502449238999915],
              [35.98853153500011, -11.512164407999947],
              [36.00785852100006, -11.50658335299994],
              [36.02222456900006, -11.505653176999886],
              [36.043101847000116, -11.514851582999881],
              [36.07958540800013, -11.53696909499999],
              [36.08940393000012, -11.540896504999864],
              [36.11152144400012, -11.54658091199991],
              [36.121133260000136, -11.550611673999896],
              [36.129504842000074, -11.557122903999868],
              [36.136016073000064, -11.563840840999902],
              [36.14283736200014, -11.569008483999895],
              [36.1519324140001, -11.571075540999871],
              [36.16805546100005, -11.57872365299994],
              [36.173636515000055, -11.597430521999925],
              [36.17591027800012, -11.620064798999877],
              [36.182628215000136, -11.640011901999898],
              [36.176220337000075, -11.654998066999951],
              [36.179217570000105, -11.675565286999941],
              [36.18820926900014, -11.693652037999868],
              [36.19968143700004, -11.701506855999895],
              [36.240919230000145, -11.694582213999922],
              [36.25290816200004, -11.696649271999974],
              [36.26841109200012, -11.705951029999909],
              [36.27874637800005, -11.708844909999897],
              [36.293422486000054, -11.70729461699996],
              [36.329802694000136, -11.697062682999984],
              [36.36122196500014, -11.692411803999931],
              [36.36814660700014, -11.687760925999953],
              [36.373314250000135, -11.6831100469999],
              [36.37806848200012, -11.680939635999906],
              [36.49485721900004, -11.680939635999906],
              [36.502712036000105, -11.68631398499987],
              [36.50870650200011, -11.709775085999937],
              [36.51501102700013, -11.715046080999883],
              [36.520592082000064, -11.717113138999935],
              [36.54570682800005, -11.729412129999972],
              [36.562966756000094, -11.73127248199998],
              [36.62570194500012, -11.721350605999888],
              [36.640584757000056, -11.716286315999909],
              [36.667249797000125, -11.713392435999921],
              [36.67458785000008, -11.708844909999897],
              [36.679962199000045, -11.70243703199995],
              [36.689677368000105, -11.694582213999922],
              [36.726574341000116, -11.680732930999866],
              [36.73804650900013, -11.674738464999919],
              [36.747038208000106, -11.666470234999878],
              [36.77484012900004, -11.626265970999953],
              [36.82010868300006, -11.573556009999933],
              [36.83705855300013, -11.567974954999912],
              [36.84656701600011, -11.572729186999908],
              [36.86630741400006, -11.574176126999902],
              [36.89111210100015, -11.589989114999895],
              [36.90589156000004, -11.592779642999858],
              [36.998392375000094, -11.58461476599993],
              [37.00779748500014, -11.580584004999935],
              [37.01668583100013, -11.573969420999944],
              [37.03239546700013, -11.564874369999885],
              [37.04438439900008, -11.595673522999945],
              [37.071566203000145, -11.62915985099994],
              [37.10649947100006, -11.65809865299991],
              [37.14163944500007, -11.674738464999919],
              [37.2265954990001, -11.693755390999897],
              [37.27021040900013, -11.698406269999865],
              [37.306073852000054, -11.694582213999922],
              [37.315789021000114, -11.69024139399994],
              [37.323643840000045, -11.685280455999887],
              [37.33139530400007, -11.681559752999888],
              [37.3408004150001, -11.680939635999906],
              [37.352375936000044, -11.68631398499987],
              [37.370152628000085, -11.704814147999898],
              [37.3783175050001, -11.708844909999897],
              [37.427823527000044, -11.722590839999924],
              [37.45066451000008, -11.722590839999924],
              [37.46968143700013, -11.719490254999883],
              [37.47639937400004, -11.715976256999923],
              [37.484770956000034, -11.708844909999897],
              [37.49035201000004, -11.698923034999893],
              [37.496036418000074, -11.68507374999993],
              [37.5037878820001, -11.672671406999953],
              [37.51588016700009, -11.667297057999903],
              [37.53675744700007, -11.662956237999921],
              [37.57293094900007, -11.644146015999908],
              [37.59463505100007, -11.640011901999898],
              [37.6263643800001, -11.639701842999912],
              [37.647758423000084, -11.635981139999984],
              [37.66636193800008, -11.625542500999956],
              [37.71090702300006, -11.59040252699991],
              [37.783667439000055, -11.558879902999948],
              [37.804441366000106, -11.544513854999934],
              [37.816947062000054, -11.533558451999866],
              [37.825111939000124, -11.520225931999946],
              [37.82325158700007, -11.507926939999905],
              [37.81725712100007, -11.495627949999871],
              [37.813226359000055, -11.482295429999937],
              [37.81849735500009, -11.459867858999942],
              [37.84247522000004, -11.41780324299991],
              [37.841028280000046, -11.399819844999925],
              [37.85043339000009, -11.387624206999917],
              [37.86583296800006, -11.342459003999934],
              [37.868416789000094, -11.327782897999953],
              [37.87523807700012, -11.3191012569999],
              [37.93807661900007, -11.283961283999943],
              [37.95461307800008, -11.280033873999884],
              [37.99533410600014, -11.277553404999907],
              [38.00422245300007, -11.275279641999887],
              [38.013627563000114, -11.265461119999927],
              [38.07078169800013, -11.25584930399991],
              [38.09335726900014, -11.256310029999923],
              [38.1011674400001, -11.256469420999878],
              [38.1011674400001, -11.254919128999859],
              [38.10426802500007, -11.252025247999967],
              [38.10933231700011, -11.249648131999919],
              [38.115430135000054, -11.249544778999905],
              [38.11718713400006, -11.252025247999967],
              [38.1224581300001, -11.26122365299996],
              [38.12566206900004, -11.263187356999907],
              [38.1353772380001, -11.266391295999966],
              [38.15501428200014, -11.280550638999927],
              [38.16689986100005, -11.283754576999897],
              [38.178372030000105, -11.281790872999863],
              [38.20048954300012, -11.272695820999985],
              [38.2104114170001, -11.270008645999951],
              [38.25661014800005, -11.277139993999896],
              [38.29247359200008, -11.301634622999941],
              [38.34766402200006, -11.35878875699997],
              [38.383114055000135, -11.37666880299993],
              [38.46238570100007, -11.396305846999965],
              [38.49168788800006, -11.413136860999913],
              [38.49225467900004, -11.413462422999928],
              [38.517162720000044, -11.383076680999878],
              [38.61565799900012, -11.317240904999892],
              [38.63818892400013, -11.28923227899989],
              [38.6542086180001, -11.27579640699993],
              [38.68397424300008, -11.26783823599996],
              [38.704231405000144, -11.258536478999943],
              [38.715083456000116, -11.256469420999878],
              [38.72707238800007, -11.257709655999918],
              [38.74867313700014, -11.262773945999896],
              [38.75973189300004, -11.263187356999907],
              [38.77802535000012, -11.253678893999918],
              [38.81781620300012, -11.216265156999953],
              [38.83104536900004, -11.207996927999915],
              [38.851922648000084, -11.202829283999904],
              [38.869492635000086, -11.190736998999924],
              [38.89626102700004, -11.167689309999957],
              [38.93005741400009, -11.160041198999878],
              [39.06079878800006, -11.160144551999906],
              [39.095421997000074, -11.153426614999972],
              [39.12622115100004, -11.139680683999941],
              [39.149785604000044, -11.14433156299991],
              [39.19050663200011, -11.166242369999864],
              [39.21159061700013, -11.173890481999933],
              [39.23815230300005, -11.17420054099992],
              [39.263267049000035, -11.166759133999903],
              [39.286624797000115, -11.154150084999884],
              [39.48268518000009, -10.999224141999974],
              [39.49849816900007, -10.990645852999947],
              [39.51565474500012, -10.985064798999929],
              [39.592755982000085, -10.979380390999893],
              [39.76049768100006, -10.943103535999938],
              [39.78581913300013, -10.932561542999878],
              [39.88596805800006, -10.864452005999865],
              [39.989114217000065, -10.820940449999938],
              [40.00813114400006, -10.811121927999878],
              [40.133188110000106, -10.714590351999945],
              [40.16109338400008, -10.70435841899996],
              [40.172772258000066, -10.693092956999905],
              [40.19158247900009, -10.668805032999913],
              [40.25070031700005, -10.610927428999972],
              [40.28852746600012, -10.583022154999895],
              [40.35332971100013, -10.56069793699993],
              [40.38919315600009, -10.53527313199993],
              [40.42102583900004, -10.503750508999957],
              [40.43685957100007, -10.474786065999922],
              [40.45394941500007, -10.469008070999905],
              [40.469411655000044, -10.472588799999926],
              [40.47543379000007, -10.482679945999905],
              [40.464854363000086, -10.49586353999996],
              [40.48373457100007, -10.50009530999995],
              [40.510508660000085, -10.477715752999927],
              [40.52702884200005, -10.488457940999922],
              [40.53207441500007, -10.50945403399993],
              [40.521494988000086, -10.526136976999908],
              [40.506602410000085, -10.539320570999905],
              [40.499034050000034, -10.55046965899993],
              [40.506602410000085, -10.566338799999926],
              [40.52475019600007, -10.572930596999925],
              [40.545583530000044, -10.576918226999908],
              [40.56104576900009, -10.584649346999925],
              [40.56812584700003, -10.599786065999922],
              [40.57048587300005, -10.633884372999944],
              [40.57781009200005, -10.649834893999923],
              [40.592133009000065, -10.65789153399993],
              [40.63135826900009, -10.662855726999908],
              [40.64673912900008, -10.670342705999929],
              [40.654958530000044, -10.686944268999923],
              [40.64039147200003, -10.691338799999926],
              [40.60206139400009, -10.687676690999922],
              [40.56983483200008, -10.696709893999923],
              [40.485362175000034, -10.762139580999929],
              [40.492198113000086, -10.79697030999995],
              [40.500010613000086, -10.791599216999941],
              [40.50562584700003, -10.785414320999905],
              [40.50961347700007, -10.778415622999944],
              [40.512705925000034, -10.76962655999995],
              [40.531993035000085, -10.785821221999925],
              [40.60206139400009, -10.820489190999922],
              [40.62029056100005, -10.840915622999944],
              [40.601573113000086, -10.859958591999941],
              [40.54672285200007, -10.88567473799992],
              [40.52857506600009, -10.901950778999947],
              [40.50831139400009, -10.927666924999926],
              [40.496104363000086, -10.955743096999925],
              [40.506602410000085, -10.992771091999941],
              [40.498383009000065, -11.027276299999926],
              [40.506521030000044, -11.03720468499995],
              [40.517914259000065, -11.03443775799991],
              [40.53101647200003, -11.00953541499996],
              [40.54053795700008, -11.003106377999927],
              [40.56609134200005, -11.013929945999905],
              [40.56576582100007, -11.042413018999923],
              [40.55201256600009, -11.07431405999995],
              [40.53687584700003, -11.095147393999923],
              [40.504893425000034, -11.12859465899993],
              [40.499034050000034, -11.13958098799992],
              [40.498383009000065, -11.152520440999922],
              [40.505869988000086, -11.17750416499996],
              [40.506521030000044, -11.187432549999926],
              [40.494151238000086, -11.20476653399993],
              [40.42758222700007, -11.25286223799992],
              [40.42009524800005, -11.265883070999905],
              [40.40544681100005, -11.300713799999926],
              [40.397227410000085, -11.310804945999905],
              [40.38445071700005, -11.315199476999908],
              [40.36052493600005, -11.315199476999908],
              [40.34880618600005, -11.317071221999925],
              [40.35906009200005, -11.33212655999995],
              [40.36768639400009, -11.35125090899993],
              [40.37549889400009, -11.35865650799991],
              [40.38298587300005, -11.338148695999905],
              [40.39812259200005, -11.346856377999927],
              [40.41382897200003, -11.361504815999922],
              [40.42750084700003, -11.37786223799992],
              [40.43685957100007, -11.392185153999947],
              [40.465830925000034, -11.385186455999929],
              [40.471364780000044, -11.416761976999908],
              [40.46509850400008, -11.450372002999927],
              [40.458018425000034, -11.489027601999908],
              [40.44752037900008, -11.520114841999941],
              [40.439463738000086, -11.533786716999941],
              [40.42758222700007, -11.547295830999929],
              [40.42335045700008, -11.563164971999925],
              [40.43506920700008, -11.578708591999941],
              [40.45045006600009, -11.592868747999944],
              [40.458018425000034, -11.605075778999947],
              [40.45199629000007, -11.616306247999944],
              [40.42945397200003, -11.64153411299992],
              [40.42758222700007, -11.65007903399993],
              [40.43832441500007, -11.664646091999941],
              [40.44157962300005, -11.676364841999941],
              [40.444346550000034, -11.70875416499996],
              [40.44898522200003, -11.728448174999926],
              [40.467458530000044, -11.74586353999996],
              [40.470713738000086, -11.75123463299991],
              [40.47201582100007, -11.75758228999996],
              [40.47380618600005, -11.806247653999947],
              [40.479502800000034, -11.823418877999927],
              [40.492198113000086, -11.839043877999927],
              [40.50082441500007, -11.834242445999905],
              [40.506195509000065, -11.83326588299991],
              [40.520192905000044, -11.839043877999927],
              [40.49301191500007, -11.86614348799992],
              [40.48617597700007, -11.895196221999925],
              [40.49301191500007, -11.92506275799991],
              [40.506521030000044, -11.954522393999923],
              [40.53687584700003, -11.996840101999908],
              [40.53687584700003, -12.006036065999922],
              [40.521820509000065, -12.021742445999905],
              [40.51547285200007, -12.03215911299992],
              [40.512705925000034, -12.064385674999926],
              [40.50082441500007, -12.112481377999927],
              [40.499034050000034, -12.126560153999947],
              [40.502940300000034, -12.14430103999996],
              [40.52133222700007, -12.171807549999926],
              [40.52702884200005, -12.187920830999929],
              [40.52491295700008, -12.204522393999923],
              [40.51734459700003, -12.225030205999929],
              [40.505869988000086, -12.242608330999929],
              [40.492198113000086, -12.25009530999995],
              [40.47787519600007, -12.24578215899993],
              [40.46371504000007, -12.23992278399993],
              [40.45362389400009, -12.242608330999929],
              [40.451182488000086, -12.263604424999926],
              [40.47584069100009, -12.258070570999905],
              [40.49781334700003, -12.274183851999908],
              [40.513682488000086, -12.30055103999996],
              [40.520192905000044, -12.325778903999947],
              [40.51710045700008, -12.33961353999996],
              [40.510752800000034, -12.351739190999922],
              [40.506521030000044, -12.364353122999944],
              [40.50953209700003, -12.380303643999923],
              [40.518321160000085, -12.38844166499996],
              [40.53207441500007, -12.39072030999995],
              [40.56104576900009, -12.387139580999929],
              [40.55811608200008, -12.397556247999944],
              [40.55225670700008, -12.40593840899993],
              [40.54411868600005, -12.41179778399993],
              [40.52116946700005, -12.417575778999947],
              [40.514659050000034, -12.42669036299992],
              [40.506521030000044, -12.447930596999925],
              [40.48031660200007, -12.484307549999926],
              [40.47820071700005, -12.501071872999944],
              [40.492198113000086, -12.51685963299991],
              [40.50277754000007, -12.521416924999926],
              [40.51490319100009, -12.523370049999926],
              [40.55689537900008, -12.525323174999926],
              [40.56202233200008, -12.530043226999908],
              [40.56104576900009, -12.59856536299992],
              [40.564789259000065, -12.61305103999996],
              [40.57374108200008, -12.619398695999905],
              [40.58513431100005, -12.622247002999927],
              [40.61410566500007, -12.63681405999995],
              [40.61963951900009, -12.645114841999941],
              [40.61264082100007, -12.65748463299991],
              [40.60271243600005, -12.658949476999908],
              [40.58562259200005, -12.639825127999927],
              [40.57471764400009, -12.639825127999927],
              [40.56804446700005, -12.649590752999927],
              [40.568695509000065, -12.662286065999922],
              [40.578135613000086, -12.70631275799991],
              [40.58643639400009, -12.706638278999947],
              [40.59742272200003, -12.70094166499996],
              [40.60889733200008, -12.701836846999925],
              [40.61605879000007, -12.71217213299991],
              [40.62452233200008, -12.738213799999926],
              [40.62940514400009, -12.74342213299991],
              [40.64144941500007, -12.746840101999908],
              [40.646820509000065, -12.755303643999923],
              [40.646820509000065, -12.766289971999925],
              [40.64307701900009, -12.777520440999922],
              [40.626963738000086, -12.793633721999925],
              [40.605479363000086, -12.798272393999923],
              [40.583994988000086, -12.79265715899993],
              [40.56788170700008, -12.777520440999922],
              [40.567067905000044, -12.785577080999929],
              [40.56885826900009, -12.795586846999925],
              [40.57195071700005, -12.803399346999925],
              [40.57471764400009, -12.804864190999922],
              [40.56006920700008, -12.813897393999923],
              [40.531993035000085, -12.81145598799992],
              [40.52702884200005, -12.818942966999941],
              [40.533213738000086, -12.827325127999927],
              [40.545583530000044, -12.83521900799991],
              [40.55445397200003, -12.846856377999927],
              [40.55054772200003, -12.866387627999927],
              [40.53931725400008, -12.892998955999929],
              [40.533213738000086, -12.901055596999925],
              [40.524424675000034, -12.909356377999927],
              [40.52173912900008, -12.91025155999995],
              [40.51937910200007, -12.906426690999922],
              [40.512705925000034, -12.901055596999925],
              [40.513682488000086, -12.89267343499995],
              [40.51026451900009, -12.88600025799991],
              [40.499034050000034, -12.88054778399993],
              [40.490244988000086, -12.879652601999908],
              [40.48406009200005, -12.881280205999929],
              [40.45533287900008, -12.89617278399993],
              [40.43490644600007, -12.910332940999922],
              [40.417979363000086, -12.926853122999944],
              [40.410899285000085, -12.942071221999925],
              [40.41260826900009, -12.96103280999995],
              [40.41773522200003, -12.971856377999927],
              [40.46827233200008, -13.017022393999923],
              [40.483409050000034, -13.021905205999929],
              [40.499034050000034, -13.01653411299992],
              [40.512380405000044, -12.99895598799992],
              [40.50709069100009, -12.984795830999929],
              [40.49626712300005, -12.970961195999905],
              [40.492198113000086, -12.955010674999926],
              [40.50017337300005, -12.948011976999908],
              [40.51547285200007, -12.947442315999922],
              [40.53207441500007, -12.951592705999929],
              [40.543711785000085, -12.958428643999923],
              [40.55811608200008, -12.962334893999923],
              [40.57504316500007, -12.957777601999908],
              [40.58920332100007, -12.95794036299992],
              [40.59522545700008, -12.975681247999944],
              [40.58961022200003, -13.008070570999905],
              [40.56568444100009, -13.066013278999947],
              [40.56104576900009, -13.099053643999923],
              [40.563487175000034, -13.11687590899993],
              [40.57276451900009, -13.150567315999922],
              [40.57471764400009, -13.16806405999995],
              [40.56788170700008, -13.243340752999927],
              [40.56226647200003, -13.262872002999927],
              [40.549489780000044, -13.274509372999944],
              [40.535492384000065, -13.284356377999927],
              [40.52702884200005, -13.298272393999923],
              [40.529633009000065, -13.31023528399993],
              [40.54281660200007, -13.305271091999941],
              [40.56788170700008, -13.284763278999947],
              [40.56788170700008, -13.366631768999923],
              [40.57252037900008, -13.364841403999947],
              [40.58375084700003, -13.36223723799992],
              [40.58838951900009, -13.360446872999944],
              [40.58448326900009, -13.383233330999929],
              [40.55420983200008, -13.415134372999944],
              [40.54672285200007, -13.431817315999922],
              [40.54468834700003, -13.47470468499995],
              [40.53874759200005, -13.495538018999923],
              [40.52702884200005, -13.510511976999908],
              [40.52702884200005, -13.510593356999948],
              [40.54444420700008, -13.52467213299991],
              [40.55909264400009, -13.542901299999926],
              [40.574554884000065, -13.558526299999926],
              [40.59522545700008, -13.565199476999908],
              [40.596446160000085, -13.571709893999923],
              [40.58334394600007, -13.587009372999944],
              [40.55054772200003, -13.616794528999947],
              [40.539398634000065, -13.63640715899993],
              [40.54265384200005, -13.658868096999925],
              [40.56999759200005, -13.716403903999947],
              [40.574961785000085, -13.734551690999922],
              [40.590586785000085, -13.85328541499996],
              [40.603526238000086, -13.88014088299991],
              [40.604177280000044, -13.891045830999929],
              [40.606211785000085, -13.90203215899993],
              [40.621755405000044, -13.916680596999925],
              [40.62842858200008, -13.92506275799991],
              [40.63396243600005, -13.93450286299992],
              [40.63624108200008, -13.942559502999927],
              [40.63851972700007, -13.967461846999925],
              [40.64869225400008, -14.011325778999947],
              [40.65056399800005, -14.031914971999925],
              [40.64568118600005, -14.05868905999995],
              [40.63428795700008, -14.070733330999929],
              [40.59522545700008, -14.085381768999923],
              [40.60670006600009, -14.092054945999905],
              [40.61646569100009, -14.101495049999926],
              [40.62159264400009, -14.11337655999995],
              [40.619476759000065, -14.127211195999905],
              [40.60962975400008, -14.138604424999926],
              [40.596690300000034, -14.143161716999941],
              [40.56788170700008, -14.14739348799992],
              [40.53858483200008, -14.164483330999929],
              [40.54542076900009, -14.18132903399993],
              [40.56006920700008, -14.201836846999925],
              [40.55420983200008, -14.230075778999947],
              [40.56788170700008, -14.225762627999927],
              [40.579112175000034, -14.206638278999947],
              [40.58806399800005, -14.206149997999944],
              [40.59489993600005, -14.21461353999996],
              [40.591807488000086, -14.22470468499995],
              [40.590179884000065, -14.234795830999929],
              [40.60206139400009, -14.243584893999923],
              [40.58708743600005, -14.254489841999941],
              [40.58090254000007, -14.257256768999923],
              [40.59148196700005, -14.263278903999947],
              [40.601898634000065, -14.263116143999923],
              [40.61215254000007, -14.258233330999929],
              [40.62256920700008, -14.250420830999929],
              [40.62232506600009, -14.221286716999941],
              [40.647146030000044, -14.202569268999923],
              [40.696299675000034, -14.18254973799992],
              [40.70850670700008, -14.19068775799991],
              [40.720713738000086, -14.20476653399993],
              [40.72624759200005, -14.219821872999944],
              [40.72413170700008, -14.250176690999922],
              [40.72934004000007, -14.26140715899993],
              [40.746104363000086, -14.270928643999923],
              [40.735036655000044, -14.28525155999995],
              [40.73023522200003, -14.304131768999923],
              [40.72999108200008, -14.323663018999923],
              [40.732432488000086, -14.33993905999995],
              [40.718760613000086, -14.344333591999941],
              [40.69516035200007, -14.362725518999923],
              [40.684580925000034, -14.367120049999926],
              [40.67074629000007, -14.36305103999996],
              [40.65162194100009, -14.34351978999996],
              [40.63624108200008, -14.33993905999995],
              [40.656586134000065, -14.449151299999926],
              [40.63884524800005, -14.443536065999922],
              [40.629649285000085, -14.449883721999925],
              [40.63062584700003, -14.461114190999922],
              [40.64307701900009, -14.470147393999923],
              [40.62256920700008, -14.490655205999929],
              [40.62452233200008, -14.49618905999995],
              [40.62907962300005, -14.501560153999947],
              [40.633799675000034, -14.50481536299992],
              [40.63624108200008, -14.504327080999929],
              [40.62875410200007, -14.550713799999926],
              [40.62940514400009, -14.566338799999926],
              [40.65056399800005, -14.547051690999922],
              [40.66529381600009, -14.523858330999929],
              [40.69263756600009, -14.439711195999905],
              [40.70053144600007, -14.432061455999929],
              [40.760752800000034, -14.403741143999923],
              [40.77328535200007, -14.40129973799992],
              [40.801442905000044, -14.410739841999941],
              [40.82837975400008, -14.434258721999925],
              [40.842539910000085, -14.464450778999947],
              [40.832041863000086, -14.494073174999926],
              [40.819021030000044, -14.502536716999941],
              [40.78842207100007, -14.509372653999947],
              [40.77328535200007, -14.514825127999927],
              [40.76002037900008, -14.526136976999908],
              [40.76099694100009, -14.53492603999996],
              [40.77173912900008, -14.539727471999925],
              [40.78695722700007, -14.53915780999995],
              [40.79712975400008, -14.53215911299992],
              [40.80616295700008, -14.522230726999908],
              [40.81609134200005, -14.517185153999947],
              [40.82862389400009, -14.524834893999923],
              [40.83375084700003, -14.53875090899993],
              [40.83220462300005, -14.555840752999927],
              [40.81137129000007, -14.61296965899993],
              [40.813243035000085, -14.623711846999925],
              [40.82178795700008, -14.640801690999922],
              [40.82504316500007, -14.644138278999947],
              [40.83090254000007, -14.64812590899993],
              [40.83716881600009, -14.653741143999923],
              [40.84229576900009, -14.662041924999926],
              [40.84351647200003, -14.668552341999941],
              [40.84359785200007, -14.682305596999925],
              [40.845713738000086, -14.68922291499996],
              [40.847992384000065, -14.705010674999926],
              [40.83415774800005, -14.763604424999926],
              [40.83220462300005, -14.769138278999947],
              [40.832692905000044, -14.774021091999941],
              [40.838877800000034, -14.781426690999922],
              [40.842458530000044, -14.78720468499995],
              [40.842539910000085, -14.792901299999926],
              [40.84009850400008, -14.798272393999923],
              [40.83545983200008, -14.802341403999947],
              [40.78760826900009, -14.82195403399993],
              [40.78012129000007, -14.829522393999923],
              [40.77515709700003, -14.838067315999922],
              [40.739268425000034, -14.87428150799991],
              [40.72624759200005, -14.886895440999922],
              [40.709727410000085, -14.895277601999908],
              [40.69166100400008, -14.90007903399993],
              [40.67408287900008, -14.901543877999927],
              [40.66570071700005, -14.89544036299992],
              [40.65455162900008, -14.865166924999926],
              [40.64307701900009, -14.853773695999905],
              [40.64698326900009, -14.872653903999947],
              [40.64812259200005, -14.89153411299992],
              [40.65365644600007, -14.908461195999905],
              [40.670909050000034, -14.922051690999922],
              [40.68685957100007, -14.924574476999908],
              [40.734385613000086, -14.924493096999925],
              [40.746104363000086, -14.922051690999922],
              [40.75635826900009, -14.938083591999941],
              [40.76710045700008, -14.960381768999923],
              [40.774424675000034, -14.982354424999926],
              [40.77393639400009, -14.99773528399993],
              [40.75904381600009, -14.98560963299991],
              [40.74887129000007, -14.984551690999922],
              [40.739268425000034, -14.98837655999995],
              [40.72624759200005, -14.990980726999908],
              [40.670909050000034, -14.97665780999995],
              [40.66195722700007, -14.994886976999908],
              [40.674571160000085, -15.023614190999922],
              [40.711924675000034, -15.072930596999925],
              [40.68083743600005, -15.08367278399993],
              [40.64966881600009, -15.08766041499996],
              [40.62224368600005, -15.098077080999929],
              [40.60206139400009, -15.128106377999927],
              [40.58765709700003, -15.12281666499996],
              [40.567393425000034, -15.118340752999927],
              [40.547211134000065, -15.11695728999996],
              [40.533213738000086, -15.120700778999947],
              [40.528005405000044, -15.131036065999922],
              [40.51970462300005, -15.16725025799991],
              [40.512705925000034, -15.182061455999929],
              [40.54835045700008, -15.187432549999926],
              [40.56609134200005, -15.193536065999922],
              [40.58090254000007, -15.20322030999995],
              [40.58952884200005, -15.173028252999927],
              [40.60962975400008, -15.161309502999927],
              [40.635427280000044, -15.164646091999941],
              [40.66041100400008, -15.17896900799991],
              [40.674164259000065, -15.201104424999926],
              [40.681651238000086, -15.233005466999941],
              [40.67750084700003, -15.260918877999927],
              [40.656586134000065, -15.27157968499995],
              [40.66928144600007, -15.286716403999947],
              [40.66684004000007, -15.299248955999929],
              [40.62940514400009, -15.339043877999927],
              [40.62484785200007, -15.345635674999926],
              [40.62663821700005, -15.36142343499995],
              [40.62354576900009, -15.369805596999925],
              [40.61833743600005, -15.378350518999923],
              [40.61264082100007, -15.385023695999905],
              [40.59343509200005, -15.402276299999926],
              [40.58838951900009, -15.408623955999929],
              [40.586680535000085, -15.41611093499995],
              [40.588226759000065, -15.432305596999925],
              [40.584646030000044, -15.439711195999905],
              [40.57634524800005, -15.453057549999926],
              [40.57276451900009, -15.468194268999923],
              [40.576182488000086, -15.47861093499995],
              [40.58838951900009, -15.477634372999944],
              [40.58179772200003, -15.492120049999926],
              [40.573252800000034, -15.504978122999944],
              [40.56185957100007, -15.515883070999905],
              [40.54672285200007, -15.525323174999926],
              [40.53337649800005, -15.53093840899993],
              [40.52426191500007, -15.531670830999929],
              [40.499034050000034, -15.525323174999926],
              [40.49594160200007, -15.551527601999908],
              [40.48072350400008, -15.569105726999908],
              [40.44068444100009, -15.59734465899993],
              [40.425791863000086, -15.61500416499996],
              [40.363617384000065, -15.714776299999926],
              [40.16456139400009, -15.915622653999947],
              [40.12224368600005, -15.939629815999922],
              [40.11605879000007, -15.948418877999927],
              [40.113942905000044, -15.96103280999995],
              [40.109711134000065, -15.972263278999947],
              [40.098399285000085, -15.977227471999925],
              [40.08912194100009, -15.97861093499995],
              [40.076182488000086, -15.98251718499995],
              [40.06495201900009, -15.98919036299992],
              [40.06080162900008, -15.998304945999905],
              [40.07203209700003, -16.00953541499996],
              [40.09351647200003, -15.997979424999926],
              [40.12907962300005, -15.963555596999925],
              [40.134776238000086, -15.986504815999922],
              [40.12680097700007, -16.004082940999922],
              [40.115244988000086, -16.020277601999908],
              [40.10922285200007, -16.039239190999922],
              [40.10474694100009, -16.064060153999947],
              [40.09302819100009, -16.079522393999923],
              [40.06080162900008, -16.108168226999908],
              [40.01929772200003, -16.184991143999923],
              [39.99236087300005, -16.22242603999996],
              [39.957774285000085, -16.238539320999905],
              [39.89372806100005, -16.239678643999923],
              [39.87525475400008, -16.244805596999925],
              [39.81332441500007, -16.276950778999947],
              [39.78337649800005, -16.301934502999927],
              [39.78093509200005, -16.306247653999947],
              [39.78256269600007, -16.31487395599993],
              [39.789398634000065, -16.31845468499995],
              [39.80062910200007, -16.319919528999947],
              [39.80128014400009, -16.33171965899993],
              [39.799815300000034, -16.35637786299992],
              [39.80062910200007, -16.368259372999944],
              [39.80795332100007, -16.388929945999905],
              [39.820648634000065, -16.40667083099993],
              [39.83708743600005, -16.42050546699994],
              [39.85596764400009, -16.42978280999995],
              [39.810557488000086, -16.45761484199994],
              [39.79379316500007, -16.46379973799992],
              [39.79265384200005, -16.45671965899993],
              [39.78760826900009, -16.443617445999905],
              [39.78638756600009, -16.43645598799992],
              [39.77686608200008, -16.440850518999923],
              [39.76693769600007, -16.443291924999926],
              [39.75668379000007, -16.444105726999908],
              [39.746104363000086, -16.443291924999926],
              [39.75131269600007, -16.447930596999925],
              [39.760752800000034, -16.45907968499995],
              [39.765961134000065, -16.46379973799992],
              [39.73910566500007, -16.47307708099993],
              [39.72901451900009, -16.479180596999925],
              [39.71827233200008, -16.49114348799992],
              [39.71957441500007, -16.492933851999908],
              [39.720713738000086, -16.499200127999927],
              [39.71989993600005, -16.507256768999923],
              [39.71509850400008, -16.515069268999923],
              [39.698252800000034, -16.53215911299992],
              [39.678396030000044, -16.546075127999927],
              [39.637461785000085, -16.568291924999926],
              [39.60767662900008, -16.59189218499995],
              [39.567393425000034, -16.60442473799992],
              [39.55779056100005, -16.610935153999947],
              [39.53256269600007, -16.635837497999944],
              [39.356211785000085, -16.72389088299991],
              [39.20435631600009, -16.81698984199994],
              [39.187510613000086, -16.83098723799992],
              [39.16146894600007, -16.867852471999925],
              [39.147471550000034, -16.87664153399993],
              [39.12916100400008, -16.867852471999925],
              [39.12907962300005, -16.871840101999908],
              [39.128916863000086, -16.888116143999923],
              [39.117930535000085, -16.901788018999923],
              [39.10043379000007, -16.910414320999905],
              [39.080739780000044, -16.91570403399993],
              [39.098317905000044, -16.921807549999926],
              [39.113291863000086, -16.91725025799991],
              [39.12232506600009, -16.917413018999923],
              [39.12232506600009, -16.93678150799991],
              [39.116221550000034, -16.95476653399993],
              [39.10499108200008, -16.970961195999905],
              [39.090505405000044, -16.983819268999923],
              [39.074554884000065, -16.991387627999927],
              [39.03858483200008, -16.995293877999927],
              [39.00367272200003, -16.993259372999944],
              [38.97046959700003, -16.996270440999922],
              [38.91260826900009, -17.033868096999925],
              [38.87549889400009, -17.045586846999925],
              [38.71827233200008, -17.059665622999944],
              [38.703135613000086, -17.054131768999923],
              [38.67945397200003, -17.03020598799992],
              [38.66293379000007, -17.025567315999922],
              [38.68490644600007, -17.054131768999923],
              [38.666758660000085, -17.075372002999927],
              [38.629893425000034, -17.088962497999944],
              [38.59546959700003, -17.094414971999925],
              [38.59978274800005, -17.076104424999926],
              [38.553070509000065, -17.121758721999925],
              [38.537445509000065, -17.12151458099993],
              [38.52662194100009, -17.11419036299992],
              [38.51880944100009, -17.106540622999944],
              [38.51221764400009, -17.104668877999927],
              [38.504242384000065, -17.110935153999947],
              [38.500336134000065, -17.118584893999923],
              [38.50082441500007, -17.127129815999922],
              [38.50538170700008, -17.135430596999925],
              [38.22282962300005, -17.243584893999923],
              [38.20980879000007, -17.252699476999908],
              [38.18702233200008, -17.278008721999925],
              [38.172862175000034, -17.28753020599993],
              [38.15593509200005, -17.28679778399993],
              [38.137705925000034, -17.263848565999922],
              [38.13624108200008, -17.196465752999927],
              [38.121755405000044, -17.176934502999927],
              [38.12859134200005, -17.197442315999922],
              [38.11670983200008, -17.201918226999908],
              [38.10401451900009, -17.201104424999926],
              [38.091807488000086, -17.196709893999923],
              [38.080821160000085, -17.19068775799991],
              [38.094737175000034, -17.211114190999922],
              [38.118174675000034, -17.234551690999922],
              [38.129649285000085, -17.256605726999908],
              [38.108083530000044, -17.27320728999996],
              [38.127940300000034, -17.286309502999927],
              [38.10474694100009, -17.30364348799992],
              [38.03988691500007, -17.32781340899993],
              [37.908864780000044, -17.35515715899993],
              [37.85368899800005, -17.383477471999925],
              [37.72445722700007, -17.468357028999947],
              [37.71436608200008, -17.46998463299991],
              [37.71705162900008, -17.456963799999926],
              [37.692067905000044, -17.467054945999905],
              [37.65512129000007, -17.49781666499996],
              [37.615244988000086, -17.52385833099993],
              [37.58057701900009, -17.518975518999923],
              [37.55591881600009, -17.545668226999908],
              [37.42741946700005, -17.618747653999947],
              [37.40064537900008, -17.644463799999926],
              [37.38559004000007, -17.65488046699994],
              [37.371104363000086, -17.658461195999905],
              [37.36085045700008, -17.649997653999947],
              [37.34392337300005, -17.67310963299991],
              [37.333994988000086, -17.681084893999923],
              [37.31983483200008, -17.68417734199994],
              [37.29314212300005, -17.684747002999927],
              [37.28296959700009, -17.690606377999927],
              [37.27898196700005, -17.704278252999927],
              [37.26783287900008, -17.72039153399993],
              [37.242198113000086, -17.736504815999922],
              [37.21241295700008, -17.74504973799992],
              [37.189463738000086, -17.73870208099993],
              [37.18506920700008, -17.775648695999905],
              [37.156586134000065, -17.81023528399993],
              [37.08643639400009, -17.869073174999926],
              [37.01351972700007, -17.985528252999927],
              [36.98406009200005, -18.012383721999925],
              [36.98365319100009, -18.004652601999908],
              [36.977224155000044, -17.985121351999908],
              [36.97038821700005, -17.99195728999996],
              [36.96143639400009, -17.97909921699994],
              [36.95264733200008, -17.969496351999908],
              [36.942393425000034, -17.962009372999944],
              [36.92920983200008, -17.955336195999905],
              [36.915049675000034, -17.944919528999947],
              [36.91146894600007, -17.93254973799992],
              [36.91163170700008, -17.918633721999925],
              [36.90837649800005, -17.90325286299992],
              [36.88795006600009, -17.881036065999922],
              [36.85914147200009, -17.871270440999922],
              [36.832774285000085, -17.877618096999925],
              [36.81959069100009, -17.90325286299992],
              [36.85173587300005, -17.88290780999995],
              [36.87354576900009, -17.89902109199994],
              [36.887461785000085, -17.93254973799992],
              [36.895274285000085, -17.96461353999996],
              [36.90007571700005, -18.00164153399993],
              [36.90748131600009, -18.014418226999908],
              [36.94092858200008, -18.022230726999908],
              [36.95248457100007, -18.029229424999926],
              [36.963552280000044, -18.038262627999927],
              [36.977224155000044, -18.04656340899993],
              [36.94662519600007, -18.101820570999905],
              [36.93287194100009, -18.11882903399993],
              [36.906993035000085, -18.144707940999922],
              [36.898448113000086, -18.158868096999925],
              [36.895274285000085, -18.176934502999927],
              [36.887380405000044, -18.189060153999947],
              [36.86841881600009, -18.186211846999925],
              [36.84555097700007, -18.17896900799991],
              [36.82642662900008, -18.17750416499996],
              [36.811208530000044, -18.186944268999923],
              [36.80103600400008, -18.201348565999922],
              [36.78541100400008, -18.23211028399993],
              [36.80420983200008, -18.225355726999908],
              [36.83350670700008, -18.20476653399993],
              [36.84750410200007, -18.198011976999908],
              [36.83570397200009, -18.219008070999905],
              [36.766286655000044, -18.300225518999923],
              [36.725596550000034, -18.33294036299992],
              [36.63168379000007, -18.437676690999922],
              [36.584971550000034, -18.47893645599993],
              [36.55201256600009, -18.48601653399993],
              [36.54476972700007, -18.52629973799992],
              [36.53834069100009, -18.54070403399993],
              [36.531911655000044, -18.536228122999944],
              [36.51107832100007, -18.52703215899993],
              [36.514414910000085, -18.546807549999926],
              [36.517914259000065, -18.55364348799992],
              [36.50505618600005, -18.55242278399993],
              [36.486664259000065, -18.552911065999922],
              [36.47291100400008, -18.55641041499996],
              [36.47348066500007, -18.56422291499996],
              [36.479502800000034, -18.576429945999905],
              [36.47445722700007, -18.588148695999905],
              [36.45655358200008, -18.608982028999947],
              [36.41749108200008, -18.68873463299991],
              [36.40186608200008, -18.71135833099993],
              [36.40365644600007, -18.69817473799992],
              [36.40162194100009, -18.689385674999926],
              [36.39625084700009, -18.68645598799992],
              [36.38819420700008, -18.690850518999923],
              [36.38428795700008, -18.698663018999923],
              [36.38111412900008, -18.72047291499996],
              [36.37240644600007, -18.741794528999947],
              [36.38054446700005, -18.74456145599993],
              [36.38990319100009, -18.740411065999922],
              [36.38819420700008, -18.73251718499995],
              [36.39185631600009, -18.734633070999905],
              [36.398773634000065, -18.737399997999944],
              [36.40186608200008, -18.739353122999944],
              [36.403005405000044, -18.742445570999905],
              [36.40316816500007, -18.752129815999922],
              [36.41618899800005, -18.774997653999947],
              [36.40748131600009, -18.78484465899993],
              [36.39079837300005, -18.79078541499996],
              [36.377696160000085, -18.79729583099993],
              [36.35889733200008, -18.804131768999923],
              [36.336273634000065, -18.79729583099993],
              [36.31373131600009, -18.78606536299992],
              [36.29542076900009, -18.78020598799992],
              [36.272227410000085, -18.758477471999925],
              [36.23812910200007, -18.694105726999908],
              [36.23682701900009, -18.72503020599993],
              [36.258555535000085, -18.794366143999923],
              [36.26417076900009, -18.830254815999922],
              [36.250336134000065, -18.862888278999947],
              [36.25904381600009, -18.865411065999922],
              [36.26547285200007, -18.870212497999944],
              [36.26937910200007, -18.877211195999905],
              [36.27084394600007, -18.88640715899993],
              [36.26693769600007, -18.890883070999905],
              [36.258148634000065, -18.889336846999925],
              [36.24431399800005, -18.88323333099993],
              [36.21143639400009, -18.888278903999947],
              [36.18213951900009, -18.89690520599993],
              [36.14673912900008, -18.90048593499995],
              [36.131846550000034, -18.886325778999947],
              [36.126963738000086, -18.82870859199994],
              [36.12907962300005, -18.82122161299992],
              [36.13306725400008, -18.811944268999923],
              [36.13306725400008, -18.804131768999923],
              [36.123789910000085, -18.800713799999926],
              [36.114268425000034, -18.802178643999923],
              [36.10857181100005, -18.80592213299991],
              [36.078461134000065, -18.837823174999926],
              [36.03060957100007, -18.905694268999923],
              [36.00953209700009, -18.92083098799992],
              [35.97673587300005, -18.924899997999944],
              [35.982758009000065, -18.904554945999905],
              [35.978851759000065, -18.893731377999927],
              [35.96892337300005, -18.89299895599993],
              [35.95679772200009, -18.903741143999923],
              [35.95093834700009, -18.918226820999905],
              [35.94678795700008, -18.93613046699994],
              [35.94076582100007, -18.95322030999995],
              [35.92896569100009, -18.965101820999905],
              [35.90748131600009, -18.969821872999944],
              [35.895518425000034, -18.96135833099993],
              [35.88640384200005, -18.949476820999905],
              [35.87354576900009, -18.944105726999908],
              [35.863942905000044, -18.946384372999944],
              [35.85531660200007, -18.951348565999922],
              [35.84937584700009, -18.95907968499995],
              [35.84693444100009, -18.968926690999922],
              [35.850271030000044, -18.978692315999922],
              [35.857758009000065, -18.976820570999905],
              [35.86687259200005, -18.97193775799991],
              [35.87354576900009, -18.972588799999926],
              [35.86744225400008, -18.988457940999922],
              [35.723399285000085, -19.08245208099993],
              [35.71436608200008, -19.09238046699994],
              [35.69898522200009, -19.11419036299992],
              [35.68873131600009, -19.12281666499996],
              [35.676117384000065, -19.119805596999925],
              [35.66228274800005, -19.132989190999922],
              [35.64087975400008, -19.170668226999908],
              [35.64812259200005, -19.167087497999944],
              [35.65381920700008, -19.16570403399993],
              [35.66822350400008, -19.16383228999996],
              [35.66822350400008, -19.170668226999908],
              [35.64047285200007, -19.185479424999926],
              [35.614024285000085, -19.205743096999925],
              [35.565196160000085, -19.252618096999925],
              [35.58570397200009, -19.252618096999925],
              [35.57732181100005, -19.266371351999908],
              [35.53272545700008, -19.315199476999908],
              [35.525401238000086, -19.32008228999996],
              [35.51392662900008, -19.32203541499996],
              [35.50521894600007, -19.325372002999927],
              [35.50147545700008, -19.33326588299991],
              [35.498708530000044, -19.343194268999923],
              [35.493174675000034, -19.35247161299992],
              [35.44166100400008, -19.41765715899993],
              [35.339854363000086, -19.520684502999927],
              [35.22250410200007, -19.610121351999908],
              [35.12680097700007, -19.705010674999926],
              [35.092133009000065, -19.719414971999925],
              [35.067067905000044, -19.726006768999923],
              [35.01254316500007, -19.779473565999922],
              [34.98226972700007, -19.80136484199994],
              [34.97315514400009, -19.790948174999926],
              [34.96176191500007, -19.798435153999947],
              [34.934580925000034, -19.829278252999927],
              [34.88005618600005, -19.86337655999995],
              [34.84848066500007, -19.85165780999995],
              [34.84001712300005, -19.844414971999925],
              [34.832774285000085, -19.829278252999927],
              [34.82740319100009, -19.80055103999996],
              [34.82309004000007, -19.786716403999947],
              [34.81568444100009, -19.780857028999947],
              [34.807302280000044, -19.775567315999922],
              [34.76498457100007, -19.739841403999947],
              [34.717133009000065, -19.72307708099993],
              [34.705821160000085, -19.715590101999908],
              [34.666351759000065, -19.659274997999944],
              [34.65805097700007, -19.65048593499995],
              [34.642914259000065, -19.64381275799991],
              [34.63624108200008, -19.628350518999923],
              [34.63257897200009, -19.610121351999908],
              [34.62671959700009, -19.595879815999922],
              [34.61695397200009, -19.589450778999947],
              [34.60108483200008, -19.58294036299992],
              [34.58350670700008, -19.57789478999996],
              [34.56861412900008, -19.57594166499996],
              [34.55323326900009, -19.582289320999905],
              [34.54273522200009, -19.610121351999908],
              [34.53044681100005, -19.616306247999944],
              [34.53044681100005, -19.623711846999925],
              [34.54607181100005, -19.62273528399993],
              [34.565114780000044, -19.60670338299991],
              [34.582041863000086, -19.602715752999927],
              [34.599619988000086, -19.604913018999923],
              [34.61378014400009, -19.611586195999905],
              [34.62322024800005, -19.623304945999905],
              [34.63021894600007, -19.654229424999926],
              [34.63884524800005, -19.669528903999947],
              [34.69190514400009, -19.742933851999908],
              [34.69809004000007, -19.74667734199994],
              [34.70818118600005, -19.75009530999995],
              [34.72592207100007, -19.753513278999947],
              [34.735036655000044, -19.75676848799992],
              [34.741221550000034, -19.764743747999944],
              [34.75017337300005, -19.780857028999947],
              [34.77361087300005, -19.806084893999923],
              [34.77759850400008, -19.81503671699994],
              [34.77295983200008, -19.84148528399993],
              [34.75757897200009, -19.869073174999926],
              [34.735118035000085, -19.886895440999922],
              [34.70923912900008, -19.883884372999944],
              [34.71176191500007, -19.901055596999925],
              [34.72120201900009, -19.901055596999925],
              [34.733164910000085, -19.893975518999923],
              [34.74333743600005, -19.890069268999923],
              [34.76107832100007, -19.895196221999925],
              [34.76482181100005, -19.90325286299992],
              [34.75700931100005, -19.93173593499995],
              [34.75757897200009, -19.947930596999925],
              [34.76417076900009, -19.98023853999996],
              [34.76498457100007, -19.99309661299992],
              [34.76384524800005, -20.001397393999923],
              [34.76197350400008, -20.00676848799992],
              [34.758799675000034, -20.01140715899993],
              [34.75359134200005, -20.01726653399993],
              [34.74887129000007, -20.026788018999923],
              [34.750743035000085, -20.035332940999922],
              [34.75473066500007, -20.04338958099993],
              [34.75700931100005, -20.051446221999925],
              [34.75562584700009, -20.073337497999944],
              [34.75700931100005, -20.083103122999944],
              [34.76002037900008, -20.090590101999908],
              [34.76880944100009, -20.10523853999996],
              [34.77198326900009, -20.120293877999927],
              [34.77686608200008, -20.135023695999905],
              [34.77759850400008, -20.14381275799991],
              [34.77491295700008, -20.15211353999996],
              [34.76685631600009, -20.161553643999923],
              [34.76498457100007, -20.16838958099993],
              [34.756521030000044, -20.180352471999925],
              [34.73715254000007, -20.17506275799991],
              [34.705821160000085, -20.15748463299991],
              [34.68921959700009, -20.161553643999923],
              [34.67514082100007, -20.16765715899993],
              [34.66382897200009, -20.167087497999944],
              [34.655284050000034, -20.151462497999944],
              [34.65642337300005, -20.158949476999908],
              [34.656260613000086, -20.16464609199994],
              [34.655284050000034, -20.171807549999926],
              [34.67074629000007, -20.188571872999944],
              [34.74333743600005, -20.226495049999926],
              [34.74333743600005, -20.232679945999905],
              [34.735118035000085, -20.24081796699994],
              [34.727549675000034, -20.25286223799992],
              [34.72095787900008, -20.267022393999923],
              [34.71029707100007, -20.30055103999996],
              [34.705739780000044, -20.31096770599993],
              [34.68531334700009, -20.332289320999905],
              [34.67994225400008, -20.34693775799991],
              [34.703461134000065, -20.362481377999927],
              [34.69874108200008, -20.373223565999922],
              [34.68327884200005, -20.383884372999944],
              [34.67017662900008, -20.38836028399993],
              [34.656911655000044, -20.386163018999923],
              [34.64031009200005, -20.376071872999944],
              [34.64389082100007, -20.390801690999922],
              [34.64926191500007, -20.40553150799991],
              [34.656260613000086, -20.41855234199994],
              [34.66456139400009, -20.428480726999908],
              [34.67758222700007, -20.437107028999947],
              [34.69890384200005, -20.440850518999923],
              [34.70923912900008, -20.445570570999905],
              [34.71225019600007, -20.45240650799991],
              [34.71631920700008, -20.466973565999922],
              [34.717539910000085, -20.48365650799991],
              [34.71265709700009, -20.497165622999944],
              [34.67310631600009, -20.528903903999947],
              [34.668304884000065, -20.54111093499995],
              [34.70337975400008, -20.52385833099993],
              [34.72429446700005, -20.519138278999947],
              [34.73991946700005, -20.52434661299992],
              [34.74244225400008, -20.550225518999923],
              [34.74968509200005, -20.560153903999947],
              [34.76498457100007, -20.54859791499996],
              [34.77312259200005, -20.569512627999927],
              [34.78646894600007, -20.578871351999908],
              [34.803721550000034, -20.585870049999926],
              [34.82211347700007, -20.599786065999922],
              [34.83253014400009, -20.612074476999908],
              [34.84009850400008, -20.624932549999926],
              [34.844737175000034, -20.64072030999995],
              [34.846446160000085, -20.661553643999923],
              [34.85181725400008, -20.67083098799992],
              [34.88038170700008, -20.651136976999908],
              [34.893565300000034, -20.658461195999905],
              [34.892588738000086, -20.67424895599993],
              [34.87940514400009, -20.683770440999922],
              [34.86801191500007, -20.694431247999944],
              [34.87240644600007, -20.713067315999922],
              [34.87810306100005, -20.704522393999923],
              [34.88607832100007, -20.698825778999947],
              [34.89616946700005, -20.69508228999996],
              [34.90788821700005, -20.692559502999927],
              [34.95557701900009, -20.695977471999925],
              [34.96070397200009, -20.704278252999927],
              [34.99333743600005, -20.73015715899993],
              [34.99732506600009, -20.73992278399993],
              [34.998057488000086, -20.754082940999922],
              [34.99659264400009, -20.780694268999923],
              [35.00749759200005, -20.774590752999927],
              [35.01612389400009, -20.77516041499996],
              [35.02198326900009, -20.781914971999925],
              [35.02393639400009, -20.794366143999923],
              [35.02068118600005, -20.80136484199994],
              [35.006602410000085, -20.81487395599993],
              [35.00342858200008, -20.82545338299991],
              [35.00961347700007, -20.842868747999944],
              [35.04021243600005, -20.86972421699994],
              [35.05193118600005, -20.883884372999944],
              [35.04509524800005, -20.89576588299991],
              [35.039805535000085, -20.90911223799992],
              [35.037119988000086, -20.923272393999923],
              [35.03760826900009, -20.93840911299992],
              [35.06560306100005, -20.91692473799992],
              [35.07976321700005, -20.91375090899993],
              [35.099619988000086, -20.92473723799992],
              [35.106455925000034, -20.930433851999908],
              [35.108164910000085, -20.93287525799991],
              [35.10914147200009, -20.93645598799992],
              [35.113291863000086, -20.94589609199994],
              [35.11247806100005, -20.952650648999906],
              [35.11247806100005, -20.95281340899993],
              [35.10792076900009, -20.959242445999905],
              [35.107758009000065, -20.96412525799991],
              [35.120127800000034, -20.966403903999947],
              [35.113291863000086, -20.988457940999922],
              [35.10767662900008, -20.998711846999925],
              [35.099619988000086, -21.00790780999995],
              [35.08871504000007, -21.00123463299991],
              [35.07764733200008, -21.000176690999922],
              [35.069021030000044, -21.00554778399993],
              [35.065440300000034, -21.017836195999905],
              [35.06853274800005, -21.02507903399993],
              [35.07536868600005, -21.026788018999923],
              [35.08228600400008, -21.02662525799991],
              [35.085948113000086, -21.02776458099993],
              [35.086924675000034, -21.033868096999925],
              [35.08570397200009, -21.04192473799992],
              [35.08578535200007, -21.07000090899993],
              [35.078786655000044, -21.085056247999944],
              [35.06568444100009, -21.09384530999995],
              [35.04810631600009, -21.09661223799992],
              [35.041351759000065, -21.09270598799992],
              [35.033213738000086, -21.086195570999905],
              [35.02491295700008, -21.08489348799992],
              [35.01775149800005, -21.09661223799992],
              [35.01644941500007, -21.11109791499996],
              [35.02230879000007, -21.117933851999908],
              [35.03174889400009, -21.121758721999925],
              [35.04664147200009, -21.13128020599993],
              [35.050791863000086, -21.131931247999944],
              [35.05437259200005, -21.13290780999995],
              [35.05795332100007, -21.13762786299992],
              [35.058604363000086, -21.142836195999905],
              [35.056651238000086, -21.148695570999905],
              [35.05396569100009, -21.152601820999905],
              [35.05193118600005, -21.151950778999947],
              [35.05355879000007, -21.16334400799991],
              [35.05323326900009, -21.17229583099993],
              [35.055430535000085, -21.17937590899993],
              [35.065440300000034, -21.18613046699994],
              [35.05941816500007, -21.197930596999925],
              [35.06617272200009, -21.203301690999922],
              [35.07764733200008, -21.20680103999996],
              [35.085948113000086, -21.21331145599993],
              [35.088552280000044, -21.227308851999908],
              [35.08155358200008, -21.232598565999922],
              [35.06967207100007, -21.235039971999925],
              [35.05795332100007, -21.24065520599993],
              [35.047536655000044, -21.25286223799992],
              [35.051442905000044, -21.25676848799992],
              [35.06226647200009, -21.25945403399993],
              [35.072276238000086, -21.26799895599993],
              [35.074880405000044, -21.27939218499995],
              [35.072276238000086, -21.32195403399993],
              [35.09717858200008, -21.297133070999905],
              [35.126963738000086, -21.17864348799992],
              [35.12842858200008, -21.196058851999908],
              [35.12134850400008, -21.26067473799992],
              [35.11182701900009, -21.28964609199994],
              [35.120127800000034, -21.377211195999905],
              [35.15162194100009, -21.453871351999908],
              [35.21225019600007, -21.551446221999925],
              [35.22681725400008, -21.568617445999905],
              [35.24000084700009, -21.57586028399993],
              [35.27100670700008, -21.644138278999947],
              [35.273448113000086, -21.68678150799991],
              [35.268565300000034, -21.773614190999922],
              [35.27784264400009, -21.816664320999905],
              [35.30779056100005, -21.87818775799991],
              [35.31185957100007, -21.89462655999995],
              [35.31657962300005, -21.958103122999944],
              [35.326914910000085, -22.00554778399993],
              [35.33578535200007, -22.08912525799991],
              [35.30591881600009, -22.345961195999905],
              [35.305674675000034, -22.388604424999926],
              [35.311534050000034, -22.41301848799992],
              [35.32569420700008, -22.42473723799992],
              [35.34359785200007, -22.431247653999947],
              [35.360362175000034, -22.43987395599993],
              [35.379649285000085, -22.47275155999995],
              [35.39405358200008, -22.487725518999923],
              [35.40064537900008, -22.47714609199994],
              [35.39779707100007, -22.43336353999996],
              [35.40512129000007, -22.41855234199994],
              [35.42798912900008, -22.405694268999923],
              [35.404633009000065, -22.369398695999905],
              [35.39112389400009, -22.320570570999905],
              [35.39087975400008, -22.27157968499995],
              [35.40805097700007, -22.23447030999995],
              [35.40398196700005, -22.225355726999908],
              [35.40455162900008, -22.217950127999927],
              [35.40845787900008, -22.211602471999925],
              [35.41488691500007, -22.206475518999923],
              [35.42660566500007, -22.23601653399993],
              [35.435883009000065, -22.24277109199994],
              [35.44906660200007, -22.226820570999905],
              [35.42408287900008, -22.184747002999927],
              [35.41488691500007, -22.179131768999923],
              [35.419932488000086, -22.167168877999927],
              [35.44166100400008, -22.138278903999947],
              [35.44255618600005, -22.13250090899993],
              [35.441416863000086, -22.12558359199994],
              [35.441416863000086, -22.11956145599993],
              [35.44548587300005, -22.117120049999926],
              [35.44971764400009, -22.11581796699994],
              [35.45557701900009, -22.11296965899993],
              [35.46062259200005, -22.10979583099993],
              [35.46273847700007, -22.10751718499995],
              [35.467133009000065, -22.09579843499995],
              [35.47738691500007, -22.09148528399993],
              [35.488942905000044, -22.092543226999908],
              [35.496836785000085, -22.09661223799992],
              [35.50082441500007, -22.10605234199994],
              [35.50049889400009, -22.11777109199994],
              [35.496836785000085, -22.14153411299992],
              [35.51734459700009, -22.310153903999947],
              [35.52515709700009, -22.29306405999995],
              [35.52906334700009, -22.27581145599993],
              [35.53288821700005, -22.21998463299991],
              [35.541758660000085, -22.19589609199994],
              [35.54468834700009, -22.179131768999923],
              [35.551442905000044, -22.179131768999923],
              [35.537852410000085, -22.302666924999926],
              [35.537852410000085, -22.32284921699994],
              [35.54468834700009, -22.388604424999926],
              [35.54224694100009, -22.40992603999996],
              [35.49268639400009, -22.56487395599993],
              [35.48943118600005, -22.69003671699994],
              [35.52076256600009, -22.907647393999923],
              [35.537852410000085, -22.94695403399993],
              [35.547618035000085, -22.93450286299992],
              [35.55046634200005, -22.92864348799992],
              [35.551442905000044, -22.91961028399993],
              [35.56885826900009, -22.926853122999944],
              [35.58513431100005, -22.927178643999923],
              [35.59327233200008, -22.921807549999926],
              [35.58570397200009, -22.91220468499995],
              [35.58570397200009, -22.90593840899993],
              [35.606130405000044, -22.914727471999925],
              [35.60092207100007, -22.943617445999905],
              [35.56462649800005, -23.012465101999908],
              [35.54249108200008, -23.042168877999927],
              [35.50367272200009, -23.13128020599993],
              [35.48552493600005, -23.160902601999908],
              [35.478526238000086, -23.176853122999944],
              [35.47584069100009, -23.19703541499996],
              [35.47803795700008, -23.21803150799991],
              [35.48780358200008, -23.25481536299992],
              [35.48943118600005, -23.275323174999926],
              [35.48218834700009, -23.31731536299992],
              [35.42408287900008, -23.480645440999922],
              [35.40805097700007, -23.61101653399993],
              [35.40805097700007, -23.69703541499996],
              [35.40577233200008, -23.71721770599993],
              [35.39926191500007, -23.73919036299992],
              [35.39039147200009, -23.747979424999926],
              [35.38013756600009, -23.727715752999927],
              [35.38111412900008, -23.70867278399993],
              [35.385508660000085, -23.690850518999923],
              [35.381602410000085, -23.677666924999926],
              [35.35694420700008, -23.672539971999925],
              [35.34034264400009, -23.67620208099993],
              [35.34359785200007, -23.684258721999925],
              [35.354502800000034, -23.691582940999922],
              [35.360362175000034, -23.693617445999905],
              [35.36638431100005, -23.716729424999926],
              [35.367198113000086, -23.727715752999927],
              [35.36500084700009, -23.74667734199994],
              [35.35572350400008, -23.785902601999908],
              [35.353526238000086, -23.806573174999926],
              [35.35523522200009, -23.83953215899993],
              [35.353526238000086, -23.851820570999905],
              [35.35010826900009, -23.861993096999925],
              [35.342458530000044, -23.87590911299992],
              [35.339854363000086, -23.88600025799991],
              [35.340505405000044, -23.892022393999923],
              [35.34498131600009, -23.911309502999927],
              [35.346039259000065, -23.923272393999923],
              [35.34392337300005, -23.934665622999944],
              [35.334646030000044, -23.95370859199994],
              [35.332367384000065, -23.96453215899993],
              [35.34115644600007, -23.963636976999908],
              [35.387705925000034, -23.91269296699994],
              [35.37159264400009, -23.87818775799991],
              [35.36996504000007, -23.85979583099993],
              [35.38013756600009, -23.844414971999925],
              [35.39478600400008, -23.84189218499995],
              [35.409190300000034, -23.849867445999905],
              [35.43539472700007, -23.871758721999925],
              [35.45435631600009, -23.879978122999944],
              [35.46607506600009, -23.88014088299991],
              [35.47250410200007, -23.87118905999995],
              [35.47999108200008, -23.801039320999905],
              [35.47584069100009, -23.789808851999908],
              [35.47584069100009, -23.782403252999927],
              [35.51677493600005, -23.791761976999908],
              [35.527354363000086, -23.802992445999905],
              [35.531993035000085, -23.84734465899993],
              [35.53500410200007, -23.855075778999947],
              [35.54127037900008, -23.858086846999925],
              [35.54322350400008, -23.863213799999926],
              [35.48568769600007, -24.03639088299991],
              [35.48324629000007, -24.05673593499995],
              [35.485362175000034, -24.069756768999923],
              [35.494802280000044, -24.090101820999905],
              [35.496836785000085, -24.10133228999996],
              [35.49350019600007, -24.110528252999927],
              [35.486338738000086, -24.117364190999922],
              [35.47901451900009, -24.122979424999926],
              [35.47584069100009, -24.128106377999927],
              [35.47055097700007, -24.147881768999923],
              [35.45875084700009, -24.16659921699994],
              [35.30437259200005, -24.375746351999908],
              [35.19117272200009, -24.489027601999908],
              [35.18832441500007, -24.49895598799992],
              [35.18799889400009, -24.511976820999905],
              [35.18580162900008, -24.52190520599993],
              [35.180674675000034, -24.530694268999923],
              [35.106455925000034, -24.597914320999905],
              [34.81226647200009, -24.741387627999927],
              [34.64893639400009, -24.812758070999905],
              [34.48267662900008, -24.85125090899993],
              [34.48015384200005, -24.852227471999925],
              [34.34937584700009, -24.903090101999908],
              [34.323252800000034, -24.910088799999926],
              [34.21216881600009, -24.952732028999947],
              [34.15650475400008, -24.960870049999926],
              [33.93384850400008, -25.036228122999944],
              [33.729177280000044, -25.105075778999947],
              [33.58521569100009, -25.174574476999908],
              [33.46469160200007, -25.213148695999905],
              [33.31763756600009, -25.287041924999926],
              [33.27719160200007, -25.296807549999926],
              [33.27719160200007, -25.28997161299992],
              [33.29346764400009, -25.28329843499995],
              [33.31006920700008, -25.27312590899993],
              [33.32406660200007, -25.261163018999923],
              [33.33253014400009, -25.24846770599993],
              [33.31918379000007, -25.25237395599993],
              [33.27857506600009, -25.27076588299991],
              [33.26978600400008, -25.280043226999908],
              [33.25757897200009, -25.28834400799991],
              [33.23292076900009, -25.29078541499996],
              [33.21461022200009, -25.29729583099993],
              [33.221446160000085, -25.31804778399993],
              [33.227305535000085, -25.31454843499995],
              [33.24195397200009, -25.30982838299991],
              [33.227305535000085, -25.331963799999926],
              [33.20435631600009, -25.345310153999947],
              [33.153086785000085, -25.36581796699994],
              [33.13200931100005, -25.379164320999905],
              [32.87273196700005, -25.54387786299992],
              [32.844737175000034, -25.57268645599993],
              [32.79232832100007, -25.640069268999923],
              [32.769541863000086, -25.68173593499995],
              [32.75131269600007, -25.745863539999903],
              [32.737315300000034, -25.767347914999903],
              [32.74463951900009, -25.81698984199994],
              [32.73991946700005, -25.82586028399993],
              [32.74073326900009, -25.820082289999903],
              [32.73878014400009, -25.81308359199994],
              [32.734711134000065, -25.80396900799991],
              [32.728526238000086, -25.80396900799991],
              [32.72152754000007, -25.81218840899993],
              [32.71225019600007, -25.817803643999923],
              [32.70427493600005, -25.824151299999926],
              [32.70069420700008, -25.834649346999925],
              [32.69971764400009, -25.84889088299991],
              [32.69703209700009, -25.862399997999944],
              [32.69288170700008, -25.87468840899993],
              [32.68702233200008, -25.885918877999927],
              [32.63998457100007, -25.926934502999927],
              [32.63233483200008, -25.93808359199994],
              [32.626963738000086, -25.944024346999925],
              [32.600596550000034, -25.964043877999927],
              [32.59148196700005, -25.969008070999905],
              [32.57960045700008, -25.969821872999944],
              [32.571055535000085, -25.967054945999905],
              [32.55054772200009, -25.955336195999905],
              [32.53370201900009, -25.950372002999927],
              [32.516612175000034, -25.949965101999908],
              [32.50017337300005, -25.95476653399993],
              [32.48519941500007, -25.96542734199994],
              [32.47681725400008, -25.984551690999922],
              [32.480804884000065, -26.00318775799991],
              [32.49138431100005, -26.01409270599993],
              [32.501963738000086, -26.00945403399993],
              [32.500987175000034, -26.004571221999925],
              [32.501963738000086, -25.972100518999923],
              [32.508799675000034, -25.968519789999903],
              [32.52361087300005, -25.97079843499995],
              [32.53882897200009, -25.975274346999925],
              [32.54712975400008, -25.97893645599993],
              [32.55209394600007, -25.986586195999905],
              [32.55941816500007, -26.00318775799991],
              [32.56413821700005, -26.00945403399993],
              [32.57390384200005, -26.01490650799991],
              [32.59538821700005, -26.02239348799992],
              [32.60572350400008, -26.030450127999927],
              [32.61280358200008, -26.04143645599993],
              [32.621755405000044, -26.064222914999903],
              [32.628916863000086, -26.075290622999944],
              [32.63754316500007, -26.08261484199994],
              [32.645274285000085, -26.08757903399993],
              [32.650726759000065, -26.093357028999947],
              [32.656586134000065, -26.12395598799992],
              [32.67465254000007, -26.166680596999925],
              [32.68083743600005, -26.188164971999925],
              [32.69809004000007, -26.173435153999947],
              [32.72348066500007, -26.17831796699994],
              [32.748057488000086, -26.19150155999995],
              [32.76286868600005, -26.201836846999925],
              [32.78443444100009, -26.225681247999944],
              [32.79737389400009, -26.24846770599993],
              [32.81169681100005, -26.26848723799992],
              [32.831065300000034, -26.28378671699994],
              [32.842458530000044, -26.288669528999947],
              [32.85279381600009, -26.284600518999923],
              [32.86451256600009, -26.278741143999923],
              [32.87940514400009, -26.277520440999922],
              [32.870127800000034, -26.24578215899993],
              [32.86882571700005, -26.219414971999925],
              [32.87419681100005, -26.192803643999923],
              [32.88559004000007, -26.160821221999925],
              [32.89478600400008, -26.114678643999923],
              [32.903086785000085, -26.102634372999944],
              [32.91529381600009, -26.094414971999925],
              [32.95443769600007, -26.078871351999908],
              [32.955088738000086, -26.105645440999922],
              [32.92945397200009, -26.26604583099993],
              [32.91822350400008, -26.54420338299991],
              [32.904633009000065, -26.619886976999908],
              [32.895518425000034, -26.642510674999926],
              [32.89307701900009, -26.654229424999926],
              [32.89926191500007, -26.695245049999926],
              [32.89307701900009, -26.77434661299992],
              [32.89087975400008, -26.784356377999927],
              [32.87940514400009, -26.811944268999923],
              [32.881195509000065, -26.822035414999903],
              [32.88990319100009, -26.836602471999925],
              [32.89307701900009, -26.84612395599993],
              [32.73844567900011, -26.85024627699991],
              [32.59809248800008, -26.853966979999925],
              [32.46890140800008, -26.85737762499994],
              [32.352216024000086, -26.86027150399994],
              [32.29583703600008, -26.852003274999987],
              [32.2230249430001, -26.841357930999905],
              [32.19408614100013, -26.840324401999922],
              [32.14318485500007, -26.845698750999887],
              [32.11388431800009, -26.840014342999936],
            ],
            [
              [34.69414025900011, -12.00040334099991],
              [34.68091109200009, -12.009395039999944],
              [34.66241092900009, -12.052803242999943],
              [34.65589969900009, -12.07626434299992],
              [34.6562097580001, -12.097244974999924],
              [34.669025512000076, -12.117812194999914],
              [34.688972616000115, -12.12453013099993],
              [34.71160689300012, -12.12080942799993],
              [34.73248417200011, -12.109027200999918],
              [34.748193807000064, -12.090423684999877],
              [34.759252563000075, -12.065618997999934],
              [34.76235315000014, -12.040297545999948],
              [34.754188273000125, -12.020143737999973],
              [34.73827193200009, -12.00949839199997],
              [34.71563765500014, -12.001643574999946],
              [34.69414025900011, -12.00040334099991],
            ],
            [
              [34.561641886000075, -11.978595885999894],
              [34.541798136000125, -11.99461557999993],
              [34.54407190000012, -12.011358743999978],
              [34.570736939000085, -12.041021015999945],
              [34.58355269400005, -12.058901061999904],
              [34.59605839000005, -12.071923522999938],
              [34.611147908000135, -12.072543639999907],
              [34.63171512800005, -12.052493183999957],
              [34.64122359200013, -12.01786997399995],
              [34.62747766100006, -11.987277526999947],
              [34.5984355060001, -11.970534362999985],
              [34.56257206200013, -11.977975768999912],
              [34.561641886000075, -11.978595885999894],
            ],
          ],
          [
            [
              [32.90674889400009, -26.057793877999927],
              [32.89535566500007, -26.028415622999944],
              [32.918304884000065, -26.001397393999923],
              [32.95435631600009, -25.98056405999995],
              [32.98259524800005, -25.969008070999905],
              [32.98194420700008, -25.98015715899993],
              [32.97510826900009, -26.00945403399993],
              [32.96452884200005, -26.03801848799992],
              [32.961273634000065, -26.044122002999927],
              [32.951914910000085, -26.052992445999905],
              [32.94939212300005, -26.05396900799991],
              [32.94613691500007, -26.049899997999944],
              [32.93474368600005, -26.044122002999927],
              [32.93083743600005, -26.03948333099993],
              [32.930349155000044, -26.032647393999923],
              [32.926768425000034, -26.02825286299992],
              [32.91358483200008, -26.030450127999927],
              [32.91382897200009, -26.034600518999923],
              [32.90674889400009, -26.057793877999927],
            ],
          ],
          [
            [
              [35.46957441500007, -21.549086195999905],
              [35.48096764400009, -21.529554945999905],
              [35.49000084700009, -21.53020598799992],
              [35.49545332100007, -21.54550546699994],
              [35.496836785000085, -21.56959400799991],
              [35.49073326900009, -21.64185963299991],
              [35.45533287900008, -21.78134530999995],
              [35.43490644600007, -21.78289153399993],
              [35.42709394600007, -21.76881275799991],
              [35.42660566500007, -21.74895598799992],
              [35.437510613000086, -21.672946872999944],
              [35.46957441500007, -21.549086195999905],
            ],
          ],
          [
            [
              [39.909537140000054, -16.27582713599992],
              [39.94357681400004, -16.279272034999906],
              [39.94637217800005, -16.302192318999914],
              [39.941800637000085, -16.322479135999913],
              [39.91514753600006, -16.348977068999943],
              [39.906923488000075, -16.37807393099996],
              [39.908796099000085, -16.395697743999904],
              [39.90330170100009, -16.409805570999936],
              [39.87847556400004, -16.416889710999953],
              [39.85639148800004, -16.40986933599993],
              [39.832454849000044, -16.390516821999938],
              [39.81770167700006, -16.356180194999922],
              [39.82133724700009, -16.317412411999953],
              [39.83234701200007, -16.29977269299991],
              [39.86082381400007, -16.286503206999953],
              [39.909537140000054, -16.27582713599992],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'eSwatini',
        iso3: 'SWZ',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [31.949243204000084, -25.958104349999914],
            [31.975288127000056, -25.980428568999884],
            [32.004020223000055, -25.99438120499987],
            [32.07057946800006, -26.00978078199995],
            [32.057453654000085, -26.041200052999983],
            [32.06272465000012, -26.07716684999987],
            [32.074558553000145, -26.11416717599991],
            [32.08143151900009, -26.148790384999927],
            [32.07781416800009, -26.175455423999964],
            [32.04474125200005, -26.254520364999863],
            [32.03988366700008, -26.283665872999876],
            [32.05233768700009, -26.386812031999895],
            [32.05983077000013, -26.41482065799991],
            [32.107063029000074, -26.500293477999932],
            [32.11739831600005, -26.582252298999904],
            [32.11388431800009, -26.840014342999936],
            [32.09776127200013, -26.833503112999963],
            [32.073163289000036, -26.81138559999995],
            [32.05714359600012, -26.808595071999903],
            [31.990067586000066, -26.808285013999907],
            [31.992237996000085, -26.838257344999946],
            [31.975288127000056, -26.92662404299996],
            [31.959681844000045, -27.008789570999895],
            [31.942111857000043, -27.100670267999945],
            [31.9442043090001, -27.162338388999984],
            [31.944850708000104, -27.181388854999895],
            [31.94738285300008, -27.255492858999915],
            [31.952963907000083, -27.27016896499991],
            [31.959785197000144, -27.281021015999954],
            [31.964849487000038, -27.29166636099994],
            [31.96774336800013, -27.303035175999938],
            [31.96826013200007, -27.31626434299993],
            [31.87860152200011, -27.31523081499995],
            [31.78253503400009, -27.313990580999914],
            [31.636910848000127, -27.31223358099993],
            [31.52652998900004, -27.31088999399988],
            [31.459453979000102, -27.298694355999956],
            [31.356669555000053, -27.267068379999955],
            [31.280136759000072, -27.243503925999875],
            [31.24470661200013, -27.23258632399991],
            [31.15704349700013, -27.205573425999958],
            [31.14195398000004, -27.19647837299989],
            [31.12650272700006, -27.18262908999992],
            [31.078753703000075, -27.11824025399993],
            [30.97607263200007, -27.035041197999917],
            [30.9536450600001, -27.000314635999885],
            [30.949407593000046, -26.975406595999914],
            [30.959742879000146, -26.93613250699994],
            [30.960983114000044, -26.91122446699997],
            [30.955092, -26.891380716999976],
            [30.944446655000093, -26.87660125699996],
            [30.91581791100009, -26.849419453999886],
            [30.902588745000116, -26.83133270199997],
            [30.885294444000124, -26.785640599999923],
            [30.880212850000134, -26.772214863999906],
            [30.868740682000123, -26.784927266999958],
            [30.853392782000128, -26.796606139999938],
            [30.836442912000052, -26.805081074999933],
            [30.819803101000105, -26.80797495499992],
            [30.802439819000085, -26.80890513099989],
            [30.795670207000057, -26.785547382999937],
            [30.785696655000038, -26.71692108099998],
            [30.784146362000115, -26.578841654999877],
            [30.782906128000093, -26.47238820399994],
            [30.80455855300005, -26.397457376999895],
            [30.89731774900008, -26.29172739699996],
            [30.969871460000093, -26.209148457999916],
            [31.03777429200005, -26.100111185999893],
            [31.091621134000093, -25.98363250699994],
            [31.106865682000034, -25.930922546999923],
            [31.11983646700014, -25.910045266999944],
            [31.20840987100007, -25.838628437999944],
            [31.309282268000118, -25.757393086999883],
            [31.337394246000144, -25.744680683999917],
            [31.372017456000037, -25.736412454999964],
            [31.40147302200006, -25.735999043999954],
            [31.42689782700006, -25.743647154999934],
            [31.53283451300007, -25.805555521999864],
            [31.63877120000012, -25.86746388799989],
            [31.7306002200001, -25.92120737799989],
            [31.746966320000126, -25.930789517999926],
            [31.834573202000115, -25.98208221399993],
            [31.863356974000055, -25.989937031999958],
            [31.891882365000072, -25.98383921299991],
            [31.949243204000084, -25.958104349999914],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Burundi',
        iso3: 'BDI',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.554599650000057, -2.400627542999885],
            [30.521475057000146, -2.442278747999907],
            [30.508090861000085, -2.463466083999961],
            [30.47016036000008, -2.555760192999941],
            [30.461995483000067, -2.587489521999956],
            [30.457654663000085, -2.598031514999917],
            [30.448042846000078, -2.610537210999922],
            [30.424168335000104, -2.633171487999959],
            [30.41600345900008, -2.64557383199994],
            [30.41212772600005, -2.670171813999929],
            [30.42323815900005, -2.680920511999943],
            [30.442668498000046, -2.681127217999901],
            [30.463752482000075, -2.674202575999914],
            [30.499615926000104, -2.657872822999892],
            [30.52256026200007, -2.649397887999967],
            [30.516100708000067, -2.66831146199992],
            [30.458584839000082, -2.728669534999923],
            [30.450523315000055, -2.741795348999887],
            [30.44726770000011, -2.757298278999897],
            [30.4469059650001, -2.782723082999908],
            [30.425098510000055, -2.812178648999904],
            [30.413626343000146, -2.834399515999849],
            [30.415796753000052, -2.851659443999935],
            [30.44080814600005, -2.884008890999922],
            [30.456001017000062, -2.898271585999908],
            [30.474191121000104, -2.903232523999947],
            [30.469643595000093, -2.914187926999929],
            [30.47543135600006, -2.922146097999885],
            [30.48411299600008, -2.930724385999923],
            [30.488325079000106, -2.94316005799989],
            [30.488453817000106, -2.943540139999897],
            [30.493259725000087, -2.941266376999891],
            [30.51305179800005, -2.913981221999961],
            [30.524937378000118, -2.904162699999901],
            [30.538890015000106, -2.898995055999904],
            [30.547003215000075, -2.900338642999955],
            [30.611960490000058, -2.939199320999919],
            [30.625189656000146, -2.944780374999937],
            [30.629530477000117, -2.947674254999924],
            [30.63211429800009, -2.953772073999886],
            [30.634904825000092, -2.970101826999922],
            [30.637592001000087, -2.974442646999904],
            [30.650924520000046, -2.977336526999892],
            [30.661363159000075, -2.974752705999975],
            [30.671336711000095, -2.970825296999919],
            [30.683687378000116, -2.969998473999894],
            [30.69598636900008, -2.974546],
            [30.718879029000107, -2.989532164999986],
            [30.732056519000082, -2.993459573999957],
            [30.755414266000116, -2.991392516999909],
            [30.802129761000117, -2.97837005599996],
            [30.825487508000037, -2.978576760999914],
            [30.81881462400014, -2.990495174999907],
            [30.815824015000146, -2.995836689999905],
            [30.78486983300013, -3.031493427999905],
            [30.77825524900004, -3.047409768999927],
            [30.78321618600006, -3.062085876999916],
            [30.80781416800005, -3.085236917999907],
            [30.817684366000037, -3.099086201999867],
            [30.817839396000068, -3.104357197999903],
            [30.813085164000086, -3.117689717999923],
            [30.812258341000074, -3.123477477999899],
            [30.815824015000146, -3.131022236999939],
            [30.82879480000014, -3.140530700999918],
            [30.832928915000082, -3.147662048999962],
            [30.833962443000075, -3.160271097999981],
            [30.832205444000067, -3.172776793999972],
            [30.823523804000047, -3.196651305999879],
            [30.809364461000087, -3.216805114999943],
            [30.809881225000083, -3.224143167999941],
            [30.81432539900004, -3.241919860999872],
            [30.814842163000037, -3.247707621999936],
            [30.79975264500007, -3.274579365999941],
            [30.775671427000134, -3.291012470999917],
            [30.747921184000063, -3.294113056999947],
            [30.72146285000008, -3.280987242999885],
            [30.71841394100005, -3.292872822999911],
            [30.712006063000047, -3.30186452199996],
            [30.702239217000056, -3.307342223999854],
            [30.689940227000136, -3.308892516999961],
            [30.662603393000097, -3.31922780399988],
            [30.640537557000073, -3.332870380999893],
            [30.62167565900006, -3.350440368999955],
            [30.603278849000105, -3.372557880999878],
            [30.610250154000084, -3.376358647999936],
            [30.640434204000087, -3.392815042999871],
            [30.639142293000134, -3.419480081999922],
            [30.612890666000112, -3.444904886999922],
            [30.56596846500014, -3.466712340999948],
            [30.55294600400009, -3.482215270999873],
            [30.54498783400004, -3.489139912999946],
            [30.538114869000083, -3.491620381999923],
            [30.511501505000126, -3.497718200999969],
            [30.509951213000136, -3.500198668999943],
            [30.50824589000007, -3.50888030999991],
            [30.507160685000144, -3.511050719999986],
            [30.488040406000096, -3.512601012999923],
            [30.487523641000053, -3.510740661999918],
            [30.48555993700012, -3.510533955999946],
            [30.468920126000057, -3.513014424999923],
            [30.466336304000095, -3.516115009999879],
            [30.46261560000005, -3.527897236999877],
            [30.460135131000072, -3.531927997999958],
            [30.43228153500013, -3.551875101999897],
            [30.426855510000053, -3.563864033999948],
            [30.42923262500011, -3.583914488999895],
            [30.4288708900001, -3.602207946999954],
            [30.421377807000056, -3.620811461999921],
            [30.380140015000052, -3.685613708999924],
            [30.373112020000065, -3.703597106999908],
            [30.373068378000085, -3.704339017999928],
            [30.37197513800004, -3.722924092999961],
            [30.37621260600008, -3.739770609999937],
            [30.381897014000117, -3.75517018599993],
            [30.384997599000087, -3.770776467999966],
            [30.381586954000056, -3.788346455999942],
            [30.336990194000123, -3.773773701999886],
            [30.31172041800005, -3.789896748999865],
            [30.273273152000115, -3.856249287999987],
            [30.22076989800007, -3.909992777999889],
            [30.208780965000074, -3.93045664499995],
            [30.1914176840001, -4.002493591999922],
            [30.175852307000127, -4.039991996999973],
            [30.173227579000127, -4.046315205999932],
            [30.14976647900005, -4.086829527999939],
            [30.119587443000057, -4.123519795999911],
            [30.05147790600006, -4.180157165999987],
            [30.04114261900014, -4.19503997799994],
            [30.015614461000098, -4.256018167999912],
            [30.00300541100006, -4.271934508999934],
            [29.980784546000052, -4.284440204999925],
            [29.970655965000105, -4.292605081999852],
            [29.936342814000056, -4.31203541999993],
            [29.90047937000014, -4.345625101999957],
            [29.84735599700008, -4.370533141999928],
            [29.838571004000073, -4.37353037499993],
            [29.82182784000014, -4.370739847999886],
            [29.81097578900011, -4.365262145999893],
            [29.80033044400011, -4.363918557999924],
            [29.784104045000106, -4.373840432999927],
            [29.7822953700001, -4.377354430999972],
            [29.780176636000135, -4.393684183999909],
            [29.77500899200004, -4.402262470999943],
            [29.75795577000008, -4.410220641999913],
            [29.751651245000062, -4.416111755999907],
            [29.747930542000063, -4.430271096999945],
            [29.747413777000133, -4.443190205999954],
            [29.744364868000105, -4.454455667999923],
            [29.73284102300005, -4.463344014999933],
            [29.72829349800014, -4.461587014999864],
            [29.687469117000035, -4.458383076999894],
            [29.638273153000057, -4.446807555999939],
            [29.404178915000102, -4.449804788999955],
            [29.37275964400004, -4.208165791999903],
            [29.36722380600014, -4.189048239999877],
            [29.3394800210001, -4.093237405999972],
            [29.27772668400013, -3.988954365999945],
            [29.239796183000124, -3.948026630999919],
            [29.224551636000058, -3.926529235999894],
            [29.215043172000094, -3.899864195999939],
            [29.206568237000056, -3.781938578999899],
            [29.217122763000134, -3.709265928999912],
            [29.223259725000105, -3.667010191999879],
            [29.22517175300004, -3.588565367999948],
            [29.2066715900001, -3.334524027999933],
            [29.208738648000065, -3.305275165999888],
            [29.213079468000046, -3.291942646999956],
            [29.23611684100007, -3.270703730999898],
            [29.240881388000105, -3.266311136999903],
            [29.22382816600009, -3.2526685589999],
            [29.2169035230001, -3.23313486699989],
            [29.21411299600004, -3.166472268999968],
            [29.21752364100007, -3.146215107999879],
            [29.225016724000113, -3.129368590999889],
            [29.237780803000078, -3.122237243999948],
            [29.2423283280001, -3.110765075999936],
            [29.241539256000067, -3.104187711999913],
            [29.23462854000013, -3.046582946999905],
            [29.22537845800008, -3.031803486999891],
            [29.211529175000123, -3.021158141999891],
            [29.19447595200009, -3.014646910999915],
            [29.175975789000063, -3.012476500999924],
            [29.156752157000142, -3.004828388999954],
            [29.1481738680001, -2.986948342999895],
            [29.144246460000147, -2.966277770999881],
            [29.13840702300007, -2.950361429999944],
            [29.123369181000072, -2.940232848999898],
            [29.10507572500009, -2.934135029999936],
            [29.089779500000134, -2.926073506999955],
            [29.083268270000076, -2.910053812999905],
            [29.081717977000068, -2.893930764999922],
            [29.07758386200004, -2.884008890999922],
            [29.0627010500001, -2.862201435999907],
            [29.053502645000094, -2.835433044999931],
            [29.04905847100008, -2.827474873999961],
            [29.034072306000013, -2.820860290999875],
            [29.013143351000025, -2.818896585999937],
            [28.99490157000008, -2.813625589999901],
            [28.9868917230001, -2.796779072999925],
            [28.988803751000034, -2.775488382999939],
            [28.995521688000053, -2.758435159999905],
            [29.008234090000087, -2.747479756999923],
            [29.02859460400012, -2.744895934999931],
            [29.015365438000117, -2.720711364999957],
            [29.032573690000106, -2.620665791999969],
            [29.055259643000085, -2.598444925999928],
            [29.113447307000087, -2.5946208699999],
            [29.129725383000107, -2.596997985999849],
            [29.190445190000105, -2.623456318999928],
            [29.21276940900009, -2.630277608999975],
            [29.254989054000134, -2.635548603999922],
            [29.276124716000083, -2.640612893999986],
            [29.294418172000064, -2.651051533999933],
            [29.306613810000044, -2.660146585999897],
            [29.30733728000007, -2.664797464999964],
            [29.306045370000106, -2.676579690999873],
            [29.30948054400011, -2.690126857999886],
            [29.309714396000118, -2.691049092999904],
            [29.33141849700013, -2.711409606999922],
            [29.337516316000062, -2.723811949999899],
            [29.33534590700009, -2.735180765999885],
            [29.321496623000087, -2.75213063599989],
            [29.318085978000056, -2.762569274999933],
            [29.320359741000118, -2.774144795999874],
            [29.329661499000053, -2.794918720999917],
            [29.330850057000134, -2.807424417999911],
            [29.33968672700007, -2.826441344999893],
            [29.36428470900006, -2.824167581999873],
            [29.407434530000046, -2.805460713999892],
            [29.425366251000128, -2.803393655999926],
            [29.444674800000087, -2.806989288999972],
            [29.480866740000124, -2.81372894299993],
            [29.504121135000048, -2.826854756999893],
            [29.52313806100011, -2.82044687899986],
            [29.54184493000008, -2.808561298999919],
            [29.563755737000122, -2.805667418999931],
            [29.57409102400004, -2.806080829999942],
            [29.582049194000092, -2.802980244999915],
            [29.589490600000147, -2.798432718999962],
            [29.61925622500013, -2.787684020999947],
            [29.626387573000045, -2.788097431999873],
            [29.637086889000045, -2.791628628999916],
            [29.67868412200005, -2.805357360999949],
            [29.697546021000107, -2.808251240999937],
            [29.719921916000146, -2.805460713999892],
            [29.729637085000093, -2.799569599999884],
            [29.733977905000074, -2.790267841999949],
            [29.737285197000062, -2.769287210999948],
            [29.744726603000117, -2.759985452999928],
            [29.75619877100013, -2.759882099999899],
            [29.778522990000113, -2.766600036999918],
            [29.80337935400013, -2.767323505999926],
            [29.823584839000034, -2.763499450999888],
            [29.842395060000058, -2.752440693999887],
            [29.862858927000104, -2.731666768999929],
            [29.87619144700011, -2.713580016999913],
            [29.888387085000147, -2.692909443999909],
            [29.897895548000122, -2.671101988999879],
            [29.903269898000076, -2.649087828999896],
            [29.903725678000058, -2.637946527999901],
            [29.90792077600014, -2.535399678999909],
            [29.929573202000142, -2.459848733999877],
            [29.922390177000068, -2.382954202999883],
            [29.92890140800006, -2.331794534999887],
            [29.92879805500013, -2.322492776999951],
            [29.931691935000117, -2.316911722999933],
            [29.941923869000107, -2.316601663999947],
            [29.949933716000146, -2.3211491899999],
            [29.956781101000047, -2.327037670999943],
            [29.95851971500008, -2.328532809999928],
            [29.976133667000056, -2.343680114999913],
            [29.98388513100008, -2.344816995999921],
            [29.992308390000062, -2.343990172999895],
            [30.00192020700007, -2.344300230999892],
            [30.013340698000093, -2.34833099399988],
            [30.025536336000073, -2.35773610499993],
            [30.056542196000123, -2.394426370999909],
            [30.0729753010001, -2.408792418999909],
            [30.093852580000146, -2.422641702999968],
            [30.116796916000112, -2.431530049999893],
            [30.13912113400005, -2.430806578999892],
            [30.15617435700011, -2.419024352999884],
            [30.201339559000075, -2.362386982999894],
            [30.20340661700004, -2.355358988999896],
            [30.203923381000095, -2.345953877999932],
            [30.207489054000064, -2.339235940999913],
            [30.219116252000106, -2.34037282299991],
            [30.250328816000092, -2.355565693999935],
            [30.262731161000147, -2.358356220999909],
            [30.27885420700005, -2.357632750999912],
            [30.297974487000147, -2.353705341999941],
            [30.316784709000046, -2.34760752299988],
            [30.331150756000056, -2.340269469999981],
            [30.344018189000053, -2.328383890999959],
            [30.348610082000107, -2.322351935999933],
            [30.35275150500013, -2.316911722999933],
            [30.362518351000062, -2.307816670999969],
            [30.37858972200013, -2.303062438999888],
            [30.38344730600005, -2.305542906999946],
            [30.41507328300014, -2.313087665999902],
            [30.418483927000068, -2.311847431999865],
            [30.42323815900005, -2.317325133999944],
            [30.428405802000043, -2.331381123999961],
            [30.434141886000134, -2.339235940999913],
            [30.488453817000106, -2.383781025999909],
            [30.521733440000048, -2.399387308999863],
            [30.554599650000057, -2.400627542999885],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Rwanda',
        iso3: 'RWA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [29.015365438000117, -2.720711364999957],
            [29.00012089000009, -2.703658141999924],
            [28.979605347000103, -2.693529560999963],
            [28.949736369000107, -2.690325621999904],
            [28.936403849000072, -2.685054625999967],
            [28.899093465000135, -2.66066335099994],
            [28.891342000000122, -2.65270517999997],
            [28.89805993700014, -2.57632741299993],
            [28.891342000000122, -2.553073017999907],
            [28.881058390000135, -2.542634378999963],
            [28.869844605000083, -2.537260029999914],
            [28.860956258000073, -2.531162210999952],
            [28.857235555000074, -2.518346455999961],
            [28.86085290500006, -2.505220641999912],
            [28.878216187000078, -2.489717711999987],
            [28.874702189000118, -2.477522073999879],
            [28.864573608000057, -2.459435322999866],
            [28.86085290500006, -2.439591572999873],
            [28.85883752400011, -2.418197529999958],
            [28.866330607000123, -2.391945901999932],
            [28.88038659600005, -2.379853616999938],
            [28.907258342000063, -2.370551858999917],
            [28.928135620000035, -2.364454039999956],
            [28.945447225000123, -2.35422210699997],
            [28.95965824400008, -2.339752705999942],
            [28.971233765000136, -2.321665954999929],
            [28.97877852400009, -2.306783141999887],
            [28.982189168000104, -2.296034443999872],
            [28.98337772600013, -2.287352802999905],
            [28.99366133600003, -2.277740986999987],
            [29.00213627100004, -2.274743753999886],
            [29.03092004400014, -2.275673928999936],
            [29.075413452000134, -2.263891702999928],
            [29.109829956000084, -2.236709899999951],
            [29.134841349000084, -2.197745869999963],
            [29.150550984000063, -2.150410257999908],
            [29.15633874500014, -2.108655700999861],
            [29.15427168700006, -2.072688903999975],
            [29.12771000100014, -1.915695901999925],
            [29.12553959200008, -1.879108988999889],
            [29.130500529000102, -1.84334889699997],
            [29.14931075000004, -1.799320575999914],
            [29.18664003500004, -1.739618238999896],
            [29.212252645000035, -1.698654886999861],
            [29.233336629000064, -1.65865732799989],
            [29.24542891400006, -1.640983987999974],
            [29.29369470200004, -1.600986429999921],
            [29.30382328200011, -1.587860615999944],
            [29.331211792000147, -1.531429951999925],
            [29.342787313000088, -1.516547138999968],
            [29.358496948000038, -1.509932555999882],
            [29.434926392000136, -1.506831969999936],
            [29.437406861000113, -1.506211852999868],
            [29.43962894700013, -1.504764912999875],
            [29.44169600400005, -1.502594501999894],
            [29.445065226000054, -1.497286823999929],
            [29.464330282000105, -1.466937764999898],
            [29.498746785000094, -1.431074319999951],
            [29.53864099100008, -1.402342223999938],
            [29.577915080000082, -1.388389587999953],
            [29.618119344000092, -1.39055999699994],
            [29.639099976000125, -1.389009703999918],
            [29.657703491000063, -1.383945413999939],
            [29.678322388000083, -1.372369892999899],
            [29.693773641000064, -1.361207783999873],
            [29.71051680500011, -1.352526142999906],
            [29.734804728000086, -1.348185322999925],
            [29.74669030800004, -1.350872496999955],
            [29.76798099700011, -1.36379160499996],
            [29.77490563900011, -1.366272073999937],
            [29.783173869000052, -1.361414488999927],
            [29.789168335000056, -1.341674092999952],
            [29.798211711000135, -1.330925394999937],
            [29.80746179200014, -1.325137633999873],
            [29.816143432000104, -1.322553812999956],
            [29.825024114000087, -1.323880810999896],
            [29.82513513200007, -1.323897399999936],
            [29.836090536000142, -1.329478454999943],
            [29.864202514000056, -1.370302835999937],
            [29.86864668800007, -1.391283466999937],
            [29.871023804000117, -1.432417906999916],
            [29.880738973000064, -1.453605244999963],
            [29.897895548000122, -1.469624938999928],
            [29.917429240000047, -1.47520599399985],
            [29.938461548000134, -1.47293223099993],
            [29.960424032000105, -1.464767353999903],
            [30.028326863000075, -1.427146911999984],
            [30.03866215000005, -1.424976500999904],
            [30.047757202000128, -1.403169046999963],
            [30.060779663000062, -1.389733174999918],
            [30.06598434300014, -1.386944953999972],
            [30.09550622600011, -1.371129658999962],
            [30.136330607000104, -1.35521331799994],
            [30.147182658000077, -1.345084736999894],
            [30.15235030100007, -1.329891865999869],
            [30.158448120000116, -1.291134541999924],
            [30.165579468000146, -1.277491963999921],
            [30.173434286000088, -1.272841084999953],
            [30.18139245600014, -1.271497497999903],
            [30.189350627000124, -1.270877379999931],
            [30.196740356000134, -1.26870696999994],
            [30.212191610000104, -1.259508564999933],
            [30.2566850180001, -1.217237243999946],
            [30.269759156000077, -1.200494079999899],
            [30.280507853000074, -1.182407327999982],
            [30.282419882000113, -1.175792744999896],
            [30.284641968000074, -1.161426695999893],
            [30.28753584800006, -1.15543222999986],
            [30.290949658000102, -1.15262085699996],
            [30.294563843000105, -1.149644469999885],
            [30.31130700700004, -1.142099710999929],
            [30.317404826000086, -1.137035419999961],
            [30.32257246900008, -1.121842549999926],
            [30.32903202300008, -1.0805014029999],
            [30.337455282000064, -1.066238707999929],
            [30.35275150500013, -1.06076100699994],
            [30.36928796400008, -1.063241474999913],
            [30.38634118600004, -1.068202412999952],
            [30.40318770300013, -1.070372822999943],
            [30.41889733900007, -1.066445413999887],
            [30.432023153000046, -1.060554300999883],
            [30.445614054000146, -1.058693948999874],
            [30.46082862300011, -1.063427549999943],
            [30.471785843000134, -1.066836591999916],
            [30.463855835000118, -1.075127054999939],
            [30.456156047000093, -1.086082457999922],
            [30.453003785000135, -1.097347919999976],
            [30.456311076000134, -1.108096617999905],
            [30.470883829000115, -1.118121845999923],
            [30.474191121000104, -1.131764424999929],
            [30.47207238800013, -1.137655537999933],
            [30.468300008000085, -1.14333994499988],
            [30.46561283400007, -1.149334410999899],
            [30.467266479000045, -1.155328876999931],
            [30.476051473000098, -1.161219990999925],
            [30.484009643000093, -1.159979755999899],
            [30.49052087400014, -1.156465758999943],
            [30.494654989000082, -1.155328876999931],
            [30.506953979000116, -1.164217223999941],
            [30.511191447000044, -1.170418395999931],
            [30.51511885600013, -1.196256611999942],
            [30.521216675000062, -1.210829365999913],
            [30.539406779000046, -1.241008401999906],
            [30.54529789200012, -1.261368915999938],
            [30.554599650000057, -1.273461201999922],
            [30.556615031000092, -1.281626077999945],
            [30.55563317900004, -1.284726663999891],
            [30.553359416000035, -1.289067483999872],
            [30.550982300000044, -1.294958597999965],
            [30.54994877100006, -1.302400003999892],
            [30.55532312000014, -1.318419697999943],
            [30.568242228000145, -1.328134867999978],
            [30.597697795000045, -1.340330504999898],
            [30.608239787000116, -1.347771911999914],
            [30.623225952000098, -1.362034606999899],
            [30.632424357000104, -1.367615660999917],
            [30.698466837000126, -1.392110290999966],
            [30.718103881000104, -1.394900817999925],
            [30.737534220000043, -1.406683043999919],
            [30.74321862800008, -1.432831318999931],
            [30.741358277000074, -1.458876240999913],
            [30.73825769000007, -1.470658467999911],
            [30.732935018000035, -1.476446227999887],
            [30.73887780800004, -1.489468687999917],
            [30.755414266000116, -1.511586201999933],
            [30.767816610000068, -1.524815368999924],
            [30.772260783000092, -1.532463479999905],
            [30.78197595200004, -1.568430276999962],
            [30.791587768000056, -1.590961201999988],
            [30.80724572800011, -1.60326019299994],
            [30.831016887000146, -1.594165139999873],
            [30.838303263000057, -1.61535247799992],
            [30.837476440000103, -1.641087340999917],
            [30.824557333000087, -1.719945576999933],
            [30.82424727300014, -1.730694273999873],
            [30.826521037000134, -1.735861917999955],
            [30.83540938300007, -1.749504495999872],
            [30.837889852000046, -1.758702900999964],
            [30.826417684000035, -1.786194762999941],
            [30.829931681000062, -1.796736754999912],
            [30.837889852000046, -1.836837666999898],
            [30.83241215000004, -1.853787536999903],
            [30.822231893000094, -1.86877370199997],
            [30.816599162000045, -1.884173278999867],
            [30.82424727300014, -1.902053324999926],
            [30.80802087400008, -1.914765725999885],
            [30.801923055000145, -1.921276956999947],
            [30.796962118000124, -1.929338479999927],
            [30.826934449000134, -1.934092711999924],
            [30.829931681000062, -1.960551044999917],
            [30.816754191000086, -2.01873870799993],
            [30.835461059000068, -2.014707946999934],
            [30.853496135000057, -2.02369964499988],
            [30.868740682000123, -2.038995869999923],
            [30.87943770300012, -2.053465270999951],
            [30.88780928500006, -2.08250742599995],
            [30.853392782000128, -2.193818460999893],
            [30.84471114100006, -2.23784678099986],
            [30.848948608000114, -2.306266377999947],
            [30.84471114100006, -2.326626891999879],
            [30.834375855000076, -2.34533375999996],
            [30.82135339400014, -2.354738870999924],
            [30.80455855300005, -2.362180276999936],
            [30.78910730000007, -2.371068623999861],
            [30.77515466300008, -2.374479267999973],
            [30.76791996300011, -2.378613382999902],
            [30.758824910000044, -2.381093851999879],
            [30.750660034000134, -2.379130146999941],
            [30.698466837000126, -2.353395283999944],
            [30.68771813900014, -2.349984638999928],
            [30.674799031000134, -2.351741637999908],
            [30.663326864000112, -2.360733336999942],
            [30.64906416800011, -2.387605081999951],
            [30.637850382000067, -2.3970101929999],
            [30.61692142700008, -2.398147073999908],
            [30.59521732500008, -2.391945901999932],
            [30.573926636000124, -2.389258727999987],
            [30.554599650000057, -2.400627542999885],
            [30.521733440000048, -2.399387308999863],
            [30.488453817000106, -2.383781025999909],
            [30.434141886000134, -2.339235940999913],
            [30.428405802000043, -2.331381123999961],
            [30.42323815900005, -2.317325133999944],
            [30.418483927000068, -2.311847431999865],
            [30.41507328300014, -2.313087665999902],
            [30.38344730600005, -2.305542906999946],
            [30.37858972200013, -2.303062438999888],
            [30.362518351000062, -2.307816670999969],
            [30.35275150500013, -2.316911722999933],
            [30.348610082000107, -2.322351935999933],
            [30.344018189000053, -2.328383890999959],
            [30.331150756000056, -2.340269469999981],
            [30.316784709000046, -2.34760752299988],
            [30.297974487000147, -2.353705341999941],
            [30.27885420700005, -2.357632750999912],
            [30.262731161000147, -2.358356220999909],
            [30.250328816000092, -2.355565693999935],
            [30.219116252000106, -2.34037282299991],
            [30.207489054000064, -2.339235940999913],
            [30.203923381000095, -2.345953877999932],
            [30.20340661700004, -2.355358988999896],
            [30.201339559000075, -2.362386982999894],
            [30.15617435700011, -2.419024352999884],
            [30.13912113400005, -2.430806578999892],
            [30.116796916000112, -2.431530049999893],
            [30.093852580000146, -2.422641702999968],
            [30.0729753010001, -2.408792418999909],
            [30.056542196000123, -2.394426370999909],
            [30.025536336000073, -2.35773610499993],
            [30.013340698000093, -2.34833099399988],
            [30.00192020700007, -2.344300230999892],
            [29.992308390000062, -2.343990172999895],
            [29.98388513100008, -2.344816995999921],
            [29.976133667000056, -2.343680114999913],
            [29.95851971500008, -2.328532809999928],
            [29.956781101000047, -2.327037670999943],
            [29.949933716000146, -2.3211491899999],
            [29.941923869000107, -2.316601663999947],
            [29.931691935000117, -2.316911722999933],
            [29.92879805500013, -2.322492776999951],
            [29.92890140800006, -2.331794534999887],
            [29.922390177000068, -2.382954202999883],
            [29.929573202000142, -2.459848733999877],
            [29.90792077600014, -2.535399678999909],
            [29.903725678000058, -2.637946527999901],
            [29.903269898000076, -2.649087828999896],
            [29.897895548000122, -2.671101988999879],
            [29.888387085000147, -2.692909443999909],
            [29.87619144700011, -2.713580016999913],
            [29.862858927000104, -2.731666768999929],
            [29.842395060000058, -2.752440693999887],
            [29.823584839000034, -2.763499450999888],
            [29.80337935400013, -2.767323505999926],
            [29.778522990000113, -2.766600036999918],
            [29.75619877100013, -2.759882099999899],
            [29.744726603000117, -2.759985452999928],
            [29.737285197000062, -2.769287210999948],
            [29.733977905000074, -2.790267841999949],
            [29.729637085000093, -2.799569599999884],
            [29.719921916000146, -2.805460713999892],
            [29.697546021000107, -2.808251240999937],
            [29.67868412200005, -2.805357360999949],
            [29.637086889000045, -2.791628628999916],
            [29.626387573000045, -2.788097431999873],
            [29.61925622500013, -2.787684020999947],
            [29.589490600000147, -2.798432718999962],
            [29.582049194000092, -2.802980244999915],
            [29.57409102400004, -2.806080829999942],
            [29.563755737000122, -2.805667418999931],
            [29.54184493000008, -2.808561298999919],
            [29.52313806100011, -2.82044687899986],
            [29.504121135000048, -2.826854756999893],
            [29.480866740000124, -2.81372894299993],
            [29.444674800000087, -2.806989288999972],
            [29.425366251000128, -2.803393655999926],
            [29.407434530000046, -2.805460713999892],
            [29.36428470900006, -2.824167581999873],
            [29.33968672700007, -2.826441344999893],
            [29.330850057000134, -2.807424417999911],
            [29.329661499000053, -2.794918720999917],
            [29.320359741000118, -2.774144795999874],
            [29.318085978000056, -2.762569274999933],
            [29.321496623000087, -2.75213063599989],
            [29.33534590700009, -2.735180765999885],
            [29.337516316000062, -2.723811949999899],
            [29.33141849700013, -2.711409606999922],
            [29.309714396000118, -2.691049092999904],
            [29.30948054400011, -2.690126857999886],
            [29.306045370000106, -2.676579690999873],
            [29.30733728000007, -2.664797464999964],
            [29.306613810000044, -2.660146585999897],
            [29.294418172000064, -2.651051533999933],
            [29.276124716000083, -2.640612893999986],
            [29.254989054000134, -2.635548603999922],
            [29.21276940900009, -2.630277608999975],
            [29.190445190000105, -2.623456318999928],
            [29.129725383000107, -2.596997985999849],
            [29.113447307000087, -2.5946208699999],
            [29.055259643000085, -2.598444925999928],
            [29.032573690000106, -2.620665791999969],
            [29.015365438000117, -2.720711364999957],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Uganda',
        iso3: 'UGA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [30.471785843000134, -1.066836591999916],
            [30.46082862300011, -1.063427549999943],
            [30.445614054000146, -1.058693948999874],
            [30.432023153000046, -1.060554300999883],
            [30.41889733900007, -1.066445413999887],
            [30.40318770300013, -1.070372822999943],
            [30.38634118600004, -1.068202412999952],
            [30.36928796400008, -1.063241474999913],
            [30.35275150500013, -1.06076100699994],
            [30.337455282000064, -1.066238707999929],
            [30.32903202300008, -1.0805014029999],
            [30.32257246900008, -1.121842549999926],
            [30.317404826000086, -1.137035419999961],
            [30.31130700700004, -1.142099710999929],
            [30.294563843000105, -1.149644469999885],
            [30.290949658000102, -1.15262085699996],
            [30.28753584800006, -1.15543222999986],
            [30.284641968000074, -1.161426695999893],
            [30.282419882000113, -1.175792744999896],
            [30.280507853000074, -1.182407327999982],
            [30.269759156000077, -1.200494079999899],
            [30.2566850180001, -1.217237243999946],
            [30.212191610000104, -1.259508564999933],
            [30.196740356000134, -1.26870696999994],
            [30.189350627000124, -1.270877379999931],
            [30.18139245600014, -1.271497497999903],
            [30.173434286000088, -1.272841084999953],
            [30.165579468000146, -1.277491963999921],
            [30.158448120000116, -1.291134541999924],
            [30.15235030100007, -1.329891865999869],
            [30.147182658000077, -1.345084736999894],
            [30.136330607000104, -1.35521331799994],
            [30.09550622600011, -1.371129658999962],
            [30.06598434300014, -1.386944953999972],
            [30.060779663000062, -1.389733174999918],
            [30.047757202000128, -1.403169046999963],
            [30.03866215000005, -1.424976500999904],
            [30.028326863000075, -1.427146911999984],
            [29.960424032000105, -1.464767353999903],
            [29.938461548000134, -1.47293223099993],
            [29.917429240000047, -1.47520599399985],
            [29.897895548000122, -1.469624938999928],
            [29.880738973000064, -1.453605244999963],
            [29.871023804000117, -1.432417906999916],
            [29.86864668800007, -1.391283466999937],
            [29.864202514000056, -1.370302835999937],
            [29.836090536000142, -1.329478454999943],
            [29.82513513200007, -1.323897399999936],
            [29.825024114000087, -1.323880810999896],
            [29.816143432000104, -1.322553812999956],
            [29.80746179200014, -1.325137633999873],
            [29.798211711000135, -1.330925394999937],
            [29.789168335000056, -1.341674092999952],
            [29.783173869000052, -1.361414488999927],
            [29.77490563900011, -1.366272073999937],
            [29.76798099700011, -1.36379160499996],
            [29.74669030800004, -1.350872496999955],
            [29.734804728000086, -1.348185322999925],
            [29.71051680500011, -1.352526142999906],
            [29.693773641000064, -1.361207783999873],
            [29.678322388000083, -1.372369892999899],
            [29.657703491000063, -1.383945413999939],
            [29.639099976000125, -1.389009703999918],
            [29.618119344000092, -1.39055999699994],
            [29.577915080000082, -1.388389587999953],
            [29.58732019100006, -1.329685159999912],
            [29.5871134840001, -1.310564879999916],
            [29.583186076000118, -1.299299417999947],
            [29.571507202000134, -1.279248961999897],
            [29.57099043800008, -1.268603616999911],
            [29.580447225000057, -1.243282164999925],
            [29.581429077000053, -1.23480722999993],
            [29.575537964000034, -1.213206480999958],
            [29.565254354000047, -1.197910257999908],
            [29.557037801000035, -1.181787210999914],
            [29.556934448000106, -1.15770599299988],
            [29.569130087000076, -1.095900979999982],
            [29.57006026200014, -1.077917581999898],
            [29.56592614800013, -1.058590595999945],
            [29.55119836400013, -1.0201433309999],
            [29.54845951300007, -1.002573343999927],
            [29.551353394000046, -0.990584411999876],
            [29.55151757200008, -0.990305308999964],
            [29.556521037000095, -0.981799417999881],
            [29.56034509300008, -0.972084247999945],
            [29.559156535000056, -0.95730478899992],
            [29.55528080200014, -0.938494567999911],
            [29.554660686000148, -0.928572691999918],
            [29.556004273000042, -0.919477640999943],
            [29.56716638200004, -0.90190765399997],
            [29.596725301000106, -0.891882425999952],
            [29.607990764000135, -0.878446553999908],
            [29.61078129100008, -0.863977152999965],
            [29.61336511200011, -0.80382578499993],
            [29.611091349000105, -0.782741799999897],
            [29.602203003000056, -0.743777770999912],
            [29.603029826000125, -0.722900491999937],
            [29.615535522000073, -0.644145608999935],
            [29.618842814000118, -0.638977965999928],
            [29.62442386800012, -0.634843851999918],
            [29.629281453000146, -0.629779560999935],
            [29.6305733640001, -0.622028095999923],
            [29.62824792500004, -0.616033629999905],
            [29.62049646000014, -0.605388284999904],
            [29.618842814000118, -0.599393818999971],
            [29.622873576000075, -0.588438414999899],
            [29.632175334000124, -0.585751240999883],
            [29.642820679000124, -0.585027770999972],
            [29.650882202000105, -0.579550068999893],
            [29.653052612000067, -0.565597431999905],
            [29.64974532000008, -0.504309182999947],
            [29.64509444200013, -0.488909606999954],
            [29.634614925000108, -0.466968118999944],
            [29.631865275000052, -0.461211038999934],
            [29.629384806000076, -0.442400817999925],
            [29.650980745000084, -0.316454752999917],
            [29.653982788000064, -0.298947041999938],
            [29.670569225000122, -0.200867429999903],
            [29.67661706600012, -0.165105081999883],
            [29.694032023000148, -0.063095804999961],
            [29.709018188000073, -0.026302184999878],
            [29.71434086100004, -0.00749196299995],
            [29.713462362000087, 0.011628316000042],
            [29.701628458000073, 0.055243226000087],
            [29.703075399000113, 0.072503154000074],
            [29.711808715000075, 0.099581604000136],
            [29.75578535900013, 0.160869853000094],
            [29.76126306200007, 0.172135315000048],
            [29.773045288000105, 0.16748443600008],
            [29.780383342000107, 0.161179911000076],
            [29.787204630000133, 0.158492737000046],
            [29.79712650600004, 0.164797261000061],
            [29.80064050200008, 0.172445374000034],
            [29.832628215000113, 0.336983134000135],
            [29.839604533000056, 0.35848053000008],
            [29.851076701000125, 0.377187399000064],
            [29.903908655000066, 0.438229209000056],
            [29.92290694200011, 0.460179748000115],
            [29.92608285600005, 0.467073351000096],
            [29.940476928000066, 0.498316956000082],
            [29.937996460000136, 0.537280985000066],
            [29.91949629700008, 0.618102925000116],
            [29.920013061000134, 0.63867014500002],
            [29.93231205300009, 0.723161113000074],
            [29.926834350000092, 0.774889221000123],
            [29.928281290000086, 0.78501780200007],
            [29.947298218000128, 0.82460195000003],
            [29.960217326000077, 0.832095032000069],
            [29.982194040000138, 0.849017102000076],
            [29.996390829000063, 0.859948629000129],
            [30.038352092000082, 0.878913879000081],
            [30.14511560000011, 0.903150126000071],
            [30.154830770000046, 0.90867950500008],
            [30.165682820000086, 0.921443583000041],
            [30.183769572000074, 0.955136617000093],
            [30.186870158000147, 0.958753968000082],
            [30.191521037000086, 0.974877014000057],
            [30.21405196100011, 0.998544820000092],
            [30.22097660300011, 1.017096660000036],
            [30.215602255000135, 1.057766012000087],
            [30.215292195000075, 1.077092997000122],
            [30.22800459800004, 1.089030253000075],
            [30.231518596000058, 1.097763570000055],
            [30.234102417000088, 1.108098857000059],
            [30.236169475000054, 1.129492900000074],
            [30.23885664900007, 1.136004130000046],
            [30.269345744000134, 1.167268371000134],
            [30.2779757080001, 1.171609192000105],
            [30.28650231900008, 1.17429636600005],
            [30.295700724000085, 1.172642721000088],
            [30.306552775000057, 1.163909404000123],
            [30.323812703000044, 1.155847880000039],
            [30.33606001800007, 1.168870341000073],
            [30.34820398000005, 1.189024150000051],
            [30.36494714300011, 1.202046611000085],
            [30.376626017000092, 1.203080140000068],
            [30.399260295000147, 1.200599670000088],
            [30.412696167000092, 1.202046611000085],
            [30.431609741000045, 1.207007548000121],
            [30.445562378000147, 1.2127953090001],
            [30.458274780000067, 1.221683655000021],
            [30.478273560000105, 1.238633525000125],
            [30.55370445300008, 1.335632478000093],
            [30.597284383000044, 1.391673279000102],
            [30.68172367300008, 1.500348816000042],
            [30.817012573000056, 1.609515279000092],
            [30.954420207000112, 1.720671285000094],
            [31.025837036000098, 1.778238831000039],
            [31.096017547000145, 1.866363001000053],
            [31.119112996000126, 1.89536346400007],
            [31.183295125000086, 1.976211243000122],
            [31.24282637600004, 2.051167908000096],
            [31.271455119000052, 2.102999370000077],
            [31.280095681000034, 2.151441144000088],
            [31.280446818000087, 2.153409729000074],
            [31.27873986900005, 2.156021156000051],
            [31.267476033000037, 2.173253479000067],
            [31.21089034000005, 2.205344543000081],
            [31.190116415000034, 2.221519267000076],
            [31.18246830200013, 2.238727519000065],
            [31.17905765800009, 2.259759827000067],
            [31.17755904100011, 2.302909648000096],
            [31.129241577000073, 2.284667868000042],
            [31.11260176600007, 2.282084045000133],
            [31.09906254000009, 2.282704163000105],
            [31.055240926000067, 2.29024892200006],
            [31.04066817200004, 2.297897033000126],
            [31.035500529000103, 2.306940409000092],
            [31.038807820000102, 2.310971171000091],
            [31.04438887500004, 2.313916728000081],
            [31.045939168000075, 2.319652812000044],
            [31.043562052000084, 2.327042542000058],
            [31.04128828900008, 2.331228333000084],
            [30.984857626000064, 2.394635315000116],
            [30.968011109000088, 2.405435689000058],
            [30.930907430000104, 2.405590719000088],
            [30.91447432400014, 2.378150534000042],
            [30.900573364000138, 2.345956116000096],
            [30.87178959200014, 2.332055155000106],
            [30.85494307500005, 2.339703268000093],
            [30.836339559000123, 2.356343078000108],
            [30.819803101000105, 2.375980123000147],
            [30.809674520000044, 2.392361552000096],
            [30.80698734500004, 2.40698598200008],
            [30.80714237500007, 2.422178853000105],
            [30.804920288000062, 2.434374491000113],
            [30.794998413000087, 2.440110575000077],
            [30.724925171000052, 2.440782369000061],
            [30.710559123000053, 2.445123189000043],
            [30.707665243000065, 2.46227976500009],
            [30.71676029400004, 2.483105367000064],
            [30.729369344000133, 2.503465882000086],
            [30.737017456000103, 2.519537252000063],
            [30.737844279000058, 2.53746897400012],
            [30.734020223000073, 2.574469300000075],
            [30.73526045800014, 2.593072815000127],
            [30.739394572000037, 2.603304749000117],
            [30.758928263000087, 2.633793844000095],
            [30.76125370300008, 2.64159698500012],
            [30.762013299000046, 2.645781198000108],
            [30.76430261300004, 2.658391825000081],
            [30.797685587000103, 2.748360495000028],
            [30.798925822000058, 2.753528138000121],
            [30.799132528000086, 2.763450012000121],
            [30.801612997000063, 2.769082743000055],
            [30.805850464000116, 2.771873271000118],
            [30.81794274900011, 2.77419871000005],
            [30.82187015700009, 2.776162415000087],
            [30.82869144700004, 2.786084290000076],
            [30.853392782000128, 2.853367005000067],
            [30.854839722000122, 2.893209534000079],
            [30.843987671000093, 2.932793681000135],
            [30.82093998200014, 2.973152975000104],
            [30.80362837700011, 2.989069316000041],
            [30.757067912000082, 3.021470439000041],
            [30.74507898000013, 3.036301575000067],
            [30.743838745000062, 3.055473531000075],
            [30.747869507000075, 3.076712545000049],
            [30.763415783000085, 3.12343695000007],
            [30.804196818000094, 3.246004537000132],
            [30.82212854000005, 3.281402893000063],
            [30.82574589000012, 3.283676656000083],
            [30.837786499000117, 3.286415507000115],
            [30.842437377000067, 3.288740946000061],
            [30.845641317000116, 3.293908589000054],
            [30.84688155100008, 3.304398906000102],
            [30.848690226000144, 3.309256490000038],
            [30.86848230000004, 3.343337097000088],
            [30.89731774900008, 3.375014750000091],
            [30.904932931000076, 3.386035094000121],
            [30.910030152000047, 3.393411560000089],
            [30.916334676000133, 3.414805603000104],
            [30.91447432400014, 3.426484477000074],
            [30.90444909700011, 3.447465108000074],
            [30.902898804000074, 3.458911438000086],
            [30.909616740000104, 3.487178447000076],
            [30.909306681000146, 3.496144307000108],
            [30.89638757300014, 3.519967143000073],
            [30.88016117400008, 3.514411927000069],
            [30.86124759900008, 3.498211365000074],
            [30.83954349800007, 3.490201518000092],
            [30.84378096600011, 3.505911153000056],
            [30.865691773000094, 3.548957621000056],
            [30.931734253000116, 3.645101624000077],
            [30.93628177900007, 3.656858012000072],
            [30.939382365000085, 3.668407695000013],
            [30.944446655000093, 3.679285583000066],
            [30.955505412000093, 3.689000753000101],
            [30.96599572700012, 3.692618103000086],
            [30.98578780100013, 3.69212717700006],
            [30.995968058000074, 3.693522440000038],
            [31.00955896000005, 3.699775289000044],
            [31.040358114000128, 3.724218242000077],
            [31.049659871000074, 3.727990621000103],
            [31.068676798000126, 3.731737162000115],
            [31.077668498000094, 3.735302836000088],
            [31.104408487000114, 3.756175184000099],
            [31.14148889200004, 3.785118917000119],
            [31.16758549000008, 3.792405294000105],
            [31.214817749000133, 3.792353617000089],
            [31.255745483000055, 3.786669210000042],
            [31.295019572000115, 3.77418935200005],
            [31.377701863000084, 3.729308370000055],
            [31.505446004000078, 3.659855245000088],
            [31.523739461000048, 3.656082866000062],
            [31.534519828000043, 3.665562968000103],
            [31.535521688000074, 3.666443990000076],
            [31.547200562000057, 3.680990906000119],
            [31.564770549000116, 3.689801737000025],
            [31.668536825000103, 3.705020447000066],
            [31.686830282000074, 3.712823589000081],
            [31.696132039000133, 3.721272685000073],
            [31.775713745000132, 3.810698751000075],
            [31.777884155000038, 3.816434835000038],
            [31.780984741000054, 3.81581471800007],
            [31.801106597000057, 3.806472428000063],
            [31.807029663000037, 3.803722433000075],
            [31.830697469000086, 3.783878683000083],
            [31.901907593000146, 3.70429697700007],
            [31.916273641000146, 3.680267436000037],
            [31.920046021000076, 3.661302185000082],
            [31.923094930000104, 3.615284323000083],
            [31.93001957200005, 3.598360290000073],
            [31.94366215000008, 3.591254781000146],
            [32.022235907000095, 3.586420195000073],
            [32.03016849700009, 3.585932109000098],
            [32.04153731300005, 3.57986012800005],
            [32.05422597800009, 3.559571835000057],
            [32.060864299000116, 3.548957621000056],
            [32.076160523000055, 3.533170471000062],
            [32.093007040000145, 3.5244629930001],
            [32.15584558100011, 3.511776428000061],
            [32.16798954200004, 3.512241516000074],
            [32.17455244900009, 3.520897318000038],
            [32.17592855800012, 3.527233818000113],
            [32.1789966230001, 3.541361185000085],
            [32.179203328000085, 3.556864115000096],
            [32.1748625080001, 3.592650045000127],
            [32.175947713000085, 3.605594991000132],
            [32.18778161600011, 3.619160054000119],
            [32.371801391000076, 3.731065369000135],
            [32.41557133000009, 3.74129730300011],
            [32.59928104700009, 3.756283468000092],
            [32.75642907700012, 3.769021708000054],
            [32.8403516030001, 3.794291484000027],
            [32.91889978100005, 3.834159851000052],
            [32.97956791200005, 3.879195862000088],
            [32.99724125100005, 3.885526225000106],
            [33.017240031000085, 3.877180481000039],
            [33.1434855550001, 3.774085999000121],
            [33.164466186000084, 3.76305308000012],
            [33.19542036900009, 3.757058614000101],
            [33.28652591900004, 3.752536926000076],
            [33.44734297700012, 3.744372051000056],
            [33.49064782700009, 3.749746399000102],
            [33.527716349000116, 3.771430572000057],
            [33.53260909000011, 3.774292705000079],
            [33.60619632900011, 3.848086650000127],
            [33.70190108200012, 3.944075623000103],
            [33.81367720500015, 4.056032614000031],
            [33.896049438000034, 4.138353170000101],
            [33.97707808500007, 4.219691875000095],
            [34.006016887000044, 4.205713399000103],
            [34.02854781100007, 4.188014221000088],
            [34.04105350800006, 4.164811503000081],
            [34.03970992100005, 4.13403818700003],
            [34.04095015500013, 4.12042144800003],
            [34.04973514800008, 4.109466044000058],
            [34.060897257000136, 4.099259949000071],
            [34.06926883900013, 4.088020325000031],
            [34.07236942600014, 4.076418966000077],
            [34.07267948400005, 4.064662577000078],
            [34.06978560300007, 4.041356506000042],
            [34.06585819500009, 4.027429708000057],
            [34.06151737500011, 4.017921245000082],
            [34.06110396300011, 4.007766825000118],
            [34.06895878100005, 3.991876323000099],
            [34.08084436100006, 3.980791728000085],
            [34.09552046700014, 3.970999044000038],
            [34.10709598800008, 3.959501037000095],
            [34.10957645600007, 3.943352152000017],
            [34.09893111200006, 3.917720642000049],
            [34.086218709000036, 3.894672953000082],
            [34.08477176900004, 3.87733551000008],
            [34.10802616400014, 3.868938091000089],
            [34.12373579900009, 3.872038676000045],
            [34.1634232990001, 3.886198019000091],
            [34.18285363700005, 3.886094666000062],
            [34.20497115100011, 3.874544983000121],
            [34.20755497300007, 3.860876567000105],
            [34.19670292200004, 3.847389018000044],
            [34.14895389800006, 3.822687683000126],
            [34.15081425000005, 3.817209981000047],
            [34.16652388500006, 3.811318868000043],
            [34.179029582000055, 3.796100159000105],
            [34.15908247900012, 3.783361919000043],
            [34.152467895000086, 3.775636292000044],
            [34.16518029800005, 3.770830383000131],
            [34.17365523300009, 3.771398824000087],
            [34.19091516100008, 3.775842997000012],
            [34.21055220500011, 3.77713490800005],
            [34.23039595600011, 3.782741801000071],
            [34.24093794700008, 3.783620300000024],
            [34.24155806500005, 3.778736878000089],
            [34.26377893000006, 3.750056457000099],
            [34.27886844900007, 3.709723002000132],
            [34.29044396900008, 3.703160095000058],
            [34.295094848000076, 3.707345886000084],
            [34.29943566900005, 3.716931864000088],
            [34.309874309000065, 3.726698710000051],
            [34.337056112000084, 3.734579366000091],
            [34.35503951000004, 3.72737050400012],
            [34.387492310000084, 3.692747294000114],
            [34.40630253100011, 3.682928772000054],
            [34.42500939900009, 3.67719268800009],
            [34.439685506000046, 3.667735901000128],
            [34.446403443000065, 3.646703593000026],
            [34.44392297400009, 3.566295065000062],
            [34.43451786300005, 3.526219991000076],
            [34.41550093600006, 3.49702280700005],
            [34.406199178000065, 3.492294414000057],
            [34.395967244000076, 3.489607239000037],
            [34.38687219200011, 3.48562815300005],
            [34.38129113800011, 3.476868998000072],
            [34.38211796000013, 3.466042786000031],
            [34.39441695200014, 3.444622904000099],
            [34.398551066000095, 3.433641662000113],
            [34.39700077300006, 3.424159037000052],
            [34.386975546000144, 3.399664409000096],
            [34.383978312000124, 3.388347270000025],
            [34.386562134000144, 3.376384176000073],
            [34.39441695200014, 3.365661316000057],
            [34.40382206200013, 3.355403544000069],
            [34.411160116000076, 3.344706523000056],
            [34.424079223000035, 3.304812317000113],
            [34.43400109900011, 3.182029114000059],
            [34.44485315000014, 3.159136455000038],
            [34.46573042800014, 3.14585561100003],
            [34.51285933400004, 3.132368063000072],
            [34.53383996600013, 3.118467102000082],
            [34.5455563430001, 3.097500953000036],
            [34.54562219200005, 3.097383118000067],
            [34.57466434700012, 2.946126200000066],
            [34.58468957500014, 2.928711243000038],
            [34.6164189050001, 2.893416239000132],
            [34.63140507000014, 2.869541728000058],
            [34.640500122000105, 2.860136617000094],
            [34.654142700000136, 2.85651926700011],
            [34.66034387200011, 2.858638001000088],
            [34.67150598100005, 2.867784729000078],
            [34.67564009600005, 2.869800110000114],
            [34.67812056500014, 2.871557109000094],
            [34.68256473800005, 2.879360250000033],
            [34.685045207000144, 2.880962220000058],
            [34.68886926300007, 2.879153545000065],
            [34.691039673000034, 2.875691223000032],
            [34.692693319000114, 2.872228903000078],
            [34.69465702300005, 2.870420227000096],
            [34.69651737400005, 2.867733053000066],
            [34.72483606000014, 2.854142151000076],
            [34.730107056000065, 2.852850240000109],
            [34.73692834500014, 2.844375305000113],
            [34.740959106000105, 2.835538635000106],
            [34.76131962100004, 2.772493388000086],
            [34.77651249200005, 2.685625306000077],
            [34.81868046100004, 2.597982076000065],
            [34.82808557100009, 2.588783671000073],
            [34.84183150300004, 2.58775014200009],
            [34.849893025000085, 2.59513987200009],
            [34.85650760900012, 2.603459778000058],
            [34.86560266100008, 2.60485504200004],
            [34.8756278890001, 2.591212464000122],
            [34.88131229600015, 2.541448059000103],
            [34.88710005700011, 2.522379456000124],
            [34.91438521300006, 2.494370829000019],
            [34.923583619000055, 2.477317607000089],
            [34.92089644300012, 2.454631653000121],
            [34.90611698400011, 2.436906637000106],
            [34.885963175000086, 2.425434469000081],
            [34.86787642400009, 2.411481832000092],
            [34.85909143100008, 2.386780497000089],
            [34.86560266100008, 2.347506409000104],
            [34.904284074000145, 2.254255316000084],
            [34.92234338300011, 2.210718893000134],
            [34.967508586000065, 2.101914164000078],
            [34.96761193800012, 2.082561340000026],
            [34.95820682800013, 2.037964580000107],
            [34.956656535000036, 2.018508403000027],
            [34.95789676900006, 1.997837830000108],
            [34.96203088300007, 1.977813212000072],
            [34.96916223100004, 1.960294902000015],
            [34.977947225000094, 1.949907939000084],
            [35.00140832500006, 1.927997132000129],
            [35.006472615000064, 1.916860860000014],
            [35.002751912000065, 1.906138001000087],
            [34.984045044000084, 1.882470194000064],
            [34.9797042240001, 1.870300395000058],
            [34.97867069500012, 1.675945333000044],
            [34.97267622900006, 1.654241231000057],
            [34.94094689900004, 1.587036031000082],
            [34.93371219900007, 1.575693054000098],
            [34.92348026500008, 1.566107076000094],
            [34.913558390000105, 1.561559550000069],
            [34.89257775900012, 1.5572704060001],
            [34.88255253000011, 1.552231954000121],
            [34.859504842000035, 1.517918803000015],
            [34.83842085800012, 1.437174378000066],
            [34.77899296100014, 1.388546855000058],
            [34.78074667700014, 1.371789122000052],
            [34.78271366400014, 1.352993469000097],
            [34.80007694500006, 1.312324117000045],
            [34.81051558500013, 1.272533264000046],
            [34.797906535000095, 1.231915588000092],
            [34.76607385300014, 1.21749786400008],
            [34.683804973000065, 1.209074606000087],
            [34.66303104600013, 1.196362203000135],
            [34.62892460100005, 1.163599345000137],
            [34.58045210800009, 1.15254058900004],
            [34.57363081800014, 1.134247131000066],
            [34.57197717300011, 1.111716207000129],
            [34.56688291800015, 1.103021686000076],
            [34.561228475000064, 1.093371074000061],
            [34.5600649320001, 1.093149310000101],
            [34.54035119700012, 1.089391988000074],
            [34.524021444000084, 1.098642069000093],
            [34.507484985000076, 1.102517802000136],
            [34.48702111800009, 1.08246734700009],
            [34.47720259600004, 1.064587301000131],
            [34.4688310140001, 1.044226787000099],
            [34.46366337100005, 1.022936096000109],
            [34.46304325400013, 0.978080953000131],
            [34.45715214100011, 0.95761708600007],
            [34.431210571000065, 0.893538310000068],
            [34.40237512200014, 0.856072896000086],
            [34.38800907400014, 0.815816955000045],
            [34.37085249800015, 0.800210673],
            [34.30667037000012, 0.768067932000065],
            [34.298402140000064, 0.759282938000084],
            [34.29625187600004, 0.746745807000053],
            [34.29230432100013, 0.723729553000027],
            [34.276181275000056, 0.680838114000068],
            [34.252100057000064, 0.654999898000142],
            [34.21975061100011, 0.638566793000081],
            [34.17913293400005, 0.623890686000095],
            [34.149574016000145, 0.603633524000088],
            [34.13241743900005, 0.572834371000027],
            [34.13158774800007, 0.569432983000056],
            [34.10750940000008, 0.470721741000077],
            [34.10440881300008, 0.462246806000081],
            [34.09738081800015, 0.451808166000134],
            [34.080120890000046, 0.431344300000077],
            [34.075676717000135, 0.42224924700011],
            [34.07671024600012, 0.403852438000101],
            [34.0879757080001, 0.3673688760001],
            [34.08518518000005, 0.347008362000068],
            [34.076606893000076, 0.333779196000066],
            [34.04064009600012, 0.305873921000085],
            [33.96026592400011, 0.198677206000113],
            [33.95175663300006, 0.187328186000073],
            [33.89356896900006, 0.109813538000111],
            [33.890468384000144, 0.090073140000058],
            [33.92157759600008, -0.012969664999943],
            [33.952480102000095, -0.115702412999951],
            [33.95351363100008, -0.154356383999954],
            [33.935116821000065, -0.313106383999894],
            [33.91134566200009, -0.519295348999918],
            [33.894809204000126, -0.662749124999891],
            [33.898529907000125, -0.799071553999937],
            [33.90421431500005, -1.002573343999927],
            [33.822255493000114, -1.002573343999927],
            [33.63926924600008, -1.002573343999927],
            [33.631776971000136, -1.002573343999927],
            [33.456127970000125, -1.002573343999927],
            [33.426414846000114, -1.002573343999927],
            [33.273090047000096, -1.002573343999927],
            [33.08994877100014, -1.002573343999927],
            [32.90696252400011, -1.002573343999927],
            [32.84722537600004, -1.002573343999927],
            [32.72387292500008, -1.002573343999927],
            [32.722267718000126, -1.002573343999927],
            [32.54083500200005, -1.002573343999927],
            [32.35764205000004, -1.002573343999927],
            [32.17455244900009, -1.002573343999927],
            [31.99141117300013, -1.002573343999927],
            [31.986192661000075, -1.002573343999927],
            [31.808373251000035, -1.002573343999927],
            [31.625335327000073, -1.002573343999927],
            [31.442245727000056, -1.002573343999927],
            [31.280492691000063, -1.002573343999927],
            [31.259156128000086, -1.002573343999927],
            [31.076118204000068, -1.002573343999927],
            [30.89297692800011, -1.002573343999927],
            [30.82838138800014, -1.002573343999927],
            [30.812465048000035, -0.9947185259999],
            [30.777118367000128, -0.98583017999988],
            [30.73949792500008, -1.005467223999915],
            [30.701567424000075, -1.017456155999881],
            [30.687098023000146, -1.025000914999922],
            [30.651337931000057, -1.062828063999902],
            [30.63862552900008, -1.073370055999959],
            [30.614544311000145, -1.065825296999918],
            [30.592736857000034, -1.063448180999956],
            [30.54230066000008, -1.068099059999923],
            [30.52369714300005, -1.072439880999909],
            [30.5116565350001, -1.073370055999959],
            [30.506023803000062, -1.070786233999868],
            [30.50085616000007, -1.06520517999985],
            [30.493414754000128, -1.060244241999897],
            [30.48101241100005, -1.059107360999889],
            [30.47295088700008, -1.065618590999861],
            [30.471785843000134, -1.066836591999916],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Lesotho',
        iso3: 'LSO',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [28.980845581000068, -28.909035338999985],
            [28.995418335000096, -28.908311868999903],
            [29.018982788000102, -28.91399627599995],
            [29.040531861000062, -28.922987975999987],
            [29.049678589000052, -28.93301320399992],
            [29.049988647000134, -28.952650248999944],
            [29.0557764080001, -28.965362649999904],
            [29.06900557500009, -28.97332082099996],
            [29.091536499000114, -28.978591816999895],
            [29.12595300300009, -28.992441100999955],
            [29.208428589000107, -29.068922220999937],
            [29.241398153000034, -29.07770721399993],
            [29.28139571100013, -29.078637389999884],
            [29.311781453000094, -29.08979949899991],
            [29.316845744000148, -29.147367044999953],
            [29.328059530000075, -29.15935597699992],
            [29.34371748900014, -29.16979461699995],
            [29.3574634200001, -29.183333841999925],
            [29.36500817800004, -29.20028371199993],
            [29.37596358200011, -29.235527037999915],
            [29.4038688550001, -29.268703307999928],
            [29.413997437000035, -29.290304056999986],
            [29.41492761300009, -29.296401875999948],
            [29.413997437000035, -29.311698098999912],
            [29.415030965000142, -29.31893279999987],
            [29.419475138000053, -29.325030618999932],
            [29.43280765700007, -29.336606139999972],
            [29.435908244000075, -29.342393900999937],
            [29.432239217000074, -29.35696665499991],
            [29.413739054000075, -29.380117695999985],
            [29.41187870300007, -29.395827330999865],
            [29.41255049700004, -29.410296732999896],
            [29.4078996180001, -29.42145884199992],
            [29.399528036000106, -29.430347188999946],
            [29.388159220000034, -29.437788594999873],
            [29.361804240000083, -29.447917174999915],
            [29.3320386150001, -29.455978698999914],
            [29.30382328200011, -29.466830749999957],
            [29.28273929800008, -29.485640970999967],
            [29.27550459800011, -29.506621601999967],
            [29.27519872500011, -29.52829489199989],
            [29.275142863000042, -29.532253112999925],
            [29.282015828000056, -29.556127623999913],
            [29.29627852400006, -29.571630553999924],
            [29.279948771000136, -29.581449075999984],
            [29.2783984780001, -29.59705535899994],
            [29.27860518400007, -29.613591817999932],
            [29.2673397210001, -29.626097513999923],
            [29.190341837000062, -29.646871438999966],
            [29.161299682000077, -29.666921894999916],
            [29.145073283000073, -29.69193328899992],
            [29.132412557000123, -29.720251972999918],
            [29.113757365000055, -29.75012095099993],
            [29.113599444000045, -29.752850734999924],
            [29.11231042500006, -29.775132344999918],
            [29.106315959000142, -29.80159067799991],
            [29.1057991940001, -29.825568541999928],
            [29.12037194800007, -29.843448587999973],
            [29.13298099800008, -29.852026874999922],
            [29.135771525000052, -29.85915822299995],
            [29.13515140800007, -29.86804656999996],
            [29.13732181800006, -29.88210255899989],
            [29.148277221000058, -29.901326191999914],
            [29.150654337000077, -29.91114471399989],
            [29.144246460000147, -29.919723002999916],
            [29.132774292000136, -29.924683939999866],
            [29.106315959000142, -29.931505227999907],
            [29.094120321000048, -29.936259459999903],
            [29.01578602900011, -29.97858746299997],
            [28.976298055000115, -29.99992482499991],
            [28.86002608200002, -30.06638071699996],
            [28.795637248000048, -30.08942840499992],
            [28.72949141400005, -30.10183074999989],
            [28.639677775000052, -30.13149302099994],
            [28.605881389000075, -30.1312863159999],
            [28.55730554200008, -30.114956562999865],
            [28.54056237700013, -30.113302916999913],
            [28.524335978000124, -30.11671356199993],
            [28.48092777500011, -30.139347839999886],
            [28.456226441000098, -30.14699595099995],
            [28.40796065300009, -30.140898131999904],
            [28.383879436000143, -30.144205423999907],
            [28.364087362000078, -30.159294941999903],
            [28.355596048000052, -30.173240026999892],
            [28.338662557000077, -30.20104949999994],
            [28.323004598000097, -30.214692076999953],
            [28.313702840000076, -30.220789895999914],
            [28.301300496000124, -30.236499531999883],
            [28.294375854000123, -30.242493997999915],
            [28.284712362000107, -30.246214700999914],
            [28.25530847200011, -30.249935403999928],
            [28.237015015000054, -30.25634328199996],
            [28.216034383000135, -30.267402038999975],
            [28.200634807000057, -30.282491555999883],
            [28.198464396000077, -30.301095072999928],
            [28.209419800000063, -30.314634297999916],
            [28.22409590700005, -30.320525410999906],
            [28.2357747800001, -30.329413756999926],
            [28.238461955000048, -30.352254739999935],
            [28.231433960000118, -30.373855488999908],
            [28.21820479300004, -30.387394713999882],
            [28.133248739000067, -30.445375670999937],
            [28.125393921000125, -30.457261250999963],
            [28.127564331000116, -30.465116068999905],
            [28.13924320500007, -30.48268605499996],
            [28.14244714300014, -30.492607930999966],
            [28.14120690900012, -30.500772805999887],
            [28.1242570390001, -30.54728159599992],
            [28.120846394000097, -30.553379414999966],
            [28.112836548000104, -30.562474466999944],
            [28.104878378000137, -30.56836557999995],
            [28.096351766000026, -30.572396341999948],
            [28.088031861000076, -30.57756398499994],
            [28.081572306000112, -30.586865742999876],
            [28.075836223000067, -30.607019551999954],
            [28.076508016000048, -30.62324595099996],
            [28.07898848500011, -30.63926564499991],
            [28.078781779000053, -30.658799335999916],
            [28.054700562000107, -30.64970428499994],
            [27.93656823800012, -30.640815938999935],
            [27.915587606000116, -30.634924824999928],
            [27.895640503000095, -30.626243183999875],
            [27.88613204000012, -30.619731953999903],
            [27.878277221000076, -30.612910663999955],
            [27.869802287000084, -30.607122904999883],
            [27.858226766000115, -30.603712259999952],
            [27.849545125000077, -30.60495249399989],
            [27.830424846000085, -30.613117370999916],
            [27.820399617000135, -30.61456431099991],
            [27.77843835400006, -30.60970672599997],
            [27.7436084390001, -30.60030161499992],
            [27.71353275600012, -30.58376515699993],
            [27.65953088300006, -30.53053843199997],
            [27.59860437000009, -30.490334167999947],
            [27.59229984500007, -30.481859232999938],
            [27.590646200000037, -30.4728675329999],
            [27.59012943500008, -30.463875833999865],
            [27.58682214400008, -30.45498748699994],
            [27.56274092600006, -30.425531920999944],
            [27.536592651000035, -30.403207701999875],
            [27.53336382400005, -30.393424839999923],
            [27.529668009000147, -30.382227070999974],
            [27.493184448000136, -30.367654316999918],
            [27.47747481300007, -30.35628550199992],
            [27.466726115000142, -30.341092630999896],
            [27.459388062000073, -30.316598001999935],
            [27.45210168400007, -30.310086770999973],
            [27.436030314000107, -30.30988006599992],
            [27.414842977000063, -30.3175281769999],
            [27.407814982000048, -30.318561705999883],
            [27.397634725000074, -30.317218118999918],
            [27.37770772900012, -30.31232376899996],
            [27.377015829000072, -30.31215382899994],
            [27.366163778000043, -30.311016946999928],
            [27.367817424000094, -30.295410664999892],
            [27.345544881000137, -30.241563821999947],
            [27.343684529000114, -30.212935078999877],
            [27.36554366000007, -30.16580617299988],
            [27.380529825000053, -30.152577005999973],
            [27.381356649000054, -30.142655130999884],
            [27.371951538000104, -30.135937194999954],
            [27.356655314000136, -30.13221649199994],
            [27.33443444800011, -30.13221649199994],
            [27.32203210400013, -30.134800312999943],
            [27.312782023000125, -30.131596373999884],
            [27.300431356000075, -30.114956562999865],
            [27.29371341900014, -30.100900573999937],
            [27.280174194000068, -30.05346160799995],
            [27.265911499000083, -30.03330780099988],
            [27.21795577000006, -29.9980644729999],
            [27.19883549000008, -29.97853078199998],
            [27.171350065000098, -29.92149529799991],
            [27.088764690000062, -29.75012095099993],
            [27.088661336000115, -29.75012095099993],
            [27.088661336000115, -29.750017598999904],
            [27.080134725000107, -29.735134785999946],
            [27.050989217000108, -29.69679087399993],
            [27.037656698000063, -29.686455586999926],
            [27.024530884000114, -29.68004770899998],
            [27.010216512000113, -29.669919127999933],
            [27.002154989000132, -29.666508483999905],
            [27.01445398000007, -29.64170379599996],
            [27.01486739100008, -29.625580749999898],
            [27.022412150000036, -29.616175638999934],
            [27.032954142000108, -29.616175638999934],
            [27.042359253000143, -29.628061218999875],
            [27.0491805420001, -29.620516458999916],
            [27.05682865400007, -29.604393411999936],
            [27.062203002000047, -29.600155944999884],
            [27.07202152500011, -29.599949238999926],
            [27.07512211100007, -29.605116882999923],
            [27.07770593200007, -29.61131805399991],
            [27.085870809000085, -29.614418639999954],
            [27.09041833500001, -29.611628112999895],
            [27.122767782000096, -29.581759134999885],
            [27.12814213000007, -29.57855519599991],
            [27.15635746300012, -29.568633320999922],
            [27.1857096760001, -29.565946145999888],
            [27.195838257000048, -29.56263885499989],
            [27.213718302000103, -29.554060566999866],
            [27.241830281000148, -29.548996276999972],
            [27.263120972000138, -29.54114145999995],
            [27.295677124000093, -29.524398294999898],
            [27.300306527000146, -29.520119603999902],
            [27.302498413000137, -29.51809376999998],
            [27.309112996000124, -29.50920542399996],
            [27.314073934000078, -29.498663430999912],
            [27.316037638000097, -29.48719126399989],
            [27.32141198700006, -29.483573913999905],
            [27.344873088000043, -29.48450408999996],
            [27.350247436000103, -29.480266621999903],
            [27.35448490400006, -29.462283222999915],
            [27.36554366000007, -29.44667694099988],
            [27.407091512000136, -29.40688608799988],
            [27.413706095000066, -29.402545267999898],
            [27.417633504000037, -29.39655080199995],
            [27.419080444000116, -29.383838398999913],
            [27.416186564000043, -29.37598358199996],
            [27.41029545100011, -29.369782408999896],
            [27.406264689000125, -29.36399464999991],
            [27.408641805000087, -29.357070006999933],
            [27.417633504000037, -29.35066212999989],
            [27.426831909000015, -29.347974954999955],
            [27.436133667000036, -29.34353078199986],
            [27.445848837000085, -29.331955260999905],
            [27.448329305000073, -29.322963561999956],
            [27.45029300900009, -29.299709166999946],
            [27.45329024300011, -29.291647643999866],
            [27.4698783770001, -29.28244923899986],
            [27.510686378000088, -29.270752951999953],
            [27.518919311000047, -29.268393248999942],
            [27.52889286300004, -29.260951842999916],
            [27.5272392170001, -29.24937632299988],
            [27.5209863690001, -29.226121927999955],
            [27.521503133000124, -29.216510110999934],
            [27.52816939300004, -29.207621764999928],
            [27.538246297000086, -29.202350768999892],
            [27.548478231000075, -29.19894012499988],
            [27.55571293200012, -29.19542612699992],
            [27.61297041800009, -29.13382781999988],
            [27.635604696000144, -29.096620788999957],
            [27.634479067000086, -29.091040540999927],
            [27.63074711100012, -29.072539570999922],
            [27.63751672400005, -29.065718281999878],
            [27.644389689000036, -29.072539570999922],
            [27.649350626000086, -29.070885925999875],
            [27.65860070800008, -29.06675181099986],
            [27.664956909000125, -29.065718281999878],
            [27.65627526800006, -29.055796406999974],
            [27.643769572000053, -29.04453094499992],
            [27.639170369000112, -29.035332539999914],
            [27.655035034000036, -29.031508483999886],
            [27.6674890540001, -29.026650898999947],
            [27.679736369000125, -29.015075377999906],
            [27.699063355000078, -28.99058074999995],
            [27.70288741100012, -28.989340514999924],
            [27.707641642000112, -28.99068410199989],
            [27.711672404000097, -28.99099416099996],
            [27.713326049000074, -28.986860045999947],
            [27.71337772600006, -28.97952199299995],
            [27.71446293100007, -28.976421406999904],
            [27.716685018000078, -28.973217468999934],
            [27.71901045700011, -28.967843118999966],
            [27.720043986000093, -28.959781594999896],
            [27.720147339000107, -28.945932311999925],
            [27.72831221500013, -28.937974140999955],
            [27.744073527000097, -28.93321990899996],
            [27.754770549000114, -28.925468444999964],
            [27.747432495000112, -28.908621927999974],
            [27.861327352000075, -28.915443216999932],
            [27.887992391000125, -28.904901224999975],
            [27.89729414900006, -28.889811705999975],
            [27.903598673000147, -28.873998717999967],
            [27.91166019700006, -28.86076955099989],
            [27.926232951000117, -28.853431497999892],
            [27.945043173000016, -28.855498555999944],
            [27.956928751000135, -28.86511037199996],
            [27.96623050900007, -28.875652363999933],
            [27.977495972000042, -28.880716655],
            [28.00467777500012, -28.880716655],
            [28.013566121000053, -28.878442890999892],
            [28.014806355000076, -28.872551777999973],
            [28.01449629700008, -28.86480031399988],
            [28.018733765000036, -28.856842142999923],
            [28.056560913000112, -28.81250376399997],
            [28.100899292000065, -28.770852559999952],
            [28.104103231000124, -28.765064798999973],
            [28.13169844500004, -28.729304707999873],
            [28.145030965000046, -28.7147319539999],
            [28.154952840000135, -28.702329609999936],
            [28.164047892000042, -28.705430195999966],
            [28.218116094000067, -28.700652075999955],
            [28.230710490000035, -28.699539082999976],
            [28.250864298000096, -28.707393899999914],
            [28.273911987000076, -28.70956431099991],
            [28.29706302900007, -28.70687713599996],
            [28.317216837000046, -28.700055846999916],
            [28.33644047000007, -28.684656269999934],
            [28.363518921000036, -28.643625182999884],
            [28.38294926000009, -28.626468607999925],
            [28.40341312700005, -28.61892384899997],
            [28.542629435000094, -28.610758971999957],
            [28.562473185000073, -28.6065215039999],
            [28.619420614000063, -28.572415058999937],
            [28.634303426000088, -28.570761413999975],
            [28.653217, -28.583060403999923],
            [28.666549520000046, -28.59721974699997],
            [28.675644572000124, -28.61375620499996],
            [28.681742391000085, -28.633393249999912],
            [28.688977092000044, -28.674424336999948],
            [28.699519083000013, -28.68848032599996],
            [28.74385746200005, -28.689513854999944],
            [28.75863692200008, -28.700469257999927],
            [28.787679077000064, -28.748735045999936],
            [28.7959473060001, -28.754316100999873],
            [28.827159871000106, -28.759277037999908],
            [28.827936586000135, -28.759534324999976],
            [28.843696330000085, -28.764754740999905],
            [28.858785848000082, -28.772816262999896],
            [28.859013629000117, -28.772990447999916],
            [28.872841837000095, -28.78356496099991],
            [28.885657593000076, -28.797207539999917],
            [28.925861857000115, -28.85952931699994],
            [28.980845581000068, -28.909035338999985],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cameroon',
        iso3: 'CMR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [11.322078491000042, 2.165760396000039],
            [11.022975301000088, 2.165708720000026],
            [10.72376875800009, 2.165657043000095],
            [10.424665568000108, 2.165657043000095],
            [10.409685690000117, 2.165654455000066],
            [10.189982611000062, 2.165616497000116],
            [10.12556237800004, 2.165605367000083],
            [9.990996948000088, 2.165605367000083],
            [9.970739786000081, 2.168912659000085],
            [9.90748783400008, 2.200486959000074],
            [9.890124552000088, 2.204569397000071],
            [9.872141154000076, 2.211235657000088],
            [9.846819702000118, 2.228547262000092],
            [9.823668660000124, 2.249011129000053],
            [9.810852905000047, 2.264875794000062],
            [9.808682495000141, 2.285494690000064],
            [9.811886434000115, 2.306165263000082],
            [9.811059611000104, 2.324872132000067],
            [9.799571159000067, 2.341742255000042],
            [9.81218509200005, 2.353583075000074],
            [9.81218509200005, 2.359808661000045],
            [9.819183790000068, 2.376939195000091],
            [9.822927280000044, 2.562933661000045],
            [9.85320071700005, 2.696966864000046],
            [9.87045332100007, 2.738104559000078],
            [9.874278191000087, 2.75454336100006],
            [9.877777540000068, 2.881415106000077],
            [9.887950066000087, 2.926906643000052],
            [9.903330925000091, 2.968329169000071],
            [9.922048373000052, 2.997259833000044],
            [9.943369988000086, 3.023138739000046],
            [9.955739780000044, 3.050482489000046],
            [9.958018425000091, 3.082220770000049],
            [9.91968834700009, 3.228094794000071],
            [9.90211022200009, 3.251695054000038],
            [9.90211022200009, 3.257961330000057],
            [9.911631707000083, 3.257717190000051],
            [9.917979363000086, 3.259466864000046],
            [9.92945397200009, 3.264797268000052],
            [9.92945397200009, 3.271551825000074],
            [9.913910352000073, 3.270331122000073],
            [9.903086785000085, 3.27289459800005],
            [9.895030144000089, 3.278306382000039],
            [9.887950066000087, 3.285223700000074],
            [9.881521030000044, 3.294338283000059],
            [9.855316602000073, 3.343573309000078],
            [9.78093509200005, 3.436753648000092],
            [9.739024285000085, 3.473089911000045],
            [9.642100457000083, 3.539048570000091],
            [9.664235873000052, 3.543931382000039],
            [9.688649936000047, 3.55609772300005],
            [9.770762566000087, 3.618719794000071],
            [9.792816602000073, 3.627183335000041],
            [9.819590691000087, 3.627875067000048],
            [9.787608269000089, 3.637111721000053],
            [9.759613477000073, 3.626166083000044],
            [9.733653191000087, 3.609320380000042],
            [9.706879102000073, 3.600531317000048],
            [9.63843834700009, 3.59438711100006],
            [9.626231316000087, 3.600002346000053],
            [9.621348504000082, 3.612779039000088],
            [9.625987175000091, 3.626450914000088],
            [9.642100457000083, 3.634670315000051],
            [9.612559441000087, 3.704982815000051],
            [9.565114780000044, 3.770900783000059],
            [9.551524285000085, 3.796210028000075],
            [9.545909050000091, 3.819647528000075],
            [9.570974155000044, 3.795477606000077],
            [9.576670769000089, 3.792303778000075],
            [9.581553582000083, 3.78782786700009],
            [9.58961022200009, 3.766099351000094],
            [9.594248894000089, 3.758205471000053],
            [9.606944207000083, 3.75226471600007],
            [9.624278191000087, 3.750189520000049],
            [9.662608269000089, 3.75071849200009],
            [9.652517123000052, 3.756048895000049],
            [9.621104363000086, 3.764960028000075],
            [9.61101321700005, 3.770575262000079],
            [9.60710696700005, 3.774725653000075],
            [9.604258660000085, 3.779974677000041],
            [9.59742272200009, 3.788885809000078],
            [9.58920332100007, 3.809637762000079],
            [9.592133009000065, 3.835150458000044],
            [9.603770379000082, 3.859035549000055],
            [9.621104363000086, 3.874823309000078],
            [9.659027540000068, 3.841009833000044],
            [9.679698113000086, 3.836086330000057],
            [9.689789259000065, 3.860581773000092],
            [9.723480665000068, 3.843817450000074],
            [9.736338738000086, 3.834173895000049],
            [9.744476759000065, 3.819647528000075],
            [9.750336134000065, 3.830267645000049],
            [9.750498894000089, 3.840765692000048],
            [9.74586022200009, 3.850897528000075],
            [9.738291863000086, 3.860581773000092],
            [9.741465691000087, 3.861029364000046],
            [9.751963738000086, 3.860581773000092],
            [9.704925977000073, 3.877508856000077],
            [9.682871941000087, 3.890448309000078],
            [9.676280144000089, 3.909002997000073],
            [9.68921959700009, 3.922430731000077],
            [9.715017123000052, 3.931341864000046],
            [9.743337436000047, 3.935939846000053],
            [9.764414910000085, 3.936346747000073],
            [9.764333530000044, 3.940741278000075],
            [9.762950066000087, 3.943793036000045],
            [9.758148634000065, 3.950018622000073],
            [9.760752800000091, 3.951361395000049],
            [9.762950066000087, 3.951239325000074],
            [9.764414910000085, 3.952337958000044],
            [9.764414910000085, 3.957464911000045],
            [9.664805535000085, 3.940375067000048],
            [9.634613477000073, 3.943182684000078],
            [9.61890709700009, 3.960353908000059],
            [9.623708530000044, 3.98578522300005],
            [9.639903191000087, 4.008775132000039],
            [9.659190300000091, 4.018866278000075],
            [9.675629102000073, 4.03384023600006],
            [9.718923373000052, 4.099554755000042],
            [9.748301629000082, 4.114447333000044],
            [9.752452019000089, 4.119818427000041],
            [9.756846550000091, 4.129828192000048],
            [9.754567905000044, 4.135687567000048],
            [9.738291863000086, 4.128729559000078],
            [9.719493035000085, 4.114935614000046],
            [9.710948113000086, 4.105698960000041],
            [9.703461134000065, 4.093939520000049],
            [9.69662519600007, 4.093939520000049],
            [9.69662519600007, 4.114447333000044],
            [9.678884311000047, 4.10101959800005],
            [9.646332227000073, 4.051459052000041],
            [9.628428582000083, 4.031927802000041],
            [9.606618686000047, 4.020656643000052],
            [9.579356316000087, 4.013006903000075],
            [9.559336785000085, 4.016791083000044],
            [9.559580925000091, 4.03937409100007],
            [9.545909050000091, 4.02570221600007],
            [9.526621941000087, 4.03579336100006],
            [9.508555535000085, 4.054185289000088],
            [9.498545769000089, 4.077215887000079],
            [9.504242384000065, 4.100775458000044],
            [9.490082227000073, 4.11587148600006],
            [9.478526238000086, 4.111395575000074],
            [9.450368686000047, 4.080308335000041],
            [9.45289147200009, 4.076971747000073],
            [9.457286004000082, 4.071112372000073],
            [9.465179884000065, 4.068101304000038],
            [9.47429446700005, 4.066148179000038],
            [9.484385613000086, 4.059881903000075],
            [9.485362175000091, 4.05532461100006],
            [9.495616082000083, 4.031480210000041],
            [9.507009311000047, 4.019476630000042],
            [9.523610873000052, 4.006089585000041],
            [9.532481316000087, 3.989447333000044],
            [9.518565300000091, 3.970445054000038],
            [9.504242384000065, 3.976141669000071],
            [9.497080925000091, 3.977687893000052],
            [9.490082227000073, 3.980658270000049],
            [9.476898634000065, 3.990912177000041],
            [9.464040561000047, 4.01203034100007],
            [9.45834394600007, 4.016180731000077],
            [9.453868035000085, 4.018622137000079],
            [9.451182488000086, 4.022772528000075],
            [9.450368686000047, 4.031927802000041],
            [9.437998894000089, 4.030462958000044],
            [9.429209832000083, 4.026556708000044],
            [9.424082879000082, 4.019476630000042],
            [9.422373894000089, 4.008368231000077],
            [9.449392123000052, 3.992132880000042],
            [9.456553582000083, 3.984076239000046],
            [9.458832227000073, 3.972357489000046],
            [9.45639082100007, 3.96352773600006],
            [9.452403191000087, 3.953924872000073],
            [9.450368686000047, 3.93976471600007],
            [9.453298373000052, 3.932114976000094],
            [9.469086134000065, 3.923407294000071],
            [9.476898634000065, 3.915838934000078],
            [9.464040561000047, 3.909979559000078],
            [9.448252800000091, 3.905747789000088],
            [9.412119988000086, 3.902167059000078],
            [9.393402540000068, 3.904282945000091],
            [9.359222852000073, 3.913723049000055],
            [9.34351647200009, 3.915838934000078],
            [9.313731316000087, 3.930853583000044],
            [9.302582227000073, 3.964992580000057],
            [9.307627800000091, 4.001939195000091],
            [9.326182488000086, 4.02570221600007],
            [9.326182488000086, 4.031927802000041],
            [9.301442905000044, 4.026353257000039],
            [9.290293816000087, 4.009711005000042],
            [9.284353061000047, 3.992254950000074],
            [9.250336134000065, 3.960842190000051],
            [9.220713738000086, 3.966009833000044],
            [9.21070397200009, 3.964260158000059],
            [9.211110873000052, 3.982570705000057],
            [9.213226759000065, 3.996568101000094],
            [9.21062259200005, 4.00812409100007],
            [9.196462436000047, 4.018866278000075],
            [9.184743686000047, 4.020900783000059],
            [9.166514519000089, 4.020900783000059],
            [9.148773634000065, 4.019029039000088],
            [9.138682488000086, 4.015448309000078],
            [9.123383009000065, 4.01788971600007],
            [9.070160352000073, 4.05141836100006],
            [8.983409050000091, 4.09243398600006],
            [8.971202019000089, 4.100775458000044],
            [8.969411655000044, 4.128973700000074],
            [8.988454623000052, 4.18891022300005],
            [8.990977410000085, 4.217474677000041],
            [8.96029707100007, 4.245917059000078],
            [8.936289910000085, 4.279527085000041],
            [8.918955925000091, 4.318060614000046],
            [8.894786004000082, 4.460516669000071],
            [8.90007571700005, 4.48509349200009],
            [8.926036004000082, 4.52960846600007],
            [8.935720248000052, 4.553290106000077],
            [8.913584832000083, 4.528631903000075],
            [8.900563998000052, 4.521633205000057],
            [8.894786004000082, 4.53587474200009],
            [8.897227410000085, 4.548000393000052],
            [8.901540561000047, 4.560248114000046],
            [8.904307488000086, 4.573187567000048],
            [8.901621941000087, 4.587388414000088],
            [8.893809441000087, 4.594631252000056],
            [8.871918165000068, 4.602484442000048],
            [8.864105665000068, 4.618719794000071],
            [8.856293165000068, 4.629950262000079],
            [8.84701582100007, 4.639715887000079],
            [8.83961022200009, 4.642645575000074],
            [8.83570397200009, 4.62962474200009],
            [8.866709832000083, 4.582709052000041],
            [8.873708530000044, 4.560044664000088],
            [8.867849155000044, 4.544582424000055],
            [8.85873457100007, 4.540838934000078],
            [8.850596550000091, 4.547430731000077],
            [8.84701582100007, 4.56321849200009],
            [8.79859459700009, 4.601141669000071],
            [8.798024936000047, 4.588283596000053],
            [8.799489780000044, 4.577785549000055],
            [8.804209832000083, 4.570135809000078],
            [8.812836134000065, 4.566351630000042],
            [8.799571160000085, 4.542181708000044],
            [8.795176629000082, 4.539007880000042],
            [8.78842207100007, 4.541449286000045],
            [8.768565300000091, 4.553127346000053],
            [8.764414910000085, 4.556626695000091],
            [8.757009311000047, 4.56509023600006],
            [8.740570509000065, 4.571234442000048],
            [8.724131707000083, 4.580471096000053],
            [8.71656334700009, 4.597723700000074],
            [8.705902540000068, 4.634670315000051],
            [8.661306186000047, 4.698797919000071],
            [8.655121290000068, 4.738267320000091],
            [8.638682488000086, 4.713080145000049],
            [8.645355665000068, 4.684068101000094],
            [8.660492384000065, 4.653998114000046],
            [8.685720248000052, 4.561224677000041],
            [8.694834832000083, 4.553290106000077],
            [8.706309441000087, 4.547674872000073],
            [8.71656334700009, 4.539007880000042],
            [8.722666863000086, 4.51312897300005],
            [8.701670769000089, 4.501288153000075],
            [8.576670769000089, 4.491888739000046],
            [8.565440300000091, 4.497259833000044],
            [8.570323113000086, 4.509670315000051],
            [8.582692905000044, 4.523342190000051],
            [8.593760613000086, 4.532782294000071],
            [8.58171634200005, 4.538478908000059],
            [8.570567254000082, 4.538560289000088],
            [8.562673373000052, 4.533189195000091],
            [8.55640709700009, 4.511704820000091],
            [8.548350457000083, 4.507798570000091],
            [8.537364129000082, 4.50853099200009],
            [8.525563998000052, 4.511704820000091],
            [8.510264519000089, 4.527044989000046],
            [8.505056186000047, 4.550930080000057],
            [8.509938998000052, 4.568833726000094],
            [8.525563998000052, 4.566351630000042],
            [8.530772332000083, 4.579250393000052],
            [8.55209394600007, 4.614732164000088],
            [8.538340691000087, 4.604641018000052],
            [8.525726759000065, 4.604437567000048],
            [8.516123894000089, 4.612982489000046],
            [8.511241082000083, 4.629055080000057],
            [8.513682488000086, 4.642320054000038],
            [8.52116946700005, 4.655951239000046],
            [8.538584832000083, 4.676214911000045],
            [8.567637566000087, 4.695990302000041],
            [8.573252800000091, 4.704087632000039],
            [8.57357832100007, 4.716376044000071],
            [8.56967207100007, 4.728338934000078],
            [8.567637566000087, 4.740220445000091],
            [8.573252800000091, 4.752508856000077],
            [8.580088738000086, 4.745062567000048],
            [8.576508009000065, 4.784654039000088],
            [8.578379754000082, 4.804673570000091],
            [8.590017123000052, 4.813381252000056],
            [8.594167514000048, 4.815293687000064],
            [8.595113159000107, 4.815314433000125],
            [8.612166382000055, 4.831876729000044],
            [8.608445679000027, 4.84621693900003],
            [8.605448445000121, 4.86004038500009],
            [8.602244506000147, 4.881331075000077],
            [8.611029501000132, 4.896653137000044],
            [8.638314656000148, 4.916781108000094],
            [8.64441247500011, 4.934867859000107],
            [8.683686564000084, 4.996879578000062],
            [8.683686564000084, 4.997034607000018],
            [8.698569376000108, 5.01780853300005],
            [8.707871134000044, 5.037548930000114],
            [8.722650594000072, 5.081189677000069],
            [8.728851765000059, 5.094548035000102],
            [8.748282104000026, 5.12421030700007],
            [8.758307332000044, 5.134881490000069],
            [8.769469442000087, 5.139945781000037],
            [8.781251668000095, 5.141987],
            [8.791690307000124, 5.146741232000082],
            [8.798925008000083, 5.159634502000088],
            [8.825693400000148, 5.295491842000104],
            [8.82465987100008, 5.30613718700009],
            [8.816391642000042, 5.33029591900015],
            [8.81525476100012, 5.343499247000054],
            [8.821662638000078, 5.367683817000113],
            [8.843160034000107, 5.409980977000103],
            [8.849774618000112, 5.432356873000089],
            [8.849257853000069, 5.453466695000117],
            [8.845743855000109, 5.47279368100007],
            [8.844296915000115, 5.49235321000009],
            [8.85049808700009, 5.514005636000078],
            [8.865484253000062, 5.533461813000059],
            [8.884294474000086, 5.551445211000043],
            [8.899487345000097, 5.570953064000136],
            [8.90393151900011, 5.595085958000098],
            [8.893699585000121, 5.621750997000049],
            [8.874889363000136, 5.6414397180001],
            [8.852565145000057, 5.658673808000074],
            [8.832411336000092, 5.678155823000068],
            [8.819285522000115, 5.703451437000055],
            [8.826933635000103, 5.717817485000054],
            [8.8446069740001, 5.730865783000098],
            [8.862176961000074, 5.752337342000118],
            [8.866621135000088, 5.777452087000057],
            [8.857836141000092, 5.794892883000088],
            [8.847087443000078, 5.810757548000097],
            [8.845227091000083, 5.831040548000104],
            [8.855872437000073, 5.847499492000082],
            [8.891219116000059, 5.871115621000101],
            [8.904654988000118, 5.888117167000118],
            [8.921708211000066, 5.904472758000068],
            [8.943205607000095, 5.901423849000125],
            [8.965013061000121, 5.893594869000111],
            [8.982686401000109, 5.895765280000091],
            [8.986303752000111, 5.908813578000135],
            [8.988474162000102, 5.937287292000079],
            [8.993848511000067, 5.944082743000124],
            [9.0098682040001, 5.95235097300008],
            [9.022477254000137, 5.965812683000124],
            [9.043871297000038, 5.996689352000118],
            [9.043871297000038, 5.996844381000059],
            [9.136165405000014, 6.092523295000063],
            [9.273314657000071, 6.202774964000113],
            [9.298842814000125, 6.238431701000096],
            [9.327368205000084, 6.298505554000116],
            [9.341010783000087, 6.313982646000042],
            [9.354756713000114, 6.32150156700007],
            [9.366538940000112, 6.322690125000094],
            [9.37914799000012, 6.321604920000098],
            [9.394960978000142, 6.322535095000148],
            [9.42286625200012, 6.339355774000126],
            [9.453148641000041, 6.397672628000066],
            [9.482604207000065, 6.415991923000135],
            [9.488590226000099, 6.418208095000097],
            [9.52859623200004, 6.43301930800007],
            [9.54895674700009, 6.44317372600004],
            [9.564769735000084, 6.458599142000125],
            [9.588127482000118, 6.502730814000117],
            [9.603010294000057, 6.515184835000099],
            [9.632672567000043, 6.521153463000118],
            [9.644805968000128, 6.521225530000038],
            [9.680524943000108, 6.521437683000102],
            [9.693030640000131, 6.531307882000078],
            [9.69397999000006, 6.534304786000064],
            [9.769821818000082, 6.773722026000144],
            [9.788528686000063, 6.794754334000061],
            [9.812299845000041, 6.793049011000093],
            [9.831730184, 6.783566386000118],
            [9.8511605220001, 6.777881978000082],
            [9.874621623000053, 6.787700500000142],
            [10.119464559000079, 6.99440623000001],
            [10.14292565900007, 7.007687073000113],
            [10.156878296000059, 7.004741516000109],
            [10.165043172000082, 6.988515117000105],
            [10.179409220000082, 6.91492787700011],
            [10.1898478600001, 6.895445862000116],
            [10.210828491000115, 6.879167786000096],
            [10.238423706000106, 6.871002910000072],
            [10.495979045000098, 6.87467193600007],
            [10.496599161000063, 6.89715118400008],
            [10.50073327600009, 6.912809144000036],
            [10.508898153000104, 6.926348369000024],
            [10.521197144000041, 6.942781474000085],
            [10.52750166800007, 6.947484029000066],
            [10.533186076000106, 6.94882761700012],
            [10.537423543000045, 6.952134908000119],
            [10.543314656000064, 7.02871938100013],
            [10.551789591000045, 7.066339824000053],
            [10.56419193500011, 7.102668355000034],
            [10.578661336000067, 7.130832011000081],
            [10.597161499000094, 7.107267558000075],
            [10.602535848000059, 7.058071595000101],
            [10.620622599000058, 7.04375722200011],
            [10.646977580000112, 7.035075582000061],
            [10.716947469000047, 6.998126933000023],
            [10.799112996000048, 6.967327779000058],
            [10.831875854000145, 6.945210266000046],
            [10.848205607000097, 6.905316061000093],
            [10.857404012000103, 6.85978912400013],
            [10.877454467000035, 6.81609670000006],
            [10.909390503000111, 6.784264018000016],
            [11.002614787000141, 6.767262471000095],
            [11.036721232000104, 6.740545757000035],
            [11.055944865000129, 6.700367330000105],
            [11.059045451000088, 6.652721659000065],
            [11.057391804000133, 6.613008321000081],
            [11.060595744000096, 6.573966777000066],
            [11.077442261000073, 6.496736348000084],
            [11.097079305000108, 6.44911651700005],
            [11.113512410000084, 6.434001160000136],
            [11.140384155000078, 6.430280456000034],
            [11.202276467000104, 6.436739242000016],
            [11.231748087000113, 6.439814759000029],
            [11.237122437000068, 6.438057759000046],
            [11.248284546000093, 6.431003927000035],
            [11.255519247000052, 6.429970398000052],
            [11.261513713000085, 6.432554220000057],
            [11.272159058000085, 6.442036845000118],
            [11.275879761000084, 6.444207255000023],
            [11.28683516500007, 6.443225403000056],
            [11.308539266000082, 6.437902731000094],
            [11.31949467000004, 6.437282613000122],
            [11.344196004000139, 6.443122050000028],
            [11.369827515000111, 6.45575693800015],
            [11.389361206000046, 6.473921204000092],
            [11.395665731000037, 6.496736348000084],
            [11.401763550000084, 6.538180848000053],
            [11.416749715000066, 6.572003073000133],
            [11.443104695000045, 6.593267924000116],
            [11.482585490000048, 6.597169495000074],
            [11.509767294000142, 6.612310689000083],
            [11.533435099000087, 6.645099386000098],
            [11.56237390100003, 6.712485454000017],
            [11.568885132000105, 6.739098816000137],
            [11.571468954000096, 6.766228943000016],
            [11.5666113690001, 6.78418650400009],
            [11.544597209000102, 6.808939515000105],
            [11.53808597800014, 6.823899841000085],
            [11.543667033000048, 6.850694071000063],
            [11.561753784000075, 6.876067200000051],
            [11.623248739000076, 6.932291158000041],
            [11.681126343000102, 6.968619690000097],
            [11.684847046000101, 6.97383901000012],
            [11.688464396000086, 6.986913147000067],
            [11.6924951580001, 6.991615703000136],
            [11.697249389000092, 6.992855937000087],
            [11.70748132400007, 6.991822408000104],
            [11.718643433000096, 6.994457906000122],
            [11.734249715000118, 6.995078024000094],
            [11.741071004000077, 6.997506815000051],
            [11.746858764000052, 7.005361634000081],
            [11.748615764000135, 7.014973450000099],
            [11.751509643000134, 7.023965149000048],
            [11.766392456000062, 7.033525289000039],
            [11.808870484000096, 7.071920878000071],
            [11.820342651000118, 7.078793843000128],
            [11.833985230000053, 7.082979635000072],
            [11.845147339000079, 7.081946106000089],
            [11.854139038000113, 7.077811992000065],
            [11.862613973000123, 7.075434876000116],
            [11.872225789000112, 7.079362284000084],
            [11.881320842000093, 7.102048239000055],
            [11.868918497000038, 7.127111308000067],
            [11.82995446800004, 7.169382630000143],
            [11.780241740000122, 7.241057841000028],
            [11.766185750000119, 7.252943421000055],
            [11.742414592000046, 7.257439270000077],
            [11.73662683100008, 7.263278707000069],
            [11.744585001000132, 7.272167054000079],
            [11.762465047000092, 7.285551249000108],
            [11.782722209000099, 7.304516500000062],
            [11.84473392700005, 7.396397197000042],
            [11.903545283000057, 7.453556830000068],
            [11.966173543000139, 7.514426168000099],
            [11.992838582000104, 7.554010315000056],
            [12.008548217000055, 7.564862366000099],
            [12.021053915000067, 7.576231181000097],
            [12.024981323000134, 7.596591696000118],
            [12.010718628000063, 7.655244446000069],
            [12.009064982000098, 7.676328430000083],
            [12.012165568000057, 7.69834259100007],
            [12.018986857000101, 7.718858134000044],
            [12.054953654000087, 7.783918763000116],
            [12.15427575700005, 7.921326396000055],
            [12.19210290600003, 7.960652161000041],
            [12.197787313000077, 7.975173239000085],
            [12.195100138000043, 7.991709696000086],
            [12.18817549600007, 8.016256002000148],
            [12.182697795000081, 8.05465159100008],
            [12.182594442000067, 8.093486430000041],
            [12.188278849000085, 8.11777435300013],
            [12.229103231000096, 8.175496928000115],
            [12.233713188000138, 8.188454644000032],
            [12.236751343000066, 8.196994324000059],
            [12.237681518000016, 8.216889750000064],
            [12.221765177000094, 8.297660014000101],
            [12.219284709000107, 8.343161112000075],
            [12.227036173000045, 8.386310934000093],
            [12.249980510000057, 8.41876373300002],
            [12.271787964000083, 8.427781271000072],
            [12.310235229000028, 8.42134755500011],
            [12.331319214000075, 8.42429311200003],
            [12.343204793000098, 8.432742208000107],
            [12.35116296300015, 8.444240214000047],
            [12.357570842000086, 8.456358338000129],
            [12.365115601000042, 8.466564433000102],
            [12.395191284000106, 8.487338359000134],
            [12.403872925000087, 8.496536764000055],
            [12.403252808000104, 8.524235332000075],
            [12.400462280000056, 8.538420512000116],
            [12.377001180000065, 8.595109559000122],
            [12.36883630400007, 8.609578960000064],
            [12.396328166000046, 8.60076812800007],
            [12.410590861000088, 8.59849436500005],
            [12.424440145000062, 8.599786275000099],
            [12.440253133000056, 8.606607565000061],
            [12.45182865400011, 8.614694926000055],
            [12.464334350000115, 8.6211544800001],
            [12.482524454000043, 8.62324737600008],
            [12.49554691500009, 8.619552510000076],
            [12.52779300900005, 8.604850565000078],
            [12.542572469000078, 8.602008362000106],
            [12.557972046000145, 8.605677389000093],
            [12.660394735000068, 8.65931752600008],
            [12.678171428000098, 8.678696187000043],
            [12.692847534000094, 8.710890605000088],
            [12.70163252800009, 8.739157613000074],
            [12.708867228000145, 8.75091400100007],
            [12.720236043000028, 8.756469218000078],
            [12.734498738000099, 8.755900777000107],
            [12.747211141000065, 8.753627014000102],
            [12.759613484000027, 8.753420309000134],
            [12.772946004000062, 8.75905303900008],
            [12.794546753000134, 8.788611959000107],
            [12.805708862000074, 8.831503397000063],
            [12.828239787000086, 9.019967346000072],
            [12.821005086000099, 9.056425070000074],
            [12.82214196800004, 9.096810201000054],
            [12.842192424000075, 9.144430033000077],
            [12.888391154000118, 9.226724752000052],
            [12.894592326000094, 9.243958842000026],
            [12.89841638200005, 9.26243316600005],
            [12.899346557000086, 9.302017314000096],
            [12.891285034000106, 9.33198964500005],
            [12.881569865000074, 9.35222096800004],
            [12.853147827000043, 9.356639303000051],
            [12.848393595000061, 9.35994659500004],
            [12.855421590000077, 9.378110860000078],
            [12.86203617300015, 9.382890931000077],
            [12.92074060100012, 9.410486146000068],
            [12.929008830000072, 9.416118877000102],
            [12.940067586000055, 9.427100119000087],
            [12.96900638800011, 9.464074605000036],
            [12.982442261000074, 9.474590759000094],
            [13.051688680000098, 9.50451141400012],
            [13.130340210000071, 9.516526184000085],
            [13.195452515000056, 9.54220937100007],
            [13.223461141000058, 9.613135275000033],
            [13.228422078000108, 9.677911682000044],
            [13.241341187000017, 9.745323588000048],
            [13.251056356000078, 9.769249777000056],
            [13.260461467000113, 9.78570872000003],
            [13.26294193600009, 9.80172841500007],
            [13.251986531000114, 9.82423350000009],
            [13.222944376000044, 9.854128316000114],
            [13.212712443000044, 9.870148010000065],
            [13.211058798000096, 9.892756449000018],
            [13.218706909000076, 9.913039449000024],
            [13.242271362000082, 9.949755554000092],
            [13.24640547700011, 9.973475037000043],
            [13.242478068000139, 9.992672831000064],
            [13.230489136000074, 10.025358175000036],
            [13.230179077000088, 10.045331116000071],
            [13.247955770000118, 10.07941172300012],
            [13.281338745000085, 10.09209828700007],
            [13.359783569000115, 10.100547384000066],
            [13.378387085000071, 10.108608907000061],
            [13.392671966000108, 10.116957418000084],
            [13.401951538000077, 10.122380677000095],
            [13.423242229000039, 10.138477886000075],
            [13.434921102000118, 10.153412374000126],
            [13.45083744300004, 10.187157084000091],
            [13.453007853000116, 10.20051544200004],
            [13.451354207000094, 10.212116801000079],
            [13.44453291800005, 10.232477315000025],
            [13.444842976000103, 10.245473938000131],
            [13.467167196000077, 10.307589010000115],
            [13.50127364100004, 10.496337179000108],
            [13.53879073000013, 10.621419983000095],
            [13.566282593000011, 10.679013367000039],
            [13.744411254000113, 10.930496725000069],
            [13.749838822000129, 10.942441823000138],
            [13.757020304000037, 10.9582469690001],
            [13.75040572100005, 10.99620330800012],
            [13.754849894000131, 11.016718852000096],
            [13.765908650000142, 11.033901265000068],
            [13.78203169800014, 11.047518006000061],
            [13.820065552000074, 11.069273783000071],
            [13.83205448400011, 11.084802551000095],
            [13.849211059000083, 11.124567566000096],
            [13.87318892400009, 11.166502991000087],
            [13.906261841000088, 11.208025004000078],
            [13.943882284000097, 11.245722962000116],
            [13.98232954900007, 11.276263733000107],
            [14.01312870300012, 11.27636708600005],
            [14.05250614400012, 11.265153300000094],
            [14.12257938600007, 11.235723572000012],
            [14.143249959000087, 11.232726338000091],
            [14.165470826000103, 11.238333232000102],
            [14.186761515000086, 11.249236959000072],
            [14.204641561000074, 11.262130229000078],
            [14.232133423000022, 11.290293884000036],
            [14.244329061000144, 11.295435690000119],
            [14.271304158000078, 11.298639628000089],
            [14.279158976000105, 11.301843567000063],
            [14.36824914600001, 11.383001404000112],
            [14.38705936600013, 11.393388367000043],
            [14.446280558000097, 11.411681824000112],
            [14.467261190000102, 11.423851624000108],
            [14.503951456000095, 11.456304424000038],
            [14.524932088000071, 11.468835958000042],
            [14.57660852100011, 11.48733612100007],
            [14.593765096000084, 11.496431173000133],
            [14.605754029000138, 11.514724630000018],
            [14.616192667000092, 11.538676656000106],
            [14.623840780000052, 11.563481344000053],
            [14.627561483000079, 11.584358623000128],
            [14.62714807100005, 11.60968007400001],
            [14.621360311000075, 11.629782206000073],
            [14.61019820100006, 11.646835429000106],
            [14.593868449000098, 11.663010152000098],
            [14.588597452000073, 11.6696764120001],
            [14.58508345600012, 11.676807760000145],
            [14.580949341000093, 11.683267314000105],
            [14.573507935000094, 11.6877114870001],
            [14.556454712000061, 11.687504781000058],
            [14.552423950000048, 11.689003398000068],
            [14.543328898000084, 11.701095683000048],
            [14.54188195800009, 11.709829000000113],
            [14.546532837000143, 11.718613993000105],
            [14.583223104000126, 11.766363017000074],
            [14.590664510000039, 11.783157857000049],
            [14.612058553000054, 11.884960429000103],
            [14.623427368000137, 11.916534729000077],
            [14.62714807100005, 11.950072734000088],
            [14.626941365000107, 11.957204082000132],
            [14.625184367000116, 11.968107809000088],
            [14.606270792000089, 12.011257629000028],
            [14.604307088000041, 12.030429586000125],
            [14.622187133000097, 12.042005106000076],
            [14.619913370000091, 12.052495423000025],
            [14.637173299000068, 12.124222311000025],
            [14.6431677650001, 12.135849508000078],
            [14.648128703000054, 12.141843974000011],
            [14.650609172000117, 12.148096822000099],
            [14.66993615700008, 12.167423808000052],
            [14.668282512000133, 12.178069153000138],
            [14.663424927000108, 12.18757761700003],
            [14.651539348000085, 12.193778789000106],
            [14.6431677650001, 12.19062652600006],
            [14.629318481000041, 12.183495179000118],
            [14.616296020000107, 12.178947652000076],
            [14.61061161300006, 12.183546855000131],
            [14.604100382000098, 12.204320781000078],
            [14.588287394000105, 12.217188213000071],
            [14.568133585000112, 12.22773020400004],
            [14.548496541000077, 12.241579488000099],
            [14.558315063000066, 12.246902161000051],
            [14.562139120000097, 12.248400778000061],
            [14.562139120000097, 12.255842184000073],
            [14.551183715000036, 12.260441386000124],
            [14.521521444000143, 12.28235219300008],
            [14.514390096000113, 12.28938018800008],
            [14.512426391000076, 12.2986302690001],
            [14.517594035000087, 12.313358053000101],
            [14.514390096000113, 12.323538310000075],
            [14.48710493900009, 12.33780100600005],
            [14.423129516000131, 12.353148906000115],
            [14.217560669000079, 12.359298402000078],
            [14.202161092000097, 12.362502340000063],
            [14.188931925000077, 12.370408834000102],
            [14.179836873000113, 12.385601705000042],
            [14.179113403000116, 12.397280579000011],
            [14.185107870000138, 12.427873027000118],
            [14.18541792800005, 12.447044983000126],
            [14.180216224000048, 12.463530383000062],
            [14.178699992000105, 12.468335673000112],
            [14.177356404000136, 12.545591940000094],
            [14.121132446000075, 12.811790161500085],
            [14.0649084880001, 13.077988383000061],
            [14.418168579000081, 13.081140646000023],
            [14.435428507000069, 13.070288595000065],
            [14.481040720000067, 13.00050796300009],
            [14.48214400200007, 12.998820089000048],
            [14.496303345000115, 12.983808085000064],
            [14.504674927000082, 12.969002788000054],
            [14.507672159000094, 12.952440491000047],
            [14.506121867000076, 12.932079977000114],
            [14.49061893700005, 12.88634633400008],
            [14.49010217300011, 12.873608094000119],
            [14.500437459000125, 12.859112854000088],
            [14.531029907000033, 12.83624603300008],
            [14.54901330600012, 12.81821095800008],
            [14.54901330600012, 12.78046132400003],
            [14.551080363000096, 12.771572978000094],
            [14.554801066000095, 12.766896261000042],
            [14.560692179000085, 12.766224467000143],
            [14.569373820000067, 12.769402568000103],
            [14.569373820000067, 12.759609884000056],
            [14.570717407000132, 12.750385641000051],
            [14.575264933000142, 12.744907939000058],
            [14.584876749000074, 12.746354879000052],
            [14.603997029000055, 12.76079844200008],
            [14.61061161300006, 12.762348735000089],
            [14.618363078000073, 12.759196472000042],
            [14.620326782000092, 12.754054667000048],
            [14.62074019400012, 12.747853495000058],
            [14.624254191000063, 12.741884867000039],
            [14.641720826000011, 12.730903626000057],
            [14.648128703000054, 12.725115865000078],
            [14.664458455000101, 12.715969136000098],
            [14.694017375000044, 12.7237206020001],
            [14.709933716000137, 12.718242900000106],
            [14.716755005000095, 12.701809795000145],
            [14.70207889800011, 12.66899526000013],
            [14.71365441900005, 12.652510478000053],
            [14.72884729000009, 12.677211812000067],
            [14.734118286000125, 12.68041575100004],
            [14.743316691000103, 12.677160136000055],
            [14.75210168400011, 12.66894358300003],
            [14.758716268000114, 12.658815003000072],
            [14.76140344300012, 12.649358216000095],
            [14.768844849000061, 12.633235168000112],
            [14.786208130000063, 12.631219788000067],
            [14.819177694000132, 12.638816223000035],
            [14.830753214000083, 12.618249003000045],
            [14.863826131000053, 12.495465800000076],
            [14.860105428000054, 12.490091451000112],
            [14.852043905000073, 12.474691875000133],
            [14.85018355300005, 12.468128968000059],
            [14.849563436000096, 12.457018534000042],
            [14.85101037600009, 12.455158183000037],
            [14.855454549000086, 12.454538066000069],
            [14.863826131000053, 12.447044983000126],
            [14.86186242700012, 12.452005920000076],
            [14.865893188000115, 12.452574361000117],
            [14.872404419000105, 12.450403952000045],
            [14.877468709000084, 12.447044983000126],
            [14.878502238000067, 12.443065897000054],
            [14.876848592000101, 12.431593730000117],
            [14.877468709000084, 12.427201233000034],
            [14.8912146400001, 12.40265492800006],
            [14.908267863000049, 12.326897278000075],
            [14.906304159000115, 12.317957255000053],
            [14.904857219000121, 12.248400778000061],
            [14.903100219000123, 12.23625681600005],
            [14.89803592900006, 12.21946197600009],
            [14.89803592900006, 12.207473043000036],
            [14.900929809000047, 12.200031636000105],
            [14.905890747000086, 12.195639140000111],
            [14.910128214000054, 12.19036814400009],
            [14.911575154000047, 12.1801362100001],
            [14.90744104, 12.173469950000097],
            [14.899896281000053, 12.171764629000037],
            [14.894831990000085, 12.167372131000135],
            [14.89803592900006, 12.152799377000079],
            [14.903100219000123, 12.145874736000096],
            [14.928731730000095, 12.128614807000105],
            [14.950745890000093, 12.10334503200005],
            [14.964801879000106, 12.09244130500008],
            [14.976790812000047, 12.094146627000043],
            [14.99384403500008, 12.10670400000015],
            [15.011827433000065, 12.108616028000071],
            [15.03043094900005, 12.100916239000085],
            [15.049447876000102, 12.084586487000138],
            [15.044590292000066, 12.078385316000066],
            [15.040869589000067, 12.06758494100012],
            [15.040559529000092, 12.055647685000082],
            [15.045727173000074, 12.046087545000077],
            [15.053065226000086, 12.038026022000096],
            [15.05368534300004, 12.031876526000119],
            [15.051204875000082, 12.02422841400005],
            [15.049447876000102, 12.011929423000097],
            [15.059679809000073, 11.997304993000029],
            [15.07683638500012, 11.9828355920001],
            [15.081177205000103, 11.97167348300006],
            [15.052548462000033, 11.96722930900006],
            [15.048310995000094, 11.96278513600005],
            [15.050584758000099, 11.952863261000061],
            [15.055545695000148, 11.94247629800013],
            [15.059369751000105, 11.936791891000084],
            [15.0634005120001, 11.927283427000106],
            [15.056579224000131, 11.918446757000098],
            [15.046967408000114, 11.91017852800006],
            [15.042006469000086, 11.902375387000035],
            [15.044176880000066, 11.877312317000118],
            [15.05099816900011, 11.861602681000065],
            [15.062780396000107, 11.853489482000057],
            [15.079833618000066, 11.851215719000038],
            [15.086344848000124, 11.840467021000023],
            [15.110942831000102, 11.782899476000068],
            [15.10536177600008, 11.772719219000109],
            [15.089135376000087, 11.757629700000109],
            [15.083554321000065, 11.748172913000133],
            [15.08531132000013, 11.744038798000105],
            [15.09595666500013, 11.73411692300003],
            [15.097196899000068, 11.72765736900007],
            [15.093062785000143, 11.722903137000074],
            [15.086344848000124, 11.72217966800008],
            [15.079833618000066, 11.722593079000092],
            [15.076112915000039, 11.72145619700008],
            [15.068258097000097, 11.700113831000081],
            [15.06650109900005, 11.680631816000087],
            [15.069394979000037, 11.660788066000094],
            [15.085207967000116, 11.615881246000086],
            [15.095749959000074, 11.598156230000072],
            [15.123861938000118, 11.563171285000067],
            [15.135644165000116, 11.53082183800008],
            [15.122311645000082, 11.503226624000078],
            [15.076112915000039, 11.453307190000118],
            [15.067017863000075, 11.4355563350001],
            [15.060609985000042, 11.416125997000023],
            [15.054305461000126, 11.364087829000084],
            [15.049447876000102, 11.348714091000105],
            [15.049447876000102, 11.337267762000096],
            [15.052548462000033, 11.329800517000066],
            [15.057819458000068, 11.325356344000056],
            [15.062263631000093, 11.320033671000104],
            [15.063090454000104, 11.30993092900006],
            [15.056372517000085, 11.293420309000084],
            [15.033324829000037, 11.26026987700007],
            [15.028260539000144, 11.244482727000076],
            [15.021232544000043, 11.182548523000051],
            [15.028830281000126, 11.08021826600013],
            [15.035185181000116, 10.994627177000098],
            [15.062470336000047, 10.930703430000037],
            [15.072702270000036, 10.915768941000067],
            [15.079006795000026, 10.898147278000081],
            [15.07559615000011, 10.87349762000008],
            [15.063090454000104, 10.830761210000077],
            [15.065880981000078, 10.79311492900004],
            [15.14225874900012, 10.647206523000094],
            [15.149906860000101, 10.623125305000059],
            [15.148459920000107, 10.607338155000065],
            [15.13843469200009, 10.589690654000066],
            [15.132336873000014, 10.565402731000077],
            [15.13171675600006, 10.54070139600006],
            [15.138227986000118, 10.52165863100008],
            [15.144429158000094, 10.516310120000128],
            [15.1536275630001, 10.511969300000146],
            [15.1646863200001, 10.50907541900007],
            [15.176055135000098, 10.507990214000074],
            [15.186597127000056, 10.505871480000096],
            [15.193315063000085, 10.501194764000033],
            [15.19817264800011, 10.49649220800005],
            [15.218326457000074, 10.487216288000127],
            [15.227214803000095, 10.470137228000084],
            [15.241167440000083, 10.432904358000073],
            [15.255636841000126, 10.417039693000063],
            [15.268762655000074, 10.40634267200005],
            [15.278374471000092, 10.39427622500007],
            [15.282198527000048, 10.374587504000118],
            [15.28426558400011, 10.34929189100005],
            [15.2905701090001, 10.328983053000044],
            [15.301422160000072, 10.311748963000056],
            [15.439191528000094, 10.185245057000074],
            [15.476398560000092, 10.132741801000108],
            [15.490661255000077, 10.124447734000057],
            [15.49014449000012, 10.120106913000086],
            [15.536136515000123, 10.08052276600003],
            [15.60279911300006, 10.04099029600009],
            [15.637939087000092, 10.029957378000091],
            [15.681243937000147, 9.991277568000072],
            [15.663777303000103, 9.986109924000075],
            [15.439398234000066, 9.931694641000092],
            [15.382967570000119, 9.930196025000086],
            [15.214915812000072, 9.984094543000126],
            [15.155487915, 9.98652333600009],
            [15.109599244000037, 9.981536560000038],
            [15.100710897000113, 9.978901062000105],
            [15.089445435000073, 9.97218312600009],
            [15.071668742000043, 9.955956726000082],
            [15.06123010200011, 9.949238790000052],
            [15.033014770000136, 9.942856751000122],
            [15.002422323000104, 9.945052999000026],
            [14.944131307000077, 9.958824768000056],
            [14.898139282000074, 9.960478414000107],
            [14.77256555200006, 9.92174692800009],
            [14.732464640000074, 9.923813985000052],
            [14.440492798000037, 9.995308329000068],
            [14.196340538000072, 9.979146894000024],
            [14.181697225000022, 9.978177593000026],
            [14.173532348000094, 9.975025329000061],
            [14.171155232000075, 9.967609762000052],
            [14.170638468000107, 9.95784291600009],
            [14.168364705000101, 9.947740174000046],
            [14.119788859000096, 9.85200958300004],
            [14.088472941000106, 9.809634909000124],
            [14.006720825000087, 9.739277446000102],
            [13.945949340000084, 9.652641907000074],
            [13.947602987000039, 9.637759094000032],
            [14.03648645000007, 9.568771057000077],
            [14.321326945000067, 9.243157858000103],
            [14.331145467000027, 9.200214743000046],
            [14.349542277000126, 9.168356221000082],
            [14.571699259500036, 8.990989787000089],
            [14.79385624200006, 8.813623353000096],
            [14.809875936000111, 8.808610738000127],
            [14.819177694000132, 8.811607971000058],
            [14.82796268700011, 8.81315826500007],
            [14.836747680000116, 8.81300323500004],
            [14.846049438000136, 8.81098785400009],
            [14.859898722000082, 8.803313904000092],
            [14.899379516000124, 8.77432342500012],
            [14.908267863000049, 8.764840800000044],
            [14.913332153000113, 8.752438457000082],
            [14.9199467360001, 8.747710063000085],
            [14.927284790000101, 8.745074565000081],
            [14.934416137000142, 8.739002584000033],
            [14.940100545000092, 8.729649149000082],
            [14.949092244000042, 8.704276022000087],
            [14.95146936000009, 8.692106222000078],
            [14.95146936000009, 8.68283030200007],
            [14.955086710000074, 8.67621571900007],
            [14.968522583, 8.67215911900007],
            [15.00583296700006, 8.666629741000065],
            [15.03125777200006, 8.65874908500011],
            [15.051928345000078, 8.643788758000056],
            [15.068568155000094, 8.623867493000134],
            [15.110736124000141, 8.555137838000064],
            [15.168510376000143, 8.498603821000103],
            [15.183703247000068, 8.479147644000122],
            [15.21070621600009, 8.421822448000057],
            [15.345347127000082, 8.135990296000088],
            [15.406532023000125, 7.921584778000124],
            [15.440741821000103, 7.83941925100001],
            [15.487870727000114, 7.804951071000048],
            [15.509368123000058, 7.804020895000079],
            [15.540787394000091, 7.796837870000033],
            [15.562904907000103, 7.792445374000039],
            [15.562181437000106, 7.690177714000058],
            [15.548952271000104, 7.630801493000121],
            [15.521977173000096, 7.576076151000052],
            [15.48104943900006, 7.523262838000093],
            [15.473297973000058, 7.509103496000051],
            [15.41945113100013, 7.436549785000039],
            [15.415523722000074, 7.420840150000075],
            [15.434954060000052, 7.402908427000099],
            [15.432783651000136, 7.38973093700011],
            [15.42844283000008, 7.38880076100007],
            [15.409632609000056, 7.387663880000062],
            [15.403224731000108, 7.386371968000105],
            [15.397436971000047, 7.380739237000071],
            [15.389168741000105, 7.364151103000069],
            [15.385344686000053, 7.358363342000089],
            [15.338215779000052, 7.322189840000064],
            [15.261321248000058, 7.279246725000093],
            [15.246563660000078, 7.26673131200009],
            [15.223907511000107, 7.247517395000074],
            [15.205097290000083, 7.200233460000035],
            [15.191248006000109, 7.177340801000113],
            [15.186597127000056, 7.166333720000111],
            [15.185356893000119, 7.156876933000149],
            [15.19021447700004, 7.098792623000065],
            [15.18752730300011, 7.088612365000102],
            [15.1790523680001, 7.078380432000117],
            [15.156108032000077, 7.067786764000047],
            [15.147012980000113, 7.061843974000041],
            [15.136160930000074, 7.045307516000136],
            [15.128926229000086, 7.026497294000123],
            [15.113216594000022, 6.964692282000044],
            [15.080247029000077, 6.878082581000101],
            [15.059059693000108, 6.836276347000137],
            [15.042213176000132, 6.790775248000074],
            [15.03456506300006, 6.776770935000073],
            [15.022369425000136, 6.766539002000087],
            [14.962321411000119, 6.73669586200009],
            [14.946095011000125, 6.725740459000107],
            [14.932452434000112, 6.710289205000024],
            [14.92187418000006, 6.686413886000054],
            [14.807292114000091, 6.427799988000061],
            [14.782177368000077, 6.393616028000068],
            [14.780006958000087, 6.382221374000068],
            [14.784347778000068, 6.358682760000079],
            [14.784657837000054, 6.347804871000022],
            [14.78238407400005, 6.336771952000035],
            [14.772255493000074, 6.318323466000024],
            [14.734841756000037, 6.270445251000098],
            [14.719028768000015, 6.257862041000081],
            [14.576401814000064, 6.189778341000078],
            [14.534957316000117, 6.190088399000075],
            [14.525965617000054, 6.174068706000114],
            [14.510979451000082, 6.15533599900003],
            [14.48214400200007, 6.127068991000044],
            [14.467054484000073, 6.122598979000131],
            [14.443903442000078, 6.100248922000063],
            [14.430570922000129, 6.088079122000053],
            [14.431811157000084, 6.084616801000024],
            [14.43270924500004, 6.079122618000085],
            [14.433568156000149, 6.073868103000095],
            [14.429123982000135, 6.064178772000062],
            [14.426023397000108, 6.05986379000008],
            [14.422509400000138, 6.051363017000071],
            [14.418168579000081, 6.047125550000118],
            [14.412897583000131, 6.047022197000089],
            [14.402458944000102, 6.054877014000041],
            [14.39770471200012, 6.053946838000073],
            [14.390263306000094, 6.045781963000067],
            [14.387266072000074, 6.039038188000035],
            [14.389436482000065, 6.031054179000066],
            [14.39770471200012, 6.019168600000029],
            [14.406076294000087, 6.011029561000029],
            [14.417548462000099, 5.99725779200007],
            [14.432327922000127, 5.985449727000073],
            [14.44690067500008, 5.970024313000081],
            [14.45382531800007, 5.953875428000089],
            [14.458166137000148, 5.936408793000041],
            [14.465710897000093, 5.920673319000073],
            [14.48214400200007, 5.909640401000075],
            [14.499197225000103, 5.909537049000051],
            [14.530616495000118, 5.905919698000062],
            [14.54539595600005, 5.907573344000099],
            [14.572474406000111, 5.924187317000118],
            [14.58477339600006, 5.923412170000105],
            [14.598002563000136, 5.903490906000101],
            [14.60296350100009, 5.883388774000124],
            [14.617432902000104, 5.864966125000123],
            [14.62404748500012, 5.758305970000052],
            [14.631075480000021, 5.738048808000144],
            [14.624357544000105, 5.72360524500003],
            [14.61061161300006, 5.66913828600012],
            [14.592834920000115, 5.623869731000113],
            [14.590147746000099, 5.60828928700009],
            [14.591491333000079, 5.590951843000084],
            [14.596555623000143, 5.577231751000056],
            [14.61061161300006, 5.55366729800005],
            [14.617226196000075, 5.537880148000056],
            [14.618879842000098, 5.525451966000077],
            [14.617432902000104, 5.495298767000094],
            [14.614125611000105, 5.48486012800015],
            [14.599552857000049, 5.456644796000091],
            [14.59624556500006, 5.440108338000087],
            [14.597279094000044, 5.411479594000113],
            [14.592834920000115, 5.400033264000101],
            [14.579605754000056, 5.395382385000048],
            [14.57929569500007, 5.387605082000036],
            [14.57082076000006, 5.370939433000103],
            [14.560795532000043, 5.355462341000091],
            [14.555937947000103, 5.351328227000067],
            [14.553974243000084, 5.338228251000103],
            [14.548393188000148, 5.320503235000089],
            [14.539608195000085, 5.303579203000098],
            [14.528032674000116, 5.293011373000127],
            [14.519867797000103, 5.290582580000063],
            [14.523898560000106, 5.279678854000096],
            [14.5397115480001, 5.261798808000052],
            [14.560485473000142, 5.248595480000063],
            [14.603583618000044, 5.234255270000062],
            [14.62446089700012, 5.224049174000086],
            [14.640480590000067, 5.208236186000093],
            [14.651539348000085, 5.187513936000059],
            [14.658877401000069, 5.164543762000022],
            [14.66321822100005, 5.141831970000055],
            [14.663011515000107, 5.091447449000057],
            [14.667455689000093, 5.052767639000052],
            [14.660324341000063, 5.0157931520001],
            [14.660132450000106, 5.011439624000047],
            [14.659497518000137, 4.997034607000018],
            [14.663424927000108, 4.985717468000132],
            [14.669832804000066, 4.977113342000095],
            [14.674483683000119, 4.967579041000107],
            [14.67210656800006, 4.940810649000127],
            [14.675827271000088, 4.930759582000093],
            [14.681615031000149, 4.920941060000132],
            [14.686989380000114, 4.908874614000055],
            [14.701458781000042, 4.814384257000086],
            [14.700631958000116, 4.804281514000124],
            [14.696084432000077, 4.779735209000066],
            [14.69184696400012, 4.768702291000068],
            [14.690710083000113, 4.762139384000079],
            [14.697324667000117, 4.745215353000091],
            [14.7042493080001, 4.669354350000077],
            [14.717271769000149, 4.622018738000108],
            [14.743730102000114, 4.579979961000092],
            [14.7796968990001, 4.545046692000099],
            [14.938343546000112, 4.435931905000061],
            [14.982061808000083, 4.420480652000052],
            [14.993947388000038, 4.413297628000095],
            [15.00056197100011, 4.403194885000062],
            [15.007383260000069, 4.377770080000047],
            [15.013894490000041, 4.364256694000076],
            [15.048517700000048, 4.3216494750001],
            [15.063813924000101, 4.293434143000042],
            [15.072805623000136, 4.265942282000069],
            [15.082934204000082, 4.205506693000046],
            [15.084484497000119, 4.14861094200009],
            [15.091202433000149, 4.121790874000098],
            [15.10257124900005, 4.112411601000048],
            [15.117764119000071, 4.114323629000069],
            [15.132853638000142, 4.108535868000089],
            [15.1392615150001, 4.094583231000101],
            [15.142568807000089, 4.080449728000062],
            [15.148459920000107, 4.0739384970001],
            [15.162412557000096, 4.0739384970001],
            [15.177708781000149, 4.071458028000023],
            [15.189801066000115, 4.063112285000059],
            [15.192074829000148, 4.052234395000099],
            [15.172437785000113, 4.043811137000105],
            [15.150423624000041, 4.038514302000067],
            [15.111252889000099, 4.019936625000113],
            [15.091719198000078, 4.015854187000116],
            [15.075182739000098, 4.017972921000094],
            [15.043143351000083, 4.026137797000018],
            [15.02598677500012, 4.026086120000087],
            [15.08489790800013, 3.885836283000089],
            [15.171300904000105, 3.758970642000108],
            [15.252639608000095, 3.672851868000109],
            [15.2623059310001, 3.662589498000102],
            [15.32974084500006, 3.590996399000076],
            [15.413973429000038, 3.501880392000061],
            [15.517946411000082, 3.391602885000097],
            [15.616855102000073, 3.286777243000117],
            [15.710699503000058, 3.187455139000036],
            [15.785630330000117, 3.107976786000037],
            [15.793175089000073, 3.103274231000057],
            [15.8010299070001, 3.100897115000109],
            [15.813535603000105, 3.098985087000088],
            [15.817566366000108, 3.100121969000014],
            [15.829141886000059, 3.106633199000072],
            [15.834206176000123, 3.108545227000093],
            [15.840200642000042, 3.107408345000081],
            [15.850949340000085, 3.100432027000082],
            [15.854773397000116, 3.098985087000088],
            [15.8977681880001, 3.10353261400013],
            [15.913994588000094, 3.097951559000109],
            [15.93342492700009, 3.081776835000113],
            [15.950064738000094, 3.06100291000007],
            [15.958229614000118, 3.041520894000087],
            [15.971562133000134, 2.991188049000101],
            [15.974249309000072, 2.985762024000039],
            [15.977763306000043, 2.980956116000115],
            [15.982000773000067, 2.976718648000073],
            [15.99543664500004, 2.981472880000069],
            [16.00608199000004, 2.983953349000046],
            [16.015797160000147, 2.983488261000019],
            [16.02623579900009, 2.978992411000092],
            [16.034193969000057, 2.970620829000026],
            [16.05538130700012, 2.939769999000134],
            [16.07016076600013, 2.906593730000026],
            [16.082459757000066, 2.885664775000038],
            [16.09238163300006, 2.863288880000056],
            [16.095172160000118, 2.836778869000057],
            [16.08690393100008, 2.813162740000038],
            [16.059928833000043, 2.786187643000105],
            [16.05620813000013, 2.759832662000051],
            [16.060032186000086, 2.725829570000101],
            [16.05930871600009, 2.7118252570001],
            [16.062616008000077, 2.703195292000061],
            [16.072847941000077, 2.702833557000062],
            [16.086283814000097, 2.704952291000041],
            [16.0990995680001, 2.703970439000074],
            [16.110468384000086, 2.701438294000084],
            [16.101373332, 2.68784739200008],
            [16.093725220000124, 2.673119609000082],
            [16.090314575, 2.661905823000041],
            [16.093105102000067, 2.641493632000092],
            [16.108504679000134, 2.606612040000115],
            [16.11150191200008, 2.586199850000071],
            [16.1068510340001, 2.567027894000063],
            [16.091244751000147, 2.532766419000055],
            [16.090314575, 2.510493876000098],
            [16.094345337000107, 2.49752309200008],
            [16.10705773900014, 2.474165344000127],
            [16.11150191200008, 2.455871887000058],
            [16.11150191200008, 2.41856150300012],
            [16.112948853000148, 2.410448304000113],
            [16.120907023000115, 2.389571025000052],
            [16.13341272000011, 2.364818013000018],
            [16.152326294000147, 2.343268941000062],
            [16.15925093600012, 2.332933655000147],
            [16.16286828600002, 2.323838603000084],
            [16.164728638000042, 2.314795227000033],
            [16.165968872000064, 2.294796448000085],
            [16.16906945800011, 2.289887187000062],
            [16.182918742000084, 2.281153870000082],
            [16.18653609200007, 2.277691549000053],
            [16.18694950400007, 2.269319967000072],
            [16.181265096000118, 2.256555888000094],
            [16.17971480300011, 2.246995748000103],
            [16.19284061700006, 2.239502665000074],
            [16.1966646730001, 2.236453756000046],
            [16.202349081000136, 2.232009582000032],
            [16.20772342900011, 2.223069560000098],
            [16.199455200000074, 2.212165833000128],
            [16.15925093600012, 2.182090149000075],
            [16.140647421000097, 2.199815165000089],
            [16.12039025900009, 2.203329163000134],
            [16.104370565000124, 2.193562317000087],
            [16.09775598100012, 2.171548157000103],
            [16.085767049000083, 2.149172262000121],
            [16.08349328600005, 2.137751770000122],
            [16.08556034300011, 2.124910177000032],
            [16.08979781000008, 2.11615102100005],
            [16.092484986000102, 2.106900940000045],
            [16.090314575, 2.092741597000085],
            [16.088144165000102, 2.091759745000033],
            [16.08411340400002, 2.091604716000077],
            [16.079669230000036, 2.090261129000027],
            [16.07667199700009, 2.085920309000045],
            [16.075535116000083, 2.079951680000107],
            [16.075535116000083, 2.075455831000099],
            [16.076155233000065, 2.072820333000081],
            [16.07667199700009, 2.072251893000029],
            [16.078118937000085, 2.063441061000034],
            [16.081529582000115, 2.055637920000024],
            [16.081736288000087, 2.046827088000029],
            [16.06644006300013, 2.025484721000026],
            [16.063752889000085, 2.015872904000105],
            [16.06488977100011, 1.978950094000069],
            [16.068713826000135, 1.973601583000118],
            [16.07491499800011, 1.970604350000102],
            [16.08349328600005, 1.963007914000045],
            [16.101373332, 1.932803040000039],
            [16.135066366000075, 1.845314840000071],
            [16.15904423000009, 1.734804790000041],
            [16.155840291000118, 1.719069316000059],
            [16.145091593000103, 1.714315084000077],
            [16.123594197000045, 1.721601461000148],
            [16.114809204000068, 1.719069316000059],
            [16.069850708000047, 1.654551290000128],
            [16.030473266000058, 1.705400900000143],
            [16.021998331000134, 1.722790019000072],
            [16.021998331000134, 1.733047790000057],
            [16.024892212000026, 1.742478740000124],
            [16.02633915200002, 1.752297262000084],
            [16.021998331000134, 1.763795268000109],
            [16.013833455000025, 1.771314189000066],
            [16.002774699000042, 1.775913391000103],
            [15.990785766000073, 1.776171774000076],
            [15.980450480000059, 1.770590719000069],
            [15.963190551000082, 1.777360331000096],
            [15.943760213000076, 1.781623637000067],
            [15.928980753000076, 1.788961691000054],
            [15.925880167000116, 1.804748840000045],
            [15.915234823000048, 1.798961080000069],
            [15.901798951000075, 1.79374176000006],
            [15.889913371000148, 1.793276672000033],
            [15.884952434000098, 1.801648254000099],
            [15.882368611000118, 1.816711934000097],
            [15.875650676000078, 1.823765768000015],
            [15.865935506000142, 1.828468323000081],
            [15.842060994000065, 1.844152120000047],
            [15.815395955000099, 1.853428039000065],
            [15.802890258000104, 1.859965109000143],
            [15.764649699000131, 1.908721822000089],
            [15.757414999000048, 1.912985128000059],
            [15.73405725100011, 1.916705831000058],
            [15.721551554000115, 1.921615092000096],
            [15.711112915000086, 1.927377014000058],
            [15.706772095000105, 1.931976217000113],
            [15.611790812000095, 1.942544047000084],
            [15.526628051000046, 1.967813822000053],
            [15.482909790000065, 1.97584950700012],
            [15.439191528000094, 1.969829204000092],
            [15.388135214000016, 1.939546815000071],
            [15.367981405000137, 1.932854716000051],
            [15.349171183000124, 1.92329457600006],
            [15.33738895600004, 1.921460063000055],
            [15.337802368000041, 1.923759664000073],
            [15.314341268000078, 1.934249979000128],
            [15.309483683000053, 1.935076803000058],
            [15.301628866000016, 1.943577576000067],
            [15.300181926000022, 1.947660014000078],
            [15.301938924000098, 1.953318584000016],
            [15.303282511000077, 1.966418559000076],
            [15.301112101000086, 1.973756612000059],
            [15.295427694000125, 1.981533915000071],
            [15.287572876000098, 1.987786764000077],
            [15.253569784000149, 2.000318299000085],
            [15.248092081000067, 2.003341370000101],
            [15.244164673000114, 2.010059306000116],
            [15.238686971000106, 2.025303854000072],
            [15.233726033000067, 2.03129832000009],
            [15.212642049000124, 2.039618225000055],
            [15.197035766000084, 2.034967346000087],
            [15.183599894000054, 2.029334615000067],
            [15.151663859000081, 2.040987651000123],
            [15.138538046000093, 2.01150624600011],
            [15.123861938000118, 2.017009786000116],
            [15.117764119000071, 2.017009786000116],
            [15.107635539000114, 2.000835062000121],
            [15.091615845000149, 1.984427796000062],
            [15.074872681000102, 1.97936350500008],
            [15.063090454000104, 1.997166036000124],
            [15.043660116000126, 1.990861512000023],
            [15.028260539000144, 1.995305684000115],
            [14.980718221000132, 2.033106995000082],
            [14.971003052000071, 2.034450582000147],
            [14.963044881000116, 2.010421041000114],
            [14.953846476000109, 2.005821838000074],
            [14.932142374000108, 2.003341370000101],
            [14.892454874000038, 2.006390279000129],
            [14.896588989000065, 2.030936585000092],
            [14.90733768700008, 2.058893535000095],
            [14.887803996000088, 2.072251893000029],
            [14.884600057000114, 2.082096253000103],
            [14.871474243000137, 2.101655782000108],
            [14.857004842, 2.115944316000096],
            [14.85018355300005, 2.109794820000033],
            [14.85018355300005, 2.097366638000054],
            [14.848219849000117, 2.085196838000044],
            [14.841191854000101, 2.075920919000026],
            [14.826309042000076, 2.072251893000029],
            [14.764814087000076, 2.065456442000084],
            [14.761610148000102, 2.070184835000063],
            [14.762540324000042, 2.092534892000046],
            [14.76140344300012, 2.099588725000061],
            [14.756339152000066, 2.099588725000061],
            [14.74755415800007, 2.097185771000099],
            [14.737115519000042, 2.09607472800009],
            [14.727296997000082, 2.099588725000061],
            [14.733498169000143, 2.102017517000107],
            [14.747864217000142, 2.11320546500005],
            [14.72088911900002, 2.127597351000063],
            [14.71365441900005, 2.123980001000078],
            [14.720475708, 2.099588725000061],
            [14.705696249000084, 2.105531514000063],
            [14.68595585100013, 2.125866190000096],
            [14.672003215000132, 2.134341125000091],
            [14.646061645000088, 2.133359273000039],
            [14.636346476000142, 2.138320211000078],
            [14.644821411000066, 2.154184876000087],
            [14.620946899000074, 2.164830221000074],
            [14.587873983000094, 2.201727193000096],
            [14.562139120000097, 2.208806865000028],
            [14.557074829000015, 2.20239898700008],
            [14.547773072000098, 2.193665670000115],
            [14.547979777000137, 2.18436391200008],
            [14.550253540000057, 2.175165507000088],
            [14.547049601000083, 2.166535543000052],
            [14.538057902000048, 2.16338328000009],
            [14.459199666000131, 2.1465367630001],
            [14.438735799000057, 2.133979391000096],
            [14.432948038000092, 2.132119039000088],
            [14.41868534400001, 2.135271301000046],
            [14.399358358000057, 2.153151347000104],
            [14.383648722000089, 2.162091370000041],
            [14.320293416000084, 2.170669658000065],
            [14.276265096000117, 2.153564758000115],
            [14.266963338000096, 2.152427877000108],
            [14.161750122000115, 2.153409729000074],
            [14.002793417000106, 2.154804993000056],
            [13.823992960000027, 2.156406962000091],
            [13.662266290000105, 2.157761182000044],
            [13.62033614100011, 2.158112284000055],
            [13.466547078000104, 2.159507548000121],
            [13.294567912000076, 2.161057841000058],
            [13.294257854000108, 2.185759175000072],
            [13.298391968000118, 2.21583485900004],
            [13.294154500000076, 2.230510967000029],
            [13.284646037000101, 2.242241516000107],
            [13.269659871000016, 2.255729066000072],
            [13.254156941000105, 2.266891175000112],
            [13.242891479000036, 2.271490377000063],
            [13.235966837000149, 2.269888407000025],
            [13.22160078900015, 2.263945618000108],
            [13.212299032000118, 2.264048971000136],
            [13.205684448000028, 2.266891175000112],
            [13.191731812000057, 2.277691549000053],
            [13.163826538000052, 2.283169251000032],
            [13.133337443000073, 2.284512838000097],
            [13.12465580200012, 2.281050517000054],
            [13.113080281000066, 2.2727306110001],
            [13.093029826000134, 2.253455302000063],
            [13.083521362000056, 2.249527893000092],
            [13.040939982000083, 2.24420522000014],
            [13.012931355000148, 2.25629750500012],
            [12.996911662000116, 2.260018209000052],
            [12.98316573100007, 2.253455302000063],
            [12.972210327000084, 2.250354716000118],
            [12.954847046000083, 2.253248596000105],
            [12.924771362000115, 2.264048971000136],
            [12.914539429000115, 2.254540507000058],
            [12.903170613000043, 2.250354716000118],
            [12.890458211000094, 2.251388245000101],
            [12.876402222000081, 2.257176005000076],
            [12.867823934000029, 2.244980368000057],
            [12.848083537000065, 2.249321187000135],
            [12.825242554000056, 2.259243062000039],
            [12.808189331000051, 2.264048971000136],
            [12.795580282000117, 2.258777975000015],
            [12.784108113000087, 2.249527893000092],
            [12.770155477000088, 2.240691224000088],
            [12.749898315000081, 2.236712138000101],
            [12.614609416000121, 2.256917623000092],
            [12.590734904000044, 2.265702616000084],
            [12.574818563000122, 2.277691549000053],
            [12.551460816000088, 2.272265523000073],
            [12.534200887000083, 2.277691549000053],
            [12.478390340000118, 2.29588165300008],
            [12.43994307400007, 2.298517151000098],
            [12.384855997000102, 2.285908102000079],
            [12.366769246000104, 2.289577128000076],
            [12.334006388000091, 2.309575907000109],
            [12.321604045000129, 2.314071757000121],
            [12.312095581000051, 2.312934875000025],
            [12.291218303000079, 2.301772766000084],
            [12.280779663000118, 2.299033915000052],
            [12.261039266000068, 2.296191712000066],
            [12.222592000000105, 2.283324280000073],
            [12.202644897000113, 2.279551901000048],
            [12.1592366940001, 2.281412252000052],
            [12.118825724000118, 2.2878201300001],
            [12.10073897300012, 2.28849192300008],
            [12.041931193000039, 2.283996073000054],
            [11.966173543000139, 2.28875030500005],
            [11.889795776000085, 2.282084045000133],
            [11.802152547000077, 2.28482289600008],
            [11.768149455000042, 2.280172017000027],
            [11.752749878000145, 2.281877340000079],
            [11.70138350500011, 2.298723857000056],
            [11.681022990000088, 2.31541534500009],
            [11.671204468000099, 2.320996399000109],
            [11.65725183100011, 2.322495016000119],
            [11.644642781000101, 2.319652812000044],
            [11.618597860000108, 2.310402731000039],
            [11.35163741000008, 2.300584209000064],
            [11.349777059000075, 2.291489156000097],
            [11.354324585000114, 2.278466695000063],
            [11.355978231000051, 2.265185852000045],
            [11.349983764000115, 2.251129862000127],
            [11.34223230000012, 2.24058787000007],
            [11.335927775000101, 2.229167378000056],
            [11.334170776000121, 2.212785950000111],
            [11.334170776000121, 2.200280253000102],
            [11.332413778000046, 2.188032938000077],
            [11.328486368000085, 2.176302389000099],
            [11.322078491000042, 2.165760396000039],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Gabon',
        iso3: 'GAB',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [13.294567912000076, 2.161057841000058],
              [13.294877970000073, 2.101087342000056],
              [13.291363973000102, 2.068944601000027],
              [13.281132040000045, 2.044966736000021],
              [13.245475301000056, 2.025303854000072],
              [13.239480835000109, 2.020730489000115],
              [13.221290731000067, 2.000835062000121],
              [13.216019735000145, 1.997166036000124],
              [13.206924682000079, 1.993574524000053],
              [13.206614624000082, 1.985151266000059],
              [13.212299032000118, 1.966418559000076],
              [13.210231974000067, 1.956315816000114],
              [13.205064331000074, 1.949339498000128],
              [13.198449748000058, 1.94311248800004],
              [13.191731812000057, 1.935076803000058],
              [13.184910523000099, 1.923449606000091],
              [13.17819258600008, 1.907791646000135],
              [13.166307006000125, 1.904381002000108],
              [13.162172892000115, 1.899833476000083],
              [13.17509200000012, 1.882108460000069],
              [13.183153523000101, 1.864047546000052],
              [13.188321167000112, 1.856580302000026],
              [13.192455281000036, 1.844746399000101],
              [13.191008341000042, 1.828726705000065],
              [13.180673055000057, 1.792010600000083],
              [13.173024943000144, 1.776946920000086],
              [13.162793010000087, 1.763640239000068],
              [13.15018396000005, 1.756302186000084],
              [13.157522013000062, 1.739145609000019],
              [13.154628133000074, 1.721653137000061],
              [13.147806844000115, 1.702868754000065],
              [13.143982788000073, 1.681810608000134],
              [13.149977254000106, 1.636283671000072],
              [13.146773315000132, 1.612254130000039],
              [13.129616740000074, 1.592462057000063],
              [13.14594649300011, 1.563419902000078],
              [13.16444665500012, 1.537840068000122],
              [13.171267945000096, 1.545255636000135],
              [13.182636759000076, 1.53654815700007],
              [13.189664754000091, 1.524740092000059],
              [13.190904989000018, 1.511071676000142],
              [13.184910523000099, 1.496886495000098],
              [13.205477743000074, 1.48637034100004],
              [13.223461141000058, 1.438001200000087],
              [13.239480835000109, 1.427975973000073],
              [13.238447306000126, 1.419630229000106],
              [13.239790893000105, 1.372346293000064],
              [13.239170776000037, 1.36418141700004],
              [13.239584188000038, 1.356507467000057],
              [13.242891479000036, 1.349789531000027],
              [13.251263062000106, 1.337645569000117],
              [13.249092651000126, 1.332374573000095],
              [13.242994832000079, 1.328860576000039],
              [13.233589721000016, 1.308810120000089],
              [13.219327026000144, 1.299198303000082],
              [13.202377156000125, 1.293410543000107],
              [13.188321167000112, 1.291446839000074],
              [13.18036299600007, 1.284832255000083],
              [13.176642293000043, 1.270879619000084],
              [13.169200887000017, 1.258580628000047],
              [13.15018396000005, 1.256616923000109],
              [13.160312540000092, 1.247728577000089],
              [13.172301473000061, 1.242870993000082],
              [13.181809936000064, 1.236463114000045],
              [13.184885479000059, 1.222623178000049],
              [13.184910523000099, 1.222510478000046],
              [13.195452515000056, 1.221115214000065],
              [13.215813028000099, 1.224370829000051],
              [13.250229533000038, 1.221787008000135],
              [13.270900106000056, 1.226024476000092],
              [13.289193562000037, 1.233982646000058],
              [13.307797079000068, 1.256720276000038],
              [13.325987183000109, 1.259304098000129],
              [13.34293705200011, 1.263851624000083],
              [13.349344930000058, 1.281576640000097],
              [13.357406453000067, 1.289069723000125],
              [13.376940145000077, 1.294444071000086],
              [13.398747599000103, 1.296924540000063],
              [13.413940470000114, 1.295529277000085],
              [13.448873739000106, 1.283075257000093],
              [13.479776245000096, 1.277132466000083],
              [13.509955281000117, 1.277287496000028],
              [13.543441609000098, 1.283488668000103],
              [13.556360718000121, 1.292790426000039],
              [13.579201701000017, 1.323486226000085],
              [13.615065145000074, 1.337438863000074],
              [13.628087605000104, 1.348135884000072],
              [13.64224694800015, 1.357385966000095],
              [13.662090699000146, 1.359194641000087],
              [13.671495808000088, 1.358781230000076],
              [13.680694214000084, 1.359401347000045],
              [13.699091023000108, 1.362786154000062],
              [13.705550578000043, 1.365990092000033],
              [13.717539510000108, 1.375369364000079],
              [13.724360799000067, 1.377953187000074],
              [13.72942508900013, 1.376919658000091],
              [13.741103963000114, 1.371312764000081],
              [13.744101196000116, 1.370279236000087],
              [13.754849894000131, 1.3743358360001],
              [13.758157186000062, 1.376506246000091],
              [13.77035282400007, 1.400432435000084],
              [13.779757935000106, 1.426270650000106],
              [13.780584757000042, 1.431024882000102],
              [13.794744100000088, 1.434435527000034],
              [13.983569784000082, 1.416839702000047],
              [14.000829712000069, 1.413015645000101],
              [14.01901981600011, 1.402137757000048],
              [14.03379927500012, 1.387642517000103],
              [14.049508911000117, 1.376402893000062],
              [14.070696248000075, 1.375110983000098],
              [14.10645634000008, 1.38893442800007],
              [14.124439738000149, 1.393585307000123],
              [14.14449019300011, 1.39162160300009],
              [14.183867635000098, 1.380847066000072],
              [14.19254927600008, 1.374955953000068],
              [14.198957153, 1.368315532000068],
              [14.206501913000068, 1.362837830000075],
              [14.218387491000101, 1.360564066000052],
              [14.219938873000103, 1.355017878000083],
              [14.22148807800005, 1.349479472000041],
              [14.230066365000056, 1.343950093000046],
              [14.241435181000071, 1.339195862000054],
              [14.252183878000068, 1.330824280000073],
              [14.2581783440001, 1.319662170000043],
              [14.273061157000143, 1.257237040000078],
              [14.275748332000092, 1.23108876600007],
              [14.274714803000109, 1.155641174000081],
              [14.282879679000104, 1.130113017000042],
              [14.298485962000143, 1.10923573900007],
              [14.34644169100008, 1.087118225000054],
              [14.360084269000083, 1.066757710000033],
              [14.375690552000037, 1.015598043000125],
              [14.386749308000049, 0.992240296000077],
              [14.400805298000051, 0.970329489000036],
              [14.417548462000099, 0.950589091000069],
              [14.436565389000066, 0.933277486000065],
              [14.460439900000068, 0.921236878000087],
              [14.468088013000056, 0.913227031000105],
              [14.466227661000119, 0.899636129000029],
              [14.457029256000027, 0.890334371000094],
              [14.4451436760001, 0.883254700000066],
              [14.43759891700006, 0.875141500000069],
              [14.44100956200009, 0.862790833000105],
              [14.447624146000067, 0.81623036700006],
              [14.41341434700007, 0.775044251000068],
              [14.36731897000007, 0.735511780000124],
              [14.3383801680001, 0.693912252000118],
              [14.33538293400008, 0.64259755500008],
              [14.328768351000093, 0.621203512000065],
              [14.254664348000063, 0.557124736000063],
              [14.250943644000131, 0.551853739000123],
              [14.245259237000084, 0.547719625000099],
              [14.231823365000139, 0.542551982000091],
              [14.181593872000093, 0.539864808000061],
              [14.125473266000142, 0.546169332000076],
              [14.075967244000083, 0.539451396000061],
              [14.045581502000033, 0.497283427000099],
              [14.056846964000101, 0.476406149000113],
              [14.063048137000095, 0.455942281000063],
              [14.059120727000106, 0.435271709000048],
              [14.040413859000125, 0.413774313000104],
              [13.966516561000049, 0.373053284000136],
              [13.945225871000076, 0.350419006000095],
              [13.909775838000144, 0.270940653000096],
              [13.875772745000091, 0.220297750000043],
              [13.87122522000007, 0.196423239000055],
              [13.87618615700012, 0.171308492000122],
              [13.885901327000056, 0.140302633000104],
              [13.890655559000038, 0.115911357000073],
              [13.894893025000101, 0.043667704000143],
              [13.901404257000081, 0.036846415000085],
              [13.913083130000132, 0.036536357000017],
              [13.925072062000083, 0.034365946000108],
              [13.932926880000139, 0.022066956000074],
              [13.931376586000113, 0.011628316000042],
              [13.917217245000074, -0.006665140999928],
              [13.912979777000118, -0.016587015999932],
              [13.91494348200004, -0.031263121999913],
              [13.920111125000062, -0.042425230999939],
              [13.921144653000027, -0.052967223999914],
              [13.910706014000084, -0.06588633199992],
              [13.900474081000112, -0.075601500999952],
              [13.888053549000063, -0.092088146999913],
              [13.84269982900011, -0.152289325999988],
              [13.832157837000068, -0.177094013999934],
              [13.8312276610001, -0.205412699999926],
              [13.877426392000046, -0.260499775999989],
              [13.883420858000079, -0.264943948999914],
              [13.889828735000037, -0.263703714999878],
              [13.903057902000114, -0.258846129999952],
              [13.907295369000082, -0.254401956999942],
              [13.909982544000087, -0.247167255999969],
              [13.913806600000044, -0.240552672999883],
              [13.921558064000038, -0.237865497999948],
              [13.95731815600007, -0.241999612999962],
              [13.967033325000102, -0.245823668999918],
              [13.9750948490001, -0.252541605999937],
              [13.98232954900007, -0.262256774999884],
              [14.018709758000057, -0.252644958999966],
              [14.058810669000138, -0.258846129999952],
              [14.095397583000079, -0.276622822999883],
              [14.121442505000061, -0.302150980999912],
              [14.138289022000038, -0.336360778999918],
              [14.150588012000071, -0.376461689999914],
              [14.157926066000073, -0.417699482999907],
              [14.159683065000138, -0.455113219999888],
              [14.176529582000114, -0.446121520999938],
              [14.193066040000105, -0.440437112999888],
              [14.210222616000067, -0.440333759999959],
              [14.228516073000037, -0.44777516699989],
              [14.24474247200007, -0.451599222999917],
              [14.260038696, -0.44643157899992],
              [14.27554162600012, -0.439093525999922],
              [14.292698201000093, -0.436406350999988],
              [14.32060347500007, -0.444467874999887],
              [14.35863732900009, -0.461314391999863],
              [14.39233036300007, -0.482398375999892],
              [14.414447876000054, -0.512164000999888],
              [14.454238729000082, -0.539552510999926],
              [14.466537719000115, -0.552678324999889],
              [14.489998820000096, -0.600944111999908],
              [14.498990519000131, -0.630916441999943],
              [14.492169230000087, -0.663369241999959],
              [14.451551554000048, -0.751219176999925],
              [14.445970499000026, -0.775713805999885],
              [14.446177205000083, -0.800311787999874],
              [14.452895142000102, -0.82573659199997],
              [14.45713260900007, -0.856122333999934],
              [14.445867147000087, -0.877516377999939],
              [14.42819380600011, -0.896946715999931],
              [14.412794230000117, -0.921544697999906],
              [14.407523234000081, -0.94448903299994],
              [14.402562296000042, -0.987690530999885],
              [14.392020304000084, -1.008981220999956],
              [14.391813598000113, -1.023347269999874],
              [14.420338989000072, -1.101792093999975],
              [14.430984334000073, -1.123392842999948],
              [14.434394979000075, -1.135071716999931],
              [14.433568156000149, -1.143650003999952],
              [14.427987101000042, -1.160909931999939],
              [14.428297160000113, -1.169488219999977],
              [14.435325154000054, -1.1816838579999],
              [14.439434821000077, -1.185733087999907],
              [14.456409139000073, -1.202457782999929],
              [14.464160604000085, -1.215376891999938],
              [14.465814250000108, -1.224368591999976],
              [14.464780721000125, -1.255581155999963],
              [14.460749959000054, -1.278008727999875],
              [14.45713260900007, -1.287620543999878],
              [14.451551554000048, -1.298162536999939],
              [14.444316854000078, -1.306327412999863],
              [14.436048625000126, -1.312735290999896],
              [14.429123982000135, -1.319969990999965],
              [14.426333455000105, -1.331028746999962],
              [14.432327922000127, -1.350149026999958],
              [14.447004028, -1.365341897999897],
              [14.48214400200007, -1.388596292999907],
              [14.487725057000063, -1.409370218999953],
              [14.480593709000033, -1.420842386999965],
              [14.467881307000084, -1.429007262999988],
              [14.456305786000144, -1.440169372999918],
              [14.452688436000045, -1.449574482999878],
              [14.451034790000108, -1.473655699999924],
              [14.438425741000088, -1.502594501999894],
              [14.451551554000048, -1.515616962999928],
              [14.462713664000091, -1.533600361999916],
              [14.463127075000102, -1.548689880999916],
              [14.43036421700009, -1.554891051999988],
              [14.423956340000132, -1.563572692999855],
              [14.419925578000061, -1.575148212999906],
              [14.413207642000117, -1.585276793999952],
              [14.40369917800004, -1.592201436999929],
              [14.39429406700009, -1.596852314999893],
              [14.373830200000043, -1.604087014999962],
              [14.364838501000094, -1.612045185999918],
              [14.37145308400008, -1.619486591999944],
              [14.390883422000059, -1.630338642999988],
              [14.402975708000042, -1.670852965999899],
              [14.420028931000076, -1.676123961999934],
              [14.441112915000105, -1.679637959999894],
              [14.448761027000074, -1.686252542999895],
              [14.425196574000097, -1.700515237999866],
              [14.413104289000103, -1.713951110999915],
              [14.40669641100007, -1.735551859999887],
              [14.40359582500011, -1.815236917999925],
              [14.397498006000149, -1.840971780999922],
              [14.39687788900008, -1.849446715999932],
              [14.404526001000079, -1.893061624999888],
              [14.39729130100011, -1.906807555999919],
              [14.370729614000084, -1.921276956999947],
              [14.36857050200004, -1.922120271999901],
              [14.252183878000068, -1.967579039999919],
              [14.245052531000056, -1.974813740999892],
              [14.240091593000102, -1.982255146999918],
              [14.237611124000125, -1.991143492999925],
              [14.238127889000054, -2.002615660999936],
              [14.232856892000115, -2.0120207719999],
              [14.233477010000087, -2.018221943999976],
              [14.238644653000108, -2.023389586999897],
              [14.246809530000121, -2.029384052999916],
              [14.251667114000043, -2.037858987999925],
              [14.25063358500006, -2.047780862999915],
              [14.244019002000073, -2.067521260999882],
              [14.238437947000136, -2.120231221999902],
              [14.233787068000083, -2.134493915999968],
              [14.226965780000114, -2.141315205999931],
              [14.209705851000137, -2.147413024999892],
              [14.204331502000088, -2.152167256999888],
              [14.20319462100008, -2.161985778999849],
              [14.209395793000056, -2.179865823999904],
              [14.209189087000084, -2.187203877999906],
              [14.195856568000067, -2.201776630999859],
              [14.161543416000143, -2.214282328999957],
              [14.14800419100007, -2.224824319999925],
              [14.151208130000043, -2.259034118999921],
              [14.226965780000114, -2.323112894999923],
              [14.234407186000055, -2.354945576999881],
              [14.230066365000056, -2.352155049999922],
              [14.18231734200009, -2.363317158999948],
              [14.172395467000086, -2.367864684999887],
              [14.163300415000037, -2.373962503999849],
              [14.144180135000028, -2.390188902999853],
              [14.136015259000118, -2.39876719199988],
              [14.13146773200009, -2.408895771999937],
              [14.13188114400009, -2.435147399999963],
              [14.124853149000074, -2.443829039999926],
              [14.115241333000057, -2.451373798999967],
              [14.106766398000076, -2.460262145999891],
              [14.100553460000071, -2.478064601999918],
              [14.096017700000061, -2.491061298999867],
              [14.090023234000114, -2.498606057999908],
              [14.080928181000047, -2.499949644999973],
              [14.071006307000061, -2.495815530999948],
              [14.055606730000079, -2.486927184999928],
              [14.045581502000033, -2.486100361999917],
              [14.039276978000117, -2.487237243999914],
              [13.993284953000028, -2.501603291999928],
              [13.985636840000069, -2.501499938999899],
              [13.97922896300011, -2.495608825999895],
              [13.976231730000109, -2.477315368999925],
              [13.967033325000102, -2.470597431999906],
              [13.95731815600007, -2.470597431999906],
              [13.947706339000149, -2.474938252999976],
              [13.930446411000048, -2.48537689199992],
              [13.909465779000072, -2.489717711999987],
              [13.884971151000087, -2.48847747799995],
              [13.862130168000107, -2.48093271899991],
              [13.84580041500007, -2.46656667099991],
              [13.846937296000078, -2.461605732999956],
              [13.847660767000065, -2.423055114999968],
              [13.855102173000091, -2.414270120999987],
              [13.875876098000049, -2.403831481999958],
              [13.890035441000066, -2.373652445999952],
              [13.901921020000117, -2.366314391999964],
              [13.906158487000141, -2.359803160999903],
              [13.892515910000043, -2.341199645999936],
              [13.882180624000057, -2.333861592999938],
              [13.871638631000081, -2.328797302999874],
              [13.863887166000069, -2.321459247999968],
              [13.86057987500007, -2.293657327999924],
              [13.853861938000136, -2.283838805999949],
              [13.835568481000081, -2.265235290999897],
              [13.823269491000133, -2.246838480999898],
              [13.800531860000149, -2.200433043999894],
              [13.7914368080001, -2.159091898999861],
              [13.782755167000118, -2.138007913999928],
              [13.770662882000039, -2.11909433999989],
              [13.756916952000097, -2.105865173999902],
              [13.746374959000036, -2.098320413999943],
              [13.743171020000062, -2.097080178999917],
              [13.740897257000142, -2.102454528999971],
              [13.720019979000085, -2.133563740999918],
              [13.70947798600011, -2.153510843999939],
              [13.706790812000094, -2.16456959999995],
              [13.705240519000057, -2.184309997999918],
              [13.701571492000085, -2.194748635999943],
              [13.693509969000075, -2.205910745999887],
              [13.617442261000122, -2.27960133899991],
              [13.610724324000074, -2.28993662499991],
              [13.607830445000104, -2.311123961999968],
              [13.60338627100009, -2.320012307999974],
              [13.593361044000062, -2.326833597999936],
              [13.56948653200007, -2.334481708999917],
              [13.557600952000143, -2.340476175999939],
              [13.547679077000055, -2.349364522999863],
              [13.533106323000084, -2.367657978999929],
              [13.524631389000092, -2.3760295619999],
              [13.492178589000076, -2.398457132999894],
              [13.482256713000083, -2.408068948999912],
              [13.476779012000094, -2.417680764999915],
              [13.47398848500012, -2.426982523999939],
              [13.46944095900011, -2.435044046999934],
              [13.45889896600005, -2.441038512999867],
              [13.453731323000028, -2.439384866999916],
              [13.445359741000061, -2.427085875999879],
              [13.438951864000103, -2.425432230999931],
              [13.4248958740001, -2.429773050999913],
              [13.419728231000079, -2.429669697999969],
              [13.398024130000096, -2.426155699999924],
              [13.378800497000071, -2.430909931999921],
              [13.361023804000126, -2.428842874999944],
              [13.18666752100006, -2.364143981999874],
              [13.1768489990001, -2.361973571999982],
              [13.165273478000046, -2.363523863999902],
              [13.14615319800015, -2.374685973999931],
              [13.135197795000096, -2.37695973699995],
              [13.114320516000106, -2.371895445999883],
              [13.049828329000093, -2.34264658599993],
              [13.025023641000132, -2.338202412999919],
              [13.012104533000127, -2.342026467999872],
              [12.994008157000025, -2.360122844999879],
              [12.982442261000074, -2.371688740999929],
              [12.96900638800011, -2.372412210999926],
              [12.966112508000037, -2.366417744999893],
              [12.971280152000134, -2.357115986999958],
              [12.982442261000074, -2.347710875999908],
              [12.987093140000127, -2.340682880999907],
              [12.991123901000037, -2.332311298999926],
              [12.993914428000096, -2.323526305999934],
              [12.994637899000082, -2.31494801799991],
              [12.996704956000144, -2.304819437999953],
              [13.002286010000063, -2.29665456099994],
              [13.010657592000143, -2.287766213999916],
              [13.00817712400007, -2.276500752999951],
              [13.003422892000088, -2.275467223999968],
              [12.997325073000127, -2.275673928999936],
              [12.990193725000097, -2.268025817999956],
              [12.987506551000138, -2.259964293999872],
              [12.982442261000074, -2.232989196999938],
              [12.973037150000039, -2.221517028999926],
              [12.954330282000058, -2.190924580999905],
              [12.945648640000087, -2.18244964599991],
              [12.921360717000084, -2.194851988999886],
              [12.907098022000099, -2.195368753999915],
              [12.902757202000117, -2.177592060999885],
              [12.90203373200012, -2.16725677499997],
              [12.898209676000079, -2.160228779999969],
              [12.885083862000045, -2.147413024999892],
              [12.882706746000082, -2.140798441999891],
              [12.884463745000062, -2.134493915999968],
              [12.888701212000115, -2.126949156999927],
              [12.890561564000109, -2.122194925999935],
              [12.89448897300008, -2.115580342999934],
              [12.895109091000052, -2.109792581999955],
              [12.876298869000038, -2.104934997999948],
              [12.874128458000143, -2.09976735499994],
              [12.875161987000126, -2.093772887999918],
              [12.875161987000126, -2.089122008999951],
              [12.876918986000106, -2.088708596999936],
              [12.87299157700005, -2.065867613999927],
              [12.868547403000036, -2.059873147999909],
              [12.85294112200009, -2.044576924999944],
              [12.84715336100004, -2.037238870999943],
              [12.838161661000072, -2.016051533999899],
              [12.816147502000092, -1.943497822999888],
              [12.804571980000048, -1.919106546999956],
              [12.787725463000072, -1.907531025999916],
              [12.745454142000085, -1.893888447999899],
              [12.741014228000068, -1.890672439999904],
              [12.67496748900004, -1.842832131999927],
              [12.632386109000066, -1.825158792999929],
              [12.583190145000088, -1.826502379999894],
              [12.572441447000074, -1.83042978899995],
              [12.523452189000068, -1.863295999999892],
              [12.517354370000106, -1.868980406999938],
              [12.512393432000067, -1.8754916379999],
              [12.506295613000106, -1.888204039999948],
              [12.504538615000115, -1.896885680999915],
              [12.503815145000118, -1.907737731999958],
              [12.499474324000062, -1.917866312999919],
              [12.486555217000046, -1.924894307999921],
              [12.468985229000083, -1.919416604999938],
              [12.45000933300011, -1.899298347999974],
              [12.438082722000075, -1.886653747999929],
              [12.42692061300005, -1.884069925999938],
              [12.423096557000093, -1.897609150999912],
              [12.431468140000078, -2.005406188999899],
              [12.440046427000112, -2.045817158999881],
              [12.460820353000145, -2.077856546999982],
              [12.499784383000133, -2.095529886999898],
              [12.495340210000023, -2.112789814999886],
              [12.47735681100005, -2.141108499999874],
              [12.470225464000094, -2.156301370999898],
              [12.46836511300009, -2.171080830999912],
              [12.475496460000045, -2.212421976999863],
              [12.468571818000072, -2.241154072999947],
              [12.455135946000098, -2.275570576999911],
              [12.44790124500014, -2.307920022999895],
              [12.459270060000023, -2.329934182999878],
              [12.062291707000071, -2.414993590999899],
              [12.031285848000039, -2.411582945999953],
              [12.000693400000046, -2.390602314999867],
              [11.96679366100011, -2.348537698999934],
              [11.948706909000094, -2.335205179999917],
              [11.938371623000108, -2.329107360999956],
              [11.90705570500009, -2.344610290999867],
              [11.864887736000128, -2.358149515999941],
              [11.828817586000127, -2.365280863999885],
              [11.806596720000101, -2.374169209999906],
              [11.772696981000081, -2.405381774999881],
              [11.756057170000076, -2.415096943999913],
              [11.739520711000068, -2.413753356999948],
              [11.721330607000112, -2.404141539999941],
              [11.687534220000146, -2.377683206999947],
              [11.67988610900008, -2.368794860999941],
              [11.675855346000077, -2.360423278999875],
              [11.66965417500009, -2.352671813999947],
              [11.655908244000045, -2.345643818999946],
              [11.605368693000116, -2.330347594999893],
              [11.568368367000062, -2.329107360999956],
              [11.566197957000071, -2.329727477999924],
              [11.558239787000105, -2.349364522999863],
              [11.579737183000049, -2.407655537999901],
              [11.583354533000119, -2.429669697999969],
              [11.576119833000064, -2.485066832999934],
              [11.576533244000075, -2.502533467999882],
              [11.584284708000098, -2.523617451999911],
              [11.609606160000084, -2.564028421999893],
              [11.619011271000119, -2.586455992999973],
              [11.624385620000083, -2.611984150999916],
              [11.624385620000083, -2.632758076999949],
              [11.619528036000077, -2.65353200299991],
              [11.61032963000008, -2.678853454999881],
              [11.537465861000072, -2.797709247999876],
              [11.535565759000065, -2.804995726999962],
              [11.525580282000135, -2.843287861999954],
              [11.530747925000128, -2.866748962999935],
              [11.5479045000001, -2.863855081999944],
              [11.588418823000012, -2.835433044999931],
              [11.616840861000128, -2.82675140299996],
              [11.636787964000064, -2.833262633999936],
              [11.6531177170001, -2.851659443999935],
              [11.687637573000075, -2.901785583999953],
              [11.763705281000057, -2.982607523999917],
              [11.778381388000128, -3.00565521199988],
              [11.778381388000128, -3.027152607999923],
              [11.753680054000114, -3.042345478999948],
              [11.730632365000048, -3.044722594999897],
              [11.716886433000127, -3.043585712999885],
              [11.706447795000088, -3.049890238999893],
              [11.693218628000096, -3.074694925999935],
              [11.688257691000047, -3.092264912999909],
              [11.687327515000078, -3.161511331999918],
              [11.68567386900014, -3.167195739999968],
              [11.687534220000146, -3.171019795999911],
              [11.696112508000084, -3.179598082999931],
              [11.703863973000068, -3.18538584399991],
              [11.760501343000072, -3.209053649999944],
              [11.781585327000101, -3.221662698999879],
              [11.82189294400004, -3.254838967999973],
              [11.858273153000141, -3.272098896999879],
              [11.905712117000121, -3.285121357999913],
              [11.944366089000113, -3.303208109999929],
              [11.954908081000099, -3.335454202999884],
              [11.94147220900004, -3.356951598999927],
              [11.898374064000024, -3.389197692999886],
              [11.884834839000064, -3.413278909999931],
              [11.827784057000144, -3.548051045999941],
              [11.824993530000086, -3.571202086999932],
              [11.834915405000089, -3.592079365999908],
              [11.855585978000107, -3.604378355999955],
              [11.879253784000127, -3.612026468999929],
              [11.898477417000066, -3.622361754999943],
              [11.905505412000082, -3.643549092999905],
              [11.89765059400014, -3.666080016999913],
              [11.879977254000039, -3.687164000999942],
              [11.85837650600007, -3.703287047999922],
              [11.840807756000089, -3.709988529999919],
              [11.83832605000012, -3.710935159999906],
              [11.81972253400005, -3.710418395999866],
              [11.762154989000123, -3.693985290999905],
              [11.74210453200007, -3.691711527999885],
              [11.687637573000075, -3.698739522999901],
              [11.665933471000073, -3.691401468999899],
              [11.649190307000111, -3.673314717999887],
              [11.569815307000056, -3.54495045999991],
              [11.53271162900009, -3.516528421999894],
              [11.482585490000048, -3.509293721999924],
              [11.454990275000057, -3.528207294999959],
              [11.436283407000076, -3.559006448999924],
              [11.41395918800012, -3.587635191999908],
              [11.375821981000058, -3.60034759499996],
              [11.334687540000061, -3.608615823999912],
              [11.30244144700012, -3.628459573999905],
              [11.27267582200011, -3.65295420299995],
              [11.238569377000147, -3.675071715999962],
              [11.212524455000079, -3.697292581999903],
              [11.196091349000113, -3.728815205999865],
              [11.12962271300006, -3.907856984999924],
              [11.114016304109821, -3.936856189796041],
              [11.094637438000063, -3.924303667999936],
              [11.070161256000063, -3.908805891999918],
              [11.021289032000084, -3.857816384999921],
              [11.005707227000073, -3.793145440999922],
              [10.996267123000052, -3.775485934999949],
              [10.989756707000083, -3.757419528999947],
              [10.98601321700005, -3.73756275799991],
              [10.984629754000082, -3.714613539999959],
              [10.963780198000052, -3.691488592999917],
              [10.930352800000037, -3.667124891999947],
              [10.807659947000047, -3.56293515099992],
              [10.646433931000047, -3.45191363899994],
              [10.63835696700005, -3.406914971999925],
              [10.639496290000068, -3.391534112999921],
              [10.645355665000068, -3.374200127999927],
              [10.648936394000089, -3.351739190999922],
              [10.644867384000065, -3.332452080999929],
              [10.635427280000044, -3.313653252999927],
              [10.620938035000052, -3.301916576999929],
              [10.598723272000086, -3.288806890999922],
              [10.569980576000091, -3.266523421999921],
              [10.55301144300006, -3.258689177999941],
              [10.549107478000053, -3.239092446999962],
              [10.511566602000073, -3.197360934999949],
              [10.49823125800009, -3.181594201999928],
              [10.479974548000087, -3.162001725999914],
              [10.452593535000062, -3.133278856999937],
              [10.346978523000075, -3.044487688999936],
              [10.21914336900005, -2.945247356999914],
              [10.16825188000007, -2.903445676999922],
              [10.038814667000054, -2.809258049999926],
              [9.97854899500004, -2.758172937999916],
              [9.902437516000077, -2.700431045999949],
              [9.725108269000089, -2.481377862999921],
              [9.703461134000065, -2.44304778399993],
              [9.721690300000091, -2.456801039999959],
              [9.750254754000082, -2.487237237999921],
              [9.771820509000065, -2.498304945999962],
              [9.794932488000086, -2.500909112999921],
              [9.808604363000086, -2.492282809999949],
              [9.821136915000068, -2.476169528999947],
              [9.840098504000082, -2.45671965899993],
              [9.83757571700005, -2.470798434999949],
              [9.832855665000068, -2.482028903999947],
              [9.830088738000086, -2.492771091999941],
              [9.833262566000087, -2.50514088299991],
              [9.838552280000044, -2.503350518999923],
              [9.842539910000085, -2.500583591999941],
              [9.84546959700009, -2.496514580999929],
              [9.847504102000073, -2.49146900799991],
              [9.847178582000083, -2.509698174999926],
              [9.850271030000044, -2.528415622999944],
              [9.85873457100007, -2.538832289999959],
              [9.874278191000087, -2.53248463299991],
              [9.910004102000073, -2.545017184999949],
              [9.91578209700009, -2.549574476999908],
              [9.917816602000073, -2.549981377999927],
              [9.932627800000091, -2.572849216999941],
              [9.936289910000085, -2.594496351999908],
              [9.94312584700009, -2.594496351999908],
              [9.94499759200005, -2.584730726999908],
              [9.94857832100007, -2.580254815999922],
              [9.95443769600007, -2.581149997999944],
              [9.963633660000085, -2.587090752999927],
              [9.964854363000086, -2.583428643999923],
              [9.964854363000086, -2.58171965899993],
              [9.965830925000091, -2.580987237999921],
              [9.97046959700009, -2.580254815999922],
              [9.973643425000091, -2.61687590899993],
              [9.977305535000085, -2.628676039999959],
              [9.98414147200009, -2.621026299999926],
              [9.992035352000073, -2.616387627999927],
              [10.001231316000087, -2.614353122999944],
              [10.01140384200005, -2.615004164999959],
              [10.008067254000082, -2.629082940999922],
              [10.011973504000082, -2.632419528999947],
              [10.020762566000087, -2.628513278999947],
              [10.031911655000044, -2.621270440999922],
              [10.039561394000089, -2.613213799999926],
              [10.047129754000082, -2.594821872999944],
              [10.052989129000082, -2.587090752999927],
              [10.067393425000091, -2.581801039999959],
              [10.089366082000083, -2.578545830999929],
              [10.110118035000085, -2.577894789999959],
              [10.121267123000052, -2.580254815999922],
              [10.147471550000091, -2.577569268999923],
              [10.156586134000065, -2.572930596999925],
              [10.162282748000052, -2.560316664999959],
              [10.143239780000044, -2.548923434999949],
              [10.135508660000085, -2.54615650799991],
              [10.137461785000085, -2.527439059999949],
              [10.117930535000085, -2.517510674999926],
              [10.093597852000073, -2.508233330999929],
              [10.080332879000082, -2.49146900799991],
              [10.073496941000087, -2.49146900799991],
              [10.080332879000082, -2.509209893999923],
              [10.094004754000082, -2.560316664999959],
              [10.07984459700009, -2.558200778999947],
              [10.07203209700009, -2.550876559999949],
              [10.067230665000068, -2.542901299999926],
              [10.062836134000065, -2.539320570999962],
              [10.054860873000052, -2.535088799999926],
              [10.043630405000044, -2.516289971999925],
              [10.035655144000089, -2.511976820999962],
              [10.028086785000085, -2.510918877999927],
              [10.015798373000052, -2.506280205999929],
              [10.008311394000089, -2.50514088299991],
              [10.004649285000085, -2.507745049999926],
              [10.005056186000047, -2.513604424999926],
              [10.006195509000065, -2.520196221999925],
              [10.00521894600007, -2.52507903399993],
              [9.998383009000065, -2.532647393999923],
              [9.99195397200009, -2.542168877999927],
              [9.986989780000044, -2.551934502999927],
              [9.98414147200009, -2.560316664999959],
              [9.97006269600007, -2.554294528999947],
              [9.957367384000065, -2.54615650799991],
              [9.961273634000065, -2.535902601999908],
              [9.955332879000082, -2.515232028999947],
              [9.957367384000065, -2.50514088299991],
              [9.96656334700009, -2.500420830999929],
              [9.97828209700009, -2.500746351999908],
              [9.988129102000073, -2.499932549999926],
              [9.99154707100007, -2.49146900799991],
              [9.979746941000087, -2.48170338299991],
              [9.954112175000091, -2.473239841999941],
              [9.926524285000085, -2.468519789999959],
              [9.908946160000085, -2.47039153399993],
              [9.88640384200005, -2.424248955999929],
              [9.884776238000086, -2.416436455999929],
              [9.874522332000083, -2.409356377999927],
              [9.869639519000089, -2.409356377999927],
              [9.867442254000082, -2.419528903999947],
              [9.863780144000089, -2.420179945999962],
              [9.84929446700005, -2.427911065999922],
              [9.847504102000073, -2.429457289999959],
              [9.82203209700009, -2.424248955999929],
              [9.79818769600007, -2.442152601999908],
              [9.775401238000086, -2.464043877999927],
              [9.751963738000086, -2.47039153399993],
              [9.742360873000052, -2.465020440999922],
              [9.733246290000068, -2.455824476999908],
              [9.726735873000052, -2.444512627999927],
              [9.72396894600007, -2.432549737999921],
              [9.726410352000073, -2.42937590899993],
              [9.73804772200009, -2.418715101999908],
              [9.741465691000087, -2.416436455999929],
              [9.747080925000091, -2.41334400799991],
              [9.739268425000091, -2.407159112999921],
              [9.72820071700005, -2.40203215899993],
              [9.72396894600007, -2.402113539999959],
              [9.72234134200005, -2.39381275799991],
              [9.723887566000087, -2.385837497999944],
              [9.72396894600007, -2.379082940999922],
              [9.717784050000091, -2.374769789999959],
              [9.709320509000065, -2.373467705999929],
              [9.70281009200005, -2.374118747999944],
              [9.698415561000047, -2.377536716999941],
              [9.69662519600007, -2.38445403399993],
              [9.709239129000082, -2.408135674999926],
              [9.71265709700009, -2.422946872999944],
              [9.703461134000065, -2.435723565999922],
              [9.687673373000052, -2.428887627999927],
              [9.64584394600007, -2.378838799999926],
              [9.628428582000083, -2.367364190999922],
              [9.637705925000091, -2.381768487999921],
              [9.65984134200005, -2.408461195999962],
              [9.668793165000068, -2.422621351999908],
              [9.646494988000086, -2.407647393999923],
              [9.619802280000044, -2.381768487999921],
              [9.59701582100007, -2.352227471999925],
              [9.586761915000068, -2.326429945999962],
              [9.586761915000068, -2.320896091999941],
              [9.579112175000091, -2.298028252999927],
              [9.573252800000091, -2.207207940999922],
              [9.56576582100007, -2.192559502999927],
              [9.46656334700009, -2.094903252999927],
              [9.439789259000065, -2.07976653399993],
              [9.409434441000087, -2.043715101999908],
              [9.395192905000044, -2.032321872999944],
              [9.397959832000083, -2.028415622999944],
              [9.40202884200005, -2.018487237999921],
              [9.380381707000083, -2.012627862999921],
              [9.368011915000068, -1.995212497999944],
              [9.354177280000044, -1.957126559999949],
              [9.31226647200009, -1.915948174999926],
              [9.305674675000091, -1.90553150799991],
              [9.301117384000065, -1.90398528399993],
              [9.291677280000044, -1.895440362999921],
              [9.283213738000086, -1.885918877999927],
              [9.281911655000044, -1.881442966999941],
              [9.27125084700009, -1.87664153399993],
              [9.273610873000052, -1.866957289999959],
              [9.28093509200005, -1.860446872999944],
              [9.285329623000052, -1.864353122999944],
              [9.29273522200009, -1.882582289999959],
              [9.311045769000089, -1.896742445999962],
              [9.33375084700009, -1.90398528399993],
              [9.354177280000044, -1.901788018999923],
              [9.351817254000082, -1.905857028999947],
              [9.350596550000091, -1.906670830999929],
              [9.34937584700009, -1.906996351999908],
              [9.346690300000091, -1.909356377999927],
              [9.359711134000065, -1.914727471999925],
              [9.36687259200005, -1.909356377999927],
              [9.374522332000083, -1.888278903999947],
              [9.380707227000073, -1.888278903999947],
              [9.388194207000083, -1.909356377999927],
              [9.382334832000083, -1.91139088299991],
              [9.377940300000091, -1.914157809999949],
              [9.375498894000089, -1.918633721999925],
              [9.374522332000083, -1.925713799999926],
              [9.377940300000091, -1.931817315999922],
              [9.384776238000086, -1.92742278399993],
              [9.389903191000087, -1.919691664999959],
              [9.388194207000083, -1.915622653999947],
              [9.439463738000086, -1.915622653999947],
              [9.467295769000089, -1.922458591999941],
              [9.481293165000068, -1.93914153399993],
              [9.478770379000082, -1.959567966999941],
              [9.456553582000083, -1.977634372999944],
              [9.46851647200009, -1.990817966999941],
              [9.474945509000065, -1.996026299999926],
              [9.480723504000082, -1.998142184999949],
              [9.502452019000089, -2.000095309999949],
              [9.508067254000082, -2.001560153999947],
              [9.510590040000068, -2.00750090899993],
              [9.510508660000085, -2.024834893999923],
              [9.511892123000052, -2.032321872999944],
              [9.532237175000091, -2.045830987999921],
              [9.53288821700005, -2.050551039999959],
              [9.537852410000085, -2.062758070999962],
              [9.543223504000082, -2.070896091999941],
              [9.545909050000091, -2.063246351999908],
              [9.549082879000082, -2.058200778999947],
              [9.563161655000044, -2.052911065999922],
              [9.566416863000086, -2.049574476999908],
              [9.563731316000087, -2.031670830999929],
              [9.557139519000089, -2.011651299999926],
              [9.54851321700005, -1.99773528399993],
              [9.539073113000086, -1.998142184999949],
              [9.528168165000068, -1.985446872999944],
              [9.50367272200009, -1.968519789999959],
              [9.498057488000086, -1.957126559999949],
              [9.509776238000086, -1.939548434999949],
              [9.51929772200009, -1.933038018999923],
              [9.517751498000052, -1.926446221999925],
              [9.485199415000068, -1.87037525799991],
              [9.466644727000073, -1.851332289999959],
              [9.456553582000083, -1.860935153999947],
              [9.44117272200009, -1.851983330999929],
              [9.436045769000089, -1.847263278999947],
              [9.432465040000068, -1.856622002999927],
              [9.432383660000085, -1.866143487999921],
              [9.436045769000089, -1.888278903999947],
              [9.41732832100007, -1.872979424999926],
              [9.39193769600007, -1.826348565999922],
              [9.374522332000083, -1.819268487999921],
              [9.367198113000086, -1.82586028399993],
              [9.362478061000047, -1.83757903399993],
              [9.359548373000052, -1.84889088299991],
              [9.35718834700009, -1.854099216999941],
              [9.347666863000086, -1.857191664999959],
              [9.342133009000065, -1.865329684999949],
              [9.340017123000052, -1.876153252999927],
              [9.340505405000044, -1.888278903999947],
              [9.333262566000087, -1.880954684999949],
              [9.32553144600007, -1.876153252999927],
              [9.316661004000082, -1.873955987999921],
              [9.305674675000091, -1.873955987999921],
              [9.317230665000068, -1.854099216999941],
              [9.314952019000089, -1.842868747999944],
              [9.292165561000047, -1.826104424999926],
              [9.270192905000044, -1.840427341999941],
              [9.255381707000083, -1.83521900799991],
              [9.246918165000068, -1.815524997999944],
              [9.244313998000052, -1.785821221999925],
              [9.245127800000091, -1.774102471999925],
              [9.24935957100007, -1.756605726999908],
              [9.250336134000065, -1.748223565999922],
              [9.250336134000065, -1.706963799999926],
              [9.248545769000089, -1.696058851999908],
              [9.239756707000083, -1.673760674999926],
              [9.236827019000089, -1.662286065999922],
              [9.23796634200005, -1.631280205999929],
              [9.236827019000089, -1.621270440999922],
              [9.22006269600007, -1.57976653399993],
              [9.197276238000086, -1.548272393999923],
              [9.141856316000087, -1.490980726999908],
              [9.016612175000091, -1.315850518999923],
              [9.007090691000087, -1.29851653399993],
              [8.996918165000068, -1.273695570999962],
              [8.988291863000086, -1.251722914999959],
              [8.983571811000047, -1.230889580999929],
              [8.996918165000068, -1.257582289999959],
              [9.007090691000087, -1.287367445999962],
              [9.019379102000073, -1.304782809999949],
              [9.03874759200005, -1.326429945999962],
              [9.054209832000083, -1.324883721999925],
              [9.069834832000083, -1.33171965899993],
              [9.082286004000082, -1.343519789999959],
              [9.092539910000085, -1.375095309999949],
              [9.115977410000085, -1.399509372999944],
              [9.121348504000082, -1.419040622999944],
              [9.127614780000044, -1.428887627999927],
              [9.159190300000091, -1.46803150799991],
              [9.172618035000085, -1.476739190999922],
              [9.178721550000091, -1.483330987999921],
              [9.226817254000082, -1.522067966999941],
              [9.235199415000068, -1.526543877999927],
              [9.264659050000091, -1.535332940999922],
              [9.274180535000085, -1.659600518999923],
              [9.280284050000091, -1.67506275799991],
              [9.292165561000047, -1.669691664999959],
              [9.295095248000052, -1.65943775799991],
              [9.285980665000068, -1.64576588299991],
              [9.28874759200005, -1.63836028399993],
              [9.297536655000044, -1.634535414999959],
              [9.305023634000065, -1.638441664999959],
              [9.310394727000073, -1.646661065999922],
              [9.312510613000086, -1.655450127999927],
              [9.32748457100007, -1.63836028399993],
              [9.35092207100007, -1.624769789999959],
              [9.377696160000085, -1.61646900799991],
              [9.40202884200005, -1.614434502999927],
              [9.39625084700009, -1.630059502999927],
              [9.395030144000089, -1.646905205999929],
              [9.400645379000082, -1.66139088299991],
              [9.415537957000083, -1.669691664999959],
              [9.422618035000085, -1.635918877999927],
              [9.422129754000082, -1.619398695999962],
              [9.415537957000083, -1.607598565999922],
              [9.446787957000083, -1.603285414999959],
              [9.529551629000082, -1.614434502999927],
              [9.559580925000091, -1.607598565999922],
              [9.518321160000085, -1.591729424999926],
              [9.502452019000089, -1.579847914999959],
              [9.490570509000065, -1.55982838299991],
              [9.481293165000068, -1.522556247999944],
              [9.48015384200005, -1.500746351999908],
              [9.484385613000086, -1.484144789999959],
              [9.47624759200005, -1.481622002999927],
              [9.456553582000083, -1.470472914999959],
              [9.452159050000091, -1.469903252999927],
              [9.439463738000086, -1.470472914999959],
              [9.432302280000044, -1.473077080999929],
              [9.431813998000052, -1.479424737999921],
              [9.436045769000089, -1.494317315999922],
              [9.434580925000091, -1.504571221999925],
              [9.431162957000083, -1.509698174999926],
              [9.426931186000047, -1.513116143999923],
              [9.40202884200005, -1.546482028999947],
              [9.379079623000052, -1.562920830999929],
              [9.351898634000065, -1.570977471999925],
              [9.319346550000091, -1.57350025799991],
              [9.312673373000052, -1.574883721999925],
              [9.30632571700005, -1.576918226999908],
              [9.299815300000091, -1.57740650799991],
              [9.292165561000047, -1.57350025799991],
              [9.286631707000083, -1.56609465899993],
              [9.285411004000082, -1.549981377999927],
              [9.278330925000091, -1.535332940999922],
              [9.277517123000052, -1.526136976999908],
              [9.278330925000091, -1.507989190999922],
              [9.274180535000085, -1.503024997999944],
              [9.26498457100007, -1.500664971999925],
              [9.255381707000083, -1.499444268999923],
              [9.250336134000065, -1.49773528399993],
              [9.248545769000089, -1.482028903999947],
              [9.256602410000085, -1.471449476999908],
              [9.27125084700009, -1.465508721999925],
              [9.28874759200005, -1.463636976999908],
              [9.297129754000082, -1.457696221999925],
              [9.298838738000086, -1.444105726999908],
              [9.294769727000073, -1.429945570999962],
              [9.285329623000052, -1.422051690999922],
              [9.285329623000052, -1.415785414999959],
              [9.29428144600007, -1.41334400799991],
              [9.318207227000073, -1.411065362999921],
              [9.326182488000086, -1.408379815999922],
              [9.334157748000052, -1.398614190999922],
              [9.338633660000085, -1.379652601999908],
              [9.354502800000091, -1.350518487999921],
              [9.35124759200005, -1.33326588299991],
              [9.333018425000091, -1.29851653399993],
              [9.338389519000089, -1.292413018999923],
              [9.339366082000083, -1.287774346999925],
              [9.335459832000083, -1.283379815999922],
              [9.326182488000086, -1.278008721999925],
              [9.325694207000083, -1.297946872999944],
              [9.333018425000091, -1.350192966999941],
              [9.330251498000052, -1.360935153999947],
              [9.322927280000044, -1.370863539999959],
              [9.312998894000089, -1.37818775799991],
              [9.302256707000083, -1.381117445999962],
              [9.293223504000082, -1.378024997999944],
              [9.28492272200009, -1.364190362999921],
              [9.278330925000091, -1.36060963299991],
              [9.262054884000065, -1.366143487999921],
              [9.251963738000086, -1.380303643999923],
              [9.243988477000073, -1.394952080999929],
              [9.233653191000087, -1.40162525799991],
              [9.185720248000052, -1.410577080999929],
              [9.169118686000047, -1.408379815999922],
              [9.15796959700009, -1.395196221999925],
              [9.154795769000089, -1.374200127999927],
              [9.156504754000082, -1.35475025799991],
              [9.159190300000091, -1.346368096999925],
              [9.156911655000044, -1.34498463299991],
              [9.15007571700005, -1.338636976999908],
              [9.146494988000086, -1.332289320999962],
              [9.141774936000047, -1.334079684999949],
              [9.135996941000087, -1.337985934999949],
              [9.126231316000087, -1.342054945999962],
              [9.124278191000087, -1.345961195999962],
              [9.119883660000085, -1.348565362999921],
              [9.10710696700005, -1.346368096999925],
              [9.092539910000085, -1.338067315999922],
              [9.057383660000085, -1.311700127999927],
              [9.042165561000047, -1.30592213299991],
              [9.030039910000085, -1.299086195999962],
              [9.02125084700009, -1.28248463299991],
              [9.018809441000087, -1.262139580999929],
              [9.025726759000065, -1.243910414999959],
              [9.022471550000091, -1.240329684999949],
              [9.020762566000087, -1.23756275799991],
              [9.018321160000085, -1.230889580999929],
              [9.037771030000044, -1.216729424999926],
              [9.033050977000073, -1.193454684999949],
              [9.015798373000052, -1.169854424999926],
              [8.997243686000047, -1.155205987999921],
              [9.009776238000086, -1.185316664999959],
              [9.003916863000086, -1.212334893999923],
              [9.000498894000089, -1.221368096999925],
              [8.994151238000086, -1.22039153399993],
              [8.990896030000044, -1.209649346999925],
              [8.983571811000047, -1.148370049999926],
              [8.966644727000073, -1.104424737999921],
              [8.867442254000082, -0.976983330999929],
              [8.893402540000068, -1.001560153999947],
              [8.907725457000083, -1.008558851999908],
              [8.922699415000068, -1.003676039999959],
              [8.908457879000082, -0.997491143999923],
              [8.914398634000065, -0.98406340899993],
              [8.922699415000068, -0.972588799999926],
              [8.930674675000091, -0.965101820999962],
              [8.935720248000052, -0.963474216999941],
              [8.924001498000052, -0.95826588299991],
              [8.894704623000052, -0.978122653999947],
              [8.877452019000089, -0.973728122999944],
              [8.87086022200009, -0.957696221999925],
              [8.864512566000087, -0.933038018999923],
              [8.856944207000083, -0.915948174999926],
              [8.84701582100007, -0.922458591999941],
              [8.83961022200009, -0.922458591999941],
              [8.831065300000091, -0.886814059999949],
              [8.82585696700005, -0.874607028999947],
              [8.810720248000052, -0.848809502999927],
              [8.784353061000047, -0.789157809999949],
              [8.762950066000087, -0.752618096999925],
              [8.74968509200005, -0.699965101999908],
              [8.718923373000052, -0.660251559999949],
              [8.695567254000082, -0.586602471999925],
              [8.709157748000052, -0.565606377999927],
              [8.71656334700009, -0.572930596999925],
              [8.707692905000044, -0.592217705999929],
              [8.718597852000073, -0.60084400799991],
              [8.750824415000068, -0.60711028399993],
              [8.746429884000065, -0.616143487999921],
              [8.74545332100007, -0.622247002999927],
              [8.747080925000091, -0.627211195999962],
              [8.750824415000068, -0.633884372999944],
              [8.772308790000068, -0.633233330999929],
              [8.787364129000082, -0.657647393999923],
              [8.795746290000068, -0.691827080999929],
              [8.800303582000083, -0.73365650799991],
              [8.80600019600007, -0.748304945999962],
              [8.815684441000087, -0.760023695999962],
              [8.829600457000083, -0.764743747999944],
              [8.837412957000083, -0.771579684999949],
              [8.83952884200005, -0.786309502999927],
              [8.844411655000044, -0.800225518999923],
              [8.86068769600007, -0.805108330999929],
              [8.851898634000065, -0.788018487999921],
              [8.85287519600007, -0.771254164999959],
              [8.857676629000082, -0.75359465899993],
              [8.86068769600007, -0.73365650799991],
              [8.866058790000068, -0.719496351999908],
              [8.879405144000089, -0.718357028999947],
              [8.896983269000089, -0.722263278999947],
              [8.914561394000089, -0.723239841999941],
              [8.914561394000089, -0.716403903999947],
              [8.904795769000089, -0.711846612999921],
              [8.894541863000086, -0.703789971999925],
              [8.887705925000091, -0.693291924999926],
              [8.887950066000087, -0.681573174999926],
              [8.895274285000085, -0.67506275799991],
              [8.904958530000044, -0.675876559999949],
              [8.92904707100007, -0.687269789999959],
              [8.938975457000083, -0.701348565999922],
              [8.946462436000047, -0.71843840899993],
              [8.949473504000082, -0.73365650799991],
              [8.957041863000086, -0.753513278999947],
              [8.993174675000091, -0.787204684999949],
              [9.004649285000085, -0.805108330999929],
              [9.005137566000087, -0.825290622999944],
              [8.998220248000052, -0.860446872999944],
              [9.004649285000085, -0.874607028999947],
              [9.01148522200009, -0.874607028999947],
              [9.015798373000052, -0.855889580999929],
              [9.018321160000085, -0.795179945999962],
              [9.023773634000065, -0.776299737999921],
              [9.047618035000085, -0.750176690999922],
              [9.052989129000082, -0.73365650799991],
              [9.052012566000087, -0.71998463299991],
              [9.05054772200009, -0.714288018999923],
              [9.052012566000087, -0.71062590899993],
              [9.059336785000085, -0.702732028999947],
              [9.065196160000085, -0.698988539999959],
              [9.08171634200005, -0.693291924999926],
              [9.087168816000087, -0.689629815999922],
              [9.089854363000086, -0.679294528999947],
              [9.087901238000086, -0.668715101999908],
              [9.089121941000087, -0.659926039999959],
              [9.100840691000087, -0.654880466999941],
              [9.114512566000087, -0.681573174999926],
              [9.112478061000047, -0.658298434999949],
              [9.100840691000087, -0.642347914999959],
              [9.092539910000085, -0.625664971999925],
              [9.100840691000087, -0.599704684999949],
              [9.160004102000073, -0.546807549999926],
              [9.177989129000082, -0.510837497999944],
              [9.267425977000073, -0.412367445999962],
              [9.292165561000047, -0.373711846999925],
              [9.306488477000073, -0.332289320999962],
              [9.305674675000091, -0.203057549999926],
              [9.313161655000044, -0.182061455999929],
              [9.33570397200009, -0.137302341999941],
              [9.340505405000044, -0.117120049999926],
              [9.34156334700009, -0.106133721999925],
              [9.345957879000082, -0.084730726999908],
              [9.346690300000091, -0.072686455999929],
              [9.344411655000044, -0.063490492999961],
              [9.333018425000091, -0.037896416999956],
              [9.334157748000052, -0.025404554999909],
              [9.33725019600007, -0.013482354999951],
              [9.342784050000091, -0.002740166999956],
              [9.350352410000085, 0.006781317000048],
              [9.355316602000073, 0.016180731000077],
              [9.353526238000086, 0.02484772300005],
              [9.34896894600007, 0.032904364000046],
              [9.346690300000091, 0.040594794000071],
              [9.34538821700005, 0.06195709800005],
              [9.31023196700005, 0.251288153000075],
              [9.298838738000086, 0.28351471600007],
              [9.302012566000087, 0.292547919000071],
              [9.307139519000089, 0.31899648600006],
              [9.309092644000089, 0.32453034100007],
              [9.313487175000091, 0.327460028000075],
              [9.34538821700005, 0.35578034100007],
              [9.356211785000085, 0.358628648000092],
              [9.365896030000044, 0.351548570000091],
              [9.374522332000083, 0.332017320000091],
              [9.37867272200009, 0.307562567000048],
              [9.37663821700005, 0.287298895000049],
              [9.367035352000073, 0.250067450000074],
              [9.36890709700009, 0.238430080000057],
              [9.373383009000065, 0.227443752000056],
              [9.373871290000068, 0.219183661000045],
              [9.363617384000065, 0.215969143000052],
              [9.358409050000091, 0.21165599200009],
              [9.356455925000091, 0.201727606000077],
              [9.357269727000073, 0.190130927000041],
              [9.360199415000068, 0.18109772300005],
              [9.36890709700009, 0.189113674000055],
              [9.374278191000087, 0.198065497000073],
              [9.380381707000083, 0.20538971600007],
              [9.391612175000091, 0.20844147300005],
              [9.424327019000089, 0.208197333000044],
              [9.429209832000083, 0.205023505000042],
              [9.434580925000091, 0.19212474200009],
              [9.460785352000073, 0.166489976000094],
              [9.47006269600007, 0.147040106000077],
              [9.473480665000068, 0.109198309000078],
              [9.47982832100007, 0.103583075000074],
              [9.48804772200009, 0.098334052000041],
              [9.494965040000068, 0.098456122000073],
              [9.498057488000086, 0.109198309000078],
              [9.492523634000065, 0.152004299000055],
              [9.493662957000083, 0.169989325000074],
              [9.504242384000065, 0.187974351000094],
              [9.553721550000091, 0.174058335000041],
              [9.566416863000086, 0.167466539000088],
              [9.571787957000083, 0.156480210000041],
              [9.580251498000052, 0.121771552000041],
              [9.586761915000068, 0.112290757000039],
              [9.59115644600007, 0.119208075000074],
              [9.619313998000052, 0.14720286700009],
              [9.628428582000083, 0.153794664000088],
              [9.643565300000091, 0.153021552000041],
              [9.652354363000086, 0.146877346000053],
              [9.662608269000089, 0.126532294000071],
              [9.712412957000083, 0.134833075000074],
              [9.748871290000068, 0.097845770000049],
              [9.779551629000082, 0.04946523600006],
              [9.81218509200005, 0.023504950000074],
              [9.775563998000052, 0.090399481000077],
              [9.761241082000083, 0.109198309000078],
              [9.758555535000085, 0.125555731000077],
              [9.778086785000085, 0.134466864000046],
              [9.803884311000047, 0.133246161000045],
              [9.819590691000087, 0.119086005000042],
              [9.831879102000073, 0.126776434000078],
              [9.850352410000085, 0.150783596000053],
              [9.861175977000073, 0.161281643000052],
              [9.896332227000073, 0.183498440000051],
              [9.908946160000085, 0.187974351000094],
              [9.925059441000087, 0.187689520000049],
              [9.954274936000047, 0.176947333000044],
              [9.97046959700009, 0.173651434000078],
              [9.985199415000068, 0.174953518000052],
              [10.025645379000082, 0.187974351000094],
              [10.025645379000082, 0.195461330000057],
              [9.975433790000068, 0.194322007000039],
              [9.955821160000085, 0.200018622000073],
              [9.936289910000085, 0.215969143000052],
              [9.920909050000091, 0.20579661700009],
              [9.902354363000086, 0.196844794000071],
              [9.882660352000073, 0.190415757000039],
              [9.805430535000085, 0.185695705000057],
              [9.792246941000087, 0.18109772300005],
              [9.747243686000047, 0.196437893000052],
              [9.734629754000082, 0.205023505000042],
              [9.719574415000068, 0.218573309000078],
              [9.711436394000089, 0.223211981000077],
              [9.679698113000086, 0.222154039000088],
              [9.668955925000091, 0.227240302000041],
              [9.621104363000086, 0.263088283000059],
              [9.586436394000089, 0.283636786000045],
              [9.572113477000073, 0.298325914000088],
              [9.566416863000086, 0.318304755000042],
              [9.559580925000091, 0.318304755000042],
              [9.553884311000047, 0.306138414000088],
              [9.54818769600007, 0.302557684000078],
              [9.535655144000089, 0.304673570000091],
              [9.527517123000052, 0.302232164000088],
              [9.505056186000047, 0.292303778000075],
              [9.498057488000086, 0.290961005000042],
              [9.490082227000073, 0.302435614000046],
              [9.48414147200009, 0.338080145000049],
              [9.473480665000068, 0.345648505000042],
              [9.459320509000065, 0.359930731000077],
              [9.411387566000087, 0.469916083000044],
              [9.398692254000082, 0.488714911000045],
              [9.37086022200009, 0.520086981000077],
              [9.352224155000044, 0.529242255000042],
              [9.334646030000044, 0.527899481000077],
              [9.319021030000044, 0.528631903000075],
              [9.305674675000091, 0.544256903000075],
              [9.304860873000052, 0.55890534100007],
              [9.308848504000082, 0.61399974200009],
              [9.315928582000083, 0.626166083000044],
              [9.33765709700009, 0.62836334800005],
              [9.360199415000068, 0.633042710000041],
              [9.371429884000065, 0.637640692000048],
              [9.391774936000047, 0.649359442000048],
              [9.40202884200005, 0.653509833000044],
              [9.41537519600007, 0.655218817000048],
              [9.424082879000082, 0.652818101000094],
              [9.43295332100007, 0.64915599200009],
              [9.446543816000087, 0.647284247000073],
              [9.45476321700005, 0.649400132000039],
              [9.468272332000083, 0.65884023600006],
              [9.486582879000082, 0.665961005000042],
              [9.502289259000065, 0.675848700000074],
              [9.520030144000089, 0.683539130000042],
              [9.539073113000086, 0.681463934000078],
              [9.555430535000085, 0.665228583000044],
              [9.562836134000065, 0.642157294000071],
              [9.559255405000044, 0.621527411000045],
              [9.542491082000083, 0.612494208000044],
              [9.499034050000091, 0.621771552000041],
              [9.477793816000087, 0.619086005000042],
              [9.464040561000047, 0.598863023000092],
              [9.487152540000068, 0.605943101000094],
              [9.516449415000068, 0.60415273600006],
              [9.539886915000068, 0.59125397300005],
              [9.545909050000091, 0.56476471600007],
              [9.557790561000047, 0.568548895000049],
              [9.566579623000052, 0.575506903000075],
              [9.571787957000083, 0.585679429000038],
              [9.573252800000091, 0.598863023000092],
              [9.58529707100007, 0.582831122000073],
              [9.587087436000047, 0.553697007000039],
              [9.581879102000073, 0.525091864000046],
              [9.573252800000091, 0.51007721600007],
              [9.582774285000085, 0.481634833000044],
              [9.590830925000091, 0.472886460000041],
              [9.607920769000089, 0.469183661000045],
              [9.603526238000086, 0.48501211100006],
              [9.603688998000052, 0.505357164000088],
              [9.608571811000047, 0.523138739000046],
              [9.617523634000065, 0.530585028000075],
              [9.623871290000068, 0.539496161000045],
              [9.63412519600007, 0.582912502000056],
              [9.642100457000083, 0.598863023000092],
              [9.628428582000083, 0.618719794000071],
              [9.625010613000086, 0.63930898600006],
              [9.628428582000083, 0.688299872000073],
              [9.618174675000091, 0.806789455000057],
              [9.582774285000085, 0.90070221600007],
              [9.579925977000073, 0.924750067000048],
              [9.57553144600007, 0.940822658000059],
              [9.567067905000044, 0.951117255000042],
              [9.561534050000091, 0.962795315000051],
              [9.566416863000086, 0.983099677000041],
              [9.578949415000068, 1.004380601000094],
              [9.592051629000082, 1.014349677000041],
              [9.606700066000087, 1.017279364000046],
              [9.62476647200009, 1.017279364000046],
              [9.642425977000073, 1.022284247000073],
              [9.65211022200009, 1.034328518000052],
              [9.658946160000085, 1.048000393000052],
              [9.668793165000068, 1.058172919000071],
              [9.686778191000087, 1.06126536700009],
              [9.745127800000091, 1.059719143000052],
              [9.761241082000083, 1.054754950000074],
              [9.774668816000087, 1.032863674000055],
              [9.783050977000073, 0.990057684000078],
              [9.792246941000087, 0.968817450000074],
              [9.80046634200005, 0.985825914000088],
              [9.804371181110866, 0.998353939898678],
              [9.834107300000142, 0.994927470000107],
              [9.849610230000081, 0.989243062000071],
              [9.866146688000072, 0.977564189000091],
              [9.892088257000097, 0.947901917000124],
              [9.908624715000087, 0.935086161000058],
              [9.926298055000103, 0.927541402000102],
              [9.94407474700003, 0.924854228000072],
              [9.959991088000066, 0.928368226000117],
              [9.971773315000064, 0.93984039300004],
              [9.975390665000134, 0.952966207000102],
              [9.975494018000063, 0.982576803000057],
              [9.980765015000088, 0.997201233000027],
              [10.000383932000148, 0.999742112000121],
              [10.029444214000137, 1.003505758000045],
              [10.138584838000071, 1.003092347000035],
              [10.41504549800004, 1.002233773000043],
              [10.438101440000054, 1.00216217100008],
              [10.737411336000093, 1.001128642000097],
              [10.96383408100013, 1.000425223000065],
              [11.036824584000044, 1.000198466000128],
              [11.33634118700013, 0.99916493700006],
              [11.334790894000093, 1.261164449000134],
              [11.333240600000067, 1.523138123000123],
              [11.332000870000087, 1.732611267000095],
              [11.331690308000049, 1.785085958000096],
              [11.33014001500004, 2.047137146000097],
              [11.32972660300004, 2.127442322000121],
              [11.322078491000042, 2.165760396000039],
              [11.328486368000085, 2.176302389000099],
              [11.332413778000046, 2.188032938000077],
              [11.334170776000121, 2.200280253000102],
              [11.334170776000121, 2.212785950000111],
              [11.335927775000101, 2.229167378000056],
              [11.34223230000012, 2.24058787000007],
              [11.349983764000115, 2.251129862000127],
              [11.355978231000051, 2.265185852000045],
              [11.354324585000114, 2.278466695000063],
              [11.349777059000075, 2.291489156000097],
              [11.35163741000008, 2.300584209000064],
              [11.618597860000108, 2.310402731000039],
              [11.644642781000101, 2.319652812000044],
              [11.65725183100011, 2.322495016000119],
              [11.671204468000099, 2.320996399000109],
              [11.681022990000088, 2.31541534500009],
              [11.70138350500011, 2.298723857000056],
              [11.752749878000145, 2.281877340000079],
              [11.768149455000042, 2.280172017000027],
              [11.802152547000077, 2.28482289600008],
              [11.889795776000085, 2.282084045000133],
              [11.966173543000139, 2.28875030500005],
              [12.041931193000039, 2.283996073000054],
              [12.10073897300012, 2.28849192300008],
              [12.118825724000118, 2.2878201300001],
              [12.1592366940001, 2.281412252000052],
              [12.202644897000113, 2.279551901000048],
              [12.222592000000105, 2.283324280000073],
              [12.261039266000068, 2.296191712000066],
              [12.280779663000118, 2.299033915000052],
              [12.291218303000079, 2.301772766000084],
              [12.312095581000051, 2.312934875000025],
              [12.321604045000129, 2.314071757000121],
              [12.334006388000091, 2.309575907000109],
              [12.366769246000104, 2.289577128000076],
              [12.384855997000102, 2.285908102000079],
              [12.43994307400007, 2.298517151000098],
              [12.478390340000118, 2.29588165300008],
              [12.534200887000083, 2.277691549000053],
              [12.551460816000088, 2.272265523000073],
              [12.574818563000122, 2.277691549000053],
              [12.590734904000044, 2.265702616000084],
              [12.614609416000121, 2.256917623000092],
              [12.749898315000081, 2.236712138000101],
              [12.770155477000088, 2.240691224000088],
              [12.784108113000087, 2.249527893000092],
              [12.795580282000117, 2.258777975000015],
              [12.808189331000051, 2.264048971000136],
              [12.825242554000056, 2.259243062000039],
              [12.848083537000065, 2.249321187000135],
              [12.867823934000029, 2.244980368000057],
              [12.876402222000081, 2.257176005000076],
              [12.890458211000094, 2.251388245000101],
              [12.903170613000043, 2.250354716000118],
              [12.914539429000115, 2.254540507000058],
              [12.924771362000115, 2.264048971000136],
              [12.954847046000083, 2.253248596000105],
              [12.972210327000084, 2.250354716000118],
              [12.98316573100007, 2.253455302000063],
              [12.996911662000116, 2.260018209000052],
              [13.012931355000148, 2.25629750500012],
              [13.040939982000083, 2.24420522000014],
              [13.083521362000056, 2.249527893000092],
              [13.093029826000134, 2.253455302000063],
              [13.113080281000066, 2.2727306110001],
              [13.12465580200012, 2.281050517000054],
              [13.133337443000073, 2.284512838000097],
              [13.163826538000052, 2.283169251000032],
              [13.191731812000057, 2.277691549000053],
              [13.205684448000028, 2.266891175000112],
              [13.212299032000118, 2.264048971000136],
              [13.22160078900015, 2.263945618000108],
              [13.235966837000149, 2.269888407000025],
              [13.242891479000036, 2.271490377000063],
              [13.254156941000105, 2.266891175000112],
              [13.269659871000016, 2.255729066000072],
              [13.284646037000101, 2.242241516000107],
              [13.294154500000076, 2.230510967000029],
              [13.298391968000118, 2.21583485900004],
              [13.294257854000108, 2.185759175000072],
              [13.294567912000076, 2.161057841000058],
            ],
          ],
          [
            [
              [8.997243686000047, -0.627618096999925],
              [9.033457879000082, -0.635430596999925],
              [9.041514519000089, -0.669854424999926],
              [9.037852410000085, -0.712090752999927],
              [9.03874759200005, -0.743747653999947],
              [9.021006707000083, -0.75554778399993],
              [9.006602410000085, -0.762139580999929],
              [8.992930535000085, -0.761163018999923],
              [8.977305535000085, -0.750583591999941],
              [8.96851647200009, -0.737399997999944],
              [8.96843509200005, -0.724867445999962],
              [8.971202019000089, -0.711521091999941],
              [8.971202019000089, -0.695896091999941],
              [8.966644727000073, -0.687269789999959],
              [8.95289147200009, -0.672784112999921],
              [8.949473504000082, -0.661716403999947],
              [8.949473504000082, -0.650648695999962],
              [8.951670769000089, -0.642998955999929],
              [8.963145379000082, -0.627618096999925],
              [8.97437584700009, -0.616957289999959],
              [8.996104363000086, -0.603692315999922],
              [9.004649285000085, -0.592868747999944],
              [9.010020379000082, -0.60279713299991],
              [9.010427280000044, -0.61101653399993],
              [9.005869988000086, -0.616957289999959],
              [8.997243686000047, -0.620212497999944],
              [8.997243686000047, -0.627618096999925],
            ],
          ],
          [
            [
              [9.376785597000037, 0.809985597000093],
              [9.38408559700008, 0.80962853200009],
              [9.379642662000037, 0.806971468000086],
              [9.376785597000037, 0.809985597000093],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Niger',
        iso3: 'NER',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [3.596400187000114, 11.69577301000001],
            [3.589372193000116, 11.701509095000063],
            [3.580070435000096, 11.717373759000068],
            [3.571698852000111, 11.721869608000091],
            [3.568184855000055, 11.729517721000065],
            [3.566221150000047, 11.738354391000072],
            [3.562500447000104, 11.746002503000057],
            [3.557436157000041, 11.76181549100005],
            [3.553715454000042, 11.769670309000077],
            [3.549271280000113, 11.773752746000085],
            [3.543690226000109, 11.777060038000087],
            [3.53697229000008, 11.782899476000068],
            [3.503485961000081, 11.829976705000064],
            [3.495424439000089, 11.837521464000105],
            [3.484262329000074, 11.845169577000092],
            [3.447675415000106, 11.85798533100008],
            [3.402820272000042, 11.885270488000089],
            [3.391658163000102, 11.888836161000057],
            [3.380909465000087, 11.895037334000051],
            [3.36912723800009, 11.897311096000067],
            [3.355071248000058, 11.889042868000018],
            [3.341635376000113, 11.88289337200004],
            [3.327786092000053, 11.886407369000096],
            [3.315487102000105, 11.894572246000024],
            [3.307012166000106, 11.902375387000035],
            [3.292749471000121, 11.918653463000055],
            [3.269908488000112, 11.956532288000048],
            [3.262570435000043, 11.97472239200009],
            [3.25760949700009, 11.997408346000057],
            [3.255129028000113, 12.018750712000056],
            [3.252028442000068, 12.024125062000024],
            [3.23848921700008, 12.034201965000051],
            [3.23538863100012, 12.039524638000103],
            [3.063409464000102, 12.193778789000106],
            [3.022895142000095, 12.252483215000069],
            [3.013076620000049, 12.27108673100011],
            [3.009355917000022, 12.276306051000034],
            [3.000984334000066, 12.278889873000125],
            [2.967808064000053, 12.282558899000037],
            [2.95602583800013, 12.286848043000091],
            [2.944967081000129, 12.292480774000126],
            [2.936802205000106, 12.300852357000096],
            [2.930394328000062, 12.323331604000103],
            [2.922642863000078, 12.335630595000055],
            [2.912617635000032, 12.346327616000067],
            [2.892257121000114, 12.357076314000082],
            [2.844301392000091, 12.39924428300013],
            [2.832415812000136, 12.384051413000108],
            [2.808644653000101, 12.38322458900008],
            [2.798412720000101, 12.381209209000133],
            [2.778155558000094, 12.381932678000041],
            [2.768543742000105, 12.380072327000036],
            [2.757484985000076, 12.372940979000091],
            [2.741465291000054, 12.354130758000082],
            [2.732266886000048, 12.34679270400008],
            [2.721828247000104, 12.344260560000095],
            [2.711286254000129, 12.351236878000094],
            [2.700434204000089, 12.347102763000066],
            [2.695059855000125, 12.341211650000076],
            [2.692165975000137, 12.33402862600012],
            [2.6902022700001, 12.326173808000078],
            [2.686894979000101, 12.31842234300008],
            [2.672942342000113, 12.296718241000079],
            [2.663847290000149, 12.291550598000072],
            [2.628603963000074, 12.300800680000094],
            [2.621679321000101, 12.299508769000042],
            [2.609690389000122, 12.290775452000062],
            [2.603592570000075, 12.287829895000073],
            [2.598631632000121, 12.288346659000098],
            [2.590053345000086, 12.293307597000052],
            [2.586125936000116, 12.294031067000049],
            [2.550572550000084, 12.284522604000074],
            [2.54602502400013, 12.281628724000086],
            [2.536929972000053, 12.273050436000048],
            [2.53124556500012, 12.26969146700013],
            [2.523700806000079, 12.26917470300009],
            [2.52060021900013, 12.27367055300003],
            [2.519049927000111, 12.27914825500011],
            [2.516259400000138, 12.281422017000125],
            [2.504477173000055, 12.28183542900004],
            [2.495072062000077, 12.283230692000117],
            [2.488044067000089, 12.280388489000046],
            [2.483393188000122, 12.268037822000082],
            [2.477708781000075, 12.257599182000149],
            [2.472644491000096, 12.259252829000104],
            [2.46696008300006, 12.265040588000076],
            [2.459518677000119, 12.266745911000044],
            [2.454351033000108, 12.26302520800003],
            [2.446082805000088, 12.251811422000074],
            [2.443705689000126, 12.249227600000083],
            [2.43088993300006, 12.247987366000046],
            [2.407945597000122, 12.248917542000086],
            [2.394199666000077, 12.247212219000033],
            [2.370015096000117, 12.23625681600005],
            [2.361230102000121, 12.218893535000035],
            [2.362056925000047, 12.196155905000055],
            [2.371875447000122, 12.140448711000118],
            [2.405568481000074, 12.04670766200006],
            [2.411149536000096, 12.03678578800006],
            [2.418280883000108, 12.02867258700006],
            [2.428616170000026, 12.020352682000095],
            [2.439261515000112, 12.015598450000098],
            [2.448769979000105, 12.013376364000095],
            [2.455281209000077, 12.008673808000111],
            [2.457348267000043, 11.996219787000129],
            [2.456728149000071, 11.97906321200007],
            [2.449390096000087, 11.977512919000048],
            [2.438951457000144, 11.981285299000078],
            [2.428926228000108, 11.980355123000024],
            [2.422001587000125, 11.973172099000067],
            [2.414146769000098, 11.958702698000138],
            [2.407428832000079, 11.9512096160001],
            [2.398747192000116, 11.94878082300005],
            [2.389342081000052, 11.950072734000088],
            [2.380867146000071, 11.947902324000012],
            [2.37518273900011, 11.935034892000104],
            [2.376526327000079, 11.924079489000036],
            [2.388205201000062, 11.906767884000118],
            [2.390168904000092, 11.896535950000057],
            [2.338079061000116, 11.940099182000083],
            [2.258807413000085, 12.048774720000026],
            [2.188527466000096, 12.145461324000081],
            [2.113803345000093, 12.247987366000046],
            [2.07091190500006, 12.306898499000056],
            [2.051791626000039, 12.341935120000073],
            [2.054168741000097, 12.370925599000131],
            [2.069258260000083, 12.383327942000022],
            [2.126929159000071, 12.395110169000105],
            [2.131476685000109, 12.398520814000051],
            [2.138711385000079, 12.408339336000012],
            [2.145015910000069, 12.411749980000124],
            [2.148013142000082, 12.410768127000068],
            [2.158761840000096, 12.405652160000074],
            [2.163826131000093, 12.404773661000135],
            [2.223254028000042, 12.409734599000089],
            [2.237930135000113, 12.413455302000102],
            [2.244958130000043, 12.424152324000104],
            [2.242994425000091, 12.446166484000088],
            [2.243097778000021, 12.451179098000054],
            [2.246301717000108, 12.461669414000099],
            [2.246301717000108, 12.465906880000148],
            [2.242270955000095, 12.473451640000093],
            [2.229558553000061, 12.487145895000111],
            [2.22387414500011, 12.494845683000023],
            [2.215709269000087, 12.510348612000115],
            [2.210851684000147, 12.523061015000081],
            [2.203203572000092, 12.583315735000056],
            [2.199999633000118, 12.595924784000076],
            [2.193281698000078, 12.609464009000064],
            [2.184289998000054, 12.620626119000093],
            [2.165996541000084, 12.631736552000106],
            [2.155454549000098, 12.640004781000059],
            [2.144809204000126, 12.650753479000073],
            [2.140985148000084, 12.656127828000123],
            [2.135197388000108, 12.675609843000117],
            [2.109049113000111, 12.705633851000087],
            [2.068948202000115, 12.716279196000073],
            [1.971693156000072, 12.72423736600004],
            [1.962494750000076, 12.71912139900006],
            [1.945544881000075, 12.700827942000075],
            [1.934486124000074, 12.693541565000103],
            [1.926631307000122, 12.694988505000097],
            [1.919603312000049, 12.698347473000098],
            [1.911438436000111, 12.696642151000049],
            [1.906994262000097, 12.69183624300004],
            [1.900172974000043, 12.678452047000093],
            [1.883223104000137, 12.653957418000047],
            [1.872681112000095, 12.634217021000083],
            [1.860692179000125, 12.617060445000021],
            [1.843742309000106, 12.606105042000138],
            [1.826068969000119, 12.604193014000117],
            [1.699461710000122, 12.61489003500013],
            [1.597039021000086, 12.623675029000111],
            [1.563862752000063, 12.63214996400012],
            [1.535854126000061, 12.647497864000087],
            [1.467124471000091, 12.704393616000047],
            [1.412037394000038, 12.749868876000107],
            [1.330595336000101, 12.817177429000097],
            [1.304806449000068, 12.838507989000092],
            [1.230756470000074, 12.899756368000041],
            [1.170915161000096, 12.949210714000074],
            [1.113967733000038, 12.996236267000143],
            [1.083788696000028, 13.010989888000054],
            [1.012268513000095, 13.016881002000062],
            [0.983536418000085, 13.032358093000056],
            [0.974648071000075, 13.048326111000094],
            [0.971754191000088, 13.067317200000062],
            [0.971661196000127, 13.085782453000121],
            [0.971340779000087, 13.149405213000065],
            [0.970824015000034, 13.243533834000047],
            [0.970410604000023, 13.32833485900008],
            [0.983536418000085, 13.368409933000066],
            [1.004723755000043, 13.364844259000094],
            [1.084718872000082, 13.333580018000106],
            [1.13846236100008, 13.320376689000113],
            [1.160683228000039, 13.311307475000149],
            [1.167607869000108, 13.313426209000028],
            [1.17763309800003, 13.347610169000106],
            [1.182387329000022, 13.358694764000035],
            [1.187658325000143, 13.364120789000097],
            [1.205745076000085, 13.358901469000088],
            [1.222074829000093, 13.3446129350001],
            [1.241505168000089, 13.335543721000136],
            [1.268686971000079, 13.346059875000094],
            [1.249566691000069, 13.367066346000101],
            [1.234270467000016, 13.37758250000006],
            [1.21742395000004, 13.381768290000096],
            [1.175049275000049, 13.38691009500009],
            [1.157169230000079, 13.392646179000053],
            [1.04823531100007, 13.441945496000045],
            [1.015265747000115, 13.465664978000092],
            [0.996558878000116, 13.496050721000046],
            [0.991391235000123, 13.541112569000092],
            [0.950980266000045, 13.583203024000028],
            [0.896926717000071, 13.614932353000142],
            [0.85072798600001, 13.628600769000059],
            [0.813107544000076, 13.625035095000086],
            [0.795330852000063, 13.625965271000055],
            [0.775693807000039, 13.635292867000075],
            [0.763704874000069, 13.646429138000101],
            [0.762878052000133, 13.653043722000106],
            [0.766288696000061, 13.657177836000116],
            [0.767012166000058, 13.66087270100013],
            [0.766185343000132, 13.666970520000092],
            [0.766392049000103, 13.675109558000102],
            [0.763498169000115, 13.682034200000075],
            [0.753369588000055, 13.684101258000041],
            [0.620664510000097, 13.679967143000027],
            [0.594309530000146, 13.68888132800005],
            [0.580460245000069, 13.713789368000107],
            [0.584801066000068, 13.729008077000046],
            [0.5945162350001, 13.749859517000104],
            [0.600510701000132, 13.76872141500013],
            [0.59368941200006, 13.778100687000077],
            [0.57446577900015, 13.785025330000067],
            [0.563200317000081, 13.796781718000062],
            [0.55296838400011, 13.810036723000067],
            [0.519275350000044, 13.831637472000125],
            [0.504082479000118, 13.845357564000054],
            [0.499925937000114, 13.851015080000096],
            [0.491990194000039, 13.861816508000032],
            [0.483515259000029, 13.880342509000059],
            [0.475660441000088, 13.888946635000096],
            [0.454809001000029, 13.902356669000142],
            [0.448633666000148, 13.909617208000029],
            [0.448065227000114, 13.920107524000073],
            [0.456255941000023, 13.938142599000074],
            [0.456695190000062, 13.94685007800004],
            [0.445920654000105, 13.958580628000021],
            [0.428376506000063, 13.96749481200004],
            [0.411865886000072, 13.97842437700011],
            [0.403933553000115, 13.996071879000098],
            [0.401866495000149, 14.013796895000027],
            [0.391376180000094, 14.022581889000023],
            [0.378353719000074, 14.0288089000001],
            [0.369155314000068, 14.039066671000086],
            [0.369051961000139, 14.047851664000078],
            [0.377320190000091, 14.063948873000058],
            [0.378457072000089, 14.070434265000102],
            [0.374219605000036, 14.078883362000099],
            [0.368741902000068, 14.084154358000134],
            [0.362463216000151, 14.088856913000114],
            [0.356262044000061, 14.095704041000076],
            [0.343575480000112, 14.114333395000045],
            [0.339157145000115, 14.125779725000143],
            [0.343472127000098, 14.137536113000053],
            [0.367398315000088, 14.173787130000093],
            [0.37215254700007, 14.185646871000117],
            [0.377423543000106, 14.216601054000122],
            [0.381118408000106, 14.225670268000087],
            [0.390601034000099, 14.23763336200004],
            [0.391634562000064, 14.245927430000094],
            [0.388792358000103, 14.251611837000041],
            [0.346366007000086, 14.30757741400005],
            [0.202382348000128, 14.435544541000127],
            [0.188649536000128, 14.447749736000034],
            [0.158832234000016, 14.496118877000072],
            [0.152941121000111, 14.546710103000109],
            [0.219707072000062, 14.73122080500005],
            [0.213092488000143, 14.761632386000116],
            [0.184102010000089, 14.819561666000055],
            [0.18575565600014, 14.84819040900004],
            [0.198002971000051, 14.86379669200008],
            [0.211852254000121, 14.874803772000064],
            [0.22084395400006, 14.88821380600011],
            [0.21846683800004, 14.910977275000093],
            [0.21278243000009, 14.960715841000109],
            [0.2131958410001, 14.985417175000109],
            [0.221257365000071, 14.995933329000081],
            [0.353187297000119, 14.963428854000142],
            [0.387035359000038, 14.963247986000098],
            [0.418790527000056, 14.969888408000102],
            [0.483515259000029, 14.992109274000128],
            [0.514831177000133, 14.993556213000119],
            [0.670067180000018, 14.939735209000105],
            [0.683813110000074, 14.940872091000116],
            [0.71140832500015, 14.947460836000104],
            [0.73993371600011, 14.958338725000061],
            [0.769182577000066, 14.969061585000077],
            [0.922144816000099, 14.97397084500011],
            [0.94932661900009, 14.979551900000033],
            [0.973717895000021, 14.9912566120001],
            [1.057537069000091, 15.067117615000114],
            [1.123062784000098, 15.126312968],
            [1.203161255000083, 15.198789165000093],
            [1.27085738100007, 15.259896546000093],
            [1.297832478000089, 15.2757353720001],
            [1.331525512000042, 15.28361602800004],
            [1.405216105000079, 15.286148173000129],
            [1.501747680000108, 15.289352112000103],
            [1.598382608000065, 15.292607728000078],
            [1.694914185000073, 15.295734151000133],
            [1.791445760000101, 15.298989766000119],
            [1.888080689000077, 15.302193706000082],
            [1.984612264000106, 15.305397645000056],
            [2.081350545000078, 15.308575744000024],
            [2.177882121000096, 15.311831360000014],
            [2.274517049000053, 15.31498362300006],
            [2.371048624000082, 15.318239238000046],
            [2.467683553000143, 15.321417338000103],
            [2.564215128000086, 15.324595439000078],
            [2.660953410000076, 15.32782521600005],
            [2.757484985000076, 15.331080831000037],
            [2.854119914000137, 15.334207256000084],
            [2.95065148900008, 15.33746287100007],
            [3.000157511000111, 15.339116516000033],
            [3.005738566000048, 15.352319844000107],
            [3.005841919000062, 15.389294332000063],
            [3.00780562300011, 15.407665304000133],
            [3.010286092000086, 15.417664693000063],
            [3.017520792000141, 15.422832337000074],
            [3.033540487000096, 15.426449687000058],
            [3.07302128000012, 15.427198995000055],
            [3.192290486000047, 15.407510274000103],
            [3.380392700000129, 15.376323547000126],
            [3.483332153000106, 15.359296163000096],
            [3.488809855000085, 15.35753916400003],
            [3.507103312000055, 15.353973491000062],
            [3.516508423000118, 15.469186097000076],
            [3.526533651000136, 15.495954489000027],
            [3.61407352700013, 15.547734274],
            [3.69220829300005, 15.631450094000044],
            [3.728898559000129, 15.650880432000022],
            [3.808376912000114, 15.66558237700012],
            [3.84610070800008, 15.685296936000086],
            [3.871215454000094, 15.714804179000097],
            [3.873849402000076, 15.720881837000078],
            [3.886511678000147, 15.750099183000074],
            [3.894469849000103, 15.788649801000062],
            [3.903461548000053, 15.886318258000088],
            [3.909869425000096, 15.9047667440001],
            [3.925062296000135, 15.927607727000023],
            [3.983249959000119, 15.983986715000029],
            [3.984180135000088, 15.986880595000017],
            [3.98480025300006, 15.989826152000106],
            [3.984593546000099, 15.995923971000067],
            [3.984696899000113, 15.997370911000061],
            [3.984490193000084, 15.998766175000057],
            [3.983973429000031, 16.000109762000122],
            [3.983249959000119, 16.00134999600006],
            [3.970847615000082, 16.03085723900007],
            [3.966920207000101, 16.058504130000088],
            [3.971157674000068, 16.086099345],
            [4.060557902000141, 16.298334453000038],
            [4.075647420000053, 16.321072083000033],
            [4.094767700000119, 16.340812480000082],
            [4.118228800000111, 16.35833079000004],
            [4.161740356000053, 16.379983215000024],
            [4.17589969900007, 16.39264394100006],
            [4.183961222000079, 16.416053365000025],
            [4.183444458000025, 16.52653757800006],
            [4.18303104600011, 16.612682190000058],
            [4.182307576000113, 16.746472473000026],
            [4.181997518000031, 16.809621074000077],
            [4.184581339000147, 16.81850942000007],
            [4.197603800000081, 16.83850819900003],
            [4.202047974000095, 16.848895162000034],
            [4.196570272000088, 16.947132060000044],
            [4.197810506000053, 16.965218811000042],
            [4.203701619000128, 16.982788798000016],
            [4.211659790000084, 16.9860444130001],
            [4.222305135000084, 16.98656117700004],
            [4.235637655000119, 16.995862935000062],
            [4.235327596000047, 17.10081777000009],
            [4.235017537000147, 17.163914694000127],
            [4.234707479000065, 17.287524719000103],
            [4.234294067000064, 17.411186422000114],
            [4.233777303000096, 17.534796448000108],
            [4.233363892000085, 17.658458151],
            [4.23305383200011, 17.782119853],
            [4.232640421000099, 17.905781556000093],
            [4.232408236000083, 17.975233873],
            [4.232227010000088, 18.029443258000086],
            [4.231916952000091, 18.153104960000107],
            [4.231503540000091, 18.2767408240001],
            [4.23109012900008, 18.400325012000067],
            [4.23067671700008, 18.524038392000094],
            [4.230270912000066, 18.645373847000073],
            [4.230263305000051, 18.64764841700007],
            [4.22984989400004, 18.771284281000064],
            [4.22943648200004, 18.894945984000074],
            [4.229023071000114, 19.018581849000057],
            [4.228609660000103, 19.14224355100005],
            [4.417228637000051, 19.178417054000093],
            [4.605847616000091, 19.214616394000117],
            [4.794466593000067, 19.250764059000048],
            [4.983188924000046, 19.286963399000072],
            [5.082821085000091, 19.306006165000056],
            [5.301825806000096, 19.347993266000074],
            [5.520830525000093, 19.389902853000038],
            [5.620462687000071, 19.40899729400003],
            [5.749343709000101, 19.433698629000062],
            [5.794302205000122, 19.449795838000014],
            [5.837607055000092, 19.478631287000056],
            [5.91636193800008, 19.54627573700013],
            [5.979407186000117, 19.600535991000086],
            [6.04255578600015, 19.654744568000112],
            [6.105601033000084, 19.70900482200004],
            [6.168646281000122, 19.763213399000065],
            [6.231691528000056, 19.81747365300002],
            [6.294736775000075, 19.871682231000065],
            [6.357782023000112, 19.92591664600009],
            [6.420930623000061, 19.980176900000046],
            [6.483769165000041, 20.03438547800006],
            [6.546917765000103, 20.088645732000103],
            [6.60996301300014, 20.14285430900013],
            [6.672956583000143, 20.197114563000085],
            [6.73610518400011, 20.25132314000011],
            [6.799047078000115, 20.30553171800004],
            [6.862092326000038, 20.359740295000066],
            [6.925137574000075, 20.414000549000022],
            [6.982808471000055, 20.463609925000085],
            [7.020532267000078, 20.49544260700013],
            [7.098046916000044, 20.558746236000033],
            [7.169463745000144, 20.61698557600006],
            [7.240880574000073, 20.675173238000056],
            [7.312297404000077, 20.73346425400011],
            [7.383610881000038, 20.791651917000095],
            [7.482726278000058, 20.872577210000102],
            [7.613777710000079, 20.949730123000066],
            [7.681887247000077, 20.989831034000062],
            [7.749790079000121, 21.029983622000074],
            [7.817899617000137, 21.07008453400006],
            [7.886009155000039, 21.110237122000072],
            [7.953911987000083, 21.150389710000084],
            [8.022021525000099, 21.19049062100008],
            [8.090131063000115, 21.230591533000066],
            [8.158033895000045, 21.27074412000009],
            [8.226143432000072, 21.310845032000074],
            [8.29425297000006, 21.350945944000088],
            [8.36225915500006, 21.391046855000084],
            [8.430265340000119, 21.43114776600008],
            [8.498374878000021, 21.471300354000064],
            [8.566381063000108, 21.511349589000062],
            [8.634490600000106, 21.551502177000074],
            [8.702496786000097, 21.591654765000087],
            [8.770606323000095, 21.6318073530001],
            [8.838612508000068, 21.671908265000084],
            [8.906722046000084, 21.712060852],
            [8.974831583000082, 21.752110087000077],
            [9.042837769000073, 21.79226267500009],
            [9.110843953000142, 21.832363587000074],
            [9.17895349100013, 21.872516175],
            [9.246959676000131, 21.912565410000084],
            [9.314965860000086, 21.952717997],
            [9.383075399000091, 21.992818909000064],
            [9.451081583000075, 22.03291982000006],
            [9.519087769000066, 22.073072408000073],
            [9.587197306000064, 22.113224997000103],
            [9.655203491000037, 22.1533259080001],
            [9.723313029000053, 22.193426819000095],
            [9.791319214000026, 22.233579407],
            [9.859325399000113, 22.273680318000075],
            [9.927434936000111, 22.31378123000009],
            [9.995441122000102, 22.353882142000074],
            [10.063447306000057, 22.394034729000097],
            [10.131556844000073, 22.434135641000083],
            [10.199563029000046, 22.474236552],
            [10.267569213000115, 22.514337463000075],
            [10.33567875200012, 22.554541728000103],
            [10.403788289000147, 22.59464264000009],
            [10.471691122000095, 22.634743551],
            [10.539800659000093, 22.674896139000012],
            [10.607806844000066, 22.714945374000095],
            [10.675813029000068, 22.75504628500009],
            [10.74392256700014, 22.795198873000075],
            [10.812032104000053, 22.835325623000088],
            [10.88003828900014, 22.875374857000068],
            [10.948147827000042, 22.91552744600007],
            [11.016257364000069, 22.955654195000093],
            [11.084366903000074, 22.99575510600009],
            [11.1522697340001, 23.035881857000092],
            [11.220379273000106, 23.076060283000103],
            [11.288488810000018, 23.1161611940001],
            [11.356391642000062, 23.156262106],
            [11.424501180000078, 23.196414693000108],
            [11.492610717000076, 23.236515605000093],
            [11.560513550000024, 23.27659067800009],
            [11.62862308700005, 23.316717428000075],
            [11.696732626000141, 23.3568441770001],
            [11.76473881000004, 23.396945089],
            [11.832744995000098, 23.43704600100007],
            [11.900854533000114, 23.477172750000094],
            [11.96886071700007, 23.517351176000105],
            [12.05702071100012, 23.497610779000055],
            [12.145284058000101, 23.477947897],
            [12.233650757000134, 23.458285014000055],
            [12.321810750000083, 23.438622132000106],
            [12.409970744000134, 23.41888173400004],
            [12.498337443000139, 23.39924469000003],
            [12.586497437000105, 23.379581808000083],
            [12.674657430000138, 23.35989308700003],
            [12.763024129000144, 23.340178528000067],
            [12.85118412300011, 23.320489808000033],
            [12.9394474690001, 23.300826925000067],
            [13.027607462000049, 23.281138204000015],
            [13.115870809000029, 23.261449483000078],
            [13.204134155000105, 23.241709087000018],
            [13.292397502000085, 23.22209788],
            [13.380660848000076, 23.202383322000017],
            [13.482256713000083, 23.17967153000005],
            [13.599562215000049, 23.119029236000088],
            [13.655786173000138, 23.072623799000056],
            [13.780894816000114, 22.96963267100007],
            [13.906055135000116, 22.866615703],
            [14.03100874800009, 22.763702087000027],
            [14.156169067000093, 22.66073679600005],
            [14.201644328000043, 22.623219706000057],
            [14.2162170820001, 22.616295064000084],
            [14.231720011000107, 22.61794871100004],
            [14.294868612000073, 22.64983306900008],
            [14.46602095600008, 22.73618438800007],
            [14.637069947000043, 22.82253570600001],
            [14.808015584000088, 22.908887024000066],
            [14.979167928000095, 22.99531585700005],
            [14.97927128000012, 22.995367534000067],
            [14.979909027000133, 22.995663760000085],
            [14.991983683000086, 22.93309743300007],
            [15.003972616000055, 22.87043975800013],
            [15.015858195000078, 22.80778208400001],
            [15.027950480000072, 22.745176087000104],
            [15.039939413000099, 22.682544251000067],
            [15.051928345000078, 22.61986073900006],
            [15.064020630000073, 22.55717722600012],
            [15.075906210000085, 22.4945970670001],
            [15.087998495000079, 22.431913554000076],
            [15.099987427000116, 22.369281718000067],
            [15.11207971200011, 22.306598206000032],
            [15.12406864500008, 22.243966370000024],
            [15.136057576000042, 22.1813345340001],
            [15.148149861000036, 22.118651022000066],
            [15.156314738000049, 22.076172994000032],
            [15.164479614000044, 22.033694967000073],
            [15.172024373000113, 21.993387350000134],
            [15.172437785000113, 21.973646952000067],
            [15.173264607000135, 21.921557109000034],
            [15.174608195000104, 21.847918193000012],
            [15.176055135000098, 21.763427226000047],
            [15.177502075000092, 21.678987936000013],
            [15.178845662000072, 21.60529734300009],
            [15.179775838000097, 21.553207500000028],
            [15.180085897000083, 21.533467102000074],
            [15.18039595500008, 21.50726715100005],
            [15.184530070000108, 21.49119578000007],
            [15.200239706000076, 21.476467998000075],
            [15.247471965000102, 21.453265280000082],
            [15.266592245000083, 21.440656230000045],
            [15.301008748000044, 21.401330465000072],
            [15.324779907000107, 21.366707255000065],
            [15.341419719000044, 21.342160950000093],
            [15.358266235000116, 21.31771799800005],
            [15.375009400000067, 21.293223369000103],
            [15.391752564000114, 21.268728739000053],
            [15.408495727000059, 21.24423411100007],
            [15.42534224400012, 21.219791158000035],
            [15.441982055000068, 21.195193177000064],
            [15.45882857200013, 21.170750224000116],
            [15.475571737000081, 21.146255595000056],
            [15.492211548000085, 21.12176096600011],
            [15.50905806500009, 21.09726633700005],
            [15.525801229000109, 21.072771709000094],
            [15.542544393000071, 21.048277079000044],
            [15.559287556000129, 21.02378245000007],
            [15.576134073000105, 20.999339498000055],
            [15.592773885000042, 20.974793192000064],
            [15.609310343000118, 20.950660299000035],
            [15.569002727000054, 20.928904521],
            [15.544301391000147, 20.890302226000117],
            [15.536033162000109, 20.844051819000057],
            [15.544198039000037, 20.798989970000022],
            [15.55608361800006, 20.773668519000026],
            [15.570242961000105, 20.751912740000122],
            [15.588123006000075, 20.732792460000027],
            [15.669461711000054, 20.671865946000068],
            [15.697263631000112, 20.6428754680001],
            [15.755554647000054, 20.582000631000042],
            [15.81384566300008, 20.521074117000083],
            [15.872033325000103, 20.460199280000055],
            [15.93032434100013, 20.39932444300011],
            [15.953992147000065, 20.374571432],
            [15.96815149000011, 20.352815654000082],
            [15.970321899000112, 20.3363308710001],
            [15.9629838460001, 20.31922597300006],
            [15.942519979000053, 20.28395680800007],
            [15.902419067000068, 20.214942932000028],
            [15.862318156000072, 20.145954896000077],
            [15.82232059800009, 20.07699269700005],
            [15.78232303800013, 20.008030498],
            [15.767233521000037, 19.98203725200004],
            [15.736020955000129, 19.903540751000023],
            [15.732403605000059, 19.861837871000077],
            [15.728372844000148, 19.816259257000084],
            [15.72434208100006, 19.770577291000066],
            [15.720207967000135, 19.72499867800009],
            [15.716177206000054, 19.679316712000073],
            [15.712146443000051, 19.633763937000097],
            [15.708115682000056, 19.58810780800009],
            [15.70408492100006, 19.542529196000103],
            [15.700054158000086, 19.496873068000113],
            [15.69602339700009, 19.451242778],
            [15.69209598800012, 19.40563832700012],
            [15.687961873000091, 19.360008036000025],
            [15.683931112000096, 19.31440358500005],
            [15.679900349000093, 19.268747457000032],
            [15.675869588000097, 19.223168844000057],
            [15.671838827000101, 19.177538554000037],
            [15.667808064000099, 19.131882426000047],
            [15.663777303000103, 19.08630381300007],
            [15.659746541000118, 19.040647685000053],
            [15.655715779000019, 18.995069072000078],
            [15.651581665000094, 18.94938710600006],
            [15.647550904000099, 18.903834331000084],
            [15.643520141000096, 18.858178203000065],
            [15.639592733000143, 18.8125995890001],
            [15.635561971000044, 18.76694346200007],
            [15.631531209000059, 18.72131317100009],
            [15.627500447000074, 18.67570872],
            [15.623469686000078, 18.630078430000097],
            [15.619438924000065, 18.584473979],
            [15.615304810000055, 18.538817851000104],
            [15.611274048000041, 18.493239238000015],
            [15.607243286000141, 18.447583110000025],
            [15.603212524000071, 18.402004496000032],
            [15.599181763000075, 18.35634836900003],
            [15.595151001000062, 18.310718079000125],
            [15.591120239000077, 18.26508778900002],
            [15.587192831000095, 18.21948333800013],
            [15.58316206800012, 18.173878886000054],
            [15.579027954000082, 18.128248597000052],
            [15.574997192000097, 18.08264414500006],
            [15.570966430000084, 18.037039694000057],
            [15.567697927000012, 18.00003856000005],
            [15.566935669000088, 17.991409403000077],
            [15.562904907000103, 17.945779114000075],
            [15.558874145000118, 17.900148825000073],
            [15.554843384000037, 17.85457021100008],
            [15.550812622000109, 17.808888245000063],
            [15.546781860000124, 17.763309631000098],
            [15.542647746000114, 17.717679342000096],
            [15.5386169840001, 17.672049052000105],
            [15.53468957500013, 17.626367086000087],
            [15.530658814000049, 17.580736796000096],
            [15.526628051000046, 17.535106507000094],
            [15.52259729000005, 17.4895278930001],
            [15.518566529000054, 17.443845927],
            [15.51453576600008, 17.39826731300009],
            [15.510505005000084, 17.352637024],
            [15.506370891000131, 17.30705841100003],
            [15.502340128000043, 17.26137644400002],
            [15.498309367000047, 17.215746155000105],
            [15.494278605000147, 17.170115866000017],
            [15.490247843000077, 17.124537252000025],
            [15.486217082000081, 17.07890696300005],
            [15.48228967300011, 17.033276672000042],
            [15.478258911000097, 16.987698059000067],
            [15.474124797000087, 16.942067770000065],
            [15.471954386000107, 16.91674631800008],
            [15.468517058000089, 16.904909712000105],
            [15.465546509000148, 16.894680481000066],
            [15.452420695000086, 16.876231994000065],
            [15.418417603000137, 16.84088531500005],
            [15.362400350000115, 16.78264597600004],
            [15.306279745000069, 16.724199931000058],
            [15.250159139000118, 16.66590891500003],
            [15.194038534000072, 16.607566223000063],
            [15.137917928000121, 16.549275208000026],
            [15.081797322000085, 16.49088083900007],
            [15.025780070000081, 16.432538148],
            [14.969659464000102, 16.374247131000075],
            [14.913538859000084, 16.315904439000022],
            [14.85741825300002, 16.25761342400007],
            [14.801401001000102, 16.199219056000018],
            [14.74538374800008, 16.14087636400008],
            [14.689263143000119, 16.08253367100012],
            [14.633142537000083, 16.024242655000066],
            [14.576918579000107, 15.96579661],
            [14.520797973000072, 15.907557272000062],
            [14.48214400200007, 15.867249654000105],
            [14.423542928000131, 15.806323141000078],
            [14.368972615000104, 15.749634095000076],
            [14.340447225000048, 15.710721741],
            [14.310681600000066, 15.669949036],
            [14.280709269000113, 15.629253846000054],
            [14.250943644000131, 15.58845530300006],
            [14.221178019000149, 15.547734274],
            [14.19120568800011, 15.507039083000038],
            [14.161440063000015, 15.46629221600007],
            [14.131571085000104, 15.425545350000107],
            [14.101702108000097, 15.384875997000051],
            [14.071833130000073, 15.344180806000097],
            [14.042067505000091, 15.303433940000033],
            [14.012198527000066, 15.262687073000052],
            [13.98232954900007, 15.221991882000097],
            [13.95256392400006, 15.181219177000116],
            [13.922591593000021, 15.140498149000052],
            [13.892825968000125, 15.099699605000069],
            [13.862956991000118, 15.059056092000034],
            [13.833914836000133, 15.019601136000105],
            [13.808076619000104, 14.965573426000034],
            [13.77541711400005, 14.897438049000115],
            [13.760534302000082, 14.866354675000068],
            [13.755159952000042, 14.847208558000062],
            [13.753919718000105, 14.82594370600009],
            [13.75795048000009, 14.805531514000052],
            [13.772006469000104, 14.762872620000053],
            [13.773246704000144, 14.74251210600002],
            [13.764358358000038, 14.719076843000053],
            [13.749165486000095, 14.711247864000114],
            [13.730045206000113, 14.709645895000094],
            [13.709994751000067, 14.705124207000068],
            [13.700021199000048, 14.697734477000054],
            [13.668085165000065, 14.662878723000077],
            [13.648344767000111, 14.649417013000033],
            [13.644727417000126, 14.644249369000121],
            [13.64627770900006, 14.639055888000101],
            [13.657026407000075, 14.629650777000052],
            [13.660333699000148, 14.623733826000134],
            [13.666741577000096, 14.58551910400007],
            [13.665604695000098, 14.566889751000105],
            [13.657853231000104, 14.548725484000073],
            [13.62426355000008, 14.521311137000026],
            [13.608052035000128, 14.518266228000059],
            [13.584369344000038, 14.513818054000083],
            [13.543855021000127, 14.510562439000097],
            [13.507784872000116, 14.495963847000041],
            [13.482256713000083, 14.483587341000074],
            [13.449493855000071, 14.439042257000068],
            [13.449183797000103, 14.380131124000059],
            [13.468304077000084, 14.310677999000092],
            [13.482256713000083, 14.259776713000065],
            [13.492695353000016, 14.21386220400008],
            [13.499723348000117, 14.18197784500012],
            [13.506958048000087, 14.150119324000059],
            [13.514192749000074, 14.118234965000099],
            [13.521324097000104, 14.086428121000054],
            [13.528455444000116, 14.05451792400008],
            [13.535690145000103, 14.02273691800005],
            [13.542821493000133, 13.99085255900009],
            [13.549952840000088, 13.958994039000032],
            [13.557187541000133, 13.927161357000088],
            [13.564318889000077, 13.895225321000098],
            [13.571450236000118, 13.86341847800007],
            [13.578581583000044, 13.831534119000096],
            [13.585816284000117, 13.799727275000066],
            [13.592947632000062, 13.767842916000092],
            [13.600182332000117, 13.735984396000049],
            [13.607313680000061, 13.704100037000075],
            [13.359990275000143, 13.714409485000076],
            [13.358919718000038, 13.714231979000132],
            [13.32991459100009, 13.709422709000123],
            [13.320716186000084, 13.702291362000082],
            [13.321232951000127, 13.685108948000021],
            [13.306040079000098, 13.674644471000079],
            [13.266145874000074, 13.638031719000125],
            [13.259221232000073, 13.628962505000061],
            [13.253846883000108, 13.61891143900003],
            [13.25353682500014, 13.614880676000041],
            [13.258601115000118, 13.607801005000113],
            [13.260048055000112, 13.60214243600008],
            [13.257257528000139, 13.594235942000125],
            [13.250849650000106, 13.592763163000114],
            [13.24382165500009, 13.593254090000059],
            [13.239480835000109, 13.591574605000105],
            [13.230179077000088, 13.577751160000048],
            [13.23224613400015, 13.572893575000123],
            [13.24640547700011, 13.57108490000013],
            [13.228112020000111, 13.548037212000068],
            [13.203927450000066, 13.539381409000029],
            [13.176952352000114, 13.534472148000091],
            [13.15018396000005, 13.52266408300008],
            [13.153697957000105, 13.530699768000062],
            [13.155868368000085, 13.54077667300001],
            [13.153697957000105, 13.548760681000076],
            [13.143982788000073, 13.55062103300007],
            [13.138401733000137, 13.546538595000072],
            [13.130960327000139, 13.529821269000124],
            [13.123518921000112, 13.52266408300008],
            [13.12382897900008, 13.533438619],
            [13.123518921000112, 13.536952617000068],
            [13.107085815000062, 13.531552429000087],
            [13.088275594000038, 13.530596415000034],
            [13.077010131000065, 13.534678854000049],
            [13.082487834000062, 13.54439402300008],
            [13.082487834000062, 13.55062103300007],
            [13.054892619000071, 13.548373108000064],
            [13.029261109000089, 13.539174703000072],
            [12.939344116000058, 13.495068868000075],
            [12.911748901000067, 13.489901225000082],
            [12.88384362800008, 13.49599904400013],
            [12.87970951300008, 13.479695129000106],
            [12.870614461000088, 13.478868307000084],
            [12.857798706000011, 13.484914449000115],
            [12.84229577700009, 13.489126079000073],
            [12.84229577700009, 13.481684673000046],
            [12.850564006000042, 13.47938507100011],
            [12.857592, 13.475328471000111],
            [12.863896525000058, 13.469282328000077],
            [12.870201050000077, 13.461246643000095],
            [12.8570752360001, 13.45065297500011],
            [12.829273315000052, 13.42029307100006],
            [12.828549845000055, 13.417450867000085],
            [12.829996786000066, 13.409363505000087],
            [12.829273315000052, 13.406624655000144],
            [12.82627608200005, 13.406056214000088],
            [12.817594441000097, 13.40729644800004],
            [12.815010620000095, 13.406624655000144],
            [12.810669799000095, 13.404299215000023],
            [12.797337280000079, 13.399648336000055],
            [12.794546753000134, 13.396056824000084],
            [12.798474161000087, 13.384274597000072],
            [12.804778687000095, 13.376859029000059],
            [12.805192098000106, 13.372983297000104],
            [12.791136108000103, 13.371846415000093],
            [12.788965698000112, 13.375463765000077],
            [12.783281291000065, 13.382336731000052],
            [12.777390177000058, 13.386703390000037],
            [12.774599650000113, 13.38269846600005],
            [12.773256062000144, 13.382233378000123],
            [12.766538127000103, 13.36567108200012],
            [12.740803264000107, 13.334820252000043],
            [12.724370158000056, 13.322288717000035],
            [12.701735880000115, 13.317250264000066],
            [12.690057006000131, 13.311979269000034],
            [12.683132365000063, 13.288931580000067],
            [12.674347371000067, 13.283712260000058],
            [12.659154500000056, 13.286606140000046],
            [12.649232626000128, 13.293608297000048],
            [12.640654337000115, 13.30239329100003],
            [12.630008993000018, 13.31037729900001],
            [12.628768758000092, 13.2941767370001],
            [12.626805054000044, 13.288259786000083],
            [12.620190471000058, 13.281438497000039],
            [12.613265829000085, 13.276503398000088],
            [12.60613448100014, 13.274229635000083],
            [12.60272383600011, 13.279991557000045],
            [12.597556193000088, 13.276503398000088],
            [12.561072631000087, 13.242758687000034],
            [12.5581787510001, 13.22653228800003],
            [12.54515629000008, 13.208212993000046],
            [12.53833500200011, 13.193356018000102],
            [12.554251343000118, 13.187542420000028],
            [12.547946818000128, 13.16545074500003],
            [12.542572469000078, 13.154779561000026],
            [12.53451094500008, 13.145917054000023],
            [12.526966186000038, 13.1436432900001],
            [12.504331909000086, 13.139612529000104],
            [12.499784383000133, 13.135969340000102],
            [12.491206096000099, 13.08263926200003],
            [12.48665856900007, 13.070805359000104],
            [12.472705932000082, 13.0641649370001],
            [12.456376180000035, 13.06742055300009],
            [12.437255900000139, 13.074009298000078],
            [12.414311564000116, 13.077626648000063],
            [12.386741699000083, 13.078580465000115],
            [12.35157637500015, 13.079797058000054],
            [12.335246622000028, 13.08447377500002],
            [12.325738159000139, 13.078815206000087],
            [12.318400105000137, 13.083853658000052],
            [12.310958699000139, 13.092638652000048],
            [12.30103682500004, 13.098116354000126],
            [12.291528361000047, 13.096824443000074],
            [12.285327189000071, 13.092018535000065],
            [12.280883016000075, 13.086850891000068],
            [12.277162313000133, 13.08447377500002],
            [12.269204142000092, 13.085869039000102],
            [12.267447143000112, 13.089641419000117],
            [12.267033732000101, 13.095170797000037],
            [12.263209676000145, 13.101862895000053],
            [12.251840861000062, 13.108012390000113],
            [12.201404663000062, 13.125427348000045],
            [12.18476485100004, 13.122094218000129],
            [12.163784220000139, 13.1079607140001],
            [12.149624878000083, 13.105583598000052],
            [12.116448609000088, 13.102844747000105],
            [12.057640828000103, 13.116771546000095],
            [12.038003784000068, 13.126357524000099],
            [11.99190840600005, 13.1620917770001],
            [11.852795451000134, 13.245394186000041],
            [11.742311238000127, 13.289448344000022],
            [11.440004110000075, 13.364430848000083],
            [10.953005412000067, 13.36189870200009],
            [10.771311076000103, 13.38269846600005],
            [10.674986206000113, 13.375102030000079],
            [10.647881836000067, 13.36940618400007],
            [10.161529175000112, 13.267201640000067],
            [10.119774618000065, 13.250096741000021],
            [9.93012211100006, 13.145968729000032],
            [9.912448771000129, 13.129199728000074],
            [9.908211303000087, 13.11878692700013],
            [9.904387247000045, 13.094343974000097],
            [9.899736368000077, 13.08431874600008],
            [9.891778198000111, 13.076231384000081],
            [9.88774743600004, 13.075507915000088],
            [9.882683146000147, 13.076231384000081],
            [9.872037801000147, 13.072562358000084],
            [9.852814169000055, 13.060444234000087],
            [9.819327840000142, 13.029205831000098],
            [9.647657343000077, 12.830537962000037],
            [9.640734090000109, 12.822525940000048],
            [9.629261922000097, 12.812784933000103],
            [9.61840987100004, 12.8057827760001],
            [9.611485229000067, 12.802940572000125],
            [9.590297892000109, 12.801390280000106],
            [9.377907756000099, 12.825781555000034],
            [9.359821004000082, 12.82459299700011],
            [9.306490926000095, 12.809839376000099],
            [9.269387248000015, 12.809787699000083],
            [8.977871813000093, 12.843182822000088],
            [8.942792196000084, 12.847201436000148],
            [8.679345743000084, 12.923579204000106],
            [8.642655477000119, 12.944353129000135],
            [8.62549890200006, 12.964791158000097],
            [8.596766805000073, 13.011403300000069],
            [8.577233114000137, 13.032435608000085],
            [8.533514851000064, 13.064630025000028],
            [8.50964034000009, 13.075921326000099],
            [8.482665242000053, 13.081554057000034],
            [8.470779663000116, 13.081657410000062],
            [8.445974976000088, 13.078711853000058],
            [8.434502807000086, 13.075094503000074],
            [8.423133993000079, 13.069487610000053],
            [8.418999877000147, 13.066697083000093],
            [8.415175822000037, 13.067058817000088],
            [8.405150594000105, 13.07085703600012],
            [8.397812541000093, 13.07540456200006],
            [8.297973673000087, 13.16462392200009],
            [8.273065633000101, 13.193872783000046],
            [8.25983646600011, 13.205215759000026],
            [8.246727828000132, 13.211291661000047],
            [8.245677124000082, 13.211778666000015],
            [8.216014852000114, 13.219607646000043],
            [8.201442098000143, 13.22637725800007],
            [8.167645711000148, 13.25237050400004],
            [8.140050496000072, 13.269113668000088],
            [8.11658939600008, 13.291050314000046],
            [8.105117228000069, 13.299654440000083],
            [8.077522013000078, 13.310015564000096],
            [7.823997436000099, 13.345284729000085],
            [7.789684286000067, 13.341977437000082],
            [7.755577840000115, 13.32714630200006],
            [7.391982463000119, 13.112534078000053],
            [7.3606665450001, 13.102638042000052],
            [7.324803100000054, 13.102844747000105],
            [7.220520061000116, 13.121577454000104],
            [7.198195841000143, 13.117391663000063],
            [7.137424357000043, 13.047240906000098],
            [7.090088745000088, 13.006390686000103],
            [7.068694702000073, 12.996081238000102],
            [7.062920948000112, 12.995139865000098],
            [7.04492354300001, 12.992205506000047],
            [6.970509481000107, 12.991843771000049],
            [6.937126505000037, 12.995409444000117],
            [6.906637410000144, 13.00685577400013],
            [6.874184611000118, 13.030497742000051],
            [6.83790775500006, 13.06349314400012],
            [6.778686564000083, 13.13028493300007],
            [6.753879129000069, 13.174899667000062],
            [6.672543172000132, 13.321177673000122],
            [6.509297322000094, 13.496050721000046],
            [6.368944133000042, 13.626275330000041],
            [6.302178181000102, 13.663844096000048],
            [6.284207679000104, 13.667656410000077],
            [6.229831176000062, 13.679191996000014],
            [6.210607543000037, 13.675264587000044],
            [6.152833293000128, 13.643561097000116],
            [6.142394653000082, 13.640822246000084],
            [6.135780069000106, 13.64366445000006],
            [6.129475545000076, 13.649064637000023],
            [6.120380493000113, 13.65407725100009],
            [5.837348673500145, 13.76374755900008],
            [5.554316854000092, 13.873417867000086],
            [5.521760701000062, 13.880290832000057],
            [5.374069458000122, 13.855253601000044],
            [5.346267538000092, 13.841559347000029],
            [5.334795369000062, 13.826702372000085],
            [5.3180522050001, 13.78993459100009],
            [5.304202922000059, 13.773940735000053],
            [5.273507120000119, 13.75252085400004],
            [5.262034953000096, 13.747740784000129],
            [5.227618449000147, 13.741332907000086],
            [5.084371378000128, 13.747534078000072],
            [4.983188924000046, 13.729679871000116],
            [4.925104614000134, 13.733090516000061],
            [4.902366984000082, 13.742986552000048],
            [4.879836060000059, 13.764018860000064],
            [4.856891724000121, 13.774095765000098],
            [4.824852335000116, 13.770736797000083],
            [4.625844677000089, 13.7231508200001],
            [4.506732218000082, 13.694669088000111],
            [4.452575318000072, 13.673765971000122],
            [4.405756470000142, 13.641235657000095],
            [4.248453409000092, 13.49413869200012],
            [4.220548136000104, 13.48062530500006],
            [4.190472453000041, 13.475018413000043],
            [4.125773559000066, 13.47297719400008],
            [4.12370650200009, 13.23358612100013],
            [4.120324552000056, 13.210607869000043],
            [4.088773234000115, 12.996236267000143],
            [3.92909305800012, 12.750385641000051],
            [3.864394165000135, 12.68966583300005],
            [3.645699503000117, 12.528538716000071],
            [3.641565389000107, 12.517996725000103],
            [3.651487264000082, 12.269019674000063],
            [3.624512166000073, 12.13765818300007],
            [3.62399540200002, 12.094249980000072],
            [3.648903442000091, 12.021024475000075],
            [3.653554321000058, 11.986814677000083],
            [3.636604452000142, 11.953586732000048],
            [3.619551229000109, 11.936275127000044],
            [3.608492473000098, 11.921960754000054],
            [3.60394494600007, 11.905579325000105],
            [3.609732707000148, 11.848786927000077],
            [3.612936645000019, 11.838968405000102],
            [3.618621053000055, 11.828374736000029],
            [3.622031698000086, 11.825015768000114],
            [3.626269165000053, 11.822535299000052],
            [3.649730265000102, 11.797833964000034],
            [3.662029256000068, 11.779488831000052],
            [3.666990194000107, 11.759696757000071],
            [3.659858846000077, 11.738096009000103],
            [3.647766561000083, 11.726003723000105],
            [3.596400187000114, 11.69577301000001],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Burkina Faso',
        iso3: 'BFA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2.390168904000092, 11.896535950000057],
            [2.354098755000081, 11.799849345000084],
            [2.340042766000067, 11.773856100000017],
            [2.301595500000104, 11.731533102000114],
            [2.29084680200009, 11.703214416000023],
            [2.290226684000118, 11.685747783000082],
            [2.291053507000072, 11.674792379000095],
            [2.287436157000087, 11.665283915000117],
            [2.273586873000113, 11.65205474900003],
            [2.220050089000068, 11.622547506000103],
            [2.146979614000116, 11.563739726000037],
            [2.015428661000072, 11.431589907000088],
            [2.010760538000085, 11.426900533000051],
            [1.983372030000055, 11.414007264000048],
            [1.948025349000147, 11.416720276000078],
            [1.905754028000075, 11.432843323000057],
            [1.879812459000107, 11.444858094000026],
            [1.867616821000098, 11.446615092000101],
            [1.858005005000081, 11.440310567000083],
            [1.84064172300009, 11.44547821000009],
            [1.821521444000069, 11.44160247800005],
            [1.78224735500001, 11.426022034000098],
            [1.763333781000085, 11.42467844600013],
            [1.719098755000061, 11.427779033000078],
            [1.703492472000107, 11.422921448000068],
            [1.684372192000126, 11.413852234000103],
            [1.638173461000065, 11.404214579000083],
            [1.621120239000049, 11.39527455700005],
            [1.601586548000114, 11.388685812000062],
            [1.58060591600011, 11.427055562000092],
            [1.563242635000108, 11.426022034000098],
            [1.564999634000088, 11.4326366170001],
            [1.567273397000093, 11.446692607000031],
            [1.56934045400007, 11.453307190000118],
            [1.475289347000114, 11.460774434000143],
            [1.455962361000047, 11.464701843000114],
            [1.439632609000114, 11.473771057000079],
            [1.433844848000149, 11.45940500900008],
            [1.423612915000149, 11.453875631000074],
            [1.423215479000135, 11.453747532000136],
            [1.411107218000069, 11.449844869000074],
            [1.398084757000049, 11.440310567000083],
            [1.389816529000086, 11.428399150000061],
            [1.388576293000142, 11.420001730000067],
            [1.398084757000049, 11.398685201000077],
            [1.381651652000073, 11.388685812000062],
            [1.359017375000121, 11.378893127000097],
            [1.339070271000082, 11.366103211000038],
            [1.330388631000034, 11.347163798000082],
            [1.336176391, 11.330033061000037],
            [1.345891561000144, 11.316338806000104],
            [1.347855265000078, 11.303497213000114],
            [1.330388631000034, 11.288846944000042],
            [1.323463989000061, 11.29708933500008],
            [1.316332642000106, 11.29987986200004],
            [1.309304647000118, 11.29708933500008],
            [1.302483358000046, 11.288846944000042],
            [1.296178833000056, 11.29962148100006],
            [1.284499959000073, 11.31272145600012],
            [1.273337850000132, 11.318224996000112],
            [1.268376912000093, 11.306210225000058],
            [1.270547323000073, 11.298277894000094],
            [1.280365845000063, 11.288691915000086],
            [1.282639608000068, 11.278873393000126],
            [1.281089314000042, 11.271096090000114],
            [1.268376912000093, 11.247893371000103],
            [1.235200642000081, 11.263473816000044],
            [1.218974243000076, 11.268047180000082],
            [1.200060669000038, 11.268977356000036],
            [1.191379028000057, 11.267013652000102],
            [1.186211385000149, 11.263887228000058],
            [1.180940389000028, 11.261355082000065],
            [1.172155395000061, 11.261484273000093],
            [1.173498982000098, 11.266600240000088],
            [1.165954224000075, 11.277994894000088],
            [1.156342407000039, 11.28553965200004],
            [1.145903768000011, 11.269855855000074],
            [1.13556848200011, 11.260114848000029],
            [1.130607544000071, 11.24758331300012],
            [1.149314412000138, 11.217249247000083],
            [1.153241821000108, 11.183168640000119],
            [1.158409465000119, 11.16593455000013],
            [1.148074178000087, 11.169500224000018],
            [1.128127076000084, 11.178879497000054],
            [1.117481730000094, 11.178982849000079],
            [1.113037557000069, 11.173866882000098],
            [1.106216267000121, 11.155650940000044],
            [1.10042850800005, 11.151620178000144],
            [1.067458943000105, 11.14428212500006],
            [1.062291300000084, 11.142060039000057],
            [1.063324829000067, 11.126970520000057],
            [1.067045532000094, 11.128339946000025],
            [1.073350057000084, 11.133946838000057],
            [1.082755168000062, 11.131802266000065],
            [1.08389204900007, 11.127719828000053],
            [1.08213505000009, 11.115291646000074],
            [1.082755168000062, 11.110692444000037],
            [1.085649047000032, 11.1087287390001],
            [1.09515751100011, 11.10443959500013],
            [1.097017863000133, 11.104491272000047],
            [1.099084920000081, 11.092605693000024],
            [1.099291626000138, 11.081288554000139],
            [1.100945272000104, 11.070410665000082],
            [1.107249796000104, 11.059791158000095],
            [1.118618612000091, 11.048241476000058],
            [1.117481730000094, 11.032195943000104],
            [1.114174438000077, 11.027674255000079],
            [1.106836385000094, 11.034418030000012],
            [1.099705037000149, 11.0443657430001],
            [1.097017863000133, 11.049275004000052],
            [1.086889282000072, 11.05273732500008],
            [1.056090129000097, 11.056070455000082],
            [1.052162720000126, 11.055011089000104],
            [1.041310669000097, 11.049585063000038],
            [1.035006144000079, 11.049275004000052],
            [1.033249146000088, 11.05157460500007],
            [1.027978149000063, 11.061341452000121],
            [1.025084269000075, 11.063511861000109],
            [1.019709920000111, 11.0656822710001],
            [1.014645629000142, 11.07035898900007],
            [1.007927694000017, 11.07506154400005],
            [0.986016887000062, 11.07849802700008],
            [0.981366008000094, 11.080125834000029],
            [0.976921834000109, 11.078368836000053],
            [0.970307251000094, 11.069480490000032],
            [0.964416138000104, 11.057414042000062],
            [0.955941203000094, 11.044727479000102],
            [0.952427205000049, 11.04240203900008],
            [0.951290324000126, 11.032299297000037],
            [0.951807088000066, 11.02108551100008],
            [0.955321085000122, 11.011990458000113],
            [0.963279256000078, 11.0082697550001],
            [0.969067017000071, 11.00289540700004],
            [0.969997192000108, 10.991164856000054],
            [0.967516723000131, 10.979485983000075],
            [0.963279256000078, 10.974137472000038],
            [0.945399211000051, 10.974292501000065],
            [0.931963338000088, 10.976101176000057],
            [0.901474243000109, 10.992740987000076],
            [0.771559692000096, 10.990363872000046],
            [0.675338175000149, 10.988529358000036],
            [0.612602987000116, 10.976566264000084],
            [0.487649373000067, 10.933235576000115],
            [0.499741658000062, 10.975687764000057],
            [0.483618612000072, 10.979692688000043],
            [0.487132609000128, 10.983671774000115],
            [0.488579549000121, 10.987754212000127],
            [0.489303019000118, 10.991914165000054],
            [0.49064660600007, 10.99635833700006],
            [0.490129842000044, 10.999510600000121],
            [0.488786254000075, 11.001784363000041],
            [0.486615844000085, 11.003205465000121],
            [0.374779215000075, 11.025807961000112],
            [0.28755822700009, 11.04343556700006],
            [0.059587646000068, 11.08940175400005],
            [-0.0631180419999, 11.114154765000066],
            [-0.115062219999885, 11.124658279000059],
            [-0.16610917099996, 11.134980367000125],
            [-0.301682291999896, 11.16293731700003],
            [-0.304472818999955, 11.146788432000037],
            [-0.300545409999899, 11.13740916000009],
            [-0.298297485999882, 11.128391622000038],
            [-0.30612646499992, 11.113534648000012],
            [-0.318813028999955, 11.101364848000088],
            [-0.368939167999883, 11.065217183000073],
            [-0.386922566999971, 11.08640452100012],
            [-0.405887816999922, 11.101468201000031],
            [-0.42521480299996, 11.101468201000031],
            [-0.444386759999873, 11.077438660000098],
            [-0.449037637999936, 11.06289174400004],
            [-0.451259724999943, 11.040205791000076],
            [-0.456685750999924, 11.029612122000103],
            [-0.46851965299993, 11.020129496000024],
            [-0.494822956999883, 11.007804667000073],
            [-0.504228067999946, 10.99635833700006],
            [-0.504228067999946, 10.99620330800012],
            [-0.506708536999923, 10.993671163000045],
            [-0.509705769999925, 10.991449077000127],
            [-0.512961384999926, 10.989743754000074],
            [-0.516475382999971, 10.988632711000065],
            [-0.555439411999942, 10.989950460000031],
            [-0.576213337999889, 10.987754212000127],
            [-0.590579385999916, 10.982431539000075],
            [-0.599829467999911, 10.965765890000057],
            [-0.607115844999896, 10.94121958400008],
            [-0.617244424999853, 10.918636983000056],
            [-0.634762735999914, 10.907965800000056],
            [-0.682770141999868, 10.953596090000048],
            [-0.679772907999933, 10.960572408000047],
            [-0.672279825999908, 10.968504741000089],
            [-0.667990682999942, 10.976514588000072],
            [-0.673933471999959, 10.98351674400007],
            [-0.683235229999894, 10.984343567000096],
            [-0.690211547999866, 10.981811422000106],
            [-0.69465572099989, 10.982741598000061],
            [-0.695999308999944, 10.994032898000043],
            [-0.703017494999926, 10.994158812000066],
            [-0.816973836999921, 10.99620330800012],
            [-0.816973836999921, 10.996461691000093],
            [-0.822141479999914, 11.003618876000132],
            [-0.827774210999934, 11.00584096300014],
            [-0.833665323999867, 11.003412171000079],
            [-0.839401407999901, 10.996461691000093],
            [-0.860795450999916, 10.99292185500012],
            [-0.883171345999898, 10.968633932000031],
            [-0.900586303999944, 10.966230978000084],
            [-0.893920043999913, 10.979899394000086],
            [-0.904358683999874, 10.979485983000075],
            [-0.909474649999936, 10.982689921000144],
            [-0.916450968999953, 10.99620330800012],
            [-0.924047403999907, 11.001422628000043],
            [-0.93247066299989, 11.003102112000093],
            [-1.070343383999955, 11.013902486000035],
            [-1.098713744999969, 11.009561666000053],
            [-1.107550414999878, 10.99434295600011],
            [-1.228059854999913, 10.995479838000037],
            [-1.355287231999881, 10.996720072000059],
            [-1.380350300999879, 11.001267599000101],
            [-1.413553084999876, 11.014049746000055],
            [-1.423584092999931, 11.017911405000092],
            [-1.436057494999915, 11.02271331800003],
            [-1.562406371999941, 11.026589050000084],
            [-1.579821329999987, 11.021214702000108],
            [-1.58700435399993, 11.003670553000049],
            [-1.598683226999924, 10.997133484000074],
            [-1.754074259999925, 10.995634868000067],
            [-1.972872273999883, 10.993516134000089],
            [-2.197871459999902, 10.991294047000082],
            [-2.439768839999942, 10.988942769000047],
            [-2.634950723999879, 10.986979065000114],
            [-2.7287975939999, 10.986057355000057],
            [-2.750705932999921, 10.985842184000106],
            [-2.751119344999921, 10.996461691000093],
            [-2.837341471999878, 10.998011984000115],
            [-2.835946207999882, 10.99222422300005],
            [-2.838710896999942, 10.985118714000109],
            [-2.832716430999909, 10.966024272000112],
            [-2.821761026999923, 10.948299256000013],
            [-2.81576656099989, 10.9291531370001],
            [-2.821399291999938, 10.906260478000078],
            [-2.834861002999901, 10.891610209000106],
            [-2.850803181999908, 10.879543763000115],
            [-2.864239054999871, 10.864273377000075],
            [-2.871628784999871, 10.843447774000111],
            [-2.882661702999883, 10.797068176000025],
            [-2.899482380999956, 10.769989726000063],
            [-2.903099730999941, 10.747148743000054],
            [-2.908577433999909, 10.737666118000078],
            [-2.919274454999936, 10.727201640000132],
            [-2.922323363999851, 10.7212071740001],
            [-2.919959289999923, 10.711088218000057],
            [-2.918912719999923, 10.706608582000044],
            [-2.916949015999904, 10.706608582000044],
            [-2.912634033999922, 10.705807597000032],
            [-2.908034829999878, 10.703637187000126],
            [-2.905140950999879, 10.699193013000112],
            [-2.905115111999891, 10.692733459000067],
            [-2.907337198999898, 10.688315125000074],
            [-2.91015356499986, 10.684491068000028],
            [-2.916251383999906, 10.668083801000066],
            [-2.929661417999853, 10.644209290000077],
            [-2.932503621999928, 10.634313253000087],
            [-2.92826615499996, 10.615218811000105],
            [-2.898293823999921, 10.562612204000104],
            [-2.895865030999857, 10.552767843000126],
            [-2.89421138499992, 10.531425476000038],
            [-2.891524210999876, 10.52165863100008],
            [-2.886899169999936, 10.515793356000088],
            [-2.873385782999947, 10.502486674000082],
            [-2.870440225999857, 10.497784119000102],
            [-2.867391316999914, 10.478250428000095],
            [-2.859562336999915, 10.465615540000059],
            [-2.824448201999871, 10.435023092000051],
            [-2.812149210999905, 10.428821920000061],
            [-2.795871134999885, 10.426108907000113],
            [-2.771428181999852, 10.42548879000006],
            [-2.767552448999908, 10.42119964600009],
            [-2.771893269999879, 10.41182037300004],
            [-2.781039998999859, 10.40241526300008],
            [-2.791995401999941, 10.398151957000039],
            [-2.804940347999946, 10.397118429000045],
            [-2.814629679999882, 10.393707784000114],
            [-2.822329467999879, 10.387584127000054],
            [-2.829460815999909, 10.378282369000118],
            [-2.836282103999878, 10.363657939000063],
            [-2.841294718999933, 10.343271586000114],
            [-2.841294718999933, 10.322290954000024],
            [-2.833181518999936, 10.30598704100008],
            [-2.824448201999871, 10.302214661000065],
            [-2.814216267999882, 10.301077779000053],
            [-2.805689656999959, 10.29901072200009],
            [-2.802098144999889, 10.292318624000075],
            [-2.799669351999938, 10.280923970000075],
            [-2.79318395999988, 10.278546854000126],
            [-2.7844506429999, 10.2788052370001],
            [-2.774838826999883, 10.275239563000127],
            [-2.764865274999863, 10.269115906000067],
            [-2.758354044999891, 10.26611867300005],
            [-2.754943399999888, 10.260796],
            [-2.754374959999922, 10.247954407000108],
            [-2.75768225199991, 10.234647726000105],
            [-2.765123657999936, 10.22583689400011],
            [-2.785380818999954, 10.210101420000044],
            [-2.798454955999887, 10.18953420000014],
            [-2.798920043999914, 10.169612935000131],
            [-2.788481404999885, 10.124447734000057],
            [-2.788481404999885, 10.038768209000082],
            [-2.783572143999947, 10.018511048000079],
            [-2.760886189999894, 9.98476633700011],
            [-2.754374959999922, 9.966782938000023],
            [-2.755563516999928, 9.941151428000055],
            [-2.764865274999863, 9.895753683000123],
            [-2.760524454999882, 9.870535584000066],
            [-2.736753295999932, 9.832579245000062],
            [-2.733911091999857, 9.822786560000097],
            [-2.740267293999892, 9.812606303000038],
            [-2.774838826999883, 9.774339905000133],
            [-2.79158199099993, 9.740931091000064],
            [-2.795302693999929, 9.720002136000076],
            [-2.788481404999885, 9.699254049000032],
            [-2.780316527999958, 9.690236512000084],
            [-2.774838826999883, 9.68930633600013],
            [-2.769257771999946, 9.689926453000098],
            [-2.760524454999882, 9.685585633000116],
            [-2.755460163999913, 9.67749827000003],
            [-2.754219929999891, 9.668351542000039],
            [-2.751015991999907, 9.65917897600005],
            [-2.743404468999927, 9.653325351000134],
            [-2.740163940999963, 9.650833231000078],
            [-2.752928019999928, 9.639903666000109],
            [-2.761506306999962, 9.625253398000027],
            [-2.766467244999916, 9.608897807000076],
            [-2.768017536999935, 9.592800599000014],
            [-2.766260538999859, 9.57652252200009],
            [-2.761092894999933, 9.566238912000088],
            [-2.725281127999921, 9.533863627000088],
            [-2.68921097799992, 9.488724263000037],
            [-2.720475219999912, 9.459217020000025],
            [-2.744918171999956, 9.408109030000034],
            [-2.763676717999942, 9.391882629000108],
            [-2.787602905999933, 9.393717143000117],
            [-2.810418049999953, 9.411106262000132],
            [-2.91015356499986, 9.542726136000098],
            [-2.959892130999947, 9.638611755000056],
            [-2.977823852999933, 9.685172221000101],
            [-2.989993651999924, 9.708426616000025],
            [-3.005677449999894, 9.724162090000092],
            [-3.024642699999958, 9.728606262000099],
            [-3.059059203999908, 9.718555196000082],
            [-3.077094278999908, 9.71940785800011],
            [-3.094560912999953, 9.733851420000036],
            [-3.104379435999931, 9.757131653000059],
            [-3.116910969999935, 9.805294088000053],
            [-3.136935587999858, 9.829530335000129],
            [-3.16011246799988, 9.834697978000037],
            [-3.182565877999878, 9.835163066000064],
            [-3.200006673999894, 9.845369161000036],
            [-3.204399169999903, 9.865367941000073],
            [-3.202228759999912, 9.888958232000078],
            [-3.202564656999897, 9.908233541000115],
            [-3.214760294999905, 9.915623271000115],
            [-3.230237385999914, 9.904719543000056],
            [-3.264059610999908, 9.857073873000019],
            [-3.277857218999941, 9.843457133000115],
            [-3.301731730999933, 9.841131694000083],
            [-3.311808634999892, 9.854128316000114],
            [-3.313565632999939, 9.874566345000062],
            [-3.312738809999928, 9.894513449000087],
            [-3.317182983999942, 9.901334737000042],
            [-3.327518269999956, 9.897303976000046],
            [-3.339248819999852, 9.890095113000086],
            [-3.348343871999901, 9.886994527000041],
            [-3.359015055999919, 9.892498068000037],
            [-3.376559203999875, 9.908491923000085],
            [-3.389168253999912, 9.913246155000081],
            [-3.546471313999945, 9.926139425000073],
            [-3.606260945999878, 9.918181254000018],
            [-3.623340006999911, 9.92174692800009],
            [-3.63401118999991, 9.92924001000003],
            [-3.64054825799991, 9.937379048000125],
            [-3.648170531999881, 9.944587911000085],
            [-3.661658080999928, 9.948928731000066],
            [-3.665042887999959, 9.946603292000134],
            [-3.674318806999878, 9.935260315000065],
            [-3.67964147999993, 9.932211405000118],
            [-3.68594600499992, 9.933451640000072],
            [-3.698994302999893, 9.940789693000056],
            [-3.706461547999908, 9.941823222000039],
            [-3.755037394999903, 9.935880433000122],
            [-3.769610147999884, 9.931332906000094],
            [-3.779738728999916, 9.92469248500008],
            [-3.795758422999882, 9.90766510000006],
            [-3.80425919599989, 9.901386414000058],
            [-3.823482828999914, 9.895702006000107],
            [-3.889706176999908, 9.89446177200007],
            [-3.891624633999925, 9.893900095000049],
            [-3.91009252899994, 9.888493144000051],
            [-3.947738809999862, 9.86436025000009],
            [-3.969184529999893, 9.85898590100004],
            [-3.984041503999919, 9.851156921000012],
            [-3.988253133999876, 9.834801331000065],
            [-3.994609333999904, 9.820771179000047],
            [-4.026674560999908, 9.82030609100012],
            [-4.034968627999973, 9.81761891700009],
            [-4.050316528999929, 9.810306702000105],
            [-4.051350056999922, 9.807567851000059],
            [-4.051711791999907, 9.80234853100005],
            [-4.053675496999858, 9.797620138000056],
            [-4.05987666799993, 9.79627655100009],
            [-4.065716104999922, 9.798085226000083],
            [-4.07615474499994, 9.803795471000043],
            [-4.133050496999914, 9.820409444000049],
            [-4.150258747999885, 9.818290711000074],
            [-4.168293823999903, 9.804829],
            [-4.196974242999886, 9.764960633000086],
            [-4.215422729999887, 9.75485789000004],
            [-4.253094848999922, 9.750051982000045],
            [-4.27032893899991, 9.74392832500007],
            [-4.283635620999917, 9.732016907000045],
            [-4.279191446999931, 9.731138408000092],
            [-4.267512572999863, 9.727262675000048],
            [-4.297794961999983, 9.695843404000101],
            [-4.303298502999979, 9.686722514000039],
            [-4.303453531999907, 9.677911682000044],
            [-4.300482137999921, 9.654295553000026],
            [-4.30298844399988, 9.641712341000101],
            [-4.315933390999902, 9.616623434000076],
            [-4.322476993999885, 9.608980710000097],
            [-4.322547973999917, 9.608897807000076],
            [-4.349678099999977, 9.620034078000103],
            [-4.365026001999951, 9.624168193000031],
            [-4.368023233999878, 9.608381043000051],
            [-4.367816528999896, 9.591973775000085],
            [-4.371175495999921, 9.582956238000037],
            [-4.38486975099994, 9.589415792000082],
            [-4.391587687999959, 9.600293681000053],
            [-4.400165974999908, 9.633134054000067],
            [-4.409105997999916, 9.647732646000037],
            [-4.43336808299992, 9.653468730000085],
            [-4.469205688999864, 9.651763407000118],
            [-4.501710163999888, 9.655019023000108],
            [-4.51592118399995, 9.675689595000037],
            [-4.513647420999916, 9.69400889100011],
            [-4.50382889899987, 9.719898783000048],
            [-4.501606810999959, 9.737107035000108],
            [-4.503958089999884, 9.742016297000049],
            [-4.509952554999927, 9.745065206000078],
            [-4.517781534999955, 9.7466154990001],
            [-4.535945800999883, 9.7466154990001],
            [-4.539098063999859, 9.74470347100008],
            [-4.539899047999967, 9.740776062000108],
            [-4.543051310999914, 9.73400645000008],
            [-4.547960570999862, 9.720260518000131],
            [-4.548425658999889, 9.706798808000087],
            [-4.552198038999904, 9.696463522000073],
            [-4.566719115999945, 9.692406922000075],
            [-4.578320475999902, 9.696515198000085],
            [-4.592712360999911, 9.717831727000075],
            [-4.604029499999882, 9.727159322000105],
            [-4.616948608999905, 9.713852641000102],
            [-4.628730834999885, 9.707703145000039],
            [-4.641107339999877, 9.706023661000074],
            [-4.655809284999862, 9.70607533800009],
            [-4.65472408099987, 9.703543193000101],
            [-4.658263915999925, 9.69760040300008],
            [-4.664826822999913, 9.690856628000049],
            [-4.672914184999911, 9.685585633000116],
            [-4.681079060999906, 9.68207163500007],
            [-4.681802530999903, 9.68284678100008],
            [-4.681544148999933, 9.686722514000039],
            [-4.686608439999929, 9.692406922000075],
            [-4.700095987999902, 9.697910462000067],
            [-4.705470336999952, 9.702096253000107],
            [-4.707640747999932, 9.70977020300009],
            [-4.709087686999936, 9.720312195000062],
            [-4.71280838999985, 9.726849264000037],
            [-4.724383911999894, 9.737107035000108],
            [-4.730016642999914, 9.744238383000052],
            [-4.733323933999912, 9.74963857000003],
            [-4.738336547999978, 9.753152568000075],
            [-4.74864599599988, 9.75449615500014],
            [-4.758593709999985, 9.753307597000116],
            [-4.762133544999926, 9.749948629000102],
            [-4.760454061, 9.745323588000048],
            [-4.754769653999858, 9.740207622000057],
            [-4.76996252399988, 9.737365418000081],
            [-4.783191690999956, 9.758371887000095],
            [-4.796446695999862, 9.75449615500014],
            [-4.79931473799985, 9.762531840000122],
            [-4.801226765999957, 9.766459249000093],
            [-4.810115111999892, 9.774339905000133],
            [-4.810115111999892, 9.78178131100006],
            [-4.800399942999945, 9.781109518000079],
            [-4.791899169999937, 9.782349752000101],
            [-4.775905313999885, 9.78800832100005],
            [-4.785413777999878, 9.804829],
            [-4.790323038999901, 9.827514953000076],
            [-4.798462076999925, 9.842526958000064],
            [-4.81755651799989, 9.836454976000113],
            [-4.824274454999937, 9.85697052000009],
            [-4.838459634999879, 9.869450378000082],
            [-4.858329223999874, 9.875703227000074],
            [-4.881738647999924, 9.877408549000037],
            [-4.890058552999903, 9.879501445000102],
            [-4.893495035999933, 9.884204],
            [-4.898016723999945, 9.888906555000062],
            [-4.909385538999857, 9.89105112700014],
            [-4.917085326999938, 9.886477763000102],
            [-4.922356322999889, 9.877460226000053],
            [-4.928014892999926, 9.870948995000077],
            [-4.936670694999862, 9.873997904000106],
            [-4.966074584999944, 9.90102467900006],
            [-4.967314819999899, 9.912367656000043],
            [-4.9529487719999, 9.95337290500008],
            [-4.954809122999905, 9.959703268000098],
            [-4.96571284999996, 9.98311269100006],
            [-4.976926634999899, 9.99760793100009],
            [-4.981396646999912, 10.007736511000047],
            [-4.960209309999868, 10.008485819000057],
            [-4.956411091999939, 10.021999207000121],
            [-4.963335733999912, 10.040318502000105],
            [-4.974523681999955, 10.055537211000043],
            [-4.986641805999852, 10.063262838000043],
            [-4.999793456999925, 10.069464010000033],
            [-5.01051631699994, 10.079049988000122],
            [-5.015580607999908, 10.097110901000036],
            [-5.025528320999911, 10.088739319000055],
            [-5.037233031999989, 10.083752544000106],
            [-5.04834346599992, 10.085354512000038],
            [-5.056482503999916, 10.097110901000036],
            [-5.042865762999924, 10.103337911000025],
            [-5.049376993999886, 10.105353292000075],
            [-5.055138916999852, 10.108040467000095],
            [-5.061701822999851, 10.110055847000055],
            [-5.07009924299993, 10.110159200000084],
            [-5.061030028999937, 10.118453268000039],
            [-5.037594767999877, 10.126488953000106],
            [-5.039455118999882, 10.134343770000058],
            [-5.06472489499987, 10.150802714000122],
            [-5.070719360999902, 10.161008809000094],
            [-5.063949747999857, 10.179043885000098],
            [-5.090718139999922, 10.177932841000086],
            [-5.09014969899988, 10.188810730000057],
            [-5.08159724999993, 10.20689748100007],
            [-5.084413614999903, 10.22743886400005],
            [-5.087333333999908, 10.220824280000045],
            [-5.091906696999928, 10.214338887000082],
            [-5.097849487999952, 10.209274597000018],
            [-5.104903319999977, 10.206949158000072],
            [-5.117073120999891, 10.208034363000067],
            [-5.118210001999898, 10.212478536000077],
            [-5.114411783999856, 10.218292134000066],
            [-5.111802123999951, 10.223718160000132],
            [-5.111802123999951, 10.278650208000059],
            [-5.119191853999951, 10.293533020000012],
            [-5.11988239199988, 10.293983277000052],
            [-5.135676635999943, 10.304281718000112],
            [-5.152058064999892, 10.305625305000092],
            [-5.159499470999918, 10.292318624000075],
            [-5.168439493999927, 10.291336772000108],
            [-5.217583780999888, 10.319939677000079],
            [-5.233551797999922, 10.315676371000023],
            [-5.279802204999896, 10.322420146000056],
            [-5.296648721999873, 10.323040263000024],
            [-5.304141804999915, 10.31841522300006],
            [-5.309206094999894, 10.311490580000083],
            [-5.315510619999912, 10.305263570000093],
            [-5.327086140999938, 10.302576396000063],
            [-5.338506632999952, 10.302214661000065],
            [-5.343777628999874, 10.303093160000103],
            [-5.348170124999882, 10.30598704100008],
            [-5.353337768999978, 10.308260804000014],
            [-5.357058471999892, 10.304385071000056],
            [-5.360830850999918, 10.29875234000012],
            [-5.365533406999901, 10.295703431000092],
            [-5.385738891999893, 10.296478577000101],
            [-5.402533731999938, 10.300561015000113],
            [-5.416227986999957, 10.307537333000099],
            [-5.426976684999886, 10.316864929000047],
            [-5.430077270999931, 10.322936910000095],
            [-5.433487915999962, 10.331876933000032],
            [-5.437828734999925, 10.340015971000128],
            [-5.443771525999864, 10.343529969000087],
            [-5.453021606999869, 10.343943380000098],
            [-5.459946248999927, 10.345157776000036],
            [-5.474157267999914, 10.350325419000043],
            [-5.475294148999922, 10.367714539000062],
            [-5.48748978699993, 10.392932638000019],
            [-5.505111449999902, 10.415566915000056],
            [-5.522578084999878, 10.42548879000006],
            [-5.517100382999956, 10.439984029000087],
            [-5.508987182999874, 10.490936992000044],
            [-5.505163126999918, 10.499179383000083],
            [-5.481650349999938, 10.535327047000095],
            [-5.46811112499995, 10.587830302000071],
            [-5.471056680999965, 10.597364604000063],
            [-5.478549763999894, 10.60423756900012],
            [-5.477412882999886, 10.61955963200009],
            [-5.470488239999895, 10.63560516400014],
            [-5.46056636599991, 10.644571024000086],
            [-5.475914265999961, 10.650384623000065],
            [-5.477154499999926, 10.658807882000048],
            [-5.48211543799988, 10.67521514900011],
            [-5.482632201999905, 10.684232687000062],
            [-5.473072061999915, 10.737872823000131],
            [-5.467956095999909, 10.75267812100006],
            [-5.461186482999892, 10.76004201300006],
            [-5.452969929999938, 10.763969421000112],
            [-5.44645869999988, 10.76869781500011],
            [-5.445011759999886, 10.778568014000086],
            [-5.445321817999883, 10.786991273000083],
            [-5.431420857999882, 10.844688009000052],
            [-5.435089883999893, 10.856909485000074],
            [-5.447027140999921, 10.877993470000106],
            [-5.46557897999989, 10.947885844000098],
            [-5.47911820499985, 10.975532736000105],
            [-5.501804157999914, 10.970210063000067],
            [-5.495602986999927, 10.99620330800012],
            [-5.505602479999965, 11.047984824000054],
            [-5.507333536999909, 11.056948954000035],
            [-5.504232950999977, 11.072684428000102],
            [-5.48976354999985, 11.082115377000065],
            [-5.390131387999872, 11.094698589000089],
            [-5.373026488999926, 11.099762879000068],
            [-5.356283325999868, 11.106894227000097],
            [-5.332512166999919, 11.12157033300008],
            [-5.322331908999956, 11.135548808000081],
            [-5.316182413999883, 11.176321513000062],
            [-5.306725626999906, 11.199395040000127],
            [-5.275254678999943, 11.230710958000131],
            [-5.262852335999895, 11.251588237000107],
            [-5.260940307999874, 11.2677371220001],
            [-5.267864949999961, 11.372020162000041],
            [-5.263472452999878, 11.390184428000069],
            [-5.24817622899991, 11.403181051000104],
            [-5.226420450999882, 11.413490499000105],
            [-5.218307250999885, 11.42219797800007],
            [-5.219185749999923, 11.43514292400009],
            [-5.224611775999904, 11.458009746000101],
            [-5.224663451999902, 11.540769551000082],
            [-5.233913533999925, 11.575987040000058],
            [-5.269466918999882, 11.604099019000088],
            [-5.28073238099995, 11.605752666000043],
            [-5.29096431499994, 11.60446075500009],
            [-5.299956013999889, 11.606424459000024],
            [-5.307604125999944, 11.617638244000076],
            [-5.307810831999916, 11.629007060000063],
            [-5.302281452999893, 11.639859111000106],
            [-5.294788370999868, 11.65029775000005],
            [-5.289258992999862, 11.660426331000096],
            [-5.280680704999924, 11.699493713000024],
            [-5.278561970999874, 11.72145619700008],
            [-5.279543822999926, 11.739026185000057],
            [-5.287140258999898, 11.758921611000062],
            [-5.298974161999894, 11.772667542000093],
            [-5.314787150999905, 11.782486064000068],
            [-5.33426916499991, 11.790805970000122],
            [-5.344656127999912, 11.793906555000063],
            [-5.353286091999877, 11.794526673000036],
            [-5.370649373999896, 11.791064351000088],
            [-5.374525105999851, 11.795250142000029],
            [-5.40041499799986, 11.810184631000084],
            [-5.405996052999882, 11.812303365000062],
            [-5.412197224999971, 11.82356882800012],
            [-5.412352254999917, 11.82852976500007],
            [-5.405944376999884, 11.830441793000091],
            [-5.392301798999966, 11.832353821000112],
            [-5.387909301999883, 11.83080352800009],
            [-5.375610310999917, 11.822225241000055],
            [-5.369874226999883, 11.820158183000089],
            [-5.364551553999917, 11.821760153000128],
            [-5.357058471999892, 11.829614970000065],
            [-5.353802856999891, 11.831733704000044],
            [-5.319024616999855, 11.83741811100009],
            [-5.314838825999914, 11.839330139000097],
            [-5.311066446999888, 11.84289581300007],
            [-5.306518920999849, 11.84604807600003],
            [-5.300162719999918, 11.846358134000113],
            [-5.293444782999899, 11.843205872000055],
            [-5.288018757999936, 11.839123433000054],
            [-5.28248937999993, 11.836436259000024],
            [-5.275151325999929, 11.83741811100009],
            [-5.268226684999945, 11.84305084200011],
            [-5.248227904999908, 11.870439351000059],
            [-5.209470580999891, 11.901496887000093],
            [-5.182908894999883, 11.93090077700009],
            [-5.167819376999972, 11.943664856000055],
            [-5.136994383999905, 11.95312164400012],
            [-5.103947306999913, 11.972758688000056],
            [-5.089322875999926, 11.979269918000028],
            [-5.073768269999903, 11.980510152000065],
            [-5.034313313999888, 11.979269918000028],
            [-5.016045694999917, 11.981285299000078],
            [-5.004702717999862, 11.98066518200011],
            [-4.994238239999902, 11.983249003000111],
            [-4.984523070999956, 11.988571676000063],
            [-4.975453857999895, 11.996271464000046],
            [-4.953749755999894, 12.005108134000054],
            [-4.93207149199992, 12.003144430000106],
            [-4.910677449999895, 11.998131816000054],
            [-4.889955199999889, 11.997925110000097],
            [-4.847244628999874, 12.013066304000105],
            [-4.826238159999946, 12.012704570000025],
            [-4.80680781999996, 11.996271464000046],
            [-4.789522053999889, 12.001800842000051],
            [-4.761280883999916, 12.006606751000064],
            [-4.7468889969999, 12.015081686000059],
            [-4.73898250299996, 12.025210266000016],
            [-4.732280930999934, 12.03726309400011],
            [-4.72513321999989, 12.050118307000076],
            [-4.714617065999931, 12.059006653000097],
            [-4.704023396999958, 12.061487122000074],
            [-4.683714558999924, 12.059058330000099],
            [-4.673585977999892, 12.059730123000094],
            [-4.653716389999886, 12.069135233000054],
            [-4.652736852999851, 12.071626775000055],
            [-4.648677937999906, 12.081950989000035],
            [-4.646662556999956, 12.098022360000087],
            [-4.636120564999914, 12.117556051000093],
            [-4.600308796999883, 12.137554830000042],
            [-4.570233113999905, 12.138898417000092],
            [-4.560466267999857, 12.14949208600008],
            [-4.585529337999958, 12.19724110900006],
            [-4.497421019999905, 12.268709615000077],
            [-4.493545288999968, 12.27284373000009],
            [-4.492253376999912, 12.278838196000024],
            [-4.494010376999881, 12.290103659000081],
            [-4.490496378999921, 12.30576161700013],
            [-4.490703084999893, 12.313823141000029],
            [-4.4881709389999, 12.3206961060001],
            [-4.477189696999915, 12.32731069000009],
            [-4.46248775199993, 12.328189189000042],
            [-4.452669229999856, 12.320282695000088],
            [-4.444814412999932, 12.30943064400013],
            [-4.43582271299988, 12.301730856000049],
            [-4.406134602999913, 12.307466939000093],
            [-4.415358845999918, 12.35030670200004],
            [-4.451635700999873, 12.43531443300013],
            [-4.443677530999906, 12.459447327000092],
            [-4.426624308999891, 12.479652812000083],
            [-4.407607380999906, 12.497946269000053],
            [-4.393448038999878, 12.516446431000077],
            [-4.38688513199989, 12.530192363000111],
            [-4.387246866999874, 12.533964742000137],
            [-4.392647053999951, 12.53742706300008],
            [-4.401406209999919, 12.550397848000017],
            [-4.422490193999863, 12.597216695000029],
            [-4.43907832799988, 12.613288066000095],
            [-4.48253820799988, 12.64625763000005],
            [-4.491323200999943, 12.662794088000055],
            [-4.485251220999913, 12.714677226000049],
            [-4.481711384999954, 12.717416077000081],
            [-4.474941771999909, 12.71576243100013],
            [-4.464370141999893, 12.717250671000073],
            [-4.435254271999924, 12.72842315700008],
            [-4.402026325999913, 12.73656219500009],
            [-4.368850056999889, 12.738990988000054],
            [-4.339446166999892, 12.732789816000064],
            [-4.310920775999932, 12.7160208130001],
            [-4.297226521999931, 12.71214508100006],
            [-4.276297565999926, 12.714677226000049],
            [-4.257642373999971, 12.720930074000137],
            [-4.245471962999915, 12.728936319000084],
            [-4.243973957999856, 12.72992177400009],
            [-4.234129597999896, 12.742349955000066],
            [-4.213278157999923, 12.807178039000078],
            [-4.211882893999928, 12.819192810000047],
            [-4.224646971999903, 12.864513041000052],
            [-4.221313842999905, 12.92125376400007],
            [-4.229323689999887, 12.9489523310001],
            [-4.247849690999914, 12.971948344000054],
            [-4.276917683999898, 12.996236267000143],
            [-4.289733439999878, 13.013470358000035],
            [-4.316398478999929, 13.07085703600012],
            [-4.345363117999909, 13.09705698700013],
            [-4.351073363999944, 13.106074524000093],
            [-4.351073363999944, 13.118321839000117],
            [-4.345905720999951, 13.127132670000023],
            [-4.339601195999933, 13.135297547000036],
            [-4.327043823999929, 13.16855133100006],
            [-4.310197306999953, 13.175553488000062],
            [-4.246170206999864, 13.17247874000013],
            [-4.234801391999952, 13.175605164000075],
            [-4.227773396999851, 13.184441834000083],
            [-4.230021321999857, 13.193149312000045],
            [-4.251208658999929, 13.204750671000099],
            [-4.258107461999884, 13.214129944000135],
            [-4.253508259999933, 13.229090271000103],
            [-4.238780476999949, 13.246789450000023],
            [-4.220667887999923, 13.262834982000086],
            [-4.205500854999912, 13.272989401000046],
            [-4.195837361999878, 13.27469472300001],
            [-4.186458088999927, 13.272834371000101],
            [-4.176872110999909, 13.272369283000074],
            [-4.16602005999988, 13.278157044000054],
            [-4.147106485999927, 13.299602763000067],
            [-4.131577718999921, 13.323839010000057],
            [-4.114653685999912, 13.364534200000023],
            [-4.104266723999899, 13.38269846600005],
            [-4.087549397999851, 13.397994690000104],
            [-4.079307006999926, 13.402128804000128],
            [-4.052538614999946, 13.409001771000092],
            [-4.043495239999885, 13.414453634000083],
            [-4.028199014999927, 13.431532694000026],
            [-4.016029215999907, 13.435770162000068],
            [-4.005358031999918, 13.439516704000084],
            [-3.990216837999895, 13.449128520000102],
            [-3.976910155999889, 13.460626526000027],
            [-3.971613321999939, 13.469954122000061],
            [-3.979468139999881, 13.475380147000038],
            [-3.992232217999856, 13.476232809000066],
            [-3.997968302999908, 13.480521953000036],
            [-3.984480753999947, 13.496050721000046],
            [-3.981250976999974, 13.498970439000047],
            [-3.977736979999918, 13.4999264530001],
            [-3.974093790999916, 13.498944601000034],
            [-3.970321410999901, 13.496154074000074],
            [-3.965467786999852, 13.489217255000057],
            [-3.964481974999927, 13.487808329000103],
            [-3.959288492999917, 13.467938741000111],
            [-3.956058715999916, 13.46166005500001],
            [-3.947480427999892, 13.458197733000063],
            [-3.923399210999946, 13.453753561000056],
            [-3.91797318499988, 13.451066386000036],
            [-3.918593302999852, 13.440317689000011],
            [-3.92554378199992, 13.43631276500011],
            [-3.934923054999985, 13.43489166300013],
            [-3.94272619599991, 13.43194610700003],
            [-3.963009195999916, 13.413161723000115],
            [-3.971613321999939, 13.408329977000022],
            [-3.984041503999919, 13.396470235000095],
            [-3.971613321999939, 13.386755066000148],
            [-3.948410603999946, 13.380838115000046],
            [-3.928825235999938, 13.38026967400009],
            [-3.908878133999906, 13.381974996000054],
            [-3.892600056999896, 13.378926087000124],
            [-3.858080199999904, 13.365516052000075],
            [-3.81710078999987, 13.354689840000049],
            [-3.798626464999955, 13.347145081000093],
            [-3.724419108999882, 13.288828227000053],
            [-3.678711303999876, 13.261749776000087],
            [-3.596881673999945, 13.199402161000052],
            [-3.589802001999914, 13.197386780000102],
            [-3.576598672999921, 13.199298808000023],
            [-3.569958251999907, 13.196766663000034],
            [-3.553912719999857, 13.180256043000043],
            [-3.54505021099996, 13.174494120000077],
            [-3.538487304999876, 13.173408916000085],
            [-3.516111409, 13.173899841000022],
            [-3.473921513999898, 13.167601349000066],
            [-3.461592773999882, 13.165760803000097],
            [-3.449474649999985, 13.16880971300013],
            [-3.439475259999881, 13.184855245000094],
            [-3.440586303999879, 13.202838643000078],
            [-3.45226517699993, 13.2375135300001],
            [-3.448544473999931, 13.265780539000076],
            [-3.426530314999866, 13.274229635000083],
            [-3.26240596599996, 13.283918966000016],
            [-3.248634195999927, 13.292781474000023],
            [-3.283955037999903, 13.542197774000087],
            [-3.269175577999903, 13.579094747000113],
            [-3.263904581999952, 13.602659200000105],
            [-3.259718789999937, 13.658314718000042],
            [-3.266281696999897, 13.682344258000072],
            [-3.286952269999915, 13.697769674000057],
            [-3.26705684399991, 13.717044984000097],
            [-3.240417642999887, 13.707975769000129],
            [-3.195820882999953, 13.674902852000045],
            [-3.16794144699989, 13.672112325000086],
            [-3.146030639999935, 13.67665985100011],
            [-3.125101683999958, 13.677279968000093],
            [-3.100038614999931, 13.66273305300004],
            [-3.082210245999903, 13.646222433000048],
            [-3.07730098499988, 13.636791483000081],
            [-3.074510457999907, 13.622141215000099],
            [-3.06750830099989, 13.606767477000034],
            [-3.05601029399989, 13.610849915000045],
            [-3.038621174999946, 13.62958262100004],
            [-3.026968139, 13.635344543000087],
            [-3.019113321999953, 13.637514954000082],
            [-2.994773721999934, 13.634982808000089],
            [-2.986402139999967, 13.632063090000102],
            [-2.979322468999925, 13.62756724100008],
            [-2.972320312999926, 13.624466655000049],
            [-2.965008096999952, 13.625655213000059],
            [-2.930473113999966, 13.638522692000066],
            [-2.895244913999903, 13.651648458000125],
            [-2.923382731999936, 13.746035462000066],
            [-2.928059447999914, 13.799623922000123],
            [-2.912168945999895, 13.83794199600004],
            [-2.89446976699989, 13.866570740000029],
            [-2.855376545999945, 13.996175232000041],
            [-2.857030191999911, 13.997777201000076],
            [-2.858606323999936, 14.00023183200004],
            [-2.861551879999951, 14.001730449000135],
            [-2.8672879639999, 14.000541891000111],
            [-2.840855468999905, 14.042994080000057],
            [-2.693190063999907, 14.123195903000052],
            [-2.676264864999894, 14.141729055000056],
            [-2.619757853999943, 14.203604431000088],
            [-2.597381958999961, 14.222311300000072],
            [-2.516146605999893, 14.267864075000148],
            [-2.461679646999897, 14.280912374000096],
            [-2.385611938999915, 14.26471181300009],
            [-2.151879435999916, 14.15613962800009],
            [-2.119840046999911, 14.14877573600009],
            [-2.104337116999915, 14.151178691000055],
            [-2.085007889999929, 14.159668076000102],
            [-2.035917520999902, 14.18122853600002],
            [-2.02728755699988, 14.188127340000094],
            [-2.023411824999926, 14.198643494000052],
            [-2.005015014999913, 14.444235739000078],
            [-1.997056843999957, 14.470694072000072],
            [-1.967032836999891, 14.483742371000105],
            [-1.919128784999884, 14.48586110400008],
            [-1.836963256999866, 14.479582418000078],
            [-1.766683308999859, 14.483173930000063],
            [-1.696920124999906, 14.496118877000072],
            [-1.350274617999929, 14.714968567000128],
            [-1.307744913999954, 14.73465728700009],
            [-1.116697143999943, 14.780442606000122],
            [-1.078559936999881, 14.796358948000147],
            [-1.04331660999992, 14.817908020000104],
            [-1.043138154, 14.818061606000114],
            [-0.836404174999899, 14.995985006000083],
            [-0.836249145999943, 14.996088359000026],
            [-0.782815714999941, 15.048384908000031],
            [-0.771271818999935, 15.056619155000107],
            [-0.752895059999901, 15.06972727400003],
            [-0.719718790999906, 15.078460592000098],
            [-0.500343259999852, 15.079721112000115],
            [-0.46789953699988, 15.079907532000092],
            [-0.458649454999943, 15.075463359000082],
            [-0.435601765999905, 15.015156962000091],
            [-0.425731567999918, 15.002599589000084],
            [-0.3976712649999, 15.002134501000057],
            [-0.361471923999943, 15.017740784000097],
            [-0.29917598499992, 15.054741110000052],
            [-0.236699177999867, 15.065618999000023],
            [-0.166987670999902, 15.049676819000084],
            [-0.033404092999916, 14.995933329000081],
            [-0.033197387999962, 14.995933329000081],
            [0.21846683800004, 14.910977275000093],
            [0.22084395400006, 14.88821380600011],
            [0.211852254000121, 14.874803772000064],
            [0.198002971000051, 14.86379669200008],
            [0.18575565600014, 14.84819040900004],
            [0.184102010000089, 14.819561666000055],
            [0.213092488000143, 14.761632386000116],
            [0.219707072000062, 14.73122080500005],
            [0.152941121000111, 14.546710103000109],
            [0.158832234000016, 14.496118877000072],
            [0.188649536000128, 14.447749736000034],
            [0.202382348000128, 14.435544541000127],
            [0.346366007000086, 14.30757741400005],
            [0.388792358000103, 14.251611837000041],
            [0.391634562000064, 14.245927430000094],
            [0.390601034000099, 14.23763336200004],
            [0.381118408000106, 14.225670268000087],
            [0.377423543000106, 14.216601054000122],
            [0.37215254700007, 14.185646871000117],
            [0.367398315000088, 14.173787130000093],
            [0.343472127000098, 14.137536113000053],
            [0.339157145000115, 14.125779725000143],
            [0.343575480000112, 14.114333395000045],
            [0.356262044000061, 14.095704041000076],
            [0.362463216000151, 14.088856913000114],
            [0.368741902000068, 14.084154358000134],
            [0.374219605000036, 14.078883362000099],
            [0.378457072000089, 14.070434265000102],
            [0.377320190000091, 14.063948873000058],
            [0.369051961000139, 14.047851664000078],
            [0.369155314000068, 14.039066671000086],
            [0.378353719000074, 14.0288089000001],
            [0.391376180000094, 14.022581889000023],
            [0.401866495000149, 14.013796895000027],
            [0.403933553000115, 13.996071879000098],
            [0.411865886000072, 13.97842437700011],
            [0.428376506000063, 13.96749481200004],
            [0.445920654000105, 13.958580628000021],
            [0.456695190000062, 13.94685007800004],
            [0.456255941000023, 13.938142599000074],
            [0.448065227000114, 13.920107524000073],
            [0.448633666000148, 13.909617208000029],
            [0.454809001000029, 13.902356669000142],
            [0.475660441000088, 13.888946635000096],
            [0.483515259000029, 13.880342509000059],
            [0.491990194000039, 13.861816508000032],
            [0.499925937000114, 13.851015080000096],
            [0.504082479000118, 13.845357564000054],
            [0.519275350000044, 13.831637472000125],
            [0.55296838400011, 13.810036723000067],
            [0.563200317000081, 13.796781718000062],
            [0.57446577900015, 13.785025330000067],
            [0.59368941200006, 13.778100687000077],
            [0.600510701000132, 13.76872141500013],
            [0.5945162350001, 13.749859517000104],
            [0.584801066000068, 13.729008077000046],
            [0.580460245000069, 13.713789368000107],
            [0.594309530000146, 13.68888132800005],
            [0.620664510000097, 13.679967143000027],
            [0.753369588000055, 13.684101258000041],
            [0.763498169000115, 13.682034200000075],
            [0.766392049000103, 13.675109558000102],
            [0.766185343000132, 13.666970520000092],
            [0.767012166000058, 13.66087270100013],
            [0.766288696000061, 13.657177836000116],
            [0.762878052000133, 13.653043722000106],
            [0.763704874000069, 13.646429138000101],
            [0.775693807000039, 13.635292867000075],
            [0.795330852000063, 13.625965271000055],
            [0.813107544000076, 13.625035095000086],
            [0.85072798600001, 13.628600769000059],
            [0.896926717000071, 13.614932353000142],
            [0.950980266000045, 13.583203024000028],
            [0.991391235000123, 13.541112569000092],
            [0.996558878000116, 13.496050721000046],
            [1.015265747000115, 13.465664978000092],
            [1.04823531100007, 13.441945496000045],
            [1.157169230000079, 13.392646179000053],
            [1.175049275000049, 13.38691009500009],
            [1.21742395000004, 13.381768290000096],
            [1.234270467000016, 13.37758250000006],
            [1.249566691000069, 13.367066346000101],
            [1.268686971000079, 13.346059875000094],
            [1.241505168000089, 13.335543721000136],
            [1.222074829000093, 13.3446129350001],
            [1.205745076000085, 13.358901469000088],
            [1.187658325000143, 13.364120789000097],
            [1.182387329000022, 13.358694764000035],
            [1.17763309800003, 13.347610169000106],
            [1.167607869000108, 13.313426209000028],
            [1.160683228000039, 13.311307475000149],
            [1.13846236100008, 13.320376689000113],
            [1.084718872000082, 13.333580018000106],
            [1.004723755000043, 13.364844259000094],
            [0.983536418000085, 13.368409933000066],
            [0.970410604000023, 13.32833485900008],
            [0.970824015000034, 13.243533834000047],
            [0.971340779000087, 13.149405213000065],
            [0.971661196000127, 13.085782453000121],
            [0.971754191000088, 13.067317200000062],
            [0.974648071000075, 13.048326111000094],
            [0.983536418000085, 13.032358093000056],
            [1.012268513000095, 13.016881002000062],
            [1.083788696000028, 13.010989888000054],
            [1.113967733000038, 12.996236267000143],
            [1.170915161000096, 12.949210714000074],
            [1.230756470000074, 12.899756368000041],
            [1.304806449000068, 12.838507989000092],
            [1.330595336000101, 12.817177429000097],
            [1.412037394000038, 12.749868876000107],
            [1.467124471000091, 12.704393616000047],
            [1.535854126000061, 12.647497864000087],
            [1.563862752000063, 12.63214996400012],
            [1.597039021000086, 12.623675029000111],
            [1.699461710000122, 12.61489003500013],
            [1.826068969000119, 12.604193014000117],
            [1.843742309000106, 12.606105042000138],
            [1.860692179000125, 12.617060445000021],
            [1.872681112000095, 12.634217021000083],
            [1.883223104000137, 12.653957418000047],
            [1.900172974000043, 12.678452047000093],
            [1.906994262000097, 12.69183624300004],
            [1.911438436000111, 12.696642151000049],
            [1.919603312000049, 12.698347473000098],
            [1.926631307000122, 12.694988505000097],
            [1.934486124000074, 12.693541565000103],
            [1.945544881000075, 12.700827942000075],
            [1.962494750000076, 12.71912139900006],
            [1.971693156000072, 12.72423736600004],
            [2.068948202000115, 12.716279196000073],
            [2.109049113000111, 12.705633851000087],
            [2.135197388000108, 12.675609843000117],
            [2.140985148000084, 12.656127828000123],
            [2.144809204000126, 12.650753479000073],
            [2.155454549000098, 12.640004781000059],
            [2.165996541000084, 12.631736552000106],
            [2.184289998000054, 12.620626119000093],
            [2.193281698000078, 12.609464009000064],
            [2.199999633000118, 12.595924784000076],
            [2.203203572000092, 12.583315735000056],
            [2.210851684000147, 12.523061015000081],
            [2.215709269000087, 12.510348612000115],
            [2.22387414500011, 12.494845683000023],
            [2.229558553000061, 12.487145895000111],
            [2.242270955000095, 12.473451640000093],
            [2.246301717000108, 12.465906880000148],
            [2.246301717000108, 12.461669414000099],
            [2.243097778000021, 12.451179098000054],
            [2.242994425000091, 12.446166484000088],
            [2.244958130000043, 12.424152324000104],
            [2.237930135000113, 12.413455302000102],
            [2.223254028000042, 12.409734599000089],
            [2.163826131000093, 12.404773661000135],
            [2.158761840000096, 12.405652160000074],
            [2.148013142000082, 12.410768127000068],
            [2.145015910000069, 12.411749980000124],
            [2.138711385000079, 12.408339336000012],
            [2.131476685000109, 12.398520814000051],
            [2.126929159000071, 12.395110169000105],
            [2.069258260000083, 12.383327942000022],
            [2.054168741000097, 12.370925599000131],
            [2.051791626000039, 12.341935120000073],
            [2.07091190500006, 12.306898499000056],
            [2.113803345000093, 12.247987366000046],
            [2.188527466000096, 12.145461324000081],
            [2.258807413000085, 12.048774720000026],
            [2.338079061000116, 11.940099182000083],
            [2.390168904000092, 11.896535950000057],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Togo',
        iso3: 'TGO',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-0.16610917099996, 11.134980367000125],
            [-0.115062219999885, 11.124658279000059],
            [-0.0631180419999, 11.114154765000066],
            [0.059587646000068, 11.08940175400005],
            [0.28755822700009, 11.04343556700006],
            [0.374779215000075, 11.025807961000112],
            [0.486615844000085, 11.003205465000121],
            [0.488786254000075, 11.001784363000041],
            [0.490129842000044, 10.999510600000121],
            [0.49064660600007, 10.99635833700006],
            [0.489303019000118, 10.991914165000054],
            [0.488579549000121, 10.987754212000127],
            [0.487132609000128, 10.983671774000115],
            [0.483618612000072, 10.979692688000043],
            [0.499741658000062, 10.975687764000057],
            [0.487649373000067, 10.933235576000115],
            [0.612602987000116, 10.976566264000084],
            [0.675338175000149, 10.988529358000036],
            [0.771559692000096, 10.990363872000046],
            [0.901474243000109, 10.992740987000076],
            [0.875842732000137, 10.93116851800005],
            [0.872948853000139, 10.911298930000058],
            [0.875325968000084, 10.90052439400003],
            [0.883697551000068, 10.88021555600011],
            [0.885144490000073, 10.86938934400007],
            [0.869538208000108, 10.839907938000053],
            [0.8675745030001, 10.829210917000054],
            [0.866024210000148, 10.80636993400013],
            [0.862923625000121, 10.796086324000058],
            [0.850004517000116, 10.777689514000144],
            [0.795640910000145, 10.726478170000036],
            [0.781274862000146, 10.693043519000057],
            [0.789233032000112, 10.60294565900007],
            [0.788509562000115, 10.563852438000055],
            [0.773833456000119, 10.508145243000115],
            [0.759880818000113, 10.405154114000126],
            [0.760707642000057, 10.382158102000076],
            [0.768769164000048, 10.36709442100009],
            [0.844423462000094, 10.317174988000119],
            [0.939508097000044, 10.254517314000097],
            [0.997105905000097, 10.216553226000073],
            [1.082238403000105, 10.160440369000042],
            [1.225485473000049, 10.066053365000087],
            [1.331008748000102, 9.996471049000093],
            [1.343824503000093, 9.962442119000045],
            [1.34394169300009, 9.954756420000066],
            [1.345064737000115, 9.881103414000052],
            [1.346925089000138, 9.771833598000057],
            [1.348165324000149, 9.694163920000051],
            [1.356020141000101, 9.647474264000067],
            [1.354573201000107, 9.635304464000058],
            [1.35219608500006, 9.625356751000055],
            [1.352506144000131, 9.605280456000102],
            [1.351265910000109, 9.595074362000034],
            [1.345064737000115, 9.58238779700008],
            [1.327288045000103, 9.55530934600003],
            [1.323153930000075, 9.542312724000084],
            [1.326357869000049, 9.521952209000062],
            [1.336486450000081, 9.497509257000019],
            [1.351265910000109, 9.48254893000005],
            [1.368422485000082, 9.490842998000105],
            [1.379894653000093, 9.4624726360001],
            [1.386715942000137, 9.36113515200006],
            [1.401185343000066, 9.32126678500012],
            [1.4201460190001, 9.292317169000057],
            [1.425266561000115, 9.28449900300005],
            [1.50515832500011, 9.201454977000083],
            [1.567273397000093, 9.136730245000095],
            [1.587840617000097, 9.100892639000051],
            [1.595798787000149, 9.07681142200002],
            [1.601173136000114, 9.0495262660001],
            [1.602826782000051, 8.924391785000097],
            [1.604273722000045, 8.815225321000042],
            [1.605513956000095, 8.722491964000127],
            [1.607204026000119, 8.588617302000031],
            [1.607581014000061, 8.558755188000049],
            [1.609027954000055, 8.546972961000051],
            [1.614092245000109, 8.535785014000112],
            [1.639930461000034, 8.50325470000007],
            [1.644167928000087, 8.493487855000112],
            [1.64044722400007, 8.475814514000106],
            [1.607581014000061, 8.421864319000065],
            [1.606030721000138, 8.413389384000055],
            [1.606030721000138, 8.39602610300004],
            [1.601069784000089, 8.371634827000022],
            [1.603944873000017, 8.367476215000096],
            [1.609854777000066, 8.365485331000045],
            [1.61491906700013, 8.356261089000043],
            [1.625564412000131, 8.270478210000121],
            [1.623807414000055, 8.155885722000093],
            [1.621326945000078, 7.996567281000097],
            [1.621947062000061, 7.838282369000098],
            [1.622773885000072, 7.640051575000129],
            [1.622854912000122, 7.622459699000032],
            [1.623251367000051, 7.536384757000107],
            [1.623704060000136, 7.438100078000062],
            [1.624324178000109, 7.288806865000097],
            [1.624944296000081, 7.143647767000061],
            [1.62566776500006, 6.996783346000058],
            [1.607477661000132, 6.991408996000089],
            [1.53192671700009, 6.991925761000033],
            [1.551357055000068, 6.920870666000027],
            [1.562622518000126, 6.90428253200011],
            [1.564223443000088, 6.903089389000073],
            [1.579055623000102, 6.892035217000085],
            [1.58804732300004, 6.881234843000058],
            [1.590114380000102, 6.867333883000086],
            [1.582569620000072, 6.825346781000079],
            [1.583189738000044, 6.808267720000032],
            [1.587530558000111, 6.791033631000047],
            [1.595178670000081, 6.770569763000083],
            [1.601069784000089, 6.746436869000121],
            [1.597039021000086, 6.730959778000027],
            [1.589182290000082, 6.72046032800003],
            [1.574301392000109, 6.700574036000077],
            [1.566033163000071, 6.678146465000083],
            [1.572441040000115, 6.666906840000124],
            [1.58536014800012, 6.656442363000082],
            [1.596315552000078, 6.636417745000045],
            [1.596522257000061, 6.628640443000037],
            [1.594765258000081, 6.620268860000053],
            [1.594145141000098, 6.611044617000047],
            [1.597349081000061, 6.600812684000061],
            [1.603343547000094, 6.592596130000032],
            [1.611198364000131, 6.584689636000078],
            [1.619569946000098, 6.577997539000066],
            [1.62742476400004, 6.573346660000098],
            [1.636829874000085, 6.572261454000099],
            [1.646648397000149, 6.573191630000068],
            [1.653883098000051, 6.570659485000078],
            [1.655226685000088, 6.559213156000069],
            [1.657810506000089, 6.55226267500008],
            [1.674450318000112, 6.538594259000064],
            [1.680754842000027, 6.530067648000042],
            [1.681995077000067, 6.520016581000021],
            [1.67951460800009, 6.498570862000079],
            [1.681685018000081, 6.489837545000114],
            [1.688299601000097, 6.484437358000136],
            [1.709796997000126, 6.473404440000053],
            [1.71837528500015, 6.466996561000101],
            [1.744110148000061, 6.425732930000095],
            [1.763540486000124, 6.350647075000097],
            [1.782350708000138, 6.27726654100006],
            [1.761576782000105, 6.276026306000119],
            [1.633109171000086, 6.245692240000082],
            [1.612438598000068, 6.234762675000098],
            [1.619639519000089, 6.213893947000088],
            [1.619313998000052, 6.213812567000048],
            [1.429535352000073, 6.18195221600007],
            [1.271006707000083, 6.133734442000048],
            [1.199554884000065, 6.102525132000039],
            [1.191579623000052, 6.10187409100007],
            [1.185394727000073, 6.100490627000056],
            [1.187968384000044, 6.135647278000079],
            [1.176186157000132, 6.151511942000084],
            [1.093400513000063, 6.160917053000048],
            [1.079654581000113, 6.167919210000136],
            [1.068905883000099, 6.18034739200003],
            [1.055780070000111, 6.200630392000036],
            [1.048131958000056, 6.209389547000114],
            [1.0405871990001, 6.213471985000112],
            [1.033145793000074, 6.216546733000058],
            [1.025187622000118, 6.222334493000034],
            [1.009684692000093, 6.244452006000046],
            [0.983536418000085, 6.324602153000114],
            [0.907262003000085, 6.324912211000097],
            [0.88679813600001, 6.33038991300009],
            [0.87387902800009, 6.340130921000124],
            [0.841322876000049, 6.379224142000055],
            [0.81620813000012, 6.395062968000062],
            [0.766805461000104, 6.419350891000065],
            [0.745721476000085, 6.440899963000021],
            [0.729908488000092, 6.465084534000084],
            [0.717919555000123, 6.488829854000045],
            [0.711718383000033, 6.513376160000107],
            [0.713075710000084, 6.533935652000082],
            [0.713475383000116, 6.539989523000131],
            [0.719779907000117, 6.552727763000092],
            [0.726807902000132, 6.562107035000054],
            [0.727428019000115, 6.571434632000077],
            [0.714612264000039, 6.583914490000069],
            [0.705517212000046, 6.585774842000077],
            [0.677611938000069, 6.584896342000135],
            [0.668206828000109, 6.58582651800009],
            [0.659421834000028, 6.601717021000113],
            [0.645365844000111, 6.612026469000114],
            [0.632240031000038, 6.623989563000066],
            [0.626658976000044, 6.644892680000041],
            [0.635340617000082, 6.695380554000067],
            [0.634307088000099, 6.711606954000075],
            [0.62583215300009, 6.727755839000054],
            [0.611259399000062, 6.741527609000102],
            [0.593792765000103, 6.751113587000106],
            [0.576636190000045, 6.75473093700009],
            [0.570021607000058, 6.763515930000068],
            [0.541082805000087, 6.817181906000059],
            [0.528887167000079, 6.826535340000092],
            [0.519275350000044, 6.832245585000052],
            [0.51607141100007, 6.841805725000143],
            [0.522789347000099, 6.86283803300006],
            [0.543873332000118, 6.897926330000089],
            [0.54625044800008, 6.914772847000066],
            [0.534468221000083, 6.935908508000111],
            [0.506046183000052, 6.957819316000069],
            [0.494574015000126, 6.973115540000023],
            [0.509146769000097, 6.977611389000046],
            [0.523822876000082, 6.97869659500013],
            [0.565990844000055, 6.989651998000113],
            [0.57890995300005, 6.996783346000058],
            [0.598030233000145, 7.031199849000103],
            [0.598753702000039, 7.074711405000116],
            [0.594309530000146, 7.119721578000053],
            [0.597720174000074, 7.158892314000099],
            [0.621801392000094, 7.218836975000087],
            [0.631103149000126, 7.265242412000092],
            [0.644435668000142, 7.301932678000071],
            [0.645675903000097, 7.323585104000045],
            [0.629656209000132, 7.389162496000068],
            [0.623041626000145, 7.397895813000048],
            [0.586248006000062, 7.38435658800006],
            [0.566404256000055, 7.380790914000087],
            [0.548214152000099, 7.383271383000064],
            [0.516691528000138, 7.411021627000096],
            [0.500568481000073, 7.455049947000063],
            [0.495607544000109, 7.504297587000053],
            [0.49943160000015, 7.562381897000122],
            [0.50304895000005, 7.574680888000074],
            [0.509250122000111, 7.585377910000076],
            [0.519378703000086, 7.595196432000051],
            [0.532504517000064, 7.601035868000039],
            [0.548524211000085, 7.60537668900011],
            [0.562063436000074, 7.612301331000097],
            [0.56774784300012, 7.625737203000142],
            [0.567437785000038, 7.652919006000033],
            [0.570538371000083, 7.683924866000055],
            [0.583354126000074, 7.704285380000087],
            [0.612292928000045, 7.699427796000066],
            [0.609502400000082, 7.718961487000072],
            [0.611672811000062, 7.771258037000081],
            [0.602577759000098, 7.82841217100011],
            [0.60340458100012, 7.888305155000083],
            [0.602687912000135, 7.893132132000062],
            [0.592862590000038, 7.959308574000076],
            [0.59368941200006, 7.996567281000097],
            [0.59317264800012, 8.015739238000023],
            [0.583974243000029, 8.053049622000046],
            [0.580253540000115, 8.100075175000114],
            [0.574982544000079, 8.12462148100009],
            [0.579943481000043, 8.131701152000119],
            [0.58779829900007, 8.137721456000051],
            [0.593276001000049, 8.15066640200007],
            [0.591519002000069, 8.164489848000116],
            [0.584594360000096, 8.173068136000055],
            [0.576842895000084, 8.180483703000078],
            [0.572708781000074, 8.190999857000037],
            [0.573845662000082, 8.203944804000045],
            [0.579013305000075, 8.207820537000103],
            [0.586661417000073, 8.208750712000054],
            [0.595032999000125, 8.212729797000037],
            [0.628312622000067, 8.24246958400002],
            [0.645055786000114, 8.253424988000091],
            [0.689187459000038, 8.27285532600007],
            [0.70520715300006, 8.28275136300006],
            [0.712751912000016, 8.297970072000098],
            [0.708824504000063, 8.322568055000076],
            [0.705103801000035, 8.325978699000103],
            [0.693114868000094, 8.32789072600012],
            [0.689187459000038, 8.331301371000052],
            [0.688567342000056, 8.336029765000134],
            [0.689394165000067, 8.346054993000067],
            [0.686913697000108, 8.360731100000052],
            [0.687223755000076, 8.37220326700006],
            [0.685053345000085, 8.382564392000077],
            [0.64670943200008, 8.414164530000065],
            [0.633790324000074, 8.452017517000058],
            [0.616323690000115, 8.48875946000004],
            [0.550797974000119, 8.519326070000133],
            [0.524753052000051, 8.538032939000118],
            [0.500568481000073, 8.560176290000044],
            [0.483515259000029, 8.579787496000066],
            [0.443517700000058, 8.606865947000117],
            [0.403726847000144, 8.662082214000122],
            [0.374426310000104, 8.724765727000062],
            [0.368083532000128, 8.761481025000066],
            [0.365873861000068, 8.774271749000107],
            [0.372669311000038, 8.783754375000086],
            [0.385278361000132, 8.786079814000118],
            [0.397112264000071, 8.781532287000076],
            [0.40780928600006, 8.75905303900008],
            [0.418299601000115, 8.770602722000106],
            [0.424965861000118, 8.787320048000055],
            [0.419591512000068, 8.791247457000026],
            [0.430133504000139, 8.794735617000072],
            [0.439409424000047, 8.793443705000115],
            [0.44951216600009, 8.790368957000084],
            [0.462482951000112, 8.78830190100011],
            [0.473490031000011, 8.793547058000044],
            [0.477004029000057, 8.806750386000132],
            [0.47845096900005, 8.822330832000063],
            [0.483515259000029, 8.834810689000065],
            [0.483629270000051, 8.834973182000098],
            [0.505632771000137, 8.866333313000027],
            [0.493127075000132, 8.915219218000104],
            [0.44488712600014, 8.996454570000083],
            [0.44488712600014, 8.996557922000108],
            [0.444680419000093, 8.996557922000108],
            [0.431270386000051, 9.027589620000043],
            [0.441553996000039, 9.05818206800005],
            [0.458478027000126, 9.089239604000085],
            [0.463749023000076, 9.12145985900014],
            [0.463645671000052, 9.137091980000093],
            [0.469976034000069, 9.146729635000014],
            [0.492610310000117, 9.16675425300005],
            [0.504702595000083, 9.187166443000095],
            [0.504392537000115, 9.20310862200003],
            [0.491990194000039, 9.238894551000058],
            [0.492920370000093, 9.258609111000098],
            [0.501085245000098, 9.268195089000102],
            [0.512350708000071, 9.274706320000078],
            [0.522479288000113, 9.285067444000092],
            [0.526613403000056, 9.297650656000116],
            [0.528267049000107, 9.32695119300007],
            [0.537568807000127, 9.37764577200005],
            [0.531367635000038, 9.401106873000032],
            [0.513280884000039, 9.416790670000083],
            [0.483515259000029, 9.426841736000114],
            [0.482791788000043, 9.427875265000097],
            [0.482585083000089, 9.428857117000064],
            [0.482791788000043, 9.42983896900003],
            [0.489406372000133, 9.44102691600007],
            [0.491680135000138, 9.451284689000062],
            [0.489923136000073, 9.461129049000121],
            [0.483515259000029, 9.470017395000056],
            [0.430443562000107, 9.489189351000064],
            [0.4116591800001, 9.492238261000082],
            [0.371429077000073, 9.490016175000079],
            [0.348949829000077, 9.486037089000092],
            [0.33378279600015, 9.479474182000018],
            [0.328796021000102, 9.471567688000064],
            [0.325747111000084, 9.451336365000074],
            [0.321819702000113, 9.442835591000062],
            [0.314223267000045, 9.436479391000134],
            [0.268489624000011, 9.420640564000038],
            [0.249886109000073, 9.416945699000038],
            [0.231360108000018, 9.418961080000074],
            [0.226812581000075, 9.432345276000106],
            [0.234977458000117, 9.443765767000116],
            [0.227949463000101, 9.459733785000054],
            [0.228052816000115, 9.473970642000026],
            [0.269729858000062, 9.482342224000092],
            [0.285310302000084, 9.488362529000128],
            [0.298100219000048, 9.497095845000104],
            [0.30192427500009, 9.50745697100011],
            [0.293139282000112, 9.518283183000065],
            [0.279005778000084, 9.519006653000062],
            [0.253503459000058, 9.51425242200007],
            [0.243116496000113, 9.518696594000076],
            [0.233220459000023, 9.52559539800005],
            [0.225908244000038, 9.531925761000068],
            [0.223401937000062, 9.534793803000056],
            [0.223066040000077, 9.541175842000087],
            [0.227742757000044, 9.569339498000133],
            [0.230197388000107, 9.57574737600008],
            [0.280530233000093, 9.570166321000059],
            [0.304559774000012, 9.57156158500004],
            [0.322439819000067, 9.583137105000077],
            [0.336159912000085, 9.574197082000055],
            [0.354608398000011, 9.571096497000013],
            [0.370808960000119, 9.575644023000052],
            [0.377733602000092, 9.589415792000082],
            [0.369155314000068, 9.610138041000113],
            [0.349363241000077, 9.613910421000043],
            [0.30879724100015, 9.603678488000071],
            [0.277636352000087, 9.60698577900007],
            [0.26169417300008, 9.627940572000057],
            [0.260970703000083, 9.657163594000096],
            [0.275285075000056, 9.685585633000116],
            [0.30192427500009, 9.65783538800008],
            [0.318719116000068, 9.648611145000075],
            [0.336650838000139, 9.650833231000078],
            [0.347089478000072, 9.663158061000033],
            [0.349880005000045, 9.68065053400008],
            [0.347606242000097, 9.69884063800012],
            [0.342955363000044, 9.71354258300002],
            [0.336289103000126, 9.723490296000108],
            [0.329131918000087, 9.731293437000133],
            [0.323886759000061, 9.742067973000061],
            [0.322439819000067, 9.760671489000117],
            [0.343885538000109, 9.838392843000037],
            [0.344195597000095, 9.84976165800012],
            [0.339673909000055, 9.889836731000116],
            [0.341715128000118, 9.903789368000105],
            [0.349776652000088, 9.918956400000127],
            [0.362592407000079, 9.93267649300006],
            [0.369568726000068, 9.938825989000122],
            [0.370188842000061, 9.947016703000145],
            [0.363393392000091, 9.966782938000023],
            [0.351430297000149, 9.990450745000146],
            [0.349776652000088, 9.997168681000076],
            [0.35174035700004, 10.006418763000084],
            [0.355125163000139, 10.012619934000071],
            [0.355719441000105, 10.018976136000106],
            [0.349776652000088, 10.02882049600008],
            [0.367294962000074, 10.032127787000078],
            [0.382746215000054, 10.029595643000093],
            [0.393908325000098, 10.032489522000077],
            [0.394570260000137, 10.035557027000038],
            [0.398145792000122, 10.052126566000112],
            [0.395148560000024, 10.072357890000106],
            [0.387087036000139, 10.078946635000094],
            [0.376079956000041, 10.081582133000026],
            [0.363393392000091, 10.08966949500011],
            [0.353600708000045, 10.11550771100012],
            [0.358845866000053, 10.18633026100008],
            [0.357192220000115, 10.219997457000119],
            [0.364426920000085, 10.233407491000065],
            [0.367294962000074, 10.249814759000031],
            [0.372049194000056, 10.265136821000084],
            [0.396595500000018, 10.283223572000097],
            [0.376183308000066, 10.299940898000045],
            [0.366597330000076, 10.304488424000084],
            [0.322749878000138, 10.297253723000026],
            [0.30879724100015, 10.29709869400007],
            [0.317582235000145, 10.317330017000074],
            [0.307066081000102, 10.333272196000095],
            [0.290038696000067, 10.348490906000038],
            [0.278824911000129, 10.366629333000063],
            [0.280220174000107, 10.375181784000091],
            [0.283553304000094, 10.385775452000061],
            [0.283114054000094, 10.396808370000059],
            [0.273243856000107, 10.40660105400012],
            [0.263011922000118, 10.408926493000052],
            [0.253942708000068, 10.40608429000008],
            [0.244563436000107, 10.401536763000053],
            [0.233220459000023, 10.398617045000051],
            [0.223608642000016, 10.399960632000031],
            [0.197072795000111, 10.410270081000121],
            [0.194437296000103, 10.407376201000133],
            [0.191750122000144, 10.400839132000058],
            [0.187512654000102, 10.394948019000054],
            [0.179864542000132, 10.394172872000055],
            [0.176970663000134, 10.397686869000012],
            [0.126017700000091, 10.491608786000114],
            [0.110178874000098, 10.508248596000044],
            [0.057262207000122, 10.541114808000074],
            [0.049019816000083, 10.550959168000048],
            [0.0373409420001, 10.573180034000089],
            [0.029434448000075, 10.582533468000122],
            [0.020339396000082, 10.588037008000114],
            [-0.01092484499992, 10.5982689410001],
            [-0.019968220999971, 10.604340922000048],
            [-0.026221069999877, 10.61036122600008],
            [-0.03335241699989, 10.615063782000064],
            [-0.056451781999982, 10.618009338000064],
            [-0.068363199999908, 10.621058248000097],
            [-0.079344441999893, 10.626251730000106],
            [-0.0881294349999, 10.633486430000076],
            [-0.098335530999861, 10.65415700300008],
            [-0.09768957599988, 10.675008443000053],
            [-0.091564479999874, 10.700253768000039],
            [-0.0881294349999, 10.714411723000055],
            [-0.082806762999923, 10.756217957000018],
            [-0.075210326999866, 10.773658753000063],
            [-0.06110266099995, 10.791357931000064],
            [-0.040690470999891, 10.80502634700008],
            [-0.032060505999937, 10.81316538500009],
            [-0.030200154999932, 10.823784892000077],
            [-0.035316120999937, 10.843447774000111],
            [-0.03609126799995, 10.853137105000144],
            [-0.014438842999965, 10.953596090000048],
            [-0.009581257999855, 10.963001201000097],
            [-0.001571410999873, 10.971295268000063],
            [0.007187744000106, 10.976798808000055],
            [0.014189901000123, 10.983671774000115],
            [0.016567017000057, 10.99620330800012],
            [0.019409221000046, 11.031627502000049],
            [0.016205282000072, 11.062581686000058],
            [0.001115763000058, 11.085991110000109],
            [-0.032267211999908, 11.09857432000004],
            [-0.051077432999904, 11.098264262000058],
            [-0.085028849999929, 11.08940175400005],
            [-0.103348144999927, 11.087541403000046],
            [-0.121744954999912, 11.092192282000013],
            [-0.142079630999945, 11.103328552000036],
            [-0.158667764999933, 11.118443908000131],
            [-0.16610917099996, 11.134980367000125],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Ghana',
        iso3: 'GHA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-0.16610917099996, 11.134980367000125],
            [-0.158667764999933, 11.118443908000131],
            [-0.142079630999945, 11.103328552000036],
            [-0.121744954999912, 11.092192282000013],
            [-0.103348144999927, 11.087541403000046],
            [-0.085028849999929, 11.08940175400005],
            [-0.051077432999904, 11.098264262000058],
            [-0.032267211999908, 11.09857432000004],
            [0.001115763000058, 11.085991110000109],
            [0.016205282000072, 11.062581686000058],
            [0.019409221000046, 11.031627502000049],
            [0.016567017000057, 10.99620330800012],
            [0.014189901000123, 10.983671774000115],
            [0.007187744000106, 10.976798808000055],
            [-0.001571410999873, 10.971295268000063],
            [-0.009581257999855, 10.963001201000097],
            [-0.014438842999965, 10.953596090000048],
            [-0.03609126799995, 10.853137105000144],
            [-0.035316120999937, 10.843447774000111],
            [-0.030200154999932, 10.823784892000077],
            [-0.032060505999937, 10.81316538500009],
            [-0.040690470999891, 10.80502634700008],
            [-0.06110266099995, 10.791357931000064],
            [-0.075210326999866, 10.773658753000063],
            [-0.082806762999923, 10.756217957000018],
            [-0.0881294349999, 10.714411723000055],
            [-0.091564479999874, 10.700253768000039],
            [-0.09768957599988, 10.675008443000053],
            [-0.098335530999861, 10.65415700300008],
            [-0.0881294349999, 10.633486430000076],
            [-0.079344441999893, 10.626251730000106],
            [-0.068363199999908, 10.621058248000097],
            [-0.056451781999982, 10.618009338000064],
            [-0.03335241699989, 10.615063782000064],
            [-0.026221069999877, 10.61036122600008],
            [-0.019968220999971, 10.604340922000048],
            [-0.01092484499992, 10.5982689410001],
            [0.020339396000082, 10.588037008000114],
            [0.029434448000075, 10.582533468000122],
            [0.0373409420001, 10.573180034000089],
            [0.049019816000083, 10.550959168000048],
            [0.057262207000122, 10.541114808000074],
            [0.110178874000098, 10.508248596000044],
            [0.126017700000091, 10.491608786000114],
            [0.176970663000134, 10.397686869000012],
            [0.179864542000132, 10.394172872000055],
            [0.187512654000102, 10.394948019000054],
            [0.191750122000144, 10.400839132000058],
            [0.194437296000103, 10.407376201000133],
            [0.197072795000111, 10.410270081000121],
            [0.223608642000016, 10.399960632000031],
            [0.233220459000023, 10.398617045000051],
            [0.244563436000107, 10.401536763000053],
            [0.253942708000068, 10.40608429000008],
            [0.263011922000118, 10.408926493000052],
            [0.273243856000107, 10.40660105400012],
            [0.283114054000094, 10.396808370000059],
            [0.283553304000094, 10.385775452000061],
            [0.280220174000107, 10.375181784000091],
            [0.278824911000129, 10.366629333000063],
            [0.290038696000067, 10.348490906000038],
            [0.307066081000102, 10.333272196000095],
            [0.317582235000145, 10.317330017000074],
            [0.30879724100015, 10.29709869400007],
            [0.322749878000138, 10.297253723000026],
            [0.366597330000076, 10.304488424000084],
            [0.376183308000066, 10.299940898000045],
            [0.396595500000018, 10.283223572000097],
            [0.372049194000056, 10.265136821000084],
            [0.367294962000074, 10.249814759000031],
            [0.364426920000085, 10.233407491000065],
            [0.357192220000115, 10.219997457000119],
            [0.358845866000053, 10.18633026100008],
            [0.353600708000045, 10.11550771100012],
            [0.363393392000091, 10.08966949500011],
            [0.376079956000041, 10.081582133000026],
            [0.387087036000139, 10.078946635000094],
            [0.395148560000024, 10.072357890000106],
            [0.398145792000122, 10.052126566000112],
            [0.394570260000137, 10.035557027000038],
            [0.393908325000098, 10.032489522000077],
            [0.382746215000054, 10.029595643000093],
            [0.367294962000074, 10.032127787000078],
            [0.349776652000088, 10.02882049600008],
            [0.355719441000105, 10.018976136000106],
            [0.355125163000139, 10.012619934000071],
            [0.35174035700004, 10.006418763000084],
            [0.349776652000088, 9.997168681000076],
            [0.351430297000149, 9.990450745000146],
            [0.363393392000091, 9.966782938000023],
            [0.370188842000061, 9.947016703000145],
            [0.369568726000068, 9.938825989000122],
            [0.362592407000079, 9.93267649300006],
            [0.349776652000088, 9.918956400000127],
            [0.341715128000118, 9.903789368000105],
            [0.339673909000055, 9.889836731000116],
            [0.344195597000095, 9.84976165800012],
            [0.343885538000109, 9.838392843000037],
            [0.322439819000067, 9.760671489000117],
            [0.323886759000061, 9.742067973000061],
            [0.329131918000087, 9.731293437000133],
            [0.336289103000126, 9.723490296000108],
            [0.342955363000044, 9.71354258300002],
            [0.347606242000097, 9.69884063800012],
            [0.349880005000045, 9.68065053400008],
            [0.347089478000072, 9.663158061000033],
            [0.336650838000139, 9.650833231000078],
            [0.318719116000068, 9.648611145000075],
            [0.30192427500009, 9.65783538800008],
            [0.275285075000056, 9.685585633000116],
            [0.260970703000083, 9.657163594000096],
            [0.26169417300008, 9.627940572000057],
            [0.277636352000087, 9.60698577900007],
            [0.30879724100015, 9.603678488000071],
            [0.349363241000077, 9.613910421000043],
            [0.369155314000068, 9.610138041000113],
            [0.377733602000092, 9.589415792000082],
            [0.370808960000119, 9.575644023000052],
            [0.354608398000011, 9.571096497000013],
            [0.336159912000085, 9.574197082000055],
            [0.322439819000067, 9.583137105000077],
            [0.304559774000012, 9.57156158500004],
            [0.280530233000093, 9.570166321000059],
            [0.230197388000107, 9.57574737600008],
            [0.227742757000044, 9.569339498000133],
            [0.223066040000077, 9.541175842000087],
            [0.223401937000062, 9.534793803000056],
            [0.225908244000038, 9.531925761000068],
            [0.233220459000023, 9.52559539800005],
            [0.243116496000113, 9.518696594000076],
            [0.253503459000058, 9.51425242200007],
            [0.279005778000084, 9.519006653000062],
            [0.293139282000112, 9.518283183000065],
            [0.30192427500009, 9.50745697100011],
            [0.298100219000048, 9.497095845000104],
            [0.285310302000084, 9.488362529000128],
            [0.269729858000062, 9.482342224000092],
            [0.228052816000115, 9.473970642000026],
            [0.227949463000101, 9.459733785000054],
            [0.234977458000117, 9.443765767000116],
            [0.226812581000075, 9.432345276000106],
            [0.231360108000018, 9.418961080000074],
            [0.249886109000073, 9.416945699000038],
            [0.268489624000011, 9.420640564000038],
            [0.314223267000045, 9.436479391000134],
            [0.321819702000113, 9.442835591000062],
            [0.325747111000084, 9.451336365000074],
            [0.328796021000102, 9.471567688000064],
            [0.33378279600015, 9.479474182000018],
            [0.348949829000077, 9.486037089000092],
            [0.371429077000073, 9.490016175000079],
            [0.4116591800001, 9.492238261000082],
            [0.430443562000107, 9.489189351000064],
            [0.483515259000029, 9.470017395000056],
            [0.489923136000073, 9.461129049000121],
            [0.491680135000138, 9.451284689000062],
            [0.489406372000133, 9.44102691600007],
            [0.482791788000043, 9.42983896900003],
            [0.482585083000089, 9.428857117000064],
            [0.482791788000043, 9.427875265000097],
            [0.483515259000029, 9.426841736000114],
            [0.513280884000039, 9.416790670000083],
            [0.531367635000038, 9.401106873000032],
            [0.537568807000127, 9.37764577200005],
            [0.528267049000107, 9.32695119300007],
            [0.526613403000056, 9.297650656000116],
            [0.522479288000113, 9.285067444000092],
            [0.512350708000071, 9.274706320000078],
            [0.501085245000098, 9.268195089000102],
            [0.492920370000093, 9.258609111000098],
            [0.491990194000039, 9.238894551000058],
            [0.504392537000115, 9.20310862200003],
            [0.504702595000083, 9.187166443000095],
            [0.492610310000117, 9.16675425300005],
            [0.469976034000069, 9.146729635000014],
            [0.463645671000052, 9.137091980000093],
            [0.463749023000076, 9.12145985900014],
            [0.458478027000126, 9.089239604000085],
            [0.441553996000039, 9.05818206800005],
            [0.431270386000051, 9.027589620000043],
            [0.444680419000093, 8.996557922000108],
            [0.44488712600014, 8.996557922000108],
            [0.44488712600014, 8.996454570000083],
            [0.493127075000132, 8.915219218000104],
            [0.505632771000137, 8.866333313000027],
            [0.483629270000051, 8.834973182000098],
            [0.483515259000029, 8.834810689000065],
            [0.47845096900005, 8.822330832000063],
            [0.477004029000057, 8.806750386000132],
            [0.473490031000011, 8.793547058000044],
            [0.462482951000112, 8.78830190100011],
            [0.44951216600009, 8.790368957000084],
            [0.439409424000047, 8.793443705000115],
            [0.430133504000139, 8.794735617000072],
            [0.419591512000068, 8.791247457000026],
            [0.424965861000118, 8.787320048000055],
            [0.418299601000115, 8.770602722000106],
            [0.40780928600006, 8.75905303900008],
            [0.397112264000071, 8.781532287000076],
            [0.385278361000132, 8.786079814000118],
            [0.372669311000038, 8.783754375000086],
            [0.365873861000068, 8.774271749000107],
            [0.368083532000128, 8.761481025000066],
            [0.374426310000104, 8.724765727000062],
            [0.403726847000144, 8.662082214000122],
            [0.443517700000058, 8.606865947000117],
            [0.483515259000029, 8.579787496000066],
            [0.500568481000073, 8.560176290000044],
            [0.524753052000051, 8.538032939000118],
            [0.550797974000119, 8.519326070000133],
            [0.616323690000115, 8.48875946000004],
            [0.633790324000074, 8.452017517000058],
            [0.64670943200008, 8.414164530000065],
            [0.685053345000085, 8.382564392000077],
            [0.687223755000076, 8.37220326700006],
            [0.686913697000108, 8.360731100000052],
            [0.689394165000067, 8.346054993000067],
            [0.688567342000056, 8.336029765000134],
            [0.689187459000038, 8.331301371000052],
            [0.693114868000094, 8.32789072600012],
            [0.705103801000035, 8.325978699000103],
            [0.708824504000063, 8.322568055000076],
            [0.712751912000016, 8.297970072000098],
            [0.70520715300006, 8.28275136300006],
            [0.689187459000038, 8.27285532600007],
            [0.645055786000114, 8.253424988000091],
            [0.628312622000067, 8.24246958400002],
            [0.595032999000125, 8.212729797000037],
            [0.586661417000073, 8.208750712000054],
            [0.579013305000075, 8.207820537000103],
            [0.573845662000082, 8.203944804000045],
            [0.572708781000074, 8.190999857000037],
            [0.576842895000084, 8.180483703000078],
            [0.584594360000096, 8.173068136000055],
            [0.591519002000069, 8.164489848000116],
            [0.593276001000049, 8.15066640200007],
            [0.58779829900007, 8.137721456000051],
            [0.579943481000043, 8.131701152000119],
            [0.574982544000079, 8.12462148100009],
            [0.580253540000115, 8.100075175000114],
            [0.583974243000029, 8.053049622000046],
            [0.59317264800012, 8.015739238000023],
            [0.59368941200006, 7.996567281000097],
            [0.592862590000038, 7.959308574000076],
            [0.602687912000135, 7.893132132000062],
            [0.60340458100012, 7.888305155000083],
            [0.602577759000098, 7.82841217100011],
            [0.611672811000062, 7.771258037000081],
            [0.609502400000082, 7.718961487000072],
            [0.612292928000045, 7.699427796000066],
            [0.583354126000074, 7.704285380000087],
            [0.570538371000083, 7.683924866000055],
            [0.567437785000038, 7.652919006000033],
            [0.56774784300012, 7.625737203000142],
            [0.562063436000074, 7.612301331000097],
            [0.548524211000085, 7.60537668900011],
            [0.532504517000064, 7.601035868000039],
            [0.519378703000086, 7.595196432000051],
            [0.509250122000111, 7.585377910000076],
            [0.50304895000005, 7.574680888000074],
            [0.49943160000015, 7.562381897000122],
            [0.495607544000109, 7.504297587000053],
            [0.500568481000073, 7.455049947000063],
            [0.516691528000138, 7.411021627000096],
            [0.548214152000099, 7.383271383000064],
            [0.566404256000055, 7.380790914000087],
            [0.586248006000062, 7.38435658800006],
            [0.623041626000145, 7.397895813000048],
            [0.629656209000132, 7.389162496000068],
            [0.645675903000097, 7.323585104000045],
            [0.644435668000142, 7.301932678000071],
            [0.631103149000126, 7.265242412000092],
            [0.621801392000094, 7.218836975000087],
            [0.597720174000074, 7.158892314000099],
            [0.594309530000146, 7.119721578000053],
            [0.598753702000039, 7.074711405000116],
            [0.598030233000145, 7.031199849000103],
            [0.57890995300005, 6.996783346000058],
            [0.565990844000055, 6.989651998000113],
            [0.523822876000082, 6.97869659500013],
            [0.509146769000097, 6.977611389000046],
            [0.494574015000126, 6.973115540000023],
            [0.506046183000052, 6.957819316000069],
            [0.534468221000083, 6.935908508000111],
            [0.54625044800008, 6.914772847000066],
            [0.543873332000118, 6.897926330000089],
            [0.522789347000099, 6.86283803300006],
            [0.51607141100007, 6.841805725000143],
            [0.519275350000044, 6.832245585000052],
            [0.528887167000079, 6.826535340000092],
            [0.541082805000087, 6.817181906000059],
            [0.570021607000058, 6.763515930000068],
            [0.576636190000045, 6.75473093700009],
            [0.593792765000103, 6.751113587000106],
            [0.611259399000062, 6.741527609000102],
            [0.62583215300009, 6.727755839000054],
            [0.634307088000099, 6.711606954000075],
            [0.635340617000082, 6.695380554000067],
            [0.626658976000044, 6.644892680000041],
            [0.632240031000038, 6.623989563000066],
            [0.645365844000111, 6.612026469000114],
            [0.659421834000028, 6.601717021000113],
            [0.668206828000109, 6.58582651800009],
            [0.677611938000069, 6.584896342000135],
            [0.705517212000046, 6.585774842000077],
            [0.714612264000039, 6.583914490000069],
            [0.727428019000115, 6.571434632000077],
            [0.726807902000132, 6.562107035000054],
            [0.719779907000117, 6.552727763000092],
            [0.713475383000116, 6.539989523000131],
            [0.713075710000084, 6.533935652000082],
            [0.711718383000033, 6.513376160000107],
            [0.717919555000123, 6.488829854000045],
            [0.729908488000092, 6.465084534000084],
            [0.745721476000085, 6.440899963000021],
            [0.766805461000104, 6.419350891000065],
            [0.81620813000012, 6.395062968000062],
            [0.841322876000049, 6.379224142000055],
            [0.87387902800009, 6.340130921000124],
            [0.88679813600001, 6.33038991300009],
            [0.907262003000085, 6.324912211000097],
            [0.983536418000085, 6.324602153000114],
            [1.009684692000093, 6.244452006000046],
            [1.025187622000118, 6.222334493000034],
            [1.033145793000074, 6.216546733000058],
            [1.0405871990001, 6.213471985000112],
            [1.048131958000056, 6.209389547000114],
            [1.055780070000111, 6.200630392000036],
            [1.068905883000099, 6.18034739200003],
            [1.079654581000113, 6.167919210000136],
            [1.093400513000063, 6.160917053000048],
            [1.176186157000132, 6.151511942000084],
            [1.187968384000044, 6.135647278000079],
            [1.185394727000073, 6.100490627000056],
            [1.184825066000087, 6.10032786700009],
            [1.178396030000044, 6.09796784100007],
            [1.133067254000082, 6.073635158000059],
            [1.098806186000047, 6.047023830000057],
            [1.048024936000047, 5.992661851000094],
            [1.036387566000087, 5.975165106000077],
            [1.011729363000086, 5.926255601000094],
            [1.007090691000087, 5.906683661000045],
            [1.00562584700009, 5.886053778000075],
            [0.995290561000047, 5.839341539000088],
            [0.986582879000082, 5.820746161000045],
            [0.95484459700009, 5.791083075000074],
            [0.914398634000065, 5.777085679000038],
            [0.723480665000068, 5.755438544000071],
            [0.36491946700005, 5.781480210000041],
            [0.32195071700005, 5.779201565000051],
            [0.298106316000087, 5.773667710000041],
            [0.285980665000068, 5.768866278000075],
            [0.28093509200005, 5.763006903000075],
            [0.275889519000089, 5.760158596000053],
            [0.25171959700009, 5.759100653000075],
            [0.243337436000047, 5.75617096600007],
            [0.22437584700009, 5.742621161000045],
            [0.157399936000047, 5.724554755000042],
            [0.142100457000083, 5.714260158000059],
            [0.11459394600007, 5.688666083000044],
            [0.075694207000083, 5.677557684000078],
            [0.061696811000047, 5.66282786700009],
            [0.050629102000073, 5.644761460000041],
            [0.03451582100007, 5.62836334800005],
            [-0.045033331999946, 5.601629950000074],
            [-0.049672003999945, 5.598863023000092],
            [-0.06273352799991, 5.585842190000051],
            [-0.06859290299991, 5.581203518000052],
            [-0.077381964999915, 5.578070380000042],
            [-0.093251105999911, 5.576646226000094],
            [-0.307850714999915, 5.507391669000071],
            [-0.353098110999952, 5.501695054000038],
            [-0.359283006999931, 5.49868398600006],
            [-0.371571417999917, 5.492743231000077],
            [-0.445057745999918, 5.431382554000038],
            [-0.452870245999918, 5.420111395000049],
            [-0.458119269999941, 5.404730536000045],
            [-0.471587693999936, 5.390814520000049],
            [-0.507435675999943, 5.368841864000046],
            [-0.577381964999915, 5.351629950000074],
            [-0.589344855999911, 5.351507880000042],
            [-0.596669074999909, 5.344305731000077],
            [-0.612863735999952, 5.332017320000091],
            [-0.629465298999946, 5.326727606000077],
            [-0.637766079999949, 5.340887762000079],
            [-0.689523891999954, 5.304754950000074],
            [-0.702300584999932, 5.299994208000044],
            [-0.760731574999909, 5.252183335000041],
            [-0.784494594999956, 5.224269924000055],
            [-0.799549933999913, 5.214829820000091],
            [-0.873890753999945, 5.204006252000056],
            [-0.896839972999942, 5.205023505000042],
            [-0.911488410999937, 5.218003648000092],
            [-0.91828365799995, 5.209418036000045],
            [-0.927723761999914, 5.206122137000079],
            [-0.952463344999956, 5.204413153000075],
            [-0.976551886999914, 5.198309637000079],
            [-0.988392706999946, 5.198797919000071],
            [-0.993478969999956, 5.20774974200009],
            [-0.997059699999909, 5.216782945000091],
            [-1.005034959999932, 5.214544989000046],
            [-1.017323370999918, 5.204413153000075],
            [-1.033802863999938, 5.202948309000078],
            [-1.049794074999909, 5.19867584800005],
            [-1.154123501999948, 5.153876044000071],
            [-1.16470292899993, 5.139227606000077],
            [-1.173654751999948, 5.130560614000046],
            [-1.194081183999913, 5.11859772300005],
            [-1.233631964999915, 5.100734768000052],
            [-1.25413977799991, 5.096502997000073],
            [-1.319243943999936, 5.094549872000073],
            [-1.329986131999931, 5.091538804000038],
            [-1.353138800999943, 5.077785549000055],
            [-1.364003058999913, 5.073431708000044],
            [-1.374134894999941, 5.072658596000053],
            [-1.39476477799991, 5.073919989000046],
            [-1.40493730399993, 5.073431708000044],
            [-1.423451300999943, 5.067450262000079],
            [-1.459706183999913, 5.049750067000048],
            [-1.529286261999914, 5.039862372000073],
            [-1.551869269999941, 5.031398830000057],
            [-1.568796352999925, 5.019273179000038],
            [-1.569488084999932, 5.018784898000092],
            [-1.583851691999939, 5.025376695000091],
            [-1.601470506999931, 5.026678778000075],
            [-1.618478969999956, 5.022447007000039],
            [-1.630848761999914, 5.012640692000048],
            [-1.632435675999943, 5.00454336100006],
            [-1.625477667999917, 4.989488023000092],
            [-1.627756313999953, 4.981594143000052],
            [-1.634022589999915, 4.974432684000078],
            [-1.638172980999911, 4.970689195000091],
            [-1.706654425999943, 4.936916408000059],
            [-1.718820766999954, 4.927679755000042],
            [-1.747670050999943, 4.895900783000059],
            [-1.749908006999931, 4.888576565000051],
            [-1.748117641999954, 4.881903387000079],
            [-1.748605923999946, 4.877183335000041],
            [-1.757435675999943, 4.875433661000045],
            [-1.766753709999932, 4.874701239000046],
            [-1.835438605999911, 4.855129299000055],
            [-1.912098761999914, 4.820868231000077],
            [-1.928089972999942, 4.806789455000057],
            [-1.952259894999941, 4.772447007000039],
            [-1.967274542999917, 4.75812409100007],
            [-1.981434699999909, 4.752427476000094],
            [-2.050363735999952, 4.743638414000088],
            [-2.063832160999937, 4.738185940000051],
            [-2.090565558999913, 4.737127997000073],
            [-2.096587693999936, 4.738470770000049],
            [-2.103871222999942, 4.745062567000048],
            [-2.106678839999915, 4.755357164000088],
            [-2.105620897999927, 4.766546942000048],
            [-2.107980923999946, 4.775580145000049],
            [-2.120961066999939, 4.779201565000051],
            [-2.129017706999946, 4.780340887000079],
            [-2.144154425999943, 4.784979559000078],
            [-2.155384894999941, 4.786078192000048],
            [-2.154367641999954, 4.790676174000055],
            [-2.163726365999935, 4.800523179000038],
            [-2.206288214999915, 4.834458726000094],
            [-2.227406378999945, 4.843410549000055],
            [-2.237049933999913, 4.849188544000071],
            [-2.241118943999936, 4.85805898600006],
            [-2.24282792899993, 4.865383205000057],
            [-2.247222459999932, 4.873032945000091],
            [-2.252756313999953, 4.879136460000041],
            [-2.356597459999932, 4.919623114000046],
            [-2.525786912999934, 4.954413153000075],
            [-2.690419074999909, 5.010199286000045],
            [-2.820871548999946, 5.020086981000077],
            [-2.964995897999927, 5.045314846000053],
            [-3.10374915299991, 5.087713934000078],
            [-3.119618292999917, 5.09133535400008],
            [-3.115305141999954, 5.107814846000053],
            [-3.108306443999936, 5.109605210000041],
            [-3.098988410999937, 5.113226630000042],
            [-3.087635870999918, 5.114976304000038],
            [-3.016102667999917, 5.114447333000044],
            [-2.994496222999942, 5.10814036700009],
            [-2.98851477799991, 5.102240302000041],
            [-2.976307745999918, 5.08462148600006],
            [-2.97093665299991, 5.080877997000073],
            [-2.957753058999913, 5.08266836100006],
            [-2.937245245999918, 5.091294664000088],
            [-2.926340298999946, 5.094549872000073],
            [-2.929025844999956, 5.122015692000048],
            [-2.901234503999945, 5.133612372000073],
            [-2.865305141999954, 5.13930898600006],
            [-2.843698696999923, 5.149115302000041],
            [-2.803855142999879, 5.147568054000104],
            [-2.780884968999914, 5.150875346000106],
            [-2.766622272999939, 5.161029765000066],
            [-2.757010456999922, 5.179865825000078],
            [-2.762488158999929, 5.186299540000036],
            [-2.775665648999905, 5.197539164000091],
            [-2.77881791199988, 5.201001486000038],
            [-2.779644734999891, 5.210122376000101],
            [-2.775407267999924, 5.231025492000086],
            [-2.774890502999909, 5.239577942000011],
            [-2.779334675999905, 5.251075948000036],
            [-2.793287312999894, 5.271100566000072],
            [-2.796129515999951, 5.284975688000131],
            [-2.789566608999877, 5.346858216000058],
            [-2.755873575999914, 5.34070872000008],
            [-2.742592732999924, 5.343137512000055],
            [-2.732670857999921, 5.355720724000065],
            [-2.730138712999945, 5.373161520000096],
            [-2.734427855999911, 5.391144918000094],
            [-2.761713012999905, 5.454913636000114],
            [-2.77943802899992, 5.52648549400007],
            [-2.781815144999882, 5.578885397000093],
            [-2.785587524999897, 5.595034282000086],
            [-2.793442341999935, 5.608134257000046],
            [-2.806258097999915, 5.618495382000063],
            [-2.877494059999975, 5.636814677000046],
            [-2.893746296999893, 5.630355123000086],
            [-2.926302449999923, 5.610718078000048],
            [-2.945861978999858, 5.60828928700009],
            [-2.969503946999879, 5.621440938000063],
            [-2.974904133999928, 5.647279155000078],
            [-2.964801390999895, 5.709781799000069],
            [-3.029758666999953, 5.704252421000064],
            [-3.019965982999878, 5.818353984000069],
            [-3.02252396699987, 5.854501648000081],
            [-3.034719604999907, 5.890700989000024],
            [-3.073244384999953, 5.960955099000017],
            [-3.087765462999897, 5.996689352000118],
            [-3.118073689999932, 6.16347503700004],
            [-3.139364379999932, 6.219285584000104],
            [-3.168794107999929, 6.24605397600007],
            [-3.171721890999947, 6.249584688000084],
            [-3.183599405999928, 6.263908183000126],
            [-3.262509317999985, 6.617142436000094],
            [-3.261114053999904, 6.633937277000072],
            [-3.253905191999934, 6.644427592000113],
            [-3.23548254399995, 6.654582011000073],
            [-3.230056518999959, 6.661119080000049],
            [-3.210419474999924, 6.715999451000059],
            [-3.21274491399987, 6.722665711000076],
            [-3.226232462999917, 6.748581441000113],
            [-3.238738158999922, 6.76462697400008],
            [-3.243078979999893, 6.774755554000123],
            [-3.241683715999926, 6.810903219000053],
            [-3.224940551999879, 6.8494021610001],
            [-3.109598754999922, 7.046392721000132],
            [-3.097274113999902, 7.05405337500008],
            [-3.096592622999907, 7.054476971000042],
            [-3.095465249999904, 7.055177714000109],
            [-3.045933390999949, 7.07124908500009],
            [-3.040869099999952, 7.078328755000101],
            [-3.032600870999914, 7.128351542000104],
            [-3.027536579999946, 7.138428447000138],
            [-2.981699584999888, 7.195530905000055],
            [-2.972811237999878, 7.214961243000033],
            [-2.97208776899987, 7.228603821000135],
            [-2.976531941999895, 7.236717021000047],
            [-2.983224039999897, 7.244985250000084],
            [-2.989528564999915, 7.258937887000087],
            [-2.990458739999951, 7.270668437000069],
            [-2.941521158999876, 7.577161357000051],
            [-2.928162800999928, 7.617675679000058],
            [-2.85594498699993, 7.771568095000063],
            [-2.852069254999947, 7.778131002000052],
            [-2.84201818799994, 7.790274963000059],
            [-2.838168294999889, 7.796837870000033],
            [-2.83790991199993, 7.802263896000099],
            [-2.840829630999906, 7.815234681000035],
            [-2.840002806999877, 7.820247294000097],
            [-2.831398680999939, 7.828360494],
            [-2.809151976999914, 7.841693014000029],
            [-2.801193806999947, 7.850219625000136],
            [-2.797886515999949, 7.861278381000133],
            [-2.793545694999864, 7.935950826000038],
            [-2.790625976999877, 7.943288880000125],
            [-2.784347289999857, 7.944012349000033],
            [-2.777681030999958, 7.939619853000124],
            [-2.772616739999876, 7.933935446000078],
            [-2.771221476999898, 7.930731507000104],
            [-2.754891723999947, 7.944374084000117],
            [-2.70926143399987, 7.996722310000052],
            [-2.690864624999961, 8.009744772000076],
            [-2.631178344999853, 8.029588521000079],
            [-2.610559447999947, 8.040001322000094],
            [-2.600689249999959, 8.052946269000117],
            [-2.599759073999905, 8.070387064000059],
            [-2.60621862799988, 8.094313253000067],
            [-2.619447793999967, 8.123097026000082],
            [-2.621876586999917, 8.135731913000114],
            [-2.617639118999875, 8.151493225000095],
            [-2.610662800999876, 8.164851583000114],
            [-2.604254923999918, 8.170794373000135],
            [-2.59598669499988, 8.17027760900001],
            [-2.583274291999942, 8.164334818000086],
            [-2.571750446999914, 8.163120422000063],
            [-2.558107869999901, 8.16769378700009],
            [-2.513201049999907, 8.194022929000056],
            [-2.506328083999932, 8.209267477000097],
            [-2.552345946999935, 8.489366659000098],
            [-2.598363809999938, 8.769465841000098],
            [-2.60311804199992, 8.785149638000064],
            [-2.612161417999886, 8.780963847000123],
            [-2.612381685999907, 8.781321221000027],
            [-2.617225707999864, 8.789180400000063],
            [-2.614641886999948, 8.801918640000025],
            [-2.60725215599993, 8.808559062000114],
            [-2.596658487999974, 8.81439849900002],
            [-2.595573282999879, 8.828066915000122],
            [-2.615933796999911, 8.897830099000075],
            [-2.617174031999951, 8.91501251300005],
            [-2.619447793999967, 8.923616639000088],
            [-2.625028848999875, 8.925993754000032],
            [-2.631746785999894, 8.926975607000102],
            [-2.637689574999911, 8.931471456000025],
            [-2.653295857999865, 8.978393657000069],
            [-2.654329386999933, 8.998831685000113],
            [-2.660788940999907, 9.014903056000094],
            [-2.686058715999962, 9.028261414000028],
            [-2.711328491999922, 9.033894145000147],
            [-2.736960001999904, 9.035134379000084],
            [-2.750809284999946, 9.037408142000103],
            [-2.758664102999887, 9.042860006000083],
            [-2.76507198099992, 9.049474589000084],
            [-2.774838826999883, 9.054978129000077],
            [-2.765433715999933, 9.06911163300012],
            [-2.761299601999895, 9.084795431000074],
            [-2.759387572999884, 9.134818217000074],
            [-2.755201781999858, 9.143138123000128],
            [-2.733911091999857, 9.164842225000129],
            [-2.716496134999915, 9.200266418000055],
            [-2.70481726099996, 9.218404847000087],
            [-2.67308793199993, 9.234889628000062],
            [-2.661150674999902, 9.253906556000032],
            [-2.659807087999923, 9.272897645000086],
            [-2.675516722999902, 9.281501771000123],
            [-2.692983357999935, 9.285325826000062],
            [-2.707142700999896, 9.295635275000066],
            [-2.714997517999933, 9.311060689000058],
            [-2.713343871999882, 9.329922587000084],
            [-2.70306026199998, 9.343255107000104],
            [-2.689417683999864, 9.34953379400011],
            [-2.677532104999926, 9.357001038000135],
            [-2.67241613799996, 9.374028422000066],
            [-2.67241613799996, 9.4010035190001],
            [-2.677377074999896, 9.41777252200005],
            [-2.678668986999867, 9.425549825000061],
            [-2.674586547999951, 9.457485861000052],
            [-2.675671752999932, 9.471722718000109],
            [-2.68921097799992, 9.488724263000037],
            [-2.725281127999921, 9.533863627000088],
            [-2.761092894999933, 9.566238912000088],
            [-2.766260538999859, 9.57652252200009],
            [-2.768017536999935, 9.592800599000014],
            [-2.766467244999916, 9.608897807000076],
            [-2.761506306999962, 9.625253398000027],
            [-2.752928019999928, 9.639903666000109],
            [-2.740163940999963, 9.650833231000078],
            [-2.743404468999927, 9.653325351000134],
            [-2.751015991999907, 9.65917897600005],
            [-2.754219929999891, 9.668351542000039],
            [-2.755460163999913, 9.67749827000003],
            [-2.760524454999882, 9.685585633000116],
            [-2.769257771999946, 9.689926453000098],
            [-2.774838826999883, 9.68930633600013],
            [-2.780316527999958, 9.690236512000084],
            [-2.788481404999885, 9.699254049000032],
            [-2.795302693999929, 9.720002136000076],
            [-2.79158199099993, 9.740931091000064],
            [-2.774838826999883, 9.774339905000133],
            [-2.740267293999892, 9.812606303000038],
            [-2.733911091999857, 9.822786560000097],
            [-2.736753295999932, 9.832579245000062],
            [-2.760524454999882, 9.870535584000066],
            [-2.764865274999863, 9.895753683000123],
            [-2.755563516999928, 9.941151428000055],
            [-2.754374959999922, 9.966782938000023],
            [-2.760886189999894, 9.98476633700011],
            [-2.783572143999947, 10.018511048000079],
            [-2.788481404999885, 10.038768209000082],
            [-2.788481404999885, 10.124447734000057],
            [-2.798920043999914, 10.169612935000131],
            [-2.798454955999887, 10.18953420000014],
            [-2.785380818999954, 10.210101420000044],
            [-2.765123657999936, 10.22583689400011],
            [-2.75768225199991, 10.234647726000105],
            [-2.754374959999922, 10.247954407000108],
            [-2.754943399999888, 10.260796],
            [-2.758354044999891, 10.26611867300005],
            [-2.764865274999863, 10.269115906000067],
            [-2.774838826999883, 10.275239563000127],
            [-2.7844506429999, 10.2788052370001],
            [-2.79318395999988, 10.278546854000126],
            [-2.799669351999938, 10.280923970000075],
            [-2.802098144999889, 10.292318624000075],
            [-2.805689656999959, 10.29901072200009],
            [-2.814216267999882, 10.301077779000053],
            [-2.824448201999871, 10.302214661000065],
            [-2.833181518999936, 10.30598704100008],
            [-2.841294718999933, 10.322290954000024],
            [-2.841294718999933, 10.343271586000114],
            [-2.836282103999878, 10.363657939000063],
            [-2.829460815999909, 10.378282369000118],
            [-2.822329467999879, 10.387584127000054],
            [-2.814629679999882, 10.393707784000114],
            [-2.804940347999946, 10.397118429000045],
            [-2.791995401999941, 10.398151957000039],
            [-2.781039998999859, 10.40241526300008],
            [-2.771893269999879, 10.41182037300004],
            [-2.767552448999908, 10.42119964600009],
            [-2.771428181999852, 10.42548879000006],
            [-2.795871134999885, 10.426108907000113],
            [-2.812149210999905, 10.428821920000061],
            [-2.824448201999871, 10.435023092000051],
            [-2.859562336999915, 10.465615540000059],
            [-2.867391316999914, 10.478250428000095],
            [-2.870440225999857, 10.497784119000102],
            [-2.873385782999947, 10.502486674000082],
            [-2.886899169999936, 10.515793356000088],
            [-2.891524210999876, 10.52165863100008],
            [-2.89421138499992, 10.531425476000038],
            [-2.895865030999857, 10.552767843000126],
            [-2.898293823999921, 10.562612204000104],
            [-2.92826615499996, 10.615218811000105],
            [-2.932503621999928, 10.634313253000087],
            [-2.929661417999853, 10.644209290000077],
            [-2.916251383999906, 10.668083801000066],
            [-2.91015356499986, 10.684491068000028],
            [-2.907337198999898, 10.688315125000074],
            [-2.905115111999891, 10.692733459000067],
            [-2.905140950999879, 10.699193013000112],
            [-2.908034829999878, 10.703637187000126],
            [-2.912634033999922, 10.705807597000032],
            [-2.916949015999904, 10.706608582000044],
            [-2.918912719999923, 10.706608582000044],
            [-2.919959289999923, 10.711088218000057],
            [-2.922323363999851, 10.7212071740001],
            [-2.919274454999936, 10.727201640000132],
            [-2.908577433999909, 10.737666118000078],
            [-2.903099730999941, 10.747148743000054],
            [-2.899482380999956, 10.769989726000063],
            [-2.882661702999883, 10.797068176000025],
            [-2.871628784999871, 10.843447774000111],
            [-2.864239054999871, 10.864273377000075],
            [-2.850803181999908, 10.879543763000115],
            [-2.834861002999901, 10.891610209000106],
            [-2.821399291999938, 10.906260478000078],
            [-2.81576656099989, 10.9291531370001],
            [-2.821761026999923, 10.948299256000013],
            [-2.832716430999909, 10.966024272000112],
            [-2.838710896999942, 10.985118714000109],
            [-2.835946207999882, 10.99222422300005],
            [-2.837341471999878, 10.998011984000115],
            [-2.751119344999921, 10.996461691000093],
            [-2.750705932999921, 10.985842184000106],
            [-2.7287975939999, 10.986057355000057],
            [-2.634950723999879, 10.986979065000114],
            [-2.439768839999942, 10.988942769000047],
            [-2.197871459999902, 10.991294047000082],
            [-1.972872273999883, 10.993516134000089],
            [-1.754074259999925, 10.995634868000067],
            [-1.598683226999924, 10.997133484000074],
            [-1.58700435399993, 11.003670553000049],
            [-1.579821329999987, 11.021214702000108],
            [-1.562406371999941, 11.026589050000084],
            [-1.436057494999915, 11.02271331800003],
            [-1.423584092999931, 11.017911405000092],
            [-1.413553084999876, 11.014049746000055],
            [-1.380350300999879, 11.001267599000101],
            [-1.355287231999881, 10.996720072000059],
            [-1.228059854999913, 10.995479838000037],
            [-1.107550414999878, 10.99434295600011],
            [-1.098713744999969, 11.009561666000053],
            [-1.070343383999955, 11.013902486000035],
            [-0.93247066299989, 11.003102112000093],
            [-0.924047403999907, 11.001422628000043],
            [-0.916450968999953, 10.99620330800012],
            [-0.909474649999936, 10.982689921000144],
            [-0.904358683999874, 10.979485983000075],
            [-0.893920043999913, 10.979899394000086],
            [-0.900586303999944, 10.966230978000084],
            [-0.883171345999898, 10.968633932000031],
            [-0.860795450999916, 10.99292185500012],
            [-0.839401407999901, 10.996461691000093],
            [-0.833665323999867, 11.003412171000079],
            [-0.827774210999934, 11.00584096300014],
            [-0.822141479999914, 11.003618876000132],
            [-0.816973836999921, 10.996461691000093],
            [-0.816973836999921, 10.99620330800012],
            [-0.703017494999926, 10.994158812000066],
            [-0.695999308999944, 10.994032898000043],
            [-0.69465572099989, 10.982741598000061],
            [-0.690211547999866, 10.981811422000106],
            [-0.683235229999894, 10.984343567000096],
            [-0.673933471999959, 10.98351674400007],
            [-0.667990682999942, 10.976514588000072],
            [-0.672279825999908, 10.968504741000089],
            [-0.679772907999933, 10.960572408000047],
            [-0.682770141999868, 10.953596090000048],
            [-0.634762735999914, 10.907965800000056],
            [-0.617244424999853, 10.918636983000056],
            [-0.607115844999896, 10.94121958400008],
            [-0.599829467999911, 10.965765890000057],
            [-0.590579385999916, 10.982431539000075],
            [-0.576213337999889, 10.987754212000127],
            [-0.555439411999942, 10.989950460000031],
            [-0.516475382999971, 10.988632711000065],
            [-0.512961384999926, 10.989743754000074],
            [-0.509705769999925, 10.991449077000127],
            [-0.506708536999923, 10.993671163000045],
            [-0.504228067999946, 10.99620330800012],
            [-0.504228067999946, 10.99635833700006],
            [-0.494822956999883, 11.007804667000073],
            [-0.46851965299993, 11.020129496000024],
            [-0.456685750999924, 11.029612122000103],
            [-0.451259724999943, 11.040205791000076],
            [-0.449037637999936, 11.06289174400004],
            [-0.444386759999873, 11.077438660000098],
            [-0.42521480299996, 11.101468201000031],
            [-0.405887816999922, 11.101468201000031],
            [-0.386922566999971, 11.08640452100012],
            [-0.368939167999883, 11.065217183000073],
            [-0.318813028999955, 11.101364848000088],
            [-0.30612646499992, 11.113534648000012],
            [-0.298297485999882, 11.128391622000038],
            [-0.300545409999899, 11.13740916000009],
            [-0.304472818999955, 11.146788432000037],
            [-0.301682291999896, 11.16293731700003],
            [-0.16610917099996, 11.134980367000125],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Guinea-Bissau',
        iso3: 'GNB',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-13.72827876799991, 12.673387757000029],
              [-13.736314453999881, 12.607603658000059],
              [-13.734634968999927, 12.585331116000091],
              [-13.725074828999936, 12.558149312000111],
              [-13.674690307999953, 12.496085917000059],
              [-13.663399007999885, 12.47577707900004],
              [-13.660711832999937, 12.458672180000079],
              [-13.664432535999964, 12.44151560500012],
              [-13.682028360999936, 12.400329489000043],
              [-13.6841470949999, 12.392009583000075],
              [-13.685154784999895, 12.379193828000083],
              [-13.682028360999936, 12.35030670200004],
              [-13.683010212999903, 12.338679505000087],
              [-13.691020059999886, 12.319300842000118],
              [-13.695024983999872, 12.292945862000053],
              [-13.711819823999917, 12.267521057000053],
              [-13.740836141999921, 12.256927389000069],
              [-13.808558104999918, 12.256100565000054],
              [-13.795690673999928, 12.278734843000095],
              [-13.812640543999919, 12.283592428000105],
              [-13.840003213999864, 12.277132873000056],
              [-13.858968464999919, 12.265970764000116],
              [-13.883153035999982, 12.246437073000024],
              [-13.94392451999991, 12.218635152000061],
              [-13.965731973999908, 12.194243877000133],
              [-13.968264119999901, 12.183960267000131],
              [-13.968367472999944, 12.162566223000042],
              [-13.972527424999953, 12.151559143000043],
              [-13.964853474999899, 12.14789011700013],
              [-13.93865352399996, 12.14427276700006],
              [-13.918396362999943, 12.137761536000085],
              [-13.89930192099996, 12.126237691000057],
              [-13.879768228999865, 12.107685852000117],
              [-13.869717162999848, 12.100709534000117],
              [-13.8424061689999, 12.091304423000068],
              [-13.837729450999944, 12.085413310000064],
              [-13.835197306999959, 12.077765198000094],
              [-13.829642089999936, 12.068101706000064],
              [-13.807757120999895, 12.044278870000085],
              [-13.795897378999882, 12.036269023000017],
              [-13.779645141999964, 12.029344381000044],
              [-13.744427652999889, 12.023918355000063],
              [-13.734919189999914, 12.0192674770001],
              [-13.723937947999929, 12.002782694000118],
              [-13.722594360999949, 11.983869121000083],
              [-13.731327677999928, 11.943406474000085],
              [-13.734634968999927, 11.901858622000091],
              [-13.719364582999987, 11.784036356000087],
              [-13.719571289999948, 11.766104635000104],
              [-13.724764770999855, 11.723109843000117],
              [-13.729932413999848, 11.709829000000113],
              [-13.745771240999943, 11.69820180300006],
              [-13.77000748699993, 11.688693339000082],
              [-13.795690673999928, 11.684042460000114],
              [-13.815766967999878, 11.686832987000074],
              [-13.82168391899998, 11.694222718000077],
              [-13.819513509999894, 11.701664124000104],
              [-13.820133625999858, 11.708072001000048],
              [-13.83455135099996, 11.712102763000132],
              [-13.84297460999997, 11.71727040600004],
              [-13.84628190099997, 11.737269185000073],
              [-13.855041055999948, 11.743418681000051],
              [-13.870053059999918, 11.743677063000106],
              [-13.873050292999949, 11.738354391000072],
              [-13.86852860499991, 11.727037252000088],
              [-13.870673176999901, 11.704144592000077],
              [-13.873515380999947, 11.69453277600006],
              [-13.886408650999954, 11.675567525000105],
              [-13.903642740999942, 11.665387268000046],
              [-13.923744872999919, 11.665025533000048],
              [-13.945423136999892, 11.675670878000048],
              [-13.95335546899986, 11.6696764120001],
              [-13.996453612999886, 11.64383819600009],
              [-14.015134643999943, 11.63712026000006],
              [-14.058827066999925, 11.644044902000047],
              [-14.074640055999907, 11.643734843000061],
              [-14.104664062999888, 11.638567200000054],
              [-14.11856502299986, 11.637998759000098],
              [-14.134920612999906, 11.641771139000127],
              [-14.144480753999886, 11.647403870000062],
              [-14.153084879999938, 11.654845276000074],
              [-14.161844034999916, 11.660943095000036],
              [-14.171972615999948, 11.662751770000028],
              [-14.195020304999929, 11.65970286000001],
              [-14.278736124999881, 11.665077210000064],
              [-14.284472208999915, 11.668177795000105],
              [-14.289691527999935, 11.66884958900009],
              [-14.300388549999951, 11.663165182000043],
              [-14.308217528999876, 11.654535217000088],
              [-14.31979304999993, 11.630505677000073],
              [-14.32648514899995, 11.620583801000066],
              [-14.339223388999898, 11.610610250000065],
              [-14.432267985999886, 11.560575461000056],
              [-14.520943562999975, 11.512890116000108],
              [-14.562258870999898, 11.505603740000126],
              [-14.645380411999895, 11.515060527000102],
              [-14.686773234999919, 11.510719706000117],
              [-14.711061157999922, 11.497568055000045],
              [-14.728992878999918, 11.478008525000035],
              [-14.828211628999952, 11.334787293000119],
              [-14.84324947099995, 11.297192688000095],
              [-14.863144896999955, 11.218644511000065],
              [-14.959056355999905, 11.035761617000077],
              [-14.992594359999913, 10.99635833700006],
              [-14.992594359999913, 10.99620330800012],
              [-15.020985480999911, 10.967474677000041],
              [-15.059803839999915, 10.94041575700004],
              [-15.085194464999915, 10.92763906500005],
              [-15.096750454999949, 10.929348049000055],
              [-15.09398352799991, 10.942531643000052],
              [-15.08702551999994, 10.949286200000074],
              [-15.078195766999954, 10.95376211100006],
              [-15.06944739499994, 10.96002838700008],
              [-15.054676886999914, 10.982570705000057],
              [-15.048329230999911, 10.987982489000046],
              [-15.048329230999911, 10.994818427000041],
              [-15.05577551999994, 10.994818427000041],
              [-15.059966600999928, 10.98541901200008],
              [-15.06509355399993, 10.977362372000073],
              [-15.072336391999954, 10.971136786000045],
              [-15.083078579999949, 10.967474677000041],
              [-15.09483801999994, 10.966986395000049],
              [-15.105824347999942, 10.969427802000041],
              [-15.114003058999913, 10.975165106000077],
              [-15.117176886999914, 10.98427969000005],
              [-15.099354620999918, 11.05768463700008],
              [-15.093332485999952, 11.069891669000071],
              [-15.082753058999913, 11.075425523000092],
              [-15.07648678299995, 11.088446356000077],
              [-15.071685350999928, 11.103257554000038],
              [-15.065744594999956, 11.114569403000075],
              [-15.059925910999937, 11.11741771000004],
              [-15.047434048999946, 11.11664459800005],
              [-15.04210364499994, 11.118312893000052],
              [-15.041411912999934, 11.12213776200008],
              [-15.04287675699993, 11.135443427000041],
              [-15.04210364499994, 11.138820705000057],
              [-15.000559048999946, 11.142238674000055],
              [-15.002430792999917, 11.150580145000049],
              [-15.007557745999918, 11.157375393000052],
              [-15.014149542999917, 11.162502346000053],
              [-15.020985480999911, 11.166083075000074],
              [-15.00767981699994, 11.180080471000053],
              [-14.999745245999918, 11.198960679000038],
              [-15.000884568999936, 11.21678294500009],
              [-15.014800584999932, 11.22752513200004],
              [-15.023833787999934, 11.20148346600007],
              [-15.038726365999935, 11.18260325700004],
              [-15.058705206999946, 11.170843817000048],
              [-15.083078579999949, 11.166083075000074],
              [-15.077504035999937, 11.150051174000055],
              [-15.081857876999948, 11.140204169000071],
              [-15.091786261999914, 11.13812897300005],
              [-15.102894660999937, 11.145656643000052],
              [-15.105091925999943, 11.140448309000078],
              [-15.107818162999934, 11.136460679000038],
              [-15.109852667999917, 11.131984768000052],
              [-15.110340949999909, 11.125148830000057],
              [-15.114328579999949, 11.12767161700009],
              [-15.124623175999943, 11.131984768000052],
              [-15.125070766999954, 11.11273834800005],
              [-15.130848761999914, 11.103664455000057],
              [-15.141102667999917, 11.097398179000038],
              [-15.154774542999917, 11.08698151200008],
              [-15.16624915299991, 11.072455145000049],
              [-15.180978969999956, 11.044256903000075],
              [-15.20689856699994, 11.009588934000078],
              [-15.21788489499994, 10.999172268000052],
              [-15.230132615999935, 10.994818427000041],
              [-15.243031378999945, 11.000433661000045],
              [-15.25845292899993, 11.013617255000042],
              [-15.269927537999934, 11.028469143000052],
              [-15.271107550999943, 11.039211330000057],
              [-15.260121222999942, 11.047064520000049],
              [-15.230213995999918, 11.061835028000075],
              [-15.219593878999945, 11.069891669000071],
              [-15.214507615999935, 11.081447658000059],
              [-15.206613735999952, 11.125148830000057],
              [-15.217355923999946, 11.209418036000045],
              [-15.206613735999952, 11.233791408000059],
              [-15.229115363999938, 11.23037344000005],
              [-15.234974738999938, 11.21556224200009],
              [-15.231678839999915, 11.19627513200004],
              [-15.22647050699993, 11.17914459800005],
              [-15.225087042999917, 11.16396719000005],
              [-15.226185675999943, 11.139797268000052],
              [-15.23350989499994, 11.122544664000088],
              [-15.259348110999952, 11.132635809000078],
              [-15.294748501999948, 11.131984768000052],
              [-15.305287238999938, 11.13507721600007],
              [-15.312896287999934, 11.139349677000041],
              [-15.318470831999946, 11.143377997000073],
              [-15.322621222999942, 11.145656643000052],
              [-15.34593665299991, 11.142320054000038],
              [-15.358225063999953, 11.144232489000046],
              [-15.363636847999942, 11.155503648000092],
              [-15.366363084999932, 11.166489976000037],
              [-15.373524542999917, 11.173773505000042],
              [-15.38345292899993, 11.177883205000057],
              [-15.394683397999927, 11.17914459800005],
              [-15.409535285999937, 11.189601955000057],
              [-15.413075324999909, 11.213812567000048],
              [-15.41201738199993, 11.261664130000042],
              [-15.409535285999937, 11.27244700700004],
              [-15.41006425699993, 11.27920156500005],
              [-15.415435350999928, 11.282171942000048],
              [-15.42174231699994, 11.28229401200008],
              [-15.424956834999932, 11.283392645000049],
              [-15.426136847999942, 11.286525783000059],
              [-15.426340298999946, 11.292710679000038],
              [-15.425160285999937, 11.303412177000041],
              [-15.420033331999946, 11.316555080000057],
              [-15.418853318999936, 11.32713450700004],
              [-15.41392981699994, 11.336411851000037],
              [-15.38857988199993, 11.369940497000073],
              [-15.377919074999909, 11.37836334800005],
              [-15.371449347999942, 11.37693919500009],
              [-15.351307745999918, 11.367621161000045],
              [-15.33975175699993, 11.365383205000057],
              [-15.329701300999943, 11.368475653000075],
              [-15.315581834999932, 11.382066148000092],
              [-15.305572068999936, 11.385199286000045],
              [-15.295399542999917, 11.390814520000049],
              [-15.28351803299995, 11.40420156500005],
              [-15.273182745999918, 11.419989325000074],
              [-15.268055792999917, 11.433010158000059],
              [-15.323068813999953, 11.389146226000037],
              [-15.343129035999937, 11.37836334800005],
              [-15.358469204999949, 11.38735586100006],
              [-15.361683722999942, 11.399115302000041],
              [-15.356760219999956, 11.42959219000005],
              [-15.350819464999915, 11.43935781500005],
              [-15.339100714999915, 11.451727606000077],
              [-15.331044074999909, 11.462632554000038],
              [-15.336293097999942, 11.46775950700004],
              [-15.35338294199994, 11.463324286000045],
              [-15.366444464999915, 11.450751044000071],
              [-15.37490800699993, 11.433742580000057],
              [-15.377919074999909, 11.41624583500004],
              [-15.384185350999928, 11.404730536000045],
              [-15.398589647999927, 11.39744700700004],
              [-15.414865688999953, 11.391831773000092],
              [-15.426340298999946, 11.385199286000045],
              [-15.435699022999927, 11.36945221600007],
              [-15.440744594999956, 11.356146552000041],
              [-15.44945227799991, 11.347072658000059],
              [-15.470041469999956, 11.34365469000005],
              [-15.483143683999913, 11.339544989000046],
              [-15.494292772999927, 11.33388906500005],
              [-15.502674933999913, 11.33665599200009],
              [-15.507069464999915, 11.357896226000037],
              [-15.504017706999946, 11.368557033000059],
              [-15.489003058999913, 11.404689846000053],
              [-15.484038865999935, 11.412543036000045],
              [-15.481027798999946, 11.41937897300005],
              [-15.45303300699993, 11.460353908000059],
              [-15.470529751999948, 11.461086330000057],
              [-15.476714647999927, 11.467962958000044],
              [-15.476307745999918, 11.47955963700008],
              [-15.473500128999945, 11.49445221600007],
              [-15.465646938999953, 11.489650783000059],
              [-15.456776495999918, 11.489081122000073],
              [-15.447743292999917, 11.493109442000048],
              [-15.438710089999915, 11.501898505000042],
              [-15.437977667999917, 11.495510158000059],
              [-15.432484503999945, 11.48078034100007],
              [-15.42804928299995, 11.493963934000078],
              [-15.420643683999913, 11.505275783000059],
              [-15.41234290299991, 11.50771719000005],
              [-15.405262824999909, 11.49445221600007],
              [-15.397816535999937, 11.49445221600007],
              [-15.39875240799995, 11.504339911000045],
              [-15.401356574999909, 11.513373114000046],
              [-15.405873175999943, 11.521673895000049],
              [-15.41201738199993, 11.529242255000042],
              [-15.407297329999949, 11.53001536700009],
              [-15.40656490799995, 11.530951239000046],
              [-15.406849738999938, 11.53266022300005],
              [-15.405262824999909, 11.536037502000056],
              [-15.396066860999952, 11.532131252000056],
              [-15.385161912999934, 11.53001536700009],
              [-15.371083136999914, 11.529242255000042],
              [-15.354359503999945, 11.525051174000055],
              [-15.348866339999915, 11.528265692000048],
              [-15.356760219999956, 11.54287344000005],
              [-15.35342363199993, 11.550523179000038],
              [-15.349964972999942, 11.563381252000056],
              [-15.343129035999937, 11.563381252000056],
              [-15.33507239499994, 11.552435614000046],
              [-15.321115688999953, 11.554266669000071],
              [-15.309559699999909, 11.553859768000052],
              [-15.308990037999934, 11.536037502000056],
              [-15.289865688999953, 11.542792059000078],
              [-15.290394660999937, 11.556341864000046],
              [-15.302113410999937, 11.57172272300005],
              [-15.316477016999954, 11.583807684000078],
              [-15.320668097999942, 11.581203518000052],
              [-15.324289516999954, 11.57998281500005],
              [-15.336293097999942, 11.576971747000073],
              [-15.336293097999942, 11.583807684000078],
              [-15.314523891999954, 11.59125397300005],
              [-15.304188605999911, 11.596909898000092],
              [-15.294748501999948, 11.60492584800005],
              [-15.28734290299991, 11.592474677000041],
              [-15.274769660999937, 11.57811107000009],
              [-15.25845292899993, 11.570257880000042],
              [-15.24010169199994, 11.576971747000073],
              [-15.25226803299995, 11.578802802000041],
              [-15.253163214999915, 11.585516669000071],
              [-15.251047329999949, 11.594956773000092],
              [-15.25377356699994, 11.60492584800005],
              [-15.261708136999914, 11.60883209800005],
              [-15.270130988999938, 11.608710028000075],
              [-15.27725175699993, 11.61163971600007],
              [-15.28111731699994, 11.624823309000078],
              [-15.269683397999927, 11.62107982000009],
              [-15.24791419199994, 11.616522528000075],
              [-15.24010169199994, 11.611761786000045],
              [-15.22647050699993, 11.61859772300005],
              [-15.228627081999946, 11.61204661700009],
              [-15.231312628999945, 11.597805080000057],
              [-15.233876105999911, 11.59125397300005],
              [-15.209136522999927, 11.573960679000038],
              [-15.201649542999917, 11.575425523000092],
              [-15.192290818999936, 11.59125397300005],
              [-15.197417772999927, 11.600043036000045],
              [-15.210194464999915, 11.616848049000055],
              [-15.21275794199994, 11.62173086100006],
              [-15.210031704999949, 11.628566799000055],
              [-15.203114386999914, 11.636379299000055],
              [-15.19444739499994, 11.64280833500004],
              [-15.186146613999938, 11.645900783000059],
              [-15.183990037999934, 11.643703518000052],
              [-15.176380988999938, 11.63898346600007],
              [-15.165842251999948, 11.634344794000071],
              [-15.154774542999917, 11.63226959800005],
              [-15.148426886999914, 11.62881094000005],
              [-15.144886847999942, 11.62018463700008],
              [-15.143544074999909, 11.609076239000046],
              [-15.143950975999928, 11.598089911000045],
              [-15.124623175999943, 11.60492584800005],
              [-15.126576300999943, 11.608303127000056],
              [-15.128895636999914, 11.615383205000057],
              [-15.130848761999914, 11.61859772300005],
              [-15.11587480399993, 11.617743231000077],
              [-15.105539516999954, 11.612250067000048],
              [-15.09752356699994, 11.603013414000088],
              [-15.089914516999954, 11.59125397300005],
              [-15.129383917999917, 11.583644924000055],
              [-15.143950975999928, 11.583807684000078],
              [-15.13931230399993, 11.57843659100007],
              [-15.13703365799995, 11.574652411000045],
              [-15.133290167999917, 11.572088934000078],
              [-15.124623175999943, 11.57021719000005],
              [-15.128895636999914, 11.554429429000038],
              [-15.12328040299991, 11.545477606000077],
              [-15.114735480999911, 11.54633209800005],
              [-15.105091925999943, 11.57290273600006],
              [-15.093332485999952, 11.574042059000078],
              [-15.081532355999911, 11.571682033000059],
              [-15.076283331999946, 11.573553778000075],
              [-15.044504360999952, 11.575425523000092],
              [-15.035267706999946, 11.576971747000073],
              [-15.02375240799995, 11.58266836100006],
              [-15.015777147999927, 11.589178778000075],
              [-15.010609503999945, 11.598334052000041],
              [-15.007313605999911, 11.611761786000045],
              [-15.01984615799995, 11.60773346600007],
              [-15.028879360999952, 11.602850653000075],
              [-15.039173956999946, 11.59906647300005],
              [-15.07249915299991, 11.595526434000078],
              [-15.07994544199994, 11.59796784100007],
              [-15.083078579999949, 11.608343817000048],
              [-15.081044074999909, 11.612860419000071],
              [-15.075917120999918, 11.616156317000048],
              [-15.069162563999953, 11.618109442000048],
              [-15.062001105999911, 11.61859772300005],
              [-15.065907355999911, 11.627630927000041],
              [-15.066151495999918, 11.633002020000049],
              [-15.062001105999911, 11.645900783000059],
              [-15.07335364499994, 11.648504950000074],
              [-15.082386847999942, 11.643255927000041],
              [-15.08820553299995, 11.632513739000046],
              [-15.089914516999954, 11.61859772300005],
              [-15.103627081999946, 11.633978583000044],
              [-15.112294074999909, 11.63865794500009],
              [-15.124623175999943, 11.638495184000078],
              [-15.124623175999943, 11.645900783000059],
              [-15.11750240799995, 11.649807033000059],
              [-15.102894660999937, 11.666408596000053],
              [-15.102894660999937, 11.673244533000059],
              [-15.110340949999909, 11.686835028000075],
              [-15.117176886999914, 11.686835028000075],
              [-15.130848761999914, 11.652736721000053],
              [-15.14281165299991, 11.649888414000088],
              [-15.157866990999935, 11.658351955000057],
              [-15.171864386999914, 11.659572658000059],
              [-15.161447719999956, 11.67487213700008],
              [-15.147287563999953, 11.68162669500009],
              [-15.135161912999934, 11.689520575000074],
              [-15.130848761999914, 11.707953192000048],
              [-15.139271613999938, 11.699286200000074],
              [-15.14867102799991, 11.694525458000044],
              [-15.157826300999943, 11.69476959800005],
              [-15.165638800999943, 11.701117255000042],
              [-15.171864386999914, 11.701117255000042],
              [-15.172759568999936, 11.690822658000059],
              [-15.175770636999914, 11.684475002000056],
              [-15.181996222999942, 11.68109772300005],
              [-15.192290818999936, 11.680080471000053],
              [-15.18932044199994, 11.66547272300005],
              [-15.196685350999928, 11.661525783000059],
              [-15.20689856699994, 11.666815497000073],
              [-15.21275794199994, 11.680080471000053],
              [-15.228016730999911, 11.658596096000053],
              [-15.236317511999914, 11.66429271000004],
              [-15.231353318999936, 11.681301174000055],
              [-15.206613735999952, 11.69367096600007],
              [-15.215443488999938, 11.700018622000073],
              [-15.219105597999942, 11.708156643000052],
              [-15.218088344999956, 11.71751536700009],
              [-15.21275794199994, 11.727850653000075],
              [-15.206613735999952, 11.727850653000075],
              [-15.20225989499994, 11.725083726000037],
              [-15.198394334999932, 11.723863023000092],
              [-15.186146613999938, 11.721625067000048],
              [-15.19054114499994, 11.73541901200008],
              [-15.19945227799991, 11.744533596000053],
              [-15.219593878999945, 11.755113023000092],
              [-15.22647050699993, 11.755113023000092],
              [-15.229237433999913, 11.738836981000077],
              [-15.236073370999918, 11.725816148000092],
              [-15.241444464999915, 11.712103583000044],
              [-15.24010169199994, 11.69367096600007],
              [-15.250477667999917, 11.689520575000074],
              [-15.259348110999952, 11.67682526200008],
              [-15.268055792999917, 11.673244533000059],
              [-15.274159308999913, 11.676581122000073],
              [-15.271473761999914, 11.68585846600007],
              [-15.261219855999911, 11.701117255000042],
              [-15.272938605999911, 11.706203518000052],
              [-15.275013800999943, 11.718491929000038],
              [-15.268055792999917, 11.74835846600007],
              [-15.277821417999917, 11.742580471000053],
              [-15.284087693999936, 11.734116929000038],
              [-15.287505662999934, 11.723456122000073],
              [-15.288563605999911, 11.711086330000057],
              [-15.292591925999943, 11.710272528000075],
              [-15.313465949999909, 11.710598049000055],
              [-15.322621222999942, 11.707953192000048],
              [-15.308990037999934, 11.701117255000042],
              [-15.308990037999934, 11.69367096600007],
              [-15.29751542899993, 11.68577708500004],
              [-15.285959438999953, 11.67877838700008],
              [-15.28111731699994, 11.66982656500005],
              [-15.28502356699994, 11.656439520000049],
              [-15.293934699999909, 11.653143622000073],
              [-15.30337480399993, 11.65729401200008],
              [-15.308990037999934, 11.666408596000053],
              [-15.313791469999956, 11.65851471600007],
              [-15.317616339999915, 11.650132554000038],
              [-15.32054602799991, 11.641424872000073],
              [-15.322621222999942, 11.63226959800005],
              [-15.330230272999927, 11.67088450700004],
              [-15.336415167999917, 11.684393622000073],
              [-15.341379360999952, 11.682806708000044],
              [-15.349964972999942, 11.680080471000053],
              [-15.343129035999937, 11.666408596000053],
              [-15.356760219999956, 11.666408596000053],
              [-15.352853969999956, 11.64008209800005],
              [-15.348052537999934, 11.62881094000005],
              [-15.336293097999942, 11.61859772300005],
              [-15.343129035999937, 11.60492584800005],
              [-15.358143683999913, 11.61546458500004],
              [-15.371571417999917, 11.629706122000073],
              [-15.391590949999909, 11.659572658000059],
              [-15.394683397999927, 11.641913153000075],
              [-15.387684699999909, 11.62531159100007],
              [-15.377552863999938, 11.608791408000059],
              [-15.371083136999914, 11.59125397300005],
              [-15.375803188999953, 11.593410549000055],
              [-15.391590949999909, 11.598089911000045],
              [-15.396066860999952, 11.58462148600006],
              [-15.40453040299991, 11.584458726000037],
              [-15.411610480999911, 11.594631252000056],
              [-15.41201738199993, 11.611761786000045],
              [-15.418853318999936, 11.611761786000045],
              [-15.423085089999915, 11.60260651200008],
              [-15.425892706999946, 11.59243398600006],
              [-15.427072719999956, 11.58148834800005],
              [-15.426340298999946, 11.57021719000005],
              [-15.435170050999943, 11.57453034100007],
              [-15.438710089999915, 11.576971747000073],
              [-15.438710089999915, 11.557114976000037],
              [-15.44912675699993, 11.563788153000075],
              [-15.45303300699993, 11.572699286000045],
              [-15.455799933999913, 11.583319403000075],
              [-15.463246222999942, 11.594671942000048],
              [-15.468861456999946, 11.60578034100007],
              [-15.464588995999918, 11.61359284100007],
              [-15.45303300699993, 11.62173086100006],
              [-15.448109503999945, 11.636867580000057],
              [-15.437855597999942, 11.65232982000009],
              [-15.428456183999913, 11.670477606000077],
              [-15.426340298999946, 11.69367096600007],
              [-15.45885169199994, 11.662990627000056],
              [-15.476144985999952, 11.654364325000074],
              [-15.493967251999948, 11.666408596000053],
              [-15.489165818999936, 11.675034898000092],
              [-15.489328579999949, 11.696112372000073],
              [-15.487782355999911, 11.707953192000048],
              [-15.500884568999936, 11.708563544000071],
              [-15.508941209999932, 11.70453522300005],
              [-15.514800584999932, 11.69867584800005],
              [-15.521311001999948, 11.69367096600007],
              [-15.521555141999954, 11.69041575700004],
              [-15.52916419199994, 11.681586005000042],
              [-15.538075324999909, 11.676214911000045],
              [-15.542347785999937, 11.683417059000078],
              [-15.545806443999936, 11.700140692000048],
              [-15.551258917999917, 11.716376044000071],
              [-15.551380988999938, 11.73314036700009],
              [-15.532866990999935, 11.760321356000077],
              [-15.524769660999937, 11.782456773000092],
              [-15.51789303299995, 11.792669989000046],
              [-15.48033606699994, 11.830267645000049],
              [-15.469309048999946, 11.837713934000078],
              [-15.46312415299991, 11.839992580000057],
              [-15.460438605999911, 11.843451239000046],
              [-15.459828253999945, 11.854722398000092],
              [-15.457386847999942, 11.864650783000059],
              [-15.451527472999942, 11.87335846600007],
              [-15.438710089999915, 11.885443427000041],
              [-15.432484503999945, 11.885443427000041],
              [-15.429758266999954, 11.878973700000074],
              [-15.426665818999936, 11.876166083000044],
              [-15.423085089999915, 11.874416408000059],
              [-15.418853318999936, 11.871242580000057],
              [-15.415028449999909, 11.880519924000055],
              [-15.41006425699993, 11.884182033000059],
              [-15.40420488199993, 11.883246161000045],
              [-15.397816535999937, 11.885443427000041],
              [-15.374745245999918, 11.88475169500009],
              [-15.33462480399993, 11.873928127000056],
              [-15.31273352799991, 11.871242580000057],
              [-15.189198370999918, 11.871242580000057],
              [-15.183990037999934, 11.874660549000055],
              [-15.167225714999915, 11.889553127000056],
              [-15.161854620999918, 11.892971096000053],
              [-15.135609503999945, 11.89915599200009],
              [-15.11900794199994, 11.913478908000059],
              [-15.105824347999942, 11.929266669000071],
              [-15.089914516999954, 11.940130927000041],
              [-15.066965298999946, 11.940130927000041],
              [-15.062855597999942, 11.924994208000044],
              [-15.069691535999937, 11.904689846000053],
              [-15.079701300999943, 11.889227606000077],
              [-15.087147589999915, 11.870347398000092],
              [-15.086415167999917, 11.845404364000046],
              [-15.079701300999943, 11.820868231000077],
              [-15.06944739499994, 11.803615627000056],
              [-15.050119594999956, 11.794989325000074],
              [-15.024769660999937, 11.790838934000078],
              [-15.002552863999938, 11.78351471600007],
              [-14.993031378999945, 11.765692450000074],
              [-14.982411261999914, 11.75413646000004],
              [-14.959136522999927, 11.748928127000056],
              [-14.935902472999942, 11.75299713700008],
              [-14.925404425999943, 11.76943594000005],
              [-14.95140540299991, 11.760646877000056],
              [-14.969471808999913, 11.77643463700008],
              [-14.983265753999945, 11.798976955000057],
              [-14.996815558999913, 11.810370184000078],
              [-15.026356574999909, 11.81391022300005],
              [-15.035267706999946, 11.816595770000049],
              [-15.046701626999948, 11.823472398000092],
              [-15.052479620999918, 11.830511786000045],
              [-15.057362433999913, 11.838324286000045],
              [-15.065744594999956, 11.84788646000004],
              [-15.07022050699993, 11.860744533000059],
              [-15.06118730399993, 11.872748114000046],
              [-15.048573370999918, 11.884344794000071],
              [-15.04210364499994, 11.896063544000071],
              [-15.02375240799995, 11.944891669000071],
              [-15.023060675999943, 11.95107656500005],
              [-15.01866614499994, 11.95376211100006],
              [-15.003895636999914, 11.954413153000075],
              [-14.993763800999943, 11.957220770000049],
              [-14.99400794199994, 11.963690497000073],
              [-15.000152147999927, 11.97060781500005],
              [-15.007313605999911, 11.97483958500004],
              [-15.007232225999928, 11.978338934000078],
              [-15.017567511999914, 11.98151276200008],
              [-15.028920050999943, 11.982163804000038],
              [-15.038685675999943, 11.97797272300005],
              [-15.046620245999918, 11.97646719000005],
              [-15.068755662999934, 11.98533763200004],
              [-15.079701300999943, 11.987941799000055],
              [-15.093861456999946, 11.983710028000075],
              [-15.124745245999918, 11.965399481000077],
              [-15.140777147999927, 11.96116771000004],
              [-15.149403449999909, 11.95453522300005],
              [-15.177845831999946, 11.923407294000071],
              [-15.192290818999936, 11.913397528000075],
              [-15.21507727799991, 11.90961334800005],
              [-15.233998175999943, 11.913234768000052],
              [-15.274240688999953, 11.926459052000041],
              [-15.313059048999946, 11.932806708000044],
              [-15.325428839999915, 11.938625393000052],
              [-15.33975175699993, 11.950995184000078],
              [-15.35850989499994, 11.96320221600007],
              [-15.380970831999946, 11.96820709800005],
              [-15.404408331999946, 11.967230536000045],
              [-15.426340298999946, 11.96116771000004],
              [-15.433705206999946, 11.95648834800005],
              [-15.450062628999945, 11.942938544000071],
              [-15.456450975999928, 11.940130927000041],
              [-15.478016730999911, 11.941229559000078],
              [-15.489125128999945, 11.940578518000052],
              [-15.497385219999956, 11.936997789000088],
              [-15.528716600999928, 11.905951239000046],
              [-15.534738735999952, 11.902411200000074],
              [-15.549183722999942, 11.896633205000057],
              [-15.555409308999913, 11.892971096000053],
              [-15.584950324999909, 11.851263739000046],
              [-15.593251105999911, 11.844549872000073],
              [-15.613270636999914, 11.839016018000052],
              [-15.657704230999911, 11.812689520000049],
              [-15.676787889999957, 11.804754950000074],
              [-15.67955481699994, 11.803615627000056],
              [-15.744252081999946, 11.791937567000048],
              [-15.754017706999946, 11.78620026200008],
              [-15.76357988199993, 11.77765534100007],
              [-15.811268683999913, 11.753159898000092],
              [-15.83039303299995, 11.74835846600007],
              [-15.809925910999937, 11.82953522300005],
              [-15.791493292999917, 11.863226630000042],
              [-15.767201300999943, 11.86469147300005],
              [-15.76158606699994, 11.861029364000046],
              [-15.753977016999954, 11.858587958000044],
              [-15.74478105399993, 11.857611395000049],
              [-15.734201626999948, 11.85814036700009],
              [-15.734201626999948, 11.864976304000038],
              [-15.75304114499994, 11.866115627000056],
              [-15.776356574999909, 11.885687567000048],
              [-15.79556230399993, 11.885443427000041],
              [-15.811594204999949, 11.87368398600006],
              [-15.815825975999928, 11.85651276200008],
              [-15.817779100999928, 11.837591864000046],
              [-15.850168423999946, 11.775336005000042],
              [-15.86046301999994, 11.76943594000005],
              [-15.880034959999932, 11.774359442000048],
              [-15.884103969999956, 11.78709544500009],
              [-15.877552863999938, 11.824042059000078],
              [-15.894276495999918, 11.816229559000078],
              [-15.898264126999948, 11.799953518000052],
              [-15.89875240799995, 11.780178127000056],
              [-15.905506964999915, 11.76194896000004],
              [-15.911610480999911, 11.758734442000048],
              [-15.933745897999927, 11.750881252000056],
              [-15.943023240999935, 11.74485911700009],
              [-15.953114386999914, 11.736273505000042],
              [-15.958973761999914, 11.734808661000045],
              [-15.962961391999954, 11.73932526200008],
              [-15.966949022999927, 11.74835846600007],
              [-15.969553188999953, 11.768255927000041],
              [-15.963775193999936, 11.788275458000044],
              [-15.94640051999994, 11.824042059000078],
              [-15.931996222999942, 11.879584052000041],
              [-15.925933397999927, 11.892971096000053],
              [-15.921864386999914, 11.896918036000045],
              [-15.915598110999952, 11.901190497000073],
              [-15.90843665299991, 11.90452708500004],
              [-15.901722785999937, 11.905951239000046],
              [-15.897816535999937, 11.909572658000059],
              [-15.891224738999938, 11.93390534100007],
              [-15.865345831999946, 11.972235419000071],
              [-15.857085740999935, 11.98110586100006],
              [-15.842925584999932, 11.989447333000044],
              [-15.821766730999911, 11.997870184000078],
              [-15.79946855399993, 12.00336334800005],
              [-15.781971808999913, 12.002834377000056],
              [-15.776600714999915, 11.996975002000056],
              [-15.772816535999937, 11.987534898000092],
              [-15.767567511999914, 11.97874583500004],
              [-15.757801886999914, 11.97483958500004],
              [-15.737945115999935, 11.97370026200008],
              [-15.729237433999913, 11.97142161700009],
              [-15.720529751999948, 11.96743398600006],
              [-15.717355923999946, 11.981594143000052],
              [-15.71007239499994, 11.996039130000042],
              [-15.706288214999915, 12.008286851000037],
              [-15.713693813999953, 12.015814520000049],
              [-15.719471808999913, 12.01203034100007],
              [-15.728911912999934, 12.002834377000056],
              [-15.742787238999938, 11.994940497000073],
              [-15.761463995999918, 11.995306708000044],
              [-15.767404751999948, 11.999335028000075],
              [-15.774240688999953, 12.010931708000044],
              [-15.781971808999913, 12.015814520000049],
              [-15.790760870999918, 12.018377997000073],
              [-15.794911261999914, 12.018052476000037],
              [-15.799224412999934, 12.01666901200008],
              [-15.837066209999932, 12.013861395000049],
              [-15.849964972999942, 12.01748281500005],
              [-15.857085740999935, 12.029486395000049],
              [-15.863880988999938, 12.029486395000049],
              [-15.87100175699993, 12.013006903000075],
              [-15.889556443999936, 12.00259023600006],
              [-15.912505662999934, 11.99705638200004],
              [-15.932769334999932, 11.995306708000044],
              [-15.930287238999938, 11.98818594000005],
              [-15.928781704999949, 11.985174872000073],
              [-15.925933397999927, 11.98110586100006],
              [-15.929351365999935, 11.980169989000046],
              [-15.931711391999954, 11.980292059000078],
              [-15.932972785999937, 11.97923411700009],
              [-15.932769334999932, 11.97483958500004],
              [-15.940785285999937, 11.97915273600006],
              [-15.94640051999994, 11.983628648000092],
              [-15.946156378999945, 11.978989976000037],
              [-15.942860480999911, 11.96548086100006],
              [-15.944732225999928, 11.953070380000042],
              [-15.953277147999927, 11.940130927000041],
              [-15.96788489499994, 11.926988023000092],
              [-15.981597459999932, 11.921291408000059],
              [-16.05565344999991, 11.92023346600007],
              [-16.065337693999936, 11.91697825700004],
              [-16.085275844999956, 11.907904364000046],
              [-16.09325110599991, 11.905951239000046],
              [-16.098540818999936, 11.90265534100007],
              [-16.10488847599993, 11.895331122000073],
              [-16.113270636999914, 11.888251044000071],
              [-16.12458248599995, 11.885443427000041],
              [-16.13426673099991, 11.888861395000049],
              [-16.143055792999917, 11.896144924000055],
              [-16.158762173999946, 11.913397528000075],
              [-16.18317623599995, 11.907904364000046],
              [-16.215199347999942, 11.913804429000038],
              [-16.243031378999945, 11.925441799000055],
              [-16.25487219999991, 11.936997789000088],
              [-16.275380011999914, 11.98110586100006],
              [-16.284982876999948, 11.98655833500004],
              [-16.311756964999915, 11.990627346000053],
              [-16.32323157499991, 11.995306708000044],
              [-16.331776495999918, 12.00462474200009],
              [-16.338002081999946, 12.016994533000059],
              [-16.341786261999914, 12.03123607000009],
              [-16.34528561099995, 12.061835028000075],
              [-16.355132615999935, 12.08734772300005],
              [-16.35728919199994, 12.101141669000071],
              [-16.330067511999914, 12.15916575700004],
              [-16.319569464999915, 12.171698309000078],
              [-16.30801347599993, 12.181219794000071],
              [-16.295725063999953, 12.188421942000048],
              [-16.282826300999943, 12.19399648600006],
              [-16.28229732999995, 12.182114976000037],
              [-16.277455206999946, 12.17328522300005],
              [-16.269886847999942, 12.17133209800005],
              [-16.26113847599993, 12.18032461100006],
              [-16.260161912999934, 12.188625393000052],
              [-16.26903235599991, 12.20343659100007],
              [-16.26862545499995, 12.214422919000071],
              [-16.25739498599995, 12.230169989000046],
              [-16.240345831999946, 12.24046458500004],
              [-16.22179114499994, 12.248195705000057],
              [-16.148426886999914, 12.290676174000055],
              [-16.131988084999932, 12.303859768000052],
              [-16.124256964999915, 12.31321849200009],
              [-16.113026495999918, 12.330226955000057],
              [-16.104115363999938, 12.337958075000074],
              [-16.095082160999937, 12.341945705000057],
              [-16.073109503999945, 12.347235419000071],
              [-16.06314042899993, 12.35101959800005],
              [-16.08975175699993, 12.351996161000045],
              [-16.107533331999946, 12.344671942000048],
              [-16.121245897999927, 12.331203518000052],
              [-16.135121222999942, 12.313788153000075],
              [-16.15538489499994, 12.300034898000092],
              [-16.206776495999918, 12.289496161000045],
              [-16.22760982999995, 12.282700914000088],
              [-16.262074347999942, 12.260931708000044],
              [-16.271962042999917, 12.252346096000053],
              [-16.305816209999932, 12.214422919000071],
              [-16.324574347999942, 12.222154039000088],
              [-16.323109503999945, 12.240708726000037],
              [-16.315663214999915, 12.263169664000088],
              [-16.316395636999914, 12.282700914000088],
              [-16.321522589999915, 12.26788971600007],
              [-16.334339972999942, 12.248114325000074],
              [-16.340402798999946, 12.21165599200009],
              [-16.350209113999938, 12.197211005000042],
              [-16.365345831999946, 12.192328192000048],
              [-16.38463294199994, 12.200832424000055],
              [-16.391468878999945, 12.19399648600006],
              [-16.394357876999948, 12.19830963700008],
              [-16.40575110599991, 12.20766836100006],
              [-16.40778561099995, 12.19440338700008],
              [-16.415679490999935, 12.18846263200004],
              [-16.428089972999942, 12.186997789000088],
              [-16.44326738199993, 12.187160549000055],
              [-16.445668097999942, 12.183417059000078],
              [-16.451568162999934, 12.176255601000037],
              [-16.457630988999938, 12.171942450000074],
              [-16.46035722599993, 12.176581122000073],
              [-16.462066209999932, 12.180568752000056],
              [-16.46629798099991, 12.18390534100007],
              [-16.471913214999915, 12.18626536700009],
              [-16.49120032499991, 12.18976471600007],
              [-16.50064042899993, 12.196600653000075],
              [-16.506337042999917, 12.20648834800005],
              [-16.508168097999942, 12.21784088700008],
              [-16.514393683999913, 12.223049221000053],
              [-16.538319464999915, 12.249823309000078],
              [-16.53892981699994, 12.256048895000049],
              [-16.54588782499991, 12.25975169500009],
              [-16.567005988999938, 12.27732982000009],
              [-16.57640540299991, 12.282700914000088],
              [-16.58112545499995, 12.281683661000045],
              [-16.596180792999917, 12.276068427000041],
              [-16.60374915299991, 12.276516018000052],
              [-16.60960852799991, 12.281317450000074],
              [-16.618885870999918, 12.296942450000074],
              [-16.624256964999915, 12.303859768000052],
              [-16.661488410999937, 12.33234284100007],
              [-16.672678188999953, 12.337958075000074],
              [-16.687570766999954, 12.337958075000074],
              [-16.698882615999935, 12.333238023000092],
              [-16.70921790299991, 12.327378648000092],
              [-16.721058722999942, 12.32367584800005],
              [-16.728436776914492, 12.332530837090502],
              [-16.705616413999877, 12.34803293900012],
              [-16.668874470999896, 12.356714579000084],
              [-16.533327188999863, 12.347826233000063],
              [-16.51487870299985, 12.348549704000064],
              [-16.462685505999957, 12.361313782000124],
              [-16.412300984999973, 12.361727193000135],
              [-16.382018595999853, 12.37381947800013],
              [-16.301920124999896, 12.416194153000049],
              [-16.23288041199993, 12.452884420000103],
              [-16.222390095999884, 12.455054830000094],
              [-16.211693074999857, 12.453142802000087],
              [-16.1900923259999, 12.444771220000106],
              [-16.181875772999945, 12.443375957000029],
              [-16.177173217999893, 12.445236308000034],
              [-16.172832396999894, 12.448543600000036],
              [-16.16606278499995, 12.45143747900002],
              [-16.090511840999852, 12.464304912000017],
              [-16.055010131999893, 12.461204326000072],
              [-15.992481648999899, 12.440688782000095],
              [-15.973258015999875, 12.437226461000066],
              [-15.893883015999904, 12.442755839000057],
              [-15.883964190999905, 12.442182464000055],
              [-15.711516885999856, 12.4322138470001],
              [-15.677048705999908, 12.439293518000028],
              [-15.42460933399991, 12.55504872700007],
              [-15.42173078199994, 12.557121923000096],
              [-15.368643757999905, 12.595356344000024],
              [-15.307820597999893, 12.622693176000055],
              [-15.249736286999905, 12.663620910000077],
              [-15.223794718999955, 12.675196432000106],
              [-15.195114298999954, 12.679433900000063],
              [-15.146228393999877, 12.679227193000102],
              [-14.872159687999954, 12.6781085450001],
              [-14.79172806799994, 12.677780253000023],
              [-14.437305256999934, 12.676281636000112],
              [-14.343107647999943, 12.675897212000095],
              [-14.082753255999904, 12.674834696000119],
              [-13.72827876799991, 12.673387757000029],
            ],
          ],
          [
            [
              [-15.94640051999994, 11.20026276200008],
              [-15.926991339999915, 11.18585846600007],
              [-15.911691860999952, 11.16632721600007],
              [-15.901600714999915, 11.142279364000046],
              [-15.89484615799995, 11.098863023000092],
              [-15.88780676999994, 11.089341539000088],
              [-15.88076738199993, 11.082180080000057],
              [-15.877552863999938, 11.073635158000059],
              [-15.88267981699994, 11.060614325000074],
              [-15.894642706999946, 11.054348049000055],
              [-15.908273891999954, 11.05337148600006],
              [-15.918446417999917, 11.056219794000071],
              [-15.926380988999938, 11.05141836100006],
              [-15.936879035999937, 11.051947333000044],
              [-15.963246222999942, 11.056219794000071],
              [-15.965565558999913, 11.053941148000092],
              [-15.97179114499994, 11.04979075700004],
              [-15.978179490999935, 11.048081773000092],
              [-15.981190558999913, 11.052883205000057],
              [-15.981434699999909, 11.060939846000053],
              [-15.981027798999946, 11.066229559000078],
              [-15.977894660999937, 11.069037177000041],
              [-15.970326300999943, 11.069891669000071],
              [-15.959950324999909, 11.07257721600007],
              [-15.93187415299991, 11.085516669000071],
              [-15.925933397999927, 11.090399481000077],
              [-15.930490688999953, 11.101629950000074],
              [-15.941761847999942, 11.10537344000005],
              [-15.951893683999913, 11.09992096600007],
              [-15.953277147999927, 11.083563544000071],
              [-15.960560675999943, 11.090277411000045],
              [-15.966949022999927, 11.097845770000049],
              [-15.958078579999949, 11.112697658000059],
              [-15.953480597999942, 11.12445709800005],
              [-15.952381964999915, 11.136419989000046],
              [-15.953277147999927, 11.15180084800005],
              [-15.958648240999935, 11.174302476000037],
              [-15.957142706999946, 11.187241929000038],
              [-15.94640051999994, 11.20026276200008],
            ],
          ],
          [
            [
              [-15.973784959999932, 11.15924713700008],
              [-15.971669074999909, 11.12986888200004],
              [-15.97447669199994, 11.11619700700004],
              [-15.98428300699993, 11.101263739000046],
              [-16.005482550999943, 11.075832424000055],
              [-16.01707923099991, 11.06867096600007],
              [-16.02212480399993, 11.080471096000053],
              [-16.025542772999927, 11.096258856000077],
              [-16.031361456999946, 11.108587958000044],
              [-16.032460089999915, 11.121486721000053],
              [-16.02212480399993, 11.138820705000057],
              [-16.044992641999954, 11.138739325000074],
              [-16.05614173099991, 11.148586330000057],
              [-16.056996222999942, 11.163560289000088],
              [-16.048898891999954, 11.17914459800005],
              [-16.034535285999937, 11.19049713700008],
              [-15.981190558999913, 11.207098700000074],
              [-15.977121548999946, 11.198797919000071],
              [-15.97492428299995, 11.185370184000078],
              [-15.973784959999932, 11.15924713700008],
            ],
          ],
          [
            [
              [-16.048898891999954, 11.118312893000052],
              [-16.06314042899993, 11.118312893000052],
              [-16.06314042899993, 11.110825914000088],
              [-16.053334113999938, 11.091538804000038],
              [-16.05728105399993, 11.07330963700008],
              [-16.062245245999918, 11.058417059000078],
              [-16.05565344999991, 11.04946523600006],
              [-16.076161261999914, 11.03611888200004],
              [-16.093861456999946, 11.035345770000049],
              [-16.11156165299991, 11.03656647300005],
              [-16.131988084999932, 11.028957424000055],
              [-16.135365363999938, 11.037665106000077],
              [-16.13658606699994, 11.045843817000048],
              [-16.135487433999913, 11.054185289000088],
              [-16.131988084999932, 11.063666083000044],
              [-16.138295050999943, 11.063666083000044],
              [-16.151275193999936, 11.042547919000071],
              [-16.145008917999917, 11.028957424000055],
              [-16.157582160999937, 11.032700914000088],
              [-16.160878058999913, 11.03546784100007],
              [-16.16551673099991, 11.042547919000071],
              [-16.18846594999991, 11.039618231000077],
              [-16.21312415299991, 11.055568752000056],
              [-16.234730597999942, 11.080633856000077],
              [-16.248036261999914, 11.104681708000044],
              [-16.234974738999938, 11.117865302000041],
              [-16.21861731699994, 11.129584052000041],
              [-16.201649542999917, 11.135646877000056],
              [-16.186675584999932, 11.131984768000052],
              [-16.200347459999932, 11.126288153000075],
              [-16.20653235599991, 11.125148830000057],
              [-16.205637173999946, 11.120754299000055],
              [-16.20457923099991, 11.117621161000045],
              [-16.202788865999935, 11.11469147300005],
              [-16.199696417999917, 11.110825914000088],
              [-16.190785285999937, 11.119574286000045],
              [-16.179432745999918, 11.124660549000055],
              [-16.169748501999948, 11.13226959800005],
              [-16.161854620999918, 11.166205145000049],
              [-16.15343176999994, 11.17218659100007],
              [-16.144276495999918, 11.17576732000009],
              [-16.138295050999943, 11.18659088700008],
              [-16.133168097999942, 11.181382554000038],
              [-16.117746548999946, 11.17291901200008],
              [-16.11510169199994, 11.197455145000049],
              [-16.099964972999942, 11.208197333000044],
              [-16.07998613199993, 11.206244208000044],
              [-16.06314042899993, 11.19281647300005],
              [-16.056630011999914, 11.185207424000055],
              [-16.05955969999991, 11.179510809000078],
              [-16.06582597599993, 11.17291901200008],
              [-16.06940670499995, 11.16274648600006],
              [-16.067697719999956, 11.14789459800005],
              [-16.063303188999953, 11.138617255000042],
              [-16.048898891999954, 11.118312893000052],
            ],
          ],
          [
            [
              [-15.857085740999935, 11.302679755000042],
              [-15.83116614499994, 11.30296458500004],
              [-15.825835740999935, 11.292669989000046],
              [-15.836537238999938, 11.255519924000055],
              [-15.837554490999935, 11.214016018000052],
              [-15.846506313999953, 11.200995184000078],
              [-15.87132727799991, 11.20026276200008],
              [-15.896066860999952, 11.21820709800005],
              [-15.896473761999914, 11.248724677000041],
              [-15.88076738199993, 11.280585028000075],
              [-15.857085740999935, 11.302679755000042],
            ],
          ],
          [
            [
              [-15.65843665299991, 11.302679755000042],
              [-15.661529100999928, 11.28461334800005],
              [-15.65648352799991, 11.251695054000038],
              [-15.65843665299991, 11.233791408000059],
              [-15.663441535999937, 11.229885158000059],
              [-15.669545050999943, 11.241156317000048],
              [-15.67882239499994, 11.25413646000004],
              [-15.693186001999948, 11.255519924000055],
              [-15.693186001999948, 11.24803294500009],
              [-15.685699022999927, 11.24803294500009],
              [-15.685699022999927, 11.24119700700004],
              [-15.69326738199993, 11.227728583000044],
              [-15.698638475999928, 11.220851955000057],
              [-15.706206834999932, 11.214504299000055],
              [-15.711781378999945, 11.222398179000038],
              [-15.714507615999935, 11.22492096600007],
              [-15.72679602799991, 11.220770575000074],
              [-15.72134355399993, 11.210150458000044],
              [-15.720326300999943, 11.19562409100007],
              [-15.72252356699994, 11.17999909100007],
              [-15.72679602799991, 11.166083075000074],
              [-15.72883053299995, 11.170355536000045],
              [-15.732045050999943, 11.175116278000075],
              [-15.734201626999948, 11.17914459800005],
              [-15.740223761999914, 11.178615627000056],
              [-15.742543097999942, 11.177923895000049],
              [-15.744211391999954, 11.177923895000049],
              [-15.747873501999948, 11.17914459800005],
              [-15.754017706999946, 11.17914459800005],
              [-15.763824022999927, 11.167914130000042],
              [-15.77330481699994, 11.173081773000092],
              [-15.780018683999913, 11.18659088700008],
              [-15.781971808999913, 11.20026276200008],
              [-15.775013800999943, 11.206732489000046],
              [-15.76353919199994, 11.214504299000055],
              [-15.759510870999918, 11.221869208000044],
              [-15.775135870999918, 11.22752513200004],
              [-15.775135870999918, 11.233791408000059],
              [-15.754017706999946, 11.255519924000055],
              [-15.753081834999932, 11.259833075000074],
              [-15.75499426999994, 11.27171458500004],
              [-15.754017706999946, 11.275946356000077],
              [-15.749256964999915, 11.277085679000038],
              [-15.742543097999942, 11.275864976000037],
              [-15.736683722999942, 11.275539455000057],
              [-15.734201626999948, 11.279038804000038],
              [-15.723540818999936, 11.299017645000049],
              [-15.69953365799995, 11.305812893000052],
              [-15.673939581999946, 11.30499909100007],
              [-15.65843665299991, 11.302679755000042],
            ],
          ],
          [
            [
              [-16.17296301999994, 11.220770575000074],
              [-16.23851477799991, 11.215277411000045],
              [-16.25145423099991, 11.217678127000056],
              [-16.278228318999936, 11.23037344000005],
              [-16.282826300999943, 11.230658270000049],
              [-16.281646287999934, 11.242621161000045],
              [-16.277902798999946, 11.252427476000037],
              [-16.271148240999935, 11.259182033000059],
              [-16.26113847599993, 11.261664130000042],
              [-16.262521938999953, 11.278631903000075],
              [-16.24868730399993, 11.294419664000088],
              [-16.229318813999953, 11.304103908000059],
              [-16.21397864499994, 11.302679755000042],
              [-16.20653235599991, 11.310126044000071],
              [-16.19749915299991, 11.298407294000071],
              [-16.18618730399993, 11.297267971000053],
              [-16.173166469999956, 11.29913971600007],
              [-16.158762173999946, 11.296454169000071],
              [-16.154408331999946, 11.289211330000057],
              [-16.151519334999932, 11.276190497000073],
              [-16.150380011999914, 11.263088283000059],
              [-16.151275193999936, 11.255519924000055],
              [-16.16307532499991, 11.250677802000041],
              [-16.17284094999991, 11.244574286000045],
              [-16.17731686099995, 11.235174872000073],
              [-16.17296301999994, 11.220770575000074],
            ],
          ],
          [
            [
              [-15.665272589999915, 11.49445221600007],
              [-15.66319739499994, 11.49217357000009],
              [-15.661366339999915, 11.489447333000044],
              [-15.658029751999948, 11.487697658000059],
              [-15.651600714999915, 11.488226630000042],
              [-15.652333136999914, 11.483547268000052],
              [-15.65343176999994, 11.480536200000074],
              [-15.65843665299991, 11.473944403000075],
              [-15.65265865799995, 11.466050523000092],
              [-15.657582160999937, 11.45799388200004],
              [-15.67955481699994, 11.44041575700004],
              [-15.684437628999945, 11.449774481000077],
              [-15.685699022999927, 11.453517971000053],
              [-15.693186001999948, 11.453517971000053],
              [-15.704660610999952, 11.442694403000075],
              [-15.720855272999927, 11.442694403000075],
              [-15.735096808999913, 11.44985586100006],
              [-15.740386522999927, 11.460353908000059],
              [-15.73546301999994, 11.469427802000041],
              [-15.727284308999913, 11.470404364000046],
              [-15.718902147999927, 11.468166408000059],
              [-15.713693813999953, 11.46775950700004],
              [-15.706206834999932, 11.47524648600006],
              [-15.700510219999956, 11.48338450700004],
              [-15.696278449999909, 11.492254950000074],
              [-15.693186001999948, 11.501898505000042],
              [-15.685699022999927, 11.49445221600007],
              [-15.680531378999945, 11.498724677000041],
              [-15.665272589999915, 11.508734442000048],
              [-15.660267706999946, 11.504706122000073],
              [-15.66006425699993, 11.50185781500005],
              [-15.665272589999915, 11.49445221600007],
            ],
          ],
          [
            [
              [-16.25487219999991, 11.44725169500009],
              [-16.275868292999917, 11.447007554000038],
              [-16.287831183999913, 11.448716539000088],
              [-16.302113410999937, 11.453517971000053],
              [-16.29002844999991, 11.46157461100006],
              [-16.271839972999942, 11.470892645000049],
              [-16.25536048099991, 11.48273346600007],
              [-16.248036261999914, 11.498195705000057],
              [-16.236683722999942, 11.508002020000049],
              [-16.211008266999954, 11.515366929000038],
              [-16.18309485599991, 11.518500067000048],
              [-16.16551673099991, 11.515570380000042],
              [-16.160633917999917, 11.505560614000046],
              [-16.164173956999946, 11.49607982000009],
              [-16.193837042999917, 11.465033270000049],
              [-16.199696417999917, 11.460353908000059],
              [-16.203114386999914, 11.455959377000056],
              [-16.205555792999917, 11.45026276200008],
              [-16.208607550999943, 11.444647528000075],
              [-16.21397864499994, 11.44041575700004],
              [-16.222482876999948, 11.44009023600006],
              [-16.25487219999991, 11.44725169500009],
            ],
          ],
          [
            [
              [-16.275542772999927, 11.495510158000059],
              [-16.281727667999917, 11.49315013200004],
              [-16.29198157499991, 11.493109442000048],
              [-16.302113410999937, 11.488226630000042],
              [-16.306711391999954, 11.48663971600007],
              [-16.30996660099993, 11.48265208500004],
              [-16.313832160999937, 11.480536200000074],
              [-16.31981360599991, 11.484523830000057],
              [-16.332834438999953, 11.499172268000052],
              [-16.336822068999936, 11.501898505000042],
              [-16.339100714999915, 11.501288153000075],
              [-16.391468878999945, 11.501898505000042],
              [-16.400502081999946, 11.493963934000078],
              [-16.40851803299995, 11.48924388200004],
              [-16.41942298099991, 11.488226630000042],
              [-16.41633053299995, 11.495062567000048],
              [-16.41197669199994, 11.501898505000042],
              [-16.418324347999942, 11.51439036700009],
              [-16.41698157499991, 11.517238674000055],
              [-16.41197669199994, 11.522406317000048],
              [-16.421945766999954, 11.52798086100006],
              [-16.426258917999917, 11.529242255000042],
              [-16.389149542999917, 11.547674872000073],
              [-16.34788977799991, 11.548529364000046],
              [-16.30996660099993, 11.55345286700009],
              [-16.282826300999943, 11.583807684000078],
              [-16.278146938999953, 11.582424221000053],
              [-16.27725175699993, 11.581854559000078],
              [-16.277333136999914, 11.580633856000077],
              [-16.275380011999914, 11.576971747000073],
              [-16.267933722999942, 11.57689036700009],
              [-16.260487433999913, 11.577948309000078],
              [-16.25377356699994, 11.580226955000057],
              [-16.248036261999914, 11.583807684000078],
              [-16.24437415299991, 11.580877997000073],
              [-16.242583787999934, 11.577826239000046],
              [-16.24128170499995, 11.57021719000005],
              [-16.244536912999934, 11.552150783000059],
              [-16.25218665299991, 11.53733958500004],
              [-16.26862545499995, 11.515570380000042],
              [-16.27257239499994, 11.50682200700004],
              [-16.273548956999946, 11.500921942000048],
              [-16.275542772999927, 11.495510158000059],
            ],
          ],
          [
            [
              [-16.02212480399993, 11.512152411000045],
              [-16.01911373599995, 11.52875397300005],
              [-16.011382615999935, 11.550279039000088],
              [-16.001332160999937, 11.569037177000041],
              [-15.991118943999936, 11.576971747000073],
              [-15.97492428299995, 11.58344147300005],
              [-15.95225989499994, 11.606756903000075],
              [-15.939605272999927, 11.60492584800005],
              [-15.938384568999936, 11.589056708000044],
              [-15.930897589999915, 11.578680731000077],
              [-15.922434048999946, 11.57802969000005],
              [-15.918446417999917, 11.59125397300005],
              [-15.906076626999948, 11.57843659100007],
              [-15.90929114499994, 11.551703192000048],
              [-15.898019985999952, 11.54287344000005],
              [-15.91038977799991, 11.522691148000092],
              [-15.913441535999937, 11.49835846600007],
              [-15.908802863999938, 11.473863023000092],
              [-15.898019985999952, 11.453517971000053],
              [-15.917795376999948, 11.446600653000075],
              [-15.943714972999942, 11.432114976000037],
              [-15.965687628999945, 11.426703192000048],
              [-15.973784959999932, 11.44725169500009],
              [-15.981190558999913, 11.44725169500009],
              [-15.982533331999946, 11.442572333000044],
              [-15.98546301999994, 11.437648830000057],
              [-15.98741614499994, 11.433010158000059],
              [-15.990589972999942, 11.436712958000044],
              [-15.997873501999948, 11.443508205000057],
              [-16.00108801999994, 11.44725169500009],
              [-16.00694739499994, 11.436346747000073],
              [-16.01585852799991, 11.428290106000077],
              [-16.025868292999917, 11.42291901200008],
              [-16.035227016999954, 11.419989325000074],
              [-16.04478919199994, 11.43305084800005],
              [-16.07921301999994, 11.456976630000042],
              [-16.083607550999943, 11.46775950700004],
              [-16.048898891999954, 11.488226630000042],
              [-16.026275193999936, 11.512274481000077],
              [-16.02212480399993, 11.512152411000045],
            ],
          ],
          [
            [
              [-15.473500128999945, 11.63226959800005],
              [-15.473947719999956, 11.61859772300005],
              [-15.484934048999946, 11.607082424000055],
              [-15.487782355999911, 11.594671942000048],
              [-15.482045050999943, 11.583563544000071],
              [-15.472645636999914, 11.573431708000044],
              [-15.471669074999909, 11.566148179000038],
              [-15.490834113999938, 11.563381252000056],
              [-15.503407355999911, 11.56517161700009],
              [-15.512074347999942, 11.571478583000044],
              [-15.521311001999948, 11.57021719000005],
              [-15.522816535999937, 11.56745026200008],
              [-15.542347785999937, 11.549709377000056],
              [-15.547352667999917, 11.548529364000046],
              [-15.569691535999937, 11.549709377000056],
              [-15.569691535999937, 11.54287344000005],
              [-15.548410610999952, 11.53514232000009],
              [-15.552235480999911, 11.51951732000009],
              [-15.56631425699993, 11.51048411700009],
              [-15.575835740999935, 11.522406317000048],
              [-15.587147589999915, 11.519354559000078],
              [-15.60069739499994, 11.520738023000092],
              [-15.612049933999913, 11.523871161000045],
              [-15.616932745999918, 11.525824286000045],
              [-15.62173417899993, 11.52244700700004],
              [-15.630279100999928, 11.528998114000046],
              [-15.632964647999927, 11.538234768000052],
              [-15.620594855999911, 11.54287344000005],
              [-15.607411261999914, 11.550116278000075],
              [-15.598255988999938, 11.56517161700009],
              [-15.585682745999918, 11.577541408000059],
              [-15.562245245999918, 11.576971747000073],
              [-15.560292120999918, 11.592189846000053],
              [-15.550282355999911, 11.603216864000046],
              [-15.537912563999953, 11.613023179000038],
              [-15.528716600999928, 11.624823309000078],
              [-15.511830206999946, 11.620428778000075],
              [-15.49673417899993, 11.62490469000005],
              [-15.483876105999911, 11.63108958500004],
              [-15.473500128999945, 11.63226959800005],
            ],
          ],
          [
            [
              [-16.16551673099991, 11.871242580000057],
              [-16.148060675999943, 11.87726471600007],
              [-16.128732876999948, 11.876613674000055],
              [-16.09325110599991, 11.871242580000057],
              [-16.07994544199994, 11.873236395000049],
              [-16.065052863999938, 11.878404039000088],
              [-16.035227016999954, 11.892971096000053],
              [-16.039051886999914, 11.896958726000037],
              [-16.03892981699994, 11.897650458000044],
              [-16.03697669199994, 11.899237372000073],
              [-16.02257239499994, 11.899644273000092],
              [-16.009429490999935, 11.90029531500005],
              [-15.994862433999913, 11.899115302000041],
              [-15.987538214999915, 11.890448309000078],
              [-15.985585089999915, 11.88743724200009],
              [-15.989084438999953, 11.861517645000049],
              [-15.996937628999945, 11.849269924000055],
              [-16.00690670499995, 11.838039455000057],
              [-16.01471920499995, 11.824042059000078],
              [-16.023508266999954, 11.785223700000074],
              [-16.029408331999946, 11.769191799000055],
              [-16.041411912999934, 11.755113023000092],
              [-16.051665818999936, 11.762193101000037],
              [-16.063384568999936, 11.760687567000048],
              [-16.074574347999942, 11.756415106000077],
              [-16.083607550999943, 11.755113023000092],
              [-16.096262173999946, 11.762925523000092],
              [-16.121164516999954, 11.79979075700004],
              [-16.132801886999914, 11.805487372000073],
              [-16.145008917999917, 11.805487372000073],
              [-16.154774542999917, 11.807766018000052],
              [-16.158762173999946, 11.82029857000009],
              [-16.15916907499991, 11.848089911000045],
              [-16.16112219999991, 11.861151434000078],
              [-16.16551673099991, 11.871242580000057],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Egypt',
        iso3: 'EGY',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [34.24835085700005, 31.211448958000076],
              [34.258611287000065, 31.184144186000125],
              [34.29798872900005, 31.078775940000085],
              [34.32951135300004, 30.99449167900009],
              [34.36785526600005, 30.90741689100004],
              [34.4188082280001, 30.79129994700007],
              [34.48040653500004, 30.651205139000027],
              [34.50221398900004, 30.571675110000015],
              [34.50438440000005, 30.530333965000082],
              [34.51037886600005, 30.513332418000047],
              [34.52629520700009, 30.49457387300005],
              [34.536217081000075, 30.482171530000088],
              [34.536010376000036, 30.468580628],
              [34.52650191200013, 30.438711650000087],
              [34.52474491400005, 30.421141662000096],
              [34.52691532400007, 30.409617818000086],
              [34.53383996600013, 30.400212708000126],
              [34.58841027900007, 30.358819886000063],
              [34.599469035000084, 30.344505513000072],
              [34.63264530400011, 30.262029928000075],
              [34.69165979000013, 30.11454539],
              [34.73041711400003, 30.018168844000016],
              [34.73320764200008, 30.012587789000108],
              [34.7349646400001, 30.006696676],
              [34.73558475800007, 30.000702210000085],
              [34.73506799300009, 29.994552714000108],
              [34.74137251800005, 29.94024078400004],
              [34.78519413300012, 29.83569936100004],
              [34.82436486800009, 29.7416999310001],
              [34.85009973200005, 29.638760478000037],
              [34.84823938000005, 29.569643250000055],
              [34.855267375000096, 29.545717062000065],
              [34.87810835800008, 29.5042984010001],
              [34.886729362000096, 29.490057684000064],
              [34.875336134000065, 29.484808661000045],
              [34.86687259200005, 29.47919342700004],
              [34.859711134000065, 29.47215403900009],
              [34.852549675000034, 29.46279531500005],
              [34.84701582100007, 29.451117255000042],
              [34.843760613000086, 29.44082265800006],
              [34.83814537900008, 29.432928778000075],
              [34.82536868600005, 29.428615627000056],
              [34.828868035000085, 29.42772044500009],
              [34.83171634200005, 29.42763906500005],
              [34.83326256600009, 29.426174221000053],
              [34.832774285000085, 29.421128648000035],
              [34.824229363000086, 29.41738515800006],
              [34.81763756600009, 29.412176825000074],
              [34.815196160000085, 29.406398830000057],
              [34.819102410000085, 29.40070221600007],
              [34.809580925000034, 29.39911530200004],
              [34.80518639400009, 29.396429755000042],
              [34.80591881600009, 29.39256419500009],
              [34.81226647200009, 29.387640692000048],
              [34.80062910200007, 29.377875067000048],
              [34.77759850400008, 29.346096096000053],
              [34.77271569100009, 29.341864325000074],
              [34.76197350400008, 29.336859442000048],
              [34.75700931100005, 29.33307526200008],
              [34.752940300000034, 29.327093817000048],
              [34.74976647200009, 29.321193752000056],
              [34.74496504000007, 29.31582265800006],
              [34.73658287900008, 29.31126536700009],
              [34.73658287900008, 29.305121161000045],
              [34.74529056100005, 29.29132721600007],
              [34.74195397200009, 29.277004299000055],
              [34.73414147200009, 29.26312897300005],
              [34.72901451900009, 29.250474351000037],
              [34.72901451900009, 29.198919989000046],
              [34.723643425000034, 29.186672268000052],
              [34.71208743600005, 29.177435614000046],
              [34.70036868600005, 29.170355536000045],
              [34.69499759200005, 29.164496161000045],
              [34.69385826900009, 29.150458075000074],
              [34.690114780000044, 29.134466864000046],
              [34.68384850400008, 29.11904531500005],
              [34.674571160000085, 29.10651276200008],
              [34.67701256600009, 29.094916083000044],
              [34.674571160000085, 29.034409898000035],
              [34.67660566500007, 29.02480703300006],
              [34.686534050000034, 29.01243724200009],
              [34.68873131600009, 29.000392971000053],
              [34.68572024800005, 28.988674221000053],
              [34.67823326900009, 28.98314036700009],
              [34.66911868600005, 28.980169989000046],
              [34.64673912900008, 28.96743398600006],
              [34.643239780000044, 28.962062893000052],
              [34.64031009200005, 28.94879791900007],
              [34.640961134000065, 28.942694403000075],
              [34.64600670700008, 28.922349351000037],
              [34.647146030000044, 28.86286041900007],
              [34.62045332100007, 28.845851955000057],
              [34.62045332100007, 28.839585679000038],
              [34.623383009000065, 28.830552476000037],
              [34.62631269600007, 28.816961981000077],
              [34.62631269600007, 28.802394924000055],
              [34.62045332100007, 28.79059479400007],
              [34.624034050000034, 28.787054755000042],
              [34.627289259000065, 28.782538153000075],
              [34.633474155000044, 28.770697333000044],
              [34.62435957100007, 28.765326239000046],
              [34.62281334700009, 28.759833075000074],
              [34.625010613000086, 28.753729559000078],
              [34.62671959700009, 28.746486721000053],
              [34.62452233200008, 28.735988674000055],
              [34.619883660000085, 28.72919342700004],
              [34.615244988000086, 28.72418854400007],
              [34.61304772200009, 28.719183661000045],
              [34.60767662900008, 28.70148346600007],
              [34.58423912900008, 28.672349351000037],
              [34.570323113000086, 28.626166083000044],
              [34.53012129000007, 28.572699286000045],
              [34.51734459700009, 28.544134833000044],
              [34.516368035000085, 28.541489976000037],
              [34.51644941500007, 28.53896719000005],
              [34.51531009200005, 28.53742096600007],
              [34.51059004000007, 28.537990627000056],
              [34.52361087300005, 28.50731028900009],
              [34.51156660200007, 28.48777903900009],
              [34.48878014400009, 28.472723700000074],
              [34.46900475400008, 28.45538971600007],
              [34.47193444100009, 28.453273830000057],
              [34.47282962300005, 28.452826239000046],
              [34.475271030000044, 28.44794342700004],
              [34.461680535000085, 28.44204336100006],
              [34.45427493600005, 28.428900458000044],
              [34.44483483200008, 28.384466864000046],
              [34.44117272200009, 28.373480536000045],
              [34.42937259200005, 28.356756903000075],
              [34.42741946700005, 28.35610586100006],
              [34.42432701900009, 28.34471263200004],
              [34.410166863000086, 28.320013739000046],
              [34.406911655000044, 28.30801015800006],
              [34.40788821700005, 28.291164455000057],
              [34.41065514400009, 28.278143622000073],
              [34.415049675000034, 28.26707591400009],
              [34.420583530000044, 28.25617096600007],
              [34.420583530000044, 28.249945380000042],
              [34.41293379000007, 28.23314036700009],
              [34.42115319100009, 28.21816640800006],
              [34.434336785000085, 28.204413153000075],
              [34.44312584700009, 28.188299872000073],
              [34.45248457100007, 28.18036530200004],
              [34.45533287900008, 28.17487213700008],
              [34.45525149800005, 28.16746653900009],
              [34.45264733200008, 28.163234768000052],
              [34.449961785000085, 28.16034577000005],
              [34.44857832100007, 28.157171942000048],
              [34.44776451900009, 28.144680080000057],
              [34.43863930100008, 28.109557429000063],
              [34.42675330900005, 28.081543500000066],
              [34.44402656800008, 28.05354050200009],
              [34.42741946700005, 27.98305898600006],
              [34.43490644600007, 27.97557200700004],
              [34.408864780000044, 27.97211334800005],
              [34.400726759000065, 27.96873607000009],
              [34.397471550000034, 27.96308014500005],
              [34.39437910200007, 27.95380280200004],
              [34.38998457100007, 27.945257880000042],
              [34.376963738000086, 27.93817780200004],
              [34.37086022200009, 27.923651434000078],
              [34.36255944100009, 27.920355536000045],
              [34.35499108200008, 27.91950104400007],
              [34.34115644600007, 27.91547272300005],
              [34.33130944100009, 27.914129950000074],
              [34.33334394600007, 27.910101630000042],
              [34.33350670700008, 27.909125067000048],
              [34.33448326900009, 27.908758856000077],
              [34.33871504000007, 27.906683661000045],
              [34.33122806100005, 27.891546942000048],
              [34.320974155000044, 27.861273505000042],
              [34.311289910000085, 27.852036851000037],
              [34.30445397200009, 27.852036851000037],
              [34.30128014400009, 27.85732656500005],
              [34.292979363000086, 27.859849351000037],
              [34.28638756600009, 27.864406643000052],
              [34.27947024800005, 27.858343817000048],
              [34.27271569100009, 27.83616771000004],
              [34.26351972700007, 27.824774481000077],
              [34.27173912900008, 27.812445380000042],
              [34.25912519600007, 27.801703192000048],
              [34.23951256600009, 27.794134833000044],
              [34.22608483200008, 27.79124583500004],
              [34.216807488000086, 27.791937567000048],
              [34.21412194100009, 27.791489976000037],
              [34.21810957100007, 27.775783596000053],
              [34.22120201900009, 27.76984284100007],
              [34.25733483200008, 27.76951732000009],
              [34.25733483200008, 27.763332424000055],
              [34.24984785200007, 27.763332424000055],
              [34.24984785200007, 27.75649648600006],
              [34.25505618600005, 27.752386786000045],
              [34.258474155000044, 27.747788804000038],
              [34.26351972700007, 27.736029364000046],
              [34.25375410200007, 27.74042389500005],
              [34.24984785200007, 27.74282461100006],
              [34.25123131600009, 27.739081122000073],
              [34.25123131600009, 27.737250067000048],
              [34.25245201900009, 27.736476955000057],
              [34.25733483200008, 27.736029364000046],
              [34.25733483200008, 27.728583075000074],
              [34.24984785200007, 27.728583075000074],
              [34.24496504000007, 27.73737213700008],
              [34.227549675000034, 27.758205471000053],
              [34.20850670700008, 27.775946356000077],
              [34.199961785000085, 27.782171942000048],
              [34.189789259000065, 27.786769924000055],
              [34.174815300000034, 27.79124583500004],
              [34.078461134000065, 27.80068594000005],
              [34.05445397200009, 27.814520575000074],
              [33.98755944100009, 27.886664130000042],
              [33.982432488000086, 27.889960028000075],
              [33.97380618600005, 27.889227606000077],
              [33.916758660000085, 27.93573639500005],
              [33.90398196700005, 27.941799221000053],
              [33.89087975400008, 27.942531643000052],
              [33.87940514400009, 27.93463776200008],
              [33.865570509000065, 27.961330471000053],
              [33.85889733200008, 27.955145575000074],
              [33.84986412900008, 27.96482982000009],
              [33.815114780000044, 27.991034247000073],
              [33.80689537900008, 27.994574286000045],
              [33.80420983200008, 27.996039130000042],
              [33.80046634200005, 28.000474351000037],
              [33.796885613000086, 28.009019273000035],
              [33.793711785000085, 28.01312897300005],
              [33.78679446700005, 28.017971096000053],
              [33.77914472700007, 28.020819403000075],
              [33.76335696700005, 28.023993231000077],
              [33.76392662900008, 28.04901764500005],
              [33.71599368600005, 28.07526276200008],
              [33.715505405000044, 28.092922268000052],
              [33.70142662900008, 28.10382721600007],
              [33.684336785000085, 28.124335028000075],
              [33.672536655000044, 28.14598216400009],
              [33.674571160000085, 28.160549221000053],
              [33.66976972700007, 28.163723049000055],
              [33.66570071700005, 28.165716864000046],
              [33.662445509000065, 28.168768622000073],
              [33.66032962300005, 28.17487213700008],
              [33.65406334700009, 28.17487213700008],
              [33.65406334700009, 28.16738515800006],
              [33.64665774800005, 28.16738515800006],
              [33.643565300000034, 28.172308661000045],
              [33.634776238000086, 28.181301174000055],
              [33.63298587300005, 28.184475002000056],
              [33.618174675000034, 28.233303127000056],
              [33.61280358200008, 28.240627346000053],
              [33.60564212300005, 28.236273505000042],
              [33.59791100400008, 28.249741929000038],
              [33.57439212300005, 28.28074778900009],
              [33.56470787900008, 28.29710521000004],
              [33.433929884000065, 28.366400458000044],
              [33.42750084700009, 28.376898505000042],
              [33.42318769600007, 28.378241278000075],
              [33.40015709700009, 28.414455471000053],
              [33.380869988000086, 28.430243231000077],
              [33.36898847700007, 28.442328192000048],
              [33.369151238000086, 28.44794342700004],
              [33.30518639400009, 28.48973216400009],
              [33.29476972700007, 28.49941640800006],
              [33.29029381600009, 28.50690338700008],
              [33.287119988000086, 28.51508209800005],
              [33.27881920700008, 28.52753327000005],
              [33.26783287900008, 28.538885809000078],
              [33.256195509000065, 28.544134833000044],
              [33.262461785000085, 28.551581122000073],
              [33.262461785000085, 28.544134833000044],
              [33.26978600400008, 28.544134833000044],
              [33.26295006600009, 28.577053127000056],
              [33.246104363000086, 28.57949453300006],
              [33.23764082100007, 28.566107489000046],
              [33.256195509000065, 28.551581122000073],
              [33.23943118600005, 28.556586005000042],
              [33.22868899800005, 28.56940338700008],
              [33.22315514400009, 28.587836005000042],
              [33.21900475400008, 28.62799713700008],
              [33.21257571700005, 28.645005601000037],
              [33.19483483200008, 28.675116278000075],
              [33.20476321700005, 28.695013739000046],
              [33.217784050000034, 28.741034247000073],
              [33.22828209700009, 28.76386139500005],
              [33.215830925000034, 28.777167059000078],
              [33.21013431100005, 28.78506094000005],
              [33.20476321700005, 28.805161851000037],
              [33.19752037900008, 28.81000397300005],
              [33.18873131600009, 28.812933661000045],
              [33.18100019600007, 28.818508205000057],
              [33.174571160000085, 28.83698151200008],
              [33.17139733200008, 28.881415106000077],
              [33.16732832100007, 28.894232489000046],
              [33.16732832100007, 28.90037669500009],
              [33.17603600400008, 28.90973541900007],
              [33.17758222700007, 28.918361721000053],
              [33.17359459700009, 28.94139232000009],
              [33.17156009200005, 28.94668203300006],
              [33.16765384200005, 28.961086330000057],
              [33.16586347700007, 28.97606028900009],
              [33.170583530000044, 28.982977606000077],
              [33.17790774800005, 28.989569403000075],
              [33.17074629000007, 29.003078518000052],
              [33.159190300000034, 29.014105536000045],
              [33.153086785000085, 29.013373114000046],
              [33.151052280000044, 29.02415599200009],
              [33.14503014400009, 29.031724351000037],
              [33.13648522200009, 29.03461334800005],
              [33.12647545700008, 29.031398830000057],
              [33.11605879000007, 29.043117580000057],
              [33.08904056100005, 29.055975653000075],
              [33.07862389400009, 29.064886786000045],
              [33.06617272200009, 29.09003327000005],
              [33.06430097700007, 29.09593333500004],
              [33.061208530000044, 29.101385809000078],
              [33.04664147200009, 29.11155833500004],
              [33.04322350400008, 29.116400458000044],
              [33.04021243600005, 29.118109442000048],
              [33.023448113000086, 29.14061107000009],
              [33.02035566500007, 29.14248281500005],
              [33.012054884000065, 29.145819403000075],
              [33.00912519600007, 29.147406317000048],
              [33.00749759200005, 29.150336005000042],
              [33.004893425000034, 29.15843333500004],
              [33.002940300000034, 29.16111888200004],
              [32.95785566500007, 29.202093817000048],
              [32.942067905000044, 29.20661041900007],
              [32.91976972700007, 29.21751536700009],
              [32.89861087300005, 29.231024481000077],
              [32.88559004000007, 29.243068752000056],
              [32.88013756600009, 29.25885651200008],
              [32.87549889400009, 29.27948639500005],
              [32.86833743600005, 29.297430731000077],
              [32.85523522200009, 29.305121161000045],
              [32.84595787900008, 29.308335679000038],
              [32.83936608200008, 29.316229559000078],
              [32.819102410000085, 29.359076239000046],
              [32.817393425000034, 29.359767971000053],
              [32.821055535000085, 29.397040106000077],
              [32.81723066500007, 29.41404857000009],
              [32.79029381600009, 29.425441799000055],
              [32.74154707100007, 29.455959377000056],
              [32.74919681100005, 29.455959377000056],
              [32.74537194100009, 29.46312083500004],
              [32.74105879000007, 29.466742255000042],
              [32.73568769600007, 29.46832916900007],
              [32.728526238000086, 29.469631252000056],
              [32.73096764400009, 29.471869208000044],
              [32.73365319100009, 29.473863023000035],
              [32.735362175000034, 29.47728099200009],
              [32.734711134000065, 29.48383209800005],
              [32.728526238000086, 29.48383209800005],
              [32.72380618600005, 29.47528717700004],
              [32.721446160000085, 29.46747467700004],
              [32.72291100400008, 29.460882880000042],
              [32.728526238000086, 29.455959377000056],
              [32.71501712300005, 29.455959377000056],
              [32.72250410200007, 29.492743231000077],
              [32.72413170700008, 29.539536851000037],
              [32.71241295700008, 29.580471096000053],
              [32.68083743600005, 29.59992096600007],
              [32.68083743600005, 29.60614655200004],
              [32.68685957100007, 29.61815013200004],
              [32.68604576900009, 29.63226959800005],
              [32.68246504000007, 29.647040106000077],
              [32.68083743600005, 29.661363023000035],
              [32.68327884200005, 29.67609284100007],
              [32.69190514400009, 29.696519273000035],
              [32.69385826900009, 29.70604075700004],
              [32.69312584700009, 29.72284577000005],
              [32.69068444100009, 29.733628648000035],
              [32.68677819100009, 29.741848049000055],
              [32.68083743600005, 29.750799872000073],
              [32.65642337300005, 29.777085679000038],
              [32.653005405000044, 29.788316148000035],
              [32.648448113000086, 29.794623114000046],
              [32.62549889400009, 29.815252997000073],
              [32.604502800000034, 29.824164130000042],
              [32.60954837300005, 29.83388906500005],
              [32.61996504000007, 29.84316640800006],
              [32.62549889400009, 29.84634023600006],
              [32.625336134000065, 29.874253648000035],
              [32.61247806100005, 29.893744208000044],
              [32.57154381600009, 29.928900458000044],
              [32.580414259000065, 29.934027411000045],
              [32.584320509000065, 29.938706773000035],
              [32.58350670700008, 29.943426825000074],
              [32.57781009200005, 29.94879791900007],
              [32.58350670700008, 29.95062897300005],
              [32.58545983200008, 29.952460028000075],
              [32.58350670700008, 29.954331773000035],
              [32.57781009200005, 29.956203518000052],
              [32.57374108200008, 29.962144273000035],
              [32.569021030000044, 29.967596747000073],
              [32.563487175000034, 29.972398179000038],
              [32.561615431000064, 29.976385809000078],
              [32.56275475400008, 29.978949286000045],
              [32.56609134200005, 29.981024481000077],
              [32.57007897200009, 29.98265208500004],
              [32.57781009200005, 29.983547268000052],
              [32.57781009200005, 29.98969147300005],
              [32.57545006600009, 29.997015692000048],
              [32.57545006600009, 30.002875067000048],
              [32.57781009200005, 30.011419989000046],
              [32.57154381600009, 30.011419989000046],
              [32.558604363000086, 29.987127997000073],
              [32.55746504000007, 29.97646719000005],
              [32.56006920700008, 29.968573309000078],
              [32.56560306100005, 29.963039455000057],
              [32.57048587300005, 29.95575592700004],
              [32.57154381600009, 29.942572333000044],
              [32.56413821700005, 29.942572333000044],
              [32.56177819100009, 29.955226955000057],
              [32.55396569100009, 29.962103583000044],
              [32.54273522200009, 29.962551174000055],
              [32.530039910000085, 29.956203518000052],
              [32.51343834700009, 29.96157461100006],
              [32.49390709700009, 29.95062897300005],
              [32.476898634000065, 29.932196356000077],
              [32.46794681100005, 29.915228583000044],
              [32.466807488000086, 29.896877346000053],
              [32.47291100400008, 29.881984768000052],
              [32.486989780000044, 29.871568101000037],
              [32.50953209700009, 29.866848049000055],
              [32.49154707100007, 29.854071356000077],
              [32.40796959700009, 29.751898505000042],
              [32.403005405000044, 29.743963934000078],
              [32.39283287900008, 29.73436107000009],
              [32.363942905000044, 29.68821849200009],
              [32.358083530000044, 29.671942450000074],
              [32.357432488000086, 29.630560614000046],
              [32.351573113000086, 29.613674221000053],
              [32.33765709700009, 29.59992096600007],
              [32.33765709700009, 29.59247467700004],
              [32.348317905000044, 29.58502838700008],
              [32.35962975400008, 29.57127513200004],
              [32.36866295700008, 29.557196356000077],
              [32.37680097700007, 29.536078192000048],
              [32.387705925000034, 29.52562083500004],
              [32.43864993600005, 29.49677155200004],
              [32.45134524800005, 29.48729075700004],
              [32.49732506600009, 29.44009023600006],
              [32.52857506600009, 29.423651434000078],
              [32.556976759000065, 29.39785390800006],
              [32.58122806100005, 29.36912669500009],
              [32.59148196700005, 29.34951406500005],
              [32.59538821700005, 29.32489655200004],
              [32.605479363000086, 29.291937567000048],
              [32.61866295700008, 29.26117584800005],
              [32.63233483200008, 29.243068752000056],
              [32.63233483200008, 29.236802476000037],
              [32.62867272200009, 29.21893952000005],
              [32.656179233000046, 29.12063222900008],
              [32.658946160000085, 29.11078522300005],
              [32.65967858200008, 29.089097398000035],
              [32.65414472700007, 29.080877997000073],
              [32.64421634200005, 29.07290273600006],
              [32.63892662900008, 29.061346747000073],
              [32.62818444100009, 29.057033596000053],
              [32.62468509200005, 29.048163153000075],
              [32.63233483200008, 29.037583726000037],
              [32.62720787900008, 29.007879950000074],
              [32.62549889400009, 28.972723700000074],
              [32.63209069100009, 28.96190013200004],
              [32.662771030000044, 28.934068101000037],
              [32.67335045700008, 28.921535549000055],
              [32.676524285000085, 28.910956122000073],
              [32.67725670700008, 28.890773830000057],
              [32.68083743600005, 28.880560614000046],
              [32.703461134000065, 28.858710028000075],
              [32.70753014400009, 28.856350002000056],
              [32.74919681100005, 28.804836330000057],
              [32.78451582100007, 28.799383856000077],
              [32.80689537900008, 28.778143622000073],
              [32.820648634000065, 28.747870184000078],
              [32.865244988000086, 28.599554755000042],
              [32.86890709700009, 28.578924872000073],
              [32.879567905000044, 28.575425523000035],
              [32.92725670700008, 28.551581122000073],
              [32.95142662900008, 28.530991929000038],
              [32.963552280000044, 28.517726955000057],
              [32.97291100400008, 28.499823309000078],
              [32.98259524800005, 28.496568101000037],
              [32.99382571700005, 28.494208075000074],
              [33.002940300000034, 28.489488023000035],
              [33.006195509000065, 28.483343817000048],
              [33.01303144600007, 28.463039455000057],
              [33.041758660000085, 28.414129950000074],
              [33.050791863000086, 28.40692780200004],
              [33.05103600400008, 28.40257396000004],
              [33.049571160000085, 28.40135325700004],
              [33.04672285200007, 28.40143463700008],
              [33.04322350400008, 28.400783596000053],
              [33.08757571700005, 28.36859772300005],
              [33.10670006600009, 28.34711334800005],
              [33.10531660200007, 28.32562897300005],
              [33.11296634200005, 28.320013739000046],
              [33.119802280000044, 28.30878327000005],
              [33.12468509200005, 28.29633209800005],
              [33.12647545700008, 28.287502346000053],
              [33.13054446700005, 28.28416575700004],
              [33.153086785000085, 28.25617096600007],
              [33.20053144600007, 28.211371161000045],
              [33.21216881600009, 28.189927476000037],
              [33.22217858200008, 28.18463776200008],
              [33.23365319100009, 28.18032461100006],
              [33.24195397200009, 28.17487213700008],
              [33.246755405000044, 28.16152578300006],
              [33.246104363000086, 28.150458075000074],
              [33.24935957100007, 28.14288971600007],
              [33.26612389400009, 28.14008209800005],
              [33.283213738000086, 28.13239166900007],
              [33.316416863000086, 28.09638092700004],
              [33.33814537900008, 28.08543528900009],
              [33.33676191500007, 28.07916901200008],
              [33.33814537900008, 28.07103099200009],
              [33.33814537900008, 28.065008856000077],
              [33.33611087300005, 28.056789455000057],
              [33.34359785200007, 28.050604559000078],
              [33.355479363000086, 28.048081773000035],
              [33.36605879000007, 28.05068594000005],
              [33.37468509200005, 28.03587474200009],
              [33.39665774800005, 28.02724844000005],
              [33.441742384000065, 28.016546942000048],
              [33.51254316500007, 27.959051825000074],
              [33.53541100400008, 27.916408596000053],
              [33.54737389400009, 27.906683661000045],
              [33.55437259200005, 27.89647044500009],
              [33.576182488000086, 27.850490627000056],
              [33.57837975400008, 27.838446356000077],
              [33.57837975400008, 27.83222077000005],
              [33.58326256600009, 27.82453034100007],
              [33.58708743600005, 27.805121161000045],
              [33.59205162900008, 27.797430731000077],
              [33.59205162900008, 27.79124583500004],
              [33.58521569100009, 27.79124583500004],
              [33.57154381600009, 27.79124583500004],
              [33.56006920700008, 27.813421942000048],
              [33.53646894600007, 27.82607656500005],
              [33.509776238000086, 27.83494700700004],
              [33.488942905000044, 27.84589264500005],
              [33.48218834700009, 27.84589264500005],
              [33.47608483200008, 27.83161041900007],
              [33.47348066500007, 27.823187567000048],
              [33.47543379000007, 27.81586334800005],
              [33.48218834700009, 27.80491771000004],
              [33.50123131600009, 27.787502346000053],
              [33.511729363000086, 27.775091864000046],
              [33.516286655000044, 27.759914455000057],
              [33.52271569100009, 27.751898505000042],
              [33.537119988000086, 27.75576406500005],
              [33.551442905000044, 27.76162344000005],
              [33.55787194100009, 27.759914455000057],
              [33.55640709700009, 27.74628327000005],
              [33.55250084700009, 27.73187897300005],
              [33.545909050000034, 27.718491929000038],
              [33.53679446700005, 27.70807526200008],
              [33.54078209700009, 27.70453522300005],
              [33.54615319100009, 27.698187567000048],
              [33.55046634200005, 27.695054429000038],
              [33.56853274800005, 27.683254299000055],
              [33.574961785000085, 27.681382554000038],
              [33.57789147200009, 27.677435614000046],
              [33.58757571700005, 27.659002997000073],
              [33.59205162900008, 27.653469143000052],
              [33.59205162900008, 27.646633205000057],
              [33.58155358200008, 27.65448639500005],
              [33.55787194100009, 27.681382554000038],
              [33.55046634200005, 27.681382554000038],
              [33.55046634200005, 27.673976955000057],
              [33.55396569100009, 27.66864655200004],
              [33.55787194100009, 27.65965403900009],
              [33.55046634200005, 27.65965403900009],
              [33.54420006600009, 27.67918528900009],
              [33.52654056100005, 27.677557684000078],
              [33.50717207100007, 27.663723049000055],
              [33.49634850400008, 27.646633205000057],
              [33.51970462300005, 27.63580963700008],
              [33.53630618600005, 27.61619700700004],
              [33.56470787900008, 27.571519273000035],
              [33.56080162900008, 27.56517161700009],
              [33.55827884200005, 27.557114976000037],
              [33.556976759000065, 27.54759349200009],
              [33.55787194100009, 27.536769924000055],
              [33.57447350400008, 27.525864976000037],
              [33.618174675000034, 27.50812409100007],
              [33.63298587300005, 27.495835679000038],
              [33.63591556100005, 27.486721096000053],
              [33.63721764400009, 27.464789130000042],
              [33.64039147200009, 27.454820054000038],
              [33.647146030000044, 27.446478583000044],
              [33.664073113000086, 27.43032461100006],
              [33.67115319100009, 27.420396226000037],
              [33.67750084700009, 27.400132554000038],
              [33.68482506600009, 27.35569896000004],
              [33.69166100400008, 27.341864325000074],
              [33.72478274800005, 27.313706773000035],
              [33.76335696700005, 27.290350653000075],
              [33.805674675000034, 27.27212148600006],
              [33.82536868600005, 27.259711005000042],
              [33.83838951900009, 27.242580471000053],
              [33.840505405000044, 27.232082424000055],
              [33.83838951900009, 27.194159247000073],
              [33.83611087300005, 27.19082265800006],
              [33.82699629000007, 27.184149481000077],
              [33.82471764400009, 27.180487372000073],
              [33.82536868600005, 27.174627997000073],
              [33.83033287900008, 27.16592031500005],
              [33.83155358200008, 27.159979559000078],
              [33.83253014400009, 27.137884833000044],
              [33.83676191500007, 27.120754299000055],
              [33.84717858200008, 27.10700104400007],
              [33.865977410000085, 27.09516022300005],
              [33.883148634000065, 27.08079661700009],
              [33.901377800000034, 27.058742580000057],
              [33.90870201900009, 27.042141018000052],
              [33.89372806100005, 27.04393138200004],
              [33.89389082100007, 27.027899481000077],
              [33.90088951900009, 27.014227606000077],
              [33.920909050000034, 26.98932526200008],
              [33.92945397200009, 26.97418854400007],
              [33.942067905000044, 26.944566148000035],
              [33.95167076900009, 26.930975653000075],
              [33.96436608200008, 26.92186107000009],
              [33.978851759000065, 26.914943752000056],
              [33.990977410000085, 26.907416083000044],
              [33.996104363000086, 26.896551825000074],
              [34.002696160000085, 26.864894924000055],
              [34.00359134200005, 26.848944403000075],
              [33.996104363000086, 26.83787669500009],
              [33.97966556100005, 26.837103583000044],
              [33.968760613000086, 26.84638092700004],
              [33.959646030000044, 26.84979889500005],
              [33.948252800000034, 26.831000067000048],
              [33.94581139400009, 26.81777578300006],
              [33.94581139400009, 26.799994208000044],
              [33.94776451900009, 26.782416083000044],
              [33.95167076900009, 26.769273179000038],
              [33.951914910000085, 26.743353583000044],
              [33.93213951900009, 26.68260325700004],
              [33.941416863000086, 26.653509833000044],
              [33.955414259000065, 26.643011786000045],
              [33.98780358200008, 26.634100653000075],
              [34.00359134200005, 26.62563711100006],
              [34.014008009000065, 26.61163971600007],
              [34.02393639400009, 26.58071523600006],
              [34.05640709700009, 26.542303778000075],
              [34.070648634000065, 26.514878648000035],
              [34.10482832100007, 26.426662502000056],
              [34.11963951900009, 26.40029531500005],
              [34.13998457100007, 26.372300523000035],
              [34.153330925000034, 26.34711334800005],
              [34.17750084700009, 26.314846096000053],
              [34.26197350400008, 26.139471747000073],
              [34.30103600400008, 26.08779531500005],
              [34.33871504000007, 26.001776434000078],
              [34.41749108200008, 25.903143622000073],
              [34.42497806100005, 25.89020416900007],
              [34.43474368600005, 25.861883856000077],
              [34.50180097700007, 25.771633205000057],
              [34.53825931100005, 25.735663153000075],
              [34.54656009200005, 25.725043036000045],
              [34.633474155000044, 25.56940338700008],
              [34.647146030000044, 25.522040106000077],
              [34.67139733200008, 25.479722398000035],
              [34.68189537900008, 25.42869700700004],
              [34.699961785000085, 25.40102773600006],
              [34.74333743600005, 25.351304429000038],
              [34.74935957100007, 25.338812567000048],
              [34.758799675000034, 25.30963776200008],
              [34.76498457100007, 25.296087958000044],
              [34.794932488000086, 25.254380601000037],
              [34.80689537900008, 25.21161530200004],
              [34.85320071700005, 25.138820705000057],
              [34.93913821700005, 25.00336334800005],
              [34.94304446700005, 24.971258856000077],
              [34.95372532300007, 24.944142343000067],
              [34.96989822300009, 24.926410745000055],
              [34.98975670700008, 24.90501536700009],
              [34.99301191500007, 24.88670482000009],
              [34.99390709700009, 24.849310614000046],
              [34.99659264400009, 24.830552476000037],
              [35.00220787900008, 24.815619208000044],
              [35.01026451900009, 24.804429429000038],
              [35.021820509000065, 24.79515208500004],
              [35.03760826900009, 24.78587474200009],
              [35.063487175000034, 24.764105536000045],
              [35.080739780000044, 24.73541901200008],
              [35.10401451900009, 24.65688711100006],
              [35.10954837300005, 24.643784898000035],
              [35.126963738000086, 24.617661851000037],
              [35.14601372100009, 24.58589824200004],
              [35.160269724000045, 24.574618369000063],
              [35.16065514400009, 24.55849844000005],
              [35.144444555000064, 24.527674880000063],
              [35.144556478000084, 24.50020647300005],
              [35.18572024800005, 24.485663153000075],
              [35.23545487500007, 24.40012586200004],
              [35.37061608200008, 24.30609772300005],
              [35.39185631600009, 24.28278229400007],
              [35.42864531300006, 24.18595302300008],
              [35.45573700700004, 24.158988126000054],
              [35.49382816200006, 24.10889989900005],
              [35.510508660000085, 24.11123281500005],
              [35.503081646000055, 24.125106824000056],
              [35.493766615000084, 24.13898874100005],
              [35.50389967000007, 24.14053756700008],
              [35.52418917000006, 24.121274980000067],
              [35.55205893100009, 24.11049993900008],
              [35.58837194100005, 24.075837120000074],
              [35.60272545300006, 24.048100985000076],
              [35.60526050100009, 24.01881704200008],
              [35.63563070300006, 24.00186455100004],
              [35.666849579000086, 24.00725254100007],
              [35.69131491300004, 24.001078156000062],
              [35.71747878700006, 23.993354869000086],
              [35.73857101300007, 23.98331737500007],
              [35.75374688900007, 23.968659484000057],
              [35.77482532700009, 23.92391199700006],
              [35.792535291000036, 23.902291028000036],
              [35.78577882500008, 23.89304596100004],
              [35.77059665200005, 23.912350222000043],
              [35.75035574300006, 23.932423406000055],
              [35.73601209200007, 23.933208663000073],
              [35.699718328000074, 23.917828438000072],
              [35.68452044800006, 23.91091620600008],
              [35.66427433900009, 23.918649273000085],
              [35.64574991400008, 23.925562007000053],
              [35.62720199800009, 23.928643612000087],
              [35.61371109800007, 23.92710193700009],
              [35.59853316500005, 23.92941347200008],
              [35.57998109400006, 23.93634852400004],
              [35.57323174800007, 23.94482518400008],
              [35.56177819100009, 23.957180080000057],
              [35.551442905000044, 23.96039459800005],
              [35.55054772200009, 23.96548086100006],
              [35.53527521600006, 23.971790037000062],
              [35.51392662900008, 23.977118231000077],
              [35.504921151000076, 23.971000635000053],
              [35.491221550000034, 23.94757721600007],
              [35.483871160000035, 23.917787169000064],
              [35.49065811200006, 23.86999553600009],
              [35.481425451000064, 23.82834822700005],
              [35.47476777800006, 23.797915038000042],
              [35.48322385800009, 23.772486864000086],
              [35.50172135400004, 23.76869470400004],
              [35.510148144000084, 23.75637860900008],
              [35.509321956000065, 23.74172918900007],
              [35.50611412900008, 23.73456452000005],
              [35.507663017000084, 23.71783219400004],
              [35.50851582700005, 23.706271653000044],
              [35.51022072200004, 23.683921913000063],
              [35.50554446700005, 23.64248281500005],
              [35.50367272200009, 23.55565013200004],
              [35.50147545700008, 23.539943752000056],
              [35.49170983200008, 23.512152411000045],
              [35.48943118600005, 23.497015692000048],
              [35.49333743600005, 23.482367255000042],
              [35.502614780000044, 23.467230536000045],
              [35.524180535000085, 23.43895091400009],
              [35.541351759000065, 23.40957265800006],
              [35.547536655000044, 23.39398834800005],
              [35.551442905000044, 23.377508856000077],
              [35.55030358200008, 23.330226955000057],
              [35.558170145000076, 23.282088772000066],
              [35.567393425000034, 23.245428778000075],
              [35.574680423000075, 23.212565219000055],
              [35.62108710600006, 23.139292914000066],
              [35.42920701600008, 22.978330157000073],
              [35.212087686000075, 22.786263058000088],
              [35.34575576106042, 22.901639312788788],
              [35.486665384664775, 23.02326614573163],
              [35.62108710600006, 23.139292914000066],
              [35.63517065500008, 23.110925449000035],
              [35.65464215500009, 23.073749597000074],
              [35.66781660200007, 22.98261139500005],
              [35.67505944100009, 22.966620184000078],
              [35.69530523100008, 22.93212649700007],
              [35.737071160000085, 22.883978583000044],
              [35.763682488000086, 22.870428778000075],
              [35.75163821700005, 22.885972398000035],
              [35.723399285000085, 22.93187083500004],
              [35.742930535000085, 22.931301174000055],
              [35.75570722700007, 22.922308661000045],
              [35.764414910000085, 22.90766022300005],
              [35.77116946700005, 22.890285549000055],
              [35.781911655000044, 22.841131903000075],
              [35.78492272200009, 22.833197333000044],
              [35.80128014400009, 22.82257721600007],
              [35.809580925000034, 22.811346747000073],
              [35.81666100400008, 22.798895575000074],
              [35.82960045700008, 22.784816799000055],
              [35.84754720600006, 22.762989315000084],
              [35.88596381200006, 22.73569486400004],
              [35.92217162600008, 22.722115922000057],
              [35.940196160000085, 22.716620184000078],
              [35.94312584700009, 22.71279531500005],
              [35.955821160000085, 22.70449453300006],
              [35.969493035000085, 22.69798411700009],
              [35.984385613000086, 22.693793036000045],
              [36.040049675000034, 22.69017161700009],
              [36.12061608200008, 22.67568594000005],
              [36.19776451900009, 22.651678778000075],
              [36.22608483200008, 22.63544342700004],
              [36.27466881600009, 22.592352606000077],
              [36.29053795700008, 22.568182684000078],
              [36.296368148000056, 22.521999294000068],
              [36.31341564000007, 22.491612729000053],
              [36.343176963000076, 22.46712941000004],
              [36.37452233200008, 22.445257880000042],
              [36.38989783400007, 22.438751525000043],
              [36.404754695000065, 22.432883726000057],
              [36.40155556000008, 22.448570577000055],
              [36.406859273000066, 22.448576942000045],
              [36.42809962300004, 22.426045101000057],
              [36.42282334400005, 22.397605441000053],
              [36.43982291600008, 22.35644297600004],
              [36.50769827600004, 22.328047585000036],
              [36.54057227200008, 22.310404805000076],
              [36.56283906200008, 22.296676577000085],
              [36.62330306400008, 22.24956790600004],
              [36.71371504000007, 22.169134833000044],
              [36.732758009000065, 22.15961334800005],
              [36.74756920700008, 22.160956122000073],
              [36.75131269600007, 22.166937567000048],
              [36.75326582100007, 22.173163153000075],
              [36.756846550000034, 22.176906643000052],
              [36.76490319100009, 22.174953518000052],
              [36.782237175000034, 22.164455471000053],
              [36.79037519600007, 22.15761953300006],
              [36.795664910000085, 22.150783596000053],
              [36.80941816500007, 22.120754299000055],
              [36.81820722700007, 22.10883209800005],
              [36.83326256600009, 22.095851955000057],
              [36.871939875000066, 22.074111979000065],
              [36.89538277300005, 22.066132567000068],
              [36.899180535000085, 22.029852606000077],
              [36.898448113000086, 22.01748281500005],
              [36.89185631600009, 22.006740627000056],
              [36.883799675000034, 21.996649481000077],
              [36.88363691500007, 21.99571360900005],
              [36.649886515000105, 21.995712789000052],
              [36.41723921700009, 21.995661113000054],
              [36.18459191900007, 21.995609436000038],
              [35.95184126800012, 21.995609436000038],
              [35.719193969000116, 21.995609436000038],
              [35.486443318000056, 21.99555776000004],
              [35.25379602000004, 21.99555776000004],
              [35.021148722000135, 21.99555776000004],
              [34.78850142400012, 21.99555776000004],
              [34.55575077300011, 21.99550608300011],
              [34.323103475000096, 21.995454407000082],
              [34.09045617700008, 21.995454407000082],
              [34.08417936900008, 21.995454407000068],
              [34.076127286598, 21.995454407000082],
              [33.85770552600013, 21.995454407000082],
              [33.625058228000114, 21.995454407000082],
              [33.39235925300011, 21.995454407000082],
              [33.181135614000084, 21.995409469000037],
              [33.15976042200009, 21.995402731000084],
              [33.15872764107581, 21.995402731000084],
              [33.05739261800005, 21.995402731000084],
              [32.955073283000104, 21.995402731000084],
              [32.85265059400007, 21.995402731000084],
              [32.75033125800013, 21.995402731000084],
              [32.647856893000096, 21.995402731000084],
              [32.54543420400006, 21.995402731000084],
              [32.52451879000006, 21.995402731000084],
              [32.44306319200007, 21.995402731000084],
              [32.340743856000074, 21.995402731000084],
              [32.23832116700004, 21.995402731000084],
              [32.136001831000044, 21.995402731000084],
              [32.03357914200012, 21.995402731000084],
              [31.93125980600007, 21.995402731000084],
              [31.82883711800008, 21.995402731000084],
              [31.726517782000087, 21.995402731000084],
              [31.62409509300005, 21.995402731000084],
              [31.521775757000057, 21.995402731000084],
              [31.494719176000046, 21.995386529000072],
              [31.435476115000085, 21.995351054000068],
              [31.467412150000087, 22.084131165000073],
              [31.49056319200008, 22.148209941000104],
              [31.491803426000104, 22.173221334000104],
              [31.482915080000055, 22.195442200000045],
              [31.460900919000096, 22.21549265600008],
              [31.442504110000073, 22.224174296000044],
              [31.423280477000105, 22.226964823000102],
              [31.404056844000138, 22.223760885000033],
              [31.3853499760001, 22.214459127000097],
              [31.359511759000043, 22.188104146000043],
              [31.314388101000134, 22.10227318800004],
              [31.310935913000037, 22.095706686000128],
              [31.261636597000063, 22.0017589320001],
              [31.248407430000043, 21.9943692020001],
              [31.210115194000082, 21.9943692020001],
              [31.11291182500014, 21.9943692020001],
              [31.01555342600011, 21.994420879000117],
              [30.91814335100014, 21.99447255500003],
              [30.820733276000055, 21.99447255500003],
              [30.72347823100006, 21.99447255500003],
              [30.626119832000086, 21.99447255500003],
              [30.528761434000046, 21.99447255500003],
              [30.431506389000106, 21.99447255500003],
              [30.334251343000062, 21.994524232000046],
              [30.236892944000147, 21.994524232000046],
              [30.139379517000123, 21.994524232000046],
              [30.042176148000124, 21.994524232000046],
              [29.944817749000094, 21.994524232000046],
              [29.84756270300005, 21.994575907000055],
              [29.75030765800011, 21.99462758400007],
              [29.65294925900008, 21.99462758400007],
              [29.55559086100004, 21.99462758400007],
              [29.45823246300006, 21.99462758400007],
              [29.3608223870001, 21.99467926000007],
              [29.2636190180001, 21.99467926000007],
              [29.166363973000074, 21.99467926000007],
              [29.06900557500009, 21.99467926000007],
              [28.971647176000147, 21.99467926000007],
              [28.874392130000047, 21.994730937],
              [28.777033732000064, 21.994782613000027],
              [28.67967533400011, 21.994782613000027],
              [28.58231693500008, 21.994782613000027],
              [28.48490686000011, 21.994782613000027],
              [28.38770349100008, 21.994782613000027],
              [28.29034509300004, 21.994782613000027],
              [28.19293501800007, 21.994834290000128],
              [28.095731649000072, 21.994834290000128],
              [27.9983732500001, 21.994834290000128],
              [27.90101485200006, 21.99488596600004],
              [27.803656453000087, 21.994937643000057],
              [27.70640140800009, 21.994937643000057],
              [27.609043009000118, 21.994937643000057],
              [27.511684611000078, 21.994937643000057],
              [27.414326212000105, 21.994937643000057],
              [27.316967814000066, 21.994937643000057],
              [27.219712768000136, 21.994989320000073],
              [27.122354370000096, 21.994989320000073],
              [27.024995972000028, 21.994989320000073],
              [26.927740926000098, 21.994989320000073],
              [26.83038252700007, 21.994989320000073],
              [26.733127482000043, 21.995040995000082],
              [26.63576908400009, 21.995092672000098],
              [26.538410685000116, 21.995092672000098],
              [26.441052286000087, 21.995092672000098],
              [26.34379724100006, 21.995092672000098],
              [26.24654219600012, 21.99514434800001],
              [26.149183797000063, 21.99514434800001],
              [26.051928752000038, 21.99514434800001],
              [25.954467, 21.995196025000027],
              [25.85710860200001, 21.995247701000054],
              [25.75985355600008, 21.995247701000054],
              [25.662598511000056, 21.995247701000054],
              [25.56524011200011, 21.995247701000054],
              [25.46793339000007, 21.99529937800004],
              [25.370678345000044, 21.99529937800004],
              [25.273216593000058, 21.99529937800004],
              [25.175858195000103, 21.99529937800004],
              [25.078499797000063, 21.99529937800004],
              [24.981244751000133, 21.995351054000068],
              [24.981244751000133, 22.287167867000065],
              [24.981244751000133, 22.578984680000033],
              [24.981244751000133, 22.870801494000133],
              [24.981244751000133, 23.162669983000043],
              [24.981244751000133, 23.4544351200001],
              [24.981244751000133, 23.74627777100001],
              [24.981244751000133, 24.038146261000108],
              [24.981244751000133, 24.329963074000105],
              [24.981244751000133, 24.621728211000075],
              [24.981244751000133, 24.91357086200007],
              [24.981244751000133, 25.205439352000056],
              [24.981244751000133, 25.497256165000053],
              [24.981244751000133, 25.788969625000036],
              [24.981244751000133, 26.08083811500002],
              [24.981244751000133, 26.37270660400013],
              [24.981244751000133, 26.66452341800003],
              [24.981244751000133, 26.859963685000096],
              [24.981244751000133, 27.04923943200005],
              [24.981244751000133, 27.138034567000076],
              [24.981244751000133, 27.475455831000048],
              [24.981244751000133, 27.627823792000058],
              [24.981244751000133, 27.666502794000067],
              [24.981244751000133, 28.018549296000018],
              [24.981244751000133, 28.096700613000067],
              [24.981244751000133, 28.49154368100004],
              [24.981244751000133, 28.89017568000004],
              [24.981244751000133, 29.057917379000017],
              [24.981244751000133, 29.181372376000056],
              [24.974320109000047, 29.238939922],
              [24.956646769000145, 29.292683411],
              [24.87375777200012, 29.468331604000028],
              [24.86383589700003, 29.502903137000104],
              [24.86156213400011, 29.54155710900004],
              [24.870553833000145, 29.614007467000093],
              [24.870657185000084, 29.638347066000037],
              [24.85618778400007, 29.6794815060001],
              [24.804924764000134, 29.75479990700005],
              [24.798206827000087, 29.796425273000082],
              [24.814949992000066, 29.84856679300013],
              [24.81619022600009, 29.868410543000024],
              [24.811642701000068, 29.89088979100005],
              [24.72554976400005, 30.078371888000063],
              [24.697334432000105, 30.122606913000098],
              [24.688342732000137, 30.144155986000058],
              [24.68865279200014, 30.182758280000044],
              [24.70467248500009, 30.217898254000076],
              [24.74611698400014, 30.28275217700009],
              [24.7628601480001, 30.317065328000027],
              [24.772368612000093, 30.331017965000015],
              [24.799447062000127, 30.360835266000024],
              [24.829729452000066, 30.38755198200009],
              [24.888123820000118, 30.46434316000004],
              [24.90765751100014, 30.49865631200008],
              [24.91706262200009, 30.532452698000057],
              [24.920369914000105, 30.55234812500005],
              [24.950652303000112, 30.621232808000073],
              [24.961194296000087, 30.676268210000032],
              [24.97359663900005, 30.7162657680001],
              [24.988582804000117, 30.75057891900012],
              [24.99488732900005, 30.785098776],
              [24.981244751000133, 30.825406392000062],
              [24.937629842000092, 30.905763245000074],
              [24.924607381000044, 30.95676788300004],
              [24.88957076000011, 31.018831279000025],
              [24.88264611800014, 31.039088440000015],
              [24.859495076000144, 31.145955303000036],
              [24.85856490000009, 31.227914124],
              [24.848643025000115, 31.312043355000085],
              [24.8489530840001, 31.348630270000015],
              [24.86125207500004, 31.38035959900013],
              [25.023722778000064, 31.49440948500002],
              [25.060413045000132, 31.579365539000023],
              [25.08842167100005, 31.613523661000087],
              [25.15088951900009, 31.656480210000026],
              [25.14942467500009, 31.648871161000045],
              [25.16179446700005, 31.58356354400007],
              [25.17286217500009, 31.551581122000073],
              [25.190928582000083, 31.53148021000004],
              [25.21257571700005, 31.52635325700004],
              [25.26343834700009, 31.52366771000004],
              [25.30209394600007, 31.50653717700004],
              [25.32276451900009, 31.506415106000077],
              [25.36850019600007, 31.512274481000077],
              [25.378103061000047, 31.509711005000042],
              [25.38965905000009, 31.505113023000035],
              [25.401866082000083, 31.503159898000035],
              [25.420176629000082, 31.512193101000037],
              [25.444834832000083, 31.517645575000074],
              [25.473887566000087, 31.52049388200004],
              [25.63648522200009, 31.560695705000057],
              [25.824066602000073, 31.614935614000046],
              [25.86882571700005, 31.620917059000078],
              [25.966807488000086, 31.61660390800006],
              [26.362152540000068, 31.521918036000045],
              [26.650645379000082, 31.488755601000037],
              [26.667246941000087, 31.480943101000037],
              [26.683116082000083, 31.476223049000055],
              [26.73292076900009, 31.47923411700009],
              [26.753184441000087, 31.477484442000048],
              [26.82471764400009, 31.447821356000077],
              [26.86573326900009, 31.436835028000075],
              [26.911631707000083, 31.43650950700004],
              [26.947927280000044, 31.44822825700004],
              [26.965505405000044, 31.449652411000045],
              [26.982595248000052, 31.439927476000037],
              [26.996429884000065, 31.42869700700004],
              [27.006521030000044, 31.425034898000035],
              [27.015798373000052, 31.42446523600006],
              [27.02702884200005, 31.422267971000053],
              [27.05437259200005, 31.408636786000045],
              [27.117360873000052, 31.390448309000078],
              [27.185069207000083, 31.38434479400007],
              [27.20997155000009, 31.378119208000044],
              [27.22624759200005, 31.367661851000037],
              [27.232432488000086, 31.372259833000044],
              [27.242035352000073, 31.377346096000053],
              [27.246104363000086, 31.381293036000045],
              [27.257985873000052, 31.380031643000052],
              [27.320648634000065, 31.381008205000057],
              [27.32748457100007, 31.37921784100007],
              [27.334808790000068, 31.375148830000057],
              [27.34229576900009, 31.36823151200008],
              [27.341970248000052, 31.36465078300006],
              [27.340098504000082, 31.360988674000055],
              [27.34229576900009, 31.353989976000037],
              [27.349782748000052, 31.34129466400009],
              [27.354340040000068, 31.335760809000078],
              [27.359385613000086, 31.33348216400009],
              [27.36231530000009, 31.330511786000045],
              [27.36378014400009, 31.31549713700008],
              [27.366465691000087, 31.30963776200008],
              [27.37354576900009, 31.29840729400007],
              [27.383474155000044, 31.268500067000048],
              [27.39356530000009, 31.254706122000073],
              [27.417491082000083, 31.237209377000056],
              [27.446299675000034, 31.223211981000077],
              [27.478037957000083, 31.21393463700008],
              [27.540537957000083, 31.20575592700004],
              [27.565440300000034, 31.196966864000046],
              [27.587738477000073, 31.193101304000038],
              [27.60987389400009, 31.203192450000074],
              [27.660329623000052, 31.180243231000077],
              [27.719493035000085, 31.189276434000078],
              [27.83570397200009, 31.237941799000055],
              [27.85287519600007, 31.240301825000074],
              [27.863291863000086, 31.233547268000052],
              [27.86850019600007, 31.21938711100006],
              [27.869883660000085, 31.199774481000077],
              [27.87273196700005, 31.19159577000005],
              [27.89031009200005, 31.155422268000052],
              [27.89429772200009, 31.12262604400007],
              [27.897146030000044, 31.114406643000052],
              [27.926931186000047, 31.09902578300006],
              [27.97510826900009, 31.093085028000075],
              [28.154551629000082, 31.09332916900007],
              [28.166270379000082, 31.090765692000048],
              [28.175303582000083, 31.084906317000048],
              [28.18327884200005, 31.07831452000005],
              [28.191416863000086, 31.073431708000044],
              [28.203868035000085, 31.07050202000005],
              [28.233571811000047, 31.073431708000044],
              [28.25635826900009, 31.07127513200004],
              [28.299082879000082, 31.06195709800005],
              [28.318369988000086, 31.059800523000035],
              [28.338633660000085, 31.064113674000055],
              [28.382090691000087, 31.08274974200009],
              [28.404958530000044, 31.086493231000077],
              [28.42432701900009, 31.08344147300005],
              [28.442230665000068, 31.07640208500004],
              [28.457774285000085, 31.066839911000045],
              [28.469737175000034, 31.05605703300006],
              [28.478526238000086, 31.05182526200008],
              [28.51417076900009, 31.05231354400007],
              [28.527598504000082, 31.050116278000075],
              [28.538259311000047, 31.046535549000055],
              [28.555023634000065, 31.038723049000055],
              [28.732676629000082, 30.984076239000046],
              [28.768239780000044, 30.96670156500005],
              [28.787771030000044, 30.95966217700004],
              [28.812022332000083, 30.956773179000038],
              [28.81804446700005, 30.951157945000034],
              [28.824961785000085, 30.92446523600006],
              [28.828868035000085, 30.915187893000052],
              [28.83570397200009, 30.91079336100006],
              [28.854340040000068, 30.905951239000046],
              [29.028086785000085, 30.827053127000056],
              [29.18921959700009, 30.833238023000035],
              [29.218923373000052, 30.838039455000057],
              [29.355723504000082, 30.895086981000077],
              [29.50326582100007, 30.956691799000055],
              [29.55632571700005, 30.99091217700004],
              [29.59807376400005, 31.009507554000038],
              [29.603770379000082, 31.01203034100007],
              [29.61101321700005, 31.021918036000045],
              [29.618662957000083, 31.029282945000034],
              [29.765961134000065, 31.121568101000037],
              [29.781504754000082, 31.14793528900009],
              [29.809336785000085, 31.142320054000038],
              [29.83838951900009, 31.154120184000078],
              [29.884613477000073, 31.189520575000074],
              [29.875661655000044, 31.200873114000046],
              [29.871836785000085, 31.200140692000048],
              [29.863536004000082, 31.19635651200008],
              [29.869151238000086, 31.20648834800005],
              [29.876963738000086, 31.21356842700004],
              [29.884776238000086, 31.213771877000056],
              [29.890879754000082, 31.203192450000074],
              [29.89820397200009, 31.203192450000074],
              [29.909678582000083, 31.214097398000035],
              [29.956228061000047, 31.250067450000074],
              [29.969981316000087, 31.257798570000034],
              [29.983164910000085, 31.26325104400007],
              [30.003103061000047, 31.287095445000034],
              [30.011241082000083, 31.29254791900007],
              [30.02507571700005, 31.294867255000042],
              [30.03296959700009, 31.30036041900007],
              [30.03956139400009, 31.307114976000037],
              [30.049082879000082, 31.313055731000077],
              [30.045909050000034, 31.314154364000046],
              [30.043223504000082, 31.314154364000046],
              [30.041677280000044, 31.31549713700008],
              [30.042246941000087, 31.32050202000005],
              [30.069590691000087, 31.33348216400009],
              [30.066661004000082, 31.30487702000005],
              [30.094899936000047, 31.285589911000045],
              [30.098480665000068, 31.28465403900009],
              [30.135996941000087, 31.27484772300005],
              [30.172618035000085, 31.271429755000042],
              [30.164398634000065, 31.26699453300006],
              [30.153086785000085, 31.255845445000034],
              [30.144704623000052, 31.251613674000055],
              [30.144053582000083, 31.246568101000037],
              [30.145518425000034, 31.24510325700004],
              [30.148610873000052, 31.245062567000048],
              [30.15211022200009, 31.244126695000034],
              [30.140147332000083, 31.237250067000048],
              [30.143728061000047, 31.22947825700004],
              [30.154633009000065, 31.22215403900009],
              [30.165212436000047, 31.216782945000034],
              [30.20679772200009, 31.237941799000055],
              [30.20167076900009, 31.226507880000042],
              [30.207204623000052, 31.22089264500005],
              [30.215830925000034, 31.21938711100006],
              [30.22046959700009, 31.22020091400009],
              [30.22437584700009, 31.22687409100007],
              [30.254567905000044, 31.251613674000055],
              [30.257334832000083, 31.24681224200009],
              [30.258067254000082, 31.24640534100007],
              [30.26140384200005, 31.244126695000034],
              [30.263845248000052, 31.24990469000005],
              [30.265961134000065, 31.253241278000075],
              [30.267751498000052, 31.25731028900009],
              [30.268809441000087, 31.265285549000055],
              [30.27507571700005, 31.265285549000055],
              [30.274587436000047, 31.25454336100006],
              [30.276621941000087, 31.24640534100007],
              [30.281423373000052, 31.24091217700004],
              [30.28874759200005, 31.237941799000055],
              [30.29273522200009, 31.244574286000045],
              [30.302989129000082, 31.271429755000042],
              [30.28760826900009, 31.278225002000056],
              [30.273448113000086, 31.27529531500005],
              [30.258636915000068, 31.268866278000075],
              [30.240896030000044, 31.265285549000055],
              [30.240896030000044, 31.271429755000042],
              [30.243988477000073, 31.271918036000045],
              [30.25131269600007, 31.27106354400007],
              [30.254567905000044, 31.271429755000042],
              [30.254567905000044, 31.278265692000048],
              [30.238454623000052, 31.273993231000077],
              [30.17945397200009, 31.271429755000042],
              [30.17945397200009, 31.278265692000048],
              [30.21656334700009, 31.286444403000075],
              [30.25171959700009, 31.30341217700004],
              [30.312836134000065, 31.35057200700004],
              [30.33448326900009, 31.381008205000057],
              [30.348399285000085, 31.42133209800005],
              [30.352386915000068, 31.46320221600007],
              [30.343923373000052, 31.497992255000042],
              [30.350759311000047, 31.497992255000042],
              [30.355723504000082, 31.47882721600007],
              [30.36459394600007, 31.460109768000052],
              [30.378428582000083, 31.44668203300006],
              [30.398610873000052, 31.443345445000034],
              [30.370616082000083, 31.46161530200004],
              [30.355723504000082, 31.491115627000056],
              [30.362152540000068, 31.508734442000048],
              [30.398610873000052, 31.491156317000048],
              [30.425629102000073, 31.47361888200004],
              [30.45639082100007, 31.462713934000078],
              [30.492523634000065, 31.45921458500004],
              [30.535817905000044, 31.46385325700004],
              [30.676524285000085, 31.496161200000074],
              [30.973887566000087, 31.586737372000073],
              [30.973887566000087, 31.579901434000078],
              [30.95875084700009, 31.578070380000042],
              [30.866384311000047, 31.54828522300005],
              [30.789073113000086, 31.510321356000077],
              [30.73609459700009, 31.488714911000045],
              [30.693369988000086, 31.46385325700004],
              [30.687754754000082, 31.46161530200004],
              [30.674082879000082, 31.45966217700004],
              [30.666026238000086, 31.457017320000034],
              [30.628103061000047, 31.43431224200009],
              [30.61068769600007, 31.42914459800005],
              [30.570974155000044, 31.426581122000073],
              [30.562347852000073, 31.422267971000053],
              [30.557871941000087, 31.42218659100007],
              [30.54265384200005, 31.402411200000074],
              [30.54265384200005, 31.394964911000045],
              [30.563243035000085, 31.39020416900007],
              [30.570323113000086, 31.39008209800005],
              [30.57667076900009, 31.394964911000045],
              [30.583506707000083, 31.394964911000045],
              [30.598643425000034, 31.38735586100006],
              [30.62671959700009, 31.388657945000034],
              [30.653819207000083, 31.395819403000075],
              [30.666026238000086, 31.405503648000035],
              [30.675059441000087, 31.421576239000046],
              [30.69507897200009, 31.416896877000056],
              [30.715993686000047, 31.402085679000038],
              [30.727549675000034, 31.38812897300005],
              [30.734385613000086, 31.38812897300005],
              [30.74073326900009, 31.405503648000035],
              [30.756195509000065, 31.423000393000052],
              [30.774668816000087, 31.436835028000075],
              [30.78956139400009, 31.443345445000034],
              [30.79851321700005, 31.446478583000044],
              [30.809580925000034, 31.44208405200004],
              [30.822601759000065, 31.434719143000052],
              [30.837412957000083, 31.42914459800005],
              [30.846853061000047, 31.430161851000037],
              [30.859711134000065, 31.433335679000038],
              [30.873708530000044, 31.434515692000048],
              [30.885752800000034, 31.42914459800005],
              [30.882660352000073, 31.428127346000053],
              [30.879893425000034, 31.428168036000045],
              [30.878428582000083, 31.426988023000035],
              [30.878916863000086, 31.422267971000053],
              [30.892425977000073, 31.419094143000052],
              [30.909434441000087, 31.423814195000034],
              [30.926442905000044, 31.43305084800005],
              [30.939707879000082, 31.443345445000034],
              [30.93726647200009, 31.44440338700008],
              [30.934825066000087, 31.444240627000056],
              [30.93327884200005, 31.445135809000078],
              [30.933604363000086, 31.449611721000053],
              [30.937022332000083, 31.451727606000077],
              [30.937510613000086, 31.45262278900009],
              [30.937673373000052, 31.45380280200004],
              [30.939707879000082, 31.457017320000034],
              [30.97396894600007, 31.44407786700009],
              [30.980723504000082, 31.43650950700004],
              [30.99000084700009, 31.44326406500005],
              [30.996918165000068, 31.451117255000042],
              [31.008067254000082, 31.47134023600006],
              [31.002207879000082, 31.479641018000052],
              [31.005707227000073, 31.48623281500005],
              [31.021739129000082, 31.497992255000042],
              [31.024668816000087, 31.504055080000057],
              [31.023610873000052, 31.50918203300006],
              [31.023285352000073, 31.513820705000057],
              [31.029144727000073, 31.518500067000048],
              [31.03492272200009, 31.519680080000057],
              [31.071299675000034, 31.517320054000038],
              [31.080739780000044, 31.514227606000077],
              [31.09742272200009, 31.504828192000048],
              [31.10010826900009, 31.50104401200008],
              [31.099782748000052, 31.49640534100007],
              [31.101573113000086, 31.49249909100007],
              [31.11109459700009, 31.491156317000048],
              [31.119151238000086, 31.493109442000048],
              [31.125254754000082, 31.497788804000038],
              [31.129242384000065, 31.504461981000077],
              [31.11109459700009, 31.512274481000077],
              [31.117523634000065, 31.516017971000053],
              [31.12354576900009, 31.51788971600007],
              [31.130381707000083, 31.51699453300006],
              [31.11109459700009, 31.53974030200004],
              [31.07081139400009, 31.565375067000048],
              [31.02320397200009, 31.58299388200004],
              [30.978037957000083, 31.58429596600007],
              [30.987559441000087, 31.58893463700008],
              [31.012380405000044, 31.596909898000035],
              [31.09742272200009, 31.607896226000037],
              [31.12867272200009, 31.60492584800005],
              [31.220957879000082, 31.579901434000078],
              [31.349945509000065, 31.529649156000062],
              [31.37859134200005, 31.518500067000048],
              [31.41960696700005, 31.491156317000048],
              [31.523692254000082, 31.449652411000045],
              [31.556813998000052, 31.443345445000034],
              [31.57162519600007, 31.443752346000053],
              [31.59742272200009, 31.444484768000052],
              [31.748301629000082, 31.481594143000052],
              [31.837901238000086, 31.525336005000042],
              [31.87435957100007, 31.535589911000045],
              [31.912933790000068, 31.534898179000038],
              [31.944834832000083, 31.52094147300005],
              [31.959157748000052, 31.49433014500005],
              [31.96420332100007, 31.482407945000034],
              [31.99577884200005, 31.445746161000045],
              [32.00904381600009, 31.417181708000044],
              [32.02491295700008, 31.400051174000055],
              [32.056976759000065, 31.375148830000057],
              [32.06755618600005, 31.371079820000034],
              [32.09197024800005, 31.366400458000044],
              [32.093760613000086, 31.365668036000045],
              [32.104258660000085, 31.361476955000057],
              [32.12916100400008, 31.33738841400009],
              [32.13526451900009, 31.33348216400009],
              [32.14966881600009, 31.327785549000055],
              [32.189463738000086, 31.300767320000034],
              [32.199554884000065, 31.295070705000057],
              [32.168955925000034, 31.300726630000042],
              [32.07007897200009, 31.353989976000037],
              [32.07569420700008, 31.353501695000034],
              [32.080088738000086, 31.353989976000037],
              [32.082774285000085, 31.352769273000035],
              [32.090586785000085, 31.34715403900009],
              [32.08814537900008, 31.354437567000048],
              [32.08350670700008, 31.35883209800005],
              [32.076508009000065, 31.36090729400007],
              [32.05600019600007, 31.36286041900007],
              [32.051442905000044, 31.366441148000035],
              [32.048838738000086, 31.37099844000005],
              [32.043955925000034, 31.375148830000057],
              [32.01734459700009, 31.387518622000073],
              [32.006602410000085, 31.395331122000073],
              [32.00245201900009, 31.394964911000045],
              [31.994965040000068, 31.394964911000045],
              [31.99195397200009, 31.40851471600007],
              [31.98568769600007, 31.420355536000045],
              [31.977549675000034, 31.42987702000005],
              [31.968272332000083, 31.43650950700004],
              [31.981293165000068, 31.43650950700004],
              [31.99350019600007, 31.43781159100007],
              [31.94312584700009, 31.49164459800005],
              [31.932383660000085, 31.507757880000042],
              [31.917979363000086, 31.523993231000077],
              [31.906586134000065, 31.52960846600007],
              [31.906260613000086, 31.525336005000042],
              [31.889496290000068, 31.532049872000073],
              [31.882985873000052, 31.528509833000044],
              [31.878916863000086, 31.518500067000048],
              [31.865244988000086, 31.525336005000042],
              [31.86500084700009, 31.52212148600006],
              [31.86573326900009, 31.515326239000046],
              [31.865244988000086, 31.512274481000077],
              [31.861664259000065, 31.51434967700004],
              [31.854746941000087, 31.516506252000056],
              [31.85092207100007, 31.518500067000048],
              [31.85132897200009, 31.510646877000056],
              [31.849457227000073, 31.505072333000044],
              [31.844737175000034, 31.497992255000042],
              [31.865244988000086, 31.497992255000042],
              [31.859711134000065, 31.486883856000077],
              [31.875010613000086, 31.463324286000045],
              [31.872080925000034, 31.449611721000053],
              [31.878916863000086, 31.449611721000053],
              [31.878916863000086, 31.443345445000034],
              [31.872080925000034, 31.443345445000034],
              [31.874278191000087, 31.43891022300005],
              [31.87745201900009, 31.434149481000077],
              [31.878916863000086, 31.42914459800005],
              [31.872080925000034, 31.42914459800005],
              [31.868662957000083, 31.441351630000042],
              [31.862071160000085, 31.45058828300006],
              [31.851898634000065, 31.45612213700008],
              [31.837901238000086, 31.457017320000034],
              [31.841644727000073, 31.464504299000055],
              [31.83765709700009, 31.46548086100006],
              [31.830414259000065, 31.458807684000078],
              [31.824229363000086, 31.443345445000034],
              [31.830414259000065, 31.442572333000044],
              [31.83375084700009, 31.443793036000045],
              [31.837901238000086, 31.449611721000053],
              [31.844981316000087, 31.44481028900009],
              [31.850596550000034, 31.44293854400007],
              [31.858409050000034, 31.443345445000034],
              [31.858409050000034, 31.43650950700004],
              [31.85092207100007, 31.43650950700004],
              [31.85092207100007, 31.42914459800005],
              [31.85482832100007, 31.423163153000075],
              [31.860606316000087, 31.41901276200008],
              [31.868418816000087, 31.416571356000077],
              [31.878916863000086, 31.416083075000074],
              [31.871836785000085, 31.409816799000055],
              [31.861664259000065, 31.40761953300006],
              [31.851735873000052, 31.40965403900009],
              [31.844737175000034, 31.416083075000074],
              [31.837901238000086, 31.416083075000074],
              [31.838552280000044, 31.41083405200004],
              [31.836680535000085, 31.40965403900009],
              [31.83366946700005, 31.409816799000055],
              [31.830414259000065, 31.408636786000045],
              [31.834971550000034, 31.40574778900009],
              [31.838552280000044, 31.402492580000057],
              [31.844737175000034, 31.394964911000045],
              [31.830739780000044, 31.379787502000056],
              [31.82789147200009, 31.368353583000044],
              [31.836924675000034, 31.361883856000077],
              [31.858409050000034, 31.361476955000057],
              [31.858409050000034, 31.353989976000037],
              [31.84506269600007, 31.35618724200009],
              [31.834157748000052, 31.359930731000077],
              [31.825043165000068, 31.360663153000075],
              [31.816742384000065, 31.353989976000037],
              [31.810557488000086, 31.353989976000037],
              [31.803884311000047, 31.36005280200004],
              [31.797211134000065, 31.359523830000057],
              [31.792246941000087, 31.353583075000074],
              [31.790212436000047, 31.343451239000046],
              [31.79428144600007, 31.338446356000077],
              [31.80128014400009, 31.334865627000056],
              [31.802744988000086, 31.331284898000035],
              [31.790212436000047, 31.326646226000037],
              [31.790212436000047, 31.32050202000005],
              [31.795909050000034, 31.310980536000045],
              [31.788910352000073, 31.307440497000073],
              [31.777517123000052, 31.30499909100007],
              [31.769053582000083, 31.298773505000042],
              [31.76693769600007, 31.28465403900009],
              [31.77320397200009, 31.275864976000037],
              [31.784190300000034, 31.273382880000042],
              [31.794932488000086, 31.277696031000062],
              [31.796397332000083, 31.278265692000048],
              [31.794444207000083, 31.28001536700009],
              [31.793142123000052, 31.280462958000044],
              [31.791840040000068, 31.28143952000005],
              [31.790212436000047, 31.285101630000042],
              [31.80437259200005, 31.27997467700004],
              [31.811208530000044, 31.27871328300006],
              [31.820567254000082, 31.278265692000048],
              [31.82862389400009, 31.27411530200004],
              [31.830251498000052, 31.264878648000035],
              [31.830332879000082, 31.25576406500005],
              [31.834157748000052, 31.251613674000055],
              [31.84538821700005, 31.248968817000048],
              [31.86101321700005, 31.24237702000005],
              [31.875987175000034, 31.233303127000056],
              [31.885752800000034, 31.22361888200004],
              [31.893402540000068, 31.239935614000046],
              [31.898610873000052, 31.246649481000077],
              [31.906260613000086, 31.251613674000055],
              [31.90211022200009, 31.242336330000057],
              [31.900645379000082, 31.236070054000038],
              [31.90202884200005, 31.230617580000057],
              [31.906260613000086, 31.22361888200004],
              [31.892588738000086, 31.22361888200004],
              [31.892588738000086, 31.216782945000034],
              [31.906260613000086, 31.216782945000034],
              [31.903005405000044, 31.214585679000038],
              [31.90015709700009, 31.213039455000057],
              [31.898448113000086, 31.209906317000048],
              [31.899424675000034, 31.203192450000074],
              [31.904144727000073, 31.20384349200009],
              [31.906911655000044, 31.205633856000077],
              [31.909190300000034, 31.20807526200008],
              [31.912933790000068, 31.210638739000046],
              [31.914235873000052, 31.208970445000034],
              [31.913910352000073, 31.20648834800005],
              [31.915049675000034, 31.204250393000052],
              [31.919769727000073, 31.203192450000074],
              [31.919769727000073, 31.210638739000046],
              [31.926605665000068, 31.210638739000046],
              [31.92164147200009, 31.196478583000044],
              [31.926442905000044, 31.18699778900009],
              [31.934743686000047, 31.187567450000074],
              [31.940277540000068, 31.203192450000074],
              [31.951914910000085, 31.20457591400009],
              [31.967539910000085, 31.218817450000074],
              [31.986582879000082, 31.230292059000078],
              [32.00928795700008, 31.22361888200004],
              [31.994965040000068, 31.22361888200004],
              [31.994965040000068, 31.216782945000034],
              [32.00928795700008, 31.210638739000046],
              [32.01197350400008, 31.214789130000042],
              [32.018239780000044, 31.21906159100007],
              [32.02279707100007, 31.22361888200004],
              [32.037119988000086, 31.216782945000034],
              [32.037119988000086, 31.210638739000046],
              [32.03296959700009, 31.206203518000052],
              [32.031260613000086, 31.202866929000038],
              [32.029633009000065, 31.189520575000074],
              [32.04078209700009, 31.193915106000077],
              [32.043955925000034, 31.19635651200008],
              [32.04232832100007, 31.187933661000045],
              [32.04037519600007, 31.18231842700004],
              [32.03679446700005, 31.178615627000056],
              [32.029633009000065, 31.175848700000074],
              [32.029633009000065, 31.169623114000046],
              [32.03638756600009, 31.161078192000048],
              [32.03687584700009, 31.15029531500005],
              [32.01612389400009, 31.134914455000057],
              [32.01612389400009, 31.128078518000052],
              [32.02686608200008, 31.12767161700009],
              [32.035166863000086, 31.129706122000073],
              [32.041026238000086, 31.13426341400009],
              [32.043955925000034, 31.141750393000052],
              [32.05014082100007, 31.141750393000052],
              [32.051442905000044, 31.13117096600007],
              [32.05233808700007, 31.12877024900007],
              [32.05453535200007, 31.122992255000042],
              [32.060557488000086, 31.11737702000005],
              [32.07007897200009, 31.114406643000052],
              [32.07007897200009, 31.10691966400009],
              [32.05990644600007, 31.104641018000052],
              [32.05258222700007, 31.100775458000044],
              [32.047618035000085, 31.094875393000052],
              [32.043955925000034, 31.086493231000077],
              [32.04900149800005, 31.084540106000077],
              [32.056976759000065, 31.07965729400007],
              [32.06657962300005, 31.08494700700004],
              [32.07553144600007, 31.086371161000045],
              [32.08375084700009, 31.084418036000045],
              [32.090586785000085, 31.07965729400007],
              [32.090586785000085, 31.073431708000044],
              [32.08375084700009, 31.073431708000044],
              [32.08375084700009, 31.06598541900007],
              [32.093760613000086, 31.058539130000042],
              [32.106455925000034, 31.05337148600006],
              [32.119802280000044, 31.05292389500005],
              [32.13209069100009, 31.059800523000035],
              [32.13209069100009, 31.06598541900007],
              [32.11744225400008, 31.06631094000005],
              [32.107432488000086, 31.072821356000077],
              [32.10124759200005, 31.08274974200009],
              [32.097992384000065, 31.09332916900007],
              [32.11296634200005, 31.09056224200009],
              [32.133148634000065, 31.081732489000046],
              [32.142588738000086, 31.08026764500005],
              [32.14633222700007, 31.07965729400007],
              [32.13835696700005, 31.09332916900007],
              [32.154307488000086, 31.093817450000074],
              [32.15943444100009, 31.09332916900007],
              [32.15943444100009, 31.100775458000044],
              [32.154958530000044, 31.10175202000005],
              [32.15406334700009, 31.10252513200004],
              [32.154307488000086, 31.103989976000037],
              [32.15284264400009, 31.106594143000052],
              [32.154307488000086, 31.10773346600007],
              [32.16627037900008, 31.114406643000052],
              [32.16684004000007, 31.108343817000048],
              [32.16968834700009, 31.107123114000046],
              [32.174164259000065, 31.107570705000057],
              [32.17994225400008, 31.10691966400009],
              [32.17603600400008, 31.11782461100006],
              [32.18384850400008, 31.124945380000042],
              [32.19483483200008, 31.125799872000073],
              [32.205739780000044, 31.109198309000078],
              [32.21851647200009, 31.105210679000038],
              [32.23414147200009, 31.10488515800006],
              [32.24822024800005, 31.10691966400009],
              [32.272227410000085, 31.118882554000038],
              [32.28345787900008, 31.136542059000078],
              [32.28052819100009, 31.15497467700004],
              [32.262461785000085, 31.169623114000046],
              [32.28646894600007, 31.170355536000045],
              [32.28736412900008, 31.17015208500004],
              [32.289805535000085, 31.169623114000046],
              [32.29476972700007, 31.199367580000057],
              [32.29509524800005, 31.213364976000037],
              [32.289805535000085, 31.230454820000034],
              [32.27295983200008, 31.248846747000073],
              [32.270518425000034, 31.257554429000038],
              [32.28296959700009, 31.265285549000055],
              [32.267914259000065, 31.272650458000044],
              [32.246755405000044, 31.279242255000042],
              [32.22632897200009, 31.282049872000073],
              [32.21412194100009, 31.278265692000048],
              [32.207041863000086, 31.295070705000057],
              [32.219493035000085, 31.293768622000073],
              [32.23267662900008, 31.29287344000005],
              [32.256602410000085, 31.288804429000038],
              [32.30046634200005, 31.28143952000005],
              [32.31381269600007, 31.272691148000035],
              [32.32007897200009, 31.272691148000035],
              [32.33139082100007, 31.271429755000042],
              [32.33383222700007, 31.254706122000073],
              [32.34424889400009, 31.241888739000046],
              [32.35914147200009, 31.23346588700008],
              [32.38990319100009, 31.226507880000042],
              [32.401377800000034, 31.21710846600007],
              [32.42017662900008, 31.19635651200008],
              [32.46265709700009, 31.161037502000056],
              [32.481211785000085, 31.148871161000045],
              [32.50953209700009, 31.10691966400009],
              [32.535817905000044, 31.08661530200004],
              [32.56568444100009, 31.07054271000004],
              [32.59970136800007, 31.06150950700004],
              [32.601573113000086, 31.060980536000045],
              [32.645518425000034, 31.059800523000035],
              [32.687510613000086, 31.064439195000034],
              [32.76197350400008, 31.081203518000052],
              [32.85075931100005, 31.118801174000055],
              [32.86801191500007, 31.13027578300006],
              [32.909190300000034, 31.148179429000038],
              [32.92042076900009, 31.155422268000052],
              [32.92725670700008, 31.155422268000052],
              [32.92725670700008, 31.14793528900009],
              [32.89535566500007, 31.13739655200004],
              [32.83961022200009, 31.101223049000055],
              [32.80713951900009, 31.09332916900007],
              [32.75245201900009, 31.07135651200008],
              [32.66651451900009, 31.05231354400007],
              [32.71501712300005, 31.05231354400007],
              [32.71501712300005, 31.04555898600006],
              [32.70069420700008, 31.038723049000055],
              [32.73129316500007, 31.038763739000046],
              [32.742849155000044, 31.042629299000055],
              [32.74919681100005, 31.05231354400007],
              [32.75538170700008, 31.05231354400007],
              [32.756195509000065, 31.046535549000055],
              [32.75945071700005, 31.04559967700004],
              [32.76384524800005, 31.04633209800005],
              [32.769541863000086, 31.04555898600006],
              [32.831065300000034, 31.07965729400007],
              [32.882823113000086, 31.093573309000078],
              [32.89307701900009, 31.100775458000044],
              [32.89926191500007, 31.100775458000044],
              [32.90349368600005, 31.095445054000038],
              [32.91773522200009, 31.092230536000045],
              [32.914398634000065, 31.08730703300006],
              [32.90674889400009, 31.086493231000077],
              [32.90674889400009, 31.07965729400007],
              [32.91724694100009, 31.082831122000073],
              [32.94092858200008, 31.09332916900007],
              [32.94092858200008, 31.100775458000044],
              [32.91358483200008, 31.100775458000044],
              [32.91358483200008, 31.10691966400009],
              [32.92709394600007, 31.111802476000037],
              [32.944021030000044, 31.107896226000037],
              [32.95948326900009, 31.098456122000073],
              [32.968760613000086, 31.086493231000077],
              [32.97120201900009, 31.080877997000073],
              [32.973317905000044, 31.07103099200009],
              [32.97510826900009, 31.06598541900007],
              [32.961273634000065, 31.06598541900007],
              [32.994476759000065, 31.055568752000056],
              [33.00993899800005, 31.056301174000055],
              [33.023448113000086, 31.06598541900007],
              [33.023448113000086, 31.073431708000044],
              [33.01392662900008, 31.078192450000074],
              [33.00912519600007, 31.07965729400007],
              [33.00912519600007, 31.086493231000077],
              [33.047862175000034, 31.09511953300006],
              [33.05746504000007, 31.100775458000044],
              [33.05250084700009, 31.108303127000056],
              [33.054698113000086, 31.11554596600007],
              [33.06006920700008, 31.123928127000056],
              [33.06430097700007, 31.134914455000057],
              [33.05746504000007, 31.134914455000057],
              [33.05103600400008, 31.128119208000044],
              [33.030284050000034, 31.114406643000052],
              [33.02711022200009, 31.11074453300006],
              [33.023773634000065, 31.10773346600007],
              [33.023773634000065, 31.104641018000052],
              [33.030284050000034, 31.100775458000044],
              [33.01693769600007, 31.098130601000037],
              [32.994151238000086, 31.098456122000073],
              [32.97055097700007, 31.10146719000005],
              [32.95443769600007, 31.10691966400009],
              [32.98462975400008, 31.109523830000057],
              [33.00180097700007, 31.124823309000078],
              [33.014414910000085, 31.144964911000045],
              [33.030284050000034, 31.162176825000074],
              [33.04232832100007, 31.167222398000035],
              [33.067067905000044, 31.17096588700008],
              [33.07862389400009, 31.175848700000074],
              [33.09782962300005, 31.191555080000057],
              [33.109385613000086, 31.196437893000052],
              [33.12647545700008, 31.19635651200008],
              [33.12647545700008, 31.189520575000074],
              [33.098643425000034, 31.189520575000074],
              [33.098643425000034, 31.183294989000046],
              [33.11109459700009, 31.17536041900007],
              [33.14698326900009, 31.134914455000057],
              [33.15772545700008, 31.11786530200004],
              [33.15357506600009, 31.11237213700008],
              [33.140961134000065, 31.10960521000004],
              [33.12647545700008, 31.100775458000044],
              [33.12525475400008, 31.103257554000038],
              [33.12525475400008, 31.105902411000045],
              [33.124034050000034, 31.107570705000057],
              [33.11898847700007, 31.10691966400009],
              [33.11898847700007, 31.100775458000044],
              [33.135752800000034, 31.090765692000048],
              [33.14470462300005, 31.077866929000038],
              [33.14429772200009, 31.062567450000074],
              [33.13331139400009, 31.04555898600006],
              [33.16911868600005, 31.05801015800006],
              [33.18767337300005, 31.061672268000052],
              [33.20093834700009, 31.059800523000035],
              [33.207692905000044, 31.061021226000037],
              [33.21241295700008, 31.060980536000045],
              [33.221446160000085, 31.059800523000035],
              [33.221446160000085, 31.06598541900007],
              [33.207774285000085, 31.073431708000044],
              [33.20093834700009, 31.073431708000044],
              [33.20093834700009, 31.06598541900007],
              [33.19483483200008, 31.06598541900007],
              [33.19483483200008, 31.073431708000044],
              [33.24789472700007, 31.09125397300005],
              [33.262461785000085, 31.100775458000044],
              [33.26978600400008, 31.100775458000044],
              [33.262461785000085, 31.09332916900007],
              [33.26978600400008, 31.086493231000077],
              [33.27719160200007, 31.09210846600007],
              [33.28541100400008, 31.092718817000048],
              [33.29249108200008, 31.088446356000077],
              [33.29656009200005, 31.07965729400007],
              [33.30396569100009, 31.07965729400007],
              [33.30486087300005, 31.08812083500004],
              [33.30453535200007, 31.098211981000077],
              [33.30323326900009, 31.09979889500005],
              [33.31763756600009, 31.100775458000044],
              [33.30811608200008, 31.105129299000055],
              [33.29818769600007, 31.103908596000053],
              [33.28874759200005, 31.10488515800006],
              [33.27719160200007, 31.10691966400009],
              [33.38648522200009, 31.114406643000052],
              [33.377696160000085, 31.132554429000038],
              [33.390635613000086, 31.13621653900009],
              [33.40642337300005, 31.137274481000077],
              [33.40642337300005, 31.155422268000052],
              [33.41724694100009, 31.150783596000053],
              [33.420664910000085, 31.14793528900009],
              [33.42750084700009, 31.14793528900009],
              [33.44092858200008, 31.151190497000073],
              [33.480804884000065, 31.133246161000045],
              [33.49952233200008, 31.128078518000052],
              [33.57252037900008, 31.121568101000037],
              [33.59205162900008, 31.114406643000052],
              [33.59205162900008, 31.12128327000005],
              [33.61475670700008, 31.115383205000057],
              [33.64795983200008, 31.117254950000074],
              [33.85434004000007, 31.16347890800006],
              [34.04704837300005, 31.22919342700004],
              [34.19849694100009, 31.313299872000073],
              [34.200269441306034, 31.314266688845734],
              [34.22460819500009, 31.275714824000104],
              [34.23039595600011, 31.259230041000123],
              [34.24835085700005, 31.211448958000076],
            ],
            [
              [34.86195202416096, 22.68018196656721],
              [34.777558475202056, 22.499764840488073],
              [34.82822569600006, 22.606889822000085],
              [34.86195202416096, 22.68018196656721],
            ],
            [
              [34.682087686000045, 22.297912314000087],
              [34.422760280000034, 22.24920651900004],
              [34.14747560600006, 22.191855545000067],
              [34.3210751525644, 22.226294360913997],
              [34.50168369455366, 22.262123626906615],
              [34.682087686000045, 22.297912314000087],
            ],
          ],
          [
            [
              [33.955088738000086, 26.79002513200004],
              [33.97055097700007, 26.790676174000055],
              [33.970632358000046, 26.790635484000063],
              [33.975596550000034, 26.79002513200004],
              [33.99545332100007, 26.751695054000038],
              [34.002940300000034, 26.731634833000044],
              [34.00359134200005, 26.708197333000044],
              [33.98959394600007, 26.72028229400007],
              [33.982758009000065, 26.734076239000046],
              [33.955088738000086, 26.79002513200004],
            ],
          ],
          [
            [
              [34.006602410000085, 27.509466864000046],
              [34.02849368600005, 27.502020575000074],
              [34.03492272200009, 27.48501211100006],
              [34.03842207100007, 27.466620184000078],
              [34.05128014400009, 27.454820054000038],
              [34.05128014400009, 27.44863515800006],
              [34.04420006600009, 27.449611721000053],
              [34.03109785200007, 27.45148346600007],
              [34.01303144600007, 27.469956773000035],
              [34.00709069100009, 27.47606028900009],
              [33.98585045700008, 27.482123114000046],
              [33.97608483200008, 27.48737213700008],
              [33.96656334700009, 27.49762604400007],
              [33.95639082100007, 27.504380601000037],
              [33.95630944100009, 27.504380601000037],
              [33.93376712300005, 27.494696356000077],
              [33.924489780000044, 27.50141022300005],
              [33.91749108200008, 27.51316966400009],
              [33.91358483200008, 27.52374909100007],
              [33.91920006600009, 27.530218817000048],
              [33.925791863000086, 27.534328518000052],
              [33.93311608200008, 27.536363023000035],
              [33.941416863000086, 27.536769924000055],
              [33.96412194100009, 27.534125067000048],
              [33.97193444100009, 27.529649156000062],
              [33.98072350400008, 27.524603583000044],
              [33.98878014400009, 27.51825592700004],
              [33.99390709700009, 27.51430898600006],
              [34.006602410000085, 27.509466864000046],
            ],
          ],
          [
            [
              [34.58513431100005, 27.955145575000074],
              [34.58521569100009, 27.95506419500009],
              [34.60132897200009, 27.942613023000035],
              [34.62045332100007, 27.927801825000074],
              [34.62045332100007, 27.920355536000045],
              [34.58220462300005, 27.917914130000042],
              [34.547211134000065, 27.919663804000038],
              [34.51807701900009, 27.93040599200009],
              [34.49813886800007, 27.95311107000009],
              [34.49634850400008, 27.955145575000074],
              [34.49781334700009, 27.96873607000009],
              [34.49439537900008, 27.988226630000042],
              [34.48951256600009, 27.996039130000042],
              [34.49301191500007, 28.000799872000073],
              [34.49439537900008, 28.001776434000078],
              [34.494476759000065, 28.001654364000046],
              [34.49634850400008, 27.996039130000042],
              [34.496429884000065, 27.996201890000066],
              [34.500010613000086, 28.00381094000005],
              [34.504893425000034, 28.009914455000057],
              [34.510752800000034, 28.014146226000037],
              [34.51734459700009, 28.016546942000048],
              [34.51742597700007, 28.016506252000056],
              [34.53484134200005, 28.008246161000045],
              [34.54053795700008, 28.003119208000044],
              [34.54420006600009, 27.996039130000042],
              [34.518239780000044, 27.991359768000052],
              [34.506846550000034, 27.98623281500005],
              [34.50318444100009, 27.97557200700004],
              [34.50790449300007, 27.971177476000037],
              [34.51189212300005, 27.96747467700004],
              [34.52881920700008, 27.96588776200008],
              [34.55795332100007, 27.97016022300005],
              [34.57056725400008, 27.97410716400009],
              [34.57276451900009, 27.97215403900009],
              [34.574880405000044, 27.97211334800005],
              [34.57960045700008, 27.96552155200004],
              [34.583994988000086, 27.957953192000048],
              [34.58513431100005, 27.955145575000074],
            ],
          ],
          [
            [
              [32.978526238000086, 31.081691799000055],
              [32.97510826900009, 31.086493231000077],
              [32.969737175000034, 31.08657461100006],
              [32.97706139400009, 31.09125397300005],
              [32.983083530000044, 31.089911200000074],
              [32.986989780000044, 31.083644924000055],
              [32.989268425000034, 31.073431708000044],
              [32.978526238000086, 31.081691799000055],
            ],
          ],
          [
            [
              [33.375987175000034, 31.189520575000074],
              [33.40601647200009, 31.184475002000056],
              [33.43295332100007, 31.17206452000005],
              [33.47592207100007, 31.141750393000052],
              [33.45435631600009, 31.154689846000053],
              [33.29867597700007, 31.21279531500005],
              [33.26978600400008, 31.216782945000034],
              [33.301117384000065, 31.21588776200008],
              [33.352549675000034, 31.19489166900007],
              [33.375987175000034, 31.189520575000074],
            ],
          ],
          [
            [
              [33.07862389400009, 31.227118231000077],
              [33.10474694100009, 31.240301825000074],
              [33.262461785000085, 31.22361888200004],
              [33.25611412900008, 31.219305731000077],
              [33.24350019600007, 31.219305731000077],
              [33.21257571700005, 31.224310614000046],
              [33.18287194100009, 31.22801341400009],
              [33.153086785000085, 31.231756903000075],
              [33.11898847700007, 31.22361888200004],
              [33.102549675000034, 31.22675202000005],
              [33.07642662900008, 31.218736070000034],
              [32.95590254000007, 31.16315338700008],
              [32.93474368600005, 31.14793528900009],
              [32.94646243600005, 31.163275458000044],
              [32.969737175000034, 31.173041083000044],
              [32.98910566500007, 31.182074286000045],
              [33.00147545700008, 31.188299872000073],
              [33.01482181100005, 31.19672272300005],
              [33.06690514400009, 31.21743398600006],
              [33.07862389400009, 31.227118231000077],
            ],
          ],
          [
            [
              [34.73188201100004, 27.95714111400008],
              [34.732161965000046, 27.918943023000054],
              [34.70469477600005, 27.908368047000067],
              [34.68103940000009, 27.915173524000068],
              [34.66178576300007, 27.930218099000058],
              [34.68177332800008, 27.958703245000038],
              [34.73188201100004, 27.95714111400008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Mauritania',
        iso3: 'MRT',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-8.68238521299989, 27.285415751000116],
              [-8.484412800999905, 27.168988750000082],
              [-8.28644038999991, 27.052665100000084],
              [-8.088623006999882, 26.93623809900005],
              [-7.890753946999922, 26.819914449000024],
              [-7.692781534999909, 26.703487447],
              [-7.494912475999854, 26.587163798000077],
              [-7.297043415999894, 26.470736796000054],
              [-7.099122680999926, 26.354361471000047],
              [-6.901201944999855, 26.237934469000024],
              [-6.703332885999885, 26.121559144000074],
              [-6.505412149999898, 26.005183818000077],
              [-6.30749141499993, 25.88880849300004],
              [-6.139904743999892, 25.790209859000058],
              [-5.972266397999931, 25.691611226000063],
              [-5.804628051999885, 25.59296091800006],
              [-5.661524745999969, 25.508881108000097],
              [-5.636989704999849, 25.49446563700009],
              [-5.515963500999874, 25.423255514000047],
              [-5.34233068899988, 25.31618194600007],
              [-5.168749552999913, 25.209160055000083],
              [-4.995194254999973, 25.10208648700008],
              [-4.821613117999902, 24.99506459600009],
              [-5.043072468999867, 24.99490956600006],
              [-5.26445430499993, 24.994806213000047],
              [-5.485939493999894, 24.994702861000107],
              [-5.707321329999957, 24.994599508000093],
              [-5.928754841999933, 24.99444447900005],
              [-6.150188354999898, 24.99434112500002],
              [-6.371673542999872, 24.99423777300008],
              [-6.593107055999923, 24.994134420000066],
              [-6.583391885999902, 24.914423523],
              [-6.573780069999884, 24.83486765600007],
              [-6.564168252999877, 24.755234274000046],
              [-6.554453083999931, 24.675549215],
              [-6.544789591999916, 24.59599334700009],
              [-6.53517777499988, 24.516359965000035],
              [-6.525514281999961, 24.436726583],
              [-6.515850789999945, 24.35706736300007],
              [-6.50633795899995, 24.27596685500005],
              [-6.505670532999886, 24.270276795000072],
              [-6.498435831999899, 24.20836842800007],
              [-6.48257116699989, 24.072304383000088],
              [-6.466603148999866, 23.936240337000115],
              [-6.459420125999912, 23.874409485000015],
              [-6.445312459999883, 23.753719177000036],
              [-6.431204793999939, 23.633028870000132],
              [-6.417045450999893, 23.512338563000057],
              [-6.402937784999949, 23.39167409300005],
              [-6.388778442999921, 23.27095794700007],
              [-6.37472245299989, 23.150293477000062],
              [-6.371634199999903, 23.123981336],
              [-6.36056310999993, 23.02965484700009],
              [-6.346455443999901, 22.90896453900011],
              [-6.332296101999873, 22.788300070000034],
              [-6.318188435999929, 22.667661438000053],
              [-6.304132446999915, 22.546996969000062],
              [-6.289973103999955, 22.426280823000056],
              [-6.275865437999926, 22.305616354000065],
              [-6.261706095999898, 22.184951884000085],
              [-6.247598429999869, 22.064235738],
              [-6.233490763999924, 21.94357126900009],
              [-6.219383096999877, 21.822855123000082],
              [-6.205223754999849, 21.702242330000033],
              [-6.191116088999905, 21.581577861000042],
              [-6.177008422999961, 21.460861715000036],
              [-6.162900756999932, 21.340197246000045],
              [-6.148741413999886, 21.219532776000065],
              [-6.134633747999942, 21.098868307000075],
              [-6.12052608299993, 20.978203837000095],
              [-6.113704792999954, 20.919551087000073],
              [-6.098615274999872, 20.79072174100007],
              [-6.083577433999892, 20.661892395000066],
              [-6.076756143999944, 20.60334299700004],
              [-6.064095417999908, 20.49544260700013],
              [-6.049677693999882, 20.37048899300008],
              [-6.035363321999881, 20.245483704000023],
              [-6.020945597999884, 20.120530091000077],
              [-6.006579548999866, 19.995524801],
              [-5.992161823999936, 19.870597025000066],
              [-5.977847452999868, 19.745617574],
              [-5.963533080999866, 19.620612285000036],
              [-5.949115355999936, 19.495632833000073],
              [-5.949115355999936, 19.49552948000006],
              [-5.934025838999958, 19.357940980000066],
              [-5.927566283999909, 19.299546611],
              [-5.921210082999977, 19.241229757000056],
              [-5.914802205999933, 19.182887065],
              [-5.9083943279999, 19.124570211000062],
              [-5.898214070999927, 19.03178517700006],
              [-5.888033813999868, 18.939051819000056],
              [-5.877801879999879, 18.846318462000042],
              [-5.867673299999922, 18.753585104000067],
              [-5.857544717999872, 18.660800070000036],
              [-5.847364460999898, 18.56806671200006],
              [-5.837080850999911, 18.475333354000057],
              [-5.826952270999868, 18.382548320000055],
              [-5.816772013999895, 18.289892477000066],
              [-5.806540079999905, 18.197081604000047],
              [-5.796359822999932, 18.10437408500006],
              [-5.786179565999873, 18.011666565000084],
              [-5.776361042999923, 17.921439514000056],
              [-5.766387491999893, 17.831264140000044],
              [-5.756465616999918, 17.741037089000045],
              [-5.746647094999929, 17.650758362000104],
              [-5.736673543999927, 17.560582988000093],
              [-5.726803344999951, 17.470355937000093],
              [-5.71693314599986, 17.380180562000092],
              [-5.706959594999944, 17.289953512000082],
              [-5.697037719999855, 17.199726461000054],
              [-5.687167521999896, 17.109499410000055],
              [-5.677297322999891, 17.019324036000043],
              [-5.6673237709999, 16.929096985000044],
              [-5.657453571999895, 16.838818257000085],
              [-5.647583373999936, 16.7486428830001],
              [-5.637609822999906, 16.658364156000076],
              [-5.627687947999931, 16.568137106000066],
              [-5.623347126999931, 16.527829489000013],
              [-5.614562133999868, 16.511861471000074],
              [-5.605880493999905, 16.495893453000022],
              [-5.566503051999888, 16.469486797000044],
              [-5.529709431999891, 16.44499216700008],
              [-5.485371053999955, 16.41543324800007],
              [-5.445941934999922, 16.389026591000075],
              [-5.404962524999917, 16.361689758000054],
              [-5.364913288999929, 16.334921367000092],
              [-5.36010738199991, 16.329908752000037],
              [-5.355301472999912, 16.32479278600003],
              [-5.354267943999929, 16.318384908],
              [-5.353286091999877, 16.31197703100007],
              [-5.358918822999897, 16.2823664350001],
              [-5.377212279999867, 16.187798564000033],
              [-5.395454060999924, 16.09317901700011],
              [-5.41379919499991, 15.998559469],
              [-5.431989298999952, 15.903939922000077],
              [-5.450799519999862, 15.806839905000103],
              [-5.469558064999944, 15.709791565000032],
              [-5.488368285999883, 15.612665710000059],
              [-5.507075154999939, 15.515539857000064],
              [-5.508057006999906, 15.51065643400004],
              [-5.508761370999935, 15.506899828000073],
              [-5.508987182999874, 15.505695496000087],
              [-5.509917358999928, 15.500812073000063],
              [-5.510950886999893, 15.49590281200004],
              [-5.510950886999893, 15.495670268000069],
              [-5.510950886999893, 15.495437724000098],
              [-5.510950886999893, 15.495282695000057],
              [-5.510950886999893, 15.495075989],
              [-5.510950886999893, 15.49481760700003],
              [-5.510950886999893, 15.494662577000085],
              [-5.510950886999893, 15.494507549000033],
              [-5.510950886999893, 15.494300842000072],
              [-5.510950886999893, 15.494197489000058],
              [-5.511105916999952, 15.494042461000035],
              [-5.511260945999879, 15.493990784000104],
              [-5.511312621999906, 15.493887431000061],
              [-5.511364298999922, 15.493732401000031],
              [-5.511519327999849, 15.493680725000033],
              [-5.511622679999988, 15.493525696000077],
              [-5.511726033999906, 15.493422343000063],
              [-5.511932739999878, 15.493422343000063],
              [-5.512191120999944, 15.493422343000063],
              [-5.512294473999873, 15.493422343000063],
              [-5.512552855999928, 15.493422343000063],
              [-5.5127595619999, 15.493422343000063],
              [-5.512966267999957, 15.493422343000063],
              [-5.513121296999884, 15.493422343000063],
              [-5.513379679999957, 15.493422343000063],
              [-5.513741414999856, 15.493525696000077],
              [-5.514051472999938, 15.493629049],
              [-5.514361531999924, 15.493732401000031],
              [-5.514671589999921, 15.493835755000063],
              [-5.514981648999907, 15.493913269000089],
              [-5.515291707999893, 15.494042461000035],
              [-5.515601765999861, 15.49414581300006],
              [-5.515963500999874, 15.494249166000074],
              [-5.673163207999977, 15.494300842000072],
              [-5.807315226999918, 15.494352519000088],
              [-5.870257120999923, 15.494352519000088],
              [-5.938211629999898, 15.494352519000088],
              [-6.010817015999919, 15.494378357000116],
              [-6.087814900999945, 15.494455872000046],
              [-6.221605183999884, 15.494507549000033],
              [-6.320144864999889, 15.49454312300007],
              [-6.364748900999899, 15.49455922500006],
              [-6.516005818999872, 15.494610901000058],
              [-6.673928995999887, 15.494662577000085],
              [-6.837174844999936, 15.49474009300009],
              [-7.004503132999901, 15.49481760700003],
              [-7.174518595999899, 15.49481760700003],
              [-7.34587764499986, 15.494920960000044],
              [-7.517236693999934, 15.494972636000071],
              [-7.687200480999905, 15.495024313000087],
              [-7.854528767999881, 15.495075989],
              [-8.017826293999946, 15.495127665000027],
              [-8.175801146999959, 15.495205180000127],
              [-8.327006388999848, 15.495282695000057],
              [-8.470201781999947, 15.495282695000057],
              [-8.603940388999888, 15.495386048000071],
              [-8.68930985599988, 15.495437724000098],
              [-8.769253296999892, 15.495437724000098],
              [-8.843408976999854, 15.495437724000098],
              [-8.911156778999953, 15.495437724000098],
              [-9.003215638999933, 15.495526284000036],
              [-9.018592081999941, 15.495541076000038],
              [-9.141378708999923, 15.49558142700009],
              [-9.17584346599989, 15.495592753000054],
              [-9.349217895999885, 15.495644430000041],
              [-9.342965046999893, 15.586930847000062],
              [-9.32932246899989, 15.655247091000106],
              [-9.332423055999925, 15.6875707],
              [-9.35645259599994, 15.697854310000096],
              [-9.375934610999934, 15.68591705300004],
              [-9.437016153999934, 15.614887798000055],
              [-9.45169225999993, 15.588326111000029],
              [-9.451847289999876, 15.559206441000029],
              [-9.435879271999937, 15.49590281200004],
              [-9.423890339999957, 15.440531515000075],
              [-9.67211808299993, 15.430661316000098],
              [-9.720823120999853, 15.420920309000053],
              [-9.740718546999858, 15.412600403000084],
              [-9.797355916999948, 15.380302633000014],
              [-9.835596475999921, 15.371104228000107],
              [-9.951403360999905, 15.381206971000054],
              [-10.067623657999889, 15.364748026000086],
              [-10.108293009999926, 15.365884908000098],
              [-10.131599080999877, 15.372628683000116],
              [-10.16797928899993, 15.395185445000052],
              [-10.188391478999904, 15.404719747000044],
              [-10.19609126799989, 15.4052881880001],
              [-10.214488077999874, 15.401980896000097],
              [-10.223221394999939, 15.402032573000028],
              [-10.308745890999887, 15.435208842000023],
              [-10.322646850999973, 15.437095032000045],
              [-10.370757608999952, 15.433503520000059],
              [-10.398404500999959, 15.43869700100008],
              [-10.500413777999881, 15.440350647000045],
              [-10.515503295999878, 15.437740988000101],
              [-10.534985310999957, 15.4416942350001],
              [-10.551521768999862, 15.439162089000106],
              [-10.584746267999947, 15.428127152000016],
              [-10.587385213999909, 15.42725067200007],
              [-10.607125609999883, 15.424434306000094],
              [-10.64888016799992, 15.424873556000122],
              [-10.709186563999907, 15.433865255000072],
              [-10.725361286999885, 15.43306427000006],
              [-10.736368367999887, 15.422625630000113],
              [-10.740140747999902, 15.403582866000136],
              [-10.738900511999873, 15.362164205000084],
              [-10.746807006999916, 15.341131897000068],
              [-10.754506794999912, 15.333638815000128],
              [-10.770681517999918, 15.32467295300009],
              [-10.781740275999908, 15.308420716000086],
              [-10.790111856999886, 15.30684458500005],
              [-10.80018876099993, 15.30684458500005],
              [-10.811040811999874, 15.303123882000136],
              [-10.82721553499988, 15.287698466000052],
              [-10.834398559999926, 15.271394552000118],
              [-10.844062051999856, 15.234549255000019],
              [-10.855327514999914, 15.217651062000115],
              [-10.882250935999906, 15.192846375000073],
              [-10.890880899999956, 15.176749166],
              [-10.906228799999923, 15.119775900000036],
              [-10.915168822999874, 15.102903544000043],
              [-10.9480350339999, 15.151996155000077],
              [-10.985190388999882, 15.187497864000122],
              [-11.012733927999875, 15.239587708000073],
              [-11.04539343299993, 15.270205994],
              [-11.29819453999994, 15.451047669000033],
              [-11.316901407999922, 15.471666565000035],
              [-11.409557250999882, 15.602201233000088],
              [-11.434827025999965, 15.623388570000074],
              [-11.45823644999993, 15.632948710000065],
              [-11.515390583999931, 15.644420878000076],
              [-11.524382283999898, 15.643464864000023],
              [-11.527327840999902, 15.642560527000072],
              [-11.52562251799992, 15.638348897000029],
              [-11.522987019999903, 15.635248312000087],
              [-11.5195763749999, 15.632742005000111],
              [-11.515390583999931, 15.630261536000134],
              [-11.513116821999915, 15.625274760000067],
              [-11.51234167499993, 15.62018463200009],
              [-11.513116821999915, 15.615042826000078],
              [-11.515390583999931, 15.610081889000057],
              [-11.524278930999856, 15.600289205000095],
              [-11.53595780399985, 15.594914856000017],
              [-11.562571166999874, 15.587240906000133],
              [-11.579210978999896, 15.577964986000026],
              [-11.614867715999878, 15.541171367000018],
              [-11.64411657799991, 15.526443583000017],
              [-11.670833292999873, 15.528407288000054],
              [-11.69755000799995, 15.536804708000133],
              [-11.701739990999954, 15.537424767000104],
              [-11.727057250999877, 15.541171367000018],
              [-11.727057250999877, 15.50698740600005],
              [-11.729434366999897, 15.496057841000052],
              [-11.754859171999925, 15.469082744000033],
              [-11.767674926999888, 15.437198385000059],
              [-11.783487914999881, 15.365884908000098],
              [-11.816922566999978, 15.29609588700012],
              [-11.821056680999902, 15.28010203000008],
              [-11.826792765999869, 15.232559713000072],
              [-11.845654662999891, 15.179074606000128],
              [-11.848186807999866, 15.158145650000051],
              [-11.847308308999942, 15.148740539000087],
              [-11.844207723999887, 15.134839579000115],
              [-11.845137898999951, 15.124555969000113],
              [-11.856765096999908, 15.084248352000074],
              [-11.859142212999956, 15.054069316000067],
              [-11.860899210999918, 15.049005026000088],
              [-11.851029011999856, 15.041951192000084],
              [-11.844466104999867, 15.044328308000033],
              [-11.839195108999917, 15.049005026000088],
              [-11.8328389079999, 15.049005026000088],
              [-11.821160034999934, 15.03975494400008],
              [-11.813770304999906, 15.028541159000042],
              [-11.8110831299999, 15.01430430200007],
              [-11.81320186399995, 14.996088359000026],
              [-11.81320186399995, 14.995933329000081],
              [-11.820591593999978, 14.980275371000118],
              [-11.825810912999884, 14.962472839000085],
              [-11.830926879999879, 14.926428528000088],
              [-11.830100056999868, 14.92033070900004],
              [-11.82736120699991, 14.915576477000045],
              [-11.82043656399992, 14.906403910000051],
              [-11.820384887999921, 14.899970195],
              [-11.826069294999854, 14.896559550000077],
              [-11.833097289999955, 14.894699199000073],
              [-11.837076375999857, 14.893097229000134],
              [-11.840487019999983, 14.888498027000082],
              [-11.84560298699995, 14.883227031000061],
              [-11.850822305999884, 14.876483256000114],
              [-11.854698038999857, 14.867310690000124],
              [-11.862604532999882, 14.854081523000033],
              [-11.87748734499985, 14.841524150000026],
              [-11.895729125999878, 14.83206736300005],
              [-11.935985066999933, 14.823618266000054],
              [-11.950299438999906, 14.811551819000073],
              [-11.973967244999955, 14.779848328000071],
              [-11.991485554999912, 14.76804026300006],
              [-12.01107092299992, 14.76274342900011],
              [-12.031069702999957, 14.762820943000037],
              [-12.049673217999924, 14.76721344000012],
              [-12.057062947999924, 14.761942444000098],
              [-12.06233394399996, 14.746258647000047],
              [-12.07039546799993, 14.73439890600011],
              [-12.081454223999856, 14.740031637000044],
              [-12.12367386899993, 14.776644389000097],
              [-12.138866739999855, 14.784525045000038],
              [-12.160209105999854, 14.781011047000078],
              [-12.203255573999854, 14.766179912000055],
              [-12.2247788089999, 14.763441061],
              [-12.246792968999955, 14.767006734000077],
              [-12.2641304119999, 14.774939067000034],
              [-12.319579223999938, 14.817184550000022],
              [-12.382495279999944, 14.846019999000049],
              [-12.400091104999916, 14.860386047000048],
              [-12.433835815999885, 14.899427592000052],
              [-12.447633422999928, 14.90743743900012],
              [-12.448201863999913, 14.918211976000066],
              [-12.47150793399993, 14.998000387000047],
              [-12.476262165999913, 15.007741395000082],
              [-12.484892130999867, 15.01727569600007],
              [-12.495563313999867, 15.023011780000033],
              [-12.518972736999928, 15.028282776000069],
              [-12.529592244999918, 15.034354757000116],
              [-12.547058878999877, 15.047170512],
              [-12.60214595599993, 15.07877065000008],
              [-12.615065062999946, 15.094609477000091],
              [-12.622945719999876, 15.102257589000061],
              [-12.632273314999907, 15.105435689000032],
              [-12.64764705399989, 15.103161927000102],
              [-12.679273029999877, 15.093782654000066],
              [-12.689585456999879, 15.092478506000077],
              [-12.690305948999878, 15.092387390000084],
              [-12.717048502999944, 15.103420308000082],
              [-12.746639016999922, 15.1311359420001],
              [-12.754565591999949, 15.138560282000128],
              [-12.779757852999893, 15.146389262000056],
              [-12.78092057299989, 15.149076436000087],
              [-12.78399532099985, 15.158145650000051],
              [-12.784667113999916, 15.166026306000091],
              [-12.779266926999867, 15.19139943500008],
              [-12.779473632999895, 15.199615987000115],
              [-12.7819799399999, 15.207289937000013],
              [-12.787225096999919, 15.214162903000073],
              [-12.7963201499999, 15.220286560000133],
              [-12.806397053999916, 15.223077088000096],
              [-12.816964883999901, 15.223077088000096],
              [-12.838333088999889, 15.218762106000028],
              [-12.847893229999897, 15.218942973000068],
              [-12.856781575999918, 15.221991882000097],
              [-12.86548905399988, 15.228683980000113],
              [-12.888355875999906, 15.25087900800014],
              [-12.894376180999927, 15.263358866000132],
              [-12.884195922999965, 15.270826111000062],
              [-12.850037801999889, 15.267389629000121],
              [-12.833449666999883, 15.26999928800005],
              [-12.828049478999901, 15.28387441000011],
              [-12.83453487199995, 15.30023000100006],
              [-12.847273111999925, 15.3132783],
              [-12.906830199999916, 15.352681580000109],
              [-12.918974161999898, 15.365368144000058],
              [-12.927216552999937, 15.380741883000042],
              [-12.931014769999877, 15.397045797000061],
              [-12.931169799999935, 15.430532125000056],
              [-12.933055988999854, 15.438283590000069],
              [-12.937551839999855, 15.445776673000111],
              [-12.9476029059999, 15.458618266000101],
              [-12.9509101969999, 15.465413717000033],
              [-12.954940958999885, 15.49306060800005],
              [-12.95801570699993, 15.501742249000117],
              [-12.964320230999931, 15.50915781700003],
              [-12.980184895999855, 15.51628916500006],
              [-12.995842854999893, 15.514222107000094],
              [-13.010544799999906, 15.506289774000052],
              [-13.023773966999897, 15.495954489000027],
              [-13.038889322999893, 15.486885274000073],
              [-13.053229532999893, 15.485102438000084],
              [-13.083845013999849, 15.492750019000098],
              [-13.089583902999948, 15.497039693000133],
              [-13.093097900999908, 15.506212260000027],
              [-13.094958251999913, 15.514713033000035],
              [-13.095087442999954, 15.5234205120001],
              [-13.08945471199985, 15.561040955000024],
              [-13.091805989999955, 15.575122782000037],
              [-13.099014851999925, 15.586879171000035],
              [-13.109711873999942, 15.596413473000027],
              [-13.122217569999918, 15.603493143000051],
              [-13.145239419999882, 15.60953928700009],
              [-13.152551635999885, 15.612407329000078],
              [-13.171051798999912, 15.625352275000083],
              [-13.178234821999865, 15.628194479000072],
              [-13.192807576999911, 15.628969625000067],
              [-13.22280574499996, 15.623853658000073],
              [-13.237843586999958, 15.623440247000062],
              [-13.247300373999906, 15.648296611000134],
              [-13.248747314999918, 15.656719870000117],
              [-13.247662108999918, 15.665608216000024],
              [-13.243993082999907, 15.673721415000031],
              [-13.228877725999922, 15.696614075000056],
              [-13.227120727999932, 15.70395212800004],
              [-13.228257608999854, 15.711290182000042],
              [-13.232546752999923, 15.719610087000106],
              [-13.24394140599992, 15.73578481],
              [-13.250659342999938, 15.742761129000101],
              [-13.258669189999921, 15.748807272000036],
              [-13.27396541399986, 15.757488912],
              [-13.28096756999986, 15.762811585000051],
              [-13.28613521299988, 15.769632874000095],
              [-13.287452961999918, 15.778159485000018],
              [-13.285230875999929, 15.786634420000027],
              [-13.281897745999913, 15.795109355000122],
              [-13.279675658999906, 15.803532613000115],
              [-13.279959879999893, 15.822859599000068],
              [-13.284765787999902, 15.839912822000102],
              [-13.293654133999922, 15.855312399000084],
              [-13.311766723999938, 15.875776266000045],
              [-13.316030028999904, 15.881770732000078],
              [-13.318174601999885, 15.888488668],
              [-13.318174601999885, 15.896705221000033],
              [-13.314350544999854, 15.913603414000121],
              [-13.313730427999872, 15.922130026000033],
              [-13.315926675999947, 15.930449931000098],
              [-13.321766113999956, 15.938149719000094],
              [-13.34701004999991, 15.95675323500005],
              [-13.355795043999905, 15.965538229000018],
              [-13.36333980299986, 15.975098368000104],
              [-13.369773518999892, 15.98548533100005],
              [-13.383674478999865, 16.019178365000087],
              [-13.385043904999861, 16.0268781540001],
              [-13.386051594999913, 16.04439646400006],
              [-13.388557901999889, 16.052096253000045],
              [-13.394578206999938, 16.059279276],
              [-13.422095906999914, 16.07721099900006],
              [-13.427031005999936, 16.08305043500006],
              [-13.435066690999946, 16.096537985000012],
              [-13.4400276289999, 16.101860657000074],
              [-13.455091308999982, 16.10222239200006],
              [-13.491549031999881, 16.0884247850001],
              [-13.501703450999855, 16.095142721000045],
              [-13.499868936999945, 16.110645650000052],
              [-13.483099935999888, 16.141031392000016],
              [-13.484934447999876, 16.154984029],
              [-13.491549031999881, 16.156275940000043],
              [-13.497259276999927, 16.1560692340001],
              [-13.502788654999932, 16.15441558900004],
              [-13.516405395999925, 16.149041239000084],
              [-13.569063679999942, 16.138189188000027],
              [-13.59939774599988, 16.125476787000068],
              [-13.606968343999938, 16.12325470000009],
              [-13.610482340999909, 16.122892965000077],
              [-13.629266723999905, 16.122789612000062],
              [-13.635028645999881, 16.12160105400004],
              [-13.6624171549999, 16.107441711000078],
              [-13.668954222999986, 16.10573639000002],
              [-13.67593054199989, 16.106924947000053],
              [-13.67812678999988, 16.108216859],
              [-13.684689696999953, 16.113797913000028],
              [-13.687454386999917, 16.115244853000107],
              [-13.693578043999878, 16.117518616000027],
              [-13.696006835999924, 16.11891388],
              [-13.697298746999877, 16.1203608200001],
              [-13.698849039999914, 16.12392649400006],
              [-13.699960082999922, 16.125631816000023],
              [-13.704481770999848, 16.128835754000093],
              [-13.714842894999947, 16.132763163000064],
              [-13.719571289999948, 16.135605367000025],
              [-13.722775227999904, 16.14609568300007],
              [-13.718305709999925, 16.15928815200006],
              [-13.712620808999958, 16.176068013000034],
              [-13.710579589999895, 16.1888837690001],
              [-13.720139729999886, 16.18996897400011],
              [-13.729415649999908, 16.189503886000082],
              [-13.738226481999902, 16.187126770000035],
              [-13.746701416999912, 16.182372539000042],
              [-13.754246174999963, 16.175344544000026],
              [-13.77199702999988, 16.15043650300005],
              [-13.778818318999924, 16.143201803000082],
              [-13.794941365999904, 16.131212870000056],
              [-13.811322794999882, 16.122066142000065],
              [-13.819203449999918, 16.119275615],
              [-13.827316649999915, 16.118500469000097],
              [-13.835765746999897, 16.120567525000055],
              [-13.84483496199988, 16.126045227000034],
              [-13.852767292999914, 16.13348663400005],
              [-13.85907181899995, 16.142271627000056],
              [-13.863826049999943, 16.151831767000047],
              [-13.872275146999925, 16.178755189000057],
              [-13.877236083999975, 16.186868388000065],
              [-13.883824829999867, 16.19374135400004],
              [-13.899586140999958, 16.205316875000065],
              [-13.907828531999883, 16.21001943000006],
              [-13.947050943999955, 16.22112986300006],
              [-13.96407832899996, 16.230069886000095],
              [-13.967799031999988, 16.246037903000044],
              [-13.962683064999908, 16.263969625000115],
              [-13.963044799999892, 16.27239288300011],
              [-13.96743729699989, 16.281384583000047],
              [-13.977281656999963, 16.293838602000037],
              [-13.979322875999912, 16.300349833],
              [-13.977462523999918, 16.308824768000093],
              [-13.971157999999889, 16.324224345000076],
              [-13.971855631999887, 16.331200663000075],
              [-13.97785009799992, 16.33797027600012],
              [-13.987048501999908, 16.34287953700006],
              [-14.00671138599995, 16.35026926700006],
              [-14.01559973199997, 16.35585032200008],
              [-14.033066364999911, 16.37605580700007],
              [-14.039835977999957, 16.38210195],
              [-14.073038085999883, 16.40065378900006],
              [-14.132440144999919, 16.452640280000068],
              [-14.166391560999926, 16.49088083900007],
              [-14.190085204999889, 16.507107239000064],
              [-14.197190713999902, 16.51346344000011],
              [-14.21416642199992, 16.534960836000053],
              [-14.222279622999935, 16.539611715000106],
              [-14.233674275999931, 16.54157541900004],
              [-14.257652140999937, 16.543177389000064],
              [-14.268064941999882, 16.54787994400006],
              [-14.273258422999959, 16.55563140900007],
              [-14.27457617199994, 16.573511454000098],
              [-14.277960977999953, 16.581262919000025],
              [-14.287650308999986, 16.58570709300004],
              [-14.325968383999907, 16.582399801000022],
              [-14.335321818999944, 16.586482239000034],
              [-14.337027139999918, 16.594130351000032],
              [-14.331756143999883, 16.613147278000085],
              [-14.331342732999872, 16.62410268200007],
              [-14.335528523999898, 16.63154408800007],
              [-14.343254149999893, 16.636660055000064],
              [-14.406635294999916, 16.660792948000037],
              [-14.426246500999952, 16.659604391000116],
              [-14.435832478999941, 16.655987041000017],
              [-14.462058267999879, 16.640794169000102],
              [-14.471954304999969, 16.636401672000105],
              [-14.482392944999901, 16.633662821000073],
              [-14.4930899659999, 16.632474264000038],
              [-14.50391617799994, 16.632680969000077],
              [-14.544456338999879, 16.640845846],
              [-14.555127522999953, 16.640587464000035],
              [-14.597011271999946, 16.62916697200005],
              [-14.608070027999958, 16.628805237000037],
              [-14.619077107999942, 16.63066558900006],
              [-14.647189086999958, 16.64353302000005],
              [-14.655974080999954, 16.645910136000097],
              [-14.665895954999968, 16.6456517540001],
              [-14.699692341999935, 16.637125143],
              [-14.711216185999973, 16.635781556000026],
              [-14.882006794999882, 16.64766713400006],
              [-14.912495890999963, 16.64063914000006],
              [-14.930944375999957, 16.643377991000094],
              [-14.941331339999891, 16.656038717000044],
              [-14.948934022999936, 16.670552930000056],
              [-14.949857950999927, 16.672316793000064],
              [-14.962932088999878, 16.685804342000026],
              [-14.97430090399996, 16.691385397000047],
              [-14.996625121999926, 16.68244537400001],
              [-15.006908731999914, 16.67583079000012],
              [-15.013368285999974, 16.666580709000087],
              [-15.016520547999932, 16.6525763960001],
              [-15.018742634999938, 16.64611684200004],
              [-15.023651895999876, 16.63996734700008],
              [-15.029853068999955, 16.63547149700004],
              [-15.036932739999884, 16.632577617000052],
              [-15.04437414599991, 16.631905823000082],
              [-15.051557169999853, 16.634179586000087],
              [-15.061995808999882, 16.643791403000094],
              [-15.069850626999909, 16.65526357000003],
              [-15.07889400299996, 16.664978739000063],
              [-15.0933117269999, 16.66916453],
              [-15.107574421999885, 16.66539215100009],
              [-15.116256062999923, 16.655521953000104],
              [-15.118271443999959, 16.64260284400008],
              [-15.112328653999953, 16.629218649000066],
              [-15.096153930999947, 16.61397410100001],
              [-15.092846638999958, 16.6076179],
              [-15.093208373999857, 16.600176494000053],
              [-15.097497517999926, 16.594492086000017],
              [-15.104008748999888, 16.590357971000103],
              [-15.125092732999917, 16.582709859000104],
              [-15.232476358999918, 16.566380107000086],
              [-15.248599405999897, 16.565811666000016],
              [-15.295935017999852, 16.57304636700009],
              [-15.328026082999969, 16.571961161],
              [-15.343632364999905, 16.568705546],
              [-15.385748656999851, 16.551755677000088],
              [-15.399804646999968, 16.548345032000086],
              [-15.41453243099997, 16.54803497400009],
              [-15.426883096999916, 16.553150941000084],
              [-15.433704386999892, 16.562504375000017],
              [-15.439440469999852, 16.572684632000076],
              [-15.448845580999887, 16.580177714000044],
              [-15.4639867759999, 16.581469625000082],
              [-15.478507853999957, 16.575165100000063],
              [-15.49091019699992, 16.564519755000063],
              [-15.515198119999923, 16.53093007400004],
              [-15.52480993699993, 16.52219675700006],
              [-15.536695515999952, 16.516512350000127],
              [-15.55147497599998, 16.515117086000046],
              [-15.594418090999852, 16.523643698000072],
              [-15.60966263799989, 16.52131825800005],
              [-15.621496541999903, 16.514238587000094],
              [-15.643614054999915, 16.494653219],
              [-15.657411661999959, 16.486178284000076],
              [-15.672191120999884, 16.481372376000067],
              [-15.687539021999953, 16.480545553000056],
              [-15.703196980999905, 16.48442128600003],
              [-15.726813110999927, 16.495273336000068],
              [-15.735288044999919, 16.497702128000114],
              [-15.767740844999935, 16.499459127000094],
              [-15.812957722999926, 16.513773499000095],
              [-15.828925740999864, 16.514548645],
              [-15.85357539899988, 16.51025950100002],
              [-15.861998656999958, 16.51025950100002],
              [-15.89693192599995, 16.518424378000063],
              [-15.911039590999877, 16.516874084000037],
              [-15.950675415999854, 16.499820862000078],
              [-15.958065144999864, 16.4984255990001],
              [-15.964369669999968, 16.498994039000067],
              [-15.977288777999973, 16.503954977000106],
              [-15.985608683999942, 16.50586700500004],
              [-15.993101765999882, 16.504626770000087],
              [-16.000181437999885, 16.501061096000043],
              [-16.007312784999925, 16.496151836000095],
              [-16.031187295999928, 16.492896220000105],
              [-16.053769897999956, 16.49542836500011],
              [-16.074027058999945, 16.504885153000075],
              [-16.09097692899988, 16.52219675700006],
              [-16.10306921399996, 16.539560039],
              [-16.11045894399996, 16.546949768],
              [-16.11965734899985, 16.55237579300008],
              [-16.132266397999985, 16.554752909000015],
              [-16.144307006999952, 16.552685853000057],
              [-16.15577917499988, 16.547518209000046],
              [-16.18518306499996, 16.527312724000055],
              [-16.195363321999935, 16.522713522000018],
              [-16.20673213799992, 16.520749817000066],
              [-16.217945922999945, 16.52152496300009],
              [-16.25101883999986, 16.52762278200005],
              [-16.27380814599985, 16.523178610000045],
              [-16.295098836999927, 16.510621237000024],
              [-16.313547322999852, 16.493309632000106],
              [-16.327396606999912, 16.474551087000023],
              [-16.33494136499985, 16.455792542000026],
              [-16.340160684999972, 16.415898336000097],
              [-16.381088419999884, 16.246658020000027],
              [-16.385377563999953, 16.234927470000017],
              [-16.391682087999868, 16.224747213000043],
              [-16.407288370999908, 16.214825338000068],
              [-16.44418534399992, 16.206298727000032],
              [-16.45875809799989, 16.19415476500005],
              [-16.465992797999945, 16.174052633000073],
              [-16.470436970999884, 16.106356507000086],
              [-16.487800251999886, 16.066048890000033],
              [-16.50159785999992, 16.02186553900013],
              [-16.50754064899985, 16.01039337200011],
              [-16.509917764999898, 15.901511129000127],
              [-16.51973628799996, 15.846372376000048],
              [-16.542347785999937, 15.80882396000004],
              [-16.527333136999914, 15.977362372000073],
              [-16.529286261999914, 16.06582265800006],
              [-16.539214647999927, 16.267238674000055],
              [-16.529286261999914, 16.33270905200004],
              [-16.522206183999913, 16.350531317000048],
              [-16.494496222999942, 16.401597398000092],
              [-16.486154751999948, 16.451727606000077],
              [-16.477691209999932, 16.466498114000046],
              [-16.467152472999942, 16.49286530200004],
              [-16.467193162999934, 16.60024648600006],
              [-16.45921790299991, 16.64394765800006],
              [-16.37913977799991, 16.841009833000044],
              [-16.357818162999934, 16.874660549000055],
              [-16.343088344999956, 16.942287502000056],
              [-16.325998501999948, 16.97524648600006],
              [-16.278065558999913, 17.040716864000046],
              [-16.192534959999932, 17.219305731000077],
              [-16.186675584999932, 17.243841864000046],
              [-16.172596808999913, 17.26235586100006],
              [-16.078968878999945, 17.54482656500005],
              [-16.048980272999927, 17.667181708000044],
              [-16.041411912999934, 17.799994208000044],
              [-16.024159308999913, 17.960150458000044],
              [-16.035227016999954, 18.141424872000073],
              [-16.06940670499995, 18.484035549000055],
              [-16.080555792999917, 18.51972077000005],
              [-16.131988084999932, 18.628648179000038],
              [-16.15566972599993, 18.752508856000077],
              [-16.17296301999994, 18.793117580000057],
              [-16.16397050699993, 18.816839911000045],
              [-16.16559811099995, 18.844183661000045],
              [-16.20457923099991, 18.98273346600007],
              [-16.21035722599993, 18.995876369000086],
              [-16.23892167899993, 19.061021226000037],
              [-16.28278561099995, 19.13043854400007],
              [-16.341867641999954, 19.195746161000045],
              [-16.360707160999937, 19.21246979400007],
              [-16.36473548099991, 19.214585679000038],
              [-16.36827551999994, 19.221502997000073],
              [-16.376576300999943, 19.223578192000048],
              [-16.386463995999918, 19.22459544500009],
              [-16.394886847999942, 19.22850169500009],
              [-16.411854620999918, 19.23924388200004],
              [-16.450917120999918, 19.25018952000005],
              [-16.467193162999934, 19.25926341400009],
              [-16.474598761999914, 19.270819403000075],
              [-16.49128170499995, 19.313055731000077],
              [-16.494496222999942, 19.330959377000056],
              [-16.504750128999945, 19.350002346000053],
              [-16.52407792899993, 19.36591217700004],
              [-16.53547115799995, 19.380804755000042],
              [-16.521839972999942, 19.396429755000042],
              [-16.463734503999945, 19.38153717700004],
              [-16.40778561099995, 19.389227606000077],
              [-16.359201626999948, 19.415838934000078],
              [-16.32323157499991, 19.457912502000056],
              [-16.299549933999913, 19.496649481000077],
              [-16.293853318999936, 19.516099351000037],
              [-16.284901495999918, 19.52928294500009],
              [-16.282826300999943, 19.536078192000048],
              [-16.285878058999913, 19.542710679000038],
              [-16.29255123599995, 19.546576239000046],
              [-16.29914303299995, 19.547023830000057],
              [-16.302113410999937, 19.54319896000004],
              [-16.30728105399993, 19.54360586100006],
              [-16.362904425999943, 19.48582591400009],
              [-16.391468878999945, 19.464056708000044],
              [-16.350493943999936, 19.546616929000038],
              [-16.36465410099993, 19.53925202000005],
              [-16.405181443999936, 19.507147528000075],
              [-16.41942298099991, 19.492010809000078],
              [-16.426258917999917, 19.482489325000074],
              [-16.432240363999938, 19.47138092700004],
              [-16.434193488999938, 19.459540106000077],
              [-16.429351365999935, 19.44794342700004],
              [-16.428944464999915, 19.44171784100007],
              [-16.437489386999914, 19.422796942000048],
              [-16.439930792999917, 19.413234768000052],
              [-16.44245357999995, 19.41034577000005],
              [-16.44835364499994, 19.408636786000045],
              [-16.455067511999914, 19.408270575000074],
              [-16.46035722599993, 19.409491278000075],
              [-16.46507727799991, 19.412543036000045],
              [-16.465728318999936, 19.414496161000045],
              [-16.465402798999946, 19.417303778000075],
              [-16.467193162999934, 19.423163153000075],
              [-16.468861456999946, 19.43121979400007],
              [-16.468495245999918, 19.45571523600006],
              [-16.467193162999934, 19.464056708000044],
              [-16.457753058999913, 19.479681708000044],
              [-16.431630011999914, 19.505926825000074],
              [-16.426258917999917, 19.52301666900007],
              [-16.42251542899993, 19.543850002000056],
              [-16.412831183999913, 19.55418528900009],
              [-16.39948482999995, 19.561753648000035],
              [-16.38463294199994, 19.573919989000046],
              [-16.289133266999954, 19.71112702000005],
              [-16.28311113199993, 19.71637604400007],
              [-16.27635657499991, 19.720445054000038],
              [-16.270822719999956, 19.725897528000075],
              [-16.26862545499995, 19.73533763200004],
              [-16.267404751999948, 19.75527578300006],
              [-16.264271613999938, 19.762844143000052],
              [-16.257964647999927, 19.765692450000074],
              [-16.256011522999927, 19.76951732000009],
              [-16.238433397999927, 19.787665106000077],
              [-16.23379472599993, 19.79364655200004],
              [-16.23350989499994, 19.804348049000055],
              [-16.235951300999943, 19.813299872000073],
              [-16.240956183999913, 19.82099030200004],
              [-16.248036261999914, 19.827826239000046],
              [-16.240223761999914, 19.834458726000037],
              [-16.235178188999953, 19.84243398600006],
              [-16.23306230399993, 19.851629950000074],
              [-16.23379472599993, 19.86196523600006],
              [-16.249623175999943, 19.853461005000042],
              [-16.25487219999991, 19.84829336100006],
              [-16.257801886999914, 19.864162502000056],
              [-16.243478969999956, 19.888739325000074],
              [-16.248036261999914, 19.902899481000077],
              [-16.266509568999936, 19.913723049000055],
              [-16.27916419199994, 19.905218817000048],
              [-16.28652910099993, 19.890448309000078],
              [-16.289133266999954, 19.882473049000055],
              [-16.305572068999936, 19.87303294500009],
              [-16.31273352799991, 19.87763092700004],
              [-16.313303188999953, 19.88971588700008],
              [-16.30955969999991, 19.902899481000077],
              [-16.304025844999956, 19.914007880000042],
              [-16.29796301999994, 19.92251211100006],
              [-16.239084438999953, 19.97919342700004],
              [-16.222482876999948, 20.003566799000055],
              [-16.21397864499994, 20.033270575000074],
              [-16.218373175999943, 20.057928778000075],
              [-16.248605923999946, 20.10846588700008],
              [-16.26113847599993, 20.135687567000048],
              [-16.253244594999956, 20.135158596000053],
              [-16.246083136999914, 20.13572825700004],
              [-16.239613410999937, 20.13812897300005],
              [-16.23379472599993, 20.143133856000077],
              [-16.211659308999913, 20.175604559000078],
              [-16.203114386999914, 20.19550202000005],
              [-16.199696417999917, 20.21515534100007],
              [-16.20225989499994, 20.233303127000056],
              [-16.208973761999914, 20.24835846600007],
              [-16.237619594999956, 20.289984442000048],
              [-16.24372311099995, 20.293117580000057],
              [-16.257964647999927, 20.29393138200004],
              [-16.26748613199993, 20.29824453300006],
              [-16.27212480399993, 20.30760325700004],
              [-16.275135870999918, 20.31704336100006],
              [-16.27916419199994, 20.321234442000048],
              [-16.295074022999927, 20.330552476000037],
              [-16.32323157499991, 20.39638906500005],
              [-16.332427537999934, 20.405462958000044],
              [-16.34121660099993, 20.411322333000044],
              [-16.34788977799991, 20.41754791900007],
              [-16.350493943999936, 20.427435614000046],
              [-16.347727016999954, 20.430853583000044],
              [-16.34203040299991, 20.432806708000044],
              [-16.338002081999946, 20.435492255000042],
              [-16.339955206999946, 20.441066799000055],
              [-16.34276282499991, 20.445135809000078],
              [-16.349232550999943, 20.457424221000053],
              [-16.353505011999914, 20.476385809000078],
              [-16.391184048999946, 20.569484768000052],
              [-16.40103105399993, 20.583238023000035],
              [-16.415679490999935, 20.588771877000056],
              [-16.423898891999954, 20.601263739000046],
              [-16.42520097599993, 20.626125393000052],
              [-16.42955481699994, 20.644232489000046],
              [-16.44668535099993, 20.636542059000078],
              [-16.467193162999934, 20.649603583000044],
              [-16.467193162999934, 20.657049872000073],
              [-16.421945766999954, 20.669134833000044],
              [-16.408680792999917, 20.675034898000035],
              [-16.429351365999935, 20.677557684000078],
              [-16.464670376999948, 20.671942450000074],
              [-16.480824347999942, 20.675116278000075],
              [-16.494496222999942, 20.691148179000038],
              [-16.487049933999913, 20.69798411700009],
              [-16.501332160999937, 20.72597890800006],
              [-16.50804602799991, 20.730617580000057],
              [-16.529286261999914, 20.73895905200004],
              [-16.536284959999932, 20.695379950000074],
              [-16.52843176999994, 20.59861888200004],
              [-16.542347785999937, 20.56085846600007],
              [-16.552479620999918, 20.57640208500004],
              [-16.56550045499995, 20.58734772300005],
              [-16.590728318999936, 20.602443752000056],
              [-16.598988410999937, 20.611070054000038],
              [-16.611805792999917, 20.634466864000046],
              [-16.621164516999954, 20.64647044500009],
              [-16.633656378999945, 20.65497467700004],
              [-16.66502844999991, 20.67055898600006],
              [-16.672678188999953, 20.677557684000078],
              [-16.673451300999943, 20.68895091400009],
              [-16.668690558999913, 20.69367096600007],
              [-16.66234290299991, 20.695379950000074],
              [-16.659006313999953, 20.69798411700009],
              [-16.65929114499994, 20.70652903900009],
              [-16.66502844999991, 20.71474844000005],
              [-16.666411912999934, 20.72215403900009],
              [-16.671131964999915, 20.737127997000073],
              [-16.682525193999936, 20.749212958000044],
              [-16.710194464999915, 20.770005601000037],
              [-16.71397864499994, 20.77765534100007],
              [-16.713693813999953, 20.796210028000075],
              [-16.717355923999946, 20.80414459800005],
              [-16.734120245999918, 20.821519273000035],
              [-16.745432094999956, 20.86859772300005],
              [-16.75153561099995, 20.87986888200004],
              [-16.76203365799995, 20.89203522300005],
              [-16.76895097599993, 20.906805731000077],
              [-16.773101365999935, 20.92255280200004],
              [-16.775054490999935, 20.937648830000057],
              [-16.779408331999946, 20.932806708000044],
              [-16.785755988999938, 20.92796458500004],
              [-16.788685675999943, 20.923976955000057],
              [-16.803212042999917, 20.937445380000042],
              [-16.808990037999934, 20.95258209800005],
              [-16.81163489499994, 20.968898830000057],
              [-16.81663977799991, 20.986029364000046],
              [-16.822987433999913, 20.99315013200004],
              [-16.832142706999946, 21.000148830000057],
              [-16.840402798999946, 21.009507554000038],
              [-16.84398352799991, 21.023871161000045],
              [-16.849354620999918, 21.033636786000045],
              [-16.87328040299991, 21.06464264500005],
              [-16.878732876999948, 21.078517971000053],
              [-16.88076738199993, 21.092596747000073],
              [-16.88581295499995, 21.108587958000044],
              [-16.898548956999946, 21.136867580000057],
              [-16.917591925999943, 21.15916575700004],
              [-16.93122311099995, 21.151516018000052],
              [-16.95726477799991, 21.105861721000053],
              [-17.000070766999954, 21.05097077000005],
              [-17.010121222999942, 21.04295482000009],
              [-17.01585852799991, 21.03123607000009],
              [-17.008412238999938, 21.013373114000046],
              [-16.99718176999994, 21.018500067000048],
              [-16.99596106699994, 21.00141022300005],
              [-17.00226803299995, 20.964911200000074],
              [-17.004383917999917, 20.932440497000073],
              [-17.008412238999938, 20.923976955000057],
              [-17.018055792999917, 20.917914130000042],
              [-17.04124915299991, 20.911363023000035],
              [-17.049427863999938, 20.903509833000044],
              [-17.050119594999956, 20.89476146000004],
              [-17.045521613999938, 20.887193101000037],
              [-17.035755988999938, 20.876776434000078],
              [-17.028553839999915, 20.86082591400009],
              [-17.027902798999946, 20.85423411700009],
              [-17.028920050999943, 20.84202708500004],
              [-17.038441535999937, 20.79979075700004],
              [-17.046945766999954, 20.777818101000037],
              [-17.05687415299991, 20.766913153000075],
              [-17.0811748859999, 20.874747620000093],
              [-17.077428344999902, 20.904513245000075],
              [-17.054018920999937, 20.9954637660001],
              [-17.047378499999922, 21.027399801000072],
              [-17.004926309999888, 21.141914775000075],
              [-16.985702677999967, 21.237826233000035],
              [-16.968339395999863, 21.324590963000034],
              [-16.958830932999973, 21.332859192000072],
              [-16.84281734299995, 21.332859192000072],
              [-16.801424519999898, 21.332859192000072],
              [-16.684635782999862, 21.33291086800007],
              [-16.503148152999955, 21.33291086800007],
              [-16.26771032699989, 21.33291086800007],
              [-15.98901932799987, 21.333014222000102],
              [-15.678082234999891, 21.3330658980001],
              [-15.345544392999926, 21.3330658980001],
              [-15.002257853999936, 21.333169251000058],
              [-14.658971312999881, 21.333169251000058],
              [-14.32648514899995, 21.333220927000056],
              [-14.295597564999923, 21.33322605900004],
              [-14.015496378999927, 21.333272603000083],
              [-13.736908731999932, 21.3333242800001],
              [-13.501419229999954, 21.333375956000012],
              [-13.31985408599985, 21.333375956000012],
              [-13.203091186999899, 21.333375956000012],
              [-13.161724202999949, 21.333427633000028],
              [-13.015247354999872, 21.333427633000028],
              [-13.026176920999944, 21.495329896],
              [-13.032092883999951, 21.581939241],
              [-13.060335041999906, 21.995402731000084],
              [-13.076832743499864, 22.24543914850007],
              [-13.093330444999879, 22.495475566000053],
              [-13.106352904999909, 22.560226135000036],
              [-13.15498042799993, 22.68879709900007],
              [-13.16549658199989, 22.752695008000032],
              [-13.152293253999915, 22.82000356000013],
              [-13.119892130999915, 22.88353973400008],
              [-13.034341796999854, 22.995212504000037],
              [-13.015247354999872, 23.018001811000133],
              [-12.915098428999954, 23.082054749000022],
              [-12.789938109999866, 23.16186899800003],
              [-12.68221858699988, 23.23075368300003],
              [-12.619431721999916, 23.27082875600003],
              [-12.558376017999933, 23.29028493300011],
              [-12.389910847999943, 23.31253163700005],
              [-12.353892374999873, 23.32247935000005],
              [-12.1345775959999, 23.419346822000065],
              [-12.032723347999905, 23.444978333000037],
              [-12.019339151999873, 23.460998027000088],
              [-12.015308389999888, 23.495181986000077],
              [-12.015308389999888, 23.575926412000015],
              [-12.015308389999888, 23.651477356000058],
              [-12.015308389999888, 23.727105815000087],
              [-12.015308389999888, 23.80273427400006],
              [-12.015308389999888, 23.878311056000072],
              [-12.015308389999888, 23.953939514000027],
              [-12.015308389999888, 24.029542135000057],
              [-12.015308389999888, 24.1050930790001],
              [-12.015308389999888, 24.180695699000054],
              [-12.015308389999888, 24.256298319000066],
              [-12.015308389999888, 24.33190094100003],
              [-12.015308389999888, 24.407477722000053],
              [-12.015308389999888, 24.483080343],
              [-12.015308389999888, 24.558631287000125],
              [-12.015308389999888, 24.63425974600007],
              [-12.015308389999888, 24.709862366000024],
              [-12.015308389999888, 24.785464986000065],
              [-12.015308389999888, 24.861015931000097],
              [-12.015308389999888, 24.936618551000024],
              [-12.015308389999888, 25.012247009000063],
              [-12.015308389999888, 25.08779795400001],
              [-12.015308389999888, 25.163323060000025],
              [-12.015308389999888, 25.238925680000065],
              [-12.015308389999888, 25.314579977000037],
              [-12.015308389999888, 25.390182597000077],
              [-12.015308389999888, 25.46573354100009],
              [-12.015308389999888, 25.541336162000036],
              [-12.015308389999888, 25.616938782000076],
              [-12.015308389999888, 25.69248972600009],
              [-12.015308389999888, 25.768092347000035],
              [-12.015308389999888, 25.843694967000076],
              [-12.015308389999888, 25.9192459100001],
              [-12.015308389999888, 25.99490020800006],
              [-11.914591023999918, 25.994951884000088],
              [-11.813821980999933, 25.994951884000088],
              [-11.713207966999903, 25.994951884000088],
              [-11.612438923999918, 25.994951884000088],
              [-11.511721557999863, 25.994951884000088],
              [-11.410952514999877, 25.994951884000088],
              [-11.310235147999919, 25.994951884000088],
              [-11.20951778199995, 25.994951884000088],
              [-11.108748738999878, 25.994951884000088],
              [-11.008083047999918, 25.994951884000088],
              [-10.907314005999922, 25.994951884000088],
              [-10.806596639999952, 25.994951884000088],
              [-10.705879272999908, 25.994951884000088],
              [-10.605161905999921, 25.994951884000088],
              [-10.504444539999952, 25.994951884000088],
              [-10.403675496999881, 25.994951884000088],
              [-10.302958129999922, 25.994951884000088],
              [-10.202292439999951, 25.994951884000088],
              [-10.10152339699988, 25.994951884000088],
              [-10.000806030999911, 25.994951884000088],
              [-9.90003698699985, 25.994951884000088],
              [-9.799371297999897, 25.994951884000088],
              [-9.698653930999939, 25.994951884000088],
              [-9.597884887999953, 25.994951884000088],
              [-9.49716752099988, 25.994951884000088],
              [-9.396450154999911, 25.994951884000088],
              [-9.295732787999953, 25.994951884000088],
              [-9.195015421999898, 25.994951884000088],
              [-9.094246378999912, 25.994951884000088],
              [-8.993580688999941, 25.994951884000088],
              [-8.892863321999897, 25.994951884000088],
              [-8.792042602999885, 25.99500356],
              [-8.707215738999935, 25.99500356],
              [-8.687656208999925, 26.000016175000056],
              [-8.680809081999882, 26.013141989000033],
              [-8.680809081999882, 26.058410543000022],
              [-8.68086075799988, 26.072208150000066],
              [-8.68086075799988, 26.111120504000056],
              [-8.680938272999896, 26.1716336060001],
              [-8.681041625999853, 26.25018178300003],
              [-8.681144978999953, 26.34299265600005],
              [-8.681300008999898, 26.446603902],
              [-8.681455036999864, 26.557449850000026],
              [-8.681558389999879, 26.671913147000012],
              [-8.681661742999893, 26.786324768],
              [-8.681816772999952, 26.89717071500003],
              [-8.681920124999891, 27.00083363800009],
              [-8.682075154999922, 27.093696188000123],
              [-8.682230183999962, 27.17214101200004],
              [-8.682230183999962, 27.232705790000082],
              [-8.682281860999865, 27.27166982100009],
              [-8.68238521299989, 27.285415751000116],
            ],
          ],
          [
            [
              [-16.377797003999945, 19.81354401200008],
              [-16.35838782499991, 19.853176174000055],
              [-16.34593665299991, 19.868353583000044],
              [-16.336822068999936, 19.85569896000004],
              [-16.36705481699994, 19.721096096000053],
              [-16.392323370999918, 19.658351955000057],
              [-16.432484503999945, 19.601263739000046],
              [-16.449696417999917, 19.622788804000038],
              [-16.452951626999948, 19.62921784100007],
              [-16.452748175999943, 19.637274481000077],
              [-16.45030676999994, 19.64647044500009],
              [-16.45018469999991, 19.65648021000004],
              [-16.456654425999943, 19.66673411700009],
              [-16.46397864499994, 19.68463776200008],
              [-16.457142706999946, 19.70335521000004],
              [-16.428334113999938, 19.744614976000037],
              [-16.426258917999917, 19.748968817000048],
              [-16.427398240999935, 19.77798086100006],
              [-16.426258917999917, 19.786851304000038],
              [-16.41820227799991, 19.805609442000048],
              [-16.40538489499994, 19.821112372000073],
              [-16.39093990799995, 19.826117255000042],
              [-16.377797003999945, 19.81354401200008],
            ],
          ],
          [
            [
              [-16.320912238999938, 19.72850169500009],
              [-16.30955969999991, 19.73078034100007],
              [-16.301625128999945, 19.722601630000042],
              [-16.313384568999936, 19.70465729400007],
              [-16.329823370999918, 19.689927476000037],
              [-16.342193162999934, 19.67641836100006],
              [-16.358713344999956, 19.64789459800005],
              [-16.394520636999914, 19.59992096600007],
              [-16.397694464999915, 19.59992096600007],
              [-16.392730272999927, 19.617132880000042],
              [-16.358550584999932, 19.677435614000046],
              [-16.320912238999938, 19.72850169500009],
            ],
          ],
          [
            [
              [-16.477162238999938, 19.73151276200008],
              [-16.469593878999945, 19.72996653900009],
              [-16.46898352799991, 19.71971263200004],
              [-16.471547003999945, 19.699652411000045],
              [-16.477894660999937, 19.68553294500009],
              [-16.48424231699994, 19.67772044500009],
              [-16.491851365999935, 19.684068101000037],
              [-16.496896938999953, 19.705511786000045],
              [-16.491118943999936, 19.725083726000037],
              [-16.477162238999938, 19.73151276200008],
            ],
          ],
          [
            [
              [-16.45929928299995, 20.61469147300005],
              [-16.45067298099991, 20.612534898000035],
              [-16.44640051999994, 20.60732656500005],
              [-16.448109503999945, 20.57453034100007],
              [-16.45417232999995, 20.571112372000073],
              [-16.467274542999917, 20.576239325000074],
              [-16.474232550999943, 20.594183661000045],
              [-16.469105597999942, 20.609076239000046],
              [-16.45929928299995, 20.61469147300005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Eq. Guinea',
        iso3: 'GNQ',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [9.799571159000067, 2.341742255000042],
              [9.811059611000104, 2.324872132000067],
              [9.811886434000115, 2.306165263000082],
              [9.808682495000141, 2.285494690000064],
              [9.810852905000047, 2.264875794000062],
              [9.823668660000124, 2.249011129000053],
              [9.846819702000118, 2.228547262000092],
              [9.872141154000076, 2.211235657000088],
              [9.890124552000088, 2.204569397000071],
              [9.90748783400008, 2.200486959000074],
              [9.970739786000081, 2.168912659000085],
              [9.990996948000088, 2.165605367000083],
              [10.12556237800004, 2.165605367000083],
              [10.189982611000062, 2.165616497000116],
              [10.409685690000117, 2.165654455000066],
              [10.424665568000108, 2.165657043000095],
              [10.72376875800009, 2.165657043000095],
              [11.022975301000088, 2.165708720000026],
              [11.322078491000042, 2.165760396000039],
              [11.32972660300004, 2.127442322000121],
              [11.33014001500004, 2.047137146000097],
              [11.331690308000049, 1.785085958000096],
              [11.332000870000087, 1.732611267000095],
              [11.333240600000067, 1.523138123000123],
              [11.334790894000093, 1.261164449000134],
              [11.33634118700013, 0.99916493700006],
              [11.036824584000044, 1.000198466000128],
              [10.96383408100013, 1.000425223000065],
              [10.737411336000093, 1.001128642000097],
              [10.438101440000054, 1.00216217100008],
              [10.41504549800004, 1.002233773000043],
              [10.138584838000071, 1.003092347000035],
              [10.029444214000137, 1.003505758000045],
              [10.000383932000148, 0.999742112000121],
              [9.980765015000088, 0.997201233000027],
              [9.975494018000063, 0.982576803000057],
              [9.975390665000134, 0.952966207000102],
              [9.971773315000064, 0.93984039300004],
              [9.959991088000066, 0.928368226000117],
              [9.94407474700003, 0.924854228000072],
              [9.926298055000103, 0.927541402000102],
              [9.908624715000087, 0.935086161000058],
              [9.892088257000097, 0.947901917000124],
              [9.866146688000072, 0.977564189000091],
              [9.849610230000081, 0.989243062000071],
              [9.834107300000142, 0.994927470000107],
              [9.804371181110866, 0.998353939898678],
              [9.805918816000087, 1.003607489000046],
              [9.804535352000073, 1.020738023000092],
              [9.796885613000086, 1.046291408000059],
              [9.799082879000082, 1.058172919000071],
              [9.806813998000052, 1.064398505000042],
              [9.819834832000083, 1.068915106000077],
              [9.834727410000085, 1.071600653000075],
              [9.847504102000073, 1.072455145000049],
              [9.84148196700005, 1.077704169000071],
              [9.829274936000047, 1.081854559000078],
              [9.814789259000065, 1.084540106000077],
              [9.80250084700009, 1.085516669000071],
              [9.792246941000087, 1.088690497000073],
              [9.76726321700005, 1.102850653000075],
              [9.755137566000087, 1.105943101000094],
              [9.714121941000087, 1.09711334800005],
              [9.703461134000065, 1.099798895000049],
              [9.699392123000052, 1.109808661000045],
              [9.703786655000044, 1.120591539000088],
              [9.711599155000044, 1.129339911000045],
              [9.717784050000091, 1.133286851000094],
              [9.699229363000086, 1.125474351000094],
              [9.676442905000044, 1.105414130000042],
              [9.657074415000068, 1.083197333000044],
              [9.648936394000089, 1.068752346000053],
              [9.642100457000083, 1.061590887000079],
              [9.60914147200009, 1.05345286700009],
              [9.584320509000065, 1.042954820000091],
              [9.575368686000047, 1.054754950000074],
              [9.559743686000047, 1.102769273000092],
              [9.551605665000068, 1.115423895000049],
              [9.54078209700009, 1.125067450000074],
              [9.52475019600007, 1.133286851000094],
              [9.506521030000044, 1.137600002000056],
              [9.49350019600007, 1.134588934000078],
              [9.48178144600007, 1.129299221000053],
              [9.449961785000085, 1.123277085000041],
              [9.420420769000089, 1.109198309000078],
              [9.405284050000091, 1.105943101000094],
              [9.396494988000086, 1.111476955000057],
              [9.373057488000086, 1.137681382000039],
              [9.360199415000068, 1.146958726000094],
              [9.362152540000068, 1.15696849200009],
              [9.359629754000082, 1.164862372000073],
              [9.346690300000091, 1.181708075000074],
              [9.362315300000091, 1.18813711100006],
              [9.374034050000091, 1.199896552000041],
              [9.38249759200005, 1.214504299000055],
              [9.398773634000065, 1.265692450000074],
              [9.40756269600007, 1.28384023600006],
              [9.418955925000091, 1.291571356000077],
              [9.434255405000044, 1.299750067000048],
              [9.448252800000091, 1.31907786700009],
              [9.458994988000086, 1.341742255000042],
              [9.464040561000047, 1.359849351000094],
              [9.461436394000089, 1.398138739000046],
              [9.465342644000089, 1.414536851000094],
              [9.492849155000044, 1.426581122000073],
              [9.532237175000091, 1.462307033000059],
              [9.549571160000085, 1.484808661000045],
              [9.552744988000086, 1.486476955000057],
              [9.554942254000082, 1.491848049000055],
              [9.559580925000091, 1.49673086100006],
              [9.56421959700009, 1.503404039000088],
              [9.566416863000086, 1.514064846000053],
              [9.578135613000086, 1.542669989000046],
              [9.594248894000089, 1.572170315000051],
              [9.614756707000083, 1.588039455000057],
              [9.627777540000068, 1.583726304000038],
              [9.64031009200005, 1.571966864000046],
              [9.659190300000091, 1.565334377000056],
              [9.685883009000065, 1.568833726000094],
              [9.70476321700005, 1.577704169000071],
              [9.722178582000083, 1.589016018000052],
              [9.744476759000065, 1.600043036000045],
              [9.72429446700005, 1.599025783000059],
              [9.683441602000073, 1.571356512000079],
              [9.66570071700005, 1.575588283000059],
              [9.622325066000087, 1.616766669000071],
              [9.607269727000073, 1.644435940000051],
              [9.617523634000065, 1.671454169000071],
              [9.676280144000089, 1.729722398000092],
              [9.678965691000087, 1.733465887000079],
              [9.684825066000087, 1.744614976000094],
              [9.689789259000065, 1.750230210000041],
              [9.71029707100007, 1.763902085000041],
              [9.71810957100007, 1.77179596600007],
              [9.72242272200009, 1.778876044000071],
              [9.730967644000089, 1.798732815000051],
              [9.735199415000068, 1.804836330000057],
              [9.739756707000083, 1.809027411000045],
              [9.743011915000068, 1.815741278000075],
              [9.746755405000044, 1.839911200000074],
              [9.75131269600007, 1.846584377000056],
              [9.756032748000052, 1.851467190000051],
              [9.758148634000065, 1.856675523000092],
              [9.763682488000086, 1.866115627000056],
              [9.799082879000082, 1.90110911700009],
              [9.809743686000047, 1.934963283000059],
              [9.805837436000047, 1.976385809000078],
              [9.778086785000085, 2.058091539000088],
              [9.768565300000091, 2.076849677000041],
              [9.765472852000073, 2.08539459800005],
              [9.764414910000085, 2.09634023600006],
              [9.766612175000091, 2.10687897300005],
              [9.77125084700009, 2.11359284100007],
              [9.775889519000089, 2.11859772300005],
              [9.778086785000085, 2.123968817000048],
              [9.786387566000087, 2.248114325000074],
              [9.783457879000082, 2.270656643000052],
              [9.774912957000083, 2.288072007000039],
              [9.76693769600007, 2.310492255000042],
              [9.779795769000089, 2.327866929000038],
              [9.799571159000067, 2.341742255000042],
            ],
          ],
          [
            [
              [5.626231316000087, -1.456231377999927],
              [5.619965040000068, -1.44459400799991],
              [5.618662957000083, -1.433038018999923],
              [5.62281334700009, -1.422946872999944],
              [5.633067254000082, -1.415785414999959],
              [5.64625084700009, -1.438409112999921],
              [5.642751498000052, -1.462823174999926],
              [5.628916863000086, -1.475681247999944],
              [5.611989780000044, -1.463636976999908],
              [5.617035352000073, -1.462090752999927],
              [5.621348504000082, -1.45826588299991],
              [5.626231316000087, -1.456231377999927],
            ],
          ],
          [
            [
              [8.922699415000068, 3.75071849200009],
              [8.949229363000086, 3.717922268000052],
              [8.959157748000052, 3.700832424000055],
              [8.963145379000082, 3.679673570000091],
              [8.961599155000044, 3.66046784100007],
              [8.957530144000089, 3.643011786000045],
              [8.951182488000086, 3.627427476000094],
              [8.94312584700009, 3.614203192000048],
              [8.906993035000085, 3.582098700000074],
              [8.896739129000082, 3.554429429000038],
              [8.863536004000082, 3.515122789000088],
              [8.86068769600007, 3.511786200000074],
              [8.840668165000068, 3.458075262000079],
              [8.823415561000047, 3.444403387000079],
              [8.818695509000065, 3.420884507000039],
              [8.815928582000083, 3.415513414000088],
              [8.813649936000047, 3.412176825000074],
              [8.78492272200009, 3.395086981000077],
              [8.781423373000052, 3.378973700000074],
              [8.78093509200005, 3.332912502000056],
              [8.774668816000087, 3.316555080000057],
              [8.729746941000087, 3.264797268000052],
              [8.695485873000052, 3.208563544000071],
              [8.686208530000044, 3.197333075000074],
              [8.676605665000068, 3.203802802000041],
              [8.65365644600007, 3.213568427000041],
              [8.648448113000086, 3.220038153000075],
              [8.642100457000083, 3.217352606000077],
              [8.627614780000044, 3.222601630000042],
              [8.599864129000082, 3.238023179000038],
              [8.592621290000068, 3.235541083000044],
              [8.56967207100007, 3.230414130000042],
              [8.559580925000091, 3.230617580000057],
              [8.548838738000086, 3.235296942000048],
              [8.527679884000065, 3.248846747000073],
              [8.514659050000091, 3.251695054000038],
              [8.493174675000091, 3.252427476000094],
              [8.469411655000044, 3.257961330000057],
              [8.450205925000091, 3.272935289000088],
              [8.442230665000068, 3.302313544000071],
              [8.437673373000052, 3.31313711100006],
              [8.428558790000068, 3.326239325000074],
              [8.422048373000052, 3.33930084800005],
              [8.425303582000083, 3.350409247000073],
              [8.429209832000083, 3.359605210000041],
              [8.435394727000073, 3.401922919000071],
              [8.442149285000085, 3.42133209800005],
              [8.455251498000052, 3.446519273000092],
              [8.473887566000087, 3.463080145000049],
              [8.497569207000083, 3.456529039000088],
              [8.510264519000089, 3.463812567000048],
              [8.52711022200009, 3.463039455000057],
              [8.562754754000082, 3.456529039000088],
              [8.579600457000083, 3.463324286000045],
              [8.585134311000047, 3.479315497000073],
              [8.582286004000082, 3.497748114000046],
              [8.573252800000091, 3.511786200000074],
              [8.58570397200009, 3.518459377000056],
              [8.601410352000073, 3.529730536000045],
              [8.615244988000086, 3.543117580000057],
              [8.621104363000086, 3.555853583000044],
              [8.627940300000091, 3.648342190000051],
              [8.640961134000065, 3.683539130000042],
              [8.667165561000047, 3.726263739000046],
              [8.702403191000087, 3.760931708000044],
              [8.743418816000087, 3.772406317000048],
              [8.741221550000091, 3.768622137000079],
              [8.737152540000068, 3.758205471000053],
              [8.768239780000044, 3.751695054000038],
              [8.781911655000044, 3.750962632000039],
              [8.791758660000085, 3.758205471000053],
              [8.814300977000073, 3.751288153000075],
              [8.846690300000091, 3.74640534100007],
              [8.88062584700009, 3.747300523000092],
              [8.908457879000082, 3.758205471000053],
              [8.91146894600007, 3.753810940000051],
              [8.914561394000089, 3.752142645000049],
              [8.922699415000068, 3.75071849200009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Gambia',
        iso3: 'GMB',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-16.753651495999918, 13.065008856000077],
            [-16.768869594999956, 13.077826239000046],
            [-16.784331834999932, 13.08299388200004],
            [-16.786732550999943, 13.09007396000004],
            [-16.782541469999956, 13.098334052000041],
            [-16.775502081999946, 13.11273834800005],
            [-16.777333136999914, 13.127834377000056],
            [-16.79674231699994, 13.177232164000088],
            [-16.797474738999938, 13.189113674000055],
            [-16.795033331999946, 13.235907294000071],
            [-16.797352667999917, 13.248928127000056],
            [-16.80296790299991, 13.262193101000037],
            [-16.820057745999918, 13.281317450000074],
            [-16.82445227799991, 13.294582424000055],
            [-16.81663977799991, 13.310614325000074],
            [-16.820301886999914, 13.315822658000059],
            [-16.829701300999943, 13.33852773600006],
            [-16.820708787999934, 13.349107164000088],
            [-16.80996660099993, 13.37986888200004],
            [-16.799549933999913, 13.386297919000071],
            [-16.78734290299991, 13.389146226000037],
            [-16.774322068999936, 13.396185614000046],
            [-16.762928839999915, 13.404974677000041],
            [-16.704457160999937, 13.475409247000073],
            [-16.67882239499994, 13.496161200000074],
            [-16.67674719999991, 13.485907294000071],
            [-16.671131964999915, 13.478664455000057],
            [-16.662505662999934, 13.473130601000037],
            [-16.65225175699993, 13.468247789000088],
            [-16.63463294199994, 13.477362372000073],
            [-16.616851365999935, 13.478176174000055],
            [-16.601389126999948, 13.472235419000071],
            [-16.590728318999936, 13.461371161000045],
            [-16.585316535999937, 13.44334544500009],
            [-16.596302863999938, 13.440252997000073],
            [-16.61278235599991, 13.439154364000046],
            [-16.624256964999915, 13.427232164000088],
            [-16.608713344999956, 13.413723049000055],
            [-16.595529751999948, 13.38507721600007],
            [-16.588368292999917, 13.355292059000078],
            [-16.590728318999936, 13.33852773600006],
            [-16.553863084999932, 13.295803127000056],
            [-16.545765753999945, 13.29010651200008],
            [-16.49518795499995, 13.287909247000073],
            [-16.480824347999942, 13.283880927000041],
            [-16.46776282499991, 13.275864976000037],
            [-16.45995032499991, 13.268866278000075],
            [-16.449696417999917, 13.264064846000053],
            [-16.429351365999935, 13.262193101000037],
            [-16.419667120999918, 13.255560614000046],
            [-16.41392981699994, 13.239976304000038],
            [-16.41348222599993, 13.222072658000059],
            [-16.41942298099991, 13.208197333000044],
            [-16.399769660999937, 13.224310614000046],
            [-16.39085852799991, 13.224798895000049],
            [-16.377797003999945, 13.215033270000049],
            [-16.383656378999945, 13.225165106000077],
            [-16.40192623599995, 13.243353583000044],
            [-16.40575110599991, 13.246039130000042],
            [-16.408273891999954, 13.258734442000048],
            [-16.415272589999915, 13.26703522300005],
            [-16.42601477799991, 13.270738023000092],
            [-16.439930792999917, 13.269598700000074],
            [-16.439930792999917, 13.27643463700008],
            [-16.410511847999942, 13.275864976000037],
            [-16.39679928299995, 13.277899481000077],
            [-16.38463294199994, 13.283880927000041],
            [-16.374745245999918, 13.263861395000049],
            [-16.363270636999914, 13.26829661700009],
            [-16.349680141999954, 13.282171942000048],
            [-16.33340410099993, 13.29010651200008],
            [-16.314808722999942, 13.29555898600006],
            [-16.277943488999938, 13.319484768000052],
            [-16.257964647999927, 13.324896552000041],
            [-16.230132615999935, 13.31639232000009],
            [-16.225900844999956, 13.296576239000046],
            [-16.230213995999918, 13.273627020000049],
            [-16.22760982999995, 13.256008205000057],
            [-16.209706183999913, 13.251166083000044],
            [-16.18545488199993, 13.258286851000037],
            [-16.151275193999936, 13.27643463700008],
            [-16.151275193999936, 13.283880927000041],
            [-16.162261522999927, 13.282700914000088],
            [-16.17251542899993, 13.27928294500009],
            [-16.181752081999946, 13.27374909100007],
            [-16.189808722999942, 13.26593659100007],
            [-16.199289516999954, 13.259100653000075],
            [-16.203521287999934, 13.264960028000075],
            [-16.20807857999995, 13.292385158000059],
            [-16.208607550999943, 13.303534247000073],
            [-16.210764126999948, 13.313299872000073],
            [-16.21703040299991, 13.31736888200004],
            [-16.222035285999937, 13.31976959800005],
            [-16.22524980399993, 13.325832424000055],
            [-16.227121548999946, 13.333685614000046],
            [-16.22760982999995, 13.341945705000057],
            [-16.224436001999948, 13.360296942000048],
            [-16.21621660099993, 13.372748114000046],
            [-16.176177537999934, 13.405422268000052],
            [-16.168690558999913, 13.413316148000092],
            [-16.16551673099991, 13.42381419500009],
            [-16.16120357999995, 13.42869700700004],
            [-16.15143795499995, 13.426947333000044],
            [-16.135121222999942, 13.420477606000077],
            [-15.994862433999913, 13.413031317000048],
            [-15.94131425699993, 13.425441799000055],
            [-15.922230597999942, 13.427232164000088],
            [-15.911284959999932, 13.426703192000048],
            [-15.905629035999937, 13.42576732000009],
            [-15.90062415299991, 13.425523179000038],
            [-15.891224738999938, 13.427232164000088],
            [-15.883778449999909, 13.43040599200009],
            [-15.878407355999911, 13.434800523000092],
            [-15.874379035999937, 13.438869533000059],
            [-15.87132727799991, 13.440904039000088],
            [-15.84951738199993, 13.442206122000073],
            [-15.78502356699994, 13.434759833000044],
            [-15.764475063999953, 13.436916408000059],
            [-15.706206834999932, 13.454575914000088],
            [-15.696766730999911, 13.459865627000056],
            [-15.67804928299995, 13.473049221000053],
            [-15.668690558999913, 13.475734768000052],
            [-15.658924933999913, 13.472398179000038],
            [-15.644683397999927, 13.457912502000056],
            [-15.634917772999927, 13.454575914000088],
            [-15.620838995999918, 13.454820054000038],
            [-15.610422329999949, 13.456447658000059],
            [-15.600900844999956, 13.460435289000088],
            [-15.589588995999918, 13.468247789000088],
            [-15.580922003999945, 13.478176174000055],
            [-15.565052863999938, 13.502508856000077],
            [-15.555409308999913, 13.50922272300005],
            [-15.543446417999917, 13.50967031500005],
            [-15.530995245999918, 13.50584544500009],
            [-15.519642706999946, 13.499660549000055],
            [-15.510731574999909, 13.492743231000077],
            [-15.500396287999934, 13.48818594000005],
            [-15.489654100999928, 13.489935614000046],
            [-15.479359503999945, 13.493963934000078],
            [-15.470041469999956, 13.496161200000074],
            [-15.45107988199993, 13.490912177000041],
            [-15.438872850999928, 13.478583075000074],
            [-15.429432745999918, 13.46474844000005],
            [-15.418853318999936, 13.454575914000088],
            [-15.384429490999935, 13.443508205000057],
            [-15.340565558999913, 13.440822658000059],
            [-15.304798956999946, 13.45530833500004],
            [-15.294748501999948, 13.496161200000074],
            [-15.299956834999932, 13.496161200000074],
            [-15.301909959999932, 13.496161200000074],
            [-15.302154100999928, 13.496161200000074],
            [-15.304066535999937, 13.481146552000041],
            [-15.311390753999945, 13.46784088700008],
            [-15.321848110999952, 13.458238023000092],
            [-15.332875128999945, 13.454575914000088],
            [-15.351673956999946, 13.456732489000046],
            [-15.385975714999915, 13.466131903000075],
            [-15.40147864499994, 13.468247789000088],
            [-15.415760870999918, 13.473211981000077],
            [-15.432240363999938, 13.484767971000053],
            [-15.456450975999928, 13.50608958500004],
            [-15.465240037999934, 13.510158596000053],
            [-15.474110480999911, 13.50853099200009],
            [-15.482818162999934, 13.505031643000052],
            [-15.490834113999938, 13.50299713700008],
            [-15.49986731699994, 13.505113023000092],
            [-15.507557745999918, 13.509833075000074],
            [-15.51357988199993, 13.514553127000056],
            [-15.51789303299995, 13.51666901200008],
            [-15.531727667999917, 13.51976146000004],
            [-15.543039516999954, 13.525539455000057],
            [-15.556141730999911, 13.52830638200004],
            [-15.575835740999935, 13.52289459800005],
            [-15.586008266999954, 13.515041408000059],
            [-15.60069739499994, 13.495510158000059],
            [-15.610666469999956, 13.48932526200008],
            [-15.627756313999953, 13.48851146000004],
            [-15.654652472999942, 13.50096263200004],
            [-15.67210852799991, 13.50299713700008],
            [-15.690174933999913, 13.498968817000048],
            [-15.734201626999948, 13.475734768000052],
            [-15.769886847999942, 13.46507396000004],
            [-16.090240037999934, 13.44049713700008],
            [-16.121896938999953, 13.451605536000045],
            [-16.14159094999991, 13.454575914000088],
            [-16.16038977799991, 13.450588283000059],
            [-16.178456183999913, 13.440985419000071],
            [-16.20653235599991, 13.420477606000077],
            [-16.248443162999934, 13.378973700000074],
            [-16.257964647999927, 13.372015692000048],
            [-16.265614386999914, 13.368719794000071],
            [-16.27301998599995, 13.362616278000075],
            [-16.280588344999956, 13.359767971000053],
            [-16.289133266999954, 13.36587148600006],
            [-16.28970292899993, 13.373236395000049],
            [-16.286732550999943, 13.383612372000073],
            [-16.284901495999918, 13.395331122000073],
            [-16.289133266999954, 13.406805731000077],
            [-16.306019660999937, 13.39166901200008],
            [-16.30809485599991, 13.383368231000077],
            [-16.302113410999937, 13.372015692000048],
            [-16.312123175999943, 13.366929429000038],
            [-16.316395636999914, 13.36587148600006],
            [-16.316395636999914, 13.359035549000055],
            [-16.31163489499994, 13.357611395000049],
            [-16.306996222999942, 13.35455963700008],
            [-16.302113410999937, 13.352769273000092],
            [-16.321888800999943, 13.34284088700008],
            [-16.355946417999917, 13.337958075000074],
            [-16.39053300699993, 13.336859442000048],
            [-16.41197669199994, 13.33852773600006],
            [-16.489491339999915, 13.357123114000046],
            [-16.521839972999942, 13.359035549000055],
            [-16.515777147999927, 13.367865302000041],
            [-16.503529425999943, 13.39256419500009],
            [-16.501332160999937, 13.40306224200009],
            [-16.503529425999943, 13.416937567000048],
            [-16.513417120999918, 13.436753648000092],
            [-16.515695766999954, 13.44432200700004],
            [-16.51976477799991, 13.451320705000057],
            [-16.53819739499994, 13.46482982000009],
            [-16.54450436099995, 13.475897528000075],
            [-16.554432745999918, 13.481838283000059],
            [-16.55654863199993, 13.485581773000092],
            [-16.55654863199993, 13.50608958500004],
            [-16.548003709999932, 13.548081773000092],
            [-16.54914303299995, 13.563869533000059],
            [-16.554798956999946, 13.577053127000056],
            [-16.56139916999996, 13.586914159000045],
            [-16.498755655999958, 13.586665345000071],
            [-16.43664058499988, 13.586458639000114],
            [-16.37457718999991, 13.58620025700013],
            [-16.312462117999928, 13.585993551000087],
            [-16.250295369999947, 13.585735169000117],
            [-16.188231973999905, 13.58552846300006],
            [-16.12611690299991, 13.58527008100009],
            [-16.085382943999946, 13.585168331000105],
            [-16.06405350799986, 13.585115052000049],
            [-16.001938435999875, 13.584908345000088],
            [-15.93977168799998, 13.584649964000022],
            [-15.877708292999927, 13.584443258000064],
            [-15.815593221999848, 13.584184876000094],
            [-15.753426473999951, 13.583978170000137],
            [-15.691363077999881, 13.583719788000067],
            [-15.6291963299999, 13.58351308200011],
            [-15.567132934999847, 13.58325470000004],
            [-15.518195353999943, 13.583099670000095],
            [-15.502485717999974, 13.588267314000106],
            [-15.50047033699991, 13.62798065200009],
            [-15.4980300899999, 13.641522305000095],
            [-15.496801310999928, 13.648341166000122],
            [-15.488946491999883, 13.67032948900001],
            [-15.478611206999886, 13.691258444000084],
            [-15.46750077299987, 13.708285828000015],
            [-15.43633988499991, 13.741177877000055],
            [-15.394068562999905, 13.771511943000093],
            [-15.347766479999933, 13.788642680000052],
            [-15.304461628999945, 13.781873067000106],
            [-15.295108194999926, 13.773191427000143],
            [-15.275729532999947, 13.748050842000026],
            [-15.267254597999852, 13.741797995000113],
            [-15.24596390799988, 13.746733094000064],
            [-15.170619669999894, 13.793784485000046],
            [-15.097704223999898, 13.81998443600007],
            [-15.076310180999883, 13.818950908000076],
            [-15.016778930999891, 13.79688507100009],
            [-14.915803181999962, 13.79244089800008],
            [-14.879267944999924, 13.780581156000054],
            [-14.86031381199993, 13.765595458000035],
            [-14.843972940999947, 13.75267588300008],
            [-14.831312214999912, 13.735622660000047],
            [-14.822372192999893, 13.717200012000134],
            [-14.802941853999897, 13.65232025200001],
            [-14.796017211999924, 13.644697978000039],
            [-14.754934448999848, 13.620384217000037],
            [-14.740930134999957, 13.615449117000082],
            [-14.728579467999907, 13.61932485000004],
            [-14.66718786699991, 13.652888692000062],
            [-14.626673542999896, 13.663508199000134],
            [-14.585539102999917, 13.66045929000012],
            [-14.54259598799996, 13.640822246000084],
            [-14.523243163999894, 13.625655213000059],
            [-14.509729777999922, 13.60909291700007],
            [-14.50022131399993, 13.58997263600007],
            [-14.486862955999925, 13.546538595000072],
            [-14.480377562999962, 13.533128561000112],
            [-14.470274820999919, 13.522354025000098],
            [-14.462134595999885, 13.516656128000093],
            [-14.3895820729999, 13.465871684000135],
            [-14.365552530999963, 13.454838766000051],
            [-14.347284912999896, 13.452358297000075],
            [-14.329947468999876, 13.456440735000086],
            [-14.271217203999925, 13.47695627800006],
            [-14.215794229999858, 13.510752665000041],
            [-14.196828979999907, 13.518788350000122],
            [-14.13913224299992, 13.531552429000087],
            [-14.092881835999975, 13.554729309000095],
            [-14.072598836999958, 13.559690247000049],
            [-14.061850138999944, 13.560051982000047],
            [-14.044461018999925, 13.558605042000053],
            [-14.034022379999982, 13.560207011000074],
            [-14.022265990999898, 13.565322978000069],
            [-14.001905476999951, 13.577027690000051],
            [-13.98849544299992, 13.579146423000026],
            [-13.967488972999888, 13.575580750000057],
            [-13.942090006999905, 13.566924948000107],
            [-13.918086303999871, 13.554987691000065],
            [-13.901343139999938, 13.541629333000031],
            [-13.896175495999927, 13.532921855000069],
            [-13.889793456999882, 13.513956604000015],
            [-13.884599975999976, 13.505533346000036],
            [-13.882503706999898, 13.503781507000028],
            [-13.87547908499991, 13.49791107200005],
            [-13.852793131999931, 13.484811096000087],
            [-13.842690388999898, 13.476646220000077],
            [-13.818712524999881, 13.42936228400012],
            [-13.822562418999922, 13.378202617000028],
            [-13.851036132999866, 13.335750428000097],
            [-13.900567992999925, 13.314563090000135],
            [-13.976118936999853, 13.308206889000104],
            [-14.016271524999866, 13.297639059000048],
            [-14.056579141999919, 13.297173971000106],
            [-14.099496419999866, 13.281955261000078],
            [-14.116808024999955, 13.282161968000125],
            [-14.131794189999937, 13.275573222000048],
            [-14.1798274329999, 13.240123190000105],
            [-14.201686564999932, 13.229555359000045],
            [-14.230625366999902, 13.228573507000078],
            [-14.284911457999954, 13.23854705800008],
            [-14.3417813719999, 13.233637797000142],
            [-14.368833984999952, 13.235704855000108],
            [-14.39498225999995, 13.242965393000077],
            [-14.431439981999858, 13.261439718000105],
            [-14.442033650999946, 13.268545227000033],
            [-14.451490437999894, 13.276865132000097],
            [-14.459138549999892, 13.286916199000117],
            [-14.470326496999917, 13.298259176000016],
            [-14.483633178999924, 13.301928203000102],
            [-14.515104125999898, 13.30316843700004],
            [-14.529573526999911, 13.307276713000064],
            [-14.542854370999919, 13.314666443000064],
            [-14.552109139999885, 13.323094217000076],
            [-14.580733195999926, 13.349160462000043],
            [-14.592153686999922, 13.353139547000112],
            [-14.624554809999921, 13.345181376000056],
            [-14.661606811999889, 13.34091807100009],
            [-14.698142048999927, 13.345181376000056],
            [-14.73157670099991, 13.359004822000102],
            [-14.759481973999897, 13.383370260000035],
            [-14.779635782999947, 13.41088796000011],
            [-14.790332803999974, 13.41734751400007],
            [-14.810796670999935, 13.421171570000098],
            [-14.82914180499992, 13.42701100700009],
            [-14.862576456999903, 13.44706146300004],
            [-14.877614297999884, 13.451376445000108],
            [-14.915906534999891, 13.454425354000136],
            [-14.949702921999886, 13.463081156000086],
            [-15.015073607999938, 13.49574066200006],
            [-15.015228637999883, 13.495844014000085],
            [-15.01543534399994, 13.49599904400013],
            [-15.01559037299998, 13.496050721000046],
            [-15.065251423999968, 13.531268209000118],
            [-15.110158243999877, 13.572480163000108],
            [-15.137650105999853, 13.58997263600007],
            [-15.160491088999947, 13.580980937000035],
            [-15.181331441999873, 13.559843218000083],
            [-15.203950967999958, 13.536900940000052],
            [-15.217955281999963, 13.5146800750001],
            [-15.221727660999875, 13.452823385000102],
            [-15.227773803999924, 13.425176493000095],
            [-15.248341023999927, 13.39897654200007],
            [-15.277073120999916, 13.380295513000092],
            [-15.309835978999928, 13.368435770000076],
            [-15.342392130999968, 13.362570496000075],
            [-15.379237426999879, 13.362518820000062],
            [-15.488326375999918, 13.385256450000043],
            [-15.519538940999894, 13.386600037000107],
            [-15.542948364999859, 13.37799591100007],
            [-15.566047729999923, 13.36567108200012],
            [-15.596123412999901, 13.355826721000142],
            [-15.612453165999852, 13.354224752000022],
            [-15.67989090999987, 13.360658468000068],
            [-15.692499959999907, 13.360348409000082],
            [-15.737406778999912, 13.346344096000067],
            [-15.807118286999923, 13.339781189000092],
            [-15.818693806999875, 13.33352834100009],
            [-15.822672891999957, 13.31942067500006],
            [-15.824367246999913, 13.248511948000086],
            [-15.824739949999923, 13.23291432700006],
            [-15.826600300999928, 13.1616783650001],
            [-15.833318237999947, 13.156846619000078],
            [-15.870783650999925, 13.157156677000074],
            [-15.897441198999985, 13.157399018000135],
            [-15.96173417199995, 13.157983500000086],
            [-16.092062133999946, 13.159120382000097],
            [-16.313288940999968, 13.161084087000035],
            [-16.46521765199995, 13.1624276740001],
            [-16.63001379399992, 13.163900452000092],
            [-16.67352534999995, 13.164313863000103],
            [-16.708406941999925, 13.156691590000051],
            [-16.723186401999925, 13.132248637000103],
            [-16.72633866399991, 13.122636821000086],
            [-16.742151651999905, 13.107392273000045],
            [-16.74850785399991, 13.099227397000035],
            [-16.752125203999896, 13.088039449000092],
            [-16.753651495999918, 13.065008856000077],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bir Tawil',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [33.181135614000084, 21.995409469000037],
            [33.39235925300011, 21.995454407000082],
            [33.625058228000114, 21.995454407000082],
            [33.85770552600013, 21.995454407000082],
            [34.076127286598, 21.995454407000082],
            [34.08417936900008, 21.995454407000068],
            [33.99911757000007, 21.76735270900008],
            [33.866456470948165, 21.749723959413306],
            [33.71726371059995, 21.730946647753747],
            [33.558441969291756, 21.71095743830486],
            [33.43957709632496, 21.80056990843564],
            [33.303681019419614, 21.90302223794743],
            [33.181135614000084, 21.995409469000037],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Madagascar',
        iso3: 'MDG',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [44.25473066500007, -20.376071872999944],
              [44.25131269600007, -20.343926690999922],
              [44.26124108200008, -20.30754973799992],
              [44.33423912900008, -20.16961028399993],
              [44.35572350400008, -20.138116143999923],
              [44.41537519600007, -20.083184502999927],
              [44.43897545700008, -20.055352471999925],
              [44.457774285000085, -20.023614190999922],
              [44.47388756600009, -19.986260674999926],
              [44.47901451900009, -19.95566171699994],
              [44.47934004000007, -19.912774346999925],
              [44.47185306100005, -19.87948984199994],
              [44.45337975400008, -19.87704843499995],
              [44.44459069100009, -19.849216403999947],
              [44.439789259000065, -19.84221770599993],
              [44.432627800000034, -19.83831145599993],
              [44.418304884000065, -19.83757903399993],
              [44.41179446700005, -19.835381768999923],
              [44.39828535200007, -19.824151299999926],
              [44.38502037900008, -19.80868905999995],
              [44.37484785200007, -19.791192315999922],
              [44.37086022200003, -19.77402109199994],
              [44.37476647200003, -19.760511976999908],
              [44.39389082100007, -19.726169528999947],
              [44.40162194100009, -19.715590101999908],
              [44.40967858200008, -19.701429945999905],
              [44.41293379000007, -19.684747002999927],
              [44.41179446700005, -19.65048593499995],
              [44.40951582100007, -19.64031340899993],
              [44.40593509200005, -19.63128020599993],
              [44.40357506600009, -19.621758721999925],
              [44.404958530000044, -19.610121351999908],
              [44.40967858200008, -19.60556405999995],
              [44.42709394600007, -19.595147393999923],
              [44.43295332100007, -19.589043877999927],
              [44.43799889400009, -19.570245049999926],
              [44.440440300000034, -19.554864190999922],
              [44.44841556100005, -19.544366143999923],
              [44.47046959700003, -19.540622653999947],
              [44.48373457100007, -19.52320728999996],
              [44.47974694100009, -19.483982028999947],
              [44.459646030000044, -19.41765715899993],
              [44.44467207100007, -19.385837497999944],
              [44.42554772200003, -19.356215101999908],
              [44.37810306100005, -19.31259530999995],
              [44.37086022200003, -19.300957940999922],
              [44.36304772200003, -19.26816171699994],
              [44.34400475400008, -19.235528252999927],
              [44.25180097700007, -19.121270440999922],
              [44.234385613000086, -19.08879973799992],
              [44.227549675000034, -19.054620049999926],
              [44.234385613000086, -18.996270440999922],
              [44.24789472700007, -18.965101820999905],
              [44.24789472700007, -18.903741143999923],
              [44.247080925000034, -18.90129973799992],
              [44.242849155000044, -18.893975518999923],
              [44.24170983200008, -18.890069268999923],
              [44.24350019600007, -18.88323333099993],
              [44.251963738000086, -18.875176690999922],
              [44.25473066500007, -18.86972421699994],
              [44.26091556100005, -18.844903252999927],
              [44.26156660200007, -18.835137627999927],
              [44.25733483200008, -18.803887627999927],
              [44.233409050000034, -18.73414478999996],
              [44.185883009000065, -18.610772393999923],
              [44.11443118600005, -18.515883070999905],
              [44.04965254000007, -18.426527601999908],
              [44.041758660000085, -18.39690520599993],
              [44.04184004000007, -18.198011976999908],
              [44.002614780000044, -18.00367603999996],
              [44.000987175000034, -17.93792083099993],
              [44.03060957100007, -17.813897393999923],
              [44.03565514400009, -17.769463799999926],
              [44.030284050000034, -17.754571221999925],
              [44.00635826900009, -17.733086846999925],
              [43.99244225400008, -17.687432549999926],
              [43.92920983200008, -17.60165780999995],
              [43.92359459700003, -17.577569268999923],
              [43.92400149800005, -17.546482028999947],
              [43.932627800000034, -17.48495859199994],
              [43.94312584700003, -17.455743096999925],
              [43.994151238000086, -17.375664971999925],
              [44.012054884000065, -17.33407968499995],
              [44.018321160000085, -17.331231377999927],
              [44.03012129000007, -17.337009372999944],
              [44.03646894600007, -17.329522393999923],
              [44.045664910000085, -17.30055103999996],
              [44.121836785000085, -17.186618747999944],
              [44.13819420700008, -17.17050546699994],
              [44.145518425000034, -17.15593840899993],
              [44.14861087300005, -17.141778252999927],
              [44.15170332100007, -17.094414971999925],
              [44.179698113000086, -17.095147393999923],
              [44.204112175000034, -17.056898695999905],
              [44.23804772200003, -16.970961195999905],
              [44.24496504000007, -16.960544528999947],
              [44.272227410000085, -16.93336353999996],
              [44.27759850400008, -16.924981377999927],
              [44.285817905000044, -16.902276299999926],
              [44.292979363000086, -16.892185153999947],
              [44.309255405000044, -16.87428150799991],
              [44.321299675000034, -16.85556405999995],
              [44.340505405000044, -16.813897393999923],
              [44.36670983200008, -16.776788018999923],
              [44.40162194100009, -16.739841403999947],
              [44.430674675000034, -16.700372002999927],
              [44.439789259000065, -16.65553150799991],
              [44.434255405000044, -16.636163018999923],
              [44.41618899800005, -16.59351978999996],
              [44.41179446700005, -16.573011976999908],
              [44.41684004000007, -16.54892343499995],
              [44.428477410000085, -16.53769296699994],
              [44.43881269600007, -16.542575778999947],
              [44.439789259000065, -16.56698984199994],
              [44.45557701900009, -16.540948174999926],
              [44.46338951900009, -16.51336028399993],
              [44.462901238000086, -16.485446872999944],
              [44.45337975400008, -16.457696221999925],
              [44.41578209700003, -16.403008721999925],
              [44.40064537900008, -16.37281666499996],
              [44.39820397200003, -16.34042734199994],
              [44.40259850400008, -16.32781340899993],
              [44.41041100400008, -16.313571872999944],
              [44.41976972700007, -16.299981377999927],
              [44.42920983200008, -16.289727471999925],
              [44.43604576900009, -16.27898528399993],
              [44.438487175000034, -16.26572030999995],
              [44.441416863000086, -16.20940520599993],
              [44.44467207100007, -16.19573333099993],
              [44.45281009200005, -16.186700127999927],
              [44.469411655000044, -16.18222421699994],
              [44.502696160000085, -16.18206145599993],
              [44.53695722700007, -16.176527601999908],
              [44.75505618600005, -16.19695403399993],
              [44.78207441500007, -16.190850518999923],
              [44.79444420700008, -16.191664320999905],
              [44.818695509000065, -16.211114190999922],
              [44.83619225400008, -16.220635674999926],
              [44.854258660000085, -16.225355726999908],
              [44.86833743600005, -16.220879815999922],
              [44.87777754000007, -16.209161065999922],
              [44.88396243600005, -16.199476820999905],
              [44.891368035000085, -16.19117603999996],
              [44.905284050000034, -16.18328215899993],
              [44.91911868600005, -16.179620049999926],
              [44.947927280000044, -16.175225518999923],
              [44.96111087300005, -16.16961028399993],
              [44.95297285200007, -16.162774346999925],
              [45.01124108200008, -16.13600025799991],
              [45.04021243600005, -16.11809661299992],
              [45.05982506600009, -16.093926690999922],
              [45.09392337300005, -16.03883228999996],
              [45.11638431100005, -16.011651299999926],
              [45.138682488000086, -15.990899346999925],
              [45.16578209700003, -15.97551848799992],
              [45.227305535000085, -15.949883721999925],
              [45.266368035000085, -15.92392343499995],
              [45.273448113000086, -15.930108330999929],
              [45.275726759000065, -15.94459400799991],
              [45.27719160200007, -15.97633228999996],
              [45.29468834700003, -16.031914971999925],
              [45.295664910000085, -16.03679778399993],
              [45.29623457100007, -16.046075127999927],
              [45.295664910000085, -16.05315520599993],
              [45.290049675000034, -16.073418877999927],
              [45.28874759200005, -16.09042734199994],
              [45.29037519600007, -16.103448174999926],
              [45.297862175000034, -16.111993096999925],
              [45.31364993600005, -16.11500416499996],
              [45.32894941500007, -16.110121351999908],
              [45.338877800000034, -16.099216403999947],
              [45.34734134200005, -16.08635833099993],
              [45.358083530000044, -16.076836846999925],
              [45.39210045700008, -16.064385674999926],
              [45.406260613000086, -16.054864190999922],
              [45.41293379000007, -16.039239190999922],
              [45.41041100400008, -16.03053150799991],
              [45.39079837300005, -16.023370049999926],
              [45.378916863000086, -16.01140715899993],
              [45.37077884200005, -15.994561455999929],
              [45.37029056100005, -15.981866143999923],
              [45.37940514400009, -15.973809502999927],
              [45.54273522200003, -15.95671965899993],
              [45.54965254000007, -15.954685153999947],
              [45.556976759000065, -15.951348565999922],
              [45.57007897200003, -15.94304778399993],
              [45.57748457100007, -15.970961195999905],
              [45.58513431100005, -15.98137786299992],
              [45.588877800000034, -15.983819268999923],
              [45.59034264400009, -15.98756275799991],
              [45.590586785000085, -16.00172291499996],
              [45.57976321700005, -16.030694268999923],
              [45.580414259000065, -16.04078541499996],
              [45.59791100400008, -16.032403252999927],
              [45.60474694100009, -16.051853122999944],
              [45.612071160000085, -16.049574476999908],
              [45.621836785000085, -16.032403252999927],
              [45.61158287900008, -15.980889580999929],
              [45.61459394600007, -15.969821872999944],
              [45.63054446700005, -15.954278252999927],
              [45.63835696700005, -15.94304778399993],
              [45.637461785000085, -15.940524997999944],
              [45.63835696700005, -15.915215752999927],
              [45.64039147200003, -15.906426690999922],
              [45.64380944100009, -15.899021091999941],
              [45.64625084700003, -15.891208591999941],
              [45.64576256600009, -15.881036065999922],
              [45.63795006600009, -15.868340752999927],
              [45.62720787900008, -15.859633070999905],
              [45.621429884000065, -15.850762627999927],
              [45.62867272200003, -15.837009372999944],
              [45.660899285000085, -15.803806247999944],
              [45.69385826900009, -15.783135674999926],
              [45.70427493600005, -15.78248463299991],
              [45.72087649800005, -15.78883228999996],
              [45.73585045700008, -15.792575778999947],
              [45.75114993600005, -15.792575778999947],
              [45.76587975400008, -15.79420338299991],
              [45.80201256600009, -15.816582940999922],
              [45.82447350400008, -15.81340911299992],
              [45.885427280000044, -15.77898528399993],
              [45.89795983200008, -15.774590752999927],
              [45.91146894600007, -15.772067966999941],
              [45.92693118600005, -15.77117278399993],
              [45.94857832100007, -15.774183851999908],
              [45.956065300000034, -15.78297291499996],
              [45.95427493600005, -15.81609465899993],
              [45.955088738000086, -15.83180103999996],
              [45.95875084700003, -15.83993905999995],
              [45.96697024800005, -15.843682549999926],
              [45.981455925000034, -15.846856377999927],
              [45.98991946700005, -15.847588799999926],
              [46.00733483200008, -15.846286716999941],
              [46.01579837300005, -15.846856377999927],
              [46.042979363000086, -15.86109791499996],
              [46.06609134200005, -15.861911716999941],
              [46.06609134200005, -15.855726820999905],
              [46.05632571700005, -15.84343840899993],
              [46.049815300000034, -15.826348565999922],
              [46.05404707100007, -15.815606377999927],
              [46.063161655000044, -15.806898695999905],
              [46.07081139400009, -15.796075127999927],
              [46.070974155000044, -15.77857838299991],
              [46.046885613000086, -15.790622653999947],
              [46.023448113000086, -15.808200778999947],
              [46.00993899800005, -15.814385674999926],
              [46.01579837300005, -15.79225025799991],
              [46.030284050000034, -15.769463799999926],
              [46.05095462300005, -15.748711846999925],
              [46.07447350400008, -15.730889580999929],
              [46.09750410200007, -15.717054945999905],
              [46.12029056100005, -15.708184502999927],
              [46.14421634200005, -15.703708591999941],
              [46.19385826900009, -15.703545830999929],
              [46.21900475400008, -15.70671965899993],
              [46.23064212300005, -15.71070728999996],
              [46.23552493600005, -15.717461846999925],
              [46.23560631600009, -15.729180596999925],
              [46.236989780000044, -15.739678643999923],
              [46.240977410000085, -15.74928150799991],
              [46.249034050000034, -15.758070570999905],
              [46.23747806100005, -15.776136976999908],
              [46.232758009000065, -15.792087497999944],
              [46.22584069100009, -15.80632903399993],
              [46.207367384000065, -15.819512627999927],
              [46.229177280000044, -15.83684661299992],
              [46.245127800000034, -15.85247161299992],
              [46.257823113000086, -15.87078215899993],
              [46.292979363000086, -15.94068775799991],
              [46.30909264400009, -15.959567966999941],
              [46.331065300000034, -15.977227471999925],
              [46.332041863000086, -15.967461846999925],
              [46.33130944100009, -15.954685153999947],
              [46.33220462300005, -15.942803643999923],
              [46.337901238000086, -15.936211846999925],
              [46.34595787900008, -15.938653252999927],
              [46.35718834700003, -15.957696221999925],
              [46.36508222700007, -15.963555596999925],
              [46.38493899800005, -15.959161065999922],
              [46.393321160000085, -15.941827080999929],
              [46.392588738000086, -15.920098565999922],
              [46.38559004000007, -15.90211353999996],
              [46.41195722700007, -15.89967213299991],
              [46.43116295700008, -15.91765715899993],
              [46.44849694100009, -15.94150155999995],
              [46.468760613000086, -15.95671965899993],
              [46.479177280000044, -15.94890715899993],
              [46.46827233200008, -15.922458591999941],
              [46.444346550000034, -15.881036065999922],
              [46.424571160000085, -15.872491143999923],
              [46.383148634000065, -15.83489348799992],
              [46.35824629000007, -15.826348565999922],
              [46.32601972700007, -15.82822030999995],
              [46.31723066500007, -15.826348565999922],
              [46.29900149800005, -15.81568775799991],
              [46.300791863000086, -15.809014580999929],
              [46.31267337300005, -15.80250416499996],
              [46.32471764400009, -15.79225025799991],
              [46.35124759200005, -15.75204843499995],
              [46.35564212300005, -15.73251718499995],
              [46.344737175000034, -15.717054945999905],
              [46.33375084700003, -15.715915622999944],
              [46.32007897200003, -15.71770598799992],
              [46.308604363000086, -15.71770598799992],
              [46.303721550000034, -15.71021900799991],
              [46.306976759000065, -15.694024346999925],
              [46.32154381600009, -15.666680596999925],
              [46.332692905000044, -15.63014088299991],
              [46.351573113000086, -15.610935153999947],
              [46.39616946700005, -15.576592705999929],
              [46.45923912900008, -15.507745049999926],
              [46.482432488000086, -15.49114348799992],
              [46.48414147200003, -15.496270440999922],
              [46.486338738000086, -15.500420830999929],
              [46.48812910200007, -15.505059502999927],
              [46.488617384000065, -15.511651299999926],
              [46.49976647200003, -15.50554778399993],
              [46.52686608200008, -15.480645440999922],
              [46.569346550000034, -15.450616143999923],
              [46.58122806100005, -15.439711195999905],
              [46.60474694100009, -15.424248955999929],
              [46.63135826900009, -15.42164478999996],
              [46.65772545700008, -15.422051690999922],
              [46.680430535000085, -15.415459893999923],
              [46.66724694100009, -15.406833591999941],
              [46.63624108200008, -15.39853280999995],
              [46.63257897200003, -15.388848565999922],
              [46.643321160000085, -15.378024997999944],
              [46.70093834700003, -15.364353122999944],
              [46.80396569100009, -15.29192473799992],
              [46.87940514400009, -15.225030205999929],
              [46.92164147200003, -15.213067315999922],
              [46.94947350400008, -15.198418877999927],
              [46.96501712300005, -15.19508228999996],
              [46.971446160000085, -15.198418877999927],
              [46.97445722700007, -15.206149997999944],
              [46.97575931100005, -15.215427341999941],
              [46.975596550000034, -15.241794528999947],
              [46.977224155000044, -15.247247002999927],
              [46.98943118600005, -15.272067966999941],
              [46.99732506600009, -15.28215911299992],
              [47.00806725400008, -15.29070403399993],
              [47.02369225400008, -15.299411716999941],
              [47.05787194100009, -15.313083591999941],
              [47.07471764400009, -15.32398853999996],
              [47.074880405000044, -15.336358330999929],
              [47.06495201900009, -15.34937916499996],
              [47.049815300000034, -15.37476978999996],
              [47.03736412900008, -15.385023695999905],
              [47.021820509000065, -15.394952080999929],
              [47.01156660200007, -15.405450127999927],
              [46.96705162900008, -15.49228280999995],
              [46.955088738000086, -15.525974216999941],
              [46.95826256600009, -15.549574476999908],
              [46.96900475400008, -15.551853122999944],
              [46.97641035200007, -15.537855726999908],
              [46.98552493600005, -15.504978122999944],
              [46.99724368600005, -15.494724216999941],
              [47.01547285200007, -15.488946221999925],
              [47.05103600400008, -15.483819268999923],
              [47.084971550000034, -15.471449476999908],
              [47.11654707100007, -15.45517343499995],
              [47.14763431100005, -15.446465752999927],
              [47.180023634000065, -15.45712655999995],
              [47.21631920700008, -15.443780205999929],
              [47.23210696700005, -15.43328215899993],
              [47.235362175000034, -15.415459893999923],
              [47.231455925000034, -15.409763278999947],
              [47.224945509000065, -15.40829843499995],
              [47.216807488000086, -15.407647393999923],
              [47.208018425000034, -15.40520598799992],
              [47.19947350400008, -15.40016041499996],
              [47.19581139400009, -15.395684502999927],
              [47.17904707100007, -15.365492445999905],
              [47.16521243600005, -15.30201588299991],
              [47.16553795700008, -15.295668226999908],
              [47.16228274800005, -15.29265715899993],
              [47.14966881600009, -15.29192473799992],
              [47.14079837300005, -15.293633721999925],
              [47.11182701900009, -15.306247653999947],
              [47.10906009200005, -15.293552341999941],
              [47.110362175000034, -15.28215911299992],
              [47.119883660000085, -15.25790780999995],
              [47.10629316500007, -15.259698174999926],
              [47.09538821700005, -15.259372653999947],
              [47.087901238000086, -15.254652601999908],
              [47.08171634200005, -15.234307549999926],
              [47.06470787900008, -15.224786065999922],
              [47.05787194100009, -15.216241143999923],
              [47.05591881600009, -15.193617445999905],
              [47.06470787900008, -15.172051690999922],
              [47.09197024800005, -15.134942315999922],
              [47.12525475400008, -15.106215101999908],
              [47.168304884000065, -15.078708591999941],
              [47.205739780000044, -15.04664478999996],
              [47.22738691500007, -14.987481377999927],
              [47.24138431100005, -14.96965911299992],
              [47.291758660000085, -14.923435153999947],
              [47.31275475400008, -14.911553643999923],
              [47.33529707100007, -14.90406666499996],
              [47.35889733200008, -14.901543877999927],
              [47.371836785000085, -14.890557549999926],
              [47.37484785200007, -14.86728280999995],
              [47.36833743600005, -14.84661223799992],
              [47.35206139400009, -14.84351978999996],
              [47.34107506600009, -14.85247161299992],
              [47.33521569100009, -14.868584893999923],
              [47.32406660200007, -14.87428150799991],
              [47.308604363000086, -14.875176690999922],
              [47.299164259000065, -14.869561455999929],
              [47.28370201900009, -14.84693775799991],
              [47.28988691500007, -14.84693775799991],
              [47.31999759200005, -14.800225518999923],
              [47.44483483200008, -14.67156340899993],
              [47.45883222700007, -14.661553643999923],
              [47.46534264400009, -14.665459893999923],
              [47.46924889400009, -14.676527601999908],
              [47.475596550000034, -14.688653252999927],
              [47.496104363000086, -14.711602471999925],
              [47.49740644600007, -14.722100518999923],
              [47.49301191500007, -14.783379815999922],
              [47.496755405000044, -14.79851653399993],
              [47.500987175000034, -14.80242278399993],
              [47.50757897200003, -14.804620049999926],
              [47.51392662900008, -14.809177341999941],
              [47.51710045700008, -14.81959400799991],
              [47.51449629000007, -14.82236093499995],
              [47.50342858200008, -14.84693775799991],
              [47.445974155000044, -14.91220468499995],
              [47.43083743600005, -14.935723565999922],
              [47.420664910000085, -14.965590101999908],
              [47.41041100400008, -15.087823174999926],
              [47.41374759200005, -15.099867445999905],
              [47.427744988000086, -15.107598565999922],
              [47.43962649800005, -15.10515715899993],
              [47.47242272200003, -15.08757903399993],
              [47.482432488000086, -15.080254815999922],
              [47.50049889400009, -15.052992445999905],
              [47.50993899800005, -15.02507903399993],
              [47.52295983200008, -14.998711846999925],
              [47.55128014400009, -14.97665780999995],
              [47.562510613000086, -14.985039971999925],
              [47.56592858200008, -14.97584400799991],
              [47.56495201900009, -14.949965101999908],
              [47.57056725400008, -14.93328215899993],
              [47.64210045700008, -14.800388278999947],
              [47.647471550000034, -14.77125416499996],
              [47.65186608200008, -14.758884372999944],
              [47.68441816500007, -14.726495049999926],
              [47.68726647200003, -14.718194268999923],
              [47.68718509200005, -14.70012786299992],
              [47.69092858200008, -14.692478122999944],
              [47.69857832100007, -14.686700127999927],
              [47.71566816500007, -14.67864348799992],
              [47.721364780000044, -14.674981377999927],
              [47.74390709700003, -14.649590752999927],
              [47.752940300000034, -14.63486093499995],
              [47.75668379000007, -14.621026299999926],
              [47.763682488000086, -14.605726820999905],
              [47.77849368600005, -14.597588799999926],
              [47.79265384200005, -14.58757903399993],
              [47.79712975400008, -14.566338799999926],
              [47.83961022200003, -14.624200127999927],
              [47.85914147200003, -14.640801690999922],
              [47.87224368600005, -14.645928643999923],
              [47.90357506600009, -14.65439218499995],
              [47.914398634000065, -14.662041924999926],
              [47.91960696700005, -14.674004815999922],
              [47.91846764400009, -14.697198174999926],
              [47.920664910000085, -14.709730726999908],
              [47.93523196700005, -14.693780205999929],
              [47.936289910000085, -14.67156340899993],
              [47.928070509000065, -14.65129973799992],
              [47.914398634000065, -14.640801690999922],
              [47.942149285000085, -14.61923593499995],
              [47.96859785200007, -14.622165622999944],
              [47.98853600400008, -14.643161716999941],
              [47.99626712300005, -14.675388278999947],
              [47.994802280000044, -14.743340752999927],
              [48.00025475400008, -14.762302341999941],
              [48.01685631600009, -14.737074476999908],
              [48.022471550000034, -14.707696221999925],
              [48.022146030000044, -14.666599216999941],
              [48.01303144600007, -14.630059502999927],
              [47.992930535000085, -14.61419036299992],
              [47.979502800000034, -14.609795830999929],
              [47.96697024800005, -14.59929778399993],
              [47.94483483200008, -14.576348565999922],
              [47.92603600400008, -14.56650155999995],
              [47.91098066500007, -14.568780205999929],
              [47.879649285000085, -14.58684661299992],
              [47.86670983200008, -14.591973565999922],
              [47.85377037900008, -14.594496351999908],
              [47.84001712300005, -14.591403903999947],
              [47.824961785000085, -14.57935963299991],
              [47.81690514400009, -14.56536223799992],
              [47.81072024800005, -14.55087655999995],
              [47.80388431100005, -14.545586846999925],
              [47.77564537900008, -14.583591403999947],
              [47.76295006600009, -14.59539153399993],
              [47.752940300000034, -14.60051848799992],
              [47.746836785000085, -14.59270598799992],
              [47.72608483200008, -14.556573174999926],
              [47.721364780000044, -14.545342705999929],
              [47.723399285000085, -14.541273695999905],
              [47.73357181100005, -14.53134530999995],
              [47.73560631600009, -14.524834893999923],
              [47.73365319100009, -14.515232028999947],
              [47.72982832100007, -14.50953541499996],
              [47.725352410000085, -14.50481536299992],
              [47.70834394600007, -14.470147393999923],
              [47.70875084700003, -14.46412525799991],
              [47.712901238000086, -14.460870049999926],
              [47.71469160200007, -14.45794036299992],
              [47.70337975400008, -14.449395440999922],
              [47.701508009000065, -14.446384372999944],
              [47.703135613000086, -14.40325286299992],
              [47.70948326900009, -14.369561455999929],
              [47.72193444100009, -14.338067315999922],
              [47.74244225400008, -14.31259530999995],
              [47.766286655000044, -14.29851653399993],
              [47.77369225400008, -14.29029713299991],
              [47.77654056100005, -14.27434661299992],
              [47.77784264400009, -14.244561455999929],
              [47.781993035000085, -14.233819268999923],
              [47.79086347700007, -14.223239841999941],
              [47.814463738000086, -14.215997002999927],
              [47.86101321700005, -14.248793226999908],
              [47.893565300000034, -14.24700286299992],
              [47.906911655000044, -14.243584893999923],
              [47.926768425000034, -14.246270440999922],
              [47.93482506600009, -14.243584893999923],
              [47.94353274800005, -14.23251718499995],
              [47.949880405000044, -14.216241143999923],
              [47.953868035000085, -14.19898853999996],
              [47.95533287900008, -14.18523528399993],
              [47.95167076900009, -14.162367445999905],
              [47.941742384000065, -14.13486093499995],
              [47.926524285000085, -14.11101653399993],
              [47.906993035000085, -14.09970468499995],
              [47.92009524800005, -14.08603280999995],
              [47.94157962300005, -14.09189218499995],
              [47.98267662900008, -14.12078215899993],
              [47.99073326900009, -14.124932549999926],
              [47.99935957100007, -14.12818775799991],
              [48.00749759200005, -14.13258228999996],
              [48.013682488000086, -14.140557549999926],
              [48.01498457100007, -14.15357838299991],
              [48.008555535000085, -14.163181247999944],
              [48.00025475400008, -14.172539971999925],
              [47.99626712300005, -14.18523528399993],
              [47.99301191500007, -14.21070728999996],
              [47.978526238000086, -14.262383721999925],
              [47.975271030000044, -14.288262627999927],
              [47.97510826900009, -14.297295830999929],
              [47.976573113000086, -14.312920830999929],
              [47.982758009000065, -14.325372002999927],
              [47.99626712300005, -14.325616143999923],
              [48.002940300000034, -14.317559502999927],
              [48.00342858200008, -14.306247653999947],
              [48.00212649800005, -14.294528903999947],
              [48.00310306100005, -14.28525155999995],
              [48.01091556100005, -14.27906666499996],
              [48.023773634000065, -14.27117278399993],
              [48.033946160000085, -14.262383721999925],
              [48.033946160000085, -14.253838799999926],
              [48.026052280000044, -14.244886976999908],
              [48.018321160000085, -14.233493747999944],
              [48.012461785000085, -14.221123955999929],
              [48.010508660000085, -14.209567966999941],
              [48.01775149800005, -14.18759530999995],
              [48.04476972700007, -14.15162525799991],
              [48.05095462300005, -14.130303643999923],
              [48.05095462300005, -14.10711028399993],
              [48.04818769600007, -14.08407968499995],
              [48.03931725400008, -14.066338799999926],
              [47.99968509200005, -14.053155205999929],
              [47.977549675000034, -14.03801848799992],
              [47.94109134200005, -14.004082940999922],
              [48.01710045700008, -13.965427341999941],
              [48.01710045700008, -13.95281340899993],
              [47.96900475400008, -13.922133070999905],
              [47.928721550000034, -13.90634530999995],
              [47.91749108200008, -13.897637627999927],
              [47.891286655000044, -13.84970468499995],
              [47.87582441500007, -13.784274997999944],
              [47.883799675000034, -13.728448174999926],
              [47.92750084700003, -13.709242445999905],
              [47.91684004000007, -13.693780205999929],
              [47.90455162900008, -13.688083591999941],
              [47.895192905000044, -13.67896900799991],
              [47.893239780000044, -13.65398528399993],
              [47.89633222700007, -13.632989190999922],
              [47.904307488000086, -13.60320403399993],
              [47.91781660200007, -13.582614841999941],
              [47.93799889400009, -13.58912525799991],
              [47.95297285200007, -13.590264580999929],
              [47.96119225400008, -13.565524997999944],
              [47.965586785000085, -13.52076588299991],
              [47.97413170700008, -13.513116143999923],
              [47.98487389400009, -13.50676848799992],
              [47.99537194100009, -13.50676848799992],
              [48.00310306100005, -13.51734791499996],
              [47.99887129000007, -13.523614190999922],
              [47.98878014400009, -13.531914971999925],
              [47.98259524800005, -13.543145440999922],
              [47.98951256600009, -13.55836353999996],
              [47.995127800000034, -13.555352471999925],
              [48.004893425000034, -13.553399346999925],
              [48.010508660000085, -13.551527601999908],
              [48.00513756600009, -13.563653252999927],
              [48.00733483200008, -13.574802341999941],
              [48.01531009200005, -13.58017343499995],
              [48.02711022200003, -13.57512786299992],
              [48.03101647200003, -13.566827080999929],
              [48.031260613000086, -13.558038018999923],
              [48.03532962300005, -13.549981377999927],
              [48.05095462300005, -13.544122002999927],
              [48.03256269600007, -13.524590752999927],
              [48.031260613000086, -13.517185153999947],
              [48.068369988000086, -13.51734791499996],
              [48.08366946700005, -13.528741143999923],
              [48.090586785000085, -13.554294528999947],
              [48.09424889400009, -13.58180103999996],
              [48.09937584700003, -13.59937916499996],
              [48.12712649800005, -13.587009372999944],
              [48.14242597700007, -13.59539153399993],
              [48.15007571700005, -13.615899346999925],
              [48.15455162900008, -13.64031340899993],
              [48.171885613000086, -13.68564218499995],
              [48.174489780000044, -13.70240650799991],
              [48.174489780000044, -13.709242445999905],
              [48.17530358200008, -13.715997002999927],
              [48.178396030000044, -13.721368096999925],
              [48.194021030000044, -13.726983330999929],
              [48.19166100400008, -13.734633070999905],
              [48.18132571700005, -13.746758721999925],
              [48.192393425000034, -13.76685963299991],
              [48.21851647200003, -13.785821221999925],
              [48.24822024800005, -13.799981377999927],
              [48.27035566500007, -13.805352471999925],
              [48.29867597700007, -13.798272393999923],
              [48.32740319100009, -13.779961846999925],
              [48.34115644600007, -13.75554778399993],
              [48.324554884000065, -13.729668877999927],
              [48.33155358200008, -13.71412525799991],
              [48.332041863000086, -13.66139088299991],
              [48.33765709700003, -13.645196221999925],
              [48.35596764400009, -13.61296965899993],
              [48.35954837300005, -13.59937916499996],
              [48.33773847700007, -13.56414153399993],
              [48.33334394600007, -13.546319268999923],
              [48.35271243600005, -13.537855726999908],
              [48.364268425000034, -13.543552341999941],
              [48.393565300000034, -13.58570728999996],
              [48.39869225400008, -13.567152601999908],
              [48.40739993600005, -13.549248955999929],
              [48.41765384200005, -13.534274997999944],
              [48.42758222700007, -13.524183851999908],
              [48.440440300000034, -13.51962655999995],
              [48.45923912900008, -13.51653411299992],
              [48.47771243600005, -13.51572030999995],
              [48.48975670700008, -13.51734791499996],
              [48.48951256600009, -13.512383721999925],
              [48.49008222700007, -13.50204843499995],
              [48.48975670700008, -13.49700286299992],
              [48.51286868600005, -13.516778252999927],
              [48.52466881600009, -13.523044528999947],
              [48.534190300000034, -13.52076588299991],
              [48.531993035000085, -13.511976820999905],
              [48.51449629000007, -13.476983330999929],
              [48.506602410000085, -13.449151299999926],
              [48.489024285000085, -13.426527601999908],
              [48.48226972700007, -13.415134372999944],
              [48.479258660000085, -13.40162525799991],
              [48.47868899800005, -13.387790622999944],
              [48.48226972700007, -13.360446872999944],
              [48.49789472700007, -13.363946221999925],
              [48.50700931100005, -13.37314218499995],
              [48.514008009000065, -13.38445403399993],
              [48.52393639400009, -13.39462655999995],
              [48.524424675000034, -13.410902601999908],
              [48.54273522200003, -13.422946872999944],
              [48.595713738000086, -13.44345468499995],
              [48.60499108200008, -13.445489190999922],
              [48.61500084700003, -13.444024346999925],
              [48.626963738000086, -13.438653252999927],
              [48.639414910000085, -13.435723565999922],
              [48.65202884200005, -13.437676690999922],
              [48.66382897200003, -13.44109465899993],
              [48.67465254000007, -13.44231536299992],
              [48.710948113000086, -13.432305596999925],
              [48.74740644600007, -13.411553643999923],
              [48.78012129000007, -13.383884372999944],
              [48.805023634000065, -13.352959893999923],
              [48.78760826900009, -13.333103122999944],
              [48.80193118600005, -13.304620049999926],
              [48.83920332100007, -13.260430596999925],
              [48.835948113000086, -13.24814218499995],
              [48.821299675000034, -13.224867445999905],
              [48.81812584700003, -13.209242445999905],
              [48.818695509000065, -13.176364841999941],
              [48.820974155000044, -13.159600518999923],
              [48.84351647200003, -13.080824476999908],
              [48.85678144600007, -13.052992445999905],
              [48.88453209700003, -13.01653411299992],
              [48.89226321700005, -13.001071872999944],
              [48.89820397200003, -12.984958591999941],
              [48.90064537900008, -12.97242603999996],
              [48.90552819100009, -12.961114190999922],
              [48.91724694100009, -12.94622161299992],
              [48.93083743600005, -12.93336353999996],
              [48.94166100400008, -12.928399346999925],
              [48.93726647200003, -12.903090101999908],
              [48.953135613000086, -12.838474216999941],
              [48.95533287900008, -12.811700127999927],
              [48.949554884000065, -12.79892343499995],
              [48.92945397200003, -12.77548593499995],
              [48.92115319100009, -12.76336028399993],
              [48.914724155000044, -12.749607028999947],
              [48.910817905000044, -12.73837655999995],
              [48.90560957100007, -12.693536065999922],
              [48.90186608200008, -12.682386976999908],
              [48.88697350400008, -12.660821221999925],
              [48.88070722700007, -12.656996351999908],
              [48.87525475400008, -12.658461195999905],
              [48.87029056100005, -12.657647393999923],
              [48.865896030000044, -12.647230726999908],
              [48.866221550000034, -12.637139580999929],
              [48.871104363000086, -12.631280205999929],
              [48.87671959700003, -12.626397393999923],
              [48.88013756600009, -12.619317315999922],
              [48.87940514400009, -12.61101653399993],
              [48.873708530000044, -12.598809502999927],
              [48.87330162900008, -12.591973565999922],
              [48.88453209700003, -12.567478122999944],
              [48.88697350400008, -12.564629815999922],
              [48.87940514400009, -12.552666924999926],
              [48.867930535000085, -12.551446221999925],
              [48.853851759000065, -12.556817315999922],
              [48.83920332100007, -12.564629815999922],
              [48.83871504000007, -12.53525155999995],
              [48.82984459700003, -12.51848723799992],
              [48.797618035000085, -12.48951588299991],
              [48.78207441500007, -12.448825778999947],
              [48.77369225400008, -12.43523528399993],
              [48.77084394600007, -12.45476653399993],
              [48.72999108200008, -12.434991143999923],
              [48.74203535200007, -12.425388278999947],
              [48.75961347700007, -12.39812590899993],
              [48.77084394600007, -12.397067966999941],
              [48.78288821700005, -12.402601820999905],
              [48.793630405000044, -12.405694268999923],
              [48.81853274800005, -12.406996351999908],
              [48.85271243600005, -12.41375090899993],
              [48.87387129000007, -12.43173593499995],
              [48.90406334700003, -12.488946221999925],
              [48.915049675000034, -12.494805596999925],
              [48.930674675000034, -12.490166924999926],
              [48.94581139400009, -12.479913018999923],
              [48.95533287900008, -12.469170830999929],
              [48.95948326900009, -12.454196872999944],
              [48.96216881600009, -12.400811455999929],
              [48.96436608200008, -12.394952080999929],
              [48.97575931100005, -12.373467705999929],
              [48.97584069100009, -12.368340752999927],
              [48.97396894600007, -12.354180596999925],
              [48.97575931100005, -12.346123955999929],
              [48.98462975400008, -12.333428643999923],
              [48.99740644600007, -12.323663018999923],
              [49.01156660200007, -12.32000090899993],
              [49.024180535000085, -12.325778903999947],
              [49.03077233200008, -12.30787525799991],
              [49.04118899800005, -12.299411716999941],
              [49.053396030000044, -12.29192473799992],
              [49.065196160000085, -12.277276299999926],
              [49.07992597700007, -12.295179945999905],
              [49.09294681100005, -12.281508070999905],
              [49.10572350400008, -12.257012627999927],
              [49.119802280000044, -12.242608330999929],
              [49.13624108200008, -12.256117445999905],
              [49.15121504000007, -12.250746351999908],
              [49.16260826900009, -12.23447030999995],
              [49.16822350400008, -12.215915622999944],
              [49.167002800000034, -12.208184502999927],
              [49.16358483200008, -12.20094166499996],
              [49.16065514400009, -12.192803643999923],
              [49.16138756600009, -12.18173593499995],
              [49.16684004000007, -12.170586846999925],
              [49.174489780000044, -12.164320570999905],
              [49.18246504000007, -12.159763278999947],
              [49.18921959700003, -12.153741143999923],
              [49.19906660200007, -12.15203215899993],
              [49.201508009000065, -12.146661065999922],
              [49.19548587300005, -12.133396091999941],
              [49.18685957100007, -12.123630466999941],
              [49.18018639400009, -12.12200286299992],
              [49.172618035000085, -12.122653903999947],
              [49.16138756600009, -12.119561455999929],
              [49.15642337300005, -12.11532968499995],
              [49.153086785000085, -12.10947030999995],
              [49.148773634000065, -12.103448174999926],
              [49.14087975400008, -12.09856536299992],
              [49.129893425000034, -12.096774997999944],
              [49.09302819100009, -12.09856536299992],
              [49.106455925000034, -12.080254815999922],
              [49.14665774800005, -12.067559502999927],
              [49.16138756600009, -12.050713799999926],
              [49.176524285000085, -12.061130466999941],
              [49.20915774800005, -12.106052341999941],
              [49.21599368600005, -12.09856536299992],
              [49.223399285000085, -12.106052341999941],
              [49.22445722700007, -12.086683851999908],
              [49.216807488000086, -12.065036716999941],
              [49.20199629000007, -12.04810963299991],
              [49.18189537900008, -12.04387786299992],
              [49.18580162900008, -12.033786716999941],
              [49.192067905000044, -12.026950778999947],
              [49.19849694100009, -12.02157968499995],
              [49.20289147200003, -12.016696872999944],
              [49.21306399800005, -12.012302341999941],
              [49.21599368600005, -12.009698174999926],
              [49.21469160200007, -12.006524346999925],
              [49.211273634000065, -12.000420830999929],
              [49.20948326900009, -11.993259372999944],
              [49.21257571700005, -11.985935153999947],
              [49.242523634000065, -11.953708591999941],
              [49.26002037900008, -11.943617445999905],
              [49.278086785000085, -11.947686455999929],
              [49.28834069100009, -11.95484791499996],
              [49.31592858200008, -11.985935153999947],
              [49.322601759000065, -12.00009530999995],
              [49.32276451900009, -12.028903903999947],
              [49.32943769600007, -12.04078541499996],
              [49.34913170700008, -12.06617603999996],
              [49.35173587300005, -12.090508721999925],
              [49.34896894600007, -12.116387627999927],
              [49.35303795700008, -12.14625416499996],
              [49.37086022200003, -12.18328215899993],
              [49.373057488000086, -12.19817473799992],
              [49.367198113000086, -12.198663018999923],
              [49.32943769600007, -12.15715911299992],
              [49.32016035200007, -12.155368747999944],
              [49.31275475400008, -12.163995049999926],
              [49.30591881600009, -12.17546965899993],
              [49.29851321700005, -12.18173593499995],
              [49.28492272200003, -12.178399346999925],
              [49.27369225400008, -12.16773853999996],
              [49.266286655000044, -12.15357838299991],
              [49.26384524800005, -12.140232028999947],
              [49.25318444100009, -12.145196221999925],
              [49.24529056100005, -12.153090101999908],
              [49.24000084700003, -12.162855726999908],
              [49.237071160000085, -12.174248955999929],
              [49.24919681100005, -12.180271091999941],
              [49.24634850400008, -12.192071221999925],
              [49.22966556100005, -12.222100518999923],
              [49.244802280000044, -12.221774997999944],
              [49.26539147200003, -12.224786065999922],
              [49.28370201900009, -12.230889580999929],
              [49.291758660000085, -12.239434502999927],
              [49.28834069100009, -12.246026299999926],
              [49.27393639400009, -12.258070570999905],
              [49.27125084700003, -12.263604424999926],
              [49.27295983200008, -12.272230726999908],
              [49.276377800000034, -12.28134530999995],
              [49.28150475400008, -12.28484465899993],
              [49.28834069100009, -12.277276299999926],
              [49.29900149800005, -12.259372653999947],
              [49.30713951900009, -12.25514088299991],
              [49.315196160000085, -12.262139580999929],
              [49.32585696700005, -12.277276299999926],
              [49.32447350400008, -12.282403252999927],
              [49.32007897200003, -12.289239190999922],
              [49.31950931100005, -12.295179945999905],
              [49.32943769600007, -12.29778411299992],
              [49.34937584700003, -12.29851653399993],
              [49.35906009200005, -12.296807549999926],
              [49.36687259200005, -12.291599216999941],
              [49.37256920700008, -12.27434661299992],
              [49.358409050000034, -12.24618905999995],
              [49.36312910200007, -12.232842705999929],
              [49.38135826900009, -12.222832940999922],
              [49.39275149800005, -12.22975025799991],
              [49.42172285200007, -12.27434661299992],
              [49.424571160000085, -12.285902601999908],
              [49.42505944100009, -12.297539971999925],
              [49.42823326900009, -12.31145598799992],
              [49.43775475400008, -12.326918226999908],
              [49.448008660000085, -12.338067315999922],
              [49.455414259000065, -12.351495049999926],
              [49.45622806100005, -12.373467705999929],
              [49.462901238000086, -12.360446872999944],
              [49.47152754000007, -12.351983330999929],
              [49.482432488000086, -12.34742603999996],
              [49.49659264400009, -12.346123955999929],
              [49.511729363000086, -12.348728122999944],
              [49.517914259000065, -12.354261976999908],
              [49.522146030000044, -12.361911716999941],
              [49.539398634000065, -12.37818775799991],
              [49.54517662900008, -12.39072030999995],
              [49.54574629000007, -12.40203215899993],
              [49.538096550000034, -12.406996351999908],
              [49.524180535000085, -12.403741143999923],
              [49.512054884000065, -12.398370049999926],
              [49.500987175000034, -12.39739348799992],
              [49.49040774800005, -12.406996351999908],
              [49.51482181100005, -12.426853122999944],
              [49.527679884000065, -12.44264088299991],
              [49.539073113000086, -12.444105726999908],
              [49.558604363000086, -12.420668226999908],
              [49.58643639400009, -12.482028903999947],
              [49.592784050000034, -12.50318775799991],
              [49.59498131600009, -12.529717705999929],
              [49.592458530000044, -12.54265715899993],
              [49.582774285000085, -12.54078541499996],
              [49.57471764400009, -12.529717705999929],
              [49.57178795700008, -12.51726653399993],
              [49.57211347700007, -12.48951588299991],
              [49.56609134200005, -12.516696872999944],
              [49.58090254000007, -12.573663018999923],
              [49.57553144600007, -12.59579843499995],
              [49.56763756600009, -12.606215101999908],
              [49.563243035000085, -12.616794528999947],
              [49.562510613000086, -12.62786223799992],
              [49.565440300000034, -12.639825127999927],
              [49.57471764400009, -12.656670830999929],
              [49.58179772200003, -12.65553150799991],
              [49.58936608200008, -12.64853280999995],
              [49.600271030000044, -12.647230726999908],
              [49.615244988000086, -12.656996351999908],
              [49.635508660000085, -12.674574476999908],
              [49.653330925000034, -12.694756768999923],
              [49.66098066500007, -12.712090752999927],
              [49.66325931100005, -12.724867445999905],
              [49.67310631600009, -12.746270440999922],
              [49.67530358200008, -12.75709400799991],
              [49.67269941500007, -12.769952080999929],
              [49.65984134200005, -12.79192473799992],
              [49.65479576900003, -12.804864190999922],
              [49.66374759200005, -12.800225518999923],
              [49.672618035000085, -12.798435153999947],
              [49.68100019600007, -12.79973723799992],
              [49.68881269600007, -12.804864190999922],
              [49.69483483200008, -12.793715101999908],
              [49.70142662900008, -12.78525155999995],
              [49.707041863000086, -12.776136976999908],
              [49.71216881600009, -12.748630466999941],
              [49.719493035000085, -12.73992278399993],
              [49.730479363000086, -12.73805103999996],
              [49.744151238000086, -12.74342213299991],
              [49.73943118600005, -12.753350518999923],
              [49.736664259000065, -12.75709400799991],
              [49.75025475400008, -12.760511976999908],
              [49.763682488000086, -12.767022393999923],
              [49.77564537900008, -12.77548593499995],
              [49.80054772200003, -12.798272393999923],
              [49.80494225400008, -12.804864190999922],
              [49.80054772200003, -12.83017343499995],
              [49.80193118600005, -12.839288018999923],
              [49.81470787900008, -12.865817966999941],
              [49.82406660200007, -12.87623463299991],
              [49.836680535000085, -12.88054778399993],
              [49.85043379000007, -12.879652601999908],
              [49.864268425000034, -12.880466403999947],
              [49.873789910000085, -12.88836028399993],
              [49.87452233200008, -12.908461195999905],
              [49.86744225400008, -12.91383228999996],
              [49.85629316500007, -12.91692473799992],
              [49.852549675000034, -12.924411716999941],
              [49.86703535200007, -12.942071221999925],
              [49.88054446700005, -12.949395440999922],
              [49.89405358200008, -12.953708591999941],
              [49.90447024800005, -12.962334893999923],
              [49.908539259000065, -12.982679945999905],
              [49.91382897200003, -12.997165622999944],
              [49.93685957100007, -13.024102471999925],
              [49.942149285000085, -13.033868096999925],
              [49.944102410000085, -13.087497653999947],
              [49.93531334700003, -13.16806405999995],
              [49.936289910000085, -13.18328215899993],
              [49.94109134200005, -13.203545830999929],
              [49.942149285000085, -13.219496351999908],
              [49.945974155000044, -13.23211028399993],
              [49.97315514400003, -13.271091403999947],
              [49.97624759200005, -13.288506768999923],
              [49.972666863000086, -13.33131275799991],
              [49.976898634000065, -13.346123955999929],
              [49.99048912900008, -13.353936455999929],
              [50.002614780000044, -13.350355726999908],
              [50.013682488000086, -13.344821872999944],
              [50.024099155000044, -13.346123955999929],
              [50.03288821700005, -13.360528252999927],
              [50.03174889400003, -13.378024997999944],
              [50.024099155000044, -13.411553643999923],
              [50.026133660000085, -13.43840911299992],
              [50.04053795700008, -13.49700286299992],
              [50.05201256600009, -13.524183851999908],
              [50.05640709700003, -13.529554945999905],
              [50.068369988000086, -13.53875090899993],
              [50.07252037900008, -13.544122002999927],
              [50.07390384200005, -13.551934502999927],
              [50.07211347700007, -13.57000090899993],
              [50.07252037900008, -13.578301690999922],
              [50.07642662900008, -13.599053643999923],
              [50.07935631600009, -13.606133721999925],
              [50.08187910200007, -13.609958591999941],
              [50.08521569100009, -13.612074476999908],
              [50.08912194100009, -13.61337655999995],
              [50.09327233200008, -13.613702080999929],
              [50.09929446700005, -13.615166924999926],
              [50.100271030000044, -13.61923593499995],
              [50.10010826900003, -13.62468840899993],
              [50.10328209700003, -13.630466403999947],
              [50.105479363000086, -13.641696872999944],
              [50.09742272200003, -13.675713799999926],
              [50.10328209700003, -13.691827080999929],
              [50.11085045700008, -13.703057549999926],
              [50.13396243600005, -13.750176690999922],
              [50.142914259000065, -13.783135674999926],
              [50.15349368600005, -13.98251718499995],
              [50.17351321700005, -14.056817315999922],
              [50.17628014400003, -14.08562590899993],
              [50.17530358200008, -14.12118905999995],
              [50.166026238000086, -14.149102471999925],
              [50.16325931100005, -14.167087497999944],
              [50.16187584700003, -14.202325127999927],
              [50.16423587300005, -14.223077080999929],
              [50.17107181100005, -14.234795830999929],
              [50.196055535000085, -14.257256768999923],
              [50.212901238000086, -14.28720468499995],
              [50.213633660000085, -14.315850518999923],
              [50.201182488000086, -14.39267343499995],
              [50.19157962300005, -14.42359791499996],
              [50.18921959700003, -14.43914153399993],
              [50.19092858200008, -14.456638278999947],
              [50.203461134000065, -14.504327080999929],
              [50.21078535200007, -14.615166924999926],
              [50.23804772200003, -14.66961028399993],
              [50.240896030000044, -14.70598723799992],
              [50.23226972700007, -14.738213799999926],
              [50.209727410000085, -14.750664971999925],
              [50.21892337300005, -14.762872002999927],
              [50.24561608200008, -14.776136976999908],
              [50.25749759200005, -14.78484465899993],
              [50.26531009200005, -14.79778411299992],
              [50.27173912900008, -14.81536223799992],
              [50.28370201900003, -14.879164320999905],
              [50.35523522200003, -15.033135674999926],
              [50.37354576900003, -15.060479424999926],
              [50.42204837300005, -15.11809661299992],
              [50.43213951900003, -15.134209893999923],
              [50.440440300000034, -15.16806405999995],
              [50.45101972700007, -15.178480726999908],
              [50.46412194100009, -15.185804945999905],
              [50.476573113000086, -15.19508228999996],
              [50.49000084700003, -15.219496351999908],
              [50.49830162900008, -15.25204843499995],
              [50.503916863000086, -15.31617603999996],
              [50.502940300000034, -15.322198174999926],
              [50.497080925000034, -15.338067315999922],
              [50.48755944100009, -15.35361093499995],
              [50.48715254000007, -15.360528252999927],
              [50.48943118600005, -15.367608330999929],
              [50.490896030000044, -15.377618096999925],
              [50.48959394600007, -15.384698174999926],
              [50.47999108200008, -15.408623955999929],
              [50.47803795700008, -15.418633721999925],
              [50.47999108200008, -15.428480726999908],
              [50.48267662900008, -15.43718840899993],
              [50.483409050000034, -15.44345468499995],
              [50.479177280000044, -15.45126718499995],
              [50.46705162900008, -15.463555596999925],
              [50.462901238000086, -15.470147393999923],
              [50.456065300000034, -15.504978122999944],
              [50.438243035000085, -15.554945570999905],
              [50.436289910000085, -15.573418877999927],
              [50.42986087300005, -15.600274346999925],
              [50.34099368600005, -15.763604424999926],
              [50.33318118600005, -15.79225025799991],
              [50.34327233200008, -15.798028252999927],
              [50.33676191500007, -15.811293226999908],
              [50.264414910000085, -15.90211353999996],
              [50.24154707100007, -15.95826588299991],
              [50.23015384200005, -15.970961195999905],
              [50.21404056100005, -15.975030205999929],
              [50.19809004000007, -15.972832940999922],
              [50.18287194100009, -15.973321221999925],
              [50.16814212300005, -15.984633070999905],
              [50.14795983200008, -15.93531666499996],
              [50.130869988000086, -15.919366143999923],
              [50.10670006600009, -15.922539971999925],
              [50.05746504000007, -15.881036065999922],
              [50.03891035200007, -15.85947030999995],
              [50.03150475400008, -15.82976653399993],
              [50.02670332100007, -15.778497002999927],
              [50.02466881600009, -15.77117278399993],
              [50.012705925000034, -15.76653411299992],
              [49.99854576900003, -15.75562916499996],
              [49.98552493600005, -15.742445570999905],
              [49.976898634000065, -15.73137786299992],
              [49.97022545700008, -15.71803150799991],
              [49.96501712300005, -15.702243747999944],
              [49.96216881600009, -15.685479424999926],
              [49.96265709700003, -15.669366143999923],
              [49.96810957100007, -15.653008721999925],
              [49.974619988000086, -15.639743747999944],
              [49.97584069100009, -15.62664153399993],
              [49.96607506600009, -15.61142343499995],
              [49.959727410000085, -15.605645440999922],
              [49.95394941500007, -15.602634372999944],
              [49.94752037900008, -15.60133228999996],
              [49.93873131600009, -15.601006768999923],
              [49.93409264400003, -15.597914320999905],
              [49.90560957100007, -15.561618747999944],
              [49.903086785000085, -15.548760674999926],
              [49.908539259000065, -15.517836195999905],
              [49.90902754000007, -15.500258070999905],
              [49.901133660000085, -15.449639580999929],
              [49.90251712300005, -15.443617445999905],
              [49.90609785200007, -15.437758070999905],
              [49.90739993600005, -15.43092213299991],
              [49.901133660000085, -15.422295830999929],
              [49.89625084700003, -15.420668226999908],
              [49.877614780000044, -15.41887786299992],
              [49.85141035200007, -15.432061455999929],
              [49.81495201900003, -15.435967705999929],
              [49.750336134000065, -15.435967705999929],
              [49.717784050000034, -15.446709893999923],
              [49.69548587300005, -15.46648528399993],
              [49.63843834700003, -15.54461028399993],
              [49.639414910000085, -15.570489190999922],
              [49.66098066500007, -15.627699476999908],
              [49.662119988000086, -15.641778252999927],
              [49.66098066500007, -15.655694268999923],
              [49.65056399800005, -15.683038018999923],
              [49.64795983200008, -15.683038018999923],
              [49.65455162900008, -15.695489190999922],
              [49.66618899800005, -15.706231377999927],
              [49.67725670700008, -15.719333591999941],
              [49.68531334700003, -15.75286223799992],
              [49.69947350400008, -15.785739841999941],
              [49.70630944100009, -15.836195570999905],
              [49.71631920700008, -15.867364190999922],
              [49.731130405000044, -15.89421965899993],
              [49.73373457100007, -15.905694268999923],
              [49.730479363000086, -15.922539971999925],
              [49.72315514400003, -15.939385674999926],
              [49.69263756600009, -15.99146900799991],
              [49.683604363000086, -16.020277601999908],
              [49.68311608200008, -16.05364348799992],
              [49.689789259000065, -16.08684661299992],
              [49.70264733200008, -16.11500416499996],
              [49.72877037900008, -16.139418226999908],
              [49.793955925000034, -16.162041924999926],
              [49.82276451900003, -16.179864190999922],
              [49.845713738000086, -16.212090752999927],
              [49.84986412900008, -16.24081796699994],
              [49.82862389400003, -16.33440520599993],
              [49.826914910000085, -16.373304945999905],
              [49.832367384000065, -16.40797291499996],
              [49.850352410000085, -16.422946872999944],
              [49.86060631600009, -16.42937590899993],
              [49.86312910200007, -16.444512627999927],
              [49.85922285200007, -16.483086846999925],
              [49.85499108200008, -16.497491143999923],
              [49.85401451900003, -16.50514088299991],
              [49.85401451900003, -16.53964609199994],
              [49.84945722700007, -16.55242278399993],
              [49.79664147200003, -16.64104583099993],
              [49.76775149800005, -16.673435153999947],
              [49.72315514400003, -16.708103122999944],
              [49.724945509000065, -16.75400155999995],
              [49.73210696700005, -16.77507903399993],
              [49.74732506600009, -16.796807549999926],
              [49.768321160000085, -16.815606377999927],
              [49.78988691500007, -16.826429945999905],
              [49.81364993600005, -16.83017343499995],
              [49.84034264400003, -16.827569268999923],
              [49.81006920700008, -16.843926690999922],
              [49.778330925000034, -16.85556405999995],
              [49.719737175000034, -16.864027601999908],
              [49.69483483200008, -16.877129815999922],
              [49.644541863000086, -16.881524346999925],
              [49.62452233200008, -16.88567473799992],
              [49.608409050000034, -16.89657968499995],
              [49.595713738000086, -16.912041924999926],
              [49.52898196700005, -17.041680596999925],
              [49.482432488000086, -17.167575778999947],
              [49.43132571700005, -17.283868096999925],
              [49.42139733200008, -17.35515715899993],
              [49.42595462300005, -17.370212497999944],
              [49.45622806100005, -17.417168877999927],
              [49.50407962300005, -17.66301848799992],
              [49.50961347700007, -17.727715752999927],
              [49.49773196700005, -17.796807549999926],
              [49.46265709700003, -17.91570403399993],
              [49.41391035200007, -18.067071221999925],
              [49.41260826900009, -18.08456796699994],
              [49.41391035200007, -18.101820570999905],
              [49.417979363000086, -18.115492445999905],
              [49.422618035000085, -18.12273528399993],
              [49.43376712300005, -18.135511976999908],
              [49.438487175000034, -18.142836195999905],
              [49.44076582100007, -18.154229424999926],
              [49.43474368600005, -18.15992603999996],
              [49.424571160000085, -18.16383228999996],
              [49.41456139400009, -18.170098565999922],
              [49.38412519600007, -18.22551848799992],
              [49.35922285200007, -18.424004815999922],
              [49.352224155000044, -18.43678150799991],
              [49.33326256600009, -18.45956796699994],
              [49.32585696700005, -18.471856377999927],
              [49.30193118600005, -18.540134372999944],
              [49.243174675000034, -18.65683359199994],
              [49.19117272200003, -18.842543226999908],
              [49.11345462300005, -19.012465101999908],
              [49.076914910000085, -19.065606377999927],
              [48.98585045700008, -19.378838799999926],
              [48.85962975400008, -19.684665622999944],
              [48.82553144600007, -19.84221770599993],
              [48.823252800000034, -19.865492445999905],
              [48.82374108200008, -19.90276458099993],
              [48.791351759000065, -19.99309661299992],
              [48.78500410200007, -19.980726820999905],
              [48.77271569100009, -19.964450778999947],
              [48.75953209700003, -19.95549895599993],
              [48.75049889400009, -19.96575286299992],
              [48.754649285000085, -19.977308851999908],
              [48.77898196700005, -20.009209893999923],
              [48.78451582100007, -20.02434661299992],
              [48.78174889400009, -20.03720468499995],
              [48.699229363000086, -20.199883721999925],
              [48.64177493600005, -20.34539153399993],
              [48.616221550000034, -20.419773044999943],
              [48.56226647200003, -20.57708098799992],
              [48.46241295700008, -20.93222421699994],
              [48.451833530000044, -20.948337497999944],
              [48.438487175000034, -20.964043877999927],
              [48.43018639400009, -20.979180596999925],
              [48.43441816500007, -20.993584893999923],
              [48.44752037900008, -20.98088958099993],
              [48.45492597700007, -20.984551690999922],
              [48.457367384000065, -20.99781666499996],
              [48.45557701900009, -21.01409270599993],
              [48.44906660200007, -21.028903903999947],
              [48.43132571700005, -21.058526299999926],
              [48.42758222700007, -21.07586028399993],
              [48.424164259000065, -21.110039971999925],
              [48.414805535000085, -21.143975518999923],
              [48.37859134200005, -21.22389088299991],
              [48.375010613000086, -21.23756275799991],
              [48.373057488000086, -21.26799895599993],
              [48.35670006600009, -21.353692315999922],
              [48.34205162900008, -21.389825127999927],
              [48.328135613000086, -21.41464609199994],
              [48.201833530000044, -21.79615650799991],
              [48.07463626400005, -22.072198174999926],
              [47.94743899800005, -22.34823984199994],
              [47.933604363000086, -22.41415780999995],
              [47.90064537900008, -22.481133721999925],
              [47.85865319100009, -22.746026299999926],
              [47.83936608200008, -22.806573174999926],
              [47.83383222700007, -22.90097421699994],
              [47.79997806100005, -23.01213958099993],
              [47.762380405000044, -23.110121351999908],
              [47.73804772200003, -23.255466403999947],
              [47.619476759000065, -23.590590101999908],
              [47.60792076900009, -23.576836846999925],
              [47.602224155000044, -23.56536223799992],
              [47.59652754000007, -23.563164971999925],
              [47.58545983200008, -23.576918226999908],
              [47.574961785000085, -23.598728122999944],
              [47.58187910200007, -23.604587497999944],
              [47.598317905000044, -23.60605234199994],
              [47.61605879000007, -23.614434502999927],
              [47.620127800000034, -23.64039478999996],
              [47.568695509000065, -23.852634372999944],
              [47.514333530000044, -23.986993096999925],
              [47.496755405000044, -24.016371351999908],
              [47.48975670700008, -24.022637627999927],
              [47.47388756600009, -24.03215911299992],
              [47.468760613000086, -24.036309502999927],
              [47.46664472700007, -24.036309502999927],
              [47.45622806100005, -24.039808851999908],
              [47.455088738000086, -24.03997161299992],
              [47.44849694100009, -24.045098565999922],
              [47.45053144600007, -24.048028252999927],
              [47.45484459700003, -24.05120208099993],
              [47.455088738000086, -24.05673593499995],
              [47.45484459700003, -24.059340101999908],
              [47.448252800000034, -24.084649346999925],
              [47.43083743600005, -24.117852471999925],
              [47.428070509000065, -24.12476978999996],
              [47.37077884200005, -24.27011484199994],
              [47.36304772200003, -24.276543877999927],
              [47.35092207100007, -24.272881768999923],
              [47.32960045700008, -24.263604424999926],
              [47.32471764400009, -24.26962655999995],
              [47.33838951900009, -24.32431405999995],
              [47.31226647200003, -24.485935153999947],
              [47.22836347700007, -24.680352471999925],
              [47.20337975400008, -24.71648528399993],
              [47.20053144600007, -24.73137786299992],
              [47.201182488000086, -24.762465101999908],
              [47.194102410000085, -24.77825286299992],
              [47.14283287900008, -24.814060153999947],
              [47.128916863000086, -24.844903252999927],
              [47.137461785000085, -24.909274997999944],
              [47.12614993600005, -24.934340101999908],
              [47.115896030000044, -24.923028252999927],
              [47.10906009200005, -24.909763278999947],
              [47.10572350400008, -24.89495208099993],
              [47.10564212300005, -24.879164320999905],
              [47.09685306100005, -24.893324476999908],
              [47.09595787900008, -24.90789153399993],
              [47.098317905000044, -24.923435153999947],
              [47.09880618600005, -24.940606377999927],
              [47.09457441500007, -24.960137627999927],
              [47.08725019600007, -24.968357028999947],
              [47.05787194100009, -24.978692315999922],
              [47.04086347700007, -24.988539320999905],
              [47.012705925000034, -25.012465101999908],
              [46.96469160200007, -25.06568775799991],
              [46.95484459700003, -25.070977471999925],
              [46.951508009000065, -25.066664320999905],
              [46.94117272200003, -25.04420338299991],
              [46.92953535200007, -25.04265715899993],
              [46.92660566500007, -25.043715101999908],
              [46.925791863000086, -25.04664478999996],
              [46.86736087300005, -25.08521900799991],
              [46.84546959700003, -25.10393645599993],
              [46.834727410000085, -25.110772393999923],
              [46.80551191500007, -25.12118905999995],
              [46.79411868600005, -25.12786223799992],
              [46.780039910000085, -25.14576588299991],
              [46.76978600400008, -25.153497002999927],
              [46.761729363000086, -25.153008721999925],
              [46.75180097700007, -25.149509372999944],
              [46.74146569100009, -25.149590752999927],
              [46.73170006600009, -25.160332940999922],
              [46.72217858200008, -25.166680596999925],
              [46.65365644600007, -25.183851820999905],
              [46.63803144600007, -25.18336353999996],
              [46.60474694100009, -25.174574476999908],
              [46.50220787900008, -25.16179778399993],
              [46.38656660200007, -25.164808851999908],
              [46.23764082100007, -25.19817473799992],
              [46.039724155000044, -25.27776458099993],
              [45.914073113000086, -25.337334893999923],
              [45.774180535000085, -25.408135674999926],
              [45.67400149800005, -25.494398695999905],
              [45.654958530000044, -25.507012627999927],
              [45.63396243600005, -25.514825127999927],
              [45.61158287900008, -25.51653411299992],
              [45.561208530000044, -25.559991143999923],
              [45.492198113000086, -25.573663018999923],
              [45.207692905000044, -25.58489348799992],
              [45.192393425000034, -25.588067315999922],
              [45.177744988000086, -25.59433359199994],
              [45.16260826900009, -25.59856536299992],
              [45.145518425000034, -25.59539153399993],
              [45.13607832100007, -25.584161065999922],
              [45.12663821700005, -25.54583098799992],
              [45.118174675000034, -25.529554945999905],
              [45.08765709700003, -25.50823333099993],
              [44.98096764400009, -25.471856377999927],
              [44.95101972700007, -25.451836846999925],
              [44.93799889400009, -25.438164971999925],
              [44.92554772200003, -25.407810153999947],
              [44.90870201900009, -25.393731377999927],
              [44.834727410000085, -25.344008070999905],
              [44.76734459700003, -25.314385674999926],
              [44.72779381600009, -25.30364348799992],
              [44.622080925000034, -25.289727471999925],
              [44.51693769600007, -25.28443775799991],
              [44.369476759000065, -25.25676848799992],
              [44.35108483200008, -25.247491143999923],
              [44.33619225400008, -25.208916924999926],
              [44.303721550000034, -25.175388278999947],
              [44.29639733200008, -25.153497002999927],
              [44.31576582100007, -25.160902601999908],
              [44.33318118600005, -25.17506275799991],
              [44.364024285000085, -25.207777601999908],
              [44.38404381600009, -25.220879815999922],
              [44.40088951900009, -25.221449476999908],
              [44.40943444100009, -25.210544528999947],
              [44.404958530000044, -25.188164971999925],
              [44.389008009000065, -25.191013278999947],
              [44.375336134000065, -25.183770440999922],
              [44.34978274800005, -25.160332940999922],
              [44.33326256600009, -25.150323174999926],
              [44.31804446700005, -25.14421965899993],
              [44.30193118600005, -25.14120859199994],
              [44.28272545700008, -25.14039478999996],
              [44.24756920700008, -25.127211195999905],
              [44.18718509200005, -25.06698984199994],
              [44.15170332100007, -25.05046965899993],
              [44.119883660000085, -25.050713799999926],
              [44.10857181100005, -25.048028252999927],
              [44.02881920700008, -24.99895598799992],
              [44.01734459700003, -24.977227471999925],
              [44.01091556100005, -24.898614190999922],
              [44.000987175000034, -24.865411065999922],
              [43.928477410000085, -24.774590752999927],
              [43.918304884000065, -24.74195728999996],
              [43.92798912900008, -24.65243905999995],
              [43.918304884000065, -24.619073174999926],
              [43.908213738000086, -24.60214609199994],
              [43.86540774800005, -24.55917734199994],
              [43.86052493600005, -24.55559661299992],
              [43.855479363000086, -24.55120208099993],
              [43.85010826900009, -24.54338958099993],
              [43.84734134200005, -24.53443775799991],
              [43.84424889400009, -24.513929945999905],
              [43.839854363000086, -24.505791924999926],
              [43.806651238000086, -24.479261976999908],
              [43.73715254000007, -24.435723565999922],
              [43.70671634200005, -24.406182549999926],
              [43.672862175000034, -24.33489348799992],
              [43.656260613000086, -24.18531666499996],
              [43.66960696700005, -24.013278903999947],
              [43.65211022200003, -23.91643645599993],
              [43.65406334700003, -23.906914971999925],
              [43.662852410000085, -23.88844166499996],
              [43.66521243600005, -23.87859465899993],
              [43.664073113000086, -23.867120049999926],
              [43.65211022200003, -23.83757903399993],
              [43.64372806100005, -23.79778411299992],
              [43.63721764400009, -23.77971770599993],
              [43.62476647200003, -23.761895440999922],
              [43.639008009000065, -23.741306247999944],
              [43.63697350400008, -23.67050546699994],
              [43.641612175000034, -23.638929945999905],
              [43.66374759200005, -23.619398695999905],
              [43.73096764400009, -23.592054945999905],
              [43.74830162900008, -23.57008228999996],
              [43.746429884000065, -23.553887627999927],
              [43.73292076900009, -23.52776458099993],
              [43.73462975400008, -23.509209893999923],
              [43.750010613000086, -23.495700778999947],
              [43.754567905000044, -23.48886484199994],
              [43.760752800000034, -23.472100518999923],
              [43.76124108200008, -23.46379973799992],
              [43.75798587300005, -23.45403411299992],
              [43.74724368600005, -23.440199476999908],
              [43.72055097700007, -23.41961028399993],
              [43.70142662900008, -23.39544036299992],
              [43.658946160000085, -23.35784270599993],
              [43.65211022200003, -23.35409921699994],
              [43.64576256600009, -23.35320403399993],
              [43.639008009000065, -23.351495049999926],
              [43.63103274800005, -23.344821872999944],
              [43.62859134200005, -23.339288018999923],
              [43.62476647200003, -23.31682708099993],
              [43.614268425000034, -23.281996351999908],
              [43.610036655000044, -23.19231536299992],
              [43.59685306100005, -23.11760833099993],
              [43.58318118600005, -23.07586028399993],
              [43.55591881600009, -23.048272393999923],
              [43.48755944100009, -23.001560153999947],
              [43.47673587300005, -22.987074476999908],
              [43.46029707100007, -22.95566171699994],
              [43.446055535000085, -22.94312916499996],
              [43.427744988000086, -22.93059661299992],
              [43.39340254000007, -22.89511484199994],
              [43.37256920700008, -22.864841403999947],
              [43.36117597700007, -22.843194268999923],
              [43.35670006600009, -22.829685153999947],
              [43.35132897200003, -22.788506768999923],
              [43.33871504000007, -22.761325778999947],
              [43.33350670700008, -22.70907968499995],
              [43.32162519600007, -22.680840752999927],
              [43.31568444100009, -22.645277601999908],
              [43.31080162900008, -22.636651299999926],
              [43.297211134000065, -22.61972421699994],
              [43.291758660000085, -22.610772393999923],
              [43.28492272200003, -22.587497653999947],
              [43.28443444100009, -22.564060153999947],
              [43.28834069100009, -22.51799895599993],
              [43.278005405000044, -22.42587655999995],
              [43.264008009000065, -22.377699476999908],
              [43.240244988000086, -22.332289320999905],
              [43.24000084700003, -22.32236093499995],
              [43.240896030000044, -22.31218840899993],
              [43.240570509000065, -22.302666924999926],
              [43.23389733200008, -22.278008721999925],
              [43.22291100400008, -22.25481536299992],
              [43.22543379000007, -22.233819268999923],
              [43.246836785000085, -22.218357028999947],
              [43.274099155000044, -22.215997002999927],
              [43.29517662900008, -22.23447030999995],
              [43.301768425000034, -22.21884530999995],
              [43.30005944100009, -22.201836846999925],
              [43.29607181100005, -22.18417734199994],
              [43.29517662900008, -22.16611093499995],
              [43.26091556100005, -22.165622653999947],
              [43.24724368600005, -22.12558359199994],
              [43.246836785000085, -22.035088799999926],
              [43.249034050000034, -22.02402109199994],
              [43.258799675000034, -22.004082940999922],
              [43.26099694100009, -21.99382903399993],
              [43.26099694100009, -21.96998463299991],
              [43.262705925000034, -21.95989348799992],
              [43.266612175000034, -21.95517343499995],
              [43.27125084700003, -21.951836846999925],
              [43.27466881600009, -21.946384372999944],
              [43.27662194100009, -21.94589609199994],
              [43.28093509200005, -21.944431247999944],
              [43.285492384000065, -21.94198984199994],
              [43.28834069100009, -21.938897393999923],
              [43.28093509200005, -21.911716403999947],
              [43.28248131600009, -21.898370049999926],
              [43.28687584700003, -21.886325778999947],
              [43.293630405000044, -21.874932549999926],
              [43.30209394600007, -21.864434502999927],
              [43.31381269600007, -21.878838799999926],
              [43.31527754000007, -21.89576588299991],
              [43.30884850400008, -21.93206145599993],
              [43.32927493600005, -21.905043226999908],
              [43.33318118600005, -21.858168226999908],
              [43.33155358200008, -21.80754973799992],
              [43.33619225400008, -21.76881275799991],
              [43.34734134200005, -21.750258070999905],
              [43.41431725400008, -21.674899997999944],
              [43.43148847700007, -21.662286065999922],
              [43.45069420700008, -21.65984465899993],
              [43.472666863000086, -21.672051690999922],
              [43.472666863000086, -21.40520598799992],
              [43.48023522200003, -21.380303643999923],
              [43.50123131600009, -21.334161065999922],
              [43.50749759200005, -21.30950286299992],
              [43.51531009200005, -21.32659270599993],
              [43.52328535200007, -21.32675546699994],
              [43.54224694100009, -21.30950286299992],
              [43.56959069100009, -21.295993747999944],
              [43.582774285000085, -21.27776458099993],
              [43.586924675000034, -21.274834893999923],
              [43.642588738000086, -21.276055596999925],
              [43.680023634000065, -21.26604583099993],
              [43.69874108200008, -21.27044036299992],
              [43.71648196700005, -21.27776458099993],
              [43.73462975400008, -21.28167083099993],
              [43.75953209700003, -21.27271900799991],
              [43.78858483200008, -21.251153252999927],
              [43.81275475400008, -21.22429778399993],
              [43.82276451900009, -21.199395440999922],
              [43.82789147200003, -21.17001718499995],
              [43.86378014400009, -21.07626718499995],
              [43.90154056100005, -20.88290780999995],
              [43.96461022200003, -20.76734791499996],
              [43.98560631600009, -20.747979424999926],
              [44.018321160000085, -20.740411065999922],
              [44.03638756600009, -20.72551848799992],
              [44.09034264400009, -20.63054778399993],
              [44.10279381600009, -20.590101820999905],
              [44.112071160000085, -20.54273853999996],
              [44.12582441500007, -20.498304945999905],
              [44.15170332100007, -20.465997002999927],
              [44.15186608200008, -20.47503020599993],
              [44.15349368600005, -20.481133721999925],
              [44.158539259000065, -20.493340752999927],
              [44.18287194100009, -20.438897393999923],
              [44.19678795700008, -20.42164478999996],
              [44.24073326900009, -20.389336846999925],
              [44.25473066500007, -20.376071872999944],
            ],
          ],
          [
            [
              [49.955821160000085, -16.77971770599993],
              [49.95948326900003, -16.76531340899993],
              [49.96119225400008, -16.749607028999947],
              [49.96461022200003, -16.73414478999996],
              [49.97315514400003, -16.72112395599993],
              [49.985362175000034, -16.71184661299992],
              [50.024099155000044, -16.69036223799992],
              [50.019867384000065, -16.71453215899993],
              [49.98373457100007, -16.786716403999947],
              [49.957367384000065, -16.864027601999908],
              [49.90845787900008, -16.966973565999922],
              [49.87281334700003, -17.013116143999923],
              [49.844493035000085, -17.072198174999926],
              [49.826182488000086, -17.094414971999925],
              [49.817393425000034, -17.067152601999908],
              [49.82252037900008, -17.041273695999905],
              [49.84652754000007, -16.991387627999927],
              [49.85084069100009, -16.977715752999927],
              [49.85303795700008, -16.964776299999926],
              [49.85401451900003, -16.93678150799991],
              [49.85726972700007, -16.91969166499996],
              [49.865570509000065, -16.90634530999995],
              [49.88819420700008, -16.881524346999925],
              [49.955821160000085, -16.77971770599993],
            ],
          ],
          [
            [
              [48.332041863000086, -13.360446872999944],
              [48.33936608200008, -13.368340752999927],
              [48.35328209700003, -13.377373955999929],
              [48.36500084700003, -13.38795338299991],
              [48.366221550000034, -13.400648695999905],
              [48.35954837300005, -13.40797291499996],
              [48.349619988000086, -13.412367445999905],
              [48.338633660000085, -13.414483330999929],
              [48.32837975400008, -13.415134372999944],
              [48.32349694100009, -13.412774346999925],
              [48.32016035200007, -13.40789153399993],
              [48.318369988000086, -13.403008721999925],
              [48.318369988000086, -13.400648695999905],
              [48.31234785200007, -13.401788018999923],
              [48.29802493600005, -13.408135674999926],
              [48.261729363000086, -13.40243905999995],
              [48.24927819100009, -13.396905205999929],
              [48.23585045700008, -13.387139580999929],
              [48.22901451900009, -13.387139580999929],
              [48.22901451900009, -13.400648695999905],
              [48.224619988000086, -13.40048593499995],
              [48.22193444100009, -13.398614190999922],
              [48.219493035000085, -13.39625416499996],
              [48.21599368600005, -13.39462655999995],
              [48.20630944100009, -13.38258228999996],
              [48.19971764400009, -13.361504815999922],
              [48.19499759200005, -13.318780205999929],
              [48.19890384200005, -13.299411716999941],
              [48.20443769600007, -13.282321872999944],
              [48.203868035000085, -13.269789320999905],
              [48.18873131600009, -13.264255466999941],
              [48.19890384200005, -13.251071872999944],
              [48.213633660000085, -13.255303643999923],
              [48.22934004000007, -13.262302341999941],
              [48.242849155000044, -13.25676848799992],
              [48.24952233200008, -13.26295338299991],
              [48.25904381600009, -13.26734791499996],
              [48.26921634200005, -13.268324476999908],
              [48.27686608200008, -13.264255466999941],
              [48.27816816500007, -13.256524346999925],
              [48.27328535200007, -13.24895598799992],
              [48.26710045700008, -13.24114348799992],
              [48.26384524800005, -13.233086846999925],
              [48.264659050000034, -13.21257903399993],
              [48.26929772200003, -13.201104424999926],
              [48.28044681100005, -13.196384372999944],
              [48.30103600400008, -13.19540780999995],
              [48.318369988000086, -13.200290622999944],
              [48.32642662900008, -13.212823174999926],
              [48.32545006600009, -13.229587497999944],
              [48.31495201900009, -13.246758721999925],
              [48.32374108200008, -13.251885674999926],
              [48.33375084700003, -13.27239348799992],
              [48.34115644600007, -13.29469166499996],
              [48.34205162900008, -13.305271091999941],
              [48.354177280000044, -13.31226978999996],
              [48.34880618600005, -13.328789971999925],
              [48.33765709700003, -13.347263278999947],
              [48.332041863000086, -13.360446872999944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Comoros',
        iso3: 'COM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [43.78874759200005, -12.308038018999923],
              [43.79704837300005, -12.311618747999944],
              [43.85010826900009, -12.346123955999929],
              [43.86158287900008, -12.36337655999995],
              [43.858164910000085, -12.371351820999905],
              [43.84294681100005, -12.373467705999929],
              [43.819346550000034, -12.373467705999929],
              [43.75147545700008, -12.359958591999941],
              [43.68140709700003, -12.358086846999925],
              [43.66521243600005, -12.35247161299992],
              [43.660817905000044, -12.34498463299991],
              [43.66179446700005, -12.327732028999947],
              [43.658946160000085, -12.318291924999926],
              [43.65023847700007, -12.31023528399993],
              [43.64112389400009, -12.30641041499996],
              [43.63396243600005, -12.301039320999905],
              [43.63103274800005, -12.287774346999925],
              [43.629893425000034, -12.25172291499996],
              [43.635752800000034, -12.236911716999941],
              [43.65211022200003, -12.242608330999929],
              [43.666351759000065, -12.25009530999995],
              [43.70834394600007, -12.25790780999995],
              [43.727224155000044, -12.263604424999926],
              [43.779307488000086, -12.297621351999908],
              [43.78874759200005, -12.308038018999923],
            ],
          ],
          [
            [
              [44.52906334700003, -12.232842705999929],
              [44.52849368600005, -12.35475025799991],
              [44.52295983200008, -12.37281666499996],
              [44.51148522200003, -12.380303643999923],
              [44.502696160000085, -12.37672291499996],
              [44.49244225400008, -12.368259372999944],
              [44.48414147200003, -12.358005466999941],
              [44.48072350400008, -12.34929778399993],
              [44.47877037900008, -12.33684661299992],
              [44.473317905000044, -12.32976653399993],
              [44.39958743600005, -12.279961846999925],
              [44.391368035000085, -12.267022393999923],
              [44.38526451900009, -12.25172291499996],
              [44.370127800000034, -12.244317315999922],
              [44.33057701900009, -12.236260674999926],
              [44.26840254000007, -12.205010674999926],
              [44.26002037900008, -12.198418877999927],
              [44.21989993600005, -12.174981377999927],
              [44.20639082100007, -12.160577080999929],
              [44.22250410200007, -12.160088799999926],
              [44.23585045700008, -12.16334400799991],
              [44.26156660200007, -12.174248955999929],
              [44.27898196700005, -12.17864348799992],
              [44.311289910000085, -12.18328215899993],
              [44.32309004000007, -12.187920830999929],
              [44.32837975400008, -12.183770440999922],
              [44.33838951900009, -12.17864348799992],
              [44.34351647200003, -12.174248955999929],
              [44.37354576900009, -12.180352471999925],
              [44.40007571700005, -12.156508070999905],
              [44.41529381600009, -12.119317315999922],
              [44.41179446700005, -12.085544528999947],
              [44.42156009200005, -12.082696221999925],
              [44.43531334700003, -12.074802341999941],
              [44.446055535000085, -12.071872653999947],
              [44.45101972700007, -12.069756768999923],
              [44.45533287900008, -12.066582940999922],
              [44.46013431100005, -12.06414153399993],
              [44.46705162900008, -12.064385674999926],
              [44.47282962300005, -12.068536065999922],
              [44.48072350400008, -12.082452080999929],
              [44.48414147200003, -12.085544528999947],
              [44.526377800000034, -12.21884530999995],
              [44.52906334700003, -12.232842705999929],
            ],
          ],
          [
            [
              [43.46656334700003, -11.821709893999923],
              [43.469086134000065, -11.83171965899993],
              [43.475352410000085, -11.84303150799991],
              [43.498789910000085, -11.873630466999941],
              [43.49830162900008, -11.882012627999927],
              [43.486989780000044, -11.899834893999923],
              [43.48373457100007, -11.90992603999996],
              [43.48259524800005, -11.917168877999927],
              [43.47999108200008, -11.92278411299992],
              [43.472666863000086, -11.927911065999922],
              [43.46314537900008, -11.93092213299991],
              [43.449554884000065, -11.93287525799991],
              [43.43767337300005, -11.931573174999926],
              [43.432383660000085, -11.924086195999905],
              [43.42595462300005, -11.911553643999923],
              [43.36996504000007, -11.86060963299991],
              [43.35515384200005, -11.854587497999944],
              [43.31226647200003, -11.852146091999941],
              [43.301768425000034, -11.849541924999926],
              [43.29029381600009, -11.843357028999947],
              [43.27100670700008, -11.82822030999995],
              [43.26286868600005, -11.81804778399993],
              [43.260101759000065, -11.809177341999941],
              [43.258799675000034, -11.80046965899993],
              [43.254242384000065, -11.79070403399993],
              [43.22877037900008, -11.766289971999925],
              [43.217784050000034, -11.750258070999905],
              [43.213226759000065, -11.725762627999927],
              [43.21599368600005, -11.715997002999927],
              [43.22250410200007, -11.703871351999908],
              [43.244151238000086, -11.672946872999944],
              [43.24439537900008, -11.662286065999922],
              [43.24154707100007, -11.651543877999927],
              [43.240570509000065, -11.639825127999927],
              [43.25440514400009, -11.463067315999922],
              [43.252289259000065, -11.451348565999922],
              [43.246836785000085, -11.440606377999927],
              [43.256602410000085, -11.423272393999923],
              [43.26612389400009, -11.398695570999905],
              [43.27654056100005, -11.379571221999925],
              [43.28834069100009, -11.379164320999905],
              [43.330821160000085, -11.36500416499996],
              [43.35572350400008, -11.361260674999926],
              [43.374034050000034, -11.368584893999923],
              [43.38599694100009, -11.38404713299991],
              [43.394867384000065, -11.40016041499996],
              [43.399424675000034, -11.418389580999929],
              [43.37712649800005, -11.605075778999947],
              [43.38607832100007, -11.645603122999944],
              [43.43051191500007, -11.708184502999927],
              [43.44662519600007, -11.749118747999944],
              [43.44711347700007, -11.759372653999947],
              [43.44556725400008, -11.78053150799991],
              [43.44662519600007, -11.79070403399993],
              [43.451182488000086, -11.798028252999927],
              [43.457774285000085, -11.80437590899993],
              [43.463877800000034, -11.811618747999944],
              [43.46656334700003, -11.821709893999923],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'São Tomé and Principe',
        iso3: 'STP',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [6.68140709700009, 0.407131252000056],
              [6.703868035000085, 0.391831773000092],
              [6.727061394000089, 0.366929429000038],
              [6.746104363000086, 0.338080145000049],
              [6.756521030000044, 0.31085846600007],
              [6.760915561000047, 0.284165757000039],
              [6.760508660000085, 0.26829661700009],
              [6.756521030000044, 0.250067450000074],
              [6.748545769000089, 0.230698960000041],
              [6.740082227000073, 0.218573309000078],
              [6.715586785000085, 0.195461330000057],
              [6.703135613000086, 0.18040599200009],
              [6.674571160000085, 0.133368231000077],
              [6.668467644000089, 0.131008205000057],
              [6.659190300000091, 0.128851630000042],
              [6.653330925000091, 0.124579169000071],
              [6.660004102000073, 0.107326565000051],
              [6.652598504000082, 0.103216864000046],
              [6.641449415000068, 0.10101959800005],
              [6.633636915000068, 0.098578192000048],
              [6.618174675000091, 0.081203518000052],
              [6.616221550000091, 0.078111070000091],
              [6.582855665000068, 0.077337958000044],
              [6.578379754000082, 0.078111070000091],
              [6.56771894600007, 0.042141018000052],
              [6.557302280000044, 0.028265692000048],
              [6.544200066000087, 0.043931382000039],
              [6.536957227000073, 0.026434637000079],
              [6.526621941000087, 0.024115302000041],
              [6.516368035000085, 0.033636786000045],
              [6.510101759000065, 0.05141836100006],
              [6.511729363000086, 0.052720445000091],
              [6.516612175000091, 0.069973049000055],
              [6.51693769600007, 0.078111070000091],
              [6.513682488000086, 0.088283596000053],
              [6.509613477000073, 0.092678127000056],
              [6.505707227000073, 0.094875393000052],
              [6.502696160000085, 0.098578192000048],
              [6.467295769000089, 0.212469794000071],
              [6.461680535000085, 0.222154039000088],
              [6.466319207000083, 0.231024481000077],
              [6.46810957100007, 0.239813544000071],
              [6.46851647200009, 0.259955145000049],
              [6.470876498000052, 0.26788971600007],
              [6.490244988000086, 0.290961005000042],
              [6.494313998000052, 0.299994208000044],
              [6.495371941000087, 0.306382554000038],
              [6.49781334700009, 0.312689520000049],
              [6.533050977000073, 0.348130601000094],
              [6.54078209700009, 0.35187409100007],
              [6.578298373000052, 0.364569403000075],
              [6.609548373000052, 0.390366929000038],
              [6.641856316000087, 0.41079336100006],
              [6.68140709700009, 0.407131252000056],
            ],
          ],
          [
            [
              [7.462738477000073, 1.67454661700009],
              [7.457367384000065, 1.669989325000074],
              [7.446136915000068, 1.66547272300005],
              [7.434825066000087, 1.658880927000041],
              [7.428721550000091, 1.647853908000059],
              [7.443532748000052, 1.645453192000048],
              [7.45671634200005, 1.638332424000055],
              [7.461761915000068, 1.630804755000042],
              [7.452647332000083, 1.627346096000053],
              [7.438243035000085, 1.623928127000056],
              [7.434418165000068, 1.615220445000091],
              [7.435557488000086, 1.592596747000073],
              [7.430511915000068, 1.572739976000094],
              [7.42554772200009, 1.562730210000041],
              [7.418223504000082, 1.558498440000051],
              [7.405772332000083, 1.556463934000078],
              [7.40211022200009, 1.550726630000042],
              [7.402517123000052, 1.542059637000079],
              [7.401377800000091, 1.531195380000042],
              [7.398773634000065, 1.534979559000078],
              [7.395681186000047, 1.542385158000059],
              [7.394053582000083, 1.545396226000094],
              [7.387380405000044, 1.542466539000088],
              [7.381032748000052, 1.537990627000056],
              [7.372243686000047, 1.55414459800005],
              [7.358409050000091, 1.55890534100007],
              [7.343760613000086, 1.559881903000075],
              [7.332530144000089, 1.565334377000056],
              [7.329356316000087, 1.596258856000077],
              [7.330088738000086, 1.614650783000059],
              [7.339366082000083, 1.613104559000078],
              [7.355967644000089, 1.620021877000056],
              [7.364024285000085, 1.629380601000094],
              [7.366465691000087, 1.641791083000044],
              [7.36654707100007, 1.658107815000051],
              [7.371836785000085, 1.67719147300005],
              [7.385264519000089, 1.692328192000048],
              [7.403005405000044, 1.699774481000077],
              [7.42123457100007, 1.695705471000053],
              [7.448741082000083, 1.693182684000078],
              [7.459727410000085, 1.688299872000073],
              [7.462738477000073, 1.67454661700009],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cabo Verde',
        iso3: 'CPV',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-24.704335089999915, 14.900824286000045],
              [-24.693104620999918, 14.890692450000074],
              [-24.686756964999915, 14.876166083000044],
              [-24.683949347999942, 14.859442450000074],
              [-24.683257615999935, 14.842474677000041],
              [-24.686879035999937, 14.826646226000037],
              [-24.695301886999914, 14.81940338700008],
              [-24.704416469999956, 14.814032294000071],
              [-24.710560675999943, 14.803941148000092],
              [-24.718006964999915, 14.803941148000092],
              [-24.725453253999945, 14.814113674000055],
              [-24.744618292999917, 14.826605536000045],
              [-24.75153561099995, 14.838771877000056],
              [-24.758941209999932, 14.831854559000078],
              [-24.754709438999953, 14.84080638200004],
              [-24.753244594999956, 14.849351304000038],
              [-24.754709438999953, 14.857855536000045],
              [-24.758941209999932, 14.86664459800005],
              [-24.745350714999915, 14.86664459800005],
              [-24.74941972599993, 14.88548411700009],
              [-24.737619594999956, 14.89203522300005],
              [-24.719349738999938, 14.89443594000005],
              [-24.704335089999915, 14.900824286000045],
            ],
          ],
          [
            [
              [-24.296538865999935, 14.917547919000071],
              [-24.301503058999913, 14.90648021000004],
              [-24.298207160999937, 14.895453192000048],
              [-24.29328365799995, 14.884344794000071],
              [-24.29283606699994, 14.872870184000078],
              [-24.299549933999913, 14.863023179000038],
              [-24.334462042999917, 14.831854559000078],
              [-24.37653561099995, 14.815985419000071],
              [-24.41502844999991, 14.820868231000077],
              [-24.44908606699994, 14.838080145000049],
              [-24.506581183999913, 14.884955145000049],
              [-24.520375128999945, 14.903957424000055],
              [-24.526234503999945, 14.924709377000056],
              [-24.52061926999994, 14.945257880000042],
              [-24.506743943999936, 14.969183661000045],
              [-24.48892167899993, 14.99054596600007],
              [-24.464588995999918, 15.00771719000005],
              [-24.40343176999994, 15.038031317000048],
              [-24.385568813999953, 15.043524481000077],
              [-24.364857550999943, 15.045396226000037],
              [-24.34325110599991, 15.040716864000046],
              [-24.32921301999994, 15.028713283000059],
              [-24.320139126999948, 15.013006903000075],
              [-24.307240363999938, 14.979437567000048],
              [-24.295765753999945, 14.930487372000073],
              [-24.296538865999935, 14.917547919000071],
            ],
          ],
          [
            [
              [-23.456776495999918, 15.02366771000004],
              [-23.45457923099991, 15.018947658000059],
              [-23.451893683999913, 15.015122789000088],
              [-23.44835364499994, 15.012396552000041],
              [-23.443104620999918, 15.010687567000048],
              [-23.447824673999946, 14.995754299000055],
              [-23.45466061099995, 14.985907294000071],
              [-23.477894660999937, 14.96906159100007],
              [-23.470448370999918, 14.962225653000075],
              [-23.480213995999918, 14.946600653000075],
              [-23.486317511999914, 14.930853583000044],
              [-23.49400794199994, 14.91868724200009],
              [-23.508290167999917, 14.913804429000038],
              [-23.516224738999938, 14.91282786700009],
              [-23.531849738999938, 14.908636786000045],
              [-23.53929602799991, 14.907619533000059],
              [-23.547352667999917, 14.90851471600007],
              [-23.555816209999932, 14.912787177000041],
              [-23.563221808999913, 14.913804429000038],
              [-23.596424933999913, 14.914536851000037],
              [-23.62413489499994, 14.918117580000057],
              [-23.649728969999956, 14.92649974200009],
              [-23.676503058999913, 14.93553294500009],
              [-23.71507727799991, 14.968451239000046],
              [-23.730539516999954, 14.985825914000088],
              [-23.73070227799991, 15.018500067000048],
              [-23.74205481699994, 15.02635325700004],
              [-23.758290167999917, 15.031317450000074],
              [-23.772084113999938, 15.037990627000056],
              [-23.772694464999915, 15.041693427000041],
              [-23.77953040299991, 15.064642645000049],
              [-23.78229732999995, 15.068548895000049],
              [-23.786284959999932, 15.072414455000057],
              [-23.79010982999995, 15.077704169000071],
              [-23.792591925999943, 15.085760809000078],
              [-23.789865688999953, 15.093817450000074],
              [-23.77562415299991, 15.11823151200008],
              [-23.772084113999938, 15.127346096000053],
              [-23.77293860599991, 15.140448309000078],
              [-23.785755988999938, 15.174505927000041],
              [-23.776193813999953, 15.177232164000088],
              [-23.770130988999938, 15.183986721000053],
              [-23.766753709999932, 15.193752346000053],
              [-23.76585852799991, 15.205511786000045],
              [-23.763661261999914, 15.216294664000088],
              [-23.758697068999936, 15.223089911000045],
              [-23.75381425699993, 15.228094794000071],
              [-23.751576300999943, 15.23346588700008],
              [-23.75495357999995, 15.25031159100007],
              [-23.763295050999943, 15.26976146000004],
              [-23.77440344999991, 15.285630601000037],
              [-23.785755988999938, 15.291815497000073],
              [-23.779123501999948, 15.294134833000044],
              [-23.758412238999938, 15.304877020000049],
              [-23.773060675999943, 15.310614325000074],
              [-23.77953040299991, 15.311672268000052],
              [-23.751576300999943, 15.33274974200009],
              [-23.744130011999914, 15.33274974200009],
              [-23.74356035099993, 15.325140692000048],
              [-23.742014126999948, 15.32094961100006],
              [-23.739898240999935, 15.317328192000048],
              [-23.737945115999935, 15.311672268000052],
              [-23.719227667999917, 15.32290273600006],
              [-23.703236456999946, 15.31346263200004],
              [-23.697824673999946, 15.29633209800005],
              [-23.710682745999918, 15.284369208000044],
              [-23.697336391999954, 15.266017971000053],
              [-23.681752081999946, 15.254828192000048],
              [-23.648548956999946, 15.237209377000056],
              [-23.656076626999948, 15.229722398000092],
              [-23.638783331999946, 15.226263739000046],
              [-23.63027910099993, 15.219183661000045],
              [-23.61510169199994, 15.195013739000046],
              [-23.58421790299991, 15.16242096600007],
              [-23.56737219999991, 15.152085679000038],
              [-23.552357550999943, 15.153998114000046],
              [-23.54914303299995, 15.149359442000048],
              [-23.547474738999938, 15.14594147300005],
              [-23.544992641999954, 15.143133856000077],
              [-23.53929602799991, 15.140366929000038],
              [-23.540760870999918, 15.139064846000053],
              [-23.534413214999915, 15.133002020000049],
              [-23.52725175699993, 15.127386786000045],
              [-23.52570553299995, 15.127346096000053],
              [-23.52293860599991, 15.126695054000038],
              [-23.514068162999934, 15.12799713700008],
              [-23.511382615999935, 15.127346096000053],
              [-23.51081295499995, 15.124212958000044],
              [-23.51203365799995, 15.116115627000056],
              [-23.511382615999935, 15.113023179000038],
              [-23.470448370999918, 15.037990627000056],
              [-23.466542120999918, 15.03424713700008],
              [-23.463612433999913, 15.033148505000042],
              [-23.460682745999918, 15.030951239000046],
              [-23.456776495999918, 15.02366771000004],
            ],
          ],
          [
            [
              [-23.127797003999945, 15.311672268000052],
              [-23.121896938999953, 15.29913971600007],
              [-23.12051347599993, 15.283351955000057],
              [-23.121571417999917, 15.256415106000077],
              [-23.11046301999994, 15.199408270000049],
              [-23.111927863999938, 15.171942450000074],
              [-23.127797003999945, 15.146633205000057],
              [-23.132801886999914, 15.144720770000049],
              [-23.14867102799991, 15.142767645000049],
              [-23.155140753999945, 15.140366929000038],
              [-23.15884355399993, 15.135565497000073],
              [-23.16364498599995, 15.123724677000041],
              [-23.168812628999945, 15.11985911700009],
              [-23.18272864499994, 15.11859772300005],
              [-23.19595292899993, 15.12205638200004],
              [-23.217152472999942, 15.13353099200009],
              [-23.240630662999934, 15.150051174000055],
              [-23.252064581999946, 15.161810614000046],
              [-23.258168097999942, 15.174505927000041],
              [-23.255116339999915, 15.186835028000075],
              [-23.247303839999915, 15.19920482000009],
              [-23.24327551999994, 15.211330471000053],
              [-23.251332160999937, 15.22288646000004],
              [-23.237172003999945, 15.231024481000077],
              [-23.230865037999934, 15.243963934000078],
              [-23.234852667999917, 15.254828192000048],
              [-23.251332160999937, 15.256415106000077],
              [-23.245716925999943, 15.271063544000071],
              [-23.22411048099991, 15.286688544000071],
              [-23.209787563999953, 15.311672268000052],
              [-23.214466925999943, 15.31354401200008],
              [-23.21515865799995, 15.31443919500009],
              [-23.214955206999946, 15.315822658000059],
              [-23.217152472999942, 15.319159247000073],
              [-23.203277147999927, 15.324896552000041],
              [-23.189849412999934, 15.33274974200009],
              [-23.189564581999946, 15.329494533000059],
              [-23.189849412999934, 15.319159247000073],
              [-23.181263800999943, 15.325751044000071],
              [-23.178944464999915, 15.327948309000078],
              [-23.176258917999917, 15.33274974200009],
              [-23.168812628999945, 15.325344143000052],
              [-23.176258917999917, 15.319159247000073],
              [-23.161936001999948, 15.312567450000074],
              [-23.139515753999945, 15.317775783000059],
              [-23.127797003999945, 15.311672268000052],
            ],
          ],
          [
            [
              [-22.682118292999917, 16.11359284100007],
              [-22.67837480399993, 16.111883856000077],
              [-22.670806443999936, 16.10224030200004],
              [-22.666574673999946, 16.091457424000055],
              [-22.67251542899993, 16.086330471000053],
              [-22.675607876999948, 16.08201732000009],
              [-22.677113410999937, 16.072658596000053],
              [-22.679798956999946, 16.06321849200009],
              [-22.696441209999932, 16.05292389500005],
              [-22.75108801999994, 16.010565497000073],
              [-22.787587042999917, 15.991603908000059],
              [-22.80614173099991, 15.985907294000071],
              [-22.863677537999934, 15.982367255000042],
              [-22.873890753999945, 15.983872789000088],
              [-22.883656378999945, 15.988714911000045],
              [-22.897775844999956, 16.000474351000037],
              [-22.90929114499994, 16.003729559000078],
              [-22.94554602799991, 16.019680080000057],
              [-22.957753058999913, 16.03082916900007],
              [-22.96397864499994, 16.05219147300005],
              [-22.963246222999942, 16.071193752000056],
              [-22.957753058999913, 16.089016018000052],
              [-22.947417772999927, 16.10224030200004],
              [-22.93260657499991, 16.10740794500009],
              [-22.91356360599991, 16.125555731000077],
              [-22.924427863999938, 16.212958075000074],
              [-22.91559811099995, 16.243963934000078],
              [-22.91161048099991, 16.236721096000053],
              [-22.90721594999991, 16.23143138200004],
              [-22.895090298999946, 16.22284577000005],
              [-22.87791907499991, 16.214911200000074],
              [-22.85252844999991, 16.20661041900007],
              [-22.829416469999956, 16.204006252000056],
              [-22.81932532499991, 16.212958075000074],
              [-22.811675584999932, 16.22842031500005],
              [-22.793812628999945, 16.231350002000056],
              [-22.73468990799995, 16.216864325000074],
              [-22.723866339999915, 16.212632554000038],
              [-22.71385657499991, 16.20575592700004],
              [-22.709828253999945, 16.19863515800006],
              [-22.70376542899993, 16.17959219000005],
              [-22.699574347999942, 16.17568594000005],
              [-22.682484503999945, 16.16864655200004],
              [-22.67870032499991, 16.15176015800006],
              [-22.682118292999917, 16.11359284100007],
            ],
          ],
          [
            [
              [-24.067534959999932, 16.61391836100006],
              [-24.04796301999994, 16.598822333000044],
              [-24.03742428299995, 16.593003648000092],
              [-24.032826300999943, 16.596828518000052],
              [-24.032826300999943, 16.56240469000005],
              [-24.044097459999932, 16.559881903000075],
              [-24.11473548099991, 16.55927155200004],
              [-24.191965298999946, 16.59247467700004],
              [-24.233306443999936, 16.602118231000077],
              [-24.272328253999945, 16.587225653000075],
              [-24.286366339999915, 16.570746161000045],
              [-24.315337693999936, 16.520412502000056],
              [-24.324696417999917, 16.48265208500004],
              [-24.33340410099993, 16.494940497000073],
              [-24.347482876999948, 16.53196849200009],
              [-24.35338294199994, 16.54043203300006],
              [-24.360178188999953, 16.54718659100007],
              [-24.365630662999934, 16.555609442000048],
              [-24.367909308999913, 16.569159247000073],
              [-24.36856035099993, 16.57953522300005],
              [-24.370920376999948, 16.587144273000092],
              [-24.37608801999994, 16.59178294500009],
              [-24.38508053299995, 16.593410549000055],
              [-24.408273891999954, 16.600165106000077],
              [-24.424712693999936, 16.617132880000042],
              [-24.43065344999991, 16.639471747000073],
              [-24.422596808999913, 16.66229889500005],
              [-24.361480272999927, 16.681586005000042],
              [-24.354237433999913, 16.680609442000048],
              [-24.340565558999913, 16.67536041900007],
              [-24.328684048999946, 16.667792059000078],
              [-24.305165167999917, 16.64789459800005],
              [-24.29283606699994, 16.641831773000092],
              [-24.282378709999932, 16.64134349200009],
              [-24.22679602799991, 16.649603583000044],
              [-24.21711178299995, 16.647691148000092],
              [-24.180572068999936, 16.63084544500009],
              [-24.172474738999938, 16.62909577000005],
              [-24.089995897999927, 16.62246328300006],
              [-24.067534959999932, 16.61391836100006],
            ],
          ],
          [
            [
              [-22.92918860599991, 16.593410549000055],
              [-22.941395636999914, 16.66937897300005],
              [-22.95653235599991, 16.69944896000004],
              [-22.97760982999995, 16.68903229400007],
              [-22.981760219999956, 16.703517971000053],
              [-22.983143683999913, 16.723049221000053],
              [-22.98005123599995, 16.741115627000056],
              [-22.970814581999946, 16.75104401200008],
              [-22.970814581999946, 16.757879950000074],
              [-22.98273678299995, 16.761379299000055],
              [-22.98924719999991, 16.77094147300005],
              [-22.991566535999937, 16.784328518000052],
              [-22.990793423999946, 16.815659898000092],
              [-22.97012285099993, 16.83144765800006],
              [-22.922434048999946, 16.860296942000048],
              [-22.91698157499991, 16.853176174000055],
              [-22.898915167999917, 16.836818752000056],
              [-22.895090298999946, 16.829291083000044],
              [-22.896311001999948, 16.825018622000073],
              [-22.902740037999934, 16.81317780200004],
              [-22.909779425999943, 16.80337148600006],
              [-22.907948370999918, 16.800604559000078],
              [-22.904042120999918, 16.798570054000038],
              [-22.90184485599991, 16.79511139500005],
              [-22.904652472999942, 16.73582591400009],
              [-22.90184485599991, 16.716945705000057],
              [-22.897368943999936, 16.710272528000075],
              [-22.88418535099993, 16.698431708000044],
              [-22.881337042999917, 16.692694403000075],
              [-22.88239498599995, 16.68154531500005],
              [-22.88662675699993, 16.66168854400007],
              [-22.887603318999936, 16.65143463700008],
              [-22.889556443999936, 16.64590078300006],
              [-22.898793097999942, 16.639471747000073],
              [-22.90184485599991, 16.634426174000055],
              [-22.90147864499994, 16.62909577000005],
              [-22.89940344999991, 16.621649481000077],
              [-22.896839972999942, 16.61546458500004],
              [-22.895090298999946, 16.61391836100006],
              [-22.901722785999937, 16.605902411000045],
              [-22.90884355399993, 16.60219961100006],
              [-22.917632615999935, 16.59918854400007],
              [-22.92918860599991, 16.593410549000055],
            ],
          ],
          [
            [
              [-24.919748501999948, 16.895086981000077],
              [-24.92292232999995, 16.89081452000005],
              [-24.914458787999934, 16.881415106000077],
              [-24.900135870999918, 16.872015692000048],
              [-24.885894334999932, 16.867743231000077],
              [-24.88109290299991, 16.86229075700004],
              [-24.876291469999956, 16.84983958500004],
              [-24.873605923999946, 16.83592357000009],
              [-24.875070766999954, 16.82615794500009],
              [-24.891102667999917, 16.81395091400009],
              [-24.91551673099991, 16.805487372000073],
              [-24.94286048099991, 16.800482489000046],
              [-24.968129035999937, 16.798895575000074],
              [-24.97451738199993, 16.796698309000078],
              [-24.984201626999948, 16.78733958500004],
              [-24.988026495999918, 16.78514232000009],
              [-24.99522864499994, 16.78611888200004],
              [-25.05817623599995, 16.80963776200008],
              [-25.06822669199994, 16.81509023600006],
              [-25.076161261999914, 16.82245514500005],
              [-25.08112545499995, 16.83234284100007],
              [-25.094146287999934, 16.82615794500009],
              [-25.08975175699993, 16.847479559000078],
              [-25.078195766999954, 16.865057684000078],
              [-25.06358801999994, 16.877020575000074],
              [-25.050119594999956, 16.881415106000077],
              [-25.018788214999915, 16.882025458000044],
              [-25.005970831999946, 16.88768138200004],
              [-25.012196417999917, 16.901271877000056],
              [-24.983998175999943, 16.915961005000042],
              [-24.97809811099995, 16.923000393000052],
              [-24.971262173999946, 16.923000393000052],
              [-24.965199347999942, 16.90892161700009],
              [-24.955189581999946, 16.91079336100006],
              [-24.93773352799991, 16.923000393000052],
              [-24.927723761999914, 16.917792059000078],
              [-24.918771938999953, 16.908270575000074],
              [-24.91470292899993, 16.89915599200009],
              [-24.919748501999948, 16.895086981000077],
            ],
          ],
          [
            [
              [-25.046986456999946, 17.03506094000005],
              [-25.055572068999936, 17.02480703300006],
              [-25.11587480399993, 16.99746328300006],
              [-25.143422003999945, 16.970038153000075],
              [-25.162953253999945, 16.94529857000009],
              [-25.187855597999942, 16.928168036000045],
              [-25.231312628999945, 16.923000393000052],
              [-25.269195115999935, 16.923000393000052],
              [-25.28083248599995, 16.920721747000073],
              [-25.289662238999938, 16.917181708000044],
              [-25.29869544199994, 16.91738515800006],
              [-25.31078040299991, 16.92609284100007],
              [-25.313384568999936, 16.93846263200004],
              [-25.31387285099993, 17.00495026200008],
              [-25.32754472599993, 17.028225002000056],
              [-25.33104407499991, 17.030951239000046],
              [-25.34829667899993, 17.034125067000048],
              [-25.354847785999937, 17.03847890800006],
              [-25.36042232999995, 17.055243231000077],
              [-25.355580206999946, 17.069566148000092],
              [-25.330922003999945, 17.096828518000052],
              [-25.316802537999934, 17.10610586100006],
              [-25.30215410099993, 17.10805898600006],
              [-25.289133266999954, 17.10700104400007],
              [-25.279774542999917, 17.10732656500005],
              [-25.269602016999954, 17.11432526200008],
              [-25.245350714999915, 17.13670482000009],
              [-25.226307745999918, 17.144680080000057],
              [-25.20270748599995, 17.158758856000077],
              [-25.17955481699994, 17.16437409100007],
              [-25.11864173099991, 17.19285716400009],
              [-25.10260982999995, 17.196600653000075],
              [-25.091053839999915, 17.193019924000055],
              [-25.07949785099993, 17.185370184000078],
              [-25.053944464999915, 17.18618398600006],
              [-25.039540167999917, 17.182440497000073],
              [-25.030181443999936, 17.175482489000046],
              [-25.026275193999936, 17.167710679000038],
              [-25.025868292999917, 17.144924221000053],
              [-25.02057857999995, 17.140366929000038],
              [-24.99705969999991, 17.13418203300006],
              [-24.99176998599995, 17.130926825000074],
              [-24.988677537999934, 17.12571849200009],
              [-24.974964972999942, 17.114488023000092],
              [-24.971262173999946, 17.10732656500005],
              [-24.973011847999942, 17.096625067000048],
              [-24.978993292999917, 17.08690013200004],
              [-25.01512610599991, 17.04913971600007],
              [-25.019683397999927, 17.04901764500005],
              [-25.023915167999917, 17.045396226000037],
              [-25.042713995999918, 17.03847890800006],
              [-25.046986456999946, 17.03506094000005],
            ],
          ],
          [
            [
              [-24.592659601036317, 16.624312420871888],
              [-24.569512031034343, 16.61997225149652],
              [-24.575298923534838, 16.605505020245285],
              [-24.58976615478607, 16.60695174337041],
              [-24.601339939787056, 16.609845189620657],
              [-24.604233386037304, 16.621418974621644],
              [-24.592659601036317, 16.624312420871888],
            ],
          ],
          [
            [
              [-24.773499991676733, 16.80225936526206],
              [-24.74890569854964, 16.79357902651132],
              [-24.735885190423527, 16.779111795260086],
              [-24.725758128547664, 16.757410948383235],
              [-24.70695072792106, 16.753070779007867],
              [-24.695376942920074, 16.760304394633483],
              [-24.683803157919087, 16.75596422525811],
              [-24.68524988104421, 16.742943717132004],
              [-24.70261055854569, 16.735710101506385],
              [-24.722864682297416, 16.73426337838126],
              [-24.740225359798895, 16.73426337838126],
              [-24.74890569854964, 16.742943717132004],
              [-24.75469259105013, 16.754517502132988],
              [-24.773499991676733, 16.761751117758607],
              [-24.787967222927968, 16.774771625884714],
              [-24.787967222927968, 16.78923885713595],
              [-24.773499991676733, 16.80225936526206],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'France',
        iso3: '-99',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-54.1115266969999, 2.114270443000066],
              [-54.134908, 2.11067332000006],
              [-54.14813716599994, 2.114394023000074],
              [-54.15738724899995, 2.121654562000046],
              [-54.18854813699994, 2.161316224000117],
              [-54.194490925999844, 2.163073222000094],
              [-54.210045532999885, 2.161574605000098],
              [-54.229785929999935, 2.157233785000116],
              [-54.246477416999966, 2.151601054000082],
              [-54.263789021999884, 2.148190410000055],
              [-54.31401851399991, 2.154856669000068],
              [-54.32285518499992, 2.157337138000045],
              [-54.33505082199994, 2.163900045000034],
              [-54.360940714999884, 2.188187968000122],
              [-54.37391149899989, 2.196507873000087],
              [-54.38052608299998, 2.197696432000015],
              [-54.38781245999988, 2.196301168000033],
              [-54.40254024299989, 2.197127991000059],
              [-54.4114802659999, 2.199711812000061],
              [-54.42708654899994, 2.207153219000077],
              [-54.43395951399992, 2.209323629000068],
              [-54.47664424699991, 2.21412953800008],
              [-54.49266394099996, 2.222707825000015],
              [-54.51142248599987, 2.243430074000045],
              [-54.54578731399991, 2.268596497000075],
              [-54.549146280999906, 2.279448548000119],
              [-54.52640865099994, 2.282652486000089],
              [-54.5442886969999, 2.300222473000062],
              [-54.56464921099993, 2.314846904000134],
              [-54.58816198799991, 2.324355367000123],
              [-54.615292114999875, 2.326267396000048],
              [-54.59922074399992, 2.345801087000055],
              [-54.58475134299988, 2.348333231000126],
              [-54.551161661999856, 2.338101298000055],
              [-54.53157629399993, 2.340168356000021],
              [-54.52031083199998, 2.348901672000096],
              [-54.49338741099987, 2.41706288600011],
              [-54.483310505999924, 2.422850647000089],
              [-54.472613484999926, 2.428690084000067],
              [-54.45054764799991, 2.428948466000051],
              [-54.435458130999905, 2.431118876000127],
              [-54.42346919799988, 2.435924784000036],
              [-54.375616821999955, 2.483777161000134],
              [-54.35944209799996, 2.508013408000124],
              [-54.320426391999945, 2.606663717000032],
              [-54.28533809499993, 2.677977193000103],
              [-54.21252600199995, 2.776420797000057],
              [-54.20472285999992, 2.791768698000027],
              [-54.188909871999925, 2.838277486000067],
              [-54.182191935999896, 2.846545716000108],
              [-54.170203002999955, 2.853056946000081],
              [-54.18338049399992, 2.863857320000108],
              [-54.18963334199992, 2.870626933000054],
              [-54.191338663999886, 2.877344870000073],
              [-54.190666869999916, 2.887835185000114],
              [-54.18704951999993, 2.89930735300004],
              [-54.17325191299997, 2.919512837000127],
              [-54.170203002999955, 2.925403951000121],
              [-54.16296830299987, 2.955996399000043],
              [-54.1634333909999, 2.969742330000074],
              [-54.16875606299996, 2.971395976000039],
              [-54.179763143999935, 2.983746643000089],
              [-54.18513749199991, 2.997802633000106],
              [-54.17361364799987, 3.004520569000121],
              [-54.16916947399997, 3.010721741000111],
              [-54.170874796999925, 3.024829407000141],
              [-54.1770242929999, 3.04891062500009],
              [-54.17919470299998, 3.05159779900012],
              [-54.18854813699994, 3.05831573500005],
              [-54.190666869999916, 3.059142558000076],
              [-54.188496459999925, 3.064620260000055],
              [-54.1840006109999, 3.06797922800007],
              [-54.17945308399996, 3.070304668000105],
              [-54.1770242929999, 3.072785136000078],
              [-54.17469885299997, 3.093920797000109],
              [-54.17707596799991, 3.116555074000075],
              [-54.18797969599987, 3.130972799000091],
              [-54.21118241399998, 3.127407125000019],
              [-54.190460164999934, 3.178101705000088],
              [-54.17655920499996, 3.200580953000099],
              [-54.140023966999934, 3.24502268500008],
              [-54.11428910399985, 3.285381979000135],
              [-54.08080455699991, 3.309314029000092],
              [-54.080234334999915, 3.309721578000051],
              [-54.06948563699987, 3.327084859000067],
              [-54.06271602399994, 3.346696066000092],
              [-54.06033890799989, 3.364214376000064],
              [-54.055688028999924, 3.377676086000108],
              [-54.01935949799986, 3.41537404400006],
              [-54.003029744999935, 3.455397441000045],
              [-54.00628535999991, 3.531025900000088],
              [-53.998275512999925, 3.573038839000091],
              [-53.99026566599986, 3.59569895500006],
              [-53.98881872599986, 3.61099517800011],
              [-53.994813191999896, 3.623604228000133],
              [-54.00881750499991, 3.637918599000031],
              [-54.01786088099996, 3.641458435000089],
              [-54.02840287299992, 3.639830627000052],
              [-54.039409952999904, 3.636445821000038],
              [-54.05010697499992, 3.634533793000102],
              [-54.05067541599996, 3.640554098000052],
              [-54.07403316299991, 3.676107483000095],
              [-54.094445352999855, 3.747059225000086],
              [-54.10478063999997, 3.758040467000072],
              [-54.12550288999989, 3.788736267000104],
              [-54.13609655799988, 3.795738424000106],
              [-54.170203002999955, 3.805815328000051],
              [-54.18162349499994, 3.811008810000061],
              [-54.1873595779999, 3.814677837000147],
              [-54.19748815999995, 3.82689931200008],
              [-54.20704829899995, 3.846484680000088],
              [-54.21454138199991, 3.858215230000084],
              [-54.21800370299994, 3.857646789000029],
              [-54.22224117099998, 3.866199239000053],
              [-54.24105139199989, 3.876353658000113],
              [-54.26580440299992, 3.922526551000061],
              [-54.27252233899995, 3.92952870700006],
              [-54.28647497599994, 3.940716655000102],
              [-54.29314123599994, 3.949811707000066],
              [-54.30388993399987, 3.984460755000086],
              [-54.31019445899997, 3.994201762000031],
              [-54.34435258099995, 4.02494923900008],
              [-54.35386104299994, 4.041718241000041],
              [-54.35515295399989, 4.066522929000087],
              [-54.351018839999966, 4.08207753500011],
              [-54.33758296699992, 4.1166490680001],
              [-54.33468908699993, 4.131712748000098],
              [-54.3385648199999, 4.152331645000089],
              [-54.34890010599989, 4.160522359000112],
              [-54.38248978699991, 4.169565735000077],
              [-54.3948921299999, 4.177911479000045],
              [-54.40657100399997, 4.191528219000048],
              [-54.410550089999845, 4.208581441000078],
              [-54.39959468599997, 4.227262472000064],
              [-54.39318680899993, 4.244393209000108],
              [-54.39411698399988, 4.269818013000119],
              [-54.4029536539999, 4.312941997000038],
              [-54.433442748999965, 4.37637481700007],
              [-54.4508060309999, 4.484223532000073],
              [-54.44796382699991, 4.509544983000055],
              [-54.42817175299993, 4.546157736000097],
              [-54.42346919799988, 4.563391825000082],
              [-54.42346919799988, 4.604345398000106],
              [-54.42527787299994, 4.616050110000089],
              [-54.43773189399994, 4.648735453000072],
              [-54.43855871599996, 4.673281759000048],
              [-54.43514807099993, 4.692376200000126],
              [-54.435458130999905, 4.709403585000061],
              [-54.44734370899994, 4.727852071000072],
              [-54.45700720299996, 4.73332977300015],
              [-54.46729081299986, 4.736197815000125],
              [-54.475404011999956, 4.741727194000134],
              [-54.47865962699987, 4.755188904000093],
              [-54.47865962699987, 4.878669739000145],
              [-54.48496415299988, 4.892751567000076],
              [-54.486721150999955, 4.902957662000048],
              [-54.48212194899989, 4.912802022000022],
              [-54.45550858599995, 4.931431377000081],
              [-54.4508060309999, 4.93672821100003],
              [-54.44884232599995, 4.951481832000127],
              [-54.45757564299993, 4.991350199000067],
              [-54.45478511599987, 5.008532613000042],
              [-54.44863561999989, 5.024293925000023],
              [-54.430238810999896, 5.053387757000024],
              [-54.375616821999955, 5.114882711000035],
              [-54.37230952999997, 5.121058045000012],
              [-54.36988073799989, 5.132375183000079],
              [-54.36543656399991, 5.138757222000024],
              [-54.350036986999896, 5.149583436000057],
              [-54.34357743299995, 5.156378886000098],
              [-54.332001912999914, 5.196195577000111],
              [-54.32065194299989, 5.212454410000049],
              [-54.311331339999896, 5.225806173000066],
              [-54.269163370999934, 5.269085185000037],
              [-54.190460164999934, 5.325748393000111],
              [-54.17096920499995, 5.34837474200009],
              [-54.13752193899995, 5.360052802000041],
              [-54.106678839999915, 5.38117096600007],
              [-54.08043372299994, 5.407945054000038],
              [-54.061105923999946, 5.436509507000039],
              [-54.03311113199993, 5.505438544000071],
              [-54.013010219999956, 5.540594794000071],
              [-54.00719153599994, 5.558172919000071],
              [-53.99192502099993, 5.661347855000088],
              [-53.974242129999936, 5.692195860000083],
              [-53.9545851819999, 5.726126182000087],
              [-53.94434961699994, 5.744640779000065],
              [-53.93402292099995, 5.744765375000043],
              [-53.88977661899992, 5.738260363000052],
              [-53.85888293399995, 5.733765930000061],
              [-53.83559892199992, 5.723940846000062],
              [-53.81565116999991, 5.715919366000037],
              [-53.808287752999945, 5.714836134000052],
              [-53.81142424099994, 5.720604829000081],
              [-53.832422755999914, 5.731693648000089],
              [-53.82452494799992, 5.733223204000069],
              [-53.81033328199993, 5.731059818000062],
              [-53.77674203099991, 5.71415567400004],
              [-53.750213026999916, 5.696698701000059],
              [-53.732403966999925, 5.684202814000059],
              [-53.71458095399993, 5.67441425800007],
              [-53.695596104999936, 5.663456422000081],
              [-53.58258299399995, 5.617772066000043],
              [-53.54713874999993, 5.599942349000059],
              [-53.517322373999946, 5.580774589000043],
              [-53.4952102499999, 5.572104697000043],
              [-53.48180091099994, 5.569525458000044],
              [-53.44824939299991, 5.560945511000057],
              [-53.40781005799994, 5.561831606000055],
              [-53.33639431799992, 5.543917484000076],
              [-53.30270985599992, 5.535476236000079],
              [-53.27745207799995, 5.538191937000079],
              [-53.26391785099992, 5.529887600000052],
              [-53.24767005099994, 5.509751695000091],
              [-53.23009192599994, 5.495306708000044],
              [-53.207915818999936, 5.502346096000053],
              [-53.207774585999914, 5.514037084000051],
              [-53.22520761399994, 5.517059900000049],
              [-53.24402696699991, 5.529744527000048],
              [-53.26478195599992, 5.545825133000051],
              [-53.28270643299993, 5.550300827000058],
              [-53.28951169699991, 5.548901656000055],
              [-53.29141073399995, 5.554709668000044],
              [-53.28116976599995, 5.561878547000049],
              [-53.27147561499993, 5.560359586000061],
              [-53.25166383599992, 5.548626877000061],
              [-53.22118648499992, 5.536335553000072],
              [-53.177632127999914, 5.524431953000089],
              [-53.15539879699992, 5.514130353000041],
              [-53.1302468479999, 5.504770442000051],
              [-53.08250891799992, 5.472154039000088],
              [-53.046213344999956, 5.459662177000041],
              [-53.005848761999914, 5.450751044000071],
              [-53.00136455599994, 5.458642102000056],
              [-52.9945805669999, 5.457623554000065],
              [-52.96509665699995, 5.443866856000056],
              [-52.89651900699994, 5.405668008000077],
              [-52.829101661999914, 5.341883111000072],
              [-52.78316844699992, 5.316884190000053],
              [-52.75294894299992, 5.267352196000047],
              [-52.68122311099995, 5.210353908000059],
              [-52.54092363199993, 5.079006252000056],
              [-52.529855923999946, 5.073431708000044],
              [-52.52611243399991, 5.070746161000045],
              [-52.526682094999956, 5.064520575000074],
              [-52.52798417899993, 5.057928778000075],
              [-52.52672278599994, 5.053615627000056],
              [-52.52183997299994, 5.052679755000042],
              [-52.509755011999914, 5.054510809000078],
              [-52.50499426999994, 5.053615627000056],
              [-52.479725714999915, 5.039618231000077],
              [-52.402333136999914, 4.973822333000044],
              [-52.38003495999993, 4.936835028000075],
              [-52.38898678299995, 4.895900783000059],
              [-52.37071692599994, 4.907212632000039],
              [-52.34512285099993, 4.942857164000088],
              [-52.32371985599991, 4.950588283000059],
              [-52.29995683499993, 4.945054429000038],
              [-52.27912350199995, 4.931219794000071],
              [-52.26427161399994, 4.912502346000053],
              [-52.25861568899995, 4.892482815000051],
              [-52.27651933499993, 4.859320380000042],
              [-52.31314042899993, 4.810777085000041],
              [-52.343006964999915, 4.76117584800005],
              [-52.34048417899993, 4.724595445000091],
              [-52.33433997299994, 4.724595445000091],
              [-52.33165442599994, 4.738348700000074],
              [-52.32457434799994, 4.747992255000042],
              [-52.31720943899995, 4.755194403000075],
              [-52.31383216099994, 4.761867580000057],
              [-52.308583136999914, 4.787258205000057],
              [-52.30016028599994, 4.813381252000056],
              [-52.28579667899993, 4.829575914000088],
              [-52.242746548999946, 4.85618724200009],
              [-52.23192298099991, 4.875433661000045],
              [-52.21349036399994, 4.866685289000088],
              [-52.19286048099991, 4.849676825000074],
              [-52.17613684799994, 4.829169012000079],
              [-52.169260219999956, 4.809963283000059],
              [-52.159494594999956, 4.795599677000041],
              [-52.09410559799994, 4.75812409100007],
              [-52.06017005099994, 4.730454820000091],
              [-52.02452551999994, 4.693548895000049],
              [-51.99632727799991, 4.652289130000042],
              [-51.98485266799992, 4.611314195000091],
              [-51.97960364499994, 4.571437893000052],
              [-51.95604407499991, 4.494045315000051],
              [-51.95075436099995, 4.454006252000056],
              [-51.961822068999936, 4.408392645000049],
              [-51.988392706999946, 4.385687567000048],
              [-52.01992753799993, 4.367010809000078],
              [-52.04629472599993, 4.333563544000071],
              [-51.985585089999915, 4.352606512000079],
              [-51.95140540299991, 4.370672919000071],
              [-51.93651282499991, 4.391913153000075],
              [-51.93431555899991, 4.402167059000078],
              [-51.92491614499994, 4.429348049000055],
              [-51.922759568999936, 4.447088934000078],
              [-51.93126380099994, 4.590399481000077],
              [-51.92540442599994, 4.626206773000092],
              [-51.90916907499991, 4.65570709800005],
              [-51.89639238199993, 4.66469961100006],
              [-51.88121497299994, 4.667792059000078],
              [-51.86481686099995, 4.66478099200009],
              [-51.84829667899993, 4.65570709800005],
              [-51.80150305899991, 4.612697658000059],
              [-51.793080206999946, 4.601141669000071],
              [-51.800770636999914, 4.589667059000078],
              [-51.773548956999946, 4.551988023000092],
              [-51.76512610599991, 4.529038804000038],
              [-51.76357988199993, 4.506089585000041],
              [-51.75804602799991, 4.477769273000092],
              [-51.74754798099991, 4.457180080000057],
              [-51.731027798999946, 4.457098700000074],
              [-51.73302161399994, 4.44790273600006],
              [-51.73770097599993, 4.440375067000048],
              [-51.74242102799991, 4.436021226000094],
              [-51.744699673999946, 4.436590887000079],
              [-51.74372311099995, 4.428900458000044],
              [-51.73843339799993, 4.413031317000048],
              [-51.73094641799992, 4.399359442000048],
              [-51.71426347599993, 4.39524974200009],
              [-51.69762122299994, 4.393052476000094],
              [-51.69005286399994, 4.38507721600007],
              [-51.69408118399991, 4.371039130000042],
              [-51.703114386999914, 4.363511460000041],
              [-51.71226966099994, 4.353745835000041],
              [-51.716786261999914, 4.333563544000071],
              [-51.71467037699995, 4.316148179000038],
              [-51.70848548099991, 4.300360419000071],
              [-51.66930091099994, 4.242092190000051],
              [-51.65672766799992, 4.217271226000094],
              [-51.65070553299995, 4.190008856000077],
              [-51.64903723899994, 4.152329820000091],
              [-51.65249589799993, 4.122056382000039],
              [-51.67223059799994, 4.060777085000041],
              [-51.68321692599994, 4.03937409100007],
              [-51.75794714399993, 4.002521668000085],
              [-51.78319108099987, 3.980946757000126],
              [-51.79753129099987, 3.949966736000107],
              [-51.806238769999936, 3.917513937000095],
              [-51.8186152749999, 3.891081442000115],
              [-51.83541011599996, 3.867542827000108],
              [-51.89972143499995, 3.796668600000061],
              [-51.93093400099991, 3.781398214000106],
              [-51.938659627999925, 3.773569234000078],
              [-51.94098506699996, 3.763569845000063],
              [-51.9381945399999, 3.742511699000133],
              [-51.9400807289999, 3.733959249000122],
              [-51.94871069399994, 3.725096741000115],
              [-51.9558162029999, 3.724424947000031],
              [-51.96330928599991, 3.725458476000114],
              [-51.972843587999904, 3.721686096000084],
              [-51.98842403199993, 3.70455535900004],
              [-51.99537451199993, 3.685331726000101],
              [-52.00310013899994, 3.642311096000114],
              [-52.012763630999956, 3.61910837900011],
              [-52.05449234999989, 3.556709087000058],
              [-52.06599035699992, 3.528855489000094],
              [-52.07418107099994, 3.516634013000072],
              [-52.09358557099992, 3.506867168000028],
              [-52.09379227799988, 3.499399923000084],
              [-52.0920352789999, 3.490201518000092],
              [-52.0927587489999, 3.481390686000097],
              [-52.2279184569999, 3.260112203000077],
              [-52.23807287599996, 3.249725240000146],
              [-52.25119868999994, 3.243058980000043],
              [-52.25926021399994, 3.243317363000102],
              [-52.26701167799993, 3.244919332000052],
              [-52.27946569799991, 3.242490539000087],
              [-52.299102741999945, 3.225333964000114],
              [-52.31935990399995, 3.177636617000061],
              [-52.35532670099994, 3.151591695000093],
              [-52.36183793099991, 3.131954651000058],
              [-52.361114461999904, 3.109320373000102],
              [-52.351554320999895, 3.06596384700012],
              [-52.353207967999964, 3.058419088000079],
              [-52.41656327299995, 2.942508850000081],
              [-52.422196003999915, 2.927471008000097],
              [-52.41785518399993, 2.915482076000046],
              [-52.41067215999996, 2.905560201000043],
              [-52.4092768969999, 2.897343649000106],
              [-52.422351033999945, 2.890522359000059],
              [-52.43346146699986, 2.886594951000092],
              [-52.44162634299997, 2.881323954000052],
              [-52.448447631999926, 2.874347636000067],
              [-52.455268920999885, 2.865045878000032],
              [-52.533300333999904, 2.689862773000129],
              [-52.539604858999894, 2.659425354000064],
              [-52.54296382699991, 2.65151886000011],
              [-52.55102534999992, 2.645989482000104],
              [-52.57159256999998, 2.638599752000104],
              [-52.57577836099992, 2.633742167000079],
              [-52.57205765799992, 2.622993470000068],
              [-52.5557795819999, 2.598137105000106],
              [-52.551903849999945, 2.586561585000069],
              [-52.55345414199988, 2.57338409400009],
              [-52.55794999299988, 2.565632630000081],
              [-52.563686075999954, 2.559328105000063],
              [-52.56906042499992, 2.55038808200004],
              [-52.59040279099992, 2.504706116000122],
              [-52.61918656499992, 2.463468323000114],
              [-52.656083536999944, 2.430912171000074],
              [-52.677219197999904, 2.390397847000074],
              [-52.690603393999936, 2.372982890000046],
              [-52.70770829299997, 2.358926901000117],
              [-52.81969112199991, 2.291540833000099],
              [-52.86273758999991, 2.274229228000095],
              [-52.88015254699994, 2.260379944000135],
              [-52.89239986199996, 2.236867167000057],
              [-52.9003063559999, 2.21412953800008],
              [-52.906714232999946, 2.204982808000082],
              [-52.91715287299988, 2.195732727000077],
              [-52.92314733899991, 2.193665670000115],
              [-52.9341027429999, 2.196404521000062],
              [-52.93906367999995, 2.195732727000077],
              [-52.944386352999885, 2.190978495000081],
              [-52.95322302299988, 2.179041240000046],
              [-52.95968257699994, 2.175217184000104],
              [-52.98092159099991, 2.173253479000067],
              [-53.01911047399997, 2.181986796000047],
              [-53.06122676599992, 2.186275940000101],
              [-53.09223262599994, 2.211907450000069],
              [-53.11336828599991, 2.219348856000096],
              [-53.13228186099994, 2.219297181000073],
              [-53.25284297699989, 2.196507873000087],
              [-53.26850093599995, 2.195732727000077],
              [-53.27971472199991, 2.204982808000082],
              [-53.27222163899995, 2.219968974000068],
              [-53.2543415939999, 2.234179993000026],
              [-53.234652872999845, 2.241259665000143],
              [-53.23418778499993, 2.25097483400009],
              [-53.29743973799992, 2.303684794000105],
              [-53.32255448499993, 2.338566386000082],
              [-53.33092606699992, 2.345697734000026],
              [-53.3441035569999, 2.349625143000083],
              [-53.34880611199986, 2.34766143800006],
              [-53.3510798749999, 2.341718649000128],
              [-53.37852006099993, 2.307560527000064],
              [-53.39040563999987, 2.299033915000052],
              [-53.42544226099989, 2.286011455000107],
              [-53.462132527999955, 2.258984681000058],
              [-53.47324296099987, 2.254127096000047],
              [-53.51153519699997, 2.252266744000039],
              [-53.53179235899998, 2.247047424000115],
              [-53.54734696499992, 2.251749980000099],
              [-53.57902461799992, 2.270405172000068],
              [-53.59530269399994, 2.273867493000097],
              [-53.62946081599992, 2.275314433000091],
              [-53.64599727399991, 2.278466695000063],
              [-53.71317663599987, 2.307353821000106],
              [-53.742167114999944, 2.308542379000116],
              [-53.74873002199993, 2.312676494000058],
              [-53.74816158099989, 2.319342753000058],
              [-53.738033, 2.338824768000052],
              [-53.737361205999946, 2.349056702000041],
              [-53.748264933999906, 2.364662985000081],
              [-53.764801391999896, 2.368693746000076],
              [-53.78345658399988, 2.36409454400011],
              [-53.80097489399992, 2.353810934000123],
              [-53.81182694499998, 2.340426737000087],
              [-53.82107702699997, 2.323631897000027],
              [-53.83089554899996, 2.310144348000065],
              [-53.843452921999955, 2.306630351000109],
              [-53.866810668999904, 2.304925028000042],
              [-53.879368041999925, 2.290610657000059],
              [-53.88846309399989, 2.273815817000084],
              [-53.901227173999956, 2.264514059000064],
              [-53.9216393639999, 2.265960999000058],
              [-53.932904825999884, 2.269630026000058],
              [-53.93776241099988, 2.264617412000092],
              [-53.93874426299996, 2.240122783000047],
              [-53.94613399299996, 2.221984355000103],
              [-53.963910685999906, 2.209323629000068],
              [-54.00597530199991, 2.1943374640001],
              [-54.011711384999984, 2.19056508400007],
              [-54.02137487899992, 2.180591532000065],
              [-54.02798946099992, 2.178576152000105],
              [-54.033260457999944, 2.180333150000095],
              [-54.043337361999875, 2.187722880000095],
              [-54.048453328999955, 2.188808086000094],
              [-54.06927893099993, 2.188342998000067],
              [-54.07666866099993, 2.183692119000099],
              [-54.084213419999884, 2.169326070000096],
              [-54.09842443899993, 2.127959086000061],
              [-54.11139522299996, 2.114290670000045],
              [-54.1115266969999, 2.114270443000066],
            ],
          ],
          [
            [
              [2.521799927545686, 51.08754088371883],
              [2.537033325000095, 51.06461029100008],
              [2.547058553000113, 51.0204786180001],
              [2.556980428000116, 51.00117747000006],
              [2.592740519000131, 50.97611440000013],
              [2.608450154000082, 50.96112823500006],
              [2.611654093000055, 50.941232809000056],
              [2.605762980000065, 50.93523834300002],
              [2.582715291000113, 50.92066558900008],
              [2.576927531000138, 50.91151886000007],
              [2.596667928000102, 50.86764556900006],
              [2.595531046000076, 50.861134339],
              [2.587779582000081, 50.85002390600006],
              [2.586746053000098, 50.845424704000024],
              [2.589949992000072, 50.84201405900011],
              [2.602042277000066, 50.83808664900003],
              [2.606589803000077, 50.83483103400006],
              [2.615168091000015, 50.822170309000015],
              [2.620439087000136, 50.81648590200005],
              [2.627777140000148, 50.814418844],
              [2.642453247000049, 50.81245513900008],
              [2.650618123000044, 50.8122484340001],
              [2.669221639000114, 50.81390207900007],
              [2.678730102000088, 50.81323028600006],
              [2.691855916000065, 50.808837789000094],
              [2.696920207000119, 50.8030500280001],
              [2.700020792000089, 50.79628041600007],
              [2.706635376000065, 50.78878733400005],
              [2.743842407000074, 50.766204732000105],
              [2.74952681500011, 50.75959014900009],
              [2.762962687000083, 50.73938466500003],
              [2.768233683000119, 50.733235169000054],
              [2.786733846000033, 50.72336497000005],
              [2.866725884000061, 50.70009100300007],
              [2.87127648900011, 50.69876698900008],
              [2.886882772000149, 50.696648255000085],
              [2.900111938000038, 50.70310780900006],
              [2.930187622000119, 50.736232402000056],
              [2.948377726000047, 50.748686422000034],
              [2.971425415000112, 50.757833150000025],
              [3.023816593000049, 50.76826211600007],
              [3.103303671000049, 50.784084778000064],
              [3.129245239000085, 50.7790721650001],
              [3.146195109000104, 50.768891907000025],
              [3.162810519000061, 50.74993907500003],
              [3.176684204000082, 50.73411366800009],
              [3.188983195000048, 50.715096742000114],
              [3.1969413650001, 50.70920562800002],
              [3.210997355000103, 50.707965394000084],
              [3.224433227000077, 50.705174866000036],
              [3.232391398000118, 50.695924785],
              [3.243760213000115, 50.67210195000003],
              [3.229807576000042, 50.65541046200009],
              [3.237869100000097, 50.626471660000036],
              [3.264327433000091, 50.570196025000044],
              [3.265877726000042, 50.53831166600007],
              [3.27104537000011, 50.5269428510001],
              [3.286755005000089, 50.51407542],
              [3.299880819000066, 50.50746083600011],
              [3.343599080000047, 50.492939759000066],
              [3.361065714000091, 50.48978749700008],
              [3.385353637000094, 50.491647848000085],
              [3.429175252000078, 50.50182810500006],
              [3.442714477000067, 50.50849436500009],
              [3.45263635200007, 50.514850566000106],
              [3.462868286000059, 50.51913971000006],
              [3.477130982000119, 50.51986318000006],
              [3.491497029000129, 50.517072652000095],
              [3.498008260000091, 50.511853332],
              [3.496457967000083, 50.50379181000001],
              [3.486742798000137, 50.49268137600008],
              [3.499145142000089, 50.48679026300009],
              [3.56374068100007, 50.48653188100012],
              [3.586374959000096, 50.48348297100007],
              [3.608285766000051, 50.47650665300007],
              [3.628129517000048, 50.46436269200008],
              [3.644355916000052, 50.44550079300005],
              [3.652830851000147, 50.40684682200005],
              [3.652934204000076, 50.36018300400009],
              [3.661719198000071, 50.31930694600008],
              [3.696859172000131, 50.298222962000054],
              [3.700786580000084, 50.304682516000085],
              [3.702233520000078, 50.30525095600005],
              [3.703887167000119, 50.30432078000011],
              [3.708434692000083, 50.30633616200005],
              [3.711121867000088, 50.30933339500005],
              [3.71546268700007, 50.31765330000003],
              [3.733446085000054, 50.33723866800004],
              [3.741507609000053, 50.34312978100006],
              [3.755046834000041, 50.34633372100002],
              [3.798661743000082, 50.348452454],
              [3.840209595000061, 50.345196839000025],
              [3.860880168000079, 50.33847890200009],
              [3.878036743000052, 50.330779114000094],
              [3.895916789000097, 50.32530141300002],
              [3.918551066000049, 50.32545644100004],
              [3.982113077000122, 50.34261301700009],
              [4.003300415000098, 50.344059957000084],
              [4.022730753000076, 50.33811716700008],
              [4.055907023000088, 50.31455271500009],
              [4.077197713000146, 50.30664622000005],
              [4.097868286000079, 50.29481231700002],
              [4.125256795000041, 50.25714019800007],
              [4.143653605000111, 50.25161082000007],
              [4.150991658000123, 50.256261698000046],
              [4.149751424000073, 50.26313466500001],
              [4.150268189000116, 50.26954254200005],
              [4.162773885000121, 50.272953187000084],
              [4.17176558500006, 50.27088612900012],
              [4.185201457000119, 50.26546010400004],
              [4.197603800000081, 50.25848378500005],
              [4.203701619000128, 50.25197255400009],
              [4.20132450300008, 50.24153391600005],
              [4.19150598100012, 50.234299215000064],
              [4.167941528000114, 50.22246531200007],
              [4.157296183000113, 50.212698466000106],
              [4.152748657000103, 50.20453359],
              [4.147374308000025, 50.18634348600004],
              [4.128150675000114, 50.146242575000045],
              [4.125773559000066, 50.12815582300003],
              [4.139932902000112, 50.12355662000009],
              [4.159880005000048, 50.12939605800007],
              [4.170628703000148, 50.13048126200006],
              [4.180550578000037, 50.12722564700009],
              [4.197397095000042, 50.08407582700006],
              [4.203391561000046, 50.074670716000114],
              [4.210316203000048, 50.066712545000044],
              [4.210006144000147, 50.060149638000055],
              [4.186028279000141, 50.05244984900007],
              [4.162877238000135, 50.04180450500009],
              [4.14458378100008, 50.030797425000074],
              [4.137349080000092, 50.025061341000125],
              [4.132284790000114, 50.017568258],
              [4.128150675000114, 50.005786031000085],
              [4.132904907000096, 50.004494121000036],
              [4.138382609000075, 49.98919789700007],
              [4.139622843000041, 49.97452179],
              [4.132364978000112, 49.974945951],
              [4.131664672000056, 49.974986878000024],
              [4.187681925000078, 49.95550486300003],
              [4.201117798000041, 49.95302439400005],
              [4.215952935000132, 49.95440767000012],
              [4.27759891700012, 49.960155742],
              [4.427651209000089, 49.93357167400008],
              [4.435108683000095, 49.932250468000106],
              [4.464770956000081, 49.935609436000036],
              [4.60419396900005, 49.98020619800003],
              [4.645845174000073, 49.9844953420001],
              [4.656697225000102, 49.989094544000054],
              [4.665895629000119, 50.00051503500005],
              [4.672923624000134, 50.01637970000006],
              [4.680571737000093, 50.04831573500006],
              [4.67953820800011, 50.0551887000001],
              [4.675817505000111, 50.06020131500007],
              [4.673440389000064, 50.06619578100002],
              [4.676127563000108, 50.07606598000008],
              [4.681915324000073, 50.08392079700012],
              [4.788575480000134, 50.153373922000085],
              [4.815550578000085, 50.16133209200005],
              [4.820098103000106, 50.14644928000011],
              [4.831363566000078, 50.143400371000084],
              [4.862679484000097, 50.147586162000025],
              [4.871877889000075, 50.13978302],
              [4.870534302000124, 50.12226471000004],
              [4.865159953000074, 50.10159413700002],
              [4.86288619000004, 50.08407582700006],
              [4.852137492000111, 50.09162058600002],
              [4.846039673000064, 50.09069041000005],
              [4.827229451000051, 50.064077047000026],
              [4.826092570000128, 50.05503367200008],
              [4.827642863000079, 50.046713766000025],
              [4.826712687000111, 50.036016744],
              [4.78826542200008, 49.97426340800003],
              [4.783924601000081, 49.95829539000009],
              [4.797257120000097, 49.944291077000074],
              [4.84459273300007, 49.93173370400008],
              [4.860199016000109, 49.91333689400007],
              [4.8619560140001, 49.90031443300005],
              [4.85937219200008, 49.891684469],
              [4.854307902000102, 49.88331288700003],
              [4.848933553000052, 49.87106557200009],
              [4.845626261000064, 49.86584625300007],
              [4.836737915000128, 49.85912831700004],
              [4.834877564000124, 49.85303049800008],
              [4.836944620000082, 49.848017884000015],
              [4.846763142000071, 49.837527568000084],
              [4.849243611000134, 49.83158477800005],
              [4.849036906000066, 49.7941710410001],
              [4.858028605000129, 49.78657460500004],
              [4.884176879000023, 49.78414581300008],
              [4.906604451000106, 49.786471252000084],
              [4.950012654000119, 49.796393128],
              [4.968370957000019, 49.79698095600007],
              [4.970993286000123, 49.797064922000075],
              [4.989080037000122, 49.79055369100011],
              [5.026287068000045, 49.76673085600005],
              [5.04623417200014, 49.75939280200005],
              [5.081890909000037, 49.75272654300004],
              [5.093776489000078, 49.74533681200002],
              [5.13635787000004, 49.705339254000066],
              [5.151240682000093, 49.69598582000002],
              [5.169430786000135, 49.687200827000126],
              [5.192478475000087, 49.682808329000025],
              [5.237643677000079, 49.690973206000066],
              [5.259244425000134, 49.69133494100005],
              [5.280121704000095, 49.67789906900002],
              [5.299448690000048, 49.662499492],
              [5.306373332000135, 49.647513327000055],
              [5.301825806000096, 49.64389597600005],
              [5.293764282000012, 49.64053700800004],
              [5.29066369700007, 49.62637766600001],
              [5.2930408120001, 49.617179261],
              [5.29789839700004, 49.61325185200003],
              [5.314538208000073, 49.61113311800007],
              [5.321669555000085, 49.61258005800006],
              [5.326940552000025, 49.61764434900003],
              [5.331178019000077, 49.62312205000002],
              [5.334898722000077, 49.625809225000054],
              [5.341099894000081, 49.62513743200007],
              [5.352468709000078, 49.62069325800006],
              [5.3834745690001, 49.61330352800006],
              [5.391165749000066, 49.608817006],
              [5.402078084000038, 49.602451477],
              [5.450240519000118, 49.545762431000085],
              [5.454374633000043, 49.53661570300001],
              [5.454167928000089, 49.52617706300008],
              [5.450963989000115, 49.51677195200001],
              [5.449930461000037, 49.50783193000008],
              [5.456131633000041, 49.49894358400009],
              [5.477732381000095, 49.49522288100006],
              [5.503673950000064, 49.50509307900005],
              [5.528788696000078, 49.517960511000055],
              [5.547598918000091, 49.52343821200013],
              [5.578914836000081, 49.51392974900004],
              [5.587493124000019, 49.51243113300005],
              [5.60227258300003, 49.5137230430001],
              [5.605579875000046, 49.517753805],
              [5.607853638000051, 49.524936829000055],
              [5.619739217000074, 49.535530497000124],
              [5.644647257000145, 49.543798727000066],
              [5.667178182000072, 49.54043975900005],
              [5.688675578000101, 49.53351511700008],
              [5.710276327000088, 49.531086325],
              [5.72267867000005, 49.53460032200006],
              [5.735597779000074, 49.54571075500009],
              [5.74634647600007, 49.549431458000086],
              [5.757095174000114, 49.54839792900002],
              [5.779005982000058, 49.539612936000125],
              [5.790684855000023, 49.53775258500012],
              [5.822104126000056, 49.51051910500003],
              [5.8395707600001, 49.49987376000003],
              [5.864685506000029, 49.49217397100004],
              [5.928144165000077, 49.482303772000066],
              [5.946954386000101, 49.4699531050001],
              [5.960700317000118, 49.44132436200003],
              [5.978063599000052, 49.44509674100006],
              [6.063329711000108, 49.44845571000006],
              [6.078005819000083, 49.45202138300003],
              [6.087720988000029, 49.46163319900005],
              [6.099813273000109, 49.46463043200005],
              [6.102087036000057, 49.470004781000014],
              [6.1019836830001, 49.47641265900005],
              [6.10725467900005, 49.482510478],
              [6.11438602700008, 49.48437083000003],
              [6.142601359000139, 49.48607615200008],
              [6.136090129000081, 49.49527455600007],
              [6.193554321000079, 49.49940867200009],
              [6.221976359000109, 49.49744496700008],
              [6.249364868000072, 49.49031361900005],
              [6.251116525000043, 49.489459778000096],
              [6.298767538000078, 49.466232402000074],
              [6.325329224000086, 49.456723938000025],
              [6.345307071000093, 49.4553486520001],
              [6.353854614000056, 49.45476023400006],
              [6.364499959000057, 49.45610382100004],
              [6.383516886000109, 49.46463043200005],
              [6.391681763000122, 49.466697490000016],
              [6.402740519000133, 49.46545725500009],
              [6.494517863000056, 49.43553660100004],
              [6.511674438000114, 49.424736226],
              [6.517875610000118, 49.41641632100006],
              [6.520562785000038, 49.40814809200002],
              [6.520769491000095, 49.4025670380001],
              [6.518805786000058, 49.40215362600007],
              [6.525730428000145, 49.39548736600007],
              [6.574306274000037, 49.36179433200003],
              [6.577716919000068, 49.35579986600008],
              [6.573376098000097, 49.3477383430001],
              [6.555599406000056, 49.34716990200003],
              [6.550121704000077, 49.33802317300005],
              [6.556426228000078, 49.326395976000086],
              [6.573169393000029, 49.313115133000096],
              [6.639676961000106, 49.27115387],
              [6.641227254000114, 49.266916403000025],
              [6.639160196000148, 49.256787822],
              [6.640297078000089, 49.25275706000009],
              [6.645671427000138, 49.25001820900003],
              [6.659520711000084, 49.24676259400006],
              [6.663758179000041, 49.24386871300008],
              [6.671612996000079, 49.22531687500005],
              [6.674816935000138, 49.221131084],
              [6.675953817000078, 49.2189089970001],
              [6.677917521000097, 49.21105418000006],
              [6.680604696000046, 49.207488505000086],
              [6.685048868000138, 49.20779856400007],
              [6.698484741000073, 49.21358632400005],
              [6.702515503000086, 49.213638001000064],
              [6.708820027000087, 49.197773336000054],
              [6.703755737000108, 49.18511261000002],
              [6.700965210000049, 49.17286529600007],
              [6.713780965000126, 49.158860982000064],
              [6.725563192000038, 49.155553691000065],
              [6.770108276000144, 49.15529530900001],
              [6.809072306000132, 49.145838522000034],
              [6.821784709000099, 49.147750550000055],
              [6.839044637000086, 49.16278839200005],
              [6.835220581000044, 49.17937652600004],
              [6.827675822000089, 49.19555125000004],
              [6.833463583000054, 49.20945221000004],
              [6.843488810000082, 49.21105418000006],
              [6.885243367000044, 49.20480133100007],
              [6.914388876000146, 49.206661683000064],
              [6.925447632000044, 49.205576477000065],
              [6.987872762000109, 49.18242543600009],
              [7.009473510000078, 49.18170196500007],
              [7.008956746000138, 49.146406963000075],
              [7.020532267000078, 49.11896677700004],
              [7.042546427000076, 49.10759796200004],
              [7.073242228000112, 49.12031036400002],
              [7.07479252100012, 49.12537465500007],
              [7.071588582000061, 49.13059397400009],
              [7.07076175900005, 49.13612335300009],
              [7.079856812000116, 49.142014465],
              [7.085334513000106, 49.14154937800008],
              [7.123575073000097, 49.12330759700002],
              [7.139284708000048, 49.11793324800006],
              [7.154994344000016, 49.114419251000086],
              [7.241190633000144, 49.11390248600007],
              [7.268062378000138, 49.10563425700012],
              [7.274366902000054, 49.10501414000005],
              [7.280258016000062, 49.10899322600004],
              [7.290800008000105, 49.12310089200007],
              [7.297104533000038, 49.12811350500003],
              [7.305992879000144, 49.130128887000055],
              [7.326456746000105, 49.13183420800003],
              [7.33400150600005, 49.13415964800005],
              [7.339065796000028, 49.139689026000056],
              [7.346300496000111, 49.154210104000114],
              [7.350951376000069, 49.15917104200007],
              [7.367591186000084, 49.165372213000055],
              [7.371633809000087, 49.1661736140001],
              [7.39105228700015, 49.17002309200011],
              [7.410482625000043, 49.1689378870001],
              [7.414823446000128, 49.15777577800007],
              [7.458024942000065, 49.15586375000005],
              [7.476111694000082, 49.15152292900008],
              [7.482726278000058, 49.13705352800004],
              [7.475284871000042, 49.13390126600008],
              [7.472804403000083, 49.131627503000075],
              [7.471047404000103, 49.12832021200008],
              [7.485103394000106, 49.11870839500007],
              [7.507737671000058, 49.09457550100011],
              [7.52086348500012, 49.08367177400005],
              [7.542670939000061, 49.07457672200006],
              [7.586389201000117, 49.06956410700012],
              [7.608610066000068, 49.06196767200005],
              [7.61594812000007, 49.05597320600002],
              [7.625663289000101, 49.043002421],
              [7.634965047000037, 49.03778310100007],
              [7.644938840000066, 49.036294476000094],
              [7.648814331000096, 49.035716045000115],
              [7.660803264000066, 49.037731425000075],
              [7.672482137000117, 49.04103871700006],
              [7.685091187000069, 49.04279571600004],
              [7.696149943000052, 49.041555481],
              [7.717337281000113, 49.03659454400007],
              [7.726949096000112, 49.0356643680001],
              [7.739144735000139, 49.037731425000075],
              [7.762605835000102, 49.04615468300004],
              [7.773664591000113, 49.048118388],
              [7.856863647000125, 49.03225372300007],
              [7.913811075000098, 49.036181133000056],
              [7.931897827000114, 49.03483754600008],
              [8.090441121000083, 48.97918202800007],
              [8.188729695000092, 48.96574615500002],
              [8.200305216000032, 48.95856313100005],
              [8.1998915450001, 48.95825033100003],
              [8.179324585000131, 48.942698467000056],
              [8.14811202000007, 48.90373443600005],
              [8.102740112000049, 48.82131052600006],
              [8.090337769000143, 48.80751292000009],
              [8.084239950000097, 48.804050598000075],
              [8.047549682000124, 48.791028137000026],
              [8.038764689000061, 48.790769756000074],
              [8.03659427900007, 48.7882892870001],
              [8.031943400000102, 48.78534373000009],
              [8.02729252100005, 48.78002105800003],
              [8.025122111000144, 48.77061594700008],
              [8.022951701000068, 48.765086569000076],
              [8.017267293000117, 48.761830954000104],
              [8.009619181000119, 48.76007395400002],
              [7.981507202000103, 48.75976389600005],
              [7.970138387000105, 48.757283427000075],
              [7.96486739100007, 48.74834340500003],
              [7.963627157000133, 48.729274801000045],
              [7.959182983000119, 48.72136830700002],
              [7.948434285000104, 48.71185984400002],
              [7.935205119000102, 48.70333323200002],
              [7.92331953900009, 48.698217265000025],
              [7.895931030000042, 48.676513163000024],
              [7.880634806000074, 48.667728170000046],
              [7.864098348000084, 48.66416249700005],
              [7.852419475000119, 48.65868479400008],
              [7.810251506000071, 48.6150182090001],
              [7.801776571000062, 48.58235870400004],
              [7.801673217000115, 48.54758046500008],
              [7.813455444000027, 48.52634145100002],
              [7.813455444000027, 48.51946848600004],
              [7.788444051000027, 48.50634267200009],
              [7.776455119000076, 48.498177796000064],
              [7.771287475000065, 48.4891085820001],
              [7.769220419000106, 48.47006581700002],
              [7.764156128000138, 48.46035064800007],
              [7.757644897000148, 48.453891093000024],
              [7.75072025500009, 48.44440846800005],
              [7.745655965000111, 48.43301381400006],
              [7.738317912000099, 48.406607158000085],
              [7.737181030000102, 48.39348134400002],
              [7.740384969000075, 48.381440736000044],
              [7.746896199000048, 48.36867665700008],
              [7.751960490000016, 48.355344137000046],
              [7.75072025500009, 48.34136566200006],
              [7.736974325000062, 48.32666371700007],
              [7.71857751500005, 48.31999745700004],
              [7.702454467000081, 48.31118662500005],
              [7.695529825000079, 48.29018015600006],
              [7.693462769000121, 48.26987131800003],
              [7.687158243000113, 48.25292144800004],
              [7.676616252000144, 48.23840037100008],
              [7.613364298000079, 48.179205018000104],
              [7.606749715000149, 48.16698354100008],
              [7.604786010000026, 48.15256581600006],
              [7.599721720000048, 48.144710999000026],
              [7.592900431000089, 48.13866485600009],
              [7.58566573000013, 48.129724833000054],
              [7.578947795000119, 48.11448028600002],
              [7.5726432700001, 48.09497243300011],
              [7.575743856000145, 48.05370880200009],
              [7.618945353000072, 48.00265248700002],
              [7.621115763000063, 47.971439922000044],
              [7.611607300000088, 47.95939931300008],
              [7.584942261000037, 47.94040822400011],
              [7.579567911000083, 47.927049866000075],
              [7.580808146000038, 47.910797628000054],
              [7.578947795000119, 47.90632761700006],
              [7.5726432700001, 47.89630238900013],
              [7.568612508000115, 47.891367290000076],
              [7.561997925000099, 47.88705230700002],
              [7.55900069100008, 47.88271148800003],
              [7.557863810000072, 47.878525697],
              [7.558380575000115, 47.87599355100009],
              [7.559207397000137, 47.873461405000015],
              [7.55900069100008, 47.86901723300012],
              [7.564168334000101, 47.85041371700005],
              [7.561997925000099, 47.83922576900004],
              [7.548458699000122, 47.834238993000056],
              [7.542877645000118, 47.829433086000066],
              [7.528614949000143, 47.797031963000066],
              [7.525927775000099, 47.783156840000075],
              [7.538330119000079, 47.748146057000085],
              [7.537813355000139, 47.73181630400005],
              [7.531922241000132, 47.72520172200005],
              [7.515385783000056, 47.71331614200001],
              [7.511871785000096, 47.70732167600009],
              [7.514662312000041, 47.685798442000035],
              [7.517866251000015, 47.67502390600002],
              [7.521793660000071, 47.67042470400007],
              [7.536573120000099, 47.66520538400003],
              [7.550112345000088, 47.65244130500007],
              [7.5726432700001, 47.62200388600009],
              [7.578637735000115, 47.61693959600002],
              [7.58504561400008, 47.61316721600009],
              [7.590316609000098, 47.607947896000084],
              [7.592487020000078, 47.59841359500008],
              [7.590109904000144, 47.59482208300001],
              [7.586028488000125, 47.584618544000065],
              [7.585482836000097, 47.584479135],
              [7.550319051000116, 47.57549509700006],
              [7.52634118600011, 47.56645172100009],
              [7.520866596000104, 47.56341604800009],
              [7.482726278000058, 47.54226715100005],
              [7.485103394000106, 47.54159535700005],
              [7.501743205000139, 47.5329653940001],
              [7.505153850000056, 47.53301707000013],
              [7.505463908000138, 47.52301768100001],
              [7.501123087000082, 47.517307434000045],
              [7.493061564000072, 47.51549875900007],
              [7.482726278000058, 47.51699737600008],
              [7.476938517000093, 47.5148786430001],
              [7.475594930000028, 47.51172637900005],
              [7.477765340000104, 47.50769561800006],
              [7.484896688000049, 47.5009001670001],
              [7.485776134000076, 47.498767511000025],
              [7.485930217000146, 47.49839386000012],
              [7.485826864000103, 47.4957842000001],
              [7.484483276000049, 47.492941997000045],
              [7.482726278000058, 47.49126251200006],
              [7.467430053000101, 47.481909078000044],
              [7.454510946000113, 47.48320098900008],
              [7.445995797000137, 47.4868841290001],
              [7.44148848500015, 47.48883372000002],
              [7.425985555000068, 47.49250274700002],
              [7.414306681000085, 47.49017730700008],
              [7.414410034000099, 47.48402781200009],
              [7.419474325000095, 47.47785247800003],
              [7.422781616000094, 47.47542368600007],
              [7.427639200000101, 47.4707469690001],
              [7.429292847000056, 47.46511423800008],
              [7.426088908000082, 47.45576080300005],
              [7.420563120000111, 47.4508570280001],
              [7.406348511000118, 47.43824249300006],
              [7.388218887000107, 47.433288860000104],
              [7.37854659000007, 47.43064605800002],
              [7.336930048000085, 47.43185368000009],
              [7.309093465000103, 47.43266143800007],
              [7.282635132000109, 47.42888905900013],
              [7.244807984000118, 47.417726949],
              [7.2380900470001, 47.41679677300006],
              [7.230338583000105, 47.419018861000055],
              [7.226307820000102, 47.42263621100004],
              [7.223517293000043, 47.42622772300011],
              [7.219383179000118, 47.4284756470001],
              [7.190030965000034, 47.434728496000034],
              [7.168326863000061, 47.44356516500001],
              [7.1626424560001, 47.459894918000046],
              [7.180832560000056, 47.48826528000005],
              [7.15365075700015, 47.486404928000056],
              [7.142169389000088, 47.48765096800004],
              [7.140318237000116, 47.48785186800005],
              [7.127295776000096, 47.492941997000045],
              [7.10373132300009, 47.49627512600004],
              [7.053915242000073, 47.49038401300005],
              [7.027973674000094, 47.492941997000045],
              [7.018878621000056, 47.49767039000001],
              [7.009783569000149, 47.499246522000035],
              [7.000791870000114, 47.49767039000001],
              [6.991903524000094, 47.492941997000045],
              [6.973300008000137, 47.48909210300009],
              [6.975780477000114, 47.477955831000074],
              [6.986115763000043, 47.4641323850001],
              [6.990973348000068, 47.45222096800008],
              [6.983428589000113, 47.443797709000066],
              [6.968545777000145, 47.43519358300004],
              [6.952319376000048, 47.4288373830001],
              [6.926067749000111, 47.42485829700003],
              [6.924517456000103, 47.4059964],
              [6.898782593000107, 47.39571279000002],
              [6.884003133000078, 47.38258697600004],
              [6.871600789000126, 47.36695485500009],
              [6.866639852000077, 47.35416493700002],
              [6.985598999000104, 47.36212310800009],
              [7.003995809000088, 47.36814341300003],
              [7.018878621000056, 47.359901021000084],
              [7.033864787000113, 47.35065094000008],
              [7.044303426000056, 47.34049652100002],
              [7.036551961000043, 47.329515279000034],
              [7.027146850000094, 47.32543284100002],
              [7.016914917000094, 47.32352081300009],
              [7.00647627800015, 47.31936086000006],
              [6.991903524000094, 47.30595082700002],
              [6.986529174000054, 47.304503887000024],
              [6.97743412300008, 47.30372873900002],
              [6.958623901000067, 47.290551250000036],
              [6.952216024000023, 47.27003570500007],
              [6.956246785000104, 47.245231018000126],
              [6.88834395300006, 47.21130544100002],
              [6.859301798000075, 47.19091908800006],
              [6.840284871000108, 47.16952504500007],
              [6.838076256000079, 47.168131597000055],
              [6.774759155000112, 47.12818389900012],
              [6.744786824000073, 47.12105255100009],
              [6.746027059000113, 47.10394765300005],
              [6.731661011000085, 47.09888336300007],
              [6.727940307000097, 47.09712636300007],
              [6.724219604000069, 47.090770162000055],
              [6.699104858000055, 47.084620667000095],
              [6.689699747000105, 47.07829030400008],
              [6.676263875000132, 47.06239980100004],
              [6.688252807000111, 47.043847961000026],
              [6.665411824000103, 47.02129119900009],
              [6.598697550000082, 46.98653879800004],
              [6.491107218000138, 46.96338775700006],
              [6.442634725000062, 46.94416412400004],
              [6.427751913000122, 46.909075827],
              [6.431886027000132, 46.90003245100003],
              [6.445218546000063, 46.88261749300001],
              [6.44842248600014, 46.871558737],
              [6.4467688390001, 46.85770945300003],
              [6.443117662000049, 46.851455121000086],
              [6.441187785000068, 46.848149313000036],
              [6.434263143000095, 46.8395451870001],
              [6.418553507000127, 46.80701487200007],
              [6.417106568000122, 46.80215728800003],
              [6.419897095000096, 46.79652455700001],
              [6.425168090000113, 46.791615296000074],
              [6.432609497000044, 46.785982565000054],
              [6.433022908000055, 46.76911021000005],
              [6.429198853000116, 46.76081614200011],
              [6.417933390000144, 46.75110097300008],
              [6.407391398000101, 46.745700786],
              [6.374215128000088, 46.733608501000035],
              [6.347860148000109, 46.71317047200007],
              [6.337938273000105, 46.707408550000096],
              [6.266314738000062, 46.680355937000044],
              [6.131852661000039, 46.595606588000024],
              [6.118416789000065, 46.58346262600013],
              [6.12151737500011, 46.570285137000056],
              [6.145701945000098, 46.551629944000084],
              [6.110355265000095, 46.52083079],
              [6.075525349000117, 46.479592998],
              [6.064156535000052, 46.471118063000105],
              [6.060229126000081, 46.46502024400003],
              [6.060229126000081, 46.459904277000064],
              [6.062399536000072, 46.45520172200007],
              [6.064776652000091, 46.45106760700004],
              [6.065500122000088, 46.44799285900011],
              [6.065500122000088, 46.44037058600004],
              [6.06756717900015, 46.43360097300011],
              [6.065706827000071, 46.427012228000095],
              [6.054234660000134, 46.41941579200004],
              [6.059019361000082, 46.417383211000086],
              [6.108184855000104, 46.39649729400013],
              [6.12286096200009, 46.385541891000045],
              [6.135056600000098, 46.37040069600003],
              [6.136400187000078, 46.35934194000002],
              [6.118607037000089, 46.331771085000085],
              [6.104050740000076, 46.3092158000001],
              [6.100743448000088, 46.30141265900009],
              [6.093612101000133, 46.273093974000076],
              [6.093095337000108, 46.26229360000006],
              [6.094025513000133, 46.25304351800004],
              [6.089684692000077, 46.24637725900003],
              [6.067670532000079, 46.241623027000045],
              [6.061882772000104, 46.24115793900002],
              [6.055888305000082, 46.24167470400006],
              [6.048033488000044, 46.243431702000024],
              [6.04617313600005, 46.243535055000066],
              [6.044519491000102, 46.243431702000024],
              [6.042865844000062, 46.24306996700004],
              [5.982921183000144, 46.2227094520001],
              [5.958529907000127, 46.21196075400009],
              [5.954809204000128, 46.19992014600011],
              [5.965247843000071, 46.18622589100009],
              [5.982921183000144, 46.17082631400011],
              [5.979820597000128, 46.162248027000075],
              [5.972172485000044, 46.15217112200004],
              [5.958839966000113, 46.13046702100003],
              [5.982921183000144, 46.14044057200006],
              [6.028293090000091, 46.147933655000074],
              [6.073871704000084, 46.14917389000003],
              [6.107874796000118, 46.13863189700005],
              [6.140327596000134, 46.15020741800002],
              [6.191383911000088, 46.19170359400009],
              [6.255359335000094, 46.22110748400006],
              [6.281197550000115, 46.24007273400012],
              [6.276029907000094, 46.263120423],
              [6.269001912000078, 46.26523915600005],
              [6.252258748000145, 46.2599164840001],
              [6.241820109000116, 46.26368886400003],
              [6.237582642000064, 46.26792633100008],
              [6.227970825000057, 46.284462789000074],
              [6.227454060000099, 46.28849355100009],
              [6.21825565600011, 46.305495097000104],
              [6.214121541000083, 46.315468649000096],
              [6.219495890000132, 46.32911122700001],
              [6.240579874000076, 46.348954977000105],
              [6.269105265000121, 46.37502573700009],
              [6.301558065000052, 46.39448191400008],
              [6.332357218000112, 46.40138071700004],
              [6.365223430000128, 46.40244008400005],
              [6.397676229000069, 46.40817616800008],
              [6.482942342000115, 46.448587138000065],
              [6.547021118000117, 46.45737213200006],
              [6.613683716000139, 46.45589935400007],
              [6.762666870000118, 46.429260152000026],
              [6.77771555400011, 46.424106493000025],
              [6.787058146000049, 46.41417063500002],
              [6.78810673300012, 46.40500797800006],
              [6.789228556000126, 46.39520538300006],
              [6.782097209000113, 46.37846222000012],
              [6.755742228000145, 46.3570681770001],
              [6.750367879000095, 46.345518494000075],
              [6.769488159000076, 46.322677511000066],
              [6.804938192000094, 46.296606751000084],
              [6.827675822000089, 46.269476624],
              [6.792225789000071, 46.221675924000024],
              [6.774862508000126, 46.185864156],
              [6.765664103000034, 46.151602681000085],
              [6.774345743000083, 46.13480784100001],
              [6.853927449000111, 46.12261220300009],
              [6.869223673000079, 46.1123285930001],
              [6.868190144000096, 46.104680482000035],
              [6.861162150000098, 46.09703236900005],
              [6.853100627000089, 46.090211081000106],
              [6.848553100000061, 46.085043437000095],
              [6.851343628000109, 46.08602529000005],
              [6.853100627000089, 46.07610341400006],
              [6.853410685000085, 46.06566477500003],
              [6.851963745000091, 46.064682922000074],
              [6.852377156000102, 46.05693145800005],
              [6.850310099000126, 46.052745667000025],
              [6.850930216000108, 46.049645081000065],
              [6.859715210000104, 46.04499420200001],
              [6.869223673000079, 46.04406402600007],
              [6.876871786000066, 46.04809478800006],
              [6.884003133000078, 46.05321075500005],
              [6.892374715000074, 46.0555878710001],
              [6.91511234500004, 46.0486115530001],
              [6.982808471000055, 45.99538482700005],
              [6.987666056000052, 45.99311106400002],
              [6.991283406000122, 45.98246571900002],
              [7.002755575000066, 45.96169179300007],
              [7.009783569000149, 45.9433983360001],
              [7.015157918000114, 45.93332143100007],
              [7.022082560000115, 45.925259909],
              [7.007716512000115, 45.920505677000094],
              [6.997174519000055, 45.911307272],
              [6.989112997000063, 45.899266663000034],
              [6.982808471000055, 45.885779114000044],
              [6.969165893000138, 45.86975942000002],
              [6.949012085000049, 45.85782216400007],
              [6.926377808000098, 45.84976064100006],
              [6.905087117000107, 45.84536814400006],
              [6.880385782000104, 45.84552317300002],
              [6.873461141000121, 45.844799704000124],
              [6.872736229768993, 45.83967982505159],
              [6.871699264678133, 45.832766724445854],
              [6.870662299587273, 45.82827320905213],
              [6.864440509042115, 45.826890588930986],
              [6.858564373527243, 45.83345803450643],
              [6.851996927951799, 45.83622327474872],
              [6.843355552194634, 45.83864285996073],
              [6.816203654000077, 45.832914124000084],
              [6.800804077000095, 45.82645457000005],
              [6.788091675000118, 45.81172678700004],
              [6.782717325000078, 45.795293681000075],
              [6.781993856000071, 45.77746531200002],
              [6.784681030000115, 45.75958526600006],
              [6.79594649200007, 45.71814076800011],
              [6.816100301000034, 45.69685007700012],
              [6.843075398000082, 45.682742412],
              [6.869223673000079, 45.679021708000064],
              [6.882556193000084, 45.67550771100012],
              [6.905293823000079, 45.65969472300013],
              [6.918626343000085, 45.6525633750001],
              [6.951079142000111, 45.646775615000124],
              [6.963378133000049, 45.640729472000075],
              [6.96947595200001, 45.62584665900003],
              [6.967098836000076, 45.62016225200007],
              [6.95562666800015, 45.60259226500001],
              [6.952939494000105, 45.59427236000006],
              [6.954903198000068, 45.58621083600006],
              [6.965858601000122, 45.574428609000066],
              [6.96978601100011, 45.56698720300004],
              [6.9752637120001, 45.525646058000106],
              [6.982808471000055, 45.51112498000005],
              [7.028490437000045, 45.493141581000074],
              [7.072001993000072, 45.470042217000085],
              [7.075368543000081, 45.466285856000056],
              [7.081820515000032, 45.45908681300001],
              [7.088745158000108, 45.446632793000035],
              [7.096806681000118, 45.43541900700008],
              [7.110139201000038, 45.42828765900005],
              [7.15292728600005, 45.41511016900007],
              [7.160678752000081, 45.41092437800005],
              [7.159645223000098, 45.39847035800004],
              [7.150756877000077, 45.38322581000001],
              [7.130086304000145, 45.3570775350001],
              [7.097736857000058, 45.32984405600011],
              [7.092569213000075, 45.323952942000105],
              [7.097633504000044, 45.29496246400002],
              [7.108382202000143, 45.27491200800007],
              [7.108382202000143, 45.259202373],
              [7.081200399000068, 45.24307932500004],
              [7.062183471000111, 45.218533021000056],
              [7.055465536000071, 45.21367543600003],
              [7.050194539000131, 45.215019023000096],
              [7.037688843000041, 45.225767721000025],
              [7.029730672000085, 45.22819651300007],
              [6.99448734500001, 45.22132354800003],
              [6.958727254000081, 45.20979970300009],
              [6.945808146000076, 45.20106638600002],
              [6.928444865000074, 45.17956899000008],
              [6.913768758000089, 45.17016388000012],
              [6.904673706000096, 45.168613587],
              [6.881315958000073, 45.16840688100005],
              [6.873461141000121, 45.165926412000076],
              [6.868190144000096, 45.157451477000066],
              [6.872841023000149, 45.152025452000075],
              [6.878628784000028, 45.14742625000004],
              [6.876665079000105, 45.14122507800006],
              [6.84410892700015, 45.130114645000035],
              [6.808142131000068, 45.13910634400007],
              [6.77145186300001, 45.1531623340001],
              [6.736415242000078, 45.15734812500004],
              [6.728870483000037, 45.15460927300008],
              [6.710887085000138, 45.14473907500012],
              [6.702205445000089, 45.14122507800006],
              [6.694350626000073, 45.140294902],
              [6.676263875000132, 45.140759990000035],
              [6.66737552900014, 45.13962310900003],
              [6.632700643000106, 45.12551544200009],
              [6.629385185000046, 45.12354511300005],
              [6.614613892000108, 45.11476674500007],
              [6.602728312000067, 45.1034496060001],
              [6.620298299000126, 45.08443267900013],
              [6.636576375000061, 45.07445912700011],
              [6.638126669000087, 45.067431132000095],
              [6.63698978700009, 45.05942128500003],
              [6.639676961000106, 45.05037791000008],
              [6.651665894000075, 45.03565012600008],
              [6.662207885000043, 45.029242249000035],
              [6.69724450700005, 45.02691681],
              [6.723496134000072, 45.013377584000025],
              [6.729904012000105, 44.984697164000025],
              [6.727940307000097, 44.92873158800002],
              [6.745406941000027, 44.90780263300003],
              [6.778169800000029, 44.887648825000056],
              [6.847106161000056, 44.8590717580001],
              [6.866019735000094, 44.85566111300007],
              [6.915319051000097, 44.86268910800008],
              [6.932682332000127, 44.8616555790001],
              [6.982808471000055, 44.846979472],
              [7.000791870000114, 44.8329751590001],
              [7.004925985000057, 44.827962545000034],
              [7.007096395000133, 44.822071432000044],
              [7.006786336000062, 44.81902252200011],
              [7.005856160000093, 44.81633534800007],
              [7.00595951400004, 44.811529440000086],
              [7.004099162000017, 44.81080596900007],
              [6.999138224000063, 44.795044658000094],
              [6.998414754000066, 44.793752747000056],
              [7.009783569000149, 44.77210032200007],
              [7.015157918000114, 44.74739898700004],
              [7.01898197400007, 44.73887237600003],
              [7.049367717000109, 44.697892965],
              [7.055155476000095, 44.684870504000074],
              [7.03727543200003, 44.684612122],
              [7.001205282000029, 44.692260234000074],
              [6.982808471000055, 44.69215688100003],
              [6.959864135000089, 44.683165182],
              [6.941467326000094, 44.66699045900002],
              [6.934335978000149, 44.64668162],
              [6.945601441000122, 44.625442607000096],
              [6.931648804000133, 44.61794952500007],
              [6.89733565200001, 44.575419821000125],
              [6.84638269000007, 44.547462871000036],
              [6.835737345000069, 44.53402699800007],
              [6.838837931000114, 44.502917786000026],
              [6.861265503000112, 44.474909160000024],
              [6.891651245000077, 44.451964824000086],
              [6.917799519000084, 44.43630686400003],
              [6.88420983900005, 44.42302602200003],
              [6.877181844000035, 44.414396057000076],
              [6.868810262000068, 44.3831834920001],
              [6.866329793000091, 44.37718902600007],
              [6.866123088000052, 44.37212473600009],
              [6.869843791000051, 44.362926331],
              [6.873977905000061, 44.358378805000044],
              [6.895992065000144, 44.33982696600002],
              [6.903846883000085, 44.33000844400006],
              [6.915629110000083, 44.309699605000034],
              [6.921210164000087, 44.30215484600008],
              [6.930201864000139, 44.29538523400005],
              [6.950045613000043, 44.285101624000035],
              [6.959244019000039, 44.27735015900005],
              [6.96554854300004, 44.26753163600007],
              [6.968855835000056, 44.258178202000025],
              [6.973403361000095, 44.249444885000045],
              [6.982808471000055, 44.24174509800007],
              [6.996140991000061, 44.23781768800008],
              [7.008026570000084, 44.239212952000074],
              [7.020015503000138, 44.24210683200006],
              [7.033451375000084, 44.24293365500007],
              [7.046060425000121, 44.240298157000055],
              [7.104868205000088, 44.21776723300006],
              [7.144969116000084, 44.207225240000085],
              [7.251319214000091, 44.16004465700006],
              [7.270129435000115, 44.1543085740001],
              [7.296174357000069, 44.15115631100004],
              [7.309300171000132, 44.147487284000064],
              [7.316224813000133, 44.14020090800007],
              [7.32159916100008, 44.131881002000014],
              [7.331004272000143, 44.12526641900011],
              [7.34061608900015, 44.12366444900009],
              [7.380820353000075, 44.12294098000008],
              [7.554763224000055, 44.15906280600008],
              [7.583598674000086, 44.160716451000056],
              [7.624733114000065, 44.180095113],
              [7.655635620000055, 44.1760643520001],
              [7.64188968900001, 44.14355987600008],
              [7.654085327000132, 44.12495636000004],
              [7.676202840000144, 44.10898834300009],
              [7.687942587000094, 44.090799457000074],
              [7.691912475000095, 44.08464874300007],
              [7.689948771000076, 44.06733713800007],
              [7.67878666200005, 44.056588441000045],
              [7.664317261000093, 44.04857859300007],
              [7.65336185700005, 44.03969024700005],
              [7.646953979000102, 44.027494609000044],
              [7.63868575000015, 44.005067037000046],
              [7.630934285000137, 43.993543193000036],
              [7.608610066000068, 43.97561147100005],
              [7.556933634000131, 43.94408884700009],
              [7.536779826000071, 43.92078277600005],
              [7.493474976000101, 43.88623708100006],
              [7.477868693000062, 43.86551483200013],
              [7.482726278000058, 43.840219219000076],
              [7.502289259000065, 43.792222398000035],
              [7.489105665000068, 43.78546784100007],
              [7.484873894000089, 43.78538646000004],
              [7.480723504000082, 43.78583405200004],
              [7.476410352000073, 43.784491278000075],
              [7.475759311000047, 43.78082916900007],
              [7.477305535000085, 43.76813385600008],
              [7.476410352000073, 43.76463450700004],
              [7.46843509200005, 43.761704820000034],
              [7.46265709700009, 43.76211172100005],
              [7.454345265000086, 43.75711729100004],
              [7.445974054000089, 43.74984536000005],
              [7.43745403212602, 43.74336054083465],
              [7.426246111000125, 43.755464229000026],
              [7.406968628000072, 43.76350555400002],
              [7.387538289000105, 43.7578986620001],
              [7.372655477000052, 43.74583221500002],
              [7.367262599000071, 43.73412453300007],
              [7.365750207000076, 43.72273028300002],
              [7.353184272000078, 43.715690694000045],
              [7.342295769000089, 43.70783112200007],
              [7.338063998000052, 43.69830963700008],
              [7.330533323000054, 43.68642412300005],
              [7.319001775000061, 43.68524995800004],
              [7.300903921000042, 43.687689084000056],
              [7.280252530000041, 43.69332627400007],
              [7.257273161000057, 43.69164800400006],
              [7.241674873000079, 43.68486905200007],
              [7.228509115000065, 43.67419580900008],
              [7.23181420800006, 43.66347049400008],
              [7.213804599000071, 43.648672916000066],
              [7.203791110000054, 43.64435965000007],
              [7.196677433000048, 43.656916607000085],
              [7.177651002000061, 43.66010941900004],
              [7.164594891000093, 43.65606095600003],
              [7.151621941000087, 43.65477122600004],
              [7.14421634200005, 43.64545319200005],
              [7.136566602000073, 43.64118073100008],
              [7.133067254000082, 43.63385651200008],
              [7.126154018000079, 43.60583297200009],
              [7.132090691000087, 43.57880280200004],
              [7.13257897200009, 43.573553778000075],
              [7.136241540000071, 43.56245863800007],
              [7.138916191000078, 43.55402035800006],
              [7.125511178000068, 43.547768114000064],
              [7.112940732000084, 43.56454415400009],
              [7.104323741000087, 43.568293579000056],
              [7.08842678700006, 43.568674446000045],
              [7.071052428000087, 43.56080479800005],
              [7.058107568000082, 43.549885465000045],
              [7.045077517000038, 43.542142829000056],
              [7.03720222700008, 43.53626350600007],
              [7.03063439400006, 43.547889169000086],
              [7.014468133000094, 43.54708658200008],
              [6.993818672000089, 43.54890562600008],
              [6.975599612000053, 43.54694595700005],
              [6.962087436000047, 43.54010651200008],
              [6.945203125000091, 43.52725267200009],
              [6.94088799900004, 43.512459668000076],
              [6.949554884000065, 43.507879950000074],
              [6.94898522200009, 43.50739166900007],
              [6.953805085000056, 43.50461583900005],
              [6.954298556000083, 43.500106394000056],
              [6.925079666000045, 43.472760512000036],
              [6.920372044000089, 43.44901182400008],
              [6.898241732000088, 43.43799878100003],
              [6.894027990000041, 43.42762841500007],
              [6.871072493000042, 43.42609293000004],
              [6.86967160800009, 43.43205232200006],
              [6.866559591000055, 43.43545579400006],
              [6.862957239000082, 43.439362059000075],
              [6.857987506000086, 43.43617576500009],
              [6.856098247000091, 43.42872944000004],
              [6.860136328000067, 43.41586789000007],
              [6.846671575000073, 43.41257713600004],
              [6.834825863000049, 43.415811149000035],
              [6.818843208000089, 43.416072341000074],
              [6.783050322000065, 43.408634723000034],
              [6.772973707000062, 43.41845419200007],
              [6.757085807000067, 43.42268659200005],
              [6.746501343000091, 43.417906118000076],
              [6.731146285000079, 43.407846721000055],
              [6.732823701000086, 43.38207900700007],
              [6.717784050000091, 43.366888739000046],
              [6.717837534000068, 43.350604247000035],
              [6.693930649000038, 43.34837157100009],
              [6.674571160000085, 43.34638092700004],
              [6.666026238000086, 43.333197333000044],
              [6.661306186000047, 43.322333075000074],
              [6.65202884200005, 43.31492747600004],
              [6.62462860100004, 43.29591306000009],
              [6.597242936000043, 43.284007286000076],
              [6.590891640000052, 43.26889795100004],
              [6.611672016000057, 43.26428823700007],
              [6.672358114000076, 43.27619557300005],
              [6.693373608000059, 43.27297279800007],
              [6.698021526000048, 43.26545707400004],
              [6.68539489200009, 43.248037166000074],
              [6.668355527000074, 43.23953564200008],
              [6.665403062000053, 43.22128973900004],
              [6.671977632000051, 43.21360924600003],
              [6.679800772000078, 43.20155281400008],
              [6.660400217000074, 43.19041167900008],
              [6.64039147200009, 43.18183014500005],
              [6.629161004000082, 43.17987702000005],
              [6.609873894000089, 43.17340729400007],
              [6.599457227000073, 43.174994208000044],
              [6.59546959700009, 43.17987702000005],
              [6.593272332000083, 43.18773021000004],
              [6.581275607000066, 43.18437362000009],
              [6.563718110000082, 43.18444937500004],
              [6.53991191700004, 43.18220400900009],
              [6.536426701000039, 43.17254385500007],
              [6.526714449000053, 43.16056742200004],
              [6.505683047000048, 43.15097126400008],
              [6.479162710000082, 43.15606016800007],
              [6.451331547000052, 43.15271929100004],
              [6.422017572000073, 43.15234158000004],
              [6.401678985000046, 43.14693816700009],
              [6.37854096500007, 43.13607915600005],
              [6.36608020500006, 43.11863492200007],
              [6.36987767800008, 43.10551938000003],
              [6.37537147200004, 43.09084111400006],
              [6.342257678000067, 43.09076336900006],
              [6.328868035000085, 43.09992096600007],
              [6.325694207000083, 43.10419342700004],
              [6.306202437000081, 43.10941311600004],
              [6.28037394100005, 43.11866552300006],
              [6.25347017900009, 43.12087477300008],
              [6.219702497000071, 43.11654758100008],
              [6.193198227000039, 43.10877332700005],
              [6.178664022000078, 43.10285632800009],
              [6.162933790000068, 43.09259674700007],
              [6.153168165000068, 43.071966864000046],
              [6.152767707000066, 43.04810730600008],
              [6.171330439000087, 43.042324989000065],
              [6.185420303000058, 43.04544363500008],
              [6.180072448000089, 43.035922138000046],
              [6.154461750000053, 43.03375113300007],
              [6.097694325000077, 43.031261474000075],
              [6.088517320000051, 43.034848587000056],
              [6.103031188000045, 43.04078050000004],
              [6.119254454000043, 43.045150180000064],
              [6.132065822000072, 43.052638336000086],
              [6.129087889000061, 43.07136218800008],
              [6.10966232800007, 43.08431566500008],
              [6.091933384000072, 43.08290279500005],
              [6.044522586000085, 43.07820776700004],
              [6.027008490000071, 43.07819510200005],
              [6.016520033000063, 43.098936371000036],
              [5.991732384000045, 43.102347472000076],
              [5.958652331000053, 43.10216795200006],
              [5.934092644000089, 43.11359284100007],
              [5.936534050000091, 43.11945221600007],
              [5.938243035000085, 43.12909577000005],
              [5.940928582000083, 43.134019273000035],
              [5.924489780000044, 43.13434479400007],
              [5.908539259000065, 43.131293036000045],
              [5.879405144000089, 43.120428778000075],
              [5.89625084700009, 43.11542389500005],
              [5.910610168000062, 43.09320399500007],
              [5.927252244000044, 43.08760106100004],
              [5.951378968000085, 43.07997756900005],
              [5.940288036000084, 43.07090971700006],
              [5.917208171000084, 43.07274182500004],
              [5.887956364000047, 43.07222586900008],
              [5.875336134000065, 43.068793036000045],
              [5.856605081000055, 43.04482851500006],
              [5.818960387000061, 43.05346898400006],
              [5.790241589000061, 43.06993079400007],
              [5.781873138000037, 43.07911819900005],
              [5.80289558000004, 43.088890484000046],
              [5.818085226000051, 43.09908959200004],
              [5.811464562000083, 43.10672548200006],
              [5.800564292000047, 43.11184894300004],
              [5.783406919000072, 43.114597606000075],
              [5.780840298000044, 43.12333360400004],
              [5.776126699000088, 43.13081108100005],
              [5.760558150000065, 43.13198199200008],
              [5.741011636000053, 43.13206265100007],
              [5.696298672000069, 43.14687511100004],
              [5.687673373000052, 43.168850002000056],
              [5.673918542000081, 43.179888546000086],
              [5.655221278000056, 43.185590034000086],
              [5.63421264200008, 43.18722911700007],
              [5.622902872000054, 43.17672741200005],
              [5.612420433000068, 43.16042865900005],
              [5.588262046000068, 43.16797860200006],
              [5.572706403000041, 43.16914829000007],
              [5.558973791000085, 43.181577564000065],
              [5.547245558000043, 43.19385852900007],
              [5.537835580000092, 43.207389644000045],
              [5.524952486000075, 43.212629082000035],
              [5.514335724000091, 43.207739925000055],
              [5.50417585100007, 43.205658895000056],
              [5.459833401000083, 43.20851918300008],
              [5.439753874000075, 43.207645710000065],
              [5.40951522000006, 43.21129237300005],
              [5.395310694000045, 43.21234101300007],
              [5.370337389000042, 43.20785932100006],
              [5.346980067000061, 43.21589931800008],
              [5.350596550000091, 43.233587958000044],
              [5.353770379000082, 43.243801174000055],
              [5.360850457000083, 43.253973700000074],
              [5.369151238000086, 43.270412502000056],
              [5.357342712000047, 43.28034452800006],
              [5.355967644000089, 43.29205963700008],
              [5.351817254000082, 43.29791901200008],
              [5.338882958000056, 43.33428883600004],
              [5.294173414000056, 43.355471883000064],
              [5.238278858000058, 43.32804075100006],
              [5.163237317000039, 43.329314199000066],
              [5.12517355600005, 43.32576874300008],
              [5.064794619000054, 43.328018530000065],
              [5.034022073000074, 43.335476431000075],
              [5.013936386000069, 43.357920695000075],
              [5.005572076000078, 43.38162750200007],
              [5.026133660000085, 43.40932851800005],
              [5.057139519000089, 43.42206452000005],
              [5.14616946700005, 43.42206452000005],
              [5.173838738000086, 43.42829010600008],
              [5.192881707000083, 43.439520575000074],
              [5.213552280000044, 43.45783112200007],
              [5.22632897200009, 43.48029205900008],
              [5.222829623000052, 43.503973700000074],
              [5.193614129000082, 43.489935614000046],
              [5.165537957000083, 43.482489325000074],
              [5.13998457100007, 43.48578522300005],
              [5.118418816000087, 43.503973700000074],
              [5.111501498000052, 43.51935455900008],
              [5.110850457000083, 43.52789948100008],
              [5.105723504000082, 43.53302643400008],
              [5.084971550000091, 43.53815338700008],
              [5.077403191000087, 43.53888580900008],
              [5.053721550000091, 43.53815338700008],
              [5.049571160000085, 43.541449286000045],
              [5.035329623000052, 43.55573151200008],
              [5.029144727000073, 43.558579820000034],
              [5.022308790000068, 43.55219147300005],
              [5.015879754000082, 43.538763739000046],
              [5.010996941000087, 43.525091864000046],
              [5.009287957000083, 43.517645575000074],
              [5.014659050000091, 43.49872467700004],
              [5.023692254000082, 43.49046458500004],
              [5.035817905000044, 43.485581773000035],
              [5.050303582000083, 43.47671133000006],
              [5.06226647200009, 43.45164622600004],
              [5.051117384000065, 43.42926666900007],
              [5.027598504000082, 43.41697825700004],
              [4.998465760000045, 43.41469940600007],
              [4.983083530000044, 43.41705963700008],
              [4.928477410000085, 43.44013092700004],
              [4.903168165000068, 43.431626695000034],
              [4.892588738000086, 43.42536041900007],
              [4.868174675000091, 43.42145416900007],
              [4.858409050000091, 43.415228583000044],
              [4.850271030000044, 43.40143463700008],
              [4.854991082000083, 43.396185614000046],
              [4.864890595000077, 43.377900012000055],
              [4.867531575000044, 43.365112099000044],
              [4.901005115000089, 43.36696508500006],
              [4.877188604000082, 43.350782491000075],
              [4.855778264000094, 43.341779141000075],
              [4.850823418000061, 43.35892884400005],
              [4.833262566000087, 43.38198476800005],
              [4.791758660000085, 43.39911530200004],
              [4.757823113000086, 43.42234935100004],
              [4.742442254000082, 43.44871653900009],
              [4.744965040000068, 43.50739166900007],
              [4.742442254000082, 43.52448151200008],
              [4.736175977000073, 43.539496161000045],
              [4.725840691000087, 43.55678945500006],
              [4.711924675000091, 43.571519273000035],
              [4.694590691000087, 43.57908763200004],
              [4.694590691000087, 43.57290273600006],
              [4.72437584700009, 43.538397528000075],
              [4.728770379000082, 43.52789948100008],
              [4.728770379000082, 43.45620351800005],
              [4.742523634000065, 43.42255280200004],
              [4.769704623000052, 43.40192291900007],
              [4.800059441000087, 43.386053778000075],
              [4.823018876000049, 43.36716896300004],
              [4.820279138000046, 43.34635571600006],
              [4.791247192000071, 43.34522195800008],
              [4.66588637600006, 43.34754133600006],
              [4.592335626000079, 43.35988927400007],
              [4.566288765000081, 43.37109356600007],
              [4.565544044000092, 43.38794900900007],
              [4.58570397200009, 43.40424225500004],
              [4.588043737000078, 43.41689077600006],
              [4.57959363000009, 43.43006620400007],
              [4.555208306000054, 43.443265515000064],
              [4.51303144600007, 43.45579661700003],
              [4.409418594000044, 43.447741342000086],
              [4.205902540000068, 43.45990631700005],
              [4.181651238000086, 43.463771877000056],
              [4.160329623000052, 43.47150299700007],
              [4.132823113000086, 43.48704661700003],
              [4.117198113000086, 43.51048411700003],
              [4.132823113000086, 43.53278229400007],
              [4.131195509000065, 43.53624095300006],
              [4.105316602000073, 43.55186595300006],
              [4.047455274000072, 43.55613841400009],
              [3.990896030000044, 43.550848700000074],
              [3.952972852000073, 43.539943752000056],
              [3.939300977000073, 43.532538153000075],
              [3.73991946700005, 43.41282786700003],
              [3.622162306000064, 43.37490469000005],
              [3.589691602000073, 43.35488515800006],
              [3.51335696700005, 43.28107330900008],
              [3.492360873000052, 43.274318752000056],
              [3.452403191000087, 43.288763739000046],
              [3.428396030000044, 43.28546784100007],
              [3.385427280000044, 43.28392161700003],
              [3.31771894600007, 43.26308828300006],
              [3.244313998000052, 43.21942780200004],
              [3.227549675000091, 43.20425039300005],
              [3.220957879000082, 43.19521719000005],
              [3.207286004000082, 43.18663157800006],
              [3.195892774000072, 43.176662502000056],
              [3.178721550000091, 43.165228583000044],
              [3.165944858000046, 43.152411200000074],
              [3.154470248000052, 43.135280666000085],
              [3.135996941000087, 43.12103913000004],
              [3.114024285000085, 43.106309312000064],
              [3.104177280000044, 43.08779531500005],
              [3.096039259000065, 43.07257721600007],
              [3.086029493000069, 43.054022528000075],
              [3.070404493000069, 43.02692291900007],
              [3.063243035000085, 43.00836823100008],
              [3.056081576000054, 42.992702541000085],
              [3.046153191000087, 42.964178778000075],
              [3.038991733000046, 42.94277578300006],
              [3.041840040000068, 42.932806708000044],
              [3.054698113000086, 42.92711009300007],
              [3.056081576000054, 42.907131252000056],
              [3.047536655000044, 42.84723541900007],
              [3.040456576000054, 42.79018789300005],
              [3.038991733000046, 42.75027090100008],
              [3.043304884000065, 42.724595445000034],
              [3.037608269000089, 42.68321360900006],
              [3.041840040000068, 42.62905508000006],
              [3.046153191000087, 42.58767324400009],
              [3.051849806000064, 42.55487702000005],
              [3.06609134200005, 42.54205963700008],
              [3.087494337000066, 42.53493886900009],
              [3.11459394600007, 42.53062571800007],
              [3.137380405000044, 42.52492910400008],
              [3.145925326000054, 42.514960028000075],
              [3.145925326000054, 42.50352610900006],
              [3.143077019000089, 42.49213288000004],
              [3.150238477000073, 42.48216380400004],
              [3.160248243000069, 42.475043036000045],
              [3.175873243000069, 42.45648834800005],
              [3.181569858000046, 42.43508535400008],
              [3.180969656804698, 42.43148414767083],
              [3.137823527000137, 42.42593862000008],
              [3.111675252000111, 42.425008444000056],
              [3.086147094000097, 42.42717885400005],
              [3.065579874000093, 42.432010600000055],
              [3.053590942000142, 42.437643331000075],
              [3.04387577300011, 42.445265605000046],
              [3.036020956000073, 42.45461903900009],
              [3.029613077000135, 42.465651957],
              [3.02299849400012, 42.46704722100007],
              [2.993749634000096, 42.467615662000114],
              [2.983104289000096, 42.469320984],
              [2.966051066000148, 42.46100107900013],
              [2.933701619000061, 42.47022532200002],
              [2.900835409000138, 42.45126007100008],
              [2.88409224500009, 42.449193014000016],
              [2.866935669000043, 42.44963226300003],
              [2.850812622000149, 42.44836619100009],
              [2.834792928000098, 42.441312358000076],
              [2.804613892000106, 42.41955658000005],
              [2.788594198000055, 42.41201182100009],
              [2.767716919000065, 42.40955719100005],
              [2.72854618300002, 42.41402720200007],
              [2.708082316000059, 42.412890320000045],
              [2.690408976000072, 42.406172384000016],
              [2.648241007000109, 42.3814710490001],
              [2.640282837000143, 42.372841085000076],
              [2.649377889000107, 42.353720806000084],
              [2.661780232000098, 42.34335968000006],
              [2.662193644000098, 42.33901886100007],
              [2.635425253000022, 42.33788197900007],
              [2.613411092000149, 42.3409567260001],
              [2.56741906700006, 42.352635600000085],
              [2.548092081000107, 42.35224802700007],
              [2.540340617000084, 42.34697703100004],
              [2.531969035000117, 42.33077647000003],
              [2.525251098000098, 42.32589304700009],
              [2.514812459000069, 42.32566050300004],
              [2.503650350000015, 42.32845103000001],
              [2.483393188000122, 42.33697764100002],
              [2.464893025000094, 42.34062082900003],
              [2.445566040000131, 42.351963806000086],
              [2.429856404000077, 42.367544251000126],
              [2.422518351000065, 42.38369313600002],
              [2.406602010000142, 42.38426157600007],
              [2.375492798000096, 42.38932586700004],
              [2.317305135000083, 42.409608867000046],
              [2.305316203000132, 42.41697275800006],
              [2.277410930000144, 42.428625794000126],
              [2.245991659000111, 42.42611948700004],
              [2.184186645000125, 42.411805115000064],
              [2.136954386000099, 42.41622345000006],
              [2.121038045000148, 42.410616557000125],
              [2.116283813000081, 42.40539723700003],
              [2.108739054000125, 42.39064361600002],
              [2.103984823000133, 42.38483001700003],
              [2.080110311000055, 42.37126495400004],
              [2.063263794000079, 42.35790659700011],
              [2.05168827300011, 42.35235138000009],
              [2.035255168000049, 42.34925079400007],
              [2.009210245000077, 42.34708038300006],
              [1.995671020000088, 42.348682353000086],
              [1.983372030000055, 42.354547628],
              [1.963734985000116, 42.367234192000055],
              [1.954226522000056, 42.382685445000035],
              [1.941100708000079, 42.420099182000016],
              [1.927458129000058, 42.43689402300008],
              [1.911955200000136, 42.44195831300006],
              [1.89324833200007, 42.44273346000007],
              [1.869787232000107, 42.446790060000055],
              [1.813666626000042, 42.475237936],
              [1.792685995000056, 42.48172332800006],
              [1.730570923000073, 42.488053691000076],
              [1.71217411300006, 42.49371226],
              [1.712690877000114, 42.496787008000055],
              [1.711967407000117, 42.49929331500003],
              [1.710003703000069, 42.501334534000065],
              [1.707006470000067, 42.50278147400006],
              [1.710623820000137, 42.52774119100006],
              [1.721682577000138, 42.54851511600002],
              [1.739976033000119, 42.56164093000005],
              [1.765090780000151, 42.56337209100003],
              [1.761107147000132, 42.567646197],
              [1.752688435000067, 42.57667877200005],
              [1.729434041000076, 42.5820014450001],
              [1.713310995000086, 42.58954620400006],
              [1.721992635000049, 42.60985504200006],
              [1.608304484000143, 42.618123271000016],
              [1.597349081000061, 42.62192148900006],
              [1.543088827000133, 42.64936167400002],
              [1.527792602000062, 42.64853485200008],
              [1.498440389000109, 42.64024078400003],
              [1.466814412000105, 42.64145518000005],
              [1.451414836000112, 42.60205190100005],
              [1.42929732200011, 42.59538564100005],
              [1.414827921000068, 42.60933827700002],
              [1.397981404000092, 42.64362559000004],
              [1.378757771000068, 42.66323679600008],
              [1.361084432000069, 42.68672373500006],
              [1.352712850000103, 42.690056865000045],
              [1.343307739000039, 42.69044443800006],
              [1.338243449000061, 42.69444936100005],
              [1.342584269000042, 42.708660381000115],
              [1.319123169000079, 42.71336293600008],
              [1.195926554000096, 42.71364715600008],
              [1.162543579000044, 42.705688986],
              [1.151484823000118, 42.706722514],
              [1.13432824700007, 42.7159725960001],
              [1.124096313000081, 42.72974436500003],
              [1.116551554000125, 42.745247294000066],
              [1.106733032000079, 42.759613343000055],
              [1.089059692000149, 42.77131805400005],
              [1.068182414000091, 42.776123963000046],
              [0.982916300000113, 42.7803614300001],
              [0.975268189000133, 42.78374623600011],
              [0.958731730000068, 42.79371978800002],
              [0.950256795000143, 42.796122742000065],
              [0.940024862000087, 42.79366811200002],
              [0.930619751000108, 42.78803538000007],
              [0.921111287000116, 42.784366354000085],
              [0.910362589000101, 42.78767364600007],
              [0.894446248000094, 42.79932668100004],
              [0.885764608000045, 42.80423594200009],
              [0.856102336000077, 42.8127625530001],
              [0.812900838000132, 42.831624451000025],
              [0.795744263000074, 42.83384653700004],
              [0.776313924000078, 42.832451274000036],
              [0.758847290000062, 42.835267640000026],
              [0.72432743300007, 42.845292867000026],
              [0.706757446000097, 42.84658477900008],
              [0.679368937000049, 42.845112],
              [0.656321248000097, 42.83841990200007],
              [0.651567016000087, 42.82405385400007],
              [0.653737427000095, 42.802685649000054],
              [0.639681437000149, 42.77467702300005],
              [0.650740194000065, 42.76338572300007],
              [0.643298787000049, 42.7590707400001],
              [0.63957808400005, 42.754833272000056],
              [0.633480265000088, 42.744782206000124],
              [0.647639608000134, 42.7410356650001],
              [0.659628540000085, 42.72989939400007],
              [0.666449829000044, 42.71475820000008],
              [0.66541630100005, 42.6986609910001],
              [0.66342581400005, 42.69621435100008],
              [0.656734660000097, 42.6879898080001],
              [0.64360884600012, 42.68447581000005],
              [0.608158813000102, 42.6879898080001],
              [0.483515259000029, 42.68530263300006],
              [0.466927124000023, 42.69044443800006],
              [0.428789917000074, 42.68302887000006],
              [0.409282064000081, 42.68225372300013],
              [0.389283285000118, 42.68514760400002],
              [0.384399862000095, 42.68858408600006],
              [0.383676391000108, 42.69269236300006],
              [0.384012288000093, 42.6968523150001],
              [0.381816040000103, 42.70010793100009],
              [0.354169148000096, 42.71749705000012],
              [0.336030721000071, 42.712691142000025],
              [0.318305704000039, 42.69953949000005],
              [0.290245402000039, 42.67029062900009],
              [0.275388428000099, 42.66868866000006],
              [0.259807983000144, 42.68238291400006],
              [0.238362264000045, 42.71036570300008],
              [0.222394246000079, 42.71620514000007],
              [0.169167521000134, 42.72646291100004],
              [0.152941121000111, 42.72460256000004],
              [0.134182576000114, 42.715223288000104],
              [0.072842651000144, 42.70847951300006],
              [-0.004310262999923, 42.68752472000007],
              [-0.038933471999911, 42.68514760400002],
              [-0.078414265999953, 42.69667144800006],
              [-0.084202026999918, 42.70108978300006],
              [-0.088852905999886, 42.70612823500004],
              [-0.095751708999956, 42.71067576100005],
              [-0.108489949999921, 42.71336293600008],
              [-0.119031941999879, 42.71685109500005],
              [-0.121822468999937, 42.723310649],
              [-0.12311437999989, 42.7303644820001],
              [-0.129238036999936, 42.73589386000002],
              [-0.145722818999928, 42.74589325000004],
              [-0.157789265999924, 42.76069854700005],
              [-0.163628702999887, 42.77798431400005],
              [-0.161406615999908, 42.79534759600007],
              [-0.179390014999882, 42.78974070200003],
              [-0.208354654999937, 42.78387542700004],
              [-0.235148885999934, 42.78622670500009],
              [-0.247034463999853, 42.804830221000046],
              [-0.305134937999952, 42.83081010700006],
              [-0.307418375999873, 42.83183115700008],
              [-0.322792113999952, 42.84250234000008],
              [-0.328243977999932, 42.832580465],
              [-0.335168619999905, 42.82495819100011],
              [-0.342997599999933, 42.822736105],
              [-0.351679239999896, 42.82924733500006],
              [-0.399738321999934, 42.801316223000086],
              [-0.423922892999911, 42.790670878000086],
              [-0.454463662999927, 42.78891388000001],
              [-0.508413858999887, 42.80749155700006],
              [-0.533890339999914, 42.80800832200002],
              [-0.535647338999894, 42.784211324000054],
              [-0.544432332999861, 42.782015076000036],
              [-0.561175495999919, 42.773540141000055],
              [-0.56903031399986, 42.7726358040001],
              [-0.578693806999866, 42.77733835900007],
              [-0.578538777999938, 42.7833069870001],
              [-0.577143513999943, 42.78979237900005],
              [-0.582931274999936, 42.79583852100011],
              [-0.587323770999916, 42.79684621200006],
              [-0.603550170999938, 42.79684621200006],
              [-0.610164753999925, 42.79909413700007],
              [-0.609958048999971, 42.802840679],
              [-0.60804602099995, 42.807181498],
              [-0.609492960999944, 42.81144480400003],
              [-0.648301961999891, 42.84978871700007],
              [-0.666078653999904, 42.860744120000035],
              [-0.700391804999924, 42.876427918],
              [-0.710520385999899, 42.877668153000045],
              [-0.720287231999862, 42.876608785000045],
              [-0.730105753999908, 42.8775131230001],
              [-0.740286010999881, 42.88479949900007],
              [-0.745867065999903, 42.89392039000005],
              [-0.744781859999904, 42.8992947390001],
              [-0.741422891999889, 42.90389394200007],
              [-0.740906128999939, 42.910896098000066],
              [-0.745031962999889, 42.918727227],
              [-0.759664672999861, 42.94650116000004],
              [-0.786433064999926, 42.953270773000085],
              [-0.863534301999948, 42.94306467700001],
              [-0.943219360999905, 42.9478964230001],
              [-0.981459920999896, 42.957043152],
              [-1.016289834999952, 42.97624094700002],
              [-1.028485473999893, 42.98670542400005],
              [-1.0450736089999, 42.99021942200001],
              [-1.079696817999888, 42.99339752200008],
              [-1.087189900999931, 42.99799672500002],
              [-1.103726358999921, 43.005748190000034],
              [-1.112408, 43.00825449600002],
              [-1.149925088999879, 43.00572235200012],
              [-1.182532918999925, 43.025281881000055],
              [-1.216897745999887, 43.03926035600004],
              [-1.274878702999928, 43.046830953],
              [-1.293688923999952, 43.05520253500008],
              [-1.310587117999944, 43.06949106900005],
              [-1.315082966999853, 43.082875265],
              [-1.306969766999941, 43.095975240000044],
              [-1.286040811999953, 43.109178569000036],
              [-1.308623412999907, 43.113571066000034],
              [-1.331050984999905, 43.10734405600003],
              [-1.348259236999866, 43.093081360000056],
              [-1.355183877999934, 43.07303090400002],
              [-1.357612670999913, 43.046830953],
              [-1.366139282999939, 43.033317567000026],
              [-1.383140827999853, 43.029209290000026],
              [-1.41052933799989, 43.030914612000075],
              [-1.435023965999932, 43.03572052000008],
              [-1.457141478999858, 43.04507395500012],
              [-1.475279906999987, 43.060137634000014],
              [-1.487837279999894, 43.0818158980001],
              [-1.479620727999873, 43.090264995],
              [-1.438434610999877, 43.12279530900004],
              [-1.425773884999927, 43.13527516700013],
              [-1.41052933799989, 43.16690114400002],
              [-1.399677286999946, 43.20674367300005],
              [-1.403501342999959, 43.243330587000074],
              [-1.432233438999987, 43.265008850000086],
              [-1.444222371999928, 43.2651122030001],
              [-1.455281127999854, 43.26221832300011],
              [-1.466391560999881, 43.26077138300012],
              [-1.508094441999901, 43.276765239000056],
              [-1.539203654999937, 43.283560690000016],
              [-1.559047403999926, 43.28407745400007],
              [-1.57398189299991, 43.277437032000066],
              [-1.581888386999935, 43.26035797100012],
              [-1.587572794999886, 43.251598817000044],
              [-1.598476521999942, 43.246999613000085],
              [-1.611085571999894, 43.24581105600005],
              [-1.621885945999907, 43.246999613000085],
              [-1.634081583999915, 43.251107890000085],
              [-1.63904252099988, 43.255681255000056],
              [-1.646328897999865, 43.2727861530001],
              [-1.647982543999916, 43.281545309000066],
              [-1.645192016999943, 43.28764312800003],
              [-1.645036986999912, 43.292371521000106],
              [-1.654907185999889, 43.297539164000014],
              [-1.673872435999925, 43.30415374800002],
              [-1.683019164999934, 43.304928894000014],
              [-1.703328002999854, 43.2986243700001],
              [-1.724825397999894, 43.29653147400005],
              [-1.736555948999865, 43.29231984400009],
              [-1.747356322999906, 43.29100209600004],
              [-1.74972998599992, 43.29479269100007],
              [-1.752420612999884, 43.29908945800004],
              [-1.755779581999889, 43.3185456340001],
              [-1.768233601999981, 43.330922140000084],
              [-1.796914021999953, 43.341128235000056],
              [-1.797172403999951, 43.353323873000065],
              [-1.796448933999955, 43.37438202],
              [-1.794074744885912, 43.38601533206285],
              [-1.791371222999942, 43.38458893400008],
              [-1.790760870999918, 43.38426341400009],
              [-1.775502081999946, 43.376166083000044],
              [-1.767974412999934, 43.38361237200007],
              [-1.749623175999943, 43.38922760600008],
              [-1.661000128999945, 43.399684963000084],
              [-1.637806769999941, 43.42377350500004],
              [-1.61546790299991, 43.43256256700005],
              [-1.596750454999949, 43.44253164300005],
              [-1.588042772999927, 43.451157945000034],
              [-1.566395636999914, 43.48216380400004],
              [-1.562082485999952, 43.493394273000035],
              [-1.553334113999938, 43.50136953300006],
              [-1.51398678299995, 43.53864166900007],
              [-1.506337042999917, 43.550116278000075],
              [-1.47687740799995, 43.580064195000034],
              [-1.470041469999956, 43.61151764500005],
              [-1.44595292899993, 43.66844310100004],
              [-1.40493730399993, 43.83234284100007],
              [-1.38117428299995, 43.88959381700005],
              [-1.346099412999934, 44.019191799000055],
              [-1.28156490799995, 44.30219147300005],
              [-1.25413977799991, 44.44245026200008],
              [-1.247303839999915, 44.50454336100006],
              [-1.249745245999918, 44.519232489000046],
              [-1.258290167999917, 44.54755280200004],
              [-1.257232225999928, 44.55605703300006],
              [-1.23078365799995, 44.58356354400007],
              [-1.22687740799995, 44.589911200000074],
              [-1.224191860999952, 44.601996161000045],
              [-1.206288214999915, 44.64789459800005],
              [-1.186512824999909, 44.66547272300005],
              [-1.161447719999956, 44.66616445500006],
              [-1.100209113999938, 44.65534088700008],
              [-1.065012173999946, 44.65912506700005],
              [-1.044748501999948, 44.66941966400009],
              [-1.044422980999911, 44.68463776200008],
              [-1.069162563999953, 44.703192450000074],
              [-1.055490688999953, 44.703192450000074],
              [-1.065297003999945, 44.71747467700004],
              [-1.14085852799991, 44.76813385600008],
              [-1.151722785999937, 44.77142975500004],
              [-1.156402147999927, 44.773423570000034],
              [-1.160633917999917, 44.77651601800005],
              [-1.165353969999956, 44.77871328300006],
              [-1.172230597999942, 44.77826569200005],
              [-1.176503058999913, 44.77521393400008],
              [-1.178456183999913, 44.77090078300006],
              [-1.179758266999954, 44.766913153000075],
              [-1.182118292999917, 44.76520416900007],
              [-1.188588019999941, 44.755845445000034],
              [-1.233631964999915, 44.70685455900008],
              [-1.244943813999953, 44.66274648600006],
              [-1.253814256999931, 44.638657945000034],
              [-1.260365363999938, 44.62742747600004],
              [-1.19945227799991, 45.12083567900004],
              [-1.157866990999935, 45.27912018400008],
              [-1.139963344999956, 45.49005768400008],
              [-1.133697068999936, 45.50482819200005],
              [-1.099598761999914, 45.55353424700007],
              [-1.085275844999956, 45.56903717700004],
              [-1.069162563999953, 45.57330963700008],
              [-1.058583136999914, 45.569647528000075],
              [-1.056223110999952, 45.56513092700004],
              [-1.056752081999946, 45.55760325700004],
              [-1.057362433999913, 45.54633209800005],
              [-1.060170050999943, 45.543036200000074],
              [-1.062326626999948, 45.53774648600006],
              [-1.062326626999948, 45.532416083000044],
              [-1.05923417899993, 45.527044989000046],
              [-1.048695441999939, 45.51504140800006],
              [-1.039947068999936, 45.50726959800005],
              [-0.97297115799995, 45.47052643400008],
              [-0.930775519999941, 45.45380280200004],
              [-0.915272589999915, 45.450425523000035],
              [-0.794178839999915, 45.35541413000004],
              [-0.766184048999946, 45.32607656500005],
              [-0.754505988999938, 45.29588450700004],
              [-0.751942511999914, 45.27594635600008],
              [-0.738677537999934, 45.238714911000045],
              [-0.720041469999956, 45.14594147300005],
              [-0.715972459999932, 45.13450755400004],
              [-0.682199673999946, 45.07648346600007],
              [-0.648182745999918, 45.044907945000034],
              [-0.609852667999917, 45.018459377000056],
              [-0.577788865999935, 45.005072333000044],
              [-0.568959113999938, 44.99799225500004],
              [-0.560699022999927, 44.98541901200008],
              [-0.559193488999938, 44.97614166900007],
              [-0.562082485999952, 44.960150458000044],
              [-0.56086178299995, 44.93927643400008],
              [-0.556507941999939, 44.91852448100008],
              [-0.548166469999956, 44.90228913000004],
              [-0.534657355999911, 44.894964911000045],
              [-0.538644985999952, 44.90875885600008],
              [-0.542388475999928, 44.937201239000046],
              [-0.548451300999943, 44.94953034100007],
              [-0.538970506999931, 44.97650788000004],
              [-0.550363735999952, 44.99819570500006],
              [-0.57258053299995, 45.01430898600006],
              [-0.596180792999917, 45.024644273000035],
              [-0.565297003999945, 45.02358633000006],
              [-0.539418097999942, 45.019517320000034],
              [-0.516428188999953, 45.011379299000055],
              [-0.493763800999943, 44.99799225500004],
              [-0.518950975999928, 45.02944570500006],
              [-0.558745897999927, 45.04344310100004],
              [-0.602162238999938, 45.05345286700003],
              [-0.637766079999949, 45.07306549700007],
              [-0.655995245999918, 45.09910716400009],
              [-0.668690558999913, 45.13080475500004],
              [-0.706654425999943, 45.32241445500006],
              [-0.719715949999909, 45.36107005400004],
              [-0.753041144999941, 45.42405833500004],
              [-0.773101365999935, 45.45209381700005],
              [-0.795480923999946, 45.47711823100008],
              [-0.841786261999914, 45.514553127000056],
              [-0.983509894999941, 45.58698151200008],
              [-0.986887173999946, 45.59125397300005],
              [-0.99087480399993, 45.61005280200004],
              [-0.997222459999932, 45.61432526200008],
              [-1.030262824999909, 45.62287018400008],
              [-1.083811001999948, 45.66038646000004],
              [-1.11392167899993, 45.66893138200004],
              [-1.132801886999914, 45.67169830900008],
              [-1.149322068999936, 45.678900458000044],
              [-1.163441535999937, 45.68895091400009],
              [-1.175607876999948, 45.70026276200008],
              [-1.194203253999945, 45.710191148000035],
              [-1.229359503999945, 45.704779364000046],
              [-1.247303839999915, 45.70990631700005],
              [-1.230132615999935, 45.77960846600007],
              [-1.230295376999948, 45.79242584800005],
              [-1.163807745999918, 45.806708075000074],
              [-1.144276495999918, 45.80609772300005],
              [-1.080555792999917, 45.75340403900009],
              [-1.069162563999953, 45.748114325000074],
              [-1.057240363999938, 45.740220445000034],
              [-0.987172003999945, 45.71735260600008],
              [-1.009632941999939, 45.73517487200007],
              [-1.099476691999939, 45.786037502000056],
              [-1.125355597999942, 45.80768463700008],
              [-1.130686001999948, 45.81671784100007],
              [-1.132150844999956, 45.82831452000005],
              [-1.136586066999939, 45.84324778900009],
              [-1.14321855399993, 45.85773346600007],
              [-1.151722785999937, 45.86815013200004],
              [-1.140614386999914, 45.872300523000035],
              [-1.133656378999945, 45.878241278000075],
              [-1.128529425999943, 45.88422272300005],
              [-1.123768683999913, 45.888657945000034],
              [-1.112538214999915, 45.89565664300005],
              [-1.097035285999937, 45.90228913000004],
              [-1.087757941999939, 45.903225002000056],
              [-1.079741990999935, 45.902004299000055],
              [-1.073353644999941, 45.904364325000074],
              [-1.069162563999953, 45.91596100500004],
              [-1.070423956999946, 45.92633698100008],
              [-1.076324022999927, 45.936712958000044],
              [-1.083485480999911, 45.945379950000074],
              [-1.089751756999931, 45.95075104400007],
              [-1.08421790299991, 45.95392487200007],
              [-1.074208136999914, 45.96157461100006],
              [-1.069162563999953, 45.96434153900009],
              [-1.085560675999943, 45.971991278000075],
              [-1.096587693999936, 45.98541901200008],
              [-1.110747850999928, 46.01837799700007],
              [-1.089751756999931, 46.00820547100005],
              [-1.072987433999913, 46.007473049000055],
              [-1.059722459999932, 46.01577383000006],
              [-1.048695441999939, 46.03266022300005],
              [-1.048695441999939, 46.03880442900004],
              [-1.052886522999927, 46.04328034100007],
              [-1.058583136999914, 46.04791901200008],
              [-1.065174933999913, 46.05158112200007],
              [-1.08421790299991, 46.05654531500005],
              [-1.087757941999939, 46.06468333500004],
              [-1.088734503999945, 46.07477448100008],
              [-1.09601803299995, 46.08836497600004],
              [-1.095692511999914, 46.097723700000074],
              [-1.097035285999937, 46.101548570000034],
              [-1.100738084999932, 46.10309479400007],
              [-1.11359615799995, 46.10614655200004],
              [-1.117014126999948, 46.10781484600005],
              [-1.122954881999931, 46.112494208000044],
              [-1.129017706999946, 46.11579010600008],
              [-1.128895636999914, 46.12006256700005],
              [-1.117014126999948, 46.128241278000075],
              [-1.140370245999918, 46.14057038000004],
              [-1.148019985999952, 46.141913153000075],
              [-1.152088995999918, 46.143866278000075],
              [-1.151844855999911, 46.148423570000034],
              [-1.150542772999927, 46.15326569200005],
              [-1.151722785999937, 46.15619538000004],
              [-1.157093878999945, 46.15696849200003],
              [-1.172230597999942, 46.15619538000004],
              [-1.182606574999909, 46.15839264500005],
              [-1.19163977799991, 46.15794505400004],
              [-1.200184699999909, 46.15912506700005],
              [-1.209706183999913, 46.16616445500006],
              [-1.210804816999939, 46.17454661700003],
              [-1.204416469999956, 46.18431224200003],
              [-1.194488084999932, 46.19277578300006],
              [-1.185170050999943, 46.19717031500005],
              [-1.190541144999941, 46.21629466400009],
              [-1.179595506999931, 46.22947825700004],
              [-1.110747850999928, 46.25922272300005],
              [-1.102650519999941, 46.27195872600004],
              [-1.103505011999914, 46.28001536700003],
              [-1.108021613999938, 46.28851959800005],
              [-1.110747850999928, 46.30267975500004],
              [-1.132476365999935, 46.32412344000005],
              [-1.177235480999911, 46.326157945000034],
              [-1.214344855999911, 46.31069570500006],
              [-1.21320553299995, 46.27912018400008],
              [-1.240101691999939, 46.28424713700008],
              [-1.259185350999928, 46.300441799000055],
              [-1.277414516999954, 46.319525458000044],
              [-1.293365037999934, 46.32265859600005],
              [-1.303456183999913, 46.323879299000055],
              [-1.33421790299991, 46.33673737200007],
              [-1.356841600999928, 46.35032786700003],
              [-1.370228644999941, 46.35419342700004],
              [-1.423329230999911, 46.34247467700004],
              [-1.448719855999911, 46.343410549000055],
              [-1.459584113999938, 46.36473216400009],
              [-1.46548417899993, 46.389960028000075],
              [-1.481434699999909, 46.408189195000034],
              [-1.504465298999946, 46.41933828300006],
              [-1.53189042899993, 46.423081773000035],
              [-1.598784959999932, 46.425034898000035],
              [-1.62564042899993, 46.43113841400009],
              [-1.617176886999914, 46.44354889500005],
              [-1.63345292899993, 46.454291083000044],
              [-1.686756964999915, 46.46088288000004],
              [-1.720285610999952, 46.48126862200007],
              [-1.748605923999946, 46.48655833500004],
              [-1.761138475999928, 46.49201080900008],
              [-1.768422003999945, 46.50023021000004],
              [-1.779652472999942, 46.52212148600006],
              [-1.789173956999946, 46.53294505400004],
              [-1.788889126999948, 46.52045319200005],
              [-1.783070441999939, 46.50413646000004],
              [-1.781727667999917, 46.495428778000075],
              [-1.786000128999945, 46.49095286700003],
              [-1.795399542999917, 46.49453359600005],
              [-1.804798956999946, 46.503607489000046],
              [-1.827056443999936, 46.57697174700007],
              [-1.822661912999934, 46.59438711100006],
              [-1.838693813999953, 46.59906647300005],
              [-1.846587693999936, 46.610256252000056],
              [-1.851226365999935, 46.62372467700004],
              [-1.857411261999914, 46.63532135600008],
              [-1.872425910999937, 46.64740631700005],
              [-1.887806769999941, 46.65656159100007],
              [-1.899769660999937, 46.66624583500004],
              [-1.909901495999918, 46.69179922100005],
              [-1.923166469999956, 46.69916413000004],
              [-1.940012173999946, 46.70307038000004],
              [-1.956450975999928, 46.704291083000044],
              [-1.964995897999927, 46.71039459800005],
              [-1.994618292999917, 46.752020575000074],
              [-2.050282355999911, 46.79205963700008],
              [-2.081288214999915, 46.80735911700003],
              [-2.107167120999918, 46.81346263200004],
              [-2.118763800999943, 46.819973049000055],
              [-2.126088019999941, 46.835598049000055],
              [-2.130034959999932, 46.854681708000044],
              [-2.131255662999934, 46.87181224200003],
              [-2.128773566999939, 46.893459377000056],
              [-2.121978318999936, 46.90371328300006],
              [-2.09634355399993, 46.91648997600004],
              [-2.102162238999938, 46.93065013200004],
              [-2.087473110999952, 46.94122955900008],
              [-2.049224412999934, 46.957464911000045],
              [-2.037017381999931, 46.97256094000005],
              [-2.02017167899993, 47.00861237200007],
              [-2.008290167999917, 47.02635325700004],
              [-1.990712042999917, 47.03538646000004],
              [-1.992583787999934, 47.05231354400007],
              [-2.003773566999939, 47.070013739000046],
              [-2.014556443999936, 47.08161041900007],
              [-2.030018683999913, 47.09210846600007],
              [-2.09015865799995, 47.11517975500004],
              [-2.205474412999934, 47.12909577000005],
              [-2.241118943999936, 47.14248281500005],
              [-2.227853969999956, 47.14862702000005],
              [-2.21703040299991, 47.155503648000035],
              [-2.20539303299995, 47.16120026200008],
              [-2.172840949999909, 47.16437409100007],
              [-2.165191209999932, 47.16787344000005],
              [-2.162098761999914, 47.17601146000004],
              [-2.159087693999936, 47.19086334800005],
              [-2.158680792999917, 47.20449453300006],
              [-2.169300910999937, 47.22016022300005],
              [-2.17210852799991, 47.235256252000056],
              [-2.170887824999909, 47.24632396000004],
              [-2.166981574999909, 47.25922272300005],
              [-2.160552537999934, 47.271185614000046],
              [-2.151682094999956, 47.27968984600005],
              [-2.127674933999913, 47.286810614000046],
              [-2.035633917999917, 47.29328034100007],
              [-2.028716600999928, 47.296942450000074],
              [-2.021962042999917, 47.299261786000045],
              [-2.014556443999936, 47.300116278000075],
              [-2.006581183999913, 47.29328034100007],
              [-1.999134894999941, 47.28856028900009],
              [-1.947865363999938, 47.279364325000074],
              [-1.932484503999945, 47.27968984600005],
              [-1.939361131999931, 47.286444403000075],
              [-1.927805141999954, 47.286322333000044],
              [-1.917062954999949, 47.28416575700004],
              [-1.907338019999941, 47.27993398600006],
              [-1.898426886999914, 47.273423570000034],
              [-1.918853318999936, 47.273423570000034],
              [-1.918853318999936, 47.26601797100005],
              [-1.877837693999936, 47.24551015800006],
              [-1.83625240799995, 47.239935614000046],
              [-1.826079881999931, 47.235256252000056],
              [-1.803944464999915, 47.21898021000004],
              [-1.780995245999918, 47.21198151200008],
              [-1.727040167999917, 47.21076080900008],
              [-1.747222459999932, 47.219916083000044],
              [-1.788238084999932, 47.22557200700004],
              [-1.805653449999909, 47.235256252000056],
              [-1.835926886999914, 47.259751695000034],
              [-1.871164516999954, 47.27968984600005],
              [-1.905629035999937, 47.29393138200004],
              [-1.925689256999931, 47.298488674000055],
              [-1.949289516999954, 47.300116278000075],
              [-1.958159959999932, 47.302394924000055],
              [-1.972157355999911, 47.312160549000055],
              [-2.010121222999942, 47.31972890800006],
              [-2.148101365999935, 47.31321849200003],
              [-2.179554816999939, 47.300116278000075],
              [-2.186594204999949, 47.29271067900004],
              [-2.190581834999932, 47.28620026200008],
              [-2.19595292899993, 47.27993398600006],
              [-2.206288214999915, 47.273423570000034],
              [-2.236073370999918, 47.26748281500005],
              [-2.259429490999935, 47.251613674000055],
              [-2.278391079999949, 47.24640534100007],
              [-2.298085089999915, 47.24664948100008],
              [-2.316070115999935, 47.251654364000046],
              [-2.330962693999936, 47.26080963700008],
              [-2.355336066999939, 47.28009674700007],
              [-2.37140865799995, 47.286444403000075],
              [-2.388091600999928, 47.28790924700007],
              [-2.397450324999909, 47.28758372600004],
              [-2.404896613999938, 47.286444403000075],
              [-2.412831183999913, 47.28172435100004],
              [-2.416574673999946, 47.27496979400007],
              [-2.418120897999927, 47.268866278000075],
              [-2.419178839999915, 47.26601797100005],
              [-2.448394334999932, 47.26658763200004],
              [-2.541981574999909, 47.300116278000075],
              [-2.541981574999909, 47.30695221600007],
              [-2.519032355999911, 47.30463288000004],
              [-2.476063605999911, 47.290676174000055],
              [-2.45335852799991, 47.29328034100007],
              [-2.43618730399993, 47.30703359600005],
              [-2.445383266999954, 47.320379950000074],
              [-2.465443488999938, 47.33380768400008],
              [-2.480620897999927, 47.34788646000004],
              [-2.487945115999935, 47.345404364000046],
              [-2.491281704999949, 47.34389883000006],
              [-2.494252081999946, 47.34174225500004],
              [-2.489369269999941, 47.334418036000045],
              [-2.48892167899993, 47.33038971600007],
              [-2.494252081999946, 47.32062409100007],
              [-2.501698370999918, 47.32062409100007],
              [-2.503325975999928, 47.349595445000034],
              [-2.514800584999932, 47.364935614000046],
              [-2.556385870999918, 47.383246161000045],
              [-2.47679602799991, 47.415676174000055],
              [-2.466135219999956, 47.415228583000044],
              [-2.455799933999913, 47.412176825000074],
              [-2.439035610999952, 47.40997955900008],
              [-2.441029425999943, 47.40444570500006],
              [-2.442209438999953, 47.404364325000074],
              [-2.446400519999941, 47.40253327000005],
              [-2.439035610999952, 47.39630768400008],
              [-2.429432745999918, 47.40387604400007],
              [-2.395008917999917, 47.41697825700004],
              [-2.391835089999915, 47.42365143400008],
              [-2.407134568999936, 47.42572663000004],
              [-2.431752081999946, 47.42617422100005],
              [-2.448150193999936, 47.43060944200005],
              [-2.439035610999952, 47.44476959800005],
              [-2.45531165299991, 47.45221588700008],
              [-2.476185675999943, 47.45376211100006],
              [-2.48892167899993, 47.45917389500005],
              [-2.480620897999927, 47.478216864000046],
              [-2.494740363999938, 47.49119700700004],
              [-2.483631964999915, 47.49795156500005],
              [-2.421213344999956, 47.50023021000004],
              [-2.384673631999931, 47.507147528000075],
              [-2.36392167899993, 47.50617096600007],
              [-2.380116339999915, 47.50922272300005],
              [-2.407053188999953, 47.50604889500005],
              [-2.425363735999952, 47.50617096600007],
              [-2.501698370999918, 47.526678778000075],
              [-2.517486131999931, 47.52838776200008],
              [-2.530506964999915, 47.52724844000005],
              [-2.563221808999913, 47.51984284100007],
              [-2.600697394999941, 47.51984284100007],
              [-2.609852667999917, 47.51772695500006],
              [-2.615589972999942, 47.51414622600004],
              [-2.621693488999938, 47.51341380400004],
              [-2.631988084999932, 47.51984284100007],
              [-2.616932745999918, 47.52171458500004],
              [-2.599354620999918, 47.52912018400008],
              [-2.584462042999917, 47.54047272300005],
              [-2.57681230399993, 47.553941148000035],
              [-2.592274542999917, 47.54364655200004],
              [-2.606434699999909, 47.54205963700008],
              [-2.621205206999946, 47.543036200000074],
              [-2.638254360999952, 47.540269273000035],
              [-2.630116339999915, 47.539129950000074],
              [-2.623931443999936, 47.537176825000074],
              [-2.619943813999953, 47.53339264500005],
              [-2.617787238999938, 47.526678778000075],
              [-2.643055792999917, 47.52643463700008],
              [-2.654774542999917, 47.52830638200004],
              [-2.665516730999911, 47.53351471600007],
              [-2.667103644999941, 47.50958893400008],
              [-2.680734829999949, 47.50421784100007],
              [-2.714019334999932, 47.51239655200004],
              [-2.73070227799991, 47.51162344000005],
              [-2.782785610999952, 47.49941640800006],
              [-2.802154100999928, 47.498114325000074],
              [-2.817128058999913, 47.499212958000044],
              [-2.830189581999946, 47.503607489000046],
              [-2.843658006999931, 47.51239655200004],
              [-2.845692511999914, 47.51618073100008],
              [-2.861073370999918, 47.53583405200004],
              [-2.864816860999952, 47.53685130400004],
              [-2.868967251999948, 47.542181708000044],
              [-2.878529425999943, 47.54531484600005],
              [-2.889881964999915, 47.54661692900004],
              [-2.892933722999942, 47.54767487200007],
              [-2.891509568999936, 47.54905833500004],
              [-2.892079230999911, 47.553941148000035],
              [-2.909250454999949, 47.55841705900008],
              [-2.892567511999914, 47.56659577000005],
              [-2.865305141999954, 47.56663646000004],
              [-2.850575324999909, 47.546535549000055],
              [-2.843658006999931, 47.546535549000055],
              [-2.83812415299991, 47.55182526200008],
              [-2.832427537999934, 47.554022528000075],
              [-2.825428839999915, 47.55247630400004],
              [-2.816395636999914, 47.546535549000055],
              [-2.815297003999945, 47.55296458500004],
              [-2.809559699999909, 47.567613023000035],
              [-2.794016079999949, 47.555121161000045],
              [-2.768666144999941, 47.54954661700003],
              [-2.741444464999915, 47.55133698100008],
              [-2.720204230999911, 47.56077708500004],
              [-2.727650519999941, 47.567613023000035],
              [-2.688628709999932, 47.604396877000056],
              [-2.683990037999934, 47.62299225500004],
              [-2.706532355999911, 47.64272695500006],
              [-2.706532355999911, 47.63654205900008],
              [-2.696929490999935, 47.629787502000056],
              [-2.69562740799995, 47.62335846600007],
              [-2.701568162999934, 47.618353583000044],
              [-2.714019334999932, 47.61603424700007],
              [-2.699777798999946, 47.60919830900008],
              [-2.704253709999932, 47.60443756700005],
              [-2.708607550999943, 47.60228099200003],
              [-2.720204230999911, 47.60175202000005],
              [-2.725331183999913, 47.60736725500004],
              [-2.775380011999914, 47.62909577000005],
              [-2.754465298999946, 47.627020575000074],
              [-2.734486456999946, 47.622259833000044],
              [-2.74632727799991, 47.63385651200008],
              [-2.758208787999934, 47.63906484600005],
              [-2.789133266999954, 47.64272695500006],
              [-2.775380011999914, 47.63654205900008],
              [-2.796050584999932, 47.62986888200004],
              [-2.847727016999954, 47.626166083000044],
              [-2.857980923999946, 47.619126695000034],
              [-2.866769985999952, 47.60716380400004],
              [-2.886382615999935, 47.60101959800005],
              [-2.919422980999911, 47.59552643400008],
              [-2.919422980999911, 47.60175202000005],
              [-2.912668423999946, 47.60175202000005],
              [-2.912668423999946, 47.60919830900008],
              [-2.925689256999931, 47.60765208500004],
              [-2.928822394999941, 47.60602448100008],
              [-2.933094855999911, 47.60175202000005],
              [-2.939930792999917, 47.60175202000005],
              [-2.943755662999934, 47.61395905200004],
              [-2.944813605999911, 47.62409088700008],
              [-2.94163977799991, 47.63182200700004],
              [-2.933094855999911, 47.63654205900008],
              [-2.94749915299991, 47.63690827000005],
              [-2.957997199999909, 47.64215729400007],
              [-2.964588995999918, 47.65143463700008],
              [-2.967193162999934, 47.66380442900004],
              [-2.974680141999954, 47.66380442900004],
              [-2.97329667899993, 47.65599192900004],
              [-2.968576626999948, 47.64350006700005],
              [-2.967193162999934, 47.63654205900008],
              [-2.967193162999934, 47.612616278000075],
              [-2.963612433999913, 47.60260651200008],
              [-2.954701300999943, 47.59153880400004],
              [-2.943511522999927, 47.58148834800005],
              [-2.933094855999911, 47.57444896000004],
              [-2.935617641999954, 47.567572333000044],
              [-2.937245245999918, 47.56468333500004],
              [-2.939930792999917, 47.56077708500004],
              [-2.942616339999915, 47.56439850500004],
              [-2.952951626999948, 47.57444896000004],
              [-2.961293097999942, 47.57054271000004],
              [-2.970285610999952, 47.57697174700007],
              [-2.980946417999917, 47.58734772300005],
              [-2.994496222999942, 47.59552643400008],
              [-2.98859615799995, 47.58226146000004],
              [-2.994211391999954, 47.57607656500005],
              [-3.003407355999911, 47.57868073100008],
              [-3.008168097999942, 47.591782945000034],
              [-3.011789516999954, 47.60716380400004],
              [-3.01821855399993, 47.60565827000005],
              [-3.02171790299991, 47.59454987200007],
              [-3.015695766999954, 47.581244208000044],
              [-3.02993730399993, 47.58193594000005],
              [-3.03579667899993, 47.583319403000075],
              [-3.042388475999928, 47.58808014500005],
              [-3.073841925999943, 47.57648346600007],
              [-3.089751756999931, 47.575506903000075],
              [-3.10374915299991, 47.581244208000044],
              [-3.097320115999935, 47.584051825000074],
              [-3.090728318999936, 47.58808014500005],
              [-3.100453253999945, 47.594183661000045],
              [-3.112049933999913, 47.59918854400007],
              [-3.12328040299991, 47.59878164300005],
              [-3.131703253999945, 47.58808014500005],
              [-3.12718665299991, 47.58661530200004],
              [-3.122954881999931, 47.583238023000035],
              [-3.118031378999945, 47.581244208000044],
              [-3.128895636999914, 47.54759349200003],
              [-3.12328040299991, 47.51898834800005],
              [-3.106760219999956, 47.495794989000046],
              [-3.084543423999946, 47.478216864000046],
              [-3.098133917999917, 47.47870514500005],
              [-3.119130011999914, 47.48261139500005],
              [-3.125477667999917, 47.478216864000046],
              [-3.131703253999945, 47.478216864000046],
              [-3.143788214999915, 47.507025458000044],
              [-3.145375128999945, 47.51609935100004],
              [-3.14321855399993, 47.527044989000046],
              [-3.133859829999949, 47.54393138200004],
              [-3.131703253999945, 47.55744049700007],
              [-3.134185350999928, 47.58075592700004],
              [-3.141184048999946, 47.59804922100005],
              [-3.152170376999948, 47.61123281500005],
              [-3.166493292999917, 47.622259833000044],
              [-3.17601477799991, 47.62636953300006],
              [-3.187245245999918, 47.62958405200004],
              [-3.196685350999928, 47.63349030200004],
              [-3.200591600999928, 47.63959381700005],
              [-3.198394334999932, 47.65257396000004],
              [-3.186350063999953, 47.68060944200005],
              [-3.111195441999939, 47.70416901200008],
              [-3.115061001999948, 47.709418036000045],
              [-3.117176886999914, 47.71503327000005],
              [-3.118031378999945, 47.72215403900009],
              [-3.118031378999945, 47.732123114000046],
              [-3.122792120999918, 47.72992584800005],
              [-3.134510870999918, 47.72679271000004],
              [-3.139149542999917, 47.724676825000074],
              [-3.139759894999941, 47.745794989000046],
              [-3.139149542999917, 47.75259023600006],
              [-3.145375128999945, 47.75259023600006],
              [-3.153187628999945, 47.74201080900008],
              [-3.163929816999939, 47.74388255400004],
              [-3.177357550999943, 47.74852122600004],
              [-3.193186001999948, 47.74640534100007],
              [-3.179188605999911, 47.74274323100008],
              [-3.169667120999918, 47.73541901200008],
              [-3.163319464999915, 47.72475820500006],
              [-3.159087693999936, 47.711004950000074],
              [-3.164051886999914, 47.710272528000075],
              [-3.165028449999909, 47.70954010600008],
              [-3.165028449999909, 47.707912502000056],
              [-3.166493292999917, 47.70416901200008],
              [-3.17837480399993, 47.71002838700008],
              [-3.185373501999948, 47.706366278000075],
              [-3.193226691999939, 47.69993724200003],
              [-3.207386847999942, 47.697333075000074],
              [-3.203521287999934, 47.69432200700004],
              [-3.193186001999948, 47.68374258000006],
              [-3.207142706999946, 47.67914459800005],
              [-3.211903449999909, 47.66982656500005],
              [-3.21507727799991, 47.660589911000045],
              [-3.224191860999952, 47.65639883000006],
              [-3.231597459999932, 47.66034577000005],
              [-3.262074347999942, 47.68374258000006],
              [-3.287587042999917, 47.688666083000044],
              [-3.331532355999911, 47.69672272300005],
              [-3.358265753999945, 47.697333075000074],
              [-3.340199347999942, 47.70229726800005],
              [-3.322417772999927, 47.70099518400008],
              [-3.282622850999928, 47.69114817900004],
              [-3.282622850999928, 47.697333075000074],
              [-3.298451300999943, 47.70384349200003],
              [-3.316273566999939, 47.70807526200008],
              [-3.358265753999945, 47.711004950000074],
              [-3.358265753999945, 47.718451239000046],
              [-3.349354620999918, 47.71906159100007],
              [-3.345122850999928, 47.72125885600008],
              [-3.34398352799991, 47.726263739000046],
              [-3.34398352799991, 47.735541083000044],
              [-3.340565558999913, 47.739488023000035],
              [-3.323557094999956, 47.73773834800005],
              [-3.317290818999936, 47.73895905200004],
              [-3.304432745999918, 47.76113515800006],
              [-3.295399542999917, 47.77301666900007],
              [-3.282622850999928, 47.77993398600006],
              [-3.282622850999928, 47.78733958500004],
              [-3.304351365999935, 47.77008698100008],
              [-3.331776495999918, 47.75250885600008],
              [-3.362172003999945, 47.74042389500005],
              [-3.383168097999942, 47.73704661700003],
              [-3.375477667999917, 47.734035549000055],
              [-3.369252081999946, 47.729803778000075],
              [-3.364491339999915, 47.724676825000074],
              [-3.364491339999915, 47.718451239000046],
              [-3.446441209999932, 47.70457591400009],
              [-3.460682745999918, 47.70758698100008],
              [-3.464995897999927, 47.71303945500006],
              [-3.494862433999913, 47.73895905200004],
              [-3.509185350999928, 47.759426174000055],
              [-3.520253058999913, 47.76813385600008],
              [-3.524484829999949, 47.77244700700004],
              [-3.528309699999909, 47.77993398600006],
              [-3.53929602799991, 47.77374909100007],
              [-3.555653449999909, 47.77399323100008],
              [-3.590972459999932, 47.77993398600006],
              [-3.616851365999935, 47.77912018400008],
              [-3.625152147999927, 47.77993398600006],
              [-3.63304602799991, 47.78302643400008],
              [-3.644398566999939, 47.79173411700003],
              [-3.649037238999938, 47.79360586100006],
              [-3.686919725999928, 47.792303778000075],
              [-3.706166144999941, 47.796942450000074],
              [-3.714588995999918, 47.810614325000074],
              [-3.723215298999946, 47.813381252000056],
              [-3.775380011999914, 47.79360586100006],
              [-3.789906378999945, 47.80320872600004],
              [-3.81118730399993, 47.80292389500005],
              [-3.833566860999952, 47.79975006700005],
              [-3.851714647999927, 47.80101146000004],
              [-3.853098110999952, 47.804348049000055],
              [-3.872222459999932, 47.82831452000005],
              [-3.87922115799995, 47.83356354400007],
              [-3.886463995999918, 47.83746979400007],
              [-3.889963344999956, 47.843451239000046],
              [-3.885853644999941, 47.85504791900007],
              [-3.894520636999914, 47.85529205900008],
              [-3.900786912999934, 47.857123114000046],
              [-3.913197394999941, 47.86245351800005],
              [-3.91633053299995, 47.87335846600007],
              [-3.935129360999952, 47.887884833000044],
              [-3.961822068999936, 47.89996979400007],
              [-3.988270636999914, 47.90346914300005],
              [-3.979237433999913, 47.88300202000005],
              [-3.986480272999927, 47.86790599200003],
              [-4.008900519999941, 47.851263739000046],
              [-4.029204881999931, 47.85504791900007],
              [-4.019154425999943, 47.85447825700004],
              [-4.011219855999911, 47.85594310100004],
              [-4.005441860999952, 47.86050039300005],
              [-4.001942511999914, 47.86928945500006],
              [-4.014068162999934, 47.86627838700008],
              [-4.024037238999938, 47.86595286700003],
              [-4.03156490799995, 47.863714911000045],
              [-4.036691860999952, 47.85504791900007],
              [-4.064930792999917, 47.870794989000046],
              [-4.078236456999946, 47.87441640800006],
              [-4.09439042899993, 47.87547435100004],
              [-4.106556769999941, 47.880113023000035],
              [-4.119292772999927, 47.891913153000075],
              [-4.12913977799991, 47.90761953300006],
              [-4.132191535999937, 47.923895575000074],
              [-4.142730272999927, 47.91201406500005],
              [-4.136830206999946, 47.896918036000045],
              [-4.12336178299995, 47.883246161000045],
              [-4.111195441999939, 47.87547435100004],
              [-4.111195441999939, 47.86928945500006],
              [-4.123768683999913, 47.86859772300005],
              [-4.133615688999953, 47.86619700700004],
              [-4.142648891999954, 47.861761786000045],
              [-4.152740037999934, 47.85504791900007],
              [-4.171620245999918, 47.877020575000074],
              [-4.185617641999954, 47.87441640800006],
              [-4.188465949999909, 47.86212799700007],
              [-4.173898891999954, 47.85504791900007],
              [-4.176665818999936, 47.851263739000046],
              [-4.180043097999942, 47.84821198100008],
              [-4.180043097999942, 47.84198639500005],
              [-4.152740037999934, 47.84198639500005],
              [-4.152740037999934, 47.83445872600004],
              [-4.185210740999935, 47.813381252000056],
              [-4.200550910999937, 47.80719635600008],
              [-4.225168423999946, 47.802435614000046],
              [-4.371815558999913, 47.80719635600008],
              [-4.371245897999927, 47.81476471600007],
              [-4.373443162999934, 47.82868073100008],
              [-4.371815558999913, 47.83445872600004],
              [-4.36546790299991, 47.837103583000044],
              [-4.356068488999938, 47.83706289300005],
              [-4.347645636999914, 47.838324286000045],
              [-4.343861456999946, 47.84511953300006],
              [-4.347320115999935, 47.862941799000055],
              [-4.362212693999936, 47.88857656500005],
              [-4.371978318999936, 47.91583893400008],
              [-4.38695227799991, 47.93406810100004],
              [-4.434641079999949, 47.97565338700008],
              [-4.523264126999948, 48.022691148000035],
              [-4.533273891999954, 48.02631256700005],
              [-4.546701626999948, 48.020738023000035],
              [-4.558990037999934, 48.01068756700005],
              [-4.572010870999918, 48.005926825000074],
              [-4.601958787999934, 48.02558014500005],
              [-4.619211391999954, 48.02765534100007],
              [-4.65298417899993, 48.02631256700005],
              [-4.728138800999943, 48.04059479400007],
              [-4.721506313999953, 48.044134833000044],
              [-4.716460740999935, 48.05023834800005],
              [-4.712269660999937, 48.05658600500004],
              [-4.706206834999932, 48.06391022300005],
              [-4.705555792999917, 48.06745026200008],
              [-4.704253709999932, 48.07123444200005],
              [-4.700795050999943, 48.07477448100008],
              [-4.697417772999927, 48.07489655200004],
              [-4.689523891999954, 48.06883372600004],
              [-4.683705206999946, 48.06732819200005],
              [-4.361927863999938, 48.11570872600004],
              [-4.304758266999954, 48.10407135600008],
              [-4.289906378999945, 48.10822174700007],
              [-4.28538977799991, 48.11538320500006],
              [-4.27570553299995, 48.14362213700008],
              [-4.280181443999936, 48.15493398600006],
              [-4.294341600999928, 48.16705963700008],
              [-4.297352667999917, 48.17405833500004],
              [-4.302357550999943, 48.19635651200008],
              [-4.315825975999928, 48.205511786000045],
              [-4.358225063999953, 48.21185944200005],
              [-4.366118943999936, 48.21515534100007],
              [-4.372425910999937, 48.220038153000075],
              [-4.376861131999931, 48.22597890800006],
              [-4.379261847999942, 48.23236725500004],
              [-4.404367641999954, 48.22614166900007],
              [-4.457630988999938, 48.24896881700005],
              [-4.485463019999941, 48.242621161000045],
              [-4.499989386999914, 48.22492096600007],
              [-4.51398678299995, 48.20209381700005],
              [-4.531646287999934, 48.18309153900009],
              [-4.557484503999945, 48.17719147300005],
              [-4.548736131999931, 48.198431708000044],
              [-4.543771938999953, 48.205064195000034],
              [-4.555043097999942, 48.21653880400004],
              [-4.56118730399993, 48.225043036000045],
              [-4.563628709999932, 48.23236725500004],
              [-4.558664516999954, 48.244208075000074],
              [-4.550933397999927, 48.24860260600008],
              [-4.54718990799995, 48.25259023600006],
              [-4.554066535999937, 48.26276276200008],
              [-4.566273566999939, 48.264878648000035],
              [-4.626332160999937, 48.26654694200005],
              [-4.62368730399993, 48.277044989000046],
              [-4.626332160999937, 48.28705475500004],
              [-4.615386522999927, 48.291083075000074],
              [-4.607085740999935, 48.29059479400007],
              [-4.598784959999932, 48.288397528000075],
              [-4.587880011999914, 48.28705475500004],
              [-4.575184699999909, 48.29002513200004],
              [-4.57290605399993, 48.29682038000004],
              [-4.575510219999956, 48.30385976800005],
              [-4.577259894999941, 48.307521877000056],
              [-4.559478318999936, 48.33869049700007],
              [-4.546701626999948, 48.34682851800005],
              [-4.530140753999945, 48.34162018400008],
              [-4.54320227799991, 48.304673570000034],
              [-4.515533006999931, 48.29584381700005],
              [-4.426503058999913, 48.300034898000035],
              [-4.416371222999942, 48.29661692900004],
              [-4.409657355999911, 48.292303778000075],
              [-4.401966925999943, 48.28856028900009],
              [-4.38898678299995, 48.28705475500004],
              [-4.376861131999931, 48.28778717700004],
              [-4.329701300999943, 48.29702383000006],
              [-4.262603318999936, 48.300034898000035],
              [-4.268950975999928, 48.29584381700005],
              [-4.275217251999948, 48.29401276200008],
              [-4.289906378999945, 48.293850002000056],
              [-4.269357876999948, 48.288397528000075],
              [-4.187489386999914, 48.300034898000035],
              [-4.187489386999914, 48.307521877000056],
              [-4.218820766999954, 48.30605703300006],
              [-4.230539516999954, 48.309881903000075],
              [-4.234730597999942, 48.32172272300005],
              [-4.243967251999948, 48.31391022300005],
              [-4.257720506999931, 48.31134674700007],
              [-4.27017167899993, 48.31468333500004],
              [-4.27570553299995, 48.32485586100006],
              [-4.281971808999913, 48.32367584800005],
              [-4.324696417999917, 48.32172272300005],
              [-4.316314256999931, 48.33079661700003],
              [-4.312082485999952, 48.33307526200008],
              [-4.303618943999936, 48.33539459800005],
              [-4.303130662999934, 48.33958567900004],
              [-4.298491990999935, 48.343817450000074],
              [-4.288685675999943, 48.348537502000056],
              [-4.269398566999939, 48.36273834800005],
              [-4.286284959999932, 48.362534898000035],
              [-4.308990037999934, 48.351548570000034],
              [-4.324696417999917, 48.34845612200007],
              [-4.324696417999917, 48.35529205900008],
              [-4.317290818999936, 48.35529205900008],
              [-4.317290818999936, 48.36273834800005],
              [-4.324696417999917, 48.36273834800005],
              [-4.327788865999935, 48.357855536000045],
              [-4.334055141999954, 48.352728583000044],
              [-4.337717251999948, 48.34845612200007],
              [-4.352609829999949, 48.352728583000044],
              [-4.384185350999928, 48.33812083500004],
              [-4.406605597999942, 48.33539459800005],
              [-4.403797980999911, 48.339178778000075],
              [-4.402821417999917, 48.33958567900004],
              [-4.399159308999913, 48.34162018400008],
              [-4.406605597999942, 48.34845612200007],
              [-4.415028449999909, 48.34292226800005],
              [-4.426503058999913, 48.33885325700004],
              [-4.439930792999917, 48.336371161000045],
              [-4.453724738999938, 48.33539459800005],
              [-4.453724738999938, 48.34162018400008],
              [-4.396595831999946, 48.38776276200008],
              [-4.385568813999953, 48.393744208000044],
              [-4.289906378999945, 48.43158600500004],
              [-4.307728644999941, 48.42804596600007],
              [-4.339019334999932, 48.416083075000074],
              [-4.358957485999952, 48.41111888200004],
              [-4.426503058999913, 48.40371328300006],
              [-4.457508917999917, 48.39484284100007],
              [-4.520619269999941, 48.36831289300005],
              [-4.569569464999915, 48.36029694200005],
              [-4.599354620999918, 48.35016510600008],
              [-4.618885870999918, 48.34845612200007],
              [-4.636341925999943, 48.35114166900007],
              [-4.671131964999915, 48.360581773000035],
              [-4.690541144999941, 48.36273834800005],
              [-4.694081183999913, 48.359442450000074],
              [-4.694081183999913, 48.35219961100006],
              [-4.695668097999942, 48.344956773000035],
              [-4.704497850999928, 48.34162018400008],
              [-4.754994269999941, 48.34198639500005],
              [-4.768381313999953, 48.345404364000046],
              [-4.777170376999948, 48.35561758000006],
              [-4.783355272999927, 48.37641022300005],
              [-4.764759894999941, 48.37763092700004],
              [-4.766346808999913, 48.39044830900008],
              [-4.783355272999927, 48.41738515800006],
              [-4.784901495999918, 48.43618398600006],
              [-4.779855923999946, 48.45490143400008],
              [-4.768055792999917, 48.46865469000005],
              [-4.749256964999915, 48.47260163000004],
              [-4.749256964999915, 48.47882721600007],
              [-4.774647589999915, 48.49127838700008],
              [-4.764556443999936, 48.52020905200004],
              [-4.739898240999935, 48.55072663000004],
              [-4.721994594999956, 48.56818268400008],
              [-4.71157792899993, 48.563666083000044],
              [-4.700795050999943, 48.56073639500005],
              [-4.708241339999915, 48.56818268400008],
              [-4.692290818999936, 48.575506903000075],
              [-4.673451300999943, 48.57957591400009],
              [-4.642486131999931, 48.58185455900008],
              [-4.623036261999914, 48.578192450000074],
              [-4.589833136999914, 48.565741278000075],
              [-4.577259894999941, 48.56818268400008],
              [-4.600493943999936, 48.58934153900009],
              [-4.60773678299995, 48.60301341400009],
              [-4.594634568999936, 48.60911692900004],
              [-4.548817511999914, 48.601223049000055],
              [-4.530140753999945, 48.60171133000006],
              [-4.557484503999945, 48.60911692900004],
              [-4.554432745999918, 48.61322663000004],
              [-4.552601691999939, 48.616522528000075],
              [-4.554798956999946, 48.61969635600008],
              [-4.563628709999932, 48.62343984600005],
              [-4.563628709999932, 48.62962474200003],
              [-4.485463019999941, 48.62962474200003],
              [-4.462880011999914, 48.63231028900009],
              [-4.429798956999946, 48.64280833500004],
              [-4.406605597999942, 48.64325592700004],
              [-4.420399542999917, 48.648871161000045],
              [-4.426503058999913, 48.650091864000046],
              [-4.426503058999913, 48.657538153000075],
              [-4.398060675999943, 48.66095612200007],
              [-4.370228644999941, 48.67182038000004],
              [-4.343251105999911, 48.67885976800005],
              [-4.317290818999936, 48.67804596600007],
              [-4.29914303299995, 48.66364166900007],
              [-4.306507941999939, 48.64154694200005],
              [-4.283111131999931, 48.64325592700004],
              [-4.25259355399993, 48.655462958000044],
              [-4.242054816999939, 48.657538153000075],
              [-4.229807094999956, 48.655951239000046],
              [-4.207142706999946, 48.64996979400007],
              [-4.193755662999934, 48.650091864000046],
              [-4.193755662999934, 48.657538153000075],
              [-4.213002081999946, 48.66120026200008],
              [-4.207753058999913, 48.67137278900009],
              [-4.190581834999932, 48.68305084800005],
              [-4.173898891999954, 48.691107489000046],
              [-4.154652472999942, 48.69623444200005],
              [-4.131459113999938, 48.69916413000004],
              [-4.108713344999956, 48.698146877000056],
              [-4.090687628999945, 48.691107489000046],
              [-4.084787563999953, 48.69717031500005],
              [-4.079253709999932, 48.696926174000055],
              [-4.074330206999946, 48.692287502000056],
              [-4.070220506999931, 48.684881903000075],
              [-4.064035610999952, 48.684881903000075],
              [-4.057362433999913, 48.68960195500006],
              [-4.053293423999946, 48.69554271000004],
              [-4.052642381999931, 48.70307038000004],
              [-4.056548631999931, 48.712144273000035],
              [-4.042713995999918, 48.71393463700008],
              [-4.030506964999915, 48.71702708500004],
              [-4.009348110999952, 48.725816148000035],
              [-3.973988410999937, 48.73281484600005],
              [-3.967762824999909, 48.72955963700008],
              [-3.970285610999952, 48.720038153000075],
              [-3.973866339999915, 48.71279531500005],
              [-3.972727016999954, 48.70770905200004],
              [-3.961008266999954, 48.704738674000055],
              [-3.961008266999954, 48.698553778000075],
              [-3.967762824999909, 48.698553778000075],
              [-3.967762824999909, 48.691107489000046],
              [-3.957753058999913, 48.686835028000075],
              [-3.951039191999939, 48.679388739000046],
              [-3.94953365799995, 48.66933828300006],
              [-3.954741990999935, 48.657538153000075],
              [-3.926584438999953, 48.67617422100005],
              [-3.911936001999948, 48.68121979400007],
              [-3.891997850999928, 48.67804596600007],
              [-3.901966925999943, 48.67202383000006],
              [-3.906320766999954, 48.67059967700004],
              [-3.906320766999954, 48.66437409100007],
              [-3.894195115999935, 48.653550523000035],
              [-3.864654100999928, 48.64101797100005],
              [-3.851714647999927, 48.62962474200003],
              [-3.844309048999946, 48.63646067900004],
              [-3.851714647999927, 48.64325592700004],
              [-3.844309048999946, 48.650091864000046],
              [-3.848947719999956, 48.656317450000074],
              [-3.852447068999936, 48.66453685100004],
              [-3.857899542999917, 48.684881903000075],
              [-3.851714647999927, 48.684881903000075],
              [-3.848500128999945, 48.679022528000075],
              [-3.845448370999918, 48.67601146000004],
              [-3.837473110999952, 48.67059967700004],
              [-3.84007727799991, 48.68805573100008],
              [-3.837147589999915, 48.70726146000004],
              [-3.829253709999932, 48.718451239000046],
              [-3.816965298999946, 48.712144273000035],
              [-3.812652147999927, 48.71674225500004],
              [-3.810454881999931, 48.72150299700007],
              [-3.809803839999915, 48.72695547100005],
              [-3.810129360999952, 48.73322174700007],
              [-3.79710852799991, 48.72117747600004],
              [-3.778431769999941, 48.71735260600008],
              [-3.731922980999911, 48.71898021000004],
              [-3.720855272999927, 48.716009833000044],
              [-3.697865363999938, 48.702337958000044],
              [-3.686634894999941, 48.698553778000075],
              [-3.673817511999914, 48.69822825700004],
              [-3.638172980999911, 48.704738674000055],
              [-3.638539191999939, 48.68781159100007],
              [-3.614003058999913, 48.68268463700008],
              [-3.584787563999953, 48.682806708000044],
              [-3.57054602799991, 48.68797435100004],
              [-3.580474412999934, 48.71108633000006],
              [-3.584543423999946, 48.72638580900008],
              [-3.580474412999934, 48.73322174700007],
              [-3.528309699999909, 48.739488023000035],
              [-3.542836066999939, 48.74567291900007],
              [-3.577381964999915, 48.77423737200007],
              [-3.581532355999911, 48.79059479400007],
              [-3.571400519999941, 48.79905833500004],
              [-3.542591925999943, 48.807806708000044],
              [-3.520863410999937, 48.833644924000055],
              [-3.515288865999935, 48.84194570500006],
              [-3.509185350999928, 48.84194570500006],
              [-3.499826626999948, 48.83698151200008],
              [-3.468129035999937, 48.83567942900004],
              [-3.433583136999914, 48.82221100500004],
              [-3.419748501999948, 48.82143789300005],
              [-3.425404425999943, 48.818426825000074],
              [-3.428089972999942, 48.815741278000075],
              [-3.42992102799991, 48.81244538000004],
              [-3.433338995999918, 48.807806708000044],
              [-3.409901495999918, 48.80654531500005],
              [-3.397613084999932, 48.80731842700004],
              [-3.388742641999954, 48.81118398600006],
              [-3.378651495999918, 48.81932200700004],
              [-3.371815558999913, 48.82249583500004],
              [-3.287464972999942, 48.843451239000046],
              [-3.275786912999934, 48.84935130400004],
              [-3.268950975999928, 48.84935130400004],
              [-3.259510870999918, 48.847723700000074],
              [-3.229725714999915, 48.872259833000044],
              [-3.213612433999913, 48.86981842700004],
              [-3.207142706999946, 48.85541413000004],
              [-3.207753058999913, 48.835923570000034],
              [-3.214955206999946, 48.81785716400009],
              [-3.227894660999937, 48.807806708000044],
              [-3.22679602799991, 48.80329010600008],
              [-3.225575324999909, 48.800482489000046],
              [-3.220529751999948, 48.794134833000044],
              [-3.216867641999954, 48.80678945500006],
              [-3.208729620999918, 48.81635163000004],
              [-3.178822394999941, 48.841009833000044],
              [-3.154204881999931, 48.85492584800005],
              [-3.145375128999945, 48.86237213700008],
              [-3.13499915299991, 48.85919830900008],
              [-3.116444464999915, 48.87409088700008],
              [-3.10374915299991, 48.876654364000046],
              [-3.091460740999935, 48.87128327000005],
              [-3.084339972999942, 48.862209377000056],
              [-3.083729620999918, 48.85171133000006],
              [-3.090728318999936, 48.84194570500006],
              [-3.090728318999936, 48.83567942900004],
              [-3.077056443999936, 48.82827383000006],
              [-3.08462480399993, 48.82013580900008],
              [-3.097523566999939, 48.794134833000044],
              [-3.104074673999946, 48.78620026200008],
              [-3.125477667999917, 48.76740143400008],
              [-3.125477667999917, 48.75995514500005],
              [-3.118031378999945, 48.75995514500005],
              [-3.085031704999949, 48.80499909100007],
              [-3.065500454999949, 48.82396067900004],
              [-3.049183722999942, 48.82143789300005],
              [-3.03929602799991, 48.82697174700007],
              [-3.028716600999928, 48.82880280200004],
              [-3.01821855399993, 48.82697174700007],
              [-3.008168097999942, 48.82143789300005],
              [-3.015695766999954, 48.81460195500006],
              [-3.011789516999954, 48.813666083000044],
              [-3.009388800999943, 48.813706773000035],
              [-3.008371548999946, 48.812486070000034],
              [-3.008168097999942, 48.807806708000044],
              [-3.01781165299991, 48.805853583000044],
              [-3.025502081999946, 48.80292389500005],
              [-3.042388475999928, 48.794134833000044],
              [-3.042388475999928, 48.78790924700007],
              [-3.029286261999914, 48.780462958000044],
              [-3.003651495999918, 48.773871161000045],
              [-2.952951626999948, 48.77228424700007],
              [-2.933094855999911, 48.76740143400008],
              [-2.934437628999945, 48.759100653000075],
              [-2.934396938999953, 48.75307851800005],
              [-2.933094855999911, 48.74632396000004],
              [-2.942738410999937, 48.74091217700004],
              [-2.946685350999928, 48.739488023000035],
              [-2.946685350999928, 48.73322174700007],
              [-2.932036912999934, 48.72695547100005],
              [-2.913970506999931, 48.716498114000046],
              [-2.89867102799991, 48.704779364000046],
              [-2.892079230999911, 48.69476959800005],
              [-2.826975063999953, 48.657538153000075],
              [-2.81704667899993, 48.62767161700003],
              [-2.812977667999917, 48.61969635600008],
              [-2.811431443999936, 48.614569403000075],
              [-2.814361131999931, 48.60993073100008],
              [-2.816395636999914, 48.60492584800005],
              [-2.812977667999917, 48.59857819200005],
              [-2.808013475999928, 48.59560781500005],
              [-2.795033331999946, 48.59125397300005],
              [-2.771066860999952, 48.57916901200008],
              [-2.714019334999932, 48.56073639500005],
              [-2.716949022999927, 48.55170319200005],
              [-2.72101803299995, 48.544623114000046],
              [-2.726673956999946, 48.53896719000005],
              [-2.734486456999946, 48.53400299700007],
              [-2.722727016999954, 48.533636786000045],
              [-2.71312415299991, 48.53009674700007],
              [-2.704701300999943, 48.52415599200003],
              [-2.696278449999909, 48.51666901200008],
              [-2.682362433999913, 48.509019273000035],
              [-2.679676886999914, 48.51837799700007],
              [-2.680246548999946, 48.53278229400007],
              [-2.676136847999942, 48.540228583000044],
              [-2.636341925999943, 48.53880442900004],
              [-2.620025193999936, 48.54360586100006],
              [-2.600697394999941, 48.55760325700004],
              [-2.577056443999936, 48.582464911000045],
              [-2.569406704999949, 48.58869049700007],
              [-2.55882727799991, 48.59414297100005],
              [-2.541086391999954, 48.598089911000045],
              [-2.473622199999909, 48.62596263200004],
              [-2.459543423999946, 48.63646067900004],
              [-2.459543423999946, 48.64325592700004],
              [-2.468006964999915, 48.64394765800006],
              [-2.487456834999932, 48.650091864000046],
              [-2.442860480999911, 48.659084377000056],
              [-2.421050584999932, 48.65696849200003],
              [-2.412261522999927, 48.64325592700004],
              [-2.386219855999911, 48.650091864000046],
              [-2.356068488999938, 48.663275458000044],
              [-2.329986131999931, 48.68036530200004],
              [-2.316070115999935, 48.698553778000075],
              [-2.312489386999914, 48.68695709800005],
              [-2.30532792899993, 48.67963288000004],
              [-2.29523678299995, 48.67658112200007],
              [-2.281971808999913, 48.67804596600007],
              [-2.281971808999913, 48.67059967700004],
              [-2.289418097999942, 48.66657135600008],
              [-2.293771938999953, 48.661363023000035],
              [-2.297474738999938, 48.65570709800005],
              [-2.302398240999935, 48.650091864000046],
              [-2.33031165299991, 48.62962474200003],
              [-2.312652147999927, 48.62018463700008],
              [-2.294016079999949, 48.628607489000046],
              [-2.273589647999927, 48.642645575000074],
              [-2.250965949999909, 48.650091864000046],
              [-2.246205206999946, 48.64472077000005],
              [-2.240712042999917, 48.62132396000004],
              [-2.237294074999909, 48.61591217700004],
              [-2.225941535999937, 48.61237213700008],
              [-2.219227667999917, 48.60366445500006],
              [-2.215687628999945, 48.59243398600006],
              [-2.213693813999953, 48.58185455900008],
              [-2.202788865999935, 48.58588288000004],
              [-2.19554602799991, 48.593451239000046],
              [-2.192128058999913, 48.60374583500004],
              [-2.192616339999915, 48.61591217700004],
              [-2.188384568999936, 48.60130442900004],
              [-2.182972785999937, 48.588771877000056],
              [-2.17406165299991, 48.58295319200005],
              [-2.159087693999936, 48.58869049700007],
              [-2.159087693999936, 48.59544505400004],
              [-2.163197394999941, 48.59650299700007],
              [-2.17210852799991, 48.60171133000006],
              [-2.161040818999936, 48.61302317900004],
              [-2.149322068999936, 48.61888255400004],
              [-2.13703365799995, 48.61798737200007],
              [-2.124338344999956, 48.60911692900004],
              [-2.131255662999934, 48.615301825000074],
              [-2.136626756999931, 48.62213776200008],
              [-2.14484615799995, 48.63646067900004],
              [-2.100209113999938, 48.646918036000045],
              [-2.052357550999943, 48.650091864000046],
              [-2.049794074999909, 48.64557526200008],
              [-2.028716600999928, 48.61969635600008],
              [-2.027088995999918, 48.60895416900007],
              [-2.022043423999946, 48.598944403000075],
              [-2.013254360999952, 48.59162018400008],
              [-2.000884568999936, 48.58869049700007],
              [-2.005116339999915, 48.57884349200003],
              [-2.008290167999917, 48.57501862200007],
              [-1.982492641999954, 48.54897695500006],
              [-1.976389126999948, 48.53563060100004],
              [-1.980295376999948, 48.51357656500005],
              [-1.970448370999918, 48.520697333000044],
              [-1.939361131999931, 48.53400299700007],
              [-1.967274542999917, 48.54706452000005],
              [-1.961903449999909, 48.55491771000004],
              [-1.976633266999954, 48.572699286000045],
              [-1.980295376999948, 48.58869049700007],
              [-1.973500128999945, 48.58869049700007],
              [-1.96939042899993, 48.58417389500005],
              [-1.96515865799995, 48.58120351800005],
              [-1.952951626999948, 48.57501862200007],
              [-1.960357225999928, 48.58661530200004],
              [-1.96939042899993, 48.59275950700004],
              [-1.979807094999956, 48.59511953300006],
              [-1.991118943999936, 48.59544505400004],
              [-2.000477667999917, 48.60130442900004],
              [-2.019032355999911, 48.63104889500005],
              [-2.028716600999928, 48.64325592700004],
              [-2.025542772999927, 48.65131256700005],
              [-2.018137173999946, 48.66034577000005],
              [-2.006581183999913, 48.667629299000055],
              [-1.991118943999936, 48.67059967700004],
              [-1.987700975999928, 48.67377350500004],
              [-1.987700975999928, 48.680853583000044],
              [-1.985910610999952, 48.68789297100005],
              [-1.976958787999934, 48.691107489000046],
              [-1.939361131999931, 48.691107489000046],
              [-1.94562740799995, 48.698553778000075],
              [-1.843739386999914, 48.712144273000035],
              [-1.846669074999909, 48.70783112200007],
              [-1.846913214999915, 48.70343659100007],
              [-1.843576626999948, 48.698146877000056],
              [-1.836333787999934, 48.691107489000046],
              [-1.861195441999939, 48.66421133000006],
              [-1.860951300999943, 48.64085521000004],
              [-1.83820553299995, 48.62376536700003],
              [-1.796009894999941, 48.61591217700004],
              [-1.722808397999927, 48.615301825000074],
              [-1.643950975999928, 48.62343984600005],
              [-1.595692511999914, 48.64093659100007],
              [-1.589670376999948, 48.641791083000044],
              [-1.579701300999943, 48.64325592700004],
              [-1.500559048999946, 48.63646067900004],
              [-1.393137173999946, 48.652411200000074],
              [-1.356556769999941, 48.64325592700004],
              [-1.372303839999915, 48.660589911000045],
              [-1.394602016999954, 48.66828034100007],
              [-1.432850714999915, 48.67059967700004],
              [-1.433013475999928, 48.66828034100007],
              [-1.43773352799991, 48.66445547100005],
              [-1.443267381999931, 48.66282786700003],
              [-1.44595292899993, 48.66746653900009],
              [-1.447092251999948, 48.673895575000074],
              [-1.450510219999956, 48.67951080900008],
              [-1.455799933999913, 48.68341705900008],
              [-1.490223761999914, 48.69013092700004],
              [-1.502674933999913, 48.69550202000005],
              [-1.507964647999927, 48.701605536000045],
              [-1.516468878999945, 48.72516510600008],
              [-1.553618943999936, 48.74713776200008],
              [-1.562082485999952, 48.770819403000075],
              [-1.562570766999954, 48.798488674000055],
              [-1.566761847999942, 48.82217031500005],
              [-1.578846808999913, 48.83783600500004],
              [-1.602935350999928, 48.84194570500006],
              [-1.602935350999928, 48.84935130400004],
              [-1.589100714999915, 48.853583075000074],
              [-1.578521287999934, 48.862616278000075],
              [-1.571848110999952, 48.874212958000044],
              [-1.563710089999915, 48.92210521000004],
              [-1.557036912999934, 48.93231842700004],
              [-1.548410610999952, 48.923814195000034],
              [-1.542795376999948, 48.935248114000046],
              [-1.541981574999909, 48.94407786700003],
              [-1.547027147999927, 48.94969310100004],
              [-1.558990037999934, 48.95180898600006],
              [-1.563059048999946, 48.95758698100008],
              [-1.552235480999911, 49.01544830900008],
              [-1.545765753999945, 49.03034088700008],
              [-1.532338019999941, 49.035142320000034],
              [-1.507964647999927, 49.02753327000005],
              [-1.507964647999927, 49.03367747600004],
              [-1.527251756999931, 49.03978099200003],
              [-1.549712693999936, 49.03978099200003],
              [-1.568430141999954, 49.03266022300005],
              [-1.576324022999927, 49.017279364000046],
              [-1.579457160999937, 49.01316966400009],
              [-1.586537238999938, 49.01898834800005],
              [-1.593576626999948, 49.028998114000046],
              [-1.596750454999949, 49.03742096600007],
              [-1.59593665299991, 49.06126536700003],
              [-1.593739386999914, 49.071966864000046],
              [-1.589344855999911, 49.082098700000074],
              [-1.603423631999931, 49.083970445000034],
              [-1.608754035999937, 49.091498114000046],
              [-1.60773678299995, 49.102728583000044],
              [-1.602935350999928, 49.11562734600005],
              [-1.59593665299991, 49.12848541900007],
              [-1.589019334999932, 49.13458893400008],
              [-1.569488084999932, 49.14354075700004],
              [-1.581776495999918, 49.14984772300005],
              [-1.58421790299991, 49.148423570000034],
              [-1.589344855999911, 49.14354075700004],
              [-1.597767706999946, 49.159369208000044],
              [-1.604481574999909, 49.17820872600004],
              [-1.608794725999928, 49.19782135600008],
              [-1.610422329999949, 49.21588776200008],
              [-1.602650519999941, 49.22540924700007],
              [-1.584462042999917, 49.226263739000046],
              [-1.548410610999952, 49.21930573100008],
              [-1.548410610999952, 49.225490627000056],
              [-1.569569464999915, 49.229681708000044],
              [-1.595285610999952, 49.23786041900007],
              [-1.616851365999935, 49.23822663000004],
              [-1.624663865999935, 49.21930573100008],
              [-1.640533006999931, 49.23151276200008],
              [-1.657093878999945, 49.26837799700007],
              [-1.671864386999914, 49.28009674700007],
              [-1.665394660999937, 49.28461334800005],
              [-1.662587042999917, 49.286037502000056],
              [-1.658192511999914, 49.287543036000045],
              [-1.686919725999928, 49.302435614000046],
              [-1.699086066999939, 49.31354401200008],
              [-1.706654425999943, 49.32916901200008],
              [-1.68618730399993, 49.32916901200008],
              [-1.68618730399993, 49.33535390800006],
              [-1.699126756999931, 49.35586172100005],
              [-1.706654425999943, 49.35586172100005],
              [-1.714751756999931, 49.33852773600006],
              [-1.733265753999945, 49.34625885600008],
              [-1.755726691999939, 49.36245351800005],
              [-1.775502081999946, 49.37010325700004],
              [-1.772857225999928, 49.377020575000074],
              [-1.771107550999943, 49.37995026200008],
              [-1.767974412999934, 49.38373444200005],
              [-1.78189042899993, 49.38153717700004],
              [-1.795074022999927, 49.37763092700004],
              [-1.806792772999927, 49.37685781500005],
              [-1.816477016999954, 49.38373444200005],
              [-1.819569464999915, 49.39679596600007],
              [-1.815785285999937, 49.430853583000044],
              [-1.816477016999954, 49.44521719000005],
              [-1.819406704999949, 49.452053127000056],
              [-1.823597785999937, 49.45848216400009],
              [-1.83820553299995, 49.475816148000035],
              [-1.839507615999935, 49.48065827000005],
              [-1.840240037999934, 49.48582591400009],
              [-1.843739386999914, 49.49359772300005],
              [-1.853586391999954, 49.50429922100005],
              [-1.879465298999946, 49.52496979400007],
              [-1.884673631999931, 49.530910549000055],
              [-1.878407355999911, 49.54486725500004],
              [-1.850168423999946, 49.561712958000044],
              [-1.843739386999914, 49.57184479400007],
              [-1.839222785999937, 49.603176174000055],
              [-1.839507615999935, 49.61977773600006],
              [-1.846913214999915, 49.63393789300005],
              [-1.855051235999952, 49.64508698100008],
              [-1.860585089999915, 49.65477122600004],
              [-1.869496222999942, 49.66168854400007],
              [-1.901600714999915, 49.66583893400008],
              [-1.94562740799995, 49.67796458500004],
              [-1.937652147999927, 49.70156484600005],
              [-1.939564581999946, 49.716457424000055],
              [-1.935210740999935, 49.72410716400009],
              [-1.908355272999927, 49.72638580900008],
              [-1.898996548999946, 49.724269924000055],
              [-1.87913977799991, 49.714829820000034],
              [-1.867298956999946, 49.71271393400008],
              [-1.839426235999952, 49.71539948100008],
              [-1.829457160999937, 49.71271393400008],
              [-1.824615037999934, 49.70844147300005],
              [-1.82095292899993, 49.69635651200008],
              [-1.816477016999954, 49.69163646000004],
              [-1.811838344999956, 49.690741278000075],
              [-1.800892706999946, 49.69208405200004],
              [-1.796009894999941, 49.69163646000004],
              [-1.773996548999946, 49.686712958000044],
              [-1.707753058999913, 49.68016185100004],
              [-1.63304602799991, 49.66351959800005],
              [-1.617176886999914, 49.66429271000004],
              [-1.616688605999911, 49.66201406500005],
              [-1.616363084999932, 49.65704987200007],
              [-1.61392167899993, 49.65224844000005],
              [-1.606678839999915, 49.650051174000055],
              [-1.597320115999935, 49.65228913000004],
              [-1.583729620999918, 49.66205475500004],
              [-1.572865363999938, 49.66429271000004],
              [-1.56118730399993, 49.66303131700005],
              [-1.540394660999937, 49.65778229400007],
              [-1.528431769999941, 49.657456773000035],
              [-1.511463995999918, 49.662543036000045],
              [-1.495920376999948, 49.67218659100007],
              [-1.470122850999928, 49.69505442900004],
              [-1.45571855399993, 49.70221588700008],
              [-1.409494594999956, 49.71157461100006],
              [-1.39126542899993, 49.71271393400008],
              [-1.271148240999935, 49.698431708000044],
              [-1.263050910999937, 49.69550202000005],
              [-1.259103969999956, 49.68829987200007],
              [-1.25413977799991, 49.67177969000005],
              [-1.232248501999948, 49.64142487200007],
              [-1.227772589999915, 49.62409088700008],
              [-1.253325975999928, 49.61225006700005],
              [-1.257557745999918, 49.602850653000075],
              [-1.25999915299991, 49.593451239000046],
              [-1.264027472999942, 49.58926015800006],
              [-1.286203579999949, 49.58893463700008],
              [-1.294992641999954, 49.586818752000056],
              [-1.30142167899993, 49.58177317900004],
              [-1.306263800999943, 49.55809153900009],
              [-1.29360917899993, 49.538397528000075],
              [-1.276519334999932, 49.520738023000035],
              [-1.261586066999939, 49.49315013200004],
              [-1.185292120999918, 49.43036530200004],
              [-1.175689256999931, 49.415228583000044],
              [-1.172230597999942, 49.39337799700007],
              [-1.174224412999934, 49.38239166900007],
              [-1.178700324999909, 49.37457916900007],
              [-1.183257615999935, 49.36945221600007],
              [-1.185170050999943, 49.366400458000044],
              [-1.181996222999942, 49.35618724200003],
              [-1.173817511999914, 49.35700104400007],
              [-1.163075324999909, 49.36151764500005],
              [-1.151722785999937, 49.36269765800006],
              [-1.141021287999934, 49.356675523000035],
              [-1.13345292899993, 49.34951406500005],
              [-1.122873501999948, 49.34544505400004],
              [-1.103423631999931, 49.34902578300006],
              [-1.103423631999931, 49.35586172100005],
              [-1.113758917999917, 49.36579010600008],
              [-1.106353318999936, 49.37946198100008],
              [-1.089588995999918, 49.39154694200005],
              [-1.072255011999914, 49.39679596600007],
              [-0.940419074999909, 49.392279364000046],
              [-0.822132941999939, 49.36269765800006],
              [-0.650786912999934, 49.35586172100005],
              [-0.607980923999946, 49.34739817900004],
              [-0.583363410999937, 49.34589264500005],
              [-0.546945766999954, 49.35895416900007],
              [-0.522531704999949, 49.35529205900008],
              [-0.479481574999909, 49.34275950700004],
              [-0.411122199999909, 49.34275950700004],
              [-0.393625454999949, 49.33803945500006],
              [-0.363433397999927, 49.32501862200007],
              [-0.313099738999938, 49.31732819200005],
              [-0.219471808999913, 49.28009674700007],
              [-0.194081183999913, 49.29523346600007],
              [-0.03384355399993, 49.32005442900004],
              [0.012868686000047, 49.33462148600006],
              [0.040293816000087, 49.35040924700007],
              [0.063080274000072, 49.35447825700004],
              [0.07195071700005, 49.35927969000005],
              [0.095957879000082, 49.38373444200005],
              [0.162364129000082, 49.41518789300005],
              [0.28687584700009, 49.43362051000008],
              [0.411306186000047, 49.452053127000056],
              [0.457286004000082, 49.46743398600006],
              [0.476573113000086, 49.47866445500006],
              [0.493174675000091, 49.49359772300005],
              [0.422129754000082, 49.46442291900007],
              [0.33961022200009, 49.456732489000046],
              [0.256846550000091, 49.464056708000044],
              [0.18531334700009, 49.47996653900009],
              [0.164805535000085, 49.47996653900009],
              [0.147308790000068, 49.48094310100004],
              [0.12435957100007, 49.48578522300005],
              [0.104421420000051, 49.49359772300005],
              [0.095957879000082, 49.503241278000075],
              [0.092784050000091, 49.50926341400009],
              [0.078623894000089, 49.51552969000005],
              [0.075368686000047, 49.52407461100006],
              [0.076589389000048, 49.53497955900008],
              [0.079681837000066, 49.542181708000044],
              [0.130869988000086, 49.603501695000034],
              [0.170909050000091, 49.69163646000004],
              [0.185883009000065, 49.703192450000074],
              [0.235850457000083, 49.72931549700007],
              [0.246755405000044, 49.72943756700005],
              [0.256846550000091, 49.73590729400007],
              [0.387461785000085, 49.775051174000055],
              [0.397634311000047, 49.784369208000044],
              [0.52279707100007, 49.83295319200005],
              [0.557383660000085, 49.83978913000004],
              [0.596690300000091, 49.85724518400008],
              [0.674815300000091, 49.87579987200007],
              [0.760915561000047, 49.875067450000074],
              [1.172618035000085, 49.961004950000074],
              [1.19695071700005, 49.97357819200005],
              [1.221202019000089, 49.97898997600004],
              [1.260996941000087, 50.007513739000046],
              [1.391286655000044, 50.07518138200004],
              [1.444102410000085, 50.117254950000074],
              [1.455821160000085, 50.12360260600008],
              [1.46452884200005, 50.132147528000075],
              [1.486827019000089, 50.18504466400009],
              [1.521006707000083, 50.21466705900008],
              [1.555349155000044, 50.21771881700005],
              [1.654307488000086, 50.18659088700008],
              [1.664073113000086, 50.18707916900007],
              [1.672536655000044, 50.19253164300005],
              [1.672536655000044, 50.19936758000006],
              [1.661957227000073, 50.198919989000046],
              [1.655284050000091, 50.200506903000075],
              [1.65007571700005, 50.204779364000046],
              [1.644541863000086, 50.21238841400009],
              [1.665049675000091, 50.21238841400009],
              [1.665049675000091, 50.21979401200008],
              [1.645681186000047, 50.220038153000075],
              [1.625498894000089, 50.224310614000046],
              [1.610036655000044, 50.23224518400008],
              [1.603526238000086, 50.243475653000075],
              [1.593923373000052, 50.256293036000045],
              [1.551117384000065, 50.26968008000006],
              [1.541514519000089, 50.27789948100008],
              [1.543142123000052, 50.31000397300005],
              [1.551524285000085, 50.34906647300005],
              [1.57203209700009, 50.37567780200004],
              [1.594981316000087, 50.37266673400006],
              [1.610362175000091, 50.37067291900007],
              [1.610362175000091, 50.37689850500004],
              [1.555186394000089, 50.40477122600004],
              [1.555186394000089, 50.41156647300005],
              [1.573496941000087, 50.445379950000074],
              [1.574229363000086, 50.49237702000005],
              [1.579274936000047, 50.53314850500004],
              [1.610362175000091, 50.548163153000075],
              [1.58334394600007, 50.57469310100004],
              [1.57789147200009, 50.58860911700003],
              [1.57357832100007, 50.63556549700007],
              [1.563161655000044, 50.67829010600008],
              [1.562673373000052, 50.69896067900004],
              [1.567637566000087, 50.71674225500004],
              [1.588715040000068, 50.756293036000045],
              [1.600108269000089, 50.77098216400009],
              [1.605642123000052, 50.79002513200004],
              [1.59929446700005, 50.812933661000045],
              [1.583181186000047, 50.84979889500005],
              [1.580821160000085, 50.863714911000045],
              [1.580577019000089, 50.868801174000055],
              [1.60482832100007, 50.88104889500005],
              [1.613454623000052, 50.88336823100008],
              [1.634287957000083, 50.88458893400008],
              [1.653330925000091, 50.889105536000045],
              [1.670176629000082, 50.900091864000046],
              [1.699066602000073, 50.92560455900008],
              [1.72982832100007, 50.94391510600008],
              [1.921397332000083, 50.99677155200004],
              [1.939300977000073, 50.99445221600007],
              [1.973480665000068, 51.007147528000075],
              [2.134043816000087, 51.019964911000045],
              [2.305511915000068, 51.05540599200003],
              [2.31609134200005, 51.059027411000045],
              [2.324473504000082, 51.059881903000075],
              [2.38445071700005, 51.05532461100006],
              [2.466075066000087, 51.068793036000045],
              [2.506683790000068, 51.08075592700004],
              [2.521494988000086, 51.08738841400009],
              [2.521799927545686, 51.08754088371883],
            ],
            [
              [1.983372030000055, 42.44126068100006],
              [1.986162557000114, 42.44126068100006],
              [1.996084432000117, 42.442836812000095],
              [1.99949507600013, 42.44389618000007],
              [1.988436320000119, 42.45818471300005],
              [1.978307740000076, 42.474979554000114],
              [1.967972453000073, 42.48570241300003],
              [1.956603638000075, 42.481775005000074],
              [1.945648233000099, 42.46381744500009],
              [1.947508585000122, 42.45123423300008],
              [1.960634399000071, 42.44371531200004],
              [1.983372030000055, 42.44126068100006],
            ],
          ],
          [
            [
              [-60.81041419199994, 14.46198151200008],
              [-60.82266191299993, 14.456691799000055],
              [-60.834828253999945, 14.427557684000078],
              [-60.84520423099991, 14.414129950000074],
              [-60.85643469999991, 14.409369208000044],
              [-60.87059485599991, 14.40810781500005],
              [-60.882476365999935, 14.413275458000044],
              [-60.886789516999954, 14.427801825000074],
              [-60.88076738199993, 14.437974351000037],
              [-60.86949622299994, 14.441473700000074],
              [-60.85985266799992, 14.44672272300005],
              [-60.85887610599991, 14.46198151200008],
              [-60.86851966099994, 14.475978908000059],
              [-60.88223222599993, 14.470526434000078],
              [-60.898101365999935, 14.460882880000042],
              [-60.914133266999954, 14.46198151200008],
              [-60.9134008449999, 14.47211334800005],
              [-60.920033331999946, 14.47337474200009],
              [-60.94762122299994, 14.46873607000009],
              [-61.005970831999946, 14.476263739000046],
              [-61.021595831999946, 14.474025783000059],
              [-61.04637610599991, 14.464178778000075],
              [-61.06118730399993, 14.46198151200008],
              [-61.069569464999915, 14.46670156500005],
              [-61.09162350199995, 14.496771552000041],
              [-61.0911352199999, 14.50421784100007],
              [-61.09239661399994, 14.508286851000037],
              [-61.09679114499994, 14.511542059000078],
              [-61.10586503799993, 14.51658763200004],
              [-61.07852128799993, 14.544582424000055],
              [-61.05231686099995, 14.557074286000045],
              [-61.043812628999945, 14.565008856000077],
              [-61.033273891999954, 14.54987213700008],
              [-61.01773027299993, 14.545314846000053],
              [-61.00332597599993, 14.550523179000038],
              [-60.99600175699993, 14.565008856000077],
              [-60.99937903599994, 14.57135651200008],
              [-61.00698808499993, 14.581854559000078],
              [-61.01431230399993, 14.595851955000057],
              [-61.016468878999945, 14.612779039000088],
              [-61.03140214799993, 14.607814846000053],
              [-61.04356848899994, 14.60545482000009],
              [-61.05426998599995, 14.605129299000055],
              [-61.06493079299992, 14.605943101000037],
              [-61.085926886999914, 14.604641018000052],
              [-61.09162350199995, 14.605943101000037],
              [-61.09593665299991, 14.610256252000056],
              [-61.10220292899993, 14.622219143000052],
              [-61.10586503799993, 14.626450914000088],
              [-61.14159094999991, 14.650091864000046],
              [-61.15957597599993, 14.666937567000048],
              [-61.16734778599994, 14.684759833000044],
              [-61.168080206999946, 14.691066799000055],
              [-61.17023678299995, 14.696437893000052],
              [-61.17357337099992, 14.701239325000074],
              [-61.17788652299993, 14.705877997000073],
              [-61.181630011999914, 14.713039455000057],
              [-61.18004309799994, 14.719671942000048],
              [-61.176665818999936, 14.726141669000071],
              [-61.17479407499991, 14.732896226000037],
              [-61.17711341099994, 14.744940497000073],
              [-61.18297278599994, 14.756415106000077],
              [-61.19054114499994, 14.76634349200009],
              [-61.21910559799994, 14.795477606000077],
              [-61.22618567599994, 14.807766018000052],
              [-61.22883053299995, 14.821966864000046],
              [-61.22618567599994, 14.835516669000071],
              [-61.21947180899991, 14.846502997000073],
              [-61.210601365999935, 14.854437567000048],
              [-61.17096920499995, 14.876369533000059],
              [-61.13589433499993, 14.876898505000042],
              [-61.10195878799993, 14.86619700700004],
              [-61.057850714999915, 14.838690497000073],
              [-61.01862545499995, 14.82172272300005],
              [-61.00226803299995, 14.811428127000056],
              [-60.998158331999946, 14.804185289000088],
              [-60.99567623599995, 14.795355536000045],
              [-60.99063066299993, 14.787909247000073],
              [-60.97899329299992, 14.784735419000071],
              [-60.96129309799994, 14.749945380000042],
              [-60.94688880099994, 14.761379299000055],
              [-60.92658443899995, 14.771144924000055],
              [-60.903187628999945, 14.777085679000038],
              [-60.87930253799993, 14.777289130000042],
              [-60.88630123599995, 14.771633205000057],
              [-60.89244544199994, 14.767767645000049],
              [-60.895375128999945, 14.763820705000057],
              [-60.89297441299993, 14.757391669000071],
              [-60.914133266999954, 14.73631419500009],
              [-60.92617753799993, 14.755560614000046],
              [-60.93382727799991, 14.75031159100007],
              [-60.93667558499993, 14.731268622000073],
              [-60.93455969999991, 14.70897044500009],
              [-60.92617753799993, 14.712713934000078],
              [-60.91893469999991, 14.712225653000075],
              [-60.912668423999946, 14.708563544000071],
              [-60.90729732999995, 14.702826239000046],
              [-60.93455969999991, 14.68846263200004],
              [-60.92711341099994, 14.68109772300005],
              [-60.93927975199995, 14.674994208000044],
              [-60.937489386999914, 14.666408596000053],
              [-60.92886308499993, 14.66351959800005],
              [-60.92027747299994, 14.67487213700008],
              [-60.886789516999954, 14.660549221000053],
              [-60.89435787699995, 14.659816799000055],
              [-60.89830481699994, 14.658026434000078],
              [-60.9016820949999, 14.655910549000055],
              [-60.90729732999995, 14.65375397300005],
              [-60.90103105399993, 14.63857656500005],
              [-60.89338131399995, 14.630804755000042],
              [-60.873158331999946, 14.619614976000037],
              [-60.87022864499994, 14.614447333000044],
              [-60.86876380099994, 14.607611395000049],
              [-60.86506100199995, 14.601711330000057],
              [-60.855458136999914, 14.599107164000088],
              [-60.84837805899991, 14.596096096000053],
              [-60.844960089999915, 14.58860911700009],
              [-60.844309048999946, 14.579494533000059],
              [-60.84520423099991, 14.571234442000048],
              [-60.832142706999946, 14.578599351000037],
              [-60.83584550699993, 14.565659898000092],
              [-60.83641516799992, 14.55296458500004],
              [-60.83299719999991, 14.54100169500009],
              [-60.824777798999946, 14.530218817000048],
              [-60.830922003999945, 14.527085679000038],
              [-60.83340410099993, 14.524359442000048],
              [-60.83507239499994, 14.521185614000046],
              [-60.83836829299992, 14.51658763200004],
              [-60.82526607999995, 14.51040273600006],
              [-60.81981360599991, 14.496649481000077],
              [-60.81663977799991, 14.480902411000045],
              [-60.81041419199994, 14.46873607000009],
              [-60.81041419199994, 14.46198151200008],
            ],
          ],
          [
            [
              [-61.19399980399993, 15.932074286000045],
              [-61.19469153599994, 15.919582424000055],
              [-61.19774329299992, 15.910589911000045],
              [-61.20425370999993, 15.902777411000045],
              [-61.215728318999936, 15.893947658000059],
              [-61.24071204299992, 15.88182200700004],
              [-61.27489173099991, 15.87376536700009],
              [-61.30508378799993, 15.878485419000071],
              [-61.31818600199995, 15.904486395000049],
              [-61.319203253999945, 15.911078192000048],
              [-61.32168535099993, 15.919094143000052],
              [-61.325103318999936, 15.925848700000074],
              [-61.32872473899994, 15.928656317000048],
              [-61.332020636999914, 15.93195221600007],
              [-61.327788865999935, 15.939276434000078],
              [-61.31818600199995, 15.952541408000059],
              [-61.315297003999945, 15.966945705000057],
              [-61.308257615999935, 15.977687893000052],
              [-61.29019120999993, 15.99750397300005],
              [-61.26829993399991, 16.00926341400009],
              [-61.24388587099992, 16.003973700000074],
              [-61.22398841099994, 15.987534898000092],
              [-61.21239173099991, 15.958929755000042],
              [-61.20490475199995, 15.95302969000005],
              [-61.197377081999946, 15.945054429000038],
              [-61.19399980399993, 15.932074286000045],
            ],
          ],
          [
            [
              [-60.98924719999991, 16.34638092700004],
              [-61.039906378999945, 16.31391022300005],
              [-61.06859290299991, 16.30223216400009],
              [-61.09162350199995, 16.30540599200009],
              [-61.07852128799993, 16.312201239000046],
              [-61.039133266999954, 16.34446849200009],
              [-61.014881964999915, 16.353989976000037],
              [-60.98924719999991, 16.34638092700004],
            ],
          ],
          [
            [
              [-61.551665818999936, 16.285549221000053],
              [-61.54918372299994, 16.280585028000075],
              [-61.55540930899991, 16.258246161000045],
              [-61.54796301999994, 16.238430080000057],
              [-61.55459550699993, 16.23651764500005],
              [-61.57266191299993, 16.232570705000057],
              [-61.57945716099994, 16.222316799000055],
              [-61.57730058499993, 16.175930080000057],
              [-61.564564581999946, 16.14093659100007],
              [-61.55772864499994, 16.086330471000053],
              [-61.56598873599995, 16.03351471600007],
              [-61.59748287699995, 15.99673086100006],
              [-61.643422003999945, 15.970363674000055],
              [-61.69493567599994, 15.949164130000042],
              [-61.696522589999915, 15.955023505000042],
              [-61.702381964999915, 15.969631252000056],
              [-61.69493567599994, 15.97646719000005],
              [-61.702015753999945, 15.989894924000055],
              [-61.71080481699994, 15.997381903000075],
              [-61.72105872299994, 16.003851630000042],
              [-61.73277747299994, 16.01398346600007],
              [-61.74006100199995, 16.025824286000045],
              [-61.74364173099991, 16.03729889500005],
              [-61.74779212099992, 16.046698309000078],
              [-61.756418423999946, 16.05219147300005],
              [-61.76862545499995, 16.087632554000038],
              [-61.76943925699993, 16.166489976000037],
              [-61.78429114499994, 16.202337958000044],
              [-61.77944902299993, 16.217230536000045],
              [-61.78400631399995, 16.229315497000073],
              [-61.791900193999936, 16.240057684000078],
              [-61.79735266799992, 16.250799872000073],
              [-61.79784094999991, 16.26788971600007],
              [-61.793853318999936, 16.29905833500004],
              [-61.79735266799992, 16.312201239000046],
              [-61.78758704299992, 16.32029857000009],
              [-61.7708227199999, 16.348822333000044],
              [-61.756418423999946, 16.360663153000075],
              [-61.73786373599995, 16.365301825000074],
              [-61.728586391999954, 16.35960521000004],
              [-61.72203528599994, 16.350897528000075],
              [-61.71202551999994, 16.34638092700004],
              [-61.68700110599991, 16.34170156500005],
              [-61.65013587099992, 16.329331773000092],
              [-61.61583411399994, 16.311835028000075],
              [-61.59874426999994, 16.29169342700004],
              [-61.612945115999935, 16.285549221000053],
              [-61.60464433499993, 16.28229401200008],
              [-61.60313880099994, 16.281195380000042],
              [-61.60301673099991, 16.28221263200004],
              [-61.59874426999994, 16.285549221000053],
              [-61.59557044199994, 16.281642971000053],
              [-61.58507239499994, 16.271307684000078],
              [-61.58023027299993, 16.282131252000056],
              [-61.57054602799991, 16.28974030200004],
              [-61.55797278599994, 16.29169342700004],
              [-61.551665818999936, 16.285549221000053],
            ],
          ],
          [
            [
              [-61.544178839999915, 16.28538646000004],
              [-61.54409745999993, 16.28546784100007],
              [-61.54409745999993, 16.285549221000053],
              [-61.52765865799995, 16.337836005000042],
              [-61.518137173999946, 16.348944403000075],
              [-61.499663865999935, 16.353216864000046],
              [-61.49705969999991, 16.356756903000075],
              [-61.49551347599993, 16.36513906500005],
              [-61.49522864499994, 16.37445709800005],
              [-61.49624589799993, 16.38117096600007],
              [-61.50035559799994, 16.385646877000056],
              [-61.50731360599991, 16.389837958000044],
              [-61.515614386999914, 16.393052476000037],
              [-61.52358964799993, 16.39476146000004],
              [-61.52916419199994, 16.430487372000073],
              [-61.53384355399993, 16.43943919500009],
              [-61.53429114499994, 16.449286200000074],
              [-61.52562415299991, 16.46230703300006],
              [-61.50991777299993, 16.480414130000042],
              [-61.505848761999914, 16.48696523600006],
              [-61.49624589799993, 16.49371979400007],
              [-61.46532141799992, 16.509833075000074],
              [-61.46251380099994, 16.51308828300006],
              [-61.45929928299995, 16.511786200000074],
              [-61.42682857999995, 16.489203192000048],
              [-61.409413214999915, 16.472479559000078],
              [-61.39761308499993, 16.45184967700004],
              [-61.39321855399993, 16.425482489000046],
              [-61.39565995999993, 16.399237372000073],
              [-61.39415442599994, 16.38934967700004],
              [-61.38646399599992, 16.37368398600006],
              [-61.376616990999935, 16.35956452000005],
              [-61.36571204299992, 16.348822333000044],
              [-61.35313880099994, 16.340277411000045],
              [-61.33869381399995, 16.33270905200004],
              [-61.33177649599992, 16.34015534100007],
              [-61.321522589999915, 16.334906317000048],
              [-61.3118383449999, 16.33417389500005],
              [-61.301665818999936, 16.334540106000077],
              [-61.29019120999993, 16.33270905200004],
              [-61.2805883449999, 16.327053127000056],
              [-61.25890051999994, 16.30923086100006],
              [-61.25300045499995, 16.30540599200009],
              [-61.24258378799993, 16.30036041900007],
              [-61.188384568999936, 16.263820705000057],
              [-61.169178839999915, 16.258693752000056],
              [-61.16356360599991, 16.25299713700008],
              [-61.17479407499991, 16.243963934000078],
              [-61.18317623599995, 16.24412669500009],
              [-61.21125240799995, 16.25071849200009],
              [-61.218861456999946, 16.25421784100007],
              [-61.234445766999954, 16.258286851000037],
              [-61.410715298999946, 16.21946849200009],
              [-61.44444739499994, 16.20506419500009],
              [-61.462147589999915, 16.202337958000044],
              [-61.4837133449999, 16.205877997000073],
              [-61.50340735599991, 16.213283596000053],
              [-61.520415818999936, 16.22296784100007],
              [-61.53384355399993, 16.23338450700004],
              [-61.54409745999993, 16.24567291900007],
              [-61.54832923099991, 16.25804271000004],
              [-61.54796301999994, 16.27106354400007],
              [-61.544178839999915, 16.28538646000004],
            ],
          ],
          [
            [
              [55.787852410000085, -21.103448174999926],
              [55.801768425000034, -21.111993096999925],
              [55.83757571700005, -21.126153252999927],
              [55.84986412900008, -21.13762786299992],
              [55.854502800000034, -21.156996351999908],
              [55.84913170700008, -21.173760674999926],
              [55.840586785000085, -21.190524997999944],
              [55.824229363000086, -21.264336846999925],
              [55.82195071700005, -21.285088799999926],
              [55.82252037900008, -21.30364348799992],
              [55.82081139400003, -21.324965101999908],
              [55.81202233200008, -21.342543226999908],
              [55.79127037900008, -21.349867445999905],
              [55.75570722700007, -21.34889088299991],
              [55.73796634200005, -21.35165780999995],
              [55.70655358200008, -21.367445570999905],
              [55.68311608200008, -21.37078215899993],
              [55.65992272200003, -21.36956145599993],
              [55.64380944100009, -21.363539320999905],
              [55.62680097700007, -21.369398695999905],
              [55.601573113000086, -21.37037525799991],
              [55.57504316500007, -21.367933851999908],
              [55.55445397200003, -21.363539320999905],
              [55.537119988000086, -21.355075778999947],
              [55.50562584700003, -21.33367278399993],
              [55.47543379000007, -21.326918226999908],
              [55.434336785000085, -21.311618747999944],
              [55.41781660200007, -21.30201588299991],
              [55.40984134200005, -21.29338958099993],
              [55.40414472700007, -21.28443775799991],
              [55.39779707100007, -21.277601820999905],
              [55.387054884000065, -21.274834893999923],
              [55.354502800000034, -21.274590752999927],
              [55.349619988000086, -21.271416924999926],
              [55.34229576900003, -21.25750090899993],
              [55.307627800000034, -21.219414971999925],
              [55.295583530000044, -21.19963958099993],
              [55.291026238000086, -21.176446221999925],
              [55.29078209700003, -21.158868096999925],
              [55.28842207100007, -21.143649997999944],
              [55.24634850400008, -21.090915622999944],
              [55.23324629000007, -21.06926848799992],
              [55.22543379000007, -21.048272393999923],
              [55.22543379000007, -21.02971770599993],
              [55.231211785000085, -21.009698174999926],
              [55.24187259200005, -20.99342213299991],
              [55.275401238000086, -20.98023853999996],
              [55.287852410000085, -20.964776299999926],
              [55.29232832100007, -20.946709893999923],
              [55.287445509000065, -20.93222421699994],
              [55.29346764400003, -20.92636484199994],
              [55.29542076900003, -20.921807549999926],
              [55.29346764400003, -20.91725025799991],
              [55.287445509000065, -20.911716403999947],
              [55.30298912900008, -20.90520598799992],
              [55.335948113000086, -20.905043226999908],
              [55.364024285000085, -20.886163018999923],
              [55.40796959700003, -20.863213799999926],
              [55.455821160000085, -20.86142343499995],
              [55.47250410200007, -20.863213799999926],
              [55.50131269600007, -20.873223565999922],
              [55.514008009000065, -20.875176690999922],
              [55.52711022200003, -20.87004973799992],
              [55.54249108200008, -20.87509530999995],
              [55.57837975400008, -20.87476978999996],
              [55.59229576900003, -20.880303643999923],
              [55.605804884000065, -20.888278903999947],
              [55.65064537900008, -20.898044528999947],
              [55.66382897200003, -20.90520598799992],
              [55.673838738000086, -20.913181247999944],
              [55.695323113000086, -20.93523528399993],
              [55.70281009200005, -20.949395440999922],
              [55.70655358200008, -20.98211028399993],
              [55.71208743600005, -20.993584893999923],
              [55.73658287900008, -21.017836195999905],
              [55.74000084700003, -21.02467213299991],
              [55.74146569100009, -21.044528903999947],
              [55.74366295700008, -21.054620049999926],
              [55.746836785000085, -21.06259530999995],
              [55.75310306100005, -21.06698984199994],
              [55.770518425000034, -21.073825778999947],
              [55.774180535000085, -21.079278252999927],
              [55.77588951900003, -21.083916924999926],
              [55.787852410000085, -21.103448174999926],
            ],
          ],
          [
            [
              [45.26221764400009, -12.76336028399993],
              [45.27711022200003, -12.747491143999923],
              [45.28256269600007, -12.74342213299991],
              [45.28931725400008, -12.75986093499995],
              [45.29086347700007, -12.774021091999941],
              [45.28842207100007, -12.78834400799991],
              [45.28256269600007, -12.804864190999922],
              [45.275726759000065, -12.804864190999922],
              [45.26221764400009, -12.76336028399993],
            ],
          ],
          [
            [
              [45.20069420700008, -12.722914320999905],
              [45.21762129000007, -12.73406340899993],
              [45.22478274800005, -12.745700778999947],
              [45.224945509000065, -12.75953541499996],
              [45.22055097700007, -12.777520440999922],
              [45.19695071700005, -12.811700127999927],
              [45.188161655000044, -12.817071221999925],
              [45.18873131600009, -12.828789971999925],
              [45.19516035200007, -12.840508721999925],
              [45.21314537900008, -12.851820570999905],
              [45.210948113000086, -12.86532968499995],
              [45.20435631600009, -12.878513278999947],
              [45.20069420700008, -12.883965752999927],
              [45.19166100400008, -12.904961846999925],
              [45.17530358200008, -12.924004815999922],
              [45.16822350400008, -12.94426848799992],
              [45.18637129000007, -12.96884530999995],
              [45.182302280000044, -12.975762627999927],
              [45.178070509000065, -12.981052341999941],
              [45.17302493600005, -12.985039971999925],
              [45.16586347700007, -12.98919036299992],
              [45.15992272200003, -12.97861093499995],
              [45.153086785000085, -12.979668877999927],
              [45.14429772200003, -12.985772393999923],
              [45.131846550000034, -12.98919036299992],
              [45.12061608200008, -12.986260674999926],
              [45.113291863000086, -12.981052341999941],
              [45.10670006600009, -12.978122653999947],
              [45.09717858200008, -12.982354424999926],
              [45.09848066500007, -12.967868747999944],
              [45.094493035000085, -12.958184502999927],
              [45.084971550000034, -12.953708591999941],
              [45.070323113000086, -12.955010674999926],
              [45.070323113000086, -12.94890715899993],
              [45.08838951900009, -12.94036223799992],
              [45.090179884000065, -12.924004815999922],
              [45.08122806100005, -12.90829843499995],
              [45.062510613000086, -12.89853280999995],
              [45.06527754000007, -12.893161716999941],
              [45.072927280000044, -12.88836028399993],
              [45.083994988000086, -12.887383721999925],
              [45.09009850400008, -12.891045830999929],
              [45.10792076900009, -12.911716403999947],
              [45.12476647200003, -12.921482028999947],
              [45.13412519600007, -12.91692473799992],
              [45.13648522200003, -12.903903903999947],
              [45.131846550000034, -12.887383721999925],
              [45.12387129000007, -12.87509530999995],
              [45.113291863000086, -12.86337655999995],
              [45.083994988000086, -12.839043877999927],
              [45.097992384000065, -12.833428643999923],
              [45.104502800000034, -12.832777601999908],
              [45.104502800000034, -12.82594166499996],
              [45.098643425000034, -12.817478122999944],
              [45.09424889400009, -12.80282968499995],
              [45.090830925000034, -12.773858330999929],
              [45.08716881600009, -12.759698174999926],
              [45.07837975400008, -12.75359465899993],
              [45.067149285000085, -12.75009530999995],
              [45.056651238000086, -12.74342213299991],
              [45.049489780000044, -12.734307549999926],
              [45.04517662900008, -12.725192966999941],
              [45.042979363000086, -12.713962497999944],
              [45.04249108200008, -12.698418877999927],
              [45.090830925000034, -12.647230726999908],
              [45.094737175000034, -12.65357838299991],
              [45.09595787900008, -12.656508070999905],
              [45.09717858200008, -12.660821221999925],
              [45.092784050000034, -12.66187916499996],
              [45.090179884000065, -12.663262627999927],
              [45.083994988000086, -12.66765715899993],
              [45.090505405000044, -12.667087497999944],
              [45.09351647200003, -12.669040622999944],
              [45.09498131600009, -12.672051690999922],
              [45.09717858200008, -12.674493096999925],
              [45.11060631600009, -12.685804945999905],
              [45.128916863000086, -12.707452080999929],
              [45.138682488000086, -12.71493905999995],
              [45.15259850400008, -12.718194268999923],
              [45.18376712300005, -12.717950127999927],
              [45.20069420700008, -12.722914320999905],
            ],
          ],
          [
            [
              [9.456553582000083, 42.64740631700005],
              [9.48210696700005, 42.62010325700004],
              [9.476898634000065, 42.62010325700004],
              [9.476817254000082, 42.61908600500004],
              [9.456553582000083, 42.64740631700005],
            ],
          ],
          [
            [
              [8.56576582100007, 42.20856354400007],
              [8.574066602000073, 42.219916083000044],
              [8.56576582100007, 42.22573476800005],
              [8.55241946700005, 42.22898997600004],
              [8.545258009000065, 42.232855536000045],
              [8.549489780000044, 42.242254950000074],
              [8.55990644600007, 42.24433014500005],
              [8.586273634000065, 42.243353583000044],
              [8.593760613000086, 42.24628327000005],
              [8.60132897200009, 42.25067780200004],
              [8.610850457000083, 42.25462474200003],
              [8.651133660000085, 42.26040273600006],
              [8.664724155000044, 42.264878648000035],
              [8.675059441000087, 42.27065664300005],
              [8.680837436000047, 42.272772528000075],
              [8.68523196700005, 42.271918036000045],
              [8.687754754000082, 42.27293528900009],
              [8.688731316000087, 42.280951239000046],
              [8.674001498000052, 42.289496161000045],
              [8.672048373000052, 42.29116445500006],
              [8.634776238000086, 42.30483633000006],
              [8.632334832000083, 42.308661200000074],
              [8.629649285000085, 42.31525299700007],
              [8.625173373000052, 42.31915924700007],
              [8.61109459700009, 42.31004466400009],
              [8.605316602000073, 42.31045156500005],
              [8.601410352000073, 42.31476471600007],
              [8.599864129000082, 42.321926174000055],
              [8.604746941000087, 42.32558828300006],
              [8.634776238000086, 42.33893463700008],
              [8.612803582000083, 42.352443752000056],
              [8.59156334700009, 42.35114166900007],
              [8.55209394600007, 42.33893463700008],
              [8.559580925000091, 42.34638092700004],
              [8.553477410000085, 42.35488515800006],
              [8.549652540000068, 42.36579010600008],
              [8.549082879000082, 42.37710195500006],
              [8.55209394600007, 42.386704820000034],
              [8.560801629000082, 42.38165924700007],
              [8.570485873000052, 42.38178131700005],
              [8.579600457000083, 42.385931708000044],
              [8.586273634000065, 42.39297109600005],
              [8.598643425000091, 42.387600002000056],
              [8.602386915000068, 42.391913153000075],
              [8.603526238000086, 42.40033600500004],
              [8.607269727000073, 42.40721263200004],
              [8.612071160000085, 42.411810614000046],
              [8.614024285000085, 42.41624583500004],
              [8.618662957000083, 42.419582424000055],
              [8.650889519000089, 42.42328522300005],
              [8.65951582100007, 42.42987702000005],
              [8.661631707000083, 42.43976471600007],
              [8.661387566000087, 42.45189036700003],
              [8.672373894000089, 42.46442291900007],
              [8.676768425000091, 42.47247955900008],
              [8.672048373000052, 42.47614166900007],
              [8.659678582000083, 42.47711823100008],
              [8.657074415000068, 42.48004791900007],
              [8.659353061000047, 42.484361070000034],
              [8.667491082000083, 42.50971100500004],
              [8.680430535000085, 42.52106354400007],
              [8.697601759000065, 42.527004299000055],
              [8.71656334700009, 42.53070709800005],
              [8.710785352000073, 42.54010651200008],
              [8.716319207000083, 42.56199778900009],
              [8.709157748000052, 42.57172272300005],
              [8.709157748000052, 42.57916901200008],
              [8.716970248000052, 42.57611725500004],
              [8.719737175000091, 42.57599518400008],
              [8.720876498000052, 42.57412344000005],
              [8.723480665000068, 42.56549713700008],
              [8.74000084700009, 42.572333075000074],
              [8.750661655000044, 42.568793036000045],
              [8.759613477000073, 42.561753648000035],
              [8.77125084700009, 42.55805084800005],
              [8.786957227000073, 42.56199778900009],
              [8.798838738000086, 42.57176341400009],
              [8.807465040000068, 42.58510976800005],
              [8.812836134000065, 42.599595445000034],
              [8.805430535000085, 42.60643138200004],
              [8.843028191000087, 42.60805898600006],
              [8.906504754000082, 42.632473049000055],
              [9.018321160000085, 42.65013255400004],
              [9.049978061000047, 42.662176825000074],
              [9.052989129000082, 42.68158600500004],
              [9.10710696700005, 42.725897528000075],
              [9.117849155000044, 42.73200104400007],
              [9.141449415000068, 42.73501211100006],
              [9.165212436000047, 42.73517487200007],
              [9.176036004000082, 42.73281484600005],
              [9.185069207000083, 42.73338450700004],
              [9.236827019000089, 42.72256094000005],
              [9.257823113000086, 42.71393463700008],
              [9.264659050000091, 42.70888906500005],
              [9.27084394600007, 42.70221588700008],
              [9.276133660000085, 42.69415924700007],
              [9.285329623000052, 42.67475006700005],
              [9.292165561000047, 42.67475006700005],
              [9.32789147200009, 42.720038153000075],
              [9.342539910000085, 42.74909088700008],
              [9.333018425000091, 42.77094147300005],
              [9.340993686000047, 42.79010651200008],
              [9.335459832000083, 42.80760325700004],
              [9.321787957000083, 42.823919989000046],
              [9.305674675000091, 42.83926015800006],
              [9.333018425000091, 42.86713288000004],
              [9.332855665000068, 42.87579987200007],
              [9.326345248000052, 42.88532135600008],
              [9.326182488000086, 42.893784898000035],
              [9.330251498000052, 42.903550523000035],
              [9.336924675000091, 42.91038646000004],
              [9.360199415000068, 42.928615627000056],
              [9.35678144600007, 42.93353913000004],
              [9.355723504000082, 42.93650950700004],
              [9.356944207000083, 42.940659898000035],
              [9.360199415000068, 42.94912344000005],
              [9.349945509000065, 42.95722077000005],
              [9.34343509200005, 42.973089911000045],
              [9.341807488000086, 42.990668036000045],
              [9.346690300000091, 43.00372955900008],
              [9.36304772200009, 43.01154205900008],
              [9.404307488000086, 43.01166413000004],
              [9.422373894000089, 43.01740143400008],
              [9.435557488000086, 43.00372955900008],
              [9.444509311000047, 42.99799225500004],
              [9.464040561000047, 42.99005768400008],
              [9.464040561000047, 42.98261139500005],
              [9.455577019000089, 42.97455475500004],
              [9.453868035000085, 42.96381256700005],
              [9.45875084700009, 42.952337958000044],
              [9.47006269600007, 42.942287502000056],
              [9.465505405000044, 42.923529364000046],
              [9.484385613000086, 42.83242422100005],
              [9.482758009000065, 42.80231354400007],
              [9.450368686000047, 42.70888906500005],
              [9.451426629000082, 42.69672272300005],
              [9.449392123000052, 42.68260325700004],
              [9.450368686000047, 42.653631903000075],
              [9.449066602000073, 42.65106842700004],
              [9.446055535000085, 42.64858633000006],
              [9.443369988000086, 42.64524974200003],
              [9.442881707000083, 42.64057038000004],
              [9.445323113000086, 42.637884833000044],
              [9.449961785000085, 42.63572825700004],
              [9.454600457000083, 42.63458893400008],
              [9.456553582000083, 42.634426174000055],
              [9.459239129000082, 42.625433661000045],
              [9.461680535000085, 42.61981842700004],
              [9.461436394000089, 42.614569403000075],
              [9.456553582000083, 42.60643138200004],
              [9.46461022200009, 42.601629950000074],
              [9.468028191000087, 42.594956773000035],
              [9.470713738000086, 42.587225653000075],
              [9.476898634000065, 42.57916901200008],
              [9.484873894000089, 42.57444896000004],
              [9.511892123000052, 42.56549713700008],
              [9.50912519600007, 42.57998281500005],
              [9.504730665000068, 42.58661530200004],
              [9.48959394600007, 42.612616278000075],
              [9.518565300000091, 42.580959377000056],
              [9.528086785000085, 42.56354401200008],
              [9.532237175000091, 42.54437897300005],
              [9.530039910000085, 42.486314195000034],
              [9.533376498000052, 42.456244208000044],
              [9.545909050000091, 42.43512604400007],
              [9.539886915000068, 42.42206452000005],
              [9.535411004000082, 42.408189195000034],
              [9.532725457000083, 42.39252350500004],
              [9.532237175000091, 42.37372467700004],
              [9.536957227000073, 42.353176174000055],
              [9.555430535000085, 42.31427643400008],
              [9.559580925000091, 42.294582424000055],
              [9.552256707000083, 42.17015208500004],
              [9.559580925000091, 42.146551825000074],
              [9.556895379000082, 42.13825104400007],
              [9.554942254000082, 42.12083567900004],
              [9.552744988000086, 42.11302317900004],
              [9.545583530000044, 42.10398997600004],
              [9.518565300000091, 42.08510976800005],
              [9.507823113000086, 42.07221100500004],
              [9.492442254000082, 42.047756252000056],
              [9.423838738000086, 41.973537502000056],
              [9.408702019000089, 41.962225653000075],
              [9.403168165000068, 41.95294830900008],
              [9.402842644000089, 41.91742584800005],
              [9.39429772200009, 41.84796784100007],
              [9.403005405000044, 41.779730536000045],
              [9.401621941000087, 41.70644765800006],
              [9.398610873000052, 41.70148346600007],
              [9.391123894000089, 41.69904205900008],
              [9.381195509000065, 41.692694403000075],
              [9.372243686000047, 41.68390534100007],
              [9.367035352000073, 41.67422109600005],
              [9.380707227000073, 41.67422109600005],
              [9.377940300000091, 41.65643952000005],
              [9.373057488000086, 41.64516836100006],
              [9.363617384000065, 41.64004140800006],
              [9.35320071700005, 41.64081452000005],
              [9.345225457000083, 41.640326239000046],
              [9.342133009000065, 41.63467031500005],
              [9.346690300000091, 41.619574286000045],
              [9.333262566000087, 41.62445709800005],
              [9.318207227000073, 41.62714264500005],
              [9.303721550000091, 41.627834377000056],
              [9.292165561000047, 41.62641022300005],
              [9.293955925000091, 41.617621161000045],
              [9.284434441000087, 41.60765208500004],
              [9.278575066000087, 41.59837474200003],
              [9.292165561000047, 41.59162018400008],
              [9.325043165000068, 41.60195547100005],
              [9.34506269600007, 41.60447825700004],
              [9.354177280000044, 41.595404364000046],
              [9.350596550000091, 41.58120351800005],
              [9.341075066000087, 41.56928131700005],
              [9.326670769000089, 41.56110260600008],
              [9.309092644000089, 41.55817291900007],
              [9.299652540000068, 41.55329010600008],
              [9.292165561000047, 41.54291413000004],
              [9.281993035000085, 41.533270575000074],
              [9.264659050000091, 41.53082916900007],
              [9.268728061000047, 41.52374909100007],
              [9.269867384000065, 41.516791083000044],
              [9.268728061000047, 41.50995514500005],
              [9.264659050000091, 41.50287506700005],
              [9.276215040000068, 41.49941640800006],
              [9.279144727000073, 41.49164459800005],
              [9.27475019600007, 41.482855536000045],
              [9.264659050000091, 41.47614166900007],
              [9.27084394600007, 41.468736070000034],
              [9.25521894600007, 41.46360911700003],
              [9.228037957000083, 41.45001862200007],
              [9.21070397200009, 41.44822825700004],
              [9.21070397200009, 41.44086334800005],
              [9.22006269600007, 41.43504466400009],
              [9.223317905000044, 41.42731354400007],
              [9.219981316000087, 41.419623114000046],
              [9.21070397200009, 41.41351959800005],
              [9.21070397200009, 41.40729401200008],
              [9.22201582100007, 41.41095612200007],
              [9.23796634200005, 41.42226797100005],
              [9.250336134000065, 41.427801825000074],
              [9.246592644000089, 41.41290924700007],
              [9.238780144000089, 41.39590078300006],
              [9.23015384200005, 41.380926825000074],
              [9.223155144000089, 41.37250397300005],
              [9.20671634200005, 41.36591217700004],
              [9.193858269000089, 41.369126695000034],
              [9.169118686000047, 41.38617584800005],
              [9.153330925000091, 41.39134349200003],
              [9.122243686000047, 41.394964911000045],
              [9.096446160000085, 41.403509833000044],
              [9.107269727000073, 41.42926666900007],
              [9.112152540000068, 41.43256256700005],
              [9.121348504000082, 41.43463776200008],
              [9.10515384200005, 41.44550202000005],
              [9.080902540000068, 41.453192450000074],
              [9.066579623000052, 41.46190013200004],
              [9.07984459700009, 41.47614166900007],
              [9.07984459700009, 41.48236725500004],
              [9.068207227000073, 41.47947825700004],
              [9.03874759200005, 41.46190013200004],
              [9.031993035000085, 41.468736070000034],
              [9.034190300000091, 41.47089264500005],
              [9.035411004000082, 41.47162506700005],
              [9.036631707000083, 41.47284577000005],
              [9.03874759200005, 41.47614166900007],
              [9.028086785000085, 41.473822333000044],
              [9.024099155000044, 41.47211334800005],
              [9.018321160000085, 41.468736070000034],
              [9.01148522200009, 41.47614166900007],
              [9.000987175000091, 41.48305898600006],
              [8.975596550000091, 41.48908112200007],
              [8.951019727000073, 41.491888739000046],
              [8.935720248000052, 41.48920319200005],
              [8.924815300000091, 41.49494049700007],
              [8.916758660000085, 41.501654364000046],
              [8.906911655000044, 41.50731028900009],
              [8.883636915000068, 41.51117584800005],
              [8.881114129000082, 41.514837958000044],
              [8.879161004000082, 41.51935455900008],
              [8.873708530000044, 41.52338288000004],
              [8.864268425000091, 41.52533600500004],
              [8.856293165000068, 41.52533600500004],
              [8.848399285000085, 41.52610911700003],
              [8.83961022200009, 41.53082916900007],
              [8.85328209700009, 41.53766510600008],
              [8.85328209700009, 41.543850002000056],
              [8.840586785000085, 41.54726797100005],
              [8.83334394600007, 41.55072663000004],
              [8.82390384200005, 41.54995351800005],
              [8.80990644600007, 41.55267975500004],
              [8.797211134000065, 41.557074286000045],
              [8.791758660000085, 41.56122467700004],
              [8.796397332000083, 41.58055247600004],
              [8.793223504000082, 41.58730703300006],
              [8.778086785000085, 41.59162018400008],
              [8.785411004000082, 41.604681708000044],
              [8.792002800000091, 41.62514883000006],
              [8.801768425000091, 41.63906484600005],
              [8.819021030000044, 41.63263580900008],
              [8.872569207000083, 41.65106842700004],
              [8.881114129000082, 41.657131252000056],
              [8.885752800000091, 41.67088450700004],
              [8.896983269000089, 41.67792389500005],
              [8.910655144000089, 41.68382396000004],
              [8.922699415000068, 41.694647528000075],
              [8.899180535000085, 41.69546133000006],
              [8.836436394000089, 41.70892975500004],
              [8.812347852000073, 41.70929596600007],
              [8.78882897200009, 41.712551174000055],
              [8.776133660000085, 41.72239817900004],
              [8.78492272200009, 41.74249909100007],
              [8.760101759000065, 41.74266185100004],
              [8.719086134000065, 41.73069896000004],
              [8.695567254000082, 41.72943756700005],
              [8.698090040000068, 41.73305898600006],
              [8.702972852000073, 41.74249909100007],
              [8.688731316000087, 41.74176666900007],
              [8.677989129000082, 41.74408600500004],
              [8.667979363000086, 41.74750397300005],
              [8.655121290000068, 41.74990469000005],
              [8.668223504000082, 41.75486888200004],
              [8.696299675000091, 41.75820547100005],
              [8.709157748000052, 41.76357656500005],
              [8.717539910000085, 41.77204010600008],
              [8.72201582100007, 41.782416083000044],
              [8.720225457000083, 41.79169342700004],
              [8.709157748000052, 41.79706452000005],
              [8.709157748000052, 41.80451080900008],
              [8.731944207000083, 41.80459219000005],
              [8.752289259000065, 41.809800523000035],
              [8.78492272200009, 41.82440827000005],
              [8.780039910000085, 41.83392975500004],
              [8.772308790000068, 41.84039948100008],
              [8.762380405000044, 41.84414297100005],
              [8.750824415000068, 41.84552643400008],
              [8.783702019000089, 41.853583075000074],
              [8.791758660000085, 41.85911692900004],
              [8.789317254000082, 41.861314195000034],
              [8.785817905000044, 41.86798737200007],
              [8.781748894000089, 41.87368398600006],
              [8.778086785000085, 41.87278880400004],
              [8.790049675000091, 41.88694896000004],
              [8.791758660000085, 41.88711172100005],
              [8.79460696700005, 41.89215729400007],
              [8.803396030000044, 41.90053945500006],
              [8.805430535000085, 41.90692780200004],
              [8.803070509000065, 41.907456773000035],
              [8.791758660000085, 41.913763739000046],
              [8.785980665000068, 41.92283763200004],
              [8.781423373000052, 41.92877838700008],
              [8.77507571700005, 41.93231842700004],
              [8.764414910000085, 41.93427155200004],
              [8.744395379000082, 41.932806708000044],
              [8.71029707100007, 41.91876862200007],
              [8.688731316000087, 41.913763739000046],
              [8.647634311000047, 41.911810614000046],
              [8.629893425000091, 41.908636786000045],
              [8.614268425000091, 41.90078359600005],
              [8.607269727000073, 41.913763739000046],
              [8.618662957000083, 41.93048737200007],
              [8.614431186000047, 41.94407786700003],
              [8.586273634000065, 41.96898021000004],
              [8.635508660000085, 41.972642320000034],
              [8.655039910000085, 41.97870514500005],
              [8.668793165000068, 41.99632396000004],
              [8.656097852000073, 42.00287506700005],
              [8.664561394000089, 42.01447174700007],
              [8.684336785000085, 42.02558014500005],
              [8.706065300000091, 42.030462958000044],
              [8.711273634000065, 42.033270575000074],
              [8.73804772200009, 42.04393138200004],
              [8.743418816000087, 42.044134833000044],
              [8.744965040000068, 42.05658600500004],
              [8.739105665000068, 42.06342194200005],
              [8.723480665000068, 42.07208893400008],
              [8.706228061000047, 42.100490627000056],
              [8.699229363000086, 42.10932038000004],
              [8.68881269600007, 42.11115143400008],
              [8.660899285000085, 42.105454820000034],
              [8.655121290000068, 42.10932038000004],
              [8.647715691000087, 42.12201569200005],
              [8.629567905000044, 42.130072333000044],
              [8.606700066000087, 42.13373444200005],
              [8.586273634000065, 42.13349030200004],
              [8.591075066000087, 42.14288971600007],
              [8.593760613000086, 42.146551825000074],
              [8.586273634000065, 42.15143463700008],
              [8.578135613000086, 42.15420156500005],
              [8.569102410000085, 42.15497467700004],
              [8.559580925000091, 42.153998114000046],
              [8.56967207100007, 42.155585028000075],
              [8.57789147200009, 42.15875885600008],
              [8.593760613000086, 42.16705963700008],
              [8.593760613000086, 42.17450592700004],
              [8.56576582100007, 42.17450592700004],
              [8.56576582100007, 42.181301174000055],
              [8.577647332000083, 42.184881903000075],
              [8.58179772200009, 42.194525458000044],
              [8.57781009200005, 42.204413153000075],
              [8.56576582100007, 42.20856354400007],
            ],
          ],
          [
            [
              [-1.21939042899993, 45.94391510600008],
              [-1.224354620999918, 45.93504466400009],
              [-1.213937954999949, 45.92804596600007],
              [-1.185170050999943, 45.91596100500004],
              [-1.177723761999914, 45.90692780200004],
              [-1.17609615799995, 45.89874909100007],
              [-1.184193488999938, 45.856350002000056],
              [-1.194569464999915, 45.830064195000034],
              [-1.20921790299991, 45.814154364000046],
              [-1.22687740799995, 45.81976959800005],
              [-1.241200324999909, 45.85455963700008],
              [-1.249419725999928, 45.86774323100008],
              [-1.260365363999938, 45.88182200700004],
              [-1.31899980399993, 45.92812734600005],
              [-1.34015865799995, 45.938666083000044],
              [-1.361724412999934, 45.956732489000046],
              [-1.378325975999928, 45.97597890800006],
              [-1.373890753999945, 45.98493073100008],
              [-1.371652798999946, 45.995306708000044],
              [-1.382923956999946, 46.01850006700005],
              [-1.40493730399993, 46.053168036000045],
              [-1.373890753999945, 46.05023834800005],
              [-1.339914516999954, 46.03782786700003],
              [-1.308705206999946, 46.02024974200003],
              [-1.285145636999914, 46.001654364000046],
              [-1.273833787999934, 45.99762604400007],
              [-1.261219855999911, 46.00067780200004],
              [-1.247629360999952, 46.00177643400008],
              [-1.233631964999915, 45.99168528900009],
              [-1.229562954999949, 45.97923411700003],
              [-1.231190558999913, 45.96792226800005],
              [-1.230458136999914, 45.958197333000044],
              [-1.21939042899993, 45.95075104400007],
              [-1.21939042899993, 45.94391510600008],
            ],
          ],
          [
            [
              [-1.281402147999927, 46.15619538000004],
              [-1.286284959999932, 46.16010163000004],
              [-1.290679490999935, 46.161322333000044],
              [-1.336089647999927, 46.167222398000035],
              [-1.432850714999915, 46.21084219000005],
              [-1.48892167899993, 46.20335521000004],
              [-1.504261847999942, 46.20766836100006],
              [-1.544829881999931, 46.239894924000055],
              [-1.555816209999932, 46.24555084800005],
              [-1.555816209999932, 46.25177643400008],
              [-1.498117641999954, 46.26190827000005],
              [-1.480091925999943, 46.25922272300005],
              [-1.472727016999954, 46.25527578300006],
              [-1.467884894999941, 46.24990469000005],
              [-1.46743730399993, 46.24396393400008],
              [-1.473866339999915, 46.23810455900008],
              [-1.497710740999935, 46.24518463700008],
              [-1.507964647999927, 46.24555084800005],
              [-1.49054928299995, 46.22443268400008],
              [-1.464182094999956, 46.22492096600007],
              [-1.435454881999931, 46.23383209800005],
              [-1.411122199999909, 46.23810455900008],
              [-1.411122199999909, 46.23126862200007],
              [-1.425363735999952, 46.23126862200007],
              [-1.425363735999952, 46.223822333000044],
              [-1.408762173999946, 46.21824778900009],
              [-1.308094855999911, 46.20693594000005],
              [-1.284738735999952, 46.19643789300005],
              [-1.265736456999946, 46.180975653000075],
              [-1.25413977799991, 46.16242096600007],
              [-1.263417120999918, 46.16185130400004],
              [-1.270863410999937, 46.160223700000074],
              [-1.281402147999927, 46.15619538000004],
            ],
          ],
          [
            [
              [-2.337228969999956, 46.73159414300005],
              [-2.298207160999937, 46.72016022300005],
              [-2.279693162999934, 46.710272528000075],
              [-2.268950975999928, 46.69741445500006],
              [-2.291371222999942, 46.70359935100004],
              [-2.37140865799995, 46.704291083000044],
              [-2.382923956999946, 46.722642320000034],
              [-2.375152147999927, 46.731634833000044],
              [-2.356800910999937, 46.73379140800006],
              [-2.337228969999956, 46.73159414300005],
            ],
          ],
          [
            [
              [-2.200103318999936, 46.98541901200008],
              [-2.189808722999942, 46.97724030200004],
              [-2.155751105999911, 46.964911200000074],
              [-2.14484615799995, 46.957464911000045],
              [-2.140044725999928, 46.943426825000074],
              [-2.137684699999909, 46.923163153000075],
              [-2.142567511999914, 46.909857489000046],
              [-2.159087693999936, 46.91648997600004],
              [-2.173695441999939, 46.939154364000046],
              [-2.194813605999911, 46.96185944200005],
              [-2.220204230999911, 46.973863023000035],
              [-2.247303839999915, 46.96430084800005],
              [-2.263172980999911, 46.979803778000075],
              [-2.278675910999937, 47.01813385600008],
              [-2.295643683999913, 47.033189195000034],
              [-2.23859615799995, 47.03534577000005],
              [-2.220448370999918, 47.033189195000034],
              [-2.200021938999953, 47.02435944200005],
              [-2.197417772999927, 47.013006903000075],
              [-2.201324022999927, 46.99974192900004],
              [-2.200103318999936, 46.98541901200008],
            ],
          ],
          [
            [
              [-3.114654100999928, 47.33148834800005],
              [-3.102691209999932, 47.327337958000044],
              [-3.072743292999917, 47.32831452000005],
              [-3.06281490799995, 47.32062409100007],
              [-3.067005988999938, 47.301947333000044],
              [-3.093617316999939, 47.29661692900004],
              [-3.171701626999948, 47.30158112200007],
              [-3.223459438999953, 47.312160549000055],
              [-3.240956183999913, 47.32062409100007],
              [-3.237619594999956, 47.336371161000045],
              [-3.245350714999915, 47.352850653000075],
              [-3.25617428299995, 47.368801174000055],
              [-3.262074347999942, 47.383246161000045],
              [-3.253651495999918, 47.38886139500005],
              [-3.249623175999943, 47.39520905200004],
              [-3.242990688999953, 47.39533112200007],
              [-3.234120245999918, 47.389553127000056],
              [-3.221506313999953, 47.38751862200007],
              [-3.176503058999913, 47.37148672100005],
              [-3.151600714999915, 47.35814036700003],
              [-3.148793097999942, 47.35537344000005],
              [-3.114654100999928, 47.33148834800005],
            ],
          ],
          [
            [
              [-5.050282355999911, 48.47882721600007],
              [-5.048166469999956, 48.47650788000004],
              [-5.046254035999937, 48.473822333000044],
              [-5.042958136999914, 48.471991278000075],
              [-5.036610480999911, 48.47260163000004],
              [-5.036610480999911, 48.46515534100007],
              [-5.087961391999954, 48.44721100500004],
              [-5.105539516999954, 48.444647528000075],
              [-5.105539516999954, 48.45148346600007],
              [-5.102162238999938, 48.45184967700004],
              [-5.095122850999928, 48.45111725500004],
              [-5.091867641999954, 48.45148346600007],
              [-5.097767706999946, 48.46133047100005],
              [-5.107411261999914, 48.46336497600004],
              [-5.132801886999914, 48.458319403000075],
              [-5.132801886999914, 48.46515534100007],
              [-5.091786261999914, 48.48078034100007],
              [-5.06899980399993, 48.48505280200004],
              [-5.050282355999911, 48.47882721600007],
            ],
          ],
          [
            [
              [-61.624663865999935, 15.871242580000057],
              [-61.621083136999914, 15.867743231000077],
              [-61.616078253999945, 15.860052802000041],
              [-61.618804490999935, 15.85228099200009],
              [-61.62755286399994, 15.846991278000075],
              [-61.638335740999935, 15.853216864000046],
              [-61.63459225199995, 15.866156317000048],
              [-61.624663865999935, 15.871242580000057],
            ],
          ],
          [
            [
              [-61.566477016999954, 15.87836334800005],
              [-61.56602942599994, 15.876776434000078],
              [-61.565012173999946, 15.874416408000059],
              [-61.57054602799991, 15.869614976000037],
              [-61.58218339799993, 15.861802476000037],
              [-61.592640753999945, 15.85838450700004],
              [-61.595692511999914, 15.862860419000071],
              [-61.59048417899993, 15.867580471000053],
              [-61.58511308499993, 15.870672919000071],
              [-61.57994544199994, 15.880804755000042],
              [-61.573882615999935, 15.883368231000077],
              [-61.56798255099994, 15.881048895000049],
              [-61.566477016999954, 15.87836334800005],
            ],
          ],
          [
            [
              [6.235036655000044, 43.02240631700005],
              [6.241884786000071, 43.02564971800007],
              [6.251004127000044, 43.017296825000074],
              [6.252208826000071, 43.00263219800007],
              [6.23023522200009, 42.995347398000035],
              [6.21648196700005, 42.99038320500006],
              [6.20248457100007, 42.98712799700007],
              [6.190114780000044, 42.99017975500004],
              [6.166188998000052, 42.999660549000055],
              [6.164724155000044, 43.005072333000044],
              [6.17514082100007, 43.008978583000044],
              [6.202972852000073, 43.00800202000005],
              [6.211599155000044, 43.01162344000005],
              [6.215017123000052, 43.01471588700008],
              [6.218272332000083, 43.01544830900008],
              [6.221039259000065, 43.014960028000075],
              [6.233393453000076, 43.01558154300005],
              [6.235036655000044, 43.02240631700005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Ukraine',
        iso3: 'UKR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [31.76434493000005, 52.10056772900005],
              [31.82583988400006, 52.104055888000104],
              [31.85870609500006, 52.09987009700008],
              [31.88206384300014, 52.086408386000116],
              [31.887489868000102, 52.07002695700005],
              [31.887748250000072, 52.05155263300004],
              [31.892037394000056, 52.03617889500005],
              [31.910382528000127, 52.029073385000046],
              [31.927229044000114, 52.03108876600008],
              [31.980559122000102, 52.04762522500006],
              [32.01693933100006, 52.04979563400006],
              [32.07714237500005, 52.03995127399999],
              [32.09559086100006, 52.040726421],
              [32.233308553000086, 52.08085317000008],
              [32.27769860900014, 52.10266062500004],
              [32.30674076300011, 52.141185405],
              [32.318833049000034, 52.20141428700005],
              [32.32823815900008, 52.21916514100009],
              [32.337849976000086, 52.225469666],
              [32.35014896700011, 52.22988800100008],
              [32.36131107600005, 52.235908305000024],
              [32.366995484000086, 52.247199606],
              [32.36327478100009, 52.25572621700012],
              [32.34446455900007, 52.27652598100006],
              [32.33950362100012, 52.28724884100008],
              [32.35355961100004, 52.32158783000001],
              [32.3942806390001, 52.32680715000002],
              [32.48058028200006, 52.30714426700008],
              [32.52843265800004, 52.31621348100005],
              [32.72542321800006, 52.25208302900002],
              [32.75560225400005, 52.2523930870001],
              [32.81482344500006, 52.26200490300003],
              [32.84417566000013, 52.26234080000002],
              [32.86102217700011, 52.257198996000014],
              [32.8907878010001, 52.24231618300006],
              [32.90897790500014, 52.241101787000034],
              [32.9268579510001, 52.246915386000026],
              [33.03010746300009, 52.30360443100004],
              [33.04824589000009, 52.309082134],
              [33.057289266000055, 52.30864288400009],
              [33.07041508000009, 52.30417287200008],
              [33.07961348500004, 52.305593975000065],
              [33.08736494900012, 52.31076161800006],
              [33.0990438230001, 52.32476593100007],
              [33.10886234500009, 52.32833160400004],
              [33.12798262500007, 52.33272410200003],
              [33.14085005700014, 52.340372213000094],
              [33.166636597000036, 52.36006093400006],
              [33.1828629960001, 52.36729563500002],
              [33.19650557500006, 52.36894928000008],
              [33.29432906100004, 52.35729624500003],
              [33.358976277000124, 52.357554627000084],
              [33.37618452900011, 52.35525502500006],
              [33.400576080000064, 52.34434301700013],
              [33.40367639200008, 52.34295603500003],
              [33.41933435100009, 52.33833099400006],
              [33.4373177490001, 52.33915781700007],
              [33.45178715000014, 52.34525563600003],
              [33.46532637600012, 52.352748718000086],
              [33.48051924600014, 52.35776133300003],
              [33.499432821000084, 52.34099233000008],
              [33.49302494300014, 52.3031393430001],
              [33.510078166000085, 52.28753306100005],
              [33.53167891500004, 52.288824972],
              [33.60020186400004, 52.330786235000105],
              [33.687948445000075, 52.35582346600002],
              [33.733578736000084, 52.36099110900001],
              [33.778950643000144, 52.36006093400006],
              [33.80406538900007, 52.35460907000008],
              [33.81522749800007, 52.34507476800009],
              [33.82339237500008, 52.331458029],
              [33.83910201000009, 52.31391388000013],
              [33.858739054000125, 52.302157491000045],
              [33.90070031700009, 52.28585357700008],
              [33.91951053900004, 52.269756369000035],
              [33.944418579000114, 52.235779114000096],
              [33.95775109900012, 52.22469451900007],
              [34.02193322800014, 52.19790028900009],
              [34.03888309700005, 52.186479798],
              [34.05572961400014, 52.17033091300003],
              [34.065341431000036, 52.15862620100005],
              [34.07102583800008, 52.14896270800001],
              [34.0736096600001, 52.13955759700006],
              [34.07391971900006, 52.128317973],
              [34.05665979000008, 52.105812887000084],
              [34.05665979000008, 52.100386862],
              [34.060070434000124, 52.08317861000005],
              [34.0625509030001, 52.05020904600006],
              [34.06823531100014, 52.031011252000056],
              [34.08032759600013, 52.01362213100005],
              [34.101101521000146, 51.992512309000105],
              [34.10440881300008, 51.975304057000116],
              [34.096657349000054, 51.96057627400002],
              [34.096243937000054, 51.95181711900004],
              [34.146163371000114, 51.95161041300007],
              [34.16642053300012, 51.94225697900005],
              [34.20342085700008, 51.91231048700011],
              [34.20941532400008, 51.90879648900004],
              [34.22264449000011, 51.90316375800002],
              [34.22843225100007, 51.89926218700005],
              [34.231016072000045, 51.89453379400008],
              [34.23463342300005, 51.88073618600002],
              [34.23422001200004, 51.87828155600006],
              [34.24600223800013, 51.8754651900001],
              [34.26491581200008, 51.88120127400005],
              [34.27669803900005, 51.881227113000065],
              [34.294578084000136, 51.873889059000064],
              [34.327754353000046, 51.85050547300001],
              [34.347288046000074, 51.84169464100002],
              [34.37110138200006, 51.826811306000124],
              [34.385735310000086, 51.81766510100009],
              [34.41271040900011, 51.77769338000003],
              [34.41415734900011, 51.73645558700012],
              [34.37633020000004, 51.70860199000005],
              [34.35689986200009, 51.70555308100002],
              [34.29819543500008, 51.7061473590001],
              [34.12797326700007, 51.68074839300009],
              [34.08911258900008, 51.66661488900006],
              [34.07950077400011, 51.64310211200005],
              [34.09066288300005, 51.633206076000064],
              [34.126009562000036, 51.62700490400009],
              [34.14006555200007, 51.621191305000096],
              [34.144509725000034, 51.6137757370001],
              [34.14885054500013, 51.593208516000104],
              [34.15298465900014, 51.583984274],
              [34.160322714000074, 51.57612945600006],
              [34.20238732900009, 51.54615712500002],
              [34.21540979000014, 51.53199778300008],
              [34.22367801900015, 51.51476369200007],
              [34.225951782000095, 51.49287872300003],
              [34.223781372000076, 51.482362569000074],
              [34.21499637900013, 51.46466339200008],
              [34.212102498000036, 51.45502573700007],
              [34.21323937900013, 51.444819641],
              [34.217063436000046, 51.43606048700009],
              [34.219647258000066, 51.42727549200002],
              [34.217063436000046, 51.41706939800004],
              [34.20879520700004, 51.41146250400003],
              [34.186987753000096, 51.40831024200007],
              [34.18192346100011, 51.402341614000036],
              [34.18585087100007, 51.394150899000024],
              [34.19597945100014, 51.3856242880001],
              [34.215719848000106, 51.37376454700008],
              [34.230499308000105, 51.36766672800012],
              [34.24734582500008, 51.363429260000075],
              [34.26439904800014, 51.36120717400006],
              [34.280315389000066, 51.361258850000084],
              [34.30015913900013, 51.36839019800003],
              [34.308737427000096, 51.33461965000005],
              [34.283622681000054, 51.301236674000066],
              [34.2439351810001, 51.27408071000009],
              [34.18595422400011, 51.248914286000044],
              [34.25788781700004, 51.229561462],
              [34.28176232900006, 51.22643503900004],
              [34.29953902200009, 51.23162852000006],
              [34.33695275900004, 51.25113637400007],
              [34.37178267400009, 51.25684661900003],
              [34.40898970600011, 51.253125916],
              [34.48040653500004, 51.23697703100002],
              [34.51347945100008, 51.229561462],
              [34.57817834500008, 51.23669281000004],
              [34.608357381000076, 51.234005636000106],
              [34.62241337100011, 51.2247555550001],
              [34.62851119000004, 51.21106130000008],
              [34.633162069000036, 51.19561004700007],
              [34.642773885000054, 51.1806238810001],
              [34.657449992000124, 51.171658021000056],
              [34.67491662600008, 51.16767893500007],
              [34.748090454000135, 51.16473337900008],
              [34.81754357900013, 51.174732768000084],
              [34.899605754000106, 51.19646270800011],
              [34.946114542000146, 51.214291077000055],
              [34.96182417800014, 51.21532460500002],
              [34.98032434100014, 51.20953684600006],
              [34.99944462000013, 51.20209543900005],
              [35.01877160600009, 51.20455007],
              [35.038718709000136, 51.21015696200003],
              [35.05938928200004, 51.212327373],
              [35.07871626800011, 51.20762481700005],
              [35.09132531800009, 51.19767710400005],
              [35.09918013500004, 51.183181865000094],
              [35.12377811700014, 51.09132700600004],
              [35.143621867000036, 51.05848663400012],
              [35.17256066900006, 51.04063242700006],
              [35.20646040800011, 51.038927104],
              [35.274259887000085, 51.04879730200007],
              [35.30867639200005, 51.04732452500009],
              [35.32841678900013, 51.04316457100005],
              [35.346400187000086, 51.03660166400006],
              [35.35508182700005, 51.025594585000064],
              [35.34671024500011, 51.00825714100007],
              [35.33255090400007, 50.999937236],
              [35.27808394400006, 50.99265085900002],
              [35.28221805800007, 50.981540426000024],
              [35.28221805800007, 50.96110741200003],
              [35.28221805800007, 50.95425527],
              [35.28480188000009, 50.9443333950001],
              [35.293586873000095, 50.93761545800008],
              [35.31715132700009, 50.93420481400004],
              [35.32914025900004, 50.929088847000045],
              [35.341749308000146, 50.915859680000054],
              [35.34298954200011, 50.90412913000007],
              [35.34040572100008, 50.89183013900005],
              [35.341439250000064, 50.876482239000055],
              [35.348570597000105, 50.863769837000106],
              [35.369034465000084, 50.8460448200001],
              [35.37771610500005, 50.83374583000004],
              [35.37967981000014, 50.819586487000024],
              [35.377406047000136, 50.80754587900013],
              [35.37905969200011, 50.79721059200004],
              [35.39311568200009, 50.78837392200002],
              [35.41823042800013, 50.77891713500004],
              [35.42939253700007, 50.77214752200011],
              [35.438487590000136, 50.76238067600006],
              [35.447065878000046, 50.734320373000045],
              [35.44375858600006, 50.70946401],
              [35.445412231000034, 50.687501527],
              [35.4688733320001, 50.66853627500005],
              [35.39156538900011, 50.64636708700003],
              [35.376165812000124, 50.63458486000003],
              [35.37771610500005, 50.62182078100007],
              [35.42525842300006, 50.50048451800011],
              [35.446445760000074, 50.476041565000074],
              [35.48013879400014, 50.46689483700008],
              [35.50194624800008, 50.464311015000064],
              [35.52272017400014, 50.459505107000055],
              [35.54080692500014, 50.45004832000011],
              [35.554656209000086, 50.43325348000003],
              [35.562304321000056, 50.409637350000125],
              [35.56385461500008, 50.39180898000008],
              [35.57015913900011, 50.37646108000011],
              [35.59217329900008, 50.36049306200006],
              [35.611396932000105, 50.35170806900008],
              [35.63155074100007, 50.34499013300005],
              [35.6521179610001, 50.3411144010001],
              [35.67320194500013, 50.340184225000044],
              [35.69221013400005, 50.344168474000114],
              [35.696869751000065, 50.345145162000094],
              [35.71030562300007, 50.35563547800005],
              [35.72126102700008, 50.368709616],
              [35.73769413300005, 50.38157704700008],
              [35.74616906800014, 50.38395416300004],
              [35.76539270100005, 50.384522604],
              [35.7743843990001, 50.386899720000045],
              [35.78554650800004, 50.39449615500011],
              [35.805390259000035, 50.412169495000015],
              [35.819342895000034, 50.419042460000085],
              [35.837429646000146, 50.42322825100011],
              [35.931894165000074, 50.430152893000084],
              [36.10583703600008, 50.42110951800005],
              [36.13322554600012, 50.41160105400006],
              [36.14077030400006, 50.392945862],
              [36.16929569500007, 50.38369578100007],
              [36.269031209000104, 50.28137644500008],
              [36.29197554500013, 50.274038391000076],
              [36.315850057000034, 50.274865214],
              [36.33951786300014, 50.2814797970001],
              [36.36142867000012, 50.291660055000065],
              [36.380962362000105, 50.30406239900013],
              [36.387990356000046, 50.306439515000065],
              [36.40018599400014, 50.30664622000005],
              [36.41000451600013, 50.30457916300007],
              [36.430571736000104, 50.296879374000085],
              [36.452689250000105, 50.29357208200007],
              [36.48018111100009, 50.280859681000024],
              [36.51211714700014, 50.276415507000124],
              [36.52110884600012, 50.27409006800009],
              [36.53640507000006, 50.26752716100002],
              [36.538885539000034, 50.26504669200004],
              [36.536095012000146, 50.26091257700001],
              [36.53392460100008, 50.23869171200006],
              [36.531650838000076, 50.228821513000085],
              [36.534648072000095, 50.219933167000065],
              [36.549530884000035, 50.21218170200008],
              [36.571028280000064, 50.20691070600013],
              [36.5943860270001, 50.20443023700007],
              [36.61691695200011, 50.206393942],
              [36.63583052600006, 50.214042054000075],
              [36.64440881400009, 50.222258606000096],
              [36.66042850800005, 50.24385935500008],
              [36.6698336180001, 50.25300608300007],
              [36.68264937300006, 50.26065419600003],
              [36.848634074000074, 50.32369944300008],
              [36.914056437000056, 50.33909902000006],
              [36.980098918000124, 50.34214792900009],
              [37.05172245200009, 50.33532664000002],
              [37.197036580000145, 50.36240509100007],
              [37.22669885300013, 50.377081198000084],
              [37.28519657400011, 50.41527008100006],
              [37.31475549400005, 50.422969870000045],
              [37.41521447800005, 50.431858216000066],
              [37.4352649330001, 50.424933573000075],
              [37.45025109900007, 50.398992005000125],
              [37.463790324000115, 50.366539205000024],
              [37.48001672400005, 50.340029195000014],
              [37.568176717000085, 50.31253733400003],
              [37.59918257600009, 50.29088490800005],
              [37.60155969200008, 50.249026998],
              [37.59153446400012, 50.22530751600003],
              [37.588640585000064, 50.21461049400004],
              [37.5902942300001, 50.203810120000085],
              [37.597115519000056, 50.196937154000025],
              [37.631842082000105, 50.1740961710001],
              [37.72765018700011, 50.078701477],
              [37.76341027900014, 50.06257843100012],
              [37.84278527800012, 50.03911733000005],
              [37.88174930800011, 50.02304596000009],
              [37.91585575400006, 50.0033055630001],
              [37.9465515550001, 49.978190816000094],
              [37.97900435300011, 49.94144887300011],
              [37.98003788200009, 49.93958852200011],
              [37.99533410600014, 49.92134674100005],
              [37.99585087000008, 49.90589548800004],
              [38.00039839700014, 49.89979766900008],
              [38.02292379300013, 49.90914218900009],
              [38.06654423000009, 49.92723785400004],
              [38.07915327900014, 49.929925029000074],
              [38.09031538900007, 49.92842641300008],
              [38.108402141000056, 49.92067494700005],
              [38.119047486000056, 49.91917633100006],
              [38.16617639200007, 49.940570374000075],
              [38.17134403500006, 49.9840819300001],
              [38.1641093340001, 50.03038401400006],
              [38.17392785600009, 50.060149638000055],
              [38.18984419700007, 50.06278513600007],
              [38.25381962000006, 50.059064433000074],
              [38.28120813000004, 50.06242340100009],
              [38.29991499900012, 50.06051137300007],
              [38.31407434100004, 50.04950429400007],
              [38.344150024000044, 49.992091777000056],
              [38.356035604000056, 49.98056793200003],
              [38.37629276500007, 49.974935201],
              [38.420114380000086, 49.97178293900005],
              [38.437787720000074, 49.96728709000003],
              [38.46114546700011, 49.956900127000026],
              [38.49752567500008, 49.94816680900003],
              [38.570182740000064, 49.95664174400004],
              [38.61948205600004, 49.95075063100005],
              [38.628887166000084, 49.95333445200005],
              [38.63777551300012, 49.95721018500008],
              [38.66216678900014, 49.962584534000044],
              [38.66464725700013, 49.96516835600006],
              [38.664337199000045, 49.96268788700009],
              [38.67281213400014, 49.942999166000035],
              [38.675602661000084, 49.927031149000086],
              [38.68097701000005, 49.91829783100012],
              [38.68728153500007, 49.913801982000095],
              [38.74784631300008, 49.88543162100008],
              [38.8522327070001, 49.865794577000045],
              [38.88633915200006, 49.845175680000054],
              [38.91052372200011, 49.820577698000065],
              [38.9373954670001, 49.80347279900012],
              [39.0322733970001, 49.80734853200006],
              [39.04911991400007, 49.81055247000005],
              [39.0683435470001, 49.82109446200009],
              [39.09986617000004, 49.85163523400011],
              [39.11712609800014, 49.86439931300008],
              [39.15578007000005, 49.873597718000084],
              [39.181005517000074, 49.85948693100006],
              [39.182755168000085, 49.85850819900007],
              [39.23804895100011, 49.765128886000085],
              [39.26088993400003, 49.74450999],
              [39.289932089000104, 49.73205597000002],
              [39.32765588400014, 49.72631988500005],
              [39.36724003100011, 49.73184926400005],
              [39.405997355000125, 49.74425160800003],
              [39.44361779800005, 49.749522603000074],
              [39.47989465300009, 49.73360626300003],
              [39.499118286000055, 49.72812856000006],
              [39.557512655000096, 49.72399444600002],
              [39.5704317630001, 49.71329742500002],
              [39.58159387200004, 49.69071482300008],
              [39.59740686100014, 49.64797841500008],
              [39.62293501800008, 49.61345855800009],
              [39.65332076000004, 49.59981598000009],
              [39.68866744000013, 49.59345977800005],
              [39.72918176300004, 49.58079905200002],
              [39.781064901000036, 49.54839792900002],
              [39.80152876800008, 49.54219675700004],
              [39.8287105710001, 49.541473288000034],
              [39.85940637200014, 49.545555726000046],
              [39.88937870300009, 49.553255513000025],
              [39.91470015500005, 49.562970684000064],
              [39.9740246990001, 49.60255483000013],
              [39.99810591600004, 49.60823923800008],
              [40.017742960000135, 49.60787750300007],
              [40.11551477000012, 49.590565898000065],
              [40.118504096000095, 49.58845100100005],
              [40.13070764200006, 49.57981720100004],
              [40.126056763000065, 49.55909495100012],
              [40.11065718600008, 49.545349019000085],
              [40.07200321400012, 49.530672913],
              [40.054329875000064, 49.51976918600003],
              [40.034899536000125, 49.48705800400005],
              [40.04089400200013, 49.45548370400006],
              [40.06197798700009, 49.42582143200009],
              [40.10135542900008, 49.38546213800005],
              [40.14807092300009, 49.34959869400011],
              [40.1595430910001, 49.333579],
              [40.157165975000055, 49.31585398400004],
              [40.14269657400013, 49.28190256800009],
              [40.14166304500014, 49.245780741],
              [40.13401493400005, 49.236272279],
              [40.11024377500007, 49.22764231400005],
              [40.09091678900012, 49.21725535100005],
              [40.057740519000106, 49.18278717100007],
              [40.038413533000096, 49.16852447600009],
              [39.97960575400009, 49.141859437000065],
              [39.95211389200011, 49.12454783200006],
              [39.93092655400005, 49.10056996700003],
              [39.92606897000013, 49.086513977000024],
              [39.923381795000125, 49.057988587000054],
              [39.91873091600007, 49.04780833000011],
              [39.90725874900005, 49.04258901000007],
              [39.89134240700008, 49.04176218700006],
              [39.86199019400004, 49.045121156000064],
              [39.831501099000036, 49.04527618400003],
              [39.74892216000012, 49.02620758100004],
              [39.698279256000035, 49.02837799100003],
              [39.68112268100009, 49.02031646800005],
              [39.67399133300006, 48.9701386520001],
              [39.68753055800005, 48.95758127900008],
              [39.707787720000056, 48.9487962860001],
              [39.7259778240001, 48.937014059],
              [39.73941369600004, 48.918978983],
              [39.74737186700008, 48.905336406000075],
              [39.75874068200005, 48.8954145310001],
              [39.78230513500006, 48.8884382130001],
              [39.861886841000114, 48.876449280000045],
              [39.89651005100012, 48.879911601000074],
              [39.90818892400006, 48.878412984000065],
              [39.91862756400013, 48.87247019500005],
              [39.93764449100007, 48.856243795000054],
              [39.95035689300005, 48.852781474000025],
              [39.97226770000009, 48.860326233000066],
              [39.989941040000076, 48.87567413400002],
              [40.00885461400014, 48.88781809500004],
              [40.03427941900014, 48.885596009000025],
              [40.053813110000135, 48.869214580000076],
              [40.052779582000085, 48.84973256500008],
              [40.03872359300004, 48.82999216800003],
              [40.01960331200007, 48.813145651000056],
              [39.97526493300012, 48.789684550000075],
              [39.934957317000055, 48.786687317000045],
              [39.82416304600014, 48.81562612000003],
              [39.801218710000114, 48.81490264900002],
              [39.77941125500007, 48.807719625000075],
              [39.759360799000035, 48.79283681200012],
              [39.751195923000125, 48.781881409000036],
              [39.744477987000096, 48.77051259400007],
              [39.73631311100007, 48.761520894000014],
              [39.711405070000126, 48.75480295900009],
              [39.70293013500009, 48.74658640500006],
              [39.64184859200009, 48.6117109180001],
              [39.631720011000084, 48.58690623000008],
              [39.67027063000006, 48.588404847000064],
              [39.690114379000136, 48.593675842000025],
              [39.80917688000011, 48.58375396800001],
              [39.83532515500008, 48.57347035800002],
              [39.85506555200004, 48.55610707700002],
              [39.862713664000125, 48.53006215500004],
              [39.86385054600004, 48.522749940000054],
              [39.86612430800005, 48.517039693000086],
              [39.8685014240001, 48.512905579000076],
              [39.869534953000084, 48.509908346000046],
              [39.86540083800014, 48.50148508800005],
              [39.855995728000096, 48.49936635300007],
              [39.84669396900006, 48.4998314410001],
              [39.842146444000036, 48.4990562950001],
              [39.844730266000056, 48.48350168900008],
              [39.85434208200007, 48.47544016500008],
              [39.8647807210001, 48.46983327300005],
              [39.89619999200005, 48.42391876300009],
              [39.90684533700011, 48.39833892800003],
              [39.91449344900008, 48.384696351000045],
              [39.92410526600008, 48.376118063],
              [39.90147098800014, 48.36118357400004],
              [39.884107706000066, 48.34635243800001],
              [39.81589481600008, 48.308163554000046],
              [39.88483117700014, 48.27899220800002],
              [39.905191691000084, 48.28064585400007],
              [39.957384888000036, 48.29338409500012],
              [39.978882284000065, 48.29007680300002],
              [39.99324833200012, 48.27323028600004],
              [39.9906645100001, 48.25374827100005],
              [39.97764204900005, 48.23545481400008],
              [39.96048547400011, 48.222070618000046],
              [39.91263309700008, 48.197679342000114],
              [39.89371952300007, 48.182977397000016],
              [39.8430766190001, 48.11975128200005],
              [39.83119104000008, 48.09998504700006],
              [39.82902063000006, 48.07678232900007],
              [39.844316854000056, 48.04567311600003],
              [39.84297326600006, 48.036397197],
              [39.84028609200004, 48.03500193300003],
              [39.833568156000126, 48.03619049100003],
              [39.778791138000145, 48.02921417300006],
              [39.76814579200004, 48.02433075000003],
              [39.75987756300009, 48.01495147800007],
              [39.761944621000055, 48.00978383400006],
              [39.77010949700008, 48.0040994270001],
              [39.78023807800014, 47.993144023000056],
              [39.79439742000005, 47.971310731000116],
              [39.79615441900006, 47.96136301700001],
              [39.79398400900004, 47.94570505800006],
              [39.79047001200007, 47.93774688800009],
              [39.77982466600008, 47.92247650200004],
              [39.777034139000136, 47.91374318500006],
              [39.777550903000076, 47.90658599900003],
              [39.78209843000013, 47.892891745],
              [39.78292525200004, 47.88656138200007],
              [39.77558719900014, 47.85801015200012],
              [39.75905074100007, 47.83294708300012],
              [39.73383264200004, 47.81599721300002],
              [39.700759725000125, 47.811527201],
              [39.60061079900004, 47.829484762000064],
              [39.5700183510001, 47.83093170200006],
              [39.509350220000044, 47.82276682600006],
              [39.47989465300009, 47.82612579400005],
              [39.45705367000011, 47.83129343700007],
              [39.41395552500012, 47.823180237000074],
              [39.391631307000125, 47.822611796],
              [39.37354455600013, 47.82829620400004],
              [39.34005822700004, 47.843566590000094],
              [39.319697713000096, 47.846021220000054],
              [39.17355676300008, 47.83705535900005],
              [39.13324914600014, 47.82953643800009],
              [39.11350874800007, 47.82855458600004],
              [39.0929415280001, 47.83209442100009],
              [39.039094686000055, 47.85692494800013],
              [39.03618022000006, 47.85700264800006],
              [38.8772441000001, 47.86123993000011],
              [38.8309420170001, 47.84824330600007],
              [38.79621545400005, 47.81992462200007],
              [38.77099735500008, 47.78083140100004],
              [38.75332401600008, 47.735149435000054],
              [38.745159139000066, 47.69311065700002],
              [38.734513794000065, 47.67714263900008],
              [38.713016398000036, 47.675721538000104],
              [38.67787642400009, 47.68517832500005],
              [38.66216678900014, 47.68329213500006],
              [38.643356567000126, 47.6735252890001],
              [38.60635624200006, 47.64505157500007],
              [38.58764937300009, 47.63430287700005],
              [38.56222456900008, 47.626628927000056],
              [38.35293501800004, 47.60709523600006],
              [38.319035278000115, 47.59130808500005],
              [38.29340376800013, 47.56278269500011],
              [38.27438684000009, 47.52784942700002],
              [38.26033085100005, 47.492941997000045],
              [38.26363814200005, 47.42170603500007],
              [38.257953736000104, 47.39323232100004],
              [38.233355753000126, 47.36240732800006],
              [38.203383423000105, 47.334631246000114],
              [38.190567668000085, 47.3169062300001],
              [38.18870731600009, 47.300989889000064],
              [38.20100630700006, 47.29062876400006],
              [38.22033329300007, 47.288794251000056],
              [38.25764367700009, 47.292747498000054],
              [38.275730429000134, 47.291817322000085],
              [38.29185347500004, 47.287037252000076],
              [38.30094852700006, 47.276030172],
              [38.298158000000114, 47.256031392000054],
              [38.284722127000066, 47.241148580000115],
              [38.26394820200005, 47.23153676400001],
              [38.24131392400011, 47.22394032800004],
              [38.2225037020001, 47.21523284900009],
              [38.203486776000034, 47.192314352000054],
              [38.19697554500004, 47.162393698000116],
              [38.20141971900006, 47.13074188300003],
              [38.21664472700007, 47.10325755400004],
              [38.21648196700005, 47.10309479400007],
              [38.196299675000034, 47.089504299000055],
              [38.14226321700005, 47.03766510600008],
              [38.108083530000044, 47.02635325700004],
              [38.13038170700008, 47.05841705900008],
              [38.13005618600005, 47.074652411000045],
              [38.10434004000007, 47.08161041900007],
              [38.07154381600009, 47.09979889500005],
              [38.06657962300005, 47.098089911000045],
              [38.06104576900009, 47.094956773000035],
              [38.035166863000086, 47.08429596600007],
              [38.02621504000007, 47.08161041900007],
              [37.98764082100007, 47.09194570500006],
              [37.96208743600005, 47.09593333500004],
              [37.95045006600009, 47.09125397300005],
              [37.86109459700009, 47.10150788000004],
              [37.75326582100007, 47.07526276200008],
              [37.71029707100007, 47.07416413000004],
              [37.580739780000044, 47.09039948100008],
              [37.54639733200008, 47.08161041900007],
              [37.48292076900009, 47.03595612200007],
              [37.377940300000034, 46.93390534100007],
              [37.35173587300005, 46.89874909100007],
              [37.33521569100009, 46.882473049000055],
              [37.31299889400009, 46.87555573100008],
              [37.317393425000034, 46.900824286000045],
              [37.29542076900009, 46.92023346600007],
              [37.260752800000034, 46.93268463700008],
              [37.22706139400009, 46.93699778900009],
              [37.20818118600005, 46.933579820000034],
              [37.16228274800005, 46.909084377000056],
              [37.04656009200005, 46.87775299700007],
              [37.02881920700008, 46.87555573100008],
              [37.01775149800005, 46.87128327000005],
              [36.98487389400009, 46.85248444200005],
              [36.97380618600005, 46.84829336100006],
              [36.93881269600007, 46.839504299000055],
              [36.88624108200008, 46.804022528000075],
              [36.85368899800005, 46.800482489000046],
              [36.86247806100005, 46.77692291900007],
              [36.84913170700008, 46.75446198100008],
              [36.82960045700008, 46.73187897300005],
              [36.81959069100009, 46.70766836100006],
              [36.81226647200009, 46.680568752000056],
              [36.793711785000085, 46.653631903000075],
              [36.76929772200009, 46.63739655200004],
              [36.74382571700005, 46.64215729400007],
              [36.74382571700005, 46.649603583000044],
              [36.75123131600009, 46.649603583000044],
              [36.77165774800005, 46.643459377000056],
              [36.79029381600009, 46.67129140800006],
              [36.80225670700008, 46.707017320000034],
              [36.80250084700009, 46.72475820500006],
              [36.79428144600007, 46.72919342700004],
              [36.75806725400008, 46.75885651200008],
              [36.742849155000044, 46.76471588700008],
              [36.71013431100005, 46.772772528000075],
              [36.696055535000085, 46.77997467700004],
              [36.67920983200008, 46.77301666900007],
              [36.66163170700008, 46.77374909100007],
              [36.63396243600005, 46.77997467700004],
              [36.61703535200007, 46.776678778000075],
              [36.60596764400009, 46.76943594000005],
              [36.59782962300005, 46.762152411000045],
              [36.59001712300005, 46.75885651200008],
              [36.524099155000044, 46.75885651200008],
              [36.48267662900008, 46.74168528900009],
              [36.43246504000007, 46.73484935100004],
              [36.40015709700009, 46.723944403000075],
              [36.371104363000086, 46.70844147300005],
              [36.303477410000085, 46.65924713700008],
              [36.28435306100005, 46.636419989000046],
              [36.278330925000034, 46.607407945000034],
              [36.27084394600007, 46.607407945000034],
              [36.27116946700005, 46.62221914300005],
              [36.267588738000086, 46.62555573100008],
              [36.257823113000086, 46.62173086100006],
              [36.24789472700007, 46.61904531500005],
              [36.246755405000044, 46.61273834800005],
              [36.24577884200005, 46.61082591400009],
              [36.24073326900009, 46.61994049700007],
              [36.24333743600005, 46.62409088700008],
              [36.244476759000065, 46.630519924000055],
              [36.24431399800005, 46.63532135600008],
              [36.23292076900009, 46.640692450000074],
              [36.23064212300005, 46.64215729400007],
              [36.22185306100005, 46.65403880400004],
              [36.21664472700007, 46.65867747600004],
              [36.209971550000034, 46.66266510600008],
              [36.189463738000086, 46.66901276200008],
              [36.17172285200007, 46.66860586100006],
              [36.13445071700005, 46.66266510600008],
              [36.06202233200008, 46.67011139500005],
              [35.92554772200009, 46.65228913000004],
              [35.90162194100009, 46.65273672100005],
              [35.827159050000034, 46.62335846600007],
              [35.77116946700005, 46.601263739000046],
              [35.74195397200009, 46.584418036000045],
              [35.66130618600005, 46.51927317900004],
              [35.62867272200009, 46.498480536000045],
              [35.510508660000085, 46.45722077000005],
              [35.49146569100009, 46.44798411700003],
              [35.47575931100005, 46.43569570500006],
              [35.44548587300005, 46.40599192900004],
              [35.430023634000065, 46.39557526200008],
              [35.39503014400009, 46.378607489000046],
              [35.38013756600009, 46.368475653000075],
              [35.28451582100007, 46.25922272300005],
              [35.27955162900008, 46.255153713000084],
              [35.26351972700007, 46.242254950000074],
              [35.20948326900009, 46.16986725500004],
              [35.18474368600005, 46.14549388200004],
              [35.16179446700005, 46.128241278000075],
              [35.121104363000086, 46.118475653000075],
              [35.09652754000007, 46.10419342700004],
              [35.06226647200009, 46.09861888200004],
              [35.03858483200008, 46.08608633000006],
              [35.000010613000086, 46.07363515800006],
              [34.98210696700005, 46.077826239000046],
              [34.985362175000034, 46.08746979400007],
              [35.01710045700008, 46.11277903900009],
              [35.05193118600005, 46.128241278000075],
              [35.04908287900008, 46.132066148000035],
              [35.04444420700008, 46.141913153000075],
              [35.14893639400009, 46.164129950000074],
              [35.20045006600009, 46.18301015800006],
              [35.22787519600007, 46.22174713700008],
              [35.25180097700007, 46.240220445000034],
              [35.26221764400009, 46.25731028900009],
              [35.291351759000065, 46.29336172100005],
              [35.32781009200005, 46.319240627000056],
              [35.342133009000065, 46.33576080900008],
              [35.346039259000065, 46.361029364000046],
              [35.328868035000085, 46.34804922100005],
              [35.311534050000034, 46.33763255400004],
              [35.291758660000085, 46.33641185100004],
              [35.267588738000086, 46.35106028900009],
              [35.258555535000085, 46.37335846600007],
              [35.26449629000007, 46.39980703300006],
              [35.28451582100007, 46.43740469000005],
              [35.27711022200009, 46.440741278000075],
              [35.26091556100005, 46.44159577000005],
              [35.25049889400009, 46.44354889500005],
              [35.243174675000034, 46.446966864000046],
              [35.23031660200007, 46.455511786000045],
              [35.21461022200009, 46.46263255400004],
              [35.20167076900009, 46.47630442900004],
              [35.191416863000086, 46.49428945500006],
              [35.18832441500007, 46.51243724200003],
              [35.166677280000044, 46.49315013200004],
              [35.17400149800005, 46.47333405200004],
              [35.192067905000044, 46.455064195000034],
              [35.20199629000007, 46.44049713700008],
              [35.205088738000086, 46.42755768400008],
              [35.21070397200009, 46.42015208500004],
              [35.21371504000007, 46.411810614000046],
              [35.20948326900009, 46.39642975500004],
              [35.201508009000065, 46.38532135600008],
              [35.16781660200007, 46.361029364000046],
              [35.108409050000034, 46.297756252000056],
              [35.10507246200007, 46.29507070500006],
              [35.07504316500007, 46.27106354400007],
              [35.03077233200008, 46.25177643400008],
              [34.93604576900009, 46.23541901200008],
              [34.926524285000085, 46.23505280200004],
              [34.914073113000086, 46.23810455900008],
              [34.90805097700007, 46.24428945500006],
              [34.907237175000034, 46.251654364000046],
              [34.90479576900009, 46.25568268400008],
              [34.893565300000034, 46.25177643400008],
              [34.88656660200007, 46.24274323100008],
              [34.885427280000044, 46.23139069200005],
              [34.88217207100007, 46.22174713700008],
              [34.838877800000034, 46.20766836100006],
              [34.83513431100005, 46.203192450000074],
              [34.81763756600009, 46.18622467700004],
              [34.81226647200009, 46.176662502000056],
              [34.811289910000085, 46.16624583500004],
              [34.813243035000085, 46.158270575000074],
              [34.819102410000085, 46.141913153000075],
              [34.824229363000086, 46.07794830900008],
              [34.82894941500007, 46.06342194200005],
              [34.838552280000044, 46.04755280200004],
              [34.87435957100007, 45.92609284100007],
              [34.883474155000044, 45.91282786700003],
              [34.895192905000044, 45.90102773600006],
              [34.905039910000085, 45.88861725500004],
              [34.95818118600005, 45.78953685100004],
              [35.00189122179862, 45.729002575039836],
              [34.97566709855772, 45.71732197013279],
              [34.95233133452342, 45.72198912240003],
              [34.91732768892166, 45.74765846256798],
              [34.870656160853116, 45.7733278036352],
              [34.80998317508346, 45.78499568520266],
              [34.78898098718281, 45.803664296070394],
              [34.78431383491551, 45.82933363713761],
              [34.78431383491551, 45.86900443500667],
              [34.78431383491551, 45.89934092834113],
              [34.76331164701486, 45.9320109978093],
              [34.735308730713314, 45.95301318570995],
              [34.68863720264477, 45.97401537271128],
              [34.64196567457623, 45.981016102011495],
              [34.59996129967419, 45.97868252587784],
              [34.56962480633973, 45.97634894974419],
              [34.52995400847067, 45.981016102011495],
              [34.52061970213754, 45.969348220443976],
              [34.504284667403454, 45.95067960867698],
              [34.464613869534446, 45.95534676184354],
              [34.43427737619993, 45.97168179657763],
              [34.41094161216563, 45.98801683131171],
              [34.39227300129795, 46.00901901921236],
              [34.37827154269752, 46.03002120621369],
              [34.361936507963435, 46.055690546381584],
              [34.33393359166189, 46.069692004982016],
              [34.30126352129446, 46.069692004982016],
              [34.27326060499291, 46.08369346358245],
              [34.23592338235818, 46.09769492128356],
              [34.20091973675642, 46.10002849831653],
              [34.16124893798809, 46.090694192882665],
              [34.10524310448568, 46.09536134514991],
              [34.06790588275027, 46.10469565058378],
              [34.02590150784829, 46.11636353305056],
              [33.99089786134721, 46.13036499075167],
              [33.94422633417798, 46.15370075478597],
              [33.89288765294282, 46.17703651882027],
              [33.84621612577354, 46.19570512968795],
              [33.801878173838645, 46.20270585898817],
              [33.755206645770045, 46.1933715535543],
              [33.71572629013616, 46.1957430352129],
              [33.67027978528387, 46.21810560059299],
              [33.66162330786932, 46.21017049727061],
              [33.6714563305452, 46.17295065684732],
              [33.660449051382614, 46.148184276483164],
              [33.628517493895586, 46.12493524180271],
              [33.61345462300005, 46.14520905200004],
              [33.59652754000007, 46.15574778900009],
              [33.57154381600009, 46.14935944200005],
              [33.549815300000034, 46.136419989000046],
              [33.53248131600009, 46.121527411000045],
              [33.531260613000086, 46.10687897300005],
              [33.55787194100009, 46.09471263200004],
              [33.55787194100009, 46.08730703300006],
              [33.531260613000086, 46.085923570000034],
              [33.50562584700009, 46.08026764500005],
              [33.49577884200005, 46.06785716400009],
              [33.516286655000044, 46.04633209800005],
              [33.50635826900009, 46.04682038000004],
              [33.48552493600005, 46.053168036000045],
              [33.423838738000086, 46.05329010600008],
              [33.41529381600009, 46.05809153900009],
              [33.38428795700008, 46.087591864000046],
              [33.357758009000065, 46.10382721600007],
              [33.331065300000034, 46.107489325000074],
              [33.31080162900008, 46.08730703300006],
              [33.30583743600005, 46.09235260600008],
              [33.301442905000044, 46.09365469000005],
              [33.29639733200008, 46.09357330900008],
              [33.29029381600009, 46.09471263200004],
              [33.30689537900008, 46.10614655200004],
              [33.31771894600007, 46.11969635600008],
              [33.31568444100009, 46.13100820500006],
              [33.29346764400009, 46.13568756700005],
              [33.21461022200009, 46.128241278000075],
              [33.22185306100005, 46.141506252000056],
              [33.225352410000085, 46.15412018400008],
              [33.235118035000085, 46.223822333000044],
              [33.211924675000034, 46.206284898000035],
              [33.19499759200005, 46.17869700700004],
              [33.17505944100009, 46.15314362200007],
              [33.143239780000044, 46.141913153000075],
              [33.135508660000085, 46.140692450000074],
              [33.12289472700007, 46.13589101800005],
              [33.11280358200008, 46.13568756700005],
              [33.10328209700009, 46.138373114000046],
              [33.08179772200009, 46.14935944200005],
              [33.023448113000086, 46.16986725500004],
              [33.03248131600009, 46.14101797100005],
              [33.018239780000044, 46.12767161700003],
              [32.913096550000034, 46.11517975500004],
              [32.89926191500007, 46.115220445000034],
              [32.891612175000034, 46.11668528900009],
              [32.88266035200007, 46.12067291900007],
              [32.87614993600005, 46.12140534100007],
              [32.85320071700005, 46.120347398000035],
              [32.84457441500007, 46.12140534100007],
              [32.789805535000085, 46.13434479400007],
              [32.766286655000044, 46.13568756700005],
              [32.75131269600007, 46.13304271000004],
              [32.71404056100005, 46.12006256700005],
              [32.588226759000065, 46.104396877000056],
              [32.57781009200005, 46.101548570000034],
              [32.56755618600005, 46.096584377000056],
              [32.55103600400008, 46.08429596600007],
              [32.543711785000085, 46.08047109600005],
              [32.50342858200008, 46.07611725500004],
              [32.30250084700009, 46.11668528900009],
              [32.28052819100009, 46.12759023600006],
              [32.26775149800005, 46.126613674000055],
              [32.262461785000085, 46.128241278000075],
              [32.260508660000085, 46.132147528000075],
              [32.25733483200008, 46.144964911000045],
              [32.25562584700009, 46.14935944200005],
              [32.25171959700009, 46.15688711100006],
              [32.24740644600007, 46.17072174700007],
              [32.24195397200009, 46.176662502000056],
              [32.26091556100005, 46.18862539300005],
              [32.26677493600005, 46.19481028900009],
              [32.26929772200009, 46.20457591400009],
              [32.239268425000034, 46.19525788000004],
              [32.21314537900008, 46.193060614000046],
              [32.18734785200007, 46.19672272300005],
              [32.142588738000086, 46.20799388200004],
              [32.12867272200009, 46.20970286700003],
              [32.11540774800005, 46.214544989000046],
              [32.07789147200009, 46.24949778900009],
              [32.05014082100007, 46.266058661000045],
              [32.01807701900009, 46.257513739000046],
              [31.96843509200005, 46.27570221600007],
              [31.885752800000034, 46.320013739000046],
              [31.884043816000087, 46.308661200000074],
              [31.887950066000087, 46.29515208500004],
              [31.889903191000087, 46.28384023600006],
              [31.882334832000083, 46.27912018400008],
              [31.819183790000068, 46.280585028000075],
              [31.801117384000065, 46.28506094000005],
              [31.785899285000085, 46.29238515800006],
              [31.772471550000034, 46.30267975500004],
              [31.76734459700009, 46.31818268400008],
              [31.779958530000044, 46.33177317900004],
              [31.799815300000034, 46.342230536000045],
              [31.816742384000065, 46.34796784100007],
              [31.837412957000083, 46.34955475500004],
              [31.892588738000086, 46.341131903000075],
              [31.968272332000083, 46.35106028900009],
              [31.977305535000085, 46.35529205900008],
              [32.029633009000065, 46.38898346600007],
              [32.041677280000044, 46.39085521000004],
              [32.05518639400009, 46.39057038000004],
              [32.06185957100007, 46.393784898000035],
              [32.05355879000007, 46.40599192900004],
              [32.007823113000086, 46.44896067900004],
              [31.991709832000083, 46.453558661000045],
              [31.954600457000083, 46.45099518400008],
              [31.91065514400009, 46.45587799700007],
              [31.771657748000052, 46.49583567900004],
              [31.74854576900009, 46.49994538000004],
              [31.726410352000073, 46.500881252000056],
              [31.71070397200009, 46.495428778000075],
              [31.695974155000044, 46.48411692900004],
              [31.690277540000068, 46.478583075000074],
              [31.686534050000034, 46.47089264500005],
              [31.685069207000083, 46.461371161000045],
              [31.686534050000034, 46.42987702000005],
              [31.663584832000083, 46.47211334800005],
              [31.655772332000083, 46.47833893400008],
              [31.641449415000068, 46.482082424000055],
              [31.524424675000034, 46.56419505400004],
              [31.50831139400009, 46.587591864000046],
              [31.540293816000087, 46.57005442900004],
              [31.566661004000082, 46.55036041900007],
              [31.581553582000083, 46.54523346600007],
              [31.75635826900009, 46.55426666900007],
              [31.790212436000047, 46.54726797100005],
              [31.847911004000082, 46.52301666900007],
              [31.851735873000052, 46.52195872600004],
              [31.86182701900009, 46.51927317900004],
              [31.947113477000073, 46.51927317900004],
              [32.03345787900008, 46.506293036000045],
              [32.09115644600007, 46.51284414300005],
              [32.111664259000065, 46.51243724200003],
              [32.22152754000007, 46.495428778000075],
              [32.276133660000085, 46.47089264500005],
              [32.31755618600005, 46.46434153900009],
              [32.36101321700005, 46.466864325000074],
              [32.39966881600009, 46.47833893400008],
              [32.42701256600009, 46.49884674700007],
              [32.40837649800005, 46.517279364000046],
              [32.43572024800005, 46.54315827000005],
              [32.50570722700007, 46.58413320500006],
              [32.52475019600007, 46.59271881700005],
              [32.570974155000044, 46.59642161700003],
              [32.58838951900009, 46.60431549700007],
              [32.60377037900008, 46.61570872600004],
              [32.61939537900008, 46.62352122600004],
              [32.633799675000034, 46.63312409100007],
              [32.645518425000034, 46.649603583000044],
              [32.621836785000085, 46.641791083000044],
              [32.59457441500007, 46.62832265800006],
              [32.567393425000034, 46.618475653000075],
              [32.543711785000085, 46.62173086100006],
              [32.40902754000007, 46.56891510600008],
              [32.33578535200007, 46.562160549000055],
              [32.26929772200009, 46.587591864000046],
              [32.25375410200007, 46.604722398000035],
              [32.24822024800005, 46.607407945000034],
              [32.23682701900009, 46.60443756700005],
              [32.22006269600007, 46.590725002000056],
              [32.210948113000086, 46.587591864000046],
              [32.19971764400009, 46.58649323100008],
              [32.18018639400009, 46.58177317900004],
              [32.169932488000086, 46.58075592700004],
              [32.14633222700007, 46.560248114000046],
              [32.13209069100009, 46.570298570000034],
              [32.117930535000085, 46.60687897300005],
              [32.10108483200008, 46.614894924000055],
              [32.03956139400009, 46.623480536000045],
              [32.02279707100007, 46.62913646000004],
              [32.00896243600005, 46.63979726800005],
              [31.992930535000085, 46.657416083000044],
              [31.97982832100007, 46.677069403000075],
              [31.974457227000073, 46.69399648600006],
              [31.970713738000086, 46.712876695000034],
              [31.96143639400009, 46.72760651200008],
              [31.950205925000034, 46.74176666900007],
              [31.940277540000068, 46.75885651200008],
              [31.936208530000044, 46.80036041900007],
              [31.95476321700005, 46.83144765800006],
              [31.981700066000087, 46.86033763200004],
              [32.00245201900009, 46.89545319200005],
              [32.00749759200005, 46.915228583000044],
              [32.00668379000007, 46.93048737200007],
              [31.995941602000073, 46.94037506700005],
              [31.946055535000085, 46.94668203300006],
              [31.935883009000065, 46.95482005400004],
              [31.93921959700009, 46.967962958000044],
              [31.968923373000052, 46.99868398600006],
              [31.976898634000065, 47.00934479400007],
              [31.970957879000082, 47.01634349200003],
              [31.943695509000065, 47.01894765800006],
              [31.90015709700009, 47.01361725500004],
              [31.881114129000082, 47.01504140800006],
              [31.865244988000086, 47.02635325700004],
              [31.893239780000044, 47.068426825000074],
              [31.896820509000065, 47.09271881700005],
              [31.882334832000083, 47.11859772300005],
              [31.868174675000034, 47.12734609600005],
              [31.855723504000082, 47.12962474200003],
              [31.845550977000073, 47.134019273000035],
              [31.837901238000086, 47.14923737200007],
              [31.834727410000085, 47.16819896000004],
              [31.83448326900009, 47.178941148000035],
              [31.83057701900009, 47.186753648000035],
              [31.816742384000065, 47.19708893400008],
              [31.757660352000073, 47.21621328300006],
              [31.74854576900009, 47.22846100500004],
              [31.75326582100007, 47.24852122600004],
              [31.752126498000052, 47.255845445000034],
              [31.741709832000083, 47.259100653000075],
              [31.737803582000083, 47.25535716400009],
              [31.723806186000047, 47.237494208000044],
              [31.720550977000073, 47.23187897300005],
              [31.726817254000082, 47.22052643400008],
              [31.742442254000082, 47.20917389500005],
              [31.761729363000086, 47.200506903000075],
              [31.806162957000083, 47.192694403000075],
              [31.816254102000073, 47.180853583000044],
              [31.815603061000047, 47.12262604400007],
              [31.81999759200005, 47.11709219000005],
              [31.844737175000034, 47.112982489000046],
              [31.851573113000086, 47.10834381700005],
              [31.856618686000047, 47.10366445500006],
              [31.86182701900009, 47.10150788000004],
              [31.874278191000087, 47.093817450000074],
              [31.866465691000087, 47.077053127000056],
              [31.852305535000085, 47.060532945000034],
              [31.844737175000034, 47.05369700700004],
              [31.837412957000083, 47.00844961100006],
              [31.868988477000073, 46.99884674700007],
              [31.914073113000086, 47.00307851800005],
              [31.947113477000073, 46.99909088700008],
              [31.91773522200009, 46.976263739000046],
              [31.904307488000086, 46.96051666900007],
              [31.899424675000034, 46.94383372600004],
              [31.907725457000083, 46.92645905200004],
              [31.925629102000073, 46.92291901200008],
              [31.947601759000065, 46.928168036000045],
              [31.968272332000083, 46.93699778900009],
              [31.972829623000052, 46.915350653000075],
              [31.96338951900009, 46.88568756700005],
              [31.94507897200009, 46.85952383000006],
              [31.92318769600007, 46.84829336100006],
              [31.898610873000052, 46.84292226800005],
              [31.87745201900009, 46.82827383000006],
              [31.864756707000083, 46.80658600500004],
              [31.865244988000086, 46.77997467700004],
              [31.90284264400009, 46.74518463700008],
              [31.90674889400009, 46.73822663000004],
              [31.899424675000034, 46.69399648600006],
              [31.902354363000086, 46.676988023000035],
              [31.907481316000087, 46.669175523000035],
              [31.908539259000065, 46.66274648600006],
              [31.899424675000034, 46.649603583000044],
              [31.892100457000083, 46.64362213700008],
              [31.870127800000034, 46.63312409100007],
              [31.858409050000034, 46.62913646000004],
              [31.814707879000082, 46.623032945000034],
              [31.771494988000086, 46.62750885600008],
              [31.674082879000082, 46.653225002000056],
              [31.614431186000047, 46.649603583000044],
              [31.597178582000083, 46.64321523600006],
              [31.588715040000068, 46.62958405200004],
              [31.578868035000085, 46.61733633000006],
              [31.556813998000052, 46.614894924000055],
              [31.54851321700005, 46.618068752000056],
              [31.53451582100007, 46.62718333500004],
              [31.525401238000086, 46.62913646000004],
              [31.504161004000082, 46.62799713700008],
              [31.493011915000068, 46.62872955900008],
              [31.485036655000044, 46.63226959800005],
              [31.48096764400009, 46.64642975500004],
              [31.490896030000044, 46.663397528000075],
              [31.546153191000087, 46.72760651200008],
              [31.56023196700005, 46.74909088700008],
              [31.559825066000087, 46.75885651200008],
              [31.572113477000073, 46.76630280200004],
              [31.618174675000034, 46.81346263200004],
              [31.606130405000044, 46.82640208500004],
              [31.597829623000052, 46.82046133000006],
              [31.591319207000083, 46.805975653000075],
              [31.583994988000086, 46.79364655200004],
              [31.57667076900009, 46.78937409100007],
              [31.557383660000085, 46.783636786000045],
              [31.54932701900009, 46.77997467700004],
              [31.54346764400009, 46.77484772300005],
              [31.524180535000085, 46.75405508000006],
              [31.522959832000083, 46.75031159100007],
              [31.519541863000086, 46.74746328300006],
              [31.50831139400009, 46.74518463700008],
              [31.495616082000083, 46.75071849200003],
              [31.481618686000047, 46.75885651200008],
              [31.466807488000086, 46.78359609600005],
              [31.456065300000034, 46.79604726800005],
              [31.440684441000087, 46.800482489000046],
              [31.451914910000085, 46.775458075000074],
              [31.453786655000044, 46.76911041900007],
              [31.455821160000085, 46.75458405200004],
              [31.461924675000034, 46.74868398600006],
              [31.470713738000086, 46.745347398000035],
              [31.502126498000052, 46.727728583000044],
              [31.505869988000086, 46.720404364000046],
              [31.498301629000082, 46.70766836100006],
              [31.479665561000047, 46.687201239000046],
              [31.47820071700005, 46.68378327000005],
              [31.46265709700009, 46.67523834800005],
              [31.428558790000068, 46.63764069200005],
              [31.416188998000052, 46.62913646000004],
              [31.396657748000052, 46.62604401200008],
              [31.352224155000044, 46.60932038000004],
              [31.33765709700009, 46.601263739000046],
              [31.32390384200005, 46.60614655200004],
              [31.295746290000068, 46.60887278900009],
              [31.28296959700009, 46.614894924000055],
              [31.275563998000052, 46.607407945000034],
              [31.256683790000068, 46.616400458000044],
              [31.18685957100007, 46.62913646000004],
              [31.15951582100007, 46.628973700000074],
              [31.108164910000085, 46.61774323100008],
              [31.054535352000073, 46.61273834800005],
              [31.01303144600007, 46.60333893400008],
              [30.991384311000047, 46.601263739000046],
              [30.982432488000086, 46.59739817900004],
              [30.959239129000082, 46.58340078300006],
              [30.950450066000087, 46.58413320500006],
              [30.93913821700005, 46.58771393400008],
              [30.926036004000082, 46.58429596600007],
              [30.86695397200009, 46.55581289300005],
              [30.854502800000034, 46.55341217700004],
              [30.812510613000086, 46.56004466400009],
              [30.802582227000073, 46.560248114000046],
              [30.79070071700005, 46.55292389500005],
              [30.760915561000047, 46.52435944200005],
              [30.754893425000034, 46.51585521000004],
              [30.75831139400009, 46.50259023600006],
              [30.775238477000073, 46.47768789300005],
              [30.782074415000068, 46.45722077000005],
              [30.785899285000085, 46.45726146000004],
              [30.79346764400009, 46.452337958000044],
              [30.79818769600007, 46.44643789300005],
              [30.792979363000086, 46.44354889500005],
              [30.79037519600007, 46.441473700000074],
              [30.78679446700005, 46.43650950700004],
              [30.783539259000065, 46.430853583000044],
              [30.77475019600007, 46.40062083500004],
              [30.772471550000034, 46.39642975500004],
              [30.731293165000068, 46.358587958000044],
              [30.71452884200005, 46.34796784100007],
              [30.66065514400009, 46.350897528000075],
              [30.651866082000083, 46.34454987200007],
              [30.656504754000082, 46.33901601800005],
              [30.67937259200005, 46.32831452000005],
              [30.686534050000034, 46.320013739000046],
              [30.686778191000087, 46.309027411000045],
              [30.682383660000085, 46.29954661700003],
              [30.653493686000047, 46.25958893400008],
              [30.583506707000083, 46.190334377000056],
              [30.56185957100007, 46.16168854400007],
              [30.547699415000068, 46.147772528000075],
              [30.531993035000085, 46.141913153000075],
              [30.523285352000073, 46.13377513200004],
              [30.503428582000083, 46.09438711100006],
              [30.494151238000086, 46.08047109600005],
              [30.371267123000052, 45.99795156500005],
              [30.26140384200005, 45.89549388200004],
              [30.204925977000073, 45.85586172100005],
              [30.13843834700009, 45.81976959800005],
              [30.140961134000065, 45.83295319200005],
              [30.13526451900009, 45.88914622600004],
              [30.12745201900009, 45.89134349200003],
              [30.118337436000047, 45.88450755400004],
              [30.110606316000087, 45.875067450000074],
              [30.105804884000065, 45.86347077000005],
              [30.102305535000085, 45.83685944200005],
              [30.100596550000034, 45.83030833500004],
              [30.096853061000047, 45.82371653900009],
              [30.096446160000085, 45.818426825000074],
              [30.094574415000068, 45.81484609600005],
              [30.086680535000085, 45.81354401200008],
              [30.084320509000065, 45.815619208000044],
              [30.078379754000082, 45.81940338700008],
              [30.072438998000052, 45.82099030200004],
              [30.069590691000087, 45.81671784100007],
              [30.061208530000044, 45.81346263200004],
              [30.014659050000034, 45.83966705900008],
              [29.99073326900009, 45.84707265800006],
              [29.96851647200009, 45.83893463700008],
              [29.960459832000083, 45.81915924700007],
              [29.958262566000087, 45.794623114000046],
              [29.95289147200009, 45.77195872600004],
              [29.94304446700005, 45.78351471600007],
              [29.932383660000085, 45.79242584800005],
              [29.932383660000085, 45.79987213700008],
              [29.93913821700005, 45.81045156500005],
              [29.935069207000083, 45.81614817900004],
              [29.92628014400009, 45.813788153000075],
              [29.918711785000085, 45.79987213700008],
              [29.91773522200009, 45.782904364000046],
              [29.92237389400009, 45.76943594000005],
              [29.93018639400009, 45.759100653000075],
              [29.939300977000073, 45.75153229400007],
              [29.932383660000085, 45.72418854400007],
              [29.92741946700005, 45.733710028000075],
              [29.91968834700009, 45.74054596600007],
              [29.89820397200009, 45.75153229400007],
              [29.895762566000087, 45.75535716400009],
              [29.896820509000065, 45.75991445500006],
              [29.89616946700005, 45.76361725500004],
              [29.887705925000034, 45.76512278900009],
              [29.881683790000068, 45.763006903000075],
              [29.878754102000073, 45.75828685100004],
              [29.876800977000073, 45.753607489000046],
              [29.874034050000034, 45.75153229400007],
              [29.850840691000087, 45.75112539300005],
              [29.823741082000083, 45.74762604400007],
              [29.80241946700005, 45.737494208000044],
              [29.795746290000068, 45.71735260600008],
              [29.80323326900009, 45.70416901200008],
              [29.816416863000086, 45.697699286000045],
              [29.843028191000087, 45.690659898000035],
              [29.858246290000068, 45.67987702000005],
              [29.86500084700009, 45.67234935100004],
              [29.860118035000085, 45.66893138200004],
              [29.842539910000085, 45.66388580900008],
              [29.82667076900009, 45.65424225500004],
              [29.809580925000034, 45.64858633000006],
              [29.789073113000086, 45.65525950700004],
              [29.786143425000034, 45.64891185100004],
              [29.783864780000044, 45.64663320500006],
              [29.784353061000047, 45.64362213700008],
              [29.789073113000086, 45.63544342700004],
              [29.774099155000044, 45.62958405200004],
              [29.745941602000073, 45.62262604400007],
              [29.73373457100007, 45.61432526200008],
              [29.735036655000044, 45.64057038000004],
              [29.72396894600007, 45.66742584800005],
              [29.705251498000052, 45.68842194200005],
              [29.682627800000034, 45.69684479400007],
              [29.68531334700009, 45.70425039300005],
              [29.679209832000083, 45.75153229400007],
              [29.685801629000082, 45.76772695500006],
              [29.692230665000068, 45.77533600500004],
              [29.69385826900009, 45.781317450000074],
              [29.685883009000065, 45.79242584800005],
              [29.680430535000085, 45.79828522300005],
              [29.677582227000073, 45.80019765800006],
              [29.674001498000052, 45.80158112200007],
              [29.653330925000034, 45.81386953300006],
              [29.647471550000034, 45.81854889500005],
              [29.642832879000082, 45.82721588700008],
              [29.638194207000083, 45.82632070500006],
              [29.633555535000085, 45.82135651200008],
              [29.63135826900009, 45.81354401200008],
              [29.634613477000073, 45.806626695000034],
              [29.648692254000082, 45.79360586100006],
              [29.651866082000083, 45.78900788000004],
              [29.647959832000083, 45.78119538000004],
              [29.629567905000044, 45.76349518400008],
              [29.623871290000068, 45.75153229400007],
              [29.62273196700005, 45.73623281500005],
              [29.625336134000065, 45.72825755400004],
              [29.630707227000073, 45.72150299700007],
              [29.637543165000068, 45.70990631700005],
              [29.60320071700005, 45.69131094000005],
              [29.597178582000083, 45.65228913000004],
              [29.59937584700009, 45.60443756700005],
              [29.589691602000073, 45.55906810100004],
              [29.61500084700009, 45.550116278000075],
              [29.629079623000052, 45.54669830900008],
              [29.648448113000086, 45.54539622600004],
              [29.666840040000068, 45.548163153000075],
              [29.681162957000083, 45.555121161000045],
              [29.707041863000086, 45.57330963700008],
              [29.694509311000047, 45.562201239000046],
              [29.661631707000083, 45.52586497600004],
              [29.648448113000086, 45.51813385600008],
              [29.63803144600007, 45.51386139500005],
              [29.631683790000068, 45.50446198100008],
              [29.62671959700009, 45.49506256700005],
              [29.62086022200009, 45.49079010600008],
              [29.60515384200005, 45.48700592700004],
              [29.605723504000082, 45.478176174000055],
              [29.621104363000086, 45.454413153000075],
              [29.629649285000085, 45.446926174000055],
              [29.640798373000052, 45.44179922100005],
              [29.651866082000083, 45.443019924000055],
              [29.65560957100007, 45.45184967700004],
              [29.653819207000083, 45.46401601800005],
              [29.65601647200009, 45.47418854400007],
              [29.67237389400009, 45.47711823100008],
              [29.67237389400009, 45.45384349200003],
              [29.675303582000083, 45.44961172100005],
              [29.681488477000073, 45.45018138200004],
              [29.686534050000034, 45.453558661000045],
              [29.685883009000065, 45.45726146000004],
              [29.694346550000034, 45.455511786000045],
              [29.702159050000034, 45.45661041900007],
              [29.70866946700005, 45.452785549000055],
              [29.713226759000065, 45.43622467700004],
              [29.719737175000034, 45.45136139500005],
              [29.724457227000073, 45.46816640800006],
              [29.732269727000073, 45.47573476800005],
              [29.74740644600007, 45.46344635600008],
              [29.754649285000085, 45.447251695000034],
              [29.755869988000086, 45.42788320500006],
              [29.74781334700009, 45.41429271000004],
              [29.727712436000047, 45.415676174000055],
              [29.74187259200005, 45.40452708500004],
              [29.750173373000052, 45.38580963700008],
              [29.753916863000086, 45.36408112200007],
              [29.756195509000065, 45.32123444200005],
              [29.754893425000034, 45.31268952000005],
              [29.751475457000083, 45.30414459800005],
              [29.742930535000085, 45.29047272300005],
              [29.741221550000034, 45.28221263200004],
              [29.729746941000087, 45.25812409100007],
              [29.727712436000047, 45.247748114000046],
              [29.728688998000052, 45.23932526200008],
              [29.729746941000087, 45.23773834800005],
              [29.728037957000083, 45.23688385600008],
              [29.70875084700009, 45.22333405200004],
              [29.692393425000034, 45.21674225500004],
              [29.674489780000044, 45.21356842700004],
              [29.659027540000068, 45.21588776200008],
              [29.66421472100012, 45.223183899000034],
              [29.66648848400007, 45.23062530600005],
              [29.664989869000124, 45.23786000600002],
              [29.6592537840001, 45.24416453100012],
              [29.672276245000035, 45.272948303000035],
              [29.66710860200004, 45.311860657000025],
              [29.650262085000122, 45.34612213200002],
              [29.628144572000053, 45.3607982380001],
              [29.61636234600013, 45.36534576500004],
              [29.56969852700007, 45.39495636],
              [29.43063724800004, 45.43040639200002],
              [29.353742717000046, 45.43593577100005],
              [29.343924195000113, 45.43810618100012],
              [29.33296879100004, 45.44213694300002],
              [29.32211674000007, 45.44384226500007],
              [29.312814982000134, 45.43934641500006],
              [29.3070272220001, 45.43412709500005],
              [29.29927575700009, 45.42890777700002],
              [29.290490763000093, 45.424618633000065],
              [29.28180912200014, 45.42229319300013],
              [29.26082849100004, 45.422034810000056],
              [29.244602091000104, 45.42420522100004],
              [29.22816898600007, 45.42374013300012],
              [29.2066715900001, 45.41542022700007],
              [29.191582072000102, 45.406170146000036],
              [29.183107137, 45.398987122000094],
              [29.179386434000094, 45.391855774000064],
              [29.17432214300004, 45.388961894000076],
              [29.150137573000052, 45.387876689000066],
              [29.1418693440001, 45.38508616100002],
              [29.1275032960001, 45.37454417000005],
              [29.11029504300012, 45.36906646800007],
              [29.06952233900006, 45.3607982380001],
              [29.01815596600008, 45.33087758400008],
              [29.004616740000102, 45.32607167600007],
              [28.982447550000074, 45.32550323500003],
              [28.973662557000097, 45.32369456000005],
              [28.96647953300004, 45.31987050400009],
              [28.960433390000105, 45.31129221600007],
              [28.957384481000076, 45.29201690700002],
              [28.952836954000134, 45.285092265000046],
              [28.92989261800011, 45.27909779900001],
              [28.910048869000036, 45.28736602800005],
              [28.893615763000042, 45.29982004900005],
              [28.880851684000078, 45.306176249000075],
              [28.85811405400011, 45.30907013000005],
              [28.831810750000074, 45.32229929700004],
              [28.816307820000134, 45.32607167600007],
              [28.78974613400004, 45.3214207970001],
              [28.788609253000118, 45.30710642500013],
              [28.79015954500005, 45.292068583000045],
              [28.761530803000056, 45.28183665000007],
              [28.759670451000147, 45.274188538],
              [28.762564331000135, 45.265145162000024],
              [28.76726688600013, 45.257755433000014],
              [28.774294881000117, 45.25336293600013],
              [28.802665243000035, 45.24416453100012],
              [28.79139978100008, 45.23496612600003],
              [28.778687378000114, 45.23109039400008],
              [28.747371460000124, 45.230470276000105],
              [28.710061076000073, 45.22695627900005],
              [28.57704593900013, 45.248091939000076],
              [28.494156942000103, 45.27889109400006],
              [28.40517012500004, 45.295065817000065],
              [28.370236857000037, 45.309225159],
              [28.353286987000047, 45.31242909800007],
              [28.330239298000066, 45.32291941300012],
              [28.310808960000088, 45.3478274540001],
              [28.281198364000147, 45.401829326000055],
              [28.28641768400007, 45.42172475200006],
              [28.26688399300008, 45.44048329700006],
              [28.237635132000037, 45.45205881800011],
              [28.215146087000107, 45.45036508200003],
              [28.21293379700009, 45.45019846600009],
              [28.19949792500006, 45.46177398700006],
              [28.201564982000036, 45.46885365800007],
              [28.208489624000094, 45.48141103100009],
              [28.217171264000058, 45.49319325800009],
              [28.217274617000072, 45.493348288000035],
              [28.27042337800009, 45.521470690000044],
              [28.270501343000063, 45.52151194300008],
              [28.341918172000135, 45.517636211000124],
              [28.41684899900011, 45.503786926000075],
              [28.48092777500011, 45.50197825100007],
              [28.502011760000045, 45.50874786400003],
              [28.50645593200005, 45.520581767000024],
              [28.500048055000036, 45.55458486000008],
              [28.49798099800006, 45.55644521100008],
              [28.498239380000115, 45.558718974],
              [28.50374338900008, 45.56610240200011],
              [28.504595581000046, 45.56724558600011],
              [28.510435018000123, 45.571017965000024],
              [28.536893351000117, 45.57980295900002],
              [28.523095744000074, 45.59323883100008],
              [28.518754923000103, 45.60703643800012],
              [28.516894572000098, 45.62098907500011],
              [28.511313517000076, 45.63504506500003],
              [28.498497762000085, 45.64429514600003],
              [28.482891480000063, 45.6507547],
              [28.474003133000053, 45.65793772500005],
              [28.48092777500011, 45.66946156900009],
              [28.504182169000046, 45.69369781500008],
              [28.515240926000047, 45.70201772100002],
              [28.532500855000137, 45.71007924400003],
              [28.561439657000108, 45.716590475],
              [28.567640828000094, 45.72460032200006],
              [28.563525429000094, 45.7354940260001],
              [28.560612834000068, 45.743203837000024],
              [28.57668420400003, 45.761910706],
              [28.64360518400011, 45.76650990800006],
              [28.66975345900002, 45.77731028300009],
              [28.673267456000076, 45.78687042300008],
              [28.671923868000107, 45.79725738600011],
              [28.669391724000036, 45.80630076100006],
              [28.66975345900002, 45.81203684500012],
              [28.67729821800009, 45.81658437100005],
              [28.70639205000009, 45.821131897],
              [28.7255640060001, 45.828780009000056],
              [28.738276407000058, 45.83756500300005],
              [28.745046021000093, 45.85048411100006],
              [28.74644128400007, 45.870586243000034],
              [28.742307170000032, 45.88732940700008],
              [28.72840620900007, 45.92195261700009],
              [28.729181356000083, 45.93864410400003],
              [28.740240112000066, 45.95321685800009],
              [28.757603393000096, 45.961175029000046],
              [28.931959676000076, 45.993162740000045],
              [28.956867717000137, 46.001379293000056],
              [28.958934773000095, 46.021016338],
              [28.941158081000083, 46.064682922000074],
              [28.938780965000035, 46.08928090500005],
              [28.94642907700009, 46.105093893000046],
              [28.980845581000068, 46.132120667],
              [29.003479858000105, 46.158940736000076],
              [29.015365438000117, 46.18260854100002],
              [29.009836059000122, 46.20436431900002],
              [28.98411214300006, 46.22122102400006],
              [28.95076989800009, 46.24306996700004],
              [28.95061486800003, 46.243121644000055],
              [28.933509969000085, 46.25898630800005],
              [28.93288985200013, 46.27262888600008],
              [28.939917847000117, 46.28699493500007],
              [28.945808960000136, 46.30497833300005],
              [28.944878784000082, 46.320739645000046],
              [28.92730879700011, 46.36802358000007],
              [28.919247274000014, 46.404662171000055],
              [28.925448446000104, 46.43277415000007],
              [28.945808960000136, 46.45478831000007],
              [29.02032637500008, 46.4895148720001],
              [29.055914596000093, 46.49874020100002],
              [29.074948364000107, 46.50367421500003],
              [29.16274662200007, 46.538090719000095],
              [29.18305928500004, 46.53804189100005],
              [29.1842440180001, 46.53803904300007],
              [29.20021203600004, 46.523983053000066],
              [29.20677494300014, 46.50251149500012],
              [29.20760176600004, 46.41789133800005],
              [29.205638061000116, 46.40610911100005],
              [29.1992818600001, 46.39649729400013],
              [29.190341837000062, 46.387195536],
              [29.18341719600008, 46.37760955800009],
              [29.183727254000075, 46.36717091900006],
              [29.200677124000094, 46.35711985300013],
              [29.222897990000035, 46.36647328800005],
              [29.259174845000075, 46.39435272300004],
              [29.2713704840001, 46.39742747000007],
              [29.278191772000127, 46.39587717800005],
              [29.283256062000135, 46.39742747000007],
              [29.290077352000083, 46.41024322500006],
              [29.290697469000065, 46.41926076300011],
              [29.285943238000073, 46.4394920860001],
              [29.289147176000142, 46.45163604700009],
              [29.306717163000087, 46.47199656200003],
              [29.32077315300012, 46.46874094700006],
              [29.34423425300008, 46.43416941400007],
              [29.36211429900004, 46.415927633000095],
              [29.37472334800009, 46.416186015000065],
              [29.418234904000087, 46.462488098000065],
              [29.436838420000072, 46.47669911800001],
              [29.456723690000103, 46.48436632400008],
              [29.457612345000086, 46.484708965],
              [29.480866740000124, 46.482047628000075],
              [29.486447795000117, 46.47587229500009],
              [29.48820479300008, 46.46936106400001],
              [29.48624108900009, 46.462488098000065],
              [29.480866740000124, 46.455511780000066],
              [29.475285685000074, 46.44755360900008],
              [29.473321981000083, 46.43980214500009],
              [29.475078980000035, 46.432257386000046],
              [29.480866740000124, 46.42515187700009],
              [29.496059611000135, 46.42081105600003],
              [29.527478882000082, 46.416651103],
              [29.54143151900007, 46.41303375300002],
              [29.555642538000143, 46.40419708300003],
              [29.5694401450001, 46.38228627600007],
              [29.582979370000146, 46.36965138800012],
              [29.5985856530001, 46.36306264300005],
              [29.615638875000116, 46.361822409000084],
              [29.63207198100008, 46.36605987600005],
              [29.64550785300014, 46.37559417800004],
              [29.65294925900008, 46.39189809200006],
              [29.647988322000117, 46.41639272100012],
              [29.654396199000075, 46.42269724500004],
              [29.682714885000053, 46.422929789000094],
              [29.70286869300014, 46.42832997600006],
              [29.7138240970001, 46.44305776000006],
              [29.714134155000067, 46.47116973900002],
              [29.726949910000087, 46.455796],
              [29.779556519000096, 46.42109527600009],
              [29.80033044400011, 46.39835764600012],
              [29.805084676000092, 46.38998606400004],
              [29.806738322000058, 46.38089101200008],
              [29.80616988200012, 46.36156402600004],
              [29.808185262000052, 46.354691061000054],
              [29.828132365000045, 46.339394837],
              [29.847769410000126, 46.34146189400006],
              [29.884666382000034, 46.36419952400006],
              [29.90254642700006, 46.371175843000046],
              [29.91866947400007, 46.37365631100003],
              [30.03726688600011, 46.36892791800004],
              [30.081140177000123, 46.374198914000075],
              [30.107185100000095, 46.39189809200006],
              [30.131576375000122, 46.42282643700007],
              [30.118243856000106, 46.42869171200006],
              [30.102017456000056, 46.43073293100012],
              [30.086927938000088, 46.42887258000012],
              [30.077006063000113, 46.42282643700007],
              [30.06000451600005, 46.43680491100007],
              [30.01406416800006, 46.46202301000004],
              [30.021712280000145, 46.47065297500008],
              [30.00941329000011, 46.48806793200002],
              [30.002850383000123, 46.494217428000084],
              [29.99494388900007, 46.49853241000004],
              [29.989259481000147, 46.498687439],
              [29.977063843000053, 46.49318390000009],
              [29.970552612000063, 46.4917369600001],
              [29.967038614000103, 46.49385569300007],
              [29.96207767700008, 46.50344167100009],
              [29.960217326000077, 46.505947978000066],
              [29.91608565200005, 46.518815410000045],
              [29.901926310000135, 46.530830180000024],
              [29.898825724000062, 46.553128561000065],
              [29.91608565200005, 46.554368795000116],
              [29.938099812000132, 46.55734019000003],
              [29.949675334000062, 46.57886342400006],
              [29.947401570000068, 46.58834604900004],
              [29.93494755000006, 46.6088357550001],
              [29.931278524000106, 46.61917104100003],
              [29.931898641000146, 46.632374369],
              [29.935412638000116, 46.64185699500008],
              [29.94027022300014, 46.650797017000016],
              [29.94440433800014, 46.662475891],
              [29.952620890000105, 46.72469431600008],
              [29.951122273000067, 46.743116964000095],
              [29.94667810100009, 46.750739238000065],
              [29.935671021000076, 46.765156963],
              [29.931795288000046, 46.77244333900008],
              [29.930451701000095, 46.781641744000055],
              [29.930658406000134, 46.803087464],
              [29.928177938000147, 46.8097537230001],
              [29.917429240000047, 46.81396535300006],
              [29.90771407000011, 46.81094228200003],
              [29.898515666000094, 46.80665313800007],
              [29.889627319000056, 46.80716990200001],
              [29.884873087000074, 46.812673442000104],
              [29.876914917000136, 46.83078603100002],
              [29.872212361000038, 46.8377106730001],
              [29.84363529400008, 46.85414377900007],
              [29.81521325700004, 46.856624248000045],
              [29.78575769000014, 46.854660543000094],
              [29.75413171400004, 46.85801951100002],
              [29.73583825700007, 46.867192078000116],
              [29.712480509000045, 46.89344370600004],
              [29.69615075700011, 46.90468332900009],
              [29.68085453300006, 46.908559062000066],
              [29.648091675000046, 46.91041941400006],
              [29.631865275000052, 46.91439849900003],
              [29.623286987000085, 46.91954030400005],
              [29.607577352000135, 46.93202016300002],
              [29.598482300000057, 46.935379130000044],
              [29.5731608480001, 46.933725485000096],
              [29.567476440000064, 46.93465566000005],
              [29.558691447000058, 46.94574025500005],
              [29.559828329000084, 46.95884023000012],
              [29.56062574300006, 46.96125639500009],
              [29.564995972000077, 46.97449819000006],
              [29.57248905500012, 47.0117568970001],
              [29.583392781000043, 47.0227898160001],
              [29.59543339000004, 47.03214325000003],
              [29.603029826000125, 47.04575998900005],
              [29.60209965000007, 47.06100453800006],
              [29.5948649500001, 47.07459543900008],
              [29.583392781000043, 47.08521494500006],
              [29.57016361500007, 47.091441956000054],
              [29.551353394000046, 47.0902017210001],
              [29.539726197000107, 47.07888458200004],
              [29.530992879000053, 47.066017151000025],
              [29.52014082900007, 47.059919332000064],
              [29.511459188000117, 47.066017151000025],
              [29.480866740000124, 47.1052395630001],
              [29.478696330000048, 47.10846934100006],
              [29.477869507000094, 47.11154408800009],
              [29.478592976000073, 47.11464467400005],
              [29.480866740000124, 47.11748687800012],
              [29.50866866000007, 47.11939890600003],
              [29.53037276200007, 47.12368805000001],
              [29.544842163000112, 47.135573629000035],
              [29.550629923000088, 47.160171611000024],
              [29.540397990000088, 47.212545675000044],
              [29.544015340000044, 47.234249777000045],
              [29.568716675000076, 47.243138123000065],
              [29.580188843000087, 47.26044972700005],
              [29.579258667000147, 47.283600769000046],
              [29.57006026200014, 47.30677764900004],
              [29.556572714000083, 47.324037578000045],
              [29.539881225000045, 47.3342178350001],
              [29.52096765200008, 47.33892039000007],
              [29.501072225000087, 47.33982472800004],
              [29.480866740000124, 47.338274435000116],
              [29.470634806000135, 47.32274566700009],
              [29.466087280000067, 47.30744944200005],
              [29.459162638000123, 47.29349680600005],
              [29.44169600400005, 47.28212799100005],
              [29.4255729570001, 47.27866567000011],
              [29.409553263000134, 47.27975087600002],
              [29.394463745000053, 47.284711813000044],
              [29.380821167000136, 47.29298004100009],
              [29.37088151900008, 47.30443393300003],
              [29.367592, 47.30822459000005],
              [29.36449141500009, 47.32243560800002],
              [29.3640780020001, 47.336879171000035],
              [29.358910360000095, 47.352717998000045],
              [29.345836222000116, 47.365843811],
              [29.330384969000136, 47.37049469000006],
              [29.31467533300014, 47.372716777000065],
              [29.30082605000007, 47.378194479000044],
              [29.2927128500001, 47.38886566200004],
              [29.288217001000078, 47.40077708000008],
              [29.28139571100013, 47.41147410100008],
              [29.250699910000094, 47.42537506100008],
              [29.23261315900004, 47.44632985500006],
              [29.218350464000082, 47.45160085000002],
              [29.20186568200012, 47.44658823700003],
              [29.192408895000142, 47.4358137010001],
              [29.182073609000042, 47.429870911000094],
              [29.163883504000097, 47.43937937400007],
              [29.15561527500003, 47.44999888100007],
              [29.140008993000095, 47.48015208000005],
              [29.137188792000074, 47.48400843200001],
              [29.130655558000058, 47.492941997000045],
              [29.13060388200006, 47.49304535000006],
              [29.130500529000102, 47.493097026000086],
              [29.130397176000088, 47.493200378],
              [29.117426391000066, 47.53332712800001],
              [29.130500529000102, 47.559630433000066],
              [29.1561837160001, 47.58278147400004],
              [29.182073609000042, 47.61321889300011],
              [29.192408895000142, 47.65091685000006],
              [29.191478719000088, 47.68626352900007],
              [29.196956421000067, 47.71750193300004],
              [29.226670369000146, 47.74323679600003],
              [29.2386076250001, 47.756000875000026],
              [29.23473189300006, 47.76680125000006],
              [29.221967814000095, 47.77481109600002],
              [29.187447957000074, 47.783208517],
              [29.177836141000085, 47.78971974700006],
              [29.177732788000043, 47.80070098900005],
              [29.186724487000077, 47.81821930000011],
              [29.198920125000114, 47.829484762000064],
              [29.21742028800014, 47.84289479600001],
              [29.23276818800008, 47.857079976000065],
              [29.23602380300008, 47.870722555000086],
              [29.225998576000052, 47.87558014000008],
              [29.186621134000063, 47.88364166300009],
              [29.172565145000135, 47.891005554000074],
              [29.164606974000094, 47.90560414700006],
              [29.155821981000088, 47.93986562100007],
              [29.147967163000146, 47.95536855100006],
              [29.136288290000095, 47.968184306000055],
              [29.12398929800014, 47.975987447000065],
              [29.11003666200014, 47.979656474000066],
              [29.092725057000052, 47.98017323800012],
              [29.061047404000135, 47.969760438],
              [29.017225790000055, 47.93108062800009],
              [28.980845581000068, 47.92637807200002],
              [28.95035648600006, 47.93480133100009],
              [28.93608673600005, 47.94216435600002],
              [28.914803101000103, 47.953146464000085],
              [28.88255700700006, 47.976762594],
              [28.862085148000034, 48.00050207700009],
              [28.855685262000037, 48.007923483000056],
              [28.83925215600007, 48.01828460700007],
              [28.83253422100006, 48.02482167600006],
              [28.83077722100009, 48.030867819],
              [28.827573283000106, 48.057016094000105],
              [28.81155358900014, 48.08290598600003],
              [28.809176473, 48.08977895200009],
              [28.808349650000082, 48.09657440200006],
              [28.805920858000036, 48.10380910300002],
              [28.799254598000118, 48.11179311100007],
              [28.771245972000088, 48.12445383700002],
              [28.735072469000073, 48.12869130500006],
              [28.665619344000106, 48.12933726000004],
              [28.573635295000116, 48.1549687710001],
              [28.54159590600011, 48.15595062300007],
              [28.51932336400006, 48.14912933400002],
              [28.501081584000104, 48.11282664000005],
              [28.49979009800009, 48.10891363000003],
              [28.494156942000103, 48.091846009000065],
              [28.493743531000092, 48.07481862400003],
              [28.490022827000104, 48.065491028000096],
              [28.479584188000047, 48.064922588000044],
              [28.459378703000056, 48.07445688900005],
              [28.44744144700013, 48.08275095700007],
              [28.4190194090001, 48.122231751000115],
              [28.435659221000037, 48.13468577100009],
              [28.43689945500006, 48.14985280400002],
              [28.427287639000042, 48.163366191000094],
              [28.411578003000074, 48.170704244],
              [28.388633667000136, 48.16858551100002],
              [28.3755595290001, 48.156648255000064],
              [28.364965861000115, 48.14150706000005],
              [28.349566284000048, 48.129724833000054],
              [28.32858565300012, 48.12701182000002],
              [28.317423543000103, 48.13535756500009],
              [28.3155631920001, 48.14928436300006],
              [28.322177775000085, 48.16321116100006],
              [28.337887410000064, 48.17548431500008],
              [28.352253458000064, 48.18186635400012],
              [28.36336389200008, 48.191013082],
              [28.370030151000094, 48.2116319790001],
              [28.36816980000009, 48.23062306800007],
              [28.35773116100006, 48.23860707600004],
              [28.3405745850001, 48.24010569300005],
              [28.29447920700005, 48.23648834300006],
              [28.277529337000146, 48.22912445100006],
              [28.261716349000068, 48.219951884000054],
              [28.240322307000042, 48.2116319790001],
              [28.216964559000104, 48.208143820000046],
              [28.19991133600007, 48.21173533200003],
              [28.189369344000113, 48.2230524700001],
              [28.185751994000015, 48.24237945600005],
              [28.17851729300014, 48.258864238000044],
              [28.16208418800008, 48.257184754],
              [28.131078329000076, 48.23958892900002],
              [28.115575399000136, 48.23674672500003],
              [28.093251180000095, 48.237444357000115],
              [28.078678426000124, 48.244911601000055],
              [28.098315471000063, 48.2841081750001],
              [28.092837768000066, 48.302065735000085],
              [28.07640466300012, 48.31493316700006],
              [28.055940796000044, 48.32149607400005],
              [28.003176857000085, 48.32588284300003],
              [27.96705733200011, 48.32888580400005],
              [27.92643965600007, 48.33942779500002],
              [27.904528849000116, 48.362475484000086],
              [27.896674032000078, 48.36717804000007],
              [27.885371499000144, 48.37844387600008],
              [27.86484134900013, 48.3989073690001],
              [27.849855184000063, 48.409630229000086],
              [27.785259643000103, 48.44156626400009],
              [27.751773315000094, 48.45197906600002],
              [27.62702640800012, 48.45125559500012],
              [27.60687259900004, 48.45781850200008],
              [27.604805542000065, 48.48412180600003],
              [27.582998087000135, 48.486033834000054],
              [27.5570565190001, 48.47435496100009],
              [27.54517093900006, 48.47236541800005],
              [27.503829794000126, 48.47236541800005],
              [27.480885458000103, 48.451410625000065],
              [27.420217325000124, 48.41714915000004],
              [27.403474161000076, 48.41149058100011],
              [27.389831583000074, 48.41500457800005],
              [27.361409546000033, 48.43280710900011],
              [27.342185913000037, 48.4361144010001],
              [27.306012411000097, 48.423660380000015],
              [27.25193001700012, 48.37831004100009],
              [27.246481160000116, 48.37374094700006],
              [27.20855065900011, 48.36061513300008],
              [27.175787801000098, 48.36180369100002],
              [27.068817586000137, 48.38888214200007],
              [27.048043661000094, 48.39766713500005],
              [27.037398315000104, 48.399682516],
              [27.026339559000093, 48.39709869400009],
              [27.02540938300004, 48.38986399400004],
              [27.028199910000097, 48.38138905900003],
              [27.027786499000086, 48.37477447600013],
              [27.028509969000083, 48.370795390000055],
              [27.031817260000082, 48.36524017400005],
              [27.033057495000037, 48.36020172200007],
              [27.027683146000072, 48.35774709100009],
              [27.015590861000078, 48.35940073700006],
              [27.00463545800011, 48.35875478100009],
              [26.997814168000048, 48.36154530900005],
              [26.990579468000078, 48.36237213100007],
              [26.981071004000086, 48.35568003400006],
              [26.943243856000038, 48.351261699000034],
              [26.90872399900013, 48.36524017400005],
              [26.875961141000033, 48.38399871900005],
              [26.84278487200004, 48.393739726],
              [26.831932821000066, 48.39136261000003],
              [26.82841882400004, 48.385135600000055],
              [26.825628296000076, 48.377771708000054],
              [26.816946655000095, 48.37172556600011],
              [26.810073690000138, 48.371880595000036],
              [26.79358890800006, 48.376273092000034],
              [26.788059530000055, 48.37596303300005],
              [26.777517538000097, 48.366170350000104],
              [26.77818933100008, 48.35720448800005],
              [26.784080444000068, 48.34516388000007],
              [26.789351440000104, 48.32594024700008],
              [26.79007491100009, 48.30705251100004],
              [26.78573409000012, 48.294107564000015],
              [26.774365275000036, 48.28718292300003],
              [26.754573202000074, 48.28614939400005],
              [26.73591801000009, 48.291833801000095],
              [26.72361901900004, 48.302582499000025],
              [26.712973674000068, 48.314907328000075],
              [26.69943444900008, 48.32511342400004],
              [26.679797404000055, 48.330177714000015],
              [26.67400964400008, 48.32170277900012],
              [26.669100382000124, 48.30880950900011],
              [26.636079142000057, 48.29488271100003],
              [26.625123739000088, 48.28289377800006],
              [26.618612508000126, 48.26718414300011],
              [26.617889038000015, 48.25896759100006],
              [26.587399943000037, 48.24935577400005],
              [26.461309448000065, 48.2303905240001],
              [26.44466963700006, 48.227729187000065],
              [26.39743737800012, 48.226204733000074],
              [26.380487508000016, 48.223207499000054],
              [26.347311239000106, 48.212097067000045],
              [26.330258015000084, 48.20850555500006],
              [26.31175785300013, 48.20971995100008],
              [26.303489624000093, 48.212045390000114],
              [26.29615157000009, 48.17899831200005],
              [26.29749515800006, 48.156338196],
              [26.286953166000103, 48.12471222000009],
              [26.27072676600008, 48.09360300700003],
              [26.2553271890001, 48.072338155000054],
              [26.243234904000133, 48.062907207000094],
              [26.21708663000004, 48.04802439400005],
              [26.204787638000084, 48.03737904900005],
              [26.182670125000072, 48.00327260400009],
              [26.173058309000055, 47.993144023000056],
              [26.1257226970001, 47.978416240000044],
              [26.102530449000056, 47.97826709400006],
              [26.029294474000096, 47.97779612200007],
              [25.96573246200012, 47.964902852000066],
              [25.918086792000082, 47.968158468000055],
              [25.901240275000106, 47.96596221900005],
              [25.87095788600007, 47.95702219700003],
              [25.81835127800008, 47.95257802400003],
              [25.752515503000097, 47.93459462600005],
              [25.261744426000064, 47.89857615200005],
              [25.218956339000016, 47.87847402000007],
              [25.121908, 47.770315247],
              [25.08025679500014, 47.74313344300002],
              [25.080050089000082, 47.743081767],
              [25.079946737000057, 47.742926738000065],
              [25.017418253000073, 47.72458160400008],
              [24.942380238000112, 47.715562921000114],
              [24.928857956000115, 47.71393770200011],
              [24.896598755000127, 47.71006052700004],
              [24.877788533000114, 47.71874216700009],
              [24.85443078600008, 47.74313344300002],
              [24.820737752000127, 47.78408701600004],
              [24.808232056000122, 47.795740052],
              [24.793659302000066, 47.804473369000064],
              [24.7128373620001, 47.82591908800002],
              [24.679144328000064, 47.840130107000064],
              [24.661470988000133, 47.85387603800011],
              [24.656923462000123, 47.866200867000046],
              [24.65599328600007, 47.87930084300011],
              [24.64927535000004, 47.89521718400003],
              [24.633669067000085, 47.908291321],
              [24.608450968000056, 47.9219339000001],
              [24.569808453000093, 47.937288541],
              [24.561632121000116, 47.94053741500004],
              [24.542098429000106, 47.94381886800004],
              [24.485564412000144, 47.94319875100008],
              [24.428513631000044, 47.9525263470001],
              [24.40918664600011, 47.952061259000075],
              [24.386242310000057, 47.94368967700011],
              [24.347174926000065, 47.9208745320001],
              [24.297875610000062, 47.91978932800002],
              [24.231006307000087, 47.89702585900004],
              [24.209302205000085, 47.89759430000008],
              [24.150184367000122, 47.91291636200005],
              [24.14873742700013, 47.91211537700012],
              [24.13116744000007, 47.91454416900008],
              [24.094787231000083, 47.93792775500005],
              [24.074943482000094, 47.94418060400004],
              [24.025230753000073, 47.95324981800009],
              [24.008797648000012, 47.961207988000055],
              [23.97727502500004, 47.962293193000065],
              [23.876609334000108, 47.934439596000075],
              [23.855215291000093, 47.93423289000005],
              [23.848394002000134, 47.94965830500003],
              [23.79651086400014, 47.9819819130001],
              [23.78007775900008, 47.98751129100002],
              [23.71052128100007, 47.98508250000005],
              [23.687266886000145, 47.98725291000004],
              [23.64613244600008, 47.996606344000085],
              [23.581743612000082, 48.00156728100002],
              [23.56324344900014, 48.005753072000076],
              [23.525623006000046, 48.00117970900003],
              [23.514460897000106, 47.99898346000002],
              [23.50371219900009, 47.99288564100006],
              [23.49937137800009, 47.986219381000055],
              [23.494307088000113, 47.98053497300002],
              [23.488519328000052, 47.97585825700004],
              [23.4854755610001, 47.974234157000055],
              [23.48159468600008, 47.97216339100005],
              [23.46082076000002, 47.971336569000115],
              [23.396018514000104, 47.993066508000126],
              [23.394468221000096, 47.99345408200013],
              [23.393021281000102, 47.993583273000056],
              [23.39157434100011, 47.99345408200013],
              [23.390127401000115, 47.993066508000126],
              [23.382169230000045, 47.991128642],
              [23.374727824000047, 47.990560202000054],
              [23.367286418000106, 47.99120615700012],
              [23.360051717000147, 47.993144023000056],
              [23.337520793000124, 48.01086903900007],
              [23.28977176900014, 48.03820587200009],
              [23.248637329000076, 48.071227112000045],
              [23.23137740100009, 48.07972788600007],
              [23.161717570000064, 48.09590260900005],
              [23.139083292000095, 48.09812469500007],
              [23.118619426000038, 48.09153595000008],
              [23.0989823810001, 48.071227112000045],
              [23.07655481000012, 48.02451161700007],
              [23.06311893700007, 48.00745839500003],
              [23.02033085100004, 47.984720764000045],
              [23.004414510000117, 47.98306711900001],
              [22.988188110000095, 47.986374411],
              [22.97247847500003, 47.99288564100006],
              [22.95707889800005, 48.00012034100003],
              [22.939302206000036, 48.00564972000005],
              [22.924109334000093, 48.00482289600002],
              [22.91573775200004, 47.9929889940001],
              [22.924212687000107, 47.97273183200009],
              [22.91584110500014, 47.95919260700002],
              [22.897857706000053, 47.95097605500008],
              [22.877600546000053, 47.94673858700013],
              [22.840806925000066, 47.96678904300008],
              [22.8324353430001, 47.97893300400007],
              [22.84948856600002, 47.993144023000056],
              [22.851348918000042, 48.008801982000094],
              [22.857963501000114, 48.01802622600009],
              [22.8615808510001, 48.02838735000002],
              [22.85475956200014, 48.047300924000055],
              [22.84432092300011, 48.0610468550001],
              [22.830988403000106, 48.0724415080001],
              [22.801429484000067, 48.09096750900004],
              [22.765566040000124, 48.1045325730001],
              [22.762052043000068, 48.10926096600009],
              [22.745722290000117, 48.11628896100011],
              [22.72856571400007, 48.11313669900004],
              [22.71161584500007, 48.10582448400005],
              [22.693219035000055, 48.10176788400007],
              [22.621182088000097, 48.10176788400007],
              [22.60805627400012, 48.096832784000114],
              [22.605472453000118, 48.09703949000006],
              [22.60009810300005, 48.10112192800007],
              [22.58304488100012, 48.12481557300002],
              [22.568885539000092, 48.15651906300003],
              [22.555759725000115, 48.17716379900004],
              [22.481449015000123, 48.24258616200002],
              [22.477418254000042, 48.24392974900009],
              [22.4732841390001, 48.244498190000044],
              [22.469046672000047, 48.24413645400004],
              [22.449719686000094, 48.23767690000007],
              [22.434216756000097, 48.23674672500003],
              [22.418403768000104, 48.23896881100005],
              [22.39876672400007, 48.2443431600001],
              [22.394529256000112, 48.2447565720001],
              [22.390498495000116, 48.2443431600001],
              [22.386467732000114, 48.24305125000005],
              [22.378612915000076, 48.23886545900011],
              [22.370861450000064, 48.2373926800001],
              [22.363626749000105, 48.23871042900005],
              [22.357115519000047, 48.24310292600005],
              [22.30812626100004, 48.293694153],
              [22.29737756300011, 48.31400299100004],
              [22.296447388000047, 48.32780059800008],
              [22.29872115100008, 48.33932444300011],
              [22.29872115100008, 48.34914296500007],
              [22.291279744000065, 48.35756622400005],
              [22.28435510300008, 48.35839304700009],
              [22.25675988800006, 48.357282003000066],
              [22.25696659300013, 48.373224182000016],
              [22.271849406000086, 48.403454895000024],
              [22.236089315000072, 48.41528879800005],
              [22.20198286900009, 48.41815684000004],
              [22.16922001100008, 48.40952687600007],
              [22.159298136000103, 48.402318014000016],
              [22.158263205000083, 48.40222218700008],
              [22.15650760900013, 48.40205963100006],
              [22.13283980300011, 48.404798483],
              [22.13376997900005, 48.476835429000076],
              [22.144828735000146, 48.493113506000086],
              [22.148342733000106, 48.508823141000065],
              [22.136663859000038, 48.54933746300007],
              [22.1387309160001, 48.56959462500008],
              [22.15371708100008, 48.5858727010001],
              [22.219036092000124, 48.62093516100002],
              [22.2252372640001, 48.628221538],
              [22.23567590300013, 48.644163717000126],
              [22.243220663000102, 48.65119171100004],
              [22.255519654000125, 48.65677276600006],
              [22.282184692000072, 48.66240549700008],
              [22.294276978000056, 48.667624817],
              [22.310296671000117, 48.68168080700012],
              [22.32249230900004, 48.700335999000075],
              [22.328900187000073, 48.72157501300005],
              [22.327659953000136, 48.74302073200009],
              [22.330760539000067, 48.75640492800004],
              [22.338408650000048, 48.762967835000026],
              [22.34781376100011, 48.76787709600005],
              [22.356495402000064, 48.77614532500009],
              [22.363420044000065, 48.7876174930001],
              [22.36569380700007, 48.79438710600006],
              [22.36352339600009, 48.82828684500005],
              [22.36155969300006, 48.836451722000064],
              [22.36228316200004, 48.844254862000085],
              [22.36889774600013, 48.856450501000026],
              [22.370798705000112, 48.85824814700008],
              [22.378406210000037, 48.86544220000006],
              [22.402384074000054, 48.87882639600009],
              [22.4117891840001, 48.887766419000016],
              [22.413752889000136, 48.89386423800006],
              [22.413649536000094, 48.90678334600007],
              [22.41488977100005, 48.91169260700012],
              [22.427292114000096, 48.92946930000004],
              [22.448996216000097, 48.97143056200004],
              [22.46656620300007, 48.98052561500002],
              [22.50501346900012, 48.98424631800005],
              [22.52051639800004, 48.992927958000095],
              [22.52010298600004, 49.00982615200009],
              [22.524753865000093, 49.03287384100004],
              [22.531988566000052, 49.05571482400005],
              [22.539636678000136, 49.072199606000126],
              [22.56072066300007, 49.08553212500006],
              [22.580771118000115, 49.081449687000045],
              [22.61828820800011, 49.05421620700004],
              [22.642886190000098, 49.04315745100003],
              [22.664383586000042, 49.041452128000074],
              [22.685777629000142, 49.04279571600004],
              [22.721951132000072, 49.04103871700006],
              [22.744482055000077, 49.045534567000075],
              [22.755334106000134, 49.044707743000046],
              [22.76546268700008, 49.038403219000045],
              [22.78396285000011, 49.0213499960001],
              [22.79502160600012, 49.019024556],
              [22.81290165200008, 49.01287506200002],
              [22.83501916500009, 48.99974924800004],
              [22.85527632600008, 48.994013164000094],
              [22.866955200000064, 49.009981181000015],
              [22.865014020000046, 49.013237354000054],
              [22.86375126100009, 49.01535553000009],
              [22.847524862000085, 49.03370066400008],
              [22.843184041000114, 49.043105774000125],
              [22.84442427600004, 49.056696676000016],
              [22.853519328000118, 49.07628204400005],
              [22.853415975000075, 49.08475697900003],
              [22.84132369000011, 49.094885559],
              [22.796468546000114, 49.11137034200006],
              [22.77807173700012, 49.12031036400002],
              [22.748822876000077, 49.145580140000064],
              [22.716370077000136, 49.16056630500013],
              [22.720194132000103, 49.161186422000114],
              [22.721434367000114, 49.161599833000125],
              [22.705724731000146, 49.168834534000084],
              [22.69249556500006, 49.15793080700003],
              [22.68784468600009, 49.15591542600008],
              [22.68174686700013, 49.16123809800003],
              [22.687121216000094, 49.17338206000004],
              [22.702934204000087, 49.19503448500011],
              [22.717093547000047, 49.230432841000024],
              [22.73394006300012, 49.26087026000009],
              [22.737764120000065, 49.275391338000034],
              [22.724224894000088, 49.367065329000056],
              [22.71978072100009, 49.38298167000006],
              [22.71419966600007, 49.390629781000044],
              [22.692598917000083, 49.405512594000086],
              [22.679576456000063, 49.41894846700005],
              [22.67678592900009, 49.424477845000055],
              [22.67306522600009, 49.435846660000024],
              [22.666864054000087, 49.478376364],
              [22.660146118000085, 49.493000794000054],
              [22.640922485000146, 49.52876088500007],
              [22.665830526000036, 49.56736318000007],
              [22.741691528000047, 49.63366404200009],
              [22.75895145600012, 49.665600078000054],
              [22.766186157000078, 49.67423004200002],
              [22.77734826600002, 49.68048289000011],
              [22.798845662000076, 49.68327341700005],
              [22.80980106600012, 49.6863223270001],
              [22.826647583000124, 49.697381083],
              [22.888245890000064, 49.769728088000065],
              [22.897961060000085, 49.77742787700005],
              [22.90674605300009, 49.781200257000066],
              [22.92441939200009, 49.78543772500002],
              [22.933101034000032, 49.79107045600004],
              [22.937751913000113, 49.798201803],
              [22.94591678800012, 49.81835561100006],
              [22.95118778500006, 49.826623841000114],
              [22.99304569500012, 49.85442576100006],
              [23.101462850000075, 49.957106832000065],
              [23.141253702000085, 49.98547719400007],
              [23.17784061700013, 50.00397735600011],
              [23.207916301000097, 50.03394968700003],
              [23.436429484000087, 50.19347483400007],
              [23.48159468600008, 50.215954082000096],
              [23.536061646000064, 50.24277415000007],
              [23.536164999000107, 50.24277415000007],
              [23.536268351000018, 50.2428258260001],
              [23.536371704000146, 50.2428258260001],
              [23.565310506000117, 50.25781199200007],
              [23.644168741000044, 50.31269236300007],
              [23.658018026000093, 50.32561147100007],
              [23.658677406000038, 50.32700492700009],
              [23.671247193000085, 50.353568421],
              [23.68220259600008, 50.36824452800006],
              [23.69574182100007, 50.376771138],
              [23.713001749000057, 50.38240387000012],
              [23.747521606000106, 50.38938018800012],
              [23.928699178000045, 50.39082712800011],
              [23.981305786000036, 50.4047797650001],
              [24.003216593000104, 50.43769765200004],
              [24.007764120000047, 50.44849802700007],
              [24.00941776500008, 50.4614688110001],
              [24.007867472000072, 50.48074412100003],
              [24.010657999000017, 50.492784729],
              [24.07504683500011, 50.514282125000065],
              [24.093960408000044, 50.527149557000044],
              [24.106466105000067, 50.538621725000056],
              [24.107706340000078, 50.54084381100007],
              [24.102538696000096, 50.54363433800002],
              [24.09540734900014, 50.55686350500012],
              [24.08527876800008, 50.60440582300005],
              [24.108429809000086, 50.62988230400005],
              [24.10816542300006, 50.630287411],
              [24.082798299000018, 50.66915639300002],
              [24.074943482000094, 50.690188701000054],
              [24.08104130100014, 50.712978007000046],
              [24.054169555000044, 50.71716379800007],
              [24.026884400000114, 50.72801584900013],
              [24.01282841000011, 50.74331207300007],
              [24.025850871000046, 50.760830384000045],
              [24.025850871000046, 50.76703155500003],
              [23.997945598000058, 50.7692019660001],
              [23.974277791000134, 50.776178284000096],
              [23.959498332000123, 50.78889068700006],
              [23.9576379800001, 50.80801096700007],
              [23.969936971000067, 50.8251675420001],
              [23.99288130700009, 50.83622629800003],
              [24.02047652100009, 50.83855173700006],
              [24.046934855000075, 50.82909495100007],
              [24.067295369000107, 50.83483103400006],
              [24.10047163900012, 50.83498606400009],
              [24.130857381000084, 50.83906850200002],
              [24.143156372000107, 50.85643178300002],
              [24.1302372640001, 50.868937480000014],
              [24.046934855000075, 50.898031311000025],
              [23.979342081000112, 50.93751210600006],
              [23.964355916000045, 50.953221741],
              [23.958878214000066, 50.96634755500007],
              [23.957844685000083, 50.97533925400002],
              [23.95505415800011, 50.98355580700006],
              [23.9439954020001, 50.99420115100004],
              [23.93179976400009, 50.999472148000066],
              [23.919087361000038, 51.00272776300007],
              [23.91174930800014, 51.00681020100008],
              [23.915986776000096, 51.014665019000105],
              [23.915986776000096, 51.020866191],
              [23.9042045490001, 51.06272410100006],
              [23.895522909000135, 51.07610829700009],
              [23.869271281000096, 51.10173980700007],
              [23.854491821000096, 51.12153188100005],
              [23.858212524000095, 51.13073028600006],
              [23.874748983000103, 51.13613047300002],
              [23.863586873000145, 51.1482744340001],
              [23.816044556000037, 51.178789368000096],
              [23.765194946000122, 51.19902069200002],
              [23.7426640220001, 51.21625478099999],
              [23.687266886000145, 51.29240000500006],
              [23.6702136640001, 51.29937632300006],
              [23.650886678000063, 51.29960886700003],
              [23.635177043000084, 51.30469899600011],
              [23.628665812000122, 51.325963848000086],
              [23.634040161000087, 51.3392963670001],
              [23.64778609200002, 51.353998312],
              [23.66556278500005, 51.36580637600012],
              [23.68385624200002, 51.37027638800002],
              [23.677655070000128, 51.383789775000096],
              [23.678895304000065, 51.394073385000084],
              [23.686026652000123, 51.40104970300008],
              [23.697602173000064, 51.40443450900001],
              [23.68943729700004, 51.41642344200007],
              [23.648716268000072, 51.45396637000006],
              [23.647165975000064, 51.460193380000064],
              [23.662772258000103, 51.48019215900008],
              [23.648612915000058, 51.48621246400005],
              [23.63052616400003, 51.49042409300007],
              [23.614816528000063, 51.49721954400012],
              [23.608098592000147, 51.51122385700002],
              [23.606238241000142, 51.517399191000024],
              [23.61543664600012, 51.51311004700004],
              [23.624118286000083, 51.5159005740001],
              [23.628665812000122, 51.53122263600007],
              [23.626288697000092, 51.54088612900007],
              [23.599106893000084, 51.58897104900005],
              [23.59331913200012, 51.596955058000034],
              [23.5943526610001, 51.6049649050001],
              [23.606444946000096, 51.61811655700008],
              [23.616676880000085, 51.62478281700008],
              [23.628975871000108, 51.62904612200005],
              [23.726230916000134, 51.64485911100003],
              [23.749692017000115, 51.64447153800005],
              [23.82028202300009, 51.631268209000055],
              [23.84529341600009, 51.62982126900006],
              [23.884877563000146, 51.61987355600006],
              [23.91288619000005, 51.59858286600006],
              [23.941308228000082, 51.581917216000036],
              [23.981305786000036, 51.58599965400005],
              [24.13075402800004, 51.6697929890001],
              [24.244132121000064, 51.718213807000055],
              [24.272347452000105, 51.74288930300007],
              [24.296118612000072, 51.808130798],
              [24.311518189000054, 51.82756113699999],
              [24.34789839700005, 51.86115081800001],
              [24.369602498000063, 51.875103455],
              [24.390789836000096, 51.880012716000024],
              [24.639766886000046, 51.89213083900002],
              [24.701055135000104, 51.88290659600001],
              [24.72182906100005, 51.882338156000074],
              [25.002742147000077, 51.91047597300009],
              [25.09265913900009, 51.93975067200007],
              [25.138031046000037, 51.94894907700005],
              [25.183299601000044, 51.94975006099999],
              [25.351971477000063, 51.9214830530001],
              [25.547396408000054, 51.919441982000066],
              [25.683475789000028, 51.918020732000045],
              [25.76791508000008, 51.9285110470001],
              [25.9811320390001, 51.9034738160001],
              [26.050585165000086, 51.90481740400007],
              [26.08076420100008, 51.90065745100004],
              [26.14535974100005, 51.864845684],
              [26.17533207200009, 51.8567066450001],
              [26.40777266500004, 51.850608826000055],
              [26.419761597000075, 51.84686228500003],
              [26.419968302000143, 51.839730937000084],
              [26.416971069000027, 51.830635885],
              [26.41924483200006, 51.82092071600006],
              [26.431543823000084, 51.81022369400007],
              [26.445599813000115, 51.805598654],
              [26.665741415000127, 51.80138702400008],
              [26.854773803000086, 51.74934885700013],
              [26.920816284000125, 51.742527568000085],
              [27.02158532700011, 51.764541728000054],
              [27.109952026000116, 51.76242299500008],
              [27.151086466000095, 51.75676442500004],
              [27.177854858000075, 51.747075094000095],
              [27.184159383000093, 51.731442974000075],
              [27.18147220800006, 51.71012644500006],
              [27.18105879700005, 51.68340973],
              [27.18901696800009, 51.66377268500007],
              [27.20358972200006, 51.65514272100005],
              [27.223640177000107, 51.653695780000035],
              [27.2479281010001, 51.65565948500007],
              [27.277487020000137, 51.65113779700003],
              [27.27448978700002, 51.63380035400003],
              [27.259710327000107, 51.612302959],
              [27.25402592000006, 51.595378927000084],
              [27.26746179200012, 51.58749827100006],
              [27.28926924700005, 51.58897104900005],
              [27.32906009900006, 51.596955058000034],
              [27.38838464400007, 51.59072804800003],
              [27.40900354000007, 51.59170990000008],
              [27.430966023000053, 51.59842783600003],
              [27.4587679440001, 51.617496440000096],
              [27.477268107000015, 51.62367177400007],
              [27.512304728000032, 51.62312917100003],
              [27.512426250000146, 51.623098617],
              [27.620618531000076, 51.59589569200004],
              [27.676842488000148, 51.59481048600004],
              [27.69265547700013, 51.589229432000124],
              [27.705161174000125, 51.56835215300005],
              [27.697306356000098, 51.54318573000002],
              [27.664130087000103, 51.49285288500003],
              [27.666181614000095, 51.49019444700009],
              [27.67033125800009, 51.48481720000005],
              [27.68376713100011, 51.47551544300002],
              [27.700045207000045, 51.46753143300005],
              [27.7142562250001, 51.463707377000034],
              [27.73012089000011, 51.46515431700003],
              [27.74055953000007, 51.471407166000105],
              [27.78732670100007, 51.51091379800003],
              [27.792546021000078, 51.51729583800007],
              [27.797145223000115, 51.530602519000084],
              [27.796266724000105, 51.54153208500007],
              [27.793734578000112, 51.552306620000095],
              [27.79321781400006, 51.56501902300003],
              [27.799522339000077, 51.58519866900012],
              [27.812544800000126, 51.602019349],
              [27.831251668000107, 51.61292307600006],
              [27.85419600400013, 51.61532603000002],
              [27.87559004700006, 51.608039653000034],
              [27.936051473000077, 51.567008565],
              [27.954758342000048, 51.56078155500008],
              [27.97315515100007, 51.55781016100009],
              [28.070823608000097, 51.55762929300003],
              [28.090150594000136, 51.56204762800003],
              [28.1142318120001, 51.57561269100002],
              [28.146684611000097, 51.61439585400005],
              [28.166218302000118, 51.63310272300005],
              [28.187612346000037, 51.64519500800013],
              [28.210039917000103, 51.65196462100006],
              [28.230400431000135, 51.65113779700003],
              [28.245128214000147, 51.640621643000074],
              [28.248900594000077, 51.630596416000074],
              [28.248383830000137, 51.62209564200005],
              [28.249365682000104, 51.6130781050001],
              [28.257788940000097, 51.60176096600013],
              [28.269726196000136, 51.594267884],
              [28.298509969000065, 51.58297658300002],
              [28.31091231300013, 51.57444997100002],
              [28.317423543000103, 51.56395965600005],
              [28.328172241000118, 51.53636444100006],
              [28.33385664900007, 51.528380433000095],
              [28.34687911000009, 51.525150656],
              [28.359643188000064, 51.529362284000044],
              [28.38553308100009, 51.54504608200001],
              [28.435349162000136, 51.56613006600004],
              [28.46123905400006, 51.57165944400005],
              [28.488369181000053, 51.57202118000005],
              [28.578079468000112, 51.560109762000096],
              [28.603917684000123, 51.55354685500002],
              [28.61270267700013, 51.53993011500002],
              [28.615183146000106, 51.5195696010001],
              [28.630892781000057, 51.463629863000094],
              [28.63730065900012, 51.44962555000008],
              [28.647015829000054, 51.439006043000106],
              [28.66355228600014, 51.43399342900004],
              [28.67791833500013, 51.43807586700005],
              [28.691147501000046, 51.44342437800002],
              [28.70396325700011, 51.44262339300009],
              [28.71109460500014, 51.430246887000024],
              [28.718225952000097, 51.41161753400006],
              [28.728767945000072, 51.401256409000055],
              [28.74675134200004, 51.413994650000106],
              [28.75160892800008, 51.42874827100012],
              [28.749438517000073, 51.46685964000007],
              [28.752229045000036, 51.48370615700004],
              [28.77186608900007, 51.511275533000045],
              [28.79987471600009, 51.532617899000044],
              [28.831914103000088, 51.5482758590001],
              [28.863643432000117, 51.55892120400007],
              [28.892892294000063, 51.56287445100007],
              [28.954593954000103, 51.56326202400005],
              [28.980845581000068, 51.56946319700005],
              [28.999965861000135, 51.58240814200006],
              [29.02363366700007, 51.61403411900007],
              [29.04358077000009, 51.62617808100005],
              [29.06321781400004, 51.630596416000074],
              [29.083681681000087, 51.63121653300003],
              [29.123885945000012, 51.62504119900005],
              [29.147967163000146, 51.6156360880001],
              [29.16042118300004, 51.60331125900005],
              [29.18145349100007, 51.567008565],
              [29.214836467000055, 51.535460103],
              [29.226515340000105, 51.51905283600006],
              [29.230442749000076, 51.49287872300003],
              [29.22103763800004, 51.466962992],
              [29.227755574000128, 51.455620016000026],
              [29.244395386000065, 51.44789438900001],
              [29.26485925300011, 51.43290822400006],
              [29.276124716000083, 51.413581239000095],
              [29.284599650000075, 51.39174794600005],
              [29.29700199400014, 51.37371287000006],
              [29.319946330000107, 51.36557383200007],
              [29.34056522600008, 51.37009552000008],
              [29.353260212000123, 51.377055123000034],
              [29.37968428500011, 51.391541239],
              [29.40273197500011, 51.39614044200006],
              [29.446398559000045, 51.384900818000105],
              [29.46629398600004, 51.38505584800005],
              [29.480866740000124, 51.401256409000055],
              [29.49554284600009, 51.42564768500007],
              [29.505464722000113, 51.43745575000007],
              [29.5190039470001, 51.44179657000005],
              [29.54504886900014, 51.443656921000056],
              [29.568199911000136, 51.44962555000008],
              [29.583186076000118, 51.460813498000036],
              [29.597345418000145, 51.47396514900002],
              [29.61801599100005, 51.48564402300006],
              [29.637756388000128, 51.4908891810001],
              [29.660804078000126, 51.49313710600002],
              [29.682714885000053, 51.491199240000086],
              [29.69997481300004, 51.48370615700004],
              [29.71651127100006, 51.46567108200004],
              [29.72529626500011, 51.4504523720001],
              [29.737905314000045, 51.43949696900005],
              [29.828649129000098, 51.429962668000044],
              [29.8466325280001, 51.43290822400006],
              [29.856761108000057, 51.43985870400003],
              [29.87360762500009, 51.4591856900001],
              [29.88626835100007, 51.4647925820001],
              [29.896551961000057, 51.46419830400005],
              [29.91257165500008, 51.45742869100012],
              [29.92507735200013, 51.45786794100003],
              [29.985745483000073, 51.47786672000005],
              [30.00868981900004, 51.48207835],
              [30.14862959800007, 51.48442962700004],
              [30.177310018000128, 51.479494527],
              [30.205370320000043, 51.466497904000065],
              [30.24278405700005, 51.43440684000005],
              [30.25689172300008, 51.42505340600012],
              [30.307379598000068, 51.40960215300002],
              [30.320195353000145, 51.40208323200007],
              [30.326189819000092, 51.39526194300002],
              [30.32903202300008, 51.38862152100002],
              [30.330117229000052, 51.38071502700008],
              [30.330013876000123, 51.370353903000066],
              [30.328256877000058, 51.362473247000096],
              [30.319885294000073, 51.34159596800005],
              [30.31709476700013, 51.340588277000066],
              [30.32453617400006, 51.32996877100008],
              [30.355128621000063, 51.30526743600008],
              [30.36846114100007, 51.2976710010001],
              [30.383757365000122, 51.293924459],
              [30.413522990000047, 51.29405365000012],
              [30.428095744000075, 51.29175404900009],
              [30.44277185100009, 51.283046570000025],
              [30.46504439300014, 51.261936748],
              [30.480702351000048, 51.258862],
              [30.494654989000082, 51.25992136700005],
              [30.508090861000085, 51.25767344200004],
              [30.52080326400005, 51.25240244600009],
              [30.532017050000036, 51.24462514300008],
              [30.539613484000085, 51.2351683560001],
              [30.550672242000076, 51.23679616300005],
              [30.55465684400008, 51.24250742700009],
              [30.55532312000014, 51.24346242300008],
              [30.556615031000092, 51.26731109600006],
              [30.55935388200004, 51.269326478],
              [30.577233928000112, 51.28901519800006],
              [30.579921102000128, 51.30366546700013],
              [30.610461874000123, 51.31754058900002],
              [30.638315470000123, 51.33585988400007],
              [30.632424357000104, 51.364101054000045],
              [30.64555017100008, 51.36746002300008],
              [30.6445166420001, 51.37267934200007],
              [30.6374886480001, 51.378596293],
              [30.632424357000104, 51.38397064200005],
              [30.622605835000115, 51.412108460000084],
              [30.618161661000045, 51.4187230430001],
              [30.60601770000011, 51.42456248000009],
              [30.59557906100008, 51.42495005299999],
              [30.587879272000066, 51.427353008000054],
              [30.58400354000014, 51.43921274900005],
              [30.58601892100006, 51.451847636000096],
              [30.593563680000045, 51.458901470000015],
              [30.604829142000085, 51.46122690900005],
              [30.618161661000045, 51.459650778000096],
              [30.618161661000045, 51.467143861000054],
              [30.607619670000076, 51.46983103500007],
              [30.597284383000044, 51.474275208000094],
              [30.58891280100005, 51.48181996700005],
              [30.58400354000014, 51.49383473800002],
              [30.589739624000117, 51.501973776000014],
              [30.58539880300009, 51.50938934400004],
              [30.575063517000103, 51.516055603000055],
              [30.562867880000113, 51.52176584900009],
              [30.571446167000147, 51.52641672800006],
              [30.5764071050001, 51.53111928400004],
              [30.58400354000014, 51.54225555400005],
              [30.567415405000133, 51.54726816900002],
              [30.534135783000067, 51.55326263500005],
              [30.52256026200007, 51.56271942200003],
              [30.52256026200007, 51.5689205930001],
              [30.527727905000063, 51.57129770900006],
              [30.53108687400004, 51.5733130900001],
              [30.535272665000093, 51.57501841200006],
              [30.543127482000045, 51.57638783800003],
              [30.543127482000045, 51.582589010000035],
              [30.53454919400008, 51.585844626],
              [30.51511885600013, 51.596257427000026],
              [30.51511885600013, 51.603672994000036],
              [30.543850952000128, 51.62013193800003],
              [30.556615031000092, 51.62362009700006],
              [30.55284265100005, 51.633335267000106],
              [30.54994877100006, 51.637185160000044],
              [30.55532312000014, 51.63976898300005],
              [30.56348799600005, 51.647313742],
              [30.57030928600011, 51.651499533000035],
              [30.564314819000117, 51.66529714000008],
              [30.575993693000044, 51.68640696200002],
              [30.57030928600011, 51.699920349000095],
              [30.582814982000116, 51.70229746500006],
              [30.613820842000052, 51.70291758300003],
              [30.62498295100005, 51.70609568300007],
              [30.6305640060001, 51.715604147000064],
              [30.632010946000094, 51.72798065200003],
              [30.635059855000122, 51.739685364000096],
              [30.64617028800012, 51.747075094000095],
              [30.64617028800012, 51.754542338000036],
              [30.63810876500014, 51.75511077900008],
              [30.618161661000045, 51.761337789],
              [30.630460653000057, 51.77001943000003],
              [30.65278487100005, 51.779140320000025],
              [30.67056156400008, 51.790534974000124],
              [30.669631388000084, 51.806063742000035],
              [30.66229333500013, 51.81559804300012],
              [30.661983277000047, 51.81942209900008],
              [30.666324096000096, 51.82239349400008],
              [30.672731975000147, 51.829602356000024],
              [30.694539429000088, 51.84727569600004],
              [30.697329956000146, 51.85073801700007],
              [30.70280765800004, 51.853761089],
              [30.707561890000136, 51.86037567199999],
              [30.713969767000037, 51.86696441700009],
              [30.734536987000126, 51.87373403000002],
              [30.737224162000075, 51.88223480300003],
              [30.737844279000058, 51.89158823700008],
              [30.7416683350001, 51.8979186000001],
              [30.74972985900007, 51.89962392200006],
              [30.779495483000062, 51.8979186000001],
              [30.78817712400013, 51.90060577400003],
              [30.79706547000012, 51.90672943200009],
              [30.810604696000098, 51.91838246700006],
              [30.810604696000098, 51.9251779180001],
              [30.805230347000133, 51.92933787100013],
              [30.802543172000128, 51.935539042000116],
              [30.803059937000057, 51.9391305540001],
              [30.831378621000056, 51.94590016700003],
              [30.845641317000116, 51.95135203100001],
              [30.858043660000078, 51.95763071800012],
              [30.86910241700008, 51.96502044700013],
              [30.87933435000008, 51.973650411000065],
              [30.879644409000093, 51.97688018800004],
              [30.87902429200011, 51.98202199300006],
              [30.880884643000115, 51.98817148900012],
              [30.888739461000057, 51.9943468230001],
              [30.89690433800007, 51.99832590800007],
              [30.902795451000145, 51.999979554000035],
              [30.908376505000092, 51.99835174600007],
              [30.91519779500004, 51.99258982300002],
              [30.94124271600009, 51.99380422000006],
              [30.95013106300013, 52.00677500400006],
              [30.94051924700011, 52.0200816860001],
              [30.91127038600007, 52.022562154000056],
              [30.914629354000056, 52.02757476800012],
              [30.916851440000073, 52.032354839000035],
              [30.91974532100005, 52.03726409900007],
              [30.92470625800013, 52.04227671300002],
              [30.91881514500011, 52.05917490600011],
              [30.934421428000064, 52.069716899000085],
              [30.95932946700009, 52.07467783600002],
              [31.096323690000133, 52.07961293600006],
              [31.134822632000123, 52.07666737900006],
              [31.15921390800014, 52.06811492900003],
              [31.204895874000044, 52.04393035900007],
              [31.228977091000104, 52.03822011400011],
              [31.252438191000067, 52.04449880000003],
              [31.268871297000146, 52.061241964000075],
              [31.28427087400013, 52.081240743000095],
              [31.304424683000093, 52.097492981000116],
              [31.383076213000038, 52.11749176100007],
              [31.474853556000085, 52.11777598100004],
              [31.649933309000062, 52.09684702600005],
              [31.76434493000005, 52.10056772900005],
            ],
          ],
          [
            [
              [29.918711785000085, 45.690659898000035],
              [30.075694207000083, 45.79242584800005],
              [30.125987175000034, 45.81146881700005],
              [29.908050977000073, 45.666449286000045],
              [29.807465040000068, 45.61432526200008],
              [29.73096764400009, 45.59137604400007],
              [29.781260613000086, 45.610663153000075],
              [29.801442905000044, 45.62189362200007],
              [29.809418165000068, 45.63165924700007],
              [29.814789259000065, 45.641058661000045],
              [29.827647332000083, 45.64472077000005],
              [29.84310957100007, 45.646185614000046],
              [29.856700066000087, 45.64911530200004],
              [29.87273196700005, 45.658270575000074],
              [29.901621941000087, 45.68048737200007],
              [29.918711785000085, 45.690659898000035],
            ],
          ],
          [
            [
              [32.989268425000034, 46.042629299000055],
              [32.99935957100007, 46.03530508000006],
              [33.04509524800005, 46.03790924700007],
              [33.05746504000007, 46.02521393400008],
              [33.040049675000034, 46.012152411000045],
              [32.61939537900008, 46.06000397300005],
              [32.62671959700009, 46.06590403900009],
              [32.63135826900009, 46.06622955900008],
              [32.639333530000044, 46.06000397300005],
              [32.783213738000086, 46.04633209800005],
              [32.85206139400009, 46.056301174000055],
              [32.88168379000007, 46.05540599200003],
              [32.91358483200008, 46.03880442900004],
              [32.95484459700009, 46.05174388200004],
              [32.97868899800005, 46.05329010600008],
              [32.989268425000034, 46.042629299000055],
            ],
          ],
          [
            [
              [31.940277540000068, 46.20457591400009],
              [32.07081139400009, 46.18244049700007],
              [32.153086785000085, 46.15599192900004],
              [32.16627037900008, 46.14935944200005],
              [32.14389082100007, 46.15265534100007],
              [32.10181725400008, 46.16669342700004],
              [31.737152540000068, 46.220770575000074],
              [31.580332879000082, 46.26276276200008],
              [31.549001498000052, 46.282416083000044],
              [31.52198326900009, 46.31321849200003],
              [31.514008009000065, 46.329413153000075],
              [31.505056186000047, 46.35492584800005],
              [31.50440514400009, 46.37335846600007],
              [31.52198326900009, 46.368475653000075],
              [31.53842207100007, 46.325832424000055],
              [31.55437259200005, 46.29633209800005],
              [31.577972852000073, 46.27558014500005],
              [31.618174675000034, 46.25922272300005],
              [31.940277540000068, 46.20457591400009],
            ],
          ],
          // Crimea is Ukraine!
          [
            [
              [33.628517493895586, 46.12493524180271],
              [33.660449051382614, 46.148184276483164],
              [33.6714563305452, 46.17295065684732],
              [33.66162330786932, 46.21017049727061],
              [33.67027978528387, 46.21810560059299],
              [33.71572629013616, 46.1957430352129],
              [33.755206645770045, 46.1933715535543],
              [33.801878173838645, 46.20270585898817],
              [33.84621612577354, 46.19570512968795],
              [33.89288765294282, 46.17703651882027],
              [33.94422633417798, 46.15370075478597],
              [33.99089786134721, 46.13036499075167],
              [34.02590150784829, 46.11636353305056],
              [34.06790588275027, 46.10469565058378],
              [34.10524310448568, 46.09536134514991],
              [34.16124893798809, 46.090694192882665],
              [34.20091973675642, 46.10002849831653],
              [34.23592338235818, 46.09769492128356],
              [34.27326060499291, 46.08369346358245],
              [34.30126352129446, 46.069692004982016],
              [34.33393359166189, 46.069692004982016],
              [34.361936507963435, 46.055690546381584],
              [34.37827154269752, 46.03002120621369],
              [34.39227300129795, 46.00901901921236],
              [34.41094161216563, 45.98801683131171],
              [34.43427737619993, 45.97168179657763],
              [34.464613869534446, 45.95534676184354],
              [34.504284667403454, 45.95067960867698],
              [34.52061970213754, 45.969348220443976],
              [34.52995400847067, 45.981016102011495],
              [34.56962480633973, 45.97634894974419],
              [34.59996129967419, 45.97868252587784],
              [34.64196567457623, 45.981016102011495],
              [34.68863720264477, 45.97401537271128],
              [34.735308730713314, 45.95301318570995],
              [34.76331164701486, 45.9320109978093],
              [34.78431383491551, 45.89934092834113],
              [34.78431383491551, 45.86900443500667],
              [34.78431383491551, 45.82933363713761],
              [34.78898098718281, 45.803664296070394],
              [34.80998317508346, 45.78499568520266],
              [34.870656160853116, 45.7733278036352],
              [34.91732768892166, 45.74765846256798],
              [34.95233133452342, 45.72198912240003],
              [34.97566709855772, 45.71732197013279],
              [35.00189122179862, 45.729002575039836],
              [35.04444420700008, 45.67007070500006],
              [35.33220462300005, 45.37124258000006],
              [35.48072350400008, 45.29779694200005],
              [35.51783287900008, 45.29547760600008],
              [35.69499759200005, 45.33038971600007],
              [35.71599368600005, 45.34056224200003],
              [35.74333743600005, 45.36107005400004],
              [35.74740644600007, 45.370754299000055],
              [35.74854576900009, 45.37970612200007],
              [35.752940300000034, 45.386419989000046],
              [35.76742597700007, 45.38898346600007],
              [35.77271569100009, 45.392279364000046],
              [35.78842207100007, 45.407456773000035],
              [35.791758660000085, 45.41229889500005],
              [35.794932488000086, 45.430568752000056],
              [35.80396569100009, 45.44916413000004],
              [35.817149285000085, 45.464056708000044],
              [35.83326256600009, 45.47089264500005],
              [35.85767662900008, 45.46942780200004],
              [35.860036655000044, 45.45954010600008],
              [35.852224155000044, 45.44415924700007],
              [35.84693444100009, 45.42625560100004],
              [35.85401451900009, 45.41400788000004],
              [35.871104363000086, 45.40412018400008],
              [35.94662519600007, 45.37213776200008],
              [35.98601321700005, 45.36273834800005],
              [36.02230879000007, 45.36810944200005],
              [36.051768425000034, 45.39520905200004],
              [36.06527754000007, 45.425482489000046],
              [36.06885826900009, 45.42999909100007],
              [36.096364780000044, 45.44196198100008],
              [36.117930535000085, 45.457098700000074],
              [36.137461785000085, 45.46206289300005],
              [36.25245201900009, 45.46149323100008],
              [36.26783287900008, 45.467230536000045],
              [36.28402754000007, 45.476629950000074],
              [36.29997806100005, 45.47333405200004],
              [36.307383660000085, 45.460923570000034],
              [36.298838738000086, 45.443019924000055],
              [36.31169681100005, 45.44350820500006],
              [36.321055535000085, 45.44839101800005],
              [36.32976321700005, 45.45425039300005],
              [36.340505405000044, 45.45726146000004],
              [36.35962975400008, 45.45449453300006],
              [36.391368035000085, 45.43964264500005],
              [36.41179446700005, 45.43622467700004],
              [36.47055097700007, 45.44578685100004],
              [36.490570509000065, 45.443019924000055],
              [36.51587975400008, 45.41974518400008],
              [36.53296959700009, 45.40892161700003],
              [36.54859459700009, 45.41229889500005],
              [36.56666100400008, 45.42519765800006],
              [36.58326256600009, 45.427394924000055],
              [36.59880618600005, 45.421210028000075],
              [36.61353600400008, 45.40888092700004],
              [36.63111412900008, 45.37474192900004],
              [36.63835696700005, 45.351263739000046],
              [36.630869988000086, 45.34056224200003],
              [36.598317905000044, 45.33429596600007],
              [36.58619225400008, 45.33380768400008],
              [36.574880405000044, 45.33608633000006],
              [36.54517662900008, 45.34739817900004],
              [36.521820509000065, 45.34992096600007],
              [36.50245201900009, 45.346869208000044],
              [36.489268425000034, 45.33633047100005],
              [36.484385613000086, 45.316392320000034],
              [36.48796634200005, 45.30931224200003],
              [36.49439537900008, 45.30524323100008],
              [36.49724368600005, 45.30072663000004],
              [36.490570509000065, 45.292181708000044],
              [36.48210696700005, 45.28880442900004],
              [36.459320509000065, 45.28774648600006],
              [36.45036868600005, 45.28534577000005],
              [36.43726647200009, 45.27204010600008],
              [36.42603600400008, 45.25153229400007],
              [36.417979363000086, 45.22992584800005],
              [36.40943444100009, 45.171128648000035],
              [36.408864780000044, 45.14948151200008],
              [36.414805535000085, 45.12836334800005],
              [36.44223066500007, 45.10651276200008],
              [36.45533287900008, 45.09162018400008],
              [36.45337975400008, 45.07648346600007],
              [36.440114780000044, 45.06745026200008],
              [36.367849155000044, 45.04877350500004],
              [36.27849368600005, 45.04584381700005],
              [36.26775149800005, 45.04368724200003],
              [36.257823113000086, 45.03896719000005],
              [36.253916863000086, 45.033189195000034],
              [36.24822024800005, 45.01609935100004],
              [36.24431399800005, 45.010972398000035],
              [36.224619988000086, 45.007513739000046],
              [36.13599694100009, 45.02142975500004],
              [36.079112175000034, 45.04637278900009],
              [36.079112175000034, 45.03896719000005],
              [36.047862175000034, 45.04877350500004],
              [36.025401238000086, 45.032904364000046],
              [36.008474155000044, 45.009751695000034],
              [35.99341881600009, 44.99799225500004],
              [35.91684004000007, 45.00141022300005],
              [35.847992384000065, 44.99241771000004],
              [35.82781009200005, 44.999212958000044],
              [35.819021030000044, 45.021551825000074],
              [35.81299889400009, 45.03164297100005],
              [35.783213738000086, 45.057521877000056],
              [35.77116946700005, 45.065619208000044],
              [35.70639082100007, 45.09467194200005],
              [35.63404381600009, 45.11469147300005],
              [35.590586785000085, 45.11985911700003],
              [35.54737389400009, 45.11969635600008],
              [35.506195509000065, 45.11351146000004],
              [35.46957441500007, 45.10101959800005],
              [35.416758660000085, 45.07086823100008],
              [35.40805097700007, 45.062486070000034],
              [35.40552819100009, 45.05097077000005],
              [35.400401238000086, 45.04287344000005],
              [35.39730879000007, 45.03506094000005],
              [35.40064537900008, 45.024644273000035],
              [35.40650475400008, 45.02008698100008],
              [35.43539472700007, 45.010972398000035],
              [35.43539472700007, 45.00482819200005],
              [35.42212975400008, 45.000433661000045],
              [35.389414910000085, 45.001939195000034],
              [35.374034050000034, 44.99799225500004],
              [35.36215254000007, 44.98655833500004],
              [35.36060631600009, 44.97357819200005],
              [35.367198113000086, 44.943345445000034],
              [35.319346550000034, 44.970038153000075],
              [35.31527754000007, 44.966050523000035],
              [35.30494225400008, 44.960923570000034],
              [35.29818769600007, 44.956366278000075],
              [35.27320397200009, 44.96698639500005],
              [35.25603274800005, 44.958685614000046],
              [35.233164910000085, 44.92568594000005],
              [35.21509850400008, 44.91437409100007],
              [35.171885613000086, 44.90717194200005],
              [35.154307488000086, 44.90110911700003],
              [35.12973066500007, 44.86859772300005],
              [35.108409050000034, 44.82493724200003],
              [35.080821160000085, 44.79376862200007],
              [35.03760826900009, 44.79877350500004],
              [35.02702884200005, 44.80939362200007],
              [35.01783287900008, 44.82318756700005],
              [35.00570722700007, 44.835191148000035],
              [34.98601321700005, 44.840277411000045],
              [34.95248457100007, 44.84153880400004],
              [34.942067905000044, 44.840277411000045],
              [34.93018639400009, 44.83612702000005],
              [34.922618035000085, 44.83087799700007],
              [34.916026238000086, 44.82534414300005],
              [34.90788821700005, 44.82050202000005],
              [34.88990319100009, 44.81810130400004],
              [34.85718834700009, 44.82371653900009],
              [34.84262129000007, 44.81671784100007],
              [34.826508009000065, 44.811835028000075],
              [34.75700931100005, 44.82050202000005],
              [34.72095787900008, 44.810980536000045],
              [34.65064537900008, 44.77728913000004],
              [34.61304772200009, 44.76520416900007],
              [34.533213738000086, 44.75291575700004],
              [34.500010613000086, 44.742621161000045],
              [34.475271030000044, 44.72361888200004],
              [34.47437584700009, 44.72638580900008],
              [34.47437584700009, 44.72890859600005],
              [34.473317905000044, 44.73029205900008],
              [34.46900475400008, 44.729803778000075],
              [34.42937259200005, 44.68964264500005],
              [34.42400149800005, 44.68268463700008],
              [34.41431725400008, 44.67377350500004],
              [34.38021894600007, 44.63133372600004],
              [34.34115644600007, 44.55849844000005],
              [34.33130944100009, 44.54547760600008],
              [34.32276451900009, 44.54352448100008],
              [34.30030358200008, 44.54559967700004],
              [34.286143425000034, 44.54539622600004],
              [34.275401238000086, 44.54637278900009],
              [34.27100670700008, 44.54547760600008],
              [34.26612389400009, 44.54193756700005],
              [34.26579837300005, 44.53896719000005],
              [34.26612389400009, 44.53583405200004],
              [34.26351972700007, 44.53188711100006],
              [34.242930535000085, 44.507473049000055],
              [34.22982832100007, 44.49990469000005],
              [34.18246504000007, 44.49282461100006],
              [34.17009524800005, 44.481634833000044],
              [34.160817905000044, 44.466457424000055],
              [34.147471550000034, 44.44989655200004],
              [34.13648522200009, 44.44196198100008],
              [34.102549675000034, 44.425116278000075],
              [34.08871504000007, 44.42202383000006],
              [34.06576582100007, 44.419623114000046],
              [33.95785566500007, 44.38300202000005],
              [33.93775475400008, 44.38104889500005],
              [33.91488691500007, 44.38377513200004],
              [33.85206139400009, 44.40151601800005],
              [33.83961022200009, 44.40119049700007],
              [33.81861412900008, 44.39598216400009],
              [33.807627800000034, 44.39468008000006],
              [33.741221550000034, 44.39590078300006],
              [33.72095787900008, 44.399644273000035],
              [33.64535566500007, 44.425116278000075],
              [33.63168379000007, 44.43431224200003],
              [33.62614993600005, 44.45302969000005],
              [33.620127800000034, 44.462225653000075],
              [33.59001712300005, 44.49005768400008],
              [33.57837975400008, 44.49705638200004],
              [33.56039472700007, 44.49628327000005],
              [33.539073113000086, 44.49160390800006],
              [33.517588738000086, 44.49054596600007],
              [33.49952233200008, 44.50079987200007],
              [33.48715254000007, 44.51032135600008],
              [33.379649285000085, 44.564520575000074],
              [33.37232506600009, 44.57648346600007],
              [33.37134850400008, 44.587958075000074],
              [33.371104363000086, 44.58844635600008],
              [33.375010613000086, 44.58539459800005],
              [33.40544681100005, 44.59023672100005],
              [33.41382897200009, 44.59332916900007],
              [33.435883009000065, 44.60529205900008],
              [33.44499759200005, 44.60691966400009],
              [33.46648196700005, 44.60578034100007],
              [33.47738691500007, 44.606634833000044],
              [33.48552493600005, 44.61033763200004],
              [33.500010613000086, 44.61391836100006],
              [33.551117384000065, 44.61465078300006],
              [33.57154381600009, 44.62055084800005],
              [33.55779056100005, 44.624335028000075],
              [33.52515709700009, 44.62885163000004],
              [33.516286655000044, 44.63426341400009],
              [33.51482181100005, 44.64911530200004],
              [33.52361087300005, 44.661444403000075],
              [33.53565514400009, 44.67218659100007],
              [33.54420006600009, 44.68268463700008],
              [33.54835045700008, 44.69867584800005],
              [33.54672285200007, 44.70954010600008],
              [33.53679446700005, 44.729803778000075],
              [33.53044681100005, 44.75731028900009],
              [33.52515709700009, 44.77240631700005],
              [33.516286655000044, 44.78510163000004],
              [33.524180535000085, 44.78969961100006],
              [33.527679884000065, 44.79319896000004],
              [33.53052819100009, 44.79877350500004],
              [33.53736412900008, 44.81899648600006],
              [33.54607181100005, 44.83690013200004],
              [33.559580925000034, 44.84975820500006],
              [33.598317905000044, 44.85932038000004],
              [33.60922285200007, 44.87173086100006],
              [33.61605879000007, 44.889105536000045],
              [33.619883660000085, 44.908636786000045],
              [33.61963951900009, 44.93146393400008],
              [33.60857181100005, 44.97060781500005],
              [33.60564212300005, 44.98745351800005],
              [33.60279381600009, 44.993394273000035],
              [33.58521569100009, 45.018459377000056],
              [33.58179772200009, 45.02749258000006],
              [33.57837975400008, 45.05320872600004],
              [33.562510613000086, 45.09393952000005],
              [33.537445509000065, 45.11737702000005],
              [33.469086134000065, 45.14883047100005],
              [33.41342207100007, 45.18451569200005],
              [33.396494988000086, 45.18976471600007],
              [33.35515384200005, 45.18573639500005],
              [33.31763756600009, 45.175482489000046],
              [33.28256269600007, 45.16054922100005],
              [33.25961347700007, 45.15607330900008],
              [33.24935957100007, 45.16559479400007],
              [33.24008222700007, 45.17963288000004],
              [33.21851647200009, 45.18744538000004],
              [33.17359459700009, 45.196600653000075],
              [33.15837649800005, 45.20677317900004],
              [33.12330162900008, 45.23786041900007],
              [33.09848066500007, 45.248114325000074],
              [33.09001712300005, 45.25665924700007],
              [33.07862389400009, 45.27167389500005],
              [33.069346550000034, 45.276556708000044],
              [33.051768425000034, 45.28164297100005],
              [33.04322350400008, 45.28534577000005],
              [32.976573113000086, 45.32566966400009],
              [32.94060306100005, 45.34251536700003],
              [32.89926191500007, 45.35423411700003],
              [32.75017337300005, 45.363348700000074],
              [32.728526238000086, 45.36107005400004],
              [32.71273847700007, 45.353176174000055],
              [32.67741946700005, 45.32599518400008],
              [32.663096550000034, 45.32013580900008],
              [32.59148196700005, 45.32013580900008],
              [32.57016035200007, 45.32518138200004],
              [32.53541100400008, 45.33803945500006],
              [32.51286868600005, 45.34056224200003],
              [32.48585045700008, 45.39492422100005],
              [32.48161868600005, 45.40888092700004],
              [32.495127800000034, 45.435532945000034],
              [32.52515709700009, 45.45815664300005],
              [32.643565300000034, 45.52167389500005],
              [32.663096550000034, 45.52558014500005],
              [32.686208530000044, 45.527004299000055],
              [32.70484459700009, 45.53107330900008],
              [32.72046959700009, 45.53733958500004],
              [32.734711134000065, 45.54539622600004],
              [32.74382571700005, 45.55288320500006],
              [32.74976647200009, 45.55963776200008],
              [32.757823113000086, 45.56464264500005],
              [32.77295983200008, 45.56655508000006],
              [32.78305097700007, 45.56537506700005],
              [32.80241946700005, 45.560248114000046],
              [32.81397545700008, 45.55906810100004],
              [32.82789147200009, 45.56240469000005],
              [32.82976321700005, 45.57021719000005],
              [32.82642662900008, 45.579413153000075],
              [32.824880405000044, 45.58698151200008],
              [32.82699629000007, 45.59552643400008],
              [32.830739780000044, 45.60101959800005],
              [32.83773847700007, 45.60809967700004],
              [32.868174675000034, 45.630072333000044],
              [32.93677819100009, 45.66250234600005],
              [33.16342207100007, 45.73627350500004],
              [33.176117384000065, 45.74310944200005],
              [33.18100019600007, 45.755194403000075],
              [33.176442905000044, 45.75893789300005],
              [33.166758660000085, 45.762600002000056],
              [33.159190300000034, 45.76850006700005],
              [33.16065514400009, 45.77879466400009],
              [33.16920006600009, 45.784409898000035],
              [33.17855879000007, 45.78025950700004],
              [33.19483483200008, 45.76512278900009],
              [33.23015384200005, 45.75092194200005],
              [33.26539147200009, 45.75381094000005],
              [33.33814537900008, 45.78563060100004],
              [33.37427819100009, 45.796535549000055],
              [33.379649285000085, 45.80304596600007],
              [33.41000410200007, 45.826605536000045],
              [33.42497806100005, 45.830959377000056],
              [33.46697024800005, 45.85008372600004],
              [33.48218834700009, 45.85447825700004],
              [33.48951256600009, 45.85236237200007],
              [33.50766035200007, 45.842962958000044],
              [33.519867384000065, 45.84088776200008],
              [33.53012129000007, 45.841864325000074],
              [33.55420983200008, 45.84707265800006],
              [33.57837975400008, 45.86815013200004],
              [33.598643425000034, 45.877386786000045],
              [33.61019941500007, 45.88076406500005],
              [33.619883660000085, 45.88182200700004],
              [33.63038170700008, 45.88003164300005],
              [33.641612175000034, 45.87604401200008],
              [33.65056399800005, 45.87067291900007],
              [33.65406334700009, 45.864447333000044],
              [33.658946160000085, 45.85932038000004],
              [33.67017662900008, 45.85854726800005],
              [33.69166100400008, 45.86074453300006],
              [33.69312584700009, 45.87254466400009],
              [33.69109134200005, 45.89622630400004],
              [33.69353274800005, 45.914496161000045],
              [33.70866946700005, 45.90973541900007],
              [33.725271030000044, 45.916083075000074],
              [33.75945071700005, 45.92226797100005],
              [33.77702884200005, 45.92963288000004],
              [33.75863691500007, 45.94086334800005],
              [33.73959394600007, 45.94782135600008],
              [33.68246504000007, 45.95844147300005],
              [33.657237175000034, 45.95693594000005],
              [33.64584394600007, 45.953558661000045],
              [33.639008009000065, 45.947333075000074],
              [33.63200931100005, 45.94440338700008],
              [33.619883660000085, 45.95075104400007],
              [33.63843834700009, 45.96824778900009],
              [33.646820509000065, 45.979722398000035],
              [33.643565300000034, 45.98493073100008],
              [33.63200931100005, 45.988267320000034],
              [33.63111412900008, 45.996527411000045],
              [33.63648522200009, 46.00641510600008],
              [33.643565300000034, 46.014960028000075],
              [33.64226321700005, 46.02216217700004],
              [33.629567905000044, 46.05658600500004],
              [33.627940300000034, 46.06781647300005],
              [33.63884524800005, 46.07831452000005],
              [33.648448113000086, 46.09003327000005],
              [33.643565300000034, 46.104681708000044],
              [33.628517493895586, 46.12493524180271],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Belarus',
        iso3: 'BLR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [23.606238241000142, 51.517399191000024],
            [23.602310832000057, 51.53078338700006],
            [23.588668253000066, 51.53589935300003],
            [23.57275191200003, 51.53967173300005],
            [23.560349569000067, 51.555303854],
            [23.56717085700012, 51.554890442],
            [23.57399214700007, 51.555303854],
            [23.55208133900004, 51.578816631000095],
            [23.543399699000076, 51.592743429000066],
            [23.539885702000106, 51.60710947800008],
            [23.54515669700004, 51.6341104130001],
            [23.543813110000087, 51.64379974400005],
            [23.53244429500009, 51.651499533000035],
            [23.53244429500009, 51.65896677700006],
            [23.54143599400004, 51.659741923000084],
            [23.547533813000086, 51.66206736300002],
            [23.560349569000067, 51.6719634],
            [23.555388631000113, 51.67630422000009],
            [23.549290812000066, 51.68320302300005],
            [23.546086873000093, 51.68963673900002],
            [23.550014282000063, 51.69242726700007],
            [23.55921268700007, 51.69516611800002],
            [23.556938924000036, 51.70139312700009],
            [23.550220988000035, 51.708421122000104],
            [23.546603637000118, 51.71358876600003],
            [23.55228804500007, 51.73663645500007],
            [23.556318806000064, 51.74735931400009],
            [23.560349569000067, 51.754542338000036],
            [23.577299439000086, 51.766686300000046],
            [23.598280070000072, 51.774670309],
            [23.617503703000096, 51.786504212000025],
            [23.628665812000122, 51.809758606000045],
            [23.610269002000024, 51.82518402100003],
            [23.594559367000073, 51.84329661100004],
            [23.6057214760001, 51.85159067800002],
            [23.609855591000013, 51.873268942],
            [23.621844523000078, 51.87742889400003],
            [23.62132775800012, 51.88202809700009],
            [23.62060428900014, 51.88321665500008],
            [23.618847290000076, 51.883268332000014],
            [23.614919881000105, 51.88425018400007],
            [23.621431111000078, 51.89556732200005],
            [23.622154582000064, 51.92794260700005],
            [23.628665812000122, 51.94633941700006],
            [23.647579386000075, 51.97408966100009],
            [23.660705200000052, 51.98687957800006],
            [23.676414835000088, 51.99408844000003],
            [23.664942668000094, 52.01116750100006],
            [23.650783325000134, 52.048942973000024],
            [23.642515096000096, 52.06139699400002],
            [23.641481567000113, 52.07292083800006],
            [23.637450806000118, 52.084470521000085],
            [23.62525516800011, 52.089715678000104],
            [23.615850057000046, 52.092299500000095],
            [23.609855591000013, 52.09862986200004],
            [23.604791301000148, 52.10676890100005],
            [23.598176717000058, 52.114520366000036],
            [23.57936649600012, 52.12154836100005],
            [23.531927531000036, 52.12064402300011],
            [23.51249719200007, 52.12444224100004],
            [23.484695272000096, 52.15862620100005],
            [23.48872603300009, 52.16214019900009],
            [23.491516561000054, 52.17410329200003],
            [23.48769250500004, 52.18162221300007],
            [23.47094934100008, 52.17162282400007],
            [23.464334757000074, 52.17635121700006],
            [23.45441288200007, 52.18146718400003],
            [23.450485474000118, 52.18591135700005],
            [23.436739542000083, 52.17567942400005],
            [23.42723107900011, 52.17679046700006],
            [23.418239380000045, 52.18250071200002],
            [23.40573368400007, 52.18591135700005],
            [23.39136763500005, 52.18250071200002],
            [23.388473755000064, 52.18415435800007],
            [23.395811808000076, 52.19337860100008],
            [23.395811808000076, 52.19957977300005],
            [23.374831177000146, 52.20094919900002],
            [23.312716105000078, 52.21528940800003],
            [23.29959029200012, 52.22342844600003],
            [23.284190715000136, 52.219733582000046],
            [23.21225712100008, 52.23167083700007],
            [23.189726196000066, 52.24053334600008],
            [23.197684367000136, 52.25831003900002],
            [23.19448042800005, 52.271461690000095],
            [23.18352502400009, 52.28130605100007],
            [23.17609938200013, 52.28513571000012],
            [23.16874556500008, 52.28892832500013],
            [23.165644979000035, 52.28939341300007],
            [23.212050415000135, 52.34750356100004],
            [23.23044722500012, 52.36507354700002],
            [23.27054813700002, 52.395123394000095],
            [23.392297810000116, 52.50963836700002],
            [23.48045780500007, 52.55441599500007],
            [23.569031209000116, 52.585886943000034],
            [23.73615279200004, 52.61490325900009],
            [23.86896122200011, 52.67004201300007],
            [23.908752075000024, 52.6998593150001],
            [23.92249800600007, 52.74259572400008],
            [23.920425639000115, 52.7726245300001],
            [23.91205936700004, 52.893852641000095],
            [23.909475545000134, 52.901500753000064],
            [23.90544478300012, 52.906539205000044],
            [23.902034139000108, 52.91253367100008],
            [23.90110396300014, 52.923256532],
            [23.903894491000102, 52.93113718700003],
            [23.914953247000113, 52.94462473500009],
            [23.917950480000115, 52.95080007000006],
            [23.917537069000105, 52.95880991700004],
            [23.909062134000123, 52.98666351400003],
            [23.90895878100008, 52.993045553000044],
            [23.91133589700013, 53.00506032400001],
            [23.909682251000078, 53.012734274000096],
            [23.898210083000066, 53.02753957100002],
            [23.86792769400003, 53.05102651],
            [23.859349406, 53.067976380000104],
            [23.86069299300007, 53.08748423300001],
            [23.87030481000008, 53.101256002000056],
            [23.882397095000073, 53.113296611000024],
            [23.891388794000108, 53.12771433600004],
            [23.893662557000113, 53.151950582000026],
            [23.88312056500007, 53.163991191],
            [23.865963989000107, 53.17200103800006],
            [23.848083943000063, 53.18380910300009],
            [23.836198365000115, 53.199286195000084],
            [23.828446899000113, 53.21383311000004],
            [23.81862837700004, 53.22796661400007],
            [23.80064497900014, 53.24246185400001],
            [23.782971639000067, 53.27093556800004],
            [23.742974080000096, 53.365477600000034],
            [23.722923625000135, 53.39710357700004],
            [23.675794719000123, 53.45570465100006],
            [23.59094201600007, 53.611250712000114],
            [23.56706750400008, 53.68101389600007],
            [23.564793742000063, 53.74240549800005],
            [23.564690389000134, 53.74240549800005],
            [23.540402466000046, 53.76359283500001],
            [23.52986047400009, 53.7841600550001],
            [23.520662069000082, 53.83733510300006],
            [23.510430135000092, 53.86250152700008],
            [23.4972009680001, 53.88554921500004],
            [23.486865682000087, 53.90999216800007],
            [23.485625448000064, 53.93929270400004],
            [23.520145305000142, 53.933970032],
            [23.60995894400014, 53.90182729100006],
            [23.627115519000114, 53.898209941000076],
            [23.64261844900011, 53.8989850870001],
            [23.691917765000113, 53.911490784000094],
            [23.754446248000107, 53.916761780000044],
            [23.77180952900011, 53.924306539000085],
            [23.78720910600009, 53.92792389000006],
            [23.794133749000082, 53.92709706600003],
            [23.812117147000066, 53.920844219000045],
            [23.820592082000076, 53.91929392500002],
            [23.82834354600007, 53.92006907100004],
            [23.90472131300004, 53.946062317],
            [23.919810832000053, 53.94776763900005],
            [23.935417114000074, 53.94394358300012],
            [23.96487268000007, 53.93272979700008],
            [23.981305786000036, 53.93040435800005],
            [24.045384562000066, 53.930869446000074],
            [24.074943482000094, 53.93572703100007],
            [24.13674849500009, 53.955415752000036],
            [24.1696147050001, 53.95892974900009],
            [24.201137329000062, 53.95247019500003],
            [24.229145955000092, 53.932368063000055],
            [24.24640588400007, 53.903635967000056],
            [24.25705122900007, 53.89402415000005],
            [24.276378215000108, 53.89180206300004],
            [24.310174601000085, 53.89268056300007],
            [24.34190393100002, 53.88704783200005],
            [24.37787072800009, 53.886841126],
            [24.414044230000115, 53.89769317600006],
            [24.528662557000075, 53.95836130800002],
            [24.579098755000075, 53.97562123700003],
            [24.642970825000106, 53.98301096700003],
            [24.666845336000108, 53.993863017000066],
            [24.67056604000004, 53.994276429000095],
            [24.67428674300004, 53.993707988000025],
            [24.677904094000013, 53.99231272400006],
            [24.690823201000114, 53.972830709000064],
            [24.705602661000057, 53.9642007450001],
            [24.723896118000113, 53.963425599000104],
            [24.7886983650001, 53.96967844700002],
            [24.806371704000128, 53.97531117800004],
            [24.819084107000066, 53.99231272400006],
            [24.81918745900009, 53.99241607700007],
            [24.819290812000133, 53.992519430000115],
            [24.819394165000062, 53.99257110600003],
            [24.8213578700001, 54.01990793900005],
            [24.81246952300009, 54.038924866000016],
            [24.799033651000116, 54.056029765000076],
            [24.787148071000104, 54.077630514000035],
            [24.78249719200005, 54.09287506200009],
            [24.784254191000116, 54.09623402900009],
            [24.790558716000106, 54.09659576500009],
            [24.799447062000127, 54.103210348000076],
            [24.81815393100004, 54.11013499000008],
            [24.818670695000066, 54.113959046],
            [24.81743046000011, 54.12062530500002],
            [24.817533813000068, 54.128221741000075],
            [24.82156457500014, 54.134526266000094],
            [24.85098389500007, 54.14495112900006],
            [24.855981079000088, 54.14672190300011],
            [24.902283163000078, 54.149770813000046],
            [24.948275187000064, 54.14589508100009],
            [25.027133423000095, 54.12786000600009],
            [25.0719885660001, 54.13220082700006],
            [25.115603475000057, 54.14878896100008],
            [25.156531210000054, 54.17571238200007],
            [25.173067667000055, 54.19658966100006],
            [25.19353153500012, 54.243666891000046],
            [25.206243937000067, 54.256792705000024],
            [25.224123983000112, 54.2585497030001],
            [25.287582641000057, 54.24521718400008],
            [25.369748169000104, 54.2479043580001],
            [25.39403609200008, 54.25715443900002],
            [25.434137004000092, 54.29182932600004],
            [25.459355103000036, 54.298908997000055],
            [25.472067505000098, 54.29715199900009],
            [25.478682088000085, 54.29332794200003],
            [25.483487996000093, 54.2876952110001],
            [25.553974650000043, 54.231264548000084],
            [25.545499715000062, 54.22749216800007],
            [25.522141967000096, 54.22862904900008],
            [25.50167810000005, 54.221756084],
            [25.499300984000087, 54.2118342080001],
            [25.52338220200005, 54.20423777300003],
            [25.528963257000044, 54.19565948500009],
            [25.521728556000085, 54.188218079000094],
            [25.493203165000125, 54.182430319],
            [25.4857617590001, 54.1754023240001],
            [25.493306518000054, 54.15752227800006],
            [25.516044149000038, 54.14475820000008],
            [25.543019247000075, 54.136955058000055],
            [25.631592651000034, 54.128325094],
            [25.653503458000102, 54.128738505000015],
            [25.66394209800012, 54.132355855000114],
            [25.679755086000114, 54.14532664000002],
            [25.690607137000086, 54.14822052000001],
            [25.72812422700008, 54.14522328800011],
            [25.740009806000103, 54.146256816000076],
            [25.763057495000055, 54.15643707300005],
            [25.77101566600004, 54.17214670800011],
            [25.771945841000075, 54.217880351000034],
            [25.77504642700012, 54.2224795530001],
            [25.786828654000118, 54.23178131100012],
            [25.789205770000052, 54.23622548500002],
            [25.78662194900005, 54.242323304000095],
            [25.78176436400014, 54.24444203700007],
            [25.776286662000047, 54.245630595000094],
            [25.77225590000006, 54.24893788700008],
            [25.765641316000142, 54.25999664300009],
            [25.757786499000133, 54.26898834300003],
            [25.74889815200001, 54.276326396000016],
            [25.739286336000106, 54.28257924500012],
            [25.734738811000057, 54.28319936100009],
            [25.723266642000056, 54.2809772750001],
            [25.719235881000145, 54.28154571600005],
            [25.715411825000103, 54.285214742000036],
            [25.704766480000018, 54.30299143500007],
            [25.70176924600011, 54.31275828100003],
            [25.69598148600005, 54.32097483400007],
            [25.682338908000133, 54.32562571300012],
            [25.667352743000066, 54.32330027300007],
            [25.607408081000074, 54.30485178700006],
            [25.56399987800006, 54.30314646500001],
            [25.54229577600009, 54.308055725000045],
            [25.528653198000058, 54.32097483400007],
            [25.52999678600014, 54.34614125600008],
            [25.54880700600006, 54.36774200500007],
            [25.594695678000107, 54.40009145100005],
            [25.612575724000067, 54.42179555300005],
            [25.616296427000094, 54.44107086300009],
            [25.615572958000087, 54.46189646400005],
            [25.61991377700008, 54.48809641600006],
            [25.630869181000037, 54.50835357700008],
            [25.64616540500009, 54.52039418600005],
            [25.707350301000105, 54.54152984700009],
            [25.726470581000115, 54.55295033800009],
            [25.740423217000114, 54.568504944000026],
            [25.74559086100001, 54.58840037000003],
            [25.739906454000078, 54.60772735600007],
            [25.715101766000117, 54.643229065000114],
            [25.708383830000088, 54.663021139000094],
            [25.709520712000113, 54.67563018900002],
            [25.713861531000077, 54.68555206400002],
            [25.719132528000017, 54.694750468],
            [25.7230599370001, 54.7053441370001],
            [25.72461022900012, 54.715679423],
            [25.72119958500008, 54.76673573900008],
            [25.72430017100004, 54.7801199340001],
            [25.73494551600004, 54.78905995700005],
            [25.756752970000036, 54.80037709600002],
            [25.76657149200011, 54.80327097600009],
            [25.77339278200006, 54.80337432900002],
            [25.778457072000037, 54.80528635700004],
            [25.782901245000062, 54.813709615000036],
            [25.78228112800008, 54.82197784500009],
            [25.773702840000055, 54.84192494700001],
            [25.77225590000006, 54.850864970000046],
            [25.78269453900009, 54.86967519200003],
            [25.802538290000086, 54.88161244700008],
            [25.825792684000106, 54.891999410000025],
            [25.846669962000078, 54.90621042900007],
            [25.85307784000011, 54.91644236300006],
            [25.85483483900009, 54.92548573800009],
            [25.858452189000076, 54.93297882100005],
            [25.870234416000073, 54.938818258000126],
            [25.907854858000093, 54.948068339000045],
            [25.926148315000063, 54.94775828100005],
            [25.96252852400005, 54.94290069600005],
            [25.9811320390001, 54.94269399000008],
            [26.102571656000094, 54.95700836200008],
            [26.138641805000105, 54.96894561800012],
            [26.153627970000088, 54.978505758000026],
            [26.170324564000083, 54.99326030100009],
            [26.187837768000065, 55.00873647100012],
            [26.224631388000063, 55.05488352500005],
            [26.229385620000073, 55.06341013600009],
            [26.231245971000078, 55.075450745000055],
            [26.2303157960001, 55.100255432],
            [26.233002971000133, 55.11162424800007],
            [26.26442224100009, 55.1400979620001],
            [26.309484090000126, 55.14464548700006],
            [26.420278361000044, 55.12810903000006],
            [26.42875329600014, 55.128212382000086],
            [26.4385718180001, 55.13002105800008],
            [26.444772989000086, 55.133948466000035],
            [26.450664103000094, 55.13983958000004],
            [26.459139038000075, 55.144748841000066],
            [26.47340173300006, 55.14567901600013],
            [26.578925008000027, 55.11854888900005],
            [26.60093916800011, 55.120822652000086],
            [26.616338745000093, 55.13539540600003],
            [26.627500854000118, 55.16443756100004],
            [26.633908732000066, 55.192187806000064],
            [26.641143432000035, 55.202833151000064],
            [26.65695642100013, 55.21533884700007],
            [26.68568851700013, 55.23161692300009],
            [26.701088094000113, 55.2368362430001],
            [26.739901281000073, 55.242776403000065],
            [26.76558028100004, 55.246706442000075],
            [26.78966149900009, 55.257196758000035],
            [26.80072025600009, 55.273319804000025],
            [26.79157352700011, 55.290166321000086],
            [26.768629191000088, 55.300243225000045],
            [26.60269616700009, 55.31688303700004],
            [26.542338094000087, 55.30758127900002],
            [26.525388224000096, 55.30809804400006],
            [26.46575362200008, 55.32086212200004],
            [26.45004398600011, 55.3270632940001],
            [26.445496460000072, 55.33750193300004],
            [26.455211629000104, 55.356105449000026],
            [26.479086141000096, 55.38137522400008],
            [26.486010783000097, 55.39083201200005],
            [26.49923995000009, 55.42809071900005],
            [26.507818238000112, 55.439149475000065],
            [26.543268270000056, 55.459613342000026],
            [26.546472209000115, 55.471240540000096],
            [26.5276619870001, 55.492169495000084],
            [26.532106161000115, 55.51625071200003],
            [26.551639852000108, 55.53449249300009],
            [26.576134480000064, 55.55056386400004],
            [26.59556481900006, 55.568030498],
            [26.605176635000078, 55.59009633400008],
            [26.607657105000044, 55.61645131500005],
            [26.603833048000098, 55.64327138300003],
            [26.594531291000067, 55.66699086600006],
            [26.615615275000096, 55.68797149700008],
            [26.64010990400007, 55.69556793300005],
            [26.66687829600005, 55.693965963000025],
            [26.72010502100008, 55.68187367800003],
            [26.74304935700013, 55.68285553],
            [26.822837769000103, 55.70610992500009],
            [26.84278487200004, 55.719339092],
            [26.900145711000107, 55.778715312000045],
            [26.957816610000094, 55.81858368000006],
            [26.979425815000127, 55.82629096300006],
            [26.981071004000086, 55.826877747000125],
            [27.11077884900004, 55.836282858000075],
            [27.15144820100008, 55.83245880200003],
            [27.173203980000096, 55.825740865000014],
            [27.235525757000033, 55.795846050000094],
            [27.263017619000095, 55.787216085000054],
            [27.282447957000073, 55.79186696400011],
            [27.329163452000074, 55.817575990000094],
            [27.349627319000035, 55.83121856700011],
            [27.374587036000037, 55.814837138000044],
            [27.405851277000124, 55.8043468230001],
            [27.43882084200007, 55.798739929000064],
            [27.564601278000055, 55.79222869900009],
            [27.59271325600008, 55.79424408000004],
            [27.601498251000066, 55.809617819000024],
            [27.610128214000014, 55.83096018500002],
            [27.617156209000115, 55.87855417900006],
            [27.645009806000104, 55.922840881000084],
            [27.74443526200011, 55.959737854000124],
            [27.776991414000065, 55.99239736],
            [27.781228882000107, 56.016375224000015],
            [27.812544800000126, 56.03451365100004],
            [27.880654337000124, 56.063865866000114],
            [27.892746622000118, 56.077095032],
            [27.901531617000103, 56.08934234600004],
            [27.91145349100009, 56.100246074],
            [27.927059774000043, 56.109366964000074],
            [27.939668823000147, 56.113061829000074],
            [27.981009969000098, 56.11802276700003],
            [28.023798055000015, 56.12964996400008],
            [28.0511000380001, 56.14066599700003],
            [28.068239787000095, 56.147581686000066],
            [28.11097619600011, 56.15680592900007],
            [28.148906697000115, 56.142414043000045],
            [28.169112182000106, 56.125257467],
            [28.238461955000048, 56.08262441],
            [28.269364462000055, 56.05820729600008],
            [28.289828329000102, 56.046605937000024],
            [28.31091231300013, 56.04267852800005],
            [28.333443238000143, 56.050249125],
            [28.366516154000124, 56.079110413000066],
            [28.389770548000058, 56.088567200000014],
            [28.537823527000086, 56.09771392800009],
            [28.59471927900003, 56.092391256000056],
            [28.61146244300008, 56.088463847000085],
            [28.620712524000112, 56.08298614600001],
            [28.637093954000136, 56.06572621700012],
            [28.671923868000107, 56.03756256100006],
            [28.680605510000078, 56.0273823050001],
            [28.690010620000123, 56.00389536500002],
            [28.695488322000102, 55.98015004500006],
            [28.70639205000009, 55.95984120700005],
            [28.731920207000115, 55.94679290800009],
            [28.808969767000065, 55.934571432000084],
            [28.830880574000105, 55.937672018000015],
            [28.833050985000085, 55.96097808900005],
            [28.859716024000136, 55.97645518000006],
            [28.922141154000087, 55.992138977000124],
            [28.92224450700013, 55.99219065400003],
            [28.922451212000084, 55.99224233000005],
            [28.980845581000068, 56.013533020000025],
            [29.030765015000014, 56.024178366000044],
            [29.08864261900004, 56.02322235100006],
            [29.145435018000086, 56.01203440400003],
            [29.19292566000007, 55.992138977000124],
            [29.22403487100013, 55.978186341000125],
            [29.377410523000094, 55.95402760800006],
            [29.395600627000135, 55.94772308400006],
            [29.413067261000094, 55.9379820760001],
            [29.431567423000104, 55.92418446900005],
            [29.441075887000125, 55.91493438700006],
            [29.44443485500011, 55.90692454000008],
            [29.44055912300007, 55.90054250200005],
            [29.433737833000123, 55.899534811000066],
            [29.4255729570001, 55.899999898],
            [29.417408081000076, 55.89801035600006],
            [29.40779626500006, 55.89387624200002],
            [29.399631388000046, 55.89188669900007],
            [29.391983277000065, 55.88837270100002],
            [29.384128459000124, 55.87994944300003],
            [29.380717814000093, 55.87124196400008],
            [29.375653524000143, 55.846799012000034],
            [29.371932821000087, 55.8363862100001],
            [29.348161662000052, 55.80284820600009],
            [29.34361413500011, 55.78698354100008],
            [29.35074548300014, 55.766054586000095],
            [29.363406209000118, 55.75148183200004],
            [29.413067261000094, 55.72776235],
            [29.461022990000117, 55.68729970300008],
            [29.480866740000124, 55.68109853200009],
            [29.508100219000085, 55.6854910280001],
            [29.58535648600008, 55.738020121000076],
            [29.684161825000047, 55.77060211200002],
            [29.71082686400007, 55.77375437400009],
            [29.779866577000064, 55.76380666100009],
            [29.805704794000064, 55.77145477400005],
            [29.844772176000106, 55.812563375000124],
            [29.86947351100008, 55.8305467740001],
            [29.90781742300004, 55.84320750000005],
            [29.94771162900014, 55.848194276000115],
            [29.98822595200005, 55.846799012000034],
            [30.10625492400004, 55.82191680900006],
            [30.132351522000135, 55.826877747000125],
            [30.17725834200013, 55.85137237600007],
            [30.200254353000048, 55.85798695900006],
            [30.21777266400005, 55.8551447550001],
            [30.251517375000105, 55.837626445000055],
            [30.270792684000128, 55.830650127000055],
            [30.46881677300013, 55.793520610000044],
            [30.47739506000005, 55.78773285000007],
            [30.477808472000106, 55.779128724000046],
            [30.471814005000056, 55.77096384700003],
            [30.46928186100007, 55.762643942000054],
            [30.480702351000048, 55.753962301000016],
            [30.56958581500004, 55.72951934900006],
            [30.5801278080001, 55.724765117000075],
            [30.587465861000055, 55.718305563000015],
            [30.591599975000122, 55.70569651300009],
            [30.588396037000052, 55.696601461000014],
            [30.583745158000056, 55.688539938000034],
            [30.583745158000056, 55.679134827000084],
            [30.596354207000104, 55.665285543000024],
            [30.61661136900011, 55.65743072500008],
            [30.639142293000134, 55.65448516900007],
            [30.679966675000117, 55.65634552100009],
            [30.693712606000133, 55.65215972900005],
            [30.703324422000037, 55.64234120700009],
            [30.713039591000097, 55.62668324800002],
            [30.74218509900004, 55.59438547800006],
            [30.770710490000056, 55.591543274000074],
            [30.80409346500005, 55.60234364900002],
            [30.847656697000104, 55.61102528900007],
            [30.88615564000014, 55.600483297000025],
            [30.907121887000073, 55.577769863000086],
            [30.912820679000106, 55.57159617200007],
            [30.91974532100005, 55.53449249300009],
            [30.899384807000047, 55.499145813000084],
            [30.914370972000086, 55.49330637600009],
            [30.919435262000093, 55.492324524000125],
            [30.913234090000117, 55.479715474],
            [30.887189169000123, 55.468088277000035],
            [30.881298055000116, 55.45144846600003],
            [30.88910119700006, 55.43341339200002],
            [30.905275920000122, 55.420856018],
            [30.91860843900014, 55.40762685200009],
            [30.918298380000067, 55.387783102000114],
            [30.905947714000035, 55.37600087500003],
            [30.845641317000116, 55.35114451200006],
            [30.81122481300008, 55.323084209000044],
            [30.79716882300005, 55.30427398700003],
            [30.79427494300006, 55.28551544200003],
            [30.80409346500005, 55.2729580690001],
            [30.82135339400014, 55.26437978100007],
            [30.856803426000056, 55.25347605400002],
            [30.869825887000104, 55.241538798000065],
            [30.88651737500004, 55.20453847300003],
            [30.90072839400011, 55.19213612900005],
            [30.947237182000038, 55.171362203000015],
            [30.959794555000144, 55.16257721000004],
            [30.96118981900014, 55.15854644900013],
            [30.956848999000044, 55.149503073000076],
            [30.958812703000092, 55.14443878200008],
            [30.962223348000123, 55.14288848900007],
            [30.972455281000066, 55.14087310800004],
            [30.975039103000086, 55.13952952100006],
            [30.97948327600011, 55.13425852500002],
            [30.98403080200012, 55.13089955700012],
            [30.985477742000114, 55.125835267000056],
            [30.98062015800008, 55.1153449510001],
            [30.972661987000038, 55.10857533800005],
            [30.970284872000093, 55.10144399100001],
            [30.973075399000038, 55.09395090800008],
            [30.98062015800008, 55.086302796],
            [30.99421106000011, 55.06702748600007],
            [31.006406698000035, 55.04242950500007],
            [31.00563155100008, 55.022999167000094],
            [30.98062015800008, 55.01865834600004],
            [30.933491252000124, 55.025634664],
            [30.913234090000117, 55.024601135000026],
            [30.906619507000073, 55.012560527000076],
            [30.916954793000116, 54.99602406800007],
            [30.931424194000044, 54.98517201800003],
            [30.936075073000097, 54.973234762000075],
            [30.917368205000116, 54.953959452000035],
            [30.899488159000043, 54.94636301800007],
            [30.83861332200013, 54.939179993000025],
            [30.814842163000037, 54.928017884],
            [30.817425985000057, 54.91763092100008],
            [30.827451213000074, 54.90254140200007],
            [30.826107625000134, 54.87747833300007],
            [30.810708048000038, 54.86151031500002],
            [30.787867065000057, 54.84771270800006],
            [30.768126668000093, 54.82993601500006],
            [30.762648966000086, 54.801979065000054],
            [30.770607137000127, 54.78601104800002],
            [30.78605839000005, 54.7793447880001],
            [30.827296183000044, 54.77102488300004],
            [30.98062015800008, 54.70565419600008],
            [30.995502970000132, 54.68984120700007],
            [30.999016967000102, 54.671341044000044],
            [31.020927775000075, 54.673666484000094],
            [31.105160359000138, 54.668292135000016],
            [31.12862146000009, 54.64038686100004],
            [31.16794722500009, 54.62157664000004],
            [31.139473511000062, 54.582870992000025],
            [31.089554077000116, 54.535897116000044],
            [31.064646037000045, 54.4922822060001],
            [31.093584839000073, 54.47941477500011],
            [31.167895548000104, 54.46706410800006],
            [31.179016967000052, 54.45335277000005],
            [31.179212687000074, 54.45311147100007],
            [31.209029988000054, 54.44804718100009],
            [31.22535974100009, 54.428048402000044],
            [31.248717488000068, 54.376785380000015],
            [31.26173994900006, 54.36448639000007],
            [31.274142293000068, 54.35663157100005],
            [31.28478763800007, 54.347381490000046],
            [31.292022339000084, 54.331258444000056],
            [31.299153686000068, 54.27260569300002],
            [31.309799032000058, 54.244338685000045],
            [31.32468184400011, 54.22924916600003],
            [31.48064131700005, 54.15664377900002],
            [31.506376180000075, 54.143931376000054],
            [31.530870809000135, 54.13742014600008],
            [31.583115682000084, 54.12951365200003],
            [31.66693485500008, 54.10186676000002],
            [31.697837361000097, 54.09793935200007],
            [31.725794311000072, 54.09747426400013],
            [31.736749715000144, 54.094166972000025],
            [31.748118531000046, 54.0863121550001],
            [31.75576664200014, 54.074943339000114],
            [31.762587932000088, 54.06031890900003],
            [31.77126957200005, 54.04853668300002],
            [31.783516886000143, 54.04579783100009],
            [31.808476604000134, 54.05597808900005],
            [31.81385095200011, 54.05706329400006],
            [31.82263594500006, 54.053445944000075],
            [31.823876180000127, 54.05013865200006],
            [31.823566121000056, 54.045487773],
            [31.84651045700008, 53.99231272400006],
            [31.841446167000072, 53.984561259000046],
            [31.83968916900011, 53.97722320600006],
            [31.83927575700011, 53.969781800000035],
            [31.837932170000045, 53.96213368700005],
            [31.826460002000147, 53.940171204000094],
            [31.81013024900011, 53.882603659000054],
            [31.79256026200011, 53.85743723500009],
            [31.753802938000092, 53.819610087000044],
            [31.744656209000084, 53.7948570760001],
            [31.787289266000073, 53.79439198800007],
            [31.873175496000044, 53.77713206],
            [32.08360192900011, 53.80963653600013],
            [32.10602950000009, 53.80694936100009],
            [32.164837280000086, 53.78167958600004],
            [32.29041101000007, 53.760853984000065],
            [32.32580936700009, 53.74545440700008],
            [32.35738366700008, 53.719719544],
            [32.371801391000076, 53.714396871000034],
            [32.42156579600004, 53.71579213500003],
            [32.44213301600013, 53.71393178300012],
            [32.46156335400008, 53.70680043600008],
            [32.48058028200006, 53.69207265200008],
            [32.48781498200009, 53.68468292300007],
            [32.49019209800008, 53.67713816300004],
            [32.48781498200009, 53.66964508100007],
            [32.48058028200006, 53.6624103810001],
            [32.406114543000115, 53.63941436800006],
            [32.39908654800013, 53.635383606000076],
            [32.39800134300009, 53.62742543600011],
            [32.40110192900005, 53.60985544900005],
            [32.41148889100009, 53.582363587000074],
            [32.42942061400004, 53.56158966100013],
            [32.452933391000045, 53.54639679000009],
            [32.48058028200006, 53.53564809200007],
            [32.53080977400009, 53.521437073000115],
            [32.55427087400005, 53.51079172800003],
            [32.56987715700012, 53.49260162400007],
            [32.56987715700012, 53.492394918000016],
            [32.57680179900012, 53.486038717],
            [32.58429488200005, 53.48423004200002],
            [32.59251143400007, 53.48645212800001],
            [32.60057295800004, 53.492394918000016],
            [32.618142944000056, 53.49425526900002],
            [32.635712932000104, 53.4926533000001],
            [32.650285685000085, 53.487640687000024],
            [32.647598511000126, 53.479320780000066],
            [32.64165572100012, 53.46898549400005],
            [32.646771688000115, 53.45797841400007],
            [32.65824385500014, 53.455652975000035],
            [32.68852624500005, 53.462215882000024],
            [32.70123864700008, 53.462112529000095],
            [32.71953210400005, 53.43947825200006],
            [32.717794068000046, 53.43106187400009],
            [32.704442587000074, 53.36640777600009],
            [32.71746504700013, 53.33493682900006],
            [32.69793135600008, 53.325893454],
            [32.68180830900013, 53.32679779100003],
            [32.66671879000012, 53.33134531700007],
            [32.64987227300014, 53.333670757],
            [32.57995406100014, 53.32436899800008],
            [32.58346805800011, 53.32121673600001],
            [32.5918913160001, 53.31183746400008],
            [32.595922079000104, 53.30827179],
            [32.56915368600011, 53.29884084100003],
            [32.53732100400009, 53.2950684610001],
            [32.50564335100006, 53.297187196],
            [32.48058028200006, 53.30517120400005],
            [32.45484541900004, 53.30044281100008],
            [32.44719730600008, 53.2887639370001],
            [32.45598230000007, 53.27778269500003],
            [32.47913334200007, 53.27491465300004],
            [32.46921146700009, 53.255458476000044],
            [32.45567224100006, 53.23667409300005],
            [32.42363285300007, 53.20440216100006],
            [32.40554610200007, 53.192671611],
            [32.38911299600011, 53.1876331590001],
            [32.35283614100007, 53.180450134000054],
            [32.320279989000085, 53.162776795000056],
            [32.29516524200005, 53.140865987000026],
            [32.26798343900009, 53.124768779000036],
            [32.2156868890001, 53.12551808700003],
            [32.2105192460001, 53.121771545000016],
            [32.20907230600011, 53.11634552000005],
            [32.20669519100005, 53.11239227300008],
            [32.20648848500008, 53.109860128],
            [32.20700524900013, 53.10515757200001],
            [32.20592004400004, 53.100351665000105],
            [32.201114136000115, 53.097561138000046],
            [32.197393432000126, 53.097742005],
            [32.18860843900012, 53.099240622000096],
            [32.15233158400008, 53.09634674100003],
            [32.12654504400007, 53.08422861800004],
            [32.11729496300006, 53.08110219300006],
            [32.08277510600004, 53.081954855],
            [32.00991133700006, 53.0999640910001],
            [31.980559122000102, 53.09802622500008],
            [31.95472090700008, 53.08999054000007],
            [31.930743042000074, 53.08833689400005],
            [31.90717858800008, 53.09192840600012],
            [31.855502157000103, 53.11024770100009],
            [31.84263472500004, 53.112185567000026],
            [31.806822957000065, 53.110015157000035],
            [31.79628096600004, 53.11239227300008],
            [31.780467977000114, 53.12786936400009],
            [31.769719279000128, 53.16926218700003],
            [31.75628340600008, 53.18657379200003],
            [31.738558390000037, 53.19254241900005],
            [31.694478393000054, 53.19290415500005],
            [31.67494470200006, 53.19522959500007],
            [31.61401818900009, 53.20975067200003],
            [31.593605997000054, 53.21068084800008],
            [31.57365889500005, 53.207089336000095],
            [31.535935100000074, 53.19486785900007],
            [31.51206058800011, 53.194066875000075],
            [31.464001506000045, 53.199983826000064],
            [31.416355835000104, 53.199983826000064],
            [31.37852868600004, 53.182026265],
            [31.359925171000043, 53.133837993],
            [31.36116540600011, 53.121306458],
            [31.361573285000077, 53.120037500000095],
            [31.36488610900011, 53.109730937000066],
            [31.367056519000073, 53.09893056200012],
            [31.363697550000097, 53.08877614400005],
            [31.354137411000067, 53.08210988400005],
            [31.329436076000093, 53.0793451950001],
            [31.319204142000103, 53.0763738000001],
            [31.269284708000043, 53.02841807100005],
            [31.24706384300009, 53.01438791900004],
            [31.322614787000134, 52.97712921200012],
            [31.33915124500004, 52.95806060900004],
            [31.36622969600006, 52.9085545870001],
            [31.387933797000073, 52.887987367],
            [31.418112834000055, 52.87023651200009],
            [31.45097904400012, 52.85721405100004],
            [31.48064131700005, 52.85093536400005],
            [31.50513594600011, 52.848894145000074],
            [31.51278405700009, 52.841039328000036],
            [31.515161173000138, 52.828378602],
            [31.523946167000133, 52.811661276000066],
            [31.53836389100013, 52.79985321100007],
            [31.550559529000054, 52.794737244000075],
            [31.560843139000042, 52.78706329400008],
            [31.56952478000011, 52.76750376400007],
            [31.570248250000134, 52.725258281],
            [31.54792403200014, 52.70569875100007],
            [31.48064131700005, 52.68247019500005],
            [31.49170007300006, 52.667096457000085],
            [31.536141805000057, 52.63048370400004],
            [31.56590743000004, 52.590150248000086],
            [31.579033243000083, 52.577825419000035],
            [31.615206746000126, 52.558575949],
            [31.62864261800007, 52.54805979500004],
            [31.62430179900008, 52.538060405000024],
            [31.610762574000034, 52.53599334700006],
            [31.574382364000144, 52.54126434400008],
            [31.55929284700005, 52.5405408730001],
            [31.56363366700009, 52.53705271400004],
            [31.575932658000056, 52.524727885000104],
            [31.55815596500014, 52.519999492000025],
            [31.550559529000054, 52.51188629200003],
            [31.55298832200009, 52.502248637],
            [31.565494018000038, 52.49263682100009],
            [31.58792159000012, 52.48261159300007],
            [31.589368530000115, 52.45803944900008],
            [31.583322387000067, 52.42829966300009],
            [31.582857300000057, 52.402771505000075],
            [31.590350382000054, 52.391841940000106],
            [31.600530639000056, 52.383392843000095],
            [31.608075398000096, 52.37246327800004],
            [31.60859216300014, 52.35442820300004],
            [31.602752727000052, 52.34091481600005],
            [31.592262410000103, 52.32861582500003],
            [31.579601684000068, 52.31851308200008],
            [31.567354370000146, 52.31138173400005],
            [31.597119995000128, 52.28430328399999],
            [31.61365645300009, 52.273011984],
            [31.63143314600012, 52.26476959300008],
            [31.64869307400005, 52.26099721300004],
            [31.683419637000043, 52.257198996000014],
            [31.69943933100012, 52.25146291100005],
            [31.68889733800006, 52.24322052000012],
            [31.68192102000006, 52.230456441000044],
            [31.679492228000072, 52.21585784900007],
            [31.68238610800006, 52.2019310510001],
            [31.68951745600009, 52.19156992600007],
            [31.69871586100004, 52.185446269000025],
            [31.74904870600011, 52.16394887400007],
            [31.762587932000088, 52.14984120700005],
            [31.766618693000055, 52.13007497200006],
            [31.76434493000005, 52.10056772900005],
            [31.649933309000062, 52.09684702600005],
            [31.474853556000085, 52.11777598100004],
            [31.383076213000038, 52.11749176100007],
            [31.304424683000093, 52.097492981000116],
            [31.28427087400013, 52.081240743000095],
            [31.268871297000146, 52.061241964000075],
            [31.252438191000067, 52.04449880000003],
            [31.228977091000104, 52.03822011400011],
            [31.204895874000044, 52.04393035900007],
            [31.15921390800014, 52.06811492900003],
            [31.134822632000123, 52.07666737900006],
            [31.096323690000133, 52.07961293600006],
            [30.95932946700009, 52.07467783600002],
            [30.934421428000064, 52.069716899000085],
            [30.91881514500011, 52.05917490600011],
            [30.92470625800013, 52.04227671300002],
            [30.91974532100005, 52.03726409900007],
            [30.916851440000073, 52.032354839000035],
            [30.914629354000056, 52.02757476800012],
            [30.91127038600007, 52.022562154000056],
            [30.94051924700011, 52.0200816860001],
            [30.95013106300013, 52.00677500400006],
            [30.94124271600009, 51.99380422000006],
            [30.91519779500004, 51.99258982300002],
            [30.908376505000092, 51.99835174600007],
            [30.902795451000145, 51.999979554000035],
            [30.89690433800007, 51.99832590800007],
            [30.888739461000057, 51.9943468230001],
            [30.880884643000115, 51.98817148900012],
            [30.87902429200011, 51.98202199300006],
            [30.879644409000093, 51.97688018800004],
            [30.87933435000008, 51.973650411000065],
            [30.86910241700008, 51.96502044700013],
            [30.858043660000078, 51.95763071800012],
            [30.845641317000116, 51.95135203100001],
            [30.831378621000056, 51.94590016700003],
            [30.803059937000057, 51.9391305540001],
            [30.802543172000128, 51.935539042000116],
            [30.805230347000133, 51.92933787100013],
            [30.810604696000098, 51.9251779180001],
            [30.810604696000098, 51.91838246700006],
            [30.79706547000012, 51.90672943200009],
            [30.78817712400013, 51.90060577400003],
            [30.779495483000062, 51.8979186000001],
            [30.74972985900007, 51.89962392200006],
            [30.7416683350001, 51.8979186000001],
            [30.737844279000058, 51.89158823700008],
            [30.737224162000075, 51.88223480300003],
            [30.734536987000126, 51.87373403000002],
            [30.713969767000037, 51.86696441700009],
            [30.707561890000136, 51.86037567199999],
            [30.70280765800004, 51.853761089],
            [30.697329956000146, 51.85073801700007],
            [30.694539429000088, 51.84727569600004],
            [30.672731975000147, 51.829602356000024],
            [30.666324096000096, 51.82239349400008],
            [30.661983277000047, 51.81942209900008],
            [30.66229333500013, 51.81559804300012],
            [30.669631388000084, 51.806063742000035],
            [30.67056156400008, 51.790534974000124],
            [30.65278487100005, 51.779140320000025],
            [30.630460653000057, 51.77001943000003],
            [30.618161661000045, 51.761337789],
            [30.63810876500014, 51.75511077900008],
            [30.64617028800012, 51.754542338000036],
            [30.64617028800012, 51.747075094000095],
            [30.635059855000122, 51.739685364000096],
            [30.632010946000094, 51.72798065200003],
            [30.6305640060001, 51.715604147000064],
            [30.62498295100005, 51.70609568300007],
            [30.613820842000052, 51.70291758300003],
            [30.582814982000116, 51.70229746500006],
            [30.57030928600011, 51.699920349000095],
            [30.575993693000044, 51.68640696200002],
            [30.564314819000117, 51.66529714000008],
            [30.57030928600011, 51.651499533000035],
            [30.56348799600005, 51.647313742],
            [30.55532312000014, 51.63976898300005],
            [30.54994877100006, 51.637185160000044],
            [30.55284265100005, 51.633335267000106],
            [30.556615031000092, 51.62362009700006],
            [30.543850952000128, 51.62013193800003],
            [30.51511885600013, 51.603672994000036],
            [30.51511885600013, 51.596257427000026],
            [30.53454919400008, 51.585844626],
            [30.543127482000045, 51.582589010000035],
            [30.543127482000045, 51.57638783800003],
            [30.535272665000093, 51.57501841200006],
            [30.53108687400004, 51.5733130900001],
            [30.527727905000063, 51.57129770900006],
            [30.52256026200007, 51.5689205930001],
            [30.52256026200007, 51.56271942200003],
            [30.534135783000067, 51.55326263500005],
            [30.567415405000133, 51.54726816900002],
            [30.58400354000014, 51.54225555400005],
            [30.5764071050001, 51.53111928400004],
            [30.571446167000147, 51.52641672800006],
            [30.562867880000113, 51.52176584900009],
            [30.575063517000103, 51.516055603000055],
            [30.58539880300009, 51.50938934400004],
            [30.589739624000117, 51.501973776000014],
            [30.58400354000014, 51.49383473800002],
            [30.58891280100005, 51.48181996700005],
            [30.597284383000044, 51.474275208000094],
            [30.607619670000076, 51.46983103500007],
            [30.618161661000045, 51.467143861000054],
            [30.618161661000045, 51.459650778000096],
            [30.604829142000085, 51.46122690900005],
            [30.593563680000045, 51.458901470000015],
            [30.58601892100006, 51.451847636000096],
            [30.58400354000014, 51.43921274900005],
            [30.587879272000066, 51.427353008000054],
            [30.59557906100008, 51.42495005299999],
            [30.60601770000011, 51.42456248000009],
            [30.618161661000045, 51.4187230430001],
            [30.622605835000115, 51.412108460000084],
            [30.632424357000104, 51.38397064200005],
            [30.6374886480001, 51.378596293],
            [30.6445166420001, 51.37267934200007],
            [30.64555017100008, 51.36746002300008],
            [30.632424357000104, 51.364101054000045],
            [30.638315470000123, 51.33585988400007],
            [30.610461874000123, 51.31754058900002],
            [30.579921102000128, 51.30366546700013],
            [30.577233928000112, 51.28901519800006],
            [30.55935388200004, 51.269326478],
            [30.556615031000092, 51.26731109600006],
            [30.55532312000014, 51.24346242300008],
            [30.55465684400008, 51.24250742700009],
            [30.550672242000076, 51.23679616300005],
            [30.539613484000085, 51.2351683560001],
            [30.532017050000036, 51.24462514300008],
            [30.52080326400005, 51.25240244600009],
            [30.508090861000085, 51.25767344200004],
            [30.494654989000082, 51.25992136700005],
            [30.480702351000048, 51.258862],
            [30.46504439300014, 51.261936748],
            [30.44277185100009, 51.283046570000025],
            [30.428095744000075, 51.29175404900009],
            [30.413522990000047, 51.29405365000012],
            [30.383757365000122, 51.293924459],
            [30.36846114100007, 51.2976710010001],
            [30.355128621000063, 51.30526743600008],
            [30.32453617400006, 51.32996877100008],
            [30.31709476700013, 51.340588277000066],
            [30.319885294000073, 51.34159596800005],
            [30.328256877000058, 51.362473247000096],
            [30.330013876000123, 51.370353903000066],
            [30.330117229000052, 51.38071502700008],
            [30.32903202300008, 51.38862152100002],
            [30.326189819000092, 51.39526194300002],
            [30.320195353000145, 51.40208323200007],
            [30.307379598000068, 51.40960215300002],
            [30.25689172300008, 51.42505340600012],
            [30.24278405700005, 51.43440684000005],
            [30.205370320000043, 51.466497904000065],
            [30.177310018000128, 51.479494527],
            [30.14862959800007, 51.48442962700004],
            [30.00868981900004, 51.48207835],
            [29.985745483000073, 51.47786672000005],
            [29.92507735200013, 51.45786794100003],
            [29.91257165500008, 51.45742869100012],
            [29.896551961000057, 51.46419830400005],
            [29.88626835100007, 51.4647925820001],
            [29.87360762500009, 51.4591856900001],
            [29.856761108000057, 51.43985870400003],
            [29.8466325280001, 51.43290822400006],
            [29.828649129000098, 51.429962668000044],
            [29.737905314000045, 51.43949696900005],
            [29.72529626500011, 51.4504523720001],
            [29.71651127100006, 51.46567108200004],
            [29.69997481300004, 51.48370615700004],
            [29.682714885000053, 51.491199240000086],
            [29.660804078000126, 51.49313710600002],
            [29.637756388000128, 51.4908891810001],
            [29.61801599100005, 51.48564402300006],
            [29.597345418000145, 51.47396514900002],
            [29.583186076000118, 51.460813498000036],
            [29.568199911000136, 51.44962555000008],
            [29.54504886900014, 51.443656921000056],
            [29.5190039470001, 51.44179657000005],
            [29.505464722000113, 51.43745575000007],
            [29.49554284600009, 51.42564768500007],
            [29.480866740000124, 51.401256409000055],
            [29.46629398600004, 51.38505584800005],
            [29.446398559000045, 51.384900818000105],
            [29.40273197500011, 51.39614044200006],
            [29.37968428500011, 51.391541239],
            [29.353260212000123, 51.377055123000034],
            [29.34056522600008, 51.37009552000008],
            [29.319946330000107, 51.36557383200007],
            [29.29700199400014, 51.37371287000006],
            [29.284599650000075, 51.39174794600005],
            [29.276124716000083, 51.413581239000095],
            [29.26485925300011, 51.43290822400006],
            [29.244395386000065, 51.44789438900001],
            [29.227755574000128, 51.455620016000026],
            [29.22103763800004, 51.466962992],
            [29.230442749000076, 51.49287872300003],
            [29.226515340000105, 51.51905283600006],
            [29.214836467000055, 51.535460103],
            [29.18145349100007, 51.567008565],
            [29.16042118300004, 51.60331125900005],
            [29.147967163000146, 51.6156360880001],
            [29.123885945000012, 51.62504119900005],
            [29.083681681000087, 51.63121653300003],
            [29.06321781400004, 51.630596416000074],
            [29.04358077000009, 51.62617808100005],
            [29.02363366700007, 51.61403411900007],
            [28.999965861000135, 51.58240814200006],
            [28.980845581000068, 51.56946319700005],
            [28.954593954000103, 51.56326202400005],
            [28.892892294000063, 51.56287445100007],
            [28.863643432000117, 51.55892120400007],
            [28.831914103000088, 51.5482758590001],
            [28.79987471600009, 51.532617899000044],
            [28.77186608900007, 51.511275533000045],
            [28.752229045000036, 51.48370615700004],
            [28.749438517000073, 51.46685964000007],
            [28.75160892800008, 51.42874827100012],
            [28.74675134200004, 51.413994650000106],
            [28.728767945000072, 51.401256409000055],
            [28.718225952000097, 51.41161753400006],
            [28.71109460500014, 51.430246887000024],
            [28.70396325700011, 51.44262339300009],
            [28.691147501000046, 51.44342437800002],
            [28.67791833500013, 51.43807586700005],
            [28.66355228600014, 51.43399342900004],
            [28.647015829000054, 51.439006043000106],
            [28.63730065900012, 51.44962555000008],
            [28.630892781000057, 51.463629863000094],
            [28.615183146000106, 51.5195696010001],
            [28.61270267700013, 51.53993011500002],
            [28.603917684000123, 51.55354685500002],
            [28.578079468000112, 51.560109762000096],
            [28.488369181000053, 51.57202118000005],
            [28.46123905400006, 51.57165944400005],
            [28.435349162000136, 51.56613006600004],
            [28.38553308100009, 51.54504608200001],
            [28.359643188000064, 51.529362284000044],
            [28.34687911000009, 51.525150656],
            [28.33385664900007, 51.528380433000095],
            [28.328172241000118, 51.53636444100006],
            [28.317423543000103, 51.56395965600005],
            [28.31091231300013, 51.57444997100002],
            [28.298509969000065, 51.58297658300002],
            [28.269726196000136, 51.594267884],
            [28.257788940000097, 51.60176096600013],
            [28.249365682000104, 51.6130781050001],
            [28.248383830000137, 51.62209564200005],
            [28.248900594000077, 51.630596416000074],
            [28.245128214000147, 51.640621643000074],
            [28.230400431000135, 51.65113779700003],
            [28.210039917000103, 51.65196462100006],
            [28.187612346000037, 51.64519500800013],
            [28.166218302000118, 51.63310272300005],
            [28.146684611000097, 51.61439585400005],
            [28.1142318120001, 51.57561269100002],
            [28.090150594000136, 51.56204762800003],
            [28.070823608000097, 51.55762929300003],
            [27.97315515100007, 51.55781016100009],
            [27.954758342000048, 51.56078155500008],
            [27.936051473000077, 51.567008565],
            [27.87559004700006, 51.608039653000034],
            [27.85419600400013, 51.61532603000002],
            [27.831251668000107, 51.61292307600006],
            [27.812544800000126, 51.602019349],
            [27.799522339000077, 51.58519866900012],
            [27.79321781400006, 51.56501902300003],
            [27.793734578000112, 51.552306620000095],
            [27.796266724000105, 51.54153208500007],
            [27.797145223000115, 51.530602519000084],
            [27.792546021000078, 51.51729583800007],
            [27.78732670100007, 51.51091379800003],
            [27.74055953000007, 51.471407166000105],
            [27.73012089000011, 51.46515431700003],
            [27.7142562250001, 51.463707377000034],
            [27.700045207000045, 51.46753143300005],
            [27.68376713100011, 51.47551544300002],
            [27.67033125800009, 51.48481720000005],
            [27.666181614000095, 51.49019444700009],
            [27.664130087000103, 51.49285288500003],
            [27.697306356000098, 51.54318573000002],
            [27.705161174000125, 51.56835215300005],
            [27.69265547700013, 51.589229432000124],
            [27.676842488000148, 51.59481048600004],
            [27.620618531000076, 51.59589569200004],
            [27.512426250000146, 51.623098617],
            [27.512304728000032, 51.62312917100003],
            [27.477268107000015, 51.62367177400007],
            [27.4587679440001, 51.617496440000096],
            [27.430966023000053, 51.59842783600003],
            [27.40900354000007, 51.59170990000008],
            [27.38838464400007, 51.59072804800003],
            [27.32906009900006, 51.596955058000034],
            [27.28926924700005, 51.58897104900005],
            [27.26746179200012, 51.58749827100006],
            [27.25402592000006, 51.595378927000084],
            [27.259710327000107, 51.612302959],
            [27.27448978700002, 51.63380035400003],
            [27.277487020000137, 51.65113779700003],
            [27.2479281010001, 51.65565948500007],
            [27.223640177000107, 51.653695780000035],
            [27.20358972200006, 51.65514272100005],
            [27.18901696800009, 51.66377268500007],
            [27.18105879700005, 51.68340973],
            [27.18147220800006, 51.71012644500006],
            [27.184159383000093, 51.731442974000075],
            [27.177854858000075, 51.747075094000095],
            [27.151086466000095, 51.75676442500004],
            [27.109952026000116, 51.76242299500008],
            [27.02158532700011, 51.764541728000054],
            [26.920816284000125, 51.742527568000085],
            [26.854773803000086, 51.74934885700013],
            [26.665741415000127, 51.80138702400008],
            [26.445599813000115, 51.805598654],
            [26.431543823000084, 51.81022369400007],
            [26.41924483200006, 51.82092071600006],
            [26.416971069000027, 51.830635885],
            [26.419968302000143, 51.839730937000084],
            [26.419761597000075, 51.84686228500003],
            [26.40777266500004, 51.850608826000055],
            [26.17533207200009, 51.8567066450001],
            [26.14535974100005, 51.864845684],
            [26.08076420100008, 51.90065745100004],
            [26.050585165000086, 51.90481740400007],
            [25.9811320390001, 51.9034738160001],
            [25.76791508000008, 51.9285110470001],
            [25.683475789000028, 51.918020732000045],
            [25.547396408000054, 51.919441982000066],
            [25.351971477000063, 51.9214830530001],
            [25.183299601000044, 51.94975006099999],
            [25.138031046000037, 51.94894907700005],
            [25.09265913900009, 51.93975067200007],
            [25.002742147000077, 51.91047597300009],
            [24.72182906100005, 51.882338156000074],
            [24.701055135000104, 51.88290659600001],
            [24.639766886000046, 51.89213083900002],
            [24.390789836000096, 51.880012716000024],
            [24.369602498000063, 51.875103455],
            [24.34789839700005, 51.86115081800001],
            [24.311518189000054, 51.82756113699999],
            [24.296118612000072, 51.808130798],
            [24.272347452000105, 51.74288930300007],
            [24.244132121000064, 51.718213807000055],
            [24.13075402800004, 51.6697929890001],
            [23.981305786000036, 51.58599965400005],
            [23.941308228000082, 51.581917216000036],
            [23.91288619000005, 51.59858286600006],
            [23.884877563000146, 51.61987355600006],
            [23.84529341600009, 51.62982126900006],
            [23.82028202300009, 51.631268209000055],
            [23.749692017000115, 51.64447153800005],
            [23.726230916000134, 51.64485911100003],
            [23.628975871000108, 51.62904612200005],
            [23.616676880000085, 51.62478281700008],
            [23.606444946000096, 51.61811655700008],
            [23.5943526610001, 51.6049649050001],
            [23.59331913200012, 51.596955058000034],
            [23.599106893000084, 51.58897104900005],
            [23.626288697000092, 51.54088612900007],
            [23.628665812000122, 51.53122263600007],
            [23.624118286000083, 51.5159005740001],
            [23.61543664600012, 51.51311004700004],
            [23.606238241000142, 51.517399191000024],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Lithuania',
        iso3: 'LTU',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [26.594531291000067, 55.66699086600006],
              [26.603833048000098, 55.64327138300003],
              [26.607657105000044, 55.61645131500005],
              [26.605176635000078, 55.59009633400008],
              [26.59556481900006, 55.568030498],
              [26.576134480000064, 55.55056386400004],
              [26.551639852000108, 55.53449249300009],
              [26.532106161000115, 55.51625071200003],
              [26.5276619870001, 55.492169495000084],
              [26.546472209000115, 55.471240540000096],
              [26.543268270000056, 55.459613342000026],
              [26.507818238000112, 55.439149475000065],
              [26.49923995000009, 55.42809071900005],
              [26.486010783000097, 55.39083201200005],
              [26.479086141000096, 55.38137522400008],
              [26.455211629000104, 55.356105449000026],
              [26.445496460000072, 55.33750193300004],
              [26.45004398600011, 55.3270632940001],
              [26.46575362200008, 55.32086212200004],
              [26.525388224000096, 55.30809804400006],
              [26.542338094000087, 55.30758127900002],
              [26.60269616700009, 55.31688303700004],
              [26.768629191000088, 55.300243225000045],
              [26.79157352700011, 55.290166321000086],
              [26.80072025600009, 55.273319804000025],
              [26.78966149900009, 55.257196758000035],
              [26.76558028100004, 55.246706442000075],
              [26.739901281000073, 55.242776403000065],
              [26.701088094000113, 55.2368362430001],
              [26.68568851700013, 55.23161692300009],
              [26.65695642100013, 55.21533884700007],
              [26.641143432000035, 55.202833151000064],
              [26.633908732000066, 55.192187806000064],
              [26.627500854000118, 55.16443756100004],
              [26.616338745000093, 55.13539540600003],
              [26.60093916800011, 55.120822652000086],
              [26.578925008000027, 55.11854888900005],
              [26.47340173300006, 55.14567901600013],
              [26.459139038000075, 55.144748841000066],
              [26.450664103000094, 55.13983958000004],
              [26.444772989000086, 55.133948466000035],
              [26.4385718180001, 55.13002105800008],
              [26.42875329600014, 55.128212382000086],
              [26.420278361000044, 55.12810903000006],
              [26.309484090000126, 55.14464548700006],
              [26.26442224100009, 55.1400979620001],
              [26.233002971000133, 55.11162424800007],
              [26.2303157960001, 55.100255432],
              [26.231245971000078, 55.075450745000055],
              [26.229385620000073, 55.06341013600009],
              [26.224631388000063, 55.05488352500005],
              [26.187837768000065, 55.00873647100012],
              [26.170324564000083, 54.99326030100009],
              [26.153627970000088, 54.978505758000026],
              [26.138641805000105, 54.96894561800012],
              [26.102571656000094, 54.95700836200008],
              [25.9811320390001, 54.94269399000008],
              [25.96252852400005, 54.94290069600005],
              [25.926148315000063, 54.94775828100005],
              [25.907854858000093, 54.948068339000045],
              [25.870234416000073, 54.938818258000126],
              [25.858452189000076, 54.93297882100005],
              [25.85483483900009, 54.92548573800009],
              [25.85307784000011, 54.91644236300006],
              [25.846669962000078, 54.90621042900007],
              [25.825792684000106, 54.891999410000025],
              [25.802538290000086, 54.88161244700008],
              [25.78269453900009, 54.86967519200003],
              [25.77225590000006, 54.850864970000046],
              [25.773702840000055, 54.84192494700001],
              [25.78228112800008, 54.82197784500009],
              [25.782901245000062, 54.813709615000036],
              [25.778457072000037, 54.80528635700004],
              [25.77339278200006, 54.80337432900002],
              [25.76657149200011, 54.80327097600009],
              [25.756752970000036, 54.80037709600002],
              [25.73494551600004, 54.78905995700005],
              [25.72430017100004, 54.7801199340001],
              [25.72119958500008, 54.76673573900008],
              [25.72461022900012, 54.715679423],
              [25.7230599370001, 54.7053441370001],
              [25.719132528000017, 54.694750468],
              [25.713861531000077, 54.68555206400002],
              [25.709520712000113, 54.67563018900002],
              [25.708383830000088, 54.663021139000094],
              [25.715101766000117, 54.643229065000114],
              [25.739906454000078, 54.60772735600007],
              [25.74559086100001, 54.58840037000003],
              [25.740423217000114, 54.568504944000026],
              [25.726470581000115, 54.55295033800009],
              [25.707350301000105, 54.54152984700009],
              [25.64616540500009, 54.52039418600005],
              [25.630869181000037, 54.50835357700008],
              [25.61991377700008, 54.48809641600006],
              [25.615572958000087, 54.46189646400005],
              [25.616296427000094, 54.44107086300009],
              [25.612575724000067, 54.42179555300005],
              [25.594695678000107, 54.40009145100005],
              [25.54880700600006, 54.36774200500007],
              [25.52999678600014, 54.34614125600008],
              [25.528653198000058, 54.32097483400007],
              [25.54229577600009, 54.308055725000045],
              [25.56399987800006, 54.30314646500001],
              [25.607408081000074, 54.30485178700006],
              [25.667352743000066, 54.32330027300007],
              [25.682338908000133, 54.32562571300012],
              [25.69598148600005, 54.32097483400007],
              [25.70176924600011, 54.31275828100003],
              [25.704766480000018, 54.30299143500007],
              [25.715411825000103, 54.285214742000036],
              [25.719235881000145, 54.28154571600005],
              [25.723266642000056, 54.2809772750001],
              [25.734738811000057, 54.28319936100009],
              [25.739286336000106, 54.28257924500012],
              [25.74889815200001, 54.276326396000016],
              [25.757786499000133, 54.26898834300003],
              [25.765641316000142, 54.25999664300009],
              [25.77225590000006, 54.24893788700008],
              [25.776286662000047, 54.245630595000094],
              [25.78176436400014, 54.24444203700007],
              [25.78662194900005, 54.242323304000095],
              [25.789205770000052, 54.23622548500002],
              [25.786828654000118, 54.23178131100012],
              [25.77504642700012, 54.2224795530001],
              [25.771945841000075, 54.217880351000034],
              [25.77101566600004, 54.17214670800011],
              [25.763057495000055, 54.15643707300005],
              [25.740009806000103, 54.146256816000076],
              [25.72812422700008, 54.14522328800011],
              [25.690607137000086, 54.14822052000001],
              [25.679755086000114, 54.14532664000002],
              [25.66394209800012, 54.132355855000114],
              [25.653503458000102, 54.128738505000015],
              [25.631592651000034, 54.128325094],
              [25.543019247000075, 54.136955058000055],
              [25.516044149000038, 54.14475820000008],
              [25.493306518000054, 54.15752227800006],
              [25.4857617590001, 54.1754023240001],
              [25.493203165000125, 54.182430319],
              [25.521728556000085, 54.188218079000094],
              [25.528963257000044, 54.19565948500009],
              [25.52338220200005, 54.20423777300003],
              [25.499300984000087, 54.2118342080001],
              [25.50167810000005, 54.221756084],
              [25.522141967000096, 54.22862904900008],
              [25.545499715000062, 54.22749216800007],
              [25.553974650000043, 54.231264548000084],
              [25.483487996000093, 54.2876952110001],
              [25.478682088000085, 54.29332794200003],
              [25.472067505000098, 54.29715199900009],
              [25.459355103000036, 54.298908997000055],
              [25.434137004000092, 54.29182932600004],
              [25.39403609200008, 54.25715443900002],
              [25.369748169000104, 54.2479043580001],
              [25.287582641000057, 54.24521718400008],
              [25.224123983000112, 54.2585497030001],
              [25.206243937000067, 54.256792705000024],
              [25.19353153500012, 54.243666891000046],
              [25.173067667000055, 54.19658966100006],
              [25.156531210000054, 54.17571238200007],
              [25.115603475000057, 54.14878896100008],
              [25.0719885660001, 54.13220082700006],
              [25.027133423000095, 54.12786000600009],
              [24.948275187000064, 54.14589508100009],
              [24.902283163000078, 54.149770813000046],
              [24.855981079000088, 54.14672190300011],
              [24.85098389500007, 54.14495112900006],
              [24.82156457500014, 54.134526266000094],
              [24.817533813000068, 54.128221741000075],
              [24.81743046000011, 54.12062530500002],
              [24.818670695000066, 54.113959046],
              [24.81815393100004, 54.11013499000008],
              [24.799447062000127, 54.103210348000076],
              [24.790558716000106, 54.09659576500009],
              [24.784254191000116, 54.09623402900009],
              [24.78249719200005, 54.09287506200009],
              [24.787148071000104, 54.077630514000035],
              [24.799033651000116, 54.056029765000076],
              [24.81246952300009, 54.038924866000016],
              [24.8213578700001, 54.01990793900005],
              [24.819394165000062, 53.99257110600003],
              [24.819290812000133, 53.992519430000115],
              [24.81918745900009, 53.99241607700007],
              [24.819084107000066, 53.99231272400006],
              [24.806371704000128, 53.97531117800004],
              [24.7886983650001, 53.96967844700002],
              [24.723896118000113, 53.963425599000104],
              [24.705602661000057, 53.9642007450001],
              [24.690823201000114, 53.972830709000064],
              [24.677904094000013, 53.99231272400006],
              [24.67428674300004, 53.993707988000025],
              [24.67056604000004, 53.994276429000095],
              [24.666845336000108, 53.993863017000066],
              [24.642970825000106, 53.98301096700003],
              [24.579098755000075, 53.97562123700003],
              [24.528662557000075, 53.95836130800002],
              [24.414044230000115, 53.89769317600006],
              [24.37787072800009, 53.886841126],
              [24.34190393100002, 53.88704783200005],
              [24.310174601000085, 53.89268056300007],
              [24.276378215000108, 53.89180206300004],
              [24.25705122900007, 53.89402415000005],
              [24.24640588400007, 53.903635967000056],
              [24.229145955000092, 53.932368063000055],
              [24.201137329000062, 53.95247019500003],
              [24.1696147050001, 53.95892974900009],
              [24.13674849500009, 53.955415752000036],
              [24.074943482000094, 53.93572703100007],
              [24.045384562000066, 53.930869446000074],
              [23.981305786000036, 53.93040435800005],
              [23.96487268000007, 53.93272979700008],
              [23.935417114000074, 53.94394358300012],
              [23.919810832000053, 53.94776763900005],
              [23.90472131300004, 53.946062317],
              [23.82834354600007, 53.92006907100004],
              [23.820592082000076, 53.91929392500002],
              [23.812117147000066, 53.920844219000045],
              [23.794133749000082, 53.92709706600003],
              [23.78720910600009, 53.92792389000006],
              [23.77180952900011, 53.924306539000085],
              [23.754446248000107, 53.916761780000044],
              [23.691917765000113, 53.911490784000094],
              [23.64261844900011, 53.8989850870001],
              [23.627115519000114, 53.898209941000076],
              [23.60995894400014, 53.90182729100006],
              [23.520145305000142, 53.933970032],
              [23.485625448000064, 53.93929270400004],
              [23.489759562000074, 53.94513214200005],
              [23.490379679000057, 53.95060984300004],
              [23.48748579900007, 53.955622457000075],
              [23.48159468600008, 53.960118307000116],
              [23.47094934100008, 53.96528595000011],
              [23.46288781700008, 53.97252065000008],
              [23.45865035000014, 53.98161570300006],
              [23.459270467000096, 53.99231272400006],
              [23.464128052000035, 53.996756897000054],
              [23.469502401000085, 54.000684306000025],
              [23.48159468600008, 54.00662709600006],
              [23.496477498000104, 54.021974996000026],
              [23.496167440000136, 54.044557597000065],
              [23.48159468600008, 54.09122141500002],
              [23.47394657400008, 54.11256378200004],
              [23.462991170000123, 54.134939678000094],
              [23.449038534000124, 54.15493845700006],
              [23.432502075000116, 54.169304505000056],
              [23.423303670000024, 54.1725084430001],
              [23.40180627400008, 54.17597076500006],
              [23.391470988000094, 54.18010487900007],
              [23.382272583000088, 54.18785634400008],
              [23.364082479000047, 54.208268535000045],
              [23.35447066200004, 54.21705352800002],
              [23.335990126000127, 54.226293796000036],
              [23.316023397000095, 54.23627716100005],
              [23.235408162000084, 54.254157207],
              [23.197270956000125, 54.26785146100012],
              [23.13525923600008, 54.2982888800001],
              [23.11706913200004, 54.303456523000094],
              [23.096915324000065, 54.300821025000076],
              [23.073040812000073, 54.29487823500007],
              [23.050096476000135, 54.29482655900004],
              [23.032113078000037, 54.309554342000055],
              [23.03221643100008, 54.320148010000125],
              [23.03800419100014, 54.33146514900001],
              [23.041621542000115, 54.34097361300009],
              [23.035317016000107, 54.346502991000094],
              [23.001003866000076, 54.34888010700003],
              [22.989738404000036, 54.35337595600005],
              [22.983433878000113, 54.3597838350001],
              [22.978989706000107, 54.36758697600003],
              [22.97330529800007, 54.37539011700004],
              [22.96265995300007, 54.381694642000056],
              [22.95242801900008, 54.383089905000034],
              [22.929690389000115, 54.38029937800006],
              [22.918838338000057, 54.3811262010001],
              [22.858893677000083, 54.3992129520001],
              [22.837602986000093, 54.40091827500008],
              [22.812694946000107, 54.39409698500002],
              [22.811343908000055, 54.39263336100008],
              [22.786029907000085, 54.365209860000064],
              [22.76721968600006, 54.356269837000056],
              [22.7069649660001, 54.41874664300012],
              [22.680403279000075, 54.453214824000085],
              [22.6746155190001, 54.4922822060001],
              [22.68174686700013, 54.569900208],
              [22.703657674000084, 54.61754587800003],
              [22.70810184700011, 54.63563262900006],
              [22.7069649660001, 54.646484680000086],
              [22.700763794000096, 54.669325663],
              [22.700867147000054, 54.679557597000084],
              [22.705104615000096, 54.68653391600007],
              [22.727015422000136, 54.7053441370001],
              [22.727532186000076, 54.709323222000066],
              [22.72484501100007, 54.71376739500009],
              [22.722777954000094, 54.71857330400009],
              [22.72484501100007, 54.7233792120001],
              [22.728255656000073, 54.72508453400006],
              [22.736730591000082, 54.726324768],
              [22.74727258300004, 54.73159576400012],
              [22.76484257000004, 54.73712514300003],
              [22.773007446000037, 54.742499492],
              [22.78665002400004, 54.75598704100004],
              [22.817759237000104, 54.769164531000044],
              [22.8328487550001, 54.77867299400002],
              [22.845767863000106, 54.79613962800006],
              [22.848351684000107, 54.81381296800005],
              [22.84432092300011, 54.83226145500008],
              [22.82933475800013, 54.87272410100006],
              [22.821273234000046, 54.88548818000005],
              [22.808870891000083, 54.89375640900009],
              [22.749236287000087, 54.90987945600007],
              [22.740968058000135, 54.91763092100008],
              [22.752130168000065, 54.931118469000026],
              [22.73879764800006, 54.934115703000046],
              [22.72918583200004, 54.94036855100005],
              [22.722054484000097, 54.94718984000009],
              [22.715543253000135, 54.95137563100003],
              [22.70613814200007, 54.9531326300001],
              [22.649914185000085, 54.95287424800004],
              [22.63348107900012, 54.95793853800002],
              [22.621698852000122, 54.970030823000016],
              [22.608366333000106, 54.992406718],
              [22.59162316800007, 55.037623596000074],
              [22.580667765000072, 55.057622376000026],
              [22.57116534000005, 55.06398964700007],
              [22.565474894000147, 55.067802633000085],
              [22.54108361900012, 55.07576080400004],
              [22.436283814000063, 55.05777740500004],
              [22.269883746000062, 55.06953696300003],
              [22.251282186000083, 55.070851542000085],
              [22.14265832500007, 55.05462514300008],
              [22.12984257000008, 55.04697703],
              [22.11847375500011, 55.03777862600002],
              [22.099870240000143, 55.029923808],
              [22.076822551000078, 55.0285802210001],
              [22.049950805000094, 55.03354115800006],
              [22.027729940000143, 55.04439320900012],
              [22.018634887000076, 55.060929667000025],
              [22.018634887000076, 55.07731109600006],
              [22.01543094900009, 55.088421530000076],
              [22.003442017000054, 55.093485820000055],
              [21.977500447000097, 55.091987203000045],
              [21.9513521720001, 55.08046335900012],
              [21.942773885000065, 55.078292948000026],
              [21.932955363000104, 55.08046335900012],
              [21.90856408700006, 55.08986847000007],
              [21.873217407000055, 55.09493276000005],
              [21.85389042200012, 55.10221913700012],
              [21.819887329000068, 55.119324036000066],
              [21.750640910000072, 55.127954],
              [21.733380982000057, 55.136325582],
              [21.716224405000105, 55.14945139600006],
              [21.645841105000073, 55.18102569600005],
              [21.605120076000105, 55.19249786400006],
              [21.50393762200011, 55.19440989200008],
              [21.46766076600008, 55.211153056000015],
              [21.405545695000086, 55.272389628000056],
              [21.374849894000135, 55.28995961500003],
              [21.34983850100005, 55.28778920500004],
              [21.267588738000086, 55.24868398600006],
              [21.269053582000083, 55.253566799000055],
              [21.264496290000068, 55.276556708000044],
              [21.264414910000085, 55.28400299700007],
              [21.27084394600007, 55.28803131700005],
              [21.278086785000085, 55.28656647300005],
              [21.285329623000052, 55.28705475500004],
              [21.291188998000052, 55.29706452000005],
              [21.289235873000052, 55.30524323100008],
              [21.282481316000087, 55.316839911000045],
              [21.274180535000085, 55.327337958000044],
              [21.267588738000086, 55.33185455900008],
              [21.25945071700005, 55.33624909100007],
              [21.25635826900009, 55.34674713700008],
              [21.257090691000087, 55.36937083500004],
              [21.24659264400009, 55.37018463700008],
              [21.18881269600007, 55.33860911700003],
              [21.18336022200009, 55.34617747600004],
              [21.18327884200005, 55.34837474200003],
              [21.18604576900009, 55.34918854400007],
              [21.22429446700005, 55.399318752000056],
              [21.232758009000065, 55.40692780200004],
              [21.248301629000082, 55.41787344000005],
              [21.248383009000065, 55.44232819200005],
              [21.236582879000082, 55.48265208500004],
              [21.22429446700005, 55.51239655200004],
              [21.222911004000082, 55.52020905200004],
              [21.21851647200009, 55.52362702000005],
              [21.208994988000086, 55.52960846600007],
              [21.199392123000052, 55.53766510600008],
              [21.19507897200009, 55.54718659100007],
              [21.196055535000085, 55.55939362200007],
              [21.19776451900009, 55.56732819200005],
              [21.198090040000068, 55.57477448100008],
              [21.19507897200009, 55.58510976800005],
              [21.15756269600007, 55.64175039300005],
              [21.15015709700009, 55.65932851800005],
              [21.147227410000085, 55.678168036000045],
              [21.140798373000052, 55.68813711100006],
              [21.09937584700009, 55.72907135600008],
              [21.08952884200005, 55.735256252000056],
              [21.080739780000044, 55.73859284100007],
              [21.074392123000052, 55.74494049700007],
              [21.069834832000083, 55.76972077000005],
              [21.060557488000086, 55.78925202000005],
              [21.04468834700009, 55.87372467700004],
              [21.04468834700009, 55.91771067900004],
              [21.046885613000086, 55.92865631700005],
              [21.056162957000083, 55.94253164300005],
              [21.05836022200009, 55.95184967700004],
              [21.05836022200009, 56.037543036000045],
              [21.053396030000044, 56.07261790600006],
              [21.091352986000118, 56.077896017000015],
              [21.150160767000102, 56.0781802370001],
              [21.190365031000113, 56.084458924],
              [21.205351196000095, 56.10342417400007],
              [21.212585897000054, 56.13099355100006],
              [21.229639119000097, 56.163187968],
              [21.25485721800004, 56.185202128000086],
              [21.29041060300011, 56.206932068000086],
              [21.32761763500011, 56.22437286400002],
              [21.35831343600006, 56.23323537300003],
              [21.40368534300009, 56.23447560700008],
              [21.41929162600013, 56.237395325000065],
              [21.558921346000147, 56.29728831000004],
              [21.59602502500013, 56.307881979000015],
              [21.684495076000076, 56.31010406600002],
              [21.965321874000068, 56.383676718000046],
              [21.98317307100004, 56.38835347900003],
              [22.094082479000065, 56.417410177000065],
              [22.139144328000015, 56.41570485400011],
              [22.158161255000095, 56.410252991000036],
              [22.195264933000146, 56.39485341400005],
              [22.214901977000096, 56.39038340300003],
              [22.511731404000045, 56.39596445800005],
              [22.575810180000076, 56.3877220670001],
              [22.57822170300011, 56.3870029160001],
              [22.604748982000018, 56.37909210200006],
              [22.649087361000085, 56.35309885700009],
              [22.666347290000147, 56.34909393400001],
              [22.681436808000058, 56.35030833000003],
              [22.822926880000097, 56.38286448200007],
              [22.859602846000143, 56.39706996200003],
              [22.888969360000146, 56.40844431600003],
              [22.924522746, 56.41211334300003],
              [22.95697554500012, 56.40198476200008],
              [22.98136682200007, 56.37317515100004],
              [23.01671350100014, 56.32384999600005],
              [23.06229211400006, 56.3041612760001],
              [23.11272831200006, 56.31087921200002],
              [23.162854451000072, 56.3410065720001],
              [23.15417281100011, 56.351393534000024],
              [23.172569620000104, 56.35795644100001],
              [23.288428182000075, 56.37304596000011],
              [23.31064904800013, 56.37059132900005],
              [23.37803970300007, 56.354629849000034],
              [23.48159468600008, 56.33010284500004],
              [23.517561482000133, 56.32865590400006],
              [23.577712850000097, 56.34860300700008],
              [23.609855591000013, 56.353822327],
              [23.679412069000108, 56.35185862200005],
              [23.706697225000113, 56.35444244400007],
              [23.715068807000108, 56.35273712200011],
              [23.723543742000118, 56.34581248000002],
              [23.72478397600014, 56.33839691200011],
              [23.72364709400003, 56.332118226],
              [23.72499068200011, 56.328810934],
              [23.756099894000045, 56.32596873000004],
              [23.82503625500007, 56.33490875300005],
              [23.85810917200007, 56.334391989000025],
              [23.871106925000106, 56.3320721300001],
              [23.981305786000036, 56.31240366600004],
              [24.075150187000133, 56.27119171200003],
              [24.108636516000047, 56.2607013960001],
              [24.138918905000082, 56.25744578000011],
              [24.14042161800006, 56.25760022600009],
              [24.16682417800004, 56.26031382300009],
              [24.28764367700009, 56.29553131100006],
              [24.31854618400007, 56.29858022100008],
              [24.35079227700004, 56.291552226000064],
              [24.4143542890001, 56.265507304],
              [24.44722049900014, 56.26052052800004],
              [24.48132694500009, 56.26884043500009],
              [24.53899784300006, 56.287624817],
              [24.5579114170001, 56.29858022100008],
              [24.63914677000008, 56.35997182200008],
              [24.678627563000106, 56.37728342700008],
              [24.71503953100006, 56.38625298800004],
              [24.80554488100009, 56.40854766900007],
              [24.815570109000106, 56.40880605100004],
              [24.837687622000118, 56.40394846600002],
              [24.845852498000056, 56.40493031900009],
              [24.852157023000075, 56.41366363500005],
              [24.853397257000097, 56.42472239300007],
              [24.857117960000096, 56.43536773700005],
              [24.87096724500006, 56.44260243700002],
              [24.89225793400007, 56.438726706000054],
              [24.910137980000115, 56.42195770300002],
              [24.936286255000113, 56.37991892500007],
              [24.96212447100004, 56.3192766320001],
              [24.97318322800004, 56.30075063100007],
              [24.983208456000057, 56.290492859],
              [25.016488077000105, 56.26989980100008],
              [25.02620324700004, 56.26018463200005],
              [25.04397994000007, 56.227990214],
              [25.07312544700011, 56.197811178],
              [25.10919559700011, 56.183083395],
              [25.349085703000128, 56.15987632300009],
              [25.45480757700011, 56.149648743000014],
              [25.522762085000068, 56.1565733850001],
              [25.57288822400008, 56.14303415900012],
              [25.590044800000044, 56.14112213100002],
              [25.64967940300005, 56.143809307000126],
              [25.66187504100006, 56.14081207300002],
              [25.66921309400007, 56.13202708000004],
              [25.687816610000112, 56.09833404600006],
              [25.69660160300009, 56.087895406000044],
              [25.7087972410001, 56.081048279000086],
              [25.766261434000114, 56.058646546],
              [25.795496034000053, 56.04013034000006],
              [25.871267944000067, 55.992138977000124],
              [25.961251118000064, 55.95845883400007],
              [26.017615600000113, 55.93736195900003],
              [26.07942061300011, 55.89813954700007],
              [26.178639364000077, 55.84958953900009],
              [26.20375411000009, 55.827446187000064],
              [26.226905152000086, 55.796931254000086],
              [26.279718466000134, 55.743239441000085],
              [26.342350301000067, 55.71634185800009],
              [26.481049846000133, 55.67830800500006],
              [26.537480509000062, 55.66952301000008],
              [26.594531291000067, 55.66699086600006],
            ],
          ],
          [
            [
              [20.989430696469412, 55.27311631266015],
              [20.924568700365, 55.28265777882994],
              [20.92481530000009, 55.282904364000046],
              [20.999522332000083, 55.35700104400007],
              [21.04151451900009, 55.416083075000074],
              [21.082367384000065, 55.49762604400007],
              [21.09310957100007, 55.581691799000055],
              [21.09937584700009, 55.59870026200008],
              [21.093923373000052, 55.60346100500004],
              [21.09937584700009, 55.612982489000046],
              [21.090668165000068, 55.63312409100007],
              [21.09351647200009, 55.69554271000004],
              [21.085215691000087, 55.72284577000005],
              [21.117442254000082, 55.69977448100008],
              [21.131521030000044, 55.655585028000075],
              [21.133555535000085, 55.56830475500004],
              [21.13135826900009, 55.55573151200008],
              [21.12208092500009, 55.53900788000004],
              [21.119883660000085, 55.527044989000046],
              [21.119883660000085, 55.489447333000044],
              [21.10840905000009, 55.473089911000045],
              [21.092621290000068, 55.45661041900007],
              [21.087168816000087, 55.441066799000055],
              [21.106211785000085, 55.427435614000046],
              [21.106211785000085, 55.421210028000075],
              [21.091807488000086, 55.41071198100008],
              [21.073496941000087, 55.391791083000044],
              [21.05762780000009, 55.36945221600007],
              [21.050954623000052, 55.348863023000035],
              [21.037852410000085, 55.32859935100004],
              [20.988942905000044, 55.29132721600007],
              [20.989430696469412, 55.27311631266015],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Russia',
        iso3: 'RUS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [87.81632409700006, 49.16583730100008],
              [87.71638187700012, 49.158860982000064],
              [87.52528243000006, 49.11979360000005],
              [87.51401696800008, 49.11963857000002],
              [87.50605879700004, 49.12087880500006],
              [87.50006433100003, 49.11917348200008],
              [87.49158939600011, 49.103205465000045],
              [87.48714522300003, 49.09695261700004],
              [87.48177087400006, 49.09162994400002],
              [87.47556970200009, 49.08759918300011],
              [87.43836267100005, 49.074680074000085],
              [87.40043217000004, 49.0710110480001],
              [87.36229496300007, 49.075093485000096],
              [87.32379602100013, 49.08527374300009],
              [87.30818973800007, 49.113850810000045],
              [87.28767419400003, 49.18433746400008],
              [87.27175785300011, 49.20511138900004],
              [87.21796268700007, 49.22981272400004],
              [87.19031579700004, 49.237822571000024],
              [87.16044681800014, 49.24200836200008],
              [87.0760075280001, 49.23689239500008],
              [87.05037601700013, 49.23890777600012],
              [87.03663008600012, 49.242731832000075],
              [87.02453780100012, 49.24893300400005],
              [87.01714807100012, 49.25864817400007],
              [87.01688969000003, 49.272755840000016],
              [87.01254886900006, 49.28071401000007],
              [87.0001465250001, 49.28908559200006],
              [86.93332889800013, 49.324277242000036],
              [86.91302006100011, 49.33869496700005],
              [86.90506189000007, 49.35192413400004],
              [86.91565555800014, 49.369959209000044],
              [86.93079675300004, 49.38055287700011],
              [86.93307051600004, 49.39011301700002],
              [86.90547530100008, 49.404685771000075],
              [86.8544189860001, 49.42127390600008],
              [86.82899418200009, 49.43331451500005],
              [86.81400801600012, 49.45000600200008],
              [86.81426639800009, 49.47295033800002],
              [86.82289636300004, 49.492794088000025],
              [86.82434330300003, 49.509227194000076],
              [86.80243249500006, 49.52224965500001],
              [86.73256595900006, 49.55067169200002],
              [86.70951827000005, 49.55449574900008],
              [86.66414636200011, 49.54741607700005],
              [86.64254561400003, 49.54746775400007],
              [86.61856774900008, 49.557958069],
              [86.59934411600011, 49.57351267500003],
              [86.59179935700013, 49.58720693000005],
              [86.59598514800007, 49.601883036000046],
              [86.61112634300008, 49.62022817000003],
              [86.64709314000004, 49.653662822000015],
              [86.66771203700006, 49.6642564910001],
              [86.71613285300003, 49.66678863500009],
              [86.73649336800014, 49.67190460300007],
              [86.75561364800006, 49.68151641900009],
              [86.77587080900014, 49.69500396800005],
              [86.75147953300012, 49.71169545500008],
              [86.74052413000004, 49.722754212],
              [86.73763024900006, 49.73500152600012],
              [86.74341801000003, 49.744716696000054],
              [86.7525647380001, 49.756033834000036],
              [86.75959273300003, 49.76771270800002],
              [86.75892094000005, 49.778616435000075],
              [86.7483789470001, 49.782957255000056],
              [86.7308089600001, 49.78254384400013],
              [86.70021651200011, 49.77773793600004],
              [86.68492028800006, 49.778203024000064],
              [86.6424422610001, 49.793860983000016],
              [86.61019616700014, 49.79551462800005],
              [86.59536503100003, 49.78089019800008],
              [86.58492639200006, 49.76006459600002],
              [86.5651343180001, 49.74270131500002],
              [86.5582096760001, 49.74146108100008],
              [86.5522152100001, 49.74233958000009],
              [86.54560062700006, 49.742649638],
              [86.53743575000004, 49.73944569900003],
              [86.52441328900005, 49.729523824000026],
              [86.51971073400006, 49.726836650000095],
              [86.47273685700009, 49.70833648800006],
              [86.47966149900009, 49.69727773000007],
              [86.48296879100008, 49.68627065100007],
              [86.48178023300005, 49.676917217000025],
              [86.47547570800003, 49.67081939700007],
              [86.45826745600004, 49.66565175400008],
              [86.39181156400008, 49.624982402000015],
              [86.32948978700006, 49.61025461800001],
              [86.27212894700006, 49.58364125600009],
              [86.24639408400009, 49.55005157500007],
              [86.21425134300006, 49.496153057000114],
              [86.17725101700012, 49.463338522000086],
              [86.1366850180001, 49.493000794000054],
              [86.11151859600005, 49.520182597000044],
              [86.0704875080001, 49.52628041600009],
              [86.02754439300003, 49.51563507100012],
              [85.99597009300004, 49.492794088000025],
              [85.99581506300012, 49.492794088000025],
              [85.98005375200012, 49.48287221300011],
              [85.96300052900011, 49.47858306900004],
              [85.94625736500012, 49.4813735960001],
              [85.93142622900012, 49.492845765000126],
              [85.93189131700012, 49.51005401700009],
              [85.94212325000012, 49.55108510400005],
              [85.94057295700009, 49.55961171500006],
              [85.89985192900014, 49.564055888000055],
              [85.88073164900004, 49.56328074200006],
              [85.8607845460001, 49.557492981000095],
              [85.82750492300005, 49.54100820000009],
              [85.80921146700013, 49.53651235000008],
              [85.79443200700007, 49.54183502300005],
              [85.77954919500013, 49.5560460410001],
              [85.76471805900013, 49.56684641500003],
              [85.7474064540001, 49.57299591100009],
              [85.72575402800004, 49.57304758700012],
              [85.69004561400004, 49.56291900700005],
              [85.67330244900006, 49.56043853800007],
              [85.65619755100005, 49.564934387],
              [85.64229659100005, 49.57749176100002],
              [85.62844730600011, 49.6064822390001],
              [85.61485640400008, 49.61712758400007],
              [85.59718306500008, 49.619297994000064],
              [85.58080163600005, 49.613355205000076],
              [85.5492790130001, 49.59526845300006],
              [85.5312956140001, 49.58911895800007],
              [85.5132088630001, 49.585346579000046],
              [85.47569177300011, 49.58307281600004],
              [85.45099043800008, 49.5884471640001],
              [85.4072721760001, 49.60963450200005],
              [85.38401778200006, 49.61568064400008],
              [85.3642257090001, 49.61413035100007],
              [85.3420565190001, 49.608187562000055],
              [85.3203524170001, 49.599454245000075],
              [85.3027824300001, 49.590100811000056],
              [85.26309493000014, 49.581522522000014],
              [85.2236141360001, 49.59573354100009],
              [85.19503706900014, 49.625654195000024],
              [85.18511519400005, 49.70502919600007],
              [85.16325606300006, 49.73396799800004],
              [85.0981437580001, 49.78218210900003],
              [85.08171065300013, 49.80001047800009],
              [85.07592289200005, 49.81391143900005],
              [85.07075524900006, 49.85023997000003],
              [85.05628584800013, 49.873339336000086],
              [85.03261804200008, 49.88496653300005],
              [84.97577396700007, 49.89400990800003],
              [84.95458662900012, 49.906929017000024],
              [84.95065922000003, 49.93328399700009],
              [84.95479333600014, 49.99048980800005],
              [84.96218306500003, 49.99188507100011],
              [84.96461185800013, 49.992763570000065],
              [84.96471521000007, 49.992763570000065],
              [85.00936364800009, 49.99782786100003],
              [85.02543501800005, 50.004080709000036],
              [85.02832889800004, 50.020513815000086],
              [85.02011234600008, 50.03307118800011],
              [84.98672937000003, 50.066970927000014],
              [84.97577396700007, 50.075187480000054],
              [84.91024825100004, 50.09508290600006],
              [84.8879757090001, 50.0967365530001],
              [84.87376468900004, 50.09244740900003],
              [84.85588464400007, 50.08485097300006],
              [84.83867639200008, 50.08082021100007],
              [84.82611901900009, 50.08671132400006],
              [84.8015210370001, 50.12376332700005],
              [84.79066898600007, 50.132755026],
              [84.77320235200011, 50.13833608100002],
              [84.73811405400005, 50.1353905240001],
              [84.72028568500014, 50.13663075800004],
              [84.68938317800013, 50.151048482000064],
              [84.66669722500006, 50.17001373300012],
              [84.64199589100008, 50.18489654600005],
              [84.60597741700008, 50.18742869100005],
              [84.5692871500001, 50.18551666300003],
              [84.53569746900007, 50.190942688000106],
              [84.50458825700014, 50.2045852670001],
              [84.4757528080001, 50.227064515],
              [84.44076786300008, 50.24463450100008],
              [84.40526615400006, 50.230836894000035],
              [84.36878259300005, 50.21181996700007],
              [84.33136885600004, 50.21347361300012],
              [84.32434086100005, 50.219623109000096],
              [84.31214522400006, 50.23636627200004],
              [84.30439375800012, 50.243239238000015],
              [84.29157800400003, 50.248045146000024],
              [84.26181237800006, 50.25362620100013],
              [84.24997847600014, 50.259930725000046],
              [84.23964318900005, 50.2782241820001],
              [84.23948815900008, 50.299308167000035],
              [84.24186527500007, 50.321890768000074],
              [84.23938480600009, 50.34462839800007],
              [84.21840417500005, 50.37770131400005],
              [84.19184248900007, 50.40772532200002],
              [84.17675297000005, 50.43914459300005],
              [84.19794030800011, 50.493146464000105],
              [84.19561486800006, 50.511439921],
              [84.18595137600005, 50.527976380000084],
              [84.15122481300011, 50.552574361000055],
              [84.14502364100014, 50.5660619100001],
              [84.14233646700012, 50.581513163000025],
              [84.13303470900007, 50.600788473000065],
              [84.10171879100005, 50.62859039400011],
              [84.0885972750001, 50.634612502000024],
              [83.97583500200005, 50.6863646450001],
              [83.94973840400007, 50.71788726900006],
              [83.9505652260001, 50.78041575200005],
              [83.92198815900014, 50.80072458900007],
              [83.88281742400011, 50.81199005100005],
              [83.86969161000013, 50.821395162],
              [83.83827233900007, 50.85627675400006],
              [83.82049564600004, 50.86800730400007],
              [83.80044519000012, 50.87565541600004],
              [83.77817264800007, 50.87942779600006],
              [83.73264571100009, 50.87963450200003],
              [83.71280196200007, 50.88221832300012],
              [83.69058109500014, 50.89183013900005],
              [83.63265181500003, 50.92479970300009],
              [83.60975915500012, 50.93203440300006],
              [83.49834476800004, 50.9454186],
              [83.47700240100005, 50.953376771000066],
              [83.46201623500014, 50.964332174000035],
              [83.43395593300005, 50.99265085900002],
              [83.32378177900011, 51.00241770500007],
              [83.21205733200003, 50.99265085900002],
              [83.19593428600007, 50.98877512600008],
              [83.17960453300003, 50.98727651000006],
              [83.1632747810001, 50.988465068],
              [83.13753991700008, 50.99466623900007],
              [83.12741133600014, 50.995234680000024],
              [83.11738610900011, 50.99456288700004],
              [83.10756758700006, 50.99265085900002],
              [83.08607019100003, 50.952549948000026],
              [83.05785485800004, 50.917151591],
              [83.02147465000007, 50.891778464000126],
              [82.9758960370001, 50.881908265000035],
              [82.84412113400009, 50.891726787000025],
              [82.76453942900014, 50.906661276000065],
              [82.7264538980001, 50.90071848500004],
              [82.69999556500011, 50.880978089000095],
              [82.69803186100006, 50.81095652300006],
              [82.6727620850001, 50.7897691860001],
              [82.6042391360001, 50.769046936000066],
              [82.47582320100008, 50.71401153600003],
              [82.43029626500004, 50.74114166300008],
              [82.40828210500007, 50.74837636300005],
              [82.36249678600012, 50.742123515000046],
              [82.35133467600008, 50.74553415900009],
              [82.34120609500013, 50.75028839100007],
              [82.32839034000006, 50.752097066000076],
              [82.31366255700004, 50.747756247],
              [82.30115686000005, 50.74093495700005],
              [82.28839278200007, 50.73742096000008],
              [82.27314823400013, 50.743053691000014],
              [82.25573327600011, 50.74522410100009],
              [82.23630293800011, 50.734475403],
              [82.21661421700009, 50.71943756100008],
              [82.19878584800011, 50.708792216000106],
              [82.17367110200007, 50.70305613200004],
              [82.14731612100013, 50.70160919200005],
              [82.09553633600007, 50.708120423000125],
              [82.07310876500009, 50.71566518100006],
              [82.01254398700013, 50.750133363000046],
              [81.99032312000008, 50.75964182500012],
              [81.94536462400009, 50.7692019660001],
              [81.89503177900008, 50.77421458000008],
              [81.82242639100008, 50.76573964500007],
              [81.8008773200001, 50.76785837900006],
              [81.76346358300003, 50.784343160000034],
              [81.74413659700008, 50.784911601],
              [81.72573978700007, 50.77462799100009],
              [81.69721439600005, 50.74501739600005],
              [81.67411503100004, 50.736025696000084],
              [81.46022627700006, 50.730341289000066],
              [81.43108077000005, 50.74072825200007],
              [81.41878177900008, 50.76248402900008],
              [81.4261198320001, 50.788167216000076],
              [81.44472334900013, 50.81338531500002],
              [81.46611739100007, 50.83374583000004],
              [81.43950402900003, 50.859687398000105],
              [81.41609460500007, 50.88965972900006],
              [81.40121179300013, 50.922991028000084],
              [81.40079838100013, 50.95911285400011],
              [81.27744673600012, 50.96267852800007],
              [81.15884932500006, 50.938235576000054],
              [81.10438236500005, 50.93668528200003],
              [81.07792403100007, 50.9406643680001],
              [81.05828698700003, 50.94707224500006],
              [81.05151737500012, 50.9557022100001],
              [81.05404952000009, 50.96986155200004],
              [81.08050785400007, 51.03086558000011],
              [81.14717045100008, 51.13594960600007],
              [81.15595544400009, 51.1574211640001],
              [81.15864261900003, 51.174267681000075],
              [81.1520280360001, 51.186540833000024],
              [81.13275272600009, 51.194473165000076],
              [81.11285730000009, 51.19594594400006],
              [81.09833622300005, 51.19090749100009],
              [81.07012089000006, 51.17199391700005],
              [81.04485111500009, 51.17351837200006],
              [81.02211348500003, 51.17739410400013],
              [80.97601810700007, 51.191088359000034],
              [80.93607222500003, 51.20568695100012],
              [80.92423832200012, 51.216073914000035],
              [80.91628015100008, 51.235375061000084],
              [80.9142130950001, 51.270179138000046],
              [80.90573816000011, 51.28356333500007],
              [80.88248376500007, 51.28485524500012],
              [80.86408695500006, 51.27583770800008],
              [80.8545268150001, 51.26462392200004],
              [80.84253788300003, 51.257518413000085],
              [80.81659631300005, 51.261006572000056],
              [80.68275435400011, 51.30201182000009],
              [80.66456425000007, 51.300151469000085],
              [80.64503055900008, 51.28924774200003],
              [80.63242150900004, 51.27795644100006],
              [80.62146610500014, 51.26454640700011],
              [80.61412805200007, 51.24966359500006],
              [80.6124744060001, 51.233876445000064],
              [80.59924523900014, 51.20855499300008],
              [80.56131473900012, 51.20209543900005],
              [80.47615197800008, 51.20964019800009],
              [80.45207076000014, 51.207934876000124],
              [80.43439742000004, 51.200622660000036],
              [80.42199507700008, 51.18757436200009],
              [80.41341678900005, 51.16842824300009],
              [80.40762902800003, 51.135742900000096],
              [80.40711226500014, 51.11721689900007],
              [80.41052290800013, 51.10484039400011],
              [80.42406213400011, 51.09210215200004],
              [80.45165734900013, 51.0734986370001],
              [80.46106245900006, 51.05895172200003],
              [80.46447310400009, 51.04370717400009],
              [80.46498986900014, 51.02577545200002],
              [80.46312951700014, 51.00784373000006],
              [80.45940881400003, 50.99265085900002],
              [80.43904829900009, 50.95813100300005],
              [80.40287479700004, 50.93373972600001],
              [80.36019006400005, 50.919218649000086],
              [80.32039921100005, 50.91410268200009],
              [80.27957482900007, 50.917151591],
              [80.26727583900004, 50.915652975000015],
              [80.25818078600014, 50.91131215500003],
              [80.24371138500004, 50.898651429],
              [80.2348230390001, 50.8932254030001],
              [80.19544559700012, 50.882321676000046],
              [80.18128625500003, 50.87565541600004],
              [80.16816044100011, 50.85984242800005],
              [80.15451786300008, 50.82723460000007],
              [80.14273563600005, 50.81710601800005],
              [80.1191711840001, 50.814935608000056],
              [80.1016011960001, 50.82155019200003],
              [80.06697798700009, 50.84661326100006],
              [80.0493046470001, 50.852349345],
              [80.01540490800011, 50.83948191300003],
              [80.03111454300006, 50.80878611300007],
              [80.08599491400008, 50.75214874300009],
              [80.05498905500014, 50.75287221300009],
              [80.02129602100007, 50.766876526],
              [79.9900834560001, 50.78811554000005],
              [79.9665190020001, 50.810181376000045],
              [79.95525354000006, 50.82599436400004],
              [79.92693485500007, 50.87849762000012],
              [79.87360477700014, 50.95017283200009],
              [79.82730269400008, 51.0123912560001],
              [79.73800581900014, 51.1324356090001],
              [79.6485022380001, 51.25242828400012],
              [79.55920536300005, 51.37249847500003],
              [79.46980513500006, 51.49259450400005],
              [79.36304162600004, 51.617573955000026],
              [79.30432255000011, 51.68637826000004],
              [79.25638147000006, 51.742553406000084],
              [79.14972131400009, 51.867584534000045],
              [79.04295780400008, 51.992512309000105],
              [79.04285445100004, 51.992512309000105],
              [79.0427510990001, 51.992512309000105],
              [78.90126102700009, 52.15392364500006],
              [78.75956425000004, 52.315257467],
              [78.6179708250001, 52.47661712700004],
              [78.47648075400014, 52.63792511100006],
              [78.36827030500007, 52.75264679000013],
              [78.26005985500007, 52.8673943080001],
              [78.1519527590001, 52.9821676640001],
              [78.04384566300007, 53.096915182000075],
              [77.97635624200007, 53.16851287900003],
              [77.8668022060001, 53.27233083200004],
              [77.78465673900013, 53.3274404750001],
              [77.73389042200006, 53.361498515000065],
              [77.61276086400005, 53.442785544000046],
              [77.47550826000008, 53.508259583000026],
              [77.29009322200011, 53.596729635000074],
              [77.10467818200004, 53.685148011000095],
              [76.91926314300014, 53.77361806300003],
              [76.73384810400006, 53.86203643900005],
              [76.61096154800009, 53.920637512000084],
              [76.5256954350001, 53.961306865000026],
              [76.49520633900005, 53.99231272400006],
              [76.48259729000011, 54.03013987300004],
              [76.47649947100012, 54.04202545200006],
              [76.3743868410001, 54.147755432000096],
              [76.37666060400011, 54.15426666300006],
              [76.39361047400013, 54.161759745],
              [76.41262740100007, 54.16568715500007],
              [76.47649947100012, 54.16403350800003],
              [76.60383020100005, 54.13535308900002],
              [76.66460168500004, 54.13406117800007],
              [76.71627811700012, 54.170854798000065],
              [76.72619999200009, 54.18020823200003],
              [76.75121138500009, 54.19400583900007],
              [76.76247684700013, 54.20263580400011],
              [76.77022831300013, 54.21312611900005],
              [76.78232059800013, 54.24237498000009],
              [76.80009729000005, 54.260668437000064],
              [76.82087121600011, 54.277618306000065],
              [76.8377177320001, 54.29689361600002],
              [76.8431954350001, 54.32231842100002],
              [76.83420373600012, 54.345676168000054],
              [76.81580692500012, 54.355598044000075],
              [76.76609419800013, 54.36458974200009],
              [76.75296838400004, 54.376682027000086],
              [76.76464725800014, 54.39053131200005],
              [76.78676477000005, 54.402830302],
              [76.80474816900005, 54.41011667900007],
              [76.88567346200011, 54.42277740500002],
              [76.90355350800007, 54.432595927000094],
              [76.91047815000007, 54.45461008800005],
              [76.8959053960001, 54.463860169000085],
              [76.87234094200011, 54.46468699200001],
              [76.85239384000005, 54.46117299500004],
              [76.78211389100005, 54.43946889300004],
              [76.75720585200008, 54.43709177700002],
              [76.70129195100003, 54.44024403900006],
              [76.67276656100006, 54.43647166000004],
              [76.65178592900008, 54.422312317],
              [76.64568811000004, 54.403708802000025],
              [76.64527469900008, 54.38381337500003],
              [76.64093387800011, 54.36650177000003],
              [76.62305383300009, 54.35590810200004],
              [76.60775760900003, 54.35456451500009],
              [76.5771651610001, 54.35678660100008],
              [76.56186893800003, 54.356269837000056],
              [76.5400614830001, 54.351102193000045],
              [76.47649947100012, 54.32314524400006],
              [76.43309126800006, 54.31658233700007],
              [76.23424035700003, 54.347433167000034],
              [76.21481001800004, 54.342213847000025],
              [76.1939327400001, 54.32562571300012],
              [76.17708622300006, 54.30676381500008],
              [76.1697481700001, 54.2913642380001],
              [76.17191857900008, 54.27467275100007],
              [76.18380415900003, 54.2515733850001],
              [76.04190067500008, 54.211730855000084],
              [75.86527063000005, 54.16206980500009],
              [75.7519958900001, 54.13018544600003],
              [75.69123357400014, 54.113138241000044],
              [75.64037479600006, 54.098869528000094],
              [75.60316776600007, 54.09452870700004],
              [75.4998149010001, 54.10233184800005],
              [75.46436486900012, 54.10057485000006],
              [75.42922489400007, 54.09008453400013],
              [75.36070194600006, 54.05954376300012],
              [75.43397912600005, 53.98652496400008],
              [75.27750289000005, 53.91769195600007],
              [75.15771691900011, 53.865085348],
              [75.02790572200007, 53.80793121300006],
              [75.0008272710001, 53.806484273000066],
              [74.92393273900012, 53.830978903000116],
              [74.8884827070001, 53.83635325200008],
              [74.80621382700014, 53.83769683900006],
              [74.77200402800014, 53.830875549],
              [74.76218550600004, 53.82255564400005],
              [74.75433068900008, 53.808499654000016],
              [74.74337528500013, 53.77945749900003],
              [74.73490035000003, 53.765194804000046],
              [74.72528853400013, 53.7591486620001],
              [74.67464563000004, 53.75708160400005],
              [74.66296675600012, 53.754962871000075],
              [74.65449182200007, 53.748399964000086],
              [74.64446659400005, 53.734602356000025],
              [74.62679325400006, 53.687318420000096],
              [74.61645796700003, 53.6807038380001],
              [74.4534705000001, 53.684992981000065],
              [74.43848433500011, 53.67341746000001],
              [74.42969934100012, 53.65357371100002],
              [74.42081099500007, 53.603085837],
              [74.42659875500004, 53.59636790000006],
              [74.44458215400005, 53.58582590800002],
              [74.45543420400008, 53.577402650000025],
              [74.45688114400008, 53.56975453700004],
              [74.40913212100014, 53.477563782000104],
              [74.38835819500008, 53.462215882000024],
              [74.35890262900006, 53.466143291],
              [74.30619266800005, 53.492394918000016],
              [74.30608931500012, 53.492394918000016],
              [74.30598596200008, 53.49260162400007],
              [74.26960575400011, 53.51523590200013],
              [74.26309452300006, 53.53022206600009],
              [74.27032922400008, 53.55321807900005],
              [74.25048547400013, 53.55678375300003],
              [74.24159712700009, 53.56779083300002],
              [74.23529260200007, 53.58189849900005],
              [74.22330367000012, 53.5946109020001],
              [74.21389856000008, 53.59703969400006],
              [74.14795943200005, 53.59802154500004],
              [74.13721073400006, 53.593939107000026],
              [74.11871057200011, 53.569547831000094],
              [74.10765181500011, 53.56510365900009],
              [74.07685266100003, 53.56618886400007],
              [74.06279667200005, 53.573216858000094],
              [74.06145308400005, 53.589494935000104],
              [74.06300337700009, 53.60871856800013],
              [74.05804244000012, 53.624583232000035],
              [74.04357303900008, 53.629957581],
              [73.97670373600005, 53.63517690100012],
              [73.93670617700008, 53.639517721000104],
              [73.90415002500004, 53.6391559850001],
              [73.87273075400009, 53.632127991000075],
              [73.80327762900004, 53.59838328100004],
              [73.78777469900007, 53.59507598900002],
              [73.7532548420001, 53.60701324500006],
              [73.73651167900005, 53.60975209600009],
              [73.65982385300003, 53.6115607710001],
              [73.65289921100003, 53.60918365600007],
              [73.65124556500012, 53.60277577700002],
              [73.65103885900004, 53.59476593000004],
              [73.64411421700004, 53.5791596480001],
              [73.6431840410001, 53.570219625000064],
              [73.64070357300005, 53.563243307000064],
              [73.63191857900006, 53.560866191000045],
              [73.60794071500004, 53.56334666000002],
              [73.60039595600006, 53.56288157200008],
              [73.58251591000004, 53.55864410500003],
              [73.57600467900005, 53.55316640200003],
              [73.57259403500012, 53.54319285100003],
              [73.56349898300004, 53.5254678350001],
              [73.5552307530001, 53.5147708140001],
              [73.54654911300014, 53.50691599500006],
              [73.52370813000005, 53.49249827100006],
              [73.52370813000005, 53.492394918000016],
              [73.52360477700012, 53.492394918000016],
              [73.45069726800006, 53.44855956200003],
              [73.42407596800007, 53.43255360900007],
              [73.41095015500008, 53.43002146500008],
              [73.34718143800006, 53.45937367800006],
              [73.39120975700007, 53.52024851500009],
              [73.23059940600012, 53.57233835900006],
              [73.25881473800007, 53.606289775000064],
              [73.22491499800009, 53.62985422800007],
              [73.22036747300012, 53.64308339500006],
              [73.22966923000007, 53.6624103810001],
              [73.24475874900014, 53.67481272400009],
              [73.26377567600014, 53.68101389600007],
              [73.30656376200005, 53.685664775000035],
              [73.33116174300005, 53.77516835500005],
              [73.34738814300005, 53.787622376000044],
              [73.43782190000013, 53.808499654000016],
              [73.39120975700007, 53.82824005200008],
              [73.41095015500008, 53.85025421200005],
              [73.43182743300008, 53.86544708300009],
              [73.45590865100013, 53.87366363600002],
              [73.48526086400011, 53.87485219300005],
              [73.6342956950001, 53.85743723500009],
              [73.66168420500014, 53.86084788000004],
              [73.68287154100011, 53.874128724000045],
              [73.69713423700006, 53.90084543900009],
              [73.74064579300011, 54.0579417930001],
              [73.68493859900008, 54.048433330000094],
              [73.67491337100012, 54.05158559200005],
              [73.67170943200006, 54.072359518],
              [73.67046919800003, 54.07592519200007],
              [73.65434615000004, 54.07850901300007],
              [73.6015328370001, 54.07122263600009],
              [73.58851037600004, 54.06615834600002],
              [73.59192102100008, 54.05773508800003],
              [73.60091272000011, 54.046934713],
              [73.60442671700008, 54.03468739800006],
              [73.58685673000008, 54.01944285100002],
              [73.52825565600006, 54.01070953400004],
              [73.51988407400012, 53.99241607700007],
              [73.51988407400012, 53.99231272400006],
              [73.52153772000014, 53.96874827100005],
              [73.51802372200012, 53.956035868000086],
              [73.50593143700013, 53.949731344000085],
              [73.48164351400004, 53.945390523000114],
              [73.4690344650001, 53.94730255200004],
              [73.44598677600004, 53.963890687000045],
              [73.43348107900005, 53.97066029900007],
              [73.42407596800007, 53.97262400400011],
              [73.3927600510001, 53.97401926700009],
              [73.38428511500007, 53.97029856400006],
              [73.38128788300014, 53.960221660000045],
              [73.3793241780001, 53.9486978150001],
              [73.37394982900014, 53.940946351],
              [73.36030725100005, 53.938414205000115],
              [73.19070520000008, 53.96161692300002],
              [73.0627543540001, 53.97908355700007],
              [73.04435754400009, 53.99231272400006],
              [73.03526249200013, 54.02057973200003],
              [73.02368697100007, 54.03396392900008],
              [72.97676477100003, 54.04770985900011],
              [72.97356083200009, 54.086518860000055],
              [72.96839318900004, 54.104140524000044],
              [72.95681766800004, 54.11752472000008],
              [72.9420382080001, 54.121762187000044],
              [72.88550419100005, 54.11731801400002],
              [72.75734664000004, 54.125999655000086],
              [72.62422814900003, 54.13499135400012],
              [72.57306848200005, 54.12868682900002],
              [72.52738651600004, 54.10005808500004],
              [72.51922163900014, 54.08822418300012],
              [72.50878299900006, 54.068742167000025],
              [72.50309859300006, 54.050862122000055],
              [72.50940311700003, 54.04357574500007],
              [72.59714969900011, 54.05458282500008],
              [72.63177290800007, 54.053911031],
              [72.65616418500014, 54.042542216000086],
              [72.67559452300003, 54.02166493800003],
              [72.69481815600005, 53.99257110600003],
              [72.70019250500008, 53.957637838000025],
              [72.67373417100009, 53.95050649000008],
              [72.57213830600011, 53.97644806000004],
              [72.55684208200006, 53.97722320600006],
              [72.54392297400005, 53.97076365200009],
              [72.5180847580001, 53.94322011400003],
              [72.47674361200006, 53.913402812000115],
              [72.45555627400012, 53.90534128900002],
              [72.42341353400008, 53.903480937000026],
              [72.3922009690001, 53.90823516900009],
              [72.37297733600008, 53.92006907100004],
              [72.37277063000005, 53.93624379500004],
              [72.38310591600003, 53.95644928100002],
              [72.40780725100007, 53.99231272400006],
              [72.40780725100007, 53.992519430000115],
              [72.4186593020001, 54.016032207000094],
              [72.40512007600012, 54.030656637000064],
              [72.38186568200013, 54.04300730400003],
              [72.36357222500004, 54.05954376300012],
              [72.35995487500014, 54.068638815],
              [72.35685428800008, 54.08176462800007],
              [72.35840458200005, 54.092978414000115],
              [72.3682231040001, 54.096337382000016],
              [72.39850549300013, 54.089671123000116],
              [72.40791060400005, 54.08956777000007],
              [72.41194136600006, 54.09277170900005],
              [72.41927941900008, 54.10532908200007],
              [72.42320682800005, 54.10868805000008],
              [72.43974328600012, 54.10889475500004],
              [72.45421268700005, 54.10713775700005],
              [72.46671838400005, 54.10992828400002],
              [72.47674361200006, 54.12367421500004],
              [72.4820146080001, 54.128325094],
              [72.48439172400003, 54.13245920900003],
              [72.48294478400004, 54.135611471000075],
              [72.3880668540001, 54.15762563100007],
              [72.29856327300007, 54.17839955700002],
              [72.3329797770001, 54.22377146500004],
              [72.33711389200005, 54.236535543000016],
              [72.32440149000007, 54.25348541300012],
              [72.27871952400005, 54.262735494000125],
              [72.26745406100014, 54.273484192000055],
              [72.25277795400012, 54.303456523000094],
              [72.22187544700012, 54.333222148000075],
              [72.18477177000005, 54.3568382780001],
              [72.15180220500008, 54.36825876900009],
              [72.04317834500006, 54.378025615000055],
              [72.02467818200006, 54.37094594400013],
              [72.0270552980001, 54.35533966100009],
              [72.03842411300008, 54.34603790300007],
              [72.07129032400013, 54.333222148000075],
              [72.0947514240001, 54.3207681280001],
              [72.10301965400004, 54.311569723],
              [72.09867883300006, 54.300510966],
              [72.07800826000005, 54.273897603000066],
              [72.07211714700014, 54.262735494000125],
              [72.06756962100008, 54.25110829700007],
              [72.06570926900008, 54.240979717000116],
              [72.06539921100011, 54.228008932000094],
              [72.06674279800006, 54.222376201000074],
              [72.08513960800008, 54.21312611900005],
              [72.11149458800014, 54.20620147700008],
              [72.1422937420001, 54.20330759700009],
              [72.16999230900012, 54.19684804300003],
              [72.18735559100014, 54.1794330850001],
              [72.1904561770001, 54.15199290000005],
              [72.17764042200008, 54.1359732050001],
              [72.15510949700007, 54.12837677100002],
              [72.12885786900006, 54.126051331],
              [72.09950565600008, 54.131890768000076],
              [72.07697473100006, 54.14832387300005],
              [72.01868371600011, 54.214986471000046],
              [72.00245731700011, 54.225631816000046],
              [71.9836470950001, 54.23157460600005],
              [71.95801558500006, 54.23596710200006],
              [71.76247196500003, 54.247645976000044],
              [71.74138798000007, 54.24242665700011],
              [71.72536828700004, 54.229094137000075],
              [71.71544641200012, 54.210749003],
              [71.71224247300006, 54.19069854700005],
              [71.71730676300012, 54.14646352200005],
              [71.7087284750001, 54.13220082700006],
              [71.68061649600008, 54.119075013],
              [71.64723352100009, 54.10858469700004],
              [71.63235070900004, 54.10713775700005],
              [71.61498742700013, 54.109514873000094],
              [71.60465214100003, 54.113700664000035],
              [71.58418827400004, 54.125896302000044],
              [71.57354292800005, 54.12920359300004],
              [71.54935835800012, 54.12698150700005],
              [71.49912886600004, 54.11158193000007],
              [71.47711470600007, 54.10966990200005],
              [71.46832971200007, 54.15840077700007],
              [71.46243859900011, 54.171526591000045],
              [71.45313684100006, 54.18134511300012],
              [71.44352502500004, 54.18511749300005],
              [71.41298425300005, 54.18444570000007],
              [71.3815649820001, 54.18883819600005],
              [71.34973230000008, 54.19767486600004],
              [71.32058679300013, 54.20103383400006],
              [71.29629886900005, 54.188993225],
              [71.24575931800013, 54.13576650000003],
              [71.21806075100011, 54.116284486000055],
              [71.18230065900008, 54.10155670200005],
              [71.16126835100005, 54.101970113000064],
              [71.1436983640001, 54.113700664000035],
              [71.11300256400006, 54.15023590100007],
              [71.09744795700004, 54.1650670370001],
              [71.08235843900013, 54.174265442],
              [71.04396285000007, 54.18594431600006],
              [71.05155928500005, 54.20031036400006],
              [71.05636519400014, 54.22340972900004],
              [71.05724369300009, 54.247129212000075],
              [71.0520760500001, 54.26320058200007],
              [71.03879520700008, 54.267593079000065],
              [70.97714522300004, 54.27012522400004],
              [70.97084069800013, 54.30500681600002],
              [70.98003910300014, 54.32505727200005],
              [71.00339685000006, 54.33311879500006],
              [71.039467, 54.33208526700007],
              [71.05982751500011, 54.32795115200004],
              [71.09687951700005, 54.31565216100002],
              [71.11625817900011, 54.311724752000046],
              [71.1344482830001, 54.311569723],
              [71.19062056500013, 54.318184307000095],
              [71.19583988500005, 54.360817362],
              [71.19568485500008, 54.37451161700001],
              [71.19811364800006, 54.39166819300006],
              [71.19801029500013, 54.399523011],
              [71.19346276900012, 54.40401886000002],
              [71.17609948800009, 54.407584534000094],
              [71.16865808200009, 54.41094350200011],
              [71.16591923000004, 54.41704132100007],
              [71.17103519800008, 54.450992737],
              [71.1669010820001, 54.46272328700006],
              [71.14685062600006, 54.47615916000002],
              [71.14519698100008, 54.48060333300002],
              [71.14592045100011, 54.48618438700005],
              [71.14824589000011, 54.49248891300006],
              [71.14121789500012, 54.563750712000015],
              [71.14757409700013, 54.59144928000005],
              [71.17904504400008, 54.608709209000025],
              [71.23015303600005, 54.61754587800003],
              [71.25232222500011, 54.62534901900007],
              [71.2648795980001, 54.63919830400003],
              [71.26467289200014, 54.661729228000056],
              [71.25278731300011, 54.682399801000045],
              [71.21878422000009, 54.7141808060001],
              [71.20069746900009, 54.72399932900005],
              [71.18033695500003, 54.727358297000066],
              [71.13692875200013, 54.7270482390001],
              [71.09724125100007, 54.73304270500002],
              [71.04701176000003, 54.74906239900007],
              [71.00598067300007, 54.77422882100011],
              [70.99409509300006, 54.80750844400005],
              [70.99719567900007, 54.83484527600008],
              [70.98996097800011, 54.84864288400003],
              [70.95327071100013, 54.87349924700008],
              [70.94593265800006, 54.88791697300009],
              [70.9474829510001, 54.90605540000003],
              [70.95513106300007, 54.9232636520001],
              [70.96644820100005, 54.934942526000086],
              [70.97445804800009, 54.94693145800004],
              [70.95699141500006, 54.973493144000045],
              [70.96339929200008, 54.99225168900004],
              [70.9692387290001, 55.005067444000034],
              [70.9733211680001, 55.018451640000066],
              [70.97714522300004, 55.046098531000084],
              [70.97745528200011, 55.04790720600006],
              [70.97745528200011, 55.05157623300006],
              [70.97714522300004, 55.05338490900006],
              [70.97786869300012, 55.06573557600011],
              [70.97714522300004, 55.07798289000003],
              [70.96009200100008, 55.10557810500005],
              [70.86190677900004, 55.18056060800011],
              [70.79317712400007, 55.2331672160001],
              [70.78211836800006, 55.248463440000066],
              [70.78893965700007, 55.26546498700007],
              [70.80454594000014, 55.281536357000036],
              [70.82035892800013, 55.294145406000084],
              [70.77757084100011, 55.30701283800006],
              [70.7212435300001, 55.313110657000024],
              [70.66574304200003, 55.30918324800005],
              [70.62543542500009, 55.29249176100002],
              [70.60652185000004, 55.28050282900007],
              [70.58440433800013, 55.27316477500007],
              [70.56125329600013, 55.269599101],
              [70.53887740100004, 55.2692373660001],
              [70.46858559900005, 55.28546209800005],
              [70.46007084200005, 55.28742747100006],
              [70.44115726700011, 55.28334503300003],
              [70.40002282700004, 55.24593129500006],
              [70.38808557200008, 55.230273336000025],
              [70.38576013200003, 55.22241851800008],
              [70.38529504400003, 55.21394358300007],
              [70.38245284100003, 55.206243796000095],
              [70.37263431800005, 55.20055938800006],
              [70.28462935400006, 55.183196106000125],
              [70.26401045700004, 55.17342926100007],
              [70.23135095200007, 55.141493225],
              [70.21367761300007, 55.13198476100011],
              [70.19703780100008, 55.13348337800004],
              [70.05864831600007, 55.18702016300007],
              [70.01999434400005, 55.19534006800002],
              [69.94030928600012, 55.20024932900007],
              [69.91168054200006, 55.21161814400004],
              [69.83044519100008, 55.276575419],
              [69.80228153500013, 55.29207834900011],
              [69.67386560100005, 55.3340396120001],
              [69.4772884520001, 55.34943918900008],
              [69.33455814700005, 55.385147604000096],
              [69.31027022300003, 55.38147857700001],
              [69.22624434500011, 55.33357452400007],
              [69.18614343200011, 55.32577138300006],
              [69.16454268400014, 55.347423808000045],
              [69.14779952000009, 55.378222962],
              [69.12258142100012, 55.397860006000045],
              [68.9431608480001, 55.43455027300003],
              [68.92729618300007, 55.4337234500001],
              [68.91112146000006, 55.42736724800007],
              [68.90243981900011, 55.41951243100003],
              [68.90243981900011, 55.41248443600004],
              [68.90657393400005, 55.4050430300001],
              [68.91783939600009, 55.37093658500005],
              [68.93230879700013, 55.360808004],
              [68.95235925300005, 55.355898743000054],
              [68.97726729300007, 55.34670033800005],
              [68.98326175900007, 55.3085631310001],
              [68.98088464400013, 55.29145823200004],
              [68.97060103400014, 55.27864247700005],
              [68.94564131700014, 55.27037424700002],
              [68.92280033400004, 55.27636871400004],
              [68.90316329000012, 55.290838115000085],
              [68.86678308200004, 55.325668030000045],
              [68.8460091550001, 55.336778463000044],
              [68.82259973100014, 55.343548076],
              [68.73423368500005, 55.351714066000014],
              [68.72250248200004, 55.352798157],
              [68.70059167500006, 55.36049794600011],
              [68.68891280100007, 55.34328969300002],
              [68.68234989400014, 55.327166647000055],
              [68.6808512770001, 55.309803365000036],
              [68.68369348100009, 55.28861602800008],
              [68.67640710500012, 55.273216451000096],
              [68.62989831500005, 55.2548713180001],
              [68.61367191600004, 55.243089092],
              [68.61284509300003, 55.23471751000004],
              [68.61821944100006, 55.2154422],
              [68.61584232600006, 55.205468648000064],
              [68.6053003340001, 55.19559845],
              [68.59362146000012, 55.19358307000006],
              [68.56716312700013, 55.197562154000124],
              [68.54411543800006, 55.19689036100006],
              [68.47734948800013, 55.182834372000045],
              [68.40117842600011, 55.19471995100007],
              [68.3767871500001, 55.19508168500006],
              [68.32573083500012, 55.181955872000074],
              [68.30578373200012, 55.18138743100003],
              [68.28986739100009, 55.18526316300007],
              [68.27705163500008, 55.190844218],
              [68.26237552900011, 55.19404815700007],
              [68.24087813300008, 55.19115427700008],
              [68.17710941600006, 55.17053538000009],
              [68.18475752800003, 55.167279765],
              [68.20697839300004, 55.154153951000026],
              [68.19054528800007, 55.125370179000114],
              [68.22811405400012, 55.10159901900006],
              [68.30816084800006, 55.07281524700004],
              [68.30423343900009, 55.052609762000046],
              [68.28159916200013, 55.04713206000007],
              [68.25374556500009, 55.045891826000016],
              [68.23478031400003, 55.03850209500011],
              [68.22599532100014, 55.02088043200003],
              [68.22180953000009, 55.00775461800005],
              [68.21307621200003, 54.99845286100005],
              [68.19090702400007, 54.99256174800003],
              [68.18362064600012, 54.96713694300003],
              [68.16605065900012, 54.956129863000044],
              [68.00967777500006, 54.943004049000066],
              [67.91314620000014, 54.96915232400006],
              [67.88224369300013, 54.970444235000016],
              [67.8467936610001, 54.963933004000054],
              [67.81733809400009, 54.95215077700006],
              [67.79754602000008, 54.937164612000075],
              [67.75791019700006, 54.8978388470001],
              [67.69848230000008, 54.86791819200006],
              [67.62272465000012, 54.85386220300005],
              [67.44299401900008, 54.85701446600011],
              [67.37793339000012, 54.84905629500004],
              [67.3113224700001, 54.8599083460001],
              [67.28393396000007, 54.85329376300008],
              [67.26005944800005, 54.83691233400005],
              [67.23954390500012, 54.812934469000126],
              [67.2133439530001, 54.797173157000046],
              [67.1739665120001, 54.79138539700007],
              [67.0985189210001, 54.79200551400005],
              [67.06699629700012, 54.7875096640001],
              [67.00818851700012, 54.767924296],
              [66.97733768700004, 54.76368682900004],
              [66.78179406800012, 54.75820912700006],
              [66.76045170100014, 54.75092275000007],
              [66.72241784700009, 54.727203268000025],
              [66.70030033400008, 54.71924509700007],
              [66.63766849800004, 54.71366404200005],
              [66.50992435700005, 54.716712952000066],
              [66.44651737500004, 54.710925191000015],
              [66.09777630500014, 54.63715821400008],
              [65.97745039900008, 54.611706442000056],
              [65.96065555800004, 54.627984518000076],
              [65.95187056500004, 54.69366526300011],
              [65.93280196100005, 54.70255360900005],
              [65.85942142800013, 54.68575876900006],
              [65.82696862800009, 54.6726846320001],
              [65.79833988500013, 54.64813832700004],
              [65.7703312590001, 54.6173908490001],
              [65.74397627800005, 54.600854391],
              [65.71297041800011, 54.597185364],
              [65.57458093200012, 54.62545237200008],
              [65.47737756300012, 54.63268707300004],
              [65.4497823480001, 54.62746775400002],
              [65.44487308800007, 54.614186910000015],
              [65.45619022700004, 54.577858378000045],
              [65.44900720200008, 54.55661936400007],
              [65.42750980600005, 54.55279530900005],
              [65.37035567200013, 54.56245880200008],
              [65.34157190000008, 54.56147694900001],
              [65.21429284700014, 54.52788726900006],
              [65.19816980000013, 54.51615671800009],
              [65.19806644700003, 54.4922822060001],
              [65.19946171100008, 54.487786357000076],
              [65.20225223800014, 54.47254180900005],
              [65.18132328300004, 54.449132385000084],
              [65.21294925900014, 54.343040670000065],
              [65.18421716400007, 54.31043284100009],
              [65.17377852400011, 54.31017445900004],
              [65.14370284000006, 54.317615866000054],
              [65.13646814000009, 54.3163756310001],
              [65.12447920700004, 54.30893422400008],
              [65.11745121300004, 54.3064020800001],
              [65.10019128400012, 54.30547190400004],
              [65.08541182500011, 54.30857249000009],
              [65.07145918800012, 54.314877015],
              [65.05709314000012, 54.32386871300004],
              [64.97771813900005, 54.38660390200009],
              [64.91064213100003, 54.40272695000006],
              [64.84723514900008, 54.383916728000045],
              [64.78455163600006, 54.35322092800003],
              [64.72016280100007, 54.33384226500006],
              [64.68429935700004, 54.33611602800006],
              [64.65267338100011, 54.347123109000066],
              [64.59148848500013, 54.37854237900008],
              [64.57851770100007, 54.38557037300011],
              [64.53650476000007, 54.36862050400002],
              [64.51139001500013, 54.36510650700005],
              [64.50007287600005, 54.36619171200003],
              [64.47898889200013, 54.370894267000025],
              [64.46705163600006, 54.37197947200012],
              [64.46178063900004, 54.36877553300003],
              [64.45428755700004, 54.36169586200002],
              [64.4445723880001, 54.35466786800002],
              [64.4325317790001, 54.351515605000046],
              [64.33382979300012, 54.34464264000009],
              [64.30856001800004, 54.35182566400003],
              [64.29403894000006, 54.35337595600005],
              [64.28230839000008, 54.34805328400002],
              [64.27621057100004, 54.344384258000034],
              [64.25585005700003, 54.338648174000056],
              [64.22530928500004, 54.33461741100005],
              [64.1766300860001, 54.32050974600013],
              [64.1520321050001, 54.317357483000066],
              [64.10810713700005, 54.324747214000084],
              [64.09374108900005, 54.32417877300013],
              [64.08433597800013, 54.320199687000056],
              [64.06800622600008, 54.30769399000006],
              [64.05953129100004, 54.30371490600005],
              [64.04805912300003, 54.30268137700007],
              [64.03514001500014, 54.303973287000034],
              [64.02325443600012, 54.30759063700002],
              [64.00449589100003, 54.319734599000114],
              [63.99596927900012, 54.31549713100007],
              [63.9882178150001, 54.30784902000009],
              [63.98036299600005, 54.30371490600005],
              [63.978967733000104, 54.296480205000094],
              [63.99369551600006, 54.28040883400003],
              [64.02542484600008, 54.255242411],
              [64.00785485900013, 54.228680725000075],
              [63.976642293000054, 54.218862203000114],
              [63.94036543800007, 54.21529653000003],
              [63.90801599100007, 54.20749338800003],
              [63.897473999000056, 54.1941608690001],
              [63.88362471500005, 54.19741648400007],
              [63.85602950000009, 54.2018606570001],
              [63.77350223800005, 54.23968780600008],
              [63.74399499500004, 54.248731181000025],
              [63.70864831600005, 54.25043650400009],
              [63.54493737800004, 54.20645986000004],
              [63.47755131000014, 54.20397939100006],
              [63.44969771400008, 54.196124573000034],
              [63.396781047000104, 54.170596415],
              [63.368307333000075, 54.16284495100008],
              [63.3316170650001, 54.16268992100005],
              [63.32859195700007, 54.16311007500009],
              [63.21627526900005, 54.1787096150001],
              [63.15674401900009, 54.18005320300007],
              [63.1237744550001, 54.174110413000065],
              [63.110028523000096, 54.15798736600006],
              [63.11602299000003, 54.13969390900009],
              [63.12532474800014, 54.12486277300006],
              [63.127443481000114, 54.110445048000045],
              [63.11219893400005, 54.093701884],
              [63.08465539600007, 54.08564036100002],
              [62.98548832200004, 54.09287506200009],
              [62.90239261900007, 54.078457337000074],
              [62.875210816000106, 54.079542542000056],
              [62.83133752500004, 54.09272003200003],
              [62.81206221500014, 54.094993795000065],
              [62.757181844000115, 54.081092835000064],
              [62.670262085000104, 54.07773386700008],
              [62.62912764500004, 54.07117096000009],
              [62.580965210000045, 54.053600973000115],
              [62.55057946700009, 54.02683258100005],
              [62.56318851700007, 53.992519430000115],
              [62.569389689000104, 53.987816874000046],
              [62.58654626400005, 53.96983347600006],
              [62.54365482600008, 53.943013407000066],
              [62.53176924700006, 53.93035268100003],
              [62.53176924700006, 53.922497864],
              [62.53662683100009, 53.91495310500004],
              [62.54510176600007, 53.883688863000046],
              [62.541226033000044, 53.87666086800003],
              [62.525258016000066, 53.87185496100004],
              [62.51161543800009, 53.872630107000035],
              [62.49890303600006, 53.877797750000056],
              [62.487379192000105, 53.88596262600005],
              [62.477715698000054, 53.89516103200005],
              [62.45668339000008, 53.90921702100009],
              [62.40815922000007, 53.924719950000096],
              [62.38996911600003, 53.94156646700007],
              [62.386610148000045, 53.961306865000026],
              [62.39958093300004, 53.974484355000115],
              [62.44381595900006, 53.99231272400006],
              [62.444022664000045, 53.99231272400006],
              [62.44614139800012, 54.01453359],
              [62.43348067200009, 54.02466217100006],
              [62.41270674600008, 54.02662587500008],
              [62.00260258000009, 54.017375794000074],
              [62.002395874000115, 53.99830719000009],
              [62.003326050000055, 53.99231272400006],
              [62.00363610900007, 53.93200632800007],
              [61.89165328000013, 53.93624379500004],
              [61.85640995300008, 53.94270334900007],
              [61.836152791000075, 53.95112660800005],
              [61.8299516190001, 53.960376689000086],
              [61.828091268000094, 53.973244121000064],
              [61.82054650900011, 53.99257110600003],
              [61.80638716700008, 53.99753204400007],
              [61.79129764800007, 54.00078765900007],
              [61.77703495300011, 53.999909160000115],
              [61.755020793000085, 53.98326934800009],
              [61.74210168400003, 53.981564026000044],
              [61.728562459000045, 53.98528473000006],
              [61.71533329200014, 53.99257110600003],
              [61.619938599000136, 53.99257110600003],
              [61.61642460100006, 53.97417429700003],
              [61.61105025300009, 53.959549866000046],
              [61.60050826000014, 53.950248108000025],
              [61.581801392000045, 53.94766428600012],
              [61.563921346000086, 53.951746725000035],
              [61.55616988100007, 53.96094513000013],
              [61.55275923600004, 53.992519430000115],
              [61.47855188000011, 54.00290639300003],
              [61.46191206900005, 54.01112294600007],
              [61.43317997200006, 54.04745147800004],
              [61.41767704200004, 54.05597808900005],
              [61.33768192500014, 54.06316111300002],
              [61.311533650000115, 54.059853821],
              [61.293343546000074, 54.046056214000046],
              [61.274843384000064, 54.0285379030001],
              [61.249831990000075, 54.02073476200009],
              [61.193504680000046, 54.018254293],
              [61.20125614400007, 53.998358867],
              [61.204770142000086, 53.99257110600003],
              [61.22513065600003, 53.960221660000045],
              [61.23050500500011, 53.94306508400008],
              [61.22730106700004, 53.92590850900011],
              [61.210764608000034, 53.90766672800005],
              [61.192884562000074, 53.90709828700001],
              [61.17624475100007, 53.916503398000046],
              [61.16301558400005, 53.928492330000026],
              [61.15557417800005, 53.938414205000115],
              [61.15185347500005, 53.945442200000016],
              [61.14523889100013, 53.950144755000096],
              [61.096352987000046, 53.95624257400006],
              [61.06379683400013, 53.95531239900002],
              [61.017391398000086, 53.94895619800006],
              [60.996100708000085, 53.94141143900002],
              [60.97801395700009, 53.92668365500002],
              [60.97181278500011, 53.915831604000076],
              [60.96943566900006, 53.90425608300002],
              [60.97139937300011, 53.89299062100007],
              [60.97801395700009, 53.882603659000054],
              [60.999614706000045, 53.87939971900006],
              [61.06524377400012, 53.87846954300004],
              [61.08498417200008, 53.87531728100008],
              [61.095216105000134, 53.87014963800006],
              [61.1149565020001, 53.852321269000115],
              [61.142448364000074, 53.841882630000086],
              [61.177174927000124, 53.83283925400012],
              [61.20197961500014, 53.819610087000044],
              [61.19908573400005, 53.79713083900002],
              [61.17872522000005, 53.780852763],
              [61.151750122000124, 53.76524648100006],
              [61.12746219900009, 53.747159729000046],
              [61.11567997200012, 53.723646953000056],
              [61.10689497900012, 53.7124331670001],
              [61.06793094900013, 53.708919169000055],
              [61.052221313000075, 53.70328643800012],
              [61.044779907000134, 53.6914008590001],
              [61.04395308400012, 53.67920522100009],
              [61.04488326000006, 53.666699524000094],
              [61.0427128500001, 53.65424550400009],
              [61.00757287600004, 53.63574534200008],
              [60.90473677600011, 53.65708770800008],
              [60.88024214700005, 53.632799785000074],
              [60.90732059700008, 53.61362782800008],
              [61.04664025900013, 53.608460185000055],
              [61.096352987000046, 53.59921010400005],
              [61.10338098200009, 53.59249216700003],
              [61.11454309100009, 53.5762140910001],
              [61.12146773300009, 53.56980621400005],
              [61.14038130700004, 53.56272654300004],
              [61.28073449700014, 53.542417704000016],
              [61.31608117700006, 53.545208232000064],
              [61.361246379000136, 53.58257029200003],
              [61.390288534000035, 53.588513082000034],
              [61.50304650900006, 53.58897817000006],
              [61.516792440000074, 53.58572255500009],
              [61.52836796100013, 53.57166656500006],
              [61.55534305900005, 53.50572743800005],
              [61.51472538300004, 53.49249827100006],
              [61.488473755000086, 53.479320780000066],
              [61.43731408700012, 53.446506247000045],
              [61.41230269400012, 53.43575754900003],
              [61.38160689300014, 53.43611928400013],
              [61.35349491400012, 53.44981353800004],
              [61.32838016700009, 53.47074249300003],
              [61.30708947800008, 53.4926533000001],
              [61.28765913900014, 53.50319529200006],
              [61.261097453000104, 53.506657614000105],
              [61.23525923700009, 53.503040264000035],
              [61.21820601400009, 53.4926533000001],
              [61.21427860500012, 53.46185414700004],
              [61.20983443200009, 53.44981353800004],
              [61.200946086000044, 53.43622263700006],
              [61.15598758900006, 53.39669016500004],
              [61.13717736800004, 53.37312571300002],
              [61.13366337100007, 53.34814015800002],
              [61.14275842300009, 53.3230254110001],
              [61.16270552600008, 53.299150899000026],
              [61.20290979000009, 53.27643910700006],
              [61.24952193200005, 53.269695333000115],
              [61.34481327300006, 53.27010874500003],
              [61.379849894000074, 53.26186635400008],
              [61.47803511500007, 53.21512502100008],
              [61.51431197200009, 53.208665467000046],
              [61.54728153500008, 53.211455994000076],
              [61.643089640000085, 53.24334035300005],
              [61.66427697800009, 53.23889617900004],
              [61.70510135900014, 53.203497823000035],
              [61.764219198000035, 53.16946889200007],
              [61.83511926300008, 53.15112376000009],
              [62.05066166200004, 53.124768779000036],
              [62.08321781400008, 53.113296611000024],
              [62.10802250100005, 53.08856943800002],
              [62.11603234900008, 53.06459157300007],
              [62.11365523300009, 53.04187978100002],
              [62.094173218000094, 52.99265798000003],
              [62.094173218000094, 52.99247711200009],
              [62.07267582200012, 52.96958445300008],
              [62.034848674000045, 52.95271209800008],
              [61.95924605400012, 52.93493540500005],
              [61.92255578600003, 52.93816518200005],
              [61.85651330500008, 52.97015289400012],
              [61.81982303900014, 52.97824025500002],
              [61.717813761000116, 52.969946187000076],
              [61.67533573400004, 52.97361521400008],
              [61.655905396000094, 52.970876363000016],
              [61.6364750570001, 52.960101828000106],
              [61.60557255000003, 52.948319601],
              [61.57425663200007, 52.95583852100005],
              [61.51462203000011, 52.992554626000114],
              [61.47803511500007, 53.012346700000094],
              [61.448269491000076, 53.02141591400006],
              [61.42429162600007, 53.017359314000046],
              [61.37664595500013, 52.99265798000003],
              [61.34936079900007, 52.98490651500005],
              [61.318458293000106, 52.98250356000007],
              [61.28734908000007, 52.985164897000104],
              [61.25872033700006, 52.99265798000003],
              [61.22492395100011, 53.00640391100008],
              [61.1903007410001, 53.01314768500002],
              [61.15578088400008, 53.00968536400008],
              [61.12270796700011, 52.99265798000003],
              [61.12260461500006, 52.99263214200003],
              [61.12239790900014, 52.99247711200009],
              [61.12229455500011, 52.99247711200009],
              [61.08860152200003, 52.97805938800006],
              [61.052428020000036, 52.971858216],
              [60.97543013500007, 52.9715481570001],
              [60.974603312000056, 52.97123809800003],
              [60.97543013500007, 52.970462952],
              [61.05842248500005, 52.92217132600008],
              [60.8848930260001, 52.82525217700005],
              [60.86690962800003, 52.81225555400003],
              [60.843035116000124, 52.78404022200006],
              [60.829082479000135, 52.771637879000096],
              [60.78743127500013, 52.75791778600005],
              [60.73864872200005, 52.75094146800008],
              [60.696170695000035, 52.73492177400003],
              [60.67353641700009, 52.69386484800005],
              [60.672192830000085, 52.682625224],
              [60.672606242000086, 52.67216074700006],
              [60.67684370900008, 52.66358245900004],
              [60.68666223100013, 52.658053081000034],
              [60.69968469200006, 52.652756246000095],
              [60.704128866000076, 52.64717519200006],
              [60.70609257000012, 52.64056060800009],
              [60.71167362500012, 52.63224070300002],
              [60.724489380000136, 52.626220398000086],
              [60.74164595600007, 52.62536773700005],
              [60.793115682000064, 52.62880422000008],
              [60.80314091000008, 52.627744853000095],
              [60.80841190600012, 52.62118194600002],
              [60.81347619600007, 52.60549814900004],
              [60.814406372000064, 52.585861105],
              [60.80996219900004, 52.53842214000012],
              [60.81492313700011, 52.521911520000046],
              [60.83135624200014, 52.51315236400005],
              [60.92396040900013, 52.49374786400007],
              [60.93646610500008, 52.48858022100008],
              [60.944630981000046, 52.479071757],
              [60.95145227100011, 52.4610883590001],
              [60.955896443000086, 52.419824728],
              [60.96137414600008, 52.40197052000006],
              [60.97801395700009, 52.387604472000035],
              [61.03992232300004, 52.334997864000044],
              [61.008503052000094, 52.314999085000025],
              [60.96581831900011, 52.29957367000013],
              [60.947421508000104, 52.289729310000055],
              [60.89667525200008, 52.25469268900004],
              [60.876728150000076, 52.24590769500004],
              [60.78123010300004, 52.220612081000084],
              [60.76293664500008, 52.210199280000055],
              [60.72283573400006, 52.16958160500009],
              [60.672192830000085, 52.144337667000045],
              [60.61813928200013, 52.14294240300008],
              [60.562432088000094, 52.15033213300008],
              [60.506518189000076, 52.15164988200003],
              [60.42579960100005, 52.12958404600003],
              [60.347664836000035, 52.08961232500009],
              [60.20276412000004, 51.99274485300005],
              [60.02977585700012, 51.992610475000035],
              [60.00318973800012, 51.992512309000105],
              [59.98727339700008, 51.968844504000074],
              [59.9857231040001, 51.95228220700007],
              [59.99461145000009, 51.9362883510001],
              [60.04008671100007, 51.87120188400003],
              [60.06075728400009, 51.858670349000036],
              [60.092279907000034, 51.85476877900008],
              [60.11780806400009, 51.86355377200006],
              [60.12648970600014, 51.87910837800008],
              [60.138065226000094, 51.888875224000046],
              [60.171964966000075, 51.88037445100012],
              [60.27449100700005, 51.832832134000014],
              [60.45205122900006, 51.80546946300008],
              [60.479749797000125, 51.78425628700002],
              [60.47551232900008, 51.776194764000124],
              [60.465797160000136, 51.76919260700002],
              [60.44585005700009, 51.76004587900003],
              [60.44016565000004, 51.75394806000007],
              [60.44119917800003, 51.73622304300007],
              [60.437375122000105, 51.72839406400003],
              [60.41835819500005, 51.71935068800006],
              [60.37153934800011, 51.70516550700002],
              [60.35603641800003, 51.69227223700001],
              [60.35510624200003, 51.67142079700007],
              [60.375880167000105, 51.66253245100005],
              [60.48471073400009, 51.651034445],
              [60.49535608000008, 51.64625437400012],
              [60.498456665000106, 51.637159323000034],
              [60.4999036050001, 51.62710825700002],
              [60.50579471800012, 51.6197702030001],
              [60.51509647600011, 51.61790985100002],
              [60.92106652900014, 51.611476136000064],
              [60.937396281000076, 51.61116607700008],
              [60.933468872000105, 51.59842783600003],
              [60.934399048000046, 51.565820008000074],
              [60.937396281000076, 51.55687998500004],
              [60.944630981000046, 51.54437428800013],
              [60.958997030000035, 51.52486643500005],
              [60.9709859620001, 51.5156163540001],
              [61.00395552600014, 51.50068186500006],
              [61.01067346200006, 51.49623769100005],
              [61.015220988000124, 51.49207773900012],
              [61.01894169100012, 51.488667094],
              [61.023282511000104, 51.48551483200005],
              [61.02938033000004, 51.48267262800006],
              [61.038061971000104, 51.48019215900008],
              [61.04850061000013, 51.478900249000034],
              [61.081470175000106, 51.48019215900008],
              [61.101830688000064, 51.47815094000005],
              [61.141518188000134, 51.46918508],
              [61.16404911300003, 51.467143861000054],
              [61.23298547400009, 51.47055450500007],
              [61.257170044000134, 51.467143861000054],
              [61.29148319500007, 51.45502573700007],
              [61.30491906800012, 51.45288116500008],
              [61.31835494000006, 51.453449606000035],
              [61.34212609900004, 51.45843638200007],
              [61.35618208800014, 51.459650778000096],
              [61.393699179000066, 51.44983225600005],
              [61.437624146000076, 51.43223643000006],
              [61.47379764800013, 51.42580271400003],
              [61.47803511500007, 51.42115183600005],
              [61.49839563000006, 51.40053293900006],
              [61.53870324700006, 51.32317332000004],
              [61.56299117000003, 51.29552642900002],
              [61.59317020700013, 51.2778272500001],
              [61.646258531000115, 51.263192932000024],
              [61.66365686000012, 51.25839691200004],
              [61.61105025300009, 51.24925018300006],
              [61.56733199100012, 51.233876445000064],
              [61.534155721000104, 51.2060745240001],
              [61.51317509000012, 51.159514059000074],
              [61.465426066000134, 50.99265085900002],
              [61.45674442600006, 50.96500396800012],
              [61.441758260000086, 50.874983622000045],
              [61.42687544800003, 50.83307403600007],
              [61.40403446500005, 50.80258494100009],
              [61.37209843000005, 50.78248280800004],
              [61.09521610550007, 50.72269317600008],
              [60.818333781000035, 50.66290354400003],
              [60.718494914000075, 50.65267161100006],
              [60.300432577000095, 50.68465932300005],
              [60.24544885200004, 50.70197092800005],
              [60.20948205500008, 50.719747620000064],
              [60.17671919700007, 50.74217519200006],
              [60.15480839000014, 50.77090728800009],
              [60.15212121600007, 50.80770090700007],
              [60.13620487500009, 50.844494528000084],
              [60.08328820800011, 50.85715525400012],
              [60.02127648900006, 50.85405466700006],
              [59.97807499200013, 50.84377105700007],
              [59.96908329300004, 50.837363180000025],
              [59.962158651000095, 50.829508362000084],
              [59.920197388000076, 50.763052470000034],
              [59.91461633300008, 50.74589589500009],
              [59.91389286300006, 50.726000468000066],
              [59.91957727100004, 50.69091217000003],
              [59.91513309700008, 50.673807272],
              [59.90397098800008, 50.66026804700003],
              [59.87203495300008, 50.635980123000124],
              [59.85921919800012, 50.622544251000065],
              [59.81570764200006, 50.56290964800006],
              [59.77467655500004, 50.53371246400003],
              [59.725480591000064, 50.52766632200009],
              [59.67308068900013, 50.52952667300009],
              [59.62223107900013, 50.524100647000026],
              [59.58771122300004, 50.50616892600006],
              [59.55505171700008, 50.484361471000014],
              [59.522805623000124, 50.47464630200007],
              [59.466271606000134, 50.507357483000064],
              [59.45076867700004, 50.52229197200002],
              [59.451698853000096, 50.53727813800002],
              [59.47815718600009, 50.55241933300003],
              [59.53531132000012, 50.54657989500002],
              [59.56042606600005, 50.553814596000095],
              [59.56342330000007, 50.57985951800008],
              [59.55102095500007, 50.58600901300004],
              [59.49810428900008, 50.599703267000066],
              [59.47815718600009, 50.61437937400005],
              [59.437642863000065, 50.6311225380001],
              [59.386483195000096, 50.630347392],
              [59.29077844300008, 50.61546458000005],
              [59.27331180800013, 50.615981344],
              [59.25904911300006, 50.620373840000084],
              [59.246956828000066, 50.62962392200008],
              [59.23569136600008, 50.64461008700006],
              [59.219361613000046, 50.658356018000106],
              [59.19745080600012, 50.66274851600009],
              [58.925942830000054, 50.678148092000086],
              [58.88677209500008, 50.688948466000014],
              [58.811531209000066, 50.72548370400004],
              [58.79396122300005, 50.73767934200005],
              [58.78507287600007, 50.7497199510001],
              [58.768433065000124, 50.78268951500009],
              [58.74776249200005, 50.79509185800005],
              [58.71954716000005, 50.793489889000014],
              [58.689781535000066, 50.78837392200002],
              [58.664356730000065, 50.789924215000056],
              [58.64668339000008, 50.801293030000025],
              [58.643892863000076, 50.81467722600006],
              [58.65123091600009, 50.85327952100006],
              [58.64099898300003, 50.86340810100002],
              [58.5904594320001, 50.86108266200007],
              [58.57144250500011, 50.86351145500005],
              [58.559970337000095, 50.8751903280001],
              [58.55015181500005, 50.89327707900013],
              [58.54653446400005, 50.91193227100008],
              [58.5543892820001, 50.92541982100006],
              [58.570822387000135, 50.93596181300002],
              [58.58529178800006, 50.947795716000044],
              [58.59635054600011, 50.96247182200004],
              [58.60265507000008, 50.98123036700012],
              [58.595006959000045, 51.023372498000086],
              [58.563484334000066, 51.049262390000095],
              [58.52048954300005, 51.061948954000044],
              [58.398016398000095, 51.06370595400004],
              [58.37796594300005, 51.070656433000025],
              [58.37083459500013, 51.08192189500009],
              [58.369284302000096, 51.09507354800006],
              [58.3659770110001, 51.10892283200012],
              [58.35357466600004, 51.12199696900008],
              [58.32339563000011, 51.14194407100008],
              [58.30840946500007, 51.1500314340001],
              [58.26810184700008, 51.13455434200007],
              [58.24526086500009, 51.13073028600006],
              [58.22376346900006, 51.123133851],
              [58.211464477000106, 51.104943746000046],
              [58.20236942600013, 51.0834463500001],
              [58.19058719900005, 51.06554046600003],
              [58.16764286300008, 51.0551793420001],
              [58.14056441300005, 51.05665212000012],
              [58.113692667000066, 51.065178732000035],
              [58.09095503800006, 51.07610829700009],
              [58.08961145000012, 51.07962229500005],
              [58.08971480400004, 51.085616761],
              [58.0887846280001, 51.09192128500008],
              [58.0841337490001, 51.09662384000008],
              [58.07731245900004, 51.09794159000005],
              [58.001658162000126, 51.089776713000035],
              [57.988428996000096, 51.08742543600009],
              [57.96021366400004, 51.07747772300009],
              [57.95008508300009, 51.07920888300005],
              [57.934065389000125, 51.09396250400006],
              [57.92507369000009, 51.0996469120001],
              [57.91225793400008, 51.10339345400011],
              [57.85768762200007, 51.10339345400011],
              [57.841771281000035, 51.10579640700006],
              [57.79619266800006, 51.12326304200012],
              [57.76880415800014, 51.11967153000005],
              [57.7528878170001, 51.097476502000106],
              [57.73438765500009, 51.0738862110001],
              [57.728186483000115, 51.03709259100002],
              [57.73790165200006, 50.97089508100002],
              [57.73728153500008, 50.938235576000054],
              [57.72239872300014, 50.90872833300004],
              [57.68922245300013, 50.89673940100006],
              [57.596204875000126, 50.91570465100001],
              [57.55589725800007, 50.91875356100006],
              [57.53284956900012, 50.90996856800005],
              [57.519930461000115, 50.89658437100003],
              [57.508871704000114, 50.88128814700006],
              [57.49140507000004, 50.866870423000066],
              [57.46763391200011, 50.85849884100007],
              [57.44303592900013, 50.857775370000084],
              [57.41812788900006, 50.862374573000025],
              [57.35270552600008, 50.88599070300005],
              [57.334308716000066, 50.89741119400004],
              [57.318909139000084, 50.913224183000054],
              [57.31012414600008, 50.92934722900013],
              [57.29761844900008, 50.9649522910001],
              [57.28852339700006, 50.98123036700012],
              [57.27291711400011, 50.99745676700003],
              [57.256277303000104, 51.006035055000055],
              [57.237157023000066, 51.00949737600011],
              [57.21359257000006, 51.01011749300007],
              [57.1974695240001, 51.017352194000054],
              [57.18992476400007, 51.0348446660001],
              [57.181243123000115, 51.0734986370001],
              [57.16822066200007, 51.093781637000106],
              [57.15447473200004, 51.09995697100008],
              [57.13793827300003, 51.09587453200008],
              [57.07241255700012, 51.069726257000056],
              [57.025180298000066, 51.06267242500006],
              [56.941051066000114, 51.06833099400008],
              [56.915832967000085, 51.06417104100005],
              [56.891234986000086, 51.0565746060001],
              [56.86508671100006, 51.0517686970001],
              [56.83862837700008, 51.051406962],
              [56.81361698400008, 51.057039694000125],
              [56.776306600000055, 51.07597910600008],
              [56.76008020000006, 51.08024241100013],
              [56.735585572000105, 51.0775810760001],
              [56.716051880000066, 51.07246510800012],
              [56.69455448400004, 51.06349924700008],
              [56.68029178900008, 51.04977915500005],
              [56.68246219900004, 51.03052968400003],
              [56.70271936000006, 50.99818023700003],
              [56.70964400200006, 50.98159210200002],
              [56.70747359200004, 50.970429993],
              [56.68835331200006, 50.96913808200004],
              [56.61662642400006, 50.97833648700005],
              [56.59657596800014, 50.984020895000086],
              [56.508002564000094, 51.06626393700013],
              [56.47834029100011, 51.07303354900007],
              [56.44650760900004, 51.0565746060001],
              [56.43069462100004, 51.04543833400008],
              [56.42118615800007, 51.03352691700003],
              [56.42035933400007, 51.01864410399999],
              [56.43193485600011, 50.98980865500006],
              [56.43203820800005, 50.976217754000075],
              [56.415811808000115, 50.96267852800007],
              [56.364962199000104, 50.95787262000009],
              [56.35049279800006, 50.94800242100008],
              [56.343878215000075, 50.91141550800005],
              [56.33571333800006, 50.895860901000034],
              [56.315456177000044, 50.883820293000056],
              [56.28858443200005, 50.880306295000096],
              [56.258198690000086, 50.88449208600004],
              [56.174896281000144, 50.90867665600011],
              [56.15835982300007, 50.90552439400007],
              [56.14750777200004, 50.89229522700005],
              [56.13737919100009, 50.86878245100006],
              [56.10006880700013, 50.74785959900002],
              [56.078881470000056, 50.724760234000044],
              [55.93232710800004, 50.64652211500008],
              [55.76489546800008, 50.58683583600008],
              [55.694305461000056, 50.5387767540001],
              [55.659992310000064, 50.53004343700003],
              [55.61679081300014, 50.549938864000055],
              [55.5861983640001, 50.57841257800008],
              [55.570385376000104, 50.58833445300006],
              [55.524289998000086, 50.60068512000002],
              [55.51374800600013, 50.61401764000006],
              [55.505686483000034, 50.63024403900006],
              [55.49111372900006, 50.6458503220001],
              [55.46775598100004, 50.656960755000014],
              [55.442331177000085, 50.661663310000094],
              [55.41597619600003, 50.66140492700002],
              [55.366056763000074, 50.652464906],
              [55.34776330600005, 50.651379700000106],
              [55.329366496000034, 50.655152080000036],
              [55.305388631000085, 50.664970602],
              [55.08400679500005, 50.796900534000045],
              [55.0613725180001, 50.82268707300004],
              [55.063232870000036, 50.86216786700008],
              [55.047729940000124, 50.88423370400007],
              [54.894250936000105, 50.912397359000025],
              [54.861281372000064, 50.933894755000054],
              [54.83120568800007, 50.95931956000008],
              [54.811671997000076, 50.97239369700013],
              [54.746249634000094, 50.99296091700002],
              [54.706872192000105, 51.01629282700004],
              [54.685788208000076, 51.02355336600003],
              [54.66222375500007, 51.02789418500002],
              [54.638245890000064, 51.02768748000004],
              [54.55266971800006, 51.01016916900009],
              [54.53375614500004, 51.003244527],
              [54.52528120900007, 50.991100566000014],
              [54.54595178300008, 50.95327341800002],
              [54.534686320000105, 50.94360992500002],
              [54.51587609900008, 50.93725372300007],
              [54.502956991000076, 50.928262024000034],
              [54.52600467900004, 50.91642812100012],
              [54.58367557800011, 50.9056794240001],
              [54.638245890000064, 50.88573232000009],
              [54.65178511500011, 50.846251526000046],
              [54.645997356000066, 50.83772491500004],
              [54.62987430800007, 50.820309957000106],
              [54.62687707600014, 50.81157664000004],
              [54.63018436700014, 50.80367014600007],
              [54.645377238000094, 50.79266306600009],
              [54.65023482300012, 50.78630686500007],
              [54.65095829300009, 50.765636291000035],
              [54.638659301000075, 50.72801584900013],
              [54.639072713000076, 50.706983541000014],
              [54.67359257000004, 50.63432647700007],
              [54.6762797450001, 50.60254547100003],
              [54.64754764800006, 50.57324493400007],
              [54.591427042000134, 50.54234242800008],
              [54.55070601400007, 50.53133534800007],
              [54.54551683900013, 50.53051930800005],
              [54.499442993000116, 50.5232738240001],
              [54.47856571500006, 50.52596099900002],
              [54.455724732000135, 50.535521139000124],
              [54.43577762800004, 50.547510071],
              [54.39950077300006, 50.578670959000036],
              [54.383584432000134, 50.59990997300012],
              [54.379760376000036, 50.61944366500002],
              [54.38534143000004, 50.63944244400007],
              [54.40714888600007, 50.68481435100007],
              [54.41241988100006, 50.704037984000095],
              [54.41438358600004, 50.74847971600009],
              [54.42192834500008, 50.76868520100008],
              [54.47856571500006, 50.81571075400005],
              [54.48528365100009, 50.8254259240001],
              [54.48786747200006, 50.83555450500005],
              [54.48590376800007, 50.84511464400005],
              [54.47856571500006, 50.85348622700012],
              [54.464303019000056, 50.85803375300004],
              [54.419654582000135, 50.86449330700002],
              [54.40993941300013, 50.86873077400007],
              [54.39164595600005, 50.88051300100007],
              [54.38100061100005, 50.88542226200009],
              [54.30007531800004, 50.89472401900012],
              [54.275787395000066, 50.90428416000002],
              [54.26028446500004, 50.91740997400008],
              [54.24767541500012, 50.931000876000084],
              [54.23351607300009, 50.94309316100005],
              [54.19403527900005, 50.95818267800006],
              [54.1765686440001, 50.967897848000106],
              [54.14535607900012, 50.99265085900002],
              [54.14907678200012, 51.00965240500004],
              [54.14566613800008, 51.01965179400007],
              [54.138328085000126, 51.028643494],
              [54.12995650300013, 51.042337749000026],
              [54.120137980000095, 51.08117258700007],
              [54.11155969200013, 51.09600372400011],
              [54.09192264800009, 51.1052279660001],
              [54.03983280500006, 51.11036977200011],
              [54.01761193800013, 51.119077251000064],
              [53.99404748600011, 51.153390401000095],
              [53.974720500000046, 51.16649037700007],
              [53.9358598230001, 51.185610657000055],
              [53.90898807800011, 51.19044240300006],
              [53.857725057000096, 51.18460296700009],
              [53.67386031100011, 51.21987213200008],
              [53.64936568200005, 51.237338766],
              [53.642544393000094, 51.255425517000035],
              [53.627971639000066, 51.267776184000084],
              [53.59407189900014, 51.28942861000006],
              [53.58859419800007, 51.305344951000095],
              [53.59314172300009, 51.32260487900008],
              [53.59324507700012, 51.33911549900007],
              [53.574434855000106, 51.3532231650001],
              [53.60936812400007, 51.364101054000045],
              [53.617946411000105, 51.37213673900003],
              [53.610298300000125, 51.38841481500005],
              [53.59748254400006, 51.39717397100004],
              [53.555417928000054, 51.41551910400004],
              [53.45340865100013, 51.44189992300009],
              [53.43966272000006, 51.45115000400001],
              [53.419198852000136, 51.47489532500005],
              [53.40731327300011, 51.48417124500007],
              [53.36948612500004, 51.4938864140001],
              [53.36690230300013, 51.49360219400005],
              [53.34633508300004, 51.503033142],
              [53.32235721900008, 51.495333354000095],
              [53.307371053000054, 51.49383473800002],
              [53.232233520000136, 51.50068186500006],
              [53.226032349000036, 51.49949330700004],
              [53.22055464600004, 51.49647023500002],
              [53.21414676900008, 51.494764913000054],
              [53.20494836500012, 51.49721954400012],
              [53.19864383900011, 51.50243886300005],
              [53.19512984200014, 51.50804575700006],
              [53.19047896400008, 51.51248993000006],
              [53.18107385300004, 51.514298605000064],
              [53.16577762900005, 51.514556987000034],
              [53.15327193200005, 51.51267079700001],
              [53.14862105300011, 51.50476430300007],
              [53.15719934100014, 51.48701344900006],
              [53.03710331200011, 51.48972646099999],
              [52.99886275300008, 51.48019215900008],
              [52.98584029200009, 51.47269907700006],
              [52.973231242000054, 51.463604025000095],
              [52.95979536900012, 51.45585256000008],
              [52.94429244000008, 51.45288116500008],
              [52.92920292200006, 51.455361634000056],
              [52.90336470500006, 51.46499928900006],
              [52.88279748500008, 51.467143861000054],
              [52.89654341700003, 51.48528228800008],
              [52.87628625500008, 51.49008819600009],
              [52.82068241400009, 51.48701344900006],
              [52.81096724500014, 51.49073415200006],
              [52.789676554000096, 51.50476430300007],
              [52.77975468000005, 51.50812327100009],
              [52.764665161000096, 51.505255229000014],
              [52.757327108000084, 51.49794301400003],
              [52.7525728760001, 51.4904757690001],
              [52.745544882000104, 51.48701344900006],
              [52.721463664000055, 51.48515309700004],
              [52.7094747320001, 51.48207835],
              [52.70089644300003, 51.47675567700007],
              [52.69231815600011, 51.4684357710001],
              [52.67981245900012, 51.45900482200004],
              [52.66854699700008, 51.455129090000085],
              [52.66368941300004, 51.463448995000036],
              [52.57506433100008, 51.467143861000054],
              [52.553670288000035, 51.457971294000046],
              [52.545815470000036, 51.459521586000065],
              [52.52498986900014, 51.46753143300005],
              [52.505817912000055, 51.478874410000046],
              [52.4902116290001, 51.49259450400005],
              [52.47884281400013, 51.504867656],
              [52.47243493700006, 51.51502207500006],
              [52.44452966300008, 51.58018605600007],
              [52.37766036000005, 51.660103659000086],
              [52.36458622300006, 51.69028269500008],
              [52.352132202000064, 51.730202739000035],
              [52.33487227300009, 51.76371490500013],
              [52.307793823000054, 51.77454111700008],
              [52.292239218000134, 51.765626933000064],
              [52.2795784920001, 51.73534454400003],
              [52.258184448000065, 51.724208273],
              [52.230175822000035, 51.72245127400002],
              [52.174106893000044, 51.72524180100008],
              [52.14801029400013, 51.71606923500009],
              [52.13333418800005, 51.70203908300006],
              [52.111009969000065, 51.67030975300004],
              [52.09178633600004, 51.65870839500009],
              [52.065948120000144, 51.653437399000055],
              [52.03525231900011, 51.65240387000007],
              [52.00455651900006, 51.65485850000006],
              [51.97861495000012, 51.66036204000004],
              [51.95251835100004, 51.67095570900004],
              [51.92476810700009, 51.67826792400011],
              [51.89675948100006, 51.679740703],
              [51.86916426600004, 51.67307444300009],
              [51.85087080900007, 51.661653951000105],
              [51.82017500900014, 51.632973532],
              [51.76472619600008, 51.59331187000002],
              [51.7677751060001, 51.562977804000084],
              [51.782967977000055, 51.52982737200007],
              [51.782296184000074, 51.49285288500003],
              [51.74431400600014, 51.473448385000054],
              [51.6933093670001, 51.4540955610001],
              [51.64736901800012, 51.45122751900003],
              [51.62442468200004, 51.48101898200012],
              [51.62297774300009, 51.50424753800003],
              [51.620497274000115, 51.51869110200006],
              [51.609955281000055, 51.527734477000095],
              [51.58432377100007, 51.534917501000066],
              [51.559829143000115, 51.53458160400008],
              [51.5447396240001, 51.524117127000025],
              [51.532078898000066, 51.508407492000075],
              [51.51497399900012, 51.49269785600008],
              [51.461850626000114, 51.47528289900005],
              [51.3794783940001, 51.46709218400004],
              [51.304237508000085, 51.471639710000076],
              [51.27302494300011, 51.49259450400005],
              [51.27302494300011, 51.49287872300003],
              [51.2638265380001, 51.504893494],
              [51.24780684400014, 51.521094055],
              [51.2365413820001, 51.53589935300003],
              [51.24165734800005, 51.543702494000044],
              [51.33917077700005, 51.55501963300013],
              [51.358962850000125, 51.56147918699999],
              [51.373173869000084, 51.57160776800005],
              [51.38113203900008, 51.58705902100003],
              [51.38195886200009, 51.609796652000014],
              [51.37193363500006, 51.62958872500009],
              [51.352503296000066, 51.636229147000094],
              [51.30847497500014, 51.63705597000002],
              [51.28842452000009, 51.642869568],
              [51.276228881000065, 51.65160288500006],
              [51.25183760600004, 51.67852630700007],
              [51.233854207000036, 51.68547678600008],
              [51.21256351800008, 51.68175608300005],
              [51.19023929800011, 51.67410797200007],
              [51.16977543100012, 51.66948293100002],
              [50.92544926000005, 51.679689026000105],
              [50.90074792500013, 51.687130433000036],
              [50.88431481900005, 51.70555308100002],
              [50.8736694750001, 51.721882833000066],
              [50.857753133000074, 51.735292868],
              [50.83925297000013, 51.74552480100009],
              [50.82085616100005, 51.75255279600002],
              [50.76700931800008, 51.75939992300006],
              [50.7441683350001, 51.74237253900013],
              [50.74737227400004, 51.709041240000076],
              [50.794501180000054, 51.625971375000105],
              [50.790677124000126, 51.59729095500002],
              [50.76432214400006, 51.578661601000064],
              [50.71998376500011, 51.567421977],
              [50.69652266500003, 51.56558746400002],
              [50.67089115400006, 51.56752533000012],
              [50.65869551600008, 51.57618113200009],
              [50.675025269000116, 51.59439707500003],
              [50.69419722500004, 51.61116607700008],
              [50.685773967000046, 51.6156360880001],
              [50.639265177000084, 51.61617869100006],
              [50.59983606000009, 51.634730530000084],
              [50.58169763200004, 51.63529897100004],
              [50.57761519400003, 51.61336232500007],
              [50.57570316600004, 51.58842844700011],
              [50.56185388200004, 51.5806511440001],
              [50.5428369550001, 51.5773696910001],
              [50.52537032100014, 51.56558746400002],
              [50.52216638200008, 51.55075632800008],
              [50.531364787000086, 51.49269785600008],
              [50.527230672000144, 51.47008941700004],
              [50.51834232600004, 51.459754130000036],
              [50.502684366000096, 51.45613678000005],
              [50.47896488400005, 51.45373382600009],
              [50.47105839000011, 51.4361121620001],
              [50.45746748800008, 51.42688792000011],
              [50.43922570800004, 51.423012187000054],
              [50.37964278200013, 51.42115183600005],
              [50.36744714400004, 51.41895558700007],
              [50.3595923260001, 51.41332285600002],
              [50.36444991000013, 51.40691497799999],
              [50.372924845000114, 51.40104970300008],
              [50.376232137000045, 51.397018942],
              [50.361866089000046, 51.38738128700008],
              [50.34672489400003, 51.381205953000105],
              [50.33757816600013, 51.372033387],
              [50.34042037000012, 51.35286143100011],
              [50.347448365000105, 51.33523976700012],
              [50.34894698000011, 51.32260487900008],
              [50.34228072100012, 51.312734681000094],
              [50.325382528000034, 51.30345876100007],
              [50.207456909000086, 51.26594167100008],
              [50.02875980600004, 51.242997336000045],
              [49.98685022000012, 51.22981984500008],
              [49.84282800300008, 51.15067738900005],
              [49.79590580300004, 51.1095687870001],
              [49.77905928600006, 51.10217905700007],
              [49.53974572800013, 51.100783794],
              [49.460112345000084, 51.11615753200009],
              [49.43654789200008, 51.112333476000046],
              [49.423112020000076, 51.10199819000003],
              [49.41060632300014, 51.08553924600007],
              [49.40104618300006, 51.067090760000056],
              [49.39272627700012, 51.03419871100003],
              [49.38332116700013, 51.019393413],
              [49.35913659700009, 50.99265085900002],
              [49.34735437000006, 50.96428049700002],
              [49.37153894100004, 50.93942413400008],
              [49.405490357000076, 50.91353424100002],
              [49.423732137000115, 50.88206329300009],
              [49.40843591400005, 50.848266907],
              [49.369420207000076, 50.82676951200007],
              [49.28368900600009, 50.803721823],
              [49.14405928500014, 50.7817076620001],
              [49.102408081000135, 50.757988180000055],
              [49.01269779400013, 50.683419088],
              [48.83043501800012, 50.596034241000055],
              [48.78625166900014, 50.59060821600009],
              [48.739587850000134, 50.597532858000065],
              [48.60879480000011, 50.64791737900005],
              [48.58399011300014, 50.64962270200003],
              [48.56828047700009, 50.63654856400008],
              [48.57293135600014, 50.61685984400002],
              [48.597425985000086, 50.608023174000024],
              [48.64848230000007, 50.60156361900006],
              [48.67339034000014, 50.57954946000008],
              [48.67866133600006, 50.54854360000006],
              [48.67442386900012, 50.478470358000024],
              [48.70129561400012, 50.33460317000002],
              [48.728890829000136, 50.26540842800004],
              [48.77095544500014, 50.211044820000055],
              [48.78904219600008, 50.173010966000035],
              [48.780980672000055, 50.13756093400009],
              [48.782841024000106, 50.111464335],
              [48.851829061000046, 50.09725331600005],
              [48.865523315000075, 50.08619456000004],
              [48.8741016030001, 50.06981313100009],
              [48.88588383000007, 50.03043568900007],
              [48.88567712400004, 50.01989369700003],
              [48.87818404100011, 50.01002349900004],
              [48.862009318000105, 49.992918600000095],
              [48.78459802200007, 49.93338735000002],
              [48.683518921000086, 49.89545684800002],
              [48.47908695500007, 49.84316029900002],
              [48.46585778800005, 49.83582224600009],
              [48.44281010000009, 49.81499664300004],
              [48.42989099100009, 49.809673971],
              [48.41759200100006, 49.811689351000055],
              [48.35950769100009, 49.8339618940001],
              [48.31217207800012, 49.86357248900005],
              [48.30287032100006, 49.866724752000025],
              [48.27403487200013, 49.8630557260001],
              [48.23930830900008, 49.86476104800006],
              [48.2271126710001, 49.879488831000074],
              [48.21987797100013, 49.901502991000044],
              [48.200447632000134, 49.92501576800005],
              [48.16086348500011, 49.946461487000064],
              [48.14928796400005, 49.954936422000074],
              [48.14236332200005, 49.96377309200007],
              [48.132234741000104, 49.9837201940001],
              [48.125310099000046, 49.992970277000026],
              [48.11249434400014, 50.02196075500008],
              [48.10598311300009, 50.05064117400006],
              [48.096371297000076, 50.07854644800007],
              [48.074563843000135, 50.10526316300012],
              [48.02474776200012, 50.13125640900007],
              [48.01224206600011, 50.14210846000013],
              [48.00505904100004, 50.15600942000002],
              [48.0003564860001, 50.16970367400002],
              [47.99322513900006, 50.18179596000003],
              [47.9536409910001, 50.204895325000095],
              [47.91343672700009, 50.24385935500008],
              [47.87405928600009, 50.266441956],
              [47.85452559400005, 50.28504547200008],
              [47.80822351000006, 50.31992706300004],
              [47.79597619700007, 50.32478464800006],
              [47.77649418100003, 50.32979726200004],
              [47.76693404200006, 50.33718699200004],
              [47.76026778200014, 50.347160543000044],
              [47.74910567200004, 50.36023468100008],
              [47.73494633000007, 50.37005320300007],
              [47.68998783300003, 50.38633127900009],
              [47.62466882300009, 50.440798238000085],
              [47.59929569500008, 50.4526838180001],
              [47.55692102100011, 50.452580465],
              [47.51149743600007, 50.43692250600013],
              [47.469794555000135, 50.411756084],
              [47.43889205000005, 50.383179017000046],
              [47.43446043500006, 50.37652808400004],
              [47.40628422000009, 50.33424143500004],
              [47.39222823000006, 50.323234355000054],
              [47.322878459000094, 50.304475810000056],
              [47.30567020700005, 50.29486399400004],
              [47.29476648000008, 50.27543365500004],
              [47.30318973800007, 50.26349639900012],
              [47.316987345000086, 50.25290273000003],
              [47.32231001800005, 50.237399801000024],
              [47.31264652500005, 50.22241363600004],
              [47.276266317000136, 50.19988271100003],
              [47.265104207000036, 50.18634348600004],
              [47.27306237800008, 50.15843821300005],
              [47.327632691000076, 50.10929392600012],
              [47.32856286700007, 50.07296539300005],
              [47.30871911600008, 50.04480173800009],
              [47.2455705160001, 49.992350159000054],
              [47.17735762500007, 49.94718495800008],
              [46.95855961100011, 49.88413970900005],
              [46.92259281400004, 49.86135040300006],
              [46.89990686100009, 49.820319316000095],
              [46.83750756900014, 49.57643239400004],
              [46.77510827700007, 49.332545472000064],
              [46.830712118000065, 49.31833445300002],
              [46.97923018400013, 49.24428212500008],
              [47.02863285300003, 49.20149403900005],
              [47.04000166800006, 49.150334371000056],
              [47.020881388000134, 49.09684926400003],
              [46.97923018400013, 49.047291565000066],
              [46.930034220000096, 49.004038391],
              [46.9110172930001, 48.99282460500005],
              [46.88807295700008, 48.98052561500002],
              [46.812935425000035, 48.95375722300004],
              [46.77800215700006, 48.936032207000025],
              [46.75381758600008, 48.914069723000054],
              [46.620191910000074, 48.669596618000085],
              [46.47931237800009, 48.41185231600009],
              [46.47858890800012, 48.41115468400001],
              [46.47827884900005, 48.410560405000055],
              [46.47858890800012, 48.41022450800007],
              [46.47931237800009, 48.41022450800007],
              [46.72927128100014, 48.352088522000074],
              [46.97923018400013, 48.29395253600008],
              [47.078293905000066, 48.27534902000012],
              [47.09891280100004, 48.265375468000016],
              [47.111831909000045, 48.2509835820001],
              [47.112120535000145, 48.24220453800005],
              [47.11214196800006, 48.24155263300004],
              [47.09860274300007, 48.22258738200007],
              [47.091988159000095, 48.217316387000054],
              [47.081549520000124, 48.21183868400006],
              [47.07524499600004, 48.20512074800003],
              [47.0803092860001, 48.19597401900005],
              [47.10263350400004, 48.180290222000096],
              [47.10883467600007, 48.17398569800007],
              [47.11648278800004, 48.153857727000016],
              [47.111573527000076, 48.136236064000016],
              [47.10408044400003, 48.119234518],
              [47.103563680000036, 48.101199443],
              [47.11948002100013, 48.088280335],
              [47.17394698000004, 48.08419789700007],
              [47.19203373200014, 48.071795553000115],
              [47.17818444800008, 48.05179677400007],
              [47.13705000800013, 48.02725046800002],
              [47.05839847900006, 47.99448761000009],
              [47.0442391360001, 47.986219381000055],
              [47.0511637780001, 47.974643860000114],
              [47.121650431000035, 47.91544850700002],
              [47.1553434650001, 47.87744049100009],
              [47.15865075700009, 47.87154937800001],
              [47.15673872900004, 47.86317779500003],
              [47.15172611500009, 47.859095357000015],
              [47.145214885000144, 47.85578806600002],
              [47.13829024300014, 47.84958689400004],
              [47.12516442900011, 47.83209442100009],
              [47.11948002100013, 47.81976959200004],
              [47.12382084200004, 47.80803904200006],
              [47.14056400600009, 47.79266530400007],
              [47.17446374500008, 47.770521953000056],
              [47.359672078000074, 47.68334381100006],
              [47.37424483300009, 47.685824280000034],
              [47.38292647300011, 47.705357971000055],
              [47.38943770300011, 47.75155670200009],
              [47.38881758700012, 47.811914775],
              [47.394191935000094, 47.82679758700006],
              [47.412175334000096, 47.83586680100011],
              [47.435326375000045, 47.834394023000115],
              [47.64973189300014, 47.765586854],
              [48.04448815900008, 47.76969512900003],
              [48.11249434400014, 47.74850779300006],
              [48.17435103400004, 47.71285105400007],
              [48.36059289600007, 47.493097026000086],
              [48.36095463100014, 47.492941997000045],
              [48.41108077000007, 47.44576141400002],
              [48.43753910300006, 47.42919911700001],
              [48.47319584200005, 47.42041412400003],
              [48.510299520000046, 47.417442729000115],
              [48.525078980000046, 47.41023386600007],
              [48.53582767800009, 47.39349070200011],
              [48.546162964000075, 47.369435323000076],
              [48.697264852000046, 47.100976258000046],
              [49.00628991700012, 46.76911021000005],
              [48.948102255000094, 46.7199400840001],
              [48.91688968900013, 46.70257680300007],
              [48.76403080200009, 46.68283640600002],
              [48.739536174000136, 46.690562033000035],
              [48.71266442800004, 46.728776754000094],
              [48.697264852000046, 46.74508066800003],
              [48.67659427900014, 46.75802561500005],
              [48.618199910000044, 46.77042795800013],
              [48.55670495600003, 46.76174631800005],
              [48.50575199400009, 46.73260081000005],
              [48.47908695500007, 46.68345652300009],
              [48.455109090000064, 46.660796407000035],
              [48.474022665000064, 46.659220276],
              [48.49345300300007, 46.65348419300004],
              [48.530039917000124, 46.63818796800008],
              [48.539238322000074, 46.62795603400009],
              [48.541925497000136, 46.61325409000001],
              [48.5468864340001, 46.599275615000025],
              [48.56300948100005, 46.59131744500006],
              [48.53939335100006, 46.567959697],
              [48.57324141500004, 46.55827036600009],
              [48.665225464000116, 46.55718516100008],
              [48.70501631700006, 46.55044138600006],
              [48.732921590000046, 46.53403411900008],
              [48.758553101000075, 46.513131002000094],
              [48.819634643000086, 46.4792571010001],
              [48.844129273000135, 46.478533630000115],
              [48.868727254000135, 46.48235768600004],
              [48.89704593900012, 46.48217681900009],
              [48.91797489400011, 46.47432200200008],
              [48.959884481000074, 46.44525400900007],
              [49.03316166200011, 46.40489471500011],
              [49.22713051952735, 46.32787918423311],
              [49.26384524800005, 46.29336172100005],
              [49.295909050000034, 46.274725653000075],
              [49.30600019600007, 46.26312897300005],
              [49.29851321700005, 46.25177643400008],
              [49.281993035000085, 46.24990469000005],
              [49.26539147200003, 46.257513739000046],
              [49.24919681100005, 46.26732005400004],
              [49.23324629000007, 46.27228424700007],
              [49.19776451900009, 46.27789948100008],
              [49.15967858200008, 46.29193756700005],
              [49.14210045700008, 46.30996328300006],
              [49.16822350400008, 46.32754140800006],
              [49.15015709700003, 46.33576080900008],
              [49.13819420700008, 46.32965729400007],
              [49.119802280000044, 46.30573151200008],
              [49.08814537900008, 46.29450104400007],
              [49.076182488000086, 46.28620026200008],
              [49.07935631600009, 46.27228424700007],
              [49.071299675000034, 46.26825592700004],
              [49.066416863000086, 46.26386139500005],
              [49.058929884000065, 46.25177643400008],
              [49.088226759000065, 46.251166083000044],
              [49.10474694100009, 46.240668036000045],
              [49.111989780000044, 46.221136786000045],
              [49.119476759000065, 46.15875885600008],
              [49.11451256600009, 46.151271877000056],
              [49.09302819100009, 46.16242096600007],
              [49.083994988000086, 46.17177969000005],
              [49.069021030000044, 46.19196198100008],
              [49.058929884000065, 46.19717031500005],
              [49.04224694100009, 46.19623444200005],
              [49.033213738000086, 46.18891022300005],
              [49.02751712300005, 46.18060944200005],
              [49.02076256600009, 46.176662502000056],
              [48.99390709700003, 46.171942450000074],
              [48.955821160000085, 46.14948151200008],
              [48.93482506600009, 46.141913153000075],
              [48.93482506600009, 46.13568756700005],
              [48.95264733200008, 46.112616278000075],
              [48.95533287900008, 46.10781484600005],
              [48.949961785000085, 46.09829336100006],
              [48.94060306100005, 46.08926015800006],
              [48.93181399800005, 46.085272528000075],
              [48.92798912900008, 46.091009833000044],
              [48.92432701900009, 46.11147695500006],
              [48.914398634000065, 46.13198476800005],
              [48.89926191500007, 46.14838288000004],
              [48.88013756600009, 46.15619538000004],
              [48.88168379000007, 46.14288971600007],
              [48.887054884000065, 46.122259833000044],
              [48.88697350400008, 46.10781484600005],
              [48.874034050000034, 46.117621161000045],
              [48.85328209700003, 46.14101797100005],
              [48.83920332100007, 46.14935944200005],
              [48.83179772200003, 46.141913153000075],
              [48.85084069100009, 46.12531159100007],
              [48.86801191500007, 46.09979889500005],
              [48.87419681100005, 46.078192450000074],
              [48.85962975400008, 46.07363515800006],
              [48.84294681100005, 46.08730703300006],
              [48.832367384000065, 46.10765208500004],
              [48.81853274800005, 46.124701239000046],
              [48.791351759000065, 46.128241278000075],
              [48.81983483200008, 46.10346100500004],
              [48.82764733200008, 46.08771393400008],
              [48.82553144600007, 46.06679922100005],
              [48.81788170700008, 46.05621979400007],
              [48.80844160200007, 46.056626695000034],
              [48.80095462300005, 46.06468333500004],
              [48.797618035000085, 46.077053127000056],
              [48.78174889400009, 46.09666575700004],
              [48.74724368600005, 46.118801174000055],
              [48.71412194100009, 46.12958405200004],
              [48.70199629000007, 46.115220445000034],
              [48.69581139400009, 46.115220445000034],
              [48.685557488000086, 46.122381903000075],
              [48.67855879000007, 46.120306708000044],
              [48.66781660200007, 46.10781484600005],
              [48.66537519600007, 46.10236237200007],
              [48.666026238000086, 46.09560781500005],
              [48.66423587300005, 46.08978913000004],
              [48.65455162900008, 46.08730703300006],
              [48.626963738000086, 46.08730703300006],
              [48.64185631600009, 46.08075592700004],
              [48.67367597700007, 46.07282135600008],
              [48.688487175000034, 46.06679922100005],
              [48.71957441500007, 46.03115469000005],
              [48.72624759200005, 46.02521393400008],
              [48.72901451900009, 46.019964911000045],
              [48.72185306100005, 46.00849030200004],
              [48.709971550000034, 45.996975002000056],
              [48.69898522200003, 45.99168528900009],
              [48.68637129000007, 45.989569403000075],
              [48.67172285200007, 45.98411692900004],
              [48.64730879000007, 45.97060781500005],
              [48.64958743600005, 45.963324286000045],
              [48.651377800000034, 45.96051666900007],
              [48.65479576900009, 45.95693594000005],
              [48.67798912900008, 45.96906159100007],
              [48.69906660200007, 45.97260163000004],
              [48.740244988000086, 45.97060781500005],
              [48.75220787900008, 45.96556224200003],
              [48.754893425000034, 45.95416901200008],
              [48.75180097700007, 45.94159577000005],
              [48.74105879000007, 45.92300039300005],
              [48.74244225400008, 45.914129950000074],
              [48.748789910000085, 45.90692780200004],
              [48.75717207100007, 45.90228913000004],
              [48.756602410000085, 45.887925523000035],
              [48.78239993600005, 45.85838450700004],
              [48.791351759000065, 45.84088776200008],
              [48.773773634000065, 45.85057200700004],
              [48.76547285200007, 45.85219961100006],
              [48.74366295700008, 45.84088776200008],
              [48.721446160000085, 45.838324286000045],
              [48.71469160200007, 45.831691799000055],
              [48.71631920700008, 45.81354401200008],
              [48.69516035200007, 45.82802969000005],
              [48.68669681100005, 45.84857819200005],
              [48.691416863000086, 45.868801174000055],
              [48.71013431100005, 45.88182200700004],
              [48.69263756600009, 45.88076406500005],
              [48.67945397200003, 45.88532135600008],
              [48.65479576900009, 45.90228913000004],
              [48.649424675000034, 45.90509674700007],
              [48.643321160000085, 45.907538153000075],
              [48.636729363000086, 45.90912506700005],
              [48.63038170700008, 45.90973541900007],
              [48.62663821700005, 45.91242096600007],
              [48.62232506600009, 45.925034898000035],
              [48.620127800000034, 45.92963288000004],
              [48.593760613000086, 45.958197333000044],
              [48.57341556100005, 45.971136786000045],
              [48.55494225400008, 45.96747467700004],
              [48.522227410000085, 45.95359935100004],
              [48.51710045700008, 45.947333075000074],
              [48.50953209700003, 45.940619208000044],
              [48.49268639400009, 45.939886786000045],
              [48.47510826900009, 45.941107489000046],
              [48.465586785000085, 45.94017161700003],
              [48.45720462300005, 45.93231842700004],
              [48.43474368600005, 45.91551341400009],
              [48.401133660000085, 45.87921784100007],
              [48.393565300000034, 45.86815013200004],
              [48.37940514400009, 45.87641022300005],
              [48.36491946700005, 45.876206773000035],
              [48.35694420700008, 45.86937083500004],
              [48.36280358200008, 45.85761139500005],
              [48.37427819100009, 45.85464101800005],
              [48.407237175000034, 45.85187409100007],
              [48.414073113000086, 45.84393952000005],
              [48.399424675000034, 45.83539459800005],
              [48.30486087300005, 45.84088776200008],
              [48.28874759200005, 45.83734772300005],
              [48.28467858200008, 45.82807038000004],
              [48.28541100400008, 45.81500885600008],
              [48.28370201900009, 45.79987213700008],
              [48.27719160200007, 45.78620026200008],
              [48.26978600400008, 45.77948639500005],
              [48.24968509200005, 45.77195872600004],
              [48.23365319100009, 45.76813385600008],
              [48.22429446700005, 45.76837799700007],
              [48.22087649800005, 45.76520416900007],
              [48.22282962300005, 45.75153229400007],
              [48.22787519600007, 45.742254950000074],
              [48.23568769600007, 45.734442450000074],
              [48.24203535200007, 45.72475820500006],
              [48.242849155000044, 45.70990631700005],
              [48.21599368600005, 45.72475820500006],
              [48.17986087300005, 45.73969147300005],
              [48.14779707100007, 45.743353583000044],
              [48.133555535000085, 45.72418854400007],
              [48.09164472700007, 45.74900950700004],
              [48.078868035000085, 45.75153229400007],
              [48.06381269600007, 45.74599844000005],
              [48.04468834700003, 45.72797272300005],
              [48.02588951900009, 45.72260163000004],
              [48.01921634200005, 45.718451239000046],
              [48.01303144600007, 45.71283600500004],
              [48.00749759200005, 45.700506903000075],
              [48.00025475400008, 45.70498281500005],
              [47.98951256600009, 45.71735260600008],
              [47.98650149800005, 45.71967194200005],
              [47.98218834700003, 45.723944403000075],
              [47.97632897200003, 45.72846100500004],
              [47.96900475400008, 45.731634833000044],
              [47.96143639400009, 45.731634833000044],
              [47.955821160000085, 45.728949286000045],
              [47.95069420700008, 45.72573476800005],
              [47.930430535000085, 45.72174713700008],
              [47.91968834700003, 45.71507396000004],
              [47.89698326900009, 45.693793036000045],
              [47.89185631600009, 45.697251695000034],
              [47.885752800000034, 45.710191148000035],
              [47.87582441500007, 45.72260163000004],
              [47.85914147200003, 45.72418854400007],
              [47.84888756600009, 45.717230536000045],
              [47.84506269600007, 45.70677317900004],
              [47.84546959700003, 45.67983633000006],
              [47.834727410000085, 45.659857489000046],
              [47.83529707100007, 45.649603583000044],
              [47.852305535000085, 45.642279364000046],
              [47.846446160000085, 45.63153717700004],
              [47.838552280000044, 45.62201569200005],
              [47.829112175000034, 45.61408112200007],
              [47.81820722700007, 45.60809967700004],
              [47.77711022200003, 45.652329820000034],
              [47.77035566500007, 45.66583893400008],
              [47.76490319100009, 45.68219635600008],
              [47.75171959700003, 45.69086334800005],
              [47.721364780000044, 45.69684479400007],
              [47.71705162900008, 45.69944896000004],
              [47.71013431100005, 45.70807526200008],
              [47.70492597700007, 45.70990631700005],
              [47.700205925000034, 45.70856354400007],
              [47.69646243600005, 45.70587799700007],
              [47.69255618600005, 45.70359935100004],
              [47.68726647200003, 45.70376211100006],
              [47.67823326900009, 45.70538971600007],
              [47.67156009200005, 45.70575592700004],
              [47.66521243600005, 45.70750560100004],
              [47.65739993600005, 45.71360911700003],
              [47.652679884000065, 45.720404364000046],
              [47.648448113000086, 45.73411692900004],
              [47.64372806100005, 45.74091217700004],
              [47.632823113000086, 45.75067780200004],
              [47.619476759000065, 45.75893789300005],
              [47.60336347700007, 45.76508209800005],
              [47.580414259000065, 45.77090078300006],
              [47.56006920700008, 45.771551825000074],
              [47.55128014400009, 45.76203034100007],
              [47.555349155000044, 45.74359772300005],
              [47.565196160000085, 45.74119700700004],
              [47.57837975400008, 45.74494049700007],
              [47.59229576900009, 45.74461497600004],
              [47.59107506600009, 45.74103424700007],
              [47.60474694100009, 45.718817450000074],
              [47.60661868600005, 45.71735260600008],
              [47.61255944100009, 45.714178778000075],
              [47.62086022200003, 45.71308014500005],
              [47.62614993600005, 45.709051825000074],
              [47.62289472700007, 45.69721100500004],
              [47.62273196700005, 45.68821849200003],
              [47.625743035000085, 45.679022528000075],
              [47.62582441500007, 45.67182038000004],
              [47.61605879000007, 45.66893138200004],
              [47.608083530000044, 45.66746653900009],
              [47.60629316500007, 45.66396719000005],
              [47.60873457100007, 45.659491278000075],
              [47.61264082100007, 45.65525950700004],
              [47.60873457100007, 45.63882070500006],
              [47.623708530000044, 45.63068268400008],
              [47.661143425000034, 45.62177155200004],
              [47.645518425000034, 45.59218984600005],
              [47.64429772200003, 45.57908763200004],
              [47.65365644600007, 45.55906810100004],
              [47.62810306100005, 45.55898672100005],
              [47.61500084700003, 45.57021719000005],
              [47.59913170700008, 45.60809967700004],
              [47.585948113000086, 45.62579987200007],
              [47.54070071700005, 45.66583893400008],
              [47.52906334700003, 45.67047760600008],
              [47.482432488000086, 45.66893138200004],
              [47.472992384000065, 45.67377350500004],
              [47.45622806100005, 45.68773021000004],
              [47.432627800000034, 45.69448476800005],
              [47.43604576900009, 45.70302969000005],
              [47.44646243600005, 45.71206289300005],
              [47.455088738000086, 45.71735260600008],
              [47.463226759000065, 45.718085028000075],
              [47.50342858200008, 45.71735260600008],
              [47.480804884000065, 45.730536200000074],
              [47.42530358200008, 45.734808661000045],
              [47.414073113000086, 45.748114325000074],
              [47.40870201900009, 45.75141022300005],
              [47.39673912900008, 45.75287506700005],
              [47.384776238000086, 45.75018952000005],
              [47.37940514400009, 45.74091217700004],
              [47.383148634000065, 45.73395416900007],
              [47.41065514400009, 45.71360911700003],
              [47.413096550000034, 45.70799388200004],
              [47.412445509000065, 45.69562409100007],
              [47.414073113000086, 45.690659898000035],
              [47.419932488000086, 45.68317291900007],
              [47.427744988000086, 45.67641836100006],
              [47.43189537900008, 45.67527903900009],
              [47.44353274800005, 45.67674388200004],
              [47.448252800000034, 45.67641836100006],
              [47.45362389400009, 45.67210521000004],
              [47.463226759000065, 45.65912506700005],
              [47.468760613000086, 45.65525950700004],
              [47.51514733200008, 45.64948151200008],
              [47.53484134200005, 45.643866278000075],
              [47.55128014400009, 45.62799713700008],
              [47.54818769600007, 45.620794989000046],
              [47.552744988000086, 45.61033763200004],
              [47.55974368600005, 45.59845612200007],
              [47.57016035200007, 45.57371653900009],
              [47.57211347700007, 45.56696198100008],
              [47.57178795700008, 45.55906810100004],
              [47.56771894600007, 45.553615627000056],
              [47.55420983200008, 45.54555898600006],
              [47.55128014400009, 45.542303778000075],
              [47.54232832100007, 45.53705475500004],
              [47.523773634000065, 45.54938385600008],
              [47.508799675000034, 45.57111237200007],
              [47.50961347700007, 45.59389883000006],
              [47.49431399800005, 45.585150458000044],
              [47.493174675000034, 45.571966864000046],
              [47.496429884000065, 45.56525299700007],
              [47.50017337300005, 45.55768463700008],
              [47.526133660000085, 45.52484772300005],
              [47.53646894600007, 45.50771719000005],
              [47.53825931100005, 45.50649648600006],
              [47.53443444100009, 45.50608958500004],
              [47.50147545700008, 45.480454820000034],
              [47.496755405000044, 45.47089264500005],
              [47.49626712300005, 45.46157461100006],
              [47.498789910000085, 45.43813711100006],
              [47.496755405000044, 45.42999909100007],
              [47.47738691500007, 45.42243073100008],
              [47.41911868600005, 45.426662502000056],
              [47.393565300000034, 45.42255280200004],
              [47.38135826900009, 45.411037502000056],
              [47.39535566500007, 45.40493398600006],
              [47.44483483200008, 45.402044989000046],
              [47.45915774800005, 45.39874909100007],
              [47.46013431100005, 45.39081452000005],
              [47.45427493600005, 45.38178131700005],
              [47.448252800000034, 45.37474192900004],
              [47.43246504000007, 45.36969635600008],
              [47.427744988000086, 45.36733633000006],
              [47.42497806100005, 45.36391836100006],
              [47.42318769600007, 45.357855536000045],
              [47.395192905000044, 45.320013739000046],
              [47.38404381600009, 45.29946523600006],
              [47.37940514400009, 45.28221263200004],
              [47.37940514400009, 45.202826239000046],
              [47.370127800000034, 45.185614325000074],
              [47.356455925000034, 45.185248114000046],
              [47.33814537900008, 45.19220612200007],
              [47.314463738000086, 45.196600653000075],
              [47.29712975400008, 45.18744538000004],
              [47.28646894600007, 45.16596100500004],
              [47.27564537900008, 45.12083567900004],
              [47.26124108200008, 45.08502838700008],
              [47.25049889400009, 45.06525299700007],
              [47.22787519600007, 45.03339264500005],
              [47.211680535000085, 44.990301825000074],
              [47.201182488000086, 44.970038153000075],
              [47.180674675000034, 44.97671133000006],
              [47.16578209700003, 44.96698639500005],
              [47.154958530000044, 44.94863515800006],
              [47.14600670700008, 44.92910390800006],
              [47.139659050000034, 44.93821849200003],
              [47.12671959700003, 44.95026276200008],
              [47.11150149800005, 44.95848216400009],
              [47.09880618600005, 44.956366278000075],
              [47.09815514400009, 44.946519273000035],
              [47.111664259000065, 44.869574286000045],
              [47.08448326900009, 44.81753164300005],
              [47.079112175000034, 44.800116278000075],
              [47.07829837300005, 44.78510163000004],
              [47.07146243600005, 44.78510163000004],
              [47.05909264400009, 44.80292389500005],
              [47.02361087300005, 44.842962958000044],
              [47.016286655000044, 44.85797760600008],
              [47.01148522200003, 44.90228913000004],
              [47.00318444100009, 44.921576239000046],
              [46.988942905000044, 44.91543203300006],
              [46.98389733200008, 44.89337799700007],
              [46.99195397200003, 44.87006256700005],
              [47.003916863000086, 44.848089911000045],
              [47.01002037900008, 44.830064195000034],
              [47.00318444100009, 44.817613023000035],
              [46.971446160000085, 44.78375885600008],
              [46.961599155000044, 44.76520416900007],
              [46.943369988000086, 44.77496979400007],
              [46.923838738000086, 44.77204010600008],
              [46.88819420700008, 44.75189850500004],
              [46.867930535000085, 44.74046458500004],
              [46.854502800000034, 44.72540924700007],
              [46.84351647200003, 44.70966217700004],
              [46.83130944100009, 44.69635651200008],
              [46.791677280000044, 44.70604075700004],
              [46.766368035000085, 44.68146393400008],
              [46.74626712300005, 44.65403880400004],
              [46.72201582100007, 44.65534088700008],
              [46.71631920700008, 44.63886139500005],
              [46.707774285000085, 44.56972890800006],
              [46.711599155000044, 44.566392320000034],
              [46.71892337300005, 44.55801015800006],
              [46.72315514400009, 44.54946523600006],
              [46.71827233200008, 44.54547760600008],
              [46.70720462300005, 44.54511139500005],
              [46.69467207100007, 44.543036200000074],
              [46.684580925000034, 44.53790924700007],
              [46.680430535000085, 44.52846914300005],
              [46.683604363000086, 44.50678131700005],
              [46.69776451900009, 44.466457424000055],
              [46.70093834700003, 44.446193752000056],
              [46.711273634000065, 44.43183014500005],
              [46.734385613000086, 44.41478099200003],
              [46.75896243600005, 44.40058014500005],
              [46.77320397200003, 44.39468008000006],
              [46.81763756600009, 44.39468008000006],
              [46.840179884000065, 44.397772528000075],
              [46.851898634000065, 44.39760976800005],
              [47.002614780000044, 44.36733633000006],
              [47.02564537900008, 44.35960521000004],
              [47.04420006600009, 44.34625885600008],
              [47.055430535000085, 44.32770416900007],
              [47.06918379000007, 44.28432851800005],
              [47.07829837300005, 44.26434967700004],
              [47.08871504000007, 44.25153229400007],
              [47.10499108200008, 44.23590729400007],
              [47.12224368600005, 44.222723700000074],
              [47.13607832100007, 44.21710846600007],
              [47.14633222700007, 44.21430084800005],
              [47.166758660000085, 44.20331452000005],
              [47.180023634000065, 44.20286692900004],
              [47.19092858200008, 44.20856354400007],
              [47.21045983200008, 44.22675202000005],
              [47.221690300000034, 44.23078034100007],
              [47.24594160200007, 44.21198151200008],
              [47.26539147200003, 44.16864655200004],
              [47.28988691500007, 44.093003648000035],
              [47.31609134200005, 44.05805084800005],
              [47.333994988000086, 44.03953685100004],
              [47.348643425000034, 44.03156159100007],
              [47.35792076900009, 44.02057526200008],
              [47.38689212300005, 43.95648834800005],
              [47.41228274800005, 43.92597077000005],
              [47.42335045700008, 43.90794505400004],
              [47.427744988000086, 43.88418203300006],
              [47.432627800000034, 43.876166083000044],
              [47.45525149800005, 43.87091705900008],
              [47.461924675000034, 43.86029694200005],
              [47.45948326900009, 43.85179271000004],
              [47.44548587300005, 43.829738674000055],
              [47.441416863000086, 43.81928131700005],
              [47.452159050000034, 43.82298411700003],
              [47.46827233200008, 43.82611725500004],
              [47.482758009000065, 43.82489655200004],
              [47.489268425000034, 43.81557851800005],
              [47.50277754000007, 43.78099192900004],
              [47.50342858200008, 43.77090078300006],
              [47.49545332100007, 43.764837958000044],
              [47.469411655000044, 43.76007721600007],
              [47.45850670700008, 43.75446198100008],
              [47.450205925000034, 43.74591705900008],
              [47.44459069100009, 43.73847077000005],
              [47.433929884000065, 43.71625397300005],
              [47.455088738000086, 43.68895091400009],
              [47.45093834700003, 43.68187083500004],
              [47.44312584700003, 43.677394924000055],
              [47.434580925000034, 43.67357005400004],
              [47.427744988000086, 43.66844310100004],
              [47.40805097700007, 43.63686758000006],
              [47.393565300000034, 43.60639069200005],
              [47.37712649800005, 43.616522528000075],
              [47.37322024800005, 43.62067291900007],
              [47.36573326900009, 43.62067291900007],
              [47.36654707100007, 43.602850653000075],
              [47.371755405000044, 43.579738674000055],
              [47.379893425000034, 43.55971914300005],
              [47.39014733200008, 43.55117422100005],
              [47.404958530000044, 43.54376862200007],
              [47.40381920700008, 43.52757396000004],
              [47.404307488000086, 43.511379299000055],
              [47.42432701900009, 43.503973700000074],
              [47.44849694100009, 43.51813385600008],
              [47.46534264400009, 43.55215078300006],
              [47.47445722700007, 43.593451239000046],
              [47.47584069100009, 43.62954336100006],
              [47.47779381600009, 43.643744208000044],
              [47.48178144600007, 43.65314362200007],
              [47.48878014400009, 43.661322333000044],
              [47.500010613000086, 43.671576239000046],
              [47.50733483200008, 43.68573639500005],
              [47.502696160000085, 43.71503327000005],
              [47.506602410000085, 43.72675202000005],
              [47.52263431100005, 43.74884674700007],
              [47.533864780000044, 43.77594635600008],
              [47.54086347700007, 43.804754950000074],
              [47.54379316500007, 43.83234284100007],
              [47.54184004000007, 43.854722398000035],
              [47.54444420700008, 43.865220445000034],
              [47.554698113000086, 43.87763092700004],
              [47.588226759000065, 43.898138739000046],
              [47.595713738000086, 43.90119049700007],
              [47.625661655000044, 43.90033600500004],
              [47.65284264400009, 43.89667389500005],
              [47.67798912900008, 43.88861725500004],
              [47.701508009000065, 43.87449778900009],
              [47.64380944100009, 43.82990143400008],
              [47.601573113000086, 43.765692450000074],
              [47.54379316500007, 43.62750885600008],
              [47.51970462300005, 43.52000560100004],
              [47.490896030000044, 43.46283600500004],
              [47.48218834700003, 43.42177969000005],
              [47.48324629000007, 43.37970612200007],
              [47.496755405000044, 43.34638092700004],
              [47.488617384000065, 43.32953522300005],
              [47.48682701900009, 43.31085846600007],
              [47.49341881600009, 43.29633209800005],
              [47.50961347700007, 43.29169342700004],
              [47.53435306100005, 43.32062409100007],
              [47.55420983200008, 43.325506903000075],
              [47.570323113000086, 43.33372630400004],
              [47.57740319100009, 43.32965729400007],
              [47.582367384000065, 43.32099030200004],
              [47.58545983200008, 43.312201239000046],
              [47.58570397200003, 43.29954661700003],
              [47.580739780000044, 43.292669989000046],
              [47.57471764400009, 43.28778717700004],
              [47.56495201900009, 43.26805247600004],
              [47.54900149800005, 43.25763580900008],
              [47.51710045700008, 43.24331289300005],
              [47.50603274800005, 43.23550039300005],
              [47.48585045700008, 43.21283600500004],
              [47.481211785000085, 43.202337958000044],
              [47.488291863000086, 43.18048737200007],
              [47.48585045700008, 43.171942450000074],
              [47.47803795700008, 43.15989817900004],
              [47.478851759000065, 43.14866771000004],
              [47.48226972700007, 43.138006903000075],
              [47.482432488000086, 43.12726471600007],
              [47.47641035200007, 43.118068752000056],
              [47.45948326900009, 43.10443756700005],
              [47.455088738000086, 43.09992096600007],
              [47.45281009200005, 43.08079661700003],
              [47.461924675000034, 43.020819403000075],
              [47.53012129000007, 42.962103583000044],
              [47.589854363000086, 42.942694403000075],
              [47.59913170700008, 42.931708075000074],
              [47.60564212300005, 42.91742584800005],
              [47.62159264400009, 42.90509674700007],
              [47.69809004000007, 42.86713288000004],
              [47.70167076900009, 42.861761786000045],
              [47.707774285000085, 42.83783600500004],
              [47.711680535000085, 42.83242422100005],
              [47.709971550000034, 42.82217031500005],
              [47.71664472700007, 42.77358633000006],
              [47.71509850400008, 42.75726959800005],
              [47.721364780000044, 42.75726959800005],
              [47.71697024800005, 42.74721914300005],
              [47.71509850400008, 42.73623281500005],
              [47.715586785000085, 42.69668203300006],
              [47.727305535000085, 42.66278717700004],
              [47.75180097700007, 42.63666413000004],
              [47.83765709700003, 42.60492584800005],
              [47.86768639400009, 42.58466217700004],
              [47.938487175000034, 42.48110586100006],
              [47.992930535000085, 42.41966380400004],
              [48.02369225400008, 42.39297109600005],
              [48.078786655000044, 42.36273834800005],
              [48.09595787900008, 42.34979889500005],
              [48.22234134200005, 42.175116278000075],
              [48.24968509200005, 42.146551825000074],
              [48.286143425000034, 42.12083567900004],
              [48.30404707100007, 42.102728583000044],
              [48.31169681100005, 42.08197663000004],
              [48.31560306100005, 42.06028880400004],
              [48.324961785000085, 42.038763739000046],
              [48.386729363000086, 41.937201239000046],
              [48.416351759000065, 41.91502513200004],
              [48.46241295700008, 41.90078359600005],
              [48.51002037900008, 41.89350006700005],
              [48.55290774800005, 41.87555573100008],
              [48.57862389400009, 41.84552643400008],
              [48.57894941500007, 41.84528229400007],
              [48.530660035000096, 41.787372946000076],
              [48.46221094500004, 41.720992372000055],
              [48.455419149000136, 41.714405823000064],
              [48.41325118000009, 41.627615255000094],
              [48.39304569500007, 41.59888315900007],
              [48.370153035000044, 41.5801504520001],
              [48.28369836400009, 41.53953277600006],
              [48.23135013800004, 41.50547800700009],
              [48.20184289500014, 41.493489075000056],
              [48.08655277500009, 41.47664255800005],
              [48.05353153500005, 41.461294658],
              [48.03456628400005, 41.43364776700007],
              [48.001648397000054, 41.36207590800005],
              [47.97916914900014, 41.35241241500002],
              [47.95322758000009, 41.35577138300003],
              [47.94268558800013, 41.34739980100004],
              [47.937931356000036, 41.331741842],
              [47.92945642100011, 41.313551738000044],
              [47.91478031400004, 41.30021921800004],
              [47.90144779500008, 41.29298451800007],
              [47.89214603700009, 41.28326934800002],
              [47.8892521570001, 41.26244374600007],
              [47.89379968200012, 41.24187652600007],
              [47.89886397300012, 41.229060771],
              [47.894626506000066, 41.21929392500003],
              [47.87111372900006, 41.20818349200003],
              [47.82873905400004, 41.19841664700006],
              [47.81349103700006, 41.19738775300003],
              [47.74373132300008, 41.19268056200009],
              [47.72455936700004, 41.19572947200005],
              [47.694888843000115, 41.207134021000044],
              [47.64254886900005, 41.2272520960001],
              [47.62249841300013, 41.229060771],
              [47.60317142700006, 41.22327301100002],
              [47.567773072000136, 41.2054963180001],
              [47.54730920500009, 41.20565134700003],
              [47.52917077600006, 41.216555074],
              [47.5009554450001, 41.246320699000094],
              [47.47914799000006, 41.251953430000114],
              [47.37558842000004, 41.25944651300004],
              [47.36729171000013, 41.261789438],
              [47.34447920800005, 41.26823150700004],
              [47.26841149900008, 41.30280304000003],
              [47.250841512000136, 41.31603220600003],
              [47.24091963700005, 41.338924866000056],
              [47.24277998800005, 41.39127309200008],
              [47.23905928500005, 41.41571604400009],
              [47.23146285000007, 41.42754994800002],
              [47.200508667000065, 41.45685048500009],
              [47.1951343180001, 41.46697906500013],
              [47.19182702600011, 41.47669423500007],
              [47.18707279400013, 41.485634257000115],
              [47.17924955000012, 41.49173237600009],
              [47.17699589000006, 41.493489075000056],
              [47.15932255100006, 41.503514303000074],
              [47.15224287900014, 41.51813873300004],
              [47.14872888100007, 41.535088603000034],
              [47.14139082800011, 41.55240020800004],
              [47.12557784000012, 41.56630116800004],
              [47.107491089000064, 41.56991851800011],
              [47.08826745600004, 41.56697296100002],
              [47.06914717700005, 41.561288555000075],
              [47.02826236300007, 41.557074659000094],
              [47.02703088400011, 41.556947734000076],
              [47.012613160000114, 41.575499573000016],
              [47.00393151800006, 41.60542022700007],
              [46.97923018400013, 41.63549591100012],
              [46.92951745600004, 41.667225240000036],
              [46.915978230000064, 41.68094533300008],
              [46.91225752700012, 41.68861928300005],
              [46.90688317900009, 41.70693857800005],
              [46.90223230000004, 41.7127521770001],
              [46.890553426000054, 41.71709299700008],
              [46.86450850400007, 41.7196768190001],
              [46.85189945400003, 41.72233815500003],
              [46.83479455600008, 41.730244650000074],
              [46.76911381100007, 41.77571991000012],
              [46.759398641000075, 41.78729543100006],
              [46.754024292000054, 41.800886332000076],
              [46.745032593000076, 41.84013458300002],
              [46.740795125000034, 41.85124501600005],
              [46.732423543000095, 41.85140004500009],
              [46.71557702600012, 41.838480937000085],
              [46.70955494600008, 41.83506555700011],
              [46.697490275000064, 41.8282231650001],
              [46.65707930500008, 41.82199615500009],
              [46.636512085000106, 41.816518453000114],
              [46.603955933000066, 41.795176087000115],
              [46.586592651000046, 41.786778667000036],
              [46.5675757250001, 41.78667531400002],
              [46.549850708000065, 41.79775990900002],
              [46.54432133000006, 41.81476145400005],
              [46.549127238000096, 41.85537913000006],
              [46.543546183000046, 41.874292705000116],
              [46.525511109000036, 41.88230255200007],
              [46.47931237800009, 41.887005107000064],
              [46.45233728000005, 41.88617828400005],
              [46.43089156100007, 41.890441590000094],
              [46.40655196100005, 41.915039571000065],
              [46.38205733300009, 41.925245667000056],
              [46.322629435000124, 41.92901804700007],
              [46.294155721000095, 41.93862986300009],
              [46.250489136000056, 41.977723084],
              [46.224340861000144, 41.993484395000095],
              [46.214574015000096, 41.995499776000045],
              [46.2061507570001, 41.996094055000086],
              [46.197675822000065, 41.995499776000045],
              [46.189200887000084, 41.99376861600008],
              [46.18889082800007, 41.99363942500004],
              [46.1885807700001, 41.993536072000026],
              [46.129876343000035, 41.98449269700005],
              [46.09918054200011, 41.9850611370001],
              [46.07499597200007, 41.993484395000095],
              [46.06827803500005, 42.015317688000025],
              [46.05845951300006, 42.02033030200009],
              [46.04481693500014, 42.01772064200007],
              [46.026730184000144, 42.01679046700012],
              [46.018358602000035, 42.02004608200009],
              [46.0016154380001, 42.03097564800008],
              [45.99515588400004, 42.03345611600007],
              [45.98673262600005, 42.03190582300003],
              [45.973503459000085, 42.02415435800013],
              [45.966372111000055, 42.02206146300007],
              [45.94756188900004, 42.02291412400008],
              [45.9341260170001, 42.0284951790001],
              [45.923480672000096, 42.039631450000044],
              [45.89516198700011, 42.09187632300002],
              [45.881364380000036, 42.10203074200008],
              [45.81160119600008, 42.115492452000055],
              [45.70178877800004, 42.1727499390001],
              [45.66158451300004, 42.18670257600009],
              [45.631405477000044, 42.201171977000016],
              [45.62138024900008, 42.22447804800005],
              [45.736411987000054, 42.44753936800005],
              [45.73950628500012, 42.470646785],
              [45.73961592600011, 42.47146555600007],
              [45.69868819200008, 42.50758738200007],
              [45.620656779000115, 42.53037668900008],
              [45.53683760600012, 42.541357931000064],
              [45.47927006000009, 42.54233978300003],
              [45.398551473000055, 42.524382223000046],
              [45.35597009300011, 42.51996388800005],
              [45.322690470000055, 42.53011830700011],
              [45.3125618900001, 42.54171966500006],
              [45.30157131900006, 42.55984209600008],
              [45.29364831500004, 42.572906393000025],
              [45.28269291200007, 42.586393941],
              [45.18419763200012, 42.67483815600012],
              [45.15536218200009, 42.69326080400002],
              [45.12296106000008, 42.70227834100008],
              [45.103892456000096, 42.700547180000015],
              [45.07601819100012, 42.691411917],
              [45.066995483000085, 42.68845489500002],
              [45.04808190900013, 42.68589691200013],
              [45.02978845200005, 42.68876495400009],
              [45.01211511300005, 42.69530202300008],
              [44.90297448700011, 42.753076274000065],
              [44.859359579000056, 42.759509990000126],
              [44.833676392000086, 42.734085185000126],
              [44.827423543000066, 42.71796213800003],
              [44.79848474100004, 42.671737569000086],
              [44.78231001700004, 42.61665049300011],
              [44.77347334800004, 42.60964833700011],
              [44.761071004000144, 42.6192343150001],
              [44.736369670000045, 42.67755116800005],
              [44.72448409000003, 42.691038717000126],
              [44.69502852400012, 42.71421559700012],
              [44.679422242000044, 42.723672384000096],
              [44.6424219160001, 42.73927866700002],
              [44.638758823000046, 42.740148766000075],
              [44.60097741700014, 42.74912302700001],
              [44.55829268400004, 42.75310211300008],
              [44.50811486800012, 42.7502857460001],
              [44.47922774300008, 42.7442912800001],
              [44.401403035000044, 42.71351796500004],
              [44.36068200700004, 42.703751119000074],
              [44.272005249000074, 42.70238169400001],
              [44.24864750100011, 42.681995342000064],
              [44.2301473390001, 42.653805848],
              [44.21135073000005, 42.63963427100002],
              [44.197384481000086, 42.6291045120001],
              [44.185803459000056, 42.62650810100003],
              [44.15082401600006, 42.61866587400006],
              [44.05506758600012, 42.615306905000054],
              [44.01150435400007, 42.60032074000007],
              [43.998016805000134, 42.589365336000085],
              [43.973212118000106, 42.5639922080001],
              [43.95843265800005, 42.55440623],
              [43.93972578900008, 42.55220998200009],
              [43.92081221600006, 42.55910878600007],
              [43.90816053600014, 42.566282989000015],
              [43.8853621830001, 42.579210918000044],
              [43.84500288900006, 42.587039897000054],
              [43.79616866000009, 42.58983042400003],
              [43.751106812000046, 42.598744609000036],
              [43.722581421000086, 42.624867045000045],
              [43.725682007000046, 42.65440012700007],
              [43.75379398600006, 42.67465728800006],
              [43.78872725400004, 42.693079936000075],
              [43.8117749430001, 42.71726450700005],
              [43.800612834000106, 42.74646169000009],
              [43.782525649000036, 42.7532129830001],
              [43.75596439600014, 42.763127340000025],
              [43.66284346600014, 42.779844666000045],
              [43.64434330200004, 42.788577983000025],
              [43.603002157000105, 42.824803162000066],
              [43.586258992000126, 42.835629374000106],
              [43.517425985000045, 42.860459900000066],
              [43.47959883700008, 42.867462057000054],
              [43.38617831300007, 42.8868823560001],
              [43.19434493000006, 42.926760763000075],
              [43.17522846100013, 42.93447107200005],
              [43.15558760600004, 42.942392884000114],
              [43.04825565600004, 43.016961975000086],
              [42.998852986000145, 43.04220591300013],
              [42.98975793500006, 43.052670390000074],
              [42.992548462000116, 43.06881927600007],
              [43.000196574000086, 43.08535573300007],
              [43.0000932210001, 43.09866241500008],
              [42.91482710800011, 43.121942648000086],
              [42.88578495300004, 43.13584360800009],
              [42.85767297300009, 43.155454814],
              [42.829767700000104, 43.16876149500003],
              [42.791320434000056, 43.176177063000054],
              [42.75152958100006, 43.17695221000004],
              [42.70491744000009, 43.16643605600008],
              [42.67360152200007, 43.16589345300004],
              [42.65623824000005, 43.159795634],
              [42.629366496000046, 43.14126963400007],
              [42.615207153000085, 43.13698049],
              [42.59588016700013, 43.14002939900011],
              [42.53490197800011, 43.16506663000003],
              [42.506066529000066, 43.18155141200002],
              [42.47971154800007, 43.200904236000056],
              [42.42286747300005, 43.22899037700007],
              [42.36256010000005, 43.23519446400006],
              [42.354551229000094, 43.236018372],
              [42.185362590000125, 43.22547638000013],
              [42.15983443200008, 43.21974029600007],
              [42.15433396100008, 43.217497744000056],
              [42.07529178900012, 43.1852721150001],
              [42.04335575400012, 43.18056956000002],
              [42.01131636500014, 43.18186147100009],
              [41.97969038900004, 43.18865692100003],
              [41.94827111800009, 43.20007741300013],
              [41.91933231600012, 43.205942689000025],
              [41.88998010300014, 43.2070278930001],
              [41.82032027200012, 43.20124013300004],
              [41.78890100100011, 43.20356557300009],
              [41.7237886960001, 43.21723398900009],
              [41.68740848800013, 43.220205383000106],
              [41.61413130700009, 43.21302236000004],
              [41.57754439300004, 43.21529612300007],
              [41.550569295000116, 43.22627736500006],
              [41.50612756400005, 43.25978953100007],
              [41.47977258300011, 43.27123586100008],
              [41.427579386000104, 43.283198954000014],
              [41.41310998500006, 43.291286317000115],
              [41.40380822800006, 43.301518250000086],
              [41.38975223800014, 43.324875997000035],
              [41.380657185000075, 43.334772034000125],
              [41.35027144300011, 43.34335032200006],
              [41.27875126100008, 43.333195903],
              [41.243921346000036, 43.344202982000084],
              [41.21312219300006, 43.36278066000004],
              [41.18077274600006, 43.37469207800008],
              [41.146666300000106, 43.379859721000074],
              [41.04248661300011, 43.369834494000045],
              [41.01179081300006, 43.37541554800008],
              [40.87495161900006, 43.45564320900006],
              [40.8427055250001, 43.46938914000002],
              [40.740179484000066, 43.495279033000045],
              [40.689965576000134, 43.523129317],
              [40.68106164500006, 43.52806772900006],
              [40.65191613800005, 43.53897145600011],
              [40.61553592900009, 43.53584503200007],
              [40.550837036000075, 43.51124705100007],
              [40.51962447100004, 43.50517506900003],
              [40.4798336180001, 43.50874074300002],
              [40.2331303310001, 43.575765076000025],
              [40.164297323000085, 43.57584259000002],
              [40.096704549000094, 43.56263926200005],
              [40.07283003800012, 43.551063742000096],
              [40.05918746000009, 43.53519907700009],
              [39.991284627000084, 43.40631805500006],
              [39.985976355436605, 43.38898960974838],
              [39.98552493600005, 43.38906484600005],
              [39.96257571700005, 43.392645575000074],
              [39.93336022200003, 43.406683661000045],
              [39.91032962300005, 43.42641836100006],
              [39.89568118600005, 43.44871653900009],
              [39.88249759200005, 43.47675202000005],
              [39.867930535000085, 43.49567291900007],
              [39.84693444100009, 43.50999583500004],
              [39.756521030000044, 43.54531484600005],
              [39.734385613000086, 43.560614325000074],
              [39.71827233200008, 43.56777578300006],
              [39.71208743600005, 43.57290273600006],
              [39.70630944100009, 43.58250560100004],
              [39.697927280000044, 43.60423411700003],
              [39.69076582100007, 43.61383698100008],
              [39.67497806100005, 43.62278880400004],
              [39.63404381600009, 43.635199286000045],
              [39.61890709700003, 43.644598700000074],
              [39.57406660200007, 43.68895091400009],
              [39.45753014400009, 43.77090078300006],
              [39.391368035000085, 43.845363674000055],
              [39.32935631600009, 43.89622630400004],
              [39.11638431100005, 44.023504950000074],
              [39.08814537900008, 44.04523346600007],
              [39.061208530000044, 44.07611725500004],
              [39.04476972700007, 44.08812083500004],
              [39.02271569100009, 44.093003648000035],
              [39.01156660200007, 44.10028717700004],
              [38.989024285000085, 44.13556549700007],
              [38.97828209700003, 44.14826080900008],
              [38.96013431100005, 44.157131252000056],
              [38.93734785200007, 44.16351959800005],
              [38.89234459700003, 44.16868724200003],
              [38.873708530000044, 44.17340729400007],
              [38.85564212300005, 44.18451569200005],
              [38.77564537900008, 44.26121653900009],
              [38.75831139400009, 44.27362702000005],
              [38.73975670700008, 44.28148021000004],
              [38.69711347700007, 44.292222398000035],
              [38.59506269600007, 44.33193594000005],
              [38.30982506600009, 44.36615631700005],
              [38.29932701900009, 44.37763092700004],
              [38.28842207100007, 44.38515859600005],
              [38.21729576900009, 44.38719310100004],
              [38.177744988000086, 44.40599192900004],
              [38.15259850400008, 44.43667226800005],
              [38.13257897200009, 44.470038153000075],
              [38.108083530000044, 44.49705638200004],
              [38.071299675000034, 44.51601797100005],
              [38.062836134000065, 44.52423737200007],
              [38.05616295700008, 44.55898672100005],
              [38.044932488000086, 44.56118398600006],
              [38.01189212300005, 44.55231354400007],
              [38.00025475400008, 44.55548737200007],
              [37.98454837300005, 44.56427643400008],
              [37.94450931100005, 44.59711334800005],
              [37.928070509000065, 44.60594310100004],
              [37.922618035000085, 44.61375560100004],
              [37.92465254000007, 44.61713288000004],
              [37.930349155000044, 44.62189362200007],
              [37.935557488000086, 44.62775299700007],
              [37.936208530000044, 44.63426341400009],
              [37.93311608200008, 44.638739325000074],
              [37.87484785200007, 44.68939850500004],
              [37.86451256600009, 44.69635651200008],
              [37.844086134000065, 44.700873114000046],
              [37.79997806100005, 44.72260163000004],
              [37.77849368600005, 44.729803778000075],
              [37.79053795700008, 44.70587799700007],
              [37.80884850400008, 44.686428127000056],
              [37.82243899800005, 44.66815827000005],
              [37.82016035200007, 44.64789459800005],
              [37.80005944100009, 44.63523997600004],
              [37.76929772200009, 44.63239166900007],
              [37.73650149800005, 44.63568756700005],
              [37.71029707100007, 44.64175039300005],
              [37.65967858200008, 44.661810614000046],
              [37.631846550000034, 44.66901276200008],
              [37.60108483200008, 44.668402411000045],
              [37.58366946700005, 44.65737539300005],
              [37.577159050000034, 44.65534088700008],
              [37.569346550000034, 44.65643952000005],
              [37.535817905000044, 44.665716864000046],
              [37.52173912900008, 44.67226797100005],
              [37.50896243600005, 44.67527903900009],
              [37.498708530000044, 44.668402411000045],
              [37.47828209700009, 44.67719147300005],
              [37.463877800000034, 44.68992747600004],
              [37.45142662900008, 44.704006252000056],
              [37.436534050000034, 44.716782945000034],
              [37.38599694100009, 44.736761786000045],
              [37.371104363000086, 44.74787018400008],
              [37.35124759200005, 44.778631903000075],
              [37.31788170700008, 44.84617747600004],
              [37.29249108200008, 44.867621161000045],
              [37.29249108200008, 44.875067450000074],
              [37.311289910000085, 44.89085521000004],
              [37.30600019600007, 44.90965403900009],
              [37.287119988000086, 44.928168036000045],
              [37.19190514400009, 44.99103424700007],
              [37.16570071700005, 44.99799225500004],
              [37.15219160200007, 44.999701239000046],
              [37.13502037900008, 45.00405508000006],
              [37.120127800000034, 45.009466864000046],
              [37.10572350400008, 45.02020905200004],
              [37.068369988000086, 45.03034088700008],
              [37.03467858200008, 45.047756252000056],
              [36.949961785000085, 45.065619208000044],
              [36.84009850400008, 45.109361070000034],
              [36.79908287900008, 45.11469147300005],
              [36.77849368600005, 45.112616278000075],
              [36.74154707100007, 45.103216864000046],
              [36.71998131600009, 45.10101959800005],
              [36.70167076900009, 45.10382721600007],
              [36.641368035000085, 45.12836334800005],
              [36.59310957100007, 45.16478099200003],
              [36.58619225400008, 45.17234935100004],
              [36.58318118600005, 45.18024323100008],
              [36.578135613000086, 45.18707916900007],
              [36.57732181100005, 45.19415924700007],
              [36.58619225400008, 45.202826239000046],
              [36.594737175000034, 45.20482005400004],
              [36.70671634200005, 45.202826239000046],
              [36.72966556100005, 45.206284898000035],
              [36.76482181100005, 45.223822333000044],
              [36.78541100400008, 45.23069896000004],
              [36.79615319100009, 45.23187897300005],
              [36.82984459700009, 45.23069896000004],
              [36.840830925000034, 45.232855536000045],
              [36.854502800000034, 45.242254950000074],
              [36.87517337300005, 45.245794989000046],
              [36.93523196700005, 45.268011786000045],
              [36.95297285200007, 45.27716705900008],
              [36.961680535000085, 45.28294505400004],
              [36.96802819100009, 45.29096100500004],
              [36.97038821700005, 45.30304596600007],
              [36.96615644600007, 45.31159088700008],
              [36.95679772200009, 45.318019924000055],
              [36.947276238000086, 45.32021719000005],
              [36.94312584700009, 45.316392320000034],
              [36.78882897200009, 45.292181708000044],
              [36.778005405000044, 45.30060455900008],
              [36.76644941500007, 45.31981028900009],
              [36.758474155000044, 45.34076569200005],
              [36.75806725400008, 45.35423411700003],
              [36.775726759000065, 45.36481354400007],
              [36.78695722700007, 45.34857819200005],
              [36.79476972700007, 45.32485586100006],
              [36.80250084700009, 45.31268952000005],
              [36.81218509200005, 45.316392320000034],
              [36.81226647200009, 45.32562897300005],
              [36.80982506600009, 45.33698151200008],
              [36.81218509200005, 45.34739817900004],
              [36.819021030000044, 45.35260651200008],
              [36.82862389400009, 45.356756903000075],
              [36.84750410200007, 45.36107005400004],
              [36.84750410200007, 45.36733633000006],
              [36.817393425000034, 45.367621161000045],
              [36.80591881600009, 45.370754299000055],
              [36.781586134000065, 45.38764069200005],
              [36.77003014400009, 45.387884833000044],
              [36.75928795700008, 45.383978583000044],
              [36.74756920700008, 45.38153717700004],
              [36.72779381600009, 45.37177155200004],
              [36.68799889400009, 45.33148834800005],
              [36.66814212300005, 45.32636139500005],
              [36.66651451900009, 45.34039948100008],
              [36.68189537900008, 45.36619700700004],
              [36.705088738000086, 45.39101797100005],
              [36.83326256600009, 45.443019924000055],
              [36.847666863000086, 45.43406810100004],
              [36.86247806100005, 45.43183014500005],
              [36.87810306100005, 45.43187083500004],
              [36.895274285000085, 45.42999909100007],
              [37.06666100400008, 45.35382721600007],
              [37.10873457100007, 45.34247467700004],
              [37.131521030000044, 45.34056224200003],
              [37.139414910000085, 45.33551666900007],
              [37.131521030000044, 45.32477448100008],
              [37.119151238000086, 45.314886786000045],
              [37.11378014400009, 45.31268952000005],
              [37.11101321700005, 45.30304596600007],
              [37.10694420700008, 45.276556708000044],
              [37.10694420700008, 45.27167389500005],
              [37.097666863000086, 45.268459377000056],
              [37.07146243600005, 45.26581452000005],
              [37.06592858200008, 45.26146067900004],
              [37.067149285000085, 45.25071849200003],
              [37.071055535000085, 45.24331289300005],
              [37.07837975400008, 45.23895905200004],
              [37.089854363000086, 45.237534898000035],
              [37.11247806100005, 45.23932526200008],
              [37.16911868600005, 45.251166083000044],
              [37.214854363000086, 45.25141022300005],
              [37.23650149800005, 45.25531647300005],
              [37.24537194100009, 45.26829661700003],
              [37.25440514400009, 45.27692291900007],
              [37.31918379000007, 45.27167389500005],
              [37.302744988000086, 45.286322333000044],
              [37.27426191500007, 45.294134833000044],
              [37.216807488000086, 45.29962799700007],
              [37.18775475400008, 45.29877350500004],
              [37.17367597700007, 45.300116278000075],
              [37.16228274800005, 45.30646393400008],
              [37.153005405000044, 45.32046133000006],
              [37.158946160000085, 45.32607656500005],
              [37.347666863000086, 45.32770416900007],
              [37.37045332100007, 45.32221100500004],
              [37.38135826900009, 45.30646393400008],
              [37.39380944100009, 45.31732819200005],
              [37.43140709700009, 45.322333075000074],
              [37.44678795700008, 45.33002350500004],
              [37.46013431100005, 45.34056224200003],
              [37.50473066500007, 45.36107005400004],
              [37.51929772200009, 45.36928945500006],
              [37.51880944100009, 45.36041901200008],
              [37.50473066500007, 45.33380768400008],
              [37.51579837300005, 45.336371161000045],
              [37.53638756600009, 45.34544505400004],
              [37.54265384200005, 45.34739817900004],
              [37.55396569100009, 45.34634023600006],
              [37.57374108200008, 45.34170156500005],
              [37.583994988000086, 45.34056224200003],
              [37.59164472700007, 45.33803945500006],
              [37.60084069100009, 45.331366278000075],
              [37.60767662900008, 45.32241445500006],
              [37.60792076900009, 45.31268952000005],
              [37.60084069100009, 45.30687083500004],
              [37.58912194100009, 45.30312734600005],
              [37.566742384000065, 45.29962799700007],
              [37.59107506600009, 45.28937409100007],
              [37.60954837300005, 45.29682038000004],
              [37.623789910000085, 45.31427643400008],
              [37.635101759000065, 45.33380768400008],
              [37.63786868600005, 45.32851797100005],
              [37.64234459700009, 45.321478583000044],
              [37.647471550000034, 45.315334377000056],
              [37.65162194100009, 45.31268952000005],
              [37.66179446700005, 45.31232330900008],
              [37.66618899800005, 45.31122467700004],
              [37.67107181100005, 45.30927155200004],
              [37.71021569100009, 45.30027903900009],
              [37.72046959700009, 45.29962799700007],
              [37.729258660000085, 45.301662502000056],
              [37.73601321700005, 45.30613841400009],
              [37.738291863000086, 45.31069570500006],
              [37.729258660000085, 45.315334377000056],
              [37.71436608200008, 45.32851797100005],
              [37.71029707100007, 45.33380768400008],
              [37.70622806100005, 45.33730703300006],
              [37.701833530000044, 45.33746979400007],
              [37.699880405000044, 45.339178778000075],
              [37.70289147200009, 45.34739817900004],
              [37.70639082100007, 45.351263739000046],
              [37.71534264400009, 45.354722398000035],
              [37.71705162900008, 45.35765208500004],
              [37.72046959700009, 45.35700104400007],
              [37.73755944100009, 45.37474192900004],
              [37.742198113000086, 45.38275788000004],
              [37.74398847700007, 45.389553127000056],
              [37.74773196700005, 45.39398834800005],
              [37.75806725400008, 45.39520905200004],
              [37.75806725400008, 45.402044989000046],
              [37.74740644600007, 45.39907461100006],
              [37.72982832100007, 45.39081452000005],
              [37.71705162900008, 45.38898346600007],
              [37.72348066500007, 45.41461823100008],
              [37.717539910000085, 45.426662502000056],
              [37.707692905000044, 45.43691640800006],
              [37.70289147200009, 45.45726146000004],
              [37.71509850400008, 45.45449453300006],
              [37.73389733200008, 45.446193752000056],
              [37.74439537900008, 45.443019924000055],
              [37.74439537900008, 45.450425523000035],
              [37.72836347700007, 45.457464911000045],
              [37.69971764400009, 45.47931549700007],
              [37.68604576900009, 45.484035549000055],
              [37.68702233200008, 45.493841864000046],
              [37.70264733200008, 45.54315827000005],
              [37.69971764400009, 45.56281159100007],
              [37.69263756600009, 45.56818268400008],
              [37.68100019600007, 45.57404205900008],
              [37.668630405000044, 45.57880280200004],
              [37.65870201900009, 45.58079661700003],
              [37.649424675000034, 45.58494700700004],
              [37.64275149800005, 45.603501695000034],
              [37.635101759000065, 45.60809967700004],
              [37.623057488000086, 45.60138580900008],
              [37.62330162900008, 45.58588288000004],
              [37.63640384200005, 45.57099030200004],
              [37.662445509000065, 45.56655508000006],
              [37.662445509000065, 45.55906810100004],
              [37.64283287900008, 45.55377838700008],
              [37.635101759000065, 45.55288320500006],
              [37.635101759000065, 45.54539622600004],
              [37.63917076900009, 45.54075755400004],
              [37.64340254000007, 45.53465403900009],
              [37.64665774800005, 45.52708567900004],
              [37.64820397200009, 45.51813385600008],
              [37.649180535000085, 45.51829661700003],
              [37.65154056100005, 45.51634349200003],
              [37.65398196700005, 45.51276276200008],
              [37.655039910000085, 45.50820547100005],
              [37.653086785000085, 45.50438060100004],
              [37.64869225400008, 45.50421784100007],
              [37.64421634200005, 45.505072333000044],
              [37.64193769600007, 45.50446198100008],
              [37.64079837300005, 45.455959377000056],
              [37.62777754000007, 45.428168036000045],
              [37.619151238000086, 45.418402411000045],
              [37.60824629000007, 45.41583893400008],
              [37.59424889400009, 45.42255280200004],
              [37.586273634000065, 45.43244049700007],
              [37.58643639400009, 45.44350820500006],
              [37.59424889400009, 45.47711823100008],
              [37.59392337300005, 45.50885651200008],
              [37.58619225400008, 45.56781647300005],
              [37.58741295700008, 45.60065338700008],
              [37.59506269600007, 45.63532135600008],
              [37.60141035200007, 45.65289948100008],
              [37.60792076900009, 45.66274648600006],
              [37.62647545700008, 45.66828034100007],
              [37.634776238000086, 45.66071198100008],
              [37.63111412900008, 45.64899323100008],
              [37.61459394600007, 45.642279364000046],
              [37.64193769600007, 45.63544342700004],
              [37.65251712300005, 45.62396881700005],
              [37.670909050000034, 45.60968659100007],
              [37.67888431100005, 45.61078522300005],
              [37.682302280000044, 45.62799713700008],
              [37.698252800000034, 45.62376536700003],
              [37.70289147200009, 45.62177155200004],
              [37.70069420700008, 45.63467031500005],
              [37.69385826900009, 45.63914622600004],
              [37.68482506600009, 45.641913153000075],
              [37.67603600400008, 45.64911530200004],
              [37.66684004000007, 45.663763739000046],
              [37.66684004000007, 45.66901276200008],
              [37.67400149800005, 45.671942450000074],
              [37.763682488000086, 45.72475820500006],
              [37.80062910200007, 45.741441148000035],
              [37.816416863000086, 45.74461497600004],
              [37.82943769600007, 45.753159898000035],
              [37.84310957100007, 45.77260976800005],
              [37.86109459700009, 45.80609772300005],
              [37.87484785200007, 45.841009833000044],
              [37.90202884200005, 45.95075104400007],
              [37.918711785000085, 45.991400458000044],
              [37.940114780000044, 46.02033112200007],
              [37.97185306100005, 46.04002513200004],
              [38.037852410000085, 46.05654531500005],
              [38.09107506600009, 46.06000397300005],
              [38.09750410200007, 46.057806708000044],
              [38.087901238000086, 46.05296458500004],
              [38.04704837300005, 46.03856028900009],
              [38.039805535000085, 46.03388092700004],
              [38.03248131600009, 46.02521393400008],
              [38.05486087300005, 46.03266022300005],
              [38.06625410200007, 46.032538153000075],
              [38.07398522200009, 46.02521393400008],
              [38.072276238000086, 46.013739325000074],
              [38.051442905000044, 45.992621161000045],
              [38.04607181100005, 45.98143138200004],
              [38.04184004000007, 45.96108633000006],
              [38.04615319100009, 45.95359935100004],
              [38.063487175000034, 45.95075104400007],
              [38.07797285200007, 45.95209381700005],
              [38.08033287900008, 45.94635651200008],
              [38.080821160000085, 45.92963288000004],
              [38.073008660000085, 45.90875885600008],
              [38.054698113000086, 45.88922760600008],
              [38.01531009200005, 45.85761139500005],
              [38.00123131600009, 45.83258698100008],
              [38.01449629000007, 45.818426825000074],
              [38.03956139400009, 45.816066799000055],
              [38.06031334700009, 45.826605536000045],
              [38.046885613000086, 45.84088776200008],
              [38.049815300000034, 45.85488515800006],
              [38.07398522200009, 45.88182200700004],
              [38.09652754000007, 45.94025299700007],
              [38.09750410200007, 45.95075104400007],
              [38.10865319100009, 45.95661041900007],
              [38.121104363000086, 45.97134023600006],
              [38.131195509000065, 45.99005768400008],
              [38.13892662900008, 46.03009674700007],
              [38.147146030000044, 46.04047272300005],
              [38.156260613000086, 46.047756252000056],
              [38.162771030000044, 46.06000397300005],
              [38.162119988000086, 46.10195547100005],
              [38.16749108200008, 46.12051015800006],
              [38.18669681100005, 46.128241278000075],
              [38.20728600400008, 46.13178131700005],
              [38.227549675000034, 46.13816966400009],
              [38.248789910000085, 46.14154694200005],
              [38.27198326900009, 46.13568756700005],
              [38.31959069100009, 46.093451239000046],
              [38.354502800000034, 46.082464911000045],
              [38.409190300000034, 46.04633209800005],
              [38.42741946700005, 46.038275458000044],
              [38.44581139400009, 46.03424713700008],
              [38.48178144600007, 46.03266022300005],
              [38.49244225400008, 46.033636786000045],
              [38.51384524800005, 46.03790924700007],
              [38.52588951900009, 46.03880442900004],
              [38.539073113000086, 46.03359609600005],
              [38.54997806100005, 46.03119538000004],
              [38.55990644600007, 46.03266022300005],
              [38.566742384000065, 46.04328034100007],
              [38.57349694100009, 46.06419505400004],
              [38.57601972700007, 46.08734772300005],
              [38.57081139400009, 46.104681708000044],
              [38.55681399800005, 46.11517975500004],
              [38.30005944100009, 46.21865469000005],
              [38.28532962300005, 46.232123114000046],
              [38.27947024800005, 46.255519924000055],
              [38.27125084700009, 46.27415599200003],
              [38.25245201900009, 46.288275458000044],
              [38.21729576900009, 46.30573151200008],
              [38.12289472700007, 46.37750885600008],
              [38.08765709700009, 46.39642975500004],
              [38.06788170700008, 46.40143463700008],
              [37.99073326900009, 46.402411200000074],
              [37.98064212300005, 46.40033600500004],
              [37.974945509000065, 46.39427317900004],
              [37.97779381600009, 46.382147528000075],
              [38.010101759000065, 46.37254466400009],
              [38.01872806100005, 46.368475653000075],
              [37.99537194100009, 46.35443756700005],
              [37.97095787900008, 46.36180247600004],
              [37.905039910000085, 46.411037502000056],
              [37.86296634200005, 46.454779364000046],
              [37.850596550000034, 46.464056708000044],
              [37.82732181100005, 46.47650788000004],
              [37.81299889400009, 46.50568268400008],
              [37.80209394600007, 46.53880442900004],
              [37.77654056100005, 46.58690013200004],
              [37.76775149800005, 46.617621161000045],
              [37.75513756600009, 46.64594147300005],
              [37.73072350400008, 46.66266510600008],
              [37.73072350400008, 46.67011139500005],
              [37.735362175000034, 46.669623114000046],
              [37.73658287900008, 46.671210028000075],
              [37.73650149800005, 46.67377350500004],
              [37.73755944100009, 46.67633698100008],
              [37.768239780000044, 46.663275458000044],
              [37.81039472700007, 46.63959381700005],
              [37.852224155000044, 46.62250397300005],
              [37.881602410000085, 46.62913646000004],
              [37.92465254000007, 46.61554596600007],
              [37.98226972700007, 46.61749909100007],
              [38.03679446700005, 46.62946198100008],
              [38.070323113000086, 46.64594147300005],
              [38.10368899800005, 46.67597077000005],
              [38.12330162900008, 46.68646881700005],
              [38.14576256600009, 46.690619208000044],
              [38.194346550000034, 46.69212474200003],
              [38.213877800000034, 46.696193752000056],
              [38.23096764400009, 46.704291083000044],
              [38.26148522200009, 46.728176174000055],
              [38.27173912900008, 46.73236725500004],
              [38.279958530000044, 46.725775458000044],
              [38.28931725400008, 46.71108633000006],
              [38.290049675000034, 46.70612213700008],
              [38.30689537900008, 46.68317291900007],
              [38.31364993600005, 46.67633698100008],
              [38.46225019600007, 46.64695872600004],
              [38.57545006600009, 46.65379466400009],
              [38.59164472700007, 46.65924713700008],
              [38.59815514400009, 46.67792389500005],
              [38.58578535200007, 46.69586823100008],
              [38.566742384000065, 46.70994700700004],
              [38.553070509000065, 46.71727122600004],
              [38.51343834700003, 46.732489325000074],
              [38.47055097700007, 46.743475653000075],
              [38.42798912900008, 46.74485911700003],
              [38.389333530000044, 46.73159414300005],
              [38.38843834700009, 46.725775458000044],
              [38.383555535000085, 46.71381256700005],
              [38.37818444100009, 46.70815664300005],
              [38.37435957100007, 46.72931549700007],
              [38.36939537900008, 46.74408600500004],
              [38.368174675000034, 46.75543854400007],
              [38.37322024800005, 46.76239655200004],
              [38.39616946700005, 46.774725653000075],
              [38.403005405000044, 46.77997467700004],
              [38.40455162900008, 46.78945547100005],
              [38.40154056100005, 46.81134674700007],
              [38.403005405000044, 46.82094961100006],
              [38.414724155000044, 46.833319403000075],
              [38.43531334700009, 46.84674713700008],
              [38.457692905000044, 46.857489325000074],
              [38.474619988000086, 46.86188385600008],
              [38.553070509000065, 46.84829336100006],
              [38.57309004000007, 46.85028717700004],
              [38.60906009200005, 46.85968659100007],
              [38.69092858200008, 46.86383698100008],
              [38.71143639400009, 46.86810944200005],
              [38.766286655000044, 46.886786200000074],
              [38.803721550000034, 46.89354075700004],
              [38.820323113000086, 46.90424225500004],
              [38.84742272200003, 46.93081289300005],
              [38.86573326900009, 46.94293854400007],
              [38.88111412900008, 46.94627513200004],
              [38.91960696700005, 46.94383372600004],
              [38.93734785200007, 46.94745514500005],
              [38.95728600400008, 46.95648834800005],
              [38.99138431100005, 46.97797272300005],
              [39.03630618600005, 47.013657945000034],
              [39.06023196700005, 47.02171458500004],
              [39.067149285000085, 47.02757396000004],
              [39.075205925000034, 47.03266022300005],
              [39.08814537900008, 47.033189195000034],
              [39.09742272200003, 47.02903880400004],
              [39.10499108200008, 47.016791083000044],
              [39.11491946700005, 47.01276276200008],
              [39.12671959700003, 47.01382070500006],
              [39.137705925000034, 47.01862213700008],
              [39.14673912900008, 47.023871161000045],
              [39.153086785000085, 47.02635325700004],
              [39.26189212300005, 47.00861237200007],
              [39.280039910000085, 47.01276276200008],
              [39.289398634000065, 47.02728913000004],
              [39.29615319100009, 47.06899648600006],
              [39.30355879000007, 47.08470286700003],
              [39.32504316500007, 47.09878164300005],
              [39.367849155000044, 47.10614655200004],
              [39.388682488000086, 47.11517975500004],
              [39.35466556100005, 47.13104889500005],
              [39.32935631600009, 47.12836334800005],
              [39.306651238000086, 47.11225006700005],
              [39.280039910000085, 47.08783600500004],
              [39.26490319100009, 47.09662506700005],
              [39.26197350400008, 47.10761139500005],
              [39.27320397200003, 47.135646877000056],
              [39.254567905000044, 47.14012278900009],
              [39.24919681100005, 47.148138739000046],
              [39.252614780000044, 47.18032461100006],
              [39.25603274800005, 47.18976471600007],
              [39.26392662900008, 47.191473700000074],
              [39.27295983200008, 47.19179922100005],
              [39.280039910000085, 47.19708893400008],
              [39.281586134000065, 47.20526764500005],
              [39.280039910000085, 47.235256252000056],
              [39.264008009000065, 47.26080963700008],
              [39.22738691500007, 47.267238674000055],
              [39.18604576900009, 47.268744208000044],
              [39.15650475400008, 47.27968984600005],
              [39.13884524800005, 47.273423570000034],
              [39.119883660000085, 47.277044989000046],
              [39.102305535000085, 47.28351471600007],
              [39.08814537900008, 47.286444403000075],
              [39.073252800000034, 47.281683661000045],
              [39.04810631600009, 47.26675039300005],
              [39.04037519600007, 47.26601797100005],
              [39.01343834700003, 47.25446198100008],
              [38.97681725400008, 47.25690338700008],
              [38.94459069100009, 47.25275299700007],
              [38.93051191500007, 47.22162506700005],
              [38.933929884000065, 47.20107656500005],
              [38.93775475400008, 47.18976471600007],
              [38.931651238000086, 47.18500397300005],
              [38.88656660200007, 47.18146393400008],
              [38.87330162900008, 47.175441799000055],
              [38.861664259000065, 47.16860586100006],
              [38.84742272200003, 47.16356028900009],
              [38.828868035000085, 47.16201406500005],
              [38.772227410000085, 47.16356028900009],
              [38.71924889400009, 47.15119049700007],
              [38.68287194100009, 47.14716217700004],
              [38.645274285000085, 47.13776276200008],
              [38.62549889400009, 47.135646877000056],
              [38.553070509000065, 47.135646877000056],
              [38.55681399800005, 47.13117096600007],
              [38.55876712300005, 47.12791575700004],
              [38.56169681100005, 47.125067450000074],
              [38.56804446700005, 47.12201569200005],
              [38.56804446700005, 47.11517975500004],
              [38.54476972700007, 47.11481354400007],
              [38.51742597700007, 47.11904531500005],
              [38.492930535000085, 47.12807851800005],
              [38.47803795700008, 47.14248281500005],
              [38.49439537900008, 47.14899323100008],
              [38.50961347700007, 47.17161692900004],
              [38.522471550000034, 47.17658112200007],
              [38.53101647200003, 47.18231842700004],
              [38.550791863000086, 47.20929596600007],
              [38.55990644600007, 47.21820709800005],
              [38.59262129000007, 47.229681708000044],
              [38.77564537900008, 47.24551015800006],
              [38.78956139400009, 47.25063711100006],
              [38.80779056100005, 47.26264069200005],
              [38.82113691500007, 47.27631256700005],
              [38.820648634000065, 47.286444403000075],
              [38.81039472700007, 47.28782786700003],
              [38.80201256600009, 47.280910549000055],
              [38.78956139400009, 47.262600002000056],
              [38.78288821700005, 47.259100653000075],
              [38.773448113000086, 47.258246161000045],
              [38.75513756600009, 47.259100653000075],
              [38.59457441500007, 47.24127838700008],
              [38.553396030000044, 47.229803778000075],
              [38.51905358200008, 47.21076080900008],
              [38.50049889400009, 47.18158600500004],
              [38.494883660000085, 47.17658112200007],
              [38.48552493600005, 47.17462799700007],
              [38.473317905000044, 47.16941966400009],
              [38.46265709700009, 47.161810614000046],
              [38.45818118600005, 47.15265534100007],
              [38.44898522200009, 47.140285549000055],
              [38.42790774800005, 47.13353099200003],
              [38.26539147200009, 47.118801174000055],
              [38.22413170700008, 47.10834381700005],
              [38.21664472700007, 47.10325755400004],
              [38.20141971900006, 47.13074188300003],
              [38.19697554500004, 47.162393698000116],
              [38.203486776000034, 47.192314352000054],
              [38.2225037020001, 47.21523284900009],
              [38.24131392400011, 47.22394032800004],
              [38.26394820200005, 47.23153676400001],
              [38.284722127000066, 47.241148580000115],
              [38.298158000000114, 47.256031392000054],
              [38.30094852700006, 47.276030172],
              [38.29185347500004, 47.287037252000076],
              [38.275730429000134, 47.291817322000085],
              [38.25764367700009, 47.292747498000054],
              [38.22033329300007, 47.288794251000056],
              [38.20100630700006, 47.29062876400006],
              [38.18870731600009, 47.300989889000064],
              [38.190567668000085, 47.3169062300001],
              [38.203383423000105, 47.334631246000114],
              [38.233355753000126, 47.36240732800006],
              [38.257953736000104, 47.39323232100004],
              [38.26363814200005, 47.42170603500007],
              [38.26033085100005, 47.492941997000045],
              [38.27438684000009, 47.52784942700002],
              [38.29340376800013, 47.56278269500011],
              [38.319035278000115, 47.59130808500005],
              [38.35293501800004, 47.60709523600006],
              [38.56222456900008, 47.626628927000056],
              [38.58764937300009, 47.63430287700005],
              [38.60635624200006, 47.64505157500007],
              [38.643356567000126, 47.6735252890001],
              [38.66216678900014, 47.68329213500006],
              [38.67787642400009, 47.68517832500005],
              [38.713016398000036, 47.675721538000104],
              [38.734513794000065, 47.67714263900008],
              [38.745159139000066, 47.69311065700002],
              [38.75332401600008, 47.735149435000054],
              [38.77099735500008, 47.78083140100004],
              [38.79621545400005, 47.81992462200007],
              [38.8309420170001, 47.84824330600007],
              [38.8772441000001, 47.86123993000011],
              [39.03618022000006, 47.85700264800006],
              [39.039094686000055, 47.85692494800013],
              [39.0929415280001, 47.83209442100009],
              [39.11350874800007, 47.82855458600004],
              [39.13324914600014, 47.82953643800009],
              [39.17355676300008, 47.83705535900005],
              [39.319697713000096, 47.846021220000054],
              [39.34005822700004, 47.843566590000094],
              [39.37354455600013, 47.82829620400004],
              [39.391631307000125, 47.822611796],
              [39.41395552500012, 47.823180237000074],
              [39.45705367000011, 47.83129343700007],
              [39.47989465300009, 47.82612579400005],
              [39.509350220000044, 47.82276682600006],
              [39.5700183510001, 47.83093170200006],
              [39.60061079900004, 47.829484762000064],
              [39.700759725000125, 47.811527201],
              [39.73383264200004, 47.81599721300002],
              [39.75905074100007, 47.83294708300012],
              [39.77558719900014, 47.85801015200012],
              [39.78292525200004, 47.88656138200007],
              [39.78209843000013, 47.892891745],
              [39.777550903000076, 47.90658599900003],
              [39.777034139000136, 47.91374318500006],
              [39.77982466600008, 47.92247650200004],
              [39.79047001200007, 47.93774688800009],
              [39.79398400900004, 47.94570505800006],
              [39.79615441900006, 47.96136301700001],
              [39.79439742000005, 47.971310731000116],
              [39.78023807800014, 47.993144023000056],
              [39.77010949700008, 48.0040994270001],
              [39.761944621000055, 48.00978383400006],
              [39.75987756300009, 48.01495147800007],
              [39.76814579200004, 48.02433075000003],
              [39.778791138000145, 48.02921417300006],
              [39.833568156000126, 48.03619049100003],
              [39.84028609200004, 48.03500193300003],
              [39.84297326600006, 48.036397197],
              [39.844316854000056, 48.04567311600003],
              [39.82902063000006, 48.07678232900007],
              [39.83119104000008, 48.09998504700006],
              [39.8430766190001, 48.11975128200005],
              [39.89371952300007, 48.182977397000016],
              [39.91263309700008, 48.197679342000114],
              [39.96048547400011, 48.222070618000046],
              [39.97764204900005, 48.23545481400008],
              [39.9906645100001, 48.25374827100005],
              [39.99324833200012, 48.27323028600004],
              [39.978882284000065, 48.29007680300002],
              [39.957384888000036, 48.29338409500012],
              [39.905191691000084, 48.28064585400007],
              [39.88483117700014, 48.27899220800002],
              [39.81589481600008, 48.308163554000046],
              [39.884107706000066, 48.34635243800001],
              [39.90147098800014, 48.36118357400004],
              [39.92410526600008, 48.376118063],
              [39.91449344900008, 48.384696351000045],
              [39.90684533700011, 48.39833892800003],
              [39.89619999200005, 48.42391876300009],
              [39.8647807210001, 48.46983327300005],
              [39.85434208200007, 48.47544016500008],
              [39.844730266000056, 48.48350168900008],
              [39.842146444000036, 48.4990562950001],
              [39.84669396900006, 48.4998314410001],
              [39.855995728000096, 48.49936635300007],
              [39.86540083800014, 48.50148508800005],
              [39.869534953000084, 48.509908346000046],
              [39.8685014240001, 48.512905579000076],
              [39.86612430800005, 48.517039693000086],
              [39.86385054600004, 48.522749940000054],
              [39.862713664000125, 48.53006215500004],
              [39.85506555200004, 48.55610707700002],
              [39.83532515500008, 48.57347035800002],
              [39.80917688000011, 48.58375396800001],
              [39.690114379000136, 48.593675842000025],
              [39.67027063000006, 48.588404847000064],
              [39.631720011000084, 48.58690623000008],
              [39.64184859200009, 48.6117109180001],
              [39.70293013500009, 48.74658640500006],
              [39.711405070000126, 48.75480295900009],
              [39.73631311100007, 48.761520894000014],
              [39.744477987000096, 48.77051259400007],
              [39.751195923000125, 48.781881409000036],
              [39.759360799000035, 48.79283681200012],
              [39.77941125500007, 48.807719625000075],
              [39.801218710000114, 48.81490264900002],
              [39.82416304600014, 48.81562612000003],
              [39.934957317000055, 48.786687317000045],
              [39.97526493300012, 48.789684550000075],
              [40.01960331200007, 48.813145651000056],
              [40.03872359300004, 48.82999216800003],
              [40.052779582000085, 48.84973256500008],
              [40.053813110000135, 48.869214580000076],
              [40.03427941900014, 48.885596009000025],
              [40.00885461400014, 48.88781809500004],
              [39.989941040000076, 48.87567413400002],
              [39.97226770000009, 48.860326233000066],
              [39.95035689300005, 48.852781474000025],
              [39.93764449100007, 48.856243795000054],
              [39.91862756400013, 48.87247019500005],
              [39.90818892400006, 48.878412984000065],
              [39.89651005100012, 48.879911601000074],
              [39.861886841000114, 48.876449280000045],
              [39.78230513500006, 48.8884382130001],
              [39.75874068200005, 48.8954145310001],
              [39.74737186700008, 48.905336406000075],
              [39.73941369600004, 48.918978983],
              [39.7259778240001, 48.937014059],
              [39.707787720000056, 48.9487962860001],
              [39.68753055800005, 48.95758127900008],
              [39.67399133300006, 48.9701386520001],
              [39.68112268100009, 49.02031646800005],
              [39.698279256000035, 49.02837799100003],
              [39.74892216000012, 49.02620758100004],
              [39.831501099000036, 49.04527618400003],
              [39.86199019400004, 49.045121156000064],
              [39.89134240700008, 49.04176218700006],
              [39.90725874900005, 49.04258901000007],
              [39.91873091600007, 49.04780833000011],
              [39.923381795000125, 49.057988587000054],
              [39.92606897000013, 49.086513977000024],
              [39.93092655400005, 49.10056996700003],
              [39.95211389200011, 49.12454783200006],
              [39.97960575400009, 49.141859437000065],
              [40.038413533000096, 49.16852447600009],
              [40.057740519000106, 49.18278717100007],
              [40.09091678900012, 49.21725535100005],
              [40.11024377500007, 49.22764231400005],
              [40.13401493400005, 49.236272279],
              [40.14166304500014, 49.245780741],
              [40.14269657400013, 49.28190256800009],
              [40.157165975000055, 49.31585398400004],
              [40.1595430910001, 49.333579],
              [40.14807092300009, 49.34959869400011],
              [40.10135542900008, 49.38546213800005],
              [40.06197798700009, 49.42582143200009],
              [40.04089400200013, 49.45548370400006],
              [40.034899536000125, 49.48705800400005],
              [40.054329875000064, 49.51976918600003],
              [40.07200321400012, 49.530672913],
              [40.11065718600008, 49.545349019000085],
              [40.126056763000065, 49.55909495100012],
              [40.13070764200006, 49.57981720100004],
              [40.118504096000095, 49.58845100100005],
              [40.11551477000012, 49.590565898000065],
              [40.017742960000135, 49.60787750300007],
              [39.99810591600004, 49.60823923800008],
              [39.9740246990001, 49.60255483000013],
              [39.91470015500005, 49.562970684000064],
              [39.88937870300009, 49.553255513000025],
              [39.85940637200014, 49.545555726000046],
              [39.8287105710001, 49.541473288000034],
              [39.80152876800008, 49.54219675700004],
              [39.781064901000036, 49.54839792900002],
              [39.72918176300004, 49.58079905200002],
              [39.68866744000013, 49.59345977800005],
              [39.65332076000004, 49.59981598000009],
              [39.62293501800008, 49.61345855800009],
              [39.59740686100014, 49.64797841500008],
              [39.58159387200004, 49.69071482300008],
              [39.5704317630001, 49.71329742500002],
              [39.557512655000096, 49.72399444600002],
              [39.499118286000055, 49.72812856000006],
              [39.47989465300009, 49.73360626300003],
              [39.44361779800005, 49.749522603000074],
              [39.405997355000125, 49.74425160800003],
              [39.36724003100011, 49.73184926400005],
              [39.32765588400014, 49.72631988500005],
              [39.289932089000104, 49.73205597000002],
              [39.26088993400003, 49.74450999],
              [39.23804895100011, 49.765128886000085],
              [39.182755168000085, 49.85850819900007],
              [39.181005517000074, 49.85948693100006],
              [39.15578007000005, 49.873597718000084],
              [39.11712609800014, 49.86439931300008],
              [39.09986617000004, 49.85163523400011],
              [39.0683435470001, 49.82109446200009],
              [39.04911991400007, 49.81055247000005],
              [39.0322733970001, 49.80734853200006],
              [38.9373954670001, 49.80347279900012],
              [38.91052372200011, 49.820577698000065],
              [38.88633915200006, 49.845175680000054],
              [38.8522327070001, 49.865794577000045],
              [38.74784631300008, 49.88543162100008],
              [38.68728153500007, 49.913801982000095],
              [38.68097701000005, 49.91829783100012],
              [38.675602661000084, 49.927031149000086],
              [38.67281213400014, 49.942999166000035],
              [38.664337199000045, 49.96268788700009],
              [38.66464725700013, 49.96516835600006],
              [38.66216678900014, 49.962584534000044],
              [38.63777551300012, 49.95721018500008],
              [38.628887166000084, 49.95333445200005],
              [38.61948205600004, 49.95075063100005],
              [38.570182740000064, 49.95664174400004],
              [38.49752567500008, 49.94816680900003],
              [38.46114546700011, 49.956900127000026],
              [38.437787720000074, 49.96728709000003],
              [38.420114380000086, 49.97178293900005],
              [38.37629276500007, 49.974935201],
              [38.356035604000056, 49.98056793200003],
              [38.344150024000044, 49.992091777000056],
              [38.31407434100004, 50.04950429400007],
              [38.29991499900012, 50.06051137300007],
              [38.28120813000004, 50.06242340100009],
              [38.25381962000006, 50.059064433000074],
              [38.18984419700007, 50.06278513600007],
              [38.17392785600009, 50.060149638000055],
              [38.1641093340001, 50.03038401400006],
              [38.17134403500006, 49.9840819300001],
              [38.16617639200007, 49.940570374000075],
              [38.119047486000056, 49.91917633100006],
              [38.108402141000056, 49.92067494700005],
              [38.09031538900007, 49.92842641300008],
              [38.07915327900014, 49.929925029000074],
              [38.06654423000009, 49.92723785400004],
              [38.02292379300013, 49.90914218900009],
              [38.00039839700014, 49.89979766900008],
              [37.99585087000008, 49.90589548800004],
              [37.99533410600014, 49.92134674100005],
              [37.98003788200009, 49.93958852200011],
              [37.97900435300011, 49.94144887300011],
              [37.9465515550001, 49.978190816000094],
              [37.91585575400006, 50.0033055630001],
              [37.88174930800011, 50.02304596000009],
              [37.84278527800012, 50.03911733000005],
              [37.76341027900014, 50.06257843100012],
              [37.72765018700011, 50.078701477],
              [37.631842082000105, 50.1740961710001],
              [37.597115519000056, 50.196937154000025],
              [37.5902942300001, 50.203810120000085],
              [37.588640585000064, 50.21461049400004],
              [37.59153446400012, 50.22530751600003],
              [37.60155969200008, 50.249026998],
              [37.59918257600009, 50.29088490800005],
              [37.568176717000085, 50.31253733400003],
              [37.48001672400005, 50.340029195000014],
              [37.463790324000115, 50.366539205000024],
              [37.45025109900007, 50.398992005000125],
              [37.4352649330001, 50.424933573000075],
              [37.41521447800005, 50.431858216000066],
              [37.31475549400005, 50.422969870000045],
              [37.28519657400011, 50.41527008100006],
              [37.22669885300013, 50.377081198000084],
              [37.197036580000145, 50.36240509100007],
              [37.05172245200009, 50.33532664000002],
              [36.980098918000124, 50.34214792900009],
              [36.914056437000056, 50.33909902000006],
              [36.848634074000074, 50.32369944300008],
              [36.68264937300006, 50.26065419600003],
              [36.6698336180001, 50.25300608300007],
              [36.66042850800005, 50.24385935500008],
              [36.64440881400009, 50.222258606000096],
              [36.63583052600006, 50.214042054000075],
              [36.61691695200011, 50.206393942],
              [36.5943860270001, 50.20443023700007],
              [36.571028280000064, 50.20691070600013],
              [36.549530884000035, 50.21218170200008],
              [36.534648072000095, 50.219933167000065],
              [36.531650838000076, 50.228821513000085],
              [36.53392460100008, 50.23869171200006],
              [36.536095012000146, 50.26091257700001],
              [36.538885539000034, 50.26504669200004],
              [36.53640507000006, 50.26752716100002],
              [36.52110884600012, 50.27409006800009],
              [36.51211714700014, 50.276415507000124],
              [36.48018111100009, 50.280859681000024],
              [36.452689250000105, 50.29357208200007],
              [36.430571736000104, 50.296879374000085],
              [36.41000451600013, 50.30457916300007],
              [36.40018599400014, 50.30664622000005],
              [36.387990356000046, 50.306439515000065],
              [36.380962362000105, 50.30406239900013],
              [36.36142867000012, 50.291660055000065],
              [36.33951786300014, 50.2814797970001],
              [36.315850057000034, 50.274865214],
              [36.29197554500013, 50.274038391000076],
              [36.269031209000104, 50.28137644500008],
              [36.16929569500007, 50.38369578100007],
              [36.14077030400006, 50.392945862],
              [36.13322554600012, 50.41160105400006],
              [36.10583703600008, 50.42110951800005],
              [35.931894165000074, 50.430152893000084],
              [35.837429646000146, 50.42322825100011],
              [35.819342895000034, 50.419042460000085],
              [35.805390259000035, 50.412169495000015],
              [35.78554650800004, 50.39449615500011],
              [35.7743843990001, 50.386899720000045],
              [35.76539270100005, 50.384522604],
              [35.74616906800014, 50.38395416300004],
              [35.73769413300005, 50.38157704700008],
              [35.72126102700008, 50.368709616],
              [35.71030562300007, 50.35563547800005],
              [35.696869751000065, 50.345145162000094],
              [35.69221013400005, 50.344168474000114],
              [35.67320194500013, 50.340184225000044],
              [35.6521179610001, 50.3411144010001],
              [35.63155074100007, 50.34499013300005],
              [35.611396932000105, 50.35170806900008],
              [35.59217329900008, 50.36049306200006],
              [35.57015913900011, 50.37646108000011],
              [35.56385461500008, 50.39180898000008],
              [35.562304321000056, 50.409637350000125],
              [35.554656209000086, 50.43325348000003],
              [35.54080692500014, 50.45004832000011],
              [35.52272017400014, 50.459505107000055],
              [35.50194624800008, 50.464311015000064],
              [35.48013879400014, 50.46689483700008],
              [35.446445760000074, 50.476041565000074],
              [35.42525842300006, 50.50048451800011],
              [35.37771610500005, 50.62182078100007],
              [35.376165812000124, 50.63458486000003],
              [35.39156538900011, 50.64636708700003],
              [35.4688733320001, 50.66853627500005],
              [35.445412231000034, 50.687501527],
              [35.44375858600006, 50.70946401],
              [35.447065878000046, 50.734320373000045],
              [35.438487590000136, 50.76238067600006],
              [35.42939253700007, 50.77214752200011],
              [35.41823042800013, 50.77891713500004],
              [35.39311568200009, 50.78837392200002],
              [35.37905969200011, 50.79721059200004],
              [35.377406047000136, 50.80754587900013],
              [35.37967981000014, 50.819586487000024],
              [35.37771610500005, 50.83374583000004],
              [35.369034465000084, 50.8460448200001],
              [35.348570597000105, 50.863769837000106],
              [35.341439250000064, 50.876482239000055],
              [35.34040572100008, 50.89183013900005],
              [35.34298954200011, 50.90412913000007],
              [35.341749308000146, 50.915859680000054],
              [35.32914025900004, 50.929088847000045],
              [35.31715132700009, 50.93420481400004],
              [35.293586873000095, 50.93761545800008],
              [35.28480188000009, 50.9443333950001],
              [35.28221805800007, 50.95425527],
              [35.28221805800007, 50.96110741200003],
              [35.28221805800007, 50.981540426000024],
              [35.27808394400006, 50.99265085900002],
              [35.33255090400007, 50.999937236],
              [35.34671024500011, 51.00825714100007],
              [35.35508182700005, 51.025594585000064],
              [35.346400187000086, 51.03660166400006],
              [35.32841678900013, 51.04316457100005],
              [35.30867639200005, 51.04732452500009],
              [35.274259887000085, 51.04879730200007],
              [35.20646040800011, 51.038927104],
              [35.17256066900006, 51.04063242700006],
              [35.143621867000036, 51.05848663400012],
              [35.12377811700014, 51.09132700600004],
              [35.09918013500004, 51.183181865000094],
              [35.09132531800009, 51.19767710400005],
              [35.07871626800011, 51.20762481700005],
              [35.05938928200004, 51.212327373],
              [35.038718709000136, 51.21015696200003],
              [35.01877160600009, 51.20455007],
              [34.99944462000013, 51.20209543900005],
              [34.98032434100014, 51.20953684600006],
              [34.96182417800014, 51.21532460500002],
              [34.946114542000146, 51.214291077000055],
              [34.899605754000106, 51.19646270800011],
              [34.81754357900013, 51.174732768000084],
              [34.748090454000135, 51.16473337900008],
              [34.67491662600008, 51.16767893500007],
              [34.657449992000124, 51.171658021000056],
              [34.642773885000054, 51.1806238810001],
              [34.633162069000036, 51.19561004700007],
              [34.62851119000004, 51.21106130000008],
              [34.62241337100011, 51.2247555550001],
              [34.608357381000076, 51.234005636000106],
              [34.57817834500008, 51.23669281000004],
              [34.51347945100008, 51.229561462],
              [34.48040653500004, 51.23697703100002],
              [34.40898970600011, 51.253125916],
              [34.37178267400009, 51.25684661900003],
              [34.33695275900004, 51.25113637400007],
              [34.29953902200009, 51.23162852000006],
              [34.28176232900006, 51.22643503900004],
              [34.25788781700004, 51.229561462],
              [34.18595422400011, 51.248914286000044],
              [34.2439351810001, 51.27408071000009],
              [34.283622681000054, 51.301236674000066],
              [34.308737427000096, 51.33461965000005],
              [34.30015913900013, 51.36839019800003],
              [34.280315389000066, 51.361258850000084],
              [34.26439904800014, 51.36120717400006],
              [34.24734582500008, 51.363429260000075],
              [34.230499308000105, 51.36766672800012],
              [34.215719848000106, 51.37376454700008],
              [34.19597945100014, 51.3856242880001],
              [34.18585087100007, 51.394150899000024],
              [34.18192346100011, 51.402341614000036],
              [34.186987753000096, 51.40831024200007],
              [34.20879520700004, 51.41146250400003],
              [34.217063436000046, 51.41706939800004],
              [34.219647258000066, 51.42727549200002],
              [34.217063436000046, 51.43606048700009],
              [34.21323937900013, 51.444819641],
              [34.212102498000036, 51.45502573700007],
              [34.21499637900013, 51.46466339200008],
              [34.223781372000076, 51.482362569000074],
              [34.225951782000095, 51.49287872300003],
              [34.22367801900015, 51.51476369200007],
              [34.21540979000014, 51.53199778300008],
              [34.20238732900009, 51.54615712500002],
              [34.160322714000074, 51.57612945600006],
              [34.15298465900014, 51.583984274],
              [34.14885054500013, 51.593208516000104],
              [34.144509725000034, 51.6137757370001],
              [34.14006555200007, 51.621191305000096],
              [34.126009562000036, 51.62700490400009],
              [34.09066288300005, 51.633206076000064],
              [34.07950077400011, 51.64310211200005],
              [34.08911258900008, 51.66661488900006],
              [34.12797326700007, 51.68074839300009],
              [34.29819543500008, 51.7061473590001],
              [34.35689986200009, 51.70555308100002],
              [34.37633020000004, 51.70860199000005],
              [34.41415734900011, 51.73645558700012],
              [34.41271040900011, 51.77769338000003],
              [34.385735310000086, 51.81766510100009],
              [34.37110138200006, 51.826811306000124],
              [34.347288046000074, 51.84169464100002],
              [34.327754353000046, 51.85050547300001],
              [34.294578084000136, 51.873889059000064],
              [34.27669803900005, 51.881227113000065],
              [34.26491581200008, 51.88120127400005],
              [34.24600223800013, 51.8754651900001],
              [34.23422001200004, 51.87828155600006],
              [34.23463342300005, 51.88073618600002],
              [34.231016072000045, 51.89453379400008],
              [34.22843225100007, 51.89926218700005],
              [34.22264449000011, 51.90316375800002],
              [34.20941532400008, 51.90879648900004],
              [34.20342085700008, 51.91231048700011],
              [34.16642053300012, 51.94225697900005],
              [34.146163371000114, 51.95161041300007],
              [34.096243937000054, 51.95181711900004],
              [34.096657349000054, 51.96057627400002],
              [34.10440881300008, 51.975304057000116],
              [34.101101521000146, 51.992512309000105],
              [34.08032759600013, 52.01362213100005],
              [34.06823531100014, 52.031011252000056],
              [34.0625509030001, 52.05020904600006],
              [34.060070434000124, 52.08317861000005],
              [34.05665979000008, 52.100386862],
              [34.05665979000008, 52.105812887000084],
              [34.07391971900006, 52.128317973],
              [34.0736096600001, 52.13955759700006],
              [34.07102583800008, 52.14896270800001],
              [34.065341431000036, 52.15862620100005],
              [34.05572961400014, 52.17033091300003],
              [34.03888309700005, 52.186479798],
              [34.02193322800014, 52.19790028900009],
              [33.95775109900012, 52.22469451900007],
              [33.944418579000114, 52.235779114000096],
              [33.91951053900004, 52.269756369000035],
              [33.90070031700009, 52.28585357700008],
              [33.858739054000125, 52.302157491000045],
              [33.83910201000009, 52.31391388000013],
              [33.82339237500008, 52.331458029],
              [33.81522749800007, 52.34507476800009],
              [33.80406538900007, 52.35460907000008],
              [33.778950643000144, 52.36006093400006],
              [33.733578736000084, 52.36099110900001],
              [33.687948445000075, 52.35582346600002],
              [33.60020186400004, 52.330786235000105],
              [33.53167891500004, 52.288824972],
              [33.510078166000085, 52.28753306100005],
              [33.49302494300014, 52.3031393430001],
              [33.499432821000084, 52.34099233000008],
              [33.48051924600014, 52.35776133300003],
              [33.46532637600012, 52.352748718000086],
              [33.45178715000014, 52.34525563600003],
              [33.4373177490001, 52.33915781700007],
              [33.41933435100009, 52.33833099400006],
              [33.40367639200008, 52.34295603500003],
              [33.400576080000064, 52.34434301700013],
              [33.37618452900011, 52.35525502500006],
              [33.358976277000124, 52.357554627000084],
              [33.29432906100004, 52.35729624500003],
              [33.19650557500006, 52.36894928000008],
              [33.1828629960001, 52.36729563500002],
              [33.166636597000036, 52.36006093400006],
              [33.14085005700014, 52.340372213000094],
              [33.12798262500007, 52.33272410200003],
              [33.10886234500009, 52.32833160400004],
              [33.0990438230001, 52.32476593100007],
              [33.08736494900012, 52.31076161800006],
              [33.07961348500004, 52.305593975000065],
              [33.07041508000009, 52.30417287200008],
              [33.057289266000055, 52.30864288400009],
              [33.04824589000009, 52.309082134],
              [33.03010746300009, 52.30360443100004],
              [32.9268579510001, 52.246915386000026],
              [32.90897790500014, 52.241101787000034],
              [32.8907878010001, 52.24231618300006],
              [32.86102217700011, 52.257198996000014],
              [32.84417566000013, 52.26234080000002],
              [32.81482344500006, 52.26200490300003],
              [32.75560225400005, 52.2523930870001],
              [32.72542321800006, 52.25208302900002],
              [32.52843265800004, 52.31621348100005],
              [32.48058028200006, 52.30714426700008],
              [32.3942806390001, 52.32680715000002],
              [32.35355961100004, 52.32158783000001],
              [32.33950362100012, 52.28724884100008],
              [32.34446455900007, 52.27652598100006],
              [32.36327478100009, 52.25572621700012],
              [32.366995484000086, 52.247199606],
              [32.36131107600005, 52.235908305000024],
              [32.35014896700011, 52.22988800100008],
              [32.337849976000086, 52.225469666],
              [32.32823815900008, 52.21916514100009],
              [32.318833049000034, 52.20141428700005],
              [32.30674076300011, 52.141185405],
              [32.27769860900014, 52.10266062500004],
              [32.233308553000086, 52.08085317000008],
              [32.09559086100006, 52.040726421],
              [32.07714237500005, 52.03995127399999],
              [32.01693933100006, 52.04979563400006],
              [31.980559122000102, 52.04762522500006],
              [31.927229044000114, 52.03108876600008],
              [31.910382528000127, 52.029073385000046],
              [31.892037394000056, 52.03617889500005],
              [31.887748250000072, 52.05155263300004],
              [31.887489868000102, 52.07002695700005],
              [31.88206384300014, 52.086408386000116],
              [31.85870609500006, 52.09987009700008],
              [31.82583988400006, 52.104055888000104],
              [31.76434493000005, 52.10056772900005],
              [31.766618693000055, 52.13007497200006],
              [31.762587932000088, 52.14984120700005],
              [31.74904870600011, 52.16394887400007],
              [31.69871586100004, 52.185446269000025],
              [31.68951745600009, 52.19156992600007],
              [31.68238610800006, 52.2019310510001],
              [31.679492228000072, 52.21585784900007],
              [31.68192102000006, 52.230456441000044],
              [31.68889733800006, 52.24322052000012],
              [31.69943933100012, 52.25146291100005],
              [31.683419637000043, 52.257198996000014],
              [31.64869307400005, 52.26099721300004],
              [31.63143314600012, 52.26476959300008],
              [31.61365645300009, 52.273011984],
              [31.597119995000128, 52.28430328399999],
              [31.567354370000146, 52.31138173400005],
              [31.579601684000068, 52.31851308200008],
              [31.592262410000103, 52.32861582500003],
              [31.602752727000052, 52.34091481600005],
              [31.60859216300014, 52.35442820300004],
              [31.608075398000096, 52.37246327800004],
              [31.600530639000056, 52.383392843000095],
              [31.590350382000054, 52.391841940000106],
              [31.582857300000057, 52.402771505000075],
              [31.583322387000067, 52.42829966300009],
              [31.589368530000115, 52.45803944900008],
              [31.58792159000012, 52.48261159300007],
              [31.565494018000038, 52.49263682100009],
              [31.55298832200009, 52.502248637],
              [31.550559529000054, 52.51188629200003],
              [31.55815596500014, 52.519999492000025],
              [31.575932658000056, 52.524727885000104],
              [31.56363366700009, 52.53705271400004],
              [31.55929284700005, 52.5405408730001],
              [31.574382364000144, 52.54126434400008],
              [31.610762574000034, 52.53599334700006],
              [31.62430179900008, 52.538060405000024],
              [31.62864261800007, 52.54805979500004],
              [31.615206746000126, 52.558575949],
              [31.579033243000083, 52.577825419000035],
              [31.56590743000004, 52.590150248000086],
              [31.536141805000057, 52.63048370400004],
              [31.49170007300006, 52.667096457000085],
              [31.48064131700005, 52.68247019500005],
              [31.54792403200014, 52.70569875100007],
              [31.570248250000134, 52.725258281],
              [31.56952478000011, 52.76750376400007],
              [31.560843139000042, 52.78706329400008],
              [31.550559529000054, 52.794737244000075],
              [31.53836389100013, 52.79985321100007],
              [31.523946167000133, 52.811661276000066],
              [31.515161173000138, 52.828378602],
              [31.51278405700009, 52.841039328000036],
              [31.50513594600011, 52.848894145000074],
              [31.48064131700005, 52.85093536400005],
              [31.45097904400012, 52.85721405100004],
              [31.418112834000055, 52.87023651200009],
              [31.387933797000073, 52.887987367],
              [31.36622969600006, 52.9085545870001],
              [31.33915124500004, 52.95806060900004],
              [31.322614787000134, 52.97712921200012],
              [31.24706384300009, 53.01438791900004],
              [31.269284708000043, 53.02841807100005],
              [31.319204142000103, 53.0763738000001],
              [31.329436076000093, 53.0793451950001],
              [31.354137411000067, 53.08210988400005],
              [31.363697550000097, 53.08877614400005],
              [31.367056519000073, 53.09893056200012],
              [31.36488610900011, 53.109730937000066],
              [31.361573285000077, 53.120037500000095],
              [31.36116540600011, 53.121306458],
              [31.359925171000043, 53.133837993],
              [31.37852868600004, 53.182026265],
              [31.416355835000104, 53.199983826000064],
              [31.464001506000045, 53.199983826000064],
              [31.51206058800011, 53.194066875000075],
              [31.535935100000074, 53.19486785900007],
              [31.57365889500005, 53.207089336000095],
              [31.593605997000054, 53.21068084800008],
              [31.61401818900009, 53.20975067200003],
              [31.67494470200006, 53.19522959500007],
              [31.694478393000054, 53.19290415500005],
              [31.738558390000037, 53.19254241900005],
              [31.75628340600008, 53.18657379200003],
              [31.769719279000128, 53.16926218700003],
              [31.780467977000114, 53.12786936400009],
              [31.79628096600004, 53.11239227300008],
              [31.806822957000065, 53.110015157000035],
              [31.84263472500004, 53.112185567000026],
              [31.855502157000103, 53.11024770100009],
              [31.90717858800008, 53.09192840600012],
              [31.930743042000074, 53.08833689400005],
              [31.95472090700008, 53.08999054000007],
              [31.980559122000102, 53.09802622500008],
              [32.00991133700006, 53.0999640910001],
              [32.08277510600004, 53.081954855],
              [32.11729496300006, 53.08110219300006],
              [32.12654504400007, 53.08422861800004],
              [32.15233158400008, 53.09634674100003],
              [32.18860843900012, 53.099240622000096],
              [32.197393432000126, 53.097742005],
              [32.201114136000115, 53.097561138000046],
              [32.20592004400004, 53.100351665000105],
              [32.20700524900013, 53.10515757200001],
              [32.20648848500008, 53.109860128],
              [32.20669519100005, 53.11239227300008],
              [32.20907230600011, 53.11634552000005],
              [32.2105192460001, 53.121771545000016],
              [32.2156868890001, 53.12551808700003],
              [32.26798343900009, 53.124768779000036],
              [32.29516524200005, 53.140865987000026],
              [32.320279989000085, 53.162776795000056],
              [32.35283614100007, 53.180450134000054],
              [32.38911299600011, 53.1876331590001],
              [32.40554610200007, 53.192671611],
              [32.42363285300007, 53.20440216100006],
              [32.45567224100006, 53.23667409300005],
              [32.46921146700009, 53.255458476000044],
              [32.47913334200007, 53.27491465300004],
              [32.45598230000007, 53.27778269500003],
              [32.44719730600008, 53.2887639370001],
              [32.45484541900004, 53.30044281100008],
              [32.48058028200006, 53.30517120400005],
              [32.50564335100006, 53.297187196],
              [32.53732100400009, 53.2950684610001],
              [32.56915368600011, 53.29884084100003],
              [32.595922079000104, 53.30827179],
              [32.5918913160001, 53.31183746400008],
              [32.58346805800011, 53.32121673600001],
              [32.57995406100014, 53.32436899800008],
              [32.64987227300014, 53.333670757],
              [32.66671879000012, 53.33134531700007],
              [32.68180830900013, 53.32679779100003],
              [32.69793135600008, 53.325893454],
              [32.71746504700013, 53.33493682900006],
              [32.704442587000074, 53.36640777600009],
              [32.717794068000046, 53.43106187400009],
              [32.71953210400005, 53.43947825200006],
              [32.70123864700008, 53.462112529000095],
              [32.68852624500005, 53.462215882000024],
              [32.65824385500014, 53.455652975000035],
              [32.646771688000115, 53.45797841400007],
              [32.64165572100012, 53.46898549400005],
              [32.647598511000126, 53.479320780000066],
              [32.650285685000085, 53.487640687000024],
              [32.635712932000104, 53.4926533000001],
              [32.618142944000056, 53.49425526900002],
              [32.60057295800004, 53.492394918000016],
              [32.59251143400007, 53.48645212800001],
              [32.58429488200005, 53.48423004200002],
              [32.57680179900012, 53.486038717],
              [32.56987715700012, 53.492394918000016],
              [32.56987715700012, 53.49260162400007],
              [32.55427087400005, 53.51079172800003],
              [32.53080977400009, 53.521437073000115],
              [32.48058028200006, 53.53564809200007],
              [32.452933391000045, 53.54639679000009],
              [32.42942061400004, 53.56158966100013],
              [32.41148889100009, 53.582363587000074],
              [32.40110192900005, 53.60985544900005],
              [32.39800134300009, 53.62742543600011],
              [32.39908654800013, 53.635383606000076],
              [32.406114543000115, 53.63941436800006],
              [32.48058028200006, 53.6624103810001],
              [32.48781498200009, 53.66964508100007],
              [32.49019209800008, 53.67713816300004],
              [32.48781498200009, 53.68468292300007],
              [32.48058028200006, 53.69207265200008],
              [32.46156335400008, 53.70680043600008],
              [32.44213301600013, 53.71393178300012],
              [32.42156579600004, 53.71579213500003],
              [32.371801391000076, 53.714396871000034],
              [32.35738366700008, 53.719719544],
              [32.32580936700009, 53.74545440700008],
              [32.29041101000007, 53.760853984000065],
              [32.164837280000086, 53.78167958600004],
              [32.10602950000009, 53.80694936100009],
              [32.08360192900011, 53.80963653600013],
              [31.873175496000044, 53.77713206],
              [31.787289266000073, 53.79439198800007],
              [31.744656209000084, 53.7948570760001],
              [31.753802938000092, 53.819610087000044],
              [31.79256026200011, 53.85743723500009],
              [31.81013024900011, 53.882603659000054],
              [31.826460002000147, 53.940171204000094],
              [31.837932170000045, 53.96213368700005],
              [31.83927575700011, 53.969781800000035],
              [31.83968916900011, 53.97722320600006],
              [31.841446167000072, 53.984561259000046],
              [31.84651045700008, 53.99231272400006],
              [31.823566121000056, 54.045487773],
              [31.823876180000127, 54.05013865200006],
              [31.82263594500006, 54.053445944000075],
              [31.81385095200011, 54.05706329400006],
              [31.808476604000134, 54.05597808900005],
              [31.783516886000143, 54.04579783100009],
              [31.77126957200005, 54.04853668300002],
              [31.762587932000088, 54.06031890900003],
              [31.75576664200014, 54.074943339000114],
              [31.748118531000046, 54.0863121550001],
              [31.736749715000144, 54.094166972000025],
              [31.725794311000072, 54.09747426400013],
              [31.697837361000097, 54.09793935200007],
              [31.66693485500008, 54.10186676000002],
              [31.583115682000084, 54.12951365200003],
              [31.530870809000135, 54.13742014600008],
              [31.506376180000075, 54.143931376000054],
              [31.48064131700005, 54.15664377900002],
              [31.32468184400011, 54.22924916600003],
              [31.309799032000058, 54.244338685000045],
              [31.299153686000068, 54.27260569300002],
              [31.292022339000084, 54.331258444000056],
              [31.28478763800007, 54.347381490000046],
              [31.274142293000068, 54.35663157100005],
              [31.26173994900006, 54.36448639000007],
              [31.248717488000068, 54.376785380000015],
              [31.22535974100009, 54.428048402000044],
              [31.209029988000054, 54.44804718100009],
              [31.179212687000074, 54.45311147100007],
              [31.179016967000052, 54.45335277000005],
              [31.167895548000104, 54.46706410800006],
              [31.093584839000073, 54.47941477500011],
              [31.064646037000045, 54.4922822060001],
              [31.089554077000116, 54.535897116000044],
              [31.139473511000062, 54.582870992000025],
              [31.16794722500009, 54.62157664000004],
              [31.12862146000009, 54.64038686100004],
              [31.105160359000138, 54.668292135000016],
              [31.020927775000075, 54.673666484000094],
              [30.999016967000102, 54.671341044000044],
              [30.995502970000132, 54.68984120700007],
              [30.98062015800008, 54.70565419600008],
              [30.827296183000044, 54.77102488300004],
              [30.78605839000005, 54.7793447880001],
              [30.770607137000127, 54.78601104800002],
              [30.762648966000086, 54.801979065000054],
              [30.768126668000093, 54.82993601500006],
              [30.787867065000057, 54.84771270800006],
              [30.810708048000038, 54.86151031500002],
              [30.826107625000134, 54.87747833300007],
              [30.827451213000074, 54.90254140200007],
              [30.817425985000057, 54.91763092100008],
              [30.814842163000037, 54.928017884],
              [30.83861332200013, 54.939179993000025],
              [30.899488159000043, 54.94636301800007],
              [30.917368205000116, 54.953959452000035],
              [30.936075073000097, 54.973234762000075],
              [30.931424194000044, 54.98517201800003],
              [30.916954793000116, 54.99602406800007],
              [30.906619507000073, 55.012560527000076],
              [30.913234090000117, 55.024601135000026],
              [30.933491252000124, 55.025634664],
              [30.98062015800008, 55.01865834600004],
              [31.00563155100008, 55.022999167000094],
              [31.006406698000035, 55.04242950500007],
              [30.99421106000011, 55.06702748600007],
              [30.98062015800008, 55.086302796],
              [30.973075399000038, 55.09395090800008],
              [30.970284872000093, 55.10144399100001],
              [30.972661987000038, 55.10857533800005],
              [30.98062015800008, 55.1153449510001],
              [30.985477742000114, 55.125835267000056],
              [30.98403080200012, 55.13089955700012],
              [30.97948327600011, 55.13425852500002],
              [30.975039103000086, 55.13952952100006],
              [30.972455281000066, 55.14087310800004],
              [30.962223348000123, 55.14288848900007],
              [30.958812703000092, 55.14443878200008],
              [30.956848999000044, 55.149503073000076],
              [30.96118981900014, 55.15854644900013],
              [30.959794555000144, 55.16257721000004],
              [30.947237182000038, 55.171362203000015],
              [30.90072839400011, 55.19213612900005],
              [30.88651737500004, 55.20453847300003],
              [30.869825887000104, 55.241538798000065],
              [30.856803426000056, 55.25347605400002],
              [30.82135339400014, 55.26437978100007],
              [30.80409346500005, 55.2729580690001],
              [30.79427494300006, 55.28551544200003],
              [30.79716882300005, 55.30427398700003],
              [30.81122481300008, 55.323084209000044],
              [30.845641317000116, 55.35114451200006],
              [30.905947714000035, 55.37600087500003],
              [30.918298380000067, 55.387783102000114],
              [30.91860843900014, 55.40762685200009],
              [30.905275920000122, 55.420856018],
              [30.88910119700006, 55.43341339200002],
              [30.881298055000116, 55.45144846600003],
              [30.887189169000123, 55.468088277000035],
              [30.913234090000117, 55.479715474],
              [30.919435262000093, 55.492324524000125],
              [30.914370972000086, 55.49330637600009],
              [30.899384807000047, 55.499145813000084],
              [30.91974532100005, 55.53449249300009],
              [30.912820679000106, 55.57159617200007],
              [30.907121887000073, 55.577769863000086],
              [30.88615564000014, 55.600483297000025],
              [30.847656697000104, 55.61102528900007],
              [30.80409346500005, 55.60234364900002],
              [30.770710490000056, 55.591543274000074],
              [30.74218509900004, 55.59438547800006],
              [30.713039591000097, 55.62668324800002],
              [30.703324422000037, 55.64234120700009],
              [30.693712606000133, 55.65215972900005],
              [30.679966675000117, 55.65634552100009],
              [30.639142293000134, 55.65448516900007],
              [30.61661136900011, 55.65743072500008],
              [30.596354207000104, 55.665285543000024],
              [30.583745158000056, 55.679134827000084],
              [30.583745158000056, 55.688539938000034],
              [30.588396037000052, 55.696601461000014],
              [30.591599975000122, 55.70569651300009],
              [30.587465861000055, 55.718305563000015],
              [30.5801278080001, 55.724765117000075],
              [30.56958581500004, 55.72951934900006],
              [30.480702351000048, 55.753962301000016],
              [30.46928186100007, 55.762643942000054],
              [30.471814005000056, 55.77096384700003],
              [30.477808472000106, 55.779128724000046],
              [30.47739506000005, 55.78773285000007],
              [30.46881677300013, 55.793520610000044],
              [30.270792684000128, 55.830650127000055],
              [30.251517375000105, 55.837626445000055],
              [30.21777266400005, 55.8551447550001],
              [30.200254353000048, 55.85798695900006],
              [30.17725834200013, 55.85137237600007],
              [30.132351522000135, 55.826877747000125],
              [30.10625492400004, 55.82191680900006],
              [29.98822595200005, 55.846799012000034],
              [29.94771162900014, 55.848194276000115],
              [29.90781742300004, 55.84320750000005],
              [29.86947351100008, 55.8305467740001],
              [29.844772176000106, 55.812563375000124],
              [29.805704794000064, 55.77145477400005],
              [29.779866577000064, 55.76380666100009],
              [29.71082686400007, 55.77375437400009],
              [29.684161825000047, 55.77060211200002],
              [29.58535648600008, 55.738020121000076],
              [29.508100219000085, 55.6854910280001],
              [29.480866740000124, 55.68109853200009],
              [29.461022990000117, 55.68729970300008],
              [29.413067261000094, 55.72776235],
              [29.363406209000118, 55.75148183200004],
              [29.35074548300014, 55.766054586000095],
              [29.34361413500011, 55.78698354100008],
              [29.348161662000052, 55.80284820600009],
              [29.371932821000087, 55.8363862100001],
              [29.375653524000143, 55.846799012000034],
              [29.380717814000093, 55.87124196400008],
              [29.384128459000124, 55.87994944300003],
              [29.391983277000065, 55.88837270100002],
              [29.399631388000046, 55.89188669900007],
              [29.40779626500006, 55.89387624200002],
              [29.417408081000076, 55.89801035600006],
              [29.4255729570001, 55.899999898],
              [29.433737833000123, 55.899534811000066],
              [29.44055912300007, 55.90054250200005],
              [29.44443485500011, 55.90692454000008],
              [29.441075887000125, 55.91493438700006],
              [29.431567423000104, 55.92418446900005],
              [29.413067261000094, 55.9379820760001],
              [29.395600627000135, 55.94772308400006],
              [29.377410523000094, 55.95402760800006],
              [29.22403487100013, 55.978186341000125],
              [29.19292566000007, 55.992138977000124],
              [29.145435018000086, 56.01203440400003],
              [29.08864261900004, 56.02322235100006],
              [29.030765015000014, 56.024178366000044],
              [28.980845581000068, 56.013533020000025],
              [28.922451212000084, 55.99224233000005],
              [28.92224450700013, 55.99219065400003],
              [28.922141154000087, 55.992138977000124],
              [28.859716024000136, 55.97645518000006],
              [28.833050985000085, 55.96097808900005],
              [28.830880574000105, 55.937672018000015],
              [28.808969767000065, 55.934571432000084],
              [28.731920207000115, 55.94679290800009],
              [28.70639205000009, 55.95984120700005],
              [28.695488322000102, 55.98015004500006],
              [28.690010620000123, 56.00389536500002],
              [28.680605510000078, 56.0273823050001],
              [28.671923868000107, 56.03756256100006],
              [28.637093954000136, 56.06572621700012],
              [28.620712524000112, 56.08298614600001],
              [28.61146244300008, 56.088463847000085],
              [28.59471927900003, 56.092391256000056],
              [28.537823527000086, 56.09771392800009],
              [28.389770548000058, 56.088567200000014],
              [28.366516154000124, 56.079110413000066],
              [28.333443238000143, 56.050249125],
              [28.31091231300013, 56.04267852800005],
              [28.289828329000102, 56.046605937000024],
              [28.269364462000055, 56.05820729600008],
              [28.238461955000048, 56.08262441],
              [28.169112182000106, 56.125257467],
              [28.148906697000115, 56.142414043000045],
              [28.169112182000106, 56.161741028],
              [28.17862064600007, 56.18391021800004],
              [28.184408406000045, 56.20752634700004],
              [28.193141724000043, 56.23103912400005],
              [28.201358276000065, 56.24168446900002],
              [28.209419800000063, 56.24814402300008],
              [28.215310913000053, 56.25599884100002],
              [28.217274617000072, 56.27072662400012],
              [28.214794148000095, 56.28137196900009],
              [28.17443485500013, 56.34963653600006],
              [28.16714847800006, 56.36986785900005],
              [28.16425459800007, 56.392812195],
              [28.167871948000055, 56.427125346000096],
              [28.16425459800007, 56.43795155900004],
              [28.156503133000086, 56.44621978800011],
              [28.104516642000135, 56.48306508400002],
              [28.09645511900007, 56.49195343100003],
              [28.093251180000095, 56.50159108600003],
              [28.099245647000117, 56.51339915000004],
              [28.125238892000084, 56.527145081000086],
              [28.132215210000084, 56.53598175100008],
              [28.126117391000037, 56.54776397700009],
              [28.108650757000078, 56.55517954600002],
              [28.028655640000125, 56.576754456000074],
              [28.01098229900012, 56.58755483],
              [27.997443074000046, 56.60383290600002],
              [27.992172079000113, 56.624994406000084],
              [27.991345255000084, 56.66997874],
              [27.981009969000098, 56.687006124000035],
              [27.882618042000047, 56.72547922800008],
              [27.865461467000102, 56.74268748000004],
              [27.876106811000085, 56.75943064400009],
              [27.90008467600009, 56.78304677400011],
              [27.918894897000115, 56.805887757000036],
              [27.913520548000065, 56.82015045200011],
              [27.891506388000067, 56.8297105920001],
              [27.85223230000011, 56.85430857300007],
              [27.830838257000096, 56.86428212500009],
              [27.7863965250001, 56.87125844300009],
              [27.744073527000097, 56.864798890000046],
              [27.6611845300001, 56.839270732],
              [27.644379266000072, 56.84177167300008],
              [27.62836999500007, 56.84415415500003],
              [27.648730510000092, 56.87926829100006],
              [27.715134724000052, 56.957403056],
              [27.718545369000083, 56.968720195000074],
              [27.72076745600009, 56.988667298000095],
              [27.72335127800008, 56.99879587800005],
              [27.729552450000057, 57.00985463500005],
              [27.74577884900009, 57.03145538300002],
              [27.75073978600011, 57.04235911100007],
              [27.745468791000093, 57.06799062100005],
              [27.722059367000043, 57.07799001100007],
              [27.696066121000058, 57.08545725600008],
              [27.6822168380001, 57.10369903600004],
              [27.7009753830001, 57.11878855500005],
              [27.7940446370001, 57.14338653600002],
              [27.824327027000038, 57.15907033300009],
              [27.833938842000123, 57.18049021500009],
              [27.84117354300008, 57.21121185300005],
              [27.846134481000036, 57.267306621],
              [27.840295044000072, 57.29063852900005],
              [27.827737671000136, 57.304952902000124],
              [27.809134155000095, 57.313944601000074],
              [27.7079517010001, 57.34812856100005],
              [27.69440872000007, 57.356375287],
              [27.64082401500005, 57.38900461800007],
              [27.536282593000067, 57.41569549600011],
              [27.511322876000065, 57.430397441000096],
              [27.514836873000036, 57.447889913000054],
              [27.525637248000066, 57.46837961900003],
              [27.522795044000077, 57.49202158700005],
              [27.52816939300004, 57.52847930900005],
              [27.352934611000137, 57.52760081000012],
              [27.344976440000067, 57.538091126000054],
              [27.335571330000107, 57.553904115000066],
              [27.32854333500012, 57.570569763],
              [27.328026571000066, 57.58315297500012],
              [27.3366048580001, 57.59173126300006],
              [27.34890384900004, 57.59405670200006],
              [27.362546428000144, 57.594547628],
              [27.374845418000092, 57.59785492000002],
              [27.38208011900005, 57.602686666000025],
              [27.38487064600011, 57.606975810000094],
              [27.386989380000102, 57.627646383000084],
              [27.38512902800008, 57.63121205700007],
              [27.382803589000048, 57.63446767200004],
              [27.380219767000142, 57.64772267700006],
              [27.377946004000137, 57.65170176200003],
              [27.377015829000072, 57.656714376000096],
              [27.379703003000117, 57.66645538400006],
              [27.384663940000053, 57.67438771600008],
              [27.3914335530001, 57.68020131400009],
              [27.40771162900012, 57.68898630900007],
              [27.490393921000077, 57.704618429],
              [27.507757202000107, 57.71477284700008],
              [27.508894084000104, 57.7274594120001],
              [27.497835327000104, 57.755674744],
              [27.502434530000073, 57.77254709900008],
              [27.512408081000075, 57.78130625500005],
              [27.52615401200009, 57.78727488200006],
              [27.553852580000125, 57.794767965000105],
              [27.53256189000004, 57.805077414000024],
              [27.524603719000083, 57.80729950000001],
              [27.537626180000103, 57.811562805000065],
              [27.55634348500007, 57.81308699600005],
              [27.700717, 57.82484364900007],
              [27.763452189000077, 57.83866709400003],
              [27.78680993600011, 57.84758127900007],
              [27.79931563300002, 57.86106882700004],
              [27.790840698000125, 57.880860901000105],
              [27.774407593000063, 57.89070526200008],
              [27.673121785000035, 57.91282277400008],
              [27.664956909000125, 57.9184038290001],
              [27.659375855000093, 57.9324598190001],
              [27.66319991100005, 57.943957825000055],
              [27.670434611000104, 57.95496490600003],
              [27.675188843000086, 57.96780649900002],
              [27.669091024000124, 57.991965230000076],
              [27.650642537000124, 58.00007843100009],
              [27.63157393400013, 58.004160868],
              [27.630126993000147, 58.03299631800003],
              [27.63658654800011, 58.059196269000054],
              [27.630437053000037, 58.088290100000066],
              [27.579690796000136, 58.125858867000076],
              [27.540003296000066, 58.171799215000036],
              [27.519585015000047, 58.194509827],
              [27.495354859000116, 58.22146026600005],
              [27.482849161000047, 58.26864084900005],
              [27.494114624000105, 58.31954213500008],
              [27.55488610800012, 58.395248109000065],
              [27.498868856000087, 58.53456776900002],
              [27.44925948000011, 58.65853953100002],
              [27.428848762000086, 58.70940260400006],
              [27.410605509000106, 58.75486440000007],
              [27.446269007000126, 58.818866663000065],
              [27.47778487100007, 58.87542551700004],
              [27.60532230600012, 58.93469838500003],
              [27.69441247600011, 58.975936178000026],
              [27.69588933300011, 58.97718303300009],
              [27.713326049000074, 58.99190419600008],
              [27.724384807000064, 59.0144351200001],
              [27.767172892000076, 59.055931295000065],
              [27.784329467000134, 59.07717030900004],
              [27.842413778000036, 59.16119618800006],
              [27.873522990000083, 59.23648875000002],
              [27.890782919000088, 59.25803782200008],
              [27.88230798400008, 59.27565948500008],
              [27.903908733000037, 59.29038726800006],
              [27.959719279000097, 59.30645863900004],
              [28.076611369000148, 59.30527008100002],
              [28.09686853100007, 59.319429423000074],
              [28.07320072400003, 59.31896433500005],
              [28.000647014000037, 59.333743796000064],
              [28.03237634300004, 59.341960348],
              [28.1135600180001, 59.34542266900003],
              [28.15753666200007, 59.36402618500007],
              [28.181824585000044, 59.35606801400003],
              [28.186475464000125, 59.37492991100005],
              [28.175365031000098, 59.38185455400013],
              [28.149578491000085, 59.39317169200011],
              [28.137796264000087, 59.40035471600005],
              [28.12839115400004, 59.409449769000034],
              [28.104826701000036, 59.4392153940001],
              [28.083432657000117, 59.450894267000095],
              [28.038577514000025, 59.46298655200006],
              [28.019053582000083, 59.481756903000075],
              [28.055349155000044, 59.52789948100008],
              [28.072601759000065, 59.57802969000005],
              [28.051768425000034, 59.62482330900008],
              [28.015879754000082, 59.65965403900003],
              [28.000173373000052, 59.68138255400004],
              [27.993418816000087, 59.70331452000005],
              [27.995371941000087, 59.71552155200004],
              [28.004893425000034, 59.74310944200005],
              [28.007009311000047, 59.758246161000045],
              [28.058604363000086, 59.78961823100008],
              [28.086924675000034, 59.79938385600008],
              [28.123871290000068, 59.792303778000075],
              [28.15984134200005, 59.77610911700003],
              [28.18523196700005, 59.75861237200007],
              [28.19971764400009, 59.73590729400007],
              [28.209239129000082, 59.71108633000006],
              [28.223887566000087, 59.691107489000046],
              [28.335785352000073, 59.66815827000005],
              [28.375254754000082, 59.66632721600007],
              [28.404958530000044, 59.682847398000035],
              [28.41773522200009, 59.70840078300006],
              [28.421153191000087, 59.735256252000056],
              [28.418630405000044, 59.78961823100008],
              [28.42750084700009, 59.81342194200005],
              [28.449066602000073, 59.83502838700008],
              [28.476084832000083, 59.85175202000005],
              [28.50049889400009, 59.861029364000046],
              [28.51734459700009, 59.86225006700005],
              [28.535817905000044, 59.85956452000005],
              [28.552907748000052, 59.853583075000074],
              [28.581879102000073, 59.834051825000074],
              [28.619965040000068, 59.82904694200005],
              [28.647959832000083, 59.820013739000046],
              [28.668630405000044, 59.81708405200004],
              [28.678558790000068, 59.81317780200004],
              [28.683929884000065, 59.80874258000006],
              [28.693614129000082, 59.79706452000005],
              [28.699066602000073, 59.792669989000046],
              [28.718028191000087, 59.786810614000046],
              [28.73406009200005, 59.78896719000005],
              [28.766774936000047, 59.79954661700003],
              [28.78492272200009, 59.799261786000045],
              [28.814300977000073, 59.789129950000074],
              [28.83253014400009, 59.78652578300006],
              [28.845957879000082, 59.790228583000044],
              [28.883799675000034, 59.81659577000005],
              [28.895355665000068, 59.81854889500005],
              [28.919118686000047, 59.81395091400003],
              [28.931895379000082, 59.81659577000005],
              [28.95875084700009, 59.82632070500006],
              [28.966319207000083, 59.827460028000075],
              [28.97632897200009, 59.831284898000035],
              [29.010996941000087, 59.85761139500005],
              [29.034434441000087, 59.886704820000034],
              [29.030772332000083, 59.90110911700003],
              [28.98023522200009, 59.92987702000005],
              [29.006683790000068, 59.928615627000056],
              [29.014414910000085, 59.92987702000005],
              [29.041270379000082, 59.94350820500006],
              [29.089366082000083, 59.97992584800005],
              [29.12045332100007, 59.99445221600007],
              [29.161387566000087, 60.00263092700004],
              [29.266286655000044, 59.998114325000074],
              [29.49968509200005, 59.968410549000055],
              [29.804209832000083, 59.94009023600006],
              [29.862803582000083, 59.917954820000034],
              [30.11500084700009, 59.87055084800005],
              [30.161957227000073, 59.868475653000075],
              [30.192556186000047, 59.88060130400004],
              [30.216319207000083, 59.90721263200004],
              [30.22429446700005, 59.933254299000055],
              [30.20679772200009, 59.94354889500005],
              [30.21843509200005, 59.95815664300005],
              [30.235850457000083, 59.96621328300006],
              [30.246104363000086, 59.97492096600007],
              [30.234629754000082, 59.99135976800005],
              [30.209971550000034, 60.00112539300005],
              [30.000824415000068, 60.01194896000004],
              [29.948252800000034, 60.02968984600005],
              [29.932383660000085, 60.066473700000074],
              [29.92351321700005, 60.066839911000045],
              [29.910411004000082, 60.07501862200007],
              [29.89779707100007, 60.087591864000046],
              [29.890879754000082, 60.101223049000055],
              [29.892832879000082, 60.113348700000074],
              [29.899099155000044, 60.12295156500005],
              [29.899668816000087, 60.13361237200007],
              [29.884613477000073, 60.149603583000044],
              [29.84896894600007, 60.16693756700005],
              [29.701019727000073, 60.200506903000075],
              [29.525401238000086, 60.200873114000046],
              [29.45834394600007, 60.17788320500006],
              [29.417897983000046, 60.168850002000056],
              [29.417816602000073, 60.168850002000056],
              [29.25635826900009, 60.176947333000044],
              [29.09229576900009, 60.17796458500004],
              [29.052012566000087, 60.18427155200004],
              [29.015147332000083, 60.19684479400007],
              [28.986501498000052, 60.217230536000045],
              [28.94695071700005, 60.263739325000074],
              [28.92237389400009, 60.27985260600008],
              [28.887461785000085, 60.28620026200008],
              [28.860199415000068, 60.295355536000045],
              [28.84343509200005, 60.31696198100008],
              [28.830821160000085, 60.34198639500005],
              [28.815684441000087, 60.36127350500004],
              [28.799489780000044, 60.368841864000046],
              [28.795583530000044, 60.36078522300005],
              [28.794769727000073, 60.348089911000045],
              [28.787852410000085, 60.34137604400007],
              [28.746348504000082, 60.34210846600007],
              [28.723643425000034, 60.344916083000044],
              [28.709727410000085, 60.35130442900004],
              [28.693614129000082, 60.36212799700007],
              [28.630869988000086, 60.37555573100008],
              [28.61695397200009, 60.38198476800005],
              [28.606700066000087, 60.38947174700007],
              [28.517588738000086, 60.48883698100008],
              [28.45362389400009, 60.53961823100008],
              [28.438975457000083, 60.559881903000075],
              [28.452972852000073, 60.56464264500005],
              [28.473399285000085, 60.56622955900008],
              [28.49390709700009, 60.56464264500005],
              [28.507334832000083, 60.559881903000075],
              [28.51335696700005, 60.55158112200007],
              [28.518239780000044, 60.53196849200003],
              [28.524424675000034, 60.522365627000056],
              [28.543793165000068, 60.51040273600006],
              [28.61695397200009, 60.48883698100008],
              [28.659027540000068, 60.464056708000044],
              [28.683604363000086, 60.45587799700007],
              [28.70281009200005, 60.46116771000004],
              [28.707204623000052, 60.47846100500004],
              [28.699066602000073, 60.49982330900008],
              [28.686289910000085, 60.51805247600004],
              [28.661387566000087, 60.53461334800005],
              [28.66065514400009, 60.55508047100005],
              [28.662933790000068, 60.57786692900004],
              [28.658050977000073, 60.59406159100007],
              [28.66382897200009, 60.614447333000044],
              [28.685394727000073, 60.61513906500005],
              [28.676768425000034, 60.62913646000004],
              [28.649180535000085, 60.65574778900003],
              [28.644541863000086, 60.66974518400008],
              [28.654633009000065, 60.68187083500004],
              [28.674815300000034, 60.679348049000055],
              [28.696543816000087, 60.67202383000006],
              [28.712738477000073, 60.66974518400008],
              [28.734548373000052, 60.69281647300005],
              [28.721934441000087, 60.72117747600004],
              [28.690440300000034, 60.73847077000005],
              [28.654633009000065, 60.72809479400007],
              [28.63803144600007, 60.71662018400008],
              [28.60328209700009, 60.70018138200004],
              [28.586110873000052, 60.687160549000055],
              [28.57390384200005, 60.68268463700008],
              [28.521006707000083, 60.684027411000045],
              [28.50831139400009, 60.68178945500006],
              [28.487803582000083, 60.67202383000006],
              [28.47624759200005, 60.66974518400008],
              [28.424082879000082, 60.67169830900008],
              [28.400563998000052, 60.665269273000035],
              [28.390635613000086, 60.646185614000046],
              [28.382985873000052, 60.624253648000035],
              [28.364431186000047, 60.62335846600007],
              [28.341807488000086, 60.62763092700004],
              [28.32162519600007, 60.62132396000004],
              [28.330902540000068, 60.61591217700004],
              [28.33757571700005, 60.609808661000045],
              [28.341807488000086, 60.60260651200008],
              [28.34343509200005, 60.59406159100007],
              [28.332367384000065, 60.59833405200004],
              [28.31967207100007, 60.60146719000005],
              [28.306895379000082, 60.602728583000044],
              [28.295095248000052, 60.60146719000005],
              [28.28646894600007, 60.59833405200004],
              [28.283050977000073, 60.59511953300006],
              [28.280528191000087, 60.59162018400008],
              [28.26026451900009, 60.580064195000034],
              [28.235606316000087, 60.55996328300006],
              [28.215830925000034, 60.54755280200004],
              [28.210459832000083, 60.546861070000034],
              [28.188324415000068, 60.54779694200005],
              [28.168793165000068, 60.552069403000075],
              [28.158457879000082, 60.55304596600007],
              [28.152191602000073, 60.54995351800005],
              [28.150401238000086, 60.54315827000005],
              [28.147227410000085, 60.536322333000044],
              [28.137380405000044, 60.533189195000034],
              [28.12663821700005, 60.53412506700005],
              [28.106618686000047, 60.538397528000075],
              [28.096446160000085, 60.53937409100007],
              [28.079925977000073, 60.53742096600007],
              [28.051442905000044, 60.52830638200004],
              [28.034434441000087, 60.52578359600005],
              [27.900401238000086, 60.52846914300005],
              [27.870941602000073, 60.54047272300005],
              [27.86304772200009, 60.56732819200005],
              [27.845713738000086, 60.557806708000044],
              [27.83179772200009, 60.54059479400007],
              [27.816416863000086, 60.528225002000056],
              [27.794118686000047, 60.533189195000034],
              [27.799164259000065, 60.53803131700005],
              [27.807871941000087, 60.55304596600007],
              [27.892953328000146, 60.60426055900005],
              [27.981009969000098, 60.64947743800006],
              [28.003781679000042, 60.66422553500006],
              [28.14813155100009, 60.757713725000045],
              [28.243939657000027, 60.791587626000066],
              [28.33592370600013, 60.85938710500007],
              [28.48092777500011, 60.933465271],
              [28.52640303600009, 60.95023427400007],
              [28.614563029000124, 60.96193898500006],
              [28.653733764000066, 60.99175628700006],
              [28.65383711700011, 60.99188547800007],
              [28.670683634000085, 61.012478536000074],
              [28.688977092000044, 61.02738718700003],
              [28.75016198700007, 61.061364442000055],
              [28.781322876000047, 61.08697011300002],
              [28.797600952000067, 61.096840312],
              [28.855478557000083, 61.11267913900009],
              [28.92637862100014, 61.14794830400008],
              [28.980845581000068, 61.16810211200006],
              [29.1300871170001, 61.21342234300006],
              [29.20315759300007, 61.24590098100002],
              [29.262275431000035, 61.29052358000003],
              [29.277058696000097, 61.30459883400003],
              [29.28925052900007, 61.316206767],
              [29.31839603700007, 61.33842763300005],
              [29.46340010600005, 61.413823548000025],
              [29.480866740000124, 61.434778341000126],
              [29.49905684400005, 61.45924713200007],
              [29.517040242000064, 61.475060120000066],
              [29.539726197000107, 61.48495615700004],
              [29.604270061000136, 61.49919301400003],
              [29.635120891000042, 61.51110443200007],
              [29.77914310700004, 61.593114930000056],
              [29.798056681000105, 61.609651388000046],
              [29.82187951700007, 61.64458465600002],
              [29.842240030000085, 61.66016510000007],
              [29.977683960000093, 61.728171286000034],
              [30.14564900500011, 61.85046941100002],
              [30.33957401500004, 61.99166941400004],
              [30.33972904500007, 61.99166941400004],
              [30.33993575100004, 61.99177276700006],
              [30.480702351000048, 62.067685445000095],
              [30.607206258000133, 62.15127207500008],
              [30.635008178000078, 62.184009094],
              [30.647720581000044, 62.19276825000007],
              [30.665497274000074, 62.199822083000086],
              [30.70384118700008, 62.21038991300007],
              [30.793809855000063, 62.25299713200003],
              [30.907549682000138, 62.292891337000086],
              [30.92563643300008, 62.30211558100008],
              [30.941862834000062, 62.31459543900006],
              [30.967080933000148, 62.34818512],
              [30.98062015800008, 62.358804627],
              [31.123350463000065, 62.43482065900004],
              [31.14164392100014, 62.45652476100004],
              [31.15296105900012, 62.46735097300008],
              [31.16861901900006, 62.476006775000045],
              [31.221587361000104, 62.49158721900007],
              [31.22194909600006, 62.49171641],
              [31.222155802000145, 62.49171641],
              [31.243756551000104, 62.503343608000066],
              [31.26008630400014, 62.52484100400001],
              [31.284064169000146, 62.57297760000007],
              [31.302771037000127, 62.59602529000004],
              [31.347006063000038, 62.62933075000008],
              [31.363335815000084, 62.65157745400005],
              [31.41056807500013, 62.74653289800004],
              [31.44126387500006, 62.788700867],
              [31.48064131700005, 62.82608876600004],
              [31.56952478000011, 62.90592885400004],
              [31.535831747000145, 62.91951975600004],
              [31.51929528800008, 62.94318756100007],
              [31.505446004000078, 62.96819895500006],
              [31.48064131700005, 62.986337383],
              [31.468032267000126, 62.991556702000096],
              [31.44446781400012, 63.00194366500004],
              [31.380337362000034, 63.04793569000002],
              [31.351553589000105, 63.062198385],
              [31.288508341000068, 63.084729309000025],
              [31.262773478000042, 63.100593974000034],
              [31.250836223000135, 63.11547678600009],
              [31.240759318000073, 63.135733948000066],
              [31.23424808700014, 63.157231344000124],
              [31.233059530000105, 63.17573150700004],
              [31.225669800000105, 63.19604034500007],
              [31.203965698000104, 63.212680155],
              [31.177817424000068, 63.2252375290001],
              [30.974935750000043, 63.28916127600006],
              [30.82093998200014, 63.37566762400006],
              [30.488660522000146, 63.46212229500007],
              [30.461065307000126, 63.472870993000086],
              [30.44142826300009, 63.49157786100007],
              [30.380450073000134, 63.532453919000076],
              [30.24247399900014, 63.58180491200007],
              [30.001145060000056, 63.715336813000064],
              [29.980784546000052, 63.74153676400009],
              [29.998432859000104, 63.74710038100007],
              [30.051271199000098, 63.76375762900001],
              [30.201546265000047, 63.79264475600006],
              [30.265573365000137, 63.83067860900009],
              [30.32856693500014, 63.895997620000045],
              [30.50933109500005, 63.991392314000066],
              [30.50933109500005, 63.991495667],
              [30.552325887000052, 64.0217263790001],
              [30.580489543000112, 64.05107859400009],
              [30.586432332000072, 64.08466827500011],
              [30.562144409000098, 64.12740468400004],
              [30.544781128000068, 64.14636993500007],
              [30.532792196000116, 64.16254465800007],
              [30.532482137000045, 64.17918446900008],
              [30.550258830000075, 64.19887318900005],
              [30.558475382000097, 64.21969879200002],
              [30.536202841000147, 64.23468495700008],
              [30.503439982000145, 64.24378000900005],
              [30.445975790000034, 64.25075632700005],
              [30.421584513000084, 64.26465728800012],
              [30.399260295000147, 64.28310577400002],
              [30.370476522000047, 64.30083079000003],
              [30.321125529000085, 64.31767730700004],
              [30.164442586000064, 64.3419135540001],
              [30.093129110000064, 64.36124054000005],
              [30.05297652200005, 64.37808705700003],
              [30.032460978000074, 64.39694895500007],
              [30.04103926600004, 64.42294220000012],
              [30.06279504400004, 64.44841868100004],
              [30.07039147900008, 64.47187978100003],
              [30.035768269000073, 64.49146514900004],
              [29.990499715000055, 64.5041775510001],
              [29.993393595000043, 64.51074045800009],
              [29.99153324400004, 64.51322092700006],
              [29.980784546000052, 64.51554636700008],
              [29.978975871000046, 64.51833689400006],
              [29.978200724000146, 64.5211274220001],
              [29.978924194000058, 64.5240213020001],
              [29.980784546000052, 64.52676015300004],
              [29.97360152100009, 64.53621694000002],
              [29.970035848000123, 64.545415345],
              [29.968485555000086, 64.56283030300004],
              [29.965178263000098, 64.56443227100006],
              [29.95887373900007, 64.56598256500008],
              [29.954842977000112, 64.568979798],
              [29.958770386000083, 64.5748709110001],
              [29.96579838000008, 64.57864329100003],
              [30.136433960000147, 64.6153852340001],
              [30.16041182500004, 64.6260822550001],
              [30.1808240150001, 64.64277374300006],
              [30.187800334000087, 64.66235911100007],
              [30.17054040500011, 64.68168609600004],
              [30.13136967000014, 64.70121978800005],
              [30.12051761900011, 64.70891957600013],
              [30.10914880300004, 64.72008168600006],
              [30.106823364000093, 64.72561106400006],
              [30.1090454510001, 64.73165720700011],
              [30.111112508000076, 64.74442128500006],
              [30.114936564000118, 64.75434316000006],
              [30.12041426600007, 64.76157786100005],
              [30.118863973000146, 64.76793406200007],
              [30.10191410300007, 64.77547882100002],
              [30.06253666200007, 64.78416046200006],
              [29.877845093000076, 64.78483225600006],
              [29.780279989000064, 64.79558095400007],
              [29.698321167000074, 64.83914418600001],
              [29.633622274000118, 64.90715037100007],
              [29.588147013000082, 64.9914346320001],
              [29.59837894700013, 65.03437774700005],
              [29.6273177490001, 65.06223134400004],
              [29.667832072000124, 65.0779409800001],
              [29.820484253000075, 65.09365061500007],
              [29.845598999000117, 65.10801666300007],
              [29.85019820100007, 65.12150421100004],
              [29.838054240000076, 65.12481150300003],
              [29.820329223000044, 65.1265168260001],
              [29.808185262000052, 65.13530181900008],
              [29.809115438000106, 65.14522369500007],
              [29.81800378400004, 65.15220001300007],
              [29.82968265800008, 65.15860789000003],
              [29.839294475000088, 65.16690195800005],
              [29.83319665500005, 65.20501332700012],
              [29.76684411600013, 65.21736399300006],
              [29.62669763200006, 65.2152194210001],
              [29.580085490000045, 65.23539906900008],
              [29.615122111000062, 65.26940216100012],
              [29.720128622000118, 65.32908844000004],
              [29.730567260000043, 65.36536529600009],
              [29.71816491700008, 65.45417124500001],
              [29.726329793000104, 65.49124908500009],
              [29.726329793000104, 65.49150746700006],
              [29.7315327930001, 65.49692139900002],
              [29.745450073000086, 65.51140289300007],
              [29.82575524900011, 65.55196889200009],
              [29.838571004000073, 65.564888001],
              [29.806738322000058, 65.58486094200002],
              [29.73232426000004, 65.60870961500011],
              [29.70286869300014, 65.62938018900003],
              [29.76426029400011, 65.64808705700001],
              [30.00300541100006, 65.67813690200008],
              [30.064707071000043, 65.66167795900002],
              [30.098503459000142, 65.65638112400005],
              [30.113903035000135, 65.66550201500003],
              [30.11628015100007, 65.68720611600004],
              [30.111732625000116, 65.71201080400006],
              [30.083517293000057, 65.80461497000003],
              [30.07514571100006, 65.82280507500006],
              [30.039282267000146, 65.86538645500003],
              [30.00972334800008, 65.91569346200002],
              [29.99794112100011, 65.9315322880001],
              [29.95846032700007, 65.97388112400002],
              [29.94884851000006, 65.99127024400006],
              [29.920529826000063, 66.06862986300006],
              [29.900169311000127, 66.10805898100007],
              [29.8753646240001, 66.13358713800001],
              [29.79237227400006, 66.18087107400005],
              [29.650882202000105, 66.28789296500004],
              [29.593211303000146, 66.34592559900001],
              [29.56969852700007, 66.37817169300008],
              [29.55166345200007, 66.41279490199999],
              [29.546194294000145, 66.43196931900012],
              [29.53419681800011, 66.47403147500002],
              [29.524481648000062, 66.49121388800008],
              [29.409449910000035, 66.56847015400008],
              [29.401336711000113, 66.5762216190001],
              [29.396427449000043, 66.58663442000001],
              [29.39539392000006, 66.59645294299999],
              [29.392396688000076, 66.605289612],
              [29.363974650000046, 66.62459076000003],
              [29.362497842000096, 66.6265528310001],
              [29.322220093000112, 66.68006541000001],
              [29.089159383000094, 66.837549337],
              [29.051538940000057, 66.90780344700006],
              [29.09990808100011, 66.99113169400003],
              [29.100114787000052, 66.99126088500005],
              [29.42939701400013, 67.23277069199999],
              [29.480866740000124, 67.256774394],
              [29.490685262000056, 67.26297556600007],
              [29.496989787000075, 67.27026194300005],
              [29.508461955000087, 67.28809031200011],
              [29.519830770000112, 67.29816721600004],
              [29.91624068200008, 67.508128561],
              [29.93344893400007, 67.52637034100006],
              [29.95990726800005, 67.57158721900002],
              [29.964661499000044, 67.58471303300009],
              [29.97344649300004, 67.64930857400005],
              [29.977683960000093, 67.66222768100006],
              [29.987864217000094, 67.67245961600004],
              [30.00941329000011, 67.68584381199999],
              [29.7138240970001, 67.79250396800005],
              [29.651192261000062, 67.82356150300008],
              [29.480866740000124, 67.96045237200009],
              [29.442626180000047, 67.99114817400003],
              [29.360150594000118, 68.05672556600005],
              [29.330850057000134, 68.07269358300009],
              [29.298655639000117, 68.08178863600007],
              [29.01293664500008, 68.127238058],
              [28.727217651000046, 68.17268748000005],
              [28.69032067900011, 68.18317779600001],
              [28.6637589930001, 68.20400339800007],
              [28.48092777500011, 68.46259226500003],
              [28.46098067300011, 68.49106597900006],
              [28.44744144700013, 68.51488881500005],
              [28.447906535000044, 68.52971995000006],
              [28.459947144000125, 68.54243235300002],
              [28.716365600000103, 68.72795074500003],
              [28.74726810700008, 68.76014516200006],
              [28.801476684000107, 68.83548940000004],
              [28.728251180000115, 68.86504832000007],
              [28.645672241000085, 68.87166290300006],
              [28.444237508000043, 68.8658234660001],
              [28.426770874000113, 68.870577698],
              [28.41312829600011, 68.88008616200007],
              [28.410234415000104, 68.89853464800008],
              [28.456226441000098, 68.90013661800002],
              [28.713265015000047, 68.96803945000006],
              [28.833464396000096, 68.98447255500012],
              [28.95407718900009, 69.02726064100004],
              [28.973662557000097, 69.03423695900004],
              [29.008130737000073, 69.03692413400007],
              [29.06476810700005, 69.03470204700007],
              [29.12026859500014, 69.04684600900008],
              [29.172978556000146, 69.0693769330001],
              [29.22103763800004, 69.09841908900007],
              [29.240467977000094, 69.11505889900009],
              [29.25100996900005, 69.13076853400007],
              [29.268786661000092, 69.16668365600005],
              [29.27643477400005, 69.17593373700005],
              [29.294418172000064, 69.19169504800003],
              [29.302272990000063, 69.200841777],
              [29.305373576000136, 69.20973012300003],
              [29.305476929000065, 69.2181017060001],
              [29.307440633000112, 69.22631825800003],
              [29.315863892000095, 69.23494822200009],
              [29.326560913000094, 69.26264679000009],
              [29.334519084000135, 69.27737457300002],
              [29.376790405000122, 69.30161082000008],
              [29.434564657000124, 69.31184275400007],
              [29.604270061000136, 69.315201722],
              [29.661837605000073, 69.32502024400004],
              [29.72839685100007, 69.35153025300006],
              [29.751392863000035, 69.35716298500007],
              [29.900686075000067, 69.35824819000008],
              [29.948073364000038, 69.36558624300007],
              [29.967141968000135, 69.37349273700003],
              [30.00176517700004, 69.39457672200005],
              [30.1234114990001, 69.441912334],
              [30.137364136000087, 69.45297109000002],
              [30.14077478100012, 69.46439158200012],
              [30.141084839000087, 69.476793925],
              [30.145012248000057, 69.49105662100006],
              [30.154830770000046, 69.50609446200006],
              [30.164029175000053, 69.51183054600001],
              [30.19229618300011, 69.51916859900011],
              [30.210641317000068, 69.52821197500005],
              [30.22469730600011, 69.54082102500008],
              [30.23162194800011, 69.55833933600006],
              [30.228676392000068, 69.58205881800008],
              [30.2201497800001, 69.60024892200003],
              [30.208780965000074, 69.60867218100002],
              [30.14862959800007, 69.61849070300009],
              [30.126718791000087, 69.62644887300006],
              [30.119070679000117, 69.63456207300005],
              [30.141239868000127, 69.6398847460001],
              [30.186146688000065, 69.6413316860001],
              [30.230691772000057, 69.637300924],
              [30.294357137000134, 69.62024770100005],
              [30.480702351000048, 69.54412831700007],
              [30.5116565350001, 69.53632517600006],
              [30.755310913000073, 69.52149403900005],
              [30.852979370000128, 69.52743682900005],
              [30.898247925000135, 69.54423167000003],
              [30.92703169700013, 69.5783897920001],
              [30.93080407700006, 69.59487457300007],
              [30.927703491000045, 69.67213083900008],
              [30.90124515800005, 69.68897735600005],
              [30.884295288000146, 69.70236155200008],
              [30.881298055000116, 69.7105264290001],
              [30.8823315840001, 69.720086569],
              [30.877060587000074, 69.73760487900005],
              [30.867862183000057, 69.74897369500003],
              [30.843987671000093, 69.76623362300005],
              [30.840953890666185, 69.80584190246314],
              [31.032237175000034, 69.77708567900004],
              [31.13331139400009, 69.77570221600007],
              [31.16570071700005, 69.77024974200003],
              [31.199554884000065, 69.75763580900008],
              [31.214121941000087, 69.75600820500006],
              [31.226084832000083, 69.75714752800008],
              [31.249196811000047, 69.76227448100008],
              [31.261566602000073, 69.76341380400004],
              [31.283457879000082, 69.76032135600008],
              [31.307871941000087, 69.75238678600005],
              [31.35132897200009, 69.73240794500003],
              [31.373057488000086, 69.72650788000004],
              [31.395274285000085, 69.72370026200008],
              [31.409027540000068, 69.71580638200004],
              [31.40601647200009, 69.69452545800004],
              [31.401377800000034, 69.68768952000005],
              [31.39389082100007, 69.68105703300006],
              [31.385101759000065, 69.67597077000005],
              [31.375173373000052, 69.67405833500004],
              [31.367930535000085, 69.67137278900003],
              [31.365489129000082, 69.66498444200005],
              [31.364431186000047, 69.65717194200005],
              [31.361582879000082, 69.65045807500007],
              [31.347178582000083, 69.63837311400005],
              [31.296722852000073, 69.61261627800008],
              [31.325694207000083, 69.61493561400005],
              [31.353851759000065, 69.62689850500004],
              [31.452159050000034, 69.68891022300005],
              [31.477793816000087, 69.69765859600005],
              [31.520681186000047, 69.68866608300004],
              [31.531260613000086, 69.69253164300005],
              [31.542491082000083, 69.69830963700008],
              [31.556813998000052, 69.70197174700007],
              [31.810557488000086, 69.68773021000004],
              [31.797618035000085, 69.70449453300006],
              [31.772634311000047, 69.71360911700003],
              [31.72120201900009, 69.72557200700004],
              [31.70085696700005, 69.73655833500004],
              [31.699066602000073, 69.74428945500006],
              [31.728037957000083, 69.77024974200003],
              [31.71656334700009, 69.78945547100005],
              [31.708832227000073, 69.80857982000003],
              [31.710948113000086, 69.82737864800004],
              [31.728037957000083, 69.84540436400005],
              [31.75367272200009, 69.85407135600008],
              [31.84815514400009, 69.85285065300008],
              [31.867930535000085, 69.84853750200006],
              [31.90674889400009, 69.82925039300005],
              [31.964040561000047, 69.81659577000005],
              [32.02906334700009, 69.78196849200003],
              [32.056976759000065, 69.77708567900004],
              [32.061208530000044, 69.77948639500005],
              [32.06755618600005, 69.78424713700008],
              [32.07634524800005, 69.78876373900005],
              [32.09888756600009, 69.79189687700006],
              [32.10141035200007, 69.79507070500006],
              [32.099619988000086, 69.80044179900005],
              [32.097992384000065, 69.80780670800004],
              [32.091807488000086, 69.81561920800004],
              [32.05046634200005, 69.84198639500005],
              [31.996104363000086, 69.86359284100007],
              [31.981293165000068, 69.87327708500004],
              [31.98015384200005, 69.87881094000005],
              [31.982595248000052, 69.89520905200004],
              [31.981293165000068, 69.90062083500004],
              [31.974945509000065, 69.90412018400008],
              [31.918304884000065, 69.92645905200004],
              [31.913340691000087, 69.93618398600006],
              [31.92318769600007, 69.95180898600006],
              [31.942149285000085, 69.96503327000005],
              [31.962412957000083, 69.96991608300004],
              [31.984548373000052, 69.97028229400007],
              [32.05445397200009, 69.96377187700006],
              [32.24170983200008, 69.88324616100005],
              [32.26726321700005, 69.87628815300008],
              [32.358083530000044, 69.87954336100006],
              [32.39820397200009, 69.87433502800008],
              [32.488291863000086, 69.85089752800008],
              [32.52320397200009, 69.83234284100007],
              [32.50359134200005, 69.82086823100008],
              [32.50668379000007, 69.81098053600005],
              [32.52320397200009, 69.80316803600005],
              [32.62468509200005, 69.78278229400007],
              [32.727305535000085, 69.79189687700006],
              [32.91960696700005, 69.78001536700003],
              [33.00603274800005, 69.75861237200007],
              [33.04908287900008, 69.74005768400008],
              [33.06430097700007, 69.73956940300008],
              [33.08130944100009, 69.74591705900008],
              [33.10141035200007, 69.74872467700004],
              [33.12029056100005, 69.74420807500007],
              [33.13331139400009, 69.72866445500006],
              [33.12859134200005, 69.72557200700004],
              [33.11687259200005, 69.69163646000004],
              [33.115977410000085, 69.68463776200008],
              [33.11280358200008, 69.67755768400008],
              [33.11475670700008, 69.67080312700006],
              [33.11801191500007, 69.66498444200005],
              [33.11898847700007, 69.66107819200005],
              [33.113617384000065, 69.65399811400005],
              [33.10670006600009, 69.64891185100004],
              [33.07504316500007, 69.63165924700007],
              [33.035817905000044, 69.61774323100008],
              [32.871755405000044, 69.58250560100004],
              [32.501963738000086, 69.63312409100007],
              [32.43726647200009, 69.65009186400005],
              [32.418630405000044, 69.64874909100007],
              [32.37061608200008, 69.64008209800005],
              [32.22055097700007, 69.65420156500005],
              [32.18832441500007, 69.65306224200003],
              [32.16968834700009, 69.65485260600008],
              [32.15943444100009, 69.66107819200005],
              [32.15967858200008, 69.66771067900004],
              [32.16456139400009, 69.67230866100005],
              [32.170583530000044, 69.67645905200004],
              [32.17367597700007, 69.68154531500005],
              [32.176768425000034, 69.69525788000004],
              [32.18018639400009, 69.70498281500005],
              [32.180430535000085, 69.71474844000005],
              [32.17367597700007, 69.72866445500006],
              [32.162445509000065, 69.74144114800004],
              [32.147471550000034, 69.75141022300005],
              [32.13013756600009, 69.75600820500006],
              [32.111664259000065, 69.75287506700005],
              [32.107432488000086, 69.74603913000004],
              [32.11052493600005, 69.73493073100008],
              [32.11605879000007, 69.72166575700004],
              [32.119151238000086, 69.70848216400003],
              [32.101573113000086, 69.67397695500006],
              [32.05982506600009, 69.65949127800008],
              [31.968272332000083, 69.65420156500005],
              [31.995371941000087, 69.64516836100006],
              [32.02881920700008, 69.64215729400007],
              [32.05591881600009, 69.63654205900008],
              [32.06381269600007, 69.61945221600007],
              [32.05193118600005, 69.60431549700007],
              [32.03207441500007, 69.59243398600006],
              [32.01612389400009, 69.58022695500006],
              [32.01612389400009, 69.56419505400004],
              [32.07471764400009, 69.59076569200005],
              [32.13331139400009, 69.59821198100008],
              [32.19304446700005, 69.59210846600007],
              [32.25562584700009, 69.57786692900004],
              [32.28825931100005, 69.57428620000007],
              [32.38599694100009, 69.58535390800006],
              [32.399099155000044, 69.58421458500004],
              [32.41521243600005, 69.58063385600008],
              [32.428477410000085, 69.57416413000004],
              [32.43384850400008, 69.56419505400004],
              [32.427744988000086, 69.55996328300006],
              [32.40056399800005, 69.54498932500007],
              [32.39210045700008, 69.53685130400004],
              [32.420909050000034, 69.53620026200008],
              [32.501963738000086, 69.51703522300005],
              [32.48585045700008, 69.50348541900007],
              [32.46461022200009, 69.50202057500007],
              [32.44166100400008, 69.50446198100008],
              [32.42017662900008, 69.50275299700007],
              [32.406911655000044, 69.49477773600006],
              [32.38168379000007, 69.47308991100005],
              [32.365244988000086, 69.46865469000005],
              [32.32276451900009, 69.46234772300005],
              [32.23845462300005, 69.43695709800005],
              [32.19361412900008, 69.43451569200005],
              [32.23804772200009, 69.42230866100005],
              [32.289398634000065, 69.43073151200008],
              [32.38599694100009, 69.46181875200006],
              [32.399099155000044, 69.46295807500007],
              [32.41000410200007, 69.46271393400008],
              [32.42009524800005, 69.46458567900004],
              [32.430430535000085, 69.47235748900005],
              [32.447927280000044, 69.48895905200004],
              [32.45460045700008, 69.49286530200004],
              [32.46924889400009, 69.49559153900003],
              [32.49634850400008, 69.48993561400005],
              [32.52173912900008, 69.48891836100006],
              [32.52759850400008, 69.48932526200008],
              [32.530039910000085, 69.49286530200004],
              [32.53060957100007, 69.49640534100007],
              [32.53467858200008, 69.50714752800008],
              [32.53687584700009, 69.50958893400008],
              [32.55591881600009, 69.50633372600004],
              [32.58920332100007, 69.48602936400005],
              [32.60377037900008, 69.48419830900008],
              [32.64389082100007, 69.49799225500004],
              [32.66456139400009, 69.50210195500006],
              [32.68702233200008, 69.50275299700007],
              [32.790049675000034, 69.48969147300005],
              [32.84782962300005, 69.49286530200004],
              [32.877696160000085, 69.49111562700006],
              [32.89926191500007, 69.48224518400008],
              [32.826914910000085, 69.45921458500004],
              [32.79249108200008, 69.44253164300005],
              [32.769541863000086, 69.41400788000004],
              [32.89307701900009, 69.46181875200006],
              [32.98764082100007, 69.47459544500003],
              [33.084971550000034, 69.47606028900003],
              [32.86182701900009, 69.36522044500003],
              [32.83773847700007, 69.33144765800006],
              [32.81967207100007, 69.31915924700007],
              [32.803721550000034, 69.30414459800005],
              [32.81332441500007, 69.30145905200004],
              [32.82349694100009, 69.30121491100005],
              [32.83415774800005, 69.30337148600006],
              [32.85482832100007, 69.31110260600008],
              [32.863617384000065, 69.31183502800008],
              [32.87273196700005, 69.31098053600005],
              [32.883148634000065, 69.31199778900003],
              [32.88917076900009, 69.31191640800006],
              [32.89535566500007, 69.31492747600004],
              [32.90674889400009, 69.32526276200008],
              [32.923838738000086, 69.34882233300004],
              [32.953135613000086, 69.37750885600008],
              [32.969493035000085, 69.38735586100006],
              [32.989268425000034, 69.39354075700004],
              [33.293955925000034, 69.44342682500007],
              [33.31763756600009, 69.45123932500007],
              [33.32894941500007, 69.45197174700007],
              [33.34896894600007, 69.43817780200004],
              [33.362071160000085, 69.43451569200005],
              [33.37826582100007, 69.43622467700004],
              [33.420664910000085, 69.44814687700006],
              [33.447927280000044, 69.44721100500004],
              [33.49781334700009, 69.43211497600004],
              [33.52369225400008, 69.42829010600008],
              [33.50538170700008, 69.40355052300004],
              [33.47437584700009, 69.39386627800008],
              [33.44060306100005, 69.38764069200005],
              [33.41382897200009, 69.37299225500004],
              [33.43409264400009, 69.37299225500004],
              [33.49634850400008, 69.37986888200004],
              [33.46607506600009, 69.35785553600005],
              [33.40447024800005, 69.32762278900003],
              [33.375987175000034, 69.30756256700005],
              [33.34457441500007, 69.29694245000007],
              [33.26124108200008, 69.29100169500003],
              [33.235118035000085, 69.27000560100004],
              [33.25505618600005, 69.27016836100006],
              [33.27865644600007, 69.27342357000003],
              [33.29769941500007, 69.27846914300005],
              [33.30396569100009, 69.28367747600004],
              [33.39795983200008, 69.29124583500004],
              [33.44776451900009, 69.28839752800008],
              [33.47592207100007, 69.27000560100004],
              [33.38648522200009, 69.24949778900003],
              [33.33904056100005, 69.24664948100008],
              [33.31576582100007, 69.24152252800008],
              [33.29656009200005, 69.22907135600008],
              [33.371836785000085, 69.23476797100005],
              [33.40601647200009, 69.22968170800004],
              [33.40642337300005, 69.20856354400007],
              [33.43995201900009, 69.21149323100008],
              [33.47592207100007, 69.22182851800005],
              [33.51156660200007, 69.22549062700006],
              [33.54420006600009, 69.20856354400007],
              [33.51189212300005, 69.18423086100006],
              [33.393321160000085, 69.15053945500006],
              [33.31763756600009, 69.11920807500007],
              [33.28956139400009, 69.11253489800004],
              [33.232432488000086, 69.10814036700003],
              [33.15967858200008, 69.09467194200005],
              [33.10873457100007, 69.09198639500005],
              [33.060557488000086, 69.08331940300008],
              [33.023448113000086, 69.05776601800005],
              [33.016368035000085, 69.03872304900005],
              [33.01124108200008, 69.00751373900005],
              [33.012380405000044, 68.97565338700008],
              [33.023448113000086, 68.95473867400005],
              [33.039805535000085, 68.97748444200005],
              [33.04818769600007, 69.03432851800005],
              [33.06430097700007, 69.05776601800005],
              [33.11264082100007, 69.07538483300004],
              [33.225596550000034, 69.07611725500004],
              [33.31959069100009, 69.09634023600006],
              [33.37680097700007, 69.09764232000003],
              [33.42660566500007, 69.10468170800004],
              [33.448008660000085, 69.12970612200007],
              [33.455414259000065, 69.14105866100005],
              [33.47291100400008, 69.15143463700008],
              [33.562836134000065, 69.18207428600005],
              [33.56470787900008, 69.18805573100008],
              [33.576182488000086, 69.19920482000003],
              [33.57536868600005, 69.21295807500007],
              [33.56470787900008, 69.24266185100004],
              [33.566742384000065, 69.24583567900004],
              [33.57642662900008, 69.25332265800006],
              [33.57837975400008, 69.25633372600004],
              [33.57593834700009, 69.26129791900007],
              [33.57146243600005, 69.26837799700007],
              [33.567067905000044, 69.27277252800008],
              [33.56470787900008, 69.27000560100004],
              [33.562836134000065, 69.28558991100005],
              [33.56421959700009, 69.29303620000007],
              [33.57154381600009, 69.30414459800005],
              [33.592539910000085, 69.31956614800004],
              [33.62045332100007, 69.32770416900007],
              [33.72396894600007, 69.33681875200006],
              [33.735362175000034, 69.33144765800006],
              [33.740244988000086, 69.32273997600004],
              [33.739024285000085, 69.31561920800004],
              [33.732758009000065, 69.30951569200005],
              [33.72234134200005, 69.30414459800005],
              [33.740244988000086, 69.30678945500006],
              [33.77906334700009, 69.31728750200006],
              [33.79542076900009, 69.31647370000007],
              [33.81381269600007, 69.31134674700007],
              [33.83578535200007, 69.30776601800005],
              [33.85694420700008, 69.30719635600008],
              [33.87322024800005, 69.31098053600005],
              [33.865896030000044, 69.31736888200004],
              [33.860362175000034, 69.32444896000004],
              [33.85206139400009, 69.33893463700008],
              [34.13632246200007, 69.32495758650006],
              [34.420583530000044, 69.31098053600005],
              [34.41374759200005, 69.29266998900005],
              [34.44703209700009, 69.28367747600004],
              [34.54232832100007, 69.26911041900007],
              [34.584971550000034, 69.27220286700003],
              [34.606211785000085, 69.27000560100004],
              [34.648448113000086, 69.25210195500006],
              [34.66179446700005, 69.24949778900003],
              [34.98226972700007, 69.22907135600008],
              [34.975596550000034, 69.22247955900008],
              [34.96078535200007, 69.20425039300005],
              [34.95557701900009, 69.19489166900007],
              [34.972666863000086, 69.19334544500003],
              [34.99195397200009, 69.20221588700008],
              [35.01189212300005, 69.21426015800006],
              [35.03077233200008, 69.22215403900003],
              [35.08716881600009, 69.22597890800006],
              [35.11801191500007, 69.22308991100005],
              [35.140635613000086, 69.21539948100008],
              [35.146494988000086, 69.20831940300008],
              [35.14535566500007, 69.20209381700005],
              [35.14283287900008, 69.19651927300004],
              [35.14405358200008, 69.19147370000007],
              [35.15650475400008, 69.18292877800008],
              [35.16920006600009, 69.18105703300006],
              [35.181976759000065, 69.18353913000004],
              [35.19581139400009, 69.18805573100008],
              [35.21265709700009, 69.19574616100005],
              [35.227549675000034, 69.20465729400007],
              [35.24350019600007, 69.21206289300005],
              [35.26417076900009, 69.21539948100008],
              [35.24691816500007, 69.23639557500007],
              [35.17595462300005, 69.25771719000005],
              [35.147471550000034, 69.27000560100004],
              [35.182627800000034, 69.27993398600006],
              [35.27295983200008, 69.27147044500003],
              [35.33033287900008, 69.27606842700004],
              [35.80941816500007, 69.19643789300005],
              [35.87354576900009, 69.19489166900007],
              [35.92351321700005, 69.18235911700003],
              [35.96697024800005, 69.17682526200008],
              [35.99529056100005, 69.16681549700007],
              [36.02116946700005, 69.15265534100007],
              [36.04151451900009, 69.13621653900003],
              [36.054698113000086, 69.12807851800005],
              [36.06755618600005, 69.12775299700007],
              [36.096446160000085, 69.13279857000003],
              [36.24952233200008, 69.11098867400005],
              [36.27361087300005, 69.09845612200007],
              [36.264659050000034, 69.07819245000007],
              [36.31234785200007, 69.05776601800005],
              [36.517914259000065, 69.02977122600004],
              [36.68921959700009, 68.98200104400007],
              [36.70281009200005, 68.98053620000007],
              [36.71607506600009, 68.98114655200004],
              [36.72877037900008, 68.97968170800004],
              [36.74073326900009, 68.97174713700008],
              [36.74935957100007, 68.96161530200004],
              [36.75473066500007, 68.95815664300005],
              [36.764333530000044, 68.95473867400005],
              [36.78956139400009, 68.94977448100008],
              [36.84205162900008, 68.94525788000004],
              [37.012380405000044, 68.89447663000004],
              [37.02881920700008, 68.88239166900007],
              [37.043711785000085, 68.87445709800005],
              [37.09555097700007, 68.86078522300005],
              [37.19125410200007, 68.85053131700005],
              [37.209971550000034, 68.84544505400004],
              [37.22413170700008, 68.83372630400004],
              [37.23259524800005, 68.82001373900005],
              [37.24268639400009, 68.80857982000003],
              [37.26148522200009, 68.80390045800004],
              [37.30909264400009, 68.79979075700004],
              [37.35523522200009, 68.79022858300004],
              [37.37240644600007, 68.78270091400003],
              [37.41065514400009, 68.76068756700005],
              [37.435557488000086, 68.75397370000007],
              [37.453868035000085, 68.74457428600005],
              [37.463877800000034, 68.74241771000004],
              [37.50131269600007, 68.74054596600007],
              [37.52475019600007, 68.73574453300006],
              [37.56999759200005, 68.73558177300004],
              [37.578461134000065, 68.73346588700008],
              [37.58716881600009, 68.72406647300005],
              [37.68051191500007, 68.71344635600008],
              [37.69971764400009, 68.70453522300005],
              [37.73023522200009, 68.68573639500005],
              [37.81177819100009, 68.66071198100008],
              [37.946299675000034, 68.60081614800004],
              [37.99040774800005, 68.57013580900008],
              [38.02369225400008, 68.55414459800005],
              [38.03988691500007, 68.54376862200007],
              [38.04737389400009, 68.53558991100005],
              [38.05982506600009, 68.51650625200006],
              [38.06657962300005, 68.50967031500005],
              [38.09115644600007, 68.50096263200004],
              [38.149424675000034, 68.49982330900008],
              [38.176442905000044, 68.49542877800008],
              [38.200205925000034, 68.48403554900005],
              [38.20679772200009, 68.48236725500004],
              [38.21045983200008, 68.47898997600004],
              [38.209727410000085, 68.47182851800005],
              [38.21013431100005, 68.46454498900005],
              [38.21705162900008, 68.46124909100007],
              [38.31690514400009, 68.44757721600007],
              [38.32984459700009, 68.44220612200007],
              [38.347666863000086, 68.41885000200006],
              [38.391286655000044, 68.39948151200008],
              [38.388682488000086, 68.34316640800006],
              [38.42351321700005, 68.33771393400008],
              [38.42904707100007, 68.34194570500006],
              [38.43132571700005, 68.34906647300005],
              [38.434580925000034, 68.35586172100005],
              [38.44361412900008, 68.35883209800005],
              [38.45167076900009, 68.35663483300004],
              [38.46314537900008, 68.34682851800005],
              [38.47095787900008, 68.34454987200007],
              [38.494883660000085, 68.34210846600007],
              [38.715830925000034, 68.29157135600008],
              [38.76539147200003, 68.29059479400007],
              [38.704112175000034, 68.31183502800008],
              [38.60572350400008, 68.33197663000004],
              [38.53248131600009, 68.35529205900008],
              [38.510101759000065, 68.36546458500004],
              [38.51221764400009, 68.37588125200006],
              [38.53663170700008, 68.37791575700004],
              [38.588633660000085, 68.35993073100008],
              [38.615244988000086, 68.36505768400008],
              [38.59791100400008, 68.38198476800005],
              [38.61158287900008, 68.38727448100008],
              [38.63917076900009, 68.38495514500005],
              [38.66293379000007, 68.37929922100005],
              [38.75912519600007, 68.33771393400008],
              [38.793630405000044, 68.32868073100008],
              [38.90259850400008, 68.31785716400003],
              [38.92562910200007, 68.31110260600008],
              [38.94613691500007, 68.29962799700007],
              [38.951833530000044, 68.28705475500004],
              [38.93051191500007, 68.27692291900007],
              [38.953868035000085, 68.26630280200004],
              [39.03492272200003, 68.25120677300004],
              [39.25318444100009, 68.17023346600007],
              [39.35873457100007, 68.14964427300004],
              [39.52076256600009, 68.07599518400008],
              [39.608409050000034, 68.06342194200005],
              [39.687510613000086, 68.06134674700007],
              [39.73910566500007, 68.04800039300005],
              [39.80062910200007, 68.05272044500003],
              [39.82837975400008, 68.04661692900004],
              [39.83871504000007, 68.04315827000005],
              [39.85043379000007, 68.04254791900007],
              [39.85954837300005, 68.04661692900004],
              [39.86215254000007, 68.05719635600008],
              [39.859385613000086, 68.05756256700005],
              [39.84164472700007, 68.07086823100008],
              [39.79476972700007, 68.11835358300004],
              [39.78296959700003, 68.12742747600004],
              [39.721364780000044, 68.15875885600008],
              [39.70980879000007, 68.16876862200007],
              [39.72193444100009, 68.17328522300005],
              [39.76970462300005, 68.16986725500004],
              [39.79322350400008, 68.16474030200004],
              [39.870127800000034, 68.12929922100005],
              [39.912852410000085, 68.12287018400008],
              [39.92115319100009, 68.11399974200003],
              [39.92367597700007, 68.10101959800005],
              [39.92986087300005, 68.08510976800005],
              [39.94459069100009, 68.06732819200005],
              [39.990244988000086, 68.02875397300005],
              [40.00440514400009, 68.01984284100007],
              [40.01978600400008, 68.01618073100008],
              [40.03874759200005, 68.01463450700004],
              [40.05811608200008, 68.01007721600007],
              [40.07634524800005, 68.00242747600004],
              [40.11898847700007, 67.97166575700004],
              [40.14861087300005, 67.95795319200005],
              [40.293630405000044, 67.91376373900005],
              [40.29835045700008, 67.90932851800005],
              [40.299571160000085, 67.90444570500006],
              [40.30355879000007, 67.90192291900007],
              [40.327159050000034, 67.90692780200004],
              [40.33969160200007, 67.90753815300008],
              [40.35206139400009, 67.90631745000007],
              [40.36247806100005, 67.90289948100008],
              [40.41065514400009, 67.87506745000007],
              [40.41773522200003, 67.86542389500005],
              [40.40357506600009, 67.85293203300006],
              [40.37387129000007, 67.84906647300005],
              [40.32154381600009, 67.85114166900007],
              [40.32154381600009, 67.84491608300004],
              [40.385101759000065, 67.79938385600008],
              [40.466807488000086, 67.76117584800005],
              [40.50367272200003, 67.75023021000004],
              [40.53834069100009, 67.75470612200007],
              [40.56788170700008, 67.78286367400005],
              [40.56812584700003, 67.78912995000007],
              [40.56413821700005, 67.79458242400005],
              [40.560883009000065, 67.80011627800008],
              [40.564463738000086, 67.80703359600005],
              [40.57406660200007, 67.81102122600004],
              [40.58725019600007, 67.81171295800004],
              [40.612315300000034, 67.81012604400007],
              [40.654633009000065, 67.81460195500006],
              [40.67074629000007, 67.81028880400004],
              [40.67709394600007, 67.79303620000007],
              [40.68409264400009, 67.78119538000004],
              [40.70036868600005, 67.77252838700008],
              [40.732432488000086, 67.76235586100006],
              [40.80062910200007, 67.72821686400005],
              [40.84197024800005, 67.72455475500004],
              [40.92318769600007, 67.73452383000006],
              [40.965830925000034, 67.72508372600004],
              [41.016612175000034, 67.69790273600006],
              [41.03988691500007, 67.67780182500007],
              [41.05396569100009, 67.65314362200007],
              [41.05225670700008, 67.61912669500003],
              [41.03288821700005, 67.59857819200005],
              [41.007823113000086, 67.58295319200005],
              [40.98943118600005, 67.56370677300004],
              [40.99000084700003, 67.55536530200004],
              [41.00757897200003, 67.54401276200008],
              [41.01351972700007, 67.53579336100006],
              [41.01335696700005, 67.52924225500004],
              [41.010752800000034, 67.52440013200004],
              [41.007823113000086, 67.52033112200007],
              [41.00611412900008, 67.51593659100007],
              [41.00513756600009, 67.49046458500004],
              [41.00342858200008, 67.47894928600005],
              [40.99927819100009, 67.46747467700004],
              [41.06006920700008, 67.46637604400007],
              [41.08725019600007, 67.45990631700005],
              [41.115977410000085, 67.44700755400004],
              [41.14535566500007, 67.42438385600008],
              [41.15007571700005, 67.42348867400005],
              [41.14820397200003, 67.41160716400003],
              [41.139333530000044, 67.39423248900005],
              [41.13648522200003, 67.38556549700007],
              [41.13656660200007, 67.33567942900004],
              [41.13298587300005, 67.30914948100008],
              [41.11963951900009, 67.28628164300005],
              [41.10889733200008, 67.25381094000005],
              [41.14047285200007, 67.23533763200004],
              [41.242849155000044, 67.21344635600008],
              [41.264414910000085, 67.22040436400005],
              [41.28541100400008, 67.23029205900008],
              [41.30779056100005, 67.23476797100005],
              [41.32113691500007, 67.23151276200008],
              [41.33969160200007, 67.22382233300004],
              [41.356130405000044, 67.21385325700004],
              [41.36304772200003, 67.20376211100006],
              [41.358164910000085, 67.19037506700005],
              [41.33838951900009, 67.17112864800004],
              [41.33570397200003, 67.15965403900003],
              [41.34546959700003, 67.14899323100008],
              [41.380869988000086, 67.13751862200007],
              [41.39039147200003, 67.12490469000005],
              [41.38453209700003, 67.11001211100006],
              [41.367930535000085, 67.10187409100007],
              [41.350596550000034, 67.09577057500007],
              [41.342539910000085, 67.08734772300005],
              [41.342539910000085, 67.04637278900003],
              [41.34742272200003, 67.03099192900004],
              [41.35629316500007, 67.02179596600007],
              [41.360036655000044, 67.01361725500004],
              [41.34937584700003, 67.00141022300005],
              [41.32984459700003, 66.99823639500005],
              [41.30355879000007, 67.00189850500004],
              [41.27979576900009, 67.00210195500006],
              [41.26734459700003, 66.98834870000007],
              [41.27466881600009, 66.98151276200008],
              [41.29086347700007, 66.97264232000003],
              [41.304698113000086, 66.96206289300005],
              [41.304698113000086, 66.94989655200004],
              [41.270518425000034, 66.90265534100007],
              [41.178070509000065, 66.80955638200004],
              [41.145274285000085, 66.78888580900008],
              [41.04118899800005, 66.74506256700005],
              [40.917979363000086, 66.67243073100008],
              [40.86068769600007, 66.65228913000004],
              [40.83318118600005, 66.63222890800006],
              [40.814789259000065, 66.62213776200008],
              [40.795583530000044, 66.61420319200005],
              [40.76319420700008, 66.60712311400005],
              [40.74496504000007, 66.59735748900005],
              [40.729177280000044, 66.58413320500006],
              [40.718760613000086, 66.57001373900005],
              [40.71607506600009, 66.55646393400008],
              [40.71957441500007, 66.54913971600007],
              [40.71924889400009, 66.54193756700005],
              [40.705088738000086, 66.52846914300005],
              [40.66976972700007, 66.51239655200004],
              [40.63412519600007, 66.50665924700007],
              [40.60206139400009, 66.49652741100005],
              [40.57781009200005, 66.46723053600005],
              [40.56560306100005, 66.45575592700004],
              [40.506521030000044, 66.44025299700007],
              [40.444346550000034, 66.40550364800004],
              [40.40015709700003, 66.39402903900003],
              [40.308604363000086, 66.38198476800005],
              [40.15837649800005, 66.32933177300004],
              [40.084971550000034, 66.28876373900005],
              [39.84888756600009, 66.24518463700008],
              [39.81185957100007, 66.23065827000005],
              [39.771494988000086, 66.22492096600007],
              [39.70443769600007, 66.20693594000005],
              [39.465179884000065, 66.17959219000005],
              [39.38445071700005, 66.14533112200007],
              [39.34359785200007, 66.13471100500004],
              [39.06397545700008, 66.10390859600005],
              [38.97217858200008, 66.11131419500003],
              [38.95045006600009, 66.10761139500005],
              [38.934580925000034, 66.10211823100008],
              [38.55437259200005, 66.05499909100007],
              [38.24073326900006, 66.07188548400006],
              [37.92709394600007, 66.08877187700006],
              [37.82146243600005, 66.11220937700006],
              [37.65552819100009, 66.12311432500007],
              [37.54639733200008, 66.14484284100007],
              [37.438487175000034, 66.19285716400003],
              [37.360118035000085, 66.20457591400003],
              [37.27312259200005, 66.23045482000003],
              [36.887380405000044, 66.28522370000007],
              [36.83139082100007, 66.28335195500006],
              [36.74927819100009, 66.29564036700003],
              [36.63257897200009, 66.28778717700004],
              [36.523448113000086, 66.30019765800006],
              [36.406260613000086, 66.29474518400008],
              [36.27466881600009, 66.32086823100008],
              [36.022471550500086, 66.34100983250008],
              [35.770274285000085, 66.36115143400008],
              [35.67107181100005, 66.38739655200004],
              [35.55779056100005, 66.38703034100007],
              [35.38062584700009, 66.41787344000005],
              [35.31421959700009, 66.45693594000005],
              [35.225352410000085, 66.46906159100007],
              [35.18148847700007, 66.48126862200007],
              [34.887705925000034, 66.59975820500006],
              [34.80355879000007, 66.61351146000004],
              [34.72250410200007, 66.59454987200007],
              [34.64616946700005, 66.56427643400008],
              [34.56470787900008, 66.54271067900004],
              [34.53060957100007, 66.53807200700004],
              [34.48015384200005, 66.53758372600004],
              [34.434336785000085, 66.54726797100005],
              [34.397471550000034, 66.59223053600005],
              [34.36768639400009, 66.61151764500005],
              [34.35596764400009, 66.62978750200006],
              [34.393321160000085, 66.64573802300004],
              [34.420583530000044, 66.64642975500004],
              [34.47510826900009, 66.63670482000003],
              [34.50318444100009, 66.63825104400007],
              [34.52515709700009, 66.64817942900004],
              [34.52165774800005, 66.65717194200005],
              [34.50538170700008, 66.66181061400005],
              [34.48951256600009, 66.65875885600008],
              [34.49634850400008, 66.65192291900007],
              [34.47022545700008, 66.64606354400007],
              [34.28402754000007, 66.67243073100008],
              [34.21241295700008, 66.67243073100008],
              [34.201508009000065, 66.67475006700005],
              [34.183929884000065, 66.68471914300005],
              [34.174815300000034, 66.68671295800004],
              [34.16879316500007, 66.68447500200006],
              [34.14226321700005, 66.67084381700005],
              [34.129649285000085, 66.66852448100008],
              [34.11744225400008, 66.66889069200005],
              [34.09229576900009, 66.67243073100008],
              [34.13249759200005, 66.69818756700005],
              [34.15056399800005, 66.71527741100005],
              [34.161143425000034, 66.73509349200003],
              [34.16130618600005, 66.74306875200006],
              [34.15943444100009, 66.75372955900008],
              [34.15650475400008, 66.76349518400008],
              [34.15365644600007, 66.76862213700008],
              [34.141368035000085, 66.77383047100005],
              [34.13607832100007, 66.76976146000004],
              [34.13298587300005, 66.75999583500004],
              [34.12712649800005, 66.74811432500007],
              [34.109385613000086, 66.72825755400004],
              [34.09034264400009, 66.71312083500004],
              [34.069021030000044, 66.70184967700004],
              [34.04379316500007, 66.69354889500005],
              [34.03842207100007, 66.69367096600007],
              [34.029307488000086, 66.69896067900004],
              [34.02369225400008, 66.70038483300004],
              [34.017914259000065, 66.69839101800005],
              [34.01514733200008, 66.68935781500005],
              [34.009776238000086, 66.68671295800004],
              [33.947276238000086, 66.68488190300008],
              [33.928721550000034, 66.68846263200004],
              [33.91765384200005, 66.69415924700007],
              [33.89576256600009, 66.70966217700004],
              [33.88624108200008, 66.71401601800005],
              [33.869802280000044, 66.71503327000005],
              [33.86768639400009, 66.70892975500004],
              [33.86801191500007, 66.70038483300004],
              [33.85889733200008, 66.69354889500005],
              [33.832692905000044, 66.69554271000004],
              [33.81421959700009, 66.71161530200004],
              [33.78687584700009, 66.75120677300004],
              [33.76384524800005, 66.76654694200005],
              [33.708994988000086, 66.78563060100004],
              [33.68441816500007, 66.79970937700006],
              [33.66960696700005, 66.80548737200007],
              [33.64177493600005, 66.80101146000004],
              [33.629567905000044, 66.80613841400003],
              [33.62061608200008, 66.81386953300006],
              [33.59205162900008, 66.83071523600006],
              [33.58741295700008, 66.81952545800004],
              [33.59107506600009, 66.80971914300005],
              [33.60564212300005, 66.78974030200004],
              [33.56137129000007, 66.80467357000003],
              [33.54118899800005, 66.81557851800005],
              [33.52369225400008, 66.83071523600006],
              [33.519541863000086, 66.80219147300005],
              [33.55160566500007, 66.78034088700008],
              [33.62614993600005, 66.74811432500007],
              [33.59929446700005, 66.75511302300004],
              [33.548838738000086, 66.77553945500006],
              [33.52369225400008, 66.78229401200008],
              [33.533946160000085, 66.77118561400005],
              [33.54542076900009, 66.76129791900007],
              [33.55827884200005, 66.75336334800005],
              [33.57154381600009, 66.74811432500007],
              [33.57154381600009, 66.74192942900004],
              [33.55046634200005, 66.74355703300006],
              [33.509776238000086, 66.76337311400005],
              [33.488942905000044, 66.76862213700008],
              [33.502289259000065, 66.75580475500004],
              [33.54078209700009, 66.73940664300005],
              [33.55787194100009, 66.72768789300005],
              [33.51710045700008, 66.72418854400007],
              [33.48324629000007, 66.73041413000004],
              [33.100596550000034, 66.85814036700003],
              [32.84327233200008, 66.97626373900005],
              [32.821055535000085, 66.99144114800004],
              [32.80486087300005, 67.01032135600008],
              [32.79818769600007, 67.03046295800004],
              [32.80225670700008, 67.04905833500004],
              [32.817393425000034, 67.06342194200005],
              [32.853851759000065, 67.07453034100007],
              [32.93279056100005, 67.07977936400005],
              [32.968760613000086, 67.09076569200005],
              [32.92994225400008, 67.10000234600005],
              [32.80713951900009, 67.09076569200005],
              [32.772227410000085, 67.09300364800004],
              [32.73853600400008, 67.09931061400005],
              [32.635508660000085, 67.13287995000007],
              [32.45443769600007, 67.13495514500005],
              [32.43384850400008, 67.13922760600008],
              [32.39405358200008, 67.15704987200007],
              [32.38257897200009, 67.15965403900003],
              [32.32536868600005, 67.15932851800005],
              [32.29769941500007, 67.15582916900007],
              [32.26775149800005, 67.14736562700006],
              [32.24968509200005, 67.14472077000005],
              [32.190196160000085, 67.15281810100004],
              [32.07406660200007, 67.14158763200004],
              [32.04086347700007, 67.14378489800004],
              [31.944590691000087, 67.16575755400004],
              [31.910492384000065, 67.16828034100007],
              [31.877696160000085, 67.16478099200003],
              [31.85092207100007, 67.15281810100004],
              [31.926605665000068, 67.15281810100004],
              [31.922129754000082, 67.14618561400005],
              [31.912933790000068, 67.12490469000005],
              [32.092784050000034, 67.12034739800004],
              [32.20484459700009, 67.13446686400005],
              [32.23454837300005, 67.13296133000006],
              [32.26197350400008, 67.12498607000003],
              [32.30396569100009, 67.09760163000004],
              [32.34498131600009, 67.08417389500005],
              [32.358083530000044, 67.07025788000004],
              [32.34156334700009, 67.07599518400008],
              [32.324554884000065, 67.07802969000005],
              [32.289805535000085, 67.07770416900007],
              [32.31413821700005, 67.06024811400005],
              [32.348399285000085, 67.05662669500003],
              [32.38559004000007, 67.05768463700008],
              [32.418630405000044, 67.05438873900005],
              [32.50326582100007, 67.03046295800004],
              [32.530039910000085, 67.01504140800006],
              [32.549815300000034, 67.00006745000007],
              [32.556976759000065, 66.98899974200003],
              [32.551524285000085, 66.97650788000004],
              [32.53345787900008, 66.95697663000004],
              [32.50668379000007, 66.94891998900005],
              [32.424571160000085, 66.95551178600005],
              [32.39210045700008, 66.95355866100005],
              [32.41773522200009, 66.94635651200008],
              [32.47242272200009, 66.94513580900008],
              [32.49586022200009, 66.93309153900003],
              [32.48161868600005, 66.92788320500006],
              [32.475352410000085, 66.92694733300004],
              [32.47828209700009, 66.90997955900008],
              [32.46216881600009, 66.90013255400004],
              [32.42017662900008, 66.89215729400007],
              [32.42017662900008, 66.88593170800004],
              [32.52662194100009, 66.88593170800004],
              [32.54542076900009, 66.88300202000005],
              [32.59148196700005, 66.85797760600008],
              [32.65259850400008, 66.84162018400008],
              [32.67603600400008, 66.82835521000004],
              [32.66651451900009, 66.80955638200004],
              [32.705088738000086, 66.79637278900003],
              [32.890961134000065, 66.78156159100007],
              [32.90674889400009, 66.77606842700004],
              [32.91578209700009, 66.76878489800004],
              [32.926768425000034, 66.75165436400005],
              [32.93474368600005, 66.74192942900004],
              [32.91920006600009, 66.73676178600005],
              [32.81202233200008, 66.73574453300006],
              [32.769541863000086, 66.74192942900004],
              [32.974619988000086, 66.69110748900005],
              [33.18344160200007, 66.69245026200008],
              [33.308604363000086, 66.65517812700006],
              [33.32447350400008, 66.64573802300004],
              [33.31861412900008, 66.62933991100005],
              [33.28638756600009, 66.63117096600007],
              [33.22486412900008, 66.64573802300004],
              [33.156260613000086, 66.65322500200006],
              [33.12077884200005, 66.65021393400008],
              [33.10531660200007, 66.63178131700005],
              [33.09359785200007, 66.61123281500005],
              [33.06617272200009, 66.59772370000007],
              [33.03484134200005, 66.59162018400008],
              [33.01107832100007, 66.59292226800005],
              [32.97486412900008, 66.60081614800004],
              [32.938161655000044, 66.60301341400003],
              [32.865244988000086, 66.59796784100007],
              [32.901377800000034, 66.57477448100008],
              [33.10531660200007, 66.57684967700004],
              [33.091807488000086, 66.58429596600007],
              [33.10572350400008, 66.59442780200004],
              [33.122080925000034, 66.59829336100006],
              [33.19263756600009, 66.59707265800006],
              [33.20630944100009, 66.59886302300004],
              [33.221446160000085, 66.60480377800008],
              [33.21900475400008, 66.60635000200006],
              [33.217539910000085, 66.61102936400005],
              [33.219737175000034, 66.61611562700006],
              [33.22828209700009, 66.61839427300004],
              [33.25961347700007, 66.61839427300004],
              [33.422862175000034, 66.59223053600005],
              [33.45142662900008, 66.57343170800004],
              [33.462901238000086, 66.55988190300008],
              [33.46892337300005, 66.55565013200004],
              [33.48218834700009, 66.55011627800008],
              [33.52361087300005, 66.54108307500007],
              [33.53679446700005, 66.53587474200003],
              [33.49919681100005, 66.52285390800006],
              [33.19271894600007, 66.57880280200004],
              [33.153086785000085, 66.57001373900005],
              [33.163096550000034, 66.57025788000004],
              [33.172211134000065, 66.56801992400005],
              [33.180349155000044, 66.56329987200007],
              [33.18726647200009, 66.55634186400005],
              [33.16968834700009, 66.55638255400004],
              [33.16586347700007, 66.55593496300008],
              [33.11898847700007, 66.55011627800008],
              [33.073252800000034, 66.55687083500004],
              [33.028330925000034, 66.54559967700004],
              [32.968760613000086, 66.54043203300006],
              [32.94092858200008, 66.52846914300005],
              [32.98959394600007, 66.51203034100007],
              [33.046885613000086, 66.50604889500005],
              [33.104258660000085, 66.50971100500004],
              [33.17896569100009, 66.53046295800004],
              [33.203461134000065, 66.53375885600008],
              [33.22868899800005, 66.53286367400005],
              [33.287771030000044, 66.52240631700005],
              [33.29712975400008, 66.51878489800004],
              [33.302744988000086, 66.51410553600005],
              [33.30355879000007, 66.50910065300008],
              [33.30388431100005, 66.50372955900008],
              [33.30746504000007, 66.49799225500004],
              [33.32764733200008, 66.48700592700004],
              [33.35482832100007, 66.48021067900004],
              [33.50863691500007, 66.46381256700005],
              [33.53736412900008, 66.47068919500003],
              [33.578461134000065, 66.49579498900005],
              [33.602224155000044, 66.50165436400005],
              [33.623057488000086, 66.49115631700005],
              [33.63363691500007, 66.47406647300005],
              [33.62647545700008, 66.46893952000005],
              [33.608164910000085, 66.46718984600005],
              [33.58521569100009, 66.46015045800004],
              [33.621429884000065, 66.45132070500006],
              [33.70460045700008, 66.44383372600004],
              [33.735362175000034, 66.42601146000004],
              [33.68474368600005, 66.41347890800006],
              [33.56568444100009, 66.41986725500004],
              [33.516286655000044, 66.40550364800004],
              [33.55250084700009, 66.39337799700007],
              [33.643239780000044, 66.37824127800008],
              [33.674571160000085, 66.35712311400005],
              [33.62907962300005, 66.34430573100008],
              [33.47592207100007, 66.35028717700004],
              [33.38843834700009, 66.34438711100006],
              [33.342539910000085, 66.33510976800005],
              [33.31080162900008, 66.31679922100005],
              [33.481130405000044, 66.31517161700003],
              [33.59880618600005, 66.33038971600007],
              [33.617523634000065, 66.32770416900007],
              [33.63461347700007, 66.32147858300004],
              [33.639008009000065, 66.31443919500003],
              [33.619883660000085, 66.30931224200003],
              [33.871104363000086, 66.26666901200008],
              [33.88917076900009, 66.25824616100005],
              [33.888682488000086, 66.25136953300006],
              [33.88249759200005, 66.24481842700004],
              [33.882823113000086, 66.23761627800008],
              [33.89966881600009, 66.22890859600005],
              [33.91578209700009, 66.23273346600007],
              [33.93181399800005, 66.24164459800005],
              [33.948252800000034, 66.24848053600005],
              [33.97234134200005, 66.25104401200008],
              [34.08725019600007, 66.24892812700006],
              [34.10279381600009, 66.24689362200007],
              [34.11963951900009, 66.24103424700007],
              [34.153330925000034, 66.22382233300004],
              [34.16732832100007, 66.22117747600004],
              [34.16179446700005, 66.21308014500005],
              [34.154307488000086, 66.20498281500005],
              [34.14926191500007, 66.19700755400004],
              [34.15064537900008, 66.18952057500007],
              [34.16138756600009, 66.18549225500004],
              [34.231211785000085, 66.17743561400005],
              [34.262380405000044, 66.16811758000006],
              [34.277679884000065, 66.16596100500004],
              [34.32992597700007, 66.16461823100008],
              [34.496836785000085, 66.11615631700005],
              [34.53728274800005, 66.09023672100005],
              [34.53044681100005, 66.10390859600005],
              [34.55298912900008, 66.09369538000004],
              [34.57016035200007, 66.06806061400005],
              [34.610362175000034, 66.05768463700008],
              [34.635508660000085, 66.03461334800005],
              [34.65406334700009, 66.02944570500006],
              [34.666758660000085, 66.02362702000005],
              [34.71225019600007, 65.99656810100004],
              [34.72291100400008, 65.98777903900003],
              [34.71729576900009, 65.97508372600004],
              [34.69939212300005, 65.96629466400003],
              [34.660899285000085, 65.95302969000005],
              [34.67269941500007, 65.94428131700005],
              [34.68669681100005, 65.93919505400004],
              [34.71607506600009, 65.93256256700005],
              [34.70281009200005, 65.92841217700004],
              [34.69499759200005, 65.91893138200004],
              [34.69507897200009, 65.90949127800008],
              [34.70557701900009, 65.90521881700005],
              [34.72282962300005, 65.90753815300008],
              [34.758148634000065, 65.91730377800008],
              [34.77759850400008, 65.91958242400005],
              [34.78630618600005, 65.91730377800008],
              [34.80209394600007, 65.90753815300008],
              [34.81202233200008, 65.90521881700005],
              [34.838877800000034, 65.90680573100008],
              [34.846446160000085, 65.90521881700005],
              [34.85238691500007, 65.90033600500004],
              [34.857758009000065, 65.89280833500004],
              [34.866221550000034, 65.87791575700004],
              [34.85499108200008, 65.87197500200006],
              [34.82536868600005, 65.84320709800005],
              [34.838552280000044, 65.82811107000003],
              [34.85466556100005, 65.82514069200005],
              [34.893565300000034, 65.83014557500007],
              [34.89966881600009, 65.82371653900003],
              [34.89820397200009, 65.80971914300005],
              [34.89283287900008, 65.79559967700004],
              [34.886729363000086, 65.78912995000007],
              [34.86898847700007, 65.78473541900007],
              [34.87061608200008, 65.77448151200008],
              [34.88209069100009, 65.76300690300008],
              [34.893565300000034, 65.75507233300004],
              [34.929698113000086, 65.73948802300004],
              [34.96859785200007, 65.72772858300004],
              [34.949554884000065, 65.71845123900005],
              [34.938487175000034, 65.70791250200006],
              [34.92530358200008, 65.70184967700004],
              [34.900401238000086, 65.70600006700005],
              [34.77076256600009, 65.77488841400003],
              [34.70484459700009, 65.79730866100005],
              [34.68873131600009, 65.80971914300005],
              [34.682302280000044, 65.77879466400003],
              [34.68189537900008, 65.76870351800005],
              [34.68409264400009, 65.76675039300005],
              [34.69190514400009, 65.73110586100006],
              [34.68873131600009, 65.72772858300004],
              [34.70476321700005, 65.72089264500005],
              [34.746755405000044, 65.72036367400005],
              [34.75700931100005, 65.71344635600008],
              [34.750743035000085, 65.70111725500004],
              [34.73218834700009, 65.69318268400008],
              [34.69499759200005, 65.68618398600006],
              [34.703135613000086, 65.67755768400008],
              [34.72779381600009, 65.66901276200008],
              [34.73991946700005, 65.66193268400008],
              [34.74390709700009, 65.65631745000007],
              [34.752696160000085, 65.63886139500005],
              [34.772227410000085, 65.60956452000005],
              [34.77662194100009, 65.59658437700006],
              [34.76612389400009, 65.58893463700008],
              [34.73658287900008, 65.58315664300005],
              [34.74008222700007, 65.54364655200004],
              [34.70687910200007, 65.52069733300004],
              [34.662852410000085, 65.50507233300004],
              [34.633474155000044, 65.48749420800004],
              [34.649424675000034, 65.48554108300004],
              [34.668711785000085, 65.47939687700006],
              [34.68246504000007, 65.46881745000007],
              [34.68189537900008, 65.45335521000004],
              [34.66456139400009, 65.44513580900008],
              [34.635427280000044, 65.44415924700007],
              [34.54802493600005, 65.45783112200007],
              [34.51091556100005, 65.45551178600005],
              [34.492198113000086, 65.44114817900004],
              [34.51059004000007, 65.41181061400005],
              [34.490570509000065, 65.40810781500005],
              [34.46827233200008, 65.40949127800008],
              [34.44654381600009, 65.41469961100006],
              [34.427744988000086, 65.42234935100004],
              [34.41651451900009, 65.42255280200004],
              [34.40170332100007, 65.41771067900004],
              [34.38453209700009, 65.41429271000004],
              [34.365977410000085, 65.41864655200004],
              [34.371104363000086, 65.41290924700007],
              [34.377696160000085, 65.40737539300005],
              [34.393321160000085, 65.39813873900005],
              [34.36898847700007, 65.39179108300004],
              [34.31788170700008, 65.39744700700004],
              [34.29704837300005, 65.38507721600007],
              [34.441742384000065, 65.37083567900004],
              [34.462901238000086, 65.36440664300005],
              [34.47803795700008, 65.34906647300005],
              [34.47999108200008, 65.33095937700006],
              [34.461599155000044, 65.31622955900008],
              [34.471039259000065, 65.28896719000005],
              [34.47974694100009, 65.28107330900008],
              [34.49634850400008, 65.27521393400008],
              [34.52719160200007, 65.27855052300004],
              [34.535899285000085, 65.27570221600007],
              [34.524180535000085, 65.26097239800004],
              [34.55290774800005, 65.25454336100006],
              [34.615244988000086, 65.25458405200004],
              [34.64031009200005, 65.24115631700005],
              [34.606211785000085, 65.22687409100007],
              [34.633799675000034, 65.22748444200005],
              [34.647227410000085, 65.22426992400005],
              [34.67945397200009, 65.19920482000003],
              [34.68189537900008, 65.20014069200005],
              [34.681976759000065, 65.18252187700006],
              [34.667979363000086, 65.17812734600005],
              [34.647146030000044, 65.17772044500003],
              [34.62671959700009, 65.17218659100007],
              [34.63689212300005, 65.16412995000007],
              [34.674571160000085, 65.15176015800006],
              [34.663096550000034, 65.12677643400008],
              [34.68100019600007, 65.11444733300004],
              [34.76587975400008, 65.10781484600005],
              [34.77369225400008, 65.10024648600006],
              [34.766286655000044, 65.08649323100008],
              [34.746755405000044, 65.06574127800008],
              [34.75440514400009, 65.05487702000005],
              [34.78931725400008, 65.05101146000004],
              [34.81609134200005, 65.04340241100005],
              [34.79859459700009, 65.02142975500004],
              [34.77361087300005, 65.01190827000005],
              [34.744883660000085, 65.00604889500005],
              [34.71900475400008, 64.99762604400007],
              [34.70240319100009, 64.98041413000004],
              [34.74439537900008, 64.97719961100006],
              [34.778330925000034, 64.96678294500003],
              [34.80779056100005, 64.94863515800006],
              [34.83578535200007, 64.92177969000005],
              [34.84131920700008, 64.91860586100006],
              [34.848317905000044, 64.91766998900005],
              [34.86255944100009, 64.91836172100005],
              [34.87281334700009, 64.91754791900007],
              [34.87273196700005, 64.91494375200006],
              [34.869883660000085, 64.91063060100004],
              [34.874034050000034, 64.90119049700007],
              [34.87680097700007, 64.88934967700004],
              [34.88005618600005, 64.88422272300005],
              [34.89210045700008, 64.87490469000005],
              [34.908864780000044, 64.86566803600005],
              [34.926524285000085, 64.85907623900005],
              [34.942067905000044, 64.85757070500006],
              [34.93189537900008, 64.84243398600006],
              [34.91260826900009, 64.82623932500007],
              [34.87240644600007, 64.80231354400007],
              [34.84457441500007, 64.79368724200003],
              [34.78500410200007, 64.78412506700005],
              [34.75700931100005, 64.77435944200005],
              [34.79802493600005, 64.75633372600004],
              [34.81202233200008, 64.75385163000004],
              [34.81397545700008, 64.75877513200004],
              [34.882302474000085, 64.75653344800008],
              [34.93055620800004, 64.76576533900004],
              [34.94899583300008, 64.77057744200005],
              [34.975303663000034, 64.77050089300008],
              [35.00903061300005, 64.74318441700007],
              [34.97035464900006, 64.72760642400004],
              [34.928339330000085, 64.72247557000009],
              [34.881099094000035, 64.71808869600005],
              [34.85484638400004, 64.71440216500008],
              [34.835545867000064, 64.70472972200008],
              [34.83228600400008, 64.69794342700004],
              [34.912848143000076, 64.66242927800005],
              [34.93609622200006, 64.63663611700008],
              [34.97340925700007, 64.62498614200007],
              [34.97759177800009, 64.61191658300004],
              [34.92948206600005, 64.59149847500004],
              [34.886748717000046, 64.58150070900007],
              [34.846557920000066, 64.55991731400007],
              [34.810557488000086, 64.55898672100005],
              [34.805430535000085, 64.55585358300004],
              [34.75798587300005, 64.56024811400005],
              [34.74333743600005, 64.55585358300004],
              [34.77320397200009, 64.55630117400005],
              [34.78443444100009, 64.54840729400007],
              [34.801442905000044, 64.54637278900003],
              [34.832692905000044, 64.53156159100007],
              [34.84945722700007, 64.52798086100006],
              [34.91163170700008, 64.52814362200007],
              [34.927744988000086, 64.52456289300005],
              [34.97096594300007, 64.50444991100005],
              [35.00896401600005, 64.49390627700006],
              [34.997386, 64.47190879200008],
              [34.95557701900009, 64.45221588700008],
              [35.01398886100009, 64.42332144700003],
              [35.05709470600004, 64.41573162300006],
              [35.121104363000086, 64.40159739800004],
              [35.133799675000034, 64.39077383000006],
              [35.16146894600007, 64.38027578300006],
              [35.280039910000085, 64.37661367400005],
              [35.307302280000044, 64.37221914300005],
              [35.32154381600009, 64.36188385600008],
              [35.305674675000034, 64.34296295800004],
              [35.33057701900009, 64.32868073100008],
              [35.32853654500008, 64.31413214200006],
              [35.34875211700006, 64.29607325700005],
              [35.41050382700007, 64.28675532000005],
              [35.46616600300007, 64.30589433100005],
              [35.53645073800004, 64.32154307600007],
              [35.58906984200007, 64.32231260500004],
              [35.618157772000075, 64.34042868100005],
              [35.59929446700005, 64.37030670800004],
              [35.58912194100009, 64.38100820500006],
              [35.573008660000085, 64.39459870000007],
              [35.56568444100009, 64.40631745000007],
              [35.58253014400009, 64.41128164300005],
              [35.63864684100008, 64.38366394200006],
              [35.72543379000007, 64.35944245000007],
              [35.81080162900008, 64.34202708500004],
              [35.860118035000085, 64.32233307500007],
              [35.894867384000065, 64.29584381700005],
              [35.88786868600005, 64.26788971600007],
              [35.900726759000065, 64.25649648600006],
              [35.93384850400008, 64.24762604400007],
              [35.94939212300005, 64.23993561400005],
              [35.957774285000085, 64.22980377800008],
              [35.96729576900009, 64.20840078300006],
              [35.97673587300005, 64.19896067900004],
              [36.00603274800005, 64.19326406500005],
              [36.02648020200007, 64.20573821100004],
              [36.05978965700007, 64.21813277100006],
              [36.08857673000006, 64.20731386600005],
              [36.12156943000008, 64.19455885000008],
              [36.161880420000045, 64.17306389700008],
              [36.18677511900006, 64.15398646200003],
              [36.22721056100005, 64.13620551600008],
              [36.23525015800004, 64.12482335300007],
              [36.22429446700005, 64.11420319200005],
              [36.209971550000034, 64.10342031500005],
              [36.22213885600007, 64.07529878200006],
              [36.259070629000064, 64.06443265700005],
              [36.28443444100009, 64.04621002800008],
              [36.27125084700009, 64.03579336100006],
              [36.264659050000034, 64.02423737200007],
              [36.29216556100005, 64.00971100500004],
              [36.36500084700009, 64.00177643400008],
              [36.42009524800005, 63.99567291900007],
              [36.459971550000034, 63.98297760600008],
              [36.47982832100007, 63.97247955900008],
              [36.506602410000085, 63.97064850500004],
              [36.55827884200005, 63.97304922100005],
              [36.578461134000065, 63.96893952000005],
              [36.61931399800005, 63.95538971600007],
              [36.637705925000034, 63.95258209800005],
              [36.64869225400008, 63.94798411700003],
              [36.684255405000044, 63.92829010600008],
              [36.703461134000065, 63.92462799700007],
              [36.768321160000085, 63.94013092700004],
              [36.79224694100009, 63.93829987200007],
              [36.80844160200007, 63.93121979400007],
              [36.83773847700007, 63.91429271000004],
              [36.857432488000086, 63.91095612200007],
              [36.87818444100009, 63.91429271000004],
              [36.916758660000085, 63.92877838700008],
              [36.936289910000085, 63.932074286000045],
              [36.95484459700009, 63.92723216400003],
              [36.99187259200005, 63.90448639500005],
              [37.01140384200005, 63.897365627000056],
              [37.16944420700008, 63.89508698100008],
              [37.19418379000007, 63.89081452000005],
              [37.21338951900009, 63.88027578300006],
              [37.246104363000086, 63.847357489000046],
              [37.25440514400009, 63.84271881700005],
              [37.26148522200009, 63.84007396000004],
              [37.27271569100009, 63.82713450700004],
              [37.27898196700005, 63.82221100500004],
              [37.291026238000086, 63.81818268400008],
              [37.43781056700004, 63.792280503000086],
              [37.53436246200005, 63.800857928000084],
              [37.608423075000076, 63.815586401000076],
              [37.61898671700004, 63.84094544700008],
              [37.610521575000064, 63.857154628000046],
              [37.614345513000046, 63.88116880200005],
              [37.65739108200006, 63.89863689800006],
              [37.719401119000054, 63.905523197000036],
              [37.82855741600008, 63.90199125700008],
              [37.86703535200007, 63.91640859600005],
              [37.944102410000085, 63.940334377000056],
              [37.98462975400008, 63.945746161000045],
              [38.00180097700007, 63.955511786000045],
              [38.07374108200008, 64.01740143400008],
              [38.08806399800005, 64.03489817900004],
              [38.08578535200007, 64.05902741100005],
              [38.045664910000085, 64.14834219000005],
              [38.03012129000007, 64.16437409100007],
              [38.00505618600005, 64.17853424700007],
              [37.94613691500007, 64.20209381700005],
              [37.91423587300005, 64.22040436400005],
              [37.90202884200005, 64.23993561400005],
              [37.92302493600005, 64.25775788000004],
              [38.00538170700008, 64.27537669500003],
              [38.02621504000007, 64.29523346600007],
              [38.020192905000044, 64.30853913000004],
              [38.002940300000034, 64.31696198100008],
              [37.950205925000034, 64.32538483300004],
              [37.92465254000007, 64.33885325700004],
              [37.908864780000044, 64.34296295800004],
              [37.91724694100009, 64.35260651200008],
              [37.929698113000086, 64.35687897300005],
              [37.943695509000065, 64.35952383000006],
              [37.95671634200005, 64.36408112200007],
              [37.83252523200008, 64.35833357100006],
              [37.79684480700007, 64.37717998400007],
              [37.79908287900008, 64.41811758000006],
              [37.80648847700007, 64.42487213700008],
              [37.77594994700007, 64.43402992500006],
              [37.74902673100007, 64.44171393000005],
              [37.687060838000036, 64.43086712600007],
              [37.65534974600007, 64.41181395500007],
              [37.65162194100009, 64.38715241100005],
              [37.629893425000034, 64.37702057500007],
              [37.60108483200008, 64.37775299700007],
              [37.55681399800005, 64.38491445500006],
              [37.51490319100009, 64.38654205900008],
              [37.47315514400009, 64.38182200700004],
              [37.38493899800005, 64.36005280200004],
              [37.33943429000004, 64.34044200100004],
              [37.28622815400007, 64.35220606100006],
              [37.12150062400008, 64.39473999100005],
              [37.055438895000066, 64.44394721900005],
              [36.83463351600005, 64.59301707700007],
              [36.78409108500006, 64.63949259700007],
              [36.74411637800006, 64.68104600300006],
              [36.69526227800009, 64.70787590500004],
              [36.644103836000056, 64.71894324500005],
              [36.559760947000086, 64.71742272300008],
              [36.54034017300006, 64.75252841300005],
              [36.516461863000075, 64.76902649300007],
              [36.528086785000085, 64.79173411700003],
              [36.52003014400009, 64.80231354400007],
              [36.51384524800005, 64.82534414300005],
              [36.504242384000065, 64.83584219000005],
              [36.55537218400008, 64.82412616300007],
              [36.57252037900008, 64.82957591400003],
              [36.494858015000034, 64.85103248300004],
              [36.47294135000004, 64.86560697300007],
              [36.459971550000034, 64.88764069200005],
              [36.43995201900009, 64.91705963700008],
              [36.46603292000009, 64.93412790800005],
              [36.53719027900007, 64.92813325100008],
              [36.568603652000036, 64.90245182100006],
              [36.631017159000066, 64.90416255500008],
              [36.65494611100007, 64.92782613000008],
              [36.695243497000035, 64.93933211600006],
              [36.761596678000046, 64.95003332000005],
              [36.80744425600005, 64.95905229700008],
              [36.81414731700005, 64.97571551900006],
              [36.80274566300005, 64.99356925600006],
              [36.82471764400009, 65.02041250200006],
              [36.82984459700009, 65.03131745000007],
              [36.86264082100007, 65.06468333500004],
              [36.86736087300005, 65.07599518400008],
              [36.86378014400009, 65.11310455900008],
              [36.817926121000085, 65.13133727300004],
              [36.820001697000066, 65.14714128400004],
              [36.90012485400007, 65.15090241800004],
              [36.94971463300004, 65.15936797000006],
              [36.97868040600008, 65.16617766700006],
              [37.00767705800007, 65.17297682600008],
              [37.060953967000046, 65.16792080900007],
              [37.12861798800009, 65.15736285500003],
              [37.21738823600003, 65.14022134300006],
              [37.324478534000036, 65.11369675300006],
              [37.39854917400004, 65.10197670500008],
              [37.500150277000046, 65.06970119700009],
              [37.56509982100005, 65.04801204800003],
              [37.62120805500007, 65.04226738000006],
              [37.67266027900007, 65.03566296800005],
              [37.70597163200006, 65.01738203100007],
              [37.715393748000054, 64.99807572800006],
              [37.70431213300009, 64.97722131700004],
              [37.718316694000066, 64.95880198000003],
              [37.794594757000084, 64.92061488500008],
              [38.04643424600005, 64.85367156900008],
              [38.14429799000004, 64.84403244300006],
              [38.257044904000054, 64.84646340900008],
              [38.35790428100006, 64.85241107400003],
              [38.385021487000074, 64.84462671200004],
              [38.37322024800005, 64.82416413000004],
              [38.368174675000034, 64.80914948100008],
              [38.37427819100009, 64.79800039300005],
              [38.39625084700009, 64.78620026200008],
              [38.403005405000044, 64.77435944200005],
              [38.36508222700007, 64.78082916900007],
              [38.328786655000044, 64.79669830900008],
              [38.29411868600005, 64.80394114800004],
              [38.26148522200009, 64.78489817900004],
              [38.24463951900009, 64.78119538000004],
              [38.162771030000044, 64.78864166900007],
              [38.088226759000065, 64.78558991100005],
              [38.06657962300005, 64.78119538000004],
              [38.03630618600005, 64.76190827000005],
              [38.04542076900009, 64.74371979400007],
              [38.11703535200007, 64.70278554900005],
              [38.125743035000085, 64.69594961100006],
              [38.123708530000044, 64.68903229400007],
              [38.108083530000044, 64.67877838700008],
              [38.09343509200005, 64.67267487200007],
              [38.03988691500007, 64.65827057500007],
              [38.04810631600009, 64.64594147300005],
              [38.062510613000086, 64.64374420800004],
              [38.079112175000034, 64.64801666900007],
              [38.094086134000065, 64.65485260600008],
              [38.11019941500007, 64.65949127800008],
              [38.14975019600007, 64.66547272300005],
              [38.162771030000044, 64.67194245000007],
              [38.16944420700008, 64.68439362200007],
              [38.166758660000085, 64.70400625200006],
              [38.17335045700008, 64.71629466400003],
              [38.18637129000007, 64.72321198100008],
              [38.205088738000086, 64.72589752800008],
              [38.241221550000034, 64.72589752800008],
              [38.27466881600009, 64.73232656500005],
              [38.33904056100005, 64.75836823100008],
              [38.375661655000044, 64.76129791900007],
              [38.440440300000034, 64.74290599200003],
              [38.47250410200007, 64.74347565300008],
              [38.49170983200008, 64.76752350500004],
              [38.482758009000065, 64.76911041900007],
              [38.42554772200009, 64.79344310100004],
              [38.416026238000086, 64.80231354400007],
              [38.418711785000085, 64.81854889500005],
              [38.44803087100007, 64.81787810400004],
              [38.464007776000074, 64.81035796700007],
              [38.51169218300004, 64.78774888700008],
              [38.62382352700007, 64.76886677600004],
              [38.73777539800005, 64.74792216100008],
              [38.81680118100007, 64.74260900900003],
              [38.87279423100006, 64.74118900100007],
              [38.92220204500006, 64.73274181800008],
              [39.041711587000066, 64.69751739200007],
              [39.14215951300008, 64.66222228600003],
              [39.24865795000005, 64.64534738400005],
              [39.303070509000065, 64.64622630400004],
              [39.330821160000085, 64.63971588700008],
              [39.34174714300008, 64.62254143200005],
              [39.38422997100008, 64.60691286100007],
              [39.444243579000045, 64.58163024700008],
              [39.56652431700007, 64.54526799300004],
              [39.73609459700003, 64.55548737200007],
              [39.759776238000086, 64.56207916900007],
              [39.746836785000085, 64.57615794500003],
              [39.76677493600005, 64.58136627800008],
              [39.821299675000034, 64.58633047100005],
              [39.84229576900009, 64.59414297100005],
              [39.900401238000086, 64.60346100500004],
              [39.92359459700003, 64.60301341400003],
              [39.90284264400009, 64.62441640800006],
              [39.863291863000086, 64.61863841400003],
              [39.81967207100007, 64.60358307500007],
              [39.78638756600009, 64.59686920800004],
              [39.791758660000085, 64.61505768400008],
              [39.80990644600007, 64.65932851800005],
              [39.821299675000034, 64.67194245000007],
              [39.850352410000085, 64.67597077000005],
              [39.889333530000044, 64.66990794500003],
              [40.06275475400008, 64.62189362200007],
              [40.11060631600009, 64.60114166900007],
              [40.15316816500007, 64.57265859600005],
              [40.181651238000086, 64.55866120000007],
              [40.21420332100007, 64.55556875200006],
              [40.35906009200005, 64.56207916900007],
              [40.373789910000085, 64.55996328300006],
              [40.401133660000085, 64.55052317900004],
              [40.47999108200008, 64.53961823100008],
              [40.51710045700008, 64.54144928600005],
              [40.533213738000086, 64.55898672100005],
              [40.52849368600005, 64.57794830900008],
              [40.51710045700008, 64.59357330900008],
              [40.50367272200003, 64.60822174700007],
              [40.492198113000086, 64.61664459800005],
              [40.47242272200003, 64.63641998900005],
              [40.441416863000086, 64.69940827000005],
              [40.42758222700007, 64.71287669500003],
              [40.42017662900008, 64.71539948100008],
              [40.41488691500007, 64.72150299700007],
              [40.41187584700003, 64.72931549700007],
              [40.410899285000085, 64.73680247600004],
              [40.41179446700005, 64.74994538000004],
              [40.414805535000085, 64.75511302300004],
              [40.45142662900008, 64.76813385600008],
              [40.47624759200005, 64.76927317900004],
              [40.500661655000044, 64.76459381700005],
              [40.520192905000044, 64.75385163000004],
              [40.51734459700003, 64.77411530200004],
              [40.49195397200003, 64.78754303600005],
              [40.459727410000085, 64.79783763200004],
              [40.43685957100007, 64.80914948100008],
              [40.42269941500007, 64.82697174700007],
              [40.37810306100005, 64.92251211100006],
              [40.365896030000044, 64.93878815300008],
              [40.34880618600005, 64.95311107000003],
              [40.30974368600005, 64.97467682500007],
              [40.29737389400009, 64.98354726800005],
              [40.29078209700003, 64.99188873900005],
              [40.28174889400009, 65.01190827000005],
              [40.27312259200005, 65.02142975500004],
              [40.24138431100005, 65.03676992400005],
              [40.13591556100005, 65.06232330900008],
              [40.114024285000085, 65.07469310100004],
              [39.87224368600005, 65.27692291900007],
              [39.78093509200005, 65.32245514500005],
              [39.740896030000044, 65.35651276200008],
              [39.720713738000086, 65.38031647300005],
              [39.71208743600005, 65.40184153900003],
              [39.70948326900009, 65.44769928600005],
              [39.710948113000086, 65.46967194200005],
              [39.71827233200008, 65.49494049700007],
              [39.73031660200007, 65.52435944200005],
              [39.73853600400008, 65.53880442900004],
              [39.74927819100009, 65.55206940300008],
              [39.826914910000085, 65.60700104400007],
              [39.97974694100009, 65.65615469000005],
              [40.06657962300005, 65.66811758000006],
              [40.27979576900009, 65.72996653900003],
              [40.471690300000034, 65.81281159100007],
              [40.63624108200008, 65.93256256700005],
              [40.71013431100005, 65.97231679900005],
              [40.795909050000034, 65.99168528900003],
              [41.01807701900009, 66.00775788000004],
              [41.105804884000065, 66.03058502800008],
              [41.342539910000085, 66.06289297100005],
              [41.40056399800005, 66.08665599200003],
              [41.417979363000086, 66.09023672100005],
              [41.43482506600009, 66.09552643400008],
              [41.46436608200008, 66.11904531500005],
              [41.47934004000007, 66.12433502800008],
              [41.49634850400008, 66.12787506700005],
              [41.55486087300005, 66.15228913000004],
              [41.623383009000065, 66.16510651200008],
              [41.643565300000034, 66.17275625200006],
              [41.63803144600007, 66.18317291900007],
              [41.64275149800005, 66.18891022300005],
              [41.652679884000065, 66.19253164300005],
              [41.85759524800005, 66.29633209800005],
              [42.02084394600007, 66.41233958500004],
              [42.119883660000085, 66.50482819200005],
              [42.15593509200005, 66.52635325700004],
              [42.20093834700003, 66.53217194200005],
              [42.365244988000086, 66.51121653900003],
              [42.64478600400008, 66.45254140800006],
              [42.66146894600007, 66.44334544500003],
              [42.66000410200007, 66.42572663000004],
              [42.57504316500007, 66.40155670800004],
              [42.54859459700003, 66.38507721600007],
              [42.74919681100005, 66.39508698100008],
              [42.941416863000086, 66.41860586100006],
              [43.12680097700007, 66.42348867400005],
              [43.25220787900008, 66.43675364800004],
              [43.30209394600007, 66.42601146000004],
              [43.32504316500007, 66.40997955900008],
              [43.350596550000034, 66.36713288000004],
              [43.367198113000086, 66.34715403900003],
              [43.40609785200007, 66.33218008000006],
              [43.510508660000085, 66.33014557500007],
              [43.555349155000044, 66.32363515800006],
              [43.65479576900009, 66.28485748900005],
              [43.68287194100009, 66.26528554900005],
              [43.69263756600009, 66.23720937700006],
              [43.66537519600007, 66.21767812700006],
              [43.508148634000065, 66.18431224200003],
              [43.46705162900008, 66.17011139500005],
              [43.43580162900008, 66.14858633000006],
              [43.42115319100009, 66.13491445500006],
              [43.40593509200005, 66.12482330900008],
              [43.389414910000085, 66.11737702000005],
              [43.37086022200003, 66.11131419500003],
              [43.32504316500007, 66.10675690300008],
              [43.301768425000034, 66.10187409100007],
              [43.28834069100009, 66.09023672100005],
              [43.335948113000086, 66.06720612200007],
              [43.34302819100009, 66.05951569200005],
              [43.35279381600009, 66.04148997600004],
              [43.37549889400009, 66.03729889500005],
              [43.418711785000085, 66.04242584800005],
              [43.45085696700005, 66.03705475500004],
              [43.47632897200003, 66.02240631700005],
              [43.49724368600005, 66.00071849200003],
              [43.51490319100009, 65.97418854400007],
              [43.52588951900009, 66.01854075700004],
              [43.52173912900008, 66.03611888200004],
              [43.500987175000034, 66.05267975500004],
              [43.41138756600009, 66.06183502800008],
              [43.38233483200008, 66.07192617400005],
              [43.41138756600009, 66.09764232000003],
              [43.46412194100009, 66.12714264500005],
              [43.47982832100007, 66.13117096600007],
              [43.52035566500007, 66.13641998900005],
              [43.56072024800005, 66.14679596600007],
              [43.583994988000086, 66.15009186400005],
              [43.63599694100009, 66.15184153900003],
              [43.65552819100009, 66.16225820500006],
              [43.67156009200005, 66.17413971600007],
              [43.69255618600005, 66.18276601800005],
              [43.71461022200003, 66.18618398600006],
              [43.75928795700008, 66.17743561400005],
              [43.83643639400009, 66.18577708500004],
              [43.852224155000044, 66.18170807500007],
              [43.89177493600005, 66.15851471600007],
              [43.94678795700008, 66.14008209800005],
              [43.98755944100009, 66.10883209800005],
              [44.045664910000085, 66.08104075700004],
              [44.05209394600007, 66.07249583500004],
              [44.04932701900009, 66.05609772300005],
              [44.041351759000065, 66.04311758000006],
              [44.033213738000086, 66.03652578300006],
              [44.02784264400009, 66.02944570500006],
              [44.02816816500007, 66.01508209800005],
              [44.04053795700008, 65.99359772300005],
              [44.08757571700005, 65.95905182500007],
              [44.16716556100005, 65.88544342700004],
              [44.179698113000086, 65.86432526200008],
              [44.19076582100007, 65.90493398600006],
              [44.17367597700007, 65.93480052300004],
              [44.14584394600007, 65.96039459800005],
              [44.12452233200008, 65.98777903900003],
              [44.12322024800005, 66.01325104400007],
              [44.151052280000044, 66.05817291900007],
              [44.158539259000065, 66.08681875200006],
              [44.14820397200003, 66.10431549700007],
              [44.09913170700008, 66.14130280200004],
              [44.08350670700008, 66.15851471600007],
              [44.07935631600009, 66.20669179900005],
              [44.096364780000044, 66.26194896000004],
              [44.12387129000007, 66.31513092700004],
              [44.15170332100007, 66.35712311400005],
              [44.16586347700007, 66.37295156500005],
              [44.21021569100009, 66.40241120000007],
              [44.21810957100007, 66.41388580900008],
              [44.23609459700003, 66.44708893400008],
              [44.244883660000085, 66.45392487200007],
              [44.34815514400009, 66.49966054900005],
              [44.36019941500007, 66.50824616100005],
              [44.37086022200003, 66.52220286700003],
              [44.377696160000085, 66.54507070500006],
              [44.38559004000007, 66.60224030200004],
              [44.39478600400008, 66.62181224200003],
              [44.430430535000085, 66.64386627800008],
              [44.474945509000065, 66.65521881700005],
              [44.563243035000085, 66.66620514500005],
              [44.551117384000065, 66.67796458500004],
              [44.531586134000065, 66.67694733300004],
              [44.50904381600009, 66.67304108300004],
              [44.48780358200008, 66.67617422100005],
              [44.46420332100007, 66.69057851800005],
              [44.451508009000065, 66.70099518400008],
              [44.434580925000034, 66.73346588700008],
              [44.380869988000086, 66.76390208500004],
              [44.364024285000085, 66.78229401200008],
              [44.37663821700005, 66.80491771000004],
              [44.46607506600009, 66.81972890800006],
              [44.48755944100009, 66.84438711100006],
              [44.48161868600005, 66.89362213700008],
              [44.49048912900008, 66.90448639500005],
              [44.52165774800005, 66.91941966400003],
              [44.49927819100009, 66.92145416900007],
              [44.490896030000044, 66.93008047100005],
              [44.48747806100005, 66.94204336100006],
              [44.48072350400008, 66.95355866100005],
              [44.43246504000007, 66.98236725500004],
              [44.42554772200003, 66.99485911700003],
              [44.40967858200008, 67.01190827000005],
              [44.37330162900008, 67.03058502800008],
              [44.30250084700003, 67.05597565300008],
              [44.315114780000044, 67.07461172100005],
              [44.33578535200007, 67.08405182500007],
              [44.35889733200008, 67.09162018400008],
              [44.377696160000085, 67.10443756700005],
              [44.28695722700007, 67.08783600500004],
              [44.26498457100007, 67.09418366100005],
              [44.24732506600009, 67.10663483300004],
              [44.20630944100009, 67.12470123900005],
              [44.17432774300005, 67.13394147400004],
              [44.151219282000056, 67.14307907800008],
              [44.09553867500006, 67.15866249100003],
              [44.03964585400007, 67.16743848900006],
              [43.987026351000054, 67.16305264600004],
              [43.94965352300005, 67.16359701300007],
              [43.916909280000084, 67.16095262700009],
              [43.86687259200005, 67.17133209800005],
              [43.815329312000074, 67.17745252300006],
              [43.775401238000086, 67.20457591400003],
              [43.76140384200005, 67.22113678600005],
              [43.76534469100005, 67.23824898600003],
              [43.76669898200004, 67.27768850600006],
              [43.79303558000004, 67.34339405300005],
              [43.862363954000045, 67.42622304900004],
              [44.00301503800006, 67.57602701500008],
              [44.023763907000045, 67.61641517100009],
              [44.02279445900007, 67.62454483300007],
              [44.02659625900009, 67.64318203500005],
              [44.02426191500007, 67.65607330900008],
              [44.033213738000086, 67.67080312700006],
              [44.04184004000007, 67.68040599200003],
              [44.04965254000007, 67.68341705900008],
              [44.075205925000034, 67.68781159100007],
              [44.08350670700008, 67.68720123900005],
              [44.088877800000034, 67.68268463700008],
              [44.093760613000086, 67.67568594000005],
              [44.09693444100009, 67.66933828300006],
              [44.09717858200008, 67.66673411700003],
              [44.10962975400008, 67.66669342700004],
              [44.127940300000034, 67.67064036700003],
              [44.144541863000086, 67.67942942900004],
              [44.15170332100007, 67.69375234600005],
              [44.143321160000085, 67.70693594000005],
              [44.12281334700003, 67.71051666900007],
              [44.07667076900009, 67.70770905200004],
              [44.06950931100005, 67.71442291900007],
              [44.08130944100009, 67.72964101800005],
              [44.11085045700008, 67.75551992400005],
              [44.11744225400008, 67.76471588700008],
              [44.12484785200007, 67.77802155200004],
              [44.13062584700003, 67.79218170800004],
              [44.131846550000034, 67.80390045800004],
              [44.125010613000086, 67.81663646000004],
              [44.11280358200008, 67.82538483300004],
              [44.09896894600007, 67.83283112200007],
              [44.086924675000034, 67.84149811400005],
              [44.08480879000007, 67.85053131700005],
              [44.08415774800005, 67.86806875200006],
              [44.08741295700008, 67.88507721600007],
              [44.09717858200008, 67.89272695500006],
              [44.17628014400009, 67.88922760600008],
              [44.200205925000034, 67.89272695500006],
              [44.21794681100005, 67.89996979400007],
              [44.250743035000085, 67.91913483300004],
              [44.26840254000007, 67.92682526200008],
              [44.234711134000065, 67.93805573100008],
              [44.14861087300005, 67.92523834800005],
              [44.12452233200008, 67.93427155200004],
              [44.13803144600007, 67.97528717700004],
              [44.15455162900008, 67.98151276200008],
              [44.195648634000065, 67.98309967700004],
              [44.213877800000034, 67.98895905200004],
              [44.19581139400009, 67.99481842700004],
              [44.15788821700005, 67.98993561400005],
              [44.13803144600007, 67.99510325700004],
              [44.16228274800005, 68.01211172100005],
              [44.334727410000085, 68.05711497600004],
              [44.41179446700005, 68.06342194200005],
              [44.404958530000044, 68.06533437700006],
              [44.359711134000065, 68.07046133000006],
              [44.30787194100009, 68.06586334800005],
              [44.256602410000085, 68.05467357000003],
              [44.213552280000044, 68.03974030200004],
              [44.18083743600005, 68.03607819200005],
              [44.17042076900009, 68.05609772300005],
              [44.17465254000007, 68.08600495000007],
              [44.186534050000034, 68.11180247600004],
              [44.20362389400009, 68.13694896000004],
              [44.206065300000034, 68.14663320500006],
              [44.20639082100007, 68.16331614800004],
              [44.20834394600007, 68.17279694200005],
              [44.236338738000086, 68.23208242400005],
              [44.24439537900008, 68.25568268400008],
              [44.243174675000034, 68.27749258000006],
              [44.227549675000034, 68.29677969000005],
              [44.160166863000086, 68.33624909100007],
              [43.742930535000085, 68.47496165600006],
              [43.32569420700008, 68.61367422100005],
              [43.291758660000085, 68.63568756700005],
              [43.27367282200004, 68.65817627600006],
              [43.31715436200005, 68.66661157200008],
              [43.37362434400006, 68.66804819700008],
              [43.47729280200008, 68.66906564400006],
              [43.61670983200008, 68.64118073100008],
              [43.63795006600009, 68.63873932500007],
              [43.69083746500007, 68.62439635900006],
              [43.746996170000045, 68.61643086000004],
              [43.78646894600007, 68.60626862200007],
              [43.80225670700008, 68.59780508000006],
              [43.82211347700007, 68.59284088700008],
              [43.86500084700003, 68.58759186400005],
              [43.98454837300005, 68.55133698100008],
              [44.239024285000085, 68.53717682500007],
              [44.51026451900009, 68.55402252800008],
              [44.96407438300008, 68.55245774100007],
              [45.30637263600005, 68.54529116900005],
              [45.582137180000075, 68.51419846300007],
              [45.888738457000045, 68.45594146700006],
              [45.94385826900009, 68.44623444200005],
              [45.95085696700005, 68.42401764500005],
              [45.95630944100009, 68.41600169500003],
              [45.96599368600005, 68.39704010600008],
              [45.97152754000007, 68.38922760600008],
              [45.981455925000034, 68.38287995000007],
              [46.00611412900008, 68.37254466400003],
              [46.01579837300005, 68.36505768400008],
              [46.019867384000065, 68.35492584800005],
              [46.02312259200005, 68.33274974200003],
              [46.029307488000086, 68.32404205900008],
              [46.04468834700003, 68.31952545800004],
              [46.080189079000036, 68.31069640600003],
              [46.164805535000085, 68.26911041900007],
              [46.22239147400006, 68.23924269100007],
              [46.276377800000034, 68.21426015800006],
              [46.29639733200008, 68.21039459800005],
              [46.351573113000086, 68.21426015800006],
              [46.366221550000034, 68.21043528900003],
              [46.39584394600007, 68.19721100500004],
              [46.421885613000086, 68.19135163000004],
              [46.461680535000085, 68.17015208500004],
              [46.53492272200003, 68.13255442900004],
              [46.519867384000065, 68.12128327000005],
              [46.48943118600005, 68.11469147300005],
              [46.46143639400009, 68.11180247600004],
              [46.525726759000065, 68.11359284100007],
              [46.54021243600005, 68.10838450700004],
              [46.547536655000044, 68.09853750200006],
              [46.547618035000085, 68.09316640800006],
              [46.54468834700003, 68.08771393400008],
              [46.54322350400008, 68.07762278900003],
              [46.54509524800005, 68.04401276200008],
              [46.54908287900008, 68.03070709800005],
              [46.557627800000034, 68.01618073100008],
              [46.576508009000065, 67.99746328300006],
              [46.59685306100005, 67.98773834800005],
              [46.61768639400009, 67.98029205900008],
              [46.63884524800005, 67.96841054900005],
              [46.645192905000044, 67.96035390800006],
              [46.647471550000034, 67.95197174700007],
              [46.65064537900008, 67.94407786700003],
              [46.65967858200008, 67.93740469000005],
              [46.678627522000056, 67.91512603200005],
              [46.70264733200008, 67.89166901200008],
              [46.70435631600009, 67.88247304900005],
              [46.71078535200007, 67.87376536700003],
              [46.72201582100007, 67.84491608300004],
              [46.698252800000034, 67.81647370000007],
              [46.661143425000034, 67.80744049700007],
              [46.57249996100006, 67.80957276400005],
              [46.508474155000044, 67.81631094000005],
              [46.490244988000086, 67.81891510600008],
              [46.44372387300007, 67.81787450900003],
              [46.375432570000044, 67.81907548600003],
              [46.211924675000034, 67.80223216400003],
              [46.004116906000036, 67.76774604400003],
              [45.619008062000034, 67.74556586300008],
              [45.44856250700008, 67.72961901500008],
              [45.35043379000007, 67.73041413000004],
              [45.30990644600007, 67.71279531500005],
              [45.303070509000065, 67.69403717700004],
              [45.32056725400008, 67.68626536700003],
              [45.33570397200003, 67.68797435100004],
              [45.346690300000034, 67.68500397300005],
              [45.35092207100007, 67.66303131700005],
              [45.34888756600009, 67.65005117400005],
              [45.339854363000086, 67.62653229400007],
              [45.337901238000086, 67.61522044500003],
              [45.31462649800005, 67.59210846600007],
              [45.26107832100007, 67.58490631700005],
              [45.16586347700007, 67.58421458500004],
              [45.09685306100005, 67.56317780200004],
              [45.02816816500007, 67.53192780200004],
              [44.96664472700007, 67.49103424700007],
              [44.918955925000034, 67.44086334800005],
              [44.92725670700008, 67.42234935100004],
              [44.92269941500007, 67.40546295800004],
              [44.914724155000044, 67.38906484600005],
              [44.912119988000086, 67.37197500200006],
              [44.924571160000085, 67.35154857000003],
              [44.95168721600004, 67.32071711000003],
              [45.05504777900006, 67.28379749300007],
              [45.15856183800008, 67.25464434800006],
              [45.22192549500005, 67.23366587000004],
              [45.30934918100007, 67.21162446400007],
              [45.409415306000085, 67.19878471400006],
              [45.50937247500008, 67.18588325900004],
              [45.593893033000086, 67.15823975900008],
              [45.63835696700005, 67.10785553600005],
              [45.646494988000086, 67.08356354400007],
              [45.66586347700007, 67.06264883000006],
              [45.78467858200008, 66.96800364800004],
              [45.79664147200003, 66.94989655200004],
              [45.80420983200008, 66.91860586100006],
              [45.82447350400008, 66.89907461100006],
              [45.85320071700005, 66.88703034100007],
              [45.96436608200008, 66.86652252800008],
              [45.988291863000086, 66.85797760600008],
              [46.01303144600007, 66.84015534100007],
              [46.02515709700003, 66.83340078300006],
              [46.04151451900009, 66.83091868700006],
              [46.30103600400008, 66.84015534100007],
              [46.489024285000085, 66.87848541900007],
              [46.547618035000085, 66.87860748900005],
              [46.578461134000065, 66.87287018400008],
              [46.59791100400008, 66.85797760600008],
              [46.59888756600009, 66.83771393400008],
              [46.579112175000034, 66.83270905200004],
              [46.552744988000086, 66.83258698100008],
              [46.533539259000065, 66.82697174700007],
              [46.50017337300005, 66.79621002800008],
              [46.48129316500007, 66.78432851800005],
              [46.398773634000065, 66.75177643400008],
              [46.37940514400009, 66.74811432500007],
              [46.40674889400009, 66.74616120000007],
              [46.44776451900009, 66.75507233300004],
              [46.489024285000085, 66.76902903900003],
              [46.551524285000085, 66.80304596600007],
              [46.58334394600007, 66.81549713700008],
              [46.82789147200003, 66.84495677300004],
              [46.92693118600005, 66.84495677300004],
              [46.98194420700008, 66.86351146000004],
              [47.02426191500007, 66.85956452000005],
              [47.40984134200005, 66.92926666900007],
              [47.457692905000044, 66.92715078300006],
              [47.55876712300005, 66.90497467700004],
              [47.57593834700003, 66.89150625200006],
              [47.57178795700008, 66.86420319200005],
              [47.58139082100007, 66.86985911700003],
              [47.59034264400009, 66.87661367400005],
              [47.60661868600005, 66.89215729400007],
              [47.59498131600009, 66.90704987200007],
              [47.59066816500007, 66.91937897300005],
              [47.594493035000085, 66.93158600500004],
              [47.60661868600005, 66.94611237200007],
              [47.62354576900009, 66.95880768400008],
              [47.67465254000007, 66.98379140800006],
              [47.694346550000034, 66.98834870000007],
              [47.725596550000034, 67.00092194200005],
              [47.74203535200007, 67.03070709800005],
              [47.74822024800005, 67.06574127800008],
              [47.74976647200003, 67.12132396000004],
              [47.74594160200007, 67.13178131700005],
              [47.73560631600009, 67.14541250200006],
              [47.701914910000085, 67.17182038000004],
              [47.69467207100007, 67.18012116100005],
              [47.689463738000086, 67.19643789300005],
              [47.69507897200003, 67.20473867400005],
              [47.77426191500007, 67.24079010600008],
              [47.787119988000086, 67.25153229400007],
              [47.79127037900008, 67.26203034100007],
              [47.78760826900009, 67.27374909100007],
              [47.77654056100005, 67.29621002800008],
              [47.776133660000085, 67.30125560100004],
              [47.77654056100005, 67.31671784100007],
              [47.772471550000034, 67.33649323100008],
              [47.77035566500007, 67.33783600500004],
              [47.79314212300005, 67.36058177300004],
              [47.90756269600007, 67.40232982000003],
              [47.93685957100007, 67.42340729400007],
              [47.947927280000044, 67.44432200700004],
              [47.942067905000044, 67.46588776200008],
              [47.920664910000085, 67.48867422100005],
              [47.82471764400009, 67.56028880400004],
              [47.81462649800005, 67.58136627800008],
              [47.845713738000086, 67.60089752800008],
              [48.00831139400009, 67.65058014500005],
              [48.05225670700008, 67.65192291900007],
              [48.09937584700003, 67.63947174700007],
              [48.08838951900009, 67.62933991100005],
              [48.07992597700007, 67.61766185100004],
              [48.07447350400008, 67.60455963700008],
              [48.07146243600005, 67.59039948100008],
              [48.09294681100005, 67.59223053600005],
              [48.111664259000065, 67.60272858300004],
              [48.147471550000034, 67.62889232000003],
              [48.20443769600007, 67.65192291900007],
              [48.219411655000044, 67.66303131700005],
              [48.25570722700007, 67.68268463700008],
              [48.30689537900008, 67.69025299700007],
              [48.35962975400008, 67.68854401200008],
              [48.44361412900008, 67.66868724200003],
              [48.48650149800005, 67.66429271000004],
              [48.529307488000086, 67.66791413000004],
              [48.656260613000086, 67.71222565300008],
              [48.699961785000085, 67.71588776200008],
              [48.74366295700008, 67.70026276200008],
              [48.73218834700003, 67.70123932500007],
              [48.721690300000034, 67.70075104400007],
              [48.711599155000044, 67.69847239800004],
              [48.70199629000007, 67.69403717700004],
              [48.92497806100005, 67.68768952000005],
              [48.996836785000085, 67.66673411700003],
              [48.96216881600009, 67.65314362200007],
              [48.99431399800005, 67.64276764500005],
              [49.035899285000085, 67.63410065300008],
              [49.07667076900009, 67.63157786700003],
              [49.10670006600009, 67.63947174700007],
              [49.076914910000085, 67.65013255400004],
              [49.060557488000086, 67.65302155200004],
              [49.04468834700003, 67.65314362200007],
              [49.047862175000034, 67.65717194200005],
              [49.05583743600005, 67.66962311400005],
              [49.058929884000065, 67.67357005400004],
              [48.97120201900009, 67.69672272300005],
              [48.94190514400009, 67.70026276200008],
              [48.92204837300005, 67.70538971600007],
              [48.881846550000034, 67.72870514500005],
              [48.85962975400008, 67.73505280200004],
              [48.803721550000034, 67.72687409100007],
              [48.77784264400009, 67.72736237200007],
              [48.77084394600007, 67.74188873900005],
              [48.78142337300005, 67.75446198100008],
              [48.79639733200008, 67.76373932500007],
              [48.805430535000085, 67.77399323100008],
              [48.797618035000085, 67.78969961100006],
              [48.793630405000044, 67.83124420800004],
              [48.585948113000086, 67.93427155200004],
              [48.62330162900008, 67.94379303600005],
              [48.66928144600007, 67.93524811400005],
              [48.79607181100005, 67.87872955900008],
              [48.842784050000034, 67.86505768400008],
              [48.970713738000086, 67.85077545800004],
              [49.13331139400009, 67.86261627800008],
              [49.17741946700005, 67.87620677300004],
              [49.31950931100005, 67.90021393400008],
              [49.510752800000034, 67.95514557500007],
              [49.654633009000065, 67.98102448100008],
              [49.79460696700005, 68.03668854400007],
              [49.972666863000086, 68.08779531500005],
              [50.01783287900008, 68.09129466400003],
              [49.982758009000065, 68.06142812700006],
              [49.881521030000044, 68.03961823100008],
              [49.84652754000007, 68.01618073100008],
              [50.00114993600005, 68.05805084800005],
              [50.04859459700003, 68.08820221600007],
              [50.06609134200005, 68.10301341400003],
              [50.09888756600009, 68.12445709800005],
              [50.20053144600007, 68.16889069200005],
              [50.26587975400008, 68.17963288000004],
              [50.35206139400003, 68.20783112200007],
              [50.43474368600005, 68.22052643400008],
              [50.64177493600005, 68.30048248900005],
              [50.69223066500007, 68.33295319200005],
              [50.725271030000044, 68.34381745000007],
              [50.75993899800005, 68.37140534100007],
              [50.77881920700008, 68.37929922100005],
              [50.795583530000044, 68.37689850500004],
              [50.84717858200008, 68.35138580900008],
              [50.89576256600009, 68.34198639500005],
              [50.951833530000044, 68.34072500200006],
              [51.05884850400008, 68.35138580900008],
              [51.08090254000007, 68.35773346600007],
              [51.125336134000065, 68.37563711100006],
              [51.148448113000086, 68.37929922100005],
              [51.19662519600007, 68.38092682500007],
              [51.33611087300005, 68.40143463700008],
              [51.42310631600009, 68.43085358300004],
              [51.44613691500007, 68.43406810100004],
              [51.49105879000007, 68.42194245000007],
              [51.510508660000085, 68.42226797100005],
              [51.56885826900003, 68.43585846600007],
              [51.586924675000034, 68.44757721600007],
              [51.57309004000007, 68.44757721600007],
              [51.53239993600005, 68.45441315300008],
              [51.560557488000086, 68.48305898600006],
              [51.60767662900008, 68.49213288000004],
              [51.70297285200007, 68.48859284100007],
              [52.06006920700008, 68.54376862200007],
              [52.17709394600007, 68.58242422100005],
              [52.21705162900008, 68.58478424700007],
              [52.20484459700003, 68.55951569200005],
              [52.18181399800005, 68.54242584800005],
              [52.12818444100009, 68.52334219000005],
              [52.059580925000034, 68.51561107000003],
              [52.04623457100007, 68.50967031500005],
              [52.04639733200008, 68.50141022300005],
              [52.051768425000034, 68.49241771000004],
              [52.05941816500007, 68.48529694200005],
              [52.066742384000065, 68.48236725500004],
              [52.10572350400008, 68.48700592700004],
              [52.176524285000085, 68.50397370000007],
              [52.29428144600007, 68.49970123900005],
              [52.33375084700003, 68.49335358300004],
              [52.36101321700005, 68.47492096600007],
              [52.34156334700003, 68.47272370000007],
              [52.31959069100009, 68.47516510600008],
              [52.299571160000085, 68.47402578300006],
              [52.28646894600007, 68.46124909100007],
              [52.28882897200003, 68.45335521000004],
              [52.29704837300005, 68.44623444200005],
              [52.30225670700008, 68.43720123900005],
              [52.29615319100009, 68.42401764500005],
              [52.25831139400003, 68.40802643400008],
              [52.158864780000044, 68.39862702000005],
              [52.13559004000007, 68.37929922100005],
              [52.15935306100005, 68.37177155200004],
              [52.24854576900003, 68.31769440300008],
              [52.26937910200007, 68.31509023600006],
              [52.291758660000085, 68.32070547100005],
              [52.320648634000065, 68.33152903900003],
              [52.340830925000034, 68.33608633000006],
              [52.40202884200005, 68.33771393400008],
              [52.41732832100007, 68.34243398600006],
              [52.44898522200003, 68.35594310100004],
              [52.47787519600007, 68.36188385600008],
              [52.57390384200005, 68.40973541900007],
              [52.60726972700007, 68.41901276200008],
              [52.67741946700005, 68.42316315300008],
              [52.71045983200008, 68.44082265800006],
              [52.72584069100009, 68.45807526200008],
              [52.73129316500007, 68.47418854400007],
              [52.72437584700003, 68.48899974200003],
              [52.70362389400003, 68.50287506700005],
              [52.67074629000007, 68.51251862200007],
              [52.59929446700005, 68.52366771000004],
              [52.567067905000044, 68.53701406500005],
              [52.559580925000034, 68.54222239800004],
              [52.55103600400008, 68.54970937700006],
              [52.543955925000034, 68.55853913000004],
              [52.541026238000086, 68.56769440300008],
              [52.53467858200008, 68.57587311400005],
              [52.49138431100005, 68.59153880400004],
              [52.49984785200007, 68.60468170800004],
              [52.500010613000086, 68.60952383000006],
              [52.498789910000085, 68.61953359600005],
              [52.60670006600009, 68.62571849200003],
              [52.62387129000007, 68.62905508000006],
              [52.640961134000065, 68.63727448100008],
              [52.64771569100009, 68.64793528900003],
              [52.63445071700005, 68.65851471600007],
              [52.61443118600005, 68.65985748900005],
              [52.56218509200005, 68.64915599200003],
              [52.515635613000086, 68.64484284100007],
              [52.49545332100007, 68.64008209800005],
              [52.47787519600007, 68.63076406500005],
              [52.44678795700008, 68.60272858300004],
              [52.42945397200003, 68.59210846600007],
              [52.41065514400003, 68.58649323100008],
              [52.29932701900003, 68.59052155200004],
              [52.27906334700003, 68.59780508000006],
              [52.28874759200005, 68.61542389500005],
              [52.328461134000065, 68.63344961100006],
              [52.37614993600005, 68.64740631700005],
              [52.45289147200003, 68.65814850500004],
              [52.80648847700007, 68.76801178600005],
              [52.943695509000065, 68.79022858300004],
              [53.07935631600009, 68.83234284100007],
              [53.16431725400008, 68.84601471600007],
              [53.250010613000086, 68.87840403900003],
              [53.340586785000085, 68.89142487200007],
              [53.43702233200008, 68.91815827000005],
              [53.87859134200005, 68.97410716400003],
              [54.10377037900008, 69.00067780200004],
              [54.297862175000034, 69.00047435100004],
              [54.347666863000086, 69.01227448100008],
              [54.527354363000086, 69.00995514500005],
              [54.55591881600009, 69.00470612200007],
              [54.561289910000085, 68.99970123900005],
              [54.55689537900008, 68.99286530200004],
              [54.54802493600005, 68.98639557500007],
              [54.54029381600009, 68.98200104400007],
              [54.52898196700005, 68.97846100500004],
              [54.51978600400008, 68.97882721600007],
              [54.51059004000007, 68.98086172100005],
              [54.49887129000007, 68.98200104400007],
              [54.42603600400008, 68.97671133000006],
              [54.35596764400003, 68.95897044500003],
              [53.98389733150003, 68.93622467650005],
              [53.61182701900003, 68.91347890800006],
              [53.59489993600005, 68.90692780200004],
              [53.61573326900003, 68.89581940300008],
              [53.62281334700003, 68.89325592700004],
              [53.62810306100005, 68.87860748900005],
              [53.66553795700008, 68.86627838700008],
              [53.705414259000065, 68.86066315300008],
              [53.73210696700005, 68.86591217700004],
              [53.72282962300005, 68.87287018400008],
              [53.71273847700007, 68.87872955900008],
              [53.702159050000034, 68.88312409100007],
              [53.69117272200003, 68.88580963700008],
              [53.72803795700008, 68.89744700700004],
              [53.957692905000044, 68.87661367400005],
              [54.00114993600005, 68.86684804900005],
              [54.02621504000007, 68.84544505400004],
              [53.95085696700005, 68.81541575700004],
              [53.923838738000086, 68.81126536700003],
              [53.89926191500007, 68.81024811400005],
              [53.88070722700007, 68.80621979400007],
              [53.86500084700003, 68.79791901200008],
              [53.83155358200008, 68.76870351800005],
              [53.82894941500007, 68.76361725500004],
              [53.834320509000065, 68.75836823100008],
              [53.84131920700008, 68.74241771000004],
              [53.83806399800005, 68.71328359600005],
              [53.81771894600007, 68.68915436400005],
              [53.787119988000086, 68.67279694200005],
              [53.752614780000044, 68.66669342700004],
              [53.72046959700003, 68.65692780200004],
              [53.72828209700003, 68.63471100500004],
              [53.75513756600009, 68.61041901200008],
              [53.79444420700008, 68.58661530200004],
              [53.82081139400003, 68.56647370000007],
              [53.87647545700008, 68.53363678600005],
              [53.88982181100005, 68.52334219000005],
              [53.90447024800005, 68.50731028900003],
              [53.915049675000034, 68.48924388200004],
              [53.92115319100009, 68.46841054900005],
              [53.92318769600007, 68.44415924700007],
              [53.92693118600005, 68.43256256700005],
              [53.94190514400003, 68.41307200700004],
              [53.944346550000034, 68.40599192900004],
              [53.93189537900008, 68.39101797100005],
              [53.909190300000034, 68.38703034100007],
              [53.86304772200003, 68.38556549700007],
              [53.84620201900003, 68.37531159100007],
              [53.821299675000034, 68.34967682500007],
              [53.803721550000034, 68.34454987200007],
              [53.78760826900003, 68.34813060100004],
              [53.738942905000044, 68.37588125200006],
              [53.65593509200005, 68.40753815300008],
              [53.60889733200008, 68.41347890800006],
              [53.57447350400008, 68.39980703300006],
              [53.63168379000007, 68.38568756700005],
              [53.646494988000086, 68.37588125200006],
              [53.65650475400008, 68.36587148600006],
              [53.666351759000065, 68.35834381700005],
              [53.69117272200003, 68.34454987200007],
              [53.66146894600007, 68.33218008000006],
              [53.624034050000034, 68.33685944200005],
              [53.55396569100009, 68.35883209800005],
              [53.440440300000034, 68.37250397300005],
              [53.420583530000044, 68.36937083500004],
              [53.40544681100005, 68.36163971600007],
              [53.37549889400003, 68.34113190300008],
              [53.36378014400003, 68.33991120000007],
              [53.33871504000007, 68.34992096600007],
              [53.32740319100009, 68.35138580900008],
              [53.319102410000085, 68.34804922100005],
              [53.30014082100007, 68.33152903900003],
              [53.23178144600007, 68.29677969000005],
              [53.21070397200003, 68.26935455900008],
              [53.238942905000044, 68.25348541900007],
              [53.32740319100009, 68.24213288000004],
              [53.37671959700003, 68.24335358300004],
              [53.47152754000007, 68.26032135600008],
              [53.80844160200007, 68.25067780200004],
              [53.83611087300005, 68.24408600500004],
              [53.87517337300005, 68.22406647300005],
              [53.892588738000086, 68.22166575700004],
              [53.992523634000065, 68.22138092700004],
              [54.041351759000065, 68.22809479400007],
              [54.08838951900003, 68.24583567900004],
              [54.15023847700007, 68.29901764500005],
              [54.18490644600007, 68.32054271000004],
              [54.218760613000086, 68.31785716400003],
              [54.182383660000085, 68.28143952000005],
              [54.17310631600009, 68.26178620000007],
              [54.17709394600007, 68.23590729400007],
              [54.20329837300005, 68.20954010600008],
              [54.23975670700008, 68.21133047100005],
              [54.46509850400008, 68.30418528900003],
              [54.50440514400003, 68.31220123900005],
              [54.53630618600005, 68.30581289300005],
              [54.56332441500007, 68.28815338700008],
              [54.65015709700003, 68.19432200700004],
              [54.69109134200005, 68.17597077000005],
              [54.738291863000086, 68.17039622600004],
              [54.83187910200007, 68.17328522300005],
              [54.84701582100007, 68.17649974200003],
              [54.864024285000085, 68.18512604400007],
              [54.877696160000085, 68.19721100500004],
              [54.883555535000085, 68.21112702000005],
              [54.88982181100005, 68.22199127800008],
              [54.917979363000086, 68.24030182500007],
              [54.924489780000044, 68.25267161700003],
              [54.91716556100005, 68.28266022300005],
              [54.899099155000044, 68.29523346600007],
              [54.87671959700003, 68.30438873900005],
              [54.856130405000044, 68.32404205900008],
              [54.895192905000044, 68.32379791900007],
              [54.90805097700007, 68.32949453300006],
              [54.90398196700005, 68.34454987200007],
              [54.91781660200007, 68.37494538000004],
              [54.924489780000044, 68.38556549700007],
              [54.93669681100005, 68.39842357000003],
              [54.996755405000044, 68.43915436400005],
              [55.014414910000085, 68.44277578300006],
              [55.05404707100007, 68.44082265800006],
              [55.06755618600005, 68.44619375200006],
              [55.094493035000085, 68.47256094000005],
              [55.109385613000086, 68.48236725500004],
              [55.189463738000086, 68.49103424700007],
              [55.20915774800005, 68.49909088700008],
              [55.21257571700005, 68.50458405200004],
              [55.21436608200008, 68.51479726800005],
              [55.21924889400003, 68.51959870000007],
              [55.229258660000085, 68.52435944200005],
              [55.392914259000065, 68.56427643400008],
              [55.49350019600007, 68.57428620000007],
              [55.60238691500007, 68.56976959800005],
              [55.699554884000065, 68.57656484600005],
              [55.78663170700008, 68.59467194200005],
              [55.95264733200008, 68.65399811400005],
              [55.997080925000034, 68.66046784100007],
              [56.04908287900008, 68.65412018400008],
              [56.14958743600005, 68.62592194200005],
              [56.20199629000007, 68.61953359600005],
              [56.50440514400003, 68.62783437700006],
              [56.52084394600007, 68.61908600500004],
              [56.49350019600007, 68.58478424700007],
              [56.51002037900008, 68.59577057500007],
              [56.569346550000034, 68.63568756700005],
              [56.596364780000044, 68.64199453300006],
              [56.629649285000085, 68.64203522300005],
              [56.663096550000034, 68.63764069200005],
              [56.69068444100009, 68.63076406500005],
              [56.848399285000085, 68.57160065300008],
              [57.092458530000044, 68.54800039300005],
              [57.32984459700003, 68.56476471600007],
              [57.38428795700008, 68.57855866100005],
              [57.414073113000086, 68.59715403900003],
              [57.44809004000007, 68.64447663000004],
              [57.473643425000034, 68.66364166900007],
              [57.53663170700008, 68.68829987200007],
              [57.55616295700008, 68.70140208500004],
              [57.58741295700008, 68.73387278900003],
              [57.60401451900003, 68.74241771000004],
              [57.92953535200007, 68.75104401200008],
              [57.98072350400008, 68.79364655200004],
              [57.974619988000086, 68.80166250200006],
              [57.961924675000034, 68.80866120000007],
              [57.949880405000044, 68.81757233300004],
              [57.945974155000044, 68.83120351800005],
              [57.95671634200005, 68.84552643400008],
              [57.97787519600007, 68.85297272300005],
              [58.17115319100009, 68.88934967700004],
              [58.22055097700007, 68.89325592700004],
              [58.245127800000034, 68.88841380400004],
              [58.242198113000086, 68.87702057500007],
              [58.21338951900003, 68.85228099200003],
              [58.20289147200003, 68.83820221600007],
              [58.20362389400003, 68.83209870000007],
              [58.21273847700007, 68.82746002800008],
              [58.22771243600005, 68.81753164300005],
              [58.25114993600005, 68.79222239800004],
              [58.26417076900003, 68.78119538000004],
              [58.278330925000034, 68.77655670800004],
              [58.328868035000085, 68.77041250200006],
              [58.377940300000034, 68.75604889500005],
              [58.336924675000034, 68.73558177300004],
              [58.39600670700008, 68.73517487200007],
              [58.42408287900008, 68.74274323100008],
              [58.43930097700007, 68.76288483300004],
              [58.42017662900008, 68.76703522300005],
              [58.38412519600007, 68.77997467700004],
              [58.364268425000034, 68.78400299700007],
              [58.32203209700003, 68.78424713700008],
              [58.30290774800005, 68.78807200700004],
              [58.28541100400008, 68.80048248900005],
              [58.282237175000034, 68.80646393400008],
              [58.28370201900003, 68.81110260600008],
              [58.28687584700003, 68.81561920800004],
              [58.28858483200008, 68.82123444200005],
              [58.28687584700003, 68.82465241100005],
              [58.27865644600007, 68.82709381700005],
              [58.27556399800005, 68.83120351800005],
              [58.26929772200003, 68.83510976800005],
              [58.25945071700005, 68.83808014500005],
              [58.25407962300005, 68.84202708500004],
              [58.26156660200007, 68.84886302300004],
              [58.26783287900008, 68.85260651200008],
              [58.27133222700007, 68.85590241100005],
              [58.273448113000086, 68.86001211100006],
              [58.27556399800005, 68.86591217700004],
              [58.27564537900008, 68.87799713700008],
              [58.27125084700003, 68.88629791900007],
              [58.270518425000034, 68.89370351800005],
              [58.281993035000085, 68.90322500200006],
              [58.300791863000086, 68.90985748900005],
              [58.58977298250008, 68.95648834850005],
              [58.87875410200007, 69.00311920800004],
              [59.20289147200003, 69.00360748900005],
              [59.22388756600009, 68.99970123900005],
              [59.24195397200003, 68.98883698100008],
              [59.217539910000085, 68.98273346600007],
              [59.167002800000034, 68.98867422100005],
              [59.145518425000034, 68.98541901200008],
              [59.12517337300005, 68.97943756700005],
              [58.96998131600009, 68.96515534100007],
              [58.924164259000065, 68.95368073100008],
              [58.89185631600009, 68.93423086100006],
              [58.96599368600005, 68.93081289300005],
              [59.105479363000086, 68.90330638200004],
              [59.41553795700008, 68.76666901200008],
              [59.42302493600005, 68.75702545800004],
              [59.41944420700008, 68.71849192900004],
              [59.398448113000086, 68.70111725500004],
              [59.35092207100007, 68.70180898600006],
              [59.26929772200003, 68.71507396000004],
              [59.23487389400003, 68.71295807500007],
              [59.201508009000065, 68.70595937700006],
              [59.17123457100007, 68.69326406500005],
              [59.14576256600009, 68.67413971600007],
              [59.127696160000085, 68.64956289300005],
              [59.11841881600009, 68.64248281500005],
              [59.10271243600005, 68.63641998900005],
              [59.07056725400008, 68.62811920800004],
              [59.05640709700003, 68.61953359600005],
              [59.06137129000007, 68.61066315300008],
              [59.063487175000034, 68.60187409100007],
              [59.06381269600007, 68.58169179900005],
              [59.06950931100005, 68.56928131700005],
              [59.08285566500007, 68.56102122600004],
              [59.09880618600005, 68.55361562700006],
              [59.11158287900008, 68.54376862200007],
              [59.11882571700005, 68.53168366100005],
              [59.11540774800005, 68.52533600500004],
              [59.10474694100009, 68.51797109600005],
              [59.090505405000044, 68.50287506700005],
              [59.07837975400008, 68.48167552300004],
              [59.07211347700007, 68.45937734600005],
              [59.074229363000086, 68.43720123900005],
              [59.08708743600005, 68.41689687700006],
              [59.10954837300005, 68.40473053600005],
              [59.39218183650004, 68.37044912300004],
              [59.674815300000034, 68.33616771000004],
              [59.857432488000086, 68.38129303600005],
              [59.899180535000085, 68.40599192900004],
              [59.963877800000034, 68.46600983300004],
              [59.963633660000085, 68.47142161700003],
              [59.957774285000085, 68.47687409100007],
              [59.94678795700008, 68.51764557500007],
              [59.92904707100007, 68.53778717700004],
              [59.870127800000034, 68.58356354400007],
              [59.824229363000086, 68.60871002800008],
              [59.789724155000044, 68.61863841400003],
              [59.772471550000034, 68.62616608300004],
              [59.762705925000034, 68.63873932500007],
              [59.77361087300005, 68.66819896000004],
              [59.811208530000044, 68.68793366100005],
              [59.91098066500007, 68.72028229400007],
              [59.93474368600005, 68.72077057500007],
              [60.03207441500007, 68.69399648600006],
              [60.08423912900008, 68.68720123900005],
              [60.46664472700007, 68.72231679900005],
              [60.55632571700005, 68.74469635600008],
              [60.701508009000065, 68.81500885600008],
              [60.71827233200008, 68.82807038000004],
              [60.75521894600007, 68.86640045800004],
              [60.76978600400008, 68.87588125200006],
              [60.81885826900003, 68.89435455900008],
              [60.86638431100005, 68.90350983300004],
              [60.968760613000086, 68.90692780200004],
              [60.95240319100003, 68.91160716400003],
              [60.936289910000085, 68.91388580900008],
              [60.920909050000034, 68.91779205900008],
              [60.907237175000034, 68.92739492400005],
              [60.924815300000034, 68.94403717700004],
              [60.93832441500007, 68.96328359600005],
              [60.94654381600003, 68.98346588700008],
              [60.948252800000034, 69.00311920800004],
              [60.94548587300005, 69.01215241100005],
              [60.935883009000065, 69.03046295800004],
              [60.933929884000065, 69.04067617400005],
              [60.93490644600007, 69.06940338700008],
              [60.933929884000065, 69.07819245000007],
              [60.902679884000065, 69.12225983300004],
              [60.843760613000086, 69.15753815300008],
              [60.77670332100007, 69.17719147300005],
              [60.721690300000034, 69.17446523600006],
              [60.727224155000044, 69.16425202000005],
              [60.728851759000065, 69.15355052300004],
              [60.727224155000044, 69.14288971600007],
              [60.721690300000034, 69.13279857000003],
              [60.72673587300005, 69.12970612200007],
              [60.736338738000086, 69.12189362200007],
              [60.742198113000086, 69.11920807500007],
              [60.710948113000086, 69.10626862200007],
              [60.66578209700003, 69.10643138200004],
              [60.621104363000086, 69.11640045800004],
              [60.59131920700008, 69.13279857000003],
              [60.58228600400008, 69.14964427300004],
              [60.58326256600009, 69.16665273600006],
              [60.588226759000065, 69.18471914300005],
              [60.59327233200008, 69.24103424700007],
              [60.58969160200007, 69.25641510600008],
              [60.57764733200008, 69.27680084800005],
              [60.562836134000065, 69.29523346600007],
              [60.54249108200008, 69.31557851800005],
              [60.51921634200005, 69.33209870000007],
              [60.482758009000065, 69.34198639500005],
              [60.445648634000065, 69.35854726800005],
              [60.434336785000085, 69.36619700700004],
              [60.43189537900008, 69.37299225500004],
              [60.430674675000034, 69.39297109600005],
              [60.426768425000034, 69.40033600500004],
              [60.41423587300005, 69.40790436400005],
              [60.32447350400008, 69.44660065300008],
              [60.31137129000007, 69.45433177300004],
              [60.26295006600009, 69.49921295800004],
              [60.22055097700007, 69.52505117400005],
              [60.21461022200003, 69.53070709800005],
              [60.21452884200005, 69.53668854400007],
              [60.219411655000044, 69.54230377800008],
              [60.22201582100007, 69.54808177300004],
              [60.214854363000086, 69.55459219000005],
              [60.195648634000065, 69.56126536700003],
              [60.15772545700008, 69.56964752800008],
              [60.13884524800005, 69.57786692900004],
              [60.15577233200008, 69.60126373900005],
              [60.15870201900003, 69.61367422100005],
              [60.15259850400008, 69.62628815300008],
              [60.185557488000086, 69.65045807500007],
              [60.23259524800005, 69.66478099200003],
              [60.65357506600009, 69.67275625200006],
              [60.66732832100007, 69.67816803600005],
              [60.667002800000034, 69.69452545800004],
              [60.655284050000034, 69.70677317900004],
              [60.63990319100009, 69.71637604400007],
              [60.633474155000044, 69.72492096600007],
              [60.64795983200008, 69.73419830900008],
              [60.66781660200007, 69.73460521000004],
              [60.68962649800005, 69.72980377800008],
              [60.70883222700007, 69.72939687700006],
              [60.721690300000034, 69.74298737200007],
              [60.70329837300005, 69.74896881700005],
              [60.68995201900003, 69.76398346600007],
              [60.68409264400003, 69.78388092700004],
              [60.687510613000086, 69.80438873900005],
              [60.70557701900003, 69.82367584800005],
              [60.73601321700005, 69.83905670800004],
              [60.770274285000085, 69.84910716400003],
              [60.92660566500007, 69.86749909100007],
              [60.97022545700008, 69.86127350500004],
              [61.02466881600003, 69.84634023600006],
              [61.04379316500007, 69.84540436400005],
              [61.05836022200003, 69.84935130400004],
              [61.09066816500007, 69.86408112200007],
              [61.10523522200003, 69.86587148600006],
              [61.115977410000085, 69.86131419500003],
              [61.13005618600005, 69.84564850500004],
              [61.139414910000085, 69.83856842700004],
              [61.15870201900003, 69.83291250200006],
              [61.30193118600005, 69.82542552300004],
              [61.33676191500007, 69.81586334800005],
              [61.37240644600007, 69.80101146000004],
              [61.40935306100005, 69.79124583500004],
              [61.770518425000034, 69.76203034100007],
              [62.161143425000034, 69.74616120000007],
              [62.631195509000065, 69.74213288000004],
              [62.92265872500005, 69.71259186400005],
              [63.21412194100003, 69.68305084800005],
              [63.410492384000065, 69.67129140800006],
              [63.57943769600007, 69.63865794500003],
              [63.823252800000034, 69.59162018400008],
              [64.12761478000004, 69.55011627800008],
              [64.37891686300009, 69.48432038000004],
              [64.54802493600005, 69.45172760600008],
              [64.72445722700007, 69.38328685100004],
              [64.91407311300009, 69.33698151200008],
              [65.00440514400003, 69.30414459800005],
              [64.98894290500004, 69.29010651200008],
              [64.96241295700008, 69.28310781500005],
              [64.93327884200005, 69.28148021000004],
              [64.90886478000004, 69.28367747600004],
              [64.85580488400007, 69.29539622600004],
              [64.83106530000003, 69.29441966400003],
              [64.83375084700003, 69.27680084800005],
              [64.81283613400007, 69.26626211100006],
              [64.79265384200005, 69.25238678600005],
              [64.78598066500007, 69.23720937700006],
              [64.80640709700003, 69.22215403900003],
              [64.78467858200008, 69.20404694200005],
              [64.76563561300009, 69.18309153900003],
              [64.76172936300009, 69.16299062700006],
              [64.78589928500008, 69.14712148600006],
              [64.80941816500007, 69.14671458500004],
              [64.83228600400008, 69.15595123900005],
              [64.87476647200003, 69.18060944200005],
              [64.91211998800009, 69.18988678600005],
              [64.93181399800005, 69.19708893400008],
              [64.94288170700008, 69.20856354400007],
              [64.94109134200005, 69.21995677300004],
              [64.93165123800009, 69.22996653900003],
              [64.92123457100007, 69.23777903900003],
              [64.91627037900008, 69.24266185100004],
              [64.92318769600007, 69.26068756700005],
              [64.94109134200005, 69.26797109600005],
              [65.02955162900008, 69.27187734600005],
              [65.06820722700007, 69.26805247600004],
              [65.41944420700008, 69.17706940300008],
              [65.81723066500007, 69.14264557500007],
              [65.86491946700005, 69.13251373900005],
              [65.90259850400008, 69.11298248900005],
              [65.88298587300005, 69.10578034100007],
              [65.75367272200003, 69.10663483300004],
              [65.73422285200007, 69.11269765800006],
              [65.74488366000008, 69.12665436400005],
              [65.72706139400003, 69.12653229400007],
              [65.69385826900003, 69.12030670800004],
              [65.67660566500007, 69.11920807500007],
              [65.66521243600005, 69.12238190300008],
              [65.65552819100003, 69.12775299700007],
              [65.64616946700005, 69.13060130400004],
              [65.63502037900008, 69.12665436400005],
              [65.67497806100005, 69.09284088700008],
              [65.68970787900008, 69.08502838700008],
              [65.71615644600007, 69.07977936400005],
              [65.77344811300009, 69.07819245000007],
              [65.85059655000003, 69.06427643400008],
              [65.95386803500008, 69.05809153900003],
              [66.03142337300005, 69.04376862200007],
              [66.08716881600003, 69.04181549700007],
              [66.11426842500003, 69.03725820500006],
              [66.17530358200008, 69.01422760600008],
              [66.23373457100007, 69.00128815300008],
              [66.32878665500004, 68.96381256700005],
              [66.37548954100004, 68.95474121400008],
              [66.67847741000008, 68.89594147300005],
              [66.99057050900007, 68.87628815300008],
              [67.09009850400008, 68.85565827000005],
              [67.12907962300005, 68.83860911700003],
              [67.07211347700007, 68.82868073100008],
              [67.04615319100003, 68.81830475500004],
              [67.03972415500004, 68.79706452000005],
              [67.05551191500007, 68.78143952000005],
              [67.14332116000008, 68.75604889500005],
              [67.16228274800005, 68.73944733300004],
              [67.17823326900003, 68.72162506700005],
              [67.19629967500003, 68.70734284100007],
              [67.22120201900003, 68.70140208500004],
              [67.29281660200007, 68.70164622600004],
              [67.33033287900008, 68.69676341400003],
              [67.35865319100003, 68.68406810100004],
              [67.38103274800005, 68.67031484600005],
              [67.58350670700008, 68.60333893400008],
              [67.80811608200008, 68.50287506700005],
              [67.70508873800009, 68.51585521000004],
              [67.79322350400008, 68.47858307500007],
              [67.81836998800009, 68.47186920800004],
              [67.87712649800005, 68.47361888200004],
              [67.90463300900007, 68.47036367400005],
              [68.06153405000003, 68.43183014500005],
              [68.11255944100003, 68.42772044500003],
              [68.13493899800005, 68.42340729400007],
              [68.15015709700003, 68.41299062700006],
              [68.16285241000008, 68.40033600500004],
              [68.17741946700005, 68.38922760600008],
              [68.24634850400008, 68.35512929900005],
              [68.25863691500007, 68.33388906500005],
              [68.20313561300009, 68.29474518400008],
              [68.20533287900008, 68.26947663000004],
              [68.19800866000008, 68.26316966400003],
              [68.19263756600003, 68.25625234600005],
              [68.18425540500004, 68.24213288000004],
              [68.23568769600007, 68.24909088700008],
              [68.26254316500007, 68.24909088700008],
              [68.28044681100005, 68.23590729400007],
              [68.28223717500003, 68.22418854400007],
              [68.27808678500008, 68.21344635600008],
              [68.27003014400003, 68.20538971600007],
              [68.25993899800005, 68.20115794500003],
              [68.28809655000003, 68.18829987200007],
              [68.32056725400008, 68.19741445500006],
              [68.38282311300009, 68.22846100500004],
              [68.44809004000007, 68.23798248900005],
              [68.48064212300005, 68.24949778900003],
              [68.48585045700008, 68.26947663000004],
              [68.54786217500003, 68.30418528900003],
              [68.55795332100007, 68.30597565300008],
              [68.59571373800009, 68.31785716400003],
              [68.60914147200003, 68.31899648600006],
              [68.65088951900003, 68.31785716400003],
              [68.62305748800009, 68.32404205900008],
              [68.58936608200008, 68.33234284100007],
              [68.56478925900007, 68.34979889500005],
              [68.56104576900003, 68.37250397300005],
              [68.57032311300009, 68.38287995000007],
              [68.61557050900007, 68.40599192900004],
              [68.64014733200008, 68.42475006700005],
              [68.66049238400007, 68.44415924700007],
              [68.69060306100005, 68.46702708500004],
              [68.76002037900008, 68.50438060100004],
              [68.92351321700005, 68.63727448100008],
              [68.93848717500003, 68.65668366100005],
              [68.94459069100003, 68.67755768400008],
              [68.95215905000003, 68.69440338700008],
              [68.98536217500003, 68.72736237200007],
              [68.99293053500008, 68.74555084800005],
              [69.00977623800009, 68.76658763200004],
              [69.01238040500004, 68.77260976800005],
              [69.01042728000004, 68.77680084800005],
              [69.00733483200008, 68.78021881700005],
              [69.00660241000008, 68.78400299700007],
              [69.01295006600003, 68.80646393400008],
              [69.01970462300005, 68.81439850500004],
              [69.06934655000003, 68.82306549700007],
              [69.08562259200005, 68.83738841400003],
              [69.09473717500003, 68.85712311400005],
              [69.10906009200005, 68.87897370000007],
              [68.99976647200003, 68.87897370000007],
              [68.96176191500007, 68.88580963700008],
              [68.94605553500008, 68.89325592700004],
              [68.95142662900008, 68.90322500200006],
              [68.99398847700007, 68.91535065300008],
              [69.08757571700005, 68.91644928600005],
              [69.13070722700007, 68.92739492400005],
              [69.06128991000008, 68.92739492400005],
              [69.09742272200003, 68.94106679900005],
              [69.17994225400008, 68.95209381700005],
              [69.21892337300005, 68.96214427300004],
              [69.01286868600005, 68.94790273600006],
              [69.02711022200003, 68.96214427300004],
              [68.99878991000008, 68.96491120000007],
              [68.91325931100005, 68.95404694200005],
              [68.78842207100007, 68.91567617400005],
              [68.68604576900003, 68.91844310100004],
              [68.48715254000007, 68.97016022300005],
              [68.45801842500003, 68.98456452000005],
              [68.43775475400008, 69.00340403900003],
              [68.39991295700008, 69.04718659100007],
              [68.37566165500004, 69.06769440300008],
              [68.12533613400007, 69.22235748900005],
              [68.05974368600005, 69.27753327000005],
              [68.02621504000007, 69.31940338700008],
              [68.01978600400008, 69.33515045800004],
              [68.03972415500004, 69.35944245000007],
              [68.07846113400007, 69.37824127800008],
              [68.10499108200008, 69.39704010600008],
              [68.08790123800009, 69.42084381700005],
              [68.09546959700003, 69.42829010600008],
              [68.08814537900008, 69.44179922100005],
              [68.09066816500007, 69.45465729400007],
              [68.09742272200003, 69.46796295800004],
              [68.10222415500004, 69.48224518400008],
              [68.10230553500008, 69.49603913000004],
              [68.09685306100005, 69.51508209800005],
              [68.09546959700003, 69.52700429900005],
              [68.09913170700008, 69.53473541900007],
              [68.10547936300009, 69.54262929900005],
              [68.10661868600005, 69.54873281500005],
              [68.09506269600007, 69.55117422100005],
              [68.06177819100003, 69.55369700700004],
              [68.04558353000004, 69.55109284100007],
              [68.03060957100007, 69.54059479400007],
              [68.01433353000004, 69.52167389500005],
              [68.01400800900007, 69.51422760600008],
              [68.02442467500003, 69.50731028900003],
              [68.04021243600005, 69.48969147300005],
              [67.96908613400007, 69.49127838700008],
              [67.82439212300005, 69.51072825700004],
              [67.68336022200003, 69.56028880400004],
              [67.62907962300005, 69.59076569200005],
              [67.56023196700005, 69.59918854400007],
              [67.45883222700007, 69.62714264500005],
              [67.31495201900003, 69.63035716400003],
              [67.10181725400008, 69.69277578300006],
              [67.01726321700005, 69.70307038000004],
              [66.97136478000004, 69.68773021000004],
              [66.98121178500008, 69.68561432500007],
              [66.99244225400008, 69.68081289300005],
              [67.00163821700005, 69.67365143400008],
              [67.00554446700005, 69.66445547100005],
              [66.99968509200005, 69.65322500200006],
              [66.98601321700005, 69.64813873900005],
              [66.93409264400003, 69.64012278900003],
              [66.86866295700008, 69.63983795800004],
              [66.85523522200003, 69.63686758000006],
              [66.86817467500003, 69.61273834800005],
              [66.95769290500004, 69.53685130400004],
              [66.92888431100005, 69.52757396000004],
              [66.88689212300005, 69.53725820500006],
              [66.81373131600003, 69.57168203300006],
              [66.79574629000007, 69.58616771000004],
              [66.78679446700005, 69.60285065300008],
              [66.78435306100005, 69.62274811400005],
              [66.78581790500004, 69.64671458500004],
              [66.79428144600007, 69.68813711100006],
              [66.79517662900008, 69.71137116100005],
              [66.78638756600003, 69.72557200700004],
              [66.77100670700008, 69.74066803600005],
              [66.76880944100003, 69.76162344000005],
              [66.77613366000008, 69.78335195500006],
              [66.79965254000007, 69.81574127800008],
              [66.87419681100005, 69.99591705900008],
              [66.88477623800009, 70.01288483300004],
              [66.90308678500008, 70.03034088700008],
              [66.92058353000004, 70.04242584800005],
              [66.93816165500004, 70.05097077000005],
              [66.95704186300009, 70.05605703300006],
              [66.97820071700005, 70.05760325700004],
              [66.98715254000007, 70.05434804900005],
              [66.99773196700005, 70.03733958500004],
              [67.00554446700005, 70.03034088700008],
              [66.98121178500008, 70.01601797100005],
              [66.97055097700007, 70.00800202000005],
              [66.96509850400008, 69.99624258000006],
              [66.98503665500004, 69.96954987200007],
              [67.00407962300005, 69.96320221600007],
              [67.02027428500008, 69.96458567900004],
              [67.05396569100003, 69.97573476800005],
              [67.14332116000008, 69.98314036700003],
              [67.19703209700003, 69.99579498900005],
              [67.25171959700003, 70.02122630400004],
              [67.29835045700008, 70.05849844000005],
              [67.32764733200008, 70.10602448100008],
              [67.30990644600007, 70.10492584800005],
              [67.29737389400003, 70.09926992400005],
              [67.28785241000008, 70.09699127800008],
              [67.27914472700007, 70.10602448100008],
              [67.27808678500008, 70.11395905200004],
              [67.28093509200005, 70.12164948100008],
              [67.28467858200008, 70.12929922100005],
              [67.28663170700008, 70.13715241100005],
              [67.28598066500007, 70.15387604400007],
              [67.28207441500007, 70.17308177300004],
              [67.27173912900008, 70.18886953300006],
              [67.25196373800009, 70.19546133000006],
              [67.24740644600007, 70.18500397300005],
              [67.25904381600003, 70.16327545800004],
              [67.26490319100003, 70.14508698100008],
              [67.24350019600007, 70.14524974200003],
              [67.16456139400003, 70.17230866100005],
              [67.12549889400003, 70.20038483300004],
              [67.10523522200003, 70.20937734600005],
              [67.09424889400003, 70.22089264500005],
              [67.10181725400008, 70.24384186400005],
              [67.11605879000007, 70.26032135600008],
              [67.15056399800005, 70.28742096600007],
              [67.16382897200003, 70.30467357000003],
              [67.19320722700007, 70.38157786700003],
              [67.21924889400003, 70.40932851800005],
              [67.26628665500004, 70.41453685100004],
              [67.25261478000004, 70.43406810100004],
              [67.25505618600005, 70.45624420800004],
              [67.26978600400008, 70.47308991100005],
              [67.29281660200007, 70.47662995000007],
              [67.27654056100005, 70.48118724200003],
              [67.22494550900007, 70.50702545800004],
              [67.21509850400008, 70.52391185100004],
              [67.22055097700007, 70.54751211100006],
              [67.27662194100003, 70.65961334800005],
              [67.28980553500008, 70.67804596600007],
              [67.32699629000007, 70.71694570500006],
              [67.33643639400003, 70.73550039300005],
              [67.33448326900003, 70.75779857000003],
              [67.31788170700008, 70.78408437700006],
              [67.29004967500003, 70.80805084800005],
              [67.25700931100005, 70.82558828300006],
              [67.13843834700003, 70.84178294500003],
              [67.10922285200007, 70.83974844000005],
              [67.04037519600007, 70.81574127800008],
              [66.79639733200008, 70.79132721600007],
              [66.71998131600003, 70.76959870000007],
              [66.68873131600003, 70.76984284100007],
              [66.66773522200003, 70.82794830900008],
              [66.64869225400008, 70.84442780200004],
              [66.62623131600003, 70.85936107000003],
              [66.60824629000007, 70.88068268400008],
              [66.62525475400008, 70.89838288000004],
              [66.65023847700007, 70.91071198100008],
              [66.75098717500003, 70.94721100500004],
              [66.77133222700007, 70.95962148600006],
              [66.82341556100005, 71.00063711100006],
              [66.83318118600005, 71.01308828300006],
              [66.84107506600003, 71.03156159100007],
              [66.83936608200008, 71.03851959800005],
              [66.83285566500007, 71.04140859600005],
              [66.83057701900003, 71.04633209800005],
              [66.84107506600003, 71.05947500200006],
              [66.85157311300009, 71.06565989800004],
              [66.87745201900003, 71.07233307500007],
              [66.88949629000007, 71.07868073100008],
              [66.87061608200008, 71.09125397300005],
              [66.84506269600007, 71.09955475500004],
              [66.81950931100005, 71.10097890800006],
              [66.80005944100003, 71.09296295800004],
              [66.80551191500007, 71.07518138200004],
              [66.78565514400003, 71.06712474200003],
              [66.75749759200005, 71.06171295800004],
              [66.73796634200005, 71.05198802300004],
              [66.76270592500003, 71.02903880400004],
              [66.77222741000008, 71.02411530200004],
              [66.73991946700005, 71.00702545800004],
              [66.69027754000007, 71.00136953300006],
              [66.64275149800005, 71.00885651200008],
              [66.61573326900003, 71.03156159100007],
              [66.62045332100007, 71.05784739800004],
              [66.64551842500003, 71.07977936400005],
              [66.81128991000008, 71.16120026200008],
              [66.82740319100003, 71.18545156500005],
              [66.83236738400007, 71.20648834800005],
              [66.84506269600007, 71.22614166900007],
              [66.90040123800009, 71.28558991100005],
              [66.91211998800009, 71.29474518400008],
              [66.92701256600003, 71.29840729400007],
              [67.03345787900008, 71.29840729400007],
              [67.16960696700005, 71.33364492400005],
              [67.30925540500004, 71.35122304900005],
              [67.49390709700003, 71.40326569200005],
              [67.58838951900003, 71.41510651200008],
              [67.58594811300009, 71.43162669500003],
              [67.60499108200008, 71.44196198100008],
              [67.67945397200003, 71.45160553600005],
              [67.74057050900007, 71.46800364800004],
              [67.84685306100005, 71.51093170800004],
              [67.87574303500008, 71.51752350500004],
              [67.92676842500003, 71.52155182500007],
              [67.94727623800009, 71.52757396000004],
              [68.01124108200008, 71.57160065300008],
              [68.25505618600005, 71.68829987200007],
              [68.30543053500008, 71.69611237200007],
              [68.34880618600005, 71.67519765800006],
              [68.33513431100005, 71.68642812700006],
              [68.32048587300005, 71.69525788000004],
              [68.30974368600005, 71.70441315300008],
              [68.30779056100005, 71.71674225500004],
              [68.31609134200005, 71.72622304900005],
              [68.44581139400003, 71.81659577000005],
              [68.46851647200003, 71.82599518400008],
              [68.47885175900007, 71.83616771000004],
              [68.50212649800005, 71.88495514500005],
              [68.51319420700008, 71.90167877800008],
              [68.52898196700005, 71.91054922100005],
              [68.54444420700008, 71.91571686400005],
              [68.55632571700005, 71.92328522300005],
              [68.56104576900003, 71.93927643400008],
              [68.56104576900003, 71.97626373900005],
              [68.58073978000004, 71.99774811400005],
              [68.64372806100005, 72.03318919500003],
              [68.65707441500007, 72.05565013200004],
              [68.65577233200008, 72.08486562700006],
              [68.65707441500007, 72.09349192900004],
              [68.66277103000004, 72.10346100500004],
              [68.66944420700008, 72.11029694200005],
              [68.67514082100007, 72.11810944200005],
              [68.67774498800009, 72.13108958500004],
              [68.68458092500003, 72.15184153900003],
              [68.73292076900003, 72.20962148600006],
              [68.74431399800005, 72.24945709800005],
              [68.75391686300009, 72.26715729400007],
              [68.77377363400007, 72.27789948100008],
              [68.76791425900007, 72.29287344000005],
              [68.78248131600003, 72.30703359600005],
              [68.82162519600007, 72.32632070500006],
              [68.81617272200003, 72.33828359600005],
              [68.81714928500008, 72.35065338700008],
              [68.82203209700003, 72.36277903900003],
              [68.82911217500003, 72.37409088700008],
              [68.82496178500008, 72.38825104400007],
              [68.83082116000008, 72.40460846600007],
              [68.84961998800009, 72.43618398600006],
              [68.85084069100003, 72.44367096600007],
              [68.84945722700007, 72.45970286700003],
              [68.85230553500008, 72.46686432500007],
              [68.86605879000007, 72.47577545800004],
              [68.90088951900003, 72.47907135600008],
              [68.91724694100003, 72.48395416900007],
              [68.88575280000003, 72.50633372600004],
              [68.87240644600007, 72.51870351800005],
              [68.86939537900008, 72.53237539300005],
              [68.88021894600007, 72.54376862200007],
              [68.89877363400007, 72.55345286700003],
              [68.91635175900007, 72.56537506700005],
              [68.93043053500008, 72.59804922100005],
              [68.95875084700003, 72.62274811400005],
              [68.96501712300005, 72.63849518400008],
              [68.97681725400008, 72.65570709800005],
              [69.00391686300009, 72.65973541900007],
              [69.03394616000008, 72.65900299700007],
              [69.05445397200003, 72.66205475500004],
              [69.03272545700008, 72.66974518400008],
              [68.99341881600003, 72.67519765800006],
              [68.97559655000003, 72.68622467700004],
              [68.97575931100005, 72.69599030200004],
              [68.98910566500007, 72.70587799700007],
              [69.18531334700003, 72.77875397300005],
              [69.23178144600007, 72.80451080900008],
              [69.27662194100003, 72.84076569200005],
              [69.30502363400007, 72.88369375200006],
              [69.30201256600003, 72.92963288000004],
              [69.35377037900008, 72.95258209800005],
              [69.40845787900008, 72.96735260600008],
              [69.46534264400003, 72.97516510600008],
              [69.77393639400003, 72.97329336100006],
              [69.79493248800009, 72.96369049700007],
              [69.79810631600003, 72.94367096600007],
              [69.77393639400003, 72.93598053600005],
              [69.57227623800009, 72.92007070500006],
              [69.55665123800009, 72.91376373900005],
              [69.55128014400003, 72.90326569200005],
              [69.56153405000003, 72.88861725500004],
              [69.58822675900007, 72.87848541900007],
              [69.88754316500007, 72.88149648600006],
              [70.17212975400008, 72.90013255400004],
              [70.65544681100005, 72.88934967700004],
              [71.03296959700003, 72.90680573100008],
              [71.26742597700007, 72.89549388200004],
              [71.35173587300005, 72.90949127800008],
              [71.44955488400007, 72.90843333500004],
              [71.52979576900003, 72.91681549700007],
              [71.55583743600005, 72.90843333500004],
              [71.56324303500008, 72.91596100500004],
              [71.67448978000004, 72.88544342700004],
              [71.98324629000007, 72.84808991100005],
              [72.00831139400003, 72.83397044500003],
              [71.98462975400008, 72.83185455900008],
              [71.93783613400007, 72.82196686400005],
              [71.91325931100005, 72.81976959800005],
              [71.86345462300005, 72.82168203300006],
              [71.83855228000004, 72.81976959800005],
              [71.81657962300005, 72.81232330900008],
              [71.85075931100005, 72.81273021000004],
              [71.86963951900003, 72.81000397300005],
              [71.87794030000003, 72.80231354400007],
              [71.88648522200003, 72.79661692900004],
              [72.13103274800005, 72.83161041900007],
              [72.29737389400003, 72.79425690300008],
              [72.49610436300003, 72.78766510600008],
              [72.66146894600007, 72.74013906500005],
              [72.83692467500003, 72.70990631700005],
              [72.72144616000008, 72.70302969000005],
              [72.73715254000007, 72.68048737200007],
              [72.74195397200003, 72.67572663000004],
              [72.75847415500004, 72.67206452000005],
              [72.78191165500004, 72.66998932500007],
              [72.80225670700008, 72.66567617400005],
              [72.80958092500003, 72.65521881700005],
              [72.79200280000003, 72.64345937700006],
              [72.75847415500004, 72.63178131700005],
              [72.73072350400008, 72.61737702000005],
              [72.73145592500003, 72.59723541900007],
              [72.76286868600005, 72.55902741100005],
              [72.78150475400008, 72.54401276200008],
              [72.84498131600003, 72.52041250200006],
              [72.84669030000003, 72.51235586100006],
              [72.82732181100005, 72.50128815300008],
              [72.79932701900003, 72.48053620000007],
              [72.79542076900003, 72.46552155200004],
              [72.79851321700005, 72.41327545800004],
              [72.80274498800003, 72.39516836100006],
              [72.82984459700003, 72.35008372600004],
              [72.85035241000008, 72.32412344000005],
              [72.86833743600005, 72.31264883000006],
              [72.88396243600005, 72.30719635600008],
              [72.88314863400007, 72.29486725500004],
              [72.87427819100003, 72.28107330900008],
              [72.86491946700005, 72.27167389500005],
              [72.84782962300005, 72.26162344000005],
              [72.80762780000003, 72.24555084800005],
              [72.76441491000008, 72.22247955900008],
              [72.74268639400003, 72.20604075700004],
              [72.72730553500008, 72.18549225500004],
              [72.72144616000008, 72.15867747600004],
              [72.72413170700008, 72.13324616100005],
              [72.72055097700007, 72.12592194200005],
              [72.70777428500008, 72.11395905200004],
              [72.69044030000003, 72.10252513200004],
              [72.59636478000004, 72.06338125200006],
              [72.57699629000007, 72.04450104400007],
              [72.56674238400007, 72.02317942900004],
              [72.55974368600005, 71.97870514500005],
              [72.54948978000004, 71.95709870000007],
              [72.53589928500008, 71.93768952000005],
              [72.52222741000008, 71.92226797100005],
              [72.48454837300005, 71.89809804900005],
              [72.39527428500008, 71.87889232000003],
              [72.35084069100003, 71.86420319200005],
              [72.32016035200007, 71.82318756700005],
              [72.33952884200005, 71.77741120000007],
              [72.36304772200003, 71.73607005400004],
              [72.34498131600003, 71.70815664300005],
              [72.26042728000004, 71.69476959800005],
              [72.23389733200008, 71.68537018400008],
              [72.22820071700005, 71.67829010600008],
              [72.22641035200007, 71.66738515800006],
              [72.22730553500008, 71.64447663000004],
              [72.20932050900007, 71.61473216400003],
              [72.16732832100007, 71.59886302300004],
              [72.02865644600007, 71.57217031500005],
              [72.01498457100007, 71.57282135600008],
              [71.98519941500007, 71.57908763200004],
              [71.97413170700008, 71.57953522300005],
              [71.95899498800003, 71.57465241100005],
              [71.92465254000007, 71.55866120000007],
              [71.83814537900008, 71.53241608300004],
              [71.81324303500008, 71.51251862200007],
              [71.80339603000004, 71.48029205900008],
              [71.81381269600007, 71.45355866100005],
              [71.83912194100003, 71.43121979400007],
              [71.87077884200005, 71.41400788000004],
              [71.91195722700007, 71.39704010600008],
              [72.10572350400008, 71.29035065300008],
              [72.56999759200005, 71.16058991100005],
              [72.63648522200003, 71.13165924700007],
              [72.67074629000007, 71.10895416900007],
              [72.67644290500004, 71.08954498900005],
              [72.63355553500008, 71.05247630400004],
              [72.62289472700007, 71.03294505400004],
              [72.63209069100003, 71.01105377800008],
              [72.64820397200003, 70.99957916900007],
              [72.68653405000003, 70.98468659100007],
              [72.70394941500007, 70.97260163000004],
              [72.70866946700005, 70.96588776200008],
              [72.70923912900008, 70.96067942900004],
              [72.70915774800005, 70.95636627800008],
              [72.71078535200007, 70.95270416900007],
              [72.71802819100003, 70.94757721600007],
              [72.73178144600007, 70.94269440300008],
              [72.76840254000007, 70.91986725500004],
              [72.80144290500004, 70.90534088700008],
              [72.82740319100003, 70.88764069200005],
              [72.83692467500003, 70.85960521000004],
              [72.83228600400008, 70.83722565300008],
              [72.82203209700003, 70.81366608300004],
              [72.80836022200003, 70.79165273600006],
              [72.79249108200008, 70.77391185100004],
              [72.78126061300003, 70.75649648600006],
              [72.77955162900008, 70.73761627800008],
              [72.78003991000008, 70.71723053600005],
              [72.77540123800003, 70.69513580900008],
              [72.75489342500003, 70.67747630400004],
              [72.68824303500008, 70.63442617400005],
              [72.68327884200005, 70.61660390800006],
              [72.68490644600007, 70.61261627800008],
              [72.68580162900008, 70.60716380400004],
              [72.68783613400007, 70.60040924700007],
              [72.69353274800005, 70.59271881700005],
              [72.70093834700003, 70.58685944200005],
              [72.70736738400007, 70.58417389500005],
              [72.71404056100005, 70.58234284100007],
              [72.72144616000008, 70.57904694200005],
              [72.75098717500003, 70.56199778900003],
              [72.76587975400008, 70.55072663000004],
              [72.77540123800003, 70.53807200700004],
              [72.77613366000008, 70.51422760600008],
              [72.75847415500004, 70.47231679900005],
              [72.77133222700007, 70.42523834800005],
              [72.73910566500007, 70.41181061400005],
              [72.65398196700005, 70.39911530200004],
              [72.61247806100005, 70.38434479400007],
              [72.45948326900003, 70.30442942900004],
              [72.43555748800003, 70.28587474200003],
              [72.43409264400003, 70.26569245000007],
              [72.46697024800005, 70.24017975500004],
              [72.59913170700008, 70.19330475500004],
              [72.62159264400003, 70.16168854400007],
              [72.61198978000004, 70.14476146000004],
              [72.57740319100003, 70.11286041900007],
              [72.57601972700007, 70.10907623900005],
              [72.57642662900008, 70.09992096600007],
              [72.57374108200008, 70.09552643400008],
              [72.56666100400008, 70.09113190300008],
              [72.54273522200003, 70.08218008000006],
              [72.51384524800005, 70.06688060100004],
              [72.50171959700003, 70.05825429900005],
              [72.49122155000003, 70.04775625200006],
              [72.49195397200003, 70.04120514500005],
              [72.50025475400008, 70.03367747600004],
              [72.51880944100003, 70.02045319200005],
              [72.52214603000004, 70.01239655200004],
              [72.52173912900008, 69.99396393400008],
              [72.52523847700007, 69.98627350500004],
              [72.54704837300005, 69.96849192900004],
              [72.61841881600003, 69.92792389500005],
              [72.64877363400007, 69.90485260600008],
              [72.67790774800005, 69.87299225500004],
              [72.69166100400008, 69.83685944200005],
              [72.67644290500004, 69.80101146000004],
              [72.66570071700005, 69.78457265800006],
              [72.65870201900003, 69.76618073100008],
              [72.64958743600005, 69.74811432500007],
              [72.63168379000007, 69.73240794500003],
              [72.58090254000007, 69.70587799700007],
              [72.55958092500003, 69.68862539300005],
              [72.56373131600003, 69.67405833500004],
              [72.55323326900003, 69.66388580900008],
              [72.51832116000008, 69.65448639500005],
              [72.50171959700003, 69.64671458500004],
              [72.53541100400008, 69.62921784100007],
              [72.56185957100007, 69.60407135600008],
              [72.62728925900007, 69.51129791900007],
              [72.63209069100003, 69.49591705900008],
              [72.63331139400003, 69.45429108300004],
              [72.63835696700005, 69.44135163000004],
              [72.62110436300003, 69.43178945500006],
              [72.60580488400007, 69.42576732000003],
              [72.58985436300003, 69.42251211100006],
              [72.50513756600003, 69.42121002800008],
              [72.48804772200003, 69.41400788000004],
              [72.52173912900008, 69.39720286700003],
              [72.56999759200005, 69.38068268400008],
              [72.61329186300003, 69.35936107000003],
              [72.63209069100003, 69.32831452000005],
              [72.63721764400003, 69.30975983300004],
              [72.64576256600003, 69.30048248900005],
              [72.64771569100003, 69.29222239800004],
              [72.63209069100003, 69.27680084800005],
              [72.60857181100005, 69.26410553600005],
              [72.55372155000003, 69.24762604400007],
              [72.52849368600005, 69.23525625200006],
              [72.50652103000004, 69.21832916900007],
              [72.48926842500003, 69.19916413000004],
              [72.47787519600007, 69.17694733300004],
              [72.47380618600005, 69.15053945500006],
              [72.48015384200005, 69.12995026200008],
              [72.52849368600005, 69.07200755400004],
              [72.53516686300003, 69.05170319200005],
              [72.54346764400003, 69.00324127800008],
              [72.55290774800005, 68.98541901200008],
              [72.56120853000004, 68.97443268400008],
              [72.57105553500008, 68.95115794500003],
              [72.57740319100003, 68.94037506700005],
              [72.58708743600005, 68.93138255400004],
              [72.69239342500003, 68.86351146000004],
              [72.85181725400008, 68.79775625200006],
              [73.07455488400007, 68.74730052300004],
              [73.53907311300003, 68.58100006700005],
              [73.61215254000007, 68.53701406500005],
              [73.63461347700007, 68.51703522300005],
              [73.64437910200007, 68.50189850500004],
              [73.64673912900008, 68.48444245000007],
              [73.64625084700003, 68.45783112200007],
              [73.63941491000008, 68.44375234600005],
              [73.62338300900007, 68.43423086100006],
              [73.60499108200008, 68.43219635600008],
              [73.59099368600005, 68.44082265800006],
              [73.58961022200003, 68.45237864800004],
              [73.59538821700005, 68.46417877800008],
              [73.60238691500007, 68.47455475500004],
              [73.60466556100005, 68.48236725500004],
              [73.57886803500008, 68.49335358300004],
              [73.53370201900003, 68.48151276200008],
              [73.45386803500008, 68.44415924700007],
              [73.43620853000004, 68.42568594000005],
              [73.41700280000003, 68.37579987200007],
              [73.39771569100003, 68.36050039300005],
              [73.31788170700008, 68.32811107000003],
              [73.16651451900003, 68.24583567900004],
              [73.10857181100005, 68.22638580900008],
              [73.09083092500003, 68.21426015800006],
              [73.12728925900007, 68.18353913000004],
              [73.13705488400007, 68.16624583500004],
              [73.13168379000007, 68.14594147300005],
              [73.11793053500008, 68.13580963700008],
              [73.08106530000003, 68.11977773600006],
              [73.07154381600003, 68.10496653900003],
              [73.07276451900003, 68.09039948100008],
              [73.08106530000003, 68.08226146000004],
              [73.10499108200008, 68.07086823100008],
              [73.19044030000003, 67.99201080900008],
              [73.20215905000003, 67.97516510600008],
              [73.20443769600007, 67.95722077000005],
              [73.20069420700008, 67.91376373900005],
              [73.20460045700008, 67.86587148600006],
              [73.19548587300005, 67.84951406500005],
              [73.16651451900003, 67.83808014500005],
              [73.09473717500003, 67.83014557500007],
              [73.07154381600003, 67.81557851800005],
              [73.08399498800003, 67.78286367400005],
              [73.11036217500003, 67.76337311400005],
              [73.13795006600003, 67.74896881700005],
              [73.15137780000003, 67.73187897300005],
              [73.13542728000004, 67.70400625200006],
              [73.11426842500003, 67.69037506700005],
              [73.10206139400003, 67.69635651200008],
              [73.09359785200007, 67.71059804900005],
              [73.08399498800003, 67.72199127800008],
              [73.06218509200005, 67.72874583500004],
              [73.03939863400007, 67.72858307500007],
              [73.01677493600005, 67.72329336100006],
              [72.97820071700005, 67.70709870000007],
              [72.90902754000007, 67.69061920800004],
              [72.89234459700003, 67.68455638200004],
              [72.88575280000003, 67.67462799700007],
              [72.89893639400003, 67.65936920800004],
              [72.85206139400003, 67.63532135600008],
              [72.79086347700007, 67.62567780200004],
              [72.61166425900007, 67.62588125200006],
              [72.58130944100003, 67.62018463700008],
              [72.55632571700005, 67.60468170800004],
              [72.54704837300005, 67.59145742400005],
              [72.54428144600007, 67.57982005400004],
              [72.54428144600007, 67.56879303600005],
              [72.54273522200003, 67.55687083500004],
              [72.55274498800003, 67.53717682500007],
              [72.53288821700005, 67.52008698100008],
              [72.50228925900007, 67.50682200700004],
              [72.40593509200005, 67.47996653900003],
              [72.39185631600003, 67.46747467700004],
              [72.39478600400008, 67.45758698100008],
              [72.40528405000003, 67.44794342700004],
              [72.42603600400008, 67.43402741100005],
              [72.44760175900007, 67.41327545800004],
              [72.45427493600005, 67.40062083500004],
              [72.45020592500003, 67.38898346600007],
              [72.44385826900003, 67.38125234600005],
              [72.42888431100005, 67.35639069200005],
              [72.42603600400008, 67.34772370000007],
              [72.40259850400008, 67.32807038000004],
              [72.34937584700003, 67.31549713700008],
              [72.29135175900007, 67.30963776200008],
              [72.25464928500008, 67.31049225500004],
              [72.21241295700008, 67.32827383000006],
              [72.19060306100005, 67.33331940300008],
              [72.16602623800003, 67.32758209800005],
              [72.14478600400008, 67.31842682500007],
              [72.12549889400003, 67.31329987200007],
              [72.06006920700008, 67.30874258000006],
              [72.04835045700008, 67.30288320500006],
              [72.04468834700003, 67.29214101800005],
              [72.05176842500003, 67.26752350500004],
              [72.05616295700008, 67.26679108300004],
              [72.08008873800003, 67.25934479400007],
              [72.10092207100007, 67.25556061400005],
              [72.11133873800003, 67.25153229400007],
              [72.14437910200007, 67.24262116100005],
              [72.18279056100005, 67.23725006700005],
              [72.21420332100007, 67.22378164300005],
              [72.22730553500008, 67.19037506700005],
              [72.23129316500007, 67.16917552300004],
              [72.22592207100007, 67.15949127800008],
              [72.20630944100003, 67.15281810100004],
              [72.19076582100007, 67.15428294500003],
              [72.17530358200008, 67.16156647300005],
              [72.16382897200003, 67.17218659100007],
              [72.15381920700008, 67.19611237200007],
              [72.14161217500003, 67.20457591400003],
              [72.12794030000003, 67.20677317900004],
              [72.11817467500003, 67.20062897300005],
              [72.11866295700008, 67.19090403900003],
              [72.12525475400008, 67.17812734600005],
              [72.13851972700007, 67.15965403900003],
              [71.91325931100005, 67.13231028900003],
              [71.93824303500008, 67.12457916900007],
              [71.99244225400008, 67.12421295800004],
              [72.01498457100007, 67.11127350500004],
              [71.99439537900008, 67.10700104400007],
              [72.00717207100007, 67.07684967700004],
              [71.99463951900003, 67.05597565300008],
              [71.97999108200008, 67.05044179900005],
              [71.94434655000003, 67.04340241100005],
              [71.92945397200003, 67.03302643400008],
              [71.92123457100007, 67.02533600500004],
              [71.90365644600007, 67.01292552300004],
              [71.89503014400003, 67.00507233300004],
              [71.87281334700003, 66.99127838700008],
              [71.81934655000003, 66.98305898600006],
              [71.79525800900007, 66.97406647300005],
              [71.78150475400008, 66.96010976800005],
              [71.76368248800009, 66.92890045800004],
              [71.74756920700008, 66.91608307500007],
              [71.72201582100007, 66.91526927300004],
              [71.65447024800005, 66.93964264500005],
              [71.62476647200003, 66.94611237200007],
              [71.59408613400007, 66.94139232000003],
              [71.54712975400008, 66.92194245000007],
              [71.52165774800005, 66.91941966400003],
              [71.49561608200008, 66.92682526200008],
              [71.42546634200005, 66.96784088700008],
              [71.39389082100007, 66.97528717700004],
              [71.36207116000008, 66.97418854400007],
              [71.33106530000003, 66.96625397300005],
              [71.30193118600005, 66.95355866100005],
              [71.42847741000008, 66.92694733300004],
              [71.45337975400008, 66.90574778900003],
              [71.39136803500008, 66.90574778900003],
              [71.41928144600007, 66.89496491100005],
              [71.51490319100003, 66.87848541900007],
              [71.49935957100007, 66.86737702000005],
              [71.48878014400003, 66.85724518400008],
              [71.48267662900008, 66.84495677300004],
              [71.48072350400008, 66.82697174700007],
              [71.48975670700008, 66.81037018400008],
              [71.51059004000007, 66.80060455900008],
              [71.53370201900003, 66.79279205900008],
              [71.54957116000008, 66.78229401200008],
              [71.51832116000008, 66.76308828300006],
              [71.54517662900008, 66.74819570500006],
              [71.58423912900008, 66.73163483300004],
              [71.58985436300009, 66.70722077000005],
              [71.59652754000007, 66.69721100500004],
              [71.58765709700003, 66.68984609600005],
              [71.55583743600005, 66.67987702000005],
              [71.56959069100003, 66.66364166900007],
              [71.57691491000008, 66.65875885600008],
              [71.53028405000003, 66.64545319200005],
              [71.45964603000004, 66.63873932500007],
              [71.39087975400008, 66.64203522300005],
              [71.34961998800009, 66.65875885600008],
              [71.36589603000004, 66.67487213700008],
              [71.37517337300005, 66.68138255400004],
              [71.38510175900007, 66.68671295800004],
              [71.35808353000004, 66.67926666900007],
              [71.31934655000003, 66.64594147300005],
              [71.29542076900003, 66.63825104400007],
              [71.26417076900003, 66.63922760600008],
              [71.19499759200005, 66.64887116100005],
              [71.16537519600007, 66.65875885600008],
              [71.18132571700005, 66.64655182500007],
              [71.21794681100005, 66.63597239800004],
              [71.23365319100003, 66.62523021000004],
              [71.08350670700008, 66.63206614800004],
              [71.07162519600007, 66.63003164300005],
              [71.05681399800005, 66.62518952000005],
              [71.04493248800009, 66.61701080900008],
              [71.04249108200008, 66.60480377800008],
              [71.05469811300009, 66.59808991100005],
              [71.12378991000008, 66.58429596600007],
              [71.07984459700003, 66.56903717700004],
              [71.03305097700007, 66.57074616100005],
              [70.93946373800009, 66.58429596600007],
              [70.99398847700007, 66.55634186400005],
              [70.97999108200008, 66.54726797100005],
              [70.97934004000007, 66.54393138200004],
              [70.98031660200007, 66.53587474200003],
              [70.68864993600005, 66.51536692900004],
              [70.41325931100005, 66.56317780200004],
              [70.31902103000004, 66.59369538000004],
              [70.29517662900008, 66.63825104400007],
              [70.31275475400008, 66.65070221600007],
              [70.33969160200007, 66.65424225500004],
              [70.39177493600005, 66.65192291900007],
              [70.41081790500004, 66.65631745000007],
              [70.44597415500004, 66.67548248900005],
              [70.46648196700005, 66.67987702000005],
              [70.57276451900003, 66.68756745000007],
              [70.59961998800009, 66.69318268400008],
              [70.60987389400003, 66.69696686400005],
              [70.61557050900007, 66.70189036700003],
              [70.61784915500004, 66.71246979400007],
              [70.62354576900003, 66.71743398600006],
              [70.63591556100005, 66.72060781500005],
              [70.64747155000003, 66.71893952000005],
              [70.65902754000007, 66.71576569200005],
              [70.67164147200003, 66.71401601800005],
              [70.67994225400008, 66.71600983300004],
              [70.73503665500004, 66.74843984600005],
              [70.74105879000007, 66.75775788000004],
              [70.72339928500008, 66.76178620000007],
              [70.62501061300009, 66.76520416900007],
              [70.57545006600003, 66.75999583500004],
              [70.53467858200008, 66.74192942900004],
              [70.61670983200008, 66.74192942900004],
              [70.46648196700005, 66.72085195500006],
              [70.48357181100005, 66.71430084800005],
              [70.54151451900003, 66.70722077000005],
              [70.54151451900003, 66.70038483300004],
              [70.31568444100003, 66.67987702000005],
              [70.28663170700008, 66.68195221600007],
              [70.17253665500004, 66.70709870000007],
              [70.15398196700005, 66.71596914300005],
              [70.15267988400007, 66.72728099200003],
              [70.17847741000008, 66.74192942900004],
              [70.09441165500004, 66.75210195500006],
              [70.06706790500004, 66.75983307500007],
              [69.99317467500003, 66.79970937700006],
              [69.96908613400007, 66.81989166900007],
              [69.95492597700007, 66.84345123900005],
              [69.93620853000004, 66.86302317900004],
              [69.89779707100007, 66.87164948100008],
              [69.88152103000004, 66.86123281500005],
              [69.88331139400003, 66.84992096600007],
              [69.88404381600003, 66.83738841400003],
              [69.86378014400003, 66.82322825700004],
              [69.83659915500004, 66.81631094000005],
              [69.73959394600007, 66.80955638200004],
              [69.70533287900008, 66.81460195500006],
              [69.63559004000007, 66.83576080900008],
              [69.60254967500003, 66.83755117400005],
              [69.57748457100007, 66.82957591400003],
              [69.58855228000004, 66.82050202000005],
              [69.61540774800005, 66.80955638200004],
              [69.63721764400003, 66.79657623900005],
              [69.59799238400007, 66.78904857000003],
              [69.39771569100003, 66.83022695500006],
              [69.37663821700005, 66.83071523600006],
              [69.32162519600007, 66.81834544500003],
              [69.30201256600003, 66.81708405200004],
              [69.13070722700007, 66.83071523600006],
              [68.96501712300005, 66.80955638200004],
              [68.98226972700007, 66.79531484600005],
              [68.99732506600003, 66.78705475500004],
              [69.01433353000004, 66.78318919500003],
              [69.08375084700003, 66.77948639500005],
              [69.10377037900008, 66.77130768400008],
              [69.11646569100003, 66.75433991100005],
              [69.11850019600007, 66.73322174700007],
              [69.10629316500007, 66.68984609600005],
              [69.10279381600003, 66.66933828300006],
              [69.10466556100005, 66.63703034100007],
              [69.11264082100007, 66.61884186400005],
              [69.13152103000004, 66.60545482000003],
              [69.20557701900003, 66.56940338700008],
              [69.38648522200003, 66.51337311400005],
              [69.48861738400007, 66.49876536700003],
              [69.62663821700005, 66.49774811400005],
              [69.67505944100003, 66.48456452000005],
              [69.72934004000007, 66.48407623900005],
              [69.81983483200008, 66.45514557500007],
              [69.85596764400003, 66.43341705900008],
              [69.90284264400003, 66.41547272300005],
              [70.26970462300005, 66.36212799700007],
              [70.36264082100007, 66.33441803600005],
              [70.60906009200005, 66.33934153900003],
              [70.85417728000004, 66.35895416900007],
              [71.14551842500003, 66.36562734600005],
              [71.32406660200007, 66.35895416900007],
              [71.42888431100005, 66.35594310100004],
              [71.52523847700007, 66.33633047100005],
              [71.67872155000003, 66.32363515800006],
              [71.71558678500008, 66.31159088700008],
              [71.74203535200007, 66.29612864800004],
              [71.79184004000007, 66.25161367400005],
              [71.83285566500007, 66.23452383000006],
              [71.91920006600003, 66.25104401200008],
              [71.95980879000007, 66.24477773600006],
              [71.97787519600007, 66.23517487200007],
              [71.99008222700007, 66.23078034100007],
              [72.00277754000007, 66.23078034100007],
              [72.02182050900007, 66.23419830900008],
              [72.02458743600005, 66.23590729400007],
              [72.03549238400007, 66.24477773600006],
              [72.04273522200003, 66.24689362200007],
              [72.04672285200007, 66.24494049700007],
              [72.05054772200003, 66.24188873900005],
              [72.06413821700005, 66.24042389500005],
              [72.06983483200008, 66.23773834800005],
              [72.07569420700008, 66.23582591400003],
              [72.08375084700003, 66.23761627800008],
              [72.09701582100007, 66.24848053600005],
              [72.26148522200003, 66.29564036700003],
              [72.30632571700005, 66.28851959800005],
              [72.34734134200005, 66.30638255400004],
              [72.37623131600003, 66.34125397300005],
              [72.39185631600003, 66.38507721600007],
              [72.39820397200003, 66.41347890800006],
              [72.39869225400008, 66.41917552300004],
              [72.39283287900008, 66.42698802300004],
              [72.37501061300003, 66.44147370000007],
              [72.37134850400008, 66.45018138200004],
              [72.36980228000004, 66.45929596600007],
              [72.36719811300003, 66.46507396000004],
              [72.36670983200008, 66.47117747600004],
              [72.37134850400008, 66.48126862200007],
              [72.37973066500007, 66.48920319200005],
              [72.40259850400008, 66.50023021000004],
              [72.41236412900008, 66.50853099200003],
              [72.38233483200008, 66.51691315300008],
              [72.35084069100003, 66.51398346600007],
              [72.28882897200003, 66.50112539300005],
              [72.31755618600005, 66.52753327000005],
              [72.41089928500008, 66.54926178600005],
              [72.45020592500003, 66.56688060100004],
              [72.45826256600003, 66.57754140800006],
              [72.46656334700003, 66.60138580900008],
              [72.47380618600005, 66.61098867400005],
              [72.49366295700008, 66.61880117400005],
              [72.80494225400008, 66.63914622600004],
              [72.85092207100007, 66.64736562700006],
              [72.87191816500007, 66.65534088700008],
              [72.91675866000008, 66.65428294500003],
              [72.94239342500003, 66.65668366100005],
              [72.95362389400003, 66.66933828300006],
              [72.95883222700007, 66.68203359600005],
              [72.97103925900007, 66.69110748900005],
              [72.98487389400003, 66.69879791900007],
              [72.99512780000003, 66.70722077000005],
              [72.99317467500003, 66.70917389500005],
              [72.99000084700003, 66.71503327000005],
              [72.98764082100007, 66.72199127800008],
              [72.98829186300003, 66.72768789300005],
              [72.99577884200005, 66.73602936400005],
              [73.00310306100005, 66.73944733300004],
              [73.11963951900003, 66.75177643400008],
              [73.17855879000007, 66.77773672100005],
              [73.49236087300005, 66.82343170800004],
              [73.52898196700005, 66.83755117400005],
              [73.54070071700005, 66.84833405200004],
              [73.55600019600007, 66.87124258000006],
              [73.59937584700003, 66.90110911700003],
              [73.62183678500008, 66.92324453300006],
              [73.65707441500007, 66.94196198100008],
              [73.75464928500008, 66.95221588700008],
              [73.79712975400008, 66.96409739800004],
              [73.85377037900008, 66.99677155200004],
              [73.86915123800003, 67.00141022300005],
              [73.87134850400008, 67.00633372600004],
              [73.86597741000008, 67.03986237200007],
              [73.87403405000003, 67.05304596600007],
              [73.91016686300003, 67.06541575700004],
              [73.91993248800003, 67.07770416900007],
              [73.91700280000003, 67.08734772300005],
              [73.89210045700008, 67.11871979400007],
              [73.93482506600003, 67.18964264500005],
              [73.95085696700005, 67.21059804900005],
              [73.95289147200003, 67.23094310100004],
              [73.93734785200007, 67.25592682500007],
              [73.89958743600005, 67.29621002800008],
              [74.09831790500004, 67.43187083500004],
              [74.41431725350006, 67.55906810100004],
              [74.73031660200007, 67.68626536700003],
              [74.74887129000007, 67.70652903900003],
              [74.77654056100005, 67.75551992400005],
              [74.79224694100003, 67.79718659100007],
              [74.80738366000008, 67.88703034100007],
              [74.82496178500008, 67.92682526200008],
              [74.81755618600005, 67.93427155200004],
              [74.82496178500008, 67.94049713700008],
              [74.79704837300005, 68.00259023600006],
              [74.75668379000007, 68.05719635600008],
              [74.74431399800005, 68.08901601800005],
              [74.73682701900003, 68.12128327000005],
              [74.72543379000007, 68.15241120000007],
              [74.70142662900008, 68.18073151200008],
              [74.58033287900008, 68.26190827000005],
              [74.37012780000003, 68.35126373900005],
              [74.33155358200008, 68.38556549700007],
              [74.34376061300003, 68.40346914300005],
              [74.39975019600007, 68.44757721600007],
              [74.45777428500008, 68.50629303600005],
              [74.46827233200008, 68.53538646000004],
              [74.45394941500007, 68.56517161700003],
              [74.43034915500004, 68.59381745000007],
              [74.41342207100007, 68.61953359600005],
              [74.43132571700005, 68.63377513200004],
              [74.43913821700005, 68.65159739800004],
              [74.44434655000003, 68.67202383000006],
              [74.45435631600003, 68.69399648600006],
              [74.48113040500004, 68.72052643400008],
              [74.51400800900007, 68.73598867400005],
              [74.62794030000003, 68.77460358300004],
              [74.92628014400003, 68.81830475500004],
              [75.19068444100003, 68.87482330900008],
              [75.49496504000007, 68.90155670800004],
              [75.62110436300003, 68.89964427300004],
              [75.81959069100003, 68.94415924700007],
              [76.01970462300005, 68.95892975500004],
              [76.11312910200007, 68.97772858300004],
              [76.16041100400008, 68.98200104400007],
              [76.37574303500008, 68.99396393400008],
              [76.58236738400007, 68.97516510600008],
              [76.60906009200005, 68.96600983300004],
              [76.62818444100003, 68.94440338700008],
              [76.64389082100007, 68.91925690300008],
              [76.66041100400008, 68.89948151200008],
              [76.69060306100005, 68.87327708500004],
              [76.69629967500003, 68.85773346600007],
              [76.67920983200008, 68.84516022300005],
              [76.64096113400007, 68.82807038000004],
              [76.61882571700005, 68.80536530200004],
              [76.63233483200008, 68.78221263200004],
              [76.66260826900003, 68.76264069200005],
              [76.86475670700008, 68.70172760600008],
              [76.91976972700007, 68.67226797100005],
              [77.00668379000007, 68.65314362200007],
              [77.04175866000008, 68.62913646000004],
              [77.06202233200008, 68.60293203300006],
              [77.08570397200003, 68.57876211100006],
              [77.11378014400003, 68.56712474200003],
              [77.14820397200003, 68.57855866100005],
              [77.12476647200003, 68.58820221600007],
              [77.11231530000003, 68.59088776200008],
              [77.09986412900008, 68.59153880400004],
              [77.12745201900003, 68.60586172100005],
              [77.17416425900007, 68.59589264500005],
              [77.31592858200008, 68.53058502800008],
              [77.32569420700008, 68.52334219000005],
              [77.31910241000008, 68.50897858300004],
              [77.30062910200007, 68.49872467700004],
              [77.27930748800003, 68.49054596600007],
              [77.26368248800003, 68.48236725500004],
              [77.24781334700003, 68.45693594000005],
              [77.26197350400008, 68.44220612200007],
              [77.28541100400008, 68.42772044500003],
              [77.29769941500007, 68.40289948100008],
              [77.29737389400003, 68.38890208500004],
              [77.29509524800005, 68.38174062700006],
              [77.25977623800003, 68.34845612200007],
              [77.24577884200005, 68.33893463700008],
              [77.22999108200008, 68.33331940300008],
              [77.19402103000004, 68.32855866100005],
              [77.17847741000008, 68.32046133000006],
              [77.16651451900003, 68.30841705900008],
              [77.16187584700003, 68.29364655200004],
              [77.16700280000003, 68.28180573100008],
              [77.17945397200003, 68.27309804900005],
              [77.19516035200007, 68.26699453300006],
              [77.23462975400008, 68.25726959800005],
              [77.33057701900003, 68.24664948100008],
              [77.34782962300005, 68.24176666900007],
              [77.35661868600005, 68.23289622600004],
              [77.34961998800003, 68.21796295800004],
              [77.32545006600003, 68.19916413000004],
              [77.31283613400007, 68.18646881700005],
              [77.31544030000003, 68.18073151200008],
              [77.31666100400008, 68.17523834800005],
              [77.30697675900007, 68.16299062700006],
              [77.29395592500003, 68.15009186400005],
              [77.28443444100003, 68.14280833500004],
              [77.22681725400008, 68.11591217700004],
              [77.21656334700003, 68.10496653900003],
              [77.21705162900008, 68.09174225500004],
              [77.22510826900003, 68.08421458500004],
              [77.23536217500003, 68.07855866100005],
              [77.24317467500003, 68.07086823100008],
              [77.24122155000003, 68.04401276200008],
              [77.22185306100005, 68.01752350500004],
              [77.20020592500003, 67.99632396000004],
              [77.19255618600005, 67.98517487200007],
              [77.22046959700003, 67.96039459800005],
              [77.25001061300003, 67.94049713700008],
              [77.28419030000003, 67.93268463700008],
              [77.29900149800005, 67.92544179900005],
              [77.30518639400003, 67.91010163000004],
              [77.29444420700008, 67.88910553600005],
              [77.26905358200008, 67.86481354400007],
              [77.23951256600003, 67.84345123900005],
              [77.21656334700003, 67.83124420800004],
              [77.19092858200008, 67.82859935100004],
              [77.17221113400007, 67.83608633000006],
              [77.15674889400003, 67.84609609600005],
              [77.14112389400003, 67.85114166900007],
              [77.12566165500004, 67.84837474200003],
              [77.10368899800005, 67.84174225500004],
              [77.08326256600003, 67.83307526200008],
              [77.07243899800005, 67.82440827000005],
              [77.07984459700003, 67.79035065300008],
              [77.12029056100005, 67.76854075700004],
              [77.43091881600003, 67.67914459800005],
              [77.51775149800005, 67.66498444200005],
              [77.67554772200003, 67.61717357000003],
              [77.70313561300003, 67.59788646000004],
              [77.69629967500003, 67.58893463700008],
              [77.68970787900008, 67.57656484600005],
              [77.68458092500003, 67.56366608300004],
              [77.68262780000003, 67.55316803600005],
              [77.69304446700005, 67.54531484600005],
              [77.71697024800005, 67.54999420800004],
              [77.76099694100003, 67.56370677300004],
              [77.86011803500008, 67.57733795800004],
              [77.86996504000007, 67.57562897300005],
              [77.87842858200008, 67.57123444200005],
              [77.89454186300003, 67.56028880400004],
              [77.90357506600003, 67.55833567900004],
              [77.95728600400008, 67.56826406500005],
              [77.96436608200008, 67.56732819200005],
              [77.98210696700005, 67.55337148600006],
              [77.99024498800003, 67.55019765800006],
              [78.02393639400003, 67.54783763200004],
              [78.03541100400008, 67.54498932500007],
              [78.04704837300005, 67.54352448100008],
              [78.05933678500008, 67.54633209800005],
              [78.07048587300005, 67.55023834800005],
              [78.09880618600005, 67.55605703300006],
              [78.13428795700008, 67.55927155200004],
              [78.20704186300003, 67.58075592700004],
              [78.23357181100005, 67.58466217700004],
              [78.25749759200005, 67.58055247600004],
              [78.28077233200008, 67.57396067900004],
              [78.31755618600005, 67.56879303600005],
              [78.35352623800003, 67.55687083500004],
              [78.36646569100003, 67.55540599200003],
              [78.49732506600003, 67.55687083500004],
              [78.51872806100005, 67.55963776200008],
              [78.58106530000003, 67.58246491100005],
              [78.60328209700003, 67.58649323100008],
              [78.67644290500004, 67.58421458500004],
              [78.74073326900003, 67.59194570500006],
              [78.80933678500008, 67.58470286700003],
              [78.90609785200007, 67.56232330900008],
              [78.95997155000003, 67.55687083500004],
              [78.98275800900007, 67.55939362200007],
              [79.02833092500003, 67.56948476800005],
              [79.05250084700003, 67.57054271000004],
              [79.01880944100003, 67.59723541900007],
              [79.00464928500008, 67.60468170800004],
              [78.98047936300003, 67.61066315300008],
              [78.85035241000008, 67.61212799700007],
              [78.82154381600003, 67.61579010600008],
              [78.80600019600007, 67.62518952000005],
              [78.81234785200007, 67.63397858300004],
              [78.85466556100005, 67.64459870000007],
              [78.86801191500007, 67.65314362200007],
              [78.75147545700008, 67.65314362200007],
              [78.72461998800003, 67.64862702000005],
              [78.70630944100003, 67.64101797100005],
              [78.66960696700005, 67.61835358300004],
              [78.62256920700008, 67.60512929900005],
              [78.56470787900008, 67.60407135600008],
              [78.50766035200007, 67.61375560100004],
              [78.46338951900003, 67.63263580900008],
              [78.48926842500003, 67.64012278900003],
              [78.57325280000003, 67.63263580900008],
              [78.60181725400008, 67.63959381700005],
              [78.61573326900003, 67.65037669500003],
              [78.61036217500003, 67.66254303600005],
              [78.58008873800003, 67.67357005400004],
              [78.55347741000008, 67.67413971600007],
              [78.50798587300005, 67.66303131700005],
              [78.48389733200008, 67.66673411700003],
              [78.46827233200008, 67.67788320500006],
              [78.45362389400003, 67.69245026200008],
              [78.43848717500003, 67.70254140800006],
              [78.42172285200007, 67.70026276200008],
              [78.42579186300003, 67.68927643400008],
              [78.42042076900003, 67.67816803600005],
              [78.41236412900008, 67.66535065300008],
              [78.40821373800003, 67.64935944200005],
              [78.40015709700003, 67.63739655200004],
              [78.38168379000007, 67.64459870000007],
              [78.34986412900008, 67.67015208500004],
              [78.32683353000004, 67.67975495000007],
              [78.30144290500004, 67.67536041900007],
              [78.25171959700003, 67.65936920800004],
              [78.22706139400003, 67.66107819200005],
              [78.20582116000008, 67.66657135600008],
              [78.18490644600007, 67.66937897300005],
              [78.16211998800003, 67.66303131700005],
              [78.11345462300005, 67.65696849200003],
              [78.01221764400003, 67.69448476800005],
              [77.96159915500004, 67.69574616100005],
              [77.94060306100005, 67.69147370000007],
              [77.87427819100003, 67.68528880400004],
              [77.86011803500008, 67.69061920800004],
              [77.87224368600005, 67.70457591400003],
              [77.89958743600005, 67.71539948100008],
              [77.94890384200005, 67.72821686400005],
              [77.92042076900003, 67.72662995000007],
              [77.85157311300003, 67.73102448100008],
              [77.82593834700003, 67.73847077000005],
              [77.80958092500003, 67.75112539300005],
              [77.79297936300003, 67.76732005400004],
              [77.77572675900007, 67.77838776200008],
              [77.75766035200007, 67.77602773600006],
              [77.73804772200003, 67.73981354400007],
              [77.61866295700008, 67.73371002800008],
              [77.49415123800003, 67.75128815300008],
              [77.45948326900003, 67.78628164300005],
              [77.47266686300003, 67.80963776200008],
              [77.47315514400003, 67.83364492400005],
              [77.46924889400003, 67.85716380400004],
              [77.46973717500003, 67.87909577000005],
              [77.47388756600003, 67.89484284100007],
              [77.47877037900008, 67.90729401200008],
              [77.48780358200008, 67.91746653900003],
              [77.50375410200007, 67.92682526200008],
              [77.52491295700008, 67.93089427300004],
              [77.55005944100003, 67.93183014500005],
              [77.57276451900003, 67.93553294500003],
              [77.58643639400003, 67.94794342700004],
              [77.56316165500004, 67.94790273600006],
              [77.54395592500003, 67.94501373900005],
              [77.52515709700003, 67.94529857000003],
              [77.50375410200007, 67.95477936400005],
              [77.49341881600003, 67.96332428600005],
              [77.48414147200003, 67.97361888200004],
              [77.46973717500003, 67.99510325700004],
              [77.48308353000004, 68.00275299700007],
              [77.48707116000008, 68.00600820500006],
              [77.50424238400007, 68.02789948100008],
              [77.50619550900007, 68.04523346600007],
              [77.50277754000007, 68.06273021000004],
              [77.50375410200007, 68.08510976800005],
              [77.51563561300003, 68.10659414300005],
              [77.53695722700007, 68.12860748900005],
              [77.58643639400003, 68.16331614800004],
              [77.66553795700008, 68.20551178600005],
              [77.70850670700008, 68.22186920800004],
              [77.75082441500007, 68.22846100500004],
              [77.90259850400008, 68.22943756700005],
              [77.99854576900003, 68.24607982000003],
              [78.10328209700003, 68.24835846600007],
              [78.15357506600003, 68.25755442900004],
              [78.17261803500008, 68.27435944200005],
              [78.14861087300005, 68.29242584800005],
              [78.11182701900003, 68.31232330900008],
              [78.09278405000003, 68.33466217700004],
              [78.09278405000003, 68.35272858300004],
              [78.09009850400008, 68.36001211100006],
              [78.03589928500008, 68.37579987200007],
              [77.99170983200008, 68.38117096600007],
              [77.96998131600003, 68.38922760600008],
              [77.95850670700008, 68.39838288000004],
              [77.95191491000008, 68.40867747600004],
              [77.94263756600003, 68.42772044500003],
              [77.91391035200007, 68.45673248900005],
              [77.90853925900007, 68.46869538000004],
              [77.92359459700003, 68.47028229400007],
              [77.93685957100007, 68.47553131700005],
              [77.94776451900003, 68.48403554900005],
              [77.95630944100003, 68.49542877800008],
              [77.92790774800005, 68.51902903900003],
              [77.89486738400007, 68.52887604400007],
              [77.85962975400008, 68.52753327000005],
              [77.82439212300005, 68.51776764500005],
              [77.78687584700003, 68.51459381700005],
              [77.77409915500004, 68.53424713700008],
              [77.77247155000003, 68.55890534100007],
              [77.76832116000008, 68.57111237200007],
              [77.74830162900008, 68.57880280200004],
              [77.72754967500003, 68.59760163000004],
              [77.71509850400008, 68.62103913000004],
              [77.72006269600007, 68.64248281500005],
              [77.73560631600003, 68.66095612200007],
              [77.74415123800003, 68.67690664300005],
              [77.74683678500008, 68.69375234600005],
              [77.74398847700007, 68.71507396000004],
              [77.73764082100007, 68.73749420800004],
              [77.72771243600005, 68.76080963700008],
              [77.71469160200007, 68.78266022300005],
              [77.69939212300005, 68.80048248900005],
              [77.69223066500007, 68.81708405200004],
              [77.69019616000008, 68.86542389500005],
              [77.68262780000003, 68.88580963700008],
              [77.64698326900003, 68.91111888200004],
              [77.60084069100003, 68.92108795800004],
              [77.40943444100003, 68.92601146000004],
              [77.35865319100003, 68.93716054900005],
              [77.28581790500004, 68.97870514500005],
              [77.23292076900003, 68.98993561400005],
              [76.92904707100007, 69.00934479400007],
              [76.91163170700008, 69.01512278900003],
              [76.89380944100003, 69.02431875200006],
              [76.86296634200005, 69.04718659100007],
              [76.82886803500008, 69.08502838700008],
              [76.81348717500003, 69.09027741100005],
              [76.75489342500003, 69.12470123900005],
              [76.73121178500008, 69.13125234600005],
              [76.66041100400008, 69.13963450700004],
              [76.64698326900003, 69.14378489800004],
              [76.63453209700003, 69.14964427300004],
              [76.62159264400003, 69.15403880400004],
              [76.60629316500007, 69.15395742400005],
              [76.59848066500007, 69.15033600500004],
              [76.58106530000003, 69.13727448100008],
              [76.57227623800003, 69.13279857000003],
              [76.54818769600007, 69.13011302300004],
              [76.42758222700007, 69.14427317900004],
              [76.23780358200008, 69.18988678600005],
              [76.16130618600005, 69.19896067900004],
              [76.09302819100003, 69.22907135600008],
              [76.04200280000003, 69.23908112200007],
              [75.80111738400007, 69.23383209800005],
              [75.50855553500008, 69.26141998900005],
              [75.45337975400008, 69.25128815300008],
              [75.31080162900008, 69.19887929900005],
              [75.17335045700008, 69.17259349200003],
              [75.12924238400007, 69.15729401200008],
              [75.09197024800005, 69.13279857000003],
              [75.13990319100003, 69.12494538000004],
              [75.15398196700005, 69.11920807500007],
              [75.10710696700005, 69.10394928600005],
              [74.94092858200008, 69.10553620000007],
              [74.77279707100007, 69.08124420800004],
              [74.71509850400008, 69.08502838700008],
              [74.50896243600005, 69.13279857000003],
              [74.31373131600003, 69.14638906500005],
              [74.24740644600007, 69.14191315300008],
              [74.02979576900003, 69.09186432500007],
              [73.96127363400007, 69.08380768400008],
              [73.89665774800005, 69.09320709800005],
              [73.83521569100003, 69.11737702000005],
              [73.77662194100003, 69.15395742400005],
              [73.75879967500003, 69.16937897300005],
              [73.75180097700007, 69.18353913000004],
              [73.75660241000008, 69.19904205900008],
              [73.77865644600007, 69.22638580900008],
              [73.78793379000007, 69.24510325700004],
              [73.79330488400007, 69.25291575700004],
              [73.82439212300005, 69.28367747600004],
              [73.84961998800003, 69.31513092700004],
              [73.89958743600005, 69.41400788000004],
              [73.89958743600005, 69.42084381700005],
              [73.85857181100005, 69.48224518400008],
              [73.75538170700008, 69.56476471600007],
              [73.63257897200003, 69.63312409100007],
              [73.56324303500008, 69.68374258000006],
              [73.53003991000008, 69.71621328300006],
              [73.51596113400007, 69.74640534100007],
              [73.53500410200007, 69.77606842700004],
              [73.62745201900003, 69.83006419500003],
              [73.65992272200003, 69.85968659100007],
              [73.65308678500008, 69.87518952000005],
              [73.65626061300003, 69.89325592700004],
              [73.66570071700005, 69.91058991100005],
              [73.70525149800005, 69.95530833500004],
              [73.70826256600003, 69.96832916900007],
              [73.70769290500004, 70.00722890800006],
              [73.71143639400003, 70.01894765800006],
              [73.75261478000004, 70.06216054900005],
              [73.76482181100005, 70.07904694200005],
              [73.76807701900003, 70.09564850500004],
              [73.75554446700005, 70.10952383000006],
              [73.70240319100003, 70.12636953300006],
              [73.69223066500007, 70.13812897300005],
              [73.70769290500004, 70.16132233300004],
              [73.73454837300005, 70.18089427300004],
              [74.00660241000008, 70.30451080900008],
              [74.03060957100007, 70.31928131700005],
              [74.05030358200008, 70.33881256700005],
              [74.05648847700007, 70.35114166900007],
              [74.05982506600003, 70.36286041900007],
              [74.06495201900003, 70.37372467700004],
              [74.07740319100003, 70.38349030200004],
              [74.19654381600003, 70.43500397300005],
              [74.26685631600003, 70.47972239800004],
              [74.31617272200003, 70.52033112200007],
              [74.32911217500003, 70.53750234600005],
              [74.33659915500004, 70.55735911700003],
              [74.33904056100005, 70.58218008000006],
              [74.33716881600003, 70.59467194200005],
              [74.32406660200007, 70.62620677300004],
              [74.32081139400003, 70.65863678600005],
              [74.31788170700008, 70.66779205900008],
              [74.29428144600007, 70.69623444200005],
              [74.26075280000003, 70.71629466400003],
              [73.95215905000003, 70.83681875200006],
              [73.92750084700003, 70.85537344000005],
              [73.91309655000003, 70.88690827000005],
              [73.91195722700007, 70.90973541900007],
              [73.91334069100003, 70.93060944200005],
              [73.91032962300005, 70.95099518400008],
              [73.89576256600003, 70.97260163000004],
              [73.86451256600003, 70.99310944200005],
              [73.78435306100005, 71.02090078300006],
              [73.74870853000004, 71.03774648600006],
              [73.70362389400003, 71.07143789300005],
              [73.68213951900003, 71.09235260600008],
              [73.67302493600005, 71.10968659100007],
              [73.66781660200007, 71.13214752800008],
              [73.65528405000003, 71.15346914300005],
              [73.58277428500008, 71.23358795800004],
              [73.55616295700008, 71.25511302300004],
              [73.53272545700008, 71.26430898600006],
              [73.51124108200008, 71.26959870000007],
              [73.46949303500008, 71.29303620000007],
              [73.42644290500004, 71.30223216400003],
              [73.36353600400008, 71.33124420800004],
              [73.33936608200008, 71.33881256700005],
              [73.23585045700008, 71.35712311400005],
              [73.17335045700008, 71.38031647300005],
              [73.07927493600005, 71.39227936400005],
              [73.03337649800005, 71.40570709800005],
              [73.02247155000003, 71.42877838700008],
              [73.03744550900007, 71.44098541900007],
              [73.36475670700008, 71.58299388200004],
              [73.38119550900007, 71.59357330900008],
              [73.40919030000003, 71.61652252800008],
              [73.42652428500008, 71.62738678600005],
              [73.48178144600007, 71.65273672100005],
              [73.49854576900003, 71.66494375200006],
              [73.51823978000004, 71.68707916900007],
              [73.52491295700008, 71.70624420800004],
              [73.51937910200007, 71.72443268400008],
              [73.50228925900007, 71.74347565300008],
              [73.47584069100003, 71.76260000200006],
              [73.47022545700008, 71.77342357000003],
              [73.47771243600005, 71.78815338700008],
              [73.49089603000004, 71.80052317900004],
              [73.50766035200007, 71.81281159100007],
              [73.52588951900003, 71.82221100500004],
              [73.76726321700005, 71.87396881700005],
              [73.93930097700007, 71.91372304900005],
              [74.25049889400003, 71.96002838700008],
              [74.33155358200008, 71.95571523600006],
              [74.40739993600005, 71.97382233300004],
              [74.66789798300005, 72.03597646700004],
              [74.92839603000004, 72.09813060100004],
              [74.96159915500004, 72.11395905200004],
              [74.99488366000008, 72.13784414300005],
              [75.07569420700008, 72.21015045800004],
              [75.09197024800005, 72.24062734600005],
              [75.11109459700003, 72.34642161700003],
              [75.10547936300003, 72.36717357000003],
              [75.10873457100007, 72.40350983300004],
              [75.07911217500003, 72.47321198100008],
              [75.06657962300005, 72.52488841400003],
              [75.05884850400008, 72.54511139500005],
              [75.05453535200007, 72.56549713700008],
              [75.06104576900003, 72.58319733300004],
              [75.05884850400008, 72.59503815300008],
              [75.04867597700007, 72.61640045800004],
              [75.02637780000003, 72.65184153900003],
              [74.99952233200008, 72.67389557500007],
              [74.74756920700008, 72.80829498900005],
              [74.74154707100007, 72.81439850500004],
              [74.75114993600005, 72.82001373900005],
              [74.77515709700003, 72.82851797100005],
              [74.98316491000008, 72.87677643400008],
              [75.03663170700008, 72.88165924700007],
              [75.09197024800005, 72.87498607000003],
              [75.11198978000004, 72.86798737200007],
              [75.16684004000007, 72.84023672100005],
              [75.19141686300003, 72.83372630400004],
              [75.31885826900003, 72.81915924700007],
              [75.45720462300005, 72.77326080900008],
              [75.50212649800005, 72.76727936400005],
              [75.52230879000007, 72.75983307500007],
              [75.53077233200008, 72.74115631700005],
              [75.51986738400007, 72.73834870000007],
              [75.45557701900003, 72.70990631700005],
              [75.43702233200008, 72.71401601800005],
              [75.42212975400008, 72.72138092700004],
              [75.40748131600003, 72.72382233300004],
              [75.37647545700008, 72.70416901200008],
              [75.34750410200007, 72.69228750200006],
              [75.33822675900007, 72.68317291900007],
              [75.35873457100007, 72.68500397300005],
              [75.40186608200008, 72.69619375200006],
              [75.42090905000003, 72.69684479400007],
              [75.43295332100007, 72.69179922100005],
              [75.44304446700005, 72.68341705900008],
              [75.45899498800003, 72.66547272300005],
              [75.48650149800005, 72.64508698100008],
              [75.51856530000003, 72.63104889500005],
              [75.65251712300005, 72.59910716400003],
              [75.68718509200005, 72.58539459800005],
              [75.70818118600005, 72.56586334800005],
              [75.70199629000007, 72.54702383000006],
              [75.66895592500003, 72.54441966400003],
              [75.62745201900003, 72.54791901200008],
              [75.59685306100005, 72.54710521000004],
              [75.56169681100005, 72.52533600500004],
              [75.55648847700007, 72.49750397300005],
              [75.57203209700003, 72.46674225500004],
              [75.62281334700003, 72.41193268400008],
              [75.62582441500007, 72.40473053600005],
              [75.62452233200008, 72.38861725500004],
              [75.62623131600003, 72.38153717700004],
              [75.66822350400008, 72.35390859600005],
              [75.68287194100003, 72.33991120000007],
              [75.66724694100003, 72.33307526200008],
              [75.69044030000003, 72.31867096600007],
              [75.75473066500007, 72.30638255400004],
              [75.75294030000003, 72.28872304900005],
              [75.74838300900007, 72.28139883000006],
              [75.74244225400008, 72.26552969000005],
              [75.73552493600005, 72.25739166900007],
              [75.72120201900003, 72.24957916900007],
              [75.62240644600007, 72.22654857000003],
              [75.59408613400007, 72.21454498900005],
              [75.58741295700008, 72.21019114800004],
              [75.51783287900008, 72.15322500200006],
              [75.51010175900007, 72.13788483300004],
              [75.51238040500004, 72.12889232000003],
              [75.52182050900007, 72.11469147300005],
              [75.52458743600005, 72.10781484600005],
              [75.52393639400003, 72.09853750200006],
              [75.51832116000008, 72.08331940300008],
              [75.51693769600007, 72.07640208500004],
              [75.50171959700003, 72.06244538000004],
              [75.43262780000003, 72.04596588700008],
              [75.41407311300003, 72.03143952000005],
              [75.41716556100005, 72.02619049700007],
              [75.43824303500008, 72.00104401200008],
              [75.44385826900003, 71.99192942900004],
              [75.43897545700008, 71.98533763200004],
              [75.39063561300003, 71.96381256700005],
              [75.35385175900007, 71.95774974200003],
              [75.28679446700005, 71.95990631700005],
              [75.28500410200007, 71.96039459800005],
              [75.26734459700003, 71.95246002800008],
              [75.25367272200003, 71.94220612200007],
              [75.25294030000003, 71.93244049700007],
              [75.27100670700008, 71.91445547100005],
              [75.27857506600003, 71.90493398600006],
              [75.28353925900007, 71.89423248900005],
              [75.26205488400007, 71.88312409100007],
              [75.23755944100003, 71.86359284100007],
              [75.22413170700008, 71.84223053600005],
              [75.23585045700008, 71.82599518400008],
              [75.22022545700008, 71.80996328300006],
              [75.21762129000007, 71.79197825700004],
              [75.22754967500003, 71.77741120000007],
              [75.24952233200008, 71.77138906500005],
              [75.25757897200003, 71.76788971600007],
              [75.25977623800003, 71.75975169500003],
              [75.26026451900003, 71.75043366100005],
              [75.26319420700008, 71.74347565300008],
              [75.27426191500007, 71.73550039300005],
              [75.28695722700007, 71.72894928600005],
              [75.30062910200007, 71.72459544500003],
              [75.34620201900003, 71.71820709800005],
              [75.49170983200008, 71.66608307500007],
              [75.50635826900003, 71.65216705900008],
              [75.49122155000003, 71.63939036700003],
              [75.42172285200007, 71.62799713700008],
              [75.39242597700007, 71.61786530200004],
              [75.40064537900008, 71.60346100500004],
              [75.49170983200008, 71.57391998900005],
              [75.51693769600007, 71.55849844000005],
              [75.52759850400008, 71.54913971600007],
              [75.53288821700005, 71.54230377800008],
              [75.52881920700008, 71.53632233300004],
              [75.51172936300003, 71.52952708500004],
              [75.46949303500008, 71.51947663000004],
              [75.45533287900008, 71.51410553600005],
              [75.43376712300005, 71.50165436400005],
              [75.42554772200003, 71.49038320500006],
              [75.42888431100005, 71.47797272300005],
              [75.44190514400003, 71.46222565300008],
              [75.40593509200005, 71.45258209800005],
              [75.26661217500003, 71.46222565300008],
              [75.25440514400003, 71.45990631700005],
              [75.24154707100007, 71.45355866100005],
              [75.23454837300005, 71.44403717700004],
              [75.24268639400003, 71.42340729400007],
              [75.23829186300003, 71.41559479400007],
              [75.23178144600007, 71.40912506700005],
              [75.22836347700007, 71.40452708500004],
              [75.26303144600007, 71.36554596600007],
              [75.34262129000007, 71.33494700700004],
              [75.73365319100003, 71.26487864800004],
              [76.01734459700003, 71.23700592700004],
              [76.10840905000003, 71.20449453300006],
              [76.12647545700008, 71.20282623900005],
              [76.11524498800003, 71.21173737200007],
              [76.11963951900003, 71.22040436400005],
              [76.13347415500004, 71.22695547100005],
              [76.15040123800003, 71.22947825700004],
              [76.46892337300005, 71.21263255400004],
              [76.71998131600003, 71.20530833500004],
              [76.88892662900008, 71.19041575700004],
              [76.91423587300005, 71.18231842700004],
              [76.89234459700003, 71.17226797100005],
              [76.88168379000007, 71.15997955900008],
              [76.88249759200005, 71.14508698100008],
              [76.89429772200003, 71.12710195500006],
              [76.90162194100003, 71.12246328300006],
              [76.91065514400003, 71.11859772300005],
              [76.91830488400007, 71.11298248900005],
              [76.92164147200003, 71.10293203300006],
              [76.91920006600003, 71.09438711100006],
              [76.91431725400008, 71.08901601800005],
              [76.91130618600005, 71.08307526200008],
              [76.91423587300005, 71.07245514500005],
              [76.92847741000008, 71.07754140800006],
              [76.94434655000003, 71.08710358300004],
              [76.95728600400008, 71.09955475500004],
              [76.96257571700005, 71.11347077000005],
              [76.95826256600003, 71.12482330900008],
              [76.92904707100007, 71.16058991100005],
              [77.00513756600003, 71.18447500200006],
              [77.38209069100003, 71.15892161700003],
              [77.55811608200008, 71.17365143400008],
              [77.78272545700008, 71.14248281500005],
              [77.83773847700007, 71.12457916900007],
              [77.86540774800005, 71.11005280200004],
              [77.88550866000008, 71.08926015800006],
              [77.89429772200003, 71.05947500200006],
              [77.89527428500008, 71.03245677300004],
              [77.89991295700008, 71.01048411700003],
              [77.91553795700008, 70.99217357000003],
              [77.94890384200005, 70.97626373900005],
              [78.00171959700003, 70.96360911700003],
              [78.27906334700003, 70.94212474200003],
              [78.36036217500003, 70.90802643400008],
              [78.41138756600003, 70.89545319200005],
              [78.45525149800005, 70.89468008000006],
              [78.49830162900008, 70.90330638200004],
              [78.54688561300003, 70.91966380400004],
              [78.59782962300005, 70.92804596600007],
              [78.76880944100003, 70.91425202000005],
              [78.88135826900003, 70.92169830900008],
              [78.89918053500008, 70.92780182500007],
              [78.91391035200007, 70.93964264500005],
              [78.92945397200003, 70.94765859600005],
              [78.94947350400008, 70.94212474200003],
              [78.94597415500004, 70.93060944200005],
              [78.96461022200003, 70.92869700700004],
              [79.03956139400003, 70.93732330900008],
              [79.05339603000004, 70.94196198100008],
              [79.05933678500008, 70.95270416900007],
              [79.05437259200005, 70.96210358300004],
              [79.04265384200005, 70.96735260600008],
              [79.02906334700003, 70.96930573100008],
              [79.01832116000008, 70.96881745000007],
              [79.07154381600003, 70.98016998900005],
              [79.10108483200008, 70.99103424700007],
              [79.11451256600003, 71.00421784100007],
              [79.10279381600003, 71.02024974200003],
              [79.07447350400008, 71.02350495000007],
              [79.04297936300003, 71.01801178600005],
              [78.96778405000003, 70.98700592700004],
              [78.84498131600003, 71.01325104400007],
              [78.78565514400003, 70.99054596600007],
              [78.81462649800005, 70.99152252800008],
              [78.84449303500008, 70.98916250200006],
              [78.90162194100003, 70.97626373900005],
              [78.75757897200003, 70.93500397300005],
              [78.70899498800003, 70.94037506700005],
              [78.66293379000007, 70.95384349200003],
              [78.61378014400003, 70.96259186400005],
              [78.56470787900008, 70.96255117400005],
              [78.51807701900003, 70.94961172100005],
              [78.48210696700005, 70.92405833500004],
              [78.46208743600005, 70.91364166900007],
              [78.44239342500003, 70.91425202000005],
              [78.43384850400008, 70.92186107000003],
              [78.43148847700007, 70.93211497600004],
              [78.43295332100007, 70.94228750200006],
              [78.43539472700007, 70.94961172100005],
              [78.47779381600003, 70.99152252800008],
              [78.48804772200003, 71.01166413000004],
              [78.46338951900003, 71.02411530200004],
              [78.48707116000008, 71.03017812700006],
              [78.53980553500008, 71.03632233300004],
              [78.55974368600005, 71.04515208500004],
              [78.54656009200005, 71.05825429900005],
              [78.53158613400007, 71.06712474200003],
              [78.49756920700008, 71.07868073100008],
              [78.50961347700007, 71.08942291900007],
              [78.51579837300005, 71.09198639500005],
              [78.52540123800003, 71.09296295800004],
              [78.49732506600003, 71.11505768400008],
              [78.44385826900003, 71.11530182500007],
              [78.34620201900003, 71.09979889500005],
              [78.37598717500003, 71.07599518400008],
              [78.47103925900007, 71.06175364800004],
              [78.49756920700008, 71.04515208500004],
              [78.43043053500008, 71.04474518400008],
              [78.36394290500004, 71.05719635600008],
              [78.29916425900007, 71.07977936400005],
              [78.23755944100003, 71.10968659100007],
              [78.23365319100003, 71.12287018400008],
              [78.25066165500004, 71.13873932500007],
              [78.28907311300003, 71.16437409100007],
              [78.29948978000004, 71.17841217700004],
              [78.30665123800003, 71.19277578300006],
              [78.31104576900003, 71.20844147300005],
              [78.31251061300003, 71.22638580900008],
              [78.27898196700005, 71.25893789300005],
              [78.20142662900008, 71.27065664300005],
              [78.02198326900003, 71.27871328300006],
              [77.95606530000003, 71.25389232000003],
              [77.92847741000008, 71.25747304900005],
              [77.92237389400003, 71.28131745000007],
              [77.91846764400003, 71.28851959800005],
              [77.91325931100005, 71.29515208500004],
              [77.90601647200003, 71.30760325700004],
              [77.90113366000008, 71.31268952000005],
              [77.92823326900003, 71.32973867400005],
              [77.99048912900008, 71.34638092700004],
              [78.01099694100003, 71.36733633000006],
              [77.98829186300003, 71.37474192900004],
              [77.96900475400008, 71.37372467700004],
              [77.92847741000008, 71.36050039300005],
              [77.88184655000003, 71.35468170800004],
              [77.86548912900008, 71.34943268400008],
              [77.87378991000008, 71.33934153900003],
              [77.77735436300003, 71.32461172100005],
              [77.73414147200003, 71.31118398600006],
              [77.75082441500007, 71.29218170800004],
              [77.71192467500003, 71.28131745000007],
              [77.67090905000003, 71.28611888200004],
              [77.59327233200008, 71.31268952000005],
              [77.51547285200007, 71.32916901200008],
              [77.43555748800003, 71.33319733300004],
              [77.45346113400007, 71.32151927300004],
              [77.52491295700008, 71.30524323100008],
              [77.49219811300003, 71.30133698100008],
              [77.23170006600003, 71.36225006700005],
              [77.18067467500003, 71.38467031500005],
              [77.13453209700003, 71.41136302300004],
              [77.10352623800003, 71.42397695500006],
              [77.07325280000003, 71.42885976800005],
              [76.94971764400003, 71.43138255400004],
              [76.71265709700003, 71.46344635600008],
              [76.68824303500008, 71.46971263200004],
              [76.67123457100007, 71.47846100500004],
              [76.62671959700003, 71.51068756700005],
              [76.58106530000003, 71.52875397300005],
              [76.52816816500007, 71.54181549700007],
              [76.32545006600003, 71.55951569200005],
              [76.27230879000007, 71.57290273600006],
              [76.24935957100007, 71.59666575700004],
              [76.25310306100005, 71.60834381700005],
              [76.26832116000008, 71.62958405200004],
              [76.27051842500003, 71.64105866100005],
              [76.26351972700007, 71.65314362200007],
              [76.18230228000004, 71.71417877800008],
              [76.16187584700003, 71.73517487200007],
              [76.14633222700007, 71.77448151200008],
              [76.07976321700005, 71.86343008000006],
              [76.05746504000007, 71.88287995000007],
              [76.03044681100005, 71.89777252800008],
              [75.99683678500008, 71.90790436400005],
              [76.02670332100007, 71.92381419500003],
              [76.09400475400008, 71.93073151200008],
              [76.35377037900008, 71.99909088700008],
              [76.61597741000006, 72.02456289250006],
              [76.87818444100003, 72.05003489800004],
              [76.94613691500007, 72.04425690300008],
              [76.96257571700005, 72.02460358300004],
              [77.02686608200008, 72.02142975500004],
              [77.38461347700007, 71.90737539300005],
              [77.44898522200003, 71.87103913000004],
              [77.58464603000004, 71.83112213700008],
              [77.72722415500004, 71.82684967700004],
              [78.10954837300005, 71.88043854400007],
              [78.15593509200005, 71.89435455900008],
              [78.19711347700007, 71.92226797100005],
              [78.21469160200007, 71.94106679900005],
              [78.22681725400008, 71.96185944200005],
              [78.22575931100005, 71.98257070500006],
              [78.20362389400003, 72.00104401200008],
              [78.03158613400007, 72.09467194200005],
              [77.98560631600003, 72.10952383000006],
              [77.93775475400008, 72.11810944200005],
              [77.71257571700005, 72.11517975500004],
              [77.56397545700008, 72.07062409100007],
              [77.51059004000007, 72.06207916900007],
              [77.46452884200005, 72.06757233300004],
              [77.38738040500004, 72.09223053600005],
              [77.37720787900008, 72.11017487200007],
              [77.41439863400007, 72.13788483300004],
              [77.49073326900003, 72.17544179900005],
              [77.48829186300003, 72.18829987200007],
              [77.47413170700008, 72.19676341400003],
              [77.44174238400007, 72.20962148600006],
              [77.47388756600003, 72.22235748900005],
              [77.50709069100003, 72.22235748900005],
              [77.61150149800005, 72.19342682500007],
              [77.65113366000008, 72.18976471600007],
              [77.66822350400008, 72.19281647300005],
              [77.69727623800003, 72.20648834800005],
              [77.74138431100005, 72.21621328300006],
              [77.87924238400007, 72.30048248900005],
              [77.94263756600003, 72.32632070500006],
              [78.08757571700005, 72.35879140800006],
              [78.09880618600005, 72.36343008000006],
              [78.10718834700003, 72.36920807500007],
              [78.12452233200008, 72.38458893400008],
              [78.13624108200008, 72.38519928600005],
              [78.19174238400007, 72.36904531500005],
              [78.23161868600005, 72.36383698100008],
              [78.34620201900003, 72.38776276200008],
              [78.42579186300003, 72.39337799700007],
              [78.46501712300005, 72.39069245000007],
              [78.50277754000007, 72.38190338700008],
              [78.50440514400003, 72.38153717700004],
              [78.50245201900003, 72.38812897300005],
              [78.50017337300005, 72.40180084800005],
              [78.49756920700008, 72.40818919500003],
              [78.75749759200008, 72.39268626500004],
              [79.01742597700007, 72.37718333500004],
              [79.20948326900003, 72.39020416900007],
              [79.39144941500007, 72.38556549700007],
              [79.51384524800005, 72.36220937700006],
              [79.78541100400008, 72.26463450700004],
              [80.01010175900007, 72.20774974200003],
              [80.47396894600007, 72.15204498900005],
              [80.83464603000004, 72.08331940300008],
              [80.85157311300003, 72.06928131700005],
              [80.84742272200003, 72.05955638200004],
              [80.84457441500007, 72.04686107000003],
              [80.83757571700005, 72.03412506700005],
              [80.82081139400003, 72.02460358300004],
              [80.80176842500003, 72.02480703300006],
              [80.73210696700005, 72.04511139500005],
              [80.75163821700005, 72.05744049700007],
              [80.79525800900007, 72.06777578300006],
              [80.81397545700008, 72.07990143400008],
              [80.72950280000003, 72.08242422100005],
              [80.68588300900007, 72.07876211100006],
              [80.64942467500003, 72.06557851800005],
              [80.63233483200008, 72.04608795800004],
              [80.64722741000008, 72.03412506700005],
              [80.94849694100006, 71.94666168800006],
              [81.24976647200003, 71.85919830900008],
              [81.25912519600007, 71.85419342700004],
              [81.26587975400008, 71.84711334800005],
              [81.26758873800003, 71.83909739800004],
              [81.26441491000008, 71.83392975500004],
              [81.26050866000008, 71.83022695500006],
              [81.25961347700007, 71.82599518400008],
              [81.27947024800005, 71.79604726800005],
              [81.30738366000008, 71.77619049700007],
              [81.34229576900003, 71.76422760600008],
              [81.54664147200003, 71.74160390800006],
              [81.73666425900007, 71.69989655200004],
              [82.19434655000003, 71.70774974200003],
              [82.30404707100007, 71.73037344000005],
              [82.41879316500007, 71.73688385600008],
              [82.49854576900003, 71.75462474200003],
              [82.86736087300005, 71.78644440300008],
              [82.92432701900003, 71.77138906500005],
              [82.93327884200005, 71.76634349200003],
              [82.94092858200008, 71.76080963700008],
              [82.95508873800003, 71.74713776200008],
              [82.96355228000004, 71.74066803600005],
              [82.97185306100005, 71.73851146000004],
              [82.98064212300005, 71.73773834800005],
              [83.01921634200005, 71.72943756700005],
              [83.15333092500003, 71.73981354400007],
              [83.20378665500004, 71.73688385600008],
              [83.25171959700003, 71.72565338700008],
              [83.29558353000004, 71.70311107000003],
              [83.31177819100003, 71.69188060100004],
              [83.32048587300005, 71.68329498900005],
              [83.31902103000004, 71.67348867400005],
              [83.30518639400003, 71.65839264500005],
              [83.28988691500007, 71.64789459800005],
              [83.24024498800003, 71.62738678600005],
              [83.17115319100003, 71.58551666900007],
              [83.13559004000007, 71.57184479400007],
              [83.05014082100007, 71.56159088700008],
              [83.02654056100005, 71.54987213700008],
              [83.01197350400008, 71.52895742400005],
              [83.00001061300003, 71.49701569200005],
              [82.98878014400003, 71.47492096600007],
              [82.98536217500003, 71.46283600500004],
              [82.98951256600003, 71.45233795800004],
              [83.00489342500003, 71.44257233300004],
              [83.02198326900003, 71.43667226800005],
              [83.03744550900007, 71.42934804900005],
              [83.04786217500003, 71.41510651200008],
              [82.98357181100005, 71.40973541900007],
              [82.93995201900003, 71.39801666900007],
              [82.82007897200003, 71.39130280200004],
              [82.55831953200004, 71.33930084850005],
              [82.29656009200005, 71.28729889500005],
              [82.27263431100005, 71.27879466400003],
              [82.25904381600003, 71.26430898600006],
              [82.25928795700008, 71.25267161700003],
              [82.26587975400008, 71.24249909100007],
              [82.27418053500008, 71.23285553600005],
              [82.28003991000008, 71.22333405200004],
              [82.28126061300003, 71.21149323100008],
              [82.27930748800003, 71.18805573100008],
              [82.28345787900008, 71.17861562700006],
              [82.29468834700003, 71.16933828300006],
              [82.31950931100005, 71.15460846600007],
              [82.33155358200008, 71.14419179900005],
              [82.34929446700005, 71.11871979400007],
              [82.35279381600003, 71.09625885600008],
              [82.34148196700005, 71.07648346600007],
              [82.31421959700003, 71.05947500200006],
              [82.23536217500003, 71.03620026200008],
              [82.20313561300003, 71.01626211100006],
              [82.20834394600007, 70.98680247600004],
              [82.30738366000008, 70.90802643400008],
              [82.30128014400003, 70.89618561400005],
              [82.31413821700005, 70.88495514500005],
              [82.32960045700008, 70.87409088700008],
              [82.33155358200008, 70.86298248900005],
              [82.32398522200003, 70.84609609600005],
              [82.33480879000007, 70.83832428600005],
              [82.34839928500008, 70.83161041900007],
              [82.34888756600003, 70.81801992400005],
              [82.40837649800005, 70.79018789300005],
              [82.41724694100003, 70.77704498900005],
              [82.40870201900003, 70.76581452000005],
              [82.36898847700007, 70.74262116100005],
              [82.23536217500003, 70.69611237200007],
              [82.20183353000004, 70.67121002800008],
              [82.19239342500003, 70.65704987200007],
              [82.19483483200008, 70.65053945500006],
              [82.20020592500003, 70.64508698100008],
              [82.19874108200008, 70.63369375200006],
              [82.18726647200003, 70.62177155200004],
              [82.16895592500003, 70.61298248900005],
              [82.10010826900003, 70.58930084800005],
              [82.08594811300003, 70.57965729400007],
              [82.08204186300003, 70.56537506700005],
              [82.09180748800003, 70.55508047100005],
              [82.14340254000007, 70.53123607000003],
              [82.15333092500003, 70.51813385600008],
              [82.15463300900007, 70.50897858300004],
              [82.15219160200007, 70.49970123900005],
              [82.15040123800003, 70.48627350500004],
              [82.15349368600005, 70.47589752800008],
              [82.16765384200005, 70.45693594000005],
              [82.17514082100007, 70.42401764500005],
              [82.19434655000003, 70.38373444200005],
              [82.20289147200003, 70.34902578300006],
              [82.21265709700003, 70.33893463700008],
              [82.22388756600003, 70.32977936400005],
              [82.23275800900007, 70.31834544500003],
              [82.23536217500003, 70.30805084800005],
              [82.23536217500003, 70.28766510600008],
              [82.23959394600007, 70.27732982000003],
              [82.25049889400003, 70.26772695500006],
              [82.29428144600007, 70.24384186400005],
              [82.33423912900008, 70.21051666900007],
              [82.34888756600003, 70.20229726800005],
              [82.34441165500004, 70.22557200700004],
              [82.32740319100003, 70.25023021000004],
              [82.28687584700003, 70.29043203300006],
              [82.29428144600007, 70.29783763200004],
              [82.25180097700007, 70.37592194200005],
              [82.24024498800003, 70.42682526200008],
              [82.22925866000008, 70.45400625200006],
              [82.22535241000008, 70.47955963700008],
              [82.23959394600007, 70.49705638200004],
              [82.22339928500008, 70.51797109600005],
              [82.17554772200003, 70.55060455900008],
              [82.15723717500003, 70.57160065300008],
              [82.18018639400003, 70.58576080900008],
              [82.20948326900003, 70.59088776200008],
              [82.24000084700003, 70.59292226800005],
              [82.29737389400003, 70.60394928600005],
              [82.44532311300003, 70.60651276200008],
              [82.46461022200003, 70.61318594000005],
              [82.47242272200003, 70.62995026200008],
              [82.46387780000003, 70.64594147300005],
              [82.44678795700008, 70.65648021000004],
              [82.43392988400007, 70.66665273600006],
              [82.43824303500008, 70.68146393400008],
              [82.43506920700008, 70.68512604400007],
              [82.43295332100007, 70.68781159100007],
              [82.43189537900008, 70.69082265800006],
              [82.43091881600003, 70.69513580900008],
              [82.45142662900008, 70.69501373900005],
              [82.46876061300003, 70.69936758000006],
              [82.48340905000003, 70.70758698100008],
              [82.49634850400008, 70.71930573100008],
              [82.50017337300005, 70.73012929900005],
              [82.49976647200003, 70.74282461100006],
              [82.50212649800005, 70.75336334800005],
              [82.51343834700003, 70.75779857000003],
              [82.53874759200005, 70.75861237200007],
              [82.55420983200008, 70.76154205900008],
              [82.55469811300003, 70.76740143400008],
              [82.53394616000008, 70.77704498900005],
              [82.50131269600007, 70.78416575700004],
              [82.48878014400003, 70.79047272300005],
              [82.47868899800005, 70.80499909100007],
              [82.50261478000004, 70.82143789300005],
              [82.56861412900008, 70.85317617400005],
              [82.58228600400008, 70.86981842700004],
              [82.57984459700003, 70.87970612200007],
              [82.57553144600007, 70.89069245000007],
              [82.57374108200008, 70.90176015800006],
              [82.57862389400003, 70.91111888200004],
              [82.59408613400007, 70.91901276200008],
              [82.63184655000003, 70.92938873900005],
              [82.68816165500004, 70.96190013200004],
              [82.73454837300005, 70.96552155200004],
              [82.84302819100003, 70.95221588700008],
              [82.85173587300005, 70.94310130400004],
              [82.85718834700003, 70.93085358300004],
              [82.86597741000003, 70.91791413000004],
              [82.87663821700005, 70.91697825700004],
              [82.88884524800005, 70.92597077000005],
              [82.89665774800005, 70.93976471600007],
              [82.89332116000003, 70.95270416900007],
              [82.87728925900007, 70.98688385600008],
              [82.87582441500007, 70.99677155200004],
              [82.88795006600003, 71.00674062700006],
              [82.90162194100003, 71.00104401200008],
              [82.91285241000003, 70.98720937700006],
              [82.91749108200008, 70.97260163000004],
              [82.93238366000003, 70.95404694200005],
              [82.96664472700007, 70.93398672100005],
              [83.03256269600007, 70.90619538000004],
              [83.10661868600005, 70.89618561400005],
              [83.13379967500003, 70.88239166900007],
              [83.14405358200008, 70.84593333500004],
              [83.14047285200007, 70.82733795800004],
              [83.13428795700008, 70.80780670800004],
              [83.13135826900003, 70.78681061400005],
              [83.13721764400003, 70.76398346600007],
              [83.11182701900003, 70.75055573100008],
              [83.08578535200007, 70.72345612200007],
              [83.06495201900003, 70.69253164300005],
              [83.05469811300003, 70.66779205900008],
              [83.05632571700005, 70.65497467700004],
              [83.06714928500003, 70.62514883000006],
              [83.06836998800003, 70.61318594000005],
              [83.05713951900003, 70.59711334800005],
              [83.03687584700003, 70.58539459800005],
              [82.99317467500003, 70.57160065300008],
              [83.00570722700007, 70.56781647300005],
              [83.01392662900008, 70.56171295800004],
              [83.01856530000003, 70.55304596600007],
              [83.02198326900003, 70.53099192900004],
              [83.02784264400003, 70.52513255400004],
              [83.03565514400003, 70.52065664300005],
              [83.04444420700008, 70.51414622600004],
              [83.05250084700003, 70.49990469000005],
              [83.04542076900003, 70.49115631700005],
              [83.03345787900008, 70.48200104400007],
              [83.01050866000003, 70.42658112200007],
              [82.96998131600003, 70.40501536700003],
              [82.87582441500007, 70.37299225500004],
              [82.66407311300003, 70.26015859600005],
              [82.65121504000007, 70.24795156500005],
              [82.65064537900008, 70.22955963700008],
              [82.66138756600003, 70.21279531500005],
              [82.67269941500007, 70.19912344000005],
              [82.67139733200008, 70.18866608300004],
              [82.64380944100003, 70.18121979400007],
              [82.67351321700005, 70.16559479400007],
              [82.77564537900008, 70.14203522300005],
              [82.88306725400008, 70.08901601800005],
              [82.91928144600007, 70.08071523600006],
              [83.00123131600003, 70.08299388200004],
              [83.07162519600007, 70.07005442900004],
              [83.11109459700003, 70.06948476800005],
              [83.14942467500003, 70.07648346600007],
              [83.17676842500003, 70.08307526200008],
              [83.18572024800005, 70.09243398600006],
              [83.15772545700008, 70.09857819200005],
              [83.18165123800003, 70.10952383000006],
              [83.18873131600003, 70.12287018400008],
              [83.18295332100007, 70.13886139500005],
              [83.12973066500007, 70.20856354400007],
              [83.11304772200003, 70.21588776200008],
              [83.08513431100005, 70.22077057500007],
              [83.06527754000007, 70.23314036700003],
              [83.03419030000003, 70.26992422100005],
              [83.01441491000003, 70.28729889500005],
              [82.97193444100003, 70.31045156500005],
              [82.95167076900003, 70.32514069200005],
              [83.01303144600007, 70.33502838700008],
              [83.20541425900007, 70.31216054900005],
              [83.33741295700008, 70.31317780200004],
              [83.48389733200008, 70.33502838700008],
              [83.51889082100007, 70.33051178600005],
              [83.53443444100003, 70.33197663000004],
              [83.53516686300003, 70.33543528900003],
              [83.53370201900003, 70.34926992400005],
              [83.53443444100003, 70.35309479400007],
              [83.53858483200008, 70.35423411700003],
              [83.54688561300003, 70.35407135600008],
              [83.55128014400003, 70.35618724200003],
              [83.56666100400008, 70.36644114800004],
              [83.61361738400007, 70.38959381700005],
              [83.64584394600007, 70.39899323100008],
              [83.77466881600003, 70.47662995000007],
              [83.74512780000003, 70.50299713700008],
              [83.75098717500003, 70.52582428600005],
              [83.76441491000003, 70.54702383000006],
              [83.75733483200008, 70.56850820500006],
              [83.69516035200007, 70.60976797100005],
              [83.68458092500003, 70.62274811400005],
              [83.67367597700007, 70.64789459800005],
              [83.66480553500003, 70.66095612200007],
              [83.65088951900003, 70.67096588700008],
              [83.61491946700005, 70.68988678600005],
              [83.60271243600005, 70.70258209800005],
              [83.59864342500003, 70.71723053600005],
              [83.60157311300003, 70.72858307500007],
              [83.60678144600007, 70.73973216400003],
              [83.60962975400008, 70.75409577000005],
              [83.60157311300003, 70.76984284100007],
              [83.58269290500004, 70.78148021000004],
              [83.56006920700008, 70.78880442900004],
              [83.54102623800003, 70.79132721600007],
              [83.53549238400007, 70.79755280200004],
              [83.51343834700003, 70.83974844000005],
              [83.52076256600003, 70.84593333500004],
              [83.50757897200003, 70.86310455900008],
              [83.48780358200008, 70.90053945500006],
              [83.47608483200008, 70.91791413000004],
              [83.45582116000003, 70.93439362200007],
              [83.40552819100003, 70.95897044500003],
              [83.38306725400008, 70.97626373900005],
              [83.39942467500003, 71.00336334800005],
              [83.38184655000003, 71.03266022300005],
              [83.34766686300003, 71.05609772300005],
              [83.31568444100003, 71.06565989800004],
              [83.16863040500004, 71.08201732000003],
              [83.15015709700003, 71.08808014500005],
              [83.13355553500003, 71.09821198100008],
              [83.11605879000007, 71.11347077000005],
              [83.24170983200008, 71.11220937700006],
              [83.25700931100005, 71.11652252800008],
              [83.23829186300003, 71.14109935100004],
              [83.20972741000003, 71.18927643400008],
              [83.15699303500003, 71.23183828300006],
              [83.14763431100005, 71.24481842700004],
              [83.15748131600003, 71.25063711100006],
              [83.17457116000003, 71.25486888200004],
              [83.21094811300003, 71.27366771000004],
              [83.26628665500004, 71.28571198100008],
              [83.29615319100003, 71.30499909100007],
              [83.34945722700007, 71.35366445500006],
              [83.37582441500007, 71.36981842700004],
              [83.38493899800005, 71.38202545800004],
              [83.37582441500007, 71.40761953300006],
              [83.37525475400008, 71.42047760600008],
              [83.37671959700003, 71.44550202000005],
              [83.38217207100007, 71.46503327000005],
              [83.39673912900008, 71.47406647300005],
              [83.41749108200008, 71.47662995000007],
              [83.44166100400008, 71.47654857000003],
              [83.49252363400007, 71.48261139500005],
              [83.54127037900008, 71.49701569200005],
              [83.56283613400007, 71.50991445500006],
              [83.61915123800003, 71.55658600500004],
              [83.63062584700003, 71.57587311400005],
              [83.62818444100003, 71.61090729400007],
              [83.61890709700003, 71.63117096600007],
              [83.59986412900008, 71.64520905200004],
              [83.56861412900008, 71.66152578300006],
              [83.54786217500003, 71.66852448100008],
              [83.54297936300003, 71.67340729400007],
              [83.54127037900008, 71.68537018400008],
              [83.53907311300003, 71.69196198100008],
              [83.53353925900007, 71.69798411700003],
              [83.52670332100007, 71.70302969000005],
              [83.45875084700003, 71.74038320500006],
              [83.41871178500003, 71.74754466400003],
              [83.41089928500003, 71.75092194200005],
              [83.40919030000003, 71.75901927300004],
              [83.41228274800005, 71.76675039300005],
              [83.41618899800005, 71.77334219000005],
              [83.41773522200003, 71.77822500200006],
              [83.41716556100005, 71.79043203300006],
              [83.41822350400008, 71.79913971600007],
              [83.41553795700008, 71.80776601800005],
              [83.40357506600003, 71.81976959800005],
              [83.36052493600005, 71.84064362200007],
              [83.25855553500003, 71.85748932500007],
              [83.16179446700005, 71.88434479400007],
              [83.05095462300005, 71.88507721600007],
              [82.96998131600003, 71.89793528900003],
              [82.78695722700007, 71.90546295800004],
              [82.76050866000008, 71.90167877800008],
              [82.73902428500008, 71.89321523600006],
              [82.72217858200008, 71.88349030200004],
              [82.70386803500008, 71.87734609600005],
              [82.67807050900007, 71.87946198100008],
              [82.66537519600007, 71.88397858300004],
              [82.65186608200008, 71.89175039300005],
              [82.64136803500008, 71.90224844000005],
              [82.63697350400008, 71.91502513200004],
              [82.62378991000008, 71.94159577000005],
              [82.59253991000008, 71.96234772300005],
              [82.47055097700007, 72.02081940300008],
              [82.43034915500004, 72.02680084800005],
              [82.38160241000008, 72.04022858300004],
              [82.32178795700008, 72.06631094000005],
              [82.27605228000004, 72.07949453300006],
              [82.18506920700008, 72.09349192900004],
              [82.22388756600003, 72.11505768400008],
              [82.26685631600003, 72.12030670800004],
              [82.29957116000008, 72.13446686400005],
              [82.30738366000008, 72.18284739800004],
              [82.30372155000003, 72.20449453300006],
              [82.29769941500007, 72.22064850500004],
              [82.28630618600005, 72.23334381700005],
              [82.26636803500008, 72.24433014500005],
              [82.23031660200007, 72.25238678600005],
              [82.21924889400003, 72.25739166900007],
              [82.21216881600003, 72.26382070500006],
              [82.20606530000003, 72.27545807500007],
              [82.19809004000007, 72.28156159100007],
              [82.18213951900003, 72.28620026200008],
              [82.16675866000008, 72.28481679900005],
              [82.13656660200007, 72.27789948100008],
              [82.12818444100003, 72.27749258000006],
              [81.94402103000004, 72.29303620000007],
              [81.86182701900003, 72.31712474200003],
              [81.58619225400008, 72.35065338700008],
              [81.20818118600005, 72.35492584800005],
              [81.15503991000008, 72.36542389500005],
              [80.90699303500008, 72.45571523600006],
              [80.85873457100007, 72.46552155200004],
              [80.83448326900003, 72.47370026200008],
              [80.79151451900003, 72.50226471600007],
              [80.70411217500003, 72.54535553600005],
              [80.71827233200008, 72.55792877800008],
              [80.77914472700007, 72.57953522300005],
              [80.77857506600003, 72.58274974200003],
              [80.77881920700008, 72.58999258000006],
              [80.78296959700003, 72.59731679900005],
              [80.79346764400003, 72.60065338700008],
              [80.80445397200003, 72.60248444200005],
              [80.81519616000008, 72.60724518400008],
              [80.83448326900003, 72.62051015800006],
              [80.79574629000007, 72.63597239800004],
              [80.68588300900007, 72.64630768400008],
              [80.66309655000003, 72.66889069200005],
              [80.65788821700005, 72.68353913000004],
              [80.63412519600007, 72.70392487200007],
              [80.62842858200008, 72.71670156500005],
              [80.63209069100003, 72.73379140800006],
              [80.64291425900007, 72.74359772300005],
              [80.69385826900003, 72.76089101800005],
              [80.75977623800003, 72.79608795800004],
              [80.77295983200008, 72.80609772300005],
              [80.77361087300005, 72.80890534100007],
              [80.77295983200008, 72.82318756700005],
              [80.77458743600005, 72.82721588700008],
              [80.77816816500007, 72.82680898600006],
              [80.78272545700008, 72.82538483300004],
              [80.78663170700008, 72.82656484600005],
              [80.80518639400003, 72.84959544500003],
              [80.81967207100007, 72.87250397300005],
              [80.84197024800005, 72.92210521000004],
              [80.82862389400003, 72.93862539300005],
              [80.81430097700007, 72.97426992400005],
              [80.80030358200008, 72.99103424700007],
              [80.78972415500004, 72.99656810100004],
              [80.77613366000008, 73.00169505400004],
              [80.76433353000004, 73.00755442900004],
              [80.75928795700008, 73.01520416900007],
              [80.75709069100003, 73.03046295800004],
              [80.75049889400003, 73.03774648600006],
              [80.68930097700007, 73.05780670800004],
              [80.65463300900007, 73.06513092700004],
              [80.50619550900007, 73.07835521000004],
              [80.46876061300003, 73.08592357000003],
              [80.43718509200005, 73.10089752800008],
              [80.46843509200005, 73.10993073100008],
              [80.51392662900008, 73.11481354400007],
              [80.59498131600003, 73.11456940300008],
              [80.56861412900008, 73.14154694200005],
              [80.52084394600007, 73.15582916900007],
              [80.40137780000003, 73.16486237200007],
              [80.32732181100005, 73.18280670800004],
              [80.30209394600007, 73.18341705900008],
              [80.25538170700008, 73.17609284100007],
              [80.23113040500004, 73.17597077000005],
              [80.27377363400007, 73.19489166900007],
              [80.32243899800005, 73.20262278900003],
              [80.46705162900008, 73.20343659100007],
              [80.48975670700008, 73.20644765800006],
              [80.53370201900003, 73.21849192900004],
              [80.55152428500008, 73.21808502800008],
              [80.56348717500003, 73.22150299700007],
              [80.56755618600005, 73.23802317900004],
              [80.52833092500003, 73.28148021000004],
              [80.43995201900003, 73.29572174700007],
              [80.34164472700007, 73.29901764500005],
              [80.27271569100003, 73.30975983300004],
              [80.25489342500003, 73.32973867400005],
              [80.28150475400008, 73.34292226800005],
              [80.32081139400003, 73.35488515800006],
              [80.34099368600005, 73.37124258000006],
              [80.34986412900008, 73.38255442900004],
              [80.37029056100005, 73.38613515800006],
              [80.39234459700003, 73.38397858300004],
              [80.40650475400008, 73.37807851800005],
              [80.41846764400003, 73.37042877800008],
              [80.42872155000003, 73.37181224200003],
              [80.48503665500004, 73.41913483300004],
              [80.49529056100005, 73.42304108300004],
              [80.56568444100003, 73.42890045800004],
              [80.58741295700008, 73.43610260600008],
              [80.60173587300005, 73.44261302300004],
              [80.61003665500004, 73.44887929900005],
              [80.61378014400003, 73.45819733300004],
              [80.61475670700008, 73.47418854400007],
              [80.62281334700003, 73.48574453300006],
              [80.64161217500003, 73.49274323100008],
              [80.66244550900007, 73.49823639500005],
              [80.67741946700005, 73.50495026200008],
              [80.63379967500003, 73.51410553600005],
              [80.54029381600003, 73.48725006700005],
              [80.50554446700005, 73.49811432500007],
              [80.51148522200003, 73.51577383000006],
              [80.51091556100005, 73.55390045800004],
              [80.51295006600003, 73.56704336100006],
              [80.53581790500004, 73.58075592700004],
              [80.57447350400008, 73.58417389500005],
              [80.83220462300005, 73.57176341400003],
              [80.91700280000003, 73.58685944200005],
              [81.25359134200005, 73.60480377800008],
              [81.31812584700003, 73.62360260600008],
              [81.52979576900003, 73.64777252800008],
              [81.95687910200007, 73.66266510600008],
              [82.30128014400003, 73.66156647300005],
              [82.57260175900007, 73.66156647300005],
              [83.06267337300005, 73.65379466400003],
              [83.48365319100003, 73.65546295800004],
              [83.72803795700008, 73.69546133000006],
              [84.04700768350006, 73.70286692900007],
              [84.36597741000003, 73.71027252800008],
              [84.57178795700008, 73.75299713700008],
              [84.79322350400008, 73.76471588700008],
              [84.92790774800005, 73.73297760600008],
              [85.00798587300005, 73.71039459800005],
              [85.02947024800005, 73.70941803600005],
              [85.09742272200003, 73.71723053600005],
              [85.42701256600003, 73.71190013200004],
              [85.47242272200003, 73.71979401200008],
              [85.49447675900007, 73.73773834800005],
              [85.48951256600003, 73.74457428600005],
              [85.47836347700007, 73.75177643400008],
              [85.47217858200008, 73.75975169500003],
              [85.48064212300005, 73.76902903900003],
              [85.52182050900007, 73.78611888200004],
              [85.57048587300005, 73.81293366100005],
              [85.58545983200008, 73.81867096600007],
              [85.60425866000003, 73.82192617400005],
              [85.86841881600003, 73.82404205900008],
              [86.01612389400003, 73.86652252800008],
              [86.39966881600003, 73.88438548400006],
              [86.78321373800003, 73.90224844000005],
              [87.08008873800003, 73.87152741100005],
              [87.09848066500007, 73.86123281500005],
              [87.10352623800003, 73.84487539300005],
              [87.09522545700008, 73.83510976800005],
              [87.06373131600003, 73.82025788000004],
              [87.05152428500003, 73.80890534100007],
              [87.03956139400003, 73.79511139500005],
              [87.02662194100003, 73.78359609600005],
              [87.01075280000003, 73.77871328300006],
              [86.86329186300003, 73.76483795800004],
              [86.82325280000003, 73.75067780200004],
              [86.74773196700005, 73.71381256700005],
              [86.72348066500007, 73.70555247600004],
              [86.67017662900008, 73.69717031500005],
              [86.61939537900008, 73.68276601800005],
              [86.51978600400008, 73.67230866100005],
              [86.39616946700005, 73.62482330900008],
              [86.27540123800003, 73.60053131700005],
              [86.11622155000003, 73.58783600500004],
              [85.97478274800005, 73.53367747600004],
              [85.89185631600003, 73.51862213700008],
              [85.83350670700008, 73.49494049700007],
              [85.81666100400008, 73.49135976800005],
              [85.78679446700005, 73.48078034100007],
              [85.78451582100007, 73.45575592700004],
              [85.80298912900008, 73.40253327000005],
              [85.80144290500004, 73.38873932500007],
              [85.79753665500004, 73.37689850500004],
              [85.79721113400007, 73.36481354400007],
              [85.80640709700003, 73.35073476800005],
              [85.81950931100005, 73.33974844000005],
              [85.83318118600005, 73.33177317900004],
              [85.84791100400008, 73.32575104400007],
              [85.91431725400008, 73.30744049700007],
              [86.23373457100007, 73.25486888200004],
              [86.24740644600007, 73.23802317900004],
              [86.25489342500003, 73.23126862200007],
              [86.24740644600007, 73.22382233300004],
              [86.32862389400003, 73.18060944200005],
              [86.52279707100007, 73.16347890800006],
              [86.61182701900003, 73.13812897300005],
              [86.62867272200003, 73.13125234600005],
              [86.66334069100003, 73.12213776200008],
              [86.68018639400003, 73.11456940300008],
              [86.69190514400003, 73.10590241100005],
              [86.71314537900008, 73.08368561400005],
              [86.72046959700003, 73.07294342700004],
              [86.72413170700008, 73.06313711100006],
              [86.72852623800003, 73.04291413000004],
              [86.73414147200003, 73.03266022300005],
              [86.74537194100003, 73.02130768400008],
              [86.75945071700005, 73.01166413000004],
              [86.77442467500003, 73.00397370000007],
              [86.78248131600003, 73.00088125200006],
              [86.78199303500003, 73.04604726800005],
              [86.77711022200003, 73.06549713700008],
              [86.76547285200007, 73.08356354400007],
              [86.74187259200005, 73.10455963700008],
              [86.65967858200008, 73.15180084800005],
              [86.62273196700005, 73.16640859600005],
              [86.58383222700007, 73.17597077000005],
              [86.51221764400003, 73.18032461100006],
              [86.48975670700008, 73.18463776200008],
              [86.46021569100003, 73.19782135600008],
              [86.40951582100007, 73.23037344000005],
              [86.37777754000007, 73.24428945500006],
              [86.25025475400008, 73.27732982000003],
              [85.93392988400007, 73.32391998900005],
              [85.89380944100003, 73.33966705900008],
              [85.86150149800005, 73.36440664300005],
              [85.85230553500003, 73.37518952000005],
              [85.84961998800003, 73.38165924700007],
              [85.85027103000004, 73.40253327000005],
              [85.85141035200007, 73.40566640800006],
              [85.85718834700003, 73.41693756700005],
              [85.85840905000003, 73.42304108300004],
              [85.85613040500004, 73.42682526200008],
              [85.84620201900003, 73.43455638200004],
              [85.84400475400008, 73.43984609600005],
              [85.88233483200008, 73.49624258000006],
              [85.97169030000003, 73.51923248900005],
              [86.07422936300003, 73.52826569200005],
              [86.20362389400003, 73.55784739800004],
              [86.48812910250004, 73.57082754100006],
              [86.77263431100005, 73.58380768400008],
              [86.84489993600005, 73.60626862200007],
              [87.11158287900008, 73.60492584800005],
              [87.16480553500003, 73.61139557500007],
              [87.20460045700008, 73.63157786700003],
              [87.23633873800003, 73.65281810100004],
              [87.31202233200008, 73.68252187700006],
              [87.34424889400003, 73.70416901200008],
              [87.32349694100003, 73.70840078300006],
              [87.27328535200007, 73.68976471600007],
              [87.24870853000004, 73.69057851800005],
              [87.28052819100003, 73.72992584800005],
              [87.32715905000003, 73.75315989800004],
              [87.55713951900003, 73.80174388200004],
              [87.61736087300005, 73.82355377800008],
              [87.65333092500003, 73.86123281500005],
              [87.64584394600007, 73.86806875200006],
              [87.66407311300003, 73.89085521000004],
              [87.64535566500007, 73.90558502800008],
              [87.61068769600007, 73.91351959800005],
              [87.58073978000004, 73.91583893400008],
              [87.54493248800003, 73.91429271000004],
              [87.53052819100003, 73.90741608300004],
              [87.52857506600003, 73.89199453300006],
              [87.52979576900003, 73.86465078300006],
              [87.51710045700008, 73.85028717700004],
              [87.48755944100003, 73.83584219000005],
              [87.45427493600005, 73.82469310100004],
              [87.43018639400003, 73.82025788000004],
              [87.36280358200008, 73.82697174700007],
              [87.29639733200008, 73.84137604400007],
              [87.24008222700007, 73.86082591400003],
              [87.18718509200005, 73.88857656500005],
              [87.16667728000004, 73.89655182500007],
              [87.15674889400003, 73.90281810100004],
              [87.15251712300005, 73.91242096600007],
              [87.15015709700003, 73.92422109600005],
              [87.14454186300003, 73.93060944200005],
              [87.11744225400008, 73.94676341400003],
              [87.09083092500003, 73.95490143400008],
              [87.08073978000004, 73.96088288000004],
              [87.04322350400008, 73.99217357000003],
              [86.96306399800005, 74.01776764500005],
              [86.94019616000003, 74.03314850500004],
              [86.99740644600007, 74.04979075700004],
              [87.25733483200008, 74.03912995000007],
              [87.36622155000003, 74.01072825700004],
              [87.41993248800003, 74.01211172100005],
              [87.36231530000003, 74.04775625200006],
              [87.29078209700003, 74.06268952000005],
              [86.89576256600003, 74.07021719000005],
              [86.85075931100005, 74.08779531500005],
              [86.85515384200005, 74.09223053600005],
              [86.85865319100003, 74.09747955900008],
              [86.86451256600003, 74.10830312700006],
              [86.84506269600007, 74.11481354400007],
              [86.73357181100005, 74.12872955900008],
              [86.72388756600003, 74.13214752800008],
              [86.73023522200003, 74.14345937700006],
              [86.80298912900008, 74.18402741100005],
              [86.75733483200008, 74.20774974200003],
              [86.71143639400003, 74.22435130400004],
              [86.66334069100003, 74.23590729400007],
              [86.50562584700003, 74.25527578300006],
              [86.02003014400003, 74.26251862200007],
              [85.97437584700003, 74.27619049700007],
              [85.94874108200008, 74.29262929900005],
              [85.94890384200005, 74.29950592700004],
              [85.95826256600003, 74.30585358300004],
              [85.96013431100005, 74.32054271000004],
              [85.94874108200008, 74.32892487200007],
              [85.92945397200003, 74.33331940300008],
              [85.91187584700003, 74.33978913000004],
              [85.90552819100003, 74.35468170800004],
              [85.93669681100005, 74.36810944200005],
              [86.15853925900007, 74.35765208500004],
              [86.23975670700008, 74.33331940300008],
              [86.28679446700005, 74.31293366100005],
              [86.29712975400008, 74.31305573100008],
              [86.30502363400007, 74.31793854400007],
              [86.30958092500003, 74.32802969000005],
              [86.30844160200007, 74.33905670800004],
              [86.30111738400007, 74.34137604400007],
              [86.29102623800003, 74.34198639500005],
              [86.28158613400007, 74.34784577000005],
              [86.26392662900008, 74.38019440300008],
              [86.25489342500003, 74.38886139500005],
              [86.23226972700007, 74.39752838700008],
              [86.20215905000003, 74.40151601800005],
              [86.09571373800003, 74.40399811400005],
              [86.07178795700008, 74.40802643400008],
              [86.04948978000004, 74.41616445500006],
              [86.06950931100005, 74.42352936400005],
              [86.09245853000004, 74.42536041900007],
              [86.13819420700008, 74.42357005400004],
              [86.20118248800003, 74.43134186400005],
              [86.25391686300003, 74.41950104400007],
              [86.28451582100007, 74.42645905200004],
              [86.31576582100007, 74.43797435100004],
              [86.47527103000004, 74.45819733300004],
              [86.57276451900003, 74.44334544500003],
              [86.59066816500007, 74.43724192900004],
              [86.60173587300005, 74.42918528900003],
              [86.61060631600003, 74.42011139500005],
              [86.62175540500004, 74.41278717700004],
              [86.63917076900003, 74.40989817900004],
              [86.60759524800005, 74.40021393400008],
              [86.59750410200007, 74.39569733300004],
              [86.62354576900003, 74.38751862200007],
              [86.65162194100003, 74.38788483300004],
              [86.70679772200003, 74.39569733300004],
              [86.72730553500003, 74.39476146000004],
              [86.78248131600003, 74.38263580900008],
              [86.80152428500003, 74.38247304900005],
              [86.85075931100005, 74.39569733300004],
              [86.87696373800003, 74.39630768400008],
              [86.92823326900003, 74.38947174700007],
              [86.95386803500003, 74.38886139500005],
              [86.92676842500003, 74.36505768400008],
              [86.88624108200008, 74.35053131700005],
              [86.78174889400003, 74.32973867400005],
              [86.71713300900007, 74.32514069200005],
              [86.70053144600007, 74.32054271000004],
              [86.69898522200003, 74.30711497600004],
              [86.71583092500003, 74.30182526200008],
              [86.73902428500003, 74.30194733300004],
              [86.78174889400003, 74.30707428600005],
              [86.83301842500003, 74.30158112200007],
              [86.85816491000003, 74.30630117400005],
              [86.90650475400008, 74.33527252800008],
              [86.92652428500003, 74.34100983300004],
              [86.94890384200005, 74.34259674700007],
              [86.95972741000003, 74.33885325700004],
              [86.98764082100007, 74.30581289300005],
              [86.99105879000007, 74.29608795800004],
              [86.98536217500003, 74.28742096600007],
              [86.96802819100003, 74.27960846600007],
              [86.99293053500003, 74.27024974200003],
              [87.02084394600007, 74.27301666900007],
              [87.04281660200007, 74.28583405200004],
              [87.05005944100003, 74.30630117400005],
              [87.04135175900007, 74.32168203300006],
              [87.00977623800003, 74.34568919500003],
              [87.00220787900008, 74.35468170800004],
              [87.01596113400007, 74.36725495000007],
              [87.05062910200007, 74.36627838700008],
              [87.11833743600005, 74.35468170800004],
              [87.26238040500004, 74.35468170800004],
              [87.23292076900003, 74.36375560100004],
              [87.12549889400003, 74.37579987200007],
              [87.10718834700003, 74.37986888200004],
              [87.08008873800003, 74.38996002800008],
              [87.06031334700003, 74.40216705900008],
              [87.06397545700008, 74.41303131700005],
              [87.08790123800003, 74.42621491100005],
              [87.09245853000004, 74.43598053600005],
              [87.07911217500003, 74.44204336100006],
              [87.05005944100003, 74.44403717700004],
              [86.79590905000003, 74.42357005400004],
              [86.78695722700007, 74.42601146000004],
              [86.77662194100003, 74.43870677300004],
              [86.76889082100007, 74.44403717700004],
              [86.75424238400007, 74.44647858300004],
              [86.72095787900008, 74.44708893400008],
              [86.70679772200003, 74.45087311400005],
              [86.70240319100003, 74.45600006700005],
              [86.69450931100005, 74.47186920800004],
              [86.68685957100007, 74.47821686400005],
              [86.67156009200005, 74.48248932500007],
              [86.64087975400008, 74.48257070500006],
              [86.62549889400003, 74.48436107000003],
              [86.60132897200003, 74.50104401200008],
              [86.59066816500007, 74.50556061400005],
              [86.54883873800003, 74.50714752800008],
              [86.53549238400007, 74.51235586100006],
              [86.56446373800003, 74.52505117400005],
              [86.75831139400003, 74.54718659100007],
              [86.78248131600003, 74.56073639500005],
              [86.49146569100003, 74.56696198100008],
              [86.48121178500003, 74.56891510600008],
              [86.45508873800003, 74.57827383000006],
              [86.43995201900003, 74.58124420800004],
              [86.38746178500003, 74.58242422100005],
              [86.37012780000003, 74.58584219000005],
              [86.32471764400003, 74.60333893400008],
              [86.30884850400008, 74.60626862200007],
              [86.27711022200003, 74.60736725500004],
              [86.19385826900003, 74.62197500200006],
              [85.74040774800005, 74.63589101800005],
              [85.76685631600003, 74.65253327000005],
              [85.79867597700007, 74.66217682500007],
              [85.86451256600003, 74.67059967700004],
              [85.83432050900007, 74.68691640800006],
              [85.84245853000004, 74.70115794500003],
              [85.90015709700003, 74.72329336100006],
              [85.93799889400003, 74.72797272300005],
              [86.01612389400003, 74.71478913000004],
              [86.05632571700005, 74.71775950700004],
              [86.07642662900008, 74.72431061400005],
              [86.10108483200008, 74.73578522300005],
              [86.12061608200008, 74.75193919500003],
              [86.12525475400008, 74.77301666900007],
              [86.10987389400003, 74.78803131700005],
              [86.02833092500003, 74.81395091400003],
              [86.04322350400008, 74.81952545800004],
              [86.05860436300003, 74.82135651200008],
              [86.09058678500003, 74.82078685100004],
              [86.10336347700007, 74.81867096600007],
              [86.10914147200003, 74.81395091400003],
              [86.11345462300005, 74.80927155200004],
              [86.12183678500003, 74.80719635600008],
              [86.19662519600007, 74.81069570500006],
              [86.22087649800005, 74.80719635600008],
              [86.28028405000003, 74.78314850500004],
              [86.30225670700008, 74.77985260600008],
              [86.34693444100003, 74.78082916900007],
              [86.36703535200007, 74.77505117400005],
              [86.37777754000007, 74.75873444200005],
              [86.21338951900003, 74.76557038000004],
              [86.22982832100007, 74.75511302300004],
              [86.28223717500003, 74.73484935100004],
              [86.32146243600005, 74.70766836100006],
              [86.33692467500003, 74.70408763200004],
              [86.35450280000003, 74.70644765800006],
              [86.36475670700008, 74.71206289300005],
              [86.37476647200003, 74.71898021000004],
              [86.39144941500007, 74.72528717700004],
              [86.41114342500003, 74.72760651200008],
              [86.47396894600007, 74.72528717700004],
              [86.63917076900003, 74.69733307500007],
              [86.63363691500007, 74.68744538000004],
              [86.60759524800005, 74.67450592700004],
              [86.60499108200008, 74.66315338700008],
              [86.61841881600003, 74.65566640800006],
              [86.64332116000003, 74.65399811400005],
              [86.68685957100007, 74.65631745000007],
              [86.68116295700008, 74.65371328300006],
              [86.66651451900003, 74.64264557500007],
              [86.69166100400008, 74.62189362200007],
              [86.71713300900007, 74.61774323100008],
              [86.77515709700003, 74.62905508000006],
              [86.80787194100003, 74.63153717700004],
              [86.84213300900007, 74.63027578300006],
              [86.87623131600003, 74.62539297100005],
              [86.93946373800003, 74.60932038000004],
              [86.95753014400003, 74.60883209800005],
              [86.96802819100003, 74.61542389500005],
              [86.96517988400007, 74.62506745000007],
              [86.95215905000003, 74.63051992400005],
              [86.92652428500003, 74.63589101800005],
              [86.90259850400008, 74.65412018400008],
              [86.90935306100005, 74.66327545800004],
              [86.93148847700007, 74.67059967700004],
              [86.95386803500003, 74.68366120000007],
              [86.90601647200003, 74.69061920800004],
              [86.79468834700003, 74.68504466400003],
              [86.76205488400007, 74.70408763200004],
              [86.77564537900008, 74.70897044500003],
              [86.80298912900008, 74.71356842700004],
              [86.81666100400008, 74.71775950700004],
              [86.80982506600003, 74.72528717700004],
              [86.85873457100007, 74.74607982000003],
              [86.91423587300005, 74.75771719000005],
              [86.96802819100003, 74.75543854400007],
              [87.01246178500003, 74.73484935100004],
              [87.02279707100007, 74.72858307500007],
              [87.03728274800005, 74.72353750200006],
              [87.05201256600003, 74.72166575700004],
              [87.06373131600003, 74.72528717700004],
              [87.06560306100005, 74.73094310100004],
              [87.06421959700003, 74.74872467700004],
              [87.06739342500003, 74.75560130400004],
              [87.08171634200005, 74.77301666900007],
              [87.07374108200008, 74.78156159100007],
              [87.05494225400008, 74.78807200700004],
              [87.03638756600003, 74.79975006700005],
              [87.06128991000003, 74.83966705900008],
              [87.09717858200008, 74.86212799700007],
              [87.26579837300005, 74.91356028900003],
              [87.31128991000003, 74.91966380400004],
              [87.36646569100003, 74.93520742400005],
              [87.38575280000003, 74.94432200700004],
              [87.36394290500004, 74.95746491100005],
              [87.33432050900007, 74.96092357000003],
              [87.27523847700007, 74.95799388200004],
              [87.25025475400008, 74.96133047100005],
              [87.17286217500003, 74.98529694200005],
              [87.21273847700007, 75.00291575700004],
              [87.26954186300003, 75.01162344000005],
              [87.32748457100007, 75.01276276200008],
              [87.38493899800005, 75.00584544500003],
              [87.41244550900007, 75.00678131700005],
              [87.42628014400003, 75.00580475500004],
              [87.43580162900008, 75.00263092700004],
              [87.45508873800003, 74.99347565300008],
              [87.47999108200008, 74.98725006700005],
              [87.47152754000007, 74.97797272300005],
              [87.45199629000007, 74.96881745000007],
              [87.43360436300003, 74.96482982000003],
              [87.44548587300005, 74.95327383000006],
              [87.46656334700003, 74.94822825700004],
              [87.50928795700008, 74.94432200700004],
              [87.55225670700008, 74.93138255400004],
              [87.57406660200007, 74.92967357000003],
              [87.59815514400003, 74.93691640800006],
              [87.55665123800003, 74.96141185100004],
              [87.56373131600003, 74.96482982000003],
              [87.63868248800003, 74.97223541900007],
              [87.66635175900007, 74.97809479400007],
              [87.69507897200003, 74.99115631700005],
              [87.70606530000003, 75.00482819200005],
              [87.68002363400007, 75.01264069200005],
              [87.73617597700007, 75.01373932500007],
              [87.76368248800003, 75.01776764500005],
              [87.78988691500007, 75.02627187700006],
              [87.73218834700003, 75.03864166900007],
              [87.45492597700007, 75.03896719000005],
              [87.42530358200008, 75.04498932500007],
              [87.41211998800003, 75.04564036700003],
              [87.38013756600003, 75.03937409100007],
              [87.36475670700008, 75.03994375200006],
              [87.35425866000003, 75.04389069200005],
              [87.32374108200008, 75.06037018400008],
              [87.26783287900008, 75.07294342700004],
              [87.03516686300003, 75.09267812700006],
              [87.00855553500003, 75.09015534100007],
              [86.94076582100007, 75.07404205900008],
              [86.91944420700008, 75.07611725500004],
              [86.89861087300005, 75.08771393400008],
              [86.91871178500003, 75.11127350500004],
              [86.93718509200005, 75.12661367400005],
              [86.98804772200003, 75.15322500200006],
              [87.02458743600005, 75.16421133000006],
              [87.20118248800003, 75.16917552300004],
              [87.53907311300003, 75.14109935100004],
              [87.58790123800003, 75.14301178600005],
              [87.91187584700003, 75.10077545800004],
              [87.95264733200008, 75.10004303600005],
              [87.99252363400007, 75.10691966400003],
              [88.08326256600003, 75.14398834800005],
              [88.11670983200008, 75.14598216400003],
              [88.13941491000003, 75.12872955900008],
              [88.16928144600007, 75.15005117400005],
              [88.20972741000003, 75.15859609600005],
              [88.25310306100005, 75.16254303600005],
              [88.29078209700003, 75.17023346600007],
              [88.30665123800003, 75.17601146000004],
              [88.31446373800003, 75.18085358300004],
              [88.31714928500003, 75.18992747600004],
              [88.31771894600007, 75.21849192900004],
              [88.32007897200003, 75.22703685100004],
              [88.32618248800003, 75.23456452000005],
              [88.33822675900007, 75.24225495000007],
              [88.37134850400008, 75.25531647300005],
              [88.48194420700008, 75.27952708500004],
              [88.51791425900007, 75.28266022300005],
              [88.62598717500003, 75.26650625200006],
              [88.61280358200008, 75.28241608300004],
              [88.59310957100007, 75.29588450700004],
              [88.55030358200008, 75.31427643400008],
              [88.61166425900007, 75.34422435100004],
              [88.75261478000004, 75.35073476800005],
              [88.81836998800003, 75.36204661700003],
              [88.76986738400007, 75.37567780200004],
              [88.84253991000003, 75.39862702000005],
              [88.92457116000003, 75.41225820500006],
              [89.00847415500004, 75.41445547100005],
              [89.08521569100003, 75.40302155200004],
              [89.05640709700003, 75.42568594000005],
              [89.00717207100007, 75.43353913000004],
              [88.73585045700008, 75.40985748900005],
              [88.75717207100007, 75.41665273600006],
              [88.95085696700005, 75.44037506700005],
              [89.01636803500003, 75.45148346600007],
              [89.13233483200008, 75.45282623900005],
              [89.15162194100003, 75.45673248900005],
              [89.17017662900008, 75.46295807500007],
              [89.18767337300005, 75.47134023600006],
              [89.22925866000003, 75.50267161700003],
              [89.24577884200005, 75.50674062700006],
              [89.26205488400007, 75.50315989800004],
              [89.31120853000004, 75.47874583500004],
              [89.37305748800003, 75.47060781500005],
              [89.39380944100003, 75.46507396000004],
              [89.39519290500004, 75.44896067900004],
              [89.54053795700008, 75.44769928600005],
              [89.55884850400008, 75.44106679900005],
              [89.61003665500004, 75.45014069200005],
              [89.63168379000007, 75.44953034100007],
              [89.65333092500003, 75.44403717700004],
              [89.67872155000003, 75.44155508000006],
              [89.70362389400003, 75.44350820500006],
              [89.72266686300003, 75.45148346600007],
              [89.69629967500003, 75.46063873900005],
              [89.62387129000007, 75.47748444200005],
              [89.61280358200008, 75.49237702000005],
              [89.63575280000003, 75.50478750200006],
              [89.85547936300003, 75.51536692900004],
              [90.05787194100003, 75.51972077000005],
              [90.03598066500007, 75.54328034100007],
              [89.99512780000003, 75.54975006700005],
              [89.94996178500003, 75.55141836100006],
              [89.91456139400003, 75.56069570500006],
              [89.95411217500003, 75.57762278900003],
              [90.31885826900003, 75.60150788000004],
              [90.59888756600003, 75.61188385600008],
              [90.75562584700003, 75.65298086100006],
              [90.81788170700008, 75.65851471600007],
              [90.86353600400008, 75.66828034100007],
              [90.88672936300003, 75.67055898600006],
              [90.90609785200007, 75.66742584800005],
              [90.91195722700007, 75.65989817900004],
              [90.91236412900008, 75.65094635600008],
              [90.91504967500003, 75.64325592700004],
              [90.94410241000003, 75.62588125200006],
              [90.97803795700008, 75.62042877800008],
              [91.01465905000003, 75.62449778900003],
              [91.05160566500007, 75.63580963700008],
              [91.10865319100003, 75.66181061400005],
              [91.12818444100003, 75.66571686400005],
              [91.19499759200005, 75.66372304900005],
              [91.18620853000004, 75.64280833500004],
              [91.21729576900003, 75.63214752800008],
              [91.29127037900008, 75.62897370000007],
              [91.45093834700003, 75.65009186400005],
              [91.58025149800005, 75.63776276200008],
              [91.62086022200003, 75.64325592700004],
              [91.64210045700008, 75.65436432500007],
              [91.64877363400007, 75.66864655200004],
              [91.64144941500007, 75.68414948100008],
              [91.62086022200003, 75.69847239800004],
              [91.65902754000007, 75.72378164300005],
              [91.70020592500003, 75.73639557500007],
              [91.74293053500003, 75.73607005400004],
              [91.78467858200008, 75.72235748900005],
              [91.81202233200008, 75.71662018400008],
              [91.90121504000007, 75.73261139500005],
              [92.00782311300003, 75.72577545800004],
              [92.08521569100003, 75.73574453300006],
              [92.22559655000003, 75.75372955900008],
              [92.37134850400008, 75.74046458500004],
              [92.51628665500004, 75.77293528900003],
              [92.86117597700007, 75.79344310100004],
              [93.18572024800005, 75.82656484600005],
              [93.54981530000003, 75.85301341400003],
              [93.80140221450006, 75.88422272350005],
              [94.05298912900008, 75.91543203300006],
              [94.14307701900003, 75.94131094000005],
              [94.16309655000003, 75.94428131700005],
              [94.14421634200005, 75.95514557500007],
              [94.11353600400008, 75.94904205900008],
              [94.08025149800005, 75.93707916900007],
              [94.05298912900008, 75.93060944200005],
              [93.74048912900008, 75.90021393400008],
              [93.66431725400008, 75.90224844000005],
              [93.59400475400008, 75.91693756700005],
              [93.60303795700008, 75.93891022300005],
              [93.58057701900003, 75.95075104400007],
              [93.54607181100005, 75.95343659100007],
              [93.51880944100003, 75.94798411700003],
              [93.46143639400003, 75.92112864800004],
              [93.44792728000004, 75.90859609600005],
              [93.47429446700005, 75.90326569200005],
              [93.49439537900008, 75.89533112200007],
              [93.46387780000003, 75.88060130400004],
              [93.41895592500003, 75.87287018400008],
              [93.39600670700008, 75.88593170800004],
              [93.38493899800005, 75.89687734600005],
              [93.31332441500007, 75.93060944200005],
              [93.32016035200007, 75.93744538000004],
              [93.30445397200003, 75.94204336100006],
              [93.27312259200005, 75.94578685100004],
              [93.25814863400007, 75.95172760600008],
              [93.27344811300003, 75.95897044500003],
              [93.32016035200007, 75.97223541900007],
              [93.27735436300003, 75.98212311400005],
              [93.23121178500003, 75.97744375200006],
              [93.14210045700008, 75.95795319200005],
              [93.00586998800003, 75.94403717700004],
              [92.96404056100005, 75.93060944200005],
              [93.00025475400008, 75.92853424700007],
              [93.07203209700003, 75.91250234600005],
              [93.10792076900003, 75.91079336100006],
              [93.07146243600005, 75.88939036700003],
              [93.00700931100005, 75.88666413000004],
              [92.88819420700008, 75.89647044500003],
              [92.88819420700008, 75.90326569200005],
              [92.90170332100007, 75.91290924700007],
              [92.88428795700008, 75.93402741100005],
              [92.85352623800003, 75.95526764500005],
              [92.82683353000004, 75.96539948100008],
              [92.85141035200007, 75.97577545800004],
              [92.92920983200008, 75.99266185100004],
              [92.91814212300005, 76.00438060100004],
              [92.91163170700008, 76.01797109600005],
              [92.91407311300003, 76.02903880400004],
              [92.92920983200008, 76.03363678600005],
              [92.92383873800003, 76.05329010600008],
              [92.95248457100007, 76.06683991100005],
              [92.99341881600003, 76.07420482000003],
              [93.02491295700008, 76.07526276200008],
              [93.04070071700005, 76.07147858300004],
              [93.05193118600005, 76.06525299700007],
              [93.09522545700008, 76.02777741100005],
              [93.10108483200008, 76.02374909100007],
              [93.12598717500003, 76.02435944200005],
              [93.21070397200003, 76.04328034100007],
              [93.23080488400007, 76.05414459800005],
              [93.21949303500003, 76.07062409100007],
              [93.14625084700003, 76.08567942900004],
              [93.12094160200007, 76.09568919500003],
              [93.25912519600007, 76.09638092700004],
              [93.31348717500003, 76.10626862200007],
              [93.43034915500004, 76.10687897300005],
              [93.42945397200003, 76.09910716400003],
              [93.35336347700007, 76.08071523600006],
              [93.33383222700007, 76.06777578300006],
              [93.35222415500004, 76.05719635600008],
              [93.37574303500003, 76.05097077000005],
              [93.42204837300005, 76.04730866100005],
              [93.41586347700007, 76.03904857000003],
              [93.38795006600003, 76.02065664300005],
              [93.42701256600003, 76.01203034100007],
              [93.46322675900007, 76.01947663000004],
              [93.53191165500004, 76.04730866100005],
              [93.55469811300003, 76.05027903900003],
              [93.62818444100003, 76.04730866100005],
              [93.68482506600003, 76.05971914300005],
              [93.70394941500007, 76.06159088700008],
              [93.72095787900008, 76.05874258000006],
              [93.74822024800005, 76.04498932500007],
              [93.76531009200005, 76.04047272300005],
              [93.78500410200007, 76.04144928600005],
              [93.82740319100003, 76.05158112200007],
              [93.84791100400008, 76.05414459800005],
              [93.96070397200003, 76.04832591400003],
              [93.99870853000004, 76.05414459800005],
              [93.95573978000004, 76.07518138200004],
              [93.93490644600007, 76.08047109600005],
              [93.88160241000003, 76.07367584800005],
              [93.85531660200007, 76.07835521000004],
              [93.80681399800005, 76.09910716400003],
              [93.78353925900007, 76.10297272300005],
              [93.68978925900007, 76.09568919500003],
              [93.67432701900003, 76.09935130400004],
              [93.65251712300005, 76.11701080900008],
              [93.63550866000003, 76.12299225500004],
              [93.68580162900008, 76.13226959800005],
              [94.10230553500003, 76.12250397300005],
              [94.20134524800005, 76.10480377800008],
              [94.25025475400008, 76.11054108300004],
              [94.27515709700003, 76.11725495000007],
              [94.32894941500007, 76.12384674700007],
              [94.37419681100005, 76.12079498900005],
              [94.38965905000003, 76.11652252800008],
              [94.39478600400008, 76.10871002800008],
              [94.38233483200003, 76.09568919500003],
              [94.40406334700003, 76.09564850500004],
              [94.42839603000004, 76.09174225500004],
              [94.45191491000003, 76.08470286700003],
              [94.47152754000007, 76.07526276200008],
              [94.43677819100003, 76.06159088700008],
              [94.45948326900003, 76.05170319200005],
              [94.48080488400007, 76.05182526200008],
              [94.52621504000007, 76.06159088700008],
              [94.57300866000003, 76.06118398600006],
              [94.59546959700003, 76.06391022300005],
              [94.61500084700003, 76.07526276200008],
              [94.58716881600003, 76.08462148600006],
              [94.58676191500007, 76.09235260600008],
              [94.60434004000007, 76.09955475500004],
              [94.65691165500004, 76.11302317900004],
              [94.73853600400008, 76.11562734600005],
              [94.70980879000007, 76.13947174700007],
              [94.64991295700003, 76.14911530200004],
              [94.53988691500007, 76.14972565300008],
              [94.57276451900003, 76.15997955900008],
              [94.83472741000003, 76.14972565300008],
              [94.85474694100003, 76.14264557500007],
              [94.89039147200003, 76.12323639500005],
              [94.90984134200005, 76.11562734600005],
              [94.93213951900003, 76.11176178600005],
              [95.05543053500003, 76.11200592700004],
              [95.15333092500003, 76.13222890800006],
              [95.25505618600005, 76.12319570500006],
              [95.34131920700003, 76.15497467700004],
              [95.38982181100005, 76.16400788000004],
              [95.87289472700007, 76.13812897300005],
              [95.97510826900003, 76.11420319200005],
              [96.02670332100007, 76.10871002800008],
              [96.11052493600005, 76.11066315300008],
              [96.13705488400007, 76.10712311400005],
              [96.17725670700003, 76.09625885600008],
              [96.19646243600005, 76.08755117400005],
              [96.19255618600005, 76.07977936400005],
              [96.14340254000007, 76.07587311400005],
              [96.03760826900003, 76.08136627800008],
              [95.99293053500003, 76.06159088700008],
              [96.03923587300005, 76.06342194200005],
              [96.06120853000004, 76.05963776200008],
              [96.07496178500003, 76.04730866100005],
              [96.05095462300005, 76.04677969000005],
              [95.97868899800005, 76.03363678600005],
              [96.00806725400008, 76.00934479400007],
              [96.01270592500003, 76.00263092700004],
              [96.00489342500003, 75.99335358300004],
              [95.98666425900007, 75.99095286700003],
              [95.95142662900008, 75.99266185100004],
              [95.91846764400003, 75.98940664300005],
              [95.85132897200003, 75.97431061400005],
              [95.71143639400003, 75.90704987200007],
              [95.67847741000003, 75.89883047100005],
              [95.60547936300003, 75.89862702000005],
              [95.57520592500003, 75.88898346600007],
              [95.67888431100005, 75.86212799700007],
              [95.73951256600003, 75.85643138200004],
              [95.76636803500003, 75.87287018400008],
              [95.77369225400008, 75.88279857000003],
              [95.79021243600005, 75.89647044500003],
              [95.82097415500004, 75.91693756700005],
              [95.84245853000004, 75.92450592700004],
              [95.88892662900008, 75.93341705900008],
              [95.93726647200003, 75.94916413000004],
              [95.99187259200005, 75.95034414300005],
              [96.07642662900008, 75.96157461100006],
              [96.10515384200005, 75.96088288000004],
              [96.13013756600003, 75.95477936400005],
              [96.17310631600003, 75.94989655200004],
              [96.30925540500004, 75.95880768400008],
              [96.34180748800003, 75.97223541900007],
              [96.32260175900007, 75.97361888200004],
              [96.30201256600003, 75.97833893400008],
              [96.28248131600003, 75.98501211100006],
              [96.26596113400007, 75.99266185100004],
              [96.30111738400007, 75.99933502800008],
              [96.37452233200003, 75.99534739800004],
              [96.40919030000003, 76.00088125200006],
              [96.44044030000003, 76.00950755400004],
              [96.47982832100007, 76.01561107000003],
              [96.51856530000003, 76.01577383000006],
              [96.54786217500003, 76.00633372600004],
              [96.53435306100005, 76.00210195500006],
              [96.52125084700003, 75.99640534100007],
              [96.50961347700007, 75.98871491100005],
              [96.50001061300003, 75.97842031500005],
              [96.59099368600005, 75.98729075700004],
              [96.63868248800003, 75.98468659100007],
              [96.66456139400003, 75.96539948100008],
              [96.63542728000004, 75.96165599200003],
              [96.57390384200005, 75.93756745000007],
              [96.46387780000003, 75.88003164300005],
              [96.43799889400003, 75.87596263200004],
              [96.46143639400003, 75.87189362200007],
              [96.56625410200007, 75.88495514500005],
              [96.63721764400003, 75.90326569200005],
              [96.68637129000007, 75.90672435100004],
              [96.78516686300003, 75.89061107000003],
              [96.83521569100003, 75.88898346600007],
              [96.83057701900003, 75.91543203300006],
              [96.86296634200005, 75.92804596600007],
              [96.93783613400007, 75.93569570500006],
              [96.95045006600003, 75.94082265800006],
              [96.97950280000003, 75.95945872600004],
              [96.98975670700003, 75.96881745000007],
              [97.00261478000004, 75.97524648600006],
              [97.06177819100003, 75.98582591400003],
              [97.20582116000003, 76.03363678600005],
              [97.25098717500003, 76.04340241100005],
              [97.39682050900007, 76.04730866100005],
              [97.19922936300003, 75.99310944200005],
              [97.19157962300005, 75.98212311400005],
              [97.19874108200003, 75.97581614800004],
              [97.24675540500004, 75.95795319200005],
              [97.21355228000004, 75.94920482000003],
              [97.19825280000003, 75.94236888200004],
              [97.18531334700003, 75.93060944200005],
              [97.21949303500003, 75.92865631700005],
              [97.31226647200003, 75.93451569200005],
              [97.34229576900003, 75.94428131700005],
              [97.31348717500003, 75.95490143400008],
              [97.31714928500003, 75.96527741100005],
              [97.36500084700003, 75.98387278900003],
              [97.39437910200007, 75.98871491100005],
              [97.45606530000003, 75.98334381700005],
              [97.51921634200005, 75.99176666900007],
              [97.63795006600003, 75.98993561400005],
              [97.68474368600005, 75.97907135600008],
              [97.70606530000003, 75.97842031500005],
              [97.82390384200005, 75.98810455900008],
              [97.84253991000003, 75.99237702000005],
              [97.83619225400008, 76.00901927300004],
              [97.82056725400008, 76.01878489800004],
              [97.70093834700003, 76.05149974200003],
              [97.67139733200003, 76.05414459800005],
              [97.57960045700003, 76.04779694200005],
              [97.54835045700003, 76.05414459800005],
              [97.62582441500007, 76.08193594000005],
              [97.71216881600003, 76.09609609600005],
              [97.79859459700003, 76.09454987200007],
              [97.87728925900007, 76.07526276200008],
              [97.86988366000003, 76.06777578300006],
              [97.91285241000003, 76.05931224200003],
              [97.96045983200003, 76.06220123900005],
              [98.09546959700003, 76.08783600500004],
              [98.14389082100007, 76.08828359600005],
              [98.16138756600003, 76.09080638200004],
              [98.19971764400003, 76.10122304900005],
              [98.21998131600003, 76.10252513200004],
              [98.01872806100005, 76.10529205900008],
              [97.91773522200003, 76.12299225500004],
              [97.97144616000003, 76.14398834800005],
              [98.02759850400008, 76.15717194200005],
              [98.05176842500003, 76.15680573100008],
              [98.09603925900007, 76.14638906500005],
              [98.11841881600003, 76.14809804900005],
              [98.12859134200005, 76.15330638200004],
              [98.14356530000003, 76.16852448100008],
              [98.15105228000004, 76.17426178600005],
              [98.16537519600007, 76.17829010600008],
              [98.34310957100007, 76.17767975500004],
              [98.40430748800003, 76.18427155200004],
              [98.57618248800003, 76.23163483300004],
              [98.81641686300003, 76.26703522300005],
              [98.80201256600003, 76.25885651200008],
              [98.79444420700003, 76.24921295800004],
              [98.78931725400008, 76.23965078300006],
              [98.78296959700003, 76.23163483300004],
              [98.76587975400008, 76.22239817900004],
              [98.72868899800005, 76.21246979400007],
              [98.71273847700007, 76.20498281500005],
              [98.74244225400008, 76.19843170800004],
              [98.83692467500003, 76.19814687700006],
              [98.86280358200003, 76.20246002800008],
              [98.91334069100003, 76.22117747600004],
              [98.93287194100003, 76.22540924700007],
              [99.17212975400008, 76.21238841400003],
              [99.16529381600003, 76.21857330900008],
              [99.19369550900007, 76.22443268400008],
              [99.23503665500004, 76.22357819200005],
              [99.27409915500004, 76.21686432500007],
              [99.29558353000004, 76.20498281500005],
              [99.24496504000007, 76.19867584800005],
              [99.22046959700003, 76.19114817900004],
              [99.20004316500007, 76.17767975500004],
              [99.23414147200003, 76.16400788000004],
              [99.09017988400007, 76.16400788000004],
              [99.17286217500003, 76.13764069200005],
              [99.21436608200003, 76.12995026200008],
              [99.26148522200003, 76.12921784100007],
              [99.40113366000003, 76.14716217700004],
              [99.51978600400008, 76.14740631700005],
              [99.56177819100003, 76.15704987200007],
              [99.57422936300003, 76.15509674700007],
              [99.59669030000003, 76.13979726800005],
              [99.59978274800005, 76.13056061400005],
              [99.58228600400008, 76.12311432500007],
              [99.46753991000003, 76.10871002800008],
              [99.48707116000003, 76.09511953300006],
              [99.51710045700003, 76.08600495000007],
              [99.54957116000003, 76.08148834800005],
              [99.57618248800003, 76.08148834800005],
              [99.55567467500003, 76.06777578300006],
              [99.57105553500003, 76.06439850500004],
              [99.59131920700003, 76.06533437700006],
              [99.61182701900003, 76.07001373900005],
              [99.62769616000003, 76.07835521000004],
              [99.64283287900008, 76.08380768400008],
              [99.66309655000003, 76.08291250200006],
              [99.68360436300003, 76.07807038000004],
              [99.75489342500003, 76.04901764500005],
              [99.76246178500003, 76.03510163000004],
              [99.74463951900003, 76.00975169500003],
              [99.73178144600007, 75.99998607000003],
              [99.70281009200005, 75.98480866100005],
              [99.68946373800003, 75.97528717700004],
              [99.68181399800005, 75.96600983300004],
              [99.68148847700007, 75.95905182500007],
              [99.68425540500004, 75.95160553600005],
              [99.68751061300003, 75.93170807500007],
              [99.69019616000003, 75.92230866100005],
              [99.69166100400008, 75.91376373900005],
              [99.68946373800003, 75.90704987200007],
              [99.67652428500003, 75.89248281500005],
              [99.67481530000003, 75.88495514500005],
              [99.67920983200003, 75.87596263200004],
              [99.61475670700003, 75.83722565300008],
              [99.54517662900008, 75.81781647300005],
              [99.42400149800005, 75.79344310100004],
              [99.57064863400007, 75.77973053600005],
              [99.61264082100007, 75.78929271000004],
              [99.64527428500003, 75.81207916900007],
              [99.67611738400007, 75.83934153900003],
              [99.71338951900003, 75.86237213700008],
              [99.85987389400003, 75.89948151200008],
              [99.90235436300003, 75.92719147300005],
              [99.91334069100003, 75.95327383000006],
              [99.89991295700003, 75.97573476800005],
              [99.87452233200003, 75.99331289300005],
              [99.84913170700003, 76.00438060100004],
              [99.82520592500003, 76.02435944200005],
              [99.84148196700005, 76.04621002800008],
              [99.86890709700003, 76.06997304900005],
              [99.87777754000007, 76.09568919500003],
              [99.86573326900003, 76.10765208500004],
              [99.82504316500007, 76.11985911700003],
              [99.80958092500003, 76.12921784100007],
              [99.80193118600005, 76.14345937700006],
              [99.80274498800003, 76.15086497600004],
              [99.79835045700003, 76.15619538000004],
              [99.77540123800003, 76.16400788000004],
              [99.68751061300003, 76.18048737200007],
              [99.64307701900003, 76.19627513200004],
              [99.62387129000007, 76.22199127800008],
              [99.61500084700003, 76.25507233300004],
              [99.59066816500007, 76.27240631700005],
              [99.55583743600005, 76.27899811400005],
              [99.39486738400007, 76.28001536700003],
              [99.38379967500003, 76.28436920800004],
              [99.37330162900008, 76.29474518400008],
              [99.35401451900003, 76.31854889500005],
              [99.31519616000003, 76.34129466400003],
              [99.26498457100007, 76.35224030200004],
              [99.06617272200003, 76.35309479400007],
              [99.02019290500004, 76.36237213700008],
              [99.02808678500003, 76.38987864800004],
              [99.02019290500004, 76.39948151200008],
              [99.01107832100007, 76.40460846600007],
              [98.98715254000007, 76.41380442900004],
              [98.94027754000007, 76.44281647300005],
              [98.92408287900008, 76.44977448100008],
              [98.84522545700003, 76.46727122600004],
              [98.82813561300003, 76.47333405200004],
              [98.81999759200005, 76.47772858300004],
              [98.81641686300003, 76.48240794500003],
              [98.81788170700003, 76.49420807500007],
              [98.82154381600003, 76.49770742400005],
              [98.82691491000003, 76.49970123900005],
              [98.83318118600005, 76.50690338700008],
              [98.84888756600003, 76.51727936400005],
              [98.87476647200003, 76.52094147300005],
              [99.20386803500003, 76.49526601800005],
              [99.50855553500003, 76.46873607000003],
              [99.77979576900003, 76.47532786700003],
              [99.89242597700007, 76.48895905200004],
              [100.22950280000003, 76.49225495000007],
              [100.26148522200003, 76.47256094000005],
              [100.30445397200003, 76.46185944200005],
              [100.69336998800003, 76.50657786700003],
              [100.79428144600007, 76.53213125200006],
              [100.85108483200003, 76.54010651200008],
              [100.88892662900008, 76.53021881700005],
              [100.92750084700003, 76.51056549700007],
              [101.01929772200003, 76.50340403900003],
              [101.05713951900003, 76.48615143400008],
              [101.04639733200003, 76.47711823100008],
              [101.02491295700003, 76.46800364800004],
              [101.01563561300003, 76.45880768400008],
              [101.26254316500007, 76.47186920800004],
              [101.29908287900008, 76.48212311400005],
              [101.31617272200003, 76.48395416900007],
              [101.41960696700005, 76.46442291900007],
              [101.73829186300003, 76.45026276200008],
              [101.77857506600003, 76.43842194200005],
              [101.79639733200003, 76.42035553600005],
              [101.81568444100003, 76.40770091400003],
              [101.85971113400007, 76.40058014500005],
              [102.24952233200003, 76.38312409100007],
              [102.19629967500003, 76.40884023600006],
              [102.17383873800003, 76.41547272300005],
              [102.15137780000003, 76.41852448100008],
              [102.10466556100005, 76.41828034100007],
              [101.96111087300005, 76.43549225500004],
              [101.92042076900003, 76.44692617400005],
              [101.75310306100005, 76.47020091400003],
              [101.56364993600005, 76.47308991100005],
              [101.52263431100005, 76.48615143400008],
              [101.54363040500004, 76.49152252800008],
              [101.55054772200003, 76.49233633000006],
              [101.37525475400008, 76.51406484600005],
              [101.03598066500007, 76.52020905200004],
              [100.91920006600003, 76.55292389500005],
              [100.87826582100007, 76.55499909100007],
              [100.90984134200005, 76.56395091400003],
              [101.00945071700005, 76.57489655200004],
              [101.03679446700005, 76.58161041900007],
              [101.10482832100007, 76.61644114800004],
              [101.10108483200003, 76.61953359600005],
              [101.09489993600005, 76.62693919500003],
              [101.09115644600007, 76.63007233300004],
              [101.10865319100003, 76.63979726800005],
              [101.11451256600003, 76.65184153900003],
              [101.11752363400007, 76.66502513200004],
              [101.12598717500003, 76.67792389500005],
              [101.11182701900003, 76.68414948100008],
              [101.12777754000007, 76.69330475500004],
              [101.13624108200003, 76.70498281500005],
              [101.13599694100003, 76.71832916900007],
              [101.12598717500003, 76.73261139500005],
              [101.15357506600003, 76.73273346600007],
              [101.18799889400003, 76.73737213700008],
              [101.21851647200003, 76.74827708500004],
              [101.23462975400008, 76.76727936400005],
              [101.17188561300003, 76.77602773600006],
              [101.04322350400008, 76.77704498900005],
              [100.98129316500007, 76.78717682500007],
              [100.91431725400008, 76.81232330900008],
              [100.89576256600003, 76.82534414300005],
              [100.87256920700003, 76.83258698100008],
              [100.86410566500007, 76.83803945500006],
              [100.87142988400007, 76.84585195500006],
              [100.87891686300003, 76.85024648600006],
              [100.88477623800003, 76.85541413000004],
              [100.88900800900007, 76.86163971600007],
              [100.89210045700003, 76.86908600500004],
              [100.85767662900008, 76.87323639500005],
              [100.87208092500003, 76.89940013200004],
              [100.93360436300003, 76.95229726800005],
              [100.91928144600007, 76.97589752800008],
              [100.95720462300005, 76.98712799700007],
              [101.05030358200003, 76.99262116100005],
              [101.15088951900003, 76.98427969000005],
              [101.20630944100003, 76.98602936400005],
              [101.23462975400008, 77.00629303600005],
              [101.23585045700003, 77.01727936400005],
              [101.24146569100003, 77.02057526200008],
              [101.23210696700005, 77.03034088700008],
              [101.23389733200003, 77.03803131700005],
              [101.23853600400008, 77.04462311400005],
              [101.23804772200003, 77.05097077000005],
              [101.22388756600003, 77.05565013200004],
              [101.17709394600007, 77.05923086100006],
              [101.16635175900007, 77.06146881700005],
              [101.17465254000007, 77.08307526200008],
              [101.20704186300003, 77.09853750200006],
              [101.43197675900007, 77.15900299700007],
              [101.58366946700005, 77.22231679900005],
              [101.78809655000003, 77.26886627800008],
              [102.03663170700003, 77.36318594000005],
              [102.04314212300005, 77.38060130400004],
              [102.07569420700003, 77.39118073100008],
              [102.15772545700003, 77.40228913000004],
              [102.19402103000004, 77.40062083500004],
              [102.20850670700003, 77.39728424700007],
              [102.21412194100003, 77.39288971600007],
              [102.22006269600007, 77.38605377800008],
              [102.22868899800005, 77.37958405200004],
              [102.24105879000007, 77.37685781500005],
              [102.27076256600003, 77.38056061400005],
              [102.29167728000004, 77.38971588700008],
              [102.30982506600003, 77.40110911700003],
              [102.33130944100003, 77.41160716400003],
              [102.40992272200003, 77.43065013200004],
              [102.47120201900003, 77.46454498900005],
              [102.56934655000003, 77.50120677300004],
              [102.88900800900007, 77.54633209800005],
              [102.92042076900003, 77.55491771000004],
              [102.91342207100007, 77.56122467700004],
              [102.89926191500007, 77.58226146000004],
              [102.94906660200007, 77.58909739800004],
              [103.19662519600007, 77.65892161700003],
              [103.25684655000003, 77.66376373900005],
              [103.29712975400008, 77.65058014500005],
              [103.29395592500003, 77.64028554900005],
              [103.31820722700007, 77.63007233300004],
              [103.35596764400003, 77.61953359600005],
              [103.59253991000003, 77.63157786700003],
              [103.72868899800005, 77.66844310100004],
              [103.79127037900008, 77.67698802300004],
              [103.85108483200003, 77.70042552300004],
              [104.02328535200007, 77.73309967700004],
              [104.06080162900008, 77.73554108300004],
              [104.17286217500003, 77.72687409100007],
              [104.29029381600003, 77.73753489800004],
              [104.32569420700003, 77.72996653900003],
              [104.32447350400008, 77.72211334800005],
              [104.27466881600003, 77.69961172100005],
              [104.25749759200005, 77.68528880400004],
              [104.28891035200007, 77.67304108300004],
              [104.32398522200003, 77.66860586100006],
              [104.67823326900003, 77.70954010600008],
              [104.75163821700005, 77.70620351800005],
              [104.79118899800005, 77.67161692900004],
              [104.79118899800005, 77.65802643400008],
              [104.80762780000003, 77.63540273600006],
              [104.86687259200005, 77.61298248900005],
              [104.98218834700003, 77.58909739800004],
              [105.23316491000003, 77.56964752800008],
              [105.33423912900003, 77.54100169500003],
              [105.60397382950003, 77.55479564000004],
              [105.87370853000004, 77.56858958500004],
              [105.86638431100005, 77.55975983300004],
              [105.85645592500003, 77.55272044500003],
              [105.83334394600007, 77.54071686400005],
              [105.84888756600003, 77.53514232000003],
              [105.88062584700003, 77.53156159100007],
              [105.89478600400003, 77.52765534100007],
              [105.90162194100003, 77.52236562700006],
              [105.91456139400003, 77.50649648600006],
              [105.92261803500003, 77.49970123900005],
              [105.91000410200007, 77.47601959800005],
              [105.92725670700003, 77.45892975500004],
              [105.98357181100005, 77.43829987200007],
              [105.98080488400007, 77.43463776200008],
              [105.97730553500003, 77.42523834800005],
              [105.99683678500003, 77.42108795800004],
              [106.07886803500003, 77.41543203300006],
              [106.11784915500004, 77.40619538000004],
              [106.17107181100005, 77.40155670800004],
              [106.25945071700005, 77.38353099200003],
              [106.29200280000003, 77.37002187700006],
              [106.21973717500003, 77.35635000200006],
              [105.79566491000003, 77.37352122600004],
              [105.75814863400007, 77.36945221600007],
              [105.74341881600003, 77.35635000200006],
              [105.72437584700003, 77.34149811400005],
              [105.61426842500003, 77.30170319200005],
              [105.57007897200003, 77.29409414300005],
              [105.47828209700003, 77.28847890800006],
              [105.43539472700007, 77.27440013200004],
              [105.51880944100003, 77.27252838700008],
              [105.53842207100007, 77.26699453300006],
              [105.50049889400003, 77.25079987200007],
              [105.45582116000003, 77.24046458500004],
              [105.31959069100003, 77.23053620000007],
              [105.29867597700007, 77.22614166900007],
              [105.23747806100005, 77.20600006700005],
              [105.19581139400003, 77.19867584800005],
              [105.01148522200003, 77.19253164300005],
              [104.87867272200003, 77.16742584800005],
              [104.78419030000003, 77.17397695500006],
              [104.60767662900008, 77.15965403900003],
              [104.52588951900003, 77.13690827000005],
              [104.48340905000003, 77.12978750200006],
              [104.34571373800003, 77.13548411700003],
              [104.16358483200003, 77.10797760600008],
              [104.11963951900003, 77.09564850500004],
              [104.14193769600007, 77.08885325700004],
              [104.16667728000004, 77.08917877800008],
              [104.21583092500003, 77.09564850500004],
              [104.29769941500007, 77.08881256700005],
              [104.77198326900003, 77.12173086100006],
              [104.77808678500003, 77.10993073100008],
              [104.82374108200003, 77.09682851800005],
              [104.87256920700003, 77.09072500200006],
              [105.06674238400007, 77.08881256700005],
              [105.08806399800005, 77.09247467700004],
              [105.14747155000003, 77.10993073100008],
              [105.19450931100005, 77.11123281500005],
              [105.34066816500007, 77.08881256700005],
              [105.61280358200003, 77.11465078300006],
              [105.79704837300005, 77.11261627800008],
              [105.83863366000003, 77.11701080900008],
              [105.88111412900003, 77.12978750200006],
              [105.88640384200005, 77.13426341400003],
              [105.88672936300003, 77.13898346600007],
              [105.88843834700003, 77.14256419500003],
              [105.89820397200003, 77.14411041900007],
              [105.92847741000003, 77.14411041900007],
              [105.93482506600003, 77.14321523600006],
              [105.93995201900003, 77.14069245000007],
              [105.94304446700005, 77.13621653900003],
              [105.94320722700007, 77.12978750200006],
              [105.93482506600003, 77.12604401200008],
              [105.88795006600003, 77.09564850500004],
              [105.85108483200003, 77.08502838700008],
              [105.76677493600005, 77.07705312700006],
              [105.73707116000003, 77.06146881700005],
              [105.76254316500007, 77.05438873900005],
              [105.77466881600003, 77.04913971600007],
              [105.78492272200003, 77.04100169500003],
              [105.70980879000007, 77.03302643400008],
              [105.48666425900007, 77.03457265800006],
              [105.43539472700007, 77.00006745000007],
              [105.45053144600007, 76.98358795800004],
              [105.49048912900003, 76.98456452000005],
              [105.53679446700005, 76.99095286700003],
              [105.57105553500003, 76.99079010600008],
              [105.61646569100003, 76.98114655200004],
              [105.66138756600003, 76.98053620000007],
              [105.79948978000004, 76.99640534100007],
              [105.89535566500007, 76.99506256700005],
              [105.94320722700007, 77.00006745000007],
              [106.16472415500004, 77.05621979400007],
              [106.20557701900003, 77.06195709800005],
              [106.29200280000003, 77.06146881700005],
              [106.38965905000003, 77.04197825700004],
              [106.46550540500004, 77.03961823100008],
              [106.49057050900007, 77.03424713700008],
              [106.50001061300003, 77.02163320500006],
              [106.53785241000003, 77.01561107000003],
              [106.61451256600003, 77.01365794500003],
              [106.63005618600005, 77.01154205900008],
              [106.66480553500003, 77.00218333500004],
              [106.75538170700003, 77.00116608300004],
              [106.77857506600003, 77.00629303600005],
              [106.75114993600005, 77.01654694200005],
              [106.71631920700003, 77.02366771000004],
              [106.64893639400003, 77.02741120000007],
              [106.64893639400003, 77.03424713700008],
              [106.73308353000004, 77.03058502800008],
              [106.75879967500003, 77.03424713700008],
              [106.80713951900003, 77.05247630400004],
              [106.82984459700003, 77.05467357000003],
              [106.98975670700003, 77.03294505400004],
              [107.01140384200005, 77.02741120000007],
              [106.97046959700003, 77.01365794500003],
              [107.00294030000003, 77.00311920800004],
              [107.08228600400003, 77.01609935100004],
              [107.11841881600003, 77.01707591400003],
              [107.15984134200005, 77.01312897300005],
              [107.28581790500004, 77.02057526200008],
              [107.27458743600005, 77.01447174700007],
              [107.26270592500003, 77.00995514500005],
              [107.25049889400003, 77.00702545800004],
              [107.23796634200005, 77.00629303600005],
              [107.25611412900003, 76.99310944200005],
              [107.28451582100007, 76.98289622600004],
              [107.34099368600005, 76.97280508000006],
              [107.32667076900003, 76.96588776200008],
              [107.34620201900003, 76.95498281500005],
              [107.37191816500007, 76.94627513200004],
              [107.47486412900003, 76.93207428600005],
              [107.49976647200003, 76.92450592700004],
              [107.49830162900003, 76.91474030200004],
              [107.46957441500007, 76.90643952000005],
              [107.26587975400003, 76.89081452000005],
              [107.28695722700007, 76.88328685100004],
              [107.33236738400007, 76.87543366100005],
              [107.35466556100005, 76.86908600500004],
              [107.31446373800003, 76.86225006700005],
              [107.22535241000003, 76.85785553600005],
              [107.19019616000003, 76.84235260600008],
              [107.26335696700005, 76.84235260600008],
              [107.28581790500004, 76.83559804900005],
              [107.21452884200005, 76.80687083500004],
              [107.19019616000003, 76.80145905200004],
              [107.16334069100003, 76.80288320500006],
              [107.10621178500003, 76.81244538000004],
              [107.08033287900003, 76.80829498900005],
              [107.06462649800005, 76.79877350500004],
              [107.05909264400003, 76.78864166900007],
              [107.05982506600003, 76.76361725500004],
              [107.04664147200003, 76.75556061400005],
              [107.01661217500003, 76.74750397300005],
              [106.97730553500003, 76.73940664300005],
              [106.95362389400003, 76.72052643400008],
              [106.92554772200003, 76.71279531500005],
              [106.84058678500003, 76.71405670800004],
              [106.80445397200003, 76.72308991100005],
              [106.78565514400003, 76.72508372600004],
              [106.72413170700003, 76.71889883000006],
              [106.78923587300005, 76.68500397300005],
              [106.79908287900003, 76.67450592700004],
              [106.78980553500003, 76.66103750200006],
              [106.73829186300003, 76.63007233300004],
              [106.72738691500007, 76.62030670800004],
              [106.71265709700003, 76.61298248900005],
              [106.68295332100007, 76.60219961100006],
              [106.68100019600007, 76.59870026200008],
              [106.68327884200005, 76.59418366100005],
              [106.68344160200007, 76.59023672100005],
              [106.67595462300005, 76.58856842700004],
              [106.65577233200003, 76.58738841400003],
              [106.64714603000004, 76.58441803600005],
              [106.62476647200003, 76.56683991100005],
              [106.61231530000003, 76.55963776200008],
              [106.59831790500004, 76.55605703300006],
              [106.57960045700003, 76.55499909100007],
              [106.56169681100005, 76.55683014500005],
              [106.54639733200003, 76.56268952000005],
              [106.54102623800003, 76.57314687700006],
              [106.55274498800003, 76.58856842700004],
              [106.51075280000003, 76.60028717700004],
              [106.45167076900003, 76.60919830900008],
              [106.39665774800005, 76.60431549700007],
              [106.36703535200007, 76.57489655200004],
              [106.38070722700007, 76.57489655200004],
              [106.37728925900007, 76.55438873900005],
              [106.40015709700003, 76.53461334800005],
              [106.38892662900003, 76.52020905200004],
              [106.41700280000003, 76.50922272300005],
              [106.44874108200003, 76.50397370000007],
              [106.70533287900003, 76.49872467700004],
              [106.73650149800005, 76.49363841400003],
              [106.79200280000003, 76.47199127800008],
              [106.81983483200003, 76.46893952000005],
              [106.84750410200007, 76.47345612200007],
              [106.87427819100003, 76.48615143400008],
              [106.87728925900007, 76.50348541900007],
              [106.91285241000003, 76.50897858300004],
              [107.03638756600003, 76.50702545800004],
              [107.27003014400003, 76.53461334800005],
              [107.59156334700003, 76.50503164300005],
              [107.84546959700003, 76.53481679900005],
              [107.88217207100007, 76.54755280200004],
              [107.89568118600005, 76.55499909100007],
              [107.97437584700003, 76.61322663000004],
              [107.98462975400003, 76.62270742400005],
              [107.99097741000003, 76.64862702000005],
              [107.96827233200003, 76.65957265800006],
              [107.90211022200003, 76.67108795800004],
              [107.93677819100003, 76.69863515800006],
              [107.94117272200003, 76.71230703300006],
              [107.91627037900003, 76.71889883000006],
              [107.94605553500003, 76.73729075700004],
              [108.00391686300003, 76.74017975500004],
              [108.11158287900003, 76.73261139500005],
              [108.22494550900007, 76.73940664300005],
              [108.32048587300005, 76.72508372600004],
              [108.30241946700005, 76.71678294500003],
              [108.28630618600005, 76.70526764500005],
              [108.49927819100003, 76.72695547100005],
              [108.68482506600003, 76.71645742400005],
              [109.04883873800003, 76.74017975500004],
              [109.19849694100003, 76.73090241100005],
              [109.33253014400003, 76.75849030200004],
              [109.39779707100007, 76.75999583500004],
              [109.40349368600005, 76.75641510600008],
              [109.40658613400007, 76.74933502800008],
              [109.41407311300003, 76.74396393400008],
              [109.42310631600003, 76.74054596600007],
              [109.43091881600003, 76.73940664300005],
              [109.60523522200003, 76.73940664300005],
              [109.61695397200003, 76.73725006700005],
              [109.62378991000003, 76.73248932500007],
              [109.62924238400007, 76.72711823100008],
              [109.63648522200003, 76.72345612200007],
              [109.75228925900007, 76.71206289300005],
              [109.83464603000004, 76.71881745000007],
              [109.85531660200007, 76.71548086100006],
              [109.88111412900003, 76.70661041900007],
              [109.95834394600007, 76.70526764500005],
              [110.03451582100007, 76.69196198100008],
              [110.06137129000007, 76.69159577000005],
              [110.35857181100005, 76.75568268400008],
              [110.56666100400003, 76.76422760600008],
              [110.61850019600007, 76.75897858300004],
              [110.63062584700003, 76.73940664300005],
              [110.66472415500004, 76.72955963700008],
              [110.70484459700003, 76.72650788000004],
              [110.82081139400003, 76.73411692900004],
              [110.90609785200007, 76.73012929900005],
              [110.94467207100007, 76.73940664300005],
              [110.93230228000004, 76.74017975500004],
              [110.91993248800003, 76.74298737200007],
              [110.90821373800003, 76.74738190300008],
              [110.89698326900003, 76.75307851800005],
              [110.94556725400003, 76.76504140800006],
              [111.01832116000003, 76.76825592700004],
              [111.09034264400003, 76.76227448100008],
              [111.13705488400007, 76.74681224200003],
              [111.11866295700003, 76.74494049700007],
              [111.09831790500004, 76.73948802300004],
              [111.08033287900003, 76.73078034100007],
              [111.06885826900003, 76.71889883000006],
              [111.09083092500003, 76.70880768400008],
              [111.10474694100003, 76.69281647300005],
              [111.11939537900003, 76.68211497600004],
              [111.14389082100007, 76.68789297100005],
              [111.17790774800005, 76.70246002800008],
              [111.21045983200003, 76.70888906500005],
              [111.55543053500003, 76.68414948100008],
              [111.53785241000003, 76.68024323100008],
              [111.50196373800003, 76.67780182500007],
              [111.48715254000007, 76.67108795800004],
              [111.50171959700003, 76.66547272300005],
              [111.53101647200003, 76.66014232000003],
              [111.54175866000003, 76.65062083500004],
              [111.51872806100005, 76.65058014500005],
              [111.49244225400003, 76.64679596600007],
              [111.46680748800003, 76.63979726800005],
              [111.44556725400003, 76.63007233300004],
              [111.48878014400003, 76.61041901200008],
              [111.66504967500003, 76.62103913000004],
              [111.82642662900003, 76.59638092700004],
              [112.15796959700003, 76.49046458500004],
              [112.19906660200002, 76.47186920800004],
              [111.87159264400003, 76.36139557500007],
              [111.82911217500003, 76.34149811400005],
              [111.86117597700007, 76.35097890800006],
              [111.96371504000007, 76.37824127800008],
              [111.99854576900003, 76.37864817900004],
              [112.01579837300005, 76.38149648600006],
              [112.06373131600003, 76.40228913000004],
              [112.17855879000001, 76.43085358300004],
              [112.23210696700005, 76.45058828300006],
              [112.25684655000009, 76.45441315300008],
              [112.28842207100001, 76.45136139500005],
              [112.67090905000009, 76.36310455900008],
              [112.72022545700008, 76.33771393400008],
              [112.74781334700003, 76.33527252800008],
              [112.74781334700003, 76.32843659100007],
              [112.65837649800005, 76.32225169500003],
              [112.71257571700005, 76.30182526200008],
              [112.73161868600005, 76.28900788000004],
              [112.74040774800005, 76.26703522300005],
              [112.68897545700008, 76.25389232000003],
              [112.67269941500001, 76.24591705900008],
              [112.67758222700002, 76.24258047100005],
              [112.68677819100003, 76.23468659100007],
              [112.69263756600003, 76.23163483300004],
              [112.66879316500001, 76.22662995000007],
              [112.61443118600005, 76.22235748900005],
              [112.59009850400003, 76.22540924700007],
              [112.54786217500009, 76.24237702000005],
              [112.52670332100001, 76.24599844000005],
              [112.50074303500003, 76.23908112200007],
              [112.54688561300009, 76.22601959800005],
              [112.58936608200008, 76.20652903900003],
              [112.63347415500004, 76.19269440300008],
              [112.73511803500003, 76.20172760600008],
              [112.779633009, 76.19196198100008],
              [112.82016035200002, 76.17112864800004],
              [112.85767662900003, 76.14350006700005],
              [112.78687584700003, 76.08624909100007],
              [112.76148522200003, 76.07526276200008],
              [112.66578209700003, 76.05414459800005],
              [112.59180748800009, 76.05467357000003],
              [112.56967207100001, 76.04730866100005],
              [112.60157311300009, 76.04120514500005],
              [112.96216881600003, 76.06509023600006],
              [113.01734459700003, 76.08055247600004],
              [113.02865644600001, 76.08616771000004],
              [113.03516686300009, 76.09593333500004],
              [113.04200280000009, 76.11562734600005],
              [113.02751712300005, 76.12299225500004],
              [112.99903405000009, 76.13300202000005],
              [112.98731530000009, 76.14350006700005],
              [113.05933678500003, 76.16376373900005],
              [113.14747155000009, 76.16254303600005],
              [113.23422285200002, 76.14484284100007],
              [113.30274498800009, 76.11562734600005],
              [113.28598066500001, 76.12970612200007],
              [113.26270592500009, 76.14492422100005],
              [113.25611412900003, 76.15924713700008],
              [113.28907311300009, 76.17084381700005],
              [113.23511803500003, 76.17621491100005],
              [113.13266035200002, 76.19961172100005],
              [113.02507571700005, 76.21015045800004],
              [112.97169030000009, 76.22370026200008],
              [112.96062259200005, 76.23021067900004],
              [112.94459069100003, 76.24998607000003],
              [112.93213951900009, 76.25958893400008],
              [113.13062584700003, 76.25336334800005],
              [113.21607506600003, 76.26679108300004],
              [113.25928795700008, 76.26642487200007],
              [113.29590905000009, 76.24591705900008],
              [113.27881920700008, 76.23834870000007],
              [113.226898634, 76.22540924700007],
              [113.24138431100005, 76.21491120000007],
              [113.24740644600001, 76.21238841400003],
              [113.24122155000009, 76.20498281500005],
              [113.31853274800005, 76.21527741100005],
              [113.35889733200008, 76.21133047100005],
              [113.45972741000003, 76.14838288000004],
              [113.46355228000004, 76.13263580900008],
              [113.44947350400003, 76.11615631700005],
              [113.44263756600003, 76.10276927300004],
              [113.44019616000003, 76.08738841400003],
              [113.439789259, 76.06468333500004],
              [113.45281009200005, 76.04132721600007],
              [113.48340905000009, 76.03388092700004],
              [113.51954186300009, 76.03074778900003],
              [113.54908287900003, 76.02065664300005],
              [113.51221764400009, 75.99567291900007],
              [113.50074303500003, 75.98582591400003],
              [113.51498457100001, 75.98582591400003],
              [113.52914472700002, 75.98330312700006],
              [113.54297936300009, 75.97858307500007],
              [113.55591881600003, 75.97223541900007],
              [113.53199303500003, 75.95404694200005],
              [113.50196373800009, 75.95058828300006],
              [113.46973717500009, 75.95091380400004],
              [113.439789259, 75.94428131700005],
              [113.45980879000001, 75.93846263200004],
              [113.50114993600005, 75.93634674700007],
              [113.52116946700005, 75.93060944200005],
              [113.53174889400009, 75.92218659100007],
              [113.53907311300009, 75.91217682500007],
              [113.54769941500001, 75.90289948100008],
              [113.56275475400003, 75.89647044500003],
              [113.55372155000009, 75.89069245000007],
              [113.55054772200003, 75.88760000200006],
              [113.55176842500009, 75.88373444200005],
              [113.55591881600003, 75.87596263200004],
              [113.51978600400003, 75.86493561400005],
              [113.49984785200002, 75.86196523600006],
              [113.480804884, 75.86237213700008],
              [113.480804884, 75.85553620000007],
              [113.52035566500001, 75.85468170800004],
              [113.61654707100001, 75.86351146000004],
              [113.65211022200003, 75.87596263200004],
              [113.63575280000009, 75.88287995000007],
              [113.62696373800009, 75.89435455900008],
              [113.61744225400003, 75.92377350500004],
              [113.63868248800009, 75.92332591400003],
              [113.70337975400003, 75.93060944200005],
              [113.73951256600003, 75.92035553600005],
              [113.75977623800009, 75.91815827000005],
              [113.78093509200005, 75.93927643400008],
              [113.80860436300009, 75.93646881700005],
              [113.83863366000003, 75.92495351800005],
              [113.85816491000003, 75.91079336100006],
              [113.82837975400003, 75.89496491100005],
              [113.89014733200008, 75.85398997600004],
              [113.87159264400009, 75.82510000200006],
              [113.83716881600003, 75.79751211100006],
              [113.83814537900003, 75.77826569200005],
              [113.83716881600003, 75.77358633000006],
              [113.82195071700005, 75.75861237200007],
              [113.76514733200008, 75.72235748900005],
              [113.75879967500009, 75.71352773600006],
              [113.75831139400009, 75.70600006700005],
              [113.75945071700005, 75.69977448100008],
              [113.75798587300005, 75.69476959800005],
              [113.74952233200008, 75.68870677300004],
              [113.72730553500003, 75.67719147300005],
              [113.72046959700003, 75.67055898600006],
              [113.71802819100003, 75.65997955900008],
              [113.72046959700003, 75.61933014500005],
              [113.69166100400003, 75.59349192900004],
              [113.57211347700002, 75.56574127800008],
              [113.55591881600003, 75.54022858300004],
              [113.426117384, 75.54022858300004],
              [113.44629967500009, 75.55817291900007],
              [113.53484134200005, 75.59479401200008],
              [113.58155358200008, 75.62140534100007],
              [113.60108483200008, 75.63666413000004],
              [113.61744225400003, 75.65623607000003],
              [113.26124108200008, 75.69354889500005],
              [113.06755618600005, 75.68349844000005],
              [113.10181725400003, 75.68992747600004],
              [113.12891686300009, 75.69432200700004],
              [113.13754316500001, 75.71149323100008],
              [113.12330162900003, 75.72064850500004],
              [112.84119713650006, 75.78597646700004],
              [112.55909264400009, 75.85130442900004],
              [112.36491946700005, 75.85643138200004],
              [112.33692467500009, 75.84808991100005],
              [112.35547936300009, 75.84613678600005],
              [112.39136803500003, 75.83661530200004],
              [112.42750084700003, 75.83307526200008],
              [112.44385826900009, 75.82925039300005],
              [112.45948326900009, 75.82294342700004],
              [112.47291100400003, 75.81452057500007],
              [112.47982832100001, 75.80658600500004],
              [112.49187259200005, 75.78754303600005],
              [112.50074303500003, 75.77973053600005],
              [112.51775149800005, 75.77374909100007],
              [112.59945722700002, 75.76634349200003],
              [112.642914259, 75.77358633000006],
              [112.66537519600001, 75.77167389500005],
              [112.76002037900003, 75.74677155200004],
              [112.80323326900009, 75.74380117400005],
              [112.82292728000004, 75.73883698100008],
              [112.83497155000009, 75.73139069200005],
              [112.84498131600003, 75.72272370000007],
              [112.855804884, 75.71523672100005],
              [112.87061608200008, 75.71149323100008],
              [112.85767662900003, 75.70465729400007],
              [112.86101321700005, 75.70400625200006],
              [112.86345462300005, 75.70392487200007],
              [112.86459394600001, 75.70270416900007],
              [112.86451256600003, 75.69847239800004],
              [112.85108483200008, 75.69529857000003],
              [112.82520592500009, 75.68622467700004],
              [112.80974368600005, 75.68793366100005],
              [112.79363040500004, 75.69537995000007],
              [112.76880944100003, 75.70282623900005],
              [112.74781334700003, 75.69847239800004],
              [112.75879967500009, 75.69537995000007],
              [112.77125084700003, 75.69537995000007],
              [112.78834069100003, 75.69183991100005],
              [112.80746504000001, 75.68455638200004],
              [112.82292728000004, 75.67055898600006],
              [112.86150149800005, 75.65790436400005],
              [112.87810306100005, 75.64667389500005],
              [112.87810306100005, 75.62897370000007],
              [112.85889733200008, 75.61542389500005],
              [112.80339603000004, 75.60447825700004],
              [112.78882897200003, 75.58860911700003],
              [112.81364993600005, 75.55731842700004],
              [112.88209069100003, 75.54604726800005],
              [113.00375410200002, 75.54767487200007],
              [113.035492384, 75.55304596600007],
              [113.02930748800009, 75.56537506700005],
              [112.99350019600001, 75.58860911700003],
              [112.99301191500001, 75.60984935100004],
              [113.01628665500004, 75.61859772300005],
              [113.20704186300009, 75.65009186400005],
              [113.26742597700002, 75.65110911700003],
              [113.29517662900003, 75.64496491100005],
              [113.29590905000009, 75.62897370000007],
              [113.303070509, 75.62287018400008],
              [113.30941816500001, 75.61591217700004],
              [113.29127037900003, 75.61005280200004],
              [113.28101647200003, 75.59926992400005],
              [113.27116946700005, 75.58637116100005],
              [113.25489342500009, 75.57436758000006],
              [113.29053795700008, 75.55052317900004],
              [113.33676191500001, 75.53510163000004],
              [113.53638756600003, 75.50657786700003],
              [113.58912194100003, 75.50706614800004],
              [113.63843834700003, 75.51972077000005],
              [113.63770592500009, 75.52407461100006],
              [113.66920006600003, 75.50641510600008],
              [113.67945397200003, 75.49921295800004],
              [113.68384850400003, 75.49266185100004],
              [113.68848717500009, 75.48334381700005],
              [113.69467207100001, 75.47492096600007],
              [113.70337975400003, 75.47134023600006],
              [113.70818118600005, 75.46344635600008],
              [113.71949303500003, 75.42462799700007],
              [113.72046959700003, 75.40985748900005],
              [113.68279056100005, 75.41933828300006],
              [113.63428795700008, 75.42169830900008],
              [113.58611087300005, 75.41730377800008],
              [113.54908287900003, 75.40643952000005],
              [113.53565514400009, 75.39012278900003],
              [113.57048587300005, 75.38544342700004],
              [113.65365644600001, 75.38434479400007],
              [113.67066491000003, 75.36888255400004],
              [113.66041100400003, 75.34943268400008],
              [113.62110436300009, 75.31736888200004],
              [113.61646569100003, 75.30914948100008],
              [113.61622155000009, 75.30023834800005],
              [113.61459394600001, 75.29181549700007],
              [113.60523522200003, 75.28497955900008],
              [113.55128014400009, 75.26935455900008],
              [113.36304772200003, 75.18553294500003],
              [113.14568118600005, 75.11810944200005],
              [113.11426842500009, 75.09829336100006],
              [113.08529707100001, 75.08698151200008],
              [113.01156660200002, 75.06761302300004],
              [113.01417076900009, 75.05418528900003],
              [112.99317467500009, 75.03949616100005],
              [112.87964928500003, 74.99290599200003],
              [112.51384524800005, 74.92153554900005],
              [112.43921959700003, 74.92157623900005],
              [112.146820509, 74.87836334800005],
              [112.09197024800005, 74.85700104400007],
              [112.09669030000009, 74.82762278900003],
              [112.05648847700002, 74.78949616100005],
              [112.03988691500001, 74.78148021000004],
              [111.98170006600003, 74.77704498900005],
              [111.95346113400007, 74.77179596600007],
              [111.94516035200007, 74.75873444200005],
              [111.92497806100005, 74.75047435100004],
              [111.91700280000003, 74.74506256700005],
              [111.91114342500003, 74.73826732000003],
              [111.93213951900003, 74.73676178600005],
              [111.95264733200003, 74.73143138200004],
              [111.92896569100003, 74.72028229400007],
              [111.86793053500003, 74.70066966400003],
              [111.81576582100007, 74.69196198100008],
              [111.77230879000007, 74.66852448100008],
              [111.74382571700005, 74.66315338700008],
              [111.46583092500003, 74.69733307500007],
              [111.40284264400003, 74.69110748900005],
              [111.11670983200003, 74.60789622600004],
              [111.08415774800005, 74.60407135600008],
              [111.01775149800005, 74.60407135600008],
              [110.98617597700007, 74.59422435100004],
              [111.03394616000003, 74.58559804900005],
              [111.05209394600007, 74.57916901200008],
              [111.03980553500003, 74.56891510600008],
              [110.96021569100003, 74.54848867400005],
              [110.81495201900003, 74.53900788000004],
              [110.74512780000003, 74.51581452000005],
              [110.55713951900003, 74.48110586100006],
              [110.49968509200005, 74.47821686400005],
              [110.38819420700003, 74.49542877800008],
              [110.33155358200003, 74.49616120000007],
              [110.28052819100003, 74.47821686400005],
              [110.35230553500003, 74.47138092700004],
              [110.35808353000004, 74.46832916900007],
              [110.37859134200005, 74.45453522300005],
              [110.38982181100005, 74.45087311400005],
              [110.36255944100003, 74.41828034100007],
              [110.31332441500007, 74.39940013200004],
              [110.21208743600005, 74.37238190300008],
              [109.99952233200003, 74.37372467700004],
              [109.96517988400007, 74.35126373900005],
              [109.95118248800003, 74.33698151200008],
              [109.91944420700003, 74.33038971600007],
              [109.83423912900003, 74.32566966400003],
              [109.82129967500003, 74.32269928600005],
              [109.80762780000003, 74.31708405200004],
              [109.79761803500003, 74.31439850500004],
              [109.79371178500003, 74.31818268400008],
              [109.78988691500007, 74.32412344000005],
              [109.78028405000003, 74.32802969000005],
              [109.69703209700003, 74.31903717700004],
              [109.64323978000004, 74.32664622600004],
              [109.58985436300003, 74.31509023600006],
              [109.56120853000004, 74.31370677300004],
              [109.64234459700003, 74.28921133000006],
              [109.72771243600005, 74.28656647300005],
              [109.94263756600003, 74.30776601800005],
              [109.96827233200003, 74.30483633000006],
              [109.97950280000003, 74.29633209800005],
              [109.97706139400003, 74.28827545800004],
              [109.93043053500003, 74.22776927300004],
              [109.91285241000003, 74.21161530200004],
              [109.89014733200003, 74.19700755400004],
              [109.79688561300003, 74.16168854400007],
              [109.59888756600003, 74.11969635600008],
              [109.48145592500003, 74.07721588700008],
              [109.17953535200007, 74.05744049700007],
              [108.99610436300003, 74.01557038000004],
              [108.95386803500003, 73.99754466400003],
              [108.92066491000003, 73.97418854400007],
              [108.90105228000004, 73.96491120000007],
              [108.82227623800003, 73.95551178600005],
              [108.76482181100005, 73.93496328300006],
              [108.68360436300003, 73.89252350500004],
              [108.62427819100003, 73.87250397300005],
              [108.60670006600003, 73.86383698100008],
              [108.59131920700003, 73.85130442900004],
              [108.56527754000007, 73.82046133000006],
              [108.55079186300003, 73.81183502800008],
              [108.52588951900003, 73.80658600500004],
              [108.50196373800003, 73.80662669500003],
              [108.43775475400003, 73.82025788000004],
              [108.45630944100003, 73.80951569200005],
              [108.47885175900007, 73.78412506700005],
              [108.49170983200003, 73.77252838700008],
              [108.46013431100005, 73.76874420800004],
              [108.39795983200003, 73.75433991100005],
              [108.06657962300005, 73.63532135600008],
              [108.07129967500003, 73.64362213700008],
              [108.07764733200003, 73.65078359600005],
              [108.08545983200003, 73.65692780200004],
              [108.09449303500003, 73.66266510600008],
              [108.03679446700005, 73.67723216400003],
              [107.96485436300003, 73.67039622600004],
              [107.77686608200003, 73.61664459800005],
              [107.74870853000004, 73.61204661700003],
              [107.65984134200005, 73.62518952000005],
              [107.37452233200003, 73.63532135600008],
              [107.35938561300003, 73.63320547100005],
              [107.33301842500003, 73.62376536700003],
              [107.32016035200007, 73.62164948100008],
              [107.17286217500003, 73.62164948100008],
              [107.14682050900007, 73.61766185100004],
              [107.13168379000007, 73.60712311400005],
              [107.10132897200003, 73.57387929900005],
              [107.11931399800005, 73.57343170800004],
              [107.13721764400003, 73.56932200700004],
              [107.15430748800003, 73.56240469000005],
              [107.16968834700003, 73.55341217700004],
              [107.13355553500003, 73.53017812700006],
              [106.93588300900007, 73.47060781500005],
              [106.91065514400003, 73.45482005400004],
              [106.89079837300005, 73.44830963700008],
              [106.88160241000003, 73.44354889500005],
              [106.87647545700003, 73.43829987200007],
              [106.87126712300005, 73.42861562700006],
              [106.83130944100003, 73.37474192900004],
              [106.81153405000003, 73.35431549700007],
              [106.78541100400003, 73.34052155200004],
              [106.64795983200003, 73.30670807500007],
              [106.60043379000007, 73.30634186400005],
              [106.52442467500003, 73.32347239800004],
              [106.49805748800003, 73.32623932500007],
              [106.39503014400003, 73.31317780200004],
              [106.23243248800003, 73.32282135600008],
              [106.06275475400003, 73.27301666900007],
              [106.04558353000004, 73.25482819200005],
              [106.04664147200003, 73.24453359600005],
              [106.05128014400003, 73.22406647300005],
              [106.05250084700003, 73.21385325700004],
              [106.04810631600003, 73.20262278900003],
              [106.02686608200003, 73.18219635600008],
              [106.00928795700003, 73.15509674700007],
              [105.87370853000004, 73.11456940300008],
              [105.85328209700003, 73.09479401200008],
              [105.85084069100003, 73.07477448100008],
              [105.85132897200003, 73.05410390800006],
              [105.83961022200003, 73.03266022300005],
              [105.84669030000003, 73.01447174700007],
              [105.83383222700007, 73.00226471600007],
              [105.75147545700003, 72.97650788000004],
              [105.67741946700005, 72.93553294500003],
              [105.65064537900003, 72.91107819200005],
              [105.62794030000003, 72.90167877800008],
              [105.54802493600005, 72.88117096600007],
              [105.52491295700003, 72.87124258000006],
              [105.35417728000004, 72.83144765800006],
              [105.29004967500003, 72.80027903900003],
              [105.06674238400007, 72.78558991100005],
              [105.07300866000003, 72.76508209800005],
              [105.11784915500004, 72.77513255400004],
              [105.48259524800005, 72.76813385600008],
              [105.51726321700005, 72.77627187700006],
              [105.58521569100003, 72.80060455900008],
              [105.62330162900003, 72.80939362200007],
              [105.66236412900003, 72.81232330900008],
              [105.67628014400003, 72.81537506700005],
              [105.75114993600005, 72.85708242400005],
              [105.78744550900007, 72.86994049700007],
              [105.82504316500007, 72.87824127800008],
              [105.93067467500003, 72.88857656500005],
              [105.94947350400003, 72.89545319200005],
              [105.95818118600005, 72.90216705900008],
              [105.97388756600003, 72.92584870000007],
              [106.00228925900007, 72.94696686400005],
              [106.03636787600004, 72.95252154100007],
              [106.11787128200007, 72.94115373500006],
              [106.13704892100003, 72.91085353800008],
              [106.22998540300006, 72.89444713400007],
              [106.28759517000003, 72.89134885500005],
              [106.40912786600006, 72.87161699500007],
              [106.55844228600006, 72.86711191100005],
              [106.61620880000004, 72.85547644300004],
              [106.65713469900004, 72.83195297000003],
              [106.82329401400006, 72.82561377700006],
              [107.00604545000004, 72.84449125800006],
              [107.10326271700006, 72.85640581500007],
              [107.05147643000004, 72.87662423200004],
              [106.97107975700004, 72.88328339200007],
              [106.86218370700004, 72.87803858000007],
              [106.75861300300005, 72.88795327700007],
              [106.62049847900005, 72.89602559100007],
              [106.49854220400005, 72.92770339300006],
              [106.32445121000006, 72.95570332800008],
              [106.25463976700007, 72.96719950600004],
              [106.22380618600005, 72.97736237200007],
              [106.21656334700003, 72.98574453300006],
              [106.21208743600005, 73.00079987200007],
              [106.19711347700007, 73.02106354400007],
              [106.18930097700007, 73.03900788000004],
              [106.18588300900007, 73.05768463700008],
              [106.18962649800005, 73.07294342700004],
              [106.17676842500003, 73.08161041900007],
              [106.17562910200007, 73.09438711100006],
              [106.18148847700007, 73.10846588700008],
              [106.18962649800005, 73.12140534100007],
              [106.20215905000003, 73.13605377800008],
              [106.21680748800003, 73.14411041900007],
              [106.23552493600005, 73.14740631700005],
              [106.26059004000007, 73.14809804900005],
              [106.28248131600003, 73.15322500200006],
              [106.29957116000003, 73.16518789300005],
              [106.31544030000003, 73.17902252800008],
              [106.33301842500003, 73.18964264500005],
              [106.35987389400003, 73.19428131700005],
              [106.77556399800005, 73.14101797100005],
              [106.83326256600003, 73.14850495000007],
              [106.89991295700003, 73.14468008000006],
              [107.03589928500003, 73.18219635600008],
              [107.32740319100003, 73.15839264500005],
              [107.49293053500003, 73.17308177300004],
              [107.72234134200005, 73.16852448100008],
              [107.83432050900007, 73.18280670800004],
              [107.96607506600003, 73.23102448100008],
              [108.09164472700007, 73.24640534100007],
              [108.12183678500003, 73.24428945500006],
              [108.25228925900007, 73.22085195500006],
              [108.31666100400003, 73.22158437700006],
              [108.37484785200007, 73.23240794500003],
              [108.39616946700005, 73.25787995000007],
              [108.36524498800003, 73.27562083500004],
              [108.23894290500004, 73.27435944200005],
              [108.19752037900003, 73.27903880400004],
              [108.24122155000003, 73.30072663000004],
              [108.39332116000003, 73.31732819200005],
              [108.53891035200007, 73.31069570500006],
              [108.68482506600003, 73.33982982000003],
              [108.92302493600005, 73.35040924700007],
              [109.06885826900003, 73.37372467700004],
              [109.22120201900003, 73.38711172100005],
              [109.25269616000003, 73.40253327000005],
              [109.25489342500003, 73.42023346600007],
              [109.24040774800005, 73.42885976800005],
              [109.21998131600003, 73.43455638200004],
              [109.20492597700007, 73.44354889500005],
              [109.19939212300005, 73.46063873900005],
              [109.20923912900003, 73.46881745000007],
              [109.22771243600005, 73.46991608300004],
              [109.34888756600003, 73.43610260600008],
              [109.37810306100005, 73.41962311400005],
              [109.39616946700005, 73.41364166900007],
              [109.41724694100003, 73.41559479400007],
              [109.43490644600007, 73.42670319200005],
              [109.43913821700005, 73.44049713700008],
              [109.43083743600005, 73.45221588700008],
              [109.41032962300005, 73.45718008000006],
              [109.38851972700007, 73.46002838700008],
              [109.33464603000004, 73.48444245000007],
              [109.28728274800005, 73.49848053600005],
              [109.23829186300003, 73.50495026200008],
              [109.19597415500004, 73.50454336100006],
              [109.18018639400003, 73.51019928600005],
              [109.18433678500003, 73.52545807500007],
              [109.18043053500003, 73.52863190300008],
              [109.17017662900003, 73.53969961100006],
              [109.19361412900003, 73.55166250200006],
              [109.22120201900003, 73.54511139500005],
              [109.25001061300003, 73.53241608300004],
              [109.27662194100003, 73.52545807500007],
              [109.30543053500003, 73.52277252800008],
              [109.36459394600007, 73.50580475500004],
              [109.44996178500003, 73.47113678600005],
              [109.51205488400007, 73.45750560100004],
              [109.57634524800005, 73.45123932500007],
              [109.71387780000003, 73.45258209800005],
              [109.85523522200003, 73.47142161700003],
              [110.01042728000004, 73.50922272300005],
              [110.10377037900003, 73.51605866100005],
              [110.13168379000007, 73.52594635600008],
              [110.15699303500003, 73.54588450700004],
              [110.14242597700007, 73.55621979400007],
              [110.12549889400003, 73.56000397300005],
              [110.08936608200003, 73.55955638200004],
              [110.12427819100003, 73.58030833500004],
              [110.16684004000007, 73.58787669500003],
              [110.25318444100003, 73.58685944200005],
              [110.42457116000003, 73.60736725500004],
              [110.39722741000003, 73.61481354400007],
              [110.42261803500003, 73.63979726800005],
              [110.47055097700007, 73.64935944200005],
              [110.56316165500004, 73.64891185100004],
              [110.89861087300005, 73.68585846600007],
              [110.92481530000003, 73.70416901200008],
              [110.91871178500003, 73.71531810100004],
              [110.88445071700005, 73.72597890800006],
              [110.87647545700003, 73.73460521000004],
              [110.88135826900003, 73.74555084800005],
              [110.89283287900003, 73.75503164300005],
              [110.90658613400007, 73.76211172100005],
              [110.91797936300003, 73.76561107000003],
              [110.87777754000007, 73.76784902600008],
              [110.72022545700003, 73.77659739800004],
              [110.69214928500003, 73.78400299700007],
              [110.66374759200005, 73.78725820500006],
              [110.28687584700003, 73.70575592700004],
              [109.79957116000003, 73.70506419500003],
              [109.75228925900007, 73.68309153900003],
              [109.76238040500004, 73.68305084800005],
              [109.77165774800005, 73.68060944200005],
              [109.78003991000003, 73.67584870000007],
              [109.78711998800003, 73.66885000200006],
              [109.73747806100005, 73.66168854400007],
              [109.67367597700007, 73.67816803600005],
              [109.61280358200003, 73.70807526200008],
              [109.55551191500007, 73.75519440300008],
              [109.54135175900007, 73.76410553600005],
              [109.53109785200007, 73.77529531500005],
              [109.52702884200005, 73.79608795800004],
              [109.53565514400003, 73.82123444200005],
              [109.55762780000003, 73.83397044500003],
              [109.71949303500003, 73.85358307500007],
              [109.81983483200003, 73.87726471600007],
              [109.84253991000003, 73.89191315300008],
              [109.85775800900007, 73.91425202000005],
              [109.87094160200007, 73.93903229400007],
              [109.88672936300003, 73.96088288000004],
              [109.92172285200007, 73.98383209800005],
              [109.97038821700005, 74.00234609600005],
              [110.02149498800003, 74.01447174700007],
              [110.30005944100003, 74.01911041900007],
              [110.58082116000003, 73.99140045800004],
              [110.71192467500003, 73.95746491100005],
              [110.78931725400003, 73.95514557500007],
              [110.81495201900003, 73.95001862200007],
              [110.90430748800003, 73.91583893400008],
              [110.95899498800003, 73.90863678600005],
              [111.00782311300003, 73.91266510600008],
              [111.05469811300003, 73.92682526200008],
              [111.10303795700003, 73.95001862200007],
              [111.08521569100003, 73.96405670800004],
              [111.07227623800003, 73.97134023600006],
              [111.06763756600003, 73.97992584800005],
              [111.07569420700003, 73.99843984600005],
              [111.09620201900003, 74.01788971600007],
              [111.12623131600003, 74.03046295800004],
              [111.15902754000007, 74.03733958500004],
              [111.53646894600007, 74.05117422100005],
              [111.56983483200003, 74.04319896000004],
              [111.58220462300005, 74.02570221600007],
              [111.56128991000003, 74.00885651200008],
              [111.51905358200003, 74.00446198100008],
              [111.44556725400003, 74.00527578300006],
              [111.38160241000003, 73.98822663000004],
              [111.35010826900003, 73.98647695500006],
              [111.28663170700003, 74.00169505400004],
              [111.25440514400003, 74.00067780200004],
              [111.22339928500003, 73.99258047100005],
              [111.19849694100003, 73.97793203300006],
              [111.29517662900003, 73.86912669500003],
              [111.43555748800003, 73.81256745000007],
              [111.80372155000003, 73.74420807500007],
              [112.14722741000003, 73.70795319200005],
              [112.37183678500003, 73.70530833500004],
              [112.48462975400003, 73.72431061400005],
              [112.60857181100005, 73.71979401200008],
              [112.717133009, 73.73973216400003],
              [112.82146243600005, 73.74681224200003],
              [112.92017662900003, 73.77887604400007],
              [112.94532311300009, 73.79047272300005],
              [112.95948326900009, 73.80658600500004],
              [112.95801842500009, 73.81329987200007],
              [112.94581139400009, 73.84760163000004],
              [112.94092858200008, 73.85301341400003],
              [112.93441816500001, 73.85748932500007],
              [112.93091881600003, 73.86294179900005],
              [112.93555748800009, 73.87177155200004],
              [112.93685957100001, 73.87685781500005],
              [112.93458092500009, 73.88231028900003],
              [112.930023634, 73.88670482000003],
              [112.914398634, 73.89256419500003],
              [112.88428795700008, 73.91229889500005],
              [112.87810306100005, 73.91958242400005],
              [112.87061608200008, 73.93378327000005],
              [112.85377037900003, 73.94257233300004],
              [112.83513431100005, 73.94928620000007],
              [112.82292728000004, 73.95746491100005],
              [112.81999759200005, 73.96588776200008],
              [112.81812584700003, 73.97846100500004],
              [112.81861412900003, 73.99091217700004],
              [112.82292728000004, 73.99843984600005],
              [112.84693444100003, 73.99453359600005],
              [112.94605553500003, 73.94009023600006],
              [113.11150149800005, 73.89215729400007],
              [113.13135826900009, 73.88231028900003],
              [113.13843834700003, 73.87604401200008],
              [113.14747155000009, 73.86603424700007],
              [113.15544681100005, 73.85468170800004],
              [113.15870201900009, 73.84446849200003],
              [113.16521243600005, 73.84617747600004],
              [113.27670332100001, 73.75397370000007],
              [113.31185957100001, 73.74054596600007],
              [113.39551842500009, 73.68577708500004],
              [113.40577233200008, 73.67625560100004],
              [113.418304884, 73.65766022300005],
              [113.42790774800005, 73.63397858300004],
              [113.43051191500001, 73.60993073100008],
              [113.42269941500001, 73.59064362200007],
              [113.40235436300009, 73.58075592700004],
              [113.37086022200003, 73.57583242400005],
              [113.312836134, 73.57387929900005],
              [113.29265384200005, 73.56976959800005],
              [113.27458743600005, 73.55975983300004],
              [113.22632897200003, 73.52488841400003],
              [113.19288170700008, 73.48444245000007],
              [113.17847741000003, 73.47553131700005],
              [113.14503014400009, 73.46076080900008],
              [113.13135826900009, 73.44969310100004],
              [113.14991295700008, 73.44212474200003],
              [113.187836134, 73.43329498900005],
              [113.20639082100001, 73.42645905200004],
              [113.219086134, 73.41893138200004],
              [113.22657311300009, 73.41217682500007],
              [113.24122155000009, 73.39508698100008],
              [113.27230879000001, 73.37518952000005],
              [113.31006920700008, 73.36505768400008],
              [113.41334069100003, 73.35980866100005],
              [113.45834394600001, 73.35162995000007],
              [113.49463951900009, 73.33991120000007],
              [113.49830162900003, 73.33588288000004],
              [113.496429884, 73.32949453300006],
              [113.49301191500001, 73.28978099200003],
              [113.494476759, 73.27903880400004],
              [113.49773196700005, 73.27057526200008],
              [113.50668379000001, 73.25291575700004],
              [113.50806725400003, 73.24428945500006],
              [113.50261478000004, 73.22402578300006],
              [113.49341881600003, 73.20840078300006],
              [113.48658287900003, 73.19208405200004],
              [113.48707116000003, 73.16982656500005],
              [113.49439537900003, 73.15428294500003],
              [113.51644941500001, 73.12295156500005],
              [113.52116946700005, 73.10398997600004],
              [113.50342858200008, 73.06915924700007],
              [113.47120201900009, 73.03021881700005],
              [113.45525149800005, 72.99310944200005],
              [113.48707116000003, 72.96369049700007],
              [113.31153405000009, 72.89370351800005],
              [113.26319420700008, 72.88434479400007],
              [113.16358483200008, 72.87592194200005],
              [113.11768639400009, 72.86066315300008],
              [113.09717858200008, 72.84080638200004],
              [113.10450280000009, 72.82196686400005],
              [113.12875410200002, 72.80451080900008],
              [113.15870201900009, 72.78900788000004],
              [113.17042076900009, 72.78034088700008],
              [113.17400149800005, 72.77094147300005],
              [113.17237389400009, 72.74835846600007],
              [113.17725670700008, 72.73297760600008],
              [113.18921959700003, 72.72190989800004],
              [113.26368248800009, 72.68903229400007],
              [113.36817467500009, 72.66547272300005],
              [113.44288170700008, 72.65900299700007],
              [113.49724368600005, 72.64524974200003],
              [113.79379316500007, 72.62295156450006],
              [114.09034264400009, 72.60065338700008],
              [114.04216556100005, 72.62067291900007],
              [113.71656334750003, 72.65064118050006],
              [113.390961134, 72.68060944200005],
              [113.23804772200003, 72.73541901200008],
              [113.22510826900009, 72.74457428600005],
              [113.21583092500009, 72.77558014500005],
              [113.20573978000004, 72.78359609600005],
              [113.19336998800009, 72.78912995000007],
              [113.18262780000009, 72.79547760600008],
              [113.15821373800009, 72.82269928600005],
              [113.15967858200008, 72.83795807500007],
              [113.18043053500003, 72.84906647300005],
              [113.25766035200002, 72.87881094000005],
              [113.35352623800009, 72.89126211100006],
              [113.51685631600003, 72.95294830900008],
              [113.54224694100003, 72.97736237200007],
              [113.51921634200005, 73.01703522300005],
              [113.53093509200005, 73.04840729400007],
              [113.60059655000009, 73.10398997600004],
              [113.59913170700008, 73.12787506700005],
              [113.52930748800009, 73.18268463700008],
              [113.53174889400009, 73.21385325700004],
              [113.53630618600005, 73.22060781500005],
              [113.54249108200008, 73.23627350500004],
              [113.54908287900003, 73.24428945500006],
              [113.56234785200002, 73.25340403900003],
              [113.67261803500003, 73.29266998900005],
              [113.69483483200008, 73.30951569200005],
              [113.70818118600005, 73.31732819200005],
              [113.72413170700008, 73.32062409100007],
              [113.85254967500009, 73.31411367400005],
              [113.92676842500009, 73.33124420800004],
              [114.00025475400003, 73.33445872600004],
              [114.03581790500004, 73.34731679900005],
              [113.99024498800009, 73.36054108300004],
              [113.84359785200002, 73.34731679900005],
              [113.79737389400009, 73.35089752800008],
              [113.77507571700005, 73.35614655200004],
              [113.69516035200002, 73.38662344000005],
              [113.64226321700005, 73.39435455900008],
              [113.60352623800009, 73.40753815300008],
              [113.53541100400003, 73.43984609600005],
              [113.515961134, 73.45624420800004],
              [113.48585045700008, 73.49477773600006],
              [113.46656334700003, 73.50495026200008],
              [113.49366295700008, 73.51064687700006],
              [113.68262780000009, 73.52204010600008],
              [113.91504967500009, 73.53583405200004],
              [114.10914147200003, 73.59955475500004],
              [114.39189700600002, 73.59607575100006],
              [114.67465254000001, 73.59259674700007],
              [114.73218834700003, 73.60346100500004],
              [114.85352623800009, 73.60887278900003],
              [115.11158287900003, 73.67511627800008],
              [115.41309655000009, 73.71039459800005],
              [115.87476647200003, 73.68935781500005],
              [116.17286217500009, 73.67572663000004],
              [116.60287519600001, 73.67479075700004],
              [117.05982506600003, 73.61522044500003],
              [117.44385826900009, 73.58877187700006],
              [117.73511803500003, 73.58209870000007],
              [117.91358483200008, 73.59601471600007],
              [118.18189537850009, 73.59239329650006],
              [118.45020592500009, 73.58877187700006],
              [118.79053795700008, 73.55597565300008],
              [118.89771569100003, 73.53046295800004],
              [118.99756920700008, 73.49135976800005],
              [118.94776451900009, 73.46588776200008],
              [118.88257897200003, 73.45189036700003],
              [118.81519616000003, 73.44953034100007],
              [118.75896243600005, 73.45892975500004],
              [118.73796634200005, 73.45994700700004],
              [118.70655358200008, 73.44391510600008],
              [118.68311608200008, 73.44513580900008],
              [118.63917076900009, 73.45319245000007],
              [118.62631269600001, 73.45718008000006],
              [118.61939537900003, 73.46210358300004],
              [118.60670006600003, 73.47577545800004],
              [118.59937584700003, 73.48102448100008],
              [118.57618248800009, 73.48627350500004],
              [118.48951256600003, 73.48444245000007],
              [118.467133009, 73.47809479400007],
              [118.43311608200008, 73.44993724200003],
              [118.41163170700008, 73.44354889500005],
              [118.39429772200003, 73.44041575700004],
              [118.37183678500003, 73.43170807500007],
              [118.35287519600001, 73.41876862200007],
              [118.34644616000003, 73.40253327000005],
              [118.35857181100005, 73.38857656500005],
              [118.38298587300005, 73.37978750200006],
              [118.40967858200008, 73.37539297100005],
              [118.42839603000004, 73.37466054900005],
              [118.41602623800009, 73.36139557500007],
              [118.37305748800009, 73.34023672100005],
              [118.37061608200008, 73.32998281500005],
              [118.37940514400009, 73.31415436400005],
              [118.37208092500009, 73.30438873900005],
              [118.359711134, 73.29547760600008],
              [118.35328209700003, 73.28241608300004],
              [118.35914147200003, 73.27826569200005],
              [118.39421634200005, 73.23802317900004],
              [118.40552819100003, 73.23358795800004],
              [118.43327884200005, 73.22866445500006],
              [118.445648634, 73.22040436400005],
              [118.453461134, 73.21385325700004],
              [118.46241295700008, 73.20941803600005],
              [118.91765384200005, 73.11953359600005],
              [119.088226759, 73.10639069200005],
              [119.25245201900009, 73.07318756700005],
              [119.36670983200008, 73.07908763200004],
              [119.45997155000009, 73.06415436400005],
              [119.49854576900009, 73.06220123900005],
              [119.53451582100001, 73.05524323100008],
              [119.56666100400003, 73.03266022300005],
              [119.58326256600003, 73.00901927300004],
              [119.59294681100005, 73.00287506700005],
              [119.61312910200002, 72.99848053600005],
              [119.66016686300009, 72.99892812700006],
              [119.68539472700002, 72.99469635600008],
              [119.69646243600005, 72.98110586100006],
              [119.72250410200002, 72.95892975500004],
              [120.12810306050005, 72.91657135650004],
              [120.53370201900009, 72.87421295800004],
              [120.57349694100003, 72.88861725500004],
              [120.54037519600001, 72.90131256700005],
              [120.19096927150002, 72.92908356300006],
              [119.84156334700003, 72.95685455900008],
              [119.80713951900009, 72.96751536700003],
              [119.77833092500009, 72.98480866100005],
              [119.76384524800005, 73.00828685100004],
              [119.78337649800005, 73.01801178600005],
              [120.23121178500003, 72.98627350500004],
              [120.42359459700003, 72.98822663000004],
              [120.65601647200003, 72.97736237200007],
              [120.82496178500003, 72.94745514500005],
              [121.05469811300009, 72.93178945500006],
              [121.13591556100005, 72.94773997600004],
              [121.25269616000003, 72.95111725500004],
              [121.38819420700008, 72.97606028900003],
              [121.66960696700005, 72.97052643400008],
              [121.73487389400009, 72.95831940300008],
              [121.74870853000004, 72.96027252800008],
              [121.791351759, 72.97687409100007],
              [121.96371504000001, 72.96369049700007],
              [121.95460045700008, 72.95197174700007],
              [121.92888431100005, 72.93878815300008],
              [121.92351321700005, 72.92584870000007],
              [121.93384850400003, 72.92413971600007],
              [122.043304884, 72.89154694200005],
              [122.42310631600003, 72.87498607000003],
              [122.53419030000009, 72.83901601800005],
              [122.623383009, 72.82770416900007],
              [122.73218834700003, 72.82656484600005],
              [122.31324303500003, 72.93439362200007],
              [122.30827884200005, 72.94135163000004],
              [122.32129967500009, 72.95010000200006],
              [122.35987389400009, 72.95018138200004],
              [122.84310957100001, 72.87250397300005],
              [122.87256920700008, 72.87250397300005],
              [122.95337975400003, 72.89154694200005],
              [122.69503828250004, 72.93445465700006],
              [122.43669681100005, 72.97736237200007],
              [122.435883009, 72.98078034100007],
              [122.43604576900009, 72.98358795800004],
              [122.43490644600001, 72.98517487200007],
              [122.43043053500003, 72.98480866100005],
              [122.44857832100001, 72.98989492400005],
              [122.467133009, 72.99160390800006],
              [122.50505618600005, 72.99103424700007],
              [122.47144616000003, 73.00922272300005],
              [122.46469160200002, 73.01898834800005],
              [122.61378014400009, 73.03095123900005],
              [122.75928795700008, 73.00446198100008],
              [122.85914147200003, 72.99848053600005],
              [122.867523634, 72.99323151200008],
              [122.87061608200008, 72.98118724200003],
              [122.87566165500004, 72.96784088700008],
              [122.88998457100001, 72.95868561400005],
              [123.13795006600003, 72.91803620000007],
              [123.19092858200008, 72.92210521000004],
              [123.21452884200005, 72.92755768400008],
              [123.23454837300005, 72.93471914300005],
              [123.252289259, 72.94513580900008],
              [123.27003014400009, 72.96027252800008],
              [123.28785241000003, 72.96869538000004],
              [123.33814537900003, 72.98110586100006],
              [123.34864342500009, 72.98798248900005],
              [123.34262129000001, 72.99909088700008],
              [123.31812584700003, 73.01312897300005],
              [123.31430097700002, 73.02578359600005],
              [123.322601759, 73.03457265800006],
              [123.36963951900009, 73.06610748900005],
              [123.38306725400003, 73.07949453300006],
              [123.40040123800009, 73.09320709800005],
              [123.42009524800005, 73.09955475500004],
              [123.44125410200002, 73.09031810100004],
              [123.44516035200002, 73.08454010600008],
              [123.44703209700003, 73.07892487200007],
              [123.45045006600003, 73.07465241100005],
              [123.45875084700003, 73.07294342700004],
              [123.46338951900009, 73.07489655200004],
              [123.46794681100005, 73.07957591400003],
              [123.47046959700003, 73.08539459800005],
              [123.46656334700003, 73.09699127800008],
              [123.46957441500001, 73.10171133000006],
              [123.46941165500004, 73.10626862200007],
              [123.45687910200002, 73.11261627800008],
              [123.44402103000004, 73.11424388200004],
              [123.41578209700003, 73.11200592700004],
              [123.40381920700008, 73.11456940300008],
              [123.39730879000001, 73.12164948100008],
              [123.37582441500001, 73.15550364800004],
              [123.40088951900009, 73.17430247600004],
              [123.45191491000003, 73.18634674700007],
              [123.54712975400003, 73.19708893400008],
              [123.51295006600003, 73.17597077000005],
              [123.54509524800005, 73.16083405200004],
              [123.58529707100001, 73.16034577000005],
              [123.66382897200003, 73.16982656500005],
              [123.60922285200002, 73.18280670800004],
              [123.62029056100005, 73.19379303600005],
              [123.63648522200003, 73.19708893400008],
              [123.65455162900003, 73.19847239800004],
              [123.67066491000003, 73.20331452000005],
              [123.65064537900003, 73.21523672100005],
              [123.62525475400003, 73.21881745000007],
              [123.55347741000003, 73.21759674700007],
              [123.53858483200008, 73.22040436400005],
              [123.52442467500009, 73.22687409100007],
              [123.50611412900003, 73.23802317900004],
              [123.51295006600003, 73.23802317900004],
              [123.50220787900003, 73.24042389500005],
              [123.49268639400009, 73.24445221600007],
              [123.48487389400009, 73.25018952000005],
              [123.47950280000009, 73.25787995000007],
              [123.50098717500009, 73.25787995000007],
              [123.50945071700005, 73.26557038000004],
              [123.50261478000004, 73.27464427300004],
              [123.41382897200003, 73.28632233300004],
              [123.39625084700003, 73.29266998900005],
              [123.37891686300009, 73.30475495000007],
              [123.33765709700003, 73.34100983300004],
              [123.33179772200003, 73.35073476800005],
              [123.39828535200002, 73.38011302300004],
              [123.41334069100003, 73.39093659100007],
              [123.37582441500001, 73.39508698100008],
              [123.29346764400009, 73.38971588700008],
              [123.250336134, 73.39297109600005],
              [123.21810957100001, 73.40875885600008],
              [123.23926842500009, 73.41681549700007],
              [123.29590905000009, 73.42108795800004],
              [123.30746504000001, 73.42645905200004],
              [123.30250084700003, 73.43732330900008],
              [123.28980553500003, 73.44619375200006],
              [123.27418053500003, 73.45278554900005],
              [123.25977623800009, 73.45718008000006],
              [123.28191165500004, 73.46417877800008],
              [123.30746504000001, 73.46629466400003],
              [123.33334394600001, 73.46385325700004],
              [123.35596764400009, 73.45718008000006],
              [123.37159264400009, 73.44647858300004],
              [123.38355553500003, 73.43577708500004],
              [123.39722741000003, 73.43235911700003],
              [123.41732832100001, 73.44354889500005],
              [123.39503014400009, 73.46613190300008],
              [123.36109459700003, 73.48358795800004],
              [123.28638756600003, 73.50495026200008],
              [123.28825931100005, 73.50849030200004],
              [123.28907311300009, 73.51162344000005],
              [123.29053795700008, 73.51479726800005],
              [123.29395592500009, 73.51862213700008],
              [123.27076256600003, 73.53461334800005],
              [123.24610436300009, 73.54588450700004],
              [123.26644941500001, 73.56391022300005],
              [123.30103600400003, 73.56688060100004],
              [123.36963951900009, 73.55955638200004],
              [123.35865319100003, 73.57257721600007],
              [123.32553144600001, 73.58266836100006],
              [123.31430097700002, 73.59438711100006],
              [123.39665774800005, 73.58124420800004],
              [123.424164259, 73.58071523600006],
              [123.41602623800009, 73.59682851800005],
              [123.40365644600001, 73.60394928600005],
              [123.38933353000004, 73.60968659100007],
              [123.37582441500001, 73.62164948100008],
              [123.38648522200003, 73.63182200700004],
              [123.38770592500009, 73.64272695500006],
              [123.38135826900009, 73.65326569200005],
              [123.36963951900009, 73.66266510600008],
              [123.51254316500001, 73.68720123900005],
              [123.54712975400003, 73.71039459800005],
              [123.56885826900009, 73.71605052300004],
              [123.59131920700008, 73.71698639500005],
              [123.61207116000003, 73.71124909100007],
              [123.62907962300005, 73.69672272300005],
              [123.58790123800009, 73.68366120000007],
              [123.57447350400003, 73.67625560100004],
              [123.57935631600003, 73.67438385600008],
              [123.58814537900003, 73.66986725500004],
              [123.59498131600003, 73.66885000200006],
              [123.58790123800009, 73.65688711100006],
              [123.57601972700002, 73.64850495000007],
              [123.56169681100005, 73.64337799700007],
              [123.63013756600003, 73.64085521000004],
              [123.65699303500003, 73.63532135600008],
              [123.64323978000004, 73.62856679900005],
              [123.61475670700008, 73.62051015800006],
              [123.60181725400003, 73.61481354400007],
              [123.64551842500009, 73.60297272300005],
              [123.69125410200002, 73.60419342700004],
              [123.78052819100003, 73.62164948100008],
              [123.88575280000009, 73.62360260600008],
              [123.88965905000009, 73.63532135600008],
              [123.94703209700003, 73.62636953300006],
              [123.97380618600005, 73.62702057500007],
              [123.99952233200008, 73.64150625200006],
              [123.97575931100005, 73.65403880400004],
              [123.94629967500009, 73.66046784100007],
              [123.92139733200008, 73.66876862200007],
              [123.91089928500003, 73.68683502800008],
              [123.90902754000001, 73.69358958500004],
              [123.90528405000009, 73.70042552300004],
              [123.90259850400003, 73.70819733300004],
              [123.90349368600005, 73.71723053600005],
              [123.90870201900009, 73.72516510600008],
              [123.93140709700003, 73.74518463700008],
              [123.91675866000003, 73.74917226800005],
              [123.90235436300009, 73.75527578300006],
              [123.88884524800005, 73.76312897300005],
              [123.87671959700003, 73.77252838700008],
              [123.90528405000009, 73.77505117400005],
              [123.93287194100003, 73.77456289300005],
              [123.95972741000003, 73.76951732000003],
              [123.98601321700005, 73.75885651200008],
              [124.01612389400009, 73.73639557500007],
              [124.033539259, 73.72699616100005],
              [124.05494225400003, 73.72406647300005],
              [124.04395592500009, 73.70929596600007],
              [124.00586998800009, 73.70205312700006],
              [123.99284915500004, 73.69057851800005],
              [124.05958092500009, 73.68480052300004],
              [124.09449303500003, 73.68817780200004],
              [124.10938561300009, 73.70734284100007],
              [124.12964928500003, 73.71898021000004],
              [124.21900475400003, 73.72426992400005],
              [124.23926842500009, 73.73460521000004],
              [124.23682701900009, 73.74917226800005],
              [124.23414147200003, 73.75576406500005],
              [124.23951256600003, 73.75958893400008],
              [124.30640709700003, 73.77472565300008],
              [124.31836998800009, 73.78241608300004],
              [124.32886803500003, 73.79975006700005],
              [124.33619225400003, 73.80483633000006],
              [124.35254967500009, 73.80658600500004],
              [124.38306725400003, 73.80638255400004],
              [124.39625084700003, 73.80239492400005],
              [124.40430748800009, 73.79238515800006],
              [124.38672936300009, 73.79096100500004],
              [124.37029056100005, 73.78611888200004],
              [124.42847741000003, 73.78652578300006],
              [124.48633873800009, 73.77871328300006],
              [124.49537194100003, 73.77480703300006],
              [124.51148522200003, 73.76349518400008],
              [124.52035566500001, 73.75885651200008],
              [124.53199303500003, 73.75576406500005],
              [124.568695509, 73.75136953300006],
              [124.61158287900003, 73.73745351800005],
              [124.63135826900009, 73.73631419500003],
              [124.65845787900003, 73.74323151200008],
              [124.67741946700005, 73.74591705900008],
              [124.69548587300005, 73.74213288000004],
              [124.70329837300005, 73.73240794500003],
              [124.691742384, 73.71723053600005],
              [124.72592207100001, 73.70840078300006],
              [124.85621178500003, 73.72406647300005],
              [124.84888756600003, 73.71271393400008],
              [124.84424889400009, 73.70844147300005],
              [124.83570397200003, 73.70416901200008],
              [124.85108483200008, 73.69769928600005],
              [124.87037194100003, 73.69350820500006],
              [124.90772545700008, 73.69057851800005],
              [124.91146894600001, 73.68732330900008],
              [124.92269941500001, 73.67206452000005],
              [124.92994225400003, 73.66718170800004],
              [124.951508009, 73.66474030200004],
              [124.96973717500009, 73.67035553600005],
              [124.97974694100003, 73.67625560100004],
              [124.97543379000001, 73.66640859600005],
              [124.98975670700008, 73.64411041900007],
              [124.98658287900003, 73.62787506700005],
              [125.01465905000009, 73.62958405200004],
              [125.043304884, 73.64101797100005],
              [125.05909264400009, 73.65965403900003],
              [125.04802493600005, 73.68309153900003],
              [125.07309004000001, 73.68789297100005],
              [125.10271243600005, 73.68610260600008],
              [125.12720787900003, 73.68817780200004],
              [125.13746178500003, 73.70416901200008],
              [125.13868248800009, 73.69212474200003],
              [125.14503014400009, 73.68280670800004],
              [125.15447024800005, 73.67527903900003],
              [125.16529381600003, 73.66885000200006],
              [125.16138756600003, 73.66592031500005],
              [125.15105228000004, 73.65574778900003],
              [125.16586347700002, 73.65086497600004],
              [125.18116295700008, 73.64891185100004],
              [125.21241295700008, 73.64891185100004],
              [125.19605553500003, 73.63401927300004],
              [125.17774498800009, 73.62164948100008],
              [125.18921959700003, 73.61615631700005],
              [125.20167076900009, 73.61432526200008],
              [125.21387780000009, 73.61615631700005],
              [125.21094811300009, 73.61546458500004],
              [125.19312584700003, 73.60309479400007],
              [125.17798912900003, 73.58885325700004],
              [125.17156009200005, 73.57729726800005],
              [125.17937259200005, 73.55853913000004],
              [125.19752037900003, 73.55093008000006],
              [125.21810957100001, 73.55390045800004],
              [125.23292076900009, 73.56704336100006],
              [125.24626712300005, 73.54401276200008],
              [125.28679446700005, 73.53912995000007],
              [125.33350670700008, 73.55198802300004],
              [125.36491946700005, 73.58270905200004],
              [125.363617384, 73.57444896000004],
              [125.365570509, 73.56879303600005],
              [125.37191816500001, 73.56427643400008],
              [125.38379967500009, 73.55955638200004],
              [125.39893639400009, 73.55560944200005],
              [125.40992272200003, 73.55605703300006],
              [125.41993248800009, 73.56004466400003],
              [125.43213951900009, 73.56704336100006],
              [125.43604576900009, 73.57001373900005],
              [125.43962649800005, 73.57387929900005],
              [125.46290123800009, 73.57103099200003],
              [125.47584069100003, 73.55947500200006],
              [125.47396894600001, 73.54804108300004],
              [125.45264733200008, 73.54588450700004],
              [125.47559655000009, 73.54083893400008],
              [125.555023634, 73.54588450700004],
              [125.63021894600001, 73.53461334800005],
              [125.65186608200008, 73.52545807500007],
              [125.64356530000009, 73.52106354400007],
              [125.62330162900003, 73.50495026200008],
              [125.64437910200002, 73.50495026200008],
              [125.64437910200002, 73.49811432500007],
              [125.53825931100005, 73.47451406500005],
              [125.52100670700008, 73.45718008000006],
              [125.53199303500003, 73.43968333500004],
              [125.57496178500003, 73.42300039300005],
              [125.56251061300009, 73.40875885600008],
              [125.59571373800009, 73.41038646000004],
              [125.62322024800005, 73.41998932500007],
              [125.63038170700008, 73.43423086100006],
              [125.60352623800009, 73.44969310100004],
              [125.63868248800009, 73.45819733300004],
              [125.76107832100001, 73.47040436400005],
              [125.78785241000003, 73.46059804900005],
              [125.80176842500009, 73.45229726800005],
              [125.83228600400003, 73.45335521000004],
              [125.87663821700005, 73.46059804900005],
              [125.86939537900003, 73.47394440300008],
              [125.85254967500009, 73.47919342700004],
              [125.83228600400003, 73.48281484600005],
              [125.81576582100001, 73.49135976800005],
              [125.88502037900003, 73.51068756700005],
              [125.90455162900003, 73.51862213700008],
              [125.90699303500003, 73.52358633000006],
              [125.90650475400003, 73.53066640800006],
              [125.90870201900009, 73.53693268400008],
              [125.91846764400009, 73.53969961100006],
              [125.94776451900009, 73.54100169500003],
              [125.96168053500003, 73.53912995000007],
              [125.97282962300005, 73.53229401200008],
              [125.97315514400009, 73.52484772300005],
              [125.96599368600005, 73.48444245000007],
              [125.95679772200003, 73.46893952000005],
              [125.94361412900003, 73.45673248900005],
              [125.91187584700003, 73.43610260600008],
              [125.94117272200003, 73.42829010600008],
              [125.97486412900003, 73.43593984600005],
              [126.00440514400009, 73.45404694200005],
              [126.02051842500009, 73.47768789300005],
              [126.01685631600003, 73.48297760600008],
              [126.00904381600003, 73.49030182500007],
              [126.00554446700005, 73.49896881700005],
              [126.014008009, 73.50869375200006],
              [126.033539259, 73.51471588700008],
              [126.10377037900003, 73.51862213700008],
              [126.22657311300009, 73.55459219000005],
              [126.26832116000003, 73.55955638200004],
              [126.28809655000009, 73.55727773600006],
              [126.30567467500009, 73.55145905200004],
              [126.35328209700003, 73.52850983300004],
              [126.40479576900009, 73.51239655200004],
              [126.39136803500003, 73.50250885600008],
              [126.381195509, 73.49030182500007],
              [126.37940514400009, 73.47703685100004],
              [126.39112389400009, 73.46401601800005],
              [126.37810306100005, 73.45172760600008],
              [126.36255944100003, 73.44310130400004],
              [126.32911217500009, 73.42987702000005],
              [126.31641686300009, 73.44285716400003],
              [126.29574629000001, 73.45180898600006],
              [126.27320397200003, 73.45465729400007],
              [126.25456790500004, 73.44969310100004],
              [126.23910566500001, 73.44261302300004],
              [126.20337975400003, 73.45477936400005],
              [126.17074629000001, 73.45929596600007],
              [126.15162194100003, 73.43610260600008],
              [126.17839603000004, 73.43475983300004],
              [126.20777428500003, 73.42926666900007],
              [126.23487389400009, 73.41876862200007],
              [126.25456790500004, 73.40253327000005],
              [126.232758009, 73.38987864800004],
              [126.18140709700003, 73.38890208500004],
              [126.15845787900003, 73.38149648600006],
              [126.28199303500003, 73.38593170800004],
              [126.38884524800005, 73.41181061400005],
              [126.41968834700003, 73.40949127800008],
              [126.45313561300009, 73.39508698100008],
              [126.44434655000009, 73.39077383000006],
              [126.43946373800009, 73.38641998900005],
              [126.43213951900009, 73.37466054900005],
              [126.49415123800009, 73.37173086100006],
              [126.52312259200005, 73.36371491100005],
              [126.54883873800009, 73.34731679900005],
              [126.58969160200002, 73.29580312700006],
              [126.58448326900009, 73.28363678600005],
              [126.56104576900009, 73.26943594000005],
              [126.55567467500009, 73.25482819200005],
              [126.55811608200008, 73.24201080900008],
              [126.56519616000003, 73.23346588700008],
              [126.61207116000003, 73.27533600500004],
              [126.65007571700005, 73.29169342700004],
              [126.65870201900009, 73.30263906500005],
              [126.64535566500001, 73.31635163000004],
              [126.56299889400009, 73.38149648600006],
              [126.61304772200003, 73.37933991100005],
              [126.63990319100003, 73.38117096600007],
              [126.65870201900009, 73.38890208500004],
              [126.66138756600003, 73.39760976800005],
              [126.65943444100003, 73.40810781500005],
              [126.65870201900009, 73.41836172100005],
              [126.66553795700008, 73.42645905200004],
              [126.69353274800005, 73.43720123900005],
              [126.73015384200005, 73.44415924700007],
              [126.76172936300009, 73.43870677300004],
              [126.78467858200008, 73.39142487200007],
              [126.80591881600003, 73.38324616100005],
              [126.82878665500004, 73.38861725500004],
              [126.84302819100003, 73.40875885600008],
              [126.83969160200002, 73.42039622600004],
              [126.83253014400009, 73.43162669500003],
              [126.83318118600005, 73.44013092700004],
              [126.85328209700003, 73.44354889500005],
              [126.93238366000003, 73.42987702000005],
              [126.90894616000003, 73.45254140800006],
              [126.90503991000003, 73.45718008000006],
              [126.906586134, 73.46588776200008],
              [126.91667728000004, 73.47968170800004],
              [126.91871178500003, 73.48444245000007],
              [126.91944420700008, 73.49371979400007],
              [126.92107181100005, 73.49945709800005],
              [126.91773522200003, 73.50429922100005],
              [126.90357506600003, 73.51044342700004],
              [126.88721764400009, 73.51471588700008],
              [126.86719811300009, 73.51764557500007],
              [126.83008873800009, 73.51862213700008],
              [126.85816491000003, 73.53339264500005],
              [126.89665774800005, 73.53929271000004],
              [127.05046634200005, 73.54901764500005],
              [127.18116295700008, 73.53904857000003],
              [127.45085696700005, 73.49070872600004],
              [127.51107832100001, 73.49599844000005],
              [127.98755944100003, 73.47085195500006],
              [127.97169030000009, 73.45502350500004],
              [127.94825280000009, 73.44757721600007],
              [127.92237389400009, 73.44306061400005],
              [127.89942467500009, 73.43610260600008],
              [128.0517684250001, 73.41632721600007],
              [128.07691491000003, 73.40566640800006],
              [128.059906446, 73.39052969000005],
              [127.98226972700002, 73.36334870000007],
              [127.96021569100003, 73.34731679900005],
              [128.18336022200003, 73.36098867400005],
              [128.20630944100003, 73.35761139500005],
              [128.24537194100003, 73.34650299700007],
              [128.26734459700003, 73.34906647300005],
              [128.31592858200008, 73.36102936400005],
              [128.3403426440001, 73.36102936400005],
              [128.36491946700005, 73.35415273600006],
              [128.3188582690001, 73.32998281500005],
              [128.3027449880001, 73.31590403900003],
              [128.30974368600005, 73.29889557500007],
              [128.23462975400003, 73.26536692900004],
              [128.325531446, 73.26756419500003],
              [128.3715926440001, 73.26097239800004],
              [128.40935306100005, 73.24115631700005],
              [128.43930097700002, 73.23627350500004],
              [128.5703231130001, 73.26536692900004],
              [128.61475670700008, 73.26605866100005],
              [128.65943444100003, 73.26129791900007],
              [128.7744246750001, 73.22793203300006],
              [128.81275475400003, 73.22138092700004],
              [128.8925887380001, 73.21698639500005],
              [128.884125196, 73.20734284100007],
              [128.8720809250001, 73.20062897300005],
              [128.8447371750001, 73.18964264500005],
              [128.8696395190001, 73.18650950700004],
              [128.93531334700003, 73.19586823100008],
              [128.96078535200002, 73.18964264500005],
              [128.9692488940001, 73.17739492400005],
              [128.9672957690001, 73.16453685100004],
              [128.95679772200003, 73.15387604400007],
              [128.92896569100003, 73.16063060100004],
              [128.850922071, 73.15550364800004],
              [128.86207116000003, 73.13641998900005],
              [128.8652449880001, 73.13442617400005],
              [128.86353600400003, 73.12734609600005],
              [128.86475670700008, 73.12148672100005],
              [128.8642684250001, 73.11615631700005],
              [128.85816491000003, 73.11082591400003],
              [128.84839928500003, 73.10732656500005],
              [128.816742384, 73.10089752800008],
              [128.80054772200003, 73.09308502800008],
              [128.7832137380001, 73.08136627800008],
              [128.7773543630001, 73.07078685100004],
              [128.79664147200003, 73.06610748900005],
              [128.8427840500001, 73.07477448100008],
              [128.93311608200008, 73.11273834800005],
              [128.9785262380001, 73.12140534100007],
              [129.06617272200003, 73.12767161700003],
              [129.11353600400003, 73.12164948100008],
              [129.226007547, 73.09774682400007],
              [129.34997963400008, 73.06264771000008],
              [129.4435084910001, 73.02894424900006],
              [129.476773009, 72.99652811400006],
              [129.4789311400001, 72.97923984400006],
              [129.441314949, 72.94944174500006],
              [129.35961841800008, 72.94001176500007],
              [129.23854407600004, 72.96122364100006],
              [129.112630878, 72.97194911100007],
              [128.92751877400008, 72.98015820800003],
              [128.77125084700003, 72.97174713700008],
              [128.67408287900003, 72.94521719000005],
              [128.29078209700003, 72.90863678600005],
              [128.2402449880001, 72.88963450700004],
              [128.21355228000004, 72.86066315300008],
              [128.24293053500003, 72.83661530200004],
              [128.22803795700008, 72.81948476800005],
              [128.129242384, 72.78607819200005],
              [128.35564212300005, 72.79393138200004],
              [128.83175703200004, 72.75570302950004],
              [129.30787194100003, 72.71747467700004],
              [129.35808353000004, 72.70302969000005],
              [129.27173912900003, 72.69672272300005],
              [129.22779381600003, 72.68789297100005],
              [129.19361412900003, 72.66889069200005],
              [129.20134524800005, 72.66815827000005],
              [129.22144616000003, 72.66205475500004],
              [129.19841556100005, 72.65517812700006],
              [128.86882571700005, 72.67820872600004],
              [128.79957116000003, 72.69196198100008],
              [128.72803795700008, 72.69684479400007],
              [128.67750084700003, 72.70823802300004],
              [128.6626082690001, 72.70990631700005],
              [128.51978600400003, 72.70441315300008],
              [128.50513756600003, 72.70840078300006],
              [128.50904381600003, 72.71670156500005],
              [128.47917728000004, 72.72455475500004],
              [128.46045983200008, 72.71621328300006],
              [128.44548587300005, 72.69965241100005],
              [128.42701256600003, 72.68317291900007],
              [128.39600670700008, 72.67316315300008],
              [127.96062259200005, 72.66205475500004],
              [127.90544681100005, 72.66714101800005],
              [127.99382571700005, 72.62457916900007],
              [128.10368899800005, 72.60065338700008],
              [128.188324415, 72.56781647300005],
              [128.21461022200003, 72.56146881700005],
              [128.2685653000001, 72.55609772300005],
              [128.6113387380001, 72.48273346600007],
              [128.83936608200008, 72.46507396000004],
              [129.11736087300005, 72.48151276200008],
              [129.2583113940001, 72.46393463700008],
              [129.27418053500003, 72.44696686400005],
              [129.24195397200003, 72.41567617400005],
              [129.30453535200002, 72.41063060100004],
              [129.368500196, 72.39736562700006],
              [129.48902428500003, 72.35419342700004],
              [129.48210696700005, 72.35301341400003],
              [129.46794681100005, 72.34674713700008],
              [129.4790145190001, 72.34454987200007],
              [129.49203535200002, 72.33974844000005],
              [129.50074303500003, 72.33246491100005],
              [129.49887129, 72.32257721600007],
              [129.485199415, 72.31720612200007],
              [129.36670983200008, 72.31492747600004],
              [129.34009850400003, 72.30508047100005],
              [129.33375084700003, 72.28554922100005],
              [129.34164472700002, 72.28424713700008],
              [129.35808353000004, 72.27789948100008],
              [129.35759524800005, 72.26288483300004],
              [129.3857528000001, 72.25690338700008],
              [129.467133009, 72.25047435100004],
              [129.5039168630001, 72.25214264500005],
              [129.52165774800005, 72.24941640800006],
              [129.56413821700005, 72.23065827000005],
              [129.54509524800005, 72.21710846600007],
              [129.51978600400003, 72.21527741100005],
              [129.49244225400003, 72.21771881700005],
              [129.46794681100005, 72.21702708500004],
              [129.35808353000004, 72.17544179900005],
              [129.32789147200003, 72.15867747600004],
              [129.306000196, 72.15375397300005],
              [129.28248131600003, 72.15143463700008],
              [129.260101759, 72.14667389500005],
              [129.24195397200003, 72.13446686400005],
              [129.25896243600005, 72.13361237200007],
              [129.29184004, 72.12734609600005],
              [129.30876712300005, 72.12946198100008],
              [129.35425866000003, 72.14028554900005],
              [129.45875084700003, 72.14158763200004],
              [129.48902428500003, 72.13446686400005],
              [129.48902428500003, 72.12763092700004],
              [129.45850670700008, 72.12641022300005],
              [129.33326256600003, 72.09105052300004],
              [129.219574415, 72.08608633000006],
              [129.20134524800005, 72.08808014500005],
              [129.14576256600003, 72.10032786700003],
              [129.12769616000003, 72.10053131700005],
              [129.11491946700005, 72.09788646000004],
              [129.084320509, 72.08608633000006],
              [129.04802493600005, 72.07684967700004],
              [128.9340926440001, 72.07298411700003],
              [128.892914259, 72.08462148600006],
              [128.81625410200002, 72.13589101800005],
              [128.77491295700008, 72.14813873900005],
              [128.74048912900003, 72.15155670800004],
              [128.49431399800005, 72.20278554900005],
              [128.4941512380001, 72.22016022300005],
              [128.51710045700008, 72.23053620000007],
              [128.56950931100005, 72.24371979400007],
              [128.52881920700008, 72.25934479400007],
              [128.149750196, 72.31663646000004],
              [127.85889733200008, 72.42914459800005],
              [127.79070071700005, 72.43842194200005],
              [127.66578209700003, 72.43008047100005],
              [127.71509850400003, 72.41054922100005],
              [127.73617597700002, 72.39716217700004],
              [127.76905358200008, 72.38646067900004],
              [127.83887780000009, 72.34247467700004],
              [127.86443118600005, 72.33246491100005],
              [127.84506269600001, 72.32225169500003],
              [127.81169681100005, 72.32099030200004],
              [127.74708092500009, 72.32562897300005],
              [127.78012129000001, 72.30630117400005],
              [127.91211998800009, 72.29148997600004],
              [128.031586134, 72.26414622600004],
              [128.06397545700008, 72.25275299700007],
              [128.10271243600005, 72.23379140800006],
              [128.13266035200002, 72.22858307500007],
              [128.19214928500003, 72.22833893400008],
              [128.249359571, 72.20482005400004],
              [128.28630618600005, 72.17617422100005],
              [128.30982506600003, 72.15143463700008],
              [128.31959069100003, 72.14813873900005],
              [128.33570397200003, 72.14496491100005],
              [128.38445071700005, 72.12079498900005],
              [128.44166100400003, 72.10028717700004],
              [128.45337975400003, 72.09292226800005],
              [128.45582116000003, 72.07550690300008],
              [128.4482528000001, 72.05866120000007],
              [128.44320722700002, 72.04173411700003],
              [128.45337975400003, 72.02399323100008],
              [128.462250196, 72.02244700700004],
              [128.47608483200008, 72.02293528900003],
              [128.4887801440001, 72.02147044500003],
              [128.49431399800005, 72.01434967700004],
              [128.50114993600005, 71.99730052300004],
              [128.50993899800005, 71.98965078300006],
              [128.51832116000003, 71.98403554900005],
              [128.52808678500003, 71.97980377800008],
              [128.5415145190001, 71.97626373900005],
              [128.60425866000003, 71.96938711100006],
              [128.6235457690001, 71.96259186400005],
              [128.6308699880001, 71.95636627800008],
              [128.64210045700008, 71.94159577000005],
              [128.6513778000001, 71.93585846600007],
              [128.65308678500003, 71.92064036700003],
              [128.66325931100005, 71.90721263200004],
              [128.66976972700002, 71.89350006700005],
              [128.66163170700008, 71.87750885600008],
              [128.66391035200002, 71.86298248900005],
              [128.69206790500004, 71.85114166900007],
              [128.74756920700008, 71.83966705900008],
              [128.7837020190001, 71.82705312700006],
              [128.85621178500003, 71.77480703300006],
              [128.926605665, 71.73875560100004],
              [128.94027754, 71.73725006700005],
              [128.95337975400003, 71.73981354400007],
              [128.9887801440001, 71.75775788000004],
              [129.13949629, 71.78392161700003],
              [129.183929884, 71.80927155200004],
              [129.18930097700002, 71.83274974200003],
              [129.1684676440001, 71.85626862200007],
              [129.11841881600003, 71.88808828300006],
              [129.09693444100003, 71.90790436400005],
              [129.0869246750001, 71.92658112200007],
              [129.07992597700002, 71.94554271000004],
              [129.067230665, 71.96662018400008],
              [129.03012129, 71.99481842700004],
              [129.022797071, 72.00409577000005],
              [129.025726759, 72.01797109600005],
              [129.04118899800005, 72.01878489800004],
              [129.06128991000003, 72.01235586100006],
              [129.0781356130001, 72.00409577000005],
              [129.180511915, 71.93244049700007],
              [129.28687584700003, 71.88349030200004],
              [129.30347741000003, 71.86420319200005],
              [129.30144290500004, 71.85276927300004],
              [129.2973738940001, 71.84235260600008],
              [129.29476972700002, 71.83185455900008],
              [129.29664147200003, 71.81976959800005],
              [129.309906446, 71.80418528900003],
              [129.3300887380001, 71.79706452000005],
              [129.37077884200005, 71.78994375200006],
              [129.54371178500003, 71.72296784100007],
              [129.51823978000004, 71.71747467700004],
              [129.4863387380001, 71.71942780200004],
              [129.30543053500003, 71.76089101800005],
              [129.28825931100005, 71.75869375200006],
              [129.24822024800005, 71.74347565300008],
              [129.1748153000001, 71.73346588700008],
              [129.09498131600003, 71.71214427300004],
              [128.9672957690001, 71.71645742400005],
              [128.90772545700008, 71.70815664300005],
              [128.864593946, 71.69448476800005],
              [128.83033287900003, 71.67914459800005],
              [128.82048587300005, 71.65810781500005],
              [128.84205162900003, 71.62197500200006],
              [128.87525475400003, 71.59674713700008],
              [128.92790774800005, 71.59100983300004],
              [129.11695397200003, 71.61505768400008],
              [129.14576256600003, 71.61310455900008],
              [129.16358483200008, 71.60602448100008],
              [129.18702233200008, 71.58539459800005],
              [129.20069420700008, 71.57587311400005],
              [129.23308353000004, 71.56024811400005],
              [129.24870853000004, 71.54987213700008],
              [129.25562584700003, 71.53864166900007],
              [129.25212649800005, 71.52582428600005],
              [129.236664259, 71.50861237200007],
              [129.235687696, 71.49701569200005],
              [129.24789472700002, 71.48627350500004],
              [129.29566491000003, 71.47459544500003],
              [129.31430097700002, 71.46600983300004],
              [129.32211347700002, 71.45628489800004],
              [129.3339949880001, 71.43455638200004],
              [129.35613040500004, 71.40599192900004],
              [129.37842858200008, 71.36481354400007],
              [129.39210045700008, 71.34682851800005],
              [129.42335045700008, 71.32453034100007],
              [129.46314537900003, 71.30703359600005],
              [129.50538170700008, 71.29385000200006],
              [129.62680097700002, 71.27008698100008],
              [129.65259850400003, 71.26089101800005],
              [129.66521243600005, 71.25299713700008],
              [129.6879988940001, 71.23407623900005],
              [129.70069420700008, 71.22638580900008],
              [129.711761915, 71.21723053600005],
              [129.7133895190001, 71.20685455900008],
              [129.71306399800005, 71.19603099200003],
              [129.71802819100003, 71.18545156500005],
              [129.719574415, 71.18048737200007],
              [129.718109571, 71.17568594000005],
              [129.71859785200002, 71.17096588700008],
              [129.72632897200003, 71.16616445500006],
              [129.7451278000001, 71.15790436400005],
              [129.7627059250001, 71.14760976800005],
              [129.7368270190001, 71.12645091400003],
              [129.70777428500003, 71.10968659100007],
              [129.68726647200003, 71.10309479400007],
              [129.64527428500003, 71.09662506700005],
              [129.62623131600003, 71.08612702000005],
              [129.8657332690001, 71.11041901300007],
              [129.940765821, 71.09296295800004],
              [129.931976759, 71.09052155200004],
              [129.9257918630001, 71.08478424700007],
              [129.92212975400003, 71.07632070500006],
              [129.9204207690001, 71.06565989800004],
              [129.95476321700005, 71.06867096600007],
              [130.016937696, 71.08246491100005],
              [130.05062910200002, 71.08612702000005],
              [130.067718946, 71.08576080900008],
              [130.080414259, 71.08344147300005],
              [130.10531660200002, 71.07245514500005],
              [130.13111412900003, 71.05752187700006],
              [130.14429772200003, 71.05263906500005],
              [130.160492384, 71.05198802300004],
              [130.1523543630001, 71.03188711100006],
              [130.16236412900003, 71.02216217700004],
              [130.201508009, 71.01105377800008],
              [130.2216903000001, 70.99363841400003],
              [130.2158309250001, 70.97943756700005],
              [130.19410241000003, 70.97052643400008],
              [130.167328321, 70.96881745000007],
              [130.30062910200002, 70.94013092700004],
              [130.4677840500001, 70.92670319200005],
              [130.47771243600005, 70.92267487200007],
              [130.48894290500004, 70.91425202000005],
              [130.49293053500003, 70.90745677300004],
              [130.49439537900003, 70.89166901200008],
              [130.49634850400003, 70.88690827000005],
              [130.51921634200005, 70.87897370000007],
              [130.61988366000003, 70.86640045800004],
              [130.6469832690001, 70.86835358300004],
              [130.67505944100003, 70.87506745000007],
              [130.69947350400003, 70.88788483300004],
              [130.71550540500004, 70.90802643400008],
              [130.71607506600003, 70.91864655200004],
              [130.71501712300005, 70.93427155200004],
              [130.715668165, 70.95042552300004],
              [130.72234134200005, 70.96259186400005],
              [130.7441512380001, 70.97402578300006],
              [130.768890821, 70.97752513200004],
              [130.7890731130001, 70.97113678600005],
              [130.7973738940001, 70.95270416900007],
              [130.8027449880001, 70.94358958500004],
              [130.8144637380001, 70.93463776200008],
              [130.8261824880001, 70.92267487200007],
              [130.83155358200008, 70.90460846600007],
              [130.84262129, 70.88031647300005],
              [130.89079837300005, 70.84528229400007],
              [130.89991295700008, 70.81801992400005],
              [130.895843946, 70.80556875200006],
              [130.88233483200008, 70.78607819200005],
              [130.8794051440001, 70.77391185100004],
              [130.88843834700003, 70.76276276200008],
              [130.9091903000001, 70.75604889500005],
              [131.0420028000001, 70.73875560100004],
              [131.13453209700003, 70.73810455900008],
              [131.22632897200003, 70.75023021000004],
              [131.39429772200003, 70.80731842700004],
              [131.54615319100003, 70.88711172100005],
              [131.60962975400003, 70.93870677300004],
              [131.72437584700003, 71.06525299700007],
              [131.77076256600003, 71.09979889500005],
              [131.75538170700008, 71.12124258000006],
              [131.76140384200005, 71.13519928600005],
              [131.7822371750001, 71.14345937700006],
              [131.81226647200003, 71.14760976800005],
              [131.84888756600003, 71.14581940300008],
              [131.86589603000004, 71.14887116100005],
              [131.8730574880001, 71.16058991100005],
              [131.86784915500004, 71.17255280200004],
              [131.8554793630001, 71.17951080900008],
              [131.840179884, 71.18235911700003],
              [131.826508009, 71.18231842700004],
              [131.850922071, 71.20819733300004],
              [131.89828535200002, 71.22235748900005],
              [131.98951256600003, 71.22947825700004],
              [132.188324415, 71.21588776200008],
              [132.1723738940001, 71.22557200700004],
              [132.15593509200005, 71.23102448100008],
              [131.96607506600003, 71.25458405200004],
              [131.9419051440001, 71.26740143400008],
              [131.9492293630001, 71.29295482000003],
              [131.96697024800005, 71.31439850500004],
              [132.03077233200008, 71.37592194200005],
              [132.039886915, 71.38890208500004],
              [132.0410262380001, 71.39769114800004],
              [132.0400496750001, 71.40546295800004],
              [132.04363040500004, 71.41779205900008],
              [132.049164259, 71.43024323100008],
              [132.06950931100005, 71.45848216400003],
              [132.09164472700002, 71.49811432500007],
              [132.1064559250001, 71.51752350500004],
              [132.19890384200005, 71.60346100500004],
              [132.2451278000001, 71.66278717700004],
              [132.2641707690001, 71.68203359600005],
              [132.53931725400003, 71.88361237200007],
              [132.631195509, 71.92617422100005],
              [132.7177840500001, 71.94623444200005],
              [132.81047479300003, 71.95226453400005],
              [132.91386449900006, 71.94757041200006],
              [132.99393321800005, 71.96603905300003],
              [133.06627440400007, 71.97129071500007],
              [133.17918312200004, 71.95812321200003],
              [133.25759466700003, 71.92124568300005],
              [133.341360795, 71.88626482800004],
              [133.35400272700008, 71.83395965500006],
              [133.30271856600007, 71.88039217600004],
              [133.22835235600007, 71.90887499400003],
              [133.1564147480001, 71.94017086900004],
              [133.1038905580001, 71.95567240800005],
              [133.031344913, 71.95509862600005],
              [132.9392477140001, 71.93468056400008],
              [132.9323221300001, 71.91121248200005],
              [132.86814249200006, 71.91907314100007],
              [132.79639493700006, 71.91092230600003],
              [132.77428358200007, 71.89010778000005],
              [132.77530487900003, 71.87981472900003],
              [132.7828961030001, 71.86396458700005],
              [132.80576593600006, 71.84544933900008],
              [132.8131284110001, 71.83146995300007],
              [132.7461043630001, 71.82648346600007],
              [132.7290145190001, 71.81952545800004],
              [132.71509850400003, 71.81069570500006],
              [132.70915774800005, 71.79531484600005],
              [132.7148543630001, 71.77680084800005],
              [132.72966556100005, 71.76923248900005],
              [132.90406334700003, 71.73346588700008],
              [132.98521604400003, 71.71971724200006],
              [133.014724505, 71.68620759900006],
              [133.06910241000003, 71.64789459800005],
              [133.07992597700002, 71.64256419500003],
              [133.08765709700003, 71.63035716400003],
              [133.09392337300005, 71.61664459800005],
              [133.1001082690001, 71.60687897300005],
              [133.11353600400003, 71.59784577000005],
              [133.15162194100003, 71.57916901200008],
              [133.426117384, 71.48997630400004],
              [133.65007571700005, 71.43650950700004],
              [133.805511915, 71.42332591400003],
              [133.9087020190001, 71.39940013200004],
              [134.16765384200005, 71.37079498900005],
              [134.489105665, 71.37685781500005],
              [134.55982506600003, 71.40192291900007],
              [134.585297071, 71.40582916900007],
              [134.6093856130001, 71.40306224200003],
              [134.73902428500003, 71.36798737200007],
              [134.74488366000003, 71.36123281500005],
              [134.73755944100003, 71.34682851800005],
              [134.70679772200003, 71.32737864800004],
              [134.67066491000003, 71.31464264500005],
              [134.65064537900003, 71.29730866100005],
              [134.66863040500004, 71.26430898600006],
              [134.67505944100003, 71.28595612200007],
              [134.69556725400003, 71.30866120000007],
              [134.72152754, 71.32884349200003],
              [134.74439537900003, 71.34308502800008],
              [134.7700301440001, 71.36692942900004],
              [134.7524520190001, 71.38226959800005],
              [134.7187606130001, 71.39752838700008],
              [134.69654381600003, 71.42133209800005],
              [134.7587996750001, 71.42332591400003],
              [134.77849368600005, 71.42877838700008],
              [134.7797957690001, 71.46076080900008],
              [134.81023196700005, 71.48183828300006],
              [134.85320071700005, 71.49347565300008],
              [134.89210045700008, 71.49701569200005],
              [134.93531334700003, 71.50629303600005],
              [135.03296959700003, 71.53912995000007],
              [135.073578321, 71.53489817900004],
              [135.10434004, 71.51626211100006],
              [135.11866295700008, 71.51577383000006],
              [135.14234459700003, 71.52496979400007],
              [135.17115319100003, 71.54319896000004],
              [135.1860457690001, 71.54975006700005],
              [135.207367384, 71.55223216400003],
              [135.23658287900003, 71.54987213700008],
              [135.319672071, 71.53119538000004],
              [135.42335045700008, 71.53119538000004],
              [135.41138756600003, 71.54800039300005],
              [135.38843834700003, 71.55585358300004],
              [135.3408309250001, 71.56590403900003],
              [135.377289259, 71.58258698100008],
              [135.4218856130001, 71.59296295800004],
              [135.54615319100003, 71.60431549700007],
              [135.6215926440001, 71.62311432500007],
              [135.98511803500003, 71.63483307500007],
              [136.30347741000003, 71.58299388200004],
              [136.4438582690001, 71.57587311400005],
              [136.51636803500003, 71.55849844000005],
              [136.5195418630001, 71.51752350500004],
              [136.5127059250001, 71.51752350500004],
              [136.54118899800005, 71.51483795800004],
              [136.5556746750001, 71.50922272300005],
              [136.55730228000004, 71.49762604400007],
              [136.5468856130001, 71.47654857000003],
              [136.57146243600005, 71.47736237200007],
              [136.587250196, 71.48777903900003],
              [136.59986412900003, 71.50193919500003],
              [136.61508222700002, 71.51410553600005],
              [136.637054884, 71.52289459800005],
              [136.6621199880001, 71.52875397300005],
              [136.68921959700003, 71.53164297100005],
              [136.71827233200008, 71.53119538000004],
              [136.77458743600005, 71.52342357000003],
              [136.8012801440001, 71.51561107000003],
              [136.8281356130001, 71.50385163000004],
              [136.88941491000003, 71.46222565300008],
              [136.91920006600003, 71.45416901200008],
              [136.981781446, 71.44843170800004],
              [137.0127059250001, 71.43903229400007],
              [137.04029381600003, 71.42731354400007],
              [137.06609134200005, 71.41998932500007],
              [137.2109481130001, 71.40737539300005],
              [137.267914259, 71.39252350500004],
              [137.27466881600003, 71.38523997600004],
              [137.26343834700003, 71.37750885600008],
              [137.23894290500004, 71.36733633000006],
              [137.2841903000001, 71.35956452000005],
              [137.35564212300005, 71.37417226800005],
              [137.38892662900003, 71.35809967700004],
              [137.40349368600005, 71.35366445500006],
              [137.44703209700003, 71.34760163000004],
              [137.4921981130001, 71.34682851800005],
              [137.48511803500003, 71.33722565300008],
              [137.4751082690001, 71.33148834800005],
              [137.45142662900003, 71.32233307500007],
              [137.44499759200005, 71.31293366100005],
              [137.4550887380001, 71.30483633000006],
              [137.47185306100005, 71.29938385600008],
              [137.4853621750001, 71.29840729400007],
              [137.46558678500003, 71.28803131700005],
              [137.42457116000003, 71.29144928600005],
              [137.40349368600005, 71.28473541900007],
              [137.43336022200003, 71.27464427300004],
              [137.52686608200008, 71.25747304900005],
              [137.53248131600003, 71.24567291900007],
              [137.55982506600003, 71.24119700700004],
              [137.59294681100005, 71.24233633000006],
              [137.6157332690001, 71.24725983300004],
              [137.70492597700002, 71.28473541900007],
              [137.69996178500003, 71.27387116100005],
              [137.69206790500004, 71.26459381700005],
              [137.6821395190001, 71.25682200700004],
              [137.6709090500001, 71.25063711100006],
              [137.68677819100003, 71.24428945500006],
              [137.703461134, 71.24555084800005],
              [137.7212020190001, 71.24941640800006],
              [137.7392684250001, 71.25063711100006],
              [137.72022545700008, 71.23143138200004],
              [137.6923934250001, 71.22093333500004],
              [137.661468946, 71.21674225500004],
              [137.6328231130001, 71.21588776200008],
              [137.61491946700005, 71.21820709800005],
              [137.57878665500004, 71.22797272300005],
              [137.5610457690001, 71.22947825700004],
              [137.5351668630001, 71.22532786700003],
              [137.52613366000003, 71.22028229400007],
              [137.5337020190001, 71.21279531500005],
              [137.56397545700008, 71.20400625200006],
              [137.62566165500004, 71.19961172100005],
              [137.74105879, 71.17064036700003],
              [137.766449415, 71.16803620000007],
              [137.76433353000004, 71.14223867400005],
              [137.78345787900003, 71.12661367400005],
              [137.8129988940001, 71.11961497600004],
              [137.8422957690001, 71.11969635600008],
              [137.8593856130001, 71.12303294500003],
              [137.8671981130001, 71.12775299700007],
              [137.874359571, 71.13458893400008],
              [137.889984571, 71.14419179900005],
              [137.909515821, 71.14911530200004],
              [137.93091881600003, 71.14801666900007],
              [137.9726668630001, 71.14077383000006],
              [137.96550540500004, 71.13812897300005],
              [137.944672071, 71.12710195500006],
              [137.977386915, 71.11896393400008],
              [138.00733483200008, 71.12323639500005],
              [138.03825931100005, 71.13104889500005],
              [138.07439212300005, 71.13397858300004],
              [138.06470787900003, 71.15045807500007],
              [138.04672285200002, 71.16278717700004],
              [138.02564537900003, 71.17096588700008],
              [138.00668379, 71.17487213700008],
              [138.01978600400003, 71.18231842700004],
              [137.9941512380001, 71.19061920800004],
              [137.96631920700008, 71.19432200700004],
              [137.91041100400003, 71.19537995000007],
              [137.9179793630001, 71.20282623900005],
              [137.89958743600005, 71.20066966400003],
              [137.8422957690001, 71.18231842700004],
              [137.85523522200003, 71.19635651200008],
              [137.84750410200002, 71.20473867400005],
              [137.82960045700008, 71.20868561400005],
              [137.79175866000003, 71.21088288000004],
              [137.7739363940001, 71.21458567900004],
              [137.75668379, 71.22085195500006],
              [137.7392684250001, 71.22947825700004],
              [137.77295983200008, 71.23574453300006],
              [137.8017684250001, 71.24664948100008],
              [137.831390821, 71.25389232000003],
              [137.96949303500003, 71.22528717700004],
              [138.067230665, 71.22492096600007],
              [138.08806399800005, 71.22947825700004],
              [138.0918074880001, 71.23456452000005],
              [138.0957137380001, 71.24282461100006],
              [138.10377037900003, 71.24876536700003],
              [138.15105228000004, 71.24188873900005],
              [138.1840926440001, 71.24542877800008],
              [138.21501712300005, 71.25763580900008],
              [138.23951256600003, 71.27789948100008],
              [138.21216881600003, 71.28644440300008],
              [137.99244225400003, 71.29218170800004],
              [137.9961043630001, 71.30219147300005],
              [138.15007571700005, 71.33270905200004],
              [138.16944420700008, 71.33124420800004],
              [138.21045983200008, 71.32078685100004],
              [138.26685631600003, 71.31297435100004],
              [138.32292728000004, 71.31122467700004],
              [138.36296634200005, 71.31891510600008],
              [138.36296634200005, 71.32575104400007],
              [138.34717858200008, 71.32672760600008],
              [138.31959069100003, 71.33685944200005],
              [138.3046981130001, 71.33934153900003],
              [138.00953209700003, 71.33934153900003],
              [137.9882918630001, 71.34369538000004],
              [137.9516707690001, 71.36025625200006],
              [137.93091881600003, 71.36050039300005],
              [137.93702233200008, 71.36692942900004],
              [137.9453231130001, 71.37221914300005],
              [137.9658309250001, 71.38031647300005],
              [137.94483483200008, 71.38523997600004],
              [137.92562910200002, 71.37995026200008],
              [137.90691165500004, 71.37164948100008],
              [137.88656660200002, 71.36733633000006],
              [137.87183678500003, 71.37055084800005],
              [137.84498131600003, 71.38458893400008],
              [137.8286238940001, 71.38715241100005],
              [137.8286238940001, 71.39398834800005],
              [137.86996504, 71.39720286700003],
              [137.90512129, 71.41176992400005],
              [137.9658309250001, 71.44863515800006],
              [138.014984571, 71.47361888200004],
              [138.02654056100005, 71.48403554900005],
              [138.02955162900003, 71.49335358300004],
              [138.029633009, 71.51459381700005],
              [138.03394616000003, 71.52496979400007],
              [138.03858483200008, 71.55874258000006],
              [138.0986434250001, 71.58144765800006],
              [138.21900475400003, 71.60004303600005],
              [138.50025475400003, 71.61310455900008],
              [138.44792728000004, 71.60293203300006],
              [138.42139733200008, 71.59422435100004],
              [138.40398196700005, 71.57953522300005],
              [138.40186608200008, 71.56708405200004],
              [138.41089928500003, 71.55906810100004],
              [138.43816165500004, 71.53864166900007],
              [138.5771590500001, 71.55194733300004],
              [138.5888778000001, 71.56590403900003],
              [138.59498131600003, 71.58319733300004],
              [138.58814537900003, 71.59406159100007],
              [138.57309004, 71.60106028900003],
              [138.55486087300005, 71.60687897300005],
              [138.67701256600003, 71.64386627800008],
              [138.715179884, 71.64789459800005],
              [138.75603274800005, 71.64301178600005],
              [138.8769637380001, 71.60004303600005],
              [138.91814212300005, 71.59227122600004],
              [139.00896243600005, 71.58527252800008],
              [139.04509524800005, 71.56903717700004],
              [139.05787194100003, 71.55182526200008],
              [139.07740319100003, 71.51170482000003],
              [139.0966903000001, 71.49701569200005],
              [139.089203321, 71.49017975500004],
              [139.10531660200002, 71.47736237200007],
              [139.14136803500003, 71.45945872600004],
              [139.15805097700002, 71.44863515800006],
              [139.11646569100003, 71.42877838700008],
              [139.1357528000001, 71.42804596600007],
              [139.192230665, 71.41510651200008],
              [139.30290774800005, 71.41567617400005],
              [139.34636478000004, 71.42182038000004],
              [139.36296634200005, 71.42877838700008],
              [139.36882571700005, 71.43553294500003],
              [139.37378991000003, 71.45156484600005],
              [139.3798934250001, 71.45917389500005],
              [139.4218856130001, 71.48875560100004],
              [139.4433699880001, 71.49510325700004],
              [139.58765709700003, 71.49510325700004],
              [139.62224368600005, 71.48859284100007],
              [139.68433678500003, 71.46430084800005],
              [139.7177840500001, 71.45734284100007],
              [139.76335696700005, 71.47431061400005],
              [139.836273634, 71.49225495000007],
              [139.85670006600003, 71.49359772300005],
              [139.8877059250001, 71.48558177300004],
              [139.954437696, 71.48525625200006],
              [139.98845462300005, 71.47846100500004],
              [140.00017337300005, 71.47467682500007],
              [140.01832116000003, 71.47085195500006],
              [140.0332137380001, 71.47211334800005],
              [140.0351668630001, 71.48403554900005],
              [140.02556399800005, 71.49188873900005],
              [139.979828321, 71.50385163000004],
              [139.98560631600003, 71.50861237200007],
              [139.99537194100003, 71.52016836100006],
              [140.0009871750001, 71.52496979400007],
              [139.83619225400003, 71.58954498900005],
              [139.81568444100003, 71.60350169500003],
              [139.7617293630001, 71.65204498900005],
              [139.740570509, 71.66494375200006],
              [139.73454837300005, 71.67218659100007],
              [139.7343856130001, 71.69131094000005],
              [139.718109571, 71.71873607000003],
              [139.71265709700003, 71.75604889500005],
              [139.69939212300005, 71.76459381700005],
              [139.7080184250001, 71.76992422100005],
              [139.7080184250001, 71.77700429900005],
              [139.70183353000004, 71.78461334800005],
              [139.6919051440001, 71.79181549700007],
              [139.70337975400003, 71.80166250200006],
              [139.7290145190001, 71.81793854400007],
              [139.73414147200003, 71.82941315300008],
              [139.74341881600003, 71.84487539300005],
              [139.76539147200003, 71.85492584800005],
              [139.79053795700008, 71.86005280200004],
              [139.80925540500004, 71.86078522300005],
              [139.7802840500001, 71.87002187700006],
              [139.710297071, 71.87091705900008],
              [139.6816512380001, 71.88467031500005],
              [139.66472415500004, 71.89984772300005],
              [139.6489363940001, 71.90973541900007],
              [139.606781446, 71.92560455900008],
              [139.57390384200005, 71.93292877800008],
              [139.33619225400003, 71.94269440300008],
              [139.33619225400003, 71.94953034100007],
              [139.42847741000003, 71.96320221600007],
              [139.58318118600005, 71.94896067900004],
              [139.63453209700003, 71.95453522300005],
              [139.6821395190001, 71.96967194200005],
              [139.712250196, 71.99795156500005],
              [139.7129012380001, 72.01748281500005],
              [139.70484459700003, 72.03766510600008],
              [139.701508009, 72.05931224200003],
              [139.715668165, 72.08295319200005],
              [139.83155358200008, 72.13764069200005],
              [139.8496199880001, 72.15867747600004],
              [139.87419681100005, 72.17816803600005],
              [139.9301863940001, 72.17381419500003],
              [140.02759850400003, 72.14874909100007],
              [140.0673934250001, 72.14785390800006],
              [140.13209069100003, 72.15387604400007],
              [140.19288170700008, 72.16673411700003],
              [140.21949303500003, 72.18634674700007],
              [140.19711347700002, 72.21381256700005],
              [140.1455184250001, 72.22492096600007],
              [139.85311933650007, 72.22846100500007],
              [139.56072024800005, 72.23200104400007],
              [139.5180770190001, 72.21922435100004],
              [139.43238366000003, 72.18284739800004],
              [139.45964603000004, 72.17243073100008],
              [139.55591881600003, 72.17544179900005],
              [139.53296959700003, 72.16429271000004],
              [139.38697350400003, 72.16217682500007],
              [139.32878665500004, 72.16864655200004],
              [139.27719160200002, 72.18016185100004],
              [139.25668379, 72.17902252800008],
              [139.26050866000003, 72.16242096600007],
              [139.28044681100005, 72.15253327000005],
              [139.33375084700003, 72.14789459800005],
              [139.34986412900003, 72.13446686400005],
              [139.29517662900003, 72.13690827000005],
              [139.2421981130001, 72.14569733300004],
              [139.19157962300005, 72.16266510600008],
              [139.13062584700003, 72.19916413000004],
              [139.09636478000004, 72.22654857000003],
              [139.089203321, 72.23688385600008],
              [139.09400475400003, 72.24823639500005],
              [139.11736087300005, 72.26561107000003],
              [139.12273196700005, 72.27472565300008],
              [139.1357528000001, 72.30410390800006],
              [139.16675866000003, 72.32778554900005],
              [139.23259524800005, 72.36041901200008],
              [139.28679446700005, 72.39704010600008],
              [139.3051863940001, 72.40200429900005],
              [139.31218509200005, 72.40477122600004],
              [139.3227645190001, 72.41803620000007],
              [139.32878665500004, 72.42251211100006],
              [139.34205162900003, 72.42495351800005],
              [139.3701278000001, 72.42609284100007],
              [139.38404381600003, 72.42869700700004],
              [139.498383009, 72.48725006700005],
              [139.54175866000003, 72.49762604400007],
              [139.8447371750001, 72.50299713700008],
              [140.0727645190001, 72.47923411700003],
              [140.3447371750001, 72.48969147300005],
              [140.576508009, 72.49632396000004],
              [140.79468834700003, 72.53164297100005],
              [140.87777754, 72.53774648600006],
              [140.904633009, 72.55560944200005],
              [140.9340926440001, 72.56777578300006],
              [141.07007897200003, 72.57807038000004],
              [141.11085045700008, 72.58698151200008],
              [140.9965926440001, 72.58738841400003],
              [140.95240319100003, 72.59357330900008],
              [140.9326278000001, 72.60065338700008],
              [140.94988040500004, 72.60700104400007],
              [140.96461022200003, 72.61566803600005],
              [140.98796634200005, 72.63471100500004],
              [140.9804793630001, 72.64223867400005],
              [141.01099694100003, 72.66840241100005],
              [141.01295006600003, 72.69082265800006],
              [140.991547071, 72.70941803600005],
              [140.95240319100003, 72.72410716400003],
              [140.9072371750001, 72.72931549700007],
              [140.88591556100005, 72.73444245000007],
              [140.84937584700003, 72.76048411700003],
              [140.66423587300005, 72.80902741100005],
              [140.65894616000003, 72.81232330900008],
              [140.65796959700003, 72.81639232000003],
              [140.65992272200003, 72.82965729400007],
              [140.65894616000003, 72.83397044500003],
              [140.64234459700003, 72.84247467700004],
              [140.59595787900003, 72.85858795800004],
              [140.58318118600005, 72.86749909100007],
              [140.58130944100003, 72.88467031500005],
              [140.5942488940001, 72.89288971600007],
              [140.72584069100003, 72.89862702000005],
              [140.78052819100003, 72.88939036700003],
              [140.8359481130001, 72.89118073100008],
              [140.89047285200002, 72.88056061400005],
              [141.00928795700008, 72.87905508000006],
              [141.06568444100003, 72.86969635600008],
              [141.27271569100003, 72.86635976800005],
              [141.38990319100003, 72.84332916900007],
              [141.41179446700005, 72.83397044500003],
              [141.4619246750001, 72.80581289300005],
              [141.55062910200002, 72.77431875200006],
              [141.65593509200005, 72.76609935100004],
              [141.73170006600003, 72.74762604400007],
              [141.98170006600003, 72.72459544500006],
              [142.23170006600003, 72.70156484600005],
              [142.54281660200002, 72.71784088700008],
              [142.7080184250001, 72.71185944200005],
              [143.03638756600003, 72.69985586100006],
              [143.090668165, 72.68939850500004],
              [143.4868270190001, 72.70010000200006],
              [143.60279381600003, 72.68870677300004],
              [143.70720462300005, 72.66665273600006],
              [144.0722762380001, 72.64862702000005],
              [144.30388431100005, 72.64199453300006],
              [144.56861412900003, 72.60887278900003],
              [144.840179884, 72.59564850500004],
              [145.1248478525, 72.57577138900004],
              [145.409515821, 72.55589427300004],
              [145.71412194100003, 72.49632396000004],
              [145.95923912900003, 72.47190989800004],
              [146.12468509200005, 72.46987539300005],
              [146.270355665, 72.44086334800005],
              [146.410492384, 72.42694733300004],
              [146.483734571, 72.40167877800008],
              [146.80201256600003, 72.35447825700004],
              [146.8540145190001, 72.35419342700004],
              [146.844086134, 72.34662506700005],
              [146.832855665, 72.34052155200004],
              [146.8403426440001, 72.34674713700008],
              [146.7920028000001, 72.33071523600006],
              [146.45032799550006, 72.34166087400007],
              [146.10865319100003, 72.35260651200008],
              [146.06023196700005, 72.34381745000007],
              [145.68767337300005, 72.36395905200004],
              [145.47022545700008, 72.36005280200004],
              [145.37175540500004, 72.34593333500004],
              [145.352875196, 72.34674713700008],
              [145.3320418630001, 72.35419342700004],
              [145.31763756600003, 72.36367422100005],
              [145.29118899800005, 72.38641998900005],
              [145.27686608200008, 72.39516836100006],
              [145.25310306100005, 72.40106842700004],
              [145.204437696, 72.40208567900004],
              [145.18132571700005, 72.40818919500003],
              [145.18873131600003, 72.41567617400005],
              [145.170258009, 72.42059967700004],
              [145.147797071, 72.41986725500004],
              [145.1259871750001, 72.41437409100007],
              [145.10954837300005, 72.40509674700007],
              [145.0922957690001, 72.40021393400008],
              [145.07243899800005, 72.40717194200005],
              [145.0356551440001, 72.42706940300008],
              [144.99089603000004, 72.43622467700004],
              [144.94320722700002, 72.43817780200004],
              [144.8955184250001, 72.43402741100005],
              [144.850922071, 72.42413971600007],
              [144.70826256600003, 72.37409088700008],
              [144.68043053500003, 72.35748932500007],
              [144.66684004, 72.34666575700004],
              [144.6611434250001, 72.33685944200005],
              [144.62623131600003, 72.31659577000005],
              [144.5478621750001, 72.25739166900007],
              [144.5376082690001, 72.24062734600005],
              [144.52076256600003, 72.22500234600005],
              [144.482758009, 72.23663971600007],
              [144.4209090500001, 72.27167389500005],
              [144.38550866000003, 72.28534577000005],
              [144.34245853000004, 72.29376862200007],
              [144.299164259, 72.29629140800006],
              [144.26319420700008, 72.29214101800005],
              [144.2431746750001, 72.28388092700004],
              [144.22527103000004, 72.27399323100008],
              [144.20679772200003, 72.26748281500005],
              [144.1855574880001, 72.26972077000005],
              [144.16724694100003, 72.27387116100005],
              [144.1054793630001, 72.27789948100008],
              [144.17212975400003, 72.24787018400008],
              [144.1943465500001, 72.24433014500005],
              [144.1938582690001, 72.22801341400003],
              [144.21070397200003, 72.22174713700008],
              [144.234711134, 72.21906159100007],
              [144.25652103000004, 72.21332428600005],
              [144.2802840500001, 72.20392487200007],
              [144.41553795700008, 72.17503489800004],
              [144.4775496750001, 72.17035553600005],
              [144.59913170700008, 72.17544179900005],
              [144.62256920700008, 72.18056875200006],
              [144.67457116000003, 72.21332428600005],
              [144.69841556100005, 72.22272370000007],
              [144.75163821700005, 72.23309967700004],
              [144.950531446, 72.24225495000007],
              [145.068695509, 72.26434967700004],
              [145.39600670700008, 72.27285390800006],
              [145.70399010550005, 72.28196849150007],
              [146.01197350400003, 72.29108307500007],
              [146.26384524800005, 72.29535553600005],
              [146.59652754000007, 72.30400218300005],
              [146.92920983200008, 72.31264883000006],
              [146.89283287900003, 72.27147044500003],
              [146.775726759, 72.22846100500004],
              [146.72681725400003, 72.19965241100005],
              [146.67758222700002, 72.16274648600006],
              [146.49537194100003, 72.06598541900007],
              [146.24382571700005, 71.98655833500004],
              [145.97250410200002, 71.85626862200007],
              [145.939789259, 71.85724518400008],
              [145.94166100400003, 71.88808828300006],
              [145.95240319100003, 71.90094635600008],
              [145.98072350400003, 71.91665273600006],
              [145.99341881600003, 71.92560455900008],
              [145.9990340500001, 71.93870677300004],
              [145.9941512380001, 71.95026276200008],
              [145.98707116000003, 71.95966217700004],
              [145.98658287900003, 71.96662018400008],
              [145.996429884, 71.97679271000004],
              [146.00114993600005, 71.98371002800008],
              [146.0029403000001, 71.99152252800008],
              [146.00367272200003, 72.00409577000005],
              [145.99984785200002, 72.01764557500007],
              [145.993011915, 72.02435944200005],
              [145.993011915, 72.02973053600005],
              [146.0097762380001, 72.03888580900008],
              [146.03272545700008, 72.04352448100008],
              [146.08179772200003, 72.03782786700003],
              [146.10670006600003, 72.03888580900008],
              [146.1298934250001, 72.04559967700004],
              [146.19548587300005, 72.07298411700003],
              [146.23951256600003, 72.08038971600007],
              [146.2617293630001, 72.08844635600008],
              [146.27125084700003, 72.10407135600008],
              [146.2812606130001, 72.11371491100005],
              [146.34693444100003, 72.12763092700004],
              [146.32439212300005, 72.14130280200004],
              [146.23707116000003, 72.15497467700004],
              [146.234711134, 72.17243073100008],
              [146.20655358200008, 72.17576732000003],
              [146.14771569100003, 72.16864655200004],
              [146.078949415, 72.17039622600004],
              [146.05836022200003, 72.16551341400003],
              [146.0468856130001, 72.15692780200004],
              [146.04957116000003, 72.14988841400003],
              [146.05681399800005, 72.14297109600005],
              [146.059906446, 72.12946198100008],
              [146.06421959700003, 72.12612539300005],
              [146.06560306100005, 72.12270742400005],
              [146.05836022200003, 72.11737702000005],
              [146.00709069100003, 72.09788646000004],
              [145.9951278000001, 72.09088776200008],
              [145.99000084700003, 72.08295319200005],
              [145.9834090500001, 72.06850820500006],
              [145.96802819100003, 72.07050202000005],
              [145.9497176440001, 72.08307526200008],
              [145.93482506600003, 72.10032786700003],
              [145.95476321700005, 72.11245351800005],
              [145.962250196, 72.12677643400008],
              [145.9575301440001, 72.14154694200005],
              [145.94166100400003, 72.15497467700004],
              [145.91138756600003, 72.16083405200004],
              [145.8769637380001, 72.15908437700006],
              [145.84937584700003, 72.16217682500007],
              [145.83912194100003, 72.18284739800004],
              [145.853851759, 72.19106679900005],
              [145.89087975400003, 72.19599030200004],
              [145.90748131600003, 72.20335521000004],
              [145.88005618600005, 72.21906159100007],
              [145.84253991000003, 72.23004791900007],
              [145.69206790500004, 72.25726959800005],
              [145.65202884200005, 72.25560130400004],
              [145.6132918630001, 72.24433014500005],
              [145.70199629, 72.21702708500004],
              [145.71599368600005, 72.21832916900007],
              [145.72966556100005, 72.22190989800004],
              [145.74146569100003, 72.22125885600008],
              [145.750336134, 72.20962148600006],
              [145.7485457690001, 72.20547109600005],
              [145.73853600400003, 72.19122955900008],
              [145.72339928500003, 72.16217682500007],
              [145.6337996750001, 72.09349192900004],
              [145.629242384, 72.09113190300008],
              [145.62525475400003, 72.09243398600006],
              [145.621918165, 72.09235260600008],
              [145.6201278000001, 72.08608633000006],
              [145.6211043630001, 72.08026764500005],
              [145.6250106130001, 72.07811107000003],
              [145.6298934250001, 72.07664622600004],
              [145.6337996750001, 72.07298411700003],
              [145.640961134, 72.06073639500005],
              [145.650726759, 72.04881419500003],
              [145.67400149800005, 72.03286367400005],
              [145.69703209700003, 72.03148021000004],
              [145.750336134, 72.03888580900008],
              [145.79127037900003, 72.02830638200004],
              [145.80046634200005, 72.00731028900003],
              [145.80152428500003, 71.98322174700007],
              [145.81812584700003, 71.96320221600007],
              [145.8129988940001, 71.95331452000005],
              [145.8095809250001, 71.93577708500004],
              [145.8056746750001, 71.92902252800008],
              [145.79029381600003, 71.92007070500006],
              [145.76929772200003, 71.91380442900004],
              [145.74756920700008, 71.90989817900004],
              [145.566742384, 71.90607330900008],
              [145.32935631600003, 71.87099844000005],
              [145.3046981130001, 71.87783437700006],
              [145.25611412900003, 71.90745677300004],
              [145.16187584700003, 71.93402741100005],
              [145.078461134, 71.94061920800004],
              [145.02214603000004, 71.95408763200004],
              [144.9907332690001, 71.97455475500004],
              [144.97095787900003, 71.98029205900008],
              [144.96216881600003, 71.96662018400008],
              [144.96021569100003, 71.95490143400008],
              [144.95679772200003, 71.94476959800005],
              [144.95622806100005, 71.93451569200005],
              [144.96216881600003, 71.92226797100005],
              [144.97437584700003, 71.91372304900005],
              [145.012054884, 71.89988841400003],
              [145.02711022200003, 71.89118073100008],
              [145.063324415, 71.88003164300005],
              [145.18873131600003, 71.85602448100008],
              [145.21599368600005, 71.84332916900007],
              [145.19646243600005, 71.81305573100008],
              [145.1513778000001, 71.80390045800004],
              [145.10181725400003, 71.80072663000004],
              [145.02906334700003, 71.77065664300005],
              [144.9267684250001, 71.78253815300008],
              [144.88640384200005, 71.77138906500005],
              [144.92066491000003, 71.74347565300008],
              [144.90113366000003, 71.73257070500006],
              [144.9062606130001, 71.69887929900005],
              [144.89323978000004, 71.67519765800006],
              [144.92066491000003, 71.69171784100007],
              [144.953461134, 71.70172760600008],
              [144.98560631600003, 71.70018138200004],
              [145.01059004, 71.68203359600005],
              [145.00310306100005, 71.67519765800006],
              [145.022797071, 71.67601146000004],
              [145.05738366000003, 71.69212474200003],
              [145.0781356130001, 71.69627513200004],
              [145.1045028000001, 71.69285716400003],
              [145.15650475400003, 71.67804596600007],
              [145.18132571700005, 71.67519765800006],
              [145.20590254, 71.67853424700007],
              [145.22803795700008, 71.68402741100005],
              [145.25074303500003, 71.68671295800004],
              [145.27686608200008, 71.68203359600005],
              [145.28288821700005, 71.67816803600005],
              [145.29053795700008, 71.66779205900008],
              [145.2988387380001, 71.66327545800004],
              [145.30933678500003, 71.66103750200006],
              [145.3212996750001, 71.66030508000006],
              [145.33326256600003, 71.66107819200005],
              [145.3437606130001, 71.66327545800004],
              [145.56999759200005, 71.74095286700003],
              [145.72999108200008, 71.72980377800008],
              [145.8271590500001, 71.74762604400007],
              [145.922699415, 71.77643463700008],
              [145.95045006600003, 71.78119538000004],
              [146.00904381600003, 71.78123607000003],
              [146.03630618600005, 71.78636302300004],
              [146.1001082690001, 71.80906810100004],
              [146.15650475400003, 71.82070547100005],
              [146.25855553500003, 71.87946198100008],
              [146.33130944100003, 71.89931875200006],
              [146.35303795700008, 71.90167877800008],
              [146.36540774800005, 71.90595123900005],
              [146.3720809250001, 71.91616445500006],
              [146.37720787900003, 71.92845286700003],
              [146.3837996750001, 71.93927643400008],
              [146.40064537900003, 71.94912344000005],
              [146.4692488940001, 71.97003815300008],
              [146.58961022200003, 72.04197825700004],
              [146.619476759, 72.07485586100006],
              [146.63062584700003, 72.07990143400008],
              [146.6704207690001, 72.08714427300004],
              [147.10466556100005, 72.30556875200006],
              [147.14869225400003, 72.32054271000004],
              [147.19556725400003, 72.32990143400008],
              [147.24382571700005, 72.33307526200008],
              [147.3300887380001, 72.32355377800008],
              [147.433929884, 72.33991120000007],
              [147.6650496750001, 72.32558828300006],
              [147.74675540500004, 72.33881256700005],
              [148.1240340500001, 72.32420482000003],
              [148.40202884200005, 72.31093984600005],
              [148.68344160250007, 72.28115468950006],
              [148.9648543630001, 72.25136953300006],
              [149.36866295700008, 72.18520742400005],
              [149.6113387380001, 72.14838288000004],
              [149.67261803500003, 72.12653229400007],
              [149.70850670700008, 72.12466054900005],
              [149.72478274800005, 72.12079498900005],
              [149.73015384200005, 72.11676666900007],
              [149.739593946, 72.10492584800005],
              [149.7446395190001, 72.10032786700003],
              [149.95134524800005, 71.99994538000004],
              [150.043304884, 71.94139232000003],
              [150.0669051440001, 71.92194245000007],
              [150.0742293630001, 71.89423248900005],
              [150.05640709700003, 71.86664459800005],
              [150.0200301440001, 71.84857819200005],
              [149.7094832690001, 71.77289459800005],
              [149.66960696700005, 71.77118561400005],
              [149.6313582690001, 71.78143952000005],
              [149.55486087300005, 71.82225169500003],
              [149.477875196, 71.85150788000004],
              [149.40796959700003, 71.89671458500004],
              [149.36898847700002, 71.90379466400003],
              [149.3291121750001, 71.89704010600008],
              [149.286468946, 71.88125234600005],
              [149.29615319100003, 71.87750885600008],
              [149.30616295700008, 71.87506745000007],
              [149.3164168630001, 71.87400950700004],
              [149.32683353000004, 71.87445709800005],
              [149.3037215500001, 71.85521067900004],
              [149.239105665, 71.83734772300005],
              [149.21070397200003, 71.82599518400008],
              [149.19507897200003, 71.81268952000005],
              [149.16553795700008, 71.78131745000007],
              [149.14869225400003, 71.77138906500005],
              [149.10621178500003, 71.76679108300004],
              [148.97803795700008, 71.79181549700007],
              [148.9170028000001, 71.79511139500005],
              [148.86605879, 71.81024811400005],
              [148.85043379, 71.81256745000007],
              [148.8339949880001, 71.81232330900008],
              [148.8339949880001, 71.80613841400003],
              [148.89136803500003, 71.77533600500004],
              [148.91285241000003, 71.77138906500005],
              [149.039398634, 71.76459381700005],
              [149.039398634, 71.75775788000004],
              [149.02418053500003, 71.74909088700008],
              [149.01002037900003, 71.73419830900008],
              [149.00212649800005, 71.71747467700004],
              [149.005218946, 71.70311107000003],
              [148.90992272200003, 71.70148346600007],
              [148.86605879, 71.69537995000007],
              [148.8271590500001, 71.67519765800006],
              [149.00310306100005, 71.66766998900005],
              [149.02605228000004, 71.67011139500005],
              [149.045258009, 71.67743561400005],
              [149.08350670700008, 71.69721100500004],
              [149.1015731130001, 71.70311107000003],
              [149.12061608200008, 71.70270416900007],
              [149.18287194100003, 71.68878815300008],
              [149.3129988940001, 71.68671295800004],
              [149.358734571, 71.67731354400007],
              [149.7724715500001, 71.64789459800005],
              [149.8442488940001, 71.66559479400007],
              [149.868011915, 71.66836172100005],
              [149.88648522200003, 71.66510651200008],
              [149.905609571, 71.65936920800004],
              [149.92408287900003, 71.65721263200004],
              [149.95329837300005, 71.66986725500004],
              [149.96509850400003, 71.66278717700004],
              [149.9853621750001, 71.64105866100005],
              [150.00416100400003, 71.63165924700007],
              [150.0688582690001, 71.61505768400008],
              [150.1020613940001, 71.59471263200004],
              [150.08578535200002, 71.58148834800005],
              [150.045258009, 71.57428620000007],
              [150.0058699880001, 71.57217031500005],
              [150.00798587300005, 71.57953522300005],
              [150.01002037900003, 71.59296295800004],
              [150.012054884, 71.60004303600005],
              [149.98015384200005, 71.60057200700004],
              [149.9516707690001, 71.59162018400008],
              [149.938812696, 71.57412344000005],
              [149.95476321700005, 71.54889557500007],
              [149.96802819100003, 71.53473541900007],
              [149.96461022200003, 71.52936432500007],
              [149.9316512380001, 71.52301666900007],
              [149.868011915, 71.49701569200005],
              [149.87281334700003, 71.48859284100007],
              [149.874359571, 71.47980377800008],
              [149.87281334700003, 71.47093333500004],
              [149.868011915, 71.46222565300008],
              [149.89372806100005, 71.47113678600005],
              [150.1171981130001, 71.51569245000007],
              [150.27711022200003, 71.52122630400004],
              [150.30193118600005, 71.51894765800006],
              [150.32740319100003, 71.51068756700005],
              [150.32195071700005, 71.50942617400005],
              [150.30689537900003, 71.50385163000004],
              [150.3271590500001, 71.49852122600004],
              [150.3505965500001, 71.50023021000004],
              [150.41773522200003, 71.51764557500007],
              [150.43628991000003, 71.51727936400005],
              [150.47820071700005, 71.51068756700005],
              [150.57992597700002, 71.51854075700004],
              [150.63502037900003, 71.51496002800008],
              [150.67066491000003, 71.49017975500004],
              [150.67017662900003, 71.46637604400007],
              [150.65162194100003, 71.44521719000005],
              [150.62574303500003, 71.42890045800004],
              [150.60377037900003, 71.41966380400004],
              [150.5703231130001, 71.41087474200003],
              [150.554047071, 71.40265534100007],
              [150.54712975400003, 71.39057038000004],
              [150.54249108200008, 71.37913646000004],
              [150.52800540500004, 71.36566803600005],
              [150.53345787900003, 71.36050039300005],
              [150.51514733200008, 71.34642161700003],
              [150.49537194100003, 71.34210846600007],
              [150.4746199880001, 71.34125397300005],
              [150.45240319100003, 71.33779531500005],
              [150.39128665500004, 71.32086823100008],
              [150.354828321, 71.31647370000007],
              [150.338226759, 71.31053294500003],
              [150.30689537900003, 71.29535553600005],
              [150.28288821700005, 71.28823476800005],
              [150.23454837300005, 71.28461334800005],
              [150.20980879, 71.27973053600005],
              [150.09441165500004, 71.23541901200008],
              [150.03663170700008, 71.22760651200008],
              [150.02686608200008, 71.22264232000003],
              [150.029633009, 71.21625397300005],
              [150.04672285200002, 71.20966217700004],
              [150.06861412900003, 71.20807526200008],
              [150.0962020190001, 71.21051666900007],
              [150.1445418630001, 71.22138092700004],
              [150.24333743600005, 71.26829661700003],
              [150.28012129, 71.27789948100008],
              [150.4087020190001, 71.28497955900008],
              [150.55779056100005, 71.33917877800008],
              [150.618011915, 71.37938060100004],
              [150.65699303500003, 71.39028554900005],
              [150.73894290500004, 71.39398834800005],
              [150.68140709700003, 71.37201569200005],
              [150.66041100400003, 71.35675690300008],
              [150.64332116000003, 71.33319733300004],
              [150.6259871750001, 71.29840729400007],
              [150.6132918630001, 71.28436920800004],
              [150.59489993600005, 71.27789948100008],
              [150.63013756600003, 71.28485748900005],
              [150.69288170700008, 71.31806061400005],
              [150.75945071700005, 71.33331940300008],
              [150.8252059250001, 71.36660390800006],
              [150.858734571, 71.37417226800005],
              [151.03305097700002, 71.39398834800005],
              [151.0712996750001, 71.38825104400007],
              [151.14470462300005, 71.36554596600007],
              [151.49244225400003, 71.33315664300005],
              [151.55339603000004, 71.31614817900004],
              [151.591156446, 71.31024811400005],
              [151.60914147200003, 71.30524323100008],
              [151.62256920700008, 71.29804108300004],
              [151.6406356130001, 71.28119538000004],
              [151.6504012380001, 71.27423737200007],
              [151.66716556100005, 71.26732005400004],
              [151.70142662900003, 71.25775788000004],
              [151.71827233200008, 71.25063711100006],
              [151.7544051440001, 71.22793203300006],
              [151.76734459700003, 71.22333405200004],
              [151.75318444100003, 71.20966217700004],
              [151.799164259, 71.18138255400004],
              [151.90577233200008, 71.14203522300005],
              [151.948578321, 71.10968659100007],
              [151.98853600400003, 71.08730703300006],
              [152.1035262380001, 71.05011627800008],
              [152.1367293630001, 71.01727936400005],
              [152.13396243600005, 70.99811432500007],
              [152.11402428500003, 70.98920319200005],
              [152.060883009, 70.98309967700004],
              [151.65748131600003, 70.99054596600007],
              [151.68148847700002, 70.97589752800008],
              [151.969086134, 70.94481028900003],
              [152.2109481130001, 70.88056061400005],
              [152.5048934250001, 70.84784577000005],
              [152.54908287900003, 70.82709381700005],
              [152.54078209700003, 70.79132721600007],
              [152.57683353000004, 70.82029857000003],
              [152.61304772200003, 70.83462148600006],
              [152.79835045700008, 70.83462148600006],
              [152.9902449880001, 70.83462148600006],
              [153.310883009, 70.85761139500005],
              [153.327484571, 70.86115143400008],
              [153.3154403000001, 70.87323639500005],
              [153.3481551440001, 70.88251373900005],
              [153.459320509, 70.88068268400008],
              [153.4531356130001, 70.87323639500005],
              [153.61784915500004, 70.88324616100005],
              [153.66374759200005, 70.86102936400005],
              [153.93043053500003, 70.89411041900007],
              [154.1787215500001, 70.94212474200003],
              [154.2387801440001, 70.96499258000006],
              [154.48841393300006, 70.98442210500005],
              [154.73804772200003, 71.00385163000004],
              [155.02947024800005, 71.03314850500004],
              [155.479828321, 71.06159088700008],
              [155.50757897200003, 71.05735911700003],
              [155.5219832690001, 71.04515208500004],
              [155.51905358200008, 71.03432851800005],
              [155.4990340500001, 71.01447174700007],
              [155.4946395190001, 71.00421784100007],
              [155.50147545700008, 70.99258047100005],
              [155.5156356130001, 70.98065827000005],
              [155.5297957690001, 70.97622304900005],
              [155.5361434250001, 70.98680247600004],
              [155.537445509, 70.99559153900003],
              [155.5410262380001, 71.00804271000004],
              [155.54639733200008, 71.01923248900005],
              [155.55298912900003, 71.02411530200004],
              [155.56568444100003, 71.02944570500006],
              [155.59099368600005, 71.05565013200004],
              [155.6045028000001, 71.06565989800004],
              [155.62956790500004, 71.07241445500006],
              [155.93637129, 71.09935130400004],
              [156.28736412900003, 71.08612702000005],
              [156.6845809250001, 71.09271881700005],
              [156.98572838600006, 71.08362457900006],
              [157.28687584700003, 71.07453034100007],
              [157.58578535200002, 71.07485586100006],
              [157.6411238940001, 71.06488678600005],
              [157.6943465500001, 71.06745026200008],
              [157.7734481130001, 71.05426666900007],
              [157.989105665, 71.04751211100006],
              [158.1806746750001, 71.01040273600006],
              [158.27955162900003, 71.00543854400007],
              [158.36939537900003, 70.98053620000007],
              [158.52361087300005, 70.96881745000007],
              [158.88070722750007, 70.89905426650006],
              [159.23780358200008, 70.82929108300004],
              [159.6894637380001, 70.67096588700008],
              [159.843109571, 70.58152903900003],
              [160.02491295700008, 70.41941966400003],
              [160.05258222700002, 70.37177155200004],
              [160.08073978000004, 70.33331940300008],
              [160.0942488940001, 70.30988190300008],
              [160.10434004, 70.28473541900007],
              [160.106293165, 70.26373932500007],
              [160.08814537900003, 70.23834870000007],
              [160.02100670700008, 70.21067942900004],
              [159.99366295700008, 70.19208405200004],
              [159.95866946700005, 70.14105866100005],
              [159.93824303500003, 70.12848541900007],
              [159.9008895190001, 70.12661367400005],
              [159.73755944100003, 70.14594147300005],
              [159.68864993600005, 70.13397858300004],
              [159.71827233200008, 70.13296133000006],
              [159.74439537900003, 70.12620677300004],
              [159.79664147200003, 70.10602448100008],
              [159.82593834700003, 70.10309479400007],
              [159.889984571, 70.10765208500004],
              [159.9145613940001, 70.09857819200005],
              [159.8696395190001, 70.07217031500005],
              [159.85132897200003, 70.05491771000004],
              [159.84636478000004, 70.03034088700008],
              [159.85230553500003, 70.02252838700008],
              [159.86280358200008, 70.01455312700006],
              [159.86931399800005, 70.00503164300005],
              [159.86304772200003, 69.99282461100006],
              [159.8486434250001, 69.98578522300005],
              [159.78695722700002, 69.97260163000004],
              [159.76099694100003, 69.96185944200005],
              [159.73609459700003, 69.94725169500003],
              [159.69206790500004, 69.91087474200003],
              [159.68897545700008, 69.89077383000006],
              [159.7099715500001, 69.87148672100005],
              [159.763031446, 69.83856842700004],
              [159.72966556100005, 69.83856842700004],
              [159.7446395190001, 69.83112213700008],
              [159.7754012380001, 69.82176341400003],
              [159.790375196, 69.81492747600004],
              [159.801117384, 69.80703359600005],
              [159.802093946, 69.80190664300005],
              [159.7988387380001, 69.79637278900003],
              [159.79664147200003, 69.78733958500004],
              [159.788422071, 69.77480703300006],
              [159.76905358200008, 69.76203034100007],
              [159.83269290500004, 69.78388092700004],
              [159.8618270190001, 69.78986237200007],
              [159.88697350400003, 69.78754303600005],
              [160.1372176440001, 69.71808502800008],
              [160.16944420700008, 69.70327383000006],
              [160.18897545700008, 69.70197174700007],
              [160.15186608200008, 69.72044505400004],
              [160.1411238940001, 69.72866445500006],
              [160.2558699880001, 69.71869538000004],
              [160.2920028000001, 69.70880768400008],
              [160.311859571, 69.70001862200007],
              [160.32056725400003, 69.69009023600006],
              [160.32154381600003, 69.67593008000006],
              [160.31861412900003, 69.65420156500005],
              [160.38396243600005, 69.67487213700008],
              [160.44906660200002, 69.68545156500005],
              [160.515961134, 69.68720123900005],
              [160.71949303500003, 69.66518789300005],
              [160.84839928500003, 69.63507721600007],
              [160.86548912900003, 69.63397858300004],
              [160.89722741000003, 69.64622630400004],
              [160.9150496750001, 69.64671458500004],
              [160.92554772200003, 69.64207591400003],
              [160.9336043630001, 69.63491445500006],
              [160.940765821, 69.62677643400008],
              [160.9492293630001, 69.61945221600007],
              [160.9946395190001, 69.59316640800006],
              [161.0063582690001, 69.57733795800004],
              [160.9902449880001, 69.56110260600008],
              [160.9589949880001, 69.54022858300004],
              [160.94507897200003, 69.51703522300005],
              [160.9365340500001, 69.49103424700007],
              [160.921234571, 69.46181875200006],
              [160.93775475400003, 69.44013092700004],
              [160.94125410200002, 69.43178945500006],
              [160.9423934250001, 69.41742584800005],
              [160.9462996750001, 69.40302155200004],
              [160.9560653000001, 69.39484284100007],
              [160.96941165500004, 69.38686758000006],
              [160.9834090500001, 69.37299225500004],
              [160.98845462300005, 69.36176178600005],
              [160.9931746750001, 69.33881256700005],
              [161.0004988940001, 69.32831452000005],
              [161.00928795700008, 69.31899648600006],
              [161.01710045700008, 69.30768463700008],
              [161.02271569100003, 69.29559967700004],
              [161.02491295700008, 69.28367747600004],
              [161.02173912900003, 69.27081940300008],
              [161.01441491000003, 69.26007721600007],
              [161.00709069100003, 69.25177643400008],
              [161.0039168630001, 69.24607982000003],
              [161.00855553500003, 69.23395416900007],
              [161.03077233200008, 69.20913320500006],
              [161.03858483200008, 69.19489166900007],
              [161.035980665, 69.16266510600008],
              [161.01246178500003, 69.14618561400005],
              [160.98324629, 69.13178131700005],
              [160.9629012380001, 69.10553620000007],
              [161.0590926440001, 69.06956614800004],
              [161.28728274800005, 69.04389069200005],
              [161.3403426440001, 69.02753327000005],
              [161.39014733200008, 69.00551992400005],
              [161.415375196, 68.98200104400007],
              [161.41089928500003, 68.96356842700004],
              [161.39405358200008, 68.94342682500007],
              [161.34343509200005, 68.89948151200008],
              [161.31234785200002, 68.88239166900007],
              [161.2993270190001, 68.87274811400005],
              [161.291351759, 68.86212799700007],
              [161.2837020190001, 68.84048086100006],
              [161.27881920700008, 68.83120351800005],
              [161.267914259, 68.82168203300006],
              [161.2412215500001, 68.80548737200007],
              [161.22535241000003, 68.79287344000005],
              [161.22185306100005, 68.79328034100007],
              [161.21941165500004, 68.79218170800004],
              [161.2168074880001, 68.78400299700007],
              [161.216156446, 68.77887604400007],
              [161.217133009, 68.76813385600008],
              [161.21412194100003, 68.71743398600006],
              [161.20964603000004, 68.69208405200004],
              [161.19906660200002, 68.68097565300008],
              [161.1709090500001, 68.67279694200005],
              [161.14665774800005, 68.65273672100005],
              [161.10694420700008, 68.60521067900004],
              [161.0317488940001, 68.56049225500004],
              [160.9423934250001, 68.55390045800004],
              [160.75806725400003, 68.56427643400008],
              [160.77947024800005, 68.53945547100005],
              [160.82105553500003, 68.52741120000007],
              [160.9082137380001, 68.52334219000005],
              [161.0468856130001, 68.53440989800004],
              [161.09644616000003, 68.55316803600005],
              [161.120453321, 68.55744049700007],
              [161.134125196, 68.56142812700006],
              [161.14991295700008, 68.57086823100008],
              [161.25660241000003, 68.66608307500007],
              [161.27125084700003, 68.67413971600007],
              [161.33082116000003, 68.69196198100008],
              [161.347015821, 68.70140208500004],
              [161.30616295700008, 68.73334381700005],
              [161.29029381600003, 68.75372955900008],
              [161.30648847700002, 68.76642487200007],
              [161.314789259, 68.78363678600005],
              [161.31910241000003, 68.79022858300004],
              [161.32764733200008, 68.79706452000005],
              [161.43230228000004, 68.84601471600007],
              [161.47779381600003, 68.87905508000006],
              [161.53337649800005, 68.89496491100005],
              [161.55876712300005, 68.90692780200004],
              [161.57406660200002, 68.92112864800004],
              [161.57585696700005, 68.93260325700004],
              [161.5708113940001, 68.94651927300004],
              [161.56617272200003, 68.96832916900007],
              [161.56706790500004, 69.00169505400004],
              [161.56568444100003, 69.01487864800004],
              [161.55876712300005, 69.02977122600004],
              [161.54070071700005, 69.04755280200004],
              [161.49919681100005, 69.07192617400005],
              [161.48365319100003, 69.09186432500007],
              [161.481781446, 69.10040924700007],
              [161.48324629, 69.11595286700003],
              [161.4804793630001, 69.12295156500005],
              [161.44890384200005, 69.15395742400005],
              [161.46607506600003, 69.16852448100008],
              [161.46558678500003, 69.18195221600007],
              [161.453461134, 69.19415924700007],
              [161.4355574880001, 69.20482005400004],
              [161.399261915, 69.22125885600008],
              [161.46314537900003, 69.28705475500004],
              [161.45720462300005, 69.30158112200007],
              [161.42725670700008, 69.31924062700006],
              [161.415375196, 69.33144765800006],
              [161.4555770190001, 69.33079661700003],
              [161.4755965500001, 69.33454010600008],
              [161.48365319100003, 69.34511953300006],
              [161.477386915, 69.35561758000006],
              [161.44800866000003, 69.37030670800004],
              [161.43580162900003, 69.37986888200004],
              [161.47380618600005, 69.39704010600008],
              [161.60035241000003, 69.42829010600008],
              [161.6279403000001, 69.44367096600007],
              [161.67644290500004, 69.48232656500005],
              [161.70264733200008, 69.49591705900008],
              [161.72632897200003, 69.50023021000004],
              [161.74756920700008, 69.50120677300004],
              [161.7680770190001, 69.50560130400004],
              [161.80445397200003, 69.52973053600005],
              [161.82374108200008, 69.53465403900003],
              [161.844086134, 69.53534577000005],
              [161.90503991000003, 69.52521393400008],
              [161.945648634, 69.52798086100006],
              [162.02556399800005, 69.55117422100005],
              [162.0146590500001, 69.57343170800004],
              [162.0302840500001, 69.58397044500003],
              [162.0864363940001, 69.59210846600007],
              [162.12647545700008, 69.61005280200004],
              [162.13819420700008, 69.61261627800008],
              [162.15308678500003, 69.61371491100005],
              [162.16871178500003, 69.61676666900007],
              [162.1962996750001, 69.62628815300008],
              [162.17847741000003, 69.62811920800004],
              [162.172211134, 69.63336823100008],
              [162.17644290500004, 69.64105866100005],
              [162.18970787900003, 69.65045807500007],
              [162.20972741000003, 69.65591054900005],
              [162.2304793630001, 69.65363190300008],
              [162.25163821700005, 69.64883047100005],
              [162.271820509, 69.64671458500004],
              [162.29851321700005, 69.65167877800008],
              [162.31788170700008, 69.66290924700007],
              [162.3281356130001, 69.67987702000005],
              [162.3271590500001, 69.70197174700007],
              [162.34343509200005, 69.70156484600005],
              [162.38851972700002, 69.68154531500005],
              [162.40796959700003, 69.67658112200007],
              [162.62134850400003, 69.68154531500005],
              [162.657562696, 69.67723216400003],
              [162.73023522200003, 69.65851471600007],
              [162.76880944100003, 69.65420156500005],
              [163.02312259200005, 69.68549225500004],
              [163.08912194100003, 69.70880768400008],
              [163.1650496750001, 69.72089264500005],
              [163.304047071, 69.72028229400007],
              [163.35377037900003, 69.70742422100005],
              [163.39625084700003, 69.71043528900003],
              [163.416351759, 69.70880768400008],
              [163.46119225400003, 69.69135163000004],
              [163.477875196, 69.68773021000004],
              [163.58480879, 69.68406810100004],
              [163.77303039900005, 69.69440219400008],
              [163.89276446400004, 69.73888248900005],
              [163.98226972700002, 69.76459381700005],
              [164.02702884200005, 69.77383047100005],
              [164.0727645190001, 69.76850006700005],
              [164.10824629, 69.75934479400007],
              [164.11939537900003, 69.75287506700005],
              [164.12525475400003, 69.74555084800005],
              [164.13038170700008, 69.73069896000004],
              [164.136078321, 69.72557200700004],
              [164.23707116000003, 69.68260325700004],
              [164.31397545700008, 69.66787344000005],
              [164.43913821700005, 69.62075429900005],
              [164.53793379, 69.60390859600005],
              [164.83425805000002, 69.56740402800006],
              [165.2694709220001, 69.59795357200005],
              [165.67472913900008, 69.59597755400006],
              [165.73316491000003, 69.58291250200006],
              [165.78923587300005, 69.58466217700004],
              [165.94605553500003, 69.55780670800004],
              [166.03199303500003, 69.52968984600005],
              [166.0752059250001, 69.52326080900008],
              [166.35242760500006, 69.52846914250006],
              [166.62964928500003, 69.53367747600004],
              [166.69255618600005, 69.51479726800005],
              [166.69841556100005, 69.50674062700006],
              [166.6782332690001, 69.49591705900008],
              [166.89380944100003, 69.49591705900008],
              [166.93873131600003, 69.50210195500006],
              [167.22413170650003, 69.59867991750005],
              [167.50953209700003, 69.69525788000004],
              [167.53500410200002, 69.71385325700004],
              [167.5869246750001, 69.74079010600008],
              [167.67408287900003, 69.77187734600005],
              [167.71648196700005, 69.77708567900004],
              [167.80201256600003, 69.77521393400008],
              [167.82960045700008, 69.77024974200003],
              [167.8481551440001, 69.76373932500007],
              [167.8916121750001, 69.73956940300008],
              [167.93824303500003, 69.72223541900007],
              [167.96257571700005, 69.71698639500005],
              [167.98715254, 69.71503327000005],
              [168.0361434250001, 69.72052643400008],
              [168.0590926440001, 69.71954987200007],
              [168.083343946, 69.70880768400008],
              [168.014008009, 69.68976471600007],
              [167.99097741000003, 69.68773021000004],
              [167.977875196, 69.68325429900005],
              [167.92644290500004, 69.65420156500005],
              [167.96550540500004, 69.63434479400007],
              [168.10328209700003, 69.60578034100007],
              [168.2197371750001, 69.56785716400003],
              [168.24097741000003, 69.55829498900005],
              [168.25407962300005, 69.54433828300006],
              [168.25660241000003, 69.53168366100005],
              [168.25310306100005, 69.52342357000003],
              [168.246429884, 69.51520416900007],
              [168.24040774800005, 69.50275299700007],
              [168.23943118600005, 69.49286530200004],
              [168.24138431100005, 69.47174713700008],
              [168.24040774800005, 69.46181875200006],
              [168.23218834700003, 69.44147370000007],
              [168.19206790500004, 69.37986888200004],
              [168.22087649800005, 69.35187409100007],
              [168.23267662900003, 69.33637116100005],
              [168.24040774800005, 69.31842682500007],
              [168.23113040500004, 69.29877350500004],
              [168.24366295700008, 69.27594635600008],
              [168.2666121750001, 69.25543854400007],
              [168.28825931100005, 69.24266185100004],
              [168.3286238940001, 69.22947825700004],
              [168.37183678500003, 69.22113678600005],
              [168.65805097700002, 69.21356842700004],
              [168.8505965500001, 69.18805573100008],
              [168.96461022200003, 69.15192291900007],
              [169.0395613940001, 69.14134349200003],
              [169.11443118600005, 69.11424388200004],
              [169.1523543630001, 69.10553620000007],
              [169.30420983200008, 69.09772370000007],
              [169.37126712300005, 69.07656484600005],
              [169.41976972700002, 69.02362702000005],
              [169.43311608200008, 68.97431061400005],
              [169.4345809250001, 68.88670482000003],
              [169.45386803500003, 68.84544505400004],
              [169.48414147200003, 68.82168203300006],
              [169.5239363940001, 68.80532461100006],
              [169.6254988940001, 68.77724844000005],
              [169.9882918630001, 68.80265941000005],
              [170.35108483200008, 68.82807038000004],
              [170.37810306100005, 68.82123444200005],
              [170.39966881600003, 68.81232330900008],
              [170.4228621750001, 68.80707428600005],
              [170.49390709700003, 68.80019765800006],
              [170.55152428500003, 68.77195872600004],
              [170.58472741000003, 68.76227448100008],
              [170.60954837300005, 68.75234609600005],
              [170.62517337300005, 68.74860260600008],
              [170.5493270190001, 68.79303620000007],
              [170.53638756600003, 68.81126536700003],
              [170.54574629, 68.81232330900008],
              [170.5517684250001, 68.81488678600005],
              [170.56373131600003, 68.82493724200003],
              [170.45866946700005, 68.83173248900005],
              [170.44019616000003, 68.84544505400004],
              [170.4492293630001, 68.86347077000005],
              [170.47608483200008, 68.87494538000004],
              [170.52898196700005, 68.88580963700008],
              [170.594574415, 68.90900299700007],
              [170.63306725400003, 68.91815827000005],
              [170.65984134200005, 68.91376373900005],
              [170.66195722700002, 68.90717194200005],
              [170.65308678500003, 68.89207591400003],
              [170.65251712300005, 68.88580963700008],
              [170.66041100400003, 68.87767161700003],
              [170.69402103000004, 68.85846588700008],
              [170.69361412900003, 68.84804922100005],
              [170.69898522200003, 68.83698151200008],
              [170.70875084700003, 68.82835521000004],
              [170.722015821, 68.82493724200003],
              [170.72803795700008, 68.82196686400005],
              [170.72575931100005, 68.83974844000005],
              [170.71452884200005, 68.85944245000007],
              [170.70769290500004, 68.87588125200006],
              [170.70875084700003, 68.88548411700003],
              [170.7133895190001, 68.90135325700004],
              [170.71452884200005, 68.91034577000005],
              [170.70972741000003, 68.91742584800005],
              [170.68734785200002, 68.93109772300005],
              [170.68043053500003, 68.94037506700005],
              [170.75928795700008, 68.95380280200004],
              [170.89437910200002, 68.99323151200008],
              [170.919281446, 69.00608958500004],
              [170.9404403000001, 69.02362702000005],
              [170.95533287900003, 69.04515208500004],
              [170.9609481130001, 69.05027903900003],
              [170.97925866000003, 69.05585358300004],
              [170.99203535200002, 69.05280182500007],
              [171.01547285200002, 69.03725820500006],
              [171.05030358200008, 69.02773672100005],
              [171.15943444100003, 69.03725820500006],
              [171.15943444100003, 69.04409414300005],
              [171.07056725400003, 69.04511139500005],
              [171.02759850400003, 69.05475495000007],
              [171.00928795700008, 69.08161041900007],
              [171.00570722700002, 69.10504791900007],
              [170.99561608200008, 69.12653229400007],
              [170.98023522200003, 69.14435455900008],
              [170.9609481130001, 69.15704987200007],
              [170.91944420700008, 69.16498444200005],
              [170.90007571700005, 69.17121002800008],
              [170.89210045700008, 69.18439362200007],
              [170.89665774800005, 69.19403717700004],
              [170.9184676440001, 69.21283600500004],
              [170.926117384, 69.22215403900003],
              [170.92986087300005, 69.23403554900005],
              [170.92945397200003, 69.24164459800005],
              [170.92741946700005, 69.24896881700005],
              [170.926117384, 69.25975169500003],
              [170.9130965500001, 69.30414459800005],
              [170.88941491000003, 69.32758209800005],
              [170.85865319100003, 69.34682851800005],
              [170.79704837300005, 69.37641022300005],
              [170.763031446, 69.38483307500007],
              [170.7485457690001, 69.39118073100008],
              [170.74244225400003, 69.40412018400008],
              [170.74398847700002, 69.43292877800008],
              [170.74244225400003, 69.44135163000004],
              [170.731781446, 69.45652903900003],
              [170.71794681100005, 69.46222565300008],
              [170.70240319100003, 69.46613190300008],
              [170.68718509200005, 69.47606028900003],
              [170.6777449880001, 69.48875560100004],
              [170.67644290500004, 69.49811432500007],
              [170.6787215500001, 69.50731028900003],
              [170.68043053500003, 69.52016836100006],
              [170.66765384200005, 69.54043203300006],
              [170.63835696700005, 69.56683991100005],
              [170.60613040500004, 69.58978913000004],
              [170.58415774800005, 69.59955475500004],
              [170.51026855400005, 69.60208845600005],
              [170.46698677900008, 69.59532485500006],
              [170.28634677500008, 69.57911656100003],
              [170.18041439800004, 69.58463579500005],
              [170.16073290200006, 69.61336663100008],
              [170.188218506, 69.64072536300006],
              [170.231553017, 69.68858894400006],
              [170.30265129100007, 69.71180541400008],
              [170.35406850200002, 69.72407360200003],
              [170.43315808500006, 69.73765997300006],
              [170.5004300390001, 69.74028909400005],
              [170.55997576200002, 69.75385352500007],
              [170.5917755590001, 69.76472476100008],
              [170.57056725400003, 69.78388092700004],
              [170.5688582690001, 69.79124583500004],
              [170.5625106130001, 69.79507070500006],
              [170.55494225400003, 69.79840729400007],
              [170.55005944100003, 69.80438873900005],
              [170.5454207690001, 69.82070547100005],
              [170.546234571, 69.82562897300005],
              [170.55103600400003, 69.83014557500007],
              [170.55681399800005, 69.84540436400005],
              [170.55616295700008, 69.88104889500005],
              [170.56031334700003, 69.89036692900004],
              [170.55648847700002, 69.89785390800006],
              [170.5293074880001, 69.92511627800008],
              [170.52271569100003, 69.93846263200004],
              [170.5273543630001, 69.96320221600007],
              [170.535492384, 69.98541901200008],
              [170.53874759200005, 70.00706614800004],
              [170.52898196700005, 70.03034088700008],
              [170.54127037900003, 70.04043203300006],
              [170.55290774800005, 70.05780670800004],
              [170.55933678500003, 70.07697174700007],
              [170.55681399800005, 70.09243398600006],
              [170.52995853000004, 70.10553620000007],
              [170.4067488940001, 70.11286041900007],
              [170.43246504, 70.13410065300008],
              [170.48161868600005, 70.14203522300005],
              [170.5341903000001, 70.13963450700004],
              [170.61085045700008, 70.11627838700008],
              [171.0380965500001, 70.08075592700004],
              [171.31625410200002, 70.07318756700005],
              [171.54753665500004, 70.03856028900003],
              [171.94646243600005, 70.00556061400005],
              [171.994476759, 69.99306875200006],
              [172.32081139450003, 69.98228587450006],
              [172.64714603000004, 69.97150299700007],
              [172.70134524800005, 69.98314036700003],
              [172.72535241000003, 69.98086172100005],
              [172.7680770190001, 69.96629466400003],
              [172.79078209700003, 69.96271393400008],
              [172.79851321700005, 69.92853424700007],
              [172.860687696, 69.90346914300005],
              [173.17937259200005, 69.84516022300005],
              [173.2363387380001, 69.81867096600007],
              [173.22144616000003, 69.81635163000004],
              [173.19947350400003, 69.81004466400003],
              [173.18140709700003, 69.80198802300004],
              [173.1777449880001, 69.79417552300004],
              [173.19800866000003, 69.78343333500004],
              [173.22087649800005, 69.78339264500005],
              [173.26710045700008, 69.79075755400004],
              [173.36841881600003, 69.78998444200005],
              [173.41863040500004, 69.79775625200006],
              [173.462250196, 69.81867096600007],
              [173.47575931100005, 69.82916901200008],
              [173.47925866000003, 69.83576080900008],
              [173.47282962300005, 69.84227122600004],
              [173.44125410200002, 69.86050039300005],
              [173.402679884, 69.87653229400007],
              [173.34351647200003, 69.88865794500003],
              [173.29908287900003, 69.90656159100007],
              [173.25367272200003, 69.91868724200003],
              [173.20850670700008, 69.91087474200003],
              [173.19597415500004, 69.90094635600008],
              [173.1836043630001, 69.88849518400008],
              [173.172699415, 69.88117096600007],
              [173.1640731130001, 69.88666413000004],
              [173.16089928500003, 69.89996979400007],
              [173.16553795700008, 69.90843333500004],
              [173.17554772200003, 69.91449616100005],
              [173.18864993600005, 69.92047760600008],
              [173.23015384200005, 69.93427155200004],
              [173.27857506600003, 69.94183991100005],
              [173.46078535200002, 69.94855377800008],
              [173.70191491000003, 69.88694896000004],
              [173.694672071, 69.88458893400008],
              [173.688812696, 69.88182200700004],
              [173.6826278000001, 69.87982819200005],
              [173.67457116000003, 69.87954336100006],
              [173.72974694100003, 69.85968659100007],
              [173.73780358200008, 69.85199616100005],
              [173.77759850400003, 69.85285065300008],
              [173.76124108200008, 69.86408112200007],
              [173.74341881600003, 69.87327708500004],
              [173.78785241000003, 69.88446686400005],
              [173.83570397200003, 69.87107982000003],
              [173.8837996750001, 69.85175202000005],
              [173.92847741000003, 69.84540436400005],
              [173.947601759, 69.85146719000005],
              [173.98454837300005, 69.87173086100006],
              [174.00407962300005, 69.87954336100006],
              [174.02613366000003, 69.88397858300004],
              [174.0708113940001, 69.88690827000005],
              [174.25513756600003, 69.87824127800008],
              [174.3291121750001, 69.88715241100005],
              [174.3740340500001, 69.87641022300005],
              [174.785492384, 69.85468170800004],
              [175.08838415700006, 69.84574892800003],
              [175.18238366000003, 69.84845612200007],
              [175.41691993100005, 69.86673999000004],
              [175.500114683, 69.87350048100006],
              [175.71554179300006, 69.88145348200004],
              [175.72478883500003, 69.87078951200004],
              [175.6230348800001, 69.86305090400003],
              [175.529736586, 69.85630401700007],
              [175.60174310700006, 69.84331497800008],
              [175.6959654100001, 69.83537610800005],
              [175.77065756600007, 69.82037818800006],
              [175.82616808900002, 69.79348012900005],
              [175.86322905400004, 69.78889006900005],
              [175.92620115900002, 69.77569230700004],
              [175.99717651800006, 69.76936290100008],
              [176.07349045500007, 69.76892671000007],
              [176.14348226200002, 69.78209028600008],
              [176.159453279, 69.80268728400006],
              [176.15766963700003, 69.82148191200008],
              [176.14579227900003, 69.83955204800003],
              [176.09974449800006, 69.85844950600006],
              [176.00671251300002, 69.85884089400008],
              [175.92014107400007, 69.85550001900003],
              [175.84380156400005, 69.86127351800008],
              [175.79022892, 69.87308539300005],
              [175.7815662280001, 69.88528289700008],
              [175.8669317450001, 69.88494795400004],
              [175.94323239000005, 69.88076607600004],
              [176.037575436, 69.88575418600004],
              [176.08361367400005, 69.89409223500007],
              [176.12761478000004, 69.89378489800004],
              [176.14047285200002, 69.88760000200006],
              [176.16374759200005, 69.87010325700004],
              [176.17595462300005, 69.86273834800005],
              [176.25407962300005, 69.83030833500004],
              [176.27214603000004, 69.81867096600007],
              [176.2822371750001, 69.80149974200003],
              [176.26628665500004, 69.79930247600004],
              [176.243011915, 69.79901764500005],
              [176.23121178500003, 69.78733958500004],
              [176.24203535200002, 69.77435944200005],
              [176.26726321700005, 69.77195872600004],
              [176.31316165500004, 69.77708567900004],
              [176.5039168630001, 69.75409577000005],
              [176.54859459700003, 69.73753489800004],
              [176.6215926440001, 69.72247955900008],
              [176.6391707690001, 69.71588776200008],
              [176.6899520190001, 69.68773021000004],
              [176.73454837300005, 69.67475006700005],
              [176.82764733200008, 69.66828034100007],
              [176.976898634, 69.63442617400005],
              [177.16228274800005, 69.61635976800005],
              [177.3579207690001, 69.61717357000003],
              [177.64283287900003, 69.57001373900005],
              [177.682953321, 69.55117422100005],
              [177.6411238940001, 69.55890534100007],
              [177.62094160200002, 69.55703359600005],
              [177.60857181100005, 69.54433828300006],
              [177.67855879, 69.53148021000004],
              [177.749359571, 69.53327057500007],
              [177.77125084700003, 69.53139883000006],
              [177.89812259200005, 69.49917226800005],
              [178.15601647200003, 69.46181875200006],
              [178.21216881600003, 69.44342682500007],
              [178.23170006600003, 69.44135163000004],
              [178.246918165, 69.44391510600008],
              [178.29997806100005, 69.46181875200006],
              [178.2910262380001, 69.47357819200005],
              [178.2773543630001, 69.47992584800005],
              [178.2998153000001, 69.48737213700008],
              [178.36491946700005, 69.48680247600004],
              [178.77263431100005, 69.41522858300004],
              [178.81072024800005, 69.39370351800005],
              [178.8720809250001, 69.38800690300008],
              [178.89633222700002, 69.38296133000006],
              [178.92017662900003, 69.37449778900003],
              [178.9926863940001, 69.35936107000003],
              [179.0488387380001, 69.33637116100005],
              [179.067718946, 69.33144765800006],
              [179.067718946, 69.32526276200008],
              [178.9238387380001, 69.31842682500007],
              [178.8974715500001, 69.32103099200003],
              [178.887054884, 69.32998281500005],
              [178.87956790500004, 69.34247467700004],
              [178.8623153000001, 69.35594310100004],
              [178.8379012380001, 69.36489492400005],
              [178.8105574880001, 69.37006256700005],
              [178.7558699880001, 69.37299225500004],
              [178.70045006600003, 69.36579010600008],
              [178.68767337300005, 69.36961497600004],
              [178.6801863940001, 69.37685781500005],
              [178.67335045700008, 69.38190338700008],
              [178.66618899800005, 69.38328685100004],
              [178.65748131600003, 69.37986888200004],
              [178.66431725400003, 69.37360260600008],
              [178.66944420700008, 69.36566803600005],
              [178.67107181100005, 69.35712311400005],
              [178.65398196700005, 69.31745026200008],
              [178.67351321700005, 69.29779694200005],
              [178.7094832690001, 69.28742096600007],
              [178.74561608200008, 69.28367747600004],
              [178.861664259, 69.29791901200008],
              [178.957855665, 69.28367747600004],
              [178.9863387380001, 69.28314850500004],
              [179.067718946, 69.29791901200008],
              [179.26148522200003, 69.27216217700004],
              [179.30591881600003, 69.25787995000007],
              [179.36060631600003, 69.22313060100004],
              [179.65955651150006, 69.10940176000005],
              [179.95850670700008, 68.99567291900007],
              [179.89958743600005, 68.99941640800006],
              [179.847992384, 69.01015859600005],
              [179.6762801440001, 69.08128489800004],
              [179.62818444100003, 69.09015534100007],
              [179.57691491000003, 69.11090729400007],
              [179.54810631600003, 69.11298248900005],
              [179.57203209700003, 69.09271881700005],
              [179.62427819100003, 69.07705312700006],
              [179.65056399800005, 69.06460195500006],
              [179.66325931100005, 69.05044179900005],
              [179.6757918630001, 69.03204987200007],
              [179.69214928500003, 69.01609935100004],
              [179.72999108200008, 69.00653717700004],
              [179.7597762380001, 68.99323151200008],
              [179.77409915500004, 68.98883698100008],
              [180, 68.98105032100005],
              [180, 68.55955678700008],
              [180, 68.06094182800007],
              [180, 67.56232687000005],
              [180, 67.06371191100004],
              [180, 66.56509695300008],
              [180, 66.06648199400007],
              [180, 65.56786703600005],
              [180, 65.06925207800003],
              [180, 65.06618951300004],
              [179.89633222700002, 65.05548737200007],
              [179.8286238940001, 65.03119538000004],
              [179.805023634, 65.02757396000004],
              [179.77955162900003, 65.01821523600006],
              [179.71265709700003, 64.95311107000003],
              [179.47868899800005, 64.82273997600004],
              [179.456390821, 64.81806061400005],
              [179.38990319100003, 64.82273997600004],
              [179.294281446, 64.80914948100008],
              [179.2500106130001, 64.81122467700004],
              [179.20240319100003, 64.79596588700008],
              [179.17115319100003, 64.79266998900005],
              [179.03825931100005, 64.74884674700007],
              [178.91179446700005, 64.71539948100008],
              [178.75798587300005, 64.64093659100007],
              [178.5615340500001, 64.59153880400004],
              [178.5141707690001, 64.59031810100004],
              [178.48560631600003, 64.61050039300005],
              [178.53972415500004, 64.62372467700004],
              [178.70191491000003, 64.64398834800005],
              [178.7187606130001, 64.64813873900005],
              [178.73316491000003, 64.65814850500004],
              [178.7558699880001, 64.68219635600008],
              [178.75017337300005, 64.69171784100007],
              [178.7212020190001, 64.69684479400007],
              [178.66773522200003, 64.69928620000007],
              [178.6425887380001, 64.69651927300004],
              [178.56804446700005, 64.67877838700008],
              [178.21794681100005, 64.65827057500007],
              [178.23780358200008, 64.66327545800004],
              [178.26002037900003, 64.66449616100005],
              [178.2734481130001, 64.66933828300006],
              [178.25961347700002, 64.68561432500007],
              [178.240570509, 64.68878815300008],
              [178.084320509, 64.68891022300005],
              [177.97836347700002, 64.67194245000007],
              [177.96794681100005, 64.67523834800005],
              [177.96257571700005, 64.68305084800005],
              [177.9580184250001, 64.69212474200003],
              [177.9511824880001, 64.69928620000007],
              [177.93718509200005, 64.70555247600004],
              [177.9267684250001, 64.70734284100007],
              [177.7441512380001, 64.70636627800008],
              [177.719574415, 64.70897044500003],
              [177.67448978000004, 64.72174713700008],
              [177.6250106130001, 64.72016022300005],
              [177.60173587300005, 64.72589752800008],
              [177.61117597700002, 64.73314036700003],
              [177.6425887380001, 64.74770742400005],
              [177.62468509200005, 64.75259023600006],
              [177.55388431100005, 64.78156159100007],
              [177.5351668630001, 64.78587474200003],
              [177.49187259200005, 64.78864166900007],
              [177.50342858200008, 64.80296458500004],
              [177.50114993600005, 64.81370677300004],
              [177.48845462300005, 64.82046133000006],
              [177.46794681100005, 64.82273997600004],
              [177.427093946, 64.82103099200003],
              [177.410492384, 64.82444896000004],
              [177.38941491000003, 64.83584219000005],
              [177.4126082690001, 64.84463125200006],
              [177.43824303500003, 64.84882233300004],
              [177.49187259200005, 64.85008372600004],
              [177.482758009, 64.86163971600007],
              [177.46021569100003, 64.87958405200004],
              [177.45085696700005, 64.89105866100005],
              [177.449554884, 64.89679596600007],
              [177.45337975400003, 64.90501536700003],
              [177.45085696700005, 64.91217682500007],
              [177.44548587300005, 64.91986725500004],
              [177.439789259, 64.92511627800008],
              [177.432953321, 64.92902252800008],
              [177.42351321700005, 64.93260325700004],
              [177.39991295700008, 64.93646881700005],
              [177.31983483200008, 64.93260325700004],
              [177.29810631600003, 64.93463776200008],
              [177.25757897200003, 64.94367096600007],
              [177.2382918630001, 64.94562409100007],
              [177.21941165500004, 64.95636627800008],
              [177.18864993600005, 65.00844961100006],
              [177.16968834700003, 65.02757396000004],
              [177.15113366000003, 65.03367747600004],
              [176.9926863940001, 65.05980052300004],
              [176.95630944100003, 65.07855866100005],
              [176.936859571, 65.08283112200007],
              [176.85499108200008, 65.08283112200007],
              [176.8129988940001, 65.07640208500004],
              [176.7304793630001, 65.04828522300005],
              [176.6084090500001, 65.03180573100008],
              [176.5708113940001, 65.03351471600007],
              [176.52100670700008, 65.05914948100008],
              [176.49822024800005, 65.06452057500007],
              [176.4575301440001, 65.06915924700007],
              [176.4497176440001, 65.07119375200006],
              [176.44304446700005, 65.07587311400005],
              [176.4365340500001, 65.08161041900007],
              [176.42986087300005, 65.08657461100006],
              [176.41863040500004, 65.09023672100005],
              [176.4062606130001, 65.09113190300008],
              [176.3813582690001, 65.09027741100005],
              [176.39478600400003, 65.06435781500005],
              [176.3711043630001, 65.05467357000003],
              [176.30632571700005, 65.05548737200007],
              [176.33570397200003, 65.03815338700008],
              [176.37183678500003, 65.03514232000003],
              [176.4438582690001, 65.04189687700006],
              [176.45492597700002, 65.03872304900005],
              [176.4843856130001, 65.01459381700005],
              [176.4985457690001, 65.00800202000005],
              [176.51343834700003, 65.00381094000005],
              [176.54615319100003, 65.00092194200005],
              [176.91472415500004, 65.04930247600004],
              [176.95850670700008, 65.04657623900005],
              [176.97779381600003, 65.03131745000007],
              [176.99187259200005, 65.01056549700007],
              [177.02263431100005, 65.00165436400005],
              [177.0532332690001, 64.99746328300006],
              [177.067230665, 64.99038320500006],
              [177.08090254, 64.97308991100005],
              [177.16968834700003, 64.94562409100007],
              [177.17790774800005, 64.93773021000004],
              [177.184418165, 64.92877838700008],
              [177.1938582690001, 64.92137278900003],
              [177.21062259200005, 64.91836172100005],
              [177.22152754, 64.91461823100008],
              [177.230804884, 64.90546295800004],
              [177.24537194100003, 64.88422272300005],
              [177.23780358200008, 64.87978750200006],
              [177.2334090500001, 64.87531159100007],
              [177.22429446700005, 64.86371491100005],
              [177.2758895190001, 64.85000234600005],
              [177.297699415, 64.83844635600008],
              [177.30005944100003, 64.82273997600004],
              [177.28467858200008, 64.81488678600005],
              [177.20378665500004, 64.79486725500004],
              [177.08033287900003, 64.78119538000004],
              [177.0537215500001, 64.77464427300004],
              [177.03980553500003, 64.77277252800008],
              [177.02564537900003, 64.77435944200005],
              [177.01636803500003, 64.77920156500005],
              [177.000824415, 64.79222239800004],
              [176.950043165, 64.80365631700005],
              [176.88559004, 64.84210846600007],
              [176.8481551440001, 64.85008372600004],
              [176.62614993600005, 64.86790599200003],
              [176.6113387380001, 64.86497630400004],
              [176.59734134200005, 64.85382721600007],
              [176.5673934250001, 64.83649323100008],
              [176.5356551440001, 64.82273997600004],
              [176.515961134, 64.82062409100007],
              [176.47584069100003, 64.81122467700004],
              [176.4575301440001, 64.80914948100008],
              [176.43580162900003, 64.81093984600005],
              [176.43181399800005, 64.81647370000007],
              [176.43279056100005, 64.82599518400008],
              [176.42644290500004, 64.83954498900005],
              [176.39714603000004, 64.85993073100008],
              [176.24170983200008, 64.90106842700004],
              [176.22413170700008, 64.90912506700005],
              [176.20687910200002, 64.92177969000005],
              [176.18873131600003, 64.92796458500004],
              [176.11109459700003, 64.92519765800006],
              [176.090668165, 64.93162669500003],
              [176.06519616000003, 64.95864492400005],
              [176.04566491000003, 64.96279531500005],
              [176.028656446, 64.95880768400008],
              [175.98357181100005, 64.93549225500004],
              [175.95484459700003, 64.92495351800005],
              [175.9462996750001, 64.91868724200003],
              [175.9433699880001, 64.91364166900007],
              [175.94255618600005, 64.90289948100008],
              [175.9394637380001, 64.89789459800005],
              [175.89861087300005, 64.86375560100004],
              [175.8676863940001, 64.84503815300008],
              [175.7880965500001, 64.82648346600007],
              [175.754730665, 64.80882396000004],
              [175.71461022200003, 64.79364655200004],
              [175.56275475400003, 64.81195709800005],
              [175.51246178500003, 64.80670807500007],
              [175.41391035200002, 64.78363678600005],
              [175.28923587300005, 64.77537669500003],
              [175.2407332690001, 64.78681061400005],
              [175.22388756600003, 64.78245677300004],
              [175.2080184250001, 64.77496979400007],
              [175.18620853000004, 64.77098216400003],
              [175.04078209700003, 64.77806224200003],
              [174.99040774800005, 64.77098216400003],
              [174.86394290500004, 64.71478913000004],
              [174.79574629, 64.70335521000004],
              [174.750336134, 64.68891022300005],
              [174.726898634, 64.68561432500007],
              [174.441742384, 64.69245026200008],
              [174.4770613940001, 64.67597077000005],
              [174.51905358200008, 64.67039622600004],
              [174.77173912900003, 64.68065013200004],
              [175.0224715500001, 64.75458405200004],
              [175.10718834700003, 64.76479726800005],
              [175.27849368600005, 64.75055573100008],
              [175.59050540500004, 64.78937409100007],
              [175.62452233200008, 64.77472565300008],
              [175.65748131600003, 64.76764557500007],
              [175.71168053500003, 64.77472565300008],
              [175.84099368600005, 64.81045156500005],
              [175.85767662900003, 64.81899648600006],
              [175.871429884, 64.82965729400007],
              [175.887054884, 64.83877187700006],
              [175.92465254, 64.84829336100006],
              [175.9394637380001, 64.85663483300004],
              [175.9809676440001, 64.90094635600008],
              [176.00464928500003, 64.91535065300008],
              [176.03874759200005, 64.92182038000004],
              [176.082367384, 64.91893138200004],
              [176.12671959700003, 64.90827057500007],
              [176.21013431100005, 64.87396881700005],
              [176.27328535200002, 64.82489655200004],
              [176.28044681100005, 64.81679922100005],
              [176.29265384200005, 64.79486725500004],
              [176.3032332690001, 64.78070709800005],
              [176.316742384, 64.76748281500005],
              [176.3330184250001, 64.75763580900008],
              [176.364593946, 64.74994538000004],
              [176.37566165500004, 64.74087148600006],
              [176.38550866000003, 64.73045482000003],
              [176.39568118600005, 64.72284577000005],
              [176.4150496750001, 64.71474844000005],
              [176.42367597700002, 64.70962148600006],
              [176.42009524800005, 64.70351797100005],
              [176.40251712300005, 64.69245026200008],
              [176.38396243600005, 64.68325429900005],
              [176.3266707690001, 64.66571686400005],
              [176.18238366000003, 64.64716217700004],
              [176.14527428500003, 64.62759023600006],
              [176.119476759, 64.59788646000004],
              [176.11451256600003, 64.59003327000005],
              [176.10499108200008, 64.55634186400005],
              [176.10084069100003, 64.54840729400007],
              [176.1142684250001, 64.54193756700005],
              [176.11793053500003, 64.54800039300005],
              [176.11833743600005, 64.55955638200004],
              [176.12134850400003, 64.56952545800004],
              [176.13396243600005, 64.57929108300004],
              [176.2099715500001, 64.62006256700005],
              [176.24626712300005, 64.62372467700004],
              [176.28443444100003, 64.62140534100007],
              [176.3266707690001, 64.62417226800005],
              [176.36841881600003, 64.63426341400003],
              [176.3891707690001, 64.64288971600007],
              [176.40593509200005, 64.65485260600008],
              [176.42888431100005, 64.67894114800004],
              [176.442230665, 64.68854401200008],
              [176.4575301440001, 64.69245026200008],
              [176.54175866000003, 64.68431224200003],
              [176.58228600400003, 64.67373281500005],
              [176.6899520190001, 64.62759023600006],
              [176.7016707690001, 64.61810944200005],
              [176.727386915, 64.57916901200008],
              [176.74293053500003, 64.57123444200005],
              [176.75953209700003, 64.57387929900005],
              [176.7929793630001, 64.59003327000005],
              [176.8193465500001, 64.59747955900008],
              [176.82837975400003, 64.60301341400003],
              [176.83220462300005, 64.60932038000004],
              [176.82992597700002, 64.61444733300004],
              [176.82691491000003, 64.61912669500003],
              [176.82837975400003, 64.62417226800005],
              [176.85466556100005, 64.64264557500007],
              [176.91968834700003, 64.67011139500005],
              [176.98585045700008, 64.71112702000005],
              [177.033539259, 64.71857330900008],
              [177.12818444100003, 64.71971263200004],
              [177.16944420700008, 64.72654857000003],
              [177.21257571700005, 64.73867422100005],
              [177.29281660200002, 64.77094147300005],
              [177.3383895190001, 64.78148021000004],
              [177.49187259200005, 64.76752350500004],
              [177.48015384200005, 64.73639557500007],
              [177.45240319100003, 64.68549225500004],
              [177.44947350400003, 64.67348867400005],
              [177.45427493600005, 64.66201406500005],
              [177.45525149800005, 64.65216705900008],
              [177.44483483200008, 64.64301178600005],
              [177.42017662900003, 64.62759023600006],
              [177.41228274800005, 64.61762116100005],
              [177.39861087300005, 64.59406159100007],
              [177.38941491000003, 64.58258698100008],
              [177.371429884, 64.57143789300005],
              [177.3642684250001, 64.56321849200003],
              [177.36150149800005, 64.54840729400007],
              [177.36939537900003, 64.52167389500005],
              [177.38738040500004, 64.49188873900005],
              [177.426605665, 64.44232819200005],
              [177.4536238940001, 64.42064036700003],
              [177.55388431100005, 64.37775299700007],
              [177.5947371750001, 64.34194570500006],
              [177.62224368600005, 64.33295319200005],
              [177.6699324880001, 64.30512116100005],
              [177.68970787900003, 64.29734935100004],
              [177.73210696700005, 64.28827545800004],
              [177.813324415, 64.25421784100007],
              [178.0000106130001, 64.21035390800006],
              [178.18384850400003, 64.20579661700003],
              [178.18384850400003, 64.21320221600007],
              [178.10084069100003, 64.23786041900007],
              [178.074554884, 64.25421784100007],
              [178.1025496750001, 64.27065664300005],
              [178.19752037900003, 64.29523346600007],
              [178.21664472700002, 64.30353424700007],
              [178.2343856130001, 64.31391022300005],
              [178.25066165500004, 64.32684967700004],
              [178.26587975400003, 64.34296295800004],
              [178.282562696, 64.35398997600004],
              [178.278656446, 64.36530182500007],
              [178.26628665500004, 64.37396881700005],
              [178.24390709700003, 64.40009186400005],
              [178.22779381600003, 64.41868724200003],
              [178.21794681100005, 64.42682526200008],
              [178.2021590500001, 64.42255280200004],
              [178.18384850400003, 64.41128164300005],
              [178.19361412900003, 64.42084381700005],
              [178.2002059250001, 64.43113841400003],
              [178.200043165, 64.44017161700003],
              [178.222015821, 64.42942942900004],
              [178.39991295700008, 64.24335358300004],
              [178.4091903000001, 64.22992584800005],
              [178.43034915500004, 64.17853424700007],
              [178.440765821, 64.16518789300005],
              [178.56470787900003, 64.06061432500007],
              [178.58863366000003, 64.03510163000004],
              [178.555023634, 64.04515208500004],
              [178.51880944100003, 64.06171295800004],
              [178.48406009200005, 64.07086823100008],
              [178.45484459700003, 64.05874258000006],
              [178.4443465500001, 64.05097077000005],
              [178.42896569100003, 64.04336172100005],
              [178.41277103000004, 64.03742096600007],
              [178.39991295700008, 64.03510163000004],
              [178.38257897200003, 64.00096263200004],
              [178.46827233200008, 63.992621161000045],
              [178.49244225400003, 63.98672109600005],
              [178.46631920700008, 63.980169989000046],
              [178.38257897200003, 63.97923411700003],
              [178.38257897200003, 63.97304922100005],
              [178.4072371750001, 63.967230536000045],
              [178.48894290500004, 63.97304922100005],
              [178.5332137380001, 63.970363674000055],
              [178.61605879, 63.948879299000055],
              [178.63941491000003, 63.94635651200008],
              [178.65691165500004, 63.94916413000004],
              [178.65984134200005, 63.96312083500004],
              [178.6523543630001, 63.97553131700005],
              [178.64771569100003, 63.98651764500005],
              [178.63640384200005, 63.993475653000075],
              [178.64323978000004, 64.00096263200004],
              [178.6938582690001, 63.91046784100007],
              [178.69841556100005, 63.897365627000056],
              [178.69809004, 63.88686758000006],
              [178.691742384, 63.86782461100006],
              [178.69109134200005, 63.85639069200005],
              [178.694672071, 63.84634023600006],
              [178.708343946, 63.82318756700005],
              [178.7168074880001, 63.78725820500006],
              [178.7402449880001, 63.73712799700007],
              [178.76286868600005, 63.64276764500005],
              [178.75928795700008, 63.62299225500004],
              [178.74195397200003, 63.640326239000046],
              [178.72282962300005, 63.65086497600004],
              [178.701508009, 63.656236070000034],
              [178.67725670700008, 63.65770091400003],
              [178.65512129, 63.66229889500005],
              [178.6313582690001, 63.67104726800005],
              [178.60857181100005, 63.67649974200003],
              [178.58863366000003, 63.67137278900003],
              [178.60271243600005, 63.657904364000046],
              [178.62525475400003, 63.64199453300006],
              [178.64909915500004, 63.628607489000046],
              [178.6670028000001, 63.62299225500004],
              [178.69703209700003, 63.621527411000045],
              [178.7246199880001, 63.61676666900007],
              [178.73308353000004, 63.60834381700005],
              [178.70533287900003, 63.59564850500004],
              [178.6645613940001, 63.58828359600005],
              [178.641449415, 63.58771393400008],
              [178.62614993600005, 63.59251536700003],
              [178.62086022200003, 63.599676825000074],
              [178.6162215500001, 63.614162502000056],
              [178.61215254, 63.61985911700003],
              [178.59009850400003, 63.63271719000005],
              [178.5610457690001, 63.64142487200007],
              [178.53109785200002, 63.64362213700008],
              [178.50603274800005, 63.63666413000004],
              [178.53239993600005, 63.63165924700007],
              [178.52686608200008, 63.613714911000045],
              [178.502289259, 63.596909898000035],
              [178.47193444100003, 63.59564850500004],
              [178.46794681100005, 63.599676825000074],
              [178.46558678500003, 63.60639069200005],
              [178.46461022200003, 63.61383698100008],
              [178.46452884200005, 63.61985911700003],
              [178.4599715500001, 63.62299225500004],
              [178.43034915500004, 63.62299225500004],
              [178.371918165, 63.63068268400008],
              [178.35523522200003, 63.63043854400007],
              [178.341156446, 63.625881252000056],
              [178.33155358200008, 63.61823151200008],
              [178.32341556100005, 63.60968659100007],
              [178.31421959700003, 63.60248444200005],
              [178.26840254, 63.58844635600008],
              [178.25961347700002, 63.58197663000004],
              [178.26880944100003, 63.56541575700004],
              [178.29371178500003, 63.54873281500005],
              [178.34148196700005, 63.527411200000074],
              [178.37232506600003, 63.522365627000056],
              [178.40023847700002, 63.52692291900007],
              [178.4262801440001, 63.53851959800005],
              [178.48218834700003, 63.57184479400007],
              [178.50953209700003, 63.57851797100005],
              [178.67546634200005, 63.563706773000035],
              [178.681000196, 63.56492747600004],
              [178.6884871750001, 63.57273997600004],
              [178.69304446700005, 63.57534414300005],
              [178.69841556100005, 63.57518138200004],
              [178.711273634, 63.570013739000046],
              [178.71306399800005, 63.56582265800006],
              [178.71070397200003, 63.55971914300005],
              [178.7114363940001, 63.548529364000046],
              [178.71827233200008, 63.54059479400007],
              [178.72673587300005, 63.53620026200008],
              [178.7290145190001, 63.53119538000004],
              [178.71762129, 63.521185614000046],
              [178.73511803500003, 63.513006903000075],
              [178.73585045700008, 63.50495026200008],
              [178.72925866000003, 63.49721914300005],
              [178.7251082690001, 63.489488023000035],
              [178.72022545700008, 63.47646719000005],
              [178.7080184250001, 63.47109609600005],
              [178.67790774800005, 63.46653880400004],
              [178.6630965500001, 63.45966217700004],
              [178.65609785200002, 63.45307038000004],
              [178.65154056100005, 63.44623444200005],
              [178.64323978000004, 63.438666083000044],
              [178.60320071700005, 63.41909414300005],
              [178.59546959700003, 63.411322333000044],
              [178.66358483200008, 63.39036692900004],
              [178.69898522200003, 63.38568756700005],
              [178.815765821, 63.41966380400004],
              [178.8383895190001, 63.434881903000075],
              [178.82447350400003, 63.455511786000045],
              [178.7861434250001, 63.49298737200007],
              [178.754242384, 63.538275458000044],
              [178.75928795700008, 63.58197663000004],
              [178.770843946, 63.59393952000005],
              [178.77702884200005, 63.59516022300005],
              [178.77947024800005, 63.587103583000044],
              [178.779633009, 63.571478583000044],
              [178.78191165500004, 63.56146881700005],
              [178.79118899800005, 63.544175523000035],
              [178.79997806100005, 63.51227448100008],
              [178.81560306100005, 63.49115631700005],
              [179.00554446700005, 63.32135651200008],
              [178.96045983200008, 63.33734772300005],
              [178.903656446, 63.37571849200003],
              [178.8481551440001, 63.40420156500005],
              [178.8071395190001, 63.39020416900007],
              [178.80933678500003, 63.350490627000056],
              [178.918304884, 63.32518138200004],
              [178.93116295700008, 63.29401276200008],
              [179.0293074880001, 63.287176825000074],
              [179.0546981130001, 63.28099192900004],
              [179.13200931100005, 63.238348700000074],
              [179.16089928500003, 63.23261139500005],
              [179.179047071, 63.23493073100008],
              [179.19483483200008, 63.239447333000044],
              [179.21168053500003, 63.242254950000074],
              [179.232758009, 63.23940664300005],
              [179.29957116000003, 63.21458567900004],
              [179.33480879, 63.196478583000044],
              [179.34205162900003, 63.18817780200004],
              [179.34791100400003, 63.175848700000074],
              [179.36117597700002, 63.16974518400008],
              [179.3759871750001, 63.166083075000074],
              [179.38648522200003, 63.16120026200008],
              [179.40739993600005, 63.14134349200003],
              [179.41334069100003, 63.13239166900007],
              [179.41781660200002, 63.116522528000075],
              [179.41960696700005, 63.07721588700008],
              [179.41781660200002, 63.068060614000046],
              [179.403656446, 63.05540599200003],
              [179.3877059250001, 63.05683014500005],
              [179.37061608200008, 63.06391022300005],
              [179.35230553500003, 63.068060614000046],
              [179.331390821, 63.066107489000046],
              [179.31120853000004, 63.06077708500004],
              [179.27361087300005, 63.044134833000044],
              [179.24870853000004, 63.025824286000045],
              [179.24195397200003, 63.00649648600006],
              [179.24952233200008, 62.98468659100007],
              [179.29175866000003, 62.92747630400004],
              [179.31617272200003, 62.90615469000005],
              [179.3457137380001, 62.893866278000075],
              [179.47087649800005, 62.88471100500004],
              [179.5117293630001, 62.87250397300005],
              [179.54070071700005, 62.848944403000075],
              [179.5449324880001, 62.83665599200003],
              [179.54672285200002, 62.80841705900008],
              [179.5512801440001, 62.79779694200005],
              [179.56324303500003, 62.78587474200003],
              [179.5703231130001, 62.781683661000045],
              [179.578461134, 62.78009674700007],
              [179.5844832690001, 62.77716705900008],
              [179.58716881600003, 62.77033112200007],
              [179.58904056100005, 62.76239655200004],
              [179.59685306100005, 62.74787018400008],
              [179.6074324880001, 62.71552155200004],
              [179.60906009200005, 62.70563385600008],
              [179.6020613940001, 62.69330475500004],
              [179.590179884, 62.68545156500005],
              [179.57764733200008, 62.679022528000075],
              [179.56804446700005, 62.67084381700005],
              [179.5586043630001, 62.65814850500004],
              [179.5595809250001, 62.65375397300005],
              [179.56462649800005, 62.643866278000075],
              [179.567230665, 62.635972398000035],
              [179.5669051440001, 62.629339911000045],
              [179.5629988940001, 62.62474192900004],
              [179.5546981130001, 62.623032945000034],
              [179.465179884, 62.623032945000034],
              [179.43344160200002, 62.616115627000056],
              [179.42261803500003, 62.59821198100008],
              [179.419281446, 62.57379791900007],
              [179.41041100400003, 62.547308661000045],
              [179.383636915, 62.520819403000075],
              [179.34913170700008, 62.50649648600006],
              [179.3110457690001, 62.50067780200004],
              [179.19019616000003, 62.503241278000075],
              [179.148773634, 62.49603913000004],
              [179.11605879, 62.47223541900007],
              [179.112640821, 62.44830963700008],
              [179.14958743600005, 62.41779205900008],
              [179.13493899800005, 62.38027578300006],
              [179.13982181100005, 62.36591217700004],
              [179.14714603000004, 62.352443752000056],
              [179.1504012380001, 62.341864325000074],
              [179.14568118600005, 62.33307526200008],
              [179.1367293630001, 62.32367584800005],
              [179.10328209700003, 62.29791901200008],
              [179.08952884200005, 62.28974030200004],
              [179.073578321, 62.287176825000074],
              [179.0546981130001, 62.29409414300005],
              [179.04517662900003, 62.31513092700004],
              [179.0410262380001, 62.32143789300005],
              [179.034515821, 62.326157945000034],
              [178.97722415500004, 62.35297272300005],
              [178.93816165500004, 62.36603424700007],
              [178.81609134200005, 62.38133372600004],
              [178.73796634200005, 62.403550523000035],
              [178.48943118600005, 62.436835028000075],
              [178.37574303500003, 62.47223541900007],
              [178.302093946, 62.47455475500004],
              [178.26392662900003, 62.488714911000045],
              [178.188812696, 62.50299713700008],
              [178.12867272200003, 62.52749258000006],
              [178.0610457690001, 62.541083075000074],
              [177.89380944100003, 62.56037018400008],
              [177.68034915500004, 62.57526276200008],
              [177.30681399800005, 62.582098700000074],
              [177.31666100400003, 62.585150458000044],
              [177.326508009, 62.58641185100004],
              [177.34107506600003, 62.588324286000045],
              [177.30543053500003, 62.60569896000004],
              [177.26587975400003, 62.61562734600005],
              [177.3076278000001, 62.655178127000056],
              [177.3169051440001, 62.67519765800006],
              [177.32390384200005, 62.68036530200004],
              [177.3310653000001, 62.68427155200004],
              [177.33415774800005, 62.68817780200004],
              [177.33326256600003, 62.696926174000055],
              [177.32447350400003, 62.727728583000044],
              [177.3203231130001, 62.73139069200005],
              [177.31788170700008, 62.735663153000075],
              [177.31983483200008, 62.74591705900008],
              [177.32374108200008, 62.75145091400003],
              [177.33871504, 62.76447174700007],
              [177.34441165500004, 62.76703522300005],
              [177.4179793630001, 62.773138739000046],
              [177.4296981130001, 62.77045319200005],
              [177.42790774800005, 62.77887604400007],
              [177.4248153000001, 62.786037502000056],
              [177.4243270190001, 62.792222398000035],
              [177.43034915500004, 62.79779694200005],
              [177.446136915, 62.80369700700004],
              [177.454437696, 62.80853913000004],
              [177.45777428500003, 62.81484609600005],
              [177.4443465500001, 62.82221100500004],
              [177.3652449880001, 62.81484609600005],
              [177.3325301440001, 62.80678945500006],
              [177.30054772200003, 62.78652578300006],
              [177.2724715500001, 62.75991445500006],
              [177.25163821700005, 62.73289622600004],
              [177.25668379, 62.727850653000075],
              [177.26587975400003, 62.71246979400007],
              [177.18897545700008, 62.70966217700004],
              [177.15544681100005, 62.719631252000056],
              [177.12818444100003, 62.74591705900008],
              [177.1533309250001, 62.77757396000004],
              [177.15601647200003, 62.78693268400008],
              [177.14795983200008, 62.79584381700005],
              [177.10132897200003, 62.822251695000034],
              [177.04851321700005, 62.834418036000045],
              [177.03191165500004, 62.84153880400004],
              [177.0283309250001, 62.84609609600005],
              [177.0278426440001, 62.851548570000034],
              [177.02613366000003, 62.857489325000074],
              [177.0195418630001, 62.86322663000004],
              [177.00953209700003, 62.867254950000074],
              [176.99927819100003, 62.86961497600004],
              [176.9921981130001, 62.86945221600007],
              [176.97527103000004, 62.86200592700004],
              [176.97925866000003, 62.841009833000044],
              [176.993011915, 62.81708405200004],
              [177.0058699880001, 62.801214911000045],
              [176.99830162900003, 62.79437897300005],
              [177.01295006600003, 62.78595612200007],
              [177.03101647200003, 62.77798086100006],
              [177.04224694100003, 62.76870351800005],
              [177.03589928500003, 62.75653717700004],
              [177.0244246750001, 62.74823639500005],
              [176.95427493600005, 62.710923570000034],
              [176.931000196, 62.69440338700008],
              [176.92790774800005, 62.67291901200008],
              [176.9580184250001, 62.64354075700004],
              [177.01148522200003, 62.623480536000045],
              [177.0195418630001, 62.61619700700004],
              [177.02361087300005, 62.59983958500004],
              [177.03467858200008, 62.58966705900008],
              [177.05005944100003, 62.58421458500004],
              [177.067230665, 62.582098700000074],
              [177.0942488940001, 62.583319403000075],
              [177.17595462300005, 62.595770575000074],
              [177.26587975400003, 62.588324286000045],
              [177.2392684250001, 62.56976959800005],
              [177.01490319100003, 62.550482489000046],
              [176.86052493600005, 62.51935455900008],
              [176.7089949880001, 62.499212958000044],
              [176.688324415, 62.50047435100004],
              [176.68311608200008, 62.51316966400003],
              [176.69092858200008, 62.52045319200005],
              [176.7041121750001, 62.52366771000004],
              [176.71697024800005, 62.528631903000075],
              [176.723968946, 62.541083075000074],
              [176.69654381600003, 62.53998444200005],
              [176.66187584700003, 62.53461334800005],
              [176.63591556100005, 62.52216217700004],
              [176.6352645190001, 62.49957916900007],
              [176.610687696, 62.49603913000004],
              [176.5996199880001, 62.49237702000005],
              [176.5942488940001, 62.48582591400003],
              [176.5976668630001, 62.47370026200008],
              [176.61052493600005, 62.47215403900003],
              [176.64210045700008, 62.47842031500005],
              [176.64210045700008, 62.47223541900007],
              [176.59587649800005, 62.45404694200005],
              [176.5595809250001, 62.448879299000055],
              [176.4316512380001, 62.40656159100007],
              [176.41618899800005, 62.403957424000055],
              [176.39340254, 62.39508698100008],
              [176.32056725400003, 62.33502838700008],
              [176.2793074880001, 62.31708405200004],
              [175.95639082150007, 62.254197496000046],
              [175.63347415500004, 62.19131094000005],
              [175.55543053500003, 62.159491278000075],
              [175.47486412900003, 62.14118073100008],
              [175.3379012380001, 62.08283112200007],
              [175.30640709700003, 62.07493724200003],
              [175.3266707690001, 62.08490631700005],
              [175.35523522200003, 62.09487539300005],
              [175.3808699880001, 62.10626862200007],
              [175.39519290500004, 62.122748114000046],
              [175.34359785200002, 62.11082591400003],
              [175.3183699880001, 62.11001211100006],
              [175.2988387380001, 62.11660390800006],
              [175.27361087300005, 62.15257396000004],
              [175.25806725400003, 62.16876862200007],
              [175.25114993600005, 62.16063060100004],
              [175.256195509, 62.09398021000004],
              [175.2509871750001, 62.065741278000075],
              [175.23031660200002, 62.04393138200004],
              [175.17448978000004, 62.021918036000045],
              [174.81511478000004, 61.94700755400004],
              [174.76514733200008, 61.91669342700004],
              [174.7714949880001, 61.926662502000056],
              [174.78101647200003, 61.93268463700008],
              [174.80486087300005, 61.94403717700004],
              [174.78541100400003, 61.95758698100008],
              [174.7563582690001, 61.96124909100007],
              [174.69939212300005, 61.958319403000075],
              [174.6743270190001, 61.96308014500005],
              [174.6254988940001, 61.982855536000045],
              [174.599945509, 61.98501211100006],
              [174.61793053500003, 61.96002838700008],
              [174.6435653000001, 61.946478583000044],
              [174.67058353000004, 61.93610260600008],
              [174.70427493600005, 61.91233958500004],
              [174.7192488940001, 61.90448639500005],
              [174.72966556100005, 61.89606354400007],
              [174.726898634, 61.88629791900007],
              [174.70281009200005, 61.86786530200004],
              [174.69011478000004, 61.86127350500004],
              [174.48975670700008, 61.81464264500005],
              [174.4536238940001, 61.81480540600006],
              [174.42847741000003, 61.81492747600004],
              [174.411468946, 61.81826406500005],
              [174.394867384, 61.82440827000005],
              [174.3833113940001, 61.825506903000075],
              [174.3598738940001, 61.82111237200007],
              [174.3774520190001, 61.829738674000055],
              [174.38038170700008, 61.839911200000074],
              [174.37134850400003, 61.84747955900008],
              [174.35303795700008, 61.84845612200007],
              [174.33952884200005, 61.84406159100007],
              [174.3051863940001, 61.82111237200007],
              [174.28500410200002, 61.81354401200008],
              [174.264984571, 61.811428127000056],
              [174.20427493600005, 61.81500885600008],
              [174.18873131600003, 61.811835028000075],
              [174.15503991000003, 61.80060455900008],
              [174.16724694100003, 61.80683014500005],
              [174.1933699880001, 61.81679922100005],
              [174.1699324880001, 61.83250560100004],
              [174.138031446, 61.844631252000056],
              [174.1045028000001, 61.848537502000056],
              [174.07300866000003, 61.84162018400008],
              [174.08619225400003, 61.82794830900008],
              [174.03272545700008, 61.82632070500006],
              [174.01351972700002, 61.81732819200005],
              [174.02068118600005, 61.796861070000034],
              [174.03874759200005, 61.783270575000074],
              [174.0605574880001, 61.77606842700004],
              [174.08033287900003, 61.77826569200005],
              [174.10661868600005, 61.780178127000056],
              [174.060883009, 61.769964911000045],
              [174.03891035200002, 61.76129791900007],
              [174.02068118600005, 61.74909088700008],
              [174.00953209700003, 61.73529694200005],
              [174.0019637380001, 61.72313060100004],
              [173.99097741000003, 61.714544989000046],
              [173.94263756600003, 61.70945872600004],
              [173.92400149800005, 61.70416901200008],
              [173.88746178500003, 61.683294989000046],
              [173.8247176440001, 61.66054922100005],
              [173.80494225400003, 61.64984772300005],
              [173.812836134, 61.67645905200004],
              [173.80193118600005, 61.69179922100005],
              [173.778656446, 61.69993724200003],
              [173.67253665500004, 61.72093333500004],
              [173.599945509, 61.753892320000034],
              [173.57309004, 61.75665924700007],
              [173.54460696700005, 61.74909088700008],
              [173.5332137380001, 61.73867422100005],
              [173.52214603000004, 61.721136786000045],
              [173.51392662900003, 61.70213450700004],
              [173.5107528000001, 61.68699778900003],
              [173.50318444100003, 61.671128648000035],
              [173.47388756600003, 61.64280833500004],
              [173.47291100400003, 61.63239166900007],
              [173.48414147200003, 61.61908600500004],
              [173.49170983200008, 61.60492584800005],
              [173.49586022200003, 61.589178778000075],
              [173.4970809250001, 61.57127513200004],
              [173.48113040500004, 61.55524323100008],
              [173.44459069100003, 61.55329010600008],
              [173.38005618600005, 61.56102122600004],
              [173.355804884, 61.55719635600008],
              [173.33122806100005, 61.547308661000045],
              [173.30876712300005, 61.53388092700004],
              [173.2910262380001, 61.51947663000004],
              [173.3090926440001, 61.49164459800005],
              [173.28589928500003, 61.46507396000004],
              [173.12842858200008, 61.39695872600004],
              [173.0839949880001, 61.39252350500004],
              [173.00212649800005, 61.415228583000044],
              [172.99341881600003, 61.42015208500004],
              [172.9755965500001, 61.43976471600007],
              [172.96941165500004, 61.44432200700004],
              [172.9555770190001, 61.44867584800005],
              [172.9282332690001, 61.44863515800006],
              [172.91480553500003, 61.451157945000034],
              [172.90886478000004, 61.454779364000046],
              [172.90455162900003, 61.45921458500004],
              [172.8994246750001, 61.46674225500004],
              [172.90064537900003, 61.469183661000045],
              [172.900726759, 61.47138092700004],
              [172.89714603000004, 61.472316799000055],
              [172.82642662900003, 61.468817450000074],
              [172.71558678500003, 61.43073151200008],
              [172.74830162900003, 61.41510651200008],
              [172.82634524800005, 61.38764069200005],
              [172.87964928500003, 61.37986888200004],
              [172.89918053500003, 61.372259833000044],
              [172.91765384200005, 61.36200592700004],
              [172.93132571700005, 61.351548570000034],
              [172.93775475400003, 61.33844635600008],
              [172.93734785200002, 61.32640208500004],
              [172.9399520190001, 61.317572333000044],
              [172.9550887380001, 61.31403229400007],
              [172.8945418630001, 61.27789948100008],
              [172.8183699880001, 61.29238515800006],
              [172.73894290500004, 61.32273997600004],
              [172.66781660200002, 61.33445872600004],
              [172.73698978000004, 61.30532461100006],
              [172.76880944100003, 61.285589911000045],
              [172.76677493600005, 61.26251862200007],
              [172.7529403000001, 61.254787502000056],
              [172.73853600400003, 61.25348541900007],
              [172.7236434250001, 61.25421784100007],
              [172.70818118600005, 61.25259023600006],
              [172.6997176440001, 61.24799225500004],
              [172.68384850400003, 61.234808661000045],
              [172.67465254, 61.232082424000055],
              [172.66976972700002, 61.22679271000004],
              [172.65650475400003, 61.20091380400004],
              [172.64673912900003, 61.191107489000046],
              [172.57374108200008, 61.187201239000046],
              [172.386078321, 61.227443752000056],
              [172.338226759, 61.211004950000074],
              [172.3632918630001, 61.192694403000075],
              [172.382172071, 61.17462799700007],
              [172.40300540500004, 61.159369208000044],
              [172.434418165, 61.14956289300005],
              [172.434418165, 61.14272695500006],
              [172.336761915, 61.122300523000035],
              [172.28638756600003, 61.12368398600006],
              [172.2426863940001, 61.14272695500006],
              [172.263031446, 61.11473216400003],
              [172.2978621750001, 61.10374583500004],
              [172.40349368600005, 61.09788646000004],
              [172.4140731130001, 61.09430573100008],
              [172.4184676440001, 61.08966705900008],
              [172.41960696700005, 61.08315664300005],
              [172.41968834700003, 61.07709381700005],
              [172.42074629, 61.07379791900007],
              [172.43734785200002, 61.07078685100004],
              [172.489593946, 61.081244208000044],
              [172.47608483200008, 61.05573151200008],
              [172.4482528000001, 61.04433828300006],
              [172.416351759, 61.03693268400008],
              [172.37256920700008, 61.012884833000044],
              [172.354828321, 61.012884833000044],
              [172.3183699880001, 61.01984284100007],
              [172.263031446, 61.014960028000075],
              [172.2426863940001, 61.01984284100007],
              [172.1328231130001, 61.067572333000044],
              [172.00928795700008, 61.10114166900007],
              [172.0312606130001, 61.087144273000035],
              [172.16089928500003, 61.02749258000006],
              [172.1806746750001, 61.01235586100006],
              [172.1943465500001, 60.99453359600005],
              [172.20085696700005, 60.975775458000044],
              [172.1972762380001, 60.95844147300005],
              [172.1806746750001, 60.94472890800006],
              [172.16521243600005, 60.943019924000055],
              [172.12842858200008, 60.946600653000075],
              [172.11540774800005, 60.94098541900007],
              [172.105804884, 60.92731354400007],
              [172.1005965500001, 60.92177969000005],
              [172.0918074880001, 60.91681549700007],
              [172.08415774800005, 60.88719310100004],
              [172.04712975400003, 60.860663153000075],
              [172.0068465500001, 60.85521067900004],
              [171.98943118600005, 60.88947174700007],
              [171.99561608200008, 60.90460846600007],
              [172.004730665, 60.92064036700003],
              [172.0044051440001, 60.93646881700005],
              [171.98267662900003, 60.950873114000046],
              [171.95777428500003, 60.953111070000034],
              [171.95630944100003, 60.93768952000005],
              [171.9575301440001, 60.91860586100006],
              [171.94092858200008, 60.90997955900008],
              [171.9433699880001, 60.90253327000005],
              [171.94483483200008, 60.899644273000035],
              [171.94841556100005, 60.895697333000044],
              [171.94109134200005, 60.88153717700004],
              [171.94800866000003, 60.87250397300005],
              [171.958343946, 60.86481354400007],
              [171.96159915500004, 60.854681708000044],
              [171.94939212300005, 60.84829336100006],
              [171.89861087300005, 60.83685944200005],
              [171.825043165, 60.83222077000005],
              [171.80445397200003, 60.834865627000056],
              [171.74594160200002, 60.853583075000074],
              [171.72291100400003, 60.846136786000045],
              [171.66334069100003, 60.81671784100007],
              [171.628265821, 60.81688060100004],
              [171.59888756600003, 60.803615627000056],
              [171.58472741000003, 60.800116278000075],
              [171.5712996750001, 60.802394924000055],
              [171.55974368600005, 60.80678945500006],
              [171.54859459700003, 60.80951569200005],
              [171.53687584700003, 60.80695221600007],
              [171.5654403000001, 60.79315827000005],
              [171.59555097700002, 60.78620026200008],
              [171.620453321, 60.77411530200004],
              [171.63257897200003, 60.74481842700004],
              [171.59986412900003, 60.737616278000075],
              [171.50277754, 60.73114655200004],
              [171.47868899800005, 60.72337474200003],
              [171.43620853000004, 60.69940827000005],
              [171.413422071, 60.69017161700003],
              [171.43873131600003, 60.70453522300005],
              [171.457367384, 60.71816640800006],
              [171.46794681100005, 60.73114655200004],
              [171.461761915, 60.747707424000055],
              [171.44516035200002, 60.75775788000004],
              [171.428070509, 60.765692450000074],
              [171.420258009, 60.77619049700007],
              [171.41521243600005, 60.78506094000005],
              [171.40503991000003, 60.78660716400003],
              [171.39633222700002, 60.78294505400004],
              [171.39673912900003, 60.77619049700007],
              [171.40113366000003, 60.76911041900007],
              [171.40447024800005, 60.76015859600005],
              [171.40650475400003, 60.75047435100004],
              [171.4072371750001, 60.71474844000005],
              [171.40357506600003, 60.70522695500006],
              [171.394867384, 60.70164622600004],
              [171.38559004, 60.700384833000044],
              [171.37907962300005, 60.697699286000045],
              [171.3730574880001, 60.682928778000075],
              [171.37484785200002, 60.65497467700004],
              [171.372406446, 60.64305247600004],
              [171.35613040500004, 60.627386786000045],
              [171.31324303500003, 60.61542389500005],
              [171.27100670700008, 60.59284088700008],
              [171.220062696, 60.58380768400008],
              [171.17945397200003, 60.55890534100007],
              [171.16032962300005, 60.55658600500004],
              [171.118500196, 60.559881903000075],
              [171.07927493600005, 60.55951569200005],
              [171.0556746750001, 60.555853583000044],
              [170.98365319100003, 60.52765534100007],
              [170.95980879, 60.52130768400008],
              [170.81072024800005, 60.51211172100005],
              [170.79118899800005, 60.51703522300005],
              [170.770355665, 60.525824286000045],
              [170.75074303500003, 60.52948639500005],
              [170.73503665500004, 60.51894765800006],
              [170.7504988940001, 60.501166083000044],
              [170.76677493600005, 60.49445221600007],
              [170.7861434250001, 60.49485911700003],
              [170.81072024800005, 60.49843984600005],
              [170.78777103000004, 60.47638580900008],
              [170.78337649800005, 60.46393463700008],
              [170.79021243600005, 60.45062897300005],
              [170.75554446700005, 60.43650950700004],
              [170.7172957690001, 60.428168036000045],
              [170.63941491000003, 60.42332591400003],
              [170.6220809250001, 60.42763906500005],
              [170.60572350400003, 60.44635651200008],
              [170.58757571700005, 60.45062897300005],
              [170.51587975400003, 60.45062897300005],
              [170.52621504, 60.434759833000044],
              [170.54363040500004, 60.434800523000035],
              [170.5634871750001, 60.438666083000044],
              [170.58073978000004, 60.43390534100007],
              [170.61158287900003, 60.400376695000034],
              [170.61841881600003, 60.38857656500005],
              [170.6118270190001, 60.38808828300006],
              [170.60499108200008, 60.38544342700004],
              [170.59888756600003, 60.37669505400004],
              [170.61540774800005, 60.370021877000056],
              [170.65251712300005, 60.36127350500004],
              [170.66293379, 60.35024648600006],
              [170.66586347700002, 60.341131903000075],
              [170.6621199880001, 60.332017320000034],
              [170.65251712300005, 60.32094961100006],
              [170.61890709700003, 60.302435614000046],
              [170.53728274800005, 60.29047272300005],
              [170.502289259, 60.27252838700008],
              [170.473968946, 60.23224518400008],
              [170.45728600400003, 60.18244049700007],
              [170.44019616000003, 60.08075592700004],
              [170.416351759, 60.01512278900003],
              [170.41285241000003, 59.99445221600007],
              [170.40064537900003, 59.96564362200007],
              [170.37126712300005, 59.948472398000035],
              [170.26514733200008, 59.920355536000045],
              [170.23422285200002, 59.92129140800006],
              [170.20630944100003, 59.932521877000056],
              [170.1767684250001, 59.95380280200004],
              [170.160980665, 59.95994700700004],
              [170.11890709700003, 59.968003648000035],
              [170.10499108200008, 59.97768789300005],
              [170.10124759200005, 59.989447333000044],
              [170.10466556100005, 59.99843984600005],
              [170.111664259, 60.00739166900007],
              [170.11866295700008, 60.01927317900004],
              [170.1025496750001, 60.02374909100007],
              [170.0566512380001, 60.046576239000046],
              [170.03980553500003, 60.05036041900007],
              [169.98804772200003, 60.052801825000074],
              [169.95582116000003, 60.05923086100006],
              [169.9360457690001, 60.07575104400007],
              [169.90577233200008, 60.12164948100008],
              [169.86247806100005, 60.16242096600007],
              [169.84880618600005, 60.181626695000034],
              [169.8437606130001, 60.21076080900008],
              [169.86247806100005, 60.219183661000045],
              [169.9746199880001, 60.23216380400004],
              [169.94516035200002, 60.243841864000046],
              [169.9199324880001, 60.249986070000034],
              [169.8945418630001, 60.25047435100004],
              [169.86475670700008, 60.24518463700008],
              [169.8369246750001, 60.243353583000044],
              [169.81080162900003, 60.25014883000006],
              [169.755218946, 60.27558014500005],
              [169.74675540500004, 60.28302643400008],
              [169.74488366000003, 60.29287344000005],
              [169.74488366000003, 60.30345286700003],
              [169.74195397200003, 60.31346263200004],
              [169.73389733200008, 60.321926174000055],
              [169.7138778000001, 60.33844635600008],
              [169.70777428500003, 60.34760163000004],
              [169.7060653000001, 60.36619700700004],
              [169.7089949880001, 60.38312409100007],
              [169.70777428500003, 60.39948151200008],
              [169.6933699880001, 60.41648997600004],
              [169.66570071700005, 60.42926666900007],
              [169.6054793630001, 60.44330475500004],
              [169.56861412900003, 60.46869538000004],
              [169.55250084700003, 60.47138092700004],
              [169.521820509, 60.471136786000045],
              [169.35027103000004, 60.533189195000034],
              [169.29224694100003, 60.54205963700008],
              [169.2641707690001, 60.550482489000046],
              [169.24781334700003, 60.56732819200005],
              [169.34107506600003, 60.56073639500005],
              [169.37134850400003, 60.56732819200005],
              [169.30616295700008, 60.61172109600005],
              [169.285492384, 60.62059153900003],
              [169.2353621750001, 60.621161200000074],
              [169.21436608200008, 60.62872955900008],
              [169.20866946700005, 60.62091705900008],
              [169.20655358200008, 60.61505768400008],
              [169.20826256600003, 60.60919830900008],
              [169.21436608200008, 60.60146719000005],
              [169.1982528000001, 60.58881256700005],
              [169.188812696, 60.583197333000044],
              [169.1801863940001, 60.58038971600007],
              [169.17066491000003, 60.58222077000005],
              [169.15162194100003, 60.592230536000045],
              [169.1455184250001, 60.59406159100007],
              [169.13257897200003, 60.587225653000075],
              [169.13786868600005, 60.57843659100007],
              [169.15211022200003, 60.57078685100004],
              [169.1665145190001, 60.56732819200005],
              [168.97575931100005, 60.57416413000004],
              [168.74830162900003, 60.56972890800006],
              [168.73324629, 60.56732819200005],
              [168.70386803500003, 60.55487702000005],
              [168.69597415500004, 60.55304596600007],
              [168.6504012380001, 60.55267975500004],
              [168.62476647200003, 60.55560944200005],
              [168.57593834700003, 60.58242422100005],
              [168.53150475400003, 60.593085028000075],
              [168.484711134, 60.59857819200005],
              [168.28012129, 60.59642161700003],
              [168.23780358200008, 60.58490631700005],
              [168.09636478000004, 60.571478583000044],
              [167.83765709700003, 60.51056549700007],
              [167.81657962300005, 60.51211172100005],
              [167.801117384, 60.521918036000045],
              [167.78191165500004, 60.548163153000075],
              [167.7680770190001, 60.55304596600007],
              [167.74968509200005, 60.54706452000005],
              [167.75017337300005, 60.53461334800005],
              [167.7602645190001, 60.52033112200007],
              [167.77125084700003, 60.508978583000044],
              [167.7719832690001, 60.49673086100006],
              [167.75171959700003, 60.49127838700008],
              [167.71314537900003, 60.48883698100008],
              [167.63493899800005, 60.45526764500005],
              [167.5922957690001, 60.44546133000006],
              [167.54900149800005, 60.443793036000045],
              [167.532074415, 60.448553778000075],
              [167.49138431100005, 60.46564362200007],
              [167.48015384200005, 60.468003648000035],
              [167.47152754, 60.45990631700005],
              [167.46900475400003, 60.448919989000046],
              [167.4677840500001, 60.437201239000046],
              [167.46314537900003, 60.427069403000075],
              [167.4336043630001, 60.42039622600004],
              [167.36597741000003, 60.46580638200004],
              [167.33611087300005, 60.471136786000045],
              [167.36394290500004, 60.43960195500006],
              [167.37484785200002, 60.42059967700004],
              [167.3740340500001, 60.405951239000046],
              [167.35523522200003, 60.39874909100007],
              [167.3300887380001, 60.404364325000074],
              [167.30388431100005, 60.413397528000075],
              [167.28150475400003, 60.41648997600004],
              [167.30640709700003, 60.393011786000045],
              [167.2783309250001, 60.37323639500005],
              [167.22966556100005, 60.35968659100007],
              [167.19214928500003, 60.35504791900007],
              [167.16081790500004, 60.361761786000045],
              [167.11638431100005, 60.37799713700008],
              [167.0805770190001, 60.39984772300005],
              [167.07545006600003, 60.42332591400003],
              [167.04175866000003, 60.42865631700005],
              [167.02491295700008, 60.42767975500004],
              [167.0239363940001, 60.419907945000034],
              [167.03296959700003, 60.40997955900008],
              [167.03980553500003, 60.39996979400007],
              [167.041351759, 60.39057038000004],
              [167.03443444100003, 60.38239166900007],
              [167.0527449880001, 60.34052155200004],
              [167.04810631600003, 60.32843659100007],
              [167.020843946, 60.32094961100006],
              [166.98609459700003, 60.316107489000046],
              [166.92562910200002, 60.29743073100008],
              [166.912445509, 60.29645416900007],
              [166.897797071, 60.29979075700004],
              [166.907074415, 60.29205963700008],
              [166.93327884200005, 60.27985260600008],
              [166.938812696, 60.26911041900007],
              [166.93181399800005, 60.259019273000035],
              [166.91521243600005, 60.24990469000005],
              [166.857758009, 60.22992584800005],
              [166.83765709700003, 60.22020091400003],
              [166.72632897200003, 60.13226959800005],
              [166.53288821700005, 60.003119208000044],
              [166.36117597700002, 59.88385651200008],
              [166.28777103000004, 59.84454987200007],
              [166.2451278000001, 59.83063385600008],
              [166.19906660200002, 59.82607656500005],
              [166.10954837300005, 59.827460028000075],
              [166.10377037900003, 59.838324286000045],
              [166.10124759200005, 59.863348700000074],
              [166.10279381600003, 59.909409898000035],
              [166.11312910200002, 59.930975653000075],
              [166.14405358200008, 59.966457424000055],
              [166.15064537900003, 59.987941799000055],
              [166.14918053500003, 60.00063711100006],
              [166.143890821, 60.020738023000035],
              [166.14380944100003, 60.03229401200008],
              [166.14576256600003, 60.04214101800005],
              [166.17530358200008, 60.120306708000044],
              [166.18873131600003, 60.137600002000056],
              [166.212250196, 60.15273672100005],
              [166.26677493600005, 60.17829010600008],
              [166.28541100400003, 60.197251695000034],
              [166.28777103000004, 60.224676825000074],
              [166.26392662900003, 60.264105536000045],
              [166.25806725400003, 60.28595612200007],
              [166.27076256600003, 60.31004466400003],
              [166.27605228000004, 60.331284898000035],
              [166.266449415, 60.35883209800005],
              [166.24968509200005, 60.38353099200003],
              [166.23259524800005, 60.39598216400003],
              [166.27458743600005, 60.38373444200005],
              [166.31267337300005, 60.39272695500006],
              [166.34343509200005, 60.416896877000056],
              [166.36296634200005, 60.45062897300005],
              [166.35889733200008, 60.452053127000056],
              [166.34986412900003, 60.457464911000045],
              [166.381195509, 60.47101471600007],
              [166.39283287900003, 60.48041413000004],
              [166.39087975400003, 60.492254950000074],
              [166.37330162900003, 60.49945709800005],
              [166.35466556100005, 60.49127838700008],
              [166.33668053500003, 60.47833893400008],
              [166.32195071700005, 60.471136786000045],
              [166.305023634, 60.47296784100007],
              [166.2714949880001, 60.483710028000075],
              [166.25367272200003, 60.48541901200008],
              [166.05225670700008, 60.45384349200003],
              [166.01343834700003, 60.44037506700005],
              [165.94605553500003, 60.38934967700004],
              [165.92408287900003, 60.38239166900007],
              [165.94060306100005, 60.36562734600005],
              [165.97974694100003, 60.37571849200003],
              [166.04078209700003, 60.42332591400003],
              [166.0805770190001, 60.43740469000005],
              [166.1689559250001, 60.452460028000075],
              [166.21208743600005, 60.457464911000045],
              [166.15902754, 60.442572333000044],
              [166.10694420700008, 60.437567450000074],
              [166.0527449880001, 60.42397695500006],
              [165.9672957690001, 60.36505768400008],
              [165.85613040500004, 60.34218984600005],
              [165.8086043630001, 60.32094961100006],
              [165.768890821, 60.29409414300005],
              [165.72144616000003, 60.26972077000005],
              [165.6709090500001, 60.252020575000074],
              [165.5161238940001, 60.21893952000005],
              [165.461273634, 60.21946849200003],
              [165.44499759200005, 60.25885651200008],
              [165.43474368600005, 60.244208075000074],
              [165.4316512380001, 60.227850653000075],
              [165.43506920700008, 60.21149323100008],
              [165.44499759200005, 60.19676341400003],
              [165.401703321, 60.17015208500004],
              [165.29859459700003, 60.14052969000005],
              [165.24577884200005, 60.10333893400008],
              [165.22925866000003, 60.09723541900007],
              [165.2119246750001, 60.093817450000074],
              [165.1977645190001, 60.09438711100006],
              [165.18506920700008, 60.09902578300006],
              [165.1816512380001, 60.10370514500005],
              [165.18043053500003, 60.10968659100007],
              [165.174164259, 60.11823151200008],
              [165.16000410200002, 60.12909577000005],
              [165.15967858200008, 60.13320547100005],
              [165.16374759200005, 60.14215729400007],
              [165.17017662900003, 60.14956289300005],
              [165.18637129, 60.16030508000006],
              [165.19166100400003, 60.17011139500005],
              [165.16228274800005, 60.16876862200007],
              [165.14372806100005, 60.15639883000006],
              [165.128265821, 60.138739325000074],
              [165.10914147200003, 60.12164948100008],
              [165.08228600400003, 60.11310455900008],
              [165.0537215500001, 60.11554596600007],
              [164.99927819100003, 60.13532135600008],
              [165.00066165500004, 60.124253648000035],
              [165.00342858200008, 60.114162502000056],
              [165.01351972700002, 60.09438711100006],
              [165.00904381600003, 60.08340078300006],
              [165.02409915500004, 60.07221100500004],
              [165.0439559250001, 60.06785716400003],
              [165.05388431100005, 60.077337958000044],
              [165.06397545700008, 60.091009833000044],
              [165.08708743600005, 60.09349192900004],
              [165.11247806100005, 60.08958567900004],
              [165.12964928500003, 60.08417389500005],
              [165.13550866000003, 60.07562897300005],
              [165.14372806100005, 60.044989325000074],
              [165.15007571700005, 60.03229401200008],
              [165.16374759200005, 60.02195872600004],
              [165.198578321, 60.005194403000075],
              [165.21208743600005, 59.99135976800005],
              [165.18181399800005, 59.98651764500005],
              [165.16179446700005, 59.973944403000075],
              [165.12964928500003, 59.93732330900008],
              [165.01351972700002, 59.84796784100007],
              [164.9931746750001, 59.83978913000004],
              [164.93034915500004, 59.833685614000046],
              [164.90105228000004, 59.819973049000055],
              [164.87029056100005, 59.80097077000005],
              [164.83863366000003, 59.78742096600007],
              [164.8071395190001, 59.78961823100008],
              [164.796234571, 59.79832591400003],
              [164.785980665, 59.81268952000005],
              [164.77759850400003, 59.82831452000005],
              [164.77271569100003, 59.841131903000075],
              [164.77458743600005, 59.84454987200007],
              [164.7797957690001, 59.84910716400003],
              [164.78484134200005, 59.854681708000044],
              [164.78638756600003, 59.861029364000046],
              [164.78296959700003, 59.86676666900007],
              [164.770843946, 59.876654364000046],
              [164.766449415, 59.882066148000035],
              [164.75342858200008, 59.90892161700003],
              [164.72331790500004, 59.95677317900004],
              [164.7016707690001, 59.98110586100006],
              [164.68637129, 59.993353583000044],
              [164.6235457690001, 60.02753327000005],
              [164.55054772200003, 60.082912502000056],
              [164.52068118600005, 60.10008372600004],
              [164.48853600400003, 60.111029364000046],
              [164.4511824880001, 60.11481354400007],
              [164.41163170700008, 60.11029694200005],
              [164.3911238940001, 60.10301341400003],
              [164.382172071, 60.09096914300005],
              [164.37671959700003, 60.075384833000044],
              [164.3637801440001, 60.07640208500004],
              [164.34131920700008, 60.09096914300005],
              [164.32056725400003, 60.08860911700003],
              [164.3193465500001, 60.063706773000035],
              [164.33611087300005, 60.036037502000056],
              [164.36866295700008, 60.025458075000074],
              [164.33912194100003, 59.991522528000075],
              [164.27686608200008, 59.97842031500005],
              [164.20769290500004, 59.97337474200003],
              [164.16431725400003, 59.96344635600008],
              [164.1406356130001, 59.95099518400008],
              [164.11793053500003, 59.941392320000034],
              [164.10670006600003, 59.92462799700007],
              [164.10914147200003, 59.90253327000005],
              [164.12574303500003, 59.88450755400004],
              [164.17204837300005, 59.867621161000045],
              [164.1904403000001, 59.85419342700004],
              [164.1650496750001, 59.854803778000075],
              [164.08806399800005, 59.874660549000055],
              [164.06397545700008, 59.874986070000034],
              [164.05201256600003, 59.87958405200004],
              [164.04167728000004, 59.907538153000075],
              [164.04281660200002, 59.913275458000044],
              [164.05396569100003, 59.91559479400007],
              [164.07886803500003, 59.91474030200004],
              [164.089203321, 59.91669342700004],
              [164.09717858200008, 59.92243073100008],
              [164.105804884, 59.934800523000035],
              [164.1132918630001, 59.94354889500005],
              [164.13941491000003, 59.955959377000056],
              [164.15691165500004, 59.969631252000056],
              [164.20484459700003, 59.99750397300005],
              [164.18116295700008, 59.99713776200008],
              [164.1328231130001, 59.98875560100004],
              [164.10914147200003, 59.99135976800005],
              [164.0908309250001, 60.000433661000045],
              [164.0586043630001, 60.02448151200008],
              [164.04021243600005, 60.03229401200008],
              [164.01734459700003, 60.03579336100006],
              [163.91968834700003, 60.03900788000004],
              [163.85523522200003, 60.025458075000074],
              [163.86280358200008, 60.028509833000044],
              [163.86890709700003, 60.032538153000075],
              [163.8730574880001, 60.038275458000044],
              [163.87525475400003, 60.046576239000046],
              [163.83383222700002, 60.05914948100008],
              [163.824554884, 60.05646393400008],
              [163.8129988940001, 60.04824453300006],
              [163.7968856130001, 60.04482656500005],
              [163.77995853000004, 60.04547760600008],
              [163.7656356130001, 60.049709377000056],
              [163.739105665, 60.05337148600006],
              [163.65154056100005, 60.051662502000056],
              [163.62867272200003, 60.046576239000046],
              [163.623383009, 60.025458075000074],
              [163.63843834700003, 60.00421784100007],
              [163.6621199880001, 59.986029364000046],
              [163.68311608200008, 59.974269924000055],
              [163.70281009200005, 59.96930573100008],
              [163.72185306100005, 59.97174713700008],
              [163.759125196, 59.98452383000006],
              [163.7607528000001, 59.98737213700008],
              [163.75896243600005, 59.99176666900007],
              [163.7587996750001, 59.995794989000046],
              [163.7656356130001, 59.99750397300005],
              [163.7719832690001, 59.99689362200007],
              [163.793793165, 59.99135976800005],
              [163.772797071, 59.978949286000045],
              [163.75163821700005, 59.962551174000055],
              [163.71436608200008, 59.92645905200004],
              [163.69800866000003, 59.90403880400004],
              [163.6884871750001, 59.89834219000005],
              [163.66968834700003, 59.89630768400008],
              [163.567718946, 59.906317450000074],
              [163.534515821, 59.90542226800005],
              [163.50407962300005, 59.89789459800005],
              [163.45134524800005, 59.86237213700008],
              [163.42367597700002, 59.84821198100008],
              [163.3618270190001, 59.827460028000075],
              [163.37818444100003, 59.81435781500005],
              [163.376312696, 59.79165273600006],
              [163.36736087300005, 59.765326239000046],
              [163.3618270190001, 59.741522528000075],
              [163.36353600400003, 59.73086172100005],
              [163.3754988940001, 59.69717031500005],
              [163.37680097700002, 59.67597077000005],
              [163.38054446700005, 59.665228583000044],
              [163.39226321700005, 59.652411200000074],
              [163.39014733200008, 59.63153717700004],
              [163.36003665500004, 59.60639069200005],
              [163.3212996750001, 59.587103583000044],
              [163.2929793630001, 59.58388906500005],
              [163.2714949880001, 59.589056708000044],
              [163.247406446, 59.58738841400003],
              [163.2021590500001, 59.57489655200004],
              [163.18344160200002, 59.56549713700008],
              [163.1801863940001, 59.558254299000055],
              [163.19011478000004, 59.555568752000056],
              [163.21045983200008, 59.55996328300006],
              [163.20378665500004, 59.54873281500005],
              [163.1836043630001, 59.53335195500006],
              [163.1762801440001, 59.525824286000045],
              [163.16871178500003, 59.51056549700007],
              [163.1709090500001, 59.50568268400008],
              [163.1801863940001, 59.50299713700008],
              [163.21762129, 59.47768789300005],
              [163.27808678500003, 59.450506903000075],
              [163.303070509, 59.43305084800005],
              [163.32146243600005, 59.411037502000056],
              [163.32837975400003, 59.392238674000055],
              [163.32691491000003, 59.37250397300005],
              [163.31714928500003, 59.32990143400008],
              [163.3125106130001, 59.287543036000045],
              [163.3066512380001, 59.27130768400008],
              [163.29509524800005, 59.259019273000035],
              [163.27857506600003, 59.24787018400008],
              [163.26050866000003, 59.24005768400008],
              [163.244476759, 59.23786041900007],
              [163.2275496750001, 59.242254950000074],
              [163.23015384200005, 59.24957916900007],
              [163.25513756600003, 59.26821523600006],
              [163.2773543630001, 59.27802155200004],
              [163.28785241000003, 59.28693268400008],
              [163.2861434250001, 59.299261786000045],
              [163.27230879, 59.30288320500006],
              [163.2172957690001, 59.285589911000045],
              [163.20777428500003, 59.28778717700004],
              [163.1919051440001, 59.29710521000004],
              [163.18311608200008, 59.299261786000045],
              [163.17359459700003, 59.29828522300005],
              [163.1572371750001, 59.29401276200008],
              [163.13347415500004, 59.291083075000074],
              [163.09441165500004, 59.278998114000046],
              [163.0805770190001, 59.27130768400008],
              [163.07292728000004, 59.26251862200007],
              [163.0688582690001, 59.252834377000056],
              [163.067230665, 59.24310944200005],
              [163.0669051440001, 59.234076239000046],
              [163.07105553500003, 59.22313060100004],
              [163.07699629, 59.212551174000055],
              [163.07634524800005, 59.205064195000034],
              [163.0747176440001, 59.19310130400004],
              [163.12842858200008, 59.18317291900007],
              [163.14177493600005, 59.17755768400008],
              [163.1718856130001, 59.15892161700003],
              [163.21861594300003, 59.15067832900007],
              [163.233296215, 59.13267931300004],
              [163.25142433300005, 59.106712977000086],
              [163.26186885100003, 59.08083037600005],
              [163.245665229, 59.06318947400007],
              [163.226051762, 59.055494546000034],
              [163.1782332690001, 59.04047272300005],
              [163.16431725400003, 59.03367747600004],
              [163.1489363940001, 59.03856028900003],
              [163.14600670700008, 59.04706452000005],
              [163.15544681100005, 59.05451080900008],
              [163.16871178500003, 59.062567450000074],
              [163.1762801440001, 59.07330963700008],
              [163.1650496750001, 59.09666575700004],
              [163.13298587300005, 59.10911692900004],
              [163.0669051440001, 59.12055084800005],
              [163.06910241000003, 59.12518952000005],
              [163.0722762380001, 59.13751862200007],
              [163.07447350400003, 59.142238674000055],
              [163.01246178500003, 59.161444403000075],
              [163.0048934250001, 59.16120026200008],
              [162.97828209700003, 59.15521881700005],
              [162.97185306100005, 59.156236070000034],
              [162.9580184250001, 59.16193268400008],
              [162.95036868600005, 59.161444403000075],
              [162.94711347700002, 59.15875885600008],
              [162.94507897200003, 59.154282945000034],
              [162.94312584700003, 59.146185614000046],
              [162.9438582690001, 59.13711172100005],
              [162.94353274800005, 59.134751695000034],
              [162.93718509200005, 59.13377513200004],
              [162.922699415, 59.13548411700003],
              [162.90357506600003, 59.133978583000044],
              [162.8911238940001, 59.13532135600008],
              [162.88266035200002, 59.132798570000034],
              [162.88152103000004, 59.12055084800005],
              [162.88656660200002, 59.11351146000004],
              [162.96851647200003, 59.05231354400007],
              [162.9868270190001, 59.04148997600004],
              [163.02605228000004, 59.02558014500005],
              [163.03589928500003, 59.02586497600004],
              [163.04273522200003, 59.02977122600004],
              [163.04615319100003, 59.029730536000045],
              [163.0777577780001, 59.00759407900006],
              [163.080661351, 58.983796787000074],
              [163.06854930200006, 58.968053169000086],
              [163.033210909, 58.94860840400008],
              [162.990397154, 58.93319470500006],
              [162.92098804400007, 58.92392397900005],
              [162.878189701, 58.90647732700006],
              [162.914121109, 58.94777156100008],
              [162.91960696700005, 58.97162506700005],
              [162.90259850400003, 58.98395416900007],
              [162.88990319100003, 58.97874583500004],
              [162.86996504, 58.96531810100004],
              [162.84366570600002, 58.906795576000036],
              [162.81619549000004, 58.88722415500007],
              [162.73422285200002, 58.89126211100006],
              [162.7002059250001, 58.875433661000045],
              [162.676605665, 58.87409088700008],
              [162.68230228000004, 58.85602448100008],
              [162.6962996750001, 58.847316799000055],
              [162.71412194100003, 58.846991278000075],
              [162.73121178500003, 58.853583075000074],
              [162.72437584700003, 58.861029364000046],
              [162.74293053500003, 58.86513906500005],
              [162.75733483200008, 58.859808661000045],
              [162.77076256600003, 58.85834381700005],
              [162.78589928500003, 58.87409088700008],
              [162.79053795700008, 58.86424388200004],
              [162.788422071, 58.85578034100007],
              [162.78150475400003, 58.84784577000005],
              [162.78768745800005, 58.83192124400006],
              [162.73758112300004, 58.82045420500003],
              [162.5133996410001, 58.72119979300004],
              [162.40529447300003, 58.65444486700005],
              [162.33924405300002, 58.577516321000076],
              [162.23902811300002, 58.47893430000005],
              [162.16986800300003, 58.405916981000075],
              [162.04692665000005, 58.20620273800006],
              [162.02387313300005, 58.15472950700007],
              [161.993228165, 58.08739217500005],
              [161.996727749, 58.061598908000065],
              [162.01486254400004, 58.00598416400004],
              [162.02556399800005, 57.92877838700008],
              [162.0820418630001, 57.882473049000055],
              [162.145843946, 57.84715403900003],
              [162.21461022200003, 57.82172272300005],
              [162.285492384, 57.80524323100008],
              [162.37005967000005, 57.78482853200006],
              [162.45553948500003, 57.78435082400006],
              [162.4662975760001, 57.76441757300006],
              [162.4398235440001, 57.740807844000074],
              [162.39503533700008, 57.72717802100004],
              [162.34546959700003, 57.69159577000005],
              [162.3545028000001, 57.68854401200008],
              [162.36833743600005, 57.68964264500005],
              [162.38233483200008, 57.69293854400007],
              [162.3950301440001, 57.698431708000044],
              [162.52178931900005, 57.75415576100005],
              [162.51534461900007, 57.79984975800005],
              [162.49404088300003, 57.84760625800004],
              [162.4911549750001, 57.88732033600007],
              [162.5102219810001, 57.907051814000056],
              [162.5297957690001, 57.93650950700004],
              [162.55933678500003, 57.949286200000074],
              [162.58277428500003, 57.954331773000035],
              [162.65552819100003, 57.956732489000046],
              [162.66480553500003, 57.95872630400004],
              [162.67790774800005, 57.96771881700005],
              [162.6899520190001, 57.96971263200004],
              [162.70191491000003, 57.96906159100007],
              [162.71159915500004, 57.96674225500004],
              [162.7207137380001, 57.96279531500005],
              [162.73121178500003, 57.956732489000046],
              [162.75513756600003, 57.935248114000046],
              [162.76539147200003, 57.92877838700008],
              [162.77466881600003, 57.927435614000046],
              [162.79517662900003, 57.929348049000055],
              [162.81324303500003, 57.920355536000045],
              [162.8398543630001, 57.92182038000004],
              [162.850922071, 57.91819896000004],
              [162.85824629, 57.91400788000004],
              [163.00387038100007, 57.83752790300008],
              [163.092633084, 57.82078546000008],
              [163.218941847, 57.81345838100003],
              [163.2219825840001, 57.79754249900009],
              [163.26677493600005, 57.77753327000005],
              [163.27857506600003, 57.75804271000004],
              [163.3295101120001, 57.708944701000064],
              [163.25393744200005, 57.67814375800003],
              [163.2424690260001, 57.67034507300008],
              [163.2374858400001, 57.64066421700005],
              [163.243954003, 57.618782503000034],
              [163.24288454700002, 57.59499209400008],
              [163.21645205000004, 57.581437179000034],
              [163.1900829770001, 57.56984895700003],
              [163.16390967100006, 57.56222854100008],
              [163.13634911300005, 57.53473389200008],
              [163.12490371900003, 57.51113111300003],
              [163.10797050400004, 57.49495750500006],
              [163.07483384600005, 57.46100005200003],
              [162.962314451, 57.436435448000054],
              [162.9085174930001, 57.416934283000046],
              [162.833119237, 57.383312181000065],
              [162.80019579400005, 57.346434455000065],
              [162.78901683900006, 57.32652004100004],
              [162.776384614, 57.25514670000007],
              [162.7954395160001, 57.183505],
              [162.78589928500003, 57.14545319200005],
              [162.8173934250001, 57.09292226800005],
              [162.8598508450001, 57.051442541000085],
              [162.8431558110001, 57.017224586000054],
              [162.82056725400003, 56.969183661000045],
              [162.798955266, 56.94328297700008],
              [162.7895613940001, 56.921861070000034],
              [162.78589928500003, 56.85993073100008],
              [162.7900496750001, 56.82123444200005],
              [162.78350026600003, 56.763028714000086],
              [162.834629844, 56.72235241800007],
              [162.89087975400003, 56.716009833000044],
              [162.9145613940001, 56.70945872600004],
              [162.93669681100005, 56.70856354400007],
              [162.9671869120001, 56.70355994600004],
              [163.0156910180001, 56.725811124000074],
              [163.05651658700003, 56.732502725000074],
              [163.06851721100008, 56.741309210000054],
              [163.12573437600008, 56.727400945000056],
              [163.18613638400006, 56.73369828700004],
              [163.22761580400004, 56.742463626000074],
              [163.238968537, 56.73302051100006],
              [163.22584069100003, 56.72093333500004],
              [163.24333743600005, 56.71369049700007],
              [163.2519637380001, 56.698879299000055],
              [163.28057240200008, 56.688011773000085],
              [163.26388463600006, 56.66881167300005],
              [163.24672384000007, 56.64751939700005],
              [163.238712696, 56.62341543900004],
              [163.24097741000003, 56.59316640800006],
              [163.27847118400007, 56.563520683000036],
              [163.2610772280001, 56.54872121400007],
              [163.24698676100002, 56.531536896000034],
              [163.25220787900003, 56.51585521000004],
              [163.26514733200008, 56.48859284100007],
              [163.272507443, 56.47971036600006],
              [163.28143646400008, 56.472364087000074],
              [163.27888941000003, 56.46217663600004],
              [163.26042363400006, 56.45837939200004],
              [163.25025475400003, 56.45111725500004],
              [163.25569271200004, 56.43946227300006],
              [163.26803948500003, 56.429630289000045],
              [163.28032547600003, 56.424989280000034],
              [163.29956211, 56.39979394000005],
              [163.33855228000004, 56.35529205900008],
              [163.3408309250001, 56.345404364000046],
              [163.34666079300007, 56.33329476500006],
              [163.35328432300003, 56.32197948800007],
              [163.348718017, 56.29730709900008],
              [163.33689505200005, 56.27752432200003],
              [163.34205162900003, 56.23354726800005],
              [163.3496199880001, 56.221136786000045],
              [163.35309291700003, 56.19952861400009],
              [163.36606862300005, 56.18065866300003],
              [163.30796235100001, 56.16807601700003],
              [163.29363685700002, 56.14951423700006],
              [163.23042386600002, 56.14177583500003],
              [163.1762801440001, 56.13312409100007],
              [163.13103274800005, 56.10993073100008],
              [163.11793053500003, 56.10643138200004],
              [163.11117597700002, 56.10150788000004],
              [163.10368899800005, 56.09003327000005],
              [163.09734134200005, 56.077337958000044],
              [163.09498131600003, 56.06826406500005],
              [163.08936608200008, 56.06297435100004],
              [163.06808409100006, 56.044215834000056],
              [163.053173367, 56.02753392300008],
              [163.05120846300008, 56.00540399300007],
              [162.99319513600005, 56.01062576000004],
              [162.93078402800006, 56.01790373300008],
              [162.88599694100003, 56.04165273600006],
              [162.856781446, 56.04975006700005],
              [162.82161808400008, 56.05619883800006],
              [162.7739363940001, 56.09365469000005],
              [162.7542531580001, 56.10830804500006],
              [162.73826897000004, 56.14952244700004],
              [162.6904403000001, 56.17145416900007],
              [162.63802459300007, 56.22079404600004],
              [162.58350670700008, 56.22483958500004],
              [162.55681399800005, 56.228501695000034],
              [162.58155358200008, 56.233587958000044],
              [162.6093856130001, 56.239447333000044],
              [162.64461114100004, 56.243368057000055],
              [162.67858567400003, 56.257066],
              [162.70687729600002, 56.27115451200007],
              [162.7248207130001, 56.29022285500008],
              [162.74165334600002, 56.312561781000056],
              [162.74660633500002, 56.33362043300008],
              [162.753632111, 56.34703601400008],
              [162.79440746, 56.355870365000044],
              [162.87251276200004, 56.358756190000065],
              [162.93992090300003, 56.38168989800005],
              [162.94391812900005, 56.40604395400004],
              [163.00018717900002, 56.438354469000046],
              [163.05820178500005, 56.44585045700006],
              [163.085129199, 56.46100179400008],
              [163.11605243200006, 56.50050429500004],
              [163.100824902, 56.517721186000074],
              [163.04334875300003, 56.52092724000005],
              [163.0201332050001, 56.53764086800004],
              [162.98994853, 56.53343412600003],
              [162.95846822600004, 56.499316268000086],
              [162.942609899, 56.44902827400006],
              [162.909901772, 56.42569068600005],
              [162.83871504, 56.448919989000046],
              [162.74018687500006, 56.479778757000076],
              [162.68294384600006, 56.48386681100004],
              [162.65066867400003, 56.47009898200008],
              [162.6281151830001, 56.439562049000074],
              [162.57300866000003, 56.42682526200008],
              [162.55681399800005, 56.42914459800005],
              [162.54127037900003, 56.437160549000055],
              [162.52507571700005, 56.44220612200007],
              [162.5117293630001, 56.440619208000044],
              [162.49968509200005, 56.43545156500005],
              [162.47803795700008, 56.421128648000035],
              [162.47046959700003, 56.414496161000045],
              [162.46314537900003, 56.40619538000004],
              [162.454437696, 56.398504950000074],
              [162.44263756600003, 56.393784898000035],
              [162.42945397200003, 56.39402903900003],
              [162.41404181200005, 56.38387026500004],
              [162.401189435, 56.36976469500007],
              [162.4822687090001, 56.335198286000036],
              [162.526467422, 56.32567415400007],
              [162.53663170700008, 56.30573151200008],
              [162.55884850400003, 56.28888580900008],
              [162.592540354, 56.26849002800009],
              [162.5768382, 56.25886721400008],
              [162.55996266700004, 56.25255465300006],
              [162.52906334700003, 56.24787018400008],
              [162.518890821, 56.24298737200007],
              [162.49586142600003, 56.24205817200004],
              [162.48991136300003, 56.23282583800005],
              [162.48821847300007, 56.21686065200004],
              [162.442718946, 56.21234772300005],
              [162.422699415, 56.204738674000055],
              [162.3658772130001, 56.18676611300003],
              [162.27444813400007, 56.16515394400005],
              [162.176117384, 56.13666413000004],
              [162.16578209700003, 56.13312409100007],
              [162.14210045700008, 56.12905508000006],
              [162.1217284390001, 56.108385396000074],
              [162.09831659300005, 56.08860890400007],
              [162.05675236700006, 56.06913521800004],
              [162.04490241400003, 56.05837590600004],
              [162.04021243600005, 56.04547760600008],
              [162.04851321700005, 56.03758372600004],
              [162.07692906800003, 56.022471556000085],
              [162.05556935800007, 56.00435336600003],
              [162.0180770190001, 55.97614166900007],
              [162.01933367100003, 55.93124987600004],
              [161.96889410400001, 55.895180793000065],
              [161.9488452820001, 55.85293756400006],
              [161.92096476400002, 55.82549089300005],
              [161.9253382180001, 55.79401693900007],
              [161.89092741900004, 55.75142887800007],
              [161.8406344880001, 55.702639728000065],
              [161.80849974800003, 55.65380079000005],
              [161.79505736700003, 55.62752214000005],
              [161.7770811150001, 55.608326555000076],
              [161.76413117700008, 55.554845542000066],
              [161.76337882100006, 55.51188312600004],
              [161.74987280100004, 55.46522881700008],
              [161.74768552400008, 55.37595448600007],
              [161.7566764070001, 55.351593913000045],
              [161.771335755, 55.32573232200008],
              [161.77606339, 55.290327079000065],
              [161.79280856800005, 55.23600297100006],
              [161.812980583, 55.179183574000035],
              [161.84264852400008, 55.13070359500006],
              [161.87476647200003, 55.07859935100004],
              [161.9013778000001, 55.06110260600008],
              [161.96013431100005, 55.03461334800005],
              [161.98707116000003, 55.01312897300005],
              [162.046898436, 54.95648790200005],
              [162.04948744900003, 54.924283424000066],
              [162.07439212300005, 54.904364325000074],
              [162.12671959700003, 54.88117096600007],
              [162.151703321, 54.862616278000075],
              [162.153168165, 54.84992096600007],
              [162.13819420700008, 54.84056224200003],
              [162.11866295700008, 54.83270905200004],
              [162.1074324880001, 54.82469310100004],
              [162.1074324880001, 54.81281159100007],
              [162.12029056100005, 54.790676174000055],
              [162.1301472250001, 54.77241458800006],
              [162.127609226, 54.76040526500003],
              [162.10932285700005, 54.74293565000005],
              [162.08301895, 54.733520472000066],
              [162.065868367, 54.72908638500007],
              [162.04509524800005, 54.725775458000044],
              [162.03638756600003, 54.71832916900007],
              [162.009125196, 54.70229726800005],
              [162.00310306100005, 54.69525788000004],
              [161.99919681100005, 54.68695709800005],
              [161.99008222700002, 54.673895575000074],
              [161.9765731130001, 54.66250234600005],
              [161.9619246750001, 54.65643952000005],
              [161.94859699300002, 54.647255080000036],
              [161.921953507, 54.635989115000086],
              [161.87867272200003, 54.61969635600008],
              [161.86451256600003, 54.608710028000075],
              [161.8505965500001, 54.600897528000075],
              [161.8169051440001, 54.59052155200004],
              [161.80258222700002, 54.58144765800006],
              [161.77100670700008, 54.537095445000034],
              [161.75318444100003, 54.51976146000004],
              [161.72380618600005, 54.509426174000055],
              [161.706390821, 54.50800202000005],
              [161.68531334700003, 54.50877513200004],
              [161.66521243600005, 54.51251862200007],
              [161.65162194100003, 54.519964911000045],
              [161.63697350400003, 54.52570221600007],
              [161.57984459700003, 54.51626211100006],
              [161.47022545700008, 54.51557038000004],
              [161.3579207690001, 54.49323151200008],
              [161.311859571, 54.49013906500005],
              [161.28191165500004, 54.49884674700007],
              [161.26742597700002, 54.50820547100005],
              [161.23755944100003, 54.51788971600007],
              [161.2236434250001, 54.52993398600006],
              [161.21900475400003, 54.53969961100006],
              [161.21501712300005, 54.56110260600008],
              [161.2099715500001, 54.57078685100004],
              [161.1508895190001, 54.597316799000055],
              [161.0664168630001, 54.59682851800005],
              [160.89185631600003, 54.57078685100004],
              [160.7412215500001, 54.535223700000074],
              [160.73414147200003, 54.53164297100005],
              [160.72331790500004, 54.52366771000004],
              [160.5273543630001, 54.43740469000005],
              [160.48698978000004, 54.40704987200007],
              [160.4204207690001, 54.37836334800005],
              [160.33773847700002, 54.31679922100005],
              [160.2724715500001, 54.27838776200008],
              [160.25147545700008, 54.25800202000005],
              [160.2373153000001, 54.24872467700004],
              [160.21892337300005, 54.24201080900008],
              [160.16089928500003, 54.23505280200004],
              [160.11670983200008, 54.215725002000056],
              [160.05298912900003, 54.17572663000004],
              [160.00074303500003, 54.13108958500004],
              [159.99089603000004, 54.09788646000004],
              [159.95777428500003, 54.048488674000055],
              [159.9179793630001, 54.00535716400003],
              [159.90154056100005, 53.98187897300005],
              [159.844086134, 53.796942450000074],
              [159.84253991000003, 53.73981354400007],
              [159.86670983200008, 53.69448476800005],
              [159.8525496750001, 53.68744538000004],
              [159.84050540500004, 53.67926666900007],
              [159.81820722700002, 53.65965403900003],
              [159.844086134, 53.65131256700005],
              [159.8730574880001, 53.63422272300005],
              [159.8989363940001, 53.612616278000075],
              [159.9145613940001, 53.59076569200005],
              [159.91871178500003, 53.61074453300006],
              [159.90495853000004, 53.630113023000035],
              [159.88550866000003, 53.64883047100005],
              [159.87289472700002, 53.66648997600004],
              [159.90308678500003, 53.673041083000044],
              [159.9306746750001, 53.64508698100008],
              [159.9692488940001, 53.570298570000034],
              [159.95777428500003, 53.55451080900008],
              [159.96045983200008, 53.49677155200004],
              [159.94874108200008, 53.47475820500006],
              [159.92017662900003, 53.47557200700004],
              [159.88005618600005, 53.49359772300005],
              [159.843109571, 53.51748281500005],
              [159.825043165, 53.53620026200008],
              [159.81609134200005, 53.53270091400003],
              [159.80738366000003, 53.52838776200008],
              [159.799164259, 53.52301666900007],
              [159.7910262380001, 53.51630280200004],
              [159.8076278000001, 53.51032135600008],
              [159.8154403000001, 53.501166083000044],
              [159.81234785200002, 53.49091217700004],
              [159.79664147200003, 53.48151276200008],
              [159.81462649800005, 53.48224518400008],
              [159.831390821, 53.48476797100005],
              [159.84652754, 53.48383209800005],
              [159.8593856130001, 53.47475820500006],
              [159.860199415, 53.46816640800006],
              [159.85857181100005, 53.444240627000056],
              [159.8593856130001, 53.43374258000006],
              [159.86280358200008, 53.42226797100005],
              [159.86793053500003, 53.41054922100005],
              [159.875824415, 53.40013255400004],
              [159.8872176440001, 53.39276764500005],
              [159.90113366000003, 53.390611070000034],
              [159.92066491000003, 53.39695872600004],
              [159.9355574880001, 53.39276764500005],
              [159.92302493600005, 53.36542389500005],
              [159.92107181100005, 53.350490627000056],
              [159.928070509, 53.337591864000046],
              [159.944672071, 53.33413320500006],
              [159.96363366000003, 53.33588288000004],
              [159.97535241000003, 53.33161041900007],
              [159.9692488940001, 53.30963776200008],
              [159.95777428500003, 53.30117422100005],
              [159.9394637380001, 53.29352448100008],
              [159.9223738940001, 53.283636786000045],
              [159.9145613940001, 53.26862213700008],
              [159.92107181100005, 53.253566799000055],
              [159.9692488940001, 53.21466705900008],
              [159.96216881600003, 53.24437083500004],
              [159.9804793630001, 53.265611070000034],
              [160.00513756600003, 53.27407461100006],
              [160.0175887380001, 53.26520416900007],
              [160.01929772200003, 53.24192942900004],
              [160.0244246750001, 53.22089264500005],
              [160.02995853000004, 53.21010976800005],
              [160.03638756600003, 53.20156484600005],
              [160.03834069100003, 53.19236888200004],
              [160.0312606130001, 53.17987702000005],
              [160.05030358200008, 53.15843333500004],
              [160.05388431100005, 53.13930898600006],
              [160.0527449880001, 53.11981842700004],
              [160.0586043630001, 53.097357489000046],
              [160.0156356130001, 53.11542389500005],
              [160.00367272200003, 53.11473216400003],
              [159.99537194100003, 53.111761786000045],
              [159.98698978000004, 53.11078522300005],
              [159.96949303500003, 53.111029364000046],
              [159.96306399800005, 53.11322663000004],
              [159.9614363940001, 53.11863841400003],
              [159.96045983200008, 53.12547435100004],
              [159.9555770190001, 53.132066148000035],
              [159.93116295700008, 53.14594147300005],
              [159.79957116000003, 53.19037506700005],
              [159.7714949880001, 53.20359935100004],
              [159.7568465500001, 53.22089264500005],
              [159.76319420700008, 53.24241771000004],
              [159.7856551440001, 53.25771719000005],
              [159.81072024800005, 53.27008698100008],
              [159.825043165, 53.28294505400004],
              [159.78288821700005, 53.27411530200004],
              [159.764008009, 53.265611070000034],
              [159.73015384200005, 53.23899974200003],
              [159.71314537900003, 53.23647695500006],
              [159.69499759200005, 53.240668036000045],
              [159.67497806100005, 53.24819570500006],
              [159.63249759200005, 53.257147528000075],
              [159.5922957690001, 53.25421784100007],
              [159.47771243600005, 53.22943756700005],
              [159.461273634, 53.22296784100007],
              [159.4453231130001, 53.21088288000004],
              [159.41089928500003, 53.17682526200008],
              [159.38152103000004, 53.161769924000055],
              [159.3535262380001, 53.16461823100008],
              [159.3242293630001, 53.17279694200005],
              [159.29078209700003, 53.17373281500005],
              [159.27466881600003, 53.167629299000055],
              [159.24105879, 53.149603583000044],
              [159.22242272200003, 53.145738023000035],
              [159.2060653000001, 53.14427317900004],
              [159.16382897200003, 53.13491445500006],
              [159.003265821, 53.07684967700004],
              [158.87094160200002, 52.99677155200004],
              [158.73943118600005, 52.90330638200004],
              [158.70866946700005, 52.891791083000044],
              [158.69483483200008, 52.90924713700008],
              [158.6855574880001, 52.934027411000045],
              [158.668304884, 52.954006252000056],
              [158.65902754, 52.97296784100007],
              [158.67367597700002, 52.99494049700007],
              [158.65943444100003, 53.00242747600004],
              [158.61980228000004, 53.042669989000046],
              [158.59156334700003, 53.062160549000055],
              [158.57642662900003, 53.06785716400003],
              [158.557953321, 53.070013739000046],
              [158.53972415500004, 53.06875234600005],
              [158.53052819100003, 53.06500885600008],
              [158.52320397200003, 53.05878327000005],
              [158.51050866000003, 53.05019765800006],
              [158.49333743600005, 53.044134833000044],
              [158.45337975400003, 53.03461334800005],
              [158.437836134, 53.02533600500004],
              [158.42945397200003, 53.017564195000034],
              [158.41822350400003, 53.004787502000056],
              [158.4150496750001, 52.99274323100008],
              [158.431000196, 52.987494208000044],
              [158.45386803500003, 52.98346588700008],
              [158.45085696700005, 52.97333405200004],
              [158.436859571, 52.95994700700004],
              [158.42741946700005, 52.946519273000035],
              [158.4355574880001, 52.91974518400008],
              [158.46452884200005, 52.90721263200004],
              [158.5004988940001, 52.90412018400008],
              [158.53044681100005, 52.905585028000075],
              [158.52312259200005, 52.916896877000056],
              [158.51050866000003, 52.92552317900004],
              [158.48267662900003, 52.940334377000056],
              [158.506195509, 52.94745514500005],
              [158.53199303500003, 52.94415924700007],
              [158.55779056100005, 52.93732330900008],
              [158.58187910200002, 52.93349844000005],
              [158.60816491000003, 52.93227773600006],
              [158.62256920700008, 52.92731354400007],
              [158.63298587300005, 52.91697825700004],
              [158.64714603000004, 52.89935944200005],
              [158.63746178500003, 52.89142487200007],
              [158.62769616000003, 52.88544342700004],
              [158.61744225400003, 52.88117096600007],
              [158.60621178500003, 52.878241278000075],
              [158.62256920700008, 52.86542389500005],
              [158.62842858200008, 52.85687897300005],
              [158.62476647200003, 52.848822333000044],
              [158.61304772200003, 52.83730703300006],
              [158.592133009, 52.82330963700008],
              [158.57789147200003, 52.824652411000045],
              [158.56421959700003, 52.83234284100007],
              [158.54468834700003, 52.83730703300006],
              [158.56364993600005, 52.80353424700007],
              [158.56519616000003, 52.79572174700007],
              [158.5532332690001, 52.78790924700007],
              [158.51319420700008, 52.78412506700005],
              [158.49976647200003, 52.778957424000055],
              [158.4951278000001, 52.75873444200005],
              [158.5156356130001, 52.74632396000004],
              [158.54615319100003, 52.74079010600008],
              [158.5712996750001, 52.74103424700007],
              [158.5708113940001, 52.73379140800006],
              [158.59099368600005, 52.72329336100006],
              [158.59937584700003, 52.713771877000056],
              [158.6015731130001, 52.70148346600007],
              [158.59782962300005, 52.69245026200008],
              [158.58773847700002, 52.68732330900008],
              [158.5712996750001, 52.68707916900007],
              [158.57585696700005, 52.66754791900007],
              [158.56470787900003, 52.647365627000056],
              [158.5449324880001, 52.63153717700004],
              [158.52361087300005, 52.624986070000034],
              [158.50043947100005, 52.62131502900007],
              [158.465935284, 52.63591756900007],
              [158.42741946700005, 52.65228913000004],
              [158.42115319100003, 52.65912506700005],
              [158.4248153000001, 52.64740631700005],
              [158.43083743600005, 52.63662344000005],
              [158.43873131600003, 52.626613674000055],
              [158.44849694100003, 52.61758047100005],
              [158.428091666, 52.601383912000074],
              [158.42733384300004, 52.593767798000044],
              [158.4608048240001, 52.574698656000066],
              [158.49305280600004, 52.57226431100008],
              [158.52361087300005, 52.570379950000074],
              [158.52556399800005, 52.562201239000046],
              [158.52312259200005, 52.55263906500005],
              [158.51677493600005, 52.53620026200008],
              [158.51734459700003, 52.524725653000075],
              [158.51905358200008, 52.516506252000056],
              [158.5161238940001, 52.509466864000046],
              [158.50318444100003, 52.50153229400007],
              [158.52320397200003, 52.490301825000074],
              [158.53044681100005, 52.48786041900007],
              [158.51905358200008, 52.47687409100007],
              [158.47803795700008, 52.46792226800005],
              [158.46208743600005, 52.46051666900007],
              [158.46070397200003, 52.45490143400008],
              [158.463226759, 52.43846263200004],
              [158.46208743600005, 52.43256256700005],
              [158.4536238940001, 52.42649974200003],
              [158.43091881600003, 52.41889069200005],
              [158.42115319100003, 52.412095445000034],
              [158.4399520190001, 52.40729401200008],
              [158.46078535200002, 52.41461823100008],
              [158.4824324880001, 52.425767320000034],
              [158.50318444100003, 52.43256256700005],
              [158.52654056100005, 52.43036530200004],
              [158.5434676440001, 52.42072174700007],
              [158.5712996750001, 52.39166901200008],
              [158.55103600400003, 52.38572825700004],
              [158.52076256600003, 52.362209377000056],
              [158.50318444100003, 52.35809967700004],
              [158.51042728000004, 52.34715403900003],
              [158.52271569100003, 52.33828359600005],
              [158.53736412900003, 52.33234284100007],
              [158.55152428500003, 52.33022695500006],
              [158.5586043630001, 52.32485586100006],
              [158.55787194100003, 52.31305573100008],
              [158.55298912900003, 52.30141836100006],
              [158.547699415, 52.29604726800005],
              [158.535492384, 52.29205963700008],
              [158.50464928500003, 52.27358633000006],
              [158.48951256600003, 52.26813385600008],
              [158.42741946700005, 52.26813385600008],
              [158.4384871750001, 52.24331289300005],
              [158.41675866000003, 52.23383209800005],
              [158.39014733200008, 52.226223049000055],
              [158.38648522200003, 52.206691799000055],
              [158.39909915500004, 52.198431708000044],
              [158.41667728000004, 52.192572333000044],
              [158.42701256600003, 52.18427155200004],
              [158.41773522200003, 52.16876862200007],
              [158.3955184250001, 52.15497467700004],
              [158.38445071700005, 52.14590078300006],
              [158.37964928500003, 52.13467031500005],
              [158.3720809250001, 52.12958405200004],
              [158.33659915500004, 52.137884833000044],
              [158.32496178500003, 52.138373114000046],
              [158.31902103000004, 52.13031647300005],
              [158.316742384, 52.11969635600008],
              [158.31755618600005, 52.09739817900004],
              [158.31983483200008, 52.090277411000045],
              [158.3291121750001, 52.07990143400008],
              [158.33122806100005, 52.07318756700005],
              [158.32732181100005, 52.06712474200003],
              [158.3007918630001, 52.052720445000034],
              [158.29167728000004, 52.04287344000005],
              [158.28638756600003, 52.03424713700008],
              [158.28394616000003, 52.024603583000044],
              [158.28345787900003, 52.011419989000046],
              [158.28687584700003, 51.96751536700003],
              [158.26785189200007, 51.95023153800008],
              [158.2491890120001, 51.94220898400005],
              [158.21713100400007, 51.92487147300005],
              [158.20671634200005, 51.902044989000046],
              [158.19092858200008, 51.898138739000046],
              [158.13110742800006, 51.851459857000066],
              [158.12192709500005, 51.83203970500006],
              [158.11890709700003, 51.81622955900008],
              [158.10694420700008, 51.80898672100005],
              [158.02711022200003, 51.77610911700003],
              [158.01482181100005, 51.76601797100005],
              [158.00668379, 51.740301825000074],
              [157.99927819100003, 51.72801341400009],
              [157.98943118600005, 51.717962958000044],
              [157.96705162900003, 51.709051825000074],
              [157.95769290500004, 51.69757721600007],
              [157.9414168630001, 51.67226797100005],
              [157.9184676440001, 51.66083405200004],
              [157.9121199880001, 51.652329820000034],
              [157.920258009, 51.63743724200003],
              [157.91334069100003, 51.631293036000045],
              [157.88542728000004, 51.63613515800006],
              [157.85368899800005, 51.622381903000075],
              [157.82526756800007, 51.596955680000065],
              [157.80103593500007, 51.58910720100005],
              [157.75919243400006, 51.54398302900006],
              [157.712852418, 51.55003466000005],
              [157.67890732900003, 51.53812527700006],
              [157.6064559250001, 51.52606842700004],
              [157.53687584700003, 51.48607005400004],
              [157.4926863940001, 51.44009023600006],
              [157.47311353600003, 51.41111234400006],
              [157.48804772200003, 51.39052969000005],
              [157.47573820900004, 51.361473738000086],
              [157.4465378320001, 51.34789779000005],
              [157.38850420400001, 51.35131795400008],
              [157.35173587300005, 51.32965729400007],
              [157.306976759, 51.29523346600007],
              [157.2856551440001, 51.27252838700008],
              [157.27662194100003, 51.25112539300005],
              [157.263031446, 51.23773834800005],
              [157.2002059250001, 51.20661041900007],
              [157.14230174800002, 51.16732356700004],
              [157.09589118600002, 51.15321583100007],
              [157.0459090500001, 51.12360260600008],
              [156.96813944000007, 51.06919202900008],
              [156.92010480300007, 51.03303217600006],
              [156.87673144200005, 51.01872394800006],
              [156.851812687, 50.997448321000036],
              [156.83724561500003, 50.97770981300005],
              [156.8207303690001, 50.97085972800005],
              [156.8034391760001, 50.95392506500008],
              [156.78024952700002, 50.93622017000007],
              [156.74771295000005, 50.91048957000004],
              [156.71969750900007, 50.88645375100003],
              [156.6699884420001, 50.86391690900007],
              [156.658235246, 50.88260556800009],
              [156.69368583300002, 50.909203114000036],
              [156.76193729800002, 50.98443058500004],
              [156.77026961400009, 51.01813357600008],
              [156.75694235100002, 51.03591728500004],
              [156.76330793700004, 51.06233842800003],
              [156.761545361, 51.077973901000064],
              [156.74198021100005, 51.09043674600008],
              [156.70809358000008, 51.08770360500006],
              [156.70533287900003, 51.10301341400009],
              [156.7002059250001, 51.118394273000035],
              [156.71900356000003, 51.15707211500006],
              [156.72187403500004, 51.195482086000084],
              [156.69361412900003, 51.20990631700005],
              [156.6562606130001, 51.25112539300005],
              [156.64210045700008, 51.25836823100008],
              [156.5908309250001, 51.261379299000055],
              [156.57699629, 51.26508209800005],
              [156.5615340500001, 51.271185614000046],
              [156.5468856130001, 51.27944570500006],
              [156.535492384, 51.28925202000005],
              [156.52361087300005, 51.31150950700004],
              [156.52019290500004, 51.335638739000046],
              [156.5214949880001, 51.41128164300005],
              [156.5195418630001, 51.42291901200008],
              [156.5156356130001, 51.43268463700008],
              [156.51099694100003, 51.43813711100006],
              [156.49952233200008, 51.447333075000074],
              [156.4951278000001, 51.453111070000034],
              [156.49170983200008, 51.456284898000035],
              [156.48707116000003, 51.45734284100007],
              [156.48316491000003, 51.458970445000034],
              [156.48161868600005, 51.46369049700007],
              [156.4824324880001, 51.46629466400009],
              [156.48780358200008, 51.47361888200004],
              [156.481781446, 51.49628327000005],
              [156.48023522200003, 51.51654694200005],
              [156.48161868600005, 51.55927155200004],
              [156.4834090500001, 51.572251695000034],
              [156.49244225400003, 51.59369538000004],
              [156.4951278000001, 51.603949286000045],
              [156.4946395190001, 51.615668036000045],
              [156.48902428500003, 51.63532135600008],
              [156.48780358200008, 51.644964911000045],
              [156.50123131600003, 51.775051174000055],
              [156.48601321700005, 51.95766836100006],
              [156.43919187900008, 52.21603094800008],
              [156.3727751560001, 52.40462384300008],
              [156.350901529, 52.427954312000054],
              [156.33366946700005, 52.44916413000004],
              [156.30339603000004, 52.48094310100004],
              [156.29672285200002, 52.49233633000006],
              [156.2822371750001, 52.52944570500006],
              [156.294281446, 52.52948639500005],
              [156.30201256600003, 52.525458075000074],
              [156.3086043630001, 52.519964911000045],
              [156.31763756600003, 52.51512278900003],
              [156.33741295700008, 52.50153229400007],
              [156.34245853000004, 52.50096263200004],
              [156.34693444100003, 52.50275299700007],
              [156.3515731130001, 52.50385163000004],
              [156.35808353000004, 52.50153229400007],
              [156.37086022200003, 52.49005768400008],
              [156.37574303500003, 52.47846100500004],
              [156.375336134, 52.46466705900008],
              [156.37232506600003, 52.44684479400007],
              [156.39527428500003, 52.456366278000075],
              [156.41968834700003, 52.47174713700008],
              [156.438812696, 52.49087148600006],
              [156.446625196, 52.511419989000046],
              [156.43189537900003, 52.524603583000044],
              [156.3584090500001, 52.53074778900003],
              [156.33130944100003, 52.53620026200008],
              [156.30355879, 52.555121161000045],
              [156.29240586600008, 52.57332338500004],
              [156.26572583000006, 52.59817127300005],
              [156.25352067900008, 52.628388517000076],
              [156.2322174420001, 52.66451716800003],
              [156.16479472000003, 52.79866493500003],
              [156.11119584000005, 52.93542032800008],
              [156.09791100400003, 53.042669989000046],
              [156.05640709700003, 53.21466705900008],
              [156.05152428500003, 53.28497955900008],
              [156.03922422800008, 53.37062855600004],
              [155.986690306, 53.57687904800008],
              [155.97437584700003, 53.642645575000074],
              [155.97136478000004, 53.66010163000004],
              [155.9672074570001, 53.73180509400004],
              [155.96127861000002, 53.75187553600006],
              [155.9546826940001, 53.78610475000005],
              [155.93864993600005, 53.84471263200004],
              [155.93580162900003, 53.86517975500004],
              [155.91236412900003, 53.90615469000005],
              [155.88445071700005, 53.98183828300006],
              [155.88835696700005, 53.99876536700003],
              [155.88461347700002, 54.02407461100006],
              [155.87134850400003, 54.07123444200005],
              [155.80730228000004, 54.20343659100007],
              [155.72803795700008, 54.42682526200008],
              [155.63851972700002, 54.76947663000004],
              [155.64039147200003, 54.79193756700005],
              [155.645355665, 54.81150950700004],
              [155.6445418630001, 54.83152903900003],
              [155.6162215500001, 54.87368398600006],
              [155.61003665500004, 54.89492422100005],
              [155.551177167, 55.28420485200007],
              [155.553932143, 55.364602871000045],
              [155.566422246, 55.43301476100004],
              [155.58628674200008, 55.52093276100004],
              [155.604455894, 55.58157487900007],
              [155.62281334700003, 55.63922760600008],
              [155.65308678500003, 55.92133209800005],
              [155.6665145190001, 55.96185944200005],
              [155.68433678500003, 55.99433014500005],
              [155.68637129, 56.00653717700004],
              [155.68531334700003, 56.02806224200003],
              [155.68620853000004, 56.039129950000074],
              [155.689789259, 56.04751211100006],
              [155.71013431100005, 56.08148834800005],
              [155.72055097700002, 56.09218984600005],
              [155.7329207690001, 56.09796784100007],
              [155.745453321, 56.10114166900007],
              [155.75603274800005, 56.106675523000035],
              [155.762054884, 56.11945221600007],
              [155.7421981130001, 56.12669505400004],
              [155.74284915500004, 56.14590078300006],
              [155.75367272200003, 56.165676174000055],
              [155.76547285200002, 56.174709377000056],
              [155.78003991000003, 56.24750397300005],
              [155.8105574880001, 56.29075755400004],
              [155.9243270190001, 56.58454010600008],
              [155.9365340500001, 56.60236237200007],
              [155.94654381600003, 56.62189362200007],
              [155.98086486300008, 56.67049308300005],
              [156.00835735200008, 56.70883208400005],
              [156.04761599900007, 56.76509066400007],
              [156.12525475400003, 56.832017320000034],
              [156.1591903000001, 56.84446849200003],
              [156.17400149800005, 56.84585195500006],
              [156.1699324880001, 56.83576080900008],
              [156.0825301440001, 56.76707591400003],
              [156.06714928500003, 56.747381903000075],
              [156.06373131600003, 56.71596914300005],
              [156.082367384, 56.737941799000055],
              [156.121918165, 56.77496979400007],
              [156.14576256600003, 56.791083075000074],
              [156.195648634, 56.81476471600007],
              [156.20777428500003, 56.825832424000055],
              [156.211761915, 56.83808014500005],
              [156.2080184250001, 56.846136786000045],
              [156.20582116000003, 56.85431549700007],
              [156.23502242000006, 56.86660429300008],
              [156.27977596000005, 56.875680626000076],
              [156.31370214100002, 56.88572450300006],
              [156.38558248700008, 56.91175411200004],
              [156.4277422250001, 56.93016268800005],
              [156.46127480400003, 56.94840631500006],
              [156.47131837200004, 56.96273395400004],
              [156.5084891570001, 56.99518868000007],
              [156.530361083, 57.02116264600005],
              [156.53077354200002, 57.05425134200004],
              [156.53581790500004, 57.08844635600008],
              [156.552093946, 57.10895416900007],
              [156.5732528000001, 57.113714911000045],
              [156.5942488940001, 57.093003648000035],
              [156.60515384200005, 57.08584219000005],
              [156.64087975400003, 57.08258698100008],
              [156.6562606130001, 57.07591380400004],
              [156.66814212300005, 57.054754950000074],
              [156.67546634200005, 57.046210028000075],
              [156.68384850400003, 57.04832591400003],
              [156.71802819100003, 57.08274974200003],
              [156.71900475400003, 57.09088776200008],
              [156.72580391400004, 57.10574912200008],
              [156.72968623100007, 57.115247182000076],
              [156.7484909530001, 57.13086745900006],
              [156.76936884200006, 57.14887139500007],
              [156.83161576600003, 57.21345099100006],
              [156.879174045, 57.269518453000046],
              [156.92879261100006, 57.33147288100008],
              [156.97649064200004, 57.39101634000008],
              [157.00128759100005, 57.42550531100005],
              [156.99105879, 57.456366278000075],
              [156.97771243600005, 57.546087958000044],
              [156.94703209700003, 57.60732656500005],
              [156.937836134, 57.64716217700004],
              [156.9306746750001, 57.65843333500004],
              [156.85499108200008, 57.72134023600006],
              [156.82007897200003, 57.735988674000055],
              [156.78305097700002, 57.739894924000055],
              [156.7490340500001, 57.72955963700008],
              [156.80103600400003, 57.77338288000004],
              [156.9814559250001, 57.857123114000046],
              [156.99756920700008, 57.85614655200004],
              [157.01197350400003, 57.84284088700008],
              [157.03638756600003, 57.81268952000005],
              [157.05103600400003, 57.80508047100005],
              [157.24187259200005, 57.77049388200004],
              [157.31006920700008, 57.77122630400004],
              [157.39185631600003, 57.78119538000004],
              [157.46989993600005, 57.803941148000035],
              [157.526703321, 57.84316640800006],
              [157.55738366000003, 57.87641022300005],
              [157.56462649800005, 57.88784414300005],
              [157.5669051440001, 57.897691148000035],
              [157.56788170700008, 57.919256903000075],
              [157.57007897200003, 57.92877838700008],
              [157.58668053500003, 57.95111725500004],
              [157.63266035200002, 57.98383209800005],
              [157.6533309250001, 58.003892320000034],
              [157.64918053500003, 58.00926341400003],
              [157.643890821, 58.01976146000004],
              [157.6396590500001, 58.02496979400007],
              [157.69507897200003, 58.02728913000004],
              [157.7231551440001, 58.024603583000044],
              [157.7656356130001, 58.00307851800005],
              [157.78931725400003, 57.996527411000045],
              [157.94703209700003, 57.98309967700004],
              [158.05689537900003, 57.990220445000034],
              [158.1679793630001, 58.020738023000035],
              [158.2246199880001, 58.025458075000074],
              [158.27662194100003, 58.003892320000034],
              [158.3037215500001, 57.97011953300006],
              [158.32097415500004, 57.954413153000075],
              [158.338226759, 57.95302969000005],
              [158.34555097700002, 57.96735260600008],
              [158.32984459700003, 57.98322174700007],
              [158.29078209700003, 58.003892320000034],
              [158.295258009, 58.02484772300005],
              [158.2778426440001, 58.03506094000005],
              [158.25123131600003, 58.038397528000075],
              [158.22877037900003, 58.03864166900007],
              [158.24675540500004, 58.051988023000035],
              [158.31755618600005, 58.07957591400003],
              [158.3344832690001, 58.089178778000075],
              [158.41781660200002, 58.14911530200004],
              [158.54411868600005, 58.19969310100004],
              [158.6547957690001, 58.26943594000005],
              [158.783539259, 58.31297435100004],
              [158.85230553500003, 58.348822333000044],
              [158.89283287900003, 58.35765208500004],
              [158.94809004, 58.38812897300005],
              [159.023773634, 58.41478099200003],
              [159.1093856130001, 58.474595445000034],
              [159.137054884, 58.483628648000035],
              [159.14470462300005, 58.488348700000074],
              [159.14722741000003, 58.498480536000045],
              [159.15251712300005, 58.507879950000074],
              [159.16781660200002, 58.510972398000035],
              [159.18376712300005, 58.50608958500004],
              [159.19214928500003, 58.49713776200008],
              [159.19874108200008, 58.48663971600007],
              [159.20826256600003, 58.47748444200005],
              [159.22331790500004, 58.470404364000046],
              [159.23698978000004, 58.46784088700008],
              [159.2421981130001, 58.47260163000004],
              [159.23267662900003, 58.48737213700008],
              [159.21998131600003, 58.49445221600007],
              [159.20264733200008, 58.50018952000005],
              [159.1875106130001, 58.50804271000004],
              [159.18091881600003, 58.521551825000074],
              [159.193695509, 58.54197825700004],
              [159.36085045700008, 58.64402903900003],
              [159.38355553500003, 58.66551341400003],
              [159.40162194100003, 58.67804596600007],
              [159.4238387380001, 58.68406810100004],
              [159.495453321, 58.691839911000045],
              [159.50367272200003, 58.696600653000075],
              [159.5048934250001, 58.70164622600004],
              [159.50261478000004, 58.708685614000046],
              [159.49919681100005, 58.71466705900008],
              [159.49683678500003, 58.716457424000055],
              [159.5102645190001, 58.728583075000074],
              [159.54029381600003, 58.74408600500004],
              [159.55486087300005, 58.75429922100005],
              [159.5825301440001, 58.78204987200007],
              [159.60914147200003, 58.79865143400008],
              [159.61198978000004, 58.804673570000034],
              [159.6118270190001, 58.812160549000055],
              [159.61980228000004, 58.82632070500006],
              [159.63461347700002, 58.837958075000074],
              [159.6523543630001, 58.84369538000004],
              [159.67115319100003, 58.84760163000004],
              [159.68864993600005, 58.853583075000074],
              [159.707367384, 58.86562734600005],
              [159.72779381600003, 58.88304271000004],
              [159.74390709700003, 58.90387604400007],
              [159.75074303500003, 58.92560455900008],
              [159.7529403000001, 58.958197333000044],
              [159.75074303500003, 58.97089264500005],
              [159.74561608200008, 58.98094310100004],
              [159.73210696700005, 59.00055573100008],
              [159.72966556100005, 59.01129791900007],
              [159.7426863940001, 59.03139883000006],
              [159.7920028000001, 59.06753164300005],
              [159.793793165, 59.08388906500005],
              [159.80347741000003, 59.09638092700004],
              [159.86443118600005, 59.14057038000004],
              [160.1621199880001, 59.29376862200007],
              [160.1875106130001, 59.31150950700004],
              [160.19947350400003, 59.323146877000056],
              [160.21461022200003, 59.332464911000045],
              [160.235687696, 59.337591864000046],
              [160.27800540500004, 59.34023672100005],
              [160.31031334700003, 59.346136786000045],
              [160.336273634, 59.36107005400004],
              [160.44646243600005, 59.45526764500005],
              [160.45582116000003, 59.47402578300006],
              [160.458343946, 59.49843984600005],
              [160.46607506600003, 59.52106354400007],
              [160.4790145190001, 59.53986237200007],
              [160.49732506600003, 59.55247630400004],
              [160.5200301440001, 59.55996328300006],
              [160.5439559250001, 59.56427643400008],
              [160.59294681100005, 59.56679922100005],
              [160.6123153000001, 59.570379950000074],
              [160.6679793630001, 59.59467194200005],
              [160.80494225400003, 59.60537344000005],
              [160.84685306100005, 59.61798737200007],
              [160.87378991000003, 59.632147528000075],
              [160.926117384, 59.667181708000044],
              [160.965179884, 59.707464911000045],
              [160.97527103000004, 59.71507396000004],
              [160.99089603000004, 59.723822333000044],
              [161.01742597700002, 59.73126862200007],
              [161.02320397200003, 59.73541901200008],
              [161.03296959700003, 59.747259833000044],
              [161.03858483200008, 59.75177643400008],
              [161.05836022200003, 59.757513739000046],
              [161.078461134, 59.759019273000035],
              [161.09831790500004, 59.762884833000044],
              [161.191742384, 59.83038971600007],
              [161.28389595800002, 59.870533943000055],
              [161.3379012380001, 59.945298570000034],
              [161.4177242610001, 59.98220434500007],
              [161.466655284, 60.03223890700008],
              [161.5328486730001, 60.06761537700004],
              [161.56137129, 60.07245514500005],
              [161.57984459700003, 60.073919989000046],
              [161.593109571, 60.08112213700008],
              [161.65418614600003, 60.089464382000074],
              [161.71021569100003, 60.12384674700007],
              [161.745914308, 60.130111330000034],
              [161.78031726300003, 60.145126582000046],
              [161.897214502, 60.202960662000066],
              [161.936326388, 60.23647092900006],
              [161.94805044400005, 60.270097504000034],
              [161.94462539300002, 60.294524306000085],
              [161.93739822700002, 60.30355569900007],
              [161.9223738940001, 60.31346263200004],
              [161.89492886900007, 60.29753049200008],
              [161.89314403800006, 60.30310640600004],
              [161.9069680780001, 60.32727101800003],
              [161.9107220740001, 60.34892126400007],
              [161.9276959450001, 60.37289814800005],
              [161.9258069230001, 60.39723673700007],
              [161.938555114, 60.41678777200008],
              [161.994231722, 60.43060752000008],
              [162.12452233200008, 60.48501211100006],
              [162.16521243600005, 60.50185781500005],
              [162.18311608200008, 60.522365627000056],
              [162.20622806100005, 60.53803131700005],
              [162.347015821, 60.54995351800005],
              [162.36589603000004, 60.55516185100004],
              [162.40251712300005, 60.560614325000074],
              [162.43327884200005, 60.58071523600006],
              [162.4609481130001, 60.59446849200003],
              [162.4746199880001, 60.60488515800006],
              [162.50180097700002, 60.620794989000046],
              [162.53687584700003, 60.62645091400003],
              [162.57406660200002, 60.623032945000034],
              [162.60767662900003, 60.61172109600005],
              [162.6254988940001, 60.610581773000035],
              [162.65186608200008, 60.61554596600007],
              [162.67790774800005, 60.62372467700004],
              [162.71241295700008, 60.64215729400007],
              [162.75367272200003, 60.64594147300005],
              [162.76880944100003, 60.65302155200004],
              [162.81450773300003, 60.686311673000034],
              [162.86913250500004, 60.71009159400006],
              [162.8912254930001, 60.732026595000036],
              [162.8826240200001, 60.74119801000006],
              [162.888982543, 60.75248384300005],
              [162.91668833100005, 60.760006461000046],
              [162.9668113780001, 60.76757704500005],
              [163.02139804700005, 60.77951130400004],
              [163.052665048, 60.760199766000085],
              [163.09905031200003, 60.75468831300003],
              [163.12296475000005, 60.76554949900003],
              [163.10230612600003, 60.77712334800003],
              [163.1217942840001, 60.77813090400008],
              [163.17085031200008, 60.78178521600006],
              [163.183819664, 60.79339004600007],
              [163.1936584770001, 60.805210516000045],
              [163.2133865400001, 60.806969320000064],
              [163.2438861280001, 60.796255862000066],
              [163.2698893820001, 60.80303922000007],
              [163.32482050700003, 60.80466475900005],
              [163.345658801, 60.799292078000065],
              [163.333512508, 60.77982730700006],
              [163.31531905600002, 60.750624369000036],
              [163.2954207690001, 60.72846100500004],
              [163.314789259, 60.72174713700008],
              [163.3339949880001, 60.72500234600005],
              [163.340837137, 60.75039357300005],
              [163.35790653000004, 60.77029374700004],
              [163.38441846800004, 60.79500205900007],
              [163.39480637600002, 60.815134442000044],
              [163.41486515600002, 60.82113835100006],
              [163.436234206, 60.83151180700008],
              [163.46183075400006, 60.83564659100006],
              [163.491764686, 60.84389559200008],
              [163.538862988, 60.85832921700006],
              [163.58675323, 60.865282953000076],
              [163.61540916800004, 60.86915711600005],
              [163.65767900800006, 60.867577845000085],
              [163.699810254, 60.85558840300007],
              [163.72817300600002, 60.86838172500006],
              [163.75103960500007, 60.883058333000065],
              [163.75987887400004, 60.90173599000008],
              [163.7742630470001, 60.91852002200005],
              [163.75163821700005, 60.93040599200003],
              [163.73414147200003, 60.93854401200008],
              [163.685883009, 60.954779364000046],
              [163.60785308900006, 60.964815661000046],
              [163.5360395780001, 60.99077529500005],
              [163.515984517, 60.99516767400007],
              [163.48730334800007, 61.001664093000045],
              [163.530444623, 61.03275652700006],
              [163.559207324, 61.04704422000003],
              [163.6182050110001, 61.05915804300008],
              [163.631337744, 61.081979414000045],
              [163.6157332690001, 61.10488515800006],
              [163.62504155700003, 61.12107286600008],
              [163.64971057000002, 61.13118877900007],
              [163.66625650700007, 61.14485960800005],
              [163.76257341100006, 61.18694511600006],
              [163.90202884200005, 61.22687409100007],
              [163.91871178500003, 61.22915273600006],
              [163.93279056100005, 61.23529694200005],
              [163.94410241000003, 61.25259023600006],
              [163.94678795700008, 61.26581452000005],
              [163.94646243600005, 61.28978099200003],
              [163.95085696700005, 61.30097077000005],
              [164.004242384, 61.32656484600005],
              [164.02881920700008, 61.34662506700005],
              [164.02295983200008, 61.372381903000075],
              [163.9765731130001, 61.41974518400008],
              [163.95232181100005, 61.43451569200005],
              [163.87183678500003, 61.45209381700005],
              [163.84782962300005, 61.45286692900004],
              [163.82781009200005, 61.44773997600004],
              [163.81177819100003, 61.43935781500005],
              [163.796066128, 61.42174523600005],
              [163.77569297800005, 61.413206691000084],
              [163.759780846, 61.42897665000004],
              [163.75147545700008, 61.44330475500004],
              [163.7594941970001, 61.479000549000034],
              [163.80140265, 61.51980008800007],
              [163.8300887380001, 61.555853583000044],
              [163.8462020190001, 61.579779364000046],
              [163.84441165500004, 61.59833405200004],
              [163.85457209700007, 61.62583538100006],
              [163.86605657100006, 61.64652369600003],
              [163.90300891100003, 61.66075548900005],
              [163.93123427600005, 61.66792684900008],
              [163.98672916200007, 61.65926112800008],
              [164.01521406300003, 61.66716576200008],
              [164.04481533500007, 61.68343317700004],
              [164.056063472, 61.72260873200008],
              [164.06345031900003, 61.745132881000075],
              [164.06788170700008, 61.78587474200003],
              [164.06755618600005, 61.80744049700007],
              [164.06039472700002, 61.81867096600007],
              [164.04948978000004, 61.83120351800005],
              [164.04249108200008, 61.842962958000044],
              [164.05236383400006, 61.849857813000085],
              [164.062558996, 61.85604307600005],
              [164.078878777, 61.87095609100004],
              [164.08995686000003, 61.89470406800007],
              [164.09488332, 61.924335564000046],
              [164.08295175600006, 61.94256394900003],
              [164.08771782500003, 61.96687864800003],
              [164.07277428400005, 61.98107794300006],
              [164.07270525500007, 61.99570264600004],
              [164.08329025400008, 61.99805565300005],
              [164.1032486690001, 62.008988927000075],
              [164.10640413500005, 62.023293823000074],
              [164.103410554, 62.03883591600004],
              [164.09939516600002, 62.051474204000044],
              [164.09514208000007, 62.06328083800008],
              [164.09273549400007, 62.07573239300007],
              [164.079598927, 62.09050549300008],
              [164.083596951, 62.10252055500007],
              [164.100284203, 62.10824758700005],
              [164.126776252, 62.128656602000035],
              [164.11711940500004, 62.14394210800003],
              [164.107544436, 62.15461934800004],
              [164.10538335700005, 62.16784602800004],
              [164.125668571, 62.19404599500007],
              [164.11820447800005, 62.206124394000085],
              [164.1204180960001, 62.227489985000034],
              [164.1198756, 62.24060541100005],
              [164.12290077300008, 62.249613294000085],
              [164.1271944140001, 62.26237935100005],
              [164.14855011400005, 62.26695540600008],
              [164.16007473500008, 62.281502895000074],
              [164.19393686700005, 62.29568868800004],
              [164.2106705440001, 62.31242897900006],
              [164.24357761700003, 62.32797695100004],
              [164.2865276440001, 62.332495287000086],
              [164.337095019, 62.342890251000085],
              [164.41806134800004, 62.35348348300005],
              [164.44250879000003, 62.38377397600004],
              [164.4554539730001, 62.404692570000066],
              [164.50254444400002, 62.412681974000066],
              [164.51234856000008, 62.43252454700007],
              [164.53831287000003, 62.45110951400005],
              [164.59337150300007, 62.449568674000034],
              [164.639770807, 62.46277170900004],
              [164.73902960500004, 62.46036739300007],
              [164.86280358200008, 62.43378327000005],
              [164.902791395, 62.41739491000004],
              [164.94770394400007, 62.40928021600007],
              [164.988420259, 62.40304168800003],
              [165.05447029000004, 62.402469705000044],
              [165.104352952, 62.40311696800006],
              [165.17964242200003, 62.37873845900003],
              [165.22543379, 62.382879950000074],
              [165.2373153000001, 62.37653229400007],
              [165.26677493600005, 62.33502838700008],
              [165.2812606130001, 62.32656484600005],
              [165.2968856130001, 62.32257721600007],
              [165.31617272200003, 62.324204820000034],
              [165.30730228000004, 62.33665599200003],
              [165.300140821, 62.35268789300005],
              [165.28728274800005, 62.366115627000056],
              [165.23055828000008, 62.395341235000046],
              [165.18135830300002, 62.40541190500005],
              [165.11087532400006, 62.42941558600006],
              [165.1237820560001, 62.45061397300003],
              [165.1701267520001, 62.45919653100003],
              [165.2667106350001, 62.461972564000064],
              [165.38729848000003, 62.46591973300008],
              [165.44851184900006, 62.45181710600008],
              [165.595062696, 62.44350820500006],
              [165.62761478000004, 62.444525458000044],
              [165.6508895190001, 62.45917389500005],
              [165.64340254, 62.45917389500005],
              [165.46875615200008, 62.470758551000074],
              [165.353717244, 62.486967889000084],
              [165.11002850300008, 62.48532579300007],
              [164.98115143500002, 62.51772518700005],
              [164.92826166300006, 62.53638233400005],
              [164.830624661, 62.551339958000085],
              [164.76565752500005, 62.55832329100008],
              [164.7070418630001, 62.589544989000046],
              [164.66773522200003, 62.63182200700004],
              [164.65162194100003, 62.640692450000074],
              [164.63404381600003, 62.64752838700008],
              [164.6162215500001, 62.65717194200005],
              [164.5979370660001, 62.67306541600004],
              [164.526021271, 62.67575213500004],
              [164.4469186880001, 62.68941884900005],
              [164.37463146700009, 62.690866490000076],
              [164.30826836800009, 62.66100804800004],
              [164.22972542700006, 62.66022241300004],
              [164.10650417700003, 62.65114425300004],
              [164.055126147, 62.656095813000036],
              [164.005787522, 62.633979638000085],
              [163.96218619400008, 62.620349531000045],
              [163.948372103, 62.59565319600006],
              [163.90840567500004, 62.584373612000036],
              [163.85936235500003, 62.60449907000003],
              [163.763869129, 62.60220069200005],
              [163.71890760500003, 62.59251502900008],
              [163.66974323, 62.586949986000036],
              [163.625739351, 62.588707216000046],
              [163.58239469, 62.574984405000066],
              [163.5238630670001, 62.55717364700007],
              [163.47553581900002, 62.545069537000074],
              [163.429693628, 62.56741073200004],
              [163.39893368000003, 62.575901669000075],
              [163.38758384000005, 62.54844947000004],
              [163.342142663, 62.54072130700007],
              [163.26705047000007, 62.52199464200004],
              [163.24982313300006, 62.507735410000066],
              [163.264340542, 62.48428384600004],
              [163.2688080050001, 62.465641781000045],
              [163.244098924, 62.447745541000074],
              [163.21278842800007, 62.44152271200005],
              [163.1850527050001, 62.442751257000054],
              [163.16773073000002, 62.43205473900008],
              [163.17653153000003, 62.419058739000036],
              [163.214249439, 62.42131668500008],
              [163.234814283, 62.41759862200007],
              [163.22946369400006, 62.40434943900004],
              [163.228589488, 62.38489401700008],
              [163.27751056700004, 62.37397391800005],
              [163.3021460770001, 62.375295522000044],
              [163.3228307930001, 62.36386628900004],
              [163.35169781700006, 62.35011161500006],
              [163.370212251, 62.34000160900007],
              [163.36891835100005, 62.32766953000004],
              [163.33985479500006, 62.32429414100005],
              [163.286748548, 62.32546949500005],
              [163.259485197, 62.31959614900006],
              [163.231523058, 62.31139896600007],
              [163.222992384, 62.30426666900007],
              [163.2247766050001, 62.29352059200005],
              [163.24133645900008, 62.28533103800004],
              [163.221243373, 62.273657048000075],
              [163.20344782400002, 62.27778850900006],
              [163.179264289, 62.27347211400007],
              [163.1356004700001, 62.25092726200006],
              [163.09148659700008, 62.22663806200006],
              [163.0869246750001, 62.21499258000006],
              [163.09009850400003, 62.20294830900008],
              [163.10474694100003, 62.16950104400007],
              [163.10808353000004, 62.15379466400003],
              [163.113617384, 62.145412502000056],
              [163.13795006600003, 62.132147528000075],
              [163.14210045700008, 62.122748114000046],
              [163.15040672600003, 62.11330247800004],
              [163.1476049480001, 62.10401327900007],
              [163.1203356320001, 62.09736984400007],
              [163.10107854300009, 62.09207637700007],
              [163.10502322000002, 62.07997117300005],
              [163.1227440140001, 62.06757853100004],
              [163.1762801440001, 62.06818268400008],
              [163.19312365400003, 62.066623191000076],
              [163.18628320800008, 62.05231449100006],
              [163.16508146400008, 62.04480338900004],
              [163.14778897300005, 62.03763795900005],
              [163.1424044370001, 62.019702023000036],
              [163.13769169800003, 62.00819810100006],
              [163.12590700300007, 61.99831037200005],
              [163.11926050700004, 61.98871407300004],
              [163.09450650400004, 61.97321866400006],
              [163.06865832200003, 61.96662123500005],
              [163.08017639800005, 61.954659390000074],
              [163.06709701900002, 61.93601880300008],
              [163.0428697540001, 61.93051299000007],
              [163.02624276200004, 61.92097114500007],
              [163.04420006600003, 61.92169830900008],
              [163.06405455100003, 61.91732188800006],
              [163.0583823610001, 61.89819857200007],
              [163.03099075900002, 61.873411187000045],
              [163.0260284740001, 61.85660332300006],
              [163.01578889400002, 61.84309736900008],
              [163.00030482700004, 61.828752017000056],
              [162.97839758400005, 61.80950880600005],
              [162.97673416600003, 61.79957036900004],
              [162.99084206100008, 61.788006059000054],
              [163.02711022200003, 61.77570221600007],
              [163.10649958300007, 61.75687874800008],
              [163.128875236, 61.75654823000008],
              [163.14517149100004, 61.74424491700006],
              [163.23878751200004, 61.73547689500003],
              [163.2994818410001, 61.721279795000044],
              [163.324797408, 61.71044507100004],
              [163.34338702500008, 61.70568605300008],
              [163.3219729120001, 61.69338672200007],
              [163.3218007050001, 61.675789777000034],
              [163.326549085, 61.65785575400008],
              [163.29127668800004, 61.648911858000076],
              [163.24258047400008, 61.644488822000085],
              [163.22058286000004, 61.64180827300004],
              [163.20789906100003, 61.63676951900004],
              [163.20798697400005, 61.628534466000076],
              [163.22410712600004, 61.62394970200006],
              [163.230211565, 61.61111495800009],
              [163.205124523, 61.61458037500006],
              [163.19579600100008, 61.625214766000056],
              [163.16553795700008, 61.62995026200008],
              [163.13612435200002, 61.62558898300006],
              [163.11209676800001, 61.61592585600005],
              [163.08717434000005, 61.598717244000056],
              [163.07593834700003, 61.585150458000044],
              [163.08326256600003, 61.579779364000046],
              [163.1076166480001, 61.570855495000046],
              [163.10212430700005, 61.556444774000056],
              [163.112069141, 61.548096686000065],
              [163.044699928, 61.51712855900007],
              [163.01728361200003, 61.516584564000084],
              [162.98170006600003, 61.53685130400004],
              [162.96763619400008, 61.57182606200007],
              [162.95680781800002, 61.57727248300006],
              [162.92741113, 61.578623305000065],
              [162.907917257, 61.57991025200005],
              [162.90311896900005, 61.58907453200004],
              [162.91261139800008, 61.59611412900006],
              [162.90882207800007, 61.608737003000044],
              [162.89452626000002, 61.61085785200004],
              [162.87572660800004, 61.61033419700004],
              [162.85979835700005, 61.60253557100003],
              [162.86014456200007, 61.616675892000046],
              [162.87485193400005, 61.62456246800008],
              [162.89755670800002, 61.63427156600005],
              [162.93999578800003, 61.63908095900007],
              [162.943187836, 61.650097488000085],
              [162.93091881600003, 61.66828034100007],
              [162.9306746750001, 61.675482489000046],
              [162.87737219200005, 61.69439047000003],
              [162.83881723700006, 61.70757119800004],
              [162.80353128800004, 61.71099023800008],
              [162.7655787440001, 61.70510711700007],
              [162.698954415, 61.686222678000036],
              [162.6226667210001, 61.659068809000075],
              [162.631493557, 61.637245578000034],
              [162.679613034, 61.62240118600005],
              [162.74610925900004, 61.62410244900008],
              [162.76425872000004, 61.61348256300005],
              [162.77483995600005, 61.593885395000086],
              [162.67207616400003, 61.604551497000045],
              [162.601583646, 61.623758647000045],
              [162.538663401, 61.65249688800009],
              [162.502189133, 61.660078964000036],
              [162.4488364990001, 61.669838697000046],
              [162.41724694100003, 61.675848700000074],
              [162.4072371750001, 61.671942450000074],
              [162.38613609000004, 61.65891850300005],
              [162.37548693400004, 61.628879065000035],
              [162.35061010200002, 61.61504191900008],
              [162.31409458500002, 61.61782693500004],
              [162.2920028000001, 61.617621161000045],
              [162.30616295700008, 61.60138580900008],
              [162.32782279600008, 61.590454855000075],
              [162.29445209900007, 61.57712226600006],
              [162.2733503610001, 61.56307273400006],
              [162.25195771800009, 61.55256437700007],
              [162.2266675740001, 61.559956502000034],
              [162.21648196700005, 61.557847398000035],
              [162.21371504, 61.54547760600008],
              [162.22842195200008, 61.52451221500007],
              [162.215449002, 61.51291086900005],
              [162.1799745940001, 61.50501671500007],
              [162.16824823500008, 61.49334057400006],
              [162.15016126400008, 61.49501408800006],
              [162.139373341, 61.49624871800006],
              [162.13616770200008, 61.48406098700008],
              [162.115659037, 61.47173047500007],
              [162.10063038400006, 61.45671161000007],
              [162.1056329700001, 61.44756053200007],
              [162.09531701900005, 61.43638256100007],
              [162.060285368, 61.439074032000065],
              [162.04078209700003, 61.43610260600008],
              [162.0607392720001, 61.417204397000035],
              [162.02692989500008, 61.40090608100007],
              [161.9863902310001, 61.37261949700007],
              [161.93939026300006, 61.37655630000006],
              [161.924164259, 61.39101797100005],
              [161.90007571700005, 61.42747630400004],
              [161.88835696700005, 61.43073151200008],
              [161.88054446700005, 61.41819896000004],
              [161.8837996750001, 61.40192291900007],
              [161.88933353000004, 61.38458893400008],
              [161.91301846500005, 61.357294327000034],
              [161.89023062800004, 61.33551868500007],
              [161.86162649800008, 61.338966146000075],
              [161.84707394100008, 61.35924375600007],
              [161.8260551850001, 61.373437383000066],
              [161.807292642, 61.37220707200004],
              [161.8034599890001, 61.36182049200005],
              [161.80922602700002, 61.34558142000003],
              [161.79420347300004, 61.334627943000044],
              [161.802100311, 61.317111769000064],
              [161.77161561700007, 61.29822303900005],
              [161.692608253, 61.28623169200006],
              [161.656462831, 61.26884458900008],
              [161.64658059500005, 61.26351279100004],
              [161.63650847400004, 61.26230764200005],
              [161.61324859900003, 61.257129192000036],
              [161.595627497, 61.25517756900007],
              [161.59614238400002, 61.237495297000066],
              [161.60305607600003, 61.22591920600007],
              [161.59385149800005, 61.20817038700005],
              [161.581015472, 61.20064262500006],
              [161.5799715820001, 61.19127367400006],
              [161.56714538300002, 61.18374418500008],
              [161.54604004300006, 61.19258526900006],
              [161.5247405880001, 61.19554240800005],
              [161.505813063, 61.19778225200008],
              [161.4874756160001, 61.20234205400004],
              [161.4711951920001, 61.19559091700006],
              [161.4682984220001, 61.18396309500008],
              [161.46033710200004, 61.17143331700004],
              [161.44106083200006, 61.16191089800003],
              [161.41661930400005, 61.15621035300006],
              [161.41190641800006, 61.15175986400004],
              [161.43580162900003, 61.14272695500006],
              [161.4544108660001, 61.13640610200008],
              [161.44583613500004, 61.12096440600004],
              [161.41711331, 61.11785711200008],
              [161.39666264700008, 61.10894975700006],
              [161.29756609600008, 61.05596127800004],
              [161.26115487000004, 61.050888711000084],
              [161.23376836700004, 61.052999071000045],
              [161.2122422550001, 61.05418989600008],
              [161.208186726, 61.04732388000008],
              [161.21507002400006, 61.03569603600005],
              [161.20454755000003, 61.022079620000056],
              [161.18209242, 61.01443061400005],
              [161.18357358600008, 60.99260704200003],
              [161.1346463550001, 60.97095547200007],
              [161.04145523, 60.94212178100008],
              [161.01173700100003, 60.93002428500006],
              [160.9782533030001, 60.90944089800007],
              [160.95087413600004, 60.90084015700006],
              [160.91514924400008, 60.89964503200008],
              [160.91122269100003, 60.881054118000066],
              [160.90196668400006, 60.86036449800008],
              [160.8718704580001, 60.848209275000045],
              [160.8471945240001, 60.81360341200008],
              [160.83265232100007, 60.77976055100004],
              [160.8284889360001, 60.75466130500007],
              [160.79647536100003, 60.74689047800007],
              [160.79144870200003, 60.73419663300007],
              [160.79162375200008, 60.717700269000034],
              [160.76566008500004, 60.72789966700003],
              [160.737456426, 60.731097280000085],
              [160.72001718900003, 60.751378988000056],
              [160.68675704300006, 60.76011231400008],
              [160.660934106, 60.752615766000076],
              [160.64170256500006, 60.73357611000006],
              [160.63587898700007, 60.71557702600006],
              [160.615288748, 60.71483603200005],
              [160.59961785500002, 60.72093495100006],
              [160.5807876340001, 60.72305341800006],
              [160.58003039000005, 60.73782886400005],
              [160.5590642850001, 60.74060699200004],
              [160.54319456500002, 60.73901662800006],
              [160.52785734600002, 60.72271133500004],
              [160.50071901900003, 60.71933925600007],
              [160.49336827900004, 60.706747154000084],
              [160.47018458900004, 60.69904675600009],
              [160.4385266280001, 60.702941552000084],
              [160.41031937600007, 60.70608607500009],
              [160.425836957, 60.729462278000085],
              [160.44293916700008, 60.74274452700007],
              [160.43101627600004, 60.74920412200004],
              [160.41532458100005, 60.742912568000065],
              [160.3979796760001, 60.73434717300006],
              [160.371617486, 60.72269247400004],
              [160.38179385900003, 60.70160571200006],
              [160.35758578700006, 60.65862019500008],
              [160.31864683800006, 60.649871714000085],
              [160.28899248900007, 60.63949319800008],
              [160.28764820900005, 60.626610860000085],
              [160.2818229940001, 60.609231253000075],
              [160.249343877, 60.60252125900007],
              [160.238404661, 60.58949710300004],
              [160.18593291500008, 60.578406234000056],
              [160.15439268300008, 60.57633613300004],
              [160.136078321, 60.60211823100008],
              [160.15969337400008, 60.64083152200004],
              [160.1496120170001, 60.65071267700006],
              [160.146998671, 60.66201063900007],
              [160.16422036200004, 60.664155564000055],
              [160.19599980200007, 60.660914966000064],
              [160.21962683900006, 60.665107945000045],
              [160.2145423500001, 60.675934357000074],
              [160.207805936, 60.68448278000005],
              [160.201862527, 60.69711010200007],
              [160.22007816500002, 60.71037402700006],
              [160.24481390100004, 60.713920226000084],
              [160.2337691890001, 60.72502246600004],
              [160.25141024000004, 60.73481168300003],
              [160.250165971, 60.74663386100008],
              [160.24268012900006, 60.757556340000065],
              [160.251685091, 60.772417637000046],
              [160.23143101800008, 60.79215764500003],
              [160.17009524800005, 60.82489655200004],
              [160.19742372200005, 60.82781986800006],
              [160.20540440900004, 60.83803416500007],
              [160.21776347900004, 60.845685669000034],
              [160.2324841840001, 60.83379581100007],
              [160.2537123730001, 60.82455028600003],
              [160.246086311, 60.854326161000074],
              [160.24148908300003, 60.87457707000004],
              [160.26813237300007, 60.89265822100003],
              [160.27212288300007, 60.900709987000084],
              [160.28154291500005, 60.90555549100009],
              [160.30429483, 60.90447862800005],
              [160.3265744360001, 60.90690143300009],
              [160.34235986500005, 60.90733435700008],
              [160.35752555600004, 60.91075495300004],
              [160.35279381600003, 60.92300039300005],
              [160.3534849, 60.94515616400008],
              [160.3734294310001, 60.96592930300005],
              [160.42487601800008, 60.98367803200006],
              [160.40767537400006, 61.00505097700005],
              [160.42128802800005, 61.019099244000074],
              [160.444214536, 61.03621952100008],
              [160.41274786600002, 61.03596668100005],
              [160.38639234900006, 61.037225549000084],
              [160.37182403500003, 61.043209851000086],
              [160.34915780200004, 61.03311112300008],
              [160.31792592500005, 61.03516963100003],
              [160.28063719700003, 61.01869649400004],
              [160.201973145, 61.03821996600004],
              [160.17251028200008, 61.03017485700008],
              [160.1305443130001, 61.020343694000076],
              [160.071858743, 61.00539355400008],
              [160.06383625500007, 60.99518378000005],
              [160.04729676400007, 60.984785833000046],
              [160.025356161, 60.984051022000074],
              [160.009388221, 60.970073667000065],
              [159.99845925400007, 60.963495530000046],
              [159.98180058000003, 60.96487377400007],
              [159.96635276300003, 60.96618706000004],
              [159.950515268, 60.959228185000086],
              [159.95733354800007, 60.95065971300005],
              [159.9506284900001, 60.940912499000035],
              [159.914917693, 60.944203540000046],
              [159.88534872700006, 60.941388810000035],
              [159.88830055300002, 60.931266389000086],
              [159.90400852200003, 60.92469789000006],
              [159.8986668660001, 60.91552652200005],
              [159.882641196, 60.913878932000046],
              [159.8637680180001, 60.922935185000085],
              [159.84434474400007, 60.92907346800007],
              [159.8279750810001, 60.932136498000034],
              [159.79753908300006, 60.931102543000065],
              [159.8070154730001, 60.93657166200006],
              [159.82849943300005, 60.941518973000086],
              [159.83458135500007, 60.95477343600004],
              [159.83848136000006, 60.969297389000076],
              [159.83048809900004, 60.978460435000045],
              [159.85309303100007, 60.98276623900006],
              [159.8794118730001, 60.99987298700006],
              [159.91506965600001, 61.02180632400007],
              [159.945096831, 61.04630382900007],
              [159.96811110200008, 61.058779359000084],
              [159.95218378700008, 61.07125520100004],
              [159.9695227200001, 61.079284647000065],
              [159.97632408900006, 61.096036025000046],
              [160.00014050000004, 61.10611751200008],
              [159.991410878, 61.12414236600006],
              [159.97486626600005, 61.13959133900005],
              [159.982140328, 61.15218694100008],
              [159.97293821100004, 61.16789063900006],
              [159.96338811300006, 61.18185998200005],
              [159.95206310700007, 61.19210676900008],
              [159.92737267500002, 61.203804104000085],
              [159.91819815200006, 61.21363801600006],
              [159.93544803700001, 61.22113729200004],
              [159.9562327330001, 61.22724702600004],
              [159.94329263100008, 61.24377388900007],
              [159.90772545700008, 61.259426174000055],
              [159.88473145900002, 61.256883680000044],
              [159.85549742700005, 61.25757233200005],
              [159.82273114500003, 61.232519807000074],
              [159.8035122980001, 61.24100308700008],
              [159.77561830500008, 61.24220566100007],
              [159.78867781200006, 61.253408739000065],
              [159.789717364, 61.26571929000005],
              [159.82761646000006, 61.27878555700005],
              [159.81852211400007, 61.28917825000008],
              [159.84357314500005, 61.29220986200005],
              [159.87290751600005, 61.292124612000066],
              [159.90863190100004, 61.29351967800005],
              [159.912159911, 61.28631311300006],
              [159.92318665100004, 61.279954140000086],
              [159.9636568530001, 61.27280935600004],
              [159.99638284900004, 61.284324292000065],
              [160.00399262200006, 61.292227843000035],
              [159.94374790900008, 61.297854414000085],
              [159.9101668630001, 61.31391022300005],
              [159.93230732300003, 61.32774473100005],
              [159.97247211500007, 61.33890865600006],
              [159.97350775100006, 61.357089149000046],
              [159.9652250270001, 61.37803625400005],
              [159.999244405, 61.38241432600006],
              [160.03564987700008, 61.38021356100006],
              [160.052543183, 61.378876105000074],
              [160.04941710700007, 61.387833406000084],
              [160.05092019300002, 61.39541031600004],
              [160.06857879300003, 61.40403267900007],
              [160.08444590400006, 61.40979284900004],
              [160.10685275700007, 61.429962523000086],
              [160.1061062990001, 61.444702987000085],
              [160.08805743800008, 61.45315794800007],
              [160.07150574900004, 61.45036568100005],
              [160.05149985100002, 61.44890419200004],
              [160.03351486200006, 61.451466114000084],
              [160.03498934900006, 61.45904615200004],
              [160.05434704200002, 61.46348231500008],
              [160.066833857, 61.47057954500008],
              [160.086297629, 61.47558854600004],
              [160.10122270600004, 61.482568133000086],
              [160.1149362660001, 61.48960161400004],
              [160.11323013000003, 61.49967912000005],
              [160.12937760300008, 61.50155317400004],
              [160.17109860800008, 61.50580101300005],
              [160.21747640400008, 61.51188389500004],
              [160.22915456200008, 61.52669861900006],
              [160.24633505300005, 61.53718741400007],
              [160.2851399870001, 61.55410723500006],
              [160.26697132900006, 61.56535777500005],
              [160.251227718, 61.575195102000066],
              [160.249231022, 61.58573037100007],
              [160.26307306700005, 61.59359742000004],
              [160.28482073400005, 61.60631138500008],
              [160.268429847, 61.62011015200005],
              [160.2598315460001, 61.62507038600006],
              [160.28851056400003, 61.630929001000084],
              [160.31295129900002, 61.644860840000035],
              [160.31879412900003, 61.66676993800007],
              [160.30707502200005, 61.68295728800007],
              [160.2720343430001, 61.68652298500007],
              [160.25905516800003, 61.69037821100005],
              [160.32753939300005, 61.71462279500008],
              [160.37832056600007, 61.746205564000036],
              [160.41395835100002, 61.764781215000085],
              [160.39728440600004, 61.77730985100004],
              [160.3992876110001, 61.79353666600008],
              [160.3854779080001, 61.80005552700004],
              [160.3681746750001, 61.800767320000034],
              [160.3619777680001, 61.81354353200004],
              [160.38882148200003, 61.82274936200008],
              [160.4002547, 61.83135352100004],
              [160.39552964300003, 61.84201325300006],
              [160.39353251900002, 61.85254480100008],
              [160.376315448, 61.85596290400008],
              [160.37408838200008, 61.86520423300004],
              [160.37133588100005, 61.87186160200008],
              [160.38173366, 61.87529458000006],
              [160.39128806100007, 61.88137730900007],
              [160.38429972300003, 61.88758081600008],
              [160.37424381900007, 61.899144507000074],
              [160.36638431100005, 61.90643952000005],
              [160.3632918630001, 61.91168854400007],
              [160.35621178500003, 61.914496161000045],
              [160.34595787900003, 61.91669342700004],
              [160.3418074880001, 61.93707916900007],
              [160.3457137380001, 61.94472890800006],
              [160.32883813900003, 61.94104469500007],
              [160.29515858000002, 61.939930169000036],
              [160.2684067140001, 61.92481741800003],
              [160.24080421300005, 61.918878290000066],
              [160.22508170800006, 61.90979820900009],
              [160.22350892100008, 61.90204195900009],
              [160.21845988300004, 61.89770038700004],
              [160.181624133, 61.88041563300004],
              [160.13241351300007, 61.87735834500006],
              [160.11093561100006, 61.866583895000076],
              [160.07437279700002, 61.85709383200003],
              [160.03901210200002, 61.84624622300004],
              [160.007610161, 61.81308437700005],
              [159.98477746600008, 61.788014289000046],
              [159.98103926600004, 61.775798577000046],
              [159.96672440400005, 61.75882770700008],
              [159.949943384, 61.757601468000075],
              [159.9479658890001, 61.74726270500008],
              [159.92712442100003, 61.731875642000034],
              [159.90589629500005, 61.728882988000066],
              [159.89833059600005, 61.71813410500005],
              [159.88074383000003, 61.70520802500005],
              [159.84290431500006, 61.708785454000065],
              [159.81112800100004, 61.71535095400009],
              [159.8055154980001, 61.722102616000086],
              [159.792544614, 61.711579888000074],
              [159.78764430700005, 61.70006280500007],
              [159.73906729500004, 61.70470559900008],
              [159.726204499, 61.70198508800007],
              [159.725149548, 61.711148189000085],
              [159.70772883000006, 61.72099172500003],
              [159.7030243160001, 61.702956260000065],
              [159.70798735800008, 61.685159103000046],
              [159.6836946410001, 61.68747438300005],
              [159.65265268300004, 61.682896320000054],
              [159.62486677800007, 61.67364031100004],
              [159.59440581, 61.66444975500008],
              [159.57721252500005, 61.652771070000085],
              [159.540949458, 61.66466263400008],
              [159.51941521600008, 61.67464796100006],
              [159.52103608200002, 61.68370904900007],
              [159.51165642500007, 61.70035418700007],
              [159.51260281600003, 61.713335638000046],
              [159.53024559200003, 61.71979339900008],
              [159.53985240100008, 61.73503032900004],
              [159.53526286600004, 61.75539244300006],
              [159.52927386200008, 61.768000406000056],
              [159.53651098300008, 61.78528391900005],
              [159.5469559400001, 61.80503790700004],
              [159.565585769, 61.816648017000034],
              [159.548269591, 61.81995135200003],
              [159.5302506390001, 61.819376814000066],
              [159.52451895000002, 61.81049709800004],
              [159.526066593, 61.79611685100008],
              [159.48548479800002, 61.79253453200005],
              [159.48637395800006, 61.78208486300008],
              [159.4775687030001, 61.76355885300006],
              [159.45253480200006, 61.77757149000007],
              [159.42759249000005, 61.78441499500008],
              [159.39921499500008, 61.79529353800007],
              [159.38060527800008, 61.81489673400006],
              [159.35606834300006, 61.81650585700004],
              [159.350909956, 61.826469383000074],
              [159.363573105, 61.82792962000008],
              [159.392226618, 61.833965324000076],
              [159.402489748, 61.853085082000064],
              [159.39401809600008, 61.87554579600004],
              [159.3598738940001, 61.893011786000045],
              [159.28789948100007, 61.90115929600006],
              [159.2122886840001, 61.911854848000075],
              [159.117795677, 61.91666008800007],
              [159.06519616000003, 61.916001695000034],
              [159.017914259, 61.915350653000075],
              [159.00025475400003, 61.90643952000005],
              [158.98585045700008, 61.90151601800005],
              [158.92074629, 61.90302155200004],
              [158.894867384, 61.89435455900008],
              [158.86491946700005, 61.87840403900003],
              [158.84498131600003, 61.858710028000075],
              [158.85303795700008, 61.82632070500006],
              [158.83716881600003, 61.82111237200007],
              [158.7978621750001, 61.82111237200007],
              [158.75402892300008, 61.821018894000076],
              [158.73608489700007, 61.832571243000075],
              [158.67427862, 61.834010428000056],
              [158.60521643200002, 61.83181586300003],
              [158.54849162100004, 61.830418518000045],
              [158.54456979300005, 61.82212281200003],
              [158.52059921300008, 61.798275372000035],
              [158.48498832100006, 61.78969764700008],
              [158.46363837900003, 61.804029625000055],
              [158.43615020000004, 61.81400440200008],
              [158.402914602, 61.82221944100007],
              [158.32374108200008, 61.827460028000075],
              [158.260226741, 61.82593385800004],
              [158.23077722300002, 61.81185621600008],
              [158.22902435700007, 61.79899907200007],
              [158.16911868600005, 61.76732005400004],
              [158.140050568, 61.77118606200008],
              [158.12009497600002, 61.75554858700008],
              [158.08016358100008, 61.733999544000085],
              [158.06343686600007, 61.74228584600007],
              [158.048746498, 61.74531533800007],
              [158.04061210700002, 61.73581479300003],
              [158.01880944100003, 61.73419830900008],
              [157.98900881100008, 61.739916968000045],
              [157.949956315, 61.74558793400007],
              [157.94086666500004, 61.760134066000035],
              [157.87975181500008, 61.76577279500003],
              [157.79365729200003, 61.781176558000084],
              [157.68765952400008, 61.78016085500008],
              [157.5373414930001, 61.79194583600008],
              [157.46450887100002, 61.782105424000065],
              [157.3932951600001, 61.745830408000074],
              [157.35654043, 61.714752943000065],
              [157.36711148400002, 61.696993372000065],
              [157.36464373800004, 61.68539352100004],
              [157.34343355800002, 61.680676764000054],
              [157.304012736, 61.69598937400008],
              [157.25660501200002, 61.69313491500009],
              [157.1837731280001, 61.673796060000086],
              [157.10182675400006, 61.66353654100004],
              [157.06284870900004, 61.65662248700005],
              [157.02759850400003, 61.65058014500005],
              [157.00878224300004, 61.63736547600007],
              [156.999311777, 61.612863479000055],
              [156.963599746, 61.584364967000056],
              [156.923833275, 61.55181318400008],
              [156.8478619450001, 61.52668181700005],
              [156.79785460900007, 61.515998515000035],
              [156.7475498670001, 61.52665187000008],
              [156.72231824300002, 61.52709980100008],
              [156.67946294500007, 61.524017068000035],
              [156.67042344900005, 61.51602696100008],
              [156.69329293700002, 61.512058308000064],
              [156.671150581, 61.49822382700006],
              [156.66167499000005, 61.482835596000086],
              [156.65967858200008, 61.464829820000034],
              [156.6489363940001, 61.44285716400003],
              [156.64210045700008, 61.43268463700008],
              [156.63168379, 61.423895575000074],
              [156.62379370600001, 61.37059138200004],
              [156.6461944360001, 61.34814202000007],
              [156.6485430030001, 61.32798487600007],
              [156.63627454000004, 61.310038002000056],
              [156.63168379, 61.29352448100008],
              [156.61987699100007, 61.27532768300006],
              [156.628737967, 61.268670770000085],
              [156.63185067400002, 61.25758205800008],
              [156.65145060700002, 61.25070656100007],
              [156.650595587, 61.22412596200007],
              [156.66291811400004, 61.21089165900008],
              [156.65497125800005, 61.19676019900004],
              [156.63568410000005, 61.191310187000056],
              [156.62531339300006, 61.196057300000064],
              [156.6236020880001, 61.20714427300004],
              [156.59976097100002, 61.212140531000045],
              [156.57820493100007, 61.21254215000005],
              [156.546888384, 61.20922558600006],
              [156.51906937, 61.19870515900004],
              [156.4553879770001, 61.177783512000076],
              [156.37389675500003, 61.148768450000034],
              [156.264335599, 61.08114622900007],
              [156.09117289000005, 61.00156668200003],
              [156.04520198900002, 60.97303276400004],
              [156.02992242300002, 60.94472706500005],
              [156.0076310390001, 60.949571733000084],
              [155.981820492, 60.924022930000035],
              [155.963671761, 60.93338411700006],
              [155.94305971300003, 60.92262906500008],
              [155.9726209810001, 60.904677304000074],
              [155.94059955900002, 60.880457972000045],
              [155.92964927700007, 60.87476995500003],
              [155.91677907000008, 60.859377976000076],
              [155.91989745500007, 60.847007932000054],
              [155.92294603100004, 60.83268521100007],
              [155.91397701800008, 60.81593794000008],
              [155.90537919000008, 60.806322255000055],
              [155.90338983800007, 60.79596152100004],
              [155.91074440700004, 60.786115222000035],
              [155.90991787200005, 60.773136487000045],
              [155.92073903200003, 60.754794496000045],
              [155.9158770570001, 60.74057498500008],
              [155.91362065400006, 60.70358311700005],
              [155.87584572900005, 60.71644882800007],
              [155.8685296440001, 60.727591688000075],
              [155.82984459700003, 60.72898997600004],
              [155.81812584700003, 60.72321198100008],
              [155.796234571, 60.70392487200007],
              [155.77881920700008, 60.69448476800005],
              [155.72482403700008, 60.655100376000064],
              [155.68012464800006, 60.657983253000054],
              [155.6651232490001, 60.64973049300005],
              [155.63180526000008, 60.642396656000074],
              [155.608423796, 60.63091447100004],
              [155.570962011, 60.625548663000075],
              [155.55527674400003, 60.61376252300005],
              [155.54065241600006, 60.59214889700007],
              [155.52811629200005, 60.59295317100003],
              [155.50798587300005, 60.59056224200003],
              [155.49207319000004, 60.58198156000003],
              [155.48690667000005, 60.57625877800007],
              [155.47891414700007, 60.563282299000036],
              [155.4747238550001, 60.555377013000054],
              [155.48123708100002, 60.54940964800005],
              [155.4800948740001, 60.54093289300005],
              [155.47977303300001, 60.53392386000007],
              [155.47301597400008, 60.53399948900005],
              [155.454091555, 60.53197008800004],
              [155.44898522200003, 60.522365627000056],
              [155.4414168630001, 60.519964911000045],
              [155.43151060700006, 60.51522206700008],
              [155.41025696000008, 60.52796692000004],
              [155.398348349, 60.529571659000055],
              [155.37509648700006, 60.52944471400008],
              [155.34028056400007, 60.52458236100006],
              [155.3000362250001, 60.51061899000007],
              [155.27531261600006, 60.49096586600007],
              [155.24059885300005, 60.48427792600006],
              [155.18435382500002, 60.437370556000076],
              [155.13759274000006, 60.41140989500008],
              [155.0313069130001, 60.38215560900005],
              [154.95240319100003, 60.36741771000004],
              [154.880938119, 60.320521848000055],
              [154.85948428300003, 60.30693891100003],
              [154.832506942, 60.29029351200006],
              [154.8136908680001, 60.271658011000056],
              [154.81751182200003, 60.284534498000085],
              [154.82445330500002, 60.29355471900004],
              [154.83325790100002, 60.30317278000007],
              [154.82099498600007, 60.30023217100006],
              [154.80423451900003, 60.288853406000044],
              [154.79957544700005, 60.274072371000045],
              [154.79360697100003, 60.25537018000006],
              [154.78288821700005, 60.24909088700008],
              [154.77523847700002, 60.238348700000074],
              [154.761078321, 60.228176174000055],
              [154.692119962, 60.201314161000084],
              [154.62086022200003, 60.135199286000045],
              [154.5356551440001, 60.052801825000074],
              [154.50972934800006, 60.02495554600006],
              [154.49040774800005, 59.97239817900004],
              [154.489458604, 59.96040268300004],
              [154.48758987500003, 59.94630657200008],
              [154.480532617, 59.95517579600005],
              [154.47915692000004, 59.97330741800005],
              [154.498975385, 60.02884848300005],
              [154.52672318400005, 60.059233489000064],
              [154.56369836200008, 60.09370475900005],
              [154.54800501300008, 60.097458171000085],
              [154.51157147100002, 60.09430420500007],
              [154.47338205100004, 60.084544709000056],
              [154.43359680100002, 60.07642916200007],
              [154.40783527300005, 60.062927667000054],
              [154.4066897890001, 60.03617303800007],
              [154.436815195, 60.007239654000045],
              [154.458715879, 59.983681509000064],
              [154.46671460200002, 59.967587266000066],
              [154.46178379700007, 59.94506569200007],
              [154.478435021, 59.923455655000055],
              [154.478851759, 59.90680573100008],
              [154.48780358200008, 59.89630768400008],
              [154.473480665, 59.879339911000045],
              [154.45196878600007, 59.87811802300007],
              [154.397797071, 59.84796784100007],
              [154.40308678500003, 59.86172109600005],
              [154.41138756600003, 59.87360260600008],
              [154.4326278000001, 59.89630768400008],
              [154.395843946, 59.902044989000046],
              [154.28071987600003, 59.89168275500003],
              [154.247157023, 59.885234671000035],
              [154.22077029800005, 59.869620187000066],
              [154.22845237600006, 59.84977354600005],
              [154.22326622100002, 59.82956457100005],
              [154.22174932100006, 59.81189975500007],
              [154.21546486700004, 59.78395505600008],
              [154.22445722700002, 59.75812409100007],
              [154.22877037900003, 59.73037344000005],
              [154.251320029, 59.699134739000044],
              [154.28871324800002, 59.66256362000007],
              [154.36117597700002, 59.58470286700003],
              [154.36825131600006, 59.574686270000086],
              [154.34589660000006, 59.58369174400008],
              [154.32352266400005, 59.60124382400005],
              [154.28580926900008, 59.62362655700008],
              [154.276159248, 59.650074275000065],
              [154.2418038090001, 59.66574055400008],
              [154.2200736100001, 59.66397628000004],
              [154.198578321, 59.63568756700005],
              [154.1958113940001, 59.626939195000034],
              [154.19499759200005, 59.60398997600004],
              [154.1923934250001, 59.59467194200005],
              [154.1966010320001, 59.58316679600006],
              [154.176832408, 59.56981993000005],
              [154.158621627, 59.56134515100007],
              [154.16146029200002, 59.55253723900006],
              [154.14928694800005, 59.536419539000065],
              [154.1094631530001, 59.539747258000034],
              [154.0910613960001, 59.53056944900004],
              [154.075043165, 59.50918203300006],
              [154.10279511300007, 59.48748530200004],
              [154.1237359170001, 59.47360846000004],
              [154.13843834700003, 59.45697663000004],
              [154.26378237000006, 59.43687767600005],
              [154.2978772040001, 59.44255329300006],
              [154.32077623400005, 59.45702204500003],
              [154.3418747720001, 59.474490625000044],
              [154.35388118800006, 59.48988445400005],
              [154.347015821, 59.499986070000034],
              [154.34693444100003, 59.50844961100006],
              [154.348480665, 59.516831773000035],
              [154.35694420700008, 59.525824286000045],
              [154.37427819100003, 59.532416083000044],
              [154.40231052500008, 59.53501503500007],
              [154.41032905500003, 59.520756163000044],
              [154.40990677700006, 59.50650832900004],
              [154.39820397200003, 59.489447333000044],
              [154.38599694100003, 59.47943756700005],
              [154.3798934250001, 59.470038153000075],
              [154.390961134, 59.46002838700008],
              [154.40545704800002, 59.44980393800006],
              [154.41968834700003, 59.43976471600007],
              [154.41920006600003, 59.43317291900007],
              [154.4268503730001, 59.420881577000046],
              [154.46386536300008, 59.41414853800006],
              [154.51585640500002, 59.410386379000045],
              [154.53677930000003, 59.42284058800004],
              [154.53270929000007, 59.43604403100005],
              [154.495453321, 59.44822825700004],
              [154.452484571, 59.46759674700007],
              [154.4360457690001, 59.48419830900008],
              [154.437250704, 59.508451378000075],
              [154.42652428500003, 59.534857489000046],
              [154.418304884, 59.54629140800006],
              [154.42876225700002, 59.54703399300007],
              [154.45730487600008, 59.539572314000054],
              [154.496058263, 59.52481663900005],
              [154.55412392800008, 59.51339871600004],
              [154.59243236700001, 59.522941039000045],
              [154.62989187800008, 59.53825736600004],
              [154.64428707000002, 59.54343440000008],
              [154.7374535250001, 59.490263567000056],
              [154.78295351200006, 59.471286242000076],
              [154.81203625, 59.470174125000085],
              [154.8418074880001, 59.475490627000056],
              [154.86202674900005, 59.46860325800009],
              [154.87759583700006, 59.46080965200008],
              [154.904964403, 59.46694893600005],
              [154.9187253670001, 59.47430067800008],
              [154.9230291020001, 59.486782825000034],
              [154.93680323500007, 59.494131691000064],
              [154.952997085, 59.496264093000036],
              [154.9629012380001, 59.496079820000034],
              [154.97868899800005, 59.490668036000045],
              [155.000844056, 59.48040838600008],
              [155.01494452200006, 59.47641341500008],
              [155.01171765700008, 59.45137682500007],
              [155.02335309900002, 59.43665715900005],
              [155.04753665500004, 59.42560455900008],
              [155.07211347700002, 59.40843333500004],
              [155.09734134200005, 59.39545319200005],
              [155.16675866000003, 59.379339911000045],
              [155.18873131600003, 59.36469147300005],
              [155.2097132140001, 59.34387954200008],
              [155.195574158, 59.33583594300006],
              [155.193371812, 59.32960990600009],
              [155.218685982, 59.31379126600007],
              [155.21575809900003, 59.30549306900008],
              [155.19774992700002, 59.30998808900006],
              [155.17732195600001, 59.308187462000035],
              [155.15762512600008, 59.29635834100009],
              [155.16048529400007, 59.28044391800006],
              [155.17139733200008, 59.26227448100008],
              [155.1971756590001, 59.237229321000086],
              [155.179021701, 59.225335037000036],
              [155.14960807600005, 59.22156873900008],
              [155.15544644800002, 59.21393292100004],
              [155.1655740660001, 59.20234272200008],
              [155.19410241000003, 59.175767320000034],
              [155.15845787900003, 59.179022528000075],
              [155.09147563600004, 59.190535484000065],
              [155.0556727280001, 59.19165253700004],
              [155.034267246, 59.18219201800008],
              [155.028604717, 59.17344969000004],
              [154.98181521000004, 59.186934018000045],
              [154.9363931270001, 59.192439086000036],
              [154.90503991000003, 59.18939850500004],
              [154.85735414500004, 59.18883027700008],
              [154.813301078, 59.19417212600007],
              [154.79923860000008, 59.18545233700007],
              [154.79303201200003, 59.17531899000005],
              [154.78514094800005, 59.15606246200008],
              [154.80487908400005, 59.132225712000036],
              [154.79069792200005, 59.13134748400006],
              [154.750536689, 59.139896314000055],
              [154.67751600400004, 59.145639144000086],
              [154.663016331, 59.15617735500007],
              [154.64145754600008, 59.162331891000065],
              [154.619522, 59.171376009000085],
              [154.600843844, 59.18224195800008],
              [154.58290776400008, 59.18665563900004],
              [154.57345538000004, 59.20027846100004],
              [154.501565357, 59.21788744600008],
              [154.438020693, 59.215520509000044],
              [154.39652581000007, 59.19557161700004],
              [154.3658504440001, 59.19534001000005],
              [154.332723095, 59.19175311500004],
              [154.34262746700006, 59.17951861200004],
              [154.345062696, 59.15570709800005],
              [154.3501082690001, 59.142238674000055],
              [154.35771027400006, 59.11058745000008],
              [154.34082187500007, 59.118433071000084],
              [154.328002362, 59.11311587000006],
              [154.30797482600008, 59.094158751000066],
              [154.27894267500005, 59.08592838800007],
              [154.24875680900004, 59.09132107600004],
              [154.1923934250001, 59.101263739000046],
              [154.164296552, 59.090678869000044],
              [154.085297071, 59.06134674700007],
              [154.04867597700002, 59.052801825000074],
              [154.0263778000001, 59.054388739000046],
              [154.00928795700008, 59.05853913000004],
              [153.97331790500004, 59.07330963700008],
              [153.95655358200008, 59.07758209800005],
              [153.92156009200005, 59.082098700000074],
              [153.90503991000003, 59.08698151200008],
              [153.87842858200008, 59.104722398000035],
              [153.82984459700003, 59.152777411000045],
              [153.80201256600003, 59.172308661000045],
              [153.76832116000003, 59.17963288000004],
              [153.6919747720001, 59.185061060000066],
              [153.69413988400004, 59.19729011800007],
              [153.70387696, 59.20429446400004],
              [153.7216417850001, 59.217656548000036],
              [153.75090457200008, 59.21853176900004],
              [153.76697617700006, 59.231247615000086],
              [153.76855655300005, 59.24658337900007],
              [153.7186515200001, 59.22794420900004],
              [153.6966335740001, 59.225740158000065],
              [153.66939208200006, 59.19607115100007],
              [153.64802394900005, 59.19077105700006],
              [153.603608743, 59.19972300500007],
              [153.581223937, 59.21624862600004],
              [153.54672792400004, 59.22287388600006],
              [153.49524235900003, 59.23371639000004],
              [153.4442054440001, 59.23095198200008],
              [153.4047957690001, 59.23663971600007],
              [153.3691512380001, 59.24127838700008],
              [153.3644630550001, 59.22839760800008],
              [153.37094042800004, 59.20933775600008],
              [153.3574171580001, 59.17388645400007],
              [153.34838997500003, 59.15362505100006],
              [153.3154403000001, 59.15302155200004],
              [153.29997806100005, 59.15249258000006],
              [153.283539259, 59.14899323100008],
              [153.284232857, 59.131324050000046],
              [153.3003212440001, 59.12930868800004],
              [153.32635043800008, 59.140531002000046],
              [153.35022026700005, 59.13401983700004],
              [153.35568007100005, 59.11647530100004],
              [153.34766074000004, 59.10464556900007],
              [153.33727527500002, 59.08988693900005],
              [153.26796991600008, 59.08589441200007],
              [153.22078779800006, 59.090294861000075],
              [153.16585324300002, 59.08360139900003],
              [153.09009992400001, 59.08309410500004],
              [153.03436937100003, 59.06784064400006],
              [153.00670778000006, 59.06056500600005],
              [152.99511310700007, 59.04668832500005],
              [152.9886073350001, 59.02931048900007],
              [152.97086836100004, 59.019746386000065],
              [152.94331567100005, 59.007020595000085],
              [152.9392406510001, 58.982468108000035],
              [152.934636135, 58.96648866900006],
              [152.9160228290001, 58.953880628000036],
              [152.90772472900005, 58.94594359600006],
              [152.91060500800006, 58.934841917000085],
              [152.90910256300003, 58.92406839000006],
              [152.91604967, 58.91655474600003],
              [152.89991295700008, 58.903631903000075],
              [152.8856527480001, 58.915699267000036],
              [152.85329786600005, 58.92354752400007],
              [152.81678943000009, 58.92627511400008],
              [152.77959093200002, 58.922026310000035],
              [152.7405527090001, 58.91786590800007],
              [152.731502428, 58.909132266000086],
              [152.71299629200007, 58.916752244000065],
              [152.70247403300004, 58.92142516000007],
              [152.66481284400004, 58.94042191700004],
              [152.61730867900008, 58.94427434900007],
              [152.556739526, 58.94998146100005],
              [152.52263091600003, 58.98256582400006],
              [152.470698406, 59.003366775000075],
              [152.43148847700002, 59.00885651200008],
              [152.4047957690001, 59.023423570000034],
              [152.4047957690001, 59.04604726800005],
              [152.391937696, 59.04751211100006],
              [152.36670983200008, 59.05727773600006],
              [152.3632918630001, 59.05971914300005],
              [152.33936608200008, 59.05548737200007],
              [152.3403426440001, 59.04897695500006],
              [152.35124759200005, 59.04096100500004],
              [152.3564559250001, 59.03237539300005],
              [152.3422957690001, 59.01968008000006],
              [152.31666100400003, 59.01585521000004],
              [152.24923276100003, 58.99820533900004],
              [152.166128974, 58.98406315300008],
              [152.15438254700007, 58.958425315000056],
              [152.1566519170001, 58.926502775000074],
              [152.11026224900002, 58.895286326000075],
              [152.0202983050001, 58.87503653300007],
              [151.91762562600002, 58.874038200000086],
              [151.81188889700002, 58.87050742000008],
              [151.76271296200002, 58.85794082100006],
              [151.71728006, 58.84895640500008],
              [151.63558816800003, 58.84898001900007],
              [151.54960695600005, 58.863870116000044],
              [151.50314478200005, 58.861537601000066],
              [151.45284065300007, 58.864754049000055],
              [151.401318134, 58.84014301600007],
              [151.35366454200005, 58.83256228600004],
              [151.33727697900008, 58.83886742900006],
              [151.35165131100007, 58.84589434900005],
              [151.35909319200005, 58.85599278400008],
              [151.34671884600004, 58.86864701400003],
              [151.30995513200003, 58.897347194000076],
              [151.297238086, 58.90872425800006],
              [151.28142337300005, 58.92251211100006],
              [151.25846948700007, 58.94021008100003],
              [151.238067516, 58.96250597100004],
              [151.22964574000002, 58.98144990700007],
              [151.23602798900004, 58.998267490000046],
              [151.1836043630001, 59.01675039300005],
              [151.17156009200005, 59.02558014500005],
              [151.1512545920001, 59.04163249800007],
              [151.1440996980001, 59.055208321000066],
              [151.132467743, 59.07169157000004],
              [151.10340522600006, 59.09055475900004],
              [151.088049855, 59.10202038500006],
              [151.1020613940001, 59.11432526200008],
              [151.119476759, 59.11082591400003],
              [151.1528426440001, 59.09642161700003],
              [151.18111336200002, 59.09381098100005],
              [151.21652762200006, 59.091682053000056],
              [151.25017952500002, 59.10413076400005],
              [151.301492058, 59.11551624900005],
              [151.343374336, 59.11954816900004],
              [151.362056553, 59.13285066700007],
              [151.40020730100002, 59.15288397200004],
              [151.4377313440001, 59.170316693000075],
              [151.49241174300005, 59.16294124400008],
              [151.570496251, 59.15670038900004],
              [151.61804889400003, 59.161586284000066],
              [151.65748131600003, 59.161444403000075],
              [151.70679772200003, 59.14321523600006],
              [151.76604112100006, 59.13362772700003],
              [151.808786049, 59.14932740200004],
              [151.837997632, 59.15270261100005],
              [151.87671959700003, 59.148423570000034],
              [151.924342012, 59.13777929400004],
              [151.95240127300008, 59.14649050600008],
              [151.99314906000006, 59.154352128000085],
              [152.05062914000007, 59.14786088500006],
              [152.1093571250001, 59.15579782400005],
              [152.18017673000008, 59.18805331600004],
              [152.22522859700007, 59.20216855800004],
              [152.28278483300005, 59.204836872000044],
              [152.32223814000008, 59.20740928400005],
              [152.31182746900004, 59.22664875800007],
              [152.28271861000007, 59.233943612000076],
              [152.25123131600003, 59.24677155200004],
              [152.20935283200004, 59.270672094000076],
              [152.1474715500001, 59.293036200000074],
              [152.1367293630001, 59.296210028000075],
              [152.12134850400003, 59.292181708000044],
              [152.10865372800004, 59.28271377000004],
              [152.07132750800008, 59.27860246400007],
              [152.0276226210001, 59.26962789400005],
              [151.9790145190001, 59.26508209800005],
              [151.96216881600003, 59.26707591400003],
              [151.94089711100003, 59.28461962200004],
              [151.91796880800007, 59.29667077900007],
              [151.90135301200007, 59.303015594000044],
              [151.82525257500004, 59.29873633900007],
              [151.7793074880001, 59.30141836100006],
              [151.7602645190001, 59.299261786000045],
              [151.734297835, 59.30726402300007],
              [151.72759262600005, 59.32219621100006],
              [151.73422503900008, 59.32834573800005],
              [151.741170935, 59.335789860000034],
              [151.77027772300005, 59.34966422600007],
              [151.74374169300006, 59.367270990000065],
              [151.72693836200006, 59.38288905700006],
              [151.70524045500008, 59.38954176000004],
              [151.705265725, 59.400101016000065],
              [151.70339443600005, 59.41342858400009],
              [151.69477478800002, 59.431120081000074],
              [151.66550899100002, 59.45943976500007],
              [151.63757604400007, 59.482479958000056],
              [151.58025280100003, 59.503254876000085],
              [151.5337020190001, 59.50617096600007],
              [151.51587975400003, 59.509100653000075],
              [151.50932524400002, 59.51307290700004],
              [151.4985098310001, 59.52037312200008],
              [151.4897926750001, 59.53206804600006],
              [151.49100859300006, 59.541935969000065],
              [151.47461979600007, 59.55095593700008],
              [151.44206374100008, 59.559547948000045],
              [151.429408168, 59.56456032400007],
              [151.43079663900005, 59.57034751600008],
              [151.46057857100004, 59.56939232500008],
              [151.45091113, 59.57714479500004],
              [151.424627374, 59.59771645100005],
              [151.39605662200006, 59.60416294200007],
              [151.37097967700004, 59.60099250700006],
              [151.3559946370001, 59.58667014100007],
              [151.34690703400008, 59.56786552900007],
              [151.32209981000005, 59.55588838500006],
              [151.27663258400003, 59.55923170300008],
              [151.2255965500001, 59.57298411700003],
              [151.18873131600003, 59.576605536000045],
              [151.1321125730001, 59.57809944500008],
              [151.0630685650001, 59.57933447400006],
              [151.00642335200007, 59.569211572000086],
              [150.93710600600002, 59.555868427000064],
              [150.90674250100005, 59.55935156800007],
              [150.894866976, 59.54648413100006],
              [150.904380199, 59.531866351000076],
              [150.93835658600005, 59.51879510100008],
              [150.91570071700005, 59.49396393400008],
              [150.9101668630001, 59.49103424700007],
              [150.92009524800005, 59.49115631700005],
              [150.929047071, 59.48883698100008],
              [150.93718509200005, 59.48419830900008],
              [150.9443465500001, 59.477443752000056],
              [150.94183317, 59.461225048000074],
              [150.92583970200008, 59.44764209300007],
              [150.8769599630001, 59.44910125600006],
              [150.8431429540001, 59.44837707700003],
              [150.7799119350001, 59.43226300200007],
              [150.7401203930001, 59.43977251800004],
              [150.752980502, 59.45086625000005],
              [150.77439646000005, 59.46541307000007],
              [150.76562180500002, 59.484321381000086],
              [150.73947032, 59.48314003100006],
              [150.70504877100007, 59.491638469000065],
              [150.674519949, 59.49469647600006],
              [150.618565988, 59.48868041800006],
              [150.53556198800004, 59.47896906600005],
              [150.50374051400001, 59.488665913000034],
              [150.581171702, 59.50786005700007],
              [150.6480265460001, 59.51737606200004],
              [150.70844783400003, 59.52057217100008],
              [150.77155967700003, 59.536957811000036],
              [150.77434801000004, 59.561914982000076],
              [150.71577186000002, 59.556007245000046],
              [150.65981408200003, 59.54839778500008],
              [150.601303057, 59.54096048300005],
              [150.5711970540001, 59.54664182100004],
              [150.51636803500003, 59.55703359600005],
              [150.5187598010001, 59.572240073000046],
              [150.4887801440001, 59.57257721600007],
              [150.46827233200008, 59.58087799700007],
              [150.46502861300007, 59.589728096000044],
              [150.45680641, 59.61258969100004],
              [150.4111434250001, 59.622300523000035],
              [150.34107506600003, 59.63198476800005],
              [150.306000196, 59.646185614000046],
              [150.2744246750001, 59.65033600500004],
              [150.16773522200003, 59.652777411000045],
              [150.094574415, 59.671535549000055],
              [150.00449000900005, 59.70036332900008],
              [149.7582147930001, 59.74066206400005],
              [149.5977249560001, 59.758204928000055],
              [149.4380063970001, 59.736450464000086],
              [149.39380944100003, 59.75580475500004],
              [149.38013756600003, 59.75381094000005],
              [149.37256920700008, 59.75828685100004],
              [149.37525475400003, 59.77220286700003],
              [149.35035241000003, 59.766913153000075],
              [149.32683353000004, 59.75861237200007],
              [149.3785930370001, 59.72465426200006],
              [149.344289259, 59.71585526000007],
              [149.1923773210001, 59.66488155500008],
              [149.132906982, 59.640736135000054],
              [149.08122806100005, 59.653225002000056],
              [149.05876712300005, 59.651678778000075],
              [149.04070071700005, 59.64288971600007],
              [149.0332137380001, 59.62482330900008],
              [149.04224694100003, 59.614488023000035],
              [149.08948173400006, 59.60969559800009],
              [149.1040187750001, 59.592341170000054],
              [149.0922957690001, 59.56915924700007],
              [149.08814537900003, 59.56439850500004],
              [149.0810653000001, 59.55996328300006],
              [149.11882571700005, 59.54401276200008],
              [149.16374759200005, 59.537990627000056],
              [149.20134524800005, 59.52488841400003],
              [149.21697024800005, 59.487982489000046],
              [149.21208743600005, 59.46914297100005],
              [149.1992293630001, 59.46775950700004],
              [149.16293379, 59.484808661000045],
              [149.1372176440001, 59.491848049000055],
              [149.114593946, 59.493353583000044],
              [149.08024884600002, 59.48346763700005],
              [149.05459460600002, 59.47714065100007],
              [149.01813899400008, 59.461150632000056],
              [148.97803795700008, 59.45351797100005],
              [148.96843509200005, 59.45221588700008],
              [148.96461022200003, 59.45848216400003],
              [148.9614363940001, 59.46653880400004],
              [148.95386803500003, 59.47060781500005],
              [148.918304884, 59.46381256700005],
              [148.90902754, 59.46312083500004],
              [148.89226321700005, 59.466782945000034],
              [148.8691512380001, 59.47492096600007],
              [148.84888756600003, 59.48663971600007],
              [148.840179884, 59.501288153000075],
              [148.844574415, 59.52016836100006],
              [148.855804884, 59.53119538000004],
              [148.88795006600003, 59.54629140800006],
              [148.84595787900003, 59.552720445000034],
              [148.81519616000003, 59.534491278000075],
              [148.78581790500004, 59.51007721600007],
              [148.77277327700006, 59.49441591200008],
              [148.74342886400007, 59.47157799200005],
              [148.72704204800004, 59.45033230100006],
              [148.723623825, 59.433959368000046],
              [148.720245417, 59.42086373900008],
              [148.72306851500002, 59.388094109000065],
              [148.73570520700002, 59.36839086800006],
              [148.78725389300007, 59.358765249000044],
              [148.8140085870001, 59.36353530000008],
              [148.8379189970001, 59.38472520700003],
              [148.86540774800005, 59.40485260600008],
              [148.8750106130001, 59.398871161000045],
              [148.87322024800005, 59.38719310100004],
              [148.8613387380001, 59.35390859600005],
              [148.88168379, 59.35643138200004],
              [148.89421634200005, 59.369208075000074],
              [148.90406334700003, 59.384833075000074],
              [148.91586347700002, 59.39545319200005],
              [148.93311608200008, 59.39667389500005],
              [148.95264733200008, 59.39130280200004],
              [148.989905678, 59.375376721000066],
              [148.99249162900003, 59.35610229900004],
              [148.93374422600004, 59.31727331500008],
              [148.93033277400002, 59.29677990500005],
              [148.964190142, 59.27327007900004],
              [148.95451397400006, 59.25009427800006],
              [148.93452246900006, 59.23327292200008],
              [148.88570502100004, 59.253007161000085],
              [148.84156334700003, 59.276556708000044],
              [148.799034936, 59.27131065000003],
              [148.78793720700003, 59.236484372000064],
              [148.739021579, 59.23703164300008],
              [148.72803794000004, 59.25954574300005],
              [148.685716071, 59.26568369700004],
              [148.58978017000004, 59.24158433300005],
              [148.47087636600008, 59.256509545000085],
              [148.43746589700004, 59.26231739700006],
              [148.44029333700007, 59.282708154000034],
              [148.4149314440001, 59.304397804000075],
              [148.41140981, 59.31926959500004],
              [148.419145491, 59.33358578100007],
              [148.40202884200005, 59.35390859600005],
              [148.39372806100005, 59.37929922100005],
              [148.36881138900003, 59.38268851300006],
              [148.33611262600004, 59.39702338400008],
              [148.2194364730001, 59.40886989000006],
              [148.0094368130001, 59.38570057800007],
              [147.91384837700002, 59.390470605000075],
              [147.84546254100007, 59.37661532700008],
              [147.78874759200005, 59.34393952000005],
              [147.834343623, 59.316491985000084],
              [147.846569197, 59.29691936000006],
              [147.82550079300006, 59.269604611000034],
              [147.77515709700003, 59.26463450700004],
              [147.73853600400003, 59.26239655200004],
              [147.70289147200003, 59.26911041900007],
              [147.675140821, 59.285589911000045],
              [147.6826278000001, 59.293036200000074],
              [147.65609785200002, 59.301947333000044],
              [147.62330162900003, 59.30638255400004],
              [147.59107506600003, 59.30414459800005],
              [147.56527754, 59.293036200000074],
              [147.55250084700003, 59.27407461100006],
              [147.552093946, 59.25861237200007],
              [147.54599906600004, 59.23754682200007],
              [147.5175887380001, 59.24461497600004],
              [147.49203535200002, 59.24677155200004],
              [147.43767337300005, 59.26089101800005],
              [147.41578209700003, 59.27130768400008],
              [147.38697350400003, 59.29511139500005],
              [147.37452233200008, 59.30296458500004],
              [147.360687696, 59.30756256700005],
              [147.3330184250001, 59.31000397300005],
              [147.31959069100003, 59.312933661000045],
              [147.287445509, 59.32709381700005],
              [147.2714949880001, 59.332098700000074],
              [147.25066165500004, 59.334051825000074],
              [147.23064212300005, 59.33177317900004],
              [147.1989388720001, 59.31291908700007],
              [147.16911868600005, 59.31976959800005],
              [147.1318465500001, 59.32721588700008],
              [147.05583743600005, 59.362982489000046],
              [147.030636748, 59.363208289000056],
              [146.97920186200008, 59.37046302300007],
              [146.88656660200002, 59.36473216400003],
              [146.86052493600005, 59.361314195000034],
              [146.719574415, 59.38190338700008],
              [146.70264733200008, 59.38861725500004],
              [146.6972762380001, 59.39435455900008],
              [146.69483483200008, 59.40680573100008],
              [146.68921959700003, 59.41225820500006],
              [146.693477014, 59.42361584900004],
              [146.6372176440001, 59.44041575700004],
              [146.61890709700003, 59.445746161000045],
              [146.56373131600003, 59.452378648000035],
              [146.52507571700005, 59.46198151200008],
              [146.5039168630001, 59.46312083500004],
              [146.439641574, 59.46040865500004],
              [146.35896135100006, 59.42993988000006],
              [146.31914097900005, 59.40169361100004],
              [146.31902103000004, 59.36473216400003],
              [146.32496178500003, 59.31940338700008],
              [146.32374108200008, 59.29877350500004],
              [146.31218509200005, 59.27875397300005],
              [146.3266707690001, 59.27098216400003],
              [146.33326256600003, 59.25934479400007],
              [146.3310653000001, 59.24721914300005],
              [146.31902103000004, 59.23786041900007],
              [146.3422957690001, 59.23143138200004],
              [146.3631079060001, 59.21281146400008],
              [146.33955883300007, 59.20600923300003],
              [146.3229571820001, 59.17995188600008],
              [146.28116799600002, 59.194111871000075],
              [146.24121168, 59.19648207400007],
              [146.204619384, 59.20462027900004],
              [146.15772881600003, 59.19241602000005],
              [146.13578767900003, 59.169389170000045],
              [146.09913170700008, 59.17438385600008],
              [146.05029199900002, 59.13887271900006],
              [145.9761986630001, 59.14331643500003],
              [145.97479999400002, 59.16243723300005],
              [145.9899059920001, 59.17241818300005],
              [145.9633895190001, 59.18939850500004],
              [145.9321395190001, 59.21320221600007],
              [145.91529381600003, 59.221136786000045],
              [145.85767662900003, 59.227850653000075],
              [145.8422957690001, 59.23309967700004],
              [145.82496178500003, 59.24127838700008],
              [145.8241991000001, 59.259341515000074],
              [145.83399786400003, 59.27530689200006],
              [145.843909134, 59.292736028000036],
              [145.8652078670001, 59.308477879000066],
              [145.886629513, 59.32568132200004],
              [145.91095243000007, 59.34282293400008],
              [145.9464959180001, 59.355321384000035],
              [145.95401871900003, 59.37867352200004],
              [145.975797006, 59.39874877600005],
              [145.95700552900007, 59.41672280700004],
              [145.88942810100002, 59.401966852000044],
              [145.84742272200003, 59.40835195500006],
              [145.81812584700003, 59.41596100500004],
              [145.81401125000002, 59.397565273000055],
              [145.80889757, 59.366828259000044],
              [145.76910219600006, 59.37491328900006],
              [145.73609459700003, 59.39545319200005],
              [145.69263756600003, 59.41168854400007],
              [145.67530358200008, 59.423488674000055],
              [145.67465254, 59.436428127000056],
              [145.65162194100003, 59.421942450000074],
              [145.62256920700008, 59.420803127000056],
              [145.5922957690001, 59.423081773000035],
              [145.541351759, 59.41323476800005],
              [145.44874108200008, 59.40851471600007],
              [145.35368899800005, 59.39272695500006],
              [145.324554884, 59.39545319200005],
              [145.31413821700005, 59.40078359600005],
              [145.30388431100005, 59.40875885600008],
              [145.22871808700006, 59.40797620600006],
              [145.13493167600006, 59.39004517400008],
              [145.00075857700006, 59.36958296600005],
              [144.76295006600003, 59.38117096600007],
              [144.7763778000001, 59.383693752000056],
              [144.7876082690001, 59.38491445500006],
              [144.7978621750001, 59.386379299000055],
              [144.80445397200003, 59.39545319200005],
              [144.6132918630001, 59.39545319200005],
              [144.629730665, 59.38393789300005],
              [144.65154056100005, 59.37929922100005],
              [144.69459069100003, 59.37494538000004],
              [144.45484459700003, 59.37494538000004],
              [144.3657332690001, 59.38117096600007],
              [144.40162194100003, 59.38239166900007],
              [144.4238387380001, 59.38239166900007],
              [144.4482528000001, 59.38117096600007],
              [144.44117272200003, 59.39134349200003],
              [144.41968834700003, 59.39785390800006],
              [144.37964928500003, 59.40228913000004],
              [144.35726972700002, 59.400824286000045],
              [144.2973738940001, 59.38861725500004],
              [144.28109785200002, 59.38764069200005],
              [144.13003873900004, 59.399858832000064],
              [143.93800957300004, 59.405078496000044],
              [143.90391134100003, 59.422709542000064],
              [143.84050514, 59.402476239000066],
              [143.58228366100002, 59.33886449000005],
              [143.49361686600002, 59.31851801800008],
              [143.40798013800008, 59.324321816000065],
              [143.3594498660001, 59.34036809600008],
              [143.31087109400005, 59.36074116600008],
              [143.22795115600002, 59.36227344000008],
              [143.20435631600003, 59.38373444200005],
              [143.16480553500003, 59.38100820500006],
              [143.1391707690001, 59.361314195000034],
              [143.14576256600003, 59.36005280200004],
              [143.15967858200008, 59.35390859600005],
              [142.89226321700005, 59.302069403000075],
              [142.58179804100007, 59.226101948000064],
              [142.26238040500004, 59.12457916900007],
              [142.14429772200003, 59.05687083500004],
              [142.0839949880001, 59.03237539300005],
              [142.05583743600005, 59.02171458500004],
              [142.01531009200005, 58.997259833000044],
              [141.94678795700008, 58.943019924000055],
              [141.78191165500004, 58.76471588700008],
              [141.67310631600003, 58.682928778000075],
              [141.5837338890001, 58.617748978000066],
              [141.39242597700002, 58.54328034100007],
              [141.2485092070001, 58.476891899000066],
              [141.18563293900002, 58.45635649400003],
              [141.13635102400008, 58.46443766400006],
              [141.10542480200002, 58.45921505200005],
              [140.9873153000001, 58.41852448100008],
              [140.95492597700002, 58.39907461100006],
              [140.9375106130001, 58.39130280200004],
              [140.9189559250001, 58.38812897300005],
              [140.9043074880001, 58.38275788000004],
              [140.74000084700003, 58.27130768400008],
              [140.69988040500004, 58.23383209800005],
              [140.66675866000003, 58.191107489000046],
              [140.62281334700003, 58.11127350500004],
              [140.51872806100005, 57.932521877000056],
              [140.51050866000003, 57.90912506700005],
              [140.499494174, 57.867579024000065],
              [140.49572797400003, 57.84477360200003],
              [140.45857274700006, 57.831786917000045],
              [140.42839300100002, 57.82064639200007],
              [140.40003916800003, 57.800331870000036],
              [140.34577649200003, 57.78683602500007],
              [140.311470762, 57.75103780000006],
              [140.30244593200007, 57.74778842100005],
              [140.2802840500001, 57.762600002000056],
              [140.26099694100003, 57.76430898600006],
              [140.22331790500004, 57.76023997600004],
              [140.2075754560001, 57.74766234300006],
              [140.16715249700007, 57.74816389500006],
              [140.11608203000003, 57.73997846700007],
              [140.07154381600003, 57.72557200700004],
              [140.0527449880001, 57.72044505400004],
              [140.03484134200005, 57.71308014500005],
              [140.00464928500003, 57.69623444200005],
              [139.9815403240001, 57.68773787200007],
              [139.93486959000006, 57.65329794500008],
              [139.877435009, 57.594113561000086],
              [139.81430011600003, 57.50736220300007],
              [139.78967780100004, 57.48273136900008],
              [139.71208743600005, 57.49176666900007],
              [139.67367597700002, 57.48139069200005],
              [139.62057154000001, 57.46734427300004],
              [139.563067897, 57.43005573600004],
              [139.54161832900002, 57.381063305000055],
              [139.52220236200003, 57.35963694900005],
              [139.49789472700002, 57.339544989000046],
              [139.47284788600007, 57.33442148900008],
              [139.44678795700008, 57.320746161000045],
              [139.41845893200002, 57.29719375900004],
              [139.40497151900001, 57.30602599600007],
              [139.38002279700004, 57.308161978000044],
              [139.34245853000004, 57.29132721600007],
              [139.3170680180001, 57.27760841600008],
              [139.300856125, 57.27900548100007],
              [139.26848768600007, 57.27716250700007],
              [139.19654381600003, 57.272650458000044],
              [139.16228274800005, 57.25625234600005],
              [139.1138111470001, 57.23438501800007],
              [139.068733392, 57.207020585000066],
              [139.037168575, 57.16684586200006],
              [139.02942751400008, 57.14603970400003],
              [139.02562407000005, 57.14000319000007],
              [139.0046905490001, 57.148823838000055],
              [138.989896831, 57.15425542300005],
              [138.96003530100006, 57.14494858100005],
              [138.9329572260001, 57.13502493300007],
              [138.93024088200002, 57.117568479000056],
              [138.9215828350001, 57.10756479200006],
              [138.93154608100008, 57.095648666000045],
              [138.92247585200005, 57.05811634000008],
              [138.9024725380001, 57.031213439000055],
              [138.885110403, 57.019112791000055],
              [138.85913586900006, 57.01316220800004],
              [138.82332901900008, 57.021424925000076],
              [138.806056947, 57.03161416100005],
              [138.78885252200007, 57.02344134400005],
              [138.7960021680001, 57.013528809000036],
              [138.787305436, 57.00615653400007],
              [138.76016697900002, 57.00483352800006],
              [138.71807182400005, 56.980028667000056],
              [138.69715510900005, 56.98407086900005],
              [138.66161502700004, 56.97794264700008],
              [138.6230574880001, 56.95929596600007],
              [138.60562841900003, 56.94522447300005],
              [138.58595577300002, 56.921675734000075],
              [138.577571508, 56.88114052100008],
              [138.56152027100006, 56.82654751800004],
              [138.57110428400006, 56.81107498800009],
              [138.581736352, 56.78450917500004],
              [138.563610067, 56.77750924700007],
              [138.54336315500007, 56.79385892000005],
              [138.54603687000008, 56.81896261300005],
              [138.54983493600002, 56.859517536000055],
              [138.51775728300004, 56.84932154000006],
              [138.4849074450001, 56.84953958300008],
              [138.4544484820001, 56.83933669600003],
              [138.46660924700006, 56.81660738800008],
              [138.44320722700002, 56.79246653900003],
              [138.43873131600003, 56.782538153000075],
              [138.43327884200005, 56.77448151200008],
              [138.41822350400003, 56.76788971600007],
              [138.41138756600003, 56.75971100500004],
              [138.40609785200002, 56.74945709800005],
              [138.40398196700005, 56.74017975500004],
              [138.39600670700008, 56.73126862200007],
              [138.37561792100007, 56.72048213800008],
              [138.35244885200007, 56.71575891700007],
              [138.32809668900006, 56.71170905000008],
              [138.2902050030001, 56.69213054700003],
              [138.28785241000003, 56.674994208000044],
              [138.279633009, 56.66657135600008],
              [138.261874519, 56.65430521400003],
              [138.25918447800007, 56.64277787200007],
              [138.26783286500006, 56.62662590700006],
              [138.26051050500007, 56.61582066900007],
              [138.25310652400003, 56.62388528400004],
              [138.23098952300006, 56.624487111000064],
              [138.21632512300005, 56.60960711800004],
              [138.18561315, 56.60882017000006],
              [138.1484481130001, 56.603583075000074],
              [138.12964928500003, 56.585638739000046],
              [138.12086022200003, 56.569566148000035],
              [138.11784915500004, 56.55532461100006],
              [138.12077884200005, 56.54083893400008],
              [138.11483830300006, 56.52810432900009],
              [138.12512578300004, 56.50693344700005],
              [138.14534543500008, 56.49287938900005],
              [138.16006399000003, 56.47876826300006],
              [138.17469793400005, 56.471757506000074],
              [138.20849599500002, 56.46892913700003],
              [138.2340286540001, 56.47052315600007],
              [138.24588150300008, 56.46953963800007],
              [138.25777321700002, 56.466050049000046],
              [138.2494433500001, 56.455346345000066],
              [138.22849904400005, 56.44367324500007],
              [138.2234770990001, 56.42416025300008],
              [138.19155746500007, 56.42910989100005],
              [138.16308130100003, 56.45113569000006],
              [138.14862326900004, 56.441057286000046],
              [138.10489950400006, 56.44091537600008],
              [138.0694281540001, 56.43775473200009],
              [138.06023196700005, 56.42617422100005],
              [138.05884850400003, 56.414496161000045],
              [138.055023634, 56.40448639500005],
              [138.0536825920001, 56.38785083100004],
              [138.0230178070001, 56.38171024400003],
              [137.97744057400007, 56.372409143000084],
              [137.93675402600002, 56.366196226000056],
              [137.91406701200003, 56.35952565000008],
              [137.9015354280001, 56.34282471700004],
              [137.88934918000007, 56.32469373500004],
              [137.8706570170001, 56.292812317000084],
              [137.85377037900003, 56.268784898000035],
              [137.83442839400004, 56.22547623100007],
              [137.79167042300003, 56.221026452000046],
              [137.7762869830001, 56.211273349000066],
              [137.76164019600003, 56.19427550800003],
              [137.75414382500003, 56.17677598000006],
              [137.73585045700008, 56.16791413000004],
              [137.72309635800002, 56.15894868100008],
              [137.720377514, 56.14734301100003],
              [137.72359734000008, 56.13632394700005],
              [137.69802908600002, 56.12620236500004],
              [137.61797097700003, 56.11841378200006],
              [137.57195071700005, 56.116522528000075],
              [137.50025475400003, 56.06281159100007],
              [137.4887801440001, 56.05805084800005],
              [137.472015821, 56.054348049000055],
              [137.459408284, 56.05030358100004],
              [137.44366089300001, 56.04851152400005],
              [137.42599296600008, 56.03114633100006],
              [137.4168378390001, 56.00450801100004],
              [137.41347648500005, 55.987367378000044],
              [137.41682345700008, 55.97300702400008],
              [137.40705256, 55.96904365900008],
              [137.4002131420001, 55.96565224700004],
              [137.39751410600002, 55.95509740400007],
              [137.3908307700001, 55.94560743800008],
              [137.36790783100002, 55.95202590900004],
              [137.35495452700002, 55.96025595200007],
              [137.33107513200002, 55.96890483000004],
              [137.29563402600002, 55.96132245700005],
              [137.254310369, 55.932766221000065],
              [137.23753284000009, 55.91560875400006],
              [137.203329811, 55.899635551000074],
              [137.18293349400005, 55.89363446900006],
              [137.15568258300004, 55.88755038600004],
              [137.11489129900008, 55.86327524900008],
              [137.0466999690001, 55.81909016100008],
              [137.05690681400006, 55.79970712900007],
              [137.04979655600005, 55.793115742000055],
              [137.0300255840001, 55.787550181000086],
              [137.00557552300006, 55.79494446800004],
              [136.97942587, 55.792255399000055],
              [136.95622806100005, 55.78778717700004],
              [136.9099201790001, 55.771266714000035],
              [136.88782904800007, 55.744936618000054],
              [136.85132897200003, 55.730902411000045],
              [136.83545983200008, 55.72284577000005],
              [136.82488040500004, 55.71369049700007],
              [136.80062910200002, 55.68187083500004],
              [136.77328535200002, 55.66054922100005],
              [136.74781334700003, 55.65770091400003],
              [136.7149207440001, 55.65873271700008],
              [136.670964153, 55.64639806900004],
              [136.62307164000003, 55.61603679700005],
              [136.602339798, 55.617505048000055],
              [136.57980656900008, 55.62342948100007],
              [136.56551469300007, 55.62319869800007],
              [136.55478932000005, 55.614944500000036],
              [136.5521897540001, 55.603228680000086],
              [136.54633280200005, 55.59325485800008],
              [136.5294769080001, 55.58040343400006],
              [136.4880539620001, 55.58330774600006],
              [136.462847184, 55.57929092100005],
              [136.43016060000002, 55.56524642800008],
              [136.417906162, 55.556044807000035],
              [136.37948711, 55.532911969000054],
              [136.35061025900006, 55.50993594500005],
              [136.31902103000004, 55.48655833500004],
              [136.31202233200008, 55.45954010600008],
              [136.30767085500008, 55.424624315000074],
              [136.268707801, 55.41494016000007],
              [136.2361840420001, 55.373840441000084],
              [136.2197791000001, 55.35458915400005],
              [136.19046180200007, 55.34325925300004],
              [136.17805986300004, 55.343118813000046],
              [136.17534823800008, 55.329419175000055],
              [136.16162658400003, 55.318283990000054],
              [136.1425887380001, 55.314439195000034],
              [136.12663821700005, 55.308254299000055],
              [136.11833181500003, 55.29970708800005],
              [136.0878762330001, 55.28548120100004],
              [136.05436378600007, 55.268840960000034],
              [136.01881853600003, 55.25653355800006],
              [135.98107865100008, 55.24481068500006],
              [135.954078911, 55.229985309000085],
              [135.93041271700008, 55.213335061000066],
              [135.917426374, 55.20590970400008],
              [135.91410568600008, 55.19675083800007],
              [135.86894250500006, 55.173885616000064],
              [135.842073625, 55.17263875300006],
              [135.810849781, 55.17136206300006],
              [135.7554407570001, 55.13948486900006],
              [135.7063483510001, 55.11541310500007],
              [135.6704687140001, 55.12130586900008],
              [135.59235871500005, 55.10141014200008],
              [135.53425505000007, 55.08656485500006],
              [135.46906384600004, 55.05666445900005],
              [135.45542427600003, 55.02882688300008],
              [135.391440557, 55.00446820800005],
              [135.33921838600008, 54.98071336300006],
              [135.26513985100007, 54.92845394600005],
              [135.2195714510001, 54.894120841000074],
              [135.20394818500006, 54.869288976000064],
              [135.183724246, 54.85915536300007],
              [135.17335045700008, 54.82127513200004],
              [135.26514733200008, 54.72166575700004],
              [135.25538170700008, 54.720689195000034],
              [135.24976647200003, 54.71771881700005],
              [135.23780358200008, 54.70799388200004],
              [135.2441512380001, 54.701239325000074],
              [135.2685653000001, 54.71108633000006],
              [135.29249108200008, 54.71564362200007],
              [135.3408309250001, 54.714829820000034],
              [135.65414472700002, 54.66596100500004],
              [135.66968834700003, 54.66087474200003],
              [135.6801863940001, 54.649603583000044],
              [135.68824303500003, 54.614162502000056],
              [135.698578321, 54.59902578300006],
              [135.7119246750001, 54.58624909100007],
              [135.7251082690001, 54.57770416900007],
              [135.75017337300005, 54.57094961100006],
              [135.88070722700002, 54.585150458000044],
              [135.97999108200008, 54.58079661700003],
              [136.129242384, 54.61225006700005],
              [136.20671634200005, 54.62067291900007],
              [136.24927819100003, 54.620428778000075],
              [136.262543165, 54.61554596600007],
              [136.27654056100005, 54.607489325000074],
              [136.29118899800005, 54.607123114000046],
              [136.32056725400003, 54.61180247600004],
              [136.53492272200003, 54.59552643400008],
              [136.567230665, 54.602728583000044],
              [136.59839928500003, 54.622707424000055],
              [136.63843834700003, 54.66811758000006],
              [136.662445509, 54.685248114000046],
              [136.677093946, 54.673895575000074],
              [136.67448978000004, 54.65835195500006],
              [136.66480553500003, 54.647772528000075],
              [136.65894616000003, 54.63743724200003],
              [136.6670028000001, 54.622707424000055],
              [136.68140709700003, 54.61469147300005],
              [136.70085696700005, 54.61188385600008],
              [136.72022545700008, 54.614447333000044],
              [136.735199415, 54.622707424000055],
              [136.74830162900003, 54.63544342700004],
              [136.76124108200008, 54.64492422100005],
              [136.77556399800005, 54.650824286000045],
              [136.793793165, 54.652777411000045],
              [136.81072024800005, 54.651597398000035],
              [136.82349694100003, 54.64752838700008],
              [136.8266707690001, 54.63934967700004],
              [136.8144637380001, 54.62612539300005],
              [136.828461134, 54.61432526200008],
              [136.84441165500004, 54.60407135600008],
              [136.86255944100003, 54.596136786000045],
              [136.8833113940001, 54.59137604400007],
              [136.87224368600005, 54.57807038000004],
              [136.83863366000003, 54.55158112200007],
              [136.83814537900003, 54.53400299700007],
              [136.81470787900003, 54.52448151200008],
              [136.80746504, 54.51626211100006],
              [136.810883009, 54.50800202000005],
              [136.84164472700002, 54.488267320000034],
              [136.82056725400003, 54.485256252000056],
              [136.81804446700005, 54.47345612200007],
              [136.826508009, 54.45815664300005],
              [136.83863366000003, 54.444240627000056],
              [136.8408309250001, 54.43231842700004],
              [136.82691491000003, 54.425116278000075],
              [136.8066512380001, 54.42401764500005],
              [136.7754012380001, 54.437486070000034],
              [136.758636915, 54.43695709800005],
              [136.74488366000003, 54.428941148000035],
              [136.738617384, 54.41380442900004],
              [136.74366295700008, 54.40119049700007],
              [136.75407962300005, 54.39166901200008],
              [136.76002037900003, 54.38108958500004],
              [136.752289259, 54.36542389500005],
              [136.77230879, 54.348537502000056],
              [136.803070509, 54.33266836100006],
              [136.820648634, 54.316107489000046],
              [136.80062910200002, 54.29718659100007],
              [136.7876082690001, 54.29718659100007],
              [136.769867384, 54.299709377000056],
              [136.755218946, 54.29743073100008],
              [136.752289259, 54.28351471600007],
              [136.762054884, 54.272650458000044],
              [136.800140821, 54.25678131700005],
              [136.8144637380001, 54.24872467700004],
              [136.80005944100003, 54.23883698100008],
              [136.77955162900003, 54.228176174000055],
              [136.76343834700003, 54.216498114000046],
              [136.76286868600005, 54.20404694200005],
              [136.77686608200008, 54.19245026200008],
              [136.79281660200002, 54.183579820000034],
              [136.80648847700002, 54.17377350500004],
              [136.8144637380001, 54.15932851800005],
              [136.80534915500004, 54.134833075000074],
              [136.783539259, 54.10614655200004],
              [136.76880944100003, 54.08022695500006],
              [136.7802840500001, 54.063788153000075],
              [136.720062696, 54.03278229400007],
              [136.68913821700005, 54.01227448100008],
              [136.68734785200002, 53.99237702000005],
              [136.69206790500004, 53.980169989000046],
              [136.6845809250001, 53.96820709800005],
              [136.66358483200008, 53.94708893400008],
              [136.6591903000001, 53.93504466400003],
              [136.6591903000001, 53.92617422100005],
              [136.67554772200003, 53.84357330900008],
              [136.677093946, 53.820746161000045],
              [136.68474368600005, 53.80849844000005],
              [136.702484571, 53.80036041900007],
              [136.738617384, 53.79002513200004],
              [136.76433353000004, 53.77529531500005],
              [136.77515709700003, 53.773098049000055],
              [136.793793165, 53.77635325700004],
              [136.80836022200003, 53.78107330900008],
              [136.82178795700008, 53.788397528000075],
              [136.83171634200005, 53.79905833500004],
              [136.83545983200008, 53.81391022300005],
              [136.84205162900003, 53.82876211100006],
              [136.85726972700002, 53.83437734600005],
              [136.874359571, 53.83657461100006],
              [136.89869225400003, 53.846991278000075],
              [136.95777428500003, 53.85765208500004],
              [136.96631920700008, 53.85683828300006],
              [136.99187259200005, 53.85150788000004],
              [137.012543165, 53.85211823100008],
              [137.01978600400003, 53.85150788000004],
              [137.04957116000003, 53.83852773600006],
              [137.07789147200003, 53.82005442900004],
              [137.1079207690001, 53.807928778000075],
              [137.14275149800005, 53.81391022300005],
              [137.16667728000004, 53.83022695500006],
              [137.18572024800005, 53.85106028900003],
              [137.23365319100003, 53.942572333000044],
              [137.247406446, 53.96173737200007],
              [137.26319420700008, 53.97842031500005],
              [137.27995853000004, 54.022772528000075],
              [137.28345787900003, 54.02985260600008],
              [137.28834069100003, 54.03261953300006],
              [137.29086347700002, 54.03571198100008],
              [137.28736412900003, 54.04389069200005],
              [137.28093509200005, 54.048529364000046],
              [137.27165774800005, 54.05023834800005],
              [137.25375410200002, 54.050116278000075],
              [137.18816165500004, 54.03880442900004],
              [137.15699303500003, 54.04401276200008],
              [137.143890821, 54.074286200000074],
              [137.13819420700008, 54.08344147300005],
              [137.06137129, 54.145697333000044],
              [137.09058678500003, 54.154282945000034],
              [137.17750084700003, 54.20774974200003],
              [137.20679772200003, 54.21702708500004],
              [137.23414147200003, 54.22028229400007],
              [137.26050866000003, 54.227443752000056],
              [137.28736412900003, 54.24872467700004],
              [137.27995853000004, 54.255560614000046],
              [137.300140821, 54.271918036000045],
              [137.3252059250001, 54.27903880400004],
              [137.35181725400003, 54.283189195000034],
              [137.37671959700003, 54.290269273000035],
              [137.38599694100003, 54.29718659100007],
              [137.38990319100003, 54.30353424700007],
              [137.39478600400003, 54.308294989000046],
              [137.41911868600005, 54.31134674700007],
              [137.43921959700003, 54.316392320000034],
              [137.45142662900003, 54.317613023000035],
              [137.4775496750001, 54.314886786000045],
              [137.54672285200002, 54.29718659100007],
              [137.64332116000003, 54.29718659100007],
              [137.663422071, 54.30524323100008],
              [137.68677819100003, 54.320746161000045],
              [137.71168053500003, 54.33047109600005],
              [137.73585045700008, 54.32099030200004],
              [137.74000084700003, 54.30658600500004],
              [137.72624759200005, 54.29547760600008],
              [137.6845809250001, 54.276597398000035],
              [137.58871504, 54.20612213700008],
              [137.58082116000003, 54.18732330900008],
              [137.5507918630001, 54.17291901200008],
              [137.52564537900003, 54.15639883000006],
              [137.504242384, 54.13654205900008],
              [137.4853621750001, 54.11212799700007],
              [137.4843856130001, 54.10203685100004],
              [137.4873153000001, 54.09162018400008],
              [137.48389733200008, 54.08466217700004],
              [137.4648543630001, 54.084865627000056],
              [137.4502059250001, 54.089056708000044],
              [137.44703209700003, 54.095038153000075],
              [137.44947350400003, 54.10431549700007],
              [137.4511824880001, 54.118353583000044],
              [137.45337975400003, 54.120347398000035],
              [137.45777428500003, 54.121161200000074],
              [137.46070397200003, 54.12417226800005],
              [137.4580184250001, 54.13263580900008],
              [137.4536238940001, 54.138373114000046],
              [137.448578321, 54.14175039300005],
              [137.436859571, 54.145697333000044],
              [137.4223738940001, 54.14801666900007],
              [137.40512129, 54.14667389500005],
              [137.3369246750001, 54.132513739000046],
              [137.32007897200003, 54.126654364000046],
              [137.30787194100003, 54.118353583000044],
              [137.30396569100003, 54.109035549000055],
              [137.30420983200008, 54.09857819200005],
              [137.3027449880001, 54.087876695000034],
              [137.29363040500004, 54.077460028000075],
              [137.3051863940001, 54.06732819200005],
              [137.310883009, 54.05768463700008],
              [137.32007897200003, 54.04946523600006],
              [137.34197024800005, 54.04389069200005],
              [137.39909915500004, 54.04539622600004],
              [137.41773522200003, 54.04389069200005],
              [137.43816165500004, 54.03701406500005],
              [137.546234571, 53.97207265800006],
              [137.571136915, 53.96548086100006],
              [137.59050540500004, 53.95612213700008],
              [137.6020613940001, 53.95384349200003],
              [137.60922285200002, 53.95600006700005],
              [137.6274520190001, 53.96539948100008],
              [137.63624108200008, 53.96759674700007],
              [137.65691165500004, 53.96539948100008],
              [137.69654381600003, 53.95600006700005],
              [137.736664259, 53.950873114000046],
              [137.7539168630001, 53.94562409100007],
              [137.77133222700002, 53.94354889500005],
              [137.8105574880001, 53.95661041900007],
              [137.86280358200008, 53.96759674700007],
              [137.83871504, 53.95014069200005],
              [137.799164259, 53.913275458000044],
              [137.7739363940001, 53.899318752000056],
              [137.67896569100003, 53.877834377000056],
              [137.6504012380001, 53.86513906500005],
              [137.6450301440001, 53.859442450000074],
              [137.6435653000001, 53.85333893400008],
              [137.64283287900003, 53.84715403900003],
              [137.6396590500001, 53.84125397300005],
              [137.633148634, 53.837958075000074],
              [137.61695397200003, 53.83641185100004],
              [137.60914147200003, 53.834418036000045],
              [137.59693444100003, 53.82416413000004],
              [137.59498131600003, 53.81313711100006],
              [137.5957137380001, 53.802394924000055],
              [137.5918074880001, 53.79315827000005],
              [137.570648634, 53.77749258000006],
              [137.56592858200008, 53.77094147300005],
              [137.5610457690001, 53.75527578300006],
              [137.56128991000003, 53.745021877000056],
              [137.56430097700002, 53.736395575000074],
              [137.56397545700008, 53.72687409100007],
              [137.55420983200008, 53.71430084800005],
              [137.53980553500003, 53.70913320500006],
              [137.51905358200008, 53.70526764500005],
              [137.50025475400003, 53.69818756700005],
              [137.4921981130001, 53.683579820000034],
              [137.48796634200005, 53.67055898600006],
              [137.47722415500004, 53.66583893400008],
              [137.38070722700002, 53.668402411000045],
              [137.34538821700005, 53.66474030200004],
              [137.31470787900003, 53.65281810100004],
              [137.30298912900003, 53.64207591400003],
              [137.29086347700002, 53.628241278000075],
              [137.277679884, 53.616400458000044],
              [137.26319420700008, 53.61127350500004],
              [137.2490340500001, 53.610663153000075],
              [137.23194420700008, 53.60765208500004],
              [137.21762129, 53.60057200700004],
              [137.21168053500003, 53.58771393400008],
              [137.22820071700005, 53.56679922100005],
              [137.265961134, 53.54901764500005],
              [137.33513431100005, 53.529364325000074],
              [137.370453321, 53.52753327000005],
              [137.4379988940001, 53.54002513200004],
              [137.678070509, 53.550116278000075],
              [137.91822350400003, 53.58661530200004],
              [138.047211134, 53.650458075000074],
              [138.15007571700005, 53.672756252000056],
              [138.16822350400003, 53.68036530200004],
              [138.21900475400003, 53.71116771000004],
              [138.2705184250001, 53.73041413000004],
              [138.2841903000001, 53.73851146000004],
              [138.298187696, 53.75617096600007],
              [138.3388778000001, 53.86961497600004],
              [138.34929446700005, 53.88898346600007],
              [138.36638431100005, 53.909491278000075],
              [138.39568118600005, 53.92841217700004],
              [138.468109571, 53.94989655200004],
              [138.558929884, 53.989569403000075],
              [138.57211347700002, 53.998928127000056],
              [138.5786238940001, 53.999335028000075],
              [138.58375084700003, 53.99054596600007],
              [138.58472741000003, 53.97724030200004],
              [138.5649520190001, 53.94208405200004],
              [138.56812584700003, 53.92202383000006],
              [138.5888778000001, 53.87938060100004],
              [138.57992597700002, 53.82831452000005],
              [138.53663170700008, 53.78607819200005],
              [138.37875410200002, 53.68414948100008],
              [138.35328209700003, 53.66010163000004],
              [138.34253991000003, 53.63548411700003],
              [138.34595787900003, 53.61831289300005],
              [138.34986412900003, 53.61127350500004],
              [138.345062696, 53.607123114000046],
              [138.2739363940001, 53.58388906500005],
              [138.25993899800005, 53.57713450700004],
              [138.2461043630001, 53.56635163000004],
              [138.24293053500003, 53.558294989000046],
              [138.24683678500003, 53.53278229400007],
              [138.2407332690001, 53.52289459800005],
              [138.21656334700003, 53.500433661000045],
              [138.21558678500003, 53.49176666900007],
              [138.22608483200008, 53.492254950000074],
              [138.26734459700003, 53.52252838700008],
              [138.28443444100003, 53.52484772300005],
              [138.40577233200008, 53.51056549700007],
              [138.43921959700003, 53.513657945000034],
              [138.4731551440001, 53.52594635600008],
              [138.50212649800005, 53.54352448100008],
              [138.5278426440001, 53.564154364000046],
              [138.55030358200008, 53.58690013200004],
              [138.65577233200008, 53.731756903000075],
              [138.69678795700008, 53.81867096600007],
              [138.698578321, 53.83673737200007],
              [138.68824303500003, 53.85455963700008],
              [138.68246504, 53.875433661000045],
              [138.695648634, 53.897772528000075],
              [138.7329207690001, 53.934027411000045],
              [138.76059004, 53.97524648600006],
              [138.771820509, 54.01557038000004],
              [138.77214603000004, 54.057806708000044],
              [138.76710045700008, 54.104681708000044],
              [138.6757918630001, 54.071519273000035],
              [138.66472415500004, 54.077460028000075],
              [138.67546634200005, 54.09780508000006],
              [138.71314537900003, 54.13735586100006],
              [138.72543379, 54.15932851800005],
              [138.72803795700008, 54.16681549700007],
              [138.73210696700005, 54.17438385600008],
              [138.7329207690001, 54.18048737200007],
              [138.73170006600003, 54.18622467700004],
              [138.72608483200008, 54.194647528000075],
              [138.72543379, 54.20034414300005],
              [138.7295028000001, 54.20962148600006],
              [138.743500196, 54.23126862200007],
              [138.7465926440001, 54.24249909100007],
              [138.7343856130001, 54.26634349200003],
              [138.7050887380001, 54.28139883000006],
              [138.6435653000001, 54.29718659100007],
              [138.70036868600005, 54.31460195500006],
              [138.7192488940001, 54.317613023000035],
              [138.73853600400003, 54.31598541900007],
              [138.934418165, 54.25307851800005],
              [139.09009850400003, 54.22357819200005],
              [139.16187584700003, 54.204738674000055],
              [139.30225670700008, 54.190619208000044],
              [139.37183678500003, 54.19586823100008],
              [139.64478600400003, 54.266058661000045],
              [139.70337975400003, 54.29596588700008],
              [139.73170006600003, 54.30414459800005],
              [139.7675887380001, 54.303941148000035],
              [139.79704837300005, 54.29743073100008],
              [139.80355879, 54.286810614000046],
              [139.79908287900003, 54.26850006700005],
              [139.7949324880001, 54.23883698100008],
              [139.80103600400003, 54.22630442900004],
              [139.81592858200008, 54.21515534100007],
              [139.87517337300005, 54.18886953300006],
              [139.883636915, 54.18732330900008],
              [139.8911238940001, 54.189520575000074],
              [139.9082137380001, 54.198919989000046],
              [139.9184676440001, 54.20034414300005],
              [139.90845787900003, 54.18886953300006],
              [139.9204207690001, 54.17568594000005],
              [140.00171959700003, 54.12299225500004],
              [140.01775149800005, 54.118353583000044],
              [140.053070509, 54.11420319200005],
              [140.240570509, 54.05695221600007],
              [140.24480228000004, 54.04437897300005],
              [140.2392684250001, 54.03424713700008],
              [140.23072350400003, 54.024318752000056],
              [140.22632897200003, 54.01227448100008],
              [140.235687696, 54.001288153000075],
              [140.25733483200008, 53.98908112200007],
              [140.28150475400003, 53.97907135600008],
              [140.29835045700008, 53.97500234600005],
              [140.3208113940001, 53.97406647300005],
              [140.33082116000003, 53.97028229400007],
              [140.33073978000004, 53.96173737200007],
              [140.32252037900003, 53.94708893400008],
              [140.30241946700005, 53.93048737200007],
              [140.272797071, 53.911444403000075],
              [140.2519637380001, 53.89057038000004],
              [140.25733483200008, 53.86855703300006],
              [140.35670006600003, 53.79002513200004],
              [140.3735457690001, 53.78278229400007],
              [140.416351759, 53.77187734600005],
              [140.51091556100005, 53.73379140800006],
              [140.52173912900003, 53.72703685100004],
              [140.52857506600003, 53.721136786000045],
              [140.53443444100003, 53.71198151200008],
              [140.53492272200003, 53.70848216400003],
              [140.53386478000004, 53.70620351800005],
              [140.53663170700008, 53.69131094000005],
              [140.53695722700002, 53.68195221600007],
              [140.53980553500003, 53.67169830900008],
              [140.54908287900003, 53.65965403900003],
              [140.58122806100005, 53.63930898600006],
              [140.65113366000003, 53.61981842700004],
              [140.71314537900003, 53.58161041900007],
              [141.02621504, 53.49213288000004],
              [141.08326256600003, 53.48216380400004],
              [141.09782962300005, 53.47475820500006],
              [141.0473738940001, 53.47846100500004],
              [140.99439537900003, 53.49518463700008],
              [140.97429446700005, 53.494126695000034],
              [140.9497176440001, 53.48895905200004],
              [140.93376712300005, 53.47650788000004],
              [140.9394637380001, 53.45359935100004],
              [140.92741946700005, 53.444525458000044],
              [140.93091881600003, 53.43634674700007],
              [140.94312584700003, 53.43260325700004],
              [140.95622806100005, 53.436835028000075],
              [140.97250410200002, 53.448431708000044],
              [140.98454837300005, 53.45184967700004],
              [140.99537194100003, 53.448431708000044],
              [141.0078231130001, 53.43992747600004],
              [141.01832116000003, 53.42885976800005],
              [141.025726759, 53.418036200000074],
              [141.03541100400003, 53.40973541900007],
              [141.08952884200005, 53.40326569200005],
              [141.124359571, 53.39276764500005],
              [141.1176863940001, 53.37523021000004],
              [141.13843834700003, 53.36204661700003],
              [141.16871178500003, 53.351263739000046],
              [141.1899520190001, 53.341009833000044],
              [141.2089949880001, 53.32562897300005],
              [141.22925866000003, 53.31598541900007],
              [141.25123131600003, 53.310980536000045],
              [141.37769616000003, 53.30963776200008],
              [141.40748131600003, 53.30377838700008],
              [141.41187584700003, 53.29364655200004],
              [141.4043074880001, 53.27798086100006],
              [141.39812259200005, 53.25560130400004],
              [141.37378991000003, 53.240301825000074],
              [141.36109459700003, 53.23004791900007],
              [141.357758009, 53.22089264500005],
              [141.36841881600003, 53.21352773600006],
              [141.38461347700002, 53.21556224200003],
              [141.40113366000003, 53.22215403900003],
              [141.41179446700005, 53.22833893400008],
              [141.42400149800005, 53.21784088700008],
              [141.41968834700003, 53.20652903900003],
              [141.412445509, 53.194973049000055],
              [141.41553795700008, 53.183294989000046],
              [141.42400149800005, 53.17487213700008],
              [141.42937259200005, 53.167303778000075],
              [141.4321395190001, 53.15916575700004],
              [141.432953321, 53.148871161000045],
              [141.42644290500004, 53.144517320000034],
              [141.38502037900003, 53.132066148000035],
              [141.3754988940001, 53.12343984600005],
              [141.34978274800005, 53.091131903000075],
              [141.36353600400003, 53.08685944200005],
              [141.36866295700008, 53.07998281500005],
              [141.36443118600005, 53.07339101800005],
              [141.34978274800005, 53.070013739000046],
              [141.33318118600005, 53.07273997600004],
              [141.2988387380001, 53.087103583000044],
              [141.28199303500003, 53.091131903000075],
              [141.25367272200003, 53.08783600500004],
              [141.23113040500004, 53.07648346600007],
              [141.21013431100005, 53.06232330900008],
              [141.18637129, 53.05019765800006],
              [141.18637129, 53.042669989000046],
              [141.2036238940001, 53.03742096600007],
              [141.22250410200002, 53.03554922100005],
              [141.26156660200002, 53.03587474200003],
              [141.25180097700002, 53.02399323100008],
              [141.21949303500003, 53.00210195500006],
              [141.188812696, 52.987494208000044],
              [141.1704207690001, 52.98346588700008],
              [141.1513778000001, 52.98338450700004],
              [141.1318465500001, 52.987494208000044],
              [140.99830162900003, 53.04364655200004],
              [140.98414147200003, 53.05329010600008],
              [140.96656334700003, 53.06195709800005],
              [140.94068444100003, 53.06948476800005],
              [140.89478600400003, 53.07684967700004],
              [140.88697350400003, 53.08340078300006],
              [140.87126712300005, 53.11196523600006],
              [140.860687696, 53.118475653000075],
              [140.77702884200005, 53.127834377000056],
              [140.72999108200008, 53.126939195000034],
              [140.70671634200005, 53.111029364000046],
              [140.7734481130001, 53.089911200000074],
              [140.82960045700008, 53.06386953300006],
              [140.8603621750001, 53.04515208500004],
              [140.87623131600003, 53.03847890800006],
              [140.93344160200002, 53.03156159100007],
              [140.9458113940001, 53.02334219000005],
              [140.94695071700005, 53.001166083000044],
              [140.9394637380001, 52.99494049700007],
              [140.94556725400003, 52.98468659100007],
              [140.95492597700002, 52.96360911700003],
              [140.96607506600003, 52.944647528000075],
              [140.96989993600005, 52.94090403900003],
              [140.9746199880001, 52.93781159100007],
              [140.98414147200003, 52.93008047100005],
              [140.99382571700005, 52.925848700000074],
              [141.00668379, 52.925116278000075],
              [141.03199303500003, 52.926662502000056],
              [141.0449324880001, 52.924261786000045],
              [141.05241946700005, 52.91860586100006],
              [141.05730228000004, 52.91156647300005],
              [141.07097415500004, 52.89667389500005],
              [141.07569420700008, 52.88979726800005],
              [141.0825301440001, 52.883978583000044],
              [141.09782962300005, 52.878241278000075],
              [141.14869225400003, 52.87201569200005],
              [141.15796959700003, 52.869208075000074],
              [141.17725670700008, 52.85561758000006],
              [141.18637129, 52.850897528000075],
              [141.1977645190001, 52.848822333000044],
              [141.26059004, 52.85224030200004],
              [141.25928795700008, 52.84662506700005],
              [141.21208743600005, 52.79759349200003],
              [141.20101972700002, 52.777411200000074],
              [141.21013431100005, 52.76837799700007],
              [141.22877037900003, 52.76325104400007],
              [141.25074303500003, 52.75079987200007],
              [141.27027428500003, 52.735256252000056],
              [141.28199303500003, 52.72125885600008],
              [141.2890731130001, 52.70111725500004],
              [141.2920028000001, 52.684759833000044],
              [141.29851321700005, 52.671128648000035],
              [141.31625410200002, 52.65912506700005],
              [141.30616295700008, 52.64948151200008],
              [141.30005944100003, 52.64142487200007],
              [141.2895613940001, 52.61758047100005],
              [141.285980665, 52.603949286000045],
              [141.2841903000001, 52.591131903000075],
              [141.280609571, 52.57876211100006],
              [141.27214603000004, 52.56663646000004],
              [141.23511803500003, 52.52631256700005],
              [141.2133895190001, 52.507879950000074],
              [141.1352645190001, 52.47052643400008],
              [141.1176863940001, 52.44896067900004],
              [141.12818444100003, 52.42291901200008],
              [141.16716556100005, 52.364894924000055],
              [141.18637129, 52.35065338700008],
              [141.234711134, 52.335638739000046],
              [141.2583113940001, 52.32371653900003],
              [141.26840254, 52.30658600500004],
              [141.27898196700005, 52.29344310100004],
              [141.34978274800005, 52.26813385600008],
              [141.36085045700008, 52.251654364000046],
              [141.3662215500001, 52.24681224200003],
              [141.39087975400003, 52.23110586100006],
              [141.40211022200003, 52.22553131700005],
              [141.41431725400003, 52.22174713700008],
              [141.46599368600005, 52.21360911700003],
              [141.48072350400003, 52.21283600500004],
              [141.52076256600003, 52.21987539300005],
              [141.52914472700002, 52.220363674000055],
              [141.53239993600005, 52.22093333500004],
              [141.5400496750001, 52.220770575000074],
              [141.54468834700003, 52.21771881700005],
              [141.5356551440001, 52.20465729400007],
              [141.5361434250001, 52.19944896000004],
              [141.53980553500003, 52.19525788000004],
              [141.5459090500001, 52.19358958500004],
              [141.5429793630001, 52.18829987200007],
              [141.5468856130001, 52.17690664300005],
              [141.5527449880001, 52.16592031500005],
              [141.55583743600005, 52.16229889500005],
              [141.55062910200002, 52.14984772300005],
              [141.53882897200003, 52.15424225500004],
              [141.51482181100005, 52.171942450000074],
              [141.500824415, 52.173814195000034],
              [141.49366295700008, 52.172308661000045],
              [141.47388756600003, 52.15888092700004],
              [141.40259850400003, 52.14020416900007],
              [141.39136803500003, 52.127834377000056],
              [141.37859134200005, 52.11798737200007],
              [141.35499108200008, 52.105902411000045],
              [141.3427840500001, 52.093817450000074],
              [141.36402428500003, 52.08372630400004],
              [141.3261824880001, 52.054022528000075],
              [141.308929884, 52.037095445000034],
              [141.30258222700002, 52.02167389500005],
              [141.31364993600005, 52.00409577000005],
              [141.3359481130001, 51.99396393400008],
              [141.36117597700002, 51.98655833500004],
              [141.3813582690001, 51.976996161000045],
              [141.41781660200002, 51.954738674000055],
              [141.42953535200002, 51.94196198100008],
              [141.42554772200003, 51.925482489000046],
              [141.40772545700008, 51.917303778000075],
              [141.35474694100003, 51.909084377000056],
              [141.34351647200003, 51.90192291900007],
              [141.33179772200003, 51.89044830900008],
              [141.28012129, 51.88031647300005],
              [141.2587996750001, 51.857489325000074],
              [141.2002059250001, 51.82367584800005],
              [141.1904403000001, 51.80560944200005],
              [141.17896569100003, 51.76821523600006],
              [141.16911868600005, 51.75104401200008],
              [141.13396243600005, 51.721136786000045],
              [141.12232506600003, 51.70502350500004],
              [141.1318465500001, 51.692694403000075],
              [141.10922285200002, 51.67877838700008],
              [140.98796634200005, 51.65924713700008],
              [140.9326278000001, 51.628241278000075],
              [140.91529381600003, 51.62384674700007],
              [140.905609571, 51.61542389500005],
              [140.90552819100003, 51.59638092700004],
              [140.9121199880001, 51.56297435100004],
              [140.9013778000001, 51.49408600500004],
              [140.8955184250001, 51.49192942900004],
              [140.8930770190001, 51.48729075700004],
              [140.89136803500003, 51.48261139500005],
              [140.88795006600003, 51.48041413000004],
              [140.85377037900003, 51.480902411000045],
              [140.84449303500003, 51.48289622600004],
              [140.83472741000003, 51.483710028000075],
              [140.8227645190001, 51.48041413000004],
              [140.803070509, 51.46710846600007],
              [140.80005944100003, 51.45416901200008],
              [140.80494225400003, 51.43976471600007],
              [140.80844160200002, 51.42210521000004],
              [140.8188582690001, 51.41673411700003],
              [140.84253991000003, 51.418036200000074],
              [140.87810306100005, 51.43268463700008],
              [140.89600670700008, 51.42877838700008],
              [140.893890821, 51.41648997600004],
              [140.88404381600003, 51.40106842700004],
              [140.87810306100005, 51.38764069200005],
              [140.87378991000003, 51.37177155200004],
              [140.86280358200008, 51.35927969000005],
              [140.84717858200008, 51.34983958500004],
              [140.82960045700008, 51.34324778900009],
              [140.74976647200003, 51.34174225500004],
              [140.70573978000004, 51.33478424700007],
              [140.68628991000003, 51.31281159100007],
              [140.69304446700005, 51.28180573100008],
              [140.70264733200008, 51.267279364000046],
              [140.70972741000003, 51.25934479400007],
              [140.71355228000004, 51.261379299000055],
              [140.70386803500003, 51.245306708000044],
              [140.66716556100005, 51.23607005400004],
              [140.65894616000003, 51.223822333000044],
              [140.66179446700005, 51.21849192900004],
              [140.67497806100005, 51.20770905200004],
              [140.67945397200003, 51.199286200000074],
              [140.680023634, 51.18976471600007],
              [140.666351759, 51.14142487200007],
              [140.667328321, 51.13141510600008],
              [140.69304446700005, 51.10993073100008],
              [140.70435631600003, 51.09235260600008],
              [140.70818118600005, 51.073553778000075],
              [140.70671634200005, 51.031683661000045],
              [140.7011824880001, 51.02187734600005],
              [140.67408287900003, 51.01471588700008],
              [140.66521243600005, 51.00812409100007],
              [140.6645613940001, 50.99750397300005],
              [140.67595462300005, 50.97650788000004],
              [140.67945397200003, 50.96653880400004],
              [140.67359459700003, 50.94830963700008],
              [140.6567488940001, 50.93781159100007],
              [140.633148634, 50.932928778000075],
              [140.6074324880001, 50.93178945500006],
              [140.59986412900003, 50.92845286700003],
              [140.54224694100003, 50.87714264500005],
              [140.5297957690001, 50.86237213700008],
              [140.5302840500001, 50.85569896000004],
              [140.54761803500003, 50.835638739000046],
              [140.5478621750001, 50.826157945000034],
              [140.54460696700005, 50.81663646000004],
              [140.54224694100003, 50.805121161000045],
              [140.53443444100003, 50.789129950000074],
              [140.49586022200003, 50.76129791900007],
              [140.48072350400003, 50.747381903000075],
              [140.475922071, 50.73700592700004],
              [140.476898634, 50.73151276200008],
              [140.47730553500003, 50.726263739000046],
              [140.46998131600003, 50.71670156500005],
              [140.4658309250001, 50.70954010600008],
              [140.4633895190001, 50.69896067900004],
              [140.46607506600003, 50.689520575000074],
              [140.4770613940001, 50.68528880400004],
              [140.4853621750001, 50.67617422100005],
              [140.51490319100003, 50.61709219000005],
              [140.49577884200005, 50.61676666900007],
              [140.48389733200008, 50.60716380400004],
              [140.46656334700003, 50.575506903000075],
              [140.44288170700008, 50.54437897300005],
              [140.44214928500003, 50.53009674700007],
              [140.45630944100003, 50.510646877000056],
              [140.5063582690001, 50.46067942900004],
              [140.51490319100003, 50.445746161000045],
              [140.5156356130001, 50.43455638200004],
              [140.51238040500004, 50.426988023000035],
              [140.511078321, 50.41937897300005],
              [140.52263431100005, 50.39911530200004],
              [140.52711022200003, 50.37641022300005],
              [140.5454207690001, 50.34406159100007],
              [140.53891035200002, 50.330145575000074],
              [140.52466881600003, 50.31663646000004],
              [140.51490319100003, 50.294907945000034],
              [140.5195418630001, 50.27944570500006],
              [140.52995853000004, 50.25849030200004],
              [140.53695722700002, 50.23607005400004],
              [140.5317488940001, 50.216131903000075],
              [140.52027428500003, 50.19554271000004],
              [140.51783287900003, 50.17328522300005],
              [140.52295983200008, 50.15106842700004],
              [140.53484134200005, 50.13043854400007],
              [140.549164259, 50.11408112200007],
              [140.586761915, 50.081244208000044],
              [140.6005965500001, 50.07518138200004],
              [140.61085045700008, 50.07802969000005],
              [140.62875410200002, 50.09170156500005],
              [140.63843834700003, 50.09634023600006],
              [140.67457116000003, 50.09821198100008],
              [140.68628991000003, 50.103176174000055],
              [140.69092858200008, 50.08026764500005],
              [140.6606551440001, 50.05801015800006],
              [140.59058678500003, 50.027411200000074],
              [140.5459090500001, 50.00071849200003],
              [140.52857506600003, 49.99331289300005],
              [140.4946395190001, 49.98354726800005],
              [140.48226972700002, 49.97528717700004],
              [140.47331790500004, 49.95913320500006],
              [140.48072350400003, 49.952337958000044],
              [140.45289147200003, 49.92479075700004],
              [140.44255618600005, 49.907456773000035],
              [140.44605553500003, 49.89085521000004],
              [140.42554772200003, 49.88344961100006],
              [140.41521243600005, 49.87457916900007],
              [140.41578209700003, 49.86269765800006],
              [140.45850670700008, 49.80560944200005],
              [140.47331790500004, 49.794623114000046],
              [140.4946395190001, 49.78880442900004],
              [140.51726321700005, 49.78554922100005],
              [140.53500410200002, 49.777411200000074],
              [140.54224694100003, 49.75678131700005],
              [140.5380965500001, 49.744208075000074],
              [140.50749759200005, 49.69163646000004],
              [140.51140384200005, 49.687567450000074],
              [140.51905358200008, 49.67674388200004],
              [140.52116946700005, 49.67177969000005],
              [140.53142337300005, 49.634100653000075],
              [140.53972415500004, 49.617254950000074],
              [140.552093946, 49.59979889500005],
              [140.56080162900003, 49.575384833000044],
              [140.55062910200002, 49.55524323100008],
              [140.52116946700005, 49.52716705900008],
              [140.51970462300005, 49.51715729400007],
              [140.519867384, 49.50340403900009],
              [140.51832116000003, 49.491400458000044],
              [140.511078321, 49.48615143400008],
              [140.50123131600003, 49.48216380400004],
              [140.49146569100003, 49.47296784100007],
              [140.46257571700005, 49.43862539300005],
              [140.45427493600005, 49.42084381700005],
              [140.44402103000004, 49.36497630400004],
              [140.43287194100003, 49.30613841400009],
              [140.4355574880001, 49.29437897300005],
              [140.35108483200008, 49.29507070500006],
              [140.3359481130001, 49.287543036000045],
              [140.3388778000001, 49.27773672100005],
              [140.35035241000003, 49.273098049000055],
              [140.36402428500003, 49.273098049000055],
              [140.38453209700003, 49.28156159100007],
              [140.39022871200007, 49.275051174000055],
              [140.38941491000003, 49.265285549000055],
              [140.38062584700003, 49.26023997600004],
              [140.37753339900007, 49.257025458000044],
              [140.35018964900007, 49.239162502000056],
              [140.3457137380001, 49.22919342700004],
              [140.3437606130001, 49.218410549000055],
              [140.34498131600003, 49.20770905200004],
              [140.35018964900007, 49.19818756700005],
              [140.35531660200002, 49.20258209800005],
              [140.36532636800007, 49.20807526200008],
              [140.37061608200008, 49.21246979400007],
              [140.37256920700008, 49.20872630400004],
              [140.3730574880001, 49.207912502000056],
              [140.3740340500001, 49.20766836100006],
              [140.37680097700002, 49.20563385600008],
              [140.3652449880001, 49.18976471600007],
              [140.35922285200002, 49.17365143400008],
              [140.36207116000003, 49.15802643400008],
              [140.37680097700002, 49.14354075700004],
              [140.36532636800007, 49.13239166900007],
              [140.3598738940001, 49.11701080900008],
              [140.3564559250001, 49.095770575000074],
              [140.34498131600003, 49.09007396000004],
              [140.32968183700007, 49.08808014500005],
              [140.2949324880001, 49.088324286000045],
              [140.2949324880001, 49.082098700000074],
              [140.33602949300007, 49.067694403000075],
              [140.3427840500001, 49.06167226800005],
              [140.34359785200002, 49.04706452000005],
              [140.33716881600003, 49.03978099200003],
              [140.29175866000003, 49.02802155200004],
              [140.2421981130001, 49.021470445000034],
              [140.2192488940001, 49.01386139500005],
              [140.235199415, 49.007513739000046],
              [140.250824415, 49.01089101800005],
              [140.26449629, 49.01227448100008],
              [140.2744246750001, 49.00018952000005],
              [140.26514733200008, 48.99494049700007],
              [140.2539168630001, 48.98541901200008],
              [140.248383009, 48.97630442900004],
              [140.25709069100003, 48.97223541900007],
              [140.26840254, 48.97443268400008],
              [140.27808678500003, 48.97752513200004],
              [140.28345787900003, 48.976263739000046],
              [140.2812606130001, 48.96539948100008],
              [140.29127037900003, 48.96478913000004],
              [140.301117384, 48.96539948100008],
              [140.29664147200003, 48.98041413000004],
              [140.30526777400007, 48.99628327000005],
              [140.32138105600006, 49.00873444200005],
              [140.3462020190001, 49.01585521000004],
              [140.3525496750001, 49.019598700000074],
              [140.35914147200003, 49.02130768400008],
              [140.36695397200003, 49.017279364000046],
              [140.36874433700007, 49.013373114000046],
              [140.36988366000003, 49.002834377000056],
              [140.37061608200008, 49.00018952000005],
              [140.38062584700003, 48.99371979400007],
              [140.38795006600003, 48.99176666900007],
              [140.39795983200008, 48.99274323100008],
              [140.37867272200003, 48.95872630400004],
              [140.3564559250001, 48.931301174000055],
              [140.35230553500003, 48.910223700000074],
              [140.3247176440001, 48.891506252000056],
              [140.266937696, 48.86237213700008],
              [140.2539168630001, 48.84804922100005],
              [140.24960371200007, 48.83698151200008],
              [140.24887129, 48.82672760600008],
              [140.2465926440001, 48.81460195500006],
              [140.23975670700008, 48.80170319200005],
              [140.22144616000003, 48.780585028000075],
              [140.21298261800007, 48.76740143400008],
              [140.20191491000003, 48.739488023000035],
              [140.19442793100006, 48.70978424700007],
              [140.18580162900003, 48.650091864000046],
              [140.1953231130001, 48.603949286000045],
              [140.19345136800007, 48.58112213700008],
              [140.17196699300007, 48.56818268400008],
              [140.17587324300007, 48.55687083500004],
              [140.18954511800007, 48.53803131700005],
              [140.19263756600003, 48.53034088700008],
              [140.1904403000001, 48.50726959800005],
              [140.18580162900003, 48.48627350500004],
              [140.17701256600003, 48.461818752000056],
              [140.1650496750001, 48.44940827000005],
              [140.12362714900007, 48.43158600500004],
              [140.08863366000003, 48.407456773000035],
              [140.07935631600003, 48.40371328300006],
              [140.07211347700002, 48.39862702000005],
              [140.0629988940001, 48.374335028000075],
              [140.05868574300007, 48.36587148600006],
              [140.05250084700003, 48.35700104400007],
              [140.0434676440001, 48.33624909100007],
              [140.03492272200003, 48.32794830900008],
              [140.0263778000001, 48.325425523000035],
              [139.99325605600006, 48.32172272300005],
              [139.95126386800007, 48.30487702000005],
              [139.77759850400003, 48.19135163000004],
              [139.76734459700003, 48.18768952000005],
              [139.73389733200008, 48.16347890800006],
              [139.72665449300007, 48.15534088700008],
              [139.71200605600006, 48.12995026200008],
              [139.6840926440001, 48.09552643400008],
              [139.65186608200008, 48.06875234600005],
              [139.56112714900007, 48.00926341400009],
              [139.51669355600006, 47.971991278000075],
              [139.50733483200008, 47.96149323100008],
              [139.49569746200007, 47.954413153000075],
              [139.4248153000001, 47.923895575000074],
              [139.39047285200002, 47.90424225500004],
              [139.2617293630001, 47.78790924700007],
              [139.24634850400003, 47.76715729400007],
              [139.23609459700003, 47.738714911000045],
              [139.21802819100003, 47.71474844000005],
              [139.2119246750001, 47.70416901200008],
              [139.2099715500001, 47.69354889500005],
              [139.20956464900007, 47.67401764500005],
              [139.20565839900007, 47.66380442900004],
              [139.18897545700008, 47.648098049000055],
              [139.168304884, 47.63613515800006],
              [139.1508895190001, 47.62177155200004],
              [139.1435653000001, 47.59870026200008],
              [139.13974043100006, 47.59349192900004],
              [139.1162215500001, 47.567613023000035],
              [139.09644616000003, 47.53351471600007],
              [139.08065839900007, 47.51276276200008],
              [139.06519616000003, 47.49632396000004],
              [139.05331464900007, 47.47870514500005],
              [139.04859459700003, 47.454331773000035],
              [139.048187696, 47.434475002000056],
              [139.0454207690001, 47.41742584800005],
              [139.03736412900003, 47.40106842700004],
              [139.0263778000001, 47.38943105700008],
              [139.02059980600006, 47.383246161000045],
              [138.99984785200002, 47.37128327000005],
              [138.99048912900003, 47.36322663000004],
              [138.98658287900003, 47.351629950000074],
              [138.984711134, 47.342230536000045],
              [138.9804793630001, 47.332464911000045],
              [138.97486412900003, 47.32367584800005],
              [138.96949303500003, 47.31753164300005],
              [138.9589949880001, 47.31342194200005],
              [138.91757246200007, 47.31439850500004],
              [138.905609571, 47.31207916900007],
              [138.89730879, 47.30906810100004],
              [138.89071699300007, 47.30516185100004],
              [138.660980665, 47.104803778000075],
              [138.61670983200008, 47.08380768400008],
              [138.59481855600006, 47.06732819200005],
              [138.56275475400003, 47.02993398600006],
              [138.53475996200007, 46.98663971600007],
              [138.51327558700007, 46.94082265800006],
              [138.5000106130001, 46.89545319200005],
              [138.50350996200007, 46.876206773000035],
              [138.50155683700007, 46.86615631700005],
              [138.49000084700003, 46.86188385600008],
              [138.4843856130001, 46.85797760600008],
              [138.40975996200007, 46.780951239000046],
              [138.3969832690001, 46.75885651200008],
              [138.36630293100006, 46.68781159100007],
              [138.35962975400003, 46.67633698100008],
              [138.34913170700008, 46.66425202000005],
              [138.34913170700008, 46.637152411000045],
              [138.3564559250001, 46.59438711100006],
              [138.344574415, 46.54873281500005],
              [138.312836134, 46.523138739000046],
              [138.2324324880001, 46.48456452000005],
              [138.20240319100003, 46.454331773000035],
              [138.11304772200003, 46.289496161000045],
              [138.10718834700003, 46.24485911700003],
              [138.10035241000003, 46.22797272300005],
              [138.03402754, 46.155951239000046],
              [138.00961347700002, 46.13646067900004],
              [137.98902428500003, 46.128241278000075],
              [137.978851759, 46.126166083000044],
              [137.96558678500003, 46.12103913000004],
              [137.95289147200003, 46.11440664300005],
              [137.94442793100006, 46.10781484600005],
              [137.94117272200003, 46.10028717700004],
              [137.94117272200003, 46.08250560100004],
              [137.93824303500003, 46.07363515800006],
              [137.924164259, 46.060980536000045],
              [137.88436933700007, 46.03424713700008],
              [137.86825605600006, 46.00849030200004],
              [137.782074415, 45.94599030200004],
              [137.7666121750001, 45.92951080900008],
              [137.7529403000001, 45.896551825000074],
              [137.70468183700007, 45.85447825700004],
              [137.68580162900003, 45.815334377000056],
              [137.67147871200007, 45.794623114000046],
              [137.6386824880001, 45.77903880400004],
              [137.5244246750001, 45.68935781500005],
              [137.49496504, 45.678900458000044],
              [137.39673912900003, 45.623928127000056],
              [137.3359481130001, 45.57062409100007],
              [137.26620527400007, 45.48590729400007],
              [137.2563582690001, 45.47711823100008],
              [137.236664259, 45.47260163000004],
              [137.21949303500003, 45.461004950000074],
              [137.1445418630001, 45.374660549000055],
              [137.12574303500003, 45.36733633000006],
              [137.10328209700003, 45.36375560100004],
              [137.08277428500003, 45.35521067900004],
              [136.92636152400007, 45.25438060100004],
              [136.825531446, 45.20408763200004],
              [136.81080162900003, 45.19318268400008],
              [136.80030358200008, 45.17527903900009],
              [136.78858483200008, 45.128119208000044],
              [136.78003991000003, 45.107855536000045],
              [136.7607528000001, 45.087876695000034],
              [136.71851647200003, 45.06736888200004],
              [136.70093834700003, 45.056341864000046],
              [136.69800866000003, 45.05255768400008],
              [136.6914168630001, 45.04116445500006],
              [136.69052168100006, 45.03896719000005],
              [136.68433678500003, 45.03790924700007],
              [136.66944420700008, 45.040228583000044],
              [136.66334069100003, 45.03896719000005],
              [136.65650475400003, 45.03339264500005],
              [136.57764733200008, 44.95294830900008],
              [136.571625196, 44.95026276200008],
              [136.564789259, 44.949652411000045],
              [136.55819746200007, 44.94830963700008],
              [136.55347741000003, 44.943345445000034],
              [136.553070509, 44.93789297100005],
              [136.5551863940001, 44.93195221600007],
              [136.55811608200008, 44.92812734600005],
              [136.56031334700003, 44.92910390800006],
              [136.55811608200008, 44.91844310100004],
              [136.5566512380001, 44.902044989000046],
              [136.55347741000003, 44.894964911000045],
              [136.51587975400003, 44.875067450000074],
              [136.5102645190001, 44.86969635600008],
              [136.49830162900003, 44.845770575000074],
              [136.4882918630001, 44.840277411000045],
              [136.47803795700008, 44.83930084800005],
              [136.46762129, 44.83661530200004],
              [136.4580184250001, 44.83226146000004],
              [136.45028730600006, 44.82664622600004],
              [136.4472762380001, 44.818060614000046],
              [136.44361412900003, 44.78510163000004],
              [136.426117384, 44.772650458000044],
              [136.40845787900003, 44.776678778000075],
              [136.3886824880001, 44.786810614000046],
              [136.36475670700008, 44.79254791900007],
              [136.35458418100006, 44.78880442900004],
              [136.349945509, 44.77985260600008],
              [136.34693444100003, 44.76850006700005],
              [136.34107506600003, 44.75775788000004],
              [136.3349715500001, 44.75275299700007],
              [136.32699629, 44.74884674700007],
              [136.31763756600003, 44.74599844000005],
              [136.306976759, 44.74408600500004],
              [136.31202233200008, 44.73322174700007],
              [136.321136915, 44.72500234600005],
              [136.32984459700003, 44.71865469000005],
              [136.33375084700003, 44.71369049700007],
              [136.32886803500003, 44.70734284100007],
              [136.317718946, 44.70180898600006],
              [136.30543053500003, 44.69782135600008],
              [136.27450605600006, 44.69293854400007],
              [136.2607528000001, 44.683579820000034],
              [136.2353621750001, 44.651678778000075],
              [136.22730553500003, 44.63104889500005],
              [136.23316491000003, 44.58608633000006],
              [136.22811933700007, 44.56972890800006],
              [136.21900475400003, 44.56537506700005],
              [136.20883222700002, 44.56419505400004],
              [136.200531446, 44.560532945000034],
              [136.19516035200002, 44.53896719000005],
              [136.1860457690001, 44.521144924000055],
              [136.1840926440001, 44.51508209800005],
              [136.16529381600003, 44.496527411000045],
              [136.12256920700008, 44.47553131700005],
              [136.04639733200008, 44.44989655200004],
              [136.03402754, 44.450832424000055],
              [136.00904381600003, 44.45693594000005],
              [135.9985457690001, 44.45612213700008],
              [135.9931746750001, 44.45197174700007],
              [135.98934980600006, 44.44057851800005],
              [135.9848738940001, 44.435614325000074],
              [135.95093834700003, 44.42011139500005],
              [135.9082137380001, 44.40961334800005],
              [135.8886824880001, 44.40151601800005],
              [135.8808699880001, 44.393744208000044],
              [135.8720809250001, 44.38226959800005],
              [135.86215254, 44.37189362200007],
              [135.8379012380001, 44.36269765800006],
              [135.83570397200003, 44.35171133000006],
              [135.8408309250001, 44.32949453300006],
              [135.83456464900007, 44.31122467700004],
              [135.81942793100006, 44.29059479400007],
              [135.78622480600006, 44.25812409100007],
              [135.766937696, 44.250433661000045],
              [135.74227949300007, 44.24494049700007],
              [135.72095787900003, 44.23655833500004],
              [135.711761915, 44.22028229400007],
              [135.70484459700003, 44.19839101800005],
              [135.6884871750001, 44.187160549000055],
              [135.6699324880001, 44.17959219000005],
              [135.65585371200007, 44.16868724200003],
              [135.6508895190001, 44.15761953300006],
              [135.6494246750001, 44.145697333000044],
              [135.65211022200003, 44.134100653000075],
              [135.65927168100006, 44.12400950700004],
              [135.65967858200008, 44.116441148000035],
              [135.65308678500003, 44.10602448100008],
              [135.63851972700002, 44.08930084800005],
              [135.62850996200007, 44.06854889500005],
              [135.62842858200008, 44.05219147300005],
              [135.6240340500001, 44.03847890800006],
              [135.60132897200003, 44.025376695000034],
              [135.560883009, 44.01439036700003],
              [135.54127037900003, 44.003973700000074],
              [135.53296959700003, 43.987209377000056],
              [135.5341903000001, 43.96784088700008],
              [135.53296959700003, 43.96263255400004],
              [135.52987714900007, 43.95978424700007],
              [135.52515709700003, 43.95783112200007],
              [135.51880944100003, 43.95648834800005],
              [135.51197350400003, 43.92169830900008],
              [135.50538170700008, 43.931708075000074],
              [135.4931746750001, 43.94391510600008],
              [135.47828209700003, 43.95197174700007],
              [135.46363366000003, 43.949652411000045],
              [135.45875084700003, 43.93817780200004],
              [135.46640058700007, 43.925482489000046],
              [135.4726668630001, 43.91111888200004],
              [135.46363366000003, 43.89443594000005],
              [135.47934004, 43.89398834800005],
              [135.48462975400003, 43.89443594000005],
              [135.48462975400003, 43.88751862200007],
              [135.480804884, 43.87799713700008],
              [135.49000084700003, 43.87864817900004],
              [135.51880944100003, 43.88751862200007],
              [135.51880944100003, 43.88076406500005],
              [135.48788496200007, 43.83270905200004],
              [135.47437584700003, 43.825506903000075],
              [135.47250410200002, 43.81810130400004],
              [135.42929121200007, 43.77830638200004],
              [135.42953535200002, 43.77130768400008],
              [135.4257918630001, 43.76316966400009],
              [135.41773522200003, 43.758978583000044],
              [135.39014733200008, 43.75482819200005],
              [135.3813582690001, 43.74746328300006],
              [135.37509199300007, 43.738348700000074],
              [135.36793053500003, 43.72992584800005],
              [135.35922285200002, 43.722316799000055],
              [135.35499108200008, 43.71946849200003],
              [135.33961022200003, 43.71539948100008],
              [135.33114668100006, 43.716457424000055],
              [135.3232528000001, 43.71653880400004],
              [135.3164168630001, 43.71283600500004],
              [135.30917402400007, 43.70677317900004],
              [135.28541100400003, 43.69188060100004],
              [135.2754012380001, 43.68895091400009],
              [135.2597762380001, 43.69375234600005],
              [135.2563582690001, 43.70453522300005],
              [135.25806725400003, 43.71625397300005],
              [135.25806725400003, 43.72370026200008],
              [135.249359571, 43.72943756700005],
              [135.23560631600003, 43.734076239000046],
              [135.22323652400007, 43.73261139500005],
              [135.21762129, 43.719956773000035],
              [135.21021569100003, 43.71369049700007],
              [135.18222089900007, 43.710638739000046],
              [135.1836043630001, 43.703192450000074],
              [135.19605553500003, 43.696478583000044],
              [135.20883222700002, 43.69546133000006],
              [135.22095787900003, 43.693019924000055],
              [135.23072350400003, 43.68211497600004],
              [135.22681725400003, 43.68219635600008],
              [135.22486412900003, 43.66836172100005],
              [135.22388756600003, 43.644598700000074],
              [135.219574415, 43.63495514500005],
              [135.21021569100003, 43.63043854400007],
              [135.20077558700007, 43.627834377000056],
              [135.19654381600003, 43.62409088700008],
              [135.176117384, 43.59332916900007],
              [135.17212975400003, 43.58356354400007],
              [135.16724694100003, 43.56655508000006],
              [135.162445509, 43.558579820000034],
              [135.15390058700007, 43.55125560100004],
              [135.144867384, 43.546128648000035],
              [135.13795006600003, 43.539496161000045],
              [135.1352645190001, 43.52789948100008],
              [135.13624108200008, 43.52496979400007],
              [135.1386824880001, 43.523098049000055],
              [135.14087975400003, 43.52016836100006],
              [135.14210045700008, 43.51422760600008],
              [135.13990319100003, 43.50836823100008],
              [135.1352645190001, 43.50560130400004],
              [135.13062584700003, 43.50372955900008],
              [135.12842858200008, 43.50055573100008],
              [135.11532636800007, 43.50067780200004],
              [135.05616295700008, 43.48810455900008],
              [134.97470136800007, 43.45954010600008],
              [134.9638778000001, 43.452460028000075],
              [134.956390821, 43.43634674700007],
              [134.938324415, 43.426988023000035],
              [134.8955184250001, 43.415228583000044],
              [134.8735457690001, 43.40497467700004],
              [134.83570397200003, 43.37970612200007],
              [134.77027428500003, 43.31525299700007],
              [134.7509871750001, 43.30536530200004],
              [134.72803795700008, 43.312567450000074],
              [134.70289147200003, 43.30418528900009],
              [134.6801863940001, 43.288763739000046],
              [134.66529381600003, 43.274318752000056],
              [134.65601647200003, 43.267238674000055],
              [134.633636915, 43.26154205900008],
              [134.62118574300007, 43.25698476800005],
              [134.61312910200002, 43.25112539300005],
              [134.59725996200007, 43.236029364000046],
              [134.58716881600003, 43.22898997600004],
              [134.56006920700008, 43.234808661000045],
              [134.53036543100006, 43.220363674000055],
              [134.47730553500003, 43.18183014500005],
              [134.43043053500003, 43.157904364000046],
              [134.40943444100003, 43.15216705900008],
              [134.375824415, 43.13849518400008],
              [134.3574324880001, 43.12555573100008],
              [134.34791100400003, 43.12156810100004],
              [134.3379012380001, 43.120428778000075],
              [134.32138105600006, 43.127386786000045],
              [134.31454511800007, 43.123480536000045],
              [134.30591881600003, 43.11359284100007],
              [134.255218946, 43.09552643400008],
              [134.2407332690001, 43.09247467700004],
              [134.22388756600003, 43.09080638200004],
              [134.207855665, 43.08633047100005],
              [134.193695509, 43.079779364000046],
              [134.18238366000003, 43.071966864000046],
              [134.17831464900007, 43.06659577000005],
              [134.17603600400003, 43.05487702000005],
              [134.1718856130001, 43.048041083000044],
              [134.165375196, 43.04433828300006],
              [134.14795983200008, 43.04018789300005],
              [134.14087975400003, 43.03725820500006],
              [134.12964928500003, 43.024603583000044],
              [134.12037194100003, 43.008978583000044],
              [134.10849043100006, 42.99567291900007],
              [134.06983483200008, 42.98505280200004],
              [134.04957116000003, 42.97329336100006],
              [133.9267684250001, 42.88271719000005],
              [133.9106551440001, 42.87982819200005],
              [133.89625084700003, 42.88491445500006],
              [133.87134850400003, 42.899318752000056],
              [133.86451256600003, 42.90119049700007],
              [133.85035241000003, 42.90070221600007],
              [133.83961022200003, 42.89760976800005],
              [133.81845136800007, 42.88393789300005],
              [133.794281446, 42.87669505400004],
              [133.72999108200008, 42.84544505400004],
              [133.723968946, 42.82518138200004],
              [133.7172957690001, 42.81663646000004],
              [133.70630944100003, 42.82245514500005],
              [133.6777449880001, 42.848822333000044],
              [133.67164147200003, 42.852850653000075],
              [133.642914259, 42.85382721600007],
              [133.633636915, 42.852850653000075],
              [133.614105665, 42.84638092700004],
              [133.60499108200008, 42.84625885600008],
              [133.59335371200007, 42.852850653000075],
              [133.58944746200007, 42.84247467700004],
              [133.5849715500001, 42.835638739000046],
              [133.57919355600006, 42.83075592700004],
              [133.5722762380001, 42.826239325000074],
              [133.5517684250001, 42.81875234600005],
              [133.54550214900007, 42.81972890800006],
              [133.5244246750001, 42.826239325000074],
              [133.51197350400003, 42.82172272300005],
              [133.50766035200002, 42.81696198100008],
              [133.50513756600003, 42.811428127000056],
              [133.49781334700003, 42.80442942900004],
              [133.48804772200003, 42.79995351800005],
              [133.46802819100003, 42.79319896000004],
              [133.4443465500001, 42.77912018400008],
              [133.42017662900003, 42.77142975500004],
              [133.3774520190001, 42.76349518400008],
              [133.3183699880001, 42.76581452000005],
              [133.29859459700003, 42.76349518400008],
              [133.23739668100006, 42.74396393400008],
              [133.22291100400003, 42.73623281500005],
              [133.193695509, 42.70677317900004],
              [133.1777449880001, 42.693793036000045],
              [133.15772545700008, 42.68842194200005],
              [133.06202233200008, 42.68842194200005],
              [133.03768964900007, 42.691392320000034],
              [133.0244246750001, 42.69936758000006],
              [133.01343834700003, 42.71035390800006],
              [132.99634850400003, 42.72256094000005],
              [133.008636915, 42.727850653000075],
              [133.02686608200008, 42.73965078300006],
              [133.038422071, 42.74298737200007],
              [133.05184980600006, 42.74119700700004],
              [133.06617272200003, 42.73737213700008],
              [133.0766707690001, 42.73810455900008],
              [133.07886803500003, 42.74982330900008],
              [133.0673934250001, 42.76284414300005],
              [133.04322350400003, 42.77960846600007],
              [132.99634850400003, 42.80442942900004],
              [133.00660241000003, 42.81549713700008],
              [133.01050866000003, 42.81875234600005],
              [132.98975670700008, 42.82697174700007],
              [132.963226759, 42.82607656500005],
              [132.91163170700008, 42.81875234600005],
              [132.90048261800007, 42.81557851800005],
              [132.89039147200003, 42.80849844000005],
              [132.88746178500003, 42.80145905200004],
              [132.89795983200008, 42.79828522300005],
              [132.90015709700003, 42.79393138200004],
              [132.8877059250001, 42.76349518400008],
              [132.875336134, 42.755926825000074],
              [132.86500084700003, 42.748114325000074],
              [132.85230553500003, 42.74648672100005],
              [132.8330184250001, 42.74982330900008],
              [132.81592858200008, 42.75641510600008],
              [132.8051863940001, 42.76581452000005],
              [132.7915145190001, 42.79083893400008],
              [132.79843183700007, 42.80841705900008],
              [132.79110761800007, 42.82050202000005],
              [132.7754012380001, 42.828111070000034],
              [132.75733483200008, 42.83242422100005],
              [132.76636803500003, 42.85179271000004],
              [132.77369225400003, 42.875067450000074],
              [132.7744246750001, 42.89590078300006],
              [132.76343834700003, 42.90814850500004],
              [132.73975670700008, 42.90717194200005],
              [132.70370527400007, 42.87872955900008],
              [132.6816512380001, 42.87335846600007],
              [132.68628991000003, 42.868841864000046],
              [132.69117272200003, 42.86273834800005],
              [132.6953231130001, 42.85968659100007],
              [132.68319746200007, 42.85569896000004],
              [132.6372176440001, 42.85968659100007],
              [132.61890709700003, 42.85919830900008],
              [132.60816491000003, 42.85683828300006],
              [132.6001082690001, 42.851629950000074],
              [132.58912194100003, 42.84235260600008],
              [132.57789147200003, 42.84039948100008],
              [132.56470787900003, 42.84625885600008],
              [132.54444420700008, 42.85968659100007],
              [132.51783287900003, 42.86595286700003],
              [132.51050866000003, 42.87140534100007],
              [132.50342858200008, 42.88703034100007],
              [132.50342858200008, 42.900091864000046],
              [132.5058699880001, 42.91364166900007],
              [132.50269616000003, 42.92430247600004],
              [132.48609459700003, 42.928615627000056],
              [132.42831464900007, 42.935980536000045],
              [132.41334069100003, 42.941107489000046],
              [132.40438886800007, 42.942287502000056],
              [132.39706464900007, 42.93935781500005],
              [132.39527428500003, 42.93276601800005],
              [132.39559980600006, 42.925767320000034],
              [132.39413496200007, 42.92177969000005],
              [132.36630293100006, 42.915676174000055],
              [132.35425866000003, 42.91083405200004],
              [132.34579511800007, 42.90070221600007],
              [132.35018964900007, 42.89663320500006],
              [132.35531660200002, 42.88751862200007],
              [132.36011803500003, 42.88080475500004],
              [132.35523522200003, 42.875067450000074],
              [132.3535262380001, 42.87026601800005],
              [132.35523522200003, 42.86546458500004],
              [132.36011803500003, 42.85968659100007],
              [132.34839928500003, 42.85492584800005],
              [132.32569420700008, 42.85146719000005],
              [132.3183699880001, 42.84544505400004],
              [132.3115340500001, 42.84544505400004],
              [132.28931725400003, 42.88271719000005],
              [132.28768964900007, 42.89044830900008],
              [132.29452558700007, 42.902777411000045],
              [132.29566491000003, 42.91754791900007],
              [132.29110761800007, 42.94912344000005],
              [132.29957116000003, 42.99713776200008],
              [132.3012801440001, 43.02391185100004],
              [132.29110761800007, 43.044623114000046],
              [132.3032332690001, 43.053168036000045],
              [132.30494225400003, 43.06403229400007],
              [132.2998153000001, 43.075506903000075],
              [132.29110761800007, 43.085638739000046],
              [132.30746504, 43.08661530200004],
              [132.32056725400003, 43.094183661000045],
              [132.32569420700008, 43.10626862200007],
              [132.3183699880001, 43.120428778000075],
              [132.32479902400007, 43.12295156500005],
              [132.33375084700003, 43.130194403000075],
              [132.33961022200003, 43.134019273000035],
              [132.33277428500003, 43.138332424000055],
              [132.32593834700003, 43.14085521000004],
              [132.327484571, 43.14899323100008],
              [132.32764733200008, 43.17059967700004],
              [132.3291121750001, 43.174994208000044],
              [132.33936608200008, 43.17365143400008],
              [132.3481551440001, 43.17145416900007],
              [132.35653730600006, 43.17096588700008],
              [132.36695397200003, 43.174994208000044],
              [132.38168379, 43.19122955900008],
              [132.37606855600006, 43.204738674000055],
              [132.35897871200007, 43.21552155200004],
              [132.31714928500003, 43.231350002000056],
              [132.30770918100006, 43.23818594000005],
              [132.30844160200002, 43.24701569200005],
              [132.316742384, 43.25189850500004],
              [132.340668165, 43.26154205900008],
              [132.34579511800007, 43.26715729400007],
              [132.34921308700007, 43.27920156500005],
              [132.354828321, 43.282538153000075],
              [132.35621178500003, 43.28595612200007],
              [132.34579511800007, 43.29791901200008],
              [132.3149520190001, 43.315659898000035],
              [132.30543053500003, 43.31903717700004],
              [132.2895613940001, 43.312567450000074],
              [132.28199303500003, 43.278509833000044],
              [132.26050866000003, 43.27057526200008],
              [132.25399824300007, 43.266506252000056],
              [132.242523634, 43.24551015800006],
              [132.23593183700007, 43.23651764500005],
              [132.22665449300007, 43.229803778000075],
              [132.13681074300007, 43.19163646000004],
              [132.11646569100003, 43.188666083000044],
              [132.09595787900003, 43.180975653000075],
              [132.07545006600003, 43.16303131700005],
              [132.04420006600003, 43.12726471600007],
              [132.029633009, 43.116522528000075],
              [131.99130293100006, 43.09585195500006],
              [131.972015821, 43.08250560100004],
              [131.95224043100006, 43.071966864000046],
              [131.92994225400003, 43.069566148000035],
              [131.9072371750001, 43.07440827000005],
              [131.88648522200003, 43.085638739000046],
              [131.89625084700003, 43.095363674000055],
              [131.90796959700003, 43.10106028900009],
              [131.91724694100003, 43.107855536000045],
              [131.92066491000003, 43.120428778000075],
              [131.87094160200002, 43.09031810100004],
              [131.85914147200003, 43.085638739000046],
              [131.84717858200008, 43.089911200000074],
              [131.84986412900003, 43.100490627000056],
              [131.8794051440001, 43.13739655200004],
              [131.90015709700003, 43.18183014500005],
              [131.91171308700007, 43.19757721600007],
              [131.92367597700002, 43.20783112200007],
              [131.95858808700007, 43.22992584800005],
              [131.97803795700008, 43.235541083000044],
              [131.99683678500003, 43.238714911000045],
              [132.0004988940001, 43.24453359600005],
              [132.0019637380001, 43.25218333500004],
              [132.00660241000003, 43.26032135600008],
              [132.0449324880001, 43.286444403000075],
              [132.05152428500003, 43.29791901200008],
              [132.05201256600003, 43.31476471600007],
              [132.04444420700008, 43.32436758000006],
              [132.03101647200003, 43.32514069200005],
              [132.014008009, 43.315619208000044],
              [132.00350996200007, 43.29950592700004],
              [131.99984785200002, 43.284084377000056],
              [131.99203535200002, 43.273098049000055],
              [131.96835371200007, 43.27057526200008],
              [131.97811933700007, 43.29205963700008],
              [131.95679772200003, 43.305853583000044],
              [131.89527428500003, 43.31863027600008],
              [131.8847762380001, 43.31777578300006],
              [131.85694420700008, 43.30731842700004],
              [131.846039259, 43.30536530200004],
              [131.8320418630001, 43.309881903000075],
              [131.82601972700002, 43.31793854400007],
              [131.8281356130001, 43.32640208500004],
              [131.83863366000003, 43.33270905200004],
              [131.8266707690001, 43.337958075000074],
              [131.81568444100003, 43.33673737200007],
              [131.8076278000001, 43.330959377000056],
              [131.80453535200002, 43.32208893400008],
              [131.7993270190001, 43.31586334800005],
              [131.77418053500003, 43.302069403000075],
              [131.76425214900007, 43.29169342700004],
              [131.7563582690001, 43.263739325000074],
              [131.7568465500001, 43.24249909100007],
              [131.7504988940001, 43.22528717700004],
              [131.7226668630001, 43.20978424700007],
              [131.7226668630001, 43.202337958000044],
              [131.74170983200008, 43.20148346600007],
              [131.7583113940001, 43.195379950000074],
              [131.76392662900003, 43.18585846600007],
              [131.74984785200002, 43.174994208000044],
              [131.73072350400003, 43.17413971600007],
              [131.71753991000003, 43.184475002000056],
              [131.70663496200007, 43.19684479400007],
              [131.694672071, 43.202337958000044],
              [131.68384850400003, 43.199286200000074],
              [131.67953535200002, 43.19367096600007],
              [131.67782636800007, 43.18732330900008],
              [131.674164259, 43.18183014500005],
              [131.65113366000003, 43.169623114000046],
              [131.6469832690001, 43.168850002000056],
              [131.65145918100006, 43.15599192900004],
              [131.66675866000003, 43.15688711100006],
              [131.6840926440001, 43.165228583000044],
              [131.694672071, 43.174994208000044],
              [131.68336022200003, 43.148504950000074],
              [131.664886915, 43.12518952000005],
              [131.586761915, 43.04995351800005],
              [131.5629988940001, 43.038316148000035],
              [131.56373131600003, 43.02383047100005],
              [131.56763756600003, 43.00755442900004],
              [131.5649520190001, 42.99628327000005],
              [131.5478621750001, 42.99310944200005],
              [131.53296959700003, 43.00226471600007],
              [131.51767011800007, 43.00934479400007],
              [131.49952233200008, 42.999986070000034],
              [131.49195397200003, 42.98432038000004],
              [131.49488366000003, 42.97060781500005],
              [131.499359571, 42.957098700000074],
              [131.4961043630001, 42.942287502000056],
              [131.49195397200003, 42.94489166900007],
              [131.47730553500003, 42.94196198100008],
              [131.4550887380001, 42.934759833000044],
              [131.43824303500003, 42.93414948100008],
              [131.42994225400003, 42.93504466400009],
              [131.40552819100003, 42.95062897300005],
              [131.393890821, 42.945013739000046],
              [131.38795006600003, 42.930121161000045],
              [131.38624108200008, 42.91429271000004],
              [131.40634199300007, 42.91006094000005],
              [131.41073652400007, 42.90094635600008],
              [131.4004012380001, 42.87335846600007],
              [131.4589949880001, 42.884426174000055],
              [131.47193444100003, 42.88393789300005],
              [131.4716903000001, 42.87323639500005],
              [131.45614668100006, 42.86383698100008],
              [131.43637129, 42.85578034100007],
              [131.40902754, 42.83934153900009],
              [131.3789168630001, 42.83112213700008],
              [131.3657332690001, 42.81875234600005],
              [131.3603621750001, 42.806626695000034],
              [131.35962975400003, 42.794256903000075],
              [131.363617384, 42.78217194200005],
              [131.352017262, 42.77432756700006],
              [131.300134285, 42.793276509000066],
              [131.27312717100006, 42.777331349000065],
              [131.257069129, 42.751560565000034],
              [131.24689629800002, 42.73253378000004],
              [131.23644697300006, 42.70664411200005],
              [131.24960371200007, 42.694566148000035],
              [131.25180097700002, 42.69082265800006],
              [131.261078321, 42.68805573100008],
              [131.26327558700007, 42.68500397300005],
              [131.26229902400007, 42.68109772300005],
              [131.25806725400003, 42.67523834800005],
              [131.25709069100003, 42.67133209800005],
              [131.25416100400003, 42.66819896000004],
              [131.2470809250001, 42.667303778000075],
              [131.23267662900003, 42.66791413000004],
              [131.22421308700007, 42.660589911000045],
              [131.21656334700003, 42.644191799000055],
              [131.20901679200006, 42.63629456400008],
              [131.20978388800006, 42.62261286900008],
              [131.20348331800005, 42.61906297100006],
              [131.20118160800007, 42.61402459700008],
              [131.20801004600003, 42.60852199400006],
              [131.224301405, 42.604925973000036],
              [131.22873617900007, 42.59712517600008],
              [131.22797025600005, 42.59167613500006],
              [131.2340899510001, 42.588854379000054],
              [131.23404707500003, 42.58726215200005],
              [131.2180499530001, 42.586132080000084],
              [131.21275056900004, 42.58393863500004],
              [131.22437584700003, 42.57062409100007],
              [131.22155991, 42.56630424200006],
              [131.21954721100008, 42.554711688000054],
              [131.213275286, 42.551392855000074],
              [131.20375066600002, 42.557243723000056],
              [131.1945602400001, 42.55896653100007],
              [131.18534559800003, 42.559550184000045],
              [131.17963704800002, 42.56400309500009],
              [131.17099043100006, 42.57294342700004],
              [131.1670028000001, 42.57562897300005],
              [131.1670028000001, 42.58539459800005],
              [131.17115319100003, 42.585272528000075],
              [131.17919651, 42.59438159300004],
              [131.1806497450001, 42.60520533400006],
              [131.158494367, 42.60130537100008],
              [131.1435653000001, 42.61269765800006],
              [131.12690303800002, 42.617256069000064],
              [131.12741468000002, 42.646809776000055],
              [131.12034658100004, 42.66719049100004],
              [131.1057008360001, 42.668348482000056],
              [131.09288647000005, 42.654887733000066],
              [131.08702706300005, 42.64037532800006],
              [131.073578321, 42.63886139500005],
              [131.03443444100003, 42.64520905200004],
              [130.99488366000003, 42.640692450000074],
              [130.9524804450001, 42.627797814000076],
              [130.93116295700008, 42.60691966400009],
              [130.91431725400003, 42.60150788000004],
              [130.8896590500001, 42.599595445000034],
              [130.87256920700008, 42.603949286000045],
              [130.83250570100006, 42.62577466200008],
              [130.81547842700002, 42.63417157900005],
              [130.8385870840001, 42.64299477900005],
              [130.86287555900003, 42.64081616400006],
              [130.88948072300002, 42.63861172800006],
              [130.9115129810001, 42.61682641200008],
              [130.9321395190001, 42.618353583000044],
              [130.94459069100003, 42.63117096600007],
              [130.949713986, 42.65312261400004],
              [130.93178110200006, 42.65750928300008],
              [130.89944468500005, 42.65463145600006],
              [130.881524581, 42.658987952000075],
              [130.8478326820001, 42.66131692700009],
              [130.8034407350001, 42.651151406000054],
              [130.78698147900002, 42.65376356300004],
              [130.79594714100006, 42.662849545000086],
              [130.8320418630001, 42.67405833500004],
              [130.83700960800002, 42.69159188900005],
              [130.825456917, 42.69932245800004],
              [130.8017859790001, 42.696845163000035],
              [130.78186638600005, 42.69028216700008],
              [130.76929772200003, 42.68158600500004],
              [130.74534894300007, 42.68109583000006],
              [130.73466741000004, 42.691689334000046],
              [130.7207578020001, 42.70002462500008],
              [130.69352581300006, 42.68545034500005],
              [130.65667038900006, 42.66407951200006],
              [130.66078899700005, 42.643184543000075],
              [130.68344160200002, 42.64354075700004],
              [130.7329207690001, 42.61554596600007],
              [130.73690839900007, 42.60724518400008],
              [130.7295028000001, 42.57916901200008],
              [130.75464928500003, 42.59723541900007],
              [130.763031446, 42.599595445000034],
              [130.77418053500003, 42.59682851800005],
              [130.77808678500003, 42.591131903000075],
              [130.77955162900003, 42.58466217700004],
              [130.783539259, 42.57916901200008],
              [130.842133009, 42.55853913000004],
              [130.85181725400003, 42.54779694200005],
              [130.85499108200008, 42.53925202000005],
              [130.8696395190001, 42.53546784100007],
              [130.87289472700002, 42.52765534100007],
              [130.87020918100006, 42.51797109600005],
              [130.864593946, 42.517279364000046],
              [130.859711134, 42.52106354400007],
              [130.85849043100006, 42.52456289300005],
              [130.8505965500001, 42.52000560100004],
              [130.84644616000003, 42.520697333000044],
              [130.84302819100003, 42.51976146000004],
              [130.83814537900003, 42.51023997600004],
              [130.8383895190001, 42.506293036000045],
              [130.8437606130001, 42.49396393400008],
              [130.84498131600003, 42.486314195000034],
              [130.83871504, 42.472357489000046],
              [130.8232528000001, 42.46503327000005],
              [130.80420983200008, 42.46234772300005],
              [130.78663170700008, 42.46185944200005],
              [130.78077233200008, 42.45343659100007],
              [130.763031446, 42.400376695000034],
              [130.752750267, 42.38077658900005],
              [130.743193851, 42.353687070000035],
              [130.73480510900004, 42.33759791400007],
              [130.70360316000006, 42.29524132000006],
              [130.69996178500003, 42.29511139500005],
              [130.67288130800006, 42.31113942500009],
              [130.662752726, 42.32057037400007],
              [130.66027225800013, 42.3339287320001],
              [130.66058231600005, 42.35919850700007],
              [130.65665490700007, 42.383253886],
              [130.6458028570001, 42.400875549],
              [130.6285429290001, 42.414802348000066],
              [130.60590865100005, 42.42061594700006],
              [130.58740848900004, 42.432010600000055],
              [130.57562626200001, 42.44573069300007],
              [130.55877974500004, 42.4827051810001],
              [130.55474898300008, 42.48761444100005],
              [130.54989139900016, 42.49037913100001],
              [130.546067343, 42.49528839100013],
              [130.5445170490001, 42.50629547200002],
              [130.5426566980001, 42.51053293900007],
              [130.53077111900006, 42.53048004200009],
              [130.56756473800016, 42.55275258400006],
              [130.58451460800006, 42.56890146900004],
              [130.5843079020001, 42.598899639000095],
              [130.57190555900002, 42.621818136000016],
              [130.55113163300007, 42.645615133],
              [130.52674035600006, 42.66576894100005],
              [130.50389937400007, 42.67780955100004],
              [130.47434045400013, 42.67904978500006],
              [130.43806359900015, 42.67530324400006],
              [130.40375044800015, 42.67755116800005],
              [130.3796692310001, 42.69667144800006],
              [130.40716109200008, 42.73537709600008],
              [130.49098026600012, 42.780826518000126],
              [130.5864783130001, 42.817258403000025],
              [130.64911014900008, 42.828937277000094],
              [130.73096561700004, 42.825888367000076],
              [130.734893026, 42.82449310300008],
              [130.74801884000016, 42.837489726000015],
              [130.75680383300005, 42.85327687600001],
              [130.76951623600013, 42.865808411],
              [130.79432092300016, 42.869064026],
              [130.8165417890001, 42.86405141200002],
              [130.856229289, 42.84976287800005],
              [130.9924483650001, 42.848729350000056],
              [130.999579713, 42.8587545780001],
              [131.00195682900005, 42.873301493000056],
              [131.00877811700002, 42.88689239500003],
              [131.0238676360001, 42.8962716680001],
              [131.039473918, 42.89800282900005],
              [131.07399377400014, 42.896581726000065],
              [131.10303592900004, 42.91043101000004],
              [131.09931522600004, 42.935442403000124],
              [131.08277876900002, 42.96523386700004],
              [131.07430383400003, 42.99339752200008],
              [131.0752340090001, 43.019597473],
              [131.078334595, 43.031818950000016],
              [131.0854659430001, 43.04210256],
              [131.094044231, 43.046830953],
              [131.11244104000002, 43.05186940600005],
              [131.11988244600002, 43.05900075300009],
              [131.12298303300014, 43.06773407000007],
              [131.12401656100013, 43.07535634400004],
              [131.12660038300015, 43.08238433900006],
              [131.13435184700006, 43.08933481900006],
              [131.16938846800008, 43.10780914400006],
              [131.1839612230001, 43.120805766],
              [131.18985233600011, 43.139150899000086],
              [131.18489139800016, 43.15633331300005],
              [131.17496952300007, 43.16839976100003],
              [131.16721805900016, 43.18155141200002],
              [131.16907841, 43.20170522100007],
              [131.17858687400008, 43.21738901800005],
              [131.193056275, 43.23079905300007],
              [131.225509074, 43.251934713000125],
              [131.2377047120001, 43.26583567400009],
              [131.242045533, 43.28376739500008],
              [131.24245894400013, 43.32141367600009],
              [131.24793664600008, 43.344202982000084],
              [131.25775516800007, 43.355726828000016],
              [131.26964074800003, 43.36474436500008],
              [131.28090621000007, 43.380221456000086],
              [131.281836386, 43.39314056500008],
              [131.27780562300012, 43.438486633000096],
              [131.2742916260001, 43.45119903600006],
              [131.26168257700016, 43.463833923],
              [131.25284846300008, 43.46916859100007],
              [131.166908, 43.52106557300006],
              [131.160706828, 43.53277028400002],
              [131.16566776500014, 43.54902252300003],
              [131.185718221, 43.574447327000044],
              [131.19202274600002, 43.588632507000014],
              [131.19078251200006, 43.595893046000086],
              [131.18241093000012, 43.614031474000015],
              [131.180240519, 43.62302317300005],
              [131.18148075400006, 43.629844463],
              [131.18726851400004, 43.64798289000002],
              [131.1879919850001, 43.6566645300001],
              [131.18540816300003, 43.666328024],
              [131.17744999200016, 43.684466451000034],
              [131.17507287600012, 43.69376820900008],
              [131.17496952300007, 43.70146799800007],
              [131.17786340300006, 43.725497538000084],
              [131.17031864400013, 43.78110138000001],
              [131.172799113, 43.79911061600008],
              [131.19284956900003, 43.860243835000105],
              [131.2173441980001, 43.90848378600002],
              [131.21837772700007, 43.92587290500005],
              [131.20793908700006, 43.95948842400007],
              [131.2066988530001, 43.974784648000124],
              [131.21290002500007, 43.99323313400005],
              [131.21310673100004, 44.00687571200005],
              [131.21775761000004, 44.01607411700006],
              [131.2353275960001, 44.03111195900003],
              [131.2515539970001, 44.041550599000075],
              [131.26147587100002, 44.046098124000096],
              [131.2644731040001, 44.054211325000026],
              [131.16515100150008, 44.36811981300009],
              [131.06582889900005, 44.682028301000074],
              [131.02138716700006, 44.746882223000014],
              [131.0075378830001, 44.75732086200004],
              [130.97157108600004, 44.77561431900001],
              [130.93012658700007, 44.82496531200003],
              [130.93343387900006, 44.84170847600008],
              [130.97157108600004, 44.85405914400003],
              [130.990277955, 44.85416249600006],
              [131.00826135300008, 44.85628123000005],
              [131.0247978120001, 44.86243072600011],
              [131.03885380100007, 44.874574687000106],
              [131.04205774000008, 44.882481181000045],
              [131.04112756400002, 44.897777405000014],
              [131.04536503200006, 44.9054255170001],
              [131.05156620300016, 44.90904286700008],
              [131.09580122900007, 44.91911977100001],
              [131.11006392400014, 44.91953318300001],
              [131.12360314900002, 44.91560577400004],
              [131.140449666, 44.906820781000064],
              [131.15801965400016, 44.90170481400007],
              [131.176519816, 44.90341013600003],
              [131.2446293540001, 44.92216868100003],
              [131.25899540300009, 44.92816314700006],
              [131.29992313700012, 44.95648183200005],
              [131.31315230400003, 44.96366485600002],
              [131.32948205600007, 44.967643942000095],
              [131.35035933500006, 44.96800567700008],
              [131.41950240100005, 44.95896230100003],
              [131.4337650970001, 44.96128774000006],
              [131.442963501, 44.971312969000095],
              [131.45216190600001, 44.98371531200006],
              [131.46570113100006, 44.99322377600005],
              [131.47148889200002, 44.99663442000006],
              [131.60905155500012, 45.08970367400006],
              [131.61980025300005, 45.10365631100005],
              [131.62238407400002, 45.12365509100009],
              [131.60491744, 45.14742625000004],
              [131.60522749900008, 45.16463450100012],
              [131.615149374, 45.18494334000003],
              [131.62775842400004, 45.19848256500002],
              [131.64450158700004, 45.20644073600006],
              [131.66692915900006, 45.20959299800005],
              [131.71126753800002, 45.20866282200008],
              [131.72315311800003, 45.215329082],
              [131.78526818900002, 45.30472930900008],
              [131.8180310470001, 45.33278961200001],
              [131.85306766800005, 45.33759552000002],
              [131.8707410080001, 45.32633005800004],
              [131.88045617700004, 45.309896952000074],
              [131.88841434800014, 45.291138407000076],
              [131.9004032800001, 45.27289662700004],
              [131.91456262200012, 45.26013254900006],
              [131.93151249200002, 45.24871205700005],
              [131.94990930200004, 45.239720357000024],
              [131.96882287600016, 45.233984274000065],
              [131.969649699, 45.233829244000034],
              [132.40471358250005, 45.14649607350013],
              [132.8397774660001, 45.05916290300006],
              [132.92121952300016, 45.027898662000055],
              [132.95336226400008, 45.024384664000095],
              [132.9661780200001, 45.02888051400002],
              [132.99263635200015, 45.04846588200006],
              [133.02384891800006, 45.058336080000046],
              [133.04968713400007, 45.0817455040001],
              [133.07335494000006, 45.09063385000012],
              [133.098779745, 45.10779042600008],
              [133.115419556, 45.12303497300012],
              [133.12151737500005, 45.13125152600004],
              [133.12523807800005, 45.141328431],
              [133.12720178300003, 45.15538442000009],
              [133.12069055200004, 45.18344472300002],
              [133.10653121000007, 45.214708964000025],
              [133.09753951000005, 45.243544413000066],
              [133.10673791500005, 45.264628398000085],
              [133.10188033100013, 45.28721099900012],
              [133.12720178300003, 45.38508616100002],
              [133.12875207500014, 45.40275950200002],
              [133.13319624900015, 45.419606019000085],
              [133.14022424400008, 45.43541900700008],
              [133.1798083910001, 45.493813375000045],
              [133.1892135020001, 45.50414866200008],
              [133.20213260900005, 45.51128000900009],
              [133.24088993300012, 45.52326894200006],
              [133.27168908700008, 45.52843658500005],
              [133.29887089000016, 45.54207916300008],
              [133.3302901620001, 45.549262187000025],
              [133.36253625500007, 45.56791737900009],
              [133.3748352460001, 45.573085022],
              [133.413489218, 45.573343405000074],
              [133.42516809100005, 45.5804230750001],
              [133.41514286300003, 45.60042185500002],
              [133.42764856000014, 45.61525299100005],
              [133.44201460800008, 45.62062734000001],
              [133.45844771400004, 45.62264272100005],
              [133.477257935, 45.62770701100003],
              [133.47178023300006, 45.63246124300012],
              [133.46216841700004, 45.64403676400006],
              [133.45669071500004, 45.648790995000056],
              [133.48283899000006, 45.6628986620001],
              [133.49152063000008, 45.67338897800006],
              [133.48779992700008, 45.68666982000006],
              [133.47663781800014, 45.693594462000036],
              [133.45162642400015, 45.69917551700006],
              [133.44304813700006, 45.7096658330001],
              [133.470850057, 45.72888946600004],
              [133.4849060470001, 45.76847361300007],
              [133.51136438100002, 45.77855051700003],
              [133.50340621000015, 45.78764556900008],
              [133.483769166, 45.79658559200003],
              [133.477257935, 45.80583567300003],
              [133.477257935, 45.820098369],
              [133.4849060470001, 45.82841827400007],
              [133.494001099, 45.833327535000095],
              [133.49834191900004, 45.83720326800007],
              [133.50268273900014, 45.862007955000095],
              [133.514361613, 45.87926788400007],
              [133.5316215410001, 45.88815623],
              [133.552292115, 45.88841461200006],
              [133.55911340300008, 45.88521067300009],
              [133.56407434100004, 45.880559794000035],
              [133.57006880700015, 45.87642568000011],
              [133.57968062300006, 45.87477203400006],
              [133.58588179500015, 45.876322327000096],
              [133.5860885020001, 45.879836325000056],
              [133.58443485500004, 45.8841254690001],
              [133.586501913, 45.88841461200006],
              [133.60303837100003, 45.89864654600005],
              [133.60613895700016, 45.90510610000011],
              [133.60696578, 45.91947214800011],
              [133.61006636600013, 45.92980743400001],
              [133.61761112500005, 45.93626698800007],
              [133.6277397060001, 45.93776560500008],
              [133.64985721900013, 45.92784373000008],
              [133.65812544800008, 45.93450999],
              [133.69481571500006, 46.02277333600007],
              [133.7200338140001, 46.063752747000095],
              [133.71931034400006, 46.07930735300003],
              [133.69636600800004, 46.11501576800005],
              [133.687374309, 46.14183583600003],
              [133.6987431240001, 46.14901886000008],
              [133.7200338140001, 46.15020741800002],
              [133.74101444500002, 46.1590440880001],
              [133.766025839, 46.177957662000054],
              [133.77512089000004, 46.18669097900003],
              [133.78173547400007, 46.19671620700005],
              [133.78648970600005, 46.20668975900004],
              [133.79351770100004, 46.21428619400011],
              [133.80623010300013, 46.21738678000007],
              [133.81294803900005, 46.214182841000095],
              [133.8212162690001, 46.200126852000054],
              [133.8301046150001, 46.19687123700008],
              [133.83661584500015, 46.20043691000005],
              [133.8528422450001, 46.21754180900008],
              [133.86090376900006, 46.223587952000045],
              [133.85532271400007, 46.23655873700007],
              [133.86958540900002, 46.24451690700003],
              [133.890049276, 46.25082143200005],
              [133.90245162000008, 46.25898630800005],
              [133.90193485600003, 46.27805491200003],
              [133.89408003800008, 46.29133575400006],
              [133.893769979, 46.301877747],
              [133.915990845, 46.31298818000003],
              [133.9069991460001, 46.322470805000094],
              [133.8963538010001, 46.32719919900008],
              [133.8851916920001, 46.32657908200012],
              [133.87444299400016, 46.31978363100008],
              [133.8633842370001, 46.33929148400007],
              [133.880850871, 46.35365753200007],
              [133.92601607300008, 46.37130503400009],
              [133.93387089100008, 46.390761211000054],
              [133.92146854700002, 46.410139872000045],
              [133.90028121000006, 46.426572978000095],
              [133.88188440000016, 46.43711497000005],
              [133.87041223100005, 46.44047393800007],
              [133.86152388500005, 46.441042379000024],
              [133.85439253800007, 46.444659729000094],
              [133.84777795500008, 46.45698455800006],
              [133.84581425000016, 46.47065297500008],
              [133.849328248, 46.480290630000084],
              [133.89190962700002, 46.528969828000115],
              [133.8963538010001, 46.538194072000024],
              [133.89883427000007, 46.56325714200004],
              [133.90245162000008, 46.57364410400005],
              [133.92033166600004, 46.59033559200007],
              [133.96735721900006, 46.611187033000064],
              [133.98802779200003, 46.62516550700006],
              [133.99849762100007, 46.637704225000036],
              [134.00528772000007, 46.64583608000008],
              [134.0147961830001, 46.66503387400009],
              [134.0258549400001, 46.71081919300012],
              [134.041771282, 46.752702942],
              [134.044665162, 46.77200409000004],
              [134.03588016800012, 46.78959991500004],
              [134.02141076700008, 46.80613637300003],
              [134.0166565350001, 46.819468892000046],
              [134.02048059100002, 46.8340416460001],
              [134.0627519130001, 46.906853740000074],
              [134.06698938, 46.926800843000095],
              [134.06698938, 46.96778025300004],
              [134.06915979000007, 46.981241964],
              [134.07412072800003, 46.988140768000065],
              [134.08083866400005, 46.99268829400002],
              [134.087349894, 46.998811951000064],
              [134.1142216400001, 47.05581105600005],
              [134.124246867, 47.070513001000066],
              [134.14574426300015, 47.081184184000065],
              [134.1971106360001, 47.085163269000034],
              [134.21716109300007, 47.094439189000056],
              [134.2272896730001, 47.11774526000009],
              [134.21623091700013, 47.13766652400001],
              [134.19876428300006, 47.155546570000055],
              [134.18977258300004, 47.172935689000084],
              [134.195560344, 47.19370961600002],
              [134.19721398900003, 47.20533681300007],
              [134.19318322800007, 47.210478617],
              [134.1864652920001, 47.21370839500007],
              [134.16837854100004, 47.230580749000055],
              [134.16186731000005, 47.23843556800007],
              [134.15411584500015, 47.25789174400008],
              [134.16000695900004, 47.27163767500009],
              [134.17013553900006, 47.28680470800002],
              [134.17550988800014, 47.31042083800004],
              [134.18357141100006, 47.327499899000074],
              [134.20300175, 47.33842946400004],
              [134.24506636600006, 47.355095113000075],
              [134.25746870900002, 47.367239075000086],
              [134.2794828700001, 47.397805685],
              [134.2928153900001, 47.409717103000034],
              [134.3128658450001, 47.42012990400006],
              [134.33260624200005, 47.42635691400004],
              [134.35400028500015, 47.42935414700007],
              [134.37818485600013, 47.43018097000008],
              [134.38903690700016, 47.43276479100008],
              [134.40185266100002, 47.437363993000034],
              [134.414978475, 47.43922434500003],
              [134.43657922400007, 47.42981923500007],
              [134.47192590300006, 47.428630676000054],
              [134.48463830600014, 47.43018097000008],
              [134.50045129400013, 47.43891428700006],
              [134.53528121, 47.46557932600008],
              [134.55688195900007, 47.47118621900002],
              [134.56060266200006, 47.481805725000115],
              [134.60411421800012, 47.52772023600009],
              [134.61496626800016, 47.53663442],
              [134.6242680260001, 47.54963104300005],
              [134.66819299400004, 47.573996481000066],
              [134.68266239500014, 47.58784576400002],
              [134.6861763920001, 47.608852234000025],
              [134.68669315600005, 47.631150615000095],
              [134.69289432900013, 47.64890146900011],
              [134.71397831300015, 47.65613617000007],
              [134.72545048100005, 47.66324167900011],
              [134.77257938700006, 47.710732321000094],
              [134.76513798000008, 47.718173727000035],
              [134.76978885900013, 47.741014710000044],
              [134.69651167900008, 47.79506825800003],
              [134.67646122300005, 47.82431711900007],
              [134.674084107, 47.84044016600005],
              [134.66757287700005, 47.86467641200004],
              [134.65775435400008, 47.88669057200012],
              [134.64576542200012, 47.89630238900013],
              [134.62271773300006, 47.9002297980001],
              [134.599049927, 47.91069427500004],
              [134.58768111200004, 47.92591298400008],
              [134.60132369100006, 47.94412892700002],
              [134.5669071860001, 47.98549591100006],
              [134.55936242700005, 48.00952545200009],
              [134.56721724500005, 48.04037628200008],
              [134.5864408770001, 48.061150208000115],
              [134.64793583200003, 48.10218129500008],
              [134.66271529200003, 48.107969056000044],
              [134.68297245300005, 48.13551259400002],
              [134.68741662600013, 48.21984853100004],
              [134.70302290900008, 48.252559713000025],
              [134.71873254400015, 48.26341176400008],
              [134.700852499, 48.26152557400006],
              [134.661164999, 48.26697743700005],
              [134.6113489180001, 48.28542592400005],
              [134.569491008, 48.31552744600005],
              [134.542619263, 48.35730784100009],
              [134.52587609900007, 48.34898793600003],
              [134.50820275900003, 48.34258005800008],
              [134.48980594900007, 48.33916941400007],
              [134.471305787, 48.33989288300005],
              [134.45311568300008, 48.34418202700003],
              [134.40547001200002, 48.37033030200003],
              [134.3863497320001, 48.381337383000115],
              [134.36712609900013, 48.37704823900005],
              [134.20620568900006, 48.35965911900003],
              [134.1160819910001, 48.33519032800008],
              [134.05717085800006, 48.32718048200009],
              [134.0406344000001, 48.32247792600002],
              [134.02482141100012, 48.31506235800002],
              [133.9824467370001, 48.28516754200008],
              [133.96642704300012, 48.27865631100012],
              [133.93697147700004, 48.27328196200007],
              [133.87754357900008, 48.275297344000094],
              [133.8676217040001, 48.27431549100005],
              [133.84953495300016, 48.26930287700007],
              [133.81480839000005, 48.25511769600003],
              [133.796618286, 48.2505960080001],
              [133.73791386000005, 48.25108693500003],
              [133.72127404800005, 48.2447565720001],
              [133.70773482300007, 48.231656596000036],
              [133.685513957, 48.202071838],
              [133.67021773300007, 48.189979553000015],
              [133.65450809700008, 48.18390757300007],
              [133.6214351810001, 48.177267151000066],
              [133.60551884000006, 48.171634420000046],
              [133.59383996600002, 48.16419301400002],
              [133.58484826700015, 48.155356344000026],
              [133.57782027200005, 48.14502105700011],
              [133.57203251200008, 48.13277374300007],
              [133.55994022700008, 48.113291728],
              [133.54402388600016, 48.10150950100008],
              [133.52438684100002, 48.09543752100005],
              [133.46371871000014, 48.089520569000044],
              [133.45079960100014, 48.09138092100004],
              [133.41317915900004, 48.102956441000075],
              [133.39622928900013, 48.105927837000095],
              [133.37948612500008, 48.10631541],
              [133.323675578, 48.10011423700011],
              [133.30145471300006, 48.101276957000024],
              [133.29070601500013, 48.10440338100007],
              [133.27272261600007, 48.115152079],
              [133.26280074100015, 48.11944122300007],
              [133.22373335800006, 48.125978293000045],
              [133.18518273900008, 48.12481557300002],
              [133.09195845600004, 48.10678049700003],
              [133.07542199700003, 48.100915222000125],
              [133.0609525960001, 48.091846009000065],
              [133.05103072100013, 48.07853932700006],
              [133.04751672400005, 48.071640523000056],
              [133.04400272700002, 48.06621449800009],
              [133.03935184800002, 48.0615119430001],
              [133.0328406170001, 48.05675771100003],
              [133.02467574100007, 48.05244272900005],
              [132.94075321400015, 48.02670786600005],
              [132.94033980300003, 48.02257375100005],
              [132.8647888590001, 47.9856509400001],
              [132.8536267500001, 47.97614247700004],
              [132.8333695880001, 47.95159617100005],
              [132.82065718600012, 47.94237192800004],
              [132.8058777270001, 47.936196594000066],
              [132.789651327, 47.932734274000026],
              [132.774871867, 47.93376780200002],
              [132.76257287700003, 47.939374695000126],
              [132.73818160000013, 47.95412831700004],
              [132.72247196500007, 47.95893422500005],
              [132.70572880100008, 47.960381164000054],
              [132.68908899000007, 47.95769399000001],
              [132.67461958900003, 47.95061431900008],
              [132.6681083580001, 47.9451366170001],
              [132.66314742000014, 47.93867706300004],
              [132.66035689300008, 47.93133901000006],
              [132.66087365700002, 47.92301910400009],
              [132.66407759600008, 47.91583608100005],
              [132.6681083580001, 47.90932485000006],
              [132.67141565000009, 47.90250356000011],
              [132.67234582600014, 47.89444203700002],
              [132.66800500500005, 47.88131622400006],
              [132.65880660100004, 47.86981821800005],
              [132.6074402270001, 47.82762441000007],
              [132.581395304, 47.80070098900005],
              [132.57643436700005, 47.7942414350001],
              [132.57385054500008, 47.788350322],
              [132.5736438400001, 47.78222666400005],
              [132.58077518800013, 47.76483754500002],
              [132.58232548000007, 47.75613006600004],
              [132.58036177600002, 47.747991028000044],
              [132.57416060400016, 47.73959360800005],
              [132.55669397000008, 47.72349639900007],
              [132.54718550700005, 47.71677846300004],
              [132.53643680900012, 47.711068217],
              [132.5246545820001, 47.70752838100013],
              [132.47576867700002, 47.70675323500002],
              [132.4532377530001, 47.710525615000066],
              [132.4006311450001, 47.72980092400009],
              [132.36652469900002, 47.735330302000094],
              [132.33241825400006, 47.73651886000003],
              [132.26441206900006, 47.728844910000035],
              [132.25076949100009, 47.72535675100009],
              [132.20219364500008, 47.70050038600003],
              [132.188964478, 47.69564280200011],
              [132.16167932100007, 47.69001007100009],
              [132.11703088400014, 47.68944163000002],
              [132.0892289630001, 47.69476430300007],
              [132.02535689300015, 47.697864889000115],
              [131.96654911400003, 47.69001007100009],
              [131.95735070800004, 47.68693532300004],
              [131.93295943300012, 47.67223337900005],
              [131.92448449800014, 47.66892608700006],
              [131.914045858, 47.667634176],
              [131.90350386600005, 47.66809926400002],
              [131.89430546100004, 47.67001129200004],
              [131.86484989400003, 47.681560974],
              [131.85461796100003, 47.68406728200007],
              [131.83591109200006, 47.6845323700001],
              [131.79901412000004, 47.67936472600009],
              [131.78041060400005, 47.67910634400003],
              [131.70299930900006, 47.69615956700004],
              [131.68356897000007, 47.69460927400003],
              [131.6306523030001, 47.66685902900009],
              [131.62166060500016, 47.663810120000065],
              [131.61246219900016, 47.66200144500006],
              [131.60326379400016, 47.66153635700003],
              [131.5939620370001, 47.662311503000055],
              [131.5847636320001, 47.6646886190001],
              [131.57742557800015, 47.66856435200005],
              [131.5379447840001, 47.70321339900006],
              [131.507765747, 47.72153269400003],
              [131.4750028890001, 47.734477641000055],
              [131.44089644400003, 47.741169739000085],
              [131.41836552000012, 47.74261667900008],
              [131.21010949700013, 47.709207865000096],
              [131.16721805900016, 47.69714141900003],
              [131.12918420400007, 47.68122507800008],
              [131.10386275300004, 47.676548360000126],
              [131.08432906100006, 47.675127259000035],
              [131.04412479700005, 47.67722015400001],
              [131.0233508710001, 47.682284445000064],
              [130.98345666500006, 47.70003529900002],
              [130.96567997300014, 47.70393687000005],
              [130.94180546100011, 47.717967021000064],
              [130.9382914640001, 47.75109161400006],
              [130.942322225, 47.7898231],
              [130.94170210800007, 47.820596415000054],
              [130.90697554600007, 47.884261780000045],
              [130.85736617100008, 47.92777333600007],
              [130.68238977100015, 48.05034983400007],
              [130.67474165900006, 48.06394073500009],
              [130.67091760300002, 48.086575012000125],
              [130.6648197840001, 48.10205210400004],
              [130.6633728440001, 48.116443990000036],
              [130.67474165900006, 48.13592600600005],
              [130.7072978110001, 48.163366191000094],
              [130.72951867700016, 48.177964783000064],
              [130.74646854700006, 48.1843726610001],
              [130.75277307200008, 48.18961781900002],
              [130.763625123, 48.22527455700002],
              [130.76889611800004, 48.23674672500003],
              [130.773857056, 48.24418813100006],
              [130.8194356690001, 48.28188608800009],
              [130.8239831950001, 48.29415924100003],
              [130.82512007700012, 48.31777537100005],
              [130.8221228430001, 48.333769226000086],
              [130.814474732, 48.33997039900008],
              [130.803415975, 48.34273508700004],
              [130.7902901610001, 48.348212790000034],
              [130.7796448160001, 48.35637766500004],
              [130.77375370300007, 48.364232483000066],
              [130.763625123, 48.382965190000064],
              [130.743264608, 48.41159393400004],
              [130.73830367100004, 48.429809876],
              [130.74646854700006, 48.44779327500008],
              [130.75959436100004, 48.467921245000056],
              [130.75897424300007, 48.48572377500007],
              [130.74429813700016, 48.497325135000025],
              [130.71587609900013, 48.4990562950001],
              [130.63929162700003, 48.477248841000076],
              [130.62637251800004, 48.48226145500003],
              [130.62430546100006, 48.4883592740001],
              [130.6157271730001, 48.50809967100007],
              [130.61345341000003, 48.51946848600004],
              [130.6147969980001, 48.53016550700006],
              [130.6207914630001, 48.54931162600006],
              [130.62017134600006, 48.56049957300009],
              [130.60766565000006, 48.57672597300011],
              [130.58637496000006, 48.583443909000025],
              [130.56239709500005, 48.58814646400002],
              [130.5407963460001, 48.598352560000066],
              [130.52973759000008, 48.616258443000035],
              [130.53325158700005, 48.635792135000045],
              [130.6278194580001, 48.79604075100009],
              [130.66668013600008, 48.841464335000026],
              [130.67649865800007, 48.85743235300008],
              [130.67432824800005, 48.870816549000025],
              [130.650660441, 48.87639760400002],
              [130.62528640000005, 48.874359528000056],
              [130.6249255780001, 48.87433054600005],
              [130.56487756400008, 48.85588206000004],
              [130.54089969900008, 48.85345326800008],
              [130.51165083900003, 48.85552032500006],
              [130.48663944500004, 48.86368520200007],
              [130.47620080600012, 48.879498190000064],
              [130.46534875600008, 48.89133209300009],
              [130.439717245, 48.89649973600008],
              [130.38680057800002, 48.896293030000024],
              [130.33812137900009, 48.885337626000066],
              [130.2935762940001, 48.87014475500003],
              [130.24934126800008, 48.86451202400009],
              [130.20179895100006, 48.88259877500012],
              [130.03746789600012, 48.97199900300011],
              [129.99685022000006, 49.00238474600006],
              [129.9742159430001, 49.015148825000026],
              [129.92646692000005, 49.02569081600008],
              [129.91344445800013, 49.03954010000005],
              [129.91168745900006, 49.0592804970001],
              [129.9206791590001, 49.081863099000046],
              [129.8831620690001, 49.09979482100003],
              [129.86249149600008, 49.10651275600004],
              [129.84151086400004, 49.109199931],
              [129.845438273, 49.154055074000055],
              [129.84151086400004, 49.16718088800003],
              [129.82466434700007, 49.17415720600003],
              [129.77598514900006, 49.17756785100006],
              [129.75562463400001, 49.18428578700009],
              [129.741775351, 49.19570627800009],
              [129.73753788300013, 49.20547312400005],
              [129.73505741400004, 49.23890777600012],
              [129.71118290200008, 49.27415110300011],
              [129.66922163900006, 49.27916371700006],
              [129.61919885300006, 49.27425445600004],
              [129.57175988900008, 49.27983551000004],
              [129.55181278500004, 49.29048085600003],
              [129.53899703000008, 49.30371002200003],
              [129.53207238800007, 49.32153839100006],
              [129.53021203600008, 49.36933909100007],
              [129.52773156800004, 49.38484202100007],
              [129.519670044, 49.39708933600009],
              [129.50241011600014, 49.41078359000004],
              [129.48060266200002, 49.42127390600008],
              [129.4550745040001, 49.427268372000086],
              [129.40339807200013, 49.43067901700003],
              [129.37869673700004, 49.4250462860001],
              [129.37146203600008, 49.410576885000054],
              [129.37321903500003, 49.369855856000086],
              [129.3620569260001, 49.34980540000005],
              [129.34097294100008, 49.341175436000114],
              [129.316064901, 49.344120993],
              [129.27234663900003, 49.37528188100008],
              [129.24557824700003, 49.38592722600008],
              [129.21787968, 49.390784811000074],
              [129.193901815, 49.389699605],
              [129.17116418500012, 49.380346171000056],
              [129.13602421100006, 49.35414622000003],
              [129.11535363800016, 49.34877187100007],
              [129.08786177600007, 49.352079163000084],
              [129.06688114500002, 49.361639303000075],
              [129.05055139200016, 49.376677145000045],
              [129.0145845950001, 49.43109242800004],
              [128.9981514900001, 49.441272685000015],
              [128.94709517400014, 49.44954091400005],
              [128.90192997300005, 49.47171010400008],
              [128.879192342, 49.479719951000064],
              [128.85356083200014, 49.480546774000075],
              [128.80984257100016, 49.46871287000006],
              [128.78658817600007, 49.46545725500009],
              [128.76012984200014, 49.47088328100004],
              [128.75020796700005, 49.484525858000055],
              [128.75413537600002, 49.50245758100003],
              [128.76932824700015, 49.5206993610001],
              [128.77925012200006, 49.525091859000085],
              [128.790412232, 49.52710723900013],
              [128.79950728400007, 49.53186147100003],
              [128.803434692, 49.54426381500009],
              [128.80322798700007, 49.55516754200006],
              [128.80167769400015, 49.565141093000065],
              [128.79692346200005, 49.57247914600005],
              [128.78658817600007, 49.575321350000124],
              [128.7595097250001, 49.5778018190001],
              [128.73418827400008, 49.58441640300002],
              [128.6867493090001, 49.603226624000015],
              [128.67186649600006, 49.611443177000055],
              [128.66618208900002, 49.60947947200002],
              [128.63517622900008, 49.578163554000085],
              [128.62866499800015, 49.575321350000124],
              [128.5512537030001, 49.5884471640001],
              [128.38351200400012, 49.57935211300013],
              [128.372039836, 49.575321350000124],
              [128.36501184100007, 49.56974029600012],
              [128.35281620400008, 49.55449574900008],
              [128.3447546800001, 49.54798451800009],
              [128.32036340400015, 49.54478057900003],
              [128.26786014800007, 49.55878489300004],
              [128.2454325770001, 49.55139516200002],
              [128.22507206300008, 49.54183502300005],
              [128.1983036700001, 49.53899281900006],
              [128.09247033800006, 49.54157664000006],
              [128.06714888600004, 49.546692607000054],
              [128.04689172400003, 49.55826812800008],
              [128.0124752200001, 49.58741363500012],
              [127.99159794100007, 49.59873077400009],
              [127.96793013500007, 49.603226624000015],
              [127.955476116, 49.603019918000044],
              [127.94793135600008, 49.601211243000066],
              [127.94080000800005, 49.595888570000014],
              [127.93015466400004, 49.585191549000015],
              [127.92069787600008, 49.581109111],
              [127.90731368100006, 49.58023061200005],
              [127.854655395, 49.58488149100002],
              [127.83088423700008, 49.593873189000064],
              [127.80964522400012, 49.607102356000055],
              [127.78990482600005, 49.62307037400011],
              [127.77000940000005, 49.633870748000035],
              [127.7220019940001, 49.64859853100005],
              [127.70360518500001, 49.660639141],
              [127.689962606, 49.681464742000074],
              [127.68696537300008, 49.69887970000009],
              [127.6862935800001, 49.71681142200008],
              [127.67998905500008, 49.73918731800005],
              [127.64428064000009, 49.76714426700006],
              [127.53865401200005, 49.789933574000045],
              [127.50811324100005, 49.822334697000045],
              [127.50671797700011, 49.844297181000016],
              [127.51162723800013, 49.86905019200013],
              [127.52087732000012, 49.8917878220001],
              [127.53224613500004, 49.90765248600003],
              [127.53400313300011, 49.92248362200006],
              [127.52160079000015, 49.94119049100003],
              [127.49441898600003, 49.973178203000046],
              [127.48666752200006, 50.02562978200008],
              [127.50661462400006, 50.06345693000007],
              [127.57017663600004, 50.13022288000009],
              [127.580615276, 50.14913645400004],
              [127.58671309500005, 50.16717153000003],
              [127.58981368000008, 50.18639516300006],
              [127.59064050300009, 50.20871938100002],
              [127.57839318800006, 50.22055328400005],
              [127.404812053, 50.2759504190001],
              [127.35463423700008, 50.298636374000054],
              [127.33065637200008, 50.328195292],
              [127.33184493000016, 50.340184225000044],
              [127.33752933800014, 50.35268992100005],
              [127.34574589000016, 50.36442047200005],
              [127.35478926600001, 50.373463847],
              [127.3587166750001, 50.38131866500002],
              [127.35964685100015, 50.39289418600008],
              [127.35850997, 50.415115051],
              [127.34915653500008, 50.42617380800003],
              [127.30466312700008, 50.451443584000074],
              [127.28895349200002, 50.46601633700003],
              [127.30264774600005, 50.47759185900007],
              [127.31029585800002, 50.48839223300011],
              [127.32362837800014, 50.5137653610001],
              [127.3337052820001, 50.52503082300008],
              [127.35685632300016, 50.544616191],
              [127.36481449400003, 50.554744772000035],
              [127.36708825800014, 50.57779246000011],
              [127.3587166750001, 50.60502594000009],
              [127.34398889200008, 50.627763570000084],
              [127.327090698, 50.63727203400008],
              [127.29494795800014, 50.666417542],
              [127.28895349200002, 50.675150859000055],
              [127.28709314000002, 50.68202382400004],
              [127.28383752500014, 50.68827667300003],
              [127.2822872320001, 50.69483958000011],
              [127.28580122900007, 50.702487692],
              [127.28988366800007, 50.708378805000095],
              [127.29324263600006, 50.715355123000094],
              [127.295516399, 50.722796529],
              [127.29644657500006, 50.730082907000096],
              [127.287351522, 50.751011862000084],
              [127.26621586100015, 50.76408599900013],
              [127.2411011150001, 50.774679667],
              [127.2207406010001, 50.788167216000076],
              [127.14425948100012, 50.90350901300009],
              [127.11077315300008, 50.931517640000024],
              [127.04710778800012, 50.96722605400002],
              [127.03232832900011, 50.97244537400003],
              [126.98116866100008, 51.02768748000004],
              [126.94644209900008, 51.04833221500006],
              [126.93176599200007, 51.06378346800007],
              [126.92582320200006, 51.086004334000094],
              [126.92298099800007, 51.10791514200004],
              [126.90959680200007, 51.146000672000085],
              [126.90541101100013, 51.164268291000056],
              [126.90380904200009, 51.19338796000007],
              [126.90515262900016, 51.20811574300008],
              [126.90892500900009, 51.22162913100006],
              [126.9163147380001, 51.232765402000055],
              [126.94711389200006, 51.25813853000007],
              [126.967939495, 51.28154795400012],
              [126.97775801700004, 51.2965599570001],
              [126.98116866100008, 51.30885894800004],
              [126.97217696100006, 51.32400014300005],
              [126.9546069750001, 51.32958119800007],
              [126.93445316600003, 51.32875437500006],
              [126.91729659100014, 51.324723613000046],
              [126.90825321500006, 51.321235453],
              [126.89936486800008, 51.316507060000035],
              [126.8913550210001, 51.310512594],
              [126.88530887900004, 51.30289032000012],
              [126.8848437910001, 51.295629781000045],
              [126.88918461100002, 51.28932525700013],
              [126.89290531400002, 51.28201304100004],
              [126.89068322800011, 51.27149688700008],
              [126.869909302, 51.251730652000035],
              [126.8458797610001, 51.251472270000065],
              [126.8237105720001, 51.26555409800007],
              [126.80898278900008, 51.289066875000074],
              [126.80732914200007, 51.30810964000004],
              [126.81415043200002, 51.32493031900002],
              [126.82701786300004, 51.33898630800003],
              [126.84345096900006, 51.34937327100006],
              [126.86086592700008, 51.35392079700007],
              [126.88029626500008, 51.35622039800002],
              [126.89750451700007, 51.36195648200008],
              [126.90892500900009, 51.37702016200005],
              [126.90944177300003, 51.39110199],
              [126.9019486900001, 51.400998027000085],
              [126.89011478700007, 51.40701833200002],
              [126.87688562000005, 51.40988637300008],
              [126.82593265800011, 51.412082622000085],
              [126.80030114800007, 51.41895558700007],
              [126.78929406800006, 51.43580210400005],
              [126.7927047120001, 51.459056498000066],
              [126.8015930580001, 51.4772207650001],
              [126.83037683200013, 51.50812327100009],
              [126.8074324960001, 51.53421986900007],
              [126.77559981300016, 51.545769552000095],
              [126.70056563400016, 51.56271942200003],
              [126.67689782700012, 51.5765945430001],
              [126.67514082900004, 51.588376770000096],
              [126.70397627800008, 51.61359486900004],
              [126.72371667500016, 51.63589325],
              [126.724543498, 51.649587505000014],
              [126.71575850400006, 51.66317840700002],
              [126.70733524600007, 51.68563181600011],
              [126.7107458910001, 51.68601938900012],
              [126.71787723900007, 51.69092865000006],
              [126.72485355700007, 51.697543234000065],
              [126.72795414300009, 51.70304677400004],
              [126.72557702700016, 51.70873118200008],
              [126.71575850400006, 51.71749033600007],
              [126.71358809500009, 51.72317474400002],
              [126.66242842600002, 51.733432516],
              [126.64790734900015, 51.741261496000035],
              [126.44605920400011, 51.982538757000086],
              [126.43928959200008, 51.99786082000004],
              [126.44735111500006, 52.01878977500003],
              [126.46709151200002, 52.03165720700004],
              [126.49158614200007, 52.03878855400008],
              [126.514427125, 52.042535096000094],
              [126.514427125, 52.04871042900005],
              [126.51980147300003, 52.06126780199999],
              [126.55132409700002, 52.11297007300003],
              [126.55597497600007, 52.130643412000026],
              [126.53117028800006, 52.15265757200011],
              [126.49380822800009, 52.16126169800005],
              [126.45329390500007, 52.165628358000035],
              [126.3507161870001, 52.19169911700003],
              [126.33283614100003, 52.19337860100008],
              [126.31671309500007, 52.19976064100011],
              [126.30932336500007, 52.213868307000055],
              [126.31221724500006, 52.22795013400007],
              [126.39205733300003, 52.26435618100005],
              [126.43928959200008, 52.27528574700004],
              [126.42120284000015, 52.28730051700008],
              [126.34441166300007, 52.302622579000044],
              [126.31573124200008, 52.31621348100005],
              [126.34430830900016, 52.35758046500008],
              [126.3507161870001, 52.37690745100004],
              [126.34368819200006, 52.39137685200008],
              [126.312682333, 52.417421773000044],
              [126.29619755100009, 52.435198466000074],
              [126.28896285000013, 52.45002960300009],
              [126.27599206600007, 52.46328460800002],
              [126.24679488100008, 52.46584259100011],
              [126.21677087500012, 52.4647573860001],
              [126.20033776900004, 52.46708282500005],
              [126.20064782700001, 52.48653900200013],
              [126.21046634900011, 52.51142120400009],
              [126.21232670100011, 52.53304779100007],
              [126.17036543800009, 52.5475947070001],
              [126.08277388500011, 52.59335418700006],
              [126.06861454300014, 52.59531789200007],
              [126.06251672400009, 52.58717885400007],
              [126.05910607900006, 52.57549998000009],
              [126.050786174, 52.57118499800002],
              [126.03952071200007, 52.56966054400003],
              [126.02804854400011, 52.56637909000001],
              [126.00923832300009, 52.568394471000076],
              [125.99084151200009, 52.58642954500006],
              [125.97730228700004, 52.61076914500008],
              [125.97316817300009, 52.63156890900002],
              [125.98277998900005, 52.653040467000054],
              [126.002572063, 52.66549448700006],
              [126.02768680800006, 52.671178894],
              [126.0526465260001, 52.67249664400005],
              [126.06861454300014, 52.67988637300006],
              [126.0619482830001, 52.69662953700002],
              [126.03512821500016, 52.72711863299999],
              [126.04902917600015, 52.73709218300009],
              [126.06603072100006, 52.74417185500003],
              [126.1040645760001, 52.75445546500002],
              [126.08804488100014, 52.77541025800012],
              [126.06670251500015, 52.78318756200012],
              [126.01781661000007, 52.78238657700011],
              [126.00748132400014, 52.77866587400008],
              [125.98526045800008, 52.764532370000055],
              [125.97694055200014, 52.764997458],
              [125.867438192, 52.8493592330001],
              [125.86103031500016, 52.856025492000114],
              [125.85694787700004, 52.864319560000084],
              [125.85751631700009, 52.87442230300012],
              [125.86185713700007, 52.88145029700003],
              [125.86371748900001, 52.88858164500006],
              [125.85694787700004, 52.899046123000105],
              [125.83736250800013, 52.9067200730001],
              [125.73649011200013, 52.89579050700003],
              [125.69173832200016, 52.88129526800007],
              [125.6686906330001, 52.877962138000086],
              [125.64646976800014, 52.88488678000006],
              [125.64708988500001, 52.90090647400011],
              [125.66093916900007, 52.91935496000012],
              [125.67887089100014, 52.933230082000094],
              [125.68858606000009, 52.936459860000085],
              [125.711065308, 52.94121409200007],
              [125.71985030200011, 52.946304220000044],
              [125.72429447400009, 52.952763774000104],
              [125.73354455600008, 52.98165090000005],
              [125.67861250800001, 53.00568044000009],
              [125.65019047100014, 53.023379619000096],
              [125.63799483300016, 53.04614308700006],
              [125.6213550220001, 53.06213694300003],
              [125.58404463700009, 53.058907166000054],
              [125.52130944900006, 53.04242238400006],
              [125.49950199400013, 53.05061309899999],
              [125.47650598200005, 53.08350514800013],
              [125.45640385000002, 53.09089487800013],
              [125.42808516500008, 53.09469309500007],
              [125.12743168100013, 53.20654673300005],
              [125.07368819200008, 53.212205303000076],
              [125.01942793800009, 53.210732524],
              [124.91917566000006, 53.193937683000044],
              [124.89767826400009, 53.18551442500005],
              [124.88041833500012, 53.172517802000115],
              [124.8791781010001, 53.15386261100004],
              [124.89178715100002, 53.13425140400001],
              [124.8962313240001, 53.11766327000002],
              [124.87013472500013, 53.107999776000085],
              [124.84812056500004, 53.11368418400012],
              [124.82202396700006, 53.14724802700006],
              [124.8013533940001, 53.155154521],
              [124.74729984600003, 53.14771311500006],
              [124.72016971900007, 53.14882415800007],
              [124.69825891200003, 53.16264760400013],
              [124.69557173700008, 53.16980478900008],
              [124.69686364800015, 53.17634185900006],
              [124.69639856000003, 53.18375742600007],
              [124.68828536, 53.19360178700005],
              [124.6786735440001, 53.19933787000009],
              [124.65159509300014, 53.20876882000006],
              [124.64022627800006, 53.210344951000096],
              [124.528191773, 53.210344951000096],
              [124.500493205, 53.21367808000009],
              [124.45393273900004, 53.22819915800004],
              [124.40819909700008, 53.23569224100008],
              [124.38370446800008, 53.24613088000011],
              [124.3599333090001, 53.25946339900004],
              [124.34251835200007, 53.27248586000006],
              [124.32582686400013, 53.305998027000086],
              [124.32138269100011, 53.309770406],
              [124.3047428800001, 53.32904571600004],
              [124.29342574100014, 53.35129242000009],
              [124.27539066600002, 53.36470245400004],
              [124.25306644700004, 53.37550282800005],
              [124.23270593300003, 53.38165232300004],
              [124.20877974500002, 53.38268585200002],
              [124.18221805900009, 53.3785517380001],
              [124.15777510600009, 53.37002512600007],
              [124.14025679600002, 53.357803650000065],
              [124.12180830900002, 53.35268768400006],
              [124.10025923700005, 53.36335886700006],
              [124.06889164200004, 53.38961049400008],
              [124.05566247600012, 53.39488149000003],
              [124.02992761300004, 53.399945781],
              [124.017370239, 53.40702545200013],
              [124.01008386300015, 53.41467356400001],
              [123.98972334900009, 53.4414936320001],
              [123.97055139200006, 53.45518788700012],
              [123.87655196200006, 53.48867421500002],
              [123.85019698100007, 53.49497874000012],
              [123.73216801, 53.5037637330001],
              [123.70178226800016, 53.51006825800003],
              [123.67775272700015, 53.51999013300012],
              [123.63956384300008, 53.55125437400001],
              [123.6142940680001, 53.56334666000002],
              [123.59191817300012, 53.5578689580001],
              [123.56091231300002, 53.52417592400006],
              [123.54189538600014, 53.51409902000002],
              [123.51957116700015, 53.51999013300012],
              [123.53259362900008, 53.532495830000116],
              [123.53936324100005, 53.53704335600007],
              [123.54747644100013, 53.54050567600008],
              [123.53528080300009, 53.554613342000025],
              [123.51440352500003, 53.56241648400005],
              [123.49476648000012, 53.56009104500002],
              [123.48608483900006, 53.543916321000026],
              [123.48551639800007, 53.52598460000006],
              [123.4815373130001, 53.5180781050001],
              [123.47140873300009, 53.51900828100007],
              [123.43166955600009, 53.53580312200002],
              [123.4199390060001, 53.53854197300005],
              [123.38025150600009, 53.542831116000045],
              [123.3677458090001, 53.54582834900005],
              [123.34025394700012, 53.561434632000086],
              [123.30955814700008, 53.56748077500002],
              [123.27731205300006, 53.56944447900007],
              [123.25255904200003, 53.56779083300002],
              [123.23473067300006, 53.56034942700008],
              [123.20325972500012, 53.53828359000009],
              [123.18005700700013, 53.53048044900008],
              [123.16424401900008, 53.51637278300005],
              [123.15359867400002, 53.51311716700006],
              [123.0025484630001, 53.507329407000086],
              [122.85966312700015, 53.473946432],
              [122.47121138500012, 53.46474802700003],
              [122.42516768400003, 53.45244903600006],
              [122.40160323100008, 53.45095041900005],
              [122.37969242400004, 53.46164744100007],
              [122.35809167500008, 53.479579163000054],
              [122.33783451400006, 53.491309713000035],
              [122.31675052900005, 53.496012269000104],
              [122.2937028400001, 53.4926533000001],
              [122.22569665600008, 53.473946432],
              [122.16869755100004, 53.46914052300009],
              [122.1477685960001, 53.461130676000025],
              [122.10808109500016, 53.43808298800006],
              [122.08162276200005, 53.42950470000004],
              [122.02505194200006, 53.429823366000036],
              [121.88897302300012, 53.43058990500005],
              [121.64102950100005, 53.384907939000115],
              [121.51214847800014, 53.32982086200006],
              [121.45876672400004, 53.3204415900001],
              [121.413274785, 53.31733482400007],
              [121.40579838100012, 53.316824240000116],
              [121.35763594600013, 53.324058940000086],
              [121.34099613500013, 53.323645529000075],
              [121.32833540900009, 53.31997650199999],
              [121.299965047, 53.30253570600003],
              [121.25355961200006, 53.2869294230001],
              [121.20348514900007, 53.276749166000045],
              [121.151808716, 53.27450124100004],
              [121.05486372900009, 53.290004171000035],
              [120.8742545980001, 53.28015981100005],
              [120.84572920700015, 53.273441875000046],
              [120.825988811, 53.26186635400008],
              [120.83043298400003, 53.24483897000006],
              [120.82387007700004, 53.235227153000054],
              [120.7512646890001, 53.206908468000066],
              [120.714057658, 53.185049337000024],
              [120.65220096800016, 53.1228309130001],
              [120.61478723100004, 53.097070211000116],
              [120.52760909100004, 53.055806580000095],
              [120.450301147, 53.00834177700001],
              [120.39190677900007, 52.9567686970001],
              [120.36203780100004, 52.93937957800007],
              [120.35407963100016, 52.933230082000094],
              [120.34658654800006, 52.923463237000036],
              [120.34240075700012, 52.915427552000054],
              [120.33723311400001, 52.90770192500007],
              [120.32669112200006, 52.899046123000105],
              [120.3023515220001, 52.891242982000094],
              [120.29072432500004, 52.885351868000086],
              [120.28571171100009, 52.87488739000004],
              [120.2801823320001, 52.86592153000002],
              [120.26721154800009, 52.858144227000096],
              [120.25248376500008, 52.852692363000116],
              [120.21961755400002, 52.844915060000105],
              [120.17739790900015, 52.81791412400007],
              [120.15595218900006, 52.809077454000075],
              [120.06582849200004, 52.78321339900005],
              [120.0329622800001, 52.76065663700011],
              [120.04608809400008, 52.73399159800006],
              [120.0440210380001, 52.7235271200001],
              [120.05156579600009, 52.70458770800006],
              [120.05290938400003, 52.69301218700012],
              [120.036579631, 52.66812998500008],
              [120.03260054600003, 52.658879903000056],
              [120.03012007700016, 52.63937205000006],
              [120.03378910300006, 52.62536773700005],
              [120.04267745000004, 52.613507996000024],
              [120.05642338100012, 52.60051137400008],
              [120.07936771700014, 52.589969381000046],
              [120.11285404500012, 52.58451751700004],
              [120.17595096800005, 52.58374237100004],
              [120.19812015800011, 52.58911672],
              [120.24209680200016, 52.60722930900003],
              [120.2611137290001, 52.611053365000046],
              [120.36761885600004, 52.61725453700005],
              [120.38942631100008, 52.622163798000074],
              [120.4299406340001, 52.63609059700006],
              [120.4540218510001, 52.63903615400007],
              [120.464150432, 52.63603892000005],
              [120.49184899900001, 52.61725453700005],
              [120.53959802300005, 52.603663636000064],
              [120.60874108900015, 52.574001363],
              [120.6544747320001, 52.566999207],
              [120.70739139800008, 52.55033355700006],
              [120.72397953300009, 52.542168681000035],
              [120.70811486900004, 52.518139140000116],
              [120.704807577, 52.50917328000007],
              [120.70413578300008, 52.49783030200008],
              [120.701965373, 52.48876108800003],
              [120.69256026200003, 52.47460174600009],
              [120.69038985300006, 52.470157573000066],
              [120.69038985300006, 52.439125875000045],
              [120.68139815300003, 52.422976990000066],
              [120.6604175220001, 52.39879242000008],
              [120.65623173100005, 52.381429139000076],
              [120.65220096800016, 52.37246327800004],
              [120.64315759300013, 52.36633962000006],
              [120.633442424, 52.361740418000025],
              [120.62837813300007, 52.35789052400007],
              [120.626156047, 52.34680592900007],
              [120.62910160400008, 52.34088897700006],
              [120.633442424, 52.33546295200007],
              [120.63576786300013, 52.32618703200005],
              [120.6549398200001, 52.2991085820001],
              [120.73896569900006, 52.25660471600004],
              [120.75808597900004, 52.237406922000034],
              [120.75705245000006, 52.22787262000004],
              [120.75234989400008, 52.21185292600008],
              [120.7512646890001, 52.20296457900007],
              [120.75374515800007, 52.194463807000076],
              [120.76666426600008, 52.17955515500002],
              [120.77178023300007, 52.17162282400007],
              [120.77741296400006, 52.164956564000065],
              [120.78320072500009, 52.16198516900003],
              [120.7840792240001, 52.158006083000075],
              [120.77555261200007, 52.14836842900006],
              [120.77126346900002, 52.14097869900003],
              [120.77126346900002, 52.13247792600002],
              [120.77431237800016, 52.124261374000085],
              [120.77916996300007, 52.11759511400008],
              [120.76666426600008, 52.1084483850001],
              [120.75307336500009, 52.08633087200009],
              [120.74506351800011, 52.07666737900006],
              [120.73198938100006, 52.07018198700008],
              [120.71803674400007, 52.06653879800011],
              [120.7056344, 52.06103525800002],
              [120.69731449400001, 52.04871042900005],
              [120.696384319, 52.034473572000095],
              [120.70108687400005, 52.02287221300004],
              [120.707546428, 52.01240773500011],
              [120.71157718900008, 52.00158152300007],
              [120.71090539600004, 51.98832651800005],
              [120.7057894290001, 51.979954936000084],
              [120.683516886, 51.95931020200008],
              [120.66207116700008, 51.92504872700006],
              [120.6476017660001, 51.91101857500006],
              [120.62496748900008, 51.905334168000095],
              [120.5786137290001, 51.90768544600006],
              [120.56631473800013, 51.905334168000095],
              [120.55613448100007, 51.89838368800012],
              [120.54936486800005, 51.89047719400007],
              [120.54114831600009, 51.88298411100003],
              [120.52662723800006, 51.87742889400003],
              [120.51189945500005, 51.876188660000096],
              [120.502080933, 51.87724802700008],
              [120.49314091000008, 51.87572357200007],
              [120.4808935960001, 51.86686106400005],
              [120.47593265800009, 51.85913543700006],
              [120.47148848500007, 51.849006857000106],
              [120.46482222500003, 51.84019602500011],
              [120.4540218510001, 51.836449484000084],
              [120.42756351800006, 51.833658956000036],
              [120.40833988500003, 51.82608835900008],
              [120.3744401460001, 51.80231720000002],
              [120.31930139200011, 51.776039734000065],
              [120.18148034700005, 51.682970479000076],
              [120.16561568200007, 51.66855275500008],
              [120.15378178000003, 51.66397939000002],
              [120.12236250900003, 51.66715749100008],
              [120.10820316600007, 51.665193787000064],
              [120.10045170100005, 51.65994862900003],
              [120.08587894700008, 51.64436818500009],
              [120.0648983160001, 51.61488678000008],
              [120.05673343900008, 51.59638661700008],
              [120.05352950000008, 51.577033794],
              [120.05290938400003, 51.55220326800007],
              [120.0421606860001, 51.53853485100005],
              [119.99218957500005, 51.50326568600006],
              [119.977203411, 51.48701344900006],
              [119.97415450100004, 51.46417246500003],
              [119.98056237800006, 51.45272613500005],
              [119.98273278900007, 51.44215830500006],
              [119.9672815350001, 51.42182362900003],
              [119.95999515800008, 51.41228932700004],
              [119.95684289600007, 51.40451202500013],
              [119.95286381100004, 51.39766489700007],
              [119.943045289, 51.39081777000011],
              [119.89529626500013, 51.38397064200005],
              [119.90015384900005, 51.37025055000002],
              [119.91271122300014, 51.34963165300012],
              [119.91565677900007, 51.33074391700008],
              [119.8918856200001, 51.322553203000055],
              [119.88330733200007, 51.31800567700013],
              [119.860621379, 51.28901519800006],
              [119.8506478270001, 51.28433848100009],
              [119.82884037300005, 51.27971344100003],
              [119.81964196800004, 51.274726665000074],
              [119.81623132400006, 51.2689905810001],
              [119.80594771400007, 51.244005026000124],
              [119.8094100350001, 51.232610372000025],
              [119.81478438300013, 51.22274017400004],
              [119.81499109000009, 51.21589304600009],
              [119.802433716, 51.21328338600007],
              [119.77230635600012, 51.218476868],
              [119.76217777600004, 51.21504038500005],
              [119.75814701300015, 51.19902069200002],
              [119.78543217000009, 51.171658021000056],
              [119.77282312100016, 51.16269215900003],
              [119.76708703600008, 51.15972076400003],
              [119.75814701300015, 51.158015442000064],
              [119.76522668500007, 51.14243499800004],
              [119.7617126880001, 51.12817230200004],
              [119.75463301700012, 51.114297180000065],
              [119.7507056070001, 51.099982809],
              [119.74827681500005, 51.083394674],
              [119.74083540900006, 51.07153493200006],
              [119.72843306500016, 51.064532776000064],
              [119.7103979900001, 51.062465719],
              [119.71019128500012, 51.0385395310001],
              [119.68321618700008, 51.01606028300007],
              [119.60425459800007, 50.978181458000094],
              [119.59402266400008, 50.969551494000044],
              [119.57319706300012, 50.945832011],
              [119.5179549560001, 50.90480092400007],
              [119.52999556500004, 50.88707590800006],
              [119.5279801850001, 50.86676707000002],
              [119.51578454600008, 50.84811187800007],
              [119.49749108900005, 50.83591624000003],
              [119.51407922400006, 50.81338531500002],
              [119.51485437100007, 50.79193959600009],
              [119.50493249500005, 50.750598450000055],
              [119.49666426700003, 50.73705922500007],
              [119.4572868250001, 50.6962865200001],
              [119.44281742400005, 50.68507273400006],
              [119.41775435400007, 50.67628774100008],
              [119.40390507000012, 50.673238831000035],
              [119.39165775600009, 50.672050273000124],
              [119.38307946800006, 50.66662424700006],
              [119.37372603400001, 50.642749736000056],
              [119.36437260000008, 50.63727203400008],
              [119.3489730230001, 50.634688213000075],
              [119.34116988100004, 50.62807362900007],
              [119.33533044500007, 50.619236960000066],
              [119.32613204000006, 50.609986877000054],
              [119.31388472600014, 50.60461252900008],
              [119.30308435100011, 50.602752177000085],
              [119.29357588700015, 50.59923817900004],
              [119.28525598200008, 50.58890289400004],
              [119.28654789200004, 50.577740784000085],
              [119.26458540900006, 50.520018209000014],
              [119.2606063240001, 50.51407542],
              [119.254405152, 50.509527893000055],
              [119.25089115500015, 50.50451527900002],
              [119.2545085050001, 50.49702219700005],
              [119.25915938400016, 50.493249817000034],
              [119.26236332200006, 50.491957906],
              [119.26401696800008, 50.48958079000003],
              [119.26458540900006, 50.48275950200009],
              [119.26122644000014, 50.47924550400005],
              [119.24365645400007, 50.44550079300005],
              [119.2161645920001, 50.424933573000075],
              [119.20675948100006, 50.415115051],
              [119.19843957600006, 50.41309967100007],
              [119.16769209900013, 50.414081523000036],
              [119.15487634300013, 50.411394348],
              [119.14671146600011, 50.40426300100005],
              [119.13756473800004, 50.392532451000065],
              [119.13348230000014, 50.381473694000064],
              [119.14123376500004, 50.37661611000006],
              [119.17187789000008, 50.375685934],
              [119.18050785300011, 50.36979482],
              [119.17534021000012, 50.35610056600008],
              [119.1879492600001, 50.3547053030001],
              [119.21358077000002, 50.35656565400011],
              [119.22370935100002, 50.35610056600008],
              [119.23301110900007, 50.352741598000065],
              [119.24644698100013, 50.34416331000004],
              [119.2507878020001, 50.342509665000065],
              [119.31434981300009, 50.35170806900008],
              [119.33357344600012, 50.349899394],
              [119.35290043100014, 50.34550689700008],
              [119.35662113400008, 50.340752666000085],
              [119.36395918900007, 50.319461975000124],
              [119.365509481, 50.31083201100007],
              [119.36246057200003, 50.30416575200006],
              [119.35041996300009, 50.301478577000026],
              [119.33853438300002, 50.294037170000095],
              [119.33378015200003, 50.27626047800008],
              [119.33155806500014, 50.21734934500007],
              [119.33414188600005, 50.21114817400009],
              [119.34359867400013, 50.20220815100005],
              [119.34726770000009, 50.19507680300002],
              [119.34830122900007, 50.18458648800008],
              [119.34396040800004, 50.14241851900003],
              [119.33775923700006, 50.12412506100004],
              [119.32861250800016, 50.10805369100008],
              [119.31621016500009, 50.0926541140001],
              [119.30132735300003, 50.07978668300008],
              [119.25104618300008, 50.04826405800013],
              [119.22329594000013, 50.025009664000024],
              [119.20851648000013, 50.015139466000036],
              [119.18955122900007, 50.007284648000095],
              [119.09167606600016, 49.98656239800006],
              [118.99044193600008, 49.97932769800009],
              [118.9625366620001, 49.982014873000125],
              [118.94780887900009, 49.985218811],
              [118.9357682700001, 49.98961130800008],
              [118.92377933800003, 49.99162668900006],
              [118.9129272880001, 49.987699280000086],
              [118.90248864800009, 49.982118226000054],
              [118.89137821500003, 49.97932769800009],
              [118.79164270000007, 49.96635691400009],
              [118.74146488400004, 49.95307607100007],
              [118.71293949400007, 49.949458721000084],
              [118.67056482000015, 49.96206777000002],
              [118.64436486800003, 49.95457468700006],
              [118.59997481300007, 49.93095855700007],
              [118.57062260000009, 49.92072662400007],
              [118.55455122900003, 49.9097712210001],
              [118.52127160700002, 49.89406158500013],
              [118.4980172120001, 49.87674998000004],
              [118.49078251200001, 49.86951528000007],
              [118.4864416910001, 49.86067861000005],
              [118.48106734300006, 49.84243682900011],
              [118.47703658100016, 49.83597727500005],
              [118.45584924400009, 49.828639221000046],
              [118.39373417100006, 49.8200092580001],
              [118.38091841700015, 49.8114826460001],
              [118.3729602460001, 49.78631622400006],
              [118.35363326000004, 49.776446025000084],
              [118.32872522000008, 49.77303538000005],
              [118.30516076700007, 49.767092591000036],
              [118.24170210800003, 49.72916208900004],
              [118.22940311700006, 49.72921376600006],
              [118.22340865100006, 49.712108867],
              [118.20821578000005, 49.69541737900006],
              [118.18847538300008, 49.68125803700012],
              [118.16863163300007, 49.67149119100007],
              [118.10641320800005, 49.65180247100001],
              [118.08915328, 49.64012359700003],
              [118.07127323400005, 49.62513743200007],
              [118.054943481, 49.61402699800006],
              [118.0171163330001, 49.595785217000085],
              [117.93071333800003, 49.567311503000056],
              [117.90466841700004, 49.552738749000085],
              [117.89381636600001, 49.54664093100003],
              [117.87376591000015, 49.513206279000045],
              [117.84089969900003, 49.50964060500009],
              [117.83686893800012, 49.50902048800002],
              [117.831908, 49.50979563400004],
              [117.82260624200006, 49.51026072200004],
              [117.8157849530001, 49.51196604500002],
              [117.80358931500007, 49.51889068600009],
              [117.79501102700016, 49.51914906800006],
              [117.7774410400001, 49.51284454400006],
              [117.76886275200008, 49.51098419200004],
              [117.7588375250001, 49.51274119100002],
              [117.4728601490001, 49.614285381000016],
              [117.25292525200007, 49.62245025600005],
              [117.05758833800007, 49.67288645400005],
              [116.7223116460001, 49.80166412400003],
              [116.68427779200016, 49.8232648730001],
              [116.65337528500004, 49.86383087200004],
              [116.61720178200005, 49.89731720000002],
              [116.57544722500006, 49.92176015300005],
              [116.30052860600011, 49.992970277000026],
              [116.21763960800007, 50.01384755500008],
              [116.135370728, 50.01441599600004],
              [116.05361861200004, 49.9984479780001],
              [115.75089807200004, 49.88496653300005],
              [115.71627486200015, 49.877783509000025],
              [115.68340865100004, 49.87768015600007],
              [115.578195434, 49.8936481730001],
              [115.50853560400003, 49.88677520800006],
              [115.47298221900013, 49.88708526600003],
              [115.45014123500005, 49.89142608700011],
              [115.38781945900013, 49.891064352000015],
              [115.36869917900003, 49.895405172],
              [115.21015588400013, 49.971679586000036],
              [115.06339481700007, 50.077512920000075],
              [115.04964888500001, 50.09084543900009],
              [115.02804813700004, 50.119887594],
              [115.01523238200008, 50.13285837800002],
              [114.99735233600012, 50.144330547000024],
              [114.75374963400014, 50.236211243000085],
              [114.65969852800009, 50.251404114000124],
              [114.47304325400006, 50.234040833],
              [114.42498417200011, 50.24184397400002],
              [114.33300012300003, 50.27233306900011],
              [114.28628462800009, 50.27688059500004],
              [114.2000883390001, 50.25621002200005],
              [114.11823287000004, 50.22437734000009],
              [114.05529097500005, 50.18381134000005],
              [114.03513716700007, 50.17693837500009],
              [113.99327925600011, 50.16867014600005],
              [113.97312544800002, 50.16050527000003],
              [113.84982548000005, 50.08071685800006],
              [113.83680301900006, 50.07694447900012],
              [113.81582238800002, 50.07689280200002],
              [113.77313765500008, 50.081647034000085],
              [113.7522603760001, 50.07859812400007],
              [113.57966109200004, 50.01994537400013],
              [113.52788130700003, 49.99281524700005],
              [113.51041467300001, 49.981033020000055],
              [113.45853153600001, 49.95726186200001],
              [113.44230513500008, 49.946048076000054],
              [113.41553674400012, 49.92238027000003],
              [113.21244836500006, 49.82202463800006],
              [113.18268274000008, 49.80197418200002],
              [113.15674117000003, 49.777376201000024],
              [113.087494751, 49.68740753200008],
              [113.07715946500008, 49.669010722000095],
              [113.07416223200005, 49.65335276300003],
              [113.07157841000009, 49.617747701000056],
              [113.06082971200016, 49.59599192300006],
              [113.0436731370001, 49.588602194000046],
              [112.9928235270001, 49.58715525400005],
              [112.96977583800003, 49.583021139000024],
              [112.94734826700011, 49.57609649700005],
              [112.92616093000004, 49.56653635700003],
              [112.86807662000007, 49.531654766000074],
              [112.77712609900004, 49.50137237500003],
              [112.73371789600009, 49.492794088000025],
              [112.70147180200001, 49.491295472],
              [112.67139611900012, 49.49594635000007],
              [112.58426965400008, 49.52633209300002],
              [112.47326867800012, 49.53413523400003],
              [112.43223758900007, 49.5291742970001],
              [112.12640515100009, 49.43994041000009],
              [112.03019494700004, 49.41186879500002],
              [111.66101851400003, 49.39636586500011],
              [111.6164734300001, 49.38644399000002],
              [111.50350874800012, 49.34706654900002],
              [111.47911747300009, 49.34334584600002],
              [111.4545194910001, 49.34308746400002],
              [111.42961145100003, 49.34639475500002],
              [111.38506636600005, 49.36225942000003],
              [111.36274214800005, 49.36763376900011],
              [111.33845422400009, 49.36473988900012],
              [111.32098759000013, 49.355334778000056],
              [111.29173872900009, 49.330788472000094],
              [111.27354862500005, 49.32283030200004],
              [111.13856978400008, 49.29156606000002],
              [110.96555708800003, 49.20738515200007],
              [110.84101688700008, 49.16242665700004],
              [110.73135949700003, 49.13767364600001],
              [110.68805464700006, 49.13452138300006],
              [110.64495650200013, 49.13674347000007],
              [110.60361535700008, 49.145321757],
              [110.50822066300009, 49.18433746400008],
              [110.45127323500003, 49.19456939800007],
              [110.43328983600003, 49.20263092100008],
              [110.38223352000006, 49.24004465800003],
              [110.37117476400005, 49.24174998000008],
              [110.36104618400009, 49.23461863200005],
              [110.34543990100008, 49.22061431900006],
              [110.30936975100008, 49.19586130800003],
              [110.26833866400011, 49.17705108600002],
              [110.22503381400003, 49.165372213000055],
              [110.1814189050001, 49.1619615690001],
              [109.9131148680001, 49.21368967700006],
              [109.83218957500003, 49.226867168000055],
              [109.8177201740001, 49.22774566700009],
              [109.78495731600009, 49.2513617960001],
              [109.72852665200003, 49.266451315000026],
              [109.51623986800007, 49.25590932300004],
              [109.49184859200005, 49.262782288000025],
              [109.4743819580001, 49.26913848900004],
              [109.46983443300007, 49.276631572000085],
              [109.46570031700003, 49.29445994100011],
              [109.46208296700013, 49.30045440700006],
              [109.45071415200005, 49.30593210900004],
              [109.41123335800012, 49.30319325800009],
              [109.39097619600011, 49.309291077000054],
              [109.33630253100006, 49.32334706600007],
              [109.31191125500004, 49.332545472000064],
              [109.28669315600007, 49.338539938000096],
              [109.16060266100004, 49.34665313700002],
              [109.05802494400007, 49.32908315100012],
              [109.03296187300003, 49.32789459300001],
              [108.93048750800011, 49.348823548],
              [108.85896732600008, 49.34055531800006],
              [108.75106693500004, 49.341175436000114],
              [108.6084399830001, 49.32365712600004],
              [108.5699726530001, 49.325718884000125],
              [108.53805668100006, 49.32742950500007],
              [108.47366784700006, 49.356419983000066],
              [108.33486495000005, 49.43636342400008],
              [108.2771423750001, 49.482510478],
              [108.26727217600012, 49.495842997000025],
              [108.2595207110001, 49.50964060500009],
              [108.25052901200007, 49.52240468300006],
              [108.2363696700001, 49.532481588000095],
              [108.20991133600012, 49.54023305300008],
              [108.12645389900007, 49.54715769400006],
              [108.10619673700006, 49.554340719000024],
              [108.03266117300006, 49.589325663000025],
              [108.01571130400004, 49.60224477200005],
              [108.00527266500012, 49.61779937700008],
              [108.00754642800013, 49.633612366000065],
              [108.01581465700008, 49.65572987900008],
              [108.00279219600003, 49.66317128500002],
              [107.9628979900001, 49.66110422800004],
              [107.93948856700007, 49.66322296200012],
              [107.92744795800007, 49.67004425100008],
              [107.92682784100003, 49.68286000600004],
              [107.94935876500011, 49.72063547800012],
              [107.95483646700012, 49.73277943900011],
              [107.95576664300006, 49.745543518],
              [107.95003055800004, 49.78249216800002],
              [107.9323572190001, 49.830292868000114],
              [107.9300317790001, 49.851428528000056],
              [107.93550948100005, 49.86662139900007],
              [107.9443978270001, 49.880419006000025],
              [107.95261438000011, 49.89747222900006],
              [107.95649011200004, 49.923362122000086],
              [107.94651656100007, 49.93349070300006],
              [107.89819909700003, 49.935506084000096],
              [107.85096683800009, 49.946048076000054],
              [107.83918461100006, 49.94656484000011],
              [107.8079203690001, 49.94387766600006],
              [107.78693973800011, 49.948218486000044],
              [107.7505078530001, 49.965581767000074],
              [107.74460414500004, 49.967352880000064],
              [107.72932051600003, 49.97193796900008],
              [107.3640714930001, 49.97612376000002],
              [107.30485030200003, 50.01002349900004],
              [107.28040734900009, 50.00759470600009],
              [107.25487919200003, 49.998913066000014],
              [107.22490686100008, 49.997052715],
              [107.19219567900012, 50.00604441400007],
              [107.16449711100006, 50.018860169000035],
              [107.11462935500003, 50.05048614600004],
              [107.10072839300005, 50.05679067000004],
              [107.07029097500009, 50.0662474570001],
              [107.05711348500012, 50.074102275000044],
              [107.04843184400005, 50.08464426700003],
              [107.03923343900004, 50.10826039700002],
              [107.03360070800011, 50.118802388000105],
              [107.0262109790001, 50.12572703100007],
              [107.00605717000013, 50.140196432000025],
              [106.99799564600005, 50.149808248000014],
              [106.9826994230001, 50.187118632000065],
              [106.97365604700013, 50.19636871300007],
              [106.93644901600004, 50.209132792000034],
              [106.78829268400006, 50.291505026000024],
              [106.74617639200011, 50.30742136700006],
              [106.65651778200004, 50.32700673500007],
              [106.54820398000004, 50.335791728000046],
              [106.43978682500006, 50.32793691000002],
              [106.24486332200013, 50.29026479100007],
              [106.22228072100006, 50.29238352500006],
              [106.20119673700003, 50.299721578000046],
              [106.16094079600009, 50.31961700500007],
              [106.13530928600005, 50.327110088],
              [106.05593428600008, 50.33356964200006],
              [106.04818282100007, 50.33811716700008],
              [106.04446211800007, 50.346023661000046],
              [106.04327356000005, 50.355532125000124],
              [106.04327356000005, 50.36478220600013],
              [106.03893273900007, 50.37139679000002],
              [105.98487919200005, 50.399767151000034],
              [105.95805912300006, 50.403591207000076],
              [105.90421228000014, 50.40379791300005],
              [105.85470625800008, 50.41092926000006],
              [105.80654382300003, 50.42436513300002],
              [105.77925866800007, 50.42891265900006],
              [105.63937056500009, 50.42193634100006],
              [105.32864017800006, 50.476454977000074],
              [105.27846236200003, 50.4725792440001],
              [105.24073856600006, 50.45800649100006],
              [105.13133955900008, 50.39806182900007],
              [105.10575972600003, 50.390051982],
              [105.07821618700012, 50.385142721000065],
              [105.0501042080001, 50.383489075000014],
              [104.93424564700013, 50.39325592100006],
              [104.90158614100005, 50.38979360000003],
              [104.8790035400001, 50.383902486000025],
              [104.81849043800003, 50.35832265300009],
              [104.78955163600011, 50.35263824500002],
              [104.69705082200005, 50.35320668600009],
              [104.67188440000012, 50.34829742400005],
              [104.63245528200008, 50.32375111900008],
              [104.61044112100012, 50.31419097900009],
              [104.57695479300003, 50.309488424],
              [104.4741186930001, 50.313260803000034],
              [104.40580245000012, 50.300548401000086],
              [104.37722538200006, 50.28917958600009],
              [104.34950155100006, 50.27186822],
              [104.32136316000009, 50.25429799400011],
              [104.26896325700005, 50.2288731900001],
              [104.24746586100008, 50.20660064800005],
              [104.19811486900011, 50.17001373300012],
              [104.12168542500012, 50.14825795500009],
              [104.0395198980001, 50.14117828400008],
              [103.97399418100008, 50.14872304300003],
              [103.84542321800006, 50.18468984000002],
              [103.78527185100012, 50.1861367800001],
              [103.66806970300007, 50.131204733000075],
              [103.60140710400009, 50.13353017200011],
              [103.53391768400013, 50.153787334000086],
              [103.47397302300004, 50.18200266500007],
              [103.43872969600005, 50.192596334000044],
              [103.40710371900008, 50.19729888900012],
              [103.30659305800003, 50.19042592400005],
              [103.27677575700005, 50.197557272],
              [103.25310795100012, 50.21497223000004],
              [103.24018884300011, 50.2443761200001],
              [103.20168990100007, 50.296982727000014],
              [103.13001469000005, 50.309126689000024],
              [102.97410689300011, 50.295639140000034],
              [102.92739139800011, 50.302977193000046],
              [102.8871354580001, 50.3149661260001],
              [102.76259525600005, 50.37480743500005],
              [102.6195294150001, 50.399009150000026],
              [102.6177978930001, 50.399302063],
              [102.58658532800013, 50.41527008100006],
              [102.51310144100006, 50.50368845700008],
              [102.47186364800007, 50.52492747000004],
              [102.37269657400003, 50.53366078800012],
              [102.32763472600004, 50.54554636600004],
              [102.30293339000008, 50.563891500000025],
              [102.28241784700009, 50.59060821600009],
              [102.27156579700005, 50.62094228100004],
              [102.2759066160001, 50.65019114200008],
              [102.29683557200008, 50.67494415300011],
              [102.32024499500005, 50.69613149000007],
              [102.32939172400006, 50.71881744500003],
              [102.30753259300008, 50.748221334],
              [102.24567590400011, 50.77876210500001],
              [102.21678877800014, 50.798864237000075],
              [102.20304284700012, 50.82935333300007],
              [102.21275801600007, 50.85674184200009],
              [102.23187829600005, 50.884750469000025],
              [102.23947473100003, 50.912294007000085],
              [102.21523848500004, 50.93818389900012],
              [102.22557377100003, 50.95074127200003],
              [102.23105147300004, 50.964900615],
              [102.22965620900004, 50.979266663],
              [102.21937259900005, 50.99265085900002],
              [102.19198409100011, 51.02058197000012],
              [102.16537072800008, 51.057556458000064],
              [102.14650883000007, 51.09763153100006],
              [102.1421680090001, 51.13483856200007],
              [102.14878259300008, 51.16878997800008],
              [102.15002282800003, 51.18540395100008],
              [102.14764571200004, 51.20263804200009],
              [102.13968754100011, 51.22093149900006],
              [102.1337964270001, 51.23085337400006],
              [102.13529504400003, 51.2402843230001],
              [102.17927168800009, 51.28643137600004],
              [102.19337935400011, 51.307205303],
              [102.1838708900001, 51.323896790000035],
              [102.09126672400004, 51.3646436560001],
              [102.07467858900003, 51.37482391400006],
              [102.05121748900007, 51.383608908000056],
              [101.97421960500003, 51.38722625800004],
              [101.95561609000009, 51.39378916500003],
              [101.92068282100007, 51.41303863500006],
              [101.9018726000001, 51.41706939800004],
              [101.82177413000011, 51.413581239000095],
              [101.79531579600012, 51.41939483700007],
              [101.74219242400011, 51.4448454800001],
              [101.72369226100005, 51.45058156300006],
              [101.69661381100013, 51.45244191500005],
              [101.64369714400004, 51.45009063800002],
              [101.56985152200008, 51.47008941700004],
              [101.52639164300007, 51.4758255010001],
              [101.48205326400011, 51.47287994400001],
              [101.3877954510001, 51.45055572500006],
              [101.35017500800006, 51.4504523720001],
              [101.31544844600006, 51.463604025000095],
              [101.27968835500013, 51.49259450400005],
              [101.24155114700005, 51.5151771040001],
              [101.2007267670001, 51.52091318800005],
              [101.1587655030001, 51.52122324600005],
              [101.11701094600005, 51.52783783000005],
              [101.06946862800004, 51.553443502],
              [100.63890059500005, 51.69203969300007],
              [100.57110111500003, 51.704803772000034],
              [100.51089807200003, 51.72689544700002],
              [100.21029626500007, 51.72622365400004],
              [100.09826175900014, 51.7386518360001],
              [100.00596765200004, 51.731727193000054],
              [99.91791101100011, 51.74947804800006],
              [99.8486645910001, 51.78934641500008],
              [99.78396569900013, 51.837612203],
              [99.70965498900006, 51.880581156000076],
              [99.67932092300009, 51.88866851900009],
              [99.55684777900012, 51.89145904600004],
              [99.32389042200003, 51.93422129400007],
              [99.29536503100007, 51.9435488890001],
              [99.27469445800006, 51.95949106900012],
              [99.25598759000007, 51.97791371700002],
              [99.23283654800008, 51.99424347000006],
              [99.19873010300012, 52.00659413700002],
              [99.02509729100007, 52.045532329000096],
              [98.99471154800011, 52.05829640700007],
              [98.9744543870001, 52.080388082000084],
              [98.96246545500003, 52.11255666100003],
              [98.93765156300003, 52.12468748800008],
              [98.92763553900005, 52.12958404600003],
              [98.88639774600006, 52.12855051700005],
              [98.85559859200009, 52.10669138600012],
              [98.84960412600009, 52.09012909000002],
              [98.84888065700005, 52.056306865000025],
              [98.84650354100012, 52.039331157000035],
              [98.83854537000008, 52.02527516700009],
              [98.80020145700013, 51.99274485300005],
              [98.79172652200003, 51.977500306000124],
              [98.77663700400012, 51.93011301700004],
              [98.71111128700005, 51.84510528600005],
              [98.68268925000012, 51.819473776000066],
              [98.6513733320001, 51.79748545300002],
              [98.61871382700014, 51.780664775000034],
              [98.42503055800012, 51.746222433000085],
              [98.33221968600009, 51.7183171600001],
              [98.27351525900013, 51.65483266200006],
              [98.26338667800007, 51.63519561800011],
              [98.23868534400009, 51.601476746000046],
              [98.22824670400013, 51.583415833000046],
              [98.22431929600009, 51.56000640900008],
              [98.23382775900006, 51.51652069100005],
              [98.2299003500001, 51.49287872300003],
              [98.22039188600007, 51.475205383000045],
              [98.13781294800009, 51.485876567000034],
              [98.1113546150001, 51.48471384700012],
              [98.06670617700013, 51.46926259400003],
              [98.05089318900013, 51.46642039000007],
              [98.03973108000014, 51.457299500000076],
              [98.02061080000004, 51.435181986000075],
              [97.97451542100009, 51.36859690300007],
              [97.96221643100006, 51.355445252],
              [97.93379439300003, 51.33177744600006],
              [97.92283899000006, 51.31847076500004],
              [97.91570764200003, 51.30061655700011],
              [97.91632775900007, 51.2858887740001],
              [97.9281099860001, 51.251472270000065],
              [97.93172733600005, 51.230414124000035],
              [97.92904016200004, 51.21504038500005],
              [97.90030806500005, 51.16842824300009],
              [97.89472701000011, 51.15385548900012],
              [97.88563195800003, 51.12011077900006],
              [97.87012902900005, 51.08680531800012],
              [97.8063603110001, 51.00112579400003],
              [97.80853072100007, 50.97048166900002],
              [97.83571252400009, 50.94071604500003],
              [97.87198938000006, 50.917099915],
              [97.91942834500003, 50.89741119400004],
              [97.92966027800003, 50.88661082000003],
              [97.9387553310001, 50.87441518200011],
              [97.95301802600005, 50.86283966100005],
              [97.98464400300003, 50.84692332000013],
              [97.99022505800008, 50.835606181000045],
              [97.94743697100006, 50.795970358],
              [97.94402632700013, 50.77447296200005],
              [97.97451542100009, 50.723158264000105],
              [98.02329797400006, 50.64202626600006],
              [98.03849084500007, 50.622957663000065],
              [98.06009159300004, 50.60890167300006],
              [98.13595259600004, 50.57097117100007],
              [98.16334110500003, 50.56466664600005],
              [98.22555953000011, 50.55763865200002],
              [98.25129439300008, 50.550558981],
              [98.27537561100013, 50.53769154900003],
              [98.29346236200007, 50.518622946000036],
              [98.30069706200004, 50.492939759000066],
              [98.30069706200004, 50.49283640600002],
              [98.3005937100001, 50.492784729],
              [98.29821659400005, 50.46012522400004],
              [98.26628055800006, 50.40069732700009],
              [98.26183638600008, 50.36746938100005],
              [98.27010461500004, 50.335946758],
              [98.27227502400012, 50.318996888000086],
              [98.26927779200008, 50.29941152000008],
              [98.26245650200013, 50.283805237000124],
              [98.10556685400007, 50.06387034100008],
              [98.04799930800004, 50.02304596000009],
              [97.90619917800012, 49.97307485],
              [97.87457320200014, 49.95395457000011],
              [97.84739139800007, 49.93008005800003],
              [97.8299247650001, 49.92331044600009],
              [97.81070113200008, 49.931165263000096],
              [97.77752486200006, 49.956176656000096],
              [97.7563375250001, 49.96149932900006],
              [97.73359989500005, 49.95834706700002],
              [97.64223596200003, 49.930028381000014],
              [97.56658166500006, 49.9167992150001],
              [97.56317102000003, 49.90894439700007],
              [97.57174930800005, 49.89674875900006],
              [97.58125777200013, 49.877938538000066],
              [97.57360966000005, 49.847501119000086],
              [97.5427071530001, 49.822748108000056],
              [97.47459761600004, 49.78869334000011],
              [97.39077844200011, 49.74947092800004],
              [97.34333947800008, 49.73417470300008],
              [97.30168827400007, 49.72554473900006],
              [97.26231083200008, 49.7261131800001],
              [97.20505334500012, 49.734071351000054],
              [97.1529635010001, 49.75024607400006],
              [97.12898563600004, 49.775825908000016],
              [97.11989058500006, 49.793654277000044],
              [97.10015018700011, 49.80218088800008],
              [97.08526964300012, 49.805838275000085],
              [97.05725874900008, 49.81272288000004],
              [97.04227258300011, 49.82321319600008],
              [97.00589237500003, 49.86527781200003],
              [96.96920210800005, 49.88667185500013],
              [96.70193160000014, 49.91375030500008],
              [96.68022749900013, 49.909719544],
              [96.62596724500008, 49.87339101100012],
              [96.60436649600013, 49.86290069600007],
              [96.5851428630001, 49.85752634700002],
              [96.56808964000004, 49.86176381400007],
              [96.55300012300006, 49.87985056600006],
              [96.53925419100011, 49.901864726000056],
              [96.52385461400013, 49.91576568700005],
              [96.50328739400004, 49.922121887000046],
              [96.47465865100008, 49.92165679900005],
              [96.44882043500007, 49.91395701200004],
              [96.39910770700004, 49.891736145],
              [96.37285607900003, 49.886051737000045],
              [96.34629439300011, 49.88858388300004],
              [96.32335005700008, 49.89788564100006],
              [96.2811820880001, 49.92625600200007],
              [96.23560347500012, 49.9492003380001],
              [96.08636193900008, 49.992763570000065],
              [96.08625858600004, 49.99281524700005],
              [96.08605188000007, 49.99286692400007],
              [96.08594852700008, 49.992918600000095],
              [96.07106571500003, 49.99674265600002],
              [96.05597619600013, 49.998809713000085],
              [96.04099003100004, 49.99793121400005],
              [96.02662398300004, 49.99281524700005],
              [96.01194787600014, 49.985218811],
              [95.99830529800005, 49.97591705300006],
              [95.98569624800012, 49.96496165000009],
              [95.97484419800008, 49.9524559530001],
              [95.94631880700013, 49.93850331600002],
              [95.92265100100008, 49.94460113600006],
              [95.90446089700004, 49.96480662100005],
              [95.89216190700012, 49.992763570000065],
              [95.89216190700012, 49.992918600000095],
              [95.86704716000008, 50.01498443600009],
              [95.82787642400012, 50.020152079000084],
              [95.78767216000011, 50.01172882100009],
              [95.75894006400011, 49.99307362900005],
              [95.72142297400012, 49.95850209600003],
              [95.6804952390001, 49.94599639900004],
              [95.58396366400007, 49.9366946410001],
              [95.56318973800012, 49.92759958900005],
              [95.53714481600014, 49.90072784500005],
              [95.52060835800006, 49.88961741200002],
              [95.50066125500013, 49.88672353200003],
              [95.48061079900009, 49.89220123300002],
              [95.47720096200004, 49.894083165000055],
              [95.46169722600007, 49.90263987300007],
              [95.44516076700006, 49.91442209900008],
              [95.39978885900013, 49.938865051],
              [95.35472701000009, 49.947701721],
              [95.07639774600005, 49.945531311000124],
              [95.0283386640001, 49.96341135700008],
              [95.02162072800007, 49.96981923400001],
              [95.00405074100007, 49.992763570000065],
              [94.98058964100005, 50.024751282000054],
              [94.95371789500012, 50.04061594700006],
              [94.92157515500008, 50.04588694300007],
              [94.74639204900006, 50.040357564],
              [94.65099735500007, 50.01782664000005],
              [94.62453902200008, 50.015191142000035],
              [94.60345503800005, 50.01973866800007],
              [94.59229292900011, 50.02981557300002],
              [94.5744128830001, 50.05854766900002],
              [94.56397424300013, 50.07100168900011],
              [94.52087609900013, 50.09777008100009],
              [94.50909387300004, 50.10986236600006],
              [94.50227258300009, 50.1250552370001],
              [94.49855188000004, 50.139524638000026],
              [94.49173059100008, 50.152288717],
              [94.47498742700003, 50.162262268000106],
              [94.39178837100013, 50.185568340000046],
              [94.36853397600004, 50.20272491500002],
              [94.35447798700011, 50.223602193000076],
              [94.34434940600005, 50.24918202700012],
              [94.33225712100005, 50.30101348900011],
              [94.32750288900007, 50.40436635300007],
              [94.31975142500005, 50.429016012],
              [94.27975386500003, 50.49268137600008],
              [94.2782035730001, 50.529216614000106],
              [94.27334598800007, 50.54477122000013],
              [94.25866988200005, 50.557535299],
              [94.23758589700003, 50.56523508700009],
              [93.88696130400001, 50.57497609500005],
              [93.5363367110001, 50.584717103000074],
              [93.4215116790001, 50.60936676100009],
              [93.18834761600004, 50.59980662],
              [93.13915165200007, 50.599444886000086],
              [93.10494185400012, 50.59882476800003],
              [93.04262007600005, 50.60988352500003],
              [93.02287968000007, 50.61629140300006],
              [93.01140751200006, 50.62331939700009],
              [93.00293257600009, 50.63484324100001],
              [92.99187382000008, 50.65479034500002],
              [92.97337365700014, 50.69437449200008],
              [92.97399377400012, 50.74217519200006],
              [92.9616947830001, 50.77788360600006],
              [92.92107710800013, 50.79245636000003],
              [92.85772180200013, 50.79550527000005],
              [92.79612349500007, 50.788012187000035],
              [92.76026005000006, 50.77075225900005],
              [92.75343876200009, 50.75468088800007],
              [92.74661747300013, 50.721452942000056],
              [92.73524865800005, 50.70522654300002],
              [92.71736861200009, 50.69215240500007],
              [92.69525109900007, 50.6819204720001],
              [92.67189335100005, 50.675615947],
              [92.64977583900003, 50.674065653000056],
              [92.61184533700003, 50.68765655500006],
              [92.55458785000008, 50.7430020150001],
              [92.5164506430001, 50.76062367800007],
              [92.47490279200014, 50.77049387600006],
              [92.44327681500005, 50.78630686500007],
              [92.41898889200013, 50.81173167000007],
              [92.39986861200003, 50.85059234700013],
              [92.3845723880001, 50.865578512000084],
              [92.36090458200005, 50.86836904000005],
              [92.33547977700005, 50.863614808000065],
              [92.31522261600003, 50.85586334200006],
              [92.30168339100004, 50.84335764600006],
              [92.29744592300011, 50.82759633400009],
              [92.2970325120001, 50.80987131800008],
              [92.29444869000008, 50.791267803000025],
              [92.24277225800006, 50.72000600200006],
              [92.15884973100003, 50.689103495000055],
              [92.06273156800012, 50.686312968],
              [91.8999508060001, 50.70724192300007],
              [91.82419315600004, 50.70155751600005],
              [91.74977909300009, 50.68409088200009],
              [91.67960249900011, 50.656547343000014],
              [91.65314416500013, 50.64006256100002],
              [91.60270796700013, 50.57960113500009],
              [91.57573287000008, 50.56197947200012],
              [91.47506717900006, 50.53598622700004],
              [91.45036584500014, 50.519088033000045],
              [91.44003055800005, 50.498572490000086],
              [91.43248579900006, 50.478056946000024],
              [91.41574263500013, 50.46136545800006],
              [91.3821529540001, 50.45495758100013],
              [91.2975069580001, 50.46637807300003],
              [91.26009322100003, 50.4665847780001],
              [91.16335494000003, 50.43278839200009],
              [91.12976525900012, 50.42617380800003],
              [91.01204634600003, 50.42529530900008],
              [90.97514937400013, 50.41392649400008],
              [90.94858768800003, 50.39749338800003],
              [90.87706750500007, 50.33935740200012],
              [90.83996382700008, 50.32080556300009],
              [90.76244917800005, 50.30571604400008],
              [90.72658573500007, 50.29186676100004],
              [90.71759403500005, 50.28075632800001],
              [90.71738732900008, 50.25202423100008],
              [90.7126330970001, 50.237968241000075],
              [90.69971398900009, 50.2251524870001],
              [90.6839010010001, 50.216212464000066],
              [90.66643436700014, 50.210373026000084],
              [90.64845096900007, 50.20665232300006],
              [90.60493941300012, 50.20598053],
              [90.51894982900006, 50.218382874000056],
              [90.4752315670001, 50.21461049400004],
              [90.42500207600006, 50.186911927],
              [90.40495162000008, 50.18262278300004],
              [90.36392053300006, 50.17978057900005],
              [90.34387007600009, 50.174664612000086],
              [90.22294722500004, 50.1144098920001],
              [90.18243290200013, 50.10247263600006],
              [90.0512264410001, 50.08417917900009],
              [90.02053064000006, 50.07074330700003],
              [90.0049243580001, 50.05074452800001],
              [89.99872318600012, 50.024647929000096],
              [89.99709068900006, 50.003663546000055],
              [89.99624271700003, 49.992763570000065],
              [89.96942264900008, 49.967080384000084],
              [89.92017500800006, 49.95085398400006],
              [89.86643151900006, 49.942740784000065],
              [89.72070398000005, 49.939743551000035],
              [89.66768396000009, 49.927289531000056],
              [89.63321098500006, 49.907939134000046],
              [89.62386234600007, 49.90269154900007],
              [89.62107181800013, 49.89333811500005],
              [89.61528405800004, 49.8545291140001],
              [89.61533573400004, 49.84192006500005],
              [89.62107181800013, 49.83504709900011],
              [89.63895186400009, 49.82481516500012],
              [89.64355106700003, 49.8188723760001],
              [89.64194909700007, 49.808123678000086],
              [89.62737634300004, 49.796806539],
              [89.6264461670001, 49.788021546000024],
              [89.63895186400009, 49.775464173],
              [89.68370365400011, 49.76114980100003],
              [89.70153202400007, 49.75313995400005],
              [89.71264245600008, 49.735156555000046],
              [89.70241052300008, 49.719963685000025],
              [89.68230839100005, 49.70833648800006],
              [89.61631758600004, 49.68544382800006],
              [89.52030277500012, 49.66317128500002],
              [89.47534428000012, 49.643430888000026],
              [89.44159956900006, 49.64358591700007],
              [89.41860355600011, 49.62420725600002],
              [89.39782963100004, 49.59898915700005],
              [89.37193973800004, 49.581677552000045],
              [89.33943526200011, 49.58079905200002],
              [89.31070316600005, 49.593149720000085],
              [89.25220544400008, 49.629426575000124],
              [89.21644535400009, 49.63449086600009],
              [89.18735152200009, 49.62198516800002],
              [89.17820479300008, 49.59847239200012],
              [89.20156254000011, 49.570618795000044],
              [89.21561853000003, 49.54545237300003],
              [89.19525801600008, 49.521526184000024],
              [89.16073816000005, 49.502715963000085],
              [89.0140804450001, 49.460547995000056],
              [88.97532312000004, 49.45584543900007],
              [88.96266239500011, 49.46214996300007],
              [88.95470422400007, 49.47186513300004],
              [88.94757287600004, 49.48282053700008],
              [88.93759932500012, 49.492845765000126],
              [88.92695398000012, 49.50741851800008],
              [88.91909916200007, 49.523179831000064],
              [88.90835046400008, 49.535943909000125],
              [88.88892012500008, 49.54167999300007],
              [88.86819787700006, 49.53811431900003],
              [88.85874108900009, 49.527365622],
              [88.85615726700007, 49.51150095700008],
              [88.85486535600012, 49.47388051400007],
              [88.87532922300011, 49.44178945000006],
              [88.87062666800011, 49.436001689000065],
              [88.71942142800003, 49.44292633000005],
              [88.69565026900005, 49.44695709300005],
              [88.67466963800007, 49.45982452400004],
              [88.6486763910001, 49.48359568300002],
              [88.63353519700007, 49.491243795000074],
              [88.61575850500009, 49.49294911700004],
              [88.61415653500012, 49.492794088000025],
              [88.59973881000008, 49.48891835600004],
              [88.55782922400005, 49.471089986000024],
              [88.53876062100005, 49.46654246100006],
              [88.47540531400011, 49.46364858],
              [88.45111739100014, 49.46514719700009],
              [88.40192142700005, 49.47584421800009],
              [88.37877038600004, 49.47579254200009],
              [88.19996993000007, 49.45434682200006],
              [88.17475183100004, 49.4438565060001],
              [88.1617293700001, 49.430110576000075],
              [88.14560632400003, 49.39719268800003],
              [88.13578780200004, 49.38608225500012],
              [88.11553064000003, 49.35657501200008],
              [88.12917321800006, 49.32593088800006],
              [88.14839685100009, 49.296578675],
              [88.14395267700007, 49.270740459000066],
              [88.10850264500004, 49.24743438800003],
              [88.02974776300005, 49.215550029000084],
              [87.99295414200003, 49.19172719400011],
              [87.97548750900012, 49.17581085200008],
              [87.95678064000003, 49.1688862110001],
              [87.85518477400012, 49.15896433500011],
              [87.83699467000008, 49.15999786400009],
              [87.81632409700006, 49.16583730100008],
            ],
          ],
          [
            [
              [22.76721968600006, 54.356269837000056],
              [22.698386678000077, 54.34293731800004],
              [22.510387817000094, 54.3487767540001],
              [22.277120402000094, 54.35606313199999],
              [21.998946167000042, 54.364667257500074],
              [21.720771932000048, 54.37327138300007],
              [21.2874133710001, 54.386758932000035],
              [20.92960575300009, 54.397817688000046],
              [20.64083784950006, 54.40678354950002],
              [20.352069946000142, 54.41574941100002],
              [19.964703410000112, 54.4278416960001],
              [19.758255974000093, 54.434255669],
              [19.680276326000126, 54.436678365],
              [19.630770304000066, 54.44665191700001],
              [19.609548373000052, 54.456732489000046],
              [19.609629754000082, 54.456732489000046],
              [19.626475457000083, 54.461004950000074],
              [19.626475457000083, 54.468451239000046],
              [19.73406009200005, 54.52570221600007],
              [19.831879102000073, 54.59813060100004],
              [19.883148634000065, 54.65619538000004],
              [19.888682488000086, 54.660223700000074],
              [19.892832879000082, 54.661037502000056],
              [19.896332227000073, 54.662176825000074],
              [19.90015709700009, 54.66705963700008],
              [19.901052280000044, 54.67169830900008],
              [19.899261915000068, 54.68301015800006],
              [19.90015709700009, 54.687567450000074],
              [19.90560957100007, 54.69481028900003],
              [19.915212436000047, 54.70254140800006],
              [19.93018639400009, 54.71942780200004],
              [19.956309441000087, 54.75690338700008],
              [19.961680535000085, 54.77317942900004],
              [19.958832227000073, 54.79682038000004],
              [19.952321811000047, 54.81631094000005],
              [19.925791863000086, 54.86713288000004],
              [19.922211134000065, 54.876613674000055],
              [19.920664910000085, 54.88959381700005],
              [19.934336785000085, 54.91693756700005],
              [19.94076582100007, 54.93439362200007],
              [19.95671634200005, 54.95184967700004],
              [19.976735873000052, 54.96458567900004],
              [19.99586022200009, 54.968085028000075],
              [20.021657748000052, 54.951239325000074],
              [20.03370201900009, 54.94818756700005],
              [20.074961785000085, 54.954413153000075],
              [20.14356530000009, 54.95180898600006],
              [20.205821160000085, 54.95844147300005],
              [20.365570509000065, 54.946193752000056],
              [20.406993035000085, 54.951605536000045],
              [20.482432488000086, 54.97553131700005],
              [20.634043816000087, 55.04877350500004],
              [20.808441602000073, 55.17625560100004],
              [20.822276238000086, 55.180975653000075],
              [20.924568700365, 55.28265777882994],
              [20.989430696469412, 55.27311631266015],
              [20.989512566000087, 55.270412502000056],
              [20.951914910000085, 55.25470612200007],
              [20.94109134200005, 55.24868398600006],
              [20.94312584700009, 55.245306708000044],
              [20.943369988000086, 55.24453359600005],
              [20.937022332000083, 55.23773834800005],
              [20.91309655000009, 55.23322174700007],
              [20.90333092500009, 55.225816148000035],
              [20.905528191000087, 55.21857330900008],
              [20.895274285000085, 55.21625397300005],
              [20.890635613000086, 55.212591864000046],
              [20.88843834700009, 55.20600006700005],
              [20.884043816000087, 55.19806549700007],
              [20.876963738000086, 55.191839911000045],
              [20.86068769600007, 55.181341864000046],
              [20.853037957000083, 55.17413971600007],
              [20.834808790000068, 55.152044989000046],
              [20.823741082000083, 55.14313385600008],
              [20.773610873000052, 55.114488023000035],
              [20.687836134000065, 55.05068594000005],
              [20.558116082000083, 54.981756903000075],
              [20.548675977000073, 54.97797272300005],
              [20.539886915000068, 54.976629950000074],
              [20.533376498000052, 54.97357819200005],
              [20.53093509200005, 54.96466705900008],
              [20.533946160000085, 54.95966217700004],
              [20.541351759000065, 54.952053127000056],
              [20.55046634200005, 54.94476959800005],
              [20.558116082000083, 54.94082265800006],
              [20.576914910000085, 54.93891022300005],
              [20.763682488000086, 54.947699286000045],
              [20.80518639400009, 54.94082265800006],
              [20.86036217500009, 54.911322333000044],
              [20.969086134000065, 54.89980703300006],
              [21.039317254000082, 54.903998114000046],
              [21.050954623000052, 54.91038646000004],
              [21.055918816000087, 54.91445547100005],
              [21.06617272200009, 54.91010163000004],
              [21.076019727000073, 54.90338776200008],
              [21.078949415000068, 54.89980703300006],
              [21.090668165000068, 54.901556708000044],
              [21.096934441000087, 54.905462958000044],
              [21.100840691000087, 54.90997955900008],
              [21.106211785000085, 54.91351959800005],
              [21.190277540000068, 54.92690664300005],
              [21.23015384200005, 54.93891022300005],
              [21.243418816000087, 54.96124909100007],
              [21.236338738000086, 54.98078034100007],
              [21.219411655000044, 55.01325104400007],
              [21.19507897200009, 55.13540273600006],
              [21.19190514400009, 55.143459377000056],
              [21.191579623000052, 55.14716217700004],
              [21.183441602000073, 55.16864655200004],
              [21.18132571700005, 55.171087958000044],
              [21.18132571700005, 55.193345445000034],
              [21.183441602000073, 55.20172760600008],
              [21.18881269600007, 55.208319403000075],
              [21.20167076900009, 55.21442291900007],
              [21.21029707100007, 55.21149323100008],
              [21.216644727000073, 55.20526764500005],
              [21.222911004000082, 55.20148346600007],
              [21.23682701900009, 55.20062897300005],
              [21.248871290000068, 55.20148346600007],
              [21.259043816000087, 55.20498281500005],
              [21.267588738000086, 55.21173737200007],
              [21.271332227000073, 55.22028229400007],
              [21.273285352000073, 55.23265208500004],
              [21.272308790000068, 55.243841864000046],
              [21.267588738000086, 55.24868398600006],
              [21.34983850100005, 55.28778920500004],
              [21.374849894000135, 55.28995961500003],
              [21.405545695000086, 55.272389628000056],
              [21.46766076600008, 55.211153056000015],
              [21.50393762200011, 55.19440989200008],
              [21.605120076000105, 55.19249786400006],
              [21.645841105000073, 55.18102569600005],
              [21.716224405000105, 55.14945139600006],
              [21.733380982000057, 55.136325582],
              [21.750640910000072, 55.127954],
              [21.819887329000068, 55.119324036000066],
              [21.85389042200012, 55.10221913700012],
              [21.873217407000055, 55.09493276000005],
              [21.90856408700006, 55.08986847000007],
              [21.932955363000104, 55.08046335900012],
              [21.942773885000065, 55.078292948000026],
              [21.9513521720001, 55.08046335900012],
              [21.977500447000097, 55.091987203000045],
              [22.003442017000054, 55.093485820000055],
              [22.01543094900009, 55.088421530000076],
              [22.018634887000076, 55.07731109600006],
              [22.018634887000076, 55.060929667000025],
              [22.027729940000143, 55.04439320900012],
              [22.049950805000094, 55.03354115800006],
              [22.076822551000078, 55.0285802210001],
              [22.099870240000143, 55.029923808],
              [22.11847375500011, 55.03777862600002],
              [22.12984257000008, 55.04697703],
              [22.14265832500007, 55.05462514300008],
              [22.251282186000083, 55.070851542000085],
              [22.269883746000062, 55.06953696300003],
              [22.436283814000063, 55.05777740500004],
              [22.54108361900012, 55.07576080400004],
              [22.565474894000147, 55.067802633000085],
              [22.57116534000005, 55.06398964700007],
              [22.580667765000072, 55.057622376000026],
              [22.59162316800007, 55.037623596000074],
              [22.608366333000106, 54.992406718],
              [22.621698852000122, 54.970030823000016],
              [22.63348107900012, 54.95793853800002],
              [22.649914185000085, 54.95287424800004],
              [22.70613814200007, 54.9531326300001],
              [22.715543253000135, 54.95137563100003],
              [22.722054484000097, 54.94718984000009],
              [22.72918583200004, 54.94036855100005],
              [22.73879764800006, 54.934115703000046],
              [22.752130168000065, 54.931118469000026],
              [22.740968058000135, 54.91763092100008],
              [22.749236287000087, 54.90987945600007],
              [22.808870891000083, 54.89375640900009],
              [22.821273234000046, 54.88548818000005],
              [22.82933475800013, 54.87272410100006],
              [22.84432092300011, 54.83226145500008],
              [22.848351684000107, 54.81381296800005],
              [22.845767863000106, 54.79613962800006],
              [22.8328487550001, 54.77867299400002],
              [22.817759237000104, 54.769164531000044],
              [22.78665002400004, 54.75598704100004],
              [22.773007446000037, 54.742499492],
              [22.76484257000004, 54.73712514300003],
              [22.74727258300004, 54.73159576400012],
              [22.736730591000082, 54.726324768],
              [22.728255656000073, 54.72508453400006],
              [22.72484501100007, 54.7233792120001],
              [22.722777954000094, 54.71857330400009],
              [22.72484501100007, 54.71376739500009],
              [22.727532186000076, 54.709323222000066],
              [22.727015422000136, 54.7053441370001],
              [22.705104615000096, 54.68653391600007],
              [22.700867147000054, 54.679557597000084],
              [22.700763794000096, 54.669325663],
              [22.7069649660001, 54.646484680000086],
              [22.70810184700011, 54.63563262900006],
              [22.703657674000084, 54.61754587800003],
              [22.68174686700013, 54.569900208],
              [22.6746155190001, 54.4922822060001],
              [22.680403279000075, 54.453214824000085],
              [22.7069649660001, 54.41874664300012],
              [22.76721968600006, 54.356269837000056],
            ],
          ],
          [
            [
              [-180, 65.06622947500006],
              [-180, 65.06925207800003],
              [-180, 65.56786703600005],
              [-180, 66.06648199400007],
              [-180, 66.56509695300008],
              [-180, 67.06371191100004],
              [-180, 67.56232687000005],
              [-180, 68.06094182800007],
              [-180, 68.55955678700008],
              [-180, 68.98236981000008],
              [-179.71271725199992, 68.91791413000004],
              [-179.57990475199992, 68.90863678600005],
              [-179.5416153639999, 68.91022370000007],
              [-179.5140274729999, 68.92112864800004],
              [-179.53461666599992, 68.93227773600006],
              [-179.54344641799992, 68.93927643400008],
              [-179.54755611899992, 68.94790273600006],
              [-179.54096432199992, 68.96328359600005],
              [-179.5227758449999, 68.96454498900005],
              [-179.50153561099992, 68.95831940300008],
              [-179.48578854099992, 68.95132070500006],
              [-179.47101803299992, 68.93992747600004],
              [-179.44965572799993, 68.91290924700007],
              [-179.43797766799992, 68.90322500200006],
              [-179.41816158799992, 68.89638906500005],
              [-179.3826078379999, 68.87904137500004],
              [-179.35450007699993, 68.87084559700008],
              [-179.33377862299992, 68.85844102800007],
              [-179.34877119499993, 68.85751626800004],
              [-179.36342940499992, 68.85510089500008],
              [-179.3541360209999, 68.84437604200008],
              [-179.3553337189999, 68.83735043600007],
              [-179.3573670129999, 68.82781128200008],
              [-179.3277958129999, 68.82468178100004],
              [-179.31953039299992, 68.81195171400003],
              [-179.26113967799992, 68.80311975200004],
              [-179.2032748629999, 68.80970738500008],
              [-179.1726942749999, 68.80854632100005],
              [-179.16661332099991, 68.79923840500004],
              [-179.12830316499992, 68.78730892900006],
              [-179.0736115459999, 68.78926880500006],
              [-178.93573971299992, 68.77171458500004],
              [-178.8448125769999, 68.75236095300005],
              [-178.6773643269999, 68.67933608500005],
              [-178.59850012899992, 68.64337799700007],
              [-178.5171268109999, 68.60296151500006],
              [-178.48493404899992, 68.59153880400004],
              [-178.51423092399992, 68.58637116100005],
              [-178.54645748599992, 68.59210846600007],
              [-178.63690233999992, 68.63798233700004],
              [-178.6517942669999, 68.64459621400005],
              [-178.6875984579999, 68.66065921800003],
              [-178.7246181209999, 68.67568568900003],
              [-178.73615817599992, 68.67039605700006],
              [-178.7258878369999, 68.65967212600003],
              [-178.71916881299992, 68.64587364900007],
              [-178.7208257689999, 68.63287036700007],
              [-178.7119604829999, 68.62212023300003],
              [-178.7188810709999, 68.60799459500004],
              [-178.71382855599992, 68.59565937800005],
              [-178.7196637589999, 68.58305756300007],
              [-178.71144884999993, 68.56831296400009],
              [-178.70151316699992, 68.55161925000004],
              [-178.6999279919999, 68.54318931600005],
              [-178.6705216139999, 68.53701406500005],
              [-178.6186417309999, 68.52509186400005],
              [-178.45824133999992, 68.50967031500005],
              [-178.4267065089999, 68.50189850500004],
              [-178.3686417309999, 68.47955963700008],
              [-178.3381241529999, 68.47492096600007],
              [-178.27623450399992, 68.47842031500005],
              [-178.2484024729999, 68.47601959800005],
              [-178.19086666599992, 68.45416901200008],
              [-178.04181881399992, 68.42767975500004],
              [-178.0213516919999, 68.41596100500004],
              [-178.00670325399992, 68.37083567900004],
              [-177.99071204299992, 68.35285065300008],
              [-177.97028561099992, 68.34003327000005],
              [-177.9505102199999, 68.33771393400008],
              [-177.9661352199999, 68.33022695500006],
              [-177.9989721339999, 68.30418528900003],
              [-178.06037350199992, 68.27692291900007],
              [-178.0742081369999, 68.26557038000004],
              [-178.07367916599992, 68.25926341400003],
              [-178.0609024729999, 68.25641510600008],
              [-177.9970596999999, 68.25653717700004],
              [-177.98021399599992, 68.26044342700004],
              [-177.96479244699992, 68.26947663000004],
              [-177.96760006399992, 68.27033112200007],
              [-177.96894283799992, 68.27631256700005],
              [-177.9680883449999, 68.28416575700004],
              [-177.96479244699992, 68.29059479400007],
              [-177.9557999339999, 68.29547760600008],
              [-177.90709387899992, 68.30426666900007],
              [-177.89073645699992, 68.30329010600008],
              [-177.8743790359999, 68.30483633000006],
              [-177.85863196499992, 68.31415436400005],
              [-177.82237708199992, 68.32770416900007],
              [-177.73237057199992, 68.32611725500004],
              [-177.70470130099991, 68.34454987200007],
              [-177.9564102854999, 68.42210521050006],
              [-178.2081192699999, 68.49966054900005],
              [-178.24583899599992, 68.50519440300008],
              [-178.2956436839999, 68.51874420800004],
              [-178.3196508449999, 68.53107330900008],
              [-178.34516354099992, 68.53440989800004],
              [-178.3558243479999, 68.53701406500005],
              [-178.36200924399992, 68.54629140800006],
              [-178.36750240799992, 68.55288320500006],
              [-178.37507076699993, 68.55744049700007],
              [-178.0429784819999, 68.46019114800006],
              [-177.71088619699992, 68.36294179900005],
              [-177.66584225199992, 68.33539459800005],
              [-177.4963272779999, 68.29295482000003],
              [-177.49225826699993, 68.29173411700003],
              [-177.6017960279999, 68.30805084800005],
              [-177.63646399599992, 68.30418528900003],
              [-177.63365637899992, 68.29889557500007],
              [-177.6308487619999, 68.28778717700004],
              [-177.62901770699992, 68.28314850500004],
              [-177.76557369699992, 68.26264069200005],
              [-177.7484024729999, 68.25336334800005],
              [-177.71076412699992, 68.24835846600007],
              [-177.6770727199999, 68.22980377800008],
              [-177.63914954299992, 68.22549062700006],
              [-177.6221817699999, 68.21426015800006],
              [-177.6360977859999, 68.20506419500003],
              [-177.63984127499992, 68.19879791900007],
              [-177.63471432199992, 68.19529857000003],
              [-177.6221817699999, 68.19432200700004],
              [-177.60846920499992, 68.19676341400003],
              [-177.4615372389999, 68.24628327000005],
              [-177.3940323559999, 68.24957916900007],
              [-177.33808346299992, 68.24457428600005],
              [-177.20331783799992, 68.20490143400008],
              [-177.17353268099993, 68.19867584800005],
              [-177.1909073559999, 68.19745514500005],
              [-177.23810787699992, 68.20742422100005],
              [-177.2591039699999, 68.21112702000005],
              [-177.26451575399992, 68.20184967700004],
              [-177.25352942599991, 68.19110748900005],
              [-177.22492428299992, 68.17328522300005],
              [-177.2385147779999, 68.16795482000003],
              [-177.24482174399992, 68.16705963700008],
              [-177.2187393869999, 68.13955312700006],
              [-177.1662491529999, 68.13739655200004],
              [-177.06725012899992, 68.15277741100005],
              [-177.0987442699999, 68.16185130400004],
              [-177.10822506399992, 68.16705963700008],
              [-177.07542883999992, 68.16425202000005],
              [-176.9366523239999, 68.12072486600005],
              [-176.82005774599992, 68.08657461100006],
              [-176.6182182489999, 68.02670410400003],
              [-176.56453810699992, 68.01031561500008],
              [-176.59323209899992, 68.00605911300005],
              [-176.72504454799991, 68.03785176100007],
              [-176.71798576499992, 68.02626621500008],
              [-176.7530559729999, 68.01530878100004],
              [-176.7791418059999, 68.00190168300009],
              [-176.77437762699992, 67.99279895900008],
              [-176.78933581599992, 67.97861818800004],
              [-176.78230052599991, 67.96786894900004],
              [-176.70210777399993, 67.94917598500007],
              [-176.6619024659999, 67.93442091700007],
              [-176.57320319599992, 67.92234190300007],
              [-176.55538414699993, 67.91660325900006],
              [-176.53937136599993, 67.89509672100007],
              [-176.4995202069999, 67.88860473800008],
              [-176.4070844089999, 67.89469917700006],
              [-176.3828072409999, 67.89310780900007],
              [-176.23961006899992, 67.89757409600008],
              [-176.20879499199992, 67.90177004200007],
              [-176.2884728969999, 67.92236018300008],
              [-176.3572533299999, 67.94293721600008],
              [-176.42621199599992, 67.96597603500004],
              [-176.4884416029999, 67.97905560100008],
              [-176.53078489299992, 67.99052682800004],
              [-176.53331889499992, 68.00296202500004],
              [-176.3997110889999, 67.96771017500004],
              [-176.27428137899992, 67.92853424700007],
              [-176.0855894839999, 67.88398576000003],
              [-175.98310299399992, 67.86082591400003],
              [-175.92072506399992, 67.85101959800005],
              [-175.9277485069999, 67.84671454200009],
              [-176.0050918059999, 67.85399773000006],
              [-176.04858234199992, 67.85215067000007],
              [-176.08470693599992, 67.83207718900007],
              [-176.1159099729999, 67.80653715300008],
              [-176.1373801999999, 67.77735890800005],
              [-176.10112798499992, 67.76008637600006],
              [-176.0649584129999, 67.74827255300005],
              [-176.0480601399999, 67.73552887700004],
              [-176.0696593449999, 67.72731413300005],
              [-176.0937157319999, 67.73002736600006],
              [-176.17787405099992, 67.72992993100007],
              [-176.23313193899992, 67.72528679600003],
              [-176.3004632109999, 67.72424411400004],
              [-176.32668318199993, 67.70960524400004],
              [-176.3408732169999, 67.69590243100004],
              [-176.2831569989999, 67.69238845900009],
              [-176.26842328599992, 67.66872766000006],
              [-176.20579216899992, 67.64515193000005],
              [-176.12179181599993, 67.62704630900004],
              [-176.0212687339999, 67.63076963300006],
              [-175.9733981009999, 67.63898505300006],
              [-175.92550153399992, 67.63898670100008],
              [-175.88242260299992, 67.62895416200007],
              [-175.8848579349999, 67.61255623700004],
              [-175.91118412999992, 67.60345307400007],
              [-175.9135961019999, 67.58796550100004],
              [-175.8682052979999, 67.58430677700005],
              [-175.7702819349999, 67.57967793200004],
              [-175.7392054819999, 67.58237574100008],
              [-175.72499080999992, 67.56960240200004],
              [-175.7129542689999, 67.57960688900005],
              [-175.6817892169999, 67.58957938200007],
              [-175.66966028399992, 67.60504763200004],
              [-175.67189410299991, 67.61871810000008],
              [-175.71012157299992, 67.62424492700006],
              [-175.7267298319999, 67.63975511600006],
              [-175.76735116999993, 67.65164718300008],
              [-175.8320452829999, 67.65170309100006],
              [-175.87280040699991, 67.64443799800006],
              [-175.8967422869999, 67.64991331300007],
              [-175.88712104299992, 67.66539815600004],
              [-175.8726833869999, 67.68270264200004],
              [-175.84860174399992, 67.70455590600005],
              [-175.8869893319999, 67.71915139600009],
              [-175.9494672509999, 67.72553924100004],
              [-176.0071461439999, 67.72279431900006],
              [-176.01196591099992, 67.72734776500005],
              [-175.9206018319999, 67.74740350000008],
              [-175.8531558749999, 67.76833473000005],
              [-175.8338441479999, 67.77834492400007],
              [-175.82169814699992, 67.79746950500004],
              [-175.8240291509999, 67.81296012700005],
              [-175.5152039189999, 67.72280957700008],
              [-175.3814591139999, 67.68720123900005],
              [-175.28650039599992, 67.66710570000004],
              [-175.2655287309999, 67.65855507900005],
              [-175.26098866599992, 67.64595824700007],
              [-175.29612077399992, 67.64419627300003],
              [-175.3123622319999, 67.63465150900004],
              [-175.29951963399992, 67.62054628800007],
              [-175.29077365799992, 67.60561657100004],
              [-175.2549843649999, 67.58605975300009],
              [-175.24015802199992, 67.57429932900004],
              [-175.24795837999991, 67.55928950800006],
              [-175.22484569999992, 67.54520543700005],
              [-175.1267700349999, 67.49988984300006],
              [-175.1432532069999, 67.50061706200006],
              [-175.2183313719999, 67.53419921100004],
              [-175.2265299149999, 67.53258846500006],
              [-175.2137983199999, 67.52003516300005],
              [-175.20512923099992, 67.50510128200006],
              [-175.1904172419999, 67.49413191600007],
              [-175.19622273099992, 67.48071615400005],
              [-175.1877636199999, 67.47208405800006],
              [-175.18939263299993, 67.45632073300004],
              [-175.18907309099993, 67.44450396400003],
              [-175.17239762999992, 67.43511393100005],
              [-175.18460703999992, 67.43112722500007],
              [-175.21123982299991, 67.42944552800003],
              [-175.2337410529999, 67.42698907400006],
              [-175.24164843699992, 67.41671337300005],
              [-175.24132726099992, 67.40568423300004],
              [-175.24922442899992, 67.39540795900007],
              [-175.35045325399992, 67.38251373900005],
              [-175.3668831669999, 67.35778862900008],
              [-175.3111700169999, 67.34467997900003],
              [-175.29068294099991, 67.34399385600005],
              [-175.2599689809999, 67.34335384000008],
              [-175.2271586239999, 67.34034441900008],
              [-175.1882797609999, 67.33972307200008],
              [-175.1595889749999, 67.33747679100009],
              [-175.13108097499992, 67.34231379200008],
              [-175.10464525799992, 67.34871328200006],
              [-175.0741398609999, 67.35669642000005],
              [-175.04977204999992, 67.36543809500006],
              [-175.0233376459999, 67.37418178000007],
              [-175.0153819489999, 67.38601977300004],
              [-175.0114389709999, 67.39390876400006],
              [-174.9911516829999, 67.40499440900004],
              [-174.9934107629999, 67.41601663100005],
              [-174.96894807299992, 67.42474840500006],
              [-174.9856444149999, 67.43967225900008],
              [-175.02082389799992, 67.45296636900008],
              [-175.05610104099992, 67.46015045800004],
              [-175.07982337099992, 67.48114655200004],
              [-174.96393795499992, 67.44525788000004],
              [-174.92902584499993, 67.42649974200003],
              [-174.91336157599991, 67.41337642300005],
              [-174.9213509399999, 67.39913907000005],
              [-174.91491959899992, 67.38099552700004],
              [-174.8801394429999, 67.38582297700003],
              [-174.84711666599992, 67.38556549700007],
              [-174.8061090209999, 67.36467088600006],
              [-174.7770987279999, 67.32843719800007],
              [-174.7564355799999, 67.30323678100007],
              [-174.79771887899992, 67.29804108300004],
              [-174.8176328589999, 67.29524986300004],
              [-174.84206871299992, 67.28968370300004],
              [-174.8378900539999, 67.28181022000007],
              [-174.86025459899992, 67.27545843700005],
              [-174.8601003439999, 67.26363598100005],
              [-174.85595028999992, 67.25812865000006],
              [-174.8538402469999, 67.25261696000007],
              [-174.87614934599992, 67.24468886500006],
              [-174.8637989689999, 67.23525978200007],
              [-174.88001415399992, 67.22970816700007],
              [-174.8819280129999, 67.22103626000006],
              [-174.88993201399992, 67.21156313600005],
              [-174.8774956599999, 67.19504446300004],
              [-174.88542539999992, 67.18084519000007],
              [-174.8850645429999, 67.15563452900005],
              [-174.8868211129999, 67.13672166400005],
              [-174.8906465999999, 67.12095512200005],
              [-174.90458227899992, 67.10437807300008],
              [-174.9124270579999, 67.08781287600004],
              [-174.90403318799991, 67.06813023300003],
              [-174.8977546259999, 67.05395728900004],
              [-174.90760809399993, 67.03738496100004],
              [-174.8872397559999, 67.02560772700008],
              [-174.86080989299992, 67.01225544100004],
              [-174.8707259349999, 66.99962328700008],
              [-174.8522894589999, 66.97836398900006],
              [-174.8098240569999, 66.96660326700004],
              [-174.7903946609999, 66.93968333500004],
              [-174.7000211509999, 66.91652040700006],
              [-174.7260909419999, 66.91308603900006],
              [-174.75863715999992, 66.90877783900004],
              [-174.76285577299993, 66.89940429200004],
              [-174.75402843199993, 66.88835083200007],
              [-174.73435378899993, 66.87646374300004],
              [-174.72986516299991, 66.86285053700004],
              [-174.7231346819999, 66.84243184700006],
              [-174.70779521199992, 66.82202716300003],
              [-174.7075834519999, 66.79904479500004],
              [-174.69876863899992, 66.77947883600007],
              [-174.68603495199991, 66.76227928100008],
              [-174.68782013799992, 66.73241687900008],
              [-174.7071025909999, 66.71791400800004],
              [-174.7117516049999, 66.74604338000006],
              [-174.76369773099992, 66.75365557200007],
              [-174.7743929799999, 66.74596834200008],
              [-174.79804126099992, 66.73995695800005],
              [-174.8130029909999, 66.73140004600003],
              [-174.8215063149999, 66.72371103800003],
              [-174.8342157959999, 66.70835089400003],
              [-174.85561293299992, 66.69893119800008],
              [-174.8900800049999, 66.69630317200006],
              [-174.90714160399992, 66.68518974400007],
              [-174.9420059889999, 66.68671295800004],
              [-174.9741104809999, 66.68211497600004],
              [-174.97133461099992, 66.66541324800005],
              [-174.9258489659999, 66.65275323100008],
              [-174.90198557899993, 66.64343817400004],
              [-174.8736641959999, 66.62815513700008],
              [-174.86058949699992, 66.62220766600007],
              [-174.8602801719999, 66.60941956400006],
              [-174.8064438069999, 66.59251683700006],
              [-174.6993024919999, 66.60035328800006],
              [-174.6069368679999, 66.57491019400004],
              [-174.52760305899992, 66.54600843700007],
              [-174.46771444799992, 66.54005900700008],
              [-174.4356631629999, 66.53154498900005],
              [-174.42930295999992, 66.50261413500004],
              [-174.39524152099992, 66.47452336100008],
              [-174.41656654899992, 66.47538324200008],
              [-174.4613142259999, 66.45923143400006],
              [-174.4613476529999, 66.44646623800008],
              [-174.4592735999999, 66.41923046100004],
              [-174.46567888599992, 66.40135683800008],
              [-174.4560440749999, 66.37140534100007],
              [-174.4345190089999, 66.35635000200006],
              [-174.3914332139999, 66.35538382700008],
              [-174.3893764579999, 66.33751094000007],
              [-174.41476446399992, 66.34775098200004],
              [-174.4380787279999, 66.34351564100007],
              [-174.45712274899992, 66.32398071400007],
              [-174.43810489799992, 66.31119989200005],
              [-174.46349997599992, 66.27974813800006],
              [-174.4128671329999, 66.27114853600006],
              [-174.35367570399993, 66.27701985200008],
              [-174.30482728299992, 66.30252528800008],
              [-174.2961777829999, 66.32635429700008],
              [-174.29605750599993, 66.34252755600005],
              [-174.3681907989999, 66.33748571700005],
              [-174.29596437599992, 66.35444836800008],
              [-174.27247771199993, 66.37144852800003],
              [-174.23621835999992, 66.38842011100007],
              [-174.16597401599992, 66.39937549400008],
              [-174.16364444899992, 66.41554283300007],
              [-174.1528169949999, 66.43082973700007],
              [-174.1632513099999, 66.44701260900007],
              [-174.2228895449999, 66.44456538000009],
              [-174.2249405499999, 66.45222557200003],
              [-174.2055564249999, 66.47260996400007],
              [-174.16523422799992, 66.45892259300007],
              [-174.13329599899993, 66.45800820400007],
              [-174.0799082529999, 66.46724209900003],
              [-174.01590711799992, 66.47217131500008],
              [-173.97131347899992, 66.46352324100008],
              [-173.95251013299992, 66.44559444700008],
              [-173.9721017669999, 66.42524929400008],
              [-173.9788707099999, 66.40570543300004],
              [-173.96421556099992, 66.39373512200007],
              [-173.95166208499992, 66.38347126000008],
              [-173.9328914419999, 66.36637275300006],
              [-173.93316034499992, 66.35360342200005],
              [-173.92918743099992, 66.34081798100004],
              [-173.95256778599992, 66.33834554400005],
              [-173.97607650799992, 66.32905886400005],
              [-174.0038262639999, 66.31893552800005],
              [-174.01890673999992, 66.30536535400006],
              [-174.02984651499992, 66.28494979300007],
              [-174.02166482299992, 66.26873526300005],
              [-174.0325199259999, 66.25258222100007],
              [-174.0306869759999, 66.23638934400003],
              [-174.0161882859999, 66.22015586400005],
              [-173.9993126649999, 66.21924953300004],
              [-173.9716825609999, 66.22853035700007],
              [-173.95652202399992, 66.24722273400005],
              [-173.9287036279999, 66.26330938800004],
              [-173.8838641849999, 66.28274816200008],
              [-173.81592920699993, 66.29444716000006],
              [-173.79653885599993, 66.30799286200005],
              [-173.8470466569999, 66.31838359700004],
              [-173.8872877359999, 66.31766776600006],
              [-173.8953599019999, 66.33644210100005],
              [-173.85910342199992, 66.34481086100004],
              [-173.82098078299992, 66.34381905200007],
              [-173.77222143799992, 66.34533370500003],
              [-173.7388528939999, 66.35346203800003],
              [-173.70525593699992, 66.37052394700004],
              [-173.7189498529999, 66.39851951100007],
              [-173.71393400199992, 66.41121268300003],
              [-173.6930265629999, 66.42449088300003],
              [-173.69112981599991, 66.43909886800003],
              [-173.71328170099991, 66.44361874500004],
              [-173.72891480099992, 66.45701271000007],
              [-173.81140337699992, 66.47059658400008],
              [-173.80792809099992, 66.48838502600006],
              [-173.83314134399993, 66.50625119600005],
              [-173.87607256299992, 66.51525136400005],
              [-173.9143274049999, 66.51787573200005],
              [-173.94942055099992, 66.51857576300006],
              [-173.9780386219999, 66.52942968800005],
              [-174.0275332729999, 66.52822865300004],
              [-174.06104876499992, 66.52953817800005],
              [-174.1009298259999, 66.53720471000008],
              [-174.1264524769999, 66.54612499700005],
              [-174.1584406609999, 66.53279017900007],
              [-174.2143592879999, 66.56142552200004],
              [-174.2639499779999, 66.56587565500007],
              [-174.1967620039999, 66.58940798600008],
              [-174.0813863539999, 66.61415007300008],
              [-174.0268042799999, 66.62679684500006],
              [-173.96964417599992, 66.64816866800004],
              [-173.93055139799992, 66.66762694600004],
              [-173.92369562099992, 66.68678088600007],
              [-173.93404325499992, 66.70554346600005],
              [-173.93577911199992, 66.72512776400004],
              [-173.9354560589999, 66.74044836800005],
              [-173.9287581799999, 66.75149039300004],
              [-173.93490662399992, 66.76597505200004],
              [-173.9345919939999, 66.78043832000003],
              [-173.9473033399999, 66.79154174700005],
              [-173.94474764499992, 66.81025048600009],
              [-173.9573254389999, 66.82815741400003],
              [-173.96559322599992, 66.84605082300004],
              [-173.98033795499992, 66.86566701200007],
              [-174.00596391699992, 66.88446278400005],
              [-174.0229994489999, 66.90067897400007],
              [-174.0184208119999, 66.91343035300008],
              [-174.0159433569999, 66.92959230800005],
              [-174.01777583799992, 66.94746965100006],
              [-174.0262143619999, 66.96111089800007],
              [-174.06075396799991, 66.97567211700004],
              [-174.1086025269999, 66.97663974200003],
              [-174.1607612079999, 66.98100239200005],
              [-174.19124365699992, 66.97935594300003],
              [-174.2391915929999, 66.97178522600007],
              [-174.25003073899993, 66.97606007200005],
              [-174.20415624499992, 66.99214217300005],
              [-174.1843583209999, 67.00911759500008],
              [-174.19069055999992, 67.02702024200005],
              [-174.2342171869999, 67.03474622200008],
              [-174.28212658899992, 67.04676114200004],
              [-174.40879584899992, 67.02731910900008],
              [-174.4742347449999, 67.01882714700008],
              [-174.49605294999992, 67.02138688200006],
              [-174.3563086119999, 67.06135792100008],
              [-174.3978214809999, 67.06224936700005],
              [-174.5572114439999, 67.03501562800005],
              [-174.61620982099993, 67.04095538300004],
              [-174.61200038899992, 67.06141402900005],
              [-174.5749309839999, 67.07677291800007],
              [-174.1966357149999, 67.08071685700008],
              [-173.9058737009999, 67.08085336100004],
              [-173.7508386549999, 67.07343162900008],
              [-173.6540457449999, 67.08835062300005],
              [-173.6464688849999, 67.11561485300007],
              [-173.6073766979999, 67.10603986700005],
              [-173.5470781699999, 67.09067684000007],
              [-173.47935475699992, 67.07912609500005],
              [-173.4465938349999, 67.07460627600005],
              [-173.4555565109999, 67.06954738700006],
              [-173.48191264099992, 67.06887992200006],
              [-173.4952850599999, 67.06299543500006],
              [-173.4937402159999, 67.04420250300007],
              [-173.46358158799993, 67.02948733000005],
              [-173.43058568599992, 67.03352311000003],
              [-173.4278819969999, 67.04715640000006],
              [-173.43168436899992, 67.06254986100004],
              [-173.4114615249999, 67.07520815300006],
              [-173.3893955899999, 67.07845929400008],
              [-173.2868057979999, 67.06742419300008],
              [-173.14301869699992, 67.05256301900005],
              [-173.07125959799993, 67.04423252400005],
              [-173.08030977299993, 67.03833588300006],
              [-173.1000969099999, 67.03595383700008],
              [-173.15048373599993, 67.03384663300005],
              [-173.2071058239999, 67.03946612200008],
              [-173.2372323849999, 67.04995160500005],
              [-173.24586409999992, 67.05258342600007],
              [-173.27215908099993, 67.05195053300008],
              [-173.2746189709999, 67.04599053900006],
              [-173.2640270809999, 67.03822706100004],
              [-173.2621970939999, 67.03052576900006],
              [-173.25788326699993, 67.02187734600005],
              [-173.22786683899992, 67.01660869700004],
              [-173.19514134699992, 67.01461666400007],
              [-173.1452686529999, 67.00563474900008],
              [-173.14337041599993, 66.99964548900005],
              [-173.1462063269999, 66.98602411100006],
              [-173.17037455699992, 66.98282946700004],
              [-173.20070467199992, 66.98821399000008],
              [-173.2378348759999, 66.98853318300007],
              [-173.2684225099999, 66.98878958200004],
              [-173.2949550529999, 66.98132764100006],
              [-173.30432573399992, 66.96691053000006],
              [-173.30947076099991, 66.95076876700006],
              [-173.29927254299992, 66.93621084800003],
              [-173.2908523979999, 66.93018410800005],
              [-173.297871, 66.92001679700007],
              [-173.30907156799992, 66.91328756000007],
              [-173.3073415099999, 66.90390520400007],
              [-173.2904825949999, 66.89270512100006],
              [-173.2672925519999, 66.87804859200008],
              [-173.2958485149999, 66.87145298400009],
              [-173.32017067299992, 66.86226538100004],
              [-173.31883914999992, 66.84436933500007],
              [-173.3194375369999, 66.83159802900008],
              [-173.30254162499992, 66.82210510500005],
              [-173.2415421709999, 66.82845430400005],
              [-173.1831844419999, 66.82543376100006],
              [-173.14204683999992, 66.82424096400007],
              [-173.1022827449999, 66.83752123800008],
              [-173.08657591099993, 66.84674686800008],
              [-173.09924023199991, 66.85281669700004],
              [-173.12497286399991, 66.85814781700003],
              [-173.1615367009999, 66.86441903900004],
              [-173.17637086699992, 66.87135477800007],
              [-173.17567755599993, 66.88411905900006],
              [-173.1729477089999, 66.89431147400006],
              [-173.1747056849999, 66.90198788100008],
              [-173.2138225569999, 66.90316790500003],
              [-173.22647860299992, 66.91093506300007],
              [-173.20647955799993, 66.91843126000003],
              [-173.1609065039999, 66.91548892400004],
              [-173.1533433349999, 66.93414812800006],
              [-173.16116455699992, 66.95038770700006],
              [-173.1627354149999, 66.96146547700005],
              [-173.1535440039999, 66.96989421400008],
              [-173.12072795499992, 66.97302236300004],
              [-173.0832231169999, 66.98292904900006],
              [-173.07396264699992, 66.99307322900006],
              [-173.06322712099993, 66.99042516500003],
              [-173.0683317539999, 66.97683839900003],
              [-173.0775460669999, 66.96754857800005],
              [-173.06537012799993, 66.95211504800005],
              [-173.0511850869999, 66.93410909900007],
              [-172.9957218469999, 66.91743223300006],
              [-172.88584957999993, 66.90359368800006],
              [-172.7823289709999, 66.89400418600007],
              [-172.6658300899999, 66.88504259400008],
              [-172.61549480099993, 66.89126831500005],
              [-172.60559837199992, 66.90732777400007],
              [-172.6153431459999, 66.92191705300007],
              [-172.5698515969999, 66.92052630400008],
              [-172.5512652019999, 66.90838146300007],
              [-172.50384436599992, 66.90439096900008],
              [-172.41168553499992, 66.91681819800004],
              [-172.36248657099992, 66.93321336000008],
              [-172.49784803799992, 66.97841619400003],
              [-172.65746008999992, 66.99144114800004],
              [-172.8485116489999, 67.00967974500008],
              [-172.92847648199992, 67.02157012000004],
              [-172.95703850899991, 67.01844539300004],
              [-172.9945890699999, 67.01027007100004],
              [-173.0248791889999, 67.01394916100008],
              [-173.03523508299992, 67.02341461900005],
              [-173.02584933199992, 67.03527228700005],
              [-172.98634417699992, 67.03917524300005],
              [-172.78810445899992, 67.03204967300007],
              [-172.7363006839999, 67.02381313200004],
              [-172.64109302999992, 67.01336202800007],
              [-172.4078831479999, 66.98664801900009],
              [-172.19470296499992, 66.96073422800004],
              [-172.05637464199992, 66.95021111000005],
              [-171.98138236699992, 66.95930203500006],
              [-171.92840968099992, 66.96613384900007],
              [-171.94287795399993, 66.97319273300008],
              [-171.93354215199992, 66.97901301200005],
              [-171.8951942509999, 66.97072856100004],
              [-171.8896853219999, 66.96126004600006],
              [-171.82106272099992, 66.95077416600003],
              [-171.7859424149999, 66.95275628500008],
              [-171.71851680999993, 66.95077749600006],
              [-171.64021530699992, 66.92981461300008],
              [-171.6296686759999, 66.90830623100004],
              [-171.6681411149999, 66.89702942500008],
              [-171.69416894399993, 66.87957169800006],
              [-171.6711881159999, 66.85047324700008],
              [-171.63003331099992, 66.83005821200004],
              [-171.56253392999992, 66.80889981400009],
              [-171.4262695299999, 66.77485204900006],
              [-171.39129083799992, 66.77937648200003],
              [-171.35340067299992, 66.77185259800007],
              [-171.33090093599992, 66.74498193500006],
              [-171.37495186299992, 66.73544908700006],
              [-171.3880787509999, 66.71518316100008],
              [-171.3633593289999, 66.67482907200008],
              [-171.2731302619999, 66.64064262800008],
              [-171.07823645699992, 66.56720612200007],
              [-170.98421668999993, 66.54162656500006],
              [-170.90872503999992, 66.51607098800008],
              [-170.87592525899993, 66.51536692900004],
              [-170.8597305979999, 66.51105377800008],
              [-170.82868404899992, 66.49184804900005],
              [-170.79389400899993, 66.48314036700003],
              [-170.75987708199992, 66.46442291900007],
              [-170.74213619699992, 66.46015045800004],
              [-170.7283829419999, 66.45477936400005],
              [-170.7054337229999, 66.43138255400004],
              [-170.66576087099992, 66.41803620000007],
              [-170.63243567599991, 66.39931875200006],
              [-170.5807999339999, 66.36082591400003],
              [-170.56525631399992, 66.35358307500007],
              [-170.49482174399992, 66.34406159100007],
              [-170.3851928839999, 66.31653175600007],
              [-170.40322472399993, 66.30706744900004],
              [-170.43273199799992, 66.30286687100005],
              [-170.4835119519999, 66.29424272700004],
              [-170.51403204699992, 66.28343582600007],
              [-170.5202222769999, 66.27035273500007],
              [-170.52257649799992, 66.25551780800004],
              [-170.53823185399992, 66.23440452200003],
              [-170.59114237799992, 66.23735904500006],
              [-170.6530655589999, 66.24848053600005],
              [-170.62568111899992, 66.23480866100005],
              [-170.5952805649999, 66.22444112000005],
              [-170.51093647399992, 66.22543399500006],
              [-170.4876104139999, 66.24303782500004],
              [-170.4604220829999, 66.25888752300006],
              [-170.4293684689999, 66.27298048100005],
              [-170.3903529209999, 66.28520683700003],
              [-170.3521160349999, 66.29247933700003],
              [-170.3149598919999, 66.29314880100009],
              [-170.27425708799993, 66.29040386700007],
              [-170.21505062499992, 66.27555494900008],
              [-170.18399564499992, 66.26476951100005],
              [-170.15385774599991, 66.24902390700004],
              [-170.1418647179999, 66.22383824000008],
              [-170.10620437999992, 66.19304745300008],
              [-170.1289772529999, 66.18043096000008],
              [-170.1622307959999, 66.17803508600008],
              [-170.2038325259999, 66.17423011100004],
              [-170.2347305979999, 66.18577708500004],
              [-170.26030861299992, 66.17909999400007],
              [-170.2888359639999, 66.17987956700006],
              [-170.33836829299992, 66.18577708500004],
              [-170.22358150899993, 66.14813873900005],
              [-170.1362673579999, 66.13924380800006],
              [-170.1141361139999, 66.14855759400007],
              [-170.0858318699999, 66.16928963400005],
              [-170.0447067339999, 66.16978729000004],
              [-169.97492428299992, 66.14569733300004],
              [-169.94737708199992, 66.14484284100007],
              [-169.92267818899992, 66.15029531500005],
              [-169.91645260299993, 66.16404857000003],
              [-169.93256588399993, 66.17153554900005],
              [-169.9710587229999, 66.18016185100004],
              [-170.01451575399992, 66.18891022300005],
              [-170.0435684889999, 66.19330475500004],
              [-169.99091549399992, 66.19013092700004],
              [-169.95209713399993, 66.18378327000005],
              [-169.90672766799992, 66.16962311400005],
              [-169.81159420499992, 66.15717194200005],
              [-169.71849524599992, 66.13279857000003],
              [-169.70746822799993, 66.13117096600007],
              [-169.70091712099992, 66.12864817900004],
              [-169.6998184889999, 66.12262604400007],
              [-169.69989986899992, 66.11497630400004],
              [-169.68016676999991, 66.10101249000007],
              [-169.65450108399992, 66.08530484300007],
              [-169.6413841899999, 66.06832743700005],
              [-169.65611606899992, 66.05553525400006],
              [-169.6798949029999, 66.03805624600005],
              [-169.69520857199993, 66.02197050100006],
              [-169.7186102839999, 66.00613326900003],
              [-169.77571975599992, 66.00623925800005],
              [-169.82500733299992, 66.00443151000007],
              [-169.8666213399999, 66.02224428000005],
              [-169.89144713699991, 66.04285290500007],
              [-169.98151607999992, 66.03900788000004],
              [-170.05447121999993, 66.02115182400007],
              [-170.14303148699992, 66.00382917400003],
              [-170.2365645749999, 65.95517185800009],
              [-170.34112398899993, 65.93653924000006],
              [-170.3752978199999, 65.92589097200005],
              [-170.42690521799992, 65.90743018900008],
              [-170.50974791399992, 65.86994319300004],
              [-170.60631262899992, 65.86131419500003],
              [-170.62580318899992, 65.85065338700008],
              [-170.60167395699992, 65.84731679900005],
              [-170.5657852859999, 65.85321686400005],
              [-170.53241939999992, 65.85272858300004],
              [-170.51593990799992, 65.83014557500007],
              [-170.52277584499993, 65.81683991100005],
              [-170.57115637899992, 65.76121653900003],
              [-170.5369766919999, 65.73175690300008],
              [-170.53022213399993, 65.72028229400007],
              [-170.5408829419999, 65.70473867400005],
              [-170.5432022779999, 65.69985586100006],
              [-170.54096432199992, 65.69537995000007],
              [-170.53547115799992, 65.69106679900005],
              [-170.53050696499992, 65.68598053600005],
              [-170.53022213399993, 65.67934804900005],
              [-170.48877325299992, 65.67075769100006],
              [-170.52023220299992, 65.64217302200007],
              [-170.53527673699992, 65.61814693500008],
              [-170.5881657239999, 65.60456584500008],
              [-170.6673561279999, 65.59954598500008],
              [-170.87543697799993, 65.62335846600007],
              [-170.8925675119999, 65.62946198100008],
              [-170.89948482999992, 65.64826080900008],
              [-171.05170650899993, 65.68573639500005],
              [-171.14731026099992, 65.69499983000009],
              [-171.16898094099992, 65.71367721500008],
              [-171.20837718399991, 65.75094263400007],
              [-171.26608366399992, 65.77201435200004],
              [-171.38512023899992, 65.81757016700004],
              [-171.46326546999993, 65.83258962800005],
              [-171.46082373399992, 65.81933757300004],
              [-171.43567077699993, 65.79565252900005],
              [-171.4181120979999, 65.77543001800007],
              [-171.40029690699993, 65.75687802500005],
              [-171.38914954299992, 65.74607982000003],
              [-171.3178604809999, 65.73395416900007],
              [-171.33014889199993, 65.72894928600005],
              [-171.34357662699992, 65.72724030200004],
              [-171.3718155589999, 65.72772858300004],
              [-171.3603002589999, 65.70966217700004],
              [-171.34333248599992, 65.70001862200007],
              [-171.30353756399992, 65.68618398600006],
              [-171.26386471299992, 65.65558502800008],
              [-171.24555416599992, 65.65135325700004],
              [-171.16681881399992, 65.64744700700004],
              [-171.14594479099992, 65.64179108300004],
              [-171.08283849999992, 65.63412664400005],
              [-171.04496814799992, 65.62220487700006],
              [-171.03266354099992, 65.59853750200006],
              [-171.02363033799992, 65.58315664300005],
              [-170.98181232699991, 65.59205382800008],
              [-170.97076007799993, 65.55146178700005],
              [-170.9753256219999, 65.51114361400005],
              [-171.00896779899992, 65.48909622000008],
              [-171.0386539159999, 65.46698723200006],
              [-171.15998287699992, 65.47939687700006],
              [-171.1911471749999, 65.49686882300006],
              [-171.25089279199992, 65.52199102500003],
              [-171.40295199699992, 65.52092742100007],
              [-171.55566310999993, 65.51008013100005],
              [-171.9037423569999, 65.46077102500004],
              [-172.03420330199992, 65.47443813600006],
              [-171.8083971739999, 65.48932711600008],
              [-171.74361916599992, 65.49966127400006],
              [-171.7777022349999, 65.51216961800003],
              [-171.8611395199999, 65.51845009500005],
              [-171.95762051399993, 65.51654791200008],
              [-171.99060674199993, 65.53772388100003],
              [-172.02548587299992, 65.54820613600003],
              [-172.06464596299992, 65.55756256700005],
              [-172.07197018099993, 65.56264883000006],
              [-172.09333248599992, 65.56801992400005],
              [-172.11340763099992, 65.54632115900006],
              [-172.1461707699999, 65.53693198100007],
              [-172.17093371899992, 65.52741088500005],
              [-172.1979242689999, 65.53773118600003],
              [-172.26008053299992, 65.54523346600007],
              [-172.2640261679999, 65.55687991500008],
              [-172.23511199499993, 65.56800365600003],
              [-172.2060288039999, 65.58076598200006],
              [-172.2286344919999, 65.59595892600004],
              [-172.2673800549999, 65.60973780500007],
              [-172.32235176799992, 65.62211315500008],
              [-172.29721143799992, 65.63493641200006],
              [-172.2720514279999, 65.64775043800006],
              [-172.2904819789999, 65.66617407000007],
              [-172.3396755109999, 65.65371640900008],
              [-172.3519180979999, 65.67251211100006],
              [-172.3651016919999, 65.67584870000007],
              [-172.4015617819999, 65.68101703100007],
              [-172.4297346989999, 65.67976195500006],
              [-172.4666641919999, 65.68650950700004],
              [-172.6838272779999, 65.70425039300005],
              [-172.75556393099993, 65.68984609600005],
              [-172.79072018099993, 65.68768952000005],
              [-172.82551021999993, 65.69110748900005],
              [-172.8596085279999, 65.69985586100006],
              [-172.8245743479999, 65.67153554900005],
              [-172.76923580599993, 65.66486237200007],
              [-172.66100012899992, 65.67251211100006],
              [-172.66962643099993, 65.66307200700004],
              [-172.68378658799992, 65.65322500200006],
              [-172.67441767699992, 65.62351809300009],
              [-172.6427905379999, 65.61817797700007],
              [-172.5792020659999, 65.61242450700007],
              [-172.48370358199992, 65.60622178300008],
              [-172.3897221039999, 65.58181650700004],
              [-172.37923567599992, 65.56350791300008],
              [-172.38881947399992, 65.54382837900005],
              [-172.3981173539999, 65.52745335800006],
              [-172.34760494699992, 65.50161367400005],
              [-172.3251846999999, 65.48749420800004],
              [-172.31968738199993, 65.46525450600006],
              [-172.38476972599992, 65.47927506500008],
              [-172.41622407999992, 65.47618219700007],
              [-172.42802695199993, 65.47045908600006],
              [-172.4257597179999, 65.46336434100004],
              [-172.3979198669999, 65.45709013200008],
              [-172.3904799869999, 65.44403541500003],
              [-172.38860854499993, 65.43223648800006],
              [-172.3553466029999, 65.42352074400009],
              [-172.2641044659999, 65.41821282600006],
              [-172.1692456719999, 65.44476786900003],
              [-172.1213764899999, 65.48397874300008],
              [-172.0934031179999, 65.48357052100005],
              [-172.1624865059999, 65.42069229300006],
              [-172.18976158299992, 65.35178478100005],
              [-172.20294967899991, 65.32453682600004],
              [-172.18521136099992, 65.29867673100006],
              [-172.17955393199992, 65.26484725600005],
              [-172.1885387799999, 65.24244984100005],
              [-172.21557172899992, 65.23948609600006],
              [-172.2495011059999, 65.23362864800004],
              [-172.27692623599992, 65.25470612200007],
              [-172.30793209499993, 65.26732005400004],
              [-172.34150143099993, 65.27358633000006],
              [-172.37677975199992, 65.27521393400008],
              [-172.4002579419999, 65.27301666900007],
              [-172.4460343089999, 65.26325104400007],
              [-172.51146399599992, 65.26056549700007],
              [-172.5312393869999, 65.25763580900008],
              [-172.55085201699993, 65.25071849200003],
              [-172.57746334499993, 65.24770742400005],
              [-172.63630123599992, 65.26911041900007],
              [-172.66816158799992, 65.27521393400008],
              [-172.6815079419999, 65.27350495000007],
              [-172.69220943899992, 65.26837799700007],
              [-172.69941158799992, 65.25975169500003],
              [-172.70197506399992, 65.24762604400007],
              [-172.69652258999992, 65.23602936400005],
              [-172.68329830599993, 65.23041413000004],
              [-172.6673477859999, 65.22821686400005],
              [-172.55064299799992, 65.20602686700005],
              [-172.4570206369999, 65.21938711100006],
              [-172.36547073499992, 65.20841635900007],
              [-172.3109024729999, 65.21995677300004],
              [-172.28071041599992, 65.21063873900005],
              [-172.2015312899999, 65.21687429900004],
              [-172.16551785399992, 65.17797398700003],
              [-172.17086372999992, 65.15232895700007],
              [-172.2037247389999, 65.13222890800006],
              [-172.22704016799992, 65.13222890800006],
              [-172.25629635299993, 65.13743724200003],
              [-172.25373287699992, 65.13515859600005],
              [-172.2431534499999, 65.12319570500006],
              [-172.22675533799992, 65.09975820500006],
              [-172.21532141799992, 65.09027741100005],
              [-172.1951798169999, 65.08372630400004],
              [-172.18248450399992, 65.08930084800005],
              [-172.1708471339999, 65.09878164300005],
              [-172.15392005099991, 65.10394928600005],
              [-172.0866144059999, 65.09363786300008],
              [-172.08009296199992, 65.07590477000008],
              [-172.0930914459999, 65.05035869200003],
              [-172.1749604409999, 65.01750784000006],
              [-172.21863108699992, 64.98424716700004],
              [-172.32300410699992, 64.94834493600007],
              [-172.4721163049999, 64.92078427600006],
              [-172.4963272779999, 64.91738515800006],
              [-172.53632564999992, 64.92633698100008],
              [-172.5579727859999, 64.92519765800006],
              [-172.60676021999993, 64.90322500200006],
              [-172.62629146999993, 64.89850495000007],
              [-172.6588252219999, 64.89014449300004],
              [-172.70090423699992, 64.87759791400003],
              [-172.7204128529999, 64.86167537200004],
              [-172.76284560699992, 64.83786813500006],
              [-172.80778055599993, 64.84779051600003],
              [-172.9016098029999, 64.85803853800007],
              [-173.0001332919999, 64.85526782700003],
              [-173.05721064199992, 64.83788292700007],
              [-173.06166054399992, 64.81062191000007],
              [-173.0811666699999, 64.78183365100006],
              [-173.16411638999992, 64.76460266000004],
              [-173.16047059899992, 64.75977203400004],
              [-173.05892267399992, 64.76888659000008],
              [-173.0056137709999, 64.79588307800003],
              [-172.97476539599992, 64.81345359300008],
              [-172.9216594399999, 64.82123425000003],
              [-172.86644446499992, 64.81590403900003],
              [-172.80573482999992, 64.80337148600006],
              [-172.78010006399992, 64.79254791900007],
              [-172.75046719699992, 64.76236555200006],
              [-172.75530909399993, 64.73346798300008],
              [-172.81191479299991, 64.72585181400007],
              [-172.83128599499992, 64.70987818300006],
              [-172.85796864399993, 64.69877816500008],
              [-172.8919115649999, 64.69415829400003],
              [-172.94840877299993, 64.68805122400005],
              [-173.0087385349999, 64.67555218100006],
              [-173.0428716079999, 64.65968467800008],
              [-173.0394822819999, 64.64680873300006],
              [-172.9756516409999, 64.65445562000008],
              [-172.8928482489999, 64.66522957000006],
              [-172.8629058109999, 64.66343986600003],
              [-172.8446332039999, 64.64886999800007],
              [-172.87156575199992, 64.62812338600008],
              [-172.91008267499993, 64.59458320300007],
              [-172.96685838899992, 64.57239732500005],
              [-172.9671928429999, 64.56113681800008],
              [-172.8998242609999, 64.56396847200006],
              [-172.8656958649999, 64.57825742300008],
              [-172.8464555029999, 64.59422793800007],
              [-172.8159056289999, 64.61173484800008],
              [-172.7824320089999, 64.60509965200004],
              [-172.74767005099991, 64.60244375200006],
              [-172.72248287699992, 64.59686920800004],
              [-172.6708471339999, 64.59389883000006],
              [-172.65355383999992, 64.59003327000005],
              [-172.62214107999992, 64.57754140800006],
              [-172.4650772779999, 64.55841705900008],
              [-172.4556778639999, 64.54832591400003],
              [-172.45112057199992, 64.53335195500006],
              [-172.4412735669999, 64.51496002800008],
              [-172.41063391799992, 64.48916250200006],
              [-172.2202440599999, 64.40733818600006],
              [-172.32427258099992, 64.40996155500005],
              [-172.3876578949999, 64.40736443800006],
              [-172.44009455499992, 64.39980399200005],
              [-172.48528207799993, 64.38728201500004],
              [-172.5452264799999, 64.37650450900009],
              [-172.59007258199992, 64.37042419200003],
              [-172.64020748599992, 64.39077383000006],
              [-172.65404212099992, 64.39301178600005],
              [-172.68146725199992, 64.40277741100005],
              [-172.71153944399992, 64.40034959100007],
              [-172.7145651069999, 64.41816172800009],
              [-172.7135992949999, 64.44390385500003],
              [-172.73570972099992, 64.45045864800005],
              [-172.7685440749999, 64.45848216400003],
              [-172.76341712099992, 64.46930573100008],
              [-172.76972408799992, 64.48094310100004],
              [-172.7846573559999, 64.48908112200007],
              [-172.8018692699999, 64.49603913000004],
              [-172.81525631399992, 64.50405508000006],
              [-172.8422026359999, 64.49769803300006],
              [-172.88334560599992, 64.49471075100007],
              [-172.9321876379999, 64.48370596000007],
              [-173.0130509109999, 64.46157461100006],
              [-172.9782297779999, 64.43888648500007],
              [-172.91459388899992, 64.44980733700004],
              [-172.83620521199992, 64.45420716300004],
              [-172.78832359799992, 64.43786076300006],
              [-172.78906374399992, 64.41692831100005],
              [-172.8157972059999, 64.39770916300006],
              [-172.8170167749999, 64.36226240900004],
              [-172.81779474099991, 64.33969219000005],
              [-172.8221713789999, 64.32036164200008],
              [-172.84867654899992, 64.30438618300008],
              [-172.87473544999992, 64.30130812600004],
              [-172.88580450799992, 64.30298502200009],
              [-172.91805308899993, 64.33866376600008],
              [-172.95145533299993, 64.33884318500003],
              [-172.9522955919999, 64.31141060300007],
              [-172.9307012209999, 64.29030859400007],
              [-172.9241038639999, 64.26442928800003],
              [-173.00943787199992, 64.25999012400007],
              [-173.10626457599992, 64.24098028000003],
              [-173.22223873599992, 64.26959870000007],
              [-173.27057857999992, 64.28839752800008],
              [-173.36825284199992, 64.28547821500007],
              [-173.37903722899992, 64.31442511900008],
              [-173.36381003199992, 64.34174738800004],
              [-173.36337612699992, 64.36595284700007],
              [-173.30707775699992, 64.39006035700004],
              [-173.27448482999992, 64.43109772300005],
              [-173.2636612619999, 64.44599030200004],
              [-173.2757462229999, 64.45123932500007],
              [-173.3002823559999, 64.45083242400005],
              [-173.31212317599991, 64.45221588700008],
              [-173.30431067599991, 64.46849192900004],
              [-173.30341549399992, 64.48493073100008],
              [-173.29987545499992, 64.50218333500004],
              [-173.2841690749999, 64.52114492400005],
              [-173.29999752499992, 64.53827545800004],
              [-173.3091934889999, 64.54547760600008],
              [-173.31891842399992, 64.54840729400007],
              [-173.3349096339999, 64.55109284100007],
              [-173.34015865799992, 64.55776601800005],
              [-173.34154212099992, 64.56659577000005],
              [-173.3521622389999, 64.58494700700004],
              [-173.3541153639999, 64.59149811400005],
              [-173.35985266799992, 64.59552643400008],
              [-173.3885391919999, 64.59882233300004],
              [-173.39806067599991, 64.60394928600005],
              [-173.41454016799992, 64.61664459800005],
              [-173.4169815749999, 64.59634023600006],
              [-173.3963516919999, 64.56476471600007],
              [-173.36945553299992, 64.53367747600004],
              [-173.35309811099992, 64.50747304900005],
              [-173.35676021999993, 64.48021067900004],
              [-173.3769425119999, 64.46035390800006],
              [-173.36599356999992, 64.42247487300006],
              [-173.3851778149999, 64.39504074400008],
              [-173.4563959429999, 64.36448377700003],
              [-173.50507923299992, 64.34353097200005],
              [-173.59824510299993, 64.33062777500004],
              [-173.63543374999992, 64.33223063900004],
              [-173.68407141799992, 64.34886302300004],
              [-173.8334854809999, 64.38080475500004],
              [-173.86994381399992, 64.39447663000004],
              [-173.98932955299992, 64.41234776500005],
              [-174.0232206819999, 64.44284607300006],
              [-174.0270022249999, 64.47027819100003],
              [-174.03836820599992, 64.49603735000005],
              [-174.04229298099992, 64.52825823400008],
              [-174.07244961299992, 64.54910946800004],
              [-174.14582271999993, 64.56989166900007],
              [-174.17731686099992, 64.58466217700004],
              [-174.2416886059999, 64.59503815300008],
              [-174.28477942599991, 64.60797760600008],
              [-174.3245743479999, 64.62543366100005],
              [-174.3467911449999, 64.64398834800005],
              [-174.30097408799992, 64.65180084800005],
              [-174.28473873599992, 64.65143463700008],
              [-174.30589758999992, 64.66616445500006],
              [-174.34850012899992, 64.66962311400005],
              [-174.42841549399992, 64.66571686400005],
              [-174.46662350199992, 64.67047760600008],
              [-174.65229244699992, 64.72532786700003],
              [-174.6586705999999, 64.74070651000005],
              [-174.65187225499992, 64.75476036900005],
              [-174.6383132039999, 64.78442774400008],
              [-174.59197431599992, 64.81740485700004],
              [-174.6079330409999, 64.85775375800006],
              [-174.6532230809999, 64.89790099300006],
              [-174.68262550799992, 64.90081730700007],
              [-174.70351242799993, 64.87113266700004],
              [-174.69123937299992, 64.83543548900008],
              [-174.72308215299992, 64.80720989700006],
              [-174.79597387899992, 64.80358698800006],
              [-174.84701429499992, 64.80164988600006],
              [-174.89798275099992, 64.79813808000006],
              [-174.91400518999993, 64.83068821500007],
              [-174.91874824899992, 64.85554260600009],
              [-174.9519345619999, 64.86149669800005],
              [-174.96958502899992, 64.84734734100005],
              [-174.96860145999992, 64.82556586100009],
              [-174.96761288599993, 64.80378754900005],
              [-174.9776411359999, 64.78346752800007],
              [-174.98779897999992, 64.76625591500004],
              [-175.0567762599999, 64.75941447000008],
              [-175.16288728499993, 64.76620055600006],
              [-175.3020019159999, 64.77409276800006],
              [-175.36487879299992, 64.78739365900003],
              [-175.41145202899992, 64.77126366200008],
              [-175.4568409849999, 64.79721539300004],
              [-175.4136198319999, 64.80704966600007],
              [-175.35252561599992, 64.82645911800006],
              [-175.36835533099992, 64.84650781800008],
              [-175.4010492539999, 64.84144762600005],
              [-175.4371918969999, 64.83322988400005],
              [-175.4817938429999, 64.84358610600003],
              [-175.4829442729999, 64.86226047600007],
              [-175.4947982939999, 64.87613030000006],
              [-175.54023189999992, 64.87612539300005],
              [-175.54596920499992, 64.88422272300005],
              [-175.56171627499992, 64.89223867400005],
              [-175.5810367699999, 64.90462704900006],
              [-175.62279212099992, 64.91478099200003],
              [-175.63129635299993, 64.92059967700004],
              [-175.7004528999999, 64.93107211600005],
              [-175.7747927929999, 64.93936498300008],
              [-175.77252154299993, 64.95807276600004],
              [-175.7883309959999, 64.97185668100008],
              [-175.8506973949999, 64.99038320500006],
              [-175.8647354809999, 64.99921295800004],
              [-175.84696388199993, 65.01460272100007],
              [-175.7674611399999, 65.03750375900006],
              [-175.77320353399992, 65.06387502400008],
              [-175.81224524599992, 65.07599518400008],
              [-175.81049557199992, 65.08722565300008],
              [-175.7800462479999, 65.10423617100008],
              [-175.7406772809999, 65.12343527900003],
              [-175.73504126999993, 65.14684510600006],
              [-175.7481100759999, 65.17156649200007],
              [-175.79670162699992, 65.18292877800008],
              [-175.88155353899992, 65.25845450000008],
              [-175.8725573749999, 65.28504277200005],
              [-175.8625098439999, 65.29918862700004],
              [-175.88802541799993, 65.33620857800008],
              [-175.89139619199992, 65.37512336200007],
              [-175.9088393119999, 65.40295276000006],
              [-175.9573868479999, 65.42291901200008],
              [-175.97704016799992, 65.43496328300006],
              [-176.0440567699999, 65.45209381700005],
              [-176.08759081399992, 65.45601814100007],
              [-176.1827731729999, 65.46343680300004],
              [-176.34923255099991, 65.50018952000005],
              [-176.62627487999993, 65.54241380800005],
              [-176.9765518869999, 65.60805898600006],
              [-177.0707641879999, 65.59035527000003],
              [-177.1643920619999, 65.56803002000004],
              [-177.2459944149999, 65.53886308500006],
              [-177.30862848599992, 65.48903656700008],
              [-177.4159254729999, 65.44074849100008],
              [-177.7516920559999, 65.44161924900004],
              [-178.0202713559999, 65.44084127800005],
              [-178.2839866489999, 65.44434628200008],
              [-178.4611005609999, 65.47274127600008],
              [-178.5049433899999, 65.49464660800004],
              [-178.5287979809999, 65.51117584800005],
              [-178.53227950399992, 65.52298646600008],
              [-178.51960440099992, 65.53659040700006],
              [-178.51189115199992, 65.54402956300004],
              [-178.49388159999992, 65.56138467600005],
              [-178.5020218909999, 65.57810123900003],
              [-178.49398759399992, 65.60367767400004],
              [-178.45824674199991, 65.62024010800008],
              [-178.4612868399999, 65.64191901400005],
              [-178.4436865689999, 65.66287751000004],
              [-178.4110886039999, 65.68176542500004],
              [-178.4242348919999, 65.71287875000007],
              [-178.47191321499992, 65.74823639500005],
              [-178.5135391919999, 65.76264069200005],
              [-178.58869769799992, 65.73047183700004],
              [-178.6282169419999, 65.72949982600005],
              [-178.65046139199993, 65.76972077000005],
              [-178.6357315749999, 65.77488841400003],
              [-178.64667721299992, 65.78066640800006],
              [-178.65815182199992, 65.78270091400003],
              [-178.6838272779999, 65.78237539300005],
              [-178.6923721999999, 65.78449127800008],
              [-178.69884192599991, 65.78961823100008],
              [-178.70470130099991, 65.79612864800004],
              [-178.75190182199992, 65.83698151200008],
              [-178.7667130199999, 65.84686920800004],
              [-178.87250729099992, 65.89394765800006],
              [-178.9032690089999, 65.91958242400005],
              [-178.86884518099993, 65.93817780200004],
              [-178.8951309889999, 65.97724030200004],
              [-178.9783829419999, 66.04926178600005],
              [-178.95673580599993, 66.04828522300005],
              [-178.93586178299992, 66.04116445500006],
              [-178.89643307199992, 66.02191803600005],
              [-178.83381100199992, 66.00556061400005],
              [-178.8148087229999, 65.99774811400005],
              [-178.79889889199993, 65.99408600500004],
              [-178.72533417499992, 65.99192556700007],
              [-178.6842561139999, 66.01257187500005],
              [-178.66941898099992, 66.04728953400007],
              [-178.6987198559999, 66.07640208500004],
              [-178.68244381399992, 66.10187409100007],
              [-178.6162437099999, 66.10675337400005],
              [-178.5592881809999, 66.10307311300005],
              [-178.5271342229999, 66.11907701000007],
              [-178.4956754549999, 66.14012730100006],
              [-178.5136679279999, 66.15619158000004],
              [-178.5283778969999, 66.17106140400006],
              [-178.5060500209999, 66.19062416000008],
              [-178.49328659699992, 66.21121980300006],
              [-178.50401442799992, 66.21983192000005],
              [-178.52936764199993, 66.22467682500007],
              [-178.52216549399992, 66.24607982000003],
              [-178.5401505199999, 66.26837799700007],
              [-178.5300186839999, 66.27387116100005],
              [-178.5206192699999, 66.28148021000004],
              [-178.5029190749999, 66.29938385600008],
              [-178.4982804029999, 66.30890534100007],
              [-178.50243079299992, 66.31683991100005],
              [-178.5092667309999, 66.32461172100005],
              [-178.51288814999992, 66.33380768400008],
              [-178.4623019469999, 66.36789054000008],
              [-178.4771240439999, 66.38276195900005],
              [-178.50222183999992, 66.38091537000008],
              [-178.52006810999993, 66.37289154400008],
              [-178.5404711959999, 66.36099876000009],
              [-178.5391675969999, 66.35215304300004],
              [-178.5647560609999, 66.35408102100007],
              [-178.60371913999992, 66.36075604500007],
              [-178.6047877119999, 66.34677966500004],
              [-178.60604460099992, 66.33406669600004],
              [-178.6108284789999, 66.32380490000008],
              [-178.61201771299991, 66.31109262100006],
              [-178.62239802899992, 66.29577707300007],
              [-178.6655335829999, 66.25868036500003],
              [-178.72290249499991, 66.20974704300005],
              [-178.75240617999992, 66.19099284100008],
              [-178.78513456099992, 66.16724307800007],
              [-178.89578144299992, 66.14971082000005],
              [-178.9824393229999, 66.15894745300005],
              [-179.0472305979999, 66.19944896000004],
              [-179.0637914699999, 66.21246979400007],
              [-179.11766516799992, 66.24266185100004],
              [-179.12922115799992, 66.25161367400005],
              [-179.1218155589999, 66.27045319200005],
              [-179.08942623599992, 66.29214101800005],
              [-179.0820206369999, 66.30621979400007],
              [-179.09496008999992, 66.34560781500005],
              [-179.12616939999992, 66.38906484600005],
              [-179.1642960279999, 66.41437409100007],
              [-179.19810950399992, 66.39931875200006],
              [-179.18073482999992, 66.37323639500005],
              [-179.1772354809999, 66.34438711100006],
              [-179.17756100199992, 66.31557851800005],
              [-179.17145748599992, 66.28945547100005],
              [-179.24677486899992, 66.29205963700008],
              [-179.2892960279999, 66.29970937700006],
              [-179.3235977859999, 66.32465241100005],
              [-179.42402096299992, 66.34406159100007],
              [-179.3904923169999, 66.29564036700003],
              [-179.3749893869999, 66.28937409100007],
              [-179.33604895699992, 66.28302643400008],
              [-179.3253067699999, 66.27545807500007],
              [-179.31017005099991, 66.25104401200008],
              [-179.28962154899992, 66.23016998900005],
              [-179.2179477669999, 66.18219585500003],
              [-179.25195469699992, 66.14517039100008],
              [-179.30930190299992, 66.12553168600004],
              [-179.4217910449999, 66.11906091000003],
              [-179.57458280799992, 66.11129726600007],
              [-179.6611221999999, 66.12750885600008],
              [-179.6807755199999, 66.13458893400008],
              [-179.69135494699992, 66.14166901200008],
              [-179.68134518099993, 66.14484284100007],
              [-179.5911759109999, 66.14443594000005],
              [-179.58039303299992, 66.14858633000006],
              [-179.58165442599991, 66.15851471600007],
              [-179.63011633999992, 66.16937897300005],
              [-179.68232174399992, 66.18773021000004],
              [-179.69298255099991, 66.18390534100007],
              [-179.70893307199992, 66.16225820500006],
              [-179.76825924399992, 66.10293203300006],
              [-179.7802628249999, 66.07591380400004],
              [-179.78779049399992, 66.03253815300008],
              [-179.7921036449999, 66.02130768400008],
              [-179.8017065089999, 66.01129791900007],
              [-179.8112686839999, 66.00324127800008],
              [-179.81566321499992, 65.99774811400005],
              [-179.8174942699999, 65.98411692900004],
              [-179.8287247389999, 65.94684479400007],
              [-179.8268936839999, 65.93431224200003],
              [-179.76667232999992, 65.81981028900003],
              [-179.7498673169999, 65.79913971600007],
              [-179.7232559889999, 65.78148021000004],
              [-179.4572647779999, 65.67450592700004],
              [-179.3904923169999, 65.65884023600006],
              [-179.27704439299993, 65.63025620200006],
              [-179.30720639799992, 65.60723690000003],
              [-179.30312051599992, 65.58322320000008],
              [-179.32126554899992, 65.57452462000003],
              [-179.2605104109999, 65.53217898500003],
              [-179.2988856359999, 65.50083704700006],
              [-179.3614756609999, 65.46857951300007],
              [-179.40211925999992, 65.45118924200005],
              [-179.41450421599993, 65.43870864900003],
              [-179.4640020049999, 65.41699067300004],
              [-179.4990030319999, 65.39571123800005],
              [-179.4889507759999, 65.36577431200004],
              [-179.4861593759999, 65.34972299400005],
              [-179.52141756799992, 65.33042975700005],
              [-179.5127643539999, 65.30850700400003],
              [-179.5219290619999, 65.27789720200008],
              [-179.5242098969999, 65.23536073200006],
              [-179.58781558099992, 65.20197056800004],
              [-179.62495108899992, 65.16862840200008],
              [-179.66308983899992, 65.14126325700005],
              [-179.69201728399992, 65.14232486800006],
              [-179.7400033229999, 65.14276027200003],
              [-179.77550217299992, 65.12749156600006],
              [-179.8054667159999, 65.10838618700006],
              [-179.83101257299992, 65.09143235200008],
              [-179.87668259499992, 65.07981268900005],
              [-179.89931567999992, 65.07299781500006],
              [-179.9361998439999, 65.06568208800007],
              [-180, 65.06622947500006],
            ],
          ],
          [
            [
              [180, 71.53641963400008],
              [180, 71.05263157900004],
              [180, 70.99242290800004],
              [179.87486895400002, 70.96034587100007],
              [179.86624067800005, 70.94238589200006],
              [179.80698045100007, 70.91309659900008],
              [179.6669933610001, 70.87477850900007],
              [179.4525471610001, 70.87349104400005],
              [179.30626276300006, 70.87922004400008],
              [179.217133009, 70.88060130400004],
              [179.13103274800005, 70.87872955900008],
              [178.8320418630001, 70.80853913000004],
              [178.793304884, 70.80499909100007],
              [178.7895613940001, 70.81293366100005],
              [178.7880965500001, 70.83441803600005],
              [178.78345787900003, 70.84284088700008],
              [178.74586022200003, 70.88198476800005],
              [178.7387801440001, 70.89435455900008],
              [178.71371504, 70.92865631700005],
              [178.70191491000003, 70.94245026200008],
              [178.69320722700002, 70.95579661700003],
              [178.6816512380001, 70.96832916900007],
              [178.6689559250001, 70.97894928600005],
              [178.65691165500004, 70.98680247600004],
              [178.62273196700005, 71.03774648600006],
              [178.62224368600005, 71.05101146000004],
              [178.62647545700008, 71.06093984600005],
              [178.63404381600003, 71.06948476800005],
              [178.66765384200005, 71.09902578300006],
              [178.69695071700005, 71.11542389500005],
              [178.8212996750001, 71.16852448100008],
              [178.8476668630001, 71.18378327000005],
              [178.8691512380001, 71.20966217700004],
              [178.86394290500004, 71.21393463700008],
              [178.85954837300005, 71.21450429900005],
              [178.855804884, 71.21308014500005],
              [178.85466556100005, 71.21255117400005],
              [178.8486434250001, 71.20966217700004],
              [178.848968946, 71.20994700700004],
              [178.85466556100005, 71.21263255400004],
              [178.90544681100005, 71.23700592700004],
              [179.182953321, 71.30353424700007],
              [179.39128665500004, 71.38328685100004],
              [179.44027754, 71.39227936400005],
              [179.49976647200003, 71.43219635600008],
              [179.5634871750001, 71.45148346600007],
              [179.700043165, 71.45856354400007],
              [179.7666121750001, 71.46971263200004],
              [179.75847415500004, 71.48029205900008],
              [179.7529403000001, 71.48403554900005],
              [179.771820509, 71.49013906500005],
              [179.79273522200003, 71.49164459800005],
              [179.83464603000004, 71.49017975500004],
              [179.852875196, 71.49262116100005],
              [179.86540774800005, 71.49884674700007],
              [179.86605879, 71.50755442900004],
              [179.8486434250001, 71.51752350500004],
              [180, 71.53641963400008],
            ],
          ],
          [
            [
              [-180, 70.99201035500005],
              [-180, 71.05263157900004],
              [-180, 71.53668798800004],
              [-179.86286373599992, 71.53864166900007],
              [-179.91222083199992, 71.55585358300004],
              [-179.9007462229999, 71.55849844000005],
              [-179.7988175119999, 71.56907786700003],
              [-179.75743567599991, 71.58319733300004],
              [-179.73595130099991, 71.58641185100004],
              [-179.7154434889999, 71.58323802300004],
              [-179.6974991529999, 71.57733795800004],
              [-179.6787003249999, 71.57367584800005],
              [-179.6108292309999, 71.58519114800004],
              [-179.3720596999999, 71.56907786700003],
              [-179.3267716139999, 71.55548737200007],
              [-179.30683346299992, 71.55756256700005],
              [-179.28718014199993, 71.56293366100005],
              [-179.24286861899992, 71.56907786700003],
              [-179.20466061099992, 71.58319733300004],
              [-179.0745743479999, 71.60004303600005],
              [-178.73471025299992, 71.57037995000005],
              [-178.39484615799992, 71.54071686400005],
              [-178.3231908839999, 71.51837799700007],
              [-178.2596329419999, 71.51068756700005],
              [-178.30488033799992, 71.51312897300005],
              [-178.32347571499992, 71.51512278900003],
              [-178.34154212099992, 71.51752350500004],
              [-178.32245846299992, 71.50543854400007],
              [-178.21532141799992, 71.47801341400003],
              [-178.19347083199992, 71.47662995000007],
              [-178.1477758449999, 71.48517487200007],
              [-178.12446041599992, 71.48187897300005],
              [-178.0057266919999, 71.44863515800006],
              [-178.01720130099991, 71.44139232000003],
              [-178.0541886059999, 71.42877838700008],
              [-178.04706783799992, 71.42572663000004],
              [-178.0334366529999, 71.41779205900008],
              [-178.02623450399992, 71.41510651200008],
              [-178.03010006399992, 71.41347890800006],
              [-178.03990637899992, 71.40766022300005],
              [-177.97089596299992, 71.39642975500004],
              [-177.77985592399992, 71.33319733300004],
              [-177.71837317599991, 71.30524323100008],
              [-177.7064102859999, 71.30390045800004],
              [-177.68211829299992, 71.30487702000005],
              [-177.6702774729999, 71.30182526200008],
              [-177.6553848949999, 71.29315827000005],
              [-177.58759518099993, 71.28595612200007],
              [-177.54857337099992, 71.29486725500004],
              [-177.5311173169999, 71.29633209800005],
              [-177.51410885299993, 71.29340241100005],
              [-177.4986466139999, 71.28473541900007],
              [-177.5062149729999, 71.26862213700008],
              [-177.48700924399992, 71.25873444200005],
              [-177.4597061839999, 71.24990469000005],
              [-177.44343014199993, 71.23700592700004],
              [-177.4459122389999, 71.22264232000003],
              [-177.4577530589999, 71.20937734600005],
              [-177.5078018869999, 71.17377350500004],
              [-177.5811661449999, 71.14760976800005],
              [-177.6376440089999, 71.11701080900008],
              [-177.68415279899992, 71.11098867400005],
              [-177.75190182199992, 71.09296295800004],
              [-177.8192846339999, 71.08466217700004],
              [-177.8776749339999, 71.05255768400008],
              [-177.93049068899992, 71.04144928600005],
              [-178.20661373599992, 71.03839752800008],
              [-178.31012936099992, 71.01361725500004],
              [-178.5930273099999, 70.99732086800006],
              [-178.8759252589999, 70.98102448100008],
              [-178.98029537699992, 70.95066966400003],
              [-179.34211178299992, 70.90802643400008],
              [-179.33625240799992, 70.91107819200005],
              [-179.3222550119999, 70.92169830900008],
              [-179.36449133999992, 70.93024323100008],
              [-179.45750891799992, 70.91551341400003],
              [-179.50121008999992, 70.91966380400004],
              [-179.6660050119999, 70.96548086100006],
              [-179.8533829419999, 70.97943756700005],
              [-179.88878333199992, 70.99359772300005],
              [-179.9075414699999, 70.99677155200004],
              [-180, 70.99201035500005],
            ],
          ],
          [
            [
              [131.92009524800005, 43.019517320000034],
              [131.92253665500004, 43.00893789300005],
              [131.92400149800005, 43.005845445000034],
              [131.9209090500001, 42.99628327000005],
              [131.9150496750001, 42.98427969000005],
              [131.8833113940001, 42.96076080900008],
              [131.837250196, 42.96112702000005],
              [131.79053795700008, 42.97455475500004],
              [131.75700931100005, 42.99005768400008],
              [131.79118899800005, 42.99628327000005],
              [131.77458743600005, 43.00531647300005],
              [131.76937910200002, 43.01536692900004],
              [131.7734481130001, 43.021185614000046],
              [131.78435306100005, 43.01740143400008],
              [131.79118899800005, 43.01740143400008],
              [131.78736412900003, 43.034369208000044],
              [131.78386478000004, 43.04010651200008],
              [131.77751712300005, 43.044623114000046],
              [131.7988387380001, 43.05263906500005],
              [131.819672071, 43.049261786000045],
              [131.84009850400003, 43.04169342700004],
              [131.8593856130001, 43.03725820500006],
              [131.8593856130001, 43.044623114000046],
              [131.826508009, 43.06517161700003],
              [131.85499108200008, 43.06134674700007],
              [131.87574303500003, 43.05101146000004],
              [131.89226321700005, 43.03583405200004],
              [131.9209090500001, 43.02415599200003],
              [131.92009524800005, 43.019517320000034],
            ],
          ],
          [
            [
              [142.52906334700003, 54.29718659100007],
              [142.53695722700002, 54.296535549000055],
              [142.52906334700003, 54.29376862200007],
              [142.52019290500004, 54.28563060100004],
              [142.52116946700005, 54.276597398000035],
              [142.52613366000003, 54.26577383000006],
              [142.52906334700003, 54.25214264500005],
              [142.54322350400003, 54.237209377000056],
              [142.5703231130001, 54.23476797100005],
              [142.5869246750001, 54.24705638200004],
              [142.57007897200003, 54.276597398000035],
              [142.58863366000003, 54.280503648000035],
              [142.60906009200005, 54.27521393400008],
              [142.62623131600003, 54.268011786000045],
              [142.635101759, 54.266058661000045],
              [142.64909915500004, 54.28339264500005],
              [142.645843946, 54.290269273000035],
              [142.6347762380001, 54.296087958000044],
              [142.62525475400003, 54.310207424000055],
              [142.6254988940001, 54.32729726800005],
              [142.63640384200005, 54.333970445000034],
              [142.652679884, 54.338324286000045],
              [142.66968834700003, 54.34833405200004],
              [142.67994225400003, 54.35879140800006],
              [142.68677819100003, 54.369126695000034],
              [142.6860457690001, 54.380072333000044],
              [142.67310631600003, 54.39207591400003],
              [142.67603600400003, 54.40485260600008],
              [142.68148847700002, 54.41596100500004],
              [142.69068444100003, 54.423895575000074],
              [142.7041121750001, 54.42682526200008],
              [142.7231551440001, 54.42560455900008],
              [142.73357181100005, 54.42145416900007],
              [142.75180097700002, 54.40298086100006],
              [142.75806725400003, 54.393866278000075],
              [142.766449415, 54.37132396000004],
              [142.77271569100003, 54.36200592700004],
              [142.79444420700008, 54.348089911000045],
              [142.80543053500003, 54.33893463700008],
              [142.819672071, 54.30190664300005],
              [142.8427840500001, 54.28070709800005],
              [142.895843946, 54.24559153900003],
              [142.957855665, 54.17023346600007],
              [143.0039168630001, 54.13548411700003],
              [143.01295006600003, 54.11908600500004],
              [143.0087996750001, 54.091050523000035],
              [142.99984785200002, 54.067572333000044],
              [142.98845462300005, 54.04718659100007],
              [142.97339928500003, 54.02814362200007],
              [142.9375106130001, 53.99091217700004],
              [142.927093946, 53.97532786700003],
              [142.90593509200005, 53.91185130400004],
              [142.9004012380001, 53.901597398000035],
              [142.89226321700005, 53.89248281500005],
              [142.88851972700002, 53.89297109600005],
              [142.88160241000003, 53.89484284100007],
              [142.87330162900003, 53.89557526200008],
              [142.86548912900003, 53.89248281500005],
              [142.8613387380001, 53.88812897300005],
              [142.8574324880001, 53.88300202000005],
              [142.85181725400003, 53.871975002000056],
              [142.89665774800005, 53.876613674000055],
              [142.9165145190001, 53.87409088700008],
              [142.93376712300005, 53.85765208500004],
              [142.9355574880001, 53.84918854400007],
              [142.9404403000001, 53.823553778000075],
              [142.94792728000004, 53.809881903000075],
              [142.97535241000003, 53.75527578300006],
              [142.99626712300005, 53.716782945000034],
              [143.00212649800005, 53.70062897300005],
              [142.95655358200008, 53.781317450000074],
              [142.9267684250001, 53.829779364000046],
              [142.89812259200005, 53.82322825700004],
              [142.89014733200008, 53.81313711100006],
              [142.90056399800005, 53.79043203300006],
              [142.90650475400003, 53.766791083000044],
              [142.91334069100003, 53.76211172100005],
              [142.93970787900003, 53.74974192900004],
              [142.96436608200008, 53.69953034100007],
              [142.98845462300005, 53.69448476800005],
              [142.9677840500001, 53.66648997600004],
              [143.0039168630001, 53.66616445500006],
              [143.017914259, 53.66034577000005],
              [143.0293074880001, 53.64606354400007],
              [143.0205184250001, 53.642645575000074],
              [143.0117293630001, 53.637884833000044],
              [143.00342858200008, 53.632147528000075],
              [142.99586022200003, 53.62555573100008],
              [143.01490319100003, 53.61774323100008],
              [143.0527449880001, 53.60724518400008],
              [143.0708113940001, 53.59821198100008],
              [143.05827884200005, 53.58978913000004],
              [143.04468834700003, 53.58510976800005],
              [143.03044681100005, 53.58510976800005],
              [143.01636803500003, 53.59076569200005],
              [143.012543165, 53.58218008000006],
              [143.00652103000004, 53.57575104400007],
              [142.99830162900003, 53.57172272300005],
              [142.98845462300005, 53.570298570000034],
              [142.98845462300005, 53.56289297100005],
              [143.00310306100005, 53.55768463700008],
              [143.0302840500001, 53.53998444200005],
              [143.04273522200003, 53.53620026200008],
              [143.05689537900003, 53.538763739000046],
              [143.090668165, 53.559759833000044],
              [143.09913170700008, 53.55385976800005],
              [143.11085045700008, 53.537095445000034],
              [143.1211043630001, 53.51805247600004],
              [143.1254988940001, 53.50543854400007],
              [143.1274520190001, 53.495794989000046],
              [143.1308699880001, 53.48688385600008],
              [143.13160241000003, 53.477850653000075],
              [143.1254988940001, 53.46792226800005],
              [143.1142684250001, 53.46674225500004],
              [143.09888756600003, 53.47211334800005],
              [143.08318118600005, 53.47357819200005],
              [143.0708113940001, 53.46108633000006],
              [143.06999759200005, 53.448553778000075],
              [143.07781009200005, 53.442613023000035],
              [143.08871504, 53.43903229400007],
              [143.0976668630001, 53.43374258000006],
              [143.103851759, 53.42796458500004],
              [143.10816491000003, 53.425116278000075],
              [143.11060631600003, 53.41974518400008],
              [143.1113387380001, 53.40643952000005],
              [143.10726972700002, 53.39984772300005],
              [143.09913170700008, 53.39411041900007],
              [143.0927840500001, 53.38841380400004],
              [143.094086134, 53.38190338700008],
              [143.10084069100003, 53.37836334800005],
              [143.1093856130001, 53.37775299700007],
              [143.11793053500003, 53.37913646000004],
              [143.15577233200008, 53.39516836100006],
              [143.16920006600003, 53.398098049000055],
              [143.18287194100003, 53.39899323100008],
              [143.196625196, 53.38812897300005],
              [143.21062259200005, 53.36322663000004],
              [143.24683678500003, 53.25665924700007],
              [143.2544051440001, 53.21552155200004],
              [143.28012129, 53.17291901200008],
              [143.2900496750001, 53.15192291900007],
              [143.29224694100003, 53.083685614000046],
              [143.300140821, 53.06696198100008],
              [143.31226647200003, 53.04913971600007],
              [143.31657962300005, 53.02789948100008],
              [143.31788170700008, 52.98187897300005],
              [143.32699629, 52.93634674700007],
              [143.3359481130001, 52.91351959800005],
              [143.347992384, 52.89594147300005],
              [143.36052493600005, 52.87140534100007],
              [143.352875196, 52.84955475500004],
              [143.32488040500004, 52.80931224200003],
              [143.33326256600003, 52.78473541900007],
              [143.33708743600005, 52.759426174000055],
              [143.3379012380001, 52.70380280200004],
              [143.32683353000004, 52.62250397300005],
              [143.3310653000001, 52.60390859600005],
              [143.3247176440001, 52.58771393400008],
              [143.3046981130001, 52.47138092700004],
              [143.2968856130001, 52.45368073100008],
              [143.27605228000004, 52.42039622600004],
              [143.2519637380001, 52.38963450700004],
              [143.22445722700002, 52.361761786000045],
              [143.193695509, 52.33698151200008],
              [143.20582116000003, 52.382147528000075],
              [143.207367384, 52.39533112200007],
              [143.20427493600005, 52.406317450000074],
              [143.19898522200003, 52.415676174000055],
              [143.1977645190001, 52.425848700000074],
              [143.207367384, 52.43939850500004],
              [143.22388756600003, 52.44794342700004],
              [143.2402449880001, 52.44839101800005],
              [143.2548934250001, 52.44700755400004],
              [143.26587975400003, 52.45026276200008],
              [143.27230879, 52.463324286000045],
              [143.26295006600003, 52.47162506700005],
              [143.2353621750001, 52.48094310100004],
              [143.244476759, 52.48875560100004],
              [143.286468946, 52.565334377000056],
              [143.2900496750001, 52.57721588700008],
              [143.29175866000003, 52.58641185100004],
              [143.2934676440001, 52.591864325000074],
              [143.29021243600005, 52.595038153000075],
              [143.2763778000001, 52.597723700000074],
              [143.26832116000003, 52.59837474200003],
              [143.26140384200005, 52.59760163000004],
              [143.25505618600005, 52.59520091400003],
              [143.2490340500001, 52.59080638200004],
              [143.250336134, 52.587876695000034],
              [143.2490340500001, 52.562933661000045],
              [143.24634850400003, 52.559800523000035],
              [143.24195397200003, 52.55817291900007],
              [143.23755944100003, 52.55735911700003],
              [143.2353621750001, 52.556708075000074],
              [143.2353621750001, 52.55215078300006],
              [143.23796634200005, 52.548081773000035],
              [143.240570509, 52.54474518400008],
              [143.241547071, 52.54242584800005],
              [143.2295028000001, 52.51947663000004],
              [143.193695509, 52.473863023000035],
              [143.17888431100005, 52.44684479400007],
              [143.16553795700008, 52.40379466400003],
              [143.15967858200008, 52.39166901200008],
              [143.1269637380001, 52.35883209800005],
              [143.11866295700008, 52.33779531500005],
              [143.1294051440001, 52.32664622600004],
              [143.1464949880001, 52.32786692900004],
              [143.15967858200008, 52.34442780200004],
              [143.1665145190001, 52.34442780200004],
              [143.16822350400003, 52.33295319200005],
              [143.17750084700003, 52.313788153000075],
              [143.17603600400003, 52.30658600500004],
              [143.169281446, 52.294623114000046],
              [143.16960696700005, 52.28465403900003],
              [143.17253665500004, 52.27606842700004],
              [143.17335045700008, 52.26813385600008],
              [143.15577233200008, 52.20368073100008],
              [143.1513778000001, 52.12006256700005],
              [143.147797071, 52.119574286000045],
              [143.125336134, 52.146144924000055],
              [143.115570509, 52.15302155200004],
              [143.1113387380001, 52.14862702000005],
              [143.11052493600005, 52.13572825700004],
              [143.10816491000003, 52.12445709800005],
              [143.1040145190001, 52.11420319200005],
              [143.0976668630001, 52.10423411700003],
              [143.1391707690001, 52.089911200000074],
              [143.13347415500004, 52.07982005400004],
              [143.1337996750001, 52.06850820500006],
              [143.1391707690001, 52.04901764500005],
              [143.13892662900003, 52.03750234600005],
              [143.13697350400003, 52.03034088700008],
              [143.13851972700002, 52.023138739000046],
              [143.14918053500003, 52.011419989000046],
              [143.15935306100005, 51.99567291900007],
              [143.15992272200003, 51.97907135600008],
              [143.14909915500004, 51.96759674700007],
              [143.1254988940001, 51.96702708500004],
              [143.13111412900003, 51.95571523600006],
              [143.14210045700008, 51.92495351800005],
              [143.14918053500003, 51.91864655200004],
              [143.16480553500003, 51.91364166900007],
              [143.16480553500003, 51.901678778000075],
              [143.160492384, 51.88694896000004],
              [143.1630965500001, 51.87396881700005],
              [143.1748153000001, 51.86660390800006],
              [143.19459069100003, 51.85846588700008],
              [143.21306399800005, 51.854803778000075],
              [143.2212020190001, 51.860581773000035],
              [143.22429446700005, 51.87445709800005],
              [143.2314559250001, 51.88703034100007],
              [143.23845462300005, 51.89154694200005],
              [143.25505618600005, 51.837103583000044],
              [143.31039472700002, 51.754339911000045],
              [143.31788170700008, 51.706366278000075],
              [143.29656009200005, 51.71308014500005],
              [143.27621504, 51.700506903000075],
              [143.261078321, 51.67820872600004],
              [143.25220787900003, 51.64154694200005],
              [143.23853600400003, 51.62246328300006],
              [143.2353621750001, 51.61391836100006],
              [143.236664259, 51.60219961100006],
              [143.24146569100003, 51.581244208000044],
              [143.241547071, 51.569240627000056],
              [143.23780358200008, 51.558294989000046],
              [143.22413170700008, 51.53778717700004],
              [143.2212020190001, 51.53164297100005],
              [143.22413170700008, 51.52216217700004],
              [143.23170006600003, 51.51264069200005],
              [143.24170983200008, 51.50763580900008],
              [143.27320397200003, 51.520738023000035],
              [143.29607181100005, 51.51666901200008],
              [143.3183699880001, 51.50922272300005],
              [143.3379012380001, 51.50836823100008],
              [143.34717858200008, 51.52338288000004],
              [143.34400475400003, 51.54865143400008],
              [143.33521569100003, 51.572333075000074],
              [143.32789147200003, 51.58283112200007],
              [143.3252059250001, 51.59284088700008],
              [143.33228600400003, 51.614488023000035],
              [143.34652754, 51.635931708000044],
              [143.36508222700002, 51.644964911000045],
              [143.37322024800005, 51.63654205900008],
              [143.37964928500003, 51.617621161000045],
              [143.38559004, 51.579779364000046],
              [143.39421634200005, 51.56464264500005],
              [143.4477645190001, 51.50836823100008],
              [143.461761915, 51.46954987200007],
              [143.474945509, 51.34324778900009],
              [143.4423934250001, 51.367254950000074],
              [143.427093946, 51.37055084800005],
              [143.41675866000003, 51.368068752000056],
              [143.3794051440001, 51.35008372600004],
              [143.38795006600003, 51.343451239000046],
              [143.40349368600005, 51.336004950000074],
              [143.413422071, 51.32965729400007],
              [143.434418165, 51.32103099200003],
              [143.433929884, 51.31696198100008],
              [143.43279056100005, 51.31240469000005],
              [143.433929884, 51.30914948100008],
              [143.4458113940001, 51.30418528900009],
              [143.456390821, 51.30097077000005],
              [143.46607506600003, 51.296861070000034],
              [143.474945509, 51.28925202000005],
              [143.477875196, 51.28143952000005],
              [143.47820071700005, 51.26341380400004],
              [143.48308353000004, 51.25454336100006],
              [143.47934004, 51.25079987200007],
              [143.4775496750001, 51.24799225500004],
              [143.474945509, 51.24087148600006],
              [143.480804884, 51.23940664300005],
              [143.489593946, 51.23501211100006],
              [143.495453321, 51.23338450700004],
              [143.49097741000003, 51.22833893400008],
              [143.48308353000004, 51.21356842700004],
              [143.51710045700008, 51.22011953300006],
              [143.52125084700003, 51.24677155200004],
              [143.50928795700008, 51.28066640800006],
              [143.495453321, 51.30914948100008],
              [143.52165774800005, 51.28510163000004],
              [143.53793379, 51.23973216400009],
              [143.58668053500003, 51.01072825700004],
              [143.67896569100003, 50.73651764500005],
              [143.701508009, 50.60537344000005],
              [143.79029381600003, 50.30923086100006],
              [143.81006920700008, 50.272650458000044],
              [143.910980665, 50.15086497600004],
              [144.00269616000003, 50.01284414300005],
              [144.04420006600003, 49.897650458000044],
              [144.07984459700003, 49.83730703300006],
              [144.090668165, 49.80451080900008],
              [144.11744225400003, 49.76780833500004],
              [144.12614993600005, 49.74689362200007],
              [144.13233483200008, 49.66087474200003],
              [144.1372176440001, 49.63959381700005],
              [144.1494246750001, 49.622381903000075],
              [144.1650496750001, 49.60651276200008],
              [144.22217858200008, 49.53261953300006],
              [144.2285262380001, 49.51715729400007],
              [144.2197371750001, 49.46185944200005],
              [144.2216903000001, 49.438381252000056],
              [144.28272545700008, 49.25018952000005],
              [144.38502037900003, 49.072699286000045],
              [144.41041100400003, 49.03925202000005],
              [144.4414168630001, 49.01386139500005],
              [144.66684004, 48.88963450700004],
              [144.68474368600005, 48.87323639500005],
              [144.69092858200008, 48.86408112200007],
              [144.69320722700002, 48.85541413000004],
              [144.69459069100003, 48.83567942900004],
              [144.69752037900003, 48.82558828300006],
              [144.70679772200003, 48.80304596600007],
              [144.70826256600003, 48.794134833000044],
              [144.7041121750001, 48.78196849200003],
              [144.69068444100003, 48.768011786000045],
              [144.687836134, 48.75653717700004],
              [144.69459069100003, 48.71556224200003],
              [144.70289147200003, 48.688666083000044],
              [144.722015821, 48.67206452000005],
              [144.74293053500003, 48.65912506700005],
              [144.75660241000003, 48.64325592700004],
              [144.7314559250001, 48.637925523000035],
              [144.69947350400003, 48.64272695500006],
              [144.67725670700008, 48.65643952000005],
              [144.6816512380001, 48.67804596600007],
              [144.66334069100003, 48.70066966400009],
              [144.657562696, 48.723863023000035],
              [144.65512129, 48.74982330900008],
              [144.6474715500001, 48.780462958000044],
              [144.63257897200003, 48.808294989000046],
              [144.50367272200003, 48.94871653900009],
              [144.4790145190001, 48.95921458500004],
              [144.47046959700003, 48.96474844000005],
              [144.44548587300005, 48.99115631700005],
              [144.43384850400003, 49.00018952000005],
              [144.4170028000001, 49.00604889500005],
              [144.3818465500001, 49.01390208500004],
              [144.3657332690001, 49.020697333000044],
              [144.32781009200005, 49.054754950000074],
              [144.31568444100003, 49.05683014500005],
              [144.30258222700002, 49.062160549000055],
              [144.29029381600003, 49.069647528000075],
              [144.28003991000003, 49.07843659100007],
              [144.27295983200008, 49.08856842700004],
              [144.263031446, 49.11237213700008],
              [144.2558699880001, 49.123032945000034],
              [144.24594160200002, 49.131740627000056],
              [144.10108483200008, 49.23126862200007],
              [144.05787194100003, 49.25340403900009],
              [144.00603274800005, 49.26935455900008],
              [143.7021590500001, 49.30609772300005],
              [143.68970787900003, 49.31240469000005],
              [143.68726647200003, 49.322333075000074],
              [143.72828209700003, 49.33535390800006],
              [143.4990340500001, 49.34918854400007],
              [143.47974694100003, 49.35309479400007],
              [143.46265709700003, 49.36273834800005],
              [143.4443465500001, 49.380072333000044],
              [143.4262801440001, 49.39321523600006],
              [143.40349368600005, 49.400458075000074],
              [143.30201256600003, 49.405178127000056],
              [143.276703321, 49.40216705900008],
              [143.258636915, 49.39337799700007],
              [143.24976647200003, 49.37327708500004],
              [143.26392662900003, 49.36017487200007],
              [143.31039472700002, 49.34275950700004],
              [143.31910241000003, 49.34096914300005],
              [143.32569420700008, 49.34218984600005],
              [143.32960045700008, 49.341131903000075],
              [143.3310653000001, 49.33222077000005],
              [143.32829837300005, 49.32904694200005],
              [143.3227645190001, 49.32697174700007],
              [143.31910241000003, 49.32412344000005],
              [143.3212996750001, 49.31858958500004],
              [143.33130944100003, 49.31391022300005],
              [143.34302819100003, 49.31582265800006],
              [143.35515384200005, 49.320013739000046],
              [143.36605879, 49.322333075000074],
              [143.61939537900003, 49.32404205900008],
              [143.66675866000003, 49.314886786000045],
              [143.6391707690001, 49.30560944200005],
              [143.3711043630001, 49.29922109600005],
              [143.174164259, 49.24599844000005],
              [143.145355665, 49.23289622600004],
              [143.0703231130001, 49.184881903000075],
              [143.03785241000003, 49.15656159100007],
              [143.0087996750001, 49.123032945000034],
              [142.98454837300005, 49.08295319200005],
              [142.9746199880001, 49.04588450700004],
              [142.9765731130001, 49.00653717700004],
              [142.98845462300005, 48.95921458500004],
              [142.98845462300005, 48.91669342700004],
              [142.9692488940001, 48.87848541900007],
              [142.92009524800005, 48.807806708000044],
              [142.88656660200002, 48.73655833500004],
              [142.79273522200003, 48.562567450000074],
              [142.7231551440001, 48.408636786000045],
              [142.658539259, 48.269598700000074],
              [142.61402428500003, 48.19017161700003],
              [142.54957116000003, 48.02008698100008],
              [142.54566491000003, 48.01398346600007],
              [142.54127037900003, 48.01219310100004],
              [142.537445509, 48.01007721600007],
              [142.53589928500003, 48.002386786000045],
              [142.5380965500001, 47.999212958000044],
              [142.54273522200003, 47.997381903000075],
              [142.5473738940001, 47.994574286000045],
              [142.54957116000003, 47.988714911000045],
              [142.54957116000003, 47.94782135600008],
              [142.53882897200003, 47.920803127000056],
              [142.53589928500003, 47.910223700000074],
              [142.534515821, 47.889960028000075],
              [142.545258009, 47.76666901200008],
              [142.592133009, 47.64207591400009],
              [142.63209069100003, 47.581244208000044],
              [142.7480574880001, 47.44476959800005],
              [142.73975670700008, 47.44554271000004],
              [142.71404056100005, 47.44476959800005],
              [142.71404056100005, 47.43724192900004],
              [142.722992384, 47.43060944200005],
              [142.73511803500003, 47.42365143400008],
              [142.75953209700003, 47.43121979400007],
              [142.7871199880001, 47.42820872600004],
              [142.81430097700002, 47.41950104400007],
              [142.87859134200005, 47.38934967700004],
              [142.91089928500003, 47.365220445000034],
              [143.01636803500003, 47.253607489000046],
              [143.02320397200003, 47.235256252000056],
              [143.02564537900003, 47.21165599200003],
              [143.0429793630001, 47.14923737200007],
              [143.0415145190001, 47.128119208000044],
              [143.0312606130001, 47.083197333000044],
              [143.03248131600003, 47.070746161000045],
              [143.06950931100005, 47.01947663000004],
              [143.1020613940001, 46.94757721600007],
              [143.10515384200005, 46.927069403000075],
              [143.11085045700008, 46.90643952000005],
              [143.11996504, 46.88711172100005],
              [143.1196395190001, 46.87490469000005],
              [143.0976668630001, 46.87555573100008],
              [143.1064559250001, 46.86587148600006],
              [143.12281334700003, 46.85736725500004],
              [143.13843834700003, 46.85541413000004],
              [143.1513778000001, 46.87384674700007],
              [143.16382897200003, 46.872259833000044],
              [143.17408287900003, 46.86273834800005],
              [143.17335045700008, 46.84829336100006],
              [143.15121504, 46.83958567900004],
              [143.11793053500003, 46.841864325000074],
              [143.09001712300005, 46.83856842700004],
              [143.08383222700002, 46.81346263200004],
              [143.09148196700005, 46.80341217700004],
              [143.10613040500004, 46.79242584800005],
              [143.122406446, 46.783636786000045],
              [143.13550866000003, 46.77997467700004],
              [143.13746178500003, 46.773504950000074],
              [143.15967858200008, 46.73899974200003],
              [143.1665145190001, 46.71662018400008],
              [143.1728621750001, 46.70783112200007],
              [143.18628991000003, 46.704291083000044],
              [143.20281009200005, 46.706366278000075],
              [143.226898634, 46.71552155200004],
              [143.241547071, 46.71727122600004],
              [143.254730665, 46.71503327000005],
              [143.28199303500003, 46.706244208000044],
              [143.2968856130001, 46.704291083000044],
              [143.3086043630001, 46.70107656500005],
              [143.3310653000001, 46.68695709800005],
              [143.34131920700008, 46.68378327000005],
              [143.36500084700003, 46.686753648000035],
              [143.38200931100005, 46.69505442900004],
              [143.3896590500001, 46.70807526200008],
              [143.38559004, 46.72475820500006],
              [143.37134850400003, 46.73843008000006],
              [143.348968946, 46.749212958000044],
              [143.32374108200008, 46.756293036000045],
              [143.28679446700005, 46.761704820000034],
              [143.25611412900003, 46.775458075000074],
              [143.241547071, 46.77997467700004],
              [143.229828321, 46.78021881700005],
              [143.20492597700002, 46.77814362200007],
              [143.193695509, 46.77997467700004],
              [143.17953535200002, 46.793036200000074],
              [143.17302493600005, 46.81354401200008],
              [143.1777449880001, 46.832464911000045],
              [143.19711347700002, 46.84080638200004],
              [143.22022545700008, 46.835638739000046],
              [143.2968856130001, 46.800482489000046],
              [143.32097415500004, 46.79572174700007],
              [143.3964949880001, 46.79364655200004],
              [143.41871178500003, 46.799709377000056],
              [143.428070509, 46.81427643400008],
              [143.43628991000003, 46.83226146000004],
              [143.45460045700008, 46.84829336100006],
              [143.47820071700005, 46.82843659100007],
              [143.49789472700002, 46.80072663000004],
              [143.51148522200003, 46.77020905200004],
              [143.5166121750001, 46.74213288000004],
              [143.5161238940001, 46.679754950000074],
              [143.520843946, 46.64940013200004],
              [143.53695722700002, 46.61713288000004],
              [143.53589928500003, 46.60732656500005],
              [143.53199303500003, 46.59796784100007],
              [143.526703321, 46.59096914300005],
              [143.5258895190001, 46.58551666900007],
              [143.5293074880001, 46.578558661000045],
              [143.53695722700002, 46.566473700000074],
              [143.5507918630001, 46.506293036000045],
              [143.576508009, 46.44749583500004],
              [143.57992597700002, 46.41819896000004],
              [143.5576278000001, 46.39642975500004],
              [143.57398522200003, 46.38947174700007],
              [143.60962975400003, 46.38422272300005],
              [143.62574303500003, 46.374701239000046],
              [143.59148196700005, 46.35342031500005],
              [143.58179772200003, 46.34454987200007],
              [143.57732181100005, 46.33502838700008],
              [143.57447350400003, 46.31012604400007],
              [143.57056725400003, 46.29954661700003],
              [143.5634871750001, 46.294989325000074],
              [143.552093946, 46.29018789300005],
              [143.54167728000004, 46.28400299700007],
              [143.53695722700002, 46.27570221600007],
              [143.53541100400003, 46.26609935100004],
              [143.52328535200002, 46.23810455900008],
              [143.51042728000004, 46.22256094000005],
              [143.47584069100003, 46.19000885600008],
              [143.4687606130001, 46.17328522300005],
              [143.4785262380001, 46.10732656500005],
              [143.474945509, 46.08730703300006],
              [143.46802819100003, 46.08038971600007],
              [143.45883222700002, 46.076605536000045],
              [143.4511824880001, 46.07050202000005],
              [143.4462996750001, 46.04710521000004],
              [143.442718946, 46.03685130400004],
              [143.43726647200003, 46.028631903000075],
              [143.430511915, 46.02521393400008],
              [143.4209090500001, 46.03571198100008],
              [143.41529381600003, 46.05955638200004],
              [143.4130965500001, 46.08535390800006],
              [143.413422071, 46.101548570000034],
              [143.42497806100005, 46.116400458000044],
              [143.42896569100003, 46.12742747600004],
              [143.41920006600003, 46.14826080900008],
              [143.4209090500001, 46.15912506700005],
              [143.42497806100005, 46.17023346600007],
              [143.427093946, 46.18008047100005],
              [143.42554772200003, 46.20404694200005],
              [143.42139733200008, 46.22313060100004],
              [143.38266035200002, 46.31671784100007],
              [143.3794051440001, 46.33738841400009],
              [143.3379012380001, 46.409409898000035],
              [143.35084069100003, 46.43268463700008],
              [143.34685306100005, 46.45270416900007],
              [143.33668053500003, 46.470770575000074],
              [143.3310653000001, 46.48822663000004],
              [143.33570397200003, 46.49746328300006],
              [143.34742272200003, 46.49603913000004],
              [143.3613387380001, 46.49168528900009],
              [143.37322024800005, 46.49201080900008],
              [143.3798934250001, 46.49945709800005],
              [143.3930770190001, 46.53294505400004],
              [143.36866295700008, 46.55548737200007],
              [143.3427840500001, 46.56281159100007],
              [143.2763778000001, 46.560248114000046],
              [143.31039472700002, 46.525458075000074],
              [143.3032332690001, 46.51439036700003],
              [143.29078209700003, 46.51715729400007],
              [143.258636915, 46.542222398000035],
              [143.2353621750001, 46.566473700000074],
              [143.22242272200003, 46.573553778000075],
              [143.19507897200003, 46.58344147300005],
              [143.18287194100003, 46.59096914300005],
              [143.159515821, 46.59829336100006],
              [143.06714928500003, 46.587591864000046],
              [142.99773196700005, 46.59414297100005],
              [142.9638778000001, 46.60260651200008],
              [142.93376712300005, 46.614894924000055],
              [142.90577233200008, 46.60529205900008],
              [142.82781009200005, 46.592962958000044],
              [142.79664147200003, 46.59438711100006],
              [142.77222741000003, 46.60976797100005],
              [142.7548934250001, 46.63825104400007],
              [142.73511803500003, 46.69741445500006],
              [142.73031660200002, 46.729396877000056],
              [142.7246199880001, 46.74079010600008],
              [142.7109481130001, 46.74518463700008],
              [142.70045006600003, 46.74209219000005],
              [142.69092858200008, 46.72793203300006],
              [142.6836043630001, 46.72475820500006],
              [142.65259850400003, 46.72475820500006],
              [142.61841881600003, 46.71857330900008],
              [142.52906334700003, 46.68378327000005],
              [142.45720462300005, 46.63080475500004],
              [142.40650475400003, 46.55365631700005],
              [142.3242293630001, 46.38898346600007],
              [142.28191165500004, 46.327460028000075],
              [142.275726759, 46.30951569200005],
              [142.27418053500003, 46.300116278000075],
              [142.2622176440001, 46.266058661000045],
              [142.2490340500001, 46.19204336100006],
              [142.2485457690001, 46.18008047100005],
              [142.24634850400003, 46.16836172100005],
              [142.23707116000003, 46.14899323100008],
              [142.2348738940001, 46.13882070500006],
              [142.22803795700008, 46.11798737200007],
              [142.21436608200008, 46.09861888200004],
              [142.20386803500003, 46.07965729400007],
              [142.20687910200002, 46.06000397300005],
              [142.20297285200002, 46.051947333000044],
              [142.2016707690001, 46.03066640800006],
              [142.19695071700005, 46.02179596600007],
              [142.1894637380001, 46.018784898000035],
              [142.13306725400003, 46.00617096600007],
              [142.11996504, 45.992173570000034],
              [142.1113387380001, 45.95075104400007],
              [142.0942488940001, 45.902777411000045],
              [142.085297071, 45.900824286000045],
              [142.0732528000001, 45.909857489000046],
              [142.0532332690001, 45.91596100500004],
              [142.03980553500003, 45.92430247600004],
              [142.00147545700008, 45.97801341400009],
              [141.94206790500004, 46.02435944200005],
              [141.9326278000001, 46.03579336100006],
              [141.9360457690001, 46.09955475500004],
              [141.89909915500004, 46.27912018400008],
              [141.8847762380001, 46.31875234600005],
              [141.83757571700005, 46.41559479400007],
              [141.82740319100003, 46.45034414300005],
              [141.81421959700003, 46.538397528000075],
              [141.81714928500003, 46.58075592700004],
              [141.8222762380001, 46.60228099200003],
              [141.8266707690001, 46.60993073100008],
              [141.84009850400003, 46.62636953300006],
              [141.8486434250001, 46.64476146000004],
              [141.86589603000004, 46.67047760600008],
              [141.88542728000004, 46.73159414300005],
              [142.0566512380001, 47.05369700700004],
              [142.05974368600005, 47.08063385600008],
              [142.063812696, 47.10932038000004],
              [142.062836134, 47.13922760600008],
              [142.0566512380001, 47.16974518400008],
              [142.044281446, 47.20453522300005],
              [142.02857506600003, 47.232489325000074],
              [141.9843856130001, 47.28302643400008],
              [141.9751082690001, 47.29759349200003],
              [141.97608483200008, 47.31073639500005],
              [141.98780358200008, 47.34174225500004],
              [141.9907332690001, 47.35716380400004],
              [141.9912215500001, 47.369574286000045],
              [141.98715254, 47.38080475500004],
              [141.9775496750001, 47.39288971600007],
              [141.96371504, 47.415676174000055],
              [141.95525149800005, 47.446966864000046],
              [141.9516707690001, 47.48114655200004],
              [141.96045983200008, 47.591782945000034],
              [141.9658309250001, 47.612494208000044],
              [142.00147545700008, 47.66380442900004],
              [142.00367272200003, 47.675482489000046],
              [142.00375410200002, 47.686712958000044],
              [142.00538170700008, 47.69741445500006],
              [142.0117293630001, 47.70758698100008],
              [142.02613366000003, 47.72304922100005],
              [142.03337649800005, 47.73309967700004],
              [142.0361434250001, 47.74266185100004],
              [142.03980553500003, 47.74990469000005],
              [142.062836134, 47.77993398600006],
              [142.09302819100003, 47.85561758000006],
              [142.10572350400003, 47.87482330900008],
              [142.13795006600003, 47.891058661000045],
              [142.17741946700005, 47.93040599200003],
              [142.18702233200008, 47.94440338700008],
              [142.19109134200005, 47.96674225500004],
              [142.1723738940001, 48.09833405200004],
              [142.16586347700002, 48.11570872600004],
              [142.17400149800005, 48.15131256700005],
              [142.1386824880001, 48.318060614000046],
              [142.133148634, 48.333685614000046],
              [142.097015821, 48.39687734600005],
              [141.91960696700005, 48.60911692900004],
              [141.8730574880001, 48.68854401200008],
              [141.85670006600003, 48.73533763200004],
              [141.8574324880001, 48.77423737200007],
              [141.92302493600005, 48.83567942900004],
              [141.93116295700008, 48.83930084800005],
              [141.96013431100005, 48.85659414300005],
              [141.9672957690001, 48.86237213700008],
              [141.9687606130001, 48.87335846600007],
              [141.9658309250001, 48.885199286000045],
              [141.961761915, 48.89606354400007],
              [141.96045983200008, 48.903998114000046],
              [141.96558678500003, 48.915228583000044],
              [141.9736434250001, 48.92283763200004],
              [141.991547071, 48.93439362200007],
              [141.996429884, 48.94293854400007],
              [142.00025475400003, 48.966498114000046],
              [142.0087996750001, 48.984076239000046],
              [142.01514733200008, 49.020697333000044],
              [142.0244246750001, 49.04173411700003],
              [142.0361434250001, 49.06167226800005],
              [142.0239363940001, 49.099310614000046],
              [142.03736412900003, 49.13426341400009],
              [142.06039472700002, 49.16705963700008],
              [142.0771590500001, 49.19818756700005],
              [142.07992597700002, 49.21596914300005],
              [142.0786238940001, 49.23200104400007],
              [142.062836134, 49.314886786000045],
              [142.08765709700003, 49.377020575000074],
              [142.0962020190001, 49.41083405200004],
              [142.1196395190001, 49.44765859600005],
              [142.1250106130001, 49.46230703300006],
              [142.12818444100003, 49.50039297100005],
              [142.14226321700005, 49.568060614000046],
              [142.14771569100003, 49.623032945000034],
              [142.15748131600003, 49.65961334800005],
              [142.15967858200008, 49.67796458500004],
              [142.1523543630001, 49.73383209800005],
              [142.15447024800005, 49.790269273000035],
              [142.15186608200008, 49.825506903000075],
              [142.14242597700002, 49.86078522300005],
              [142.1250106130001, 49.897650458000044],
              [142.1318465500001, 49.897650458000044],
              [142.13445071700005, 49.90444570500006],
              [142.1435653000001, 49.91547272300005],
              [142.1455184250001, 49.921576239000046],
              [142.14437910200002, 49.92747630400004],
              [142.1396590500001, 49.936835028000075],
              [142.1386824880001, 49.94179922100005],
              [142.14185631600003, 49.95368073100008],
              [142.15650475400003, 49.968817450000074],
              [142.15967858200008, 49.97650788000004],
              [142.15748131600003, 50.01439036700003],
              [142.15886478000004, 50.02838776200008],
              [142.16586347700002, 50.048529364000046],
              [142.1738387380001, 50.08641185100004],
              [142.15552819100003, 50.23965078300006],
              [142.1352645190001, 50.29120514500005],
              [142.14673912900003, 50.30878327000005],
              [142.1508895190001, 50.32721588700008],
              [142.15007571700005, 50.345689195000034],
              [142.1455184250001, 50.36383698100008],
              [142.139008009, 50.37929922100005],
              [142.11736087300005, 50.417629299000055],
              [142.09929446700005, 50.43374258000006],
              [142.04517662900003, 50.52826569200005],
              [142.041351759, 50.55097077000005],
              [142.0532332690001, 50.572333075000074],
              [142.0571395190001, 50.58148834800005],
              [142.05787194100003, 50.59467194200005],
              [142.0566512380001, 50.61709219000005],
              [142.062836134, 50.65802643400008],
              [142.0927840500001, 50.714097398000035],
              [142.1045028000001, 50.780951239000046],
              [142.10271243600005, 50.78961823100008],
              [142.09880618600005, 50.79950592700004],
              [142.09595787900003, 50.81037018400008],
              [142.097015821, 50.821926174000055],
              [142.10271243600005, 50.830511786000045],
              [142.12281334700003, 50.85224030200004],
              [142.12842858200008, 50.856634833000044],
              [142.12916100400003, 50.86127350500004],
              [142.12525475400003, 50.88450755400004],
              [142.12842858200008, 50.894517320000034],
              [142.20069420700008, 50.95966217700004],
              [142.2255965500001, 50.99127838700008],
              [142.24984785200002, 51.03082916900007],
              [142.26685631600003, 51.074286200000074],
              [142.26921634200005, 51.11241282800006],
              [142.26636803500003, 51.135646877000056],
              [142.25513756600003, 51.15912506700005],
              [142.17302493600005, 51.25849030200004],
              [142.16586347700002, 51.27838776200008],
              [142.16822350400003, 51.285589911000045],
              [142.17798912900003, 51.29751211100006],
              [142.1801863940001, 51.30573151200008],
              [142.17855879, 51.314154364000046],
              [142.17497806100005, 51.317572333000044],
              [142.170258009, 51.31928131700005],
              [142.16586347700002, 51.32282135600008],
              [142.15886478000004, 51.33197663000004],
              [142.114593946, 51.37262604400007],
              [142.0771590500001, 51.41901276200008],
              [142.09782962300005, 51.44330475500004],
              [142.078949415, 51.47138092700004],
              [141.942718946, 51.55927155200004],
              [141.9326278000001, 51.57025788000004],
              [141.93327884200005, 51.574652411000045],
              [141.93775475400003, 51.57904694200005],
              [141.9399520190001, 51.59780508000006],
              [141.941742384, 51.60521067900004],
              [141.93921959700003, 51.61188385600008],
              [141.9262801440001, 51.61701080900008],
              [141.88795006600003, 51.61082591400009],
              [141.86670983200008, 51.61245351800005],
              [141.8520613940001, 51.63654205900008],
              [141.81714928500003, 51.67226797100005],
              [141.703461134, 51.72402578300006],
              [141.68677819100003, 51.747300523000035],
              [141.75171959700003, 51.728949286000045],
              [141.7871199880001, 51.72483958500004],
              [141.79802493600005, 51.72150299700007],
              [141.80811608200008, 51.72085195500006],
              [141.81714928500003, 51.72687409100007],
              [141.82252037900003, 51.73615143400008],
              [141.82300866000003, 51.744208075000074],
              [141.8188582690001, 51.750433661000045],
              [141.80974368600005, 51.754787502000056],
              [141.8095809250001, 51.80621979400007],
              [141.76099694100003, 51.83588288000004],
              [141.69410241000003, 51.857489325000074],
              [141.639008009, 51.88450755400004],
              [141.67554772200003, 51.91242096600007],
              [141.676117384, 51.95262278900003],
              [141.65211022200003, 52.03192780200004],
              [141.64966881600003, 52.05231354400007],
              [141.645843946, 52.06867096600007],
              [141.6450301440001, 52.08478424700007],
              [141.65211022200003, 52.10423411700003],
              [141.65788821700005, 52.11115143400008],
              [141.67693118600005, 52.12767161700003],
              [141.68311608200008, 52.130926825000074],
              [141.68775475400003, 52.13540273600006],
              [141.69988040500004, 52.165716864000046],
              [141.65894616000003, 52.21662018400008],
              [141.6718856130001, 52.259833075000074],
              [141.67310631600003, 52.27558014500005],
              [141.6645613940001, 52.292181708000044],
              [141.6508895190001, 52.30536530200004],
              [141.64185631600003, 52.31818268400008],
              [141.65211022200003, 52.34048086100006],
              [141.6528426440001, 52.349595445000034],
              [141.65211022200003, 52.36774323100008],
              [141.6547957690001, 52.37555573100008],
              [141.660980665, 52.382473049000055],
              [141.75749759200005, 52.445013739000046],
              [141.78296959700003, 52.46735260600008],
              [141.79175866000003, 52.48257070500006],
              [141.80486087300005, 52.51943594000005],
              [141.813324415, 52.53278229400007],
              [141.81666100400003, 52.540716864000046],
              [141.81714928500003, 52.55072663000004],
              [141.81910241000003, 52.55927155200004],
              [141.82699629, 52.562933661000045],
              [141.8305770190001, 52.566473700000074],
              [141.8437606130001, 52.59080638200004],
              [141.83472741000003, 52.59162018400008],
              [141.80974368600005, 52.597723700000074],
              [141.80974368600005, 52.60390859600005],
              [141.8344832690001, 52.634100653000075],
              [141.84302819100003, 52.66876862200007],
              [141.8437606130001, 52.74103424700007],
              [141.84945722700002, 52.76251862200007],
              [141.86793053500003, 52.79474518400008],
              [141.87183678500003, 52.81679922100005],
              [141.87077884200005, 52.82318756700005],
              [141.8662215500001, 52.84023672100005],
              [141.86500084700003, 52.850897528000075],
              [141.8657332690001, 52.860256252000056],
              [141.87061608200008, 52.87885163000004],
              [141.87183678500003, 52.88882070500006],
              [141.8750106130001, 52.89516836100006],
              [141.88949629, 52.91201406500005],
              [141.89283287900003, 52.92291901200008],
              [141.89177493600005, 52.94440338700008],
              [141.89242597700002, 52.95538971600007],
              [141.89600670700008, 52.96393463700008],
              [141.92009524800005, 52.998032945000034],
              [141.92839603000004, 53.02065664300005],
              [141.92302493600005, 53.03929271000004],
              [141.91944420700008, 53.046128648000035],
              [141.91627037900003, 53.056708075000074],
              [141.91334069100003, 53.073431708000044],
              [141.90894616000003, 53.07953522300005],
              [141.88982181100005, 53.09829336100006],
              [141.8789168630001, 53.11977773600006],
              [141.84782962300005, 53.14752838700008],
              [141.83757571700005, 53.159409898000035],
              [141.83375084700003, 53.169134833000044],
              [141.83423912900003, 53.17715078300006],
              [141.836273634, 53.18573639500005],
              [141.83757571700005, 53.197251695000034],
              [141.83668053500003, 53.20978424700007],
              [141.83366946700005, 53.21775950700004],
              [141.80339603000004, 53.27138906500005],
              [141.8037215500001, 53.28571198100008],
              [141.81714928500003, 53.302801825000074],
              [141.80779056100005, 53.31305573100008],
              [141.80738366000003, 53.32265859600005],
              [141.809906446, 53.330959377000056],
              [141.80974368600005, 53.337591864000046],
              [141.8007918630001, 53.34747955900008],
              [141.76880944100003, 53.37164948100008],
              [141.79607181100005, 53.38703034100007],
              [141.88542728000004, 53.41266510600008],
              [141.942718946, 53.450506903000075],
              [141.9570418630001, 53.456284898000035],
              [142.0083113940001, 53.46108633000006],
              [142.09400475400003, 53.49428945500006],
              [142.24105879, 53.529364325000074],
              [142.22974694100003, 53.520819403000075],
              [142.23560631600003, 53.511053778000075],
              [142.24773196700005, 53.50018952000005],
              [142.25538170700008, 53.488348700000074],
              [142.25212649800005, 53.47443268400008],
              [142.244476759, 53.46393463700008],
              [142.24236087300005, 53.453558661000045],
              [142.25538170700008, 53.43992747600004],
              [142.24105879, 53.43211497600004],
              [142.23707116000003, 53.419989325000074],
              [142.24048912900003, 53.40615469000005],
              [142.2485457690001, 53.39276764500005],
              [142.26392662900003, 53.380072333000044],
              [142.28484134200005, 53.37140534100007],
              [142.30738366000003, 53.366400458000044],
              [142.32740319100003, 53.364894924000055],
              [142.34693444100003, 53.366400458000044],
              [142.39242597700002, 53.37848541900007],
              [142.43433678500003, 53.378159898000035],
              [142.45533287900003, 53.38027578300006],
              [142.52116946700005, 53.420355536000045],
              [142.53394616000003, 53.446478583000044],
              [142.563812696, 53.488348700000074],
              [142.5766707690001, 53.500067450000074],
              [142.62525475400003, 53.52594635600008],
              [142.6425887380001, 53.52708567900004],
              [142.65967858200008, 53.52094147300005],
              [142.67530358200008, 53.51821523600006],
              [142.68726647200003, 53.529364325000074],
              [142.66627037900003, 53.55263906500005],
              [142.6289168630001, 53.56907786700003],
              [142.58619225400003, 53.575832424000055],
              [142.54957116000003, 53.570298570000034],
              [142.5263778000001, 53.55023834800005],
              [142.514008009, 53.54559967700004],
              [142.50855553500003, 53.559759833000044],
              [142.508148634, 53.56403229400007],
              [142.5087996750001, 53.59125397300005],
              [142.51197350400003, 53.59446849200003],
              [142.4980574880001, 53.61562734600005],
              [142.4926863940001, 53.63808828300006],
              [142.49773196700005, 53.658270575000074],
              [142.51539147200003, 53.672756252000056],
              [142.53337649800005, 53.676214911000045],
              [142.55054772200003, 53.67365143400008],
              [142.56804446700005, 53.66901276200008],
              [142.58708743600005, 53.66648997600004],
              [142.6035262380001, 53.670355536000045],
              [142.62281334700003, 53.67763906500005],
              [142.64136803500003, 53.68178945500006],
              [142.65601647200003, 53.67645905200004],
              [142.67945397200003, 53.65106842700004],
              [142.69800866000003, 53.63816966400003],
              [142.71851647200003, 53.64020416900007],
              [142.80005944100003, 53.69757721600007],
              [142.80445397200003, 53.70697663000004],
              [142.8027449880001, 53.71771881700005],
              [142.7988387380001, 53.72870514500005],
              [142.79664147200003, 53.73851146000004],
              [142.79175866000003, 53.78351471600007],
              [142.78532962300005, 53.80581289300005],
              [142.77613366000003, 53.82416413000004],
              [142.739105665, 53.845689195000034],
              [142.71314537900003, 53.80914948100008],
              [142.692718946, 53.75263092700004],
              [142.67310631600003, 53.71430084800005],
              [142.65967858200008, 53.70856354400007],
              [142.61402428500003, 53.69603099200003],
              [142.60417728000004, 53.69757721600007],
              [142.6074324880001, 53.709051825000074],
              [142.6220809250001, 53.72846100500004],
              [142.63249759200005, 53.75568268400008],
              [142.67994225400003, 53.81732819200005],
              [142.7060653000001, 53.86432526200008],
              [142.71851647200003, 53.90729401200008],
              [142.70826256600003, 53.94822825700004],
              [142.66627037900003, 53.98924388200004],
              [142.58863366000003, 54.04511139500005],
              [142.54420006600003, 54.089097398000035],
              [142.46753991000003, 54.145697333000044],
              [142.45134524800005, 54.16640859600005],
              [142.42562910200002, 54.21124909100007],
              [142.409515821, 54.231634833000044],
              [142.3828231130001, 54.25275299700007],
              [142.348968946, 54.271918036000045],
              [142.282562696, 54.29718659100007],
              [142.282562696, 54.303941148000035],
              [142.30494225400003, 54.301947333000044],
              [142.34498131600003, 54.281683661000045],
              [142.3652449880001, 54.276597398000035],
              [142.4433699880001, 54.269191799000055],
              [142.46550540500004, 54.272365627000056],
              [142.52906334700003, 54.29718659100007],
            ],
          ],
          [
            [
              [28.634613477000073, 60.60138580900008],
              [28.599457227000073, 60.57664622600004],
              [28.57553144600007, 60.58038971600007],
              [28.561696811000047, 60.59446849200003],
              [28.556651238000086, 60.61200592700004],
              [28.56104576900009, 60.62946198100008],
              [28.57553144600007, 60.64305247600004],
              [28.588715040000068, 60.64630768400008],
              [28.604502800000034, 60.64500560100004],
              [28.617849155000044, 60.63922760600008],
              [28.623383009000065, 60.62848541900007],
              [28.631032748000052, 60.617621161000045],
              [28.634613477000073, 60.60138580900008],
            ],
          ],
          [
            [
              [-172.2430960069999, 64.81594233400006],
              [-172.11256257699992, 64.79049780000008],
              [-172.0433560109999, 64.75118299700006],
              [-172.1796096239999, 64.73821910700008],
              [-172.27872694299992, 64.71351763000007],
              [-172.3847247139999, 64.69848106200004],
              [-172.50089733299993, 64.70428798900008],
              [-172.5468039289999, 64.68538553700006],
              [-172.63319292999992, 64.68443931500008],
              [-172.6087501099999, 64.73083326200003],
              [-172.5774488399999, 64.75949953800006],
              [-172.5234842989999, 64.78797481300006],
              [-172.4845660899999, 64.81494769000005],
              [-172.4613440789999, 64.82759459800008],
              [-172.4005204849999, 64.83669621900003],
              [-172.3290757839999, 64.83122512500006],
              [-172.2430960069999, 64.81594233400006],
            ],
          ],
          [
            [
              [70.13062584700003, 66.55634186400005],
              [70.10694420700008, 66.55744049700007],
              [70.08366946700005, 66.56195709800005],
              [70.06153405000003, 66.56207916900007],
              [70.04127037900008, 66.55011627800008],
              [70.06592858200008, 66.55190664300005],
              [70.08668053500008, 66.54852936400005],
              [70.09669030000003, 66.53896719000005],
              [70.08912194100003, 66.52220286700003],
              [70.08497155000003, 66.52073802300004],
              [70.05469811300009, 66.50482819200005],
              [70.04363040500004, 66.50128815300008],
              [69.95191491000008, 66.50088125200006],
              [69.89779707100007, 66.49494049700007],
              [69.89039147200003, 66.48993561400005],
              [69.88510175900007, 66.48236725500004],
              [69.87964928500008, 66.47695547100005],
              [69.87061608200008, 66.47785065300008],
              [69.85914147200003, 66.48175690300008],
              [69.83529707100007, 66.48883698100008],
              [69.82349694100003, 66.49371979400007],
              [69.74708092500003, 66.52846914300005],
              [69.54542076900003, 66.59100983300004],
              [69.53760826900003, 66.60138580900008],
              [69.54517662900008, 66.60443756700005],
              [69.55437259200005, 66.60382721600007],
              [69.56446373800009, 66.60439687700006],
              [69.57520592500003, 66.61098867400005],
              [69.57341556100005, 66.63133372600004],
              [69.57520592500003, 66.63825104400007],
              [69.54566491000008, 66.65924713700008],
              [69.50310306100005, 66.70864492400005],
              [69.42457116000008, 66.76837799700007],
              [69.40447024800005, 66.77606842700004],
              [69.37403405000003, 66.77814362200007],
              [69.28101647200003, 66.76178620000007],
              [69.29086347700007, 66.75120677300004],
              [69.29460696700005, 66.74811432500007],
              [69.25709069100003, 66.74628327000005],
              [69.20118248800009, 66.75702545800004],
              [69.15088951900003, 66.77537669500003],
              [69.13070722700007, 66.79657623900005],
              [69.14625084700003, 66.80975983300004],
              [69.17758222700007, 66.81142812700006],
              [69.27979576900003, 66.79450104400007],
              [69.30274498800009, 66.79413483300004],
              [69.42546634200005, 66.80670807500007],
              [69.47299238400007, 66.79767487200007],
              [69.50025475400008, 66.75214264500005],
              [69.51677493600005, 66.73895905200004],
              [69.57439212300005, 66.70892975500004],
              [69.60450280000003, 66.69953034100007],
              [69.63550866000008, 66.69383372600004],
              [69.66456139400003, 66.69354889500005],
              [69.64576256600003, 66.70551178600005],
              [69.57520592500003, 66.73139069200005],
              [69.56080162900008, 66.73993561400005],
              [69.54468834700003, 66.75238678600005],
              [69.54037519600007, 66.76365794500003],
              [69.56153405000003, 66.76862213700008],
              [69.67139733200008, 66.76178620000007],
              [69.72738691500007, 66.76557038000004],
              [69.75562584700003, 66.76215241100005],
              [69.78126061300009, 66.74811432500007],
              [69.76189212300005, 66.74201080900008],
              [69.75391686300009, 66.74192942900004],
              [69.77466881600003, 66.73525625200006],
              [69.85499108200008, 66.72768789300005],
              [69.87964928500008, 66.72919342700004],
              [69.89112389400003, 66.72768789300005],
              [69.90007571700005, 66.72333405200004],
              [69.91602623800009, 66.71100495000007],
              [69.92530358200008, 66.70722077000005],
              [69.96436608200008, 66.70644765800006],
              [70.00757897200003, 66.71067942900004],
              [70.04981530000003, 66.70892975500004],
              [70.08570397200003, 66.69013092700004],
              [70.08570397200003, 66.68211497600004],
              [70.07545006600003, 66.65192291900007],
              [70.07634524800005, 66.64915599200003],
              [70.07886803500008, 66.64484284100007],
              [70.07984459700003, 66.63910553600005],
              [70.07545006600003, 66.63206614800004],
              [70.06544030000003, 66.63007233300004],
              [70.05062910200007, 66.63182200700004],
              [70.03614342500003, 66.63202545800004],
              [70.02711022200003, 66.62523021000004],
              [70.03923587300005, 66.60789622600004],
              [70.11150149800005, 66.56997304900005],
              [70.13062584700003, 66.55634186400005],
            ],
          ],
          [
            [
              [51.299571160000085, 68.49542877800008],
              [51.49830162900008, 68.48859284100007],
              [51.45980879000007, 68.47394440300008],
              [51.17237389400003, 68.45709870000007],
              [51.09742272200003, 68.42523834800005],
              [50.998789910000085, 68.42536041900007],
              [50.93726647200003, 68.39647044500003],
              [50.89112389400003, 68.39459870000007],
              [50.869151238000086, 68.39101797100005],
              [50.85010826900003, 68.38495514500005],
              [50.832041863000086, 68.38149648600006],
              [50.79249108200008, 68.37929922100005],
              [50.801442905000044, 68.38955312700006],
              [50.811289910000085, 68.39813873900005],
              [50.822276238000086, 68.40534088700008],
              [50.871836785000085, 68.42829010600008],
              [51.17172285200007, 68.50145091400003],
              [51.299571160000085, 68.49542877800008],
            ],
          ],
          [
            [
              [55.369476759000065, 68.94790273600006],
              [55.442393425000034, 68.94037506700005],
              [55.48023522200003, 68.93032461100006],
              [55.506602410000085, 68.91376373900005],
              [55.36670983200008, 68.92739492400005],
              [55.25912519600007, 68.91290924700007],
              [55.22543379000007, 68.91376373900005],
              [55.23975670700008, 68.92739492400005],
              [55.24659264400003, 68.92739492400005],
              [55.338552280000044, 68.94635651200008],
              [55.369476759000065, 68.94790273600006],
            ],
          ],
          [
            [
              [54.643321160000085, 69.00934479400007],
              [54.66032962300005, 69.00873444200005],
              [54.67994225400008, 69.00551992400005],
              [54.69483483200008, 68.99725983300004],
              [54.697927280000044, 68.98200104400007],
              [54.68572024800005, 68.96869538000004],
              [54.66382897200003, 68.96063873900005],
              [54.64014733200008, 68.95648834800005],
              [54.602549675000034, 68.95457591400003],
              [54.58025149800005, 68.95746491100005],
              [54.57081139400003, 68.96405670800004],
              [54.588633660000085, 68.97516510600008],
              [54.59546959700003, 68.97516510600008],
              [54.61670983200008, 68.99725983300004],
              [54.628916863000086, 69.00584544500003],
              [54.643321160000085, 69.00934479400007],
            ],
          ],
          [
            [
              [161.48707116000003, 69.02667877800008],
              [161.5175887380001, 68.97988515800006],
              [161.514984571, 68.93463776200008],
              [161.48210696700005, 68.90216705900008],
              [161.422211134, 68.89325592700004],
              [161.4091903000001, 68.89325592700004],
              [161.42310631600003, 68.91474030200004],
              [161.4619246750001, 68.95302969000005],
              [161.477386915, 68.97516510600008],
              [161.4555770190001, 69.00096263200004],
              [161.4218856130001, 69.02155182500007],
              [161.38355553500003, 69.03778717700004],
              [161.305511915, 69.06024811400005],
              [161.141449415, 69.08734772300005],
              [161.1347762380001, 69.09186432500007],
              [161.13445071700005, 69.09788646000004],
              [161.13689212300005, 69.10431549700007],
              [161.13990319100003, 69.10976797100005],
              [161.1416121750001, 69.11440664300005],
              [161.140961134, 69.13279857000003],
              [161.1386824880001, 69.13768138200004],
              [161.127289259, 69.15395742400005],
              [161.121918165, 69.16766998900005],
              [161.1215926440001, 69.17479075700004],
              [161.13160241000003, 69.21698639500005],
              [161.131195509, 69.22626373900005],
              [161.127289259, 69.23525625200006],
              [161.12956790500004, 69.23822663000004],
              [161.1318465500001, 69.24022044500003],
              [161.13404381600003, 69.24241771000004],
              [161.14039147200003, 69.26919179900005],
              [161.164398634, 69.30540599200003],
              [161.1689559250001, 69.32526276200008],
              [161.1513778000001, 69.35464101800005],
              [161.08155358200008, 69.39297109600005],
              [161.06592858200008, 69.41742584800005],
              [161.0732528000001, 69.44501373900005],
              [161.09245853000004, 69.46478913000004],
              [161.11890709700003, 69.47846100500004],
              [161.2539168630001, 69.52362702000005],
              [161.26099694100003, 69.52753327000005],
              [161.26823978000004, 69.53375885600008],
              [161.27849368600005, 69.53815338700008],
              [161.30640709700003, 69.53729889500005],
              [161.31861412900003, 69.53888580900008],
              [161.33741295700008, 69.54564036700003],
              [161.3579207690001, 69.55011627800008],
              [161.37452233200008, 69.54588450700004],
              [161.38795006600003, 69.50747304900005],
              [161.38990319100003, 69.49648672100005],
              [161.38168379, 69.47874583500004],
              [161.385101759, 69.47304922100005],
              [161.38933353000004, 69.46775950700004],
              [161.3886824880001, 69.46181875200006],
              [161.3818465500001, 69.45612213700008],
              [161.31430097700002, 69.43724192900004],
              [161.29712975400003, 69.42829010600008],
              [161.29249108200008, 69.41400788000004],
              [161.30534915500004, 69.40070221600007],
              [161.35084069100003, 69.38043854400007],
              [161.360687696, 69.36277903900003],
              [161.3579207690001, 69.35008372600004],
              [161.35303795700008, 69.34076569200005],
              [161.35108483200008, 69.33209870000007],
              [161.374359571, 69.29604726800005],
              [161.36736087300005, 69.27899811400005],
              [161.31910241000003, 69.24266185100004],
              [161.33472741000003, 69.22459544500003],
              [161.374359571, 69.20376211100006],
              [161.3886824880001, 69.18805573100008],
              [161.38111412900003, 69.18060944200005],
              [161.38746178500003, 69.16250234600005],
              [161.38550866000003, 69.11904531500005],
              [161.39177493600005, 69.10211823100008],
              [161.41391035200002, 69.08136627800008],
              [161.48707116000003, 69.02667877800008],
            ],
          ],
          [
            [
              [161.63111412900003, 69.56110260600008],
              [161.6240340500001, 69.55341217700004],
              [161.6157332690001, 69.53998444200005],
              [161.61052493600005, 69.53375885600008],
              [161.60767662900003, 69.51703522300005],
              [161.61988366000003, 69.49949778900003],
              [161.62671959700003, 69.48285553600005],
              [161.60718834700003, 69.46865469000005],
              [161.6157332690001, 69.45038483300004],
              [161.58855228000004, 69.43618398600006],
              [161.54835045700008, 69.42621491100005],
              [161.4101668630001, 69.41551341400003],
              [161.3750106130001, 69.40778229400007],
              [161.3750106130001, 69.41400788000004],
              [161.360687696, 69.41400788000004],
              [161.3730574880001, 69.42715078300006],
              [161.40886478000004, 69.44147370000007],
              [161.422211134, 69.45433177300004],
              [161.42562910200002, 69.46499258000006],
              [161.42847741000003, 69.51276276200008],
              [161.42758222700002, 69.52130768400008],
              [161.415375196, 69.54433828300006],
              [161.4023543630001, 69.58079661700003],
              [161.39478600400003, 69.59210846600007],
              [161.45427493600005, 69.60236237200007],
              [161.46314537900003, 69.60919830900008],
              [161.46412194100003, 69.62116120000007],
              [161.46762129, 69.63117096600007],
              [161.4751082690001, 69.63800690300008],
              [161.4873153000001, 69.64057038000004],
              [161.52466881600003, 69.63873932500007],
              [161.5590926440001, 69.63202545800004],
              [161.59009850400003, 69.61839427300004],
              [161.61736087300005, 69.59589264500005],
              [161.63209069100003, 69.57973867400005],
              [161.63550866000003, 69.57029857000003],
              [161.63111412900003, 69.56110260600008],
            ],
          ],
          [
            [
              [71.35336347700007, 73.38519928600005],
              [71.33318118600005, 73.37287018400008],
              [71.32984459700003, 73.36782461100006],
              [71.33277428500008, 73.36090729400007],
              [71.34717858200008, 73.35228099200003],
              [71.34961998800009, 73.34731679900005],
              [71.34253991000008, 73.33136627800008],
              [71.33155358200008, 73.32705312700006],
              [71.31657962300005, 73.32721588700008],
              [71.29664147200003, 73.32477448100008],
              [71.26417076900003, 73.31492747600004],
              [71.25180097700007, 73.30792877800008],
              [71.23707116000008, 73.29580312700006],
              [71.21412194100003, 73.28506094000005],
              [71.18864993600005, 73.28583405200004],
              [71.16236412900008, 73.29083893400008],
              [71.13746178500008, 73.29266998900005],
              [71.14869225400008, 73.30097077000005],
              [71.14991295700008, 73.31232330900008],
              [71.14429772200003, 73.34052155200004],
              [71.14380944100003, 73.34731679900005],
              [71.16537519600007, 73.36416250200006],
              [71.21680748800009, 73.38670482000003],
              [71.22681725400008, 73.39883047100005],
              [71.24952233200008, 73.41787344000005],
              [71.29802493600005, 73.41600169500003],
              [71.34253991000008, 73.40228913000004],
              [71.35336347700007, 73.38519928600005],
            ],
          ],
          [
            [
              [51.40951582100007, 71.80613841400003],
              [51.401377800000034, 71.87051015800006],
              [51.43962649800005, 71.94220612200007],
              [51.50025475400008, 72.00568268400008],
              [51.56031334700003, 72.04511139500005],
              [51.55290774800005, 72.05255768400008],
              [51.610036655000044, 72.09170156500005],
              [51.74781334700003, 72.12250397300005],
              [51.84310957100007, 72.15794505400004],
              [51.86573326900003, 72.15867747600004],
              [51.956065300000034, 72.11505768400008],
              [51.97282962300005, 72.10944245000007],
              [51.98991946700005, 72.10712311400005],
              [52.053070509000065, 72.10781484600005],
              [52.04867597700007, 72.08466217700004],
              [52.066742384000065, 72.07428620000007],
              [52.09001712300005, 72.07607656500005],
              [52.11670983200008, 72.10765208500004],
              [52.15088951900003, 72.12173086100006],
              [52.18775475400008, 72.12921784100007],
              [52.21078535200007, 72.12763092700004],
              [52.19743899800005, 72.11147695500006],
              [52.19125410200007, 72.10171133000006],
              [52.18970787900008, 72.09349192900004],
              [52.20036868600005, 72.08274974200003],
              [52.21810957100007, 72.08567942900004],
              [52.238942905000044, 72.09149811400005],
              [52.258148634000065, 72.08978913000004],
              [52.29704837300005, 72.07453034100007],
              [52.33228600400008, 72.07062409100007],
              [52.36841881600009, 72.07534414300005],
              [52.40943444100009, 72.08608633000006],
              [52.389414910000085, 72.09284088700008],
              [52.38257897200003, 72.10521067900004],
              [52.38917076900003, 72.11847565300008],
              [52.40943444100009, 72.12763092700004],
              [52.39828535200007, 72.13544342700004],
              [52.38412519600007, 72.14301178600005],
              [52.37240644600007, 72.15159739800004],
              [52.36841881600009, 72.16242096600007],
              [52.383148634000065, 72.17169830900008],
              [52.41325931100005, 72.16803620000007],
              [52.46461022200003, 72.15497467700004],
              [52.48414147200003, 72.15753815300008],
              [52.49008222700007, 72.16421133000006],
              [52.48324629000007, 72.17413971600007],
              [52.40202884200005, 72.22321198100008],
              [52.42505944100009, 72.23143138200004],
              [52.44483483200008, 72.22858307500007],
              [52.48454837300005, 72.20962148600006],
              [52.479258660000085, 72.21417877800008],
              [52.46461022200003, 72.23065827000005],
              [52.471690300000034, 72.23338450700004],
              [52.48462975400008, 72.24140045800004],
              [52.49138431100005, 72.24433014500005],
              [52.478526238000086, 72.25482819200005],
              [52.46371504000007, 72.26080963700008],
              [52.44752037900008, 72.26357656500005],
              [52.43018639400003, 72.26422760600008],
              [52.41358483200008, 72.26951732000003],
              [52.41000410200007, 72.28042226800005],
              [52.41651451900003, 72.28929271000004],
              [52.42994225400008, 72.28872304900005],
              [52.465830925000034, 72.27558014500005],
              [52.54737389400003, 72.26496002800008],
              [52.58757571700005, 72.26422760600008],
              [52.582367384000065, 72.26723867400005],
              [52.57276451900003, 72.27472565300008],
              [52.567067905000044, 72.27789948100008],
              [52.593760613000086, 72.29096100500004],
              [52.66879316500007, 72.30638255400004],
              [52.684336785000085, 72.32257721600007],
              [52.66928144600007, 72.34536367400005],
              [52.60010826900003, 72.35541413000004],
              [52.580739780000044, 72.37409088700008],
              [52.650401238000086, 72.35516998900005],
              [52.72291100400008, 72.34516022300005],
              [52.868174675000034, 72.34674713700008],
              [52.84782962300005, 72.35431549700007],
              [52.779307488000086, 72.35419342700004],
              [52.71257571700005, 72.36652252800008],
              [52.68995201900003, 72.36717357000003],
              [52.70362389400003, 72.38617584800005],
              [52.69223066500007, 72.40029531500005],
              [52.67335045700008, 72.41327545800004],
              [52.66334069100009, 72.42869700700004],
              [52.68409264400003, 72.44692617400005],
              [52.78467858200008, 72.44619375200006],
              [52.820323113000086, 72.45038483300004],
              [52.76107832100007, 72.47435130400004],
              [52.72966556100005, 72.47980377800008],
              [52.67937259200005, 72.47150299700007],
              [52.680023634000065, 72.47874583500004],
              [52.68864993600005, 72.48944733300004],
              [52.69743899800005, 72.49762604400007],
              [52.71241295700008, 72.50592682500007],
              [52.73015384200005, 72.51093170800004],
              [52.746836785000085, 72.51097239800004],
              [52.75831139400003, 72.50438060100004],
              [52.83350670700008, 72.51064687700006],
              [52.86890709700003, 72.51874420800004],
              [52.868174675000034, 72.53856028900003],
              [52.881846550000034, 72.54824453300006],
              [52.93018639400003, 72.55902741100005],
              [52.924489780000044, 72.56232330900008],
              [52.90967858200008, 72.57330963700008],
              [52.95476321700005, 72.57770416900007],
              [52.998383009000065, 72.58698151200008],
              [53.07748457100007, 72.59357330900008],
              [53.10206139400003, 72.60065338700008],
              [52.91423587300005, 72.59699127800008],
              [52.76490319100009, 72.56037018400008],
              [52.72396894600007, 72.55902741100005],
              [52.73560631600009, 72.57713450700004],
              [52.75212649800005, 72.59259674700007],
              [52.77173912900008, 72.60346100500004],
              [52.80600019600007, 72.60927969000005],
              [52.81177819100009, 72.61391836100006],
              [52.809336785000085, 72.61985911700003],
              [52.79818769600007, 72.62604401200008],
              [52.785492384000065, 72.62710195500006],
              [52.73845462300005, 72.62051015800006],
              [52.754893425000034, 72.63837311400005],
              [52.77979576900003, 72.64769114800004],
              [52.98023522200003, 72.67584870000007],
              [53.01303144600007, 72.67352936400005],
              [53.110118035000085, 72.64980703300006],
              [53.21810957100007, 72.64842357000003],
              [53.195974155000044, 72.65704987200007],
              [53.088552280000044, 72.66474030200004],
              [53.005869988000086, 72.68317291900007],
              [52.793711785000085, 72.68211497600004],
              [52.74691816500007, 72.67243073100008],
              [52.57504316500007, 72.67064036700003],
              [52.54664147200003, 72.67572663000004],
              [52.52898196700005, 72.68455638200004],
              [52.500010613000086, 72.70343659100007],
              [52.47828209700003, 72.70990631700005],
              [52.42432701900003, 72.71320221600007],
              [52.39763431100005, 72.71792226800005],
              [52.37525475400008, 72.73037344000005],
              [52.39405358200008, 72.75202057500007],
              [52.41920006600009, 72.75409577000005],
              [52.44548587300005, 72.75218333500004],
              [52.467784050000034, 72.76170482000003],
              [52.47234134200005, 72.76992422100005],
              [52.47779381600009, 72.78945547100005],
              [52.48454837300005, 72.79857005400004],
              [52.50017337300005, 72.80801015800006],
              [52.553477410000085, 72.82318756700005],
              [52.59595787900008, 72.85244375200006],
              [52.61670983200008, 72.86322663000004],
              [53.02686608200008, 72.92499420800004],
              [53.30844160200007, 72.87763092700004],
              [53.34815514400003, 72.87811920800004],
              [53.38200931100005, 72.88861725500004],
              [53.336924675000034, 72.89508698100008],
              [53.293304884000065, 72.90843333500004],
              [53.31723066500007, 72.91486237200007],
              [53.389414910000085, 72.90843333500004],
              [53.384776238000086, 72.91673411700003],
              [53.383555535000085, 72.92023346600007],
              [53.39568118600005, 72.92963288000004],
              [53.360118035000085, 72.93992747600004],
              [53.23178144600007, 72.93642812700006],
              [53.17156009200005, 72.94871653900003],
              [53.14193769600007, 72.96246979400007],
              [53.139333530000044, 72.98110586100006],
              [53.14185631600009, 72.98920319200005],
              [53.13892662900008, 72.99640534100007],
              [53.13689212300005, 73.00348541900007],
              [53.14242597700007, 73.01154205900008],
              [53.15284264400003, 73.01422760600008],
              [53.191742384000065, 73.01829661700003],
              [53.38200931100005, 73.01154205900008],
              [53.362315300000034, 73.01780833500004],
              [53.31853274800005, 73.02570221600007],
              [53.30014082100007, 73.03266022300005],
              [53.28882897200003, 73.04197825700004],
              [53.27947024800005, 73.05304596600007],
              [53.26929772200003, 73.06232330900008],
              [53.25570722700007, 73.06610748900005],
              [53.183604363000086, 73.06989166900007],
              [53.15154056100005, 73.08006419500003],
              [53.12191816500007, 73.10089752800008],
              [53.15381920700008, 73.10639069200005],
              [53.16130618600005, 73.11200592700004],
              [53.16342207100007, 73.12482330900008],
              [53.16000410200007, 73.14142487200007],
              [53.15479576900003, 73.14679596600007],
              [53.15560957100007, 73.15058014500005],
              [53.170258009000065, 73.16233958500004],
              [53.18970787900008, 73.17328522300005],
              [53.32252037900008, 73.22085195500006],
              [53.36736087300005, 73.22699616100005],
              [53.41163170700008, 73.24111562700006],
              [53.43384850400008, 73.24428945500006],
              [53.53272545700008, 73.22955963700008],
              [53.56080162900008, 73.23468659100007],
              [53.655039910000085, 73.27488841400003],
              [53.75318444100009, 73.29889557500007],
              [53.86182701900003, 73.30215078300006],
              [54.07960045700008, 73.27293528900003],
              [54.19076582100007, 73.27220286700003],
              [54.326182488000086, 73.30768463700008],
              [54.39698326900003, 73.31561920800004],
              [54.41374759200005, 73.32200755400004],
              [54.444102410000085, 73.34052155200004],
              [54.531993035000085, 73.37641022300005],
              [54.58545983200008, 73.38617584800005],
              [54.69450931100005, 73.39142487200007],
              [54.770192905000044, 73.41201406500005],
              [54.81771894600007, 73.41303131700005],
              [54.86963951900003, 73.42413971600007],
              [54.93482506600009, 73.42536041900007],
              [55.12549889400003, 73.39378489800004],
              [55.30420983200008, 73.33934153900003],
              [55.48975670700008, 73.32062409100007],
              [55.75806725400008, 73.32794830900008],
              [55.80836022200003, 73.31317780200004],
              [55.80909264400003, 73.30955638200004],
              [55.80746504000007, 73.29633209800005],
              [55.80836022200003, 73.29266998900005],
              [55.81804446700005, 73.29035065300008],
              [56.12663821700005, 73.26023997600007],
              [56.43523196700005, 73.23012929900005],
              [56.45329837300005, 73.22382233300004],
              [56.46452884200005, 73.21718984600005],
              [56.47868899800005, 73.20368073100008],
              [56.487315300000034, 73.19708893400008],
              [56.55990644600007, 73.16620514500005],
              [56.57943769600007, 73.15180084800005],
              [56.582041863000086, 73.12958405200004],
              [56.54835045700008, 73.12156810100004],
              [56.17835533950006, 73.09383779500004],
              [55.80836022200003, 73.06610748900005],
              [55.84392337300005, 73.05678945500006],
              [56.11548912850006, 73.06266917500005],
              [56.387054884000065, 73.06854889500005],
              [56.46615644600007, 73.05247630400004],
              [56.42953535200007, 73.02631256700005],
              [56.37720787900008, 73.00665924700007],
              [56.32195071700005, 72.99673086100006],
              [56.22543379000007, 73.00897858300004],
              [55.924489780000044, 72.98891836100006],
              [55.87663821700005, 72.97955963700008],
              [55.64226321700005, 72.97190989800004],
              [55.61646569100009, 72.96369049700007],
              [55.63851972700007, 72.96271393400008],
              [55.682383660000085, 72.95156484600005],
              [55.705821160000085, 72.95010000200006],
              [55.815114780000044, 72.95685455900008],
              [55.972666863000086, 72.94110748900005],
              [56.115977410000085, 72.96954987200007],
              [56.21241295700008, 72.97736237200007],
              [56.25180097700007, 72.97235748900005],
              [56.25505618600005, 72.95831940300008],
              [56.21989993600005, 72.90843333500004],
              [56.23812910200007, 72.89801666900007],
              [56.23796634200005, 72.88373444200005],
              [56.21989993600005, 72.85321686400005],
              [56.218760613000086, 72.84682851800005],
              [56.21924889400003, 72.82965729400007],
              [56.21989993600005, 72.82656484600005],
              [56.20850670700008, 72.82221100500004],
              [56.177744988000086, 72.81712474200003],
              [56.17139733200008, 72.80914948100008],
              [56.13795006600009, 72.78229401200008],
              [56.06267337300005, 72.77777741100005],
              [55.86736087300005, 72.80206940300008],
              [55.73853600400008, 72.78424713700008],
              [55.67115319100009, 72.78558991100005],
              [55.50359134200005, 72.80882396000004],
              [55.48072350400008, 72.80581289300005],
              [55.431651238000086, 72.78558991100005],
              [55.60279381600009, 72.78558991100005],
              [55.716807488000086, 72.75364817900004],
              [55.81072024800005, 72.75836823100008],
              [55.85954837300005, 72.73578522300005],
              [55.946055535000085, 72.66889069200005],
              [55.76392662900008, 72.67572663000004],
              [55.648773634000065, 72.70408763200004],
              [55.61646569100009, 72.69684479400007],
              [55.71924889400003, 72.65184153900003],
              [55.72348066500007, 72.63833242400005],
              [55.69076582100007, 72.62848541900007],
              [55.62273196700005, 72.62051015800006],
              [55.631602410000085, 72.60708242400005],
              [55.64861087300005, 72.59430573100008],
              [55.68482506600009, 72.57330963700008],
              [55.66928144600007, 72.56248607000003],
              [55.618174675000034, 72.54218170800004],
              [55.59880618600005, 72.53856028900003],
              [55.55160566500007, 72.54266998900005],
              [55.528005405000044, 72.54995351800005],
              [55.48796634200005, 72.57514069200005],
              [55.45687910200007, 72.58222077000005],
              [55.26710045700008, 72.58698151200008],
              [55.44898522200003, 72.56329987200007],
              [55.46566816500007, 72.53856028900003],
              [55.50473066500007, 72.53579336100006],
              [55.54273522200003, 72.52684153900003],
              [55.553070509000065, 72.52020905200004],
              [55.55225670700008, 72.51284414300005],
              [55.54078209700003, 72.49762604400007],
              [55.53891035200007, 72.48712799700007],
              [55.53931725400008, 72.47842031500005],
              [55.536143425000034, 72.47247955900008],
              [55.52328535200007, 72.47028229400007],
              [55.43490644600007, 72.47028229400007],
              [55.377696160000085, 72.45831940300008],
              [55.35954837300005, 72.46002838700008],
              [55.33912194100009, 72.46417877800008],
              [55.15211022200003, 72.46279531500005],
              [55.115570509000065, 72.45038483300004],
              [55.32056725400008, 72.44367096600007],
              [55.35092207100007, 72.43793366100005],
              [55.378916863000086, 72.43626536700003],
              [55.442149285000085, 72.44415924700007],
              [55.46566816500007, 72.43618398600006],
              [55.467539910000085, 72.42658112200007],
              [55.465830925000034, 72.41307200700004],
              [55.469493035000085, 72.40086497600004],
              [55.48682701900003, 72.39516836100006],
              [55.48292076900003, 72.38418203300006],
              [55.475596550000034, 72.37055084800005],
              [55.46697024800005, 72.35797760600008],
              [55.45923912900008, 72.35049062700006],
              [55.38819420700008, 72.31329987200007],
              [55.376963738000086, 72.30267975500004],
              [55.40414472700007, 72.28587474200003],
              [55.512461785000085, 72.25934479400007],
              [55.520274285000085, 72.23688385600008],
              [55.56771894600007, 72.20840078300006],
              [55.574961785000085, 72.19965241100005],
              [55.56495201900003, 72.18170807500007],
              [55.54151451900003, 72.17169830900008],
              [55.49333743600005, 72.15867747600004],
              [55.42628014400003, 72.11908600500004],
              [55.40414472700007, 72.11395905200004],
              [55.389659050000034, 72.10773346600007],
              [55.36312910200007, 72.07697174700007],
              [55.342784050000034, 72.06557851800005],
              [55.42628014400003, 72.06460195500006],
              [55.45264733200008, 72.05878327000005],
              [55.43580162900008, 72.04775625200006],
              [55.39991295700008, 72.02948639500005],
              [55.38363691500007, 72.01776764500005],
              [55.37623131600009, 72.00751373900005],
              [55.37126712300005, 71.99689362200007],
              [55.364024285000085, 71.98627350500004],
              [55.349619988000086, 71.97626373900005],
              [55.363291863000086, 71.97256094000005],
              [55.37525475400008, 71.96503327000005],
              [55.38461347700007, 71.95473867400005],
              [55.39047285200007, 71.94269440300008],
              [55.35523522200003, 71.94306061400005],
              [55.24659264400003, 71.95571523600006],
              [55.26026451900003, 71.94269440300008],
              [55.23951256600009, 71.93691640800006],
              [55.231455925000034, 71.93349844000005],
              [55.22543379000007, 71.92902252800008],
              [55.39763431100005, 71.92226797100005],
              [55.41228274800005, 71.91998932500007],
              [55.44060306100005, 71.91014232000003],
              [55.49561608200008, 71.90208567900004],
              [55.50635826900003, 71.89801666900007],
              [55.51148522200003, 71.89325592700004],
              [55.512461785000085, 71.88837311400005],
              [55.51303144600007, 71.88328685100004],
              [55.528005405000044, 71.86371491100005],
              [55.528086785000085, 71.85419342700004],
              [55.52328535200007, 71.84536367400005],
              [55.520274285000085, 71.83283112200007],
              [55.52865644600007, 71.78514232000003],
              [55.55160566500007, 71.74762604400007],
              [55.62273196700005, 71.68203359600005],
              [55.67212975400008, 71.61102936400005],
              [55.75367272200003, 71.55719635600008],
              [55.80836022200003, 71.53119538000004],
              [55.82960045700008, 71.51504140800006],
              [55.887461785000085, 71.45233795800004],
              [55.916026238000086, 71.43170807500007],
              [55.98422285200007, 71.40558502800008],
              [56.014414910000085, 71.38715241100005],
              [56.02711022200003, 71.37075429900005],
              [56.05103600400008, 71.32074616100005],
              [56.055349155000044, 71.30182526200008],
              [56.07056725400008, 71.28021881700005],
              [56.10572350400008, 71.25897858300004],
              [56.34306888150007, 71.15776194900005],
              [56.580414259000065, 71.05654531500005],
              [56.64820397200003, 71.01288483300004],
              [56.790049675000034, 70.96796295800004],
              [56.840505405000044, 70.95986562700006],
              [56.86378014400003, 70.95270416900007],
              [56.879242384000065, 70.94399648600006],
              [56.918711785000085, 70.91425202000005],
              [56.936534050000034, 70.90717194200005],
              [56.97592207100007, 70.89765045800004],
              [57.03874759200005, 70.86981842700004],
              [57.063243035000085, 70.86245351800005],
              [57.129567905000044, 70.85700104400007],
              [57.22771243600005, 70.83779531500005],
              [57.267588738000086, 70.82172272300005],
              [57.311534050000034, 70.80975983300004],
              [57.466807488000086, 70.81801992400005],
              [57.47974694100009, 70.78925202000005],
              [57.638682488000086, 70.72988515800006],
              [57.55453535200007, 70.72724030200004],
              [57.52759850400008, 70.72988515800006],
              [57.48072350400008, 70.74445221600007],
              [57.457041863000086, 70.74848053600005],
              [57.432627800000034, 70.74355703300006],
              [57.45834394600007, 70.72532786700003],
              [57.50513756600009, 70.71596914300005],
              [57.53931725400008, 70.70477936400005],
              [57.52759850400008, 70.68146393400008],
              [57.48796634200005, 70.66779205900008],
              [57.487071160000085, 70.66547272300005],
              [57.473643425000034, 70.64793528900003],
              [57.45834394600007, 70.63743724200003],
              [57.440114780000044, 70.63080475500004],
              [57.41960696700005, 70.62726471600007],
              [57.39779707100007, 70.62620677300004],
              [57.39779707100007, 70.62002187700006],
              [57.41236412900008, 70.62091705900008],
              [57.426524285000085, 70.61871979400007],
              [57.440114780000044, 70.61383698100008],
              [57.45248457100007, 70.60635000200006],
              [57.25896243600005, 70.62811920800004],
              [57.06967207100007, 70.67283763200004],
              [57.045583530000044, 70.67593008000006],
              [57.02116946700005, 70.67462799700007],
              [57.01091556100005, 70.67182038000004],
              [56.986989780000044, 70.66095612200007],
              [56.96957441500007, 70.65916575700004],
              [56.905039910000085, 70.66779205900008],
              [56.82195071700005, 70.69920482000003],
              [56.776377800000034, 70.71063873900005],
              [56.74048912900008, 70.70258209800005],
              [56.75147545700008, 70.69253164300005],
              [56.76539147200003, 70.68549225500004],
              [56.79517662900008, 70.67462799700007],
              [56.84066816500007, 70.65143463700008],
              [56.853526238000086, 70.64793528900003],
              [57.03882897200003, 70.62620677300004],
              [57.06023196700005, 70.62848541900007],
              [57.114268425000034, 70.64052969000005],
              [57.13982181100005, 70.64004140800006],
              [57.15211022200003, 70.63808828300006],
              [57.16456139400003, 70.63369375200006],
              [57.16570071700005, 70.63043854400007],
              [57.166026238000086, 70.62445709800005],
              [57.16749108200008, 70.61798737200007],
              [57.171885613000086, 70.61318594000005],
              [57.21306399800005, 70.60028717700004],
              [57.30290774800005, 70.58612702000005],
              [57.34327233200008, 70.57160065300008],
              [57.320974155000044, 70.56509023600006],
              [57.29574629000007, 70.56468333500004],
              [57.00831139400006, 70.60262685750004],
              [56.72087649800005, 70.64057038000004],
              [56.63998457100007, 70.66986725500004],
              [56.59652754000007, 70.67462799700007],
              [56.61182701900003, 70.65888092700004],
              [56.640961134000065, 70.64769114800004],
              [56.69898522200003, 70.63369375200006],
              [56.65162194100009, 70.62982819200005],
              [56.58529707100007, 70.64232005400004],
              [56.52458743600005, 70.66592031500005],
              [56.49350019600007, 70.69513580900008],
              [56.50521894600007, 70.70441315300008],
              [56.51343834700003, 70.72573476800005],
              [56.52076256600009, 70.72988515800006],
              [56.562510613000086, 70.73265208500004],
              [56.58130944100009, 70.73773834800005],
              [56.57601972700007, 70.74697500200006],
              [56.55209394600007, 70.75397370000007],
              [56.47681725400008, 70.75039297100005],
              [56.45923912900008, 70.74579498900005],
              [56.44947350400008, 70.73525625200006],
              [56.442393425000034, 70.72353750200006],
              [56.431976759000065, 70.71556224200003],
              [56.41163170700008, 70.71360911700003],
              [56.31373131600009, 70.72711823100008],
              [56.268565300000034, 70.74066803600005],
              [56.247080925000034, 70.74355703300006],
              [56.22413170700008, 70.74160390800006],
              [56.215830925000034, 70.73651764500005],
              [56.221039259000065, 70.72939687700006],
              [56.23878014400003, 70.72113678600005],
              [56.260752800000034, 70.71735260600008],
              [56.28492272200003, 70.71674225500004],
              [56.306976759000065, 70.71369049700007],
              [56.322276238000086, 70.70258209800005],
              [56.199229363000086, 70.70937734600005],
              [56.213633660000085, 70.69586823100008],
              [56.243174675000034, 70.68793366100005],
              [56.301768425000034, 70.68146393400008],
              [56.28402754000007, 70.67072174700007],
              [56.26295006600009, 70.66697825700004],
              [56.21989993600005, 70.66779205900008],
              [56.23796634200005, 70.65314362200007],
              [56.268565300000034, 70.64765045800004],
              [56.36182701900003, 70.64720286700003],
              [56.37826582100007, 70.65082428600005],
              [56.38363691500007, 70.66095612200007],
              [56.375743035000085, 70.66620514500005],
              [56.34156334700003, 70.67487213700008],
              [56.329112175000034, 70.68146393400008],
              [56.433604363000086, 70.67621491100005],
              [56.48259524800005, 70.66400788000004],
              [56.52759850400008, 70.64052969000005],
              [56.484711134000065, 70.64227936400005],
              [56.464854363000086, 70.63849518400008],
              [56.45329837300005, 70.62620677300004],
              [56.58285566500007, 70.61318594000005],
              [56.64210045700008, 70.59772370000007],
              [56.65455162900008, 70.58999258000006],
              [56.654307488000086, 70.58136627800008],
              [56.64478600400008, 70.57444896000004],
              [56.60075931100005, 70.56761302300004],
              [56.54411868600005, 70.54975006700005],
              [56.514008009000065, 70.54486725500004],
              [56.47592207100007, 70.54791901200008],
              [56.40064537900008, 70.56386953300006],
              [56.500987175000034, 70.55853913000004],
              [56.46615644600007, 70.57160065300008],
              [56.46615644600007, 70.57904694200005],
              [56.488942905000044, 70.57265859600005],
              [56.51482181100005, 70.56972890800006],
              [56.54037519600007, 70.57147858300004],
              [56.562510613000086, 70.57904694200005],
              [56.53492272200003, 70.59686920800004],
              [56.49927819100009, 70.59979889500005],
              [56.42855879000007, 70.59271881700005],
              [56.354258660000085, 70.59796784100007],
              [56.281260613000086, 70.61318594000005],
              [56.15756269600007, 70.65745677300004],
              [56.09001712300005, 70.66852448100008],
              [56.041026238000086, 70.64793528900003],
              [56.15935306100005, 70.62913646000004],
              [56.17823326900003, 70.60976797100005],
              [56.16423587300005, 70.59463125200006],
              [56.131521030000044, 70.59589264500005],
              [56.041351759000065, 70.62343984600005],
              [55.96599368600005, 70.66095612200007],
              [55.92701256600009, 70.67153554900005],
              [55.846690300000034, 70.68390534100007],
              [55.80836022200003, 70.69513580900008],
              [55.85141035200007, 70.65094635600008],
              [55.99382571700005, 70.61786530200004],
              [56.047862175000034, 70.58527252800008],
              [56.020518425000034, 70.57379791900007],
              [55.99594160200007, 70.57977936400005],
              [55.97201582100007, 70.59218984600005],
              [55.946055535000085, 70.59951406500005],
              [55.93116295700008, 70.59686920800004],
              [55.90170332100007, 70.58535390800006],
              [55.88404381600009, 70.58527252800008],
              [55.87159264400003, 70.58950429900005],
              [55.864268425000034, 70.59516022300005],
              [55.858164910000085, 70.60114166900007],
              [55.84986412900008, 70.60635000200006],
              [55.81755618600005, 70.61334870000007],
              [55.751963738000086, 70.60862864800004],
              [55.71924889400003, 70.61139557500007],
              [55.62525475400008, 70.63373444200005],
              [55.60279381600009, 70.64793528900003],
              [55.63062584700003, 70.63800690300008],
              [55.66537519600007, 70.62811920800004],
              [55.69874108200008, 70.62051015800006],
              [55.72632897200003, 70.62620677300004],
              [55.69874108200008, 70.64716217700004],
              [55.74366295700008, 70.63694896000004],
              [55.79151451900003, 70.63369375200006],
              [55.80005944100009, 70.64451732000003],
              [55.78345787900008, 70.66876862200007],
              [55.75766035200007, 70.69391510600008],
              [55.73804772200003, 70.70758698100008],
              [55.670909050000034, 70.71637604400007],
              [55.63013756600009, 70.73725006700005],
              [55.608083530000044, 70.73216380400004],
              [55.59937584700003, 70.72142161700003],
              [55.615896030000044, 70.71556224200003],
              [55.65316816500007, 70.71137116100005],
              [55.693695509000065, 70.69867584800005],
              [55.72803795700008, 70.67755768400008],
              [55.746836785000085, 70.64793528900003],
              [55.71119225400008, 70.67365143400008],
              [55.662852410000085, 70.68915436400005],
              [55.49529056100005, 70.71287669500003],
              [55.47250410200007, 70.72304922100005],
              [55.44459069100009, 70.74359772300005],
              [55.42904707100007, 70.74990469000005],
              [55.40479576900003, 70.75039297100005],
              [55.405284050000034, 70.73639557500007],
              [55.36378014400003, 70.71816640800006],
              [55.349619988000086, 70.70258209800005],
              [55.38404381600009, 70.70282623900005],
              [55.420664910000085, 70.69623444200005],
              [55.45264733200008, 70.68065013200004],
              [55.47250410200007, 70.65412018400008],
              [55.45394941500007, 70.65936920800004],
              [55.422211134000065, 70.68170807500007],
              [55.40479576900003, 70.68891022300005],
              [55.39380944100009, 70.68846263200004],
              [55.349619988000086, 70.68146393400008],
              [55.29086347700007, 70.68891022300005],
              [55.274099155000044, 70.68618398600006],
              [55.250010613000086, 70.67853424700007],
              [55.23267662900008, 70.66657135600008],
              [55.236338738000086, 70.65106842700004],
              [55.28687584700003, 70.61985911700003],
              [55.295583530000044, 70.60635000200006],
              [55.27515709700003, 70.61204661700003],
              [55.27165774800005, 70.60594310100004],
              [55.27279707100007, 70.59467194200005],
              [55.26710045700008, 70.58527252800008],
              [55.224619988000086, 70.58466217700004],
              [55.207367384000065, 70.58063385600008],
              [55.21314537900008, 70.56537506700005],
              [55.16260826900003, 70.55312734600005],
              [55.109385613000086, 70.57176341400003],
              [55.05632571700005, 70.59910716400003],
              [54.99463951900003, 70.61603424700007],
              [54.99000084700003, 70.62254466400003],
              [54.98845462300005, 70.62954336100006],
              [54.98601321700005, 70.63369375200006],
              [54.967133009000065, 70.63788483300004],
              [54.92994225400008, 70.63776276200008],
              [54.91138756600009, 70.64052969000005],
              [54.901133660000085, 70.64476146000004],
              [54.88135826900003, 70.65643952000005],
              [54.869883660000085, 70.66095612200007],
              [54.801524285000085, 70.66779205900008],
              [54.779958530000044, 70.67304108300004],
              [54.76059004000007, 70.68060944200005],
              [54.742849155000044, 70.69049713700008],
              [54.72584069100009, 70.70258209800005],
              [54.70728600400008, 70.72215403900003],
              [54.70850670700008, 70.73322174700007],
              [54.71501712300005, 70.74282461100006],
              [54.71216881600009, 70.75779857000003],
              [54.69117272200003, 70.76788971600007],
              [54.59009850400008, 70.77899811400005],
              [54.55054772200003, 70.80312734600005],
              [54.533213738000086, 70.81305573100008],
              [54.51343834700003, 70.82542552300004],
              [54.531993035000085, 70.80931224200003],
              [54.558929884000065, 70.79218170800004],
              [54.56812584700003, 70.77704498900005],
              [54.50635826900003, 70.78754303600005],
              [54.49244225400008, 70.78449127800008],
              [54.491221550000034, 70.76487864800004],
              [54.48780358200008, 70.74925364800004],
              [54.47877037900008, 70.73602936400005],
              [54.65015709700003, 70.69513580900008],
              [54.635101759000065, 70.69513580900008],
              [54.628916863000086, 70.69330475500004],
              [54.62273196700005, 70.68891022300005],
              [54.660166863000086, 70.67853424700007],
              [54.69776451900003, 70.67621491100005],
              [54.73414147200003, 70.66986725500004],
              [54.76742597700007, 70.64793528900003],
              [54.63640384200005, 70.66095612200007],
              [54.57081139400003, 70.67479075700004],
              [54.54444420700008, 70.68650950700004],
              [54.54769941500007, 70.70258209800005],
              [54.52523847700007, 70.71010976800005],
              [54.47624759200005, 70.71287669500003],
              [54.45297285200007, 70.71751536700003],
              [54.30746504000007, 70.77338288000004],
              [54.28695722700007, 70.77704498900005],
              [54.26978600400008, 70.77244700700004],
              [54.269541863000086, 70.76361725500004],
              [54.280039910000085, 70.75307851800005],
              [54.29444420700008, 70.74355703300006],
              [54.260508660000085, 70.72988515800006],
              [54.22510826900003, 70.72955963700008],
              [54.18995201900003, 70.73883698100008],
              [54.157237175000034, 70.75409577000005],
              [54.140961134000065, 70.75690338700008],
              [54.084971550000034, 70.74355703300006],
              [54.04509524800005, 70.74787018400008],
              [54.006521030000044, 70.75779857000003],
              [53.85482832100007, 70.82221100500004],
              [53.84066816500007, 70.82314687700006],
              [53.83448326900003, 70.81517161700003],
              [53.84156334700003, 70.80752187700006],
              [53.88982181100005, 70.78449127800008],
              [53.871429884000065, 70.78497955900008],
              [53.854177280000044, 70.78851959800005],
              [53.82056725400008, 70.80190664300005],
              [53.797536655000044, 70.80609772300005],
              [53.74431399800005, 70.79865143400008],
              [53.71900475400008, 70.79877350500004],
              [53.70476321700005, 70.80263906500005],
              [53.66382897200003, 70.82172272300005],
              [53.63803144600007, 70.82965729400007],
              [53.58529707100007, 70.83185455900008],
              [53.56080162900008, 70.83974844000005],
              [53.563487175000034, 70.84345123900005],
              [53.56763756600009, 70.85276927300004],
              [53.54460696700005, 70.85431549700007],
              [53.536143425000034, 70.84430573100008],
              [53.53842207100007, 70.82851797100005],
              [53.54712975400008, 70.81244538000004],
              [53.539724155000044, 70.80499909100007],
              [53.518565300000034, 70.81903717700004],
              [53.45923912900008, 70.82355377800008],
              [53.40748131600009, 70.85032786700003],
              [53.37037194100009, 70.85919830900008],
              [53.30014082100007, 70.86640045800004],
              [53.49203535200007, 70.87348053600005],
              [53.50928795700008, 70.86981842700004],
              [53.520518425000034, 70.86957428600005],
              [53.53109785200007, 70.87466054900005],
              [53.54216556100005, 70.88153717700004],
              [53.55396569100009, 70.88690827000005],
              [53.576833530000044, 70.88873932500007],
              [53.59555097700007, 70.88251373900005],
              [53.647146030000044, 70.84813060100004],
              [53.66944420700008, 70.83734772300005],
              [53.69060306100005, 70.83421458500004],
              [53.70476321700005, 70.84593333500004],
              [53.684336785000085, 70.85712311400005],
              [53.673838738000086, 70.87270742400005],
              [53.67359459700003, 70.89036692900004],
              [53.68376712300005, 70.90802643400008],
              [53.708018425000034, 70.92609284100007],
              [53.72934004000007, 70.93646881700005],
              [53.73812910200007, 70.94794342700004],
              [53.724619988000086, 70.96881745000007],
              [53.672618035000085, 71.00482819200005],
              [53.54965254000007, 71.04572174700007],
              [53.49187259200005, 71.07245514500005],
              [53.496429884000065, 71.07729726800005],
              [53.50171959700003, 71.09442780200004],
              [53.53793379000007, 71.08551666900007],
              [53.58334394600007, 71.07953522300005],
              [53.67750084700003, 71.07868073100008],
              [53.66382897200003, 71.09296295800004],
              [53.67994225400008, 71.09931061400005],
              [53.69548587300005, 71.09861888200004],
              [53.72681725400008, 71.08787669500003],
              [53.744802280000044, 71.08494700700004],
              [53.78256269600007, 71.08710358300004],
              [53.80103600400008, 71.08612702000005],
              [53.904307488000086, 71.05463288000004],
              [53.93685957100007, 71.05947500200006],
              [53.83366946700005, 71.10968659100007],
              [53.80713951900003, 71.13397858300004],
              [53.941416863000086, 71.14301178600005],
              [54.008799675000034, 71.14020416900007],
              [54.06788170700008, 71.11969635600008],
              [53.98023522200003, 71.13251373900005],
              [53.93897545700008, 71.13031647300005],
              [53.917002800000034, 71.10602448100008],
              [53.935883009000065, 71.10130442900004],
              [53.999034050000034, 71.10602448100008],
              [54.078135613000086, 71.09979889500005],
              [54.232432488000086, 71.11969635600008],
              [54.24398847700007, 71.12287018400008],
              [54.23853600400008, 71.12982819200005],
              [54.224945509000065, 71.13711172100005],
              [54.211924675000034, 71.14077383000006],
              [54.19353274800005, 71.13934967700004],
              [54.15837649800005, 71.12954336100006],
              [54.13990319100009, 71.12710195500006],
              [54.063243035000085, 71.13617584800005],
              [54.02173912900008, 71.14667389500005],
              [53.992198113000086, 71.16058991100005],
              [54.00717207100007, 71.16201406500005],
              [54.015961134000065, 71.16893138200004],
              [54.02328535200007, 71.17788320500006],
              [54.03345787900008, 71.18545156500005],
              [54.04769941500007, 71.18915436400005],
              [54.09522545700008, 71.18854401200008],
              [54.056651238000086, 71.20892975500004],
              [54.07976321700005, 71.21141185100004],
              [54.127940300000034, 71.20770905200004],
              [54.164073113000086, 71.20966217700004],
              [54.14047285200007, 71.21230703300006],
              [54.090586785000085, 71.23216380400004],
              [54.064463738000086, 71.23700592700004],
              [54.04118899800005, 71.23334381700005],
              [54.02523847700007, 71.22418854400007],
              [53.992198113000086, 71.19912344000005],
              [53.968760613000086, 71.18659088700008],
              [53.94304446700005, 71.17641836100006],
              [53.917002800000034, 71.17413971600007],
              [53.893239780000044, 71.18545156500005],
              [53.87240644600007, 71.19940827000005],
              [53.85010826900003, 71.20652903900003],
              [53.80103600400008, 71.20966217700004],
              [53.81592858200008, 71.19928620000007],
              [53.82862389400003, 71.18512604400007],
              [53.83228600400008, 71.17011139500005],
              [53.82056725400008, 71.15753815300008],
              [53.795909050000034, 71.15534088700008],
              [53.733083530000044, 71.17169830900008],
              [53.70476321700005, 71.17487213700008],
              [53.719086134000065, 71.18545156500005],
              [53.724619988000086, 71.18854401200008],
              [53.708018425000034, 71.19537995000007],
              [53.66928144600007, 71.20026276200008],
              [53.65015709700003, 71.20624420800004],
              [53.627940300000034, 71.20868561400005],
              [53.57699629000007, 71.19928620000007],
              [53.557383660000085, 71.20624420800004],
              [53.54224694100009, 71.21588776200008],
              [53.509776238000086, 71.22459544500003],
              [53.461680535000085, 71.25470612200007],
              [53.45093834700003, 71.26430898600006],
              [53.57471764400003, 71.29433828300006],
              [53.59489993600005, 71.30182526200008],
              [53.60572350400008, 71.32294342700004],
              [53.653005405000044, 71.34845612200007],
              [53.66382897200003, 71.37075429900005],
              [53.682383660000085, 71.39834219000005],
              [53.725596550000034, 71.41132233300004],
              [53.888682488000086, 71.42230866100005],
              [53.92530358200008, 71.43650950700004],
              [53.951182488000086, 71.46222565300008],
              [53.92115319100009, 71.46954987200007],
              [53.89975019600007, 71.47101471600007],
              [53.88005618600005, 71.46474844000005],
              [53.830821160000085, 71.43569570500006],
              [53.57634524800005, 71.39081452000005],
              [53.553721550000034, 71.37921784100007],
              [53.539724155000044, 71.36050039300005],
              [53.543630405000044, 71.31683991100005],
              [53.48764082100007, 71.30341217700004],
              [53.41334069100009, 71.31175364800004],
              [53.36158287900008, 71.33319733300004],
              [53.35824629000007, 71.33917877800008],
              [53.35141035200007, 71.35993073100008],
              [53.34791100400008, 71.36733633000006],
              [53.31373131600009, 71.39398834800005],
              [53.25171959700003, 71.45604075700004],
              [53.26783287900008, 71.45758698100008],
              [53.30600019600007, 71.46723053600005],
              [53.32056725400008, 71.47313060100004],
              [53.32976321700005, 71.47955963700008],
              [53.330739780000044, 71.48468659100007],
              [53.33025149800005, 71.48997630400004],
              [53.33423912900008, 71.49701569200005],
              [53.358164910000085, 71.51487864800004],
              [53.444102410000085, 71.54547760600008],
              [53.365244988000086, 71.56903717700004],
              [53.34782962300005, 71.56753164300005],
              [53.205739780000044, 71.50983307500007],
              [53.172862175000034, 71.48883698100008],
              [53.14242597700007, 71.46222565300008],
              [53.15007571700005, 71.44037506700005],
              [53.13461347700007, 71.42617422100005],
              [53.11304772200003, 71.42243073100008],
              [53.10206139400003, 71.43219635600008],
              [53.09717858200008, 71.45278554900005],
              [53.08423912900008, 71.46450429900005],
              [53.046885613000086, 71.48403554900005],
              [53.05713951900003, 71.49823639500005],
              [53.04810631600009, 71.50226471600007],
              [53.029633009000065, 71.49957916900007],
              [53.012705925000034, 71.49359772300005],
              [53.00700931100005, 71.48346588700008],
              [53.019541863000086, 71.47313060100004],
              [53.03736412900008, 71.46360911700003],
              [53.046885613000086, 71.45604075700004],
              [53.03874759200005, 71.44277578300006],
              [53.01539147200003, 71.44228750200006],
              [52.988942905000044, 71.44521719000005],
              [52.97185306100005, 71.44236888200004],
              [52.96859785200007, 71.42877838700008],
              [52.97185306100005, 71.41400788000004],
              [52.96810957100007, 71.40521881700005],
              [52.945323113000086, 71.40961334800005],
              [52.92823326900003, 71.40989817900004],
              [52.903086785000085, 71.39272695500006],
              [52.88233483200008, 71.39398834800005],
              [52.86841881600009, 71.40224844000005],
              [52.860362175000034, 71.41388580900008],
              [52.85889733200008, 71.42682526200008],
              [52.86500084700003, 71.43903229400007],
              [52.855479363000086, 71.45697663000004],
              [52.821299675000034, 71.46991608300004],
              [52.79769941500007, 71.46478913000004],
              [52.820323113000086, 71.42877838700008],
              [52.762380405000044, 71.43325429900005],
              [52.73991946700005, 71.44212474200003],
              [52.73096764400003, 71.46600983300004],
              [52.71810957100007, 71.48973216400003],
              [52.68881269600007, 71.48590729400007],
              [52.635427280000044, 71.46222565300008],
              [52.60987389400003, 71.46869538000004],
              [52.61703535200007, 71.48663971600007],
              [52.63697350400008, 71.50800202000005],
              [52.64966881600009, 71.52496979400007],
              [52.64380944100009, 71.54608795800004],
              [52.62354576900003, 71.55874258000006],
              [52.57390384200005, 71.57587311400005],
              [52.561289910000085, 71.59235260600008],
              [52.56137129000007, 71.62799713700008],
              [52.547211134000065, 71.63483307500007],
              [52.52068118600005, 71.62815989800004],
              [52.513682488000086, 71.61139557500007],
              [52.51140384200005, 71.58905670800004],
              [52.498789910000085, 71.56590403900003],
              [52.46900475400008, 71.55621979400007],
              [52.38559004000007, 71.54954661700003],
              [52.36841881600009, 71.53489817900004],
              [52.37476647200003, 71.51333242400005],
              [52.38917076900003, 71.50063711100006],
              [52.405039910000085, 71.49046458500004],
              [52.41627037900008, 71.47654857000003],
              [52.378916863000086, 71.48090241100005],
              [52.326914910000085, 71.49384186400005],
              [52.28044681100005, 71.51373932500007],
              [52.258555535000085, 71.53864166900007],
              [52.27116946700005, 71.57273997600004],
              [52.26880944100009, 71.58795807500007],
              [52.24431399800005, 71.58299388200004],
              [52.19581139400003, 71.55678945500006],
              [52.17212975400008, 71.54852936400005],
              [52.14185631600009, 71.54547760600008],
              [52.16325931100005, 71.51837799700007],
              [52.201914910000085, 71.50238678600005],
              [52.244883660000085, 71.49079010600008],
              [52.27906334700003, 71.47654857000003],
              [52.13949629000007, 71.48501211100006],
              [52.053070509000065, 71.47654857000003],
              [51.96208743600005, 71.47964101800005],
              [51.91586347700007, 71.46576569200005],
              [51.861989780000044, 71.45624420800004],
              [51.84034264400003, 71.45604075700004],
              [51.82195071700005, 71.46088288000004],
              [51.809336785000085, 71.46914297100005],
              [51.79867597700007, 71.47858307500007],
              [51.785899285000085, 71.48712799700007],
              [51.70980879000007, 71.51752350500004],
              [51.682627800000034, 71.52509186400005],
              [51.60084069100009, 71.53668854400007],
              [51.549815300000034, 71.56024811400005],
              [51.53239993600005, 71.56590403900003],
              [51.53638756600009, 71.57599518400008],
              [51.549815300000034, 71.59495677300004],
              [51.55290774800005, 71.60346100500004],
              [51.54965254000007, 71.61351146000004],
              [51.53565514400003, 71.62360260600008],
              [51.53239993600005, 71.63104889500005],
              [51.523773634000065, 71.64663320500006],
              [51.467539910000085, 71.69253164300005],
              [51.46338951900003, 71.70233795800004],
              [51.469493035000085, 71.70604075700004],
              [51.47185306100005, 71.71059804900005],
              [51.45671634200005, 71.72296784100007],
              [51.44190514400003, 71.73004791900007],
              [51.431976759000065, 71.73224518400008],
              [51.424489780000044, 71.73676178600005],
              [51.41627037900008, 71.75092194200005],
              [51.410899285000085, 71.76483795800004],
              [51.40642337300005, 71.78156159100007],
              [51.40951582100007, 71.80613841400003],
            ],
          ],
          [
            [
              [127.40479576900009, 73.51862213700008],
              [127.39234459700003, 73.52545807500007],
              [127.428070509, 73.53733958500004],
              [127.52027428500003, 73.54564036700003],
              [127.69092858200008, 73.54287344000005],
              [127.98129316500001, 73.49408600500004],
              [128.063324415, 73.49135976800005],
              [128.03248131600003, 73.48358795800004],
              [127.77507571700005, 73.49258047100005],
              [127.69743899800005, 73.50543854400007],
              [127.61768639400009, 73.50031159100007],
              [127.53907311300009, 73.51561107000003],
              [127.40479576900009, 73.51862213700008],
            ],
          ],
          [
            [
              [86.89234459700003, 73.69672272300005],
              [86.88119550900007, 73.69013092700004],
              [86.80990644600007, 73.65835195500006],
              [86.79249108200008, 73.64520905200004],
              [86.78939863400007, 73.63788483300004],
              [86.79883873800003, 73.62571849200003],
              [86.79615319100003, 73.61481354400007],
              [86.78394616000003, 73.60822174700007],
              [86.76221764400003, 73.60374583500004],
              [86.39893639400003, 73.59438711100006],
              [86.46558678500003, 73.61839427300004],
              [86.48764082100007, 73.62164948100008],
              [86.50961347700007, 73.64183177300004],
              [86.57471764400003, 73.65387604400007],
              [86.69369550900007, 73.66266510600008],
              [86.85108483200008, 73.69855377800008],
              [86.90601647200003, 73.70416901200008],
              [86.89234459700003, 73.69672272300005],
            ],
          ],
          [
            [
              [97.15805097700007, 76.08828359600005],
              [97.29330488400007, 76.09634023600006],
              [97.33480879000007, 76.10871002800008],
              [97.33480879000007, 76.10252513200004],
              [97.30486087300005, 76.08340078300006],
              [97.17847741000003, 76.05414459800005],
              [97.04737389400003, 76.00633372600004],
              [96.74805748800003, 75.98102448100008],
              [96.69857832100007, 75.99579498900005],
              [96.71314537900008, 76.02163320500006],
              [96.74773196700005, 76.03099192900004],
              [97.15805097700007, 76.08828359600005],
            ],
          ],
          [
            [
              [95.17741946700005, 76.17084381700005],
              [95.19174238400007, 76.16502513200004],
              [95.19727623800003, 76.16400788000004],
              [95.15593509200005, 76.15371328300006],
              [95.10157311300003, 76.15497467700004],
              [95.04704837300005, 76.16412995000007],
              [95.00603274800005, 76.17767975500004],
              [95.04883873800003, 76.19155508000006],
              [95.06714928500003, 76.20099518400008],
              [95.08122806100005, 76.21857330900008],
              [95.10157311300003, 76.22540924700007],
              [95.15894616000003, 76.20160553600005],
              [95.18181399800005, 76.18553294500003],
              [95.17741946700005, 76.17084381700005],
            ],
          ],
          [
            [
              [94.99919681100005, 76.27326080900008],
              [94.96371504000007, 76.26333242400005],
              [94.88868248800003, 76.25141022300005],
              [94.85523522200003, 76.23908112200007],
              [94.86622155000003, 76.22980377800008],
              [94.89087975400008, 76.21991608300004],
              [94.90357506600003, 76.21238841400003],
              [94.84888756600003, 76.18610260600008],
              [94.78101647200003, 76.18121979400007],
              [94.61500084700003, 76.19476959800005],
              [94.58668053500003, 76.20189036700003],
              [94.55762780000003, 76.20441315300008],
              [94.52564537900008, 76.19440338700008],
              [94.50025475400008, 76.18964264500005],
              [94.46729576900003, 76.19367096600007],
              [94.43474368600005, 76.20262278900003],
              [94.41016686300003, 76.21238841400003],
              [94.47185306100005, 76.23533763200004],
              [94.49219811300003, 76.23908112200007],
              [94.77865644600007, 76.21092357000003],
              [94.79997806100005, 76.21857330900008],
              [94.78687584700003, 76.23102448100008],
              [94.77051842500003, 76.24266185100004],
              [94.75359134200005, 76.25092194200005],
              [94.73853600400008, 76.25336334800005],
              [94.75220787900008, 76.25958893400008],
              [94.74537194100003, 76.25958893400008],
              [94.82243899800005, 76.26512278900003],
              [94.89673912900008, 76.28001536700003],
              [94.90308678500003, 76.28363678600005],
              [94.90821373800003, 76.28888580900008],
              [94.91407311300003, 76.29279205900008],
              [94.92212975400008, 76.29242584800005],
              [94.94402103000004, 76.28001536700003],
              [94.97038821700005, 76.27509186400005],
              [94.99919681100005, 76.27326080900008],
            ],
          ],
          [
            [
              [96.57488040500004, 76.34149811400005],
              [96.72461998800003, 76.34638092700004],
              [96.76693769600007, 76.33527252800008],
              [96.75521894600007, 76.32843659100007],
              [96.73145592500003, 76.32558828300006],
              [96.71973717500003, 76.32225169500003],
              [96.71062259200005, 76.31435781500005],
              [96.70492597700007, 76.30524323100008],
              [96.69792728000004, 76.29751211100006],
              [96.68474368600005, 76.29433828300006],
              [96.66187584700003, 76.29808177300004],
              [96.62973066500007, 76.31639232000003],
              [96.61060631600003, 76.32322825700004],
              [96.43376712300005, 76.32111237200007],
              [96.38331139400003, 76.33527252800008],
              [96.42725670700003, 76.34536367400005],
              [96.57488040500004, 76.34149811400005],
            ],
          ],
          [
            [
              [96.89665774800005, 76.25649648600006],
              [96.92994225400008, 76.26154205900008],
              [97.04127037900008, 76.23908112200007],
              [97.01026451900003, 76.22992584800005],
              [96.94174238400007, 76.22630442900004],
              [96.90894616000003, 76.22040436400005],
              [96.76091556100005, 76.17641836100006],
              [96.74301191500007, 76.17544179900005],
              [96.72934004000007, 76.18109772300005],
              [96.72543379000007, 76.18720123900005],
              [96.72095787900008, 76.20148346600007],
              [96.71599368600005, 76.20868561400005],
              [96.71697024800005, 76.22272370000007],
              [96.73113040500004, 76.23847077000005],
              [96.74024498800003, 76.25202057500007],
              [96.72584069100003, 76.25958893400008],
              [96.74301191500007, 76.27057526200008],
              [96.78101647200003, 76.28070709800005],
              [96.81576582100007, 76.30365631700005],
              [96.87680097700007, 76.32225169500003],
              [96.86557050900007, 76.33006419500003],
              [96.82837975400008, 76.34149811400005],
              [96.85401451900003, 76.35565827000005],
              [96.88526451900003, 76.35537344000005],
              [96.94516035200007, 76.33991120000007],
              [97.00513756600003, 76.34320709800005],
              [97.03142337300005, 76.34186432500007],
              [97.03443444100003, 76.32843659100007],
              [97.04314212300005, 76.32029857000003],
              [97.05298912900008, 76.31484609600005],
              [97.07545006600003, 76.30801015800006],
              [97.03052819100003, 76.29026927300004],
              [96.98560631600003, 76.28217194200005],
              [96.89014733200003, 76.28001536700003],
              [96.85954837300005, 76.27216217700004],
              [96.83497155000003, 76.25340403900003],
              [96.81226647200003, 76.23114655200004],
              [96.78736412900008, 76.21238841400003],
              [96.81869550900007, 76.21417877800008],
              [96.84555097700007, 76.22573476800005],
              [96.89665774800005, 76.25649648600006],
            ],
          ],
          [
            [
              [94.16309655000003, 76.59601471600007],
              [94.31641686300003, 76.58966705900008],
              [94.36231530000003, 76.57489655200004],
              [93.86833743600005, 76.58856842700004],
              [93.88640384200005, 76.60004303600005],
              [93.94410241000003, 76.61644114800004],
              [94.16309655000003, 76.59601471600007],
            ],
          ],
          [
            [
              [95.26612389400003, 76.67108795800004],
              [95.31185957100007, 76.66828034100007],
              [95.32748457100007, 76.66425202000005],
              [95.28516686300003, 76.64252350500004],
              [95.22779381600003, 76.63996002800008],
              [95.11841881600003, 76.65062083500004],
              [94.84669030000003, 76.63784414300005],
              [94.82146243600005, 76.64272695500006],
              [94.81763756600003, 76.65399811400005],
              [94.83904056100005, 76.66791413000004],
              [94.86784915500004, 76.67397695500006],
              [95.01587975400008, 76.68402741100005],
              [95.04672285200007, 76.67959219000005],
              [95.06592858200003, 76.68138255400004],
              [95.08659915500004, 76.69183991100005],
              [95.12208092500003, 76.71889883000006],
              [95.12891686300003, 76.71206289300005],
              [95.12916100400008, 76.70673248900005],
              [95.13795006600003, 76.70604075700004],
              [95.15064537900008, 76.70669179900005],
              [95.16309655000003, 76.70526764500005],
              [95.19662519600007, 76.68675364800004],
              [95.26612389400003, 76.67108795800004],
            ],
          ],
          [
            [
              [56.986989780000044, 74.69049713700008],
              [56.973317905000044, 74.69049713700008],
              [56.94483483200008, 74.70734284100007],
              [56.89307701900003, 74.71271393400008],
              [56.83871504000007, 74.70945872600004],
              [56.77881920700008, 74.69350820500006],
              [56.754242384000065, 74.69232819200005],
              [56.705821160000085, 74.69733307500007],
              [56.62680097700007, 74.69354889500005],
              [56.60279381600009, 74.69733307500007],
              [56.58619225400008, 74.70563385600008],
              [56.56381269600007, 74.72699616100005],
              [56.548838738000086, 74.73826732000003],
              [56.531260613000086, 74.74628327000005],
              [56.51002037900008, 74.75214264500005],
              [56.48796634200005, 74.75409577000005],
              [56.45093834700003, 74.74799225500004],
              [56.429698113000086, 74.74860260600008],
              [56.41684004000007, 74.75311920800004],
              [56.42514082100007, 74.76215241100005],
              [56.500987175000034, 74.79352448100008],
              [56.46599368600005, 74.79926178600005],
              [56.201874220000064, 74.78998444200005],
              [55.93775475400008, 74.78070709800005],
              [55.883474155000044, 74.78754303600005],
              [55.832692905000044, 74.80003489800004],
              [55.81690514400003, 74.80735911700003],
              [55.81568444100009, 74.81720612200007],
              [55.83562259200005, 74.83104075700004],
              [55.88493899800005, 74.84617747600004],
              [56.21387780000006, 74.88552480650006],
              [56.54281660200007, 74.92487213700008],
              [56.594493035000085, 74.94269440300008],
              [56.61605879000007, 74.94550202000005],
              [56.66456139400003, 74.94432200700004],
              [56.678477410000085, 74.94867584800005],
              [56.67237389400003, 74.95831940300008],
              [56.65552819100009, 74.96796295800004],
              [56.637461785000085, 74.97223541900007],
              [56.588877800000034, 74.96588776200008],
              [56.54086347700007, 74.95246002800008],
              [56.514333530000044, 74.94822825700004],
              [56.431976759000065, 74.95799388200004],
              [56.410492384000065, 74.95400625200006],
              [56.36638431100005, 74.94009023600006],
              [56.35710696700005, 74.94086334800005],
              [56.38363691500007, 74.96482982000003],
              [56.294932488000086, 74.96482982000003],
              [56.31788170700008, 74.96784088700008],
              [56.38892662900008, 74.99347565300008],
              [56.44157962300005, 75.00438060100004],
              [56.46648196700005, 75.01276276200008],
              [56.46615644600007, 75.02252838700008],
              [56.44312584700003, 75.03266022300005],
              [56.420583530000044, 75.03725820500006],
              [56.397471550000034, 75.03652578300006],
              [56.34009850400008, 75.02509186400005],
              [56.180023634000065, 75.02081940300008],
              [56.065440300000034, 74.99697500200006],
              [55.903330925000034, 74.99127838700008],
              [55.86996504000007, 74.99701569200005],
              [55.86500084700003, 75.00360748900005],
              [55.89389082100007, 75.02179596600007],
              [55.89087975400008, 75.03245677300004],
              [55.946055535000085, 75.07404205900008],
              [55.93482506600009, 75.07656484600005],
              [55.91570071700005, 75.08567942900004],
              [55.90414472700007, 75.08771393400008],
              [55.83619225400008, 75.08771393400008],
              [55.74773196700005, 75.07538483300004],
              [55.72632897200003, 75.08148834800005],
              [55.73764082100007, 75.08685944200005],
              [55.74170983200008, 75.09422435100004],
              [55.74301191500007, 75.10195547100005],
              [55.746836785000085, 75.10822174700007],
              [55.75831139400003, 75.11432526200008],
              [55.78402754000007, 75.12278880400004],
              [55.79468834700003, 75.12872955900008],
              [55.799571160000085, 75.13568756700005],
              [55.803070509000065, 75.15058014500005],
              [55.80836022200003, 75.15664297100005],
              [55.82341556100005, 75.16217682500007],
              [55.85474694100009, 75.16185130400004],
              [55.87037194100009, 75.16339752800008],
              [55.88233483200008, 75.16974518400008],
              [55.906260613000086, 75.19037506700005],
              [55.91822350400008, 75.19757721600007],
              [56.03793379000007, 75.21759674700007],
              [56.07113691500007, 75.21893952000005],
              [56.10320071700005, 75.21124909100007],
              [56.09791100400008, 75.20819733300004],
              [56.08757571700005, 75.20050690300008],
              [56.082041863000086, 75.19757721600007],
              [56.11410566500007, 75.18829987200007],
              [56.15707441500007, 75.18577708500004],
              [56.20045006600009, 75.18915436400005],
              [56.23357181100005, 75.19757721600007],
              [56.216807488000086, 75.18040599200003],
              [56.16041100400008, 75.16795482000003],
              [56.13721764400003, 75.15664297100005],
              [56.17359459700003, 75.15021393400008],
              [56.212901238000086, 75.15253327000005],
              [56.287445509000065, 75.17023346600007],
              [56.33741295700008, 75.18964264500005],
              [56.35629316500007, 75.19074127800008],
              [56.37134850400008, 75.18817780200004],
              [56.37867272200003, 75.18414948100008],
              [56.38331139400003, 75.17829010600008],
              [56.45337975400008, 75.11896393400008],
              [56.47120201900003, 75.08783600500004],
              [56.44581139400003, 75.06728750200006],
              [56.53044681100005, 75.07843659100007],
              [56.61255944100009, 75.10691966400003],
              [56.791351759000065, 75.19790273600006],
              [56.880869988000086, 75.22329336100006],
              [56.89625084700003, 75.22996653900003],
              [56.90707441500007, 75.24017975500004],
              [56.91130618600005, 75.25592682500007],
              [56.89210045700008, 75.28046295800004],
              [56.84782962300005, 75.28900788000004],
              [56.76059004000007, 75.28701406500005],
              [56.73324629000007, 75.29657623900005],
              [56.75798587300005, 75.31842682500007],
              [56.83619225400008, 75.35521067900004],
              [57.04623457100007, 75.39813873900005],
              [57.07447350400008, 75.39606354400007],
              [57.148448113000086, 75.37909577000005],
              [57.425791863000086, 75.37567780200004],
              [57.420664910000085, 75.36237213700008],
              [57.43482506600009, 75.35687897300005],
              [57.47217858200008, 75.35346100500004],
              [57.55616295700008, 75.33417389500005],
              [57.74105879000007, 75.32786692900004],
              [57.73585045700008, 75.33075592700004],
              [57.71998131600009, 75.34153880400004],
              [57.72348066500007, 75.34471263200004],
              [57.72999108200008, 75.35219961100006],
              [57.73365319100009, 75.35521067900004],
              [57.71989993600005, 75.35785553600005],
              [57.680430535000085, 75.37225983300004],
              [57.672211134000065, 75.37909577000005],
              [57.66846764400003, 75.41034577000005],
              [57.666677280000044, 75.41669342700004],
              [57.64039147200003, 75.43939850500004],
              [57.60873457100007, 75.44403717700004],
              [57.57504316500007, 75.44358958500004],
              [57.54249108200008, 75.45148346600007],
              [57.543711785000085, 75.46710846600007],
              [57.53272545700008, 75.47866445500006],
              [57.50082441500007, 75.49921295800004],
              [57.56364993600005, 75.51968008000006],
              [58.05298912900008, 75.57729726800005],
              [58.14185631600009, 75.57436758000006],
              [58.164724155000044, 75.57835521000004],
              [58.18669681100005, 75.58877187700006],
              [58.195648634000065, 75.60321686400005],
              [58.17994225400008, 75.61933014500005],
              [58.146820509000065, 75.62885163000004],
              [57.95427493600005, 75.62409088700008],
              [57.92554772200003, 75.62897370000007],
              [57.944346550000034, 75.65485260600008],
              [57.979502800000034, 75.67194245000007],
              [58.01929772200003, 75.68134186400005],
              [58.25912519600007, 75.69285716400003],
              [58.30632571700005, 75.70246002800008],
              [58.400726759000065, 75.70966217700004],
              [58.459646030000044, 75.72752513200004],
              [58.604502800000034, 75.73261139500005],
              [58.59302819100009, 75.74213288000004],
              [58.536143425000034, 75.75995514500005],
              [58.573252800000034, 75.77374909100007],
              [58.60987389400003, 75.78213125200006],
              [58.723399285000085, 75.79214101800005],
              [58.72738691500007, 75.80402252800008],
              [58.726898634000065, 75.81903717700004],
              [58.750010613000086, 75.83299388200004],
              [58.93100019600007, 75.86762116100005],
              [59.13689212300005, 75.86542389500005],
              [59.228526238000086, 75.88666413000004],
              [59.24887129000007, 75.88898346600007],
              [59.30616295700008, 75.88776276200008],
              [59.33350670700008, 75.89166901200008],
              [59.358083530000044, 75.90326569200005],
              [59.35564212300005, 75.90460846600007],
              [59.354258660000085, 75.91054922100005],
              [59.35474694100009, 75.91791413000004],
              [59.358083530000044, 75.92377350500004],
              [59.365977410000085, 75.92816803600005],
              [59.38982181100005, 75.93602122600004],
              [59.39869225400008, 75.93744538000004],
              [59.748789910000085, 75.93060944200005],
              [59.77515709700003, 75.93390534100007],
              [59.82585696700005, 75.94843170800004],
              [59.902354363000086, 75.95807526200008],
              [59.99935957100007, 75.98627350500004],
              [60.04818769600007, 75.99266185100004],
              [60.322276238000086, 75.99823639500005],
              [60.347666863000086, 76.00568268400008],
              [60.34522545700008, 76.01691315300008],
              [60.32601972700007, 76.02350495000007],
              [60.29867597700007, 76.02887604400007],
              [60.08448326900003, 76.03636302300004],
              [60.06218509200005, 76.04246653900003],
              [60.04273522200003, 76.05414459800005],
              [60.08366946700005, 76.06972890800006],
              [60.26807701900003, 76.11009349200003],
              [60.55323326900003, 76.11654287350004],
              [60.83838951900003, 76.12299225500004],
              [60.81820722700007, 76.11066315300008],
              [60.793630405000044, 76.10639069200005],
              [60.76783287900008, 76.10480377800008],
              [60.481455925000034, 76.02704498900005],
              [60.46843509200005, 76.01312897300005],
              [60.53565514400003, 76.02069733300004],
              [60.55713951900003, 76.02065664300005],
              [60.54965254000007, 76.01312897300005],
              [60.603526238000086, 75.99876536700003],
              [60.66976972700007, 75.99607982000003],
              [60.734711134000065, 76.00535716400003],
              [60.78370201900003, 76.02680084800005],
              [60.78874759200005, 76.03270091400003],
              [60.79664147200003, 76.04730866100005],
              [60.80420983200008, 76.05414459800005],
              [60.818369988000086, 76.06012604400007],
              [60.89771569100003, 76.06915924700007],
              [60.96412194100003, 76.06586334800005],
              [61.08545983200008, 76.08454010600008],
              [61.11264082100007, 76.09568919500003],
              [61.14576256600003, 76.11611562700006],
              [61.15414472700007, 76.12909577000005],
              [61.14673912900008, 76.14350006700005],
              [61.11931399800005, 76.15119049700007],
              [60.947601759000065, 76.14061107000003],
              [60.919932488000086, 76.14411041900007],
              [60.89975019600007, 76.15717194200005],
              [60.92937259200005, 76.17495351800005],
              [60.995127800000034, 76.19977448100008],
              [61.02328535200007, 76.21857330900008],
              [60.99366295700008, 76.23078034100007],
              [60.99577884200005, 76.24640534100007],
              [61.01677493600005, 76.26186758000006],
              [61.04379316500007, 76.27326080900008],
              [61.076914910000085, 76.27997467700004],
              [61.18100019600007, 76.28001536700003],
              [61.48226972700007, 76.29433828300006],
              [61.56006920700008, 76.28363678600005],
              [61.584971550000034, 76.28685130400004],
              [61.60474694100003, 76.29572174700007],
              [61.62029056100005, 76.30483633000006],
              [61.63697350400008, 76.31195709800005],
              [61.67514082100007, 76.31517161700003],
              [61.70460045700008, 76.31460195500006],
              [61.71851647200003, 76.31142812700006],
              [61.74732506600003, 76.29637278900003],
              [61.75668379000007, 76.29433828300006],
              [61.903330925000034, 76.29315827000005],
              [61.92758222700007, 76.29743073100008],
              [61.97836347700007, 76.26337311400005],
              [62.093760613000086, 76.25340403900003],
              [62.38249759200005, 76.27118561400005],
              [62.40406334700003, 76.26333242400005],
              [62.406260613000086, 76.25116608300004],
              [62.394867384000065, 76.24115631700005],
              [62.38038170700008, 76.23183828300006],
              [62.37330162900008, 76.22199127800008],
              [62.38892662900008, 76.19708893400008],
              [62.42595462300005, 76.18764883000006],
              [62.469086134000065, 76.18431224200003],
              [62.50367272200003, 76.17767975500004],
              [62.506602410000085, 76.18964264500005],
              [62.514414910000085, 76.19725169500003],
              [62.537852410000085, 76.20868561400005],
              [62.55445397200003, 76.21906159100007],
              [62.55941816500007, 76.21954987200007],
              [62.57195071700005, 76.21857330900008],
              [62.625661655000044, 76.20734284100007],
              [62.651052280000044, 76.20978424700007],
              [62.64771569100003, 76.23163483300004],
              [62.67318769600007, 76.24225495000007],
              [62.77947024800005, 76.27069733300004],
              [62.81234785200007, 76.26996491100005],
              [62.84359785200007, 76.26194896000004],
              [62.86687259200005, 76.24591705900008],
              [62.85206139400003, 76.23444245000007],
              [62.846364780000044, 76.23163483300004],
              [62.92139733200008, 76.23163483300004],
              [62.90154056100005, 76.21857330900008],
              [62.95679772200003, 76.20693594000005],
              [63.17017662900008, 76.24347565300008],
              [63.22038821700005, 76.26268138200004],
              [63.46265709700003, 76.28685130400004],
              [63.48324629000007, 76.29181549700007],
              [63.52955162900008, 76.31679922100005],
              [63.55844160200007, 76.32200755400004],
              [63.62037194100003, 76.32391998900005],
              [63.64795983200008, 76.33185455900008],
              [63.670583530000044, 76.34137604400007],
              [63.69459069100003, 76.34723541900007],
              [63.71924889400003, 76.34967682500007],
              [63.85987389400003, 76.34149811400005],
              [63.93311608200008, 76.36229075700004],
              [63.956065300000034, 76.36322663000004],
              [63.971364780000044, 76.35785553600005],
              [63.98747806100005, 76.34808991100005],
              [64.01441491000008, 76.32538483300004],
              [64.03451582100007, 76.31525299700007],
              [64.06218509200005, 76.31199778900003],
              [64.09083092500003, 76.31281159100007],
              [64.16456139400003, 76.32440827000005],
              [64.26205488400007, 76.35480377800008],
              [64.31299889400003, 76.36322663000004],
              [64.40699303500008, 76.35903554900005],
              [64.43588300900007, 76.36322663000004],
              [64.45020592500003, 76.37124258000006],
              [64.46615644600007, 76.39183177300004],
              [64.47527103000004, 76.39866771000004],
              [64.52369225400008, 76.40110911700003],
              [64.62647545700008, 76.37490469000005],
              [64.67603600400008, 76.38312409100007],
              [64.65406334700003, 76.39354075700004],
              [64.65503991000008, 76.40582916900007],
              [64.66976972700007, 76.41860586100006],
              [64.68970787900008, 76.43085358300004],
              [64.71998131600003, 76.44501373900005],
              [64.74594160200007, 76.44993724200003],
              [64.80640709700003, 76.45136139500005],
              [64.79322350400008, 76.46702708500004],
              [64.78589928500008, 76.47186920800004],
              [64.82593834700003, 76.48419830900008],
              [64.98633873800009, 76.50116608300004],
              [65.03126061300009, 76.50104401200008],
              [65.06804446700005, 76.49457428600005],
              [65.07325280000003, 76.47870514500005],
              [65.10206139400003, 76.46954987200007],
              [65.13542728000004, 76.46942780200004],
              [65.16895592500003, 76.47528717700004],
              [65.22608483200008, 76.49233633000006],
              [65.33863366000008, 76.51312897300005],
              [65.35368899800005, 76.52187734600005],
              [65.38233483200008, 76.54755280200004],
              [65.40316816500007, 76.55853913000004],
              [65.48487389400003, 76.57489655200004],
              [65.61068769600007, 76.58038971600007],
              [65.99138431100005, 76.53335195500006],
              [65.99878991000008, 76.53335195500006],
              [66.03288821700005, 76.54755280200004],
              [66.01710045700008, 76.55744049700007],
              [65.99732506600003, 76.56622955900008],
              [65.97657311300009, 76.57245514500005],
              [65.95736738400007, 76.57489655200004],
              [65.94166100400008, 76.57916901200008],
              [65.93262780000003, 76.58958567900004],
              [65.92660566500007, 76.60211823100008],
              [65.91968834700003, 76.61302317900004],
              [65.88803144600007, 76.63678620000007],
              [65.85254967500003, 76.65228913000004],
              [65.77173912900008, 76.67291901200008],
              [65.75342858200008, 76.68284739800004],
              [65.76124108200008, 76.69342682500007],
              [65.78207441500007, 76.70184967700004],
              [65.82357832100007, 76.70945872600004],
              [65.88892662900008, 76.73940664300005],
              [65.94434655000003, 76.74970123900005],
              [66.10808353000004, 76.75307851800005],
              [66.15105228000004, 76.76276276200008],
              [66.23503665500004, 76.79462311400005],
              [66.27881920700008, 76.80145905200004],
              [66.32781009200005, 76.80097077000005],
              [66.35157311300009, 76.80565013200004],
              [66.37183678500008, 76.81818268400008],
              [66.38754316500007, 76.83661530200004],
              [66.39535566500007, 76.84271881700005],
              [66.40967858200008, 76.84918854400007],
              [66.46192467500003, 76.86050039300005],
              [66.57113691500007, 76.86456940300008],
              [66.62256920700008, 76.87653229400007],
              [66.62973066500007, 76.88149648600006],
              [66.63672936300009, 76.89297109600005],
              [66.64177493600005, 76.89704010600008],
              [66.65406334700003, 76.90070221600007],
              [66.87956790500004, 76.92308177300004],
              [66.91830488400007, 76.94464752800008],
              [66.94353274800005, 76.94896067900004],
              [67.21094811300009, 76.95229726800005],
              [67.34555097700007, 76.98554108300004],
              [67.39918053500008, 76.98602936400005],
              [67.47820071700005, 77.00409577000005],
              [67.58806399800005, 77.01337311400005],
              [68.03443444100003, 76.99848053600005],
              [68.15853925900007, 76.96759674700007],
              [68.29411868600005, 76.95913320500006],
              [68.46290123800009, 76.96670156500005],
              [68.51319420700008, 76.95229726800005],
              [68.48698978000004, 76.94041575700004],
              [68.47803795700008, 76.93170807500007],
              [68.48829186300009, 76.92621491100005],
              [68.56934655000003, 76.92548248900005],
              [68.59327233200008, 76.92096588700008],
              [68.62566165500004, 76.89931875200006],
              [68.67335045700008, 76.88019440300008],
              [68.69044030000003, 76.87653229400007],
              [68.75131269600007, 76.87962474200003],
              [68.78272545700008, 76.87791575700004],
              [68.80860436300009, 76.86908600500004],
              [68.78296959700003, 76.85663483300004],
              [68.76238040500004, 76.84235260600008],
              [68.75912519600007, 76.82737864800004],
              [68.78598066500007, 76.81281159100007],
              [68.89795983200008, 76.79873281500005],
              [68.93091881600003, 76.78717682500007],
              [68.89958743600005, 76.76093170800004],
              [68.89356530000003, 76.74835846600007],
              [68.90300540500004, 76.73261139500005],
              [68.93067467500003, 76.71938711100006],
              [69.00261478000004, 76.71662018400008],
              [69.03394616000008, 76.71206289300005],
              [68.89389082100007, 76.67914459800005],
              [68.85515384200005, 76.65741608300004],
              [68.85035241000008, 76.65082428600005],
              [68.84392337300005, 76.63373444200005],
              [68.83904056100005, 76.62641022300005],
              [68.78760826900003, 76.58856842700004],
              [68.90430748800009, 76.57880280200004],
              [68.93832441500007, 76.56806061400005],
              [68.90211022200003, 76.55247630400004],
              [68.74732506600003, 76.51048411700003],
              [68.62305748800009, 76.45335521000004],
              [68.54965254000007, 76.42938873900005],
              [68.51319420700008, 76.42348867400005],
              [68.43726647200003, 76.42348867400005],
              [68.41700280000003, 76.41722239800004],
              [68.40626061300009, 76.40721263200004],
              [68.40919030000003, 76.40094635600008],
              [68.42090905000003, 76.39765045800004],
              [68.43734785200007, 76.39671458500004],
              [68.39136803500008, 76.36713288000004],
              [68.34351647200003, 76.34992096600007],
              [68.20704186300009, 76.33047109600005],
              [68.18132571700005, 76.32282135600008],
              [68.17774498800009, 76.31460195500006],
              [68.21208743600005, 76.30801015800006],
              [68.30160566500007, 76.30341217700004],
              [68.32748457100007, 76.29433828300006],
              [68.28793379000007, 76.28131745000007],
              [67.91236412900008, 76.25849030200004],
              [67.60206139400003, 76.19814687700006],
              [67.54053795700008, 76.19977448100008],
              [67.36605879000007, 76.16730377800008],
              [67.14649498800009, 76.10464101800005],
              [66.98031660200007, 76.09536367400005],
              [66.80600019600007, 76.06281159100007],
              [66.68628991000008, 76.06024811400005],
              [66.60515384200005, 76.03603750200006],
              [66.52263431100005, 76.02374909100007],
              [66.43018639400003, 75.99884674700007],
              [66.29184004000007, 75.99648672100005],
              [66.22934004000007, 75.97382233300004],
              [66.17855879000007, 75.96198151200008],
              [65.69760175850007, 75.90808746950006],
              [65.21664472700007, 75.85419342700004],
              [65.12427819100003, 75.81867096600007],
              [65.07829837300005, 75.80744049700007],
              [65.02955162900008, 75.80219147300005],
              [64.88917076900003, 75.80878327000005],
              [64.59986412850006, 75.76563141450006],
              [64.31055748800009, 75.72247955900008],
              [64.10377037900008, 75.71893952000005],
              [64.07992597700007, 75.71458567900004],
              [64.03199303500008, 75.69537995000007],
              [63.856455925000034, 75.66913483300004],
              [63.761729363000086, 75.64158763200004],
              [63.709646030000044, 75.63580963700008],
              [63.71794681100005, 75.64931875200006],
              [63.72486412900008, 75.65827057500007],
              [63.72592207100007, 75.66657135600008],
              [63.71648196700005, 75.67796458500004],
              [63.699554884000065, 75.68134186400005],
              [63.675791863000086, 75.68256256700005],
              [63.662119988000086, 75.68817780200004],
              [63.67554772200003, 75.70465729400007],
              [63.648448113000086, 75.71954987200007],
              [63.61646569100003, 75.71938711100006],
              [63.55201256600003, 75.71149323100008],
              [63.59310957100007, 75.70709870000007],
              [63.613291863000086, 75.70233795800004],
              [63.62037194100003, 75.69106679900005],
              [63.610362175000034, 75.68109772300005],
              [63.52133222700007, 75.63271719000005],
              [63.48226972700007, 75.62494538000004],
              [63.441416863000086, 75.62148672100005],
              [63.30437259200005, 75.58860911700003],
              [63.221039259000065, 75.58860911700003],
              [63.170909050000034, 75.58038971600007],
              [63.05225670700008, 75.58942291900007],
              [63.029958530000044, 75.58771393400008],
              [62.734711134000065, 75.51886627800008],
              [62.62134850400008, 75.51557038000004],
              [62.27279707100007, 75.44009023600006],
              [62.224619988000086, 75.43598053600005],
              [62.154307488000086, 75.45380280200004],
              [62.09701582100007, 75.44505442900004],
              [62.07154381600003, 75.44594961100006],
              [62.04818769600007, 75.45034414300005],
              [62.02881920700008, 75.44879791900007],
              [62.01107832100007, 75.44114817900004],
              [61.993174675000034, 75.42723216400003],
              [61.85564212300005, 75.38100820500006],
              [61.845713738000086, 75.36204661700003],
              [61.81006920700008, 75.35683828300006],
              [61.73218834700003, 75.38060130400004],
              [61.69418379000007, 75.37567780200004],
              [61.71265709700003, 75.36078522300005],
              [61.70337975400008, 75.34870026200008],
              [61.660166863000086, 75.32786692900004],
              [61.66773522200003, 75.32538483300004],
              [61.68799889400003, 75.31427643400008],
              [61.67400149800005, 75.30988190300008],
              [61.64625084700003, 75.30516185100004],
              [61.632823113000086, 75.29999420800004],
              [61.641612175000034, 75.29564036700003],
              [61.64665774800005, 75.29116445500006],
              [61.65398196700005, 75.27952708500004],
              [61.60466556100005, 75.27875397300005],
              [61.579112175000034, 75.27505117400005],
              [61.55836022200003, 75.26650625200006],
              [61.54818769600007, 75.25698476800005],
              [61.541351759000065, 75.24713776200008],
              [61.53337649800005, 75.23798248900005],
              [61.51880944100003, 75.23053620000007],
              [61.48170006600003, 75.22345612200007],
              [61.44157962300005, 75.22479889500005],
              [61.40512129000007, 75.23631419500003],
              [61.379649285000085, 75.25967031500005],
              [61.38445071700005, 75.27045319200005],
              [61.387461785000085, 75.28046295800004],
              [61.38835696700005, 75.29010651200008],
              [61.387054884000065, 75.29999420800004],
              [61.379567905000044, 75.30923086100006],
              [61.36939537900008, 75.31517161700003],
              [61.366221550000034, 75.32208893400008],
              [61.379649285000085, 75.33417389500005],
              [61.27662194100003, 75.32786692900004],
              [61.295583530000044, 75.30072663000004],
              [61.29249108200008, 75.27973053600005],
              [61.27165774800005, 75.26349518400008],
              [61.107432488000086, 75.19765859600005],
              [61.03736412900008, 75.18862539300005],
              [60.968760613000086, 75.17023346600007],
              [60.83253014400003, 75.15289948100008],
              [60.81275475400008, 75.14614492400005],
              [60.79802493600005, 75.12083567900004],
              [60.78305097700007, 75.11517975500004],
              [60.74968509200005, 75.10822174700007],
              [60.77523847700007, 75.09389883000006],
              [60.79639733200008, 75.09125397300005],
              [60.803721550000034, 75.08592357000003],
              [60.78687584700003, 75.06386953300006],
              [60.76685631600003, 75.04450104400007],
              [60.74740644600007, 75.03310781500005],
              [60.72478274800005, 75.02765534100007],
              [60.62826582100007, 75.02822500200006],
              [60.59148196700005, 75.03416575700004],
              [60.57016035200007, 75.04677969000005],
              [60.56959069100009, 75.06199778900003],
              [60.57943769600007, 75.07786692900004],
              [60.59522545700008, 75.09186432500007],
              [60.61182701900003, 75.10138580900008],
              [60.594737175000034, 75.11424388200004],
              [60.571055535000085, 75.11790599200003],
              [60.506846550000034, 75.11424388200004],
              [60.49382571700005, 75.11025625200006],
              [60.490244988000086, 75.10374583500004],
              [60.502614780000044, 75.09516022300005],
              [60.44109134200005, 75.06728750200006],
              [60.44467207100007, 75.06427643400008],
              [60.451182488000086, 75.05719635600008],
              [60.45476321700005, 75.05418528900003],
              [60.439463738000086, 75.04808177300004],
              [60.434336785000085, 75.04677969000005],
              [60.46843509200005, 75.03245677300004],
              [60.44483483200008, 75.01825592700004],
              [60.416026238000086, 75.01093170800004],
              [60.264659050000034, 74.99160390800006],
              [60.235036655000044, 74.99152252800008],
              [60.25440514400003, 75.00283437700006],
              [60.262461785000085, 75.00580475500004],
              [60.233409050000034, 75.01935455900008],
              [60.11182701900003, 74.99152252800008],
              [59.92725670700008, 75.00580475500004],
              [59.95622806100005, 74.99017975500004],
              [60.01124108200008, 74.97980377800008],
              [60.31625410250007, 74.97410716350007],
              [60.62126712300005, 74.96841054900005],
              [60.687510613000086, 74.92381419500003],
              [60.66179446700005, 74.91339752800008],
              [60.59131920700008, 74.87543366100005],
              [60.560557488000086, 74.86627838700008],
              [60.32447350400008, 74.85496653900003],
              [60.22348066500007, 74.86432526200008],
              [60.194102410000085, 74.85496653900003],
              [60.207692905000044, 74.84398021000004],
              [60.23015384200005, 74.83295319200005],
              [60.254242384000065, 74.82428620000007],
              [60.27263431100005, 74.82078685100004],
              [60.29737389400003, 74.81903717700004],
              [60.32504316500007, 74.81386953300006],
              [60.35132897200003, 74.80524323100008],
              [60.37232506600009, 74.79352448100008],
              [60.32984459700003, 74.76658763200004],
              [60.276377800000034, 74.74966054900005],
              [59.93376712300005, 74.72528717700004],
              [59.90414472700007, 74.72833893400008],
              [59.846039259000065, 74.74201080900008],
              [59.81755618600005, 74.74510325700004],
              [59.723317905000044, 74.74160390800006],
              [59.69556725400008, 74.74701569200005],
              [59.630869988000086, 74.77586497600004],
              [59.55974368600005, 74.78652578300006],
              [59.508799675000034, 74.79975006700005],
              [59.539805535000085, 74.78685130400004],
              [59.59896894600007, 74.75397370000007],
              [59.622080925000034, 74.73484935100004],
              [59.64193769600007, 74.72699616100005],
              [59.77003014400003, 74.72581614800004],
              [59.77979576900003, 74.72150299700007],
              [59.783539259000065, 74.71625397300005],
              [59.78598066500007, 74.71185944200005],
              [59.789724155000044, 74.70791250200006],
              [59.79672285200007, 74.70408763200004],
              [59.83920332100007, 74.69623444200005],
              [59.85824629000007, 74.69061920800004],
              [59.87256920700008, 74.67682526200008],
              [59.87427819100009, 74.66787344000005],
              [59.87224368600005, 74.64777252800008],
              [59.875987175000034, 74.63930898600006],
              [59.87476647200003, 74.62848541900007],
              [59.85336347700007, 74.62254466400003],
              [59.80909264400003, 74.61713288000004],
              [59.793711785000085, 74.61025625200006],
              [59.77076256600009, 74.59438711100006],
              [59.75521894600007, 74.58746979400007],
              [59.709320509000065, 74.58193594000005],
              [59.601898634000065, 74.59723541900007],
              [59.51685631600009, 74.62156810100004],
              [59.432627800000034, 74.65619538000004],
              [59.37517337300005, 74.66657135600008],
              [59.31763756600009, 74.69049713700008],
              [59.22771243600005, 74.71161530200004],
              [59.15748131600009, 74.73794179900005],
              [59.122080925000034, 74.74677155200004],
              [59.090505405000044, 74.73826732000003],
              [59.114024285000085, 74.72150299700007],
              [59.22445722700007, 74.68162669500003],
              [59.269541863000086, 74.65818919500003],
              [59.289805535000085, 74.64264557500007],
              [59.23389733200008, 74.64154694200005],
              [59.206065300000034, 74.64618561400005],
              [59.18336022200003, 74.65973541900007],
              [59.16228274800005, 74.66730377800008],
              [59.13217207100007, 74.66551341400003],
              [59.10287519600007, 74.65810781500005],
              [59.08366946700005, 74.64887116100005],
              [59.193695509000065, 74.63080475500004],
              [59.221446160000085, 74.61542389500005],
              [59.20630944100009, 74.60537344000005],
              [59.18148847700007, 74.57904694200005],
              [59.16627037900008, 74.56696198100008],
              [59.13331139400003, 74.55048248900005],
              [59.12940514400003, 74.54043203300006],
              [59.14576256600009, 74.52602773600006],
              [59.10718834700003, 74.50824616100005],
              [59.09115644600007, 74.49494049700007],
              [59.094493035000085, 74.48126862200007],
              [59.10962975400008, 74.47601959800005],
              [59.12973066500007, 74.47125885600008],
              [59.143321160000085, 74.46401601800005],
              [59.13835696700005, 74.45087311400005],
              [59.14576256600009, 74.44403717700004],
              [58.86451256600009, 74.45709870000007],
              [58.744802280000044, 74.47821686400005],
              [58.74138431100005, 74.48065827000005],
              [58.739268425000034, 74.49310944200005],
              [58.73487389400003, 74.49803294500003],
              [58.71998131600009, 74.50332265800006],
              [58.45337975350009, 74.54228343300005],
              [58.18677819100009, 74.58124420800004],
              [58.18311608200008, 74.57648346600007],
              [58.17709394600007, 74.56561920800004],
              [58.17310631600009, 74.56073639500005],
              [58.27003014400003, 74.53266022300005],
              [58.418711785000085, 74.51434967700004],
              [58.42628014400003, 74.51235586100006],
              [58.42701256600009, 74.50971100500004],
              [58.42562910200007, 74.50071849200003],
              [58.42628014400003, 74.49803294500003],
              [58.47348066500007, 74.47382233300004],
              [58.638682488000086, 74.42357005400004],
              [58.623708530000044, 74.41327545800004],
              [58.57048587300005, 74.38886139500005],
              [58.63103274800005, 74.36127350500004],
              [58.656586134000065, 74.34048086100006],
              [58.65219160200007, 74.31370677300004],
              [58.67156009200005, 74.30963776200008],
              [58.71111087300005, 74.30658600500004],
              [58.72803795700008, 74.30003489800004],
              [58.70687910200007, 74.28644440300008],
              [58.740977410000085, 74.27277252800008],
              [58.725271030000044, 74.26772695500006],
              [58.69361412900008, 74.26121653900003],
              [58.680349155000044, 74.25165436400005],
              [58.69304446700005, 74.25193919500003],
              [58.70557701900003, 74.25006745000007],
              [58.717458530000044, 74.24575429900005],
              [58.72803795700008, 74.23859284100007],
              [58.536143425000034, 74.23859284100007],
              [58.63111412900008, 74.22703685100004],
              [58.65902754000007, 74.21747467700004],
              [58.50831139400003, 74.21747467700004],
              [58.527354363000086, 74.20229726800005],
              [58.547618035000085, 74.19554271000004],
              [58.569021030000044, 74.19147370000007],
              [58.590830925000034, 74.18402741100005],
              [58.56039472700007, 74.17527903900003],
              [58.52947024800005, 74.17177969000005],
              [58.49822024800005, 74.17251211100006],
              [58.466807488000086, 74.17658112200007],
              [58.44117272200003, 74.18439362200007],
              [58.39975019600007, 74.20294830900008],
              [58.377940300000034, 74.20384349200003],
              [58.34205162900008, 74.19013092700004],
              [58.33318118600005, 74.19293854400007],
              [58.330088738000086, 74.21409739800004],
              [58.318369988000086, 74.22687409100007],
              [58.29224694100009, 74.22162506700005],
              [58.264333530000044, 74.20669179900005],
              [58.24830162900008, 74.19017161700003],
              [58.30062910200007, 74.16063060100004],
              [58.37720787900008, 74.14911530200004],
              [58.52198326900003, 74.14923737200007],
              [58.48324629000007, 74.13190338700008],
              [58.38502037900008, 74.14008209800005],
              [58.34327233200008, 74.12872955900008],
              [58.34131920700008, 74.12274811400005],
              [58.34009850400008, 74.10106028900003],
              [58.336924675000034, 74.09398021000004],
              [58.322927280000044, 74.08795807500007],
              [58.30795332100007, 74.08763255400004],
              [58.299164259000065, 74.09418366100005],
              [58.30290774800005, 74.10830312700006],
              [58.26970462300005, 74.12604401200008],
              [58.21412194100009, 74.14313385600008],
              [58.162119988000086, 74.15037669500003],
              [58.139008009000065, 74.13898346600007],
              [58.145274285000085, 74.12913646000004],
              [58.15845787900008, 74.12360260600008],
              [58.17042076900003, 74.11635976800005],
              [58.17310631600009, 74.10138580900008],
              [58.16163170700008, 74.08991120000007],
              [58.09742272200003, 74.05988190300008],
              [58.164073113000086, 74.05565013200004],
              [58.19849694100009, 74.04612864800004],
              [58.21338951900003, 74.02944570500006],
              [58.21436608200008, 74.01557038000004],
              [58.21338951900003, 74.00836823100008],
              [58.20492597700007, 74.00568268400008],
              [58.18336022200003, 74.00527578300006],
              [58.168955925000034, 74.00324127800008],
              [58.12330162900008, 73.98672109600005],
              [58.108409050000034, 73.98615143400008],
              [58.03012129000007, 74.00470612200007],
              [57.93132571700005, 74.00828685100004],
              [57.81576582100007, 74.04157135600008],
              [57.75416100400008, 74.04682038000004],
              [57.739268425000034, 74.05093008000006],
              [57.726573113000086, 74.05613841400003],
              [57.62435957100007, 74.12128327000005],
              [57.559336785000085, 74.18024323100008],
              [57.53174889400003, 74.19183991100005],
              [57.48878014400003, 74.19342682500007],
              [57.412119988000086, 74.18402741100005],
              [57.48178144600007, 74.14533112200007],
              [57.512705925000034, 74.12343984600005],
              [57.53565514400003, 74.09398021000004],
              [57.47510826900003, 74.07367584800005],
              [57.32699629000007, 74.09271881700005],
              [57.260752800000034, 74.08030833500004],
              [57.52686608200008, 74.06513092700004],
              [57.54769941500007, 74.06077708500004],
              [57.56983483200008, 74.05304596600007],
              [57.61060631600009, 74.02993398600006],
              [57.87842858200008, 73.93431224200003],
              [57.91187584700003, 73.91583893400008],
              [57.85906009200005, 73.91160716400003],
              [57.83253014400003, 73.90631745000007],
              [57.80941816500007, 73.89541250200006],
              [57.83122806100005, 73.88833242400005],
              [57.883474155000044, 73.88483307500007],
              [57.905039910000085, 73.87547435100004],
              [57.906260613000086, 73.86640045800004],
              [57.90447024800005, 73.85366445500006],
              [57.90992272200003, 73.84320709800005],
              [57.93287194100009, 73.84137604400007],
              [57.92790774800005, 73.83169179900005],
              [57.92945397200003, 73.82257721600007],
              [57.936208530000044, 73.81415436400005],
              [57.945974155000044, 73.80658600500004],
              [57.748708530000044, 73.72601959800005],
              [57.71461022200003, 73.72333405200004],
              [57.68148847700007, 73.72931549700007],
              [57.627696160000085, 73.74518463700008],
              [57.62061608200008, 73.75018952000005],
              [57.60710696700005, 73.76902903900003],
              [57.59229576900003, 73.77895742400005],
              [57.53500410200007, 73.79608795800004],
              [57.487071160000085, 73.82074616100005],
              [57.39535566500007, 73.84552643400008],
              [56.97551517000005, 73.86705149950006],
              [56.555674675000034, 73.88857656500005],
              [56.63461347700007, 73.86334870000007],
              [56.931651238000086, 73.85398997600004],
              [57.09555097700007, 73.83014557500007],
              [57.17937259200005, 73.83055247600004],
              [57.21989993600005, 73.82534414300005],
              [57.34986412900008, 73.82758209800005],
              [57.37061608200008, 73.81028880400004],
              [57.38306725400008, 73.79498932500007],
              [57.48991946700005, 73.75433991100005],
              [57.49781334700003, 73.74787018400008],
              [57.50082441500007, 73.73460521000004],
              [57.508148634000065, 73.72768789300005],
              [57.58033287900008, 73.70917389500005],
              [57.590586785000085, 73.70384349200003],
              [57.58716881600009, 73.69367096600007],
              [57.58643639400003, 73.68545156500005],
              [57.59546959700003, 73.67723216400003],
              [57.60792076900003, 73.67108795800004],
              [57.617523634000065, 73.66885000200006],
              [57.60132897200003, 73.65338776200008],
              [57.59489993600005, 73.64500560100004],
              [57.59034264400003, 73.63532135600008],
              [57.60718834700003, 73.63092682500007],
              [57.60206139400003, 73.62254466400003],
              [57.58578535200007, 73.61367422100005],
              [57.56983483200008, 73.60736725500004],
              [57.32960045700008, 73.57387929900005],
              [57.33578535200007, 73.56924062700006],
              [57.35010826900003, 73.55341217700004],
              [57.020192905000044, 73.58421458500004],
              [56.78834069100009, 73.67625560100004],
              [56.751963738000086, 73.68301015800006],
              [56.735118035000085, 73.68024323100008],
              [56.719493035000085, 73.66885000200006],
              [56.746429884000065, 73.64838288000004],
              [56.81690514400003, 73.62946198100008],
              [56.850352410000085, 73.61481354400007],
              [56.82699629000007, 73.60691966400003],
              [56.79997806100005, 73.60512929900005],
              [56.746755405000044, 73.60736725500004],
              [56.78834069100009, 73.59552643400008],
              [56.87720787900008, 73.60073476800005],
              [56.920258009000065, 73.59593333500004],
              [57.08025149800005, 73.53656647300005],
              [57.211273634000065, 73.51699453300006],
              [57.23755944100009, 73.50958893400008],
              [57.24626712300005, 73.50340403900003],
              [57.253916863000086, 73.49135976800005],
              [57.251963738000086, 73.48427969000005],
              [57.245127800000034, 73.47719961100006],
              [57.24268639400003, 73.46865469000005],
              [57.253916863000086, 73.45718008000006],
              [57.22999108200008, 73.45750560100004],
              [57.200205925000034, 73.45307038000004],
              [57.178721550000034, 73.44204336100006],
              [57.178721550000034, 73.42304108300004],
              [56.959646030000044, 73.34052155200004],
              [56.90845787900008, 73.31468333500004],
              [56.89087975400008, 73.31317780200004],
              [56.88135826900003, 73.31753164300005],
              [56.86500084700003, 73.33405182500007],
              [56.85661868600005, 73.34052155200004],
              [56.81413821700005, 73.35736725500004],
              [56.787119988000086, 73.36399974200003],
              [56.76710045700008, 73.36562734600005],
              [56.74927819100009, 73.36151764500005],
              [56.74048912900008, 73.34731679900005],
              [56.74626712300005, 73.33380768400008],
              [56.76148522200003, 73.32672760600008],
              [56.79517662900008, 73.32062409100007],
              [56.739024285000085, 73.29389069200005],
              [56.72315514400003, 73.28241608300004],
              [56.72095787900008, 73.27285390800006],
              [56.73267662900008, 73.26557038000004],
              [56.74927819100009, 73.25918203300006],
              [56.76099694100009, 73.25169505400004],
              [56.72982832100007, 73.24453359600005],
              [56.68734785200007, 73.24339427300004],
              [56.64437910200007, 73.24689362200007],
              [56.578786655000044, 73.26080963700008],
              [56.12086022200003, 73.29002513200004],
              [56.07781009200005, 73.30402252800008],
              [56.04623457100007, 73.33026764500005],
              [56.034190300000034, 73.37124258000006],
              [56.01579837300005, 73.41229889500005],
              [55.971446160000085, 73.43927643400008],
              [55.91749108200008, 73.44839101800005],
              [55.87037194100009, 73.43610260600008],
              [55.936208530000044, 73.41901276200008],
              [55.97120201900003, 73.40298086100006],
              [55.98650149800005, 73.38519928600005],
              [55.98462975400008, 73.37579987200007],
              [55.97282962300005, 73.34731679900005],
              [55.97388756600009, 73.33270905200004],
              [55.98072350400008, 73.33026764500005],
              [55.98023522200003, 73.32965729400007],
              [55.959727410000085, 73.32062409100007],
              [55.92400149800005, 73.31199778900003],
              [55.89087975400008, 73.31736888200004],
              [55.82195071700005, 73.34052155200004],
              [55.77230879000007, 73.34804922100005],
              [55.43490644600007, 73.33209870000007],
              [55.02068118600005, 73.44354889500005],
              [54.90007571700005, 73.44839101800005],
              [54.78052819100009, 73.43610260600008],
              [54.65943444100009, 73.40680573100008],
              [54.56812584700003, 73.40875885600008],
              [54.47388756600009, 73.39081452000005],
              [54.29420006600009, 73.33413320500006],
              [54.250010613000086, 73.32827383000006],
              [54.03305097700007, 73.37466054900005],
              [54.06804446700005, 73.39785390800006],
              [54.13021894600007, 73.41010163000004],
              [54.277354363000086, 73.41478099200003],
              [54.293630405000044, 73.41771067900004],
              [54.30054772200003, 73.42645905200004],
              [54.30160566500007, 73.43378327000005],
              [54.30437259200005, 73.43976471600007],
              [54.30876712300005, 73.44489166900007],
              [54.31495201900003, 73.44969310100004],
              [54.33741295700008, 73.46027252800008],
              [54.41732832100007, 73.47768789300005],
              [54.31495201900003, 73.46881745000007],
              [54.28077233200008, 73.47085195500006],
              [54.184580925000034, 73.49135976800005],
              [54.20362389400003, 73.50495026200008],
              [54.54151451900003, 73.61098867400005],
              [54.61215254000007, 73.61652252800008],
              [54.68091881600009, 73.62986888200004],
              [54.71216881600009, 73.64150625200006],
              [54.78492272200003, 73.65932851800005],
              [54.94076582100007, 73.66547272300005],
              [55.04672285200007, 73.69830963700008],
              [55.088633660000085, 73.70551178600005],
              [55.349619988000086, 73.71723053600005],
              [55.31804446700005, 73.72532786700003],
              [55.28467858200008, 73.72528717700004],
              [55.250987175000034, 73.72117747600004],
              [54.96452884200005, 73.71710846600007],
              [54.93132571700005, 73.71039459800005],
              [54.881195509000065, 73.68854401200008],
              [54.856455925000034, 73.68353913000004],
              [54.82829837300005, 73.69057851800005],
              [54.86296634200005, 73.71942780200004],
              [54.869883660000085, 73.73151276200008],
              [54.84880618600005, 73.73078034100007],
              [54.81104576900003, 73.71991608300004],
              [54.791026238000086, 73.71723053600005],
              [54.72437584700003, 73.71686432500007],
              [54.664073113000086, 73.70477936400005],
              [54.530039910000085, 73.70416901200008],
              [54.49195397200003, 73.69733307500007],
              [54.46257571700005, 73.68065013200004],
              [54.43531334700003, 73.66014232000003],
              [54.40357506600009, 73.64150625200006],
              [54.36939537900008, 73.63190338700008],
              [54.295664910000085, 73.62372467700004],
              [54.26026451900003, 73.61481354400007],
              [54.27466881600009, 73.60358307500007],
              [54.28077233200008, 73.60053131700005],
              [54.11963951900003, 73.61717357000003],
              [54.07398522200003, 73.60871002800008],
              [54.051442905000044, 73.61098867400005],
              [54.006521030000044, 73.62164948100008],
              [53.96648196700005, 73.62665436400005],
              [53.94695071700005, 73.63157786700003],
              [53.930674675000034, 73.64150625200006],
              [53.93832441500007, 73.64272695500006],
              [53.958018425000034, 73.64891185100004],
              [53.94117272200003, 73.65399811400005],
              [53.906911655000044, 73.65827057500007],
              [53.88982181100005, 73.66266510600008],
              [53.87875410200007, 73.66746653900003],
              [53.85499108200008, 73.68309153900003],
              [53.76002037900008, 73.72064850500004],
              [53.732758009000065, 73.72785065300008],
              [53.66749108200008, 73.73501211100006],
              [53.643321160000085, 73.74518463700008],
              [53.63111412900008, 73.75958893400008],
              [53.63257897200003, 73.77008698100008],
              [53.639333530000044, 73.78074778900003],
              [53.643321160000085, 73.79608795800004],
              [53.65357506600009, 73.81248607000003],
              [53.677744988000086, 73.80817291900007],
              [53.724619988000086, 73.78611888200004],
              [53.75896243600005, 73.77968984600005],
              [53.795909050000034, 73.77676015800006],
              [53.86866295700008, 73.77871328300006],
              [54.08155358200008, 73.83392975500004],
              [54.06275475400008, 73.84861888200004],
              [54.078135613000086, 73.86200592700004],
              [54.108083530000044, 73.87177155200004],
              [54.162445509000065, 73.88031647300005],
              [54.25277754000007, 73.91583893400008],
              [54.31592858200008, 73.93097565300008],
              [54.45085696700005, 73.94794342700004],
              [54.62777754000007, 73.95148346600007],
              [54.72584069100009, 73.97793203300006],
              [54.78541100400008, 73.96621328300006],
              [54.801524285000085, 73.97044505400004],
              [54.79997806100005, 73.98541901200008],
              [54.76937910200007, 73.99628327000005],
              [54.70492597700007, 74.00527578300006],
              [54.64047285200007, 74.00218333500004],
              [54.60678144600007, 74.00560130400004],
              [54.588633660000085, 74.01886627800008],
              [54.60279381600009, 74.01992422100005],
              [54.60922285200007, 74.02195872600004],
              [54.67798912900008, 74.06818268400008],
              [54.69483483200008, 74.07416413000004],
              [54.71509850400008, 74.07689036700003],
              [55.01889082100007, 74.17300039300005],
              [55.15455162900008, 74.18838125200006],
              [55.181651238000086, 74.18707916900007],
              [55.20134524800005, 74.18195221600007],
              [55.25180097700007, 74.16107819200005],
              [55.27881920700008, 74.15477122600004],
              [55.39372806100005, 74.14069245000007],
              [55.48682701900003, 74.14923737200007],
              [55.81413821700005, 74.10049062700006],
              [55.84148196700005, 74.10024648600006],
              [55.86443118600005, 74.10594310100004],
              [55.87037194100009, 74.12128327000005],
              [55.85670006600009, 74.12933991100005],
              [55.78142337300005, 74.14744700700004],
              [55.682302280000044, 74.15204498900005],
              [55.63249759200005, 74.16290924700007],
              [55.62273196700005, 74.19017161700003],
              [55.23764082100007, 74.24567291900007],
              [55.14771569100009, 74.24209219000005],
              [55.129893425000034, 74.24481842700004],
              [55.11646569100009, 74.24933502800008],
              [55.090505405000044, 74.26121653900003],
              [55.07585696700005, 74.26593659100007],
              [55.092539910000085, 74.27167389500005],
              [55.12623131600009, 74.27094147300005],
              [55.143565300000034, 74.27277252800008],
              [55.14380944100009, 74.27460358300004],
              [55.14503014400003, 74.27899811400005],
              [55.14730879000007, 74.28363678600005],
              [55.150401238000086, 74.28644440300008],
              [55.18572024800005, 74.29262929900005],
              [55.20915774800005, 74.30206940300008],
              [55.22836347700007, 74.30744049700007],
              [55.246836785000085, 74.30536530200004],
              [55.26710045700008, 74.29262929900005],
              [55.26343834700003, 74.28953685100004],
              [55.25700931100005, 74.28253815300008],
              [55.25342858200008, 74.27960846600007],
              [55.286143425000034, 74.27435944200005],
              [55.40447024800005, 74.28644440300008],
              [55.52857506600009, 74.28204987200007],
              [55.56666100400008, 74.28803131700005],
              [55.62671959700003, 74.30438873900005],
              [55.65788821700005, 74.30499909100007],
              [55.68287194100009, 74.27265045800004],
              [55.708994988000086, 74.27081940300008],
              [55.735036655000044, 74.28001536700003],
              [55.746836785000085, 74.29633209800005],
              [55.73170006600009, 74.30487702000005],
              [55.66032962300005, 74.32953522300005],
              [55.63697350400008, 74.33421458500004],
              [55.61963951900003, 74.33144765800006],
              [55.606211785000085, 74.32746002800008],
              [55.592539910000085, 74.32538483300004],
              [55.574961785000085, 74.32802969000005],
              [55.527354363000086, 74.34609609600005],
              [55.44939212300005, 74.35443756700005],
              [55.29810631600009, 74.35472239800004],
              [55.260752800000034, 74.36074453300006],
              [55.23292076900003, 74.37579987200007],
              [55.349619988000086, 74.43382396000004],
              [55.38835696700005, 74.44505442900004],
              [55.506602410000085, 74.44403717700004],
              [55.61841881600009, 74.46576569200005],
              [55.66358483200008, 74.45929596600007],
              [55.903330925000034, 74.45941803600005],
              [55.94890384200005, 74.46914297100005],
              [55.97291100400008, 74.47138092700004],
              [56.039805535000085, 74.46539948100008],
              [56.10482832100007, 74.47772858300004],
              [56.26335696700005, 74.47996653900003],
              [56.280039910000085, 74.48476797100005],
              [56.28736412900008, 74.49168528900003],
              [56.276052280000044, 74.49998607000003],
              [56.25440514400003, 74.50495026200008],
              [56.23365319100009, 74.50486888200004],
              [56.19190514400003, 74.49803294500003],
              [56.014414910000085, 74.49188873900005],
              [56.02881920700008, 74.50275299700007],
              [56.04615319100009, 74.51113515800006],
              [56.064463738000086, 74.51679108300004],
              [56.082041863000086, 74.51976146000004],
              [55.976898634000065, 74.54604726800005],
              [55.86654707100007, 74.55329010600008],
              [55.81373131600009, 74.54718659100007],
              [55.708994988000086, 74.52236562700006],
              [55.656911655000044, 74.51976146000004],
              [55.69947350400008, 74.54214101800005],
              [55.705821160000085, 74.54987213700008],
              [55.699229363000086, 74.55512116100005],
              [55.66749108200008, 74.57111237200007],
              [55.657237175000034, 74.57440827000005],
              [55.49976647200003, 74.56696198100008],
              [55.56104576900003, 74.61448802300004],
              [55.55486087300005, 74.62221914300005],
              [55.54468834700003, 74.62441640800006],
              [55.53239993600005, 74.63031647300005],
              [55.522471550000034, 74.63886139500005],
              [55.520274285000085, 74.64887116100005],
              [55.52955162900008, 74.65485260600008],
              [55.612315300000034, 74.67609284100007],
              [55.68506920700008, 74.67983633000006],
              [55.75554446700005, 74.69171784100007],
              [55.87037194100009, 74.68366120000007],
              [55.865977410000085, 74.67438385600008],
              [55.86296634200005, 74.67059967700004],
              [55.89600670700008, 74.66063060100004],
              [56.387054884000065, 74.72138092700004],
              [56.41822350400008, 74.72052643400008],
              [56.418304884000065, 74.70408763200004],
              [56.45264733200008, 74.70331452000005],
              [56.555674675000034, 74.68366120000007],
              [56.986989780000044, 74.69049713700008],
            ],
          ],
          [
            [
              [93.86839950400008, 78.14708968500008],
              [93.80767323100008, 78.14311167200003],
              [93.76485364600006, 78.14626837600008],
              [93.69800407700006, 78.15260332700007],
              [93.62907962300005, 78.15704987200007],
              [93.59291351000007, 78.17239763200007],
              [93.59956353600006, 78.18767964700004],
              [93.64647261300007, 78.19767379400008],
              [93.69668947300005, 78.20328590900004],
              [93.74998225000007, 78.20399179800006],
              [93.79272336600008, 78.20302473900006],
              [93.82021979400008, 78.19326273600007],
              [93.86061564300007, 78.18628737400007],
              [93.88238175700008, 78.17871576100003],
              [93.91486798600005, 78.16899167000008],
              [93.92087436700007, 78.15702430600004],
              [93.86839950400008, 78.14708968500008],
            ],
          ],
          [
            [
              [92.45679772200003, 79.11041901200008],
              [92.65992272200003, 79.09178294500003],
              [92.72437584700003, 79.07684967700004],
              [92.51661217500003, 79.08038971600007],
              [92.24219811300003, 79.11522044500003],
              [92.17562910200007, 79.13084544500003],
              [92.18246504000007, 79.13084544500003],
              [92.21338951900003, 79.13955312700006],
              [92.45679772200003, 79.11041901200008],
            ],
          ],
          [
            [
              [92.99057050900007, 79.41950104400007],
              [92.94825280000003, 79.40350983300004],
              [92.90430748800003, 79.39793528900003],
              [92.81324303500003, 79.39899323100008],
              [92.82056725400008, 79.39158763200004],
              [92.79184004000007, 79.38324616100005],
              [92.66895592500003, 79.38760000200006],
              [92.62452233200008, 79.40094635600008],
              [92.60084069100003, 79.40521881700005],
              [92.59351647200003, 79.40521881700005],
              [92.58855228000004, 79.41168854400007],
              [92.58725019600007, 79.41510651200008],
              [92.58725019600007, 79.41950104400007],
              [92.63803144600007, 79.42023346600007],
              [92.79127037900008, 79.44000885600008],
              [92.89242597700007, 79.43573639500005],
              [92.99057050900007, 79.41950104400007],
            ],
          ],
          [
            [
              [92.30543053500003, 79.45302969000005],
              [92.47055097700007, 79.43256256700005],
              [92.44629967500003, 79.42576732000003],
              [92.36768639400003, 79.42572663000004],
              [92.29078209700003, 79.41290924700007],
              [92.26514733200008, 79.41266510600008],
              [92.27214603000004, 79.40497467700004],
              [92.28174889400003, 79.39980703300006],
              [92.30543053500003, 79.39158763200004],
              [92.24382571700005, 79.38231028900003],
              [91.78467858200008, 79.41950104400007],
              [91.94971764400003, 79.42267487200007],
              [92.02881920700008, 79.41331614800004],
              [92.07056725400008, 79.41388580900008],
              [92.11158287900008, 79.42112864800004],
              [92.18181399800005, 79.44782135600008],
              [92.22388756600003, 79.45343659100007],
              [92.30543053500003, 79.45302969000005],
            ],
          ],
          [
            [
              [91.37224368600005, 79.48554108300004],
              [91.53126061300003, 79.44928620000007],
              [91.46314537900008, 79.45986562700006],
              [91.38502037900008, 79.46088288000004],
              [91.36011803500003, 79.46727122600004],
              [91.36264082100007, 79.47113678600005],
              [91.36361738400007, 79.47785065300008],
              [91.33423912900008, 79.48452383000006],
              [91.19483483200008, 79.51508209800005],
              [90.82007897200003, 79.55670807500007],
              [90.79379316500007, 79.56354401200008],
              [91.14421634200005, 79.53733958500004],
              [91.37224368600005, 79.48554108300004],
            ],
          ],
          [
            [
              [100.19996178500003, 79.67894114800004],
              [100.25733483200003, 79.68081289300005],
              [100.28646894600007, 79.67731354400007],
              [100.30982506600003, 79.66596100500004],
              [100.18897545700003, 79.65908437700006],
              [100.07016035200007, 79.63861725500004],
              [99.98601321700005, 79.60179271000004],
              [99.94410241000003, 79.59076569200005],
              [99.90577233200003, 79.60382721600007],
              [99.91895592500003, 79.61334870000007],
              [99.92823326900003, 79.62197500200006],
              [99.93506920700003, 79.63190338700008],
              [99.94044030000003, 79.64545319200005],
              [99.93970787900008, 79.65497467700004],
              [99.93604576900003, 79.66425202000005],
              [99.93604576900003, 79.67430247600004],
              [99.94662519600007, 79.68642812700006],
              [99.98292076900003, 79.69790273600006],
              [100.02076256600003, 79.70156484600005],
              [100.09693444100003, 79.70062897300005],
              [100.08326256600003, 79.68642812700006],
              [100.19996178500003, 79.67894114800004],
            ],
          ],
          [
            [
              [94.32764733200003, 80.02899811400005],
              [94.29314212300005, 80.01801178600005],
              [94.24984785200007, 80.01105377800008],
              [94.16944420700003, 80.00853099200003],
              [94.17188561300003, 80.00551992400005],
              [94.17408287900008, 80.00218333500004],
              [94.17750084700003, 79.99860260600008],
              [94.18295332100007, 79.99485911700003],
              [94.15414472700007, 79.98334381700005],
              [93.99398847700007, 79.96478913000004],
              [93.95948326900003, 79.96527741100005],
              [93.92986087300005, 79.97443268400008],
              [93.95435631600003, 79.99909088700008],
              [93.96810957100007, 80.00918203300006],
              [93.98438561300003, 80.01536692900004],
              [94.12582441500007, 80.01886627800008],
              [94.25025475400008, 80.04010651200008],
              [94.29200280000003, 80.03888580900008],
              [94.32764733200003, 80.02899811400005],
            ],
          ],
          [
            [
              [146.17505944100003, 43.53815338700008],
              [146.20460045700008, 43.53880442900004],
              [146.2207137380001, 43.53701406500005],
              [146.2295028000001, 43.531317450000074],
              [146.22673587300005, 43.520819403000075],
              [146.21461022200003, 43.51219310100004],
              [146.20492597700002, 43.501166083000044],
              [146.20915774800005, 43.48346588700008],
              [146.15186608200008, 43.46279531500005],
              [146.13404381600003, 43.46303945500006],
              [146.12916100400003, 43.46865469000005],
              [146.12647545700008, 43.486029364000046],
              [146.123383009, 43.48969147300005],
              [146.11345462300005, 43.49290599200003],
              [146.10043379, 43.50067780200004],
              [146.07935631600003, 43.517645575000074],
              [146.13168379, 43.54083893400008],
              [146.15748131600003, 43.54633209800005],
              [146.17505944100003, 43.53815338700008],
            ],
          ],
          [
            [
              [146.88168379, 43.85919830900008],
              [146.895843946, 43.850897528000075],
              [146.9101668630001, 43.844631252000056],
              [146.925140821, 43.84247467700004],
              [146.94214928500003, 43.84662506700005],
              [146.93539472700002, 43.830064195000034],
              [146.926605665, 43.81439850500004],
              [146.9145613940001, 43.802720445000034],
              [146.89828535200002, 43.79824453300006],
              [146.8779403000001, 43.79677969000005],
              [146.86540774800005, 43.79271067900004],
              [146.8403426440001, 43.77830638200004],
              [146.83350670700008, 43.77826569200005],
              [146.8266707690001, 43.781317450000074],
              [146.81902103000004, 43.78192780200004],
              [146.80933678500003, 43.774603583000044],
              [146.80241946700005, 43.767238674000055],
              [146.79314212300005, 43.759466864000046],
              [146.78345787900003, 43.75348541900007],
              [146.77458743600005, 43.75104401200008],
              [146.75749759200005, 43.74835846600007],
              [146.7426863940001, 43.74331289300005],
              [146.7275496750001, 43.74017975500004],
              [146.7094832690001, 43.74359772300005],
              [146.71631920700008, 43.72992584800005],
              [146.693695509, 43.71629466400009],
              [146.68189537900003, 43.711371161000045],
              [146.6684676440001, 43.709418036000045],
              [146.65064537900003, 43.712591864000046],
              [146.6250106130001, 43.72675202000005],
              [146.609711134, 43.72992584800005],
              [146.60222415500004, 43.73607005400004],
              [146.603851759, 43.750433661000045],
              [146.61312910200002, 43.77830638200004],
              [146.60954837300005, 43.789496161000045],
              [146.60328209700003, 43.80036041900007],
              [146.60466556100005, 43.808579820000034],
              [146.64795983200008, 43.81476471600007],
              [146.6743270190001, 43.821966864000046],
              [146.76872806100005, 43.86082591400009],
              [146.79558353000004, 43.86701080900008],
              [146.8193465500001, 43.86029694200005],
              [146.8320418630001, 43.87201569200005],
              [146.8462020190001, 43.87832265800006],
              [146.86052493600005, 43.87718333500004],
              [146.87452233200008, 43.86709219000005],
              [146.88168379, 43.85919830900008],
            ],
          ],
          [
            [
              [146.4692488940001, 44.42877838700008],
              [146.55193118600005, 44.45111725500004],
              [146.57211347700002, 44.44989655200004],
              [146.55486087300005, 44.40802643400008],
              [146.54835045700008, 44.398098049000055],
              [146.5439559250001, 44.39276764500005],
              [146.53882897200003, 44.38296133000006],
              [146.53467858200008, 44.37763092700004],
              [146.5293074880001, 44.37335846600007],
              [146.51905358200008, 44.368353583000044],
              [146.51392662900003, 44.36395905200004],
              [146.50318444100003, 44.36212799700007],
              [146.47234134200005, 44.37689850500004],
              [146.45923912900003, 44.38104889500005],
              [146.44800866000003, 44.37872955900008],
              [146.41431725400003, 44.36786530200004],
              [146.407074415, 44.36395905200004],
              [146.40202884200005, 44.36237213700008],
              [146.37370853000004, 44.32636139500005],
              [146.3642684250001, 44.31793854400007],
              [146.32585696700005, 44.292222398000035],
              [146.3037215500001, 44.282131252000056],
              [146.2734481130001, 44.273423570000034],
              [146.24366295700008, 44.27049388200004],
              [146.22339928500003, 44.27798086100006],
              [146.20199629, 44.269598700000074],
              [146.13941491000003, 44.265692450000074],
              [146.116547071, 44.25438060100004],
              [146.11117597700002, 44.24884674700007],
              [146.1040145190001, 44.24315013200004],
              [146.09636478000004, 44.23875560100004],
              [146.08936608200008, 44.23700592700004],
              [146.08521569100003, 44.234076239000046],
              [146.07935631600003, 44.21930573100008],
              [146.07593834700003, 44.21344635600008],
              [146.064789259, 44.20148346600007],
              [146.05640709700003, 44.19432200700004],
              [146.04664147200003, 44.18895091400009],
              [146.03101647200003, 44.18235911700003],
              [145.93140709700003, 44.12091705900008],
              [145.92302493600005, 44.113714911000045],
              [145.89340254, 44.07998281500005],
              [145.88697350400003, 44.06940338700008],
              [145.887543165, 44.039048570000034],
              [145.8837996750001, 44.026597398000035],
              [145.87330162900003, 44.01788971600007],
              [145.85377037900003, 44.024725653000075],
              [145.83155358200008, 44.019964911000045],
              [145.81324303500003, 44.00653717700004],
              [145.8056746750001, 43.987209377000056],
              [145.801605665, 43.96747467700004],
              [145.79167728000004, 43.948553778000075],
              [145.778168165, 43.93256256700005],
              [145.764008009, 43.92169830900008],
              [145.74594160200002, 43.91303131700005],
              [145.72681725400003, 43.90656159100007],
              [145.6621199880001, 43.89817942900004],
              [145.64763431100005, 43.890326239000046],
              [145.6201278000001, 43.86709219000005],
              [145.58871504, 43.84756094000005],
              [145.5810653000001, 43.833685614000046],
              [145.5722762380001, 43.72992584800005],
              [145.557953321, 43.657904364000046],
              [145.55616295700008, 43.65265534100007],
              [145.5517684250001, 43.657863674000055],
              [145.54712975400003, 43.667181708000044],
              [145.544281446, 43.674709377000056],
              [145.5439559250001, 43.68724192900004],
              [145.54859459700003, 43.70302969000005],
              [145.544281446, 43.709418036000045],
              [145.5517684250001, 43.71625397300005],
              [145.5141707690001, 43.73574453300006],
              [145.47486412900003, 43.72557200700004],
              [145.44312584700003, 43.72451406500005],
              [145.42758222700002, 43.77090078300006],
              [145.4296981130001, 43.797308661000045],
              [145.42758222700002, 43.80560944200005],
              [145.42261803500003, 43.81240469000005],
              [145.41529381600003, 43.820298570000034],
              [145.40992272200003, 43.828558661000045],
              [145.41089928500003, 43.836004950000074],
              [145.42058353000004, 43.84349192900004],
              [145.44214928500003, 43.85028717700004],
              [145.45183353000004, 43.85651276200008],
              [145.47380618600005, 43.88580963700008],
              [145.48226972700002, 43.89443594000005],
              [145.54184004, 43.91864655200004],
              [145.5517684250001, 43.925441799000055],
              [145.56080162900003, 43.93789297100005],
              [145.66163170700008, 43.99062734600005],
              [145.6801863940001, 44.02045319200005],
              [145.68531334700003, 44.025376695000034],
              [145.70777428500003, 44.030585028000075],
              [145.72877037900003, 44.04376862200007],
              [145.74594160200002, 44.06126536700003],
              [145.757172071, 44.079413153000075],
              [145.764008009, 44.117254950000074],
              [145.76832116000003, 44.12531159100007],
              [145.7871199880001, 44.140692450000074],
              [145.79127037900003, 44.15135325700004],
              [145.80103600400003, 44.16006094000005],
              [145.84595787900003, 44.18032461100006],
              [145.85962975400003, 44.18927643400008],
              [145.862640821, 44.19790273600006],
              [145.86508222700002, 44.218817450000074],
              [145.8696395190001, 44.22703685100004],
              [145.89722741000003, 44.25438060100004],
              [145.91431725400003, 44.26577383000006],
              [145.95476321700005, 44.277329820000034],
              [145.96949303500003, 44.28538646000004],
              [145.97486412900003, 44.292303778000075],
              [145.97917728000004, 44.300767320000034],
              [145.98218834700003, 44.30927155200004],
              [145.98316491000003, 44.31614817900004],
              [145.98747806100005, 44.32371653900009],
              [146.00562584700003, 44.33633047100005],
              [146.0097762380001, 44.34316640800006],
              [146.01246178500003, 44.366115627000056],
              [146.01978600400003, 44.38263580900008],
              [146.03077233200008, 44.395819403000075],
              [146.04468834700003, 44.40892161700003],
              [146.09099368600005, 44.478216864000046],
              [146.11931399800005, 44.50604889500005],
              [146.16138756600003, 44.511379299000055],
              [146.18311608200008, 44.51080963700008],
              [146.1943465500001, 44.50653717700004],
              [146.24756920700008, 44.46698639500005],
              [146.25416100400003, 44.46356842700004],
              [146.2793074880001, 44.457017320000034],
              [146.33383222700002, 44.42853424700007],
              [146.36345462300005, 44.42202383000006],
              [146.4692488940001, 44.42877838700008],
            ],
          ],
          [
            [
              [148.799164259, 45.415676174000055],
              [148.80648847700002, 45.40448639500005],
              [148.84400475400003, 45.37103913000004],
              [148.84343509200005, 45.35175202000005],
              [148.81666100400003, 45.33348216400009],
              [148.7822371750001, 45.31940338700008],
              [148.7583113940001, 45.31268952000005],
              [148.72877037900003, 45.31110260600008],
              [148.6450301440001, 45.32013580900008],
              [148.584320509, 45.31549713700008],
              [148.55616295700008, 45.30703359600005],
              [148.4687606130001, 45.259466864000046],
              [148.43824303500003, 45.24852122600004],
              [148.34351647200003, 45.23891836100006],
              [148.277679884, 45.22256094000005],
              [148.2158309250001, 45.195746161000045],
              [148.127289259, 45.13108958500004],
              [148.06787452100002, 45.07959012400005],
              [148.02388849600004, 45.03866737700008],
              [147.99030926, 45.005797994000034],
              [147.96351136300007, 44.99892833300004],
              [147.91302404500004, 44.96300168400006],
              [147.864897724, 44.963835320000044],
              [147.8320418630001, 44.96531810100004],
              [147.80925540500004, 44.96381256700005],
              [147.79664147200003, 44.960638739000046],
              [147.7783309250001, 44.946519273000035],
              [147.76832116000003, 44.943345445000034],
              [147.73873891000005, 44.96818608500007],
              [147.7257949330001, 44.99219538700004],
              [147.70077651500003, 45.007986257000084],
              [147.6538007470001, 44.99485105500008],
              [147.6259871750001, 44.96942780200004],
              [147.6209180940001, 44.950685846000056],
              [147.62677705500005, 44.93156173600005],
              [147.64879602000008, 44.92110857000006],
              [147.64544915500005, 44.90809570000005],
              [147.6274520190001, 44.90110911700003],
              [147.6171981130001, 44.891506252000056],
              [147.5864363940001, 44.867621161000045],
              [147.57837975400003, 44.85691966400009],
              [147.5644637380001, 44.83356354400007],
              [147.55543053500003, 44.823553778000075],
              [147.4853621750001, 44.77838776200008],
              [147.38837682200005, 44.73665873400006],
              [147.33033287900003, 44.68821849200003],
              [147.28891035200002, 44.660589911000045],
              [147.27173912900003, 44.64175039300005],
              [147.2260268020001, 44.58100204600004],
              [147.15326665700002, 44.55911948900007],
              [147.1132569250001, 44.57038670800006],
              [147.05469895800002, 44.537169815000084],
              [147.0185653000001, 44.50263092700004],
              [146.99366295700008, 44.48037344000005],
              [146.97779381600003, 44.45742422100005],
              [146.97038821700005, 44.43740469000005],
              [146.958343946, 44.42104726800005],
              [146.93818284400004, 44.42278787100008],
              [146.91236831600008, 44.43273754900008],
              [146.87603852900008, 44.43414403200006],
              [146.86179580400005, 44.44533723400008],
              [146.85832294500005, 44.461981355000034],
              [146.86347514800002, 44.475318522000066],
              [146.873383009, 44.489894924000055],
              [146.89242597700002, 44.50429922100005],
              [146.90739993600005, 44.52216217700004],
              [146.93831476100002, 44.53613833600008],
              [146.94985470300003, 44.54894331300005],
              [146.9370948090001, 44.56828781400009],
              [146.93130800200004, 44.58600917400008],
              [146.92920983200008, 44.60691966400009],
              [146.93702654900005, 44.62482239700006],
              [146.95163947600008, 44.622260338000046],
              [146.95998428100006, 44.60202264800006],
              [146.96193723300007, 44.58393584200007],
              [146.984230207, 44.57221345900007],
              [147.00074303500003, 44.56598541900007],
              [147.02158031600004, 44.58168272000006],
              [147.03782467200006, 44.599012264000066],
              [147.02734454000006, 44.62048577400009],
              [147.01042728000004, 44.63426341400009],
              [146.99862314400002, 44.66261245700008],
              [147.0311005860001, 44.668953155000054],
              [147.06766366800002, 44.64603342300006],
              [147.09142733400006, 44.63735817400004],
              [147.1291597080001, 44.647109957000055],
              [147.1528426440001, 44.67397695500006],
              [147.19658000100003, 44.71368175500004],
              [147.20093860100008, 44.731091691000074],
              [147.2039314010001, 44.755435427000066],
              [147.16086706500005, 44.77056610800008],
              [147.12188569900002, 44.77630120400005],
              [147.09652754, 44.795803127000056],
              [147.10919889900003, 44.82714813000007],
              [147.1515775580001, 44.834477193000055],
              [147.19060170300008, 44.808964666000065],
              [147.21654031600008, 44.79900713600006],
              [147.24987793100001, 44.820875879000084],
              [147.240570509, 44.850897528000075],
              [147.26441491000003, 44.867621161000045],
              [147.36052493600005, 44.90110911700003],
              [147.40837649800005, 44.93650950700004],
              [147.45378665500004, 44.95856354400007],
              [147.46656334700003, 44.96694570500006],
              [147.4843856130001, 44.98533763200004],
              [147.49488366000003, 45.00495026200008],
              [147.50074303500003, 45.027044989000046],
              [147.5039168630001, 45.05320872600004],
              [147.50310306100005, 45.066473700000074],
              [147.50074303500003, 45.073431708000044],
              [147.50180097700002, 45.07880280200004],
              [147.51140384200005, 45.08734772300005],
              [147.5263778000001, 45.09393952000005],
              [147.54167728000004, 45.09284088700008],
              [147.55616295700008, 45.08633047100005],
              [147.56902103000004, 45.07648346600007],
              [147.59302819100003, 45.06439850500004],
              [147.6196395190001, 45.065334377000056],
              [147.64600670700008, 45.07611725500004],
              [147.6689559250001, 45.09357330900008],
              [147.73389733200008, 45.16559479400007],
              [147.75700931100005, 45.18573639500005],
              [147.7812606130001, 45.197699286000045],
              [147.88624108200008, 45.218736070000034],
              [147.894867384, 45.223944403000075],
              [147.89429772200003, 45.237534898000035],
              [147.88453209700003, 45.24787018400008],
              [147.8730574880001, 45.25726959800005],
              [147.867523634, 45.26829661700003],
              [147.874359571, 45.30955638200004],
              [147.8720809250001, 45.32050202000005],
              [147.86207116000003, 45.34210846600007],
              [147.860687696, 45.35423411700003],
              [147.8715926440001, 45.38035716400009],
              [147.89275149800005, 45.39671458500004],
              [147.91773522200003, 45.409857489000046],
              [147.9399520190001, 45.42625560100004],
              [147.95093834700003, 45.431341864000046],
              [147.95826256600003, 45.42340729400007],
              [147.96241295700008, 45.40997955900008],
              [147.96509850400003, 45.38385651200008],
              [147.9692488940001, 45.37441640800006],
              [147.99756920700008, 45.33462148600006],
              [148.00147545700008, 45.32591380400004],
              [148.004730665, 45.31268952000005],
              [148.00505618600005, 45.29873281500005],
              [148.00318444100003, 45.28974030200004],
              [148.00464928500003, 45.28119538000004],
              [148.01490319100003, 45.26829661700003],
              [148.0395613940001, 45.25462474200003],
              [148.06959069100003, 45.251166083000044],
              [148.311859571, 45.27529531500005],
              [148.36101321700005, 45.29962799700007],
              [148.39966881600003, 45.339178778000075],
              [148.4238387380001, 45.35887278900009],
              [148.4472762380001, 45.36733633000006],
              [148.44947350400003, 45.37262604400007],
              [148.46843509200005, 45.397650458000044],
              [148.47730553500003, 45.405462958000044],
              [148.50603274800005, 45.41937897300005],
              [148.53239993600005, 45.43622467700004],
              [148.5512801440001, 45.45726146000004],
              [148.56031334700003, 45.46344635600008],
              [148.569672071, 45.466131903000075],
              [148.59148196700005, 45.468003648000035],
              [148.60075931100005, 45.47089264500005],
              [148.60694420700008, 45.476996161000045],
              [148.6176863940001, 45.49396393400008],
              [148.6211043630001, 45.49823639500005],
              [148.629242384, 45.50096263200004],
              [148.64673912900003, 45.50267161700003],
              [148.7265731130001, 45.52521393400008],
              [148.76392662900003, 45.52789948100008],
              [148.799164259, 45.51813385600008],
              [148.85132897200003, 45.48151276200008],
              [148.85621178500003, 45.46434153900009],
              [148.8271590500001, 45.443019924000055],
              [148.80144290500004, 45.43500397300005],
              [148.79672285200002, 45.429388739000046],
              [148.799164259, 45.415676174000055],
            ],
          ],
          [
            [
              [150.33423912900003, 46.21084219000005],
              [150.397406143, 46.23110152700008],
              [150.47822867900004, 46.20998136900005],
              [150.569349547, 46.23175790200008],
              [150.51542835500004, 46.18983845300005],
              [150.473480665, 46.16046784100007],
              [150.44410241000003, 46.141913153000075],
              [150.39332116000003, 46.10040924700007],
              [150.3632918630001, 46.08152903900009],
              [150.3222762380001, 46.069240627000056],
              [150.28618225000002, 46.045529599000076],
              [150.24536862600007, 46.03703213700004],
              [150.22868899800005, 46.00849030200004],
              [150.1899744440001, 45.983828611000035],
              [150.179611723, 45.94870304600005],
              [150.197601759, 45.92963288000004],
              [150.19092858200008, 45.92670319200005],
              [150.15696537200006, 45.921620947000065],
              [150.14579817900005, 45.91186393800007],
              [150.14234459700003, 45.89801666900007],
              [150.113617384, 45.87929922100005],
              [150.086273634, 45.87067291900007],
              [150.03819057700002, 45.84309366800005],
              [150.0229505960001, 45.82379688600008],
              [149.99577630400006, 45.81854274300008],
              [149.9728711140001, 45.81968806200007],
              [149.94763534000003, 45.82236743300007],
              [149.92287366900007, 45.81071206200005],
              [149.92139733200008, 45.79376862200007],
              [149.87061608200008, 45.77826569200005],
              [149.842133009, 45.760199286000045],
              [149.75464928500003, 45.68414948100008],
              [149.70191491000003, 45.64789459800005],
              [149.6377659110001, 45.61094607900009],
              [149.603745388, 45.605364835000046],
              [149.58326256600003, 45.63226959800005],
              [149.5771590500001, 45.63727448100008],
              [149.57447350400003, 45.62490469000005],
              [149.57374108200008, 45.60846588700008],
              [149.57016035200002, 45.603216864000046],
              [149.56275475400003, 45.60008372600004],
              [149.54997806100005, 45.59039948100008],
              [149.52906334700003, 45.58356354400007],
              [149.43669681100005, 45.58698151200008],
              [149.44459069100003, 45.59438711100006],
              [149.45297285200002, 45.59979889500005],
              [149.46582254600003, 45.62430633400004],
              [149.48230892200002, 45.66937736600005],
              [149.5122176440001, 45.67401764500005],
              [149.52955162900003, 45.693793036000045],
              [149.53541100400003, 45.69818756700005],
              [149.5478621750001, 45.70563385600008],
              [149.55339603000004, 45.70990631700005],
              [149.56706790500004, 45.731634833000044],
              [149.59498131600003, 45.76512278900009],
              [149.59644616000003, 45.77057526200008],
              [149.59555097700002, 45.783270575000074],
              [149.597992384, 45.78900788000004],
              [149.6045028000001, 45.79246653900009],
              [149.6191512380001, 45.79271067900004],
              [149.62574303500003, 45.796128648000035],
              [149.6528426440001, 45.82371653900009],
              [149.667328321, 45.853216864000046],
              [149.69361412900003, 45.861029364000046],
              [149.7519637380001, 45.86074453300006],
              [149.8110457690001, 45.87982819200005],
              [149.85075931100005, 45.91705963700008],
              [149.88396243600005, 45.96039459800005],
              [149.92335045700008, 45.99795156500005],
              [150.02016890700008, 46.07302358000004],
              [150.094574415, 46.09471263200004],
              [150.1084090500001, 46.095404364000046],
              [150.135101759, 46.09292226800005],
              [150.149750196, 46.09471263200004],
              [150.1806746750001, 46.10541413000004],
              [150.19459069100003, 46.11359284100007],
              [150.207855665, 46.12482330900008],
              [150.2114363940001, 46.134751695000034],
              [150.1819053270001, 46.159732715000075],
              [150.21105639100006, 46.17922017800004],
              [150.245075983, 46.190836052000066],
              [150.28848684700006, 46.19622762100005],
              [150.33423912900003, 46.21084219000005],
            ],
          ],
          [
            [
              [152.2055770190001, 47.12881094000005],
              [152.23023522200003, 47.13816966400009],
              [152.25538170700008, 47.15485260600008],
              [152.2778426440001, 47.16185130400004],
              [152.2949324880001, 47.14248281500005],
              [152.184418165, 47.071478583000044],
              [152.17351321700005, 47.056626695000034],
              [152.157074415, 47.01894765800006],
              [152.13941491000003, 47.003119208000044],
              [152.0864363940001, 46.97675202000005],
              [152.0752059250001, 46.968003648000035],
              [152.07211347700002, 46.95575592700004],
              [152.064789259, 46.948553778000075],
              [152.0556746750001, 46.94330475500004],
              [152.047211134, 46.93699778900009],
              [152.0200301440001, 46.90289948100008],
              [151.99927819100003, 46.889878648000035],
              [151.98462968400008, 46.87855620800008],
              [151.95178559700003, 46.859836606000044],
              [151.920258009, 46.855536200000074],
              [151.908051429, 46.83550125700003],
              [151.88891253200006, 46.81676595400006],
              [151.85060091100002, 46.79047320600006],
              [151.80141489300001, 46.76603202100006],
              [151.7636824880001, 46.77997467700004],
              [151.751312696, 46.78266022300005],
              [151.73560631600003, 46.78945547100005],
              [151.7212020190001, 46.798163153000075],
              [151.71216881600003, 46.806626695000034],
              [151.71111087300005, 46.81549713700008],
              [151.7138778000001, 46.82518138200004],
              [151.71412194100003, 46.83608633000006],
              [151.70533287900003, 46.84829336100006],
              [151.745453321, 46.861761786000045],
              [151.83765709700003, 46.85626862200007],
              [151.87330162900003, 46.87181224200003],
              [151.922211134, 46.92792389500005],
              [151.9502059250001, 46.95209381700005],
              [152.04965254, 47.014960028000075],
              [152.15894616000003, 47.13385651200008],
              [152.22543379, 47.17658112200007],
              [152.22543379, 47.16974518400008],
              [152.21371504, 47.163316148000035],
              [152.2055770190001, 47.153998114000046],
              [152.20045006600003, 47.14232005400004],
              [152.19874108200008, 47.12881094000005],
              [152.2055770190001, 47.12881094000005],
            ],
          ],
          [
            [
              [152.50342858200008, 47.383246161000045],
              [152.52133222700002, 47.37250397300005],
              [152.53663170700008, 47.348822333000044],
              [152.54029381600003, 47.32514069200005],
              [152.52444390900007, 47.298645934000035],
              [152.48168840000005, 47.301350650000074],
              [152.42973104500004, 47.31919081700005],
              [152.41315419400007, 47.34067053800004],
              [152.4133727100001, 47.367127861000085],
              [152.4262801440001, 47.38349030200004],
              [152.4502059250001, 47.38703034100007],
              [152.50342858200008, 47.383246161000045],
            ],
          ],
          [
            [
              [153.02127099400002, 47.79959657900008],
              [153.04928631200005, 47.80789084400004],
              [153.06160554000007, 47.79355592500008],
              [153.06386339000005, 47.780160884000054],
              [153.06636651600002, 47.76116963700008],
              [153.0688187940001, 47.743296497000074],
              [153.05977248, 47.72184257400005],
              [153.04711174300007, 47.707023493000065],
              [153.02800540500004, 47.697333075000074],
              [153.01099694100003, 47.69782135600008],
              [152.99263039100003, 47.69711128900008],
              [152.97825383500003, 47.68433281800009],
              [152.9661079880001, 47.69528769300007],
              [152.96680495400005, 47.71677805500008],
              [152.97095433800007, 47.73481251900006],
              [152.9701891960001, 47.75157035600006],
              [152.98267872300005, 47.76968218800005],
              [153.00191459100006, 47.78578321100008],
              [153.02127099400002, 47.79959657900008],
            ],
          ],
          [
            [
              [153.288422071, 48.077460028000075],
              [153.29078209700003, 48.06500885600008],
              [153.29704837300005, 48.054673570000034],
              [153.29363040500004, 48.042181708000044],
              [153.2754727360001, 48.03273889500008],
              [153.2517203000001, 48.040147964000084],
              [153.233300945, 48.03980896400009],
              [153.20093778400008, 48.052645710000036],
              [153.18482506600003, 48.069240627000056],
              [153.15906880900002, 48.09218029900006],
              [153.16455577400006, 48.12141547200008],
              [153.21472652400007, 48.125724698000056],
              [153.2403780100001, 48.11387509300005],
              [153.25922627500006, 48.10413783200005],
              [153.288422071, 48.077460028000075],
            ],
          ],
          [
            [
              [154.2129012380001, 48.917669989000046],
              [154.230804884, 48.89716217700004],
              [154.22136478000004, 48.87287018400008],
              [154.1992293630001, 48.85053131700005],
              [154.1787215500001, 48.83567942900004],
              [154.08741295700008, 48.794256903000075],
              [154.06267337300005, 48.77423737200007],
              [154.0590926440001, 48.762152411000045],
              [154.06023196700005, 48.74872467700004],
              [154.05640709700003, 48.73777903900009],
              [154.03882897200003, 48.73322174700007],
              [154.00855553500003, 48.73281484600005],
              [153.99724368600005, 48.734442450000074],
              [153.98072350400003, 48.739488023000035],
              [153.97331790500004, 48.739488023000035],
              [153.97608483200008, 48.76243724200003],
              [153.99366295700008, 48.779364325000074],
              [154.06592858200008, 48.807847398000035],
              [154.0781356130001, 48.81671784100007],
              [154.10035241000003, 48.83881256700005],
              [154.1045028000001, 48.851263739000046],
              [154.10035241000003, 48.86359284100007],
              [154.10035241000003, 48.87299225500004],
              [154.11736087300005, 48.876654364000046],
              [154.119476759, 48.899603583000044],
              [154.1469832690001, 48.91498444200005],
              [154.1836043630001, 48.92137278900009],
              [154.2129012380001, 48.917669989000046],
            ],
          ],
          [
            [
              [153.98698978000004, 48.96539948100008],
              [154.00074303500003, 48.95978424700007],
              [154.012054884, 48.95294830900008],
              [154.01433353000004, 48.944525458000044],
              [154.0009871750001, 48.93439362200007],
              [153.98357181100005, 48.929388739000046],
              [153.96070397200003, 48.92670319200005],
              [153.93913821700005, 48.927069403000075],
              [153.92554772200003, 48.931301174000055],
              [153.91871178500003, 48.931301174000055],
              [153.90691165500004, 48.94367096600007],
              [153.90211022200003, 48.95648834800005],
              [153.9047957690001, 48.96946849200003],
              [153.9150496750001, 48.982489325000074],
              [153.927093946, 48.981756903000075],
              [153.98698978000004, 48.96539948100008],
            ],
          ],
          [
            [
              [154.5629988940001, 49.15717194200005],
              [154.58383222700002, 49.14866771000004],
              [154.5996199880001, 49.12995026200008],
              [154.60132897200003, 49.11107005400004],
              [154.5800887380001, 49.10260651200008],
              [154.55250084700003, 49.096869208000044],
              [154.53150475400003, 49.08624909100007],
              [154.5117293630001, 49.08022695500006],
              [154.48780358200008, 49.088324286000045],
              [154.47234134200005, 49.10443756700005],
              [154.454437696, 49.14158763200004],
              [154.4394637380001, 49.15717194200005],
              [154.4438582690001, 49.16518789300005],
              [154.44947350400003, 49.16974518400008],
              [154.4570418630001, 49.17145416900007],
              [154.49195397200003, 49.17031484600005],
              [154.5376082690001, 49.159857489000046],
              [154.5629988940001, 49.15717194200005],
            ],
          ],
          [
            [
              [154.44755767000004, 49.816984250000075],
              [154.48006287400005, 49.81103513900007],
              [154.49133796500007, 49.783252395000034],
              [154.47251850200007, 49.762212713000054],
              [154.46084751600006, 49.74432009900005],
              [154.447928434, 49.72951019800007],
              [154.41191697800002, 49.73309557400006],
              [154.3912405110001, 49.749186734000034],
              [154.378956, 49.76534803200008],
              [154.37390441700006, 49.778467248000084],
              [154.380891991, 49.789363463000086],
              [154.39499155500005, 49.804185833000076],
              [154.42237181100006, 49.816015640000046],
              [154.44755767000004, 49.816984250000075],
            ],
          ],
          [
            [
              [156.12525475400003, 50.63751862200007],
              [156.136078321, 50.62445709800005],
              [156.15552819100003, 50.60887278900009],
              [156.15943444100003, 50.59662506700005],
              [156.15748131600003, 50.58856842700004],
              [156.14795983200008, 50.56395091400009],
              [156.14576256600003, 50.55158112200007],
              [156.15259850400003, 50.53034088700008],
              [156.15251712300005, 50.51902903900009],
              [156.13493899800005, 50.51121653900009],
              [156.119476759, 50.49799225500004],
              [156.11158287900003, 50.49355703300006],
              [156.10474694100003, 50.49286530200004],
              [156.09050540500004, 50.49408600500004],
              [156.08366946700005, 50.49355703300006],
              [156.06788170700008, 50.49005768400008],
              [156.05689537900003, 50.48627350500004],
              [156.0493270190001, 50.47931549700007],
              [156.04273522200003, 50.46625397300005],
              [156.03931725400003, 50.45343659100007],
              [156.03972415500004, 50.44391510600008],
              [156.0415145190001, 50.43451569200005],
              [156.04273522200003, 50.42218659100007],
              [156.0376082690001, 50.40989817900004],
              [156.02556399800005, 50.402044989000046],
              [156.0107528000001, 50.39549388200004],
              [155.99756920700008, 50.38739655200004],
              [155.9882918630001, 50.37840403900009],
              [155.94125410200002, 50.318019924000055],
              [155.89722741000003, 50.27521393400008],
              [155.89185631600003, 50.26422760600008],
              [155.88493899800005, 50.25372955900008],
              [155.868500196, 50.24860260600008],
              [155.8369246750001, 50.243475653000075],
              [155.82154381600003, 50.23505280200004],
              [155.812836134, 50.22675202000005],
              [155.78199303500003, 50.18964264500005],
              [155.77320397200003, 50.18659088700008],
              [155.62281334700003, 50.179388739000046],
              [155.5615340500001, 50.16657135600008],
              [155.50147545700008, 50.13727448100008],
              [155.48031660200002, 50.11908600500004],
              [155.4228621750001, 50.03546784100007],
              [155.412445509, 50.011053778000075],
              [155.39576256600003, 49.995794989000046],
              [155.3642684250001, 50.000067450000074],
              [155.3789168630001, 50.02301666900007],
              [155.38453209700003, 50.03750234600005],
              [155.37671959700003, 50.046861070000034],
              [155.3505965500001, 50.054754950000074],
              [155.29460696700005, 50.064520575000074],
              [155.26514733200008, 50.06386953300006],
              [155.24146569100003, 50.054754950000074],
              [155.22779381600003, 50.054754950000074],
              [155.21656334700003, 50.06708405200004],
              [155.21306399800005, 50.08120351800005],
              [155.21509850400003, 50.09589264500005],
              [155.22087649800005, 50.10993073100008],
              [155.22934004, 50.120428778000075],
              [155.2407332690001, 50.13060130400004],
              [155.25074303500003, 50.14158763200004],
              [155.25505618600005, 50.15468984600005],
              [155.252289259, 50.16705963700008],
              [155.243011915, 50.19399648600006],
              [155.24488366000003, 50.202460028000075],
              [155.24984785200002, 50.21576569200005],
              [155.24000084700003, 50.226629950000074],
              [155.19288170700008, 50.25348541900007],
              [155.18734785200002, 50.26154205900008],
              [155.18677819100003, 50.27448151200008],
              [155.20191491000003, 50.29352448100008],
              [155.2334090500001, 50.30463288000004],
              [155.26783287900003, 50.306708075000074],
              [155.32016035200002, 50.28888580900008],
              [155.3466903000001, 50.30219147300005],
              [155.3847762380001, 50.34271881700005],
              [155.4101668630001, 50.36017487200007],
              [155.441742384, 50.37055084800005],
              [155.4765731130001, 50.37555573100008],
              [155.54029381600003, 50.37567780200004],
              [155.549164259, 50.37689850500004],
              [155.55494225400003, 50.38076406500005],
              [155.5644637380001, 50.39362213700008],
              [155.5703231130001, 50.397365627000056],
              [155.58814537900003, 50.39789459800005],
              [155.61646569100003, 50.387152411000045],
              [155.6318465500001, 50.383693752000056],
              [155.65894616000003, 50.38886139500005],
              [155.68962649800005, 50.40371328300006],
              [155.7177840500001, 50.423081773000035],
              [155.76710045700008, 50.468410549000055],
              [155.775726759, 50.47931549700007],
              [155.78003991000003, 50.48895905200004],
              [155.785492384, 50.51068756700005],
              [155.7895613940001, 50.52024974200003],
              [155.819672071, 50.564113674000055],
              [155.85425866000003, 50.600043036000045],
              [155.86207116000003, 50.614569403000075],
              [155.87077884200005, 50.65973541900007],
              [155.87818444100003, 50.67853424700007],
              [155.88949629, 50.69086334800005],
              [155.97779381600003, 50.747381903000075],
              [156.00928795700008, 50.75633372600004],
              [156.04118899800005, 50.772772528000075],
              [156.0732528000001, 50.78156159100007],
              [156.10474694100003, 50.767279364000046],
              [156.1171981130001, 50.74909088700008],
              [156.12322024800005, 50.728176174000055],
              [156.12525475400003, 50.68195221600007],
              [156.12370853000004, 50.67055898600006],
              [156.12094160200002, 50.66071198100008],
              [156.12037194100003, 50.65033600500004],
              [156.12525475400003, 50.63751862200007],
            ],
          ],
          [
            [
              [156.46045983200008, 50.87372467700004],
              [156.48357181100005, 50.85691966400009],
              [156.49187259200005, 50.83808014500005],
              [156.49768182600008, 50.813362736000045],
              [156.49987510300002, 50.79671095000003],
              [156.502063442, 50.78088733300007],
              [156.51099024300004, 50.76584855100003],
              [156.50001194700008, 50.749327116000075],
              [156.482408599, 50.73203740900004],
              [156.46885966600007, 50.71886611100007],
              [156.4566325400001, 50.70236339400009],
              [156.43223753000007, 50.67184881700007],
              [156.40577233200008, 50.65420156500005],
              [156.40577233200008, 50.630113023000035],
              [156.3852645190001, 50.630113023000035],
              [156.3540145190001, 50.63629791900007],
              [156.32105553500003, 50.63751862200007],
              [156.303850473, 50.63563966700008],
              [156.27244270300002, 50.63340604900009],
              [156.25822770700006, 50.650964567000074],
              [156.23707116000003, 50.66128164300005],
              [156.2060653000001, 50.67129140800006],
              [156.180023634, 50.68842194200005],
              [156.16627037900003, 50.713324286000045],
              [156.1684676440001, 50.73663971600007],
              [156.1806746750001, 50.76117584800005],
              [156.19939212300005, 50.780503648000035],
              [156.221039259, 50.788397528000075],
              [156.2544051440001, 50.79319896000004],
              [156.28077233200008, 50.805975653000075],
              [156.33130944100003, 50.84365469000005],
              [156.3574324880001, 50.85618724200003],
              [156.3955184250001, 50.868475653000075],
              [156.43376712300005, 50.87592194200005],
              [156.46045983200008, 50.87372467700004],
            ],
          ],
          [
            [
              [155.5634871750001, 50.808254299000055],
              [155.52328535200002, 50.81342194200005],
              [155.4921981130001, 50.82843659100007],
              [155.46762129, 50.85248444200005],
              [155.44678795700008, 50.88458893400008],
              [155.47413170700008, 50.92182038000004],
              [155.54379066400008, 50.929819818000055],
              [155.6312646, 50.91228352200005],
              [155.6728621750001, 50.870306708000044],
              [155.66994119900005, 50.811953876000075],
              [155.64537449300008, 50.806855960000064],
              [155.59978274800005, 50.80927155200004],
              [155.5634871750001, 50.808254299000055],
            ],
          ],
          [
            [
              [142.54965254, 54.30223216400003],
              [142.56763756600003, 54.309759833000044],
              [142.58716881600003, 54.31329987200007],
              [142.60417728000004, 54.310207424000055],
              [142.58806399800005, 54.303900458000044],
              [142.54070071700005, 54.29779694200005],
              [142.54965254, 54.30223216400003],
            ],
          ],
          [
            [
              [137.82178795700008, 54.45783112200007],
              [137.83228600400003, 54.49103424700007],
              [137.85808353000004, 54.50189850500004],
              [137.8896590500001, 54.50364817900004],
              [137.9179793630001, 54.509426174000055],
              [137.92505944100003, 54.488714911000045],
              [137.92750084700003, 54.47451406500005],
              [137.92172285200002, 54.464097398000035],
              [137.9043074880001, 54.454779364000046],
              [137.86353600400003, 54.446519273000035],
              [137.84831790500004, 54.43773021000004],
              [137.83570397200003, 54.39911530200004],
              [137.819672071, 54.38495514500005],
              [137.79859459700003, 54.37563711100006],
              [137.73218834700003, 54.36440664300005],
              [137.71509850400003, 54.367173570000034],
              [137.7187606130001, 54.38589101800005],
              [137.71648196700005, 54.39215729400007],
              [137.72038821700005, 54.39370351800005],
              [137.7392684250001, 54.39207591400003],
              [137.74830162900003, 54.394598700000074],
              [137.80347741000003, 54.43244049700007],
              [137.8164168630001, 54.44432200700004],
              [137.82178795700008, 54.45783112200007],
            ],
          ],
          [
            [
              [137.62256920700008, 54.57078685100004],
              [137.62680097700002, 54.554348049000055],
              [137.6294051440001, 54.53668854400007],
              [137.63559004, 54.520819403000075],
              [137.6504012380001, 54.509426174000055],
              [137.6450301440001, 54.50145091400003],
              [137.64332116000003, 54.49555084800005],
              [137.6450301440001, 54.48981354400007],
              [137.6504012380001, 54.482123114000046],
              [137.6372176440001, 54.47565338700008],
              [137.62322024800005, 54.466782945000034],
              [137.61247806100005, 54.45538971600007],
              [137.60889733200008, 54.441107489000046],
              [137.61402428500003, 54.42829010600008],
              [137.63445071700005, 54.411322333000044],
              [137.6411238940001, 54.400458075000074],
              [137.61345462300005, 54.40778229400007],
              [137.58961022200003, 54.40058014500005],
              [137.56812584700003, 54.39663320500006],
              [137.54672285200002, 54.41380442900004],
              [137.5688582690001, 54.42633698100008],
              [137.57203209700003, 54.44863515800006],
              [137.5610457690001, 54.495754299000055],
              [137.55811608200008, 54.50079987200007],
              [137.5527449880001, 54.50470612200007],
              [137.5478621750001, 54.50922272300005],
              [137.54672285200002, 54.51626211100006],
              [137.55103600400003, 54.52204010600008],
              [137.5747176440001, 54.53668854400007],
              [137.59644616000003, 54.55768463700008],
              [137.60808353000004, 54.565741278000075],
              [137.62256920700008, 54.57078685100004],
            ],
          ],
          [
            [
              [168.05925540500004, 54.54661692900004],
              [168.0703231130001, 54.53921133000006],
              [168.101898634, 54.52496979400007],
              [168.110687696, 54.51626211100006],
              [168.1103621750001, 54.50348541900007],
              [168.09929446700005, 54.50104401200008],
              [168.08375084700003, 54.50446198100008],
              [168.04249108200008, 54.521551825000074],
              [167.98585045700008, 54.55540599200003],
              [167.93734785200002, 54.594183661000045],
              [167.82007897200003, 54.647365627000056],
              [167.8051863940001, 54.65135325700004],
              [167.7705184250001, 54.65403880400004],
              [167.75220787900003, 54.657863674000055],
              [167.7348738940001, 54.663397528000075],
              [167.7231551440001, 54.67047760600008],
              [167.69898522200003, 54.68968333500004],
              [167.50114993600005, 54.78510163000004],
              [167.44890384200005, 54.82046133000006],
              [167.43913821700005, 54.86627838700008],
              [167.472992384, 54.866848049000055],
              [167.51978600400003, 54.85610586100006],
              [167.55779056100005, 54.839178778000075],
              [167.56511478000004, 54.82127513200004],
              [167.56267337300005, 54.80731842700004],
              [167.57740319100003, 54.79755280200004],
              [167.59913170700008, 54.79181549700007],
              [167.64039147200003, 54.78851959800005],
              [167.65772545700008, 54.78432851800005],
              [167.6923934250001, 54.76947663000004],
              [167.73406009200005, 54.76264069200005],
              [167.7407332690001, 54.755519924000055],
              [167.75375410200002, 54.728501695000034],
              [167.7685653000001, 54.712551174000055],
              [167.78402754, 54.70172760600008],
              [167.80193118600005, 54.69570547100005],
              [167.82300866000003, 54.693793036000045],
              [167.84522545700008, 54.68732330900008],
              [167.8750106130001, 54.65916575700004],
              [167.8916121750001, 54.652777411000045],
              [167.90984134200005, 54.65070221600007],
              [167.9243270190001, 54.64447663000004],
              [167.93734785200002, 54.634019273000035],
              [167.95240319100003, 54.61928945500006],
              [167.97877037900003, 54.598863023000035],
              [168.0361434250001, 54.56655508000006],
              [168.05925540500004, 54.54661692900004],
            ],
          ],
          [
            [
              [137.171234571, 55.11953359600005],
              [137.18531334700003, 55.10626862200007],
              [137.1806746750001, 55.09320709800005],
              [137.113617384, 55.025376695000034],
              [137.09498131600003, 55.01398346600007],
              [137.07105553500003, 55.00971100500004],
              [137.06511478000004, 55.00023021000004],
              [137.07178795700008, 54.97992584800005],
              [137.08228600400003, 54.960638739000046],
              [137.08814537900003, 54.954413153000075],
              [137.07496178500003, 54.93317291900007],
              [137.04859459700003, 54.92328522300005],
              [137.017914259, 54.920355536000045],
              [136.94304446700005, 54.92283763200004],
              [136.92986087300005, 54.927720445000034],
              [136.92741946700005, 54.933661200000074],
              [136.92855879, 54.94212474200003],
              [136.9287215500001, 54.95099518400008],
              [136.92335045700008, 54.95783112200007],
              [136.895843946, 54.960150458000044],
              [136.84131920700008, 54.93781159100007],
              [136.8247176440001, 54.93768952000005],
              [136.81275475400003, 54.943019924000055],
              [136.80298912900003, 54.93886953300006],
              [136.79371178500003, 54.93158600500004],
              [136.78337649800005, 54.927720445000034],
              [136.75904381600003, 54.93260325700004],
              [136.74887129, 54.93109772300005],
              [136.738617384, 54.92031484600005],
              [136.74537194100003, 54.91364166900007],
              [136.7597762380001, 54.893011786000045],
              [136.73812910200002, 54.88507721600007],
              [136.7153426440001, 54.891791083000044],
              [136.6923934250001, 54.90273672100005],
              [136.6704207690001, 54.90729401200008],
              [136.6704207690001, 54.91351959800005],
              [136.68572024800005, 54.921210028000075],
              [136.688324415, 54.93113841400003],
              [136.68726647200003, 54.942572333000044],
              [136.690765821, 54.954413153000075],
              [136.70093834700003, 54.96478913000004],
              [136.71119225400003, 54.96938711100006],
              [136.738617384, 54.97553131700005],
              [136.754730665, 54.98232656500005],
              [136.793793165, 55.00971100500004],
              [136.80925540500004, 55.01805247600004],
              [136.82341556100005, 55.023138739000046],
              [136.8559676440001, 55.03021881700005],
              [136.9790145190001, 55.08685944200005],
              [137.04607181100005, 55.10643138200004],
              [137.08814537900003, 55.08539459800005],
              [137.1015731130001, 55.10700104400007],
              [137.1220809250001, 55.12128327000005],
              [137.14633222700002, 55.126166083000044],
              [137.171234571, 55.11953359600005],
            ],
          ],
          [
            [
              [138.04672285200002, 55.05805084800005],
              [138.1372176440001, 55.06317780200004],
              [138.1836043630001, 55.05760325700004],
              [138.21216881600003, 55.036363023000035],
              [138.18824303500003, 55.02106354400007],
              [138.1328231130001, 55.01557038000004],
              [138.11280358200008, 55.006293036000045],
              [138.047699415, 54.94082265800006],
              [138.03443444100003, 54.937201239000046],
              [138.02100670700008, 54.93724192900004],
              [138.01091556100005, 54.933254299000055],
              [138.00342858200008, 54.90509674700007],
              [137.996429884, 54.89565664300005],
              [137.98951256600003, 54.88825104400007],
              [137.98617597700002, 54.88275788000004],
              [137.99236087300005, 54.85879140800006],
              [138.00269616000003, 54.83881256700005],
              [138.004730665, 54.819525458000044],
              [137.98617597700002, 54.79743073100008],
              [137.87907962300005, 54.75971100500004],
              [137.86280358200008, 54.738714911000045],
              [137.85694420700008, 54.725775458000044],
              [137.843109571, 54.71507396000004],
              [137.78858483200008, 54.68585846600007],
              [137.766449415, 54.66705963700008],
              [137.7602645190001, 54.66453685100004],
              [137.7426863940001, 54.660223700000074],
              [137.7392684250001, 54.65619538000004],
              [137.73943118600005, 54.64557526200008],
              [137.73853600400003, 54.64057038000004],
              [137.73585045700008, 54.636379299000055],
              [137.71892337300005, 54.624335028000075],
              [137.7060653000001, 54.624986070000034],
              [137.6777449880001, 54.64321523600006],
              [137.65308678500003, 54.65509674700007],
              [137.64625084700003, 54.661322333000044],
              [137.58521569100003, 54.75104401200008],
              [137.57439212300005, 54.75958893400008],
              [137.563812696, 54.76593659100007],
              [137.5527449880001, 54.77484772300005],
              [137.54411868600005, 54.78473541900007],
              [137.53443444100003, 54.813666083000044],
              [137.5195418630001, 54.839056708000044],
              [137.50147545700008, 54.86318594000005],
              [137.4853621750001, 54.879339911000045],
              [137.4306746750001, 54.86570872600004],
              [137.39470462300005, 54.85138580900008],
              [137.29273522200003, 54.79584381700005],
              [137.26091556100005, 54.78367747600004],
              [137.225922071, 54.77781810100004],
              [137.2426863940001, 54.79865143400008],
              [137.24919681100005, 54.80914948100008],
              [137.25375410200002, 54.82469310100004],
              [137.25611412900003, 54.86078522300005],
              [137.25953209700003, 54.87250397300005],
              [137.27491295700008, 54.89826080900008],
              [137.29664147200003, 54.923081773000035],
              [137.32056725400003, 54.94403717700004],
              [137.35621178500003, 54.96889883000006],
              [137.37647545700008, 54.995794989000046],
              [137.39014733200008, 55.006293036000045],
              [137.40845787900003, 55.011379299000055],
              [137.44459069100003, 55.01618073100008],
              [137.4614363940001, 55.02680084800005],
              [137.4765731130001, 55.045355536000045],
              [137.49089603000004, 55.07050202000005],
              [137.4980574880001, 55.096909898000035],
              [137.4921981130001, 55.11953359600005],
              [137.51710045700008, 55.13515859600005],
              [137.5439559250001, 55.178615627000056],
              [137.56788170700008, 55.194647528000075],
              [137.60613040500004, 55.200100002000056],
              [137.63884524800005, 55.19253164300005],
              [137.70492597700002, 55.16791413000004],
              [137.7021590500001, 55.151271877000056],
              [137.7207137380001, 55.14638906500005],
              [137.746918165, 55.146144924000055],
              [137.76710045700008, 55.143459377000056],
              [137.78638756600003, 55.137600002000056],
              [137.8559676440001, 55.13320547100005],
              [137.8794051440001, 55.13816966400003],
              [137.9043074880001, 55.14752838700008],
              [137.929047071, 55.15314362200007],
              [137.9521590500001, 55.14687734600005],
              [137.9614363940001, 55.13450755400004],
              [137.96599368600005, 55.11969635600008],
              [137.972015821, 55.10643138200004],
              [137.98617597700002, 55.09906647300005],
              [137.966156446, 55.071966864000046],
              [137.89812259200005, 55.025458075000074],
              [137.883148634, 55.00287506700005],
              [138.02491295700008, 55.05573151200008],
              [138.04672285200002, 55.05805084800005],
            ],
          ],
          [
            [
              [166.664398634, 54.75641510600008],
              [166.66521243600005, 54.73379140800006],
              [166.65845787900003, 54.717962958000044],
              [166.6547957690001, 54.702337958000044],
              [166.664398634, 54.68008047100005],
              [166.65211022200003, 54.68732330900008],
              [166.62452233200008, 54.71002838700008],
              [166.61304772200003, 54.714829820000034],
              [166.5922957690001, 54.71771881700005],
              [166.57927493600005, 54.72524648600006],
              [166.55453535200002, 54.74900950700004],
              [166.5019637380001, 54.780462958000044],
              [166.48585045700008, 54.80133698100008],
              [166.5000106130001, 54.82469310100004],
              [166.47478274800005, 54.83234284100007],
              [166.44507897200003, 54.83392975500004],
              [166.39763431100005, 54.83152903900003],
              [166.374359571, 54.833319403000075],
              [166.3564559250001, 54.839544989000046],
              [166.29835045700008, 54.88385651200008],
              [166.29078209700003, 54.89203522300005],
              [166.28777103000004, 54.903550523000035],
              [166.28191165500004, 54.908270575000074],
              [166.253265821, 54.91844310100004],
              [166.23170006600003, 54.93154531500005],
              [166.206390821, 54.93659088700008],
              [166.1953231130001, 54.944525458000044],
              [166.18930097700002, 54.95368073100008],
              [166.18246504, 54.97247955900008],
              [166.17790774800005, 54.981756903000075],
              [166.1626082690001, 54.999701239000046],
              [166.082855665, 55.060614325000074],
              [166.0800887380001, 55.06932200700004],
              [166.08480879, 55.07990143400008],
              [166.08855228000004, 55.10219961100006],
              [166.0805770190001, 55.120428778000075],
              [166.02361087300005, 55.17755768400008],
              [165.98121178500003, 55.193426825000074],
              [165.969574415, 55.205511786000045],
              [165.99293053500003, 55.221909898000035],
              [165.961761915, 55.23061758000006],
              [165.8984481130001, 55.25726959800005],
              [165.80054772200003, 55.271918036000045],
              [165.76482181100005, 55.28270091400003],
              [165.746429884, 55.29706452000005],
              [165.8203231130001, 55.30125560100004],
              [165.8584090500001, 55.30878327000005],
              [165.89031009200005, 55.32127513200004],
              [165.901703321, 55.330511786000045],
              [165.91667728000004, 55.35101959800005],
              [165.92408287900003, 55.35854726800005],
              [165.9404403000001, 55.36497630400004],
              [165.9555770190001, 55.36424388200004],
              [166.17994225400003, 55.31940338700008],
              [166.24000084700003, 55.33185455900008],
              [166.25367272200003, 55.33185455900008],
              [166.2583113940001, 55.32127513200004],
              [166.2661238940001, 55.31342194200005],
              [166.27621504, 55.307806708000044],
              [166.28777103000004, 55.303900458000044],
              [166.2412215500001, 55.269964911000045],
              [166.22632897200003, 55.250067450000074],
              [166.24097741000003, 55.21499258000006],
              [166.24000084700003, 55.17413971600007],
              [166.24431399800005, 55.16233958500004],
              [166.25025475400003, 55.15228913000004],
              [166.26734459700003, 55.13320547100005],
              [166.27995853000004, 55.122707424000055],
              [166.30640709700003, 55.105536200000074],
              [166.31853274800005, 55.09564850500004],
              [166.35328209700003, 55.054388739000046],
              [166.36475670700008, 55.04572174700007],
              [166.3769637380001, 55.03925202000005],
              [166.3867293630001, 55.03172435100004],
              [166.395355665, 55.00625234600005],
              [166.40601647200003, 54.998928127000056],
              [166.4184676440001, 54.99274323100008],
              [166.44809004, 54.96112702000005],
              [166.4790145190001, 54.94354889500005],
              [166.5410262380001, 54.92031484600005],
              [166.5732528000001, 54.91242096600007],
              [166.5849715500001, 54.90477122600004],
              [166.58952884200005, 54.88959381700005],
              [166.649750196, 54.84454987200007],
              [166.64820397200003, 54.83392975500004],
              [166.64087975400003, 54.82294342700004],
              [166.6372176440001, 54.81110260600008],
              [166.64136803500003, 54.796087958000044],
              [166.65796959700003, 54.770697333000044],
              [166.664398634, 54.75641510600008],
            ],
          ],
          [
            [
              [150.72527103000004, 59.12799713700008],
              [150.77915858200004, 59.10951608400006],
              [150.782800263, 59.09086381600008],
              [150.749894981, 59.08089599900006],
              [150.722590761, 59.07322615700008],
              [150.7084797230001, 59.05556757700003],
              [150.6539393920001, 59.02833590100005],
              [150.610699887, 59.00571978800008],
              [150.55562554900007, 58.999557063000054],
              [150.48138836700002, 58.99968964700008],
              [150.47207555900002, 59.00415294700008],
              [150.48683983700005, 59.02574819800003],
              [150.50758471900008, 59.03910526400006],
              [150.54828142400004, 59.06189591400005],
              [150.598334809, 59.080198041000074],
              [150.62789453200003, 59.08645284700003],
              [150.66309301900003, 59.09501802300008],
              [150.68391665600006, 59.10833700200004],
              [150.69009118200006, 59.12511428600004],
              [150.698530441, 59.14044604400004],
              [150.7099715500001, 59.13963450700004],
              [150.72527103000004, 59.12799713700008],
            ],
          ],
          [
            [
              [164.7069004880001, 58.97682818700008],
              [164.69087841700002, 58.95514530400004],
              [164.68964827000002, 58.94047178200003],
              [164.68140709700003, 58.925848700000074],
              [164.6855574880001, 58.91502513200004],
              [164.68083743600005, 58.905178127000056],
              [164.6318735430001, 58.865365928000074],
              [164.56585947400004, 58.86245617000009],
              [164.460476976, 58.86775447300005],
              [164.40772545700008, 58.864894924000055],
              [164.34929446700005, 58.84528229400007],
              [164.303579323, 58.82700427600008],
              [164.29083039500006, 58.80817281700007],
              [164.25600978500006, 58.79860358700006],
              [164.2314559250001, 58.81264883000006],
              [164.22152754, 58.81354401200008],
              [164.21078535200002, 58.81598541900007],
              [164.19068444100003, 58.82318756700005],
              [164.1796981130001, 58.82566966400003],
              [164.17017662900003, 58.824286200000074],
              [164.16081790500004, 58.821600653000075],
              [164.134071544, 58.80249295500005],
              [164.121246541, 58.78071756800006],
              [164.08617008600004, 58.76523625100003],
              [164.03973011100004, 58.74848578000007],
              [163.98742924400005, 58.728916189000074],
              [163.95484887500004, 58.70752698900009],
              [163.914706196, 58.70096272900008],
              [163.88233483200008, 58.702785549000055],
              [163.84603488200003, 58.69051468100008],
              [163.7899395820001, 58.642870594000044],
              [163.66912539300006, 58.59625996600005],
              [163.58546241400006, 58.55789026900004],
              [163.5526810890001, 58.52164746500006],
              [163.514999729, 58.497146755000074],
              [163.490018932, 58.44450321800008],
              [163.471157973, 58.46097754300007],
              [163.445648634, 58.47557200700004],
              [163.44518303900009, 58.50549532600007],
              [163.41285435400005, 58.53536894400008],
              [163.416344481, 58.550026080000066],
              [163.44499633700002, 58.56139059600008],
              [163.555287291, 58.57302892900003],
              [163.61054268600003, 58.607463142000086],
              [163.638184389, 58.651108639000086],
              [163.65437805800002, 58.69050542200006],
              [163.6754733260001, 58.715129895000075],
              [163.7252879240001, 58.749628091000034],
              [163.74666489700007, 58.77714402700008],
              [163.77955161300008, 58.81040226200008],
              [163.77259460900007, 58.83540616600004],
              [163.76632706600003, 58.87212445700004],
              [163.78175768000006, 58.89387347500008],
              [163.82053260600003, 58.92549675100008],
              [163.859849489, 58.961472074000085],
              [163.91319136000004, 58.994291270000076],
              [163.8935653000001, 59.01007721600007],
              [163.87867272200003, 59.00950755400004],
              [163.8481551440001, 59.005072333000044],
              [163.83423912900003, 59.007025458000044],
              [163.80420983200008, 59.016058661000045],
              [163.78980553500003, 59.01813385600008],
              [163.757138823, 59.00711314300008],
              [163.73084180900003, 58.99580205600006],
              [163.696386341, 58.99194479100004],
              [163.71720185700008, 59.00627132500006],
              [163.74928256200008, 59.01895985800007],
              [163.80418487100007, 59.03127791600008],
              [163.9666983740001, 59.02856146600004],
              [164.28305097700002, 59.113714911000045],
              [164.3173934250001, 59.13141510600008],
              [164.340668165, 59.15131256700005],
              [164.39519290500004, 59.18390534100007],
              [164.45337975400003, 59.208644924000055],
              [164.55811608200008, 59.23969147300005],
              [164.58082116000003, 59.234076239000046],
              [164.57878665500004, 59.19245026200008],
              [164.58082116000003, 59.18317291900007],
              [164.58765709700003, 59.181708075000074],
              [164.60954837300005, 59.184800523000035],
              [164.6162215500001, 59.18317291900007],
              [164.61744225400003, 59.17853424700007],
              [164.615570509, 59.16648997600004],
              [164.6162215500001, 59.161444403000075],
              [164.629242384, 59.11123281500005],
              [164.6372176440001, 59.09935130400004],
              [164.67465254, 59.08417389500005],
              [164.68767337300005, 59.07709381700005],
              [164.705414259, 59.04877350500004],
              [164.73407172300006, 59.02325303300006],
              [164.70954073100006, 59.00617528400005],
              [164.7069004880001, 58.97682818700008],
            ],
          ],
          [
            [
              [155.50771059200008, 59.328127136000035],
              [155.53368599400005, 59.33783518200005],
              [155.56693249700004, 59.340423609000084],
              [155.6001496450001, 59.33514669600004],
              [155.60004935200004, 59.31942877700004],
              [155.56967223700008, 59.32086883900007],
              [155.5341903000001, 59.31818268400008],
              [155.509035809, 59.32014779600007],
              [155.50771059200008, 59.328127136000035],
            ],
          ],
          [
            [
              [29.791351759000065, 59.99485911700003],
              [29.79851321700005, 59.99005768400008],
              [29.80054772200009, 59.985541083000044],
              [29.79664147200009, 59.98334381700005],
              [29.792491082000083, 59.97866445500006],
              [29.78687584700009, 59.97508372600004],
              [29.733653191000087, 59.99628327000005],
              [29.728851759000065, 60.00153229400007],
              [29.716807488000086, 60.00617096600007],
              [29.699229363000086, 60.01032135600008],
              [29.657399936000047, 60.025458075000074],
              [29.668711785000085, 60.02789948100008],
              [29.713552280000044, 60.02187734600005],
              [29.787445509000065, 59.99677155200004],
              [29.791351759000065, 59.99485911700003],
            ],
          ],
          [
            [
              [27.885020379000082, 60.011053778000075],
              [27.891612175000034, 60.003607489000046],
              [27.89234459700009, 59.995021877000056],
              [27.873871290000068, 59.99481842700004],
              [27.820485873000052, 59.98273346600007],
              [27.804860873000052, 59.989488023000035],
              [27.802582227000073, 59.999335028000075],
              [27.807871941000087, 60.00991445500006],
              [27.809743686000047, 60.02020905200004],
              [27.82007897200009, 60.03082916900007],
              [27.841075066000087, 60.02643463700008],
              [27.869313998000052, 60.013739325000074],
              [27.885020379000082, 60.011053778000075],
            ],
          ],
          [
            [
              [27.022227410000085, 60.042181708000044],
              [27.025401238000086, 60.03729889500005],
              [27.027354363000086, 60.02676015800006],
              [27.020681186000047, 60.017564195000034],
              [27.00831139400009, 60.01386139500005],
              [26.99577884200005, 60.01422760600008],
              [26.984711134000065, 60.01772695500006],
              [26.976817254000082, 60.02570221600007],
              [26.967539910000085, 60.04368724200003],
              [26.964366082000083, 60.04706452000005],
              [26.962168816000087, 60.05951569200005],
              [26.944509311000047, 60.09137604400007],
              [26.950043165000068, 60.09955475500004],
              [26.964121941000087, 60.09943268400008],
              [26.976573113000086, 60.08844635600008],
              [26.98682701900009, 60.07599518400008],
              [26.99708092500009, 60.06631094000005],
              [27.007823113000086, 60.057847398000035],
              [27.017832879000082, 60.04791901200008],
              [27.022227410000085, 60.042181708000044],
            ],
          ],
          [
            [
              [28.711761915000068, 60.294989325000074],
              [28.71534264400009, 60.29246653900003],
              [28.721364780000044, 60.287543036000045],
              [28.715830925000034, 60.284369208000044],
              [28.703135613000086, 60.28001536700003],
              [28.697927280000044, 60.27228424700007],
              [28.69890384200005, 60.26430898600006],
              [28.694590691000087, 60.26113515800006],
              [28.672211134000065, 60.26447174700007],
              [28.658539259000065, 60.264553127000056],
              [28.64698326900009, 60.265611070000034],
              [28.624196811000047, 60.27020905200004],
              [28.569346550000034, 60.292303778000075],
              [28.551036004000082, 60.302720445000034],
              [28.544118686000047, 60.315741278000075],
              [28.54346764400009, 60.32656484600005],
              [28.546885613000086, 60.33421458500004],
              [28.54542076900009, 60.341498114000046],
              [28.541351759000065, 60.347357489000046],
              [28.545258009000065, 60.34861888200004],
              [28.556488477000073, 60.34446849200003],
              [28.568695509000065, 60.34332916900007],
              [28.57585696700005, 60.34935130400004],
              [28.580332879000082, 60.348944403000075],
              [28.586924675000034, 60.34003327000005],
              [28.593923373000052, 60.33860911700003],
              [28.602793816000087, 60.34096914300005],
              [28.612315300000034, 60.33730703300006],
              [28.621429884000065, 60.330145575000074],
              [28.68295332100007, 60.29950592700004],
              [28.711761915000068, 60.294989325000074],
            ],
          ],
          [
            [
              [28.516856316000087, 60.33771393400008],
              [28.521820509000065, 60.333685614000046],
              [28.524261915000068, 60.331366278000075],
              [28.523285352000073, 60.32477448100008],
              [28.518321160000085, 60.312933661000045],
              [28.50367272200009, 60.31102122600004],
              [28.483083530000044, 60.32099030200004],
              [28.47120201900009, 60.32998281500005],
              [28.467784050000034, 60.33437734600005],
              [28.461110873000052, 60.33779531500005],
              [28.451426629000082, 60.33978913000004],
              [28.442393425000034, 60.34430573100008],
              [28.42554772200009, 60.36078522300005],
              [28.427989129000082, 60.36591217700004],
              [28.454600457000083, 60.366848049000055],
              [28.465098504000082, 60.36591217700004],
              [28.48487389400009, 60.36188385600008],
              [28.503103061000047, 60.35407135600008],
              [28.512543165000068, 60.34666575700004],
              [28.513682488000086, 60.34170156500005],
              [28.516856316000087, 60.33771393400008],
            ],
          ],
          [
            [
              [35.94312584700009, 64.40509674700007],
              [35.965505405000044, 64.39398834800005],
              [36.031260613000086, 64.37311432500007],
              [36.044932488000086, 64.36033763200004],
              [36.033213738000086, 64.34251536700003],
              [36.00570722700007, 64.33331940300008],
              [35.97510826900009, 64.33258698100008],
              [35.953135613000086, 64.33982982000003],
              [35.89861087300005, 64.37445709800005],
              [35.86939537900008, 64.38060130400004],
              [35.85678144600007, 64.38735586100006],
              [35.85629316500007, 64.40338776200008],
              [35.883148634000065, 64.41266510600008],
              [35.91846764400009, 64.41372304900005],
              [35.94312584700009, 64.40509674700007],
            ],
          ],
          [
            [
              [35.86687259200005, 65.03131745000007],
              [35.86451256600009, 65.01251862200007],
              [35.858164910000085, 65.00446198100008],
              [35.848643425000034, 64.99957916900007],
              [35.836680535000085, 64.99038320500006],
              [35.82374108200008, 64.98379140800006],
              [35.80201256600009, 64.97801341400003],
              [35.76418467700006, 64.96370785200008],
              [35.74465999000006, 64.96155085700008],
              [35.730181523000056, 64.97284604900005],
              [35.72982832100007, 64.98550039300005],
              [35.723399285000085, 65.00092194200005],
              [35.72234134200005, 65.01382070500006],
              [35.723317905000044, 65.02635325700004],
              [35.71202690400008, 65.02807839300004],
              [35.68910602200009, 65.03391408200008],
              [35.65181725300005, 65.03431997000007],
              [35.603310641000064, 65.03800797700006],
              [35.56326054900006, 65.05213822600007],
              [35.527440382000066, 65.07398978200007],
              [35.505162443000074, 65.09555240800006],
              [35.506113249000066, 65.12128825600007],
              [35.524099155000044, 65.14447663000004],
              [35.558894045000045, 65.14959330000005],
              [35.60173587300005, 65.15436432500007],
              [35.649995593000085, 65.15398639900008],
              [35.66335387100008, 65.16793019300007],
              [35.68603975600007, 65.17133130900004],
              [35.73308825200007, 65.17286538100007],
              [35.786449566000044, 65.16510551500005],
              [35.81530696200008, 65.15421069400008],
              [35.83054470500008, 65.12440167200003],
              [35.86353600400008, 65.07977936400005],
              [35.86687259200005, 65.07599518400008],
              [35.85572350400008, 65.06411367400005],
              [35.84310957100007, 65.06830475500004],
              [35.819021030000044, 65.09027741100005],
              [35.81690514400009, 65.09568919500003],
              [35.807383660000085, 65.10830312700006],
              [35.79664147200009, 65.11440664300005],
              [35.791758660000085, 65.10024648600006],
              [35.78736412900008, 65.07990143400008],
              [35.781260613000086, 65.07273997600004],
              [35.783946160000085, 65.06903717700004],
              [35.805674675000034, 65.05898672100005],
              [35.84164472700007, 65.05158112200007],
              [35.85922285200007, 65.04490794500003],
              [35.86687259200005, 65.03131745000007],
            ],
          ],
          [
            [
              [-169.0833634109999, 65.81586334800005],
              [-169.0632218089999, 65.82819245000007],
              [-169.04133053299992, 65.82733795800004],
              [-168.99461829299992, 65.81586334800005],
              [-169.00776119699992, 65.79572174700007],
              [-169.02753658799992, 65.77391185100004],
              [-169.0513809889999, 65.75787995000007],
              [-169.0765274729999, 65.75507233300004],
              [-169.09369869699992, 65.76194896000004],
              [-169.09809322799993, 65.77887604400007],
              [-169.09337317599991, 65.79905833500004],
              [-169.0833634109999, 65.81586334800005],
            ],
          ],
          [
            [
              [42.64583765200007, 66.74234467000008],
              [42.664934935000076, 66.72323437300008],
              [42.668220629000075, 66.70189172800008],
              [42.68097318300005, 66.68188634200004],
              [42.66802874200005, 66.66669125900006],
              [42.64370678700004, 66.66606352800005],
              [42.58263240300005, 66.67851162700003],
              [42.48342151700007, 66.70732598600006],
              [42.441731824000044, 66.72953807600004],
              [42.42649975100005, 66.75200894200003],
              [42.454868, 66.77366208700005],
              [42.50449069500007, 66.77790578300005],
              [42.53770879600006, 66.77488543500004],
              [42.58475686400004, 66.77029366600004],
              [42.63022933000008, 66.75561722100008],
              [42.64583765200007, 66.74234467000008],
            ],
          ],
          [
            [
              [32.38599694100009, 67.13231028900003],
              [32.40756269600007, 67.12042877800008],
              [32.40707441500007, 67.10712311400005],
              [32.39372806100005, 67.10032786700003],
              [32.367198113000086, 67.11139557500007],
              [32.355479363000086, 67.11334870000007],
              [32.34424889400009, 67.11684804900005],
              [32.33765709700009, 67.12490469000005],
              [32.34148196700005, 67.13605377800008],
              [32.356130405000044, 67.13906484600005],
              [32.37354576900009, 67.13686758000006],
              [32.38599694100009, 67.13231028900003],
            ],
          ],
          [
            [
              [59.24195397200003, 69.17755768400008],
              [59.24073326900003, 69.15973541900007],
              [59.24138431100005, 69.15289948100008],
              [59.24463951900003, 69.14569733300004],
              [59.230479363000086, 69.15424225500004],
              [59.21404056100005, 69.16095612200007],
              [59.19752037900008, 69.16543203300006],
              [59.17310631600009, 69.16913483300004],
              [59.16195722700007, 69.17454661700003],
              [59.14047285200007, 69.18976471600007],
              [59.12484785200007, 69.19647858300004],
              [59.08366946700005, 69.22907135600008],
              [59.06023196700005, 69.24262116100005],
              [58.782237175000034, 69.32648346600007],
              [58.762054884000065, 69.33893463700008],
              [58.78598066500007, 69.34345123900005],
              [58.815440300000034, 69.34076569200005],
              [59.150726759000065, 69.25462474200003],
              [59.20036868600005, 69.22907135600008],
              [59.195323113000086, 69.22606028900003],
              [59.185557488000086, 69.21824778900003],
              [59.17994225400008, 69.21539948100008],
              [59.195323113000086, 69.20449453300006],
              [59.23414147200003, 69.19000885600008],
              [59.24195397200003, 69.17755768400008],
            ],
          ],
          [
            [
              [34.03012129000007, 69.39354075700004],
              [34.12159264400009, 69.40566640800006],
              [34.215830925000034, 69.40778229400007],
              [34.406911655000044, 69.35252513200004],
              [34.38070722700007, 69.34145742400005],
              [34.02662194100009, 69.35390859600005],
              [33.984385613000086, 69.36298248900005],
              [33.975596550000034, 69.36961497600004],
              [33.98226972700007, 69.38141510600008],
              [33.998057488000086, 69.38800690300008],
              [34.03012129000007, 69.39354075700004],
            ],
          ],
          [
            [
              [50.323008660000085, 69.15053945500006],
              [50.31169681100005, 69.10980866100005],
              [50.24789472700007, 69.05658600500004],
              [50.16928144600007, 69.01162344000005],
              [50.11345462300005, 68.99567291900007],
              [50.12061608200008, 69.00722890800006],
              [50.125336134000065, 69.01215241100005],
              [50.13396243600005, 69.01679108300004],
              [50.12322024800005, 69.03896719000005],
              [50.139333530000044, 69.06338125200006],
              [50.18921959700003, 69.10553620000007],
              [50.22006269600007, 69.14423248900005],
              [50.223317905000044, 69.15395742400005],
              [50.20834394600007, 69.15717194200005],
              [50.18018639400003, 69.15338776200008],
              [50.13298587300005, 69.14158763200004],
              [50.023448113000086, 69.09137604400007],
              [49.983409050000034, 69.08502838700008],
              [49.95492597700007, 69.07469310100004],
              [49.87191816500007, 69.02558014500005],
              [49.85401451900003, 69.00934479400007],
              [49.89503014400003, 69.01288483300004],
              [49.91138756600009, 69.00999583500004],
              [49.908539259000065, 68.99567291900007],
              [49.89234459700003, 68.98354726800005],
              [49.826182488000086, 68.96527741100005],
              [49.719737175000034, 68.88996002800008],
              [49.68539472700007, 68.87897370000007],
              [49.64210045700008, 68.87490469000005],
              [49.600271030000044, 68.86591217700004],
              [49.53891035200007, 68.83539459800005],
              [49.42139733200008, 68.81126536700003],
              [49.33155358200008, 68.81590403900003],
              [49.305349155000044, 68.81126536700003],
              [49.31275475400008, 68.80390045800004],
              [49.24854576900009, 68.77997467700004],
              [48.797618035000085, 68.72939687700006],
              [48.77955162900008, 68.73187897300005],
              [48.76889082100007, 68.73676178600005],
              [48.760752800000034, 68.74274323100008],
              [48.75049889400009, 68.74860260600008],
              [48.734385613000086, 68.75458405200004],
              [48.72022545700008, 68.75702545800004],
              [48.70818118600005, 68.75364817900004],
              [48.69898522200003, 68.74213288000004],
              [48.68572024800005, 68.73444245000007],
              [48.59205162900008, 68.73086172100005],
              [48.56267337300005, 68.74371979400007],
              [48.51026451900009, 68.77655670800004],
              [48.41529381600009, 68.81297435100004],
              [48.386729363000086, 68.81753164300005],
              [48.37468509200005, 68.82184479400007],
              [48.35173587300005, 68.84113190300008],
              [48.338877800000034, 68.84544505400004],
              [48.327159050000034, 68.84788646000004],
              [48.29053795700008, 68.86591217700004],
              [48.32243899800005, 68.87970612200007],
              [48.332041863000086, 68.88580963700008],
              [48.317067905000044, 68.88646067900004],
              [48.29379316500007, 68.89691803600005],
              [48.28370201900009, 68.89948151200008],
              [48.269541863000086, 68.89614492400005],
              [48.24431399800005, 68.88324616100005],
              [48.23585045700008, 68.88239166900007],
              [48.219411655000044, 68.89565664300005],
              [48.218760613000086, 68.90924713700008],
              [48.224945509000065, 68.92487213700008],
              [48.22901451900009, 68.94415924700007],
              [48.23878014400009, 68.96377187700006],
              [48.25668379000007, 68.97443268400008],
              [48.26587975400008, 68.98285553600005],
              [48.24968509200005, 68.99567291900007],
              [48.242930535000085, 68.99518463700008],
              [48.23454837300005, 68.99188873900005],
              [48.225271030000044, 68.99054596600007],
              [48.21599368600005, 68.99567291900007],
              [48.211680535000085, 69.00165436400005],
              [48.21216881600009, 69.00438060100004],
              [48.21461022200003, 69.00714752800008],
              [48.21599368600005, 69.01308828300006],
              [48.221364780000044, 69.02024974200003],
              [48.25635826900009, 69.04409414300005],
              [48.221364780000044, 69.05048248900005],
              [48.21599368600005, 69.05394114800004],
              [48.21697024800005, 69.06443919500003],
              [48.21810957100007, 69.06899648600006],
              [48.21998131600009, 69.07298411700003],
              [48.23910566500007, 69.09788646000004],
              [48.262380405000044, 69.11969635600008],
              [48.27003014400009, 69.13279857000003],
              [48.26880944100009, 69.13873932500007],
              [48.26644941500007, 69.17088450700004],
              [48.26693769600007, 69.17755768400008],
              [48.26319420700008, 69.19745514500005],
              [48.27230879000007, 69.22662995000007],
              [48.288096550000034, 69.25617096600007],
              [48.30420983200008, 69.27680084800005],
              [48.334320509000065, 69.29987213700008],
              [48.40154056100005, 69.33942291900007],
              [48.43100019600007, 69.36277903900003],
              [48.44695071700005, 69.37189362200007],
              [48.51026451900009, 69.38979726800005],
              [48.56568444100009, 69.41998932500007],
              [48.80632571700005, 69.49323151200008],
              [48.906260613000086, 69.50796133000006],
              [49.08529707100007, 69.51703522300005],
              [49.27173912900008, 69.50796133000006],
              [49.69450931100005, 69.39789459800005],
              [50.024099155000044, 69.29975006700005],
              [50.164398634000065, 69.26089101800005],
              [50.22193444100009, 69.22947825700004],
              [50.27588951900003, 69.19196198100008],
              [50.323008660000085, 69.15053945500006],
            ],
          ],
          [
            [
              [169.44646243600005, 69.84910716400003],
              [169.44898522200003, 69.83405182500007],
              [169.45264733200008, 69.82623932500007],
              [169.45142662900003, 69.81867096600007],
              [169.43962649800005, 69.80438873900005],
              [169.4277449880001, 69.79710521000004],
              [169.415375196, 69.79218170800004],
              [169.40845787900003, 69.78481679900005],
              [169.41228274800005, 69.77024974200003],
              [169.41228274800005, 69.76341380400004],
              [169.30591881600003, 69.77024974200003],
              [169.2856551440001, 69.76707591400003],
              [169.27759850400003, 69.75950755400004],
              [169.282562696, 69.75043366100005],
              [169.30250084700003, 69.74298737200007],
              [169.27849368600005, 69.71995677300004],
              [169.28386478000004, 69.70392487200007],
              [169.30046634200005, 69.68773021000004],
              [169.309906446, 69.66445547100005],
              [169.30054772200003, 69.64533112200007],
              [169.27898196700005, 69.62400950700004],
              [169.234711134, 69.59210846600007],
              [169.1894637380001, 69.57518138200004],
              [169.14014733200008, 69.57196686400005],
              [169.03931725400003, 69.57786692900004],
              [168.87452233200008, 69.56785716400003],
              [168.52352949350006, 69.63153717700004],
              [168.17253665500004, 69.69521719000005],
              [168.133636915, 69.71320221600007],
              [168.09986412900003, 69.73956940300008],
              [168.059906446, 69.76365794500003],
              [167.969086134, 69.77558014500005],
              [167.88233483200008, 69.79824453300006],
              [167.79086347700002, 69.80833567900004],
              [167.75375410200002, 69.83234284100007],
              [167.7856551440001, 69.85830312700006],
              [167.82252037900003, 69.88100820500006],
              [167.99105879, 69.95709870000007],
              [168.19410241000003, 70.00897858300004],
              [168.22339928500003, 70.01048411700003],
              [168.23414147200003, 70.01264069200005],
              [168.25318444100003, 70.02204010600008],
              [168.2646590500001, 70.02411530200004],
              [168.63786868600005, 69.98602936400005],
              [168.6836043630001, 69.97085195500006],
              [168.7680770190001, 69.96271393400008],
              [168.82984459700003, 69.93988678600005],
              [169.22771243600005, 69.90729401200008],
              [169.276703321, 69.89557526200008],
              [169.37232506600003, 69.88475169500003],
              [169.4238387380001, 69.87299225500004],
              [169.44646243600005, 69.84910716400003],
            ],
          ],
          [
            [
              [60.539805535000085, 69.81867096600007],
              [60.54769941500007, 69.81537506700005],
              [60.545909050000034, 69.80817291900007],
              [60.53834069100009, 69.80093008000006],
              [60.529307488000086, 69.79759349200003],
              [60.51384524800005, 69.79608795800004],
              [60.49822024800005, 69.79230377800008],
              [60.46859785200007, 69.78050364800004],
              [60.44849694100009, 69.76593659100007],
              [60.443695509000065, 69.75043366100005],
              [60.45337975400008, 69.73541901200008],
              [60.47592207100007, 69.72247955900008],
              [60.373708530000044, 69.73090241100005],
              [60.35173587300005, 69.72247955900008],
              [60.35857181100005, 69.71503327000005],
              [60.25407962300005, 69.68943919500003],
              [60.20101972700007, 69.68512604400007],
              [60.09489993600005, 69.71552155200004],
              [60.03272545700008, 69.72247955900008],
              [60.00245201900003, 69.71987539300005],
              [59.974619988000086, 69.71246979400007],
              [59.92042076900003, 69.68773021000004],
              [59.92505944100009, 69.68280670800004],
              [59.93409264400003, 69.66787344000005],
              [59.913096550000034, 69.66962311400005],
              [59.900726759000065, 69.67731354400007],
              [59.89144941500007, 69.68683502800008],
              [59.87940514400003, 69.69452545800004],
              [59.85401451900003, 69.69867584800005],
              [59.769541863000086, 69.69452545800004],
              [59.563487175000034, 69.71503327000005],
              [59.580088738000086, 69.73078034100007],
              [59.56812584700003, 69.74201080900008],
              [59.546885613000086, 69.75096263200004],
              [59.535492384000065, 69.75971100500004],
              [59.546885613000086, 69.77899811400005],
              [59.573252800000034, 69.78314850500004],
              [59.602305535000085, 69.78245677300004],
              [59.622080925000034, 69.78733958500004],
              [59.623708530000044, 69.80434804900005],
              [59.602549675000034, 69.81793854400007],
              [59.477549675000034, 69.86347077000005],
              [59.43148847700007, 69.88947174700007],
              [59.39893639400003, 69.89520905200004],
              [59.36540774800005, 69.89459870000007],
              [59.30486087300005, 69.88434479400007],
              [59.270274285000085, 69.88849518400008],
              [59.23650149800005, 69.89838288000004],
              [59.20720462300005, 69.91087474200003],
              [59.178477410000085, 69.91901276200008],
              [59.08366946700005, 69.92047760600008],
              [58.93970787900008, 69.94220612200007],
              [58.953135613000086, 69.93130117400005],
              [58.97820071700005, 69.91990794500003],
              [59.00538170700008, 69.91107819200005],
              [59.05298912900008, 69.90306224200003],
              [59.13209069100009, 69.87327708500004],
              [59.10914147200003, 69.85976797100005],
              [59.07740319100009, 69.85635000200006],
              [59.015961134000065, 69.85968659100007],
              [59.022227410000085, 69.87327708500004],
              [59.001963738000086, 69.87445709800005],
              [58.978526238000086, 69.87905508000006],
              [58.95720462300005, 69.88800690300008],
              [58.95394941500007, 69.89378489800004],
              [58.940196160000085, 69.90595123900005],
              [58.898773634000065, 69.92865631700005],
              [58.69556725400008, 70.00283437700006],
              [58.57048587300005, 70.07880280200004],
              [58.604502800000034, 70.11286041900007],
              [58.59009850400008, 70.11928945500006],
              [58.559580925000034, 70.12457916900007],
              [58.549164259000065, 70.13397858300004],
              [58.565114780000044, 70.13361237200007],
              [58.611338738000086, 70.14020416900007],
              [58.603851759000065, 70.14622630400004],
              [58.59546959700003, 70.15058014500005],
              [58.58619225400008, 70.15322500200006],
              [58.57667076900003, 70.15387604400007],
              [58.580088738000086, 70.15961334800005],
              [58.58716881600009, 70.17544179900005],
              [58.590830925000034, 70.18121979400007],
              [58.57398522200003, 70.18520742400005],
              [58.557383660000085, 70.18252187700006],
              [58.54029381600009, 70.17763906500005],
              [58.52198326900003, 70.17495351800005],
              [58.515635613000086, 70.17682526200008],
              [58.51490319100009, 70.18622467700004],
              [58.50993899800005, 70.19037506700005],
              [58.49577884200005, 70.19383372600004],
              [58.45297285200007, 70.19546133000006],
              [58.46306399800005, 70.20652903900003],
              [58.49040774800005, 70.21898021000004],
              [58.50147545700008, 70.22955963700008],
              [58.47966556100005, 70.23379140800006],
              [58.449880405000044, 70.23395416900007],
              [58.42351321700005, 70.23956940300008],
              [58.412119988000086, 70.26032135600008],
              [58.42896569100009, 70.27073802300004],
              [58.46762129000007, 70.27114492400005],
              [58.824229363000086, 70.21588776200008],
              [58.816742384000065, 70.22662995000007],
              [58.79428144600007, 70.24355703300006],
              [58.789398634000065, 70.25348541900007],
              [58.77719160200007, 70.25824616100005],
              [58.69703209700003, 70.27948639500005],
              [58.67335045700008, 70.29413483300004],
              [58.65992272200003, 70.29946523600006],
              [58.52230879000007, 70.33112213700008],
              [58.49463951900003, 70.33197663000004],
              [58.51970462300005, 70.34760163000004],
              [58.56039472700007, 70.34589264500005],
              [58.638682488000086, 70.33197663000004],
              [58.631846550000034, 70.34564850500004],
              [58.64966881600009, 70.35309479400007],
              [58.67514082100007, 70.35993073100008],
              [58.72120201900003, 70.36676666900007],
              [58.729177280000044, 70.36904531500005],
              [58.739024285000085, 70.37433502800008],
              [58.75521894600007, 70.38690827000005],
              [58.76140384200005, 70.39687734600005],
              [58.75554446700005, 70.39964427300004],
              [58.74586022200003, 70.40131256700005],
              [58.740977410000085, 70.40770091400003],
              [58.73755944100009, 70.41571686400005],
              [58.73170006600009, 70.41665273600006],
              [58.73064212300005, 70.41819896000004],
              [58.740977410000085, 70.42820872600004],
              [58.74887129000007, 70.43089427300004],
              [58.77686608200008, 70.43451569200005],
              [58.87281334700003, 70.43455638200004],
              [58.900401238000086, 70.44013092700004],
              [58.97982832100007, 70.47060781500005],
              [59.02361087300005, 70.47980377800008],
              [59.04273522200003, 70.46637604400007],
              [59.047536655000044, 70.45425039300005],
              [59.05982506600009, 70.44428131700005],
              [59.07740319100009, 70.43748607000003],
              [59.12134850400008, 70.43170807500007],
              [59.315114780000044, 70.37164948100008],
              [59.35181725400008, 70.35309479400007],
              [59.43995201900003, 70.28705475500004],
              [59.46794681100005, 70.27732982000003],
              [59.510508660000085, 70.27220286700003],
              [59.533213738000086, 70.26487864800004],
              [59.542979363000086, 70.25348541900007],
              [59.535166863000086, 70.21747467700004],
              [59.535492384000065, 70.20848216400003],
              [59.55396569100009, 70.19961172100005],
              [59.63917076900003, 70.20229726800005],
              [59.70630944100009, 70.17812734600005],
              [59.73129316500007, 70.17495351800005],
              [59.752289259000065, 70.17462799700007],
              [59.766286655000044, 70.17137278900003],
              [59.77393639400003, 70.16209544500003],
              [59.776377800000034, 70.14362213700008],
              [59.78288821700005, 70.13149648600006],
              [59.79900149800005, 70.12799713700008],
              [59.83773847700007, 70.12661367400005],
              [59.92725670700008, 70.09857819200005],
              [59.955739780000044, 70.09829336100006],
              [60.01026451900003, 70.10407135600008],
              [60.03646894600007, 70.09857819200005],
              [60.05689537900008, 70.07880280200004],
              [60.06788170700008, 70.07347239800004],
              [60.09791100400008, 70.06513092700004],
              [60.32447350400008, 69.96954987200007],
              [60.328461134000065, 69.95726146000004],
              [60.41382897200003, 69.96271393400008],
              [60.42986087300005, 69.95502350500004],
              [60.47592207100007, 69.92047760600008],
              [60.46216881600009, 69.91132233300004],
              [60.45443769600007, 69.89704010600008],
              [60.453868035000085, 69.88076406500005],
              [60.461599155000044, 69.86587148600006],
              [60.47242272200003, 69.85927969000005],
              [60.50220787900008, 69.85130442900004],
              [60.515635613000086, 69.84540436400005],
              [60.52003014400003, 69.83942291900007],
              [60.52466881600009, 69.83051178600005],
              [60.53093509200005, 69.82225169500003],
              [60.539805535000085, 69.81867096600007],
            ],
          ],
          [
            [
              [57.11736087300005, 70.55853913000004],
              [57.19304446700005, 70.54144928600005],
              [57.221690300000034, 70.52606842700004],
              [57.206065300000034, 70.51072825700004],
              [57.18930097700007, 70.51121653900003],
              [57.10132897200003, 70.53408437700006],
              [57.056651238000086, 70.53851959800005],
              [57.03541100400008, 70.54486725500004],
              [57.05884850400008, 70.52985260600008],
              [57.12134850400008, 70.51605866100005],
              [57.13843834700003, 70.49705638200004],
              [57.06364993600005, 70.50242747600004],
              [56.92904707100007, 70.53217194200005],
              [56.89820397200003, 70.55853913000004],
              [56.914398634000065, 70.56468333500004],
              [56.92269941500007, 70.56590403900003],
              [56.932383660000085, 70.56537506700005],
              [56.914073113000086, 70.57880280200004],
              [56.859711134000065, 70.58527252800008],
              [56.84302819100009, 70.60635000200006],
              [56.95240319100009, 70.58283112200007],
              [57.01091556100005, 70.57680898600006],
              [57.02719160200007, 70.57135651200008],
              [57.055349155000044, 70.55853913000004],
              [57.07211347700007, 70.55491771000004],
              [57.11736087300005, 70.55853913000004],
            ],
          ],
          [
            [
              [162.38168379, 70.68146393400008],
              [162.40552819100003, 70.68024323100008],
              [162.4345809250001, 70.67283763200004],
              [162.48414147200003, 70.65412018400008],
              [162.45093834700003, 70.65363190300008],
              [162.35075931100005, 70.64052969000005],
              [162.23780358200008, 70.65412018400008],
              [162.23780358200008, 70.66095612200007],
              [162.2636824880001, 70.66181061400005],
              [162.271820509, 70.66095612200007],
              [162.2793074880001, 70.66095612200007],
              [162.29249108200008, 70.66575755400004],
              [162.29851321700005, 70.66559479400007],
              [162.30616295700008, 70.66095612200007],
              [162.34555097700002, 70.66205475500004],
              [162.36280358200008, 70.66600169500003],
              [162.3696395190001, 70.66998932500007],
              [162.37614993600005, 70.67894114800004],
              [162.38168379, 70.68146393400008],
            ],
          ],
          [
            [
              [161.66228274800005, 70.79132721600007],
              [161.67017662900003, 70.77997467700004],
              [161.68873131600003, 70.76068756700005],
              [161.69459069100003, 70.75043366100005],
              [161.66521243600005, 70.75238678600005],
              [161.6386824880001, 70.75779857000003],
              [161.57056725400003, 70.78766510600008],
              [161.5551863940001, 70.79071686400005],
              [161.5214949880001, 70.79132721600007],
              [161.50668379, 70.79364655200004],
              [161.47868899800005, 70.80341217700004],
              [161.46314537900003, 70.80499909100007],
              [161.4770613940001, 70.80971914300005],
              [161.48698978000004, 70.81736888200004],
              [161.49000084700003, 70.82758209800005],
              [161.48365319100003, 70.83974844000005],
              [161.53052819100003, 70.84162018400008],
              [161.54517662900003, 70.83974844000005],
              [161.5556746750001, 70.83535390800006],
              [161.5761824880001, 70.82245514500005],
              [161.58668053500003, 70.81801992400005],
              [161.61052493600005, 70.81586334800005],
              [161.634125196, 70.81663646000004],
              [161.6562606130001, 70.81338125200006],
              [161.67603600400003, 70.79877350500004],
              [161.66228274800005, 70.79132721600007],
            ],
          ],
          [
            [
              [160.723480665, 70.83844635600008],
              [160.74382571700005, 70.82542552300004],
              [160.76397367800007, 70.80404488700003],
              [160.682529885, 70.80210578000003],
              [160.59724964500003, 70.79296921000008],
              [160.50406569100005, 70.80501215600003],
              [160.50956163500007, 70.83354572000007],
              [160.54555211900004, 70.85147368700007],
              [160.55281050300005, 70.88478811400006],
              [160.50367272200003, 70.89061107000003],
              [160.48138919400003, 70.87739600700007],
              [160.4507459790001, 70.87218586000006],
              [160.40796959700003, 70.91425202000005],
              [160.4248153000001, 70.92792389500005],
              [160.45655358200008, 70.93475983300004],
              [160.51783287900003, 70.93528880400004],
              [160.54184004, 70.93048737200007],
              [160.67438511800003, 70.91421070000007],
              [160.69377230400005, 70.89629753400004],
              [160.69747752400008, 70.88686405100003],
              [160.70610545500006, 70.87670869500005],
              [160.723480665, 70.83844635600008],
            ],
          ],
          [
            [
              [53.23178144600007, 71.21588776200008],
              [53.20834394600007, 71.19717031500005],
              [53.20460045700008, 71.19196198100008],
              [53.20671634200005, 71.18561432500007],
              [53.21810957100007, 71.16803620000007],
              [53.20460045700008, 71.15167877800008],
              [53.16488691500007, 71.13849518400008],
              [53.14991295700008, 71.12710195500006],
              [53.14975019600007, 71.11985911700003],
              [53.16163170700008, 71.10879140800006],
              [53.16000410200007, 71.10293203300006],
              [53.151052280000044, 71.09552643400008],
              [53.142588738000086, 71.09088776200008],
              [53.13331139400003, 71.08808014500005],
              [53.12191816500007, 71.08612702000005],
              [53.09945722700007, 71.08698151200008],
              [53.07960045700008, 71.09052155200004],
              [53.06202233200008, 71.08836497600004],
              [53.046885613000086, 71.07245514500005],
              [53.041351759000065, 71.03432851800005],
              [53.06861412900008, 71.01679108300004],
              [53.108164910000085, 71.00739166900007],
              [53.139333530000044, 70.99363841400003],
              [53.12045332100007, 70.97711823100008],
              [53.061534050000034, 70.96621328300006],
              [53.009776238000086, 70.96820709800005],
              [53.01189212300005, 70.99030182500007],
              [53.01514733200008, 71.00438060100004],
              [52.97201582100007, 71.02912018400008],
              [52.97185306100005, 71.04515208500004],
              [52.95630944100009, 71.05707428600005],
              [52.93384850400008, 71.06443919500003],
              [52.799815300000034, 71.09296295800004],
              [52.803477410000085, 71.10586172100005],
              [52.79810631600009, 71.11432526200008],
              [52.77588951900003, 71.13051992400005],
              [52.775401238000086, 71.13589101800005],
              [52.776052280000044, 71.15786367400005],
              [52.772471550000034, 71.16803620000007],
              [52.75635826900003, 71.17670319200005],
              [52.684336785000085, 71.18854401200008],
              [52.67172285200007, 71.19635651200008],
              [52.65845787900008, 71.21246979400007],
              [52.64283287900008, 71.22333405200004],
              [52.60466556100005, 71.23895905200004],
              [52.55836022200003, 71.24900950700004],
              [52.51148522200003, 71.25047435100004],
              [52.45004316500007, 71.23578522300005],
              [52.35181725400008, 71.24579498900005],
              [52.254893425000034, 71.27326080900008],
              [52.228526238000086, 71.28803131700005],
              [52.21176191500007, 71.30809153900003],
              [52.21705162900008, 71.33319733300004],
              [52.23267662900008, 71.34259674700007],
              [52.257823113000086, 71.34894440300008],
              [52.37029056100005, 71.36383698100008],
              [52.38892662900008, 71.37075429900005],
              [52.412852410000085, 71.37636953300006],
              [52.46176191500007, 71.37262604400007],
              [52.484711134000065, 71.37726471600007],
              [52.506846550000034, 71.38475169500003],
              [52.52955162900008, 71.38784414300005],
              [52.64665774800005, 71.38051992400005],
              [52.67009524800005, 71.37417226800005],
              [52.70329837300005, 71.35537344000005],
              [52.72087649800005, 71.34931061400005],
              [52.73845462300005, 71.35366445500006],
              [52.70329837300005, 71.37132396000004],
              [52.68767337300005, 71.38410065300008],
              [52.68718509200005, 71.39769114800004],
              [52.70866946700005, 71.40721263200004],
              [52.74105879000007, 71.40582916900007],
              [52.88363691500007, 71.37763092700004],
              [52.90967858200008, 71.36733633000006],
              [52.923838738000086, 71.35700104400007],
              [52.943369988000086, 71.33222077000005],
              [52.95818118600005, 71.31891510600008],
              [52.97486412900008, 71.31199778900003],
              [52.995127800000034, 71.30646393400008],
              [53.012380405000044, 71.29779694200005],
              [53.019541863000086, 71.28131745000007],
              [53.004649285000085, 71.27924225500004],
              [52.91651451900003, 71.30898672100005],
              [52.90349368600005, 71.31924062700006],
              [52.880869988000086, 71.34341054900005],
              [52.861989780000044, 71.35366445500006],
              [52.803070509000065, 71.37225983300004],
              [52.76978600400008, 71.37775299700007],
              [52.74463951900003, 71.37417226800005],
              [52.77475019600007, 71.37055084800005],
              [52.84791100400008, 71.34711334800005],
              [52.87549889400003, 71.33319733300004],
              [52.85271243600005, 71.32404205900008],
              [52.82927493600005, 71.32290273600006],
              [52.779307488000086, 71.32575104400007],
              [52.779307488000086, 71.31891510600008],
              [53.06104576900003, 71.23818594000005],
              [53.11296634200005, 71.23309967700004],
              [53.15674889400003, 71.24380117400005],
              [53.13917076900003, 71.25006745000007],
              [53.120127800000034, 71.25185781500005],
              [53.08171634200005, 71.25063711100006],
              [53.08171634200005, 71.25747304900005],
              [53.09717858200008, 71.25967031500005],
              [53.12647545700008, 71.26813385600008],
              [53.14242597700007, 71.27045319200005],
              [53.160899285000085, 71.26898834800005],
              [53.193695509000065, 71.25983307500007],
              [53.211273634000065, 71.25747304900005],
              [53.199229363000086, 71.24176666900007],
              [53.196055535000085, 71.22646719000005],
              [53.205821160000085, 71.21621328300006],
              [53.23178144600007, 71.21588776200008],
            ],
          ],
          [
            [
              [137.91423587300005, 71.55849844000005],
              [137.92310631600003, 71.55215078300006],
              [137.9658309250001, 71.51068756700005],
              [137.9423934250001, 71.49445221600007],
              [137.76742597700002, 71.43073151200008],
              [137.7187606130001, 71.42133209800005],
              [137.6933699880001, 71.41937897300005],
              [137.58619225400003, 71.43740469000005],
              [137.5219832690001, 71.47540924700007],
              [137.48218834700003, 71.48403554900005],
              [137.3950301440001, 71.48114655200004],
              [137.3457137380001, 71.49518463700008],
              [137.31812584700003, 71.49917226800005],
              [137.29078209700003, 71.49787018400008],
              [137.26685631600003, 71.49017975500004],
              [137.30144290500004, 71.48029205900008],
              [137.37680097700002, 71.46718984600005],
              [137.41089928500003, 71.45604075700004],
              [137.3945418630001, 71.45001862200007],
              [137.38656660200002, 71.44863515800006],
              [137.37671959700003, 71.44863515800006],
              [137.38982181100005, 71.43561432500007],
              [137.344086134, 71.42755768400008],
              [137.04314212300005, 71.51105377800008],
              [136.99187259200005, 71.51752350500004],
              [137.02320397200003, 71.53412506700005],
              [137.128265821, 71.54726797100005],
              [137.21827233200008, 71.57623932500007],
              [137.47250410200002, 71.58673737200007],
              [137.5800887380001, 71.57684967700004],
              [137.60954837300005, 71.57965729400007],
              [137.6709090500001, 71.59324778900003],
              [137.7060653000001, 71.59642161700003],
              [137.85377037900003, 71.58364492400005],
              [137.8701278000001, 71.57953522300005],
              [137.90503991000003, 71.56126536700003],
              [137.91423587300005, 71.55849844000005],
            ],
          ],
          [
            [
              [78.27906334700003, 72.55219147300005],
              [78.36695397200003, 72.51203034100007],
              [78.39454186300003, 72.49140045800004],
              [78.35572350400008, 72.47280508000006],
              [78.26661217500003, 72.45425039300005],
              [78.18018639400003, 72.42177969000005],
              [78.07715905000003, 72.39850495000007],
              [77.98389733200008, 72.38910553600005],
              [77.93783613400007, 72.37392812700006],
              [77.81137129000007, 72.31509023600006],
              [77.77076256600003, 72.30499909100007],
              [77.58643639400003, 72.28530508000006],
              [77.20093834700003, 72.28994375200006],
              [77.12712649800005, 72.27789948100008],
              [76.91797936300003, 72.29303620000007],
              [76.86988366000008, 72.30744049700007],
              [76.85271243600005, 72.33307526200008],
              [76.85474694100003, 72.33649323100008],
              [76.88412519600007, 72.35932038000004],
              [76.91260826900003, 72.37213776200008],
              [77.22852623800003, 72.46015045800004],
              [77.24878991000008, 72.46938711100006],
              [77.25749759200005, 72.48053620000007],
              [77.27735436300003, 72.51805247600004],
              [77.31299889400003, 72.54523346600007],
              [77.35580488400007, 72.55971914300005],
              [77.44402103000004, 72.57786692900004],
              [77.56812584700003, 72.62815989800004],
              [77.61019941500007, 72.63471100500004],
              [77.79468834700003, 72.62860748900005],
              [78.02361087300005, 72.58966705900008],
              [78.13135826900003, 72.58539459800005],
              [78.23080488400007, 72.56915924700007],
              [78.27906334700003, 72.55219147300005],
            ],
          ],
          [
            [
              [128.8310653000001, 72.65521881700005],
              [128.870453321, 72.65151601800005],
              [128.9101668630001, 72.64008209800005],
              [128.94597415500004, 72.62091705900008],
              [128.97445722700002, 72.59381745000007],
              [128.87224368600005, 72.59186432500007],
              [128.84449303500003, 72.58319733300004],
              [128.816742384, 72.55902741100005],
              [128.8051863940001, 72.55658600500004],
              [128.7812606130001, 72.55621979400007],
              [128.76905358200008, 72.55219147300005],
              [128.77320397200003, 72.55084870000007],
              [128.78272545700008, 72.54535553600005],
              [128.6533309250001, 72.52749258000006],
              [128.61060631600003, 72.53237539300005],
              [128.564789259, 72.54360586100006],
              [128.47608483200008, 72.55394114800004],
              [128.383148634, 72.55304596600007],
              [128.33936608200008, 72.56102122600004],
              [128.11109459700003, 72.63471100500004],
              [128.10368899800005, 72.63471100500004],
              [128.13453209700003, 72.64350006700005],
              [128.39352461000004, 72.65963369350004],
              [128.65251712300005, 72.67576732000003],
              [128.8310653000001, 72.65521881700005],
            ],
          ],
          [
            [
              [128.31714928500003, 72.81232330900008],
              [128.32154381600003, 72.82855866100005],
              [128.41900670200005, 72.86926187200004],
              [128.51803866600005, 72.87765319600004],
              [128.73566124900003, 72.88414824600005],
              [128.84379364200004, 72.90982067500005],
              [128.99408262200006, 72.93247107700006],
              [129.21965983500002, 72.92640602700004],
              [129.3986125460001, 72.86602262700006],
              [129.41713899900003, 72.81259570200007],
              [129.33406087900005, 72.77370331900005],
              [129.207042752, 72.76189459800008],
              [128.988854779, 72.77140547300007],
              [128.65300203200002, 72.79186439100008],
              [128.31714928500003, 72.81232330900008],
            ],
          ],
          [
            [
              [79.56299889400003, 72.76825592700004],
              [79.57203209700003, 72.74054596600007],
              [79.53687584700003, 72.72646719000005],
              [79.39527428500008, 72.70404694200005],
              [79.00123131600003, 72.74457428600005],
              [78.90992272200003, 72.74127838700008],
              [78.88282311300003, 72.74656810100004],
              [78.79249108200008, 72.77875397300005],
              [78.71021569100003, 72.78974030200004],
              [78.67156009200005, 72.80353424700007],
              [78.65512129000007, 72.83026764500005],
              [78.65023847700007, 72.84511953300006],
              [78.63868248800003, 72.84943268400008],
              [78.62525475400008, 72.84658437700006],
              [78.61426842500003, 72.84023672100005],
              [78.61231530000003, 72.82990143400008],
              [78.61231530000003, 72.81476471600007],
              [78.60914147200003, 72.80634186400005],
              [78.59693444100003, 72.81598541900007],
              [78.58464603000004, 72.84186432500007],
              [78.59229576900003, 72.86212799700007],
              [78.61280358200008, 72.87824127800008],
              [78.63990319100003, 72.89166901200008],
              [78.66195722700007, 72.89545319200005],
              [78.90117434950005, 72.99542877800005],
              [79.14039147200003, 73.09540436400005],
              [79.17310631600003, 73.10138580900008],
              [79.20533287900008, 73.09760163000004],
              [79.23617597700007, 73.08710358300004],
              [79.32056725400008, 73.04629140800006],
              [79.36850019600007, 73.03473541900007],
              [79.38209069100003, 73.02578359600005],
              [79.38892662900008, 73.01845937700006],
              [79.39307701900003, 73.01190827000005],
              [79.39519290500004, 73.00454336100006],
              [79.39576256600003, 72.99477773600006],
              [79.40211022200003, 72.98818594000005],
              [79.44353274800005, 72.96369049700007],
              [79.54135175900007, 72.92552317900004],
              [79.55958092500003, 72.90843333500004],
              [79.54127037900008, 72.90973541900007],
              [79.52361087300005, 72.91388580900008],
              [79.50684655000003, 72.91543203300006],
              [79.49073326900003, 72.90843333500004],
              [79.50766035200007, 72.89777252800008],
              [79.52068118600005, 72.88373444200005],
              [79.52564537900008, 72.86664459800005],
              [79.51921634200005, 72.84699127800008],
              [79.52898196700005, 72.84137604400007],
              [79.53638756600003, 72.83405182500007],
              [79.54184004000007, 72.82453034100007],
              [79.54590905000003, 72.81232330900008],
              [79.54395592500003, 72.80857982000003],
              [79.53858483200008, 72.80414459800005],
              [79.53353925900007, 72.79877350500004],
              [79.53223717500003, 72.79242584800005],
              [79.53695722700007, 72.78416575700004],
              [79.54468834700003, 72.77887604400007],
              [79.55396569100003, 72.77423737200007],
              [79.56299889400003, 72.76825592700004],
            ],
          ],
          [
            [
              [74.72535241000008, 73.10712311400005],
              [74.84522545700008, 73.09369538000004],
              [74.96159915500004, 73.06610748900005],
              [74.96159915500004, 73.05996328300006],
              [74.87281334700003, 73.07977936400005],
              [74.79363040500004, 73.08657461100006],
              [74.76823978000004, 73.09178294500003],
              [74.73422285200007, 73.09247467700004],
              [74.70264733200008, 73.07876211100006],
              [74.68539472700007, 73.05499909100007],
              [74.69459069100003, 73.02578359600005],
              [74.64665774800005, 72.97455475500004],
              [74.63941491000008, 72.96027252800008],
              [74.64649498800003, 72.93675364800004],
              [74.66391035200007, 72.92157623900005],
              [74.70826256600003, 72.90167877800008],
              [74.69890384200005, 72.89256419500003],
              [74.68702233200008, 72.87091705900008],
              [74.68034915500004, 72.86408112200007],
              [74.65626061300003, 72.85862864800004],
              [74.58472741000008, 72.87498607000003],
              [74.58961022200003, 72.88007233300004],
              [74.59839928500008, 72.89545319200005],
              [74.46501712300005, 72.89960358300004],
              [74.34408613400007, 72.92767975500004],
              [74.33594811300003, 72.93382396000004],
              [74.33204186300003, 72.94122955900008],
              [74.32471764400003, 72.94745514500005],
              [74.23406009200005, 72.95661041900007],
              [74.20053144600007, 72.96613190300008],
              [74.12077884200005, 72.99884674700007],
              [74.09848066500007, 73.01203034100007],
              [74.09327233200008, 73.02777741100005],
              [74.15870201900003, 73.08856842700004],
              [74.18458092500003, 73.10700104400007],
              [74.21168053500008, 73.11456940300008],
              [74.47461998800003, 73.13442617400005],
              [74.72535241000008, 73.10712311400005],
            ],
          ],
          [
            [
              [120.27857506600003, 73.10089752800008],
              [120.26246178500003, 73.08698151200008],
              [120.22584069100003, 73.06622955900008],
              [120.20972741000003, 73.05247630400004],
              [120.22437584700003, 73.04193756700005],
              [120.23023522200003, 73.03949616100005],
              [119.80225670700008, 73.03949616100005],
              [119.74740644600001, 73.03278229400007],
              [119.72071373800009, 73.03384023600006],
              [119.70264733200008, 73.04629140800006],
              [119.76465905000009, 73.07294342700004],
              [119.73878014400009, 73.09369538000004],
              [119.658539259, 73.10858795800004],
              [119.63445071700005, 73.12815989800004],
              [119.67172285200002, 73.13080475500004],
              [119.79200280000009, 73.16233958500004],
              [120.02198326900009, 73.16811758000006],
              [120.24805748800009, 73.11859772300005],
              [120.27857506600003, 73.10089752800008],
            ],
          ],
          [
            [
              [76.69507897200003, 73.18622467700004],
              [76.72046959700003, 73.17438385600008],
              [76.73218834700003, 73.16592031500005],
              [76.73658287900008, 73.15550364800004],
              [76.72885175900007, 73.14398834800005],
              [76.71208743600005, 73.14105866100005],
              [76.69239342500003, 73.14142487200007],
              [76.63257897200003, 73.13125234600005],
              [76.31836998800003, 73.14809804900005],
              [76.17090905000003, 73.18162669500003],
              [76.14389082100007, 73.19725169500003],
              [76.13331139400003, 73.20831940300008],
              [76.14503014400003, 73.21482982000003],
              [76.18458092500003, 73.21698639500005],
              [76.52751712300005, 73.18964264500005],
              [76.65577233200008, 73.19700755400004],
              [76.69507897200003, 73.18622467700004],
            ],
          ],
          [
            [
              [71.66911868600005, 73.22748444200005],
              [71.67611738400007, 73.21580638200004],
              [71.67798912900008, 73.20457591400003],
              [71.67774498800009, 73.19358958500004],
              [71.70750134000008, 73.13374842800005],
              [71.75012580600009, 73.04211181700003],
              [71.73023628800007, 73.03440871000004],
              [71.61774723700006, 73.09037564700003],
              [71.49467709100009, 73.15011707400004],
              [71.37450146400005, 73.17893414500008],
              [71.34099368600005, 73.17658112200007],
              [71.31934655000003, 73.16608307500007],
              [71.30014082100007, 73.15159739800004],
              [71.27930748800009, 73.14313385600008],
              [70.97063235750008, 73.12299225450008],
              [70.66195722700007, 73.10285065300008],
              [70.46192467500003, 73.05117422100005],
              [70.25660241000008, 73.03827545800004],
              [70.20386803500008, 73.04657623900005],
              [70.16114342500003, 73.06952545800004],
              [70.14039147200003, 73.09100983300004],
              [70.12826582100007, 73.09796784100007],
              [70.10954837300005, 73.10089752800008],
              [70.08545983200008, 73.09796784100007],
              [70.01539147200003, 73.07123444200005],
              [69.99935957100007, 73.06098053600005],
              [70.01384524800005, 73.05402252800008],
              [70.06177819100003, 73.04629140800006],
              [70.08521569100003, 73.03754303600005],
              [70.10124759200005, 73.02578359600005],
              [70.10084069100003, 73.01797109600005],
              [70.01319420700008, 73.03241608300004],
              [69.98121178500008, 73.03314850500004],
              [69.93425540500004, 73.02509186400005],
              [69.91098066500007, 73.02558014500005],
              [69.88851972700007, 73.02968984600005],
              [69.87484785200007, 73.03827545800004],
              [69.87794030000003, 73.05805084800005],
              [69.89136803500008, 73.08759186400005],
              [69.90007571700005, 73.10138580900008],
              [69.91163170700008, 73.11456940300008],
              [69.93425540500004, 73.13174062700006],
              [70.02084394600007, 73.18280670800004],
              [70.03598066500007, 73.19660065300008],
              [70.05250084700003, 73.21572500200006],
              [70.06495201900003, 73.23712799700007],
              [70.06861412900008, 73.25787995000007],
              [70.05795332100007, 73.27924225500004],
              [70.02125084700003, 73.31053294500003],
              [70.01335696700005, 73.32998281500005],
              [70.00489342500003, 73.34332916900007],
              [69.96794681100005, 73.37620677300004],
              [69.95932050900007, 73.39883047100005],
              [69.98267662900008, 73.40810781500005],
              [70.46957441500007, 73.49921295800004],
              [70.50798587300005, 73.49013906500005],
              [70.52426191500007, 73.48004791900007],
              [70.56324303500008, 73.48102448100008],
              [70.65007571700005, 73.50014883000006],
              [70.94874108200008, 73.51748281500005],
              [71.22917728000004, 73.46474844000005],
              [71.26783287900008, 73.44354889500005],
              [71.23853600400008, 73.43650950700004],
              [71.14771569100003, 73.44969310100004],
              [71.11150149800005, 73.44733307500007],
              [71.10914147200003, 73.43988678600005],
              [71.12338300900007, 73.42706940300008],
              [71.13746178500008, 73.40875885600008],
              [71.13648522200003, 73.39252350500004],
              [71.12330162900008, 73.38084544500003],
              [71.10466556100005, 73.37030670800004],
              [71.08676191500007, 73.35757070500006],
              [71.08171634200005, 73.34577057500007],
              [71.08350670700008, 73.33209870000007],
              [71.08952884200005, 73.32005442900004],
              [71.09644616000008, 73.31317780200004],
              [71.06568444100003, 73.29857005400004],
              [70.99708092500003, 73.28839752800008],
              [70.98031660200007, 73.26536692900004],
              [71.00123131600003, 73.26605866100005],
              [71.06234785200007, 73.27903880400004],
              [71.08350670700008, 73.27928294500003],
              [71.14429772200003, 73.27220286700003],
              [71.21192467500003, 73.27440013200004],
              [71.23365319100003, 73.27220286700003],
              [71.24822024800005, 73.26715729400007],
              [71.27466881600003, 73.25433991100005],
              [71.28891035200007, 73.25169505400004],
              [71.27686608200008, 73.27798086100006],
              [71.29639733200008, 73.29564036700003],
              [71.33082116000008, 73.30670807500007],
              [71.40235436300009, 73.31915924700007],
              [71.41871178500008, 73.32758209800005],
              [71.42546634200005, 73.34389883000006],
              [71.43572024800005, 73.35297272300005],
              [71.45915774800005, 73.34837474200003],
              [71.60792076900003, 73.27533600500004],
              [71.62476647200003, 73.26166413000004],
              [71.63013756600003, 73.25153229400007],
              [71.66911868600005, 73.22748444200005],
            ],
          ],
          [
            [
              [76.75660241000008, 73.44969310100004],
              [76.75440514400003, 73.42987702000005],
              [76.72364342500003, 73.43577708500004],
              [76.65479576900003, 73.46401601800005],
              [76.56275475400008, 73.48631419500003],
              [76.27735436300003, 73.51862213700008],
              [76.11687259200005, 73.51341380400004],
              [76.07195071700005, 73.52545807500007],
              [76.16211998800003, 73.56256745000007],
              [76.25074303500008, 73.55418528900003],
              [76.42481530000003, 73.51862213700008],
              [76.51742597700007, 73.51239655200004],
              [76.73121178500008, 73.46979401200008],
              [76.75660241000008, 73.44969310100004],
            ],
          ],
          [
            [
              [75.92261803500008, 73.52366771000004],
              [75.88982181100005, 73.51605866100005],
              [75.87305748800003, 73.50999583500004],
              [75.86589603000004, 73.50153229400007],
              [75.87045332100007, 73.49290599200003],
              [75.89291425900007, 73.48021067900004],
              [75.90064537900008, 73.47085195500006],
              [75.80258222700007, 73.45384349200003],
              [75.49642988400007, 73.44969310100004],
              [75.51050866000008, 73.45408763200004],
              [75.52588951900003, 73.46100495000007],
              [75.53500410200007, 73.46918366100005],
              [75.53077233200008, 73.47768789300005],
              [75.53541100400008, 73.48281484600005],
              [75.54428144600007, 73.49811432500007],
              [75.52572675900007, 73.49404531500005],
              [75.47234134200005, 73.47418854400007],
              [75.40056399800005, 73.45831940300008],
              [75.37973066500007, 73.44969310100004],
              [75.36296634200005, 73.43524811400005],
              [75.36451256600003, 73.42576732000003],
              [75.37191816500007, 73.41811758000006],
              [75.37305748800003, 73.40875885600008],
              [75.36003665500004, 73.39695872600004],
              [75.34131920700008, 73.39329661700003],
              [75.32113691500007, 73.39736562700006],
              [75.30420983200008, 73.40875885600008],
              [75.30681399800005, 73.41864655200004],
              [75.30827884200005, 73.42084381700005],
              [75.31104576900003, 73.42304108300004],
              [75.31381269600007, 73.42853424700007],
              [75.33529707100007, 73.45091380400004],
              [75.35962975400008, 73.46906159100007],
              [75.42090905000003, 73.49811432500007],
              [75.61939537900008, 73.55341217700004],
              [76.03386478000004, 73.57904694200005],
              [76.07935631600003, 73.55955638200004],
              [76.04224694100003, 73.54437897300005],
              [75.92261803500008, 73.52366771000004],
            ],
          ],
          [
            [
              [143.474945509, 73.32062409100007],
              [143.51710045700008, 73.27838776200008],
              [143.53834069100003, 73.25177643400008],
              [143.56511332800005, 73.23115028900008],
              [143.52628679200006, 73.20780655700008],
              [143.40655699, 73.18839427200004],
              [143.17494506900005, 73.17658021600005],
              [142.75718066500008, 73.22086551000007],
              [142.538281653, 73.21383151300006],
              [142.34392675700008, 73.23523862200005],
              [142.2185031470001, 73.24045947500008],
              [141.84103014000004, 73.27010924100006],
              [141.5124347950001, 73.29935170900006],
              [141.308647103, 73.33072879000008],
              [141.04863392700003, 73.37036707100006],
              [140.78862075100005, 73.41000535200004],
              [140.50265405100004, 73.40544238800004],
              [140.288702866, 73.38317323300004],
              [140.1596083390001, 73.34718274000005],
              [139.9651000030001, 73.32656662500005],
              [139.81669593900006, 73.33906922000006],
              [139.78649522400008, 73.36952378100005],
              [139.76708783100003, 73.41834474900008],
              [139.9065184970001, 73.47102948500003],
              [140.08050573000003, 73.45866971300006],
              [140.2348738940001, 73.45229726800005],
              [140.4933024390001, 73.48504391600005],
              [140.62671959700003, 73.56195709800005],
              [140.65992272200003, 73.57998281500005],
              [140.68970787900003, 73.60394928600005],
              [140.7119246750001, 73.63206614800004],
              [140.73194420700008, 73.65277741100005],
              [140.79216556100005, 73.70026276200008],
              [140.809418165, 73.71727122600004],
              [140.84009850400003, 73.75507233300004],
              [140.86638431100005, 73.77977122600004],
              [140.89918053500003, 73.80145905200004],
              [140.93474368600005, 73.81928131700005],
              [141.12720787900003, 73.88165924700007],
              [141.1660262380001, 73.88231028900003],
              [141.16391035200002, 73.87848541900007],
              [141.170258009, 73.87689850500004],
              [141.18091881600003, 73.87579987200007],
              [141.20777428500003, 73.86933014500005],
              [141.368011915, 73.86383698100008],
              [141.5947371750001, 73.90607330900008],
              [142.04517662900003, 73.91657135600008],
              [142.273773634, 73.86570872600004],
              [142.48113040500004, 73.84760163000004],
              [142.58277428500003, 73.82534414300005],
              [142.88355553500003, 73.71059804900005],
              [142.92693118600005, 73.70416901200008],
              [142.94507897200003, 73.69944896000004],
              [143.009125196, 73.66571686400005],
              [143.0302840500001, 73.65888092700004],
              [143.1533309250001, 73.64240143400008],
              [143.4072371750001, 73.54279205900008],
              [143.4375106130001, 73.52204010600008],
              [143.483734571, 73.48012929900005],
              [143.53695722700002, 73.44354889500005],
              [143.46697024800005, 73.41290924700007],
              [143.44092858200008, 73.40875885600008],
              [143.4492293630001, 73.39630768400008],
              [143.45191491000003, 73.38397858300004],
              [143.45240319100003, 73.37213776200008],
              [143.45460045700008, 73.36098867400005],
              [143.45883222700002, 73.35809967700004],
              [143.4658309250001, 73.35724518400008],
              [143.47217858200008, 73.35394928600005],
              [143.474945509, 73.34389883000006],
              [143.47413170700008, 73.33746979400007],
              [143.47282962300005, 73.33274974200003],
              [143.4726668630001, 73.32782623900005],
              [143.474945509, 73.32062409100007],
            ],
          ],
          [
            [
              [124.58594811300009, 73.91583893400008],
              [124.63331139400009, 73.91014232000003],
              [124.65699303500003, 73.90277741100005],
              [124.66065514400009, 73.89199453300006],
              [124.62956790500004, 73.87225983300004],
              [124.51417076900009, 73.84137604400007],
              [124.50668379000001, 73.84137604400007],
              [124.48658287900003, 73.85248444200005],
              [124.46273847700002, 73.85663483300004],
              [124.43824303500003, 73.85516998900005],
              [124.41578209700003, 73.84955475500004],
              [124.39047285200002, 73.84662506700005],
              [124.36915123800009, 73.85370514500005],
              [124.34937584700003, 73.86322663000004],
              [124.32829837300005, 73.86806875200006],
              [124.31202233200008, 73.86896393400008],
              [124.29615319100003, 73.87262604400007],
              [124.28785241000003, 73.88092682500007],
              [124.29444420700008, 73.89541250200006],
              [124.31251061300009, 73.90424225500004],
              [124.35694420700008, 73.90501536700003],
              [124.37647545700008, 73.91583893400008],
              [124.36255944100003, 73.91535065300008],
              [124.34880618600005, 73.91644928600005],
              [124.33497155000009, 73.91913483300004],
              [124.32178795700008, 73.92328522300005],
              [124.38103274800005, 73.93939850500004],
              [124.57569420700008, 73.95001862200007],
              [124.48601321700005, 73.93524811400005],
              [124.45883222700002, 73.92328522300005],
              [124.58594811300009, 73.91583893400008],
            ],
          ],
          [
            [
              [84.35523522200003, 74.01886627800008],
              [84.32813561300003, 74.01251862200007],
              [84.35059655000003, 73.99778880400004],
              [84.41830488400007, 73.97044505400004],
              [84.37859134200005, 73.95604075700004],
              [84.33423912900008, 73.95547109600005],
              [84.22868899800005, 73.96694570500006],
              [84.17872155000003, 73.98476797100005],
              [83.91211998800003, 73.99359772300005],
              [83.89649498800003, 73.99823639500005],
              [83.88502037900008, 74.00653717700004],
              [83.88453209700003, 74.01886627800008],
              [83.89747155000003, 74.02317942900004],
              [83.96583092500003, 74.02570221600007],
              [83.98015384200005, 74.03314850500004],
              [84.01758873800003, 74.03436920800004],
              [84.15788821700005, 74.01886627800008],
              [84.24496504000007, 74.02415599200003],
              [84.37940514400003, 74.04767487200007],
              [84.40650475400008, 74.04800039300005],
              [84.41830488400007, 74.03998444200005],
              [84.41089928500003, 74.02724844000005],
              [84.39307701900003, 74.02098216400003],
              [84.35523522200003, 74.01886627800008],
            ],
          ],
          [
            [
              [83.51343834700003, 74.12128327000005],
              [83.53956139400003, 74.11961497600004],
              [83.56967207100007, 74.11432526200008],
              [83.59839928500003, 74.10492584800005],
              [83.62012780000003, 74.09088776200008],
              [83.61304772200003, 74.08087799700007],
              [83.58253014400003, 74.07343170800004],
              [83.52759850400008, 74.06732819200005],
              [83.53484134200005, 74.08250560100004],
              [83.50310306100005, 74.08559804900005],
              [83.39551842500003, 74.07453034100007],
              [83.40365644600007, 74.06207916900007],
              [83.43392988400007, 74.05036041900007],
              [83.46558678500003, 74.04682038000004],
              [83.43336022200003, 74.03681061400005],
              [83.39234459700003, 74.03579336100006],
              [83.08130944100003, 74.08710358300004],
              [82.82813561300003, 74.08030833500004],
              [82.82813561300003, 74.08779531500005],
              [82.81446373800003, 74.09398021000004],
              [82.85922285200007, 74.11859772300005],
              [82.91749108200008, 74.13092682500007],
              [83.05909264400003, 74.13678620000007],
              [83.18002363400007, 74.15517812700006],
              [83.51343834700003, 74.12128327000005],
            ],
          ],
          [
            [
              [82.56804446700005, 74.16290924700007],
              [82.74000084700003, 74.10138580900008],
              [82.71143639400003, 74.08588288000004],
              [82.66537519600007, 74.06761302300004],
              [82.61963951900003, 74.05499909100007],
              [82.59213300900007, 74.05646393400008],
              [82.55176842500003, 74.07391998900005],
              [82.35287519600007, 74.08087799700007],
              [82.33432050900007, 74.08563873900005],
              [82.32105553500008, 74.10138580900008],
              [82.31755618600005, 74.11684804900005],
              [82.32203209700003, 74.12718333500004],
              [82.33326256600003, 74.13446686400005],
              [82.34986412900008, 74.14061107000003],
              [82.39869225400008, 74.15289948100008],
              [82.45435631600003, 74.16071198100008],
              [82.56804446700005, 74.16290924700007],
            ],
          ],
          [
            [
              [136.25896243600005, 73.95746491100005],
              [136.26978600400003, 73.93162669500003],
              [136.24830162900003, 73.91209544500003],
              [136.2133895190001, 73.89972565300008],
              [136.17400149800005, 73.89354075700004],
              [136.16773522200003, 73.88914622600004],
              [136.16285241000003, 73.88373444200005],
              [136.15609785200002, 73.87889232000003],
              [136.14616946700005, 73.87710195500006],
              [136.1352645190001, 73.87921784100007],
              [136.08073978000004, 73.89817942900004],
              [136.06617272200003, 73.90729401200008],
              [136.06031334700003, 73.91958242400005],
              [136.04167728000004, 73.93805573100008],
              [135.73267662900003, 74.04120514500005],
              [135.70655358200008, 74.05565013200004],
              [135.68580162900003, 74.07453034100007],
              [135.67725670700008, 74.09772370000007],
              [135.6601668630001, 74.11017487200007],
              [135.55298912900003, 74.15102773600006],
              [135.5141707690001, 74.15517812700006],
              [135.47535241000003, 74.15497467700004],
              [135.43930097700002, 74.16111888200004],
              [135.4091903000001, 74.18402741100005],
              [135.39128665500004, 74.23456452000005],
              [135.38062584700003, 74.24420807500007],
              [135.3540145190001, 74.25910065300008],
              [135.38550866000003, 74.25910065300008],
              [135.4008895190001, 74.25702545800004],
              [135.4516707690001, 74.24262116100005],
              [135.58952884200005, 74.23505280200004],
              [135.7451278000001, 74.17039622600004],
              [135.86841881600003, 74.13873932500007],
              [135.913422071, 74.13328685100004],
              [135.95728600400003, 74.11513906500005],
              [136.0107528000001, 74.10346100500004],
              [136.02613366000003, 74.09772370000007],
              [136.11475670700008, 74.04682038000004],
              [136.21631920700008, 74.01422760600008],
              [136.2627059250001, 73.98899974200003],
              [136.25896243600005, 73.95746491100005],
            ],
          ],
          [
            [
              [141.09782962300005, 74.14923737200007],
              [141.086273634, 74.13983795800004],
              [141.07536868600005, 74.13312409100007],
              [141.071136915, 74.12506745000007],
              [141.0800887380001, 74.11172109600005],
              [141.0820418630001, 74.10610586100006],
              [141.07781009200005, 74.10244375200006],
              [141.07195071700005, 74.09894440300008],
              [141.06983483200008, 74.09398021000004],
              [141.07252037900003, 74.08974844000005],
              [141.08171634200005, 74.08250560100004],
              [141.08350670700008, 74.07721588700008],
              [141.0810653000001, 74.06460195500006],
              [141.0747176440001, 74.06000397300005],
              [141.06617272200003, 74.05646393400008],
              [141.05681399800005, 74.04682038000004],
              [141.05396569100003, 74.03839752800008],
              [141.05298912900003, 74.02114492400005],
              [141.04867597700002, 74.01211172100005],
              [141.03777103000004, 74.00385163000004],
              [140.98796634200005, 73.98476797100005],
              [140.940765821, 73.97675202000005],
              [140.84351647200003, 73.97650788000004],
              [140.79615319100003, 73.97044505400004],
              [140.74341881600003, 73.95233795800004],
              [140.723968946, 73.95001862200007],
              [140.67400149800005, 73.94928620000007],
              [140.62476647200003, 73.94318268400008],
              [140.563324415, 73.91937897300005],
              [140.54509524800005, 73.91583893400008],
              [140.43775475400003, 73.90843333500004],
              [140.3266707690001, 73.93862539300005],
              [140.1983621170001, 74.02558188400008],
              [140.16471625500003, 74.07063819000007],
              [140.17277571900001, 74.10342368200008],
              [140.1779748990001, 74.15436468500008],
              [140.19313617500006, 74.19069773600006],
              [140.22188882800003, 74.22008231800004],
              [140.349900026, 74.25421572500005],
              [140.6206747205, 74.26536587150005],
              [140.891449415, 74.27651601800005],
              [140.97925866000003, 74.26333242400005],
              [141.05836022200003, 74.23444245000007],
              [141.1040145190001, 74.18402741100005],
              [141.11011803500003, 74.17035553600005],
              [141.112640821, 74.16608307500007],
              [141.09782962300005, 74.14923737200007],
            ],
          ],
          [
            [
              [116.09831790500004, 74.35468170800004],
              [116.11654707100001, 74.33934153900003],
              [116.12484785200002, 74.32322825700004],
              [116.11817467500009, 74.30744049700007],
              [116.09148196700005, 74.29262929900005],
              [116.05298912900003, 74.28522370000007],
              [116.00562584700003, 74.28485748900005],
              [115.95826256600003, 74.29022858300004],
              [115.92009524800005, 74.30003489800004],
              [115.89820397200003, 74.30206940300008],
              [115.88998457100001, 74.30369700700004],
              [115.89226321700005, 74.30630117400005],
              [115.88575280000009, 74.32363515800006],
              [115.898773634, 74.34259674700007],
              [115.92066491000003, 74.35903554900005],
              [115.94125410200002, 74.36896393400008],
              [115.98072350400003, 74.37750885600008],
              [116.02279707100001, 74.37836334800005],
              [116.06332441500001, 74.37099844000005],
              [116.09831790500004, 74.35468170800004],
            ],
          ],
          [
            [
              [84.87086022200003, 74.50556061400005],
              [84.90707441500007, 74.50165436400005],
              [84.93311608200008, 74.49290599200003],
              [84.93482506600003, 74.48200104400007],
              [84.89812259200005, 74.47138092700004],
              [84.85084069100003, 74.46800364800004],
              [84.67359459700003, 74.47760651200008],
              [84.57862389400003, 74.46849192900004],
              [84.54184004000007, 74.45709870000007],
              [84.76783287900008, 74.40989817900004],
              [84.73275800900007, 74.39569733300004],
              [84.43921959700003, 74.42552317900004],
              [84.39779707100007, 74.44061920800004],
              [84.38656660200007, 74.45766836100006],
              [84.41830488400007, 74.46808502800008],
              [84.59180748800003, 74.49892812700006],
              [84.87086022200003, 74.50556061400005],
            ],
          ],
          [
            [
              [113.40577233200008, 74.44403717700004],
              [113.41277103000004, 74.43520742400005],
              [113.42204837300005, 74.41657135600008],
              [113.42953535200002, 74.40619538000004],
              [113.42945397200003, 74.39419179900005],
              [113.40870201900009, 74.38841380400004],
              [113.36475670700008, 74.38263580900008],
              [113.36638431100005, 74.35122304900005],
              [113.32732181100005, 74.32721588700008],
              [113.24122155000009, 74.30003489800004],
              [113.27222741000003, 74.28725820500006],
              [113.281586134, 74.27960846600007],
              [113.22348066500001, 74.26390208500004],
              [113.20704186300009, 74.25165436400005],
              [113.22006269600001, 74.24481842700004],
              [113.15739993600005, 74.22500234600005],
              [113.02857506600003, 74.21206289300005],
              [112.96656334700003, 74.19358958500004],
              [112.94922936300009, 74.18235911700003],
              [112.918304884, 74.15477122600004],
              [112.84571373800009, 74.10834381700005],
              [112.77491295700008, 74.08808014500005],
              [112.66732832100001, 74.10651276200008],
              [112.57789147200003, 74.10138580900008],
              [112.47706139400009, 74.12262604400007],
              [112.16285241000003, 74.13857656500005],
              [112.12077884200005, 74.15135325700004],
              [112.04175866000003, 74.18707916900007],
              [111.93873131600003, 74.21710846600007],
              [111.58130944100003, 74.26015859600005],
              [111.48454837300005, 74.29246653900003],
              [111.45923912900003, 74.31370677300004],
              [111.46851647200003, 74.34479401200008],
              [111.51099694100003, 74.36005280200004],
              [111.64771569100003, 74.37995026200008],
              [111.70313561300003, 74.37714264500005],
              [111.80876712300005, 74.35468170800004],
              [111.85157311300003, 74.35053131700005],
              [111.90267988400007, 74.35586172100005],
              [111.95134524800005, 74.37079498900005],
              [111.98682701900003, 74.39569733300004],
              [111.97242272200003, 74.40892161700003],
              [111.97291100400003, 74.42059967700004],
              [111.98365319100003, 74.43109772300005],
              [112.00049889400009, 74.44061920800004],
              [112.00416100400003, 74.44769928600005],
              [111.98145592500003, 74.46596914300005],
              [111.97315514400003, 74.47821686400005],
              [112.00733483200008, 74.53815338700008],
              [112.11011803500003, 74.55121491100005],
              [112.41138756600003, 74.53339264500005],
              [112.74976647200003, 74.49579498900005],
              [113.04769941500001, 74.49567291900007],
              [113.31446373800009, 74.47980377800008],
              [113.36646569100003, 74.46674225500004],
              [113.40577233200008, 74.44403717700004],
            ],
          ],
          [
            [
              [85.53891035200007, 74.57440827000005],
              [85.56446373800003, 74.56956614800004],
              [85.61557050900007, 74.54946523600006],
              [85.64478600400008, 74.54645416900007],
              [85.63070722700007, 74.51129791900007],
              [85.49537194100003, 74.49941640800006],
              [85.50131269600007, 74.46454498900005],
              [85.31185957100007, 74.46564362200007],
              [85.24781334700003, 74.47646719000005],
              [85.20850670700008, 74.48981354400007],
              [85.16675866000003, 74.51186758000006],
              [85.14812259200005, 74.53717682500007],
              [85.17855879000007, 74.56073639500005],
              [85.23747806100005, 74.57526276200008],
              [85.53891035200007, 74.57440827000005],
            ],
          ],
          [
            [
              [86.07846113400007, 74.55524323100008],
              [86.16277103000004, 74.54458242400005],
              [86.20215905000003, 74.53388092700004],
              [86.20720462300005, 74.51235586100006],
              [86.14747155000003, 74.49310944200005],
              [86.11304772200003, 74.48725006700005],
              [86.09791100400008, 74.49494049700007],
              [86.07992597700007, 74.50869375200006],
              [86.03907311300003, 74.51532623900005],
              [85.99537194100003, 74.51605866100005],
              [85.96827233200008, 74.51235586100006],
              [85.97437584700003, 74.50263092700004],
              [85.98389733200008, 74.49616120000007],
              [85.99561608200008, 74.49262116100005],
              [86.00855553500003, 74.49188873900005],
              [85.99170983200008, 74.47711823100008],
              [85.97787519600007, 74.46942780200004],
              [85.91732832100007, 74.46124909100007],
              [85.85840905000003, 74.44403717700004],
              [85.80372155000003, 74.44232819200005],
              [85.70769290500004, 74.46507396000004],
              [85.65845787900008, 74.47138092700004],
              [85.67465254000007, 74.48297760600008],
              [85.72730553500003, 74.50177643400008],
              [85.73462975400008, 74.50796133000006],
              [85.75017337300005, 74.52728913000004],
              [85.79053795700008, 74.56761302300004],
              [85.80298912900008, 74.57440827000005],
              [85.82545006600003, 74.57819245000007],
              [85.87476647200003, 74.57689036700003],
              [85.93913821700005, 74.58246491100005],
              [85.98926842500003, 74.57729726800005],
              [86.07846113400007, 74.55524323100008],
            ],
          ],
          [
            [
              [79.61410566500007, 74.60175202000005],
              [79.58863366000008, 74.58690013200004],
              [79.54883873800003, 74.57001373900005],
              [79.52125084700003, 74.55003489800004],
              [79.53223717500003, 74.52602773600006],
              [79.49000084700003, 74.51691315300008],
              [79.42904707100007, 74.52265045800004],
              [79.19068444100003, 74.58808014500005],
              [79.14869225400008, 74.60789622600004],
              [79.16236412900008, 74.60789622600004],
              [79.20101972700007, 74.60248444200005],
              [79.24301191500007, 74.58820221600007],
              [79.28321373800003, 74.57949453300006],
              [79.31690514400003, 74.59080638200004],
              [79.31072024800005, 74.60871002800008],
              [79.26636803500008, 74.62042877800008],
              [79.18279056100005, 74.62905508000006],
              [79.20378665500004, 74.65143463700008],
              [79.24431399800005, 74.65863678600005],
              [79.32056725400008, 74.65631745000007],
              [79.31657962300005, 74.64935944200005],
              [79.31023196700005, 74.64354075700004],
              [79.30201256600003, 74.63898346600007],
              [79.29273522200003, 74.63589101800005],
              [79.33375084700003, 74.62531159100007],
              [79.56332441500007, 74.61225006700005],
              [79.59717858200008, 74.60333893400008],
              [79.61410566500007, 74.60175202000005],
            ],
          ],
          [
            [
              [85.22706139400003, 74.74510325700004],
              [85.11451256600003, 74.74583567900004],
              [85.09669030000003, 74.75560130400004],
              [85.11329186300003, 74.76569245000007],
              [85.34620201900003, 74.77789948100008],
              [85.40870201900003, 74.79002513200004],
              [85.46664472700007, 74.81395091400003],
              [85.49586022200003, 74.81386953300006],
              [85.53736412900008, 74.80267975500004],
              [85.55982506600003, 74.79975006700005],
              [85.61036217500003, 74.80394114800004],
              [85.63477623800003, 74.80272044500003],
              [85.65845787900008, 74.79352448100008],
              [85.65064537900008, 74.77114492400005],
              [85.66195722700007, 74.75385163000004],
              [85.68336022200003, 74.74087148600006],
              [85.70622806100005, 74.73143138200004],
              [85.67896569100003, 74.72313060100004],
              [85.65503991000003, 74.72565338700008],
              [85.60377037900008, 74.73826732000003],
              [85.50603274800005, 74.71625397300005],
              [85.48406009200005, 74.72150299700007],
              [85.46176191500007, 74.73533763200004],
              [85.42798912900008, 74.74506256700005],
              [85.36573326900003, 74.75250885600008],
              [85.22706139400003, 74.74510325700004],
            ],
          ],
          [
            [
              [87.02898196700005, 74.99152252800008],
              [87.12208092500003, 74.95164622600004],
              [87.13884524800005, 74.93691640800006],
              [87.12232506600003, 74.93256256700005],
              [87.07764733200008, 74.89964427300004],
              [87.05355879000007, 74.89081452000005],
              [86.99415123800003, 74.88373444200005],
              [86.94548587300005, 74.88410065300008],
              [86.92359459700003, 74.88873932500007],
              [86.85523522200003, 74.91282786700003],
              [86.72657311300003, 74.91620514500005],
              [86.69988040500004, 74.91010163000004],
              [86.68685957100007, 74.89594147300005],
              [86.69605553500003, 74.88703034100007],
              [86.74089603000004, 74.87132396000004],
              [86.77979576900003, 74.86542389500005],
              [86.82618248800003, 74.85126373900005],
              [86.94703209700003, 74.84072500200006],
              [86.91960696700005, 74.81981028900003],
              [86.87159264400003, 74.82046133000006],
              [86.73243248800003, 74.84951406500005],
              [86.57081139400003, 74.84072500200006],
              [86.54468834700003, 74.84247467700004],
              [86.49390709700003, 74.85260651200008],
              [86.46778405000003, 74.85496653900003],
              [86.36475670700008, 74.84813060100004],
              [86.31983483200008, 74.85089752800008],
              [86.29818769600007, 74.85765208500004],
              [86.28907311300003, 74.87201569200005],
              [86.27906334700003, 74.88251373900005],
              [86.23031660200007, 74.89508698100008],
              [86.21338951900003, 74.90338776200008],
              [86.23259524800005, 74.91461823100008],
              [86.25114993600005, 74.91864655200004],
              [86.27125084700003, 74.91583893400008],
              [86.29590905000003, 74.90648021000004],
              [86.32007897200003, 74.90029531500005],
              [86.50945071700005, 74.89032623900005],
              [86.56592858200008, 74.89691803600005],
              [86.59750410200007, 74.91705963700008],
              [86.57357832100007, 74.91742584800005],
              [86.50131269600007, 74.93065013200004],
              [86.52930748800003, 74.95058828300006],
              [86.51303144600007, 74.96572500200006],
              [86.49512780000003, 74.97846100500004],
              [86.52393639400003, 74.98696523600006],
              [86.63917076900003, 74.97223541900007],
              [86.62525475400008, 74.95551178600005],
              [86.61866295700008, 74.95058828300006],
              [86.71892337300005, 74.95477936400005],
              [86.91578209700003, 74.98932526200008],
              [87.02898196700005, 74.99152252800008],
            ],
          ],
          [
            [
              [82.13656660200007, 75.14232005400004],
              [82.14600670700008, 75.13296133000006],
              [82.15040123800003, 75.12148672100005],
              [82.15154056100005, 75.10862864800004],
              [82.15040123800003, 75.09516022300005],
              [82.05681399800005, 75.11790599200003],
              [82.02670332100007, 75.12872955900008],
              [82.05111738400007, 75.14618561400005],
              [82.08253014400003, 75.15802643400008],
              [82.11329186300003, 75.15863678600005],
              [82.13656660200007, 75.14232005400004],
            ],
          ],
          [
            [
              [82.23959394600007, 75.37567780200004],
              [82.25228925900007, 75.36473216400003],
              [82.28126061300003, 75.34564850500004],
              [82.29428144600007, 75.33417389500005],
              [82.24382571700005, 75.33274974200003],
              [82.07691491000008, 75.34613678600005],
              [82.04118899800005, 75.33783600500004],
              [82.04200280000003, 75.32990143400008],
              [82.04420006600003, 75.32196686400005],
              [82.05128014400003, 75.30711497600004],
              [82.05258222700007, 75.29816315300008],
              [82.03777103000004, 75.28925202000005],
              [82.03370201900003, 75.28009674700007],
              [82.04395592500003, 75.26410553600005],
              [82.04542076900003, 75.25580475500004],
              [82.03394616000008, 75.25218333500004],
              [82.02173912900008, 75.25096263200004],
              [82.01091556100005, 75.24721914300005],
              [82.00114993600005, 75.24103424700007],
              [81.99268639400003, 75.23236725500004],
              [82.00424238400007, 75.22199127800008],
              [82.01172936300003, 75.20962148600006],
              [82.01286868600005, 75.19635651200008],
              [82.00562584700003, 75.18329498900005],
              [82.01303144600007, 75.17715078300006],
              [81.98454837300005, 75.17739492400005],
              [81.95639082100007, 75.18203359600005],
              [81.93018639400003, 75.19196198100008],
              [81.90658613400007, 75.20815664300005],
              [81.89454186300003, 75.22394440300008],
              [81.89429772200003, 75.23607005400004],
              [81.89795983200008, 75.24884674700007],
              [81.89698326900003, 75.26650625200006],
              [81.87077884200005, 75.31590403900003],
              [81.84538821700005, 75.32168203300006],
              [81.81763756600003, 75.32371653900003],
              [81.80201256600003, 75.31614817900004],
              [81.81397545700008, 75.29315827000005],
              [81.75855553500008, 75.29319896000004],
              [81.73121178500008, 75.29913971600007],
              [81.71159915500004, 75.31427643400008],
              [81.71713300900007, 75.29816315300008],
              [81.72055097700007, 75.29214101800005],
              [81.72510826900003, 75.28701406500005],
              [81.68848717500003, 75.27704498900005],
              [81.64079837300005, 75.28750234600005],
              [81.55388431100005, 75.32050202000005],
              [81.57618248800003, 75.34149811400005],
              [81.58171634200005, 75.34845612200007],
              [81.53435306100005, 75.34674713700008],
              [81.51107832100007, 75.35028717700004],
              [81.49244225400008, 75.36204661700003],
              [81.52491295700008, 75.38125234600005],
              [81.71159915500004, 75.45368073100008],
              [81.75180097700007, 75.46328359600005],
              [81.79330488400007, 75.46507396000004],
              [81.77165774800005, 75.44497304900005],
              [81.74122155000003, 75.42426178600005],
              [81.73194420700008, 75.40692780200004],
              [81.77295983200008, 75.39679596600007],
              [81.73878014400003, 75.38251373900005],
              [81.76823978000004, 75.38076406500005],
              [81.93962649800005, 75.39350006700005],
              [81.96534264400003, 75.40302155200004],
              [81.94516035200007, 75.41962311400005],
              [81.92139733200008, 75.43301015800006],
              [81.89527428500008, 75.44159577000005],
              [81.86915123800003, 75.44403717700004],
              [81.88770592500003, 75.45526764500005],
              [81.93034915500004, 75.45921458500004],
              [81.95101972700007, 75.46507396000004],
              [81.95101972700007, 75.47874583500004],
              [81.93677819100003, 75.48281484600005],
              [81.90853925900007, 75.48566315300008],
              [81.89698326900003, 75.49237702000005],
              [81.95997155000003, 75.50975169500003],
              [82.17074629000007, 75.51972077000005],
              [82.16830488400007, 75.51288483300004],
              [82.16374759200005, 75.50967031500005],
              [82.15040123800003, 75.50674062700006],
              [82.15040123800003, 75.49921295800004],
              [82.13013756600003, 75.45722077000005],
              [82.13428795700008, 75.44082265800006],
              [82.16456139400003, 75.43773021000004],
              [82.13135826900003, 75.42430247600004],
              [82.01303144600007, 75.44403717700004],
              [82.05290774800005, 75.41962311400005],
              [82.10368899800005, 75.41644928600005],
              [82.15658613400007, 75.41982656500005],
              [82.20394941500007, 75.41494375200006],
              [82.21778405000003, 75.40761953300006],
              [82.22535241000008, 75.39826080900008],
              [82.23121178500008, 75.38751862200007],
              [82.23959394600007, 75.37567780200004],
            ],
          ],
          [
            [
              [150.82764733200008, 75.16339752800008],
              [150.8603621750001, 75.16229889500005],
              [150.9267684250001, 75.15208567900004],
              [150.9580184250001, 75.14232005400004],
              [150.9101668630001, 75.13955312700006],
              [150.85865319100003, 75.12567780200004],
              [150.81226647200003, 75.10301341400003],
              [150.7797957690001, 75.07404205900008],
              [150.78736412900003, 75.06728750200006],
              [150.7700301440001, 75.05296458500004],
              [150.70476321700005, 75.03245677300004],
              [150.70476321700005, 75.02252838700008],
              [150.70240319100003, 75.01813385600008],
              [150.69654381600003, 75.01805247600004],
              [150.68962649800005, 75.01927317900004],
              [150.6836043630001, 75.01886627800008],
              [150.65406334700003, 75.00787995000007],
              [150.6464949880001, 75.00238678600005],
              [150.6513778000001, 74.99070872600004],
              [150.67359459700003, 74.97760651200008],
              [150.69068444100003, 74.95978424700007],
              [150.680511915, 74.93378327000005],
              [150.64527428500003, 74.90664297100005],
              [150.60922285200002, 74.89350006700005],
              [150.20256595100005, 74.84931061400005],
              [149.7959090500001, 74.80512116100005],
              [149.7724715500001, 74.79661692900004],
              [149.7290145190001, 74.76959870000007],
              [149.71753991000003, 74.76557038000004],
              [149.29371178500003, 74.77204010600008],
              [149.2089949880001, 74.75800202000005],
              [148.8633732433334, 74.77317942900005],
              [148.5177514986667, 74.78835683800007],
              [148.17212975400003, 74.80353424700007],
              [147.85320071700005, 74.88800690300008],
              [147.801605665, 74.90859609600005],
              [147.74878991000003, 74.91608307500007],
              [147.7236434250001, 74.92381419500003],
              [147.7304793630001, 74.93065013200004],
              [147.66382897200003, 74.95343659100007],
              [147.51832116000003, 74.97117747600004],
              [147.31511478000004, 74.97345612200007],
              [147.0879012380001, 75.00519440300008],
              [146.95582116000003, 75.05418528900003],
              [146.6484481130001, 75.12840403900003],
              [146.21802819100003, 75.17633698100008],
              [146.1196395190001, 75.20502350500004],
              [146.10230553500003, 75.21352773600006],
              [146.08073978000004, 75.22736237200007],
              [146.07178795700008, 75.24030182500007],
              [146.11060631600003, 75.25120677300004],
              [146.1430770190001, 75.27423737200007],
              [146.15796959700003, 75.27952708500004],
              [146.1728621750001, 75.29071686400005],
              [146.18091881600003, 75.31614817900004],
              [146.18376712300005, 75.34398021000004],
              [146.18238366000003, 75.36204661700003],
              [146.16781660200002, 75.38605377800008],
              [146.16863040500004, 75.39618561400005],
              [146.18921959700003, 75.39492422100005],
              [146.21273847700002, 75.38971588700008],
              [146.23894290500004, 75.38776276200008],
              [146.26392662900003, 75.39134349200003],
              [146.28492272200003, 75.40302155200004],
              [146.2563582690001, 75.41474030200004],
              [146.25074303500003, 75.42523834800005],
              [146.26384524800005, 75.43667226800005],
              [146.29167728000004, 75.45148346600007],
              [146.31959069100003, 75.45945872600004],
              [146.37907962300005, 75.46295807500007],
              [146.407074415, 75.47134023600006],
              [146.37427819100003, 75.48460521000004],
              [146.35043379, 75.50067780200004],
              [146.34148196700005, 75.52265045800004],
              [146.35303795700008, 75.55390045800004],
              [146.3891707690001, 75.58515045800004],
              [146.43620853000004, 75.59674713700008],
              [146.4863387380001, 75.59438711100006],
              [146.6630965500001, 75.55560944200005],
              [146.67212975400003, 75.54954661700003],
              [146.683929884, 75.53196849200003],
              [146.69418379, 75.52521393400008],
              [146.77076256600003, 75.50674062700006],
              [146.7539168630001, 75.49542877800008],
              [146.7295028000001, 75.48822663000004],
              [146.703461134, 75.48480866100005],
              [146.681976759, 75.48493073100008],
              [146.68637129, 75.47504303600005],
              [146.688812696, 75.47134023600006],
              [146.64210045700008, 75.44769928600005],
              [146.63428795700008, 75.43773021000004],
              [146.64283287900003, 75.42316315300008],
              [146.66472415500004, 75.41596100500004],
              [146.7094832690001, 75.40985748900005],
              [146.72820071700005, 75.40241120000007],
              [146.77076256600003, 75.37567780200004],
              [146.79672285200002, 75.36635976800005],
              [147.15503991000003, 75.33637116100005],
              [147.21656334700003, 75.34613678600005],
              [147.32545006600003, 75.34983958500004],
              [147.34742272200003, 75.35521067900004],
              [147.31169681100005, 75.37482330900008],
              [147.2627059250001, 75.37506745000007],
              [147.16814212300005, 75.36204661700003],
              [147.19263756600003, 75.38117096600007],
              [147.23064212300005, 75.39630768400008],
              [147.27165774800005, 75.40631745000007],
              [147.35027103000004, 75.40985748900005],
              [147.3613387380001, 75.40835195500006],
              [147.3613387380001, 75.40460846600007],
              [147.35816491000003, 75.40029531500005],
              [147.36052493600005, 75.39679596600007],
              [147.37818444100003, 75.39264557500007],
              [147.43620853000004, 75.38934967700004],
              [147.42156009200005, 75.40643952000005],
              [147.39210045700008, 75.41738515800006],
              [147.33318118600005, 75.43036530200004],
              [147.37387129, 75.44037506700005],
              [147.68620853000004, 75.44208405200004],
              [147.83855228000004, 75.41909414300005],
              [148.12313886850006, 75.42009105050005],
              [148.40772545700008, 75.42108795800004],
              [148.54712975400003, 75.38556549700007],
              [148.5800887380001, 75.38251373900005],
              [148.5527449880001, 75.34674713700008],
              [148.54281660200002, 75.34153880400004],
              [148.52507571700005, 75.33783600500004],
              [148.45728600400003, 75.31085846600007],
              [148.44450931100005, 75.28729889500005],
              [148.479828321, 75.26581452000005],
              [148.56031334700003, 75.23859284100007],
              [148.55420983200008, 75.22736237200007],
              [148.5576278000001, 75.22235748900005],
              [148.6103621750001, 75.21552155200004],
              [148.6728621750001, 75.22451406500005],
              [148.7036238940001, 75.22553131700005],
              [148.78492272200003, 75.21873607000003],
              [148.89991295700008, 75.22272370000007],
              [148.946625196, 75.23822663000004],
              [149.12680097700002, 75.26862213700008],
              [149.46100236600003, 75.2542585303334],
              [149.79520375500007, 75.23989492366672],
              [150.1294051440001, 75.22553131700005],
              [150.1748153000001, 75.21287669500003],
              [150.1962996750001, 75.20221588700008],
              [150.21469160200002, 75.18699778900003],
              [150.2138778000001, 75.17719147300005],
              [150.19800866000003, 75.16966380400004],
              [150.17758222700002, 75.16323476800005],
              [150.163422071, 75.15664297100005],
              [150.21306399800005, 75.16840241100005],
              [150.266449415, 75.16571686400005],
              [150.41749108200008, 75.13458893400008],
              [150.56080162900003, 75.12872955900008],
              [150.53891035200002, 75.11896393400008],
              [150.49187259200005, 75.10960521000004],
              [150.47136478000004, 75.10138580900008],
              [150.50025475400003, 75.09446849200003],
              [150.53541100400003, 75.09568919500003],
              [150.6328231130001, 75.11652252800008],
              [150.64828535200002, 75.12335846600007],
              [150.66041100400003, 75.13239166900007],
              [150.66521243600005, 75.14158763200004],
              [150.664886915, 75.14899323100008],
              [150.66578209700003, 75.15501536700003],
              [150.67367597700002, 75.15997955900008],
              [150.70964603000004, 75.16689687700006],
              [150.82764733200008, 75.16339752800008],
            ],
          ],
          [
            [
              [136.9751082690001, 75.59174225500004],
              [136.96998131600003, 75.59711334800005],
              [136.96762129, 75.60179271000004],
              [136.96794681100005, 75.60594310100004],
              [136.96981855600006, 75.60903554900005],
              [136.96989993600005, 75.60781484600005],
              [136.96989993600005, 75.60578034100007],
              [136.97022545700008, 75.60374583500004],
              [136.97144616000003, 75.60162995000007],
              [136.99203535200002, 75.58832428600005],
              [137.05681399800005, 75.57831452000005],
              [137.08130944100003, 75.56818268400008],
              [137.05453535200002, 75.56801992400005],
              [137.02515709700003, 75.57160065300008],
              [136.99732506600003, 75.57933177300004],
              [136.9751082690001, 75.59174225500004],
            ],
          ],
          [
            [
              [137.059906446, 75.64077383000006],
              [137.071136915, 75.64325592700004],
              [137.08350670700008, 75.64325592700004],
              [137.1313582690001, 75.65241120000007],
              [137.13990319100003, 75.65281810100004],
              [137.11158287900003, 75.64280833500004],
              [136.98121178500003, 75.61652252800008],
              [136.97022545700008, 75.60968659100007],
              [136.98462975400003, 75.62164948100008],
              [137.0127059250001, 75.62978750200006],
              [137.059906446, 75.64077383000006],
            ],
          ],
          [
            [
              [135.99138431100005, 75.52716705900008],
              [135.959320509, 75.50202057500007],
              [135.967133009, 75.47947825700004],
              [135.99756920700008, 75.46002838700008],
              [136.03296959700003, 75.44403717700004],
              [136.01335696700005, 75.42890045800004],
              [135.9834090500001, 75.41718170800004],
              [135.84449303500003, 75.38263580900008],
              [135.450043165, 75.37567780200004],
              [135.4497176440001, 75.39443594000005],
              [135.4550887380001, 75.40766022300005],
              [135.45883222700002, 75.42129140800006],
              [135.45378665500004, 75.43402741100005],
              [135.4511824880001, 75.44745514500005],
              [135.46159915500004, 75.46206289300005],
              [135.47836347700002, 75.47386302300004],
              [135.51579837300005, 75.48403554900005],
              [135.5283309250001, 75.49677155200004],
              [135.546234571, 75.52716705900008],
              [135.594086134, 75.56818268400008],
              [135.5883895190001, 75.59739817900004],
              [135.55225670700008, 75.64809804900005],
              [135.539398634, 75.67796458500004],
              [135.5527449880001, 75.68162669500003],
              [135.56511478000004, 75.68797435100004],
              [135.5879012380001, 75.70465729400007],
              [135.58366946700005, 75.71010976800005],
              [135.57829837300005, 75.72052643400008],
              [135.57349694100003, 75.72577545800004],
              [135.58562259200005, 75.73029205900008],
              [135.59400475400003, 75.73607005400004],
              [135.607758009, 75.75250885600008],
              [135.60417728000004, 75.75885651200008],
              [135.60271243600005, 75.76434967700004],
              [135.60474694100003, 75.76984284100007],
              [135.61101321700005, 75.77521393400008],
              [135.61687259200005, 75.77680084800005],
              [135.62281334700003, 75.77732982000003],
              [135.6567488940001, 75.79287344000005],
              [135.67107181100005, 75.80166250200006],
              [135.67725670700008, 75.81085846600007],
              [135.67725670700008, 75.81997304900005],
              [135.67798912900003, 75.82575104400007],
              [135.67994225400003, 75.83002350500004],
              [135.6840926440001, 75.83441803600005],
              [135.6782332690001, 75.85976797100005],
              [135.69312584700003, 75.86933014500005],
              [135.70850670700008, 75.86481354400007],
              [135.703949415, 75.84808991100005],
              [135.73601321700005, 75.82583242400005],
              [135.78052819100003, 75.80524323100008],
              [135.8164168630001, 75.78058502800008],
              [135.8212996750001, 75.74567291900007],
              [135.8383895190001, 75.74022044500003],
              [135.84717858200008, 75.72606028900003],
              [135.8540145190001, 75.71141185100004],
              [135.86475670700008, 75.70465729400007],
              [135.8867293630001, 75.69936758000006],
              [135.93279056100005, 75.67593008000006],
              [135.9575301440001, 75.67055898600006],
              [135.98601321700005, 75.66864655200004],
              [136.0556746750001, 75.65570709800005],
              [136.1064559250001, 75.63898346600007],
              [136.1601668630001, 75.62962474200003],
              [136.18433678500003, 75.61591217700004],
              [136.168304884, 75.60089752800008],
              [135.99138431100005, 75.52716705900008],
            ],
          ],
          [
            [
              [82.10954837300005, 75.88898346600007],
              [82.22803795700008, 75.88703034100007],
              [82.25904381600003, 75.87596263200004],
              [82.22315514400003, 75.86041901200008],
              [81.76140384200005, 75.89386627800008],
              [81.67888431100005, 75.91315338700008],
              [81.59327233200008, 75.91718170800004],
              [81.55388431100005, 75.93060944200005],
              [81.57764733200008, 75.93545156500005],
              [81.60230553500008, 75.93744538000004],
              [81.62761478000004, 75.93675364800004],
              [81.63705488400007, 75.93475983300004],
              [81.63640384200005, 75.93060944200005],
              [81.68637129000007, 75.93146393400008],
              [82.10954837300005, 75.88898346600007],
            ],
          ],
          [
            [
              [83.27947024800005, 75.95628489800004],
              [83.29712975400008, 75.94310130400004],
              [83.27605228000004, 75.93073151200008],
              [83.21290123800003, 75.91693756700005],
              [83.17448978000004, 75.91669342700004],
              [83.06153405000003, 75.93060944200005],
              [83.02466881600003, 75.93016185100004],
              [82.91765384200005, 75.91693756700005],
              [82.86231530000003, 75.91718170800004],
              [82.84327233200008, 75.92487213700008],
              [82.85613040500004, 75.94428131700005],
              [82.82398522200003, 75.95477936400005],
              [82.70728600400008, 75.94428131700005],
              [82.53394616000008, 75.95795319200005],
              [82.38941491000008, 75.94428131700005],
              [82.31641686300003, 75.94717031500005],
              [82.27784264400003, 75.95538971600007],
              [82.25904381600003, 75.97223541900007],
              [82.41529381600003, 75.96507396000004],
              [82.46501712300005, 75.97223541900007],
              [82.53614342500003, 75.99437083500004],
              [82.56120853000004, 75.99884674700007],
              [82.65748131600003, 75.99884674700007],
              [82.69556725400008, 75.99062734600005],
              [82.97002200650007, 75.97646718950006],
              [83.24447675900007, 75.96230703300006],
              [83.27947024800005, 75.95628489800004],
            ],
          ],
          [
            [
              [145.3662215500001, 75.54022858300004],
              [145.38453209700003, 75.52631256700005],
              [145.39039147200003, 75.51683177300004],
              [145.3808699880001, 75.51227448100008],
              [145.26547285200002, 75.52033112200007],
              [145.07195071700005, 75.50063711100006],
              [144.96794681100005, 75.47239817900004],
              [144.78248131600003, 75.44692617400005],
              [144.72934004, 75.43158600500004],
              [144.71168053500003, 75.42039622600004],
              [144.69792728000004, 75.40477122600004],
              [144.69597415500004, 75.39923737200007],
              [144.69947350400003, 75.39398834800005],
              [144.7021590500001, 75.37909577000005],
              [144.69654381600003, 75.36774323100008],
              [144.6723738940001, 75.34910716400003],
              [144.66724694100003, 75.34153880400004],
              [144.6777449880001, 75.32782623900005],
              [144.6997176440001, 75.32147858300004],
              [144.89380944100003, 75.29230377800008],
              [144.94109134200005, 75.27334219000005],
              [144.8891707690001, 75.25804271000004],
              [144.76840254, 75.26117584800005],
              [144.72136478000004, 75.24603913000004],
              [144.7270613940001, 75.22597890800006],
              [144.72087649800005, 75.20050690300008],
              [144.70655358200008, 75.17633698100008],
              [144.68816165500004, 75.15997955900008],
              [144.6630965500001, 75.15151601800005],
              [144.57699629, 75.13776276200008],
              [144.49634850400003, 75.11196523600006],
              [144.41773522200003, 75.06903717700004],
              [144.376312696, 75.05304596600007],
              [144.33122806100005, 75.04677969000005],
              [144.1528426440001, 75.04645416900007],
              [143.9985457690001, 75.02496979400007],
              [143.97046959700003, 75.02789948100008],
              [143.9458113940001, 75.03461334800005],
              [143.84489993600005, 75.05011627800008],
              [143.77759850400003, 75.07599518400008],
              [143.75074303500003, 75.08177317900004],
              [143.51587975400003, 75.08730703300006],
              [143.41480553500003, 75.06708405200004],
              [143.36060631600003, 75.07111237200007],
              [143.255218946, 75.09516022300005],
              [143.0825301440001, 75.11082591400003],
              [143.0498153000001, 75.12872955900008],
              [143.03589928500003, 75.12592194200005],
              [142.98853600400003, 75.13613515800006],
              [142.94516035200002, 75.13373444200005],
              [142.89812259200005, 75.14154694200005],
              [142.88445071700005, 75.14679596600007],
              [142.87224368600005, 75.15664297100005],
              [142.87134850400003, 75.16185130400004],
              [142.872406446, 75.16868724200003],
              [142.87273196700005, 75.17454661700003],
              [142.8593856130001, 75.18402741100005],
              [142.84392337300005, 75.21588776200008],
              [142.83757571700005, 75.22553131700005],
              [142.808929884, 75.23281484600005],
              [142.74000084700003, 75.23016998900005],
              [142.70777428500003, 75.23859284100007],
              [142.70980879, 75.25478750200006],
              [142.67554772200003, 75.26727936400005],
              [142.66627037900003, 75.28327057500007],
              [142.659515821, 75.30878327000005],
              [142.64210045700008, 75.31997304900005],
              [142.59050540500004, 75.32786692900004],
              [142.53500410200002, 75.34552643400008],
              [142.50700931100005, 75.35980866100005],
              [142.49431399800005, 75.37567780200004],
              [142.500336134, 75.38617584800005],
              [142.52914472700002, 75.41144440300008],
              [142.53589928500003, 75.42723216400003],
              [142.53003991000003, 75.43988678600005],
              [142.51880944100003, 75.44586823100008],
              [142.5107528000001, 75.45189036700003],
              [142.51539147200003, 75.46507396000004],
              [142.534515821, 75.47654857000003],
              [142.61988366000003, 75.49046458500004],
              [142.62452233200008, 75.49437083500004],
              [142.6274520190001, 75.50682200700004],
              [142.63209069100003, 75.51288483300004],
              [142.63738040500004, 75.51605866100005],
              [142.72437584700003, 75.55068594000005],
              [142.84693444100003, 75.56134674700007],
              [143.01351972700002, 75.60244375200006],
              [143.03492272200003, 75.61762116100005],
              [143.0429793630001, 75.64667389500005],
              [143.00114993600005, 75.70795319200005],
              [142.90406334700003, 75.72455475500004],
              [142.7148543630001, 75.71149323100008],
              [142.70297285200002, 75.71393463700008],
              [142.68482506600003, 75.72589752800008],
              [142.673187696, 75.73086172100005],
              [142.6601668630001, 75.73297760600008],
              [142.61841881600003, 75.73261139500005],
              [142.51490319100003, 75.71893952000005],
              [142.3379012380001, 75.72565338700008],
              [142.2900496750001, 75.71149323100008],
              [142.32398522200003, 75.71190013200004],
              [142.36646569100003, 75.70648834800005],
              [142.40691165500004, 75.69525788000004],
              [142.4340926440001, 75.67796458500004],
              [142.4106551440001, 75.66559479400007],
              [142.3813582690001, 75.66181061400005],
              [142.06039472700002, 75.66819896000004],
              [142.0083113940001, 75.66372304900005],
              [142.02914472700002, 75.65591054900005],
              [142.13257897200003, 75.64769114800004],
              [142.181976759, 75.63776276200008],
              [142.20687910200002, 75.63580963700008],
              [142.18336022200003, 75.62824127800008],
              [142.0083113940001, 75.62274811400005],
              [142.03581790500004, 75.61359284100007],
              [142.06902103000004, 75.60700104400007],
              [142.1318465500001, 75.60162995000007],
              [142.1396590500001, 75.59516022300005],
              [142.12859134200005, 75.58063385600008],
              [142.087250196, 75.54462311400005],
              [142.0805770190001, 75.53473541900007],
              [142.08318118600005, 75.52594635600008],
              [142.0976668630001, 75.51630280200004],
              [142.18702233200008, 75.47134023600006],
              [142.16277103000004, 75.42316315300008],
              [142.15601647200003, 75.39935944200005],
              [142.16285241000003, 75.37909577000005],
              [142.19988040500004, 75.34882233300004],
              [142.4101668630001, 75.26675039300005],
              [142.426605665, 75.25218333500004],
              [142.42888431100005, 75.23834870000007],
              [142.42546634200005, 75.22500234600005],
              [142.4257918630001, 75.21295807500007],
              [142.4394637380001, 75.20311107000003],
              [142.537445509, 75.17890045800004],
              [142.58033287900003, 75.15973541900007],
              [142.61158287900003, 75.12250397300005],
              [142.60417728000004, 75.11562734600005],
              [142.62818444100003, 75.09699127800008],
              [142.66871178500003, 75.08795807500007],
              [142.8330184250001, 75.07062409100007],
              [143.01295006600003, 75.06513092700004],
              [143.24537194100003, 75.02708567900004],
              [143.44800866000003, 75.00580475500004],
              [143.55982506600003, 75.01561107000003],
              [143.61451256600003, 75.01113515800006],
              [143.66675866000003, 74.98529694200005],
              [143.70777428500003, 74.94745514500005],
              [143.6958113940001, 74.93744538000004],
              [143.66822350400003, 74.92999909100007],
              [143.46452884200005, 74.90005117400005],
              [143.00342858200008, 74.88214752800008],
              [142.924164259, 74.89411041900007],
              [142.89714603000004, 74.89093659100007],
              [142.844574415, 74.87738678600005],
              [142.8212996750001, 74.87641022300005],
              [142.78093509200005, 74.89175039300005],
              [142.758636915, 74.89594147300005],
              [142.71509850400003, 74.89516836100006],
              [142.6796981130001, 74.88987864800004],
              [142.6504012380001, 74.87567780200004],
              [142.62525475400003, 74.84813060100004],
              [142.6943465500001, 74.85333893400008],
              [142.71404056100005, 74.84813060100004],
              [142.67798912900003, 74.83397044500003],
              [142.514008009, 74.81736888200004],
              [142.35564212300005, 74.82453034100007],
              [141.97413170700008, 74.93378327000005],
              [141.97413170700008, 74.94537995000007],
              [142.00928795700008, 74.95530833500004],
              [142.0805770190001, 74.96482982000003],
              [142.11703535200002, 74.96360911700003],
              [142.19166100400003, 74.95282623900005],
              [142.2954207690001, 74.92279694200005],
              [142.33187910200002, 74.92121002800008],
              [142.36451256600003, 74.93065013200004],
              [142.34717858200008, 74.94306061400005],
              [142.3261824880001, 74.95172760600008],
              [142.24105879, 74.97540924700007],
              [142.2373153000001, 74.99103424700007],
              [142.19874108200008, 75.00421784100007],
              [141.8437606130001, 74.99896881700005],
              [141.67310631600003, 74.96482982000003],
              [141.3711043630001, 74.91950104400007],
              [141.11402428500003, 74.91665273600006],
              [140.637543165, 74.87543366100005],
              [140.549164259, 74.87763092700004],
              [140.35132897200003, 74.84007396000004],
              [140.068695509, 74.82794830900008],
              [140.0078231130001, 74.86237213700008],
              [139.996429884, 74.87335846600007],
              [139.98406009200005, 74.89374420800004],
              [139.9736434250001, 74.90338776200008],
              [139.94906660200002, 74.91095612200007],
              [139.8935653000001, 74.91217682500007],
              [139.86996504, 74.92381419500003],
              [139.8632918630001, 74.93427155200004],
              [139.85613040500004, 74.95693594000005],
              [139.8496199880001, 74.96482982000003],
              [139.82349694100003, 74.97089264500005],
              [139.71941165500004, 74.96482982000003],
              [139.69646243600005, 74.96845123900005],
              [139.65202884200005, 74.98078034100007],
              [139.62427819100003, 74.97846100500004],
              [139.4951278000001, 74.94692617400005],
              [139.45850670700008, 74.93065013200004],
              [139.48316491000003, 74.92283763200004],
              [139.481781446, 74.90648021000004],
              [139.47437584700003, 74.88666413000004],
              [139.48023522200003, 74.86859772300005],
              [139.5166121750001, 74.85594310100004],
              [139.56430097700002, 74.85814036700003],
              [139.61109459700003, 74.87075429900005],
              [139.64478600400003, 74.88910553600005],
              [139.63168379, 74.87689850500004],
              [139.61939537900003, 74.87091705900008],
              [139.59009850400003, 74.86237213700008],
              [139.56202233200008, 74.84552643400008],
              [139.54411868600005, 74.82444896000004],
              [139.52857506600003, 74.80166250200006],
              [139.50318444100003, 74.77553945500006],
              [139.5004988940001, 74.77179596600007],
              [139.49626712300005, 74.76756419500003],
              [139.34343509200005, 74.68740469000005],
              [139.23585045700008, 74.66242096600007],
              [139.12720787900003, 74.65228913000004],
              [139.015961134, 74.65753815300008],
              [138.81560306100005, 74.71405670800004],
              [138.49065188900005, 74.74512360250006],
              [138.16570071700005, 74.77619049700007],
              [138.1137801440001, 74.79035065300008],
              [138.06324303500003, 74.79612864800004],
              [137.89527428500003, 74.84617747600004],
              [137.87029056100005, 74.86050039300005],
              [137.84734134200005, 74.88206614800004],
              [137.82837975400003, 74.90680573100008],
              [137.814789259, 74.93065013200004],
              [137.81169681100005, 74.94424062700006],
              [137.8115340500001, 74.95571523600006],
              [137.8076278000001, 74.96580638200004],
              [137.793793165, 74.97540924700007],
              [137.6513778000001, 75.02277252800008],
              [137.43279056100005, 75.05044179900005],
              [137.14909915500004, 75.13422272300005],
              [137.134125196, 75.14154694200005],
              [137.10173587300005, 75.17023346600007],
              [137.08545983200008, 75.18085358300004],
              [137.03402754, 75.20502350500004],
              [136.94166100400003, 75.26349518400008],
              [136.90992272200003, 75.27334219000005],
              [136.92204837300005, 75.29751211100006],
              [136.9257918630001, 75.30971914300005],
              [136.9243270190001, 75.32050202000005],
              [136.912445509, 75.33038971600007],
              [136.87476647200003, 75.34951406500005],
              [136.86215254, 75.36204661700003],
              [136.98161868600005, 75.38865794500003],
              [137.03931725400003, 75.38800690300008],
              [137.1176863940001, 75.34320709800005],
              [137.151703321, 75.33608633000006],
              [137.25375410200002, 75.33637116100005],
              [137.37623131600003, 75.35040924700007],
              [137.40154056100005, 75.35724518400008],
              [137.4223738940001, 75.36981842700004],
              [137.4306746750001, 75.38934967700004],
              [137.420258009, 75.40713125200006],
              [137.39730879, 75.41718170800004],
              [137.34880618600005, 75.42413971600007],
              [137.27613366000003, 75.42548248900005],
              [137.20484459700003, 75.41669342700004],
              [137.1606551440001, 75.40574778900003],
              [137.14332116000003, 75.41022370000007],
              [137.12907962300005, 75.43036530200004],
              [137.1445418630001, 75.43650950700004],
              [137.1455184250001, 75.45062897300005],
              [137.14869225400003, 75.46482982000003],
              [137.17074629, 75.47134023600006],
              [137.30103600400003, 75.47134023600006],
              [137.2871199880001, 75.48460521000004],
              [137.26099694100003, 75.50478750200006],
              [137.24577884200005, 75.51288483300004],
              [137.20492597700002, 75.52802155200004],
              [137.18384850400003, 75.53949616100005],
              [137.1806746750001, 75.55072663000004],
              [137.18628991000003, 75.55707428600005],
              [137.1884871750001, 75.56093984600005],
              [137.18930097700002, 75.56403229400007],
              [137.19117272200003, 75.56818268400008],
              [137.19166100400003, 75.57387929900005],
              [137.18921959700003, 75.57660553600005],
              [137.19109134200005, 75.58026764500005],
              [137.20484459700003, 75.58860911700003],
              [137.22803795700008, 75.59300364800004],
              [137.27955162900003, 75.59137604400007],
              [137.29363040500004, 75.60162995000007],
              [137.2656356130001, 75.60797760600008],
              [137.22388756600003, 75.63666413000004],
              [137.20142662900003, 75.64325592700004],
              [137.18531334700003, 75.64484284100007],
              [137.15512129, 75.65167877800008],
              [137.14014733200008, 75.65281810100004],
              [137.15202884200005, 75.66010163000004],
              [137.159515821, 75.66876862200007],
              [137.16163170700008, 75.67902252800008],
              [137.15699303500003, 75.69106679900005],
              [137.13949629, 75.69928620000007],
              [137.08033287900003, 75.71458567900004],
              [137.06763756600003, 75.72577545800004],
              [137.15056399800005, 75.76300690300008],
              [137.15894616000003, 75.76874420800004],
              [137.1743270190001, 75.78241608300004],
              [137.18376712300005, 75.78725820500006],
              [137.19849694100003, 75.78961823100008],
              [137.3330184250001, 75.79116445500006],
              [137.4165145190001, 75.77415599200003],
              [137.5883895190001, 75.77358633000006],
              [137.69068444100003, 75.74567291900007],
              [137.71794681100005, 75.74384186400005],
              [137.7329207690001, 75.74510325700004],
              [137.7426863940001, 75.74909088700008],
              [137.74431399800005, 75.75433991100005],
              [137.74048912900003, 75.75897858300004],
              [137.73511803500003, 75.76390208500004],
              [137.7324324880001, 75.76984284100007],
              [137.70972741000003, 75.78839752800008],
              [137.60141035200002, 75.80931224200003],
              [137.5644637380001, 75.82510000200006],
              [137.53402754, 75.84568919500003],
              [137.4619246750001, 75.86855703300006],
              [137.431976759, 75.88727448100008],
              [137.423187696, 75.91010163000004],
              [137.4165145190001, 75.93911367400005],
              [137.41431725400003, 75.94086334800005],
              [137.432953321, 75.95319245000007],
              [137.7119246750001, 76.01312897300005],
              [137.92408287900003, 76.01703522300005],
              [138.02751712300005, 76.03192780200004],
              [138.11597741000003, 76.07526276200008],
              [138.11060631600003, 76.08128489800004],
              [138.10279381600003, 76.08490631700005],
              [138.0927840500001, 76.08657461100006],
              [138.08130944100003, 76.08649323100008],
              [138.0781356130001, 76.08486562700006],
              [138.01189212300005, 76.06932200700004],
              [137.9726668630001, 76.05414459800005],
              [137.979828321, 76.06281159100007],
              [137.99488366000003, 76.06777578300006],
              [138.04566491000003, 76.08515045800004],
              [138.066742384, 76.08763255400004],
              [138.089203321, 76.09096914300005],
              [138.138031446, 76.11884186400005],
              [138.37663821700005, 76.15717194200005],
              [138.35027103000004, 76.15021393400008],
              [138.3383895190001, 76.14520905200004],
              [138.32829837300005, 76.13605377800008],
              [138.34522545700008, 76.12400950700004],
              [138.36353600400003, 76.11570872600004],
              [138.37818444100003, 76.10659414300005],
              [138.3916121750001, 76.07387929900005],
              [138.40992272200003, 76.06484609600005],
              [138.4321395190001, 76.06338125200006],
              [138.4516707690001, 76.06777578300006],
              [138.446136915, 76.07835521000004],
              [138.45297285200002, 76.08974844000005],
              [138.46631920700008, 76.10032786700003],
              [138.47966556100005, 76.10871002800008],
              [138.47429446700005, 76.11172109600005],
              [138.46436608200008, 76.11985911700003],
              [138.45923912900003, 76.12299225500004],
              [138.49244225400003, 76.15973541900007],
              [138.5102645190001, 76.17523834800005],
              [138.53272545700008, 76.18610260600008],
              [138.79078209750008, 76.21259186400007],
              [139.0488387380001, 76.23908112200007],
              [139.008148634, 76.22809479400007],
              [138.9282332690001, 76.22166575700004],
              [138.89730879, 76.21873607000003],
              [138.91944420700008, 76.21662018400008],
              [138.96078535200002, 76.20693594000005],
              [138.96631920700008, 76.20164622600004],
              [138.96355228000004, 76.19464752800008],
              [138.95915774800005, 76.18646881700005],
              [138.9594832690001, 76.17767975500004],
              [138.97535241000003, 76.15778229400007],
              [138.9951278000001, 76.14451732000003],
              [139.10962975400003, 76.09686920800004],
              [139.55396569100003, 76.01137929900005],
              [139.62427819100003, 75.98582591400003],
              [139.7949324880001, 75.97842031500005],
              [139.82545006600003, 75.97003815300008],
              [139.88257897200003, 75.94550202000005],
              [139.91163170700008, 75.93744538000004],
              [139.89714603000004, 75.92523834800005],
              [139.87761478000004, 75.92658112200007],
              [139.8559676440001, 75.93162669500003],
              [139.83578535200002, 75.93060944200005],
              [139.82878665500004, 75.92324453300006],
              [139.82927493600005, 75.91421133000006],
              [139.82878665500004, 75.90656159100007],
              [139.81910241000003, 75.90326569200005],
              [139.79761803500003, 75.90082428600005],
              [139.791351759, 75.89447663000004],
              [139.79859459700003, 75.88617584800005],
              [139.8169051440001, 75.87783437700006],
              [139.8906356130001, 75.86424388200004],
              [139.90414472700002, 75.85936107000003],
              [139.938812696, 75.84186432500007],
              [139.9560653000001, 75.83584219000005],
              [140.1504012380001, 75.80052317900004],
              [140.25993899800005, 75.83112213700008],
              [140.30054772200003, 75.82689036700003],
              [140.34343509200005, 75.81679922100005],
              [140.48072350400003, 75.80093008000006],
              [140.50953209700003, 75.79047272300005],
              [140.5376082690001, 75.77431875200006],
              [140.5459090500001, 75.75551992400005],
              [140.46851647200003, 75.70905182500007],
              [140.45630944100003, 75.70465729400007],
              [140.45337975400003, 75.70062897300005],
              [140.4462996750001, 75.68130117400005],
              [140.44263756600003, 75.67426178600005],
              [140.434906446, 75.66445547100005],
              [140.432953321, 75.65656159100007],
              [140.438324415, 75.65021393400008],
              [140.452484571, 75.64500560100004],
              [140.47584069100003, 75.64032623900005],
              [140.6767684250001, 75.62327708500004],
              [140.7656356130001, 75.63129303600005],
              [140.90186608200008, 75.61591217700004],
              [140.98650149800005, 75.62067291900007],
              [141.03003991000003, 75.63080475500004],
              [141.06226647200003, 75.65009186400005],
              [141.0415145190001, 75.65818919500003],
              [140.996429884, 75.66925690300008],
              [140.97429446700005, 75.67796458500004],
              [140.98975670700008, 75.68610260600008],
              [140.99822024800005, 75.68927643400008],
              [141.0078231130001, 75.69106679900005],
              [140.974945509, 75.70538971600007],
              [140.86443118600005, 75.73883698100008],
              [140.8911238940001, 75.76951732000003],
              [140.9052840500001, 75.80890534100007],
              [140.90495853000004, 75.84837474200003],
              [140.87875410200002, 75.89691803600005],
              [140.88591556100005, 75.91254303600005],
              [140.89820397200003, 75.92877838700008],
              [140.904633009, 75.94798411700003],
              [140.90544681100005, 75.96820709800005],
              [140.90894616000003, 75.98411692900004],
              [140.91724694100003, 75.99823639500005],
              [140.9326278000001, 76.01312897300005],
              [140.966156446, 76.03497955900008],
              [141.0009871750001, 76.04743073100008],
              [141.03858483200008, 76.05288320500006],
              [141.2309676440001, 76.05707428600005],
              [141.58521569100003, 76.00751373900005],
              [141.62468509200005, 76.01312897300005],
              [141.60710696700005, 76.03017812700006],
              [141.51482181100005, 76.05414459800005],
              [141.4853621750001, 76.07265859600005],
              [141.45655358200008, 76.09910716400003],
              [141.44898522200003, 76.10439687700006],
              [141.39722741000003, 76.12531159100007],
              [141.39136803500003, 76.12921784100007],
              [141.3886824880001, 76.13385651200008],
              [141.38843834700003, 76.13886139500005],
              [141.3896590500001, 76.14272695500006],
              [141.39136803500003, 76.14350006700005],
              [141.37273196700005, 76.15363190300008],
              [141.325531446, 76.17218659100007],
              [141.31006920700008, 76.18447500200006],
              [141.36695397200003, 76.18121979400007],
              [141.59392337300005, 76.12970612200007],
              [141.7021590500001, 76.12099844000005],
              [141.9130965500001, 76.06073639500005],
              [142.14568118600005, 76.01190827000005],
              [142.42725670700008, 75.91388580900008],
              [142.4697371750001, 75.88401927300004],
              [142.48804772200003, 75.87596263200004],
              [142.5468856130001, 75.86298248900005],
              [142.9287215500001, 75.83222077000005],
              [143.05884850400003, 75.80683014500005],
              [143.27751712300005, 75.81598541900007],
              [143.38559004, 75.80707428600005],
              [143.35889733200008, 75.83441803600005],
              [143.38396243600005, 75.84625885600008],
              [143.58480879, 75.86981842700004],
              [143.68580162900003, 75.86269765800006],
              [143.78288821700005, 75.84186432500007],
              [143.7880965500001, 75.83812083500004],
              [143.79371178500003, 75.83274974200003],
              [143.80225670700008, 75.82904694200005],
              [143.81609134200005, 75.83026764500005],
              [143.847992384, 75.84056224200003],
              [143.858734571, 75.84186432500007],
              [143.94711347700002, 75.83478424700007],
              [144.1914168630001, 75.76699453300006],
              [144.42359459700003, 75.73672109600005],
              [144.60962975400003, 75.69847239800004],
              [144.70484459700003, 75.69847239800004],
              [144.72413170700008, 75.69501373900005],
              [144.7373153000001, 75.68642812700006],
              [144.76295006600003, 75.66372304900005],
              [144.80982506600003, 75.64423248900005],
              [145.174164259, 75.60822174700007],
              [145.2763778000001, 75.58344147300005],
              [145.3662215500001, 75.54022858300004],
            ],
          ],
          [
            [
              [96.64405358200003, 76.26703522300005],
              [96.64633222700007, 76.24787018400008],
              [96.62973066500007, 76.23436107000003],
              [96.60670006600003, 76.22357819200005],
              [96.58936608200003, 76.21238841400003],
              [96.57837975400008, 76.19464752800008],
              [96.58122806100005, 76.18463776200008],
              [96.58969160200007, 76.17462799700007],
              [96.59555097700007, 76.15717194200005],
              [96.56666100400008, 76.15839264500005],
              [96.54948978000004, 76.16315338700008],
              [96.53646894600007, 76.17332591400003],
              [96.51986738400007, 76.19065989800004],
              [96.52735436300003, 76.20319245000007],
              [96.53711998800003, 76.21381256700005],
              [96.56153405000003, 76.23163483300004],
              [96.46705162900008, 76.26691315300008],
              [96.44678795700003, 76.27163320500006],
              [96.42554772200003, 76.27362702000005],
              [96.40381920700003, 76.27326080900008],
              [96.36312910200007, 76.26434967700004],
              [96.34685306100005, 76.25470612200007],
              [96.35531660200007, 76.24249909100007],
              [96.40772545700003, 76.22125885600008],
              [96.42432701900003, 76.21238841400003],
              [96.38111412900008, 76.20600006700005],
              [96.27849368600005, 76.22223541900007],
              [96.24610436300003, 76.20498281500005],
              [96.27751712300005, 76.20408763200004],
              [96.37037194100003, 76.18988678600005],
              [96.39649498800003, 76.17767975500004],
              [96.40056399800005, 76.15517812700006],
              [96.37769616000003, 76.14557526200008],
              [96.34546959700003, 76.14166901200008],
              [96.32129967500003, 76.13605377800008],
              [96.34441165500004, 76.12278880400004],
              [96.35645592500003, 76.11806875200006],
              [96.36963951900003, 76.11562734600005],
              [96.34473717500003, 76.10504791900007],
              [96.30176842500003, 76.11139557500007],
              [96.18140709700003, 76.15468984600005],
              [95.89136803500003, 76.15363190300008],
              [95.70411217500003, 76.17609284100007],
              [95.66334069100003, 76.19065989800004],
              [95.67017662900008, 76.19814687700006],
              [95.31055748800003, 76.20115794500003],
              [95.26612389400003, 76.21857330900008],
              [95.30836022200003, 76.23175690300008],
              [95.32129967500003, 76.23908112200007],
              [95.31088300900007, 76.24819570500006],
              [95.30933678500003, 76.25641510600008],
              [95.31185957100007, 76.26532623900005],
              [95.31397545700003, 76.27659739800004],
              [95.32488040500004, 76.28607819200005],
              [95.34994550900007, 76.28876373900005],
              [95.46949303500003, 76.28583405200004],
              [95.49252363400007, 76.28001536700003],
              [95.54102623800003, 76.25336334800005],
              [95.53370201900003, 76.24591705900008],
              [95.57016035200007, 76.23818594000005],
              [95.61361738400007, 76.24534739800004],
              [95.72706139400003, 76.29071686400005],
              [95.76954186300003, 76.30060455900008],
              [95.81226647200003, 76.30292389500005],
              [95.84888756600003, 76.29433828300006],
              [95.87232506600003, 76.27952708500004],
              [96.02198326900003, 76.28685130400004],
              [96.06812584700003, 76.28001536700003],
              [96.07341556100005, 76.26227448100008],
              [96.06836998800003, 76.24677155200004],
              [96.07227623800003, 76.23578522300005],
              [96.10417728000004, 76.23163483300004],
              [96.12720787900008, 76.23525625200006],
              [96.14429772200003, 76.24502187700006],
              [96.17416425900007, 76.27659739800004],
              [96.21957441500007, 76.30121491100005],
              [96.28296959700003, 76.30927155200004],
              [96.61557050900007, 76.26642487200007],
              [96.64405358200003, 76.26703522300005],
            ],
          ],
          [
            [
              [113.29249108200008, 76.36322663000004],
              [113.13754316500001, 76.36945221600007],
              [113.11768639400009, 76.37689850500004],
              [113.15503991000003, 76.40542226800005],
              [113.20826256600003, 76.43305084800005],
              [113.26433353000004, 76.44432200700004],
              [113.30941816500001, 76.42348867400005],
              [113.27222741000003, 76.40525950700004],
              [113.26172936300009, 76.39671458500004],
              [113.30567467500009, 76.38646067900004],
              [113.40870201900009, 76.38711172100005],
              [113.44662519600001, 76.36945221600007],
              [113.41293379000001, 76.36033763200004],
              [113.29249108200008, 76.36322663000004],
            ],
          ],
          [
            [
              [111.95883222700007, 76.60219961100006],
              [111.97339928500003, 76.60809967700004],
              [111.98902428500003, 76.61009349200003],
              [112.02100670700008, 76.60960521000004],
              [112.01417076900009, 76.61644114800004],
              [111.99561608200003, 76.61566803600005],
              [111.98462975400003, 76.61766185100004],
              [111.97486412900003, 76.62250397300005],
              [111.96631920700003, 76.63007233300004],
              [112.14584394600001, 76.63694896000004],
              [112.27222741000003, 76.61554596600007],
              [112.308929884, 76.62270742400005],
              [112.31544030000009, 76.62995026200008],
              [112.32129967500009, 76.64940013200004],
              [112.32935631600003, 76.65741608300004],
              [112.34400475400003, 76.65949127800008],
              [112.36719811300009, 76.65814850500004],
              [112.38843834700003, 76.65387604400007],
              [112.41480553500003, 76.63641998900005],
              [112.49781334700003, 76.62986888200004],
              [112.52808678500003, 76.62270742400005],
              [112.51856530000009, 76.61579010600008],
              [112.50847415500004, 76.61017487200007],
              [112.48650149800005, 76.60219961100006],
              [112.50171959700003, 76.59544505400004],
              [112.54851321700005, 76.58173248900005],
              [112.541351759, 76.57892487200007],
              [112.52759850400003, 76.57111237200007],
              [112.52068118600005, 76.56806061400005],
              [112.53248131600003, 76.56378815300008],
              [112.55713951900009, 76.55951569200005],
              [112.56967207100001, 76.55499909100007],
              [112.55469811300009, 76.54901764500005],
              [112.52344811300009, 76.54531484600005],
              [112.50757897200003, 76.54071686400005],
              [112.54761803500003, 76.52749258000006],
              [112.65455162900003, 76.53266022300005],
              [112.70093834700003, 76.52871328300006],
              [112.71412194100003, 76.52045319200005],
              [112.70533287900003, 76.51337311400005],
              [112.68718509200005, 76.50849030200004],
              [112.67188561300009, 76.50657786700003],
              [112.59848066500001, 76.50633372600004],
              [112.57593834700003, 76.49974192900004],
              [112.58692467500009, 76.49384186400005],
              [112.60173587300005, 76.48305898600006],
              [112.61410566500001, 76.47040436400005],
              [112.61801191500001, 76.45880768400008],
              [112.60084069100003, 76.44464752800008],
              [112.56788170700008, 76.44350820500006],
              [112.46290123800009, 76.45502350500004],
              [112.42310631600003, 76.46572500200006],
              [112.38803144600001, 76.48297760600008],
              [112.35678144600001, 76.50657786700003],
              [112.31006920700008, 76.53400299700007],
              [112.25700931100005, 76.54580312700006],
              [112.11939537900003, 76.54922109600005],
              [112.09888756600003, 76.55438873900005],
              [112.08130944100003, 76.56395091400003],
              [112.06568444100003, 76.57831452000005],
              [112.04566491000003, 76.58795807500007],
              [111.95883222700007, 76.60219961100006],
            ],
          ],
          [
            [
              [96.47201582100007, 76.69159577000005],
              [96.39421634200005, 76.67987702000005],
              [96.36133873800003, 76.66547272300005],
              [96.36963951900003, 76.64321523600006],
              [96.34595787900008, 76.63080475500004],
              [96.31348717500003, 76.62254466400003],
              [96.25294030000003, 76.61644114800004],
              [96.15430748800003, 76.62319570500006],
              [96.09205162900008, 76.61420319200005],
              [95.99634850400008, 76.62270742400005],
              [95.98267662900008, 76.62067291900007],
              [95.95720462300005, 76.61163971600007],
              [95.94418379000007, 76.60960521000004],
              [95.88990319100003, 76.61644114800004],
              [95.89437910200007, 76.62616608300004],
              [95.89665774800005, 76.63564687700006],
              [95.89527428500003, 76.64398834800005],
              [95.88990319100003, 76.65062083500004],
              [95.92562910200007, 76.66592031500005],
              [95.96436608200003, 76.67645905200004],
              [96.00416100400008, 76.67963288000004],
              [96.08008873800003, 76.66815827000005],
              [96.19402103000004, 76.69476959800005],
              [96.21778405000003, 76.70888906500005],
              [96.23243248800003, 76.71206289300005],
              [96.29623457100007, 76.70563385600008],
              [96.33375084700003, 76.70978424700007],
              [96.38331139400003, 76.70526764500005],
              [96.46583092500003, 76.71206289300005],
              [96.46794681100005, 76.70758698100008],
              [96.47201582100007, 76.69159577000005],
            ],
          ],
          [
            [
              [95.65023847700007, 76.67792389500005],
              [95.67058353000004, 76.67987702000005],
              [95.71127363400007, 76.69476959800005],
              [95.73365319100003, 76.69843170800004],
              [95.83472741000003, 76.69159577000005],
              [95.81967207100007, 76.67890045800004],
              [95.79265384200005, 76.66933828300006],
              [95.68441816500007, 76.65106842700004],
              [95.52865644600007, 76.64874909100007],
              [95.47974694100003, 76.65424225500004],
              [95.43734785200007, 76.67108795800004],
              [95.44255618600005, 76.68138255400004],
              [95.43775475400008, 76.68952057500007],
              [95.41700280000003, 76.70526764500005],
              [95.48633873800003, 76.71653880400004],
              [95.52084394600007, 76.71678294500003],
              [95.55404707100007, 76.70526764500005],
              [95.59546959700003, 76.67641836100006],
              [95.61915123800003, 76.67039622600004],
              [95.65023847700007, 76.67792389500005],
            ],
          ],
          [
            [
              [97.47632897200003, 76.65033600500004],
              [97.48487389400003, 76.63027578300006],
              [97.52198326900003, 76.61737702000005],
              [97.59620201900003, 76.60219961100006],
              [97.56519616000003, 76.58673737200007],
              [97.52540123800003, 76.58222077000005],
              [97.48438561300003, 76.58563873900005],
              [97.41700280000003, 76.59894440300008],
              [97.34310957100007, 76.59931061400005],
              [97.31495201900003, 76.60960521000004],
              [97.37029056100005, 76.62421295800004],
              [97.39136803500003, 76.63495514500005],
              [97.38697350400008, 76.65399811400005],
              [97.37940514400003, 76.66421133000006],
              [97.37720787900008, 76.66901276200008],
              [97.37191816500007, 76.67230866100005],
              [97.35596764400003, 76.67792389500005],
              [97.30534915500004, 76.68439362200007],
              [97.28825931100005, 76.69159577000005],
              [97.32569420700003, 76.69586823100008],
              [97.38412519600007, 76.71458567900004],
              [97.41814212300005, 76.71889883000006],
              [97.44629967500003, 76.71474844000005],
              [97.46753991000003, 76.69672272300005],
              [97.47852623800003, 76.67259349200003],
              [97.47632897200003, 76.65033600500004],
            ],
          ],
          [
            [
              [149.37471311600007, 76.73820157300008],
              [149.3155672470001, 76.72439387300005],
              [149.26321830200004, 76.71058331400008],
              [149.24739974400006, 76.69153757800007],
              [149.23821753200002, 76.66795754600008],
              [149.26200151700004, 76.64519143200005],
              [149.255800625, 76.63376798500008],
              [149.20009036800002, 76.62680582400003],
              [149.04525350300003, 76.62794706500006],
              [148.785319597, 76.62936893700004],
              [148.59424833700007, 76.62249342900003],
              [148.45220345500002, 76.62333563700008],
              [148.43178885200007, 76.62932582800005],
              [148.43718162100004, 76.64154283800008],
              [148.46875551200003, 76.65693777300004],
              [148.55983407100007, 76.67185546500008],
              [148.6189091, 76.68124204800006],
              [148.72357058800003, 76.69766863100006],
              [148.78830556100002, 76.71696169500007],
              [148.8667354600001, 76.73399787000005],
              [148.98265574100003, 76.73968770000005],
              [149.40035065200004, 76.77020751700007],
              [149.45349656400003, 76.76877913300007],
              [149.44397621200005, 76.75049546700006],
              [149.37471311600007, 76.73820157300008],
            ],
          ],
          [
            [
              [96.52735436300003, 77.20551178600005],
              [96.54574629000007, 77.19354889500005],
              [96.56641686300003, 77.15619538000004],
              [96.58936608200003, 77.14411041900007],
              [96.47722415500004, 77.08222077000005],
              [96.43799889400003, 77.06899648600006],
              [96.35962975400008, 77.06004466400003],
              [96.31983483200003, 77.04490794500003],
              [96.26596113400007, 77.03424713700008],
              [96.27279707100007, 77.02537669500003],
              [96.28272545700003, 77.01972077000005],
              [96.29468834700003, 77.01609935100004],
              [96.30762780000003, 77.01365794500003],
              [96.27751712300005, 76.99982330900008],
              [96.23503665500004, 76.99046458500004],
              [96.19125410200007, 76.98843008000006],
              [96.11980228000004, 77.00674062700006],
              [96.08171634200005, 77.00283437700006],
              [96.00660241000003, 76.98578522300005],
              [95.68441816500007, 76.95229726800005],
              [95.69971764400003, 76.95636627800008],
              [95.72828209700003, 76.96987539300005],
              [95.75953209700003, 76.97589752800008],
              [95.78630618600005, 76.98948802300004],
              [95.79712975400008, 76.99262116100005],
              [95.91700280000003, 77.00238678600005],
              [95.95142662900008, 77.01365794500003],
              [95.91846764400003, 77.03070709800005],
              [95.86988366000003, 77.03046295800004],
              [95.78003991000003, 77.01365794500003],
              [95.51856530050003, 77.00263092650005],
              [95.25709069100003, 76.99160390800006],
              [95.23194420700003, 77.00629303600005],
              [95.25017337300005, 77.01044342700004],
              [95.28541100400008, 77.02435944200005],
              [95.36451256600003, 77.03717682500007],
              [95.42066491000003, 77.05548737200007],
              [95.58082116000003, 77.07855866100005],
              [95.70484459700003, 77.07514069200005],
              [96.00342858150003, 77.11788564650004],
              [96.30201256600003, 77.16063060100004],
              [96.44320722700007, 77.20726146000004],
              [96.46216881600003, 77.21027252800008],
              [96.52735436300003, 77.20551178600005],
            ],
          ],
          [
            [
              [105.78492272200003, 77.28058502800008],
              [105.90267988400007, 77.30402252800008],
              [105.97038821700005, 77.30508047100005],
              [106.01148522200003, 77.28742096600007],
              [105.98072350400003, 77.27920156500005],
              [105.91195722700007, 77.27627187700006],
              [105.86182701900003, 77.25486888200004],
              [105.83277428500003, 77.25678131700005],
              [105.80445397200003, 77.26642487200007],
              [105.78492272200003, 77.28058502800008],
            ],
          ],
          [
            [
              [89.68921959700003, 77.28058502800008],
              [89.72755137700005, 77.24407664100005],
              [89.81702034700004, 77.21058966400005],
              [89.74679532600004, 77.16442435900007],
              [89.49279048500006, 77.14075702300005],
              [89.30121631000003, 77.14722236400007],
              [89.18523196700005, 77.19623444200005],
              [89.13461347700007, 77.21771881700005],
              [89.16293379000007, 77.24994538000004],
              [89.21306399800005, 77.27789948100008],
              [89.26628665500004, 77.29828522300005],
              [89.30437259200005, 77.30792877800008],
              [89.60401451900003, 77.31256745000007],
              [89.65316816500007, 77.30243561400005],
              [89.68921959700003, 77.28058502800008],
            ],
          ],
          [
            [
              [106.36117597700007, 77.32192617400005],
              [106.38282311300003, 77.32941315300008],
              [106.40845787900003, 77.33100006700005],
              [106.43409264400003, 77.32794830900008],
              [106.45655358200003, 77.32160065300008],
              [106.42896569100003, 77.31077708500004],
              [106.39039147200003, 77.30475495000007],
              [106.35401451900003, 77.30719635600008],
              [106.33301842500003, 77.32160065300008],
              [106.36117597700007, 77.32192617400005],
            ],
          ],
          [
            [
              [107.74512780000003, 77.32904694200005],
              [107.74317467500003, 77.31305573100008],
              [107.73023522200003, 77.30605703300006],
              [107.71452884200005, 77.30190664300005],
              [107.70411217500003, 77.29425690300008],
              [107.70899498800003, 77.28558991100005],
              [107.72022545700003, 77.27667877800008],
              [107.72169030000003, 77.26972077000005],
              [107.69743899800005, 77.26699453300006],
              [107.62549889400003, 77.26797109600005],
              [107.34457441500007, 77.23285553600005],
              [107.27222741000003, 77.24054596600007],
              [107.24708092500003, 77.23973216400003],
              [107.22429446700005, 77.23338450700004],
              [107.20484459700003, 77.23432038000004],
              [107.20728600400003, 77.24038320500006],
              [107.22152754000007, 77.24787018400008],
              [107.23796634200005, 77.25332265800006],
              [107.42318769600007, 77.26984284100007],
              [107.45704186300003, 77.28058502800008],
              [107.41358483200003, 77.28986237200007],
              [107.31983483200003, 77.28733958500004],
              [107.27955162900003, 77.30170319200005],
              [107.35621178500003, 77.34568919500003],
              [107.39535566500007, 77.36025625200006],
              [107.44223066500007, 77.35443756700005],
              [107.46949303500003, 77.34796784100007],
              [107.52662194100003, 77.34341054900005],
              [107.57740319100003, 77.33197663000004],
              [107.60580488400007, 77.32859935100004],
              [107.63404381600003, 77.32933177300004],
              [107.64893639400003, 77.32904694200005],
              [107.66895592500003, 77.33417389500005],
              [107.70004316500007, 77.33808014500005],
              [107.72974694100003, 77.33746979400007],
              [107.74512780000003, 77.32904694200005],
            ],
          ],
          [
            [
              [106.86117597700007, 77.44574616100005],
              [106.88249759200005, 77.43374258000006],
              [106.88111412900003, 77.42454661700003],
              [106.86475670700003, 77.41901276200008],
              [106.84009850400003, 77.41779205900008],
              [106.79078209700003, 77.42576732000003],
              [106.76612389400003, 77.42645905200004],
              [106.74447675900007, 77.41779205900008],
              [106.75196373800003, 77.41160716400003],
              [106.70093834700003, 77.38361237200007],
              [106.64144941500007, 77.37909577000005],
              [106.52475019600007, 77.39044830900008],
              [106.52670332100007, 77.40550364800004],
              [106.56234785200007, 77.42153554900005],
              [106.55958092500003, 77.43829987200007],
              [106.58415774800005, 77.44586823100008],
              [106.63754316500007, 77.44334544500003],
              [106.66228274800005, 77.44912344000005],
              [106.68230228000004, 77.45783112200007],
              [106.73031660200007, 77.47044505400004],
              [106.83041425900007, 77.47260163000004],
              [106.87712649800005, 77.46596914300005],
              [106.92481530000003, 77.46702708500004],
              [106.94312584700003, 77.45872630400004],
              [106.92546634200005, 77.45233795800004],
              [106.88038170700003, 77.44550202000005],
              [106.86117597700007, 77.44574616100005],
            ],
          ],
          [
            [
              [107.70411217500003, 78.13715241100005],
              [107.70411217500003, 78.12348053600005],
              [107.61963951900003, 78.08185455900008],
              [107.57357832100007, 78.06757233300004],
              [107.45101972700007, 78.05316803600005],
              [107.42904707100007, 78.06207916900007],
              [107.42156009200005, 78.07412344000005],
              [107.42408287900003, 78.08466217700004],
              [107.43458092500003, 78.09080638200004],
              [107.39063561300003, 78.10248444200005],
              [107.20386803500003, 78.08250560100004],
              [106.79944908950003, 78.10671621300006],
              [106.39503014400003, 78.13092682500007],
              [106.44939212300005, 78.15444570500006],
              [106.47706139400003, 78.16250234600005],
              [106.90211022200003, 78.17877838700008],
              [106.92986087300005, 78.18329498900005],
              [106.93816165500004, 78.18195221600007],
              [106.93628991000003, 78.17194245000007],
              [107.21412194100003, 78.17194245000007],
              [107.22527103000004, 78.17047760600008],
              [107.24830162900003, 78.16486237200007],
              [107.25904381600003, 78.16449616100005],
              [107.27173912900003, 78.16746653900003],
              [107.27800540500004, 78.17133209800005],
              [107.28337649800005, 78.17621491100005],
              [107.29297936300003, 78.18211497600004],
              [107.31226647200003, 78.18764883000006],
              [107.33790123800003, 78.19074127800008],
              [107.56511478000004, 78.18756745000007],
              [107.60775800900007, 78.17902252800008],
              [107.64258873800003, 78.16449616100005],
              [107.62907962300005, 78.15827057500007],
              [107.64869225400003, 78.15257396000004],
              [107.68628991000003, 78.14728424700007],
              [107.70411217500003, 78.13715241100005],
            ],
          ],
          [
            [
              [106.53223717500003, 78.25385163000004],
              [106.50033613400007, 78.24144114800004],
              [106.19385826900003, 78.19306061400005],
              [106.15853925900007, 78.19281647300005],
              [106.09009850400003, 78.20795319200005],
              [106.02271569100003, 78.21137116100005],
              [105.99097741000003, 78.21914297100005],
              [106.01099694100003, 78.23183828300006],
              [106.02564537900003, 78.25702545800004],
              [106.04029381600003, 78.26585521000004],
              [106.06885826900003, 78.27057526200008],
              [106.27914472700007, 78.26080963700008],
              [106.33790123800003, 78.26585521000004],
              [106.38892662900003, 78.28864166900007],
              [106.38070722700007, 78.29539622600004],
              [106.41724694100003, 78.32819245000007],
              [106.47006269600007, 78.34259674700007],
              [106.60523522200003, 78.34149811400005],
              [106.65333092500003, 78.33368561400005],
              [106.69825280000003, 78.32050202000005],
              [106.74594160200007, 78.31639232000003],
              [106.76563561300003, 78.30849844000005],
              [106.74878991000003, 78.29881419500003],
              [106.74789472700007, 78.27570221600007],
              [106.73308353000004, 78.26585521000004],
              [106.71338951900003, 78.26190827000005],
              [106.68523196700005, 78.25983307500007],
              [106.65992272200003, 78.26365794500003],
              [106.64893639400003, 78.27806224200003],
              [106.62094160200007, 78.28603750200006],
              [106.45020592500003, 78.26129791900007],
              [106.46892337300005, 78.25429922100005],
              [106.49000084700003, 78.25238678600005],
              [106.53223717500003, 78.25385163000004],
            ],
          ],
          [
            [
              [105.41553795700003, 78.58344147300005],
              [105.40788821700005, 78.56622955900008],
              [105.36768639400003, 78.54319896000004],
              [105.38021894600007, 78.53506094000005],
              [105.35743248800003, 78.50625234600005],
              [105.30811608200003, 78.48956940300008],
              [105.20948326900003, 78.47357819200005],
              [105.02344811300003, 78.40863678600005],
              [104.78736412900008, 78.33637116100005],
              [104.75709069100003, 78.33405182500007],
              [104.72681725400008, 78.33624909100007],
              [104.65259850400008, 78.35516998900005],
              [104.63038170700003, 78.35675690300008],
              [104.57862389400003, 78.34662506700005],
              [104.35328209700003, 78.34145742400005],
              [104.29786217500003, 78.33250560100004],
              [104.18824303500003, 78.32684967700004],
              [104.13575280000003, 78.31403229400007],
              [104.08301842500003, 78.30914948100008],
              [103.98194420700003, 78.28384023600006],
              [103.71257571700005, 78.25629303600005],
              [103.31511478000004, 78.25307851800005],
              [103.12110436300003, 78.24412669500003],
              [103.01596113400007, 78.25649648600006],
              [102.96322675900007, 78.24982330900008],
              [102.86573326900003, 78.21914297100005],
              [102.87256920700003, 78.21662018400008],
              [102.88648522200003, 78.20917389500005],
              [102.89307701900003, 78.20673248900005],
              [102.86833743600005, 78.19452545800004],
              [102.83741295700003, 78.18573639500005],
              [102.66032962300005, 78.16449616100005],
              [102.66822350400008, 78.17715078300006],
              [102.67855879000007, 78.18842194200005],
              [102.68523196700005, 78.19985586100006],
              [102.68148847700007, 78.21287669500003],
              [102.66586347700007, 78.21857330900008],
              [102.60710696700005, 78.22553131700005],
              [102.23853600400008, 78.21979401200008],
              [102.17115319100003, 78.20368073100008],
              [102.09180748800003, 78.19920482000003],
              [102.04737389400003, 78.18667226800005],
              [102.02540123800003, 78.18528880400004],
              [102.00245201900003, 78.19236888200004],
              [101.99984785200007, 78.20844147300005],
              [101.97486412900008, 78.21206289300005],
              [101.61378014400003, 78.19013092700004],
              [101.20980879000007, 78.19350820500006],
              [101.15430748800003, 78.18292877800008],
              [101.01238040500004, 78.13035716400003],
              [100.58277428500003, 78.06146881700005],
              [100.48316491000003, 78.02997467700004],
              [100.36622155000003, 78.02285390800006],
              [100.03728274800005, 77.96161530200004],
              [99.87126712300005, 77.95221588700008],
              [99.65870201900003, 77.96588776200008],
              [99.56324303500003, 77.94757721600007],
              [99.51465905000003, 77.94354889500005],
              [99.47380618600005, 77.95966217700004],
              [99.37134850400008, 77.95966217700004],
              [99.38111412900008, 77.96995677300004],
              [99.41163170700003, 77.97768789300005],
              [99.42603600400008, 77.98700592700004],
              [99.40870201900003, 77.99750397300005],
              [99.38697350400008, 78.00348541900007],
              [99.34400475400008, 78.00747304900005],
              [99.35027103000004, 78.02114492400005],
              [99.28728274800005, 78.03485748900005],
              [99.26832116000003, 78.04157135600008],
              [99.30445397200003, 78.05463288000004],
              [99.38738040500004, 78.06574127800008],
              [99.42603600400008, 78.07566966400003],
              [99.48308353000004, 78.10635000200006],
              [99.53581790500004, 78.14459870000007],
              [99.52214603000004, 78.16526927300004],
              [99.54314212300005, 78.17967357000003],
              [99.60352623800003, 78.19236888200004],
              [99.59734134200005, 78.19920482000003],
              [99.75513756600003, 78.26455312700006],
              [99.80225670700003, 78.27073802300004],
              [99.96876061300003, 78.33441803600005],
              [100.03687584700003, 78.33942291900007],
              [100.04965254000007, 78.34320709800005],
              [100.04297936300003, 78.35932038000004],
              [100.01644941500007, 78.37140534100007],
              [99.99805748800003, 78.38483307500007],
              [100.01563561300003, 78.40468984600005],
              [100.00074303500003, 78.41771067900004],
              [100.03191165500004, 78.42841217700004],
              [100.07504316500007, 78.43829987200007],
              [100.09693444100003, 78.44904205900008],
              [100.11052493600005, 78.46308014500005],
              [100.13599694100003, 78.47492096600007],
              [100.15040123800003, 78.48676178600005],
              [100.13111412900008, 78.50092194200005],
              [100.14234459700003, 78.51056549700007],
              [100.15414472700007, 78.51341380400004],
              [100.16667728000004, 78.51508209800005],
              [100.17945397200003, 78.52073802300004],
              [100.18580162900008, 78.52651601800005],
              [100.19418379000007, 78.53717682500007],
              [100.19996178500003, 78.54246653900003],
              [100.27564537900008, 78.57973867400005],
              [100.28858483200003, 78.59267812700006],
              [100.28142337300005, 78.60309479400007],
              [100.26587975400008, 78.61286041900007],
              [100.25464928500003, 78.62376536700003],
              [100.25416100400008, 78.63450755400004],
              [100.25896243600005, 78.64386627800008],
              [100.26140384200005, 78.65350983300004],
              [100.25464928500003, 78.66535065300008],
              [100.33130944100003, 78.69358958500004],
              [100.35450280000003, 78.70945872600004],
              [100.35710696700005, 78.71417877800008],
              [100.36451256600003, 78.73704661700003],
              [100.37077884200005, 78.74433014500005],
              [100.38526451900003, 78.75161367400005],
              [100.40162194100003, 78.75751373900005],
              [100.56690514400003, 78.79490794500003],
              [100.60157311300003, 78.79816315300008],
              [100.63648522200003, 78.79694245000007],
              [100.73389733200003, 78.77562083500004],
              [100.99398847700007, 78.76406484600005],
              [101.00945071700005, 78.76097239800004],
              [101.01937910200007, 78.75486888200004],
              [101.02458743600005, 78.74778880400004],
              [101.03093509200005, 78.74339427300004],
              [101.07496178500003, 78.75023021000004],
              [101.13941491000003, 78.75169505400004],
              [101.16635175900007, 78.76097239800004],
              [101.12891686300003, 78.77798086100006],
              [101.08220462300005, 78.78595612200007],
              [100.90430748800003, 78.78839752800008],
              [100.85767662900008, 78.79413483300004],
              [100.82374108200003, 78.80878327000005],
              [100.83277428500003, 78.83152903900003],
              [100.82292728000004, 78.84162018400008],
              [100.80307050900007, 78.84894440300008],
              [100.78223717500003, 78.86334870000007],
              [100.78972415500004, 78.87079498900005],
              [100.78492272200003, 78.89508698100008],
              [100.81234785200007, 78.91315338700008],
              [100.85059655000003, 78.92865631700005],
              [100.87826582100007, 78.94594961100006],
              [100.88404381600003, 78.95770905200004],
              [100.88591556100005, 78.96792226800005],
              [100.89112389400003, 78.97687409100007],
              [100.90723717500003, 78.98509349200003],
              [100.97364342500003, 79.00454336100006],
              [100.98812910200007, 79.01422760600008],
              [101.02711022200003, 79.03143952000005],
              [101.07007897200003, 79.03465403900003],
              [101.33086184950005, 79.00582510000004],
              [101.59164472700007, 78.97699616100005],
              [101.62566165500004, 78.98688385600008],
              [101.58375084700003, 78.98672109600005],
              [101.37777754000007, 79.00787995000007],
              [101.22673587300005, 79.04360586100006],
              [100.98812910200007, 79.06264883000006],
              [101.00953209700003, 79.08104075700004],
              [101.01872806100005, 79.09178294500003],
              [101.02808678500003, 79.12348053600005],
              [101.04265384200005, 79.13300202000005],
              [101.06169681100005, 79.13735586100006],
              [101.19564863400007, 79.14716217700004],
              [101.15805097700007, 79.15322500200006],
              [101.12598717500003, 79.16502513200004],
              [101.13559004000007, 79.17182038000004],
              [101.14584394600007, 79.17450592700004],
              [101.15626061300003, 79.17601146000004],
              [101.16635175900007, 79.17926666900007],
              [101.17457116000003, 79.18520742400005],
              [101.18580162900008, 79.19745514500005],
              [101.19418379000007, 79.20286692900004],
              [101.30990644600007, 79.23875560100004],
              [101.37061608200003, 79.24510325700004],
              [101.49756920700003, 79.24022044500003],
              [101.55738366000003, 79.25438060100004],
              [101.54127037900008, 79.26459381700005],
              [101.54102623800003, 79.27399323100008],
              [101.56364993600005, 79.29596588700008],
              [101.54712975400008, 79.30145905200004],
              [101.53891035200007, 79.30272044500003],
              [101.52947024800005, 79.30219147300005],
              [101.53248131600003, 79.31171295800004],
              [101.53589928500003, 79.31875234600005],
              [101.54167728000004, 79.32444896000004],
              [101.55054772200003, 79.33014557500007],
              [101.54371178500003, 79.34076569200005],
              [101.57545006600003, 79.35162995000007],
              [101.64673912900008, 79.36424388200004],
              [101.81755618600005, 79.37103913000004],
              [101.84441165500004, 79.36359284100007],
              [101.88900800900007, 79.32721588700008],
              [101.91146894600007, 79.31419505400004],
              [101.94019616000003, 79.30727773600006],
              [101.95199629000007, 79.30231354400007],
              [101.96461022200003, 79.29230377800008],
              [101.96705162900008, 79.28412506700005],
              [101.95875084700003, 79.26813385600008],
              [101.96078535200007, 79.26121653900003],
              [101.97730553500003, 79.25739166900007],
              [102.05054772200003, 79.26121653900003],
              [102.24626712300005, 79.24164459800005],
              [102.26319420700003, 79.25438060100004],
              [102.25294030000003, 79.25946686400005],
              [102.17465254000007, 79.28681061400005],
              [102.16781660200007, 79.29238515800006],
              [102.16016686300003, 79.30219147300005],
              [102.15365644600007, 79.31610748900005],
              [102.14698326900003, 79.34503815300008],
              [102.13965905000003, 79.35683828300006],
              [102.14730879000007, 79.36676666900007],
              [102.15528405000003, 79.36961497600004],
              [102.16391035200007, 79.37116120000007],
              [102.17432701900003, 79.37726471600007],
              [102.17611738400007, 79.38153717700004],
              [102.17595462300005, 79.38727448100008],
              [102.17660566500007, 79.39354075700004],
              [102.18051191500007, 79.39899323100008],
              [102.19703209700003, 79.40818919500003],
              [102.23764082100007, 79.42145416900007],
              [102.30290774800005, 79.43280670800004],
              [102.40154056100005, 79.43195221600007],
              [102.49927819100003, 79.41819896000004],
              [102.60572350400008, 79.41718170800004],
              [102.75220787900008, 79.38882070500006],
              [102.89372806100005, 79.38133372600004],
              [102.91244550900007, 79.37409088700008],
              [102.92750084700003, 79.34784577000005],
              [102.94434655000003, 79.34121328300006],
              [103.13835696700005, 79.32514069200005],
              [103.15316816500007, 79.30963776200008],
              [103.13786868600005, 79.29926178600005],
              [103.11150149800005, 79.29026927300004],
              [103.06397545700003, 79.28172435100004],
              [102.96827233200003, 79.28172435100004],
              [102.92994225400008, 79.27570221600007],
              [102.82545006600003, 79.22711823100008],
              [102.85043379000007, 79.22077057500007],
              [102.85962975400008, 79.22028229400007],
              [102.83155358200003, 79.20282623900005],
              [102.76872806100005, 79.17869700700004],
              [102.74293053500003, 79.15884023600006],
              [102.75709069100003, 79.15582916900007],
              [102.77084394600007, 79.15110911700003],
              [102.79761803500003, 79.13833242400005],
              [102.77100670700003, 79.11741771000004],
              [102.70484459700003, 79.09324778900003],
              [102.67400149800005, 79.07684967700004],
              [102.68165123800003, 79.06732819200005],
              [102.69206790500004, 79.05963776200008],
              [102.70004316500007, 79.05182526200008],
              [102.70142662900008, 79.04148997600004],
              [102.69141686300003, 79.03221263200004],
              [102.63990319100003, 79.01422760600008],
              [102.63892662900008, 79.01141998900005],
              [102.63843834700003, 79.00141022300005],
              [102.63648522200003, 78.99746328300006],
              [102.62989342500003, 78.99335358300004],
              [102.61500084700003, 78.98798248900005],
              [102.59652754000007, 78.97426992400005],
              [102.55046634200005, 78.95648834800005],
              [102.44027754000007, 78.88580963700008],
              [102.40308678500003, 78.85370514500005],
              [102.39795983200003, 78.84495677300004],
              [102.39600670700003, 78.83624909100007],
              [102.39144941500007, 78.82843659100007],
              [102.37916100400008, 78.82245514500005],
              [102.41529381600003, 78.83148834800005],
              [102.53003991000003, 78.84349192900004],
              [102.66578209700003, 78.89240143400008],
              [102.67042076900003, 78.89789459800005],
              [102.67774498800003, 78.91181061400005],
              [102.68775475400008, 78.91844310100004],
              [102.74073326900003, 78.93357982000003],
              [102.79004967500003, 78.95604075700004],
              [102.83171634200005, 78.98688385600008],
              [102.87501061300003, 79.03510163000004],
              [102.88656660200007, 79.04523346600007],
              [102.92115319100003, 79.05841705900008],
              [102.95826256600003, 79.06321849200003],
              [103.14429772200003, 79.05776601800005],
              [103.27767988400007, 79.08319733300004],
              [103.30469811300003, 79.09674713700008],
              [103.29712975400008, 79.10358307500007],
              [103.34913170700003, 79.11635976800005],
              [103.46265709700003, 79.11391836100006],
              [103.51685631600003, 79.12742747600004],
              [103.52369225400008, 79.13275788000004],
              [103.52279707100007, 79.13711172100005],
              [103.51872806100005, 79.14183177300004],
              [103.51636803500003, 79.14826080900008],
              [103.52076256600003, 79.15448639500005],
              [103.53101647200003, 79.15936920800004],
              [103.57349694100003, 79.16998932500007],
              [103.59896894600007, 79.17251211100006],
              [103.62427819100003, 79.17121002800008],
              [103.64665774800005, 79.16502513200004],
              [103.63591556100005, 79.15643952000005],
              [103.61508222700007, 79.14760976800005],
              [103.60629316500007, 79.13833242400005],
              [103.66016686300003, 79.13808828300006],
              [103.80795332100007, 79.15350983300004],
              [103.80494225400008, 79.14516836100006],
              [103.98910566500007, 79.13084544500003],
              [104.00131269600007, 79.12767161700003],
              [104.01295006600003, 79.11957428600005],
              [104.02125084700003, 79.10858795800004],
              [104.02328535200007, 79.09674713700008],
              [104.01710045700003, 79.08462148600006],
              [104.00473066500007, 79.07566966400003],
              [103.97624759200005, 79.06264883000006],
              [104.04476972700007, 79.04559967700004],
              [104.07374108200003, 79.03278229400007],
              [104.06836998800003, 79.01113515800006],
              [104.07349694100003, 79.00482819200005],
              [104.38314863400007, 78.98859284100007],
              [104.45533287900008, 78.96674225500004],
              [104.50375410200007, 78.92544179900005],
              [104.48340905000003, 78.89069245000007],
              [104.50375410200007, 78.88637929900005],
              [104.52491295700003, 78.88507721600007],
              [104.49919681100005, 78.86375560100004],
              [104.45435631600003, 78.85980866100005],
              [104.40544681100005, 78.86151764500005],
              [104.36670983200003, 78.85712311400005],
              [104.63257897200003, 78.84284088700008],
              [104.64527428500003, 78.83885325700004],
              [104.65455162900008, 78.82990143400008],
              [104.65870201900003, 78.81956614800004],
              [104.65552819100003, 78.81622955900008],
              [104.65007571700005, 78.81366608300004],
              [104.64722741000003, 78.80560944200005],
              [104.63835696700005, 78.79051341400003],
              [104.61784915500004, 78.78310781500005],
              [104.57886803500003, 78.77521393400008],
              [104.60775800900007, 78.77167389500005],
              [104.72510826900003, 78.79083893400008],
              [104.73975670700003, 78.79767487200007],
              [104.75196373800003, 78.80756256700005],
              [104.75709069100003, 78.81928131700005],
              [104.75245201900003, 78.82347239800004],
              [104.73072350400008, 78.83698151200008],
              [104.72291100400008, 78.84349192900004],
              [104.75904381600003, 78.85333893400008],
              [104.88705488400007, 78.85712311400005],
              [105.05876712300005, 78.84349192900004],
              [105.17505944100003, 78.80927155200004],
              [105.18726647200003, 78.80292389500005],
              [105.24301191500007, 78.74868398600006],
              [105.25733483200003, 78.74046458500004],
              [105.23959394600007, 78.72500234600005],
              [105.24976647200003, 78.71332428600005],
              [105.27344811300003, 78.70246002800008],
              [105.29493248800003, 78.68927643400008],
              [105.32943769600007, 78.65989817900004],
              [105.34376061300003, 78.64232005400004],
              [105.34302819100003, 78.62718333500004],
              [105.33350670700003, 78.60480377800008],
              [105.35718834700003, 78.60065338700008],
              [105.39210045700003, 78.59882233300004],
              [105.41553795700003, 78.58344147300005],
            ],
          ],
          [
            [
              [77.61361738400007, 79.52191803600005],
              [77.61378014400003, 79.50897858300004],
              [77.60124759200005, 79.50039297100005],
              [77.58285566500007, 79.49551015800006],
              [77.13945560000008, 79.48655833500007],
              [76.69605553500008, 79.47760651200008],
              [76.64096113400007, 79.48712799700007],
              [76.65479576900003, 79.49559153900003],
              [76.69483483200008, 79.51044342700004],
              [76.69874108200008, 79.51821523600006],
              [76.68433678500008, 79.52777741100005],
              [76.62061608200008, 79.54857005400004],
              [76.60596764400003, 79.54783763200004],
              [76.59180748800003, 79.54539622600004],
              [76.56381269600007, 79.53733958500004],
              [76.55201256600003, 79.53620026200008],
              [76.17432701900003, 79.56907786700003],
              [76.09205162900008, 79.60370514500005],
              [76.05201256600003, 79.62929922100005],
              [76.05144290500004, 79.64850495000007],
              [76.10303795700008, 79.66193268400008],
              [76.16358483200008, 79.66388580900008],
              [76.22437584700003, 79.65737539300005],
              [76.27735436300003, 79.64545319200005],
              [76.17318769600007, 79.63727448100008],
              [76.14014733200008, 79.63861725500004],
              [76.19947350400008, 79.60858795800004],
              [76.26880944100003, 79.60431549700007],
              [76.40699303500008, 79.61749909100007],
              [76.42302493600005, 79.63703034100007],
              [76.48226972700007, 79.64374420800004],
              [76.85309220966673, 79.60689253700004],
              [77.22391469233338, 79.57004086600004],
              [77.59473717500003, 79.53318919500003],
              [77.61361738400007, 79.52191803600005],
            ],
          ],
          [
            [
              [93.62818444100003, 79.93341705900008],
              [93.72388756600003, 79.92731354400007],
              [93.77100670700008, 79.91803620000007],
              [93.81373131600003, 79.89866771000004],
              [93.78256269600007, 79.87417226800005],
              [93.74683678500003, 79.85614655200004],
              [93.66993248800003, 79.83173248900005],
              [93.46412194100003, 79.80182526200008],
              [93.36182701900003, 79.77521393400008],
              [93.27906334700003, 79.76764557500007],
              [93.05209394600007, 79.71527741100005],
              [92.62476647200003, 79.67279694200005],
              [92.27332604250003, 79.67586904500004],
              [91.92188561300003, 79.67894114800004],
              [91.93441816500007, 79.67975495000007],
              [91.94695071700005, 79.68268463700008],
              [91.95883222700007, 79.68724192900004],
              [91.97022545700008, 79.69326406500005],
              [91.92969811300003, 79.70595937700006],
              [91.91570071700005, 79.70693594000005],
              [91.94450931100005, 79.71588776200008],
              [92.14812259200005, 79.73419830900008],
              [92.20508873800003, 79.73021067900004],
              [92.28321373800003, 79.71181875200006],
              [92.30844160200007, 79.71450429900005],
              [92.33285566500007, 79.72239817900004],
              [92.35328209700003, 79.73419830900008],
              [92.32211347700007, 79.75682200700004],
              [92.28077233200008, 79.77106354400007],
              [92.09945722700007, 79.80988190300008],
              [91.7571449443334, 79.82358090466674],
              [91.41483266166675, 79.83727990633339],
              [91.07252037900008, 79.85097890800006],
              [91.05909264400003, 79.86078522300005],
              [91.06592858200008, 79.87689850500004],
              [91.08277428500003, 79.88397858300004],
              [91.16480553500003, 79.89765045800004],
              [91.26238040500004, 79.90302155200004],
              [91.29859459700003, 79.91913483300004],
              [91.23243248800003, 79.94179922100005],
              [91.08716881600003, 79.95237864800004],
              [91.01758873800003, 79.96698639500005],
              [91.05160566500007, 79.96710846600007],
              [91.15381920700008, 79.98004791900007],
              [91.18189537900008, 79.99485911700003],
              [91.17986087300005, 80.01117584800005],
              [91.16146894600007, 80.02684153900003],
              [91.13640384200005, 80.04002513200004],
              [91.11361738400007, 80.04889557500007],
              [91.08497155000003, 80.04718659100007],
              [90.99008222700007, 80.05634186400005],
              [90.89486738400007, 80.05499909100007],
              [90.86654707100007, 80.06256745000007],
              [90.90211022200003, 80.07363515800006],
              [91.24927819100003, 80.05573151250005],
              [91.59644616000003, 80.03782786700003],
              [91.78207441500007, 80.06378815300008],
              [92.04029381600003, 80.03729889500005],
              [92.42432701900003, 80.03070709800005],
              [92.64877363400007, 79.98379140800006],
              [93.13847903750005, 79.95860423350007],
              [93.62818444100003, 79.93341705900008],
            ],
          ],
          [
            [
              [51.34685306100005, 79.95331452000005],
              [51.382823113000086, 79.95538971600007],
              [51.47022545700008, 79.94432200700004],
              [51.50513756600009, 79.93341705900008],
              [51.46607506600009, 79.92011139500005],
              [51.42009524800005, 79.91644928600005],
              [50.96181616833339, 79.93577708533338],
              [50.503537088666725, 79.95510488466674],
              [50.045258009000065, 79.97443268400008],
              [50.05005944100009, 79.97724030200004],
              [50.05494225400008, 79.97882721600007],
              [50.23015384200005, 79.99485911700003],
              [50.55250084700003, 79.98802317900004],
              [50.58334394600007, 79.99485911700003],
              [50.625743035000085, 80.02960846600007],
              [50.65381920700008, 80.04433828300006],
              [50.69255618600005, 80.05353424700007],
              [50.85474694100009, 80.06720612200007],
              [50.963552280000044, 80.10187409100007],
              [51.000987175000034, 80.10252513200004],
              [51.02881920700008, 80.09023672100005],
              [51.054698113000086, 80.07379791900007],
              [51.086680535000085, 80.06256745000007],
              [51.26482181100005, 80.05634186400005],
              [51.246836785000085, 80.04962799700007],
              [51.213552280000044, 80.04222239800004],
              [51.19971764400003, 80.03241608300004],
              [51.19654381600009, 80.02204010600008],
              [51.201182488000086, 80.01089101800005],
              [51.209646030000044, 80.00112539300005],
              [51.21762129000007, 79.99485911700003],
              [51.25611412900008, 79.98285553600005],
              [51.346690300000034, 79.97711823100008],
              [51.38843834700003, 79.96698639500005],
              [51.36695397200003, 79.96173737200007],
              [51.34685306100005, 79.95331452000005],
            ],
          ],
          [
            [
              [36.59359785200007, 80.15875885600008],
              [36.65259850400008, 80.17487213700008],
              [36.85368899800005, 80.15192291900007],
              [36.824880405000044, 80.14179108300004],
              [36.785899285000085, 80.13983795800004],
              [36.70720462300005, 80.14472077000005],
              [36.64625084700009, 80.14549388200004],
              [36.61736087300005, 80.14972565300008],
              [36.59359785200007, 80.15875885600008],
            ],
          ],
          [
            [
              [99.88599694100003, 79.04148997600004],
              [99.86304772200003, 79.02435944200005],
              [99.88754316500007, 79.00145091400003],
              [99.94662519600007, 78.97011953300006],
              [99.92554772200003, 78.94599030200004],
              [99.87720787900008, 78.93113841400003],
              [99.68604576900003, 78.89813873900005],
              [99.63038170700003, 78.86762116100005],
              [99.55844160200007, 78.85700104400007],
              [99.45834394600007, 78.82880280200004],
              [99.40560957100007, 78.82245514500005],
              [99.13306725400008, 78.82746002800008],
              [98.92750084700003, 78.80731842700004],
              [98.60271243600005, 78.81586334800005],
              [98.55518639400003, 78.80255768400008],
              [98.58838951900003, 78.79783763200004],
              [98.60271243600005, 78.79254791900007],
              [98.59831790500004, 78.78644440300008],
              [98.57960045700003, 78.78217194200005],
              [98.32740319100003, 78.78473541900007],
              [98.24048912900008, 78.80878327000005],
              [98.08961022200003, 78.80878327000005],
              [98.11695397200003, 78.81622955900008],
              [98.08277428500003, 78.82420482000003],
              [97.94556725400008, 78.80878327000005],
              [97.76075280000003, 78.80878327000005],
              [97.75554446700005, 78.81696198100008],
              [97.73853600400008, 78.82111237200007],
              [97.67351321700005, 78.82811107000003],
              [97.44223066500007, 78.81720612200007],
              [97.40447024800005, 78.82990143400008],
              [97.45232181100005, 78.83803945500006],
              [97.55974368600005, 78.83051178600005],
              [97.60303795700003, 78.84349192900004],
              [97.55787194100003, 78.85468170800004],
              [97.26392662900008, 78.85301341400003],
              [97.21949303500003, 78.86334870000007],
              [97.22681725400008, 78.87079498900005],
              [97.20167076900003, 78.87848541900007],
              [97.12322024800005, 78.88507721600007],
              [96.91871178500003, 78.94135163000004],
              [96.86719811300003, 78.94009023600006],
              [96.84205162900008, 78.94594961100006],
              [96.85010826900003, 78.95010000200006],
              [96.86939537900008, 78.96698639500005],
              [96.79851321700005, 78.98920319200005],
              [96.53939863350004, 78.99176666850005],
              [96.28028405000003, 78.99433014500005],
              [96.30388431100005, 78.99921295800004],
              [96.33057701900003, 79.00136953300006],
              [96.35450280000003, 79.00678131700005],
              [96.36963951900003, 79.02167389500005],
              [95.93246504000007, 78.99290599200003],
              [95.85523522200003, 79.00055573100008],
              [95.69727623800003, 78.99827708500004],
              [95.67253665500004, 79.00096263200004],
              [95.65349368600005, 79.01113515800006],
              [95.65015709700003, 79.01984284100007],
              [95.65251712300005, 79.02879466400003],
              [95.65259850400008, 79.03839752800008],
              [95.64283287900008, 79.04897695500006],
              [95.66228274800005, 79.06537506700005],
              [95.67017662900008, 79.06940338700008],
              [95.64730879000007, 79.07640208500004],
              [95.59839928500003, 79.07827383000006],
              [95.57520592500003, 79.08307526200008],
              [95.56177819100003, 79.09707265800006],
              [95.55250084700003, 79.10175202000005],
              [95.52377363400007, 79.10907623900005],
              [95.46753991000003, 79.11151764500005],
              [95.42212975400008, 79.10626862200007],
              [95.28923587300005, 79.07249583500004],
              [95.21973717500003, 79.06622955900008],
              [95.17969811300003, 79.05215078300006],
              [95.06657962300005, 79.03815338700008],
              [95.01823978000004, 79.03851959800005],
              [94.97934004000007, 79.05516185100004],
              [94.99244225400008, 79.06264883000006],
              [94.95728600400008, 79.06952545800004],
              [94.85181725400008, 79.06264883000006],
              [94.82667076900003, 79.06663646000004],
              [94.63233483200003, 79.12742747600004],
              [94.62281334700003, 79.13764069200005],
              [94.63054446700005, 79.15127187700006],
              [94.64356530000003, 79.16596100500004],
              [94.64975019600007, 79.17926666900007],
              [94.61736087300005, 79.20132070500006],
              [94.36451256600003, 79.23688385600008],
              [94.33399498800003, 79.24860260600008],
              [94.32081139400003, 79.26430898600006],
              [94.32325280000003, 79.28253815300008],
              [94.33008873800003, 79.29389069200005],
              [94.35482832100007, 79.31586334800005],
              [94.34717858200003, 79.32689036700003],
              [94.33757571700005, 79.33543528900003],
              [94.31332441500007, 79.35000234600005],
              [94.32105553500003, 79.36204661700003],
              [94.32178795700003, 79.37303294500003],
              [94.32007897200003, 79.38287995000007],
              [94.32081139400003, 79.39158763200004],
              [94.32886803500003, 79.40403880400004],
              [94.35206139400003, 79.42682526200008],
              [94.36231530000003, 79.44000885600008],
              [94.31226647200003, 79.47919342700004],
              [94.22291100400008, 79.48663971600007],
              [94.05323326900003, 79.47353750200006],
              [94.06495201900003, 79.45986562700006],
              [94.08057701900003, 79.44684479400007],
              [94.04127037900008, 79.42975495000007],
              [93.98804772200003, 79.42715078300006],
              [93.73926842500003, 79.44773997600004],
              [93.69695071700005, 79.45986562700006],
              [93.76840254000007, 79.47174713700008],
              [93.92457116000003, 79.47052643400008],
              [93.99122155000003, 79.49404531500005],
              [93.95883222700007, 79.50568268400008],
              [93.82740319100003, 79.51447174700007],
              [93.79249108200008, 79.52090078300006],
              [93.77654056100005, 79.52741120000007],
              [93.76221764400003, 79.53896719000005],
              [93.74887129000007, 79.54385000200006],
              [93.69019616000003, 79.54242584800005],
              [93.77369225400008, 79.55560944200005],
              [93.80005944100003, 79.56293366100005],
              [93.86085045700008, 79.59593333500004],
              [93.88200931100005, 79.60382721600007],
              [93.76514733200008, 79.60382721600007],
              [93.74610436300003, 79.60150788000004],
              [93.72095787900008, 79.59540436400005],
              [93.70281009200005, 79.58673737200007],
              [93.70386803500003, 79.57656484600005],
              [93.68539472700007, 79.56317780200004],
              [93.65967858200008, 79.55727773600006],
              [93.58366946700005, 79.55426666900007],
              [93.55827884200005, 79.54938385600008],
              [93.53370201900003, 79.54173411700003],
              [93.51172936300003, 79.53217194200005],
              [93.47022545700008, 79.52244700700004],
              [93.44947350400008, 79.51455312700006],
              [93.44312584700003, 79.50145091400003],
              [93.45769290500004, 79.49461497600004],
              [93.53931725400008, 79.48712799700007],
              [93.51384524800005, 79.48676178600005],
              [93.43685957100007, 79.47353750200006],
              [93.38746178500003, 79.47296784100007],
              [93.36378014400003, 79.46991608300004],
              [93.36182701900003, 79.45986562700006],
              [93.30347741000003, 79.44525788000004],
              [93.23585045700008, 79.43895091400003],
              [93.16928144600007, 79.44501373900005],
              [93.11410566500007, 79.46727122600004],
              [93.16309655000003, 79.48407623900005],
              [93.27271569100003, 79.48700592700004],
              [93.32016035200007, 79.50145091400003],
              [93.27881920700008, 79.51976146000004],
              [93.17628014400003, 79.52875397300005],
              [93.09620201900003, 79.51898834800005],
              [93.05445397200003, 79.51854075700004],
              [93.01856530000003, 79.52875397300005],
              [93.04175866000003, 79.53432851800005],
              [92.85417728000004, 79.55609772300005],
              [92.90333092500003, 79.57469310100004],
              [92.97071373800003, 79.57225169500003],
              [93.15707441500007, 79.54266998900005],
              [93.28028405000003, 79.55247630400004],
              [93.55152428500003, 79.60911692900004],
              [93.61060631600003, 79.61351146000004],
              [93.63526451900003, 79.61933014500005],
              [93.68482506600003, 79.63686758000006],
              [93.76148522200003, 79.65070221600007],
              [93.78565514400003, 79.65851471600007],
              [93.79444420700008, 79.68817780200004],
              [93.84791100400008, 79.70966217700004],
              [94.16944420700003, 79.77521393400008],
              [94.42977949350004, 79.79566071150006],
              [94.69011478000004, 79.81610748900005],
              [94.66773522200003, 79.82733795800004],
              [94.64079837300005, 79.83372630400004],
              [94.56332441500007, 79.84031810100004],
              [94.51587975400008, 79.85398997600004],
              [94.40455162900008, 79.85976797100005],
              [94.35987389400003, 79.86790599200003],
              [94.34799238400007, 79.88499583500004],
              [94.32276451900003, 79.89398834800005],
              [94.28834069100003, 79.89858633000006],
              [94.22461998800003, 79.89866771000004],
              [94.25294030000003, 79.91657135600008],
              [94.29664147200003, 79.92658112200007],
              [94.38233483200003, 79.93341705900008],
              [94.37037194100003, 79.94668203300006],
              [94.35482832100007, 79.95490143400008],
              [94.32081139400003, 79.96698639500005],
              [94.35124759200005, 79.97699616100005],
              [94.38526451900003, 79.97597890800006],
              [94.45118248800003, 79.96698639500005],
              [94.74976647200003, 80.00747304900005],
              [94.79997806100005, 80.02899811400005],
              [94.79761803500003, 80.03278229400007],
              [94.79371178500003, 80.04266998900005],
              [94.83904056100005, 80.04450104400007],
              [94.89918053500003, 80.05385976800005],
              [94.93555748800003, 80.07127513200004],
              [94.90984134200005, 80.09731679900005],
              [94.95199629000007, 80.10447825700004],
              [94.99293053500003, 80.10187409100007],
              [95.10775800900007, 80.07343170800004],
              [95.10743248800003, 80.05902741100005],
              [95.10775800900007, 80.05634186400005],
              [95.12598717500003, 80.05011627800008],
              [95.20639082100007, 80.03937409100007],
              [95.22535241000003, 80.02484772300005],
              [95.24187259200005, 80.02155182500007],
              [95.33472741000003, 80.02899811400005],
              [95.34929446700005, 80.03253815300008],
              [95.35515384200005, 80.04181549700007],
              [95.35547936300003, 80.06972890800006],
              [95.36304772200003, 80.07916901200008],
              [95.38086998800003, 80.08722565300008],
              [95.40137780000003, 80.09345123900005],
              [95.50212649800005, 80.11147695500006],
              [95.80587812600007, 80.11123281450006],
              [96.10962975400008, 80.11098867400005],
              [96.10767662900008, 80.10639069200005],
              [96.10474694100003, 80.09503815300008],
              [96.10279381600003, 80.09048086100006],
              [96.17408287900008, 80.09149811400005],
              [96.19752037900008, 80.09552643400008],
              [96.25131269600007, 80.11517975500004],
              [96.27003014400003, 80.11782461100006],
              [96.28980553500003, 80.11595286700003],
              [96.34083092500003, 80.10187409100007],
              [96.36003665500004, 80.09870026200008],
              [96.50147545700003, 80.10663483300004],
              [96.52711022200003, 80.11440664300005],
              [96.56641686300003, 80.13141510600008],
              [96.58619225400008, 80.13641998900005],
              [96.60792076900003, 80.13825104400007],
              [96.63640384200005, 80.13507721600007],
              [96.68897545700003, 80.12091705900008],
              [96.71566816500007, 80.11782461100006],
              [96.90154056100005, 80.13328685100004],
              [97.15479576900003, 80.15444570500006],
              [97.59213300900007, 80.17487213700008],
              [97.73926842500003, 80.14923737200007],
              [97.76221764400003, 80.13629791900007],
              [97.77426191500007, 80.13141510600008],
              [97.78777103000004, 80.13011302300004],
              [97.81592858200003, 80.13239166900007],
              [97.82943769600007, 80.13141510600008],
              [97.84693444100003, 80.12677643400008],
              [97.88599694100003, 80.11050039300005],
              [97.90064537900008, 80.10040924700007],
              [97.94369550900007, 80.07859935100004],
              [98.04297936300003, 80.07111237200007],
              [98.08961022200003, 80.05634186400005],
              [98.05884850400008, 80.03180573100008],
              [98.00717207100007, 80.01459381700005],
              [97.95134524800005, 80.00438060100004],
              [97.86264082100007, 79.99974192900004],
              [97.84782962300005, 79.99652741100005],
              [97.84180748800003, 79.99225495000007],
              [97.84546959700003, 79.98745351800005],
              [97.85254967500003, 79.98236725500004],
              [97.85621178500003, 79.97748444200005],
              [97.84424889400003, 79.97036367400005],
              [97.76807701900003, 79.94647858300004],
              [97.78199303500003, 79.94086334800005],
              [97.82943769600007, 79.93341705900008],
              [97.81421959700003, 79.91632721600007],
              [97.78484134200005, 79.89980703300006],
              [97.75196373800003, 79.88617584800005],
              [97.61573326900003, 79.85687897300005],
              [97.58253014400003, 79.85712311400005],
              [97.64063561300003, 79.84052155200004],
              [97.65821373800003, 79.82977936400005],
              [97.62427819100003, 79.82265859600005],
              [97.55152428500003, 79.82371653900003],
              [97.52051842500003, 79.80927155200004],
              [97.54639733200003, 79.80044179900005],
              [97.60401451900003, 79.79702383000006],
              [97.63038170700003, 79.78880442900004],
              [97.60873457100007, 79.77659739800004],
              [97.57837975400008, 79.76780833500004],
              [97.49545332100007, 79.75787995000007],
              [97.44385826900003, 79.74461497600004],
              [97.21314537900008, 79.72036367400005],
              [97.19157962300005, 79.70693594000005],
              [97.21558678500003, 79.70062897300005],
              [97.24683678500003, 79.69953034100007],
              [97.27784264400003, 79.70286692900004],
              [97.32789147200003, 79.71906159100007],
              [97.70582116000003, 79.76316966400003],
              [97.71957441500007, 79.77171458500004],
              [97.71941165500004, 79.79564036700003],
              [97.72315514400003, 79.80536530200004],
              [97.73324629000007, 79.80927155200004],
              [97.75562584700003, 79.81159088700008],
              [97.85084069100003, 79.83698151200008],
              [97.87452233200003, 79.83954498900005],
              [97.89722741000003, 79.84454987200007],
              [97.91773522200003, 79.85712311400005],
              [97.88404381600003, 79.87718333500004],
              [97.89283287900008, 79.89240143400008],
              [97.92611738400007, 79.90216705900008],
              [98.08790123800003, 79.90550364800004],
              [98.25562584700003, 79.87287018400008],
              [98.33985436300003, 79.87230052300004],
              [98.37720787900008, 79.87787506700005],
              [98.41285241000003, 79.88849518400008],
              [98.45281009200005, 79.90550364800004],
              [98.44532311300003, 79.91185130400004],
              [98.43718509200005, 79.91632721600007],
              [98.42807050900007, 79.91876862200007],
              [98.41863040500004, 79.91913483300004],
              [98.43474368600005, 79.92820872600004],
              [98.47022545700003, 79.93414948100008],
              [98.48682701900003, 79.93964264500005],
              [98.47315514400003, 79.94647858300004],
              [98.48731530000003, 79.95555247600004],
              [98.56739342500003, 79.97064850500004],
              [98.58236738400007, 79.97597890800006],
              [98.57789147200003, 79.98257070500006],
              [98.46558678500003, 79.99990469000005],
              [98.43913821700005, 80.01536692900004],
              [98.47681725400008, 80.03790924700007],
              [98.51539147200003, 80.05231354400007],
              [98.55697675900007, 80.05853913000004],
              [98.75619550900007, 80.03778717700004],
              [99.19898522200003, 80.04999420800004],
              [99.24781334700003, 80.03583405200004],
              [99.22543379000007, 80.02781810100004],
              [99.18067467500003, 80.02155182500007],
              [99.15845787900008, 80.01536692900004],
              [99.19467207100007, 80.01068756700005],
              [99.23072350400008, 80.01019928600005],
              [99.30258222700007, 80.01996491100005],
              [99.33171634200005, 80.01976146000004],
              [99.36280358200003, 80.01215241100005],
              [99.37582441500007, 80.00043366100005],
              [99.35027103000004, 79.98802317900004],
              [99.37582441500007, 79.97955963700008],
              [99.56316165500004, 79.96698639500005],
              [99.54859459700003, 79.96051666900007],
              [99.53321373800003, 79.95587799700007],
              [99.51775149800005, 79.95335521000004],
              [99.50171959700003, 79.95331452000005],
              [99.53581790500004, 79.93573639500005],
              [99.66553795700003, 79.93341705900008],
              [99.73487389400003, 79.92316315300008],
              [99.80339603000004, 79.90550364800004],
              [99.80730228000004, 79.90273672100005],
              [99.81177819100003, 79.89793528900003],
              [99.81544030000003, 79.89280833500004],
              [99.81706790500004, 79.88873932500007],
              [99.81934655000003, 79.88564687700006],
              [99.82488040500004, 79.88418203300006],
              [99.83139082100007, 79.88324616100005],
              [99.83716881600003, 79.88157786700003],
              [99.86597741000003, 79.86493561400005],
              [99.88062584700003, 79.85927969000005],
              [99.92888431100005, 79.85398997600004],
              [99.96257571700005, 79.84609609600005],
              [100.02247155000003, 79.82355377800008],
              [100.00171959700003, 79.80548737200007],
              [100.01807701900003, 79.79417552300004],
              [100.07699629000007, 79.78266022300005],
              [100.05372155000003, 79.76748281500005],
              [100.01392662900008, 79.75633372600004],
              [99.93978925900007, 79.74725983300004],
              [99.84205162900008, 79.74876536700003],
              [99.81706790500004, 79.74164459800005],
              [99.86085045700003, 79.72540924700007],
              [99.88111412900008, 79.71141185100004],
              [99.88599694100003, 79.69326406500005],
              [99.86736087300005, 79.67853424700007],
              [99.79444420700003, 79.65717194200005],
              [99.76791425900007, 79.64545319200005],
              [99.77979576900003, 79.63304271000004],
              [99.77816816500007, 79.62494538000004],
              [99.76172936300003, 79.61131419500003],
              [99.73943118600005, 79.58437734600005],
              [99.72510826900003, 79.57453034100007],
              [99.70720462300005, 79.56907786700003],
              [99.72535241000003, 79.55255768400008],
              [99.76856530000003, 79.53510163000004],
              [99.78907311300003, 79.52191803600005],
              [99.76636803500003, 79.51056549700007],
              [99.70281009200005, 79.48965078300006],
              [99.68604576900003, 79.47353750200006],
              [99.68881269600007, 79.45734284100007],
              [99.70232181100005, 79.44188060100004],
              [99.73373457100007, 79.41950104400007],
              [99.70899498800003, 79.40566640800006],
              [99.69727623800003, 79.39642975500004],
              [99.69629967500003, 79.38816966400003],
              [99.70679772200003, 79.38068268400008],
              [99.74805748800003, 79.36424388200004],
              [99.73129316500007, 79.35590241100005],
              [99.68604576900003, 79.32269928600005],
              [99.66667728000004, 79.31224192900004],
              [99.60352623800003, 79.29596588700008],
              [99.59815514400003, 79.29189687700006],
              [99.59058678500003, 79.27977122600004],
              [99.58301842500003, 79.27488841400003],
              [99.57056725400008, 79.27216217700004],
              [99.48796634200005, 79.26894765800006],
              [99.47006269600007, 79.26630280200004],
              [99.46013431100005, 79.25438060100004],
              [99.46013431100005, 79.24754466400003],
              [99.41480553500003, 79.26463450700004],
              [99.14698326900003, 79.31069570500006],
              [99.08920332100007, 79.30914948100008],
              [99.03492272200003, 79.29596588700008],
              [99.06226647200003, 79.28001536700003],
              [99.32272382900004, 79.22640615450004],
              [99.58318118600005, 79.17279694200005],
              [99.61085045700003, 79.15884023600006],
              [99.58334394600007, 79.14883047100005],
              [99.55128014400003, 79.14500560100004],
              [99.48804772200003, 79.14516836100006],
              [99.52702884200005, 79.12376536700003],
              [99.82105553500003, 79.10146719000005],
              [99.84294681100005, 79.09210846600007],
              [99.85450280000003, 79.08991120000007],
              [99.85621178500003, 79.08380768400008],
              [99.87533613400007, 79.05345286700003],
              [99.88599694100003, 79.04148997600004],
            ],
          ],
          [
            [
              [50.08130944100009, 80.06806061400005],
              [50.04127037900008, 80.05914948100008],
              [50.00017337300005, 80.05634186400005],
              [49.883148634000065, 80.06989166900007],
              [49.789398634000065, 80.09601471600007],
              [49.734385613000086, 80.10248444200005],
              [49.62680097700007, 80.13141510600008],
              [49.57545006600009, 80.13629791900007],
              [49.550791863000086, 80.14350006700005],
              [49.531260613000086, 80.15875885600008],
              [49.56072024800005, 80.17291901200008],
              [49.83912194100009, 80.21503327000005],
              [49.87973066500007, 80.22955963700008],
              [49.89861087300005, 80.23395416900007],
              [50.228526238000086, 80.22601959800005],
              [50.31861412900008, 80.19599030200004],
              [50.33562259200005, 80.18158600500004],
              [50.31763756600009, 80.16779205900008],
              [50.125987175000034, 80.14215729400007],
              [50.07252037900008, 80.11098867400005],
              [50.08676191500007, 80.10346100500004],
              [50.07732181100005, 80.10004303600005],
              [50.06812584700003, 80.09552643400008],
              [50.05974368600005, 80.09003327000005],
              [50.05201256600009, 80.08364492400005],
              [50.063243035000085, 80.08266836100006],
              [50.07781009200005, 80.07900625200006],
              [50.08676191500007, 80.07379791900007],
              [50.08130944100009, 80.06806061400005],
            ],
          ],
          [
            [
              [55.794932488000086, 80.64227936400005],
              [55.74830162900008, 80.65045807500007],
              [55.64437910200007, 80.64935944200005],
              [55.60279381600009, 80.66583893400008],
              [55.68091881600009, 80.68793366100005],
              [55.705821160000085, 80.70001862200007],
              [55.49545332100007, 80.70026276200008],
              [55.431651238000086, 80.71426015800006],
              [55.444021030000044, 80.71938711100006],
              [55.49976647200003, 80.72728099200003],
              [55.54802493600005, 80.73680247600004],
              [55.60962975400008, 80.74160390800006],
              [55.72388756600009, 80.73261139500005],
              [55.760508660000085, 80.74160390800006],
              [55.761729363000086, 80.75519440300008],
              [55.78239993600005, 80.76113515800006],
              [56.15642337350005, 80.77411530150005],
              [56.53044681100005, 80.78709544500003],
              [56.57601972700007, 80.77570221600007],
              [56.55844160200007, 80.76341380400004],
              [56.570323113000086, 80.75739166900007],
              [56.67920983200008, 80.75446198100008],
              [56.84489993600005, 80.72752513200004],
              [56.946055535000085, 80.69379303600005],
              [56.935557488000086, 80.68943919500003],
              [56.934255405000044, 80.68455638200004],
              [56.93718509200005, 80.67816803600005],
              [56.93921959700003, 80.66925690300008],
              [56.92790774800005, 80.66299062700006],
              [56.62850996150004, 80.64394765850005],
              [56.329112175000034, 80.62490469000005],
              [56.34400475400008, 80.63593170800004],
              [56.349619988000086, 80.63914622600004],
              [56.31202233200008, 80.65509674700007],
              [55.83765709700003, 80.63178131700005],
              [55.794932488000086, 80.64227936400005],
            ],
          ],
          [
            [
              [46.68726647200003, 80.52928294500003],
              [46.66773522200003, 80.51679108300004],
              [46.64478600400008, 80.51504140800006],
              [46.59791100400008, 80.52244700700004],
              [46.54509524800005, 80.52338288000004],
              [46.51921634200005, 80.51862213700008],
              [46.49545332100007, 80.50824616100005],
              [46.52295983200008, 80.48395416900007],
              [46.53012129000007, 80.47406647300005],
              [46.480479363000086, 80.45970286700003],
              [46.083994988000086, 80.43988678600005],
              [46.05290774800005, 80.44782135600008],
              [46.03044681100005, 80.46507396000004],
              [46.02125084700003, 80.48859284100007],
              [46.029307488000086, 80.51504140800006],
              [46.04151451900009, 80.52472565300008],
              [46.07748457100007, 80.54621002800008],
              [46.083994988000086, 80.55597565300008],
              [46.07056725400008, 80.56728750200006],
              [46.043711785000085, 80.57355377800008],
              [45.99496504000007, 80.57709381700005],
              [45.835948113000086, 80.55125560100004],
              [45.78296959700003, 80.54975006700005],
              [45.77523847700007, 80.55272044500003],
              [45.76783287900008, 80.55792877800008],
              [45.75993899800005, 80.56195709800005],
              [45.75025475400008, 80.56146881700005],
              [45.71119225400008, 80.55072663000004],
              [45.67318769600007, 80.54726797100005],
              [45.62232506600009, 80.53440989800004],
              [45.51531009200005, 80.51976146000004],
              [45.489024285000085, 80.52423737200007],
              [45.47242272200003, 80.53180573100008],
              [45.44361412900008, 80.55060455900008],
              [45.428721550000034, 80.55792877800008],
              [45.37720787900008, 80.57318756700005],
              [45.27116946700005, 80.58950429900005],
              [44.89600670700008, 80.60488515800006],
              [44.857432488000086, 80.61741771000004],
              [44.879893425000034, 80.62518952000005],
              [44.90707441500007, 80.63003164300005],
              [45.00538170700008, 80.63397858300004],
              [45.094737175000034, 80.64915599200003],
              [45.56869550833337, 80.67314959000004],
              [46.0426538416667, 80.69714318800004],
              [46.516612175000034, 80.72113678600005],
              [46.516612175000034, 80.72728099200003],
              [46.48845462300005, 80.72679271000004],
              [46.39926191500007, 80.73476797100005],
              [46.41627037900008, 80.74160390800006],
              [46.44157962300005, 80.74534739800004],
              [46.92074629000007, 80.74868398600006],
              [47.02320397200003, 80.76032135600008],
              [47.11255944100009, 80.78803131700005],
              [47.180674675000034, 80.79832591400003],
              [47.201182488000086, 80.80988190300008],
              [47.11841881600009, 80.82111237200007],
              [47.09197024800005, 80.83095937700006],
              [47.13819420700008, 80.84223053600005],
              [47.53630618600005, 80.85667552300004],
              [47.86548912900008, 80.81207916900007],
              [48.03858483200008, 80.80719635600008],
              [48.27515709700003, 80.83051178600005],
              [48.49634850400008, 80.79808177300004],
              [48.65479576900009, 80.75519440300008],
              [48.60661868600005, 80.74518463700008],
              [48.49976647200003, 80.74941640800006],
              [48.45557701900009, 80.72728099200003],
              [48.61646569100009, 80.69843170800004],
              [48.633799675000034, 80.68012116100005],
              [48.666351759000065, 80.67780182500007],
              [48.764008009000065, 80.65961334800005],
              [48.75611412900008, 80.64874909100007],
              [48.75440514400009, 80.63641998900005],
              [48.754242384000065, 80.62523021000004],
              [48.75049889400009, 80.61741771000004],
              [48.72681725400008, 80.61074453300006],
              [48.69654381600009, 80.61359284100007],
              [48.640635613000086, 80.62490469000005],
              [48.50717207100007, 80.63471100500004],
              [48.458994988000086, 80.64866771000004],
              [48.43441816500007, 80.65277741100005],
              [48.06373131600009, 80.66242096600007],
              [47.98951256600009, 80.68012116100005],
              [48.00700931100005, 80.70123932500007],
              [48.000010613000086, 80.70872630400004],
              [47.949880405000044, 80.70742422100005],
              [47.920909050000034, 80.71124909100007],
              [47.779958530000044, 80.76459381700005],
              [47.748789910000085, 80.77049388200004],
              [47.715830925000034, 80.76837799700007],
              [47.637054884000065, 80.75340403900003],
              [47.55811608200008, 80.74843984600005],
              [47.57276451900009, 80.74323151200008],
              [47.59880618600005, 80.73045482000003],
              [47.61264082100007, 80.72728099200003],
              [47.52979576900009, 80.72870514500005],
              [47.494151238000086, 80.73432038000004],
              [47.475596550000034, 80.73476797100005],
              [47.48975670700008, 80.71784088700008],
              [47.54810631600009, 80.69379303600005],
              [47.57178795700008, 80.68012116100005],
              [47.506521030000044, 80.67304108300004],
              [47.43083743600005, 80.68524811400005],
              [47.35865319100009, 80.68817780200004],
              [47.30420983200008, 80.65277741100005],
              [47.43327884200005, 80.61066315300008],
              [47.442149285000085, 80.60065338700008],
              [47.430674675000034, 80.59381745000007],
              [47.39698326900009, 80.59137604400007],
              [47.20004316500007, 80.62555573100008],
              [47.13917076900009, 80.61432526200008],
              [47.113291863000086, 80.60614655200004],
              [47.061208530000044, 80.59568919500003],
              [47.03679446700005, 80.58392975500004],
              [47.03109785200007, 80.57794830900008],
              [47.01970462300005, 80.56207916900007],
              [47.01002037900008, 80.55597565300008],
              [46.99244225400008, 80.55272044500003],
              [46.66684004000007, 80.56610748900005],
              [46.63257897200003, 80.55597565300008],
              [46.68726647200003, 80.52928294500003],
            ],
          ],
          [
            [
              [62.22193444100003, 80.81321849200003],
              [62.23267662900008, 80.79840729400007],
              [62.25562584700003, 80.79230377800008],
              [62.27523847700007, 80.78388092700004],
              [62.27711022200003, 80.76203034100007],
              [62.25945071700005, 80.74144114800004],
              [62.23072350400008, 80.72785065300008],
              [62.17408287900008, 80.71426015800006],
              [62.037445509000065, 80.66583893400008],
              [62.09115644600007, 80.64935944200005],
              [62.14730879000007, 80.63914622600004],
              [62.115977410000085, 80.62238190300008],
              [62.072276238000086, 80.61416250200006],
              [61.70622806100005, 80.59747955900008],
              [61.698008660000085, 80.59418366100005],
              [61.69516035200007, 80.59072500200006],
              [61.68864993600005, 80.57929108300004],
              [61.68799889400003, 80.57709381700005],
              [61.60962975400008, 80.56720612200007],
              [61.58765709700003, 80.55597565300008],
              [61.606211785000085, 80.52928294500003],
              [61.31080162900008, 80.51072825700004],
              [61.27662194100003, 80.50136953300006],
              [61.373789910000085, 80.49380117400005],
              [61.38306725400008, 80.49079010600008],
              [61.38021894600007, 80.48456452000005],
              [61.365244988000086, 80.47406647300005],
              [61.32740319100003, 80.45746491100005],
              [61.28207441500007, 80.44696686400005],
              [61.154307488000086, 80.43451569200005],
              [61.08448326900003, 80.41058991100005],
              [61.04460696700005, 80.40517812700006],
              [60.56080162900008, 80.44647858300004],
              [60.307383660000085, 80.49555084800005],
              [60.180430535000085, 80.48834870000007],
              [60.18726647200003, 80.48151276200008],
              [60.15756269600007, 80.46906159100007],
              [60.12623131600009, 80.46283600500004],
              [60.02914472700007, 80.45722077000005],
              [59.963226759000065, 80.44310130400004],
              [59.68685957100007, 80.42690664300005],
              [59.63640384200005, 80.43121979400007],
              [59.49594160200007, 80.48261139500005],
              [59.24195397200003, 80.52928294500003],
              [59.25611412900008, 80.53888580900008],
              [59.27361087300005, 80.54291413000004],
              [59.310883009000065, 80.54315827000005],
              [59.36215254000007, 80.55882396000004],
              [59.37232506600009, 80.57025788000004],
              [59.33318118600005, 80.57196686400005],
              [59.286143425000034, 80.58197663000004],
              [59.26148522200003, 80.59788646000004],
              [59.289805535000085, 80.61741771000004],
              [59.229258660000085, 80.64411041900007],
              [59.221446160000085, 80.65277741100005],
              [59.234711134000065, 80.66111888200004],
              [59.29151451900003, 80.67796458500004],
              [59.31023196700005, 80.68695709800005],
              [59.30225670700008, 80.68903229400007],
              [59.282237175000034, 80.70001862200007],
              [59.301768425000034, 80.70758698100008],
              [59.34457441500007, 80.71385325700004],
              [59.36548912900008, 80.72113678600005],
              [59.358083530000044, 80.72728099200003],
              [59.404633009000065, 80.75031159100007],
              [59.533864780000044, 80.76341380400004],
              [59.57081139400003, 80.78998444200005],
              [59.508799675000034, 80.80365631700005],
              [59.55591881600009, 80.80780670800004],
              [59.69385826900003, 80.83714427300004],
              [59.71810957100007, 80.83795807500007],
              [59.78931725400008, 80.83095937700006],
              [59.81218509200005, 80.83266836100006],
              [59.85141035200007, 80.84235260600008],
              [60.170909050000034, 80.85394928600005],
              [60.22437584700003, 80.84837474200003],
              [60.256195509000065, 80.83095937700006],
              [60.03931725400008, 80.82391998900005],
              [59.96810957100007, 80.80988190300008],
              [60.31202233200008, 80.81077708500004],
              [60.35173587300005, 80.80365631700005],
              [60.354258660000085, 80.79999420800004],
              [60.35092207100007, 80.79547760600008],
              [60.350596550000034, 80.79157135600008],
              [60.361989780000044, 80.78998444200005],
              [60.375336134000065, 80.79043203300006],
              [60.56397545700008, 80.82282135600008],
              [61.05433190200006, 80.84393952000008],
              [61.54468834700003, 80.86505768400008],
              [61.535817905000044, 80.87514883000006],
              [61.53044681100005, 80.87872955900008],
              [61.561289910000085, 80.89248281500005],
              [61.602549675000034, 80.89565664300005],
              [62.06771894600007, 80.87986888200004],
              [62.20826256600003, 80.82269928600005],
              [62.22193444100003, 80.81321849200003],
            ],
          ],
          [
            [
              [58.13005618600005, 80.78074778900003],
              [58.089854363000086, 80.78774648600006],
              [57.88249759200005, 80.78729889500005],
              [57.842784050000034, 80.79559967700004],
              [57.81568444100009, 80.80988190300008],
              [57.84424889400003, 80.82469310100004],
              [57.91391035200007, 80.82908763200004],
              [57.94548587300005, 80.83698151200008],
              [58.01587975400008, 80.84056224200003],
              [58.15739993600005, 80.87124258000006],
              [58.45163007900004, 80.88698965050006],
              [58.74586022200003, 80.90273672100005],
              [58.92888431100005, 80.88214752800008],
              [58.96021569100009, 80.87189362200007],
              [58.97901451900003, 80.85887278900003],
              [59.00603274800005, 80.83539459800005],
              [59.02906334700003, 80.82412344000005],
              [59.014008009000065, 80.82318756700005],
              [59.004649285000085, 80.81806061400005],
              [58.988617384000065, 80.80365631700005],
              [58.93441816500007, 80.78074778900003],
              [58.895518425000034, 80.77374909100007],
              [58.775726759000065, 80.78253815300008],
              [58.696055535000085, 80.77887604400007],
              [58.54273522200003, 80.75429922100005],
              [58.42123457100007, 80.74876536700003],
              [58.13005618600005, 80.78074778900003],
            ],
          ],
          [
            [
              [55.76587975400008, 80.78367747600004],
              [55.32129967550006, 80.75240713100004],
              [54.87671959700003, 80.72113678600005],
              [54.66382897200003, 80.74160390800006],
              [54.66944420700008, 80.75462474200003],
              [54.682627800000034, 80.76170482000003],
              [54.68995201900003, 80.76898834800005],
              [54.67798912900008, 80.78253815300008],
              [54.656993035000085, 80.78803131700005],
              [54.58920332100007, 80.78823476800005],
              [54.54273522200003, 80.78001536700003],
              [54.27723229250006, 80.78811269750005],
              [54.011729363000086, 80.79621002800008],
              [53.99040774800005, 80.80267975500004],
              [53.98031660200007, 80.81622955900008],
              [53.98462975400008, 80.82851797100005],
              [54.10084069100009, 80.85171133000006],
              [54.32341556100005, 80.86444733300004],
              [54.40674889400003, 80.85146719000005],
              [54.72242272200003, 80.87189362200007],
              [54.74341881600009, 80.87002187700006],
              [54.76482181100005, 80.86444733300004],
              [54.772471550000034, 80.85590241100005],
              [54.75318444100009, 80.84463125200006],
              [54.822927280000044, 80.83592357000003],
              [54.85759524800005, 80.83930084800005],
              [54.89039147200003, 80.85146719000005],
              [54.95142662900008, 80.88226959800005],
              [54.983164910000085, 80.89240143400008],
              [55.02068118600005, 80.89862702000005],
              [55.09701582100007, 80.90281810100004],
              [55.25700931100005, 80.89028554900005],
              [55.36898847700007, 80.86176178600005],
              [55.67774498750006, 80.83270905150005],
              [55.98650149800005, 80.80365631700005],
              [55.93336022200003, 80.79124583500004],
              [55.76587975400008, 80.78367747600004],
            ],
          ],
          [
            [
              [51.68930097700007, 80.72728099200003],
              [51.72087649800005, 80.72703685100004],
              [51.73422285200007, 80.72357819200005],
              [51.74398847700007, 80.71426015800006],
              [51.740896030000044, 80.71019114800004],
              [51.73170006600009, 80.70648834800005],
              [51.72543379000007, 80.70160553600005],
              [51.73096764400003, 80.69379303600005],
              [51.70093834700003, 80.67694733300004],
              [51.43775475350006, 80.64754873250004],
              [51.174571160000085, 80.61815013200004],
              [51.12232506600009, 80.60248444200005],
              [50.994802280000044, 80.54734935100004],
              [50.949554884000065, 80.53676992400005],
              [50.53545169400007, 80.53192780150005],
              [50.12134850400008, 80.52708567900004],
              [50.08676191500007, 80.51504140800006],
              [50.04664147200003, 80.49860260600008],
              [49.72779381600009, 80.49433014500005],
              [49.67530358200008, 80.48151276200008],
              [49.70826256600009, 80.46995677300004],
              [49.75863691500007, 80.46332428600005],
              [49.79810631600009, 80.45209381700005],
              [49.79867597700007, 80.42690664300005],
              [49.808604363000086, 80.42597077000005],
              [49.821055535000085, 80.42234935100004],
              [49.83025149800005, 80.41644928600005],
              [49.82960045700008, 80.40888092700004],
              [49.81617272200003, 80.40102773600006],
              [49.49040774800005, 80.36351146000004],
              [49.16496829500005, 80.37567780150005],
              [48.83952884200005, 80.38784414300005],
              [48.791351759000065, 80.36420319200005],
              [48.79835045700008, 80.36163971600007],
              [48.81812584700003, 80.35053131700005],
              [48.65447024800005, 80.31704336100006],
              [48.626963738000086, 80.29531484600005],
              [48.680349155000044, 80.28693268400008],
              [48.89600670700008, 80.28188711100006],
              [48.94263756600009, 80.27301666900007],
              [49.037852410000085, 80.24127838700008],
              [49.02523847700007, 80.23053620000007],
              [48.99187259200005, 80.22113678600005],
              [48.97575931100005, 80.21336497600004],
              [49.068695509000065, 80.19965241100005],
              [49.10718834700003, 80.18952057500007],
              [49.08562259200005, 80.17243073100008],
              [49.06177819100009, 80.16840241100005],
              [49.00945071700005, 80.16868724200003],
              [48.98943118600005, 80.16620514500005],
              [48.98650149800005, 80.16278717700004],
              [48.986989780000044, 80.15794505400004],
              [48.98357181100005, 80.15375397300005],
              [48.969086134000065, 80.15192291900007],
              [48.73389733200008, 80.15908437700006],
              [48.58350670700008, 80.20282623900005],
              [48.528330925000034, 80.20913320500006],
              [48.49659264400009, 80.19285716400003],
              [48.53988691500007, 80.16986725500004],
              [48.551768425000034, 80.15875885600008],
              [48.51059004000007, 80.12421295800004],
              [48.44385826900009, 80.10081614800004],
              [48.37240644600007, 80.09178294500003],
              [48.31812584700003, 80.10040924700007],
              [48.28956139400009, 80.11318594000005],
              [48.22315514400009, 80.13467031500005],
              [48.191742384000065, 80.13825104400007],
              [48.11605879000007, 80.13678620000007],
              [48.07634524800005, 80.13084544500003],
              [48.04468834700003, 80.11782461100006],
              [48.04273522200003, 80.11176178600005],
              [48.047618035000085, 80.10586172100005],
              [48.048838738000086, 80.09955475500004],
              [48.035817905000044, 80.09227122600004],
              [48.01921634200005, 80.08905670800004],
              [47.66358483200008, 80.07001373900005],
              [47.627696160000085, 80.07221100500004],
              [47.60523522200003, 80.07859935100004],
              [47.60531660200007, 80.08885325700004],
              [47.637461785000085, 80.10260651200008],
              [47.633148634000065, 80.11782461100006],
              [47.73650149800005, 80.16201406500005],
              [47.79029381600009, 80.17511627800008],
              [48.04664147200003, 80.18903229400007],
              [48.08513431100005, 80.20718008000006],
              [47.900401238000086, 80.20148346600007],
              [47.84546959700003, 80.21336497600004],
              [47.871429884000065, 80.22402578300006],
              [47.94060306100005, 80.22455475500004],
              [47.96900475400008, 80.23509349200003],
              [47.92937259200005, 80.24713776200008],
              [47.67855879000007, 80.24774811400005],
              [47.599945509000065, 80.23777903900003],
              [47.45134524800005, 80.23981354400007],
              [47.33838951900009, 80.21336497600004],
              [47.375010613000086, 80.19464752800008],
              [47.38689212300005, 80.18671295800004],
              [47.21208743600005, 80.19009023600006],
              [47.10181725400008, 80.17031484600005],
              [46.894541863000086, 80.19179922100005],
              [46.89283287900008, 80.20376211100006],
              [46.902354363000086, 80.21743398600006],
              [46.90642337300005, 80.22768789300005],
              [46.89014733200008, 80.23663971600007],
              [46.65951582100007, 80.27415599200003],
              [46.61841881600009, 80.29531484600005],
              [46.64975019600007, 80.31386953300006],
              [47.088552280000044, 80.37164948100008],
              [47.119883660000085, 80.36823151200008],
              [47.163096550000034, 80.35854726800005],
              [47.190196160000085, 80.34324778900003],
              [47.173838738000086, 80.32318756700005],
              [47.22388756600009, 80.30898672100005],
              [47.42798912900008, 80.32269928600005],
              [47.55616295700008, 80.30390045800004],
              [47.637054884000065, 80.31647370000007],
              [48.01685631600009, 80.30955638200004],
              [47.97095787900008, 80.32184479400007],
              [48.13298587300005, 80.32648346600007],
              [48.18873131600009, 80.33755117400005],
              [48.14779707100007, 80.34373607000003],
              [48.064789259000065, 80.34601471600007],
              [47.910817905000044, 80.36908600500004],
              [47.68930097700007, 80.37295156500005],
              [47.661143425000034, 80.37787506700005],
              [47.63591556100005, 80.38812897300005],
              [47.619476759000065, 80.40517812700006],
              [47.910899285000056, 80.41058991100005],
              [48.20232181100005, 80.41600169500003],
              [48.23585045700008, 80.42690664300005],
              [48.20248457100007, 80.43398672100005],
              [48.13013756600009, 80.43545156500005],
              [48.09937584700003, 80.44611237200007],
              [48.10865319100009, 80.45286692900004],
              [48.14039147200003, 80.46784088700008],
              [48.10010826900009, 80.47630442900004],
              [47.96900475400008, 80.46784088700008],
              [47.81983483200008, 80.47638580900008],
              [47.42335045700008, 80.44293854400007],
              [47.37940514400009, 80.45355866100005],
              [47.41521243600005, 80.46625397300005],
              [47.71428470150005, 80.50641510600005],
              [48.01335696700005, 80.54657623900005],
              [48.162445509000065, 80.53343333500004],
              [48.19516035200007, 80.53546784100007],
              [48.298838738000086, 80.56118398600006],
              [48.37549889400009, 80.57111237200007],
              [48.414073113000086, 80.57025788000004],
              [48.525726759000065, 80.54450104400007],
              [48.565440300000034, 80.54291413000004],
              [48.55811608200008, 80.53644440300008],
              [48.53931725400008, 80.52374909100007],
              [48.53077233200008, 80.51504140800006],
              [48.569021030000044, 80.50560130400004],
              [48.70199629000007, 80.51504140800006],
              [48.78638756600009, 80.49896881700005],
              [48.82740319100009, 80.49774811400005],
              [48.87330162900008, 80.50824616100005],
              [48.91684004000007, 80.52553945500006],
              [48.93482506600009, 80.52928294500003],
              [48.960948113000086, 80.53074778900003],
              [49.13648522200003, 80.51691315300008],
              [49.188243035000085, 80.52142975500004],
              [49.22966556100005, 80.53676992400005],
              [49.18775475400008, 80.54816315300008],
              [49.17505944100009, 80.55597565300008],
              [49.19255618600005, 80.56069570500006],
              [49.22771243600005, 80.56460195500006],
              [49.24529056100005, 80.56850820500006],
              [49.254567905000044, 80.57294342700004],
              [49.26221764400009, 80.57802969000005],
              [49.272227410000085, 80.58222077000005],
              [49.35572350400008, 80.58722565300008],
              [49.38949629000007, 80.59707265800006],
              [49.40707441500007, 80.61741771000004],
              [49.377289259000065, 80.61660390800006],
              [49.34197024800005, 80.62002187700006],
              [49.308604363000086, 80.62909577000005],
              [49.28492272200003, 80.64533112200007],
              [49.428721550000034, 80.65460846600007],
              [49.63103274800005, 80.63959381700005],
              [49.66846764400003, 80.65277741100005],
              [49.65943444100009, 80.65501536700003],
              [49.63428795700008, 80.66583893400008],
              [49.64031009200005, 80.66889069200005],
              [49.65479576900003, 80.68012116100005],
              [49.64503014400003, 80.68463776200008],
              [49.634776238000086, 80.68720123900005],
              [49.62419681100005, 80.68797435100004],
              [49.613291863000086, 80.68695709800005],
              [49.681976759000065, 80.72113678600005],
              [49.627940300000034, 80.73090241100005],
              [49.20289147200003, 80.69379303600005],
              [49.225352410000085, 80.71466705900008],
              [49.26319420700008, 80.72797272300005],
              [49.305023634000065, 80.73444245000007],
              [49.33952884200005, 80.73476797100005],
              [49.30005944100009, 80.74628327000005],
              [49.242930535000085, 80.74477773600006],
              [49.045909050000034, 80.71458567900004],
              [48.99887129000007, 80.71906159100007],
              [48.95533287900008, 80.73476797100005],
              [48.99203535200007, 80.74762604400007],
              [49.07471764400009, 80.75849030200004],
              [49.11353600400008, 80.76947663000004],
              [49.08676191500007, 80.77509186400005],
              [49.00367272200003, 80.77570221600007],
              [49.34046471450006, 80.81460195550005],
              [49.67725670700008, 80.85350169500003],
              [49.75757897200003, 80.88426341400003],
              [49.801768425000034, 80.89337799700007],
              [50.23715254000007, 80.93349844000005],
              [50.30209394600007, 80.92304108300004],
              [50.39698326900003, 80.92108795800004],
              [50.44304446700005, 80.91290924700007],
              [50.44304446700005, 80.90607330900008],
              [50.13135826900003, 80.88971588700008],
              [50.07748457100007, 80.87677643400008],
              [50.02312259200005, 80.87250397300005],
              [49.99732506600009, 80.86505768400008],
              [50.02312259200005, 80.85822174700007],
              [50.37370852950005, 80.87683746950006],
              [50.72429446700005, 80.89545319200005],
              [50.82667076900003, 80.91909414300005],
              [50.85596764400003, 80.91852448100008],
              [50.87842858200008, 80.91156647300005],
              [50.92212975400008, 80.88873932500007],
              [51.04517662900008, 80.85146719000005],
              [51.01775149800005, 80.83710358300004],
              [50.98210696700005, 80.83124420800004],
              [50.795664910000085, 80.83173248900005],
              [50.68970787900008, 80.81354401200008],
              [50.47038821700005, 80.80988190300008],
              [50.47038821700005, 80.80365631700005],
              [50.52881920700008, 80.79596588700008],
              [50.54542076900003, 80.78998444200005],
              [50.510101759000065, 80.77635325700004],
              [50.31267337300005, 80.76487864800004],
              [50.27491295700008, 80.75649648600006],
              [50.25123131600009, 80.74160390800006],
              [50.278330925000034, 80.74103424700007],
              [50.29900149800005, 80.73387278900003],
              [50.31812584700003, 80.72426992400005],
              [50.340179884000065, 80.71605052300004],
              [50.37240644600007, 80.71344635600008],
              [50.65259850400008, 80.76581452000005],
              [50.67945397200003, 80.76398346600007],
              [50.734385613000086, 80.74738190300008],
              [50.76490319100009, 80.74176666900007],
              [50.79542076900003, 80.74290599200003],
              [50.84595787900008, 80.76829661700003],
              [50.88298587300005, 80.77423737200007],
              [51.008555535000085, 80.77773672100005],
              [51.03923587300005, 80.77513255400004],
              [51.05258222700007, 80.76577383000006],
              [51.06755618600005, 80.75104401200008],
              [51.101573113000086, 80.74819570500006],
              [51.16187584700003, 80.75519440300008],
              [51.14405358200008, 80.76752350500004],
              [51.15650475400008, 80.77570221600007],
              [51.31267337300005, 80.78998444200005],
              [51.30884850400008, 80.77968984600005],
              [51.30640709700003, 80.77570221600007],
              [51.33480879000007, 80.76813385600008],
              [51.39503014400003, 80.76093170800004],
              [51.45134524800005, 80.74188873900005],
              [51.48292076900003, 80.73663971600007],
              [51.68930097700007, 80.72728099200003],
            ],
          ],
          [
            [
              [79.80665123800003, 80.97431061400005],
              [80.12191816500004, 80.95724111550004],
              [80.43718509200005, 80.94017161700003],
              [80.41382897200003, 80.90053945500006],
              [80.39991295700008, 80.88593170800004],
              [80.37427819100003, 80.87372467700004],
              [80.32642662900008, 80.86054108300004],
              [79.9268226793334, 80.84259674700006],
              [79.52721872966673, 80.82465241100006],
              [79.12761478000004, 80.80670807500007],
              [79.01148522200003, 80.82412344000005],
              [78.97461998800003, 80.84259674700007],
              [78.98658287900008, 80.86102936400005],
              [79.07593834700003, 80.90033600500004],
              [79.12110436300003, 80.92991771000004],
              [79.14307701900003, 80.93903229400007],
              [79.18799889400003, 80.95184967700004],
              [79.21070397200003, 80.96133047100005],
              [79.21697024800005, 80.96133047100005],
              [79.23780358200008, 80.95311107000003],
              [79.72999108200008, 80.98012929900005],
              [79.80665123800003, 80.97431061400005],
            ],
          ],
          [
            [
              [58.65365644600007, 81.04376862200007],
              [58.69662519600007, 81.02472565300008],
              [58.60670006600009, 80.99485911700003],
              [58.604502800000034, 80.97431061400005],
              [58.561289910000085, 80.95701732000003],
              [58.36695397200003, 80.94594961100006],
              [58.25359134200005, 80.95514557500007],
              [57.882823113000086, 81.03021881700005],
              [57.84099368600005, 81.04767487200007],
              [57.844737175000034, 81.05951569200005],
              [57.864024285000085, 81.06517161700003],
              [58.00114993600005, 81.08417389500005],
              [57.99048912900008, 81.09760163000004],
              [58.012380405000044, 81.10618724200003],
              [58.06950931100005, 81.11151764500005],
              [58.36158287850006, 81.07764313350006],
              [58.65365644600007, 81.04376862200007],
            ],
          ],
          [
            [
              [57.33643639400003, 80.89179108300004],
              [57.23161868600005, 80.90704987200007],
              [57.19857832100007, 80.90607330900008],
              [57.217133009000065, 80.91844310100004],
              [57.23406009200005, 80.93333567900004],
              [57.20142662900008, 80.95392487200007],
              [57.14625084700003, 80.96165599200003],
              [57.01417076900003, 80.96185944200005],
              [56.957774285000085, 80.96784088700008],
              [56.932383660000085, 80.97431061400005],
              [56.91423587300005, 80.98200104400007],
              [56.89730879000007, 80.99282461100006],
              [56.894541863000086, 81.00287506700005],
              [56.918711785000085, 81.00844961100006],
              [56.89673912900008, 81.01609935100004],
              [56.845713738000086, 81.01361725500004],
              [56.82252037900008, 81.01902903900003],
              [56.79932701900003, 81.02749258000006],
              [56.47177168050004, 81.05992259300007],
              [56.14421634200005, 81.09235260600008],
              [56.09555097700007, 81.09100983300004],
              [56.09978274800005, 81.10138580900008],
              [56.10320071700005, 81.10529205900008],
              [56.12387129000007, 81.11859772300005],
              [56.147146030000044, 81.12319570500006],
              [56.17123457100007, 81.12128327000005],
              [56.22486412900008, 81.10785553600005],
              [56.70289147200003, 81.11310455900008],
              [56.77751712300005, 81.09735748900005],
              [56.830821160000085, 81.09349192900004],
              [56.944346550000034, 81.07245514500005],
              [57.17432701900003, 81.05687083500004],
              [57.25635826900003, 81.06476471600007],
              [57.644541863000086, 81.02435944200005],
              [57.65479576900003, 81.01984284100007],
              [57.66781660200007, 81.00576406500005],
              [57.67945397200003, 80.99852122600004],
              [57.750010613000086, 80.97068919500003],
              [58.01620527450007, 80.94859446850003],
              [58.28239993600005, 80.92649974200003],
              [58.248383009000065, 80.91722239800004],
              [57.96566816500007, 80.88833242400005],
              [57.87094160200007, 80.85956452000005],
              [57.83814537900008, 80.85333893400008],
              [57.53435306100005, 80.86269765800006],
              [57.44068444100009, 80.88373444200005],
              [57.33643639400003, 80.89179108300004],
            ],
          ],
          [
            [
              [54.56413821700005, 80.99542877800008],
              [54.44939212300005, 80.99774811400005],
              [54.41732832100007, 81.00844961100006],
              [54.426442905000044, 81.02423737200007],
              [54.430430535000085, 81.02895742400005],
              [54.45492597700007, 81.04857005400004],
              [54.487315300000034, 81.05451080900008],
              [54.522227410000085, 81.05634186400005],
              [54.55396569100009, 81.06370677300004],
              [54.53646894600007, 81.07436758000006],
              [54.54428144600007, 81.08380768400008],
              [54.647227410000085, 81.12230052300004],
              [54.670909050000034, 81.12518952000005],
              [54.72038821700005, 81.11957428600005],
              [54.86304772200003, 81.08417389500005],
              [55.32162519600007, 81.05003489800004],
              [55.520274285000085, 81.00844961100006],
              [55.576914910000085, 81.00714752800008],
              [56.01921634200005, 81.04360586100006],
              [56.321258985500066, 81.01268138200007],
              [56.62330162900008, 80.98175690300008],
              [56.652354363000086, 80.94354889500005],
              [56.99534481433341, 80.90129900366672],
              [57.33833526566673, 80.85904911233338],
              [57.68132571700005, 80.81679922100005],
              [57.700205925000034, 80.80988190300008],
              [57.71607506600009, 80.79315827000005],
              [57.70679772200003, 80.78266022300005],
              [57.68376712300005, 80.77724844000005],
              [57.63428795700008, 80.77252838700008],
              [57.56234785200007, 80.74843984600005],
              [57.31055748750006, 80.72013987850005],
              [57.05876712300005, 80.69183991100005],
              [57.00749759200005, 80.70001862200007],
              [56.84302819100009, 80.76203034100007],
              [56.717539910000085, 80.77912018400008],
              [56.705821160000085, 80.78253815300008],
              [56.69662519600007, 80.78676992400005],
              [56.69459069100009, 80.78912995000007],
              [56.69385826900003, 80.79262929900005],
              [56.68873131600009, 80.79995351800005],
              [56.66846764400003, 80.80923086100006],
              [56.23365319100006, 80.83183421400005],
              [55.798838738000086, 80.85443756700005],
              [55.77393639400003, 80.86139557500007],
              [55.764333530000044, 80.87116120000007],
              [55.762705925000034, 80.88104889500005],
              [55.75733483200008, 80.88873932500007],
              [55.73658287900008, 80.89179108300004],
              [55.547211134000065, 80.89769114800004],
              [55.376963738000086, 80.93333567900004],
              [55.401052280000044, 80.95254140800006],
              [55.40479576900003, 80.95758698100008],
              [55.39763431100005, 80.96491120000007],
              [55.38062584700003, 80.96857330900008],
              [55.315196160000085, 80.97528717700004],
              [55.20728600400008, 80.95384349200003],
              [54.99830162900008, 80.95115794500003],
              [54.93279056100005, 80.96287669500003],
              [54.883555535000085, 80.97801341400003],
              [54.88070722700007, 80.98615143400008],
              [54.87387129000007, 80.99371979400007],
              [54.865977410000085, 80.99941640800006],
              [54.85954837300005, 81.00165436400005],
              [54.56413821700005, 80.99542877800008],
            ],
          ],
          [
            [
              [50.476573113000086, 81.06997304900005],
              [50.34742272200003, 81.09100983300004],
              [50.38786868600005, 81.10529205900008],
              [50.38257897200003, 81.10993073100008],
              [50.37281334700003, 81.12075429900005],
              [50.36736087300005, 81.12518952000005],
              [50.49756920700008, 81.12518952000005],
              [50.51905358200008, 81.12897370000007],
              [50.53858483200008, 81.13882070500006],
              [50.52816816500007, 81.14691803600005],
              [50.490896030000044, 81.15924713700008],
              [50.529633009000065, 81.16787344000005],
              [50.778005405000044, 81.17023346600007],
              [50.81983483200008, 81.16616445500006],
              [50.912119988000086, 81.14301178600005],
              [50.949554884000065, 81.12518952000005],
              [50.97681725400008, 81.10590241100005],
              [50.96802819100009, 81.09568919500003],
              [50.93799889400003, 81.09170156500005],
              [50.765961134000065, 81.08836497600004],
              [50.744802280000044, 81.07737864800004],
              [50.75220787900008, 81.06781647300005],
              [50.77914472700007, 81.06244538000004],
              [50.78500410200007, 81.05345286700003],
              [50.774424675000034, 81.04401276200008],
              [50.75017337300005, 81.04116445500006],
              [50.574554884000065, 81.04637278900003],
              [50.451508009000065, 81.01654694200005],
              [50.40943444100009, 81.01312897300005],
              [50.37427819100009, 81.02277252800008],
              [50.37777754000007, 81.02680084800005],
              [50.38200931100005, 81.03046295800004],
              [50.390961134000065, 81.03644440300008],
              [50.41456139400003, 81.04043203300006],
              [50.44092858200008, 81.04832591400003],
              [50.463633660000085, 81.05874258000006],
              [50.476573113000086, 81.06997304900005],
            ],
          ],
          [
            [
              [91.54721113400007, 81.15379466400003],
              [91.57113691500007, 81.14297109600005],
              [91.57390384200005, 81.13556549700007],
              [91.55933678500003, 81.13019440300008],
              [91.37086022200003, 81.10407135600008],
              [91.34424889400003, 81.09625885600008],
              [91.33277428500003, 81.08075592700004],
              [91.18620853000004, 81.05683014500005],
              [90.78958852133339, 81.07298411633339],
              [90.39296851266674, 81.08913808766674],
              [89.99634850400008, 81.10529205900008],
              [89.97413170700008, 81.11033763200004],
              [89.93433678500003, 81.13076406500005],
              [89.91456139400003, 81.13263580900008],
              [89.92432701900003, 81.14793528900003],
              [89.92302493600005, 81.15802643400008],
              [89.91211998800003, 81.16567617400005],
              [89.89389082100007, 81.17357005400004],
              [89.93702233200008, 81.18016185100004],
              [90.02279707100007, 81.20595937700006],
              [90.06470787900008, 81.20709870000007],
              [90.07154381600003, 81.21454498900005],
              [90.53264407633337, 81.2072343336667],
              [90.9937443366667, 81.19992367833338],
              [91.45484459700003, 81.19261302300004],
              [91.54721113400007, 81.15379466400003],
            ],
          ],
          [
            [
              [97.74708092500003, 80.74160390800006],
              [97.80111738400007, 80.73387278900003],
              [97.92652428500003, 80.74095286700003],
              [97.97291100400008, 80.72113678600005],
              [97.94410241000003, 80.70014069200005],
              [97.89584394600007, 80.69318268400008],
              [97.80225670700003, 80.69379303600005],
              [97.78028405000003, 80.69106679900005],
              [97.76693769600007, 80.68593984600005],
              [97.74048912900008, 80.66925690300008],
              [97.71900475400008, 80.66364166900007],
              [97.69532311300003, 80.66502513200004],
              [97.65088951900003, 80.67267487200007],
              [97.55534915500004, 80.67426178600005],
              [97.37322024800005, 80.65277741100005],
              [97.32984459700003, 80.65322500200006],
              [97.28825931100005, 80.66583893400008],
              [97.29420006600003, 80.67072174700007],
              [97.13062584700003, 80.66583893400008],
              [97.14454186300003, 80.65668366100005],
              [97.17554772200003, 80.65058014500005],
              [97.19157962300005, 80.64533112200007],
              [97.16032962300005, 80.62254466400003],
              [97.08187910200007, 80.60252513200004],
              [97.04737389400003, 80.58392975500004],
              [97.05941816500007, 80.57225169500003],
              [97.05469811300003, 80.56757233300004],
              [97.04216556100005, 80.56488678600005],
              [97.03077233200003, 80.55971914300005],
              [97.01978600400008, 80.54804108300004],
              [97.01758873800003, 80.54214101800005],
              [97.01929772200003, 80.53656647300005],
              [97.02076256600003, 80.52586497600004],
              [97.13721764400003, 80.49457428600005],
              [97.14877363400007, 80.48700592700004],
              [97.14527428500003, 80.47036367400005],
              [97.14698326900003, 80.45368073100008],
              [97.17497806100005, 80.44611237200007],
              [97.18734785200007, 80.44440338700008],
              [97.19922936300003, 80.43919505400004],
              [97.20850670700003, 80.43085358300004],
              [97.21265709700003, 80.41941966400003],
              [97.20980879000007, 80.41046784100007],
              [97.19564863400007, 80.39874909100007],
              [97.19157962300005, 80.39154694200005],
              [97.19361412900008, 80.37055084800005],
              [97.20582116000003, 80.35561758000006],
              [97.22584069100003, 80.34666575700004],
              [97.25074303500003, 80.34369538000004],
              [97.33480879000007, 80.34369538000004],
              [97.42286217500003, 80.32697174700007],
              [97.42286217500003, 80.31956614800004],
              [97.41423587300005, 80.31053294500003],
              [97.40447024800005, 80.30272044500003],
              [97.38998457100007, 80.29572174700007],
              [97.34229576900003, 80.28974030200004],
              [97.24984785200007, 80.26459381700005],
              [97.21949303500003, 80.26178620000007],
              [97.22950280000003, 80.25120677300004],
              [97.23308353000004, 80.24811432500007],
              [97.18799889400003, 80.23358795800004],
              [96.75718834720003, 80.21452057520005],
              [96.32637780040002, 80.19545319240005],
              [95.89556725360003, 80.17638580960006],
              [95.46475670680003, 80.15731842680006],
              [95.03394616000003, 80.13825104400007],
              [94.86304772200003, 80.15155670800004],
              [94.80941816500007, 80.14329661700003],
              [94.74398847700007, 80.12177155200004],
              [94.71802819100003, 80.11782461100006],
              [94.53003991000003, 80.13100820500006],
              [94.50570722700007, 80.12523021000004],
              [94.48878014400003, 80.11546458500004],
              [94.47380618600005, 80.10394928600005],
              [94.45777428500003, 80.09442780200004],
              [94.17253665500004, 80.04157135600008],
              [93.85059655000003, 80.02020905200004],
              [93.74984785200007, 79.99677155200004],
              [93.69410241000003, 79.99811432500007],
              [93.33924401150003, 80.04771556200006],
              [92.98438561300003, 80.09731679900005],
              [92.99057050900007, 80.10346100500004],
              [92.96501712300005, 80.11102936400005],
              [92.50489342500003, 80.15766022300005],
              [92.40845787900008, 80.15192291900007],
              [92.06576582100007, 80.17243073100008],
              [92.09099368600005, 80.18268463700008],
              [92.14144941500007, 80.18447500200006],
              [92.16732832100007, 80.18829987200007],
              [92.17400149800005, 80.19253164300005],
              [92.17904707100007, 80.19891998900005],
              [92.18213951900003, 80.20477936400005],
              [92.18246504000007, 80.20718008000006],
              [92.19532311300003, 80.20815664300005],
              [92.20687910200007, 80.20620351800005],
              [92.21827233200008, 80.20294830900008],
              [92.52784264450008, 80.18154531450006],
              [92.83741295700008, 80.16014232000003],
              [92.88819420700008, 80.17243073100008],
              [92.85726972700007, 80.18797435100004],
              [92.77572675900007, 80.18976471600007],
              [92.69996178500003, 80.20368073100008],
              [92.43897545700008, 80.21010976800005],
              [92.36207116000003, 80.22646719000005],
              [92.28101647200003, 80.23041413000004],
              [92.24398847700007, 80.24127838700008],
              [92.25212649800005, 80.24811432500007],
              [92.21762129000007, 80.26532623900005],
              [92.12964928500003, 80.27586497600004],
              [92.10743248800003, 80.28974030200004],
              [92.39975019650004, 80.29444000900006],
              [92.69206790500004, 80.29913971600007],
              [92.73088626400005, 80.29812246300008],
              [92.79761803500003, 80.29503001500007],
              [92.83611087300005, 80.29165273600006],
              [93.28939863400007, 80.26683177300004],
              [93.32016035200007, 80.27606842700004],
              [93.30469811300003, 80.28733958500004],
              [93.28402754000007, 80.29682038000004],
              [93.24439537900008, 80.30955638200004],
              [93.19214928500003, 80.31647370000007],
              [92.79647871200007, 80.31008535400008],
              [92.73552493600005, 80.31130605700008],
              [92.3343476356667, 80.30411747200007],
              [91.93317033533337, 80.29692888700005],
              [91.53199303500003, 80.28974030200004],
              [91.55933678500003, 80.29657623900005],
              [91.61850019600007, 80.30438873900005],
              [91.64128665500004, 80.31704336100006],
              [91.50342858200008, 80.30670807500007],
              [91.42212975400008, 80.30955638200004],
              [91.47242272200003, 80.35040924700007],
              [91.54615319100003, 80.35976797100005],
              [91.62468509200005, 80.35956452000005],
              [91.68897545700008, 80.37164948100008],
              [91.68140709700003, 80.37445709800005],
              [91.66236412900008, 80.38523997600004],
              [91.98878014400003, 80.40159739800004],
              [92.04037519600007, 80.39118073100008],
              [92.07064863400007, 80.38837311400005],
              [92.10010826900003, 80.39032623900005],
              [92.12094160200007, 80.39899323100008],
              [92.11068769600007, 80.40228913000004],
              [92.10010826900003, 80.40436432500007],
              [92.56226647200003, 80.37946198100008],
              [92.62761478000004, 80.39154694200005],
              [92.36223392050005, 80.40521881700005],
              [92.09685306100005, 80.41889069200005],
              [92.01295006600003, 80.44033437700006],
              [91.92750084700003, 80.44839101800005],
              [91.88770592500003, 80.46039459800005],
              [91.91846764400003, 80.46841054900005],
              [92.27662194100003, 80.50946686400005],
              [92.74048912900008, 80.51300690300008],
              [92.76929772200003, 80.51675039300005],
              [92.79265384200005, 80.52928294500003],
              [92.79493248800003, 80.53530508000006],
              [92.79346764400003, 80.54140859600005],
              [92.79322350400008, 80.54743073100008],
              [92.80469811300003, 80.55784739800004],
              [92.81462649800005, 80.57566966400003],
              [92.82056725400008, 80.58392975500004],
              [92.81169681100005, 80.59125397300005],
              [92.80176842500003, 80.59589264500005],
              [92.79078209700003, 80.59780508000006],
              [92.77898196700005, 80.59690989800004],
              [92.78484134200005, 80.60394928600005],
              [92.79265384200005, 80.60932038000004],
              [92.81324303500003, 80.61741771000004],
              [92.82520592500003, 80.65062083500004],
              [92.88868248800003, 80.68048737200007],
              [93.23959394600007, 80.76943594000005],
              [93.27247155000003, 80.78253815300008],
              [93.27027428500003, 80.79710521000004],
              [92.89844811300003, 80.76203034100007],
              [92.75513756600003, 80.77570221600007],
              [92.73682701900003, 80.77252838700008],
              [92.70142662900008, 80.75844961100006],
              [92.68238366000003, 80.75519440300008],
              [92.53467858200008, 80.75307851800005],
              [92.50261478000004, 80.75861237200007],
              [92.49724368600005, 80.77570221600007],
              [92.52035566500007, 80.79218170800004],
              [92.55860436300003, 80.80267975500004],
              [92.62818444100003, 80.80988190300008],
              [92.63111412900008, 80.81366608300004],
              [92.67286217500003, 80.83405182500007],
              [92.68580162900008, 80.84267812700006],
              [92.70036868600005, 80.84853750200006],
              [92.71558678500003, 80.85138580900008],
              [92.73121178500003, 80.85146719000005],
              [92.72339928500003, 80.86420319200005],
              [92.70883222700007, 80.87262604400007],
              [92.69190514400003, 80.87734609600005],
              [92.67652428500003, 80.87872955900008],
              [92.71876061300003, 80.88800690300008],
              [92.80518639400003, 80.89179108300004],
              [92.88884524800005, 80.91058991100005],
              [93.10694420700008, 80.92072174700007],
              [93.14844811300003, 80.93073151200008],
              [93.16260826900003, 80.94696686400005],
              [93.14242597700007, 80.95770905200004],
              [93.07585696700005, 80.97345612200007],
              [93.07325280000003, 80.98798248900005],
              [93.05787194100003, 80.99428945500006],
              [93.05274498800003, 80.99542877800008],
              [93.47136478000004, 81.04389069200005],
              [93.65495853000004, 81.03229401200008],
              [93.66895592500003, 81.03440989800004],
              [93.67481530000003, 81.03790924700007],
              [93.67888431100005, 81.04291413000004],
              [93.68148847700007, 81.04767487200007],
              [93.68336022200003, 81.05003489800004],
              [93.69971764400003, 81.05402252800008],
              [94.05884850400008, 81.06903717700004],
              [94.16163170700003, 81.09247467700004],
              [94.38599694100003, 81.11408112200007],
              [94.55713951900003, 81.10398997600004],
              [94.88965905000003, 81.14435455900008],
              [95.03711998800003, 81.18793366100005],
              [95.10922285200007, 81.19635651200008],
              [95.18702233200003, 81.21759674700007],
              [95.54721113400007, 81.22077057500007],
              [95.51807701900003, 81.23029205900008],
              [95.06055748800003, 81.24164459800005],
              [95.03394616000003, 81.24868398600006],
              [95.10352623800003, 81.27130768400008],
              [95.44007408950003, 81.28005605650006],
              [95.77662194100003, 81.28880442900004],
              [95.83472741000003, 81.27594635600008],
              [95.89820397200003, 81.25169505400004],
              [95.99732506600003, 81.24249909100007],
              [96.02027428500003, 81.23444245000007],
              [95.96558678500003, 81.22280508000006],
              [95.95875084700003, 81.21454498900005],
              [95.96753991000003, 81.20502350500004],
              [95.98438561300003, 81.20091380400004],
              [96.13526451900003, 81.20246002800008],
              [96.17115319100003, 81.19342682500007],
              [96.15739993600005, 81.17983633000006],
              [96.18458092500003, 81.17145416900007],
              [96.24586022200003, 81.16673411700003],
              [96.27491295700003, 81.16107819200005],
              [96.27979576900003, 81.15721263200004],
              [96.28785241000003, 81.14398834800005],
              [96.29395592500003, 81.13882070500006],
              [96.55469811300003, 81.07737864800004],
              [96.53288821700005, 81.06464264500005],
              [96.53077233200003, 81.04633209800005],
              [96.54411868600005, 81.02985260600008],
              [96.56861412900008, 81.02277252800008],
              [96.73275800900007, 81.00844961100006],
              [96.71070397200003, 81.00210195500006],
              [96.66586347700007, 80.99648672100005],
              [96.64405358200003, 80.98798248900005],
              [96.66244550900007, 80.98065827000005],
              [96.68327884200005, 80.97601959800005],
              [96.70492597700007, 80.97394440300008],
              [96.72584069100003, 80.97431061400005],
              [96.71973717500003, 80.96751536700003],
              [96.76636803500003, 80.94993724200003],
              [96.86329186300003, 80.94257233300004],
              [96.91089928500003, 80.93333567900004],
              [96.95484459700003, 80.91058991100005],
              [96.97299238400007, 80.90607330900008],
              [97.42481530000003, 80.85146719000005],
              [97.42025800900007, 80.84833405200004],
              [97.41065514400003, 80.83714427300004],
              [97.56088300900007, 80.84202708500004],
              [97.65267988400007, 80.82868073100008],
              [97.75464928500003, 80.82929108300004],
              [97.78858483200003, 80.81663646000004],
              [97.75619550900007, 80.80288320500006],
              [97.74708092500003, 80.79621002800008],
              [97.78150475400008, 80.79559967700004],
              [97.81641686300003, 80.78961823100008],
              [97.88355553500003, 80.76947663000004],
              [97.85230553500003, 80.75543854400007],
              [97.78077233200003, 80.74982330900008],
              [97.74708092500003, 80.74160390800006],
            ],
          ],
          [
            [
              [57.26612389400003, 81.42682526200008],
              [57.01059004000004, 81.43836090700006],
              [56.75505618600005, 81.44989655200004],
              [56.74048912900008, 81.45351797100005],
              [56.76148522200003, 81.46515534100007],
              [56.79249108200008, 81.47231679900005],
              [56.935883009000065, 81.48281484600005],
              [56.98178144600007, 81.49323151200008],
              [57.00749759200005, 81.50873444200005],
              [56.991221550000034, 81.50983307500007],
              [56.97543379000007, 81.51284414300005],
              [56.946055535000085, 81.52240631700005],
              [57.01303144600007, 81.53681061400005],
              [57.48226972700007, 81.53335195500006],
              [57.51449629000007, 81.54291413000004],
              [57.50505618600005, 81.54767487200007],
              [57.494883660000085, 81.55060455900008],
              [57.48454837300005, 81.55141836100006],
              [57.51417076900003, 81.56000397300005],
              [57.78402754000007, 81.56476471600007],
              [57.823008660000085, 81.55027903900003],
              [57.803477410000085, 81.53876373900005],
              [57.79574629000007, 81.53607819200005],
              [57.813161655000044, 81.52924225500004],
              [57.84815514400003, 81.52228424700007],
              [57.864024285000085, 81.51618073100008],
              [57.85865319100009, 81.51129791900007],
              [57.84896894600007, 81.49970123900005],
              [57.84351647200003, 81.49506256700005],
              [57.88884524800005, 81.48558177300004],
              [58.14437910250007, 81.47988515850005],
              [58.39991295700008, 81.47418854400007],
              [58.54444420700008, 81.42999909100007],
              [58.57048587300005, 81.41315338700008],
              [58.517588738000086, 81.40277741100005],
              [58.41065514400003, 81.39622630400004],
              [58.305674675000034, 81.37689850500004],
              [58.05164635500006, 81.37789541250004],
              [57.797618035000085, 81.37889232000003],
              [57.65943444100009, 81.39935944200005],
              [57.60279381600009, 81.39516836100006],
              [57.57667076900003, 81.39887116100005],
              [57.567393425000034, 81.41571686400005],
              [57.56234785200007, 81.41998932500007],
              [57.545583530000044, 81.42446523600006],
              [57.43873131600009, 81.43773021000004],
              [57.26612389400003, 81.42682526200008],
            ],
          ],
          [
            [
              [62.50367272200003, 81.65277741100005],
              [62.51734459700003, 81.66014232000003],
              [62.106455925000034, 81.67324453300006],
              [62.106455925000034, 81.68008047100005],
              [62.16944420700008, 81.69334544500003],
              [62.19117272200003, 81.69424062700006],
              [62.22486412900008, 81.70184967700004],
              [62.461273634000065, 81.71649811400005],
              [62.53834069100003, 81.70571523600006],
              [62.64771569100003, 81.72162506700005],
              [62.804698113000086, 81.72162506700005],
              [62.786143425000034, 81.71263255400004],
              [62.765961134000065, 81.70661041900007],
              [63.22177168050007, 81.70079173400006],
              [63.67758222700007, 81.69497304900005],
              [63.80591881600003, 81.66014232000003],
              [63.780284050000034, 81.63890208500004],
              [63.74740644600007, 81.62376536700003],
              [63.71216881600003, 81.61473216400003],
              [63.467458530000044, 81.58905670800004],
              [63.29664147200003, 81.59878164300005],
              [63.21045983200008, 81.59271881700005],
              [62.95069420700008, 81.60344065950005],
              [62.69092858200008, 81.61416250200006],
              [62.61150149800005, 81.63056061400005],
              [62.533864780000044, 81.63792552300004],
              [62.50367272200003, 81.65277741100005],
            ],
          ],
          [
            [
              [58.29542076900003, 81.71417877800008],
              [57.98943118600005, 81.69013092700004],
              [57.891286655000044, 81.70795319200005],
              [57.89429772200003, 81.71556224200003],
              [57.898773634000065, 81.72272370000007],
              [57.904633009000065, 81.72919342700004],
              [57.91187584700003, 81.73468659100007],
              [57.928070509000065, 81.73358795800004],
              [57.934580925000034, 81.73969147300005],
              [57.938161655000044, 81.74835846600007],
              [57.945974155000044, 81.75519440300008],
              [57.96314537900008, 81.75971100500004],
              [58.145274285000085, 81.77684153900003],
              [58.09424889400003, 81.78473541900007],
              [57.98812910200007, 81.78725820500006],
              [57.93970787900008, 81.80361562700006],
              [57.97779381600009, 81.81663646000004],
              [58.06999759200005, 81.81704336100006],
              [58.15609785200007, 81.83026764500005],
              [58.50896243533341, 81.83974843933339],
              [58.86182701866674, 81.84922923366673],
              [59.21469160200007, 81.85871002800008],
              [59.30453535200007, 81.84296295800004],
              [59.403086785000085, 81.83657461100006],
              [59.43995201900003, 81.81781647300005],
              [59.41382897200003, 81.81679922100005],
              [59.38445071700005, 81.81024811400005],
              [59.33130944100009, 81.78986237200007],
              [59.362315300000034, 81.78058502800008],
              [59.37232506600009, 81.77374909100007],
              [59.37232506600009, 81.76264069200005],
              [59.35564212300005, 81.75332265800006],
              [59.002235005000045, 81.74027469800006],
              [58.64882788700004, 81.72722673800007],
              [58.29542076900003, 81.71417877800008],
            ],
          ],
          [
            [
              [150.8433310800001, 46.448224466000056],
              [150.84645675900003, 46.442049833000056],
              [150.832855665, 46.44086334800005],
              [150.8090926440001, 46.445746161000045],
              [150.78007698300007, 46.45715948600008],
              [150.783954902, 46.46270887500003],
              [150.7908596110001, 46.466186159000074],
              [150.7995849460001, 46.48009903500008],
              [150.80848058100003, 46.48643753400006],
              [150.81856076300005, 46.47811514300008],
              [150.8259099070001, 46.46521069400006],
              [150.83918878400004, 46.455078779000075],
              [150.8433310800001, 46.448224466000056],
            ],
          ],
          [
            [
              [154.83668053500003, 49.650051174000055],
              [154.85425866000003, 49.64398834800005],
              [154.8681746750001, 49.63239166900007],
              [154.88347415500004, 49.62482330900008],
              [154.90503991000003, 49.63080475500004],
              [154.90186608200008, 49.61225006700005],
              [154.88819420700008, 49.57754140800006],
              [154.88502037900003, 49.55849844000005],
              [154.8759871750001, 49.54352448100008],
              [154.8320418630001, 49.51707591400009],
              [154.81560306100005, 49.49982330900008],
              [154.82300866000003, 49.49359772300005],
              [154.8027449880001, 49.47866445500006],
              [154.79712975400003, 49.45697663000004],
              [154.8012801440001, 49.43301015800006],
              [154.81006920700008, 49.41107819200005],
              [154.81470787900003, 49.40501536700003],
              [154.82740319100003, 49.39337799700007],
              [154.82984459700003, 49.38686758000006],
              [154.8281356130001, 49.38104889500005],
              [154.8247176440001, 49.37677643400008],
              [154.82309004, 49.37246328300006],
              [154.83464603000004, 49.352728583000044],
              [154.83187910200002, 49.343736070000034],
              [154.81560306100005, 49.32916901200008],
              [154.81364993600005, 49.32217031500005],
              [154.81511478000004, 49.31586334800005],
              [154.81511478000004, 49.310207424000055],
              [154.80884850400003, 49.30491771000004],
              [154.78435306100005, 49.294582424000055],
              [154.778656446, 49.29096100500004],
              [154.770355665, 49.287095445000034],
              [154.7504988940001, 49.28856028900009],
              [154.74105879, 49.287543036000045],
              [154.73511803500003, 49.28339264500005],
              [154.72193444100003, 49.26984284100007],
              [154.71998131600003, 49.26703522300005],
              [154.69947350400003, 49.26536692900004],
              [154.67920983200008, 49.26870351800005],
              [154.61255944100003, 49.28937409100007],
              [154.6059676440001, 49.292669989000046],
              [154.60303795700008, 49.297756252000056],
              [154.60279381600003, 49.30341217700004],
              [154.6059676440001, 49.31513092700004],
              [154.60718834700003, 49.326157945000034],
              [154.603851759, 49.35927969000005],
              [154.60824629, 49.374986070000034],
              [154.6274520190001, 49.39321523600006],
              [154.63835696700005, 49.424261786000045],
              [154.65381920700008, 49.43732330900008],
              [154.6865340500001, 49.45888906500005],
              [154.69678795700008, 49.47138092700004],
              [154.7036238940001, 49.48346588700008],
              [154.71371504, 49.50665924700007],
              [154.72388756600003, 49.51902903900009],
              [154.7544051440001, 49.548529364000046],
              [154.76099694100003, 49.55849844000005],
              [154.7587996750001, 49.56663646000004],
              [154.74952233200008, 49.578558661000045],
              [154.74732506600003, 49.58551666900007],
              [154.7509871750001, 49.59564850500004],
              [154.76002037900003, 49.60028717700004],
              [154.77027428500003, 49.602769273000035],
              [154.778656446, 49.60659414300005],
              [154.82309004, 49.64520905200004],
              [154.83668053500003, 49.650051174000055],
            ],
          ],
          [
            [
              [59.03435306100005, 75.95986562700006],
              [59.06861412900008, 75.96820709800005],
              [59.14014733200008, 75.97565338700008],
              [59.200205925000034, 75.98924388200004],
              [59.23414147200003, 75.99066803600005],
              [59.26002037900008, 75.98407623900005],
              [59.262461785000085, 75.96539948100008],
              [59.23715254000007, 75.94822825700004],
              [59.19890384200005, 75.94379303600005],
              [59.158946160000085, 75.94403717700004],
              [59.09327233200008, 75.93402741100005],
              [59.02125084700003, 75.93207428600005],
              [58.951508009000065, 75.91844310100004],
              [58.87859134200005, 75.91474030200004],
              [58.81031334700003, 75.90208567900004],
              [58.72413170700008, 75.89704010600008],
              [58.69320722700007, 75.90326569200005],
              [58.73170006600009, 75.91689687700006],
              [58.991221550000034, 75.94798411700003],
              [59.03435306100005, 75.95986562700006],
            ],
          ],
          [
            [
              [59.00171959700003, 79.98061758000006],
              [58.79273522200003, 80.01105377800008],
              [58.76872806100005, 80.02106354400007],
              [58.77857506600009, 80.03742096600007],
              [58.79639733200008, 80.04364655200004],
              [59.16277102950008, 80.08228180550006],
              [59.52914472700007, 80.12091705900008],
              [59.59034264400003, 80.10858795800004],
              [59.78630618600005, 80.09418366100005],
              [59.809580925000034, 80.08893463700008],
              [59.83130944100009, 80.08022695500006],
              [59.84156334700003, 80.07074616100005],
              [59.84197024800005, 80.06102122600004],
              [59.83969160200007, 80.05239492400005],
              [59.84115644600007, 80.04580312700006],
              [59.84498131600009, 80.03729889500005],
              [59.838552280000044, 80.03286367400005],
              [59.83611087300005, 80.02728913000004],
              [59.85141035200007, 80.01536692900004],
              [59.87086022200003, 80.00926341400003],
              [59.90984134200005, 80.00560130400004],
              [59.92725670700008, 79.99485911700003],
              [59.86247806100005, 79.98834870000007],
              [59.73755944100009, 79.95986562700006],
              [59.542979363000086, 79.93964264500005],
              [59.47632897200003, 79.94867584800005],
              [59.44068444100009, 79.94806549700007],
              [59.43311608200008, 79.93341705900008],
              [59.402679884000065, 79.92186107000003],
              [59.372080925000034, 79.91966380400004],
              [59.20679772200003, 79.92890045800004],
              [59.17367597700007, 79.93964264500005],
              [59.18116295700008, 79.94253164300005],
              [59.20036868600005, 79.95331452000005],
              [59.15162194100009, 79.95490143400008],
              [59.00171959700003, 79.98061758000006],
            ],
          ],
          [
            [
              [55.71208743600005, 80.10346100500004],
              [56.01905358200008, 80.18183014500005],
              [56.047862175000034, 80.20034414300005],
              [56.007823113000086, 80.21222565300008],
              [55.99390709700003, 80.21336497600004],
              [56.002614780000044, 80.22972239800004],
              [56.00757897200003, 80.23509349200003],
              [55.99439537900008, 80.24335358300004],
              [55.96607506600009, 80.25165436400005],
              [55.95232181100005, 80.26178620000007],
              [55.97738691500007, 80.27952708500004],
              [55.98796634200005, 80.29035065300008],
              [55.99390709700003, 80.30272044500003],
              [55.990896030000044, 80.30707428600005],
              [55.97584069100009, 80.31932200700004],
              [55.97282962300005, 80.32318756700005],
              [55.979502800000034, 80.33307526200008],
              [55.989268425000034, 80.33665599200003],
              [56.129893425000034, 80.35122304900005],
              [56.38632246150004, 80.33787669500006],
              [56.64275149800005, 80.32453034100007],
              [56.692149285000085, 80.34369538000004],
              [56.69027754000007, 80.36009349200003],
              [56.71225019600007, 80.36835358300004],
              [57.02198326900003, 80.36399974200003],
              [57.097666863000086, 80.34516022300005],
              [57.13103274800005, 80.30613841400003],
              [57.12549889400003, 80.29637278900003],
              [57.086599155000044, 80.27228424700007],
              [57.08366946700005, 80.25812409100007],
              [57.08871504000007, 80.23843008000006],
              [57.09888756600009, 80.22089264500005],
              [57.11060631600009, 80.21336497600004],
              [57.13217207100007, 80.21190013200004],
              [57.14893639400003, 80.20722077000005],
              [57.15357506600009, 80.19896067900004],
              [57.13843834700003, 80.18671295800004],
              [57.11931399800005, 80.17967357000003],
              [57.05437259200005, 80.16779205900008],
              [57.046885613000086, 80.15436432500007],
              [57.072927280000044, 80.13715241100005],
              [57.11068769600007, 80.12295156500005],
              [57.13843834700003, 80.11782461100006],
              [57.117930535000085, 80.09601471600007],
              [57.07748457100007, 80.08299388200004],
              [56.95679772200003, 80.06631094000005],
              [56.62072458833338, 80.07035282366672],
              [56.28465145466672, 80.0743947073334],
              [55.94857832100007, 80.07843659100007],
              [55.75961347700007, 80.10431549700007],
              [55.71208743600005, 80.10346100500004],
            ],
          ],
          [
            [
              [52.62289472700007, 80.18329498900005],
              [52.60132897200003, 80.19940827000005],
              [52.35661868600005, 80.20868561400005],
              [52.304698113000086, 80.22272370000007],
              [52.18287194100009, 80.27606842700004],
              [52.20557701900003, 80.28278229400007],
              [52.25513756600009, 80.28449127800008],
              [52.30551191500007, 80.29291413000004],
              [52.56885826900003, 80.28949616100005],
              [52.59555097700007, 80.29531484600005],
              [52.58904056100005, 80.30898672100005],
              [52.60043379000007, 80.31513092700004],
              [52.70728600400008, 80.31818268400008],
              [52.73096764400003, 80.32318756700005],
              [52.73096764400003, 80.33002350500004],
              [52.71599368600005, 80.33112213700008],
              [52.69898522200003, 80.33551666900007],
              [52.686289910000085, 80.34414297100005],
              [52.684336785000085, 80.35797760600008],
              [52.698252800000034, 80.36774323100008],
              [52.77100670700008, 80.38027578300006],
              [52.85954837300005, 80.40546295800004],
              [52.90593509200005, 80.41258372600004],
              [52.95053144600007, 80.41258372600004],
              [53.02173912900008, 80.39996979400007],
              [53.046885613000086, 80.39899323100008],
              [53.14958743600005, 80.41258372600004],
              [53.293711785000085, 80.40863678600005],
              [53.34107506600009, 80.39899323100008],
              [53.322927280000044, 80.37872955900008],
              [53.34880618600005, 80.36054108300004],
              [53.531993035000085, 80.30955638200004],
              [53.86182701900003, 80.27606842700004],
              [53.869476759000065, 80.27094147300005],
              [53.855804884000065, 80.25967031500005],
              [53.82081139400003, 80.24127838700008],
              [53.763682488000086, 80.22264232000003],
              [53.733409050000034, 80.21767812700006],
              [53.70476321700005, 80.22077057500007],
              [53.68921959700003, 80.22846100500004],
              [53.67725670700008, 80.23749420800004],
              [53.66391035200007, 80.24494049700007],
              [53.64405358200008, 80.24811432500007],
              [53.617930535000085, 80.24677155200004],
              [53.589854363000086, 80.24237702000005],
              [53.56267337300005, 80.23403554900005],
              [53.539724155000044, 80.22077057500007],
              [53.531260613000086, 80.21100495000007],
              [53.52125084700003, 80.18939850500004],
              [53.51295006600009, 80.17987702000005],
              [53.48991946700005, 80.17182038000004],
              [53.06747480550004, 80.17206452050004],
              [52.64503014400003, 80.17230866100005],
              [52.62289472700007, 80.18329498900005],
            ],
          ],
          [
            [
              [57.52881920700008, 80.13141510600008],
              [57.42628014400003, 80.12775299700007],
              [57.39820397200003, 80.13483307500007],
              [57.378916863000086, 80.14337799700007],
              [57.29021243600005, 80.16901276200008],
              [57.277679884000065, 80.17837148600006],
              [57.28060957100007, 80.19041575700004],
              [57.30225670700008, 80.20718008000006],
              [57.28443444100009, 80.21930573100008],
              [57.24008222700007, 80.23187897300005],
              [57.219737175000034, 80.24127838700008],
              [57.247080925000034, 80.25153229400007],
              [57.26539147200003, 80.26886627800008],
              [57.265961134000065, 80.28603750200006],
              [57.240244988000086, 80.29531484600005],
              [57.254649285000085, 80.31574127800008],
              [57.25896243600005, 80.32587311400005],
              [57.253916863000086, 80.33372630400004],
              [57.20753014400003, 80.35394928600005],
              [57.192393425000034, 80.36420319200005],
              [57.274424675000034, 80.39154694200005],
              [57.242849155000044, 80.41152578300006],
              [57.20655358200008, 80.42462799700007],
              [56.946055535000085, 80.48151276200008],
              [57.322642449000085, 80.47815582850008],
              [57.699229363000086, 80.47479889500008],
              [58.07581627700009, 80.47144196150008],
              [58.45240319100009, 80.46808502800008],
              [58.56470787900008, 80.45050690300008],
              [58.680430535000085, 80.44603099200003],
              [58.774180535000085, 80.42816803600005],
              [58.89869225400008, 80.42690664300005],
              [59.193369988000086, 80.37848541900007],
              [59.21216881600009, 80.37274811400005],
              [59.23943118600005, 80.35919830900008],
              [59.264333530000044, 80.34320709800005],
              [59.276133660000085, 80.33002350500004],
              [58.93348229250006, 80.33378733950005],
              [58.590830925000034, 80.33755117400005],
              [58.58757571700005, 80.32119375200006],
              [58.55787194100009, 80.31525299700007],
              [58.42505944100009, 80.32217031500005],
              [58.390961134000065, 80.32021719000005],
              [58.32203209700003, 80.30361562700006],
              [58.19459069100009, 80.29132721600007],
              [58.15756269600007, 80.28367747600004],
              [58.13843834700003, 80.28229401200008],
              [58.121836785000085, 80.27887604400007],
              [58.092784050000034, 80.26434967700004],
              [58.076914910000085, 80.26178620000007],
              [58.09327233200008, 80.24799225500004],
              [58.12330162900008, 80.24213288000004],
              [58.42937259200005, 80.24188873900005],
              [58.46062259200005, 80.23509349200003],
              [58.47486412900008, 80.22235748900005],
              [58.46705162900008, 80.20945872600004],
              [58.42628014400003, 80.18671295800004],
              [58.43279056100005, 80.18561432500007],
              [58.44678795700008, 80.17987702000005],
              [58.40650475400008, 80.16559479400007],
              [58.25131269600007, 80.18671295800004],
              [58.142588738000086, 80.18024323100008],
              [58.08619225400008, 80.18329498900005],
              [58.075205925000034, 80.18549225500004],
              [58.06999759200005, 80.18732330900008],
              [58.065114780000044, 80.18988678600005],
              [58.05209394600007, 80.20209381700005],
              [58.04656009200005, 80.20490143400008],
              [58.041351759000065, 80.20575592700004],
              [57.95671634200005, 80.19721100500004],
              [57.933604363000086, 80.19220612200007],
              [57.913096550000034, 80.18406810100004],
              [57.905039910000085, 80.17243073100008],
              [57.914398634000065, 80.16339752800008],
              [57.95630944100009, 80.15424225500004],
              [57.97046959700003, 80.14850495000007],
              [57.978526238000086, 80.13597239800004],
              [57.98218834700003, 80.12543366100005],
              [57.990977410000085, 80.11709219000005],
              [58.01490319100009, 80.11098867400005],
              [57.97046959700003, 80.09894440300008],
              [57.71306399800005, 80.09882233300004],
              [57.56568444100009, 80.12860748900005],
              [57.52881920700008, 80.13141510600008],
            ],
          ],
          [
            [
              [53.79802493600005, 80.47288646000004],
              [53.853851759000065, 80.48212311400005],
              [53.83757571700005, 80.50511302300004],
              [53.84750410200007, 80.51019928600005],
              [53.85906009200005, 80.51113515800006],
              [53.88266035200007, 80.51007721600007],
              [53.97291100400008, 80.52928294500003],
              [53.94304446700005, 80.53888580900008],
              [53.85873457100007, 80.55442942900004],
              [53.84131920700008, 80.57367584800005],
              [53.853526238000086, 80.60008372600004],
              [53.88331139400003, 80.61074453300006],
              [54.26905358200008, 80.58869049700007],
              [54.31495201900003, 80.57709381700005],
              [54.220713738000086, 80.57835521000004],
              [54.17042076900003, 80.57257721600007],
              [54.13607832100007, 80.55597565300008],
              [54.16521243600005, 80.54791901200008],
              [54.40984134200005, 80.54291413000004],
              [54.387054884000065, 80.52496979400007],
              [54.401052280000044, 80.51487864800004],
              [54.45826256600009, 80.50136953300006],
              [54.45720462300005, 80.49005768400008],
              [54.458994988000086, 80.48647695500006],
              [54.46509850400008, 80.48151276200008],
              [54.44906660200007, 80.47077057500007],
              [54.42986087300005, 80.46442291900007],
              [54.40902754000007, 80.46124909100007],
              [54.38949629000007, 80.46039459800005],
              [54.36939537900008, 80.45636627800008],
              [54.35718834700003, 80.44700755400004],
              [54.34717858200008, 80.43634674700007],
              [54.33383222700007, 80.42853424700007],
              [54.28825931100005, 80.42035553600005],
              [54.239024285000085, 80.42015208500004],
              [53.79802493600005, 80.47288646000004],
            ],
          ],
          [
            [
              [60.256195509000065, 81.03636302300004],
              [60.30453535200007, 81.05121491100005],
              [60.50831139400003, 81.06903717700004],
              [60.61280358200008, 81.09247467700004],
              [60.96851647266675, 81.09955475500004],
              [61.324229363333416, 81.10663483300004],
              [61.67994225400008, 81.11371491100005],
              [61.70167076900003, 81.10529205900008],
              [61.67725670700008, 81.10370514500005],
              [61.651377800000034, 81.09845612200007],
              [61.62671959700003, 81.08958567900004],
              [61.606211785000085, 81.07737864800004],
              [61.621429884000065, 81.07387929900005],
              [61.628916863000086, 81.06598541900007],
              [61.62826582100007, 81.05512116100005],
              [61.619883660000085, 81.04262929900005],
              [61.59978274800005, 81.03139883000006],
              [61.29379316500007, 80.97671133000006],
              [60.98780358200008, 80.92202383000006],
              [60.66553795700008, 80.93528880400007],
              [60.34327233200008, 80.94855377800008],
              [60.25440514400003, 80.97211334800005],
              [60.06999759200005, 80.97964101800005],
              [60.02271569100009, 80.99542877800008],
              [60.06226647200003, 81.00828685100004],
              [60.20826256600009, 81.02277252800008],
              [60.256195509000065, 81.03636302300004],
            ],
          ],
          [
            [
              [62.770518425000034, 80.88556549700007],
              [62.88249759200005, 80.89801666900007],
              [62.938161655000044, 80.91022370000007],
              [63.03646894600007, 80.94887929900005],
              [63.14226321700005, 80.97138092700004],
              [63.58936608150006, 80.97913239150006],
              [64.03646894600007, 80.98688385600008],
              [64.16911868600005, 81.01019928600005],
              [64.18604576900003, 81.01902903900003],
              [64.19288170700008, 81.03139883000006],
              [64.19646243600005, 81.04364655200004],
              [64.20240319100003, 81.05316803600005],
              [64.21680748800009, 81.05687083500004],
              [64.19874108200008, 81.07074616100005],
              [64.17750084700003, 81.07607656500005],
              [64.13266035200007, 81.08242422100005],
              [64.12037194100003, 81.09357330900008],
              [64.13257897200003, 81.10529205900008],
              [64.15463300900007, 81.11456940300008],
              [64.19019616000008, 81.12152741100005],
              [64.20630944100003, 81.12970612200007],
              [64.23731530000003, 81.15184153900003],
              [64.25586998800009, 81.16225820500006],
              [64.27475019600007, 81.16913483300004],
              [64.42286217500003, 81.19383372600004],
              [64.70484459700003, 81.20526764500005],
              [64.78541100400008, 81.19098541900007],
              [64.86793053500008, 81.19342682500007],
              [65.22982832100007, 81.13670482000003],
              [65.26107832100007, 81.12396881700005],
              [65.37525475400008, 81.06028880400004],
              [65.41684004000007, 81.04608795800004],
              [65.43628991000008, 81.03705475500004],
              [65.45004316500007, 81.02277252800008],
              [65.30616295700008, 80.99542877800008],
              [65.35010826900003, 80.99310944200005],
              [65.38868248800009, 80.98615143400008],
              [65.42302493600005, 80.97247955900008],
              [65.45386803500008, 80.95042552300004],
              [65.46566816500007, 80.93488190300008],
              [65.46168053500008, 80.92548248900005],
              [65.44581139400003, 80.91962311400005],
              [65.15455162900008, 80.84992096600007],
              [65.07829837300005, 80.84137604400007],
              [65.06137129000007, 80.83344147300005],
              [65.04558353000004, 80.82371653900003],
              [65.02654056100005, 80.81488678600005],
              [64.99976647200003, 80.80882396000004],
              [64.66895592500003, 80.77643463700008],
              [64.58668053500008, 80.75519440300008],
              [64.50261478000004, 80.75531647300005],
              [64.42562910200007, 80.74087148600006],
              [64.10039309950005, 80.72721995650005],
              [63.77515709700003, 80.71356842700004],
              [63.68580162900008, 80.72728099200003],
              [63.40825442800008, 80.70518626550003],
              [63.13070722700007, 80.68309153900003],
              [62.87362714900007, 80.74058665600003],
              [62.61654707100007, 80.79808177300004],
              [62.53077233200008, 80.80475495000007],
              [62.510508660000085, 80.81012604400007],
              [62.50367272200003, 80.82412344000005],
              [62.50863691500007, 80.83417389500005],
              [62.518239780000044, 80.84031810100004],
              [62.52979576900003, 80.84381745000007],
              [62.770518425000034, 80.88556549700007],
            ],
          ],
          [
            [
              [57.33619225400008, 81.20526764500005],
              [57.39730879000007, 81.21629466400003],
              [57.61158287900008, 81.22280508000006],
              [57.670664910000085, 81.23187897300005],
              [57.79542076900003, 81.23395416900007],
              [57.88786868600005, 81.24555084800005],
              [57.957774285000085, 81.24420807500007],
              [58.02654056100005, 81.23403554900005],
              [58.08375084700003, 81.21454498900005],
              [57.85181725400008, 81.19013092700004],
              [57.77076256600009, 81.14801666900007],
              [57.70045006600009, 81.13715241100005],
              [57.38982181100005, 81.12376536700003],
              [56.99439537900008, 81.16616445500006],
              [57.028005405000044, 81.17885976800005],
              [57.06853274800005, 81.18427155200004],
              [57.24203535200007, 81.18943919500003],
              [57.33619225400008, 81.20526764500005],
            ],
          ],
          [
            [
              [55.646820509000065, 81.20026276200008],
              [55.610362175000034, 81.20294830900008],
              [55.57504316500007, 81.21222565300008],
              [55.560557488000086, 81.22308991100005],
              [55.567067905000044, 81.23273346600007],
              [55.580739780000044, 81.23956940300008],
              [55.588633660000085, 81.24188873900005],
              [55.58326256600009, 81.25381094000005],
              [55.58611087300005, 81.26361725500004],
              [55.59538821700005, 81.27114492400005],
              [55.60906009200005, 81.27594635600008],
              [55.431651238000086, 81.27594635600008],
              [55.431651238000086, 81.28343333500004],
              [55.45883222700007, 81.28807200700004],
              [55.51449629000007, 81.28949616100005],
              [55.54078209700003, 81.29710521000004],
              [55.52328535200007, 81.30695221600007],
              [55.48422285200007, 81.31525299700007],
              [55.46566816500007, 81.32440827000005],
              [55.58545983200008, 81.31696198100008],
              [55.71208743600005, 81.33055247600004],
              [55.705821160000085, 81.32440827000005],
              [55.73414147200003, 81.31704336100006],
              [55.764333530000044, 81.31537506700005],
              [55.834727410000085, 81.32477448100008],
              [55.86963951900003, 81.32440827000005],
              [55.88445071700005, 81.32192617400005],
              [55.89405358200008, 81.31663646000004],
              [55.89869225400008, 81.31159088700008],
              [55.89771569100009, 81.31012604400007],
              [55.95362389400003, 81.30084870000007],
              [56.07447350400008, 81.30194733300004],
              [56.21599368600005, 81.27724844000005],
              [56.54476972700007, 81.25478750200006],
              [56.60279381600009, 81.26170482000003],
              [56.60279381600009, 81.26911041900007],
              [56.57211347700007, 81.26972077000005],
              [56.472992384000065, 81.28969961100006],
              [56.41334069100009, 81.31834544500003],
              [56.39112389400003, 81.32440827000005],
              [56.418304884000065, 81.33808014500005],
              [56.40748131600009, 81.34430573100008],
              [56.38331139400003, 81.35004303600005],
              [56.373789910000085, 81.35516998900005],
              [56.35922285200007, 81.37400950700004],
              [56.35084069100009, 81.37946198100008],
              [56.335948113000086, 81.37905508000006],
              [56.335948113000086, 81.38519928600005],
              [56.72624759200005, 81.39716217700004],
              [56.78101647200003, 81.38519928600005],
              [56.76099694100009, 81.37905508000006],
              [56.789073113000086, 81.36847565300008],
              [56.82667076900003, 81.36912669500003],
              [56.89820397200003, 81.37905508000006],
              [57.15345299550003, 81.36009349150007],
              [57.40870201900003, 81.34113190300008],
              [57.422862175000034, 81.33649323100008],
              [57.44752037900008, 81.32225169500003],
              [57.459971550000034, 81.31696198100008],
              [57.498789910000085, 81.31232330900008],
              [57.617523634000065, 81.33055247600004],
              [57.68873131600009, 81.33112213700008],
              [57.905039910000085, 81.29710521000004],
              [57.81080162900008, 81.27464427300004],
              [57.42916914200006, 81.26394277550006],
              [57.047536655000044, 81.25324127800008],
              [56.70834394600007, 81.20392487200007],
              [56.61451256600009, 81.17853424700007],
              [56.43116295700008, 81.17446523600006],
              [56.38363691500007, 81.17983633000006],
              [56.38998457100007, 81.20376211100006],
              [56.343760613000086, 81.21857330900008],
              [56.24040774800005, 81.22821686400005],
              [55.82439212300005, 81.18646881700005],
              [55.73959394600007, 81.20115794500003],
              [55.646820509000065, 81.20026276200008],
            ],
          ],
          [
            [
              [58.563487175000034, 81.32440827000005],
              [58.510508660000085, 81.32111237200007],
              [58.481211785000085, 81.32363515800006],
              [58.46412194100009, 81.33494700700004],
              [58.469493035000085, 81.34747955900008],
              [58.492523634000065, 81.35187409100007],
              [58.536143425000034, 81.35175202000005],
              [58.66920006600009, 81.38157786700003],
              [59.017914259000065, 81.40338776200008],
              [59.109711134000065, 81.39740631700005],
              [59.13949629000007, 81.39105866100005],
              [59.157237175000034, 81.38670482000003],
              [59.24594160200007, 81.37653229400007],
              [59.30014082100007, 81.36420319200005],
              [59.35694420700008, 81.34430573100008],
              [59.385427280000044, 81.33055247600004],
              [59.342458530000044, 81.30426666900007],
              [59.285166863000086, 81.30003489800004],
              [59.22486412900008, 81.30390045800004],
              [59.05437259200005, 81.28705475500004],
              [58.654633009000065, 81.30658600500004],
              [58.59392337300005, 81.32111237200007],
              [58.563487175000034, 81.32440827000005],
            ],
          ],
          [
            [
              [61.90365644600007, 81.60492584800005],
              [62.01099694100003, 81.60293203300006],
              [62.07504316500007, 81.58999258000006],
              [62.14112389400003, 81.58608633000006],
              [62.17408287900008, 81.57762278900003],
              [62.196299675000034, 81.56484609600005],
              [62.186289910000085, 81.55931224200003],
              [62.06804446700005, 81.54730866100005],
              [61.828135613000086, 81.56439850500004],
              [61.71265709700003, 81.59707265800006],
              [61.65398196700005, 81.60492584800005],
              [61.684336785000085, 81.61041901200008],
              [61.90365644600007, 81.60492584800005],
            ],
          ],
          [
            [
              [40.45492597700007, 64.58185455900008],
              [40.45826256600009, 64.57802969000005],
              [40.46119225400008, 64.57387929900005],
              [40.457774285000085, 64.56826406500005],
              [40.435557488000086, 64.56415436400005],
              [40.335948113000086, 64.57416413000004],
              [40.19483483200008, 64.57416413000004],
              [40.14698326900009, 64.59174225500004],
              [40.130869988000086, 64.61399974200003],
              [40.11101321700005, 64.63035716400003],
              [40.06959069100009, 64.64801666900007],
              [40.054698113000086, 64.65253327000005],
              [40.021820509000065, 64.65867747600004],
              [39.93832441500007, 64.66278717700004],
              [39.92017662900008, 64.66718170800004],
              [39.87134850400008, 64.68402741100005],
              [39.854502800000034, 64.68349844000005],
              [39.84034264400009, 64.68158600500004],
              [39.824229363000086, 64.67975495000007],
              [39.832692905000044, 64.68976471600007],
              [39.85531660200007, 64.69916413000004],
              [39.90552819100009, 64.71039459800005],
              [39.98422285200007, 64.71922435100004],
              [40.00049889400009, 64.71800364800004],
              [40.01677493600005, 64.71027252800008],
              [40.04322350400008, 64.70087311400005],
              [40.080739780000044, 64.69993724200003],
              [40.15064537900008, 64.70941803600005],
              [40.188487175000034, 64.70823802300004],
              [40.22836347700007, 64.69989655200004],
              [40.25359134200005, 64.68886953300006],
              [40.26335696700005, 64.67869700700004],
              [40.26807701900009, 64.65623607000003],
              [40.30225670700008, 64.63548411700003],
              [40.35132897200003, 64.62018463700008],
              [40.39730879000007, 64.61863841400003],
              [40.43140709700003, 64.61269765800006],
              [40.44743899800005, 64.60016510600008],
              [40.45004316500007, 64.59039948100008],
              [40.45492597700007, 64.58185455900008],
            ],
          ],
          [
            [
              [40.001963738000086, 64.73737213700008],
              [39.980479363000086, 64.72943756700005],
              [39.943695509000065, 64.72797272300005],
              [39.94971764400009, 64.74192942900004],
              [39.98658287900008, 64.74347565300008],
              [40.001963738000086, 64.73737213700008],
            ],
          ],
          [
            [
              [40.145192905000044, 64.73427969000005],
              [40.07553144600007, 64.75702545800004],
              [40.03484134200005, 64.76056549700007],
              [40.05014082100007, 64.76927317900004],
              [40.11068769600007, 64.78119538000004],
              [40.22242272200003, 64.78392161700003],
              [40.33350670700008, 64.77240631700005],
              [40.36353600400008, 64.75820547100005],
              [40.38786868600005, 64.73574453300006],
              [40.40056399800005, 64.71124909100007],
              [40.40251712300005, 64.66250234600005],
              [40.405284050000034, 64.65180084800005],
              [40.40674889400009, 64.64248281500005],
              [40.39600670700008, 64.62913646000004],
              [40.36939537900008, 64.62811920800004],
              [40.32569420700008, 64.63764069200005],
              [40.305349155000044, 64.65045807500007],
              [40.285492384000065, 64.67332591400003],
              [40.25220787900008, 64.69891998900005],
              [40.201833530000044, 64.71995677300004],
              [40.17554772200003, 64.72809479400007],
              [40.145192905000044, 64.73427969000005],
            ],
          ],
          [
            [
              [36.01295006600009, 65.05170319200005],
              [36.02393639400009, 65.04572174700007],
              [36.02564537900008, 65.03656647300005],
              [36.01726321700005, 65.02903880400004],
              [36.00513756600009, 65.02651601800005],
              [35.95655358200008, 65.02558014500005],
              [35.920583530000044, 65.02118561400005],
              [35.90601647200009, 65.02179596600007],
              [35.89991295700008, 65.02655670800004],
              [35.89771569100009, 65.03286367400005],
              [35.89185631600009, 65.04071686400005],
              [35.89975019600007, 65.04718659100007],
              [35.92741946700005, 65.05410390800006],
              [35.955414259000065, 65.05438873900005],
              [35.963226759000065, 65.05548737200007],
              [35.97413170700008, 65.05605703300006],
              [35.99577884200005, 65.05512116100005],
              [36.006602410000085, 65.05365631700005],
              [36.01295006600009, 65.05170319200005],
            ],
          ],
          [
            [
              [36.21143639400009, 65.15827057500007],
              [36.24976647200009, 65.15932851800005],
              [36.26099694100009, 65.15452708500004],
              [36.23617597700007, 65.14590078300006],
              [36.201914910000085, 65.13886139500005],
              [36.13689212300005, 65.13764069200005],
              [36.097992384000065, 65.13056061400005],
              [36.07569420700008, 65.13117096600007],
              [36.07398522200009, 65.12738678600005],
              [36.06609134200005, 65.12514883000006],
              [36.046885613000086, 65.12689850500004],
              [36.03077233200008, 65.13068268400008],
              [36.02466881600009, 65.13279857000003],
              [35.95199629000007, 65.14638906500005],
              [35.94223066500007, 65.15460846600007],
              [35.943369988000086, 65.16811758000006],
              [35.949880405000044, 65.18097565300008],
              [35.96656334700009, 65.18838125200006],
              [35.99040774800005, 65.19122955900008],
              [35.99244225400008, 65.18927643400008],
              [35.99008222700007, 65.18353913000004],
              [35.99740644600007, 65.18451569200005],
              [36.00912519600007, 65.18378327000005],
              [36.02361087300005, 65.17767975500004],
              [36.03663170700008, 65.16998932500007],
              [36.049489780000044, 65.16571686400005],
              [36.05551191500007, 65.16205475500004],
              [36.05884850400008, 65.15867747600004],
              [36.06918379000007, 65.15729401200008],
              [36.191742384000065, 65.15525950700004],
              [36.21143639400009, 65.15827057500007],
            ],
          ],
          [
            [
              [54.32976321700005, 68.31146881700005],
              [54.340505405000044, 68.30670807500007],
              [54.343760613000086, 68.29279205900008],
              [54.338552280000044, 68.27643463700008],
              [54.32545006600009, 68.26365794500003],
              [54.31690514400003, 68.25910065300008],
              [54.22095787900008, 68.24518463700008],
              [54.20484459700003, 68.24900950700004],
              [54.19947350400008, 68.25649648600006],
              [54.197276238000086, 68.26227448100008],
              [54.199554884000065, 68.26532623900005],
              [54.201182488000086, 68.27045319200005],
              [54.20093834700003, 68.27850983300004],
              [54.21273847700007, 68.29108307500007],
              [54.23943118600005, 68.30377838700008],
              [54.30290774800005, 68.32737864800004],
              [54.32976321700005, 68.33124420800004],
              [54.338877800000034, 68.32705312700006],
              [54.32504316500007, 68.32168203300006],
              [54.301442905000044, 68.31631094000005],
              [54.29656009200005, 68.31391022300005],
              [54.308604363000086, 68.31403229400007],
              [54.31861412900008, 68.31232330900008],
              [54.32976321700005, 68.31146881700005],
            ],
          ],
          [
            [
              [53.91228274800005, 68.36196523600006],
              [53.966807488000086, 68.35809967700004],
              [53.99146569100009, 68.34585195500006],
              [53.98519941500007, 68.32420482000003],
              [53.957692905000044, 68.29336172100005],
              [53.91968834700003, 68.28754303600005],
              [53.887380405000044, 68.29677969000005],
              [53.86573326900003, 68.30695221600007],
              [53.85873457100007, 68.31818268400008],
              [53.856211785000085, 68.32933177300004],
              [53.85320071700005, 68.33714427300004],
              [53.85792076900003, 68.34552643400008],
              [53.873057488000086, 68.35199616100005],
              [53.88209069100009, 68.35358307500007],
              [53.91228274800005, 68.36196523600006],
            ],
          ],
          [
            [
              [49.04908287900008, 68.67841217700004],
              [49.073008660000085, 68.67597077000005],
              [49.12427819100009, 68.66766998900005],
              [49.12037194100009, 68.66299062700006],
              [48.76587975400008, 68.69037506700005],
              [48.765961134000065, 68.69660065300008],
              [48.81234785200007, 68.69651927300004],
              [49.04908287900008, 68.67841217700004],
            ],
          ],
          [
            [
              [49.57927493600005, 68.81928131700005],
              [49.594737175000034, 68.82037995000007],
              [49.59848066500007, 68.81476471600007],
              [49.59107506600009, 68.80866120000007],
              [49.55046634200005, 68.79511139500005],
              [49.49919681100005, 68.78558991100005],
              [49.49195397200003, 68.79242584800005],
              [49.553070509000065, 68.81098053600005],
              [49.570323113000086, 68.81708405200004],
              [49.57927493600005, 68.81928131700005],
            ],
          ],
          [
            [
              [54.26677493600005, 68.81683991100005],
              [54.37484785200007, 68.79096100500004],
              [54.39535566500007, 68.78253815300008],
              [54.386729363000086, 68.77838776200008],
              [54.22820071700005, 68.79621002800008],
              [54.21029707100007, 68.80149974200003],
              [54.195323113000086, 68.80805084800005],
              [54.19271894600007, 68.81370677300004],
              [54.20435631600009, 68.81850820500006],
              [54.21648196700005, 68.82094961100006],
              [54.221690300000034, 68.82103099200003],
              [54.26677493600005, 68.81683991100005],
            ],
          ],
          [
            [
              [49.81430097700007, 68.89948151200008],
              [49.82390384200005, 68.90257396000004],
              [49.841807488000086, 68.90623607000003],
              [49.83952884200005, 68.90058014500005],
              [49.782237175000034, 68.88068268400008],
              [49.76685631600009, 68.87763092700004],
              [49.75171959700003, 68.87742747600004],
              [49.75310306100005, 68.88031647300005],
              [49.788096550000034, 68.88947174700007],
              [49.81430097700007, 68.89948151200008],
            ],
          ],
          [
            [
              [54.97429446700005, 68.93988678600005],
              [55.01295006600009, 68.93585846600007],
              [55.022227410000085, 68.92820872600004],
              [55.019541863000086, 68.91543203300006],
              [54.988291863000086, 68.91193268400008],
              [54.94971764400003, 68.91746653900003],
              [54.92335045700008, 68.92413971600007],
              [54.91187584700003, 68.93097565300008],
              [54.91423587300005, 68.93756745000007],
              [54.92798912900008, 68.94017161700003],
              [54.97429446700005, 68.93988678600005],
            ],
          ],
          [
            [
              [50.08285566500007, 68.96092357000003],
              [50.09351647200003, 68.96405670800004],
              [50.10767662900008, 68.96352773600006],
              [50.09782962300005, 68.95343659100007],
              [50.06983483200008, 68.94306061400005],
              [50.004242384000065, 68.93073151200008],
              [50.000743035000085, 68.93231842700004],
              [50.05005944100009, 68.94550202000005],
              [50.07243899800005, 68.95473867400005],
              [50.08285566500007, 68.96092357000003],
            ],
          ],
          [
            [
              [67.21729576900003, 69.42055898600006],
              [67.28687584700003, 69.43805573100008],
              [67.30827884200005, 69.43768952000005],
              [67.30648847700007, 69.42792389500005],
              [67.24822024800005, 69.40485260600008],
              [67.18425540500004, 69.38861725500004],
              [67.15992272200003, 69.37628815300008],
              [67.14942467500003, 69.36774323100008],
              [67.13217207100007, 69.36391836100006],
              [67.09595787900008, 69.36579010600008],
              [67.07691491000008, 69.37164948100008],
              [66.99537194100003, 69.38886139500005],
              [66.95435631600003, 69.41205475500004],
              [66.93864993600005, 69.43939850500004],
              [66.95337975400008, 69.45661041900007],
              [66.96843509200005, 69.45941803600005],
              [66.97299238400007, 69.45425039300005],
              [66.97852623800009, 69.45026276200008],
              [66.98519941500007, 69.44741445500006],
              [66.99594160200007, 69.44139232000003],
              [67.01319420700008, 69.43634674700007],
              [67.16382897200003, 69.42084381700005],
              [67.15601647200003, 69.42059967700004],
              [67.16529381600003, 69.41982656500005],
              [67.21729576900003, 69.42055898600006],
            ],
          ],
          [
            [
              [67.32797285200007, 69.57269928600005],
              [67.33594811300009, 69.55988190300008],
              [67.34506269600007, 69.54865143400008],
              [67.34498131600003, 69.52212148600006],
              [67.31723066500007, 69.48794179900005],
              [67.28956139400003, 69.46600983300004],
              [67.27906334700003, 69.45026276200008],
              [67.25896243600005, 69.43862539300005],
              [67.22934004000007, 69.43353913000004],
              [67.21436608200008, 69.43292877800008],
              [67.05892988400007, 69.45050690300008],
              [67.04127037900008, 69.45758698100008],
              [67.02182050900007, 69.47695547100005],
              [67.03793379000007, 69.49795156500005],
              [67.15455162900008, 69.56012604400007],
              [67.18824303500008, 69.57099030200004],
              [67.29965254000007, 69.58445872600004],
              [67.31820722700007, 69.58307526200008],
              [67.32797285200007, 69.57269928600005],
            ],
          ],
          [
            [
              [66.83708743600005, 70.39191315300008],
              [66.86443118600005, 70.38312409100007],
              [66.86752363400007, 70.38080475500004],
              [66.84986412900008, 70.38312409100007],
              [66.76368248800009, 70.40314362200007],
              [66.60726972700007, 70.46181875200006],
              [66.59034264400003, 70.47304922100005],
              [66.59644616000008, 70.48940664300005],
              [66.64014733200008, 70.52631256700005],
              [66.66846764400003, 70.53827545800004],
              [66.67554772200003, 70.53546784100007],
              [66.66675866000008, 70.52065664300005],
              [66.67115319100003, 70.50755442900004],
              [66.67945397200003, 70.49994538000004],
              [66.68913821700005, 70.49380117400005],
              [66.70085696700005, 70.49005768400008],
              [66.70297285200007, 70.48493073100008],
              [66.69971764400003, 70.47748444200005],
              [66.70753014400003, 70.47150299700007],
              [66.72242272200003, 70.46796295800004],
              [66.73243248800009, 70.46328359600005],
              [66.73568769600007, 70.45612213700008],
              [66.73951256600003, 70.45038483300004],
              [66.74561608200008, 70.44692617400005],
              [66.74903405000003, 70.44350820500006],
              [66.74927819100003, 70.43988678600005],
              [66.75269616000008, 70.43622467700004],
              [66.75912519600007, 70.43305084800005],
              [66.80738366000008, 70.40082428600005],
              [66.81853274800005, 70.39647044500003],
              [66.83708743600005, 70.39191315300008],
            ],
          ],
          [
            [
              [66.55925540500004, 70.54425690300008],
              [66.57357832100007, 70.51577383000006],
              [66.58253014400003, 70.50165436400005],
              [66.56666100400008, 70.49876536700003],
              [66.52833092500003, 70.50678131700005],
              [66.47820071700005, 70.53506094000005],
              [66.43881269600007, 70.56826406500005],
              [66.41472415500004, 70.59682851800005],
              [66.39730879000007, 70.63031647300005],
              [66.38892662900008, 70.66762929900005],
              [66.38672936300009, 70.69497304900005],
              [66.38835696700005, 70.71063873900005],
              [66.39673912900008, 70.73533763200004],
              [66.39975019600007, 70.75092194200005],
              [66.40552819100003, 70.76923248900005],
              [66.41480553500008, 70.78681061400005],
              [66.42798912900008, 70.79950592700004],
              [66.44117272200003, 70.79791901200008],
              [66.46127363400007, 70.77802155200004],
              [66.47055097700007, 70.77179596600007],
              [66.47982832100007, 70.76386139500005],
              [66.48218834700003, 70.75324127800008],
              [66.47575931100005, 70.74266185100004],
              [66.46745853000004, 70.73297760600008],
              [66.46070397200003, 70.72028229400007],
              [66.45557701900003, 70.70453522300005],
              [66.45435631600003, 70.68402741100005],
              [66.47144616000008, 70.66575755400004],
              [66.49024498800009, 70.65591054900005],
              [66.49675540500004, 70.64691803600005],
              [66.50123131600003, 70.63861725500004],
              [66.50342858200008, 70.63157786700003],
              [66.50945071700005, 70.62494538000004],
              [66.52540123800009, 70.61530182500007],
              [66.53980553500008, 70.60834381700005],
              [66.54623457100007, 70.60333893400008],
              [66.55225670700008, 70.58612702000005],
              [66.55925540500004, 70.54425690300008],
            ],
          ],
          [
            [
              [66.60043379000007, 70.91376373900005],
              [66.59652754000007, 70.90766022300005],
              [66.58472741000008, 70.90131256700005],
              [66.57349694100003, 70.89329661700003],
              [66.56055748800009, 70.88597239800004],
              [66.55111738400007, 70.87864817900004],
              [66.54037519600007, 70.85683828300006],
              [66.53060957100007, 70.84137604400007],
              [66.50847415500004, 70.82794830900008],
              [66.47461998800009, 70.81928131700005],
              [66.44727623800009, 70.81891510600008],
              [66.43392988400007, 70.82713450700004],
              [66.44288170700008, 70.84662506700005],
              [66.48796634200005, 70.89744700700004],
              [66.51905358200008, 70.92670319200005],
              [66.51807701900003, 70.93036530200004],
              [66.51758873800009, 70.93512604400007],
              [66.52125084700003, 70.94025299700007],
              [66.52344811300009, 70.94269440300008],
              [66.59961998800009, 71.00438060100004],
              [66.60572350400008, 71.00324127800008],
              [66.61426842500003, 70.99555084800005],
              [66.61304772200003, 70.98285553600005],
              [66.60368899800005, 70.97182851800005],
              [66.59245853000004, 70.96360911700003],
              [66.58448326900003, 70.95498281500005],
              [66.58383222700007, 70.94684479400007],
              [66.58969160200007, 70.94277578300006],
              [66.59310957100007, 70.93768952000005],
              [66.59164472700007, 70.92999909100007],
              [66.59424889400003, 70.92182038000004],
              [66.60043379000007, 70.91376373900005],
            ],
          ],
          [
            [
              [53.369802280000044, 71.29173411700003],
              [53.379649285000085, 71.28465403900003],
              [53.39535566500007, 71.28050364800004],
              [53.39185631600009, 71.27871328300006],
              [53.372080925000034, 71.27814362200007],
              [53.35474694100009, 71.27973053600005],
              [53.242198113000086, 71.30947500200006],
              [53.231211785000085, 71.31635163000004],
              [53.21176191500007, 71.33380768400008],
              [53.19971764400003, 71.34088776200008],
              [53.16920006600009, 71.34918854400007],
              [53.16146894600007, 71.35488515800006],
              [53.169932488000086, 71.35765208500004],
              [53.185557488000086, 71.35578034100007],
              [53.20093834700003, 71.35537344000005],
              [53.215505405000044, 71.35814036700003],
              [53.23991946700005, 71.35443756700005],
              [53.369802280000044, 71.29173411700003],
            ],
          ],
          [
            [
              [152.87525475400003, 76.15135325700004],
              [152.88591556100005, 76.14492422100005],
              [152.89079837300005, 76.13446686400005],
              [152.88428795700008, 76.11611562700006],
              [152.85718834700003, 76.10126373900005],
              [152.825043165, 76.08881256700005],
              [152.7734481130001, 76.08340078300006],
              [152.7041121750001, 76.09398021000004],
              [152.58415774800005, 76.12592194200005],
              [152.55486087300005, 76.13934967700004],
              [152.56983483200008, 76.15241120000007],
              [152.620453321, 76.16941966400003],
              [152.70980879, 76.18667226800005],
              [152.82927493600005, 76.19619375200006],
              [152.84945722700002, 76.19578685100004],
              [152.87769616000003, 76.19122955900008],
              [152.8740340500001, 76.18089427300004],
              [152.86353600400003, 76.16632721600007],
              [152.87525475400003, 76.15135325700004],
            ],
          ],
          [
            [
              [156.660980665, 77.10761139500005],
              [156.665375196, 77.10390859600005],
              [156.67302493600005, 77.09540436400005],
              [156.6709090500001, 77.08779531500005],
              [156.65967858200008, 77.08454010600008],
              [156.6533309250001, 77.08417389500005],
              [156.51579837300005, 77.08771393400008],
              [156.49170983200008, 77.09821198100008],
              [156.50749759200005, 77.11163971600007],
              [156.52881920700008, 77.12107982000003],
              [156.55030358200008, 77.12579987200007],
              [156.58863366000003, 77.12555573100008],
              [156.63851972700002, 77.11566803600005],
              [156.660980665, 77.10761139500005],
            ],
          ],
          [
            [
              [92.06226647200003, 77.62995026200008],
              [92.07886803500003, 77.62832265800006],
              [92.11036217500003, 77.62164948100008],
              [92.11011803500003, 77.61090729400007],
              [92.09498131600003, 77.60504791900007],
              [92.03272545700008, 77.58808014500005],
              [91.98454837300005, 77.58722565300008],
              [91.91114342500003, 77.60024648600006],
              [91.88086998800003, 77.61200592700004],
              [91.86597741000003, 77.62864817900004],
              [91.89128665500004, 77.64179108300004],
              [91.94361412900008, 77.64394765800006],
              [92.06226647200003, 77.62995026200008],
            ],
          ],
          [
            [
              [58.814789259000065, 79.91669342700004],
              [58.86117597700007, 79.91095612200007],
              [58.87037194100009, 79.90131256700005],
              [58.81959069100009, 79.88654205900008],
              [58.81039472700007, 79.88523997600004],
              [58.76335696700005, 79.88300202000005],
              [58.65406334700003, 79.89276764500005],
              [58.636729363000086, 79.89948151200008],
              [58.619476759000065, 79.91258372600004],
              [58.584727410000085, 79.92645905200004],
              [58.52947024800005, 79.93329498900005],
              [58.24830162900008, 79.93341705900008],
              [58.25163821700005, 79.93919505400004],
              [58.613942905000044, 79.97943756700005],
              [58.63005618600005, 79.97825755400004],
              [58.644867384000065, 79.97532786700003],
              [58.64576256600009, 79.97162506700005],
              [58.63624108200008, 79.96552155200004],
              [58.637380405000044, 79.95913320500006],
              [58.71607506600009, 79.92890045800004],
              [58.76482181100005, 79.91840241100005],
              [58.79029381600009, 79.91669342700004],
              [58.814789259000065, 79.91669342700004],
            ],
          ],
          [
            [
              [60.16724694100009, 80.16852448100008],
              [60.199229363000086, 80.15704987200007],
              [60.21045983200008, 80.14915599200003],
              [60.20069420700008, 80.14252350500004],
              [60.17302493600005, 80.13865794500003],
              [59.993174675000034, 80.14695872600004],
              [59.90259850400008, 80.16766998900005],
              [59.891286655000044, 80.17544179900005],
              [59.89975019600007, 80.18305084800005],
              [60.05225670700008, 80.18768952000005],
              [60.10132897200003, 80.18366120000007],
              [60.16724694100009, 80.16852448100008],
            ],
          ],
          [
            [
              [54.40772545700008, 80.28481679900005],
              [54.41879316500007, 80.27879466400003],
              [54.42750084700003, 80.27187734600005],
              [54.423838738000086, 80.26504140800006],
              [54.40805097700007, 80.26044342700004],
              [54.39958743600005, 80.25885651200008],
              [54.39763431100005, 80.25193919500003],
              [54.406260613000086, 80.23700592700004],
              [54.40609785200007, 80.22113678600005],
              [54.38209069100009, 80.21035390800006],
              [54.315440300000034, 80.20180898600006],
              [54.20630944100009, 80.20038483300004],
              [54.196055535000085, 80.19745514500005],
              [54.19027754000007, 80.19269440300008],
              [54.178070509000065, 80.18927643400008],
              [54.15845787900008, 80.18903229400007],
              [54.14405358200008, 80.19204336100006],
              [54.13795006600009, 80.19647858300004],
              [54.14047285200007, 80.20087311400005],
              [54.14779707100007, 80.20628489800004],
              [54.15154056100005, 80.21198151200008],
              [54.15064537900008, 80.21621328300006],
              [54.15552819100009, 80.22113678600005],
              [54.16846764400003, 80.22890859600005],
              [54.16822350400008, 80.23688385600008],
              [54.15211022200003, 80.24266185100004],
              [54.122080925000034, 80.24892812700006],
              [54.110362175000034, 80.25267161700003],
              [54.10377037900008, 80.25950755400004],
              [54.10124759200005, 80.27289459800005],
              [54.10922285200007, 80.28676992400005],
              [54.13111412900008, 80.29425690300008],
              [54.19353274800005, 80.30711497600004],
              [54.242523634000065, 80.30890534100007],
              [54.30128014400003, 80.30467357000003],
              [54.39478600400008, 80.28961823100008],
              [54.40772545700008, 80.28481679900005],
            ],
          ],
          [
            [
              [55.498789910000085, 80.31683991100005],
              [55.51587975400008, 80.31329987200007],
              [55.524099155000044, 80.30634186400005],
              [55.51539147200003, 80.29962799700007],
              [55.50326582100007, 80.29340241100005],
              [55.50538170700008, 80.28534577000005],
              [55.49830162900008, 80.27716705900008],
              [55.45834394600007, 80.26683177300004],
              [55.42408287900008, 80.25958893400008],
              [55.29932701900003, 80.24664948100008],
              [55.258555535000085, 80.23322174700007],
              [55.23487389400003, 80.22793203300006],
              [55.07569420700008, 80.21930573100008],
              [55.045258009000065, 80.22321198100008],
              [54.99659264400003, 80.23761627800008],
              [54.98210696700005, 80.23822663000004],
              [54.97478274800005, 80.23773834800005],
              [54.95435631600009, 80.23859284100007],
              [54.942067905000044, 80.24087148600006],
              [54.93189537900008, 80.24412669500003],
              [54.932302280000044, 80.24648672100005],
              [54.94190514400003, 80.24872467700004],
              [54.94076582100007, 80.25324127800008],
              [54.93482506600009, 80.25629303600005],
              [54.929698113000086, 80.25958893400008],
              [54.93775475400008, 80.26414622600004],
              [54.96534264400003, 80.26349518400008],
              [54.97974694100009, 80.26162344000005],
              [55.01107832100007, 80.26040273600006],
              [55.029958530000044, 80.26215241100005],
              [55.04574629000007, 80.26605866100005],
              [55.15381920700008, 80.27562083500004],
              [55.157237175000034, 80.27936432500007],
              [55.140961134000065, 80.28424713700008],
              [55.12549889400003, 80.28587474200003],
              [55.08961022200003, 80.28632233300004],
              [55.06657962300005, 80.29214101800005],
              [55.070974155000044, 80.30076732000003],
              [55.29639733200008, 80.33218008000006],
              [55.35173587300005, 80.33340078300006],
              [55.37525475400008, 80.33038971600007],
              [55.385752800000034, 80.32709381700005],
              [55.498789910000085, 80.31683991100005],
            ],
          ],
          [
            [
              [54.98747806100005, 80.41437409100007],
              [55.065440300000034, 80.42047760600008],
              [55.09107506600009, 80.41998932500007],
              [55.11247806100005, 80.42157623900005],
              [55.19874108200008, 80.43838125200006],
              [55.24496504000007, 80.43846263200004],
              [55.26303144600007, 80.43060944200005],
              [55.26734459700003, 80.42446523600006],
              [55.270518425000034, 80.41864655200004],
              [55.270518425000034, 80.40936920800004],
              [55.26351972700007, 80.40314362200007],
              [55.259776238000086, 80.39691803600005],
              [55.26319420700008, 80.39052969000005],
              [55.221446160000085, 80.38068268400008],
              [55.129893425000034, 80.37433502800008],
              [55.08480879000007, 80.37677643400008],
              [55.08716881600009, 80.38125234600005],
              [55.08448326900003, 80.38580963700008],
              [55.07797285200007, 80.38914622600004],
              [55.07113691500007, 80.39109935100004],
              [54.98747806100005, 80.40033600500004],
              [54.974619988000086, 80.40326569200005],
              [54.97250410200007, 80.40753815300008],
              [54.981130405000044, 80.41242096600007],
              [54.98747806100005, 80.41437409100007],
            ],
          ],
          [
            [
              [54.841807488000086, 80.43134186400005],
              [54.84546959700003, 80.42991771000004],
              [54.85108483200008, 80.42617422100005],
              [54.85075931100005, 80.42157623900005],
              [54.846446160000085, 80.41771067900004],
              [54.83643639400003, 80.41347890800006],
              [54.805430535000085, 80.40619538000004],
              [54.794932488000086, 80.40013255400004],
              [54.783864780000044, 80.39508698100008],
              [54.771494988000086, 80.39301178600005],
              [54.52588951900003, 80.37490469000005],
              [54.40007571700005, 80.38422272300005],
              [54.39039147200003, 80.38654205900008],
              [54.39389082100007, 80.38873932500007],
              [54.40935306100005, 80.39028554900005],
              [54.43336022200003, 80.39484284100007],
              [54.45826256600009, 80.40253327000005],
              [54.47282962300005, 80.41225820500006],
              [54.49268639400003, 80.43378327000005],
              [54.51343834700003, 80.44562409100007],
              [54.576182488000086, 80.46271393400008],
              [54.598399285000085, 80.47150299700007],
              [54.62671959700003, 80.47724030200004],
              [54.70687910200007, 80.47577545800004],
              [54.72429446700005, 80.47207265800006],
              [54.74000084700003, 80.46588776200008],
              [54.799815300000034, 80.44871653900003],
              [54.81666100400008, 80.44049713700008],
              [54.841807488000086, 80.43134186400005],
            ],
          ],
          [
            [
              [54.82146243600005, 80.46478913000004],
              [54.630869988000086, 80.50210195500006],
              [54.62240644600007, 80.51129791900007],
              [54.641368035000085, 80.51679108300004],
              [54.708994988000086, 80.52578359600005],
              [54.88624108200008, 80.53310781500005],
              [55.05640709700003, 80.50287506700005],
              [55.06861412900008, 80.49872467700004],
              [55.07162519600007, 80.49160390800006],
              [55.070323113000086, 80.48590729400007],
              [55.073008660000085, 80.48407623900005],
              [55.06609134200005, 80.47744375200006],
              [55.04607181100005, 80.46723053600005],
              [55.02173912900008, 80.45823802300004],
              [54.98194420700008, 80.44891998900005],
              [54.82146243600005, 80.46478913000004],
            ],
          ],
          [
            [
              [59.73715254000007, 81.18976471600007],
              [59.75554446700005, 81.18488190300008],
              [59.758555535000085, 81.17853424700007],
              [59.75554446700005, 81.16998932500007],
              [59.74268639400003, 81.16673411700003],
              [59.72966556100005, 81.16486237200007],
              [59.37216230550004, 81.17896149300006],
              [59.014659050000034, 81.19306061400005],
              [58.99463951900003, 81.19818756700005],
              [59.00171959700003, 81.20453522300005],
              [59.097666863000086, 81.21312083500004],
              [59.41740970150008, 81.20144277550006],
              [59.73715254000007, 81.18976471600007],
            ],
          ],
          [
            [
              [60.56275475400008, 81.27362702000005],
              [60.56576582100007, 81.27195872600004],
              [60.57146243600005, 81.26813385600008],
              [60.551524285000085, 81.26056549700007],
              [60.47396894600007, 81.24689362200007],
              [60.432302280000044, 81.24437083500004],
              [60.13717695450006, 81.26569245000005],
              [59.84205162900008, 81.28701406500005],
              [59.840586785000085, 81.29157135600008],
              [59.849945509000065, 81.29734935100004],
              [60.031993035000085, 81.31110260600008],
              [60.514008009000065, 81.28953685100004],
              [60.53484134200005, 81.28400299700007],
              [60.56275475400008, 81.27362702000005],
            ],
          ],
          [
            [
              [58.36890709700003, 81.57965729400007],
              [58.29769941500007, 81.58478424700007],
              [58.275726759000065, 81.59271881700005],
              [58.28077233200008, 81.59983958500004],
              [58.291758660000085, 81.60455963700008],
              [58.36410566500007, 81.61066315300008],
              [58.394867384000065, 81.62197500200006],
              [58.41358483200008, 81.62518952000005],
              [58.582692905000044, 81.62954336100006],
              [58.611664259000065, 81.63393789300005],
              [58.646820509000065, 81.63353099200003],
              [58.67514082100007, 81.62689850500004],
              [58.68572024800005, 81.62311432500007],
              [58.69646243600005, 81.62030670800004],
              [58.70232181100005, 81.61261627800008],
              [58.689463738000086, 81.60325755400004],
              [58.66529381600009, 81.59613678600005],
              [58.49301191500007, 81.57908763200004],
              [58.369476759000065, 81.57965729400007],
              [58.36890709700003, 81.57965729400007],
            ],
          ],
          [
            [
              [132.44988040500004, 42.828111070000034],
              [132.46745853000004, 42.81093984600005],
              [132.47771243600005, 42.803900458000044],
              [132.4755965500001, 42.80023834800005],
              [132.467133009, 42.79682038000004],
              [132.45826256600003, 42.79828522300005],
              [132.45337975400003, 42.80097077000005],
              [132.4472762380001, 42.80731842700004],
              [132.4394637380001, 42.81753164300005],
              [132.42986087300005, 42.82648346600007],
              [132.41749108200008, 42.83002350500004],
              [132.40642337300005, 42.82876211100006],
              [132.40154056100005, 42.83197663000004],
              [132.40007571700005, 42.84170156500005],
              [132.39966881600003, 42.85211823100008],
              [132.404633009, 42.85911692900004],
              [132.41325931100005, 42.864447333000044],
              [132.4184676440001, 42.87986888200004],
              [132.42750084700003, 42.89590078300006],
              [132.43921959700003, 42.89203522300005],
              [132.4472762380001, 42.87677643400008],
              [132.4536238940001, 42.86090729400007],
              [132.44898522200003, 42.845404364000046],
              [132.44988040500004, 42.828111070000034],
            ],
          ],
          [
            [
              [47.85108483200008, 43.999212958000044],
              [47.862071160000085, 43.99433014500005],
              [47.86695397200003, 43.991441148000035],
              [47.86687259200005, 43.98379140800006],
              [47.76295006600009, 43.92841217700004],
              [47.74626712300005, 43.926947333000044],
              [47.70980879000007, 43.93577708500004],
              [47.69418379000007, 43.936753648000035],
              [47.68409264400009, 43.939520575000074],
              [47.68018639400009, 43.95140208500004],
              [47.67359459700003, 43.95107656500005],
              [47.65577233200008, 43.94318268400008],
              [47.64283287900008, 43.94440338700008],
              [47.63298587300005, 43.95254140800006],
              [47.62818444100009, 43.962591864000046],
              [47.637380405000044, 43.981350002000056],
              [47.66570071700005, 43.99628327000005],
              [47.78060957100007, 43.99453359600005],
              [47.81332441500007, 43.999253648000035],
              [47.838552280000044, 44.00063711100006],
              [47.85108483200008, 43.999212958000044],
            ],
          ],
          [
            [
              [47.997080925000034, 45.46784088700008],
              [47.998789910000085, 45.45384349200003],
              [47.999034050000034, 45.45132070500006],
              [47.996836785000085, 45.44790273600006],
              [47.99073326900009, 45.44871653900009],
              [47.98406009200005, 45.45302969000005],
              [47.98072350400008, 45.45547109600005],
              [47.95980879000007, 45.475775458000044],
              [47.94385826900009, 45.49957916900007],
              [47.92798912900008, 45.53400299700007],
              [47.91773522200003, 45.57005442900004],
              [47.91651451900009, 45.579291083000044],
              [47.916026238000086, 45.595363674000055],
              [47.916758660000085, 45.60919830900008],
              [47.91456139400009, 45.623032945000034],
              [47.91749108200008, 45.63275788000004],
              [47.92790774800005, 45.63544342700004],
              [47.937510613000086, 45.63621653900009],
              [47.946299675000034, 45.64492422100005],
              [47.957041863000086, 45.650458075000074],
              [47.96208743600005, 45.63979726800005],
              [47.959727410000085, 45.62409088700008],
              [47.96615644600007, 45.60614655200004],
              [47.97803795700008, 45.58344147300005],
              [47.98226972700007, 45.56427643400008],
              [47.98267662900008, 45.550116278000075],
              [47.988617384000065, 45.53579336100006],
              [47.997080925000034, 45.52049388200004],
              [47.997080925000034, 45.46784088700008],
            ],
          ],
          [
            [
              [139.2254560780001, 54.58935777500005],
              [139.239606105, 54.58926016400005],
              [139.26146162600003, 54.59923354500006],
              [139.27002580600004, 54.61026470100006],
              [139.276750074, 54.61310968300006],
              [139.27579200600007, 54.607329048000054],
              [139.26213822300008, 54.59199353000008],
              [139.24359328000003, 54.58103164400006],
              [139.219454, 54.580717641000035],
              [139.21372548300008, 54.585579271000086],
              [139.2254560780001, 54.58935777500005],
            ],
          ],
          [
            [
              [138.19001337200007, 54.71557892000004],
              [138.226782555, 54.715626317000044],
              [138.24099507800008, 54.71371165900007],
              [138.23099907000005, 54.70694540900007],
              [138.21014439100009, 54.70112979900006],
              [138.19594380500007, 54.70111044100008],
              [138.18253610200009, 54.707846534000055],
              [138.18082279100008, 54.715082893000044],
              [138.19001337200007, 54.71557892000004],
            ],
          ],
          [
            [
              [149.0327892580001, 59.192177739000044],
              [149.04002865500001, 59.20292969500008],
              [149.0511316410001, 59.20297174400008],
              [149.0709462430001, 59.197366989000045],
              [149.0918267090001, 59.20374762500006],
              [149.117654002, 59.20950951100008],
              [149.14110770700006, 59.20769035300003],
              [149.1362986580001, 59.19758499400007],
              [149.11913582800003, 59.189962893000086],
              [149.098370306, 59.17538719700008],
              [149.10348110900009, 59.16152900800006],
              [149.07883838700002, 59.16144174200008],
              [149.03436267400002, 59.169473982000056],
              [149.03292282200005, 59.183346605000054],
              [149.0327892580001, 59.192177739000044],
            ],
          ],
          [
            [
              [-172.47529049399992, 64.64183177300004],
              [-172.46540279899992, 64.63719310100004],
              [-172.4533585279999, 64.62352122600004],
              [-172.4584854809999, 64.61102936400005],
              [-172.5193985669999, 64.59300364800004],
              [-172.5432022779999, 64.59218984600005],
              [-172.56550045499992, 64.59552643400008],
              [-172.67039954299992, 64.60114166900007],
              [-172.67784583199992, 64.60358307500007],
              [-172.68248450399992, 64.60895416900007],
              [-172.6855362619999, 64.61591217700004],
              [-172.69420325399992, 64.61969635600008],
              [-172.7076309889999, 64.62002187700006],
              [-172.72504635299993, 64.62645091400003],
              [-172.72028561099992, 64.64435455900008],
              [-172.6960343089999, 64.65253327000005],
              [-172.6788223949999, 64.64594147300005],
              [-172.65595455599993, 64.64118073100008],
              [-172.47529049399992, 64.64183177300004],
            ],
          ],
          [
            [
              [67.38119550900007, 68.79226308800008],
              [67.40739993600005, 68.77578359600005],
              [67.40674889400003, 68.76809316600009],
              [67.40121504000007, 68.76125722900008],
              [67.39307701900003, 68.75731028900003],
              [67.35002688900005, 68.76618073100008],
              [67.33611087300005, 68.76443105700008],
              [67.33318118600005, 68.76080963700008],
              [67.33871504000007, 68.75930410400008],
              [67.33326256600003, 68.75849030200004],
              [67.20720462300005, 68.80154043200008],
              [67.19353274800005, 68.80170319200005],
              [67.15821373800009, 68.78754303600005],
              [67.13795006600003, 68.78888580900008],
              [67.12232506600003, 68.79344310100004],
              [67.11581464900007, 68.79836660400008],
              [67.12061608200008, 68.80422597900008],
              [67.23560631600003, 68.82037995000007],
              [67.33781985800005, 68.80894603100006],
              [67.38119550900007, 68.79226308800008],
            ],
          ],
          [
            [
              [-175.58568274599992, 71.37986888200004],
              [-175.57929439999992, 71.37832265800006],
              [-175.57433020699992, 71.37352122600004],
              [-175.57477779899992, 71.36416250200006],
              [-175.5900772779999, 71.35809967700004],
              [-175.6087540359999, 71.35394928600005],
              [-175.62865149599992, 71.35175202000005],
              [-175.6502579419999, 71.35700104400007],
              [-175.6663712229999, 71.36664459800005],
              [-175.67857825399992, 71.37563711100006],
              [-175.69542395699992, 71.38080475500004],
              [-175.73810787699992, 71.38369375200006],
              [-175.75987708199992, 71.38971588700008],
              [-175.8107804029999, 71.41168854400007],
              [-175.79816646999993, 71.41205475500004],
              [-175.61729895699992, 71.38104889500005],
              [-175.59894771999993, 71.38108958500004],
              [-175.58568274599992, 71.37986888200004],
            ],
          ],
          [
            [
              [161.89376693300005, 69.65383772300004],
              [161.90787918600006, 69.64744246400005],
              [161.90372992800008, 69.63210869200003],
              [161.88562390900006, 69.61914024200007],
              [161.89103010100007, 69.59497130700004],
              [161.89863658700006, 69.57404028700006],
              [161.86693604800007, 69.55455380300003],
              [161.82553257200004, 69.55034623600005],
              [161.77943945700008, 69.54852676300004],
              [161.75156390000006, 69.55323541400008],
              [161.73496690900004, 69.56444713800005],
              [161.7109694410001, 69.58691103100006],
              [161.67564795300007, 69.60205220300008],
              [161.66561653400004, 69.62054810900008],
              [161.6672436350001, 69.63668263100004],
              [161.70424884200008, 69.63848392400007],
              [161.7551542650001, 69.64034235700007],
              [161.81711706700003, 69.65755330600007],
              [161.89376693300005, 69.65383772300004],
            ],
          ],
          [
            [
              [170.12487070400005, 69.77337787400006],
              [170.275276857, 69.77337143300008],
              [170.271278683, 69.76379826100003],
              [170.247539416, 69.76380804800004],
              [170.223754417, 69.73919563200008],
              [170.16056431700008, 69.70911008500008],
              [170.10148466500004, 69.68721106100008],
              [170.065968547, 69.69403181500007],
              [170.0698256070001, 69.70907357300007],
              [170.03033721300005, 69.71451529400008],
              [169.97896014000003, 69.71993461100004],
              [169.9552103750001, 69.72674171800008],
              [169.9747903330001, 69.74180631500008],
              [170.05370073400002, 69.76376360100005],
              [170.12487070400005, 69.77337787400006],
            ],
          ],
          [
            [
              [83.30510887300005, 70.80551475300007],
              [83.37163680800006, 70.78827661800005],
              [83.46940813200007, 70.73773494400007],
              [83.44388361200004, 70.69130566400008],
              [83.37434012600005, 70.66362047400008],
              [83.30476002900008, 70.64460434500006],
              [83.30134887900005, 70.60546065100004],
              [83.25919110200005, 70.54880653600009],
              [83.26451660800006, 70.51112655900005],
              [83.30869606100003, 70.48080660800008],
              [83.30957222200004, 70.44310013300003],
              [83.25818547300008, 70.41973802700005],
              [83.19442277300004, 70.37889519700008],
              [83.09138034500006, 70.36111167400009],
              [83.06527091900006, 70.36532894700008],
              [83.09892616400003, 70.39305110700008],
              [83.13223168700006, 70.43380736600005],
              [83.11773234300006, 70.48016611700007],
              [83.12500619300005, 70.52369900800005],
              [83.13671576600007, 70.56579151000005],
              [83.13091736200005, 70.60925978700004],
              [83.14705910100008, 70.64990855900004],
              [83.20724549000005, 70.68635389600007],
              [83.22360496700003, 70.72699657700008],
              [83.23118613800006, 70.76906195100008],
              [83.25672166800007, 70.80103268100004],
              [83.30510887300005, 70.80551475300007],
            ],
          ],
          [
            [
              [97.64568118600005, 76.75621165600006],
              [97.64600670700003, 76.75381094000005],
              [97.64795983200003, 76.74860260600008],
              [97.63860110800005, 76.74131907800006],
              [97.62305748800003, 76.73749420800004],
              [97.58114668100006, 76.75149160400008],
              [97.56552168100006, 76.75230540600006],
              [97.52084394600007, 76.74428945500006],
              [97.45980879000007, 76.71845123900005],
              [97.45403079500005, 76.72129954600007],
              [97.44939212300005, 76.72752513200004],
              [97.44833418100006, 76.73314036700003],
              [97.45069420700003, 76.73680247600004],
              [97.45167076900003, 76.73997630400004],
              [97.44752037900008, 76.74233633000006],
              [97.16692142000005, 76.74571360900006],
              [97.16073652400007, 76.75360748900005],
              [97.51010175900007, 76.76675039300005],
              [97.51775149800005, 76.77098216400003],
              [97.63900800900007, 76.77309804900005],
              [97.64267011800007, 76.76760488500008],
              [97.64307701900003, 76.76312897300005],
              [97.64616946700005, 76.75901927300004],
              [97.64568118600005, 76.75621165600006],
            ],
          ],
          [
            [
              [89.04712791500003, 77.14089453200006],
              [89.13589831700006, 77.12711443300003],
              [89.09857921500003, 77.09860134600007],
              [89.04493849500005, 77.07709186900007],
              [88.96883685300003, 77.03943478000008],
              [89.01868583200007, 77.01307845500008],
              [88.98926217300004, 76.98987672600003],
              [88.91957126100004, 76.97710091000005],
              [88.81633380600005, 76.98540998400006],
              [88.69981186600006, 77.03972270500003],
              [88.66387512900008, 77.08035050300003],
              [88.78564889000006, 77.12357191300003],
              [89.04712791500003, 77.14089453200006],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Czechia',
        iso3: 'CZE',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [14.810392700000136, 50.858447164000054],
            [14.831683390000137, 50.85798207600003],
            [14.867856893000067, 50.86438995400009],
            [14.982061808000083, 50.85906728200003],
            [14.98412886500006, 50.86769724600008],
            [14.982888631, 50.90242380800002],
            [14.981751749000097, 50.90526601200007],
            [14.981131632000142, 50.909090068000026],
            [14.982061808000083, 50.91467112300005],
            [14.984852335000141, 50.91808176700006],
            [14.994670857000102, 50.925109762000076],
            [14.997771444000051, 50.930174052000055],
            [14.996634562000054, 50.95921620700004],
            [14.981441691000015, 50.973220520000055],
            [14.965215291000106, 50.98133372000005],
            [14.960977824000054, 50.99265085900002],
            [14.961081176000079, 50.99265085900002],
            [14.965628703000021, 50.996061503000064],
            [14.970692993000085, 50.99869700200007],
            [14.976377401000036, 51.000402324000035],
            [14.982061808000083, 51.00117747000006],
            [14.996531209000125, 51.00784373000006],
            [15.001182088000093, 51.01244293200001],
            [15.003972616000055, 51.02068532300005],
            [15.022989543000108, 51.00965240500004],
            [15.073632446000062, 51.00262441000005],
            [15.082107381000071, 50.992754212000065],
            [15.09388960700008, 50.98541615800006],
            [15.107945597000082, 50.981023662000055],
            [15.119211059000065, 50.98247060200005],
            [15.122518351000053, 50.99265085900002],
            [15.122518351000053, 50.992754212000065],
            [15.131510051000106, 51.00582834900011],
            [15.144429158000094, 51.01156443300006],
            [15.156108032000077, 51.00784373000006],
            [15.16075891100013, 50.99265085900002],
            [15.170164022000108, 50.97797475200004],
            [15.22711145000008, 50.977406311],
            [15.253776489000103, 50.96903472900003],
            [15.269796183000068, 50.95265330000005],
            [15.268762655000074, 50.942989807000046],
            [15.260081014000036, 50.93249949100009],
            [15.253053019000106, 50.91410268200009],
            [15.256050252000136, 50.89989166300002],
            [15.265352010000072, 50.88227],
            [15.277134236000052, 50.86573354100004],
            [15.287779581000052, 50.854881490000096],
            [15.307726685000063, 50.844752910000054],
            [15.32581343600009, 50.83968861900006],
            [15.34100630600011, 50.83173044900009],
            [15.35299523900008, 50.812971904],
            [15.353305298000066, 50.80325673500006],
            [15.350514770000103, 50.793231506000055],
            [15.349687948000081, 50.78372304300005],
            [15.356095825000125, 50.775454814000014],
            [15.368578785000096, 50.772949110000084],
            [15.370255168000057, 50.77261261000005],
            [15.381313924000068, 50.78000234000005],
            [15.39082238800006, 50.79064768500005],
            [15.400124145000092, 50.79798573800004],
            [15.441775350000086, 50.800207825000044],
            [15.641866496000148, 50.755766094000066],
            [15.653235310000042, 50.75096018500007],
            [15.666464477000147, 50.73809275300006],
            [15.673802530000046, 50.73354522700002],
            [15.684344523000107, 50.73142649400005],
            [15.767440226000076, 50.74419057200002],
            [15.792244914000037, 50.74269195600003],
            [15.794415323000095, 50.73587066700007],
            [15.797619263000087, 50.729772848],
            [15.848158813000111, 50.675150859000055],
            [15.854566691000059, 50.67370391900006],
            [15.882265258000075, 50.674220683],
            [15.94148645000007, 50.68838002600005],
            [15.958022908000146, 50.68688140900004],
            [15.97145878100011, 50.678613180000085],
            [15.984481242000044, 50.66290354400003],
            [15.99316288200012, 50.64936431900004],
            [15.9986405840001, 50.63556671200011],
            [15.996366821000095, 50.62368113200007],
            [15.982000773000067, 50.616239726000046],
            [15.980037068000058, 50.612984111000074],
            [15.979210246000036, 50.6097801720001],
            [15.9799337150001, 50.60662791000006],
            [15.982000773000067, 50.60363067700003],
            [16.02447880000011, 50.608591614000076],
            [16.08649051900008, 50.64678049800004],
            [16.128658488000042, 50.644041647],
            [16.160284465000103, 50.628642070000026],
            [16.17547733500004, 50.62409454400007],
            [16.19232385200013, 50.62657501300005],
            [16.204519491000042, 50.63634185800002],
            [16.211754191000097, 50.64910593700007],
            [16.2190922450001, 50.65913116500009],
            [16.232011352000114, 50.66088816400007],
            [16.268288208000058, 50.66042307600007],
            [16.30094771400013, 50.65510040300002],
            [16.331643514000092, 50.644041647],
            [16.416806275000113, 50.586629130000105],
            [16.425901326000087, 50.567560527000026],
            [16.394482056000044, 50.5593439740001],
            [16.398306111000096, 50.55179921500006],
            [16.398306111000096, 50.54849192300004],
            [16.395515584000123, 50.5457013960001],
            [16.39117476400014, 50.53991363500002],
            [16.389624471000047, 50.53484934500004],
            [16.388280884000068, 50.527149557000044],
            [16.388384237000082, 50.521258443000036],
            [16.39117476400014, 50.521826884000106],
            [16.382596476000117, 50.51417877200002],
            [16.36202925600014, 50.50120798800002],
            [16.352624145000078, 50.492784729],
            [16.335467570000105, 50.49035593700005],
            [16.30342818200012, 50.49604034400009],
            [16.287718547000054, 50.492784729],
            [16.27996708200004, 50.479865621],
            [16.26498091700006, 50.471649068000076],
            [16.247410929000097, 50.46498280900006],
            [16.232011352000114, 50.45676625600002],
            [16.226533651000125, 50.455370992000056],
            [16.21733524600012, 50.45165028900003],
            [16.21123742700007, 50.45128855400013],
            [16.21609501100008, 50.44017812200012],
            [16.2179553630001, 50.437129211000084],
            [16.19800826000008, 50.44002309200006],
            [16.190153443000042, 50.42415842700005],
            [16.199558553000088, 50.406278381],
            [16.232011352000114, 50.402609355000024],
            [16.24493046000012, 50.3768228150001],
            [16.249684692000102, 50.371035055000036],
            [16.262500448000083, 50.36442047200005],
            [16.269838501000095, 50.36545400100003],
            [16.276969849000125, 50.3694330850001],
            [16.28864872200009, 50.37186187800005],
            [16.334227335000094, 50.37186187800005],
            [16.343735799000058, 50.369949850000026],
            [16.350763794000073, 50.36064809200009],
            [16.35148726400007, 50.35134633400007],
            [16.35066044100006, 50.342251282000106],
            [16.353244263000136, 50.33351796500004],
            [16.37102095600008, 50.31837677000003],
            [16.415566040000073, 50.307938131000085],
            [16.437786906000014, 50.297964580000084],
            [16.45215295400004, 50.28499379500006],
            [16.47757775900004, 50.255331523000095],
            [16.492047160000055, 50.24272247300006],
            [16.504759563000107, 50.22799469100006],
            [16.535041952000142, 50.207737529000056],
            [16.545894003000086, 50.18882395500002],
            [16.557262817000094, 50.154717510000054],
            [16.56666792800013, 50.14221181200007],
            [16.584237915000102, 50.12743235300003],
            [16.618654419000052, 50.10702016300009],
            [16.66061568200007, 50.0930158500001],
            [16.701233357000092, 50.09492787700002],
            [16.732032511000057, 50.12195465200004],
            [16.75425337700011, 50.132289938000056],
            [16.76644901600011, 50.143400371000084],
            [16.777301066000064, 50.15693959600007],
            [16.795284464000048, 50.17440623],
            [16.817712036000046, 50.18675689700005],
            [16.837555786000053, 50.188617249000075],
            [16.857606242000088, 50.18773875000004],
            [16.86976208200008, 50.18972886500002],
            [16.880963990000026, 50.19156280600008],
            [16.8903691000001, 50.196937154000025],
            [16.907008911000105, 50.21176829000005],
            [16.918997843000056, 50.21709096300002],
            [16.927782837000052, 50.21729766900005],
            [16.946283, 50.21306020200011],
            [16.955274699000114, 50.21347361300012],
            [16.9577551670001, 50.21714264000012],
            [16.957548462000148, 50.229234925000085],
            [16.960338989000093, 50.23197377500004],
            [16.975015096000078, 50.23181874700002],
            [16.981009563000015, 50.2291832480001],
            [16.98566044100008, 50.22313710600004],
            [16.99630578600008, 50.21290517200008],
            [17.008398071000073, 50.20995961500007],
            [17.014805949000106, 50.21848622700007],
            [17.01284224400007, 50.231663717000075],
            [16.999819783000135, 50.24272247300006],
            [16.99837284300014, 50.26701039600006],
            [16.98783085100007, 50.284942119000036],
            [16.969640747000113, 50.29775787400003],
            [16.945249471000096, 50.3069046020001],
            [16.926542602000012, 50.319255270000056],
            [16.91672408000005, 50.338633932000036],
            [16.909282674000025, 50.359924622],
            [16.89791385900014, 50.37821807900009],
            [16.86587447100004, 50.4084487920001],
            [16.86577111800011, 50.42240142900009],
            [16.892952921000102, 50.43294342100005],
            [16.915793904000083, 50.43108306900005],
            [16.94400462900012, 50.42026669700003],
            [16.958788696000084, 50.41459828700006],
            [16.98193973800008, 50.41635528600004],
            [17.084672485000084, 50.397958476000056],
            [17.09562788900007, 50.39366933200007],
            [17.11888228400008, 50.38116363600007],
            [17.131698038000053, 50.3768228150001],
            [17.145443970000088, 50.37671946300007],
            [17.175933065000066, 50.38075022400007],
            [17.187611939000135, 50.37847646100006],
            [17.18544152800007, 50.375685934],
            [17.1888521730001, 50.36483388300006],
            [17.195053345000076, 50.351914775000026],
            [17.20104781100011, 50.34323313400007],
            [17.21086633300007, 50.33641184500003],
            [17.24610965900004, 50.322149150000044],
            [17.269880819000093, 50.317756653000046],
            [17.316803019000048, 50.3186351530001],
            [17.337473592000066, 50.313002422000054],
            [17.31907678200008, 50.30824819000007],
            [17.321867309000112, 50.304475810000056],
            [17.32538130700007, 50.30111684200004],
            [17.3295154220001, 50.298222962000054],
            [17.334062947000035, 50.29569081700005],
            [17.3328227130001, 50.28266835600003],
            [17.334786418000135, 50.27000763000008],
            [17.341711060000108, 50.25972402000009],
            [17.35504357900004, 50.25326446600003],
            [17.365895630000097, 50.271557923],
            [17.38801314300011, 50.2726431280001],
            [17.409820597000135, 50.261325989000014],
            [17.41912235500007, 50.24272247300006],
            [17.424186645000134, 50.24055206300007],
            [17.4295609940001, 50.23977691700007],
            [17.434831991000124, 50.24050038700007],
            [17.439999634000117, 50.24272247300006],
            [17.469351847000098, 50.265563456000066],
            [17.51699751800004, 50.26835398400003],
            [17.60639774600014, 50.25822540300008],
            [17.629548787000118, 50.26210113600003],
            [17.64670536300008, 50.27109283500006],
            [17.676367635000133, 50.297396139000014],
            [17.68194869000007, 50.30556101500004],
            [17.68453251100007, 50.312382304],
            [17.691043741000044, 50.31506947800004],
            [17.707993611000035, 50.31103871700013],
            [17.713574666000056, 50.30767974900003],
            [17.73197147600007, 50.29176340700009],
            [17.734451945000046, 50.289489645000074],
            [17.73496870900007, 50.28680247000004],
            [17.734245239000074, 50.283805237000124],
            [17.73197147600007, 50.28065297500008],
            [17.721119425000097, 50.261946106],
            [17.719155721000078, 50.25279937800009],
            [17.721429484000083, 50.24272247300006],
            [17.73197147600007, 50.236004538000046],
            [17.74757775900011, 50.21750437400003],
            [17.738172648000045, 50.20236318000009],
            [17.71791548700014, 50.19109771800005],
            [17.675334106000065, 50.174716289000074],
            [17.648669067000128, 50.167998352000055],
            [17.60040327900012, 50.16680979500005],
            [17.589447876000122, 50.16324412000007],
            [17.582109823000053, 50.15316721600003],
            [17.584176880000086, 50.14588083900004],
            [17.632752726000092, 50.10634836900003],
            [17.648359009000046, 50.10180084300008],
            [17.65848758900009, 50.102989400000084],
            [17.6669625240001, 50.10614166300006],
            [17.6776078690001, 50.107743632000094],
            [17.690733683000047, 50.10546986900006],
            [17.71791548700014, 50.09678822800002],
            [17.73197147600007, 50.094876201],
            [17.73238488800007, 50.093894349000024],
            [17.73259159400004, 50.092964173000084],
            [17.73238488800007, 50.09218902600007],
            [17.73197147600007, 50.091465556000074],
            [17.722669719000123, 50.08634959000007],
            [17.719465780000064, 50.08087188800009],
            [17.72256636500009, 50.07513580400003],
            [17.73197147600007, 50.06908966100009],
            [17.743030232000052, 50.060563050000084],
            [17.749851522000114, 50.04950429400007],
            [17.755432577000136, 50.03715362600012],
            [17.76328739400006, 50.02521637000008],
            [17.774552857000117, 50.015191142000035],
            [17.839355102000127, 49.973643291000045],
            [17.875735311000113, 49.96868235300009],
            [17.91211551900011, 49.975813700000046],
            [17.941571085000106, 49.992763570000065],
            [17.95976119000005, 49.99581248000008],
            [17.999862101000133, 49.996587627000096],
            [18.03241825300009, 50.0028404750001],
            [18.037482544000056, 50.00723297100008],
            [18.035725545000076, 50.0172065230001],
            [18.02869755000009, 50.02413116500007],
            [18.020119262000065, 50.024286195000016],
            [18.0121610920001, 50.022684225],
            [18.006890096000063, 50.02413116500007],
            [18.00244592300004, 50.04676544200002],
            [18.019073899000148, 50.04408711000012],
            [18.0332450760001, 50.04180450500009],
            [18.091639445000084, 50.0172065230001],
            [18.08512821400012, 49.99875803600007],
            [18.098150675000056, 49.98904286700004],
            [18.162022746000105, 49.98123972600003],
            [18.17721561700003, 49.975813700000046],
            [18.208738241000106, 49.95829539000009],
            [18.220520467000085, 49.95488474600005],
            [18.243981567000077, 49.9517324830001],
            [18.25586714700009, 49.946048076000054],
            [18.260104614000056, 49.940570374000075],
            [18.26702925600003, 49.92506744400005],
            [18.27261031100005, 49.91829783100012],
            [18.292454061000058, 49.90780751600006],
            [18.30692346200007, 49.909667868000085],
            [18.334932088000073, 49.92542917900006],
            [18.333795206000076, 49.927134501000026],
            [18.33245161900001, 49.92827138300002],
            [18.330694621000134, 49.92883982400009],
            [18.328524211000058, 49.92883982400009],
            [18.368831827000093, 49.93204376300007],
            [18.407485800000103, 49.92315541600003],
            [18.481796509000077, 49.89664540700004],
            [18.505050903000097, 49.89669708300006],
            [18.544428345000114, 49.912975159000084],
            [18.55920780400004, 49.90718739800009],
            [18.5654089760001, 49.889048971000065],
            [18.562928507000038, 49.8737010710001],
            [18.567269328000123, 49.861453756000074],
            [18.593831014000045, 49.85220367500007],
            [18.56633915200007, 49.83158477800005],
            [18.56675256400007, 49.80476471000007],
            [18.5841158450001, 49.77437896700012],
            [18.607680298000105, 49.742959697000074],
            [18.617705526000123, 49.71386586600006],
            [18.624010050000038, 49.70637278300005],
            [18.637342570000044, 49.700326640000085],
            [18.668141724000122, 49.69856964100002],
            [18.68240441800009, 49.69577911400005],
            [18.695426880000127, 49.688854472000074],
            [18.715063924000077, 49.67381663],
            [18.727672974000086, 49.66890736900005],
            [18.742245727000068, 49.669682516000066],
            [18.757852010000107, 49.67407501300006],
            [18.773458293000118, 49.675832011000054],
            [18.7884444580001, 49.668597311000084],
            [18.792578573000128, 49.660794169000056],
            [18.799296508000054, 49.62637766600001],
            [18.803947387000107, 49.61676584900009],
            [18.815729614000105, 49.599299215000045],
            [18.82017378800012, 49.59025583900008],
            [18.83453983600012, 49.54762278200009],
            [18.837433716000106, 49.52695221000009],
            [18.833196249000082, 49.51026072200004],
            [18.792268514000057, 49.509537252000044],
            [18.773561645000058, 49.504886373],
            [18.73253055800012, 49.480288391],
            [18.70452193200009, 49.47925486300004],
            [18.675583130000035, 49.4850426230001],
            [18.64282027200005, 49.49579132100003],
            [18.63589563000005, 49.49672149700008],
            [18.628970988000077, 49.49579132100003],
            [18.600445598000135, 49.485972799000066],
            [18.556210571000094, 49.49015859000009],
            [18.535643351000118, 49.481683655],
            [18.53047570800001, 49.47346710200004],
            [18.527995239000035, 49.45486358700002],
            [18.522930949000056, 49.4460785940001],
            [18.514662719000114, 49.44060089100013],
            [18.481796509000077, 49.42907704700009],
            [18.43921512900002, 49.39507395500006],
            [18.416787557000134, 49.38546213800005],
            [18.387642049000107, 49.38975128200009],
            [18.385161580000045, 49.34226064100001],
            [18.36158636600004, 49.33019141800007],
            [18.324596802000087, 49.31125478100007],
            [18.190031372000107, 49.27694163100007],
            [18.16057580600011, 49.2586998500001],
            [18.136494588000062, 49.23306833900004],
            [18.11778771900009, 49.20257924500005],
            [18.105075318000047, 49.16976471000005],
            [18.101457967000044, 49.14294464100006],
            [18.101629686000138, 49.136928332000096],
            [18.10290490700004, 49.092250062000076],
            [18.096290323000062, 49.07028757800002],
            [18.075516398000104, 49.04718821200002],
            [18.04606083200011, 49.029153138000126],
            [18.012884562000096, 49.01912791000011],
            [17.95924442600011, 49.021866760000066],
            [17.935059855000134, 49.01938629200008],
            [17.914079223000044, 49.01049794600006],
            [17.900850057000127, 48.993031311000024],
            [17.894648885000066, 48.97820017600007],
            [17.88689742000014, 48.94724599200008],
            [17.87873254400003, 48.93355173800005],
            [17.860335734000046, 48.92171783500005],
            [17.841215454000036, 48.920994365000055],
            [17.820131469000103, 48.923371481000075],
            [17.795533488000046, 48.92058095300003],
            [17.77941044100004, 48.91174428300003],
            [17.744890584000075, 48.87257354800009],
            [17.72721724400006, 48.86291005400007],
            [17.535084269000066, 48.812990621],
            [17.49849735500004, 48.816763001000126],
            [17.467904907000104, 48.838105367000125],
            [17.453332153000133, 48.84275624700008],
            [17.4295609940001, 48.83815704300004],
            [17.41122471900013, 48.8302163340001],
            [17.391733846000108, 48.82177561400009],
            [17.374370565000106, 48.81960520500009],
            [17.260269002000086, 48.85779408800006],
            [17.212209920000134, 48.86606231800003],
            [17.167458130000085, 48.859757792000025],
            [17.113714641000087, 48.83391957600007],
            [17.104619588000105, 48.82461781800005],
            [17.098728475000087, 48.80575592100003],
            [17.084362426000098, 48.79371531200006],
            [17.049945923000053, 48.77402659200003],
            [17.025347941000064, 48.746328024],
            [16.974808390000135, 48.649873963000076],
            [16.963336222000123, 48.635947164000086],
            [16.9475232340001, 48.62315724700004],
            [16.945042766000142, 48.60416615800007],
            [16.910522908000075, 48.63077952100009],
            [16.89667362500009, 48.69697703000007],
            [16.87300581900007, 48.71899119100006],
            [16.856572713000105, 48.71981801400007],
            [16.818125447000057, 48.71077463800002],
            [16.798901814000118, 48.70922434500001],
            [16.780505005000123, 48.71377187100005],
            [16.744331502000108, 48.72963653600006],
            [16.729035279000044, 48.73309885700009],
            [16.69100142400012, 48.73206532800002],
            [16.675085083000084, 48.73392567900002],
            [16.661959269000135, 48.74002349900006],
            [16.654724569000052, 48.751857402],
            [16.651003866000053, 48.76622345],
            [16.643149047000122, 48.77826405900005],
            [16.624028767000112, 48.783380026000046],
            [16.605528605000103, 48.78482696500005],
            [16.54579065000007, 48.79629913400005],
            [16.528737426000134, 48.80353383400002],
            [16.519539022000117, 48.805600891],
            [16.510340617000026, 48.80477406900006],
            [16.492253865000123, 48.79970977900008],
            [16.48191857900011, 48.79939971900011],
            [16.453083130000067, 48.80219024700007],
            [16.435719848000048, 48.79454213500007],
            [16.38497359200008, 48.737077943000074],
            [16.374018188000093, 48.73030832900004],
            [16.358308553000114, 48.72725942000001],
            [16.352727498, 48.728447978000034],
            [16.3394983310001, 48.735579326000064],
            [16.318724406000058, 48.7335122680001],
            [16.317587524000146, 48.73284047500003],
            [16.177751098000073, 48.74653472900003],
            [16.085353638000072, 48.74286570200006],
            [16.032333618000052, 48.75805857400006],
            [15.931771281000124, 48.806427714],
            [15.93032434100013, 48.811388652000076],
            [15.93032434100013, 48.81831329400005],
            [15.925053345000094, 48.822602438],
            [15.908103475000104, 48.819708558000016],
            [15.90706994600012, 48.8302505490001],
            [15.899628540000094, 48.8347464000001],
            [15.888363077000122, 48.835056458000096],
            [15.875754028000102, 48.83309275300006],
            [15.885985961000102, 48.842032776000096],
            [15.877614379000107, 48.841671041],
            [15.87017297300008, 48.843893128],
            [15.859217570000112, 48.849164124000126],
            [15.84009729000013, 48.850094300000066],
            [15.833276001000058, 48.85200632800009],
            [15.828315064000037, 48.85712229500008],
            [15.82428430100012, 48.86942128500003],
            [15.818496541000059, 48.87231516500002],
            [15.787904093000037, 48.87226348900002],
            [15.779222453000074, 48.870868225000024],
            [15.743669067000042, 48.85846588200006],
            [15.726822550000037, 48.8549518840001],
            [15.703774861000085, 48.8549518840001],
            [15.681347290000076, 48.85846588200006],
            [15.603729288000096, 48.8873530070001],
            [15.54418668100007, 48.90261173300006],
            [15.521253703000099, 48.90848866800006],
            [15.471851033000064, 48.93670400000012],
            [15.45035363800011, 48.94481720000003],
            [15.405911906000142, 48.95468739900009],
            [15.357852823000087, 48.97081044600007],
            [15.335528605000036, 48.9749962370001],
            [15.288709757000106, 48.975357972000026],
            [15.283748820000142, 48.97763173500003],
            [15.279614706000132, 48.98259267200008],
            [15.27455041500005, 48.98672678700011],
            [15.26690230300008, 48.98667511100008],
            [15.262871542000084, 48.98259267200008],
            [15.260391073000108, 48.96915680000002],
            [15.25708378100012, 48.963885803],
            [15.24323449700006, 48.95293040000003],
            [15.238066854000039, 48.95075998900005],
            [15.161792440000113, 48.93722076400006],
            [15.141948689000117, 48.93747914700002],
            [15.148563273000036, 48.951741842],
            [15.148976684000047, 48.965332743],
            [15.14473921700008, 48.97892364500008],
            [15.137401164000096, 48.993031311000024],
            [15.059576457000048, 48.99721710200005],
            [15.003972616000055, 49.00977447500007],
            [14.982061808000083, 49.00791412400007],
            [14.978857869000109, 49.006260478000016],
            [14.97730757700009, 49.002901510000086],
            [14.97730757700009, 48.99825063100003],
            [14.978237753000144, 48.99282460500005],
            [14.964595174000038, 48.97174062200013],
            [14.964181763000028, 48.94326690700008],
            [14.968315877000066, 48.91267445900009],
            [14.968212524000108, 48.88502756800007],
            [14.947025187000065, 48.82239573200006],
            [14.939790487000096, 48.80978668200002],
            [14.93813684000014, 48.802810364000024],
            [14.940100545000092, 48.79650583900012],
            [14.944441366000149, 48.788599345000065],
            [14.94888553800007, 48.78213979100012],
            [14.951055949000079, 48.78033111600003],
            [14.939583781000039, 48.76281280600007],
            [14.91932662000005, 48.76157257100003],
            [14.867650187000095, 48.77557688400013],
            [14.815456991000104, 48.78033111600003],
            [14.800367472000119, 48.77650706000007],
            [14.794476359000015, 48.76699859700001],
            [14.790445597000115, 48.754854635000086],
            [14.780420370000087, 48.74312408500002],
            [14.775356079000119, 48.72400380500004],
            [14.722749471000043, 48.693411357000016],
            [14.70383589700009, 48.673102519000096],
            [14.700218546000116, 48.64610158300006],
            [14.700735310000141, 48.615534974000056],
            [14.695671020000077, 48.58954172800007],
            [14.691140439000037, 48.58653496300009],
            [14.675620565000116, 48.576235046000065],
            [14.659187459000066, 48.57695851700008],
            [14.651332641000124, 48.58349558500005],
            [14.645441529000038, 48.592900696000086],
            [14.634692831000109, 48.60233164500006],
            [14.628181600000033, 48.60328765900003],
            [14.612885376000094, 48.59974782300007],
            [14.605133911000081, 48.600316264000114],
            [14.601929973000097, 48.60452789300005],
            [14.601826619000065, 48.611194153000056],
            [14.600586385000042, 48.617576193],
            [14.594178507000095, 48.62132273400003],
            [14.578778930000112, 48.620495911],
            [14.548806599000073, 48.610935771000086],
            [14.533820434000091, 48.60871368400008],
            [14.522038208000083, 48.610625712000015],
            [14.48214400200007, 48.624474997000064],
            [14.458166137000148, 48.643181865000074],
            [14.443593384000081, 48.63651560500004],
            [14.421165812000083, 48.59706064900003],
            [14.4053528230001, 48.5862861130001],
            [14.353366333000082, 48.571429139000074],
            [14.333212525000079, 48.56070627900006],
            [14.325357706000148, 48.55863922100009],
            [14.31574589000013, 48.557915752],
            [14.216527140000096, 48.58117014600002],
            [14.074830363000075, 48.59171213900008],
            [14.040827270000136, 48.60116892500004],
            [14.032455688000084, 48.606129863],
            [14.015195760000097, 48.62039255800006],
            [14.010854939000097, 48.62587026000007],
            [14.00620406000013, 48.63951283800007],
            [14.008064412000039, 48.64240671800006],
            [14.013748820000103, 48.64380198200003],
            [14.020466756000104, 48.653155416000075],
            [14.02346398900005, 48.65460235600007],
            [14.028321574000046, 48.65398223900009],
            [14.032869100000084, 48.65491241400004],
            [14.03472945100009, 48.66116526300006],
            [14.032145630000088, 48.66726308200002],
            [14.026151164000055, 48.67005361000007],
            [14.019226521000093, 48.67191396100007],
            [14.014162231000114, 48.67506622300003],
            [14.00775435400007, 48.68328277600007],
            [13.991114543000037, 48.70018097000006],
            [13.98232954900007, 48.70648549400006],
            [13.915046834000066, 48.73098012400003],
            [13.89313602700011, 48.74302073200009],
            [13.87494592300007, 48.75242584300004],
            [13.855928996000102, 48.759298808000025],
            [13.815724731000074, 48.766430156000055],
            [13.796191040000082, 48.77981435200009],
            [13.747925252000073, 48.84337636300005],
            [13.724670858000138, 48.867302552000055],
            [13.710614868000022, 48.87247019500005],
            [13.673356160000111, 48.87634592800002],
            [13.654442586000073, 48.88223704000002],
            [13.637389363000125, 48.89345082600006],
            [13.621783081000103, 48.9090571090001],
            [13.611137736000103, 48.92724721300006],
            [13.608657267000126, 48.94616078700007],
            [13.590467163000085, 48.94481720000003],
            [13.573413940000137, 48.95101837200009],
            [13.55646407100005, 48.959958395000044],
            [13.53889408300006, 48.96703806600006],
            [13.522395447000093, 48.969341930000084],
            [13.515949747000036, 48.97024200500003],
            [13.50210046400008, 48.96605621400009],
            [13.492592, 48.955049133],
            [13.482256713000083, 48.93763417600006],
            [13.45889896600005, 48.94502390600006],
            [13.427272990000034, 48.959958395000044],
            [13.398540893000131, 48.97768341100006],
            [13.384174845000132, 48.993031311000024],
            [13.38355472800015, 49.02109161400004],
            [13.372392618000049, 49.03850657200006],
            [13.32991459100009, 49.06692861],
            [13.299528849000126, 49.093645325000054],
            [13.287333211000117, 49.10056996700003],
            [13.267282755000082, 49.10563425700012],
            [13.206821330000139, 49.10749460900011],
            [13.178502645000066, 49.11834666000006],
            [13.162586303000126, 49.13514150000013],
            [13.149460489000148, 49.15483022100007],
            [13.055822795000012, 49.238184306000036],
            [13.043420451000145, 49.24278350900006],
            [13.043213745000088, 49.242886861],
            [13.011277710000115, 49.26779490200006],
            [13.006730184000077, 49.277096659],
            [13.005386597000012, 49.28676015300003],
            [12.999805542000104, 49.294925029000055],
            [12.982442261000074, 49.29962758400002],
            [12.954330282000058, 49.319109599000015],
            [12.9398608810001, 49.3267577110001],
            [12.92291101100011, 49.33270050100002],
            [12.884670451000119, 49.33957346700008],
            [12.870924519000084, 49.336731263],
            [12.875368693000098, 49.323863831000025],
            [12.856661825000089, 49.32221018500006],
            [12.797750692000108, 49.3278429170001],
            [12.777906941000111, 49.332545472000064],
            [12.762093953000118, 49.34324249300006],
            [12.729331095000106, 49.39114654600009],
            [12.709177286000028, 49.40473744700007],
            [12.663081909000113, 49.41889679000003],
            [12.643548218000092, 49.42949045800002],
            [12.632179402000105, 49.44395985900003],
            [12.627218465000055, 49.460186259000054],
            [12.624324585000068, 49.493000794000054],
            [12.622980998000116, 49.50984731000004],
            [12.61553959200009, 49.513774720000114],
            [12.604997599000114, 49.512792867000044],
            [12.593732137000075, 49.51501495400005],
            [12.58288008700012, 49.52240468300006],
            [12.575025268000076, 49.529897766],
            [12.568720744000075, 49.53883778900011],
            [12.562312867000117, 49.55082672200008],
            [12.558282104000028, 49.56255727200006],
            [12.55363122500006, 49.58472646100007],
            [12.546603230000073, 49.59557851200013],
            [12.536061239000105, 49.603123271000086],
            [12.512186727000113, 49.611649882],
            [12.501954793000039, 49.61971140600009],
            [12.50267826300012, 49.622140198000054],
            [12.507432495000103, 49.62999501600008],
            [12.499474324000062, 49.632527161000084],
            [12.496890503000145, 49.633870748000035],
            [12.505365437000137, 49.64611806300006],
            [12.504641968000072, 49.65939890500006],
            [12.49637373900012, 49.66999257500005],
            [12.482524454000043, 49.674695130000046],
            [12.44924483200009, 49.68503041600003],
            [12.433948608000065, 49.69180002900008],
            [12.419582560000038, 49.70022328700007],
            [12.398911987000133, 49.719498597],
            [12.388576700000016, 49.732314351000085],
            [12.38361576300008, 49.74285634400006],
            [12.395397990000077, 49.75789418600003],
            [12.436739135000096, 49.76926300100003],
            [12.452655477000121, 49.779701640000056],
            [12.455859415000106, 49.79613474600002],
            [12.456376180000035, 49.817115377000036],
            [12.46247399900011, 49.831223043000065],
            [12.482524454000043, 49.82724395800007],
            [12.489862508000044, 49.84269521100008],
            [12.51291019700011, 49.87023874900005],
            [12.520971720000091, 49.88553497300002],
            [12.52407230600005, 49.9049653120001],
            [12.517871135000064, 49.91220001200007],
            [12.50360843900009, 49.91576568700005],
            [12.462680705000139, 49.931268616000054],
            [12.463817586000062, 49.94212066600009],
            [12.470742228000063, 49.955608216000044],
            [12.468158406000043, 49.97023264600004],
            [12.451311889000067, 49.98056793200003],
            [12.414518270000059, 49.98304840100012],
            [12.39922204600012, 49.992763570000065],
            [12.398188517000051, 49.992763570000065],
            [12.246879923000108, 50.04495676700013],
            [12.243675984000049, 50.05131296900005],
            [12.243469279000095, 50.060408020000025],
            [12.241402221000044, 50.070639954000015],
            [12.232513875000109, 50.080510152],
            [12.218044474000095, 50.088571676000086],
            [12.202024780000045, 50.0945144650001],
            [12.187865438000074, 50.10283437200006],
            [12.179183797000121, 50.117975566000084],
            [12.178563680000053, 50.13296173100004],
            [12.185591675000069, 50.15569936100012],
            [12.182697795000081, 50.170737203],
            [12.175049682000093, 50.18262278300004],
            [12.163784220000139, 50.19378489200007],
            [12.139289592000097, 50.211044820000055],
            [12.089886922000062, 50.230836894000035],
            [12.079551635000144, 50.24272247300006],
            [12.09205733300007, 50.25481475800005],
            [12.102392619000057, 50.25915557900002],
            [12.109110555000086, 50.263806458],
            [12.110970906000091, 50.27662221300007],
            [12.107250203000092, 50.29088490800005],
            [12.099188680000083, 50.29977325500006],
            [12.076140991000045, 50.315172831000055],
            [12.101343547000027, 50.313980338000064],
            [12.149314819000011, 50.311710511000015],
            [12.16853845200012, 50.302977193000046],
            [12.174429565000139, 50.29372711200004],
            [12.174119507000057, 50.27657053700007],
            [12.178046916000113, 50.26876739500004],
            [12.189209025000139, 50.262462871000125],
            [12.20378177900011, 50.259568990000034],
            [12.232513875000109, 50.259103902000035],
            [12.239645223000139, 50.25657175800002],
            [12.24295251500007, 50.25295440700005],
            [12.242435750000112, 50.248355204000106],
            [12.237991577000116, 50.24272247300006],
            [12.23644128400008, 50.24256744500012],
            [12.235097697000128, 50.24225738500003],
            [12.233754110000064, 50.24168894399999],
            [12.232513875000109, 50.240965475000095],
            [12.229826701000093, 50.239053447000074],
            [12.228896525000039, 50.237038066000125],
            [12.229930054000107, 50.23481597900012],
            [12.232513875000109, 50.232490540000086],
            [12.249980510000057, 50.22117340100003],
            [12.254321330000039, 50.21740102100007],
            [12.258455445000067, 50.210889791000014],
            [12.260212443000057, 50.205050355000125],
            [12.26124597200004, 50.19988271100003],
            [12.273234904000077, 50.172339173000054],
            [12.28336348400012, 50.16221059200008],
            [12.300416707000068, 50.16081532800011],
            [12.314369344000056, 50.167326559000074],
            [12.314369344000056, 50.176214905000094],
            [12.308581583000091, 50.186911927],
            [12.305584351000078, 50.19931427000007],
            [12.308684936000105, 50.21709096300002],
            [12.314059286000088, 50.22649607400005],
            [12.333799683000052, 50.24272247300006],
            [12.336486857000068, 50.25858713800007],
            [12.344651733000092, 50.266390280000095],
            [12.355813842000117, 50.27140289400005],
            [12.367182658000104, 50.27905100500003],
            [12.398188517000051, 50.315172831000055],
            [12.408937215000066, 50.321994121],
            [12.438289429000122, 50.332536113000074],
            [12.450175008000144, 50.33935740200012],
            [12.453792359000147, 50.34070099000009],
            [12.462784058000096, 50.34049428300004],
            [12.466814819000092, 50.341889547],
            [12.468985229000083, 50.345558574],
            [12.46836511300009, 50.349485983000065],
            [12.46702152500012, 50.35284495100008],
            [12.466814819000092, 50.354912008000056],
            [12.469501994000098, 50.35940785800007],
            [12.471569051000074, 50.36447214800005],
            [12.475083048000045, 50.3694330850001],
            [12.482524454000043, 50.373567200000124],
            [12.510223022000076, 50.38876007100005],
            [12.550530640000119, 50.39635650700011],
            [12.62535811400005, 50.399922181000065],
            [12.678791544000063, 50.3937210080001],
            [12.6918140060001, 50.39465118400004],
            [12.702976115000041, 50.401524150000014],
            [12.725093628000138, 50.42343495800007],
            [12.737909383000044, 50.43154815700008],
            [12.75423913600008, 50.435320536000106],
            [12.770258830000046, 50.43594065400008],
            [12.788138875000072, 50.434338684000025],
            [12.794340047000077, 50.43588897700006],
            [12.80839603700008, 50.44183176700007],
            [12.817387736000029, 50.44302032500009],
            [12.82575931800011, 50.44141835600006],
            [12.918363485000071, 50.405399882000054],
            [12.952573283000078, 50.40415964800003],
            [12.960631103000111, 50.40923412300005],
            [12.982442261000074, 50.422969870000045],
            [12.996601603000045, 50.433666891000044],
            [13.003112833000102, 50.4519086720001],
            [13.00962406400015, 50.49268137600008],
            [13.017892293000102, 50.49635040400007],
            [13.026263875000097, 50.49764231400003],
            [13.03453210400005, 50.496505432000035],
            [13.042283570000052, 50.492784729],
            [13.051068563000115, 50.49113108400006],
            [13.06037032100005, 50.4906143190001],
            [13.069775431000096, 50.49107940700004],
            [13.078870483000088, 50.49268137600008],
            [13.078973836000102, 50.49268137600008],
            [13.079180542000074, 50.492784729],
            [13.107395874000133, 50.4989859010001],
            [13.160105835000138, 50.49702219700005],
            [13.184703817000127, 50.50875274700006],
            [13.199069865000126, 50.525340882000066],
            [13.232349487000079, 50.58202992800007],
            [13.251779825000142, 50.58089304700006],
            [13.268006226000068, 50.57365834600007],
            [13.284646037000101, 50.56895579000009],
            [13.305626668000087, 50.575777080000066],
            [13.316272013000088, 50.596034241000055],
            [13.32185306800011, 50.60239044300009],
            [13.359370158000104, 50.61934031200009],
            [13.365364624000108, 50.62347442700012],
            [13.36598474100009, 50.62709177700002],
            [13.36877526800015, 50.62833201100004],
            [13.380970906000073, 50.62548980700008],
            [13.386345256000112, 50.621614075000096],
            [13.400401245000126, 50.60657623400003],
            [13.407015828000056, 50.60130523700009],
            [13.429340048000114, 50.59432891900009],
            [13.447943563000052, 50.59727447600001],
            [13.464893432000054, 50.607092998000056],
            [13.482256713000083, 50.620890605000014],
            [13.492178589000076, 50.624456279000086],
            [13.498173055000109, 50.62915883400005],
            [13.49910323000006, 50.635204977000015],
            [13.493315471000074, 50.64321482300009],
            [13.509955281000117, 50.651224671000065],
            [13.523287801000038, 50.66218007500005],
            [13.527215210000094, 50.675667623],
            [13.515639689000068, 50.691015524000065],
            [13.556567423000075, 50.706725159000044],
            [13.601939331000096, 50.712151185000025],
            [13.691752970000096, 50.711841126000124],
            [13.71102828000005, 50.714269918000085],
            [13.74906213400007, 50.723209941000036],
            [13.770662882000039, 50.7246052040001],
            [13.816551554000114, 50.72134958900001],
            [13.834534953000087, 50.723675029000034],
            [13.863473755000143, 50.735147197000074],
            [13.869571574000105, 50.7352505490001],
            [13.87535933400008, 50.73654246100004],
            [13.882180624000057, 50.74274363200003],
            [13.882697388000082, 50.748014628000064],
            [13.880320272000034, 50.75504262300008],
            [13.879080037000108, 50.76351755800006],
            [13.883317505000065, 50.773232727],
            [13.892515910000043, 50.78041575200005],
            [13.900990844000148, 50.780622457000035],
            [13.910706014000084, 50.77876210500001],
            [13.923315064000121, 50.779950664000026],
            [13.933546997000093, 50.78480824800006],
            [13.948843221000061, 50.79721059200004],
            [13.959591919000076, 50.80206817700004],
            [13.979125610000096, 50.80475535100008],
            [14.015712524000037, 50.80175811800005],
            [14.034936157000061, 50.80258494100009],
            [14.1907922770001, 50.8479051720001],
            [14.202987915000108, 50.855139873000056],
            [14.221281372000078, 50.872606507000015],
            [14.232133423000022, 50.87937611900004],
            [14.268100220000093, 50.88413035100005],
            [14.34654504400001, 50.88020294200008],
            [14.375897257000076, 50.89596425400005],
            [14.381891724000127, 50.920872294000034],
            [14.355226685000076, 50.93063914000008],
            [14.318329712000065, 50.93751210600006],
            [14.292801554000107, 50.95348012400008],
            [14.293731730000076, 50.96397043900005],
            [14.302206665000057, 50.96769114200005],
            [14.303756958000093, 50.969706523000085],
            [14.283809855000072, 50.97482249000008],
            [14.250013469000095, 50.97761301700005],
            [14.238334595000111, 50.98247060200005],
            [14.249496704000137, 50.99265085900002],
            [14.263552694000055, 51.02143463200004],
            [14.287530558000071, 51.03683420800003],
            [14.319363240000115, 51.04001230900009],
            [14.356570272000056, 51.032338359],
            [14.364115031000097, 51.02799753800004],
            [14.369386027000104, 51.02244232200012],
            [14.375897257000076, 51.01699045900004],
            [14.386749308000049, 51.01326975600004],
            [14.39780806400006, 51.0131147260001],
            [14.425816691000136, 51.0209437060001],
            [14.462093547000109, 51.01965179400007],
            [14.473462362000106, 51.023372498000086],
            [14.48214400200007, 51.03719594300013],
            [14.48793176300012, 51.02872100900002],
            [14.49010217300011, 51.022700704],
            [14.493512818000056, 51.016706238000054],
            [14.502917928000102, 51.00851552400003],
            [14.515320272000082, 51.00303782200005],
            [14.542295369000101, 50.99874867800007],
            [14.554594360000038, 50.99265085900002],
            [14.566686645000118, 50.98340077800002],
            [14.574334758000106, 50.97549428300006],
            [14.577435343000047, 50.96572743700001],
            [14.575574992000043, 50.95068959600003],
            [14.567823527000144, 50.938648987000064],
            [14.555834594000089, 50.924282939000065],
            [14.5503568930001, 50.91208730100003],
            [14.561829061000111, 50.90635121700008],
            [14.617122843000118, 50.920872294000034],
            [14.629215128000112, 50.92071726600007],
            [14.634589478000066, 50.9094001270001],
            [14.628801717000101, 50.89611928300009],
            [14.61185184700011, 50.87095286100005],
            [14.608337850000055, 50.85307281500009],
            [14.61319543500008, 50.845579732000076],
            [14.647921997000111, 50.83937856100009],
            [14.662184692000068, 50.834365946000034],
            [14.70042525200006, 50.815969137000124],
            [14.737528931000043, 50.81069814100009],
            [14.759233032000054, 50.810181376000045],
            [14.775356079000119, 50.812971904],
            [14.785071248000065, 50.82005157500002],
            [14.794579712000143, 50.83162709600008],
            [14.810392700000136, 50.858447164000054],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Germany',
        iso3: 'DEU',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [13.815724731000074, 48.766430156000055],
              [13.785855754000067, 48.72477895100003],
              [13.783581991000062, 48.71527048800006],
              [13.788749634000055, 48.71651072300007],
              [13.799394979000056, 48.70260976200011],
              [13.804355916000105, 48.69956085200009],
              [13.816861612000082, 48.69558176700009],
              [13.803529093000066, 48.687158508000024],
              [13.800945272000064, 48.67522125300006],
              [13.8062162680001, 48.642923483000075],
              [13.805492798000103, 48.626128642000126],
              [13.802392211000068, 48.6117109180001],
              [13.796191040000082, 48.59858510400004],
              [13.77903446400012, 48.57393544600005],
              [13.774280233000127, 48.56920705200007],
              [13.766012003000071, 48.56375518800009],
              [13.758053833000105, 48.56148142500005],
              [13.737279907000072, 48.559259339000064],
              [13.733869263000145, 48.559776103],
              [13.72539432800005, 48.54838145000009],
              [13.716505981000125, 48.521690572000054],
              [13.71433557100005, 48.52321502700006],
              [13.673356160000111, 48.53548818000009],
              [13.658059936000143, 48.55109446300004],
              [13.641833537000139, 48.55910430900012],
              [13.624366902000105, 48.565357158000026],
              [13.520703979000132, 48.58458079100005],
              [13.487217652000112, 48.58158355700003],
              [13.454558146000068, 48.57344451900012],
              [13.445566447000118, 48.567915141000114],
              [13.44008874500011, 48.56096466100003],
              [13.440708862000093, 48.55734731100004],
              [13.443706095000096, 48.55285146100003],
              [13.447736857000109, 48.53481638600003],
              [13.457038615000045, 48.5251787320001],
              [13.45920902500012, 48.51639373800002],
              [13.456418498000062, 48.506652731000074],
              [13.442982625000099, 48.48771331900012],
              [13.438228394000106, 48.47854075200003],
              [13.436368042000112, 48.469238994000094],
              [13.438228394000106, 48.44099782400012],
              [13.436161336000055, 48.4305850220001],
              [13.431717163000144, 48.42371205700003],
              [13.427169637000105, 48.41854441300002],
              [13.425205932000068, 48.41337677000003],
              [13.41952152500005, 48.39216359500007],
              [13.405568888000062, 48.37658315100002],
              [13.307797079000068, 48.31963572200006],
              [13.274207397000055, 48.307104187000036],
              [13.136438029000118, 48.29105865500007],
              [13.032775106000145, 48.26356679300001],
              [13.01665205900008, 48.255892843000126],
              [12.979445027000054, 48.23201833200004],
              [12.947198934000113, 48.22000356100007],
              [12.931696004000088, 48.2116319790001],
              [12.933039591000068, 48.209254863000055],
              [12.877642456000103, 48.202046001],
              [12.862552938000107, 48.196645813000046],
              [12.85345788600003, 48.189979553000015],
              [12.835164429000145, 48.170704244],
              [12.82214196800004, 48.16067901700005],
              [12.782351115000012, 48.142023825000095],
              [12.778320353000112, 48.138716533],
              [12.764057658000127, 48.12375620500002],
              [12.75795983900008, 48.121895854000016],
              [12.751448608000118, 48.12210256000007],
              [12.745040731000074, 48.12062978200008],
              [12.738942912000113, 48.113446757000034],
              [12.736979207000076, 48.09995920900006],
              [12.742043498000072, 48.08678171800007],
              [12.750931844000064, 48.07474111],
              [12.760233602000113, 48.06487091100003],
              [12.830616903000134, 48.01546824200001],
              [12.845603068000088, 47.993144023000056],
              [12.84824627100005, 47.98238892000002],
              [12.848600301000118, 47.98094838500002],
              [12.853974650000083, 47.97048390700009],
              [12.86203617300015, 47.962551575000035],
              [12.88601403800007, 47.95288808200009],
              [12.906167847000063, 47.9389096070001],
              [12.914229370000044, 47.93598988900003],
              [12.931075887000105, 47.924879456],
              [12.964975626000125, 47.87196279000001],
              [12.986576375000112, 47.85025868800001],
              [12.99122725400008, 47.84710642600005],
              [12.926735067000038, 47.77739491800013],
              [12.921257365000145, 47.76954010100009],
              [12.91929366100004, 47.763183899000055],
              [12.91898360200014, 47.75677602200001],
              [12.917226603000074, 47.75016143800012],
              [12.910818726000116, 47.743081767],
              [12.91061201900007, 47.742926738000065],
              [12.892008504000103, 47.723548076],
              [12.90833825600015, 47.71236012900006],
              [12.96404545100009, 47.705357971000055],
              [12.979031616000043, 47.70708913200012],
              [13.004353068000029, 47.71460805300005],
              [13.01985599800014, 47.712928569],
              [13.032258341000102, 47.706624044000094],
              [13.044557332000068, 47.69657297800005],
              [13.064091024000078, 47.67399037700004],
              [13.072049194000044, 47.659469299000065],
              [13.074839722000092, 47.646653545],
              [13.07421960400012, 47.63450958300008],
              [13.072049194000044, 47.622417298000116],
              [13.069568725000067, 47.62024688700002],
              [13.057683146000016, 47.60042897600003],
              [13.057063029000062, 47.5976642860001],
              [13.040939982000083, 47.583349915],
              [13.038252807000049, 47.58402170900008],
              [13.039079631000078, 47.561335755000115],
              [13.041250041000069, 47.56190419600007],
              [13.040113159000043, 47.56045725500009],
              [13.030604696000069, 47.54425669400008],
              [13.028124227000092, 47.541647034000064],
              [13.028124227000092, 47.524232077000036],
              [13.028951050000103, 47.51803090500006],
              [13.031224812000119, 47.51255320300005],
              [13.034428751000092, 47.50743723600006],
              [13.037012573000112, 47.50136525500004],
              [13.03732263100008, 47.49304535000006],
              [13.008797241000138, 47.47010101400012],
              [13.001872599000052, 47.466018576000025],
              [12.991123901000037, 47.46568267900004],
              [12.984922729000061, 47.46826650000013],
              [12.979341674000125, 47.47224558600003],
              [12.969729858000022, 47.475733745000056],
              [12.959291219000079, 47.475527039],
              [12.951022990000126, 47.472478130000084],
              [12.942548055000145, 47.47048858700005],
              [12.931592651000074, 47.47351165800005],
              [12.882603393000068, 47.498574728000065],
              [12.83692142700005, 47.53265533500003],
              [12.828446492000126, 47.537254538000084],
              [12.81904138100009, 47.5395283000001],
              [12.803641805000098, 47.541336975],
              [12.778940470000094, 47.55482452400004],
              [12.773669474000144, 47.579500021000044],
              [12.785865112000067, 47.60267690100004],
              [12.81315026900009, 47.61182362900003],
              [12.793306518000094, 47.62479441300006],
              [12.767364950000058, 47.636369935000104],
              [12.751655314000061, 47.64939239600004],
              [12.761990600000075, 47.66685902900009],
              [12.744834025000017, 47.66536041300007],
              [12.688713419000067, 47.675127259000035],
              [12.653056681000095, 47.675127259000035],
              [12.617399943000095, 47.66933949800007],
              [12.59838301500011, 47.66287994400001],
              [12.563374919000069, 47.641761370000054],
              [12.553837931000118, 47.6360081990001],
              [12.538231649000096, 47.63133148200005],
              [12.51714766400005, 47.62854095500008],
              [12.496580444000074, 47.62890269000006],
              [12.482524454000043, 47.633579407000056],
              [12.45275883000005, 47.649754130000034],
              [12.44469730600008, 47.65629119900002],
              [12.439219604000073, 47.664481914000035],
              [12.428780965000044, 47.685798442000035],
              [12.424130086000076, 47.691560365],
              [12.407696980000111, 47.69373077400009],
              [12.36842289200004, 47.68355051700003],
              [12.35147302300004, 47.681690166000024],
              [12.293698771000038, 47.69001007100009],
              [12.271891317000012, 47.68789133700001],
              [12.249567098000057, 47.68001068200006],
              [12.238715047000113, 47.67889963900005],
              [12.22879317200011, 47.684868266000066],
              [12.223315470000017, 47.69590118400008],
              [12.226622762000119, 47.70287750200008],
              [12.233030639000049, 47.7088719690001],
              [12.236544637000122, 47.71677846300004],
              [12.239128459000113, 47.72744964600004],
              [12.242229044000055, 47.732023011000095],
              [12.239748576000096, 47.73168711400011],
              [12.22517582200004, 47.72737213200013],
              [12.216494181000058, 47.723703105000126],
              [12.192412964000113, 47.71016388000005],
              [12.17659997600012, 47.70582305900008],
              [12.178563680000053, 47.69765818300006],
              [12.181767619000112, 47.69212880500005],
              [12.18910567200004, 47.685565898000064],
              [12.197270549000052, 47.680088196000085],
              [12.202334839000116, 47.67778859500005],
              [12.20512536600009, 47.672285055000074],
              [12.206779012000112, 47.64556833900009],
              [12.205745483000044, 47.636214905000074],
              [12.202128133000144, 47.62983286600003],
              [12.1736027420001, 47.605079855],
              [12.165644572000133, 47.60396881100009],
              [11.935891154000018, 47.61073842400005],
              [11.851968627000105, 47.599162903],
              [11.840703166000054, 47.59461537700007],
              [11.830677938000122, 47.57761383100005],
              [11.820342651000118, 47.575288391000115],
              [11.764015340000128, 47.58311737100003],
              [11.682573283000096, 47.583349915],
              [11.63895837400014, 47.5892410280001],
              [11.620458211000113, 47.58965444000002],
              [11.6170475670001, 47.58676056000003],
              [11.589142293000094, 47.57037913100008],
              [11.58232100400005, 47.559785462],
              [11.574466186000109, 47.53663442],
              [11.569401896000045, 47.527384339],
              [11.551211792000089, 47.51369008400006],
              [11.529507690000116, 47.50785064800009],
              [11.482585490000048, 47.50257965100006],
              [11.459951212000107, 47.50743723600006],
              [11.435353231000107, 47.50971099900009],
              [11.412615600000038, 47.506093648],
              [11.36548669400014, 47.46932586700002],
              [11.377785685000077, 47.4670521040001],
              [11.388637736000135, 47.462220357],
              [11.392461792000063, 47.45477895100005],
              [11.383883504000039, 47.444857076000076],
              [11.36765710500012, 47.44012868300008],
              [11.324248901000118, 47.439431051],
              [11.305645385000076, 47.43540029000009],
              [11.286318400000113, 47.42320465100009],
              [11.273089233000121, 47.4111123660001],
              [11.25882653800005, 47.40072540300007],
              [11.23701908300012, 47.39395579000005],
              [11.213041219000019, 47.395816142000044],
              [11.215211629000095, 47.422997945000034],
              [11.193817587000098, 47.42894073500004],
              [11.168599487000051, 47.42426401800007],
              [11.103280477000084, 47.39356821800003],
              [11.083746785000102, 47.38951161800013],
              [10.979463745000146, 47.39054514600009],
              [10.965511108000072, 47.3960745240001],
              [10.955279175000072, 47.40961375000008],
              [10.95765629100012, 47.409717103000034],
              [10.960860229000104, 47.41431630500007],
              [10.96313399200011, 47.421240947000044],
              [10.962823934000141, 47.42795888300007],
              [10.959826701000111, 47.43250640900003],
              [10.909907267000051, 47.46898997000004],
              [10.858437540000068, 47.485164693000016],
              [10.851616252000014, 47.493097026000086],
              [10.883862346000086, 47.508005676000025],
              [10.892233928000053, 47.5148786430001],
              [10.86928959100004, 47.52658335400007],
              [10.858644247000115, 47.530665792],
              [10.844794962000066, 47.53131174700006],
              [10.830635620000123, 47.528572896000114],
              [10.79032800300007, 47.51606720000002],
              [10.760769083000127, 47.513638407000045],
              [10.752190795000104, 47.515395406000025],
              [10.74722985800014, 47.52014963800012],
              [10.74392256700014, 47.52531728100003],
              [10.73989180500007, 47.52846954400009],
              [10.607910197000109, 47.562265930000066],
              [10.58372562700012, 47.56247263600004],
              [10.569876343000061, 47.55593556700005],
              [10.549619181000054, 47.53678945000006],
              [10.536906779000105, 47.529864808000056],
              [10.525124552000108, 47.52846954400009],
              [10.482543172000135, 47.53286204000007],
              [10.466936890000085, 47.53771962500009],
              [10.458772013000072, 47.541647034000064],
              [10.453501017000065, 47.546246236000016],
              [10.451744018000085, 47.55482452400004],
              [10.455464721000084, 47.561180726000075],
              [10.460322306000108, 47.565986633000065],
              [10.461562540000045, 47.569914043000054],
              [10.457118368000124, 47.579241638000084],
              [10.453604370000079, 47.58110199],
              [10.445956258000109, 47.579060771000044],
              [10.429213094000147, 47.57701955200007],
              [10.41422692900008, 47.57301462800008],
              [10.415673868000084, 47.56438466500005],
              [10.424355509000122, 47.55335174600005],
              [10.430970093000042, 47.542163798],
              [10.429729858000087, 47.532913717],
              [10.41960127800013, 47.49304535000006],
              [10.433657267000058, 47.48785186800005],
              [10.442235555000082, 47.481392314000104],
              [10.447609904000046, 47.4725814830001],
              [10.451744018000085, 47.46020497700003],
              [10.451950724000113, 47.438759257000115],
              [10.442855672000064, 47.41628001000002],
              [10.428282918000093, 47.3960486860001],
              [10.411643107000089, 47.38103668300003],
              [10.403064819000036, 47.37710927300007],
              [10.381980835000121, 47.37212249800011],
              [10.371645549000107, 47.36739410400013],
              [10.365651082000085, 47.36111541800001],
              [10.343430216000058, 47.330755514000074],
              [10.325446818000046, 47.3143224090001],
              [10.305913126000064, 47.30217844700009],
              [10.2611613360001, 47.28349741600003],
              [10.239353882000074, 47.277735494000055],
              [10.17495085000013, 47.27237555400005],
              [10.159875529000061, 47.27112091100007],
              [10.155431355000076, 47.27287790900003],
              [10.15946211800005, 47.27913075800005],
              [10.168660522000067, 47.290422058],
              [10.172691284000052, 47.292308248000026],
              [10.185920451000129, 47.29499542300006],
              [10.190778036000069, 47.29825103800003],
              [10.193258504000141, 47.304917298000035],
              [10.192741739000098, 47.31091176400007],
              [10.190467977000083, 47.317474671000056],
              [10.208554729000099, 47.35447499600009],
              [10.209278198000078, 47.372484233000094],
              [10.190881388000093, 47.37922800800003],
              [10.146956420000066, 47.373801982000074],
              [10.135070842000118, 47.36488779700004],
              [10.130833374000076, 47.36266571100005],
              [10.125665731000083, 47.36269154900005],
              [10.11533044400008, 47.36695485500009],
              [10.110369507000115, 47.36739410400013],
              [10.097243693000053, 47.363130799000075],
              [10.089595581000083, 47.359280904000016],
              [10.082877644000064, 47.35907419900006],
              [10.073162475000117, 47.36548207600002],
              [10.067788127000142, 47.375042217],
              [10.066857951000088, 47.385790914000026],
              [10.064170776000054, 47.396177878000046],
              [10.053215373000086, 47.404859518000094],
              [10.07595300300008, 47.41687428800007],
              [10.080603881000116, 47.42739044200003],
              [10.071818888000053, 47.43912099300012],
              [10.022622924000075, 47.487955221000064],
              [10.011254110000095, 47.48444122400012],
              [10.002365764000075, 47.4791702270001],
              [9.99358077000008, 47.476586406000095],
              [9.982625366000093, 47.481030579],
              [9.981075073000085, 47.48687001600008],
              [9.980765015000088, 47.489918925000026],
              [9.980765015000088, 47.492941997000045],
              [9.971669962000135, 47.506403707000075],
              [9.95916426600013, 47.5148786430001],
              [9.948725626000083, 47.524232077000036],
              [9.945935099000053, 47.54076853400004],
              [9.933842814000059, 47.53420562800004],
              [9.918753296000148, 47.53219024700009],
              [9.88898767100008, 47.53379221600004],
              [9.858911988000102, 47.541336975],
              [9.853847697000106, 47.54040680000013],
              [9.841548706000083, 47.53503245000006],
              [9.833487182000084, 47.53461903900005],
              [9.81312666900007, 47.541750387],
              [9.809302612000124, 47.552318217000064],
              [9.811266317000047, 47.56448801700007],
              [9.80795902500006, 47.5763219200001],
              [9.796280152000065, 47.584951885000024],
              [9.782120809000048, 47.58841420500006],
              [9.767134643000048, 47.587277324000056],
              [9.75266524200012, 47.58205800400005],
              [9.730857788000094, 47.564901429000074],
              [9.718455444000114, 47.54671132400004],
              [9.7039860430001, 47.531415100000075],
              [9.676700887000095, 47.5226301070001],
              [9.612622111000064, 47.5218807990001],
              [9.554143852000095, 47.5327431110001],
              [9.549886922000042, 47.53353383400007],
              [9.547481674000068, 47.53454710200005],
              [9.273211304000142, 47.65009002700005],
              [9.234350627000083, 47.65616200800007],
              [9.196936890000131, 47.65613617000007],
              [9.183397664000069, 47.67042470400007],
              [9.12810388100013, 47.67042470400007],
              [9.016586141000118, 47.67889963900005],
              [8.997672566000091, 47.67383534800008],
              [8.981756225000055, 47.6621564740001],
              [8.945376017000086, 47.65430165600007],
              [8.906205281000041, 47.651795349000096],
              [8.881710652000095, 47.65613617000007],
              [8.8526684980001, 47.670786438000064],
              [8.851935119000075, 47.67128172300009],
              [8.837785685000142, 47.68083750400008],
              [8.837682333000117, 47.68778798500007],
              [8.856079142000112, 47.69068186400007],
              [8.830240926000101, 47.70719248500005],
              [8.797581420000114, 47.72003407900003],
              [8.77070967600011, 47.72086090100005],
              [8.761717977000075, 47.701249695000044],
              [8.769882853000098, 47.69507436100007],
              [8.71706954000004, 47.6945575970001],
              [8.715105835000116, 47.70106882700007],
              [8.712625366000054, 47.70869110100004],
              [8.70466719500007, 47.715331523000046],
              [8.700429728000131, 47.72349639900007],
              [8.70373702000012, 47.73003346800006],
              [8.71706954000004, 47.74354685500002],
              [8.719756714000084, 47.747319234000045],
              [8.71314213000008, 47.757421977],
              [8.703323608000119, 47.75871388700004],
              [8.692264852000108, 47.75716359500002],
              [8.681929565000104, 47.75873972600006],
              [8.674488159000077, 47.7666978970001],
              [8.66663334200004, 47.77827341700005],
              [8.657021525000118, 47.78811777800003],
              [8.644102417000113, 47.791011658000016],
              [8.635007365000149, 47.78460378000007],
              [8.629839721000053, 47.76279632600004],
              [8.61743737800009, 47.757318624000064],
              [8.607618856000101, 47.762253723000114],
              [8.604104858000142, 47.77439768500001],
              [8.603174682000088, 47.787316793000016],
              [8.601624390000069, 47.79460317000009],
              [8.58312422700007, 47.80023590100002],
              [8.558216187000085, 47.801166077000076],
              [8.542299846000077, 47.7950165810001],
              [8.55160160300008, 47.77925527000012],
              [8.536512085000084, 47.774087626000025],
              [8.482665242000053, 47.766852926000055],
              [8.471503133000112, 47.76705963200003],
              [8.463648315000086, 47.76390737000007],
              [8.450109090000097, 47.75047149700002],
              [8.445458211000044, 47.74318512000012],
              [8.437913452000089, 47.7231863410001],
              [8.427268107000117, 47.716468404000054],
              [8.401946655000131, 47.70708913200012],
              [8.392128133000142, 47.69951853500005],
              [8.39099125100006, 47.69212880500005],
              [8.395228719000102, 47.68481659000007],
              [8.397709188000078, 47.67628997900006],
              [8.39130131000013, 47.6654637650001],
              [8.40701094500011, 47.66156219500006],
              [8.411971883000149, 47.661045430000016],
              [8.43760339400012, 47.647842102000126],
              [8.458273966000121, 47.639883932000046],
              [8.476050659000066, 47.6404006960001],
              [8.490830119000066, 47.64556833900009],
              [8.504679402000136, 47.65226043700004],
              [8.519665568000107, 47.657350566],
              [8.568241414000113, 47.66293162100003],
              [8.582194051000101, 47.66132965100009],
              [8.593588683000092, 47.65816856000002],
              [8.598213745000066, 47.65688547800006],
              [8.607308797000115, 47.65629119900002],
              [8.601624390000069, 47.63259755500009],
              [8.595113159000107, 47.634819641],
              [8.594493042000039, 47.640969137000056],
              [8.593562866000099, 47.64257110600009],
              [8.589222046000117, 47.642467754000066],
              [8.583951050000081, 47.6411241660001],
              [8.580333699000107, 47.63900543200002],
              [8.578059936000074, 47.6334760540001],
              [8.579713583000114, 47.62892852900008],
              [8.582090698000087, 47.62502695700003],
              [8.582504110000087, 47.621590475000076],
              [8.581263875000047, 47.61476918600003],
              [8.581780639000101, 47.607663677000104],
              [8.580643758000093, 47.60017059400006],
              [8.576305366000042, 47.59502305800005],
              [8.574132527000103, 47.59244496700008],
              [8.560696655000072, 47.58939605700003],
              [8.551719149000036, 47.59686332900007],
              [8.54963789900006, 47.59859446200004],
              [8.53775231900002, 47.6121336880001],
              [8.522352742000038, 47.62190053400006],
              [8.492380411000084, 47.61983347600001],
              [8.46178796400008, 47.606139221],
              [8.450109090000097, 47.589034323000035],
              [8.448868856000075, 47.58428009100005],
              [8.421100326000044, 47.5811118700001],
              [8.41806970200011, 47.58076609400008],
              [8.354094279000037, 47.58102447500006],
              [8.316163777000014, 47.58784576400002],
              [8.306345255000053, 47.592186585],
              [8.299317260000038, 47.60182423900001],
              [8.293942912000091, 47.611461894000044],
              [8.288568562000108, 47.6158027150001],
              [8.276993042000072, 47.61662953700004],
              [8.251051473000132, 47.62200388600009],
              [8.232964721000116, 47.62195221000009],
              [8.17901452600006, 47.6158027150001],
              [8.173846883000067, 47.613528951],
              [8.168885946000103, 47.60864552800008],
              [8.162064656000041, 47.60376210500006],
              [8.14377119900007, 47.60006724100005],
              [8.122067098000088, 47.59213490800009],
              [8.113902221000075, 47.58784576400002],
              [8.105427286000065, 47.581257019000034],
              [8.10139652500007, 47.576192729000056],
              [8.09695235100014, 47.571851909000074],
              [8.08723718200011, 47.56738189700006],
              [8.042278686000088, 47.5605606080001],
              [7.91215743000015, 47.5605606080001],
              [7.909470256000105, 47.56479807600006],
              [7.907506551000097, 47.57417734800002],
              [7.904302613000112, 47.58355662100006],
              [7.898204794000065, 47.58784576400002],
              [7.83371260600012, 47.59048126300003],
              [7.819656616000117, 47.595338847000065],
              [7.801466512000076, 47.57608937600013],
              [7.78555017100004, 47.56319610600012],
              [7.766739949000055, 47.555961406000065],
              [7.727320447000125, 47.55042262400006],
              [7.683437540000114, 47.54425669400008],
              [7.661423380000116, 47.546246236000016],
              [7.64690103500007, 47.55144523600005],
              [7.609746948000094, 47.56474639900004],
              [7.612337281000094, 47.564731041000115],
              [7.635895223000091, 47.56459137000009],
              [7.646540568000091, 47.57154185000009],
              [7.65966638200004, 47.596579082000076],
              [7.637032104000099, 47.59497711200005],
              [7.586028488000125, 47.584618544000065],
              [7.590109904000144, 47.59482208300001],
              [7.592487020000078, 47.59841359500008],
              [7.590316609000098, 47.607947896000084],
              [7.58504561400008, 47.61316721600009],
              [7.578637735000115, 47.61693959600002],
              [7.5726432700001, 47.62200388600009],
              [7.550112345000088, 47.65244130500007],
              [7.536573120000099, 47.66520538400003],
              [7.521793660000071, 47.67042470400007],
              [7.517866251000015, 47.67502390600002],
              [7.514662312000041, 47.685798442000035],
              [7.511871785000096, 47.70732167600009],
              [7.515385783000056, 47.71331614200001],
              [7.531922241000132, 47.72520172200005],
              [7.537813355000139, 47.73181630400005],
              [7.538330119000079, 47.748146057000085],
              [7.525927775000099, 47.783156840000075],
              [7.528614949000143, 47.797031963000066],
              [7.542877645000118, 47.829433086000066],
              [7.548458699000122, 47.834238993000056],
              [7.561997925000099, 47.83922576900004],
              [7.564168334000101, 47.85041371700005],
              [7.55900069100008, 47.86901723300012],
              [7.559207397000137, 47.873461405000015],
              [7.558380575000115, 47.87599355100009],
              [7.557863810000072, 47.878525697],
              [7.55900069100008, 47.88271148800003],
              [7.561997925000099, 47.88705230700002],
              [7.568612508000115, 47.891367290000076],
              [7.5726432700001, 47.89630238900013],
              [7.578947795000119, 47.90632761700006],
              [7.580808146000038, 47.910797628000054],
              [7.579567911000083, 47.927049866000075],
              [7.584942261000037, 47.94040822400011],
              [7.611607300000088, 47.95939931300008],
              [7.621115763000063, 47.971439922000044],
              [7.618945353000072, 48.00265248700002],
              [7.575743856000145, 48.05370880200009],
              [7.5726432700001, 48.09497243300011],
              [7.578947795000119, 48.11448028600002],
              [7.58566573000013, 48.129724833000054],
              [7.592900431000089, 48.13866485600009],
              [7.599721720000048, 48.144710999000026],
              [7.604786010000026, 48.15256581600006],
              [7.606749715000149, 48.16698354100008],
              [7.613364298000079, 48.179205018000104],
              [7.676616252000144, 48.23840037100008],
              [7.687158243000113, 48.25292144800004],
              [7.693462769000121, 48.26987131800003],
              [7.695529825000079, 48.29018015600006],
              [7.702454467000081, 48.31118662500005],
              [7.71857751500005, 48.31999745700004],
              [7.736974325000062, 48.32666371700007],
              [7.75072025500009, 48.34136566200006],
              [7.751960490000016, 48.355344137000046],
              [7.746896199000048, 48.36867665700008],
              [7.740384969000075, 48.381440736000044],
              [7.737181030000102, 48.39348134400002],
              [7.738317912000099, 48.406607158000085],
              [7.745655965000111, 48.43301381400006],
              [7.75072025500009, 48.44440846800005],
              [7.757644897000148, 48.453891093000024],
              [7.764156128000138, 48.46035064800007],
              [7.769220419000106, 48.47006581700002],
              [7.771287475000065, 48.4891085820001],
              [7.776455119000076, 48.498177796000064],
              [7.788444051000027, 48.50634267200009],
              [7.813455444000027, 48.51946848600004],
              [7.813455444000027, 48.52634145100002],
              [7.801673217000115, 48.54758046500008],
              [7.801776571000062, 48.58235870400004],
              [7.810251506000071, 48.6150182090001],
              [7.852419475000119, 48.65868479400008],
              [7.864098348000084, 48.66416249700005],
              [7.880634806000074, 48.667728170000046],
              [7.895931030000042, 48.676513163000024],
              [7.92331953900009, 48.698217265000025],
              [7.935205119000102, 48.70333323200002],
              [7.948434285000104, 48.71185984400002],
              [7.959182983000119, 48.72136830700002],
              [7.963627157000133, 48.729274801000045],
              [7.96486739100007, 48.74834340500003],
              [7.970138387000105, 48.757283427000075],
              [7.981507202000103, 48.75976389600005],
              [8.009619181000119, 48.76007395400002],
              [8.017267293000117, 48.761830954000104],
              [8.022951701000068, 48.765086569000076],
              [8.025122111000144, 48.77061594700008],
              [8.02729252100005, 48.78002105800003],
              [8.031943400000102, 48.78534373000009],
              [8.03659427900007, 48.7882892870001],
              [8.038764689000061, 48.790769756000074],
              [8.047549682000124, 48.791028137000026],
              [8.084239950000097, 48.804050598000075],
              [8.090337769000143, 48.80751292000009],
              [8.102740112000049, 48.82131052600006],
              [8.14811202000007, 48.90373443600005],
              [8.179324585000131, 48.942698467000056],
              [8.1998915450001, 48.95825033100003],
              [8.200305216000032, 48.95856313100005],
              [8.188729695000092, 48.96574615500002],
              [8.090441121000083, 48.97918202800007],
              [7.931897827000114, 49.03483754600008],
              [7.913811075000098, 49.036181133000056],
              [7.856863647000125, 49.03225372300007],
              [7.773664591000113, 49.048118388],
              [7.762605835000102, 49.04615468300004],
              [7.739144735000139, 49.037731425000075],
              [7.726949096000112, 49.0356643680001],
              [7.717337281000113, 49.03659454400007],
              [7.696149943000052, 49.041555481],
              [7.685091187000069, 49.04279571600004],
              [7.672482137000117, 49.04103871700006],
              [7.660803264000066, 49.037731425000075],
              [7.648814331000096, 49.035716045000115],
              [7.644938840000066, 49.036294476000094],
              [7.634965047000037, 49.03778310100007],
              [7.625663289000101, 49.043002421],
              [7.61594812000007, 49.05597320600002],
              [7.608610066000068, 49.06196767200005],
              [7.586389201000117, 49.06956410700012],
              [7.542670939000061, 49.07457672200006],
              [7.52086348500012, 49.08367177400005],
              [7.507737671000058, 49.09457550100011],
              [7.485103394000106, 49.11870839500007],
              [7.471047404000103, 49.12832021200008],
              [7.472804403000083, 49.131627503000075],
              [7.475284871000042, 49.13390126600008],
              [7.482726278000058, 49.13705352800004],
              [7.476111694000082, 49.15152292900008],
              [7.458024942000065, 49.15586375000005],
              [7.414823446000128, 49.15777577800007],
              [7.410482625000043, 49.1689378870001],
              [7.39105228700015, 49.17002309200011],
              [7.371633809000087, 49.1661736140001],
              [7.367591186000084, 49.165372213000055],
              [7.350951376000069, 49.15917104200007],
              [7.346300496000111, 49.154210104000114],
              [7.339065796000028, 49.139689026000056],
              [7.33400150600005, 49.13415964800005],
              [7.326456746000105, 49.13183420800003],
              [7.305992879000144, 49.130128887000055],
              [7.297104533000038, 49.12811350500003],
              [7.290800008000105, 49.12310089200007],
              [7.280258016000062, 49.10899322600004],
              [7.274366902000054, 49.10501414000005],
              [7.268062378000138, 49.10563425700012],
              [7.241190633000144, 49.11390248600007],
              [7.154994344000016, 49.114419251000086],
              [7.139284708000048, 49.11793324800006],
              [7.123575073000097, 49.12330759700002],
              [7.085334513000106, 49.14154937800008],
              [7.079856812000116, 49.142014465],
              [7.07076175900005, 49.13612335300009],
              [7.071588582000061, 49.13059397400009],
              [7.07479252100012, 49.12537465500007],
              [7.073242228000112, 49.12031036400002],
              [7.042546427000076, 49.10759796200004],
              [7.020532267000078, 49.11896677700004],
              [7.008956746000138, 49.146406963000075],
              [7.009473510000078, 49.18170196500007],
              [6.987872762000109, 49.18242543600009],
              [6.925447632000044, 49.205576477000065],
              [6.914388876000146, 49.206661683000064],
              [6.885243367000044, 49.20480133100007],
              [6.843488810000082, 49.21105418000006],
              [6.833463583000054, 49.20945221000004],
              [6.827675822000089, 49.19555125000004],
              [6.835220581000044, 49.17937652600004],
              [6.839044637000086, 49.16278839200005],
              [6.821784709000099, 49.147750550000055],
              [6.809072306000132, 49.145838522000034],
              [6.770108276000144, 49.15529530900001],
              [6.725563192000038, 49.155553691000065],
              [6.713780965000126, 49.158860982000064],
              [6.700965210000049, 49.17286529600007],
              [6.703755737000108, 49.18511261000002],
              [6.708820027000087, 49.197773336000054],
              [6.702515503000086, 49.213638001000064],
              [6.698484741000073, 49.21358632400005],
              [6.685048868000138, 49.20779856400007],
              [6.680604696000046, 49.207488505000086],
              [6.677917521000097, 49.21105418000006],
              [6.675953817000078, 49.2189089970001],
              [6.674816935000138, 49.221131084],
              [6.671612996000079, 49.22531687500005],
              [6.663758179000041, 49.24386871300008],
              [6.659520711000084, 49.24676259400006],
              [6.645671427000138, 49.25001820900003],
              [6.640297078000089, 49.25275706000009],
              [6.639160196000148, 49.256787822],
              [6.641227254000114, 49.266916403000025],
              [6.639676961000106, 49.27115387],
              [6.573169393000029, 49.313115133000096],
              [6.556426228000078, 49.326395976000086],
              [6.550121704000077, 49.33802317300005],
              [6.555599406000056, 49.34716990200003],
              [6.573376098000097, 49.3477383430001],
              [6.577716919000068, 49.35579986600008],
              [6.574306274000037, 49.36179433200003],
              [6.525730428000145, 49.39548736600007],
              [6.518805786000058, 49.40215362600007],
              [6.520769491000095, 49.4025670380001],
              [6.520562785000038, 49.40814809200002],
              [6.517875610000118, 49.41641632100006],
              [6.511674438000114, 49.424736226],
              [6.494517863000056, 49.43553660100004],
              [6.402740519000133, 49.46545725500009],
              [6.391681763000122, 49.466697490000016],
              [6.383516886000109, 49.46463043200005],
              [6.364499959000057, 49.45610382100004],
              [6.353854614000056, 49.45476023400006],
              [6.345307071000093, 49.4553486520001],
              [6.345379679000132, 49.46271840400003],
              [6.342279094000105, 49.493000794000054],
              [6.348808550000058, 49.52528975500012],
              [6.350754028000097, 49.534910381000046],
              [6.350754028000097, 49.56658803400005],
              [6.356438435000143, 49.577595113000044],
              [6.371527954000044, 49.592994690000026],
              [6.397572876000112, 49.6138719690001],
              [6.407701457000087, 49.62741119400009],
              [6.415246216000128, 49.63464589400006],
              [6.417933390000144, 49.63914174500006],
              [6.417003215000108, 49.64575632700006],
              [6.410905396000146, 49.64963206000003],
              [6.404497518000113, 49.652474264],
              [6.402740519000133, 49.655781555],
              [6.418243449000045, 49.66988922200004],
              [6.49172733600011, 49.70079172800003],
              [6.489763631000073, 49.70296213800002],
              [6.482942342000115, 49.7080781050001],
              [6.486352986000043, 49.71293569000004],
              [6.49100386500001, 49.71443430600003],
              [6.499685506000077, 49.71221221900002],
              [6.492554158000132, 49.71841339100011],
              [6.487799926000122, 49.72559641600007],
              [6.485526163000117, 49.73376129200007],
              [6.486249634000018, 49.74270131500002],
              [6.495964803000049, 49.748230693000025],
              [6.49637821400006, 49.752106425000065],
              [6.493691040000044, 49.75655059800006],
              [6.493794392000069, 49.76363026899999],
              [6.498548624000051, 49.78538604800009],
              [6.499995564000045, 49.78605784100007],
              [6.500098918000077, 49.794481100000084],
              [6.502269327000079, 49.79587636300006],
              [6.502579387000139, 49.79566965800011],
              [6.4972050370001, 49.79944203800004],
              [6.493277629000119, 49.79959706600006],
              [6.462478475000069, 49.80548818000007],
              [6.414522746000046, 49.80548818000007],
              [6.397056111000097, 49.80858876600011],
              [6.380106242000068, 49.81556508400011],
              [6.351374145000079, 49.83329010000001],
              [6.33442427500006, 49.8402147420001],
              [6.325639282000083, 49.840369772000045],
              [6.310653116000111, 49.834478659000055],
              [6.30259159400012, 49.83494374700008],
              [6.301558065000052, 49.83830271400008],
              [6.295567892000093, 49.84861569200011],
              [6.291532837000119, 49.855562643000084],
              [6.286778605000109, 49.86104034500006],
              [6.27220585200007, 49.867138164000025],
              [6.238306111000043, 49.87690500900008],
              [6.222699829000106, 49.887136943000044],
              [6.18983361800008, 49.93829661100004],
              [6.172677043000107, 49.95622833300003],
              [6.161928345000092, 49.942482402000095],
              [6.153970174000051, 49.951215719000075],
              [6.138777303000097, 49.97932769800009],
              [6.12151737500011, 49.996277568000025],
              [6.117176554000139, 50.00439076800011],
              [6.119967081000084, 50.01550120000003],
              [6.113765910000012, 50.03637848000001],
              [6.10725467900005, 50.04459503200003],
              [6.096402629000096, 50.04862579400013],
              [6.105704386000127, 50.060304668000086],
              [6.10942509000003, 50.063560283000086],
              [6.107151327000111, 50.06376698800004],
              [6.101156861000078, 50.063405254000045],
              [6.099399861000109, 50.06412872300005],
              [6.105704386000127, 50.09224070200007],
              [6.110561971000038, 50.10598663400002],
              [6.11748661300004, 50.12045603500006],
              [6.126581665000089, 50.1273290000001],
              [6.129475545000076, 50.134046937000036],
              [6.125961547000117, 50.140196432000025],
              [6.115832967000074, 50.14546742800003],
              [6.11800337700015, 50.15037668900008],
              [6.121310668000149, 50.161590475000125],
              [6.123171020000058, 50.16489776700003],
              [6.13174930800011, 50.16830841100004],
              [6.151696411000017, 50.169341939000034],
              [6.159137817000044, 50.17244252600007],
              [6.165132284000066, 50.181899312000056],
              [6.165752400000144, 50.193164775000085],
              [6.160171346000112, 50.20453359],
              [6.146838827000096, 50.214042054000075],
              [6.15717411300011, 50.22272369400004],
              [6.179808390000062, 50.233007304000026],
              [6.189626912000023, 50.24272247300006],
              [6.210400838000083, 50.249026998],
              [6.253395630000057, 50.25677846300009],
              [6.271792439000137, 50.26742380800009],
              [6.267348267000045, 50.276415507000124],
              [6.269415324000107, 50.28649241200007],
              [6.276029907000094, 50.29610422800006],
              [6.285951782000097, 50.303855692000084],
              [6.299491007000086, 50.308868307000054],
              [6.310653116000111, 50.30824819000007],
              [6.322021932000098, 50.305405986],
              [6.335457804000043, 50.303855692000084],
              [6.36201949000008, 50.30695627900012],
              [6.374525187000074, 50.31548289100003],
              [6.373399684000105, 50.323080035000075],
              [6.372458130000098, 50.32943552700003],
              [6.337731567000077, 50.36808949800003],
              [6.336387980000097, 50.379923402000045],
              [6.34331262200007, 50.39330759700009],
              [6.350443969000111, 50.416872051000084],
              [6.351167440000012, 50.43356353800003],
              [6.347343384000084, 50.43697418300006],
              [6.340212036000139, 50.43785268200007],
              [6.331633748000115, 50.446896057000046],
              [6.326156046000108, 50.45702463800008],
              [6.32326216600012, 50.46601633700003],
              [6.325742635000097, 50.474026184000095],
              [6.336904744000037, 50.481002502000095],
              [6.31871464000011, 50.481674296000094],
              [6.27540979000014, 50.488030497000025],
              [6.260113566000086, 50.49268137600008],
              [6.257839803000053, 50.494076640000074],
              [6.255566040000133, 50.4945934040001],
              [6.253085571000071, 50.494076640000074],
              [6.25091516100008, 50.49268137600008],
              [6.217118774000085, 50.486015117000065],
              [6.207196900000099, 50.48632517500006],
              [6.199238729000029, 50.49040761300007],
              [6.190660441000091, 50.50182810500006],
              [6.182598917000121, 50.50658233700007],
              [6.190557088000077, 50.51521230100009],
              [6.178878214000093, 50.51578074200005],
              [6.170816691000113, 50.51795115200004],
              [6.169473103000144, 50.522498678],
              [6.177327922000075, 50.53019846600007],
              [6.160688110000052, 50.543582663],
              [6.17908492000015, 50.56197947200012],
              [6.210607543000037, 50.578670959000036],
              [6.232931763000096, 50.587145894000045],
              [6.232931763000096, 50.59076324500005],
              [6.244300577000075, 50.599548239000015],
              [6.251328572000091, 50.608436585000035],
              [6.249054809000086, 50.61443105100007],
              [6.180015096000119, 50.61551625600005],
              [6.159447876000115, 50.622389222000024],
              [6.147769002000047, 50.63675527000002],
              [6.161101521000063, 50.642181296],
              [6.100226685000052, 50.70129913400005],
              [6.081003052000113, 50.71349477200009],
              [6.064363240000091, 50.714476624000056],
              [6.02477909300012, 50.707551982000055],
              [6.011549926000043, 50.708533835000125],
              [6.007622518000062, 50.71690541700009],
              [6.011343221000089, 50.72744740800006],
              [6.010826457000036, 50.73705922500007],
              [5.994186645000127, 50.74258860300007],
              [5.992739705000133, 50.744448955000095],
              [5.992636353000108, 50.74625763000007],
              [5.993256469000073, 50.74806630500008],
              [5.994910116000113, 50.749926656000085],
              [5.997080525000115, 50.76294911700002],
              [5.990569295000057, 50.769046936000066],
              [5.980647420000139, 50.773439433000064],
              [5.972999308000055, 50.78181101500003],
              [5.968761841000116, 50.79462677000002],
              [5.983954712000127, 50.79219797800006],
              [5.998320760000041, 50.80072458900007],
              [6.003591756000077, 50.812610169000024],
              [6.001421346000086, 50.821808574],
              [6.000491170000117, 50.83043853800005],
              [6.009276164000113, 50.84046376500008],
              [6.023022095000073, 50.845424704000024],
              [6.045553019000067, 50.8441844690001],
              [6.056715129000111, 50.85265940400008],
              [6.062812948000072, 50.862943014000095],
              [6.063123006000069, 50.87090118400006],
              [6.054648071000145, 50.89146840400004],
              [6.056508423000139, 50.89808298800004],
              [6.061779419000089, 50.90350901300009],
              [6.063743124000041, 50.90753977500002],
              [6.031083618000139, 50.914722799000046],
              [6.007519165000133, 50.92407623300009],
              [5.999871053000078, 50.92939890600003],
              [5.997287232000076, 50.93735707600011],
              [5.995840291000064, 50.95177480100001],
              [5.999664348000096, 50.96009470600008],
              [6.005762167000057, 50.96851796500006],
              [6.003695109000091, 50.973737284],
              [5.967831665000062, 50.97099843400004],
              [5.941580037000023, 50.97647613500003],
              [5.927730754000066, 50.97766469400007],
              [5.914191529000078, 50.97523590100009],
              [5.888249959000035, 50.96712270100009],
              [5.874607381000118, 50.96536570300002],
              [5.87357385200005, 50.99058380100006],
              [5.858174275000067, 51.01934173600007],
              [5.852489868000106, 51.04275116000004],
              [5.88049849500004, 51.05205291800006],
              [5.894347778000082, 51.047143657000035],
              [5.906233358000122, 51.03740264900007],
              [5.919565877000139, 51.02970286],
              [5.937962687000038, 51.03094309500004],
              [5.950261678000089, 51.03946970700004],
              [5.969485311000113, 51.064920350000065],
              [5.982921183000144, 51.07468719500012],
              [6.075421997000092, 51.12036916100003],
              [6.132369426000082, 51.13982533800002],
              [6.147252238000107, 51.15225352],
              [6.12627160700012, 51.16457834900005],
              [6.149112589000111, 51.17633473700003],
              [6.157070760000067, 51.17925445600012],
              [6.134126424000044, 51.18421539400008],
              [6.084310344000102, 51.16269215900003],
              [6.060849243000121, 51.17090871200007],
              [6.053717895000091, 51.18938303700007],
              [6.056611776000096, 51.211707255000036],
              [6.065190063000102, 51.23162852000006],
              [6.075421997000092, 51.24266143900006],
              [6.096505981000121, 51.25881032400004],
              [6.147769002000047, 51.31816070600006],
              [6.158207641000075, 51.32459442200012],
              [6.183632446000104, 51.33570485400004],
              [6.193554321000079, 51.34451568600004],
              [6.198928670000043, 51.3569697060001],
              [6.202029256000088, 51.378880513000055],
              [6.207817016000149, 51.38766550800007],
              [6.192727499000057, 51.39895680800002],
              [6.194071086000122, 51.417379456000035],
              [6.201719197000102, 51.438644308],
              [6.205336548000105, 51.45843638200007],
              [6.20047896300008, 51.47657480900001],
              [6.19334761500005, 51.50933766700011],
              [6.153039998000082, 51.538431499000026],
              [6.086480754000092, 51.59553395600004],
              [6.082139933000121, 51.60780710900006],
              [6.087514282000086, 51.62209564200005],
              [6.099193156000069, 51.64447153800005],
              [6.031497030000054, 51.662997539000074],
              [6.008552694000116, 51.681187643],
              [6.02198856600009, 51.70950632800002],
              [6.012066691000086, 51.715862528000045],
              [5.989742472000103, 51.72637868200009],
              [5.978270304000091, 51.729789327],
              [5.949228150000096, 51.729375916],
              [5.939306274000103, 51.731882223000085],
              [5.940133097000029, 51.7426309210001],
              [5.946056400000117, 51.746288216000025],
              [5.962353963000083, 51.75635101300013],
              [5.964110962000063, 51.77655649900002],
              [5.950778442000114, 51.79590932200007],
              [5.928040812000063, 51.8067355350001],
              [5.931451457000065, 51.81564972000005],
              [5.948091268000098, 51.82296193500012],
              [5.988915650000081, 51.82745778400006],
              [6.008242635000045, 51.832573751000055],
              [6.028913208000063, 51.84210805300005],
              [6.043279256000062, 51.84686228500003],
              [6.084000284000126, 51.853657735000056],
              [6.116453084000057, 51.84828338700002],
              [6.140017537000062, 51.84453684500009],
              [6.156140584000127, 51.842056376000116],
              [6.142704712000068, 51.85518219000009],
              [6.105394327000056, 51.87947011300007],
              [6.09299198400015, 51.88530955000006],
              [6.1269950760001, 51.89673004100008],
              [6.159241170000058, 51.887299093000095],
              [6.191383911000088, 51.87115020800012],
              [6.225180298000083, 51.862546082000094],
              [6.256392862000069, 51.86680938700003],
              [6.264661092000011, 51.86618927100007],
              [6.271792439000137, 51.86190012700011],
              [6.282851196000138, 51.84960113500007],
              [6.287398722000091, 51.84616465300003],
              [6.325742635000097, 51.842547303000046],
              [6.341969034000016, 51.836682028000055],
              [6.344966268000121, 51.82110158300013],
              [6.382483358000115, 51.827586975000074],
              [6.38661747200004, 51.83756052700009],
              [6.378452596000045, 51.86011728900003],
              [6.442531372000133, 51.84836090100002],
              [6.462891887000069, 51.84836090100002],
              [6.47942834400007, 51.8530117800001],
              [6.528624308000133, 51.87642120400007],
              [6.628153117000068, 51.897505189000086],
              [6.716674846000046, 51.89926218700005],
              [6.743753296000079, 51.90833140100004],
              [6.767007690000099, 51.925513815],
              [6.789848673000108, 51.95114532500007],
              [6.798013550000121, 51.956700542000064],
              [6.805661661000102, 51.957527365],
              [6.81072595200007, 51.96057627400002],
              [6.811656127000049, 51.972797751000044],
              [6.809175659000061, 51.97954152500007],
              [6.804008016000068, 51.984373271],
              [6.778169800000029, 52.00127146500007],
              [6.7128507890001, 52.023854065000094],
              [6.690939982000117, 52.027858988],
              [6.675023641000109, 52.034809469],
              [6.672956583000143, 52.05005401600003],
              [6.679881225000116, 52.06046681800005],
              [6.688872925000084, 52.06310231600007],
              [6.699414917000126, 52.063567404000096],
              [6.711403849000106, 52.067288107000095],
              [6.719465373000077, 52.07356679300001],
              [6.7276302490001, 52.08630503300007],
              [6.73290124500005, 52.091989441000024],
              [6.749851115000126, 52.10286733000008],
              [6.765870808000102, 52.108396709],
              [6.77157568400014, 52.10879250200004],
              [6.830673055000091, 52.11289255800001],
              [6.843282105000128, 52.119998067000026],
              [6.865399617000037, 52.147799988000074],
              [6.884829956000118, 52.160331523000096],
              [6.927721395000077, 52.17190704400004],
              [6.94766849700008, 52.182810771],
              [6.971129598000061, 52.206271871000084],
              [6.981878296000076, 52.21399749800007],
              [7.026320027000054, 52.2306373090001],
              [7.029110555000017, 52.235779114000096],
              [7.026600152000071, 52.23862268699999],
              [7.02073897300005, 52.24526173900007],
              [7.011850626000125, 52.26662994400009],
              [7.012470744000098, 52.284949239000056],
              [7.019705444000067, 52.30003875800004],
              [7.039755900000102, 52.32861582500003],
              [7.048230835000112, 52.36507354700002],
              [7.034174845000081, 52.390782573000095],
              [6.973300008000137, 52.45137319000007],
              [6.966995483000034, 52.44956451500009],
              [6.960794311000143, 52.442846578000044],
              [6.951492553000037, 52.437472229],
              [6.92648116100014, 52.432976380000085],
              [6.9002295330001, 52.43191701299999],
              [6.872014200000137, 52.43473337800005],
              [6.820337769000105, 52.44682566300004],
              [6.741169474000088, 52.4536727910001],
              [6.714814494000109, 52.46155344700004],
              [6.695074097000145, 52.475609437000045],
              [6.688976278000098, 52.49051808700001],
              [6.687529337000115, 52.508139751],
              [6.684015340000144, 52.52599395800006],
              [6.671716349000121, 52.541677755000094],
              [6.688252807000111, 52.542582093000064],
              [6.743753296000079, 52.559712830000095],
              [6.710990438000096, 52.576636862],
              [6.70396244300008, 52.58307057700004],
              [6.703652384000094, 52.59139048300001],
              [6.708199911000122, 52.59968455000008],
              [6.710163615000056, 52.60865041200002],
              [6.701792032000071, 52.619114889000045],
              [6.719083149000085, 52.626758982000055],
              [6.73703536000005, 52.63469533300007],
              [6.77052168700007, 52.641025696],
              [6.865399617000037, 52.641955872000054],
              [6.918419637000056, 52.632189026],
              [6.967718953000144, 52.63665903800002],
              [6.982808471000055, 52.632783305000075],
              [7.018465210000045, 52.625987854000115],
              [7.036655314000058, 52.647381897000045],
              [7.04399336700007, 52.682625224],
              [7.053295125000091, 52.79057729100005],
              [7.061976766000043, 52.824011942000126],
              [7.072150759000124, 52.841316552000066],
              [7.079856812000116, 52.854423523],
              [7.161918986000103, 52.93263580400013],
              [7.183623088000104, 52.966122131000034],
              [7.19282149300011, 52.998006490000094],
              [7.194371786000119, 53.03384409600004],
              [7.18507002700008, 53.10544179300008],
              [7.181349324000081, 53.11417511100005],
              [7.176491740000074, 53.11939443000007],
              [7.172667684000118, 53.12575063100009],
              [7.171944214000121, 53.13771372500007],
              [7.174424682000108, 53.14577524900004],
              [7.18858402500004, 53.16778940800002],
              [7.195405314000112, 53.18499766100011],
              [7.198505900000043, 53.20057810500005],
              [7.19747237100006, 53.2166236370001],
              [7.194590691000087, 53.245021877000056],
              [7.20443769600007, 53.24827708500004],
              [7.215830925000091, 53.25560130400004],
              [7.224619988000086, 53.262925523000035],
              [7.233571811000047, 53.27362702000005],
              [7.236989780000044, 53.28554922100005],
              [7.229502800000091, 53.296576239000046],
              [7.254730665000068, 53.319525458000044],
              [7.268321160000085, 53.32367584800005],
              [7.291514519000089, 53.323919989000046],
              [7.313161655000044, 53.32050202000005],
              [7.347666863000086, 53.30735911700003],
              [7.36654707100007, 53.302801825000074],
              [7.342539910000085, 53.32404205900008],
              [7.302907748000052, 53.33274974200003],
              [7.075205925000091, 53.337591864000046],
              [7.038259311000047, 53.34857819200005],
              [7.023610873000052, 53.37641022300005],
              [7.023285352000073, 53.450506903000075],
              [7.027679884000065, 53.46735260600008],
              [7.047048373000052, 53.497707424000055],
              [7.051442905000044, 53.512600002000056],
              [7.059743686000047, 53.52171458500004],
              [7.079356316000087, 53.521551825000074],
              [7.119639519000089, 53.51630280200004],
              [7.125010613000086, 53.52435944200005],
              [7.13453209700009, 53.527411200000074],
              [7.141774936000047, 53.537176825000074],
              [7.13998457100007, 53.54979075700004],
              [7.131114129000082, 53.55695221600007],
              [7.101898634000065, 53.565741278000075],
              [7.088877800000091, 53.57371653900003],
              [7.086761915000068, 53.58685944200005],
              [7.10092207100007, 53.59788646000004],
              [7.133148634000065, 53.61127350500004],
              [7.169444207000083, 53.63548411700003],
              [7.188975457000083, 53.64350006700005],
              [7.226084832000083, 53.66648997600004],
              [7.305023634000065, 53.684800523000035],
              [7.458832227000073, 53.69513580900008],
              [7.469574415000068, 53.690741278000075],
              [7.48023522200009, 53.68203359600005],
              [7.503916863000086, 53.67865631700005],
              [7.651377800000091, 53.696966864000046],
              [7.951426629000082, 53.721909898000035],
              [8.031423373000052, 53.70807526200008],
              [8.031423373000052, 53.70062897300005],
              [8.024912957000083, 53.67255280200004],
              [8.052907748000052, 53.63629791900007],
              [8.094086134000065, 53.604722398000035],
              [8.127614780000044, 53.59076569200005],
              [8.127614780000044, 53.58462148600006],
              [8.119151238000086, 53.571926174000055],
              [8.134613477000073, 53.56745026200008],
              [8.156748894000089, 53.563666083000044],
              [8.167979363000086, 53.55320872600004],
              [8.164886915000068, 53.535223700000074],
              [8.155446811000047, 53.52602773600006],
              [8.133799675000091, 53.51630280200004],
              [8.115733269000089, 53.51072825700004],
              [8.076345248000052, 53.50861237200007],
              [8.058767123000052, 53.502020575000074],
              [8.076996290000068, 53.46869538000004],
              [8.086192254000082, 53.45612213700008],
              [8.099782748000052, 53.44741445500006],
              [8.112478061000047, 53.45107656500005],
              [8.123871290000068, 53.454006252000056],
              [8.140635613000086, 53.45359935100004],
              [8.152354363000086, 53.44977448100008],
              [8.171397332000083, 53.43659088700008],
              [8.178558790000068, 53.43374258000006],
              [8.186696811000047, 53.42951080900008],
              [8.194834832000083, 53.42011139500005],
              [8.205332879000082, 53.41071198100008],
              [8.219737175000091, 53.40643952000005],
              [8.236501498000052, 53.40672435100004],
              [8.248708530000044, 53.40839264500005],
              [8.25945071700005, 53.41229889500005],
              [8.271739129000082, 53.41950104400007],
              [8.292816602000073, 53.44049713700008],
              [8.315114780000044, 53.47492096600007],
              [8.320485873000052, 53.50922272300005],
              [8.291514519000089, 53.529364325000074],
              [8.252207879000082, 53.523098049000055],
              [8.231211785000085, 53.52521393400008],
              [8.233164910000085, 53.53986237200007],
              [8.241709832000083, 53.556301174000055],
              [8.248871290000068, 53.590277411000045],
              [8.257334832000083, 53.60443756700005],
              [8.270681186000047, 53.61286041900007],
              [8.287608269000089, 53.616888739000046],
              [8.329356316000087, 53.61810944200005],
              [8.348480665000068, 53.61286041900007],
              [8.363291863000086, 53.60057200700004],
              [8.375498894000089, 53.58690013200004],
              [8.387705925000091, 53.57713450700004],
              [8.428070509000065, 53.56476471600007],
              [8.51343834700009, 53.554754950000074],
              [8.55209394600007, 53.54360586100006],
              [8.55209394600007, 53.53620026200008],
              [8.528168165000068, 53.52391185100004],
              [8.506195509000065, 53.50796133000006],
              [8.49000084700009, 53.486395575000074],
              [8.483897332000083, 53.45734284100007],
              [8.485036655000044, 53.40119049700007],
              [8.490896030000044, 53.37645091400003],
              [8.504405144000089, 53.35805898600006],
              [8.507334832000083, 53.382798570000034],
              [8.496755405000044, 53.44525788000004],
              [8.497569207000083, 53.47475820500006],
              [8.512868686000047, 53.49648672100005],
              [8.535817905000044, 53.50617096600007],
              [8.556651238000086, 53.51821523600006],
              [8.56576582100007, 53.54669830900008],
              [8.560801629000082, 53.55170319200005],
              [8.535166863000086, 53.59076569200005],
              [8.527517123000052, 53.59662506700005],
              [8.517100457000083, 53.61017487200007],
              [8.508311394000089, 53.62514883000006],
              [8.501231316000087, 53.644191799000055],
              [8.487071160000085, 53.66693756700005],
              [8.483897332000083, 53.683579820000034],
              [8.48609459700009, 53.700425523000035],
              [8.492198113000086, 53.71515534100007],
              [8.529633009000065, 53.770697333000044],
              [8.556162957000083, 53.830959377000056],
              [8.573252800000091, 53.85765208500004],
              [8.58757571700005, 53.870428778000075],
              [8.60710696700005, 53.88153717700004],
              [8.629242384000065, 53.88939036700003],
              [8.651866082000083, 53.89248281500005],
              [8.672699415000068, 53.89158763200004],
              [8.684580925000091, 53.88849518400008],
              [8.709157748000052, 53.871975002000056],
              [8.744639519000089, 53.85415273600006],
              [8.782481316000087, 53.84247467700004],
              [8.86068769600007, 53.83100006700005],
              [8.903575066000087, 53.831732489000046],
              [8.97624759200005, 53.84243398600006],
              [9.016286655000044, 53.84052155200004],
              [9.035004102000073, 53.853583075000074],
              [9.114512566000087, 53.86513906500005],
              [9.193614129000082, 53.86469147300005],
              [9.21070397200009, 53.871975002000056],
              [9.22429446700005, 53.86591217700004],
              [9.240733269000089, 53.864162502000056],
              [9.274668816000087, 53.86513906500005],
              [9.283376498000052, 53.86163971600007],
              [9.305349155000044, 53.84454987200007],
              [9.402679884000065, 53.74241771000004],
              [9.442881707000083, 53.71430084800005],
              [9.470957879000082, 53.70062897300005],
              [9.484711134000065, 53.69009023600006],
              [9.498383009000065, 53.659857489000046],
              [9.567067905000044, 53.599595445000034],
              [9.582367384000065, 53.59129466400003],
              [9.60092207100007, 53.58633047100005],
              [9.62476647200009, 53.58462148600006],
              [9.637217644000089, 53.58100006700005],
              [9.69662519600007, 53.556626695000034],
              [9.764008009000065, 53.54767487200007],
              [9.819021030000044, 53.540350653000075],
              [9.832041863000086, 53.54360586100006],
              [9.819590691000087, 53.556626695000034],
              [9.782074415000068, 53.56972890800006],
              [9.692393425000091, 53.57591380400004],
              [9.655772332000083, 53.58462148600006],
              [9.58366946700005, 53.61245351800005],
              [9.550791863000086, 53.63458893400008],
              [9.539073113000086, 53.66648997600004],
              [9.536143425000091, 53.69375234600005],
              [9.532237175000091, 53.71116771000004],
              [9.522227410000085, 53.71662018400008],
              [9.475271030000044, 53.73216380400004],
              [9.460215691000087, 53.73541901200008],
              [9.435801629000082, 53.74868398600006],
              [9.412445509000065, 53.77875397300005],
              [9.396657748000052, 53.81102122600004],
              [9.395192905000044, 53.83100006700005],
              [9.35873457100007, 53.839544989000046],
              [9.295583530000044, 53.87189362200007],
              [9.257823113000086, 53.88556549700007],
              [9.22046959700009, 53.89077383000006],
              [9.09343509200005, 53.89248281500005],
              [9.055430535000085, 53.90289948100008],
              [9.029958530000044, 53.907131252000056],
              [9.018321160000085, 53.90273672100005],
              [9.007823113000086, 53.89248281500005],
              [8.984629754000082, 53.89704010600008],
              [8.949473504000082, 53.91290924700007],
              [8.916026238000086, 53.93740469000005],
              [8.83334394600007, 54.036444403000075],
              [8.871836785000085, 54.046942450000074],
              [8.890635613000086, 54.04779694200005],
              [8.914561394000089, 54.04389069200005],
              [8.953868035000085, 54.02830638200004],
              [8.975352410000085, 54.02407461100006],
              [8.997243686000047, 54.03021881700005],
              [9.004893425000091, 54.04116445500006],
              [9.01303144600007, 54.060980536000045],
              [9.018565300000091, 54.08242422100005],
              [9.018321160000085, 54.09788646000004],
              [9.006683790000068, 54.10814036700003],
              [8.988129102000073, 54.11786530200004],
              [8.974457227000073, 54.12807851800005],
              [8.977305535000085, 54.13947174700007],
              [8.977305535000085, 54.145697333000044],
              [8.95289147200009, 54.150091864000046],
              [8.917979363000086, 54.14630768400008],
              [8.885427280000044, 54.13703034100007],
              [8.867442254000082, 54.12518952000005],
              [8.86068769600007, 54.12518952000005],
              [8.83334394600007, 54.15314362200007],
              [8.815684441000087, 54.17560455900008],
              [8.812836134000065, 54.18048737200007],
              [8.820974155000044, 54.200506903000075],
              [8.836273634000065, 54.21775950700004],
              [8.846690300000091, 54.23354726800005],
              [8.83961022200009, 54.24872467700004],
              [8.83961022200009, 54.255560614000046],
              [8.851898634000065, 54.261053778000075],
              [8.89421634200005, 54.26821523600006],
              [8.91146894600007, 54.269191799000055],
              [8.922048373000052, 54.27423737200007],
              [8.937510613000086, 54.28668854400007],
              [8.953135613000086, 54.30255768400008],
              [8.963145379000082, 54.317613023000035],
              [8.940277540000068, 54.31500885600008],
              [8.902598504000082, 54.29584381700005],
              [8.881114129000082, 54.290269273000035],
              [8.883067254000082, 54.29360586100006],
              [8.885915561000047, 54.30072663000004],
              [8.887950066000087, 54.303941148000035],
              [8.857595248000052, 54.30182526200008],
              [8.805430535000085, 54.29242584800005],
              [8.774668816000087, 54.290269273000035],
              [8.738942905000044, 54.29389069200005],
              [8.723480665000068, 54.290269273000035],
              [8.690196160000085, 54.271470445000034],
              [8.678477410000085, 54.269191799000055],
              [8.651866082000083, 54.27484772300005],
              [8.623383009000065, 54.29010651200008],
              [8.602712436000047, 54.31207916900007],
              [8.599864129000082, 54.33808014500005],
              [8.614024285000085, 54.34837474200003],
              [8.641368035000085, 54.35565827000005],
              [8.672048373000052, 54.35927969000005],
              [8.695567254000082, 54.358587958000044],
              [8.695567254000082, 54.36542389500005],
              [8.677582227000073, 54.36790599200003],
              [8.66382897200009, 54.37555573100008],
              [8.650645379000082, 54.37799713700008],
              [8.634776238000086, 54.36542389500005],
              [8.626231316000087, 54.37641022300005],
              [8.629161004000082, 54.38768138200004],
              [8.63843834700009, 54.398138739000046],
              [8.648448113000086, 54.40639883000006],
              [8.669769727000073, 54.400824286000045],
              [8.750824415000068, 54.41380442900004],
              [8.86068769600007, 54.41380442900004],
              [8.88607832100007, 54.41779205900008],
              [8.907237175000091, 54.42552317900004],
              [8.949473504000082, 54.447333075000074],
              [8.98804772200009, 54.45844147300005],
              [9.004730665000068, 54.46588776200008],
              [9.01148522200009, 54.482123114000046],
              [9.011566602000073, 54.50633372600004],
              [8.98609459700009, 54.529282945000034],
              [8.904470248000052, 54.58063385600008],
              [8.892832879000082, 54.59125397300005],
              [8.887950066000087, 54.60187409100007],
              [8.878754102000073, 54.60651276200008],
              [8.858164910000085, 54.60614655200004],
              [8.837087436000047, 54.60268789300005],
              [8.82585696700005, 54.59813060100004],
              [8.819021030000044, 54.60561758000006],
              [8.85328209700009, 54.61928945500006],
              [8.818369988000086, 54.67365143400008],
              [8.805430535000085, 54.687567450000074],
              [8.77670332100007, 54.69798411700003],
              [8.722666863000086, 54.72553131700005],
              [8.688731316000087, 54.73529694200005],
              [8.688731316000087, 54.742173570000034],
              [8.694346550000091, 54.76023997600004],
              [8.68132571700005, 54.780585028000075],
              [8.66187584700009, 54.80060455900008],
              [8.648448113000086, 54.81785716400003],
              [8.642751498000052, 54.844183661000045],
              [8.647227410000085, 54.86737702000005],
              [8.660775934000071, 54.89631115600007],
              [8.695882202000092, 54.88998402900005],
              [8.732779175000104, 54.88905385400001],
              [8.80088871200013, 54.90383331400004],
              [8.82424645900008, 54.90590037000008],
              [8.904138224000064, 54.89794220000003],
              [8.982686401000109, 54.879338684000075],
              [9.194766480000055, 54.85039988200002],
              [9.211509644000103, 54.84182159400008],
              [9.216057169000123, 54.831744690000036],
              [9.219054403000143, 54.81779205400004],
              [9.226392456000042, 54.805906474000025],
              [9.244065796000143, 54.8017723600001],
              [9.317032918000052, 54.80161733000004],
              [9.332019084000137, 54.803219300000094],
              [9.341734253000084, 54.80905873600007],
              [9.35599694800004, 54.81133249900007],
              [9.366952352000112, 54.817016907000024],
              [9.385039103000054, 54.81939402300007],
              [9.405192911000114, 54.80838694300009],
              [9.42214278100002, 54.80725006100009],
              [9.436922241000048, 54.81014394200007],
              [9.437503027053964, 54.81041112738269],
              [9.451426629000082, 54.81037018400008],
              [9.510996941000087, 54.827826239000046],
              [9.529958530000044, 54.841498114000046],
              [9.55437259200005, 54.84711334800005],
              [9.566905144000089, 54.86017487200007],
              [9.579925977000073, 54.86627838700008],
              [9.583181186000047, 54.83026764500005],
              [9.631602410000085, 54.81989166900007],
              [9.69304446700005, 54.818019924000055],
              [9.734629754000082, 54.80731842700004],
              [9.752126498000052, 54.79962799700007],
              [9.778086785000085, 54.79315827000005],
              [9.801768425000091, 54.78339264500005],
              [9.81218509200005, 54.766058661000045],
              [9.823741082000083, 54.756740627000056],
              [9.849864129000082, 54.75934479400007],
              [9.895355665000068, 54.76947663000004],
              [9.891449415000068, 54.790269273000035],
              [9.915049675000091, 54.79120514500005],
              [9.947520379000082, 54.77952708500004],
              [9.97046959700009, 54.76264069200005],
              [9.98414147200009, 54.728501695000034],
              [9.990489129000082, 54.72052643400008],
              [9.999522332000083, 54.712958075000074],
              [10.018239780000044, 54.701239325000074],
              [10.005381707000083, 54.69550202000005],
              [9.992198113000086, 54.696478583000044],
              [9.97982832100007, 54.69977448100008],
              [9.97046959700009, 54.701239325000074],
              [9.971039259000065, 54.69904205900008],
              [9.946299675000091, 54.68764883000006],
              [9.94312584700009, 54.687567450000074],
              [9.936696811000047, 54.68500397300005],
              [9.932383660000085, 54.685248114000046],
              [9.929942254000082, 54.68309153900003],
              [9.92945397200009, 54.673895575000074],
              [9.944102410000085, 54.67332591400003],
              [9.970225457000083, 54.67792389500005],
              [9.996348504000082, 54.67877838700008],
              [10.01140384200005, 54.66705963700008],
              [10.022146030000044, 54.67243073100008],
              [10.033539259000065, 54.67291901200008],
              [10.039073113000086, 54.66681549700007],
              [10.031911655000044, 54.652777411000045],
              [10.036957227000073, 54.63890208500004],
              [10.037608269000089, 54.61908600500004],
              [10.031911655000044, 54.57770416900007],
              [10.026866082000083, 54.55996328300006],
              [10.020030144000089, 54.54584381700005],
              [10.010427280000044, 54.53432851800005],
              [9.99781334700009, 54.52366771000004],
              [9.965586785000085, 54.50617096600007],
              [9.925303582000083, 54.49310944200005],
              [9.882009311000047, 54.48484935100004],
              [9.840098504000082, 54.482123114000046],
              [9.840098504000082, 54.47528717700004],
              [9.883311394000089, 54.462103583000044],
              [10.12468509200005, 54.495754299000055],
              [10.143402540000068, 54.491848049000055],
              [10.203868035000085, 54.461004950000074],
              [10.183929884000065, 54.44936758000006],
              [10.183848504000082, 54.43842194200005],
              [10.191742384000065, 54.42617422100005],
              [10.19703209700009, 54.41010163000004],
              [10.191254102000073, 54.39671458500004],
              [10.17709394600007, 54.38426341400003],
              [10.159027540000068, 54.37531159100007],
              [10.141774936000047, 54.372259833000044],
              [10.144379102000073, 54.370021877000056],
              [10.14779707100007, 54.36831289300005],
              [10.148285352000073, 54.36517975500004],
              [10.141774936000047, 54.358587958000044],
              [10.152517123000052, 54.35179271000004],
              [10.155528191000087, 54.343410549000055],
              [10.151621941000087, 54.333970445000034],
              [10.141774936000047, 54.32440827000005],
              [10.16374759200005, 54.32916901200008],
              [10.180349155000044, 54.341131903000075],
              [10.203868035000085, 54.372259833000044],
              [10.217133009000065, 54.40542226800005],
              [10.22437584700009, 54.41380442900004],
              [10.234385613000086, 54.41771067900004],
              [10.272146030000044, 54.42007070500006],
              [10.285817905000044, 54.42475006700005],
              [10.292491082000083, 54.43016185100004],
              [10.297618035000085, 54.43573639500005],
              [10.306895379000082, 54.441107489000046],
              [10.318369988000086, 54.44330475500004],
              [10.360850457000083, 54.441107489000046],
              [10.382823113000086, 54.434759833000044],
              [10.443369988000086, 54.40639883000006],
              [10.601084832000083, 54.36542389500005],
              [10.690196160000085, 54.31622955900008],
              [10.731293165000068, 54.310207424000055],
              [10.77711022200009, 54.31513092700004],
              [10.810801629000082, 54.327378648000035],
              [10.867930535000085, 54.358587958000044],
              [10.900889519000089, 54.37103913000004],
              [10.93531334700009, 54.37954336100006],
              [11.018809441000087, 54.38589101800005],
              [11.018809441000087, 54.37909577000005],
              [11.000824415000068, 54.378566799000055],
              [10.975840691000087, 54.37840403900003],
              [10.993174675000091, 54.37384674700007],
              [11.010508660000085, 54.37718333500004],
              [11.033946160000085, 54.367621161000045],
              [11.104177280000044, 54.39288971600007],
              [11.135508660000085, 54.38589101800005],
              [11.098399285000085, 54.36151764500005],
              [11.087738477000073, 54.35175202000005],
              [11.08179772200009, 54.35464101800005],
              [11.066579623000052, 54.358587958000044],
              [11.077403191000087, 54.342230536000045],
              [11.086599155000044, 54.302435614000046],
              [11.094493035000085, 54.28351471600007],
              [11.087087436000047, 54.27090078300006],
              [11.087738477000073, 54.253892320000034],
              [11.094493035000085, 54.22508372600004],
              [11.090179884000065, 54.20799388200004],
              [11.080577019000089, 54.198879299000055],
              [11.070974155000044, 54.192572333000044],
              [11.066579623000052, 54.18390534100007],
              [10.950450066000087, 54.13947174700007],
              [10.910329623000052, 54.10919830900008],
              [10.892832879000082, 54.10252513200004],
              [10.852386915000068, 54.09430573100008],
              [10.844574415000068, 54.09446849200003],
              [10.836110873000052, 54.08999258000006],
              [10.829356316000087, 54.09284088700008],
              [10.822276238000086, 54.097357489000046],
              [10.813324415000068, 54.09788646000004],
              [10.805430535000085, 54.09487539300005],
              [10.801442905000044, 54.092230536000045],
              [10.762868686000047, 54.05683014500005],
              [10.752614780000044, 54.050116278000075],
              [10.752614780000044, 54.04389069200005],
              [10.765879754000082, 54.02435944200005],
              [10.780446811000047, 54.00995514500005],
              [10.799652540000068, 54.00055573100008],
              [10.826914910000085, 53.995428778000075],
              [10.865570509000065, 53.99778880400004],
              [10.875498894000089, 53.995428778000075],
              [10.88257897200009, 53.98505280200004],
              [10.883555535000085, 53.97313060100004],
              [10.887380405000044, 53.96393463700008],
              [10.90211022200009, 53.961371161000045],
              [10.90601647200009, 53.96120840100008],
              [10.91765384200005, 53.96076080900008],
              [10.922618035000085, 53.961371161000045],
              [10.935394727000073, 53.96727122600004],
              [10.964691602000073, 53.98541901200008],
              [10.981211785000085, 53.98924388200004],
              [11.000254754000082, 53.99160390800006],
              [11.053477410000085, 54.00849030200004],
              [11.175059441000087, 54.018011786000045],
              [11.183848504000082, 54.01601797100005],
              [11.19076582100007, 54.01032135600008],
              [11.197276238000086, 53.99624258000006],
              [11.204356316000087, 53.98924388200004],
              [11.23991946700005, 53.98346588700008],
              [11.245371941000087, 53.97842031500005],
              [11.240733269000089, 53.95563385600008],
              [11.242930535000085, 53.94521719000005],
              [11.25562584700009, 53.94086334800005],
              [11.285411004000082, 53.93968333500004],
              [11.293711785000085, 53.94086334800005],
              [11.334157748000052, 53.961371161000045],
              [11.341807488000086, 53.958319403000075],
              [11.352061394000089, 53.94415924700007],
              [11.358246290000068, 53.94086334800005],
              [11.399912957000083, 53.94086334800005],
              [11.400401238000086, 53.93773021000004],
              [11.438731316000087, 53.90912506700005],
              [11.446299675000091, 53.90615469000005],
              [11.457692905000044, 53.90615469000005],
              [11.458994988000086, 53.91669342700004],
              [11.469086134000065, 53.93276601800005],
              [11.476817254000082, 53.95270416900007],
              [11.47242272200009, 53.968817450000074],
              [11.47982832100007, 53.97614166900007],
              [11.489512566000087, 53.98061758000006],
              [11.497894727000073, 53.98183828300006],
              [11.495941602000073, 53.986314195000034],
              [11.49350019600007, 53.99762604400007],
              [11.491709832000083, 54.00234609600005],
              [11.525889519000089, 54.022772528000075],
              [11.525889519000089, 54.03021881700005],
              [11.519053582000083, 54.03021881700005],
              [11.519053582000083, 54.036444403000075],
              [11.54460696700005, 54.030178127000056],
              [11.553233269000089, 54.03021881700005],
              [11.573496941000087, 54.039048570000034],
              [11.591319207000083, 54.065619208000044],
              [11.604746941000087, 54.07123444200005],
              [11.612803582000083, 54.07290273600006],
              [11.619395379000082, 54.07729726800005],
              [11.624522332000083, 54.083644924000055],
              [11.628916863000086, 54.091050523000035],
              [11.629567905000044, 54.09601471600007],
              [11.622080925000091, 54.09955475500004],
              [11.622080925000091, 54.104681708000044],
              [11.625254754000082, 54.109808661000045],
              [11.629405144000089, 54.11322663000004],
              [11.633148634000065, 54.11591217700004],
              [11.65788821700005, 54.142238674000055],
              [11.689707879000082, 54.15521881700005],
              [11.728770379000082, 54.15851471600007],
              [11.81226647200009, 54.14980703300006],
              [12.050629102000073, 54.17991771000004],
              [12.088145379000082, 54.19407786700003],
              [12.093272332000083, 54.16543203300006],
              [12.08952884200005, 54.13764069200005],
              [12.091644727000073, 54.11399974200003],
              [12.11500084700009, 54.09788646000004],
              [12.105316602000073, 54.11001211100006],
              [12.100352410000085, 54.135972398000035],
              [12.09506269600007, 54.145697333000044],
              [12.105479363000086, 54.15737539300005],
              [12.134287957000083, 54.16697825700004],
              [12.142832879000082, 54.18048737200007],
              [12.131602410000085, 54.18113841400003],
              [12.12086022200009, 54.17999909100007],
              [12.110606316000087, 54.177435614000046],
              [12.10132897200009, 54.17365143400008],
              [12.108897332000083, 54.18301015800006],
              [12.142832879000082, 54.20917389500005],
              [12.163096550000091, 54.219916083000044],
              [12.18685957100007, 54.243353583000044],
              [12.20093834700009, 54.24872467700004],
              [12.214040561000047, 54.25096263200004],
              [12.289398634000065, 54.275091864000046],
              [12.327321811000047, 54.29376862200007],
              [12.342133009000065, 54.303941148000035],
              [12.378184441000087, 54.344916083000044],
              [12.438324415000068, 54.395819403000075],
              [12.444834832000083, 54.405462958000044],
              [12.48609459700009, 54.447333075000074],
              [12.501963738000086, 54.47357819200005],
              [12.51343834700009, 54.48224518400008],
              [12.533864780000044, 54.488267320000034],
              [12.533864780000044, 54.482123114000046],
              [12.52702884200005, 54.482123114000046],
              [12.548350457000083, 54.46206289300005],
              [12.59148196700005, 54.45172760600008],
              [12.819102410000085, 54.45172760600008],
              [12.856618686000047, 54.441107489000046],
              [12.879649285000085, 54.44879791900007],
              [12.908376498000052, 54.444647528000075],
              [12.921153191000087, 54.43349844000005],
              [12.896332227000073, 54.42007070500006],
              [12.87077884200005, 54.41681549700007],
              [12.763682488000086, 54.42218659100007],
              [12.720957879000082, 54.43158600500004],
              [12.694590691000087, 54.433661200000074],
              [12.686778191000087, 54.431626695000034],
              [12.676117384000065, 54.42255280200004],
              [12.670420769000089, 54.42007070500006],
              [12.65007571700005, 54.42007070500006],
              [12.624196811000047, 54.42291901200008],
              [12.614512566000087, 54.41974518400008],
              [12.608409050000091, 54.40639883000006],
              [12.602224155000044, 54.41380442900004],
              [12.596934441000087, 54.41193268400008],
              [12.588063998000052, 54.407456773000035],
              [12.58171634200005, 54.40639883000006],
              [12.583506707000083, 54.39785390800006],
              [12.58765709700009, 54.39402903900003],
              [12.594004754000082, 54.39276764500005],
              [12.602224155000044, 54.39207591400003],
              [12.598643425000091, 54.39154694200005],
              [12.595876498000052, 54.391506252000056],
              [12.594411655000044, 54.39020416900007],
              [12.594737175000091, 54.38589101800005],
              [12.57553144600007, 54.39199453300006],
              [12.55404707100007, 54.39081452000005],
              [12.535980665000068, 54.38373444200005],
              [12.52702884200005, 54.372259833000044],
              [12.510752800000091, 54.38426341400003],
              [12.490977410000085, 54.39008209800005],
              [12.45476321700005, 54.39207591400003],
              [12.438487175000091, 54.38751862200007],
              [12.424978061000047, 54.37592194200005],
              [12.418467644000089, 54.360663153000075],
              [12.424001498000052, 54.344916083000044],
              [12.409678582000083, 54.34662506700005],
              [12.403819207000083, 54.348089911000045],
              [12.396739129000082, 54.35175202000005],
              [12.389903191000087, 54.344916083000044],
              [12.396494988000086, 54.33295319200005],
              [12.391612175000091, 54.32111237200007],
              [12.379079623000052, 54.31244538000004],
              [12.362559441000087, 54.310207424000055],
              [12.369639519000089, 54.296576239000046],
              [12.377940300000091, 54.28587474200003],
              [12.380137566000087, 54.27708567900004],
              [12.36882571700005, 54.269191799000055],
              [12.412445509000065, 54.25141022300005],
              [12.436778191000087, 54.247707424000055],
              [12.458181186000047, 54.255560614000046],
              [12.442637566000087, 54.255194403000075],
              [12.430837436000047, 54.25861237200007],
              [12.410329623000052, 54.269191799000055],
              [12.416840040000068, 54.280951239000046],
              [12.426280144000089, 54.28961823100008],
              [12.451426629000082, 54.303941148000035],
              [12.457286004000082, 54.306301174000055],
              [12.468272332000083, 54.30833567900004],
              [12.47242272200009, 54.310207424000055],
              [12.475596550000091, 54.31513092700004],
              [12.476573113000086, 54.327785549000055],
              [12.478688998000052, 54.33185455900008],
              [12.495616082000083, 54.340277411000045],
              [12.560557488000086, 54.358587958000044],
              [12.547048373000052, 54.364488023000035],
              [12.54078209700009, 54.36542389500005],
              [12.54078209700009, 54.372259833000044],
              [12.559336785000085, 54.376288153000075],
              [12.56609134200005, 54.37592194200005],
              [12.574229363000086, 54.372259833000044],
              [12.574229363000086, 54.37909577000005],
              [12.592946811000047, 54.36933014500005],
              [12.62273196700005, 54.373928127000056],
              [12.677256707000083, 54.39207591400003],
              [12.675059441000087, 54.395412502000056],
              [12.672373894000089, 54.40298086100006],
              [12.670420769000089, 54.40639883000006],
              [12.680837436000047, 54.41087474200003],
              [12.692556186000047, 54.41364166900007],
              [12.70484459700009, 54.41461823100008],
              [12.717539910000085, 54.41380442900004],
              [12.717539910000085, 54.40639883000006],
              [12.70248457100007, 54.40412018400008],
              [12.692393425000091, 54.396185614000046],
              [12.686534050000091, 54.384751695000034],
              [12.684092644000089, 54.372259833000044],
              [12.69662519600007, 54.38495514500005],
              [12.701182488000086, 54.39166901200008],
              [12.704600457000083, 54.399603583000044],
              [12.713552280000044, 54.39008209800005],
              [12.723806186000047, 54.38125234600005],
              [12.735036655000044, 54.378159898000035],
              [12.746104363000086, 54.38589101800005],
              [12.757823113000086, 54.379787502000056],
              [12.768565300000091, 54.380072333000044],
              [12.778330925000091, 54.384751695000034],
              [12.787119988000086, 54.39207591400003],
              [12.789886915000068, 54.38434479400007],
              [12.79468834700009, 54.37714264500005],
              [12.800954623000052, 54.370754299000055],
              [12.81804446700005, 54.35797760600008],
              [12.821787957000083, 54.35614655200004],
              [12.825368686000047, 54.35724518400008],
              [12.835459832000083, 54.358587958000044],
              [12.854665561000047, 54.357855536000045],
              [12.864756707000083, 54.35956452000005],
              [12.875987175000091, 54.36542389500005],
              [12.88453209700009, 54.373480536000045],
              [12.894867384000065, 54.38971588700008],
              [12.903819207000083, 54.399603583000044],
              [12.92937259200005, 54.41437409100007],
              [12.969086134000065, 54.429388739000046],
              [13.008799675000091, 54.43805573100008],
              [13.034190300000091, 54.433661200000074],
              [13.021494988000086, 54.42645905200004],
              [13.021006707000083, 54.41453685100004],
              [13.028575066000087, 54.40184153900003],
              [13.04037519600007, 54.39207591400003],
              [13.08366946700005, 54.378973700000074],
              [13.095550977000073, 54.372259833000044],
              [13.076670769000089, 54.35252513200004],
              [13.080739780000044, 54.337144273000035],
              [13.109222852000073, 54.310207424000055],
              [13.112071160000085, 54.29930247600004],
              [13.112071160000085, 54.28847890800006],
              [13.11491946700005, 54.28001536700003],
              [13.125987175000091, 54.276597398000035],
              [13.170664910000085, 54.276597398000035],
              [13.170664910000085, 54.269191799000055],
              [13.161306186000047, 54.26902903900003],
              [13.154633009000065, 54.26732005400004],
              [13.143402540000068, 54.263006903000075],
              [13.176117384000065, 54.264837958000044],
              [13.228363477000073, 54.247381903000075],
              [13.263194207000083, 54.24249909100007],
              [13.28882897200009, 54.23427969000005],
              [13.321787957000083, 54.194525458000044],
              [13.348887566000087, 54.18048737200007],
              [13.33334394600007, 54.17401764500005],
              [13.321543816000087, 54.16681549700007],
              [13.346527540000068, 54.16693756700005],
              [13.383799675000091, 54.17812734600005],
              [13.403493686000047, 54.17365143400008],
              [13.395681186000047, 54.16193268400008],
              [13.390879754000082, 54.15729401200008],
              [13.382985873000052, 54.15314362200007],
              [13.394786004000082, 54.14891185100004],
              [13.40211022200009, 54.15131256700005],
              [13.408702019000089, 54.15460846600007],
              [13.41773522200009, 54.15314362200007],
              [13.42318769600007, 54.148098049000055],
              [13.437673373000052, 54.12518952000005],
              [13.450368686000047, 54.11041901200008],
              [13.465098504000082, 54.09845612200007],
              [13.483571811000047, 54.09129466400003],
              [13.507090691000087, 54.091050523000035],
              [13.507090691000087, 54.09788646000004],
              [13.498871290000068, 54.10248444200005],
              [13.487478061000047, 54.11391836100006],
              [13.479258660000085, 54.118353583000044],
              [13.479258660000085, 54.12518952000005],
              [13.602712436000047, 54.13947174700007],
              [13.632334832000083, 54.14752838700008],
              [13.683441602000073, 54.168036200000074],
              [13.711924675000091, 54.17365143400008],
              [13.71648196700005, 54.16844310100004],
              [13.714691602000073, 54.164048570000034],
              [13.708262566000087, 54.16087474200003],
              [13.698252800000091, 54.15932851800005],
              [13.698252800000091, 54.15314362200007],
              [13.728770379000082, 54.143866278000075],
              [13.808116082000083, 54.104681708000044],
              [13.808116082000083, 54.09788646000004],
              [13.793711785000085, 54.083197333000044],
              [13.785492384000065, 54.06391022300005],
              [13.77320397200009, 54.04633209800005],
              [13.746104363000086, 54.036444403000075],
              [13.758148634000065, 54.03099192900004],
              [13.787119988000086, 54.009100653000075],
              [13.797618035000085, 53.998928127000056],
              [13.803477410000085, 53.99632396000004],
              [13.83179772200009, 53.98924388200004],
              [13.838633660000085, 53.986314195000034],
              [13.84310957100007, 53.97955963700008],
              [13.846202019000089, 53.97223541900007],
              [13.849131707000083, 53.96759674700007],
              [13.850271030000044, 53.96401601800005],
              [13.84896894600007, 53.95945872600004],
              [13.848643425000091, 53.95555247600004],
              [13.852549675000091, 53.95384349200003],
              [13.86687259200005, 53.95465729400007],
              [13.870127800000091, 53.95384349200003],
              [13.875498894000089, 53.951239325000074],
              [13.881602410000085, 53.94904205900008],
              [13.887950066000087, 53.94757721600007],
              [13.893565300000091, 53.94708893400008],
              [13.90601647200009, 53.943060614000046],
              [13.90756269600007, 53.93353913000004],
              [13.901377800000091, 53.922308661000045],
              [13.890147332000083, 53.91290924700007],
              [13.818532748000052, 53.87799713700008],
              [13.808116082000083, 53.86513906500005],
              [13.817067905000044, 53.85293203300006],
              [13.835785352000073, 53.84747955900008],
              [13.854340040000068, 53.844916083000044],
              [13.862803582000083, 53.84125397300005],
              [13.869151238000086, 53.83030833500004],
              [13.883799675000091, 53.817694403000075],
              [13.899912957000083, 53.80914948100008],
              [13.910655144000089, 53.81049225500004],
              [13.984222852000073, 53.77399323100008],
              [14.01734459700009, 53.769517320000034],
              [14.033539259000065, 53.757513739000046],
              [14.037445509000065, 53.75527578300006],
              [14.061534050000091, 53.75641510600008],
              [14.068858269000089, 53.75527578300006],
              [14.094004754000082, 53.74632396000004],
              [14.106130405000044, 53.743353583000044],
              [14.186534050000091, 53.73981354400007],
              [14.214691602000073, 53.74485911700003],
              [14.226573113000086, 53.758693752000056],
              [14.23414147200009, 53.761786200000074],
              [14.250173373000052, 53.75995514500005],
              [14.264496290000068, 53.751613674000055],
              [14.267425977000073, 53.73541901200008],
              [14.25953209700009, 53.72797272300005],
              [14.212738477000073, 53.70807526200008],
              [14.225352410000085, 53.70376211100006],
              [14.24000084700009, 53.70075104400007],
              [14.256195509000065, 53.69944896000004],
              [14.263900720257396, 53.69997615968076],
              [14.263862752000136, 53.699875794],
              [14.265102986000073, 53.67176381500006],
              [14.260968872000149, 53.65620920900004],
              [14.27605839000006, 53.636623841000116],
              [14.297039022000149, 53.59776316400006],
              [14.298899373000069, 53.58789296500008],
              [14.296212199000138, 53.551306051000026],
              [14.29693566900005, 53.5291368620001],
              [14.304170370000094, 53.50851796500011],
              [14.328458293000097, 53.4860903940001],
              [14.338896932000125, 53.465213115000054],
              [14.359877564000044, 53.444077454000094],
              [14.370316202000083, 53.39229766900003],
              [14.391260511000098, 53.334017003000056],
              [14.398014770000088, 53.31522227000009],
              [14.399565064000114, 53.30674733500008],
              [14.40018518000008, 53.28860890800006],
              [14.403285767000028, 53.278790385],
              [14.409383586000075, 53.27243418400006],
              [14.424679810000043, 53.26465688100005],
              [14.4286072190001, 53.259075827000046],
              [14.441629680000062, 53.25184112600006],
              [14.415584757000062, 53.22099029600007],
              [14.408246704000078, 53.214401551],
              [14.39770471200012, 53.21099090600008],
              [14.387782837000117, 53.20207672200006],
              [14.380651489000087, 53.18985524500003],
              [14.377860962000113, 53.1765485640001],
              [14.381478312000098, 53.160296326],
              [14.38747277900012, 53.14613698400005],
              [14.389539835000107, 53.131667583000095],
              [14.359567505000143, 53.07505605100003],
              [14.356776977000095, 53.066684469000066],
              [14.343341105000036, 53.04862355500005],
              [14.312645305000103, 53.02921905500007],
              [14.253734172000094, 53.00087453300007],
              [14.192859334000048, 52.98165090000005],
              [14.14449019300011, 52.95992096000005],
              [14.14449019300011, 52.953693950000044],
              [14.150484660000131, 52.94364288400003],
              [14.162680298000055, 52.908167013000096],
              [14.164954061000088, 52.89566131700009],
              [14.16081994600006, 52.87674774200006],
              [14.150484660000131, 52.86462961900007],
              [14.12392297300002, 52.850651144000054],
              [14.13539514200005, 52.83659515400005],
              [14.152758423000051, 52.8283269250001],
              [14.173739054000066, 52.824347839000026],
              [14.195959920000092, 52.82336598700006],
              [14.216010375000053, 52.817991639000084],
              [14.248669882000115, 52.794582215000034],
              [14.27595503700013, 52.78571970600002],
              [14.382201782000095, 52.738151551],
              [14.39770471200012, 52.72711863299999],
              [14.431914510000098, 52.68608754600005],
              [14.442353149000041, 52.67996388799999],
              [14.461370076, 52.67456370100011],
              [14.49010217300011, 52.65063751200002],
              [14.54994348100007, 52.63619395000008],
              [14.607964828000092, 52.596462963000064],
              [14.613712199000105, 52.59252736400002],
              [14.644821411000066, 52.576921082000084],
              [14.616812785000064, 52.54103180000003],
              [14.609061320000137, 52.51780324300002],
              [14.627664836000093, 52.5074162800001],
              [14.632315715000061, 52.49674509800009],
              [14.615779256000081, 52.473283997000024],
              [14.591594686000093, 52.44979705900003],
              [14.539814901000113, 52.42186594700006],
              [14.54539595600005, 52.382152608000055],
              [14.569167114000095, 52.3385118610001],
              [14.590147746000099, 52.30941803000009],
              [14.584153280000066, 52.29122792600005],
              [14.606580851000075, 52.27575083500007],
              [14.640480590000067, 52.26505381300005],
              [14.668902628000097, 52.26099721300004],
              [14.696911255000117, 52.2534782930001],
              [14.712414184000124, 52.235908305000024],
              [14.712104126000042, 52.21544443800006],
              [14.69257043500005, 52.19957977300005],
              [14.69257043500005, 52.19337860100008],
              [14.707039836000149, 52.17945180300008],
              [14.703215780000022, 52.16516327],
              [14.692467082000093, 52.14697316500006],
              [14.686369263000131, 52.12103159600012],
              [14.696394491000063, 52.10669138600012],
              [14.76140344300012, 52.07666737900006],
              [14.74300663300005, 52.06253387500003],
              [14.735358520000148, 52.05403310200002],
              [14.732154582000078, 52.04506724100007],
              [14.730294230000084, 52.03589467400009],
              [14.726056762000042, 52.02643788700003],
              [14.704456014000073, 52.00222747800005],
              [14.699081665000108, 51.992512309000105],
              [14.695567667000148, 51.931456604000104],
              [14.687092733000043, 51.911897074000095],
              [14.67169315600006, 51.89388783800008],
              [14.653296346000076, 51.87861745300005],
              [14.595935507000064, 51.84241811200012],
              [14.582809693000115, 51.82508066800001],
              [14.585806925000043, 51.803893332000044],
              [14.602240031000093, 51.78831288700012],
              [14.620326782000092, 51.780535584000106],
              [14.634176066000066, 51.76901173900008],
              [14.638103475000037, 51.7426309210001],
              [14.648438761000136, 51.7172061160001],
              [14.670969686000149, 51.70077301100012],
              [14.719545532000069, 51.675632426],
              [14.732464640000074, 51.65834665900009],
              [14.74228316200012, 51.632973532],
              [14.743936808000086, 51.606644390000056],
              [14.732154582000078, 51.58661977200002],
              [14.71272424300011, 51.567421977],
              [14.704559367000087, 51.54799163800003],
              [14.706769960000116, 51.54082806400008],
              [14.710037068000076, 51.5302407840001],
              [14.732154582000078, 51.515823059000084],
              [14.79747359200013, 51.50210296600004],
              [14.818557576000075, 51.49269785600008],
              [14.818557576000075, 51.49259450400005],
              [14.841398559000083, 51.48442962700004],
              [14.888320760000113, 51.475747987],
              [14.910955038000083, 51.46897837300004],
              [14.926561320000104, 51.46133026100007],
              [14.945061483000131, 51.44918630000008],
              [14.95539676900006, 51.435414530000045],
              [14.946921835000126, 51.42290883400004],
              [14.950647846000038, 51.396539377000025],
              [14.956637004000072, 51.35415334100004],
              [14.956637004000072, 51.3532231650001],
              [14.960977824000054, 51.33529144300003],
              [14.963768352000017, 51.32839263900006],
              [14.982268514000054, 51.30800628700011],
              [15.004902792000081, 51.29128896100006],
              [15.019475545000148, 51.271677755000056],
              [15.014307901000052, 51.24266143900006],
              [15.017925252000026, 51.23956085200011],
              [15.022059367000054, 51.23677032500005],
              [15.004902792000081, 51.215608826],
              [14.991363566000103, 51.18896962500007],
              [14.983198690000108, 51.16090932300004],
              [14.982061808000083, 51.13563954700008],
              [14.97999475100002, 51.12279795400009],
              [14.97338016800012, 51.11613169400009],
              [14.965628703000021, 51.111506653000035],
              [14.960254354000057, 51.10458201100003],
              [14.958497355000077, 51.094737651000074],
              [14.958290649000048, 51.07551401800005],
              [14.95529341700012, 51.06404185000012],
              [14.910644979000097, 50.99265085900002],
              [14.860208781000068, 50.916841533000124],
              [14.824655395000036, 50.89183013900005],
              [14.810496053000065, 50.877050680000124],
              [14.810392700000136, 50.858447164000054],
              [14.794579712000143, 50.83162709600008],
              [14.785071248000065, 50.82005157500002],
              [14.775356079000119, 50.812971904],
              [14.759233032000054, 50.810181376000045],
              [14.737528931000043, 50.81069814100009],
              [14.70042525200006, 50.815969137000124],
              [14.662184692000068, 50.834365946000034],
              [14.647921997000111, 50.83937856100009],
              [14.61319543500008, 50.845579732000076],
              [14.608337850000055, 50.85307281500009],
              [14.61185184700011, 50.87095286100005],
              [14.628801717000101, 50.89611928300009],
              [14.634589478000066, 50.9094001270001],
              [14.629215128000112, 50.92071726600007],
              [14.617122843000118, 50.920872294000034],
              [14.561829061000111, 50.90635121700008],
              [14.5503568930001, 50.91208730100003],
              [14.555834594000089, 50.924282939000065],
              [14.567823527000144, 50.938648987000064],
              [14.575574992000043, 50.95068959600003],
              [14.577435343000047, 50.96572743700001],
              [14.574334758000106, 50.97549428300006],
              [14.566686645000118, 50.98340077800002],
              [14.554594360000038, 50.99265085900002],
              [14.542295369000101, 50.99874867800007],
              [14.515320272000082, 51.00303782200005],
              [14.502917928000102, 51.00851552400003],
              [14.493512818000056, 51.016706238000054],
              [14.49010217300011, 51.022700704],
              [14.48793176300012, 51.02872100900002],
              [14.48214400200007, 51.03719594300013],
              [14.473462362000106, 51.023372498000086],
              [14.462093547000109, 51.01965179400007],
              [14.425816691000136, 51.0209437060001],
              [14.39780806400006, 51.0131147260001],
              [14.386749308000049, 51.01326975600004],
              [14.375897257000076, 51.01699045900004],
              [14.369386027000104, 51.02244232200012],
              [14.364115031000097, 51.02799753800004],
              [14.356570272000056, 51.032338359],
              [14.319363240000115, 51.04001230900009],
              [14.287530558000071, 51.03683420800003],
              [14.263552694000055, 51.02143463200004],
              [14.249496704000137, 50.99265085900002],
              [14.238334595000111, 50.98247060200005],
              [14.250013469000095, 50.97761301700005],
              [14.283809855000072, 50.97482249000008],
              [14.303756958000093, 50.969706523000085],
              [14.302206665000057, 50.96769114200005],
              [14.293731730000076, 50.96397043900005],
              [14.292801554000107, 50.95348012400008],
              [14.318329712000065, 50.93751210600006],
              [14.355226685000076, 50.93063914000008],
              [14.381891724000127, 50.920872294000034],
              [14.375897257000076, 50.89596425400005],
              [14.34654504400001, 50.88020294200008],
              [14.268100220000093, 50.88413035100005],
              [14.232133423000022, 50.87937611900004],
              [14.221281372000078, 50.872606507000015],
              [14.202987915000108, 50.855139873000056],
              [14.1907922770001, 50.8479051720001],
              [14.034936157000061, 50.80258494100009],
              [14.015712524000037, 50.80175811800005],
              [13.979125610000096, 50.80475535100008],
              [13.959591919000076, 50.80206817700004],
              [13.948843221000061, 50.79721059200004],
              [13.933546997000093, 50.78480824800006],
              [13.923315064000121, 50.779950664000026],
              [13.910706014000084, 50.77876210500001],
              [13.900990844000148, 50.780622457000035],
              [13.892515910000043, 50.78041575200005],
              [13.883317505000065, 50.773232727],
              [13.879080037000108, 50.76351755800006],
              [13.880320272000034, 50.75504262300008],
              [13.882697388000082, 50.748014628000064],
              [13.882180624000057, 50.74274363200003],
              [13.87535933400008, 50.73654246100004],
              [13.869571574000105, 50.7352505490001],
              [13.863473755000143, 50.735147197000074],
              [13.834534953000087, 50.723675029000034],
              [13.816551554000114, 50.72134958900001],
              [13.770662882000039, 50.7246052040001],
              [13.74906213400007, 50.723209941000036],
              [13.71102828000005, 50.714269918000085],
              [13.691752970000096, 50.711841126000124],
              [13.601939331000096, 50.712151185000025],
              [13.556567423000075, 50.706725159000044],
              [13.515639689000068, 50.691015524000065],
              [13.527215210000094, 50.675667623],
              [13.523287801000038, 50.66218007500005],
              [13.509955281000117, 50.651224671000065],
              [13.493315471000074, 50.64321482300009],
              [13.49910323000006, 50.635204977000015],
              [13.498173055000109, 50.62915883400005],
              [13.492178589000076, 50.624456279000086],
              [13.482256713000083, 50.620890605000014],
              [13.464893432000054, 50.607092998000056],
              [13.447943563000052, 50.59727447600001],
              [13.429340048000114, 50.59432891900009],
              [13.407015828000056, 50.60130523700009],
              [13.400401245000126, 50.60657623400003],
              [13.386345256000112, 50.621614075000096],
              [13.380970906000073, 50.62548980700008],
              [13.36877526800015, 50.62833201100004],
              [13.36598474100009, 50.62709177700002],
              [13.365364624000108, 50.62347442700012],
              [13.359370158000104, 50.61934031200009],
              [13.32185306800011, 50.60239044300009],
              [13.316272013000088, 50.596034241000055],
              [13.305626668000087, 50.575777080000066],
              [13.284646037000101, 50.56895579000009],
              [13.268006226000068, 50.57365834600007],
              [13.251779825000142, 50.58089304700006],
              [13.232349487000079, 50.58202992800007],
              [13.199069865000126, 50.525340882000066],
              [13.184703817000127, 50.50875274700006],
              [13.160105835000138, 50.49702219700005],
              [13.107395874000133, 50.4989859010001],
              [13.079180542000074, 50.492784729],
              [13.078973836000102, 50.49268137600008],
              [13.078870483000088, 50.49268137600008],
              [13.069775431000096, 50.49107940700004],
              [13.06037032100005, 50.4906143190001],
              [13.051068563000115, 50.49113108400006],
              [13.042283570000052, 50.492784729],
              [13.03453210400005, 50.496505432000035],
              [13.026263875000097, 50.49764231400003],
              [13.017892293000102, 50.49635040400007],
              [13.00962406400015, 50.49268137600008],
              [13.003112833000102, 50.4519086720001],
              [12.996601603000045, 50.433666891000044],
              [12.982442261000074, 50.422969870000045],
              [12.960631103000111, 50.40923412300005],
              [12.952573283000078, 50.40415964800003],
              [12.918363485000071, 50.405399882000054],
              [12.82575931800011, 50.44141835600006],
              [12.817387736000029, 50.44302032500009],
              [12.80839603700008, 50.44183176700007],
              [12.794340047000077, 50.43588897700006],
              [12.788138875000072, 50.434338684000025],
              [12.770258830000046, 50.43594065400008],
              [12.75423913600008, 50.435320536000106],
              [12.737909383000044, 50.43154815700008],
              [12.725093628000138, 50.42343495800007],
              [12.702976115000041, 50.401524150000014],
              [12.6918140060001, 50.39465118400004],
              [12.678791544000063, 50.3937210080001],
              [12.62535811400005, 50.399922181000065],
              [12.550530640000119, 50.39635650700011],
              [12.510223022000076, 50.38876007100005],
              [12.482524454000043, 50.373567200000124],
              [12.475083048000045, 50.3694330850001],
              [12.471569051000074, 50.36447214800005],
              [12.469501994000098, 50.35940785800007],
              [12.466814819000092, 50.354912008000056],
              [12.46702152500012, 50.35284495100008],
              [12.46836511300009, 50.349485983000065],
              [12.468985229000083, 50.345558574],
              [12.466814819000092, 50.341889547],
              [12.462784058000096, 50.34049428300004],
              [12.453792359000147, 50.34070099000009],
              [12.450175008000144, 50.33935740200012],
              [12.438289429000122, 50.332536113000074],
              [12.408937215000066, 50.321994121],
              [12.398188517000051, 50.315172831000055],
              [12.367182658000104, 50.27905100500003],
              [12.355813842000117, 50.27140289400005],
              [12.344651733000092, 50.266390280000095],
              [12.336486857000068, 50.25858713800007],
              [12.333799683000052, 50.24272247300006],
              [12.314059286000088, 50.22649607400005],
              [12.308684936000105, 50.21709096300002],
              [12.305584351000078, 50.19931427000007],
              [12.308581583000091, 50.186911927],
              [12.314369344000056, 50.176214905000094],
              [12.314369344000056, 50.167326559000074],
              [12.300416707000068, 50.16081532800011],
              [12.28336348400012, 50.16221059200008],
              [12.273234904000077, 50.172339173000054],
              [12.26124597200004, 50.19988271100003],
              [12.260212443000057, 50.205050355000125],
              [12.258455445000067, 50.210889791000014],
              [12.254321330000039, 50.21740102100007],
              [12.249980510000057, 50.22117340100003],
              [12.232513875000109, 50.232490540000086],
              [12.229930054000107, 50.23481597900012],
              [12.228896525000039, 50.237038066000125],
              [12.229826701000093, 50.239053447000074],
              [12.232513875000109, 50.240965475000095],
              [12.233754110000064, 50.24168894399999],
              [12.235097697000128, 50.24225738500003],
              [12.23644128400008, 50.24256744500012],
              [12.237991577000116, 50.24272247300006],
              [12.242435750000112, 50.248355204000106],
              [12.24295251500007, 50.25295440700005],
              [12.239645223000139, 50.25657175800002],
              [12.232513875000109, 50.259103902000035],
              [12.20378177900011, 50.259568990000034],
              [12.189209025000139, 50.262462871000125],
              [12.178046916000113, 50.26876739500004],
              [12.174119507000057, 50.27657053700007],
              [12.174429565000139, 50.29372711200004],
              [12.16853845200012, 50.302977193000046],
              [12.149314819000011, 50.311710511000015],
              [12.101343547000027, 50.313980338000064],
              [12.076140991000045, 50.315172831000055],
              [12.099188680000083, 50.29977325500006],
              [12.107250203000092, 50.29088490800005],
              [12.110970906000091, 50.27662221300007],
              [12.109110555000086, 50.263806458],
              [12.102392619000057, 50.25915557900002],
              [12.09205733300007, 50.25481475800005],
              [12.079551635000144, 50.24272247300006],
              [12.089886922000062, 50.230836894000035],
              [12.139289592000097, 50.211044820000055],
              [12.163784220000139, 50.19378489200007],
              [12.175049682000093, 50.18262278300004],
              [12.182697795000081, 50.170737203],
              [12.185591675000069, 50.15569936100012],
              [12.178563680000053, 50.13296173100004],
              [12.179183797000121, 50.117975566000084],
              [12.187865438000074, 50.10283437200006],
              [12.202024780000045, 50.0945144650001],
              [12.218044474000095, 50.088571676000086],
              [12.232513875000109, 50.080510152],
              [12.241402221000044, 50.070639954000015],
              [12.243469279000095, 50.060408020000025],
              [12.243675984000049, 50.05131296900005],
              [12.246879923000108, 50.04495676700013],
              [12.398188517000051, 49.992763570000065],
              [12.39922204600012, 49.992763570000065],
              [12.414518270000059, 49.98304840100012],
              [12.451311889000067, 49.98056793200003],
              [12.468158406000043, 49.97023264600004],
              [12.470742228000063, 49.955608216000044],
              [12.463817586000062, 49.94212066600009],
              [12.462680705000139, 49.931268616000054],
              [12.50360843900009, 49.91576568700005],
              [12.517871135000064, 49.91220001200007],
              [12.52407230600005, 49.9049653120001],
              [12.520971720000091, 49.88553497300002],
              [12.51291019700011, 49.87023874900005],
              [12.489862508000044, 49.84269521100008],
              [12.482524454000043, 49.82724395800007],
              [12.46247399900011, 49.831223043000065],
              [12.456376180000035, 49.817115377000036],
              [12.455859415000106, 49.79613474600002],
              [12.452655477000121, 49.779701640000056],
              [12.436739135000096, 49.76926300100003],
              [12.395397990000077, 49.75789418600003],
              [12.38361576300008, 49.74285634400006],
              [12.388576700000016, 49.732314351000085],
              [12.398911987000133, 49.719498597],
              [12.419582560000038, 49.70022328700007],
              [12.433948608000065, 49.69180002900008],
              [12.44924483200009, 49.68503041600003],
              [12.482524454000043, 49.674695130000046],
              [12.49637373900012, 49.66999257500005],
              [12.504641968000072, 49.65939890500006],
              [12.505365437000137, 49.64611806300006],
              [12.496890503000145, 49.633870748000035],
              [12.499474324000062, 49.632527161000084],
              [12.507432495000103, 49.62999501600008],
              [12.50267826300012, 49.622140198000054],
              [12.501954793000039, 49.61971140600009],
              [12.512186727000113, 49.611649882],
              [12.536061239000105, 49.603123271000086],
              [12.546603230000073, 49.59557851200013],
              [12.55363122500006, 49.58472646100007],
              [12.558282104000028, 49.56255727200006],
              [12.562312867000117, 49.55082672200008],
              [12.568720744000075, 49.53883778900011],
              [12.575025268000076, 49.529897766],
              [12.58288008700012, 49.52240468300006],
              [12.593732137000075, 49.51501495400005],
              [12.604997599000114, 49.512792867000044],
              [12.61553959200009, 49.513774720000114],
              [12.622980998000116, 49.50984731000004],
              [12.624324585000068, 49.493000794000054],
              [12.627218465000055, 49.460186259000054],
              [12.632179402000105, 49.44395985900003],
              [12.643548218000092, 49.42949045800002],
              [12.663081909000113, 49.41889679000003],
              [12.709177286000028, 49.40473744700007],
              [12.729331095000106, 49.39114654600009],
              [12.762093953000118, 49.34324249300006],
              [12.777906941000111, 49.332545472000064],
              [12.797750692000108, 49.3278429170001],
              [12.856661825000089, 49.32221018500006],
              [12.875368693000098, 49.323863831000025],
              [12.870924519000084, 49.336731263],
              [12.884670451000119, 49.33957346700008],
              [12.92291101100011, 49.33270050100002],
              [12.9398608810001, 49.3267577110001],
              [12.954330282000058, 49.319109599000015],
              [12.982442261000074, 49.29962758400002],
              [12.999805542000104, 49.294925029000055],
              [13.005386597000012, 49.28676015300003],
              [13.006730184000077, 49.277096659],
              [13.011277710000115, 49.26779490200006],
              [13.043213745000088, 49.242886861],
              [13.043420451000145, 49.24278350900006],
              [13.055822795000012, 49.238184306000036],
              [13.149460489000148, 49.15483022100007],
              [13.162586303000126, 49.13514150000013],
              [13.178502645000066, 49.11834666000006],
              [13.206821330000139, 49.10749460900011],
              [13.267282755000082, 49.10563425700012],
              [13.287333211000117, 49.10056996700003],
              [13.299528849000126, 49.093645325000054],
              [13.32991459100009, 49.06692861],
              [13.372392618000049, 49.03850657200006],
              [13.38355472800015, 49.02109161400004],
              [13.384174845000132, 48.993031311000024],
              [13.398540893000131, 48.97768341100006],
              [13.427272990000034, 48.959958395000044],
              [13.45889896600005, 48.94502390600006],
              [13.482256713000083, 48.93763417600006],
              [13.492592, 48.955049133],
              [13.50210046400008, 48.96605621400009],
              [13.515949747000036, 48.97024200500003],
              [13.522395447000093, 48.969341930000084],
              [13.53889408300006, 48.96703806600006],
              [13.55646407100005, 48.959958395000044],
              [13.573413940000137, 48.95101837200009],
              [13.590467163000085, 48.94481720000003],
              [13.608657267000126, 48.94616078700007],
              [13.611137736000103, 48.92724721300006],
              [13.621783081000103, 48.9090571090001],
              [13.637389363000125, 48.89345082600006],
              [13.654442586000073, 48.88223704000002],
              [13.673356160000111, 48.87634592800002],
              [13.710614868000022, 48.87247019500005],
              [13.724670858000138, 48.867302552000055],
              [13.747925252000073, 48.84337636300005],
              [13.796191040000082, 48.77981435200009],
              [13.815724731000074, 48.766430156000055],
            ],
          ],
          [
            [
              [14.210052931000064, 53.93846263200004],
              [14.193066040000105, 53.911490784000094],
              [14.184797811000067, 53.908131816],
              [14.175289348000092, 53.90647817000003],
              [14.192755981000118, 53.89376576800008],
              [14.200818737000134, 53.87815729300003],
              [14.087412957000083, 53.870428778000075],
              [14.065114780000044, 53.872381903000075],
              [14.048350457000083, 53.87938060100004],
              [14.02507571700005, 53.86383698100008],
              [13.99586022200009, 53.85374583500004],
              [13.938487175000091, 53.84467194200005],
              [13.875254754000082, 53.84406159100007],
              [13.840098504000082, 53.85028717700004],
              [13.821787957000083, 53.86513906500005],
              [13.834727410000085, 53.86798737200007],
              [13.855479363000086, 53.877386786000045],
              [13.887705925000091, 53.88153717700004],
              [13.922373894000089, 53.89337799700007],
              [13.931651238000086, 53.899318752000056],
              [13.938975457000083, 53.92820872600004],
              [13.901866082000083, 53.96979401200008],
              [13.904470248000052, 53.995428778000075],
              [13.95484459700009, 53.99359772300005],
              [13.972666863000086, 53.98924388200004],
              [13.965830925000091, 53.98183828300006],
              [13.968272332000083, 53.976263739000046],
              [13.96029707100007, 53.956732489000046],
              [13.958994988000086, 53.94086334800005],
              [13.974619988000086, 53.95734284100007],
              [13.987478061000047, 53.96141185100004],
              [14.027842644000089, 53.961371161000045],
              [14.022634311000047, 53.958970445000034],
              [14.018565300000091, 53.956366278000075],
              [14.015879754000082, 53.95270416900007],
              [14.014333530000044, 53.94708893400008],
              [14.048350457000083, 53.94086334800005],
              [14.040293816000087, 53.95384349200003],
              [14.053070509000065, 53.97842031500005],
              [14.051280144000089, 54.005072333000044],
              [14.037445509000065, 54.02171458500004],
              [14.014333530000044, 54.01601797100005],
              [14.006195509000065, 54.03229401200008],
              [13.995290561000047, 54.04572174700007],
              [13.981700066000087, 54.056341864000046],
              [13.965830925000091, 54.063788153000075],
              [13.946055535000085, 54.06659577000005],
              [13.926117384000065, 54.06403229400007],
              [13.915863477000073, 54.05638255400004],
              [13.924815300000091, 54.04389069200005],
              [13.924815300000091, 54.036444403000075],
              [13.916270379000082, 54.033636786000045],
              [13.907237175000091, 54.02749258000006],
              [13.899912957000083, 54.01972077000005],
              [13.896983269000089, 54.01227448100008],
              [13.890879754000082, 54.01015859600005],
              [13.855967644000089, 54.00234609600005],
              [13.858083530000044, 54.01577383000006],
              [13.865570509000065, 54.02407461100006],
              [13.873545769000089, 54.02997467700004],
              [13.87631269600007, 54.036444403000075],
              [13.871104363000086, 54.04865143400008],
              [13.863617384000065, 54.049994208000044],
              [13.854991082000083, 54.04633209800005],
              [13.823008660000085, 54.03790924700007],
              [13.80827884200005, 54.02631256700005],
              [13.794200066000087, 54.01813385600008],
              [13.774099155000044, 54.022772528000075],
              [13.782074415000068, 54.04214101800005],
              [13.809255405000044, 54.075100002000056],
              [13.814952019000089, 54.101263739000046],
              [13.806162957000083, 54.11664459800005],
              [13.76531009200005, 54.141913153000075],
              [13.752940300000091, 54.15314362200007],
              [13.762217644000089, 54.16445547100005],
              [13.777598504000082, 54.17401764500005],
              [13.796153191000087, 54.17829010600008],
              [13.814952019000089, 54.17365143400008],
              [13.823741082000083, 54.16396719000005],
              [13.844086134000065, 54.131293036000045],
              [13.855967644000089, 54.118353583000044],
              [13.88249759200005, 54.102443752000056],
              [13.948415561000047, 54.079779364000046],
              [13.986175977000073, 54.07123444200005],
              [14.016612175000091, 54.06000397300005],
              [14.192393425000091, 53.94611237200007],
              [14.209483269000089, 53.93862539300005],
              [14.210052931000064, 53.93846263200004],
            ],
          ],
          [
            [
              [6.798106316000087, 53.60443756700005],
              [6.775645379000082, 53.60248444200005],
              [6.740896030000044, 53.593451239000046],
              [6.72242272200009, 53.59076569200005],
              [6.72242272200009, 53.58462148600006],
              [6.733571811000047, 53.582017320000034],
              [6.742198113000086, 53.57835521000004],
              [6.749522332000083, 53.57241445500006],
              [6.756521030000044, 53.56289297100005],
              [6.747569207000083, 53.56598541900007],
              [6.734629754000082, 53.57518138200004],
              [6.726084832000083, 53.57713450700004],
              [6.715993686000047, 53.57607656500005],
              [6.701182488000086, 53.57143789300005],
              [6.69507897200009, 53.570298570000034],
              [6.67709394600007, 53.57562897300005],
              [6.663340691000087, 53.58734772300005],
              [6.65951582100007, 53.59910716400003],
              [6.671153191000087, 53.60443756700005],
              [6.747325066000087, 53.618353583000044],
              [6.784678582000083, 53.62006256700005],
              [6.798106316000087, 53.60443756700005],
            ],
          ],
          [
            [
              [6.873789910000085, 53.672756252000056],
              [6.910817905000044, 53.683661200000074],
              [7.047048373000052, 53.69415924700007],
              [7.085459832000083, 53.68699778900003],
              [6.873789910000085, 53.672756252000056],
            ],
          ],
          [
            [
              [7.133148634000065, 53.70807526200008],
              [7.178965691000087, 53.72406647300005],
              [7.232920769000089, 53.72943756700005],
              [7.346202019000089, 53.72797272300005],
              [7.346690300000091, 53.72321198100008],
              [7.34506269600007, 53.72207265800006],
              [7.342295769000089, 53.72211334800005],
              [7.295746290000068, 53.711004950000074],
              [7.17359459700009, 53.70140208500004],
              [7.133148634000065, 53.70807526200008],
            ],
          ],
          [
            [
              [7.36654707100007, 53.72797272300005],
              [7.383067254000082, 53.73484935100004],
              [7.403493686000047, 53.73672109600005],
              [7.422618035000085, 53.73419830900008],
              [7.435557488000086, 53.72797272300005],
              [7.432383660000085, 53.72406647300005],
              [7.42904707100007, 53.72247955900008],
              [7.42123457100007, 53.721136786000045],
              [7.381195509000065, 53.728501695000034],
              [7.36654707100007, 53.72797272300005],
            ],
          ],
          [
            [
              [8.120127800000091, 53.721136786000045],
              [8.132660352000073, 53.734035549000055],
              [8.152354363000086, 53.739162502000056],
              [8.174815300000091, 53.73700592700004],
              [8.195974155000044, 53.72797272300005],
              [8.181651238000086, 53.72797272300005],
              [8.171722852000073, 53.72557200700004],
              [8.155772332000083, 53.71637604400007],
              [8.150889519000089, 53.71430084800005],
              [8.14226321700005, 53.71564362200007],
              [8.136729363000086, 53.717962958000044],
              [8.130707227000073, 53.718451239000046],
              [8.120127800000091, 53.71430084800005],
              [8.120127800000091, 53.721136786000045],
            ],
          ],
          [
            [
              [7.517425977000073, 53.76211172100005],
              [7.606618686000047, 53.762600002000056],
              [7.62671959700009, 53.75527578300006],
              [7.627207879000082, 53.75092194200005],
              [7.625743035000085, 53.74994538000004],
              [7.623301629000082, 53.749986070000034],
              [7.620616082000083, 53.74909088700008],
              [7.547699415000068, 53.750433661000045],
              [7.513926629000082, 53.74551015800006],
              [7.511241082000083, 53.72797272300005],
              [7.481944207000083, 53.72711823100008],
              [7.472992384000065, 53.73187897300005],
              [7.469574415000068, 53.745347398000035],
              [7.474619988000086, 53.75682200700004],
              [7.486989780000044, 53.761419989000046],
              [7.517425977000073, 53.76211172100005],
            ],
          ],
          [
            [
              [7.660899285000085, 53.76211172100005],
              [7.686289910000085, 53.78099192900004],
              [7.72828209700009, 53.78656647300005],
              [7.812836134000065, 53.78314850500004],
              [7.812836134000065, 53.77635325700004],
              [7.79859459700009, 53.77635325700004],
              [7.776215040000068, 53.76797109600005],
              [7.748220248000052, 53.760931708000044],
              [7.719493035000085, 53.75991445500006],
              [7.69499759200005, 53.769517320000034],
              [7.685883009000065, 53.761786200000074],
              [7.67709394600007, 53.757798570000034],
              [7.668630405000044, 53.757879950000074],
              [7.660899285000085, 53.76211172100005],
            ],
          ],
          [
            [
              [7.873789910000085, 53.77635325700004],
              [7.854502800000091, 53.78457265800006],
              [7.858897332000083, 53.79092031500005],
              [7.87671959700009, 53.79486725500004],
              [7.897634311000047, 53.79629140800006],
              [7.914073113000086, 53.795355536000045],
              [7.928965691000087, 53.79254791900007],
              [7.955577019000089, 53.782904364000046],
              [7.946055535000085, 53.78400299700007],
              [7.93531334700009, 53.78314850500004],
              [7.893239780000044, 53.78896719000005],
              [7.875254754000082, 53.788397528000075],
              [7.873789910000085, 53.77635325700004],
            ],
          ],
          [
            [
              [11.375661655000044, 53.98183828300006],
              [11.39039147200009, 54.00458405200004],
              [11.426605665000068, 54.02293528900003],
              [11.468028191000087, 54.030951239000046],
              [11.497894727000073, 54.022772528000075],
              [11.468272332000083, 53.970689195000034],
              [11.457692905000044, 53.961371161000045],
              [11.445323113000086, 53.96112702000005],
              [11.444509311000047, 53.968085028000075],
              [11.451426629000082, 53.985541083000044],
              [11.44703209700009, 53.99713776200008],
              [11.438731316000087, 53.997259833000044],
              [11.43327884200005, 53.98875560100004],
              [11.437754754000082, 53.97500234600005],
              [11.423106316000087, 53.96771881700005],
              [11.407074415000068, 53.96820709800005],
              [11.390961134000065, 53.973944403000075],
              [11.375661655000044, 53.98183828300006],
            ],
          ],
          [
            [
              [11.528493686000047, 54.075100002000056],
              [11.528575066000087, 54.077460028000075],
              [11.533946160000085, 54.084865627000056],
              [11.601898634000065, 54.10415273600006],
              [11.615896030000044, 54.11212799700007],
              [11.59896894600007, 54.09804922100005],
              [11.552744988000086, 54.07306549700007],
              [11.539561394000089, 54.05695221600007],
              [11.533946160000085, 54.05695221600007],
              [11.528493686000047, 54.075100002000056],
            ],
          ],
          [
            [
              [8.963145379000082, 54.52366771000004],
              [8.958506707000083, 54.52244700700004],
              [8.956309441000087, 54.51943594000005],
              [8.955821160000085, 54.514960028000075],
              [8.956879102000073, 54.509426174000055],
              [8.938487175000091, 54.49909088700008],
              [8.925791863000086, 54.486761786000045],
              [8.911306186000047, 54.475490627000056],
              [8.887950066000087, 54.468451239000046],
              [8.844493035000085, 54.466498114000046],
              [8.82390384200005, 54.47085195500006],
              [8.812836134000065, 54.482123114000046],
              [8.823741082000083, 54.485541083000044],
              [8.82553144600007, 54.49119700700004],
              [8.820974155000044, 54.497259833000044],
              [8.812836134000065, 54.501939195000034],
              [8.844493035000085, 54.51972077000005],
              [8.879649285000085, 54.52912018400008],
              [8.919200066000087, 54.530462958000044],
              [8.963145379000082, 54.52366771000004],
            ],
          ],
          [
            [
              [11.25562584700009, 54.47870514500005],
              [11.31421959700009, 54.41380442900004],
              [11.188487175000091, 54.42617422100005],
              [11.170176629000082, 54.42007070500006],
              [11.174652540000068, 54.416001695000034],
              [11.17904707100007, 54.41421133000006],
              [11.138845248000052, 54.41266510600008],
              [11.11264082100007, 54.415228583000044],
              [11.10132897200009, 54.423488674000055],
              [11.10328209700009, 54.44383372600004],
              [11.098643425000091, 54.45164622600004],
              [11.084320509000065, 54.454779364000046],
              [11.058116082000083, 54.45526764500005],
              [11.047373894000089, 54.45327383000006],
              [11.039886915000068, 54.447333075000074],
              [11.032481316000087, 54.447333075000074],
              [11.029144727000073, 54.45465729400007],
              [11.025726759000065, 54.45880768400008],
              [11.020355665000068, 54.458970445000034],
              [11.008474155000044, 54.45465729400007],
              [11.005707227000073, 54.468451239000046],
              [11.033702019000089, 54.50885651200008],
              [11.072927280000044, 54.53119538000004],
              [11.121267123000052, 54.53595612200007],
              [11.206553582000083, 54.51447174700007],
              [11.23210696700005, 54.501654364000046],
              [11.24000084700009, 54.49555084800005],
              [11.25562584700009, 54.47870514500005],
            ],
          ],
          [
            [
              [13.143402540000068, 54.59813060100004],
              [13.11890709700009, 54.58641185100004],
              [13.113129102000073, 54.57005442900004],
              [13.112152540000068, 54.55068594000005],
              [13.102549675000091, 54.52993398600006],
              [13.095225457000083, 54.52435944200005],
              [13.081065300000091, 54.51715729400007],
              [13.075043165000068, 54.509426174000055],
              [13.071462436000047, 54.499660549000055],
              [13.069590691000087, 54.48965078300006],
              [13.068207227000073, 54.468451239000046],
              [13.061371290000068, 54.468451239000046],
              [13.061371290000068, 54.482123114000046],
              [13.06421959700009, 54.505113023000035],
              [13.095550977000073, 54.57078685100004],
              [13.102305535000085, 54.59609609600005],
              [13.109629754000082, 54.60309479400007],
              [13.125987175000091, 54.60561758000006],
              [13.139821811000047, 54.60602448100008],
              [13.151052280000044, 54.60492584800005],
              [13.157237175000091, 54.59906647300005],
              [13.157074415000068, 54.587958075000074],
              [13.156504754000082, 54.589056708000044],
              [13.15365644600007, 54.591131903000075],
              [13.149668816000087, 54.59137604400007],
              [13.149668816000087, 54.57770416900007],
              [13.143402540000068, 54.57770416900007],
              [13.143402540000068, 54.59813060100004],
            ],
          ],
          [
            [
              [13.698252800000091, 54.39207591400003],
              [13.724864129000082, 54.36359284100007],
              [13.74195397200009, 54.350490627000056],
              [13.766449415000068, 54.344916083000044],
              [13.753103061000047, 54.33930084800005],
              [13.740082227000073, 54.32982005400004],
              [13.73015384200005, 54.316839911000045],
              [13.72624759200005, 54.30052317900004],
              [13.72624759200005, 54.28465403900003],
              [13.723155144000089, 54.27838776200008],
              [13.712738477000073, 54.278998114000046],
              [13.690928582000083, 54.28351471600007],
              [13.702647332000083, 54.28351471600007],
              [13.711924675000091, 54.28656647300005],
              [13.715993686000047, 54.29328034100007],
              [13.711924675000091, 54.303941148000035],
              [13.705088738000086, 54.303941148000035],
              [13.694834832000083, 54.29743073100008],
              [13.67945397200009, 54.29401276200008],
              [13.663340691000087, 54.29389069200005],
              [13.651133660000085, 54.29718659100007],
              [13.651133660000085, 54.303941148000035],
              [13.688243035000085, 54.31329987200007],
              [13.703623894000089, 54.32046133000006],
              [13.711924675000091, 54.33185455900008],
              [13.65992272200009, 54.329779364000046],
              [13.636729363000086, 54.325506903000075],
              [13.61695397200009, 54.317613023000035],
              [13.672129754000082, 54.34031810100004],
              [13.690928582000083, 54.344916083000044],
              [13.690928582000083, 54.35175202000005],
              [13.664073113000086, 54.35325755400004],
              [13.65007571700005, 54.352443752000056],
              [13.64031009200005, 54.34833405200004],
              [13.626800977000073, 54.339097398000035],
              [13.618337436000047, 54.34137604400007],
              [13.610606316000087, 54.34796784100007],
              [13.59929446700005, 54.35175202000005],
              [13.49968509200005, 54.344916083000044],
              [13.48178144600007, 54.33828359600005],
              [13.428884311000047, 54.31093984600005],
              [13.41773522200009, 54.30052317900004],
              [13.406097852000073, 54.285223700000074],
              [13.381602410000085, 54.28221263200004],
              [13.359629754000082, 54.275458075000074],
              [13.355723504000082, 54.24872467700004],
              [13.369395379000082, 54.255560614000046],
              [13.369639519000089, 54.260646877000056],
              [13.367523634000065, 54.26194896000004],
              [13.364756707000083, 54.26203034100007],
              [13.363129102000073, 54.263006903000075],
              [13.410899285000085, 54.26788971600007],
              [13.41773522200009, 54.266058661000045],
              [13.425059441000087, 54.24323151200008],
              [13.423024936000047, 54.23273346600007],
              [13.407237175000091, 54.228216864000046],
              [13.37867272200009, 54.23086172100005],
              [13.34701582100007, 54.23745351800005],
              [13.311534050000091, 54.25112539300005],
              [13.319509311000047, 54.25641510600008],
              [13.324880405000044, 54.26821523600006],
              [13.335215691000087, 54.28351471600007],
              [13.320567254000082, 54.27838776200008],
              [13.313975457000083, 54.27440013200004],
              [13.307871941000087, 54.269191799000055],
              [13.31185957100007, 54.26642487200007],
              [13.314707879000082, 54.263006903000075],
              [13.29468834700009, 54.264105536000045],
              [13.284190300000091, 54.26284414300005],
              [13.276866082000083, 54.25926341400003],
              [13.267914259000065, 54.25649648600006],
              [13.257985873000052, 54.26044342700004],
              [13.248789910000085, 54.26626211100006],
              [13.242442254000082, 54.269191799000055],
              [13.227793816000087, 54.270819403000075],
              [13.210134311000047, 54.275824286000045],
              [13.199229363000086, 54.284409898000035],
              [13.20484459700009, 54.29718659100007],
              [13.190277540000068, 54.29975006700005],
              [13.159678582000083, 54.29096100500004],
              [13.149668816000087, 54.290269273000035],
              [13.142832879000082, 54.29800039300005],
              [13.148936394000089, 54.304754950000074],
              [13.162282748000052, 54.30768463700008],
              [13.17750084700009, 54.303941148000035],
              [13.17750084700009, 54.310207424000055],
              [13.115489129000082, 54.33808014500005],
              [13.129242384000065, 54.35956452000005],
              [13.148936394000089, 54.37726471600007],
              [13.174327019000089, 54.383978583000044],
              [13.20484459700009, 54.372259833000044],
              [13.211680535000085, 54.37909577000005],
              [13.223317905000044, 54.37250397300005],
              [13.237152540000068, 54.37396881700005],
              [13.266856316000087, 54.38589101800005],
              [13.251149936000047, 54.38690827000005],
              [13.239268425000091, 54.39362213700008],
              [13.234385613000086, 54.40338776200008],
              [13.239024285000085, 54.41380442900004],
              [13.239024285000085, 54.42007070500006],
              [13.225352410000085, 54.42084381700005],
              [13.217946811000047, 54.42568594000005],
              [13.211599155000044, 54.43109772300005],
              [13.201426629000082, 54.433661200000074],
              [13.156993035000085, 54.42682526200008],
              [13.174327019000089, 54.44765859600005],
              [13.181813998000052, 54.45302969000005],
              [13.208832227000073, 54.45693594000005],
              [13.239024285000085, 54.46625397300005],
              [13.25953209700009, 54.468451239000046],
              [13.25953209700009, 54.47528717700004],
              [13.260752800000091, 54.475490627000056],
              [13.266856316000087, 54.47748444200005],
              [13.27312259200005, 54.482123114000046],
              [13.245371941000087, 54.488348700000074],
              [13.233246290000068, 54.493068752000056],
              [13.225352410000085, 54.501939195000034],
              [13.228770379000082, 54.50429922100005],
              [13.231944207000083, 54.50600820500006],
              [13.233653191000087, 54.50922272300005],
              [13.232758009000065, 54.51626211100006],
              [13.203298373000052, 54.509466864000046],
              [13.185394727000073, 54.50828685100004],
              [13.17750084700009, 54.51284414300005],
              [13.175303582000083, 54.51601797100005],
              [13.170664910000085, 54.516791083000044],
              [13.166026238000086, 54.51911041900007],
              [13.16382897200009, 54.52680084800005],
              [13.162608269000089, 54.53546784100007],
              [13.158864780000044, 54.540676174000055],
              [13.152354363000086, 54.542954820000034],
              [13.143402540000068, 54.54291413000004],
              [13.166351759000065, 54.54938385600008],
              [13.242930535000085, 54.555975653000075],
              [13.25953209700009, 54.55377838700008],
              [13.264903191000087, 54.54779694200005],
              [13.276540561000047, 54.54507070500006],
              [13.288259311000047, 54.539943752000056],
              [13.293630405000044, 54.52680084800005],
              [13.297862175000091, 54.51968008000006],
              [13.305511915000068, 54.523423570000034],
              [13.309255405000044, 54.534816799000055],
              [13.301036004000082, 54.55036041900007],
              [13.315440300000091, 54.56195709800005],
              [13.33366946700005, 54.57306549700007],
              [13.352549675000091, 54.58144765800006],
              [13.369395379000082, 54.585150458000044],
              [13.358246290000068, 54.56476471600007],
              [13.350759311000047, 54.555975653000075],
              [13.342051629000082, 54.55036041900007],
              [13.348399285000085, 54.550482489000046],
              [13.353851759000065, 54.54987213700008],
              [13.358653191000087, 54.54755280200004],
              [13.363129102000073, 54.54291413000004],
              [13.358083530000044, 54.53815338700008],
              [13.348887566000087, 54.52366771000004],
              [13.363291863000086, 54.523138739000046],
              [13.374847852000073, 54.52558014500005],
              [13.383799675000091, 54.53188711100006],
              [13.389821811000047, 54.54291413000004],
              [13.381358269000089, 54.54437897300005],
              [13.371836785000085, 54.548895575000074],
              [13.363129102000073, 54.55036041900007],
              [13.363129102000073, 54.55719635600008],
              [13.37671959700009, 54.56464264500005],
              [13.387868686000047, 54.55125560100004],
              [13.405528191000087, 54.53823476800005],
              [13.41732832100007, 54.52456289300005],
              [13.410899285000085, 54.509426174000055],
              [13.430674675000091, 54.49274323100008],
              [13.455577019000089, 54.487494208000044],
              [13.507090691000087, 54.488267320000034],
              [13.49968509200005, 54.495754299000055],
              [13.509287957000083, 54.508978583000044],
              [13.514170769000089, 54.51312897300005],
              [13.520762566000087, 54.51626211100006],
              [13.520762566000087, 54.52366771000004],
              [13.512950066000087, 54.537543036000045],
              [13.50749759200005, 54.54466380400004],
              [13.49968509200005, 54.55036041900007],
              [13.49968509200005, 54.55719635600008],
              [13.50554446700005, 54.55971914300005],
              [13.508799675000091, 54.561835028000075],
              [13.512868686000047, 54.56354401200008],
              [13.520762566000087, 54.56464264500005],
              [13.520762566000087, 54.57078685100004],
              [13.508311394000089, 54.570379950000074],
              [13.500254754000082, 54.566066799000055],
              [13.49390709700009, 54.56073639500005],
              [13.486582879000082, 54.55719635600008],
              [13.475759311000047, 54.55609772300005],
              [13.441416863000086, 54.55719635600008],
              [13.436045769000089, 54.56037018400008],
              [13.430674675000091, 54.56745026200008],
              [13.423838738000086, 54.57453034100007],
              [13.414317254000082, 54.57770416900007],
              [13.399261915000068, 54.57957591400003],
              [13.393077019000089, 54.58454010600008],
              [13.389659050000091, 54.591050523000035],
              [13.382985873000052, 54.59813060100004],
              [13.371348504000082, 54.60809967700004],
              [13.369151238000086, 54.61212799700007],
              [13.355723504000082, 54.60561758000006],
              [13.347911004000082, 54.600816148000035],
              [13.33179772200009, 54.58783600500004],
              [13.30836022200009, 54.57957591400003],
              [13.291351759000065, 54.568793036000045],
              [13.273285352000073, 54.56093984600005],
              [13.25326582100007, 54.56464264500005],
              [13.24976647200009, 54.57648346600007],
              [13.256846550000091, 54.594916083000044],
              [13.269867384000065, 54.61180247600004],
              [13.283946160000085, 54.61928945500006],
              [13.286957227000073, 54.62352122600004],
              [13.291270379000082, 54.63296133000006],
              [13.293467644000089, 54.642279364000046],
              [13.290537957000083, 54.646551825000074],
              [13.24586022200009, 54.63979726800005],
              [13.231211785000085, 54.63385651200008],
              [13.224782748000052, 54.63495514500005],
              [13.225352410000085, 54.646551825000074],
              [13.230967644000089, 54.65330638200004],
              [13.24154707100007, 54.65997955900008],
              [13.25359134200005, 54.66502513200004],
              [13.390798373000052, 54.68817780200004],
              [13.418711785000085, 54.68842194200005],
              [13.44507897200009, 54.68008047100005],
              [13.44507897200009, 54.673895575000074],
              [13.429698113000086, 54.66673411700003],
              [13.409027540000068, 54.659816799000055],
              [13.390879754000082, 54.65053945500006],
              [13.382985873000052, 54.636379299000055],
              [13.385996941000087, 54.61863841400003],
              [13.394541863000086, 54.60443756700005],
              [13.407725457000083, 54.593410549000055],
              [13.424571160000085, 54.585150458000044],
              [13.466319207000083, 54.57689036700003],
              [13.595957879000082, 54.59137604400007],
              [13.640472852000073, 54.58567942900004],
              [13.670664910000085, 54.56622955900008],
              [13.677256707000083, 54.54047272300005],
              [13.651133660000085, 54.51626211100006],
              [13.60678144600007, 54.49896881700005],
              [13.584808790000068, 54.48651764500005],
              [13.575450066000087, 54.471869208000044],
              [13.579112175000091, 54.455064195000034],
              [13.587901238000086, 54.437567450000074],
              [13.599131707000083, 54.42267487200007],
              [13.609548373000052, 54.41380442900004],
              [13.630056186000047, 54.407538153000075],
              [13.67741946700005, 54.400824286000045],
              [13.698252800000091, 54.39207591400003],
            ],
          ],
          [
            [
              [8.332367384000065, 54.693793036000045],
              [8.382334832000083, 54.63914622600004],
              [8.401377800000091, 54.63296133000006],
              [8.387705925000091, 54.62612539300005],
              [8.353688998000052, 54.61896393400008],
              [8.330251498000052, 54.63141510600008],
              [8.311371290000068, 54.65135325700004],
              [8.291514519000089, 54.66705963700008],
              [8.320485873000052, 54.69871653900003],
              [8.338389519000089, 54.710150458000044],
              [8.360362175000091, 54.714829820000034],
              [8.36068769600007, 54.71002838700008],
              [8.35914147200009, 54.70892975500004],
              [8.356293165000068, 54.70917389500005],
              [8.353526238000086, 54.70799388200004],
              [8.342458530000044, 54.70140208500004],
              [8.332367384000065, 54.693793036000045],
            ],
          ],
          [
            [
              [8.497569207000083, 54.75641510600008],
              [8.553233269000089, 54.75446198100008],
              [8.57593834700009, 54.74640534100007],
              [8.593760613000086, 54.728501695000034],
              [8.593760613000086, 54.72166575700004],
              [8.585459832000083, 54.71360911700003],
              [8.574066602000073, 54.69440338700008],
              [8.56576582100007, 54.687567450000074],
              [8.55209394600007, 54.68500397300005],
              [8.535166863000086, 54.68618398600006],
              [8.519867384000065, 54.68960195500006],
              [8.511241082000083, 54.693793036000045],
              [8.485199415000068, 54.68805573100008],
              [8.45281009200005, 54.69383372600004],
              [8.394541863000086, 54.714829820000034],
              [8.414235873000052, 54.73578522300005],
              [8.436778191000087, 54.748480536000045],
              [8.464121941000087, 54.754787502000056],
              [8.497569207000083, 54.75641510600008],
            ],
          ],
          [
            [
              [8.360362175000091, 54.94818756700005],
              [8.354502800000091, 54.91274648600006],
              [8.38835696700005, 54.894232489000046],
              [8.436534050000091, 54.88727448100008],
              [8.654470248000052, 54.89362213700008],
              [8.629405144000089, 54.882147528000075],
              [8.504405144000089, 54.88617584800005],
              [8.488780144000089, 54.881293036000045],
              [8.461192254000082, 54.868801174000055],
              [8.446055535000085, 54.86627838700008],
              [8.377126498000052, 54.86627838700008],
              [8.370616082000083, 54.86823151200008],
              [8.361989780000044, 54.876939195000034],
              [8.353526238000086, 54.879339911000045],
              [8.343923373000052, 54.87909577000005],
              [8.337412957000083, 54.87759023600006],
              [8.307139519000089, 54.86538320500006],
              [8.302012566000087, 54.862616278000075],
              [8.299327019000089, 54.85529205900008],
              [8.297862175000091, 54.835598049000055],
              [8.294932488000086, 54.83152903900003],
              [8.298350457000083, 54.77692291900007],
              [8.295746290000068, 54.759100653000075],
              [8.29070071700005, 54.745306708000044],
              [8.284434441000087, 54.74237702000005],
              [8.277842644000089, 54.75641510600008],
              [8.27702884200005, 54.78278229400007],
              [8.288584832000083, 54.89130280200004],
              [8.298024936000047, 54.912543036000045],
              [8.373708530000044, 55.03497955900008],
              [8.41578209700009, 55.065334377000056],
              [8.463389519000089, 55.05068594000005],
              [8.402354363000086, 55.04877350500004],
              [8.394541863000086, 55.043850002000056],
              [8.422211134000065, 55.042181708000044],
              [8.430430535000085, 55.03001536700003],
              [8.42156009200005, 55.01626211100006],
              [8.380869988000086, 55.00307851800005],
              [8.361989780000044, 54.98680247600004],
              [8.351573113000086, 54.96674225500004],
              [8.360362175000091, 54.94818756700005],
            ],
          ],
          [
            [
              [8.63453209700009, 54.542629299000055],
              [8.69890384200005, 54.558579820000034],
              [8.70093834700009, 54.547756252000056],
              [8.692881707000083, 54.52326080900008],
              [8.669769727000073, 54.50189850500004],
              [8.641286655000044, 54.49237702000005],
              [8.61882571700005, 54.492621161000045],
              [8.606130405000044, 54.499212958000044],
              [8.595876498000052, 54.513657945000034],
              [8.602061394000089, 54.52977122600004],
              [8.620127800000091, 54.53790924700007],
              [8.627452019000089, 54.539943752000056],
              [8.63453209700009, 54.542629299000055],
            ],
          ],
          [
            [
              [7.904144727000073, 54.18040599200003],
              [7.899180535000085, 54.178168036000045],
              [7.897715691000087, 54.18231842700004],
              [7.893565300000091, 54.18309153900003],
              [7.89039147200009, 54.187567450000074],
              [7.885915561000047, 54.190659898000035],
              [7.879893425000091, 54.19391510600008],
              [7.894541863000086, 54.194647528000075],
              [7.900645379000082, 54.190659898000035],
              [7.904144727000073, 54.18040599200003],
            ],
          ],
          [
            [
              [7.912364129000082, 54.192287502000056],
              [7.929860873000052, 54.195298570000034],
              [7.933441602000073, 54.189886786000045],
              [7.91765384200005, 54.18699778900003],
              [7.912364129000082, 54.192287502000056],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Estonia',
        iso3: 'EST',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [24.306158734238295, 57.86818625584296],
              [24.316661004000082, 57.87726471600007],
              [24.324392123000052, 57.886786200000074],
              [24.32789147200009, 57.898138739000046],
              [24.330332879000082, 57.91010163000004],
              [24.333832227000073, 57.92133209800005],
              [24.381114129000082, 57.98383209800005],
              [24.398285352000073, 58.02326080900008],
              [24.446543816000087, 58.05451080900008],
              [24.464121941000087, 58.07217031500005],
              [24.464121941000087, 58.12055084800005],
              [24.471446160000085, 58.14248281500005],
              [24.472911004000082, 58.154730536000045],
              [24.467539910000085, 58.165269273000035],
              [24.459808790000068, 58.17450592700004],
              [24.455088738000086, 58.185248114000046],
              [24.45484459700009, 58.19643789300005],
              [24.467539910000085, 58.21784088700008],
              [24.46810957100007, 58.22882721600007],
              [24.467621290000068, 58.23981354400007],
              [24.470957879000082, 58.25092194200005],
              [24.491465691000087, 58.265692450000074],
              [24.521494988000086, 58.27610911700003],
              [24.54851321700005, 58.28929271000004],
              [24.560394727000073, 58.31232330900008],
              [24.551036004000082, 58.33372630400004],
              [24.528819207000083, 58.35065338700008],
              [24.444183790000068, 58.38613515800006],
              [24.403168165000068, 58.39533112200007],
              [24.36182701900009, 58.39728424700007],
              [24.326996290000068, 58.38812897300005],
              [24.315928582000083, 58.37995026200008],
              [24.304535352000073, 58.368068752000056],
              [24.295746290000068, 58.35496653900003],
              [24.292246941000087, 58.343085028000075],
              [24.29078209700009, 58.32754140800006],
              [24.28687584700009, 58.31854889500005],
              [24.255869988000086, 58.28953685100004],
              [24.243337436000047, 58.28021881700005],
              [24.228851759000065, 58.27411530200004],
              [24.210785352000073, 58.27138906500005],
              [24.174164259000065, 58.27680084800005],
              [24.15601647200009, 58.27684153900003],
              [24.138926629000082, 58.26797109600005],
              [24.12086022200009, 58.24518463700008],
              [24.111664259000065, 58.24103424700007],
              [24.094086134000065, 58.24469635600008],
              [24.083506707000083, 58.250881252000056],
              [24.05323326900009, 58.27826569200005],
              [24.007090691000087, 58.30052317900004],
              [23.98023522200009, 58.318426825000074],
              [23.91382897200009, 58.333319403000075],
              [23.873708530000044, 58.335191148000035],
              [23.854665561000047, 58.33966705900008],
              [23.849457227000073, 58.34275950700004],
              [23.83838951900009, 58.35138580900008],
              [23.833506707000083, 58.353949286000045],
              [23.824473504000082, 58.35455963700008],
              [23.818369988000086, 58.35175202000005],
              [23.812836134000065, 58.34829336100006],
              [23.80567467500009, 58.34650299700007],
              [23.79664147200009, 58.348822333000044],
              [23.78687584700009, 58.35309479400007],
              [23.77711022200009, 58.35496653900003],
              [23.76807701900009, 58.35024648600006],
              [23.762054884000065, 58.34438711100006],
              [23.75562584700009, 58.34003327000005],
              [23.74854576900009, 58.339056708000044],
              [23.740977410000085, 58.343085028000075],
              [23.73487389400009, 58.35138580900008],
              [23.729258660000085, 58.36286041900007],
              [23.725271030000044, 58.37490469000005],
              [23.72364342500009, 58.38471100500004],
              [23.718923373000052, 58.39956289300005],
              [23.70753014400009, 58.40737539300005],
              [23.694183790000068, 58.41315338700008],
              [23.68336022200009, 58.42218659100007],
              [23.67741946700005, 58.435248114000046],
              [23.67750084700009, 58.44554271000004],
              [23.68336022200009, 58.470038153000075],
              [23.684336785000085, 58.499660549000055],
              [23.678965691000087, 58.52415599200003],
              [23.66382897200009, 58.53620026200008],
              [23.634938998000052, 58.52838776200008],
              [23.62240644600007, 58.52912018400008],
              [23.60320071700005, 58.53595612200007],
              [23.584320509000065, 58.54486725500004],
              [23.573496941000087, 58.551947333000044],
              [23.566254102000073, 58.56590403900003],
              [23.565114780000044, 58.577378648000035],
              [23.561208530000044, 58.58315664300005],
              [23.546153191000087, 58.57990143400008],
              [23.532725457000083, 58.57025788000004],
              [23.52475019600007, 58.55955638200004],
              [23.516368035000085, 58.55463288000004],
              [23.501475457000083, 58.562486070000034],
              [23.498057488000086, 58.57221100500004],
              [23.50440514400009, 58.58295319200005],
              [23.513519727000073, 58.593817450000074],
              [23.518239780000044, 58.60374583500004],
              [23.512461785000085, 58.622381903000075],
              [23.50098717500009, 58.64712148600006],
              [23.49317467500009, 58.67340729400007],
              [23.49773196700005, 58.696600653000075],
              [23.506521030000044, 58.70538971600007],
              [23.514821811000047, 58.706691799000055],
              [23.535899285000085, 58.702785549000055],
              [23.543223504000082, 58.70490143400008],
              [23.54664147200009, 58.70962148600006],
              [23.54623457100007, 58.71430084800005],
              [23.530039910000085, 58.72284577000005],
              [23.527354363000086, 58.73615143400008],
              [23.533050977000073, 58.74746328300006],
              [23.546153191000087, 58.747748114000046],
              [23.58448326900009, 58.737941799000055],
              [23.621755405000044, 58.741400458000044],
              [23.658946160000085, 58.748928127000056],
              [23.69703209700009, 58.751166083000044],
              [23.716644727000073, 58.74701569200005],
              [23.75521894600007, 58.733587958000044],
              [23.771820509000065, 58.73069896000004],
              [23.80250084700009, 58.73069896000004],
              [23.805430535000085, 58.73387278900003],
              [23.806651238000086, 58.74095286700003],
              [23.804860873000052, 58.74799225500004],
              [23.799082879000082, 58.751166083000044],
              [23.783376498000052, 58.755845445000034],
              [23.779551629000082, 58.76642487200007],
              [23.785492384000065, 58.77798086100006],
              [23.799489780000044, 58.78534577000005],
              [23.81617272200009, 58.78461334800005],
              [23.85515384200005, 58.77326080900008],
              [23.87435957100007, 58.77167389500005],
              [23.84742272200009, 58.78823476800005],
              [23.815684441000087, 58.79995351800005],
              [23.78419030000009, 58.80097077000005],
              [23.757660352000073, 58.78534577000005],
              [23.739512566000087, 58.79800039300005],
              [23.719086134000065, 58.79905833500004],
              [23.676524285000085, 58.792181708000044],
              [23.603363477000073, 58.79482656500005],
              [23.580332879000082, 58.792181708000044],
              [23.56031334700009, 58.78583405200004],
              [23.55014082100007, 58.780910549000055],
              [23.54273522200009, 58.775376695000034],
              [23.536631707000083, 58.77448151200008],
              [23.50489342500009, 58.77912018400008],
              [23.485524936000047, 58.777329820000034],
              [23.42945397200009, 58.764837958000044],
              [23.46656334700009, 58.80072663000004],
              [23.48568769600007, 58.80963776200008],
              [23.518809441000087, 58.81264883000006],
              [23.526133660000085, 58.81976959800005],
              [23.463633660000085, 58.864162502000056],
              [23.455088738000086, 58.88300202000005],
              [23.42237389400009, 58.90867747600004],
              [23.422048373000052, 58.92869700700004],
              [23.443695509000065, 58.94403717700004],
              [23.510101759000065, 58.94159577000005],
              [23.531911655000044, 58.956691799000055],
              [23.549164259000065, 58.950832424000055],
              [23.56690514400009, 58.95014069200005],
              [23.58448326900009, 58.953558661000045],
              [23.616709832000083, 58.967678127000056],
              [23.624847852000073, 58.97260163000004],
              [23.627696160000085, 58.97915273600006],
              [23.628103061000047, 58.991400458000044],
              [23.62159264400009, 59.015326239000046],
              [23.605479363000086, 59.03266022300005],
              [23.583506707000083, 59.04474518400008],
              [23.559825066000087, 59.052801825000074],
              [23.572276238000086, 59.03974030200004],
              [23.601898634000065, 59.02448151200008],
              [23.614431186000047, 59.01129791900007],
              [23.60596764400009, 59.00849030200004],
              [23.58757571700005, 59.007473049000055],
              [23.580332879000082, 59.005072333000044],
              [23.559825066000087, 58.991400458000044],
              [23.558441602000073, 58.987941799000055],
              [23.558604363000086, 58.98200104400007],
              [23.552989129000082, 58.97089264500005],
              [23.543304884000065, 58.96987539300005],
              [23.537119988000086, 58.97435130400004],
              [23.531993035000085, 58.980536200000074],
              [23.525645379000082, 58.98395416900007],
              [23.461273634000065, 58.99237702000005],
              [23.434825066000087, 59.00381094000005],
              [23.408376498000052, 59.02558014500005],
              [23.415212436000047, 59.02496979400007],
              [23.42945397200009, 59.02586497600004],
              [23.436289910000085, 59.02558014500005],
              [23.429209832000083, 59.04360586100006],
              [23.43490644600007, 59.05609772300005],
              [23.480316602000073, 59.083644924000055],
              [23.49073326900009, 59.08828359600005],
              [23.501231316000087, 59.08543528900003],
              [23.518239780000044, 59.07330963700008],
              [23.519379102000073, 59.124986070000034],
              [23.486175977000073, 59.17413971600007],
              [23.470876498000052, 59.212144273000035],
              [23.525645379000082, 59.23041413000004],
              [23.53679446700005, 59.229681708000044],
              [23.557790561000047, 59.22524648600006],
              [23.56967207100007, 59.22418854400007],
              [23.578461134000065, 59.22630442900004],
              [23.59278405000009, 59.235663153000075],
              [23.615489129000082, 59.24176666900007],
              [23.627696160000085, 59.250067450000074],
              [23.641856316000087, 59.25739166900007],
              [23.662282748000052, 59.25828685100004],
              [23.715505405000044, 59.231675523000035],
              [23.71851647200009, 59.23143138200004],
              [23.730479363000086, 59.23041413000004],
              [23.742198113000086, 59.23940664300005],
              [23.742930535000085, 59.25014883000006],
              [23.73601321700005, 59.25958893400008],
              [23.72364342500009, 59.26508209800005],
              [23.73487389400009, 59.27773672100005],
              [23.75684655000009, 59.283636786000045],
              [23.84538821700005, 59.28465403900003],
              [23.888845248000052, 59.27875397300005],
              [23.935557488000086, 59.280585028000075],
              [23.98764082100007, 59.29092031500005],
              [24.038584832000083, 59.29328034100007],
              [24.08057701900009, 59.27130768400008],
              [24.10010826900009, 59.29450104400007],
              [24.092051629000082, 59.312567450000074],
              [24.028168165000068, 59.35765208500004],
              [24.019379102000073, 59.367254950000074],
              [24.022227410000085, 59.378119208000044],
              [24.03484134200005, 59.388657945000034],
              [24.04818769600007, 59.39508698100008],
              [24.06299889400009, 59.397365627000056],
              [24.08057701900009, 59.39545319200005],
              [24.108653191000087, 59.384833075000074],
              [24.164886915000068, 59.35407135600008],
              [24.19385826900009, 59.347723700000074],
              [24.221934441000087, 59.355169989000046],
              [24.21338951900009, 59.372259833000044],
              [24.18726647200009, 59.390692450000074],
              [24.16309655000009, 59.40228913000004],
              [24.182871941000087, 59.40875885600008],
              [24.27125084700009, 59.412095445000034],
              [24.306162957000083, 59.41909414300005],
              [24.31771894600007, 59.430975653000075],
              [24.329600457000083, 59.46381256700005],
              [24.333832227000073, 59.47060781500005],
              [24.399668816000087, 59.47882721600007],
              [24.422536655000044, 59.477443752000056],
              [24.442149285000085, 59.46987539300005],
              [24.47828209700009, 59.44839101800005],
              [24.498301629000082, 59.44383372600004],
              [24.516774936000047, 59.44822825700004],
              [24.532399936000047, 59.45677317900004],
              [24.54818769600007, 59.462958075000074],
              [24.567149285000085, 59.46002838700008],
              [24.624847852000073, 59.43891022300005],
              [24.642588738000086, 59.436428127000056],
              [24.660492384000065, 59.440619208000044],
              [24.656586134000065, 59.44989655200004],
              [24.64039147200009, 59.459051825000074],
              [24.621836785000085, 59.46312083500004],
              [24.621836785000085, 59.47060781500005],
              [24.64812259200005, 59.46922435100004],
              [24.658539259000065, 59.47207265800006],
              [24.662771030000044, 59.48114655200004],
              [24.666270379000082, 59.49209219000005],
              [24.674978061000047, 59.49603913000004],
              [24.686289910000085, 59.49506256700005],
              [24.697520379000082, 59.49103424700007],
              [24.715586785000085, 59.475897528000075],
              [24.72828209700009, 59.45856354400007],
              [24.744395379000082, 59.44721100500004],
              [24.772634311000047, 59.450100002000056],
              [24.78419030000009, 59.454779364000046],
              [24.79004967500009, 59.45892975500004],
              [24.813243035000085, 59.484035549000055],
              [24.81576582100007, 59.48932526200008],
              [24.806813998000052, 59.50470612200007],
              [24.800303582000083, 59.51056549700007],
              [24.791351759000065, 59.51471588700008],
              [24.783539259000065, 59.51984284100007],
              [24.780121290000068, 59.528957424000055],
              [24.779958530000044, 59.538397528000075],
              [24.77898196700005, 59.54547760600008],
              [24.77670332100007, 59.55215078300006],
              [24.772634311000047, 59.55996328300006],
              [24.803477410000085, 59.57050202000005],
              [24.841644727000073, 59.55442942900004],
              [24.90919030000009, 59.51154205900008],
              [24.934418165000068, 59.50804271000004],
              [25.01221764400009, 59.51837799700007],
              [25.035817905000044, 59.51520416900007],
              [25.07715905000009, 59.50104401200008],
              [25.097829623000052, 59.49787018400008],
              [25.116465691000087, 59.503119208000044],
              [25.10792076900009, 59.528998114000046],
              [25.12208092500009, 59.539496161000045],
              [25.14551842500009, 59.539129950000074],
              [25.194102410000085, 59.522650458000044],
              [25.407725457000083, 59.49103424700007],
              [25.409434441000087, 59.49103424700007],
              [25.402354363000086, 59.51430898600006],
              [25.41578209700009, 59.52708567900004],
              [25.440114780000044, 59.532131252000056],
              [25.533213738000086, 59.53204987200007],
              [25.543711785000085, 59.535142320000034],
              [25.543304884000065, 59.542222398000035],
              [25.53614342500009, 59.54930247600004],
              [25.525726759000065, 59.55247630400004],
              [25.49708092500009, 59.57086823100008],
              [25.481944207000083, 59.61115143400008],
              [25.478526238000086, 59.65151601800005],
              [25.48487389400009, 59.66982656500005],
              [25.50245201900009, 59.66225820500006],
              [25.535329623000052, 59.628973700000074],
              [25.55372155000009, 59.62140534100007],
              [25.575043165000068, 59.616888739000046],
              [25.592051629000082, 59.60602448100008],
              [25.622325066000087, 59.58047109600005],
              [25.644541863000086, 59.57184479400007],
              [25.67676842500009, 59.566066799000055],
              [25.705902540000068, 59.56928131700005],
              [25.71851647200009, 59.587591864000046],
              [25.710785352000073, 59.60455963700008],
              [25.695567254000082, 59.61591217700004],
              [25.684825066000087, 59.62864817900004],
              [25.690684441000087, 59.64935944200005],
              [25.684336785000085, 59.65021393400008],
              [25.675303582000083, 59.65412018400008],
              [25.670664910000085, 59.655503648000035],
              [25.69467207100007, 59.67088450700004],
              [25.725352410000085, 59.66583893400008],
              [25.780528191000087, 59.63568756700005],
              [25.77312259200005, 59.628241278000075],
              [25.785411004000082, 59.61546458500004],
              [25.793711785000085, 59.59121328300006],
              [25.807383660000085, 59.58047109600005],
              [25.826182488000086, 59.57526276200008],
              [25.83692467500009, 59.57648346600007],
              [25.844493035000085, 59.577337958000044],
              [25.861338738000086, 59.58612702000005],
              [25.876231316000087, 59.600897528000075],
              [25.86882571700005, 59.60773346600007],
              [25.883067254000082, 59.63133372600004],
              [25.904470248000052, 59.62400950700004],
              [25.926931186000047, 59.60529205900008],
              [25.944509311000047, 59.59467194200005],
              [25.965017123000052, 59.597316799000055],
              [25.967051629000082, 59.60382721600007],
              [25.962738477000073, 59.612534898000035],
              [25.964366082000083, 59.62140534100007],
              [25.976898634000065, 59.63125234600005],
              [25.988536004000082, 59.63434479400007],
              [26.001800977000073, 59.63263580900008],
              [26.036387566000087, 59.62323639500005],
              [26.074473504000082, 59.60431549700007],
              [26.078379754000082, 59.60028717700004],
              [26.080332879000082, 59.59467194200005],
              [26.08171634200005, 59.58730703300006],
              [26.090993686000047, 59.585638739000046],
              [26.280039910000085, 59.58730703300006],
              [26.29932701900009, 59.58421458500004],
              [26.340098504000082, 59.57050202000005],
              [26.40170332100007, 59.56305573100008],
              [26.457692905000044, 59.54588450700004],
              [26.49781334700009, 59.53998444200005],
              [26.519867384000065, 59.539496161000045],
              [26.53646894600007, 59.542669989000046],
              [26.570323113000086, 59.55678945500006],
              [26.584727410000085, 59.55996328300006],
              [26.62631269600007, 59.55805084800005],
              [26.66504967500009, 59.551947333000044],
              [26.702321811000047, 59.54140859600005],
              [26.739024285000085, 59.525824286000045],
              [26.780853712000066, 59.50254954600007],
              [26.826914910000085, 59.47695547100005],
              [26.875743035000085, 59.46771881700005],
              [26.917491082000083, 59.45416901200008],
              [26.937673373000052, 59.450100002000056],
              [27.11622155000009, 59.44204336100006],
              [27.27507571700005, 59.446966864000046],
              [27.409027540000068, 59.45189036700003],
              [27.563161655000044, 59.432074286000045],
              [27.717051629000082, 59.42715078300006],
              [27.873301629000082, 59.40761953300006],
              [27.914724155000044, 59.41453685100004],
              [27.953461134000065, 59.428168036000045],
              [27.983164910000085, 59.446966864000046],
              [28.019053582000083, 59.481756903000075],
              [28.038577514000025, 59.46298655200006],
              [28.083432657000117, 59.450894267000095],
              [28.104826701000036, 59.4392153940001],
              [28.12839115400004, 59.409449769000034],
              [28.137796264000087, 59.40035471600005],
              [28.149578491000085, 59.39317169200011],
              [28.175365031000098, 59.38185455400013],
              [28.186475464000125, 59.37492991100005],
              [28.181824585000044, 59.35606801400003],
              [28.15753666200007, 59.36402618500007],
              [28.1135600180001, 59.34542266900003],
              [28.03237634300004, 59.341960348],
              [28.000647014000037, 59.333743796000064],
              [28.07320072400003, 59.31896433500005],
              [28.09686853100007, 59.319429423000074],
              [28.076611369000148, 59.30527008100002],
              [27.959719279000097, 59.30645863900004],
              [27.903908733000037, 59.29038726800006],
              [27.88230798400008, 59.27565948500008],
              [27.890782919000088, 59.25803782200008],
              [27.873522990000083, 59.23648875000002],
              [27.842413778000036, 59.16119618800006],
              [27.784329467000134, 59.07717030900004],
              [27.767172892000076, 59.055931295000065],
              [27.724384807000064, 59.0144351200001],
              [27.713326049000074, 58.99190419600008],
              [27.69588933300011, 58.97718303300009],
              [27.69441247600011, 58.975936178000026],
              [27.60532230600012, 58.93469838500003],
              [27.47778487100007, 58.87542551700004],
              [27.446269007000126, 58.818866663000065],
              [27.410605509000106, 58.75486440000007],
              [27.428848762000086, 58.70940260400006],
              [27.44925948000011, 58.65853953100002],
              [27.498868856000087, 58.53456776900002],
              [27.55488610800012, 58.395248109000065],
              [27.494114624000105, 58.31954213500008],
              [27.482849161000047, 58.26864084900005],
              [27.495354859000116, 58.22146026600005],
              [27.519585015000047, 58.194509827],
              [27.540003296000066, 58.171799215000036],
              [27.579690796000136, 58.125858867000076],
              [27.630437053000037, 58.088290100000066],
              [27.63658654800011, 58.059196269000054],
              [27.630126993000147, 58.03299631800003],
              [27.63157393400013, 58.004160868],
              [27.650642537000124, 58.00007843100009],
              [27.669091024000124, 57.991965230000076],
              [27.675188843000086, 57.96780649900002],
              [27.670434611000104, 57.95496490600003],
              [27.66319991100005, 57.943957825000055],
              [27.659375855000093, 57.9324598190001],
              [27.664956909000125, 57.9184038290001],
              [27.673121785000035, 57.91282277400008],
              [27.774407593000063, 57.89070526200008],
              [27.790840698000125, 57.880860901000105],
              [27.79931563300002, 57.86106882700004],
              [27.78680993600011, 57.84758127900007],
              [27.763452189000077, 57.83866709400003],
              [27.700717, 57.82484364900007],
              [27.55634348500007, 57.81308699600005],
              [27.537626180000103, 57.811562805000065],
              [27.524603719000083, 57.80729950000001],
              [27.53256189000004, 57.805077414000024],
              [27.553852580000125, 57.794767965000105],
              [27.52615401200009, 57.78727488200006],
              [27.512408081000075, 57.78130625500005],
              [27.502434530000073, 57.77254709900008],
              [27.497835327000104, 57.755674744],
              [27.508894084000104, 57.7274594120001],
              [27.507757202000107, 57.71477284700008],
              [27.490393921000077, 57.704618429],
              [27.40771162900012, 57.68898630900007],
              [27.3914335530001, 57.68020131400009],
              [27.384663940000053, 57.67438771600008],
              [27.379703003000117, 57.66645538400006],
              [27.377015829000072, 57.656714376000096],
              [27.377946004000137, 57.65170176200003],
              [27.380219767000142, 57.64772267700006],
              [27.382803589000048, 57.63446767200004],
              [27.38512902800008, 57.63121205700007],
              [27.386989380000102, 57.627646383000084],
              [27.38487064600011, 57.606975810000094],
              [27.38208011900005, 57.602686666000025],
              [27.374845418000092, 57.59785492000002],
              [27.362546428000144, 57.594547628],
              [27.34890384900004, 57.59405670200006],
              [27.3366048580001, 57.59173126300006],
              [27.328026571000066, 57.58315297500012],
              [27.32854333500012, 57.570569763],
              [27.335571330000107, 57.553904115000066],
              [27.344976440000067, 57.538091126000054],
              [27.352934611000137, 57.52760081000012],
              [27.319965047000068, 57.51612864200008],
              [27.165659220000066, 57.546695252000106],
              [27.085354045000116, 57.54943410300005],
              [27.061531209000066, 57.555661113000056],
              [27.041325724000075, 57.56845103000002],
              [27.00463545800011, 57.598914286000095],
              [26.981071004000086, 57.60899119100013],
              [26.94655114800011, 57.61534739200006],
              [26.929187866000092, 57.61555409800012],
              [26.911617880000023, 57.61343536400004],
              [26.89611495000011, 57.61498565700005],
              [26.884952840000096, 57.62209116600009],
              [26.87265384900013, 57.627181295000085],
              [26.85415368700012, 57.622556254000116],
              [26.83854740400008, 57.60986969000008],
              [26.82831547100008, 57.595038555000045],
              [26.816326538000055, 57.58118927000008],
              [26.795759318000137, 57.571319071000104],
              [26.778085978000064, 57.56847686800002],
              [26.70046797600014, 57.57075063100005],
              [26.666981649000064, 57.564859518000034],
              [26.634322144000095, 57.55442087900009],
              [26.604763224000067, 57.54031321300006],
              [26.59835534700011, 57.53385365900003],
              [26.594841349000063, 57.52648976700003],
              [26.59008711800007, 57.52036610900005],
              [26.57985518300009, 57.517833965000065],
              [26.570243367000074, 57.519590963000056],
              [26.551743205000065, 57.526825664000015],
              [26.542234741000073, 57.52816925100008],
              [26.528695516000084, 57.523880107000096],
              [26.515052938000082, 57.517265524000024],
              [26.499550008000057, 57.51581858300001],
              [26.481049846000133, 57.5271357220001],
              [26.44756351700005, 57.552922262],
              [26.430923706000016, 57.56170725500009],
              [26.430678413000066, 57.561764252],
              [26.351325150000037, 57.5802030010001],
              [26.33862959800004, 57.58315297500012],
              [26.297185099000075, 57.599146830000066],
              [26.26318200700004, 57.62082509400004],
              [26.168510783000016, 57.70404998800005],
              [26.135231161000092, 57.724772238000085],
              [26.024746948000143, 57.77435577400006],
              [26.016065308000094, 57.78668060300002],
              [26.013068074000074, 57.80729950000001],
              [26.016065308000094, 57.816472067000106],
              [26.021749715000055, 57.82241485600012],
              [26.0252637130001, 57.82840932200004],
              [26.021956421000112, 57.83794362400003],
              [26.014515015000086, 57.84282704700006],
              [26.00273278800009, 57.84597931000012],
              [25.792616415000083, 57.85597869900003],
              [25.76750166800008, 57.868923646000056],
              [25.75468591300009, 57.88889658600009],
              [25.745384155000067, 57.90917958600009],
              [25.73029463700007, 57.923132223],
              [25.714998413000103, 57.92339060500005],
              [25.703799772000053, 57.921326524000065],
              [25.65009281400006, 57.911427511000014],
              [25.62508142100006, 57.91029063000009],
              [25.601516968000055, 57.91220265800011],
              [25.579399455000072, 57.919463196],
              [25.55831547000011, 57.93424265600002],
              [25.552941122000078, 57.94217498800005],
              [25.55211429800005, 57.94881541000005],
              [25.551815984000143, 57.949859510000024],
              [25.550253947000044, 57.955326640000024],
              [25.541675659000106, 57.96281972300007],
              [25.531960489000056, 57.96643707300005],
              [25.49661381000007, 57.97059702600008],
              [25.457184692000055, 57.98405873600005],
              [25.396619914000098, 58.02317779600007],
              [25.356519002000084, 58.034753317000096],
              [25.346390421000137, 58.034443258000024],
              [25.33987919100008, 58.03258290600003],
              [25.333678019000104, 58.03180776],
              [25.32458296700011, 58.034753317000096],
              [25.31827844300011, 58.040618592],
              [25.30639286300007, 58.05873118100003],
              [25.29957157400011, 58.065604147],
              [25.281691528000067, 58.07340728800001],
              [25.26350142400011, 58.07513844900008],
              [25.250685669000035, 58.068498027],
              [25.24954878800014, 58.05118642200007],
              [25.277557414000057, 58.024107972000124],
              [25.2843787030001, 58.00813995400007],
              [25.264534953000094, 57.9941873180001],
              [25.232495565000107, 57.985376486000106],
              [25.21678593000013, 57.985376486000106],
              [25.20210982200004, 57.991965230000076],
              [25.189914184000116, 58.013514303000036],
              [25.180715780000128, 58.03816396100005],
              [25.166969848000093, 58.05873118100003],
              [25.141028280000057, 58.06800710100005],
              [25.094209432000127, 58.06730946900005],
              [25.070644978000132, 58.06361460400005],
              [25.048837524000106, 58.05619903600005],
              [25.034856819000083, 58.04857408500003],
              [24.9748368730001, 58.01583974200007],
              [24.949308716000047, 58.00643463100003],
              [24.87251753700008, 58.000440165],
              [24.84833296700012, 57.99214609800005],
              [24.827417479000076, 57.98187693600009],
              [24.816810344000146, 57.97666900700004],
              [24.79076542100009, 57.97899444600007],
              [24.764720500000095, 57.987908631],
              [24.73350793500012, 57.99219777400005],
              [24.718831828000134, 57.981836650000034],
              [24.70043501800012, 57.95418975800003],
              [24.68482873500008, 57.94757517500004],
              [24.624057251000096, 57.943957825000055],
              [24.553880656000103, 57.947420146000084],
              [24.533830200000068, 57.945068868000035],
              [24.48132694500009, 57.91930816700004],
              [24.441639445000106, 57.90809438100008],
              [24.429133748000112, 57.9003429160001],
              [24.41270064300005, 57.876571757000036],
              [24.40153853300012, 57.86646901400009],
              [24.378180786000087, 57.85944102000009],
              [24.349655395000127, 57.85864003600007],
              [24.306158734238295, 57.86818625584296],
            ],
          ],
          [
            [
              [23.943369988000086, 58.11318594000005],
              [23.93799889400009, 58.13727448100008],
              [23.955332879000082, 58.15180084800005],
              [23.984222852000073, 58.157131252000056],
              [24.01335696700005, 58.153509833000044],
              [24.022146030000044, 58.12986888200004],
              [24.00245201900009, 58.10854726800005],
              [23.970713738000086, 58.099595445000034],
              [23.943369988000086, 58.11318594000005],
            ],
          ],
          [
            [
              [23.230642123000052, 58.50482819200005],
              [23.255137566000087, 58.500067450000074],
              [23.288584832000083, 58.48818594000005],
              [23.318369988000086, 58.47247955900008],
              [23.333262566000087, 58.456366278000075],
              [23.324961785000085, 58.442287502000056],
              [23.26140384200005, 58.46588776200008],
              [23.23764082100007, 58.456366278000075],
              [23.250254754000082, 58.45453522300005],
              [23.261729363000086, 58.451605536000045],
              [23.271332227000073, 58.44599030200004],
              [23.278005405000044, 58.43650950700004],
              [23.23487389400009, 58.439886786000045],
              [23.215668165000068, 58.44586823100008],
              [23.196055535000085, 58.456366278000075],
              [23.192230665000068, 58.46112702000005],
              [23.188243035000085, 58.46820709800005],
              [23.181895379000082, 58.474676825000074],
              [23.171885613000086, 58.47748444200005],
              [23.156504754000082, 58.47752513200004],
              [23.15479576900009, 58.475490627000056],
              [23.14893639400009, 58.470038153000075],
              [23.14698326900009, 58.46637604400007],
              [23.14161217500009, 58.45184967700004],
              [23.13803144600007, 58.44611237200007],
              [23.130381707000083, 58.439520575000074],
              [23.12354576900009, 58.43569570500006],
              [23.108653191000087, 58.429022528000075],
              [23.101898634000065, 58.42959219000005],
              [23.092539910000085, 58.43154531500005],
              [23.084239129000082, 58.42963288000004],
              [23.08057701900009, 58.41852448100008],
              [23.08106530000009, 58.41242096600007],
              [23.082286004000082, 58.40599192900004],
              [23.084239129000082, 58.39996979400007],
              [23.086761915000068, 58.394964911000045],
              [23.06381269600007, 58.38544342700004],
              [23.042491082000083, 58.37148672100005],
              [23.02198326900009, 58.36322663000004],
              [22.97754967500009, 58.38165924700007],
              [22.95484459700009, 58.38104889500005],
              [22.947520379000082, 58.37262604400007],
              [22.969493035000085, 58.36017487200007],
              [22.902679884000065, 58.311835028000075],
              [22.886973504000082, 58.30735911700003],
              [22.870941602000073, 58.304673570000034],
              [22.85401451900009, 58.29873281500005],
              [22.824880405000044, 58.27920156500005],
              [22.811208530000044, 58.273423570000034],
              [22.788584832000083, 58.27138906500005],
              [22.742930535000085, 58.27383047100005],
              [22.72120201900009, 58.27033112200007],
              [22.710134311000047, 58.25775788000004],
              [22.756683790000068, 58.242254950000074],
              [22.72315514400009, 58.22540924700007],
              [22.669200066000087, 58.22150299700007],
              [22.654958530000044, 58.24469635600008],
              [22.639821811000047, 58.25023021000004],
              [22.621348504000082, 58.25275299700007],
              [22.60254967500009, 58.25210195500006],
              [22.586192254000082, 58.24778880400004],
              [22.570974155000044, 58.239447333000044],
              [22.56495201900009, 58.23517487200007],
              [22.56031334700009, 58.23725006700005],
              [22.549082879000082, 58.24778880400004],
              [22.535004102000073, 58.25405508000006],
              [22.526133660000085, 58.247381903000075],
              [22.517588738000086, 58.23041413000004],
              [22.510427280000044, 58.22719961100006],
              [22.50717207100007, 58.22492096600007],
              [22.504161004000082, 58.223537502000056],
              [22.497243686000047, 58.22304922100005],
              [22.496836785000085, 58.22650788000004],
              [22.49154707100007, 58.241522528000075],
              [22.490977410000085, 58.24469635600008],
              [22.476817254000082, 58.24510325700004],
              [22.459320509000065, 58.24091217700004],
              [22.44304446700005, 58.234076239000046],
              [22.432383660000085, 58.22675202000005],
              [22.42164147200009, 58.22162506700005],
              [22.410004102000073, 58.22402578300006],
              [22.398448113000086, 58.227728583000044],
              [22.387950066000087, 58.22675202000005],
              [22.38054446700005, 58.22345612200007],
              [22.361501498000052, 58.21771881700005],
              [22.353770379000082, 58.216782945000034],
              [22.323415561000047, 58.20661041900007],
              [22.295095248000052, 58.19285716400003],
              [22.281993035000085, 58.18256256700005],
              [22.27475019600007, 58.17926666900007],
              [22.271739129000082, 58.174261786000045],
              [22.269867384000065, 58.13703034100007],
              [22.26539147200009, 58.11505768400008],
              [22.25684655000009, 58.09324778900003],
              [22.229258660000085, 58.05219147300005],
              [22.221039259000065, 58.042954820000034],
              [22.209808790000068, 58.03489817900004],
              [22.199880405000044, 58.02602773600006],
              [22.198415561000047, 58.01634349200003],
              [22.202972852000073, 57.99396393400008],
              [22.18995201900009, 57.98383209800005],
              [22.048350457000083, 57.91510651200008],
              [22.016856316000087, 57.914496161000045],
              [21.990082227000073, 57.935614325000074],
              [21.994395379000082, 57.947251695000034],
              [21.99073326900009, 57.958238023000035],
              [21.980804884000065, 57.966498114000046],
              [21.966807488000086, 57.96971263200004],
              [21.964121941000087, 57.97138092700004],
              [21.96265709700009, 57.97528717700004],
              [21.96225019600007, 57.97996653900003],
              [21.96338951900009, 57.984035549000055],
              [21.989756707000083, 57.98273346600007],
              [21.997569207000083, 57.984035549000055],
              [22.004567905000044, 57.99095286700003],
              [22.01539147200009, 58.01203034100007],
              [22.021332227000073, 58.02122630400004],
              [22.058929884000065, 58.05231354400007],
              [22.076182488000086, 58.07339101800005],
              [22.08570397200009, 58.08258698100008],
              [22.09620201900009, 58.08641185100004],
              [22.11068769600007, 58.084051825000074],
              [22.12354576900009, 58.07953522300005],
              [22.135508660000085, 58.07672760600008],
              [22.147715691000087, 58.07957591400003],
              [22.153168165000068, 58.08624909100007],
              [22.159027540000068, 58.107123114000046],
              [22.16504967500009, 58.116888739000046],
              [22.202972852000073, 58.14789459800005],
              [22.180349155000044, 58.16083405200004],
              [22.141856316000087, 58.16950104400007],
              [22.072276238000086, 58.175848700000074],
              [22.052989129000082, 58.18659088700008],
              [22.016856316000087, 58.23387278900003],
              [21.99382571700005, 58.24469635600008],
              [21.928884311000047, 58.24510325700004],
              [21.896494988000086, 58.25071849200003],
              [21.867849155000044, 58.26459381700005],
              [21.85132897200009, 58.28188711100006],
              [21.843760613000086, 58.29360586100006],
              [21.843272332000083, 58.30215078300006],
              [21.855642123000052, 58.30687083500004],
              [21.908213738000086, 58.29873281500005],
              [21.896657748000052, 58.31391022300005],
              [21.879567905000044, 58.32953522300005],
              [21.873301629000082, 58.34162018400008],
              [21.894541863000086, 58.34650299700007],
              [21.912364129000082, 58.33974844000005],
              [21.928396030000044, 58.32680898600006],
              [21.944590691000087, 58.31875234600005],
              [21.96338951900009, 58.326605536000045],
              [21.954925977000073, 58.34406159100007],
              [21.968028191000087, 58.35455963700008],
              [21.990489129000082, 58.357855536000045],
              [22.011241082000083, 58.353949286000045],
              [22.002207879000082, 58.36542389500005],
              [21.990082227000073, 58.38694896000004],
              [21.945974155000044, 58.43227773600006],
              [21.924489780000044, 58.446966864000046],
              [21.901133660000085, 58.468410549000055],
              [21.88770592500009, 58.47748444200005],
              [21.859385613000086, 58.491888739000046],
              [21.832367384000065, 58.510972398000035],
              [21.885020379000082, 58.49819570500006],
              [21.90137780000009, 58.49799225500004],
              [21.916270379000082, 58.501166083000044],
              [21.91846764400009, 58.50470612200007],
              [21.91895592500009, 58.50995514500005],
              [21.928477410000085, 58.51837799700007],
              [21.966644727000073, 58.517564195000034],
              [21.995616082000083, 58.51251862200007],
              [22.020762566000087, 58.499253648000035],
              [22.06421959700009, 58.456691799000055],
              [22.069834832000083, 58.446478583000044],
              [22.07203209700009, 58.432806708000044],
              [22.07357832100007, 58.42690664300005],
              [22.07781009200005, 58.42377350500004],
              [22.08334394600007, 58.42251211100006],
              [22.089366082000083, 58.42218659100007],
              [22.098480665000068, 58.42609284100007],
              [22.09864342500009, 58.434759833000044],
              [22.09310957100007, 58.44953034100007],
              [22.098806186000047, 58.475775458000044],
              [22.103688998000052, 58.487209377000056],
              [22.113617384000065, 58.49799225500004],
              [22.126800977000073, 58.50462474200003],
              [22.158946160000085, 58.51361725500004],
              [22.171885613000086, 58.521551825000074],
              [22.18327884200005, 58.53546784100007],
              [22.187754754000082, 58.54287344000005],
              [22.194590691000087, 58.54584381700005],
              [22.212901238000086, 58.54637278900003],
              [22.215586785000085, 58.544175523000035],
              [22.219004754000082, 58.53900788000004],
              [22.222178582000083, 58.53302643400008],
              [22.223480665000068, 58.52838776200008],
              [22.224864129000082, 58.51642487200007],
              [22.228851759000065, 58.51056549700007],
              [22.243337436000047, 58.50482819200005],
              [22.27320397200009, 58.502020575000074],
              [22.28288821700005, 58.52204010600008],
              [22.283946160000085, 58.54954661700003],
              [22.288340691000087, 58.56932200700004],
              [22.32195071700005, 58.58478424700007],
              [22.463063998000052, 58.59292226800005],
              [22.550303582000083, 58.62958405200004],
              [22.583181186000047, 58.63450755400004],
              [22.594086134000065, 58.62913646000004],
              [22.61264082100007, 58.60569896000004],
              [22.623789910000085, 58.60032786700003],
              [22.630137566000087, 58.59821198100008],
              [22.640798373000052, 58.58885325700004],
              [22.64812259200005, 58.58673737200007],
              [22.658213738000086, 58.58885325700004],
              [22.675791863000086, 58.59829336100006],
              [22.68213951900009, 58.60032786700003],
              [22.702647332000083, 58.59711334800005],
              [22.71924889400009, 58.59121328300006],
              [22.736338738000086, 58.58808014500005],
              [22.757985873000052, 58.59292226800005],
              [22.79070071700005, 58.61481354400007],
              [22.811371290000068, 58.62295156500005],
              [22.846364780000044, 58.61343008000006],
              [22.899668816000087, 58.62026601800005],
              [22.922048373000052, 58.61741771000004],
              [22.944021030000044, 58.61017487200007],
              [22.989756707000083, 58.60175202000005],
              [23.03646894600007, 58.58417389500005],
              [23.091075066000087, 58.57094961100006],
              [23.111338738000086, 58.55573151200008],
              [23.125824415000068, 58.53510163000004],
              [23.133555535000085, 58.528998114000046],
              [23.148285352000073, 58.521551825000074],
              [23.188649936000047, 58.51040273600006],
              [23.230642123000052, 58.50482819200005],
            ],
          ],
          [
            [
              [23.381602410000085, 58.57990143400008],
              [23.397146030000044, 58.563666083000044],
              [23.400238477000073, 58.55540599200003],
              [23.37989342500009, 58.54755280200004],
              [23.37159264400009, 58.538763739000046],
              [23.362152540000068, 58.532456773000035],
              [23.346934441000087, 58.53546784100007],
              [23.330902540000068, 58.54148997600004],
              [23.313731316000087, 58.54466380400004],
              [23.278575066000087, 58.54637278900003],
              [23.26465905000009, 58.543850002000056],
              [23.23487389400009, 58.53465403900003],
              [23.223806186000047, 58.53546784100007],
              [23.134613477000073, 58.57990143400008],
              [23.083262566000087, 58.59052155200004],
              [23.059336785000085, 58.60346100500004],
              [23.062836134000065, 58.62457916900007],
              [23.075450066000087, 58.62982819200005],
              [23.106130405000044, 58.624212958000044],
              [23.120941602000073, 58.62832265800006],
              [23.12354576900009, 58.633693752000056],
              [23.130381707000083, 58.65448639500005],
              [23.134613477000073, 58.661810614000046],
              [23.154633009000065, 58.67593008000006],
              [23.175791863000086, 58.68109772300005],
              [23.19776451900009, 58.68060944200005],
              [23.288340691000087, 58.66648997600004],
              [23.330251498000052, 58.65306224200003],
              [23.343760613000086, 58.64472077000005],
              [23.349131707000083, 58.63507721600007],
              [23.34815514400009, 58.62518952000005],
              [23.345957879000082, 58.615668036000045],
              [23.347504102000073, 58.60716380400004],
              [23.355642123000052, 58.59833405200004],
              [23.37403405000009, 58.586371161000045],
              [23.381602410000085, 58.57990143400008],
            ],
          ],
          [
            [
              [23.364024285000085, 59.028957424000055],
              [23.38965905000009, 59.007513739000046],
              [23.393728061000047, 58.99624258000006],
              [23.384776238000086, 58.980536200000074],
              [23.374278191000087, 58.97553131700005],
              [23.36231530000009, 58.97748444200005],
              [23.350433790000068, 58.98187897300005],
              [23.340098504000082, 58.98395416900007],
              [23.32943769600007, 58.98183828300006],
              [23.299082879000082, 58.97089264500005],
              [23.278575066000087, 58.970689195000034],
              [23.244395379000082, 58.981350002000056],
              [23.223399285000085, 58.98395416900007],
              [23.217539910000085, 58.98187897300005],
              [23.215098504000082, 58.97736237200007],
              [23.210785352000073, 58.97296784100007],
              [23.174164259000065, 58.96832916900007],
              [23.163259311000047, 58.96893952000005],
              [23.148285352000073, 58.97402578300006],
              [23.119395379000082, 59.01609935100004],
              [23.114105665000068, 59.02179596600007],
              [23.11890709700009, 59.03351471600007],
              [23.13135826900009, 59.040716864000046],
              [23.14820397200009, 59.04441966400003],
              [23.170176629000082, 59.04588450700004],
              [23.20801842500009, 59.04409414300005],
              [23.278005405000044, 59.03237539300005],
              [23.32203209700009, 59.03900788000004],
              [23.34424889400009, 59.03929271000004],
              [23.364024285000085, 59.028957424000055],
            ],
          ],
          [
            [
              [22.291758660000085, 58.89520905200004],
              [22.226898634000065, 58.88646067900004],
              [22.19499759200005, 58.888006903000075],
              [22.062510613000086, 58.925848700000074],
              [22.04468834700009, 58.93618398600006],
              [22.055511915000068, 58.95270416900007],
              [22.09424889400009, 58.95604075700004],
              [22.168223504000082, 58.950384833000044],
              [22.463063998000052, 58.97089264500005],
              [22.443532748000052, 58.977728583000044],
              [22.442067905000044, 58.98468659100007],
              [22.454600457000083, 58.987209377000056],
              [22.476735873000052, 58.980536200000074],
              [22.488454623000052, 58.98114655200004],
              [22.487559441000087, 59.01642487200007],
              [22.504242384000065, 59.02558014500005],
              [22.526866082000083, 59.02635325700004],
              [22.544444207000083, 59.03009674700007],
              [22.559255405000044, 59.038397528000075],
              [22.572927280000044, 59.052801825000074],
              [22.576426629000082, 59.061712958000044],
              [22.576426629000082, 59.07013580900008],
              [22.578298373000052, 59.07843659100007],
              [22.587168816000087, 59.08698151200008],
              [22.597666863000086, 59.089504299000055],
              [22.640472852000073, 59.08706289300005],
              [22.64112389400009, 59.08698151200008],
              [22.666677280000044, 59.08490631700005],
              [22.696543816000087, 59.07916901200008],
              [22.714121941000087, 59.069566148000035],
              [22.691579623000052, 59.04116445500006],
              [22.701345248000052, 59.02496979400007],
              [22.72046959700009, 59.01162344000005],
              [22.736664259000065, 59.005072333000044],
              [22.837168816000087, 59.00861237200007],
              [22.93409264400009, 58.984035549000055],
              [22.949554884000065, 58.97089264500005],
              [22.952647332000083, 58.960598049000055],
              [22.947601759000065, 58.94513580900008],
              [22.949554884000065, 58.93618398600006],
              [22.958506707000083, 58.92670319200005],
              [22.97950280000009, 58.917629299000055],
              [22.987559441000087, 58.91193268400008],
              [22.993988477000073, 58.90582916900007],
              [23.008067254000082, 58.89740631700005],
              [23.015147332000083, 58.891791083000044],
              [23.01807701900009, 58.88719310100004],
              [23.019053582000083, 58.882025458000044],
              [23.01856530000009, 58.87067291900007],
              [23.021739129000082, 58.86408112200007],
              [23.028493686000047, 58.86212799700007],
              [23.035492384000065, 58.86200592700004],
              [23.039073113000086, 58.861029364000046],
              [23.040537957000083, 58.84076569200005],
              [23.033539259000065, 58.83030833500004],
              [23.019053582000083, 58.82908763200004],
              [22.977793816000087, 58.844183661000045],
              [22.96729576900009, 58.84650299700007],
              [22.95679772200009, 58.84739817900004],
              [22.949554884000065, 58.84393952000005],
              [22.94703209700009, 58.837551174000055],
              [22.942230665000068, 58.83421458500004],
              [22.929209832000083, 58.83999258000006],
              [22.91260826900009, 58.835598049000055],
              [22.89551842500009, 58.83551666900007],
              [22.879567905000044, 58.83270905200004],
              [22.867198113000086, 58.82005442900004],
              [22.87663821700005, 58.81989166900007],
              [22.883067254000082, 58.817287502000056],
              [22.886973504000082, 58.811835028000075],
              [22.888194207000083, 58.80304596600007],
              [22.886729363000086, 58.79047272300005],
              [22.882090691000087, 58.78803131700005],
              [22.874278191000087, 58.78790924700007],
              [22.863617384000065, 58.78221263200004],
              [22.84538821700005, 58.77651601800005],
              [22.816661004000082, 58.77594635600008],
              [22.79004967500009, 58.78099192900004],
              [22.77833092500009, 58.792181708000044],
              [22.789317254000082, 58.80263906500005],
              [22.811208530000044, 58.81085846600007],
              [22.826914910000085, 58.81915924700007],
              [22.81934655000009, 58.82965729400007],
              [22.802256707000083, 58.83038971600007],
              [22.777598504000082, 58.82436758000006],
              [22.753184441000087, 58.81513092700004],
              [22.736664259000065, 58.80646393400008],
              [22.715179884000065, 58.78204987200007],
              [22.68100019600007, 58.72406647300005],
              [22.654958530000044, 58.702785549000055],
              [22.611175977000073, 58.69049713700008],
              [22.55567467500009, 58.68699778900003],
              [22.50171959700009, 58.69476959800005],
              [22.463063998000052, 58.716457424000055],
              [22.472178582000083, 58.719916083000044],
              [22.48096764400009, 58.72479889500005],
              [22.497243686000047, 58.737534898000035],
              [22.48340905000009, 58.74819570500006],
              [22.465179884000065, 58.76658763200004],
              [22.449473504000082, 58.786810614000046],
              [22.442637566000087, 58.80304596600007],
              [22.442637566000087, 58.82721588700008],
              [22.439789259000065, 58.84137604400007],
              [22.429942254000082, 58.852443752000056],
              [22.382090691000087, 58.88226959800005],
              [22.354746941000087, 58.89207591400003],
              [22.324961785000085, 58.89663320500006],
              [22.291758660000085, 58.89520905200004],
            ],
          ],
          [
            [
              [24.515879754000082, 59.598089911000045],
              [24.53093509200005, 59.583970445000034],
              [24.550059441000087, 59.55776601800005],
              [24.542816602000073, 59.54779694200005],
              [24.516286655000044, 59.544256903000075],
              [24.489105665000068, 59.55963776200008],
              [24.48731530000009, 59.57851797100005],
              [24.50049889400009, 59.59625885600008],
              [24.515879754000082, 59.598089911000045],
            ],
          ],
          [
            [
              [23.260508660000085, 57.81354401200008],
              [23.270681186000047, 57.807806708000044],
              [23.27507571700005, 57.79873281500005],
              [23.270192905000044, 57.78563060100004],
              [23.250254754000082, 57.784369208000044],
              [23.22950280000009, 57.79169342700004],
              [23.21778405000009, 57.80093008000006],
              [23.218597852000073, 57.80951569200005],
              [23.220550977000073, 57.817694403000075],
              [23.22429446700005, 57.82371653900003],
              [23.23959394600007, 57.82257721600007],
              [23.260508660000085, 57.81354401200008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Latvia',
        iso3: 'LVA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [27.352934611000137, 57.52760081000012],
            [27.52816939300004, 57.52847930900005],
            [27.522795044000077, 57.49202158700005],
            [27.525637248000066, 57.46837961900003],
            [27.514836873000036, 57.447889913000054],
            [27.511322876000065, 57.430397441000096],
            [27.536282593000067, 57.41569549600011],
            [27.64082401500005, 57.38900461800007],
            [27.69440872000007, 57.356375287],
            [27.7079517010001, 57.34812856100005],
            [27.809134155000095, 57.313944601000074],
            [27.827737671000136, 57.304952902000124],
            [27.840295044000072, 57.29063852900005],
            [27.846134481000036, 57.267306621],
            [27.84117354300008, 57.21121185300005],
            [27.833938842000123, 57.18049021500009],
            [27.824327027000038, 57.15907033300009],
            [27.7940446370001, 57.14338653600002],
            [27.7009753830001, 57.11878855500005],
            [27.6822168380001, 57.10369903600004],
            [27.696066121000058, 57.08545725600008],
            [27.722059367000043, 57.07799001100007],
            [27.745468791000093, 57.06799062100005],
            [27.75073978600011, 57.04235911100007],
            [27.74577884900009, 57.03145538300002],
            [27.729552450000057, 57.00985463500005],
            [27.72335127800008, 56.99879587800005],
            [27.72076745600009, 56.988667298000095],
            [27.718545369000083, 56.968720195000074],
            [27.715134724000052, 56.957403056],
            [27.648730510000092, 56.87926829100006],
            [27.62836999500007, 56.84415415500003],
            [27.644379266000072, 56.84177167300008],
            [27.6611845300001, 56.839270732],
            [27.744073527000097, 56.864798890000046],
            [27.7863965250001, 56.87125844300009],
            [27.830838257000096, 56.86428212500009],
            [27.85223230000011, 56.85430857300007],
            [27.891506388000067, 56.8297105920001],
            [27.913520548000065, 56.82015045200011],
            [27.918894897000115, 56.805887757000036],
            [27.90008467600009, 56.78304677400011],
            [27.876106811000085, 56.75943064400009],
            [27.865461467000102, 56.74268748000004],
            [27.882618042000047, 56.72547922800008],
            [27.981009969000098, 56.687006124000035],
            [27.991345255000084, 56.66997874],
            [27.992172079000113, 56.624994406000084],
            [27.997443074000046, 56.60383290600002],
            [28.01098229900012, 56.58755483],
            [28.028655640000125, 56.576754456000074],
            [28.108650757000078, 56.55517954600002],
            [28.126117391000037, 56.54776397700009],
            [28.132215210000084, 56.53598175100008],
            [28.125238892000084, 56.527145081000086],
            [28.099245647000117, 56.51339915000004],
            [28.093251180000095, 56.50159108600003],
            [28.09645511900007, 56.49195343100003],
            [28.104516642000135, 56.48306508400002],
            [28.156503133000086, 56.44621978800011],
            [28.16425459800007, 56.43795155900004],
            [28.167871948000055, 56.427125346000096],
            [28.16425459800007, 56.392812195],
            [28.16714847800006, 56.36986785900005],
            [28.17443485500013, 56.34963653600006],
            [28.214794148000095, 56.28137196900009],
            [28.217274617000072, 56.27072662400012],
            [28.215310913000053, 56.25599884100002],
            [28.209419800000063, 56.24814402300008],
            [28.201358276000065, 56.24168446900002],
            [28.193141724000043, 56.23103912400005],
            [28.184408406000045, 56.20752634700004],
            [28.17862064600007, 56.18391021800004],
            [28.169112182000106, 56.161741028],
            [28.148906697000115, 56.142414043000045],
            [28.11097619600011, 56.15680592900007],
            [28.068239787000095, 56.147581686000066],
            [28.0511000380001, 56.14066599700003],
            [28.023798055000015, 56.12964996400008],
            [27.981009969000098, 56.11802276700003],
            [27.939668823000147, 56.113061829000074],
            [27.927059774000043, 56.109366964000074],
            [27.91145349100009, 56.100246074],
            [27.901531617000103, 56.08934234600004],
            [27.892746622000118, 56.077095032],
            [27.880654337000124, 56.063865866000114],
            [27.812544800000126, 56.03451365100004],
            [27.781228882000107, 56.016375224000015],
            [27.776991414000065, 55.99239736],
            [27.74443526200011, 55.959737854000124],
            [27.645009806000104, 55.922840881000084],
            [27.617156209000115, 55.87855417900006],
            [27.610128214000014, 55.83096018500002],
            [27.601498251000066, 55.809617819000024],
            [27.59271325600008, 55.79424408000004],
            [27.564601278000055, 55.79222869900009],
            [27.43882084200007, 55.798739929000064],
            [27.405851277000124, 55.8043468230001],
            [27.374587036000037, 55.814837138000044],
            [27.349627319000035, 55.83121856700011],
            [27.329163452000074, 55.817575990000094],
            [27.282447957000073, 55.79186696400011],
            [27.263017619000095, 55.787216085000054],
            [27.235525757000033, 55.795846050000094],
            [27.173203980000096, 55.825740865000014],
            [27.15144820100008, 55.83245880200003],
            [27.11077884900004, 55.836282858000075],
            [26.981071004000086, 55.826877747000125],
            [26.979425815000127, 55.82629096300006],
            [26.957816610000094, 55.81858368000006],
            [26.900145711000107, 55.778715312000045],
            [26.84278487200004, 55.719339092],
            [26.822837769000103, 55.70610992500009],
            [26.74304935700013, 55.68285553],
            [26.72010502100008, 55.68187367800003],
            [26.66687829600005, 55.693965963000025],
            [26.64010990400007, 55.69556793300005],
            [26.615615275000096, 55.68797149700008],
            [26.594531291000067, 55.66699086600006],
            [26.537480509000062, 55.66952301000008],
            [26.481049846000133, 55.67830800500006],
            [26.342350301000067, 55.71634185800009],
            [26.279718466000134, 55.743239441000085],
            [26.226905152000086, 55.796931254000086],
            [26.20375411000009, 55.827446187000064],
            [26.178639364000077, 55.84958953900009],
            [26.07942061300011, 55.89813954700007],
            [26.017615600000113, 55.93736195900003],
            [25.961251118000064, 55.95845883400007],
            [25.871267944000067, 55.992138977000124],
            [25.795496034000053, 56.04013034000006],
            [25.766261434000114, 56.058646546],
            [25.7087972410001, 56.081048279000086],
            [25.69660160300009, 56.087895406000044],
            [25.687816610000112, 56.09833404600006],
            [25.66921309400007, 56.13202708000004],
            [25.66187504100006, 56.14081207300002],
            [25.64967940300005, 56.143809307000126],
            [25.590044800000044, 56.14112213100002],
            [25.57288822400008, 56.14303415900012],
            [25.522762085000068, 56.1565733850001],
            [25.45480757700011, 56.149648743000014],
            [25.349085703000128, 56.15987632300009],
            [25.10919559700011, 56.183083395],
            [25.07312544700011, 56.197811178],
            [25.04397994000007, 56.227990214],
            [25.02620324700004, 56.26018463200005],
            [25.016488077000105, 56.26989980100008],
            [24.983208456000057, 56.290492859],
            [24.97318322800004, 56.30075063100007],
            [24.96212447100004, 56.3192766320001],
            [24.936286255000113, 56.37991892500007],
            [24.910137980000115, 56.42195770300002],
            [24.89225793400007, 56.438726706000054],
            [24.87096724500006, 56.44260243700002],
            [24.857117960000096, 56.43536773700005],
            [24.853397257000097, 56.42472239300007],
            [24.852157023000075, 56.41366363500005],
            [24.845852498000056, 56.40493031900009],
            [24.837687622000118, 56.40394846600002],
            [24.815570109000106, 56.40880605100004],
            [24.80554488100009, 56.40854766900007],
            [24.71503953100006, 56.38625298800004],
            [24.678627563000106, 56.37728342700008],
            [24.63914677000008, 56.35997182200008],
            [24.5579114170001, 56.29858022100008],
            [24.53899784300006, 56.287624817],
            [24.48132694500009, 56.26884043500009],
            [24.44722049900014, 56.26052052800004],
            [24.4143542890001, 56.265507304],
            [24.35079227700004, 56.291552226000064],
            [24.31854618400007, 56.29858022100008],
            [24.28764367700009, 56.29553131100006],
            [24.16682417800004, 56.26031382300009],
            [24.14042161800006, 56.25760022600009],
            [24.138918905000082, 56.25744578000011],
            [24.108636516000047, 56.2607013960001],
            [24.075150187000133, 56.27119171200003],
            [23.981305786000036, 56.31240366600004],
            [23.871106925000106, 56.3320721300001],
            [23.85810917200007, 56.334391989000025],
            [23.82503625500007, 56.33490875300005],
            [23.756099894000045, 56.32596873000004],
            [23.72499068200011, 56.328810934],
            [23.72364709400003, 56.332118226],
            [23.72478397600014, 56.33839691200011],
            [23.723543742000118, 56.34581248000002],
            [23.715068807000108, 56.35273712200011],
            [23.706697225000113, 56.35444244400007],
            [23.679412069000108, 56.35185862200005],
            [23.609855591000013, 56.353822327],
            [23.577712850000097, 56.34860300700008],
            [23.517561482000133, 56.32865590400006],
            [23.48159468600008, 56.33010284500004],
            [23.37803970300007, 56.354629849000034],
            [23.31064904800013, 56.37059132900005],
            [23.288428182000075, 56.37304596000011],
            [23.172569620000104, 56.35795644100001],
            [23.15417281100011, 56.351393534000024],
            [23.162854451000072, 56.3410065720001],
            [23.11272831200006, 56.31087921200002],
            [23.06229211400006, 56.3041612760001],
            [23.01671350100014, 56.32384999600005],
            [22.98136682200007, 56.37317515100004],
            [22.95697554500012, 56.40198476200008],
            [22.924522746, 56.41211334300003],
            [22.888969360000146, 56.40844431600003],
            [22.859602846000143, 56.39706996200003],
            [22.822926880000097, 56.38286448200007],
            [22.681436808000058, 56.35030833000003],
            [22.666347290000147, 56.34909393400001],
            [22.649087361000085, 56.35309885700009],
            [22.604748982000018, 56.37909210200006],
            [22.57822170300011, 56.3870029160001],
            [22.575810180000076, 56.3877220670001],
            [22.511731404000045, 56.39596445800005],
            [22.214901977000096, 56.39038340300003],
            [22.195264933000146, 56.39485341400005],
            [22.158161255000095, 56.410252991000036],
            [22.139144328000015, 56.41570485400011],
            [22.094082479000065, 56.417410177000065],
            [21.98317307100004, 56.38835347900003],
            [21.965321874000068, 56.383676718000046],
            [21.684495076000076, 56.31010406600002],
            [21.59602502500013, 56.307881979000015],
            [21.558921346000147, 56.29728831000004],
            [21.41929162600013, 56.237395325000065],
            [21.40368534300009, 56.23447560700008],
            [21.35831343600006, 56.23323537300003],
            [21.32761763500011, 56.22437286400002],
            [21.29041060300011, 56.206932068000086],
            [21.25485721800004, 56.185202128000086],
            [21.229639119000097, 56.163187968],
            [21.212585897000054, 56.13099355100006],
            [21.205351196000095, 56.10342417400007],
            [21.190365031000113, 56.084458924],
            [21.150160767000102, 56.0781802370001],
            [21.091352986000118, 56.077896017000015],
            [21.053396030000044, 56.07261790600006],
            [21.053396030000044, 56.07294342700004],
            [21.052582227000073, 56.07754140800006],
            [21.04273522200009, 56.114569403000075],
            [21.028819207000083, 56.14740631700005],
            [20.98406009200005, 56.21043528900003],
            [20.973399285000085, 56.23200104400007],
            [20.969086134000065, 56.25348541900007],
            [20.971039259000065, 56.25967031500005],
            [20.98023522200009, 56.279282945000034],
            [20.982676629000082, 56.29075755400004],
            [20.982676629000082, 56.30145905200004],
            [20.98145592500009, 56.31049225500004],
            [20.970957879000082, 56.34983958500004],
            [20.968597852000073, 56.36981842700004],
            [20.970550977000073, 56.38898346600007],
            [20.97901451900009, 56.404364325000074],
            [20.992523634000065, 56.41791413000004],
            [20.998383009000065, 56.42568594000005],
            [21.003184441000087, 56.434800523000035],
            [21.005381707000083, 56.44586823100008],
            [21.00554446700005, 56.46552155200004],
            [21.010590040000068, 56.47573476800005],
            [21.00326582100007, 56.49258047100005],
            [21.00049889400009, 56.510646877000056],
            [21.00635826900009, 56.519964911000045],
            [21.024261915000068, 56.51048411700003],
            [21.030528191000087, 56.50014883000006],
            [21.035817905000044, 56.473944403000075],
            [21.04468834700009, 56.462103583000044],
            [21.030528191000087, 56.448431708000044],
            [21.037445509000065, 56.444647528000075],
            [21.04468834700009, 56.44220612200007],
            [21.04468834700009, 56.42796458500004],
            [21.04468834700009, 56.421128648000035],
            [21.030528191000087, 56.40810781500005],
            [21.053396030000044, 56.389960028000075],
            [21.061778191000087, 56.38703034100007],
            [21.070160352000073, 56.38934967700004],
            [21.07715905000009, 56.39520905200004],
            [21.07976321700005, 56.40306224200003],
            [21.068614129000082, 56.42405833500004],
            [21.066661004000082, 56.441839911000045],
            [21.06812584700009, 56.45880768400008],
            [21.072113477000073, 56.46954987200007],
            [21.067637566000087, 56.47638580900008],
            [21.063243035000085, 56.49396393400008],
            [21.05836022200009, 56.50364817900004],
            [21.052907748000052, 56.511053778000075],
            [21.048106316000087, 56.515611070000034],
            [21.030528191000087, 56.52415599200003],
            [21.019541863000086, 56.52708567900004],
            [21.010508660000085, 56.527777411000045],
            [21.003103061000047, 56.53001536700003],
            [20.996348504000082, 56.53782786700003],
            [20.992198113000086, 56.548895575000074],
            [20.99512780000009, 56.55337148600006],
            [21.000336134000065, 56.55768463700008],
            [21.010508660000085, 56.59870026200008],
            [21.046153191000087, 56.65619538000004],
            [21.05836022200009, 56.688666083000044],
            [21.065196160000085, 56.774318752000056],
            [21.061208530000044, 56.794134833000044],
            [21.054209832000083, 56.81195709800005],
            [21.052744988000086, 56.82892487200007],
            [21.065196160000085, 56.84634023600006],
            [21.147227410000085, 56.87641022300005],
            [21.15674889400009, 56.88556549700007],
            [21.222911004000082, 56.90770091400003],
            [21.240977410000085, 56.91828034100007],
            [21.277598504000082, 56.94912344000005],
            [21.287771030000044, 56.955511786000045],
            [21.30014082100007, 56.95954010600008],
            [21.32821699300007, 56.97361888200004],
            [21.360118035000085, 56.98969147300005],
            [21.38249759200005, 57.00893789300005],
            [21.401621941000087, 57.03750234600005],
            [21.413584832000083, 57.07318756700005],
            [21.414805535000085, 57.11383698100008],
            [21.41187584700009, 57.12445709800005],
            [21.401052280000044, 57.15131256700005],
            [21.403168165000068, 57.16205475500004],
            [21.41260826900009, 57.176214911000045],
            [21.414805535000085, 57.184881903000075],
            [21.41260826900009, 57.250067450000074],
            [21.414805535000085, 57.27090078300006],
            [21.421397332000083, 57.288723049000055],
            [21.433604363000086, 57.30646393400008],
            [21.449473504000082, 57.320013739000046],
            [21.46656334700009, 57.325506903000075],
            [21.48023522200009, 57.333644924000055],
            [21.517751498000052, 57.387600002000056],
            [21.589121941000087, 57.438788153000075],
            [21.699229363000086, 57.55532461100006],
            [21.729665561000047, 57.57379791900007],
            [21.771657748000052, 57.58612702000005],
            [21.955902540000068, 57.592962958000044],
            [21.999278191000087, 57.60032786700003],
            [22.194509311000047, 57.65761953300006],
            [22.48373457100007, 57.74249909100007],
            [22.526133660000085, 57.749660549000055],
            [22.549082879000082, 57.75063711100006],
            [22.56031334700009, 57.75275299700007],
            [22.572601759000065, 57.75682200700004],
            [22.585785352000073, 57.75971100500004],
            [22.600271030000044, 57.75804271000004],
            [22.61036217500009, 57.75462474200003],
            [22.610118035000085, 57.75348541900007],
            [22.604991082000083, 57.75104401200008],
            [22.600271030000044, 57.743841864000046],
            [22.59083092500009, 57.70612213700008],
            [22.587168816000087, 57.66498444200005],
            [22.590993686000047, 57.64476146000004],
            [22.600759311000047, 57.630113023000035],
            [22.656097852000073, 57.58576080900008],
            [22.878916863000086, 57.48126862200007],
            [22.950368686000047, 57.432806708000044],
            [23.031423373000052, 57.39447663000004],
            [23.08334394600007, 57.378241278000075],
            [23.117523634000065, 57.373928127000056],
            [23.13021894600007, 57.370794989000046],
            [23.133148634000065, 57.362982489000046],
            [23.133555535000085, 57.35309479400007],
            [23.13803144600007, 57.34316640800006],
            [23.160166863000086, 57.31858958500004],
            [23.16456139400009, 57.313666083000044],
            [23.174571160000085, 57.29734935100004],
            [23.182383660000085, 57.27765534100007],
            [23.190196160000085, 57.24249909100007],
            [23.198741082000083, 57.22418854400007],
            [23.213552280000044, 57.21625397300005],
            [23.22242272200009, 57.207017320000034],
            [23.25049889400009, 57.114447333000044],
            [23.260915561000047, 57.098944403000075],
            [23.274912957000083, 57.09271881700005],
            [23.29265384200005, 57.08893463700008],
            [23.340098504000082, 57.058579820000034],
            [23.42286217500009, 57.040228583000044],
            [23.508555535000085, 57.031236070000034],
            [23.52084394600007, 57.02558014500005],
            [23.56967207100007, 56.98627350500004],
            [23.57862389400009, 56.982082424000055],
            [23.585134311000047, 56.97907135600008],
            [23.632009311000047, 56.97093333500004],
            [23.695160352000073, 56.96727122600004],
            [23.866058790000068, 56.99017975500004],
            [23.926931186000047, 57.00633372600004],
            [23.95289147200009, 57.01325104400007],
            [23.99122155000009, 57.031236070000034],
            [24.009287957000083, 57.04559967700004],
            [24.02198326900009, 57.059027411000045],
            [24.03565514400009, 57.06899648600006],
            [24.074554884000065, 57.07493724200003],
            [24.11304772200009, 57.088731187000064],
            [24.210785352000073, 57.12372467700004],
            [24.21924889400009, 57.138006903000075],
            [24.238617384000065, 57.14956289300005],
            [24.261241082000083, 57.157456773000035],
            [24.278575066000087, 57.161037502000056],
            [24.278819207000083, 57.17177969000005],
            [24.28874759200005, 57.178900458000044],
            [24.312673373000052, 57.18829987200007],
            [24.379161004000082, 57.23021067900004],
            [24.400645379000082, 57.25812409100007],
            [24.408864780000044, 57.298163153000075],
            [24.405528191000087, 57.34446849200003],
            [24.381602410000085, 57.46942780200004],
            [24.37989342500009, 57.50653717700004],
            [24.375173373000052, 57.528550523000035],
            [24.364512566000087, 57.538397528000075],
            [24.358571811000047, 57.55036041900007],
            [24.36296634200005, 57.576605536000045],
            [24.37476647200009, 57.61347077000005],
            [24.36304772200009, 57.67226797100005],
            [24.357676629000082, 57.68549225500004],
            [24.313731316000087, 57.725043036000045],
            [24.299571160000085, 57.743841864000046],
            [24.299571160000085, 57.76190827000005],
            [24.28882897200009, 57.80890534100007],
            [24.285980665000068, 57.83258698100008],
            [24.28882897200009, 57.84528229400007],
            [24.296153191000087, 57.85736725500004],
            [24.306158734238295, 57.86818625584296],
            [24.349655395000127, 57.85864003600007],
            [24.378180786000087, 57.85944102000009],
            [24.40153853300012, 57.86646901400009],
            [24.41270064300005, 57.876571757000036],
            [24.429133748000112, 57.9003429160001],
            [24.441639445000106, 57.90809438100008],
            [24.48132694500009, 57.91930816700004],
            [24.533830200000068, 57.945068868000035],
            [24.553880656000103, 57.947420146000084],
            [24.624057251000096, 57.943957825000055],
            [24.68482873500008, 57.94757517500004],
            [24.70043501800012, 57.95418975800003],
            [24.718831828000134, 57.981836650000034],
            [24.73350793500012, 57.99219777400005],
            [24.764720500000095, 57.987908631],
            [24.79076542100009, 57.97899444600007],
            [24.816810344000146, 57.97666900700004],
            [24.827417479000076, 57.98187693600009],
            [24.84833296700012, 57.99214609800005],
            [24.87251753700008, 58.000440165],
            [24.949308716000047, 58.00643463100003],
            [24.9748368730001, 58.01583974200007],
            [25.034856819000083, 58.04857408500003],
            [25.048837524000106, 58.05619903600005],
            [25.070644978000132, 58.06361460400005],
            [25.094209432000127, 58.06730946900005],
            [25.141028280000057, 58.06800710100005],
            [25.166969848000093, 58.05873118100003],
            [25.180715780000128, 58.03816396100005],
            [25.189914184000116, 58.013514303000036],
            [25.20210982200004, 57.991965230000076],
            [25.21678593000013, 57.985376486000106],
            [25.232495565000107, 57.985376486000106],
            [25.264534953000094, 57.9941873180001],
            [25.2843787030001, 58.00813995400007],
            [25.277557414000057, 58.024107972000124],
            [25.24954878800014, 58.05118642200007],
            [25.250685669000035, 58.068498027],
            [25.26350142400011, 58.07513844900008],
            [25.281691528000067, 58.07340728800001],
            [25.29957157400011, 58.065604147],
            [25.30639286300007, 58.05873118100003],
            [25.31827844300011, 58.040618592],
            [25.32458296700011, 58.034753317000096],
            [25.333678019000104, 58.03180776],
            [25.33987919100008, 58.03258290600003],
            [25.346390421000137, 58.034443258000024],
            [25.356519002000084, 58.034753317000096],
            [25.396619914000098, 58.02317779600007],
            [25.457184692000055, 57.98405873600005],
            [25.49661381000007, 57.97059702600008],
            [25.531960489000056, 57.96643707300005],
            [25.541675659000106, 57.96281972300007],
            [25.550253947000044, 57.955326640000024],
            [25.551815984000143, 57.949859510000024],
            [25.55211429800005, 57.94881541000005],
            [25.552941122000078, 57.94217498800005],
            [25.55831547000011, 57.93424265600002],
            [25.579399455000072, 57.919463196],
            [25.601516968000055, 57.91220265800011],
            [25.62508142100006, 57.91029063000009],
            [25.65009281400006, 57.911427511000014],
            [25.703799772000053, 57.921326524000065],
            [25.714998413000103, 57.92339060500005],
            [25.73029463700007, 57.923132223],
            [25.745384155000067, 57.90917958600009],
            [25.75468591300009, 57.88889658600009],
            [25.76750166800008, 57.868923646000056],
            [25.792616415000083, 57.85597869900003],
            [26.00273278800009, 57.84597931000012],
            [26.014515015000086, 57.84282704700006],
            [26.021956421000112, 57.83794362400003],
            [26.0252637130001, 57.82840932200004],
            [26.021749715000055, 57.82241485600012],
            [26.016065308000094, 57.816472067000106],
            [26.013068074000074, 57.80729950000001],
            [26.016065308000094, 57.78668060300002],
            [26.024746948000143, 57.77435577400006],
            [26.135231161000092, 57.724772238000085],
            [26.168510783000016, 57.70404998800005],
            [26.26318200700004, 57.62082509400004],
            [26.297185099000075, 57.599146830000066],
            [26.33862959800004, 57.58315297500012],
            [26.351325150000037, 57.5802030010001],
            [26.430678413000066, 57.561764252],
            [26.430923706000016, 57.56170725500009],
            [26.44756351700005, 57.552922262],
            [26.481049846000133, 57.5271357220001],
            [26.499550008000057, 57.51581858300001],
            [26.515052938000082, 57.517265524000024],
            [26.528695516000084, 57.523880107000096],
            [26.542234741000073, 57.52816925100008],
            [26.551743205000065, 57.526825664000015],
            [26.570243367000074, 57.519590963000056],
            [26.57985518300009, 57.517833965000065],
            [26.59008711800007, 57.52036610900005],
            [26.594841349000063, 57.52648976700003],
            [26.59835534700011, 57.53385365900003],
            [26.604763224000067, 57.54031321300006],
            [26.634322144000095, 57.55442087900009],
            [26.666981649000064, 57.564859518000034],
            [26.70046797600014, 57.57075063100005],
            [26.778085978000064, 57.56847686800002],
            [26.795759318000137, 57.571319071000104],
            [26.816326538000055, 57.58118927000008],
            [26.82831547100008, 57.595038555000045],
            [26.83854740400008, 57.60986969000008],
            [26.85415368700012, 57.622556254000116],
            [26.87265384900013, 57.627181295000085],
            [26.884952840000096, 57.62209116600009],
            [26.89611495000011, 57.61498565700005],
            [26.911617880000023, 57.61343536400004],
            [26.929187866000092, 57.61555409800012],
            [26.94655114800011, 57.61534739200006],
            [26.981071004000086, 57.60899119100013],
            [27.00463545800011, 57.598914286000095],
            [27.041325724000075, 57.56845103000002],
            [27.061531209000066, 57.555661113000056],
            [27.085354045000116, 57.54943410300005],
            [27.165659220000066, 57.546695252000106],
            [27.319965047000068, 57.51612864200008],
            [27.352934611000137, 57.52760081000012],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Norway',
        iso3: '-99',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [20.62316451, 69.03635569300012],
              [20.36271529150011, 69.02925018350014],
              [20.102266073000095, 69.02214467400005],
              [20.34111454300009, 68.91005849300011],
              [20.34876265400007, 68.893108623],
              [20.35651412000007, 68.80458689400005],
              [20.35217329900007, 68.78567332000001],
              [20.338840779000066, 68.76546783500002],
              [20.236624796000086, 68.65906606100002],
              [20.151772095000126, 68.60682118700002],
              [19.96222294100005, 68.54119211900009],
              [20.245926554000107, 68.47737172400004],
              [20.010282023000087, 68.36389027900002],
              [19.971214640000085, 68.35128123000008],
              [19.931010376000046, 68.35019602500007],
              [19.48173547300007, 68.42404164700004],
              [19.038144979000066, 68.50563873300003],
              [18.70028446400005, 68.495613505],
              [18.644577270000127, 68.50124623600003],
              [18.481796509000077, 68.56196604400002],
              [18.436217895000112, 68.57385162400006],
              [18.189291148000052, 68.53842468300006],
              [18.171841268000065, 68.53592112300005],
              [18.16150598200008, 68.53018503800008],
              [18.15623498500014, 68.51860951800005],
              [18.136804647000048, 68.42631541000007],
              [18.13566776500005, 68.39572296200005],
              [18.188584432000113, 68.19873240200003],
              [18.166673625000072, 68.15847646200008],
              [17.981878703000064, 68.01615956700003],
              [17.950769491000102, 67.99109649700002],
              [17.921003865000017, 67.97285471700006],
              [17.895372355000063, 67.96965077800009],
              [17.608413126500125, 68.03747609500012],
              [17.3214538980001, 68.10530141200006],
              [17.29995650200007, 68.09791168200003],
              [17.220064738000076, 68.04008575500002],
              [16.8079968670001, 67.91063629200006],
              [16.782882121000085, 67.89699371400006],
              [16.76190148900008, 67.87714996400005],
              [16.608732544000077, 67.64729319300001],
              [16.58723514800002, 67.62589915000008],
              [16.482952107000102, 67.55784128900008],
              [16.428588501000036, 67.53401845400002],
              [16.366990193000078, 67.52166778600007],
              [16.199558553000088, 67.50828359000003],
              [16.180748332000093, 67.4963980100001],
              [16.12710819500009, 67.4227590950001],
              [16.43789025900014, 67.20031789200006],
              [16.443781372000046, 67.18261871400004],
              [16.415566040000073, 67.05270416300006],
              [16.399649698000047, 67.03596099900001],
              [16.3696773690001, 67.02428212500003],
              [16.310559529000045, 67.00991607700003],
              [16.125661255000097, 66.9343651330001],
              [16.03884484800011, 66.88754628599999],
              [15.669461711000054, 66.59942433700009],
              [15.426272420000089, 66.49121388800008],
              [15.429889770000074, 66.46356699700009],
              [15.476076322000097, 66.3549371430001],
              [15.482082967000053, 66.34080963200002],
              [15.48993778500008, 66.30848602300004],
              [15.491798136000085, 66.28799631800008],
              [15.481876261000082, 66.27487050400002],
              [15.053375285000072, 66.15327585900006],
              [14.796956828000106, 66.13936197950012],
              [14.54053837100011, 66.1254481000001],
              [14.644408, 65.84290720700004],
              [14.648852172000147, 65.80239288400013],
              [14.637069947000043, 65.78120554700008],
              [14.570200643000078, 65.71671335900005],
              [14.560692179000085, 65.7010554000001],
              [14.510359335000118, 65.46473907500008],
              [14.511392862000093, 65.41706756700005],
              [14.518317505000084, 65.36453847200006],
              [14.514286743000099, 65.31808136000005],
              [14.48214400200007, 65.28867747100004],
              [14.400495239000065, 65.25544952500003],
              [14.380238078000076, 65.2402824920001],
              [14.365975383000091, 65.21576202500005],
              [14.338483520000125, 65.12289947500001],
              [14.332849860000096, 65.11504586000008],
              [14.332073666000099, 65.11396380500007],
              [14.310681600000066, 65.08414215100008],
              [14.172602172000069, 64.99153798400003],
              [14.172395467000086, 64.99138295600007],
              [13.90757959000004, 64.78770029750008],
              [13.642763713000079, 64.5840176390001],
              [13.940058228000083, 64.49131012],
              [13.98232954900007, 64.48438547900012],
              [14.060877726000086, 64.4766340130001],
              [14.096947876000087, 64.46531687400004],
              [14.115551391000054, 64.441235657],
              [14.161440063000015, 64.20543609600013],
              [14.160509887000075, 64.18724599200009],
              [14.147797485000098, 64.16900421200002],
              [13.98232954900007, 64.01950429300011],
              [13.964242798000043, 64.009530742],
              [13.939438110000111, 64.009530742],
              [13.586772298000085, 64.05020009400006],
              [13.234106486000144, 64.0908694460001],
              [12.982442261000074, 64.05883005800008],
              [12.755272665000064, 63.991392314000066],
              [12.681892131000012, 63.95635569300005],
              [12.482524454000043, 63.809491273000035],
              [12.293182006000109, 63.656994121000096],
              [12.170295450000111, 63.59813466500002],
              [12.219491414000089, 63.49659047500002],
              [12.219801472000057, 63.474266256000064],
              [12.204918660000118, 63.45462921200003],
              [11.992425171000093, 63.2889028930001],
              [12.059826572000105, 63.20477215000001],
              [12.222695353000063, 63.001478577000015],
              [12.104356323000104, 62.923343811000066],
              [12.093297567000093, 62.90742747100005],
              [12.097018270000092, 62.88655019100007],
              [12.156239461000098, 62.73369130500005],
              [12.154069051000107, 62.710514425000056],
              [12.13866947400004, 62.682712505],
              [12.103116089000054, 62.634033305000074],
              [12.090093628000119, 62.60633473700004],
              [12.091230509000127, 62.58631012000011],
              [12.279521921000054, 62.34421403900005],
              [12.28636071800014, 62.33542104100003],
              [12.314265991000127, 62.28612172500003],
              [12.31514930500012, 62.271760746],
              [12.317469929000112, 62.23403188100009],
              [12.239593546000037, 61.97943501800002],
              [12.161717163000077, 61.72483815500003],
              [12.175566447000051, 61.7115314740001],
              [12.291321655000104, 61.651121724000106],
              [12.337830444000133, 61.63298329700008],
              [12.416481975000096, 61.582288717],
              [12.444800659000094, 61.57350372400002],
              [12.482524454000043, 61.56913706500002],
              [12.550944051000045, 61.566914978000014],
              [12.58339685000007, 61.56110138000004],
              [12.61378259200012, 61.54704539000004],
              [12.877125692000078, 61.37098378600008],
              [12.886944214000039, 61.36150116],
              [12.888184448000061, 61.349615581000066],
              [12.85469812000008, 61.255306092000055],
              [12.839815308000112, 61.22698740600005],
              [12.819661499000063, 61.20494740800008],
              [12.746694376000022, 61.15146230100005],
              [12.739149617000066, 61.142444763000086],
              [12.73294844600008, 61.12911224400007],
              [12.713518107000112, 61.061157735],
              [12.71082559800007, 61.05701155800007],
              [12.70380293800008, 61.046197409000044],
              [12.68251224700009, 61.04033213400005],
              [12.569650920000129, 61.05064158100005],
              [12.511773316000102, 61.04911712700003],
              [12.28098636900009, 61.01519154900002],
              [12.253287801000056, 61.001704],
              [12.256078329000019, 60.981317648000115],
              [12.294835653000064, 60.935325623000026],
              [12.313232463000134, 60.901865133000015],
              [12.335039917000074, 60.828898011],
              [12.350026082000056, 60.793344626000035],
              [12.377001180000065, 60.75409637500006],
              [12.482524454000043, 60.65733225600009],
              [12.594352254000029, 60.51493784600008],
              [12.608614950000117, 60.48648997000005],
              [12.612645711000113, 60.455380758],
              [12.6053076580001, 60.419155579000076],
              [12.593628784000117, 60.395022685000114],
              [12.577919148000149, 60.37590240500002],
              [12.5585921630001, 60.359882711000054],
              [12.504745321000087, 60.32562123600006],
              [12.491722860000039, 60.312288717000044],
              [12.487278686000138, 60.295907288000066],
              [12.495650268000105, 60.262007549000074],
              [12.521591838000063, 60.19761871300007],
              [12.52469242300009, 60.1617035930001],
              [12.510946492000073, 60.11798533200003],
              [12.483247925000057, 60.08124338800006],
              [12.446764364000046, 60.05111602800007],
              [12.290598185000107, 59.958718567000076],
              [12.143733764000103, 59.89841217000007],
              [12.102702677000138, 59.893967998000065],
              [11.942195678000132, 59.902029521000074],
              [11.890312540000139, 59.89277944000004],
              [11.874627299000053, 59.88493681900006],
              [11.849591512000075, 59.87241892500002],
              [11.842976929000088, 59.83841583300007],
              [11.85486250800011, 59.82430816700004],
              [11.883741546000095, 59.80538299800013],
              [11.889795776000085, 59.801415507000016],
              [11.902094767000051, 59.78513743100011],
              [11.903541707000045, 59.7699962360001],
              [11.89723718300013, 59.732014059000065],
              [11.89723718300013, 59.713978984000065],
              [11.891656128000108, 59.70576243200004],
              [11.852485392000062, 59.673361308000025],
              [11.828404175000117, 59.65971873000002],
              [11.693735392000121, 59.62230499300007],
              [11.674925171000012, 59.60711212200003],
              [11.670997762000042, 59.580550436000024],
              [11.677405640000103, 59.55905304000008],
              [11.783962443000036, 59.36061554000007],
              [11.806803426000045, 59.293591207000034],
              [11.81166101100007, 59.270905253000066],
              [11.81166101100007, 59.24966624000011],
              [11.811088078000097, 59.24871671700005],
              [11.802462605000073, 59.234421692000055],
              [11.784685913000146, 59.218143616000035],
              [11.775590861000069, 59.20253733300011],
              [11.748512411000121, 59.140060527000045],
              [11.745308472000147, 59.09215647400002],
              [11.734249715000118, 59.06554311100008],
              [11.708928263000047, 59.021618144000044],
              [11.700246623000083, 58.99913889600005],
              [11.693735392000121, 58.973507385000076],
              [11.66438317900014, 58.92007395500006],
              [11.611569865000092, 58.89315053300005],
              [11.547077678000079, 58.88472727500006],
              [11.482585490000048, 58.88689768500005],
              [11.45199304200014, 58.89604441400003],
              [11.453233276000077, 58.960484925000046],
              [11.43814375800008, 58.991129049000065],
              [11.437510613000086, 58.99172597900008],
              [11.437754754000082, 58.99823639500005],
              [11.403575066000087, 59.03856028900003],
              [11.399587436000047, 59.04767487200007],
              [11.393809441000087, 59.070013739000046],
              [11.389333530000044, 59.08075592700004],
              [11.37045332100007, 59.10065338700008],
              [11.344574415000068, 59.111395575000074],
              [11.31381269600007, 59.11517975500004],
              [11.21656334700009, 59.11041901200008],
              [11.182383660000085, 59.11603424700007],
              [11.170176629000082, 59.134751695000034],
              [11.174652540000068, 59.14093659100007],
              [11.183116082000083, 59.14288971600007],
              [11.20093834700009, 59.142238674000055],
              [11.20671634200005, 59.145697333000044],
              [11.201670769000089, 59.15253327000005],
              [11.193614129000082, 59.157538153000075],
              [11.190114780000044, 59.15521881700005],
              [11.183116082000083, 59.16006094000005],
              [11.178558790000068, 59.16498444200005],
              [11.176442905000044, 59.172308661000045],
              [11.177989129000082, 59.18073151200008],
              [11.180511915000068, 59.18427155200004],
              [11.18100019600007, 59.18805573100008],
              [11.176442905000044, 59.19684479400007],
              [11.166677280000044, 59.19212474200003],
              [11.135508660000085, 59.18317291900007],
              [11.15015709700009, 59.17519765800006],
              [11.153086785000085, 59.162543036000045],
              [11.147308790000068, 59.14996979400007],
              [11.135508660000085, 59.142238674000055],
              [11.11882571700005, 59.142279364000046],
              [11.10710696700005, 59.15070221600007],
              [11.087738477000073, 59.175767320000034],
              [11.09734134200005, 59.148504950000074],
              [11.099131707000083, 59.13418203300006],
              [11.091075066000087, 59.12799713700008],
              [11.032481316000087, 59.12799713700008],
              [11.039805535000085, 59.143744208000044],
              [11.02670332100007, 59.15184153900003],
              [11.007823113000086, 59.15912506700005],
              [10.998301629000082, 59.172308661000045],
              [10.989431186000047, 59.17568594000005],
              [10.948496941000087, 59.18333567900004],
              [10.936208530000044, 59.18317291900007],
              [10.944834832000083, 59.16486237200007],
              [10.944021030000044, 59.149318752000056],
              [10.934092644000089, 59.14036692900004],
              [10.916351759000065, 59.142238674000055],
              [10.90788821700005, 59.14984772300005],
              [10.900645379000082, 59.16400788000004],
              [10.897715691000087, 59.180894273000035],
              [10.90211022200009, 59.19684479400007],
              [10.882823113000086, 59.18768952000005],
              [10.872569207000083, 59.184475002000056],
              [10.861501498000052, 59.18317291900007],
              [10.850271030000044, 59.18036530200004],
              [10.848399285000085, 59.173814195000034],
              [10.847992384000065, 59.16657135600008],
              [10.84115644600007, 59.161444403000075],
              [10.822927280000044, 59.16396719000005],
              [10.802012566000087, 59.188788153000075],
              [10.779144727000073, 59.18939850500004],
              [10.784190300000091, 59.206284898000035],
              [10.766368035000085, 59.231756903000075],
              [10.772959832000083, 59.25210195500006],
              [10.761892123000052, 59.24494049700007],
              [10.74935957100007, 59.223944403000075],
              [10.738129102000073, 59.21670156500005],
              [10.733164910000085, 59.24091217700004],
              [10.743662957000083, 59.268011786000045],
              [10.761566602000073, 59.29352448100008],
              [10.779144727000073, 59.312933661000045],
              [10.76343834700009, 59.315334377000056],
              [10.752696160000085, 59.322699286000045],
              [10.744151238000086, 59.33047109600005],
              [10.734711134000065, 59.334051825000074],
              [10.724457227000073, 59.329779364000046],
              [10.708994988000086, 59.310980536000045],
              [10.700694207000083, 59.306708075000074],
              [10.674082879000082, 59.315741278000075],
              [10.66537519600007, 59.33641185100004],
              [10.65984134200005, 59.359361070000034],
              [10.642751498000052, 59.37494538000004],
              [10.656097852000073, 59.38971588700008],
              [10.659678582000083, 59.40021393400008],
              [10.653005405000044, 59.408189195000034],
              [10.635264519000089, 59.41596100500004],
              [10.595957879000082, 59.42373281500005],
              [10.591644727000073, 59.43065013200004],
              [10.601084832000083, 59.450100002000056],
              [10.627452019000089, 59.47882721600007],
              [10.644541863000086, 59.49315013200004],
              [10.656423373000052, 59.49787018400008],
              [10.662933790000068, 59.488714911000045],
              [10.661143425000091, 59.47329336100006],
              [10.648936394000089, 59.44383372600004],
              [10.662445509000065, 59.43789297100005],
              [10.67514082100007, 59.44086334800005],
              [10.685069207000083, 59.45026276200008],
              [10.690440300000091, 59.46312083500004],
              [10.690277540000068, 59.48065827000005],
              [10.683441602000073, 59.48932526200008],
              [10.67351321700005, 59.49526601800005],
              [10.663096550000091, 59.50470612200007],
              [10.651133660000085, 59.52643463700008],
              [10.645518425000091, 59.54946523600006],
              [10.646820509000065, 59.57257721600007],
              [10.656423373000052, 59.59467194200005],
              [10.639008009000065, 59.61579010600008],
              [10.625987175000091, 59.63727448100008],
              [10.617686394000089, 59.66307200700004],
              [10.61459394600007, 59.69717031500005],
              [10.597504102000073, 59.68455638200004],
              [10.575450066000087, 59.69961172100005],
              [10.56023196700005, 59.726223049000055],
              [10.563243035000085, 59.74835846600007],
              [10.577159050000091, 59.76642487200007],
              [10.601735873000052, 59.81391022300005],
              [10.61459394600007, 59.833685614000046],
              [10.655528191000087, 59.856675523000035],
              [10.680349155000044, 59.827337958000044],
              [10.698090040000068, 59.77716705900008],
              [10.717784050000091, 59.73810455900008],
              [10.72820071700005, 59.77635325700004],
              [10.747325066000087, 59.81435781500005],
              [10.758474155000044, 59.85016510600008],
              [10.745127800000091, 59.882066148000035],
              [10.752614780000044, 59.88890208500004],
              [10.74000084700009, 59.89516836100006],
              [10.711110873000052, 59.90070221600007],
              [10.688731316000087, 59.911769924000055],
              [10.680837436000047, 59.90497467700004],
              [10.674327019000089, 59.89443594000005],
              [10.666270379000082, 59.88890208500004],
              [10.621429884000065, 59.89630768400008],
              [10.615570509000065, 59.894598700000074],
              [10.60287519600007, 59.88532135600008],
              [10.594248894000089, 59.882066148000035],
              [10.553233269000089, 59.884100653000075],
              [10.529470248000052, 59.88231028900003],
              [10.508148634000065, 59.871527411000045],
              [10.475433790000068, 59.850043036000045],
              [10.473806186000047, 59.84137604400007],
              [10.498708530000044, 59.833685614000046],
              [10.488617384000065, 59.81631094000005],
              [10.486664259000065, 59.803168036000045],
              [10.484548373000052, 59.78864166900007],
              [10.48568769600007, 59.757879950000074],
              [10.491221550000091, 59.73126862200007],
              [10.502207879000082, 59.70872630400004],
              [10.51889082100007, 59.68903229400007],
              [10.539805535000085, 59.675034898000035],
              [10.563243035000085, 59.66982656500005],
              [10.582692905000044, 59.66205475500004],
              [10.599131707000083, 59.64398834800005],
              [10.610524936000047, 59.62335846600007],
              [10.61459394600007, 59.60773346600007],
              [10.59310957100007, 59.570379950000074],
              [10.54273522200009, 59.53554922100005],
              [10.48373457100007, 59.51447174700007],
              [10.436696811000047, 59.51837799700007],
              [10.42359459700009, 59.53384023600006],
              [10.422373894000089, 59.554022528000075],
              [10.429209832000083, 59.59784577000005],
              [10.42741946700005, 59.60736725500004],
              [10.415537957000083, 59.641913153000075],
              [10.41146894600007, 59.66229889500005],
              [10.408702019000089, 59.671210028000075],
              [10.403005405000044, 59.682847398000035],
              [10.397634311000047, 59.68805573100008],
              [10.374522332000083, 59.704291083000044],
              [10.371104363000086, 59.706732489000046],
              [10.360524936000047, 59.711004950000074],
              [10.353770379000082, 59.71067942900004],
              [10.352468295000051, 59.710638739000046],
              [10.34734134200005, 59.71039459800005],
              [10.332286004000082, 59.71149323100008],
              [10.29664147200009, 59.73200104400007],
              [10.266856316000087, 59.73973216400003],
              [10.238942905000044, 59.73875560100004],
              [10.22437584700009, 59.723822333000044],
              [10.23804772200009, 59.71898021000004],
              [10.257090691000087, 59.70107656500005],
              [10.26889082100007, 59.69717031500005],
              [10.284434441000087, 59.69570547100005],
              [10.297211134000065, 59.69179922100005],
              [10.360036655000044, 59.672756252000056],
              [10.379242384000065, 59.65835195500006],
              [10.390879754000082, 59.63816966400003],
              [10.394867384000065, 59.61115143400008],
              [10.39421634200005, 59.586371161000045],
              [10.390147332000083, 59.558294989000046],
              [10.381032748000052, 59.53534577000005],
              [10.364268425000091, 59.525824286000045],
              [10.332774285000085, 59.53261953300006],
              [10.269379102000073, 59.559027411000045],
              [10.237315300000091, 59.55996328300006],
              [10.24781334700009, 59.54315827000005],
              [10.267914259000065, 59.525051174000055],
              [10.291026238000086, 59.51056549700007],
              [10.31031334700009, 59.50470612200007],
              [10.331309441000087, 59.49506256700005],
              [10.369395379000082, 59.45526764500005],
              [10.458994988000086, 59.44086334800005],
              [10.477549675000091, 59.42963288000004],
              [10.480316602000073, 59.412095445000034],
              [10.472178582000083, 59.393866278000075],
              [10.446787957000083, 59.36473216400003],
              [10.444509311000047, 59.348944403000075],
              [10.461680535000085, 59.33576080900008],
              [10.498708530000044, 59.31976959800005],
              [10.514170769000089, 59.30292389500005],
              [10.504730665000068, 59.293402411000045],
              [10.487071160000085, 59.28412506700005],
              [10.477549675000091, 59.26821523600006],
              [10.469574415000068, 59.24778880400004],
              [10.451182488000086, 59.24896881700005],
              [10.416188998000052, 59.26508209800005],
              [10.371592644000089, 59.27374909100007],
              [10.360850457000083, 59.27130768400008],
              [10.35914147200009, 59.26508209800005],
              [10.36109459700009, 59.24518463700008],
              [10.360850457000083, 59.23786041900007],
              [10.364756707000083, 59.22597890800006],
              [10.361989780000044, 59.21954987200007],
              [10.334727410000085, 59.21478913000004],
              [10.330251498000052, 59.20966217700004],
              [10.328379754000082, 59.20221588700008],
              [10.317149285000085, 59.17959219000005],
              [10.313161655000044, 59.159369208000044],
              [10.311778191000087, 59.13971588700008],
              [10.313731316000087, 59.12799713700008],
              [10.289805535000085, 59.13458893400008],
              [10.286957227000073, 59.114894924000055],
              [10.295909050000091, 59.08470286700003],
              [10.306895379000082, 59.05971914300005],
              [10.29265384200005, 59.07013580900008],
              [10.286631707000083, 59.08429596600007],
              [10.281993035000085, 59.099676825000074],
              [10.272146030000044, 59.11432526200008],
              [10.268077019000089, 59.09467194200005],
              [10.269541863000086, 59.04779694200005],
              [10.262461785000085, 59.03856028900003],
              [10.260101759000065, 59.049994208000044],
              [10.231130405000044, 59.11432526200008],
              [10.22437584700009, 59.11432526200008],
              [10.222666863000086, 59.100897528000075],
              [10.212738477000073, 59.078111070000034],
              [10.211273634000065, 59.06655508000006],
              [10.21656334700009, 59.05890534100007],
              [10.22592207100007, 59.05023834800005],
              [10.23218834700009, 59.040350653000075],
              [10.227793816000087, 59.028957424000055],
              [10.207041863000086, 59.01642487200007],
              [10.174978061000047, 59.00531647300005],
              [10.140798373000052, 58.99994538000004],
              [10.114512566000087, 59.005072333000044],
              [10.125661655000044, 59.014553127000056],
              [10.16187584700009, 59.02753327000005],
              [10.16968834700009, 59.03546784100007],
              [10.16342207100007, 59.05231354400007],
              [10.148773634000065, 59.05158112200007],
              [10.117930535000085, 59.03856028900003],
              [10.103770379000082, 59.03538646000004],
              [10.076508009000065, 59.02130768400008],
              [10.059418165000068, 59.01813385600008],
              [10.053721550000091, 59.02285390800006],
              [10.033457879000082, 59.03107330900008],
              [10.016774936000047, 59.03367747600004],
              [10.033376498000052, 58.993475653000075],
              [10.014821811000047, 58.97313060100004],
              [9.983653191000087, 58.96088288000004],
              [9.957367384000065, 58.956691799000055],
              [9.846202019000089, 58.95563385600008],
              [9.81218509200005, 58.96344635600008],
              [9.838877800000091, 58.971869208000044],
              [9.845225457000083, 58.98932526200008],
              [9.836761915000068, 59.00934479400007],
              [9.819590691000087, 59.02558014500005],
              [9.781748894000089, 59.05117422100005],
              [9.765961134000065, 59.052394924000055],
              [9.758148634000065, 59.03237539300005],
              [9.748871290000068, 59.03790924700007],
              [9.72396894600007, 59.05971914300005],
              [9.718923373000052, 59.06150950700004],
              [9.712087436000047, 59.06232330900008],
              [9.706065300000091, 59.06427643400008],
              [9.703461134000065, 59.069973049000055],
              [9.704112175000091, 59.08429596600007],
              [9.703461134000065, 59.08698151200008],
              [9.688487175000091, 59.09076569200005],
              [9.685394727000073, 59.080064195000034],
              [9.686289910000085, 59.06264883000006],
              [9.683116082000083, 59.04604726800005],
              [9.668630405000044, 59.05145905200004],
              [9.660980665000068, 59.056301174000055],
              [9.648936394000089, 59.07330963700008],
              [9.645274285000085, 59.083685614000046],
              [9.644867384000065, 59.09389883000006],
              [9.641368035000085, 59.102443752000056],
              [9.628428582000083, 59.10809967700004],
              [9.640472852000073, 59.11758047100005],
              [9.639821811000047, 59.12726471600007],
              [9.63062584700009, 59.13141510600008],
              [9.60092207100007, 59.115668036000045],
              [9.539073113000086, 59.12055084800005],
              [9.559092644000089, 59.10236237200007],
              [9.621348504000082, 59.07526276200008],
              [9.634613477000073, 59.04946523600006],
              [9.654144727000073, 59.03729889500005],
              [9.694346550000091, 59.02948639500005],
              [9.726817254000082, 59.01520416900007],
              [9.72396894600007, 58.98395416900007],
              [9.717784050000091, 58.98395416900007],
              [9.714854363000086, 58.98859284100007],
              [9.70866946700005, 58.993394273000035],
              [9.703461134000065, 58.99823639500005],
              [9.695648634000065, 58.98737213700008],
              [9.684743686000047, 58.98346588700008],
              [9.655772332000083, 58.98395416900007],
              [9.655772332000083, 58.97711823100008],
              [9.667491082000083, 58.97614166900007],
              [9.67750084700009, 58.97260163000004],
              [9.685069207000083, 58.96625397300005],
              [9.689789259000065, 58.956691799000055],
              [9.663340691000087, 58.95880768400008],
              [9.594248894000089, 58.943019924000055],
              [9.594248894000089, 58.93618398600006],
              [9.598317905000044, 58.93455638200004],
              [9.607920769000089, 58.92869700700004],
              [9.57593834700009, 58.92145416900007],
              [9.47006269600007, 58.92869700700004],
              [9.508636915000068, 58.91083405200004],
              [9.523936394000089, 58.900051174000055],
              [9.51148522200009, 58.89520905200004],
              [9.471527540000068, 58.900824286000045],
              [9.455902540000068, 58.897691148000035],
              [9.450368686000047, 58.88153717700004],
              [9.428070509000065, 58.89313385600008],
              [9.399424675000091, 58.898504950000074],
              [9.373789910000085, 58.895412502000056],
              [9.360199415000068, 58.88153717700004],
              [9.381521030000044, 58.88768138200004],
              [9.39421634200005, 58.889878648000035],
              [9.40202884200005, 58.888373114000046],
              [9.40365644600007, 58.880926825000074],
              [9.398936394000089, 58.874212958000044],
              [9.391286655000044, 58.869208075000074],
              [9.38453209700009, 58.867254950000074],
              [9.33952884200005, 58.862616278000075],
              [9.318532748000052, 58.86603424700007],
              [9.298838738000086, 58.88153717700004],
              [9.294200066000087, 58.868353583000044],
              [9.27084394600007, 58.83315664300005],
              [9.282725457000083, 58.83307526200008],
              [9.302989129000082, 58.82721588700008],
              [9.312510613000086, 58.82632070500006],
              [9.323090040000068, 58.82859935100004],
              [9.354177280000044, 58.83999258000006],
              [9.379649285000085, 58.844183661000045],
              [9.403168165000068, 58.84406159100007],
              [9.426117384000065, 58.84015534100007],
              [9.450368686000047, 58.83315664300005],
              [9.436208530000044, 58.820298570000034],
              [9.387950066000087, 58.80337148600006],
              [9.367035352000073, 58.792181708000044],
              [9.38843834700009, 58.79437897300005],
              [9.408702019000089, 58.79962799700007],
              [9.408702019000089, 58.792181708000044],
              [9.39234459700009, 58.78733958500004],
              [9.370941602000073, 58.77802155200004],
              [9.351410352000073, 58.76552969000005],
              [9.340505405000044, 58.751166083000044],
              [9.306488477000073, 58.738714911000045],
              [9.249278191000087, 58.733587958000044],
              [9.080088738000086, 58.74437083500004],
              [9.070974155000044, 58.74119700700004],
              [9.062347852000073, 58.73411692900004],
              [9.058441602000073, 58.72703685100004],
              [9.062998894000089, 58.723822333000044],
              [9.143565300000091, 58.70978424700007],
              [9.169118686000047, 58.716457424000055],
              [9.114268425000091, 58.73110586100006],
              [9.100840691000087, 58.737534898000035],
              [9.214691602000073, 58.72162506700005],
              [9.216319207000083, 58.702785549000055],
              [9.186696811000047, 58.69159577000005],
              [9.09506269600007, 58.69025299700007],
              [9.059336785000085, 58.682928778000075],
              [9.089121941000087, 58.683254299000055],
              [9.15601647200009, 58.68854401200008],
              [9.182871941000087, 58.68634674700007],
              [9.20053144600007, 58.67234935100004],
              [9.190196160000085, 58.66486237200007],
              [9.15221528300009, 58.643273804000046],
              [9.089180461000069, 58.61441670500005],
              [9.033836547000078, 58.59475403200008],
              [8.990977410000085, 58.60032786700003],
              [8.985606316000087, 58.59723541900007],
              [8.98178144600007, 58.59251536700003],
              [8.977712436000047, 58.58844635600008],
              [8.971202019000089, 58.58673737200007],
              [8.963877800000091, 58.58869049700007],
              [8.955088738000086, 58.59739817900004],
              [8.949473504000082, 58.60032786700003],
              [8.925303582000083, 58.60700104400007],
              [8.913340691000087, 58.60687897300005],
              [8.918711785000085, 58.59662506700005],
              [8.940603061000047, 58.58665599200003],
              [8.94890384200005, 58.57965729400007],
              [8.946299675000091, 58.56932200700004],
              [8.95009437300007, 58.54718385600006],
              [8.943880357000069, 58.52598520000004],
              [8.928075741000043, 58.51348633200007],
              [8.909419211000056, 58.50089176200004],
              [8.847288620000086, 58.46738950100007],
              [8.823518643000057, 58.45281778800006],
              [8.794256959000052, 58.44037859300005],
              [8.777450565000038, 58.43408743500004],
              [8.754104478000045, 58.427586579000035],
              [8.740175204000082, 58.41563656200003],
              [8.732799730000067, 58.40389647400008],
              [8.714523131000078, 58.39180049600009],
              [8.707295191000071, 58.37891074300006],
              [8.682790561000047, 58.370794989000046],
              [8.668711785000085, 58.36790599200003],
              [8.652842644000089, 58.366400458000044],
              [8.641612175000091, 58.36391836100006],
              [8.634043816000087, 58.35691966400003],
              [8.627452019000089, 58.347642320000034],
              [8.619395379000082, 58.33869049700007],
              [8.607269727000073, 58.33283112200007],
              [8.594981316000087, 58.33144765800006],
              [8.588389519000089, 58.33417389500005],
              [8.587738477000073, 58.34153880400004],
              [8.579356316000087, 58.34747955900008],
              [8.545258009000065, 58.31297435100004],
              [8.51343834700009, 58.29336172100005],
              [8.506358269000089, 58.28310781500005],
              [8.518077019000089, 58.27138906500005],
              [8.501231316000087, 58.25722890800006],
              [8.479258660000085, 58.25926341400003],
              [8.455821160000085, 58.26406484600005],
              [8.435394727000073, 58.25775788000004],
              [8.42351321700005, 58.27020905200004],
              [8.409353061000047, 58.27204010600008],
              [8.400563998000052, 58.26581452000005],
              [8.404795769000089, 58.254339911000045],
              [8.406260613000086, 58.244208075000074],
              [8.388926629000082, 58.241888739000046],
              [8.353526238000086, 58.24469635600008],
              [8.344981316000087, 58.241400458000044],
              [8.317230665000068, 58.225816148000035],
              [8.308848504000082, 58.21987539300005],
              [8.295258009000065, 58.21271393400008],
              [8.259287957000083, 58.20750560100004],
              [8.243662957000083, 58.203111070000034],
              [8.25131269600007, 58.202460028000075],
              [8.264903191000087, 58.198919989000046],
              [8.271739129000082, 58.19627513200004],
              [8.25757897200009, 58.17865631700005],
              [8.248871290000068, 58.17133209800005],
              [8.227224155000044, 58.16315338700008],
              [8.224619988000086, 58.15692780200004],
              [8.222504102000073, 58.151678778000075],
              [8.22242272200009, 58.14012278900003],
              [8.223155144000089, 58.134833075000074],
              [8.201914910000085, 58.12299225500004],
              [8.186289910000085, 58.132879950000074],
              [8.172699415000068, 58.146144924000055],
              [8.15796959700009, 58.14447663000004],
              [8.136729363000086, 58.11497630400004],
              [8.122894727000073, 58.10203685100004],
              [8.109873894000089, 58.10346100500004],
              [8.098480665000068, 58.10838450700004],
              [8.06576582100007, 58.11033763200004],
              [8.05250084700009, 58.11318594000005],
              [8.047048373000052, 58.116888739000046],
              [8.035492384000065, 58.130113023000035],
              [8.024587436000047, 58.141058661000045],
              [8.053477410000085, 58.14817942900004],
              [8.067556186000047, 58.153631903000075],
              [8.07984459700009, 58.162095445000034],
              [8.060069207000083, 58.177394924000055],
              [8.045746290000068, 58.204006252000056],
              [8.029551629000082, 58.22483958500004],
              [8.004079623000052, 58.22304922100005],
              [8.022146030000044, 58.202826239000046],
              [8.027598504000082, 58.18317291900007],
              [8.022308790000068, 58.163763739000046],
              [8.00749759200005, 58.14447663000004],
              [7.953623894000089, 58.124701239000046],
              [7.934092644000089, 58.109442450000074],
              [7.956309441000087, 58.09324778900003],
              [7.91578209700009, 58.08185455900008],
              [7.75521894600007, 58.070013739000046],
              [7.715179884000065, 58.060614325000074],
              [7.695974155000044, 58.05853913000004],
              [7.663910352000073, 58.067287502000056],
              [7.653575066000087, 58.06464264500005],
              [7.660899285000085, 58.04547760600008],
              [7.642751498000052, 58.04584381700005],
              [7.634613477000073, 58.04779694200005],
              [7.62671959700009, 58.05231354400007],
              [7.629242384000065, 58.031236070000034],
              [7.614756707000083, 58.02212148600006],
              [7.594086134000065, 58.02635325700004],
              [7.578868035000085, 58.04547760600008],
              [7.574880405000044, 58.03204987200007],
              [7.575205925000091, 58.02606842700004],
              [7.578868035000085, 58.01752350500004],
              [7.390635613000086, 58.01752350500004],
              [7.267588738000086, 58.03595612200007],
              [7.253428582000083, 58.04364655200004],
              [7.249847852000073, 58.05853913000004],
              [7.190440300000091, 58.04197825700004],
              [7.174978061000047, 58.03119538000004],
              [7.166351759000065, 58.046087958000044],
              [7.155528191000087, 58.05027903900003],
              [7.082774285000085, 58.03685130400004],
              [7.078786655000044, 58.03266022300005],
              [7.078949415000068, 58.02806224200003],
              [7.078623894000089, 58.02496979400007],
              [7.076914910000085, 58.01968008000006],
              [7.07748457100007, 58.01264069200005],
              [7.076019727000073, 58.00653717700004],
              [7.068369988000086, 58.003892320000034],
              [7.06031334700009, 58.003241278000075],
              [7.02312259200005, 57.99481842700004],
              [7.006602410000085, 57.99315013200004],
              [6.997243686000047, 57.99713776200008],
              [7.00359134200005, 58.011379299000055],
              [6.99935957100007, 58.03070709800005],
              [7.022471550000091, 58.04336172100005],
              [7.053884311000047, 58.05263906500005],
              [7.075205925000091, 58.06224192900004],
              [7.087738477000073, 58.07062409100007],
              [7.09742272200009, 58.068426825000074],
              [7.106211785000085, 58.06207916900007],
              [7.116221550000091, 58.05853913000004],
              [7.124522332000083, 58.063381252000056],
              [7.14031009200005, 58.08624909100007],
              [7.147471550000091, 58.09324778900003],
              [7.147471550000091, 58.10008372600004],
              [7.127614780000044, 58.09756094000005],
              [7.064707879000082, 58.078111070000034],
              [7.051442905000044, 58.06903717700004],
              [7.03492272200009, 58.06232330900008],
              [6.95875084700009, 58.04511139500005],
              [6.93531334700009, 58.04547760600008],
              [6.95248457100007, 58.05809153900003],
              [6.979502800000091, 58.08893463700008],
              [6.996104363000086, 58.10008372600004],
              [6.980316602000073, 58.10537344000005],
              [6.923675977000073, 58.06525299700007],
              [6.900563998000052, 58.05231354400007],
              [6.907399936000047, 58.064154364000046],
              [6.912119988000086, 58.07501862200007],
              [6.912852410000085, 58.08641185100004],
              [6.90796959700009, 58.10008372600004],
              [6.89584394600007, 58.09589264500005],
              [6.879079623000052, 58.08372630400004],
              [6.866384311000047, 58.07957591400003],
              [6.85132897200009, 58.080064195000034],
              [6.832204623000052, 58.08429596600007],
              [6.814463738000086, 58.09125397300005],
              [6.804209832000083, 58.10008372600004],
              [6.848155144000089, 58.11517975500004],
              [6.87077884200005, 58.119208075000074],
              [6.949961785000085, 58.12091705900008],
              [6.974782748000052, 58.12677643400008],
              [6.989268425000091, 58.141058661000045],
              [6.958994988000086, 58.14008209800005],
              [6.904144727000073, 58.13104889500005],
              [6.873789910000085, 58.134833075000074],
              [6.84896894600007, 58.14752838700008],
              [6.801524285000085, 58.179348049000055],
              [6.777598504000082, 58.18203359600005],
              [6.812836134000065, 58.128241278000075],
              [6.80795332100007, 58.12055084800005],
              [6.757334832000083, 58.11635976800005],
              [6.731455925000091, 58.11985911700003],
              [6.715586785000085, 58.134833075000074],
              [6.727305535000085, 58.14520905200004],
              [6.727305535000085, 58.157538153000075],
              [6.723317905000044, 58.17226797100005],
              [6.72242272200009, 58.189439195000034],
              [6.699473504000082, 58.13646067900004],
              [6.688243035000085, 58.12055084800005],
              [6.703379754000082, 58.120428778000075],
              [6.71062259200005, 58.11546458500004],
              [6.715342644000089, 58.10789622600004],
              [6.72242272200009, 58.10008372600004],
              [6.733164910000085, 58.09414297100005],
              [6.75359134200005, 58.08657461100006],
              [6.774261915000068, 58.07396067900004],
              [6.783213738000086, 58.06981028900003],
              [6.78256269600007, 58.065334377000056],
              [6.763926629000082, 58.05853913000004],
              [6.754079623000052, 58.05809153900003],
              [6.733653191000087, 58.06427643400008],
              [6.722666863000086, 58.06598541900007],
              [6.61850019600007, 58.06830475500004],
              [6.595876498000052, 58.075873114000046],
              [6.542002800000091, 58.10765208500004],
              [6.530528191000087, 58.12055084800005],
              [6.550303582000083, 58.12287018400008],
              [6.56812584700009, 58.13178131700005],
              [6.580902540000068, 58.14630768400008],
              [6.585785352000073, 58.165269273000035],
              [6.59701582100007, 58.17649974200003],
              [6.653005405000044, 58.17792389500005],
              [6.674571160000085, 58.18203359600005],
              [6.660329623000052, 58.18813711100006],
              [6.65406334700009, 58.189439195000034],
              [6.67514082100007, 58.20697663000004],
              [6.725271030000044, 58.22162506700005],
              [6.765879754000082, 58.24628327000005],
              [6.845957879000082, 58.27138906500005],
              [6.828461134000065, 58.274725653000075],
              [6.802989129000082, 58.27045319200005],
              [6.756846550000091, 58.254339911000045],
              [6.698496941000087, 58.22455475500004],
              [6.68140709700009, 58.22304922100005],
              [6.668711785000085, 58.23151276200008],
              [6.639333530000044, 58.264105536000045],
              [6.633636915000068, 58.27484772300005],
              [6.640147332000083, 58.29376862200007],
              [6.656260613000086, 58.302801825000074],
              [6.676442905000044, 58.30219147300005],
              [6.69507897200009, 58.291896877000056],
              [6.70875084700009, 58.31297435100004],
              [6.68726647200009, 58.327337958000044],
              [6.664073113000086, 58.32371653900003],
              [6.640879754000082, 58.31635163000004],
              [6.619965040000068, 58.31915924700007],
              [6.619802280000044, 58.26463450700004],
              [6.626231316000087, 58.24469635600008],
              [6.562347852000073, 58.24310944200005],
              [6.499278191000087, 58.262884833000044],
              [6.400627956000051, 58.27222924400007],
              [6.347515413000053, 58.28585123900007],
              [6.291758660000085, 58.308661200000074],
              [6.280772332000083, 58.31297435100004],
              [6.265961134000065, 58.31427643400008],
              [6.248220248000052, 58.31781647300005],
              [6.231211785000085, 58.323146877000056],
              [6.219004754000082, 58.329779364000046],
              [6.203379754000082, 58.33551666900007],
              [6.14031009200005, 58.33966705900008],
              [6.084971550000091, 58.36017487200007],
              [6.061696811000047, 58.374701239000046],
              [6.050629102000073, 58.37946198100008],
              [6.02116946700005, 58.382147528000075],
              [6.010101759000065, 58.38491445500006],
              [6.001475457000083, 58.39012278900003],
              [5.983897332000083, 58.40639883000006],
              [5.978037957000083, 58.414496161000045],
              [5.973399285000085, 58.42401764500005],
              [5.968923373000052, 58.43650950700004],
              [5.966970248000052, 58.44839101800005],
              [5.967051629000082, 58.458685614000046],
              [5.964366082000083, 58.46816640800006],
              [5.954600457000083, 58.47748444200005],
              [5.928477410000085, 58.483587958000044],
              [5.837321585000041, 58.481318903000044],
              [5.79665267200005, 58.48924595700004],
              [5.77839094400008, 58.520899272000065],
              [5.741953415000069, 58.52700449100007],
              [5.70417068200004, 58.52076740800004],
              [5.64625084700009, 58.54865143400008],
              [5.652354561000038, 58.56273329600003],
              [5.614598254000043, 58.59323478300007],
              [5.571543816000087, 58.62832265800006],
              [5.547939707000069, 58.666960620000054],
              [5.526375706000067, 58.69428704500007],
              [5.518161617000089, 58.71422159800005],
              [5.50692261800009, 58.72989756100009],
              [5.477951160000089, 58.75474722700005],
              [5.49520504700007, 58.765956515000084],
              [5.526723268000069, 58.78411390400004],
              [5.535357781000073, 58.798901009000076],
              [5.539672727000038, 58.81547855800005],
              [5.539662634000081, 58.83384715400007],
              [5.53687584700009, 58.853583075000074],
              [5.530528191000087, 58.86871979400007],
              [5.539235873000052, 58.874986070000034],
              [5.553721550000091, 58.87763092700004],
              [5.56413821700005, 58.88153717700004],
              [5.572520379000082, 58.89402903900003],
              [5.570648634000065, 58.900051174000055],
              [5.56218509200005, 58.90525950700004],
              [5.55054772200009, 58.915716864000046],
              [5.549327019000089, 58.92084381700005],
              [5.543223504000082, 58.934759833000044],
              [5.535655144000089, 58.94599030200004],
              [5.537119988000086, 58.95612213700008],
              [5.546397332000083, 58.954738674000055],
              [5.556976759000065, 58.947333075000074],
              [5.567881707000083, 58.943019924000055],
              [5.597666863000086, 58.91559479400007],
              [5.617360873000052, 58.90729401200008],
              [5.626231316000087, 58.92560455900008],
              [5.616384311000047, 58.935614325000074],
              [5.593597852000073, 58.94993724200003],
              [5.55054772200009, 58.97089264500005],
              [5.560394727000073, 58.97797272300005],
              [5.570648634000065, 58.982082424000055],
              [5.581065300000091, 58.98224518400008],
              [5.59156334700009, 58.97711823100008],
              [5.578868035000085, 58.98908112200007],
              [5.541026238000086, 58.98456452000005],
              [5.52320397200009, 58.991400458000044],
              [5.535655144000089, 58.99860260600008],
              [5.542491082000083, 59.00958893400008],
              [5.55054772200009, 59.03856028900003],
              [5.715586785000085, 58.97711823100008],
              [5.706309441000087, 58.95221588700008],
              [5.701019727000073, 58.919134833000044],
              [5.702972852000073, 58.887600002000056],
              [5.715586785000085, 58.867254950000074],
              [5.735524936000047, 58.92869700700004],
              [5.754079623000052, 58.93390534100007],
              [5.800791863000086, 58.93183014500005],
              [5.81812584700009, 58.93618398600006],
              [5.819509311000047, 58.94220612200007],
              [5.817393425000091, 58.95978424700007],
              [5.821787957000083, 58.96344635600008],
              [5.853526238000086, 58.96503327000005],
              [5.865896030000044, 58.96344635600008],
              [5.88249759200005, 58.95929596600007],
              [5.91960696700005, 58.94505442900004],
              [5.934092644000089, 58.93618398600006],
              [5.957367384000065, 58.91351959800005],
              [5.969981316000087, 58.903631903000075],
              [6.092539910000085, 58.84723541900007],
              [6.135101759000065, 58.83958567900004],
              [6.228851759000065, 58.83999258000006],
              [6.206228061000047, 58.84902578300006],
              [6.118988477000073, 58.853583075000074],
              [6.102549675000091, 58.85976797100005],
              [6.082041863000086, 58.870794989000046],
              [6.064789259000065, 58.88540273600006],
              [6.057627800000091, 58.902044989000046],
              [6.063731316000087, 58.91364166900007],
              [6.07789147200009, 58.92829010600008],
              [6.105316602000073, 58.950384833000044],
              [6.126475457000083, 58.962103583000044],
              [6.194834832000083, 58.98395416900007],
              [6.626231316000087, 59.052801825000074],
              [6.626231316000087, 59.05971914300005],
              [6.352061394000089, 59.03302643400008],
              [6.298675977000073, 59.01512278900003],
              [6.160411004000082, 58.99823639500005],
              [6.126800977000073, 58.983710028000075],
              [6.033864780000044, 58.905178127000056],
              [5.982676629000082, 58.95172760600008],
              [5.975108269000089, 58.96344635600008],
              [5.98406009200005, 58.984076239000046],
              [6.006358269000089, 58.99103424700007],
              [6.031911655000044, 58.99290599200003],
              [6.050791863000086, 58.99823639500005],
              [6.037445509000065, 59.002834377000056],
              [6.020030144000089, 59.019964911000045],
              [6.00912519600007, 59.02558014500005],
              [5.992442254000082, 59.02513255400004],
              [5.953949415000068, 59.01642487200007],
              [5.934092644000089, 59.01813385600008],
              [5.913910352000073, 59.02806224200003],
              [5.891856316000087, 59.045355536000045],
              [5.875498894000089, 59.06622955900008],
              [5.87273196700005, 59.08698151200008],
              [5.890635613000086, 59.10390859600005],
              [5.923024936000047, 59.11347077000005],
              [6.021820509000065, 59.12612539300005],
              [6.050791863000086, 59.134751695000034],
              [6.108409050000091, 59.14252350500004],
              [6.126475457000083, 59.148423570000034],
              [6.089366082000083, 59.15289948100008],
              [6.039317254000082, 59.14744700700004],
              [6.008799675000091, 59.14935944200005],
              [6.030446811000047, 59.175767320000034],
              [6.064300977000073, 59.20722077000005],
              [6.078786655000044, 59.21670156500005],
              [6.125173373000052, 59.23383209800005],
              [6.171397332000083, 59.261419989000046],
              [6.252126498000052, 59.27724844000005],
              [6.32390384200005, 59.31500885600008],
              [6.369313998000052, 59.32135651200008],
              [6.461680535000085, 59.31976959800005],
              [6.461680535000085, 59.32656484600005],
              [6.339121941000087, 59.32656484600005],
              [6.31381269600007, 59.32294342700004],
              [6.202403191000087, 59.277044989000046],
              [6.154144727000073, 59.26776764500005],
              [6.112315300000091, 59.27456289300005],
              [6.084971550000091, 59.306708075000074],
              [6.236338738000086, 59.312933661000045],
              [6.236338738000086, 59.31976959800005],
              [6.226573113000086, 59.330145575000074],
              [6.212087436000047, 59.33978913000004],
              [6.199229363000086, 59.351548570000034],
              [6.200694207000083, 59.34414297100005],
              [6.197601759000065, 59.33470286700003],
              [6.188649936000047, 59.32656484600005],
              [6.172129754000082, 59.32123444200005],
              [6.164561394000089, 59.327460028000075],
              [6.158457879000082, 59.33661530200004],
              [6.146983269000089, 59.34023672100005],
              [6.143809441000087, 59.33771393400008],
              [6.129893425000091, 59.323146877000056],
              [6.12281334700009, 59.31976959800005],
              [6.112152540000068, 59.318426825000074],
              [6.10124759200005, 59.31867096600007],
              [6.092458530000044, 59.31976959800005],
              [6.078379754000082, 59.32453034100007],
              [6.069183790000068, 59.33177317900004],
              [6.062998894000089, 59.34153880400004],
              [6.057627800000091, 59.35390859600005],
              [6.05404707100007, 59.33462148600006],
              [6.037445509000065, 59.327460028000075],
              [6.01539147200009, 59.328558661000045],
              [5.99545332100007, 59.334051825000074],
              [5.99545332100007, 59.34023672100005],
              [6.00757897200009, 59.346136786000045],
              [6.015472852000073, 59.35504791900007],
              [6.022227410000085, 59.365301825000074],
              [6.030446811000047, 59.37494538000004],
              [6.041514519000089, 59.383693752000056],
              [6.053396030000044, 59.39081452000005],
              [6.078786655000044, 59.40228913000004],
              [6.129242384000065, 59.417303778000075],
              [6.153819207000083, 59.427394924000055],
              [6.174327019000089, 59.44383372600004],
              [6.17750084700009, 59.44000885600008],
              [6.18531334700009, 59.433294989000046],
              [6.188649936000047, 59.42963288000004],
              [6.19304446700005, 59.43821849200003],
              [6.198090040000068, 59.44562409100007],
              [6.211761915000068, 59.46002838700008],
              [6.21615644600007, 59.468085028000075],
              [6.217946811000047, 59.48851146000004],
              [6.222666863000086, 59.49787018400008],
              [6.242686394000089, 59.51056549700007],
              [6.42750084700009, 59.55097077000005],
              [6.544200066000087, 59.55996328300006],
              [6.50521894600007, 59.57127513200004],
              [6.336110873000052, 59.553615627000056],
              [6.272146030000044, 59.52814362200007],
              [6.236338738000086, 59.525824286000045],
              [6.249278191000087, 59.54083893400008],
              [6.26498457100007, 59.55581289300005],
              [6.278575066000087, 59.57200755400004],
              [6.284190300000091, 59.591009833000044],
              [6.285004102000073, 59.61029694200005],
              [6.28874759200005, 59.62913646000004],
              [6.297048373000052, 59.644964911000045],
              [6.311534050000091, 59.655503648000035],
              [6.28646894600007, 59.64923737200007],
              [6.266856316000087, 59.62563711100006],
              [6.254079623000052, 59.59552643400008],
              [6.24935957100007, 59.56989166900007],
              [6.24586022200009, 59.56195709800005],
              [6.237315300000091, 59.54979075700004],
              [6.219004754000082, 59.528957424000055],
              [6.198252800000091, 59.511053778000075],
              [6.162852410000085, 59.46849192900004],
              [6.153005405000044, 59.459418036000045],
              [6.14031009200005, 59.450100002000056],
              [6.099131707000083, 59.43268463700008],
              [6.078135613000086, 59.41933828300006],
              [6.041514519000089, 59.40497467700004],
              [6.02702884200005, 59.40228913000004],
              [6.00953209700009, 59.40761953300006],
              [5.998301629000082, 59.42841217700004],
              [5.982595248000052, 59.42963288000004],
              [5.988617384000065, 59.41596100500004],
              [5.983246290000068, 59.414129950000074],
              [5.97437584700009, 59.409816799000055],
              [5.968923373000052, 59.40851471600007],
              [5.968923373000052, 59.40228913000004],
              [5.978363477000073, 59.40013255400004],
              [5.98609459700009, 59.39590078300006],
              [5.99195397200009, 59.38947174700007],
              [5.99545332100007, 59.38117096600007],
              [5.94857832100007, 59.360256252000056],
              [5.924164259000065, 59.35578034100007],
              [5.91374759200005, 59.37156810100004],
              [5.910004102000073, 59.382025458000044],
              [5.90170332100007, 59.389105536000045],
              [5.892751498000052, 59.39516836100006],
              [5.886241082000083, 59.40228913000004],
              [5.88249759200005, 59.415228583000044],
              [5.882823113000086, 59.425116278000075],
              [5.885020379000082, 59.43471914300005],
              [5.886241082000083, 59.446966864000046],
              [5.924082879000082, 59.44611237200007],
              [6.153168165000068, 59.477443752000056],
              [6.133555535000085, 59.49005768400008],
              [6.104340040000068, 59.49290599200003],
              [6.073741082000083, 59.48895905200004],
              [6.024668816000087, 59.474310614000046],
              [5.901866082000083, 59.47907135600008],
              [5.887461785000085, 59.48224518400008],
              [5.87273196700005, 59.487982489000046],
              [5.863536004000082, 59.49428945500006],
              [5.84937584700009, 59.50873444200005],
              [5.842295769000089, 59.51154205900008],
              [5.834483269000089, 59.515611070000034],
              [5.823008660000085, 59.53424713700008],
              [5.81812584700009, 59.539496161000045],
              [5.807383660000085, 59.53937409100007],
              [5.788910352000073, 59.528631903000075],
              [5.77711022200009, 59.525824286000045],
              [5.803477410000085, 59.49477773600006],
              [5.807871941000087, 59.48029205900008],
              [5.797536655000044, 59.46312083500004],
              [5.776377800000091, 59.45091380400004],
              [5.748383009000065, 59.44578685100004],
              [5.722829623000052, 59.451157945000034],
              [5.708262566000087, 59.47060781500005],
              [5.713715040000068, 59.44668203300006],
              [5.696462436000047, 59.42942942900004],
              [5.64616946700005, 59.40851471600007],
              [5.664398634000065, 59.40648021000004],
              [5.735524936000047, 59.42963288000004],
              [5.76303144600007, 59.43235911700003],
              [5.784190300000091, 59.42926666900007],
              [5.80250084700009, 59.42011139500005],
              [5.852549675000091, 59.38499583500004],
              [5.858164910000085, 59.37457916900007],
              [5.859629754000082, 59.350775458000044],
              [5.846364780000044, 59.346909898000035],
              [5.783539259000065, 59.34320709800005],
              [5.76343834700009, 59.347723700000074],
              [5.752696160000085, 59.33624909100007],
              [5.738454623000052, 59.33478424700007],
              [5.70484459700009, 59.34023672100005],
              [5.697927280000044, 59.33803945500006],
              [5.697601759000065, 59.33266836100006],
              [5.69857832100007, 59.325873114000046],
              [5.695160352000073, 59.31976959800005],
              [5.682383660000085, 59.312933661000045],
              [5.677744988000086, 59.309800523000035],
              [5.666514519000089, 59.304673570000034],
              [5.624196811000047, 59.292181708000044],
              [5.611989780000044, 59.293036200000074],
              [5.609629754000082, 59.305568752000056],
              [5.618662957000083, 59.31688060100004],
              [5.632985873000052, 59.32477448100008],
              [5.64616946700005, 59.32656484600005],
              [5.64616946700005, 59.334051825000074],
              [5.623383009000065, 59.35455963700008],
              [5.607269727000073, 59.390285549000055],
              [5.586599155000044, 59.41648997600004],
              [5.560720248000052, 59.40932851800005],
              [5.57007897200009, 59.407416083000044],
              [5.578135613000086, 59.402777411000045],
              [5.58529707100007, 59.39545319200005],
              [5.57781009200005, 59.37592194200005],
              [5.576345248000052, 59.33299388200004],
              [5.567881707000083, 59.31635163000004],
              [5.549327019000089, 59.299709377000056],
              [5.529307488000086, 59.28579336100006],
              [5.505381707000083, 59.27773672100005],
              [5.475433790000068, 59.27875397300005],
              [5.456065300000091, 59.28851959800005],
              [5.435801629000082, 59.30768463700008],
              [5.423838738000086, 59.33047109600005],
              [5.430430535000085, 59.350775458000044],
              [5.440603061000047, 59.36981842700004],
              [5.441742384000065, 59.392238674000055],
              [5.433116082000083, 59.40509674700007],
              [5.413340691000087, 59.39545319200005],
              [5.404307488000086, 59.378973700000074],
              [5.402842644000089, 59.359035549000055],
              [5.406504754000082, 59.31635163000004],
              [5.404633009000065, 59.30426666900007],
              [5.399424675000091, 59.29669830900008],
              [5.390879754000082, 59.294623114000046],
              [5.379242384000065, 59.299261786000045],
              [5.37273196700005, 59.30719635600008],
              [5.369476759000065, 59.318345445000034],
              [5.365570509000065, 59.34023672100005],
              [5.353851759000065, 59.35529205900008],
              [5.349945509000065, 59.366441148000035],
              [5.358246290000068, 59.38719310100004],
              [5.357595248000052, 59.39988841400003],
              [5.353770379000082, 59.41107819200005],
              [5.348399285000085, 59.41596100500004],
              [5.336273634000065, 59.41510651200008],
              [5.332692905000044, 59.41152578300006],
              [5.330414259000065, 59.35809967700004],
              [5.33139082100007, 59.35390859600005],
              [5.297211134000065, 59.34467194200005],
              [5.231211785000085, 59.424261786000045],
              [5.201670769000089, 59.42963288000004],
              [5.196055535000085, 59.44428131700005],
              [5.191905144000089, 59.46303945500006],
              [5.187998894000089, 59.49787018400008],
              [5.185883009000065, 59.50287506700005],
              [5.182790561000047, 59.506740627000056],
              [5.182302280000044, 59.51121653900003],
              [5.187998894000089, 59.51837799700007],
              [5.199717644000089, 59.524603583000044],
              [5.213389519000089, 59.526678778000075],
              [5.242686394000089, 59.525824286000045],
              [5.242686394000089, 59.53204987200007],
              [5.201670769000089, 59.539496161000045],
              [5.201670769000089, 59.54629140800006],
              [5.222504102000073, 59.55170319200005],
              [5.237803582000083, 59.55963776200008],
              [5.29037519600007, 59.600897528000075],
              [5.30404707100007, 59.628241278000075],
              [5.321299675000091, 59.63825104400007],
              [5.344248894000089, 59.647650458000044],
              [5.367523634000065, 59.65265534100007],
              [5.385996941000087, 59.64935944200005],
              [5.393565300000091, 59.638006903000075],
              [5.401621941000087, 59.605536200000074],
              [5.413340691000087, 59.59467194200005],
              [5.41578209700009, 59.61127350500004],
              [5.428070509000065, 59.624986070000034],
              [5.427012566000087, 59.63568756700005],
              [5.417816602000073, 59.64935944200005],
              [5.401621941000087, 59.66079336100006],
              [5.399668816000087, 59.66982656500005],
              [5.411631707000083, 59.68919505400004],
              [5.43718509200005, 59.708197333000044],
              [5.489105665000068, 59.73810455900008],
              [5.48414147200009, 59.727728583000044],
              [5.481700066000087, 59.723822333000044],
              [5.493011915000068, 59.71832916900007],
              [5.498708530000044, 59.71442291900007],
              [5.502126498000052, 59.710150458000044],
              [5.50554446700005, 59.692694403000075],
              [5.504567905000044, 59.67182038000004],
              [5.498057488000086, 59.65058014500005],
              [5.485362175000091, 59.63198476800005],
              [5.480479363000086, 59.62132396000004],
              [5.482758009000065, 59.61005280200004],
              [5.487315300000091, 59.59857819200005],
              [5.489105665000068, 59.58730703300006],
              [5.487803582000083, 59.57501862200007],
              [5.485524936000047, 59.56976959800005],
              [5.461680535000085, 59.55996328300006],
              [5.457855665000068, 59.556708075000074],
              [5.453135613000086, 59.548041083000044],
              [5.45085696700005, 59.54629140800006],
              [5.432790561000047, 59.54718659100007],
              [5.423675977000073, 59.54637278900003],
              [5.416758660000085, 59.54291413000004],
              [5.41179446700005, 59.53465403900003],
              [5.407725457000083, 59.52179596600007],
              [5.40788821700005, 59.51622142100007],
              [5.408050977000073, 59.50991445500006],
              [5.416758660000085, 59.50470612200007],
              [5.422536655000044, 59.50649648600006],
              [5.434336785000085, 59.51520416900007],
              [5.441254102000073, 59.51837799700007],
              [5.50562584700009, 59.53335195500006],
              [5.516368035000085, 59.539496161000045],
              [5.526866082000083, 59.55385976800005],
              [5.528737826000054, 59.557928778000075],
              [5.537364129000082, 59.57684967700004],
              [5.540049675000091, 59.59829336100006],
              [5.526621941000087, 59.60773346600007],
              [5.523610873000052, 59.61790599200003],
              [5.534027540000068, 59.64057038000004],
              [5.550303582000083, 59.66400788000004],
              [5.56413821700005, 59.676662502000056],
              [5.580577019000089, 59.679022528000075],
              [5.608571811000047, 59.67202383000006],
              [5.626231316000087, 59.66982656500005],
              [5.694590691000087, 59.66982656500005],
              [5.721934441000087, 59.66347890800006],
              [5.730967644000089, 59.647650458000044],
              [5.727061394000089, 59.627386786000045],
              [5.715586785000085, 59.60773346600007],
              [5.743011915000068, 59.607855536000045],
              [5.754405144000089, 59.60984935100004],
              [5.76343834700009, 59.614569403000075],
              [5.76531009200005, 59.620428778000075],
              [5.764170769000089, 59.63849518400008],
              [5.766856316000087, 59.64557526200008],
              [5.789073113000086, 59.65643952000005],
              [5.820160352000073, 59.65884023600006],
              [5.879405144000089, 59.655503648000035],
              [5.879405144000089, 59.676662502000056],
              [5.788584832000083, 59.660142320000034],
              [5.76343834700009, 59.66233958500004],
              [5.746104363000086, 59.67552317900004],
              [5.75562584700009, 59.68829987200007],
              [5.797536655000044, 59.710150458000044],
              [5.803477410000085, 59.71674225500004],
              [5.807465040000068, 59.72361888200004],
              [5.81421959700009, 59.72907135600008],
              [5.87476647200009, 59.73529694200005],
              [5.886241082000083, 59.73810455900008],
              [5.893077019000089, 59.74567291900007],
              [5.893077019000089, 59.75446198100008],
              [5.894053582000083, 59.761786200000074],
              [5.903086785000085, 59.76479726800005],
              [5.912608269000089, 59.76219310100004],
              [5.920746290000068, 59.75617096600007],
              [5.927582227000073, 59.74949778900003],
              [5.934092644000089, 59.74494049700007],
              [5.985850457000083, 59.73574453300006],
              [6.038096550000091, 59.74518463700008],
              [6.162282748000052, 59.796861070000034],
              [6.170909050000091, 59.80267975500004],
              [6.17741946700005, 59.80560944200005],
              [6.191742384000065, 59.805975653000075],
              [6.198252800000091, 59.809475002000056],
              [6.210948113000086, 59.82444896000004],
              [6.215179884000065, 59.827460028000075],
              [6.291758660000085, 59.84031810100004],
              [6.311534050000091, 59.85419342700004],
              [6.244313998000052, 59.84357330900008],
              [6.121918165000068, 59.804754950000074],
              [6.037119988000086, 59.76479726800005],
              [6.020518425000091, 59.76015859600005],
              [6.002289259000065, 59.75861237200007],
              [5.963877800000091, 59.75995514500005],
              [5.945323113000086, 59.76593659100007],
              [5.934092644000089, 59.77903880400004],
              [5.934418165000068, 59.794623114000046],
              [5.944102410000085, 59.80133698100008],
              [5.955821160000085, 59.806341864000046],
              [5.961436394000089, 59.81659577000005],
              [5.957530144000089, 59.84125397300005],
              [5.959157748000052, 59.85053131700005],
              [5.968923373000052, 59.861029364000046],
              [5.946787957000083, 59.855536200000074],
              [5.934255405000044, 59.841498114000046],
              [5.928558790000068, 59.82257721600007],
              [5.927256707000083, 59.80267975500004],
              [5.914398634000065, 59.791449286000045],
              [5.885020379000082, 59.781317450000074],
              [5.85287519600007, 59.77423737200007],
              [5.83171634200005, 59.77220286700003],
              [5.809092644000089, 59.778225002000056],
              [5.79037519600007, 59.78925202000005],
              [5.759613477000073, 59.81659577000005],
              [5.735524936000047, 59.82880280200004],
              [5.715098504000082, 59.831732489000046],
              [5.707530144000089, 59.83812083500004],
              [5.721853061000047, 59.861029364000046],
              [5.70443769600007, 59.85114166900007],
              [5.68140709700009, 59.841498114000046],
              [5.65984134200005, 59.83999258000006],
              [5.64616946700005, 59.85419342700004],
              [5.670420769000089, 59.855902411000045],
              [5.696543816000087, 59.86225006700005],
              [5.742930535000085, 59.882066148000035],
              [5.740244988000086, 59.90989817900004],
              [5.772227410000085, 59.93073151200008],
              [5.818858269000089, 59.94448476800005],
              [5.859629754000082, 59.95099518400008],
              [5.965098504000082, 59.95661041900007],
              [5.971527540000068, 59.95954010600008],
              [5.977224155000044, 59.96653880400004],
              [5.981130405000044, 59.97475820500006],
              [5.982595248000052, 59.98110586100006],
              [5.978037957000083, 59.984808661000045],
              [5.947764519000089, 59.99750397300005],
              [6.010020379000082, 60.05744049700007],
              [6.097992384000065, 60.091864325000074],
              [6.291026238000086, 60.12164948100008],
              [6.291026238000086, 60.12909577000005],
              [6.266449415000068, 60.12763092700004],
              [6.261729363000086, 60.13776276200008],
              [6.262950066000087, 60.15192291900007],
              [6.256846550000091, 60.16266510600008],
              [6.24740644600007, 60.161322333000044],
              [6.233409050000091, 60.154730536000045],
              [6.220713738000086, 60.146144924000055],
              [6.215179884000065, 60.138739325000074],
              [6.20053144600007, 60.125433661000045],
              [6.166840040000068, 60.11505768400008],
              [6.129893425000091, 60.108710028000075],
              [6.105316602000073, 60.10736725500004],
              [6.107758009000065, 60.134100653000075],
              [6.084320509000065, 60.16860586100006],
              [6.074961785000085, 60.19839101800005],
              [6.14234459700009, 60.21548086100006],
              [6.155772332000083, 60.22671133000006],
              [6.166514519000089, 60.24213288000004],
              [6.181162957000083, 60.25885651200008],
              [6.209157748000052, 60.27680084800005],
              [6.213389519000089, 60.28628164300005],
              [6.201670769000089, 60.29979075700004],
              [6.258474155000044, 60.30809153900003],
              [6.277354363000086, 60.31346263200004],
              [6.287852410000085, 60.32021719000005],
              [6.309418165000068, 60.33783600500004],
              [6.32162519600007, 60.34137604400007],
              [6.33334394600007, 60.34259674700007],
              [6.335785352000073, 60.345689195000034],
              [6.335459832000083, 60.35008372600004],
              [6.338715040000068, 60.35504791900007],
              [6.338145379000082, 60.35541413000004],
              [6.340993686000047, 60.35895416900007],
              [6.345957879000082, 60.36375560100004],
              [6.351817254000082, 60.36810944200005],
              [6.383555535000085, 60.377020575000074],
              [6.41765384200005, 60.38239166900007],
              [6.441661004000082, 60.38886139500005],
              [6.478688998000052, 60.42011139500005],
              [6.502696160000085, 60.43081289300005],
              [6.537933790000068, 60.43414948100008],
              [6.574229363000086, 60.43195221600007],
              [6.64039147200009, 60.41648997600004],
              [6.591970248000052, 60.36367422100005],
              [6.571787957000083, 60.33075592700004],
              [6.578379754000082, 60.306626695000034],
              [6.567637566000087, 60.29389069200005],
              [6.536957227000073, 60.27228424700007],
              [6.530528191000087, 60.26227448100008],
              [6.521739129000082, 60.18585846600007],
              [6.512705925000091, 60.15289948100008],
              [6.510101759000065, 60.13532135600008],
              [6.510101759000065, 60.11009349200003],
              [6.51693769600007, 60.08075592700004],
              [6.523773634000065, 60.08075592700004],
              [6.524180535000085, 60.135199286000045],
              [6.529144727000073, 60.16388580900008],
              [6.54818769600007, 60.18276601800005],
              [6.578379754000082, 60.224676825000074],
              [6.58179772200009, 60.23822663000004],
              [6.581065300000091, 60.248480536000045],
              [6.571543816000087, 60.27252838700008],
              [6.596364780000044, 60.29486725500004],
              [6.630381707000083, 60.357489325000074],
              [6.65406334700009, 60.38239166900007],
              [6.671397332000083, 60.39052969000005],
              [6.701426629000082, 60.39940013200004],
              [6.715586785000085, 60.40965403900003],
              [6.748301629000082, 60.44635651200008],
              [6.763926629000082, 60.457464911000045],
              [6.783376498000052, 60.466864325000074],
              [6.802582227000073, 60.47280508000006],
              [6.942149285000085, 60.492254950000074],
              [7.032481316000087, 60.477850653000075],
              [7.078786655000044, 60.479396877000056],
              [7.105967644000089, 60.505845445000034],
              [6.900563998000052, 60.505845445000034],
              [6.900563998000052, 60.51211172100005],
              [6.908213738000086, 60.512600002000056],
              [6.917491082000083, 60.51459381700005],
              [6.92514082100007, 60.51788971600007],
              [6.928477410000085, 60.522365627000056],
              [6.932465040000068, 60.533189195000034],
              [6.942149285000085, 60.53660716400003],
              [6.953379754000082, 60.537176825000074],
              [6.96265709700009, 60.53937409100007],
              [7.01726321700005, 60.58783600500004],
              [6.98804772200009, 60.589544989000046],
              [6.950205925000091, 60.57489655200004],
              [6.91342207100007, 60.55296458500004],
              [6.887461785000085, 60.533189195000034],
              [6.855967644000089, 60.503241278000075],
              [6.839691602000073, 60.496079820000034],
              [6.772308790000068, 60.48533763200004],
              [6.73609459700009, 60.471136786000045],
              [6.674571160000085, 60.43695709800005],
              [6.656097852000073, 60.43301015800006],
              [6.630056186000047, 60.43105703300006],
              [6.605642123000052, 60.43374258000006],
              [6.592051629000082, 60.443793036000045],
              [6.602305535000085, 60.46523672100005],
              [6.67359459700009, 60.50055573100008],
              [6.69507897200009, 60.51894765800006],
              [6.647715691000087, 60.513006903000075],
              [6.56185957100007, 60.462958075000074],
              [6.513519727000073, 60.45062897300005],
              [6.482920769000089, 60.44749583500004],
              [6.42750084700009, 60.43390534100007],
              [6.397227410000085, 60.43081289300005],
              [6.37086022200009, 60.42462799700007],
              [6.31967207100007, 60.396470445000034],
              [6.297211134000065, 60.38857656500005],
              [6.270762566000087, 60.38963450700004],
              [6.246348504000082, 60.398098049000055],
              [6.225271030000044, 60.41229889500005],
              [6.20834394600007, 60.43081289300005],
              [6.195323113000086, 60.46430084800005],
              [6.188649936000047, 60.471136786000045],
              [6.17750084700009, 60.47101471600007],
              [6.175629102000073, 60.46161530200004],
              [6.179209832000083, 60.449286200000074],
              [6.184825066000087, 60.44037506700005],
              [6.192149285000085, 60.43256256700005],
              [6.211761915000068, 60.405951239000046],
              [6.232269727000073, 60.39516836100006],
              [6.240977410000085, 60.387884833000044],
              [6.239431186000047, 60.378973700000074],
              [6.225433790000068, 60.37396881700005],
              [6.192149285000085, 60.38344961100006],
              [6.165293816000087, 60.37360260600008],
              [6.133067254000082, 60.37327708500004],
              [6.118988477000073, 60.36810944200005],
              [6.134287957000083, 60.36188385600008],
              [6.188649936000047, 60.35504791900007],
              [6.179698113000086, 60.339911200000074],
              [6.151052280000044, 60.32103099200003],
              [6.14031009200005, 60.306626695000034],
              [6.148448113000086, 60.296128648000035],
              [6.153575066000087, 60.29096100500004],
              [6.160655144000089, 60.28620026200008],
              [6.15170332100007, 60.267645575000074],
              [6.139903191000087, 60.254339911000045],
              [6.12476647200009, 60.24673086100006],
              [6.105316602000073, 60.24518463700008],
              [6.083832227000073, 60.25067780200004],
              [6.037119988000086, 60.269598700000074],
              [6.016612175000091, 60.27252838700008],
              [5.996429884000065, 60.264960028000075],
              [5.985606316000087, 60.25055573100008],
              [5.978363477000073, 60.233303127000056],
              [5.968923373000052, 60.217230536000045],
              [5.934092644000089, 60.190619208000044],
              [5.914724155000044, 60.168850002000056],
              [5.906748894000089, 60.16266510600008],
              [5.88998457100007, 60.159816799000055],
              [5.873871290000068, 60.16323476800005],
              [5.860524936000047, 60.16307200700004],
              [5.851573113000086, 60.149603583000044],
              [5.852793816000087, 60.13711172100005],
              [5.87273196700005, 60.087551174000055],
              [5.873383009000065, 60.05093008000006],
              [5.855967644000089, 60.02374909100007],
              [5.824554884000065, 60.007798570000034],
              [5.783864780000044, 60.00495026200008],
              [5.786631707000083, 60.01190827000005],
              [5.79070071700005, 60.01927317900004],
              [5.771657748000052, 60.023504950000074],
              [5.756032748000052, 59.990668036000045],
              [5.739268425000091, 59.99445221600007],
              [5.706065300000091, 60.00885651200008],
              [5.701426629000082, 60.01552969000005],
              [5.699473504000082, 60.02362702000005],
              [5.694834832000083, 60.03066640800006],
              [5.688324415000068, 60.03620026200008],
              [5.68140709700009, 60.03974030200004],
              [5.688649936000047, 60.06085846600007],
              [5.699473504000082, 60.06663646000004],
              [5.735524936000047, 60.060248114000046],
              [5.756521030000044, 60.06037018400008],
              [5.775726759000065, 60.06549713700008],
              [5.790537957000083, 60.076605536000045],
              [5.797536655000044, 60.09438711100006],
              [5.756602410000085, 60.09438711100006],
              [5.750661655000044, 60.092230536000045],
              [5.747243686000047, 60.087551174000055],
              [5.742442254000082, 60.08283112200007],
              [5.732432488000086, 60.08075592700004],
              [5.721202019000089, 60.08388906500005],
              [5.71461022200009, 60.09096914300005],
              [5.709971550000091, 60.09804922100005],
              [5.700205925000091, 60.10390859600005],
              [5.708262566000087, 60.10976797100005],
              [5.725596550000091, 60.11823151200008],
              [5.729177280000044, 60.13239166900007],
              [5.705577019000089, 60.16030508000006],
              [5.708262566000087, 60.17633698100008],
              [5.724782748000052, 60.18659088700008],
              [5.79070071700005, 60.20425039300005],
              [5.79070071700005, 60.21108633000006],
              [5.758067254000082, 60.21002838700008],
              [5.718760613000086, 60.202460028000075],
              [5.681162957000083, 60.190619208000044],
              [5.653575066000087, 60.17633698100008],
              [5.651621941000087, 60.17145416900007],
              [5.650726759000065, 60.15619538000004],
              [5.64616946700005, 60.149603583000044],
              [5.637461785000085, 60.147650458000044],
              [5.617035352000073, 60.14996979400007],
              [5.593028191000087, 60.13857656500005],
              [5.572764519000089, 60.14130280200004],
              [5.55404707100007, 60.15053945500006],
              [5.543711785000085, 60.16266510600008],
              [5.560069207000083, 60.16693756700005],
              [5.574066602000073, 60.17674388200004],
              [5.578135613000086, 60.18797435100004],
              [5.56413821700005, 60.19676341400003],
              [5.56413821700005, 60.20425039300005],
              [5.600271030000044, 60.20600006700005],
              [5.670176629000082, 60.226996161000045],
              [5.708262566000087, 60.23216380400004],
              [5.708262566000087, 60.238348700000074],
              [5.624522332000083, 60.23696523600006],
              [5.598399285000085, 60.23216380400004],
              [5.627289259000065, 60.25263092700004],
              [5.638194207000083, 60.264105536000045],
              [5.633067254000082, 60.27252838700008],
              [5.614756707000083, 60.27216217700004],
              [5.600759311000047, 60.26089101800005],
              [5.58757571700005, 60.24689362200007],
              [5.571543816000087, 60.238348700000074],
              [5.574961785000085, 60.255926825000074],
              [5.586924675000091, 60.26463450700004],
              [5.599782748000052, 60.26947663000004],
              [5.605723504000082, 60.27558014500005],
              [5.611175977000073, 60.284409898000035],
              [5.637461785000085, 60.313666083000044],
              [5.64616946700005, 60.32094961100006],
              [5.647471550000091, 60.32648346600007],
              [5.653005405000044, 60.33690013200004],
              [5.660329623000052, 60.34788646000004],
              [5.667246941000087, 60.35504791900007],
              [5.683767123000052, 60.362209377000056],
              [5.719004754000082, 60.370428778000075],
              [5.732432488000086, 60.378973700000074],
              [5.736582879000082, 60.39203522300005],
              [5.71810957100007, 60.38934967700004],
              [5.695811394000089, 60.38060130400004],
              [5.688243035000085, 60.37555573100008],
              [5.67318769600007, 60.37299225500004],
              [5.660492384000065, 60.366441148000035],
              [5.649587436000047, 60.357489325000074],
              [5.639903191000087, 60.34760163000004],
              [5.638519727000073, 60.35333893400008],
              [5.634287957000083, 60.36245351800005],
              [5.633067254000082, 60.36810944200005],
              [5.617035352000073, 60.35431549700007],
              [5.598887566000087, 60.33344147300005],
              [5.584157748000052, 60.31028880400004],
              [5.57789147200009, 60.28953685100004],
              [5.568207227000073, 60.28188711100006],
              [5.530039910000085, 60.229722398000035],
              [5.526621941000087, 60.217230536000045],
              [5.516449415000068, 60.21328359600005],
              [5.474864129000082, 60.187201239000046],
              [5.438487175000091, 60.17210521000004],
              [5.427012566000087, 60.16266510600008],
              [5.421885613000086, 60.152044989000046],
              [5.417246941000087, 60.138739325000074],
              [5.40984134200005, 60.13133372600004],
              [5.386729363000086, 60.14472077000005],
              [5.351817254000082, 60.15582916900007],
              [5.365896030000044, 60.161444403000075],
              [5.37240644600007, 60.16266510600008],
              [5.37240644600007, 60.17011139500005],
              [5.320160352000073, 60.18195221600007],
              [5.30404707100007, 60.190619208000044],
              [5.312998894000089, 60.19961172100005],
              [5.324880405000044, 60.20526764500005],
              [5.351817254000082, 60.21108633000006],
              [5.351817254000082, 60.217230536000045],
              [5.320811394000089, 60.22174713700008],
              [5.250824415000068, 60.207464911000045],
              [5.222829623000052, 60.21108633000006],
              [5.297129754000082, 60.249212958000044],
              [5.31031334700009, 60.265692450000074],
              [5.276540561000047, 60.264960028000075],
              [5.170664910000085, 60.27871328300006],
              [5.162364129000082, 60.283636786000045],
              [5.161631707000083, 60.294989325000074],
              [5.165537957000083, 60.307928778000075],
              [5.170664910000085, 60.31720612200007],
              [5.18132571700005, 60.32208893400008],
              [5.197520379000082, 60.32282135600008],
              [5.22828209700009, 60.32094961100006],
              [5.211761915000068, 60.33299388200004],
              [5.198741082000083, 60.33836497600004],
              [5.158376498000052, 60.34170156500005],
              [5.147227410000085, 60.343736070000034],
              [5.140961134000065, 60.35138580900008],
              [5.146494988000086, 60.36810944200005],
              [5.177744988000086, 60.38857656500005],
              [5.265635613000086, 60.38703034100007],
              [5.297862175000091, 60.39598216400003],
              [5.283213738000086, 60.40102773600006],
              [5.250173373000052, 60.43081289300005],
              [5.258799675000091, 60.44672272300005],
              [5.263194207000083, 60.45062897300005],
              [5.237071160000085, 60.47378164300005],
              [5.238291863000086, 60.48920319200005],
              [5.280284050000091, 60.522365627000056],
              [5.305837436000047, 60.52826569200005],
              [5.336273634000065, 60.51430898600006],
              [5.365244988000086, 60.49510325700004],
              [5.385996941000087, 60.48541901200008],
              [5.397308790000068, 60.48151276200008],
              [5.448741082000083, 60.44627513200004],
              [5.47624759200005, 60.43504466400003],
              [5.527842644000089, 60.42059967700004],
              [5.573252800000091, 60.414943752000056],
              [5.617686394000089, 60.417181708000044],
              [5.653575066000087, 60.43081289300005],
              [5.649668816000087, 60.44782135600008],
              [5.666514519000089, 60.456366278000075],
              [5.690603061000047, 60.462225653000075],
              [5.708262566000087, 60.471136786000045],
              [5.714040561000047, 60.48427969000005],
              [5.714121941000087, 60.49900950700004],
              [5.708262566000087, 60.533189195000034],
              [5.707204623000052, 60.56281159100007],
              [5.71062259200005, 60.60309479400007],
              [5.721527540000068, 60.63939036700003],
              [5.742930535000085, 60.656683661000045],
              [5.723155144000089, 60.667629299000055],
              [5.725840691000087, 60.68602122600004],
              [5.738617384000065, 60.705145575000074],
              [5.74976647200009, 60.71816640800006],
              [5.72820071700005, 60.70644765800006],
              [5.708506707000083, 60.70258209800005],
              [5.66382897200009, 60.70392487200007],
              [5.66179446700005, 60.71108633000006],
              [5.671397332000083, 60.72711823100008],
              [5.68523196700005, 60.74359772300005],
              [5.695160352000073, 60.75234609600005],
              [5.675629102000073, 60.75775788000004],
              [5.661306186000047, 60.74481842700004],
              [5.647634311000047, 60.72711823100008],
              [5.629649285000085, 60.71816640800006],
              [5.619883660000085, 60.71539948100008],
              [5.60092207100007, 60.70221588700008],
              [5.59156334700009, 60.697699286000045],
              [5.57781009200005, 60.69586823100008],
              [5.533457879000082, 60.697699286000045],
              [5.52320397200009, 60.68691640800006],
              [5.535899285000085, 60.639553127000056],
              [5.526621941000087, 60.62872955900008],
              [5.504567905000044, 60.62710195500006],
              [5.44312584700009, 60.61469147300005],
              [5.37240644600007, 60.58038971600007],
              [5.300059441000087, 60.56077708500004],
              [5.27475019600007, 60.55923086100006],
              [5.250498894000089, 60.56342194200005],
              [5.222829623000052, 60.57416413000004],
              [5.188975457000083, 60.59393952000005],
              [5.160166863000086, 60.61513906500005],
              [5.097666863000086, 60.64911530200004],
              [5.084971550000091, 60.66290924700007],
              [5.123220248000052, 60.660223700000074],
              [5.156911655000044, 60.64899323100008],
              [5.222829623000052, 60.61513906500005],
              [5.22828209700009, 60.62132396000004],
              [5.16179446700005, 60.669989325000074],
              [5.084971550000091, 60.711371161000045],
              [5.101410352000073, 60.71149323100008],
              [5.146494988000086, 60.70392487200007],
              [5.125824415000068, 60.72443268400008],
              [5.094981316000087, 60.72923411700003],
              [5.061371290000068, 60.730902411000045],
              [5.03296959700009, 60.74168528900003],
              [4.985118035000085, 60.77985260600008],
              [4.957774285000085, 60.79393138200004],
              [4.926768425000091, 60.800116278000075],
              [4.951670769000089, 60.80874258000006],
              [4.981455925000091, 60.80878327000005],
              [5.010427280000044, 60.80182526200008],
              [5.05640709700009, 60.778998114000046],
              [5.10914147200009, 60.77374909100007],
              [5.148936394000089, 60.75063711100006],
              [5.176768425000091, 60.74164459800005],
              [5.280121290000068, 60.72182851800005],
              [5.304209832000083, 60.71198151200008],
              [5.30404707100007, 60.697699286000045],
              [5.31031334700009, 60.67601146000004],
              [5.326182488000086, 60.655462958000044],
              [5.347992384000065, 60.64044830900008],
              [5.37240644600007, 60.635646877000056],
              [5.363454623000052, 60.63963450700004],
              [5.356944207000083, 60.64545319200005],
              [5.353037957000083, 60.65306224200003],
              [5.351817254000082, 60.66290924700007],
              [5.373301629000082, 60.654364325000074],
              [5.412282748000052, 60.63312409100007],
              [5.433848504000082, 60.62872955900008],
              [5.418142123000052, 60.64313385600008],
              [5.390472852000073, 60.65961334800005],
              [5.37086022200009, 60.67438385600008],
              [5.379242384000065, 60.684027411000045],
              [5.39389082100007, 60.68073151200008],
              [5.426280144000089, 60.66282786700003],
              [5.433848504000082, 60.66290924700007],
              [5.430918816000087, 60.67377350500004],
              [5.41968834700009, 60.68048737200007],
              [5.410411004000082, 60.688666083000044],
              [5.413340691000087, 60.70392487200007],
              [5.381521030000044, 60.712876695000034],
              [5.37240644600007, 60.71816640800006],
              [5.367686394000089, 60.72532786700003],
              [5.365489129000082, 60.73419830900008],
              [5.362559441000087, 60.74164459800005],
              [5.354991082000083, 60.74481842700004],
              [5.309825066000087, 60.74469635600008],
              [5.284190300000091, 60.747748114000046],
              [5.256602410000085, 60.76032135600008],
              [5.246755405000044, 60.76080963700008],
              [5.238942905000044, 60.76386139500005],
              [5.235850457000083, 60.77619049700007],
              [5.239268425000091, 60.779730536000045],
              [5.263194207000083, 60.792669989000046],
              [5.284353061000047, 60.79954661700003],
              [5.32943769600007, 60.80605703300006],
              [5.351817254000082, 60.81313711100006],
              [5.338145379000082, 60.839829820000034],
              [5.356455925000091, 60.852850653000075],
              [5.430837436000047, 60.86933014500005],
              [5.448008660000085, 60.867621161000045],
              [5.464854363000086, 60.86359284100007],
              [5.481700066000087, 60.86155833500004],
              [5.496918165000068, 60.862941799000055],
              [5.510752800000091, 60.86627838700008],
              [5.53687584700009, 60.87579987200007],
              [5.506846550000091, 60.87718333500004],
              [5.479665561000047, 60.88458893400008],
              [5.470876498000052, 60.896144924000055],
              [5.49586022200009, 60.90997955900008],
              [5.471690300000091, 60.907456773000035],
              [5.399668816000087, 60.882025458000044],
              [5.348399285000085, 60.877834377000056],
              [5.326670769000089, 60.86815013200004],
              [5.31771894600007, 60.84442780200004],
              [5.293223504000082, 60.82273997600004],
              [5.239756707000083, 60.81712474200003],
              [5.187836134000065, 60.82770416900007],
              [5.16765384200005, 60.854681708000044],
              [5.164398634000065, 60.83087799700007],
              [5.149261915000068, 60.81492747600004],
              [5.131032748000052, 60.81207916900007],
              [5.118418816000087, 60.827378648000035],
              [5.132823113000086, 60.834865627000056],
              [5.113536004000082, 60.83779531500005],
              [5.066661004000082, 60.83454010600008],
              [5.047129754000082, 60.84442780200004],
              [5.040049675000091, 60.85614655200004],
              [5.028575066000087, 60.885931708000044],
              [5.019541863000086, 60.89907461100006],
              [5.013519727000073, 60.905178127000056],
              [5.010508660000085, 60.909816799000055],
              [5.00945071700005, 60.916001695000034],
              [5.009287957000083, 60.92670319200005],
              [5.005137566000087, 60.931301174000055],
              [4.986501498000052, 60.94375234600005],
              [4.981944207000083, 60.950873114000046],
              [4.990570509000065, 60.96246979400007],
              [5.011973504000082, 60.96503327000005],
              [5.037119988000086, 60.96234772300005],
              [5.057139519000089, 60.95770905200004],
              [5.077403191000087, 60.949652411000045],
              [5.082774285000085, 60.94090403900003],
              [5.078135613000086, 60.90619538000004],
              [5.082367384000065, 60.88882070500006],
              [5.09156334700009, 60.87787506700005],
              [5.100759311000047, 60.87775299700007],
              [5.10482832100007, 60.892564195000034],
              [5.096202019000089, 60.93891022300005],
              [5.098643425000091, 60.950873114000046],
              [5.114105665000068, 60.96185944200005],
              [5.131358269000089, 60.96552155200004],
              [5.142832879000082, 60.97215403900003],
              [5.14031009200005, 60.991888739000046],
              [5.134043816000087, 60.98883698100008],
              [5.131358269000089, 60.986761786000045],
              [5.132823113000086, 60.985663153000075],
              [5.120941602000073, 60.98379140800006],
              [5.093272332000083, 60.97378164300005],
              [5.07789147200009, 60.97138092700004],
              [5.023610873000052, 60.978216864000046],
              [5.012705925000091, 60.98191966400003],
              [5.004730665000068, 60.99754466400003],
              [5.003916863000086, 61.016058661000045],
              [5.008067254000082, 61.033636786000045],
              [5.016123894000089, 61.046535549000055],
              [5.068614129000082, 61.073553778000075],
              [5.135101759000065, 61.07672760600008],
              [5.202159050000091, 61.06476471600007],
              [5.281423373000052, 61.03847890800006],
              [5.31226647200009, 61.03217194200005],
              [5.375824415000068, 61.026597398000035],
              [5.421071811000047, 61.02912018400008],
              [5.433848504000082, 61.026597398000035],
              [5.439463738000086, 61.01788971600007],
              [5.442637566000087, 61.00454336100006],
              [5.448415561000047, 60.995428778000075],
              [5.461680535000085, 60.999335028000075],
              [5.467051629000082, 61.00739166900007],
              [5.463633660000085, 61.01593659100007],
              [5.457530144000089, 61.025458075000074],
              [5.454274936000047, 61.03656647300005],
              [5.460215691000087, 61.049994208000044],
              [5.473643425000091, 61.055894273000035],
              [5.488536004000082, 61.059027411000045],
              [5.52711022200009, 61.075425523000035],
              [5.566742384000065, 61.071519273000035],
              [5.607920769000089, 61.06281159100007],
              [5.639903191000087, 61.06012604400007],
              [5.639903191000087, 61.067572333000044],
              [5.610606316000087, 61.078558661000045],
              [5.597666863000086, 61.085150458000044],
              [5.602061394000089, 61.08808014500005],
              [5.638682488000086, 61.093451239000046],
              [5.656260613000086, 61.09414297100005],
              [5.674001498000052, 61.08808014500005],
              [5.696462436000047, 61.09878164300005],
              [5.73609459700009, 61.10993073100008],
              [5.773936394000089, 61.114447333000044],
              [5.79070071700005, 61.10488515800006],
              [5.78101647200009, 61.07713450700004],
              [5.78093509200005, 61.06435781500005],
              [5.794118686000047, 61.07070547100005],
              [5.804698113000086, 61.07916901200008],
              [5.817637566000087, 61.08673737200007],
              [5.831553582000083, 61.092230536000045],
              [5.84538821700005, 61.09430573100008],
              [5.83529707100007, 61.10541413000004],
              [5.83171634200005, 61.108587958000044],
              [5.863617384000065, 61.11786530200004],
              [5.892751498000052, 61.12177155200004],
              [5.976573113000086, 61.120794989000046],
              [6.010996941000087, 61.11497630400004],
              [6.030446811000047, 61.11473216400003],
              [6.098480665000068, 61.12221914300005],
              [6.131846550000091, 61.11863841400003],
              [6.19507897200009, 61.10431549700007],
              [6.229502800000091, 61.10114166900007],
              [6.258067254000082, 61.093817450000074],
              [6.270762566000087, 61.07709381700005],
              [6.266286655000044, 61.05874258000006],
              [6.242523634000065, 61.046535549000055],
              [6.27475019600007, 61.04791901200008],
              [6.287445509000065, 61.05304596600007],
              [6.300954623000052, 61.06386953300006],
              [6.312022332000083, 61.06850820500006],
              [6.329356316000087, 61.07046133000006],
              [6.347178582000083, 61.07005442900004],
              [6.359222852000073, 61.067572333000044],
              [6.370290561000047, 61.056301174000055],
              [6.362803582000083, 61.04441966400003],
              [6.348317905000044, 61.03042226800005],
              [6.338715040000068, 61.01235586100006],
              [6.355967644000089, 61.010931708000044],
              [6.372894727000073, 61.01235586100006],
              [6.369965040000068, 61.026597398000035],
              [6.374522332000083, 61.03742096600007],
              [6.383474155000044, 61.04604726800005],
              [6.413259311000047, 61.06818268400008],
              [6.437673373000052, 61.081244208000044],
              [6.465098504000082, 61.09064362200007],
              [6.521820509000065, 61.09650299700007],
              [6.545664910000085, 61.10407135600008],
              [6.566416863000086, 61.11888255400004],
              [6.585785352000073, 61.14272695500006],
              [6.594004754000082, 61.16665273600006],
              [6.600596550000091, 61.17523834800005],
              [6.612803582000083, 61.17373281500005],
              [6.636241082000083, 61.161810614000046],
              [6.648448113000086, 61.157456773000035],
              [6.78679446700005, 61.15033600500004],
              [6.836680535000085, 61.13934967700004],
              [6.847911004000082, 61.134833075000074],
              [6.856211785000085, 61.128119208000044],
              [6.859548373000052, 61.118475653000075],
              [6.859711134000065, 61.10614655200004],
              [6.861827019000089, 61.09650299700007],
              [6.868174675000091, 61.090277411000045],
              [6.88062584700009, 61.08808014500005],
              [6.938975457000083, 61.09137604400007],
              [6.955821160000085, 61.08808014500005],
              [6.965017123000052, 61.08026764500005],
              [6.983083530000044, 61.046535549000055],
              [6.99968509200005, 61.028998114000046],
              [7.006846550000091, 61.01935455900008],
              [7.009776238000086, 61.00893789300005],
              [7.003184441000087, 61.00031159100007],
              [6.98796634200005, 60.99017975500004],
              [6.970957879000082, 60.981675523000035],
              [6.939300977000073, 60.97321198100008],
              [6.873789910000085, 60.93724192900004],
              [6.965017123000052, 60.96552155200004],
              [7.010996941000087, 60.971136786000045],
              [7.051442905000044, 60.964544989000046],
              [7.11459394600007, 60.93935781500005],
              [7.130137566000087, 60.92670319200005],
              [7.131602410000085, 60.912176825000074],
              [7.105967644000089, 60.86155833500004],
              [7.131602410000085, 60.87531159100007],
              [7.157481316000087, 60.89744700700004],
              [7.17156009200005, 60.92401764500005],
              [7.161306186000047, 60.950873114000046],
              [7.152598504000082, 60.95343659100007],
              [7.100596550000091, 60.95945872600004],
              [7.09351647200009, 60.96381256700005],
              [7.082041863000086, 60.97479889500005],
              [7.043955925000091, 61.026597398000035],
              [7.034190300000091, 61.03538646000004],
              [7.02312259200005, 61.043036200000074],
              [7.013845248000052, 61.05174388200004],
              [7.005707227000073, 61.07908763200004],
              [6.999522332000083, 61.087144273000035],
              [7.000336134000065, 61.09292226800005],
              [7.01726321700005, 61.10114166900007],
              [7.059743686000047, 61.10700104400007],
              [7.166270379000082, 61.11005280200004],
              [7.195323113000086, 61.12909577000005],
              [7.209239129000082, 61.13882070500006],
              [7.222666863000086, 61.14036692900004],
              [7.30445397200009, 61.13027578300006],
              [7.315440300000091, 61.12563711100006],
              [7.338389519000089, 61.11200592700004],
              [7.369151238000086, 61.104681708000044],
              [7.435557488000086, 61.10114166900007],
              [7.435557488000086, 61.108587958000044],
              [7.41732832100007, 61.109442450000074],
              [7.40365644600007, 61.11196523600006],
              [7.39226321700005, 61.11627838700008],
              [7.356455925000091, 61.138006903000075],
              [7.346202019000089, 61.14272695500006],
              [7.359711134000065, 61.15216705900008],
              [7.405284050000091, 61.16742584800005],
              [7.415049675000091, 61.17373281500005],
              [7.427012566000087, 61.18585846600007],
              [7.454356316000087, 61.19277578300006],
              [7.606211785000085, 61.19830963700008],
              [7.655284050000091, 61.20685455900008],
              [7.69499759200005, 61.232082424000055],
              [7.660329623000052, 61.22988515800006],
              [7.633555535000085, 61.224595445000034],
              [7.600352410000085, 61.21234772300005],
              [7.449229363000086, 61.197333075000074],
              [7.38843834700009, 61.19818756700005],
              [7.358897332000083, 61.20563385600008],
              [7.346202019000089, 61.22150299700007],
              [7.34506269600007, 61.232855536000045],
              [7.340505405000044, 61.252386786000045],
              [7.339366082000083, 61.26251862200007],
              [7.33570397200009, 61.27435944200005],
              [7.327403191000087, 61.278998114000046],
              [7.318207227000073, 61.28164297100005],
              [7.312022332000083, 61.28729889500005],
              [7.31381269600007, 61.30841705900008],
              [7.355804884000065, 61.326239325000074],
              [7.36654707100007, 61.34471263200004],
              [7.370290561000047, 61.36709219000005],
              [7.380707227000073, 61.37832265800006],
              [7.42123457100007, 61.39594147300005],
              [7.436778191000087, 61.40851471600007],
              [7.451508009000065, 61.42462799700007],
              [7.467539910000085, 61.43846263200004],
              [7.486827019000089, 61.44432200700004],
              [7.510752800000091, 61.447699286000045],
              [7.535655144000089, 61.45652903900003],
              [7.557383660000085, 61.469631252000056],
              [7.57203209700009, 61.48533763200004],
              [7.488617384000065, 61.46043528900003],
              [7.346202019000089, 61.389105536000045],
              [7.323741082000083, 61.386053778000075],
              [7.285329623000052, 61.394517320000034],
              [7.263682488000086, 61.39594147300005],
              [7.281586134000065, 61.38336823100008],
              [7.299001498000052, 61.37409088700008],
              [7.308848504000082, 61.36383698100008],
              [7.305186394000089, 61.34813060100004],
              [7.244965040000068, 61.30805084800005],
              [7.239756707000083, 61.29726797100005],
              [7.259613477000073, 61.283270575000074],
              [7.28101647200009, 61.27374909100007],
              [7.29818769600007, 61.26056549700007],
              [7.30990644600007, 61.21759674700007],
              [7.322520379000082, 61.20538971600007],
              [7.340098504000082, 61.19717031500005],
              [7.359711134000065, 61.191107489000046],
              [7.319346550000091, 61.16738515800006],
              [7.305186394000089, 61.16323476800005],
              [7.292246941000087, 61.16242096600007],
              [7.280528191000087, 61.163763739000046],
              [7.257334832000083, 61.169989325000074],
              [7.250254754000082, 61.173041083000044],
              [7.235362175000091, 61.18146393400008],
              [7.229502800000091, 61.183661200000074],
              [7.213715040000068, 61.183661200000074],
              [7.17514082100007, 61.175848700000074],
              [7.161306186000047, 61.169989325000074],
              [7.158702019000089, 61.16648997600004],
              [7.156748894000089, 61.16083405200004],
              [7.153493686000047, 61.15460846600007],
              [7.147471550000091, 61.14956289300005],
              [7.137217644000089, 61.145697333000044],
              [7.009776238000086, 61.12909577000005],
              [6.973480665000068, 61.11579010600008],
              [6.953135613000086, 61.11163971600007],
              [6.93531334700009, 61.11473216400003],
              [6.917246941000087, 61.13629791900007],
              [6.941661004000082, 61.152329820000034],
              [6.979991082000083, 61.16681549700007],
              [7.00359134200005, 61.183661200000074],
              [6.95053144600007, 61.167222398000035],
              [6.922211134000065, 61.16201406500005],
              [6.89429772200009, 61.16323476800005],
              [6.810069207000083, 61.181626695000034],
              [6.664724155000044, 61.19513580900008],
              [6.557871941000087, 61.224595445000034],
              [6.56999759200005, 61.24079010600008],
              [6.60678144600007, 61.257473049000055],
              [6.623057488000086, 61.26935455900008],
              [6.660329623000052, 61.32086823100008],
              [6.668223504000082, 61.32697174700007],
              [6.690440300000091, 61.34052155200004],
              [6.69507897200009, 61.34471263200004],
              [6.696299675000091, 61.35211823100008],
              [6.702403191000087, 61.371527411000045],
              [6.705332879000082, 61.37547435100004],
              [6.710459832000083, 61.38031647300005],
              [6.715586785000085, 61.390692450000074],
              [6.71461022200009, 61.40029531500005],
              [6.701914910000085, 61.402777411000045],
              [6.697438998000052, 61.39935944200005],
              [6.636892123000052, 61.30955638200004],
              [6.603363477000073, 61.27875397300005],
              [6.564707879000082, 61.265611070000034],
              [6.552989129000082, 61.26894765800006],
              [6.537445509000065, 61.28388092700004],
              [6.52711022200009, 61.28729889500005],
              [6.51929772200009, 61.28400299700007],
              [6.50912519600007, 61.27643463700008],
              [6.501149936000047, 61.26813385600008],
              [6.499522332000083, 61.26251862200007],
              [6.51343834700009, 61.24746328300006],
              [6.523773634000065, 61.232082424000055],
              [6.524261915000068, 61.22675202000005],
              [6.523448113000086, 61.219956773000035],
              [6.526215040000068, 61.21234772300005],
              [6.537364129000082, 61.20416901200008],
              [6.470957879000082, 61.21124909100007],
              [6.465098504000082, 61.20758698100008],
              [6.475759311000047, 61.201605536000045],
              [6.48804772200009, 61.19794342700004],
              [6.498301629000082, 61.19232819200005],
              [6.502696160000085, 61.180568752000056],
              [6.504649285000085, 61.16693756700005],
              [6.50749759200005, 61.15643952000005],
              [6.506195509000065, 61.14695872600004],
              [6.496429884000065, 61.13646067900004],
              [6.484711134000065, 61.13076406500005],
              [6.434336785000085, 61.11473216400003],
              [6.372325066000087, 61.11408112200007],
              [6.282725457000083, 61.125433661000045],
              [6.203949415000068, 61.14866771000004],
              [6.174327019000089, 61.183661200000074],
              [6.130137566000087, 61.15932851800005],
              [6.073496941000087, 61.14801666900007],
              [6.014008009000065, 61.14948151200008],
              [5.961436394000089, 61.16323476800005],
              [6.006602410000085, 61.17804596600007],
              [6.027842644000089, 61.18813711100006],
              [6.037119988000086, 61.20416901200008],
              [5.940928582000083, 61.169989325000074],
              [5.874522332000083, 61.15835195500006],
              [5.80445397200009, 61.15574778900003],
              [5.783457879000082, 61.16498444200005],
              [5.781748894000089, 61.18317291900007],
              [5.78296959700009, 61.196600653000075],
              [5.770274285000085, 61.191107489000046],
              [5.763194207000083, 61.18187083500004],
              [5.758799675000091, 61.16380442900004],
              [5.74976647200009, 61.15574778900003],
              [5.736664259000065, 61.15477122600004],
              [5.71843509200005, 61.15656159100007],
              [5.702159050000091, 61.155503648000035],
              [5.695160352000073, 61.146144924000055],
              [5.675954623000052, 61.142279364000046],
              [5.557302280000044, 61.13646067900004],
              [5.53687584700009, 61.131293036000045],
              [5.475433790000068, 61.09430573100008],
              [5.423675977000073, 61.07965729400007],
              [5.37663821700005, 61.08047109600005],
              [5.334483269000089, 61.096869208000044],
              [5.297862175000091, 61.12909577000005],
              [5.28101647200009, 61.116115627000056],
              [5.259938998000052, 61.10984935100004],
              [5.204925977000073, 61.10736725500004],
              [5.199392123000052, 61.10504791900007],
              [5.193858269000089, 61.10529205900008],
              [5.184336785000085, 61.11163971600007],
              [5.174652540000068, 61.12221914300005],
              [5.169444207000083, 61.126166083000044],
              [5.160166863000086, 61.12909577000005],
              [5.169932488000086, 61.139960028000075],
              [5.188324415000068, 61.140611070000034],
              [5.209646030000044, 61.13890208500004],
              [5.22828209700009, 61.14272695500006],
              [5.205332879000082, 61.14695872600004],
              [5.182871941000087, 61.153957424000055],
              [5.16187584700009, 61.15619538000004],
              [5.143321160000085, 61.146144924000055],
              [5.125173373000052, 61.14508698100008],
              [5.059255405000044, 61.157904364000046],
              [5.044118686000047, 61.16323476800005],
              [5.059336785000085, 61.18797435100004],
              [5.118174675000091, 61.185980536000045],
              [5.222829623000052, 61.16323476800005],
              [5.220550977000073, 61.167669989000046],
              [5.216807488000086, 61.179022528000075],
              [5.214691602000073, 61.183661200000074],
              [5.250173373000052, 61.183661200000074],
              [5.197276238000086, 61.21088288000004],
              [5.167816602000073, 61.220770575000074],
              [5.139659050000091, 61.224595445000034],
              [5.020762566000087, 61.216498114000046],
              [4.988780144000089, 61.224595445000034],
              [5.008148634000065, 61.22943756700005],
              [5.031504754000082, 61.230454820000034],
              [5.052256707000083, 61.23379140800006],
              [5.064463738000086, 61.245754299000055],
              [5.03101647200009, 61.237941799000055],
              [5.012950066000087, 61.23663971600007],
              [4.999034050000091, 61.24233633000006],
              [4.989512566000087, 61.25234609600005],
              [4.982758009000065, 61.25698476800005],
              [4.973155144000089, 61.25682200700004],
              [4.954600457000083, 61.25259023600006],
              [4.964121941000087, 61.265692450000074],
              [4.979991082000083, 61.27533600500004],
              [5.016123894000089, 61.28729889500005],
              [5.039724155000044, 61.291896877000056],
              [5.063975457000083, 61.29352448100008],
              [5.07398522200009, 61.29572174700007],
              [5.090179884000065, 61.30508047100005],
              [5.095225457000083, 61.30719635600008],
              [5.139414910000085, 61.306301174000055],
              [5.159353061000047, 61.31110260600008],
              [5.177744988000086, 61.33942291900007],
              [5.201508009000065, 61.34271881700005],
              [5.229014519000089, 61.33942291900007],
              [5.250173373000052, 61.33445872600004],
              [5.266286655000044, 61.32868073100008],
              [5.279307488000086, 61.32135651200008],
              [5.289561394000089, 61.31224192900004],
              [5.297862175000091, 61.30097077000005],
              [5.31023196700005, 61.266913153000075],
              [5.320648634000065, 61.25226471600007],
              [5.334483269000089, 61.25600820500006],
              [5.337412957000083, 61.268744208000044],
              [5.334157748000052, 61.28733958500004],
              [5.32748457100007, 61.30573151200008],
              [5.320811394000089, 61.31745026200008],
              [5.305511915000068, 61.32843659100007],
              [5.271820509000065, 61.33869049700007],
              [5.256358269000089, 61.34813060100004],
              [5.440603061000047, 61.36741771000004],
              [5.633067254000082, 61.36180247600004],
              [5.599619988000086, 61.37592194200005],
              [5.554535352000073, 61.37832265800006],
              [5.164317254000082, 61.35610586100006],
              [5.15015709700009, 61.351548570000034],
              [5.127940300000091, 61.33978913000004],
              [5.093272332000083, 61.32880280200004],
              [5.058441602000073, 61.323472398000035],
              [5.036631707000083, 61.32831452000005],
              [5.025726759000065, 61.339544989000046],
              [5.006358269000089, 61.34747955900008],
              [4.995616082000083, 61.36180247600004],
              [4.998789910000085, 61.37689850500004],
              [5.01148522200009, 61.39154694200005],
              [5.028330925000091, 61.401556708000044],
              [5.044118686000047, 61.402777411000045],
              [5.054698113000086, 61.39288971600007],
              [5.057871941000087, 61.38068268400008],
              [5.062673373000052, 61.37457916900007],
              [5.078135613000086, 61.38296133000006],
              [5.07943769600007, 61.38808828300006],
              [5.077159050000091, 61.40468984600005],
              [5.078135613000086, 61.410223700000074],
              [5.085459832000083, 61.41351959800005],
              [5.118418816000087, 61.41640859600005],
              [5.117523634000065, 61.421087958000044],
              [5.11654707100007, 61.42401764500005],
              [5.114756707000083, 61.42682526200008],
              [5.111664259000065, 61.43073151200008],
              [5.092458530000044, 61.42023346600007],
              [5.071462436000047, 61.41705963700008],
              [5.029144727000073, 61.41640859600005],
              [4.989105665000068, 61.41111888200004],
              [4.947927280000044, 61.410223700000074],
              [4.947927280000044, 61.41640859600005],
              [5.057139519000089, 61.44432200700004],
              [5.16342207100007, 61.450832424000055],
              [5.187998894000089, 61.464829820000034],
              [5.180511915000068, 61.472316799000055],
              [5.21810957100007, 61.46784088700008],
              [5.266286655000044, 61.45530833500004],
              [5.310801629000082, 61.44940827000005],
              [5.33757571700005, 61.464829820000034],
              [5.483897332000083, 61.431708075000074],
              [5.51889082100007, 61.430121161000045],
              [5.543711785000085, 61.43695709800005],
              [5.53687584700009, 61.44432200700004],
              [5.556651238000086, 61.44977448100008],
              [5.59937584700009, 61.45258209800005],
              [5.619395379000082, 61.45799388200004],
              [5.62859134200005, 61.46474844000005],
              [5.638519727000073, 61.473822333000044],
              [5.650889519000089, 61.48187897300005],
              [5.667246941000087, 61.48533763200004],
              [5.71265709700009, 61.48712799700007],
              [5.73601321700005, 61.48460521000004],
              [5.752777540000068, 61.47573476800005],
              [5.770355665000068, 61.455145575000074],
              [5.78256269600007, 61.45058828300006],
              [5.80445397200009, 61.451157945000034],
              [5.80445397200009, 61.45799388200004],
              [5.781748894000089, 61.46564362200007],
              [5.746755405000044, 61.49298737200007],
              [5.72242272200009, 61.49896881700005],
              [5.665049675000091, 61.49835846600007],
              [5.637868686000047, 61.49437083500004],
              [5.611989780000044, 61.48533763200004],
              [5.583506707000083, 61.46743398600006],
              [5.574717644000089, 61.464829820000034],
              [5.523610873000052, 61.46466705900008],
              [5.49195397200009, 61.454006252000056],
              [5.460948113000086, 61.452826239000046],
              [5.437998894000089, 61.46043528900003],
              [5.441254102000073, 61.47915273600006],
              [5.39779707100007, 61.48688385600008],
              [5.290293816000087, 61.47964101800005],
              [5.253184441000087, 61.49526601800005],
              [5.178233269000089, 61.509751695000034],
              [5.138926629000082, 61.52411530200004],
              [5.146494988000086, 61.53998444200005],
              [5.140798373000052, 61.54682038000004],
              [5.14031009200005, 61.54682038000004],
              [5.14031009200005, 61.55418528900003],
              [5.156586134000065, 61.55451080900008],
              [5.201670769000089, 61.54682038000004],
              [5.214040561000047, 61.54767487200007],
              [5.246429884000065, 61.55418528900003],
              [5.358164910000085, 61.55418528900003],
              [5.358164910000085, 61.56102122600004],
              [5.33139082100007, 61.56126536700003],
              [5.172048373000052, 61.58551666900007],
              [5.146494988000086, 61.59520091400003],
              [5.33757571700005, 61.59520091400003],
              [5.31812584700009, 61.589829820000034],
              [5.31031334700009, 61.58893463700008],
              [5.31031334700009, 61.58218008000006],
              [5.402598504000082, 61.58030833500004],
              [5.427012566000087, 61.58893463700008],
              [5.350433790000068, 61.60651276200008],
              [5.270030144000089, 61.615668036000045],
              [5.320160352000073, 61.62872955900008],
              [5.340668165000068, 61.64313385600008],
              [5.283702019000089, 61.64232005400004],
              [5.24187259200005, 61.63068268400008],
              [5.229258660000085, 61.62872955900008],
              [4.992686394000089, 61.63043854400007],
              [4.968272332000083, 61.63613515800006],
              [4.962412957000083, 61.64175039300005],
              [4.944102410000085, 61.667181708000044],
              [4.939626498000052, 61.67837148600006],
              [4.946055535000085, 61.687486070000034],
              [4.957692905000044, 61.69407786700003],
              [4.968272332000083, 61.69765859600005],
              [4.960459832000083, 61.706691799000055],
              [4.962738477000073, 61.71710846600007],
              [4.972911004000082, 61.72479889500005],
              [4.988780144000089, 61.72553131700005],
              [4.985362175000091, 61.72955963700008],
              [4.983409050000091, 61.73273346600007],
              [4.980642123000052, 61.735581773000035],
              [4.974457227000073, 61.73859284100007],
              [4.988129102000073, 61.74689362200007],
              [5.003428582000083, 61.75112539300005],
              [5.036631707000083, 61.75218333500004],
              [5.053965691000087, 61.75039297100005],
              [5.070648634000065, 61.74603913000004],
              [5.07553144600007, 61.74286530200004],
              [5.076833530000044, 61.73867422100005],
              [5.076833530000044, 61.73468659100007],
              [5.078135613000086, 61.73236725500004],
              [5.084646030000044, 61.731756903000075],
              [5.098887566000087, 61.733587958000044],
              [5.10482832100007, 61.73236725500004],
              [5.121918165000068, 61.72028229400007],
              [5.125987175000091, 61.718085028000075],
              [5.137380405000044, 61.71694570500006],
              [5.14616946700005, 61.71759674700007],
              [5.16765384200005, 61.72553131700005],
              [5.135508660000085, 61.743801174000055],
              [5.125987175000091, 61.75218333500004],
              [5.148285352000073, 61.75926341400003],
              [5.190196160000085, 61.76894765800006],
              [5.064463738000086, 61.75971100500004],
              [5.078949415000068, 61.77374909100007],
              [5.103851759000065, 61.78538646000004],
              [5.131602410000085, 61.79441966400003],
              [5.244476759000065, 61.817287502000056],
              [5.270030144000089, 61.82794830900008],
              [5.26539147200009, 61.82925039300005],
              [5.262705925000091, 61.83075592700004],
              [5.256358269000089, 61.83539459800005],
              [5.295746290000068, 61.84088776200008],
              [5.33757571700005, 61.84162018400008],
              [5.320485873000052, 61.847723700000074],
              [5.303233269000089, 61.848863023000035],
              [5.291514519000089, 61.85150788000004],
              [5.29037519600007, 61.86212799700007],
              [5.296885613000086, 61.868353583000044],
              [5.362559441000087, 61.905462958000044],
              [5.394786004000082, 61.91107819200005],
              [5.487803582000083, 61.907863674000055],
              [5.522308790000068, 61.898871161000045],
              [5.540293816000087, 61.89687734600005],
              [5.580739780000044, 61.89980703300006],
              [5.600271030000044, 61.89911530200004],
              [5.63648522200009, 61.88886139500005],
              [5.675791863000086, 61.88694896000004],
              [5.691416863000086, 61.879787502000056],
              [5.716075066000087, 61.86163971600007],
              [5.742930535000085, 61.84845612200007],
              [5.71265709700009, 61.84056224200003],
              [5.675303582000083, 61.839829820000034],
              [5.640798373000052, 61.83510976800005],
              [5.619395379000082, 61.81492747600004],
              [5.647146030000044, 61.81525299700007],
              [5.735524936000047, 61.83539459800005],
              [5.922618035000085, 61.85028717700004],
              [5.940928582000083, 61.845038153000075],
              [5.946299675000091, 61.83734772300005],
              [5.943207227000073, 61.82684967700004],
              [5.93726647200009, 61.81525299700007],
              [5.92709394600007, 61.782416083000044],
              [5.90015709700009, 61.75063711100006],
              [5.899261915000068, 61.73859284100007],
              [5.916351759000065, 61.75169505400004],
              [5.930023634000065, 61.759426174000055],
              [5.942230665000068, 61.76870351800005],
              [5.954600457000083, 61.78701406500005],
              [5.964366082000083, 61.82005442900004],
              [5.972911004000082, 61.83112213700008],
              [5.992035352000073, 61.83539459800005],
              [6.010264519000089, 61.83120351800005],
              [6.058929884000065, 61.808294989000046],
              [6.098643425000091, 61.77887604400007],
              [6.123383009000065, 61.76992422100005],
              [6.181162957000083, 61.76654694200005],
              [6.170909050000091, 61.780462958000044],
              [6.155039910000085, 61.78579336100006],
              [6.137705925000091, 61.789129950000074],
              [6.12281334700009, 61.796861070000034],
              [6.109385613000086, 61.80801015800006],
              [6.092621290000068, 61.81785716400003],
              [6.074880405000044, 61.82493724200003],
              [6.057627800000091, 61.82794830900008],
              [6.057627800000091, 61.83539459800005],
              [6.29070071700005, 61.83539459800005],
              [6.313243035000085, 61.83104075700004],
              [6.359222852000073, 61.811835028000075],
              [6.383799675000091, 61.80744049700007],
              [6.473806186000047, 61.80463288000004],
              [6.502696160000085, 61.80744049700007],
              [6.521332227000073, 61.81419505400004],
              [6.533213738000086, 61.82453034100007],
              [6.55046634200005, 61.84845612200007],
              [6.56812584700009, 61.86237213700008],
              [6.58961022200009, 61.87083567900004],
              [6.613780144000089, 61.87518952000005],
              [6.640147332000083, 61.87641022300005],
              [6.66732832100007, 61.87319570500006],
              [6.720957879000082, 61.859076239000046],
              [6.746348504000082, 61.85586172100005],
              [6.75562584700009, 61.852443752000056],
              [6.766449415000068, 61.84564850500004],
              [6.777679884000065, 61.84125397300005],
              [6.787445509000065, 61.845038153000075],
              [6.802012566000087, 61.85976797100005],
              [6.809743686000047, 61.86542389500005],
              [6.818614129000082, 61.869574286000045],
              [6.818614129000082, 61.87641022300005],
              [6.80209394600007, 61.87604401200008],
              [6.771006707000083, 61.870306708000044],
              [6.756846550000091, 61.87299225500004],
              [6.742523634000065, 61.877386786000045],
              [6.69507897200009, 61.88320547100005],
              [6.690196160000085, 61.88617584800005],
              [6.683767123000052, 61.894964911000045],
              [6.677989129000082, 61.89687734600005],
              [6.671722852000073, 61.895697333000044],
              [6.662282748000052, 61.89057038000004],
              [6.657237175000091, 61.88939036700003],
              [6.555511915000068, 61.87832265800006],
              [6.53842207100007, 61.86627838700008],
              [6.525889519000089, 61.85073476800005],
              [6.510101759000065, 61.83539459800005],
              [6.47624759200005, 61.82534414300005],
              [6.258555535000085, 61.85626862200007],
              [6.09546959700009, 61.84845612200007],
              [6.081879102000073, 61.851223049000055],
              [6.037119988000086, 61.869574286000045],
              [6.018402540000068, 61.87103913000004],
              [5.961436394000089, 61.869574286000045],
              [5.906993035000085, 61.88153717700004],
              [5.886241082000083, 61.88320547100005],
              [5.871836785000085, 61.88104889500005],
              [5.84310957100007, 61.87164948100008],
              [5.828623894000089, 61.869574286000045],
              [5.822520379000082, 61.86741771000004],
              [5.81031334700009, 61.85822174700007],
              [5.80445397200009, 61.85586172100005],
              [5.796397332000083, 61.85736725500004],
              [5.729258660000085, 61.88939036700003],
              [5.729258660000085, 61.89687734600005],
              [5.93327884200005, 61.90302155200004],
              [5.961436394000089, 61.909857489000046],
              [5.961436394000089, 61.91669342700004],
              [5.645355665000068, 61.92479075700004],
              [5.516612175000091, 61.93813711100006],
              [5.450205925000091, 61.92519765800006],
              [5.443614129000082, 61.92918528900003],
              [5.43726647200009, 61.93496328300006],
              [5.427012566000087, 61.93781159100007],
              [5.34896894600007, 61.92731354400007],
              [5.301931186000047, 61.913397528000075],
              [5.276866082000083, 61.909857489000046],
              [5.221527540000068, 61.91437409100007],
              [5.193695509000065, 61.91233958500004],
              [5.170664910000085, 61.89996979400007],
              [5.155772332000083, 61.89606354400007],
              [5.135264519000089, 61.90131256700005],
              [5.098643425000091, 61.91669342700004],
              [5.113780144000089, 61.93008047100005],
              [5.125987175000091, 61.94403717700004],
              [5.14039147200009, 61.967962958000044],
              [5.14031009200005, 61.97134023600006],
              [5.155528191000087, 61.97601959800005],
              [5.16146894600007, 61.97138092700004],
              [5.165049675000091, 61.96352773600006],
              [5.173838738000086, 61.958319403000075],
              [5.183929884000065, 61.95954010600008],
              [5.190196160000085, 61.96442291900007],
              [5.195160352000073, 61.96954987200007],
              [5.201670769000089, 61.97134023600006],
              [5.210215691000087, 61.96865469000005],
              [5.223643425000091, 61.95990631700005],
              [5.22828209700009, 61.958319403000075],
              [5.238617384000065, 61.960638739000046],
              [5.240244988000086, 61.964911200000074],
              [5.241221550000091, 61.97101471600007],
              [5.250173373000052, 61.97874583500004],
              [5.288910352000073, 61.99274323100008],
              [5.301524285000085, 62.00287506700005],
              [5.31031334700009, 62.026556708000044],
              [5.339040561000047, 62.019232489000046],
              [5.37671959700009, 62.016058661000045],
              [5.40015709700009, 62.02000560100004],
              [5.385996941000087, 62.03400299700007],
              [5.371918165000068, 62.036810614000046],
              [5.340993686000047, 62.03685130400004],
              [5.327647332000083, 62.04393138200004],
              [5.313324415000068, 62.05711497600004],
              [5.297862175000091, 62.06818268400008],
              [5.208506707000083, 62.10228099200003],
              [5.10914147200009, 62.10911692900004],
              [5.091807488000086, 62.122748114000046],
              [5.101573113000086, 62.12299225500004],
              [5.109711134000065, 62.12445709800005],
              [5.125987175000091, 62.12958405200004],
              [5.11109459700009, 62.13979726800005],
              [5.080251498000052, 62.15249258000006],
              [5.070648634000065, 62.163763739000046],
              [5.076426629000082, 62.164943752000056],
              [5.086436394000089, 62.169134833000044],
              [5.091807488000086, 62.17059967700004],
              [5.088145379000082, 62.17365143400008],
              [5.08179772200009, 62.18109772300005],
              [5.078135613000086, 62.18423086100006],
              [5.082367384000065, 62.183661200000074],
              [5.084157748000052, 62.184800523000035],
              [5.084971550000091, 62.191066799000055],
              [5.096202019000089, 62.19354889500005],
              [5.125987175000091, 62.191066799000055],
              [5.130869988000086, 62.19163646000004],
              [5.141449415000068, 62.19049713700008],
              [5.146494988000086, 62.191066799000055],
              [5.146739129000082, 62.19330475500004],
              [5.146006707000083, 62.202378648000035],
              [5.146494988000086, 62.204738674000055],
              [5.16968834700009, 62.214504299000055],
              [5.181813998000052, 62.21271393400008],
              [5.210215691000087, 62.194240627000056],
              [5.241221550000091, 62.18305084800005],
              [5.253184441000087, 62.174261786000045],
              [5.26107832100007, 62.16982656500005],
              [5.268809441000087, 62.17031484600005],
              [5.274587436000047, 62.16941966400003],
              [5.276866082000083, 62.16063060100004],
              [5.275238477000073, 62.154282945000034],
              [5.269704623000052, 62.14101797100005],
              [5.270030144000089, 62.13580963700008],
              [5.317881707000083, 62.10651276200008],
              [5.390961134000065, 62.08836497600004],
              [5.451426629000082, 62.061712958000044],
              [5.461680535000085, 62.006740627000056],
              [5.468028191000087, 62.009059963000084],
              [5.481211785000085, 62.01386139500005],
              [5.495941602000073, 62.02757396000004],
              [5.528330925000091, 62.06891510600008],
              [5.53093509200005, 62.07489655200004],
              [5.536387566000087, 62.07904694200005],
              [5.55054772200009, 62.081244208000044],
              [5.560883009000065, 62.07953522300005],
              [5.580332879000082, 62.07050202000005],
              [5.59156334700009, 62.06818268400008],
              [5.564707879000082, 62.08966705900008],
              [5.420176629000082, 62.10911692900004],
              [5.400401238000086, 62.11587148600006],
              [5.390961134000065, 62.12323639500005],
              [5.391774936000047, 62.132879950000074],
              [5.413910352000073, 62.162095445000034],
              [5.420583530000044, 62.17593008000006],
              [5.431162957000083, 62.18618398600006],
              [5.454274936000047, 62.191066799000055],
              [5.478851759000065, 62.18854401200008],
              [5.524099155000044, 62.17401764500005],
              [5.622080925000091, 62.16486237200007],
              [5.639903191000087, 62.157538153000075],
              [5.64820397200009, 62.146470445000034],
              [5.653493686000047, 62.13296133000006],
              [5.66146894600007, 62.12140534100007],
              [5.69312584700009, 62.112982489000046],
              [5.74976647200009, 62.08860911700003],
              [5.73015384200005, 62.10496653900003],
              [5.696055535000085, 62.12246328300006],
              [5.668304884000065, 62.14350006700005],
              [5.667246941000087, 62.17059967700004],
              [5.684743686000047, 62.179022528000075],
              [5.714691602000073, 62.18073151200008],
              [5.770274285000085, 62.17804596600007],
              [5.786143425000091, 62.18048737200007],
              [5.838552280000044, 62.201239325000074],
              [5.857432488000086, 62.20425039300005],
              [5.882090691000087, 62.20018138200004],
              [5.905528191000087, 62.19090403900003],
              [5.920583530000044, 62.17804596600007],
              [5.92546634200005, 62.16364166900007],
              [5.924815300000091, 62.14988841400003],
              [5.920583530000044, 62.11969635600008],
              [5.907074415000068, 62.09357330900008],
              [5.852549675000091, 62.051214911000045],
              [5.84538821700005, 62.01972077000005],
              [5.909434441000087, 62.06118398600006],
              [5.936696811000047, 62.08734772300005],
              [5.954600457000083, 62.139960028000075],
              [5.970957879000082, 62.13898346600007],
              [6.04428144600007, 62.099269924000055],
              [6.055186394000089, 62.08608633000006],
              [6.050791863000086, 62.06818268400008],
              [6.088633660000085, 62.07758209800005],
              [6.125254754000082, 62.08266836100006],
              [6.20834394600007, 62.081244208000044],
              [6.366709832000083, 62.06134674700007],
              [6.366709832000083, 62.06818268400008],
              [6.088633660000085, 62.10911692900004],
              [6.076182488000086, 62.114447333000044],
              [6.04859459700009, 62.137884833000044],
              [6.040293816000087, 62.14325592700004],
              [6.02711022200009, 62.14874909100007],
              [5.982595248000052, 62.18423086100006],
              [5.928721550000091, 62.198919989000046],
              [5.920583530000044, 62.20815664300005],
              [5.926036004000082, 62.225490627000056],
              [5.939707879000082, 62.229396877000056],
              [5.957530144000089, 62.22524648600006],
              [5.996592644000089, 62.21112702000005],
              [6.01726321700005, 62.20697663000004],
              [6.064463738000086, 62.204738674000055],
              [6.050059441000087, 62.21039459800005],
              [6.029795769000089, 62.21466705900008],
              [5.992035352000073, 62.218410549000055],
              [5.982595248000052, 62.22345612200007],
              [5.975271030000044, 62.23432038000004],
              [5.965179884000065, 62.24408600500004],
              [5.947764519000089, 62.24567291900007],
              [5.978363477000073, 62.279730536000045],
              [6.027679884000065, 62.30573151200008],
              [6.08334394600007, 62.32241445500006],
              [6.133311394000089, 62.32827383000006],
              [6.247325066000087, 62.36107005400004],
              [6.310801629000082, 62.37205638200004],
              [6.338715040000068, 62.352443752000056],
              [6.34310957100007, 62.34552643400008],
              [6.372894727000073, 62.31460195500006],
              [6.393402540000068, 62.280462958000044],
              [6.413340691000087, 62.26654694200005],
              [6.459971550000091, 62.24799225500004],
              [6.48218834700009, 62.23200104400007],
              [6.55046634200005, 62.17059967700004],
              [6.560801629000082, 62.15208567900004],
              [6.556895379000082, 62.13841380400004],
              [6.530528191000087, 62.10911692900004],
              [6.592051629000082, 62.13580963700008],
              [6.580902540000068, 62.16034577000005],
              [6.494883660000085, 62.253119208000044],
              [6.41765384200005, 62.31118398600006],
              [6.39779707100007, 62.33665599200003],
              [6.38998457100007, 62.36469147300005],
              [6.400238477000073, 62.38719310100004],
              [6.434336785000085, 62.396470445000034],
              [6.479746941000087, 62.40053945500006],
              [6.500254754000082, 62.399318752000056],
              [6.523773634000065, 62.390326239000046],
              [6.533946160000085, 62.38349030200004],
              [6.564707879000082, 62.355536200000074],
              [6.562022332000083, 62.37164948100008],
              [6.562510613000086, 62.386786200000074],
              [6.558929884000065, 62.39838288000004],
              [6.544200066000087, 62.403957424000055],
              [6.544200066000087, 62.41079336100006],
              [6.563649936000047, 62.417669989000046],
              [6.649099155000044, 62.434881903000075],
              [6.688975457000083, 62.44985586100006],
              [6.70875084700009, 62.45172760600008],
              [6.723399285000085, 62.44745514500005],
              [6.748301629000082, 62.43414948100008],
              [6.879161004000082, 62.41791413000004],
              [6.881114129000082, 62.402411200000074],
              [6.873301629000082, 62.380560614000046],
              [6.873789910000085, 62.355536200000074],
              [6.886241082000083, 62.341131903000075],
              [6.979014519000089, 62.283636786000045],
              [6.989268425000091, 62.27301666900007],
              [6.996348504000082, 62.26166413000004],
              [6.99935957100007, 62.25348541900007],
              [7.00749759200005, 62.20888906500005],
              [7.00521894600007, 62.19428131700005],
              [6.996104363000086, 62.18244049700007],
              [6.94271894600007, 62.13735586100006],
              [6.938731316000087, 62.12181224200003],
              [6.955821160000085, 62.10228099200003],
              [6.98796634200005, 62.08930084800005],
              [7.02125084700009, 62.09076569200005],
              [7.099945509000065, 62.10455963700008],
              [7.124847852000073, 62.11432526200008],
              [7.13998457100007, 62.11660390800006],
              [7.152679884000065, 62.114894924000055],
              [7.187836134000065, 62.10228099200003],
              [7.149668816000087, 62.13080475500004],
              [7.029958530000044, 62.10040924700007],
              [6.979340040000068, 62.11286041900007],
              [6.973399285000085, 62.12938060100004],
              [6.986501498000052, 62.142645575000074],
              [7.02711022200009, 62.167181708000044],
              [7.037119988000086, 62.18382396000004],
              [7.037933790000068, 62.20302969000005],
              [7.026052280000044, 62.26015859600005],
              [7.028086785000085, 62.26601797100005],
              [7.037771030000044, 62.27301666900007],
              [7.051442905000044, 62.27602773600006],
              [7.112803582000083, 62.280462958000044],
              [7.209239129000082, 62.250881252000056],
              [7.232920769000089, 62.25625234600005],
              [7.25326582100007, 62.27106354400007],
              [7.281260613000086, 62.28082916900007],
              [7.310720248000052, 62.28156159100007],
              [7.335948113000086, 62.26992422100005],
              [7.352061394000089, 62.257513739000046],
              [7.373383009000065, 62.24469635600008],
              [7.39584394600007, 62.23493073100008],
              [7.415049675000091, 62.23200104400007],
              [7.415049675000091, 62.239447333000044],
              [7.373545769000089, 62.27301666900007],
              [7.33179772200009, 62.285223700000074],
              [7.322276238000086, 62.290350653000075],
              [7.293467644000089, 62.29791901200008],
              [7.161306186000047, 62.28660716400003],
              [7.021332227000073, 62.30377838700008],
              [6.957041863000086, 62.32534414300005],
              [6.914073113000086, 62.36981842700004],
              [6.946299675000091, 62.36985911700003],
              [6.961436394000089, 62.37181224200003],
              [6.975596550000091, 62.376654364000046],
              [6.851573113000086, 62.45449453300006],
              [6.839691602000073, 62.45917389500005],
              [6.818695509000065, 62.46149323100008],
              [6.776540561000047, 62.45978424700007],
              [6.756521030000044, 62.46478913000004],
              [6.773936394000089, 62.470404364000046],
              [6.79070071700005, 62.47842031500005],
              [6.690196160000085, 62.47752513200004],
              [6.483653191000087, 62.43073151200008],
              [6.397715691000087, 62.425034898000035],
              [6.359222852000073, 62.43121979400007],
              [6.34310957100007, 62.43842194200005],
              [6.319102410000085, 62.454413153000075],
              [6.304698113000086, 62.45917389500005],
              [6.28451582100007, 62.45799388200004],
              [6.263845248000052, 62.45307038000004],
              [6.242930535000085, 62.45111725500004],
              [6.222666863000086, 62.45917389500005],
              [6.24968509200005, 62.467962958000044],
              [6.338715040000068, 62.47223541900007],
              [6.415212436000047, 62.489569403000075],
              [6.430918816000087, 62.496161200000074],
              [6.453623894000089, 62.502386786000045],
              [6.532725457000083, 62.50112539300005],
              [6.571136915000068, 62.49237702000005],
              [6.674571160000085, 62.49274323100008],
              [6.674571160000085, 62.49957916900007],
              [6.651866082000083, 62.50332265800006],
              [6.613780144000089, 62.52016836100006],
              [6.567149285000085, 62.51032135600008],
              [6.476084832000083, 62.51316966400003],
              [6.476084832000083, 62.52000560100004],
              [6.543223504000082, 62.52830638200004],
              [6.564707879000082, 62.52749258000006],
              [6.53296959700009, 62.53685130400004],
              [6.26303144600007, 62.52749258000006],
              [6.267425977000073, 62.535223700000074],
              [6.267832879000082, 62.53701406500005],
              [6.265879754000082, 62.53742096600007],
              [6.26303144600007, 62.541083075000074],
              [6.270518425000091, 62.55491771000004],
              [6.264414910000085, 62.56244538000004],
              [6.254161004000082, 62.567613023000035],
              [6.24935957100007, 62.574652411000045],
              [6.254893425000091, 62.58494700700004],
              [6.266123894000089, 62.592962958000044],
              [6.291026238000086, 62.60260651200008],
              [6.319590691000087, 62.60854726800005],
              [6.537364129000082, 62.61562734600005],
              [6.559580925000091, 62.61115143400008],
              [6.583262566000087, 62.599310614000046],
              [6.601084832000083, 62.58185455900008],
              [6.605723504000082, 62.560980536000045],
              [6.612559441000087, 62.560980536000045],
              [6.622243686000047, 62.58881256700005],
              [6.622080925000091, 62.601223049000055],
              [6.612559441000087, 62.609442450000074],
              [6.621592644000089, 62.619574286000045],
              [6.63217207100007, 62.62287018400008],
              [6.641368035000085, 62.61945221600007],
              [6.646657748000052, 62.609442450000074],
              [6.686696811000047, 62.63373444200005],
              [6.72982832100007, 62.65094635600008],
              [6.756114129000082, 62.65460846600007],
              [6.77711022200009, 62.65033600500004],
              [6.881846550000091, 62.601548570000034],
              [6.900563998000052, 62.588324286000045],
              [6.90170332100007, 62.58258698100008],
              [6.89820397200009, 62.57831452000005],
              [6.90015709700009, 62.57558828300006],
              [6.917816602000073, 62.574652411000045],
              [6.92351321700005, 62.57859935100004],
              [6.920664910000085, 62.587551174000055],
              [6.914073113000086, 62.596991278000075],
              [6.90796959700009, 62.60260651200008],
              [6.915212436000047, 62.60700104400007],
              [6.928477410000085, 62.623032945000034],
              [6.916270379000082, 62.62417226800005],
              [6.905528191000087, 62.62807851800005],
              [6.896006707000083, 62.63458893400008],
              [6.887461785000085, 62.64354075700004],
              [6.931651238000086, 62.655462958000044],
              [7.092295769000089, 62.65094635600008],
              [7.084320509000065, 62.63886139500005],
              [7.070323113000086, 62.63043854400007],
              [7.053558790000068, 62.62531159100007],
              [7.037771030000044, 62.623032945000034],
              [7.052012566000087, 62.60960521000004],
              [7.096527540000068, 62.612209377000056],
              [7.105967644000089, 62.59918854400007],
              [7.109711134000065, 62.58344147300005],
              [7.125336134000065, 62.55353424700007],
              [7.127126498000052, 62.53367747600004],
              [7.133148634000065, 62.53367747600004],
              [7.137380405000044, 62.54315827000005],
              [7.150889519000089, 62.56679922100005],
              [7.153819207000083, 62.574652411000045],
              [7.150401238000086, 62.58185455900008],
              [7.13648522200009, 62.594183661000045],
              [7.133148634000065, 62.59918854400007],
              [7.157481316000087, 62.62921784100007],
              [7.172211134000065, 62.62759023600006],
              [7.208994988000086, 62.61562734600005],
              [7.315440300000091, 62.60496653900003],
              [7.36500084700009, 62.59284088700008],
              [7.430430535000085, 62.548041083000044],
              [7.488780144000089, 62.54913971600007],
              [7.517425977000073, 62.541083075000074],
              [7.527598504000082, 62.52716705900008],
              [7.533457879000082, 62.51089101800005],
              [7.542491082000083, 62.503607489000046],
              [7.561778191000087, 62.51658763200004],
              [7.566661004000082, 62.52753327000005],
              [7.567881707000083, 62.539943752000056],
              [7.572927280000044, 62.549994208000044],
              [7.588552280000044, 62.55414459800005],
              [7.778168165000068, 62.574652411000045],
              [7.745371941000087, 62.586004950000074],
              [7.50521894600007, 62.56635163000004],
              [7.462738477000073, 62.574652411000045],
              [7.441661004000082, 62.584051825000074],
              [7.422699415000068, 62.59796784100007],
              [7.412771030000044, 62.61473216400003],
              [7.418223504000082, 62.63300202000005],
              [7.444509311000047, 62.64472077000005],
              [7.477305535000085, 62.63959381700005],
              [7.500254754000082, 62.61994049700007],
              [7.497080925000091, 62.588324286000045],
              [7.520192905000044, 62.58466217700004],
              [7.532481316000087, 62.59511953300006],
              [7.53296959700009, 62.613348700000074],
              [7.510020379000082, 62.64948151200008],
              [7.510590040000068, 62.66400788000004],
              [7.52320397200009, 62.67438385600008],
              [7.571136915000068, 62.68219635600008],
              [7.61687259200005, 62.70014069200005],
              [7.835948113000086, 62.732123114000046],
              [7.948252800000091, 62.730902411000045],
              [7.995616082000083, 62.735541083000044],
              [8.018809441000087, 62.733587958000044],
              [8.041758660000085, 62.727850653000075],
              [8.12671959700009, 62.693793036000045],
              [8.147471550000091, 62.69196198100008],
              [8.129405144000089, 62.718410549000055],
              [8.065114780000044, 62.73920319200005],
              [8.045095248000052, 62.75958893400008],
              [8.05437259200005, 62.761786200000074],
              [8.06226647200009, 62.766058661000045],
              [8.068695509000065, 62.77216217700004],
              [8.073008660000085, 62.78009674700007],
              [8.048675977000073, 62.77924225500004],
              [8.001149936000047, 62.77008698100008],
              [7.908864780000044, 62.76325104400007],
              [7.864512566000087, 62.74957916900007],
              [7.646006707000083, 62.72866445500006],
              [7.524912957000083, 62.69196198100008],
              [7.489268425000091, 62.686835028000075],
              [7.385020379000082, 62.687567450000074],
              [7.359711134000065, 62.69818756700005],
              [7.392588738000086, 62.70465729400007],
              [7.403575066000087, 62.71190013200004],
              [7.39429772200009, 62.72101471600007],
              [7.36654707100007, 62.73289622600004],
              [7.403005405000044, 62.73859284100007],
              [7.471527540000068, 62.767238674000055],
              [7.68132571700005, 62.79437897300005],
              [7.656993035000085, 62.793036200000074],
              [7.609548373000052, 62.796087958000044],
              [7.450450066000087, 62.77142975500004],
              [7.415049675000091, 62.75958893400008],
              [7.395274285000085, 62.75653717700004],
              [7.351573113000086, 62.75535716400003],
              [7.312510613000086, 62.74404531500005],
              [6.97038821700005, 62.72557200700004],
              [6.94898522200009, 62.73289622600004],
              [6.96062259200005, 62.732407945000034],
              [6.971527540000068, 62.735581773000035],
              [6.979746941000087, 62.74249909100007],
              [6.983083530000044, 62.75336334800005],
              [6.978770379000082, 62.75922272300005],
              [6.959971550000091, 62.76504140800006],
              [6.955821160000085, 62.77045319200005],
              [6.961924675000091, 62.78416575700004],
              [6.976735873000052, 62.79702383000006],
              [7.009776238000086, 62.81484609600005],
              [7.059580925000091, 62.82632070500006],
              [7.215830925000091, 62.81484609600005],
              [7.192149285000085, 62.821966864000046],
              [7.154795769000089, 62.84316640800006],
              [7.133148634000065, 62.848944403000075],
              [7.016612175000091, 62.84153880400004],
              [7.004161004000082, 62.84829336100006],
              [6.955821160000085, 62.88686758000006],
              [6.948008660000085, 62.905462958000044],
              [6.928965691000087, 62.912095445000034],
              [6.880056186000047, 62.91107819200005],
              [6.891123894000089, 62.92169830900008],
              [6.910166863000086, 62.929388739000046],
              [7.000173373000052, 62.951239325000074],
              [7.076019727000073, 62.982855536000045],
              [7.108246290000068, 62.990668036000045],
              [7.172129754000082, 62.998032945000034],
              [7.23764082100007, 63.01471588700008],
              [7.27116946700005, 63.014105536000045],
              [7.297618035000085, 63.00429922100005],
              [7.34343509200005, 62.97842031500005],
              [7.369965040000068, 62.973089911000045],
              [7.42123457100007, 62.95140208500004],
              [7.426442905000044, 62.944973049000055],
              [7.441742384000065, 62.91787344000005],
              [7.501149936000047, 62.91083405200004],
              [7.559825066000087, 62.931301174000055],
              [7.615977410000085, 62.96039459800005],
              [7.668304884000065, 62.97931549700007],
              [7.689952019000089, 62.98114655200004],
              [7.775726759000065, 62.97752513200004],
              [7.780446811000047, 62.97260163000004],
              [7.776133660000085, 62.96499258000006],
              [7.767588738000086, 62.955145575000074],
              [7.748301629000082, 62.94208405200004],
              [7.668304884000065, 62.91787344000005],
              [7.694346550000091, 62.912095445000034],
              [7.832041863000086, 62.94940827000005],
              [7.846446160000085, 62.95140208500004],
              [7.881195509000065, 62.95254140800006],
              [7.899424675000091, 62.95575592700004],
              [7.939300977000073, 62.97711823100008],
              [7.973887566000087, 62.97695547100005],
              [8.07553144600007, 62.950873114000046],
              [8.086680535000085, 62.94521719000005],
              [8.093028191000087, 62.93724192900004],
              [8.095957879000082, 62.92914459800005],
              [8.101084832000083, 62.92218659100007],
              [8.113291863000086, 62.91787344000005],
              [8.113942905000044, 62.89911530200004],
              [8.124196811000047, 62.86774323100008],
              [8.139333530000044, 62.83567942900004],
              [8.154307488000086, 62.81484609600005],
              [8.189707879000082, 62.79791901200008],
              [8.278493686000047, 62.78705475500004],
              [8.319102410000085, 62.777004299000055],
              [8.415212436000047, 62.725775458000044],
              [8.449066602000073, 62.71930573100008],
              [8.480723504000082, 62.716782945000034],
              [8.513194207000083, 62.70742422100005],
              [8.537771030000044, 62.68846263200004],
              [8.545258009000065, 62.65717194200005],
              [8.567230665000068, 62.68227773600006],
              [8.564789259000065, 62.703558661000045],
              [8.543955925000091, 62.72064850500004],
              [8.455251498000052, 62.75625234600005],
              [8.37671959700009, 62.77716705900008],
              [8.331065300000091, 62.80068594000005],
              [8.246267123000052, 62.81614817900004],
              [8.184092644000089, 62.847723700000074],
              [8.172048373000052, 62.85838450700004],
              [8.167979363000086, 62.87689850500004],
              [8.171153191000087, 62.891791083000044],
              [8.179209832000083, 62.90216705900008],
              [8.192067905000044, 62.90835195500006],
              [8.209646030000044, 62.91107819200005],
              [8.197927280000044, 62.91502513200004],
              [8.186045769000089, 62.917303778000075],
              [8.175059441000087, 62.92072174700007],
              [8.164886915000068, 62.92812734600005],
              [8.15992272200009, 62.93471914300005],
              [8.153819207000083, 62.945379950000074],
              [8.147471550000091, 62.95140208500004],
              [8.129079623000052, 62.95966217700004],
              [8.086924675000091, 62.967230536000045],
              [8.000743035000085, 63.00665924700007],
              [7.997243686000047, 63.00950755400004],
              [7.98804772200009, 63.02293528900003],
              [7.983083530000044, 63.02708567900004],
              [7.97234134200005, 63.028957424000055],
              [7.961273634000065, 63.02814362200007],
              [7.951182488000086, 63.025091864000046],
              [7.942637566000087, 63.02024974200003],
              [7.953949415000068, 63.020738023000035],
              [7.96070397200009, 63.01870351800005],
              [7.965098504000082, 63.01406484600005],
              [7.969981316000087, 63.00665924700007],
              [7.948008660000085, 63.003241278000075],
              [7.914073113000086, 63.001939195000034],
              [7.885020379000082, 63.003973700000074],
              [7.877207879000082, 63.01040273600006],
              [7.893321160000085, 63.022650458000044],
              [7.931162957000083, 63.03782786700003],
              [7.94890384200005, 63.04755280200004],
              [7.981293165000068, 63.081366278000075],
              [7.997325066000087, 63.09227122600004],
              [8.016856316000087, 63.10097890800006],
              [8.040049675000091, 63.10765208500004],
              [8.06413821700005, 63.110988674000055],
              [8.086680535000085, 63.10968659100007],
              [8.102224155000044, 63.10443756700005],
              [8.121104363000086, 63.09406159100007],
              [8.133962436000047, 63.08026764500005],
              [8.128428582000083, 63.05023834800005],
              [8.141612175000091, 63.03701406500005],
              [8.160411004000082, 63.02643463700008],
              [8.17546634200005, 63.02024974200003],
              [8.246755405000044, 63.00796133000006],
              [8.267832879000082, 62.99673086100006],
              [8.285899285000085, 62.982082424000055],
              [8.295420769000089, 62.979803778000075],
              [8.312673373000052, 62.97931549700007],
              [8.32203209700009, 62.977728583000044],
              [8.330088738000086, 62.97337474200003],
              [8.336192254000082, 62.96694570500006],
              [8.339854363000086, 62.95880768400008],
              [8.309336785000085, 62.944566148000035],
              [8.318858269000089, 62.930121161000045],
              [8.336436394000089, 62.912095445000034],
              [8.329356316000087, 62.88686758000006],
              [8.329274936000047, 62.88068268400008],
              [8.344493035000085, 62.88239166900007],
              [8.374034050000091, 62.889960028000075],
              [8.389414910000085, 62.889878648000035],
              [8.403005405000044, 62.88690827000005],
              [8.48804772200009, 62.85297272300005],
              [8.522959832000083, 62.84430573100008],
              [8.538584832000083, 62.85236237200007],
              [8.524180535000085, 62.87128327000005],
              [8.454356316000087, 62.88349030200004],
              [8.428721550000091, 62.89679596600007],
              [8.450694207000083, 62.89565664300005],
              [8.57398522200009, 62.875433661000045],
              [8.593760613000086, 62.86945221600007],
              [8.605804884000065, 62.86269765800006],
              [8.624196811000047, 62.84796784100007],
              [8.634776238000086, 62.84153880400004],
              [8.650889519000089, 62.83588288000004],
              [8.685720248000052, 62.82835521000004],
              [8.702972852000073, 62.822251695000034],
              [8.619883660000085, 62.87791575700004],
              [8.596364780000044, 62.885199286000045],
              [8.52084394600007, 62.89215729400007],
              [8.498871290000068, 62.89826080900008],
              [8.479746941000087, 62.90717194200005],
              [8.423024936000047, 62.94757721600007],
              [8.41570071700005, 62.95880768400008],
              [8.64421634200005, 62.96735260600008],
              [8.668793165000068, 62.97931549700007],
              [8.63998457100007, 62.98875560100004],
              [8.575368686000047, 62.97992584800005],
              [8.545258009000065, 62.97931549700007],
              [8.521739129000082, 62.98920319200005],
              [8.533457879000082, 63.00031159100007],
              [8.586273634000065, 63.02024974200003],
              [8.553721550000091, 63.022650458000044],
              [8.48804772200009, 62.99404531500005],
              [8.393565300000091, 62.97280508000006],
              [8.374034050000091, 62.973089911000045],
              [8.369476759000065, 62.975775458000044],
              [8.35873457100007, 62.98582591400003],
              [8.35328209700009, 62.98981354400007],
              [8.34506269600007, 62.99315013200004],
              [8.319509311000047, 62.99982330900008],
              [8.35523522200009, 63.00828685100004],
              [8.435394727000073, 63.009833075000074],
              [8.470225457000083, 63.02024974200003],
              [8.43531334700009, 63.03143952000005],
              [8.305186394000089, 63.02024974200003],
              [8.262217644000089, 63.02163320500006],
              [8.238536004000082, 63.025458075000074],
              [8.223155144000089, 63.03335195500006],
              [8.221853061000047, 63.03851959800005],
              [8.22242272200009, 63.04629140800006],
              [8.22437584700009, 63.05369700700004],
              [8.228851759000065, 63.06305573100008],
              [8.224945509000065, 63.06598541900007],
              [8.219248894000089, 63.06850820500006],
              [8.216319207000083, 63.07184479400007],
              [8.20289147200009, 63.092678127000056],
              [8.178233269000089, 63.10496653900003],
              [8.165537957000083, 63.115301825000074],
              [8.188487175000091, 63.130113023000035],
              [8.219737175000091, 63.134466864000046],
              [8.24195397200009, 63.12352122600004],
              [8.263194207000083, 63.10736725500004],
              [8.291514519000089, 63.09601471600007],
              [8.289724155000044, 63.09137604400007],
              [8.28679446700005, 63.080145575000074],
              [8.284678582000083, 63.075506903000075],
              [8.307139519000089, 63.07859935100004],
              [8.318614129000082, 63.08242422100005],
              [8.326182488000086, 63.08856842700004],
              [8.325043165000068, 63.09389883000006],
              [8.318369988000086, 63.097642320000034],
              [8.31381269600007, 63.10211823100008],
              [8.319509311000047, 63.10968659100007],
              [8.30437259200005, 63.12514883000006],
              [8.283050977000073, 63.13312409100007],
              [8.236175977000073, 63.14321523600006],
              [8.236175977000073, 63.15070221600007],
              [8.543630405000044, 63.13239166900007],
              [8.640961134000065, 63.10968659100007],
              [8.624522332000083, 63.128119208000044],
              [8.57593834700009, 63.144232489000046],
              [8.56576582100007, 63.16120026200008],
              [8.578786655000044, 63.17454661700003],
              [8.60873457100007, 63.18109772300005],
              [8.849945509000065, 63.20343659100007],
              [8.94312584700009, 63.21206289300005],
              [8.868988477000073, 63.21047597900008],
              [8.648448113000086, 63.20587799700007],
              [8.623708530000044, 63.20148346600007],
              [8.612152540000068, 63.20380280200004],
              [8.60320071700005, 63.224269924000055],
              [8.59310957100007, 63.235541083000044],
              [8.573252800000091, 63.25307851800005],
              [8.52702884200005, 63.278998114000046],
              [8.501963738000086, 63.28856028900003],
              [8.476410352000073, 63.29401276200008],
              [8.514659050000091, 63.305894273000035],
              [8.701996290000068, 63.32396067900004],
              [8.737559441000087, 63.33466217700004],
              [8.764414910000085, 63.349269924000055],
              [8.72820071700005, 63.34918854400007],
              [8.711110873000052, 63.351223049000055],
              [8.695567254000082, 63.356675523000035],
              [8.68881269600007, 63.362982489000046],
              [8.682139519000089, 63.37189362200007],
              [8.674571160000085, 63.37986888200004],
              [8.638926629000082, 63.39207591400003],
              [8.646820509000065, 63.40916575700004],
              [8.672373894000089, 63.421210028000075],
              [8.718272332000083, 63.40814850500004],
              [8.740896030000044, 63.414129950000074],
              [8.765798373000052, 63.42450592700004],
              [8.786387566000087, 63.42983633000006],
              [8.791758660000085, 63.43121979400007],
              [8.823415561000047, 63.429388739000046],
              [8.842621290000068, 63.420355536000045],
              [8.858897332000083, 63.40835195500006],
              [8.881114129000082, 63.397650458000044],
              [8.891368035000085, 63.42133209800005],
              [8.926117384000065, 63.423895575000074],
              [8.967539910000085, 63.41852448100008],
              [8.997243686000047, 63.41815827000005],
              [8.997243686000047, 63.42438385600008],
              [8.973399285000085, 63.42438385600008],
              [8.967458530000044, 63.43341705900008],
              [8.974864129000082, 63.446600653000075],
              [9.000824415000068, 63.466131903000075],
              [9.006358269000089, 63.467230536000045],
              [9.018321160000085, 63.46653880400004],
              [9.052989129000082, 63.452337958000044],
              [9.114512566000087, 63.41815827000005],
              [9.123057488000086, 63.40729401200008],
              [9.12859134200005, 63.39545319200005],
              [9.135508660000085, 63.384426174000055],
              [9.148610873000052, 63.37592194200005],
              [9.126231316000087, 63.36225006700005],
              [9.10287519600007, 63.34320709800005],
              [9.088715040000068, 63.320013739000046],
              [9.09343509200005, 63.29401276200008],
              [9.125254754000082, 63.32062409100007],
              [9.143077019000089, 63.33087799700007],
              [9.191579623000052, 63.33844635600008],
              [9.264659050000091, 63.362941799000055],
              [9.434580925000091, 63.38043854400007],
              [9.476898634000065, 63.40387604400007],
              [9.449961785000085, 63.40094635600008],
              [9.39389082100007, 63.38666413000004],
              [9.260264519000089, 63.38125234600005],
              [9.229991082000083, 63.37287018400008],
              [9.218028191000087, 63.37201569200005],
              [9.204356316000087, 63.37653229400007],
              [9.191661004000082, 63.38361237200007],
              [9.16773522200009, 63.402004299000055],
              [9.169118686000047, 63.421210028000075],
              [9.18295332100007, 63.43451569200005],
              [9.481944207000083, 63.47321198100008],
              [9.483897332000083, 63.47606028900003],
              [9.484385613000086, 63.48265208500004],
              [9.480723504000082, 63.48704661700003],
              [9.472178582000083, 63.485541083000044],
              [9.456553582000083, 63.47955963700008],
              [9.364268425000091, 63.46625397300005],
              [9.333018425000091, 63.46653880400004],
              [9.300629102000073, 63.477769273000035],
              [9.285329623000052, 63.47955963700008],
              [9.279958530000044, 63.48236725500004],
              [9.268077019000089, 63.49555084800005],
              [9.257823113000086, 63.500067450000074],
              [9.262054884000065, 63.48517487200007],
              [9.268077019000089, 63.47345612200007],
              [9.277598504000082, 63.46478913000004],
              [9.292165561000047, 63.45913320500006],
              [9.210215691000087, 63.459418036000045],
              [9.16732832100007, 63.466864325000074],
              [9.148610873000052, 63.48582591400003],
              [9.161957227000073, 63.507147528000075],
              [9.192556186000047, 63.51361725500004],
              [9.244313998000052, 63.513739325000074],
              [9.237152540000068, 63.534491278000075],
              [9.255869988000086, 63.53530508000006],
              [9.283376498000052, 63.52968984600005],
              [9.302256707000083, 63.53082916900007],
              [9.319021030000044, 63.54328034100007],
              [9.342784050000091, 63.55560944200005],
              [9.368011915000068, 63.56329987200007],
              [9.388194207000083, 63.562201239000046],
              [9.377696160000085, 63.55385976800005],
              [9.374522332000083, 63.542303778000075],
              [9.37826582100007, 63.530462958000044],
              [9.388194207000083, 63.521185614000046],
              [9.403330925000091, 63.518459377000056],
              [9.416677280000044, 63.52488841400003],
              [9.460134311000047, 63.56167226800005],
              [9.476817254000082, 63.57176341400003],
              [9.495371941000087, 63.57689036700003],
              [9.518565300000091, 63.57518138200004],
              [9.536387566000087, 63.567287502000056],
              [9.55990644600007, 63.54584381700005],
              [9.573252800000091, 63.541001695000034],
              [9.560557488000086, 63.56586334800005],
              [9.545909050000091, 63.58055247600004],
              [9.524180535000085, 63.58763255400004],
              [9.490570509000065, 63.58942291900007],
              [9.516774936000047, 63.60370514500005],
              [9.546071811000047, 63.61029694200005],
              [9.607920769000089, 63.61676666900007],
              [9.66765384200005, 63.63776276200008],
              [9.699066602000073, 63.64447663000004],
              [9.72396894600007, 63.63666413000004],
              [9.720225457000083, 63.620754299000055],
              [9.73959394600007, 63.60260651200008],
              [9.785492384000065, 63.57518138200004],
              [9.799978061000047, 63.56313711100006],
              [9.810720248000052, 63.54857005400004],
              [9.81381269600007, 63.53204987200007],
              [9.805918816000087, 63.513739325000074],
              [9.898692254000082, 63.47736237200007],
              [9.947438998000052, 63.44953034100007],
              [9.96062259200005, 63.427720445000034],
              [9.941416863000086, 63.39447663000004],
              [9.928477410000085, 63.37718333500004],
              [9.833262566000087, 63.32880280200004],
              [9.856700066000087, 63.325425523000035],
              [9.89421634200005, 63.33120351800005],
              [9.93132571700005, 63.341782945000034],
              [9.979177280000044, 63.36347077000005],
              [10.01343834700009, 63.36188385600008],
              [10.047048373000052, 63.35228099200003],
              [10.09929446700005, 63.32489655200004],
              [10.138926629000082, 63.322333075000074],
              [10.211273634000065, 63.32880280200004],
              [10.242198113000086, 63.32632070500006],
              [10.254405144000089, 63.314439195000034],
              [10.259043816000087, 63.267279364000046],
              [10.268565300000091, 63.27301666900007],
              [10.272227410000085, 63.281683661000045],
              [10.272146030000044, 63.30487702000005],
              [10.273285352000073, 63.307806708000044],
              [10.275726759000065, 63.309475002000056],
              [10.278330925000091, 63.312201239000046],
              [10.279551629000082, 63.31826406500005],
              [10.277354363000086, 63.32379791900007],
              [10.272715691000087, 63.32684967700004],
              [10.268077019000089, 63.32892487200007],
              [10.265879754000082, 63.33193594000005],
              [10.244883660000085, 63.34406159100007],
              [10.083994988000086, 63.36127350500004],
              [10.068695509000065, 63.36554596600007],
              [10.05640709700009, 63.37287018400008],
              [10.049082879000082, 63.38190338700008],
              [10.042246941000087, 63.39476146000004],
              [10.040863477000073, 63.40639883000006],
              [10.049571160000085, 63.411322333000044],
              [10.060069207000083, 63.41498444200005],
              [10.08366946700005, 63.43256256700005],
              [10.094004754000082, 63.438666083000044],
              [10.15601647200009, 63.452337958000044],
              [10.30046634200005, 63.46653880400004],
              [10.317230665000068, 63.46369049700007],
              [10.354665561000047, 63.44489166900007],
              [10.373057488000086, 63.44171784100007],
              [10.386892123000052, 63.443060614000046],
              [10.415537957000083, 63.452337958000044],
              [10.447276238000086, 63.45677317900004],
              [10.481944207000083, 63.45465729400007],
              [10.515961134000065, 63.44708893400008],
              [10.546153191000087, 63.434881903000075],
              [10.576914910000085, 63.43073151200008],
              [10.690440300000091, 63.452337958000044],
              [10.695974155000044, 63.447333075000074],
              [10.758799675000091, 63.438666083000044],
              [10.783702019000089, 63.423041083000044],
              [10.797862175000091, 63.41738515800006],
              [10.81023196700005, 63.421210028000075],
              [10.82976321700005, 63.44057851800005],
              [10.840993686000047, 63.44399648600006],
              [10.875905795000051, 63.44590892100007],
              [10.875987175000091, 63.44594961100006],
              [10.893077019000089, 63.44953034100007],
              [10.908050977000073, 63.456244208000044],
              [10.916351759000065, 63.46653880400004],
              [10.822520379000082, 63.475897528000075],
              [10.777679884000065, 63.487494208000044],
              [10.758799675000091, 63.51748281500005],
              [10.780772332000083, 63.53900788000004],
              [10.831065300000091, 63.55036041900007],
              [10.922618035000085, 63.554754950000074],
              [10.922618035000085, 63.562201239000046],
              [10.877289259000065, 63.56439850500004],
              [10.856944207000083, 63.56932200700004],
              [10.861501498000052, 63.57859935100004],
              [10.879161004000082, 63.583319403000075],
              [10.896983269000089, 63.58437734600005],
              [10.912364129000082, 63.58852773600006],
              [10.922618035000085, 63.60248444200005],
              [10.85132897200009, 63.598089911000045],
              [10.817556186000047, 63.59076569200005],
              [10.785980665000068, 63.57859935100004],
              [10.768321160000085, 63.57404205900008],
              [10.73015384200005, 63.57176341400003],
              [10.714366082000083, 63.56492747600004],
              [10.702159050000091, 63.55744049700007],
              [10.687510613000086, 63.551947333000044],
              [10.67164147200009, 63.54877350500004],
              [10.656423373000052, 63.548529364000046],
              [10.656423373000052, 63.554754950000074],
              [10.672618035000085, 63.55817291900007],
              [10.680023634000065, 63.567613023000035],
              [10.686045769000089, 63.577460028000075],
              [10.697276238000086, 63.58197663000004],
              [10.705088738000086, 63.583685614000046],
              [10.708506707000083, 63.58783600500004],
              [10.71062259200005, 63.59332916900007],
              [10.714366082000083, 63.59906647300005],
              [10.719737175000091, 63.603501695000034],
              [10.729340040000068, 63.60883209800005],
              [10.734711134000065, 63.613348700000074],
              [10.755707227000073, 63.625067450000074],
              [10.787771030000044, 63.634833075000074],
              [10.844574415000068, 63.64411041900007],
              [10.864268425000091, 63.65151601800005],
              [10.905446811000047, 63.684475002000056],
              [11.033457879000082, 63.719183661000045],
              [11.056895379000082, 63.716050523000035],
              [11.083018425000091, 63.70457591400003],
              [11.119639519000089, 63.70449453300006],
              [11.156748894000089, 63.71112702000005],
              [11.183848504000082, 63.71979401200008],
              [11.205821160000085, 63.733710028000075],
              [11.242198113000086, 63.76508209800005],
              [11.265798373000052, 63.77440013200004],
              [11.33725019600007, 63.78416575700004],
              [11.44304446700005, 63.78607819200005],
              [11.457692905000044, 63.78998444200005],
              [11.463877800000091, 63.80170319200005],
              [11.459727410000085, 63.81244538000004],
              [11.449392123000052, 63.81891510600008],
              [11.436371290000068, 63.82184479400007],
              [11.424082879000082, 63.82221100500004],
              [11.427582227000073, 63.82526276200008],
              [11.434255405000044, 63.83266836100006],
              [11.437754754000082, 63.83588288000004],
              [11.415212436000047, 63.85008372600004],
              [11.354746941000087, 63.84813060100004],
              [11.327321811000047, 63.85297272300005],
              [11.301931186000047, 63.862941799000055],
              [11.27711022200009, 63.86737702000005],
              [11.251800977000073, 63.867173570000034],
              [11.111582879000082, 63.84955475500004],
              [11.101735873000052, 63.85187409100007],
              [11.096527540000068, 63.85809967700004],
              [11.094574415000068, 63.866888739000046],
              [11.094493035000085, 63.87685781500005],
              [11.096446160000085, 63.88963450700004],
              [11.101898634000065, 63.89350006700005],
              [11.112315300000091, 63.89411041900007],
              [11.176605665000068, 63.90924713700008],
              [11.200368686000047, 63.91974518400008],
              [11.21062259200005, 63.935207424000055],
              [11.223317905000044, 63.94546133000006],
              [11.299978061000047, 63.96556224200003],
              [11.43685957100007, 63.98314036700003],
              [11.463145379000082, 63.99323151200008],
              [11.486827019000089, 64.00665924700007],
              [11.497894727000073, 64.02081940300008],
              [11.45443769600007, 64.01740143400008],
              [11.441742384000065, 64.02570221600007],
              [11.426280144000089, 64.02879466400003],
              [11.36654707100007, 64.02728913000004],
              [11.262054884000065, 64.03611888200004],
              [11.254242384000065, 64.03790924700007],
              [11.24195397200009, 64.05158112200007],
              [11.240489129000082, 64.06102122600004],
              [11.252452019000089, 64.06806061400005],
              [11.280039910000085, 64.07611725500004],
              [11.34506269600007, 64.10488515800006],
              [11.362071160000085, 64.11709219000005],
              [11.328379754000082, 64.11440664300005],
              [11.299978061000047, 64.10716380400004],
              [11.225352410000085, 64.07196686400005],
              [11.203461134000065, 64.02741120000007],
              [11.197601759000065, 64.02081940300008],
              [11.17514082100007, 64.00702545800004],
              [10.962738477000073, 63.94794342700004],
              [10.936289910000085, 63.93634674700007],
              [10.910980665000068, 63.92169830900008],
              [10.89226321700005, 63.907538153000075],
              [10.871348504000082, 63.89720286700003],
              [10.838063998000052, 63.88727448100008],
              [10.72006269600007, 63.86981842700004],
              [10.688649936000047, 63.86029694200005],
              [10.64616946700005, 63.833238023000035],
              [10.59538821700005, 63.82025788000004],
              [10.573741082000083, 63.80914948100008],
              [10.593760613000086, 63.80878327000005],
              [10.613129102000073, 63.81146881700005],
              [10.631602410000085, 63.81631094000005],
              [10.68913821700005, 63.84015534100007],
              [10.700694207000083, 63.84271881700005],
              [10.770030144000089, 63.85028717700004],
              [10.900238477000073, 63.89472077000005],
              [10.93490644600007, 63.898138739000046],
              [11.000661655000044, 63.87742747600004],
              [11.030284050000091, 63.871975002000056],
              [11.05600019600007, 63.86127350500004],
              [11.07398522200009, 63.83588288000004],
              [11.053477410000085, 63.83148834800005],
              [11.029795769000089, 63.823431708000044],
              [11.00749759200005, 63.81313711100006],
              [10.991465691000087, 63.80170319200005],
              [10.987152540000068, 63.79437897300005],
              [10.982269727000073, 63.77578359600005],
              [10.97787519600007, 63.767564195000034],
              [10.971690300000091, 63.76316966400003],
              [10.954600457000083, 63.755926825000074],
              [10.94703209700009, 63.75018952000005],
              [10.910004102000073, 63.73102448100008],
              [10.811045769000089, 63.72016022300005],
              [10.740733269000089, 63.69037506700005],
              [10.671722852000073, 63.686835028000075],
              [10.642751498000052, 63.67763906500005],
              [10.633555535000085, 63.669623114000046],
              [10.611582879000082, 63.640326239000046],
              [10.602305535000085, 63.635931708000044],
              [10.566661004000082, 63.62518952000005],
              [10.529633009000065, 63.61945221600007],
              [10.41578209700009, 63.579413153000075],
              [10.401621941000087, 63.57636139500005],
              [10.366709832000083, 63.57318756700005],
              [10.335459832000083, 63.564154364000046],
              [10.320160352000073, 63.562201239000046],
              [10.241384311000047, 63.562201239000046],
              [10.228363477000073, 63.55882396000004],
              [10.20484459700009, 63.54433828300006],
              [10.193614129000082, 63.541001695000034],
              [10.166351759000065, 63.53693268400008],
              [10.080332879000082, 63.507513739000046],
              [10.041026238000086, 63.501654364000046],
              [9.998383009000065, 63.500067450000074],
              [9.99154707100007, 63.49827708500004],
              [9.98568769600007, 63.495021877000056],
              [9.98015384200005, 63.493353583000044],
              [9.973887566000087, 63.49664948100008],
              [9.969248894000089, 63.50018952000005],
              [9.962738477000073, 63.50372955900008],
              [9.955902540000068, 63.50649648600006],
              [9.918223504000082, 63.51471588700008],
              [9.908376498000052, 63.532416083000044],
              [9.90398196700005, 63.55459219000005],
              [9.887950066000087, 63.57518138200004],
              [9.898448113000086, 63.586371161000045],
              [9.90211022200009, 63.58942291900007],
              [9.885590040000068, 63.595038153000075],
              [9.849864129000082, 63.597357489000046],
              [9.833262566000087, 63.60248444200005],
              [9.818207227000073, 63.61408112200007],
              [9.810801629000082, 63.62714264500005],
              [9.814463738000086, 63.63825104400007],
              [9.833262566000087, 63.64411041900007],
              [9.826426629000082, 63.653509833000044],
              [9.817149285000085, 63.65884023600006],
              [9.792246941000087, 63.66453685100004],
              [9.795583530000044, 63.66852448100008],
              [9.797373894000089, 63.67177969000005],
              [9.800059441000087, 63.674709377000056],
              [9.805918816000087, 63.67763906500005],
              [9.803396030000044, 63.68158600500004],
              [9.799082879000082, 63.691839911000045],
              [9.84343509200005, 63.69623444200005],
              [9.924082879000082, 63.71548086100006],
              [9.999847852000073, 63.723863023000035],
              [10.036306186000047, 63.73460521000004],
              [10.070974155000044, 63.74994538000004],
              [10.101410352000073, 63.767564195000034],
              [10.07593834700009, 63.76581452000005],
              [10.030284050000091, 63.74799225500004],
              [10.00521894600007, 63.746527411000045],
              [10.009613477000073, 63.75763580900008],
              [10.017588738000086, 63.76593659100007],
              [10.028005405000044, 63.77138906500005],
              [10.039317254000082, 63.77440013200004],
              [10.029551629000082, 63.78351471600007],
              [10.011973504000082, 63.78009674700007],
              [9.99187259200005, 63.77204010600008],
              [9.973887566000087, 63.767564195000034],
              [9.955821160000085, 63.76630280200004],
              [9.906586134000065, 63.75726959800005],
              [9.857595248000052, 63.731634833000044],
              [9.779551629000082, 63.72321198100008],
              [9.728851759000065, 63.70209381700005],
              [9.648936394000089, 63.699286200000074],
              [9.645681186000047, 63.69635651200008],
              [9.643809441000087, 63.69163646000004],
              [9.642832879000082, 63.687201239000046],
              [9.642100457000083, 63.68504466400003],
              [9.637054884000065, 63.68431224200003],
              [9.625824415000068, 63.68585846600007],
              [9.621104363000086, 63.68504466400003],
              [9.586761915000068, 63.67137278900003],
              [9.544118686000047, 63.66559479400007],
              [9.551280144000089, 63.68309153900003],
              [9.567881707000083, 63.70677317900004],
              [9.552744988000086, 63.71979401200008],
              [9.552744988000086, 63.72601959800005],
              [9.719493035000085, 63.762884833000044],
              [9.778086785000085, 63.767564195000034],
              [9.778086785000085, 63.77440013200004],
              [9.581309441000087, 63.759100653000075],
              [9.545909050000091, 63.77440013200004],
              [9.662771030000044, 63.818793036000045],
              [9.831228061000047, 63.86163971600007],
              [9.874278191000087, 63.86318594000005],
              [9.874278191000087, 63.86937083500004],
              [9.830739780000044, 63.87059153900003],
              [9.811208530000044, 63.87474192900004],
              [9.792246941000087, 63.883693752000056],
              [9.892100457000083, 63.90253327000005],
              [9.912364129000082, 63.90078359600005],
              [9.914561394000089, 63.891506252000056],
              [9.907725457000083, 63.886419989000046],
              [9.906748894000089, 63.884100653000075],
              [9.925791863000086, 63.883693752000056],
              [9.93685957100007, 63.88629791900007],
              [9.97046959700009, 63.90420156500005],
              [10.06804446700005, 63.917669989000046],
              [10.115977410000085, 63.941107489000046],
              [10.173675977000073, 63.93406810100004],
              [10.19703209700009, 63.93829987200007],
              [10.172373894000089, 63.95722077000005],
              [10.158864780000044, 63.96369049700007],
              [10.141774936000047, 63.96556224200003],
              [10.126149936000047, 63.96206289300005],
              [10.095713738000086, 63.94867584800005],
              [10.063975457000083, 63.94358958500004],
              [10.031260613000086, 63.93427155200004],
              [9.99390709700009, 63.929388739000046],
              [9.961924675000091, 63.918850002000056],
              [9.94312584700009, 63.918402411000045],
              [9.972666863000086, 63.941839911000045],
              [10.08725019600007, 63.966498114000046],
              [10.128103061000047, 63.98672109600005],
              [10.11304772200009, 63.98700592700004],
              [10.102224155000044, 63.982123114000046],
              [10.092133009000065, 63.97606028900003],
              [10.080332879000082, 63.97304922100005],
              [10.069590691000087, 63.97630442900004],
              [10.064463738000086, 63.98281484600005],
              [10.058604363000086, 63.98680247600004],
              [9.993011915000068, 63.964544989000046],
              [9.963063998000052, 63.95966217700004],
              [9.936289910000085, 63.959418036000045],
              [9.944834832000083, 63.97162506700005],
              [9.97234134200005, 63.98383209800005],
              [9.98414147200009, 63.993475653000075],
              [9.989268425000091, 64.00950755400004],
              [9.991221550000091, 64.02570221600007],
              [9.998057488000086, 64.03628164300005],
              [10.018239780000044, 64.03510163000004],
              [10.013926629000082, 64.04425690300008],
              [10.014414910000085, 64.04922109600005],
              [10.025645379000082, 64.06244538000004],
              [10.014821811000047, 64.07050202000005],
              [10.003184441000087, 64.08197663000004],
              [9.99577884200005, 64.09544505400004],
              [9.99781334700009, 64.10956452000005],
              [10.013682488000086, 64.11880117400005],
              [10.035817905000044, 64.11546458500004],
              [10.084320509000065, 64.10126373900005],
              [10.098399285000085, 64.09186432500007],
              [10.107920769000089, 64.08974844000005],
              [10.192067905000044, 64.10146719000005],
              [10.208832227000073, 64.10976797100005],
              [10.217539910000085, 64.12392812700006],
              [10.191416863000086, 64.11737702000005],
              [10.107676629000082, 64.11709219000005],
              [10.117360873000052, 64.13043854400007],
              [10.133799675000091, 64.13849518400008],
              [10.152598504000082, 64.14077383000006],
              [10.16968834700009, 64.13690827000005],
              [10.160980665000068, 64.14765045800004],
              [10.15601647200009, 64.15119049700007],
              [10.15601647200009, 64.15802643400008],
              [10.19703209700009, 64.15802643400008],
              [10.18523196700005, 64.16087474200003],
              [10.177907748000052, 64.16669342700004],
              [10.176768425000091, 64.17495351800005],
              [10.18336022200009, 64.18537018400008],
              [10.177582227000073, 64.18903229400007],
              [10.174489780000044, 64.19257233300004],
              [10.172373894000089, 64.19594961100006],
              [10.16968834700009, 64.19896067900004],
              [10.187754754000082, 64.19790273600006],
              [10.205414259000065, 64.19403717700004],
              [10.222178582000083, 64.19261302300004],
              [10.237315300000091, 64.19896067900004],
              [10.234385613000086, 64.20107656500005],
              [10.233409050000091, 64.20140208500004],
              [10.231130405000044, 64.20579661700003],
              [10.254649285000085, 64.20551178600005],
              [10.297129754000082, 64.20994700700004],
              [10.31999759200005, 64.20579661700003],
              [10.365082227000073, 64.18504466400003],
              [10.374522332000083, 64.18537018400008],
              [10.365407748000052, 64.20718008000006],
              [10.323496941000087, 64.22223541900007],
              [10.245371941000087, 64.23379140800006],
              [10.258799675000091, 64.24559153900003],
              [10.283702019000089, 64.25250885600008],
              [10.333506707000083, 64.26044342700004],
              [10.330821160000085, 64.26410553600005],
              [10.326833530000044, 64.27411530200004],
              [10.351573113000086, 64.27496979400007],
              [10.397308790000068, 64.26439036700003],
              [10.391856316000087, 64.27777741100005],
              [10.391368035000085, 64.28778717700004],
              [10.407481316000087, 64.28929271000004],
              [10.436289910000085, 64.28497955900008],
              [10.449392123000052, 64.29043203300006],
              [10.46257571700005, 64.29413483300004],
              [10.47632897200009, 64.29584381700005],
              [10.491221550000091, 64.29523346600007],
              [10.491221550000091, 64.30141836100006],
              [10.457692905000044, 64.30101146000004],
              [10.449554884000065, 64.31281159100007],
              [10.452159050000091, 64.33100006700005],
              [10.450205925000091, 64.34979889500005],
              [10.470957879000082, 64.35040924700007],
              [10.477549675000091, 64.34979889500005],
              [10.470713738000086, 64.35663483300004],
              [10.49390709700009, 64.35643138200004],
              [10.51734459700009, 64.35004303600005],
              [10.559418165000068, 64.32933177300004],
              [10.553558790000068, 64.34345123900005],
              [10.539317254000082, 64.35325755400004],
              [10.504730665000068, 64.36408112200007],
              [10.504730665000068, 64.37030670800004],
              [10.547536655000044, 64.36888255400004],
              [10.567393425000091, 64.36391836100006],
              [10.598317905000044, 64.34577057500007],
              [10.61459394600007, 64.34642161700003],
              [10.648936394000089, 64.35663483300004],
              [10.648936394000089, 64.36408112200007],
              [10.62086022200009, 64.36294179900005],
              [10.60710696700005, 64.36554596600007],
              [10.601084832000083, 64.37396881700005],
              [10.598399285000085, 64.38300202000005],
              [10.591319207000083, 64.38800690300008],
              [10.58139082100007, 64.39028554900005],
              [10.570323113000086, 64.39077383000006],
              [10.566905144000089, 64.39301178600005],
              [10.56421959700009, 64.39789459800005],
              [10.56023196700005, 64.40277741100005],
              [10.552989129000082, 64.40509674700007],
              [10.463877800000091, 64.40509674700007],
              [10.471039259000065, 64.41571686400005],
              [10.483083530000044, 64.42373281500005],
              [10.497325066000087, 64.42910390800006],
              [10.511566602000073, 64.43170807500007],
              [10.544118686000047, 64.42617422100005],
              [10.599131707000083, 64.40208567900004],
              [10.62826582100007, 64.39765045800004],
              [10.623220248000052, 64.41034577000005],
              [10.613129102000073, 64.42080312700006],
              [10.602224155000044, 64.42649974200003],
              [10.594248894000089, 64.42487213700008],
              [10.591970248000052, 64.43012116100005],
              [10.58765709700009, 64.43276601800005],
              [10.585459832000083, 64.43431224200003],
              [10.593272332000083, 64.44139232000003],
              [10.59929446700005, 64.44879791900007],
              [10.604746941000087, 64.45221588700008],
              [10.615244988000086, 64.45010000200006],
              [10.631114129000082, 64.44074127800008],
              [10.638926629000082, 64.43854401200008],
              [10.64625084700009, 64.43537018400008],
              [10.658864780000044, 64.42129140800006],
              [10.666270379000082, 64.41811758000006],
              [10.721202019000089, 64.41811758000006],
              [10.731944207000083, 64.41575755400004],
              [10.736664259000065, 64.41010163000004],
              [10.739756707000083, 64.40338776200008],
              [10.745127800000091, 64.39765045800004],
              [10.753754102000073, 64.39305247600004],
              [10.815114780000044, 64.37026601800005],
              [10.834971550000091, 64.36912669500003],
              [10.854991082000083, 64.37775299700007],
              [10.799327019000089, 64.40078359600005],
              [10.786631707000083, 64.41128164300005],
              [10.805186394000089, 64.42080312700006],
              [10.79664147200009, 64.43231842700004],
              [10.774587436000047, 64.44188060100004],
              [10.752614780000044, 64.44599030200004],
              [10.679942254000082, 64.43903229400007],
              [10.656423373000052, 64.44599030200004],
              [10.656423373000052, 64.45221588700008],
              [10.670420769000089, 64.45429108300004],
              [10.692149285000085, 64.46792226800005],
              [10.704112175000091, 64.47272370000007],
              [10.715098504000082, 64.47247955900008],
              [10.74000084700009, 64.46670156500005],
              [10.752614780000044, 64.46588776200008],
              [10.752777540000068, 64.46816640800006],
              [10.754405144000089, 64.47304922100005],
              [10.757334832000083, 64.47793203300006],
              [10.762217644000089, 64.48016998900005],
              [10.792816602000073, 64.48016998900005],
              [10.805837436000047, 64.47650788000004],
              [10.827321811000047, 64.46727122600004],
              [10.84115644600007, 64.46588776200008],
              [10.836924675000091, 64.48289622600004],
              [10.82748457100007, 64.49188873900005],
              [10.814707879000082, 64.49819570500006],
              [10.800303582000083, 64.50747304900005],
              [10.824717644000089, 64.51137929900005],
              [10.848399285000085, 64.50486888200004],
              [10.869313998000052, 64.49201080900008],
              [10.885427280000044, 64.47646719000005],
              [10.89226321700005, 64.47467682500007],
              [10.900238477000073, 64.48041413000004],
              [10.908457879000082, 64.48834870000007],
              [10.916351759000065, 64.49315013200004],
              [10.927256707000083, 64.49217357000003],
              [10.936208530000044, 64.48745351800005],
              [10.945485873000052, 64.48403554900005],
              [10.95671634200005, 64.48700592700004],
              [10.926280144000089, 64.50202057500007],
              [10.922618035000085, 64.50747304900005],
              [10.927907748000052, 64.51337311400005],
              [10.93881269600007, 64.51292552300004],
              [10.964121941000087, 64.50747304900005],
              [10.964121941000087, 64.51496002800008],
              [10.949880405000044, 64.52049388200004],
              [10.948741082000083, 64.52871328300006],
              [10.953623894000089, 64.53921133000006],
              [10.95671634200005, 64.55219147300005],
              [10.951670769000089, 64.55878327000005],
              [10.939952019000089, 64.56610748900005],
              [10.926442905000044, 64.57241445500006],
              [10.916351759000065, 64.57575104400007],
              [10.916351759000065, 64.58258698100008],
              [10.926768425000091, 64.58197663000004],
              [10.934825066000087, 64.58356354400007],
              [10.950450066000087, 64.59003327000005],
              [10.953461134000065, 64.59275950700004],
              [10.955739780000044, 64.59723541900007],
              [10.957041863000086, 64.60130442900004],
              [10.95671634200005, 64.60301341400003],
              [10.971202019000089, 64.60260651200008],
              [10.995371941000087, 64.59259674700007],
              [11.051931186000047, 64.57982005400004],
              [11.06031334700009, 64.57575104400007],
              [11.063487175000091, 64.56614817900004],
              [11.059743686000047, 64.54743073100008],
              [11.063487175000091, 64.53815338700008],
              [11.076182488000086, 64.52362702000005],
              [11.084320509000065, 64.52147044500003],
              [11.10132897200009, 64.52114492400005],
              [11.167246941000087, 64.48916250200006],
              [11.178070509000065, 64.47866445500006],
              [11.176117384000065, 64.46548086100006],
              [11.162771030000044, 64.44599030200004],
              [11.185069207000083, 64.44159577000005],
              [11.245371941000087, 64.45221588700008],
              [11.269786004000082, 64.45258209800005],
              [11.293955925000091, 64.44916413000004],
              [11.31771894600007, 64.44212474200003],
              [11.34156334700009, 64.43170807500007],
              [11.33179772200009, 64.41209544500003],
              [11.320323113000086, 64.39866771000004],
              [11.268728061000047, 64.36664459800005],
              [11.224864129000082, 64.32245514500005],
              [11.24740644600007, 64.32558828300006],
              [11.26734459700009, 64.33950429900005],
              [11.299978061000047, 64.37030670800004],
              [11.377614780000044, 64.39716217700004],
              [11.389333530000044, 64.40509674700007],
              [11.369965040000068, 64.41071198100008],
              [11.362071160000085, 64.41128164300005],
              [11.369639519000089, 64.42015208500004],
              [11.397227410000085, 64.44574616100005],
              [11.40984134200005, 64.45221588700008],
              [11.416758660000085, 64.45062897300005],
              [11.434580925000091, 64.44090403900003],
              [11.443369988000086, 64.43854401200008],
              [11.453868035000085, 64.43992747600004],
              [11.477386915000068, 64.45221588700008],
              [11.520274285000085, 64.46246979400007],
              [11.61264082100007, 64.46954987200007],
              [11.656260613000086, 64.48016998900005],
              [11.437754754000082, 64.46588776200008],
              [11.447764519000089, 64.47699616100005],
              [11.451670769000089, 64.49628327000005],
              [11.46070397200009, 64.51117584800005],
              [11.475271030000044, 64.51723867400005],
              [11.521332227000073, 64.51821523600006],
              [11.539561394000089, 64.52114492400005],
              [11.539561394000089, 64.52798086100006],
              [11.528086785000085, 64.52936432500007],
              [11.518077019000089, 64.53314850500004],
              [11.510427280000044, 64.53937409100007],
              [11.506032748000052, 64.54840729400007],
              [11.573741082000083, 64.55585358300004],
              [11.55445397200009, 64.54450104400007],
              [11.547048373000052, 64.54157135600008],
              [11.57007897200009, 64.53725820500006],
              [11.656260613000086, 64.56952545800004],
              [11.750498894000089, 64.58567942900004],
              [11.779795769000089, 64.59686920800004],
              [11.65951582100007, 64.59430573100008],
              [11.635752800000091, 64.58258698100008],
              [11.624522332000083, 64.59259674700007],
              [11.627940300000091, 64.60260651200008],
              [11.633555535000085, 64.61298248900005],
              [11.628916863000086, 64.62417226800005],
              [11.611175977000073, 64.62860748900005],
              [11.589121941000087, 64.62295156500005],
              [11.567881707000083, 64.61253489800004],
              [11.553233269000089, 64.60301341400003],
              [11.562673373000052, 64.59853750200006],
              [11.572764519000089, 64.59638092700004],
              [11.583506707000083, 64.59601471600007],
              [11.594737175000091, 64.59686920800004],
              [11.577159050000091, 64.57501862200007],
              [11.547618035000085, 64.56818268400008],
              [11.516774936000047, 64.57294342700004],
              [11.494883660000085, 64.58633047100005],
              [11.485524936000047, 64.59528229400007],
              [11.463877800000091, 64.61127350500004],
              [11.45443769600007, 64.62042877800008],
              [11.443369988000086, 64.62714264500005],
              [11.429535352000073, 64.63157786700003],
              [11.420664910000085, 64.63637929900005],
              [11.424082879000082, 64.64398834800005],
              [11.424082879000082, 64.65143463700008],
              [11.412608269000089, 64.65599192900004],
              [11.40202884200005, 64.66315338700008],
              [11.395681186000047, 64.67283763200004],
              [11.39616946700005, 64.68561432500007],
              [11.40202884200005, 64.68829987200007],
              [11.411387566000087, 64.68610260600008],
              [11.420176629000082, 64.68610260600008],
              [11.424082879000082, 64.69586823100008],
              [11.420664910000085, 64.69940827000005],
              [11.412608269000089, 64.70294830900008],
              [11.403330925000091, 64.70563385600008],
              [11.39616946700005, 64.70673248900005],
              [11.421071811000047, 64.71381256700005],
              [11.47982832100007, 64.71954987200007],
              [11.531748894000089, 64.74457428600005],
              [11.560394727000073, 64.74233633000006],
              [11.588552280000044, 64.73639557500007],
              [11.615896030000044, 64.74022044500003],
              [11.610036655000044, 64.74152252800008],
              [11.594737175000091, 64.74770742400005],
              [11.595225457000083, 64.75849030200004],
              [11.584157748000052, 64.76203034100007],
              [11.56771894600007, 64.76333242400005],
              [11.553233269000089, 64.76752350500004],
              [11.79037519600007, 64.78363678600005],
              [11.823252800000091, 64.79376862200007],
              [11.841807488000086, 64.79486725500004],
              [11.841807488000086, 64.80231354400007],
              [11.738780144000089, 64.80231354400007],
              [11.745616082000083, 64.80914948100008],
              [11.71656334700009, 64.81122467700004],
              [11.670909050000091, 64.82062409100007],
              [11.643239780000044, 64.82273997600004],
              [11.67709394600007, 64.83209870000007],
              [11.787282748000052, 64.83584219000005],
              [11.78679446700005, 64.84072500200006],
              [11.785492384000065, 64.84381745000007],
              [11.779795769000089, 64.85008372600004],
              [11.787282748000052, 64.85757070500006],
              [11.718923373000052, 64.84125397300005],
              [11.683604363000086, 64.83706289300005],
              [11.649424675000091, 64.84320709800005],
              [11.708506707000083, 64.85830312700006],
              [11.726084832000083, 64.87661367400005],
              [11.74545332100007, 64.88418203300006],
              [11.766449415000068, 64.88922760600008],
              [11.814463738000086, 64.89508698100008],
              [11.916840040000068, 64.92519765800006],
              [11.99195397200009, 64.93024323100008],
              [12.008799675000091, 64.93602122600004],
              [12.01929772200009, 64.94318268400008],
              [12.050954623000052, 64.95734284100007],
              [12.063731316000087, 64.95994700700004],
              [12.224864129000082, 64.93943919500003],
              [12.186289910000085, 64.95954010600008],
              [12.14389082100007, 64.96942780200004],
              [12.053477410000085, 64.97296784100007],
              [12.033457879000082, 64.96991608300004],
              [11.998057488000086, 64.95620351800005],
              [11.98218834700009, 64.95311107000003],
              [11.911631707000083, 64.94940827000005],
              [11.738780144000089, 64.89105866100005],
              [11.617035352000073, 64.86961497600004],
              [11.608409050000091, 64.86196523600006],
              [11.622080925000091, 64.85008372600004],
              [11.622080925000091, 64.84320709800005],
              [11.547618035000085, 64.81964752800008],
              [11.522471550000091, 64.81590403900003],
              [11.494965040000068, 64.81488678600005],
              [11.47828209700009, 64.81061432500007],
              [11.464854363000086, 64.80121491100005],
              [11.447438998000052, 64.78489817900004],
              [11.426768425000091, 64.77024974200003],
              [11.403330925000091, 64.75971100500004],
              [11.37859134200005, 64.75242747600004],
              [11.260996941000087, 64.73436107000003],
              [11.238536004000082, 64.74022044500003],
              [11.250987175000091, 64.74534739800004],
              [11.310069207000083, 64.75600820500006],
              [11.337901238000086, 64.76536692900004],
              [11.351410352000073, 64.76752350500004],
              [11.360524936000047, 64.77122630400004],
              [11.421397332000083, 64.80829498900005],
              [11.429698113000086, 64.81590403900003],
              [11.346364780000044, 64.80499909100007],
              [11.30241946700005, 64.82196686400005],
              [11.255056186000047, 64.81659577000005],
              [11.231700066000087, 64.82273997600004],
              [11.252696160000085, 64.83783600500004],
              [11.281993035000085, 64.84454987200007],
              [11.523773634000065, 64.86253489800004],
              [11.664886915000068, 64.89325592700004],
              [11.697113477000073, 64.91217682500007],
              [11.672536655000044, 64.91229889500005],
              [11.601573113000086, 64.89105866100005],
              [11.245371941000087, 64.85757070500006],
              [11.26726321700005, 64.86981842700004],
              [11.401377800000091, 64.92226797100005],
              [11.42318769600007, 64.92519765800006],
              [11.450205925000091, 64.92230866100005],
              [11.512217644000089, 64.89850495000007],
              [11.533376498000052, 64.89590078300006],
              [11.554209832000083, 64.89907461100006],
              [11.574473504000082, 64.90692780200004],
              [11.594737175000091, 64.91836172100005],
              [11.594737175000091, 64.92519765800006],
              [11.57789147200009, 64.92255280200004],
              [11.549327019000089, 64.90794505400004],
              [11.533946160000085, 64.90473053600005],
              [11.521983269000089, 64.90814850500004],
              [11.477386915000068, 64.93260325700004],
              [11.495371941000087, 64.94086334800005],
              [11.560069207000083, 64.95311107000003],
              [11.580088738000086, 64.95282623900005],
              [11.621104363000086, 64.94440338700008],
              [11.635752800000091, 64.94562409100007],
              [11.630707227000073, 64.94891998900005],
              [11.62240644600007, 64.95644765800006],
              [11.615896030000044, 64.95994700700004],
              [11.629079623000052, 64.96588776200008],
              [11.639821811000047, 64.96279531500005],
              [11.65015709700009, 64.95648834800005],
              [11.663096550000091, 64.95311107000003],
              [11.71062259200005, 64.95726146000004],
              [11.766774936000047, 64.97089264500005],
              [11.776377800000091, 64.97671133000006],
              [11.820160352000073, 64.98118724200003],
              [11.834971550000091, 64.98663971600007],
              [11.81771894600007, 64.99140045800004],
              [11.804535352000073, 64.99860260600008],
              [11.801524285000085, 65.00763580900008],
              [11.81421959700009, 65.01801178600005],
              [11.872569207000083, 65.04189687700006],
              [11.90756269600007, 65.04913971600007],
              [11.94312584700009, 65.06244538000004],
              [11.978526238000086, 65.06883372600004],
              [12.012461785000085, 65.05548737200007],
              [12.009287957000083, 65.04608795800004],
              [12.010101759000065, 65.03595612200007],
              [12.015472852000073, 65.02960846600007],
              [12.026133660000085, 65.03131745000007],
              [12.031423373000052, 65.03636302300004],
              [12.03874759200005, 65.05158112200007],
              [12.043467644000089, 65.05898672100005],
              [12.05445397200009, 65.06557851800005],
              [12.060394727000073, 65.06004466400003],
              [12.063161655000044, 65.05068594000005],
              [12.063731316000087, 65.04559967700004],
              [12.07593834700009, 65.03945547100005],
              [12.090017123000052, 65.04144928600005],
              [12.103688998000052, 65.04653554900005],
              [12.115570509000065, 65.04930247600004],
              [12.137054884000065, 65.04669830900008],
              [12.153168165000068, 65.03945547100005],
              [12.165863477000073, 65.02846914300005],
              [12.177012566000087, 65.01459381700005],
              [12.176361524000072, 65.01121653900003],
              [12.176036004000082, 65.00975169500003],
              [12.172618035000085, 65.00360748900005],
              [12.17318769600007, 64.99778880400004],
              [12.184336785000085, 64.99408600500004],
              [12.194021030000044, 64.99485911700003],
              [12.201508009000065, 64.99917226800005],
              [12.201670769000089, 64.99925364800004],
              [12.207286004000082, 65.00604889500005],
              [12.211192254000082, 65.01459381700005],
              [12.201833530000044, 65.01951732000003],
              [12.19312584700009, 65.02594635600008],
              [12.18685957100007, 65.03449127800008],
              [12.184336785000085, 65.04559967700004],
              [12.19312584700009, 65.05048248900005],
              [12.28093509200005, 65.06012604400007],
              [12.339040561000047, 65.08246491100005],
              [12.36882571700005, 65.09027741100005],
              [12.437998894000089, 65.08462148600006],
              [12.471527540000068, 65.08930084800005],
              [12.48609459700009, 65.11351146000004],
              [12.50749759200005, 65.12124258000006],
              [12.606455925000091, 65.12596263200004],
              [12.636241082000083, 65.13129303600005],
              [12.620371941000087, 65.13686758000006],
              [12.611989780000044, 65.13825104400007],
              [12.602224155000044, 65.13743724200003],
              [12.617360873000052, 65.14984772300005],
              [12.637217644000089, 65.15350983300004],
              [12.658376498000052, 65.15448639500005],
              [12.677256707000083, 65.15916575700004],
              [12.715586785000085, 65.18463776200008],
              [12.774587436000047, 65.21157461100006],
              [12.790537957000083, 65.21381256700005],
              [12.79623457100007, 65.21898021000004],
              [12.801036004000082, 65.23053620000007],
              [12.807383660000085, 65.24209219000005],
              [12.817881707000083, 65.24730052300004],
              [12.838063998000052, 65.25360748900005],
              [12.93100019600007, 65.31240469000005],
              [12.939952019000089, 65.32782623900005],
              [12.931813998000052, 65.33319733300004],
              [12.89625084700009, 65.31199778900003],
              [12.856618686000047, 65.29572174700007],
              [12.845550977000073, 65.28945547100005],
              [12.825368686000047, 65.27460358300004],
              [12.668223504000082, 65.19594961100006],
              [12.568695509000065, 65.16669342700004],
              [12.553721550000091, 65.16535065300008],
              [12.541026238000086, 65.16225820500006],
              [12.514903191000087, 65.14809804900005],
              [12.502777540000068, 65.14492422100005],
              [12.42904707100007, 65.13922760600008],
              [12.390147332000083, 65.14252350500004],
              [12.36882571700005, 65.15176015800006],
              [12.381683790000068, 65.17723216400003],
              [12.470550977000073, 65.18260325700004],
              [12.499196811000047, 65.20014069200005],
              [12.48764082100007, 65.20001862200007],
              [12.461273634000065, 65.20282623900005],
              [12.451426629000082, 65.20636627800008],
              [12.438324415000068, 65.21381256700005],
              [12.437836134000065, 65.21613190300008],
              [12.438731316000087, 65.22467682500007],
              [12.438324415000068, 65.22687409100007],
              [12.417002800000091, 65.23021067900004],
              [12.377940300000091, 65.22138092700004],
              [12.35515384200005, 65.21995677300004],
              [12.35515384200005, 65.22687409100007],
              [12.38998457100007, 65.24266185100004],
              [12.408213738000086, 65.24689362200007],
              [12.430918816000087, 65.24730052300004],
              [12.479991082000083, 65.24030182500007],
              [12.508067254000082, 65.24066803600005],
              [12.520192905000044, 65.25071849200003],
              [12.677012566000087, 65.24921295800004],
              [12.712087436000047, 65.25413646000004],
              [12.680674675000091, 65.26268138200004],
              [12.588145379000082, 65.26097239800004],
              [12.516449415000068, 65.26776764500005],
              [12.502696160000085, 65.26536692900004],
              [12.474782748000052, 65.25535716400003],
              [12.458181186000047, 65.25413646000004],
              [12.46265709700009, 65.26410553600005],
              [12.465017123000052, 65.26776764500005],
              [12.435720248000052, 65.27334219000005],
              [12.34546959700009, 65.26776764500005],
              [12.320567254000082, 65.26019928600005],
              [12.299489780000044, 65.24469635600008],
              [12.276215040000068, 65.23224518400008],
              [12.245290561000047, 65.23362864800004],
              [12.25717207100007, 65.24510325700004],
              [12.30046634200005, 65.26776764500005],
              [12.312022332000083, 65.27631256700005],
              [12.330577019000089, 65.29511139500005],
              [12.342133009000065, 65.30255768400008],
              [12.378103061000047, 65.30939362200007],
              [12.416270379000082, 65.30878327000005],
              [12.451426629000082, 65.31354401200008],
              [12.478688998000052, 65.33665599200003],
              [12.459971550000091, 65.33681875200006],
              [12.410329623000052, 65.32245514500005],
              [12.418630405000044, 65.33515045800004],
              [12.43295332100007, 65.34454987200007],
              [12.492035352000073, 65.36912669500003],
              [12.499196811000047, 65.37083567900004],
              [12.506358269000089, 65.36880117400005],
              [12.510264519000089, 65.36408112200007],
              [12.512950066000087, 65.35932038000004],
              [12.516449415000068, 65.35716380400004],
              [12.600840691000087, 65.35468170800004],
              [12.625743035000085, 65.34723541900007],
              [12.639659050000091, 65.33527252800008],
              [12.656504754000082, 65.32575104400007],
              [12.674489780000044, 65.32257721600007],
              [12.691579623000052, 65.32982005400004],
              [12.662771030000044, 65.35468170800004],
              [12.62435957100007, 65.35757070500006],
              [12.58334394600007, 65.35846588700008],
              [12.547048373000052, 65.36399974200003],
              [12.538096550000091, 65.37250397300005],
              [12.533946160000085, 65.39191315300008],
              [12.52702884200005, 65.40558502800008],
              [12.514821811000047, 65.41693756700005],
              [12.488780144000089, 65.43231842700004],
              [12.478688998000052, 65.44651927300004],
              [12.528005405000044, 65.44867584800005],
              [12.54859459700009, 65.44700755400004],
              [12.567393425000091, 65.43976471600007],
              [12.56999759200005, 65.43524811400005],
              [12.569021030000044, 65.42934804900005],
              [12.569021030000044, 65.42348867400005],
              [12.574229363000086, 65.41864655200004],
              [12.58334394600007, 65.41791413000004],
              [12.591644727000073, 65.42987702000005],
              [12.602224155000044, 65.43231842700004],
              [12.629242384000065, 65.42121002800008],
              [12.680674675000091, 65.37995026200008],
              [12.712087436000047, 65.37083567900004],
              [12.640798373000052, 65.41640859600005],
              [12.629405144000089, 65.43231842700004],
              [12.64975019600007, 65.45026276200008],
              [12.780284050000091, 65.45962148600006],
              [12.740977410000085, 65.46775950700004],
              [12.608409050000091, 65.45962148600006],
              [12.608409050000091, 65.46702708500004],
              [12.62077884200005, 65.46967194200005],
              [12.64389082100007, 65.47809479400007],
              [12.656911655000044, 65.48069896000004],
              [12.633799675000091, 65.48798248900005],
              [12.596527540000068, 65.48859284100007],
              [12.577972852000073, 65.49803294500003],
              [12.564626498000052, 65.51365794500003],
              [12.573252800000091, 65.51927317900004],
              [12.59351647200009, 65.52191803600005],
              [12.615733269000089, 65.52850983300004],
              [12.594248894000089, 65.53400299700007],
              [12.57943769600007, 65.54950592700004],
              [12.572601759000065, 65.56989166900007],
              [12.574229363000086, 65.58999258000006],
              [12.551931186000047, 65.56801992400005],
              [12.537119988000086, 65.53481679900005],
              [12.513682488000086, 65.51215241100005],
              [12.465017123000052, 65.52167389500005],
              [12.486338738000086, 65.53803131700005],
              [12.508148634000065, 65.54913971600007],
              [12.525726759000065, 65.56183502800008],
              [12.533864780000044, 65.58315664300005],
              [12.510020379000082, 65.57371653900003],
              [12.46656334700009, 65.53685130400004],
              [12.438324415000068, 65.52850983300004],
              [12.404307488000086, 65.53497955900008],
              [12.396494988000086, 65.55190664300005],
              [12.404307488000086, 65.57412344000005],
              [12.417165561000047, 65.59674713700008],
              [12.397308790000068, 65.59625885600008],
              [12.381683790000068, 65.59243398600006],
              [12.368418816000087, 65.59267812700006],
              [12.35515384200005, 65.60419342700004],
              [12.35710696700005, 65.60773346600007],
              [12.35914147200009, 65.61758047100005],
              [12.357676629000082, 65.62929922100005],
              [12.348887566000087, 65.63837311400005],
              [12.364105665000068, 65.65249258000006],
              [12.39820397200009, 65.67121002800008],
              [12.41374759200005, 65.68276601800005],
              [12.430430535000085, 65.70042552300004],
              [12.438324415000068, 65.70600006700005],
              [12.448008660000085, 65.71043528900003],
              [12.466807488000086, 65.71674225500004],
              [12.475596550000091, 65.72402578300006],
              [12.495371941000087, 65.73334381700005],
              [12.52507571700005, 65.73436107000003],
              [12.554535352000073, 65.72939687700006],
              [12.574229363000086, 65.72028229400007],
              [12.581309441000087, 65.71308014500005],
              [12.585459832000083, 65.70661041900007],
              [12.587412957000083, 65.69936758000006],
              [12.587901238000086, 65.68960195500006],
              [12.594248894000089, 65.68634674700007],
              [12.636241082000083, 65.68618398600006],
              [12.626475457000083, 65.68109772300005],
              [12.615733269000089, 65.67328522300005],
              [12.608246290000068, 65.66315338700008],
              [12.608409050000091, 65.65135325700004],
              [12.61500084700009, 65.65249258000006],
              [12.656911655000044, 65.63837311400005],
              [12.69312584700009, 65.64427317900004],
              [12.712412957000083, 65.64411041900007],
              [12.740896030000044, 65.62970612200007],
              [12.757823113000086, 65.63019440300008],
              [12.774912957000083, 65.63393789300005],
              [12.787119988000086, 65.63837311400005],
              [12.776866082000083, 65.64907461100006],
              [12.758148634000065, 65.65525950700004],
              [12.737071160000085, 65.65814850500004],
              [12.69662519600007, 65.65912506700005],
              [12.683604363000086, 65.66144440300008],
              [12.674327019000089, 65.66746653900003],
              [12.663584832000083, 65.67934804900005],
              [12.658457879000082, 65.69009023600006],
              [12.65593509200005, 65.70115794500003],
              [12.65015709700009, 65.70990631700005],
              [12.623301629000082, 65.71564362200007],
              [12.586436394000089, 65.72772858300004],
              [12.574229363000086, 65.73395416900007],
              [12.557790561000047, 65.75372955900008],
              [12.567149285000085, 65.76654694200005],
              [12.615733269000089, 65.78912995000007],
              [12.634287957000083, 65.80272044500003],
              [12.645355665000068, 65.80768463700008],
              [12.660329623000052, 65.80971914300005],
              [12.673106316000087, 65.80585358300004],
              [12.685069207000083, 65.79779694200005],
              [12.698741082000083, 65.79059479400007],
              [12.717539910000085, 65.78912995000007],
              [12.704600457000083, 65.80223216400003],
              [12.711192254000082, 65.82713450700004],
              [12.693695509000065, 65.83551666900007],
              [12.666188998000052, 65.83421458500004],
              [12.62631269600007, 65.82737864800004],
              [12.615733269000089, 65.82794830900008],
              [12.611664259000065, 65.83466217700004],
              [12.615733269000089, 65.85065338700008],
              [12.619802280000044, 65.85529205900008],
              [12.631358269000089, 65.85976797100005],
              [12.636241082000083, 65.86432526200008],
              [12.638926629000082, 65.87116120000007],
              [12.64039147200009, 65.88564687700006],
              [12.642425977000073, 65.89158763200004],
              [12.660411004000082, 65.91181061400005],
              [12.682302280000044, 65.92666250200006],
              [12.789073113000086, 65.96499258000006],
              [12.817393425000091, 65.96873607000003],
              [12.848480665000068, 65.96670156500005],
              [12.917491082000083, 65.95302969000005],
              [12.929698113000086, 65.94627513200004],
              [12.951670769000089, 65.93073151200008],
              [12.965830925000091, 65.92572663000004],
              [12.985362175000091, 65.92527903900003],
              [13.02279707100007, 65.92975495000007],
              [13.04037519600007, 65.92572663000004],
              [13.04859459700009, 65.91962311400005],
              [13.059336785000085, 65.90497467700004],
              [13.068207227000073, 65.89838288000004],
              [13.077321811000047, 65.89541250200006],
              [13.094004754000082, 65.89370351800005],
              [13.102549675000091, 65.89158763200004],
              [13.108083530000044, 65.89134349200003],
              [13.11491946700005, 65.89232005400004],
              [13.12045332100007, 65.89215729400007],
              [13.122894727000073, 65.88816966400003],
              [13.12273196700005, 65.87954336100006],
              [13.122894727000073, 65.87791575700004],
              [13.156993035000085, 65.85065338700008],
              [13.176036004000082, 65.85578034100007],
              [13.167002800000091, 65.87164948100008],
              [13.151052280000044, 65.89248281500005],
              [13.149668816000087, 65.91209544500003],
              [13.133555535000085, 65.92426178600005],
              [13.125987175000091, 65.93333567900004],
              [13.122894727000073, 65.94310130400004],
              [13.112559441000087, 65.94684479400007],
              [13.04851321700005, 65.94684479400007],
              [12.978363477000073, 65.95990631700005],
              [12.942393425000091, 65.97386302300004],
              [12.924327019000089, 65.99404531500005],
              [12.945567254000082, 65.99982330900008],
              [12.963145379000082, 66.01019928600005],
              [12.968028191000087, 66.02285390800006],
              [12.951508009000065, 66.03558991100005],
              [12.970550977000073, 66.05280182500007],
              [13.023610873000052, 66.06728750200006],
              [13.04037519600007, 66.08344147300005],
              [13.002207879000082, 66.08266836100006],
              [12.927256707000083, 66.06146881700005],
              [12.712087436000047, 66.04242584800005],
              [12.715505405000044, 66.04694245000007],
              [12.717133009000065, 66.05011627800008],
              [12.719574415000068, 66.05288320500006],
              [12.725596550000091, 66.05609772300005],
              [12.712901238000086, 66.06146881700005],
              [12.699392123000052, 66.06338125200006],
              [12.670420769000089, 66.06289297100005],
              [12.68718509200005, 66.07461172100005],
              [12.75171959700009, 66.10512929900005],
              [12.77320397200009, 66.11131419500003],
              [12.805918816000087, 66.11562734600005],
              [12.868988477000073, 66.13434479400007],
              [13.047536655000044, 66.15228913000004],
              [13.075368686000047, 66.14606354400007],
              [13.08952884200005, 66.14614492400005],
              [13.095550977000073, 66.15542226800005],
              [13.103688998000052, 66.16156647300005],
              [13.156748894000089, 66.16937897300005],
              [13.17351321700005, 66.17536041900007],
              [13.225352410000085, 66.18577708500004],
              [13.30600019600007, 66.21792226800005],
              [13.527191602000073, 66.24013906500005],
              [13.561778191000087, 66.23419830900008],
              [13.576508009000065, 66.21893952000005],
              [13.557383660000085, 66.20514557500007],
              [13.52320397200009, 66.19570547100005],
              [13.492849155000044, 66.19330475500004],
              [13.492849155000044, 66.18577708500004],
              [13.582286004000082, 66.18577708500004],
              [13.57162519600007, 66.17243073100008],
              [13.54460696700005, 66.15200429900005],
              [13.534434441000087, 66.13861725500004],
              [13.530121290000068, 66.12026601800005],
              [13.535899285000085, 66.11054108300004],
              [13.547699415000068, 66.10797760600008],
              [13.561778191000087, 66.11131419500003],
              [13.57357832100007, 66.11920807500007],
              [13.60092207100007, 66.14329661700003],
              [13.61695397200009, 66.15228913000004],
              [13.639659050000091, 66.15729401200008],
              [13.711924675000091, 66.15851471600007],
              [13.746592644000089, 66.16624583500004],
              [13.760264519000089, 66.16596100500004],
              [13.771006707000083, 66.16323476800005],
              [13.789805535000085, 66.15525950700004],
              [13.82162519600007, 66.14704010600008],
              [13.830414259000065, 66.14874909100007],
              [13.834808790000068, 66.15851471600007],
              [13.83179772200009, 66.16852448100008],
              [13.822438998000052, 66.17182038000004],
              [13.776621941000087, 66.17617422100005],
              [13.705088738000086, 66.17275625200006],
              [13.609548373000052, 66.18577708500004],
              [13.641123894000089, 66.22060781500005],
              [13.696462436000047, 66.23871491100005],
              [13.757823113000086, 66.24241771000004],
              [13.808116082000083, 66.23419830900008],
              [13.799164259000065, 66.22378164300005],
              [13.772959832000083, 66.21027252800008],
              [13.760264519000089, 66.19944896000004],
              [13.78842207100007, 66.20083242400005],
              [13.836680535000085, 66.22207265800006],
              [13.972911004000082, 66.23794179900005],
              [13.986175977000073, 66.24103424700007],
              [13.996348504000082, 66.24974192900004],
              [14.002289259000065, 66.26105377800008],
              [14.009776238000086, 66.27094147300005],
              [14.035980665000068, 66.27749258000006],
              [14.051605665000068, 66.28725820500006],
              [14.086761915000068, 66.29291413000004],
              [14.112803582000083, 66.30231354400007],
              [14.134613477000073, 66.31639232000003],
              [14.14389082100007, 66.33380768400008],
              [14.13054446700005, 66.34308502800008],
              [14.100108269000089, 66.33685944200005],
              [14.048350457000083, 66.31679922100005],
              [13.964040561000047, 66.30475495000007],
              [13.938487175000091, 66.29564036700003],
              [13.91537519600007, 66.27195872600004],
              [13.907481316000087, 66.26837799700007],
              [13.803477410000085, 66.27777741100005],
              [13.780284050000091, 66.28261953300006],
              [13.764333530000044, 66.29344310100004],
              [13.753754102000073, 66.29584381700005],
              [13.739268425000091, 66.28945547100005],
              [13.740407748000052, 66.27753327000005],
              [13.723643425000091, 66.26410553600005],
              [13.699066602000073, 66.25307851800005],
              [13.619802280000044, 66.24091217700004],
              [13.591644727000073, 66.24384186400005],
              [13.575450066000087, 66.26215241100005],
              [13.623220248000052, 66.27521393400008],
              [13.61304772200009, 66.28095123900005],
              [13.60092207100007, 66.28587474200003],
              [13.588145379000082, 66.28904857000003],
              [13.575450066000087, 66.28945547100005],
              [13.563487175000091, 66.28611888200004],
              [13.503184441000087, 66.25901927300004],
              [13.467539910000085, 66.25543854400007],
              [13.41374759200005, 66.24315013200004],
              [13.327321811000047, 66.24579498900005],
              [13.287364129000082, 66.24103424700007],
              [13.20476321700005, 66.20465729400007],
              [13.069346550000091, 66.17405833500004],
              [13.04037519600007, 66.17963288000004],
              [13.031586134000065, 66.19822825700004],
              [13.055186394000089, 66.21088288000004],
              [13.089366082000083, 66.22068919500003],
              [13.112478061000047, 66.23078034100007],
              [13.13445071700005, 66.24705638200004],
              [13.163096550000091, 66.25910065300008],
              [13.321299675000091, 66.30027903900003],
              [13.494313998000052, 66.29999420800004],
              [13.534434441000087, 66.30931224200003],
              [13.50562584700009, 66.31858958500004],
              [13.403493686000047, 66.31679922100005],
              [13.411306186000047, 66.32733795800004],
              [13.423350457000083, 66.33246491100005],
              [13.451914910000085, 66.33722565300008],
              [13.432871941000087, 66.34324778900003],
              [13.415537957000083, 66.34259674700007],
              [13.379893425000091, 66.33722565300008],
              [13.364756707000083, 66.33832428600005],
              [13.357920769000089, 66.34174225500004],
              [13.352386915000068, 66.34788646000004],
              [13.342051629000082, 66.35712311400005],
              [13.323496941000087, 66.36937083500004],
              [13.310883009000065, 66.37449778900003],
              [13.306976759000065, 66.36912669500003],
              [13.314707879000082, 66.35028717700004],
              [13.330821160000085, 66.33710358300004],
              [13.33765709700009, 66.32782623900005],
              [13.33179772200009, 66.32363515800006],
              [13.317393425000091, 66.32184479400007],
              [13.226573113000086, 66.29734935100004],
              [13.212087436000047, 66.29564036700003],
              [13.155284050000091, 66.30369700700004],
              [13.136566602000073, 66.30312734600005],
              [13.146820509000065, 66.30902741100005],
              [13.157725457000083, 66.31826406500005],
              [13.161631707000083, 66.32672760600008],
              [13.150238477000073, 66.33038971600007],
              [13.133799675000091, 66.32880280200004],
              [13.095550977000073, 66.31679922100005],
              [13.06413821700005, 66.31435781500005],
              [13.037282748000052, 66.31997304900005],
              [13.015635613000086, 66.33413320500006],
              [13.000010613000086, 66.35712311400005],
              [13.140961134000065, 66.38613515800006],
              [13.170664910000085, 66.41233958500004],
              [13.16570071700005, 66.41640859600005],
              [13.161306186000047, 66.42206452000005],
              [13.158213738000086, 66.42894114800004],
              [13.156993035000085, 66.43659088700008],
              [13.149668816000087, 66.44354889500005],
              [13.102549675000091, 66.45392487200007],
              [13.116221550000091, 66.45921458500004],
              [13.131683790000068, 66.46092357000003],
              [13.16382897200009, 66.46015045800004],
              [13.16382897200009, 66.46698639500005],
              [13.148773634000065, 66.47040436400005],
              [13.117035352000073, 66.47138092700004],
              [13.102549675000091, 66.47443268400008],
              [13.092784050000091, 66.48167552300004],
              [13.087901238000086, 66.49046458500004],
              [13.08179772200009, 66.49799225500004],
              [13.068207227000073, 66.50112539300005],
              [13.040537957000083, 66.50202057500007],
              [13.017100457000083, 66.50527578300006],
              [12.995371941000087, 66.51178620000007],
              [12.97201582100007, 66.52220286700003],
              [13.102549675000091, 66.54271067900004],
              [13.113454623000052, 66.54047272300005],
              [13.133311394000089, 66.53066640800006],
              [13.185883009000065, 66.52155182500007],
              [13.208994988000086, 66.51410553600005],
              [13.219086134000065, 66.50482819200005],
              [13.22242272200009, 66.49079010600008],
              [13.228526238000086, 66.47846100500004],
              [13.231455925000091, 66.46808502800008],
              [13.225352410000085, 66.46015045800004],
              [13.225352410000085, 66.45392487200007],
              [13.362071160000085, 66.45551178600005],
              [13.397227410000085, 66.46698639500005],
              [13.287852410000085, 66.46010976800005],
              [13.266856316000087, 66.46698639500005],
              [13.270518425000091, 66.48383209800005],
              [13.284434441000087, 66.49848053600005],
              [13.287771030000044, 66.50950755400004],
              [13.25953209700009, 66.51536692900004],
              [13.25953209700009, 66.52220286700003],
              [13.28492272200009, 66.52411530200004],
              [13.330332879000082, 66.53900788000004],
              [13.355967644000089, 66.54271067900004],
              [13.441416863000086, 66.53994375200006],
              [13.465830925000091, 66.54645416900007],
              [13.489431186000047, 66.55011627800008],
              [13.517588738000086, 66.54462311400005],
              [13.568614129000082, 66.52846914300005],
              [13.619151238000086, 66.51902903900003],
              [13.671071811000047, 66.51536692900004],
              [13.648936394000089, 66.53058502800008],
              [13.623383009000065, 66.53876373900005],
              [13.479991082000083, 66.55499909100007],
              [13.45875084700009, 66.56378815300008],
              [13.507090691000087, 66.58429596600007],
              [13.60132897200009, 66.60724518400008],
              [13.72624759200005, 66.60480377800008],
              [13.687510613000086, 66.61579010600008],
              [13.502777540000068, 66.60651276200008],
              [13.47242272200009, 66.59735748900005],
              [13.423350457000083, 66.56281159100007],
              [13.396332227000073, 66.55731842700004],
              [13.335215691000087, 66.55634186400005],
              [13.270355665000068, 66.54791901200008],
              [13.239024285000085, 66.54840729400007],
              [13.20484459700009, 66.55634186400005],
              [13.209727410000085, 66.57367584800005],
              [13.21810957100007, 66.58307526200008],
              [13.24586022200009, 66.59796784100007],
              [13.239268425000091, 66.60089752800008],
              [13.232758009000065, 66.60480377800008],
              [13.250010613000086, 66.61383698100008],
              [13.288259311000047, 66.61640045800004],
              [13.332204623000052, 66.62628815300008],
              [13.381602410000085, 66.61908600500004],
              [13.403493686000047, 66.62523021000004],
              [13.373301629000082, 66.63328685100004],
              [13.250743035000085, 66.63312409100007],
              [13.170664910000085, 66.65192291900007],
              [13.19117272200009, 66.66657135600008],
              [13.213877800000091, 66.66254303600005],
              [13.237315300000091, 66.65399811400005],
              [13.260101759000065, 66.65534088700008],
              [13.283946160000085, 66.66071198100008],
              [13.306976759000065, 66.65692780200004],
              [13.328868035000085, 66.64984772300005],
              [13.348887566000087, 66.64573802300004],
              [13.375336134000065, 66.64809804900005],
              [13.42514082100007, 66.65916575700004],
              [13.451914910000085, 66.65875885600008],
              [13.521332227000073, 66.64061107000003],
              [13.547373894000089, 66.63825104400007],
              [13.522634311000047, 66.66107819200005],
              [13.48015384200005, 66.67527903900003],
              [13.266856316000087, 66.70164622600004],
              [13.225352410000085, 66.71401601800005],
              [13.256032748000052, 66.72406647300005],
              [13.493174675000091, 66.71401601800005],
              [13.500254754000082, 66.71084219000005],
              [13.516612175000091, 66.69672272300005],
              [13.527598504000082, 66.69354889500005],
              [13.69312584700009, 66.69131094000005],
              [13.718760613000086, 66.70038483300004],
              [13.698252800000091, 66.70722077000005],
              [13.698252800000091, 66.71401601800005],
              [13.799001498000052, 66.71149323100008],
              [13.85124759200005, 66.71710846600007],
              [13.890147332000083, 66.73509349200003],
              [13.711924675000091, 66.73509349200003],
              [13.676931186000047, 66.73078034100007],
              [13.61068769600007, 66.71417877800008],
              [13.575450066000087, 66.71401601800005],
              [13.547129754000082, 66.72431061400005],
              [13.543223504000082, 66.73920319200005],
              [13.558767123000052, 66.75348541900007],
              [13.589121941000087, 66.76178620000007],
              [13.718028191000087, 66.75055573100008],
              [13.752940300000091, 66.76178620000007],
              [13.721039259000065, 66.76951732000003],
              [13.563649936000047, 66.77716705900008],
              [13.551280144000089, 66.77236562700006],
              [13.543304884000065, 66.77147044500003],
              [13.507090691000087, 66.78229401200008],
              [13.541840040000068, 66.80320872600004],
              [13.612152540000068, 66.80980052300004],
              [13.68726647200009, 66.80703359600005],
              [13.768321160000085, 66.79262929900005],
              [13.993011915000068, 66.78974030200004],
              [13.948008660000085, 66.80019765800006],
              [13.801442905000044, 66.80955638200004],
              [13.785411004000082, 66.81366608300004],
              [13.758474155000044, 66.83234284100007],
              [13.739268425000091, 66.83755117400005],
              [13.70289147200009, 66.83222077000005],
              [13.688324415000068, 66.83502838700008],
              [13.677907748000052, 66.85114166900007],
              [13.684255405000044, 66.85211823100008],
              [13.693369988000086, 66.85639069200005],
              [13.698252800000091, 66.85797760600008],
              [13.68523196700005, 66.86127350500004],
              [13.657074415000068, 66.86371491100005],
              [13.64389082100007, 66.86798737200007],
              [13.637705925000091, 66.87470123900005],
              [13.636241082000083, 66.89166901200008],
              [13.63062584700009, 66.89960358300004],
              [13.605723504000082, 66.90688711100006],
              [13.547536655000044, 66.89960358300004],
              [13.520762566000087, 66.90574778900003],
              [13.543630405000044, 66.92186107000003],
              [13.564952019000089, 66.93235911700003],
              [13.589691602000073, 66.93817780200004],
              [13.744476759000065, 66.93695709800005],
              [13.780284050000091, 66.94611237200007],
              [13.772959832000083, 66.95087311400005],
              [13.768321160000085, 66.95612213700008],
              [13.760264519000089, 66.96784088700008],
              [13.839040561000047, 66.96409739800004],
              [13.862803582000083, 66.96784088700008],
              [13.869151238000086, 66.97150299700007],
              [13.88217207100007, 66.98346588700008],
              [13.890147332000083, 66.98834870000007],
              [13.901621941000087, 66.99213288000004],
              [13.913259311000047, 66.99396393400008],
              [13.938487175000091, 66.99457428600005],
              [13.972666863000086, 66.99457428600005],
              [13.957774285000085, 66.97402578300006],
              [13.936289910000085, 66.96600983300004],
              [13.912445509000065, 66.96198151200008],
              [13.890147332000083, 66.95355866100005],
              [13.917491082000083, 66.92890045800004],
              [13.934580925000091, 66.92218659100007],
              [13.958994988000086, 66.92694733300004],
              [13.951914910000085, 66.92792389500005],
              [13.931651238000086, 66.93309153900003],
              [13.979991082000083, 66.95355866100005],
              [13.982269727000073, 66.95673248900005],
              [13.983164910000085, 66.96161530200004],
              [13.98568769600007, 66.96596914300005],
              [13.993011915000068, 66.96784088700008],
              [14.020518425000091, 66.96637604400007],
              [14.027842644000089, 66.96784088700008],
              [14.043793165000068, 66.98094310100004],
              [14.04273522200009, 66.99506256700005],
              [14.03093509200005, 67.00922272300005],
              [14.014333530000044, 67.02252838700008],
              [14.02320397200009, 67.03001536700003],
              [14.03288821700005, 67.04865143400008],
              [14.040293816000087, 67.05597565300008],
              [14.05990644600007, 67.06085846600007],
              [14.071543816000087, 67.05341217700004],
              [14.078868035000085, 67.04242584800005],
              [14.08562259200005, 67.03681061400005],
              [14.08529707100007, 67.03042226800005],
              [14.09929446700005, 67.00307851800005],
              [14.109385613000086, 66.99066803600005],
              [14.151540561000047, 66.97162506700005],
              [14.164561394000089, 66.97907135600008],
              [14.17709394600007, 66.97955963700008],
              [14.190684441000087, 66.97654857000003],
              [14.20085696700005, 66.97760651200008],
              [14.21070397200009, 66.98016998900005],
              [14.222829623000052, 66.98151276200008],
              [14.226735873000052, 66.98358795800004],
              [14.22624759200005, 66.99258047100005],
              [14.229665561000047, 66.99457428600005],
              [14.25171959700009, 67.00385163000004],
              [14.269053582000083, 67.02399323100008],
              [14.270762566000087, 67.04315827000005],
              [14.246348504000082, 67.04979075700004],
              [14.272146030000044, 67.06000397300005],
              [14.418223504000082, 67.06342194200005],
              [14.437347852000073, 67.06024811400005],
              [14.474131707000083, 67.04612864800004],
              [14.493418816000087, 67.04295482000003],
              [14.529551629000082, 67.04848867400005],
              [14.54428144600007, 67.04535553600005],
              [14.555430535000085, 67.02928294500003],
              [14.55250084700009, 67.01850006700005],
              [14.568207227000073, 67.01813385600008],
              [14.587738477000073, 67.02676015800006],
              [14.595876498000052, 67.04295482000003],
              [14.581309441000087, 67.05841705900008],
              [14.551768425000091, 67.06411367400005],
              [14.496836785000085, 67.06342194200005],
              [14.37671959700009, 67.07770416900007],
              [14.290049675000091, 67.07583242400005],
              [14.267425977000073, 67.08392975500004],
              [14.287445509000065, 67.08982982000003],
              [14.303721550000091, 67.10089752800008],
              [14.319021030000044, 67.11383698100008],
              [14.335785352000073, 67.12490469000005],
              [14.321787957000083, 67.13641998900005],
              [14.328135613000086, 67.14704010600008],
              [14.345225457000083, 67.15521881700005],
              [14.36304772200009, 67.15965403900003],
              [14.451914910000085, 67.16583893400008],
              [14.442149285000085, 67.15924713700008],
              [14.427989129000082, 67.14508698100008],
              [14.41570071700005, 67.12938060100004],
              [14.411387566000087, 67.11871979400007],
              [14.422862175000091, 67.10944245000007],
              [14.44076582100007, 67.11517975500004],
              [14.459320509000065, 67.12775299700007],
              [14.472911004000082, 67.13922760600008],
              [14.467458530000044, 67.14252350500004],
              [14.46461022200009, 67.14565664300005],
              [14.46257571700005, 67.14899323100008],
              [14.459239129000082, 67.15281810100004],
              [14.676931186000047, 67.15957265800006],
              [14.709239129000082, 67.15082428600005],
              [14.733653191000087, 67.12490469000005],
              [14.743337436000047, 67.11831289300005],
              [14.750336134000065, 67.12392812700006],
              [14.750743035000085, 67.13515859600005],
              [14.747243686000047, 67.14541250200006],
              [14.736664259000065, 67.15582916900007],
              [14.723155144000089, 67.16120026200008],
              [14.651377800000091, 67.17670319200005],
              [14.513926629000082, 67.18012116100005],
              [14.53646894600007, 67.19009023600006],
              [14.56999759200005, 67.20001862200007],
              [14.603770379000082, 67.20425039300005],
              [14.627207879000082, 67.19721100500004],
              [14.651621941000087, 67.18524811400005],
              [14.678721550000091, 67.18781159100007],
              [14.705821160000085, 67.19594961100006],
              [14.742523634000065, 67.20278554900005],
              [14.76734459700009, 67.21214427300004],
              [14.781423373000052, 67.21430084800005],
              [14.882985873000052, 67.20620351800005],
              [14.979340040000068, 67.21430084800005],
              [14.979340040000068, 67.20685455900008],
              [14.937673373000052, 67.20453522300005],
              [14.924815300000091, 67.20062897300005],
              [14.932627800000091, 67.18048737200007],
              [14.91968834700009, 67.17194245000007],
              [14.900726759000065, 67.16575755400004],
              [14.890635613000086, 67.15281810100004],
              [14.899099155000044, 67.14158763200004],
              [14.94117272200009, 67.12368398600006],
              [14.972911004000082, 67.10382721600007],
              [14.99390709700009, 67.09906647300005],
              [15.007985873000052, 67.10219961100006],
              [15.003916863000086, 67.11493561400005],
              [14.986338738000086, 67.12824127800008],
              [14.949229363000086, 67.14191315300008],
              [14.931651238000086, 67.15281810100004],
              [14.944183790000068, 67.15766022300005],
              [15.005381707000083, 67.19741445500006],
              [15.019541863000086, 67.20408763200004],
              [15.07398522200009, 67.21336497600004],
              [15.094574415000068, 67.21336497600004],
              [15.129893425000091, 67.19578685100004],
              [15.150889519000089, 67.19310130400004],
              [15.218597852000073, 67.19228750200006],
              [15.239431186000047, 67.18789297100005],
              [15.281748894000089, 67.17328522300005],
              [15.300629102000073, 67.16901276200008],
              [15.35678144600007, 67.16583893400008],
              [15.383311394000089, 67.15672435100004],
              [15.394704623000052, 67.14203522300005],
              [15.39193769600007, 67.12213776200008],
              [15.37671959700009, 67.09760163000004],
              [15.40406334700009, 67.08441803600005],
              [15.435557488000086, 67.07575104400007],
              [15.469004754000082, 67.07119375200006],
              [15.501475457000083, 67.07025788000004],
              [15.491221550000091, 67.08051178600005],
              [15.45484459700009, 67.09007396000004],
              [15.438731316000087, 67.09760163000004],
              [15.442393425000091, 67.10805898600006],
              [15.438731316000087, 67.11871979400007],
              [15.47046959700009, 67.14276764500005],
              [15.480316602000073, 67.15281810100004],
              [15.472911004000082, 67.15281810100004],
              [15.455414259000065, 67.17177969000005],
              [15.400726759000065, 67.18789297100005],
              [15.37671959700009, 67.20062897300005],
              [15.410492384000065, 67.21312083500004],
              [15.455088738000086, 67.21356842700004],
              [15.716319207000083, 67.17328522300005],
              [15.740407748000052, 67.17328522300005],
              [15.733164910000085, 67.18756745000007],
              [15.72038821700005, 67.19330475500004],
              [15.705577019000089, 67.19745514500005],
              [15.692637566000087, 67.20685455900008],
              [15.706309441000087, 67.21430084800005],
              [15.606211785000085, 67.20282623900005],
              [15.55046634200005, 67.21954987200007],
              [15.40796959700009, 67.23574453300006],
              [15.383555535000085, 67.23468659100007],
              [15.35678144600007, 67.22797272300005],
              [15.311696811000047, 67.20888906500005],
              [15.287445509000065, 67.20563385600008],
              [15.261241082000083, 67.21430084800005],
              [15.283213738000086, 67.22060781500005],
              [15.307627800000091, 67.22190989800004],
              [15.329112175000091, 67.22630442900004],
              [15.342458530000044, 67.24160390800006],
              [15.28296959700009, 67.24701569200005],
              [15.268077019000089, 67.24469635600008],
              [15.255381707000083, 67.24030182500007],
              [15.240977410000085, 67.23712799700007],
              [15.212738477000073, 67.23476797100005],
              [15.062510613000086, 67.24774811400005],
              [15.07781009200005, 67.26044342700004],
              [15.097911004000082, 67.26365794500003],
              [15.118988477000073, 67.26439036700003],
              [15.137705925000091, 67.26951732000003],
              [15.147471550000091, 67.27773672100005],
              [15.165049675000091, 67.31049225500004],
              [15.137950066000087, 67.31102122600004],
              [15.055186394000089, 67.29621002800008],
              [15.027842644000089, 67.29425690300008],
              [15.013519727000073, 67.29165273600006],
              [15.007334832000083, 67.28628164300005],
              [15.004730665000068, 67.27871328300006],
              [14.998301629000082, 67.27350495000007],
              [14.989512566000087, 67.27049388200004],
              [14.979991082000083, 67.26951732000003],
              [14.909353061000047, 67.27472565300008],
              [14.774587436000047, 67.26951732000003],
              [14.789235873000052, 67.26365794500003],
              [14.820648634000065, 67.26117584800005],
              [14.835459832000083, 67.25527578300006],
              [14.811208530000044, 67.24469635600008],
              [14.673838738000086, 67.21670156500005],
              [14.61695397200009, 67.21430084800005],
              [14.672862175000091, 67.23371002800008],
              [14.694590691000087, 67.24843984600005],
              [14.692067905000044, 67.26951732000003],
              [14.699473504000082, 67.27570221600007],
              [14.681813998000052, 67.27826569200005],
              [14.662445509000065, 67.27472565300008],
              [14.623789910000085, 67.26211172100005],
              [14.575694207000083, 67.25189850500004],
              [14.410899285000085, 67.24774811400005],
              [14.390635613000086, 67.24433014500005],
              [14.370290561000047, 67.23798248900005],
              [14.34937584700009, 67.23505280200004],
              [14.328298373000052, 67.24160390800006],
              [14.391612175000091, 67.25983307500007],
              [14.411387566000087, 67.26951732000003],
              [14.406911655000044, 67.27806224200003],
              [14.417816602000073, 67.28449127800008],
              [14.451914910000085, 67.29621002800008],
              [14.492198113000086, 67.32290273600006],
              [14.601735873000052, 67.37734609600005],
              [14.611582879000082, 67.38788483300004],
              [14.60523522200009, 67.39378489800004],
              [14.57593834700009, 67.39240143400008],
              [14.57593834700009, 67.39862702000005],
              [14.586680535000085, 67.39862702000005],
              [14.59701582100007, 67.40009186400005],
              [14.61695397200009, 67.40607330900008],
              [14.623057488000086, 67.42064036700003],
              [14.652517123000052, 67.42633698100008],
              [14.742442254000082, 67.42007070500006],
              [14.771983269000089, 67.42328522300005],
              [14.799978061000047, 67.42182038000004],
              [14.822438998000052, 67.40607330900008],
              [14.814300977000073, 67.40277741100005],
              [14.807871941000087, 67.39801666900007],
              [14.795095248000052, 67.38556549700007],
              [14.824717644000089, 67.37832265800006],
              [14.854014519000089, 67.38898346600007],
              [14.882985873000052, 67.40477122600004],
              [14.91146894600007, 67.41290924700007],
              [14.94467207100007, 67.41596100500004],
              [14.982758009000065, 67.42381419500003],
              [15.049001498000052, 67.44700755400004],
              [14.93913821700005, 67.44086334800005],
              [14.822438998000052, 67.44700755400004],
              [14.82781009200005, 67.45010000200006],
              [14.842784050000091, 67.46133047100005],
              [14.822520379000082, 67.46600983300004],
              [14.784190300000091, 67.46246979400007],
              [14.767751498000052, 67.46747467700004],
              [14.780772332000083, 67.47500234600005],
              [14.768565300000091, 67.48078034100007],
              [14.75521894600007, 67.48525625200006],
              [14.741221550000091, 67.48786041900007],
              [14.726817254000082, 67.48867422100005],
              [14.740082227000073, 67.50096263200004],
              [14.765798373000052, 67.51434967700004],
              [14.794118686000047, 67.52521393400008],
              [14.990407748000052, 67.57062409100007],
              [15.058848504000082, 67.57733795800004],
              [15.083506707000083, 67.57367584800005],
              [15.115407748000052, 67.56395091400003],
              [15.14389082100007, 67.55060455900008],
              [15.158864780000044, 67.53579336100006],
              [15.14616946700005, 67.53237539300005],
              [15.133311394000089, 67.53050364800004],
              [15.106944207000083, 67.52960846600007],
              [15.09734134200005, 67.53172435100004],
              [15.080414259000065, 67.54116445500006],
              [15.051524285000085, 67.54926178600005],
              [15.030039910000085, 67.55975983300004],
              [15.008311394000089, 67.56366608300004],
              [14.986827019000089, 67.54950592700004],
              [15.006032748000052, 67.54083893400008],
              [15.036387566000087, 67.51854075700004],
              [15.055186394000089, 67.51593659100007],
              [15.010427280000044, 67.48700592700004],
              [14.885020379000082, 67.48639557500007],
              [14.829274936000047, 67.47500234600005],
              [14.853851759000065, 67.47016022300005],
              [14.987152540000068, 67.46596914300005],
              [15.016774936000047, 67.46873607000003],
              [15.038096550000091, 67.47801341400003],
              [15.055918816000087, 67.48871491100005],
              [15.079356316000087, 67.49628327000005],
              [15.103688998000052, 67.50079987200007],
              [15.124034050000091, 67.50226471600007],
              [15.141774936000047, 67.50690338700008],
              [15.158946160000085, 67.51577383000006],
              [15.175791863000086, 67.52130768400008],
              [15.192881707000083, 67.51593659100007],
              [15.188161655000044, 67.50869375200006],
              [15.191416863000086, 67.50165436400005],
              [15.200368686000047, 67.49648672100005],
              [15.212738477000073, 67.49481842700004],
              [15.212738477000073, 67.48867422100005],
              [15.197927280000044, 67.48403554900005],
              [15.182871941000087, 67.48183828300006],
              [15.151377800000091, 67.48114655200004],
              [15.151377800000091, 67.47500234600005],
              [15.157074415000068, 67.47370026200008],
              [15.172373894000089, 67.46747467700004],
              [15.164398634000065, 67.45502350500004],
              [15.153575066000087, 67.44647858300004],
              [15.143321160000085, 67.43671295800004],
              [15.137705925000091, 67.42035553600005],
              [15.15560957100007, 67.42438385600008],
              [15.18921959700009, 67.44285716400003],
              [15.209646030000044, 67.44700755400004],
              [15.217133009000065, 67.44953034100007],
              [15.222666863000086, 67.45571523600006],
              [15.225840691000087, 67.46356842700004],
              [15.227061394000089, 67.47125885600008],
              [15.231130405000044, 67.47606028900003],
              [15.240977410000085, 67.47919342700004],
              [15.371267123000052, 67.48773834800005],
              [15.42904707100007, 67.48297760600008],
              [15.472911004000082, 67.46133047100005],
              [15.479340040000068, 67.45278554900005],
              [15.492198113000086, 67.43146393400008],
              [15.541758660000085, 67.37938060100004],
              [15.543955925000091, 67.37352122600004],
              [15.545583530000044, 67.35846588700008],
              [15.54859459700009, 67.35146719000005],
              [15.551524285000085, 67.35028717700004],
              [15.57593834700009, 67.33100006700005],
              [15.60914147200009, 67.31509023600006],
              [15.644786004000082, 67.30304596600007],
              [15.644786004000082, 67.29621002800008],
              [15.60482832100007, 67.29092031500005],
              [15.603526238000086, 67.28034088700008],
              [15.626149936000047, 67.27260976800005],
              [15.658457879000082, 67.27570221600007],
              [15.700043165000068, 67.30304596600007],
              [15.692230665000068, 67.31264883000006],
              [15.637950066000087, 67.32416413000004],
              [15.621429884000065, 67.33368561400005],
              [15.618662957000083, 67.33954498900005],
              [15.620371941000087, 67.34613678600005],
              [15.617442254000082, 67.35765208500004],
              [15.59929446700005, 67.37685781500005],
              [15.596446160000085, 67.38251373900005],
              [15.585459832000083, 67.39557526200008],
              [15.56031334700009, 67.40961334800005],
              [15.514414910000085, 67.42649974200003],
              [15.529958530000044, 67.43886953300006],
              [15.566416863000086, 67.45132070500006],
              [15.582774285000085, 67.46133047100005],
              [15.554209832000083, 67.46076080900008],
              [15.54078209700009, 67.46246979400007],
              [15.52865644600007, 67.46747467700004],
              [15.558441602000073, 67.49335358300004],
              [15.597911004000082, 67.50991445500006],
              [15.786306186000047, 67.55060455900008],
              [15.897959832000083, 67.55687083500004],
              [15.868174675000091, 67.57322825700004],
              [15.668142123000052, 67.55194733300004],
              [15.555918816000087, 67.51593659100007],
              [15.498708530000044, 67.51048411700003],
              [15.26734459700009, 67.52435944200005],
              [15.239268425000091, 67.52924225500004],
              [15.227061394000089, 67.53949616100005],
              [15.228363477000073, 67.55878327000005],
              [15.233409050000091, 67.56671784100007],
              [15.261241082000083, 67.57733795800004],
              [15.255707227000073, 67.57868073100008],
              [15.240733269000089, 67.58421458500004],
              [15.275645379000082, 67.59357330900008],
              [15.307871941000087, 67.59414297100005],
              [15.37671959700009, 67.58421458500004],
              [15.410899285000085, 67.58344147300005],
              [15.425629102000073, 67.57916901200008],
              [15.436371290000068, 67.55980052300004],
              [15.44662519600007, 67.56171295800004],
              [15.458181186000047, 67.56891510600008],
              [15.466075066000087, 67.57733795800004],
              [15.418793165000068, 67.60468170800004],
              [15.424327019000089, 67.60586172100005],
              [15.438731316000087, 67.61212799700007],
              [15.423838738000086, 67.62384674700007],
              [15.406586134000065, 67.63129303600005],
              [15.388194207000083, 67.63239166900007],
              [15.37045332100007, 67.62518952000005],
              [15.380381707000083, 67.61517975500004],
              [15.384043816000087, 67.61212799700007],
              [15.35914147200009, 67.60521067900004],
              [15.330821160000085, 67.61127350500004],
              [15.301768425000091, 67.62099844000005],
              [15.274912957000083, 67.62518952000005],
              [15.222911004000082, 67.61188385600008],
              [15.194346550000091, 67.60871002800008],
              [15.178558790000068, 67.61835358300004],
              [15.196462436000047, 67.64459870000007],
              [15.336924675000091, 67.68720123900005],
              [15.304942254000082, 67.68659088700008],
              [15.289398634000065, 67.68842194200005],
              [15.274912957000083, 67.69403717700004],
              [15.291514519000089, 67.71491120000007],
              [15.301117384000065, 67.72020091400003],
              [15.31576582100007, 67.72199127800008],
              [15.330332879000082, 67.72036367400005],
              [15.368662957000083, 67.71027252800008],
              [15.412282748000052, 67.68891022300005],
              [15.541758660000085, 67.67357005400004],
              [15.521739129000082, 67.68964264500005],
              [15.514414910000085, 67.69403717700004],
              [15.658457879000082, 67.68040599200003],
              [15.58725019600007, 67.70433177300004],
              [15.548106316000087, 67.71124909100007],
              [15.486582879000082, 67.69891998900005],
              [15.457286004000082, 67.70783112200007],
              [15.404551629000082, 67.73505280200004],
              [15.404551629000082, 67.74188873900005],
              [15.596934441000087, 67.74884674700007],
              [15.658457879000082, 67.73505280200004],
              [15.799652540000068, 67.67902252800008],
              [15.82203209700009, 67.67780182500007],
              [15.836599155000044, 67.69403717700004],
              [15.821055535000085, 67.69358958500004],
              [15.806813998000052, 67.69574616100005],
              [15.793793165000068, 67.70042552300004],
              [15.781911655000044, 67.70770905200004],
              [15.785329623000052, 67.71430084800005],
              [15.785492384000065, 67.72186920800004],
              [15.78874759200005, 67.72821686400005],
              [15.669200066000087, 67.76178620000007],
              [15.63054446700005, 67.76235586100006],
              [15.640635613000086, 67.77533600500004],
              [15.657481316000087, 67.78245677300004],
              [15.676280144000089, 67.78807200700004],
              [15.692637566000087, 67.79645416900007],
              [15.67514082100007, 67.79669830900008],
              [15.65984134200005, 67.79376862200007],
              [15.61109459700009, 67.77631256700005],
              [15.594981316000087, 67.77387116100005],
              [15.411387566000087, 67.79645416900007],
              [15.42156009200005, 67.81313711100006],
              [15.446136915000068, 67.83218008000006],
              [15.446055535000085, 67.84491608300004],
              [15.432790561000047, 67.86074453300006],
              [15.420909050000091, 67.85683828300006],
              [15.411143425000091, 67.84186432500007],
              [15.404551629000082, 67.82440827000005],
              [15.383555535000085, 67.85529205900008],
              [15.369476759000065, 67.86517975500004],
              [15.35678144600007, 67.85114166900007],
              [15.360118035000085, 67.84345123900005],
              [15.378916863000086, 67.81492747600004],
              [15.384043816000087, 67.80390045800004],
              [15.308929884000065, 67.77602773600006],
              [15.262217644000089, 67.75226471600007],
              [15.223806186000047, 67.74335358300004],
              [15.193695509000065, 67.71991608300004],
              [15.181976759000065, 67.71454498900005],
              [15.162445509000065, 67.71246979400007],
              [15.04070071700005, 67.67755768400008],
              [14.952403191000087, 67.66364166900007],
              [14.93531334700009, 67.65619538000004],
              [14.918142123000052, 67.65151601800005],
              [14.836110873000052, 67.64252350500004],
              [14.808441602000073, 67.64834219000005],
              [14.752696160000085, 67.64801666900007],
              [14.726817254000082, 67.65936920800004],
              [14.876963738000086, 67.70026276200008],
              [14.876963738000086, 67.70770905200004],
              [14.780772332000083, 67.71454498900005],
              [14.792979363000086, 67.72882721600007],
              [14.81413821700005, 67.72890859600005],
              [14.837412957000083, 67.72443268400008],
              [14.856455925000091, 67.72508372600004],
              [14.875498894000089, 67.73114655200004],
              [15.117198113000086, 67.74188873900005],
              [15.08757571700005, 67.74848053600005],
              [15.049978061000047, 67.74494049700007],
              [15.01531009200005, 67.74664948100008],
              [14.993662957000083, 67.76923248900005],
              [15.015147332000083, 67.77460358300004],
              [15.034678582000083, 67.78286367400005],
              [14.876963738000086, 67.77326080900008],
              [14.829274936000047, 67.76235586100006],
              [14.83961022200009, 67.76581452000005],
              [14.843028191000087, 67.76923248900005],
              [14.83961022200009, 67.77260976800005],
              [14.829274936000047, 67.77602773600006],
              [14.831228061000047, 67.79181549700007],
              [14.819346550000091, 67.79743073100008],
              [14.802256707000083, 67.79401276200008],
              [14.788340691000087, 67.78286367400005],
              [14.778575066000087, 67.78489817900004],
              [14.769541863000086, 67.78974030200004],
              [14.761241082000083, 67.79645416900007],
              [14.754079623000052, 67.80390045800004],
              [14.772959832000083, 67.81598541900007],
              [14.789398634000065, 67.82282135600008],
              [14.806976759000065, 67.82534414300005],
              [14.873220248000052, 67.82294342700004],
              [14.959320509000065, 67.83722565300008],
              [15.063243035000085, 67.83877187700006],
              [15.10287519600007, 67.85114166900007],
              [15.07585696700005, 67.86151764500005],
              [14.849619988000086, 67.84491608300004],
              [14.849619988000086, 67.85114166900007],
              [14.859222852000073, 67.85057200700004],
              [14.867442254000082, 67.85187409100007],
              [14.883799675000091, 67.85854726800005],
              [14.899424675000091, 67.87299225500004],
              [14.945323113000086, 67.88678620000007],
              [14.998708530000044, 67.89545319200005],
              [15.036306186000047, 67.89447663000004],
              [15.084971550000091, 67.88727448100008],
              [15.192067905000044, 67.88605377800008],
              [15.233246290000068, 67.87221914300005],
              [15.216319207000083, 67.86823151200008],
              [15.201182488000086, 67.85980866100005],
              [15.193369988000086, 67.84735748900005],
              [15.199066602000073, 67.83124420800004],
              [15.30209394600007, 67.89036692900004],
              [15.336924675000091, 67.89956289300005],
              [15.338063998000052, 67.89183177300004],
              [15.359873894000089, 67.89166901200008],
              [15.483164910000085, 67.91766998900005],
              [15.535492384000065, 67.91986725500004],
              [15.543467644000089, 67.91697825700004],
              [15.517588738000086, 67.88930898600006],
              [15.510020379000082, 67.88336823100008],
              [15.504649285000085, 67.88011302300004],
              [15.503184441000087, 67.87543366100005],
              [15.50757897200009, 67.86542389500005],
              [15.514903191000087, 67.85635000200006],
              [15.523448113000086, 67.85179271000004],
              [15.53256269600007, 67.85236237200007],
              [15.541758660000085, 67.85854726800005],
              [15.524261915000068, 67.86676666900007],
              [15.524424675000091, 67.87799713700008],
              [15.53492272200009, 67.88979726800005],
              [15.54859459700009, 67.89956289300005],
              [15.565928582000083, 67.90615469000005],
              [15.583994988000086, 67.91014232000003],
              [15.597992384000065, 67.91669342700004],
              [15.603770379000082, 67.93056875200006],
              [15.752289259000065, 67.95209381700005],
              [15.78874759200005, 67.95136139500005],
              [15.820811394000089, 67.93764883000006],
              [15.832204623000052, 67.92739492400005],
              [15.836599155000044, 67.91010163000004],
              [15.840993686000047, 67.90106842700004],
              [15.850596550000091, 67.89834219000005],
              [15.860118035000085, 67.89964427300004],
              [15.864512566000087, 67.90289948100008],
              [15.87077884200005, 67.92682526200008],
              [15.885508660000085, 67.93886953300006],
              [15.932139519000089, 67.95783112200007],
              [15.94499759200005, 67.96556224200003],
              [15.95281009200005, 67.97394440300008],
              [15.966319207000083, 67.99510325700004],
              [15.953298373000052, 67.99510325700004],
              [15.968760613000086, 68.00861237200007],
              [16.000661655000044, 68.01227448100008],
              [16.063161655000044, 68.00942617400005],
              [16.063161655000044, 68.01618073100008],
              [15.900889519000089, 68.02358633000006],
              [15.850271030000044, 68.03668854400007],
              [15.850271030000044, 68.04291413000004],
              [15.88803144600007, 68.05792877800008],
              [15.898285352000073, 68.06683991100005],
              [15.877452019000089, 68.07086823100008],
              [15.86500084700009, 68.06781647300005],
              [15.824717644000089, 68.05267975500004],
              [15.81617272200009, 68.04661692900004],
              [15.789235873000052, 68.03432851800005],
              [15.602386915000068, 68.03827545800004],
              [15.593028191000087, 68.04311758000006],
              [15.587412957000083, 68.05145905200004],
              [15.57593834700009, 68.06342194200005],
              [15.558767123000052, 68.07355377800008],
              [15.545420769000089, 68.07469310100004],
              [15.533539259000065, 68.07021719000005],
              [15.520681186000047, 68.06342194200005],
              [15.384043816000087, 68.02301666900007],
              [15.392832879000082, 68.01129791900007],
              [15.407074415000068, 68.00958893400008],
              [15.42351321700005, 68.01117584800005],
              [15.438731316000087, 68.00942617400005],
              [15.39820397200009, 67.99494049700007],
              [15.35678144600007, 67.99591705900008],
              [15.317067905000044, 68.01048411700003],
              [15.281748894000089, 68.03668854400007],
              [15.29428144600007, 68.04718659100007],
              [15.309580925000091, 68.05133698100008],
              [15.326182488000086, 68.05337148600006],
              [15.342458530000044, 68.05719635600008],
              [15.354502800000091, 68.07998281500005],
              [15.403575066000087, 68.10455963700008],
              [15.463389519000089, 68.12421295800004],
              [15.50757897200009, 68.13226959800005],
              [15.501963738000086, 68.11798737200007],
              [15.504079623000052, 68.10516998900005],
              [15.512950066000087, 68.09564850500004],
              [15.52865644600007, 68.09129466400003],
              [15.533539259000065, 68.09430573100008],
              [15.53492272200009, 68.10854726800005],
              [15.538340691000087, 68.11180247600004],
              [15.583018425000091, 68.11180247600004],
              [15.59310957100007, 68.11554596600007],
              [15.629893425000091, 68.13458893400008],
              [15.637950066000087, 68.14280833500004],
              [15.636241082000083, 68.16551341400003],
              [15.643728061000047, 68.16893138200004],
              [15.66578209700009, 68.16705963700008],
              [15.662771030000044, 68.16307200700004],
              [15.661143425000091, 68.15965403900003],
              [15.660166863000086, 68.15631745000007],
              [15.658457879000082, 68.15277741100005],
              [15.67741946700005, 68.14891185100004],
              [15.71648196700005, 68.14557526200008],
              [15.73414147200009, 68.13971588700008],
              [15.71810957100007, 68.13153717700004],
              [15.700043165000068, 68.12604401200008],
              [15.713552280000044, 68.12128327000005],
              [15.728363477000073, 68.11310455900008],
              [15.737478061000047, 68.10276927300004],
              [15.73414147200009, 68.09129466400003],
              [15.710134311000047, 68.08462148600006],
              [15.64429772200009, 68.09662506700005],
              [15.617442254000082, 68.09129466400003],
              [15.626963738000086, 68.08462148600006],
              [15.62859134200005, 68.07640208500004],
              [15.62468509200005, 68.06712474200003],
              [15.617442254000082, 68.05719635600008],
              [15.628428582000083, 68.05304596600007],
              [15.64031009200005, 68.05060455900008],
              [15.652842644000089, 68.04970937700006],
              [15.66578209700009, 68.05036041900007],
              [15.657399936000047, 68.06671784100007],
              [15.669444207000083, 68.07233307500007],
              [15.734629754000082, 68.07233307500007],
              [15.76148522200009, 68.07762278900003],
              [15.764170769000089, 68.08087799700007],
              [15.763845248000052, 68.08539459800005],
              [15.766449415000068, 68.08954498900005],
              [15.778493686000047, 68.09129466400003],
              [15.824229363000086, 68.09227122600004],
              [15.844493035000085, 68.09625885600008],
              [15.864512566000087, 68.10496653900003],
              [15.891774936000047, 68.12543366100005],
              [15.906748894000089, 68.13247304900005],
              [15.925303582000083, 68.13226959800005],
              [15.889414910000085, 68.15420156500005],
              [15.872325066000087, 68.16966380400004],
              [15.87077884200005, 68.18691640800006],
              [15.888682488000086, 68.19245026200008],
              [15.916514519000089, 68.18699778900003],
              [15.942067905000044, 68.18593984600005],
              [15.953298373000052, 68.20457591400003],
              [15.95093834700009, 68.21332428600005],
              [15.94703209700009, 68.22235748900005],
              [15.94507897200009, 68.23114655200004],
              [15.949554884000065, 68.23899974200003],
              [15.964040561000047, 68.24721914300005],
              [15.979665561000047, 68.25006745000007],
              [16.01465905000009, 68.24957916900007],
              [16.037852410000085, 68.24298737200007],
              [16.04542076900009, 68.22801341400003],
              [16.04981530000009, 68.21173737200007],
              [16.063161655000044, 68.20115794500003],
              [16.056162957000083, 68.19253164300005],
              [16.047699415000068, 68.18577708500004],
              [16.038259311000047, 68.18170807500007],
              [16.02784264400009, 68.18073151200008],
              [16.042491082000083, 68.16229889500005],
              [16.062022332000083, 68.16396719000005],
              [16.08179772200009, 68.17206452000005],
              [16.097178582000083, 68.17328522300005],
              [16.10401451900009, 68.16022370000007],
              [16.099945509000065, 68.14191315300008],
              [16.09034264400009, 68.12567780200004],
              [16.06967207100007, 68.11249420800004],
              [16.074554884000065, 68.09857819200005],
              [16.089854363000086, 68.07420482000003],
              [16.08366946700005, 68.05735911700003],
              [16.06934655000009, 68.04828522300005],
              [16.053396030000044, 68.04108307500007],
              [16.04200280000009, 68.02985260600008],
              [16.15796959700009, 67.99970123900005],
              [16.192881707000083, 67.98151276200008],
              [16.21062259200005, 67.95880768400008],
              [16.21387780000009, 67.93463776200008],
              [16.213226759000065, 67.91160716400003],
              [16.22006269600007, 67.89272695500006],
              [16.23682701900009, 67.88361237200007],
              [16.281993035000085, 67.87718333500004],
              [16.29932701900009, 67.86880117400005],
              [16.31023196700005, 67.86127350500004],
              [16.437347852000073, 67.80756256700005],
              [16.484711134000065, 67.79779694200005],
              [16.51498457100007, 67.80390045800004],
              [16.48926842500009, 67.80878327000005],
              [16.46029707100007, 67.81769440300008],
              [16.443532748000052, 67.83152903900003],
              [16.453461134000065, 67.85114166900007],
              [16.31104576900009, 67.87396881700005],
              [16.26856530000009, 67.88930898600006],
              [16.254567905000044, 67.90033600500004],
              [16.257660352000073, 67.90892161700003],
              [16.267914259000065, 67.91718170800004],
              [16.275401238000086, 67.92682526200008],
              [16.275726759000065, 67.94082265800006],
              [16.27125084700009, 67.96491120000007],
              [16.275401238000086, 67.97528717700004],
              [16.260508660000085, 67.98688385600008],
              [16.243337436000047, 67.99433014500005],
              [16.207041863000086, 68.00259023600006],
              [16.244802280000044, 68.00942617400005],
              [16.274261915000068, 68.00568268400008],
              [16.301117384000065, 67.99359772300005],
              [16.40593509200005, 67.91950104400007],
              [16.41260826900009, 67.90631745000007],
              [16.452647332000083, 67.89899323100008],
              [16.46656334700009, 67.89956289300005],
              [16.46257571700005, 67.90753815300008],
              [16.458181186000047, 67.91429271000004],
              [16.446055535000085, 67.92682526200008],
              [16.451182488000086, 67.92983633000006],
              [16.461192254000082, 67.93773021000004],
              [16.46656334700009, 67.94049713700008],
              [16.451996290000068, 67.94647858300004],
              [16.405772332000083, 67.95477936400005],
              [16.39616946700005, 67.95892975500004],
              [16.37159264400009, 67.97528717700004],
              [16.334808790000068, 67.99445221600007],
              [16.333506707000083, 68.00242747600004],
              [16.357432488000086, 68.00942617400005],
              [16.380381707000083, 68.00893789300005],
              [16.397227410000085, 68.00088125200006],
              [16.42628014400009, 67.97528717700004],
              [16.451508009000065, 67.96279531500005],
              [16.48178144600007, 67.95718008000006],
              [16.51335696700005, 67.95697663000004],
              [16.542246941000087, 67.96100495000007],
              [16.52393639400009, 67.96743398600006],
              [16.481130405000044, 67.96954987200007],
              [16.46338951900009, 67.97833893400008],
              [16.46338951900009, 67.98769765800006],
              [16.474619988000086, 67.99803294500003],
              [16.500743035000085, 68.01618073100008],
              [16.364756707000083, 68.02985260600008],
              [16.373708530000044, 68.04633209800005],
              [16.38917076900009, 68.05927155200004],
              [16.407725457000083, 68.06781647300005],
              [16.42628014400009, 68.07086823100008],
              [16.442637566000087, 68.07611725500004],
              [16.451914910000085, 68.08661530200004],
              [16.463633660000085, 68.09430573100008],
              [16.487071160000085, 68.09129466400003],
              [16.55014082100007, 68.06622955900008],
              [16.662771030000044, 68.05068594000005],
              [16.686289910000085, 68.05719635600008],
              [16.68067467500009, 68.05809153900003],
              [16.665212436000047, 68.06342194200005],
              [16.676931186000047, 68.06842682500007],
              [16.688975457000083, 68.07103099200003],
              [16.576996290000068, 68.08510976800005],
              [16.554942254000082, 68.09271881700005],
              [16.52125084700009, 68.11196523600006],
              [16.500743035000085, 68.11859772300005],
              [16.44507897200009, 68.11554596600007],
              [16.346446160000085, 68.08218008000006],
              [16.289073113000086, 68.09129466400003],
              [16.293793165000068, 68.09638092700004],
              [16.302744988000086, 68.11180247600004],
              [16.269541863000086, 68.11668528900003],
              [16.25367272200009, 68.12164948100008],
              [16.24122155000009, 68.13226959800005],
              [16.29346764400009, 68.12563711100006],
              [16.31999759200005, 68.12579987200007],
              [16.360118035000085, 68.14411041900007],
              [16.40211022200009, 68.13703034100007],
              [16.41260826900009, 68.14594147300005],
              [16.405528191000087, 68.14874909100007],
              [16.39893639400009, 68.15277741100005],
              [16.416270379000082, 68.15875885600008],
              [16.434825066000087, 68.15741608300004],
              [16.45411217500009, 68.15363190300008],
              [16.473399285000085, 68.15277741100005],
              [16.464366082000083, 68.16571686400005],
              [16.448008660000085, 68.17348867400005],
              [16.41260826900009, 68.18073151200008],
              [16.41260826900009, 68.18691640800006],
              [16.545176629000082, 68.16502513200004],
              [16.590098504000082, 68.16705963700008],
              [16.572601759000065, 68.17365143400008],
              [16.53296959700009, 68.17816803600005],
              [16.47632897200009, 68.19912344000005],
              [16.466807488000086, 68.20115794500003],
              [16.45997155000009, 68.20547109600005],
              [16.460459832000083, 68.22418854400007],
              [16.453135613000086, 68.22846100500004],
              [16.441254102000073, 68.22528717700004],
              [16.417816602000073, 68.21116771000004],
              [16.405772332000083, 68.20799388200004],
              [16.172048373000052, 68.20368073100008],
              [16.162119988000086, 68.21112702000005],
              [16.18336022200009, 68.22113678600005],
              [16.213715040000068, 68.22626373900005],
              [16.34734134200005, 68.22846100500004],
              [16.356130405000044, 68.23183828300006],
              [16.355642123000052, 68.23899974200003],
              [16.349131707000083, 68.24628327000005],
              [16.340179884000065, 68.24957916900007],
              [16.190928582000083, 68.25844961100006],
              [16.119802280000044, 68.27383047100005],
              [16.103363477000073, 68.28314850500004],
              [16.121348504000082, 68.28998444200005],
              [16.149668816000087, 68.31305573100008],
              [16.17237389400009, 68.31785716400003],
              [16.19239342500009, 68.31586334800005],
              [16.227305535000085, 68.30695221600007],
              [16.247569207000083, 68.30418528900003],
              [16.260508660000085, 68.30491771000004],
              [16.271006707000083, 68.30683014500005],
              [16.28174889400009, 68.30744049700007],
              [16.29590905000009, 68.30418528900003],
              [16.302907748000052, 68.29962799700007],
              [16.310883009000065, 68.28733958500004],
              [16.31690514400009, 68.28314850500004],
              [16.33920332100007, 68.27985260600008],
              [16.38843834700009, 68.28412506700005],
              [16.39893639400009, 68.27692291900007],
              [16.50831139400009, 68.25543854400007],
              [16.559825066000087, 68.23281484600005],
              [16.562754754000082, 68.19432200700004],
              [16.739512566000087, 68.13890208500004],
              [16.771739129000082, 68.13263580900008],
              [16.802989129000082, 68.13226959800005],
              [16.749278191000087, 68.15802643400008],
              [16.74154707100007, 68.17015208500004],
              [16.731293165000068, 68.17670319200005],
              [16.643728061000047, 68.20172760600008],
              [16.612152540000068, 68.21906159100007],
              [16.592621290000068, 68.23948802300004],
              [16.603770379000082, 68.25580475500004],
              [16.56739342500009, 68.27631256700005],
              [16.52279707100007, 68.28888580900008],
              [16.41187584700009, 68.29877350500004],
              [16.357758009000065, 68.31183502800008],
              [16.340179884000065, 68.32099030200004],
              [16.31771894600007, 68.32941315300008],
              [16.264333530000044, 68.32428620000007],
              [16.24122155000009, 68.33152903900003],
              [16.281586134000065, 68.34454987200007],
              [16.265879754000082, 68.34699127800008],
              [16.235199415000068, 68.34511953300006],
              [16.22006269600007, 68.35138580900008],
              [16.263926629000082, 68.36220937700006],
              [16.356130405000044, 68.37091705900008],
              [16.42286217500009, 68.38934967700004],
              [16.694590691000087, 68.40546295800004],
              [16.72201582100007, 68.40143463700008],
              [16.802989129000082, 68.37929922100005],
              [16.84896894600007, 68.37848541900007],
              [16.869883660000085, 68.37254466400003],
              [16.87867272200009, 68.35512929900005],
              [16.871267123000052, 68.35028717700004],
              [16.835948113000086, 68.33242422100005],
              [16.824066602000073, 68.32404205900008],
              [16.847504102000073, 68.32343170800004],
              [16.994802280000044, 68.34454987200007],
              [17.029551629000082, 68.35822174700007],
              [17.046885613000086, 68.36261627800008],
              [17.127289259000065, 68.37287018400008],
              [17.14503014400009, 68.36871979400007],
              [17.17546634200005, 68.34170156500005],
              [17.183116082000083, 68.33771393400008],
              [17.19312584700009, 68.30784739800004],
              [17.196787957000083, 68.30048248900005],
              [17.223806186000047, 68.28424713700008],
              [17.33057701900009, 68.25580475500004],
              [17.312347852000073, 68.23663971600007],
              [17.310069207000083, 68.23224518400008],
              [17.313161655000044, 68.22308991100005],
              [17.31999759200005, 68.21759674700007],
              [17.326914910000085, 68.21332428600005],
              [17.33057701900009, 68.20799388200004],
              [17.32715905000009, 68.19147370000007],
              [17.319834832000083, 68.17853424700007],
              [17.318614129000082, 68.17007070500006],
              [17.333994988000086, 68.16705963700008],
              [17.354991082000083, 68.17186107000003],
              [17.364024285000085, 68.18353913000004],
              [17.36304772200009, 68.19806549700007],
              [17.354340040000068, 68.21112702000005],
              [17.35206139400009, 68.22553131700005],
              [17.37403405000009, 68.23289622600004],
              [17.419932488000086, 68.23590729400007],
              [17.38998457100007, 68.26683177300004],
              [17.352224155000044, 68.28473541900007],
              [17.26856530000009, 68.31037018400008],
              [17.251475457000083, 68.31858958500004],
              [17.23601321700005, 68.32855866100005],
              [17.222992384000065, 68.33958567900004],
              [17.21387780000009, 68.35138580900008],
              [17.20606530000009, 68.37299225500004],
              [17.21656334700009, 68.37787506700005],
              [17.236175977000073, 68.37986888200004],
              [17.25554446700005, 68.39301178600005],
              [17.252777540000068, 68.39663320500006],
              [17.247894727000073, 68.40599192900004],
              [17.327972852000073, 68.40839264500005],
              [17.49577884200005, 68.36505768400008],
              [17.576914910000085, 68.35883209800005],
              [17.545583530000044, 68.37677643400008],
              [17.36459394600007, 68.41347890800006],
              [17.395274285000085, 68.42304108300004],
              [17.539886915000068, 68.42837148600006],
              [17.70948326900009, 68.41181061400005],
              [17.816661004000082, 68.38475169500003],
              [17.871836785000085, 68.39301178600005],
              [17.815684441000087, 68.39728424700007],
              [17.612152540000068, 68.45087311400005],
              [17.467621290000068, 68.44757721600007],
              [17.544118686000047, 68.51854075700004],
              [17.54656009200005, 68.53009674700007],
              [17.52475019600007, 68.52903880400004],
              [17.48096764400009, 68.52033112200007],
              [17.43848717500009, 68.50649648600006],
              [17.36459394600007, 68.50287506700005],
              [17.327647332000083, 68.49115631700005],
              [17.260101759000065, 68.45522695500006],
              [17.04664147200009, 68.43414948100008],
              [17.00163821700005, 68.44757721600007],
              [17.02320397200009, 68.45237864800004],
              [17.081309441000087, 68.45823802300004],
              [17.097178582000083, 68.46869538000004],
              [17.091970248000052, 68.48078034100007],
              [17.071543816000087, 68.48908112200007],
              [17.046885613000086, 68.49384186400005],
              [17.02898196700005, 68.49542877800008],
              [17.019053582000083, 68.49762604400007],
              [16.99903405000009, 68.50739166900007],
              [16.98796634200005, 68.50967031500005],
              [16.977386915000068, 68.50820547100005],
              [16.900645379000082, 68.47406647300005],
              [16.888519727000073, 68.46499258000006],
              [16.84864342500009, 68.44871653900003],
              [16.739105665000068, 68.45237864800004],
              [16.668793165000068, 68.43838125200006],
              [16.53484134200005, 68.43829987200007],
              [16.510996941000087, 68.44131094000005],
              [16.500743035000085, 68.45099518400008],
              [16.500254754000082, 68.46531810100004],
              [16.498057488000086, 68.47321198100008],
              [16.487071160000085, 68.48859284100007],
              [16.476817254000082, 68.49795156500005],
              [16.467539910000085, 68.50336334800005],
              [16.46461022200009, 68.50999583500004],
              [16.473399285000085, 68.52334219000005],
              [16.48487389400009, 68.52895742400005],
              [16.54200280000009, 68.54376862200007],
              [16.580821160000085, 68.53449127800008],
              [16.604340040000068, 68.52887604400007],
              [16.621104363000086, 68.53351471600007],
              [16.632090691000087, 68.54629140800006],
              [16.62826582100007, 68.55084870000007],
              [16.614756707000083, 68.55280182500007],
              [16.596934441000087, 68.55744049700007],
              [16.58334394600007, 68.56317780200004],
              [16.57325280000009, 68.56924062700006],
              [16.566416863000086, 68.57782623900005],
              [16.562754754000082, 68.59153880400004],
              [16.571787957000083, 68.61212799700007],
              [16.59701582100007, 68.62954336100006],
              [16.629242384000065, 68.64166901200008],
              [16.69695071700005, 68.65053945500006],
              [16.809825066000087, 68.68097565300008],
              [16.925059441000087, 68.69326406500005],
              [16.96070397200009, 68.70453522300005],
              [16.992930535000085, 68.70795319200005],
              [17.019867384000065, 68.69383372600004],
              [17.045258009000065, 68.67572663000004],
              [17.080902540000068, 68.66400788000004],
              [17.082367384000065, 68.65778229400007],
              [17.08179772200009, 68.65086497600004],
              [17.083506707000083, 68.64618561400005],
              [17.090017123000052, 68.64337799700007],
              [17.129649285000085, 68.63377513200004],
              [17.148692254000082, 68.63231028900003],
              [17.16773522200009, 68.63401927300004],
              [17.18653405000009, 68.63873932500007],
              [17.179860873000052, 68.64760976800005],
              [17.169932488000086, 68.65180084800005],
              [17.14503014400009, 68.65302155200004],
              [17.13257897200009, 68.65521881700005],
              [17.118337436000047, 68.66453685100004],
              [17.107432488000086, 68.66669342700004],
              [17.100433790000068, 68.66950104400007],
              [17.097178582000083, 68.67617422100005],
              [17.09734134200005, 68.68414948100008],
              [17.10059655000009, 68.69061920800004],
              [17.108571811000047, 68.69692617400005],
              [17.115082227000073, 68.69904205900008],
              [17.205414259000065, 68.71137116100005],
              [17.250173373000052, 68.72394440300008],
              [17.27084394600007, 68.72016022300005],
              [17.310069207000083, 68.70766836100006],
              [17.33106530000009, 68.70892975500004],
              [17.351084832000083, 68.71246979400007],
              [17.370371941000087, 68.71112702000005],
              [17.40365644600007, 68.68455638200004],
              [17.42156009200005, 68.67572663000004],
              [17.440684441000087, 68.66998932500007],
              [17.460215691000087, 68.66669342700004],
              [17.490082227000073, 68.66571686400005],
              [17.57667076900009, 68.67413971600007],
              [17.65560957100007, 68.65729401200008],
              [17.67937259200005, 68.66046784100007],
              [17.620616082000083, 68.68134186400005],
              [17.494476759000065, 68.69033437700006],
              [17.447276238000086, 68.71507396000004],
              [17.429860873000052, 68.72988515800006],
              [17.40333092500009, 68.74445221600007],
              [17.373871290000068, 68.75031159100007],
              [17.347666863000086, 68.73899974200003],
              [17.32357832100007, 68.73159414300005],
              [17.290293816000087, 68.73655833500004],
              [17.234385613000086, 68.75604889500005],
              [17.262950066000087, 68.76821523600006],
              [17.333262566000087, 68.78709544500003],
              [17.39551842500009, 68.79645416900007],
              [17.427744988000086, 68.80825429900005],
              [17.460948113000086, 68.81537506700005],
              [17.564789259000065, 68.78876373900005],
              [17.72169030000009, 68.77846914300005],
              [17.78296959700009, 68.74860260600008],
              [17.78288821700005, 68.77814362200007],
              [17.73926842500009, 68.79132721600007],
              [17.645274285000085, 68.79706452000005],
              [17.467621290000068, 68.83120351800005],
              [17.545664910000085, 68.84715403900003],
              [17.609222852000073, 68.87148672100005],
              [17.630137566000087, 68.87689850500004],
              [17.664805535000085, 68.88149648600006],
              [17.694183790000068, 68.89175039300005],
              [17.707367384000065, 68.89325592700004],
              [17.718272332000083, 68.89081452000005],
              [17.741465691000087, 68.87897370000007],
              [17.768728061000047, 68.87181224200003],
              [17.796071811000047, 68.86815013200004],
              [17.82357832100007, 68.86831289300005],
              [17.85132897200009, 68.87274811400005],
              [17.82593834700009, 68.89374420800004],
              [17.707367384000065, 68.91376373900005],
              [17.711680535000085, 68.91876862200007],
              [17.720957879000082, 68.93423086100006],
              [17.521494988000086, 68.91673411700003],
              [17.457774285000085, 68.89980703300006],
              [17.426117384000065, 68.89948151200008],
              [17.436371290000068, 68.91339752800008],
              [17.479746941000087, 68.94782135600008],
              [17.49512780000009, 68.95473867400005],
              [17.52393639400009, 68.95502350500004],
              [17.53370201900009, 68.96084219000005],
              [17.535980665000068, 68.97516510600008],
              [17.530446811000047, 68.98688385600008],
              [17.51921634200005, 68.99046458500004],
              [17.488291863000086, 68.98883698100008],
              [17.488291863000086, 68.99567291900007],
              [17.559418165000068, 69.03172435100004],
              [17.60320071700005, 69.06061432500007],
              [17.656993035000085, 69.07811107000003],
              [17.67937259200005, 69.09186432500007],
              [17.667816602000073, 69.09601471600007],
              [17.643809441000087, 69.10077545800004],
              [17.631602410000085, 69.10553620000007],
              [17.658864780000044, 69.11688873900005],
              [17.868988477000073, 69.12132396000004],
              [17.958832227000073, 69.14850495000007],
              [18.024180535000085, 69.15566640800006],
              [18.152354363000086, 69.15395742400005],
              [18.081309441000087, 69.16913483300004],
              [18.071055535000085, 69.17755768400008],
              [18.07325280000009, 69.19741445500006],
              [18.079600457000083, 69.20701732000003],
              [18.09034264400009, 69.21478913000004],
              [18.10523522200009, 69.22907135600008],
              [18.07715905000009, 69.23712799700007],
              [18.016286655000044, 69.22919342700004],
              [17.988536004000082, 69.23525625200006],
              [18.004079623000052, 69.25014883000006],
              [18.003103061000047, 69.28571198100008],
              [18.015798373000052, 69.30414459800005],
              [18.04542076900009, 69.31745026200008],
              [18.112559441000087, 69.33348216400003],
              [18.138682488000086, 69.35252513200004],
              [18.13054446700005, 69.36933014500005],
              [18.144053582000083, 69.38202545800004],
              [18.16537519600007, 69.39374420800004],
              [18.180349155000044, 69.40778229400007],
              [18.175303582000083, 69.41217682500007],
              [18.170664910000085, 69.41828034100007],
              [18.166026238000086, 69.42084381700005],
              [18.171071811000047, 69.43366120000007],
              [18.164805535000085, 69.43886953300006],
              [18.155772332000083, 69.44196198100008],
              [18.152354363000086, 69.44814687700006],
              [18.155039910000085, 69.45758698100008],
              [18.158457879000082, 69.45962148600006],
              [18.165537957000083, 69.46015045800004],
              [18.193532748000052, 69.46942780200004],
              [18.241709832000083, 69.47606028900003],
              [18.249522332000083, 69.47968170800004],
              [18.25562584700009, 69.48419830900008],
              [18.26335696700005, 69.48810455900008],
              [18.27588951900009, 69.48969147300005],
              [18.300954623000052, 69.48676178600005],
              [18.322520379000082, 69.47894928600005],
              [18.34148196700005, 69.46767812700006],
              [18.382334832000083, 69.43134186400005],
              [18.387380405000044, 69.42218659100007],
              [18.383474155000044, 69.41469961100006],
              [18.37631269600007, 69.40766022300005],
              [18.368337436000047, 69.39325592700004],
              [18.364756707000083, 69.39150625200006],
              [18.36817467500009, 69.39232005400004],
              [18.447520379000082, 69.39354075700004],
              [18.467133009000065, 69.39032623900005],
              [18.487152540000068, 69.38202545800004],
              [18.50294030000009, 69.37006256700005],
              [18.509287957000083, 69.35594310100004],
              [18.507090691000087, 69.33783600500004],
              [18.49781334700009, 69.30695221600007],
              [18.495616082000083, 69.29047272300005],
              [18.50953209700009, 69.28294505400004],
              [18.516286655000044, 69.27610911700003],
              [18.51270592500009, 69.26654694200005],
              [18.504242384000065, 69.25873444200005],
              [18.49854576900009, 69.25202057500007],
              [18.497243686000047, 69.24469635600008],
              [18.50245201900009, 69.23525625200006],
              [18.524912957000083, 69.26203034100007],
              [18.533213738000086, 69.27789948100008],
              [18.536631707000083, 69.29425690300008],
              [18.536306186000047, 69.32900625200006],
              [18.538340691000087, 69.34796784100007],
              [18.54395592500009, 69.35936107000003],
              [18.564789259000065, 69.36465078300006],
              [18.57976321700005, 69.35293203300006],
              [18.588715040000068, 69.33323802300004],
              [18.591807488000086, 69.31468333500004],
              [18.60206139400009, 69.30023834800005],
              [18.625336134000065, 69.29315827000005],
              [18.65170332100007, 69.28823476800005],
              [18.670258009000065, 69.28025950700004],
              [18.679209832000083, 69.27204010600008],
              [18.691661004000082, 69.26349518400008],
              [18.702972852000073, 69.26251862200007],
              [18.707774285000085, 69.27680084800005],
              [18.703135613000086, 69.28766510600008],
              [18.692637566000087, 69.29254791900007],
              [18.68100019600007, 69.29645416900007],
              [18.673675977000073, 69.30414459800005],
              [18.689707879000082, 69.31785716400003],
              [18.735036655000044, 69.32416413000004],
              [18.82390384200005, 69.32526276200008],
              [18.863454623000052, 69.31932200700004],
              [18.929698113000086, 69.29580312700006],
              [19.005381707000083, 69.28554922100005],
              [19.012950066000087, 69.28705475500004],
              [19.016368035000085, 69.29393138200004],
              [19.013519727000073, 69.29930247600004],
              [19.007009311000047, 69.30288320500006],
              [18.99903405000009, 69.30414459800005],
              [18.988536004000082, 69.30711497600004],
              [18.954600457000083, 69.32831452000005],
              [18.933767123000052, 69.33405182500007],
              [18.664805535000085, 69.36933014500005],
              [18.631521030000044, 69.38296133000006],
              [18.61573326900009, 69.38605377800008],
              [18.606618686000047, 69.39044830900008],
              [18.600840691000087, 69.40053945500006],
              [18.59669030000009, 69.41217682500007],
              [18.591807488000086, 69.42084381700005],
              [18.57781009200005, 69.43134186400005],
              [18.562673373000052, 69.43695709800005],
              [18.52979576900009, 69.44135163000004],
              [18.490082227000073, 69.44171784100007],
              [18.466644727000073, 69.44521719000005],
              [18.454600457000083, 69.45433177300004],
              [18.456879102000073, 69.46539948100008],
              [18.46615644600007, 69.47382233300004],
              [18.47820071700005, 69.47955963700008],
              [18.48878014400009, 69.48224518400008],
              [18.46851647200009, 69.50405508000006],
              [18.47429446700005, 69.51642487200007],
              [18.497569207000083, 69.52195872600004],
              [18.564707879000082, 69.52655670800004],
              [18.63062584700009, 69.54100169500003],
              [18.852712436000047, 69.55231354400007],
              [18.861582879000082, 69.54669830900008],
              [18.865489129000082, 69.53070709800005],
              [18.86426842500009, 69.52191803600005],
              [18.860036655000044, 69.51447174700007],
              [18.85328209700009, 69.50824616100005],
              [18.844493035000085, 69.50275299700007],
              [18.860118035000085, 69.50340403900003],
              [18.877207879000082, 69.50193919500003],
              [18.893728061000047, 69.49762604400007],
              [18.906504754000082, 69.48969147300005],
              [18.911387566000087, 69.48183828300006],
              [18.912933790000068, 69.46556224200003],
              [18.916758660000085, 69.45807526200008],
              [18.93531334700009, 69.44627513200004],
              [19.00953209700009, 69.42829010600008],
              [19.003184441000087, 69.40790436400005],
              [19.014414910000085, 69.39704010600008],
              [19.057383660000085, 69.38605377800008],
              [19.122325066000087, 69.35879140800006],
              [19.146006707000083, 69.35252513200004],
              [19.34742272200009, 69.34418366100005],
              [19.37940514400009, 69.32184479400007],
              [19.371104363000086, 69.30011627800008],
              [19.35059655000009, 69.29047272300005],
              [19.28492272200009, 69.27553945500006],
              [19.229258660000085, 69.28367747600004],
              [19.21534264400009, 69.28156159100007],
              [19.18921959700009, 69.27216217700004],
              [19.16700280000009, 69.26703522300005],
              [19.168793165000068, 69.26044342700004],
              [19.17750084700009, 69.25348541900007],
              [19.187754754000082, 69.24949778900003],
              [19.19662519600007, 69.25128815300008],
              [19.224457227000073, 69.26211172100005],
              [19.23210696700005, 69.26654694200005],
              [19.25098717500009, 69.27423737200007],
              [19.26856530000009, 69.26618073100008],
              [19.272308790000068, 69.25238678600005],
              [19.24903405000009, 69.24266185100004],
              [19.263194207000083, 69.23529694200005],
              [19.300791863000086, 69.22402578300006],
              [19.31771894600007, 69.22215403900003],
              [19.336599155000044, 69.22492096600007],
              [19.36500084700009, 69.23798248900005],
              [19.37940514400009, 69.24266185100004],
              [19.41309655000009, 69.24017975500004],
              [19.477224155000044, 69.22077057500007],
              [19.509287957000083, 69.22907135600008],
              [19.48764082100007, 69.24127838700008],
              [19.465993686000047, 69.24896881700005],
              [19.44857832100007, 69.26032135600008],
              [19.440928582000083, 69.28367747600004],
              [19.443614129000082, 69.29238515800006],
              [19.449473504000082, 69.29865143400008],
              [19.454600457000083, 69.30609772300005],
              [19.454600457000083, 69.31842682500007],
              [19.449473504000082, 69.32485586100006],
              [19.429535352000073, 69.34174225500004],
              [19.35010826900009, 69.37909577000005],
              [19.324880405000044, 69.38401927300004],
              [19.298350457000083, 69.38580963700008],
              [19.156260613000086, 69.37714264500005],
              [19.119395379000082, 69.38605377800008],
              [19.109629754000082, 69.39203522300005],
              [19.085215691000087, 69.41400788000004],
              [19.083262566000087, 69.41828034100007],
              [19.083262566000087, 69.42352936400005],
              [19.082367384000065, 69.42918528900003],
              [19.07789147200009, 69.43451569200005],
              [19.07007897200009, 69.43756745000007],
              [19.043630405000044, 69.44135163000004],
              [19.021739129000082, 69.45026276200008],
              [19.00131269600007, 69.46434153900003],
              [18.99268639400009, 69.48314036700003],
              [19.005707227000073, 69.50617096600007],
              [19.031911655000044, 69.52114492400005],
              [19.069102410000085, 69.53327057500007],
              [19.176931186000047, 69.55072663000004],
              [19.194834832000083, 69.55048248900005],
              [19.22201582100007, 69.53375885600008],
              [19.235606316000087, 69.52826569200005],
              [19.250173373000052, 69.52464427300004],
              [19.26270592500009, 69.52326080900008],
              [19.253754102000073, 69.53530508000006],
              [19.242849155000044, 69.54376862200007],
              [19.233246290000068, 69.55316803600005],
              [19.229258660000085, 69.56793854400007],
              [19.147634311000047, 69.56488678600005],
              [19.10320071700005, 69.55597565300008],
              [19.053396030000044, 69.55215078300006],
              [19.033457879000082, 69.54059479400007],
              [19.016368035000085, 69.53436920800004],
              [18.994476759000065, 69.53961823100008],
              [18.97315514400009, 69.55048248900005],
              [18.95801842500009, 69.56110260600008],
              [18.94434655000009, 69.61530182500007],
              [19.08497155000009, 69.69342682500007],
              [19.098317905000044, 69.73615143400008],
              [19.117849155000044, 69.74335358300004],
              [19.139496290000068, 69.74750397300005],
              [19.184336785000085, 69.74982330900008],
              [19.201426629000082, 69.75332265800006],
              [19.23292076900009, 69.77057526200008],
              [19.24903405000009, 69.77708567900004],
              [19.295746290000068, 69.78290436400005],
              [19.44434655000009, 69.77708567900004],
              [19.483083530000044, 69.78139883000006],
              [19.558767123000052, 69.80019765800006],
              [19.737152540000068, 69.81305573100008],
              [19.78419030000009, 69.80438873900005],
              [19.776866082000083, 69.79157135600008],
              [19.769379102000073, 69.78424713700008],
              [19.73145592500009, 69.75682200700004],
              [19.73414147200009, 69.75360748900005],
              [19.736338738000086, 69.73956940300008],
              [19.728688998000052, 69.72288646000004],
              [19.71029707100007, 69.70538971600007],
              [19.689707879000082, 69.69033437700006],
              [19.67432701900009, 69.68154531500005],
              [19.693369988000086, 69.66372304900005],
              [19.715586785000085, 69.65493398600006],
              [19.727386915000068, 69.64215729400007],
              [19.715179884000065, 69.61261627800008],
              [19.699880405000044, 69.59369538000004],
              [19.643321160000085, 69.54059479400007],
              [19.635915561000047, 69.53156159100007],
              [19.62989342500009, 69.52045319200005],
              [19.626475457000083, 69.50824616100005],
              [19.626475457000083, 69.49591705900008],
              [19.632660352000073, 69.48566315300008],
              [19.643728061000047, 69.47174713700008],
              [19.65015709700009, 69.45962148600006],
              [19.643321160000085, 69.45433177300004],
              [19.614105665000068, 69.44969310100004],
              [19.58171634200005, 69.43744538000004],
              [19.551931186000047, 69.42011139500005],
              [19.53028405000009, 69.40033600500004],
              [19.68848717500009, 69.44472890800006],
              [19.698090040000068, 69.46600983300004],
              [19.715993686000047, 69.49217357000003],
              [19.724864129000082, 69.51605866100005],
              [19.70834394600007, 69.53070709800005],
              [19.75684655000009, 69.59955475500004],
              [19.75098717500009, 69.60268789300005],
              [19.748301629000082, 69.60541413000004],
              [19.746429884000065, 69.60854726800005],
              [19.74317467500009, 69.61261627800008],
              [19.763845248000052, 69.61147695500006],
              [19.803396030000044, 69.61416250200006],
              [19.928558790000068, 69.60516998900005],
              [19.994395379000082, 69.58905670800004],
              [20.06023196700005, 69.57908763200004],
              [20.112559441000087, 69.58535390800006],
              [20.074961785000085, 69.58429596600007],
              [20.031586134000065, 69.58832428600005],
              [19.98926842500009, 69.59686920800004],
              [19.95484459700009, 69.60919830900008],
              [19.924978061000047, 69.61570872600004],
              [19.888519727000073, 69.61871979400007],
              [19.857758009000065, 69.62726471600007],
              [19.844981316000087, 69.65045807500007],
              [19.842458530000044, 69.65973541900007],
              [19.82943769600007, 69.67352936400005],
              [19.824473504000082, 69.68154531500005],
              [19.82276451900009, 69.68870677300004],
              [19.824473504000082, 69.71190013200004],
              [19.83643639400009, 69.72394440300008],
              [19.860199415000068, 69.73289622600004],
              [19.878184441000087, 69.74433014500005],
              [19.872325066000087, 69.76341380400004],
              [19.889496290000068, 69.77488841400003],
              [19.927744988000086, 69.78412506700005],
              [19.944590691000087, 69.79417552300004],
              [19.97787519600007, 69.83051178600005],
              [19.989024285000085, 69.83856842700004],
              [20.006114129000082, 69.84284088700008],
              [20.009043816000087, 69.83486562700006],
              [20.002696160000085, 69.82111237200007],
              [19.983164910000085, 69.79669830900008],
              [19.96851647200009, 69.76341380400004],
              [20.007009311000047, 69.76850006700005],
              [20.033946160000085, 69.79035065300008],
              [20.078379754000082, 69.84540436400005],
              [20.114756707000083, 69.87840403900003],
              [20.14356530000009, 69.92218659100007],
              [20.154551629000082, 69.93488190300008],
              [20.16773522200009, 69.94220612200007],
              [20.17042076900009, 69.93073151200008],
              [20.170176629000082, 69.92698802300004],
              [20.16773522200009, 69.92047760600008],
              [20.168304884000065, 69.89622630400004],
              [20.170664910000085, 69.88043854400007],
              [20.177989129000082, 69.87327708500004],
              [20.19304446700005, 69.86774323100008],
              [20.202403191000087, 69.85895416900007],
              [20.207286004000082, 69.85895416900007],
              [20.20875084700009, 69.87954336100006],
              [20.201914910000085, 69.92422109600005],
              [20.207692905000044, 69.93183014500005],
              [20.23601321700005, 69.94574616100005],
              [20.270355665000068, 69.96784088700008],
              [20.29265384200005, 69.97101471600007],
              [20.31495201900009, 69.96381256700005],
              [20.417246941000087, 69.89036692900004],
              [20.425303582000083, 69.87718333500004],
              [20.420258009000065, 69.86713288000004],
              [20.409353061000047, 69.85748932500007],
              [20.399912957000083, 69.84540436400005],
              [20.396820509000065, 69.83405182500007],
              [20.39616946700005, 69.81317780200004],
              [20.39356530000009, 69.80438873900005],
              [20.386241082000083, 69.79718659100007],
              [20.374522332000083, 69.78864166900007],
              [20.363617384000065, 69.77855052300004],
              [20.358897332000083, 69.76683177300004],
              [20.356293165000068, 69.75706614800004],
              [20.350271030000044, 69.74506256700005],
              [20.342621290000068, 69.73358795800004],
              [20.33570397200009, 69.72557200700004],
              [20.321787957000083, 69.68610260600008],
              [20.318614129000082, 69.68154531500005],
              [20.323008660000085, 69.66917552300004],
              [20.330414259000065, 69.66327545800004],
              [20.375254754000082, 69.64215729400007],
              [20.383067254000082, 69.63467031500005],
              [20.386241082000083, 69.62287018400008],
              [20.385508660000085, 69.61102936400005],
              [20.38257897200009, 69.59878164300005],
              [20.376475457000083, 69.58917877800008],
              [20.365977410000085, 69.58535390800006],
              [20.330251498000052, 69.58222077000005],
              [20.291270379000082, 69.57355377800008],
              [20.274180535000085, 69.56061432500007],
              [20.30437259200005, 69.54433828300006],
              [20.289073113000086, 69.53790924700007],
              [20.277598504000082, 69.52895742400005],
              [20.269541863000086, 69.51727936400005],
              [20.263926629000082, 69.50275299700007],
              [20.278493686000047, 69.48517487200007],
              [20.266856316000087, 69.46808502800008],
              [20.241709832000083, 69.45978424700007],
              [20.215586785000085, 69.46865469000005],
              [20.20671634200005, 69.43984609600005],
              [20.191579623000052, 69.41323476800005],
              [20.168793165000068, 69.39370351800005],
              [20.116058790000068, 69.38287995000007],
              [20.057871941000087, 69.35936107000003],
              [20.000254754000082, 69.34837474200003],
              [19.98218834700009, 69.33893463700008],
              [19.987152540000068, 69.33588288000004],
              [19.997243686000047, 69.32819245000007],
              [20.002696160000085, 69.32526276200008],
              [19.93726647200009, 69.28839752800008],
              [19.916840040000068, 69.26927317900004],
              [19.948008660000085, 69.26312897300005],
              [19.97169030000009, 69.27016836100006],
              [20.000254754000082, 69.28571198100008],
              [20.027679884000065, 69.30463288000004],
              [20.047211134000065, 69.32184479400007],
              [20.070485873000052, 69.33600495000007],
              [20.225352410000085, 69.38434479400007],
              [20.26693769600007, 69.38764069200005],
              [20.27702884200005, 69.39227936400005],
              [20.354258660000085, 69.46808502800008],
              [20.373220248000052, 69.48224518400008],
              [20.42286217500009, 69.50690338700008],
              [20.44109134200005, 69.52277252800008],
              [20.44825280000009, 69.54779694200005],
              [20.45215905000009, 69.55585358300004],
              [20.461599155000044, 69.56517161700003],
              [20.472829623000052, 69.57343170800004],
              [20.482432488000086, 69.57786692900004],
              [20.497325066000087, 69.57762278900003],
              [20.511566602000073, 69.57217031500005],
              [20.524912957000083, 69.56452057500007],
              [20.57081139400009, 69.54482656500005],
              [20.64698326900009, 69.52118561400005],
              [20.79151451900009, 69.50958893400008],
              [20.80836022200009, 69.50267161700003],
              [20.823008660000085, 69.49433014500005],
              [20.837168816000087, 69.49022044500003],
              [20.853037957000083, 69.49591705900008],
              [20.81218509200005, 69.51044342700004],
              [20.71843509200005, 69.52838776200008],
              [20.684825066000087, 69.54779694200005],
              [20.65870201900009, 69.57664622600004],
              [20.647634311000047, 69.58535390800006],
              [20.626800977000073, 69.59442780200004],
              [20.540293816000087, 69.61033763200004],
              [20.492360873000052, 69.62726471600007],
              [20.482432488000086, 69.63686758000006],
              [20.488291863000086, 69.64838288000004],
              [20.52711022200009, 69.67780182500007],
              [20.541758660000085, 69.70538971600007],
              [20.535166863000086, 69.73045482000003],
              [20.51335696700005, 69.74876536700003],
              [20.482432488000086, 69.75600820500006],
              [20.482432488000086, 69.76341380400004],
              [20.511973504000082, 69.76947663000004],
              [20.642914259000065, 69.77265045800004],
              [20.785166863000086, 69.80174388200004],
              [20.803884311000047, 69.81195709800005],
              [20.822276238000086, 69.82859935100004],
              [20.824961785000085, 69.84153880400004],
              [20.81421959700009, 69.85394928600005],
              [20.79981530000009, 69.86635976800005],
              [20.79151451900009, 69.87954336100006],
              [20.829274936000047, 69.88304271000004],
              [21.05176842500009, 69.94472890800006],
              [21.092539910000085, 69.94839101800005],
              [21.092539910000085, 69.94220612200007],
              [20.982432488000086, 69.90403880400004],
              [20.91895592500009, 69.86684804900005],
              [20.89389082100007, 69.85968659100007],
              [20.89389082100007, 69.85285065300008],
              [20.91456139400009, 69.84870026200008],
              [20.93604576900009, 69.84894440300008],
              [20.955088738000086, 69.84609609600005],
              [20.969086134000065, 69.83234284100007],
              [20.958994988000086, 69.83185455900008],
              [20.95167076900009, 69.82977936400005],
              [20.946055535000085, 69.82550690300008],
              [20.94109134200005, 69.81867096600007],
              [20.99463951900009, 69.79340241100005],
              [21.02051842500009, 69.78815338700008],
              [21.050954623000052, 69.79759349200003],
              [21.03565514400009, 69.80524323100008],
              [21.00489342500009, 69.81395091400003],
              [20.996348504000082, 69.82489655200004],
              [21.018402540000068, 69.82648346600007],
              [21.049001498000052, 69.83201732000003],
              [21.068614129000082, 69.84267812700006],
              [21.05836022200009, 69.85968659100007],
              [21.085134311000047, 69.86611562700006],
              [21.17042076900009, 69.87563711100006],
              [21.18881269600007, 69.86957428600005],
              [21.180511915000068, 69.85455963700008],
              [21.140879754000082, 69.82501862200007],
              [21.12671959700009, 69.81122467700004],
              [21.149912957000083, 69.81256745000007],
              [21.179209832000083, 69.81948476800005],
              [21.206553582000083, 69.83079661700003],
              [21.222911004000082, 69.84540436400005],
              [21.223887566000087, 69.85740794500003],
              [21.209239129000082, 69.90745677300004],
              [21.32593834700009, 69.90745677300004],
              [21.30209394600007, 69.92035553600005],
              [21.27051842500009, 69.92975495000007],
              [21.237559441000087, 69.93475983300004],
              [21.209239129000082, 69.93475983300004],
              [21.225271030000044, 69.97467682500007],
              [21.253103061000047, 70.00299713700008],
              [21.289886915000068, 70.02106354400007],
              [21.332774285000085, 70.03034088700008],
              [21.392588738000086, 70.02899811400005],
              [21.558116082000083, 69.98940664300005],
              [21.55632571700005, 69.97516510600008],
              [21.56967207100007, 69.96539948100008],
              [21.60645592500009, 69.95526764500005],
              [21.57862389400009, 69.92792389500005],
              [21.608897332000083, 69.91193268400008],
              [21.646006707000083, 69.89891185100004],
              [21.684336785000085, 69.89012278900003],
              [21.757660352000073, 69.88287995000007],
              [21.904551629000082, 69.82542552300004],
              [21.930918816000087, 69.80841705900008],
              [21.942230665000068, 69.78733958500004],
              [21.957286004000082, 69.77781810100004],
              [22.051524285000085, 69.74982330900008],
              [22.03419030000009, 69.74306875200006],
              [22.015472852000073, 69.74359772300005],
              [21.97706139400009, 69.74982330900008],
              [22.000173373000052, 69.74038320500006],
              [22.030039910000085, 69.73432038000004],
              [22.06104576900009, 69.73338450700004],
              [22.086273634000065, 69.73956940300008],
              [22.09815514400009, 69.74982330900008],
              [22.092051629000082, 69.75763580900008],
              [22.058929884000065, 69.77024974200003],
              [22.056162957000083, 69.79360586100006],
              [22.010020379000082, 69.81240469000005],
              [21.915537957000083, 69.83856842700004],
              [21.937022332000083, 69.84259674700007],
              [21.999847852000073, 69.83515045800004],
              [22.01807701900009, 69.84540436400005],
              [22.011973504000082, 69.85952383000006],
              [21.989024285000085, 69.86798737200007],
              [21.942881707000083, 69.87327708500004],
              [21.930023634000065, 69.87933991100005],
              [21.92823326900009, 69.89362213700008],
              [21.92937259200005, 69.91046784100007],
              [21.92514082100007, 69.92422109600005],
              [21.914398634000065, 69.93781159100007],
              [21.913584832000083, 69.94525788000004],
              [21.928558790000068, 69.96271393400008],
              [21.927989129000082, 69.96747467700004],
              [21.923350457000083, 69.97186920800004],
              [21.921397332000083, 69.97675202000005],
              [21.928558790000068, 69.98314036700003],
              [21.940114780000044, 69.98574453300006],
              [21.983897332000083, 69.98314036700003],
              [22.010020379000082, 69.98615143400008],
              [22.024099155000044, 69.98550039300005],
              [22.03484134200005, 69.97943756700005],
              [22.03484134200005, 69.97382233300004],
              [22.02475019600007, 69.95526764500005],
              [22.052256707000083, 69.93842194200005],
              [22.061371290000068, 69.95669179900005],
              [22.058929884000065, 69.98965078300006],
              [22.051524285000085, 70.01675039300005],
              [22.067230665000068, 70.01813385600008],
              [22.097504102000073, 70.02448151200008],
              [22.113617384000065, 70.02411530200004],
              [22.113617384000065, 70.03034088700008],
              [21.95085696700005, 70.01227448100008],
              [21.865896030000044, 70.01190827000005],
              [21.798350457000083, 70.03717682500007],
              [21.83887780000009, 70.05512116100005],
              [21.983897332000083, 70.05760325700004],
              [22.005137566000087, 70.06134674700007],
              [22.020681186000047, 70.06781647300005],
              [22.051524285000085, 70.08559804900005],
              [22.082774285000085, 70.09650299700007],
              [22.094411655000044, 70.10480377800008],
              [22.09937584700009, 70.12034739800004],
              [22.019786004000082, 70.10325755400004],
              [22.007823113000086, 70.10236237200007],
              [21.98601321700005, 70.08905670800004],
              [21.958262566000087, 70.08454010600008],
              [21.83920332100007, 70.09243398600006],
              [21.82984459700009, 70.08909739800004],
              [21.817149285000085, 70.07461172100005],
              [21.805023634000065, 70.07135651200008],
              [21.719493035000085, 70.06061432500007],
              [21.68848717500009, 70.06513092700004],
              [21.631032748000052, 70.09430573100008],
              [21.613291863000086, 70.09857819200005],
              [21.51335696700005, 70.09170156500005],
              [21.482269727000073, 70.09857819200005],
              [21.468760613000086, 70.10643138200004],
              [21.438975457000083, 70.13715241100005],
              [21.43653405000009, 70.14960358300004],
              [21.455251498000052, 70.15892161700003],
              [21.48023522200009, 70.16669342700004],
              [21.49659264400009, 70.17495351800005],
              [21.358164910000085, 70.16404857000003],
              [21.31226647200009, 70.16754791900007],
              [21.294932488000086, 70.17137278900003],
              [21.281993035000085, 70.17625560100004],
              [21.271494988000086, 70.18292877800008],
              [21.26075280000009, 70.19208405200004],
              [21.246836785000085, 70.19940827000005],
              [21.214854363000086, 70.20644765800006],
              [21.209239129000082, 70.20848216400003],
              [21.233897332000083, 70.22426992400005],
              [21.23568769600007, 70.22549062700006],
              [21.270355665000068, 70.23859284100007],
              [21.306976759000065, 70.24701569200005],
              [21.33961022200009, 70.25006745000007],
              [21.407074415000068, 70.26732005400004],
              [21.439300977000073, 70.26947663000004],
              [21.43523196700005, 70.25006745000007],
              [21.44507897200009, 70.23786041900007],
              [21.489756707000083, 70.20848216400003],
              [21.492930535000085, 70.21718984600005],
              [21.492523634000065, 70.22109609600005],
              [21.490977410000085, 70.22479889500005],
              [21.489756707000083, 70.23297760600008],
              [21.49268639400009, 70.24017975500004],
              [21.506114129000082, 70.25067780200004],
              [21.51026451900009, 70.25690338700008],
              [21.51148522200009, 70.27000560100004],
              [21.510915561000047, 70.28204987200007],
              [21.511729363000086, 70.29340241100005],
              [21.517751498000052, 70.30467357000003],
              [21.533946160000085, 70.31683991100005],
              [21.552989129000082, 70.32103099200003],
              [21.571462436000047, 70.31891510600008],
              [21.585948113000086, 70.31216054900005],
              [21.587412957000083, 70.30776601800005],
              [21.58692467500009, 70.29295482000003],
              [21.589121941000087, 70.28729889500005],
              [21.613291863000086, 70.26992422100005],
              [21.63607832100007, 70.26146067900004],
              [21.685394727000073, 70.25568268400008],
              [21.70948326900009, 70.25006745000007],
              [21.796885613000086, 70.20628489800004],
              [21.80437259200005, 70.19798411700003],
              [21.808929884000065, 70.18842194200005],
              [21.81934655000009, 70.17495351800005],
              [21.829600457000083, 70.16815827000005],
              [21.87403405000009, 70.14704010600008],
              [21.879649285000085, 70.16058991100005],
              [21.87671959700009, 70.16974518400008],
              [21.870941602000073, 70.17792389500005],
              [21.867849155000044, 70.18866608300004],
              [21.86573326900009, 70.19061920800004],
              [21.861582879000082, 70.19131094000005],
              [21.858897332000083, 70.19403717700004],
              [21.86036217500009, 70.20229726800005],
              [21.86622155000009, 70.20742422100005],
              [21.875824415000068, 70.20954010600008],
              [21.88648522200009, 70.20954010600008],
              [21.894541863000086, 70.20848216400003],
              [21.873057488000086, 70.21605052300004],
              [21.827321811000047, 70.22662995000007],
              [21.808848504000082, 70.24017975500004],
              [21.80567467500009, 70.25722890800006],
              [21.821787957000083, 70.26862213700008],
              [21.98682701900009, 70.32343170800004],
              [22.010101759000065, 70.32461172100005],
              [22.031586134000065, 70.31834544500003],
              [22.018728061000047, 70.30902741100005],
              [21.991465691000087, 70.29572174700007],
              [21.983897332000083, 70.28424713700008],
              [22.00912519600007, 70.28652578300006],
              [22.07203209700009, 70.30467357000003],
              [22.095225457000083, 70.30780670800004],
              [22.10482832100007, 70.30414459800005],
              [22.10678144600007, 70.29393138200004],
              [22.107595248000052, 70.24530670800004],
              [22.117198113000086, 70.23346588700008],
              [22.140879754000082, 70.23647695500006],
              [22.15284264400009, 70.24652741100005],
              [22.153168165000068, 70.25934479400007],
              [22.140879754000082, 70.28424713700008],
              [22.267425977000073, 70.29511139500005],
              [22.305837436000047, 70.28729889500005],
              [22.315114780000044, 70.27269114800004],
              [22.300303582000083, 70.25511302300004],
              [22.276133660000085, 70.23920319200005],
              [22.25757897200009, 70.22955963700008],
              [22.272308790000068, 70.21792226800005],
              [22.277679884000065, 70.20246002800008],
              [22.281504754000082, 70.18520742400005],
              [22.291758660000085, 70.16754791900007],
              [22.278086785000085, 70.15818919500003],
              [22.24903405000009, 70.15058014500005],
              [22.237071160000085, 70.14020416900007],
              [22.274668816000087, 70.13548411700003],
              [22.404958530000044, 70.14704010600008],
              [22.52475019600007, 70.12352122600004],
              [22.559336785000085, 70.12661367400005],
              [22.536387566000087, 70.13947174700007],
              [22.507334832000083, 70.14671458500004],
              [22.32593834700009, 70.16754791900007],
              [22.332367384000065, 70.18012116100005],
              [22.360606316000087, 70.21588776200008],
              [22.37476647200009, 70.24632396000004],
              [22.373708530000044, 70.25006745000007],
              [22.400645379000082, 70.25828685100004],
              [22.433929884000065, 70.26093170800004],
              [22.46810957100007, 70.25991445500006],
              [22.512950066000087, 70.25372955900008],
              [22.553965691000087, 70.23834870000007],
              [22.565277540000068, 70.23761627800008],
              [22.57585696700005, 70.24066803600005],
              [22.587087436000047, 70.24209219000005],
              [22.600271030000044, 70.23647695500006],
              [22.594004754000082, 70.22207265800006],
              [22.603688998000052, 70.21849192900004],
              [22.675303582000083, 70.22313060100004],
              [22.967051629000082, 70.20746491100005],
              [22.976898634000065, 70.19887929900005],
              [22.970550977000073, 70.18935781500005],
              [22.860199415000068, 70.12620677300004],
              [22.836680535000085, 70.12034739800004],
              [22.803965691000087, 70.11692942900004],
              [22.73609459700009, 70.10199616100005],
              [22.55250084700009, 70.08559804900005],
              [22.47624759200005, 70.09088776200008],
              [22.43458092500009, 70.08893463700008],
              [22.39234459700009, 70.06781647300005],
              [22.28492272200009, 70.04401276200008],
              [22.304209832000083, 70.03912995000007],
              [22.33179772200009, 70.04043203300006],
              [22.35906009200005, 70.04608795800004],
              [22.39503014400009, 70.06110260600008],
              [22.647634311000047, 70.07566966400003],
              [22.713715040000068, 70.09528229400007],
              [22.867198113000086, 70.10602448100008],
              [22.978526238000086, 70.14541250200006],
              [23.01856530000009, 70.14704010600008],
              [23.002696160000085, 70.11440664300005],
              [22.999196811000047, 70.10097890800006],
              [22.998057488000086, 70.08218008000006],
              [23.001149936000047, 70.06586334800005],
              [23.009043816000087, 70.05048248900005],
              [23.02003014400009, 70.03807200700004],
              [23.03223717500009, 70.03034088700008],
              [23.05241946700005, 70.03237539300005],
              [23.08497155000009, 70.03961823100008],
              [23.115082227000073, 70.04303620000007],
              [23.128428582000083, 70.03375885600008],
              [23.124522332000083, 70.01288483300004],
              [23.119802280000044, 69.99896881700005],
              [23.12435957100007, 69.98794179900005],
              [23.14893639400009, 69.97573476800005],
              [23.135915561000047, 69.96674225500004],
              [23.123301629000082, 69.96088288000004],
              [23.10987389400009, 69.95726146000004],
              [23.094411655000044, 69.95526764500005],
              [23.12549889400009, 69.94440338700008],
              [23.15919030000009, 69.95107656500005],
              [23.283457879000082, 69.99339427300004],
              [23.299082879000082, 69.99624258000006],
              [23.31413821700005, 69.99652741100005],
              [23.31617272200009, 69.99363841400003],
              [23.323008660000085, 69.98627350500004],
              [23.334808790000068, 69.98118724200003],
              [23.339040561000047, 69.97772858300004],
              [23.336680535000085, 69.97260163000004],
              [23.30958092500009, 69.95408763200004],
              [23.30958092500009, 69.94977448100008],
              [23.32984459700009, 69.94839101800005],
              [23.420583530000044, 69.97809479400007],
              [23.46729576900009, 69.98578522300005],
              [23.477305535000085, 69.99282461100006],
              [23.484629754000082, 70.00633372600004],
              [23.502207879000082, 70.01141998900005],
              [23.522715691000087, 70.01496002800008],
              [23.539317254000082, 70.02411530200004],
              [23.488536004000082, 70.03416575700004],
              [23.296885613000086, 70.03978099200003],
              [23.272715691000087, 70.04657623900005],
              [23.17554772200009, 70.09243398600006],
              [23.192067905000044, 70.09756094000005],
              [23.227793816000087, 70.09764232000003],
              [23.244476759000065, 70.10236237200007],
              [23.25953209700009, 70.10846588700008],
              [23.275645379000082, 70.11163971600007],
              [23.357758009000065, 70.11530182500007],
              [23.379242384000065, 70.12323639500005],
              [23.40211022200009, 70.14020416900007],
              [23.379161004000082, 70.14964427300004],
              [23.32357832100007, 70.15924713700008],
              [23.299082879000082, 70.16754791900007],
              [23.327647332000083, 70.17536041900007],
              [23.403086785000085, 70.18081289300005],
              [23.422048373000052, 70.19546133000006],
              [23.32862389400009, 70.19306061400005],
              [23.280772332000083, 70.19847239800004],
              [23.24390709700009, 70.21588776200008],
              [23.275726759000065, 70.22504303600005],
              [23.387868686000047, 70.22955963700008],
              [23.417816602000073, 70.23436107000003],
              [23.48764082100007, 70.23554108300004],
              [23.503428582000083, 70.23753489800004],
              [23.505137566000087, 70.24384186400005],
              [23.531911655000044, 70.24384186400005],
              [23.50294030000009, 70.25336334800005],
              [23.47046959700009, 70.25600820500006],
              [23.292246941000087, 70.24384186400005],
              [23.312836134000065, 70.25698476800005],
              [23.39942467500009, 70.27863190300008],
              [23.57081139400009, 70.29067617400005],
              [23.614431186000047, 70.30467357000003],
              [23.511973504000082, 70.29783763200004],
              [23.518728061000047, 70.30585358300004],
              [23.546153191000087, 70.32514069200005],
              [23.52442467500009, 70.32396067900004],
              [23.482758009000065, 70.31549713700008],
              [23.463633660000085, 70.31834544500003],
              [23.482269727000073, 70.33026764500005],
              [23.513194207000083, 70.36554596600007],
              [23.535492384000065, 70.37299225500004],
              [23.562022332000083, 70.37693919500003],
              [23.590586785000085, 70.38670482000003],
              [23.64234459700009, 70.41111888200004],
              [23.75098717500009, 70.44871653900003],
              [23.815684441000087, 70.48700592700004],
              [23.84034264400009, 70.49705638200004],
              [23.917979363000086, 70.50942617400005],
              [24.186289910000085, 70.49396393400008],
              [24.298024936000047, 70.47483958500004],
              [24.31104576900009, 70.47040436400005],
              [24.333832227000073, 70.45954010600008],
              [24.350271030000044, 70.45624420800004],
              [24.357432488000086, 70.46279531500005],
              [24.355316602000073, 70.47199127800008],
              [24.344411655000044, 70.47662995000007],
              [24.315196160000085, 70.48309967700004],
              [24.25879967500009, 70.51373932500007],
              [24.23145592500009, 70.52383047100005],
              [24.114756707000083, 70.53807200700004],
              [24.102712436000047, 70.54140859600005],
              [24.11231530000009, 70.54889557500007],
              [24.210785352000073, 70.58527252800008],
              [24.238291863000086, 70.59951406500005],
              [24.247325066000087, 70.60211823100008],
              [24.256032748000052, 70.60342031500005],
              [24.264333530000044, 70.60626862200007],
              [24.272308790000068, 70.61318594000005],
              [24.275645379000082, 70.62278880400004],
              [24.27637780000009, 70.64712148600006],
              [24.28223717500009, 70.65753815300008],
              [24.29395592500009, 70.66640859600005],
              [24.333832227000073, 70.68520742400005],
              [24.352386915000068, 70.69098541900007],
              [24.37045332100007, 70.68984609600005],
              [24.408864780000044, 70.68146393400008],
              [24.477712436000047, 70.68329498900005],
              [24.498301629000082, 70.67804596600007],
              [24.61500084700009, 70.62620677300004],
              [24.64698326900009, 70.61798737200007],
              [24.68799889400009, 70.61432526200008],
              [24.723480665000068, 70.62103913000004],
              [24.738536004000082, 70.64423248900005],
              [24.724864129000082, 70.66522858300004],
              [24.661631707000083, 70.68817780200004],
              [24.64226321700005, 70.70258209800005],
              [24.646739129000082, 70.70384349200003],
              [24.65593509200005, 70.70937734600005],
              [24.588145379000082, 70.72190989800004],
              [24.566661004000082, 70.72988515800006],
              [24.54395592500009, 70.74628327000005],
              [24.532399936000047, 70.75039297100005],
              [24.515961134000065, 70.75214264500005],
              [24.464121941000087, 70.75039297100005],
              [24.34742272200009, 70.76398346600007],
              [24.29232832100007, 70.76410553600005],
              [24.265879754000082, 70.76992422100005],
              [24.24512780000009, 70.78449127800008],
              [24.26807701900009, 70.80023834800005],
              [24.267588738000086, 70.82070547100005],
              [24.269379102000073, 70.83844635600008],
              [24.363617384000065, 70.86286041900007],
              [24.395762566000087, 70.86688873900005],
              [24.416270379000082, 70.85276927300004],
              [24.408864780000044, 70.84593333500004],
              [24.451182488000086, 70.84113190300008],
              [24.46583092500009, 70.83445872600004],
              [24.464121941000087, 70.81801992400005],
              [24.520274285000085, 70.81159088700008],
              [24.57398522200009, 70.79877350500004],
              [24.616058790000068, 70.77973053600005],
              [24.635427280000044, 70.77977122600004],
              [24.649668816000087, 70.79877350500004],
              [24.640635613000086, 70.80857982000003],
              [24.629079623000052, 70.81557851800005],
              [24.600759311000047, 70.82542552300004],
              [24.610606316000087, 70.84076569200005],
              [24.61109459700009, 70.85146719000005],
              [24.613291863000086, 70.85936107000003],
              [24.62867272200009, 70.86640045800004],
              [24.65333092500009, 70.86579010600008],
              [24.683604363000086, 70.85993073100008],
              [24.71029707100007, 70.85903554900005],
              [24.724864129000082, 70.87323639500005],
              [24.637543165000068, 70.89394765800006],
              [24.608164910000085, 70.89435455900008],
              [24.621348504000082, 70.90509674700007],
              [24.62867272200009, 70.90802643400008],
              [24.59473717500009, 70.91811758000006],
              [24.582286004000082, 70.92450592700004],
              [24.57398522200009, 70.93528880400004],
              [24.590993686000047, 70.94245026200008],
              [24.61304772200009, 70.94749583500004],
              [24.635996941000087, 70.95001862200007],
              [24.65593509200005, 70.94961172100005],
              [24.639414910000085, 70.95506419500003],
              [24.603526238000086, 70.95612213700008],
              [24.58765709700009, 70.96259186400005],
              [24.608653191000087, 70.97052643400008],
              [24.636892123000052, 70.97565338700008],
              [24.666026238000086, 70.97768789300005],
              [24.774180535000085, 70.96820709800005],
              [24.78288821700005, 70.96596914300005],
              [24.788910352000073, 70.96108633000006],
              [24.796885613000086, 70.95270416900007],
              [24.80713951900009, 70.94721100500004],
              [24.83529707100007, 70.94245026200008],
              [24.84742272200009, 70.93870677300004],
              [24.860199415000068, 70.92837148600006],
              [24.853770379000082, 70.92182038000004],
              [24.837412957000083, 70.91608307500007],
              [24.820485873000052, 70.90802643400008],
              [24.98487389400009, 70.91425202000005],
              [24.96810957100007, 70.92983633000006],
              [24.978037957000083, 70.94578685100004],
              [24.98796634200005, 70.95815664300005],
              [24.97120201900009, 70.96259186400005],
              [24.99350019600007, 70.97207265800006],
              [25.033457879000082, 70.97134023600006],
              [25.062836134000065, 70.95758698100008],
              [25.05323326900009, 70.92788320500006],
              [25.02588951900009, 70.90839264500005],
              [24.988942905000044, 70.89130280200004],
              [24.94971764400009, 70.87885163000004],
              [24.916026238000086, 70.87323639500005],
              [24.93295332100007, 70.86762116100005],
              [24.971364780000044, 70.87616608300004],
              [24.988291863000086, 70.86981842700004],
              [25.004730665000068, 70.86163971600007],
              [25.048350457000083, 70.85797760600008],
              [25.06739342500009, 70.85276927300004],
              [25.067149285000085, 70.87303294500003],
              [25.076019727000073, 70.88434479400007],
              [25.111501498000052, 70.90932851800005],
              [25.13453209700009, 70.91966380400004],
              [25.142588738000086, 70.92169830900008],
              [25.153575066000087, 70.91950104400007],
              [25.159678582000083, 70.91486237200007],
              [25.16342207100007, 70.91014232000003],
              [25.16651451900009, 70.90802643400008],
              [25.179942254000082, 70.90375397300005],
              [25.231944207000083, 70.87323639500005],
              [25.24187259200005, 70.86237213700008],
              [25.26612389400009, 70.82542552300004],
              [25.245616082000083, 70.79132721600007],
              [25.25749759200005, 70.79083893400008],
              [25.266856316000087, 70.79425690300008],
              [25.27507571700005, 70.80048248900005],
              [25.283457879000082, 70.80874258000006],
              [25.294769727000073, 70.81342194200005],
              [25.311289910000085, 70.81419505400004],
              [25.34156334700009, 70.81244538000004],
              [25.349782748000052, 70.81867096600007],
              [25.39226321700005, 70.88442617400005],
              [25.396657748000052, 70.90070221600007],
              [25.385508660000085, 70.90802643400008],
              [25.375254754000082, 70.91315338700008],
              [25.360606316000087, 70.92560455900008],
              [25.34742272200009, 70.94041575700004],
              [25.341807488000086, 70.95270416900007],
              [25.36500084700009, 70.97614166900007],
              [25.418223504000082, 70.96454498900005],
              [25.535980665000068, 70.92291901200008],
              [25.537282748000052, 70.91128164300005],
              [25.52702884200005, 70.89765045800004],
              [25.512461785000085, 70.88690827000005],
              [25.49317467500009, 70.87791575700004],
              [25.44385826900009, 70.86261627800008],
              [25.423106316000087, 70.85960521000004],
              [25.441661004000082, 70.84149811400005],
              [25.465668165000068, 70.84406159100007],
              [25.512461785000085, 70.86981842700004],
              [25.520762566000087, 70.86912669500003],
              [25.53882897200009, 70.85439687700006],
              [25.553396030000044, 70.85276927300004],
              [25.56031334700009, 70.85700104400007],
              [25.58887780000009, 70.88068268400008],
              [25.616709832000083, 70.88857656500005],
              [25.66260826900009, 70.89533112200007],
              [25.705739780000044, 70.89557526200008],
              [25.724782748000052, 70.88377513200004],
              [25.72820071700005, 70.87738678600005],
              [25.736582879000082, 70.86933014500005],
              [25.746836785000085, 70.86245351800005],
              [25.756114129000082, 70.85960521000004],
              [25.768402540000068, 70.86286041900007],
              [25.778086785000085, 70.87010325700004],
              [25.785411004000082, 70.87738678600005],
              [25.790537957000083, 70.88068268400008],
              [25.823090040000068, 70.88568756700005],
              [25.853037957000083, 70.89402903900003],
              [25.881602410000085, 70.89569733300004],
              [25.910411004000082, 70.88068268400008],
              [25.918711785000085, 70.87287018400008],
              [25.925791863000086, 70.86367422100005],
              [25.92514082100007, 70.85590241100005],
              [25.895762566000087, 70.84955475500004],
              [25.868662957000083, 70.83543528900003],
              [25.82520592500009, 70.82746002800008],
              [25.800303582000083, 70.81541575700004],
              [25.75326582100007, 70.78449127800008],
              [25.726084832000083, 70.77545807500007],
              [25.629161004000082, 70.76398346600007],
              [25.63445071700005, 70.75503164300005],
              [25.64039147200009, 70.74848053600005],
              [25.656504754000082, 70.73602936400005],
              [25.64112389400009, 70.72288646000004],
              [25.62012780000009, 70.71230703300006],
              [25.59734134200005, 70.70514557500007],
              [25.55990644600007, 70.69904205900008],
              [25.512461785000085, 70.67121002800008],
              [25.446787957000083, 70.66193268400008],
              [25.427989129000082, 70.64240143400008],
              [25.353770379000082, 70.60716380400004],
              [25.306976759000065, 70.59931061400005],
              [25.287119988000086, 70.59271881700005],
              [25.254649285000085, 70.57225169500003],
              [25.23926842500009, 70.56476471600007],
              [25.101084832000083, 70.52309804900005],
              [25.07357832100007, 70.50332265800006],
              [25.245941602000073, 70.52789948100008],
              [25.287119988000086, 70.51072825700004],
              [25.242523634000065, 70.48663971600007],
              [25.05990644600007, 70.48965078300006],
              [25.097504102000073, 70.47134023600006],
              [25.243337436000047, 70.47842031500005],
              [25.287119988000086, 70.45612213700008],
              [25.267425977000073, 70.45600006700005],
              [25.251800977000073, 70.44806549700007],
              [25.245941602000073, 70.43463776200008],
              [25.264008009000065, 70.40534088700008],
              [25.26465905000009, 70.39301178600005],
              [25.256602410000085, 70.38637929900005],
              [25.19776451900009, 70.40037669500003],
              [25.156586134000065, 70.39394765800006],
              [25.08106530000009, 70.35932038000004],
              [25.09424889400009, 70.35472239800004],
              [25.107758009000065, 70.35297272300005],
              [25.13575280000009, 70.35309479400007],
              [25.117930535000085, 70.34699127800008],
              [25.105479363000086, 70.33624909100007],
              [25.104746941000087, 70.32534414300005],
              [25.12208092500009, 70.31834544500003],
              [25.14039147200009, 70.32282135600008],
              [25.16382897200009, 70.33307526200008],
              [25.186778191000087, 70.33934153900003],
              [25.203949415000068, 70.33197663000004],
              [25.20875084700009, 70.31671784100007],
              [25.201345248000052, 70.30707428600005],
              [25.05795332100007, 70.25446198100008],
              [25.02637780000009, 70.24852122600004],
              [25.014333530000044, 70.24457428600005],
              [25.00294030000009, 70.23908112200007],
              [24.994802280000044, 70.23297760600008],
              [24.98991946700005, 70.23045482000003],
              [24.97982832100007, 70.22943756700005],
              [24.978037957000083, 70.22581614800004],
              [24.978037957000083, 70.21849192900004],
              [24.97706139400009, 70.21548086100006],
              [24.97006269600007, 70.20628489800004],
              [24.96615644600007, 70.19891998900005],
              [24.964691602000073, 70.19135163000004],
              [24.970225457000083, 70.17682526200008],
              [24.964366082000083, 70.16998932500007],
              [24.946787957000083, 70.15761953300006],
              [24.94507897200009, 70.14858633000006],
              [24.943369988000086, 70.10236237200007],
              [24.96338951900009, 70.08038971600007],
              [25.004242384000065, 70.06403229400007],
              [25.037119988000086, 70.06435781500005],
              [25.033376498000052, 70.09243398600006],
              [25.023285352000073, 70.10089752800008],
              [25.011973504000082, 70.10862864800004],
              [25.006032748000052, 70.11859772300005],
              [25.01221764400009, 70.13397858300004],
              [25.027517123000052, 70.14280833500004],
              [25.09473717500009, 70.15387604400007],
              [25.08765709700009, 70.14760976800005],
              [25.07357832100007, 70.12661367400005],
              [25.090993686000047, 70.12710195500006],
              [25.107269727000073, 70.13068268400008],
              [25.122243686000047, 70.13226959800005],
              [25.13575280000009, 70.12661367400005],
              [25.10401451900009, 70.12128327000005],
              [25.09034264400009, 70.11660390800006],
              [25.08106530000009, 70.10602448100008],
              [25.093272332000083, 70.10028717700004],
              [25.101817254000082, 70.09100983300004],
              [25.11378014400009, 70.08246491100005],
              [25.13607832100007, 70.07880280200004],
              [25.159434441000087, 70.08087799700007],
              [25.205251498000052, 70.09027741100005],
              [25.228526238000086, 70.09243398600006],
              [25.252696160000085, 70.10130442900004],
              [25.27393639400009, 70.12270742400005],
              [25.310394727000073, 70.17121002800008],
              [25.324392123000052, 70.18244049700007],
              [25.341644727000073, 70.18988678600005],
              [25.361338738000086, 70.19415924700007],
              [25.38249759200005, 70.19546133000006],
              [25.394786004000082, 70.19969310100004],
              [25.41309655000009, 70.20990631700005],
              [25.429535352000073, 70.22223541900007],
              [25.436778191000087, 70.23297760600008],
              [25.45053144600007, 70.24949778900003],
              [25.517100457000083, 70.27789948100008],
              [25.54037519600007, 70.29783763200004],
              [25.51726321700005, 70.31134674700007],
              [25.423106316000087, 70.32514069200005],
              [25.44109134200005, 70.34223053600005],
              [25.656423373000052, 70.44061920800004],
              [25.869151238000086, 70.56419505400004],
              [25.896657748000052, 70.57160065300008],
              [25.92741946700005, 70.57640208500004],
              [25.960459832000083, 70.58893463700008],
              [25.990570509000065, 70.60651276200008],
              [26.01221764400009, 70.62620677300004],
              [26.053477410000085, 70.69269440300008],
              [26.07081139400009, 70.71246979400007],
              [26.08253014400009, 70.71637604400007],
              [26.119151238000086, 70.71735260600008],
              [26.13640384200005, 70.72304922100005],
              [26.145274285000085, 70.73135000200006],
              [26.156993035000085, 70.75018952000005],
              [26.163584832000083, 70.75779857000003],
              [26.191661004000082, 70.77374909100007],
              [26.255381707000083, 70.79743073100008],
              [26.30827884200005, 70.83331940300008],
              [26.374278191000087, 70.86847565300008],
              [26.613617384000065, 70.94912344000005],
              [26.69117272200009, 70.95579661700003],
              [26.68726647200009, 70.95270416900007],
              [26.67750084700009, 70.94212474200003],
              [26.725352410000085, 70.92788320500006],
              [26.71924889400009, 70.91616445500006],
              [26.722666863000086, 70.91095612200007],
              [26.729177280000044, 70.90668366100005],
              [26.732758009000065, 70.89777252800008],
              [26.73015384200005, 70.88788483300004],
              [26.723399285000085, 70.88080475500004],
              [26.708262566000087, 70.86981842700004],
              [26.696136915000068, 70.86440664300005],
              [26.681488477000073, 70.86286041900007],
              [26.669118686000047, 70.85960521000004],
              [26.66382897200009, 70.84931061400005],
              [26.665863477000073, 70.83803945500006],
              [26.671397332000083, 70.83063385600008],
              [26.679942254000082, 70.82664622600004],
              [26.690928582000083, 70.82542552300004],
              [26.704600457000083, 70.82900625200006],
              [26.720957879000082, 70.83539459800005],
              [26.73601321700005, 70.83860911700003],
              [26.74577884200005, 70.83226146000004],
              [26.744313998000052, 70.82347239800004],
              [26.735606316000087, 70.81533437700006],
              [26.719086134000065, 70.80499909100007],
              [26.704600457000083, 70.79002513200004],
              [26.691579623000052, 70.77293528900003],
              [26.68531334700009, 70.75458405200004],
              [26.69117272200009, 70.73602936400005],
              [26.640472852000073, 70.70661041900007],
              [26.341644727000073, 70.64793528900003],
              [26.375336134000065, 70.63837311400005],
              [26.49935957100007, 70.66095612200007],
              [26.537445509000065, 70.66185130400004],
              [26.623057488000086, 70.65192291900007],
              [26.656993035000085, 70.64052969000005],
              [26.601817254000082, 70.55853913000004],
              [26.606293165000068, 70.54437897300005],
              [26.59310957100007, 70.53587474200003],
              [26.57390384200005, 70.52846914300005],
              [26.560801629000082, 70.51764557500007],
              [26.558441602000073, 70.50413646000004],
              [26.563975457000083, 70.49681224200003],
              [26.573090040000068, 70.48965078300006],
              [26.581309441000087, 70.47662995000007],
              [26.541026238000086, 70.46157461100006],
              [26.521332227000073, 70.44839101800005],
              [26.51303144600007, 70.43158600500004],
              [26.51531009200005, 70.42365143400008],
              [26.525238477000073, 70.41339752800008],
              [26.526621941000087, 70.40770091400003],
              [26.52393639400009, 70.40058014500005],
              [26.515147332000083, 70.38670482000003],
              [26.51303144600007, 70.37978750200006],
              [26.510427280000044, 70.37775299700007],
              [26.506032748000052, 70.37055084800005],
              [26.505869988000086, 70.36286041900007],
              [26.51612389400009, 70.35932038000004],
              [26.553884311000047, 70.35309479400007],
              [26.567637566000087, 70.35618724200003],
              [26.57520592500009, 70.36196523600006],
              [26.578379754000082, 70.36823151200008],
              [26.583262566000087, 70.37433502800008],
              [26.594981316000087, 70.37978750200006],
              [26.608897332000083, 70.38080475500004],
              [26.63526451900009, 70.37665436400005],
              [26.649587436000047, 70.37978750200006],
              [26.631032748000052, 70.40110911700003],
              [26.629161004000082, 70.40770091400003],
              [26.63445071700005, 70.41303131700005],
              [26.65593509200005, 70.42475006700005],
              [26.662282748000052, 70.42641836100006],
              [26.69271894600007, 70.42023346600007],
              [26.723399285000085, 70.42088450700004],
              [26.753103061000047, 70.42731354400007],
              [26.780528191000087, 70.43842194200005],
              [26.79932701900009, 70.45465729400007],
              [26.803965691000087, 70.46954987200007],
              [26.81226647200009, 70.47992584800005],
              [26.94507897200009, 70.48285553600005],
              [26.931488477000073, 70.46645742400005],
              [26.94825280000009, 70.46246979400007],
              [27.05128014400009, 70.47606028900003],
              [27.07667076900009, 70.47435130400004],
              [27.10206139400009, 70.46979401200008],
              [27.090586785000085, 70.47451406500005],
              [27.05437259200005, 70.48285553600005],
              [27.04468834700009, 70.48773834800005],
              [27.02702884200005, 70.50332265800006],
              [26.976084832000083, 70.52741120000007],
              [26.966075066000087, 70.53807200700004],
              [26.990896030000044, 70.54376862200007],
              [27.000336134000065, 70.54905833500004],
              [27.007090691000087, 70.55853913000004],
              [26.98178144600007, 70.56464264500005],
              [26.972911004000082, 70.56537506700005],
              [26.991709832000083, 70.58283112200007],
              [27.021494988000086, 70.59894440300008],
              [27.053884311000047, 70.61017487200007],
              [27.080902540000068, 70.61318594000005],
              [27.088552280000044, 70.61090729400007],
              [27.107269727000073, 70.60244375200006],
              [27.116384311000047, 70.59951406500005],
              [27.129649285000085, 70.59833405200004],
              [27.171071811000047, 70.59951406500005],
              [27.242035352000073, 70.58543528900003],
              [27.26661217500009, 70.58527252800008],
              [27.235118035000085, 70.60171133000006],
              [27.12989342500009, 70.62620677300004],
              [27.099864129000082, 70.64109935100004],
              [27.105316602000073, 70.65574778900003],
              [27.15674889400009, 70.68146393400008],
              [27.139008009000065, 70.68919505400004],
              [27.09929446700005, 70.69672272300005],
              [27.080902540000068, 70.70258209800005],
              [27.110606316000087, 70.72870514500005],
              [27.139821811000047, 70.74062734600005],
              [27.286957227000073, 70.74355703300006],
              [27.316661004000082, 70.73895905200004],
              [27.32943769600007, 70.74331289300005],
              [27.34229576900009, 70.75779857000003],
              [27.318532748000052, 70.75934479400007],
              [27.293711785000085, 70.76390208500004],
              [27.280446811000047, 70.77472565300008],
              [27.29078209700009, 70.79507070500006],
              [27.310883009000065, 70.81818268400008],
              [27.32398522200009, 70.82363515800006],
              [27.34896894600007, 70.82542552300004],
              [27.629649285000085, 70.80499909100007],
              [27.48015384200005, 70.82542552300004],
              [27.48015384200005, 70.83226146000004],
              [27.495371941000087, 70.83173248900005],
              [27.508067254000082, 70.83600495000007],
              [27.520518425000034, 70.84178294500003],
              [27.534027540000068, 70.84593333500004],
              [27.522308790000068, 70.85150788000004],
              [27.509613477000073, 70.86180247600004],
              [27.500010613000086, 70.86640045800004],
              [27.490489129000082, 70.86725495000007],
              [27.47046959700009, 70.86595286700003],
              [27.46225019600007, 70.86981842700004],
              [27.458018425000034, 70.87531159100007],
              [27.45639082100007, 70.87807851800005],
              [27.453461134000065, 70.87933991100005],
              [27.44467207100007, 70.88068268400008],
              [27.409678582000083, 70.87645091400003],
              [27.391286655000044, 70.87636953300006],
              [27.38331139400009, 70.88377513200004],
              [27.386892123000052, 70.89166901200008],
              [27.404307488000086, 70.90619538000004],
              [27.410492384000065, 70.91425202000005],
              [27.394053582000083, 70.90973541900007],
              [27.36963951900009, 70.89321523600006],
              [27.355804884000065, 70.88690827000005],
              [27.335134311000047, 70.88401927300004],
              [27.190928582000083, 70.89496491100005],
              [27.15398196700005, 70.90570709800005],
              [27.122569207000083, 70.92169830900008],
              [27.13379967500009, 70.95001862200007],
              [27.148692254000082, 70.96385325700004],
              [27.171153191000087, 70.96686432500007],
              [27.34896894600007, 70.94212474200003],
              [27.341970248000052, 70.95270416900007],
              [27.331309441000087, 70.96076080900008],
              [27.307871941000087, 70.97260163000004],
              [27.28956139400009, 70.97919342700004],
              [27.248301629000082, 70.98908112200007],
              [27.232432488000086, 70.99677155200004],
              [27.22169030000009, 71.01894765800006],
              [27.253184441000087, 71.02631256700005],
              [27.476410352000073, 71.00665924700007],
              [27.500010613000086, 70.99363841400003],
              [27.508555535000085, 70.96857330900008],
              [27.529307488000086, 70.95547109600005],
              [27.554209832000083, 70.95526764500005],
              [27.57553144600007, 70.96881745000007],
              [27.566579623000052, 70.98163483300004],
              [27.564300977000073, 70.99445221600007],
              [27.569509311000047, 71.00653717700004],
              [27.58253014400009, 71.01727936400005],
              [27.54664147200009, 71.02269114800004],
              [27.533050977000073, 71.02875397300005],
              [27.52784264400009, 71.04144928600005],
              [27.526052280000044, 71.05707428600005],
              [27.523285352000073, 71.06647370000007],
              [27.524587436000047, 71.07440827000005],
              [27.534027540000068, 71.08612702000005],
              [27.568695509000065, 71.09723541900007],
              [27.610118035000085, 71.09292226800005],
              [27.64234459700009, 71.09544505400004],
              [27.65015709700009, 71.12710195500006],
              [27.715505405000044, 71.10423411700003],
              [27.724619988000086, 71.09039948100008],
              [27.698008660000085, 71.06565989800004],
              [27.721690300000034, 71.05971914300005],
              [27.787852410000085, 71.05947500200006],
              [27.811534050000034, 71.05597565300008],
              [27.855723504000082, 71.04100169500003],
              [27.87671959700009, 71.03774648600006],
              [27.963633660000085, 71.04661692900004],
              [27.983164910000085, 71.05573151200008],
              [27.999034050000034, 71.06582265800006],
              [28.020762566000087, 71.07099030200004],
              [28.043223504000082, 71.07099030200004],
              [28.061696811000047, 71.06565989800004],
              [28.063975457000083, 71.06159088700008],
              [28.063324415000068, 71.05585358300004],
              [28.063975457000083, 71.04995351800005],
              [28.069102410000085, 71.04515208500004],
              [28.081065300000034, 71.04096100500004],
              [28.087168816000087, 71.04157135600008],
              [28.145192905000044, 71.07404205900008],
              [28.16732832100007, 71.08270905200004],
              [28.191416863000086, 71.08612702000005],
              [28.209727410000085, 71.08397044500003],
              [28.232758009000065, 71.07802969000005],
              [28.25245201900009, 71.06842682500007],
              [28.260996941000087, 71.05573151200008],
              [28.252289259000065, 71.03937409100007],
              [28.23292076900009, 71.03261953300006],
              [28.211924675000034, 71.02777741100005],
              [28.19890384200005, 71.01727936400005],
              [28.21924889400009, 71.01727936400005],
              [28.208994988000086, 71.01532623900005],
              [28.199961785000085, 71.01117584800005],
              [28.19190514400009, 71.00495026200008],
              [28.18523196700005, 70.99677155200004],
              [28.19971764400009, 70.99896881700005],
              [28.239756707000083, 71.01105377800008],
              [28.234385613000086, 71.00071849200003],
              [28.22632897200009, 70.99282461100006],
              [28.216319207000083, 70.98700592700004],
              [28.205088738000086, 70.98309967700004],
              [28.233083530000044, 70.97703685100004],
              [28.34343509200005, 71.00421784100007],
              [28.491465691000087, 70.99982330900008],
              [28.53101647200009, 70.98362864800004],
              [28.539235873000052, 70.98248932500007],
              [28.546071811000047, 70.97992584800005],
              [28.548838738000086, 70.97260163000004],
              [28.54664147200009, 70.96694570500006],
              [28.53687584700009, 70.95844147300005],
              [28.529307488000086, 70.93919505400004],
              [28.505707227000073, 70.91986725500004],
              [28.50049889400009, 70.91111888200004],
              [28.483164910000085, 70.88947174700007],
              [28.443207227000073, 70.88393789300005],
              [28.369476759000065, 70.88690827000005],
              [28.383555535000085, 70.87498607000003],
              [28.403168165000068, 70.87250397300005],
              [28.425059441000087, 70.87213776200008],
              [28.445160352000073, 70.86640045800004],
              [28.42237389400009, 70.85317617400005],
              [28.397471550000034, 70.84711334800005],
              [28.34343509200005, 70.84593333500004],
              [28.34343509200005, 70.83974844000005],
              [28.352712436000047, 70.83714427300004],
              [28.356455925000034, 70.83466217700004],
              [28.358653191000087, 70.83112213700008],
              [28.363291863000086, 70.82542552300004],
              [28.225433790000068, 70.83226146000004],
              [28.243337436000047, 70.82489655200004],
              [28.261973504000082, 70.81940338700008],
              [28.30128014400009, 70.81244538000004],
              [28.265879754000082, 70.79498932500007],
              [28.223887566000087, 70.78583405200004],
              [28.179698113000086, 70.78286367400005],
              [28.137380405000044, 70.78449127800008],
              [28.080739780000044, 70.79710521000004],
              [28.061696811000047, 70.79877350500004],
              [28.02312259200005, 70.79291413000004],
              [28.00953209700009, 70.79612864800004],
              [28.013845248000052, 70.81244538000004],
              [27.998789910000085, 70.81574127800008],
              [27.985850457000083, 70.81313711100006],
              [27.973317905000044, 70.80825429900005],
              [27.959239129000082, 70.80499909100007],
              [27.950694207000083, 70.79775625200006],
              [27.822276238000086, 70.79120514500005],
              [27.808441602000073, 70.79507070500006],
              [27.79851321700005, 70.79657623900005],
              [27.772634311000047, 70.79165273600006],
              [27.760020379000082, 70.79132721600007],
              [27.776377800000034, 70.78148021000004],
              [27.811778191000087, 70.77667877800008],
              [27.828298373000052, 70.77081940300008],
              [27.813243035000085, 70.76483795800004],
              [27.796722852000073, 70.76093170800004],
              [27.782481316000087, 70.75519440300008],
              [27.773692254000082, 70.74355703300006],
              [27.857595248000052, 70.76300690300008],
              [27.899668816000087, 70.76821523600006],
              [27.98682701900009, 70.75702545800004],
              [27.993418816000087, 70.75409577000005],
              [27.997325066000087, 70.74579498900005],
              [28.006683790000068, 70.74286530200004],
              [28.080821160000085, 70.74567291900007],
              [28.107432488000086, 70.74384186400005],
              [28.13054446700005, 70.73602936400005],
              [28.072438998000052, 70.70327383000006],
              [27.933441602000073, 70.68707916900007],
              [27.869883660000085, 70.66779205900008],
              [27.874034050000034, 70.66510651200008],
              [27.87671959700009, 70.66095612200007],
              [27.793142123000052, 70.63678620000007],
              [27.752940300000034, 70.63153717700004],
              [27.721853061000047, 70.62213776200008],
              [27.676524285000085, 70.61566803600005],
              [27.65015709700009, 70.60635000200006],
              [27.79468834700009, 70.61367422100005],
              [28.153819207000083, 70.67792389500005],
              [28.253428582000083, 70.71637604400007],
              [28.283376498000052, 70.71849192900004],
              [28.30128014400009, 70.70258209800005],
              [28.287852410000085, 70.65375397300005],
              [28.233164910000085, 70.61517975500004],
              [28.16651451900009, 70.58746979400007],
              [28.05795332100007, 70.55540599200003],
              [28.033539259000065, 70.54120514500005],
              [27.994395379000082, 70.52651601800005],
              [27.91187584700009, 70.51162344000005],
              [27.873789910000085, 70.49860260600008],
              [27.84937584700009, 70.48285553600005],
              [27.862315300000034, 70.46967194200005],
              [27.869965040000068, 70.45856354400007],
              [27.883555535000085, 70.42820872600004],
              [27.89389082100007, 70.43919505400004],
              [27.91456139400009, 70.47321198100008],
              [27.927907748000052, 70.48273346600007],
              [27.94499759200005, 70.48916250200006],
              [27.979746941000087, 70.49705638200004],
              [27.958018425000034, 70.48444245000007],
              [27.938161655000044, 70.46979401200008],
              [28.058604363000086, 70.49298737200007],
              [28.18523196700005, 70.50332265800006],
              [28.080088738000086, 70.47711823100008],
              [28.051768425000034, 70.45954010600008],
              [28.040863477000073, 70.44476959800005],
              [28.050059441000087, 70.44253164300005],
              [28.08765709700009, 70.45148346600007],
              [28.112803582000083, 70.46385325700004],
              [28.13054446700005, 70.46979401200008],
              [28.12948652400007, 70.46934642100007],
              [28.110443556000064, 70.46120840100008],
              [28.10401451900009, 70.45433177300004],
              [28.107595248000052, 70.44570547100005],
              [28.127126498000052, 70.44183991100005],
              [28.13721764400009, 70.44668203300006],
              [28.177744988000086, 70.47662995000007],
              [28.214040561000047, 70.49567291900007],
              [28.252940300000034, 70.51007721600007],
              [28.293630405000044, 70.51797109600005],
              [28.33529707100007, 70.51764557500007],
              [28.322113477000073, 70.49697500200006],
              [28.30323326900009, 70.48663971600007],
              [28.282481316000087, 70.47898997600004],
              [28.264008009000065, 70.46637604400007],
              [28.246836785000085, 70.44822825700004],
              [28.213226759000065, 70.42121002800008],
              [28.17237389400009, 70.39545319200005],
              [28.16065514400009, 70.38279857000003],
              [28.158457879000082, 70.36810944200005],
              [28.168142123000052, 70.34943268400008],
              [28.173350457000083, 70.33295319200005],
              [28.16960696700005, 70.31537506700005],
              [28.157237175000034, 70.28424713700008],
              [28.15788821700005, 70.24730052300004],
              [28.177907748000052, 70.18227773600006],
              [28.177744988000086, 70.15387604400007],
              [28.167246941000087, 70.13548411700003],
              [28.15202884200005, 70.12372467700004],
              [28.13526451900009, 70.11416250200006],
              [28.099782748000052, 70.08812083500004],
              [28.07081139400009, 70.07737864800004],
              [28.039886915000068, 70.07127513200004],
              [28.013845248000052, 70.07135651200008],
              [28.066254102000073, 70.06317780200004],
              [28.128103061000047, 70.08161041900007],
              [28.183929884000065, 70.11554596600007],
              [28.21924889400009, 70.15387604400007],
              [28.225433790000068, 70.17401764500005],
              [28.219737175000034, 70.18602122600004],
              [28.208506707000083, 70.19749583500004],
              [28.19890384200005, 70.21588776200008],
              [28.19890384200005, 70.22622304900005],
              [28.204356316000087, 70.24579498900005],
              [28.201914910000085, 70.25348541900007],
              [28.198741082000083, 70.25995514500005],
              [28.191416863000086, 70.28424713700008],
              [28.195567254000082, 70.30158112200007],
              [28.216644727000073, 70.33006419500003],
              [28.225433790000068, 70.34564850500004],
              [28.229177280000044, 70.36591217700004],
              [28.229177280000044, 70.38328685100004],
              [28.232676629000082, 70.39911530200004],
              [28.24659264400009, 70.41453685100004],
              [28.258148634000065, 70.42096588700008],
              [28.291188998000052, 70.43292877800008],
              [28.32081139400009, 70.43891022300005],
              [28.325043165000068, 70.44830963700008],
              [28.32553144600007, 70.45978424700007],
              [28.329112175000034, 70.46979401200008],
              [28.353363477000073, 70.48379140800006],
              [28.39039147200009, 70.49335358300004],
              [28.428965691000087, 70.49603913000004],
              [28.458832227000073, 70.48965078300006],
              [28.456228061000047, 70.47199127800008],
              [28.46924889400009, 70.45514557500007],
              [28.489268425000034, 70.44525788000004],
              [28.507334832000083, 70.44871653900003],
              [28.511729363000086, 70.45799388200004],
              [28.506846550000034, 70.46625397300005],
              [28.500336134000065, 70.47418854400007],
              [28.50049889400009, 70.48285553600005],
              [28.510752800000034, 70.49184804900005],
              [28.525726759000065, 70.49787018400008],
              [28.555023634000065, 70.50332265800006],
              [28.555023634000065, 70.51072825700004],
              [28.481700066000087, 70.51211172100005],
              [28.458832227000073, 70.51764557500007],
              [28.406097852000073, 70.54498932500007],
              [28.397471550000034, 70.54828522300005],
              [28.40170332100007, 70.55898672100005],
              [28.479258660000085, 70.62620677300004],
              [28.485036655000044, 70.63580963700008],
              [28.493418816000087, 70.65802643400008],
              [28.50049889400009, 70.66779205900008],
              [28.516856316000087, 70.67816803600005],
              [28.533864780000044, 70.68012116100005],
              [28.57553144600007, 70.67462799700007],
              [28.613536004000082, 70.67381419500003],
              [28.620290561000047, 70.67829010600008],
              [28.610362175000034, 70.68891022300005],
              [28.57593834700009, 70.70148346600007],
              [28.54070071700005, 70.70892975500004],
              [28.526215040000068, 70.72174713700008],
              [28.555023634000065, 70.75039297100005],
              [28.64307701900009, 70.78925202000005],
              [28.693207227000073, 70.82982005400004],
              [28.725596550000034, 70.84894440300008],
              [28.76107832100007, 70.86408112200007],
              [28.79468834700009, 70.87323639500005],
              [29.057465040000068, 70.88401927300004],
              [29.082692905000044, 70.88068268400008],
              [29.104502800000034, 70.87303294500003],
              [29.102224155000044, 70.86871979400007],
              [29.06226647200009, 70.86640045800004],
              [29.06226647200009, 70.85960521000004],
              [29.221364780000044, 70.85541413000004],
              [29.26140384200005, 70.83974844000005],
              [29.26303144600007, 70.83502838700008],
              [29.261973504000082, 70.82086823100008],
              [29.264821811000047, 70.81517161700003],
              [29.272959832000083, 70.80971914300005],
              [29.282399936000047, 70.80512116100005],
              [29.301768425000034, 70.79877350500004],
              [29.381195509000065, 70.79291413000004],
              [29.40479576900009, 70.78449127800008],
              [29.38054446700005, 70.76943594000005],
              [29.294932488000086, 70.74355703300006],
              [29.322113477000073, 70.73493073100008],
              [29.417816602000073, 70.73602936400005],
              [29.399099155000044, 70.72821686400005],
              [29.372569207000083, 70.72386302300004],
              [29.322276238000086, 70.72304922100005],
              [29.32789147200009, 70.71271393400008],
              [29.337738477000073, 70.70844147300005],
              [29.350271030000044, 70.70807526200008],
              [29.36378014400009, 70.70937734600005],
              [29.351898634000065, 70.69529857000003],
              [29.328786655000044, 70.69000885600008],
              [29.30250084700009, 70.68740469000005],
              [29.281423373000052, 70.68146393400008],
              [29.285004102000073, 70.67861562700006],
              [29.287852410000085, 70.67698802300004],
              [29.294932488000086, 70.67462799700007],
              [29.281423373000052, 70.66095612200007],
              [29.30640709700009, 70.65289948100008],
              [29.328868035000085, 70.65997955900008],
              [29.369965040000068, 70.68891022300005],
              [29.392100457000083, 70.69733307500007],
              [29.517751498000052, 70.70587799700007],
              [29.699554884000065, 70.74371979400007],
              [29.74577884200005, 70.74274323100008],
              [29.77898196700005, 70.72654857000003],
              [29.781504754000082, 70.68891022300005],
              [29.761973504000082, 70.66449616100005],
              [29.702647332000083, 70.63959381700005],
              [29.679209832000083, 70.62002187700006],
              [29.823090040000068, 70.63369375200006],
              [29.83952884200005, 70.63939036700003],
              [29.84937584700009, 70.64720286700003],
              [29.858083530000044, 70.65595123900005],
              [29.870371941000087, 70.66437409100007],
              [29.959157748000052, 70.70465729400007],
              [29.99382571700005, 70.71308014500005],
              [30.069590691000087, 70.71556224200003],
              [30.104746941000087, 70.71076080900008],
              [30.20679772200009, 70.68146393400008],
              [30.18604576900009, 70.66469961100006],
              [30.156504754000082, 70.65599192900004],
              [30.096934441000087, 70.64793528900003],
              [30.130707227000073, 70.63882070500006],
              [30.240896030000044, 70.63369375200006],
              [30.336924675000034, 70.60614655200004],
              [30.34734134200005, 70.59613678600005],
              [30.326914910000085, 70.58490631700005],
              [30.264659050000034, 70.56976959800005],
              [30.152679884000065, 70.55825429900005],
              [30.12476647200009, 70.55170319200005],
              [30.12476647200009, 70.54486725500004],
              [30.13803144600007, 70.54637278900003],
              [30.150238477000073, 70.54584381700005],
              [30.15984134200005, 70.54144928600005],
              [30.165212436000047, 70.53123607000003],
              [30.124278191000087, 70.53168366100005],
              [30.041351759000065, 70.54437897300005],
              [30.000743035000085, 70.54486725500004],
              [30.000743035000085, 70.53807200700004],
              [30.163096550000034, 70.52460358300004],
              [30.456309441000087, 70.56122467700004],
              [30.50163821700005, 70.55853913000004],
              [30.58179772200009, 70.54218170800004],
              [30.599131707000083, 70.52977122600004],
              [30.562347852000073, 70.51764557500007],
              [30.731944207000083, 70.46816640800006],
              [30.741221550000034, 70.44183991100005],
              [30.786631707000083, 70.42064036700003],
              [30.812347852000073, 70.41469961100006],
              [30.823741082000083, 70.42479075700004],
              [30.837412957000083, 70.43170807500007],
              [30.926036004000082, 70.45612213700008],
              [30.94695071700005, 70.45001862200007],
              [30.973399285000085, 70.42121002800008],
              [30.98796634200005, 70.41453685100004],
              [31.00562584700009, 70.40900299700007],
              [31.063324415000068, 70.36676666900007],
              [31.047699415000068, 70.35626862200007],
              [31.030528191000087, 70.34878164300005],
              [31.019379102000073, 70.33991120000007],
              [31.021739129000082, 70.32514069200005],
              [31.033946160000085, 70.31500885600008],
              [31.05046634200005, 70.30878327000005],
              [31.066416863000086, 70.30048248900005],
              [31.076996290000068, 70.28424713700008],
              [31.041188998000052, 70.28485748900005],
              [30.933604363000086, 70.26373932500007],
              [30.548838738000086, 70.24868398600006],
              [30.515147332000083, 70.23908112200007],
              [30.514659050000034, 70.21588776200008],
              [30.488942905000044, 70.20307038000004],
              [30.398610873000052, 70.19546133000006],
              [30.374847852000073, 70.18585846600007],
              [30.357758009000065, 70.17324453300006],
              [30.357432488000086, 70.16128164300005],
              [30.384287957000083, 70.15387604400007],
              [30.35523522200009, 70.12970612200007],
              [30.317067905000044, 70.11737702000005],
              [30.144704623000052, 70.09243398600006],
              [30.119476759000065, 70.08490631700005],
              [30.117930535000085, 70.07807038000004],
              [30.133148634000065, 70.07318756700005],
              [30.158946160000085, 70.07135651200008],
              [29.689707878500087, 70.09585195500006],
              [29.22046959700009, 70.12034739800004],
              [29.226735873000052, 70.12034739800004],
              [28.94019615950006, 70.15133291250004],
              [28.65365644600007, 70.18231842700004],
              [28.61654707100007, 70.17690664300005],
              [28.596690300000034, 70.16132233300004],
              [28.75367272200009, 70.16754791900007],
              [28.732595248000052, 70.14931875200006],
              [28.690114780000044, 70.13410065300008],
              [28.643565300000034, 70.12392812700006],
              [28.610362175000034, 70.12034739800004],
              [28.62940514400009, 70.10712311400005],
              [28.664805535000085, 70.10000234600005],
              [28.732676629000082, 70.09857819200005],
              [28.774099155000044, 70.11139557500007],
              [28.78646894600007, 70.11115143400008],
              [28.833994988000086, 70.09951406500005],
              [28.849945509000065, 70.09857819200005],
              [28.849945509000065, 70.09243398600006],
              [28.759043816000087, 70.09357330900008],
              [28.732676629000082, 70.08559804900005],
              [28.924082879000082, 70.07387929900005],
              [28.993337436000047, 70.05585358300004],
              [29.137950066000087, 70.05760325700004],
              [29.129161004000082, 70.04755280200004],
              [29.124278191000087, 70.04401276200008],
              [29.16187584700009, 70.04515208500004],
              [29.183116082000083, 70.04340241100005],
              [29.192556186000047, 70.03717682500007],
              [29.183848504000082, 70.03294505400004],
              [29.130381707000083, 70.01675039300005],
              [29.158376498000052, 70.00922272300005],
              [29.34343509200005, 70.01675039300005],
              [29.389414910000085, 70.00486888200004],
              [29.685883009000065, 69.96954987200007],
              [29.663584832000083, 69.96596914300005],
              [29.57553144600007, 69.93577708500004],
              [29.529470248000052, 69.92536041900007],
              [29.486338738000086, 69.91071198100008],
              [29.440114780000044, 69.90082428600005],
              [29.42164147200009, 69.89036692900004],
              [29.415049675000034, 69.88361237200007],
              [29.412282748000052, 69.87962474200003],
              [29.408376498000052, 69.87588125200006],
              [29.398285352000073, 69.86957428600005],
              [29.39031009200005, 69.86615631700005],
              [29.36378014400009, 69.85968659100007],
              [29.413259311000047, 69.85691966400003],
              [29.435801629000082, 69.86237213700008],
              [29.471446160000085, 69.88784414300005],
              [29.51539147200009, 69.90932851800005],
              [29.535166863000086, 69.91425202000005],
              [29.549489780000044, 69.91469961100006],
              [29.563649936000047, 69.91303131700005],
              [29.577403191000087, 69.90936920800004],
              [29.59034264400009, 69.90403880400004],
              [29.604340040000068, 69.90127187700006],
              [29.629893425000034, 69.90704987200007],
              [29.667246941000087, 69.90135325700004],
              [29.714366082000083, 69.91364166900007],
              [29.741221550000034, 69.90745677300004],
              [29.731618686000047, 69.89443594000005],
              [29.738129102000073, 69.88572825700004],
              [29.746267123000052, 69.87742747600004],
              [29.741221550000034, 69.86587148600006],
              [29.775401238000086, 69.83856842700004],
              [29.755381707000083, 69.82884349200003],
              [29.736989780000044, 69.80292389500005],
              [29.699392123000052, 69.79328034100007],
              [29.649261915000068, 69.77191803600005],
              [29.64503014400009, 69.76341380400004],
              [29.64503014400009, 69.75600820500006],
              [29.624847852000073, 69.75409577000005],
              [29.612559441000087, 69.74494049700007],
              [29.602793816000087, 69.73297760600008],
              [29.589691602000073, 69.72247955900008],
              [29.570567254000082, 69.71649811400005],
              [29.528086785000085, 69.71295807500007],
              [29.507985873000052, 69.70880768400008],
              [29.54346764400009, 69.70831940300008],
              [29.53370201900009, 69.69525788000004],
              [29.506032748000052, 69.67706940300008],
              [29.487315300000034, 69.66107819200005],
              [29.521494988000086, 69.66844310100004],
              [29.537771030000044, 69.67499420800004],
              [29.567230665000068, 69.69489166900007],
              [29.680023634000065, 69.73541901200008],
              [29.715586785000085, 69.74111562700006],
              [29.820974155000044, 69.74396393400008],
              [29.901621941000087, 69.73631419500003],
              [29.908457879000082, 69.73745351800005],
              [29.993011915000068, 69.76801178600005],
              [30.030446811000047, 69.77594635600008],
              [30.062754754000082, 69.77024974200003],
              [30.04346764400009, 69.76141998900005],
              [30.019053582000083, 69.73753489800004],
              [30.000987175000034, 69.72557200700004],
              [29.954925977000073, 69.71531810100004],
              [29.936696811000047, 69.70575592700004],
              [29.939300977000073, 69.68773021000004],
              [29.952321811000047, 69.70522695500006],
              [29.977793816000087, 69.71417877800008],
              [30.028575066000087, 69.72247955900008],
              [30.071136915000068, 69.73993561400005],
              [30.080821160000085, 69.73867422100005],
              [30.101735873000052, 69.71621328300006],
              [30.114512566000087, 69.70620351800005],
              [30.17514082100007, 69.68634674700007],
              [30.186289910000085, 69.68773021000004],
              [30.18799889400009, 69.69570547100005],
              [30.180674675000034, 69.70197174700007],
              [30.161957227000073, 69.71190013200004],
              [30.122243686000047, 69.74384186400005],
              [30.110606316000087, 69.75600820500006],
              [30.131846550000034, 69.75999583500004],
              [30.188975457000083, 69.76251862200007],
              [30.20679772200009, 69.77024974200003],
              [30.208994988000086, 69.78440989800004],
              [30.19467207100007, 69.79364655200004],
              [30.174571160000085, 69.80141836100006],
              [30.158946160000085, 69.81122467700004],
              [30.165863477000073, 69.82391998900005],
              [30.167979363000086, 69.84662506700005],
              [30.167165561000047, 69.86871979400007],
              [30.165212436000047, 69.87954336100006],
              [30.240896030000044, 69.87954336100006],
              [30.289235873000052, 69.88654205900008],
              [30.302744988000086, 69.88324616100005],
              [30.32398522200009, 69.86713288000004],
              [30.318207227000073, 69.85927969000005],
              [30.268809441000087, 69.84540436400005],
              [30.299489780000044, 69.83820221600007],
              [30.371836785000085, 69.84760163000004],
              [30.398610873000052, 69.83856842700004],
              [30.402598504000082, 69.83124420800004],
              [30.40365644600007, 69.82241445500006],
              [30.403819207000083, 69.81313711100006],
              [30.40479576900009, 69.80438873900005],
              [30.410980665000068, 69.78196849200003],
              [30.412282748000052, 69.78050364800004],
              [30.413584832000083, 69.73663971600007],
              [30.40984134200005, 69.70229726800005],
              [30.388194207000083, 69.68036530200004],
              [30.337087436000047, 69.67405833500004],
              [30.360199415000068, 69.66746653900003],
              [30.42937259200005, 69.67405833500004],
              [30.443532748000052, 69.67841217700004],
              [30.44857832100007, 69.68895091400003],
              [30.45248457100007, 69.71503327000005],
              [30.447438998000052, 69.72679271000004],
              [30.447438998000052, 69.73334381700005],
              [30.462087436000047, 69.73773834800005],
              [30.465179884000065, 69.74164459800005],
              [30.46656334700009, 69.74701569200005],
              [30.466807488000086, 69.75287506700005],
              [30.46265709700009, 69.76422760600008],
              [30.455251498000052, 69.77334219000005],
              [30.451833530000044, 69.78168366100005],
              [30.459971550000034, 69.79075755400004],
              [30.450694207000083, 69.81028880400004],
              [30.48292076900009, 69.81818268400008],
              [30.698741082000083, 69.80853913000004],
              [30.720550977000073, 69.79759349200003],
              [30.70671634200005, 69.79279205900008],
              [30.700368686000047, 69.78343333500004],
              [30.703135613000086, 69.77440013200004],
              [30.716970248000052, 69.77024974200003],
              [30.732595248000052, 69.77220286700003],
              [30.74968509200005, 69.77716705900008],
              [30.782074415000068, 69.79075755400004],
              [30.78956139400009, 69.79075755400004],
              [30.840953890666185, 69.80584190246314],
              [30.843987671000093, 69.76623362300005],
              [30.867862183000057, 69.74897369500003],
              [30.877060587000074, 69.73760487900005],
              [30.8823315840001, 69.720086569],
              [30.881298055000116, 69.7105264290001],
              [30.884295288000146, 69.70236155200008],
              [30.90124515800005, 69.68897735600005],
              [30.927703491000045, 69.67213083900008],
              [30.93080407700006, 69.59487457300007],
              [30.92703169700013, 69.5783897920001],
              [30.898247925000135, 69.54423167000003],
              [30.852979370000128, 69.52743682900005],
              [30.755310913000073, 69.52149403900005],
              [30.5116565350001, 69.53632517600006],
              [30.480702351000048, 69.54412831700007],
              [30.294357137000134, 69.62024770100005],
              [30.230691772000057, 69.637300924],
              [30.186146688000065, 69.6413316860001],
              [30.141239868000127, 69.6398847460001],
              [30.119070679000117, 69.63456207300005],
              [30.126718791000087, 69.62644887300006],
              [30.14862959800007, 69.61849070300009],
              [30.208780965000074, 69.60867218100002],
              [30.2201497800001, 69.60024892200003],
              [30.228676392000068, 69.58205881800008],
              [30.23162194800011, 69.55833933600006],
              [30.22469730600011, 69.54082102500008],
              [30.210641317000068, 69.52821197500005],
              [30.19229618300011, 69.51916859900011],
              [30.164029175000053, 69.51183054600001],
              [30.154830770000046, 69.50609446200006],
              [30.145012248000057, 69.49105662100006],
              [30.141084839000087, 69.476793925],
              [30.14077478100012, 69.46439158200012],
              [30.137364136000087, 69.45297109000002],
              [30.1234114990001, 69.441912334],
              [30.00176517700004, 69.39457672200005],
              [29.967141968000135, 69.37349273700003],
              [29.948073364000038, 69.36558624300007],
              [29.900686075000067, 69.35824819000008],
              [29.751392863000035, 69.35716298500007],
              [29.72839685100007, 69.35153025300006],
              [29.661837605000073, 69.32502024400004],
              [29.604270061000136, 69.315201722],
              [29.434564657000124, 69.31184275400007],
              [29.376790405000122, 69.30161082000008],
              [29.334519084000135, 69.27737457300002],
              [29.326560913000094, 69.26264679000009],
              [29.315863892000095, 69.23494822200009],
              [29.307440633000112, 69.22631825800003],
              [29.305476929000065, 69.2181017060001],
              [29.305373576000136, 69.20973012300003],
              [29.302272990000063, 69.200841777],
              [29.294418172000064, 69.19169504800003],
              [29.27643477400005, 69.17593373700005],
              [29.268786661000092, 69.16668365600005],
              [29.25100996900005, 69.13076853400007],
              [29.240467977000094, 69.11505889900009],
              [29.22103763800004, 69.09841908900007],
              [29.172978556000146, 69.0693769330001],
              [29.12026859500014, 69.04684600900008],
              [29.06476810700005, 69.03470204700007],
              [29.008130737000073, 69.03692413400007],
              [28.973662557000097, 69.03423695900004],
              [28.95407718900009, 69.02726064100004],
              [28.839613892000074, 69.08028066000004],
              [28.827573283000106, 69.090770976],
              [28.826953166000123, 69.10684234700007],
              [28.844109741000096, 69.18125640900008],
              [28.852171265000095, 69.20352895200004],
              [28.864780314000114, 69.216603089],
              [29.229254191000052, 69.37685170500005],
              [29.34454431100005, 69.46439158200012],
              [29.20315759300007, 69.58598622600006],
              [29.147140341000124, 69.66391428700003],
              [29.1312239990001, 69.67419789700004],
              [28.806075887000077, 69.72995676750013],
              [28.48092777500011, 69.78571563800004],
              [28.442687215000035, 69.791451722],
              [28.404550008000058, 69.80225209600012],
              [28.37974532000004, 69.82235422800007],
              [28.381192260000034, 69.85620229100009],
              [28.18926599100007, 69.88604543100008],
              [28.167355184000115, 69.89433949900005],
              [27.981009969000098, 70.00960378100005],
              [27.927163127000142, 70.05327036600004],
              [27.89729414900006, 70.07068532400005],
              [27.866908407000096, 70.07531036400012],
              [27.792184286000094, 70.05892893600007],
              [27.665060262000054, 70.06828237000009],
              [27.612557007000078, 70.06205535900001],
              [27.570905802000055, 70.04089386000005],
              [27.5633093670001, 70.02358225500005],
              [27.445228719000113, 70.00322174100002],
              [27.380943237000054, 69.97425710100005],
              [27.364975220000105, 69.97175079400007],
              [27.349110555000095, 69.97128570600005],
              [27.334537801000124, 69.96862436900004],
              [27.32316898600004, 69.95968434700008],
              [27.330507039000054, 69.9574622600001],
              [27.34507979300011, 69.95074432400007],
              [27.352417847000083, 69.948703105],
              [27.311800170000055, 69.9294794720001],
              [27.1003402100001, 69.90175506600006],
              [27.081219930000117, 69.90294362400009],
              [27.00752933700008, 69.92245147800007],
              [26.981071004000086, 69.923278301],
              [26.951098673000047, 69.92015187600005],
              [26.89570153800011, 69.934337057],
              [26.864592326000064, 69.93808359900002],
              [26.771884807000077, 69.928394267],
              [26.70697920700013, 69.93506052700009],
              [26.533863159000077, 69.92524200500004],
              [26.500686890000082, 69.91831736200005],
              [26.481049846000133, 69.89940378900012],
              [26.445909871000083, 69.88175628700002],
              [26.435884643000065, 69.87423736600009],
              [26.44787357600012, 69.85604726200005],
              [26.418728068000092, 69.83563507100008],
              [26.31682214300011, 69.79491404200003],
              [26.268246297000104, 69.75827545200006],
              [26.222977742000126, 69.7319204710001],
              [26.210988811000078, 69.72287709600006],
              [26.198276408000112, 69.71543569000004],
              [26.18142989100005, 69.71124989800008],
              [26.031981649000045, 69.69667714500004],
              [26.005109904000022, 69.68933909100004],
              [25.981338745000073, 69.67486969000002],
              [25.968833049000068, 69.66319081600004],
              [25.961701701000038, 69.65254547200006],
              [25.964388875000054, 69.64267527300005],
              [25.9811320390001, 69.63347686800007],
              [26.005109904000022, 69.61084259000002],
              [26.0039730230001, 69.58717478500007],
              [25.986196330000098, 69.56541900600006],
              [25.960254761000044, 69.54867584200012],
              [25.900206747000112, 69.53203603200011],
              [25.88666752100005, 69.52087392200006],
              [25.890594930000105, 69.51482778000003],
              [25.90144698100005, 69.50914337200008],
              [25.9064079180001, 69.5018569950001],
              [25.89214522300003, 69.49090159200001],
              [25.8857373460001, 69.47911936500002],
              [25.88666752100005, 69.45519317600012],
              [25.877469116000043, 69.447028301],
              [25.86579024200006, 69.44098215800007],
              [25.841398966000042, 69.41777943900006],
              [25.87261153200012, 69.37907379200003],
              [25.877365763000114, 69.370805563],
              [25.78662194900005, 69.31277292900002],
              [25.774529663000067, 69.29882029300005],
              [25.737219279000044, 69.21820505800004],
              [25.734118693000084, 69.19133331400003],
              [25.749931681000078, 69.16518503900004],
              [25.755306031000146, 69.1595523080001],
              [25.76832849100009, 69.14213735000006],
              [25.771222372000068, 69.13510935500004],
              [25.769982137000056, 69.12740956700007],
              [25.76636478700007, 69.122707012],
              [25.7624373780001, 69.11919301400003],
              [25.76047367400014, 69.11516225200005],
              [25.759026734000145, 69.08203765900002],
              [25.757166382000065, 69.07511301700005],
              [25.749414917000138, 69.06555287700006],
              [25.750241739000074, 69.05924835200004],
              [25.765124553000106, 69.04338368700003],
              [25.7657446690001, 69.03919789600009],
              [25.76460778800009, 69.035167135],
              [25.765848022000114, 69.03067128600007],
              [25.77380619300007, 69.02540028900005],
              [25.79292647300008, 69.01816558800009],
              [25.801091350000092, 69.0131529750001],
              [25.804708700000077, 69.00612498000002],
              [25.795820353000067, 68.99330922500003],
              [25.75385909000005, 68.97837473600008],
              [25.742696981000023, 68.96586903900005],
              [25.7374259850001, 68.95253652000004],
              [25.7263672280001, 68.94245961500009],
              [25.694844605000128, 68.92561309800003],
              [25.67841149900005, 68.91253896100007],
              [25.66621586100004, 68.89739776700007],
              [25.651643107000098, 68.883496806],
              [25.627768595000106, 68.87414337200003],
              [25.60244714400011, 68.87212799100008],
              [25.481059204000132, 68.88773427300005],
              [25.43393029800012, 68.883858542],
              [25.387214803000035, 68.87455678400006],
              [25.201283, 68.81264841800005],
              [25.16273238100004, 68.78458811500012],
              [25.14960656700009, 68.7646410120001],
              [25.1448523360001, 68.74262685200001],
              [25.1430953360001, 68.69596303400003],
              [25.138754517000024, 68.68831492100004],
              [25.132760051000105, 68.68268219000002],
              [25.132139933000133, 68.67658437100006],
              [25.144232218000127, 68.66800608400003],
              [25.13244999200012, 68.64764556900009],
              [25.117567179000076, 68.6376720170001],
              [25.097826782000112, 68.63374460900003],
              [25.070955038000108, 68.63141917000009],
              [25.006876261000087, 68.61457265300002],
              [24.981244751000133, 68.61508941700005],
              [24.951789185000024, 68.60506418900003],
              [24.938146606000117, 68.58826934800008],
              [24.927087850000106, 68.57038930300011],
              [24.905177042000076, 68.55695343000006],
              [24.879235474000012, 68.55483469700009],
              [24.860942016000138, 68.56341298400012],
              [24.829626098000034, 68.59410878600006],
              [24.754178508000052, 68.63787872400006],
              [24.663434693000085, 68.66609405600012],
              [24.48132694500009, 68.6891934210001],
              [24.33249882000007, 68.70862376000007],
              [24.186874633000087, 68.74453888000004],
              [24.16372359200011, 68.75482249000002],
              [24.13116744000007, 68.77616485600002],
              [23.92900923700003, 68.8162140910001],
              [23.852631469000073, 68.81667917900005],
              [23.78720910600009, 68.79978098600004],
              [23.767985474000085, 68.75595937100003],
              [23.734809204000072, 68.71544504800003],
              [23.641584920000128, 68.69498118100007],
              [23.48159468600008, 68.68562774700003],
              [23.197581014000093, 68.61803497300006],
              [23.175360148000067, 68.62165232400004],
              [23.097948852000115, 68.67012481700003],
              [23.071490519000037, 68.68087351500004],
              [23.019297322000057, 68.68671295200004],
              [22.851658976000095, 68.67570587200002],
              [22.596480753000066, 68.72464345300004],
              [22.570125773000115, 68.72681386400002],
              [22.542943970000124, 68.726038717],
              [22.42873905400009, 68.71007070000006],
              [22.409205363000098, 68.71291290300003],
              [22.396699666000103, 68.73182647800009],
              [22.371378215000107, 68.82262196900005],
              [22.35680546100005, 68.83275055000009],
              [22.277223755000136, 68.85745188400001],
              [22.2002258710001, 68.90845652300005],
              [22.188650350000074, 68.91863678000003],
              [22.1743876540001, 68.94369985000004],
              [22.160745076000097, 68.95610219400002],
              [22.02307906100009, 69.01201609300001],
              [21.946100152000042, 69.065702532],
              [21.662894328000107, 69.26321523100005],
              [21.638813110000086, 69.27138010700007],
              [21.313561646000096, 69.29143056300002],
              [21.098380981000048, 69.23949574900011],
              [21.079674113000067, 69.23014231400008],
              [21.06303430200012, 69.21494944300004],
              [21.03357873500002, 69.18120473300009],
              [21.15636193800009, 69.08761871400004],
              [21.099001099000105, 69.04379709900003],
              [21.071509237000043, 69.03666575200002],
              [21.032545207000055, 69.04100657100007],
              [20.744397421000144, 69.10436187800009],
              [20.716595499000107, 69.09878082300007],
              [20.62316451, 69.03635569300012],
            ],
          ],
          [
            [
              [14.87240644600007, 68.22272370000007],
              [14.843760613000086, 68.22662995000007],
              [14.81381269600007, 68.23183828300006],
              [14.795583530000044, 68.24616120000007],
              [14.81771894600007, 68.26829661700003],
              [14.886729363000086, 68.30084870000007],
              [14.940114780000044, 68.30215078300006],
              [14.953135613000086, 68.27741120000007],
              [14.897146030000044, 68.24355703300006],
              [14.87240644600007, 68.22272370000007],
            ],
          ],
          [
            [
              [14.199229363000086, 68.31517161700003],
              [14.240896030000044, 68.31386953300006],
              [14.268239780000044, 68.28261953300006],
              [14.242198113000086, 68.25657786700003],
              [14.20053144600007, 68.24876536700003],
              [14.162771030000044, 68.26308828300006],
              [14.143239780000044, 68.27350495000007],
              [14.13803144600007, 68.28522370000007],
              [14.14584394600007, 68.29564036700003],
              [14.10678144600007, 68.29564036700003],
              [14.058604363000086, 68.29694245000007],
              [14.04037519600007, 68.31256745000007],
              [14.07943769600007, 68.31517161700003],
              [14.066416863000086, 68.33209870000007],
              [14.117198113000086, 68.33730703300006],
              [14.147146030000044, 68.33470286700003],
              [14.16928144600007, 68.32168203300006],
              [14.199229363000086, 68.31517161700003],
            ],
          ],
          [
            [
              [14.027842644000089, 68.26264069200005],
              [14.08725019600007, 68.28261953300006],
              [14.125010613000086, 68.27480703300006],
              [14.158864780000044, 68.25527578300006],
              [14.11068769600007, 68.20709870000007],
              [14.062022332000083, 68.20115794500003],
              [14.051117384000065, 68.18984609600005],
              [14.043467644000089, 68.18349844000005],
              [14.034027540000068, 68.18073151200008],
              [13.947764519000089, 68.17767975500004],
              [13.936778191000087, 68.17487213700008],
              [13.924815300000091, 68.17015208500004],
              [13.910411004000082, 68.16766998900005],
              [13.899912957000083, 68.17243073100008],
              [13.889659050000091, 68.17865631700005],
              [13.87631269600007, 68.18073151200008],
              [13.869639519000089, 68.17682526200008],
              [13.863942905000044, 68.16962311400005],
              [13.855804884000065, 68.16274648600006],
              [13.841970248000052, 68.15961334800005],
              [13.774099155000044, 68.15961334800005],
              [13.784678582000083, 68.14691803600005],
              [13.824717644000089, 68.14313385600008],
              [13.842295769000089, 68.13226959800005],
              [13.845957879000082, 68.12055084800005],
              [13.839366082000083, 68.11200592700004],
              [13.825694207000083, 68.10675690300008],
              [13.774099155000044, 68.10195547100005],
              [13.760264519000089, 68.10496653900003],
              [13.754730665000068, 68.10980866100005],
              [13.749522332000083, 68.12327708500004],
              [13.742686394000089, 68.12604401200008],
              [13.722666863000086, 68.12303294500003],
              [13.713715040000068, 68.11566803600005],
              [13.708262566000087, 68.10651276200008],
              [13.698252800000091, 68.09813060100004],
              [13.706065300000091, 68.08592357000003],
              [13.710785352000073, 68.08144765800006],
              [13.718760613000086, 68.07762278900003],
              [13.69898522200009, 68.07025788000004],
              [13.682139519000089, 68.06972890800006],
              [13.664805535000085, 68.07135651200008],
              [13.643728061000047, 68.07086823100008],
              [13.651133660000085, 68.07762278900003],
              [13.643809441000087, 68.07908763200004],
              [13.63054446700005, 68.08368561400005],
              [13.623220248000052, 68.08510976800005],
              [13.62468509200005, 68.10785553600005],
              [13.594899936000047, 68.12055084800005],
              [13.558848504000082, 68.11961497600004],
              [13.541270379000082, 68.10154857000003],
              [13.542979363000086, 68.09613678600005],
              [13.547373894000089, 68.09080638200004],
              [13.552744988000086, 68.08673737200007],
              [13.55836022200009, 68.08510976800005],
              [13.564789259000065, 68.08177317900004],
              [13.559092644000089, 68.07501862200007],
              [13.550303582000083, 68.06972890800006],
              [13.547373894000089, 68.07086823100008],
              [13.538259311000047, 68.05487702000005],
              [13.527191602000073, 68.04340241100005],
              [13.512868686000047, 68.04051341400003],
              [13.45671634200005, 68.07099030200004],
              [13.48568769600007, 68.10683828300006],
              [13.589121941000087, 68.15961334800005],
              [13.562998894000089, 68.16421133000006],
              [13.509938998000052, 68.13670482000003],
              [13.479258660000085, 68.13226959800005],
              [13.479258660000085, 68.13971588700008],
              [13.490733269000089, 68.14061107000003],
              [13.500743035000085, 68.14398834800005],
              [13.508555535000085, 68.15009186400005],
              [13.51335696700005, 68.15961334800005],
              [13.50326582100007, 68.15932851800005],
              [13.494883660000085, 68.16071198100008],
              [13.479258660000085, 68.16705963700008],
              [13.527598504000082, 68.17328522300005],
              [13.516612175000091, 68.17910390800006],
              [13.479258660000085, 68.18691640800006],
              [13.515635613000086, 68.20970286700003],
              [13.57162519600007, 68.21751536700003],
              [13.615896030000044, 68.22662995000007],
              [13.596853061000047, 68.23139069200005],
              [13.582286004000082, 68.23590729400007],
              [13.565440300000091, 68.23773834800005],
              [13.500010613000086, 68.24225495000007],
              [13.636729363000086, 68.29433828300006],
              [13.66570071700005, 68.29083893400008],
              [13.677907748000052, 68.29059479400007],
              [13.686371290000068, 68.28782786700003],
              [13.701345248000052, 68.27879466400003],
              [13.715017123000052, 68.27464427300004],
              [13.734385613000086, 68.27871328300006],
              [13.750010613000086, 68.28261953300006],
              [13.77084394600007, 68.28001536700003],
              [13.791188998000052, 68.26805247600004],
              [13.800791863000086, 68.26947663000004],
              [13.808116082000083, 68.27415599200003],
              [13.81967207100007, 68.28774648600006],
              [13.828379754000082, 68.29059479400007],
              [13.846364780000044, 68.30215078300006],
              [13.873708530000044, 68.32558828300006],
              [13.91928144600007, 68.34121328300006],
              [13.983083530000044, 68.33730703300006],
              [14.007823113000086, 68.29433828300006],
              [13.967458530000044, 68.26959870000007],
              [13.99350019600007, 68.25787995000007],
              [14.027842644000089, 68.26264069200005],
            ],
          ],
          [
            [
              [14.76303144600007, 68.49485911700003],
              [14.717458530000044, 68.49095286700003],
              [14.70443769600007, 68.51308828300006],
              [14.658864780000044, 68.53001536700003],
              [14.62631269600007, 68.54303620000007],
              [14.604177280000044, 68.55866120000007],
              [14.619802280000044, 68.57037995000007],
              [14.66928144600007, 68.58730703300006],
              [14.713552280000044, 68.57689036700003],
              [14.787771030000044, 68.57428620000007],
              [14.867198113000086, 68.56907786700003],
              [14.932302280000044, 68.56126536700003],
              [15.000010613000086, 68.55475495000007],
              [14.99865353000007, 68.53518720000005],
              [14.998586186000068, 68.53514270000005],
              [14.998493530000076, 68.53508170000003],
              [14.998376498000084, 68.53500495000003],
              [14.998236030000044, 68.53491320000006],
              [14.99807306100007, 68.53480720000005],
              [14.997888530000068, 68.53468770000006],
              [14.997683373000086, 68.53455545000008],
              [14.997458530000074, 68.53441120000008],
              [14.997214936000091, 68.53425570000007],
              [14.996953530000042, 68.53408970000004],
              [14.996675248000088, 68.53391395000006],
              [14.996381030000066, 68.53372920000004],
              [14.996071811000093, 68.53353620000007],
              [14.995748530000071, 68.53333570000007],
              [14.995412123000051, 68.53312845000005],
              [14.995063530000039, 68.53291520000005],
              [14.994703686000037, 68.53269670000003],
              [14.994333530000063, 68.53247370000008],
              [14.993953998000052, 68.53224695000006],
              [14.993566030000068, 68.53201720000004],
              [14.993170561000056, 68.53178520000006],
              [14.992768530000092, 68.53155170000008],
              [14.992360873000052, 68.53131745000007],
              [14.991948530000059, 68.53108320000007],
              [14.991532436000057, 68.53084970000003],
              [14.991113530000064, 68.53061770000005],
              [14.990692748000072, 68.53038795000003],
              [14.990271030000088, 68.53016120000007],
              [14.989849311000057, 68.52993820000006],
              [14.989428530000055, 68.52971970000004],
              [14.989009623000072, 68.52950645000004],
              [14.98859353000006, 68.52929920000008],
              [14.988181186000077, 68.52909870000008],
              [14.987773530000084, 68.52890570000005],
              [14.987371498000073, 68.52872095000004],
              [14.98697603000005, 68.52854520000005],
              [14.986588061000077, 68.52837920000007],
              [14.986208530000056, 68.52822370000007],
              [14.985838373000092, 68.52807945000006],
              [14.98547853000008, 68.52794720000009],
              [14.985129936000078, 68.52782770000005],
              [14.984793530000047, 68.52772170000009],
              [14.984470248000036, 68.52762995000006],
              [14.984161030000053, 68.52755320000006],
              [14.983866811000041, 68.52749220000004],
              [14.983588530000077, 68.52744770000004],
              [14.983327123000038, 68.52742045000008],
              [14.983083530000044, 68.52741120000007],
              [14.982408196000051, 68.52731386700003],
              [14.981922248000046, 68.52719520000005],
              [14.981343363000065, 68.52703253300007],
              [14.98067597700009, 68.52682786700007],
              [14.979924530000062, 68.52658320000006],
              [14.97909345700009, 68.52630053300004],
              [14.978187196000079, 68.52598186700004],
              [14.977210186000036, 68.52562920000008],
              [14.97616686300006, 68.52524453300003],
              [14.975061665000055, 68.52482986700005],
              [14.973899030000041, 68.52438720000004],
              [14.972683394000057, 68.52391853300009],
              [14.971419196000056, 68.52342586700007],
              [14.970110873000067, 68.52291120000007],
              [14.968762863000052, 68.52237653300006],
              [14.967379602000051, 68.52182386700008],
              [14.965965530000062, 68.52125520000004],
              [14.96452508200008, 68.52067253300004],
              [14.963062696000065, 68.52007786700005],
              [14.961582811000085, 68.51947320000005],
              [14.960089863000064, 68.51886053300007],
              [14.95858829000008, 68.51824186700009],
              [14.957082530000037, 68.51761920000007],
              [14.955577019000089, 68.51699453300006],
              [14.954076196000074, 68.51636986700004],
              [14.952584498000078, 68.51574720000008],
              [14.951106363000065, 68.51512853300005],
              [14.949646227000073, 68.51451586700006],
              [14.948208530000045, 68.51391120000005],
              [14.946797707000087, 68.51331653300008],
              [14.945418196000048, 68.51273386700007],
              [14.94407443600005, 68.51216520000008],
              [14.942770863000078, 68.51161253300006],
              [14.941511915000092, 68.51107786700004],
              [14.940302030000055, 68.51056320000004],
              [14.939145644000064, 68.51007053300003],
              [14.93804719600007, 68.50960186700007],
              [14.937011123000048, 68.50915920000006],
              [14.93604186300007, 68.50874453300008],
              [14.935143852000067, 68.50835986700008],
              [14.93432153000009, 68.50800720000007],
              [14.933579332000079, 68.50768853300008],
              [14.93292169600005, 68.50740586700005],
              [14.932353061000072, 68.50716120000004],
              [14.931877863000068, 68.50695653300005],
              [14.931500540000059, 68.50679386700006],
              [14.931225530000063, 68.50667520000007],
              [14.93100019600007, 68.50657786700003],
              [14.89193769600007, 68.49485911700003],
              [14.76303144600007, 68.49485911700003],
            ],
          ],
          [
            [
              [5.276866082000083, 59.299261786000045],
              [5.27898196700005, 59.29254791900007],
              [5.295099389000086, 59.28285371900006],
              [5.314098375000071, 59.27359874600006],
              [5.317929266000078, 59.256539763000035],
              [5.317382707000093, 59.22885302800006],
              [5.302363396000089, 59.20549853600005],
              [5.297090544000071, 59.168884398000046],
              [5.263194207000083, 59.15184153900003],
              [5.235929479000049, 59.14105820900005],
              [5.208550995000053, 59.14288559800008],
              [5.188430242000038, 59.15724584600008],
              [5.178666760000056, 59.17049469400007],
              [5.166168649000042, 59.19568241400003],
              [5.164431019000062, 59.21805485500005],
              [5.172691646000089, 59.241024726000035],
              [5.172129468000094, 59.25827843800005],
              [5.173124861000076, 59.268710430000056],
              [5.165278478000062, 59.27342763000007],
              [5.178721550000091, 59.292222398000035],
              [5.22828209700009, 59.285589911000045],
              [5.182790561000047, 59.320013739000046],
              [5.173838738000086, 59.334051825000074],
              [5.174489780000044, 59.349269924000055],
              [5.18523196700005, 59.35586172100005],
              [5.198741082000083, 59.36188385600008],
              [5.208506707000083, 59.37494538000004],
              [5.188487175000091, 59.383978583000044],
              [5.180023634000065, 59.40058014500005],
              [5.185883009000065, 59.41474030200004],
              [5.208506707000083, 59.41596100500004],
              [5.244883660000085, 59.369208075000074],
              [5.253916863000086, 59.34796784100007],
              [5.262543165000068, 59.341050523000035],
              [5.272634311000047, 59.335638739000046],
              [5.280284050000091, 59.33026764500005],
              [5.28646894600007, 59.320379950000074],
              [5.284027540000068, 59.31537506700005],
              [5.278819207000083, 59.31012604400007],
              [5.276866082000083, 59.299261786000045],
            ],
          ],
          [
            [
              [5.307139519000089, 59.75861237200007],
              [5.317637566000087, 59.75226471600007],
              [5.334239129000082, 59.72142161700003],
              [5.344981316000087, 59.710150458000044],
              [5.309743686000047, 59.69013092700004],
              [5.29078209700009, 59.68353913000004],
              [5.270030144000089, 59.682847398000035],
              [5.270030144000089, 59.68968333500004],
              [5.28101647200009, 59.69135163000004],
              [5.31031334700009, 59.70331452000005],
              [5.30241946700005, 59.718451239000046],
              [5.297862175000091, 59.73627350500004],
              [5.289317254000082, 59.74982330900008],
              [5.270030144000089, 59.75177643400008],
              [5.273448113000086, 59.73501211100006],
              [5.260590040000068, 59.73387278900003],
              [5.241221550000091, 59.74249909100007],
              [5.225596550000091, 59.755194403000075],
              [5.22046959700009, 59.75543854400007],
              [5.210785352000073, 59.753241278000075],
              [5.200694207000083, 59.74945709800005],
              [5.194183790000068, 59.74494049700007],
              [5.189952019000089, 59.736395575000074],
              [5.190440300000091, 59.72992584800005],
              [5.192881707000083, 59.72321198100008],
              [5.194183790000068, 59.71385325700004],
              [5.187998894000089, 59.70262278900003],
              [5.160166863000086, 59.68244049700007],
              [5.15398196700005, 59.66982656500005],
              [5.160166863000086, 59.65521881700005],
              [5.174815300000091, 59.66193268400008],
              [5.192881707000083, 59.675848700000074],
              [5.208506707000083, 59.682847398000035],
              [5.191661004000082, 59.66347890800006],
              [5.187998894000089, 59.655503648000035],
              [5.190440300000091, 59.64728424700007],
              [5.197520379000082, 59.64081452000005],
              [5.201508009000065, 59.63312409100007],
              [5.194183790000068, 59.62140534100007],
              [5.201670769000089, 59.614569403000075],
              [5.193858269000089, 59.60724518400008],
              [5.185801629000082, 59.601629950000074],
              [5.17709394600007, 59.59747955900008],
              [5.155121290000068, 59.59170156500005],
              [5.152842644000089, 59.59162018400008],
              [5.152598504000082, 59.594631252000056],
              [5.146494988000086, 59.600897528000075],
              [5.135590040000068, 59.609442450000074],
              [5.124278191000087, 59.62140534100007],
              [5.115407748000052, 59.636053778000075],
              [5.111664259000065, 59.652411200000074],
              [5.116709832000083, 59.68569570500006],
              [5.131358269000089, 59.71198151200008],
              [5.155446811000047, 59.73509349200003],
              [5.187998894000089, 59.75861237200007],
              [5.144867384000065, 59.75755442900004],
              [5.124847852000073, 59.76186758000006],
              [5.118418816000087, 59.77903880400004],
              [5.10523522200009, 59.767564195000034],
              [5.08952884200005, 59.76227448100008],
              [5.076182488000086, 59.76630280200004],
              [5.070648634000065, 59.78278229400007],
              [5.076182488000086, 59.794623114000046],
              [5.087412957000083, 59.80093008000006],
              [5.09742272200009, 59.80931224200003],
              [5.098643425000091, 59.827460028000075],
              [5.103037957000083, 59.82534414300005],
              [5.114105665000068, 59.82200755400004],
              [5.118418816000087, 59.820013739000046],
              [5.122243686000047, 59.828192450000074],
              [5.128428582000083, 59.83161041900007],
              [5.136566602000073, 59.83100006700005],
              [5.146494988000086, 59.827460028000075],
              [5.138926629000082, 59.84080638200004],
              [5.10482832100007, 59.868475653000075],
              [5.116221550000091, 59.87323639500005],
              [5.128184441000087, 59.874986070000034],
              [5.15398196700005, 59.874660549000055],
              [5.159678582000083, 59.85993073100008],
              [5.168304884000065, 59.85000234600005],
              [5.194183790000068, 59.833685614000046],
              [5.204112175000091, 59.83047109600005],
              [5.213389519000089, 59.82965729400007],
              [5.220225457000083, 59.826605536000045],
              [5.222829623000052, 59.81659577000005],
              [5.227224155000044, 59.80731842700004],
              [5.23764082100007, 59.80548737200007],
              [5.249847852000073, 59.80573151200008],
              [5.259776238000086, 59.80267975500004],
              [5.279551629000082, 59.77798086100006],
              [5.293223504000082, 59.76447174700007],
              [5.307139519000089, 59.75861237200007],
            ],
          ],
          [
            [
              [5.489105665000068, 59.861029364000046],
              [5.490896030000044, 59.85195547100005],
              [5.492523634000065, 59.82371653900003],
              [5.49781334700009, 59.80341217700004],
              [5.481700066000087, 59.78790924700007],
              [5.421885613000086, 59.758978583000044],
              [5.389659050000091, 59.75861237200007],
              [5.363291863000086, 59.76406484600005],
              [5.358164910000085, 59.77220286700003],
              [5.370371941000087, 59.774644273000035],
              [5.385915561000047, 59.77204010600008],
              [5.399587436000047, 59.77122630400004],
              [5.406504754000082, 59.77903880400004],
              [5.401866082000083, 59.78729889500005],
              [5.390147332000083, 59.79205963700008],
              [5.377940300000091, 59.79291413000004],
              [5.37240644600007, 59.78961823100008],
              [5.366384311000047, 59.780462958000044],
              [5.352305535000085, 59.77765534100007],
              [5.336273634000065, 59.77903880400004],
              [5.324554884000065, 59.78278229400007],
              [5.314300977000073, 59.78945547100005],
              [5.310394727000073, 59.794989325000074],
              [5.30404707100007, 59.81317780200004],
              [5.28484134200005, 59.84821198100008],
              [5.27312259200005, 59.86163971600007],
              [5.256358269000089, 59.874660549000055],
              [5.261566602000073, 59.88515859600005],
              [5.261973504000082, 59.89508698100008],
              [5.257985873000052, 59.90338776200008],
              [5.250173373000052, 59.909409898000035],
              [5.287608269000089, 59.93781159100007],
              [5.297536655000044, 59.95099518400008],
              [5.280284050000091, 59.95661041900007],
              [5.275401238000086, 59.95966217700004],
              [5.28288821700005, 59.96662018400008],
              [5.294932488000086, 59.973822333000044],
              [5.30404707100007, 59.97768789300005],
              [5.313975457000083, 59.978216864000046],
              [5.326182488000086, 59.97650788000004],
              [5.33765709700009, 59.971991278000075],
              [5.344981316000087, 59.964056708000044],
              [5.388194207000083, 59.95774974200003],
              [5.420664910000085, 59.938381252000056],
              [5.446055535000085, 59.911322333000044],
              [5.468028191000087, 59.882066148000035],
              [5.489105665000068, 59.861029364000046],
            ],
          ],
          [
            [
              [5.619151238000086, 60.073919989000046],
              [5.646983269000089, 60.080145575000074],
              [5.656748894000089, 60.07884349200003],
              [5.660411004000082, 60.066473700000074],
              [5.660411004000082, 60.016913153000075],
              [5.652842644000089, 60.00092194200005],
              [5.60523522200009, 59.962225653000075],
              [5.606130405000044, 59.950506903000075],
              [5.622080925000091, 59.93854401200008],
              [5.639903191000087, 59.91559479400007],
              [5.62240644600007, 59.91120026200008],
              [5.59156334700009, 59.92279694200005],
              [5.571543816000087, 59.923041083000044],
              [5.528086785000085, 59.90176015800006],
              [5.508067254000082, 59.89911530200004],
              [5.489105665000068, 59.91559479400007],
              [5.481700066000087, 59.95380280200004],
              [5.476817254000082, 59.962958075000074],
              [5.46648196700005, 59.96084219000005],
              [5.456879102000073, 59.95453522300005],
              [5.454274936000047, 59.95099518400008],
              [5.432790561000047, 59.952337958000044],
              [5.410166863000086, 59.95766836100006],
              [5.388926629000082, 59.96629466400003],
              [5.37240644600007, 59.97768789300005],
              [5.361827019000089, 59.995347398000035],
              [5.375254754000082, 60.00250885600008],
              [5.449392123000052, 60.00503164300005],
              [5.453623894000089, 60.00958893400008],
              [5.444346550000091, 60.02240631700005],
              [5.439707879000082, 60.032416083000044],
              [5.444102410000085, 60.041001695000034],
              [5.45289147200009, 60.04800039300005],
              [5.461680535000085, 60.052801825000074],
              [5.468272332000083, 60.052435614000046],
              [5.475840691000087, 60.048814195000034],
              [5.48414147200009, 60.04637278900003],
              [5.492523634000065, 60.049709377000056],
              [5.496592644000089, 60.05247630400004],
              [5.508799675000091, 60.05898672100005],
              [5.512950066000087, 60.060248114000046],
              [5.57789147200009, 60.066473700000074],
              [5.58334394600007, 60.06500885600008],
              [5.588715040000068, 60.061712958000044],
              [5.594574415000068, 60.05996328300006],
              [5.602061394000089, 60.06329987200007],
              [5.606455925000091, 60.06854889500005],
              [5.607920769000089, 60.07172272300005],
              [5.610606316000087, 60.073431708000044],
              [5.619151238000086, 60.073919989000046],
            ],
          ],
          [
            [
              [5.111664259000065, 60.200506903000075],
              [5.10320071700005, 60.190741278000075],
              [5.084320509000065, 60.18895091400003],
              [5.065603061000047, 60.19122955900008],
              [5.057139519000089, 60.19367096600007],
              [5.05437259200005, 60.20848216400003],
              [5.04664147200009, 60.22451406500005],
              [5.035817905000044, 60.237941799000055],
              [5.022959832000083, 60.24518463700008],
              [5.017425977000073, 60.220770575000074],
              [4.993011915000068, 60.22528717700004],
              [4.96461022200009, 60.24323151200008],
              [4.947927280000044, 60.25885651200008],
              [4.938487175000091, 60.275051174000055],
              [4.935801629000082, 60.28554922100005],
              [4.941416863000086, 60.29124583500004],
              [4.992442254000082, 60.29702383000006],
              [5.00757897200009, 60.29559967700004],
              [5.022959832000083, 60.28620026200008],
              [5.036631707000083, 60.31346263200004],
              [5.020192905000044, 60.30768463700008],
              [5.006683790000068, 60.31321849200003],
              [4.993662957000083, 60.322333075000074],
              [4.97828209700009, 60.32709381700005],
              [4.970957879000082, 60.33283112200007],
              [4.965098504000082, 60.359442450000074],
              [4.960785352000073, 60.36810944200005],
              [4.971934441000087, 60.383978583000044],
              [4.96851647200009, 60.39215729400007],
              [4.959646030000044, 60.397772528000075],
              [4.954600457000083, 60.405951239000046],
              [4.944590691000087, 60.43024323100008],
              [4.94890384200005, 60.439154364000046],
              [4.968272332000083, 60.443793036000045],
              [4.976817254000082, 60.44122955900008],
              [4.981944207000083, 60.43659088700008],
              [5.002207879000082, 60.39996979400007],
              [5.070648634000065, 60.34760163000004],
              [5.093760613000086, 60.32021719000005],
              [5.097666863000086, 60.298163153000075],
              [5.082855665000068, 60.28554922100005],
              [5.050303582000083, 60.28620026200008],
              [5.058441602000073, 60.27521393400008],
              [5.086192254000082, 60.26154205900008],
              [5.098643425000091, 60.25141022300005],
              [5.104258660000085, 60.24168528900003],
              [5.108246290000068, 60.229396877000056],
              [5.11068769600007, 60.21531810100004],
              [5.111664259000065, 60.200506903000075],
            ],
          ],
          [
            [
              [4.977793816000087, 60.524318752000056],
              [4.960785352000073, 60.559881903000075],
              [4.970876498000052, 60.55410390800006],
              [4.975759311000047, 60.553941148000035],
              [4.981944207000083, 60.55304596600007],
              [5.026377800000091, 60.52289459800005],
              [5.15015709700009, 60.50136953300006],
              [5.194183790000068, 60.471136786000045],
              [5.20476321700005, 60.44916413000004],
              [5.204356316000087, 60.43183014500005],
              [5.192393425000091, 60.41876862200007],
              [5.139903191000087, 60.40184153900003],
              [5.125010613000086, 60.402411200000074],
              [5.118418816000087, 60.41307200700004],
              [5.115733269000089, 60.42804596600007],
              [5.119313998000052, 60.43537018400008],
              [5.132823113000086, 60.443793036000045],
              [5.078949415000068, 60.45555247600004],
              [5.064463738000086, 60.464911200000074],
              [5.070648634000065, 60.469183661000045],
              [5.073496941000087, 60.470404364000046],
              [5.078135613000086, 60.471136786000045],
              [5.078135613000086, 60.47797272300005],
              [5.063324415000068, 60.47679271000004],
              [5.059092644000089, 60.482489325000074],
              [5.058116082000083, 60.49201080900008],
              [5.053721550000091, 60.50214264500005],
              [5.043955925000091, 60.50641510600008],
              [5.031586134000065, 60.50458405200004],
              [5.018402540000068, 60.50063711100006],
              [5.005869988000086, 60.49843984600005],
              [4.990570509000065, 60.50617096600007],
              [4.977793816000087, 60.524318752000056],
            ],
          ],
          [
            [
              [5.687673373000052, 60.67658112200007],
              [5.687673373000052, 60.61172109600005],
              [5.685801629000082, 60.59593333500004],
              [5.674001498000052, 60.54682038000004],
              [5.674164259000065, 60.52920156500005],
              [5.68140709700009, 60.481675523000035],
              [5.675954623000052, 60.47288646000004],
              [5.662933790000068, 60.470038153000075],
              [5.63648522200009, 60.471136786000045],
              [5.624522332000083, 60.466864325000074],
              [5.616709832000083, 60.457464911000045],
              [5.611827019000089, 60.44806549700007],
              [5.608897332000083, 60.443793036000045],
              [5.52906334700009, 60.43504466400003],
              [5.502126498000052, 60.43695709800005],
              [5.48601321700005, 60.44428131700005],
              [5.459157748000052, 60.466457424000055],
              [5.444346550000091, 60.471136786000045],
              [5.435557488000086, 60.47650788000004],
              [5.392832879000082, 60.51211172100005],
              [5.32398522200009, 60.54682038000004],
              [5.338715040000068, 60.552069403000075],
              [5.385996941000087, 60.55304596600007],
              [5.409027540000068, 60.55801015800006],
              [5.414805535000085, 60.56199778900003],
              [5.42359459700009, 60.570746161000045],
              [5.434336785000085, 60.577826239000046],
              [5.475433790000068, 60.59406159100007],
              [5.521983269000089, 60.60614655200004],
              [5.543223504000082, 60.61741771000004],
              [5.56967207100007, 60.625067450000074],
              [5.581553582000083, 60.63222890800006],
              [5.587738477000073, 60.64252350500004],
              [5.588715040000068, 60.66547272300005],
              [5.59156334700009, 60.67658112200007],
              [5.608409050000091, 60.68842194200005],
              [5.63607832100007, 60.692613023000035],
              [5.66570071700005, 60.688788153000075],
              [5.687673373000052, 60.67658112200007],
            ],
          ],
          [
            [
              [4.960785352000073, 61.177435614000046],
              [4.987315300000091, 61.11969635600008],
              [4.985362175000091, 61.10488515800006],
              [4.967946811000047, 61.09227122600004],
              [4.926524285000085, 61.075873114000046],
              [4.909678582000083, 61.06386953300006],
              [4.893809441000087, 61.05609772300005],
              [4.884776238000086, 61.06976959800005],
              [4.875498894000089, 61.08978913000004],
              [4.858409050000091, 61.10114166900007],
              [4.855642123000052, 61.09650299700007],
              [4.82593834700009, 61.079413153000075],
              [4.820567254000082, 61.07754140800006],
              [4.815196160000085, 61.06899648600006],
              [4.81413821700005, 61.06146881700005],
              [4.81185957100007, 61.05414459800005],
              [4.803233269000089, 61.046535549000055],
              [4.797048373000052, 61.06281159100007],
              [4.795258009000065, 61.082912502000056],
              [4.796397332000083, 61.118475653000075],
              [4.795583530000044, 61.12604401200008],
              [4.791188998000052, 61.13690827000005],
              [4.790212436000047, 61.146144924000055],
              [4.79460696700005, 61.15375397300005],
              [4.818369988000086, 61.15542226800005],
              [4.830577019000089, 61.16323476800005],
              [4.85132897200009, 61.12929922100005],
              [4.863291863000086, 61.12173086100006],
              [4.872080925000091, 61.13646067900004],
              [4.869965040000068, 61.15013255400004],
              [4.844737175000091, 61.197333075000074],
              [4.862478061000047, 61.20343659100007],
              [4.87281334700009, 61.194647528000075],
              [4.885752800000091, 61.16323476800005],
              [4.89039147200009, 61.14520905200004],
              [4.895274285000085, 61.13735586100006],
              [4.903168165000068, 61.13959381700005],
              [4.906097852000073, 61.14642975500004],
              [4.905772332000083, 61.15501536700003],
              [4.903330925000091, 61.16351959800005],
              [4.90007571700005, 61.169989325000074],
              [4.910329623000052, 61.16937897300005],
              [4.918630405000044, 61.17059967700004],
              [4.926036004000082, 61.17328522300005],
              [4.934255405000044, 61.177435614000046],
              [4.929698113000086, 61.18048737200007],
              [4.924815300000091, 61.186428127000056],
              [4.919932488000086, 61.191107489000046],
              [4.932383660000085, 61.192287502000056],
              [4.943532748000052, 61.19017161700003],
              [4.95289147200009, 61.18512604400007],
              [4.960785352000073, 61.177435614000046],
            ],
          ],
          [
            [
              [4.865244988000086, 61.88939036700003],
              [4.90951582100007, 61.89817942900004],
              [4.952972852000073, 61.89695872600004],
              [5.222829623000052, 61.84845612200007],
              [5.205414259000065, 61.83392975500004],
              [5.176605665000068, 61.82566966400003],
              [5.118418816000087, 61.82111237200007],
              [5.131846550000091, 61.827826239000046],
              [5.138682488000086, 61.83734772300005],
              [5.137461785000085, 61.847357489000046],
              [5.125987175000091, 61.85586172100005],
              [5.090586785000085, 61.828111070000034],
              [5.053396030000044, 61.80878327000005],
              [5.012950066000087, 61.795803127000056],
              [4.916270379000082, 61.780951239000046],
              [4.889659050000091, 61.78510163000004],
              [4.872080925000091, 61.80060455900008],
              [4.87077884200005, 61.813381252000056],
              [4.880707227000073, 61.81435781500005],
              [4.90007571700005, 61.80744049700007],
              [4.907481316000087, 61.81122467700004],
              [4.914073113000086, 61.816107489000046],
              [4.926768425000091, 61.82794830900008],
              [4.89812259200005, 61.827053127000056],
              [4.82943769600007, 61.83421458500004],
              [4.803233269000089, 61.84162018400008],
              [4.82195071700005, 61.85342031500005],
              [4.846446160000085, 61.862494208000044],
              [4.86491946700005, 61.873032945000034],
              [4.865244988000086, 61.88939036700003],
            ],
          ],
          [
            [
              [5.73609459700009, 62.280462958000044],
              [5.781260613000086, 62.28119538000004],
              [5.801117384000065, 62.277411200000074],
              [5.80445397200009, 62.266791083000044],
              [5.795746290000068, 62.26398346600007],
              [5.789317254000082, 62.25885651200008],
              [5.785329623000052, 62.25169505400004],
              [5.783864780000044, 62.24258047100005],
              [5.785817905000044, 62.23847077000005],
              [5.790293816000087, 62.23387278900003],
              [5.794932488000086, 62.23094310100004],
              [5.797536655000044, 62.23200104400007],
              [5.791677280000044, 62.21906159100007],
              [5.79070071700005, 62.21499258000006],
              [5.778330925000091, 62.20742422100005],
              [5.701426629000082, 62.191066799000055],
              [5.546885613000086, 62.192694403000075],
              [5.537771030000044, 62.19489166900007],
              [5.530039910000085, 62.19782135600008],
              [5.522471550000091, 62.204779364000046],
              [5.518809441000087, 62.21271393400008],
              [5.513926629000082, 62.22020091400003],
              [5.502126498000052, 62.225816148000035],
              [5.583262566000087, 62.218410549000055],
              [5.605723504000082, 62.225816148000035],
              [5.588552280000044, 62.23200104400007],
              [5.568369988000086, 62.23627350500004],
              [5.530039910000085, 62.239447333000044],
              [5.518077019000089, 62.24315013200004],
              [5.523773634000065, 62.25104401200008],
              [5.539398634000065, 62.258246161000045],
              [5.557302280000044, 62.25995514500005],
              [5.554209832000083, 62.263373114000046],
              [5.552012566000087, 62.26666901200008],
              [5.549082879000082, 62.26984284100007],
              [5.543711785000085, 62.27301666900007],
              [5.563243035000085, 62.29140859600005],
              [5.598480665000068, 62.29702383000006],
              [5.670583530000044, 62.29409414300005],
              [5.679209832000083, 62.296210028000075],
              [5.687836134000065, 62.29995351800005],
              [5.696462436000047, 62.301662502000056],
              [5.70484459700009, 62.29751211100006],
              [5.711680535000085, 62.29096100500004],
              [5.718597852000073, 62.28546784100007],
              [5.726573113000086, 62.28180573100008],
              [5.73609459700009, 62.280462958000044],
            ],
          ],
          [
            [
              [5.988617384000065, 62.396470445000034],
              [5.992686394000089, 62.38629791900007],
              [5.994476759000065, 62.37518952000005],
              [5.999522332000083, 62.366115627000056],
              [6.012950066000087, 62.36237213700008],
              [6.02670332100007, 62.36017487200007],
              [6.066254102000073, 62.34821198100008],
              [6.078786655000044, 62.341864325000074],
              [6.06804446700005, 62.34210846600007],
              [6.057383660000085, 62.34088776200008],
              [6.037119988000086, 62.33502838700008],
              [5.874034050000091, 62.25543854400007],
              [5.811289910000085, 62.24567291900007],
              [5.81804446700005, 62.25665924700007],
              [5.840993686000047, 62.26976146000004],
              [5.851573113000086, 62.280462958000044],
              [5.846446160000085, 62.281683661000045],
              [5.837087436000047, 62.285589911000045],
              [5.83171634200005, 62.28660716400003],
              [5.841075066000087, 62.31305573100008],
              [5.828786655000044, 62.32949453300006],
              [5.811208530000044, 62.343451239000046],
              [5.80445397200009, 62.36237213700008],
              [5.815603061000047, 62.38572825700004],
              [5.836599155000044, 62.403225002000056],
              [5.861989780000044, 62.41559479400007],
              [5.886241082000083, 62.423814195000034],
              [5.917002800000091, 62.42987702000005],
              [5.943858269000089, 62.42804596600007],
              [5.967458530000044, 62.417303778000075],
              [5.988617384000065, 62.396470445000034],
            ],
          ],
          [
            [
              [6.26303144600007, 62.423814195000034],
              [6.303233269000089, 62.42519765800006],
              [6.321299675000091, 62.42283763200004],
              [6.332530144000089, 62.41079336100006],
              [6.327647332000083, 62.41071198100008],
              [6.324717644000089, 62.409084377000056],
              [6.32203209700009, 62.40656159100007],
              [6.318369988000086, 62.403957424000055],
              [6.165049675000091, 62.396551825000074],
              [6.090668165000068, 62.402411200000074],
              [6.023448113000086, 62.43744538000004],
              [6.201670769000089, 62.44489166900007],
              [6.21656334700009, 62.44135163000004],
              [6.26303144600007, 62.423814195000034],
            ],
          ],
          [
            [
              [6.852793816000087, 62.74591705900008],
              [6.878916863000086, 62.74274323100008],
              [6.904470248000052, 62.73261139500005],
              [6.919444207000083, 62.71718984600005],
              [6.914073113000086, 62.69818756700005],
              [6.749196811000047, 62.67645905200004],
              [6.68295332100007, 62.657538153000075],
              [6.672373894000089, 62.65599192900004],
              [6.66773522200009, 62.660589911000045],
              [6.666514519000089, 62.669907945000034],
              [6.662771030000044, 62.675116278000075],
              [6.656260613000086, 62.677435614000046],
              [6.646657748000052, 62.67829010600008],
              [6.646657748000052, 62.68451569200005],
              [6.656260613000086, 62.68569570500006],
              [6.665293816000087, 62.68829987200007],
              [6.67359459700009, 62.69253164300005],
              [6.68140709700009, 62.69818756700005],
              [6.674815300000091, 62.71718984600005],
              [6.684743686000047, 62.730169989000046],
              [6.703135613000086, 62.73578522300005],
              [6.72242272200009, 62.73289622600004],
              [6.715586785000085, 62.725490627000056],
              [6.743988477000073, 62.72288646000004],
              [6.852793816000087, 62.74591705900008],
            ],
          ],
          [
            [
              [6.832286004000082, 62.84153880400004],
              [6.859873894000089, 62.845038153000075],
              [6.893728061000047, 62.85390859600005],
              [6.924327019000089, 62.85659414300005],
              [6.942149285000085, 62.84153880400004],
              [6.942149285000085, 62.82591380400004],
              [6.896332227000073, 62.81981028900003],
              [6.880056186000047, 62.80801015800006],
              [6.889170769000089, 62.80540599200003],
              [6.898610873000052, 62.79913971600007],
              [6.903819207000083, 62.790350653000075],
              [6.900563998000052, 62.78009674700007],
              [6.886729363000086, 62.775091864000046],
              [6.86882571700005, 62.77977122600004],
              [6.839691602000073, 62.79437897300005],
              [6.784434441000087, 62.80801015800006],
              [6.770355665000068, 62.81696198100008],
              [6.772227410000085, 62.82217031500005],
              [6.785004102000073, 62.823879299000055],
              [6.804209832000083, 62.822251695000034],
              [6.785004102000073, 62.83222077000005],
              [6.777517123000052, 62.839829820000034],
              [6.777598504000082, 62.848944403000075],
              [6.790049675000091, 62.85765208500004],
              [6.805674675000091, 62.854396877000056],
              [6.832286004000082, 62.84153880400004],
            ],
          ],
          [
            [
              [7.778168165000068, 63.081732489000046],
              [7.848643425000091, 63.09804922100005],
              [7.886729363000086, 63.09975820500006],
              [7.914724155000044, 63.081732489000046],
              [7.899912957000083, 63.06268952000005],
              [7.873383009000065, 63.04511139500005],
              [7.843028191000087, 63.03217194200005],
              [7.805837436000047, 63.025824286000045],
              [7.787933790000068, 63.02065664300005],
              [7.778168165000068, 63.02024974200003],
              [7.770355665000068, 63.02289459800005],
              [7.75749759200005, 63.03143952000005],
              [7.75367272200009, 63.03335195500006],
              [7.735118035000085, 63.036037502000056],
              [7.68132571700005, 63.05508047100005],
              [7.68132571700005, 63.06126536700003],
              [7.699066602000073, 63.06195709800005],
              [7.70639082100007, 63.07172272300005],
              [7.708832227000073, 63.08315664300005],
              [7.712738477000073, 63.08856842700004],
              [7.72046959700009, 63.09039948100008],
              [7.726410352000073, 63.093817450000074],
              [7.733246290000068, 63.09552643400008],
              [7.778168165000068, 63.081732489000046],
            ],
          ],
          [
            [
              [7.64039147200009, 63.05508047100005],
              [7.65202884200005, 63.051988023000035],
              [7.662608269000089, 63.04254791900007],
              [7.68132571700005, 63.02024974200003],
              [7.697601759000065, 63.009466864000046],
              [7.706309441000087, 63.00665924700007],
              [7.681651238000086, 62.99673086100006],
              [7.664398634000065, 62.993068752000056],
              [7.624034050000091, 62.98965078300006],
              [7.609629754000082, 62.98273346600007],
              [7.598887566000087, 62.97508372600004],
              [7.526540561000047, 62.94603099200003],
              [7.508799675000091, 62.94285716400003],
              [7.490244988000086, 62.94521719000005],
              [7.489268425000091, 62.947251695000034],
              [7.472992384000065, 62.962225653000075],
              [7.465342644000089, 62.96548086100006],
              [7.392914259000065, 62.97964101800005],
              [7.374522332000083, 62.98704661700003],
              [7.36654707100007, 62.99673086100006],
              [7.375743035000085, 63.00604889500005],
              [7.396739129000082, 63.01264069200005],
              [7.435557488000086, 63.02024974200003],
              [7.423024936000047, 63.02765534100007],
              [7.41732832100007, 63.036037502000056],
              [7.420746290000068, 63.04319896000004],
              [7.435557488000086, 63.04755280200004],
              [7.418955925000091, 63.05345286700003],
              [7.410899285000085, 63.05491771000004],
              [7.401377800000091, 63.05508047100005],
              [7.401377800000091, 63.06126536700003],
              [7.42359459700009, 63.060980536000045],
              [7.490244988000086, 63.068060614000046],
              [7.476410352000073, 63.05508047100005],
              [7.504893425000091, 63.054388739000046],
              [7.52702884200005, 63.04661692900004],
              [7.565196160000085, 63.02024974200003],
              [7.571462436000047, 63.02728913000004],
              [7.575368686000047, 63.036322333000044],
              [7.575043165000068, 63.044256903000075],
              [7.563161655000044, 63.05060455900008],
              [7.574066602000073, 63.05695221600007],
              [7.589121941000087, 63.062933661000045],
              [7.595550977000073, 63.06464264500005],
              [7.606130405000044, 63.07843659100007],
              [7.605479363000086, 63.089911200000074],
              [7.585134311000047, 63.116522528000075],
              [7.620616082000083, 63.117621161000045],
              [7.637054884000065, 63.11579010600008],
              [7.64779707100007, 63.10968659100007],
              [7.64820397200009, 63.09247467700004],
              [7.650401238000086, 63.08047109600005],
              [7.649587436000047, 63.06940338700008],
              [7.64039147200009, 63.05508047100005],
            ],
          ],
          [
            [
              [8.113291863000086, 63.23940664300005],
              [8.132823113000086, 63.22919342700004],
              [8.15560957100007, 63.21088288000004],
              [8.170746290000068, 63.191392320000034],
              [8.167979363000086, 63.17792389500005],
              [8.182302280000044, 63.167181708000044],
              [8.188487175000091, 63.164943752000056],
              [8.188487175000091, 63.157456773000035],
              [8.020192905000044, 63.137925523000035],
              [7.976817254000082, 63.14321523600006],
              [7.928396030000044, 63.17792389500005],
              [7.937754754000082, 63.18610260600008],
              [7.990489129000082, 63.198431708000044],
              [8.047129754000082, 63.23061758000006],
              [8.07781009200005, 63.24115631700005],
              [8.113291863000086, 63.23940664300005],
            ],
          ],
          [
            [
              [8.483897332000083, 63.24681224200003],
              [8.548024936000047, 63.21889883000006],
              [8.574717644000089, 63.19961172100005],
              [8.56576582100007, 63.17792389500005],
              [8.42318769600007, 63.16107819200005],
              [8.374034050000091, 63.164943752000056],
              [8.344899936000047, 63.17645905200004],
              [8.292816602000073, 63.216131903000075],
              [8.264170769000089, 63.23261139500005],
              [8.270274285000085, 63.24323151200008],
              [8.272959832000083, 63.26752350500004],
              [8.277842644000089, 63.27480703300006],
              [8.28842207100007, 63.27716705900008],
              [8.29859459700009, 63.27513255400004],
              [8.307871941000087, 63.27020905200004],
              [8.315684441000087, 63.26390208500004],
              [8.32593834700009, 63.25958893400008],
              [8.33570397200009, 63.26227448100008],
              [8.344981316000087, 63.26658763200004],
              [8.353526238000086, 63.267279364000046],
              [8.367849155000044, 63.25486888200004],
              [8.382090691000087, 63.23672109600005],
              [8.396006707000083, 63.22687409100007],
              [8.408213738000086, 63.23940664300005],
              [8.400726759000065, 63.25641510600008],
              [8.401377800000091, 63.27204010600008],
              [8.410492384000065, 63.28339264500005],
              [8.428721550000091, 63.28778717700004],
              [8.445974155000044, 63.28367747600004],
              [8.459239129000082, 63.27338288000004],
              [8.483897332000083, 63.24681224200003],
            ],
          ],
          [
            [
              [7.914724155000044, 63.34247467700004],
              [7.93295332100007, 63.346136786000045],
              [7.997325066000087, 63.34247467700004],
              [7.963877800000091, 63.353176174000055],
              [7.80632571700005, 63.37128327000005],
              [7.78679446700005, 63.38275788000004],
              [7.791188998000052, 63.40387604400007],
              [7.787445509000065, 63.405585028000075],
              [7.778168165000068, 63.411322333000044],
              [7.809418165000068, 63.42291901200008],
              [7.837738477000073, 63.42877838700008],
              [7.897634311000047, 63.43121979400007],
              [7.923838738000086, 63.43732330900008],
              [7.975433790000068, 63.46515534100007],
              [8.004079623000052, 63.47280508000006],
              [8.070567254000082, 63.47329336100006],
              [8.100759311000047, 63.464056708000044],
              [8.12435957100007, 63.42597077000005],
              [8.172048373000052, 63.40607330900008],
              [8.181651238000086, 63.39020416900007],
              [8.150889519000089, 63.359808661000045],
              [8.13843834700009, 63.350897528000075],
              [8.127452019000089, 63.34756094000005],
              [8.099782748000052, 63.34247467700004],
              [8.094737175000091, 63.339178778000075],
              [8.09148196700005, 63.33120351800005],
              [8.086680535000085, 63.32880280200004],
              [8.038259311000047, 63.32880280200004],
              [8.022471550000091, 63.32611725500004],
              [7.993988477000073, 63.315619208000044],
              [7.976817254000082, 63.31513092700004],
              [7.973806186000047, 63.32591380400004],
              [7.933116082000083, 63.33478424700007],
              [7.914724155000044, 63.34247467700004],
            ],
          ],
          [
            [
              [9.138682488000086, 63.56777578300006],
              [9.176036004000082, 63.56777578300006],
              [9.176036004000082, 63.562201239000046],
              [9.141856316000087, 63.554754950000074],
              [9.10678144600007, 63.533270575000074],
              [8.858571811000047, 63.48700592700004],
              [8.718028191000087, 63.484035549000055],
              [8.662282748000052, 63.46832916900007],
              [8.573252800000091, 63.45913320500006],
              [8.50359134200005, 63.43423086100006],
              [8.477061394000089, 63.43121979400007],
              [8.408457879000082, 63.43121979400007],
              [8.39031009200005, 63.43382396000004],
              [8.346039259000065, 63.452337958000044],
              [8.344493035000085, 63.453558661000045],
              [8.342946811000047, 63.45587799700007],
              [8.33961022200009, 63.45815664300005],
              [8.333018425000091, 63.45913320500006],
              [8.324880405000044, 63.45685455900008],
              [8.321299675000091, 63.45197174700007],
              [8.318532748000052, 63.44708893400008],
              [8.312673373000052, 63.44489166900007],
              [8.299327019000089, 63.44550202000005],
              [8.288259311000047, 63.448553778000075],
              [8.282399936000047, 63.455064195000034],
              [8.284678582000083, 63.46653880400004],
              [8.277842644000089, 63.46653880400004],
              [8.28842207100007, 63.48672109600005],
              [8.300954623000052, 63.50141022300005],
              [8.317230665000068, 63.51316966400003],
              [8.413340691000087, 63.557806708000044],
              [8.435394727000073, 63.562201239000046],
              [8.618011915000068, 63.570746161000045],
              [8.69109134200005, 63.56342194200005],
              [8.709483269000089, 63.56362539300005],
              [8.723480665000068, 63.56777578300006],
              [8.681813998000052, 63.57880280200004],
              [8.584646030000044, 63.587103583000044],
              [8.545258009000065, 63.60248444200005],
              [8.564707879000082, 63.61188385600008],
              [8.582530144000089, 63.61359284100007],
              [8.621104363000086, 63.60993073100008],
              [8.788259311000047, 63.64004140800006],
              [8.827647332000083, 63.63959381700005],
              [8.83334394600007, 63.61676666900007],
              [8.846446160000085, 63.61591217700004],
              [8.854746941000087, 63.61981842700004],
              [8.859385613000086, 63.628159898000035],
              [8.86068769600007, 63.640326239000046],
              [8.868174675000091, 63.646185614000046],
              [8.885264519000089, 63.649318752000056],
              [8.918711785000085, 63.65086497600004],
              [8.951670769000089, 63.657416083000044],
              [8.965179884000065, 63.656236070000034],
              [8.977305535000085, 63.64411041900007],
              [8.972992384000065, 63.64435455900008],
              [8.965993686000047, 63.64004140800006],
              [8.959646030000044, 63.63434479400007],
              [8.956879102000073, 63.63043854400007],
              [8.96062259200005, 63.624660549000055],
              [8.97437584700009, 63.62026601800005],
              [8.988291863000086, 63.59275950700004],
              [9.015147332000083, 63.59723541900007],
              [9.048675977000073, 63.60797760600008],
              [9.080088738000086, 63.60618724200003],
              [9.121348504000082, 63.58197663000004],
              [9.12468509200005, 63.57713450700004],
              [9.124278191000087, 63.57257721600007],
              [9.12671959700009, 63.56907786700003],
              [9.138682488000086, 63.56777578300006],
            ],
          ],
          [
            [
              [8.360362175000091, 63.67137278900003],
              [8.335215691000087, 63.66815827000005],
              [8.313487175000091, 63.66815827000005],
              [8.293142123000052, 63.67328522300005],
              [8.271739129000082, 63.68504466400003],
              [8.331553582000083, 63.70180898600006],
              [8.518077019000089, 63.71979401200008],
              [8.743418816000087, 63.77440013200004],
              [8.727305535000085, 63.78001536700003],
              [8.708506707000083, 63.77924225500004],
              [8.690196160000085, 63.77423737200007],
              [8.675059441000087, 63.767564195000034],
              [8.682302280000044, 63.78009674700007],
              [8.737152540000068, 63.80914948100008],
              [8.752452019000089, 63.801947333000044],
              [8.76929772200009, 63.80548737200007],
              [8.787364129000082, 63.81244538000004],
              [8.805430535000085, 63.81537506700005],
              [8.80209394600007, 63.81159088700008],
              [8.799815300000091, 63.80817291900007],
              [8.796885613000086, 63.80499909100007],
              [8.791758660000085, 63.80170319200005],
              [8.791758660000085, 63.794907945000034],
              [8.805349155000044, 63.79096100500004],
              [8.810720248000052, 63.78164297100005],
              [8.812836134000065, 63.76072825700004],
              [8.817393425000091, 63.75018952000005],
              [8.822113477000073, 63.74274323100008],
              [8.82553144600007, 63.734076239000046],
              [8.82585696700005, 63.71979401200008],
              [8.792002800000091, 63.69806549700007],
              [8.743418816000087, 63.687933661000045],
              [8.545258009000065, 63.67763906500005],
              [8.475840691000087, 63.66429271000004],
              [8.455902540000068, 63.67137278900003],
              [8.525563998000052, 63.691839911000045],
              [8.47046959700009, 63.684475002000056],
              [8.455902540000068, 63.67763906500005],
              [8.441661004000082, 63.68504466400003],
              [8.414317254000082, 63.682847398000035],
              [8.360362175000091, 63.67137278900003],
            ],
          ],
          [
            [
              [11.286306186000047, 64.55898672100005],
              [11.31218509200005, 64.54010651200008],
              [11.425629102000073, 64.53974030200004],
              [11.451426629000082, 64.51496002800008],
              [11.438975457000083, 64.50690338700008],
              [11.430674675000091, 64.49677155200004],
              [11.416758660000085, 64.47272370000007],
              [11.391449415000068, 64.48273346600007],
              [11.31576582100007, 64.48798248900005],
              [11.299978061000047, 64.49689362200007],
              [11.283864780000044, 64.51325104400007],
              [11.246918165000068, 64.51528554900005],
              [11.180186394000089, 64.50747304900005],
              [11.12867272200009, 64.55585358300004],
              [11.141612175000091, 64.57127513200004],
              [11.169932488000086, 64.57404205900008],
              [11.224864129000082, 64.56952545800004],
              [11.191742384000065, 64.59560781500005],
              [11.083994988000086, 64.58828359600005],
              [11.042979363000086, 64.59992096600007],
              [11.037364129000082, 64.61444733300004],
              [11.04265384200005, 64.63035716400003],
              [11.053965691000087, 64.64394765800006],
              [11.066579623000052, 64.65143463700008],
              [11.085785352000073, 64.65204498900005],
              [11.105967644000089, 64.64630768400008],
              [11.14234459700009, 64.63100820500006],
              [11.229258660000085, 64.61127350500004],
              [11.269379102000073, 64.59223053600005],
              [11.286306186000047, 64.55898672100005],
            ],
          ],
          [
            [
              [11.091075066000087, 64.90159739800004],
              [11.081309441000087, 64.89834219000005],
              [11.005707227000073, 64.89850495000007],
              [10.940277540000068, 64.87482330900008],
              [10.906911655000044, 64.85740794500003],
              [10.879161004000082, 64.85162995000007],
              [10.850108269000089, 64.84931061400005],
              [10.826914910000085, 64.85008372600004],
              [10.826914910000085, 64.85757070500006],
              [11.089040561000047, 64.95042552300004],
              [11.10132897200009, 64.95311107000003],
              [11.116384311000047, 64.95107656500005],
              [11.140961134000065, 64.94159577000005],
              [11.167165561000047, 64.93732330900008],
              [11.180837436000047, 64.93178945500006],
              [11.192637566000087, 64.92397695500006],
              [11.197601759000065, 64.91522858300004],
              [11.206879102000073, 64.90912506700005],
              [11.265798373000052, 64.89850495000007],
              [11.266368035000085, 64.89370351800005],
              [11.265147332000083, 64.89215729400007],
              [11.262380405000044, 64.89199453300006],
              [11.259043816000087, 64.89105866100005],
              [11.217133009000065, 64.86579010600008],
              [11.176280144000089, 64.84861888200004],
              [11.13217207100007, 64.83885325700004],
              [11.080902540000068, 64.83584219000005],
              [11.084971550000091, 64.84609609600005],
              [11.087738477000073, 64.85008372600004],
              [11.07789147200009, 64.85394928600005],
              [11.067556186000047, 64.85472239800004],
              [11.056651238000086, 64.85321686400005],
              [11.046071811000047, 64.85008372600004],
              [11.046071811000047, 64.85757070500006],
              [11.062510613000086, 64.86269765800006],
              [11.080251498000052, 64.87506745000007],
              [11.092051629000082, 64.88963450700004],
              [11.091075066000087, 64.90159739800004],
            ],
          ],
          [
            [
              [10.84115644600007, 64.87738678600005],
              [10.816905144000089, 64.86855703300006],
              [10.738129102000073, 64.85008372600004],
              [10.742198113000086, 64.85984935100004],
              [10.745127800000091, 64.86371491100005],
              [10.710948113000086, 64.86371491100005],
              [10.730479363000086, 64.87221914300005],
              [10.741221550000091, 64.88711172100005],
              [10.750498894000089, 64.90395742400005],
              [10.765635613000086, 64.91836172100005],
              [10.783864780000044, 64.92401764500005],
              [10.851410352000073, 64.92519765800006],
              [10.871755405000044, 64.92767975500004],
              [10.924489780000044, 64.94179922100005],
              [10.963389519000089, 64.95746491100005],
              [11.032481316000087, 64.97296784100007],
              [11.033457879000082, 64.98822663000004],
              [11.059336785000085, 64.99042389500005],
              [11.092458530000044, 64.98387278900003],
              [11.11500084700009, 64.97296784100007],
              [11.111827019000089, 64.96954987200007],
              [11.108653191000087, 64.96820709800005],
              [11.10523522200009, 64.96767812700006],
              [10.965017123000052, 64.91868724200003],
              [10.898936394000089, 64.90827057500007],
              [10.84115644600007, 64.87738678600005],
            ],
          ],
          [
            [
              [12.224864129000082, 65.12376536700003],
              [12.249196811000047, 65.11920807500007],
              [12.28451582100007, 65.11652252800008],
              [12.309092644000089, 65.11058177300004],
              [12.30046634200005, 65.09650299700007],
              [12.270274285000085, 65.08071523600006],
              [12.231211785000085, 65.06850820500006],
              [12.156504754000082, 65.05548737200007],
              [12.132823113000086, 65.05646393400008],
              [12.09148196700005, 65.06659577000005],
              [12.070811394000089, 65.06915924700007],
              [12.047699415000068, 65.06948476800005],
              [11.999847852000073, 65.07510000200006],
              [11.979014519000089, 65.08283112200007],
              [11.993662957000083, 65.08673737200007],
              [12.033376498000052, 65.08283112200007],
              [12.048350457000083, 65.08539459800005],
              [12.048106316000087, 65.09174225500004],
              [12.043142123000052, 65.09967682500007],
              [12.043467644000089, 65.10700104400007],
              [12.060557488000086, 65.11762116100005],
              [12.099782748000052, 65.12343984600005],
              [12.122325066000087, 65.13129303600005],
              [12.107595248000052, 65.12897370000007],
              [12.098399285000085, 65.13031647300005],
              [12.092784050000091, 65.13556549700007],
              [12.088145379000082, 65.14492422100005],
              [12.091075066000087, 65.14850495000007],
              [12.094574415000068, 65.16168854400007],
              [12.096690300000091, 65.17495351800005],
              [12.09506269600007, 65.17841217700004],
              [12.113942905000044, 65.19257233300004],
              [12.139821811000047, 65.20380280200004],
              [12.167246941000087, 65.21112702000005],
              [12.190928582000083, 65.21381256700005],
              [12.208018425000091, 65.20726146000004],
              [12.240977410000085, 65.17869700700004],
              [12.271657748000052, 65.16461823100008],
              [12.258555535000085, 65.14789459800005],
              [12.224864129000082, 65.12376536700003],
            ],
          ],
          [
            [
              [12.451426629000082, 65.42609284100007],
              [12.461680535000085, 65.41282786700003],
              [12.474945509000065, 65.40289948100008],
              [12.490489129000082, 65.39760976800005],
              [12.506602410000085, 65.39813873900005],
              [12.49187259200005, 65.38751862200007],
              [12.45875084700009, 65.38226959800005],
              [12.444590691000087, 65.37083567900004],
              [12.392425977000073, 65.36017487200007],
              [12.379649285000085, 65.35407135600008],
              [12.366709832000083, 65.34393952000005],
              [12.352549675000091, 65.33633047100005],
              [12.336436394000089, 65.33152903900003],
              [12.239024285000085, 65.32245514500005],
              [12.211110873000052, 65.32465241100005],
              [12.204274936000047, 65.31932200700004],
              [12.211192254000082, 65.30255768400008],
              [12.218597852000073, 65.30101146000004],
              [12.236338738000086, 65.29132721600007],
              [12.24773196700005, 65.28046295800004],
              [12.235606316000087, 65.27521393400008],
              [12.221039259000065, 65.27090078300006],
              [12.193858269000089, 65.25165436400005],
              [12.183848504000082, 65.24730052300004],
              [12.080577019000089, 65.21503327000005],
              [12.053477410000085, 65.21995677300004],
              [12.077321811000047, 65.23362864800004],
              [12.094737175000091, 65.25580475500004],
              [12.122325066000087, 65.30255768400008],
              [12.111175977000073, 65.30170319200005],
              [12.100352410000085, 65.30215078300006],
              [12.090098504000082, 65.30434804900005],
              [12.080739780000044, 65.30878327000005],
              [12.09734134200005, 65.32534414300005],
              [12.10906009200005, 65.34296295800004],
              [12.122243686000047, 65.35732656500005],
              [12.142832879000082, 65.36399974200003],
              [12.155121290000068, 65.36245351800005],
              [12.17123457100007, 65.35317617400005],
              [12.180674675000091, 65.35101959800005],
              [12.187754754000082, 65.35455963700008],
              [12.20248457100007, 65.37177155200004],
              [12.211192254000082, 65.37763092700004],
              [12.211192254000082, 65.38507721600007],
              [12.183767123000052, 65.38349030200004],
              [12.177012566000087, 65.38507721600007],
              [12.174001498000052, 65.38629791900007],
              [12.165863477000073, 65.39081452000005],
              [12.160817905000044, 65.39581940300008],
              [12.174815300000091, 65.40200429900005],
              [12.211192254000082, 65.42609284100007],
              [12.267751498000052, 65.44940827000005],
              [12.328461134000065, 65.46702708500004],
              [12.321543816000087, 65.47431061400005],
              [12.317149285000085, 65.48078034100007],
              [12.314789259000065, 65.48737213700008],
              [12.31421959700009, 65.49494049700007],
              [12.258555535000085, 65.47296784100007],
              [12.229014519000089, 65.46849192900004],
              [12.197438998000052, 65.47386302300004],
              [12.23218834700009, 65.48749420800004],
              [12.204356316000087, 65.48749420800004],
              [12.23023522200009, 65.51227448100008],
              [12.240407748000052, 65.52606842700004],
              [12.245290561000047, 65.54148997600004],
              [12.238536004000082, 65.54262929900005],
              [12.22982832100007, 65.54710521000004],
              [12.224864129000082, 65.54897695500006],
              [12.244395379000082, 65.55882396000004],
              [12.258636915000068, 65.57461172100005],
              [12.274261915000068, 65.58173248900005],
              [12.297373894000089, 65.56606679900005],
              [12.315928582000083, 65.54108307500007],
              [12.324717644000089, 65.53192780200004],
              [12.33529707100007, 65.52728913000004],
              [12.38648522200009, 65.51422760600008],
              [12.397308790000068, 65.50755442900004],
              [12.444590691000087, 65.46702708500004],
              [12.446462436000047, 65.45848216400003],
              [12.446543816000087, 65.43842194200005],
              [12.451426629000082, 65.42609284100007],
            ],
          ],
          [
            [
              [12.005137566000087, 65.68960195500006],
              [11.99976647200009, 65.67804596600007],
              [11.986827019000089, 65.67194245000007],
              [11.957855665000068, 65.66502513200004],
              [11.972992384000065, 65.64956289300005],
              [11.976084832000083, 65.64158763200004],
              [11.971446160000085, 65.63153717700004],
              [11.958262566000087, 65.62270742400005],
              [11.926605665000068, 65.59634023600006],
              [11.916840040000068, 65.58999258000006],
              [11.907074415000068, 65.59031810100004],
              [11.902679884000065, 65.59540436400005],
              [11.898692254000082, 65.60130442900004],
              [11.889903191000087, 65.60419342700004],
              [11.877940300000091, 65.60224030200004],
              [11.86850019600007, 65.59906647300005],
              [11.859385613000086, 65.59837474200003],
              [11.848643425000091, 65.60419342700004],
              [11.869151238000086, 65.61041901200008],
              [11.84742272200009, 65.61416250200006],
              [11.779795769000089, 65.60700104400007],
              [11.759287957000083, 65.61790599200003],
              [11.765147332000083, 65.63499583500004],
              [11.785004102000073, 65.66030508000006],
              [11.80827884200005, 65.68305084800005],
              [11.824473504000082, 65.69301992400005],
              [11.890961134000065, 65.70620351800005],
              [11.926117384000065, 65.70872630400004],
              [11.95443769600007, 65.69643789300005],
              [11.965017123000052, 65.69623444200005],
              [11.98210696700005, 65.69993724200003],
              [11.997894727000073, 65.70014069200005],
              [12.005137566000087, 65.68960195500006],
            ],
          ],
          [
            [
              [12.698008660000085, 65.99774811400005],
              [12.740896030000044, 66.01357656500005],
              [12.800303582000083, 66.02480703300006],
              [12.860036655000044, 66.02680084800005],
              [12.903819207000083, 66.01508209800005],
              [12.890147332000083, 66.00145091400003],
              [12.857676629000082, 66.00047435100004],
              [12.73406009200005, 65.97557200700004],
              [12.674815300000091, 65.95221588700008],
              [12.623383009000065, 65.94212474200003],
              [12.492686394000089, 65.87978750200006],
              [12.465830925000091, 65.87327708500004],
              [12.430918816000087, 65.87107982000003],
              [12.444183790000068, 65.87872955900008],
              [12.458262566000087, 65.88251373900005],
              [12.470713738000086, 65.88751862200007],
              [12.478688998000052, 65.89838288000004],
              [12.36882571700005, 65.89158763200004],
              [12.383555535000085, 65.90648021000004],
              [12.430918816000087, 65.93256256700005],
              [12.443858269000089, 65.94403717700004],
              [12.461436394000089, 65.97003815300008],
              [12.47242272200009, 65.98094310100004],
              [12.491221550000091, 65.99062734600005],
              [12.60132897200009, 66.02167389500005],
              [12.627207879000082, 66.02301666900007],
              [12.65007571700005, 66.01508209800005],
              [12.620290561000047, 65.99306875200006],
              [12.608571811000047, 65.97992584800005],
              [12.615244988000086, 65.97418854400007],
              [12.635996941000087, 65.97606028900003],
              [12.658213738000086, 65.98126862200007],
              [12.679535352000073, 65.98875560100004],
              [12.698008660000085, 65.99774811400005],
            ],
          ],
          [
            [
              [12.574229363000086, 66.07591380400004],
              [12.533376498000052, 66.06069570500006],
              [12.294200066000087, 66.01508209800005],
              [12.334727410000085, 66.04242584800005],
              [12.350596550000091, 66.04804108300004],
              [12.365733269000089, 66.05158112200007],
              [12.380056186000047, 66.05658600500004],
              [12.393321160000085, 66.06663646000004],
              [12.420420769000089, 66.07990143400008],
              [12.429698113000086, 66.08710358300004],
              [12.417165561000047, 66.09023672100005],
              [12.397959832000083, 66.08763255400004],
              [12.361664259000065, 66.07709381700005],
              [12.342133009000065, 66.07591380400004],
              [12.342133009000065, 66.08344147300005],
              [12.357269727000073, 66.08734772300005],
              [12.385996941000087, 66.10089752800008],
              [12.40015709700009, 66.10390859600005],
              [12.45671634200005, 66.10724518400008],
              [12.47242272200009, 66.11131419500003],
              [12.477712436000047, 66.11774323100008],
              [12.48023522200009, 66.12689850500004],
              [12.487478061000047, 66.13507721600007],
              [12.522959832000083, 66.14069245000007],
              [12.574229363000086, 66.15851471600007],
              [12.542165561000047, 66.17059967700004],
              [12.504242384000065, 66.17584870000007],
              [12.465586785000085, 66.17430247600004],
              [12.430918816000087, 66.16596100500004],
              [12.430918816000087, 66.17275625200006],
              [12.522715691000087, 66.19814687700006],
              [12.533864780000044, 66.19891998900005],
              [12.542979363000086, 66.20197174700007],
              [12.551442905000044, 66.22036367400005],
              [12.561696811000047, 66.22113678600005],
              [12.58171634200005, 66.21377187700006],
              [12.595225457000083, 66.20502350500004],
              [12.600759311000047, 66.19367096600007],
              [12.604258660000085, 66.18113841400003],
              [12.612071160000085, 66.16937897300005],
              [12.611827019000089, 66.15680573100008],
              [12.590505405000044, 66.14760976800005],
              [12.547048373000052, 66.13861725500004],
              [12.547048373000052, 66.13117096600007],
              [12.621918165000068, 66.13117096600007],
              [12.605723504000082, 66.12274811400005],
              [12.587901238000086, 66.11749909100007],
              [12.587901238000086, 66.11131419500003],
              [12.628428582000083, 66.11489492400005],
              [12.646657748000052, 66.11318594000005],
              [12.656911655000044, 66.10390859600005],
              [12.649587436000047, 66.09418366100005],
              [12.64039147200009, 66.09027741100005],
              [12.600271030000044, 66.08869049700007],
              [12.590098504000082, 66.08494700700004],
              [12.574229363000086, 66.07591380400004],
            ],
          ],
          [
            [
              [14.273692254000082, 67.16583893400008],
              [14.258555535000085, 67.13764069200005],
              [14.23959394600007, 67.11546458500004],
              [14.217621290000068, 67.09808991100005],
              [14.192393425000091, 67.08392975500004],
              [14.212738477000073, 67.04922109600005],
              [14.215098504000082, 67.03241608300004],
              [14.198496941000087, 67.02252838700008],
              [14.201182488000086, 67.01886627800008],
              [14.204356316000087, 67.01178620000007],
              [14.205902540000068, 67.00885651200008],
              [14.192230665000068, 67.00356679900005],
              [14.174082879000082, 66.99990469000005],
              [14.158213738000086, 67.00141022300005],
              [14.151377800000091, 67.01190827000005],
              [14.150401238000086, 67.02692291900007],
              [14.146983269000089, 67.03270091400003],
              [14.140472852000073, 67.03595612200007],
              [14.100108269000089, 67.06167226800005],
              [14.067556186000047, 67.06956614800004],
              [13.993011915000068, 67.07770416900007],
              [13.993011915000068, 67.08392975500004],
              [14.01335696700005, 67.08991120000007],
              [14.030772332000083, 67.09804922100005],
              [14.062022332000083, 67.11871979400007],
              [14.057302280000044, 67.13304271000004],
              [14.066905144000089, 67.13495514500005],
              [14.133799675000091, 67.11009349200003],
              [14.152191602000073, 67.10712311400005],
              [14.171885613000086, 67.11127350500004],
              [14.194102410000085, 67.12946198100008],
              [14.219574415000068, 67.15595123900005],
              [14.246836785000085, 67.17373281500005],
              [14.273692254000082, 67.16583893400008],
            ],
          ],
          [
            [
              [13.054698113000086, 68.09813060100004],
              [13.054698113000086, 68.10496653900003],
              [13.079600457000083, 68.10419342700004],
              [13.156993035000085, 68.08510976800005],
              [13.156993035000085, 68.07762278900003],
              [13.143402540000068, 68.07762278900003],
              [13.133311394000089, 68.06818268400008],
              [13.121592644000089, 68.06232330900008],
              [13.10906009200005, 68.05898672100005],
              [13.095550977000073, 68.05719635600008],
              [13.095550977000073, 68.05036041900007],
              [13.136566602000073, 68.05036041900007],
              [13.120616082000083, 68.03823476800005],
              [13.101573113000086, 68.03652578300006],
              [13.081228061000047, 68.03742096600007],
              [13.061371290000068, 68.03327057500007],
              [13.050303582000083, 68.02456289300005],
              [13.050303582000083, 68.01654694200005],
              [13.059336785000085, 68.01113515800006],
              [13.075043165000068, 68.00942617400005],
              [13.086273634000065, 68.01544830900008],
              [13.099782748000052, 68.02537669500003],
              [13.110850457000083, 68.02826569200005],
              [13.117360873000052, 68.00405508000006],
              [13.125987175000091, 67.98696523600006],
              [13.130869988000086, 67.96385325700004],
              [13.130869988000086, 67.95258209800005],
              [13.123871290000068, 67.94399648600006],
              [13.105804884000065, 67.94049713700008],
              [13.05640709700009, 67.93878815300008],
              [13.04037519600007, 67.94049713700008],
              [12.995371941000087, 67.96478913000004],
              [12.976817254000082, 67.96946849200003],
              [12.98568769600007, 67.94794342700004],
              [12.970876498000052, 67.94953034100007],
              [12.961110873000052, 67.94668203300006],
              [12.960215691000087, 67.94098541900007],
              [12.97201582100007, 67.93427155200004],
              [12.989268425000091, 67.93097565300008],
              [13.024099155000044, 67.92865631700005],
              [13.041270379000082, 67.92340729400007],
              [13.04664147200009, 67.91547272300005],
              [13.04232832100007, 67.90525950700004],
              [13.033050977000073, 67.89647044500003],
              [13.017914259000065, 67.89085521000004],
              [13.015961134000065, 67.88666413000004],
              [13.01531009200005, 67.88202545800004],
              [13.013682488000086, 67.87909577000005],
              [12.992686394000089, 67.87221914300005],
              [12.897308790000068, 67.85590241100005],
              [12.883311394000089, 67.84149811400005],
              [12.87086022200009, 67.82514069200005],
              [12.841970248000052, 67.81561920800004],
              [12.787119988000086, 67.81012604400007],
              [12.794444207000083, 67.82062409100007],
              [12.831065300000091, 67.84552643400008],
              [12.845713738000086, 67.85276927300004],
              [12.848480665000068, 67.85480377800008],
              [12.84701582100007, 67.86098867400005],
              [12.84156334700009, 67.87433502800008],
              [12.841644727000073, 67.87909577000005],
              [12.849619988000086, 67.88983795800004],
              [12.858409050000091, 67.89907461100006],
              [12.879649285000085, 67.91689687700006],
              [12.889170769000089, 67.92865631700005],
              [12.893077019000089, 67.94839101800005],
              [12.90015709700009, 67.95783112200007],
              [12.906911655000044, 67.96076080900008],
              [12.92123457100007, 67.96116771000004],
              [12.927744988000086, 67.96466705900008],
              [12.930349155000044, 67.97064850500004],
              [12.92945397200009, 67.98358795800004],
              [12.931162957000083, 67.98895905200004],
              [12.979177280000044, 68.03652578300006],
              [12.990082227000073, 68.04474518400008],
              [13.013682488000086, 68.05719635600008],
              [13.047129754000082, 68.06468333500004],
              [13.06226647200009, 68.07086823100008],
              [13.075043165000068, 68.08510976800005],
              [13.068532748000052, 68.08844635600008],
              [13.059743686000047, 68.09528229400007],
              [13.054698113000086, 68.09813060100004],
            ],
          ],
          [
            [
              [13.280528191000087, 68.12913646000004],
              [13.295664910000085, 68.15228913000004],
              [13.330577019000089, 68.15574778900003],
              [13.400401238000086, 68.14594147300005],
              [13.409027540000068, 68.14321523600006],
              [13.428070509000065, 68.13027578300006],
              [13.437673373000052, 68.12604401200008],
              [13.41374759200005, 68.08299388200004],
              [13.39584394600007, 68.06024811400005],
              [13.379893425000091, 68.05036041900007],
              [13.380137566000087, 68.04547760600008],
              [13.371592644000089, 68.02171458500004],
              [13.366221550000091, 68.01276276200008],
              [13.356700066000087, 68.01064687700006],
              [13.333262566000087, 68.02643463700008],
              [13.321543816000087, 68.02985260600008],
              [13.269053582000083, 67.99778880400004],
              [13.238617384000065, 67.98554108300004],
              [13.225352410000085, 67.99884674700007],
              [13.22437584700009, 68.02142975500004],
              [13.221364780000044, 68.03213125200006],
              [13.215505405000044, 68.03668854400007],
              [13.19703209700009, 68.03343333500004],
              [13.193614129000082, 68.02582428600005],
              [13.193369988000086, 68.01679108300004],
              [13.184336785000085, 68.00942617400005],
              [13.172699415000068, 68.00901927300004],
              [13.166270379000082, 68.01536692900004],
              [13.16374759200005, 68.02558014500005],
              [13.16382897200009, 68.03668854400007],
              [13.168467644000089, 68.04975006700005],
              [13.177989129000082, 68.05947500200006],
              [13.239268425000091, 68.09210846600007],
              [13.258311394000089, 68.09560781500005],
              [13.276866082000083, 68.08820221600007],
              [13.298106316000087, 68.06549713700008],
              [13.31218509200005, 68.05829498900005],
              [13.328379754000082, 68.06342194200005],
              [13.338633660000085, 68.08600495000007],
              [13.320160352000073, 68.10415273600006],
              [13.293955925000091, 68.11835358300004],
              [13.280528191000087, 68.12913646000004],
            ],
          ],
          [
            [
              [15.000498894000089, 68.36505768400008],
              [14.945323113000086, 68.35138580900008],
              [14.963226759000065, 68.34540436400005],
              [14.979340040000068, 68.33771393400008],
              [14.936289910000085, 68.32786692900004],
              [14.763194207000083, 68.25901927300004],
              [14.735524936000047, 68.25495026200008],
              [14.719981316000087, 68.26264069200005],
              [14.722911004000082, 68.27960846600007],
              [14.738617384000065, 68.29580312700006],
              [14.774587436000047, 68.31785716400003],
              [14.756602410000085, 68.31736888200004],
              [14.747243686000047, 68.32416413000004],
              [14.741221550000091, 68.33274974200003],
              [14.733653191000087, 68.33771393400008],
              [14.718760613000086, 68.33763255400004],
              [14.709727410000085, 68.33291250200006],
              [14.692067905000044, 68.31037018400008],
              [14.703135613000086, 68.29682038000004],
              [14.693858269000089, 68.28620026200008],
              [14.675303582000083, 68.27936432500007],
              [14.651052280000044, 68.27570221600007],
              [14.639414910000085, 68.27244700700004],
              [14.62859134200005, 68.26788971600007],
              [14.623789910000085, 68.26264069200005],
              [14.630056186000047, 68.25779857000003],
              [14.67164147200009, 68.24957916900007],
              [14.656504754000082, 68.24079010600008],
              [14.61491946700005, 68.22455475500004],
              [14.57203209700009, 68.21987539300005],
              [14.555511915000068, 68.21523672100005],
              [14.52125084700009, 68.20115794500003],
              [14.498220248000052, 68.19672272300005],
              [14.418223504000082, 68.19432200700004],
              [14.407074415000068, 68.19245026200008],
              [14.391449415000068, 68.18329498900005],
              [14.383555535000085, 68.18073151200008],
              [14.368418816000087, 68.18105703300006],
              [14.338145379000082, 68.18671295800004],
              [14.32203209700009, 68.18691640800006],
              [14.326019727000073, 68.17694733300004],
              [14.328298373000052, 68.17328522300005],
              [14.31218509200005, 68.16803620000007],
              [14.27702884200005, 68.16779205900008],
              [14.247080925000091, 68.15839264500005],
              [14.212901238000086, 68.15281810100004],
              [14.198496941000087, 68.15277741100005],
              [14.20875084700009, 68.16864655200004],
              [14.212738477000073, 68.17328522300005],
              [14.215993686000047, 68.17426178600005],
              [14.21843509200005, 68.17450592700004],
              [14.219737175000091, 68.17597077000005],
              [14.219004754000082, 68.18073151200008],
              [14.211761915000068, 68.18451569200005],
              [14.206065300000091, 68.18935781500005],
              [14.201833530000044, 68.19489166900007],
              [14.198496941000087, 68.20115794500003],
              [14.234873894000089, 68.22003815300008],
              [14.31804446700005, 68.23232656500005],
              [14.356211785000085, 68.24213288000004],
              [14.301524285000085, 68.23578522300005],
              [14.274180535000085, 68.23700592700004],
              [14.253184441000087, 68.24957916900007],
              [14.270274285000085, 68.25812409100007],
              [14.28882897200009, 68.26190827000005],
              [14.328298373000052, 68.26264069200005],
              [14.305918816000087, 68.27448151200008],
              [14.296722852000073, 68.29315827000005],
              [14.303396030000044, 68.31199778900003],
              [14.328298373000052, 68.32404205900008],
              [14.357920769000089, 68.32050202000005],
              [14.395274285000085, 68.28733958500004],
              [14.425059441000087, 68.28314850500004],
              [14.425059441000087, 68.29059479400007],
              [14.41342207100007, 68.29730866100005],
              [14.419444207000083, 68.30109284100007],
              [14.431651238000086, 68.30540599200003],
              [14.438161655000044, 68.31415436400005],
              [14.44271894600007, 68.31842682500007],
              [14.453461134000065, 68.31452057500007],
              [14.472911004000082, 68.30418528900003],
              [14.495616082000083, 68.30605703300006],
              [14.496429884000065, 68.31631094000005],
              [14.483897332000083, 68.33063385600008],
              [14.466075066000087, 68.34454987200007],
              [14.456228061000047, 68.33738841400003],
              [14.444021030000044, 68.33730703300006],
              [14.435801629000082, 68.34430573100008],
              [14.438161655000044, 68.35883209800005],
              [14.39616946700005, 68.36717357000003],
              [14.383555535000085, 68.37250397300005],
              [14.493418816000087, 68.38556549700007],
              [14.51929772200009, 68.38231028900003],
              [14.562998894000089, 68.36823151200008],
              [14.58961022200009, 68.36505768400008],
              [14.58179772200009, 68.38108958500004],
              [14.552989129000082, 68.39402903900003],
              [14.541758660000085, 68.40599192900004],
              [14.653493686000047, 68.42853424700007],
              [14.67164147200009, 68.41689687700006],
              [14.67318769600007, 68.40355052300004],
              [14.678233269000089, 68.39565664300005],
              [14.695811394000089, 68.38247304900005],
              [14.707530144000089, 68.37791575700004],
              [14.709320509000065, 68.38882070500006],
              [14.705739780000044, 68.41347890800006],
              [14.714121941000087, 68.42328522300005],
              [14.726410352000073, 68.42999909100007],
              [14.742360873000052, 68.43353913000004],
              [14.760915561000047, 68.43390534100007],
              [14.796397332000083, 68.42670319200005],
              [14.814463738000086, 68.41917552300004],
              [14.822438998000052, 68.40973541900007],
              [14.82553144600007, 68.39508698100008],
              [14.82195071700005, 68.38983795800004],
              [14.754079623000052, 68.35883209800005],
              [14.754079623000052, 68.35138580900008],
              [14.783539259000065, 68.35415273600006],
              [14.840098504000082, 68.37445709800005],
              [14.870127800000091, 68.37929922100005],
              [14.880381707000083, 68.38597239800004],
              [14.88445071700005, 68.41982656500005],
              [14.897471550000091, 68.43390534100007],
              [14.929860873000052, 68.43732330900008],
              [15.009776238000086, 68.42804596600007],
              [15.063324415000068, 68.44871653900003],
              [15.101410352000073, 68.45368073100008],
              [15.172373894000089, 68.45441315300008],
              [15.154633009000065, 68.43866608300004],
              [15.034190300000091, 68.36347077000005],
              [15.014170769000089, 68.35883209800005],
              [15.016449415000068, 68.36359284100007],
              [15.018809441000087, 68.37042877800008],
              [15.018809441000087, 68.37653229400007],
              [15.014170769000089, 68.37929922100005],
              [15.003916863000086, 68.37763092700004],
              [15.00171959700009, 68.37311432500007],
              [15.002289259000065, 68.36810944200005],
              [15.000498894000089, 68.36505768400008],
            ],
          ],
          [
            [
              [16.42286217500009, 68.49192942900004],
              [16.432790561000047, 68.48525625200006],
              [16.45557701900009, 68.47650788000004],
              [16.46656334700009, 68.46869538000004],
              [16.44312584700009, 68.46263255400004],
              [16.392100457000083, 68.45595937700006],
              [16.37159264400009, 68.44757721600007],
              [16.38640384200005, 68.44106679900005],
              [16.40528405000009, 68.42942942900004],
              [16.414073113000086, 68.41840241100005],
              [16.398610873000052, 68.41347890800006],
              [16.230723504000082, 68.40957265800006],
              [16.179209832000083, 68.39980703300006],
              [16.141286655000044, 68.38397858300004],
              [16.12354576900009, 68.37921784100007],
              [16.11768639400009, 68.38556549700007],
              [16.094899936000047, 68.39752838700008],
              [16.115407748000052, 68.41034577000005],
              [16.17237389400009, 68.42772044500003],
              [16.158539259000065, 68.42731354400007],
              [16.144704623000052, 68.42853424700007],
              [16.11768639400009, 68.43390534100007],
              [16.13770592500009, 68.46869538000004],
              [16.16895592500009, 68.49909088700008],
              [16.192149285000085, 68.51496002800008],
              [16.22169030000009, 68.52374909100007],
              [16.343597852000073, 68.53701406500005],
              [16.35873457100007, 68.53485748900005],
              [16.388845248000052, 68.52545807500007],
              [16.402354363000086, 68.52334219000005],
              [16.412119988000086, 68.51947663000004],
              [16.416677280000044, 68.51048411700003],
              [16.41895592500009, 68.50006745000007],
              [16.42286217500009, 68.49192942900004],
            ],
          ],
          [
            [
              [17.052907748000052, 68.81753164300005],
              [17.073415561000047, 68.81207916900007],
              [17.131602410000085, 68.78339264500005],
              [17.145681186000047, 68.77033112200007],
              [17.104991082000083, 68.75804271000004],
              [16.840993686000047, 68.72540924700007],
              [16.816661004000082, 68.73558177300004],
              [16.82357832100007, 68.73997630400004],
              [16.830332879000082, 68.74713776200008],
              [16.835215691000087, 68.75625234600005],
              [16.837168816000087, 68.76658763200004],
              [16.84424889400009, 68.77326080900008],
              [16.87794030000009, 68.78750234600005],
              [16.910980665000068, 68.79706452000005],
              [16.97429446700005, 68.84544505400004],
              [17.00098717500009, 68.85858795800004],
              [17.015635613000086, 68.86001211100006],
              [17.02198326900009, 68.84886302300004],
              [17.02702884200005, 68.84699127800008],
              [17.052907748000052, 68.81753164300005],
            ],
          ],
          [
            [
              [17.20639082100007, 68.89325592700004],
              [17.205332879000082, 68.91327545800004],
              [17.224945509000065, 68.92112864800004],
              [17.31967207100007, 68.91844310100004],
              [17.36426842500009, 68.90932851800005],
              [17.405528191000087, 68.89227936400005],
              [17.44044030000009, 68.86591217700004],
              [17.34896894600007, 68.83515045800004],
              [17.29981530000009, 68.80365631700005],
              [17.26221764400009, 68.79364655200004],
              [17.22364342500009, 68.79303620000007],
              [17.193369988000086, 68.80390045800004],
              [17.17823326900009, 68.81500885600008],
              [17.17237389400009, 68.84796784100007],
              [17.15870201900009, 68.86591217700004],
              [17.109629754000082, 68.88621653900003],
              [17.087168816000087, 68.89850495000007],
              [17.083506707000083, 68.91376373900005],
              [17.10450280000009, 68.92503489800004],
              [17.131195509000065, 68.91543203300006],
              [17.17237389400009, 68.88580963700008],
              [17.19662519600007, 68.87278880400004],
              [17.22592207100007, 68.86139557500007],
              [17.255869988000086, 68.85541413000004],
              [17.28223717500009, 68.85846588700008],
              [17.264821811000047, 68.86871979400007],
              [17.22046959700009, 68.88222890800006],
              [17.20639082100007, 68.89325592700004],
            ],
          ],
          [
            [
              [16.528575066000087, 68.72199127800008],
              [16.576996290000068, 68.70766836100006],
              [16.567149285000085, 68.69920482000003],
              [16.53484134200005, 68.68097565300008],
              [16.560883009000065, 68.67169830900008],
              [16.558929884000065, 68.65521881700005],
              [16.54232832100007, 68.63703034100007],
              [16.524668816000087, 68.62262604400007],
              [16.513194207000083, 68.61676666900007],
              [16.50098717500009, 68.61220937700006],
              [16.491058790000068, 68.60578034100007],
              [16.487071160000085, 68.59467194200005],
              [16.492035352000073, 68.58234284100007],
              [16.496104363000086, 68.57933177300004],
              [16.501231316000087, 68.57558828300006],
              [16.506032748000052, 68.56818268400008],
              [16.497569207000083, 68.55402252800008],
              [16.48145592500009, 68.54751211100006],
              [16.459320509000065, 68.54905833500004],
              [16.419444207000083, 68.55744049700007],
              [16.346527540000068, 68.55951569200005],
              [16.222178582000083, 68.54743073100008],
              [16.155528191000087, 68.52456289300005],
              [16.141774936000047, 68.52334219000005],
              [16.129730665000068, 68.52716705900008],
              [16.117930535000085, 68.53424713700008],
              [16.10596764400009, 68.53851959800005],
              [16.09351647200009, 68.53351471600007],
              [16.082367384000065, 68.51557038000004],
              [16.06967207100007, 68.48895905200004],
              [16.053396030000044, 68.46482982000003],
              [16.012054884000065, 68.44696686400005],
              [15.994965040000068, 68.42942942900004],
              [15.966319207000083, 68.39301178600005],
              [15.940928582000083, 68.38031647300005],
              [15.90398196700005, 68.36985911700003],
              [15.876231316000087, 68.36908600500004],
              [15.878184441000087, 68.38556549700007],
              [15.87077884200005, 68.40058014500005],
              [15.873708530000044, 68.41461823100008],
              [15.88062584700009, 68.42877838700008],
              [15.884287957000083, 68.44415924700007],
              [15.881602410000085, 68.45636627800008],
              [15.875498894000089, 68.46662018400008],
              [15.870616082000083, 68.47846100500004],
              [15.87077884200005, 68.49542877800008],
              [15.858571811000047, 68.48623281500005],
              [15.859629754000082, 68.47736237200007],
              [15.864756707000083, 68.46735260600008],
              [15.864512566000087, 68.45441315300008],
              [15.85718834700009, 68.44086334800005],
              [15.84929446700005, 68.43475983300004],
              [15.823008660000085, 68.42401764500005],
              [15.812347852000073, 68.42641836100006],
              [15.796071811000047, 68.43390534100007],
              [15.78101647200009, 68.43817780200004],
              [15.774424675000091, 68.43085358300004],
              [15.780446811000047, 68.41868724200003],
              [15.807383660000085, 68.40314362200007],
              [15.81617272200009, 68.39301178600005],
              [15.79273522200009, 68.39362213700008],
              [15.78101647200009, 68.40180084800005],
              [15.77312259200005, 68.41339752800008],
              [15.76148522200009, 68.42401764500005],
              [15.747894727000073, 68.42536041900007],
              [15.740407748000052, 68.41494375200006],
              [15.733083530000044, 68.40131256700005],
              [15.719899936000047, 68.39301178600005],
              [15.721853061000047, 68.38837311400005],
              [15.724619988000086, 68.37693919500003],
              [15.726735873000052, 68.37250397300005],
              [15.691416863000086, 68.37323639500005],
              [15.674327019000089, 68.37128327000005],
              [15.658457879000082, 68.36505768400008],
              [15.669444207000083, 68.36139557500007],
              [15.681162957000083, 68.35907623900005],
              [15.693532748000052, 68.35814036700003],
              [15.706309441000087, 68.35883209800005],
              [15.691254102000073, 68.34300364800004],
              [15.640147332000083, 68.31745026200008],
              [15.637950066000087, 68.30418528900003],
              [15.62435957100007, 68.30048248900005],
              [15.597992384000065, 68.30442942900004],
              [15.582774285000085, 68.30418528900003],
              [15.58961022200009, 68.30780670800004],
              [15.596446160000085, 68.31037018400008],
              [15.596446160000085, 68.31785716400003],
              [15.575368686000047, 68.31940338700008],
              [15.544118686000047, 68.33405182500007],
              [15.527679884000065, 68.33771393400008],
              [15.375987175000091, 68.32758209800005],
              [15.338389519000089, 68.33197663000004],
              [15.322601759000065, 68.35138580900008],
              [15.342539910000085, 68.34821198100008],
              [15.358083530000044, 68.35492584800005],
              [15.387868686000047, 68.38247304900005],
              [15.40593509200005, 68.39191315300008],
              [15.472911004000082, 68.40599192900004],
              [15.50717207100007, 68.42255280200004],
              [15.57007897200009, 68.46303945500006],
              [15.611338738000086, 68.47492096600007],
              [15.580577019000089, 68.48745351800005],
              [15.57593834700009, 68.49192942900004],
              [15.572764519000089, 68.50287506700005],
              [15.564707879000082, 68.50910065300008],
              [15.553721550000091, 68.51117584800005],
              [15.541758660000085, 68.50967031500005],
              [15.552907748000052, 68.48777903900003],
              [15.553965691000087, 68.47532786700003],
              [15.542165561000047, 68.46625397300005],
              [15.439300977000073, 68.41840241100005],
              [15.41179446700005, 68.41347890800006],
              [15.405039910000085, 68.41449616100005],
              [15.384043816000087, 68.42023346600007],
              [15.376475457000083, 68.41718170800004],
              [15.370371941000087, 68.41254303600005],
              [15.363617384000065, 68.40599192900004],
              [15.316254102000073, 68.39549388200004],
              [15.27865644600007, 68.37323639500005],
              [15.211761915000068, 68.36595286700003],
              [15.185394727000073, 68.35138580900008],
              [15.214854363000086, 68.35252513200004],
              [15.226735873000052, 68.34882233300004],
              [15.233246290000068, 68.33771393400008],
              [15.21656334700009, 68.33539459800005],
              [15.145030144000089, 68.31293366100005],
              [15.134043816000087, 68.30805084800005],
              [15.113780144000089, 68.28681061400005],
              [15.085785352000073, 68.27122630400004],
              [15.040863477000073, 68.25702545800004],
              [15.000498894000089, 68.25332265800006],
              [14.986827019000089, 68.26947663000004],
              [14.992686394000089, 68.27138906500005],
              [14.997894727000073, 68.27407461100006],
              [15.002940300000091, 68.27789948100008],
              [15.007334832000083, 68.28314850500004],
              [14.995371941000087, 68.29779694200005],
              [15.009287957000083, 68.31366608300004],
              [15.034190300000091, 68.32632070500006],
              [15.055837436000047, 68.33152903900003],
              [15.06812584700009, 68.33909739800004],
              [15.104014519000089, 68.37734609600005],
              [15.123383009000065, 68.39301178600005],
              [15.192556186000047, 68.43488190300008],
              [15.222911004000082, 68.44379303600005],
              [15.252207879000082, 68.45734284100007],
              [15.268077019000089, 68.46124909100007],
              [15.35678144600007, 68.46124909100007],
              [15.330821160000085, 68.46466705900008],
              [15.260101759000065, 68.46649811400005],
              [15.240733269000089, 68.47492096600007],
              [15.248383009000065, 68.48623281500005],
              [15.27898196700005, 68.48989492400005],
              [15.336924675000091, 68.48859284100007],
              [15.281748894000089, 68.49542877800008],
              [15.274912957000083, 68.49852122600004],
              [15.274587436000047, 68.50560130400004],
              [15.275238477000073, 68.51268138200004],
              [15.271494988000086, 68.51585521000004],
              [15.178558790000068, 68.52334219000005],
              [15.198741082000083, 68.54303620000007],
              [15.217295769000089, 68.55687083500004],
              [15.238780144000089, 68.56427643400008],
              [15.268077019000089, 68.56427643400008],
              [15.311696811000047, 68.55882396000004],
              [15.323252800000091, 68.56281159100007],
              [15.308929884000065, 68.57855866100005],
              [15.394704623000052, 68.58478424700007],
              [15.405528191000087, 68.58051178600005],
              [15.434336785000085, 68.56183502800008],
              [15.452321811000047, 68.55744049700007],
              [15.439626498000052, 68.57363515800006],
              [15.391612175000091, 68.60521067900004],
              [15.40756269600007, 68.60468170800004],
              [15.436045769000089, 68.59833405200004],
              [15.452321811000047, 68.59780508000006],
              [15.443207227000073, 68.60903554900005],
              [15.438731316000087, 68.61212799700007],
              [15.438731316000087, 68.61953359600005],
              [15.548838738000086, 68.62571849200003],
              [15.556651238000086, 68.62392812700006],
              [15.567393425000091, 68.61444733300004],
              [15.574961785000085, 68.61029694200005],
              [15.589121941000087, 68.60643138200004],
              [15.60320071700005, 68.60504791900007],
              [15.61687259200005, 68.60663483300004],
              [15.63054446700005, 68.61212799700007],
              [15.615977410000085, 68.61286041900007],
              [15.60482832100007, 68.61863841400003],
              [15.594493035000085, 68.62628815300008],
              [15.582774285000085, 68.63255442900004],
              [15.562754754000082, 68.63519928600005],
              [15.513845248000052, 68.63617584800005],
              [15.49773196700005, 68.64248281500005],
              [15.47828209700009, 68.65582916900007],
              [15.457367384000065, 68.66705963700008],
              [15.442067905000044, 68.68219635600008],
              [15.438731316000087, 68.70766836100006],
              [15.44304446700005, 68.72357819200005],
              [15.449554884000065, 68.72915273600006],
              [15.569102410000085, 68.72939687700006],
              [15.581553582000083, 68.73110586100006],
              [15.593028191000087, 68.73427969000005],
              [15.60482832100007, 68.73574453300006],
              [15.617849155000044, 68.73248932500007],
              [15.64226321700005, 68.72321198100008],
              [15.662608269000089, 68.71918366100005],
              [15.713633660000085, 68.70140208500004],
              [15.686696811000047, 68.71092357000003],
              [15.678884311000047, 68.71507396000004],
              [15.675954623000052, 68.71918366100005],
              [15.668711785000085, 68.73208242400005],
              [15.66578209700009, 68.73558177300004],
              [15.639659050000091, 68.74323151200008],
              [15.501231316000087, 68.74306875200006],
              [15.47592207100007, 68.74689362200007],
              [15.459808790000068, 68.75604889500005],
              [15.455577019000089, 68.76902903900003],
              [15.459157748000052, 68.79612864800004],
              [15.452321811000047, 68.81126536700003],
              [15.464121941000087, 68.81000397300005],
              [15.485850457000083, 68.80499909100007],
              [15.497080925000091, 68.80390045800004],
              [15.507660352000073, 68.80646393400008],
              [15.514170769000089, 68.81268952000005],
              [15.519867384000065, 68.81976959800005],
              [15.52865644600007, 68.82493724200003],
              [15.55632571700005, 68.82636139500005],
              [15.613454623000052, 68.81777578300006],
              [15.637950066000087, 68.82493724200003],
              [15.618418816000087, 68.82977936400005],
              [15.590179884000065, 68.83307526200008],
              [15.563487175000091, 68.83917877800008],
              [15.54859459700009, 68.85228099200003],
              [15.553233269000089, 68.87225983300004],
              [15.575694207000083, 68.88222890800006],
              [15.624278191000087, 68.88580963700008],
              [15.620371941000087, 68.89411041900007],
              [15.614105665000068, 68.90045807500007],
              [15.606130405000044, 68.90473053600005],
              [15.596446160000085, 68.90692780200004],
              [15.609548373000052, 68.91941966400003],
              [15.63054446700005, 68.94481028900003],
              [15.644786004000082, 68.95473867400005],
              [15.676605665000068, 68.96271393400008],
              [15.778493686000047, 68.95473867400005],
              [15.857595248000052, 68.97016022300005],
              [15.884287957000083, 68.96832916900007],
              [15.907399936000047, 68.95941803600005],
              [15.90788821700005, 68.95734284100007],
              [15.90984134200005, 68.94977448100008],
              [15.902842644000089, 68.93675364800004],
              [15.897959832000083, 68.91742584800005],
              [15.904551629000082, 68.90387604400007],
              [15.917002800000091, 68.89573802300004],
              [15.924082879000082, 68.88641998900005],
              [15.914805535000085, 68.86933014500005],
              [15.878184441000087, 68.81753164300005],
              [15.875824415000068, 68.81049225500004],
              [15.87476647200009, 68.79755280200004],
              [15.87077884200005, 68.79022858300004],
              [15.863291863000086, 68.78290436400005],
              [15.847911004000082, 68.77301666900007],
              [15.840342644000089, 68.76658763200004],
              [15.82398522200009, 68.75617096600007],
              [15.76148522200009, 68.73558177300004],
              [15.805511915000068, 68.73847077000005],
              [15.853526238000086, 68.74762604400007],
              [15.898936394000089, 68.76361725500004],
              [15.935557488000086, 68.78709544500003],
              [15.955577019000089, 68.79165273600006],
              [15.976898634000065, 68.78131745000007],
              [15.98959394600007, 68.76349518400008],
              [15.983653191000087, 68.74555084800005],
              [15.971202019000089, 68.73224518400008],
              [15.953868035000085, 68.70477936400005],
              [15.942393425000091, 68.69061920800004],
              [15.933116082000083, 68.68414948100008],
              [15.924489780000044, 68.68207428600005],
              [15.915293816000087, 68.68097565300008],
              [15.904795769000089, 68.67755768400008],
              [15.895192905000044, 68.67157623900005],
              [15.87867272200009, 68.65790436400005],
              [15.87077884200005, 68.65302155200004],
              [15.847911004000082, 68.64834219000005],
              [15.793304884000065, 68.64297109600005],
              [15.774424675000091, 68.63255442900004],
              [15.765798373000052, 68.61566803600005],
              [15.76921634200005, 68.60321686400005],
              [15.77711022200009, 68.59198639500005],
              [15.781911655000044, 68.57855866100005],
              [15.777842644000089, 68.56216054900005],
              [15.766612175000091, 68.55377838700008],
              [15.752614780000044, 68.54572174700007],
              [15.740407748000052, 68.53009674700007],
              [15.78101647200009, 68.54120514500005],
              [15.802907748000052, 68.55133698100008],
              [15.81617272200009, 68.56427643400008],
              [15.819021030000044, 68.58380768400008],
              [15.815114780000044, 68.59808991100005],
              [15.816742384000065, 68.61082591400003],
              [15.836599155000044, 68.62571849200003],
              [15.858571811000047, 68.63418203300006],
              [15.932139519000089, 68.65302155200004],
              [15.97820071700005, 68.67153554900005],
              [16.005137566000087, 68.67755768400008],
              [16.02784264400009, 68.67413971600007],
              [16.04542076900009, 68.64301178600005],
              [16.061289910000085, 68.63031647300005],
              [16.08301842500009, 68.63873932500007],
              [16.090017123000052, 68.65619538000004],
              [16.08106530000009, 68.67251211100006],
              [16.05567467500009, 68.69399648600006],
              [16.050629102000073, 68.69599030200004],
              [16.038910352000073, 68.70343659100007],
              [16.033213738000086, 68.71137116100005],
              [16.04542076900009, 68.71507396000004],
              [16.06812584700009, 68.73126862200007],
              [16.076182488000086, 68.73558177300004],
              [16.107432488000086, 68.74070872600004],
              [16.213226759000065, 68.73558177300004],
              [16.201019727000073, 68.76072825700004],
              [16.178884311000047, 68.77167389500005],
              [16.123871290000068, 68.78400299700007],
              [16.108571811000047, 68.79144928600005],
              [16.094574415000068, 68.80166250200006],
              [16.08887780000009, 68.81488678600005],
              [16.097178582000083, 68.83120351800005],
              [16.107432488000086, 68.83612702000005],
              [16.191742384000065, 68.85716380400004],
              [16.207041863000086, 68.85846588700008],
              [16.224619988000086, 68.85602448100008],
              [16.25359134200005, 68.84296295800004],
              [16.267914259000065, 68.83860911700003],
              [16.284027540000068, 68.84031810100004],
              [16.29395592500009, 68.84735748900005],
              [16.295258009000065, 68.85492584800005],
              [16.262461785000085, 68.86668528900003],
              [16.249522332000083, 68.88418203300006],
              [16.246836785000085, 68.89996979400007],
              [16.254649285000085, 68.90322500200006],
              [16.314626498000052, 68.87010325700004],
              [16.390961134000065, 68.85443756700005],
              [16.430023634000065, 68.85199616100005],
              [16.43881269600007, 68.84955475500004],
              [16.44044030000009, 68.84235260600008],
              [16.439789259000065, 68.82807038000004],
              [16.45557701900009, 68.81533437700006],
              [16.530446811000047, 68.82599518400008],
              [16.555918816000087, 68.82493724200003],
              [16.539805535000085, 68.81500885600008],
              [16.50554446700005, 68.80316803600005],
              [16.494476759000065, 68.79022858300004],
              [16.511973504000082, 68.79096100500004],
              [16.53060957100007, 68.78900788000004],
              [16.546722852000073, 68.78266022300005],
              [16.555918816000087, 68.77033112200007],
              [16.526133660000085, 68.76097239800004],
              [16.525726759000065, 68.75263092700004],
              [16.53370201900009, 68.74111562700006],
              [16.528575066000087, 68.72199127800008],
            ],
          ],
          [
            [
              [16.56617272200009, 68.96832916900007],
              [16.584646030000044, 68.96185944200005],
              [16.599457227000073, 68.94717031500005],
              [16.601898634000065, 68.93121979400007],
              [16.583262566000087, 68.92112864800004],
              [16.587168816000087, 68.89744700700004],
              [16.567067905000044, 68.88739655200004],
              [16.47624759200005, 68.88580963700008],
              [16.434743686000047, 68.89130280200004],
              [16.394867384000065, 68.90200429900005],
              [16.343597852000073, 68.93374258000006],
              [16.285166863000086, 68.95209381700005],
              [16.261729363000086, 68.96832916900007],
              [16.30632571700005, 68.99530670800004],
              [16.359385613000086, 68.99013906500005],
              [16.41504967500009, 68.97247955900008],
              [16.466807488000086, 68.96214427300004],
              [16.52051842500009, 68.96214427300004],
              [16.56617272200009, 68.96832916900007],
            ],
          ],
          [
            [
              [14.397227410000085, 68.66046784100007],
              [14.387950066000087, 68.66388580900008],
              [14.382090691000087, 68.66937897300005],
              [14.369883660000085, 68.68720123900005],
              [14.381114129000082, 68.69765859600005],
              [14.394541863000086, 68.70160553600005],
              [14.425059441000087, 68.70140208500004],
              [14.426280144000089, 68.71442291900007],
              [14.464121941000087, 68.72451406500005],
              [14.541758660000085, 68.73558177300004],
              [14.541758660000085, 68.74241771000004],
              [14.516612175000091, 68.74249909100007],
              [14.438161655000044, 68.75604889500005],
              [14.455332879000082, 68.77602773600006],
              [14.488454623000052, 68.79535553600005],
              [14.523936394000089, 68.80707428600005],
              [14.548024936000047, 68.80390045800004],
              [14.553233269000089, 68.79433828300006],
              [14.555023634000065, 68.77041250200006],
              [14.561778191000087, 68.75604889500005],
              [14.572276238000086, 68.74632396000004],
              [14.58725019600007, 68.73908112200007],
              [14.604991082000083, 68.73517487200007],
              [14.623789910000085, 68.73558177300004],
              [14.616221550000091, 68.74070872600004],
              [14.607920769000089, 68.74461497600004],
              [14.598887566000087, 68.74730052300004],
              [14.58961022200009, 68.74860260600008],
              [14.597829623000052, 68.76740143400008],
              [14.608653191000087, 68.77806224200003],
              [14.623708530000044, 68.78449127800008],
              [14.64421634200005, 68.79022858300004],
              [14.616465691000087, 68.79905833500004],
              [14.607595248000052, 68.80727773600006],
              [14.613536004000082, 68.82123444200005],
              [14.628428582000083, 68.82990143400008],
              [14.648692254000082, 68.83295319200005],
              [14.669444207000083, 68.83104075700004],
              [14.685801629000082, 68.82493724200003],
              [14.678965691000087, 68.81753164300005],
              [14.692067905000044, 68.81126536700003],
              [14.679698113000086, 68.76732005400004],
              [14.686534050000091, 68.75747304900005],
              [14.719981316000087, 68.76288483300004],
              [14.801280144000089, 68.78937409100007],
              [14.843597852000073, 68.79629140800006],
              [14.883799675000091, 68.79022858300004],
              [14.872894727000073, 68.78046295800004],
              [14.872325066000087, 68.76923248900005],
              [14.880056186000047, 68.75995514500005],
              [14.894053582000083, 68.75604889500005],
              [14.907074415000068, 68.76023997600004],
              [14.928965691000087, 68.77903880400004],
              [14.945323113000086, 68.78400299700007],
              [14.941579623000052, 68.79266998900005],
              [14.942230665000068, 68.80145905200004],
              [14.946543816000087, 68.80988190300008],
              [14.952647332000083, 68.81753164300005],
              [14.904307488000086, 68.84544505400004],
              [14.94117272200009, 68.85980866100005],
              [14.952647332000083, 68.86591217700004],
              [14.976084832000083, 68.84804922100005],
              [14.991058790000068, 68.84202708500004],
              [14.992686394000089, 68.83417389500005],
              [14.992035352000073, 68.82485586100006],
              [14.993662957000083, 68.81753164300005],
              [14.999847852000073, 68.79926178600005],
              [15.006032748000052, 68.79385000200006],
              [15.017588738000086, 68.80048248900005],
              [15.024261915000068, 68.80805084800005],
              [15.027598504000082, 68.81439850500004],
              [15.026621941000087, 68.81997304900005],
              [15.021006707000083, 68.82493724200003],
              [15.049815300000091, 68.85276927300004],
              [15.085459832000083, 68.84520091400003],
              [15.123301629000082, 68.82558828300006],
              [15.158864780000044, 68.81753164300005],
              [15.145681186000047, 68.84251536700003],
              [15.120290561000047, 68.85651276200008],
              [15.09156334700009, 68.86640045800004],
              [15.068695509000065, 68.87897370000007],
              [15.076670769000089, 68.89899323100008],
              [15.065196160000085, 68.91315338700008],
              [15.027842644000089, 68.93423086100006],
              [15.019379102000073, 68.94476959800005],
              [15.009287957000083, 68.96332428600005],
              [15.007660352000073, 68.98102448100008],
              [15.084483269000089, 69.01121653900003],
              [15.104340040000068, 69.01447174700007],
              [15.12435957100007, 69.01532623900005],
              [15.137705925000091, 69.01308828300006],
              [15.15398196700005, 69.00250885600008],
              [15.168223504000082, 68.98826732000003],
              [15.170664910000085, 68.97378164300005],
              [15.151377800000091, 68.96214427300004],
              [15.192556186000047, 68.94269440300008],
              [15.206553582000083, 68.94037506700005],
              [15.19703209700009, 68.93520742400005],
              [15.192881707000083, 68.93423086100006],
              [15.192881707000083, 68.92739492400005],
              [15.206228061000047, 68.92755768400008],
              [15.21851647200009, 68.92438385600008],
              [15.240733269000089, 68.91376373900005],
              [15.209483269000089, 68.90326569200005],
              [15.195567254000082, 68.89691803600005],
              [15.185394727000073, 68.88580963700008],
              [15.214366082000083, 68.88165924700007],
              [15.271494988000086, 68.91974518400008],
              [15.295258009000065, 68.90692780200004],
              [15.281748894000089, 68.86591217700004],
              [15.27279707100007, 68.85407135600008],
              [15.240733269000089, 68.82493724200003],
              [15.30209394600007, 68.84300364800004],
              [15.319509311000047, 68.85541413000004],
              [15.32585696700005, 68.85871002800008],
              [15.333506707000083, 68.85871002800008],
              [15.339691602000073, 68.85553620000007],
              [15.342458530000044, 68.84886302300004],
              [15.347829623000052, 68.84690989800004],
              [15.384043816000087, 68.85228099200003],
              [15.371755405000044, 68.83535390800006],
              [15.36264082100007, 68.81732819200005],
              [15.350759311000047, 68.80292389500005],
              [15.32976321700005, 68.79706452000005],
              [15.299815300000091, 68.80280182500007],
              [15.284434441000087, 68.80353424700007],
              [15.274912957000083, 68.79706452000005],
              [15.278330925000091, 68.79181549700007],
              [15.302744988000086, 68.77655670800004],
              [15.282399936000047, 68.76557038000004],
              [15.274912957000083, 68.76288483300004],
              [15.311696811000047, 68.75263092700004],
              [15.358409050000091, 68.74628327000005],
              [15.39421634200005, 68.73110586100006],
              [15.397715691000087, 68.69399648600006],
              [15.375254754000082, 68.66990794500003],
              [15.336192254000082, 68.65289948100008],
              [15.062673373000052, 68.57851797100005],
              [14.873220248000052, 68.58445872600004],
              [14.842784050000091, 68.59153880400004],
              [14.848806186000047, 68.59454987200007],
              [14.858246290000068, 68.60203685100004],
              [14.863291863000086, 68.60521067900004],
              [14.808116082000083, 68.61469147300005],
              [14.80640709700009, 68.61595286700003],
              [14.808767123000052, 68.61953359600005],
              [14.815928582000083, 68.63776276200008],
              [14.83366946700005, 68.64447663000004],
              [14.876963738000086, 68.64618561400005],
              [14.948741082000083, 68.66412995000007],
              [14.972911004000082, 68.66669342700004],
              [15.034678582000083, 68.66669342700004],
              [15.043467644000089, 68.66937897300005],
              [15.05054772200009, 68.67536041900007],
              [15.056895379000082, 68.68227773600006],
              [15.062510613000086, 68.68720123900005],
              [15.088877800000091, 68.69501373900005],
              [15.140879754000082, 68.69501373900005],
              [15.165049675000091, 68.70140208500004],
              [15.154307488000086, 68.71320221600007],
              [15.146739129000082, 68.72553131700005],
              [15.145030144000089, 68.73956940300008],
              [15.151377800000091, 68.75604889500005],
              [15.026052280000044, 68.77118561400005],
              [14.993662957000083, 68.76288483300004],
              [15.013519727000073, 68.76300690300008],
              [15.068695509000065, 68.74860260600008],
              [15.05014082100007, 68.72980377800008],
              [15.019541863000086, 68.71214427300004],
              [14.98601321700005, 68.70254140800006],
              [14.958832227000073, 68.70766836100006],
              [14.962901238000086, 68.71621328300006],
              [14.962901238000086, 68.71906159100007],
              [14.961110873000052, 68.72162506700005],
              [14.958832227000073, 68.72939687700006],
              [14.94695071700005, 68.71458567900004],
              [14.925303582000083, 68.69501373900005],
              [14.900889519000089, 68.68130117400005],
              [14.880381707000083, 68.68406810100004],
              [14.861989780000044, 68.68988678600005],
              [14.82781009200005, 68.67348867400005],
              [14.808767123000052, 68.68097565300008],
              [14.820648634000065, 68.69407786700003],
              [14.821543816000087, 68.70722077000005],
              [14.815114780000044, 68.71474844000005],
              [14.805023634000065, 68.71137116100005],
              [14.796397332000083, 68.70099518400008],
              [14.78492272200009, 68.68317291900007],
              [14.774587436000047, 68.67413971600007],
              [14.750336134000065, 68.66746653900003],
              [14.721934441000087, 68.67304108300004],
              [14.696055535000085, 68.68756745000007],
              [14.678965691000087, 68.70766836100006],
              [14.674082879000082, 68.68695709800005],
              [14.662119988000086, 68.67397695500006],
              [14.63062584700009, 68.65302155200004],
              [14.625824415000068, 68.64520905200004],
              [14.622569207000083, 68.62885163000004],
              [14.61695397200009, 68.62571849200003],
              [14.55827884200005, 68.62726471600007],
              [14.544932488000086, 68.62262604400007],
              [14.520681186000047, 68.60903554900005],
              [14.49195397200009, 68.60667552300004],
              [14.435069207000083, 68.61212799700007],
              [14.417246941000087, 68.61953359600005],
              [14.413259311000047, 68.63641998900005],
              [14.419200066000087, 68.65485260600008],
              [14.431895379000082, 68.66669342700004],
              [14.420909050000091, 68.67251211100006],
              [14.414398634000065, 68.66864655200004],
              [14.408050977000073, 68.66217682500007],
              [14.397227410000085, 68.66046784100007],
            ],
          ],
          [
            [
              [15.52865644600007, 68.91376373900005],
              [15.501475457000083, 68.89581940300008],
              [15.464040561000047, 68.88206614800004],
              [15.431488477000073, 68.88422272300005],
              [15.418793165000068, 68.91376373900005],
              [15.427989129000082, 68.92462799700007],
              [15.42904707100007, 68.93480052300004],
              [15.426442905000044, 68.94668203300006],
              [15.425059441000087, 68.96214427300004],
              [15.430918816000087, 68.97752513200004],
              [15.45443769600007, 69.00055573100008],
              [15.459808790000068, 69.01308828300006],
              [15.517588738000086, 69.05394114800004],
              [15.542002800000091, 69.08095937700006],
              [15.56967207100007, 69.10553620000007],
              [15.61068769600007, 69.12567780200004],
              [15.65992272200009, 69.13849518400008],
              [15.758067254000082, 69.14712148600006],
              [15.791351759000065, 69.16128164300005],
              [15.84310957100007, 69.22028229400007],
              [15.87077884200005, 69.22907135600008],
              [15.868662957000083, 69.23358795800004],
              [15.866221550000091, 69.24494049700007],
              [15.864512566000087, 69.24949778900003],
              [15.881602410000085, 69.25413646000004],
              [15.916026238000086, 69.25897858300004],
              [15.932139519000089, 69.26312897300005],
              [15.975108269000089, 69.28717682500007],
              [16.101573113000086, 69.31525299700007],
              [16.131521030000044, 69.31098053600005],
              [16.149912957000083, 69.29083893400008],
              [16.146739129000082, 69.26923248900005],
              [16.131602410000085, 69.24872467700004],
              [16.11426842500009, 69.23212311400005],
              [16.09896894600007, 69.21108633000006],
              [16.08920332100007, 69.17145416900007],
              [16.076182488000086, 69.15395742400005],
              [16.060801629000082, 69.14459870000007],
              [16.014008009000065, 69.13279857000003],
              [15.97038821700005, 69.10895416900007],
              [15.956309441000087, 69.10553620000007],
              [15.946462436000047, 69.10187409100007],
              [15.934418165000068, 69.09332916900007],
              [15.914805535000085, 69.07514069200005],
              [15.910166863000086, 69.07265859600005],
              [15.893239780000044, 69.06590403900003],
              [15.877126498000052, 69.06224192900004],
              [15.873871290000068, 69.05670807500007],
              [15.873383009000065, 69.04999420800004],
              [15.87077884200005, 69.04409414300005],
              [15.857758009000065, 69.03384023600006],
              [15.847911004000082, 69.02924225500004],
              [15.81617272200009, 69.02362702000005],
              [15.760427280000044, 69.00568268400008],
              [15.63217207100007, 68.98663971600007],
              [15.596446160000085, 68.99567291900007],
              [15.566742384000065, 69.01268138200004],
              [15.549082879000082, 69.01626211100006],
              [15.52865644600007, 69.00934479400007],
              [15.545664910000085, 69.00031159100007],
              [15.560069207000083, 68.99013906500005],
              [15.569102410000085, 68.97772858300004],
              [15.56967207100007, 68.96214427300004],
              [15.563487175000091, 68.95136139500005],
              [15.52865644600007, 68.91376373900005],
            ],
          ],
          [
            [
              [18.07081139400009, 69.43793366100005],
              [18.07862389400009, 69.42499420800004],
              [18.08106530000009, 69.38764069200005],
              [18.088145379000082, 69.37986888200004],
              [18.09864342500009, 69.37612539300005],
              [18.097666863000086, 69.36762116100005],
              [18.090993686000047, 69.35834381700005],
              [18.084727410000085, 69.35252513200004],
              [18.07081139400009, 69.34906647300005],
              [18.015798373000052, 69.35252513200004],
              [17.955332879000082, 69.34267812700006],
              [17.923106316000087, 69.33234284100007],
              [17.90593509200005, 69.31842682500007],
              [17.919118686000047, 69.31232330900008],
              [17.92123457100007, 69.30402252800008],
              [17.921071811000047, 69.29413483300004],
              [17.926442905000044, 69.28367747600004],
              [17.935394727000073, 69.27773672100005],
              [17.958994988000086, 69.26780833500004],
              [17.967458530000044, 69.26312897300005],
              [17.950694207000083, 69.25079987200007],
              [17.926931186000047, 69.24725983300004],
              [17.87867272200009, 69.24949778900003],
              [17.87867272200009, 69.24266185100004],
              [17.91374759200005, 69.23407623900005],
              [17.932465040000068, 69.22724030200004],
              [17.940684441000087, 69.21881745000007],
              [17.949066602000073, 69.20514557500007],
              [17.968923373000052, 69.20221588700008],
              [17.99154707100007, 69.20307038000004],
              [18.008962436000047, 69.20111725500004],
              [17.988454623000052, 69.18744538000004],
              [17.958262566000087, 69.18048737200007],
              [17.820648634000065, 69.16950104400007],
              [17.707204623000052, 69.17291901200008],
              [17.61109459700009, 69.15395742400005],
              [17.519053582000083, 69.15794505400004],
              [17.488291863000086, 69.15395742400005],
              [17.49390709700009, 69.16889069200005],
              [17.504079623000052, 69.17983633000006],
              [17.52979576900009, 69.20111725500004],
              [17.498708530000044, 69.20282623900005],
              [17.472178582000083, 69.20014069200005],
              [17.44695071700005, 69.19285716400003],
              [17.419932488000086, 69.18060944200005],
              [17.378428582000083, 69.15395742400005],
              [17.234629754000082, 69.10618724200003],
              [17.188324415000068, 69.08348216400003],
              [17.15870201900009, 69.05027903900003],
              [17.17237389400009, 69.04559967700004],
              [17.199473504000082, 69.04824453300006],
              [17.21387780000009, 69.04409414300005],
              [17.185069207000083, 69.02440013200004],
              [17.12940514400009, 69.01154205900008],
              [17.073008660000085, 69.00812409100007],
              [17.04200280000009, 69.01679108300004],
              [17.04346764400009, 69.03070709800005],
              [17.05827884200005, 69.03921133000006],
              [17.07862389400009, 69.04319896000004],
              [17.097178582000083, 69.04409414300005],
              [17.087412957000083, 69.04897695500006],
              [17.083506707000083, 69.05027903900003],
              [17.09156334700009, 69.06171295800004],
              [17.105642123000052, 69.06635163000004],
              [17.122325066000087, 69.06830475500004],
              [17.13803144600007, 69.07200755400004],
              [17.10987389400009, 69.08470286700003],
              [16.82325280000009, 69.05442942900004],
              [16.809825066000087, 69.06460195500006],
              [16.779633009000065, 69.07013580900008],
              [16.77312259200005, 69.08820221600007],
              [16.78646894600007, 69.10814036700003],
              [16.816661004000082, 69.11920807500007],
              [16.87240644600007, 69.10439687700006],
              [16.89625084700009, 69.10423411700003],
              [16.89234459700009, 69.12665436400005],
              [16.988536004000082, 69.13963450700004],
              [17.033050977000073, 69.13202545800004],
              [17.05600019600007, 69.13287995000007],
              [17.069834832000083, 69.14712148600006],
              [17.06421959700009, 69.15009186400005],
              [17.061289910000085, 69.15326569200005],
              [17.059336785000085, 69.15664297100005],
              [17.05632571700005, 69.16014232000003],
              [17.144541863000086, 69.18406810100004],
              [17.17237389400009, 69.20111725500004],
              [17.082367384000065, 69.18158600500004],
              [17.049489780000044, 69.18060944200005],
              [16.97429446700005, 69.19489166900007],
              [16.898610873000052, 69.19489166900007],
              [16.898610873000052, 69.20111725500004],
              [16.90870201900009, 69.20319245000007],
              [16.912364129000082, 69.20575592700004],
              [16.914317254000082, 69.20945872600004],
              [16.919118686000047, 69.21539948100008],
              [16.89942467500009, 69.22093333500004],
              [16.88917076900009, 69.22231679900005],
              [16.87867272200009, 69.22215403900003],
              [16.944834832000083, 69.23651764500005],
              [17.086761915000068, 69.22894928600005],
              [17.145681186000047, 69.25633372600004],
              [17.123789910000085, 69.25023021000004],
              [17.11768639400009, 69.24949778900003],
              [17.108897332000083, 69.25177643400008],
              [17.106944207000083, 69.25657786700003],
              [17.108897332000083, 69.26141998900005],
              [17.110850457000083, 69.26312897300005],
              [17.109711134000065, 69.26821523600006],
              [17.10010826900009, 69.28123607000003],
              [17.08887780000009, 69.28953685100004],
              [17.083506707000083, 69.28025950700004],
              [17.070567254000082, 69.26805247600004],
              [17.04037519600007, 69.26825592700004],
              [16.981130405000044, 69.27680084800005],
              [16.981130405000044, 69.28367747600004],
              [16.990407748000052, 69.28534577000005],
              [16.996104363000086, 69.28774648600006],
              [17.007823113000086, 69.29791901200008],
              [16.92554772200009, 69.29344310100004],
              [16.90601647200009, 69.29791901200008],
              [16.897634311000047, 69.31171295800004],
              [16.915293816000087, 69.31757233300004],
              [17.13184655000009, 69.31098053600005],
              [17.124196811000047, 69.31370677300004],
              [17.10401451900009, 69.32526276200008],
              [17.11768639400009, 69.33144765800006],
              [17.077403191000087, 69.33051178600005],
              [17.05827884200005, 69.33429596600007],
              [17.04200280000009, 69.34511953300006],
              [17.058441602000073, 69.34983958500004],
              [17.075450066000087, 69.35203685100004],
              [17.110850457000083, 69.35252513200004],
              [17.084646030000044, 69.36176178600005],
              [17.05567467500009, 69.36444733300004],
              [16.971364780000044, 69.35651276200008],
              [16.87867272200009, 69.35936107000003],
              [16.87867272200009, 69.36619700700004],
              [16.893321160000085, 69.36579010600008],
              [16.90723717500009, 69.36859772300005],
              [16.933929884000065, 69.37986888200004],
              [16.930918816000087, 69.38377513200004],
              [16.926524285000085, 69.39354075700004],
              [16.93848717500009, 69.39838288000004],
              [16.949880405000044, 69.39801666900007],
              [16.97901451900009, 69.39227936400005],
              [16.991058790000068, 69.38715241100005],
              [16.998220248000052, 69.38605377800008],
              [17.004242384000065, 69.38833242400005],
              [17.014496290000068, 69.39809804900005],
              [17.021739129000082, 69.40033600500004],
              [17.039073113000086, 69.39838288000004],
              [17.062510613000086, 69.38914622600004],
              [17.07667076900009, 69.38605377800008],
              [17.094981316000087, 69.38735586100006],
              [17.124847852000073, 69.39777252800008],
              [17.14193769600007, 69.40033600500004],
              [17.276052280000044, 69.39354075700004],
              [17.368418816000087, 69.36688873900005],
              [17.39942467500009, 69.36619700700004],
              [17.389414910000085, 69.38043854400007],
              [17.370616082000083, 69.38703034100007],
              [17.33057701900009, 69.39354075700004],
              [17.29623457100007, 69.41136302300004],
              [17.28223717500009, 69.41400788000004],
              [17.44662519600007, 69.41429271000004],
              [17.49577884200005, 69.42829010600008],
              [17.325450066000087, 69.43943919500003],
              [17.242930535000085, 69.45473867400005],
              [17.18653405000009, 69.50275299700007],
              [17.22559655000009, 69.50096263200004],
              [17.246429884000065, 69.49603913000004],
              [17.26343834700009, 69.47842031500005],
              [17.281586134000065, 69.46991608300004],
              [17.302012566000087, 69.46352773600006],
              [17.316254102000073, 69.46181875200006],
              [17.30795332100007, 69.47711823100008],
              [17.30323326900009, 69.48224518400008],
              [17.37273196700005, 69.47662995000007],
              [17.392100457000083, 69.48224518400008],
              [17.36817467500009, 69.49079010600008],
              [17.32667076900009, 69.51772695500006],
              [17.30323326900009, 69.52326080900008],
              [17.317149285000085, 69.53497955900008],
              [17.343272332000083, 69.53754303600005],
              [17.371755405000044, 69.53388092700004],
              [17.40479576900009, 69.52265045800004],
              [17.42090905000009, 69.51951732000003],
              [17.450368686000047, 69.51703522300005],
              [17.46143639400009, 69.51373932500007],
              [17.478037957000083, 69.49921295800004],
              [17.488536004000082, 69.49591705900008],
              [17.511973504000082, 69.49437083500004],
              [17.53093509200005, 69.49013906500005],
              [17.58301842500009, 69.46796295800004],
              [17.60132897200009, 69.46369049700007],
              [17.645274285000085, 69.46181875200006],
              [17.645274285000085, 69.46865469000005],
              [17.616465691000087, 69.47606028900003],
              [17.60287519600007, 69.48212311400005],
              [17.590668165000068, 69.48969147300005],
              [17.584727410000085, 69.49713776200008],
              [17.57162519600007, 69.51874420800004],
              [17.566416863000086, 69.52326080900008],
              [17.49512780000009, 69.54059479400007],
              [17.474782748000052, 69.55296458500004],
              [17.46851647200009, 69.55988190300008],
              [17.460215691000087, 69.57168203300006],
              [17.469004754000082, 69.57925039300005],
              [17.47364342500009, 69.58661530200004],
              [17.473480665000068, 69.59345123900005],
              [17.467621290000068, 69.59955475500004],
              [17.516856316000087, 69.59699127800008],
              [17.553965691000087, 69.57485586100006],
              [17.617930535000085, 69.51703522300005],
              [17.632090691000087, 69.51284414300005],
              [17.65788821700005, 69.50849030200004],
              [17.68262780000009, 69.50926341400003],
              [17.693614129000082, 69.52016836100006],
              [17.68921959700009, 69.52968984600005],
              [17.670095248000052, 69.53196849200003],
              [17.66578209700009, 69.54059479400007],
              [17.664724155000044, 69.55076732000003],
              [17.65984134200005, 69.56924062700006],
              [17.658946160000085, 69.57786692900004],
              [17.656993035000085, 69.58466217700004],
              [17.65365644600007, 69.58958567900004],
              [17.653005405000044, 69.59414297100005],
              [17.658946160000085, 69.59955475500004],
              [17.673838738000086, 69.60346100500004],
              [17.687754754000082, 69.59951406500005],
              [17.699229363000086, 69.59198639500005],
              [17.707367384000065, 69.58535390800006],
              [17.73568769600007, 69.55170319200005],
              [17.753103061000047, 69.54059479400007],
              [17.772227410000085, 69.54779694200005],
              [17.79981530000009, 69.57510000200006],
              [17.81771894600007, 69.58710358300004],
              [17.837412957000083, 69.59210846600007],
              [17.85914147200009, 69.58673737200007],
              [17.873871290000068, 69.57314687700006],
              [17.892832879000082, 69.53685130400004],
              [17.883067254000082, 69.52704498900005],
              [17.861338738000086, 69.51630280200004],
              [17.85132897200009, 69.50958893400008],
              [17.844574415000068, 69.50250885600008],
              [17.84229576900009, 69.49774811400005],
              [17.841075066000087, 69.49213288000004],
              [17.83765709700009, 69.48224518400008],
              [17.82471764400009, 69.46576569200005],
              [17.82276451900009, 69.45750560100004],
              [17.830821160000085, 69.44814687700006],
              [17.844981316000087, 69.44521719000005],
              [17.857676629000082, 69.45233795800004],
              [17.875254754000082, 69.47235748900005],
              [17.882985873000052, 69.48948802300004],
              [17.891368035000085, 69.49872467700004],
              [17.91773522200009, 69.50592682500007],
              [17.93458092500009, 69.52008698100008],
              [17.944102410000085, 69.52326080900008],
              [17.972666863000086, 69.52000560100004],
              [18.05054772200009, 69.49591705900008],
              [18.039073113000086, 69.48476797100005],
              [18.02116946700005, 69.48102448100008],
              [17.982269727000073, 69.48224518400008],
              [17.99390709700009, 69.46283600500004],
              [17.984385613000086, 69.44961172100005],
              [17.940684441000087, 69.42829010600008],
              [17.982269727000073, 69.41315338700008],
              [18.002289259000065, 69.40997955900008],
              [18.015798373000052, 69.42084381700005],
              [18.010020379000082, 69.43305084800005],
              [18.024668816000087, 69.44086334800005],
              [18.04859459700009, 69.44293854400007],
              [18.07081139400009, 69.43793366100005],
            ],
          ],
          [
            [
              [18.99903405000009, 69.82859935100004],
              [19.019704623000052, 69.81415436400005],
              [19.044200066000087, 69.80215078300006],
              [19.060801629000082, 69.78705475500004],
              [19.057383660000085, 69.76341380400004],
              [19.033457879000082, 69.74371979400007],
              [18.969899936000047, 69.73346588700008],
              [18.91456139400009, 69.69904205900008],
              [18.877289259000065, 69.69220612200007],
              [18.838552280000044, 69.68939850500004],
              [18.803477410000085, 69.68154531500005],
              [18.794118686000047, 69.67560455900008],
              [18.782725457000083, 69.66567617400005],
              [18.77320397200009, 69.65509674700007],
              [18.76929772200009, 69.64671458500004],
              [18.77702884200005, 69.63544342700004],
              [18.793304884000065, 69.63165924700007],
              [18.81226647200009, 69.62938060100004],
              [18.82781009200005, 69.62287018400008],
              [18.83643639400009, 69.60431549700007],
              [18.822927280000044, 69.59072500200006],
              [18.76929772200009, 69.57168203300006],
              [18.731944207000083, 69.56533437700006],
              [18.62598717500009, 69.57786692900004],
              [18.614024285000085, 69.57477448100008],
              [18.579600457000083, 69.56110260600008],
              [18.560394727000073, 69.55805084800005],
              [18.485606316000087, 69.55857982000003],
              [18.261973504000082, 69.53058502800008],
              [18.194021030000044, 69.53070709800005],
              [18.168711785000085, 69.54043203300006],
              [18.12826582100007, 69.56492747600004],
              [18.10523522200009, 69.57168203300006],
              [18.04786217500009, 69.57200755400004],
              [18.02084394600007, 69.57664622600004],
              [17.995371941000087, 69.59210846600007],
              [18.00554446700005, 69.60065338700008],
              [18.026133660000085, 69.61420319200005],
              [18.037445509000065, 69.61945221600007],
              [18.034353061000047, 69.62323639500005],
              [18.029470248000052, 69.63312409100007],
              [18.04070071700005, 69.63226959800005],
              [18.05014082100007, 69.63051992400005],
              [18.069590691000087, 69.62445709800005],
              [18.080902540000068, 69.62274811400005],
              [18.090993686000047, 69.62494538000004],
              [18.111989780000044, 69.63312409100007],
              [18.135020379000082, 69.63694896000004],
              [18.23682701900009, 69.62929922100005],
              [18.261892123000052, 69.62164948100008],
              [18.269053582000083, 69.61737702000005],
              [18.282725457000083, 69.60578034100007],
              [18.27906334700009, 69.60455963700008],
              [18.276052280000044, 69.59967682500007],
              [18.278086785000085, 69.59442780200004],
              [18.290212436000047, 69.59210846600007],
              [18.29737389400009, 69.59540436400005],
              [18.31348717500009, 69.60952383000006],
              [18.324229363000086, 69.61261627800008],
              [18.322276238000086, 69.61835358300004],
              [18.34351647200009, 69.61884186400005],
              [18.354665561000047, 69.62287018400008],
              [18.364512566000087, 69.62824127800008],
              [18.38917076900009, 69.63458893400008],
              [18.40007571700005, 69.64057038000004],
              [18.324229363000086, 69.63312409100007],
              [18.304535352000073, 69.63426341400003],
              [18.291026238000086, 69.63898346600007],
              [18.18653405000009, 69.70880768400008],
              [18.214366082000083, 69.71417877800008],
              [18.31690514400009, 69.70880768400008],
              [18.310720248000052, 69.70880768400008],
              [18.35320071700005, 69.70482005400004],
              [18.478526238000086, 69.70880768400008],
              [18.610850457000083, 69.69281647300005],
              [18.632823113000086, 69.70197174700007],
              [18.593923373000052, 69.71092357000003],
              [18.38917076900009, 69.71991608300004],
              [18.351817254000082, 69.72992584800005],
              [18.34473717500009, 69.74982330900008],
              [18.326914910000085, 69.76544830900008],
              [18.334727410000085, 69.78095123900005],
              [18.35678144600007, 69.79287344000005],
              [18.382334832000083, 69.79759349200003],
              [18.394867384000065, 69.79608795800004],
              [18.403086785000085, 69.79197825700004],
              [18.419932488000086, 69.78050364800004],
              [18.43653405000009, 69.77631256700005],
              [18.46648196700005, 69.78001536700003],
              [18.481944207000083, 69.77708567900004],
              [18.48609459700009, 69.76898834800005],
              [18.481944207000083, 69.75885651200008],
              [18.483083530000044, 69.75096263200004],
              [18.50245201900009, 69.74982330900008],
              [18.513682488000086, 69.75409577000005],
              [18.521006707000083, 69.76215241100005],
              [18.533213738000086, 69.78050364800004],
              [18.556895379000082, 69.79637278900003],
              [18.585134311000047, 69.80329010600008],
              [18.653168165000068, 69.80438873900005],
              [18.641286655000044, 69.75560130400004],
              [18.663259311000047, 69.71295807500007],
              [18.707367384000065, 69.68683502800008],
              [18.762461785000085, 69.68773021000004],
              [18.742198113000086, 69.69456614800004],
              [18.73682701900009, 69.70600006700005],
              [18.740896030000044, 69.72028229400007],
              [18.756683790000068, 69.75189850500004],
              [18.789805535000085, 69.78388092700004],
              [18.77442467500009, 69.79559967700004],
              [18.688649936000047, 69.83551666900007],
              [18.674082879000082, 69.84715403900003],
              [18.666840040000068, 69.85968659100007],
              [18.678884311000047, 69.88605377800008],
              [18.717946811000047, 69.88165924700007],
              [18.763845248000052, 69.86981842700004],
              [18.79664147200009, 69.87327708500004],
              [18.78296959700009, 69.87954336100006],
              [18.801524285000085, 69.88739655200004],
              [18.82203209700009, 69.88605377800008],
              [18.841644727000073, 69.87799713700008],
              [18.858164910000085, 69.86587148600006],
              [18.849131707000083, 69.86147695500006],
              [18.844493035000085, 69.85691966400003],
              [18.83765709700009, 69.84540436400005],
              [18.85914147200009, 69.84438711100006],
              [18.898448113000086, 69.84808991100005],
              [18.98601321700005, 69.83380768400008],
              [18.99903405000009, 69.82859935100004],
            ],
          ],
          [
            [
              [21.667979363000086, 69.94839101800005],
              [21.685069207000083, 69.95311107000003],
              [21.701996290000068, 69.95477936400005],
              [21.719086134000065, 69.95319245000007],
              [21.736175977000073, 69.94839101800005],
              [21.729746941000087, 69.93846263200004],
              [21.719899936000047, 69.93414948100008],
              [21.70801842500009, 69.93183014500005],
              [21.69581139400009, 69.92792389500005],
              [21.685883009000065, 69.93024323100008],
              [21.677907748000052, 69.93439362200007],
              [21.671722852000073, 69.94041575700004],
              [21.667979363000086, 69.94839101800005],
            ],
          ],
          [
            [
              [19.90015709700009, 70.01675039300005],
              [19.919769727000073, 70.02423737200007],
              [19.947927280000044, 70.02680084800005],
              [19.976084832000083, 70.02435944200005],
              [19.99586022200009, 70.01675039300005],
              [19.949961785000085, 70.00971100500004],
              [19.916351759000065, 70.01146067900004],
              [19.908213738000086, 70.01361725500004],
              [19.90015709700009, 70.01675039300005],
            ],
          ],
          [
            [
              [20.958832227000073, 70.00307851800005],
              [21.09937584700009, 70.01048411700003],
              [20.980723504000082, 69.98163483300004],
              [20.975352410000085, 69.96271393400008],
              [20.94044030000009, 69.94696686400005],
              [20.89193769600007, 69.93797435100004],
              [20.842621290000068, 69.93781159100007],
              [20.80518639400009, 69.94839101800005],
              [20.775563998000052, 69.97211334800005],
              [20.761729363000086, 69.98761627800008],
              [20.760508660000085, 69.99966054900005],
              [20.783539259000065, 70.02423737200007],
              [20.802012566000087, 70.03750234600005],
              [20.824392123000052, 70.04295482000003],
              [20.85987389400009, 70.04401276200008],
              [20.886241082000083, 70.03758372600004],
              [20.93531334700009, 70.00942617400005],
              [20.958832227000073, 70.00307851800005],
            ],
          ],
          [
            [
              [21.041026238000086, 70.06134674700007],
              [21.04664147200009, 70.03912995000007],
              [21.02003014400009, 70.02814362200007],
              [20.955332879000082, 70.02411530200004],
              [20.966319207000083, 70.03497955900008],
              [20.99187259200005, 70.05145905200004],
              [21.02051842500009, 70.06354401200008],
              [21.041026238000086, 70.06134674700007],
            ],
          ],
          [
            [
              [19.619151238000086, 70.01675039300005],
              [19.63526451900009, 70.02073802300004],
              [19.652598504000082, 70.02142975500004],
              [19.669444207000083, 70.01732005400004],
              [19.684825066000087, 70.00678131700005],
              [19.683116082000083, 69.98578522300005],
              [19.64747155000009, 69.96995677300004],
              [19.540212436000047, 69.95160553600005],
              [19.53288821700005, 69.94627513200004],
              [19.523448113000086, 69.93475983300004],
              [19.521494988000086, 69.93048737200007],
              [19.519379102000073, 69.91962311400005],
              [19.51661217500009, 69.91425202000005],
              [19.508636915000068, 69.90778229400007],
              [19.492198113000086, 69.90176015800006],
              [19.485606316000087, 69.89720286700003],
              [19.473317905000044, 69.88666413000004],
              [19.43409264400009, 69.86957428600005],
              [19.42286217500009, 69.86123281500005],
              [19.41732832100007, 69.85301341400003],
              [19.413340691000087, 69.84544505400004],
              [19.40674889400009, 69.83856842700004],
              [19.37476647200009, 69.82330963700008],
              [19.333994988000086, 69.81264883000006],
              [19.12159264400009, 69.78782786700003],
              [19.08838951900009, 69.80101146000004],
              [19.05567467500009, 69.83136627800008],
              [19.043630405000044, 69.83856842700004],
              [18.843028191000087, 69.90330638200004],
              [18.764333530000044, 69.91494375200006],
              [18.73340905000009, 69.93134186400005],
              [18.728851759000065, 69.94782135600008],
              [18.76929772200009, 69.95526764500005],
              [18.865244988000086, 69.94220612200007],
              [18.883636915000068, 69.94537995000007],
              [18.914317254000082, 69.96206289300005],
              [18.933767123000052, 69.96954987200007],
              [18.875661655000044, 69.97313060100004],
              [18.84473717500009, 69.98212311400005],
              [18.83139082100007, 69.99966054900005],
              [18.844899936000047, 70.01504140800006],
              [18.875824415000068, 70.02423737200007],
              [18.933767123000052, 70.03034088700008],
              [18.985606316000087, 70.02411530200004],
              [18.998301629000082, 70.02619049700007],
              [19.017832879000082, 70.03514232000003],
              [19.030039910000085, 70.03717682500007],
              [19.04346764400009, 70.03408437700006],
              [19.050791863000086, 70.02716705900008],
              [19.054860873000052, 70.02016836100006],
              [19.057383660000085, 70.01675039300005],
              [19.07390384200005, 70.01626211100006],
              [19.119395379000082, 70.03034088700008],
              [19.10206139400009, 70.04157135600008],
              [19.08253014400009, 70.05048248900005],
              [19.067556186000047, 70.06146881700005],
              [19.06421959700009, 70.07880280200004],
              [19.08529707100007, 70.07225169500003],
              [19.10206139400009, 70.07046133000006],
              [19.118662957000083, 70.07273997600004],
              [19.208181186000047, 70.09857819200005],
              [19.226735873000052, 70.09357330900008],
              [19.22624759200005, 70.08421458500004],
              [19.223399285000085, 70.07367584800005],
              [19.23487389400009, 70.06513092700004],
              [19.255869988000086, 70.06732819200005],
              [19.27670332100007, 70.07807038000004],
              [19.299082879000082, 70.08584219000005],
              [19.324880405000044, 70.07880280200004],
              [19.308441602000073, 70.06582265800006],
              [19.294200066000087, 70.04755280200004],
              [19.29232832100007, 70.03119538000004],
              [19.339691602000073, 70.01772695500006],
              [19.392588738000086, 69.99188873900005],
              [19.42042076900009, 69.98940664300005],
              [19.418630405000044, 70.01365794500003],
              [19.43848717500009, 70.03339264500005],
              [19.46810957100007, 70.04661692900004],
              [19.53565514400009, 70.05731842700004],
              [19.556895379000082, 70.05707428600005],
              [19.574961785000085, 70.04775625200006],
              [19.58253014400009, 70.03384023600006],
              [19.578135613000086, 70.02358633000006],
              [19.57129967500009, 70.01422760600008],
              [19.57129967500009, 70.00307851800005],
              [19.582286004000082, 69.99323151200008],
              [19.594493035000085, 69.99795156500005],
              [19.60710696700005, 70.00873444200005],
              [19.619151238000086, 70.01675039300005],
            ],
          ],
          [
            [
              [20.79151451900009, 70.09243398600006],
              [20.795176629000082, 70.07664622600004],
              [20.794200066000087, 70.06781647300005],
              [20.78679446700005, 70.06256745000007],
              [20.771006707000083, 70.05760325700004],
              [20.747325066000087, 70.05597565300008],
              [20.724864129000082, 70.06110260600008],
              [20.704925977000073, 70.06793854400007],
              [20.68848717500009, 70.07135651200008],
              [20.67514082100007, 70.06826406500005],
              [20.660411004000082, 70.05459219000005],
              [20.647227410000085, 70.05145905200004],
              [20.636241082000083, 70.05027903900003],
              [20.614512566000087, 70.04515208500004],
              [20.60254967500009, 70.04401276200008],
              [20.588145379000082, 70.04596588700008],
              [20.588633660000085, 70.05093008000006],
              [20.595225457000083, 70.05776601800005],
              [20.599131707000083, 70.06513092700004],
              [20.60254967500009, 70.08637116100005],
              [20.601084832000083, 70.09715403900003],
              [20.59229576900009, 70.10602448100008],
              [20.576914910000085, 70.10956452000005],
              [20.564707879000082, 70.10472239800004],
              [20.55958092500009, 70.09373607000003],
              [20.56495201900009, 70.07880280200004],
              [20.517832879000082, 70.07880280200004],
              [20.52084394600007, 70.06232330900008],
              [20.506683790000068, 70.05833567900004],
              [20.468760613000086, 70.06513092700004],
              [20.45093834700009, 70.06476471600007],
              [20.431651238000086, 70.06806061400005],
              [20.41382897200009, 70.07493724200003],
              [20.399912957000083, 70.08559804900005],
              [20.391286655000044, 70.09662506700005],
              [20.389903191000087, 70.10268789300005],
              [20.392100457000083, 70.10960521000004],
              [20.39356530000009, 70.12348053600005],
              [20.399668816000087, 70.15037669500003],
              [20.41570071700005, 70.17153554900005],
              [20.437754754000082, 70.18667226800005],
              [20.46257571700005, 70.19546133000006],
              [20.525401238000086, 70.20294830900008],
              [20.54460696700005, 70.20848216400003],
              [20.545176629000082, 70.21149323100008],
              [20.54590905000009, 70.21792226800005],
              [20.547699415000068, 70.22479889500005],
              [20.55128014400009, 70.22955963700008],
              [20.561371290000068, 70.23322174700007],
              [20.58765709700009, 70.23615143400008],
              [20.733897332000083, 70.23672109600005],
              [20.777191602000073, 70.22955963700008],
              [20.808848504000082, 70.22036367400005],
              [20.824392123000052, 70.20986562700006],
              [20.824229363000086, 70.19456614800004],
              [20.80827884200005, 70.17121002800008],
              [20.789317254000082, 70.15314362200007],
              [20.780772332000083, 70.14248281500005],
              [20.775563998000052, 70.12457916900007],
              [20.77247155000009, 70.12010325700004],
              [20.771006707000083, 70.11554596600007],
              [20.774180535000085, 70.10952383000006],
              [20.789398634000065, 70.09373607000003],
              [20.79151451900009, 70.09243398600006],
            ],
          ],
          [
            [
              [19.98218834700009, 70.14704010600008],
              [20.111582879000082, 70.12018463700008],
              [20.15406334700009, 70.12034739800004],
              [20.15406334700009, 70.11286041900007],
              [20.054209832000083, 70.10150788000004],
              [20.023692254000082, 70.09243398600006],
              [20.036387566000087, 70.08307526200008],
              [20.03101647200009, 70.07538483300004],
              [20.016856316000087, 70.06928131700005],
              [19.97820071700005, 70.06012604400007],
              [19.819509311000047, 70.06024811400005],
              [19.776133660000085, 70.06732819200005],
              [19.74935957100007, 70.08559804900005],
              [19.747569207000083, 70.09345123900005],
              [19.74935957100007, 70.12348053600005],
              [19.747569207000083, 70.13593170800004],
              [19.742442254000082, 70.14069245000007],
              [19.735036655000044, 70.14362213700008],
              [19.725840691000087, 70.15045807500007],
              [19.701508009000065, 70.18121979400007],
              [19.692149285000085, 70.18862539300005],
              [19.67351321700005, 70.19855377800008],
              [19.664073113000086, 70.20538971600007],
              [19.633067254000082, 70.21930573100008],
              [19.559336785000085, 70.23118724200003],
              [19.537119988000086, 70.25006745000007],
              [19.54932701900009, 70.25653717700004],
              [19.563161655000044, 70.25633372600004],
              [19.591644727000073, 70.25006745000007],
              [19.591644727000073, 70.25690338700008],
              [19.58838951900009, 70.26837799700007],
              [19.615570509000065, 70.27924225500004],
              [19.677744988000086, 70.29043203300006],
              [19.689707879000082, 70.28534577000005],
              [19.69507897200009, 70.27362702000005],
              [19.69776451900009, 70.26019928600005],
              [19.701508009000065, 70.25006745000007],
              [19.715179884000065, 70.23875560100004],
              [19.733246290000068, 70.22992584800005],
              [19.752614780000044, 70.22418854400007],
              [19.770192905000044, 70.22211334800005],
              [19.790537957000083, 70.21059804900005],
              [19.801524285000085, 70.18740469000005],
              [19.815603061000047, 70.16974518400008],
              [19.844981316000087, 70.17495351800005],
              [19.853037957000083, 70.18414948100008],
              [19.865977410000085, 70.21043528900003],
              [19.872894727000073, 70.21588776200008],
              [19.891368035000085, 70.21385325700004],
              [19.94117272200009, 70.19546133000006],
              [19.930511915000068, 70.17670319200005],
              [19.938161655000044, 70.16376373900005],
              [19.95753014400009, 70.15460846600007],
              [19.98218834700009, 70.14704010600008],
            ],
          ],
          [
            [
              [22.92237389400009, 70.30467357000003],
              [22.94304446700005, 70.30023834800005],
              [22.965993686000047, 70.29783763200004],
              [22.988536004000082, 70.29295482000003],
              [23.00831139400009, 70.28074778900003],
              [23.019053582000083, 70.26496002800008],
              [23.016286655000044, 70.25429922100005],
              [23.001475457000083, 70.24917226800005],
              [22.731700066000087, 70.25690338700008],
              [22.445160352000073, 70.29144928600005],
              [22.38135826900009, 70.32575104400007],
              [22.373708530000044, 70.33197663000004],
              [22.37867272200009, 70.34699127800008],
              [22.397634311000047, 70.35781484600005],
              [22.421071811000047, 70.36176178600005],
              [22.43921959700009, 70.35618724200003],
              [22.453379754000082, 70.34564850500004],
              [22.469574415000068, 70.33730703300006],
              [22.504649285000085, 70.32514069200005],
              [22.475352410000085, 70.34772370000007],
              [22.469899936000047, 70.35309479400007],
              [22.467946811000047, 70.36823151200008],
              [22.47364342500009, 70.38027578300006],
              [22.485118035000085, 70.38446686400005],
              [22.52979576900009, 70.36420319200005],
              [22.57520592500009, 70.38202545800004],
              [22.600271030000044, 70.36676666900007],
              [22.605723504000082, 70.38007233300004],
              [22.61890709700009, 70.38703034100007],
              [22.632985873000052, 70.38540273600006],
              [22.64112389400009, 70.37299225500004],
              [22.64812259200005, 70.37299225500004],
              [22.65088951900009, 70.38629791900007],
              [22.660899285000085, 70.39557526200008],
              [22.674652540000068, 70.39887116100005],
              [22.688975457000083, 70.39411041900007],
              [22.694509311000047, 70.38556549700007],
              [22.69434655000009, 70.36294179900005],
              [22.696462436000047, 70.35309479400007],
              [22.714366082000083, 70.33698151200008],
              [22.729746941000087, 70.34463125200006],
              [22.737152540000068, 70.36505768400008],
              [22.730479363000086, 70.38719310100004],
              [22.75635826900009, 70.39496491100005],
              [22.780528191000087, 70.38621653900003],
              [22.79859459700009, 70.36684804900005],
              [22.80567467500009, 70.34223053600005],
              [22.827972852000073, 70.33372630400004],
              [22.95639082100007, 70.32514069200005],
              [22.946462436000047, 70.32298411700003],
              [22.937347852000073, 70.31879303600005],
              [22.929209832000083, 70.31264883000006],
              [22.92237389400009, 70.30467357000003],
            ],
          ],
          [
            [
              [23.65601647200009, 70.50332265800006],
              [23.649180535000085, 70.50031159100007],
              [23.635508660000085, 70.49241771000004],
              [23.628103061000047, 70.48965078300006],
              [23.635996941000087, 70.48334381700005],
              [23.65333092500009, 70.47313060100004],
              [23.662282748000052, 70.46979401200008],
              [23.63412519600007, 70.43748607000003],
              [23.592539910000085, 70.41526927300004],
              [23.408376498000052, 70.35309479400007],
              [23.319021030000044, 70.34210846600007],
              [23.292246941000087, 70.33197663000004],
              [23.313649936000047, 70.33274974200003],
              [23.339040561000047, 70.33087799700007],
              [23.363129102000073, 70.32615794500003],
              [23.381602410000085, 70.31834544500003],
              [23.216319207000083, 70.28278229400007],
              [23.155039910000085, 70.27732982000003],
              [23.104665561000047, 70.28327057500007],
              [23.082041863000086, 70.30166250200006],
              [23.087412957000083, 70.32835521000004],
              [23.114105665000068, 70.35932038000004],
              [23.126963738000086, 70.37079498900005],
              [23.135427280000044, 70.38532135600008],
              [23.138194207000083, 70.40070221600007],
              [23.134613477000073, 70.41453685100004],
              [23.075043165000068, 70.36005280200004],
              [23.038910352000073, 70.34096914300005],
              [23.00831139400009, 70.34943268400008],
              [22.995371941000087, 70.35716380400004],
              [22.98023522200009, 70.35883209800005],
              [22.96452884200005, 70.35809967700004],
              [22.949554884000065, 70.35932038000004],
              [22.93913821700005, 70.36334870000007],
              [22.871348504000082, 70.40228913000004],
              [22.85401451900009, 70.40770091400003],
              [22.880869988000086, 70.41412995000007],
              [22.940114780000044, 70.40704987200007],
              [22.96387780000009, 70.42137278900003],
              [22.91968834700009, 70.43089427300004],
              [22.90870201900009, 70.43500397300005],
              [22.895355665000068, 70.44611237200007],
              [22.897227410000085, 70.45099518400008],
              [22.92237389400009, 70.45612213700008],
              [22.93653405000009, 70.46100495000007],
              [22.943695509000065, 70.46238841400003],
              [22.952972852000073, 70.46295807500007],
              [22.95834394600007, 70.46503327000005],
              [22.96143639400009, 70.46967194200005],
              [22.96387780000009, 70.47662995000007],
              [22.97242272200009, 70.47724030200004],
              [22.99122155000009, 70.47597890800006],
              [22.998057488000086, 70.47662995000007],
              [23.00367272200009, 70.48065827000005],
              [23.01303144600007, 70.49315013200004],
              [23.01856530000009, 70.49705638200004],
              [23.124278191000087, 70.52057526200008],
              [23.141449415000068, 70.51414622600004],
              [23.151052280000044, 70.49835846600007],
              [23.17359459700009, 70.50275299700007],
              [23.200694207000083, 70.51373932500007],
              [23.223399285000085, 70.51764557500007],
              [23.223399285000085, 70.52383047100005],
              [23.20093834700009, 70.52899811400005],
              [23.18100019600007, 70.53851959800005],
              [23.17554772200009, 70.54759349200003],
              [23.19629967500009, 70.55170319200005],
              [23.214366082000083, 70.55044179900005],
              [23.23959394600007, 70.54564036700003],
              [23.262054884000065, 70.53611888200004],
              [23.271739129000082, 70.52069733300004],
              [23.26734459700009, 70.50608958500004],
              [23.260427280000044, 70.49184804900005],
              [23.260915561000047, 70.48090241100005],
              [23.278575066000087, 70.47662995000007],
              [23.291270379000082, 70.48383209800005],
              [23.310801629000082, 70.51874420800004],
              [23.326426629000082, 70.53123607000003],
              [23.304698113000086, 70.53510163000004],
              [23.298350457000083, 70.54315827000005],
              [23.30762780000009, 70.55044179900005],
              [23.333262566000087, 70.55170319200005],
              [23.35328209700009, 70.54682038000004],
              [23.386973504000082, 70.53290436400005],
              [23.408376498000052, 70.53123607000003],
              [23.393809441000087, 70.54205963700008],
              [23.387868686000047, 70.54486725500004],
              [23.41260826900009, 70.56171295800004],
              [23.503754102000073, 70.54498932500007],
              [23.539317254000082, 70.54486725500004],
              [23.515472852000073, 70.56000397300005],
              [23.48926842500009, 70.57086823100008],
              [23.436289910000085, 70.58527252800008],
              [23.441661004000082, 70.59027741100005],
              [23.45167076900009, 70.60150788000004],
              [23.457367384000065, 70.60635000200006],
              [23.39820397200009, 70.61334870000007],
              [23.390961134000065, 70.61798737200007],
              [23.46420332100007, 70.62494538000004],
              [23.484548373000052, 70.62466054900005],
              [23.501475457000083, 70.61660390800006],
              [23.518809441000087, 70.61054108300004],
              [23.556651238000086, 70.61888255400004],
              [23.573496941000087, 70.61318594000005],
              [23.559825066000087, 70.60635000200006],
              [23.568207227000073, 70.59772370000007],
              [23.60132897200009, 70.57904694200005],
              [23.594493035000085, 70.56574127800008],
              [23.586599155000044, 70.55414459800005],
              [23.580739780000044, 70.54295482000003],
              [23.580332879000082, 70.53123607000003],
              [23.591644727000073, 70.51642487200007],
              [23.61109459700009, 70.51215241100005],
              [23.634043816000087, 70.51044342700004],
              [23.65601647200009, 70.50332265800006],
            ],
          ],
          [
            [
              [24.06690514400009, 70.66095612200007],
              [24.065196160000085, 70.64594147300005],
              [24.083262566000087, 70.63597239800004],
              [24.128428582000083, 70.62002187700006],
              [24.101573113000086, 70.58869049700007],
              [24.01221764400009, 70.56777578300006],
              [23.928965691000087, 70.52326080900008],
              [23.867930535000085, 70.51239655200004],
              [23.804209832000083, 70.51333242400005],
              [23.75098717500009, 70.52383047100005],
              [23.737803582000083, 70.53681061400005],
              [23.709808790000068, 70.55825429900005],
              [23.69703209700009, 70.57160065300008],
              [23.69499759200005, 70.57819245000007],
              [23.694021030000044, 70.58759186400005],
              [23.692067905000044, 70.59589264500005],
              [23.686778191000087, 70.59951406500005],
              [23.641774936000047, 70.59951406500005],
              [23.66570071700005, 70.61298248900005],
              [23.68067467500009, 70.62494538000004],
              [23.679535352000073, 70.63629791900007],
              [23.65601647200009, 70.64793528900003],
              [23.67628014400009, 70.65424225500004],
              [23.684336785000085, 70.65892161700003],
              [23.690196160000085, 70.66779205900008],
              [23.642832879000082, 70.68520742400005],
              [23.635508660000085, 70.69204336100006],
              [23.640147332000083, 70.70221588700008],
              [23.651133660000085, 70.70990631700005],
              [23.675954623000052, 70.72304922100005],
              [23.69776451900009, 70.74339427300004],
              [23.709239129000082, 70.74860260600008],
              [23.815684441000087, 70.75116608300004],
              [23.84034264400009, 70.74355703300006],
              [23.830332879000082, 70.73639557500007],
              [23.828379754000082, 70.73029205900008],
              [23.834239129000082, 70.72565338700008],
              [23.847178582000083, 70.72304922100005],
              [23.840179884000065, 70.71670156500005],
              [23.83497155000009, 70.71279531500005],
              [23.828786655000044, 70.71063873900005],
              [23.819183790000068, 70.70937734600005],
              [23.831879102000073, 70.70335521000004],
              [23.843597852000073, 70.70404694200005],
              [23.85515384200005, 70.70734284100007],
              [23.86768639400009, 70.70937734600005],
              [23.96387780000009, 70.70937734600005],
              [23.977793816000087, 70.70693594000005],
              [24.032725457000083, 70.68891022300005],
              [24.04346764400009, 70.68349844000005],
              [24.052256707000083, 70.67719147300005],
              [24.059825066000087, 70.66974518400008],
              [24.06690514400009, 70.66095612200007],
            ],
          ],
          [
            [
              [22.422129754000082, 70.51072825700004],
              [22.40723717500009, 70.51459381700005],
              [22.398692254000082, 70.51398346600007],
              [22.373708530000044, 70.50332265800006],
              [22.34229576900009, 70.49921295800004],
              [22.308929884000065, 70.50336334800005],
              [22.292816602000073, 70.51447174700007],
              [22.312836134000065, 70.53123607000003],
              [22.28565514400009, 70.54157135600008],
              [22.26807701900009, 70.52899811400005],
              [22.243337436000047, 70.48965078300006],
              [22.221446160000085, 70.48065827000005],
              [22.18653405000009, 70.47313060100004],
              [22.154470248000052, 70.47231679900005],
              [22.140879754000082, 70.48285553600005],
              [22.151540561000047, 70.49966054900005],
              [22.160899285000085, 70.51137929900005],
              [22.185557488000086, 70.53465403900003],
              [22.20289147200009, 70.54409414300005],
              [22.24545332100007, 70.55670807500007],
              [22.264414910000085, 70.57160065300008],
              [22.256602410000085, 70.57257721600007],
              [22.237071160000085, 70.57904694200005],
              [22.310557488000086, 70.60150788000004],
              [22.33334394600007, 70.61318594000005],
              [22.099945509000065, 70.60635000200006],
              [22.091644727000073, 70.60419342700004],
              [22.077321811000047, 70.59479401200008],
              [22.068614129000082, 70.59271881700005],
              [22.04070071700005, 70.59357330900008],
              [22.011241082000083, 70.59951406500005],
              [22.02507571700005, 70.61188385600008],
              [22.057383660000085, 70.62449778900003],
              [22.07203209700009, 70.63369375200006],
              [22.00879967500009, 70.63349030200004],
              [21.97706139400009, 70.63751862200007],
              [21.950368686000047, 70.64793528900003],
              [21.986501498000052, 70.66254303600005],
              [22.044200066000087, 70.65985748900005],
              [22.195323113000086, 70.63182200700004],
              [22.221527540000068, 70.63190338700008],
              [22.243337436000047, 70.64052969000005],
              [22.250336134000065, 70.64940013200004],
              [22.251149936000047, 70.65936920800004],
              [22.244476759000065, 70.66836172100005],
              [22.229746941000087, 70.67462799700007],
              [22.265879754000082, 70.67499420800004],
              [22.320567254000082, 70.66128164300005],
              [22.415212436000047, 70.62620677300004],
              [22.415212436000047, 70.63369375200006],
              [22.401866082000083, 70.64740631700005],
              [22.383962436000047, 70.67324453300006],
              [22.373871290000068, 70.69818756700005],
              [22.38453209700009, 70.70937734600005],
              [22.404958530000044, 70.70941803600005],
              [22.41456139400009, 70.70795319200005],
              [22.421153191000087, 70.70294830900008],
              [22.432383660000085, 70.69204336100006],
              [22.44857832100007, 70.68252187700006],
              [22.470225457000083, 70.67658112200007],
              [22.49268639400009, 70.67572663000004],
              [22.51148522200009, 70.68146393400008],
              [22.497894727000073, 70.68935781500005],
              [22.494802280000044, 70.69879791900007],
              [22.501475457000083, 70.70807526200008],
              [22.517588738000086, 70.71556224200003],
              [22.541026238000086, 70.71747467700004],
              [22.56739342500009, 70.71287669500003],
              [22.651540561000047, 70.68768952000005],
              [22.656260613000086, 70.68170807500007],
              [22.64112389400009, 70.67121002800008],
              [22.60482832100007, 70.66034577000005],
              [22.594981316000087, 70.65253327000005],
              [22.60645592500009, 70.64052969000005],
              [22.630869988000086, 70.63593170800004],
              [22.651621941000087, 70.64569733300004],
              [22.67042076900009, 70.65786367400005],
              [22.688975457000083, 70.66095612200007],
              [22.70289147200009, 70.65151601800005],
              [22.707041863000086, 70.63739655200004],
              [22.708262566000087, 70.62230052300004],
              [22.713145379000082, 70.60976797100005],
              [22.724864129000082, 70.60358307500007],
              [22.73210696700005, 70.61115143400008],
              [22.735850457000083, 70.62490469000005],
              [22.736664259000065, 70.63711172100005],
              [22.747894727000073, 70.64740631700005],
              [22.773692254000082, 70.65021393400008],
              [22.826182488000086, 70.64793528900003],
              [22.807790561000047, 70.66323476800005],
              [22.785166863000086, 70.67462799700007],
              [22.792491082000083, 70.69358958500004],
              [22.77784264400009, 70.70429108300004],
              [22.753184441000087, 70.71393463700008],
              [22.730479363000086, 70.72988515800006],
              [22.72437584700009, 70.73696523600006],
              [22.720225457000083, 70.74355703300006],
              [22.722992384000065, 70.74848053600005],
              [22.753916863000086, 70.75177643400008],
              [22.80567467500009, 70.76398346600007],
              [22.796885613000086, 70.75364817900004],
              [22.79200280000009, 70.75039297100005],
              [22.810801629000082, 70.74433014500005],
              [22.851084832000083, 70.74188873900005],
              [22.867198113000086, 70.72988515800006],
              [22.85401451900009, 70.72988515800006],
              [22.85401451900009, 70.72304922100005],
              [22.87240644600007, 70.72284577000005],
              [22.90560957100007, 70.72768789300005],
              [22.923838738000086, 70.72479889500005],
              [22.931488477000073, 70.71662018400008],
              [22.921722852000073, 70.70726146000004],
              [22.89503014400009, 70.69513580900008],
              [22.917816602000073, 70.68512604400007],
              [22.943614129000082, 70.67035553600005],
              [22.969086134000065, 70.66120026200008],
              [22.99073326900009, 70.66779205900008],
              [22.976898634000065, 70.68146393400008],
              [22.997569207000083, 70.68789297100005],
              [23.019867384000065, 70.69208405200004],
              [23.032725457000083, 70.70136139500005],
              [23.025401238000086, 70.72304922100005],
              [23.049571160000085, 70.72247955900008],
              [23.096446160000085, 70.71019114800004],
              [23.120941602000073, 70.70937734600005],
              [23.110606316000087, 70.71417877800008],
              [23.098806186000047, 70.72333405200004],
              [23.09310957100007, 70.73212311400005],
              [23.101410352000073, 70.73602936400005],
              [23.16537519600007, 70.73029205900008],
              [23.182383660000085, 70.73602936400005],
              [23.17318769600007, 70.74070872600004],
              [23.164317254000082, 70.74286530200004],
              [23.144867384000065, 70.74355703300006],
              [23.135427280000044, 70.74551015800006],
              [23.13217207100007, 70.74994538000004],
              [23.131032748000052, 70.75478750200006],
              [23.128428582000083, 70.75779857000003],
              [23.07129967500009, 70.76776764500005],
              [23.052744988000086, 70.77391185100004],
              [23.029958530000044, 70.79083893400008],
              [23.04859459700009, 70.79718659100007],
              [23.10059655000009, 70.79877350500004],
              [23.090668165000068, 70.79954661700003],
              [23.08179772200009, 70.80206940300008],
              [23.07357832100007, 70.80638255400004],
              [23.066254102000073, 70.81244538000004],
              [23.092539910000085, 70.81366608300004],
              [23.137543165000068, 70.79559967700004],
              [23.16187584700009, 70.79132721600007],
              [23.18213951900009, 70.79498932500007],
              [23.187673373000052, 70.80219147300005],
              [23.18018639400009, 70.81061432500007],
              [23.16187584700009, 70.81801992400005],
              [23.16187584700009, 70.82542552300004],
              [23.190114780000044, 70.81574127800008],
              [23.24317467500009, 70.78705475500004],
              [23.271739129000082, 70.77704498900005],
              [23.286631707000083, 70.77594635600008],
              [23.328949415000068, 70.77928294500003],
              [23.340098504000082, 70.78449127800008],
              [23.34034264400009, 70.79848867400005],
              [23.320974155000044, 70.81850820500006],
              [23.323008660000085, 70.82884349200003],
              [23.322276238000086, 70.83812083500004],
              [23.315277540000068, 70.85065338700008],
              [23.31299889400009, 70.86163971600007],
              [23.326426629000082, 70.86640045800004],
              [23.342539910000085, 70.86603424700007],
              [23.358083530000044, 70.86408112200007],
              [23.372325066000087, 70.85895416900007],
              [23.384776238000086, 70.84931061400005],
              [23.396494988000086, 70.84259674700007],
              [23.434825066000087, 70.82880280200004],
              [23.44312584700009, 70.82884349200003],
              [23.44629967500009, 70.81342194200005],
              [23.454925977000073, 70.80483633000006],
              [23.467946811000047, 70.80072663000004],
              [23.48414147200009, 70.79877350500004],
              [23.460459832000083, 70.79083893400008],
              [23.412364129000082, 70.79189687700006],
              [23.387868686000047, 70.78449127800008],
              [23.402679884000065, 70.77777741100005],
              [23.420664910000085, 70.77387116100005],
              [23.457367384000065, 70.77081940300008],
              [23.44662519600007, 70.76752350500004],
              [23.425303582000083, 70.76654694200005],
              [23.41578209700009, 70.76398346600007],
              [23.410980665000068, 70.75922272300005],
              [23.40674889400009, 70.74730052300004],
              [23.40211022200009, 70.74355703300006],
              [23.38526451900009, 70.74335358300004],
              [23.34896894600007, 70.75311920800004],
              [23.333262566000087, 70.75039297100005],
              [23.326833530000044, 70.74192942900004],
              [23.324554884000065, 70.71938711100006],
              [23.319590691000087, 70.70937734600005],
              [23.314626498000052, 70.70868561400005],
              [23.306813998000052, 70.71019114800004],
              [23.297536655000044, 70.71039459800005],
              [23.281586134000065, 70.70209381700005],
              [23.25131269600007, 70.69513580900008],
              [23.266368035000085, 70.68431224200003],
              [23.271739129000082, 70.68146393400008],
              [23.182383660000085, 70.68891022300005],
              [23.166677280000044, 70.69452545800004],
              [23.158539259000065, 70.69415924700007],
              [23.153086785000085, 70.67816803600005],
              [23.14779707100007, 70.67316315300008],
              [23.141286655000044, 70.66974518400008],
              [23.134613477000073, 70.66779205900008],
              [23.142832879000082, 70.65900299700007],
              [23.155039910000085, 70.65582916900007],
              [23.182383660000085, 70.65412018400008],
              [23.16968834700009, 70.64887116100005],
              [23.151866082000083, 70.63226959800005],
              [23.141449415000068, 70.62620677300004],
              [23.120371941000087, 70.62400950700004],
              [23.078868035000085, 70.62986888200004],
              [23.059418165000068, 70.62620677300004],
              [23.114105665000068, 70.61318594000005],
              [23.08887780000009, 70.58624909100007],
              [23.055023634000065, 70.59137604400007],
              [23.018321160000085, 70.60394928600005],
              [22.984548373000052, 70.59951406500005],
              [23.004730665000068, 70.59613678600005],
              [23.008148634000065, 70.58515045800004],
              [22.99781334700009, 70.57282135600008],
              [22.976898634000065, 70.56537506700005],
              [22.952647332000083, 70.56647370000007],
              [22.905772332000083, 70.57835521000004],
              [22.880869988000086, 70.57904694200005],
              [22.880869988000086, 70.57160065300008],
              [22.93604576900009, 70.55853913000004],
              [22.925059441000087, 70.54979075700004],
              [22.91382897200009, 70.54376862200007],
              [22.901621941000087, 70.53998444200005],
              [22.888194207000083, 70.53807200700004],
              [22.870941602000073, 70.53937409100007],
              [22.843760613000086, 70.54930247600004],
              [22.833262566000087, 70.55170319200005],
              [22.82162519600007, 70.54734935100004],
              [22.79981530000009, 70.52814362200007],
              [22.788584832000083, 70.52383047100005],
              [22.772715691000087, 70.52570221600007],
              [22.765147332000083, 70.53107330900008],
              [22.766856316000087, 70.53986237200007],
              [22.77833092500009, 70.55170319200005],
              [22.689300977000073, 70.56366608300004],
              [22.643809441000087, 70.56415436400005],
              [22.634287957000083, 70.55170319200005],
              [22.626800977000073, 70.54486725500004],
              [22.635427280000044, 70.53261953300006],
              [22.631602410000085, 70.52631256700005],
              [22.621348504000082, 70.52411530200004],
              [22.60987389400009, 70.52383047100005],
              [22.60287519600007, 70.52582428600005],
              [22.59546959700009, 70.52895742400005],
              [22.58961022200009, 70.52863190300008],
              [22.584808790000068, 70.51471588700008],
              [22.57911217500009, 70.50910065300008],
              [22.57203209700009, 70.50495026200008],
              [22.56609134200005, 70.50332265800006],
              [22.516774936000047, 70.52781810100004],
              [22.48926842500009, 70.53192780200004],
              [22.477305535000085, 70.50702545800004],
              [22.46843509200005, 70.49485911700003],
              [22.449229363000086, 70.49762604400007],
              [22.43018639400009, 70.50604889500005],
              [22.422129754000082, 70.51072825700004],
            ],
          ],
          [
            [
              [24.073090040000068, 70.96259186400005],
              [24.210215691000087, 70.96698639500005],
              [24.24512780000009, 70.95579661700003],
              [24.210785352000073, 70.95579661700003],
              [24.210785352000073, 70.94599030200004],
              [24.199880405000044, 70.94159577000005],
              [24.183848504000082, 70.94086334800005],
              [24.16928144600007, 70.94212474200003],
              [24.17676842500009, 70.93528880400004],
              [24.15992272200009, 70.92804596600007],
              [24.143321160000085, 70.93024323100008],
              [24.126231316000087, 70.93500397300005],
              [24.10792076900009, 70.93528880400004],
              [24.09734134200005, 70.92942942900004],
              [24.090098504000082, 70.92108795800004],
              [24.079600457000083, 70.91461823100008],
              [24.043142123000052, 70.91412995000007],
              [24.022959832000083, 70.91697825700004],
              [24.005707227000073, 70.92283763200004],
              [23.998708530000044, 70.93158600500004],
              [23.986501498000052, 70.94228750200006],
              [23.909353061000047, 70.95579661700003],
              [23.940196160000085, 70.96405670800004],
              [24.008555535000085, 70.96649811400005],
              [24.038910352000073, 70.97626373900005],
              [24.007090691000087, 70.98309967700004],
              [23.942149285000085, 70.97760651200008],
              [23.909353061000047, 70.98309967700004],
              [23.88575280000009, 70.99616120000007],
              [23.89503014400009, 71.00226471600007],
              [23.95020592500009, 71.00421784100007],
              [23.939626498000052, 71.01178620000007],
              [23.932383660000085, 71.01532623900005],
              [23.92286217500009, 71.01727936400005],
              [23.960134311000047, 71.02863190300008],
              [24.087412957000083, 71.02411530200004],
              [24.07862389400009, 71.01447174700007],
              [24.073090040000068, 71.01105377800008],
              [24.109222852000073, 71.00214264500005],
              [24.187673373000052, 71.00507233300004],
              [24.224619988000086, 70.99677155200004],
              [24.187836134000065, 70.98932526200008],
              [24.106700066000087, 70.99388255400004],
              [24.073090040000068, 70.98309967700004],
              [24.07984459700009, 70.98021067900004],
              [24.082367384000065, 70.97711823100008],
              [24.083994988000086, 70.97345612200007],
              [24.087412957000083, 70.96881745000007],
              [24.073090040000068, 70.96259186400005],
            ],
          ],
          [
            [
              [26.135996941000087, 71.03774648600006],
              [26.18523196700005, 71.04987213700008],
              [26.208506707000083, 71.04962799700007],
              [26.21810957100007, 71.03156159100007],
              [26.206553582000083, 71.01325104400007],
              [26.179942254000082, 71.00267161700003],
              [26.113536004000082, 70.99534739800004],
              [26.105723504000082, 70.99164459800005],
              [26.088145379000082, 70.97968170800004],
              [26.072601759000065, 70.97516510600008],
              [25.968597852000073, 70.97772858300004],
              [25.94825280000009, 70.97492096600007],
              [25.923675977000073, 70.96576569200005],
              [25.900238477000073, 70.96133047100005],
              [25.80054772200009, 70.96259186400005],
              [25.75294030000009, 70.97650788000004],
              [25.731130405000044, 70.97540924700007],
              [25.71851647200009, 70.95579661700003],
              [25.744151238000086, 70.95018138200004],
              [25.75326582100007, 70.94961172100005],
              [25.75326582100007, 70.94212474200003],
              [25.668142123000052, 70.94537995000007],
              [25.600271030000044, 70.93207428600005],
              [25.553396030000044, 70.92788320500006],
              [25.533539259000065, 70.93183014500005],
              [25.51856530000009, 70.94025299700007],
              [25.49195397200009, 70.95917389500005],
              [25.45671634200005, 70.97272370000007],
              [25.416270379000082, 70.98309967700004],
              [25.53809655000009, 71.00336334800005],
              [25.560801629000082, 71.01727936400005],
              [25.490570509000065, 71.02195872600004],
              [25.471527540000068, 71.02777741100005],
              [25.454356316000087, 71.02997467700004],
              [25.32553144600007, 71.00739166900007],
              [25.306976759000065, 71.01105377800008],
              [25.294200066000087, 71.02033112200007],
              [25.292491082000083, 71.02814362200007],
              [25.294444207000083, 71.03603750200006],
              [25.293304884000065, 71.04515208500004],
              [25.347992384000065, 71.06565989800004],
              [25.31381269600007, 71.07245514500005],
              [25.332041863000086, 71.07933177300004],
              [25.35515384200005, 71.08348216400003],
              [25.399180535000085, 71.08612702000005],
              [25.41928144600007, 71.08234284100007],
              [25.43921959700009, 71.07550690300008],
              [25.458832227000073, 71.07200755400004],
              [25.478363477000073, 71.07868073100008],
              [25.472911004000082, 71.08209870000007],
              [25.46420332100007, 71.08954498900005],
              [25.457286004000082, 71.09296295800004],
              [25.47169030000009, 71.10260651200008],
              [25.489024285000085, 71.10175202000005],
              [25.526133660000085, 71.09296295800004],
              [25.553884311000047, 71.09259674700007],
              [25.56031334700009, 71.09003327000005],
              [25.57398522200009, 71.08246491100005],
              [25.592051629000082, 71.07811107000003],
              [25.634776238000086, 71.08038971600007],
              [25.70866946700005, 71.06207916900007],
              [25.71851647200009, 71.05198802300004],
              [25.713226759000065, 71.07070547100005],
              [25.70093834700009, 71.08392975500004],
              [25.683441602000073, 71.09320709800005],
              [25.553396030000044, 71.14077383000006],
              [25.565277540000068, 71.15216705900008],
              [25.60710696700005, 71.14500560100004],
              [25.625743035000085, 71.15102773600006],
              [25.63843834700009, 71.15973541900007],
              [25.653493686000047, 71.16474030200004],
              [25.66732832100007, 71.16526927300004],
              [25.677012566000087, 71.16058991100005],
              [25.68409264400009, 71.14472077000005],
              [25.807383660000085, 71.15444570500006],
              [25.80176842500009, 71.14158763200004],
              [25.783946160000085, 71.11220937700006],
              [25.78370201900009, 71.10293203300006],
              [25.80567467500009, 71.09585195500006],
              [25.85914147200009, 71.11334870000007],
              [25.883067254000082, 71.11347077000005],
              [25.879649285000085, 71.09682851800005],
              [25.897227410000085, 71.09857819200005],
              [25.92123457100007, 71.10675690300008],
              [25.937022332000083, 71.10968659100007],
              [25.960459832000083, 71.10748932500007],
              [26.00635826900009, 71.12518952000005],
              [26.02979576900009, 71.11652252800008],
              [26.03370201900009, 71.08722565300008],
              [25.990977410000085, 71.06704336100006],
              [25.932871941000087, 71.05540599200003],
              [25.889821811000047, 71.05198802300004],
              [25.906504754000082, 71.04450104400007],
              [25.92514082100007, 71.03969961100006],
              [25.944834832000083, 71.03754303600005],
              [25.964366082000083, 71.03774648600006],
              [25.964366082000083, 71.01727936400005],
              [25.939626498000052, 71.01080963700008],
              [25.93018639400009, 71.01105377800008],
              [25.95639082100007, 71.00202057500007],
              [25.99122155000009, 70.99892812700006],
              [26.026215040000068, 71.00014883000006],
              [26.05372155000009, 71.00421784100007],
              [26.074554884000065, 71.01227448100008],
              [26.11573326900009, 71.03343333500004],
              [26.135996941000087, 71.03774648600006],
            ],
          ],
          [
            [
              [12.875336134000065, 66.28563060100004],
              [12.882334832000083, 66.27680084800005],
              [12.886892123000052, 66.25690338700008],
              [12.879242384000065, 66.24339427300004],
              [12.868337436000047, 66.23944733300004],
              [12.85718834700009, 66.23403554900005],
              [12.846039259000065, 66.22626373900005],
              [12.824961785000085, 66.21588776200008],
              [12.81023196700005, 66.22357819200005],
              [12.787282748000052, 66.21727122600004],
              [12.760752800000091, 66.22190989800004],
              [12.750824415000068, 66.23309967700004],
              [12.740977410000085, 66.24164459800005],
              [12.719574415000068, 66.24310944200005],
              [12.705088738000086, 66.24127838700008],
              [12.700205925000091, 66.24323151200008],
              [12.705088738000086, 66.25079987200007],
              [12.714691602000073, 66.25910065300008],
              [12.737559441000087, 66.27057526200008],
              [12.75717207100007, 66.27749258000006],
              [12.792816602000073, 66.29498932500007],
              [12.794200066000087, 66.30036041900007],
              [12.795258009000065, 66.30512116100005],
              [12.793793165000068, 66.31122467700004],
              [12.799978061000047, 66.31195709800005],
              [12.806976759000065, 66.30377838700008],
              [12.81218509200005, 66.29669830900008],
              [12.824392123000052, 66.29901764500005],
              [12.829274936000047, 66.29584381700005],
              [12.83562259200005, 66.29364655200004],
              [12.839366082000083, 66.29311758000006],
              [12.859711134000065, 66.29266998900005],
              [12.867198113000086, 66.29169342700004],
              [12.872894727000073, 66.28823476800005],
              [12.875336134000065, 66.28563060100004],
            ],
          ],
          [
            [
              [12.94076582100007, 66.46019114800004],
              [12.96070397200009, 66.45945872600004],
              [12.96648196700005, 66.45311107000003],
              [12.954112175000091, 66.43309153900003],
              [12.94890384200005, 66.40908437700006],
              [12.938487175000091, 66.39443594000005],
              [12.93100019600007, 66.38934967700004],
              [12.916026238000086, 66.39459870000007],
              [12.907399936000047, 66.39891185100004],
              [12.902354363000086, 66.40485260600008],
              [12.899668816000087, 66.41608307500007],
              [12.891286655000044, 66.40932851800005],
              [12.885996941000087, 66.40167877800008],
              [12.881358269000089, 66.39057038000004],
              [12.884287957000083, 66.37645091400003],
              [12.895192905000044, 66.36041901200008],
              [12.898936394000089, 66.35504791900007],
              [12.877207879000082, 66.35903554900005],
              [12.867930535000085, 66.36347077000005],
              [12.859548373000052, 66.36640045800004],
              [12.848399285000085, 66.37173086100006],
              [12.837901238000086, 66.37079498900005],
              [12.83179772200009, 66.37323639500005],
              [12.827403191000087, 66.37677643400008],
              [12.816661004000082, 66.38108958500004],
              [12.800791863000086, 66.38471100500004],
              [12.810557488000086, 66.38934967700004],
              [12.84310957100007, 66.39842357000003],
              [12.850271030000044, 66.40961334800005],
              [12.835459832000083, 66.42389557500007],
              [12.826426629000082, 66.43622467700004],
              [12.818614129000082, 66.43744538000004],
              [12.817230665000068, 66.44257233300004],
              [12.82943769600007, 66.44733307500007],
              [12.886729363000086, 66.45652903900003],
              [12.896739129000082, 66.45620351800005],
              [12.901621941000087, 66.45311107000003],
              [12.902354363000086, 66.44643789300005],
              [12.906993035000085, 66.44261302300004],
              [12.910817905000044, 66.43716054900005],
              [12.912445509000065, 66.43138255400004],
              [12.919444207000083, 66.43158600500004],
              [12.928233269000089, 66.44204336100006],
              [12.929209832000083, 66.45246002800008],
              [12.928884311000047, 66.45783112200007],
              [12.94076582100007, 66.46019114800004],
            ],
          ],
          [
            [
              [15.295664910000085, 67.94525788000004],
              [15.303965691000087, 67.94505442900004],
              [15.304860873000052, 67.93768952000005],
              [15.289235873000052, 67.92584870000007],
              [15.25367272200009, 67.91657135600008],
              [15.246348504000082, 67.91787344000005],
              [15.242523634000065, 67.91974518400008],
              [15.163096550000091, 67.91071198100008],
              [15.147634311000047, 67.91063060100004],
              [15.119313998000052, 67.91583893400008],
              [15.022634311000047, 67.91889069200005],
              [14.98023522200009, 67.91461823100008],
              [14.972178582000083, 67.91648997600004],
              [14.969086134000065, 67.92523834800005],
              [14.961192254000082, 67.94159577000005],
              [14.965098504000082, 67.95258209800005],
              [14.976898634000065, 67.95913320500006],
              [14.977061394000089, 67.96377187700006],
              [14.97201582100007, 67.97003815300008],
              [14.97820071700005, 67.97186920800004],
              [15.018809441000087, 67.97052643400008],
              [15.038340691000087, 67.96743398600006],
              [15.05209394600007, 67.96824778900003],
              [15.061778191000087, 67.97443268400008],
              [15.069102410000085, 67.98053620000007],
              [15.095957879000082, 67.99384186400005],
              [15.105723504000082, 68.00071849200003],
              [15.11068769600007, 68.00018952000005],
              [15.113617384000065, 67.99485911700003],
              [15.11109459700009, 67.98700592700004],
              [15.106618686000047, 67.98086172100005],
              [15.108897332000083, 67.97622304900005],
              [15.139903191000087, 67.95844147300005],
              [15.162445509000065, 67.95404694200005],
              [15.211599155000044, 67.95123932500007],
              [15.22787519600007, 67.94769928600005],
              [15.231293165000068, 67.94188060100004],
              [15.246592644000089, 67.94171784100007],
              [15.257090691000087, 67.94049713700008],
              [15.262705925000091, 67.93256256700005],
              [15.279307488000086, 67.93976471600007],
              [15.280284050000091, 67.94281647300005],
              [15.295664910000085, 67.94525788000004],
            ],
          ],
          [
            [
              [15.930186394000089, 68.00824616100005],
              [15.93295332100007, 68.00405508000006],
              [15.933604363000086, 67.99701569200005],
              [15.924815300000091, 67.99286530200004],
              [15.883962436000047, 67.98411692900004],
              [15.84115644600007, 67.98371002800008],
              [15.786143425000091, 67.99315013200004],
              [15.728770379000082, 68.01194896000004],
              [15.706228061000047, 68.01235586100006],
              [15.67937259200005, 67.99359772300005],
              [15.661306186000047, 67.98859284100007],
              [15.65211022200009, 67.98720937700006],
              [15.617360873000052, 67.98525625200006],
              [15.523448113000086, 67.98997630400004],
              [15.510264519000089, 67.99282461100006],
              [15.50367272200009, 67.99530670800004],
              [15.49577884200005, 67.99738190300008],
              [15.482432488000086, 68.00263092700004],
              [15.483164910000085, 68.00604889500005],
              [15.495371941000087, 68.00560130400004],
              [15.508474155000044, 68.00800202000005],
              [15.521657748000052, 68.01569245000007],
              [15.535899285000085, 68.02081940300008],
              [15.574066602000073, 68.02558014500005],
              [15.859711134000065, 68.02749258000006],
              [15.891774936000047, 68.01862213700008],
              [15.918711785000085, 68.01422760600008],
              [15.930186394000089, 68.00824616100005],
            ],
          ],
          [
            [
              [15.166188998000052, 67.98676178600005],
              [15.160492384000065, 67.99262116100005],
              [15.159678582000083, 67.99567291900007],
              [15.163340691000087, 68.00055573100008],
              [15.171153191000087, 68.00527578300006],
              [15.176524285000085, 68.01154205900008],
              [15.189463738000086, 68.01898834800005],
              [15.211436394000089, 68.02553945500006],
              [15.220957879000082, 68.03143952000005],
              [15.22201582100007, 68.03725820500006],
              [15.230316602000073, 68.03668854400007],
              [15.240407748000052, 68.02899811400005],
              [15.258067254000082, 68.00975169500003],
              [15.27507571700005, 67.99542877800008],
              [15.286631707000083, 67.97699616100005],
              [15.268239780000044, 67.96698639500005],
              [15.184825066000087, 67.96678294500003],
              [15.173350457000083, 67.97467682500007],
              [15.166188998000052, 67.98676178600005],
            ],
          ],
          [
            [
              [14.996592644000089, 68.90159739800004],
              [14.987559441000087, 68.88467031500005],
              [14.95834394600007, 68.87531159100007],
              [14.901215040000068, 68.87230052300004],
              [14.89226321700005, 68.87335846600007],
              [14.85873457100007, 68.88336823100008],
              [14.843597852000073, 68.88544342700004],
              [14.840098504000082, 68.89166901200008],
              [14.85523522200009, 68.90717194200005],
              [14.854014519000089, 68.91347890800006],
              [14.851898634000065, 68.91876862200007],
              [14.857269727000073, 68.92304108300004],
              [14.873383009000065, 68.92914459800005],
              [14.899668816000087, 68.93085358300004],
              [14.95866946700005, 68.92609284100007],
              [14.982920769000089, 68.91779205900008],
              [14.996592644000089, 68.90159739800004],
            ],
          ],
          [
            [
              [20.70289147200009, 69.88882070500006],
              [20.69825280000009, 69.88401927300004],
              [20.69662519600007, 69.87787506700005],
              [20.70443769600007, 69.86102936400005],
              [20.720713738000086, 69.83710358300004],
              [20.70671634200005, 69.81728750200006],
              [20.660899285000085, 69.80337148600006],
              [20.606211785000085, 69.79376862200007],
              [20.553965691000087, 69.80048248900005],
              [20.532481316000087, 69.81232330900008],
              [20.52670332100007, 69.82111237200007],
              [20.522634311000047, 69.83942291900007],
              [20.529307488000086, 69.85419342700004],
              [20.549001498000052, 69.87335846600007],
              [20.555023634000065, 69.88174062700006],
              [20.558116082000083, 69.89008209800005],
              [20.562754754000082, 69.89598216400003],
              [20.576914910000085, 69.90119049700007],
              [20.598887566000087, 69.90460846600007],
              [20.713145379000082, 69.90961334800005],
              [20.72201582100007, 69.90412018400008],
              [20.722504102000073, 69.89752838700008],
              [20.71656334700009, 69.89423248900005],
              [20.713145379000082, 69.89321523600006],
              [20.70289147200009, 69.88882070500006],
            ],
          ],
          [
            [
              [30.02116946700005, 69.83234284100007],
              [30.099864129000082, 69.83445872600004],
              [30.107432488000086, 69.82859935100004],
              [30.08765709700009, 69.81708405200004],
              [30.05713951900009, 69.80963776200008],
              [29.97624759200005, 69.80027903900003],
              [29.928884311000047, 69.78192780200004],
              [29.905039910000085, 69.77708567900004],
              [29.884287957000083, 69.78143952000005],
              [29.864756707000083, 69.79071686400005],
              [29.846527540000068, 69.79657623900005],
              [29.830088738000086, 69.79075755400004],
              [29.846039259000065, 69.77973053600005],
              [29.832855665000068, 69.76927317900004],
              [29.795746290000068, 69.75600820500006],
              [29.713226759000065, 69.76341380400004],
              [29.735362175000034, 69.79018789300005],
              [29.80128014400009, 69.82070547100005],
              [29.830088738000086, 69.83856842700004],
              [29.80836022200009, 69.86587148600006],
              [29.815928582000083, 69.89105866100005],
              [29.842458530000044, 69.90892161700003],
              [29.877207879000082, 69.91425202000005],
              [29.971039259000065, 69.90204498900005],
              [29.994476759000065, 69.89378489800004],
              [29.99854576900009, 69.88812897300005],
              [29.99659264400009, 69.87433502800008],
              [30.000743035000085, 69.86587148600006],
              [30.00554446700005, 69.86286041900007],
              [30.028575066000087, 69.85285065300008],
              [30.026621941000087, 69.84829336100006],
              [30.023285352000073, 69.83673737200007],
              [30.02116946700005, 69.83234284100007],
            ],
          ],
          [
            [
              [19.813324415000068, 70.00259023600006],
              [19.834239129000082, 69.99481842700004],
              [19.85645592500009, 69.97313060100004],
              [19.834727410000085, 69.94965241100005],
              [19.79232832100007, 69.92519765800006],
              [19.758067254000082, 69.89179108300004],
              [19.720550977000073, 69.86469147300005],
              [19.67709394600007, 69.85521067900004],
              [19.483653191000087, 69.83832428600005],
              [19.434255405000044, 69.84052155200004],
              [19.44271894600007, 69.85846588700008],
              [19.509938998000052, 69.89374420800004],
              [19.53296959700009, 69.91937897300005],
              [19.546885613000086, 69.92548248900005],
              [19.59506269600007, 69.93439362200007],
              [19.692637566000087, 69.96360911700003],
              [19.72624759200005, 69.97919342700004],
              [19.74968509200005, 69.99510325700004],
              [19.774261915000068, 70.00482819200005],
              [19.800303582000083, 70.00433991100005],
              [19.813324415000068, 70.00259023600006],
            ],
          ],
          [
            [
              [18.666758660000085, 70.02757396000004],
              [18.660166863000086, 70.03359609600005],
              [18.65723717500009, 70.04832591400003],
              [18.675303582000083, 70.06427643400008],
              [18.701996290000068, 70.07656484600005],
              [18.712412957000083, 70.08356354400007],
              [18.708262566000087, 70.08649323100008],
              [18.710215691000087, 70.09442780200004],
              [18.703868035000085, 70.10228099200003],
              [18.702403191000087, 70.11139557500007],
              [18.721364780000044, 70.11603424700007],
              [18.75367272200009, 70.11196523600006],
              [18.781260613000086, 70.10199616100005],
              [18.795746290000068, 70.08421458500004],
              [18.799082879000082, 70.06565989800004],
              [18.806488477000073, 70.05931224200003],
              [18.818369988000086, 70.06439850500004],
              [18.828461134000065, 70.07314687700006],
              [18.889821811000047, 70.10614655200004],
              [18.907399936000047, 70.10541413000004],
              [18.920664910000085, 70.09739817900004],
              [18.969086134000065, 70.08429596600007],
              [18.97559655000009, 70.07363515800006],
              [18.959727410000085, 70.06391022300005],
              [18.937754754000082, 70.05341217700004],
              [18.910492384000065, 70.04555898600006],
              [18.836680535000085, 70.03839752800008],
              [18.765147332000083, 70.01919179900005],
              [18.730316602000073, 69.99994538000004],
              [18.718760613000086, 69.99070872600004],
              [18.713226759000065, 69.98916250200006],
              [18.707774285000085, 69.98655833500004],
              [18.70167076900009, 69.98468659100007],
              [18.687836134000065, 69.98822663000004],
              [18.670095248000052, 69.99900950700004],
              [18.67042076900009, 70.01215241100005],
              [18.687510613000086, 70.02216217700004],
              [18.68995201900009, 70.02643463700008],
              [18.666758660000085, 70.02757396000004],
            ],
          ],
          [
            [
              [20.89421634200005, 70.07957591400003],
              [20.861664259000065, 70.06899648600006],
              [20.82553144600007, 70.07306549700007],
              [20.808116082000083, 70.08055247600004],
              [20.798838738000086, 70.09332916900007],
              [20.792979363000086, 70.11904531500005],
              [20.807465040000068, 70.14081452000005],
              [20.83179772200009, 70.15094635600008],
              [20.856944207000083, 70.14492422100005],
              [20.914805535000085, 70.10789622600004],
              [20.915212436000047, 70.09552643400008],
              [20.89421634200005, 70.07957591400003],
            ],
          ],
          [
            [
              [19.53874759200005, 70.09369538000004],
              [19.490570509000065, 70.09393952000005],
              [19.41732832100007, 70.10423411700003],
              [19.358653191000087, 70.11310455900008],
              [19.34310957100007, 70.11839427300004],
              [19.33497155000009, 70.12791575700004],
              [19.340586785000085, 70.14008209800005],
              [19.36654707100007, 70.15420156500005],
              [19.40796959700009, 70.16205475500004],
              [19.44662519600007, 70.15542226800005],
              [19.55209394600007, 70.12091705900008],
              [19.57325280000009, 70.11172109600005],
              [19.569021030000044, 70.10138580900008],
              [19.550303582000083, 70.09491608300004],
              [19.53874759200005, 70.09369538000004],
            ],
          ],
          [
            [
              [19.242360873000052, 70.20087311400005],
              [19.248708530000044, 70.19375234600005],
              [19.252207879000082, 70.18667226800005],
              [19.250173373000052, 70.17413971600007],
              [19.229665561000047, 70.15985748900005],
              [19.225433790000068, 70.15387604400007],
              [19.225433790000068, 70.14915599200003],
              [19.226817254000082, 70.14443594000005],
              [19.22950280000009, 70.13987864800004],
              [19.226817254000082, 70.13495514500005],
              [19.174164259000065, 70.11513906500005],
              [19.140635613000086, 70.11078522300005],
              [19.10287519600007, 70.11688873900005],
              [19.031423373000052, 70.14081452000005],
              [19.00945071700005, 70.14590078300006],
              [18.99586022200009, 70.15208567900004],
              [19.00171959700009, 70.15835195500006],
              [19.045664910000085, 70.16913483300004],
              [19.064463738000086, 70.17047760600008],
              [19.076345248000052, 70.16669342700004],
              [19.087412957000083, 70.15745677300004],
              [19.09864342500009, 70.15790436400005],
              [19.097911004000082, 70.18585846600007],
              [19.114105665000068, 70.19330475500004],
              [19.137380405000044, 70.19721100500004],
              [19.13803144600007, 70.20172760600008],
              [19.11882571700005, 70.20880768400008],
              [19.111989780000044, 70.21625397300005],
              [19.113942905000044, 70.22060781500005],
              [19.11036217500009, 70.22443268400008],
              [19.096364780000044, 70.22992584800005],
              [19.08920332100007, 70.23358795800004],
              [19.09148196700005, 70.23794179900005],
              [19.10515384200005, 70.24115631700005],
              [19.135020379000082, 70.24091217700004],
              [19.14551842500009, 70.23940664300005],
              [19.15202884200005, 70.23745351800005],
              [19.155121290000068, 70.23920319200005],
              [19.155772332000083, 70.24290599200003],
              [19.15984134200005, 70.24835846600007],
              [19.168304884000065, 70.25486888200004],
              [19.17741946700005, 70.25584544500003],
              [19.18490644600007, 70.25340403900003],
              [19.191579623000052, 70.25433991100005],
              [19.197276238000086, 70.25702545800004],
              [19.205902540000068, 70.25429922100005],
              [19.21143639400009, 70.25055573100008],
              [19.230479363000086, 70.23436107000003],
              [19.229665561000047, 70.22085195500006],
              [19.227712436000047, 70.21206289300005],
              [19.242360873000052, 70.20087311400005],
            ],
          ],
          [
            [
              [21.738129102000073, 70.37824127800008],
              [21.79273522200009, 70.35805898600006],
              [21.799164259000065, 70.34711334800005],
              [21.793711785000085, 70.32343170800004],
              [21.76465905000009, 70.28685130400004],
              [21.74903405000009, 70.27440013200004],
              [21.73096764400009, 70.26483795800004],
              [21.714854363000086, 70.25999583500004],
              [21.703135613000086, 70.26178620000007],
              [21.689626498000052, 70.27049388200004],
              [21.676931186000047, 70.28481679900005],
              [21.678884311000047, 70.30735911700003],
              [21.68881269600007, 70.33543528900003],
              [21.68913821700005, 70.35455963700008],
              [21.68458092500009, 70.36383698100008],
              [21.688161655000044, 70.36920807500007],
              [21.69304446700005, 70.37030670800004],
              [21.698008660000085, 70.37107982000003],
              [21.703379754000082, 70.37665436400005],
              [21.70362389400009, 70.38637929900005],
              [21.71225019600007, 70.38922760600008],
              [21.72950280000009, 70.38271719000005],
              [21.738129102000073, 70.37824127800008],
            ],
          ],
          [
            [
              [-7.962554490999935, 71.17487213700008],
              [-7.938465949999909, 71.15656159100007],
              [-7.939320441999939, 71.13641998900005],
              [-7.957875128999945, 71.12010325700004],
              [-7.986805792999917, 71.11347077000005],
              [-8.00890051999994, 71.10521067900004],
              [-8.003000454999949, 71.08576080900008],
              [-7.988189256999931, 71.06313711100006],
              [-7.983021613999938, 71.04515208500004],
              [-8.005970831999946, 71.03253815300008],
              [-8.401356574999909, 70.96259186400005],
              [-8.424956834999932, 70.96515534100007],
              [-8.471994594999956, 70.97553131700005],
              [-8.497547980999911, 70.97626373900005],
              [-8.619740363999938, 70.95807526200008],
              [-8.65811113199993, 70.94489166900007],
              [-8.697417772999927, 70.93813711100006],
              [-8.860340949999909, 70.86298248900005],
              [-8.876942511999914, 70.85773346600007],
              [-8.912180141999954, 70.85211823100008],
              [-8.928944464999915, 70.84593333500004],
              [-8.937570766999954, 70.83978913000004],
              [-8.954253709999932, 70.82436758000006],
              [-8.96312415299991, 70.81801992400005],
              [-8.98656165299991, 70.81077708500004],
              [-9.020130988999938, 70.80670807500007],
              [-9.054351365999935, 70.80703359600005],
              [-9.079741990999935, 70.81244538000004],
              [-9.07530676999994, 70.81879303600005],
              [-9.070301886999914, 70.82827383000006],
              [-9.066070115999935, 70.83226146000004],
              [-9.109730597999942, 70.86107005400004],
              [-9.11742102799991, 70.87490469000005],
              [-9.08657792899993, 70.88068268400008],
              [-9.05846106699994, 70.88080475500004],
              [-9.046620245999918, 70.88251373900005],
              [-9.031971808999913, 70.88690827000005],
              [-8.995716925999943, 70.90521881700005],
              [-8.964670376999948, 70.91046784100007],
              [-8.953521287999934, 70.91620514500005],
              [-8.944813605999911, 70.92283763200004],
              [-8.936390753999945, 70.92788320500006],
              [-8.91633053299995, 70.93280670800004],
              [-8.832997199999909, 70.93732330900008],
              [-8.790435350999928, 70.94562409100007],
              [-8.744618292999917, 70.96259186400005],
              [-8.73859615799995, 70.96637604400007],
              [-8.734852667999917, 70.97052643400008],
              [-8.73273678299995, 70.97431061400005],
              [-8.730946417999917, 70.97626373900005],
              [-8.692738410999937, 70.98598867400005],
              [-8.572661912999934, 70.99677155200004],
              [-8.566232876999948, 71.00039297100005],
              [-8.562245245999918, 71.00511302300004],
              [-8.557606574999909, 71.00922272300005],
              [-8.548817511999914, 71.01105377800008],
              [-8.526966925999943, 71.01166413000004],
              [-8.516835089999915, 71.01447174700007],
              [-8.507435675999943, 71.02069733300004],
              [-8.47642981699994, 71.05198802300004],
              [-8.468006964999915, 71.05784739800004],
              [-8.45140540299991, 71.06655508000006],
              [-8.443023240999935, 71.07245514500005],
              [-8.397775844999956, 71.11371491100005],
              [-8.375152147999927, 71.12726471600007],
              [-8.325672980999911, 71.14760976800005],
              [-8.18736731699994, 71.15424225500004],
              [-8.175404425999943, 71.15753815300008],
              [-8.153920050999943, 71.17186107000003],
              [-8.147450324999909, 71.17487213700008],
              [-8.123117641999954, 71.17792389500005],
              [-8.045643683999913, 71.17487213700008],
              [-8.003651495999918, 71.18036530200004],
              [-7.983550584999932, 71.18016185100004],
              [-7.962554490999935, 71.17487213700008],
            ],
          ],
          [
            [
              [19.160329623000052, 74.52602773600006],
              [19.250824415000068, 74.48948802300004],
              [19.286387566000087, 74.48436107000003],
              [19.29737389400009, 74.48110586100006],
              [19.294444207000083, 74.47361888200004],
              [19.279958530000044, 74.46084219000005],
              [19.27833092500009, 74.45595937700006],
              [19.28451582100007, 74.44843170800004],
              [19.283376498000052, 74.44403717700004],
              [19.276540561000047, 74.43927643400008],
              [19.262461785000085, 74.43475983300004],
              [19.23682701900009, 74.41864655200004],
              [19.235036655000044, 74.41351959800005],
              [19.23487389400009, 74.39907461100006],
              [19.187754754000082, 74.37579987200007],
              [19.19507897200009, 74.36896393400008],
              [19.16773522200009, 74.36090729400007],
              [19.073741082000083, 74.34735748900005],
              [19.047048373000052, 74.35126373900005],
              [19.034678582000083, 74.36627838700008],
              [19.026621941000087, 74.37299225500004],
              [19.016368035000085, 74.37579987200007],
              [19.002614780000044, 74.37714264500005],
              [18.963063998000052, 74.38613515800006],
              [18.95093834700009, 74.39227936400005],
              [18.931895379000082, 74.40525950700004],
              [18.865489129000082, 74.43036530200004],
              [18.813324415000068, 74.46841054900005],
              [18.789805535000085, 74.47821686400005],
              [18.820485873000052, 74.50405508000006],
              [18.874847852000073, 74.51618073100008],
              [18.981618686000047, 74.51976146000004],
              [19.026621941000087, 74.51284414300005],
              [19.114756707000083, 74.52728913000004],
              [19.160329623000052, 74.52602773600006],
            ],
          ],
          [
            [
              [25.478363477000073, 76.71206289300005],
              [25.504567905000044, 76.71430084800005],
              [25.580821160000085, 76.71206289300005],
              [25.580821160000085, 76.69843170800004],
              [25.560801629000082, 76.69599030200004],
              [25.391286655000044, 76.62030670800004],
              [25.289724155000044, 76.59406159100007],
              [25.241384311000047, 76.57428620000007],
              [25.217621290000068, 76.56806061400005],
              [25.219411655000044, 76.56452057500007],
              [25.22038821700005, 76.56167226800005],
              [25.22169030000009, 76.55874258000006],
              [25.22510826900009, 76.55499909100007],
              [25.181162957000083, 76.53375885600008],
              [25.047211134000065, 76.49803294500003],
              [25.019053582000083, 76.46873607000003],
              [25.023448113000086, 76.45795319200005],
              [25.030772332000083, 76.45156484600005],
              [25.031911655000044, 76.44647858300004],
              [25.017588738000086, 76.43964264500005],
              [25.002289259000065, 76.43716054900005],
              [24.979258660000085, 76.43646881700005],
              [24.95679772200009, 76.43878815300008],
              [24.943369988000086, 76.44513580900008],
              [24.947276238000086, 76.46019114800004],
              [24.96778405000009, 76.47821686400005],
              [24.993418816000087, 76.49339427300004],
              [25.03223717500009, 76.50511302300004],
              [25.09473717500009, 76.54413483300004],
              [25.35450280000009, 76.63690827000005],
              [25.423106316000087, 76.68414948100008],
              [25.416270379000082, 76.69159577000005],
              [25.431488477000073, 76.69432200700004],
              [25.462087436000047, 76.70722077000005],
              [25.478363477000073, 76.71206289300005],
            ],
          ],
          [
            [
              [24.42476468500007, 77.82593585100005],
              [24.335789720000037, 77.79857857900004],
              [24.24686617100008, 77.75791328200006],
              [24.228369960000066, 77.71685052100008],
              [24.15284209400005, 77.68409245300006],
              [24.094086134000065, 77.65037669500003],
              [24.076833530000044, 77.64061107000003],
              [24.063731316000087, 77.63068268400008],
              [24.04542076900009, 77.62055084800005],
              [24.026621941000087, 77.61273834800005],
              [23.994965040000068, 77.60529205900008],
              [23.98292076900009, 77.59487539300005],
              [23.96387780000009, 77.56858958500004],
              [23.918142123000052, 77.52448151200008],
              [23.892832879000082, 77.50836823100008],
              [23.73487389400009, 77.45538971600007],
              [23.540293816000087, 77.42438385600008],
              [23.390879754000082, 77.38011302300004],
              [23.354340040000068, 77.37685781500005],
              [23.268472086000088, 77.32659352800005],
              [23.289058295000075, 77.29085078200006],
              [23.23454060800009, 77.26368345100008],
              [22.92222438300007, 77.25628812500008],
              [22.70394650500009, 77.23728022200004],
              [22.610062809000055, 77.24832127400003],
              [22.47510826900009, 77.26215241100005],
              [22.449473504000082, 77.26072825700004],
              [22.429698113000086, 77.26373932500007],
              [22.42042076900009, 77.26886627800008],
              [22.413584832000083, 77.27582428600005],
              [22.401621941000087, 77.28400299700007],
              [22.390879754000082, 77.30394114800004],
              [22.42628014400009, 77.31928131700005],
              [22.504649285000085, 77.33588288000004],
              [22.492442254000082, 77.36432526200008],
              [22.490977410000085, 77.37343984600005],
              [22.48414147200009, 77.38202545800004],
              [22.451019727000073, 77.39447663000004],
              [22.425629102000073, 77.40961334800005],
              [22.414073113000086, 77.41449616100005],
              [22.410899285000085, 77.42031484600005],
              [22.422129754000082, 77.43146393400008],
              [22.43881269600007, 77.43891022300005],
              [22.566579623000052, 77.46662018400008],
              [22.602793816000087, 77.48639557500007],
              [22.675303582000083, 77.49347565300008],
              [22.733083530000044, 77.51805247600004],
              [22.76140384200005, 77.53620026200008],
              [22.77833092500009, 77.55491771000004],
              [22.667816602000073, 77.55145905200004],
              [22.60914147200009, 77.53937409100007],
              [22.57911217500009, 77.51337311400005],
              [22.55372155000009, 77.51862213700008],
              [22.559418165000068, 77.53001536700003],
              [22.58179772200009, 77.54181549700007],
              [22.60645592500009, 77.54816315300008],
              [22.565928582000083, 77.56732819200005],
              [22.507334832000083, 77.57705312700006],
              [22.44662519600007, 77.57782623900005],
              [22.291758660000085, 77.55491771000004],
              [22.28223717500009, 77.55036041900007],
              [22.243337436000047, 77.52020905200004],
              [22.191742384000065, 77.50413646000004],
              [21.778737826500077, 77.48741282750004],
              [21.36573326900009, 77.47068919500003],
              [21.31690514400009, 77.45791250200006],
              [21.092539910000085, 77.43915436400005],
              [21.038259311000047, 77.44440338700008],
              [20.921722852000073, 77.44236888200004],
              [20.89389082100007, 77.44574616100005],
              [20.865489129000082, 77.45620351800005],
              [20.863291863000086, 77.46686432500007],
              [20.878428582000083, 77.47711823100008],
              [20.929860873000052, 77.50161367400005],
              [20.919118686000047, 77.50897858300004],
              [20.889008009000065, 77.51552969000005],
              [20.85987389400009, 77.52765534100007],
              [20.880869988000086, 77.53449127800008],
              [20.86963951900009, 77.53945547100005],
              [20.857595248000052, 77.54116445500006],
              [20.83179772200009, 77.54071686400005],
              [20.845225457000083, 77.54608795800004],
              [20.858653191000087, 77.54816315300008],
              [20.887054884000065, 77.54816315300008],
              [20.878428582000083, 77.56342194200005],
              [20.87354576900009, 77.56858958500004],
              [21.189626498000052, 77.60171133000006],
              [21.216075066000087, 77.60956452000005],
              [21.236501498000052, 77.62303294500003],
              [21.236989780000044, 77.63328685100004],
              [21.230316602000073, 77.64378489800004],
              [21.229177280000044, 77.65802643400008],
              [21.233246290000068, 77.66242096600007],
              [21.246755405000044, 77.66742584800005],
              [21.250254754000082, 77.67161692900004],
              [21.250336134000065, 77.67926666900007],
              [21.247894727000073, 77.68244049700007],
              [21.244883660000085, 77.68439362200007],
              [21.243418816000087, 77.68842194200005],
              [21.24512780000009, 77.69977448100008],
              [21.24935957100007, 77.71458567900004],
              [21.25489342500009, 77.72752513200004],
              [21.26075280000009, 77.73309967700004],
              [21.328868035000085, 77.75731028900003],
              [21.362803582000083, 77.77553945500006],
              [21.412771030000044, 77.78485748900005],
              [21.43523196700005, 77.79515208500004],
              [21.437754754000082, 77.82037995000007],
              [21.478851759000065, 77.83685944200005],
              [21.558116082000083, 77.85663483300004],
              [21.566254102000073, 77.87213776200008],
              [21.556488477000073, 77.87982819200005],
              [21.542491082000083, 77.88617584800005],
              [21.53760826900009, 77.89760976800005],
              [21.55632571700005, 77.90704987200007],
              [21.66179446700005, 77.91803620000007],
              [21.65137780000009, 77.92885976800005],
              [21.637543165000068, 77.93866608300004],
              [21.622325066000087, 77.94456614800004],
              [21.60792076900009, 77.94403717700004],
              [21.582286004000082, 77.93976471600007],
              [21.36817467500009, 77.96503327000005],
              [21.316254102000073, 77.98305898600006],
              [21.24350019600007, 77.99213288000004],
              [20.880137566000087, 78.08539459800005],
              [20.876963738000086, 78.09857819200005],
              [20.900563998000052, 78.11115143400008],
              [20.992198113000086, 78.13861725500004],
              [21.344493035000085, 78.17485179250005],
              [21.696787957000083, 78.21108633000006],
              [22.046519402000087, 78.20547109550006],
              [22.39625084700009, 78.19985586100006],
              [22.492198113000086, 78.21605052300004],
              [22.53419030000009, 78.23021067900004],
              [22.966075066000087, 78.25629303600005],
              [23.060801629000082, 78.23505280200004],
              [23.133148634000065, 78.23183828300006],
              [23.32781009200005, 78.20014069200005],
              [23.420664910000085, 78.16836172100005],
              [23.47046959700009, 78.15827057500007],
              [23.47046959700009, 78.15143463700008],
              [23.396494988000086, 78.13934967700004],
              [23.374278191000087, 78.13092682500007],
              [23.375254754000082, 78.11286041900007],
              [23.35010826900009, 78.10492584800005],
              [23.14161217500009, 78.09686920800004],
              [23.105479363000086, 78.08812083500004],
              [23.07129967500009, 78.06622955900008],
              [23.055023634000065, 78.03729889500005],
              [23.073090040000068, 78.00747304900005],
              [23.12045332100007, 77.98590729400007],
              [23.36890709700009, 77.95636627800008],
              [23.39503014400009, 77.94912344000005],
              [23.47046959700009, 77.91803620000007],
              [23.56609134200005, 77.89760976800005],
              [23.612478061000047, 77.87372467700004],
              [23.62826582100007, 77.87030670800004],
              [23.941661004000082, 77.85211823100008],
              [23.995616082000083, 77.85944245000007],
              [24.035899285000085, 77.88019440300008],
              [24.073415561000047, 77.89411041900007],
              [24.238291863000086, 77.89760976800005],
              [24.25945071700005, 77.90184153900003],
              [24.282481316000087, 77.90936920800004],
              [24.304942254000082, 77.91185130400004],
              [24.32390384200005, 77.90131256700005],
              [24.335215691000087, 77.89069245000007],
              [24.348806186000047, 77.88239166900007],
              [24.381602410000085, 77.87030670800004],
              [24.406504754000082, 77.86517975500004],
              [24.42476468500007, 77.82593585100005],
            ],
          ],
          [
            [
              [21.024261915000068, 78.21914297100005],
              [20.797699415000068, 78.22650788000004],
              [20.767100457000083, 78.22158437700006],
              [20.737559441000087, 78.21287669500003],
              [20.73145592500009, 78.20929596600007],
              [20.72706139400009, 78.20490143400008],
              [20.722504102000073, 78.19920482000003],
              [20.699554884000065, 78.19293854400007],
              [20.673024936000047, 78.19033437700006],
              [20.647227410000085, 78.19403717700004],
              [20.627696160000085, 78.20673248900005],
              [20.674082879000082, 78.21426015800006],
              [20.687836134000065, 78.21914297100005],
              [20.66732832100007, 78.21914297100005],
              [20.66732832100007, 78.22650788000004],
              [20.71583092500009, 78.23334381700005],
              [20.713145379000082, 78.25336334800005],
              [20.736338738000086, 78.26068756700005],
              [20.768239780000044, 78.26455312700006],
              [20.79151451900009, 78.27435944200005],
              [20.78060957100007, 78.28017812700006],
              [20.762950066000087, 78.29230377800008],
              [20.74740644600007, 78.29881419500003],
              [20.725271030000044, 78.30438873900005],
              [20.468760613000086, 78.31533437700006],
              [20.483083530000044, 78.32770416900007],
              [20.507823113000086, 78.33637116100005],
              [20.535411004000082, 78.34149811400005],
              [20.557871941000087, 78.34320709800005],
              [20.648448113000086, 78.34015534100007],
              [20.674571160000085, 78.34662506700005],
              [20.685069207000083, 78.35797760600008],
              [20.681895379000082, 78.37124258000006],
              [20.67164147200009, 78.38324616100005],
              [20.66114342500009, 78.39105866100005],
              [20.636973504000082, 78.39915599200003],
              [20.58301842500009, 78.40448639500005],
              [20.45557701900009, 78.44025299700007],
              [20.153575066000087, 78.47540924700007],
              [20.162119988000086, 78.48163483300004],
              [20.171153191000087, 78.49066803600005],
              [20.183116082000083, 78.49534739800004],
              [20.527272983000074, 78.52598704650003],
              [20.871429884000065, 78.55662669500003],
              [20.953135613000086, 78.54572174700007],
              [21.020355665000068, 78.54474518400008],
              [21.084239129000082, 78.55573151200008],
              [21.12671959700009, 78.58344147300005],
              [21.121836785000085, 78.58490631700005],
              [21.112559441000087, 78.58885325700004],
              [21.106211785000085, 78.58958567900004],
              [21.106211785000085, 78.59711334800005],
              [21.17823326900009, 78.62323639500005],
              [21.303965691000087, 78.62775299700007],
              [21.423106316000087, 78.61440664300005],
              [21.476084832000083, 78.58657461100006],
              [21.49935957100007, 78.56806061400005],
              [21.552256707000083, 78.57269928600005],
              [21.646820509000065, 78.59711334800005],
              [21.67432701900009, 78.60053131700005],
              [21.793142123000052, 78.59878164300005],
              [21.80567467500009, 78.59711334800005],
              [21.81104576900009, 78.59284088700008],
              [21.813731316000087, 78.58600495000007],
              [21.81739342500009, 78.57949453300006],
              [21.826182488000086, 78.57599518400008],
              [21.846853061000047, 78.57868073100008],
              [21.86264082100007, 78.58478424700007],
              [21.878428582000083, 78.58567942900004],
              [21.91651451900009, 78.56244538000004],
              [21.939300977000073, 78.56069570500006],
              [21.983897332000083, 78.56915924700007],
              [22.04460696700005, 78.59381745000007],
              [22.064789259000065, 78.59711334800005],
              [22.084727410000085, 78.59495677300004],
              [22.091970248000052, 78.58926015800006],
              [22.094086134000065, 78.58038971600007],
              [22.09937584700009, 78.56915924700007],
              [22.13257897200009, 78.52724844000005],
              [22.15560957100007, 78.51264069200005],
              [22.20679772200009, 78.50482819200005],
              [22.223887566000087, 78.49835846600007],
              [22.23536217500009, 78.48786041900007],
              [22.237071160000085, 78.47357819200005],
              [22.230642123000052, 78.46417877800008],
              [22.20639082100007, 78.44867584800005],
              [22.195567254000082, 78.43886953300006],
              [22.204356316000087, 78.42845286700003],
              [22.215668165000068, 78.42153554900005],
              [22.225433790000068, 78.41388580900008],
              [22.229746941000087, 78.40155670800004],
              [22.22632897200009, 78.38092682500007],
              [22.229746941000087, 78.37457916900007],
              [22.24390709700009, 78.36684804900005],
              [22.241384311000047, 78.35565827000005],
              [22.231944207000083, 78.33295319200005],
              [22.22828209700009, 78.30756256700005],
              [22.243337436000047, 78.28864166900007],
              [22.237071160000085, 78.28180573100008],
              [22.27125084700009, 78.26752350500004],
              [21.867903408000075, 78.24513038433338],
              [21.46455596900006, 78.22273726366672],
              [21.061208530000044, 78.20034414300005],
              [21.010590040000068, 78.20673248900005],
              [21.015635613000086, 78.20986562700006],
              [21.024261915000068, 78.21914297100005],
            ],
          ],
          [
            [
              [27.020762566000087, 78.69891998900005],
              [26.967946811000047, 78.68911367400005],
              [26.947276238000086, 78.67829010600008],
              [26.951914910000085, 78.65790436400005],
              [26.90984134200005, 78.65021393400008],
              [26.774668816000087, 78.64069245000007],
              [26.74577884200005, 78.63434479400007],
              [26.737559441000087, 78.62645091400003],
              [26.71924889400009, 78.63060130400004],
              [26.69117272200009, 78.64423248900005],
              [26.694183790000068, 78.64614492400005],
              [26.697113477000073, 78.65265534100007],
              [26.698741082000083, 78.66034577000005],
              [26.698008660000085, 78.66535065300008],
              [26.68685957100007, 78.66966380400004],
              [26.636241082000083, 78.67157623900005],
              [26.465993686000047, 78.70945872600004],
              [26.45866946700005, 78.73248932500007],
              [26.440928582000083, 78.74860260600008],
              [26.396332227000073, 78.77521393400008],
              [26.44190514400009, 78.80735911700003],
              [26.497243686000047, 78.81557851800005],
              [26.615489129000082, 78.80878327000005],
              [26.634043816000087, 78.79279205900008],
              [26.650401238000086, 78.78237539300005],
              [26.74577884200005, 78.74725983300004],
              [26.773692254000082, 78.72679271000004],
              [26.833994988000086, 78.71124909100007],
              [27.020762566000087, 78.69891998900005],
            ],
          ],
          [
            [
              [12.142832879000082, 78.23704661700003],
              [12.14779707100007, 78.22744375200006],
              [12.157399936000047, 78.21881745000007],
              [12.162852410000085, 78.21088288000004],
              [12.156097852000073, 78.20294830900008],
              [12.140472852000073, 78.19920482000003],
              [12.119639519000089, 78.19940827000005],
              [12.09896894600007, 78.20307038000004],
              [12.051931186000047, 78.22247955900008],
              [11.923675977000073, 78.22650788000004],
              [11.89226321700005, 78.23358795800004],
              [11.865244988000086, 78.24506256700005],
              [11.81381269600007, 78.27435944200005],
              [11.849864129000082, 78.29311758000006],
              [11.855479363000086, 78.29881419500003],
              [11.848399285000085, 78.30776601800005],
              [11.832041863000086, 78.31216054900005],
              [11.800954623000052, 78.31533437700006],
              [11.623545769000089, 78.36603424700007],
              [11.600108269000089, 78.38263580900008],
              [11.58757571700005, 78.38930898600006],
              [11.574229363000086, 78.39427317900004],
              [11.455821160000085, 78.41583893400008],
              [11.410166863000086, 78.43414948100008],
              [11.343760613000086, 78.44912344000005],
              [11.305349155000044, 78.45221588700008],
              [11.163910352000073, 78.43622467700004],
              [11.121836785000085, 78.43886953300006],
              [11.085215691000087, 78.45449453300006],
              [11.039317254000082, 78.48480866100005],
              [11.00367272200009, 78.51959870000007],
              [10.998301629000082, 78.54873281500005],
              [10.96851647200009, 78.55532461100006],
              [10.950450066000087, 78.57037995000007],
              [10.935883009000065, 78.58991120000007],
              [10.916351759000065, 78.61017487200007],
              [10.885996941000087, 78.62978750200006],
              [10.854258660000085, 78.64411041900007],
              [10.786631707000083, 78.66535065300008],
              [10.800954623000052, 78.68134186400005],
              [10.807139519000089, 78.68585846600007],
              [10.781504754000082, 78.68870677300004],
              [10.651540561000047, 78.72980377800008],
              [10.635264519000089, 78.74046458500004],
              [10.576833530000044, 78.75828685100004],
              [10.54859459700009, 78.77118561400005],
              [10.525401238000086, 78.78827545800004],
              [10.545258009000065, 78.80390045800004],
              [10.563975457000083, 78.81093984600005],
              [10.57357832100007, 78.82046133000006],
              [10.566905144000089, 78.84349192900004],
              [10.55241946700005, 78.86041901200008],
              [10.531260613000086, 78.87372467700004],
              [10.484385613000086, 78.89069245000007],
              [10.516123894000089, 78.90648021000004],
              [10.56023196700005, 78.90912506700005],
              [10.843760613000086, 78.87889232000003],
              [10.999847852000073, 78.83417389500005],
              [11.002289259000065, 78.82172272300005],
              [10.991465691000087, 78.79572174700007],
              [11.031423373000052, 78.78310781500005],
              [11.099131707000083, 78.77879466400003],
              [11.11500084700009, 78.77521393400008],
              [11.132823113000086, 78.76679108300004],
              [11.183848504000082, 78.73362864800004],
              [11.06031334700009, 78.69269440300008],
              [11.12240644600007, 78.67560455900008],
              [11.153819207000083, 78.66258372600004],
              [11.159353061000047, 78.64801666900007],
              [11.162771030000044, 78.63202545800004],
              [11.24382571700005, 78.62018463700008],
              [11.272634311000047, 78.61017487200007],
              [11.257009311000047, 78.59955475500004],
              [11.256358269000089, 78.58592357000003],
              [11.26734459700009, 78.57416413000004],
              [11.28687584700009, 78.56915924700007],
              [11.298024936000047, 78.56395091400003],
              [11.287445509000065, 78.55194733300004],
              [11.259043816000087, 78.52822500200006],
              [11.355316602000073, 78.54608795800004],
              [11.447113477000073, 78.54804108300004],
              [11.463877800000091, 78.54246653900003],
              [11.471202019000089, 78.53522370000007],
              [11.482920769000089, 78.51528554900005],
              [11.491709832000083, 78.50706614800004],
              [11.507090691000087, 78.50242747600004],
              [11.541758660000085, 78.49884674700007],
              [11.568532748000052, 78.48354726800005],
              [11.759287957000083, 78.44562409100007],
              [11.872243686000047, 78.44794342700004],
              [11.90015709700009, 78.43573639500005],
              [11.900645379000082, 78.42918528900003],
              [11.88062584700009, 78.41852448100008],
              [11.875987175000091, 78.41087474200003],
              [11.880137566000087, 78.40232982000003],
              [11.889170769000089, 78.39508698100008],
              [12.050303582000083, 78.31037018400008],
              [12.10132897200009, 78.29539622600004],
              [12.096934441000087, 78.27358633000006],
              [12.112478061000047, 78.26178620000007],
              [12.132660352000073, 78.25226471600007],
              [12.142832879000082, 78.23704661700003],
            ],
          ],
          [
            [
              [29.438975457000083, 78.90497467700004],
              [29.583994988000086, 78.92059967700004],
              [29.665537957000083, 78.92059967700004],
              [29.707041863000086, 78.89813873900005],
              [29.329112175000034, 78.86334870000007],
              [29.333018425000034, 78.85394928600005],
              [29.33529707100007, 78.85032786700003],
              [29.236501498000052, 78.85321686400005],
              [28.92709394600007, 78.89598216400003],
              [28.888845248000052, 78.90912506700005],
              [28.86963951900009, 78.91181061400005],
              [28.619558139000077, 78.89472077050004],
              [28.369476759000065, 78.87763092700004],
              [28.10328209700009, 78.82245514500005],
              [28.08725019600007, 78.82196686400005],
              [27.841970248000052, 78.84349192900004],
              [27.860606316000087, 78.85008372600004],
              [28.03060957100007, 78.87392812700006],
              [28.06967207100007, 78.88760000200006],
              [28.105642123000052, 78.89500560100004],
              [28.135996941000087, 78.91425202000005],
              [28.151133660000085, 78.91860586100006],
              [28.364024285000085, 78.92121002800008],
              [28.402679884000065, 78.92951080900008],
              [28.428721550000034, 78.94452545800004],
              [28.418630405000044, 78.96698639500005],
              [28.788910352000073, 78.96417877800008],
              [28.99390709700009, 78.93162669500003],
              [29.03484134200005, 78.91181061400005],
              [29.064789259000065, 78.90420156500005],
              [29.438975457000083, 78.90497467700004],
            ],
          ],
          [
            [
              [30.069590691000087, 79.00800202000005],
              [30.309255405000044, 79.00800202000005],
              [30.316416863000086, 79.00580475500004],
              [30.32390384200005, 79.00238678600005],
              [30.337087436000047, 78.99433014500005],
              [30.311371290000068, 78.98566315300008],
              [30.274587436000047, 78.98090241100005],
              [30.20679772200009, 78.98004791900007],
              [30.22046959700009, 78.97321198100008],
              [30.184255405000044, 78.96674225500004],
              [30.136241082000083, 78.96893952000005],
              [30.092458530000044, 78.98200104400007],
              [30.069590691000087, 79.00800202000005],
            ],
          ],
          [
            [
              [20.098887566000087, 79.12409088700008],
              [20.188731316000087, 79.13165924700007],
              [20.215586785000085, 79.12409088700008],
              [20.20948326900009, 79.12287018400008],
              [20.19507897200009, 79.11786530200004],
              [20.46778405000009, 79.12579987200007],
              [20.496104363000086, 79.11786530200004],
              [20.515472852000073, 79.11733633000006],
              [20.571787957000083, 79.10358307500007],
              [20.764008009000065, 79.08588288000004],
              [20.805918816000087, 79.07412344000005],
              [20.83179772200009, 79.05516185100004],
              [20.701019727000073, 79.02594635600008],
              [20.49854576900009, 79.01788971600007],
              [20.40593509200005, 78.99591705900008],
              [20.358246290000068, 78.99469635600008],
              [20.311696811000047, 79.00214264500005],
              [20.270762566000087, 79.01788971600007],
              [20.243988477000073, 79.02505117400005],
              [20.12281334700009, 79.02313873900005],
              [20.06739342500009, 79.03351471600007],
              [20.044200066000087, 79.04148997600004],
              [20.103770379000082, 79.05133698100008],
              [20.135020379000082, 79.06069570500006],
              [20.13331139400009, 79.07318756700005],
              [20.11036217500009, 79.08832428600005],
              [20.114756707000083, 79.09560781500005],
              [20.130137566000087, 79.10272858300004],
              [20.14039147200009, 79.11786530200004],
              [20.129730665000068, 79.11758047100005],
              [20.119151238000086, 79.11847565300008],
              [20.108897332000083, 79.12067291900007],
              [20.098887566000087, 79.12409088700008],
            ],
          ],
          [
            [
              [20.057871941000087, 79.37726471600007],
              [20.155121290000068, 79.36440664300005],
              [20.177989129000082, 79.35342031500005],
              [20.172699415000068, 79.34259674700007],
              [20.14389082100007, 79.33624909100007],
              [20.10987389400009, 79.33515045800004],
              [20.08887780000009, 79.34003327000005],
              [20.064626498000052, 79.35342031500005],
              [20.03492272200009, 79.35618724200003],
              [19.701508009000065, 79.33698151200008],
              [19.672536655000044, 79.34072500200006],
              [19.65992272200009, 79.34747955900008],
              [19.66309655000009, 79.35907623900005],
              [19.681162957000083, 79.37726471600007],
              [19.640879754000082, 79.39032623900005],
              [19.626475457000083, 79.39158763200004],
              [19.66773522200009, 79.40424225500004],
              [19.713552280000044, 79.40778229400007],
              [19.804535352000073, 79.40521881700005],
              [19.86622155000009, 79.39150625200006],
              [20.057871941000087, 79.37726471600007],
            ],
          ],
          [
            [
              [11.032481316000087, 79.70693594000005],
              [11.022959832000083, 79.69448476800005],
              [11.016774936000047, 79.69025299700007],
              [11.005707227000073, 79.68642812700006],
              [11.046071811000047, 79.68667226800005],
              [11.06413821700005, 79.68089427300004],
              [11.07398522200009, 79.66596100500004],
              [11.002452019000089, 79.67226797100005],
              [10.984629754000082, 79.66937897300005],
              [10.965668165000068, 79.66132233300004],
              [10.945485873000052, 79.65570709800005],
              [10.924082879000082, 79.65241120000007],
              [10.821543816000087, 79.65053945500006],
              [10.779470248000052, 79.65619538000004],
              [10.752614780000044, 79.67279694200005],
              [10.738129102000073, 79.68642812700006],
              [10.847992384000065, 79.69326406500005],
              [10.814952019000089, 79.70213450700004],
              [10.739756707000083, 79.70575592700004],
              [10.710948113000086, 79.72117747600004],
              [10.871755405000044, 79.72736237200007],
              [10.993418816000087, 79.70795319200005],
              [11.032481316000087, 79.70693594000005],
            ],
          ],
          [
            [
              [10.717458530000044, 79.74164459800005],
              [10.683767123000052, 79.74396393400008],
              [10.65398196700005, 79.75055573100008],
              [10.645762566000087, 79.76113515800006],
              [10.676768425000091, 79.77521393400008],
              [10.712901238000086, 79.78245677300004],
              [10.868662957000083, 79.77944570500006],
              [11.011973504000082, 79.74164459800005],
              [10.984222852000073, 79.73139069200005],
              [10.717458530000044, 79.74164459800005],
            ],
          ],
          [
            [
              [20.20875084700009, 78.63808828300006],
              [20.18067467500009, 78.63092682500007],
              [20.12598717500009, 78.63788483300004],
              [20.098887566000087, 78.63808828300006],
              [20.051524285000085, 78.62958405200004],
              [20.031911655000044, 78.61981842700004],
              [20.030528191000087, 78.60394928600005],
              [19.76303144600007, 78.62421295800004],
              [19.67432701900009, 78.61017487200007],
              [19.582774285000085, 78.58148834800005],
              [19.57943769600007, 78.57501862200007],
              [19.584808790000068, 78.56171295800004],
              [19.602386915000068, 78.54702383000006],
              [19.658376498000052, 78.52700429900005],
              [19.681162957000083, 78.51455312700006],
              [19.337087436000076, 78.49076976100005],
              [18.993011915000068, 78.46698639500005],
              [18.961761915000068, 78.45246002800008],
              [19.008474155000044, 78.42877838700008],
              [19.031260613000086, 78.41132233300004],
              [19.066416863000086, 78.37787506700005],
              [19.06226647200009, 78.36395905200004],
              [19.05054772200009, 78.34320709800005],
              [19.033213738000086, 78.33567942900004],
              [18.993988477000073, 78.32819245000007],
              [18.981618686000047, 78.31533437700006],
              [18.99586022200009, 78.31533437700006],
              [18.985118035000085, 78.30760325700004],
              [18.96924889400009, 78.30206940300008],
              [18.95639082100007, 78.29474518400008],
              [18.954356316000087, 78.28180573100008],
              [18.965993686000047, 78.27407461100006],
              [19.030039910000085, 78.25385163000004],
              [19.062510613000086, 78.24896881700005],
              [19.078461134000065, 78.24258047100005],
              [19.085215691000087, 78.22992584800005],
              [19.077972852000073, 78.22011953300006],
              [19.061371290000068, 78.21010976800005],
              [19.042816602000073, 78.20233795800004],
              [19.030039910000085, 78.19920482000003],
              [18.949554884000065, 78.19578685100004],
              [18.926931186000047, 78.18903229400007],
              [18.920583530000044, 78.17853424700007],
              [18.933767123000052, 78.16864655200004],
              [18.99390709700009, 78.13959381700005],
              [19.069183790000068, 78.12592194200005],
              [19.098317905000044, 78.10301341400003],
              [19.062754754000082, 78.08685944200005],
              [18.811208530000044, 78.02846914300005],
              [18.582855665000068, 78.05512116100005],
              [18.492849155000044, 78.04808177300004],
              [18.406260613000086, 78.02114492400005],
              [18.426442905000044, 78.00568268400008],
              [18.50245201900009, 77.98016998900005],
              [18.476573113000086, 77.96063873900005],
              [18.441579623000052, 77.95213450700004],
              [18.404144727000073, 77.94721100500004],
              [18.37208092500009, 77.93854401200008],
              [18.375173373000052, 77.92462799700007],
              [18.364512566000087, 77.91425202000005],
              [18.347178582000083, 77.90766022300005],
              [18.330414259000065, 77.90497467700004],
              [18.366465691000087, 77.87759023600006],
              [18.378916863000086, 77.87030670800004],
              [18.39779707100007, 77.86538320500006],
              [18.418142123000052, 77.86269765800006],
              [18.436208530000044, 77.85675690300008],
              [18.44776451900009, 77.84235260600008],
              [18.437022332000083, 77.82412344000005],
              [18.452972852000073, 77.79242584800005],
              [18.454600457000083, 77.77407461100006],
              [18.445160352000073, 77.75625234600005],
              [18.353363477000073, 77.68227773600006],
              [18.34742272200009, 77.66620514500005],
              [18.361501498000052, 77.64061107000003],
              [18.35328209700009, 77.63007233300004],
              [18.282725457000083, 77.58226146000004],
              [18.310720248000052, 77.55491771000004],
              [18.29981530000009, 77.52020905200004],
              [18.240082227000073, 77.49510325700004],
              [18.194102410000085, 77.49017975500004],
              [18.096527540000068, 77.50039297100005],
              [18.032481316000087, 77.49258047100005],
              [18.01221764400009, 77.49262116100005],
              [17.99268639400009, 77.49599844000005],
              [17.96029707100007, 77.51333242400005],
              [17.940114780000044, 77.51349518400008],
              [17.813324415000068, 77.49347565300008],
              [17.747325066000087, 77.49933502800008],
              [17.727793816000087, 77.49347565300008],
              [17.73568769600007, 77.46686432500007],
              [17.70484459700009, 77.45258209800005],
              [17.62476647200009, 77.44574616100005],
              [17.628754102000073, 77.43549225500004],
              [17.636566602000073, 77.42869700700004],
              [17.64698326900009, 77.42544179900005],
              [17.658946160000085, 77.42523834800005],
              [17.65211022200009, 77.41535065300008],
              [17.642100457000083, 77.40949127800008],
              [17.630381707000083, 77.40452708500004],
              [17.617930535000085, 77.39728424700007],
              [17.594086134000065, 77.36660390800006],
              [17.57007897200009, 77.35293203300006],
              [17.51148522200009, 77.33771393400008],
              [17.488291863000086, 77.32160065300008],
              [17.49577884200005, 77.31537506700005],
              [17.483246290000068, 77.30609772300005],
              [17.486989780000044, 77.29604726800005],
              [17.496429884000065, 77.28440989800004],
              [17.501963738000086, 77.27069733300004],
              [17.50049889400009, 77.25531647300005],
              [17.494802280000044, 77.24848053600005],
              [17.460215691000087, 77.23338450700004],
              [17.433848504000082, 77.21426015800006],
              [17.423838738000086, 77.19428131700005],
              [17.428558790000068, 77.17324453300006],
              [17.447276238000086, 77.15086497600004],
              [17.430430535000085, 77.13654205900008],
              [17.390147332000083, 77.12474192900004],
              [17.37159264400009, 77.11615631700005],
              [17.36654707100007, 77.11107005400004],
              [17.36459394600007, 77.10553620000007],
              [17.36459394600007, 77.09223053600005],
              [17.338552280000044, 77.08079661700003],
              [17.33057701900009, 77.07514069200005],
              [17.342051629000082, 77.07099030200004],
              [17.34734134200005, 77.06443919500003],
              [17.346039259000065, 77.05634186400005],
              [17.337412957000083, 77.04726797100005],
              [17.32195071700005, 77.04352448100008],
              [17.097178582000083, 77.05467357000003],
              [17.113454623000052, 77.03864166900007],
              [17.207041863000086, 77.01707591400003],
              [17.265147332000083, 76.99412669500003],
              [17.323741082000083, 76.97894928600005],
              [17.287445509000065, 76.95294830900008],
              [17.088715040000068, 76.87417226800005],
              [17.055918816000087, 76.85382721600007],
              [17.062510613000086, 76.83559804900005],
              [16.97982832100007, 76.82526276200008],
              [16.935720248000052, 76.81476471600007],
              [16.919118686000047, 76.79393138200004],
              [16.94239342500009, 76.78025950700004],
              [17.082041863000086, 76.76536692900004],
              [17.13607832100007, 76.75116608300004],
              [17.159027540000068, 76.73720937700006],
              [17.19190514400009, 76.72479889500005],
              [17.20020592500009, 76.71889883000006],
              [17.192067905000044, 76.69684479400007],
              [17.160166863000086, 76.68447500200006],
              [17.09034264400009, 76.67108795800004],
              [17.098887566000087, 76.65546295800004],
              [17.10401451900009, 76.65062083500004],
              [17.076019727000073, 76.64158763200004],
              [17.011241082000083, 76.63446686400005],
              [16.994802280000044, 76.61644114800004],
              [17.003428582000083, 76.60635000200006],
              [16.992198113000086, 76.60004303600005],
              [16.90788821700005, 76.59027741100005],
              [16.863536004000082, 76.57664622600004],
              [16.80958092500009, 76.56683991100005],
              [16.590668165000068, 76.57802969000005],
              [16.564789259000065, 76.58331940300008],
              [16.559336785000085, 76.59227122600004],
              [16.563731316000087, 76.60667552300004],
              [16.546397332000083, 76.61078522300005],
              [16.500743035000085, 76.60960521000004],
              [16.453868035000085, 76.62042877800008],
              [16.430918816000087, 76.62238190300008],
              [16.405772332000083, 76.61644114800004],
              [16.402517123000052, 76.61204661700003],
              [16.401052280000044, 76.60516998900005],
              [16.398448113000086, 76.59882233300004],
              [16.392100457000083, 76.59601471600007],
              [16.38249759200005, 76.59520091400003],
              [16.374847852000073, 76.59267812700006],
              [16.36890709700009, 76.58828359600005],
              [16.364756707000083, 76.58173248900005],
              [16.363536004000082, 76.57371653900003],
              [16.343760613000086, 76.57241445500006],
              [16.317149285000085, 76.57929108300004],
              [16.29590905000009, 76.59601471600007],
              [16.305837436000047, 76.60248444200005],
              [16.336761915000068, 76.61644114800004],
              [16.32585696700005, 76.62433502800008],
              [16.324392123000052, 76.63446686400005],
              [16.32911217500009, 76.64590078300006],
              [16.336761915000068, 76.65741608300004],
              [16.32398522200009, 76.65794505400004],
              [16.31153405000009, 76.66111888200004],
              [16.289073113000086, 76.67108795800004],
              [16.300059441000087, 76.69061920800004],
              [16.297536655000044, 76.70180898600006],
              [16.284027540000068, 76.70791250200006],
              [16.17741946700005, 76.72321198100008],
              [16.120941602000073, 76.73859284100007],
              [16.000824415000068, 76.74848053600005],
              [15.941579623000052, 76.76068756700005],
              [15.881114129000082, 76.79401276200008],
              [15.681488477000073, 76.85154857000003],
              [15.501475457000083, 76.87653229400007],
              [15.527517123000052, 76.90631745000007],
              [15.578461134000065, 76.91958242400005],
              [15.726817254000082, 76.93024323100008],
              [15.740977410000085, 76.93520742400005],
              [15.774424675000091, 76.95229726800005],
              [15.803965691000087, 76.95453522300005],
              [15.861989780000044, 76.94855377800008],
              [15.891774936000047, 76.95229726800005],
              [15.941742384000065, 76.96430084800005],
              [16.048675977000073, 76.97744375200006],
              [16.187754754000082, 76.97451406500005],
              [16.214854363000086, 76.96771881700005],
              [16.23015384200005, 76.96124909100007],
              [16.23804772200009, 76.95408763200004],
              [16.235606316000087, 76.94651927300004],
              [16.22006269600007, 76.93862539300005],
              [16.241058790000068, 76.93260325700004],
              [16.329925977000073, 76.94481028900003],
              [16.317556186000047, 76.97093333500004],
              [16.328868035000085, 76.98285553600005],
              [16.356130405000044, 76.98602936400005],
              [16.467621290000068, 76.98240794500003],
              [16.50757897200009, 76.98602936400005],
              [16.528575066000087, 77.00006745000007],
              [16.48218834700009, 77.00722890800006],
              [16.31617272200009, 77.00413646000004],
              [16.279551629000082, 76.99469635600008],
              [16.257660352000073, 76.99262116100005],
              [16.243337436000047, 76.99510325700004],
              [16.19971764400009, 77.01365794500003],
              [16.16187584700009, 77.01935455900008],
              [16.125010613000086, 77.02098216400003],
              [16.09148196700005, 77.02728913000004],
              [16.063161655000044, 77.04726797100005],
              [16.06218509200005, 77.05182526200008],
              [16.06421959700009, 77.06443919500003],
              [16.063161655000044, 77.06899648600006],
              [16.058604363000086, 77.07249583500004],
              [16.049571160000085, 77.07587311400005],
              [16.04542076900009, 77.07892487200007],
              [16.02898196700005, 77.08515045800004],
              [16.00326582100007, 77.08515045800004],
              [15.977305535000085, 77.08112213700008],
              [15.959483269000089, 77.07514069200005],
              [15.958181186000047, 77.06167226800005],
              [15.883636915000068, 77.06989166900007],
              [15.857676629000082, 77.06899648600006],
              [15.852061394000089, 77.05341217700004],
              [15.868662957000083, 77.04022858300004],
              [15.91179446700005, 77.02057526200008],
              [15.886566602000073, 77.01557038000004],
              [15.809336785000085, 77.01365794500003],
              [15.740896030000044, 77.00104401200008],
              [15.719737175000091, 77.00169505400004],
              [15.689952019000089, 77.00653717700004],
              [15.345713738000086, 77.00853099200003],
              [15.299001498000052, 77.01829661700003],
              [15.238536004000082, 77.02374909100007],
              [15.194509311000047, 77.03302643400008],
              [15.152679884000065, 77.04824453300006],
              [15.123383009000065, 77.06899648600006],
              [15.13803144600007, 77.07196686400005],
              [15.143321160000085, 77.07880280200004],
              [15.138682488000086, 77.08576080900008],
              [15.124034050000091, 77.08881256700005],
              [15.085459832000083, 77.08759186400005],
              [15.06617272200009, 77.08934153900003],
              [15.049001498000052, 77.09564850500004],
              [15.061208530000044, 77.10834381700005],
              [15.06771894600007, 77.11286041900007],
              [15.07553144600007, 77.11615631700005],
              [15.040212436000047, 77.13475169500003],
              [14.610118035000085, 77.18500397300005],
              [14.472992384000065, 77.17816803600005],
              [14.447764519000089, 77.18138255400004],
              [14.398285352000073, 77.19550202000005],
              [14.373708530000044, 77.19867584800005],
              [14.32203209700009, 77.23899974200003],
              [14.315277540000068, 77.24323151200008],
              [14.310883009000065, 77.24380117400005],
              [14.308604363000086, 77.24640534100007],
              [14.307790561000047, 77.25702545800004],
              [14.309743686000047, 77.26162344000005],
              [14.32203209700009, 77.28058502800008],
              [14.15796959700009, 77.29425690300008],
              [14.138845248000052, 77.30170319200005],
              [14.13843834700009, 77.31858958500004],
              [14.149587436000047, 77.33706289300005],
              [14.164398634000065, 77.34886302300004],
              [13.998383009000065, 77.39911530200004],
              [13.973806186000047, 77.40985748900005],
              [13.958994988000086, 77.42523834800005],
              [13.964854363000086, 77.42788320500006],
              [13.979991082000083, 77.43829987200007],
              [13.974457227000073, 77.44090403900003],
              [13.970713738000086, 77.44330475500004],
              [13.96615644600007, 77.44505442900004],
              [13.958994988000086, 77.44574616100005],
              [13.958994988000086, 77.45254140800006],
              [14.032725457000083, 77.44721100500004],
              [14.054535352000073, 77.45254140800006],
              [14.02320397200009, 77.47370026200008],
              [13.95248457100007, 77.48822663000004],
              [13.917979363000086, 77.49970123900005],
              [13.922129754000082, 77.50885651200008],
              [13.92123457100007, 77.51772695500006],
              [13.916840040000068, 77.52619049700007],
              [13.910655144000089, 77.53449127800008],
              [13.952403191000087, 77.53856028900003],
              [14.075694207000083, 77.56858958500004],
              [14.439952019000089, 77.58608633000006],
              [14.521494988000086, 77.57314687700006],
              [14.595876498000052, 77.53449127800008],
              [14.582774285000085, 77.52309804900005],
              [14.564789259000065, 77.51439036700003],
              [14.545258009000065, 77.50897858300004],
              [14.527517123000052, 77.50714752800008],
              [14.547618035000085, 77.49249909100007],
              [14.583181186000047, 77.49140045800004],
              [14.651052280000044, 77.49970123900005],
              [14.711110873000052, 77.49445221600007],
              [14.738942905000044, 77.49762604400007],
              [14.760915561000047, 77.51337311400005],
              [14.760915561000047, 77.53758372600004],
              [14.764903191000087, 77.54584381700005],
              [14.774180535000085, 77.54877350500004],
              [14.904307488000086, 77.54816315300008],
              [14.996755405000044, 77.56427643400008],
              [15.04232832100007, 77.56671784100007],
              [15.141856316000087, 77.54547760600008],
              [15.497569206500089, 77.53851959850007],
              [15.85328209700009, 77.53156159100007],
              [15.877452019000089, 77.52387116100005],
              [15.89429772200009, 77.51654694200005],
              [15.941254102000073, 77.50234609600005],
              [15.999278191000087, 77.49461497600004],
              [16.03687584700009, 77.48191966400003],
              [16.10401451900009, 77.44912344000005],
              [16.124847852000073, 77.44269440300008],
              [16.199880405000044, 77.43829987200007],
              [16.221364780000044, 77.44086334800005],
              [16.220957879000082, 77.44745514500005],
              [16.192881707000083, 77.46621328300006],
              [16.219493035000085, 77.47426992400005],
              [16.30958092500009, 77.46621328300006],
              [16.270762566000087, 77.48745351800005],
              [16.097178582000083, 77.49970123900005],
              [16.02865644600007, 77.51439036700003],
              [15.989268425000091, 77.53123607000003],
              [15.951019727000073, 77.54165273600006],
              [15.935557488000086, 77.55158112200007],
              [15.898936394000089, 77.56964752800008],
              [15.845876498000052, 77.57880280200004],
              [15.40597578200007, 77.60101959850005],
              [14.966075066000087, 77.62323639500005],
              [14.910817905000044, 77.61546458500004],
              [14.883799675000091, 77.61701080900008],
              [14.866384311000047, 77.62303294500003],
              [14.834239129000082, 77.63873932500007],
              [14.814952019000089, 77.64435455900008],
              [14.773448113000086, 77.64887116100005],
              [14.753103061000047, 77.65399811400005],
              [14.740489129000082, 77.66421133000006],
              [14.858571811000047, 77.68280670800004],
              [15.03296959700009, 77.68451569200005],
              [15.115407748000052, 77.70319245000007],
              [15.49035349466673, 77.72630442900008],
              [15.865299241333409, 77.74941640800007],
              [16.240244988000086, 77.77252838700008],
              [16.33334394600007, 77.79759349200003],
              [16.60165449300007, 77.80447011950005],
              [16.869965040000068, 77.81134674700007],
              [16.953379754000082, 77.79352448100008],
              [17.01270592500009, 77.79596588700008],
              [17.035166863000086, 77.79144928600005],
              [17.054535352000073, 77.78343333500004],
              [17.08057701900009, 77.77692291900007],
              [17.106130405000044, 77.77521393400008],
              [17.124522332000083, 77.78148021000004],
              [17.07943769600007, 77.79743073100008],
              [17.024668816000087, 77.80776601800005],
              [16.91968834700009, 77.81500885600008],
              [16.881683790000068, 77.82196686400005],
              [16.847992384000065, 77.83869049700007],
              [16.789317254000082, 77.87714264500005],
              [16.814300977000073, 77.88934967700004],
              [16.842458530000044, 77.88593170800004],
              [16.871267123000052, 77.87811920800004],
              [16.898610873000052, 77.87714264500005],
              [16.968760613000086, 77.89996979400007],
              [16.994802280000044, 77.90497467700004],
              [16.983897332000083, 77.90814850500004],
              [16.97437584700009, 77.91225820500006],
              [16.96656334700009, 77.91766998900005],
              [16.96070397200009, 77.92487213700008],
              [16.972992384000065, 77.92552317900004],
              [16.985118035000085, 77.92816803600005],
              [16.996836785000085, 77.93256256700005],
              [17.007823113000086, 77.93854401200008],
              [16.761241082000083, 77.91201406500005],
              [16.72820071700005, 77.90330638200004],
              [16.714854363000086, 77.87714264500005],
              [16.682871941000087, 77.86603424700007],
              [16.23410078200007, 77.85069407750007],
              [15.785329623000052, 77.83535390800006],
              [15.59546959700009, 77.87734609600005],
              [15.554535352000073, 77.88011302300004],
              [15.308929884000065, 77.85663483300004],
              [15.090342644000089, 77.79096100500004],
              [14.76889082100007, 77.78091054900005],
              [14.71843509200005, 77.76947663000004],
              [14.670258009000065, 77.76902903900003],
              [14.568614129000082, 77.79344310100004],
              [14.52125084700009, 77.78148021000004],
              [14.63062584700009, 77.76788971600007],
              [14.599131707000083, 77.75971100500004],
              [14.457774285000085, 77.75804271000004],
              [14.356618686000047, 77.76788971600007],
              [14.292165561000047, 77.75999583500004],
              [14.26107832100007, 77.75983307500007],
              [14.21029707100007, 77.78229401200008],
              [14.17554772200009, 77.78424713700008],
              [14.109873894000089, 77.77407461100006],
              [14.011566602000073, 77.73407623900005],
              [13.957041863000086, 77.71991608300004],
              [13.914317254000082, 77.72996653900003],
              [13.885508660000085, 77.74453359600005],
              [13.857432488000086, 77.74404531500005],
              [13.797618035000085, 77.73309967700004],
              [13.77116946700005, 77.73436107000003],
              [13.752940300000091, 77.73944733300004],
              [13.737315300000091, 77.74994538000004],
              [13.718760613000086, 77.76788971600007],
              [13.774424675000091, 77.77533600500004],
              [13.801605665000068, 77.78514232000003],
              [13.821787957000083, 77.80141836100006],
              [13.785655144000089, 77.82713450700004],
              [13.74154707100007, 77.83673737200007],
              [13.69499759200005, 77.84076569200005],
              [13.651133660000085, 77.84979889500005],
              [13.66570071700005, 77.86033763200004],
              [13.672211134000065, 77.87653229400007],
              [13.670664910000085, 77.89398834800005],
              [13.660817905000044, 77.90814850500004],
              [13.65170332100007, 77.91840241100005],
              [13.633148634000065, 77.94989655200004],
              [13.63062584700009, 77.95966217700004],
              [13.645192905000044, 77.98114655200004],
              [13.662608269000089, 77.98761627800008],
              [13.670664910000085, 77.99380117400005],
              [13.656586134000065, 78.01422760600008],
              [13.640635613000086, 78.02777741100005],
              [13.606944207000083, 78.04344310100004],
              [13.589121941000087, 78.05585358300004],
              [13.613536004000082, 78.06362539300005],
              [13.698252800000091, 78.06207916900007],
              [13.784678582000083, 78.08026764500005],
              [13.829112175000091, 78.08478424700007],
              [13.852386915000068, 78.09454987200007],
              [13.866221550000091, 78.09686920800004],
              [13.957692905000044, 78.09568919500003],
              [14.00953209700009, 78.08812083500004],
              [14.074880405000044, 78.07013580900008],
              [14.24000084700009, 78.00397370000007],
              [14.256602410000085, 78.00063711100006],
              [14.262868686000047, 77.99518463700008],
              [14.268239780000044, 77.98322174700007],
              [14.275645379000082, 77.97125885600008],
              [14.287445509000065, 77.96588776200008],
              [14.330088738000086, 77.96442291900007],
              [14.347911004000082, 77.96845123900005],
              [14.359629754000082, 77.98061758000006],
              [14.353688998000052, 77.98883698100008],
              [14.348399285000085, 78.00556061400005],
              [14.346039259000065, 78.01996491100005],
              [14.324392123000052, 78.03880442900004],
              [14.252207879000082, 78.06244538000004],
              [14.222829623000052, 78.07916901200008],
              [14.232758009000065, 78.09345123900005],
              [14.633718295500074, 78.10504791850005],
              [15.034678582000083, 78.11664459800005],
              [15.024912957000083, 78.12348053600005],
              [14.993662957000083, 78.13715241100005],
              [15.020030144000089, 78.14728424700007],
              [15.084483269000089, 78.16217682500007],
              [15.11304772200009, 78.16449616100005],
              [15.139414910000085, 78.16990794500003],
              [15.190196160000085, 78.19379303600005],
              [15.239756707000083, 78.20351797100005],
              [15.295176629000082, 78.22223541900007],
              [15.41732832100007, 78.23859284100007],
              [15.557383660000085, 78.23969147300005],
              [15.61459394600007, 78.22288646000004],
              [15.693532748000052, 78.21482982000003],
              [15.719899936000047, 78.21914297100005],
              [15.729665561000047, 78.23395416900007],
              [15.709727410000085, 78.24485911700003],
              [15.634287957000083, 78.25722890800006],
              [15.617360873000052, 78.26569245000007],
              [15.590179884000065, 78.28864166900007],
              [15.610199415000068, 78.30263906500005],
              [15.641286655000044, 78.31342194200005],
              [15.795095248000052, 78.34292226800005],
              [15.828379754000082, 78.34210846600007],
              [15.864756707000083, 78.33714427300004],
              [15.901215040000068, 78.33612702000005],
              [16.064463738000086, 78.35199616100005],
              [16.089854363000086, 78.36107005400004],
              [16.103363477000073, 78.36371491100005],
              [16.140798373000052, 78.36351146000004],
              [16.293793165000068, 78.34031810100004],
              [16.61516360750008, 78.34629954650003],
              [16.93653405000009, 78.35228099200003],
              [17.09742272200009, 78.38841380400004],
              [17.146657748000052, 78.39411041900007],
              [17.198415561000047, 78.40778229400007],
              [17.272308790000068, 78.41388580900008],
              [17.293711785000085, 78.42039622600004],
              [17.296397332000083, 78.43260325700004],
              [17.260101759000065, 78.44428131700005],
              [17.197601759000065, 78.44208405200004],
              [16.850840691000087, 78.38491445500006],
              [16.627696160000085, 78.40582916900007],
              [16.604746941000087, 78.41083405200004],
              [16.586680535000085, 78.42169830900008],
              [16.583994988000086, 78.42560455900008],
              [16.578135613000086, 78.43793366100005],
              [16.576996290000068, 78.44220612200007],
              [16.57007897200009, 78.44537995000007],
              [16.526052280000044, 78.44562409100007],
              [16.410980665000068, 78.43260325700004],
              [16.390879754000082, 78.43618398600006],
              [16.351817254000082, 78.45062897300005],
              [16.329925977000073, 78.45246002800008],
              [16.329925977000073, 78.45929596600007],
              [16.34734134200005, 78.45929596600007],
              [16.36573326900009, 78.46185944200005],
              [16.400563998000052, 78.47162506700005],
              [16.427989129000082, 78.48330312700006],
              [16.436289910000085, 78.49017975500004],
              [16.446055535000085, 78.50092194200005],
              [16.459320509000065, 78.52020905200004],
              [16.467621290000068, 78.52985260600008],
              [16.48023522200009, 78.53876373900005],
              [16.495290561000047, 78.54535553600005],
              [16.647146030000044, 78.59100983300004],
              [16.676036004000082, 78.60700104400007],
              [16.688975457000083, 78.61741771000004],
              [16.703379754000082, 78.62645091400003],
              [16.718597852000073, 78.63353099200003],
              [16.73414147200009, 78.63808828300006],
              [16.80958092500009, 78.63979726800005],
              [16.82715905000009, 78.64801666900007],
              [16.828949415000068, 78.67332591400003],
              [16.789235873000052, 78.67910390800006],
              [16.628754102000073, 78.67161692900004],
              [16.617442254000082, 78.67499420800004],
              [16.615896030000044, 78.68870677300004],
              [16.610850457000083, 78.69594961100006],
              [16.602386915000068, 78.70042552300004],
              [16.554209832000083, 78.71930573100008],
              [16.52279707100007, 78.71784088700008],
              [16.494313998000052, 78.70551178600005],
              [16.455088738000086, 78.67845286700003],
              [16.414073113000086, 78.66339752800008],
              [16.380381707000083, 78.65737539300005],
              [16.365896030000044, 78.65155670800004],
              [16.357432488000086, 78.63808828300006],
              [16.374847852000073, 78.63255442900004],
              [16.37273196700005, 78.62079498900005],
              [16.35906009200005, 78.60781484600005],
              [16.342051629000082, 78.59886302300004],
              [16.338145379000082, 78.59491608300004],
              [16.33106530000009, 78.57933177300004],
              [16.326508009000065, 78.57257721600007],
              [16.31771894600007, 78.56777578300006],
              [16.04200280000009, 78.52073802300004],
              [16.04786217500009, 78.49461497600004],
              [16.001963738000086, 78.48273346600007],
              [15.720713738000086, 78.47056712450006],
              [15.439463738000086, 78.45840078300006],
              [15.342458530000044, 78.48427969000005],
              [15.261241082000083, 78.54246653900003],
              [15.256114129000082, 78.56464264500005],
              [15.24195397200009, 78.57807038000004],
              [15.22201582100007, 78.58543528900003],
              [15.192881707000083, 78.58958567900004],
              [15.203786655000044, 78.59658437700006],
              [15.215586785000085, 78.60146719000005],
              [15.22787519600007, 78.60407135600008],
              [15.233246290000068, 78.61017487200007],
              [15.401540561000047, 78.61692942900004],
              [15.422618035000085, 78.62225983300004],
              [15.446055535000085, 78.63589101800005],
              [15.465098504000082, 78.65460846600007],
              [15.48015384200005, 78.68964264500005],
              [15.493337436000047, 78.70917389500005],
              [15.498789910000085, 78.72630442900004],
              [15.475108269000089, 78.73761627800008],
              [15.472911004000082, 78.74677155200004],
              [15.471446160000085, 78.75702545800004],
              [15.466319207000083, 78.76439036700003],
              [15.441742384000065, 78.77383047100005],
              [15.432139519000089, 78.77903880400004],
              [15.425059441000087, 78.78827545800004],
              [15.44076582100007, 78.79051341400003],
              [15.457041863000086, 78.79564036700003],
              [15.486582879000082, 78.80878327000005],
              [15.465993686000047, 78.82062409100007],
              [15.421071811000047, 78.83405182500007],
              [15.401133660000085, 78.84690989800004],
              [15.381521030000044, 78.85138580900008],
              [15.352224155000044, 78.84564850500004],
              [15.30209394600007, 78.82611725500004],
              [15.233897332000083, 78.78485748900005],
              [15.222911004000082, 78.77269114800004],
              [15.219981316000087, 78.75796133000006],
              [15.215342644000089, 78.74555084800005],
              [15.199066602000073, 78.74046458500004],
              [15.202647332000083, 78.73187897300005],
              [15.20875084700009, 78.72549062700006],
              [15.217051629000082, 78.72142161700003],
              [15.227061394000089, 78.72003815300008],
              [15.206553582000083, 78.70636627800008],
              [15.219248894000089, 78.70416901200008],
              [15.225352410000085, 78.69818756700005],
              [15.225433790000068, 78.68927643400008],
              [15.220225457000083, 78.67841217700004],
              [15.231700066000087, 78.67910390800006],
              [15.242442254000082, 78.67706940300008],
              [15.252289259000065, 78.67251211100006],
              [15.261241082000083, 78.66535065300008],
              [15.209320509000065, 78.65619538000004],
              [15.057871941000087, 78.64736562700006],
              [15.021006707000083, 78.61692942900004],
              [15.027191602000073, 78.61570872600004],
              [15.041514519000089, 78.61017487200007],
              [14.982676629000082, 78.59739817900004],
              [14.919932488000086, 78.60765208500004],
              [14.801280144000089, 78.64423248900005],
              [14.814952019000089, 78.65412018400008],
              [14.831228061000047, 78.66132233300004],
              [14.844574415000068, 78.67035553600005],
              [14.849619988000086, 78.68585846600007],
              [14.842133009000065, 78.70014069200005],
              [14.815196160000085, 78.72113678600005],
              [14.814952019000089, 78.73362864800004],
              [14.72787519600007, 78.73554108300004],
              [14.679698113000086, 78.73041413000004],
              [14.629161004000082, 78.71735260600008],
              [14.575368686000047, 78.69000885600008],
              [14.488129102000073, 78.68659088700008],
              [14.445567254000082, 78.67841217700004],
              [14.445567254000082, 78.67157623900005],
              [14.525726759000065, 78.66429271000004],
              [14.541758660000085, 78.65790436400005],
              [14.545909050000091, 78.64716217700004],
              [14.542816602000073, 78.63959381700005],
              [14.537364129000082, 78.63178131700005],
              [14.534353061000047, 78.62034739800004],
              [14.53646894600007, 78.61725495000007],
              [14.541188998000052, 78.61554596600007],
              [14.545746290000068, 78.61286041900007],
              [14.548024936000047, 78.60700104400007],
              [14.547048373000052, 78.60211823100008],
              [14.54273522200009, 78.59247467700004],
              [14.541758660000085, 78.58657461100006],
              [14.547618035000085, 78.57501862200007],
              [14.561371290000068, 78.56818268400008],
              [14.577321811000047, 78.56281159100007],
              [14.58961022200009, 78.55548737200007],
              [14.562347852000073, 78.54393138200004],
              [14.502207879000082, 78.54608795800004],
              [14.472911004000082, 78.54246653900003],
              [14.383555535000085, 78.50092194200005],
              [14.41968834700009, 78.47553131700005],
              [14.481455925000091, 78.46332428600005],
              [14.599864129000082, 78.45929596600007],
              [14.640635613000086, 78.45343659100007],
              [14.676280144000089, 78.43793366100005],
              [14.707041863000086, 78.41596100500004],
              [14.733653191000087, 78.39105866100005],
              [14.663096550000091, 78.38108958500004],
              [14.451914910000085, 78.38422272300005],
              [14.459239129000082, 78.37738678600005],
              [14.432871941000087, 78.36884186400005],
              [14.402354363000086, 78.37384674700007],
              [14.342621290000068, 78.39105866100005],
              [14.31023196700005, 78.39199453300006],
              [14.285980665000068, 78.38743724200003],
              [14.266123894000089, 78.37791575700004],
              [14.246348504000082, 78.36371491100005],
              [14.258555535000085, 78.35431549700007],
              [14.287608269000089, 78.34381745000007],
              [14.301524285000085, 78.33637116100005],
              [14.306651238000086, 78.33112213700008],
              [14.32203209700009, 78.30849844000005],
              [14.281911655000044, 78.30508047100005],
              [14.126231316000087, 78.26337311400005],
              [14.101573113000086, 78.25063711100006],
              [14.07585696700005, 78.24290599200003],
              [14.040293816000087, 78.24701569200005],
              [14.04851321700005, 78.26117584800005],
              [14.063649936000047, 78.27045319200005],
              [14.081228061000047, 78.27846914300005],
              [14.096690300000091, 78.28864166900007],
              [14.02084394600007, 78.28180573100008],
              [14.006032748000052, 78.28351471600007],
              [13.99382571700005, 78.28632233300004],
              [13.981455925000091, 78.28693268400008],
              [13.965830925000091, 78.28180573100008],
              [13.95093834700009, 78.27179596600007],
              [13.94499759200005, 78.26072825700004],
              [13.94467207100007, 78.22650788000004],
              [13.924082879000082, 78.23818594000005],
              [13.898610873000052, 78.24778880400004],
              [13.798024936000047, 78.27045319200005],
              [13.771983269000089, 78.27106354400007],
              [13.746104363000086, 78.26752350500004],
              [13.772715691000087, 78.25120677300004],
              [13.839366082000083, 78.23354726800005],
              [13.855967644000089, 78.21287669500003],
              [13.50228925850007, 78.22052643450004],
              [13.148610873000052, 78.22817617400005],
              [13.081879102000073, 78.21914297100005],
              [13.032481316000087, 78.20404694200005],
              [13.009613477000073, 78.20384349200003],
              [12.960948113000086, 78.22016022300005],
              [12.927256707000083, 78.23578522300005],
              [12.911306186000047, 78.24701569200005],
              [12.94703209700009, 78.26105377800008],
              [12.95834394600007, 78.26752350500004],
              [12.952972852000073, 78.27220286700003],
              [12.943858269000089, 78.28384023600006],
              [12.938649936000047, 78.28864166900007],
              [12.951508009000065, 78.29539622600004],
              [12.856618686000047, 78.32273997600004],
              [12.903819207000083, 78.32273997600004],
              [12.88648522200009, 78.34772370000007],
              [12.858083530000044, 78.35968659100007],
              [12.65756269600007, 78.37734609600005],
              [12.568369988000086, 78.40485260600008],
              [12.506521030000044, 78.43537018400008],
              [12.47592207100007, 78.44212474200003],
              [12.430918816000087, 78.46613190300008],
              [12.377126498000052, 78.47736237200007],
              [12.362559441000087, 78.48725006700005],
              [12.531260613000086, 78.50706614800004],
              [13.001963738000086, 78.50824616100005],
              [13.198008660000085, 78.54246653900003],
              [13.146006707000083, 78.55512116100005],
              [13.08570397200009, 78.55231354400007],
              [12.97201582100007, 78.53506094000005],
              [12.700856967000078, 78.53961823150004],
              [12.429698113000086, 78.54417552300004],
              [12.389821811000047, 78.55133698100008],
              [12.36882571700005, 78.57599518400008],
              [12.376231316000087, 78.58344147300005],
              [12.347178582000083, 78.59568919500003],
              [12.020518425000091, 78.61444733300004],
              [11.941905144000089, 78.63373444200005],
              [11.903575066000087, 78.63808828300006],
              [11.882090691000087, 78.64386627800008],
              [11.859711134000065, 78.65766022300005],
              [11.850759311000047, 78.67352936400005],
              [11.869151238000086, 78.68585846600007],
              [11.843028191000087, 78.70270416900007],
              [11.805918816000087, 78.71043528900003],
              [11.735606316000087, 78.71259186400005],
              [11.711680535000085, 78.71605052300004],
              [11.681488477000073, 78.72483958500004],
              [11.655284050000091, 78.73615143400008],
              [11.643239780000044, 78.74725983300004],
              [11.665293816000087, 78.76019928600005],
              [11.73218834700009, 78.81244538000004],
              [11.780772332000083, 78.82558828300006],
              [11.887461785000085, 78.81708405200004],
              [11.937347852000073, 78.82245514500005],
              [11.90170332100007, 78.84430573100008],
              [11.856618686000047, 78.85561758000006],
              [11.564463738000086, 78.88715241100005],
              [11.506032748000052, 78.90497467700004],
              [11.441661004000082, 78.91559479400007],
              [11.370371941000087, 78.94122955900008],
              [11.345957879000082, 78.95416901200008],
              [11.334157748000052, 78.97321198100008],
              [11.567067905000044, 78.98493073100008],
              [11.907928907500064, 78.94324371950006],
              [12.248789910000085, 78.90155670800004],
              [12.474131707000083, 78.90228913000004],
              [12.506602410000085, 78.91181061400005],
              [12.499847852000073, 78.91950104400007],
              [12.478688998000052, 78.93911367400005],
              [12.46070397200009, 78.95213450700004],
              [12.458181186000047, 78.95648834800005],
              [12.457692905000044, 78.96942780200004],
              [12.455577019000089, 78.97455475500004],
              [12.451426629000082, 78.98004791900007],
              [12.424327019000089, 78.99664948100008],
              [12.390798373000052, 79.00214264500005],
              [12.064789259000065, 78.97426992400005],
              [11.979014519000089, 78.98688385600008],
              [12.008148634000065, 78.99502187700006],
              [12.042816602000073, 78.99982330900008],
              [12.10873457100007, 79.00055573100008],
              [12.084808790000068, 79.01093170800004],
              [12.05836022200009, 79.01463450700004],
              [12.002289259000065, 79.01422760600008],
              [11.770192905000044, 79.05849844000005],
              [11.711110873000052, 79.06183502800008],
              [11.683604363000086, 79.06940338700008],
              [11.736582879000082, 79.07843659100007],
              [11.761241082000083, 79.08588288000004],
              [11.80795332100007, 79.11493561400005],
              [11.856944207000083, 79.12197500200006],
              [11.882823113000086, 79.13084544500003],
              [11.875743035000085, 79.13784414300005],
              [11.867686394000089, 79.14252350500004],
              [11.858571811000047, 79.14500560100004],
              [11.848643425000091, 79.14516836100006],
              [11.89421634200005, 79.16022370000007],
              [11.906748894000089, 79.16844310100004],
              [11.925303582000083, 79.18768952000005],
              [11.93523196700005, 79.19415924700007],
              [11.951019727000073, 79.19985586100006],
              [11.996429884000065, 79.20644765800006],
              [12.090505405000044, 79.20587799700007],
              [12.135996941000087, 79.21344635600008],
              [12.120941602000073, 79.22589752800008],
              [12.074880405000044, 79.22801341400003],
              [12.06031334700009, 79.24070872600004],
              [12.100108269000089, 79.25873444200005],
              [12.11500084700009, 79.26121653900003],
              [12.108083530000044, 79.26740143400008],
              [12.10287519600007, 79.27440013200004],
              [12.09506269600007, 79.28851959800005],
              [12.101735873000052, 79.29148997600004],
              [12.11500084700009, 79.30219147300005],
              [12.081228061000047, 79.30329010600008],
              [11.985199415000068, 79.28851959800005],
              [11.834971550000091, 79.29596588700008],
              [11.90593509200005, 79.25067780200004],
              [11.916840040000068, 79.24070872600004],
              [11.896657748000052, 79.22553131700005],
              [11.85287519600007, 79.22601959800005],
              [11.807139519000089, 79.23554108300004],
              [11.779795769000089, 79.24754466400003],
              [11.787282748000052, 79.25438060100004],
              [11.772146030000044, 79.25812409100007],
              [11.724782748000052, 79.27830638200004],
              [11.716807488000086, 79.28558991100005],
              [11.712087436000047, 79.29498932500007],
              [11.705251498000052, 79.30369700700004],
              [11.69109134200005, 79.30963776200008],
              [11.69109134200005, 79.32221100500004],
              [11.594737175000091, 79.30963776200008],
              [11.601573113000086, 79.30219147300005],
              [11.591319207000083, 79.29401276200008],
              [11.578949415000068, 79.28876373900005],
              [11.553233269000089, 79.28172435100004],
              [11.592784050000091, 79.27277252800008],
              [11.690440300000091, 79.21686432500007],
              [11.722666863000086, 79.18756745000007],
              [11.700450066000087, 79.16803620000007],
              [11.279307488000086, 79.09955475500004],
              [11.22828209700009, 79.10065338700008],
              [11.183848504000082, 79.12409088700008],
              [11.205088738000086, 79.12946198100008],
              [11.200368686000047, 79.13800690300008],
              [11.176442905000044, 79.15131256700005],
              [11.174082879000082, 79.15875885600008],
              [11.170176629000082, 79.18891022300005],
              [11.16187584700009, 79.21600983300004],
              [11.140961134000065, 79.23663971600007],
              [11.11304772200009, 79.24982330900008],
              [11.066742384000065, 79.25739166900007],
              [11.051768425000091, 79.26496002800008],
              [11.039317254000082, 79.27488841400003],
              [11.010590040000068, 79.30483633000006],
              [11.001231316000087, 79.31004466400003],
              [10.984629754000082, 79.31586334800005],
              [10.912445509000065, 79.32953522300005],
              [10.84115644600007, 79.37103913000004],
              [10.898773634000065, 79.37807851800005],
              [10.916351759000065, 79.38475169500003],
              [10.87077884200005, 79.39520905200004],
              [10.861827019000089, 79.39899323100008],
              [10.85523522200009, 79.41083405200004],
              [10.860606316000087, 79.41498444200005],
              [10.871348504000082, 79.41632721600007],
              [10.88217207100007, 79.41950104400007],
              [10.906423373000052, 79.43056875200006],
              [10.916270379000082, 79.43939850500004],
              [10.912608269000089, 79.44989655200004],
              [10.908457879000082, 79.45604075700004],
              [10.904958530000044, 79.46381256700005],
              [10.90007571700005, 79.47064850500004],
              [10.89226321700005, 79.47353750200006],
              [10.880869988000086, 79.47622304900005],
              [10.84115644600007, 79.49404531500005],
              [10.787364129000082, 79.50649648600006],
              [10.740733269000089, 79.50824616100005],
              [10.715179884000065, 79.51211172100005],
              [10.693614129000082, 79.52240631700005],
              [10.676768425000091, 79.54242584800005],
              [10.708018425000091, 79.56142812700006],
              [11.183848504000082, 79.56293366100005],
              [11.145681186000047, 79.57391998900005],
              [10.854991082000083, 79.59699127800008],
              [10.867360873000052, 79.60932038000004],
              [10.889659050000091, 79.61847565300008],
              [11.013682488000086, 79.64996979400007],
              [11.43327884200005, 79.62750885600008],
              [11.457692905000044, 79.63178131700005],
              [11.455577019000089, 79.64545319200005],
              [11.42937259200005, 79.65350983300004],
              [11.352549675000091, 79.66185130400004],
              [11.233083530000044, 79.69863515800006],
              [11.213877800000091, 79.70807526200008],
              [11.197601759000065, 79.72117747600004],
              [11.202647332000083, 79.72239817900004],
              [11.21257571700005, 79.72626373900005],
              [11.218028191000087, 79.72736237200007],
              [11.21615644600007, 79.73086172100005],
              [11.213715040000068, 79.73773834800005],
              [11.21062259200005, 79.74164459800005],
              [11.217784050000091, 79.74575429900005],
              [11.238536004000082, 79.76093170800004],
              [11.190114780000044, 79.77521393400008],
              [11.227305535000085, 79.78803131700005],
              [11.283457879000082, 79.78929271000004],
              [11.47632897200009, 79.76727936400005],
              [11.523773634000065, 79.76707591400003],
              [11.560069207000083, 79.78880442900004],
              [11.525889519000089, 79.80927155200004],
              [11.550303582000083, 79.81366608300004],
              [11.60515384200005, 79.80573151200008],
              [11.625498894000089, 79.81268952000005],
              [11.638682488000086, 79.82355377800008],
              [11.653493686000047, 79.83124420800004],
              [11.66960696700005, 79.83576080900008],
              [11.777354363000086, 79.84686920800004],
              [11.822276238000086, 79.84503815300008],
              [11.858571811000047, 79.82664622600004],
              [11.873871290000068, 79.81561920800004],
              [11.923675977000073, 79.80182526200008],
              [11.942881707000083, 79.79096100500004],
              [11.944509311000047, 79.78416575700004],
              [11.938975457000083, 79.77952708500004],
              [11.937347852000073, 79.77521393400008],
              [11.96070397200009, 79.76203034100007],
              [12.028005405000044, 79.73456452000005],
              [12.03296959700009, 79.72117747600004],
              [12.049327019000089, 79.71491120000007],
              [12.057302280000044, 79.71336497600004],
              [12.067149285000085, 79.71369049700007],
              [12.061696811000047, 79.70917389500005],
              [12.04664147200009, 79.69326406500005],
              [12.108409050000091, 79.67698802300004],
              [12.142832879000082, 79.67377350500004],
              [12.170176629000082, 79.67894114800004],
              [12.161957227000073, 79.68317291900007],
              [12.155284050000091, 79.68846263200004],
              [12.142832879000082, 79.70062897300005],
              [12.170664910000085, 79.70917389500005],
              [12.199229363000086, 79.70416901200008],
              [12.281748894000089, 79.66738515800006],
              [12.297048373000052, 79.66498444200005],
              [12.330902540000068, 79.66840241100005],
              [12.336599155000044, 79.66998932500007],
              [12.34546959700009, 79.68268463700008],
              [12.349619988000086, 79.71747467700004],
              [12.303558790000068, 79.73688385600008],
              [12.204356316000087, 79.75462474200003],
              [12.218028191000087, 79.76251862200007],
              [12.197438998000052, 79.76829661700003],
              [12.204356316000087, 79.77521393400008],
              [12.188649936000047, 79.77724844000005],
              [12.17351321700005, 79.78310781500005],
              [12.163584832000083, 79.79344310100004],
              [12.163340691000087, 79.80927155200004],
              [12.172618035000085, 79.81688060100004],
              [12.204356316000087, 79.83722565300008],
              [12.391123894000089, 79.83417389500005],
              [12.451426629000082, 79.82355377800008],
              [12.488780144000089, 79.80971914300005],
              [12.495941602000073, 79.80556875200006],
              [12.50562584700009, 79.79824453300006],
              [12.526377800000091, 79.79266998900005],
              [12.533864780000044, 79.78880442900004],
              [12.541758660000085, 79.77431875200006],
              [12.53288821700005, 79.76569245000007],
              [12.492930535000085, 79.75462474200003],
              [12.536631707000083, 79.74628327000005],
              [12.684092644000089, 79.77521393400008],
              [12.767588738000086, 79.77326080900008],
              [12.91578209700009, 79.79824453300006],
              [12.959971550000091, 79.81110260600008],
              [13.060069207000083, 79.82859935100004],
              [13.250010613000086, 79.83681875200006],
              [13.356130405000044, 79.85846588700008],
              [13.583181186000047, 79.85748932500007],
              [13.797048373000052, 79.88190338700008],
              [13.842133009000065, 79.87787506700005],
              [13.885590040000068, 79.86652252800008],
              [13.950205925000091, 79.83734772300005],
              [13.95443769600007, 79.83030833500004],
              [13.958994988000086, 79.81610748900005],
              [13.959808790000068, 79.80414459800005],
              [13.958506707000083, 79.79437897300005],
              [13.960785352000073, 79.78522370000007],
              [13.972666863000086, 79.77521393400008],
              [13.897146030000044, 79.73773834800005],
              [13.738291863000086, 79.70644765800006],
              [13.262380405000044, 79.69367096600007],
              [13.239024285000085, 79.70062897300005],
              [13.19117272200009, 79.69301992400005],
              [13.013682488000086, 79.69326406500005],
              [13.027354363000086, 79.67894114800004],
              [13.010508660000085, 79.67291901200008],
              [12.64625084700009, 79.59442780200004],
              [12.563975457000083, 79.59076569200005],
              [12.49935957100007, 79.59516022300005],
              [12.469248894000089, 79.58954498900005],
              [12.451426629000082, 79.56907786700003],
              [12.482432488000086, 79.56679922100005],
              [12.545176629000082, 79.55206940300008],
              [12.577647332000083, 79.54857005400004],
              [12.610036655000044, 79.55117422100005],
              [12.704600457000083, 79.56907786700003],
              [12.901621941000087, 79.57221100500004],
              [13.033457879000082, 79.59735748900005],
              [13.181976759000065, 79.59149811400005],
              [13.287852410000085, 79.60236237200007],
              [13.396494988000086, 79.59076569200005],
              [13.451670769000089, 79.59243398600006],
              [13.477224155000044, 79.58649323100008],
              [13.492849155000044, 79.56907786700003],
              [13.430430535000085, 79.53400299700007],
              [13.410492384000065, 79.52875397300005],
              [13.393402540000068, 79.52667877800008],
              [13.359222852000073, 79.51707591400003],
              [13.342051629000082, 79.51447174700007],
              [13.322927280000044, 79.51544830900008],
              [13.285817905000044, 79.52155182500007],
              [13.266856316000087, 79.52191803600005],
              [13.277679884000065, 79.50901927300004],
              [13.287364129000082, 79.49404531500005],
              [13.276866082000083, 79.49335358300004],
              [13.268565300000091, 79.48965078300006],
              [13.262705925000091, 79.48297760600008],
              [13.25953209700009, 79.47353750200006],
              [13.30054772200009, 79.47142161700003],
              [13.457204623000052, 79.43960195500006],
              [13.478688998000052, 79.44110748900005],
              [13.486582879000082, 79.45302969000005],
              [13.479502800000091, 79.45994700700004],
              [13.437673373000052, 79.48094310100004],
              [13.475271030000044, 79.49140045800004],
              [13.52711022200009, 79.49433014500005],
              [13.579112175000091, 79.49054596600007],
              [13.61695397200009, 79.48094310100004],
              [13.621592644000089, 79.47646719000005],
              [13.625498894000089, 79.46430084800005],
              [13.63062584700009, 79.45986562700006],
              [13.644379102000073, 79.45636627800008],
              [13.676280144000089, 79.45429108300004],
              [13.759287957000083, 79.44025299700007],
              [13.780284050000091, 79.43256256700005],
              [13.785004102000073, 79.42023346600007],
              [13.807383660000085, 79.41120026200008],
              [13.873383009000065, 79.39337799700007],
              [13.87826582100007, 79.38996002800008],
              [13.898448113000086, 79.36786530200004],
              [13.906260613000086, 79.36440664300005],
              [13.917979363000086, 79.36424388200004],
              [13.907074415000068, 79.34048086100006],
              [13.905528191000087, 79.32843659100007],
              [13.910655144000089, 79.31586334800005],
              [13.891123894000089, 79.30605703300006],
              [13.898610873000052, 79.29364655200004],
              [13.920746290000068, 79.28424713700008],
              [13.945567254000082, 79.28351471600007],
              [13.976735873000052, 79.28725820500006],
              [13.998383009000065, 79.28261953300006],
              [14.041677280000044, 79.26581452000005],
              [14.073090040000068, 79.26951732000003],
              [14.104746941000087, 79.28912995000007],
              [14.158213738000086, 79.34316640800006],
              [14.141856316000087, 79.34813060100004],
              [14.10287519600007, 79.37726471600007],
              [14.081065300000091, 79.38686758000006],
              [14.035411004000082, 79.39736562700006],
              [14.014333530000044, 79.40521881700005],
              [14.021739129000082, 79.41258372600004],
              [14.029795769000089, 79.41836172100005],
              [14.038584832000083, 79.42267487200007],
              [14.048350457000083, 79.42572663000004],
              [14.031504754000082, 79.43561432500007],
              [14.021820509000065, 79.44953034100007],
              [14.009938998000052, 79.46190013200004],
              [13.966970248000052, 79.47256094000005],
              [13.94507897200009, 79.48407623900005],
              [13.93531334700009, 79.49579498900005],
              [13.952159050000091, 79.50145091400003],
              [13.899261915000068, 79.52993398600006],
              [13.883148634000065, 79.54242584800005],
              [13.900401238000086, 79.54897695500006],
              [13.952159050000091, 79.57656484600005],
              [14.074961785000085, 79.60639069200005],
              [14.252614780000044, 79.60984935100004],
              [14.280528191000087, 79.61749909100007],
              [14.246429884000065, 79.61884186400005],
              [14.177582227000073, 79.63153717700004],
              [14.14389082100007, 79.63178131700005],
              [14.17554772200009, 79.65143463700008],
              [14.268565300000091, 79.66339752800008],
              [14.307790561000047, 79.67279694200005],
              [14.275645379000082, 79.67182038000004],
              [14.260101759000065, 79.67352936400005],
              [14.246348504000082, 79.67894114800004],
              [14.276540561000047, 79.69367096600007],
              [14.403493686000047, 79.73891836100006],
              [14.491709832000083, 79.78668854400007],
              [14.514414910000085, 79.80353424700007],
              [14.527517123000052, 79.80927155200004],
              [14.54859459700009, 79.81146881700005],
              [14.857920769000089, 79.77366771000004],
              [14.924571160000085, 79.75128815300008],
              [15.090668165000068, 79.66181061400005],
              [15.124034050000091, 79.65009186400005],
              [15.172373894000089, 79.64215729400007],
              [15.208262566000087, 79.62763092700004],
              [15.262380405000044, 79.61884186400005],
              [15.280284050000091, 79.61229075700004],
              [15.295258009000065, 79.60382721600007],
              [15.27279707100007, 79.58808014500005],
              [15.274587436000047, 79.58234284100007],
              [15.281748894000089, 79.56907786700003],
              [15.289805535000085, 79.56085846600007],
              [15.299082879000082, 79.55548737200007],
              [15.303070509000065, 79.54840729400007],
              [15.295258009000065, 79.53558991100005],
              [15.310394727000073, 79.52265045800004],
              [15.330088738000086, 79.51308828300006],
              [15.37045332100007, 79.50145091400003],
              [15.360850457000083, 79.48309967700004],
              [15.365570509000065, 79.47215403900003],
              [15.397715691000087, 79.45302969000005],
              [15.410004102000073, 79.44110748900005],
              [15.430674675000091, 79.41571686400005],
              [15.446055535000085, 79.40521881700005],
              [15.438731316000087, 79.38760000200006],
              [15.451914910000085, 79.37409088700008],
              [15.470713738000086, 79.36155833500004],
              [15.480316602000073, 79.34658437700006],
              [15.497325066000087, 79.33002350500004],
              [15.536387566000087, 79.32050202000005],
              [15.605723504000082, 79.31126536700003],
              [15.627940300000091, 79.30052317900004],
              [15.661143425000091, 79.27228424700007],
              [15.685801629000082, 79.26121653900003],
              [15.745371941000087, 79.25234609600005],
              [15.772715691000087, 79.24217357000003],
              [15.78874759200005, 79.22028229400007],
              [15.779307488000086, 79.22060781500005],
              [15.775238477000073, 79.21967194200005],
              [15.745371941000087, 79.20010000200006],
              [15.677256707000083, 79.17055898600006],
              [15.658457879000082, 79.15131256700005],
              [15.660492384000065, 79.12531159100007],
              [15.682139519000089, 79.11220937700006],
              [15.711599155000044, 79.11273834800005],
              [15.805186394000089, 79.16583893400008],
              [15.881602410000085, 79.16103750200006],
              [15.956553582000083, 79.13255442900004],
              [16.021006707000083, 79.10016510600008],
              [16.041188998000052, 79.09267812700006],
              [16.103363477000073, 79.07684967700004],
              [16.118988477000073, 79.06769440300008],
              [16.12631269600007, 79.05829498900005],
              [16.131521030000044, 79.03530508000006],
              [16.131683790000068, 79.02130768400008],
              [16.13054446700005, 79.01146067900004],
              [16.134938998000052, 79.00234609600005],
              [16.151866082000083, 78.99066803600005],
              [16.172048373000052, 78.98232656500005],
              [16.21420332100007, 78.97109609600005],
              [16.23414147200009, 78.96332428600005],
              [16.248708530000044, 78.95937734600005],
              [16.281911655000044, 78.95758698100008],
              [16.29590905000009, 78.95335521000004],
              [16.30054772200009, 78.94847239800004],
              [16.307302280000044, 78.93512604400007],
              [16.30958092500009, 78.93162669500003],
              [16.329274936000047, 78.92169830900008],
              [16.347911004000082, 78.91624583500004],
              [16.43523196700005, 78.91144440300008],
              [16.476573113000086, 78.91730377800008],
              [16.490896030000044, 78.93073151200008],
              [16.453461134000065, 78.95335521000004],
              [16.45639082100007, 78.95722077000005],
              [16.457774285000085, 78.96035390800006],
              [16.45866946700005, 78.96344635600008],
              [16.46029707100007, 78.96698639500005],
              [16.405039910000085, 78.97308991100005],
              [16.38135826900009, 78.98362864800004],
              [16.365489129000082, 79.02147044500003],
              [16.35059655000009, 79.03046295800004],
              [16.33366946700005, 79.03660716400003],
              [16.32007897200009, 79.04523346600007],
              [16.285166863000086, 79.09170156500005],
              [16.267914259000065, 79.10358307500007],
              [16.20997155000009, 79.12628815300008],
              [16.192881707000083, 79.13833242400005],
              [16.181813998000052, 79.15086497600004],
              [16.165293816000087, 79.17670319200005],
              [16.15528405000009, 79.18891022300005],
              [16.151866082000083, 79.20115794500003],
              [16.152354363000086, 79.21849192900004],
              [16.150726759000065, 79.23403554900005],
              [16.141368035000085, 79.24070872600004],
              [16.124847852000073, 79.24579498900005],
              [16.00945071700005, 79.29637278900003],
              [15.959483269000089, 79.30963776200008],
              [15.969004754000082, 79.33905670800004],
              [15.95289147200009, 79.37352122600004],
              [15.929698113000086, 79.40949127800008],
              [15.913910352000073, 79.45917389500005],
              [15.904470248000052, 79.47825755400004],
              [15.881195509000065, 79.51105377800008],
              [15.869802280000044, 79.51874420800004],
              [15.858653191000087, 79.52285390800006],
              [15.853037957000083, 79.52899811400005],
              [15.857676629000082, 79.54242584800005],
              [15.867686394000089, 79.54852936400005],
              [15.917979363000086, 79.56293366100005],
              [15.896657748000052, 79.56842682500007],
              [15.852224155000044, 79.56976959800005],
              [15.833181186000047, 79.57998281500005],
              [15.826833530000044, 79.58856842700004],
              [15.821136915000068, 79.60394928600005],
              [15.812998894000089, 79.61444733300004],
              [15.793142123000052, 79.62767161700003],
              [15.740489129000082, 79.65399811400005],
              [15.726735873000052, 79.66596100500004],
              [15.745371941000087, 79.67324453300006],
              [15.732269727000073, 79.68309153900003],
              [15.685801629000082, 79.70062897300005],
              [15.690277540000068, 79.70416901200008],
              [15.703868035000085, 79.71698639500005],
              [15.706309441000087, 79.72117747600004],
              [15.702647332000083, 79.72772858300004],
              [15.699066602000073, 79.72992584800005],
              [15.695648634000065, 79.73102448100008],
              [15.692637566000087, 79.73419830900008],
              [15.683848504000082, 79.74534739800004],
              [15.671397332000083, 79.75592682500007],
              [15.657725457000083, 79.76414622600004],
              [15.644786004000082, 79.76829661700003],
              [15.664561394000089, 79.78473541900007],
              [15.672048373000052, 79.78880442900004],
              [15.654307488000086, 79.80048248900005],
              [15.643402540000068, 79.81500885600008],
              [15.641856316000087, 79.83185455900008],
              [15.651621941000087, 79.85028717700004],
              [15.679535352000073, 79.86912669500003],
              [15.715830925000091, 79.87714264500005],
              [16.10287519600007, 79.85984935100004],
              [16.13770592500009, 79.87075429900005],
              [16.102224155000044, 79.89435455900008],
              [16.008636915000068, 79.90981679900005],
              [15.969981316000087, 79.92975495000007],
              [15.959727410000085, 79.93911367400005],
              [15.955739780000044, 79.94529857000003],
              [15.959727410000085, 79.95302969000005],
              [15.973806186000047, 79.96698639500005],
              [15.991058790000068, 79.97772858300004],
              [16.05567467500009, 79.99485911700003],
              [16.04468834700009, 79.99681224200003],
              [16.034678582000083, 80.00092194200005],
              [16.02670332100007, 80.00702545800004],
              [16.021657748000052, 80.01536692900004],
              [16.041188998000052, 80.01748281500005],
              [16.07943769600007, 80.02684153900003],
              [16.14112389400009, 80.03213125200006],
              [16.254649285000085, 80.06183502800008],
              [16.29468834700009, 80.06736888200004],
              [16.32976321700005, 80.06443919500003],
              [16.367930535000085, 80.05646393400008],
              [16.54151451900009, 80.04751211100006],
              [16.555918816000087, 80.04266998900005],
              [16.561778191000087, 80.03611888200004],
              [16.568369988000086, 80.01911041900007],
              [16.57325280000009, 80.01194896000004],
              [16.59278405000009, 79.99762604400007],
              [16.616465691000087, 79.98505280200004],
              [16.665212436000047, 79.96698639500005],
              [16.69581139400009, 79.96039459800005],
              [16.712168816000087, 79.95457591400003],
              [16.72046959700009, 79.94647858300004],
              [16.717133009000065, 79.93915436400005],
              [16.69776451900009, 79.92999909100007],
              [16.69312584700009, 79.92255280200004],
              [16.70639082100007, 79.91181061400005],
              [16.82007897200009, 79.87579987200007],
              [16.85401451900009, 79.87006256700005],
              [16.88648522200009, 79.87360260600008],
              [16.912852410000085, 79.89252350500004],
              [16.902191602000073, 79.89618561400005],
              [16.871348504000082, 79.91181061400005],
              [16.864431186000047, 79.91913483300004],
              [16.87012780000009, 79.93333567900004],
              [16.885996941000087, 79.94110748900005],
              [16.964691602000073, 79.96259186400005],
              [17.269541863000086, 79.94554271000004],
              [17.40015709700009, 79.91429271000004],
              [17.562510613000086, 79.89785390800006],
              [17.59343509200005, 79.88076406500005],
              [17.635996941000087, 79.86692942900004],
              [17.691742384000065, 79.85984935100004],
              [17.899668816000087, 79.79564036700003],
              [17.942149285000085, 79.77155182500007],
              [17.993418816000087, 79.76455312700006],
              [18.030528191000087, 79.75486888200004],
              [18.098399285000085, 79.72736237200007],
              [18.068532748000052, 79.69464752800008],
              [18.016774936000047, 79.67837148600006],
              [17.912771030000044, 79.66596100500004],
              [17.87045332100007, 79.65619538000004],
              [17.851084832000083, 79.64777252800008],
              [17.815684441000087, 79.62323639500005],
              [17.748871290000068, 79.60382721600007],
              [17.768809441000087, 79.59699127800008],
              [17.736175977000073, 79.56696198100008],
              [17.688975457000083, 79.56024811400005],
              [17.637054884000065, 79.55975983300004],
              [17.590668165000068, 79.54857005400004],
              [17.673106316000087, 79.54242584800005],
              [17.73145592500009, 79.54999420800004],
              [17.748871290000068, 79.54857005400004],
              [17.765879754000082, 79.53896719000005],
              [17.76929772200009, 79.51040273600006],
              [17.78296959700009, 79.49404531500005],
              [17.76465905000009, 79.47736237200007],
              [17.757660352000073, 79.46784088700008],
              [17.755137566000087, 79.45644765800006],
              [17.758962436000047, 79.44904205900008],
              [17.76693769600007, 79.44342682500007],
              [17.774180535000085, 79.43659088700008],
              [17.775645379000082, 79.42572663000004],
              [17.75367272200009, 79.40932851800005],
              [17.631602410000085, 79.39158763200004],
              [17.653168165000068, 79.36937083500004],
              [17.693532748000052, 79.37103913000004],
              [17.768809441000087, 79.39158763200004],
              [17.842621290000068, 79.39520905200004],
              [17.881032748000052, 79.40131256700005],
              [17.93604576900009, 79.42987702000005],
              [17.971527540000068, 79.44041575700004],
              [18.002614780000044, 79.45579661700003],
              [18.015798373000052, 79.48403554900005],
              [18.01921634200005, 79.49396393400008],
              [18.02702884200005, 79.50702545800004],
              [18.043223504000082, 79.52875397300005],
              [18.06421959700009, 79.54857005400004],
              [18.077321811000047, 79.56907786700003],
              [18.106130405000044, 79.58832428600005],
              [18.13998457100007, 79.60398997600004],
              [18.176931186000047, 79.61603424700007],
              [18.24195397200009, 79.62824127800008],
              [18.346934441000087, 79.62995026200008],
              [18.40007571700005, 79.61131419500003],
              [18.451426629000082, 79.59951406500005],
              [18.55909264400009, 79.58690013200004],
              [18.727305535000085, 79.54352448100008],
              [18.75562584700009, 79.52191803600005],
              [18.76140384200005, 79.51089101800005],
              [18.77051842500009, 79.48468659100007],
              [18.776133660000085, 79.47724030200004],
              [18.796153191000087, 79.46922435100004],
              [18.837901238000086, 79.45994700700004],
              [18.858164910000085, 79.45302969000005],
              [18.88184655000009, 79.44110748900005],
              [18.876963738000086, 79.43915436400005],
              [18.86109459700009, 79.43659088700008],
              [18.851898634000065, 79.42259349200003],
              [18.85914147200009, 79.40924713700008],
              [18.87631269600007, 79.40379466400003],
              [18.896739129000082, 79.40009186400005],
              [18.913340691000087, 79.39158763200004],
              [18.892751498000052, 79.38898346600007],
              [18.868988477000073, 79.38263580900008],
              [18.848480665000068, 79.37221914300005],
              [18.83765709700009, 79.35683828300006],
              [18.83887780000009, 79.34052155200004],
              [18.84937584700009, 79.33047109600005],
              [18.879161004000082, 79.31586334800005],
              [18.783457879000082, 79.27912018400008],
              [18.627207879000082, 79.27228424700007],
              [18.591807488000086, 79.26121653900003],
              [18.65202884200005, 79.24876536700003],
              [18.844574415000068, 79.25438060100004],
              [18.93213951900009, 79.22772858300004],
              [18.947520379000082, 79.22028229400007],
              [18.94312584700009, 79.20673248900005],
              [18.915212436000047, 79.18121979400007],
              [18.916758660000085, 79.16844310100004],
              [18.94507897200009, 79.15696849200003],
              [19.057465040000068, 79.15688711100006],
              [19.09156334700009, 79.15094635600008],
              [19.197927280000044, 79.15131256700005],
              [19.226084832000083, 79.15521881700005],
              [19.246755405000044, 79.16449616100005],
              [19.265879754000082, 79.17576732000003],
              [19.28956139400009, 79.18549225500004],
              [19.322520379000082, 79.18943919500003],
              [19.40723717500009, 79.18488190300008],
              [19.420176629000082, 79.18378327000005],
              [19.611989780000044, 79.15330638200004],
              [19.667165561000047, 79.15058014500005],
              [19.786306186000047, 79.16510651200008],
              [19.838145379000082, 79.15131256700005],
              [19.82976321700005, 79.14423248900005],
              [19.821787957000083, 79.14081452000005],
              [19.813324415000068, 79.13849518400008],
              [19.80372155000009, 79.13458893400008],
              [19.795664910000085, 79.12811920800004],
              [19.798350457000083, 79.12396881700005],
              [19.80567467500009, 79.12103913000004],
              [19.810801629000082, 79.11786530200004],
              [19.81812584700009, 79.10639069200005],
              [19.828949415000068, 79.09511953300006],
              [19.84278405000009, 79.08649323100008],
              [19.924001498000052, 79.06411367400005],
              [19.934336785000085, 79.05890534100007],
              [19.930349155000044, 79.04580312700006],
              [19.91187584700009, 79.02728913000004],
              [19.906423373000052, 79.01422760600008],
              [19.98601321700005, 79.01398346600007],
              [20.010996941000087, 79.01972077000005],
              [20.031097852000073, 79.02098216400003],
              [20.076914910000085, 79.00910065300008],
              [20.198741082000083, 79.00141022300005],
              [20.450368686000047, 78.94635651200008],
              [20.920624220000064, 78.90686676600006],
              [21.390879754000082, 78.86737702000005],
              [21.440603061000047, 78.85541413000004],
              [21.464040561000047, 78.85301341400003],
              [21.522146030000044, 78.85370514500005],
              [21.541026238000086, 78.84690989800004],
              [21.54542076900009, 78.83405182500007],
              [21.535329623000052, 78.82465241100005],
              [21.520192905000044, 78.81683991100005],
              [21.51026451900009, 78.80878327000005],
              [21.508474155000044, 78.79401276200008],
              [21.517914259000065, 78.78705475500004],
              [21.53419030000009, 78.78261953300006],
              [21.551931186000047, 78.77521393400008],
              [21.531993035000085, 78.76044342700004],
              [21.50831139400009, 78.74701569200005],
              [21.483164910000085, 78.73737213700008],
              [21.43604576900009, 78.73041413000004],
              [21.406097852000073, 78.72215403900003],
              [21.378103061000047, 78.71100495000007],
              [21.360118035000085, 78.69891998900005],
              [21.369151238000086, 78.69428131700005],
              [21.39031009200005, 78.67694733300004],
              [21.39421634200005, 78.67157623900005],
              [21.38331139400009, 78.65859609600005],
              [21.361501498000052, 78.65546295800004],
              [21.336599155000044, 78.65835195500006],
              [21.268239780000044, 78.67426178600005],
              [21.12671959700009, 78.66535065300008],
              [21.125824415000068, 78.64520905200004],
              [21.098806186000047, 78.63979726800005],
              [21.037364129000082, 78.64423248900005],
              [21.037852410000085, 78.64874909100007],
              [20.988942905000044, 78.65851471600007],
              [20.940196160000085, 78.65790436400005],
              [20.93018639400009, 78.65957265800006],
              [20.917979363000086, 78.66364166900007],
              [20.906260613000086, 78.66913483300004],
              [20.886973504000082, 78.68256256700005],
              [20.879649285000085, 78.68341705900008],
              [20.87159264400009, 78.68085358300004],
              [20.85987389400009, 78.67841217700004],
              [20.691416863000086, 78.69358958500004],
              [20.640147332000083, 78.67157623900005],
              [20.625824415000068, 78.65558502800008],
              [20.617523634000065, 78.64252350500004],
              [20.60523522200009, 78.63385651200008],
              [20.578298373000052, 78.63060130400004],
              [20.503428582000083, 78.63060130400004],
              [20.45948326900009, 78.64252350500004],
              [20.444834832000083, 78.64423248900005],
              [20.219574415000068, 78.64618561400005],
              [20.20875084700009, 78.63808828300006],
            ],
          ],
          [
            [
              [33.098643425000034, 80.22768789300005],
              [33.29859459700009, 80.24811432500007],
              [33.64039147200009, 80.22077057500007],
              [33.59620201900009, 80.20319245000007],
              [33.54346764400009, 80.19505442900004],
              [33.28768964950007, 80.18307119350004],
              [33.031911655000044, 80.17108795800004],
              [32.831065300000034, 80.13324616100005],
              [32.42440839900005, 80.11306386933337],
              [32.017751498000074, 80.09288157766672],
              [31.61109459700009, 80.07269928600005],
              [31.495290561000047, 80.09731679900005],
              [31.47706139400009, 80.10394928600005],
              [31.480642123000052, 80.11058177300004],
              [31.496348504000082, 80.11570872600004],
              [31.97744116866674, 80.14588722000003],
              [32.4585338333334, 80.17606571400005],
              [32.93962649800005, 80.20624420800004],
              [32.99561608200008, 80.21889883000006],
              [33.02125084700009, 80.22150299700007],
              [33.074229363000086, 80.22016022300005],
              [33.098643425000034, 80.22768789300005],
            ],
          ],
          [
            [
              [18.296397332000083, 80.27606842700004],
              [18.15870201900009, 80.27863190300008],
              [18.11882571700005, 80.28974030200004],
              [18.138682488000086, 80.30955638200004],
              [18.15560957100007, 80.31781647300005],
              [18.19076582100007, 80.32184479400007],
              [18.207692905000044, 80.32660553600005],
              [18.238942905000044, 80.34373607000003],
              [18.301442905000044, 80.36249420800004],
              [18.31690514400009, 80.36420319200005],
              [18.586761915000068, 80.34174225500004],
              [18.670095248000052, 80.31976959800005],
              [18.687673373000052, 80.31220123900005],
              [18.700450066000087, 80.30955638200004],
              [18.715668165000068, 80.31037018400008],
              [18.728851759000065, 80.31313711100006],
              [18.741709832000083, 80.31232330900008],
              [18.75562584700009, 80.30272044500003],
              [18.69971764400009, 80.29132721600007],
              [18.680511915000068, 80.28974030200004],
              [18.664317254000082, 80.28538646000004],
              [18.639008009000065, 80.26609935100004],
              [18.62598717500009, 80.26178620000007],
              [18.491384311000047, 80.23883698100008],
              [18.449392123000052, 80.24310944200005],
              [18.296397332000083, 80.27606842700004],
            ],
          ],
          [
            [
              [24.16928144600007, 80.44611237200007],
              [24.192637566000087, 80.45758698100008],
              [24.21778405000009, 80.45905182500007],
              [24.242849155000044, 80.45404694200005],
              [24.265472852000073, 80.44611237200007],
              [24.292165561000047, 80.43097565300008],
              [24.36231530000009, 80.40802643400008],
              [24.381602410000085, 80.39154694200005],
              [24.167165561000047, 80.38336823100008],
              [24.128428582000083, 80.40517812700006],
              [24.144867384000065, 80.40875885600008],
              [24.15365644600007, 80.41986725500004],
              [24.160004102000073, 80.43378327000005],
              [24.16928144600007, 80.44611237200007],
            ],
          ],
          [
            [
              [24.292246941000087, 80.48834870000007],
              [24.259776238000086, 80.47304922100005],
              [24.216970248000052, 80.46954987200007],
              [24.010508660000085, 80.48338450700004],
              [23.97754967500009, 80.49457428600005],
              [23.994313998000052, 80.50161367400005],
              [24.016449415000068, 80.50649648600006],
              [24.039724155000044, 80.50873444200005],
              [24.059418165000068, 80.50824616100005],
              [24.114431186000047, 80.51235586100006],
              [24.17481530000009, 80.51162344000005],
              [24.234385613000086, 80.50381094000005],
              [24.292246941000087, 80.48834870000007],
            ],
          ],
          [
            [
              [27.171071811000047, 80.07343170800004],
              [27.162771030000044, 80.06671784100007],
              [27.147959832000083, 80.04913971600007],
              [27.136241082000083, 80.04266998900005],
              [27.14429772200009, 80.03693268400008],
              [27.152679884000065, 80.03270091400003],
              [27.16146894600007, 80.03009674700007],
              [27.171071811000047, 80.02899811400005],
              [27.158213738000086, 80.01093170800004],
              [27.120290561000047, 79.98871491100005],
              [27.10206139400009, 79.97443268400008],
              [27.134613477000073, 79.95522695500006],
              [27.224945509000065, 79.92487213700008],
              [27.239105665000068, 79.90550364800004],
              [27.207367384000065, 79.87368398600006],
              [27.149668816000087, 79.85496653900003],
              [26.91960696700005, 79.84251536700003],
              [26.856944207000083, 79.83148834800005],
              [26.79004967500009, 79.79547760600008],
              [26.757660352000073, 79.79083893400008],
              [26.649912957000083, 79.78685130400004],
              [26.630707227000073, 79.78107330900008],
              [26.635915561000047, 79.76829661700003],
              [26.612803582000083, 79.75967031500005],
              [26.586273634000065, 79.75568268400008],
              [26.533457879000082, 79.75462474200003],
              [26.527517123000052, 79.73505280200004],
              [26.49512780000009, 79.72333405200004],
              [26.296885613000086, 79.69692617400005],
              [26.22234134200005, 79.66950104400007],
              [25.826019727000073, 79.62604401200008],
              [25.810801629000082, 79.62091705900008],
              [25.808929884000065, 79.60952383000006],
              [25.82325280000009, 79.60187409100007],
              [25.85206139400009, 79.59393952000005],
              [25.864024285000085, 79.58734772300005],
              [25.894053582000083, 79.58100006700005],
              [25.906993035000085, 79.57282135600008],
              [25.914724155000044, 79.56488678600005],
              [25.965098504000082, 79.52619049700007],
              [25.968760613000086, 79.51544830900008],
              [25.95639082100007, 79.50657786700003],
              [25.92904707100007, 79.49591705900008],
              [25.85320071700005, 79.47785065300008],
              [25.823090040000068, 79.46503327000005],
              [25.842051629000082, 79.45302969000005],
              [25.82911217500009, 79.44220612200007],
              [25.807383660000085, 79.43667226800005],
              [25.783376498000052, 79.43325429900005],
              [25.645681186000047, 79.39769114800004],
              [25.41065514400009, 79.37409088700008],
              [25.366709832000083, 79.36001211100006],
              [25.18327884200005, 79.33624909100007],
              [24.974945509000065, 79.33445872600004],
              [24.963715040000068, 79.33698151200008],
              [24.959320509000065, 79.34149811400005],
              [24.95484459700009, 79.35199616100005],
              [24.950043165000068, 79.35683828300006],
              [24.946787957000083, 79.36147695500006],
              [24.947276238000086, 79.36611562700006],
              [24.945323113000086, 79.37079498900005],
              [24.93490644600007, 79.37567780200004],
              [24.920664910000085, 79.37824127800008],
              [24.771494988000086, 79.37083567900004],
              [24.562510613000086, 79.32404205900008],
              [24.28809655000009, 79.30988190300008],
              [24.258636915000068, 79.28851959800005],
              [24.260020379000082, 79.28009674700007],
              [24.271820509000065, 79.26373932500007],
              [24.272308790000068, 79.25438060100004],
              [24.259776238000086, 79.24079010600008],
              [24.238536004000082, 79.23110586100006],
              [24.053070509000065, 79.18886953300006],
              [23.677256706666736, 79.2001949453334],
              [23.301442904333403, 79.21152035766671],
              [22.925629102000073, 79.22284577000005],
              [22.736664259000065, 79.26740143400008],
              [22.68213951900009, 79.28851959800005],
              [22.651866082000083, 79.30678945500006],
              [22.644704623000052, 79.30963776200008],
              [22.642100457000083, 79.31781647300005],
              [22.654958530000044, 79.36424388200004],
              [22.89503014400009, 79.41950104400007],
              [22.51335696700005, 79.39362213700008],
              [22.416677280000044, 79.40973541900007],
              [22.064219597500056, 79.39075348550006],
              [21.711761915000068, 79.37177155200004],
              [21.500743035000085, 79.39728424700007],
              [21.158824089500087, 79.38768138250006],
              [20.81690514400009, 79.37807851800005],
              [20.79151451900009, 79.39158763200004],
              [20.807383660000085, 79.39337799700007],
              [20.83725019600007, 79.40265534100007],
              [20.853037957000083, 79.40521881700005],
              [20.763682488000086, 79.43341705900008],
              [20.750010613000086, 79.44989655200004],
              [20.729746941000087, 79.45856354400007],
              [20.463267449000085, 79.46369049700007],
              [20.196787957000083, 79.46881745000007],
              [20.07667076900009, 79.49046458500004],
              [20.016856316000087, 79.51219310100004],
              [19.68531334700009, 79.55390045800004],
              [19.66309655000009, 79.56793854400007],
              [19.645762566000087, 79.58795807500007],
              [19.63331139400009, 79.61131419500003],
              [19.816579623000052, 79.63568756700005],
              [20.20834394600007, 79.64545319200005],
              [20.22706139400009, 79.64232005400004],
              [20.277598504000082, 79.61749909100007],
              [20.41260826900009, 79.59186432500007],
              [20.783579949000085, 79.58047109600005],
              [21.154551629000082, 79.56907786700003],
              [21.127777540000068, 79.58771393400008],
              [20.64942467500009, 79.62653229400007],
              [20.495371941000087, 79.67316315300008],
              [20.47559655000009, 79.68642812700006],
              [20.933848503333422, 79.69326406466672],
              [21.392100456666753, 79.70010000233339],
              [21.850352410000085, 79.70693594000005],
              [21.866384311000047, 79.71076080900008],
              [21.864431186000047, 79.71942780200004],
              [21.853037957000083, 79.72866445500006],
              [21.840505405000044, 79.73419830900008],
              [21.893728061000047, 79.75234609600005],
              [22.28174889400009, 79.77411530200004],
              [22.346934441000087, 79.78880442900004],
              [22.287445509000065, 79.80573151200008],
              [22.215668165000068, 79.80670807500007],
              [21.798350457000083, 79.76829661700003],
              [21.798350457000083, 79.77521393400008],
              [21.807383660000085, 79.77582428600005],
              [21.832367384000065, 79.78266022300005],
              [21.736175977000073, 79.78266022300005],
              [21.768809441000087, 79.80463288000004],
              [21.85320071700005, 79.80707428600005],
              [21.88770592500009, 79.82355377800008],
              [21.45879153700008, 79.81397125850008],
              [21.02987714900007, 79.80438873900007],
              [20.600962761000062, 79.79480621950007],
              [20.172048373000052, 79.78522370000007],
              [19.996918165000068, 79.74884674700007],
              [19.81104576900009, 79.74941640800006],
              [19.732432488000086, 79.72601959800005],
              [19.485606316000087, 79.71796295800004],
              [19.411957227000073, 79.73843008000006],
              [19.394053582000083, 79.74079010600008],
              [19.310557488000086, 79.73997630400004],
              [19.24350019600007, 79.72793203300006],
              [18.95281009200005, 79.73623281500005],
              [18.783864780000044, 79.72308991100005],
              [18.742035352000073, 79.72736237200007],
              [18.74781334700009, 79.73065827000005],
              [18.762461785000085, 79.74164459800005],
              [18.741384311000047, 79.74298737200007],
              [18.719411655000044, 79.74713776200008],
              [18.70866946700005, 79.75511302300004],
              [18.721527540000068, 79.76829661700003],
              [18.682465040000068, 79.78774648600006],
              [18.63607832100007, 79.79417552300004],
              [18.48015384200005, 79.78595612200007],
              [18.460785352000073, 79.78880442900004],
              [18.449961785000085, 79.79547760600008],
              [18.419932488000086, 79.82355377800008],
              [18.396332227000073, 79.83075592700004],
              [18.322276238000086, 79.84223053600005],
              [18.308116082000083, 79.84857819200005],
              [18.269053582000083, 79.87449778900003],
              [18.23210696700005, 79.89061107000003],
              [18.19434655000009, 79.90009186400005],
              [18.111989780000044, 79.90550364800004],
              [18.146739129000082, 79.91644928600005],
              [18.295258009000065, 79.94513580900008],
              [18.41309655000009, 79.94647858300004],
              [18.52051842500009, 79.96332428600005],
              [18.58448326900009, 79.95453522300005],
              [18.62354576900009, 79.95673248900005],
              [18.65992272200009, 79.96527741100005],
              [18.680511915000068, 79.98061758000006],
              [18.556976759000065, 79.98061758000006],
              [18.57781009200005, 79.98305898600006],
              [18.615977410000085, 79.99762604400007],
              [18.668711785000085, 80.01015859600005],
              [18.686696811000047, 80.00950755400004],
              [18.680511915000068, 79.99485911700003],
              [18.708181186000047, 79.99164459800005],
              [18.764414910000085, 79.97443268400008],
              [18.789805535000085, 79.97443268400008],
              [18.806162957000083, 79.98261139500005],
              [18.80990644600007, 79.99286530200004],
              [18.801931186000047, 80.00238678600005],
              [18.78296959700009, 80.00853099200003],
              [18.822927280000044, 80.01947663000004],
              [18.861582879000082, 80.02448151200008],
              [18.898610873000052, 80.03343333500004],
              [18.933767123000052, 80.05634186400005],
              [18.836680535000085, 80.03123607000003],
              [18.37549889400009, 80.03900788000004],
              [18.30795332100007, 80.05874258000006],
              [18.23487389400009, 80.04889557500007],
              [18.213552280000044, 80.05320872600004],
              [18.174001498000052, 80.07245514500005],
              [18.152354363000086, 80.07684967700004],
              [18.152354363000086, 80.08364492400005],
              [18.200694207000083, 80.07196686400005],
              [18.25953209700009, 80.06598541900007],
              [18.317881707000083, 80.06891510600008],
              [18.36459394600007, 80.08364492400005],
              [18.14893639400009, 80.09731679900005],
              [18.112071160000085, 80.10830312700006],
              [18.06617272200009, 80.12836334800005],
              [18.02320397200009, 80.13800690300008],
              [17.995371941000087, 80.11782461100006],
              [17.985118035000085, 80.12079498900005],
              [17.959727410000085, 80.12710195500006],
              [17.93336022200009, 80.13043854400007],
              [17.801605665000068, 80.12872955900008],
              [17.78296959700009, 80.13825104400007],
              [17.81812584700009, 80.14057038000004],
              [17.88526451900009, 80.16111888200004],
              [17.95093834700009, 80.17088450700004],
              [18.007823113000086, 80.19037506700005],
              [18.037445509000065, 80.19285716400003],
              [18.061289910000085, 80.18235911700003],
              [18.071055535000085, 80.17987702000005],
              [18.08838951900009, 80.17959219000005],
              [18.138682488000086, 80.18671295800004],
              [18.340668165000068, 80.17987702000005],
              [18.394786004000082, 80.17202383000006],
              [18.41146894600007, 80.17430247600004],
              [18.442637566000087, 80.18256256700005],
              [18.570323113000086, 80.18475983300004],
              [18.646494988000086, 80.16620514500005],
              [18.68140709700009, 80.16185130400004],
              [18.710459832000083, 80.16518789300005],
              [18.76929772200009, 80.18671295800004],
              [18.700450066000087, 80.20718008000006],
              [18.854340040000068, 80.19757721600007],
              [18.90796959700009, 80.18829987200007],
              [18.95948326900009, 80.16254303600005],
              [19.182302280000044, 80.11969635600008],
              [19.242930535000085, 80.09048086100006],
              [19.27125084700009, 80.08527252800008],
              [19.301524285000085, 80.08567942900004],
              [19.331309441000087, 80.09100983300004],
              [19.391856316000087, 80.11375560100004],
              [19.404307488000086, 80.12262604400007],
              [19.39942467500009, 80.13141510600008],
              [19.39942467500009, 80.13825104400007],
              [19.493337436000047, 80.13947174700007],
              [19.584808790000068, 80.15192291900007],
              [19.54460696700005, 80.17202383000006],
              [19.48568769600007, 80.17719147300005],
              [19.375743035000085, 80.17243073100008],
              [19.277191602000073, 80.18374258000006],
              [19.22429446700005, 80.19769928600005],
              [19.19239342500009, 80.22553131700005],
              [19.150238477000073, 80.23851146000004],
              [19.13648522200009, 80.24469635600008],
              [19.12867272200009, 80.25043366100005],
              [19.113617384000065, 80.25458405200004],
              [19.10515384200005, 80.25804271000004],
              [19.09896894600007, 80.26373932500007],
              [19.09896894600007, 80.26951732000003],
              [19.100271030000044, 80.27558014500005],
              [19.098317905000044, 80.28229401200008],
              [19.092051629000082, 80.29340241100005],
              [19.088715040000068, 80.30158112200007],
              [19.08171634200005, 80.30890534100007],
              [19.06421959700009, 80.31704336100006],
              [18.999522332000083, 80.33169179900005],
              [18.981618686000047, 80.34369538000004],
              [18.99545332100007, 80.34589264500005],
              [19.019867384000065, 80.35569896000004],
              [19.033457879000082, 80.35797760600008],
              [19.282481316000087, 80.33930084800005],
              [19.337168816000087, 80.32746002800008],
              [19.61296634200005, 80.22768789300005],
              [19.671722852000073, 80.21747467700004],
              [19.851817254000082, 80.22077057500007],
              [19.822113477000073, 80.23285553600005],
              [19.738942905000044, 80.23550039300005],
              [19.715179884000065, 80.24811432500007],
              [19.73023522200009, 80.25763580900008],
              [19.838145379000082, 80.28974030200004],
              [19.828786655000044, 80.29222239800004],
              [19.804535352000073, 80.30272044500003],
              [19.815114780000044, 80.30223216400003],
              [19.823090040000068, 80.30341217700004],
              [19.838145379000082, 80.30955638200004],
              [19.821787957000083, 80.31533437700006],
              [19.77051842500009, 80.32318756700005],
              [19.792979363000086, 80.32705312700006],
              [19.81934655000009, 80.32819245000007],
              [19.843272332000083, 80.33197663000004],
              [19.858653191000087, 80.34369538000004],
              [19.791840040000068, 80.34511953300006],
              [19.77051842500009, 80.35053131700005],
              [19.807790561000047, 80.35285065300008],
              [19.878184441000087, 80.37372467700004],
              [19.91382897200009, 80.37848541900007],
              [19.91382897200009, 80.38523997600004],
              [19.528819207000083, 80.38837311400005],
              [19.487071160000085, 80.39313385600008],
              [19.468760613000086, 80.40888092700004],
              [19.463552280000044, 80.43634674700007],
              [19.46265709700009, 80.45343659100007],
              [19.46810957100007, 80.46409739800004],
              [19.50049889400009, 80.47223541900007],
              [19.542979363000086, 80.47247955900008],
              [19.619151238000086, 80.46039459800005],
              [19.660166863000086, 80.43988678600005],
              [19.67432701900009, 80.43988678600005],
              [19.68848717500009, 80.44847239800004],
              [19.682383660000085, 80.45465729400007],
              [19.653819207000083, 80.46409739800004],
              [19.635508660000085, 80.48114655200004],
              [19.63835696700005, 80.49591705900008],
              [19.65674889400009, 80.50503164300005],
              [19.802256707000083, 80.49298737200007],
              [19.838145379000082, 80.48151276200008],
              [19.831879102000073, 80.47406647300005],
              [20.014008009000065, 80.47223541900007],
              [20.03679446700005, 80.46784088700008],
              [20.022715691000087, 80.45115794500003],
              [20.016286655000044, 80.44611237200007],
              [20.046397332000083, 80.43768952000005],
              [20.078379754000082, 80.43305084800005],
              [20.07398522200009, 80.42316315300008],
              [20.071543816000087, 80.41941966400003],
              [20.091075066000087, 80.41315338700008],
              [20.098887566000087, 80.41258372600004],
              [20.08765709700009, 80.40021393400008],
              [20.081228061000047, 80.38930898600006],
              [20.08497155000009, 80.38141510600008],
              [20.105479363000086, 80.37848541900007],
              [20.12794030000009, 80.38043854400007],
              [20.141449415000068, 80.38580963700008],
              [20.160329623000052, 80.40517812700006],
              [20.191416863000086, 80.42137278900003],
              [20.23406009200005, 80.42739492400005],
              [20.389821811000047, 80.42348867400005],
              [20.42351321700005, 80.41315338700008],
              [20.427907748000052, 80.39154694200005],
              [20.484548373000052, 80.37128327000005],
              [20.54460696700005, 80.35797760600008],
              [20.53614342500009, 80.34332916900007],
              [20.530772332000083, 80.33637116100005],
              [20.523448113000086, 80.33002350500004],
              [20.558116082000083, 80.31321849200003],
              [20.591807488000086, 80.30272044500003],
              [20.62745201900009, 80.29913971600007],
              [20.798024936000047, 80.31622955900008],
              [20.83920332100007, 80.30955638200004],
              [20.821055535000085, 80.30292389500005],
              [20.773773634000065, 80.29120514500005],
              [20.75749759200005, 80.28229401200008],
              [20.74903405000009, 80.26862213700008],
              [20.755056186000047, 80.26080963700008],
              [20.784027540000068, 80.24811432500007],
              [20.813243035000085, 80.22675202000005],
              [20.825694207000083, 80.22077057500007],
              [20.85287519600007, 80.21393463700008],
              [20.88257897200009, 80.21124909100007],
              [21.19312584700009, 80.23358795800004],
              [21.28093509200005, 80.25836823100008],
              [21.32593834700009, 80.26178620000007],
              [21.316742384000065, 80.25771719000005],
              [21.30958092500009, 80.25275299700007],
              [21.303558790000068, 80.24721914300005],
              [21.298675977000073, 80.24127838700008],
              [21.30958092500009, 80.23847077000005],
              [21.31739342500009, 80.23432038000004],
              [21.332774285000085, 80.22077057500007],
              [21.318532748000052, 80.22077057500007],
              [21.318532748000052, 80.21336497600004],
              [21.34546959700009, 80.21442291900007],
              [21.36963951900009, 80.21800364800004],
              [21.392100457000083, 80.22475820500006],
              [21.414805535000085, 80.23509349200003],
              [21.417816602000073, 80.24030182500007],
              [21.417491082000083, 80.24664948100008],
              [21.420176629000082, 80.25210195500006],
              [21.432383660000085, 80.25433991100005],
              [21.44312584700009, 80.25507233300004],
              [21.45484459700009, 80.25739166900007],
              [21.46615644600007, 80.26080963700008],
              [21.476084832000083, 80.26520416900007],
              [21.531504754000082, 80.27350495000007],
              [21.64812259200005, 80.23761627800008],
              [21.702647332000083, 80.24127838700008],
              [21.666758660000085, 80.25291575700004],
              [21.654307488000086, 80.25433991100005],
              [21.67741946700005, 80.27484772300005],
              [21.723399285000085, 80.28042226800005],
              [21.84669030000009, 80.27212148600006],
              [21.866384311000047, 80.26121653900003],
              [21.897959832000083, 80.22426992400005],
              [21.897634311000047, 80.21344635600008],
              [21.879161004000082, 80.20648834800005],
              [21.840505405000044, 80.20034414300005],
              [21.775563998000052, 80.18207428600005],
              [21.716970248000052, 80.17381419500003],
              [21.599619988000086, 80.12523021000004],
              [21.621836785000085, 80.11517975500004],
              [21.649912957000083, 80.11627838700008],
              [21.76343834700009, 80.14691803600005],
              [21.826996290000068, 80.15192291900007],
              [21.85450280000009, 80.14769114800004],
              [21.905528191000087, 80.12946198100008],
              [22.065196160000085, 80.11098867400005],
              [22.058929884000065, 80.10346100500004],
              [22.079925977000073, 80.09479401200008],
              [22.120616082000083, 80.08344147300005],
              [22.15601647200009, 80.06126536700003],
              [22.195323113000086, 80.05097077000005],
              [22.216644727000073, 80.04266998900005],
              [22.207041863000086, 80.03497955900008],
              [22.175059441000087, 80.02155182500007],
              [22.223480665000068, 80.00853099200003],
              [22.20281009200005, 79.99233633000006],
              [22.195567254000082, 79.98802317900004],
              [22.23536217500009, 79.98187897300005],
              [22.283213738000086, 79.98305898600006],
              [22.330088738000086, 79.99176666900007],
              [22.367442254000082, 80.00853099200003],
              [22.344411655000044, 80.02456289300005],
              [22.319102410000085, 80.03583405200004],
              [22.36573326900009, 80.04498932500007],
              [22.438161655000044, 80.01089101800005],
              [22.477305535000085, 80.01536692900004],
              [22.43726647200009, 80.03856028900003],
              [22.423675977000073, 80.04433828300006],
              [22.378754102000073, 80.05003489800004],
              [22.357758009000065, 80.05609772300005],
              [22.346934441000087, 80.07001373900005],
              [22.44898522200009, 80.06549713700008],
              [22.463063998000052, 80.07001373900005],
              [22.44890384200005, 80.08173248900005],
              [22.373708530000044, 80.11098867400005],
              [22.390798373000052, 80.12518952000005],
              [22.408376498000052, 80.14508698100008],
              [22.408864780000044, 80.15058014500005],
              [22.401052280000044, 80.16054922100005],
              [22.401621941000087, 80.16620514500005],
              [22.407399936000047, 80.17080312700006],
              [22.435801629000082, 80.18671295800004],
              [22.456879102000073, 80.20490143400008],
              [22.465993686000047, 80.22162506700005],
              [22.463226759000065, 80.23965078300006],
              [22.449473504000082, 80.26178620000007],
              [22.478526238000086, 80.27586497600004],
              [22.549978061000047, 80.28465403900003],
              [22.576019727000073, 80.29901764500005],
              [22.56421959700009, 80.31085846600007],
              [22.381114129000082, 80.33755117400005],
              [22.37273196700005, 80.34052155200004],
              [22.341644727000073, 80.35569896000004],
              [22.33334394600007, 80.36420319200005],
              [22.337738477000073, 80.38385651200008],
              [22.35710696700005, 80.40208567900004],
              [22.38135826900009, 80.41522858300004],
              [22.387950066000087, 80.42690664300005],
              [22.457367384000065, 80.44086334800005],
              [22.68213951900009, 80.42690664300005],
              [22.68213951900009, 80.41941966400003],
              [22.668793165000068, 80.40399811400005],
              [22.633636915000068, 80.37177155200004],
              [22.613291863000086, 80.35797760600008],
              [22.635508660000085, 80.34137604400007],
              [22.674164259000065, 80.33315664300005],
              [22.750336134000065, 80.33002350500004],
              [22.735118035000085, 80.33698151200008],
              [22.719574415000068, 80.34174225500004],
              [22.70606530000009, 80.34760163000004],
              [22.696462436000047, 80.35797760600008],
              [22.715993686000047, 80.35976797100005],
              [22.77312259200005, 80.37669505400004],
              [22.792246941000087, 80.37909577000005],
              [22.801605665000068, 80.38190338700008],
              [22.80567467500009, 80.38837311400005],
              [22.80795332100007, 80.39728424700007],
              [22.81421959700009, 80.40424225500004],
              [22.823008660000085, 80.40936920800004],
              [22.83301842500009, 80.41258372600004],
              [22.82715905000009, 80.41571686400005],
              [22.812510613000086, 80.42690664300005],
              [22.828461134000065, 80.43414948100008],
              [22.810069207000083, 80.44424062700006],
              [22.791351759000065, 80.45921458500004],
              [22.80567467500009, 80.48151276200008],
              [22.792491082000083, 80.48330312700006],
              [22.774099155000044, 80.48802317900004],
              [22.75757897200009, 80.49534739800004],
              [22.750336134000065, 80.50482819200005],
              [22.759776238000086, 80.51398346600007],
              [22.781586134000065, 80.51727936400005],
              [22.826182488000086, 80.51504140800006],
              [22.976898634000065, 80.47406647300005],
              [23.267425977000073, 80.45380280200004],
              [23.360606316000087, 80.43305084800005],
              [23.344493035000085, 80.42694733300004],
              [23.324554884000065, 80.42255280200004],
              [23.285411004000082, 80.41941966400003],
              [23.301931186000047, 80.41425202000005],
              [23.30990644600007, 80.41303131700005],
              [23.319590691000087, 80.41258372600004],
              [23.294932488000086, 80.40509674700007],
              [23.189463738000086, 80.40302155200004],
              [23.14389082100007, 80.39354075700004],
              [23.120941602000073, 80.39154694200005],
              [23.142425977000073, 80.38117096600007],
              [23.167246941000087, 80.37763092700004],
              [23.217133009000065, 80.37848541900007],
              [23.213715040000068, 80.36985911700003],
              [23.207774285000085, 80.36359284100007],
              [23.199473504000082, 80.35960521000004],
              [23.18921959700009, 80.35797760600008],
              [23.209646030000044, 80.35834381700005],
              [23.271739129000082, 80.35053131700005],
              [23.315196160000085, 80.35171133000006],
              [23.336192254000082, 80.34837474200003],
              [23.353770379000082, 80.33755117400005],
              [23.295176629000082, 80.32778554900005],
              [23.294118686000047, 80.32225169500003],
              [23.298106316000087, 80.31557851800005],
              [23.299082879000082, 80.30955638200004],
              [23.29851321700005, 80.30434804900005],
              [23.305511915000068, 80.29511139500005],
              [23.305918816000087, 80.28974030200004],
              [23.29590905000009, 80.28099192900004],
              [23.27979576900009, 80.27728913000004],
              [23.263194207000083, 80.27545807500007],
              [23.22624759200005, 80.26447174700007],
              [23.084320509000065, 80.25551992400005],
              [23.055023634000065, 80.24835846600007],
              [23.025401238000086, 80.19285716400003],
              [23.00554446700005, 80.16840241100005],
              [23.006683790000068, 80.16209544500003],
              [23.01856530000009, 80.15192291900007],
              [23.061289910000085, 80.13165924700007],
              [23.122325066000087, 80.11758047100005],
              [23.184418165000068, 80.11395905200004],
              [23.23023522200009, 80.12523021000004],
              [23.19239342500009, 80.13251373900005],
              [23.172618035000085, 80.13959381700005],
              [23.143239780000044, 80.15619538000004],
              [23.103688998000052, 80.16258372600004],
              [23.086761915000068, 80.17243073100008],
              [23.24390709700009, 80.16620514500005],
              [23.23145592500009, 80.17523834800005],
              [23.225759311000047, 80.17755768400008],
              [23.217133009000065, 80.17987702000005],
              [23.225433790000068, 80.19114817900004],
              [23.240489129000082, 80.19464752800008],
              [23.274912957000083, 80.19285716400003],
              [23.296397332000083, 80.19415924700007],
              [23.307383660000085, 80.19342682500007],
              [23.315928582000083, 80.18976471600007],
              [23.318207227000073, 80.18549225500004],
              [23.318369988000086, 80.17560455900008],
              [23.319590691000087, 80.17243073100008],
              [23.34424889400009, 80.15485260600008],
              [23.37045332100007, 80.14305247600004],
              [23.398692254000082, 80.14252350500004],
              [23.42945397200009, 80.15875885600008],
              [23.393321160000085, 80.18268463700008],
              [23.387868686000047, 80.18976471600007],
              [23.398692254000082, 80.20416901200008],
              [23.423838738000086, 80.21108633000006],
              [23.47046959700009, 80.21336497600004],
              [23.457367384000065, 80.20718008000006],
              [23.467458530000044, 80.20819733300004],
              [23.480642123000052, 80.20697663000004],
              [23.492198113000086, 80.20221588700008],
              [23.49773196700005, 80.19285716400003],
              [23.494395379000082, 80.18366120000007],
              [23.485036655000044, 80.17845286700003],
              [23.463633660000085, 80.17243073100008],
              [23.471446160000085, 80.16982656500005],
              [23.491465691000087, 80.15875885600008],
              [23.502614780000044, 80.15680573100008],
              [23.539317254000082, 80.15875885600008],
              [23.537119988000086, 80.15424225500004],
              [23.533946160000085, 80.14280833500004],
              [23.531911655000044, 80.13825104400007],
              [23.567637566000087, 80.13349030200004],
              [23.60059655000009, 80.14256419500003],
              [23.662282748000052, 80.17243073100008],
              [23.804860873000052, 80.18455638200004],
              [23.833506707000083, 80.20034414300005],
              [23.771820509000065, 80.20718008000006],
              [23.759287957000083, 80.21019114800004],
              [23.750254754000082, 80.21759674700007],
              [23.74154707100007, 80.22675202000005],
              [23.730479363000086, 80.23509349200003],
              [23.746348504000082, 80.23920319200005],
              [23.777598504000082, 80.24262116100005],
              [23.79265384200005, 80.24811432500007],
              [23.735118035000085, 80.25556061400005],
              [23.716807488000086, 80.26178620000007],
              [23.72592207100007, 80.26850006700005],
              [23.73601321700005, 80.27358633000006],
              [23.74659264400009, 80.27619049700007],
              [23.757660352000073, 80.27606842700004],
              [23.74968509200005, 80.28742096600007],
              [23.745371941000087, 80.29165273600006],
              [23.73731530000009, 80.29531484600005],
              [23.76531009200005, 80.30906810100004],
              [23.79981530000009, 80.30361562700006],
              [23.86768639400009, 80.28229401200008],
              [23.958506707000083, 80.28229401200008],
              [23.977224155000044, 80.27912018400008],
              [23.995941602000073, 80.27338288000004],
              [24.014496290000068, 80.27057526200008],
              [24.032725457000083, 80.27606842700004],
              [23.927989129000082, 80.29816315300008],
              [23.89503014400009, 80.30955638200004],
              [24.07715905000009, 80.30272044500003],
              [24.18995201900009, 80.27533600500004],
              [24.224619988000086, 80.28229401200008],
              [24.20997155000009, 80.29254791900007],
              [24.203949415000068, 80.29531484600005],
              [24.33562259200005, 80.28628164300005],
              [24.37476647200009, 80.29531484600005],
              [24.35987389400009, 80.30182526200008],
              [24.342539910000085, 80.30719635600008],
              [24.324066602000073, 80.31020742400005],
              [24.30640709700009, 80.30955638200004],
              [24.30640709700009, 80.31704336100006],
              [24.38135826900009, 80.31635163000004],
              [24.40211022200009, 80.32318756700005],
              [24.37598717500009, 80.33234284100007],
              [24.210785352000073, 80.33502838700008],
              [24.148773634000065, 80.35053131700005],
              [24.187022332000083, 80.37177155200004],
              [24.259776238000086, 80.37579987200007],
              [24.481211785000085, 80.35537344000005],
              [24.510508660000085, 80.34878164300005],
              [24.600759311000047, 80.31704336100006],
              [24.570567254000082, 80.31761302300004],
              [24.53419030000009, 80.31362539300005],
              [24.49854576900009, 80.30581289300005],
              [24.470957879000082, 80.29531484600005],
              [24.476410352000073, 80.29254791900007],
              [24.486338738000086, 80.28510163000004],
              [24.491465691000087, 80.28229401200008],
              [24.484385613000086, 80.27936432500007],
              [24.471039259000065, 80.27142975500004],
              [24.464121941000087, 80.26862213700008],
              [24.48796634200005, 80.26137929900005],
              [24.521332227000073, 80.25568268400008],
              [24.55437259200005, 80.25556061400005],
              [24.57715905000009, 80.26520416900007],
              [24.601573113000086, 80.27973053600005],
              [24.725433790000068, 80.29389069200005],
              [24.737803582000083, 80.29828522300005],
              [24.748708530000044, 80.30613841400003],
              [24.75163821700005, 80.31268952000005],
              [24.752696160000085, 80.32054271000004],
              [24.755137566000087, 80.32729726800005],
              [24.78419030000009, 80.33698151200008],
              [24.806813998000052, 80.34967682500007],
              [24.829925977000073, 80.35590241100005],
              [24.871836785000085, 80.33466217700004],
              [24.888682488000086, 80.32318756700005],
              [24.877777540000068, 80.31500885600008],
              [24.866465691000087, 80.30857982000003],
              [24.854177280000044, 80.30434804900005],
              [24.84083092500009, 80.30272044500003],
              [24.848806186000047, 80.28603750200006],
              [24.831309441000087, 80.27130768400008],
              [24.780121290000068, 80.24811432500007],
              [24.816579623000052, 80.25519440300008],
              [24.892425977000073, 80.26129791900007],
              [25.04590905000009, 80.25291575700004],
              [25.115244988000086, 80.26862213700008],
              [25.355479363000086, 80.28229401200008],
              [25.324473504000082, 80.26797109600005],
              [25.22510826900009, 80.25433991100005],
              [25.269704623000052, 80.23346588700008],
              [25.31812584700009, 80.22614166900007],
              [25.45281009200005, 80.23078034100007],
              [25.513926629000082, 80.24237702000005],
              [25.54664147200009, 80.24127838700008],
              [25.566661004000082, 80.23688385600008],
              [25.58757571700005, 80.22907135600008],
              [25.604991082000083, 80.21718984600005],
              [25.61491946700005, 80.20034414300005],
              [25.698741082000083, 80.22296784100007],
              [25.74390709700009, 80.22553131700005],
              [25.780528191000087, 80.21336497600004],
              [25.763926629000082, 80.19953034100007],
              [25.704356316000087, 80.17243073100008],
              [25.84742272200009, 80.17259349200003],
              [25.939707879000082, 80.18545156500005],
              [26.373423699000085, 80.17985667550005],
              [26.80713951900009, 80.17426178600005],
              [26.903493686000047, 80.15192291900007],
              [27.003916863000086, 80.11517975500004],
              [27.04037519600007, 80.11098867400005],
              [27.19190514400009, 80.10960521000004],
              [27.239105665000068, 80.09731679900005],
              [27.171071811000047, 80.07343170800004],
            ],
          ],
          [
            [
              [19.906993035000085, 80.48834870000007],
              [19.881521030000044, 80.49030182500007],
              [19.859222852000073, 80.49603913000004],
              [19.852224155000044, 80.50503164300005],
              [19.871348504000082, 80.51691315300008],
              [19.95875084700009, 80.54026927300004],
              [20.025563998000052, 80.54246653900003],
              [20.06348717500009, 80.53754303600005],
              [20.100352410000085, 80.52838776200008],
              [20.133555535000085, 80.51504140800006],
              [20.10515384200005, 80.50714752800008],
              [20.044769727000073, 80.50234609600005],
              [19.98731530000009, 80.48940664300005],
              [19.906993035000085, 80.48834870000007],
            ],
          ],
          [
            [
              [20.75749759200005, 80.62490469000005],
              [20.724782748000052, 80.62807851800005],
              [20.66651451900009, 80.64215729400007],
              [20.529633009000065, 80.65936920800004],
              [20.496104363000086, 80.65961334800005],
              [20.517832879000082, 80.66583893400008],
              [20.79151451900009, 80.65961334800005],
              [20.785899285000085, 80.64838288000004],
              [20.776133660000085, 80.64130280200004],
              [20.763682488000086, 80.63833242400005],
              [20.750010613000086, 80.63914622600004],
              [20.752777540000068, 80.63519928600005],
              [20.75749759200005, 80.62490469000005],
            ],
          ],
          [
            [
              [21.174489780000044, 80.65961334800005],
              [21.13803144600007, 80.65619538000004],
              [21.08952884200005, 80.65717194200005],
              [21.045746290000068, 80.66791413000004],
              [21.024261915000068, 80.69379303600005],
              [21.061208530000044, 80.69334544500003],
              [21.21461022200009, 80.71124909100007],
              [21.332774285000085, 80.70742422100005],
              [21.33334394600007, 80.70246002800008],
              [21.33179772200009, 80.70111725500004],
              [21.32911217500009, 80.70099518400008],
              [21.32593834700009, 80.70001862200007],
              [21.337168816000087, 80.69757721600007],
              [21.347911004000082, 80.69330475500004],
              [21.357758009000065, 80.68744538000004],
              [21.36695397200009, 80.68012116100005],
              [21.174489780000044, 80.65961334800005],
            ],
          ],
          [
            [
              [20.63331139400009, 80.73476797100005],
              [20.561289910000085, 80.73993561400005],
              [20.527679884000065, 80.74738190300008],
              [20.517832879000082, 80.76947663000004],
              [20.62208092500009, 80.77008698100008],
              [20.654470248000052, 80.76203034100007],
              [20.694102410000085, 80.74477773600006],
              [20.718272332000083, 80.73769765800006],
              [20.838226759000065, 80.72321198100008],
              [20.97046959700009, 80.72182851800005],
              [21.003184441000087, 80.71426015800006],
              [20.994476759000065, 80.70294830900008],
              [20.97787519600007, 80.69708893400008],
              [20.897308790000068, 80.69379303600005],
              [20.887868686000047, 80.69183991100005],
              [20.873871290000068, 80.68301015800006],
              [20.866709832000083, 80.68012116100005],
              [20.821543816000087, 80.68012116100005],
              [20.81185957100007, 80.68170807500007],
              [20.808929884000065, 80.68569570500006],
              [20.80836022200009, 80.69025299700007],
              [20.80518639400009, 80.69379303600005],
              [20.803396030000044, 80.69725169500003],
              [20.805430535000085, 80.70184967700004],
              [20.805511915000068, 80.70575592700004],
              [20.798350457000083, 80.70742422100005],
              [20.77637780000009, 80.70815664300005],
              [20.755381707000083, 80.71246979400007],
              [20.73796634200005, 80.71312083500004],
              [20.694834832000083, 80.70526764500005],
              [20.67481530000009, 80.70742422100005],
              [20.66374759200005, 80.71344635600008],
              [20.646657748000052, 80.72793203300006],
              [20.63331139400009, 80.73476797100005],
            ],
          ],
          [
            [
              [3.457286004000082, -54.39006926899992],
              [3.477793816000087, -54.396742445999905],
              [3.486664259000065, -54.40203215899993],
              [3.484629754000082, -54.41090260199991],
              [3.479340040000068, -54.41871510199991],
              [3.471934441000087, -54.435804945999905],
              [3.467539910000085, -54.441338799999926],
              [3.442230665000068, -54.44801197699991],
              [3.38257897200009, -54.44931405999995],
              [3.364512566000087, -54.46249765399995],
              [3.361175977000073, -54.45842864399992],
              [3.357920769000089, -54.45720794099992],
              [3.354502800000091, -54.4568010399999],
              [3.350840691000087, -54.45566171699994],
              [3.345550977000073, -54.41855234199994],
              [3.377207879000082, -54.39137135199991],
              [3.422129754000082, -54.38014088299991],
              [3.457286004000082, -54.39006926899992],
            ],
          ],
          [
            [
              [11.070323113000086, 59.079331773000035],
              [11.075694207000083, 59.08047109600005],
              [11.083018425000091, 59.07729726800005],
              [11.082367384000065, 59.06785716400003],
              [11.07553144600007, 59.05853913000004],
              [11.064789259000065, 59.05149974200003],
              [11.051605665000068, 59.046128648000035],
              [11.05046634200005, 59.042303778000075],
              [11.054860873000052, 59.03587474200003],
              [11.046397332000083, 59.02680084800005],
              [11.030528191000087, 59.020819403000075],
              [11.018239780000044, 59.01935455900008],
              [11.013519727000073, 59.02163320500006],
              [11.011566602000073, 59.025376695000034],
              [11.008962436000047, 59.02920156500005],
              [11.000824415000068, 59.02960846600007],
              [10.991465691000087, 59.03359609600005],
              [10.99154707100007, 59.046861070000034],
              [10.993418816000087, 59.06232330900008],
              [10.993174675000091, 59.07664622600004],
              [11.00326582100007, 59.08649323100008],
              [11.020762566000087, 59.09125397300005],
              [11.034353061000047, 59.08893463700008],
              [11.040212436000047, 59.08104075700004],
              [11.039805535000085, 59.07440827000005],
              [11.047618035000085, 59.07318756700005],
              [11.070485873000052, 59.07489655200004],
              [11.069590691000087, 59.07762278900003],
              [11.070323113000086, 59.079331773000035],
            ],
          ],
          [
            [
              [10.910492384000065, 59.116441148000035],
              [10.91382897200009, 59.11155833500004],
              [10.914398634000065, 59.10073476800005],
              [10.907074415000068, 59.09056224200003],
              [10.883799675000091, 59.07217031500005],
              [10.877452019000089, 59.07123444200005],
              [10.87476647200009, 59.07566966400003],
              [10.869802280000044, 59.07709381700005],
              [10.855723504000082, 59.07416413000004],
              [10.845713738000086, 59.07575104400007],
              [10.841807488000086, 59.08022695500006],
              [10.838389519000089, 59.08641185100004],
              [10.829112175000091, 59.09943268400008],
              [10.832530144000089, 59.10443756700005],
              [10.842621290000068, 59.11001211100006],
              [10.855479363000086, 59.11538320500006],
              [10.865244988000086, 59.11660390800006],
              [10.867930535000085, 59.113267320000034],
              [10.86500084700009, 59.10895416900007],
              [10.85914147200009, 59.10602448100008],
              [10.855723504000082, 59.10236237200007],
              [10.857269727000073, 59.09906647300005],
              [10.871918165000068, 59.10651276200008],
              [10.897634311000047, 59.11562734600005],
              [10.910492384000065, 59.116441148000035],
            ],
          ],
          [
            [
              [5.289724155000044, 60.074286200000074],
              [5.298350457000083, 60.05971914300005],
              [5.300059441000087, 60.050767320000034],
              [5.299082879000082, 60.04633209800005],
              [5.29859459700009, 60.03782786700003],
              [5.297048373000052, 60.02753327000005],
              [5.279307488000086, 60.01251862200007],
              [5.277598504000082, 60.003607489000046],
              [5.268809441000087, 59.99485911700003],
              [5.25367272200009, 59.99310944200005],
              [5.246104363000086, 59.99843984600005],
              [5.24545332100007, 60.00429922100005],
              [5.240082227000073, 60.00649648600006],
              [5.230967644000089, 60.00617096600007],
              [5.218272332000083, 60.00849030200004],
              [5.204274936000047, 60.016058661000045],
              [5.199392123000052, 60.02383047100005],
              [5.200694207000083, 60.029364325000074],
              [5.197927280000044, 60.03388092700004],
              [5.173838738000086, 60.046128648000035],
              [5.171722852000073, 60.04946523600006],
              [5.172536655000044, 60.05410390800006],
              [5.179860873000052, 60.06818268400008],
              [5.197113477000073, 60.08197663000004],
              [5.203623894000089, 60.08828359600005],
              [5.20679772200009, 60.08673737200007],
              [5.207286004000082, 60.07953522300005],
              [5.211110873000052, 60.07123444200005],
              [5.216970248000052, 60.061428127000056],
              [5.219574415000068, 60.05101146000004],
              [5.223887566000087, 60.042303778000075],
              [5.231700066000087, 60.04051341400003],
              [5.239756707000083, 60.04393138200004],
              [5.242442254000082, 60.04669830900008],
              [5.240407748000052, 60.04946523600006],
              [5.24195397200009, 60.05133698100008],
              [5.246592644000089, 60.05145905200004],
              [5.241384311000047, 60.05536530200004],
              [5.228770379000082, 60.06732819200005],
              [5.222992384000065, 60.07880280200004],
              [5.221202019000089, 60.08551666900007],
              [5.218272332000083, 60.087958075000074],
              [5.215342644000089, 60.08881256700005],
              [5.204925977000073, 60.107082424000055],
              [5.205332879000082, 60.11737702000005],
              [5.217539910000085, 60.118475653000075],
              [5.22201582100007, 60.11713288000004],
              [5.22982832100007, 60.112209377000056],
              [5.24781334700009, 60.098537502000056],
              [5.25367272200009, 60.08978913000004],
              [5.24976647200009, 60.08942291900007],
              [5.252207879000082, 60.08502838700008],
              [5.25953209700009, 60.07558828300006],
              [5.262461785000085, 60.075384833000044],
              [5.265879754000082, 60.08266836100006],
              [5.272715691000087, 60.08372630400004],
              [5.279307488000086, 60.081244208000044],
              [5.289724155000044, 60.074286200000074],
            ],
          ],
          [
            [
              [4.922373894000089, 60.86749909100007],
              [4.928396030000044, 60.86424388200004],
              [4.92937259200005, 60.86115143400008],
              [4.928965691000087, 60.858628648000035],
              [4.92514082100007, 60.855536200000074],
              [4.918223504000082, 60.85537344000005],
              [4.897959832000083, 60.85846588700008],
              [4.878754102000073, 60.86513906500005],
              [4.87240644600007, 60.875067450000074],
              [4.872243686000047, 60.884019273000035],
              [4.868174675000091, 60.88776276200008],
              [4.865407748000052, 60.88568756700005],
              [4.86101321700005, 60.88467031500005],
              [4.84538821700005, 60.89008209800005],
              [4.834727410000085, 60.89520905200004],
              [4.830902540000068, 60.902411200000074],
              [4.833181186000047, 60.90839264500005],
              [4.831228061000047, 60.914496161000045],
              [4.825205925000091, 60.92047760600008],
              [4.821055535000085, 60.91852448100008],
              [4.816905144000089, 60.91168854400007],
              [4.809580925000091, 60.91185130400004],
              [4.800303582000083, 60.91693756700005],
              [4.791351759000065, 60.918402411000045],
              [4.783864780000044, 60.91693756700005],
              [4.781586134000065, 60.917629299000055],
              [4.784027540000068, 60.92023346600007],
              [4.781993035000085, 60.92401764500005],
              [4.776866082000083, 60.92999909100007],
              [4.781586134000065, 60.93528880400004],
              [4.795095248000052, 60.93886953300006],
              [4.836761915000068, 60.94318268400008],
              [4.843272332000083, 60.93886953300006],
              [4.836599155000044, 60.93317291900007],
              [4.824880405000044, 60.93008047100005],
              [4.826345248000052, 60.929022528000075],
              [4.855642123000052, 60.932521877000056],
              [4.87077884200005, 60.932928778000075],
              [4.882823113000086, 60.92999909100007],
              [4.88412519600007, 60.92560455900008],
              [4.87663821700005, 60.92593008000006],
              [4.87086022200009, 60.92377350500004],
              [4.874034050000091, 60.917669989000046],
              [4.885264519000089, 60.913723049000055],
              [4.897227410000085, 60.907416083000044],
              [4.922536655000044, 60.878119208000044],
              [4.924164259000065, 60.871161200000074],
              [4.920095248000052, 60.868353583000044],
              [4.922373894000089, 60.86749909100007],
            ],
          ],
          [
            [
              [4.721446160000085, 61.040228583000044],
              [4.732676629000082, 61.03506094000005],
              [4.73959394600007, 61.02765534100007],
              [4.739024285000085, 61.013739325000074],
              [4.731130405000044, 60.99994538000004],
              [4.71843509200005, 60.99091217700004],
              [4.706879102000073, 60.98851146000004],
              [4.701914910000085, 60.99371979400007],
              [4.701345248000052, 61.001613674000055],
              [4.705414259000065, 61.01044342700004],
              [4.70866946700005, 61.01972077000005],
              [4.705414259000065, 61.018744208000044],
              [4.697438998000052, 61.00771719000005],
              [4.691742384000065, 61.00250885600008],
              [4.688487175000091, 60.99945709800005],
              [4.680349155000044, 60.99713776200008],
              [4.672373894000089, 61.00332265800006],
              [4.668793165000068, 61.014105536000045],
              [4.664886915000068, 61.01870351800005],
              [4.656260613000086, 61.019517320000034],
              [4.648692254000082, 61.02643463700008],
              [4.646006707000083, 61.03628164300005],
              [4.644786004000082, 61.04584381700005],
              [4.64812259200005, 61.05231354400007],
              [4.648773634000065, 61.054673570000034],
              [4.643809441000087, 61.05760325700004],
              [4.644704623000052, 61.060248114000046],
              [4.659353061000047, 61.066066799000055],
              [4.664073113000086, 61.06745026200008],
              [4.668467644000089, 61.06830475500004],
              [4.674571160000085, 61.07339101800005],
              [4.679698113000086, 61.07965729400007],
              [4.688975457000083, 61.08234284100007],
              [4.700043165000068, 61.08222077000005],
              [4.705577019000089, 61.076239325000074],
              [4.709157748000052, 61.067287502000056],
              [4.71461022200009, 61.06012604400007],
              [4.712168816000087, 61.05516185100004],
              [4.711436394000089, 61.04828522300005],
              [4.721446160000085, 61.040228583000044],
            ],
          ],
          [
            [
              [5.120290561000047, 62.02578359600005],
              [5.133555535000085, 62.01984284100007],
              [5.15211022200009, 61.99795156500005],
              [5.148692254000082, 61.98859284100007],
              [5.138926629000082, 61.979722398000035],
              [5.129893425000091, 61.96369049700007],
              [5.127940300000091, 61.95856354400007],
              [5.123220248000052, 61.94879791900007],
              [5.112559441000087, 61.93691640800006],
              [5.095225457000083, 61.927435614000046],
              [5.075368686000047, 61.92719147300005],
              [5.041026238000086, 61.93463776200008],
              [5.033864780000044, 61.93504466400003],
              [5.021494988000086, 61.93886953300006],
              [5.015472852000073, 61.943426825000074],
              [5.016123894000089, 61.952460028000075],
              [5.02475019600007, 61.960191148000035],
              [5.036631707000083, 61.96149323100008],
              [5.044200066000087, 61.95697663000004],
              [5.048350457000083, 61.952826239000046],
              [5.055837436000047, 61.958970445000034],
              [5.05437259200005, 61.972357489000046],
              [4.998545769000089, 61.99624258000006],
              [4.986175977000073, 62.00527578300006],
              [4.984222852000073, 62.009466864000046],
              [4.98414147200009, 62.01862213700008],
              [4.985850457000083, 62.027411200000074],
              [4.985118035000085, 62.03388092700004],
              [4.992930535000085, 62.03506094000005],
              [5.009613477000073, 62.03066640800006],
              [5.067637566000087, 62.00885651200008],
              [5.07976321700005, 62.00641510600008],
              [5.085785352000073, 62.01040273600006],
              [5.089040561000047, 62.01581452000005],
              [5.101817254000082, 62.02130768400008],
              [5.120290561000047, 62.02578359600005],
            ],
          ],
          [
            [
              [5.635996941000087, 62.31928131700005],
              [5.613942905000044, 62.32469310100004],
              [5.603037957000083, 62.32876211100006],
              [5.609711134000065, 62.33380768400008],
              [5.630137566000087, 62.341782945000034],
              [5.654307488000086, 62.34511953300006],
              [5.673106316000087, 62.343817450000074],
              [5.679860873000052, 62.34650299700007],
              [5.678884311000047, 62.35541413000004],
              [5.68531334700009, 62.36204661700003],
              [5.69695071700005, 62.36465078300006],
              [5.715830925000091, 62.36517975500004],
              [5.72006269600007, 62.36310455900008],
              [5.721527540000068, 62.36009349200003],
              [5.729665561000047, 62.36163971600007],
              [5.741465691000087, 62.360663153000075],
              [5.742360873000052, 62.34975820500006],
              [5.734629754000082, 62.337876695000034],
              [5.73373457100007, 62.33307526200008],
              [5.739024285000085, 62.33242422100005],
              [5.728526238000086, 62.32664622600004],
              [5.69898522200009, 62.32135651200008],
              [5.674571160000085, 62.32273997600004],
              [5.668955925000091, 62.32758209800005],
              [5.667246941000087, 62.32990143400008],
              [5.65951582100007, 62.32802969000005],
              [5.65406334700009, 62.32440827000005],
              [5.64975019600007, 62.31976959800005],
              [5.635996941000087, 62.31928131700005],
            ],
          ],
          [
            [
              [5.593923373000052, 62.33978913000004],
              [5.576914910000085, 62.335272528000075],
              [5.542491082000083, 62.331732489000046],
              [5.521332227000073, 62.334865627000056],
              [5.515635613000086, 62.34031810100004],
              [5.514903191000087, 62.34552643400008],
              [5.516856316000087, 62.34943268400008],
              [5.509938998000052, 62.36399974200003],
              [5.523610873000052, 62.36969635600008],
              [5.547373894000089, 62.36786530200004],
              [5.564789259000065, 62.36107005400004],
              [5.58171634200005, 62.35883209800005],
              [5.596364780000044, 62.35447825700004],
              [5.597666863000086, 62.34479401200008],
              [5.593923373000052, 62.33978913000004],
            ],
          ],
          [
            [
              [8.314789259000065, 63.181341864000046],
              [8.31812584700009, 63.177801825000074],
              [8.325368686000047, 63.17137278900003],
              [8.306813998000052, 63.167181708000044],
              [8.231293165000068, 63.15957265800006],
              [8.209808790000068, 63.161363023000035],
              [8.195811394000089, 63.167181708000044],
              [8.19076582100007, 63.174994208000044],
              [8.181895379000082, 63.20136139500005],
              [8.173675977000073, 63.209051825000074],
              [8.165293816000087, 63.21344635600008],
              [8.170664910000085, 63.22016022300005],
              [8.188161655000044, 63.22532786700003],
              [8.210459832000083, 63.22736237200007],
              [8.235118035000085, 63.22223541900007],
              [8.278005405000044, 63.200384833000044],
              [8.288910352000073, 63.196600653000075],
              [8.30640709700009, 63.18821849200003],
              [8.314789259000065, 63.181341864000046],
            ],
          ],
          [
            [
              [9.160004102000073, 63.647772528000075],
              [9.167002800000091, 63.64720286700003],
              [9.170909050000091, 63.64142487200007],
              [9.162119988000086, 63.63385651200008],
              [9.132334832000083, 63.62864817900004],
              [9.110524936000047, 63.621161200000074],
              [9.076345248000052, 63.612982489000046],
              [9.030121290000068, 63.617254950000074],
              [9.014008009000065, 63.62669505400004],
              [9.026866082000083, 63.63031647300005],
              [9.030528191000087, 63.63300202000005],
              [9.031260613000086, 63.63808828300006],
              [9.038259311000047, 63.644232489000046],
              [9.040537957000083, 63.64923737200007],
              [9.041514519000089, 63.65460846600007],
              [9.04818769600007, 63.65916575700004],
              [9.057871941000087, 63.66107819200005],
              [9.084727410000085, 63.661810614000046],
              [9.107595248000052, 63.659816799000055],
              [9.11850019600007, 63.65534088700008],
              [9.11890709700009, 63.65176015800006],
              [9.123301629000082, 63.64984772300005],
              [9.144541863000086, 63.652411200000074],
              [9.150238477000073, 63.65094635600008],
              [9.156586134000065, 63.648423570000034],
              [9.160004102000073, 63.647772528000075],
            ],
          ],
          [
            [
              [9.930837436000047, 64.02753327000005],
              [9.939952019000089, 64.02212148600006],
              [9.943858269000089, 64.01146067900004],
              [9.928477410000085, 64.00315989800004],
              [9.908213738000086, 63.99750397300005],
              [9.89226321700005, 63.99701569200005],
              [9.880869988000086, 64.00263092700004],
              [9.867523634000065, 64.00649648600006],
              [9.853851759000065, 64.00893789300005],
              [9.855967644000089, 64.01300690300008],
              [9.873789910000085, 64.01654694200005],
              [9.881114129000082, 64.01996491100005],
              [9.875498894000089, 64.02269114800004],
              [9.867360873000052, 64.02358633000006],
              [9.85678144600007, 64.02338288000004],
              [9.84742272200009, 64.02631256700005],
              [9.843760613000086, 64.03318919500003],
              [9.851084832000083, 64.03823476800005],
              [9.875254754000082, 64.03831614800004],
              [9.879730665000068, 64.04352448100008],
              [9.888519727000073, 64.04905833500004],
              [9.903575066000087, 64.04547760600008],
              [9.917491082000083, 64.03717682500007],
              [9.920176629000082, 64.03156159100007],
              [9.91968834700009, 64.02850983300004],
              [9.930837436000047, 64.02753327000005],
            ],
          ],
          [
            [
              [11.465505405000044, 64.58783600500004],
              [11.472911004000082, 64.56948476800005],
              [11.481700066000087, 64.56342194200005],
              [11.48023522200009, 64.55605703300006],
              [11.465668165000068, 64.55117422100005],
              [11.437836134000065, 64.54987213700008],
              [11.433929884000065, 64.54734935100004],
              [11.437347852000073, 64.54364655200004],
              [11.432871941000087, 64.54242584800005],
              [11.414398634000065, 64.54596588700008],
              [11.385996941000087, 64.55280182500007],
              [11.35132897200009, 64.56439850500004],
              [11.344493035000085, 64.57367584800005],
              [11.347911004000082, 64.58258698100008],
              [11.354258660000085, 64.58734772300005],
              [11.36882571700005, 64.59100983300004],
              [11.36850019600007, 64.60358307500007],
              [11.361338738000086, 64.62775299700007],
              [11.366465691000087, 64.63442617400005],
              [11.391449415000068, 64.61102936400005],
              [11.388845248000052, 64.62026601800005],
              [11.393077019000089, 64.62592194200005],
              [11.402679884000065, 64.62274811400005],
              [11.444021030000044, 64.59540436400005],
              [11.454356316000087, 64.59316640800006],
              [11.465505405000044, 64.58783600500004],
            ],
          ],
          [
            [
              [11.350759311000047, 64.65155670800004],
              [11.343760613000086, 64.63898346600007],
              [11.34148196700005, 64.62864817900004],
              [11.342133009000065, 64.62323639500005],
              [11.340098504000082, 64.62042877800008],
              [11.334239129000082, 64.61664459800005],
              [11.328868035000085, 64.61383698100008],
              [11.326019727000073, 64.60952383000006],
              [11.321136915000068, 64.60333893400008],
              [11.31226647200009, 64.59967682500007],
              [11.297862175000091, 64.60346100500004],
              [11.279795769000089, 64.61176178600005],
              [11.26539147200009, 64.62250397300005],
              [11.255056186000047, 64.63369375200006],
              [11.24545332100007, 64.63939036700003],
              [11.236582879000082, 64.63910553600005],
              [11.231293165000068, 64.63646067900004],
              [11.229258660000085, 64.63422272300005],
              [11.22046959700009, 64.63344961100006],
              [11.173106316000087, 64.63735586100006],
              [11.169932488000086, 64.64459870000007],
              [11.181813998000052, 64.65350983300004],
              [11.181651238000086, 64.65753815300008],
              [11.167979363000086, 64.65973541900007],
              [11.17123457100007, 64.66372304900005],
              [11.174001498000052, 64.66885000200006],
              [11.185557488000086, 64.67381419500003],
              [11.303965691000087, 64.69208405200004],
              [11.316661004000082, 64.68976471600007],
              [11.316416863000086, 64.68081289300005],
              [11.342621290000068, 64.67767975500004],
              [11.355723504000082, 64.66730377800008],
              [11.350759311000047, 64.65155670800004],
            ],
          ],
          [
            [
              [11.761729363000086, 65.11937083500004],
              [11.776866082000083, 65.11847565300008],
              [11.777191602000073, 65.11005280200004],
              [11.76531009200005, 65.10211823100008],
              [11.74545332100007, 65.09511953300006],
              [11.709646030000044, 65.08161041900007],
              [11.68881269600007, 65.07713450700004],
              [11.67359459700009, 65.07172272300005],
              [11.67351321700005, 65.06850820500006],
              [11.688161655000044, 65.06854889500005],
              [11.70085696700005, 65.06476471600007],
              [11.698496941000087, 65.05744049700007],
              [11.684418165000068, 65.05060455900008],
              [11.669444207000083, 65.04490794500003],
              [11.657237175000091, 65.04242584800005],
              [11.651866082000083, 65.04572174700007],
              [11.653575066000087, 65.05145905200004],
              [11.652679884000065, 65.05756256700005],
              [11.652191602000073, 65.06000397300005],
              [11.65796959700009, 65.06468333500004],
              [11.649912957000083, 65.06509023600006],
              [11.626963738000086, 65.05805084800005],
              [11.603526238000086, 65.04816315300008],
              [11.57984459700009, 65.04254791900007],
              [11.558604363000086, 65.04205963700008],
              [11.518809441000087, 65.05459219000005],
              [11.51921634200005, 65.05878327000005],
              [11.526621941000087, 65.06195709800005],
              [11.528168165000068, 65.06378815300008],
              [11.52507571700005, 65.06541575700004],
              [11.528819207000083, 65.07542552300004],
              [11.53101647200009, 65.08519114800004],
              [11.540863477000073, 65.09170156500005],
              [11.554698113000086, 65.09625885600008],
              [11.565684441000087, 65.10390859600005],
              [11.580332879000082, 65.10968659100007],
              [11.66179446700005, 65.11835358300004],
              [11.688975457000083, 65.11798737200007],
              [11.707286004000082, 65.11391836100006],
              [11.718760613000086, 65.10838450700004],
              [11.725759311000047, 65.10663483300004],
              [11.731130405000044, 65.10871002800008],
              [11.732920769000089, 65.11188385600008],
              [11.742930535000085, 65.11538320500006],
              [11.761729363000086, 65.11937083500004],
            ],
          ],
          [
            [
              [17.547129754000082, 69.09210846600007],
              [17.55836022200009, 69.09198639500005],
              [17.572113477000073, 69.08954498900005],
              [17.566579623000052, 69.08588288000004],
              [17.55128014400009, 69.08124420800004],
              [17.54590905000009, 69.07461172100005],
              [17.547211134000065, 69.06712474200003],
              [17.54428144600007, 69.06049225500004],
              [17.538910352000073, 69.05560944200005],
              [17.524912957000083, 69.04791901200008],
              [17.501231316000087, 69.03945547100005],
              [17.47828209700009, 69.03461334800005],
              [17.457855665000068, 69.02716705900008],
              [17.442230665000068, 69.01679108300004],
              [17.41895592500009, 68.99640534100007],
              [17.401133660000085, 68.98932526200008],
              [17.37663821700005, 68.98932526200008],
              [17.351898634000065, 68.99575429900005],
              [17.344086134000065, 69.00324127800008],
              [17.34937584700009, 69.00934479400007],
              [17.350759311000047, 69.01630280200004],
              [17.348806186000047, 69.02391185100004],
              [17.35254967500009, 69.03473541900007],
              [17.364431186000047, 69.04710521000004],
              [17.38648522200009, 69.06354401200008],
              [17.41968834700009, 69.07916901200008],
              [17.451508009000065, 69.08490631700005],
              [17.547129754000082, 69.09210846600007],
            ],
          ],
          [
            [
              [24.83692467500009, 71.09487539300005],
              [24.816742384000065, 71.08600495000007],
              [24.812347852000073, 71.07998281500005],
              [24.826019727000073, 71.07684967700004],
              [24.818695509000065, 71.07379791900007],
              [24.78760826900009, 71.06781647300005],
              [24.776621941000087, 71.05923086100006],
              [24.789073113000086, 71.05304596600007],
              [24.789073113000086, 71.04706452000005],
              [24.77003014400009, 71.02619049700007],
              [24.756032748000052, 71.02533600500004],
              [24.72201582100007, 71.02655670800004],
              [24.70484459700009, 71.03143952000005],
              [24.687673373000052, 71.03815338700008],
              [24.670746290000068, 71.04291413000004],
              [24.633962436000047, 71.04877350500004],
              [24.61426842500009, 71.05662669500003],
              [24.618988477000073, 71.06932200700004],
              [24.646332227000073, 71.08270905200004],
              [24.67164147200009, 71.08808014500005],
              [24.693369988000086, 71.08510976800005],
              [24.705332879000082, 71.07851797100005],
              [24.701996290000068, 71.07233307500007],
              [24.70484459700009, 71.06903717700004],
              [24.720713738000086, 71.06781647300005],
              [24.73292076900009, 71.06858958500004],
              [24.739105665000068, 71.07330963700008],
              [24.731211785000085, 71.08368561400005],
              [24.70948326900009, 71.09772370000007],
              [24.71257571700005, 71.10757070500006],
              [24.744883660000085, 71.10879140800006],
              [24.764008009000065, 71.10468170800004],
              [24.767751498000052, 71.09931061400005],
              [24.772959832000083, 71.09589264500005],
              [24.779307488000086, 71.09365469000005],
              [24.788259311000047, 71.09300364800004],
              [24.806813998000052, 71.09739817900004],
              [24.81690514400009, 71.09882233300004],
              [24.836599155000044, 71.09955475500004],
              [24.83692467500009, 71.09487539300005],
            ],
          ],
          [
            [
              [5.764008009000065, 59.11786530200004],
              [5.775889519000089, 59.11273834800005],
              [5.778493686000047, 59.10138580900008],
              [5.77475019600007, 59.08055247600004],
              [5.750743035000085, 59.072333075000074],
              [5.667002800000091, 59.10040924700007],
              [5.601573113000086, 59.115220445000034],
              [5.575205925000091, 59.12400950700004],
              [5.585134311000047, 59.12718333500004],
              [5.593597852000073, 59.132513739000046],
              [5.607920769000089, 59.134426174000055],
              [5.624278191000087, 59.13104889500005],
              [5.634776238000086, 59.13149648600006],
              [5.646820509000065, 59.13068268400008],
              [5.67750084700009, 59.12250397300005],
              [5.697927280000044, 59.12018463700008],
              [5.720957879000082, 59.12567780200004],
              [5.739105665000068, 59.12441640800006],
              [5.764008009000065, 59.11786530200004],
            ],
          ],
          [
            [
              [5.462087436000047, 59.21088288000004],
              [5.466319207000083, 59.20453522300005],
              [5.46810957100007, 59.19672272300005],
              [5.46461022200009, 59.18309153900003],
              [5.451182488000086, 59.16347890800006],
              [5.443207227000073, 59.15892161700003],
              [5.434418165000068, 59.16107819200005],
              [5.430674675000091, 59.16474030200004],
              [5.432627800000091, 59.167222398000035],
              [5.431976759000065, 59.17059967700004],
              [5.42741946700005, 59.17454661700003],
              [5.421722852000073, 59.177801825000074],
              [5.396006707000083, 59.187933661000045],
              [5.384776238000086, 59.195298570000034],
              [5.376800977000073, 59.20722077000005],
              [5.375336134000065, 59.218817450000074],
              [5.378428582000083, 59.22675202000005],
              [5.385101759000065, 59.23411692900004],
              [5.39389082100007, 59.24042389500005],
              [5.403819207000083, 59.24209219000005],
              [5.41382897200009, 59.24079010600008],
              [5.42554772200009, 59.236395575000074],
              [5.432302280000044, 59.23273346600007],
              [5.43921959700009, 59.22992584800005],
              [5.451996290000068, 59.22211334800005],
              [5.462087436000047, 59.21088288000004],
            ],
          ],
          [
            [
              [6.016368035000085, 59.292181708000044],
              [6.072601759000065, 59.28506094000005],
              [6.099864129000082, 59.276556708000044],
              [6.091807488000086, 59.261419989000046],
              [6.05632571700005, 59.24070872600004],
              [6.004405144000089, 59.23078034100007],
              [5.958181186000047, 59.227850653000075],
              [5.929860873000052, 59.243475653000075],
              [5.932465040000068, 59.26898834800005],
              [5.95248457100007, 59.28392161700003],
              [5.987559441000087, 59.29083893400008],
              [6.016368035000085, 59.292181708000044],
            ],
          ],
          [
            [
              [4.845876498000052, 60.628119208000044],
              [4.851573113000086, 60.621079820000034],
              [4.851817254000082, 60.61420319200005],
              [4.844737175000091, 60.611395575000074],
              [4.840830925000091, 60.606756903000075],
              [4.843923373000052, 60.58974844000005],
              [4.836761915000068, 60.58673737200007],
              [4.820974155000044, 60.584418036000045],
              [4.801768425000091, 60.587103583000044],
              [4.78288821700005, 60.59275950700004],
              [4.779470248000052, 60.598537502000056],
              [4.788910352000073, 60.59747955900008],
              [4.79078209700009, 60.60028717700004],
              [4.785980665000068, 60.61180247600004],
              [4.785411004000082, 60.61579010600008],
              [4.78874759200005, 60.61395905200004],
              [4.792002800000091, 60.614569403000075],
              [4.794932488000086, 60.61542389500005],
              [4.793630405000044, 60.61786530200004],
              [4.791026238000086, 60.630519924000055],
              [4.78842207100007, 60.63812897300005],
              [4.787608269000089, 60.644232489000046],
              [4.786143425000091, 60.648423570000034],
              [4.786143425000091, 60.65607330900008],
              [4.791270379000082, 60.666083075000074],
              [4.801442905000044, 60.667181708000044],
              [4.810069207000083, 60.66128164300005],
              [4.820567254000082, 60.65643952000005],
              [4.82398522200009, 60.65151601800005],
              [4.82390384200005, 60.646551825000074],
              [4.825368686000047, 60.64362213700008],
              [4.830332879000082, 60.64004140800006],
              [4.830902540000068, 60.63556549700007],
              [4.827321811000047, 60.63141510600008],
              [4.82943769600007, 60.62970612200007],
              [4.837901238000086, 60.630519924000055],
              [4.845876498000052, 60.628119208000044],
            ],
          ],
          [
            [
              [4.836273634000065, 61.67454661700003],
              [4.831879102000073, 61.68146393400008],
              [4.830251498000052, 61.69000885600008],
              [4.832855665000068, 61.69578685100004],
              [4.838715040000068, 61.69961172100005],
              [4.848317905000044, 61.701605536000045],
              [4.858246290000068, 61.70221588700008],
              [4.86304772200009, 61.708197333000044],
              [4.870290561000047, 61.71466705900008],
              [4.879893425000091, 61.71198151200008],
              [4.877452019000089, 61.70099518400008],
              [4.884287957000083, 61.69570547100005],
              [4.889496290000068, 61.68846263200004],
              [4.895762566000087, 61.68451569200005],
              [4.903493686000047, 61.67617422100005],
              [4.904795769000089, 61.660223700000074],
              [4.902842644000089, 61.65249258000006],
              [4.902354363000086, 61.65460846600007],
              [4.899099155000044, 61.659369208000044],
              [4.892100457000083, 61.66278717700004],
              [4.883555535000085, 61.66429271000004],
              [4.865407748000052, 61.659369208000044],
              [4.85718834700009, 61.66160716400003],
              [4.85328209700009, 61.663316148000035],
              [4.848155144000089, 61.66498444200005],
              [4.840830925000091, 61.669623114000046],
              [4.836273634000065, 61.67454661700003],
            ],
          ],
          [
            [
              [14.408457879000082, 67.42576732000003],
              [14.412119988000086, 67.42527903900003],
              [14.419200066000087, 67.42340729400007],
              [14.412852410000085, 67.41307200700004],
              [14.392100457000083, 67.39850495000007],
              [14.366465691000087, 67.39093659100007],
              [14.284190300000091, 67.37954336100006],
              [14.27475019600007, 67.37677643400008],
              [14.256114129000082, 67.37384674700007],
              [14.238942905000044, 67.37396881700005],
              [14.226735873000052, 67.37734609600005],
              [14.229014519000089, 67.38418203300006],
              [14.248545769000089, 67.38890208500004],
              [14.245290561000047, 67.39264557500007],
              [14.248871290000068, 67.39533112200007],
              [14.25912519600007, 67.39549388200004],
              [14.26929772200009, 67.40021393400008],
              [14.279551629000082, 67.40863678600005],
              [14.309418165000068, 67.42308177300004],
              [14.371755405000044, 67.44110748900005],
              [14.389903191000087, 67.44122955900008],
              [14.400645379000082, 67.43659088700008],
              [14.403493686000047, 67.43016185100004],
              [14.398773634000065, 67.42377350500004],
              [14.399180535000085, 67.42182038000004],
              [14.408457879000082, 67.42576732000003],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Sweden',
        iso3: 'SWE',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [20.62316451, 69.03635569300012],
              [20.675461059000042, 69.01816558800009],
              [20.795350383000084, 69.011240947],
              [20.86397668500004, 68.98628123000002],
              [20.911208944000066, 68.980700175],
              [20.934566691000043, 68.96695424500005],
              [20.934256632000142, 68.94902252200008],
              [20.91782352700008, 68.93295115200003],
              [20.88764449000007, 68.92706003800002],
              [20.884543905000044, 68.90669952500009],
              [20.905731242000087, 68.8946072400001],
              [21.072129353000093, 68.86944081700007],
              [21.15284794100012, 68.84174224900003],
              [21.21661665800005, 68.81724762000009],
              [21.275734497000116, 68.7764232390001],
              [21.28834354700004, 68.77001536100006],
              [21.2937178950001, 68.76820668600006],
              [21.300952596000087, 68.75921498600012],
              [21.305396769000083, 68.755804342],
              [21.314698527000104, 68.7540473430001],
              [21.38590865100005, 68.75384063800006],
              [21.406372518000126, 68.74887970000002],
              [21.415260864000118, 68.73875111900007],
              [21.421255330000065, 68.727485657],
              [21.45153772000009, 68.69647979800008],
              [21.463630005000084, 68.68686798100005],
              [21.49566939300007, 68.67549916600008],
              [21.572460571000136, 68.66738596700007],
              [21.661550740000052, 68.63353790300006],
              [21.716844523000077, 68.619223532],
              [21.737101685000084, 68.58790761400006],
              [21.91920943200006, 68.56821889300004],
              [21.96396122200011, 68.54692820300004],
              [21.969852336000116, 68.54083038400007],
              [21.9984810790001, 68.52584421900009],
              [22.012123657000103, 68.51643910800006],
              [22.024215942000097, 68.51044464200002],
              [22.028763469000125, 68.50935943700004],
              [22.03610152200011, 68.50651723300005],
              [22.03744510900009, 68.50005767900011],
              [22.036721639000092, 68.49292633100008],
              [22.038375285000143, 68.488275452],
              [22.07217167200011, 68.47700999000004],
              [22.303061971000147, 68.47613149000001],
              [22.371068156000035, 68.468380026],
              [22.37458215300009, 68.4661579390001],
              [22.37396203600011, 68.45633941700002],
              [22.377992798, 68.45411733000002],
              [22.456851034000124, 68.4517918910001],
              [22.521343221000052, 68.438200989],
              [22.565164836000065, 68.43628896100007],
              [22.60764286300011, 68.424920146],
              [22.625832967000065, 68.42507517500003],
              [22.643402954000123, 68.42729726200004],
              [22.66221317500012, 68.42740061500005],
              [22.690221801000064, 68.41675527000008],
              [22.719057251000095, 68.39877187200007],
              [22.748616170000105, 68.38549102800006],
              [22.80825077300011, 68.39489613900004],
              [22.83336551900004, 68.38476755800006],
              [22.875120077000076, 68.35107452500002],
              [22.903748820000146, 68.33660512400009],
              [23.052163533000083, 68.29820953400007],
              [23.06694299300011, 68.2902513640001],
              [23.0735575760001, 68.28193145800005],
              [23.076451457000076, 68.27381825800005],
              [23.081619100000097, 68.2652916470001],
              [23.09484826700009, 68.25552480100005],
              [23.140013468000063, 68.23418243500005],
              [23.155206340000092, 68.21743927100003],
              [23.149418579000013, 68.19402984700007],
              [23.15851363100009, 68.18669179300007],
              [23.15975386600013, 68.178733622],
              [23.154482869000077, 68.1537739060001],
              [23.149831990000024, 68.14483388300009],
              [23.149418579000013, 68.13940785700002],
              [23.151692342000047, 68.13026112900003],
              [23.15458622200012, 68.1283491010001],
              [23.158823690000077, 68.1275739550001],
              [23.165644979000035, 68.1220445770001],
              [23.18724572700009, 68.12225128200005],
              [23.27209842900004, 68.14498891300003],
              [23.306514933000102, 68.14560902900008],
              [23.31984745200012, 68.13827097600002],
              [23.33090621000011, 68.12778066000006],
              [23.371213826000087, 68.06845611600004],
              [23.374831177000146, 68.05998118100003],
              [23.382996053000085, 68.05124786400005],
              [23.45730676200006, 68.02432444300005],
              [23.484695272000096, 68.01590118500006],
              [23.573682088000083, 67.97331980400007],
              [23.64313521300005, 67.96319122300004],
              [23.662152140000046, 67.95042714500006],
              [23.661221964000077, 67.9328571570001],
              [23.636107219000053, 67.91347849600002],
              [23.60334436000005, 67.90298818000007],
              [23.532547648000104, 67.89316965800002],
              [23.498854614000066, 67.88216257800012],
              [23.481284627000093, 67.86464426700006],
              [23.476737102000044, 67.84133819600002],
              [23.479734334000057, 67.81699859600012],
              [23.484695272000096, 67.79622467100008],
              [23.48459191900008, 67.73715850900003],
              [23.488415975000123, 67.72480784200006],
              [23.499474731000134, 67.70899485300008],
              [23.51074019400008, 67.66925567600008],
              [23.518801717000088, 67.652822572],
              [23.542572876000122, 67.62667429600002],
              [23.550324341000135, 67.61091298400002],
              [23.55352827900012, 67.58703847300002],
              [23.535441528000092, 67.577013245],
              [23.499474731000134, 67.566316224],
              [23.47342981000014, 67.55499908500003],
              [23.484695272000096, 67.54295847700006],
              [23.465988404000115, 67.52244293200009],
              [23.443457479000102, 67.50471791600008],
              [23.431261841000094, 67.48552012200004],
              [23.443664184000056, 67.461025492],
              [23.477150513000055, 67.44381724100002],
              [23.514254191000134, 67.44482493200009],
              [23.553838338000105, 67.45200795500004],
              [23.594559367000073, 67.45360992500007],
              [23.66266890500006, 67.43622080500005],
              [23.730778442000087, 67.43141489700004],
              [23.752585897000102, 67.42730662100003],
              [23.765194946000122, 67.42007192000007],
              [23.763231242000103, 67.39754099600005],
              [23.751345662000062, 67.36953237000004],
              [23.751449015000077, 67.3462262990001],
              [23.785658814000072, 67.33751882000003],
              [23.763231242000103, 67.30648712200009],
              [23.73542932100014, 67.28969228100003],
              [23.62225793400009, 67.26902170900003],
              [23.60272424300007, 67.26026255300003],
              [23.594559367000073, 67.24442372600005],
              [23.591458781000114, 67.22501922600007],
              [23.596729777000064, 67.21796539400005],
              [23.614919881000105, 67.21398630800006],
              [23.607065064000068, 67.20122223],
              [23.597556600000075, 67.19026682600013],
              [23.586497844000064, 67.18088755400008],
              [23.57399214700007, 67.17303273600005],
              [23.58133020000008, 67.15313730900003],
              [23.59890018700014, 67.14029571600004],
              [23.6205009360001, 67.12926279700004],
              [23.64778609200002, 67.10856638600002],
              [23.658018026000093, 67.104018861],
              [23.666596313000127, 67.09792104100005],
              [23.6702136640001, 67.08706899],
              [23.670627075000112, 67.07422739700009],
              [23.672590780000064, 67.065700786],
              [23.676724894000074, 67.05849192300012],
              [23.68385624200002, 67.04952606299999],
              [23.72033980300003, 67.01686655800002],
              [23.743800903000107, 67.0010277310001],
              [23.761680949000066, 66.99428395600007],
              [23.792066691000116, 66.98893544600013],
              [23.816664672000115, 66.97549957300008],
              [23.873612102000095, 66.92464996400007],
              [23.91236942600011, 66.9034109500001],
              [23.933350057000013, 66.88876068200001],
              [23.960841919000075, 66.8618889370001],
              [24.001252889000057, 66.81243459100007],
              [24.004043416000115, 66.8051998910001],
              [23.99918583200011, 66.79628570600006],
              [23.98440637200008, 66.79297841400007],
              [23.961048624000057, 66.79354685500003],
              [23.939241170000116, 66.79111806300007],
              [23.924771769000074, 66.77297963500006],
              [23.8924223220001, 66.75091379800004],
              [23.891698853000094, 66.74357574500006],
              [23.902964315000048, 66.70688547800007],
              [23.903171020000116, 66.6863182580001],
              [23.899036906000077, 66.666371155],
              [23.89159550000008, 66.64787099300004],
              [23.881880330000115, 66.63179962200009],
              [23.889115030000085, 66.61407460600007],
              [23.8932491460001, 66.59603953100007],
              [23.891492146000132, 66.57888295500003],
              [23.881880330000115, 66.56353505500003],
              [23.86120975700001, 66.55459503200011],
              [23.80767297400007, 66.53924713200003],
              [23.806122681000147, 66.52813669900003],
              [23.78586551900014, 66.51842153000008],
              [23.75506636500006, 66.5118586230001],
              [23.731088501000073, 66.50312530500013],
              [23.731088501000073, 66.48715728800009],
              [23.706077108000073, 66.48297149700004],
              [23.676828247000117, 66.47400563600011],
              [23.6524369710001, 66.45883860300007],
              [23.64230839000004, 66.43625600200006],
              [23.646649210000106, 66.42406036400006],
              [23.665872843000045, 66.40556020100011],
              [23.6702136640001, 66.39530243000003],
              [23.671660604000095, 66.38178904300007],
              [23.67703495300006, 66.36362477600004],
              [23.676414835000088, 66.35000803700002],
              [23.673004191000075, 66.33951772100006],
              [23.66442590300005, 66.32639190700009],
              [23.662772258000103, 66.31652170900013],
              [23.66597619600006, 66.3054629520001],
              [23.680652303000045, 66.28298370400002],
              [23.68943729700004, 66.25699045900005],
              [23.724163859000072, 66.20663177500008],
              [23.750002075000083, 66.18965606700006],
              [23.785555461000058, 66.17668528300003],
              [23.889321737000046, 66.16110483900009],
              [23.911439250000058, 66.1486249800001],
              [23.965596151000085, 66.08160064700009],
              [23.97458785000012, 66.07281565400011],
              [23.985129842000077, 66.06635610000005],
              [24.00941776500008, 66.05560740200004],
              [24.01964969900007, 66.04894114200003],
              [24.029778279000112, 66.03498850500004],
              [24.05530643700004, 65.98517242499999],
              [24.056960083000092, 65.97010874400009],
              [24.0547896730001, 65.94791371700008],
              [24.07597701000006, 65.92801829100007],
              [24.10233199000004, 65.90858795200008],
              [24.12444950400004, 65.868900452],
              [24.163413534000114, 65.84078847300007],
              [24.16309655000009, 65.82269928600005],
              [24.14031009200005, 65.80451080900008],
              [24.10515384200005, 65.80182526200008],
              [24.032725457000083, 65.80971914300005],
              [24.039073113000086, 65.80365631700005],
              [24.040863477000073, 65.80052317900004],
              [24.043793165000068, 65.79852936400005],
              [24.05323326900009, 65.79604726800005],
              [24.028819207000083, 65.79010651200008],
              [23.98015384200005, 65.79486725500004],
              [23.957041863000086, 65.78912995000007],
              [23.951426629000082, 65.78310781500005],
              [23.94385826900009, 65.76654694200005],
              [23.93653405000009, 65.76121653900003],
              [23.926442905000044, 65.76040273600006],
              [23.918142123000052, 65.76316966400003],
              [23.910329623000052, 65.76691315300008],
              [23.894541863000086, 65.77000560100004],
              [23.885427280000044, 65.77362702000005],
              [23.877696160000085, 65.77899811400005],
              [23.87435957100007, 65.78579336100006],
              [23.871836785000085, 65.79486725500004],
              [23.86573326900009, 65.79486725500004],
              [23.854665561000047, 65.78912995000007],
              [23.80567467500009, 65.78945547100005],
              [23.78174889400009, 65.79303620000007],
              [23.771494988000086, 65.80597565300008],
              [23.761973504000082, 65.82225169500003],
              [23.739431186000047, 65.82929108300004],
              [23.690196160000085, 65.83014557500007],
              [23.674978061000047, 65.82538483300004],
              [23.649261915000068, 65.80304596600007],
              [23.635508660000085, 65.79604726800005],
              [23.623301629000082, 65.79621002800008],
              [23.61622155000009, 65.80093008000006],
              [23.611664259000065, 65.80646393400008],
              [23.607595248000052, 65.80971914300005],
              [23.528005405000044, 65.81000397300005],
              [23.48414147200009, 65.81586334800005],
              [23.490570509000065, 65.82977936400005],
              [23.483571811000047, 65.83437734600005],
              [23.47006269600007, 65.83331940300008],
              [23.457367384000065, 65.83014557500007],
              [23.458181186000047, 65.82843659100007],
              [23.449961785000085, 65.81586334800005],
              [23.44312584700009, 65.81268952000005],
              [23.436208530000044, 65.81134674700007],
              [23.428965691000087, 65.80878327000005],
              [23.422048373000052, 65.80223216400003],
              [23.43327884200005, 65.79779694200005],
              [23.437836134000065, 65.79230377800008],
              [23.438243035000085, 65.78497955900008],
              [23.436289910000085, 65.77488841400003],
              [23.433441602000073, 65.76666901200008],
              [23.428477410000085, 65.76532623900005],
              [23.418793165000068, 65.76723867400005],
              [23.401866082000083, 65.76870351800005],
              [23.385020379000082, 65.77521393400008],
              [23.374278191000087, 65.79043203300006],
              [23.37045332100007, 65.80833567900004],
              [23.374278191000087, 65.82269928600005],
              [23.352793816000087, 65.82135651200008],
              [23.338063998000052, 65.81305573100008],
              [23.32585696700005, 65.80292389500005],
              [23.31218509200005, 65.79604726800005],
              [23.289724155000044, 65.79584381700005],
              [23.268809441000087, 65.80312734600005],
              [23.23023522200009, 65.82269928600005],
              [23.21338951900009, 65.82705312700006],
              [23.195974155000044, 65.82697174700007],
              [23.183767123000052, 65.81964752800008],
              [23.182383660000085, 65.80223216400003],
              [23.19076582100007, 65.78986237200007],
              [23.205739780000044, 65.78131745000007],
              [23.23764082100007, 65.76870351800005],
              [23.221934441000087, 65.76361725500004],
              [23.158457879000082, 65.75023021000004],
              [23.14820397200009, 65.74559153900003],
              [23.128428582000083, 65.73395416900007],
              [23.129567905000044, 65.71503327000005],
              [23.103037957000083, 65.70465729400007],
              [23.078786655000044, 65.70722077000005],
              [23.086761915000068, 65.72772858300004],
              [23.058116082000083, 65.75507233300004],
              [23.04590905000009, 65.76121653900003],
              [22.989756707000083, 65.76430898600006],
              [22.944021030000044, 65.77533600500004],
              [22.93604576900009, 65.77863190300008],
              [22.914886915000068, 65.79604726800005],
              [22.901052280000044, 65.79865143400008],
              [22.877696160000085, 65.79486725500004],
              [22.860199415000068, 65.79604726800005],
              [22.837168816000087, 65.80768463700008],
              [22.805918816000087, 65.84857819200005],
              [22.785166863000086, 65.86432526200008],
              [22.673024936000047, 65.90570709800005],
              [22.653005405000044, 65.90839264500005],
              [22.634287957000083, 65.90521881700005],
              [22.64698326900009, 65.89508698100008],
              [22.672536655000044, 65.88178131700005],
              [22.68213951900009, 65.87107982000003],
              [22.68531334700009, 65.86249420800004],
              [22.688975457000083, 65.83698151200008],
              [22.69304446700005, 65.82391998900005],
              [22.697520379000082, 65.81419505400004],
              [22.69971764400009, 65.80394114800004],
              [22.696462436000047, 65.78912995000007],
              [22.688731316000087, 65.77562083500004],
              [22.677582227000073, 65.76471588700008],
              [22.66374759200005, 65.75751373900005],
              [22.64812259200005, 65.75507233300004],
              [22.653005405000044, 65.77806224200003],
              [22.62794030000009, 65.79035065300008],
              [22.569834832000083, 65.79604726800005],
              [22.55600019600007, 65.79214101800005],
              [22.522715691000087, 65.77643463700008],
              [22.51148522200009, 65.77488841400003],
              [22.50554446700005, 65.78359609600005],
              [22.511566602000073, 65.79466380400004],
              [22.52279707100007, 65.80459219000005],
              [22.531993035000085, 65.80971914300005],
              [22.518402540000068, 65.82265859600005],
              [22.50359134200005, 65.83100006700005],
              [22.469899936000047, 65.84320709800005],
              [22.47242272200009, 65.84686920800004],
              [22.477305535000085, 65.85687897300005],
              [22.405528191000087, 65.86391836100006],
              [22.37012780000009, 65.86172109600005],
              [22.367442254000082, 65.84320709800005],
              [22.32593834700009, 65.83698151200008],
              [22.367442254000082, 65.80971914300005],
              [22.364512566000087, 65.79779694200005],
              [22.35124759200005, 65.79653554900005],
              [22.319102410000085, 65.80223216400003],
              [22.33057701900009, 65.79291413000004],
              [22.345550977000073, 65.77130768400008],
              [22.360606316000087, 65.76121653900003],
              [22.326019727000073, 65.73550039300005],
              [22.285492384000065, 65.74339427300004],
              [22.24463951900009, 65.76023997600004],
              [22.209239129000082, 65.76121653900003],
              [22.23023522200009, 65.74530670800004],
              [22.249847852000073, 65.73574453300006],
              [22.273285352000073, 65.73053620000007],
              [22.33952884200005, 65.72418854400007],
              [22.36182701900009, 65.71625397300005],
              [22.37663821700005, 65.70026276200008],
              [22.387950066000087, 65.67251211100006],
              [22.375254754000082, 65.67352936400005],
              [22.362803582000083, 65.67291901200008],
              [22.350840691000087, 65.67023346600007],
              [22.33961022200009, 65.66502513200004],
              [22.32943769600007, 65.68927643400008],
              [22.307871941000087, 65.70083242400005],
              [22.281504754000082, 65.70148346600007],
              [22.25757897200009, 65.69301992400005],
              [22.26531009200005, 65.68789297100005],
              [22.26807701900009, 65.68121979400007],
              [22.265472852000073, 65.67352936400005],
              [22.25757897200009, 65.66502513200004],
              [22.26531009200005, 65.65949127800008],
              [22.272227410000085, 65.65102773600006],
              [22.28492272200009, 65.63153717700004],
              [22.262054884000065, 65.62555573100008],
              [22.18921959700009, 65.62409088700008],
              [22.26270592500009, 65.61176178600005],
              [22.300629102000073, 65.61151764500005],
              [22.319102410000085, 65.63153717700004],
              [22.31413821700005, 65.64179108300004],
              [22.28956139400009, 65.65570709800005],
              [22.28492272200009, 65.66502513200004],
              [22.293142123000052, 65.67365143400008],
              [22.308604363000086, 65.66937897300005],
              [22.324392123000052, 65.65957265800006],
              [22.33334394600007, 65.65135325700004],
              [22.32593834700009, 65.64520905200004],
              [22.380381707000083, 65.63401927300004],
              [22.38453209700009, 65.62783437700006],
              [22.340098504000082, 65.61286041900007],
              [22.33334394600007, 65.60419342700004],
              [22.343597852000073, 65.59564850500004],
              [22.365977410000085, 65.58893463700008],
              [22.404958530000044, 65.58315664300005],
              [22.411387566000087, 65.57900625200006],
              [22.418630405000044, 65.56915924700007],
              [22.428965691000087, 65.54897695500006],
              [22.40528405000009, 65.54193756700005],
              [22.386892123000052, 65.55003489800004],
              [22.369883660000085, 65.56281159100007],
              [22.35010826900009, 65.56940338700008],
              [22.320323113000086, 65.57196686400005],
              [22.29851321700005, 65.57689036700003],
              [22.274912957000083, 65.58787669500003],
              [22.26303144600007, 65.58958567900004],
              [22.250743035000085, 65.58315664300005],
              [22.256602410000085, 65.56903717700004],
              [22.22828209700009, 65.57208893400008],
              [22.126475457000083, 65.60374583500004],
              [22.05128014400009, 65.61733633000006],
              [22.021332227000073, 65.63495514500005],
              [22.006195509000065, 65.64179108300004],
              [21.96387780000009, 65.64671458500004],
              [21.929860873000052, 65.66339752800008],
              [21.867849155000044, 65.67251211100006],
              [21.852793816000087, 65.67829010600008],
              [21.84351647200009, 65.68382396000004],
              [21.82276451900009, 65.70294830900008],
              [21.80958092500009, 65.71059804900005],
              [21.778168165000068, 65.71946849200003],
              [21.76417076900009, 65.72772858300004],
              [21.787771030000044, 65.68671295800004],
              [21.847911004000082, 65.66095612200007],
              [21.970225457000083, 65.63153717700004],
              [22.052744988000086, 65.59764232000003],
              [22.118662957000083, 65.58348216400003],
              [22.13257897200009, 65.57819245000007],
              [22.147715691000087, 65.56940338700008],
              [22.170095248000052, 65.55304596600007],
              [22.18336022200009, 65.54857005400004],
              [22.202972852000073, 65.54897695500006],
              [22.176931186000047, 65.53978099200003],
              [22.12086022200009, 65.53949616100005],
              [22.09310957100007, 65.53534577000005],
              [22.083994988000086, 65.53180573100008],
              [22.082041863000086, 65.52920156500005],
              [22.081228061000047, 65.52533600500004],
              [22.075694207000083, 65.51788971600007],
              [22.065928582000083, 65.51430898600006],
              [22.056813998000052, 65.51898834800005],
              [22.047618035000085, 65.52496979400007],
              [22.038259311000047, 65.52509186400005],
              [22.011241082000083, 65.51748281500005],
              [21.87468509200005, 65.53685130400004],
              [21.853526238000086, 65.53534577000005],
              [21.900238477000073, 65.50128815300008],
              [21.927907748000052, 65.48944733300004],
              [21.950368686000047, 65.49494049700007],
              [21.929860873000052, 65.50604889500005],
              [21.921722852000073, 65.50800202000005],
              [21.947113477000073, 65.50942617400005],
              [22.004567905000044, 65.47687409100007],
              [22.031586134000065, 65.46702708500004],
              [22.024099155000044, 65.45319245000007],
              [22.01889082100007, 65.44131094000005],
              [22.011729363000086, 65.43203359600005],
              [21.997569207000083, 65.42609284100007],
              [21.981211785000085, 65.42682526200008],
              [21.966075066000087, 65.43374258000006],
              [21.942230665000068, 65.45335521000004],
              [21.932302280000044, 65.44135163000004],
              [21.935883009000065, 65.43105703300006],
              [21.942881707000083, 65.42153554900005],
              [21.942230665000068, 65.41181061400005],
              [21.927744988000086, 65.40412018400008],
              [21.906993035000085, 65.40277741100005],
              [21.888519727000073, 65.40766022300005],
              [21.880869988000086, 65.41864655200004],
              [21.85092207100007, 65.40753815300008],
              [21.820974155000044, 65.40102773600006],
              [21.790212436000047, 65.40009186400005],
              [21.705902540000068, 65.41449616100005],
              [21.688324415000068, 65.41233958500004],
              [21.702647332000083, 65.39813873900005],
              [21.656097852000073, 65.39716217700004],
              [21.631114129000082, 65.40005117400005],
              [21.610036655000044, 65.41864655200004],
              [21.586680535000085, 65.41819896000004],
              [21.544444207000083, 65.41181061400005],
              [21.544444207000083, 65.40558502800008],
              [21.585459832000083, 65.39752838700008],
              [21.599619988000086, 65.39813873900005],
              [21.599619988000086, 65.39191315300008],
              [21.527517123000052, 65.39679596600007],
              [21.489105665000068, 65.39337799700007],
              [21.469981316000087, 65.37763092700004],
              [21.476084832000083, 65.37645091400003],
              [21.485036655000044, 65.37238190300008],
              [21.489756707000083, 65.37083567900004],
              [21.44890384200005, 65.35716380400004],
              [21.46973717500009, 65.35455963700008],
              [21.49154707100007, 65.34829336100006],
              [21.511566602000073, 65.33860911700003],
              [21.527354363000086, 65.32611725500004],
              [21.542979363000086, 65.31858958500004],
              [21.565684441000087, 65.31586334800005],
              [21.583994988000086, 65.32094961100006],
              [21.585948113000086, 65.33665599200003],
              [21.604746941000087, 65.33372630400004],
              [21.622325066000087, 65.32648346600007],
              [21.654307488000086, 65.30878327000005],
              [21.687022332000083, 65.29682038000004],
              [21.70167076900009, 65.28587474200003],
              [21.699229363000086, 65.27155182500007],
              [21.668142123000052, 65.25275299700007],
              [21.62281334700009, 65.24079010600008],
              [21.576996290000068, 65.23810455900008],
              [21.544444207000083, 65.24730052300004],
              [21.534434441000087, 65.25751373900005],
              [21.515961134000065, 65.28339264500005],
              [21.503428582000083, 65.29572174700007],
              [21.48959394600007, 65.30548737200007],
              [21.47429446700005, 65.31403229400007],
              [21.45639082100007, 65.32013580900008],
              [21.435557488000086, 65.32245514500005],
              [21.408946160000085, 65.33319733300004],
              [21.378428582000083, 65.35504791900007],
              [21.345550977000073, 65.37278880400004],
              [21.31226647200009, 65.37083567900004],
              [21.31771894600007, 65.36953359600005],
              [21.327321811000047, 65.36554596600007],
              [21.332774285000085, 65.36399974200003],
              [21.319509311000047, 65.35138580900008],
              [21.27784264400009, 65.35004303600005],
              [21.264414910000085, 65.33665599200003],
              [21.391368035000085, 65.32184479400007],
              [21.422129754000082, 65.30878327000005],
              [21.482269727000073, 65.26097239800004],
              [21.53760826900009, 65.23090241100005],
              [21.60987389400009, 65.16885000200006],
              [21.61882571700005, 65.14801666900007],
              [21.599864129000082, 65.13906484600005],
              [21.544444207000083, 65.13743724200003],
              [21.55713951900009, 65.13117096600007],
              [21.562836134000065, 65.12250397300005],
              [21.56218509200005, 65.11200592700004],
              [21.543793165000068, 65.08307526200008],
              [21.54932701900009, 65.07762278900003],
              [21.54940839900007, 65.07758209800005],
              [21.565277540000068, 65.07558828300006],
              [21.585948113000086, 65.06915924700007],
              [21.563161655000044, 65.06126536700003],
              [21.479258660000085, 65.06232330900008],
              [21.467051629000082, 65.05548737200007],
              [21.477386915000068, 65.04051341400003],
              [21.494883660000085, 65.02631256700005],
              [21.503428582000083, 65.02142975500004],
              [21.47234134200005, 65.00946686400005],
              [21.463145379000082, 65.00771719000005],
              [21.45289147200009, 65.00934479400007],
              [21.43336022200009, 65.01496002800008],
              [21.422129754000082, 65.01459381700005],
              [21.422129754000082, 65.01276276200008],
              [21.420258009000065, 65.00836823100008],
              [21.417491082000083, 65.00364817900004],
              [21.414805535000085, 65.00092194200005],
              [21.397634311000047, 64.99437083500004],
              [21.383148634000065, 64.98655833500004],
              [21.37940514400009, 64.97736237200007],
              [21.39421634200005, 64.96678294500003],
              [21.377777540000068, 64.96002838700008],
              [21.256114129000082, 64.95673248900005],
              [21.243418816000087, 64.95311107000003],
              [21.241465691000087, 64.94537995000007],
              [21.247325066000087, 64.93952057500007],
              [21.252207879000082, 64.93256256700005],
              [21.246836785000085, 64.92177969000005],
              [21.238942905000044, 64.91453685100004],
              [21.22787519600007, 64.90656159100007],
              [21.215179884000065, 64.90033600500004],
              [21.202403191000087, 64.89850495000007],
              [21.21257571700005, 64.87197500200006],
              [21.192881707000083, 64.86115143400008],
              [21.172699415000068, 64.85342031500005],
              [21.18132571700005, 64.83584219000005],
              [21.165293816000087, 64.82982005400004],
              [21.130869988000086, 64.82347239800004],
              [21.11304772200009, 64.82273997600004],
              [21.09734134200005, 64.82754140800006],
              [21.09148196700005, 64.83836497600004],
              [21.08952884200005, 64.85008372600004],
              [21.085215691000087, 64.85757070500006],
              [21.069102410000085, 64.86074453300006],
              [21.053558790000068, 64.85667552300004],
              [21.04200280000009, 64.84686920800004],
              [21.037364129000082, 64.83270905200004],
              [21.04232832100007, 64.81989166900007],
              [21.054698113000086, 64.81443919500003],
              [21.085215691000087, 64.80914948100008],
              [21.08106530000009, 64.79873281500005],
              [21.078949415000068, 64.79486725500004],
              [21.097178582000083, 64.78530508000006],
              [21.11500084700009, 64.78143952000005],
              [21.15398196700005, 64.78119538000004],
              [21.217539910000085, 64.78925202000005],
              [21.281260613000086, 64.77676015800006],
              [21.305837436000047, 64.76829661700003],
              [21.31226647200009, 64.75385163000004],
              [21.299489780000044, 64.74884674700007],
              [21.248301629000082, 64.75079987200007],
              [21.229177280000044, 64.74770742400005],
              [21.246267123000052, 64.73086172100005],
              [21.26726321700005, 64.71751536700003],
              [21.31226647200009, 64.69928620000007],
              [21.31226647200009, 64.69245026200008],
              [21.295746290000068, 64.69208405200004],
              [21.28874759200005, 64.68683502800008],
              [21.291351759000065, 64.67934804900005],
              [21.304942254000082, 64.67194245000007],
              [21.304942254000082, 64.66571686400005],
              [21.27865644600007, 64.67088450700004],
              [21.231293165000068, 64.69399648600006],
              [21.205821160000085, 64.69928620000007],
              [21.184825066000087, 64.70673248900005],
              [21.164886915000068, 64.72158437700006],
              [21.14389082100007, 64.73297760600008],
              [21.119883660000085, 64.72968170800004],
              [21.10914147200009, 64.71637604400007],
              [21.111175977000073, 64.69936758000006],
              [21.12273196700005, 64.68305084800005],
              [21.14039147200009, 64.67194245000007],
              [21.168223504000082, 64.66787344000005],
              [21.20167076900009, 64.66657135600008],
              [21.231944207000083, 64.66107819200005],
              [21.250254754000082, 64.64398834800005],
              [21.231700066000087, 64.64264557500007],
              [21.23218834700009, 64.63300202000005],
              [21.24512780000009, 64.62201569200005],
              [21.263845248000052, 64.61664459800005],
              [21.285411004000082, 64.61615631700005],
              [21.295095248000052, 64.61432526200008],
              [21.304942254000082, 64.61050039300005],
              [21.31023196700005, 64.60565827000005],
              [21.31885826900009, 64.59267812700006],
              [21.322276238000086, 64.59003327000005],
              [21.330251498000052, 64.58685944200005],
              [21.343923373000052, 64.57269928600005],
              [21.35328209700009, 64.56952545800004],
              [21.362803582000083, 64.57221100500004],
              [21.365407748000052, 64.57762278900003],
              [21.363536004000082, 64.58234284100007],
              [21.360118035000085, 64.58258698100008],
              [21.36695397200009, 64.59479401200008],
              [21.368337436000047, 64.60423411700003],
              [21.37403405000009, 64.60797760600008],
              [21.39421634200005, 64.60301341400003],
              [21.414805535000085, 64.58966705900008],
              [21.43726647200009, 64.57111237200007],
              [21.45557701900009, 64.56248607000003],
              [21.46729576900009, 64.58734772300005],
              [21.476410352000073, 64.58746979400007],
              [21.485606316000087, 64.58344147300005],
              [21.489756707000083, 64.57916901200008],
              [21.489756707000083, 64.55585358300004],
              [21.501231316000087, 64.54417552300004],
              [21.515147332000083, 64.53709544500003],
              [21.531911655000044, 64.53412506700005],
              [21.551931186000047, 64.53473541900007],
              [21.539398634000065, 64.52814362200007],
              [21.525563998000052, 64.52289459800005],
              [21.510996941000087, 64.52094147300005],
              [21.49659264400009, 64.52456289300005],
              [21.470957879000082, 64.54498932500007],
              [21.463145379000082, 64.54840729400007],
              [21.41456139400009, 64.52936432500007],
              [21.386566602000073, 64.52171458500004],
              [21.374278191000087, 64.53139883000006],
              [21.371429884000065, 64.53831614800004],
              [21.36459394600007, 64.54169342700004],
              [21.356618686000047, 64.54157135600008],
              [21.349864129000082, 64.53815338700008],
              [21.34734134200005, 64.53196849200003],
              [21.35320071700005, 64.52952708500004],
              [21.36695397200009, 64.52798086100006],
              [21.38607832100007, 64.51032135600008],
              [21.399180535000085, 64.50519440300008],
              [21.411631707000083, 64.51117584800005],
              [21.422536655000044, 64.51463450700004],
              [21.463226759000065, 64.51699453300006],
              [21.476084832000083, 64.51496002800008],
              [21.479665561000047, 64.51064687700006],
              [21.487559441000087, 64.49408600500004],
              [21.489756707000083, 64.48700592700004],
              [21.477712436000047, 64.47166575700004],
              [21.479665561000047, 64.46084219000005],
              [21.49195397200009, 64.45433177300004],
              [21.510508660000085, 64.45221588700008],
              [21.519867384000065, 64.45538971600007],
              [21.53101647200009, 64.46954987200007],
              [21.53760826900009, 64.47272370000007],
              [21.55827884200005, 64.47040436400005],
              [21.57862389400009, 64.46588776200008],
              [21.572438998000052, 64.48016998900005],
              [21.585948113000086, 64.48016998900005],
              [21.597666863000086, 64.47516510600008],
              [21.605316602000073, 64.46564362200007],
              [21.60645592500009, 64.45221588700008],
              [21.60010826900009, 64.44245026200008],
              [21.588633660000085, 64.44110748900005],
              [21.57520592500009, 64.44110748900005],
              [21.561778191000087, 64.43512604400007],
              [21.55054772200009, 64.42841217700004],
              [21.525726759000065, 64.42177969000005],
              [21.513926629000082, 64.41469961100006],
              [21.457286004000082, 64.37164948100008],
              [21.416758660000085, 64.35309479400007],
              [21.397634311000047, 64.33982982000003],
              [21.373220248000052, 64.33038971600007],
              [21.351817254000082, 64.34007396000004],
              [21.333506707000083, 64.35578034100007],
              [21.318532748000052, 64.36408112200007],
              [21.32276451900009, 64.35516998900005],
              [21.324229363000086, 64.34662506700005],
              [21.32276451900009, 64.33812083500004],
              [21.318532748000052, 64.32933177300004],
              [21.324961785000085, 64.32623932500007],
              [21.327647332000083, 64.32294342700004],
              [21.329356316000087, 64.31924062700006],
              [21.332774285000085, 64.31500885600008],
              [21.316416863000086, 64.31207916900007],
              [21.287771030000044, 64.30231354400007],
              [21.270681186000047, 64.30141836100006],
              [21.25635826900009, 64.30512116100005],
              [21.250254754000082, 64.30866120000007],
              [21.24390709700009, 64.30707428600005],
              [21.117035352000073, 64.22113678600005],
              [21.11304772200009, 64.21942780200004],
              [21.082692905000044, 64.22549062700006],
              [21.078949415000068, 64.22687409100007],
              [21.070323113000086, 64.22174713700008],
              [21.04468834700009, 64.19155508000006],
              [20.96656334700009, 64.14940013200004],
              [20.948496941000087, 64.13007233300004],
              [20.960785352000073, 64.11286041900007],
              [20.954274936000047, 64.09479401200008],
              [20.914805535000085, 64.05695221600007],
              [20.912364129000082, 64.05292389500005],
              [20.91146894600007, 64.04759349200003],
              [20.90756269600007, 64.03510163000004],
              [20.910004102000073, 64.03709544500003],
              [20.912282748000052, 64.03351471600007],
              [20.91382897200009, 64.02789948100008],
              [20.914398634000065, 64.02423737200007],
              [20.91260826900009, 64.02106354400007],
              [20.90870201900009, 64.02045319200005],
              [20.904307488000086, 64.01919179900005],
              [20.90137780000009, 64.01406484600005],
              [20.899912957000083, 63.99396393400008],
              [20.89698326900009, 63.983710028000075],
              [20.890472852000073, 63.97923411700003],
              [20.878754102000073, 63.97711823100008],
              [20.87086022200009, 63.97239817900004],
              [20.865977410000085, 63.96771881700005],
              [20.863291863000086, 63.96556224200003],
              [20.84148196700005, 63.959418036000045],
              [20.824961785000085, 63.94472890800006],
              [20.80518639400009, 63.91095612200007],
              [20.78646894600007, 63.878607489000046],
              [20.777191602000073, 63.86937083500004],
              [20.729340040000068, 63.84955475500004],
              [20.684743686000047, 63.84845612200007],
              [20.67481530000009, 63.84271881700005],
              [20.669932488000086, 63.82908763200004],
              [20.677907748000052, 63.82257721600007],
              [20.692881707000083, 63.82099030200004],
              [20.708994988000086, 63.82221100500004],
              [20.687510613000086, 63.79873281500005],
              [20.674652540000068, 63.78925202000005],
              [20.664317254000082, 63.79120514500005],
              [20.64307701900009, 63.814520575000074],
              [20.63021894600007, 63.82086823100008],
              [20.61264082100007, 63.82221100500004],
              [20.56495201900009, 63.79832591400003],
              [20.561778191000087, 63.785223700000074],
              [20.553558790000068, 63.777044989000046],
              [20.54265384200005, 63.77533600500004],
              [20.53093509200005, 63.781236070000034],
              [20.540863477000073, 63.79169342700004],
              [20.53874759200005, 63.800767320000034],
              [20.529307488000086, 63.80878327000005],
              [20.507660352000073, 63.82103099200003],
              [20.503428582000083, 63.82200755400004],
              [20.455821160000085, 63.77220286700003],
              [20.43685957100007, 63.76117584800005],
              [20.413584832000083, 63.767564195000034],
              [20.419200066000087, 63.75934479400007],
              [20.41846764400009, 63.75421784100007],
              [20.415293816000087, 63.74909088700008],
              [20.413584832000083, 63.740301825000074],
              [20.420583530000044, 63.718451239000046],
              [20.421071811000047, 63.71234772300005],
              [20.41504967500009, 63.70111725500004],
              [20.40560957100007, 63.68984609600005],
              [20.39429772200009, 63.68109772300005],
              [20.383067254000082, 63.67763906500005],
              [20.36491946700005, 63.68073151200008],
              [20.354746941000087, 63.689154364000046],
              [20.353526238000086, 63.70140208500004],
              [20.36231530000009, 63.716050523000035],
              [20.361664259000065, 63.725490627000056],
              [20.352386915000068, 63.738714911000045],
              [20.33887780000009, 63.75014883000006],
              [20.325450066000087, 63.753973700000074],
              [20.316661004000082, 63.74005768400008],
              [20.31812584700009, 63.679022528000075],
              [20.30795332100007, 63.654364325000074],
              [20.295176629000082, 63.65224844000005],
              [20.279307488000086, 63.65924713700008],
              [20.267588738000086, 63.67059967700004],
              [20.26693769600007, 63.681341864000046],
              [20.275238477000073, 63.692694403000075],
              [20.28256269600007, 63.706691799000055],
              [20.286631707000083, 63.720770575000074],
              [20.284434441000087, 63.732855536000045],
              [20.264903191000087, 63.71971263200004],
              [20.246104363000086, 63.69822825700004],
              [20.23601321700005, 63.67357005400004],
              [20.242849155000044, 63.65086497600004],
              [20.219411655000044, 63.65338776200008],
              [20.153493686000047, 63.65086497600004],
              [20.143239780000044, 63.648504950000074],
              [20.131602410000085, 63.644232489000046],
              [20.119883660000085, 63.64248281500005],
              [20.10914147200009, 63.64744700700004],
              [20.102305535000085, 63.65729401200008],
              [20.098399285000085, 63.66156647300005],
              [20.092051629000082, 63.66453685100004],
              [20.07357832100007, 63.66624583500004],
              [20.053477410000085, 63.663397528000075],
              [20.03451582100007, 63.65680573100008],
              [20.02003014400009, 63.64744700700004],
              [20.01107832100007, 63.634100653000075],
              [20.01343834700009, 63.62287018400008],
              [20.030528191000087, 63.60248444200005],
              [19.952321811000047, 63.61928945500006],
              [19.937754754000082, 63.61985911700003],
              [19.923106316000087, 63.61237213700008],
              [19.886973504000082, 63.60309479400007],
              [19.879730665000068, 63.59906647300005],
              [19.864431186000047, 63.57318756700005],
              [19.828135613000086, 63.555568752000056],
              [19.786306186000047, 63.541001695000034],
              [19.753184441000087, 63.524318752000056],
              [19.750336134000065, 63.51422760600008],
              [19.766856316000087, 63.487616278000075],
              [19.77247155000009, 63.46458567900004],
              [19.76889082100007, 63.46076080900008],
              [19.744802280000044, 63.45726146000004],
              [19.735606316000087, 63.45294830900008],
              [19.722666863000086, 63.44489166900007],
              [19.699473504000082, 63.43374258000006],
              [19.687347852000073, 63.431341864000046],
              [19.639496290000068, 63.44489166900007],
              [19.63648522200009, 63.45913320500006],
              [19.64031009200005, 63.46979401200008],
              [19.637054884000065, 63.47833893400008],
              [19.61296634200005, 63.48582591400003],
              [19.615407748000052, 63.48969147300005],
              [19.617523634000065, 63.49656810100004],
              [19.619151238000086, 63.500067450000074],
              [19.605723504000082, 63.50405508000006],
              [19.57862389400009, 63.521185614000046],
              [19.52637780000009, 63.530503648000035],
              [19.512950066000087, 63.53758372600004],
              [19.492523634000065, 63.552801825000074],
              [19.470225457000083, 63.56146881700005],
              [19.44629967500009, 63.56085846600007],
              [19.42042076900009, 63.548529364000046],
              [19.431488477000073, 63.54279205900008],
              [19.44312584700009, 63.53888580900008],
              [19.468760613000086, 63.53424713700008],
              [19.454600457000083, 63.50893789300005],
              [19.467051629000082, 63.500881252000056],
              [19.493988477000073, 63.497381903000075],
              [19.523448113000086, 63.48582591400003],
              [19.495616082000083, 63.47671133000006],
              [19.481618686000047, 63.473822333000044],
              [19.465098504000082, 63.47280508000006],
              [19.46143639400009, 63.46893952000005],
              [19.471364780000044, 63.46039459800005],
              [19.511729363000086, 63.43333567900004],
              [19.51539147200009, 63.42625560100004],
              [19.51661217500009, 63.41474030200004],
              [19.507985873000052, 63.41185130400004],
              [19.488291863000086, 63.417181708000044],
              [19.454600457000083, 63.43121979400007],
              [19.372569207000083, 63.47955963700008],
              [19.34620201900009, 63.48590729400007],
              [19.345225457000083, 63.47760651200008],
              [19.372569207000083, 63.44489166900007],
              [19.351410352000073, 63.44000885600008],
              [19.330739780000044, 63.44830963700008],
              [19.311208530000044, 63.46043528900003],
              [19.293223504000082, 63.46653880400004],
              [19.280772332000083, 63.459418036000045],
              [19.276133660000085, 63.442694403000075],
              [19.276540561000047, 63.40761953300006],
              [19.275401238000086, 63.39801666900007],
              [19.270681186000047, 63.38178131700005],
              [19.269541863000086, 63.37287018400008],
              [19.269541863000086, 63.34247467700004],
              [19.259287957000083, 63.32904694200005],
              [19.24545332100007, 63.322333075000074],
              [19.233653191000087, 63.32566966400003],
              [19.229258660000085, 63.34247467700004],
              [19.20753014400009, 63.32611725500004],
              [19.156586134000065, 63.31903717700004],
              [19.133067254000082, 63.308294989000046],
              [19.13917076900009, 63.30560944200005],
              [19.153493686000047, 63.29401276200008],
              [19.141856316000087, 63.28742096600007],
              [19.123301629000082, 63.26414622600004],
              [19.111989780000044, 63.25307851800005],
              [19.133067254000082, 63.25307851800005],
              [19.116709832000083, 63.23663971600007],
              [19.097178582000083, 63.23786041900007],
              [19.057383660000085, 63.26048411700003],
              [19.039886915000068, 63.23895905200004],
              [19.05640709700009, 63.22650788000004],
              [19.08692467500009, 63.22085195500006],
              [19.111989780000044, 63.21954987200007],
              [19.104177280000044, 63.20783112200007],
              [19.09278405000009, 63.20661041900007],
              [19.080088738000086, 63.20750560100004],
              [19.067881707000083, 63.20213450700004],
              [19.061289910000085, 63.19204336100006],
              [19.058604363000086, 63.18390534100007],
              [19.052744988000086, 63.17885976800005],
              [19.03679446700005, 63.17792389500005],
              [19.032481316000087, 63.18203359600005],
              [19.00440514400009, 63.19961172100005],
              [18.99903405000009, 63.20213450700004],
              [18.990977410000085, 63.20844147300005],
              [18.970876498000052, 63.21832916900007],
              [18.961761915000068, 63.225775458000044],
              [18.96656334700009, 63.23891836100006],
              [18.955088738000086, 63.24583567900004],
              [18.937510613000086, 63.25055573100008],
              [18.923838738000086, 63.25678131700005],
              [18.90674889400009, 63.26707591400003],
              [18.885996941000087, 63.27252838700008],
              [18.872894727000073, 63.269191799000055],
              [18.879161004000082, 63.25307851800005],
              [18.866058790000068, 63.24990469000005],
              [18.81031334700009, 63.26048411700003],
              [18.769053582000083, 63.262152411000045],
              [18.751149936000047, 63.259466864000046],
              [18.735199415000068, 63.25307851800005],
              [18.75562584700009, 63.24274323100008],
              [18.913340691000087, 63.21206289300005],
              [18.894379102000073, 63.19782135600008],
              [18.86264082100007, 63.19204336100006],
              [18.79664147200009, 63.19159577000005],
              [18.801117384000065, 63.181708075000074],
              [18.803477410000085, 63.17792389500005],
              [18.787282748000052, 63.168036200000074],
              [18.77312259200005, 63.16876862200007],
              [18.760427280000044, 63.17755768400008],
              [18.75562584700009, 63.19159577000005],
              [18.75294030000009, 63.20766836100006],
              [18.77442467500009, 63.21185944200005],
              [18.82390384200005, 63.21206289300005],
              [18.82390384200005, 63.21954987200007],
              [18.72901451900009, 63.23200104400007],
              [18.700450066000087, 63.225775458000044],
              [18.714121941000087, 63.21922435100004],
              [18.719899936000047, 63.211004950000074],
              [18.722504102000073, 63.20148346600007],
              [18.727793816000087, 63.19159577000005],
              [18.750173373000052, 63.166083075000074],
              [18.75562584700009, 63.157456773000035],
              [18.611338738000086, 63.178900458000044],
              [18.564463738000086, 63.17792389500005],
              [18.564463738000086, 63.171128648000035],
              [18.58562259200005, 63.17072174700007],
              [18.608653191000087, 63.165350653000075],
              [18.629161004000082, 63.15672435100004],
              [18.64307701900009, 63.146918036000045],
              [18.651540561000047, 63.13589101800005],
              [18.657074415000068, 63.12372467700004],
              [18.654633009000065, 63.113714911000045],
              [18.63965905000009, 63.10968659100007],
              [18.61890709700009, 63.11375560100004],
              [18.598887566000087, 63.12124258000006],
              [18.57862389400009, 63.12449778900003],
              [18.556976759000065, 63.116522528000075],
              [18.549652540000068, 63.107082424000055],
              [18.54542076900009, 63.095770575000074],
              [18.53842207100007, 63.08466217700004],
              [18.522959832000083, 63.075506903000075],
              [18.556976759000065, 63.075506903000075],
              [18.51270592500009, 63.05744049700007],
              [18.49903405000009, 63.05508047100005],
              [18.492930535000085, 63.04962799700007],
              [18.486582879000082, 63.02570221600007],
              [18.47820071700005, 63.02024974200003],
              [18.467946811000047, 63.02366771000004],
              [18.43409264400009, 63.04755280200004],
              [18.41928144600007, 63.05312734600005],
              [18.403819207000083, 63.05565013200004],
              [18.387868686000047, 63.05418528900003],
              [18.37208092500009, 63.04755280200004],
              [18.40479576900009, 63.03546784100007],
              [18.421885613000086, 63.02692291900007],
              [18.43409264400009, 63.014105536000045],
              [18.368337436000047, 63.02024974200003],
              [18.365489129000082, 63.02240631700005],
              [18.356618686000047, 63.03302643400008],
              [18.351573113000086, 63.03705475500004],
              [18.34310957100007, 63.03953685100004],
              [18.340668165000068, 63.03607819200005],
              [18.34034264400009, 63.030585028000075],
              [18.337901238000086, 63.02708567900004],
              [18.339121941000087, 63.02558014500005],
              [18.324229363000086, 63.014105536000045],
              [18.29981530000009, 63.00665924700007],
              [18.241709832000083, 62.99982330900008],
              [18.266449415000068, 62.990301825000074],
              [18.52442467500009, 62.991888739000046],
              [18.551117384000065, 62.98590729400007],
              [18.570648634000065, 62.973089911000045],
              [18.57667076900009, 62.95840078300006],
              [18.56804446700005, 62.95343659100007],
              [18.55404707100007, 62.95840078300006],
              [18.54395592500009, 62.973089911000045],
              [18.536631707000083, 62.973089911000045],
              [18.528086785000085, 62.95380280200004],
              [18.50489342500009, 62.949204820000034],
              [18.476898634000065, 62.953111070000034],
              [18.418142123000052, 62.96930573100008],
              [18.40333092500009, 62.964829820000034],
              [18.392588738000086, 62.94521719000005],
              [18.439626498000052, 62.928168036000045],
              [18.454600457000083, 62.92475006700005],
              [18.491058790000068, 62.93121979400007],
              [18.510996941000087, 62.93244049700007],
              [18.522959832000083, 62.92475006700005],
              [18.512543165000068, 62.90412018400008],
              [18.47234134200005, 62.901678778000075],
              [18.40007571700005, 62.91107819200005],
              [18.41504967500009, 62.89716217700004],
              [18.46338951900009, 62.887600002000056],
              [18.474457227000073, 62.87689850500004],
              [18.471364780000044, 62.86774323100008],
              [18.46257571700005, 62.86115143400008],
              [18.451345248000052, 62.857123114000046],
              [18.426931186000047, 62.85407135600008],
              [18.417816602000073, 62.85016510600008],
              [18.410004102000073, 62.845404364000046],
              [18.40007571700005, 62.84153880400004],
              [18.377614780000044, 62.83673737200007],
              [18.366384311000047, 62.83624909100007],
              [18.347178582000083, 62.83966705900008],
              [18.33106530000009, 62.84007396000004],
              [18.324229363000086, 62.84153880400004],
              [18.320974155000044, 62.84467194200005],
              [18.31885826900009, 62.849310614000046],
              [18.31690514400009, 62.85578034100007],
              [18.284434441000087, 62.876288153000075],
              [18.268321160000085, 62.88349030200004],
              [18.24854576900009, 62.88373444200005],
              [18.25098717500009, 62.879787502000056],
              [18.255381707000083, 62.86945221600007],
              [18.207041863000086, 62.86945221600007],
              [18.207041863000086, 62.86322663000004],
              [18.218028191000087, 62.85932038000004],
              [18.220225457000083, 62.85228099200003],
              [18.215668165000068, 62.84389883000006],
              [18.207041863000086, 62.83535390800006],
              [18.229258660000085, 62.82953522300005],
              [18.26221764400009, 62.84829336100006],
              [18.282725457000083, 62.84153880400004],
              [18.25879967500009, 62.810614325000074],
              [18.243662957000083, 62.79901764500005],
              [18.22437584700009, 62.79437897300005],
              [18.215098504000082, 62.79010651200008],
              [18.20557701900009, 62.78196849200003],
              [18.19507897200009, 62.777411200000074],
              [18.18336022200009, 62.78351471600007],
              [18.182871941000087, 62.78998444200005],
              [18.188161655000044, 62.797756252000056],
              [18.195567254000082, 62.80442942900004],
              [18.20085696700005, 62.80801015800006],
              [18.186289910000085, 62.81167226800005],
              [18.176931186000047, 62.80410390800006],
              [18.169118686000047, 62.791449286000045],
              [18.15919030000009, 62.78009674700007],
              [18.140472852000073, 62.771918036000045],
              [18.120371941000087, 62.77057526200008],
              [18.077321811000047, 62.773871161000045],
              [18.082041863000086, 62.783270575000074],
              [18.084727410000085, 62.78693268400008],
              [18.068369988000086, 62.79389069200005],
              [18.048838738000086, 62.795803127000056],
              [18.008962436000047, 62.79437897300005],
              [18.034027540000068, 62.81146881700005],
              [18.121429884000065, 62.80581289300005],
              [18.14616946700005, 62.822251695000034],
              [18.104177280000044, 62.830959377000056],
              [18.084320509000065, 62.83734772300005],
              [18.071055535000085, 62.848944403000075],
              [18.073496941000087, 62.85106028900003],
              [18.074473504000082, 62.85219961100006],
              [18.07520592500009, 62.85333893400008],
              [18.077321811000047, 62.85578034100007],
              [18.054698113000086, 62.852850653000075],
              [18.020274285000085, 62.84125397300005],
              [17.988617384000065, 62.82591380400004],
              [17.974864129000082, 62.81146881700005],
              [17.96778405000009, 62.807806708000044],
              [17.95167076900009, 62.810980536000045],
              [17.93531334700009, 62.81704336100006],
              [17.926442905000044, 62.822251695000034],
              [17.92432701900009, 62.83112213700008],
              [17.926442905000044, 62.86635976800005],
              [17.924489780000044, 62.86933014500005],
              [17.91504967500009, 62.87832265800006],
              [17.912771030000044, 62.88373444200005],
              [17.914724155000044, 62.888739325000074],
              [17.924164259000065, 62.89728424700007],
              [17.926442905000044, 62.90053945500006],
              [17.921397332000083, 62.915716864000046],
              [17.909353061000047, 62.91575755400004],
              [17.893728061000047, 62.91083405200004],
              [17.87867272200009, 62.91107819200005],
              [17.87208092500009, 62.91844310100004],
              [17.85450280000009, 62.955145575000074],
              [17.845713738000086, 62.96360911700003],
              [17.835459832000083, 62.97028229400007],
              [17.823496941000087, 62.97540924700007],
              [17.809743686000047, 62.97931549700007],
              [17.81690514400009, 62.98383209800005],
              [17.830821160000085, 62.99982330900008],
              [17.808604363000086, 62.99835846600007],
              [17.777191602000073, 62.98334381700005],
              [17.761973504000082, 62.97931549700007],
              [17.74350019600007, 62.983587958000044],
              [17.726898634000065, 62.99241771000004],
              [17.710785352000073, 62.99823639500005],
              [17.693614129000082, 62.99359772300005],
              [17.817556186000047, 62.94232819200005],
              [17.847666863000086, 62.92129140800006],
              [17.865896030000044, 62.90192291900007],
              [17.88965905000009, 62.87018463700008],
              [17.901866082000083, 62.83930084800005],
              [17.885508660000085, 62.822251695000034],
              [17.885508660000085, 62.81484609600005],
              [17.92904707100007, 62.80052317900004],
              [17.940684441000087, 62.79437897300005],
              [17.95289147200009, 62.78595612200007],
              [17.95679772200009, 62.782538153000075],
              [17.954925977000073, 62.763332424000055],
              [17.962412957000083, 62.75214264500005],
              [17.995371941000087, 62.727728583000044],
              [18.002696160000085, 62.708970445000034],
              [18.000173373000052, 62.69782135600008],
              [17.990896030000044, 62.68081289300005],
              [17.99195397200009, 62.67454661700003],
              [17.997325066000087, 62.66486237200007],
              [17.993418816000087, 62.65989817900004],
              [17.984385613000086, 62.657904364000046],
              [17.974864129000082, 62.65717194200005],
              [17.96778405000009, 62.65912506700005],
              [17.944834832000083, 62.66864655200004],
              [17.933604363000086, 62.67084381700005],
              [17.871836785000085, 62.67084381700005],
              [17.89161217500009, 62.65802643400008],
              [18.043223504000082, 62.626166083000044],
              [18.044118686000047, 62.61517975500004],
              [18.047699415000068, 62.606634833000044],
              [18.054209832000083, 62.60028717700004],
              [18.06421959700009, 62.595770575000074],
              [18.042491082000083, 62.59210846600007],
              [17.968272332000083, 62.56049225500004],
              [17.962168816000087, 62.56362539300005],
              [17.96070397200009, 62.57599518400008],
              [17.95281009200005, 62.60569896000004],
              [17.953379754000082, 62.611761786000045],
              [17.950368686000047, 62.61481354400007],
              [17.937022332000083, 62.61562734600005],
              [17.93067467500009, 62.61237213700008],
              [17.925791863000086, 62.604722398000035],
              [17.914886915000068, 62.57322825700004],
              [17.913340691000087, 62.56492747600004],
              [17.912771030000044, 62.55756256700005],
              [17.909353061000047, 62.54938385600008],
              [17.900645379000082, 62.54572174700007],
              [17.87867272200009, 62.541083075000074],
              [17.892832879000082, 62.52749258000006],
              [17.861664259000065, 62.50079987200007],
              [17.84310957100007, 62.48969147300005],
              [17.823496941000087, 62.48582591400003],
              [17.812510613000086, 62.489447333000044],
              [17.79542076900009, 62.502834377000056],
              [17.78614342500009, 62.50576406500005],
              [17.734629754000082, 62.50576406500005],
              [17.69304446700005, 62.497748114000046],
              [17.67123457100007, 62.489447333000044],
              [17.658946160000085, 62.47842031500005],
              [17.659678582000083, 62.461371161000045],
              [17.676036004000082, 62.45530833500004],
              [17.696055535000085, 62.45058828300006],
              [17.707367384000065, 62.43744538000004],
              [17.576345248000052, 62.440334377000056],
              [17.561778191000087, 62.44375234600005],
              [17.549978061000047, 62.44830963700008],
              [17.531504754000082, 62.46271393400008],
              [17.526133660000085, 62.46478913000004],
              [17.48145592500009, 62.50576406500005],
              [17.43799889400009, 62.536769924000055],
              [17.42676842500009, 62.541083075000074],
              [17.406097852000073, 62.535589911000045],
              [17.39551842500009, 62.51129791900007],
              [17.37867272200009, 62.50576406500005],
              [17.358571811000047, 62.503973700000074],
              [17.34148196700005, 62.498114325000074],
              [17.330821160000085, 62.48773834800005],
              [17.33057701900009, 62.47223541900007],
              [17.375010613000086, 62.43744538000004],
              [17.37745201900009, 62.43390534100007],
              [17.379242384000065, 62.425767320000034],
              [17.379730665000068, 62.41681549700007],
              [17.378428582000083, 62.41079336100006],
              [17.370941602000073, 62.406236070000034],
              [17.359385613000086, 62.403957424000055],
              [17.34701582100007, 62.40330638200004],
              [17.337412957000083, 62.403957424000055],
              [17.348887566000087, 62.39801666900007],
              [17.360524936000047, 62.38959381700005],
              [17.366465691000087, 62.378892320000034],
              [17.361175977000073, 62.366115627000056],
              [17.360036655000044, 62.35565827000005],
              [17.368011915000068, 62.343085028000075],
              [17.38062584700009, 62.33266836100006],
              [17.392751498000052, 62.32827383000006],
              [17.424001498000052, 62.331732489000046],
              [17.437836134000065, 62.33026764500005],
              [17.45411217500009, 62.32143789300005],
              [17.46192467500009, 62.312567450000074],
              [17.468760613000086, 62.301947333000044],
              [17.476817254000082, 62.292303778000075],
              [17.488291863000086, 62.28660716400003],
              [17.488291863000086, 62.280462958000044],
              [17.478851759000065, 62.28074778900003],
              [17.472666863000086, 62.27912018400008],
              [17.460215691000087, 62.27301666900007],
              [17.54656009200005, 62.24909088700008],
              [17.566661004000082, 62.253892320000034],
              [17.59937584700009, 62.24957916900007],
              [17.632090691000087, 62.240668036000045],
              [17.652679884000065, 62.23200104400007],
              [17.569509311000047, 62.204738674000055],
              [17.544444207000083, 62.201605536000045],
              [17.541758660000085, 62.206366278000075],
              [17.569509311000047, 62.23200104400007],
              [17.552989129000082, 62.23725006700005],
              [17.53492272200009, 62.23501211100006],
              [17.519053582000083, 62.22793203300006],
              [17.508636915000068, 62.218410549000055],
              [17.504161004000082, 62.20368073100008],
              [17.505381707000083, 62.18744538000004],
              [17.508067254000082, 62.173081773000035],
              [17.508636915000068, 62.163763739000046],
              [17.50163821700005, 62.15062083500004],
              [17.49854576900009, 62.14756907800006],
              [17.481618686000047, 62.13043854400007],
              [17.474457227000073, 62.11660390800006],
              [17.47242272200009, 62.09682851800005],
              [17.47315514400009, 62.08466217700004],
              [17.467621290000068, 62.07636139500005],
              [17.447276238000086, 62.06818268400008],
              [17.469004754000082, 62.062160549000055],
              [17.459239129000082, 62.04865143400008],
              [17.426117384000065, 62.026556708000044],
              [17.437836134000065, 62.021551825000074],
              [17.452647332000083, 62.01227448100008],
              [17.460459832000083, 62.00332265800006],
              [17.450694207000083, 61.999253648000035],
              [17.40284264400009, 61.99559153900003],
              [17.392100457000083, 61.99241771000004],
              [17.38648522200009, 61.982082424000055],
              [17.388682488000086, 61.97085195500006],
              [17.385996941000087, 61.96198151200008],
              [17.36459394600007, 61.958319403000075],
              [17.354746941000087, 61.95530833500004],
              [17.34815514400009, 61.94757721600007],
              [17.344574415000068, 61.93667226800005],
              [17.34424889400009, 61.92413971600007],
              [17.34815514400009, 61.91156647300005],
              [17.36182701900009, 61.89394765800006],
              [17.36459394600007, 61.88629791900007],
              [17.361501498000052, 61.87970612200007],
              [17.34734134200005, 61.87449778900003],
              [17.34424889400009, 61.869574286000045],
              [17.34351647200009, 61.87128327000005],
              [17.342621290000068, 61.86375560100004],
              [17.342621290000068, 61.85565827000005],
              [17.34424889400009, 61.85586172100005],
              [17.346934441000087, 61.855129299000055],
              [17.351817254000082, 61.85252513200004],
              [17.353770379000082, 61.847316799000055],
              [17.347666863000086, 61.83852773600006],
              [17.342621290000068, 61.83392975500004],
              [17.338633660000085, 61.829006252000056],
              [17.337412957000083, 61.82367584800005],
              [17.34083092500009, 61.818060614000046],
              [17.353688998000052, 61.81403229400007],
              [17.40560957100007, 61.82111237200007],
              [17.400726759000065, 61.81159088700008],
              [17.392914259000065, 61.80524323100008],
              [17.383067254000082, 61.80170319200005],
              [17.37159264400009, 61.80060455900008],
              [17.37159264400009, 61.79315827000005],
              [17.38835696700005, 61.788316148000035],
              [17.390635613000086, 61.77708567900004],
              [17.387054884000065, 61.762152411000045],
              [17.385915561000047, 61.74603913000004],
              [17.39112389400009, 61.727728583000044],
              [17.399180535000085, 61.722357489000046],
              [17.44825280000009, 61.728501695000034],
              [17.465586785000085, 61.73354726800005],
              [17.483083530000044, 61.73456452000005],
              [17.501963738000086, 61.72553131700005],
              [17.51417076900009, 61.71381256700005],
              [17.520274285000085, 61.702378648000035],
              [17.52003014400009, 61.69122955900008],
              [17.512054884000065, 61.68024323100008],
              [17.50562584700009, 61.66705963700008],
              [17.50245201900009, 61.64984772300005],
              [17.496348504000082, 61.63507721600007],
              [17.48145592500009, 61.62872955900008],
              [17.461599155000044, 61.62962474200003],
              [17.446136915000068, 61.632879950000074],
              [17.432871941000087, 61.63939036700003],
              [17.419932488000086, 61.64984772300005],
              [17.38331139400009, 61.692694403000075],
              [17.36231530000009, 61.70913320500006],
              [17.33057701900009, 61.718085028000075],
              [17.332286004000082, 61.70502350500004],
              [17.337412957000083, 61.69513580900008],
              [17.35092207100007, 61.67715078300006],
              [17.313161655000044, 61.68195221600007],
              [17.29981530000009, 61.68992747600004],
              [17.30323326900009, 61.705064195000034],
              [17.26661217500009, 61.72162506700005],
              [17.22429446700005, 61.72724030200004],
              [17.13803144600007, 61.72553131700005],
              [17.150401238000086, 61.71430084800005],
              [17.16570071700005, 61.71039459800005],
              [17.199961785000085, 61.71124909100007],
              [17.26856530000009, 61.69082265800006],
              [17.259776238000086, 61.67413971600007],
              [17.228688998000052, 61.66307200700004],
              [17.19190514400009, 61.657416083000044],
              [17.166188998000052, 61.656683661000045],
              [17.166188998000052, 61.64984772300005],
              [17.173838738000086, 61.648871161000045],
              [17.193369988000086, 61.64232005400004],
              [17.164805535000085, 61.636419989000046],
              [17.11890709700009, 61.645819403000075],
              [17.097178582000083, 61.63613515800006],
              [17.22559655000009, 61.62201569200005],
              [17.247894727000073, 61.60883209800005],
              [17.22592207100007, 61.602850653000075],
              [17.208506707000083, 61.60455963700008],
              [17.17237389400009, 61.615668036000045],
              [17.150726759000065, 61.61790599200003],
              [17.083506707000083, 61.615668036000045],
              [17.083506707000083, 61.60883209800005],
              [17.119151238000086, 61.60968659100007],
              [17.134938998000052, 61.60594310100004],
              [17.145681186000047, 61.59520091400003],
              [17.10287519600007, 61.58502838700008],
              [17.05632571700005, 61.58218008000006],
              [17.082367384000065, 61.57127513200004],
              [17.18653405000009, 61.56102122600004],
              [17.18653405000009, 61.55418528900003],
              [17.09034264400009, 61.55605703300006],
              [17.080088738000086, 61.550482489000046],
              [17.089040561000047, 61.545355536000045],
              [17.111582879000082, 61.541449286000045],
              [17.130137566000087, 61.53270091400003],
              [17.155528191000087, 61.52952708500004],
              [17.166188998000052, 61.52692291900007],
              [17.166188998000052, 61.51947663000004],
              [17.124522332000083, 61.51947663000004],
              [17.124522332000083, 61.51325104400007],
              [17.16374759200005, 61.50405508000006],
              [17.17237389400009, 61.49896881700005],
              [17.177012566000087, 61.48688385600008],
              [17.17156009200005, 61.48041413000004],
              [17.161306186000047, 61.474595445000034],
              [17.151866082000083, 61.464829820000034],
              [17.157481316000087, 61.456284898000035],
              [17.16146894600007, 61.44798411700003],
              [17.16928144600007, 61.441107489000046],
              [17.179698113000086, 61.43695709800005],
              [17.192556186000047, 61.43699778900003],
              [17.198741082000083, 61.44208405200004],
              [17.20411217500009, 61.44822825700004],
              [17.213552280000044, 61.451157945000034],
              [17.22038821700005, 61.44798411700003],
              [17.221446160000085, 61.44098541900007],
              [17.217051629000082, 61.43390534100007],
              [17.207041863000086, 61.43073151200008],
              [17.195485873000052, 61.42987702000005],
              [17.18458092500009, 61.42731354400007],
              [17.17481530000009, 61.42283763200004],
              [17.166188998000052, 61.41640859600005],
              [17.15870201900009, 61.42413971600007],
              [17.147227410000085, 61.43353913000004],
              [17.136566602000073, 61.43707916900007],
              [17.127614780000044, 61.41828034100007],
              [17.10840905000009, 61.409369208000044],
              [17.10401451900009, 61.39935944200005],
              [17.10914147200009, 61.39362213700008],
              [17.13803144600007, 61.36928945500006],
              [17.16700280000009, 61.35578034100007],
              [17.20020592500009, 61.34813060100004],
              [17.201833530000044, 61.337103583000044],
              [17.276052280000044, 61.31403229400007],
              [17.246104363000086, 61.31028880400004],
              [17.213715040000068, 61.31342194200005],
              [17.151866082000083, 61.32831452000005],
              [17.166270379000082, 61.30841705900008],
              [17.19312584700009, 61.299261786000045],
              [17.223399285000085, 61.29437897300005],
              [17.247894727000073, 61.28729889500005],
              [17.205088738000086, 61.28851959800005],
              [17.18726647200009, 61.29120514500005],
              [17.135101759000065, 61.316107489000046],
              [17.118418816000087, 61.319647528000075],
              [17.097178582000083, 61.32086823100008],
              [17.097178582000083, 61.31403229400007],
              [17.121348504000082, 61.30817291900007],
              [17.151540561000047, 61.29389069200005],
              [17.180349155000044, 61.27602773600006],
              [17.20020592500009, 61.259426174000055],
              [17.212738477000073, 61.23529694200005],
              [17.197113477000073, 61.22630442900004],
              [17.17090905000009, 61.220038153000075],
              [17.151866082000083, 61.20416901200008],
              [17.18653405000009, 61.191107489000046],
              [17.181651238000086, 61.16596100500004],
              [17.17432701900009, 61.15766022300005],
              [17.15870201900009, 61.14956289300005],
              [17.178965691000087, 61.135972398000035],
              [17.182790561000047, 61.12323639500005],
              [17.171397332000083, 61.11505768400008],
              [17.145681186000047, 61.11473216400003],
              [17.15674889400009, 61.111761786000045],
              [17.183848504000082, 61.11155833500004],
              [17.193369988000086, 61.108587958000044],
              [17.198090040000068, 61.10268789300005],
              [17.199880405000044, 61.09589264500005],
              [17.197520379000082, 61.09039948100008],
              [17.18995201900009, 61.08808014500005],
              [17.181162957000083, 61.083685614000046],
              [17.173838738000086, 61.07290273600006],
              [17.168711785000085, 61.05931224200003],
              [17.166188998000052, 61.046535549000055],
              [17.16968834700009, 61.04246653900003],
              [17.177256707000083, 61.037176825000074],
              [17.18653405000009, 61.032863674000055],
              [17.165537957000083, 61.02228424700007],
              [17.15870201900009, 61.01984284100007],
              [17.21143639400009, 61.023871161000045],
              [17.235850457000083, 61.02228424700007],
              [17.247894727000073, 61.01235586100006],
              [17.188243035000085, 61.00458405200004],
              [17.16773522200009, 60.992173570000034],
              [17.15870201900009, 60.964544989000046],
              [17.157481316000087, 60.952378648000035],
              [17.158213738000086, 60.948431708000044],
              [17.179698113000086, 60.93724192900004],
              [17.197438998000052, 60.93622467700004],
              [17.205088738000086, 60.93390534100007],
              [17.202403191000087, 60.921535549000055],
              [17.205088738000086, 60.91469961100006],
              [17.21387780000009, 60.90253327000005],
              [17.216807488000086, 60.89935944200005],
              [17.23292076900009, 60.90460846600007],
              [17.241709832000083, 60.90253327000005],
              [17.246267123000052, 60.89801666900007],
              [17.28223717500009, 60.841009833000044],
              [17.274099155000044, 60.83974844000005],
              [17.265147332000083, 60.83698151200008],
              [17.258067254000082, 60.83274974200003],
              [17.25554446700005, 60.827378648000035],
              [17.259287957000083, 60.815659898000035],
              [17.26661217500009, 60.81517161700003],
              [17.27507571700005, 60.81720612200007],
              [17.28223717500009, 60.81313711100006],
              [17.28484134200005, 60.799994208000044],
              [17.28223717500009, 60.78974030200004],
              [17.283050977000073, 60.78115469000005],
              [17.296397332000083, 60.772772528000075],
              [17.31544030000009, 60.76972077000005],
              [17.330821160000085, 60.77033112200007],
              [17.33570397200009, 60.766913153000075],
              [17.323741082000083, 60.75234609600005],
              [17.31153405000009, 60.74526601800005],
              [17.279144727000073, 60.73627350500004],
              [17.252207879000082, 60.720038153000075],
              [17.214691602000073, 60.706244208000044],
              [17.19117272200009, 60.70172760600008],
              [17.186289910000085, 60.69708893400008],
              [17.186696811000047, 60.69236888200004],
              [17.193369988000086, 60.69017161700003],
              [17.205251498000052, 60.69135163000004],
              [17.22754967500009, 60.696478583000044],
              [17.23804772200009, 60.697699286000045],
              [17.257985873000052, 60.69440338700008],
              [17.278005405000044, 60.67987702000005],
              [17.31023196700005, 60.673041083000044],
              [17.36459394600007, 60.64923737200007],
              [17.323741082000083, 60.635646877000056],
              [17.323741082000083, 60.62872955900008],
              [17.33952884200005, 60.62299225500004],
              [17.35987389400009, 60.62148672100005],
              [17.37663821700005, 60.623887437000064],
              [17.38021894600007, 60.62441640800006],
              [17.395762566000087, 60.63222890800006],
              [17.41382897200009, 60.637925523000035],
              [17.547129754000082, 60.64915599200003],
              [17.574961785000085, 60.64789459800005],
              [17.594086134000065, 60.63934967700004],
              [17.60840905000009, 60.63043854400007],
              [17.64551842500009, 60.61859772300005],
              [17.658946160000085, 60.608303127000056],
              [17.646739129000082, 60.59955475500004],
              [17.61109459700009, 60.58852773600006],
              [17.603770379000082, 60.58413320500006],
              [17.606944207000083, 60.569525458000044],
              [17.621429884000065, 60.54706452000005],
              [17.62476647200009, 60.536322333000044],
              [17.638194207000083, 60.51544830900008],
              [17.670583530000044, 60.50409577000005],
              [17.741465691000087, 60.49843984600005],
              [17.741465691000087, 60.505845445000034],
              [17.72706139400009, 60.53473541900007],
              [17.76221764400009, 60.56329987200007],
              [17.81609134200005, 60.585272528000075],
              [17.918630405000044, 60.60016510600008],
              [17.948741082000083, 60.59918854400007],
              [17.974864129000082, 60.58783600500004],
              [17.995371941000087, 60.55304596600007],
              [17.99350019600007, 60.54092031500005],
              [17.98764082100007, 60.53074778900003],
              [17.978688998000052, 60.52334219000005],
              [17.967458530000044, 60.51894765800006],
              [17.967458530000044, 60.51211172100005],
              [17.993418816000087, 60.510931708000044],
              [18.018321160000085, 60.50226471600007],
              [18.06421959700009, 60.47797272300005],
              [18.098399285000085, 60.464911200000074],
              [18.10254967500009, 60.45892975500004],
              [18.10873457100007, 60.44253164300005],
              [18.111989780000044, 60.43695709800005],
              [18.143321160000085, 60.41356028900003],
              [18.17872155000009, 60.39891185100004],
              [18.26221764400009, 60.38239166900007],
              [18.245371941000087, 60.37689850500004],
              [18.219899936000047, 60.36367422100005],
              [18.207041863000086, 60.35504791900007],
              [18.207041863000086, 60.34760163000004],
              [18.22120201900009, 60.339056708000044],
              [18.22787519600007, 60.33380768400008],
              [18.23487389400009, 60.32709381700005],
              [18.250661655000044, 60.334051825000074],
              [18.277517123000052, 60.34935130400004],
              [18.296397332000083, 60.35504791900007],
              [18.31348717500009, 60.35691966400003],
              [18.326345248000052, 60.355536200000074],
              [18.35840905000009, 60.34760163000004],
              [18.427989129000082, 60.34878164300005],
              [18.44776451900009, 60.34137604400007],
              [18.44662519600007, 60.33836497600004],
              [18.44581139400009, 60.33022695500006],
              [18.445974155000044, 60.32070547100005],
              [18.44776451900009, 60.31346263200004],
              [18.451996290000068, 60.310248114000046],
              [18.474457227000073, 60.29979075700004],
              [18.474457227000073, 60.292954820000034],
              [18.462087436000047, 60.29124583500004],
              [18.449880405000044, 60.29242584800005],
              [18.43799889400009, 60.29205963700008],
              [18.42676842500009, 60.28620026200008],
              [18.56544030000009, 60.25934479400007],
              [18.60482832100007, 60.238348700000074],
              [18.563731316000087, 60.22760651200008],
              [18.400563998000052, 60.25958893400008],
              [18.369151238000086, 60.278998114000046],
              [18.31690514400009, 60.32094961100006],
              [18.330902540000068, 60.28571198100008],
              [18.369883660000085, 60.25861237200007],
              [18.41504967500009, 60.23509349200003],
              [18.44776451900009, 60.21108633000006],
              [18.43067467500009, 60.21035390800006],
              [18.417246941000087, 60.21576569200005],
              [18.392588738000086, 60.23216380400004],
              [18.399668816000087, 60.20783112200007],
              [18.419932488000086, 60.19350820500006],
              [18.468272332000083, 60.17633698100008],
              [18.492930535000085, 60.16079336100006],
              [18.506114129000082, 60.15574778900003],
              [18.522959832000083, 60.15582916900007],
              [18.53492272200009, 60.15888092700004],
              [18.544118686000047, 60.16425202000005],
              [18.548024936000047, 60.172308661000045],
              [18.54851321700005, 60.17413971600007],
              [18.548106316000087, 60.143866278000075],
              [18.55014082100007, 60.12909577000005],
              [18.554535352000073, 60.12140534100007],
              [18.573415561000047, 60.08820221600007],
              [18.578135613000086, 60.073919989000046],
              [18.584320509000065, 60.073919989000046],
              [18.589854363000086, 60.08885325700004],
              [18.59083092500009, 60.108303127000056],
              [18.587168816000087, 60.12750885600008],
              [18.578135613000086, 60.14215729400007],
              [18.59937584700009, 60.14826080900008],
              [18.625743035000085, 60.150824286000045],
              [18.65137780000009, 60.14826080900008],
              [18.685720248000052, 60.13080475500004],
              [18.720713738000086, 60.12604401200008],
              [18.735199415000068, 60.11481354400007],
              [18.74000084700009, 60.09861888200004],
              [18.738291863000086, 60.064113674000055],
              [18.74512780000009, 60.049709377000056],
              [18.78882897200009, 60.017564195000034],
              [18.79664147200009, 60.00495026200008],
              [18.781504754000082, 60.03082916900007],
              [18.762543165000068, 60.055975653000075],
              [18.753103061000047, 60.08218008000006],
              [18.765879754000082, 60.11107005400004],
              [18.803477410000085, 60.12164948100008],
              [18.81690514400009, 60.11758047100005],
              [18.820485873000052, 60.11367422100005],
              [18.817637566000087, 60.09780508000006],
              [18.819590691000087, 60.08100006700005],
              [18.824473504000082, 60.06830475500004],
              [18.86817467500009, 59.99371979400007],
              [18.903086785000085, 59.94721100500004],
              [18.922129754000082, 59.93431224200003],
              [18.96583092500009, 59.92682526200008],
              [18.98878014400009, 59.91933828300006],
              [19.00554446700005, 59.911810614000046],
              [19.00953209700009, 59.909409898000035],
              [19.010020379000082, 59.90692780200004],
              [19.008962436000047, 59.89874909100007],
              [19.00953209700009, 59.89630768400008],
              [19.02442467500009, 59.88450755400004],
              [19.032074415000068, 59.88149648600006],
              [19.043630405000044, 59.882066148000035],
              [19.041758660000085, 59.88686758000006],
              [19.03882897200009, 59.89801666900007],
              [19.03679446700005, 59.90253327000005],
              [19.054535352000073, 59.90070221600007],
              [19.07162519600007, 59.89630768400008],
              [19.068207227000073, 59.88190338700008],
              [19.066661004000082, 59.84194570500006],
              [19.067881707000083, 59.833685614000046],
              [19.034678582000083, 59.83502838700008],
              [19.02125084700009, 59.84003327000005],
              [18.949066602000073, 59.89996979400007],
              [18.916758660000085, 59.92129140800006],
              [18.885996941000087, 59.92987702000005],
              [18.896332227000073, 59.91705963700008],
              [18.93067467500009, 59.88548411700003],
              [18.93531334700009, 59.868475653000075],
              [18.924082879000082, 59.85228099200003],
              [18.861582879000082, 59.80304596600007],
              [18.84343509200005, 59.79555898600006],
              [18.82081139400009, 59.792669989000046],
              [18.77702884200005, 59.793850002000056],
              [18.754567905000044, 59.79116445500006],
              [18.738617384000065, 59.78278229400007],
              [18.733897332000083, 59.768784898000035],
              [18.751963738000086, 59.768866278000075],
              [18.789805535000085, 59.77903880400004],
              [19.04200280000009, 59.78497955900008],
              [19.085215691000087, 59.77220286700003],
              [19.074473504000082, 59.749701239000046],
              [19.057790561000047, 59.73615143400008],
              [19.035980665000068, 59.728501695000034],
              [18.975271030000044, 59.71906159100007],
              [18.95679772200009, 59.71922435100004],
              [18.941254102000073, 59.723822333000044],
              [18.931651238000086, 59.73139069200005],
              [18.92090905000009, 59.74640534100007],
              [18.913340691000087, 59.75177643400008],
              [18.90137780000009, 59.73468659100007],
              [18.87989342500009, 59.721584377000056],
              [18.855479363000086, 59.71308014500005],
              [18.781260613000086, 59.70156484600005],
              [18.757823113000086, 59.691066799000055],
              [18.75562584700009, 59.676662502000056],
              [18.719981316000087, 59.67572663000004],
              [18.714121941000087, 59.67324453300006],
              [18.71257571700005, 59.66437409100007],
              [18.708506707000083, 59.657456773000035],
              [18.701996290000068, 59.65257396000004],
              [18.693614129000082, 59.64935944200005],
              [18.742035352000073, 59.64935944200005],
              [18.735606316000087, 59.641506252000056],
              [18.723806186000047, 59.63226959800005],
              [18.710459832000083, 59.62457916900007],
              [18.700450066000087, 59.62140534100007],
              [18.690196160000085, 59.624253648000035],
              [18.681976759000065, 59.630072333000044],
              [18.672699415000068, 59.635199286000045],
              [18.660004102000073, 59.63568756700005],
              [18.679698113000086, 59.61676666900007],
              [18.68653405000009, 59.60578034100007],
              [18.67709394600007, 59.600897528000075],
              [18.664317254000082, 59.597723700000074],
              [18.63998457100007, 59.583644924000055],
              [18.59734134200005, 59.57404205900008],
              [18.54070071700005, 59.54584381700005],
              [18.48406009200005, 59.534409898000035],
              [18.457855665000068, 59.52195872600004],
              [18.41309655000009, 59.49103424700007],
              [18.379649285000085, 59.47638580900008],
              [18.344981316000087, 59.473089911000045],
              [18.269053582000083, 59.477443752000056],
              [18.269053582000083, 59.47060781500005],
              [18.30323326900009, 59.45697663000004],
              [18.289317254000082, 59.45058828300006],
              [18.26221764400009, 59.452460028000075],
              [18.24854576900009, 59.450100002000056],
              [18.266774936000047, 59.44476959800005],
              [18.282725457000083, 59.436428127000056],
              [18.276866082000083, 59.42255280200004],
              [18.293142123000052, 59.414048570000034],
              [18.317881707000083, 59.40973541900007],
              [18.337901238000086, 59.40851471600007],
              [18.307302280000044, 59.39679596600007],
              [18.247569207000083, 59.397691148000035],
              [18.18848717500009, 59.407416083000044],
              [18.15919030000009, 59.42218659100007],
              [18.170664910000085, 59.42609284100007],
              [18.182871941000087, 59.42804596600007],
              [18.195323113000086, 59.42715078300006],
              [18.207041863000086, 59.42218659100007],
              [18.203868035000085, 59.43060944200005],
              [18.199473504000082, 59.450873114000046],
              [18.194021030000044, 59.45697663000004],
              [18.18140709700009, 59.458197333000044],
              [18.15919030000009, 59.44700755400004],
              [18.14551842500009, 59.44383372600004],
              [18.13770592500009, 59.44603099200003],
              [18.126231316000087, 59.45526764500005],
              [18.11882571700005, 59.45697663000004],
              [18.113291863000086, 59.45465729400007],
              [18.10124759200005, 59.44578685100004],
              [18.094981316000087, 59.44383372600004],
              [18.08448326900009, 59.43895091400003],
              [18.08448326900009, 59.427801825000074],
              [18.090586785000085, 59.41592031500005],
              [18.098399285000085, 59.40851471600007],
              [18.06544030000009, 59.39716217700004],
              [18.053965691000087, 59.39545319200005],
              [18.042491082000083, 59.397365627000056],
              [18.020681186000047, 59.40607330900008],
              [18.008962436000047, 59.40851471600007],
              [18.14616946700005, 59.34023672100005],
              [18.110524936000047, 59.336004950000074],
              [18.09506269600007, 59.338405666000085],
              [18.095144076000054, 59.32680898600006],
              [18.17286217500009, 59.32656484600005],
              [18.19662519600007, 59.33417389500005],
              [18.207041863000086, 59.33266836100006],
              [18.214366082000083, 59.31976959800005],
              [18.220550977000073, 59.31976959800005],
              [18.254730665000068, 59.36277903900003],
              [18.31812584700009, 59.37592194200005],
              [18.38965905000009, 59.36945221600007],
              [18.44776451900009, 59.35390859600005],
              [18.442149285000085, 59.35073476800005],
              [18.43213951900009, 59.34332916900007],
              [18.42676842500009, 59.34023672100005],
              [18.45679772200009, 59.33535390800006],
              [18.47006269600007, 59.337103583000044],
              [18.481944207000083, 59.347723700000074],
              [18.454925977000073, 59.38157786700003],
              [18.44776451900009, 59.39545319200005],
              [18.495616082000083, 59.39545319200005],
              [18.455821160000085, 59.40965403900003],
              [18.437510613000086, 59.419256903000075],
              [18.42676842500009, 59.436428127000056],
              [18.484629754000082, 59.43423086100006],
              [18.51075280000009, 59.428168036000045],
              [18.536631707000083, 59.41596100500004],
              [18.538259311000047, 59.41250234600005],
              [18.542165561000047, 59.39923737200007],
              [18.54395592500009, 59.39545319200005],
              [18.61231530000009, 59.37494538000004],
              [18.600840691000087, 59.362494208000044],
              [18.58366946700005, 59.36245351800005],
              [18.56348717500009, 59.366888739000046],
              [18.54395592500009, 59.36815013200004],
              [18.566579623000052, 59.361314195000034],
              [18.601084832000083, 59.35578034100007],
              [18.63257897200009, 59.346909898000035],
              [18.646494988000086, 59.33026764500005],
              [18.638926629000082, 59.31509023600006],
              [18.619802280000044, 59.308294989000046],
              [18.567637566000087, 59.306708075000074],
              [18.551605665000068, 59.304388739000046],
              [18.53565514400009, 59.300116278000075],
              [18.51929772200009, 59.29828522300005],
              [18.50245201900009, 59.30296458500004],
              [18.49000084700009, 59.307847398000035],
              [18.461192254000082, 59.31244538000004],
              [18.44776451900009, 59.312933661000045],
              [18.364431186000047, 59.30658600500004],
              [18.337901238000086, 59.312933661000045],
              [18.339854363000086, 59.317572333000044],
              [18.34278405000009, 59.32949453300006],
              [18.34473717500009, 59.334051825000074],
              [18.324880405000044, 59.334418036000045],
              [18.307383660000085, 59.33022695500006],
              [18.291270379000082, 59.322699286000045],
              [18.27588951900009, 59.312933661000045],
              [18.28874759200005, 59.308294989000046],
              [18.30014082100007, 59.30133698100008],
              [18.30958092500009, 59.293402411000045],
              [18.31690514400009, 59.285589911000045],
              [18.31690514400009, 59.27875397300005],
              [18.283050977000073, 59.278998114000046],
              [18.272959832000083, 59.27423737200007],
              [18.279307488000086, 59.261704820000034],
              [18.33765709700009, 59.24461497600004],
              [18.361175977000073, 59.24079010600008],
              [18.388194207000083, 59.23029205900008],
              [18.412282748000052, 59.21503327000005],
              [18.42676842500009, 59.19684479400007],
              [18.33570397200009, 59.23590729400007],
              [18.313731316000087, 59.234076239000046],
              [18.31348717500009, 59.22211334800005],
              [18.32943769600007, 59.21466705900008],
              [18.35059655000009, 59.210923570000034],
              [18.365244988000086, 59.20990631700005],
              [18.372325066000087, 59.20351797100005],
              [18.377696160000085, 59.19122955900008],
              [18.387054884000065, 59.18309153900003],
              [18.406260613000086, 59.18939850500004],
              [18.40284264400009, 59.18549225500004],
              [18.400645379000082, 59.18219635600008],
              [18.397715691000087, 59.17910390800006],
              [18.392588738000086, 59.175767320000034],
              [18.392588738000086, 59.16889069200005],
              [18.41895592500009, 59.175116278000075],
              [18.429698113000086, 59.17462799700007],
              [18.43409264400009, 59.165228583000044],
              [18.43140709700009, 59.153509833000044],
              [18.424164259000065, 59.14394765800006],
              [18.414317254000082, 59.14004140800006],
              [18.403086785000085, 59.14533112200007],
              [18.381521030000044, 59.147772528000075],
              [18.343760613000086, 59.14175039300005],
              [18.30762780000009, 59.131293036000045],
              [18.290212436000047, 59.12055084800005],
              [18.301442905000044, 59.12221914300005],
              [18.311371290000068, 59.12099844000005],
              [18.31934655000009, 59.116441148000035],
              [18.324229363000086, 59.10809967700004],
              [18.230479363000086, 59.08429596600007],
              [18.20085696700005, 59.08075592700004],
              [18.21420332100007, 59.08665599200003],
              [18.24195397200009, 59.09544505400004],
              [18.255381707000083, 59.101263739000046],
              [18.241709832000083, 59.10809967700004],
              [18.248383009000065, 59.11163971600007],
              [18.255381707000083, 59.11432526200008],
              [18.255381707000083, 59.12055084800005],
              [18.238942905000044, 59.12148672100005],
              [18.22364342500009, 59.11953359600005],
              [18.209727410000085, 59.11408112200007],
              [18.197438998000052, 59.104681708000044],
              [18.18523196700005, 59.099310614000046],
              [18.151866082000083, 59.097357489000046],
              [18.138682488000086, 59.093817450000074],
              [18.12989342500009, 59.08706289300005],
              [18.108653191000087, 59.06305573100008],
              [18.09620201900009, 59.05833567900004],
              [18.043223504000082, 59.05971914300005],
              [18.045176629000082, 59.05483633000006],
              [18.04851321700005, 59.04319896000004],
              [18.05054772200009, 59.03856028900003],
              [18.025645379000082, 59.045355536000045],
              [18.013682488000086, 59.044907945000034],
              [18.002696160000085, 59.03856028900003],
              [18.01856530000009, 59.02289459800005],
              [18.00326582100007, 59.00600820500006],
              [17.977386915000068, 58.98655833500004],
              [17.961192254000082, 58.96344635600008],
              [17.962901238000086, 58.95172760600008],
              [17.968597852000073, 58.94407786700003],
              [17.970550977000073, 58.935980536000045],
              [17.961192254000082, 58.92251211100006],
              [17.94825280000009, 58.91474030200004],
              [17.93067467500009, 58.91006094000005],
              [17.912771030000044, 58.909857489000046],
              [17.899668816000087, 58.915716864000046],
              [17.89429772200009, 58.90338776200008],
              [17.89234459700009, 58.88979726800005],
              [17.892832879000082, 58.861029364000046],
              [17.87989342500009, 58.86749909100007],
              [17.869395379000082, 58.877020575000074],
              [17.865244988000086, 58.88882070500006],
              [17.871836785000085, 58.902044989000046],
              [17.864512566000087, 58.91498444200005],
              [17.861175977000073, 58.91909414300005],
              [17.851817254000082, 58.92479075700004],
              [17.844411655000044, 58.92462799700007],
              [17.837738477000073, 58.92255280200004],
              [17.830821160000085, 58.92251211100006],
              [17.814707879000082, 58.92820872600004],
              [17.80518639400009, 58.93390534100007],
              [17.78614342500009, 58.953558661000045],
              [17.773610873000052, 58.96067942900004],
              [17.775645379000082, 58.94721100500004],
              [17.787364129000082, 58.92552317900004],
              [17.803477410000085, 58.908270575000074],
              [17.79200280000009, 58.89085521000004],
              [17.786306186000047, 58.88422272300005],
              [17.779307488000086, 58.88153717700004],
              [17.77442467500009, 58.88621653900003],
              [17.775401238000086, 58.896918036000045],
              [17.779144727000073, 58.90843333500004],
              [17.78296959700009, 58.915716864000046],
              [17.749278191000087, 58.923814195000034],
              [17.746755405000044, 58.942613023000035],
              [17.751963738000086, 58.96507396000004],
              [17.741465691000087, 58.98395416900007],
              [17.741465691000087, 58.991400458000044],
              [17.755707227000073, 59.00633372600004],
              [17.76075280000009, 59.03701406500005],
              [17.76026451900009, 59.06720612200007],
              [17.758555535000085, 59.08075592700004],
              [17.756114129000082, 59.085191148000035],
              [17.769053582000083, 59.10895416900007],
              [17.768809441000087, 59.12055084800005],
              [17.758148634000065, 59.12592194200005],
              [17.74463951900009, 59.122748114000046],
              [17.732758009000065, 59.114447333000044],
              [17.727793816000087, 59.104681708000044],
              [17.72632897200009, 59.073553778000075],
              [17.72120201900009, 59.05898672100005],
              [17.710459832000083, 59.052801825000074],
              [17.701345248000052, 59.05727773600006],
              [17.66578209700009, 59.08075592700004],
              [17.668711785000085, 59.09544505400004],
              [17.68881269600007, 59.11798737200007],
              [17.693614129000082, 59.13141510600008],
              [17.68995201900009, 59.14280833500004],
              [17.680918816000087, 59.15338776200008],
              [17.66968834700009, 59.16229889500005],
              [17.658946160000085, 59.16889069200005],
              [17.673106316000087, 59.134751695000034],
              [17.66114342500009, 59.11961497600004],
              [17.64747155000009, 59.10805898600006],
              [17.631114129000082, 59.09955475500004],
              [17.61109459700009, 59.093817450000074],
              [17.62045332100007, 59.07257721600007],
              [17.61622155000009, 59.05117422100005],
              [17.614512566000087, 59.032131252000056],
              [17.631602410000085, 59.01813385600008],
              [17.621429884000065, 59.002386786000045],
              [17.61426842500009, 58.98069896000004],
              [17.60710696700005, 58.96596914300005],
              [17.597504102000073, 58.97089264500005],
              [17.58643639400009, 58.96499258000006],
              [17.586273634000065, 58.964911200000074],
              [17.58139082100007, 58.96112702000005],
              [17.576914910000085, 58.956691799000055],
              [17.584727410000085, 58.95099518400008],
              [17.592946811000047, 58.94684479400007],
              [17.601735873000052, 58.944240627000056],
              [17.61109459700009, 58.943019924000055],
              [17.61109459700009, 58.93618398600006],
              [17.60124759200005, 58.927801825000074],
              [17.61378014400009, 58.92401764500005],
              [17.62671959700009, 58.91779205900008],
              [17.617930535000085, 58.902044989000046],
              [17.59896894600007, 58.89411041900007],
              [17.578135613000086, 58.89557526200008],
              [17.556813998000052, 58.90033600500004],
              [17.535980665000068, 58.902044989000046],
              [17.545746290000068, 58.88963450700004],
              [17.559418165000068, 58.88035716400003],
              [17.590668165000068, 58.867254950000074],
              [17.590668165000068, 58.861029364000046],
              [17.569509311000047, 58.861029364000046],
              [17.576508009000065, 58.85651276200008],
              [17.58375084700009, 58.853583075000074],
              [17.55567467500009, 58.85415273600006],
              [17.48023522200009, 58.88613515800006],
              [17.447276238000086, 58.89520905200004],
              [17.447276238000086, 58.888373114000046],
              [17.465017123000052, 58.88149648600006],
              [17.469086134000065, 58.870428778000075],
              [17.460215691000087, 58.83999258000006],
              [17.451426629000082, 58.82339101800005],
              [17.449961785000085, 58.81586334800005],
              [17.457204623000052, 58.81264883000006],
              [17.464366082000083, 58.81102122600004],
              [17.488291863000086, 58.79962799700007],
              [17.459727410000085, 58.791449286000045],
              [17.337412957000083, 58.80646393400008],
              [17.37159264400009, 58.778998114000046],
              [17.376800977000073, 58.76439036700003],
              [17.357758009000065, 58.751166083000044],
              [17.30518639400009, 58.752386786000045],
              [17.276052280000044, 58.74884674700007],
              [17.276052280000044, 58.73069896000004],
              [17.162364129000082, 58.73200104400007],
              [17.13184655000009, 58.737534898000035],
              [17.12077884200005, 58.74408600500004],
              [17.100840691000087, 58.761379299000055],
              [17.08692467500009, 58.764837958000044],
              [17.075368686000047, 58.76268138200004],
              [17.046153191000087, 58.75332265800006],
              [17.028168165000068, 58.751166083000044],
              [17.041758660000085, 58.74701569200005],
              [17.073415561000047, 58.74477773600006],
              [17.083506707000083, 58.737534898000035],
              [17.08366946700005, 58.72870514500005],
              [17.077403191000087, 58.720363674000055],
              [17.069102410000085, 58.71381256700005],
              [17.062510613000086, 58.710191148000035],
              [17.08301842500009, 58.70286692900004],
              [17.125336134000065, 58.70579661700003],
              [17.145681186000047, 58.702785549000055],
              [17.145681186000047, 58.696600653000075],
              [17.122569207000083, 58.683294989000046],
              [17.10792076900009, 58.66966380400004],
              [17.093028191000087, 58.66083405200004],
              [17.069834832000083, 58.661810614000046],
              [17.010915561000047, 58.68183014500005],
              [16.974945509000065, 58.68537018400008],
              [16.953868035000085, 58.669256903000075],
              [17.00163821700005, 58.66787344000005],
              [17.019541863000086, 58.659857489000046],
              [17.035817905000044, 58.64130280200004],
              [17.012950066000087, 58.64142487200007],
              [16.924164259000065, 58.625433661000045],
              [16.578949415000068, 58.64734528200006],
              [16.23373457100007, 58.669256903000075],
              [16.23373457100007, 58.661810614000046],
              [16.246429884000065, 58.658636786000045],
              [16.257090691000087, 58.65176015800006],
              [16.26148522200009, 58.64305247600004],
              [16.25489342500009, 58.63450755400004],
              [16.23991946700005, 58.63226959800005],
              [16.19776451900009, 58.63739655200004],
              [16.179209832000083, 58.63450755400004],
              [16.179209832000083, 58.62832265800006],
              [16.191742384000065, 58.63190338700008],
              [16.203949415000068, 58.633978583000044],
              [16.214121941000087, 58.631293036000045],
              [16.22006269600007, 58.62083567900004],
              [16.240244988000086, 58.628119208000044],
              [16.285411004000082, 58.61591217700004],
              [16.306162957000083, 58.62457916900007],
              [16.320648634000065, 58.63617584800005],
              [16.333994988000086, 58.63914622600004],
              [16.346039259000065, 58.63580963700008],
              [16.367523634000065, 58.62173086100006],
              [16.37159264400009, 58.62055084800005],
              [16.37208092500009, 58.61713288000004],
              [16.37159264400009, 58.60374583500004],
              [16.376475457000083, 58.59516022300005],
              [16.38770592500009, 58.59162018400008],
              [16.400238477000073, 58.59235260600008],
              [16.40919030000009, 58.59662506700005],
              [16.416026238000086, 58.609076239000046],
              [16.421397332000083, 58.62490469000005],
              [16.428396030000044, 58.63939036700003],
              [16.439789259000065, 58.648138739000046],
              [16.453868035000085, 58.64598216400003],
              [16.504567905000044, 58.630926825000074],
              [16.517832879000082, 58.62457916900007],
              [16.635915561000047, 58.62677643400008],
              [16.657399936000047, 58.622300523000035],
              [16.676036004000082, 58.610581773000035],
              [16.689707879000082, 58.605454820000034],
              [16.730479363000086, 58.60228099200003],
              [16.748301629000082, 58.59292226800005],
              [16.746348504000082, 58.59784577000005],
              [16.74350019600007, 58.60911692900004],
              [16.74154707100007, 58.61399974200003],
              [16.776866082000083, 58.60765208500004],
              [16.789317254000082, 58.60716380400004],
              [16.779633009000065, 58.58869049700007],
              [16.785980665000068, 58.57273997600004],
              [16.804209832000083, 58.56207916900007],
              [16.830332879000082, 58.55939362200007],
              [16.821055535000085, 58.55353424700007],
              [16.816661004000082, 58.551947333000044],
              [16.816661004000082, 58.54637278900003],
              [16.844004754000082, 58.54637278900003],
              [16.844004754000082, 58.53888580900008],
              [16.834157748000052, 58.52952708500004],
              [16.84669030000009, 58.52435944200005],
              [16.884938998000052, 58.518459377000056],
              [16.940196160000085, 58.491115627000056],
              [16.916188998000052, 58.48346588700008],
              [16.865896030000044, 58.48305898600006],
              [16.844004754000082, 58.47748444200005],
              [16.85287519600007, 58.46308014500005],
              [16.830332879000082, 58.45209381700005],
              [16.796397332000083, 58.44513580900008],
              [16.77198326900009, 58.442694403000075],
              [16.765472852000073, 58.440659898000035],
              [16.75359134200005, 58.43146393400008],
              [16.748301629000082, 58.429022528000075],
              [16.740977410000085, 58.42963288000004],
              [16.72754967500009, 58.434881903000075],
              [16.72046959700009, 58.43650950700004],
              [16.597911004000082, 58.44863515800006],
              [16.539724155000044, 58.46816640800006],
              [16.441416863000086, 58.485988674000055],
              [16.41260826900009, 58.47748444200005],
              [16.44825280000009, 58.47479889500005],
              [16.65951582100007, 58.41478099200003],
              [16.692556186000047, 58.41274648600006],
              [16.70557701900009, 58.40770091400003],
              [16.714854363000086, 58.394964911000045],
              [16.715017123000052, 58.38572825700004],
              [16.71143639400009, 58.377386786000045],
              [16.709646030000044, 58.369126695000034],
              [16.714854363000086, 58.36017487200007],
              [16.723399285000085, 58.36074453300006],
              [16.738942905000044, 58.364935614000046],
              [16.752289259000065, 58.37006256700005],
              [16.754567905000044, 58.37376536700003],
              [16.76661217500009, 58.36859772300005],
              [16.77125084700009, 58.36310455900008],
              [16.77507571700005, 58.33966705900008],
              [16.631683790000068, 58.353949286000045],
              [16.64812259200005, 58.34324778900003],
              [16.684743686000047, 58.32786692900004],
              [16.699961785000085, 58.31915924700007],
              [16.69629967500009, 58.308579820000034],
              [16.698496941000087, 58.30170319200005],
              [16.710785352000073, 58.29873281500005],
              [16.721853061000047, 58.29987213700008],
              [16.72706139400009, 58.303615627000056],
              [16.726735873000052, 58.31000397300005],
              [16.72046959700009, 58.31915924700007],
              [16.779307488000086, 58.32558828300006],
              [16.799164259000065, 58.32363515800006],
              [16.789317254000082, 58.305568752000056],
              [16.783946160000085, 58.30414459800005],
              [16.76734459700009, 58.305975653000075],
              [16.76140384200005, 58.305568752000056],
              [16.760508660000085, 58.302435614000046],
              [16.760020379000082, 58.29633209800005],
              [16.758636915000068, 58.28974030200004],
              [16.754567905000044, 58.28510163000004],
              [16.743011915000068, 58.281317450000074],
              [16.70679772200009, 58.27826569200005],
              [16.70679772200009, 58.27138906500005],
              [16.72950280000009, 58.26850006700005],
              [16.802989129000082, 58.24469635600008],
              [16.793304884000065, 58.23883698100008],
              [16.789317254000082, 58.23725006700005],
              [16.802582227000073, 58.23102448100008],
              [16.813731316000087, 58.220404364000046],
              [16.82129967500009, 58.207098700000074],
              [16.824066602000073, 58.19285716400003],
              [16.822276238000086, 58.17963288000004],
              [16.817067905000044, 58.17719147300005],
              [16.80836022200009, 58.17987702000005],
              [16.796153191000087, 58.18203359600005],
              [16.788259311000047, 58.17926666900007],
              [16.79151451900009, 58.17291901200008],
              [16.80046634200005, 58.166083075000074],
              [16.809825066000087, 58.162095445000034],
              [16.777191602000073, 58.130519924000055],
              [16.721446160000085, 58.14984772300005],
              [16.66187584700009, 58.185532945000034],
              [16.617442254000082, 58.203111070000034],
              [16.632090691000087, 58.18573639500005],
              [16.671885613000086, 58.165269273000035],
              [16.686289910000085, 58.14789459800005],
              [16.679698113000086, 58.14826080900008],
              [16.666026238000086, 58.14740631700005],
              [16.65951582100007, 58.14789459800005],
              [16.681651238000086, 58.128241278000075],
              [16.716075066000087, 58.10415273600006],
              [16.73609459700009, 58.08478424700007],
              [16.714854363000086, 58.07957591400003],
              [16.717621290000068, 58.06679922100005],
              [16.71225019600007, 58.05951569200005],
              [16.701019727000073, 58.05695221600007],
              [16.686289910000085, 58.05853913000004],
              [16.707367384000065, 58.04987213700008],
              [16.724864129000082, 58.04584381700005],
              [16.740244988000086, 58.03978099200003],
              [16.754567905000044, 58.02496979400007],
              [16.746429884000065, 58.01658763200004],
              [16.737803582000083, 58.01422760600008],
              [16.728851759000065, 58.017279364000046],
              [16.72046959700009, 58.02496979400007],
              [16.691579623000052, 58.014837958000044],
              [16.686778191000087, 58.00873444200005],
              [16.699961785000085, 57.997707424000055],
              [16.67904707100007, 58.005113023000035],
              [16.65796959700009, 58.03534577000005],
              [16.644704623000052, 58.03864166900007],
              [16.631195509000065, 58.02789948100008],
              [16.63721764400009, 58.01447174700007],
              [16.65951582100007, 57.990220445000034],
              [16.67164147200009, 57.99176666900007],
              [16.686289910000085, 57.990220445000034],
              [16.68685957100007, 57.98924388200004],
              [16.697601759000065, 57.97064850500004],
              [16.70639082100007, 57.962103583000044],
              [16.717621290000068, 57.96662018400008],
              [16.727793816000087, 57.97406647300005],
              [16.73536217500009, 57.971909898000035],
              [16.74000084700009, 57.962103583000044],
              [16.74154707100007, 57.946193752000056],
              [16.747243686000047, 57.94041575700004],
              [16.77393639400009, 57.92340729400007],
              [16.782481316000087, 57.91510651200008],
              [16.76539147200009, 57.915228583000044],
              [16.727305535000085, 57.92877838700008],
              [16.736175977000073, 57.913763739000046],
              [16.76539147200009, 57.89883047100005],
              [16.768809441000087, 57.88784414300005],
              [16.758148634000065, 57.877020575000074],
              [16.741058790000068, 57.87718333500004],
              [16.723399285000085, 57.88349030200004],
              [16.710785352000073, 57.89126211100006],
              [16.69117272200009, 57.91620514500005],
              [16.682871941000087, 57.91889069200005],
              [16.67945397200009, 57.89838288000004],
              [16.670746290000068, 57.89142487200007],
              [16.650563998000052, 57.89085521000004],
              [16.610606316000087, 57.89468008000006],
              [16.61378014400009, 57.903509833000044],
              [16.61378014400009, 57.912095445000034],
              [16.61036217500009, 57.92055898600006],
              [16.603770379000082, 57.92877838700008],
              [16.61500084700009, 57.92959219000005],
              [16.625661655000044, 57.92837148600006],
              [16.635590040000068, 57.925482489000046],
              [16.644704623000052, 57.92133209800005],
              [16.51531009200005, 57.99884674700007],
              [16.505869988000086, 57.99823639500005],
              [16.498301629000082, 57.99298737200007],
              [16.494476759000065, 57.984035549000055],
              [16.497243686000047, 57.97719961100006],
              [16.504567905000044, 57.97016022300005],
              [16.532074415000068, 57.95026276200008],
              [16.590098504000082, 57.935614325000074],
              [16.584808790000068, 57.93260325700004],
              [16.574880405000044, 57.92438385600008],
              [16.569590691000087, 57.92133209800005],
              [16.576019727000073, 57.91128164300005],
              [16.576996290000068, 57.90192291900007],
              [16.572520379000082, 57.89394765800006],
              [16.562754754000082, 57.88784414300005],
              [16.544118686000047, 57.89891185100004],
              [16.524587436000047, 57.906317450000074],
              [16.480804884000065, 57.91510651200008],
              [16.494476759000065, 57.90208567900004],
              [16.487071160000085, 57.89468008000006],
              [16.48015384200005, 57.89826080900008],
              [16.46029707100007, 57.90208567900004],
              [16.46029707100007, 57.89468008000006],
              [16.67546634200005, 57.76447174700007],
              [16.70679772200009, 57.75063711100006],
              [16.699961785000085, 57.743841864000046],
              [16.68295332100007, 57.747300523000035],
              [16.635101759000065, 57.765692450000074],
              [16.621104363000086, 57.77423737200007],
              [16.541840040000068, 57.83901601800005],
              [16.419444207000083, 57.89468008000006],
              [16.427582227000073, 57.87689850500004],
              [16.438975457000083, 57.86538320500006],
              [16.473399285000085, 57.846869208000044],
              [16.530039910000085, 57.82526276200008],
              [16.57325280000009, 57.795355536000045],
              [16.580902540000068, 57.78693268400008],
              [16.586761915000068, 57.77887604400007],
              [16.594493035000085, 57.77289459800005],
              [16.60718834700009, 57.77049388200004],
              [16.61817467500009, 57.76658763200004],
              [16.652679884000065, 57.74632396000004],
              [16.665212436000047, 57.73700592700004],
              [16.65211022200009, 57.72955963700008],
              [16.673024936000047, 57.729722398000035],
              [16.69076582100007, 57.72565338700008],
              [16.70484459700009, 57.716782945000034],
              [16.714854363000086, 57.702826239000046],
              [16.69312584700009, 57.702826239000046],
              [16.69312584700009, 57.69599030200004],
              [16.70679772200009, 57.69599030200004],
              [16.70679772200009, 57.68854401200008],
              [16.63917076900009, 57.69232819200005],
              [16.608897332000083, 57.69871653900003],
              [16.576996290000068, 57.70966217700004],
              [16.583994988000086, 57.700384833000044],
              [16.60254967500009, 57.68903229400007],
              [16.610606316000087, 57.68235911700003],
              [16.619965040000068, 57.66665273600006],
              [16.61768639400009, 57.658270575000074],
              [16.60482832100007, 57.65680573100008],
              [16.583262566000087, 57.66193268400008],
              [16.591807488000086, 57.651678778000075],
              [16.60328209700009, 57.64911530200004],
              [16.615082227000073, 57.64789459800005],
              [16.624847852000073, 57.64142487200007],
              [16.63054446700005, 57.62909577000005],
              [16.626149936000047, 57.62457916900007],
              [16.61654707100007, 57.622381903000075],
              [16.60718834700009, 57.617173570000034],
              [16.597829623000052, 57.61029694200005],
              [16.56999759200005, 57.595689195000034],
              [16.562754754000082, 57.592962958000044],
              [16.55713951900009, 57.596869208000044],
              [16.554942254000082, 57.60618724200003],
              [16.554942254000082, 57.61737702000005],
              [16.555918816000087, 57.62714264500005],
              [16.547618035000085, 57.62221914300005],
              [16.53882897200009, 57.62067291900007],
              [16.52979576900009, 57.622381903000075],
              [16.52051842500009, 57.62714264500005],
              [16.530528191000087, 57.61546458500004],
              [16.535329623000052, 57.61147695500006],
              [16.542246941000087, 57.60732656500005],
              [16.527354363000086, 57.59544505400004],
              [16.52051842500009, 57.592962958000044],
              [16.52051842500009, 57.58612702000005],
              [16.542246941000087, 57.579291083000044],
              [16.542246941000087, 57.57249583500004],
              [16.51498457100007, 57.57249583500004],
              [16.51498457100007, 57.56631094000005],
              [16.592458530000044, 57.56484609600005],
              [16.629161004000082, 57.55687083500004],
              [16.65756269600007, 57.51552969000005],
              [16.680349155000044, 57.48965078300006],
              [16.688975457000083, 57.47174713700008],
              [16.65951582100007, 57.476263739000046],
              [16.672211134000065, 57.45966217700004],
              [16.666758660000085, 57.45526764500005],
              [16.652191602000073, 57.45453522300005],
              [16.63843834700009, 57.44896067900004],
              [16.63331139400009, 57.43707916900007],
              [16.639008009000065, 57.42670319200005],
              [16.653005405000044, 57.41901276200008],
              [16.672618035000085, 57.41547272300005],
              [16.65601647200009, 57.40924713700008],
              [16.63721764400009, 57.40619538000004],
              [16.625743035000085, 57.39899323100008],
              [16.631683790000068, 57.38076406500005],
              [16.572601759000065, 57.38743724200003],
              [16.547618035000085, 57.382513739000046],
              [16.53484134200005, 57.360256252000056],
              [16.569590691000087, 57.346584377000056],
              [16.56023196700005, 57.33738841400003],
              [16.549571160000085, 57.33315664300005],
              [16.54737389400009, 57.32880280200004],
              [16.562754754000082, 57.31928131700005],
              [16.485199415000068, 57.294623114000046],
              [16.469086134000065, 57.275376695000034],
              [16.494476759000065, 57.24290599200003],
              [16.465993686000047, 57.22801341400003],
              [16.458181186000047, 57.204006252000056],
              [16.465017123000052, 57.17731354400007],
              [16.480804884000065, 57.15477122600004],
              [16.50945071700005, 57.12734609600005],
              [16.52051842500009, 57.12006256700005],
              [16.53101647200009, 57.11692942900004],
              [16.537282748000052, 57.11823151200008],
              [16.543142123000052, 57.11798737200007],
              [16.55250084700009, 57.11009349200003],
              [16.569590691000087, 57.08649323100008],
              [16.55445397200009, 57.08075592700004],
              [16.560557488000086, 57.06928131700005],
              [16.574473504000082, 57.05609772300005],
              [16.583262566000087, 57.044907945000034],
              [16.570485873000052, 57.04433828300006],
              [16.53484134200005, 57.05174388200004],
              [16.533376498000052, 57.05442942900004],
              [16.535004102000073, 57.05906810100004],
              [16.53484134200005, 57.06346263200004],
              [16.527679884000065, 57.06537506700005],
              [16.52125084700009, 57.06439850500004],
              [16.517832879000082, 57.06207916900007],
              [16.51612389400009, 57.059759833000044],
              [16.51498457100007, 57.058579820000034],
              [16.51075280000009, 57.055975653000075],
              [16.508555535000085, 57.05101146000004],
              [16.50684655000009, 57.04559967700004],
              [16.50440514400009, 57.04148997600004],
              [16.500336134000065, 57.03974030200004],
              [16.496836785000085, 57.041449286000045],
              [16.49268639400009, 57.04389069200005],
              [16.47632897200009, 57.04584381700005],
              [16.452403191000087, 57.05141836100006],
              [16.439789259000065, 57.05174388200004],
              [16.447520379000082, 57.04437897300005],
              [16.455332879000082, 57.038397528000075],
              [16.464040561000047, 57.03400299700007],
              [16.473399285000085, 57.031236070000034],
              [16.473399285000085, 57.02383047100005],
              [16.453135613000086, 57.023504950000074],
              [16.439789259000065, 57.014105536000045],
              [16.43490644600007, 56.99787018400008],
              [16.439789259000065, 56.976629950000074],
              [16.44971764400009, 56.964504299000055],
              [16.46143639400009, 56.95661041900007],
              [16.46810957100007, 56.949286200000074],
              [16.46338951900009, 56.93846263200004],
              [16.436371290000068, 56.91111888200004],
              [16.436289910000085, 56.90477122600004],
              [16.43995201900009, 56.877834377000056],
              [16.439789259000065, 56.866848049000055],
              [16.436289910000085, 56.85687897300005],
              [16.408946160000085, 56.80841705900008],
              [16.40796959700009, 56.79913971600007],
              [16.416026238000086, 56.787990627000056],
              [16.428558790000068, 56.78294505400004],
              [16.44076582100007, 56.78705475500004],
              [16.452403191000087, 56.794134833000044],
              [16.46338951900009, 56.79783763200004],
              [16.472504102000073, 56.79437897300005],
              [16.474457227000073, 56.786322333000044],
              [16.47169030000009, 56.777411200000074],
              [16.46656334700009, 56.771185614000046],
              [16.45484459700009, 56.76829661700003],
              [16.427582227000073, 56.77558014500005],
              [16.41260826900009, 56.777411200000074],
              [16.396820509000065, 56.77480703300006],
              [16.376231316000087, 56.765692450000074],
              [16.36109459700009, 56.763739325000074],
              [16.356618686000047, 56.75844961100006],
              [16.36304772200009, 56.74648672100005],
              [16.377777540000068, 56.725897528000075],
              [16.38062584700009, 56.693793036000045],
              [16.379161004000082, 56.67560455900008],
              [16.37159264400009, 56.661322333000044],
              [16.358653191000087, 56.65444570500006],
              [16.34156334700009, 56.651271877000056],
              [16.324961785000085, 56.65216705900008],
              [16.301117384000065, 56.663275458000044],
              [16.288259311000047, 56.661322333000044],
              [16.275645379000082, 56.65656159100007],
              [16.264903191000087, 56.65387604400007],
              [16.25521894600007, 56.650376695000034],
              [16.246348504000082, 56.64240143400008],
              [16.22364342500009, 56.61420319200005],
              [16.220957879000082, 56.608710028000075],
              [16.22120201900009, 56.60374583500004],
              [16.22006269600007, 56.593003648000035],
              [16.215505405000044, 56.57172272300005],
              [16.213226759000065, 56.54840729400007],
              [16.207041863000086, 56.53851959800005],
              [16.17872155000009, 56.53705475500004],
              [16.17237389400009, 56.52728913000004],
              [16.166026238000086, 56.50800202000005],
              [16.11768639400009, 56.45526764500005],
              [16.095225457000083, 56.41937897300005],
              [16.066254102000073, 56.33596426000008],
              [16.038259311000047, 56.255072333000044],
              [16.031504754000082, 56.24982330900008],
              [16.020355665000068, 56.24640534100007],
              [16.014496290000068, 56.238267320000034],
              [16.010427280000044, 56.22825755400004],
              [16.00440514400009, 56.21942780200004],
              [15.987803582000083, 56.20774974200003],
              [15.94898522200009, 56.18744538000004],
              [15.932139519000089, 56.174709377000056],
              [15.87435957100007, 56.102728583000044],
              [15.851735873000052, 56.086371161000045],
              [15.835134311000047, 56.087958075000074],
              [15.816742384000065, 56.09784577000005],
              [15.78874759200005, 56.10643138200004],
              [15.818695509000065, 56.14004140800006],
              [15.826508009000065, 56.159369208000044],
              [15.806162957000083, 56.16791413000004],
              [15.756683790000068, 56.15672435100004],
              [15.731211785000085, 56.15721263200004],
              [15.713633660000085, 56.174709377000056],
              [15.70248457100007, 56.17023346600007],
              [15.696787957000083, 56.173163153000075],
              [15.691742384000065, 56.178615627000056],
              [15.682383660000085, 56.18154531500005],
              [15.670176629000082, 56.18353913000004],
              [15.655772332000083, 56.192572333000044],
              [15.64820397200009, 56.194566148000035],
              [15.631521030000044, 56.18573639500005],
              [15.611827019000089, 56.169256903000075],
              [15.592133009000065, 56.16054922100005],
              [15.57593834700009, 56.174709377000056],
              [15.582855665000068, 56.18081289300005],
              [15.592295769000089, 56.19245026200008],
              [15.596202019000089, 56.20376211100006],
              [15.586436394000089, 56.20888906500005],
              [15.572764519000089, 56.206284898000035],
              [15.53492272200009, 56.188381252000056],
              [15.492930535000085, 56.17633698100008],
              [15.486582879000082, 56.17133209800005],
              [15.484873894000089, 56.15566640800006],
              [15.479991082000083, 56.15184153900003],
              [15.459808790000068, 56.16107819200005],
              [15.452321811000047, 56.16596100500004],
              [15.444021030000044, 56.17283763200004],
              [15.43327884200005, 56.178900458000044],
              [15.418223504000082, 56.18154531500005],
              [15.40398196700005, 56.179754950000074],
              [15.393402540000068, 56.175116278000075],
              [15.37671959700009, 56.16107819200005],
              [15.370371941000087, 56.15143463700008],
              [15.370127800000091, 56.14492422100005],
              [15.365570509000065, 56.14109935100004],
              [15.320974155000044, 56.13963450700004],
              [15.307302280000044, 56.14175039300005],
              [15.295258009000065, 56.14740631700005],
              [15.314707879000082, 56.15338776200008],
              [15.322601759000065, 56.153631903000075],
              [15.316742384000065, 56.163275458000044],
              [15.295258009000065, 56.188381252000056],
              [15.273773634000065, 56.171210028000075],
              [15.234548373000052, 56.15721263200004],
              [15.192393425000091, 56.15289948100008],
              [15.16187584700009, 56.164496161000045],
              [15.154307488000086, 56.16864655200004],
              [15.146332227000073, 56.16693756700005],
              [15.138682488000086, 56.16315338700008],
              [15.130869988000086, 56.16107819200005],
              [15.093028191000087, 56.16107819200005],
              [15.085215691000087, 56.16461823100008],
              [15.08171634200005, 56.182074286000045],
              [15.07553144600007, 56.188381252000056],
              [15.068695509000065, 56.18773021000004],
              [15.04428144600007, 56.18227773600006],
              [15.034678582000083, 56.18154531500005],
              [15.038259311000047, 56.175441799000055],
              [15.045258009000065, 56.15961334800005],
              [15.049001498000052, 56.153631903000075],
              [14.988454623000052, 56.169175523000035],
              [14.953379754000082, 56.17291901200008],
              [14.928233269000089, 56.164496161000045],
              [14.90601647200009, 56.16120026200008],
              [14.873220248000052, 56.16474030200004],
              [14.848155144000089, 56.16396719000005],
              [14.849619988000086, 56.14740631700005],
              [14.830251498000052, 56.142645575000074],
              [14.813324415000068, 56.150091864000046],
              [14.795746290000068, 56.16128164300005],
              [14.774587436000047, 56.16791413000004],
              [14.724945509000065, 56.167629299000055],
              [14.701345248000052, 56.161363023000035],
              [14.685801629000082, 56.14740631700005],
              [14.68295332100007, 56.13906484600005],
              [14.68100019600007, 56.12742747600004],
              [14.682302280000044, 56.11713288000004],
              [14.688975457000083, 56.112616278000075],
              [14.703379754000082, 56.109442450000074],
              [14.71029707100007, 56.10187409100007],
              [14.71452884200005, 56.092678127000056],
              [14.719981316000087, 56.08466217700004],
              [14.748301629000082, 56.06073639500005],
              [14.757985873000052, 56.048488674000055],
              [14.767751498000052, 56.03070709800005],
              [14.756358269000089, 56.027411200000074],
              [14.74382571700005, 56.02142975500004],
              [14.73218834700009, 56.014105536000045],
              [14.723399285000085, 56.00653717700004],
              [14.715505405000044, 56.00234609600005],
              [14.710459832000083, 56.00657786700003],
              [14.705739780000044, 56.01703522300005],
              [14.685801629000082, 56.01703522300005],
              [14.67904707100007, 56.00926341400003],
              [14.673024936000047, 56.00531647300005],
              [14.664724155000044, 56.00653717700004],
              [14.657399936000047, 56.00926341400003],
              [14.64975019600007, 56.01032135600008],
              [14.621836785000085, 56.01015859600005],
              [14.611501498000052, 56.01113515800006],
              [14.609711134000065, 56.015326239000046],
              [14.623789910000085, 56.02448151200008],
              [14.615244988000086, 56.030178127000056],
              [14.607676629000082, 56.03701406500005],
              [14.603037957000083, 56.04596588700008],
              [14.60328209700009, 56.05805084800005],
              [14.582204623000052, 56.04376862200007],
              [14.571299675000091, 56.050848700000074],
              [14.566742384000065, 56.05560944200005],
              [14.569102410000085, 56.05805084800005],
              [14.556651238000086, 56.05536530200004],
              [14.533457879000082, 56.04584381700005],
              [14.524424675000091, 56.04376862200007],
              [14.49740644600007, 56.04047272300005],
              [14.478851759000065, 56.031683661000045],
              [14.445567254000082, 56.00275299700007],
              [14.407725457000083, 55.97703685100004],
              [14.385590040000068, 55.96625397300005],
              [14.366465691000087, 55.96185944200005],
              [14.346446160000085, 55.95331452000005],
              [14.33334394600007, 55.93451569200005],
              [14.323252800000091, 55.915716864000046],
              [14.311534050000091, 55.90717194200005],
              [14.271006707000083, 55.89447663000004],
              [14.234711134000065, 55.86269765800006],
              [14.208506707000083, 55.82127513200004],
              [14.198496941000087, 55.77997467700004],
              [14.194183790000068, 55.741888739000046],
              [14.195811394000089, 55.72565338700008],
              [14.205902540000068, 55.70856354400007],
              [14.222504102000073, 55.69684479400007],
              [14.26107832100007, 55.68016185100004],
              [14.273692254000082, 55.667629299000055],
              [14.275889519000089, 55.65680573100008],
              [14.27507571700005, 55.646144924000055],
              [14.276052280000044, 55.63499583500004],
              [14.28451582100007, 55.62295156500005],
              [14.294769727000073, 55.61517975500004],
              [14.316661004000082, 55.60236237200007],
              [14.358164910000085, 55.563666083000044],
              [14.367523634000065, 55.54539622600004],
              [14.36304772200009, 55.52362702000005],
              [14.348806186000047, 55.51056549700007],
              [14.29468834700009, 55.47553131700005],
              [14.27711022200009, 55.468410549000055],
              [14.264903191000087, 55.46124909100007],
              [14.219004754000082, 55.413763739000046],
              [14.199717644000089, 55.39899323100008],
              [14.181162957000083, 55.39081452000005],
              [14.158376498000052, 55.38719310100004],
              [14.094086134000065, 55.38739655200004],
              [14.06421959700009, 55.39077383000006],
              [14.035411004000082, 55.39712148600006],
              [13.956228061000047, 55.42682526200008],
              [13.930023634000065, 55.43276601800005],
              [13.897227410000085, 55.434881903000075],
              [13.882334832000083, 55.43305084800005],
              [13.85678144600007, 55.42438385600008],
              [13.842295769000089, 55.421210028000075],
              [13.828135613000086, 55.42133209800005],
              [13.780284050000091, 55.427435614000046],
              [13.647308790000068, 55.421210028000075],
              [13.629567905000044, 55.41828034100007],
              [13.618174675000091, 55.41095612200007],
              [13.608653191000087, 55.40180084800005],
              [13.595957879000082, 55.39325592700004],
              [13.580821160000085, 55.38882070500006],
              [13.537852410000085, 55.39325592700004],
              [13.503428582000083, 55.388373114000046],
              [13.410899285000085, 55.35228099200003],
              [13.381358269000089, 55.34601471600007],
              [13.312510613000086, 55.342678127000056],
              [13.280528191000087, 55.34544505400004],
              [13.115489129000082, 55.38027578300006],
              [13.061534050000091, 55.38125234600005],
              [13.041758660000085, 55.38544342700004],
              [13.030772332000083, 55.386419989000046],
              [13.024912957000083, 55.38825104400007],
              [13.008636915000068, 55.396918036000045],
              [13.000010613000086, 55.400091864000046],
              [12.979177280000044, 55.40326569200005],
              [12.95834394600007, 55.400091864000046],
              [12.947276238000086, 55.39622630400004],
              [12.932627800000091, 55.388006903000075],
              [12.920909050000091, 55.386419989000046],
              [12.910411004000082, 55.38751862200007],
              [12.897146030000044, 55.39215729400007],
              [12.886729363000086, 55.39325592700004],
              [12.867198113000086, 55.38886139500005],
              [12.84742272200009, 55.382025458000044],
              [12.832774285000085, 55.38255442900004],
              [12.828786655000044, 55.400091864000046],
              [12.859385613000086, 55.434881903000075],
              [12.866221550000091, 55.43500397300005],
              [12.871836785000085, 55.43439362200007],
              [12.877940300000091, 55.43138255400004],
              [12.886729363000086, 55.42430247600004],
              [12.904633009000065, 55.417954820000034],
              [12.929698113000086, 55.41876862200007],
              [12.95289147200009, 55.424994208000044],
              [12.965830925000091, 55.434881903000075],
              [12.959971550000091, 55.44790273600006],
              [12.963226759000065, 55.45425039300005],
              [12.972911004000082, 55.45416901200008],
              [12.98568769600007, 55.44790273600006],
              [12.975840691000087, 55.475043036000045],
              [12.928477410000085, 55.52000560100004],
              [12.917491082000083, 55.54718659100007],
              [12.92937259200005, 55.57892487200007],
              [12.95834394600007, 55.59813060100004],
              [13.027354363000086, 55.626654364000046],
              [13.038340691000087, 55.635199286000045],
              [13.049489780000044, 55.64712148600006],
              [13.05795332100007, 55.66071198100008],
              [13.061371290000068, 55.67446523600006],
              [13.054860873000052, 55.69403717700004],
              [13.040537957000083, 55.70538971600007],
              [13.026377800000091, 55.71238841400003],
              [13.01148522200009, 55.72842031500005],
              [12.992930535000085, 55.725775458000044],
              [12.97437584700009, 55.72646719000005],
              [12.965830925000091, 55.746161200000074],
              [12.94117272200009, 55.745347398000035],
              [12.922618035000085, 55.74945709800005],
              [12.911306186000047, 55.76386139500005],
              [12.923838738000086, 55.765285549000055],
              [12.931895379000082, 55.76947663000004],
              [12.936534050000091, 55.777411200000074],
              [12.938649936000047, 55.79047272300005],
              [12.926036004000082, 55.834051825000074],
              [12.891286655000044, 55.853583075000074],
              [12.850759311000047, 55.865668036000045],
              [12.821299675000091, 55.886704820000034],
              [12.810801629000082, 55.90224844000005],
              [12.80836022200009, 55.910142320000034],
              [12.807627800000091, 55.92462799700007],
              [12.804942254000082, 55.92926666900007],
              [12.79851321700005, 55.934800523000035],
              [12.790537957000083, 55.93939850500004],
              [12.783702019000089, 55.94135163000004],
              [12.770762566000087, 55.948431708000044],
              [12.764659050000091, 55.96478913000004],
              [12.760020379000082, 55.98322174700007],
              [12.752289259000065, 55.99656810100004],
              [12.734873894000089, 56.00617096600007],
              [12.719493035000085, 56.012152411000045],
              [12.70875084700009, 56.02130768400008],
              [12.704600457000083, 56.040676174000055],
              [12.698008660000085, 56.05149974200003],
              [12.609548373000052, 56.116522528000075],
              [12.602224155000044, 56.12319570500006],
              [12.564626498000052, 56.17169830900008],
              [12.553721550000091, 56.18154531500005],
              [12.54460696700005, 56.21320221600007],
              [12.54078209700009, 56.22247955900008],
              [12.516449415000068, 56.25218333500004],
              [12.504567905000044, 56.27533600500004],
              [12.464854363000086, 56.29169342700004],
              [12.451426629000082, 56.30442942900004],
              [12.64625084700009, 56.25726959800005],
              [12.65365644600007, 56.253973700000074],
              [12.666188998000052, 56.239447333000044],
              [12.673838738000086, 56.23615143400008],
              [12.681651238000086, 56.234035549000055],
              [12.69662519600007, 56.224595445000034],
              [12.70484459700009, 56.22247955900008],
              [12.713389519000089, 56.22357819200005],
              [12.727386915000068, 56.228216864000046],
              [12.735606316000087, 56.22931549700007],
              [12.777598504000082, 56.22650788000004],
              [12.796885613000086, 56.22809479400007],
              [12.814463738000086, 56.23615143400008],
              [12.827403191000087, 56.24994538000004],
              [12.833506707000083, 56.265692450000074],
              [12.82943769600007, 56.278550523000035],
              [12.783457879000082, 56.293402411000045],
              [12.762950066000087, 56.31537506700005],
              [12.73178144600007, 56.35968659100007],
              [12.643809441000087, 56.39606354400007],
              [12.621592644000089, 56.41933828300006],
              [12.656911655000044, 56.45526764500005],
              [12.713715040000068, 56.46735260600008],
              [12.833262566000087, 56.442572333000044],
              [12.890147332000083, 56.45526764500005],
              [12.904470248000052, 56.46702708500004],
              [12.920420769000089, 56.48529694200005],
              [12.93336022200009, 56.50653717700004],
              [12.938649936000047, 56.52728913000004],
              [12.934418165000068, 56.54706452000005],
              [12.903819207000083, 56.593003648000035],
              [12.88607832100007, 56.637152411000045],
              [12.871755405000044, 56.64948151200008],
              [12.842051629000082, 56.65387604400007],
              [12.81804446700005, 56.65253327000005],
              [12.778168165000068, 56.644232489000046],
              [12.762380405000044, 56.64329661700003],
              [12.746836785000085, 56.644232489000046],
              [12.73178144600007, 56.64704010600008],
              [12.679860873000052, 56.67959219000005],
              [12.670420769000089, 56.69208405200004],
              [12.664317254000082, 56.71430084800005],
              [12.649261915000068, 56.72516510600008],
              [12.631358269000089, 56.734035549000055],
              [12.615733269000089, 56.750067450000074],
              [12.594737175000091, 56.787990627000056],
              [12.600352410000085, 56.809881903000075],
              [12.598317905000044, 56.82099030200004],
              [12.533864780000044, 56.84634023600006],
              [12.529551629000082, 56.849676825000074],
              [12.528819207000083, 56.853583075000074],
              [12.528819207000083, 56.85732656500005],
              [12.52702884200005, 56.85993073100008],
              [12.520518425000091, 56.86200592700004],
              [12.504242384000065, 56.86473216400003],
              [12.499196811000047, 56.866848049000055],
              [12.479991082000083, 56.886379299000055],
              [12.469574415000068, 56.89203522300005],
              [12.437347852000073, 56.896185614000046],
              [12.41187584700009, 56.905585028000075],
              [12.375010613000086, 56.91205475500004],
              [12.356455925000091, 56.923814195000034],
              [12.345225457000083, 56.94135163000004],
              [12.342133009000065, 56.962958075000074],
              [12.344248894000089, 56.96792226800005],
              [12.353037957000083, 56.97675202000005],
              [12.35515384200005, 56.979722398000035],
              [12.354258660000085, 56.985663153000075],
              [12.349864129000082, 56.995428778000075],
              [12.348887566000087, 57.00055573100008],
              [12.346853061000047, 57.006293036000045],
              [12.340993686000047, 57.01406484600005],
              [12.333262566000087, 57.02090078300006],
              [12.301768425000091, 57.02924225500004],
              [12.27125084700009, 57.04287344000005],
              [12.24740644600007, 57.06073639500005],
              [12.245290561000047, 57.07904694200005],
              [12.23796634200005, 57.081366278000075],
              [12.218597852000073, 57.09271881700005],
              [12.23764082100007, 57.10805898600006],
              [12.233409050000091, 57.12148672100005],
              [12.204356316000087, 57.14793528900003],
              [12.201019727000073, 57.15570709800005],
              [12.197927280000044, 57.175767320000034],
              [12.197438998000052, 57.184881903000075],
              [12.191416863000086, 57.18528880400004],
              [12.160980665000068, 57.18414948100008],
              [12.149099155000044, 57.18829987200007],
              [12.180511915000068, 57.20416901200008],
              [12.191254102000073, 57.212591864000046],
              [12.180674675000091, 57.21625397300005],
              [12.157725457000083, 57.216864325000074],
              [12.13835696700005, 57.21967194200005],
              [12.120371941000087, 57.225897528000075],
              [12.10132897200009, 57.23672109600005],
              [12.129242384000065, 57.23672109600005],
              [12.142914259000065, 57.238714911000045],
              [12.156504754000082, 57.24290599200003],
              [12.142425977000073, 57.24795156500005],
              [12.127289259000065, 57.250067450000074],
              [12.09506269600007, 57.25039297100005],
              [12.09506269600007, 57.257147528000075],
              [12.105479363000086, 57.263006903000075],
              [12.112315300000091, 57.26976146000004],
              [12.119883660000085, 57.27533600500004],
              [12.142588738000086, 57.27997467700004],
              [12.147227410000085, 57.28546784100007],
              [12.147227410000085, 57.292222398000035],
              [12.142832879000082, 57.298163153000075],
              [12.144053582000083, 57.31012604400007],
              [12.136973504000082, 57.319525458000044],
              [12.125743035000085, 57.32680898600006],
              [12.11500084700009, 57.33234284100007],
              [12.112478061000047, 57.335191148000035],
              [12.109385613000086, 57.34003327000005],
              [12.104991082000083, 57.34454987200007],
              [12.098155144000089, 57.346584377000056],
              [12.089854363000086, 57.34516022300005],
              [12.07390384200005, 57.339829820000034],
              [12.067149285000085, 57.33978913000004],
              [12.049815300000091, 57.35114166900007],
              [12.063731316000087, 57.36359284100007],
              [12.089854363000086, 57.37787506700005],
              [12.10873457100007, 57.39435455900008],
              [12.06031334700009, 57.39435455900008],
              [12.082692905000044, 57.40228913000004],
              [12.092051629000082, 57.411363023000035],
              [12.089854363000086, 57.423041083000044],
              [12.059255405000044, 57.45880768400008],
              [12.053477410000085, 57.46263255400004],
              [12.043630405000044, 57.461818752000056],
              [12.036631707000083, 57.45697663000004],
              [12.030121290000068, 57.45156484600005],
              [12.022715691000087, 57.44896067900004],
              [12.006602410000085, 57.43414948100008],
              [11.992930535000085, 57.36603424700007],
              [11.979014519000089, 57.346584377000056],
              [11.972178582000083, 57.36408112200007],
              [11.949961785000085, 57.36082591400003],
              [11.933604363000086, 57.36082591400003],
              [11.944834832000083, 57.387600002000056],
              [11.933604363000086, 57.38690827000005],
              [11.922699415000068, 57.38739655200004],
              [11.912608269000089, 57.38971588700008],
              [11.903330925000091, 57.39435455900008],
              [11.915212436000047, 57.40338776200008],
              [11.91374759200005, 57.41665273600006],
              [11.906993035000085, 57.43244049700007],
              [11.903330925000091, 57.44896067900004],
              [11.907074415000068, 57.465277411000045],
              [11.916351759000065, 57.476263739000046],
              [11.929698113000086, 57.48383209800005],
              [11.944834832000083, 57.489935614000046],
              [11.927744988000086, 57.49795156500005],
              [11.910166863000086, 57.503607489000046],
              [11.916758660000085, 57.50470612200007],
              [11.931162957000083, 57.511053778000075],
              [11.910166863000086, 57.521470445000034],
              [11.903330925000091, 57.52411530200004],
              [11.91765384200005, 57.53953685100004],
              [11.91146894600007, 57.59528229400007],
              [11.916840040000068, 57.62091705900008],
              [11.912852410000085, 57.62295156500005],
              [11.901866082000083, 57.62636953300006],
              [11.897146030000044, 57.62714264500005],
              [11.891856316000087, 57.612982489000046],
              [11.879649285000085, 57.60618724200003],
              [11.867360873000052, 57.607407945000034],
              [11.861582879000082, 57.617173570000034],
              [11.858083530000044, 57.63263580900008],
              [11.849619988000086, 57.64325592700004],
              [11.840586785000085, 57.652004299000055],
              [11.834971550000091, 57.66193268400008],
              [11.844574415000068, 57.68301015800006],
              [11.90951582100007, 57.686835028000075],
              [11.923675977000073, 57.702826239000046],
              [11.90211022200009, 57.69623444200005],
              [11.87435957100007, 57.69326406500005],
              [11.845876498000052, 57.69330475500004],
              [11.821299675000091, 57.69599030200004],
              [11.770518425000091, 57.712225653000075],
              [11.74773196700005, 57.71360911700003],
              [11.751800977000073, 57.69599030200004],
              [11.73804772200009, 57.69326406500005],
              [11.719737175000091, 57.69350820500006],
              [11.705414259000065, 57.698431708000044],
              [11.703949415000068, 57.70966217700004],
              [11.706309441000087, 57.721991278000075],
              [11.801524285000085, 57.77423737200007],
              [11.810394727000073, 57.78139883000006],
              [11.807871941000087, 57.78807200700004],
              [11.789398634000065, 57.790269273000035],
              [11.766856316000087, 57.78880442900004],
              [11.751800977000073, 57.784816799000055],
              [11.727305535000085, 57.80304596600007],
              [11.707855665000068, 57.823146877000056],
              [11.686778191000087, 57.83763255400004],
              [11.656260613000086, 57.83942291900007],
              [11.678396030000044, 57.85374583500004],
              [11.69076582100007, 57.858587958000044],
              [11.703949415000068, 57.86050039300005],
              [11.693614129000082, 57.88117096600007],
              [11.707286004000082, 57.89142487200007],
              [11.759287957000083, 57.90208567900004],
              [11.759287957000083, 57.908270575000074],
              [11.745616082000083, 57.908270575000074],
              [11.745616082000083, 57.91510651200008],
              [11.755381707000083, 57.91714101800005],
              [11.75945071700005, 57.91901276200008],
              [11.766123894000089, 57.92877838700008],
              [11.736582879000082, 57.938666083000044],
              [11.743662957000083, 57.95571523600006],
              [11.787282748000052, 57.997707424000055],
              [11.80014082100007, 58.02228424700007],
              [11.802907748000052, 58.03656647300005],
              [11.797129754000082, 58.048895575000074],
              [11.787771030000044, 58.05898672100005],
              [11.78296959700009, 58.06915924700007],
              [11.786306186000047, 58.07859935100004],
              [11.800954623000052, 58.08641185100004],
              [11.797699415000068, 58.090277411000045],
              [11.796153191000087, 58.09332916900007],
              [11.793467644000089, 58.10008372600004],
              [11.81812584700009, 58.103176174000055],
              [11.828461134000065, 58.12124258000006],
              [11.837412957000083, 58.187160549000055],
              [11.841319207000083, 58.193793036000045],
              [11.852061394000089, 58.19627513200004],
              [11.865407748000052, 58.19672272300005],
              [11.875743035000085, 58.19916413000004],
              [11.883799675000091, 58.20526764500005],
              [11.889659050000091, 58.216782945000034],
              [11.873708530000044, 58.21539948100008],
              [11.860606316000087, 58.218410549000055],
              [11.851817254000082, 58.226629950000074],
              [11.844574415000068, 58.25336334800005],
              [11.834808790000068, 58.261704820000034],
              [11.823415561000047, 58.26898834800005],
              [11.81381269600007, 58.27826569200005],
              [11.808929884000065, 58.30219147300005],
              [11.82593834700009, 58.31655508000006],
              [11.882823113000086, 58.33283112200007],
              [11.870371941000087, 58.345363674000055],
              [11.849457227000073, 58.342678127000056],
              [11.806976759000065, 58.326605536000045],
              [11.751800977000073, 58.329779364000046],
              [11.726735873000052, 58.32709381700005],
              [11.725759311000047, 58.31297435100004],
              [11.711436394000089, 58.30756256700005],
              [11.678965691000087, 58.30744049700007],
              [11.62867272200009, 58.28148021000004],
              [11.61890709700009, 58.27826569200005],
              [11.612803582000083, 58.27435944200005],
              [11.590993686000047, 58.25633372600004],
              [11.581065300000091, 58.25092194200005],
              [11.567067905000044, 58.249212958000044],
              [11.552012566000087, 58.25031159100007],
              [11.537771030000044, 58.25348541900007],
              [11.525889519000089, 58.25775788000004],
              [11.530446811000047, 58.25275299700007],
              [11.539561394000089, 58.23725006700005],
              [11.505869988000086, 58.243068752000056],
              [11.496592644000089, 58.25836823100008],
              [11.50367272200009, 58.28021881700005],
              [11.519053582000083, 58.305568752000056],
              [11.541758660000085, 58.33356354400007],
              [11.567393425000091, 58.35504791900007],
              [11.622080925000091, 58.38812897300005],
              [11.607758009000065, 58.394964911000045],
              [11.621755405000044, 58.40599192900004],
              [11.636973504000082, 58.41356028900003],
              [11.669932488000086, 58.42218659100007],
              [11.652598504000082, 58.43740469000005],
              [11.628916863000086, 58.431341864000046],
              [11.605316602000073, 58.41547272300005],
              [11.588633660000085, 58.40110911700003],
              [11.578379754000082, 58.414129950000074],
              [11.559255405000044, 58.44830963700008],
              [11.553233269000089, 58.46320221600007],
              [11.547048373000052, 58.46320221600007],
              [11.553477410000085, 58.43398672100005],
              [11.551768425000091, 58.39935944200005],
              [11.541677280000044, 58.364935614000046],
              [11.522471550000091, 58.33624909100007],
              [11.494965040000068, 58.312486070000034],
              [11.465993686000047, 58.294134833000044],
              [11.39616946700005, 58.26459381700005],
              [11.405121290000068, 58.27920156500005],
              [11.416188998000052, 58.290350653000075],
              [11.428965691000087, 58.29897695500006],
              [11.443369988000086, 58.305568752000056],
              [11.443369988000086, 58.31297435100004],
              [11.428070509000065, 58.311835028000075],
              [11.399180535000085, 58.30296458500004],
              [11.389333530000044, 58.305568752000056],
              [11.383799675000091, 58.31818268400008],
              [11.389496290000068, 58.32908763200004],
              [11.401052280000044, 58.336818752000056],
              [11.413259311000047, 58.33966705900008],
              [11.44857832100007, 58.34174225500004],
              [11.441254102000073, 58.34906647300005],
              [11.422862175000091, 58.36383698100008],
              [11.424082879000082, 58.38812897300005],
              [11.406993035000085, 58.38735586100006],
              [11.397715691000087, 58.37885163000004],
              [11.391123894000089, 58.366441148000035],
              [11.38249759200005, 58.353949286000045],
              [11.370616082000083, 58.34747955900008],
              [11.355316602000073, 58.34389883000006],
              [11.345876498000052, 58.34601471600007],
              [11.351410352000073, 58.357082424000055],
              [11.385915561000047, 58.39801666900007],
              [11.407237175000091, 58.41836172100005],
              [11.41570071700005, 58.428900458000044],
              [11.424082879000082, 58.442694403000075],
              [11.415212436000047, 58.43195221600007],
              [11.37240644600007, 58.39988841400003],
              [11.355967644000089, 58.39272695500006],
              [11.348399285000085, 58.38812897300005],
              [11.34506269600007, 58.38385651200008],
              [11.33765709700009, 58.37189362200007],
              [11.334157748000052, 58.367621161000045],
              [11.306813998000052, 58.36005280200004],
              [11.279144727000073, 58.36615631700005],
              [11.25359134200005, 58.36591217700004],
              [11.231700066000087, 58.33966705900008],
              [11.220876498000052, 58.34625885600008],
              [11.219574415000068, 58.352728583000044],
              [11.222666863000086, 58.36041901200008],
              [11.224864129000082, 58.37067291900007],
              [11.221690300000091, 58.37958405200004],
              [11.204356316000087, 58.40110911700003],
              [11.208994988000086, 58.41893138200004],
              [11.223399285000085, 58.42487213700008],
              [11.259043816000087, 58.42218659100007],
              [11.251475457000083, 58.44232819200005],
              [11.261241082000083, 58.45221588700008],
              [11.278575066000087, 58.459051825000074],
              [11.293711785000085, 58.470038153000075],
              [11.257660352000073, 58.48216380400004],
              [11.252207879000082, 58.48737213700008],
              [11.250010613000086, 58.49323151200008],
              [11.240733269000089, 58.50218333500004],
              [11.238536004000082, 58.507879950000074],
              [11.240733269000089, 58.51251862200007],
              [11.245371941000087, 58.51630280200004],
              [11.250010613000086, 58.51850006700005],
              [11.252207879000082, 58.518459377000056],
              [11.252940300000091, 58.54824453300006],
              [11.25562584700009, 58.55573151200008],
              [11.26498457100007, 58.56289297100005],
              [11.273285352000073, 58.56622955900008],
              [11.280528191000087, 58.570298570000034],
              [11.286306186000047, 58.57990143400008],
              [11.265798373000052, 58.57990143400008],
              [11.269786004000082, 58.592230536000045],
              [11.264821811000047, 58.59674713700008],
              [11.257009311000047, 58.599676825000074],
              [11.252207879000082, 58.60716380400004],
              [11.252777540000068, 58.61603424700007],
              [11.259043816000087, 58.62579987200007],
              [11.259043816000087, 58.63450755400004],
              [11.249847852000073, 58.64891185100004],
              [11.21062259200005, 58.67918528900003],
              [11.214121941000087, 58.698919989000046],
              [11.218028191000087, 58.70795319200005],
              [11.212412957000083, 58.71035390800006],
              [11.18685957100007, 58.710191148000035],
              [11.17741946700005, 58.71857330900008],
              [11.178558790000068, 58.73647695500006],
              [11.189789259000065, 58.75299713700008],
              [11.21062259200005, 58.75739166900007],
              [11.206879102000073, 58.77094147300005],
              [11.21265709700009, 58.77944570500006],
              [11.222666863000086, 58.787543036000045],
              [11.231700066000087, 58.79962799700007],
              [11.233409050000091, 58.80817291900007],
              [11.231700066000087, 58.84369538000004],
              [11.22632897200009, 58.848944403000075],
              [11.21461022200009, 58.851263739000046],
              [11.20289147200009, 58.85492584800005],
              [11.197601759000065, 58.864162502000056],
              [11.197601759000065, 58.887884833000044],
              [11.195567254000082, 58.89838288000004],
              [11.190114780000044, 58.908270575000074],
              [11.193207227000073, 58.912176825000074],
              [11.19499759200005, 58.915228583000044],
              [11.197601759000065, 58.92251211100006],
              [11.146739129000082, 58.93121979400007],
              [11.119883660000085, 58.94086334800005],
              [11.108164910000085, 58.953558661000045],
              [11.117442254000082, 58.968817450000074],
              [11.138926629000082, 58.97833893400008],
              [11.183848504000082, 58.991400458000044],
              [11.141774936000047, 58.989569403000075],
              [11.12281334700009, 58.99408600500004],
              [11.11500084700009, 59.00820547100005],
              [11.119395379000082, 59.020819403000075],
              [11.129405144000089, 59.03119538000004],
              [11.193614129000082, 59.080145575000074],
              [11.22006269600007, 59.09015534100007],
              [11.320974155000044, 59.09951406500005],
              [11.354665561000047, 59.09162018400008],
              [11.36890709700009, 59.06305573100008],
              [11.376231316000087, 59.04169342700004],
              [11.393809441000087, 59.01943594000005],
              [11.414073113000086, 59.00112539300005],
              [11.429698113000086, 58.991400458000044],
              [11.437510613000086, 58.991400458000044],
              [11.437510613000086, 58.99172597900008],
              [11.43814375800008, 58.991129049000065],
              [11.453233276000077, 58.960484925000046],
              [11.45199304200014, 58.89604441400003],
              [11.482585490000048, 58.88689768500005],
              [11.547077678000079, 58.88472727500006],
              [11.611569865000092, 58.89315053300005],
              [11.66438317900014, 58.92007395500006],
              [11.693735392000121, 58.973507385000076],
              [11.700246623000083, 58.99913889600005],
              [11.708928263000047, 59.021618144000044],
              [11.734249715000118, 59.06554311100008],
              [11.745308472000147, 59.09215647400002],
              [11.748512411000121, 59.140060527000045],
              [11.775590861000069, 59.20253733300011],
              [11.784685913000146, 59.218143616000035],
              [11.802462605000073, 59.234421692000055],
              [11.811088078000097, 59.24871671700005],
              [11.81166101100007, 59.24966624000011],
              [11.81166101100007, 59.270905253000066],
              [11.806803426000045, 59.293591207000034],
              [11.783962443000036, 59.36061554000007],
              [11.677405640000103, 59.55905304000008],
              [11.670997762000042, 59.580550436000024],
              [11.674925171000012, 59.60711212200003],
              [11.693735392000121, 59.62230499300007],
              [11.828404175000117, 59.65971873000002],
              [11.852485392000062, 59.673361308000025],
              [11.891656128000108, 59.70576243200004],
              [11.89723718300013, 59.713978984000065],
              [11.89723718300013, 59.732014059000065],
              [11.903541707000045, 59.7699962360001],
              [11.902094767000051, 59.78513743100011],
              [11.889795776000085, 59.801415507000016],
              [11.883741546000095, 59.80538299800013],
              [11.85486250800011, 59.82430816700004],
              [11.842976929000088, 59.83841583300007],
              [11.849591512000075, 59.87241892500002],
              [11.874627299000053, 59.88493681900006],
              [11.890312540000139, 59.89277944000004],
              [11.942195678000132, 59.902029521000074],
              [12.102702677000138, 59.893967998000065],
              [12.143733764000103, 59.89841217000007],
              [12.290598185000107, 59.958718567000076],
              [12.446764364000046, 60.05111602800007],
              [12.483247925000057, 60.08124338800006],
              [12.510946492000073, 60.11798533200003],
              [12.52469242300009, 60.1617035930001],
              [12.521591838000063, 60.19761871300007],
              [12.495650268000105, 60.262007549000074],
              [12.487278686000138, 60.295907288000066],
              [12.491722860000039, 60.312288717000044],
              [12.504745321000087, 60.32562123600006],
              [12.5585921630001, 60.359882711000054],
              [12.577919148000149, 60.37590240500002],
              [12.593628784000117, 60.395022685000114],
              [12.6053076580001, 60.419155579000076],
              [12.612645711000113, 60.455380758],
              [12.608614950000117, 60.48648997000005],
              [12.594352254000029, 60.51493784600008],
              [12.482524454000043, 60.65733225600009],
              [12.377001180000065, 60.75409637500006],
              [12.350026082000056, 60.793344626000035],
              [12.335039917000074, 60.828898011],
              [12.313232463000134, 60.901865133000015],
              [12.294835653000064, 60.935325623000026],
              [12.256078329000019, 60.981317648000115],
              [12.253287801000056, 61.001704],
              [12.28098636900009, 61.01519154900002],
              [12.511773316000102, 61.04911712700003],
              [12.569650920000129, 61.05064158100005],
              [12.68251224700009, 61.04033213400005],
              [12.70380293800008, 61.046197409000044],
              [12.71082559800007, 61.05701155800007],
              [12.713518107000112, 61.061157735],
              [12.73294844600008, 61.12911224400007],
              [12.739149617000066, 61.142444763000086],
              [12.746694376000022, 61.15146230100005],
              [12.819661499000063, 61.20494740800008],
              [12.839815308000112, 61.22698740600005],
              [12.85469812000008, 61.255306092000055],
              [12.888184448000061, 61.349615581000066],
              [12.886944214000039, 61.36150116],
              [12.877125692000078, 61.37098378600008],
              [12.61378259200012, 61.54704539000004],
              [12.58339685000007, 61.56110138000004],
              [12.550944051000045, 61.566914978000014],
              [12.482524454000043, 61.56913706500002],
              [12.444800659000094, 61.57350372400002],
              [12.416481975000096, 61.582288717],
              [12.337830444000133, 61.63298329700008],
              [12.291321655000104, 61.651121724000106],
              [12.175566447000051, 61.7115314740001],
              [12.161717163000077, 61.72483815500003],
              [12.239593546000037, 61.97943501800002],
              [12.317469929000112, 62.23403188100009],
              [12.31514930500012, 62.271760746],
              [12.314265991000127, 62.28612172500003],
              [12.28636071800014, 62.33542104100003],
              [12.279521921000054, 62.34421403900005],
              [12.091230509000127, 62.58631012000011],
              [12.090093628000119, 62.60633473700004],
              [12.103116089000054, 62.634033305000074],
              [12.13866947400004, 62.682712505],
              [12.154069051000107, 62.710514425000056],
              [12.156239461000098, 62.73369130500005],
              [12.097018270000092, 62.88655019100007],
              [12.093297567000093, 62.90742747100005],
              [12.104356323000104, 62.923343811000066],
              [12.222695353000063, 63.001478577000015],
              [12.059826572000105, 63.20477215000001],
              [11.992425171000093, 63.2889028930001],
              [12.204918660000118, 63.45462921200003],
              [12.219801472000057, 63.474266256000064],
              [12.219491414000089, 63.49659047500002],
              [12.170295450000111, 63.59813466500002],
              [12.293182006000109, 63.656994121000096],
              [12.482524454000043, 63.809491273000035],
              [12.681892131000012, 63.95635569300005],
              [12.755272665000064, 63.991392314000066],
              [12.982442261000074, 64.05883005800008],
              [13.234106486000144, 64.0908694460001],
              [13.586772298000085, 64.05020009400006],
              [13.939438110000111, 64.009530742],
              [13.964242798000043, 64.009530742],
              [13.98232954900007, 64.01950429300011],
              [14.147797485000098, 64.16900421200002],
              [14.160509887000075, 64.18724599200009],
              [14.161440063000015, 64.20543609600013],
              [14.115551391000054, 64.441235657],
              [14.096947876000087, 64.46531687400004],
              [14.060877726000086, 64.4766340130001],
              [13.98232954900007, 64.48438547900012],
              [13.940058228000083, 64.49131012],
              [13.642763713000079, 64.5840176390001],
              [13.90757959000004, 64.78770029750008],
              [14.172395467000086, 64.99138295600007],
              [14.172602172000069, 64.99153798400003],
              [14.310681600000066, 65.08414215100008],
              [14.332073666000099, 65.11396380500007],
              [14.332849860000096, 65.11504586000008],
              [14.338483520000125, 65.12289947500001],
              [14.365975383000091, 65.21576202500005],
              [14.380238078000076, 65.2402824920001],
              [14.400495239000065, 65.25544952500003],
              [14.48214400200007, 65.28867747100004],
              [14.514286743000099, 65.31808136000005],
              [14.518317505000084, 65.36453847200006],
              [14.511392862000093, 65.41706756700005],
              [14.510359335000118, 65.46473907500008],
              [14.560692179000085, 65.7010554000001],
              [14.570200643000078, 65.71671335900005],
              [14.637069947000043, 65.78120554700008],
              [14.648852172000147, 65.80239288400013],
              [14.644408, 65.84290720700004],
              [14.54053837100011, 66.1254481000001],
              [14.796956828000106, 66.13936197950012],
              [15.053375285000072, 66.15327585900006],
              [15.481876261000082, 66.27487050400002],
              [15.491798136000085, 66.28799631800008],
              [15.48993778500008, 66.30848602300004],
              [15.482082967000053, 66.34080963200002],
              [15.476076322000097, 66.3549371430001],
              [15.429889770000074, 66.46356699700009],
              [15.426272420000089, 66.49121388800008],
              [15.669461711000054, 66.59942433700009],
              [16.03884484800011, 66.88754628599999],
              [16.125661255000097, 66.9343651330001],
              [16.310559529000045, 67.00991607700003],
              [16.3696773690001, 67.02428212500003],
              [16.399649698000047, 67.03596099900001],
              [16.415566040000073, 67.05270416300006],
              [16.443781372000046, 67.18261871400004],
              [16.43789025900014, 67.20031789200006],
              [16.12710819500009, 67.4227590950001],
              [16.180748332000093, 67.4963980100001],
              [16.199558553000088, 67.50828359000003],
              [16.366990193000078, 67.52166778600007],
              [16.428588501000036, 67.53401845400002],
              [16.482952107000102, 67.55784128900008],
              [16.58723514800002, 67.62589915000008],
              [16.608732544000077, 67.64729319300001],
              [16.76190148900008, 67.87714996400005],
              [16.782882121000085, 67.89699371400006],
              [16.8079968670001, 67.91063629200006],
              [17.220064738000076, 68.04008575500002],
              [17.29995650200007, 68.09791168200003],
              [17.3214538980001, 68.10530141200006],
              [17.608413126500125, 68.03747609500012],
              [17.895372355000063, 67.96965077800009],
              [17.921003865000017, 67.97285471700006],
              [17.950769491000102, 67.99109649700002],
              [17.981878703000064, 68.01615956700003],
              [18.166673625000072, 68.15847646200008],
              [18.188584432000113, 68.19873240200003],
              [18.13566776500005, 68.39572296200005],
              [18.136804647000048, 68.42631541000007],
              [18.15623498500014, 68.51860951800005],
              [18.16150598200008, 68.53018503800008],
              [18.171841268000065, 68.53592112300005],
              [18.189291148000052, 68.53842468300006],
              [18.436217895000112, 68.57385162400006],
              [18.481796509000077, 68.56196604400002],
              [18.644577270000127, 68.50124623600003],
              [18.70028446400005, 68.495613505],
              [19.038144979000066, 68.50563873300003],
              [19.48173547300007, 68.42404164700004],
              [19.931010376000046, 68.35019602500007],
              [19.971214640000085, 68.35128123000008],
              [20.010282023000087, 68.36389027900002],
              [20.245926554000107, 68.47737172400004],
              [19.96222294100005, 68.54119211900009],
              [20.151772095000126, 68.60682118700002],
              [20.236624796000086, 68.65906606100002],
              [20.338840779000066, 68.76546783500002],
              [20.35217329900007, 68.78567332000001],
              [20.35651412000007, 68.80458689400005],
              [20.34876265400007, 68.893108623],
              [20.34111454300009, 68.91005849300011],
              [20.102266073000095, 69.02214467400005],
              [20.36271529150011, 69.02925018350014],
              [20.62316451, 69.03635569300012],
            ],
          ],
          [
            [
              [17.124522332000083, 57.31928131700005],
              [17.09701582100007, 57.31736888200004],
              [17.07553144600007, 57.305121161000045],
              [17.04200280000009, 57.27090078300006],
              [17.064463738000086, 57.241888739000046],
              [17.066254102000073, 57.22671133000006],
              [17.05046634200005, 57.201157945000034],
              [17.050791863000086, 57.19232819200005],
              [17.049489780000044, 57.18829987200007],
              [17.045664910000085, 57.18667226800005],
              [17.031993035000085, 57.18317291900007],
              [17.028168165000068, 57.18146393400008],
              [17.023285352000073, 57.17218659100007],
              [17.01921634200005, 57.15717194200005],
              [17.01531009200005, 57.14793528900003],
              [16.973480665000068, 57.10419342700004],
              [16.967458530000044, 57.08958567900004],
              [16.96062259200005, 57.06321849200003],
              [16.943207227000073, 57.05182526200008],
              [16.92090905000009, 57.04637278900003],
              [16.898610873000052, 57.03807200700004],
              [16.90479576900009, 57.02944570500006],
              [16.912852410000085, 57.023504950000074],
              [16.92286217500009, 57.01972077000005],
              [16.933929884000065, 57.017564195000034],
              [16.914073113000086, 57.00739166900007],
              [16.899180535000085, 56.99640534100007],
              [16.871267123000052, 56.969183661000045],
              [16.878428582000083, 56.956366278000075],
              [16.88453209700009, 56.935614325000074],
              [16.883067254000082, 56.91624583500004],
              [16.867849155000044, 56.90770091400003],
              [16.858164910000085, 56.89679596600007],
              [16.841807488000086, 56.84406159100007],
              [16.830332879000082, 56.825832424000055],
              [16.82781009200005, 56.82566966400003],
              [16.781586134000065, 56.810614325000074],
              [16.77507571700005, 56.80536530200004],
              [16.768728061000047, 56.79677969000005],
              [16.764414910000085, 56.78742096600007],
              [16.762054884000065, 56.77765534100007],
              [16.76140384200005, 56.76752350500004],
              [16.756521030000044, 56.74746328300006],
              [16.698496941000087, 56.64520905200004],
              [16.689707879000082, 56.625433661000045],
              [16.686289910000085, 56.60236237200007],
              [16.682790561000047, 56.59349192900004],
              [16.67432701900009, 56.58344147300005],
              [16.664235873000052, 56.57534414300005],
              [16.65593509200005, 56.571966864000046],
              [16.643239780000044, 56.568426825000074],
              [16.636973504000082, 56.55971914300005],
              [16.631683790000068, 56.53782786700003],
              [16.631521030000044, 56.53221263200004],
              [16.637950066000087, 56.52920156500005],
              [16.63843834700009, 56.52415599200003],
              [16.63575280000009, 56.519191799000055],
              [16.627126498000052, 56.50853099200003],
              [16.624847852000073, 56.50364817900004],
              [16.62281334700009, 56.48651764500005],
              [16.61963951900009, 56.47532786700003],
              [16.614024285000085, 56.46580638200004],
              [16.59929446700005, 56.44741445500006],
              [16.586110873000052, 56.426662502000056],
              [16.57585696700005, 56.40574778900003],
              [16.569590691000087, 56.38703034100007],
              [16.568532748000052, 56.37905508000006],
              [16.569590691000087, 56.35626862200007],
              [16.566416863000086, 56.346136786000045],
              [16.552256707000083, 56.332098700000074],
              [16.549082879000082, 56.32217031500005],
              [16.541188998000052, 56.30613841400003],
              [16.490896030000044, 56.239569403000075],
              [16.472666863000086, 56.22724030200004],
              [16.45020592500009, 56.21865469000005],
              [16.428477410000085, 56.217962958000044],
              [16.41260826900009, 56.22931549700007],
              [16.410492384000065, 56.238267320000034],
              [16.412771030000044, 56.26117584800005],
              [16.41260826900009, 56.27094147300005],
              [16.39893639400009, 56.29824453300006],
              [16.40723717500009, 56.319973049000055],
              [16.408376498000052, 56.344631252000056],
              [16.405772332000083, 56.38703034100007],
              [16.414073113000086, 56.402777411000045],
              [16.40796959700009, 56.42059967700004],
              [16.397227410000085, 56.43960195500006],
              [16.391449415000068, 56.458685614000046],
              [16.39893639400009, 56.54466380400004],
              [16.40211022200009, 56.554388739000046],
              [16.419444207000083, 56.585638739000046],
              [16.442556186000047, 56.608710028000075],
              [16.446055535000085, 56.61664459800005],
              [16.45281009200005, 56.63751862200007],
              [16.62086022200009, 56.872259833000044],
              [16.637868686000047, 56.882473049000055],
              [16.659027540000068, 56.88654205900008],
              [16.689707879000082, 56.88727448100008],
              [16.716807488000086, 56.891831773000035],
              [16.731293165000068, 56.903998114000046],
              [16.748301629000082, 56.94188060100004],
              [16.793630405000044, 57.00385163000004],
              [16.845550977000073, 57.05906810100004],
              [16.88835696700005, 57.11823151200008],
              [16.90601647200009, 57.19204336100006],
              [16.90992272200009, 57.20221588700008],
              [16.91928144600007, 57.20722077000005],
              [16.94044030000009, 57.21283600500004],
              [16.953868035000085, 57.22211334800005],
              [16.959239129000082, 57.23069896000004],
              [16.962087436000047, 57.28733958500004],
              [16.96648196700005, 57.30459219000005],
              [16.988536004000082, 57.317572333000044],
              [17.01921634200005, 57.34454987200007],
              [17.035817905000044, 57.352769273000035],
              [17.054860873000052, 57.35822174700007],
              [17.065277540000068, 57.35773346600007],
              [17.073496941000087, 57.34320709800005],
              [17.081879102000073, 57.34137604400007],
              [17.091075066000087, 57.34446849200003],
              [17.097178582000083, 57.352769273000035],
              [17.10401451900009, 57.352769273000035],
              [17.104258660000085, 57.34829336100006],
              [17.106130405000044, 57.34560781500005],
              [17.108571811000047, 57.34320709800005],
              [17.110850457000083, 57.33978913000004],
              [17.11573326900009, 57.33535390800006],
              [17.119802280000044, 57.330511786000045],
              [17.12281334700009, 57.32518138200004],
              [17.124522332000083, 57.31928131700005],
            ],
          ],
          [
            [
              [19.040212436000047, 57.86790599200003],
              [19.050303582000083, 57.862209377000056],
              [19.078786655000044, 57.83478424700007],
              [19.085215691000087, 57.82575104400007],
              [19.01498457100007, 57.82200755400004],
              [18.986582879000082, 57.80744049700007],
              [18.981618686000047, 57.77049388200004],
              [18.970225457000083, 57.77960846600007],
              [18.957774285000085, 57.78461334800005],
              [18.948741082000083, 57.78266022300005],
              [18.947520379000082, 57.77049388200004],
              [18.938243035000085, 57.76264069200005],
              [18.93213951900009, 57.75226471600007],
              [18.93213951900009, 57.74079010600008],
              [18.941254102000073, 57.72955963700008],
              [18.901215040000068, 57.723944403000075],
              [18.865244988000086, 57.72333405200004],
              [18.852793816000087, 57.725490627000056],
              [18.831879102000073, 57.73484935100004],
              [18.82081139400009, 57.73700592700004],
              [18.80713951900009, 57.734442450000074],
              [18.805918816000087, 57.727850653000075],
              [18.809418165000068, 57.71906159100007],
              [18.81031334700009, 57.70966217700004],
              [18.79664147200009, 57.67552317900004],
              [18.779144727000073, 57.65106842700004],
              [18.77393639400009, 57.64081452000005],
              [18.76929772200009, 57.634833075000074],
              [18.76465905000009, 57.62689850500004],
              [18.762461785000085, 57.617173570000034],
              [18.76889082100007, 57.614488023000035],
              [18.81031334700009, 57.60732656500005],
              [18.801036004000082, 57.591782945000034],
              [18.79468834700009, 57.57807038000004],
              [18.790863477000073, 57.564154364000046],
              [18.789805535000085, 57.54828522300005],
              [18.781993035000085, 57.53497955900008],
              [18.767832879000082, 57.520738023000035],
              [18.76140384200005, 57.50763580900008],
              [18.776133660000085, 57.49746328300006],
              [18.768809441000087, 57.48183828300006],
              [18.77320397200009, 57.47223541900007],
              [18.785899285000085, 57.46820709800005],
              [18.803477410000085, 57.46942780200004],
              [18.798350457000083, 57.46434153900003],
              [18.789805535000085, 57.44896067900004],
              [18.828786655000044, 57.44000885600008],
              [18.86890709700009, 57.43528880400004],
              [18.87281334700009, 57.438666083000044],
              [18.87468509200005, 57.44513580900008],
              [18.879730665000068, 57.449204820000034],
              [18.892832879000082, 57.44562409100007],
              [18.908864780000044, 57.439154364000046],
              [18.91382897200009, 57.43593984600005],
              [18.920176629000082, 57.42853424700007],
              [18.926117384000065, 57.41819896000004],
              [18.930023634000065, 57.40452708500004],
              [18.92628014400009, 57.392645575000074],
              [18.90992272200009, 57.387600002000056],
              [18.879161004000082, 57.387600002000056],
              [18.875336134000065, 57.38857656500005],
              [18.864024285000085, 57.39337799700007],
              [18.858164910000085, 57.39435455900008],
              [18.85328209700009, 57.392238674000055],
              [18.84115644600007, 57.382879950000074],
              [18.83448326900009, 57.38076406500005],
              [18.801524285000085, 57.376206773000035],
              [18.770192905000044, 57.364488023000035],
              [18.74154707100007, 57.34788646000004],
              [18.717946811000047, 57.32892487200007],
              [18.680430535000085, 57.31049225500004],
              [18.666758660000085, 57.29677969000005],
              [18.673675977000073, 57.27765534100007],
              [18.68140709700009, 57.275376695000034],
              [18.70248457100007, 57.27765534100007],
              [18.710948113000086, 57.274318752000056],
              [18.714121941000087, 57.24290599200003],
              [18.678884311000047, 57.23334381700005],
              [18.680511915000068, 57.22992584800005],
              [18.59148196700005, 57.21869538000004],
              [18.564463738000086, 57.209418036000045],
              [18.564463738000086, 57.20197174700007],
              [18.578135613000086, 57.20197174700007],
              [18.578135613000086, 57.195746161000045],
              [18.555430535000085, 57.19245026200008],
              [18.431162957000083, 57.154282945000034],
              [18.406423373000052, 57.143011786000045],
              [18.38575280000009, 57.12742747600004],
              [18.454600457000083, 57.12742747600004],
              [18.431162957000083, 57.11692942900004],
              [18.35987389400009, 57.096136786000045],
              [18.34473717500009, 57.08274974200003],
              [18.337901238000086, 57.031236070000034],
              [18.34864342500009, 57.01850006700005],
              [18.36426842500009, 57.011419989000046],
              [18.40007571700005, 57.003973700000074],
              [18.34473717500009, 57.003973700000074],
              [18.34473717500009, 56.99713776200008],
              [18.35840905000009, 56.98969147300005],
              [18.332367384000065, 56.97711823100008],
              [18.321462436000047, 56.96906159100007],
              [18.31153405000009, 56.94806549700007],
              [18.29851321700005, 56.94159577000005],
              [18.203949415000068, 56.91518789300005],
              [18.16968834700009, 56.91201406500005],
              [18.138682488000086, 56.92202383000006],
              [18.203868035000085, 56.98627350500004],
              [18.20639082100007, 56.99469635600008],
              [18.20484459700009, 57.00458405200004],
              [18.20085696700005, 57.017564195000034],
              [18.21387780000009, 57.02631256700005],
              [18.250824415000068, 57.03388092700004],
              [18.265635613000086, 57.04148997600004],
              [18.273692254000082, 57.05410390800006],
              [18.281993035000085, 57.08104075700004],
              [18.290212436000047, 57.09271881700005],
              [18.266368035000085, 57.08437734600005],
              [18.24463951900009, 57.07013580900008],
              [18.223317905000044, 57.06028880400004],
              [18.20085696700005, 57.06537506700005],
              [18.20085696700005, 57.07282135600008],
              [18.214121941000087, 57.08152903900003],
              [18.22510826900009, 57.094916083000044],
              [18.227305535000085, 57.107489325000074],
              [18.214366082000083, 57.11383698100008],
              [18.21851647200009, 57.11904531500005],
              [18.223806186000047, 57.128607489000046],
              [18.228037957000083, 57.133693752000056],
              [18.18531334700009, 57.14484284100007],
              [18.15984134200005, 57.229803778000075],
              [18.09937584700009, 57.258978583000044],
              [18.101084832000083, 57.27802155200004],
              [18.115570509000065, 57.29702383000006],
              [18.153086785000085, 57.31342194200005],
              [18.165863477000073, 57.33161041900007],
              [18.171153191000087, 57.35211823100008],
              [18.166026238000086, 57.36709219000005],
              [18.179209832000083, 57.37954336100006],
              [18.176605665000068, 57.38556549700007],
              [18.167246941000087, 57.38922760600008],
              [18.15919030000009, 57.39435455900008],
              [18.15593509200005, 57.39862702000005],
              [18.14616946700005, 57.40802643400008],
              [18.14429772200009, 57.413397528000075],
              [18.145355665000068, 57.42617422100005],
              [18.14234459700009, 57.43195221600007],
              [18.131602410000085, 57.445298570000034],
              [18.120941602000073, 57.46507396000004],
              [18.113454623000052, 57.487982489000046],
              [18.111989780000044, 57.511053778000075],
              [18.128184441000087, 57.548163153000075],
              [18.16146894600007, 57.57794830900008],
              [18.325043165000068, 57.67259349200003],
              [18.463063998000052, 57.803168036000045],
              [18.49935957100007, 57.82656484600005],
              [18.55014082100007, 57.83942291900007],
              [18.56413821700005, 57.83779531500005],
              [18.57943769600007, 57.83344147300005],
              [18.594899936000047, 57.831366278000075],
              [18.608653191000087, 57.83633047100005],
              [18.61500084700009, 57.84357330900008],
              [18.620371941000087, 57.85809967700004],
              [18.62598717500009, 57.86790599200003],
              [18.640798373000052, 57.88617584800005],
              [18.65796959700009, 57.90184153900003],
              [18.677744988000086, 57.91388580900008],
              [18.700450066000087, 57.92133209800005],
              [18.723806186000047, 57.92300039300005],
              [18.742442254000082, 57.91791413000004],
              [18.75717207100007, 57.90615469000005],
              [18.76929772200009, 57.88784414300005],
              [18.769867384000065, 57.88275788000004],
              [18.767425977000073, 57.878892320000034],
              [18.76417076900009, 57.87523021000004],
              [18.762461785000085, 57.87103913000004],
              [18.76465905000009, 57.86517975500004],
              [18.76929772200009, 57.86225006700005],
              [18.77393639400009, 57.860256252000056],
              [18.776133660000085, 57.857123114000046],
              [18.77833092500009, 57.84739817900004],
              [18.784353061000047, 57.83958567900004],
              [18.803477410000085, 57.82575104400007],
              [18.810720248000052, 57.851223049000055],
              [18.827403191000087, 57.863714911000045],
              [18.844086134000065, 57.87360260600008],
              [18.851898634000065, 57.89126211100006],
              [18.847178582000083, 57.897365627000056],
              [18.83920332100007, 57.90534088700008],
              [18.837412957000083, 57.912176825000074],
              [18.85132897200009, 57.91510651200008],
              [18.913340691000087, 57.92133209800005],
              [18.913340691000087, 57.91510651200008],
              [18.897959832000083, 57.897650458000044],
              [18.917246941000087, 57.88812897300005],
              [18.941579623000052, 57.88882070500006],
              [18.941254102000073, 57.90208567900004],
              [18.956553582000083, 57.90778229400007],
              [18.976410352000073, 57.91152578300006],
              [18.99577884200005, 57.91205475500004],
              [19.00953209700009, 57.908270575000074],
              [19.002126498000052, 57.90208567900004],
              [19.00684655000009, 57.892645575000074],
              [19.014008009000065, 57.881293036000045],
              [19.024668816000087, 57.87189362200007],
              [19.040212436000047, 57.86790599200003],
            ],
          ],
          [
            [
              [19.272959832000083, 57.976548570000034],
              [19.30567467500009, 57.97638580900008],
              [19.321136915000068, 57.972723700000074],
              [19.338552280000044, 57.96356842700004],
              [19.332286004000082, 57.959051825000074],
              [19.32585696700005, 57.956691799000055],
              [19.318532748000052, 57.95604075700004],
              [19.310557488000086, 57.956732489000046],
              [19.296071811000047, 57.94367096600007],
              [19.247894727000073, 57.952460028000075],
              [19.225840691000087, 57.946193752000056],
              [19.205332879000082, 57.93512604400007],
              [19.161957227000073, 57.92597077000005],
              [19.139903191000087, 57.908270575000074],
              [19.153168165000068, 57.902044989000046],
              [19.16065514400009, 57.89606354400007],
              [19.162852410000085, 57.88922760600008],
              [19.160329623000052, 57.88031647300005],
              [19.131114129000082, 57.85219961100006],
              [19.129649285000085, 57.846869208000044],
              [19.113454623000052, 57.84837474200003],
              [19.098399285000085, 57.852728583000044],
              [19.08448326900009, 57.859361070000034],
              [19.07162519600007, 57.86790599200003],
              [19.03679446700005, 57.90521881700005],
              [19.03956139400009, 57.91697825700004],
              [19.046722852000073, 57.924261786000045],
              [19.067881707000083, 57.93935781500005],
              [19.074961785000085, 57.94904205900008],
              [19.079925977000073, 57.959051825000074],
              [19.086599155000044, 57.968451239000046],
              [19.098317905000044, 57.976548570000034],
              [19.11459394600007, 57.979681708000044],
              [19.148610873000052, 57.97907135600008],
              [19.16342207100007, 57.98712799700007],
              [19.172129754000082, 57.98737213700008],
              [19.187754754000082, 57.98432038000004],
              [19.205821160000085, 57.98346588700008],
              [19.22242272200009, 57.990220445000034],
              [19.226735873000052, 57.97370026200008],
              [19.240082227000073, 57.97060781500005],
              [19.272959832000083, 57.976548570000034],
            ],
          ],
          [
            [
              [11.738780144000089, 58.05853913000004],
              [11.738454623000052, 58.04148997600004],
              [11.740489129000082, 58.035589911000045],
              [11.745616082000083, 58.03119538000004],
              [11.735606316000087, 58.00340403900003],
              [11.731944207000083, 57.997707424000055],
              [11.719411655000044, 57.992173570000034],
              [11.710215691000087, 57.99290599200003],
              [11.70679772200009, 57.99949778900003],
              [11.711436394000089, 58.011379299000055],
              [11.69507897200009, 58.01508209800005],
              [11.67937259200005, 58.00625234600005],
              [11.66765384200005, 57.99038320500006],
              [11.659434441000087, 57.96328359600005],
              [11.650645379000082, 57.95538971600007],
              [11.639414910000085, 57.95136139500005],
              [11.61890709700009, 57.95425039300005],
              [11.61109459700009, 57.948431708000044],
              [11.603688998000052, 57.940619208000044],
              [11.594737175000091, 57.935614325000074],
              [11.581065300000091, 57.93585846600007],
              [11.572276238000086, 57.94025299700007],
              [11.56609134200005, 57.94586823100008],
              [11.560069207000083, 57.949286200000074],
              [11.533702019000089, 57.95066966400003],
              [11.527842644000089, 57.954291083000044],
              [11.525889519000089, 57.96662018400008],
              [11.522715691000087, 57.975043036000045],
              [11.516449415000068, 57.98383209800005],
              [11.512461785000085, 57.992621161000045],
              [11.515635613000086, 58.00079987200007],
              [11.52702884200005, 58.00531647300005],
              [11.554860873000052, 58.002386786000045],
              [11.567556186000047, 58.003892320000034],
              [11.547129754000082, 58.00999583500004],
              [11.524261915000068, 58.00995514500005],
              [11.50562584700009, 58.013006903000075],
              [11.497894727000073, 58.02806224200003],
              [11.505869988000086, 58.04604726800005],
              [11.52475019600007, 58.05072663000004],
              [11.567556186000047, 58.04547760600008],
              [11.659678582000083, 58.04547760600008],
              [11.681488477000073, 58.05023834800005],
              [11.69898522200009, 58.05914948100008],
              [11.71656334700009, 58.064520575000074],
              [11.738780144000089, 58.05853913000004],
            ],
          ],
          [
            [
              [11.806976759000065, 58.23041413000004],
              [11.813731316000087, 58.211371161000045],
              [11.815277540000068, 58.18927643400008],
              [11.81381269600007, 58.14447663000004],
              [11.804698113000086, 58.12571849200003],
              [11.782725457000083, 58.120306708000044],
              [11.756683790000068, 58.11831289300005],
              [11.708181186000047, 58.09821198100008],
              [11.654633009000065, 58.10797760600008],
              [11.628916863000086, 58.10008372600004],
              [11.612315300000091, 58.11859772300005],
              [11.58529707100007, 58.123114325000074],
              [11.556488477000073, 58.11786530200004],
              [11.533946160000085, 58.10687897300005],
              [11.523692254000082, 58.09666575700004],
              [11.519867384000065, 58.089544989000046],
              [11.516286655000044, 58.086004950000074],
              [11.506032748000052, 58.08641185100004],
              [11.495616082000083, 58.089911200000074],
              [11.463877800000091, 58.10687897300005],
              [11.463877800000091, 58.07217031500005],
              [11.457692905000044, 58.07217031500005],
              [11.451182488000086, 58.09707265800006],
              [11.447438998000052, 58.10346100500004],
              [11.416026238000086, 58.12250397300005],
              [11.406586134000065, 58.13108958500004],
              [11.408864780000044, 58.145697333000044],
              [11.428965691000087, 58.16095612200007],
              [11.527842644000089, 58.21279531500005],
              [11.562673373000052, 58.21954987200007],
              [11.588226759000065, 58.23289622600004],
              [11.601573113000086, 58.23725006700005],
              [11.618418816000087, 58.237616278000075],
              [11.647959832000083, 58.234035549000055],
              [11.663096550000091, 58.23725006700005],
              [11.658539259000065, 58.248114325000074],
              [11.660004102000073, 58.25812409100007],
              [11.666758660000085, 58.26630280200004],
              [11.67741946700005, 58.27138906500005],
              [11.672699415000068, 58.28119538000004],
              [11.669932488000086, 58.28510163000004],
              [11.686371290000068, 58.29120514500005],
              [11.703461134000065, 58.29124583500004],
              [11.738780144000089, 58.28510163000004],
              [11.749847852000073, 58.262884833000044],
              [11.768565300000091, 58.25364817900004],
              [11.789398634000065, 58.24640534100007],
              [11.806976759000065, 58.23041413000004],
            ],
          ],
          [
            [
              [19.33171634200005, 58.367621161000045],
              [19.291188998000052, 58.35024648600006],
              [19.250336134000065, 58.34284088700008],
              [19.214121941000087, 58.354681708000044],
              [19.187754754000082, 58.394964911000045],
              [19.22242272200009, 58.394964911000045],
              [19.248789910000085, 58.386053778000075],
              [19.30567467500009, 58.378973700000074],
              [19.33171634200005, 58.367621161000045],
            ],
          ],
          [
            [
              [18.430430535000085, 59.25828685100004],
              [18.42709394600007, 59.26089101800005],
              [18.417979363000086, 59.27374909100007],
              [18.41309655000009, 59.27875397300005],
              [18.396820509000065, 59.28611888200004],
              [18.34473717500009, 59.299261786000045],
              [18.461680535000085, 59.29824453300006],
              [18.523448113000086, 59.28864166900007],
              [18.61231530000009, 59.25828685100004],
              [18.560720248000052, 59.25739166900007],
              [18.539073113000086, 59.25995514500005],
              [18.51612389400009, 59.27130768400008],
              [18.51726321700005, 59.24900950700004],
              [18.532399936000047, 59.241888739000046],
              [18.578135613000086, 59.24461497600004],
              [18.551605665000068, 59.225897528000075],
              [18.520355665000068, 59.22866445500006],
              [18.468272332000083, 59.25210195500006],
              [18.430430535000085, 59.25828685100004],
            ],
          ],
          [
            [
              [18.55014082100007, 60.32709381700005],
              [18.554698113000086, 60.32477448100008],
              [18.56153405000009, 60.32330963700008],
              [18.567881707000083, 60.32127513200004],
              [18.570648634000065, 60.31720612200007],
              [18.56690514400009, 60.30744049700007],
              [18.558116082000083, 60.30719635600008],
              [18.514333530000044, 60.32094961100006],
              [18.458832227000073, 60.35382721600007],
              [18.402191602000073, 60.36981842700004],
              [18.38917076900009, 60.39101797100005],
              [18.384938998000052, 60.41791413000004],
              [18.388926629000082, 60.46751536700003],
              [18.38803144600007, 60.47890859600005],
              [18.375173373000052, 60.50039297100005],
              [18.378754102000073, 60.507798570000034],
              [18.390147332000083, 60.51007721600007],
              [18.406260613000086, 60.505845445000034],
              [18.410980665000068, 60.50071849200003],
              [18.42237389400009, 60.49091217700004],
              [18.42676842500009, 60.48541901200008],
              [18.42676842500009, 60.481756903000075],
              [18.42481530000009, 60.47679271000004],
              [18.424001498000052, 60.47109609600005],
              [18.42676842500009, 60.464911200000074],
              [18.43921959700009, 60.45555247600004],
              [18.466075066000087, 60.442694403000075],
              [18.474457227000073, 60.43081289300005],
              [18.457855665000068, 60.432074286000045],
              [18.43458092500009, 60.44208405200004],
              [18.419932488000086, 60.443793036000045],
              [18.429698113000086, 60.42991771000004],
              [18.474457227000073, 60.38239166900007],
              [18.484629754000082, 60.366400458000044],
              [18.494313998000052, 60.35659414300005],
              [18.507823113000086, 60.35602448100008],
              [18.52979576900009, 60.36810944200005],
              [18.532399936000047, 60.35390859600005],
              [18.53679446700005, 60.34442780200004],
              [18.55014082100007, 60.32709381700005],
            ],
          ],
          [
            [
              [20.83920332100007, 63.767564195000034],
              [20.86491946700005, 63.79682038000004],
              [20.904633009000065, 63.79352448100008],
              [20.92042076900009, 63.77374909100007],
              [20.87354576900009, 63.753973700000074],
              [20.880869988000086, 63.76072825700004],
              [20.873220248000052, 63.770697333000044],
              [20.863454623000052, 63.773504950000074],
              [20.851898634000065, 63.77167389500005],
              [20.83920332100007, 63.767564195000034],
            ],
          ],
          [
            [
              [18.48536217500009, 59.09756094000005],
              [18.488454623000052, 59.095038153000075],
              [18.490082227000073, 59.08942291900007],
              [18.48731530000009, 59.08502838700008],
              [18.483897332000083, 59.08270905200004],
              [18.45606530000009, 59.05719635600008],
              [18.435883009000065, 59.04975006700005],
              [18.432871941000087, 59.04311758000006],
              [18.429535352000073, 59.03815338700008],
              [18.42945397200009, 59.03180573100008],
              [18.42750084700009, 59.02570221600007],
              [18.424571160000085, 59.02163320500006],
              [18.419932488000086, 59.01703522300005],
              [18.413584832000083, 59.01166413000004],
              [18.40528405000009, 59.00861237200007],
              [18.396006707000083, 59.010646877000056],
              [18.390961134000065, 59.01068756700005],
              [18.386241082000083, 59.007147528000075],
              [18.37671959700009, 59.00690338700008],
              [18.36654707100007, 59.009100653000075],
              [18.355479363000086, 59.01581452000005],
              [18.344411655000044, 59.02570221600007],
              [18.341319207000083, 59.03343333500004],
              [18.346039259000065, 59.03705475500004],
              [18.35328209700009, 59.03668854400007],
              [18.361582879000082, 59.03921133000006],
              [18.358083530000044, 59.045355536000045],
              [18.349782748000052, 59.05292389500005],
              [18.351084832000083, 59.05683014500005],
              [18.35710696700005, 59.055853583000044],
              [18.36622155000009, 59.057806708000044],
              [18.37631269600007, 59.063788153000075],
              [18.378754102000073, 59.07054271000004],
              [18.37159264400009, 59.073553778000075],
              [18.37476647200009, 59.07835521000004],
              [18.41537519600007, 59.09292226800005],
              [18.433767123000052, 59.10415273600006],
              [18.45085696700005, 59.11204661700003],
              [18.465993686000047, 59.117254950000074],
              [18.479340040000068, 59.11664459800005],
              [18.48536217500009, 59.10561758000006],
              [18.48536217500009, 59.09756094000005],
            ],
          ],
          [
            [
              [18.71583092500009, 59.20880768400008],
              [18.74382571700005, 59.206691799000055],
              [18.750010613000086, 59.205145575000074],
              [18.73796634200005, 59.19773997600004],
              [18.66846764400009, 59.174261786000045],
              [18.659678582000083, 59.17690664300005],
              [18.66570071700005, 59.187933661000045],
              [18.677256707000083, 59.199286200000074],
              [18.690928582000083, 59.20880768400008],
              [18.704356316000087, 59.21149323100008],
              [18.71583092500009, 59.20880768400008],
            ],
          ],
          [
            [
              [18.797048373000052, 59.29486725500004],
              [18.80323326900009, 59.29393138200004],
              [18.810801629000082, 59.28925202000005],
              [18.80762780000009, 59.28314850500004],
              [18.798675977000073, 59.27826569200005],
              [18.791188998000052, 59.27317942900004],
              [18.778575066000087, 59.26007721600007],
              [18.777679884000065, 59.257025458000044],
              [18.77784264400009, 59.25409577000005],
              [18.77515709700009, 59.25218333500004],
              [18.77051842500009, 59.25079987200007],
              [18.763845248000052, 59.25153229400007],
              [18.753754102000073, 59.25604889500005],
              [18.742930535000085, 59.25885651200008],
              [18.73731530000009, 59.258978583000044],
              [18.731618686000047, 59.25849030200004],
              [18.722666863000086, 59.26239655200004],
              [18.724619988000086, 59.272650458000044],
              [18.738454623000052, 59.285223700000074],
              [18.757660352000073, 59.294582424000055],
              [18.77588951900009, 59.29779694200005],
              [18.79004967500009, 59.296576239000046],
              [18.797048373000052, 59.29486725500004],
            ],
          ],
          [
            [
              [18.676036004000082, 59.340277411000045],
              [18.66382897200009, 59.346991278000075],
              [18.653168165000068, 59.35488515800006],
              [18.648448113000086, 59.35956452000005],
              [18.63803144600007, 59.36798737200007],
              [18.647308790000068, 59.37181224200003],
              [18.68799889400009, 59.37128327000005],
              [18.69109134200005, 59.37372467700004],
              [18.698090040000068, 59.37360260600008],
              [18.705902540000068, 59.37124258000006],
              [18.715017123000052, 59.366888739000046],
              [18.731293165000068, 59.35390859600005],
              [18.73804772200009, 59.351629950000074],
              [18.741709832000083, 59.350775458000044],
              [18.744151238000086, 59.344916083000044],
              [18.74708092500009, 59.33185455900008],
              [18.741384311000047, 59.320013739000046],
              [18.726573113000086, 59.31199778900003],
              [18.682790561000047, 59.30027903900003],
              [18.67750084700009, 59.29954661700003],
              [18.673106316000087, 59.303900458000044],
              [18.67676842500009, 59.31102122600004],
              [18.68295332100007, 59.31342194200005],
              [18.685801629000082, 59.316473700000074],
              [18.683604363000086, 59.32245514500005],
              [18.68213951900009, 59.331244208000044],
              [18.676036004000082, 59.340277411000045],
            ],
          ],
          [
            [
              [18.106700066000087, 59.38495514500005],
              [18.12273196700005, 59.389105536000045],
              [18.237478061000047, 59.37278880400004],
              [18.249278191000087, 59.36668528900003],
              [18.232758009000065, 59.364569403000075],
              [18.223887566000087, 59.36570872600004],
              [18.203949415000068, 59.36591217700004],
              [18.209727410000085, 59.36237213700008],
              [18.22242272200009, 59.35179271000004],
              [18.212087436000047, 59.341498114000046],
              [18.190114780000044, 59.33836497600004],
              [18.165537957000083, 59.34064362200007],
              [18.13998457100007, 59.34857819200005],
              [18.12281334700009, 59.356756903000075],
              [18.11695397200009, 59.36432526200008],
              [18.112478061000047, 59.37201569200005],
              [18.105316602000073, 59.37763092700004],
              [18.106700066000087, 59.38495514500005],
            ],
          ],
          [
            [
              [18.854258660000085, 59.40253327000005],
              [18.865082227000073, 59.39984772300005],
              [18.869476759000065, 59.393459377000056],
              [18.865489129000082, 59.38971588700008],
              [18.855723504000082, 59.385931708000044],
              [18.847666863000086, 59.38934967700004],
              [18.846527540000068, 59.39590078300006],
              [18.854258660000085, 59.40253327000005],
            ],
          ],
          [
            [
              [18.94239342500009, 59.39362213700008],
              [18.946462436000047, 59.388739325000074],
              [18.94825280000009, 59.37872955900008],
              [18.937673373000052, 59.37323639500005],
              [18.921071811000047, 59.379339911000045],
              [18.908457879000082, 59.388373114000046],
              [18.903819207000083, 59.39101797100005],
              [18.899912957000083, 59.393744208000044],
              [18.89942467500009, 59.40070221600007],
              [18.908213738000086, 59.406317450000074],
              [18.92156009200005, 59.405910549000055],
              [18.935883009000065, 59.39883047100005],
              [18.94239342500009, 59.39362213700008],
            ],
          ],
          [
            [
              [18.925791863000086, 59.434027411000045],
              [18.909027540000068, 59.41791413000004],
              [18.89389082100007, 59.40717194200005],
              [18.872325066000087, 59.408636786000045],
              [18.860606316000087, 59.42450592700004],
              [18.87354576900009, 59.43976471600007],
              [18.898610873000052, 59.44570547100005],
              [18.91179446700005, 59.44721100500004],
              [18.916351759000065, 59.446193752000056],
              [18.924164259000065, 59.44135163000004],
              [18.925791863000086, 59.434027411000045],
            ],
          ],
          [
            [
              [18.656586134000065, 59.506740627000056],
              [18.646494988000086, 59.50446198100008],
              [18.63770592500009, 59.499212958000044],
              [18.632985873000052, 59.48965078300006],
              [18.62354576900009, 59.488267320000034],
              [18.60840905000009, 59.49363841400003],
              [18.60328209700009, 59.493068752000056],
              [18.604177280000044, 59.48802317900004],
              [18.599864129000082, 59.48623281500005],
              [18.594411655000044, 59.48688385600008],
              [18.605316602000073, 59.466782945000034],
              [18.601817254000082, 59.45612213700008],
              [18.59115644600007, 59.452460028000075],
              [18.58253014400009, 59.455511786000045],
              [18.578461134000065, 59.46393463700008],
              [18.580902540000068, 59.43073151200008],
              [18.573090040000068, 59.43183014500005],
              [18.56226647200009, 59.42829010600008],
              [18.55640709700009, 59.422308661000045],
              [18.550629102000073, 59.42259349200003],
              [18.54542076900009, 59.42853424700007],
              [18.541840040000068, 59.43724192900004],
              [18.536306186000047, 59.44643789300005],
              [18.526866082000083, 59.45465729400007],
              [18.519053582000083, 59.464056708000044],
              [18.517751498000052, 59.47406647300005],
              [18.514496290000068, 59.47846100500004],
              [18.510508660000085, 59.48314036700003],
              [18.514414910000085, 59.49095286700003],
              [18.524912957000083, 59.49506256700005],
              [18.53809655000009, 59.49555084800005],
              [18.548838738000086, 59.49298737200007],
              [18.557383660000085, 59.48200104400007],
              [18.558116082000083, 59.482855536000045],
              [18.556162957000083, 59.487494208000044],
              [18.55958092500009, 59.491441148000035],
              [18.56495201900009, 59.49298737200007],
              [18.57162519600007, 59.493394273000035],
              [18.577647332000083, 59.49506256700005],
              [18.576426629000082, 59.49640534100007],
              [18.569509311000047, 59.495347398000035],
              [18.56348717500009, 59.49567291900007],
              [18.560069207000083, 59.498114325000074],
              [18.555430535000085, 59.49945709800005],
              [18.548106316000087, 59.49896881700005],
              [18.54542076900009, 59.502386786000045],
              [18.551117384000065, 59.51007721600007],
              [18.559825066000087, 59.51788971600007],
              [18.580414259000065, 59.53009674700007],
              [18.592458530000044, 59.538763739000046],
              [18.609711134000065, 59.54564036700003],
              [18.63249759200005, 59.54987213700008],
              [18.654307488000086, 59.550034898000035],
              [18.674489780000044, 59.54564036700003],
              [18.684255405000044, 59.53969961100006],
              [18.684418165000068, 59.53510163000004],
              [18.688975457000083, 59.53339264500005],
              [18.693207227000073, 59.53351471600007],
              [18.739105665000068, 59.54043203300006],
              [18.737478061000047, 59.535142320000034],
              [18.68140709700009, 59.52130768400008],
              [18.656586134000065, 59.506740627000056],
            ],
          ],
          [
            [
              [18.977712436000047, 59.63385651200008],
              [18.98178144600007, 59.632879950000074],
              [18.986338738000086, 59.628566799000055],
              [18.984629754000082, 59.624335028000075],
              [18.980642123000052, 59.624335028000075],
              [18.975271030000044, 59.623114325000074],
              [18.968028191000087, 59.61937083500004],
              [18.955088738000086, 59.61786530200004],
              [18.936696811000047, 59.61896393400008],
              [18.92750084700009, 59.62246328300006],
              [18.912852410000085, 59.59210846600007],
              [18.90528405000009, 59.583238023000035],
              [18.895681186000047, 59.58120351800005],
              [18.885590040000068, 59.57859935100004],
              [18.863454623000052, 59.583970445000034],
              [18.858571811000047, 59.595770575000074],
              [18.868418816000087, 59.60561758000006],
              [18.937754754000082, 59.64907461100006],
              [18.95248457100007, 59.65298086100006],
              [18.964854363000086, 59.647650458000044],
              [18.977712436000047, 59.63385651200008],
            ],
          ],
          [
            [
              [18.854258660000085, 59.60114166900007],
              [18.830821160000085, 59.59162018400008],
              [18.827647332000083, 59.58881256700005],
              [18.82781009200005, 59.58588288000004],
              [18.82390384200005, 59.58388906500005],
              [18.816254102000073, 59.583319403000075],
              [18.808767123000052, 59.58185455900008],
              [18.783539259000065, 59.57436758000006],
              [18.770355665000068, 59.57200755400004],
              [18.75684655000009, 59.57265859600005],
              [18.756602410000085, 59.57558828300006],
              [18.77442467500009, 59.58075592700004],
              [18.796153191000087, 59.58930084800005],
              [18.815603061000047, 59.60187409100007],
              [18.825043165000068, 59.609361070000034],
              [18.864756707000083, 59.632473049000055],
              [18.92432701900009, 59.65692780200004],
              [18.924164259000065, 59.64826080900008],
              [18.90528405000009, 59.63361237200007],
              [18.85792076900009, 59.60333893400008],
              [18.854258660000085, 59.60114166900007],
            ],
          ],
          [
            [
              [18.996348504000082, 59.809759833000044],
              [18.998708530000044, 59.809027411000045],
              [19.002289259000065, 59.80573151200008],
              [19.001963738000086, 59.799994208000044],
              [18.99781334700009, 59.794623114000046],
              [18.987803582000083, 59.78953685100004],
              [18.97201582100007, 59.78660716400003],
              [18.95639082100007, 59.78705475500004],
              [18.94312584700009, 59.79010651200008],
              [18.935557488000086, 59.792669989000046],
              [18.932302280000044, 59.79010651200008],
              [18.92628014400009, 59.78685130400004],
              [18.917491082000083, 59.78774648600006],
              [18.891286655000044, 59.785589911000045],
              [18.88575280000009, 59.79393138200004],
              [18.897634311000047, 59.809800523000035],
              [18.941661004000082, 59.848089911000045],
              [18.95167076900009, 59.86115143400008],
              [18.959157748000052, 59.863714911000045],
              [18.968597852000073, 59.86180247600004],
              [18.97828209700009, 59.857855536000045],
              [18.98796634200005, 59.85053131700005],
              [18.99545332100007, 59.839504299000055],
              [18.996348504000082, 59.82640208500004],
              [18.992523634000065, 59.81354401200008],
              [18.992198113000086, 59.807521877000056],
              [18.994965040000068, 59.80853913000004],
              [18.996348504000082, 59.809759833000044],
            ],
          ],
          [
            [
              [18.72396894600007, 60.196600653000075],
              [18.728770379000082, 60.19672272300005],
              [18.728770379000082, 60.200425523000035],
              [18.71225019600007, 60.212144273000035],
              [18.71851647200009, 60.216457424000055],
              [18.738291863000086, 60.214504299000055],
              [18.753103061000047, 60.20917389500005],
              [18.76140384200005, 60.203192450000074],
              [18.765798373000052, 60.19599030200004],
              [18.772634311000047, 60.19196198100008],
              [18.782399936000047, 60.189886786000045],
              [18.788259311000047, 60.18414948100008],
              [18.78809655000009, 60.17804596600007],
              [18.783864780000044, 60.17593008000006],
              [18.784434441000087, 60.175116278000075],
              [18.790293816000087, 60.17617422100005],
              [18.795583530000044, 60.17820872600004],
              [18.800303582000083, 60.17641836100006],
              [18.806162957000083, 60.168036200000074],
              [18.806895379000082, 60.160589911000045],
              [18.781993035000085, 60.153509833000044],
              [18.760996941000087, 60.150051174000055],
              [18.736338738000086, 60.15289948100008],
              [18.72437584700009, 60.155462958000044],
              [18.72038821700005, 60.16120026200008],
              [18.71420332100007, 60.17340729400007],
              [18.713063998000052, 60.18256256700005],
              [18.71461022200009, 60.18773021000004],
              [18.718272332000083, 60.19415924700007],
              [18.72396894600007, 60.196600653000075],
            ],
          ],
          [
            [
              [15.705332879000082, 56.116400458000044],
              [15.717784050000091, 56.11660390800006],
              [15.726898634000065, 56.118353583000044],
              [15.725840691000087, 56.112982489000046],
              [15.714366082000083, 56.10700104400007],
              [15.70085696700005, 56.10565827000005],
              [15.698496941000087, 56.10053131700005],
              [15.703298373000052, 56.08942291900007],
              [15.703623894000089, 56.08071523600006],
              [15.702159050000091, 56.07672760600008],
              [15.696787957000083, 56.074286200000074],
              [15.687673373000052, 56.07461172100005],
              [15.68327884200005, 56.075384833000044],
              [15.651133660000085, 56.08999258000006],
              [15.64234459700009, 56.10464101800005],
              [15.654958530000044, 56.11945221600007],
              [15.669118686000047, 56.123928127000056],
              [15.675303582000083, 56.12010325700004],
              [15.68336022200009, 56.11749909100007],
              [15.693532748000052, 56.11758047100005],
              [15.705332879000082, 56.116400458000044],
            ],
          ],
          [
            [
              [16.866709832000083, 58.30459219000005],
              [16.877289259000065, 58.299709377000056],
              [16.88062584700009, 58.29328034100007],
              [16.879079623000052, 58.280585028000075],
              [16.86817467500009, 58.272650458000044],
              [16.855804884000065, 58.27187734600005],
              [16.84742272200009, 58.275458075000074],
              [16.83643639400009, 58.29051341400003],
              [16.83253014400009, 58.30418528900003],
              [16.844899936000047, 58.31037018400008],
              [16.866709832000083, 58.30459219000005],
            ],
          ],
          [
            [
              [16.89161217500009, 58.33372630400004],
              [16.910492384000065, 58.338324286000045],
              [16.91895592500009, 58.336371161000045],
              [16.915293816000087, 58.33502838700008],
              [16.913259311000047, 58.33478424700007],
              [16.908376498000052, 58.329413153000075],
              [16.904958530000044, 58.32632070500006],
              [16.89503014400009, 58.32070547100005],
              [16.88184655000009, 58.31712474200003],
              [16.865244988000086, 58.31671784100007],
              [16.846039259000065, 58.31981028900003],
              [16.827403191000087, 58.32754140800006],
              [16.81495201900009, 58.339178778000075],
              [16.809418165000068, 58.34845612200007],
              [16.804209832000083, 58.35301341400003],
              [16.80014082100007, 58.358303127000056],
              [16.801524285000085, 58.36481354400007],
              [16.796397332000083, 58.37140534100007],
              [16.785166863000086, 58.380072333000044],
              [16.79004967500009, 58.38906484600005],
              [16.807790561000047, 58.394232489000046],
              [16.816742384000065, 58.39557526200008],
              [16.82976321700005, 58.39948151200008],
              [16.836599155000044, 58.400458075000074],
              [16.840668165000068, 58.39907461100006],
              [16.853770379000082, 58.402004299000055],
              [16.859711134000065, 58.40029531500005],
              [16.86426842500009, 58.397691148000035],
              [16.861582879000082, 58.39199453300006],
              [16.85124759200005, 58.38336823100008],
              [16.840017123000052, 58.38035716400003],
              [16.828786655000044, 58.38153717700004],
              [16.847178582000083, 58.37213776200008],
              [16.84538821700005, 58.368801174000055],
              [16.833832227000073, 58.36888255400004],
              [16.82748457100007, 58.36359284100007],
              [16.83057701900009, 58.35594310100004],
              [16.846039259000065, 58.345363674000055],
              [16.870290561000047, 58.333238023000035],
              [16.89161217500009, 58.33372630400004],
            ],
          ],
          [
            [
              [18.321462436000047, 58.96914297100005],
              [18.350840691000087, 58.979681708000044],
              [18.35710696700005, 58.976996161000045],
              [18.353851759000065, 58.96735260600008],
              [18.33887780000009, 58.957912502000056],
              [18.317230665000068, 58.95136139500005],
              [18.309336785000085, 58.94765859600005],
              [18.301524285000085, 58.94550202000005],
              [18.29346764400009, 58.94627513200004],
              [18.289805535000085, 58.941392320000034],
              [18.29932701900009, 58.93423086100006],
              [18.314789259000065, 58.930975653000075],
              [18.316416863000086, 58.926947333000044],
              [18.288340691000087, 58.92373281500005],
              [18.27247155000009, 58.919175523000035],
              [18.23796634200005, 58.914129950000074],
              [18.216319207000083, 58.905585028000075],
              [18.20606530000009, 58.90542226800005],
              [18.19825280000009, 58.90814850500004],
              [18.193614129000082, 58.911322333000044],
              [18.195567254000082, 58.92015208500004],
              [18.210948113000086, 58.93504466400003],
              [18.226410352000073, 58.94472890800006],
              [18.261892123000052, 58.95962148600006],
              [18.276540561000047, 58.96141185100004],
              [18.29037519600007, 58.96124909100007],
              [18.299489780000044, 58.96271393400008],
              [18.30567467500009, 58.96539948100008],
              [18.321462436000047, 58.96914297100005],
            ],
          ],
          [
            [
              [18.19825280000009, 59.00967031500005],
              [18.194590691000087, 58.99799225500004],
              [18.190196160000085, 58.99388255400004],
              [18.18262780000009, 58.999253648000035],
              [18.174652540000068, 59.00145091400003],
              [18.16765384200005, 58.997300523000035],
              [18.159434441000087, 58.997707424000055],
              [18.14812259200005, 59.00527578300006],
              [18.14584394600007, 59.00438060100004],
              [18.149180535000085, 58.99437083500004],
              [18.148692254000082, 58.98578522300005],
              [18.150238477000073, 58.97687409100007],
              [18.144704623000052, 58.96906159100007],
              [18.131114129000082, 58.96474844000005],
              [18.117523634000065, 58.96735260600008],
              [18.09896894600007, 58.97882721600007],
              [18.09473717500009, 58.97801341400003],
              [18.08692467500009, 58.97516510600008],
              [18.07195071700005, 58.96552155200004],
              [18.056651238000086, 58.959418036000045],
              [18.050629102000073, 58.960923570000034],
              [18.05054772200009, 58.96710846600007],
              [18.052582227000073, 58.97064850500004],
              [18.058604363000086, 58.98509349200003],
              [18.065196160000085, 58.99103424700007],
              [18.07593834700009, 58.99310944200005],
              [18.081553582000083, 58.99673086100006],
              [18.07984459700009, 59.00259023600006],
              [18.082855665000068, 59.00922272300005],
              [18.09278405000009, 59.01776764500005],
              [18.103526238000086, 59.022650458000044],
              [18.125336134000065, 59.020738023000035],
              [18.14942467500009, 59.02558014500005],
              [18.172129754000082, 59.027329820000034],
              [18.21656334700009, 59.02448151200008],
              [18.215668165000068, 59.02008698100008],
              [18.17872155000009, 59.011419989000046],
              [18.18067467500009, 59.00922272300005],
              [18.185394727000073, 59.01154205900008],
              [18.192067905000044, 59.01203034100007],
              [18.19825280000009, 59.00967031500005],
            ],
          ],
          [
            [
              [17.707286004000082, 58.993353583000044],
              [17.70248457100007, 58.984808661000045],
              [17.70020592500009, 58.97675202000005],
              [17.70362389400009, 58.96531810100004],
              [17.70411217500009, 58.95526764500005],
              [17.700043165000068, 58.945379950000074],
              [17.697113477000073, 58.93549225500004],
              [17.69434655000009, 58.928615627000056],
              [17.687510613000086, 58.92479075700004],
              [17.68067467500009, 58.92182038000004],
              [17.68262780000009, 58.91425202000005],
              [17.69117272200009, 58.90180084800005],
              [17.684825066000087, 58.900824286000045],
              [17.657725457000083, 58.92267487200007],
              [17.657074415000068, 58.91779205900008],
              [17.64812259200005, 58.91893138200004],
              [17.63917076900009, 58.930975653000075],
              [17.640635613000086, 58.94765859600005],
              [17.633962436000047, 58.956244208000044],
              [17.625824415000068, 58.95677317900004],
              [17.624278191000087, 58.96393463700008],
              [17.626800977000073, 58.98139069200005],
              [17.63640384200005, 58.997748114000046],
              [17.646006707000083, 59.009466864000046],
              [17.64812259200005, 59.01752350500004],
              [17.64616946700005, 59.023423570000034],
              [17.646820509000065, 59.03384023600006],
              [17.64389082100007, 59.06134674700007],
              [17.652191602000073, 59.071519273000035],
              [17.66309655000009, 59.071966864000046],
              [17.66570071700005, 59.06476471600007],
              [17.66895592500009, 59.05890534100007],
              [17.673024936000047, 59.05760325700004],
              [17.677582227000073, 59.05658600500004],
              [17.686696811000047, 59.05036041900007],
              [17.694102410000085, 59.03896719000005],
              [17.70093834700009, 59.02484772300005],
              [17.706309441000087, 59.00836823100008],
              [17.707286004000082, 58.993353583000044],
            ],
          ],
          [
            [
              [18.12468509200005, 62.687933661000045],
              [18.078949415000068, 62.679754950000074],
              [18.02702884200005, 62.68451569200005],
              [18.006114129000082, 62.70555247600004],
              [18.015798373000052, 62.722316799000055],
              [18.024912957000083, 62.73460521000004],
              [18.02833092500009, 62.74518463700008],
              [18.041026238000086, 62.75454336100006],
              [18.064300977000073, 62.757879950000074],
              [18.082041863000086, 62.75438060100004],
              [18.09278405000009, 62.74819570500006],
              [18.10320071700005, 62.74518463700008],
              [18.128103061000047, 62.751654364000046],
              [18.14942467500009, 62.74982330900008],
              [18.15984134200005, 62.74713776200008],
              [18.16114342500009, 62.73920319200005],
              [18.15723717500009, 62.72540924700007],
              [18.148448113000086, 62.71552155200004],
              [18.14698326900009, 62.70954010600008],
              [18.14307701900009, 62.706366278000075],
              [18.131114129000082, 62.707464911000045],
              [18.119965040000068, 62.70648834800005],
              [18.117035352000073, 62.70172760600008],
              [18.124522332000083, 62.69896067900004],
              [18.130056186000047, 62.69350820500006],
              [18.12468509200005, 62.687933661000045],
            ],
          ],
          [
            [
              [20.87086022200009, 63.66937897300005],
              [20.86459394600007, 63.659369208000044],
              [20.856130405000044, 63.65094635600008],
              [20.843028191000087, 63.644191799000055],
              [20.82593834700009, 63.64362213700008],
              [20.827647332000083, 63.65314362200007],
              [20.86459394600007, 63.67674388200004],
              [20.86890709700009, 63.67572663000004],
              [20.87086022200009, 63.66937897300005],
            ],
          ],
          [
            [
              [20.89812259200005, 63.75409577000005],
              [20.907074415000068, 63.75617096600007],
              [20.919769727000073, 63.76414622600004],
              [20.938243035000085, 63.77285390800006],
              [20.948496941000087, 63.774603583000044],
              [20.94703209700009, 63.772691148000035],
              [20.942230665000068, 63.76935455900008],
              [20.940684441000087, 63.765692450000074],
              [20.944183790000068, 63.76113515800006],
              [20.94304446700005, 63.756740627000056],
              [20.936208530000044, 63.75210195500006],
              [20.932871941000087, 63.745306708000044],
              [20.93523196700005, 63.73729075700004],
              [20.936696811000047, 63.72752513200004],
              [20.932871941000087, 63.715277411000045],
              [20.923106316000087, 63.703192450000074],
              [20.908864780000044, 63.695298570000034],
              [20.894053582000083, 63.68992747600004],
              [20.88721764400009, 63.69090403900003],
              [20.879730665000068, 63.690659898000035],
              [20.864756707000083, 63.68309153900003],
              [20.862071160000085, 63.693345445000034],
              [20.880869988000086, 63.74237702000005],
              [20.888926629000082, 63.74994538000004],
              [20.89812259200005, 63.75409577000005],
            ],
          ],
          [
            [
              [22.408050977000073, 65.45526764500005],
              [22.417816602000073, 65.44993724200003],
              [22.410411004000082, 65.44131094000005],
              [22.387868686000047, 65.43366120000007],
              [22.375661655000044, 65.43073151200008],
              [22.294932488000086, 65.42816803600005],
              [22.285166863000086, 65.43162669500003],
              [22.286387566000087, 65.44257233300004],
              [22.294769727000073, 65.45286692900004],
              [22.30640709700009, 65.45538971600007],
              [22.316661004000082, 65.45221588700008],
              [22.32129967500009, 65.44692617400005],
              [22.33253014400009, 65.44301992400005],
              [22.35206139400009, 65.44928620000007],
              [22.37086022200009, 65.45945872600004],
              [22.390879754000082, 65.45954010600008],
              [22.408050977000073, 65.45526764500005],
            ],
          ],
          [
            [
              [22.153575066000087, 65.43036530200004],
              [22.148285352000073, 65.43463776200008],
              [22.142588738000086, 65.44578685100004],
              [22.144053582000083, 65.45453522300005],
              [22.147227410000085, 65.45844147300005],
              [22.147308790000068, 65.46865469000005],
              [22.156586134000065, 65.47435130400004],
              [22.174001498000052, 65.47431061400005],
              [22.210215691000087, 65.46580638200004],
              [22.21534264400009, 65.46002838700008],
              [22.207204623000052, 65.45612213700008],
              [22.206553582000083, 65.45018138200004],
              [22.216807488000086, 65.44196198100008],
              [22.227224155000044, 65.43667226800005],
              [22.231700066000087, 65.43154531500005],
              [22.233164910000085, 65.42389557500007],
              [22.231700066000087, 65.41811758000006],
              [22.219899936000047, 65.41986725500004],
              [22.21070397200009, 65.42316315300008],
              [22.201426629000082, 65.42552317900004],
              [22.153575066000087, 65.43036530200004],
            ],
          ],
          [
            [
              [22.594899936000047, 65.52826569200005],
              [22.610524936000047, 65.52399323100008],
              [22.617198113000086, 65.51748281500005],
              [22.61426842500009, 65.51190827000005],
              [22.604746941000087, 65.51032135600008],
              [22.58838951900009, 65.51211172100005],
              [22.567556186000047, 65.51691315300008],
              [22.552989129000082, 65.53009674700007],
              [22.558929884000065, 65.53827545800004],
              [22.57715905000009, 65.53310781500005],
              [22.586599155000044, 65.52899811400005],
              [22.594899936000047, 65.52826569200005],
            ],
          ],
          [
            [
              [22.218760613000086, 65.50678131700005],
              [22.193207227000073, 65.52578359600005],
              [22.186778191000087, 65.53782786700003],
              [22.198008660000085, 65.54197825700004],
              [22.21143639400009, 65.54511139500005],
              [22.226410352000073, 65.54393138200004],
              [22.303396030000044, 65.52301666900007],
              [22.311289910000085, 65.52285390800006],
              [22.318614129000082, 65.52399323100008],
              [22.326833530000044, 65.52057526200008],
              [22.336273634000065, 65.51288483300004],
              [22.35873457100007, 65.50397370000007],
              [22.358246290000068, 65.49506256700005],
              [22.344086134000065, 65.49038320500006],
              [22.332692905000044, 65.49164459800005],
              [22.321136915000068, 65.50018952000005],
              [22.307790561000047, 65.50674062700006],
              [22.293223504000082, 65.51141998900005],
              [22.278819207000083, 65.51325104400007],
              [22.27051842500009, 65.50983307500007],
              [22.274261915000068, 65.50128815300008],
              [22.270762566000087, 65.50023021000004],
              [22.27051842500009, 65.49689362200007],
              [22.272715691000087, 65.49115631700005],
              [22.283457879000082, 65.48309967700004],
              [22.285492384000065, 65.47919342700004],
              [22.280121290000068, 65.47821686400005],
              [22.265798373000052, 65.48175690300008],
              [22.218760613000086, 65.50678131700005],
            ],
          ],
          [
            [
              [22.577972852000073, 65.58274974200003],
              [22.625824415000068, 65.59341054900005],
              [22.641449415000068, 65.58909739800004],
              [22.637461785000085, 65.57965729400007],
              [22.621429884000065, 65.57611725500004],
              [22.613942905000044, 65.57143789300005],
              [22.612152540000068, 65.56378815300008],
              [22.606211785000085, 65.55752187700006],
              [22.59742272200009, 65.55394114800004],
              [22.586761915000068, 65.55512116100005],
              [22.575368686000047, 65.55817291900007],
              [22.57203209700009, 65.55756256700005],
              [22.576345248000052, 65.55418528900003],
              [22.569590691000087, 65.55499909100007],
              [22.539317254000082, 65.56366608300004],
              [22.533539259000065, 65.56781647300005],
              [22.529144727000073, 65.57623932500007],
              [22.535899285000085, 65.58136627800008],
              [22.546397332000083, 65.58177317900004],
              [22.560720248000052, 65.58079661700003],
              [22.577972852000073, 65.58274974200003],
            ],
          ],
          [
            [
              [22.570160352000073, 65.59479401200008],
              [22.558604363000086, 65.60097890800006],
              [22.55445397200009, 65.60537344000005],
              [22.56812584700009, 65.61253489800004],
              [22.59506269600007, 65.61298248900005],
              [22.60450280000009, 65.60028717700004],
              [22.589121941000087, 65.59373607000003],
              [22.570160352000073, 65.59479401200008],
            ],
          ],
          [
            [
              [22.96265709700009, 65.71629466400003],
              [22.976898634000065, 65.70986562700006],
              [22.985118035000085, 65.70026276200008],
              [22.981944207000083, 65.69358958500004],
              [22.971039259000065, 65.69550202000005],
              [22.964040561000047, 65.69562409100007],
              [22.960948113000086, 65.69013092700004],
              [22.962901238000086, 65.68195221600007],
              [22.971934441000087, 65.66705963700008],
              [22.957286004000082, 65.67088450700004],
              [22.927256707000083, 65.68451569200005],
              [22.899099155000044, 65.70140208500004],
              [22.88217207100007, 65.72044505400004],
              [22.886241082000083, 65.73737213700008],
              [22.904551629000082, 65.74274323100008],
              [22.930023634000065, 65.74188873900005],
              [22.956228061000047, 65.73322174700007],
              [22.959727410000085, 65.72532786700003],
              [22.944834832000083, 65.72455475500004],
              [22.945974155000044, 65.72162506700005],
              [22.96265709700009, 65.71629466400003],
            ],
          ],
          [
            [
              [23.797211134000065, 65.75372955900008],
              [23.800791863000086, 65.74982330900008],
              [23.802744988000086, 65.74371979400007],
              [23.799489780000044, 65.73480866100005],
              [23.792816602000073, 65.72846100500004],
              [23.786306186000047, 65.72467682500007],
              [23.783213738000086, 65.72113678600005],
              [23.784678582000083, 65.71820709800005],
              [23.77393639400009, 65.71124909100007],
              [23.738291863000086, 65.69672272300005],
              [23.699880405000044, 65.70746491100005],
              [23.681488477000073, 65.72166575700004],
              [23.681651238000086, 65.74306875200006],
              [23.689626498000052, 65.74843984600005],
              [23.69662519600007, 65.73956940300008],
              [23.70476321700005, 65.73598867400005],
              [23.71070397200009, 65.74017975500004],
              [23.713552280000044, 65.75189850500004],
              [23.71924889400009, 65.75067780200004],
              [23.72982832100007, 65.74526601800005],
              [23.741709832000083, 65.74225495000007],
              [23.75367272200009, 65.74127838700008],
              [23.765147332000083, 65.74420807500007],
              [23.77515709700009, 65.74957916900007],
              [23.781504754000082, 65.74835846600007],
              [23.786957227000073, 65.74363841400003],
              [23.79004967500009, 65.74713776200008],
              [23.79265384200005, 65.75389232000003],
              [23.797211134000065, 65.75372955900008],
            ],
          ],
          [
            [
              [22.741058790000068, 65.71360911700003],
              [22.732432488000086, 65.71869538000004],
              [22.725759311000047, 65.72402578300006],
              [22.72624759200005, 65.72996653900003],
              [22.730479363000086, 65.73859284100007],
              [22.731944207000083, 65.75145091400003],
              [22.735524936000047, 65.76634349200003],
              [22.746836785000085, 65.77041250200006],
              [22.79078209700009, 65.75031159100007],
              [22.80241946700005, 65.73480866100005],
              [22.811371290000068, 65.71409739800004],
              [22.805430535000085, 65.70522695500006],
              [22.760508660000085, 65.70848216400003],
              [22.741058790000068, 65.71360911700003],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Finland',
        iso3: 'FIN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [28.95407718900009, 69.02726064100004],
              [28.833464396000096, 68.98447255500012],
              [28.713265015000047, 68.96803945000006],
              [28.456226441000098, 68.90013661800002],
              [28.410234415000104, 68.89853464800008],
              [28.41312829600011, 68.88008616200007],
              [28.426770874000113, 68.870577698],
              [28.444237508000043, 68.8658234660001],
              [28.645672241000085, 68.87166290300006],
              [28.728251180000115, 68.86504832000007],
              [28.801476684000107, 68.83548940000004],
              [28.74726810700008, 68.76014516200006],
              [28.716365600000103, 68.72795074500003],
              [28.459947144000125, 68.54243235300002],
              [28.447906535000044, 68.52971995000006],
              [28.44744144700013, 68.51488881500005],
              [28.46098067300011, 68.49106597900006],
              [28.48092777500011, 68.46259226500003],
              [28.6637589930001, 68.20400339800007],
              [28.69032067900011, 68.18317779600001],
              [28.727217651000046, 68.17268748000005],
              [29.01293664500008, 68.127238058],
              [29.298655639000117, 68.08178863600007],
              [29.330850057000134, 68.07269358300009],
              [29.360150594000118, 68.05672556600005],
              [29.442626180000047, 67.99114817400003],
              [29.480866740000124, 67.96045237200009],
              [29.651192261000062, 67.82356150300008],
              [29.7138240970001, 67.79250396800005],
              [30.00941329000011, 67.68584381199999],
              [29.987864217000094, 67.67245961600004],
              [29.977683960000093, 67.66222768100006],
              [29.97344649300004, 67.64930857400005],
              [29.964661499000044, 67.58471303300009],
              [29.95990726800005, 67.57158721900002],
              [29.93344893400007, 67.52637034100006],
              [29.91624068200008, 67.508128561],
              [29.519830770000112, 67.29816721600004],
              [29.508461955000087, 67.28809031200011],
              [29.496989787000075, 67.27026194300005],
              [29.490685262000056, 67.26297556600007],
              [29.480866740000124, 67.256774394],
              [29.42939701400013, 67.23277069199999],
              [29.100114787000052, 66.99126088500005],
              [29.09990808100011, 66.99113169400003],
              [29.051538940000057, 66.90780344700006],
              [29.089159383000094, 66.837549337],
              [29.322220093000112, 66.68006541000001],
              [29.362497842000096, 66.6265528310001],
              [29.363974650000046, 66.62459076000003],
              [29.392396688000076, 66.605289612],
              [29.39539392000006, 66.59645294299999],
              [29.396427449000043, 66.58663442000001],
              [29.401336711000113, 66.5762216190001],
              [29.409449910000035, 66.56847015400008],
              [29.524481648000062, 66.49121388800008],
              [29.53419681800011, 66.47403147500002],
              [29.546194294000145, 66.43196931900012],
              [29.55166345200007, 66.41279490199999],
              [29.56969852700007, 66.37817169300008],
              [29.593211303000146, 66.34592559900001],
              [29.650882202000105, 66.28789296500004],
              [29.79237227400006, 66.18087107400005],
              [29.8753646240001, 66.13358713800001],
              [29.900169311000127, 66.10805898100007],
              [29.920529826000063, 66.06862986300006],
              [29.94884851000006, 65.99127024400006],
              [29.95846032700007, 65.97388112400002],
              [29.99794112100011, 65.9315322880001],
              [30.00972334800008, 65.91569346200002],
              [30.039282267000146, 65.86538645500003],
              [30.07514571100006, 65.82280507500006],
              [30.083517293000057, 65.80461497000003],
              [30.111732625000116, 65.71201080400006],
              [30.11628015100007, 65.68720611600004],
              [30.113903035000135, 65.66550201500003],
              [30.098503459000142, 65.65638112400005],
              [30.064707071000043, 65.66167795900002],
              [30.00300541100006, 65.67813690200008],
              [29.76426029400011, 65.64808705700001],
              [29.70286869300014, 65.62938018900003],
              [29.73232426000004, 65.60870961500011],
              [29.806738322000058, 65.58486094200002],
              [29.838571004000073, 65.564888001],
              [29.82575524900011, 65.55196889200009],
              [29.745450073000086, 65.51140289300007],
              [29.7315327930001, 65.49692139900002],
              [29.726329793000104, 65.49150746700006],
              [29.726329793000104, 65.49124908500009],
              [29.71816491700008, 65.45417124500001],
              [29.730567260000043, 65.36536529600009],
              [29.720128622000118, 65.32908844000004],
              [29.615122111000062, 65.26940216100012],
              [29.580085490000045, 65.23539906900008],
              [29.62669763200006, 65.2152194210001],
              [29.76684411600013, 65.21736399300006],
              [29.83319665500005, 65.20501332700012],
              [29.839294475000088, 65.16690195800005],
              [29.82968265800008, 65.15860789000003],
              [29.81800378400004, 65.15220001300007],
              [29.809115438000106, 65.14522369500007],
              [29.808185262000052, 65.13530181900008],
              [29.820329223000044, 65.1265168260001],
              [29.838054240000076, 65.12481150300003],
              [29.85019820100007, 65.12150421100004],
              [29.845598999000117, 65.10801666300007],
              [29.820484253000075, 65.09365061500007],
              [29.667832072000124, 65.0779409800001],
              [29.6273177490001, 65.06223134400004],
              [29.59837894700013, 65.03437774700005],
              [29.588147013000082, 64.9914346320001],
              [29.633622274000118, 64.90715037100007],
              [29.698321167000074, 64.83914418600001],
              [29.780279989000064, 64.79558095400007],
              [29.877845093000076, 64.78483225600006],
              [30.06253666200007, 64.78416046200006],
              [30.10191410300007, 64.77547882100002],
              [30.118863973000146, 64.76793406200007],
              [30.12041426600007, 64.76157786100005],
              [30.114936564000118, 64.75434316000006],
              [30.111112508000076, 64.74442128500006],
              [30.1090454510001, 64.73165720700011],
              [30.106823364000093, 64.72561106400006],
              [30.10914880300004, 64.72008168600006],
              [30.12051761900011, 64.70891957600013],
              [30.13136967000014, 64.70121978800005],
              [30.17054040500011, 64.68168609600004],
              [30.187800334000087, 64.66235911100007],
              [30.1808240150001, 64.64277374300006],
              [30.16041182500004, 64.6260822550001],
              [30.136433960000147, 64.6153852340001],
              [29.96579838000008, 64.57864329100003],
              [29.958770386000083, 64.5748709110001],
              [29.954842977000112, 64.568979798],
              [29.95887373900007, 64.56598256500008],
              [29.965178263000098, 64.56443227100006],
              [29.968485555000086, 64.56283030300004],
              [29.970035848000123, 64.545415345],
              [29.97360152100009, 64.53621694000002],
              [29.980784546000052, 64.52676015300004],
              [29.978924194000058, 64.5240213020001],
              [29.978200724000146, 64.5211274220001],
              [29.978975871000046, 64.51833689400006],
              [29.980784546000052, 64.51554636700008],
              [29.99153324400004, 64.51322092700006],
              [29.993393595000043, 64.51074045800009],
              [29.990499715000055, 64.5041775510001],
              [30.035768269000073, 64.49146514900004],
              [30.07039147900008, 64.47187978100003],
              [30.06279504400004, 64.44841868100004],
              [30.04103926600004, 64.42294220000012],
              [30.032460978000074, 64.39694895500007],
              [30.05297652200005, 64.37808705700003],
              [30.093129110000064, 64.36124054000005],
              [30.164442586000064, 64.3419135540001],
              [30.321125529000085, 64.31767730700004],
              [30.370476522000047, 64.30083079000003],
              [30.399260295000147, 64.28310577400002],
              [30.421584513000084, 64.26465728800012],
              [30.445975790000034, 64.25075632700005],
              [30.503439982000145, 64.24378000900005],
              [30.536202841000147, 64.23468495700008],
              [30.558475382000097, 64.21969879200002],
              [30.550258830000075, 64.19887318900005],
              [30.532482137000045, 64.17918446900008],
              [30.532792196000116, 64.16254465800007],
              [30.544781128000068, 64.14636993500007],
              [30.562144409000098, 64.12740468400004],
              [30.586432332000072, 64.08466827500011],
              [30.580489543000112, 64.05107859400009],
              [30.552325887000052, 64.0217263790001],
              [30.50933109500005, 63.991495667],
              [30.50933109500005, 63.991392314000066],
              [30.32856693500014, 63.895997620000045],
              [30.265573365000137, 63.83067860900009],
              [30.201546265000047, 63.79264475600006],
              [30.051271199000098, 63.76375762900001],
              [29.998432859000104, 63.74710038100007],
              [29.980784546000052, 63.74153676400009],
              [30.001145060000056, 63.715336813000064],
              [30.24247399900014, 63.58180491200007],
              [30.380450073000134, 63.532453919000076],
              [30.44142826300009, 63.49157786100007],
              [30.461065307000126, 63.472870993000086],
              [30.488660522000146, 63.46212229500007],
              [30.82093998200014, 63.37566762400006],
              [30.974935750000043, 63.28916127600006],
              [31.177817424000068, 63.2252375290001],
              [31.203965698000104, 63.212680155],
              [31.225669800000105, 63.19604034500007],
              [31.233059530000105, 63.17573150700004],
              [31.23424808700014, 63.157231344000124],
              [31.240759318000073, 63.135733948000066],
              [31.250836223000135, 63.11547678600009],
              [31.262773478000042, 63.100593974000034],
              [31.288508341000068, 63.084729309000025],
              [31.351553589000105, 63.062198385],
              [31.380337362000034, 63.04793569000002],
              [31.44446781400012, 63.00194366500004],
              [31.468032267000126, 62.991556702000096],
              [31.48064131700005, 62.986337383],
              [31.505446004000078, 62.96819895500006],
              [31.51929528800008, 62.94318756100007],
              [31.535831747000145, 62.91951975600004],
              [31.56952478000011, 62.90592885400004],
              [31.48064131700005, 62.82608876600004],
              [31.44126387500006, 62.788700867],
              [31.41056807500013, 62.74653289800004],
              [31.363335815000084, 62.65157745400005],
              [31.347006063000038, 62.62933075000008],
              [31.302771037000127, 62.59602529000004],
              [31.284064169000146, 62.57297760000007],
              [31.26008630400014, 62.52484100400001],
              [31.243756551000104, 62.503343608000066],
              [31.222155802000145, 62.49171641],
              [31.22194909600006, 62.49171641],
              [31.221587361000104, 62.49158721900007],
              [31.16861901900006, 62.476006775000045],
              [31.15296105900012, 62.46735097300008],
              [31.14164392100014, 62.45652476100004],
              [31.123350463000065, 62.43482065900004],
              [30.98062015800008, 62.358804627],
              [30.967080933000148, 62.34818512],
              [30.941862834000062, 62.31459543900006],
              [30.92563643300008, 62.30211558100008],
              [30.907549682000138, 62.292891337000086],
              [30.793809855000063, 62.25299713200003],
              [30.70384118700008, 62.21038991300007],
              [30.665497274000074, 62.199822083000086],
              [30.647720581000044, 62.19276825000007],
              [30.635008178000078, 62.184009094],
              [30.607206258000133, 62.15127207500008],
              [30.480702351000048, 62.067685445000095],
              [30.33993575100004, 61.99177276700006],
              [30.33972904500007, 61.99166941400004],
              [30.33957401500004, 61.99166941400004],
              [30.14564900500011, 61.85046941100002],
              [29.977683960000093, 61.728171286000034],
              [29.842240030000085, 61.66016510000007],
              [29.82187951700007, 61.64458465600002],
              [29.798056681000105, 61.609651388000046],
              [29.77914310700004, 61.593114930000056],
              [29.635120891000042, 61.51110443200007],
              [29.604270061000136, 61.49919301400003],
              [29.539726197000107, 61.48495615700004],
              [29.517040242000064, 61.475060120000066],
              [29.49905684400005, 61.45924713200007],
              [29.480866740000124, 61.434778341000126],
              [29.46340010600005, 61.413823548000025],
              [29.31839603700007, 61.33842763300005],
              [29.28925052900007, 61.316206767],
              [29.277058696000097, 61.30459883400003],
              [29.262275431000035, 61.29052358000003],
              [29.20315759300007, 61.24590098100002],
              [29.1300871170001, 61.21342234300006],
              [28.980845581000068, 61.16810211200006],
              [28.92637862100014, 61.14794830400008],
              [28.855478557000083, 61.11267913900009],
              [28.797600952000067, 61.096840312],
              [28.781322876000047, 61.08697011300002],
              [28.75016198700007, 61.061364442000055],
              [28.688977092000044, 61.02738718700003],
              [28.670683634000085, 61.012478536000074],
              [28.65383711700011, 60.99188547800007],
              [28.653733764000066, 60.99175628700006],
              [28.614563029000124, 60.96193898500006],
              [28.52640303600009, 60.95023427400007],
              [28.48092777500011, 60.933465271],
              [28.33592370600013, 60.85938710500007],
              [28.243939657000027, 60.791587626000066],
              [28.14813155100009, 60.757713725000045],
              [28.003781679000042, 60.66422553500006],
              [27.981009969000098, 60.64947743800006],
              [27.892953328000146, 60.60426055900005],
              [27.807871941000087, 60.55304596600007],
              [27.791188998000052, 60.562201239000046],
              [27.777598504000082, 60.57367584800005],
              [27.762054884000065, 60.580145575000074],
              [27.739512566000087, 60.57416413000004],
              [27.743174675000034, 60.57094961100006],
              [27.749522332000083, 60.56313711100006],
              [27.753184441000087, 60.559881903000075],
              [27.736175977000073, 60.555568752000056],
              [27.733409050000034, 60.544256903000075],
              [27.740570509000065, 60.530585028000075],
              [27.753184441000087, 60.51894765800006],
              [27.738129102000073, 60.513332424000055],
              [27.732676629000082, 60.51211172100005],
              [27.746429884000065, 60.50649648600006],
              [27.753184441000087, 60.505845445000034],
              [27.71843509200005, 60.48847077000005],
              [27.705414259000065, 60.48541901200008],
              [27.63648522200009, 60.492254950000074],
              [27.645762566000087, 60.503566799000055],
              [27.676605665000068, 60.51117584800005],
              [27.691661004000082, 60.51894765800006],
              [27.65170332100007, 60.522650458000044],
              [27.63217207100007, 60.52167389500005],
              [27.615977410000085, 60.51211172100005],
              [27.608246290000068, 60.49994538000004],
              [27.610850457000083, 60.49213288000004],
              [27.619313998000052, 60.484076239000046],
              [27.629649285000085, 60.471136786000045],
              [27.592458530000044, 60.47736237200007],
              [27.508474155000044, 60.51386139500005],
              [27.472666863000086, 60.505845445000034],
              [27.482269727000073, 60.50429922100005],
              [27.486338738000086, 60.501939195000034],
              [27.493174675000034, 60.492254950000074],
              [27.487071160000085, 60.489447333000044],
              [27.47828209700009, 60.481675523000035],
              [27.472666863000086, 60.47797272300005],
              [27.483571811000047, 60.47443268400008],
              [27.493011915000068, 60.47020091400003],
              [27.500743035000085, 60.46474844000005],
              [27.506683790000068, 60.457464911000045],
              [27.45679772200009, 60.46369049700007],
              [27.369313998000052, 60.49787018400008],
              [27.32520592500009, 60.505845445000034],
              [27.248789910000085, 60.507879950000074],
              [27.232432488000086, 60.51211172100005],
              [27.230804884000065, 60.52631256700005],
              [27.256602410000085, 60.52944570500006],
              [27.308116082000083, 60.52578359600005],
              [27.28492272200009, 60.53652578300006],
              [27.21192467500009, 60.559881903000075],
              [27.227712436000047, 60.57957591400003],
              [27.21461022200009, 60.58494700700004],
              [27.191742384000065, 60.579738674000055],
              [27.177744988000086, 60.56732819200005],
              [27.183848504000082, 60.55219147300005],
              [27.19703209700009, 60.53705475500004],
              [27.200694207000083, 60.52326080900008],
              [27.177744988000086, 60.51211172100005],
              [27.175791863000086, 60.52513255400004],
              [27.16968834700009, 60.528631903000075],
              [27.149912957000083, 60.52578359600005],
              [27.13770592500009, 60.52903880400004],
              [27.12403405000009, 60.54352448100008],
              [27.112559441000087, 60.54682038000004],
              [27.105642123000052, 60.54360586100006],
              [27.095713738000086, 60.52920156500005],
              [27.08838951900009, 60.52578359600005],
              [27.078949415000068, 60.528631903000075],
              [27.062836134000065, 60.54291413000004],
              [27.05437259200005, 60.54682038000004],
              [27.045176629000082, 60.545803127000056],
              [27.033376498000052, 60.54181549700007],
              [27.02442467500009, 60.53607819200005],
              [27.02393639400009, 60.52948639500005],
              [27.02711022200009, 60.51992422100005],
              [27.020762566000087, 60.51434967700004],
              [27.011729363000086, 60.509466864000046],
              [26.998220248000052, 60.48802317900004],
              [26.976898634000065, 60.48354726800005],
              [26.93140709700009, 60.48541901200008],
              [26.95557701900009, 60.46930573100008],
              [26.96534264400009, 60.45848216400003],
              [26.962412957000083, 60.44721100500004],
              [26.954600457000083, 60.44940827000005],
              [26.92432701900009, 60.46698639500005],
              [26.914724155000044, 60.47455475500004],
              [26.823090040000068, 60.45774974200003],
              [26.793630405000044, 60.457464911000045],
              [26.801036004000082, 60.46369049700007],
              [26.806488477000073, 60.47052643400008],
              [26.814707879000082, 60.48541901200008],
              [26.797048373000052, 60.48590729400007],
              [26.776540561000047, 60.482855536000045],
              [26.75684655000009, 60.476629950000074],
              [26.742442254000082, 60.468003648000035],
              [26.739024285000085, 60.46088288000004],
              [26.740977410000085, 60.44367096600007],
              [26.739024285000085, 60.43695709800005],
              [26.731944207000083, 60.432928778000075],
              [26.71062259200005, 60.425848700000074],
              [26.701426629000082, 60.419907945000034],
              [26.687347852000073, 60.41815827000005],
              [26.66928144600007, 60.42841217700004],
              [26.65088951900009, 60.44208405200004],
              [26.635915561000047, 60.45062897300005],
              [26.617035352000073, 60.45294830900008],
              [26.594411655000044, 60.45229726800005],
              [26.57715905000009, 60.447333075000074],
              [26.574473504000082, 60.43695709800005],
              [26.553396030000044, 60.43301015800006],
              [26.527354363000086, 60.439886786000045],
              [26.501963738000086, 60.45307038000004],
              [26.482676629000082, 60.468003648000035],
              [26.474864129000082, 60.48725006700005],
              [26.491465691000087, 60.498114325000074],
              [26.51726321700005, 60.50580475500004],
              [26.536631707000083, 60.51552969000005],
              [26.563649936000047, 60.54336172100005],
              [26.567637566000087, 60.54995351800005],
              [26.564463738000086, 60.57257721600007],
              [26.56739342500009, 60.580959377000056],
              [26.57984459700009, 60.59137604400007],
              [26.625010613000086, 60.60960521000004],
              [26.666677280000044, 60.60643138200004],
              [26.753184441000087, 60.57416413000004],
              [26.73178144600007, 60.61286041900007],
              [26.699229363000086, 60.64020416900007],
              [26.65919030000009, 60.65180084800005],
              [26.615489129000082, 60.64305247600004],
              [26.591807488000086, 60.628566799000055],
              [26.55331464900007, 60.591782945000034],
              [26.46583092500009, 60.50812409100007],
              [26.456228061000047, 60.47455475500004],
              [26.48568769600007, 60.443793036000045],
              [26.469411655000044, 60.42747630400004],
              [26.46070397200009, 60.42088450700004],
              [26.451508009000065, 60.41648997600004],
              [26.423350457000083, 60.41632721600007],
              [26.416351759000065, 60.41193268400008],
              [26.424164259000065, 60.39598216400003],
              [26.412852410000085, 60.39801666900007],
              [26.402598504000082, 60.40265534100007],
              [26.38331139400009, 60.41648997600004],
              [26.38453209700009, 60.40485260600008],
              [26.381195509000065, 60.39874909100007],
              [26.37403405000009, 60.39642975500004],
              [26.362803582000083, 60.39598216400003],
              [26.351410352000073, 60.39280833500004],
              [26.34896894600007, 60.38580963700008],
              [26.348317905000044, 60.37872955900008],
              [26.342051629000082, 60.37555573100008],
              [26.32398522200009, 60.38300202000005],
              [26.31023196700005, 60.39940013200004],
              [26.299164259000065, 60.41592031500005],
              [26.290212436000047, 60.42332591400003],
              [26.27865644600007, 60.42914459800005],
              [26.262543165000068, 60.44098541900007],
              [26.245616082000083, 60.450873114000046],
              [26.23178144600007, 60.45062897300005],
              [26.229340040000068, 60.43842194200005],
              [26.242930535000085, 60.424261786000045],
              [26.273448113000086, 60.40216705900008],
              [26.178965691000087, 60.41063060100004],
              [26.17042076900009, 60.40965403900003],
              [26.150726759000065, 60.398504950000074],
              [26.142425977000073, 60.39598216400003],
              [26.13445071700005, 60.40281810100004],
              [26.094574415000068, 60.42332591400003],
              [26.06218509200005, 60.43227773600006],
              [26.049164259000065, 60.437486070000034],
              [26.013682488000086, 60.462591864000046],
              [25.98096764400009, 60.475775458000044],
              [25.94629967500009, 60.48419830900008],
              [25.917246941000087, 60.48541901200008],
              [25.917246941000087, 60.47797272300005],
              [25.971853061000047, 60.464911200000074],
              [25.982595248000052, 60.45807526200008],
              [26.003754102000073, 60.44049713700008],
              [26.02898196700005, 60.43333567900004],
              [26.03614342500009, 60.42475006700005],
              [26.039317254000082, 60.414496161000045],
              [26.04004967500009, 60.405951239000046],
              [26.032481316000087, 60.40062083500004],
              [26.017425977000073, 60.401678778000075],
              [26.00684655000009, 60.40053945500006],
              [26.01221764400009, 60.38857656500005],
              [26.02320397200009, 60.38068268400008],
              [26.060557488000086, 60.36810944200005],
              [26.079600457000083, 60.35040924700007],
              [26.088633660000085, 60.34393952000005],
              [26.101410352000073, 60.34137604400007],
              [26.108164910000085, 60.335923570000034],
              [26.10645592500009, 60.32404205900008],
              [26.099864129000082, 60.31207916900007],
              [26.091319207000083, 60.306626695000034],
              [26.04004967500009, 60.29979075700004],
              [26.03882897200009, 60.32265859600005],
              [25.99708092500009, 60.35492584800005],
              [26.005869988000086, 60.36810944200005],
              [25.99350019600007, 60.36782461100006],
              [25.98487389400009, 60.36310455900008],
              [25.977305535000085, 60.35773346600007],
              [25.968028191000087, 60.35504791900007],
              [25.956553582000083, 60.35602448100008],
              [25.94776451900009, 60.35887278900003],
              [25.88835696700005, 60.38914622600004],
              [25.867198113000086, 60.39704010600008],
              [25.842051629000082, 60.40216705900008],
              [25.877696160000085, 60.37791575700004],
              [25.899099155000044, 60.367254950000074],
              [25.917246941000087, 60.36127350500004],
              [25.90723717500009, 60.34096914300005],
              [25.884287957000083, 60.320013739000046],
              [25.883067254000082, 60.306626695000034],
              [25.892425977000073, 60.29157135600008],
              [25.92123457100007, 60.265285549000055],
              [25.93018639400009, 60.24518463700008],
              [25.909353061000047, 60.246161200000074],
              [25.894867384000065, 60.24957916900007],
              [25.882660352000073, 60.255926825000074],
              [25.86882571700005, 60.265692450000074],
              [25.876231316000087, 60.27252838700008],
              [25.86101321700005, 60.28400299700007],
              [25.84148196700005, 60.28774648600006],
              [25.820323113000086, 60.28888580900008],
              [25.80054772200009, 60.292954820000034],
              [25.770355665000068, 60.314154364000046],
              [25.753754102000073, 60.320746161000045],
              [25.739024285000085, 60.31346263200004],
              [25.745371941000087, 60.295803127000056],
              [25.78093509200005, 60.28266022300005],
              [25.848887566000087, 60.265692450000074],
              [25.780528191000087, 60.25141022300005],
              [25.780528191000087, 60.24518463700008],
              [25.761973504000082, 60.24038320500006],
              [25.735524936000047, 60.247259833000044],
              [25.655772332000083, 60.293036200000074],
              [25.649668816000087, 60.29979075700004],
              [25.65088951900009, 60.31346263200004],
              [25.658539259000065, 60.32273997600004],
              [25.670583530000044, 60.327460028000075],
              [25.649668816000087, 60.33392975500004],
              [25.649668816000087, 60.34137604400007],
              [25.704356316000087, 60.34137604400007],
              [25.690196160000085, 60.36286041900007],
              [25.668630405000044, 60.36465078300006],
              [25.646006707000083, 60.356350002000056],
              [25.629161004000082, 60.34760163000004],
              [25.602712436000047, 60.33856842700004],
              [25.526133660000085, 60.32709381700005],
              [25.526133660000085, 60.32094961100006],
              [25.541270379000082, 60.31635163000004],
              [25.54656009200005, 60.305853583000044],
              [25.545095248000052, 60.292303778000075],
              [25.54037519600007, 60.27871328300006],
              [25.535899285000085, 60.27570221600007],
              [25.528819207000083, 60.27448151200008],
              [25.522227410000085, 60.27138906500005],
              [25.516856316000087, 60.25454336100006],
              [25.510915561000047, 60.249212958000044],
              [25.502777540000068, 60.246161200000074],
              [25.361664259000065, 60.24518463700008],
              [25.363454623000052, 60.26007721600007],
              [25.35092207100007, 60.267238674000055],
              [25.31381269600007, 60.27252838700008],
              [25.31617272200009, 60.26788971600007],
              [25.319509311000047, 60.256293036000045],
              [25.32129967500009, 60.25141022300005],
              [25.290537957000083, 60.24591705900008],
              [25.197520379000082, 60.24518463700008],
              [25.192149285000085, 60.243841864000046],
              [25.19044030000009, 60.24005768400008],
              [25.190928582000083, 60.22846100500004],
              [25.190277540000068, 60.227769273000035],
              [25.185801629000082, 60.22313060100004],
              [25.174164259000065, 60.22540924700007],
              [25.156260613000086, 60.23216380400004],
              [25.155039910000085, 60.22378164300005],
              [25.191254102000073, 60.21234772300005],
              [25.203949415000068, 60.20425039300005],
              [25.19467207100007, 60.200832424000055],
              [25.18140709700009, 60.200506903000075],
              [25.197113477000073, 60.190619208000044],
              [25.177012566000087, 60.183294989000046],
              [25.117035352000073, 60.17572663000004],
              [25.09473717500009, 60.17633698100008],
              [25.09742272200009, 60.18341705900008],
              [25.09896894600007, 60.18650950700004],
              [25.101573113000086, 60.190619208000044],
              [25.058604363000086, 60.17731354400007],
              [25.04786217500009, 60.16889069200005],
              [25.06739342500009, 60.16266510600008],
              [25.06104576900009, 60.15656159100007],
              [25.045258009000065, 60.15680573100008],
              [25.029307488000086, 60.14785390800006],
              [25.01075280000009, 60.15135325700004],
              [24.997894727000073, 60.16266510600008],
              [25.01075280000009, 60.16986725500004],
              [25.021494988000086, 60.18398672100005],
              [25.02588951900009, 60.19944896000004],
              [25.019053582000083, 60.21108633000006],
              [24.998789910000085, 60.21283600500004],
              [24.984548373000052, 60.19944896000004],
              [24.961192254000082, 60.151556708000044],
              [24.95093834700009, 60.143459377000056],
              [24.86573326900009, 60.14012278900003],
              [24.845225457000083, 60.143744208000044],
              [24.834157748000052, 60.15582916900007],
              [24.870941602000073, 60.16168854400007],
              [24.86882571700005, 60.179754950000074],
              [24.842458530000044, 60.194647528000075],
              [24.806813998000052, 60.190619208000044],
              [24.827321811000047, 60.16266510600008],
              [24.812510613000086, 60.158270575000074],
              [24.785899285000085, 60.14622630400004],
              [24.772634311000047, 60.14215729400007],
              [24.720957879000082, 60.13841380400004],
              [24.687754754000082, 60.132513739000046],
              [24.679698113000086, 60.130113023000035],
              [24.673350457000083, 60.125433661000045],
              [24.671153191000087, 60.11823151200008],
              [24.67481530000009, 60.105536200000074],
              [24.670258009000065, 60.101223049000055],
              [24.656423373000052, 60.10097890800006],
              [24.649587436000047, 60.10956452000005],
              [24.64616946700005, 60.12091705900008],
              [24.64226321700005, 60.12909577000005],
              [24.63062584700009, 60.13629791900007],
              [24.569102410000085, 60.153998114000046],
              [24.55404707100007, 60.155951239000046],
              [24.549001498000052, 60.152777411000045],
              [24.560394727000073, 60.14215729400007],
              [24.57667076900009, 60.13523997600004],
              [24.59083092500009, 60.13222890800006],
              [24.596853061000047, 60.12726471600007],
              [24.58765709700009, 60.11481354400007],
              [24.57471764400009, 60.10773346600007],
              [24.560557488000086, 60.10455963700008],
              [24.548024936000047, 60.099676825000074],
              [24.54037519600007, 60.087551174000055],
              [24.608164910000085, 60.101223049000055],
              [24.602712436000047, 60.091782945000034],
              [24.59424889400009, 60.08494700700004],
              [24.57398522200009, 60.073919989000046],
              [24.594493035000085, 60.066473700000074],
              [24.594493035000085, 60.060248114000046],
              [24.52702884200005, 60.03534577000005],
              [24.48764082100007, 60.00580475500004],
              [24.46810957100007, 59.99640534100007],
              [24.445648634000065, 59.992254950000074],
              [24.416270379000082, 59.99135976800005],
              [24.42432701900009, 60.005072333000044],
              [24.452972852000073, 60.03774648600006],
              [24.464121941000087, 60.046576239000046],
              [24.446136915000068, 60.04751211100006],
              [24.42090905000009, 60.03546784100007],
              [24.37476647200009, 60.00495026200008],
              [24.36768639400009, 60.02204010600008],
              [24.350271030000044, 60.01654694200005],
              [24.32976321700005, 60.00336334800005],
              [24.312673373000052, 59.99750397300005],
              [24.319102410000085, 60.01414622600004],
              [24.33057701900009, 60.02167389500005],
              [24.34424889400009, 60.02680084800005],
              [24.357676629000082, 60.036037502000056],
              [24.36036217500009, 60.04311758000006],
              [24.359711134000065, 60.051988023000035],
              [24.360850457000083, 60.06240469000005],
              [24.367930535000085, 60.073919989000046],
              [24.31967207100007, 60.075832424000055],
              [24.29590905000009, 60.07221100500004],
              [24.278575066000087, 60.060248114000046],
              [24.292246941000087, 60.052801825000074],
              [24.26107832100007, 60.04157135600008],
              [24.25245201900009, 60.03974030200004],
              [24.239024285000085, 60.03937409100007],
              [24.203949415000068, 60.046576239000046],
              [24.176524285000085, 60.048041083000044],
              [24.158457879000082, 60.043036200000074],
              [24.15796959700009, 60.034491278000075],
              [24.18295332100007, 60.025458075000074],
              [24.164235873000052, 60.01943594000005],
              [24.147715691000087, 60.02195872600004],
              [24.13184655000009, 60.02798086100006],
              [24.114756707000083, 60.03229401200008],
              [24.10596764400009, 60.03192780200004],
              [24.06812584700009, 60.02057526200008],
              [24.05836022200009, 60.020412502000056],
              [24.046397332000083, 60.025458075000074],
              [24.028168165000068, 60.00934479400007],
              [24.009613477000073, 60.01056549700007],
              [24.002614780000044, 60.02098216400003],
              [24.01921634200005, 60.03229401200008],
              [24.01921634200005, 60.03974030200004],
              [24.000824415000068, 60.038275458000044],
              [23.990244988000086, 60.03156159100007],
              [23.981944207000083, 60.02195872600004],
              [23.970713738000086, 60.011786200000074],
              [23.955332879000082, 60.003566799000055],
              [23.940684441000087, 59.999335028000075],
              [23.873057488000086, 59.993068752000056],
              [23.799489780000044, 59.95661041900007],
              [23.77125084700009, 59.967962958000044],
              [23.607595248000052, 59.95661041900007],
              [23.594493035000085, 59.96112702000005],
              [23.583832227000073, 59.97333405200004],
              [23.573496941000087, 59.97768789300005],
              [23.56185957100007, 59.97760651200008],
              [23.49545332100007, 59.968085028000075],
              [23.452972852000073, 59.95726146000004],
              [23.42945397200009, 59.95661041900007],
              [23.440603061000047, 59.97182851800005],
              [23.483571811000047, 60.01129791900007],
              [23.498301629000082, 60.01927317900004],
              [23.52711022200009, 60.02383047100005],
              [23.540863477000073, 60.02912018400008],
              [23.54273522200009, 60.036037502000056],
              [23.53614342500009, 60.044989325000074],
              [23.534353061000047, 60.05369700700004],
              [23.537364129000082, 60.06305573100008],
              [23.546153191000087, 60.073919989000046],
              [23.509613477000073, 60.06745026200008],
              [23.498301629000082, 60.06329987200007],
              [23.490244988000086, 60.05548737200007],
              [23.48568769600007, 60.04515208500004],
              [23.478770379000082, 60.03611888200004],
              [23.46387780000009, 60.03229401200008],
              [23.453786655000044, 60.02798086100006],
              [23.449392123000052, 60.017564195000034],
              [23.446055535000085, 60.005113023000035],
              [23.439707879000082, 59.99445221600007],
              [23.43018639400009, 59.98867422100005],
              [23.40796959700009, 59.98041413000004],
              [23.398692254000082, 59.974269924000055],
              [23.36500084700009, 59.945379950000074],
              [23.326426629000082, 59.923041083000044],
              [23.237152540000068, 59.89801666900007],
              [23.22234134200005, 59.88621653900003],
              [23.222178582000083, 59.86782461100006],
              [23.233164910000085, 59.851996161000045],
              [23.25131269600007, 59.84796784100007],
              [23.25131269600007, 59.841131903000075],
              [23.08057701900009, 59.82684967700004],
              [23.06812584700009, 59.82078685100004],
              [23.00684655000009, 59.826157945000034],
              [22.983897332000083, 59.82371653900003],
              [22.964854363000086, 59.81830475500004],
              [22.905121290000068, 59.81122467700004],
              [22.888194207000083, 59.81317780200004],
              [22.90601647200009, 59.819647528000075],
              [22.93140709700009, 59.84284088700008],
              [22.946136915000068, 59.84796784100007],
              [22.986582879000082, 59.85195547100005],
              [23.12745201900009, 59.886379299000055],
              [23.168142123000052, 59.88890208500004],
              [23.16114342500009, 59.910223700000074],
              [23.165863477000073, 59.917669989000046],
              [23.17709394600007, 59.91742584800005],
              [23.18921959700009, 59.91559479400007],
              [23.22242272200009, 59.916083075000074],
              [23.24708092500009, 59.92243073100008],
              [23.26889082100007, 59.93622467700004],
              [23.293711785000085, 59.958685614000046],
              [23.30909264400009, 59.97943756700005],
              [23.326426629000082, 60.00934479400007],
              [23.332855665000068, 60.02985260600008],
              [23.315928582000083, 60.02240631700005],
              [23.24976647200009, 59.948472398000035],
              [23.223399285000085, 59.92987702000005],
              [23.20362389400009, 59.92987702000005],
              [23.205088738000086, 59.93317291900007],
              [23.207286004000082, 59.93976471600007],
              [23.209727410000085, 59.94354889500005],
              [23.19971764400009, 59.94818756700005],
              [23.18881269600007, 59.95018138200004],
              [23.178070509000065, 59.948919989000046],
              [23.168142123000052, 59.94354889500005],
              [23.17123457100007, 59.936428127000056],
              [23.13184655000009, 59.94293854400007],
              [23.120941602000073, 59.933579820000034],
              [23.117849155000044, 59.92377350500004],
              [23.11068769600007, 59.92328522300005],
              [23.103688998000052, 59.929673570000034],
              [23.10059655000009, 59.94041575700004],
              [23.11068769600007, 59.97028229400007],
              [23.111338738000086, 59.974269924000055],
              [23.128184441000087, 59.98309967700004],
              [23.20362389400009, 59.99750397300005],
              [23.217946811000047, 60.00836823100008],
              [23.241384311000047, 60.03310781500005],
              [23.25757897200009, 60.03974030200004],
              [23.205088738000086, 60.049709377000056],
              [23.106211785000085, 60.039048570000034],
              [23.059418165000068, 60.03974030200004],
              [23.035492384000065, 60.044582424000055],
              [23.01335696700005, 60.05158112200007],
              [22.996918165000068, 60.06207916900007],
              [22.99073326900009, 60.077337958000044],
              [22.997243686000047, 60.08966705900008],
              [23.012868686000047, 60.10175202000005],
              [23.04590905000009, 60.12164948100008],
              [23.025401238000086, 60.13532135600008],
              [23.019867384000065, 60.12881094000005],
              [23.00879967500009, 60.11200592700004],
              [23.00489342500009, 60.10736725500004],
              [22.996755405000044, 60.10370514500005],
              [22.97787519600007, 60.09878164300005],
              [22.969493035000085, 60.09438711100006],
              [22.968272332000083, 60.11082591400003],
              [22.95866946700005, 60.12156810100004],
              [22.942556186000047, 60.127386786000045],
              [22.90788821700005, 60.13178131700005],
              [22.886973504000082, 60.14492422100005],
              [22.87468509200005, 60.149603583000044],
              [22.884776238000086, 60.159857489000046],
              [22.885590040000068, 60.16933828300006],
              [22.879161004000082, 60.17747630400004],
              [22.867198113000086, 60.18374258000006],
              [22.92156009200005, 60.23114655200004],
              [22.942881707000083, 60.24518463700008],
              [23.00757897200009, 60.277004299000055],
              [23.025401238000086, 60.292954820000034],
              [23.031260613000086, 60.30263906500005],
              [23.03809655000009, 60.31915924700007],
              [23.04590905000009, 60.32709381700005],
              [23.072520379000082, 60.33869049700007],
              [23.082855665000068, 60.34589264500005],
              [23.08057701900009, 60.35504791900007],
              [23.06031334700009, 60.35732656500005],
              [23.03419030000009, 60.34393952000005],
              [23.010590040000068, 60.32396067900004],
              [22.998057488000086, 60.306626695000034],
              [22.94117272200009, 60.316473700000074],
              [22.877126498000052, 60.30109284100007],
              [22.736175977000073, 60.23818594000005],
              [22.611175977000073, 60.219956773000035],
              [22.553396030000044, 60.20502350500004],
              [22.52507571700005, 60.20425039300005],
              [22.539805535000085, 60.21356842700004],
              [22.59343509200005, 60.23216380400004],
              [22.573496941000087, 60.23493073100008],
              [22.57203209700009, 60.24266185100004],
              [22.59034264400009, 60.26227448100008],
              [22.601084832000083, 60.26821523600006],
              [22.64812259200005, 60.27871328300006],
              [22.598399285000085, 60.27578359600005],
              [22.574554884000065, 60.270819403000075],
              [22.527354363000086, 60.25214264500005],
              [22.50359134200005, 60.24705638200004],
              [22.449473504000082, 60.24518463700008],
              [22.457774285000085, 60.252386786000045],
              [22.459239129000082, 60.25873444200005],
              [22.459157748000052, 60.264960028000075],
              [22.463063998000052, 60.27252838700008],
              [22.469411655000044, 60.27692291900007],
              [22.487478061000047, 60.28497955900008],
              [22.50879967500009, 60.30109284100007],
              [22.540293816000087, 60.31899648600006],
              [22.545664910000085, 60.33392975500004],
              [22.596364780000044, 60.36367422100005],
              [22.627614780000044, 60.37539297100005],
              [22.63135826900009, 60.389553127000056],
              [22.624278191000087, 60.39907461100006],
              [22.580821160000085, 60.37592194200005],
              [22.54346764400009, 60.37254466400003],
              [22.463063998000052, 60.37555573100008],
              [22.483571811000047, 60.40216705900008],
              [22.326182488000086, 60.38239166900007],
              [22.29151451900009, 60.38263580900008],
              [22.280121290000068, 60.38646067900004],
              [22.249522332000083, 60.40460846600007],
              [22.181488477000073, 60.43048737200007],
              [22.16114342500009, 60.43463776200008],
              [22.116709832000083, 60.43695709800005],
              [22.11101321700005, 60.44407786700003],
              [22.108164910000085, 60.45685455900008],
              [22.101084832000083, 60.462144273000035],
              [22.082692905000044, 60.44721100500004],
              [22.064463738000086, 60.43634674700007],
              [22.047048373000052, 60.438788153000075],
              [22.01807701900009, 60.457464911000045],
              [22.017425977000073, 60.45990631700005],
              [22.01856530000009, 60.46869538000004],
              [22.01807701900009, 60.471136786000045],
              [22.01343834700009, 60.47174713700008],
              [22.00171959700009, 60.47011953300006],
              [21.997569207000083, 60.471136786000045],
              [21.989024285000085, 60.47516510600008],
              [21.981944207000083, 60.47675202000005],
              [21.979177280000044, 60.48078034100007],
              [21.983897332000083, 60.492254950000074],
              [21.935394727000073, 60.492254950000074],
              [21.939707879000082, 60.499212958000044],
              [21.945648634000065, 60.51203034100007],
              [21.950368686000047, 60.51894765800006],
              [21.931651238000086, 60.52496979400007],
              [21.903168165000068, 60.52887604400007],
              [21.87403405000009, 60.52952708500004],
              [21.853526238000086, 60.52578359600005],
              [21.843923373000052, 60.51552969000005],
              [21.848480665000068, 60.50372955900008],
              [21.87403405000009, 60.47797272300005],
              [21.82862389400009, 60.48541901200008],
              [21.80600019600007, 60.485988674000055],
              [21.785329623000052, 60.47797272300005],
              [21.78956139400009, 60.49510325700004],
              [21.802989129000082, 60.52513255400004],
              [21.80567467500009, 60.54682038000004],
              [21.805349155000044, 60.56195709800005],
              [21.807871941000087, 60.57558828300006],
              [21.819590691000087, 60.58502838700008],
              [21.846039259000065, 60.58783600500004],
              [21.833262566000087, 60.59650299700007],
              [21.828461134000065, 60.60639069200005],
              [21.830902540000068, 60.61713288000004],
              [21.840505405000044, 60.62872955900008],
              [21.77393639400009, 60.603949286000045],
              [21.754242384000065, 60.59096914300005],
              [21.73178144600007, 60.581732489000046],
              [21.678965691000087, 60.57648346600007],
              [21.66179446700005, 60.56732819200005],
              [21.660166863000086, 60.55906810100004],
              [21.66895592500009, 60.54523346600007],
              [21.664805535000085, 60.536322333000044],
              [21.65870201900009, 60.53034088700008],
              [21.65560957100007, 60.52594635600008],
              [21.654470248000052, 60.51984284100007],
              [21.654307488000086, 60.508978583000044],
              [21.641449415000068, 60.495754299000055],
              [21.612071160000085, 60.48883698100008],
              [21.57984459700009, 60.48786041900007],
              [21.558116082000083, 60.492254950000074],
              [21.58375084700009, 60.50503164300005],
              [21.56967207100007, 60.52643463700008],
              [21.517751498000052, 60.56732819200005],
              [21.533457879000082, 60.568060614000046],
              [21.57862389400009, 60.559881903000075],
              [21.57862389400009, 60.56732819200005],
              [21.555023634000065, 60.57217031500005],
              [21.48609459700009, 60.57416413000004],
              [21.454600457000083, 60.567694403000075],
              [21.442637566000087, 60.56732819200005],
              [21.434336785000085, 60.56989166900007],
              [21.41846764400009, 60.57843659100007],
              [21.408539259000065, 60.58038971600007],
              [21.408539259000065, 60.58783600500004],
              [21.41504967500009, 60.58844635600008],
              [21.419444207000083, 60.589911200000074],
              [21.428396030000044, 60.59406159100007],
              [21.414805535000085, 60.608303127000056],
              [21.445160352000073, 60.60219961100006],
              [21.46265709700009, 60.60175202000005],
              [21.469981316000087, 60.608303127000056],
              [21.42156009200005, 60.62872955900008],
              [21.399912957000083, 60.634100653000075],
              [21.379649285000085, 60.64704010600008],
              [21.36304772200009, 60.66278717700004],
              [21.35328209700009, 60.67658112200007],
              [21.35401451900009, 60.681708075000074],
              [21.355804884000065, 60.682928778000075],
              [21.356211785000085, 60.68439362200007],
              [21.35328209700009, 60.69017161700003],
              [21.425954623000052, 60.67963288000004],
              [21.438975457000083, 60.68032461100006],
              [21.445648634000065, 60.69285716400003],
              [21.440928582000083, 60.70302969000005],
              [21.431162957000083, 60.712958075000074],
              [21.422129754000082, 60.72500234600005],
              [21.469981316000087, 60.72500234600005],
              [21.469981316000087, 60.73114655200004],
              [21.448496941000087, 60.73224518400008],
              [21.42709394600007, 60.73651764500005],
              [21.406504754000082, 60.743475653000075],
              [21.387380405000044, 60.75234609600005],
              [21.40333092500009, 60.758246161000045],
              [21.411631707000083, 60.75967031500005],
              [21.422129754000082, 60.759100653000075],
              [21.400238477000073, 60.77456289300005],
              [21.38770592500009, 60.77924225500004],
              [21.374278191000087, 60.77960846600007],
              [21.380869988000086, 60.793402411000045],
              [21.374278191000087, 60.80760325700004],
              [21.360850457000083, 60.81622955900008],
              [21.346446160000085, 60.81313711100006],
              [21.339040561000047, 60.81712474200003],
              [21.333262566000087, 60.82184479400007],
              [21.328868035000085, 60.82754140800006],
              [21.32593834700009, 60.834865627000056],
              [21.33643639400009, 60.84471263200004],
              [21.318532748000052, 60.86469147300005],
              [21.33253014400009, 60.868353583000044],
              [21.382334832000083, 60.86318594000005],
              [21.40788821700005, 60.864569403000075],
              [21.428396030000044, 60.87579987200007],
              [21.41732832100007, 60.88031647300005],
              [21.40593509200005, 60.882025458000044],
              [21.380869988000086, 60.882025458000044],
              [21.373708530000044, 60.88458893400008],
              [21.35328209700009, 60.90253327000005],
              [21.36378014400009, 60.90485260600008],
              [21.381683790000068, 60.91461823100008],
              [21.390798373000052, 60.91681549700007],
              [21.399668816000087, 60.914048570000034],
              [21.407399936000047, 60.908270575000074],
              [21.416188998000052, 60.903225002000056],
              [21.428396030000044, 60.90253327000005],
              [21.422211134000065, 60.91290924700007],
              [21.417816602000073, 60.92430247600004],
              [21.412771030000044, 60.93349844000005],
              [21.404470248000052, 60.93724192900004],
              [21.392588738000086, 60.93903229400007],
              [21.387868686000047, 60.94367096600007],
              [21.385508660000085, 60.95026276200008],
              [21.38054446700005, 60.95770905200004],
              [21.33570397200009, 61.00458405200004],
              [21.318532748000052, 61.01235586100006],
              [21.332855665000068, 61.02391185100004],
              [21.339040561000047, 61.026597398000035],
              [21.31153405000009, 61.037543036000045],
              [21.30209394600007, 61.04604726800005],
              [21.298675977000073, 61.06012604400007],
              [21.320323113000086, 61.060207424000055],
              [21.36426842500009, 61.04474518400008],
              [21.387380405000044, 61.040269273000035],
              [21.408864780000044, 61.04328034100007],
              [21.408132358000046, 61.048163153000075],
              [21.407725457000083, 61.05072663000004],
              [21.391368035000085, 61.057928778000075],
              [21.36695397200009, 61.06012604400007],
              [21.395274285000085, 61.06940338700008],
              [21.453868035000085, 61.05499909100007],
              [21.482269727000073, 61.06012604400007],
              [21.468272332000083, 61.066839911000045],
              [21.45484459700009, 61.078192450000074],
              [21.450450066000087, 61.09076569200005],
              [21.463145379000082, 61.10114166900007],
              [21.452403191000087, 61.12523021000004],
              [21.446055535000085, 61.13515859600005],
              [21.43523196700005, 61.14272695500006],
              [21.44507897200009, 61.14305247600004],
              [21.469981316000087, 61.14956289300005],
              [21.46265709700009, 61.14935944200005],
              [21.455821160000085, 61.15021393400008],
              [21.449066602000073, 61.152329820000034],
              [21.442637566000087, 61.15574778900003],
              [21.456309441000087, 61.169989325000074],
              [21.442637566000087, 61.169989325000074],
              [21.455821160000085, 61.17617422100005],
              [21.471039259000065, 61.178168036000045],
              [21.503428582000083, 61.177435614000046],
              [21.498871290000068, 61.18744538000004],
              [21.49659264400009, 61.191107489000046],
              [21.526621941000087, 61.19969310100004],
              [21.558116082000083, 61.20416901200008],
              [21.54346764400009, 61.22508372600004],
              [21.524099155000044, 61.23460521000004],
              [21.476084832000083, 61.245754299000055],
              [21.485606316000087, 61.25617096600007],
              [21.49935957100007, 61.261053778000075],
              [21.50831139400009, 61.266831773000035],
              [21.503428582000083, 61.27985260600008],
              [21.544444207000083, 61.27985260600008],
              [21.544444207000083, 61.28729889500005],
              [21.54200280000009, 61.29271067900004],
              [21.544444207000083, 61.31077708500004],
              [21.544444207000083, 61.32086823100008],
              [21.54200280000009, 61.32689036700003],
              [21.53419030000009, 61.32949453300006],
              [21.530772332000083, 61.33445872600004],
              [21.529958530000044, 61.34052155200004],
              [21.53174889400009, 61.349676825000074],
              [21.530772332000083, 61.35496653900003],
              [21.524261915000068, 61.37531159100007],
              [21.518402540000068, 61.38157786700003],
              [21.503428582000083, 61.389105536000045],
              [21.490082227000073, 61.39325592700004],
              [21.462087436000047, 61.398423570000034],
              [21.44890384200005, 61.402777411000045],
              [21.47787519600007, 61.41156647300005],
              [21.541677280000044, 61.40839264500005],
              [21.572438998000052, 61.41640859600005],
              [21.557871941000087, 61.43121979400007],
              [21.542246941000087, 61.44212474200003],
              [21.51026451900009, 61.45799388200004],
              [21.442067905000044, 61.475043036000045],
              [21.422129754000082, 61.48533763200004],
              [21.55567467500009, 61.47516510600008],
              [21.592133009000065, 61.48533763200004],
              [21.571136915000068, 61.514105536000045],
              [21.565603061000047, 61.51947663000004],
              [21.550954623000052, 61.52179596600007],
              [21.524261915000068, 61.51740143400008],
              [21.51026451900009, 61.51947663000004],
              [21.469981316000087, 61.54682038000004],
              [21.46192467500009, 61.55776601800005],
              [21.460134311000047, 61.56240469000005],
              [21.46648196700005, 61.564439195000034],
              [21.482269727000073, 61.56785716400003],
              [21.507985873000052, 61.57013580900008],
              [21.623383009000065, 61.54588450700004],
              [21.68685957100007, 61.52448151200008],
              [21.716319207000083, 61.51947663000004],
              [21.716319207000083, 61.52692291900007],
              [21.64812259200005, 61.56028880400004],
              [21.61426842500009, 61.58543528900003],
              [21.591807488000086, 61.628119208000044],
              [21.57325280000009, 61.63556549700007],
              [21.55250084700009, 61.64077383000006],
              [21.53760826900009, 61.64984772300005],
              [21.53614342500009, 61.65802643400008],
              [21.544118686000047, 61.67283763200004],
              [21.541026238000086, 61.68024323100008],
              [21.517751498000052, 61.705064195000034],
              [21.517751498000052, 61.71124909100007],
              [21.536306186000047, 61.708197333000044],
              [21.570323113000086, 61.695013739000046],
              [21.585948113000086, 61.69765859600005],
              [21.559336785000085, 61.713324286000045],
              [21.48926842500009, 61.73696523600006],
              [21.469981316000087, 61.75971100500004],
              [21.472666863000086, 61.771918036000045],
              [21.481944207000083, 61.785589911000045],
              [21.489024285000085, 61.79913971600007],
              [21.48609459700009, 61.81118398600006],
              [21.472504102000073, 61.816839911000045],
              [21.45557701900009, 61.819973049000055],
              [21.444590691000087, 61.82632070500006],
              [21.44890384200005, 61.84162018400008],
              [21.41846764400009, 61.862534898000035],
              [21.403168165000068, 61.87641022300005],
              [21.39421634200005, 61.88939036700003],
              [21.403575066000087, 61.89313385600008],
              [21.411957227000073, 61.900091864000046],
              [21.414073113000086, 61.90688711100006],
              [21.39356530000009, 61.91323476800005],
              [21.389496290000068, 61.921128648000035],
              [21.38721764400009, 61.93040599200003],
              [21.38054446700005, 61.93781159100007],
              [21.371429884000065, 61.939113674000055],
              [21.325694207000083, 61.93781159100007],
              [21.316742384000065, 61.93919505400004],
              [21.312510613000086, 61.93984609600005],
              [21.290212436000047, 61.948919989000046],
              [21.277517123000052, 61.95148346600007],
              [21.294932488000086, 61.97134023600006],
              [21.280528191000087, 61.97955963700008],
              [21.236582879000082, 61.98501211100006],
              [21.276215040000068, 62.05019765800006],
              [21.284353061000047, 62.07493724200003],
              [21.289073113000086, 62.12156810100004],
              [21.296397332000083, 62.13043854400007],
              [21.31226647200009, 62.10911692900004],
              [21.32911217500009, 62.13812897300005],
              [21.33253014400009, 62.15257396000004],
              [21.32593834700009, 62.163763739000046],
              [21.34034264400009, 62.17572663000004],
              [21.371104363000086, 62.18646881700005],
              [21.383962436000047, 62.19448476800005],
              [21.389903191000087, 62.20815664300005],
              [21.380869988000086, 62.21784088700008],
              [21.35328209700009, 62.23200104400007],
              [21.374278191000087, 62.266791083000044],
              [21.352305535000085, 62.26601797100005],
              [21.340017123000052, 62.255194403000075],
              [21.329356316000087, 62.241441148000035],
              [21.31226647200009, 62.23200104400007],
              [21.31617272200009, 62.24823639500005],
              [21.328461134000065, 62.27716705900008],
              [21.332774285000085, 62.29409414300005],
              [21.333506707000083, 62.34056224200003],
              [21.339040561000047, 62.355536200000074],
              [21.285329623000052, 62.34528229400007],
              [21.270681186000047, 62.349310614000046],
              [21.262461785000085, 62.35919830900008],
              [21.260427280000044, 62.371975002000056],
              [21.26531009200005, 62.385199286000045],
              [21.277517123000052, 62.396470445000034],
              [21.270681186000047, 62.41079336100006],
              [21.205088738000086, 62.35968659100007],
              [21.202403191000087, 62.34918854400007],
              [21.216075066000087, 62.33502838700008],
              [21.19434655000009, 62.33706289300005],
              [21.189789259000065, 62.352443752000056],
              [21.19507897200009, 62.37287018400008],
              [21.202403191000087, 62.390326239000046],
              [21.196543816000087, 62.391506252000056],
              [21.187022332000083, 62.39524974200003],
              [21.18132571700005, 62.396470445000034],
              [21.189463738000086, 62.40839264500005],
              [21.194590691000087, 62.41323476800005],
              [21.202403191000087, 62.417629299000055],
              [21.18604576900009, 62.42357005400004],
              [21.166758660000085, 62.42133209800005],
              [21.14779707100007, 62.41380442900004],
              [21.133555535000085, 62.403957424000055],
              [21.13135826900009, 62.41669342700004],
              [21.149180535000085, 62.44708893400008],
              [21.154551629000082, 62.46478913000004],
              [21.136973504000082, 62.45799388200004],
              [21.124278191000087, 62.45482005400004],
              [21.116384311000047, 62.460150458000044],
              [21.11304772200009, 62.47842031500005],
              [21.115570509000065, 62.495794989000046],
              [21.124278191000087, 62.50999583500004],
              [21.137868686000047, 62.520697333000044],
              [21.154551629000082, 62.52749258000006],
              [21.148773634000065, 62.53554922100005],
              [21.12671959700009, 62.55414459800005],
              [21.146820509000065, 62.56281159100007],
              [21.16732832100007, 62.57575104400007],
              [21.188161655000044, 62.584865627000056],
              [21.209239129000082, 62.582098700000074],
              [21.193532748000052, 62.600897528000075],
              [21.12159264400009, 62.609442450000074],
              [21.106211785000085, 62.623032945000034],
              [21.094086134000065, 62.61945221600007],
              [21.083262566000087, 62.61269765800006],
              [21.065196160000085, 62.595770575000074],
              [21.067881707000083, 62.62010325700004],
              [21.083181186000047, 62.65924713700008],
              [21.078949415000068, 62.67829010600008],
              [21.098887566000087, 62.680894273000035],
              [21.125743035000085, 62.69017161700003],
              [21.149668816000087, 62.70380280200004],
              [21.160817905000044, 62.71930573100008],
              [21.160166863000086, 62.730169989000046],
              [21.15560957100007, 62.731756903000075],
              [21.148610873000052, 62.73041413000004],
              [21.14039147200009, 62.73289622600004],
              [21.12281334700009, 62.74371979400007],
              [21.116465691000087, 62.749660549000055],
              [21.10792076900009, 62.76703522300005],
              [21.113536004000082, 62.78119538000004],
              [21.129079623000052, 62.79083893400008],
              [21.15088951900009, 62.79437897300005],
              [21.171071811000047, 62.78461334800005],
              [21.18336022200009, 62.78237539300005],
              [21.18881269600007, 62.790676174000055],
              [21.192230665000068, 62.79291413000004],
              [21.209646030000044, 62.80760325700004],
              [21.216075066000087, 62.81484609600005],
              [21.221934441000087, 62.83104075700004],
              [21.222666863000086, 62.84564850500004],
              [21.226735873000052, 62.85846588700008],
              [21.243418816000087, 62.86945221600007],
              [21.267425977000073, 62.86904531500005],
              [21.33570397200009, 62.855454820000034],
              [21.356700066000087, 62.85952383000006],
              [21.36426842500009, 62.86542389500005],
              [21.382823113000086, 62.87457916900007],
              [21.390798373000052, 62.88031647300005],
              [21.39551842500009, 62.88735586100006],
              [21.399668816000087, 62.90070221600007],
              [21.40919030000009, 62.91380442900004],
              [21.420095248000052, 62.934881903000075],
              [21.422129754000082, 62.94179922100005],
              [21.42750084700009, 62.94403717700004],
              [21.463145379000082, 62.95140208500004],
              [21.446543816000087, 62.98700592700004],
              [21.44271894600007, 63.005072333000044],
              [21.442637566000087, 63.02708567900004],
              [21.441742384000065, 63.034369208000044],
              [21.44076582100007, 63.03778717700004],
              [21.444102410000085, 63.04092031500005],
              [21.456309441000087, 63.04755280200004],
              [21.467051629000082, 63.04791901200008],
              [21.475271030000044, 63.043036200000074],
              [21.480479363000086, 63.043036200000074],
              [21.482269727000073, 63.05817291900007],
              [21.49512780000009, 63.07172272300005],
              [21.523448113000086, 63.06395091400003],
              [21.565196160000085, 63.04075755400004],
              [21.59546959700009, 63.034857489000046],
              [21.625743035000085, 63.023871161000045],
              [21.65674889400009, 63.01788971600007],
              [21.68848717500009, 63.02708567900004],
              [21.645681186000047, 63.05524323100008],
              [21.57911217500009, 63.08372630400004],
              [21.55958092500009, 63.09511953300006],
              [21.55323326900009, 63.108587958000044],
              [21.572438998000052, 63.12335846600007],
              [21.560069207000083, 63.11969635600008],
              [21.54590905000009, 63.11790599200003],
              [21.531993035000085, 63.11969635600008],
              [21.52084394600007, 63.12677643400008],
              [21.516774936000047, 63.137600002000056],
              [21.517832879000082, 63.14801666900007],
              [21.51612389400009, 63.155462958000044],
              [21.503428582000083, 63.157456773000035],
              [21.510508660000085, 63.168402411000045],
              [21.522227410000085, 63.17206452000005],
              [21.551931186000047, 63.171128648000035],
              [21.551931186000047, 63.17792389500005],
              [21.512868686000047, 63.18500397300005],
              [21.50098717500009, 63.19245026200008],
              [21.49659264400009, 63.208970445000034],
              [21.50489342500009, 63.21743398600006],
              [21.523773634000065, 63.22540924700007],
              [21.544444207000083, 63.23102448100008],
              [21.558116082000083, 63.23261139500005],
              [21.615407748000052, 63.20392487200007],
              [21.647227410000085, 63.19765859600005],
              [21.667979363000086, 63.21954987200007],
              [21.68799889400009, 63.210191148000035],
              [21.714691602000073, 63.202337958000044],
              [21.742360873000052, 63.199652411000045],
              [21.76417076900009, 63.20587799700007],
              [21.74903405000009, 63.21088288000004],
              [21.717946811000047, 63.21531810100004],
              [21.702647332000083, 63.21954987200007],
              [21.702647332000083, 63.225775458000044],
              [21.743662957000083, 63.23940664300005],
              [21.758067254000082, 63.241522528000075],
              [21.798350457000083, 63.23940664300005],
              [21.82129967500009, 63.24371979400007],
              [21.869883660000085, 63.259426174000055],
              [21.894541863000086, 63.26048411700003],
              [21.88445071700005, 63.245428778000075],
              [21.882660352000073, 63.23590729400007],
              [21.891449415000068, 63.196600653000075],
              [21.889903191000087, 63.18817780200004],
              [21.880869988000086, 63.17792389500005],
              [21.905528191000087, 63.175441799000055],
              [21.983897332000083, 63.14321523600006],
              [21.972178582000083, 63.16498444200005],
              [21.955902540000068, 63.184759833000044],
              [21.98406009200005, 63.19122955900008],
              [21.994395379000082, 63.19643789300005],
              [22.00440514400009, 63.20587799700007],
              [22.010020379000082, 63.21576569200005],
              [22.012543165000068, 63.224310614000046],
              [22.015961134000065, 63.23200104400007],
              [22.02475019600007, 63.23940664300005],
              [22.043142123000052, 63.24559153900003],
              [22.053558790000068, 63.24091217700004],
              [22.061371290000068, 63.232123114000046],
              [22.07203209700009, 63.225775458000044],
              [22.08757571700005, 63.225775458000044],
              [22.114024285000085, 63.23627350500004],
              [22.127207879000082, 63.23940664300005],
              [22.139496290000068, 63.237982489000046],
              [22.15919030000009, 63.231756903000075],
              [22.175059441000087, 63.23261139500005],
              [22.18018639400009, 63.23550039300005],
              [22.181162957000083, 63.24005768400008],
              [22.180837436000047, 63.24445221600007],
              [22.181895379000082, 63.24681224200003],
              [22.18726647200009, 63.24640534100007],
              [22.19499759200005, 63.244126695000034],
              [22.201426629000082, 63.24135976800005],
              [22.202972852000073, 63.23940664300005],
              [22.24463951900009, 63.26707591400003],
              [22.266368035000085, 63.28534577000005],
              [22.278086785000085, 63.30145905200004],
              [22.28492272200009, 63.30145905200004],
              [22.30762780000009, 63.27586497600004],
              [22.330088738000086, 63.28384023600006],
              [22.352224155000044, 63.30560944200005],
              [22.373708530000044, 63.32135651200008],
              [22.363942905000044, 63.32689036700003],
              [22.35718834700009, 63.33421458500004],
              [22.346934441000087, 63.349269924000055],
              [22.333832227000073, 63.35968659100007],
              [22.305349155000044, 63.372707424000055],
              [22.255381707000083, 63.40643952000005],
              [22.25049889400009, 63.411322333000044],
              [22.23292076900009, 63.411810614000046],
              [22.218272332000083, 63.41437409100007],
              [22.205821160000085, 63.42031484600005],
              [22.195567254000082, 63.43121979400007],
              [22.190928582000083, 63.45844147300005],
              [22.21338951900009, 63.47089264500005],
              [22.246755405000044, 63.469631252000056],
              [22.274668816000087, 63.45571523600006],
              [22.304942254000082, 63.43585846600007],
              [22.335215691000087, 63.43040599200003],
              [22.36695397200009, 63.42829010600008],
              [22.401621941000087, 63.41815827000005],
              [22.318207227000073, 63.46051666900007],
              [22.279958530000044, 63.487616278000075],
              [22.27125084700009, 63.513739325000074],
              [22.281423373000052, 63.52619049700007],
              [22.292246941000087, 63.529730536000045],
              [22.31934655000009, 63.527411200000074],
              [22.337412957000083, 63.52334219000005],
              [22.337087436000047, 63.51361725500004],
              [22.331228061000047, 63.50234609600005],
              [22.33334394600007, 63.49323151200008],
              [22.355479363000086, 63.487494208000044],
              [22.38021894600007, 63.48541901200008],
              [22.396820509000065, 63.47695547100005],
              [22.394786004000082, 63.452337958000044],
              [22.407399936000047, 63.45693594000005],
              [22.423675977000073, 63.468003648000035],
              [22.435801629000082, 63.47280508000006],
              [22.435801629000082, 63.47955963700008],
              [22.428396030000044, 63.48875560100004],
              [22.431488477000073, 63.497381903000075],
              [22.438649936000047, 63.50653717700004],
              [22.442637566000087, 63.51748281500005],
              [22.445485873000052, 63.51813385600008],
              [22.463063998000052, 63.554754950000074],
              [22.47242272200009, 63.561835028000075],
              [22.48373457100007, 63.566839911000045],
              [22.49317467500009, 63.573472398000035],
              [22.497243686000047, 63.58576080900008],
              [22.503428582000083, 63.587103583000044],
              [22.545664910000085, 63.57518138200004],
              [22.537771030000044, 63.58771393400008],
              [22.497243686000047, 63.62299225500004],
              [22.514414910000085, 63.635972398000035],
              [22.522227410000085, 63.640611070000034],
              [22.531993035000085, 63.64411041900007],
              [22.529470248000052, 63.65086497600004],
              [22.52784264400009, 63.65387604400007],
              [22.52507571700005, 63.65770091400003],
              [22.56739342500009, 63.65314362200007],
              [22.58570397200009, 63.65704987200007],
              [22.59343509200005, 63.67450592700004],
              [22.591075066000087, 63.69415924700007],
              [22.589040561000047, 63.70331452000005],
              [22.594086134000065, 63.704291083000044],
              [22.613291863000086, 63.699286200000074],
              [22.627777540000068, 63.68744538000004],
              [22.637054884000065, 63.68309153900003],
              [22.64112389400009, 63.68846263200004],
              [22.644867384000065, 63.698553778000075],
              [22.65406334700009, 63.70376211100006],
              [22.665212436000047, 63.704779364000046],
              [22.675303582000083, 63.702378648000035],
              [22.69076582100007, 63.693793036000045],
              [22.702321811000047, 63.68341705900008],
              [22.707041863000086, 63.67133209800005],
              [22.702647332000083, 63.65770091400003],
              [22.713226759000065, 63.64988841400003],
              [22.73406009200005, 63.62759023600006],
              [22.740489129000082, 63.62299225500004],
              [22.75521894600007, 63.62409088700008],
              [22.773448113000086, 63.62750885600008],
              [22.790537957000083, 63.63300202000005],
              [22.802256707000083, 63.640326239000046],
              [22.81023196700005, 63.643744208000044],
              [22.820485873000052, 63.644191799000055],
              [22.829274936000047, 63.64622630400004],
              [22.83301842500009, 63.654364325000074],
              [22.83301842500009, 63.661810614000046],
              [22.833506707000083, 63.667303778000075],
              [22.83570397200009, 63.67210521000004],
              [22.84034264400009, 63.67763906500005],
              [22.855479363000086, 63.687160549000055],
              [22.886973504000082, 63.69521719000005],
              [22.901866082000083, 63.705511786000045],
              [22.88526451900009, 63.71230703300006],
              [22.83301842500009, 63.72601959800005],
              [22.901866082000083, 63.72601959800005],
              [22.882090691000087, 63.74213288000004],
              [22.87468509200005, 63.746527411000045],
              [22.900401238000086, 63.74005768400008],
              [22.914724155000044, 63.73920319200005],
              [22.925791863000086, 63.743394273000035],
              [22.928477410000085, 63.74876536700003],
              [22.929860873000052, 63.75690338700008],
              [22.929209832000083, 63.76434967700004],
              [22.925791863000086, 63.767564195000034],
              [22.907725457000083, 63.77240631700005],
              [22.898773634000065, 63.783270575000074],
              [22.902517123000052, 63.79486725500004],
              [22.92237389400009, 63.80170319200005],
              [22.942881707000083, 63.800482489000046],
              [22.95484459700009, 63.79328034100007],
              [22.97315514400009, 63.77098216400003],
              [22.99000084700009, 63.76129791900007],
              [23.000661655000044, 63.76361725500004],
              [23.001800977000073, 63.77374909100007],
              [22.99073326900009, 63.78750234600005],
              [22.99073326900009, 63.787624416000085],
              [22.99463951900009, 63.80072663000004],
              [22.994476759000065, 63.80621979400007],
              [22.99073326900009, 63.81537506700005],
              [23.047618035000085, 63.84129466400003],
              [23.062836134000065, 63.85297272300005],
              [23.074961785000085, 63.85736725500004],
              [23.121348504000082, 63.84955475500004],
              [23.13257897200009, 63.85248444200005],
              [23.14234459700009, 63.85846588700008],
              [23.153493686000047, 63.86347077000005],
              [23.151215040000068, 63.864894924000055],
              [23.14161217500009, 63.86945221600007],
              [23.141856316000087, 63.87596263200004],
              [23.155039910000085, 63.883693752000056],
              [23.16732832100007, 63.88694896000004],
              [23.197927280000044, 63.890611070000034],
              [23.275238477000073, 63.88890208500004],
              [23.306488477000073, 63.894232489000046],
              [23.326426629000082, 63.91095612200007],
              [23.350759311000047, 63.89883047100005],
              [23.37281334700009, 63.90062083500004],
              [23.39421634200005, 63.91107819200005],
              [23.41578209700009, 63.92462799700007],
              [23.384776238000086, 63.93829987200007],
              [23.37086022200009, 63.946519273000035],
              [23.37086022200009, 63.95600006700005],
              [23.378754102000073, 63.96893952000005],
              [23.37671959700009, 63.97874583500004],
              [23.37086022200009, 63.987534898000035],
              [23.367442254000082, 63.997259833000044],
              [23.369883660000085, 64.00324127800008],
              [23.381602410000085, 64.04816315300008],
              [23.396494988000086, 64.05613841400003],
              [23.415212436000047, 64.05621979400007],
              [23.449961785000085, 64.04816315300008],
              [23.456553582000083, 64.04547760600008],
              [23.467539910000085, 64.03790924700007],
              [23.477305535000085, 64.03510163000004],
              [23.487559441000087, 64.03595612200007],
              [23.496755405000044, 64.03945547100005],
              [23.506602410000085, 64.04165273600006],
              [23.538340691000087, 64.03188711100006],
              [23.60450280000009, 64.02765534100007],
              [23.619802280000044, 64.03803131700005],
              [23.60596764400009, 64.06110260600008],
              [23.58171634200005, 64.08466217700004],
              [23.56609134200005, 64.09658437700006],
              [23.57357832100007, 64.10724518400008],
              [23.585459832000083, 64.10854726800005],
              [23.614431186000047, 64.10342031500005],
              [23.62208092500009, 64.10712311400005],
              [23.644786004000082, 64.12441640800006],
              [23.65601647200009, 64.13007233300004],
              [23.660329623000052, 64.14329661700003],
              [23.679535352000073, 64.15534088700008],
              [23.704274936000047, 64.16669342700004],
              [23.706472201000054, 64.16807689000007],
              [23.72364342500009, 64.17853424700007],
              [23.716807488000086, 64.17853424700007],
              [23.719411655000044, 64.19428131700005],
              [23.72437584700009, 64.20892975500004],
              [23.73568769600007, 64.21621328300006],
              [23.757660352000073, 64.20954010600008],
              [23.772715691000087, 64.20892975500004],
              [23.819102410000085, 64.22064850500004],
              [23.833506707000083, 64.22687409100007],
              [23.841644727000073, 64.23615143400008],
              [23.86109459700009, 64.26788971600007],
              [23.881602410000085, 64.26609935100004],
              [23.924489780000044, 64.25470612200007],
              [23.943369988000086, 64.24677155200004],
              [23.93458092500009, 64.25849030200004],
              [23.927582227000073, 64.27118561400005],
              [23.92514082100007, 64.28546784100007],
              [23.92904707100007, 64.30141836100006],
              [23.940928582000083, 64.31655508000006],
              [23.97120201900009, 64.33515045800004],
              [23.984222852000073, 64.34979889500005],
              [23.996104363000086, 64.37986888200004],
              [24.00440514400009, 64.38910553600005],
              [24.025401238000086, 64.39765045800004],
              [24.068614129000082, 64.40558502800008],
              [24.084727410000085, 64.41474030200004],
              [24.08057701900009, 64.43170807500007],
              [24.093272332000083, 64.43040599200003],
              [24.10482832100007, 64.43121979400007],
              [24.115489129000082, 64.43480052300004],
              [24.125010613000086, 64.44232819200005],
              [24.129161004000082, 64.44082265800006],
              [24.16928144600007, 64.45221588700008],
              [24.205739780000044, 64.45221588700008],
              [24.210785352000073, 64.45600006700005],
              [24.210459832000083, 64.47308991100005],
              [24.21225019600007, 64.48102448100008],
              [24.21778405000009, 64.48700592700004],
              [24.22950280000009, 64.48916250200006],
              [24.25757897200009, 64.48598867400005],
              [24.26889082100007, 64.49005768400008],
              [24.27515709700009, 64.49762604400007],
              [24.28093509200005, 64.51015859600005],
              [24.285980665000068, 64.51496002800008],
              [24.30632571700005, 64.52204010600008],
              [24.325694207000083, 64.52460358300004],
              [24.344086134000065, 64.53074778900003],
              [24.36109459700009, 64.54840729400007],
              [24.360118035000085, 64.55536530200004],
              [24.355642123000052, 64.56452057500007],
              [24.354991082000083, 64.57241445500006],
              [24.373871290000068, 64.57953522300005],
              [24.374522332000083, 64.58779531500005],
              [24.37086022200009, 64.59516022300005],
              [24.367930535000085, 64.59686920800004],
              [24.37549889400009, 64.61725495000007],
              [24.382660352000073, 64.62864817900004],
              [24.408864780000044, 64.65143463700008],
              [24.414317254000082, 64.65908437700006],
              [24.418304884000065, 64.66803620000007],
              [24.42286217500009, 64.67560455900008],
              [24.42937259200005, 64.67877838700008],
              [24.44117272200009, 64.68109772300005],
              [24.470957879000082, 64.69928620000007],
              [24.511566602000073, 64.71002838700008],
              [24.53028405000009, 64.71784088700008],
              [24.546071811000047, 64.73338450700004],
              [24.53646894600007, 64.74412669500003],
              [24.532399936000047, 64.74770742400005],
              [24.532399936000047, 64.75385163000004],
              [24.543711785000085, 64.76471588700008],
              [24.55713951900009, 64.77090078300006],
              [24.58765709700009, 64.78119538000004],
              [24.550059441000087, 64.79657623900005],
              [24.53842207100007, 64.80532461100006],
              [24.556651238000086, 64.80914948100008],
              [24.578379754000082, 64.80792877800008],
              [24.658539259000065, 64.78864166900007],
              [24.668304884000065, 64.78912995000007],
              [24.676524285000085, 64.79486725500004],
              [24.67676842500009, 64.79954661700003],
              [24.66570071700005, 64.80707428600005],
              [24.662771030000044, 64.81256745000007],
              [24.670664910000085, 64.82973867400005],
              [24.689626498000052, 64.83470286700003],
              [24.731700066000087, 64.83584219000005],
              [24.736338738000086, 64.85537344000005],
              [24.77312259200005, 64.86579010600008],
              [24.89698326900009, 64.87311432500007],
              [25.073741082000083, 64.91608307500007],
              [25.09473717500009, 64.91836172100005],
              [25.11231530000009, 64.91445547100005],
              [25.121755405000044, 64.90509674700007],
              [25.129730665000068, 64.89378489800004],
              [25.143239780000044, 64.88422272300005],
              [25.151052280000044, 64.88385651200008],
              [25.158457879000082, 64.88670482000003],
              [25.166677280000044, 64.88841380400004],
              [25.177256707000083, 64.88422272300005],
              [25.179860873000052, 64.87995026200008],
              [25.183929884000065, 64.86579010600008],
              [25.18726647200009, 64.86066315300008],
              [25.20248457100007, 64.84918854400007],
              [25.217621290000068, 64.84145742400005],
              [25.235606316000087, 64.83710358300004],
              [25.259287957000083, 64.83584219000005],
              [25.259287957000083, 64.82957591400003],
              [25.24976647200009, 64.82953522300005],
              [25.24154707100007, 64.82811107000003],
              [25.22510826900009, 64.82273997600004],
              [25.25953209700009, 64.81647370000007],
              [25.35482832100007, 64.82957591400003],
              [25.362152540000068, 64.83307526200008],
              [25.350433790000068, 64.85171133000006],
              [25.351817254000082, 64.86066315300008],
              [25.366709832000083, 64.89175039300005],
              [25.36850019600007, 64.89850495000007],
              [25.359548373000052, 64.91111888200004],
              [25.347829623000052, 64.91156647300005],
              [25.334808790000068, 64.90692780200004],
              [25.32129967500009, 64.90473053600005],
              [25.30632571700005, 64.90888092700004],
              [25.27979576900009, 64.92230866100005],
              [25.24122155000009, 64.92902252800008],
              [25.223480665000068, 64.93891022300005],
              [25.190928582000083, 64.96678294500003],
              [25.196055535000085, 64.96979401200008],
              [25.206228061000047, 64.97748444200005],
              [25.21143639400009, 64.98041413000004],
              [25.203949415000068, 64.98663971600007],
              [25.220957879000082, 64.99054596600007],
              [25.32162519600007, 64.98358795800004],
              [25.340098504000082, 64.97724030200004],
              [25.37598717500009, 64.95994700700004],
              [25.399099155000044, 64.95189036700003],
              [25.42156009200005, 64.94887929900005],
              [25.438161655000044, 64.95307038000004],
              [25.443532748000052, 64.96678294500003],
              [25.436289910000085, 64.98029205900008],
              [25.42432701900009, 64.98908112200007],
              [25.416758660000085, 64.99860260600008],
              [25.423106316000087, 65.01459381700005],
              [25.416188998000052, 65.01992422100005],
              [25.41309655000009, 65.02448151200008],
              [25.413259311000047, 65.02924225500004],
              [25.416270379000082, 65.03506094000005],
              [25.392588738000086, 65.04767487200007],
              [25.380869988000086, 65.05597565300008],
              [25.37598717500009, 65.06574127800008],
              [25.37435957100007, 65.07636139500005],
              [25.369965040000068, 65.08441803600005],
              [25.363536004000082, 65.09076569200005],
              [25.355479363000086, 65.09650299700007],
              [25.324066602000073, 65.10980866100005],
              [25.21143639400009, 65.12376536700003],
              [25.218272332000083, 65.14573802300004],
              [25.225840691000087, 65.15664297100005],
              [25.259287957000083, 65.17218659100007],
              [25.272634311000047, 65.18040599200003],
              [25.282481316000087, 65.19139232000003],
              [25.28565514400009, 65.20477936400005],
              [25.27979576900009, 65.21995677300004],
              [25.292165561000047, 65.21906159100007],
              [25.30445397200009, 65.21967194200005],
              [25.316254102000073, 65.22211334800005],
              [25.32748457100007, 65.22687409100007],
              [25.320648634000065, 65.22842031500005],
              [25.307871941000087, 65.23273346600007],
              [25.30014082100007, 65.23362864800004],
              [25.308848504000082, 65.24909088700008],
              [25.31381269600007, 65.25413646000004],
              [25.297211134000065, 65.25950755400004],
              [25.289073113000086, 65.26113515800006],
              [25.27979576900009, 65.26097239800004],
              [25.294200066000087, 65.27114492400005],
              [25.307871941000087, 65.30215078300006],
              [25.32129967500009, 65.31622955900008],
              [25.31739342500009, 65.31932200700004],
              [25.310801629000082, 65.32684967700004],
              [25.306976759000065, 65.32982005400004],
              [25.316254102000073, 65.33136627800008],
              [25.322438998000052, 65.33356354400007],
              [25.33497155000009, 65.34349192900004],
              [25.26612389400009, 65.37763092700004],
              [25.280039910000085, 65.38117096600007],
              [25.306895379000082, 65.38157786700003],
              [25.32129967500009, 65.38507721600007],
              [25.330088738000086, 65.39052969000005],
              [25.34669030000009, 65.40574778900003],
              [25.355479363000086, 65.41181061400005],
              [25.344493035000085, 65.42853424700007],
              [25.358653191000087, 65.46552155200004],
              [25.351817254000082, 65.48411692900004],
              [25.32357832100007, 65.50678131700005],
              [25.293711785000085, 65.52509186400005],
              [25.219004754000082, 65.55727773600006],
              [25.197113477000073, 65.56264883000006],
              [25.170095248000052, 65.56224192900004],
              [25.146820509000065, 65.55902741100005],
              [25.124847852000073, 65.56110260600008],
              [25.101573113000086, 65.57689036700003],
              [25.096364780000044, 65.58502838700008],
              [25.093190951000054, 65.59190501500007],
              [25.091807488000086, 65.59495677300004],
              [25.085459832000083, 65.60516998900005],
              [25.074229363000086, 65.61416250200006],
              [25.060720248000052, 65.61725495000007],
              [25.035817905000044, 65.61416250200006],
              [25.02247155000009, 65.62099844000005],
              [25.00489342500009, 65.62702057500007],
              [24.957204623000052, 65.62278880400004],
              [24.93718509200005, 65.62409088700008],
              [24.924082879000082, 65.63043854400007],
              [24.906097852000073, 65.64594147300005],
              [24.89551842500009, 65.65135325700004],
              [24.85914147200009, 65.65912506700005],
              [24.819509311000047, 65.66217682500007],
              [24.78028405000009, 65.65973541900007],
              [24.745290561000047, 65.65135325700004],
              [24.719086134000065, 65.63788483300004],
              [24.70679772200009, 65.63328685100004],
              [24.687022332000083, 65.63153717700004],
              [24.675791863000086, 65.63544342700004],
              [24.671071811000047, 65.64496491100005],
              [24.670176629000082, 65.68341705900008],
              [24.66773522200009, 65.69086334800005],
              [24.659678582000083, 65.69505442900004],
              [24.596527540000068, 65.70917389500005],
              [24.583994988000086, 65.71686432500007],
              [24.56771894600007, 65.73065827000005],
              [24.554860873000052, 65.74510325700004],
              [24.55046634200005, 65.76349518400008],
              [24.560394727000073, 65.78912995000007],
              [24.575368686000047, 65.80817291900007],
              [24.632009311000047, 65.86058177300004],
              [24.645762566000087, 65.87946198100008],
              [24.65365644600007, 65.88556549700007],
              [24.670258009000065, 65.89158763200004],
              [24.697601759000065, 65.89447663000004],
              [24.70753014400009, 65.89923737200007],
              [24.71062259200005, 65.91209544500003],
              [24.694590691000087, 65.90399811400005],
              [24.64226321700005, 65.89158763200004],
              [24.63445071700005, 65.89093659100007],
              [24.625336134000065, 65.89130280200004],
              [24.617930535000085, 65.88922760600008],
              [24.61500084700009, 65.88133372600004],
              [24.615489129000082, 65.87079498900005],
              [24.614512566000087, 65.86615631700005],
              [24.611582879000082, 65.86432526200008],
              [24.587168816000087, 65.85431549700007],
              [24.543630405000044, 65.80898672100005],
              [24.518809441000087, 65.79604726800005],
              [24.494395379000082, 65.79515208500004],
              [24.473480665000068, 65.79718659100007],
              [24.452972852000073, 65.79694245000007],
              [24.430511915000068, 65.78912995000007],
              [24.427989129000082, 65.78620026200008],
              [24.426117384000065, 65.78168366100005],
              [24.42286217500009, 65.77659739800004],
              [24.41570071700005, 65.77179596600007],
              [24.40479576900009, 65.76923248900005],
              [24.35710696700005, 65.77920156500005],
              [24.32789147200009, 65.79791901200008],
              [24.316661004000082, 65.80223216400003],
              [24.27784264400009, 65.80939362200007],
              [24.238291863000086, 65.82269928600005],
              [24.248301629000082, 65.80902741100005],
              [24.251231316000087, 65.79413483300004],
              [24.244313998000052, 65.78156159100007],
              [24.224619988000086, 65.77488841400003],
              [24.206228061000047, 65.77875397300005],
              [24.188243035000085, 65.79022858300004],
              [24.173024936000047, 65.80418528900003],
              [24.16309655000009, 65.81586334800005],
              [24.16309655000009, 65.82269928600005],
              [24.163413534000114, 65.84078847300007],
              [24.12444950400004, 65.868900452],
              [24.10233199000004, 65.90858795200008],
              [24.07597701000006, 65.92801829100007],
              [24.0547896730001, 65.94791371700008],
              [24.056960083000092, 65.97010874400009],
              [24.05530643700004, 65.98517242499999],
              [24.029778279000112, 66.03498850500004],
              [24.01964969900007, 66.04894114200003],
              [24.00941776500008, 66.05560740200004],
              [23.985129842000077, 66.06635610000005],
              [23.97458785000012, 66.07281565400011],
              [23.965596151000085, 66.08160064700009],
              [23.911439250000058, 66.1486249800001],
              [23.889321737000046, 66.16110483900009],
              [23.785555461000058, 66.17668528300003],
              [23.750002075000083, 66.18965606700006],
              [23.724163859000072, 66.20663177500008],
              [23.68943729700004, 66.25699045900005],
              [23.680652303000045, 66.28298370400002],
              [23.66597619600006, 66.3054629520001],
              [23.662772258000103, 66.31652170900013],
              [23.66442590300005, 66.32639190700009],
              [23.673004191000075, 66.33951772100006],
              [23.676414835000088, 66.35000803700002],
              [23.67703495300006, 66.36362477600004],
              [23.671660604000095, 66.38178904300007],
              [23.6702136640001, 66.39530243000003],
              [23.665872843000045, 66.40556020100011],
              [23.646649210000106, 66.42406036400006],
              [23.64230839000004, 66.43625600200006],
              [23.6524369710001, 66.45883860300007],
              [23.676828247000117, 66.47400563600011],
              [23.706077108000073, 66.48297149700004],
              [23.731088501000073, 66.48715728800009],
              [23.731088501000073, 66.50312530500013],
              [23.75506636500006, 66.5118586230001],
              [23.78586551900014, 66.51842153000008],
              [23.806122681000147, 66.52813669900003],
              [23.80767297400007, 66.53924713200003],
              [23.86120975700001, 66.55459503200011],
              [23.881880330000115, 66.56353505500003],
              [23.891492146000132, 66.57888295500003],
              [23.8932491460001, 66.59603953100007],
              [23.889115030000085, 66.61407460600007],
              [23.881880330000115, 66.63179962200009],
              [23.89159550000008, 66.64787099300004],
              [23.899036906000077, 66.666371155],
              [23.903171020000116, 66.6863182580001],
              [23.902964315000048, 66.70688547800007],
              [23.891698853000094, 66.74357574500006],
              [23.8924223220001, 66.75091379800004],
              [23.924771769000074, 66.77297963500006],
              [23.939241170000116, 66.79111806300007],
              [23.961048624000057, 66.79354685500003],
              [23.98440637200008, 66.79297841400007],
              [23.99918583200011, 66.79628570600006],
              [24.004043416000115, 66.8051998910001],
              [24.001252889000057, 66.81243459100007],
              [23.960841919000075, 66.8618889370001],
              [23.933350057000013, 66.88876068200001],
              [23.91236942600011, 66.9034109500001],
              [23.873612102000095, 66.92464996400007],
              [23.816664672000115, 66.97549957300008],
              [23.792066691000116, 66.98893544600013],
              [23.761680949000066, 66.99428395600007],
              [23.743800903000107, 67.0010277310001],
              [23.72033980300003, 67.01686655800002],
              [23.68385624200002, 67.04952606299999],
              [23.676724894000074, 67.05849192300012],
              [23.672590780000064, 67.065700786],
              [23.670627075000112, 67.07422739700009],
              [23.6702136640001, 67.08706899],
              [23.666596313000127, 67.09792104100005],
              [23.658018026000093, 67.104018861],
              [23.64778609200002, 67.10856638600002],
              [23.6205009360001, 67.12926279700004],
              [23.59890018700014, 67.14029571600004],
              [23.58133020000008, 67.15313730900003],
              [23.57399214700007, 67.17303273600005],
              [23.586497844000064, 67.18088755400008],
              [23.597556600000075, 67.19026682600013],
              [23.607065064000068, 67.20122223],
              [23.614919881000105, 67.21398630800006],
              [23.596729777000064, 67.21796539400005],
              [23.591458781000114, 67.22501922600007],
              [23.594559367000073, 67.24442372600005],
              [23.60272424300007, 67.26026255300003],
              [23.62225793400009, 67.26902170900003],
              [23.73542932100014, 67.28969228100003],
              [23.763231242000103, 67.30648712200009],
              [23.785658814000072, 67.33751882000003],
              [23.751449015000077, 67.3462262990001],
              [23.751345662000062, 67.36953237000004],
              [23.763231242000103, 67.39754099600005],
              [23.765194946000122, 67.42007192000007],
              [23.752585897000102, 67.42730662100003],
              [23.730778442000087, 67.43141489700004],
              [23.66266890500006, 67.43622080500005],
              [23.594559367000073, 67.45360992500007],
              [23.553838338000105, 67.45200795500004],
              [23.514254191000134, 67.44482493200009],
              [23.477150513000055, 67.44381724100002],
              [23.443664184000056, 67.461025492],
              [23.431261841000094, 67.48552012200004],
              [23.443457479000102, 67.50471791600008],
              [23.465988404000115, 67.52244293200009],
              [23.484695272000096, 67.54295847700006],
              [23.47342981000014, 67.55499908500003],
              [23.499474731000134, 67.566316224],
              [23.535441528000092, 67.577013245],
              [23.55352827900012, 67.58703847300002],
              [23.550324341000135, 67.61091298400002],
              [23.542572876000122, 67.62667429600002],
              [23.518801717000088, 67.652822572],
              [23.51074019400008, 67.66925567600008],
              [23.499474731000134, 67.70899485300008],
              [23.488415975000123, 67.72480784200006],
              [23.48459191900008, 67.73715850900003],
              [23.484695272000096, 67.79622467100008],
              [23.479734334000057, 67.81699859600012],
              [23.476737102000044, 67.84133819600002],
              [23.481284627000093, 67.86464426700006],
              [23.498854614000066, 67.88216257800012],
              [23.532547648000104, 67.89316965800002],
              [23.60334436000005, 67.90298818000007],
              [23.636107219000053, 67.91347849600002],
              [23.661221964000077, 67.9328571570001],
              [23.662152140000046, 67.95042714500006],
              [23.64313521300005, 67.96319122300004],
              [23.573682088000083, 67.97331980400007],
              [23.484695272000096, 68.01590118500006],
              [23.45730676200006, 68.02432444300005],
              [23.382996053000085, 68.05124786400005],
              [23.374831177000146, 68.05998118100003],
              [23.371213826000087, 68.06845611600004],
              [23.33090621000011, 68.12778066000006],
              [23.31984745200012, 68.13827097600002],
              [23.306514933000102, 68.14560902900008],
              [23.27209842900004, 68.14498891300003],
              [23.18724572700009, 68.12225128200005],
              [23.165644979000035, 68.1220445770001],
              [23.158823690000077, 68.1275739550001],
              [23.15458622200012, 68.1283491010001],
              [23.151692342000047, 68.13026112900003],
              [23.149418579000013, 68.13940785700002],
              [23.149831990000024, 68.14483388300009],
              [23.154482869000077, 68.1537739060001],
              [23.15975386600013, 68.178733622],
              [23.15851363100009, 68.18669179300007],
              [23.149418579000013, 68.19402984700007],
              [23.155206340000092, 68.21743927100003],
              [23.140013468000063, 68.23418243500005],
              [23.09484826700009, 68.25552480100005],
              [23.081619100000097, 68.2652916470001],
              [23.076451457000076, 68.27381825800005],
              [23.0735575760001, 68.28193145800005],
              [23.06694299300011, 68.2902513640001],
              [23.052163533000083, 68.29820953400007],
              [22.903748820000146, 68.33660512400009],
              [22.875120077000076, 68.35107452500002],
              [22.83336551900004, 68.38476755800006],
              [22.80825077300011, 68.39489613900004],
              [22.748616170000105, 68.38549102800006],
              [22.719057251000095, 68.39877187200007],
              [22.690221801000064, 68.41675527000008],
              [22.66221317500012, 68.42740061500005],
              [22.643402954000123, 68.42729726200004],
              [22.625832967000065, 68.42507517500003],
              [22.60764286300011, 68.424920146],
              [22.565164836000065, 68.43628896100007],
              [22.521343221000052, 68.438200989],
              [22.456851034000124, 68.4517918910001],
              [22.377992798, 68.45411733000002],
              [22.37396203600011, 68.45633941700002],
              [22.37458215300009, 68.4661579390001],
              [22.371068156000035, 68.468380026],
              [22.303061971000147, 68.47613149000001],
              [22.07217167200011, 68.47700999000004],
              [22.038375285000143, 68.488275452],
              [22.036721639000092, 68.49292633100008],
              [22.03744510900009, 68.50005767900011],
              [22.03610152200011, 68.50651723300005],
              [22.028763469000125, 68.50935943700004],
              [22.024215942000097, 68.51044464200002],
              [22.012123657000103, 68.51643910800006],
              [21.9984810790001, 68.52584421900009],
              [21.969852336000116, 68.54083038400007],
              [21.96396122200011, 68.54692820300004],
              [21.91920943200006, 68.56821889300004],
              [21.737101685000084, 68.58790761400006],
              [21.716844523000077, 68.619223532],
              [21.661550740000052, 68.63353790300006],
              [21.572460571000136, 68.66738596700007],
              [21.49566939300007, 68.67549916600008],
              [21.463630005000084, 68.68686798100005],
              [21.45153772000009, 68.69647979800008],
              [21.421255330000065, 68.727485657],
              [21.415260864000118, 68.73875111900007],
              [21.406372518000126, 68.74887970000002],
              [21.38590865100005, 68.75384063800006],
              [21.314698527000104, 68.7540473430001],
              [21.305396769000083, 68.755804342],
              [21.300952596000087, 68.75921498600012],
              [21.2937178950001, 68.76820668600006],
              [21.28834354700004, 68.77001536100006],
              [21.275734497000116, 68.7764232390001],
              [21.21661665800005, 68.81724762000009],
              [21.15284794100012, 68.84174224900003],
              [21.072129353000093, 68.86944081700007],
              [20.905731242000087, 68.8946072400001],
              [20.884543905000044, 68.90669952500009],
              [20.88764449000007, 68.92706003800002],
              [20.91782352700008, 68.93295115200003],
              [20.934256632000142, 68.94902252200008],
              [20.934566691000043, 68.96695424500005],
              [20.911208944000066, 68.980700175],
              [20.86397668500004, 68.98628123000002],
              [20.795350383000084, 69.011240947],
              [20.675461059000042, 69.01816558800009],
              [20.62316451, 69.03635569300012],
              [20.716595499000107, 69.09878082300007],
              [20.744397421000144, 69.10436187800009],
              [21.032545207000055, 69.04100657100007],
              [21.071509237000043, 69.03666575200002],
              [21.099001099000105, 69.04379709900003],
              [21.15636193800009, 69.08761871400004],
              [21.03357873500002, 69.18120473300009],
              [21.06303430200012, 69.21494944300004],
              [21.079674113000067, 69.23014231400008],
              [21.098380981000048, 69.23949574900011],
              [21.313561646000096, 69.29143056300002],
              [21.638813110000086, 69.27138010700007],
              [21.662894328000107, 69.26321523100005],
              [21.946100152000042, 69.065702532],
              [22.02307906100009, 69.01201609300001],
              [22.160745076000097, 68.95610219400002],
              [22.1743876540001, 68.94369985000004],
              [22.188650350000074, 68.91863678000003],
              [22.2002258710001, 68.90845652300005],
              [22.277223755000136, 68.85745188400001],
              [22.35680546100005, 68.83275055000009],
              [22.371378215000107, 68.82262196900005],
              [22.396699666000103, 68.73182647800009],
              [22.409205363000098, 68.71291290300003],
              [22.42873905400009, 68.71007070000006],
              [22.542943970000124, 68.726038717],
              [22.570125773000115, 68.72681386400002],
              [22.596480753000066, 68.72464345300004],
              [22.851658976000095, 68.67570587200002],
              [23.019297322000057, 68.68671295200004],
              [23.071490519000037, 68.68087351500004],
              [23.097948852000115, 68.67012481700003],
              [23.175360148000067, 68.62165232400004],
              [23.197581014000093, 68.61803497300006],
              [23.48159468600008, 68.68562774700003],
              [23.641584920000128, 68.69498118100007],
              [23.734809204000072, 68.71544504800003],
              [23.767985474000085, 68.75595937100003],
              [23.78720910600009, 68.79978098600004],
              [23.852631469000073, 68.81667917900005],
              [23.92900923700003, 68.8162140910001],
              [24.13116744000007, 68.77616485600002],
              [24.16372359200011, 68.75482249000002],
              [24.186874633000087, 68.74453888000004],
              [24.33249882000007, 68.70862376000007],
              [24.48132694500009, 68.6891934210001],
              [24.663434693000085, 68.66609405600012],
              [24.754178508000052, 68.63787872400006],
              [24.829626098000034, 68.59410878600006],
              [24.860942016000138, 68.56341298400012],
              [24.879235474000012, 68.55483469700009],
              [24.905177042000076, 68.55695343000006],
              [24.927087850000106, 68.57038930300011],
              [24.938146606000117, 68.58826934800008],
              [24.951789185000024, 68.60506418900003],
              [24.981244751000133, 68.61508941700005],
              [25.006876261000087, 68.61457265300002],
              [25.070955038000108, 68.63141917000009],
              [25.097826782000112, 68.63374460900003],
              [25.117567179000076, 68.6376720170001],
              [25.13244999200012, 68.64764556900009],
              [25.144232218000127, 68.66800608400003],
              [25.132139933000133, 68.67658437100006],
              [25.132760051000105, 68.68268219000002],
              [25.138754517000024, 68.68831492100004],
              [25.1430953360001, 68.69596303400003],
              [25.1448523360001, 68.74262685200001],
              [25.14960656700009, 68.7646410120001],
              [25.16273238100004, 68.78458811500012],
              [25.201283, 68.81264841800005],
              [25.387214803000035, 68.87455678400006],
              [25.43393029800012, 68.883858542],
              [25.481059204000132, 68.88773427300005],
              [25.60244714400011, 68.87212799100008],
              [25.627768595000106, 68.87414337200003],
              [25.651643107000098, 68.883496806],
              [25.66621586100004, 68.89739776700007],
              [25.67841149900005, 68.91253896100007],
              [25.694844605000128, 68.92561309800003],
              [25.7263672280001, 68.94245961500009],
              [25.7374259850001, 68.95253652000004],
              [25.742696981000023, 68.96586903900005],
              [25.75385909000005, 68.97837473600008],
              [25.795820353000067, 68.99330922500003],
              [25.804708700000077, 69.00612498000002],
              [25.801091350000092, 69.0131529750001],
              [25.79292647300008, 69.01816558800009],
              [25.77380619300007, 69.02540028900005],
              [25.765848022000114, 69.03067128600007],
              [25.76460778800009, 69.035167135],
              [25.7657446690001, 69.03919789600009],
              [25.765124553000106, 69.04338368700003],
              [25.750241739000074, 69.05924835200004],
              [25.749414917000138, 69.06555287700006],
              [25.757166382000065, 69.07511301700005],
              [25.759026734000145, 69.08203765900002],
              [25.76047367400014, 69.11516225200005],
              [25.7624373780001, 69.11919301400003],
              [25.76636478700007, 69.122707012],
              [25.769982137000056, 69.12740956700007],
              [25.771222372000068, 69.13510935500004],
              [25.76832849100009, 69.14213735000006],
              [25.755306031000146, 69.1595523080001],
              [25.749931681000078, 69.16518503900004],
              [25.734118693000084, 69.19133331400003],
              [25.737219279000044, 69.21820505800004],
              [25.774529663000067, 69.29882029300005],
              [25.78662194900005, 69.31277292900002],
              [25.877365763000114, 69.370805563],
              [25.87261153200012, 69.37907379200003],
              [25.841398966000042, 69.41777943900006],
              [25.86579024200006, 69.44098215800007],
              [25.877469116000043, 69.447028301],
              [25.88666752100005, 69.45519317600012],
              [25.8857373460001, 69.47911936500002],
              [25.89214522300003, 69.49090159200001],
              [25.9064079180001, 69.5018569950001],
              [25.90144698100005, 69.50914337200008],
              [25.890594930000105, 69.51482778000003],
              [25.88666752100005, 69.52087392200006],
              [25.900206747000112, 69.53203603200011],
              [25.960254761000044, 69.54867584200012],
              [25.986196330000098, 69.56541900600006],
              [26.0039730230001, 69.58717478500007],
              [26.005109904000022, 69.61084259000002],
              [25.9811320390001, 69.63347686800007],
              [25.964388875000054, 69.64267527300005],
              [25.961701701000038, 69.65254547200006],
              [25.968833049000068, 69.66319081600004],
              [25.981338745000073, 69.67486969000002],
              [26.005109904000022, 69.68933909100004],
              [26.031981649000045, 69.69667714500004],
              [26.18142989100005, 69.71124989800008],
              [26.198276408000112, 69.71543569000004],
              [26.210988811000078, 69.72287709600006],
              [26.222977742000126, 69.7319204710001],
              [26.268246297000104, 69.75827545200006],
              [26.31682214300011, 69.79491404200003],
              [26.418728068000092, 69.83563507100008],
              [26.44787357600012, 69.85604726200005],
              [26.435884643000065, 69.87423736600009],
              [26.445909871000083, 69.88175628700002],
              [26.481049846000133, 69.89940378900012],
              [26.500686890000082, 69.91831736200005],
              [26.533863159000077, 69.92524200500004],
              [26.70697920700013, 69.93506052700009],
              [26.771884807000077, 69.928394267],
              [26.864592326000064, 69.93808359900002],
              [26.89570153800011, 69.934337057],
              [26.951098673000047, 69.92015187600005],
              [26.981071004000086, 69.923278301],
              [27.00752933700008, 69.92245147800007],
              [27.081219930000117, 69.90294362400009],
              [27.1003402100001, 69.90175506600006],
              [27.311800170000055, 69.9294794720001],
              [27.352417847000083, 69.948703105],
              [27.34507979300011, 69.95074432400007],
              [27.330507039000054, 69.9574622600001],
              [27.32316898600004, 69.95968434700008],
              [27.334537801000124, 69.96862436900004],
              [27.349110555000095, 69.97128570600005],
              [27.364975220000105, 69.97175079400007],
              [27.380943237000054, 69.97425710100005],
              [27.445228719000113, 70.00322174100002],
              [27.5633093670001, 70.02358225500005],
              [27.570905802000055, 70.04089386000005],
              [27.612557007000078, 70.06205535900001],
              [27.665060262000054, 70.06828237000009],
              [27.792184286000094, 70.05892893600007],
              [27.866908407000096, 70.07531036400012],
              [27.89729414900006, 70.07068532400005],
              [27.927163127000142, 70.05327036600004],
              [27.981009969000098, 70.00960378100005],
              [28.167355184000115, 69.89433949900005],
              [28.18926599100007, 69.88604543100008],
              [28.381192260000034, 69.85620229100009],
              [28.37974532000004, 69.82235422800007],
              [28.404550008000058, 69.80225209600012],
              [28.442687215000035, 69.791451722],
              [28.48092777500011, 69.78571563800004],
              [28.806075887000077, 69.72995676750013],
              [29.1312239990001, 69.67419789700004],
              [29.147140341000124, 69.66391428700003],
              [29.20315759300007, 69.58598622600006],
              [29.34454431100005, 69.46439158200012],
              [29.229254191000052, 69.37685170500005],
              [28.864780314000114, 69.216603089],
              [28.852171265000095, 69.20352895200004],
              [28.844109741000096, 69.18125640900008],
              [28.826953166000123, 69.10684234700007],
              [28.827573283000106, 69.090770976],
              [28.839613892000074, 69.08028066000004],
              [28.95407718900009, 69.02726064100004],
            ],
          ],
          [
            [
              [22.408376498000052, 60.052801825000074],
              [22.401866082000083, 60.07575104400007],
              [22.41179446700005, 60.085191148000035],
              [22.430430535000085, 60.08185455900008],
              [22.449473504000082, 60.066473700000074],
              [22.44971764400009, 60.02952708500004],
              [22.448008660000085, 60.01235586100006],
              [22.442637566000087, 59.99750397300005],
              [22.435801629000082, 59.99750397300005],
              [22.425629102000073, 60.00690338700008],
              [22.40951582100007, 60.00934479400007],
              [22.394541863000086, 60.00503164300005],
              [22.387950066000087, 59.99445221600007],
              [22.382823113000086, 59.99258047100005],
              [22.371429884000065, 60.00454336100006],
              [22.359711134000065, 60.02090078300006],
              [22.35320071700005, 60.03229401200008],
              [22.349457227000073, 60.04751211100006],
              [22.348887566000087, 60.06321849200003],
              [22.35482832100007, 60.07562897300005],
              [22.370616082000083, 60.08075592700004],
              [22.382660352000073, 60.07453034100007],
              [22.383474155000044, 60.061835028000075],
              [22.38721764400009, 60.051662502000056],
              [22.408376498000052, 60.052801825000074],
            ],
          ],
          [
            [
              [21.49659264400009, 60.13532135600008],
              [21.52979576900009, 60.159409898000035],
              [21.571055535000085, 60.170355536000045],
              [21.614512566000087, 60.16889069200005],
              [21.654307488000086, 60.15582916900007],
              [21.64747155000009, 60.14508698100008],
              [21.637380405000044, 60.13882070500006],
              [21.613291863000086, 60.12909577000005],
              [21.63021894600007, 60.12848541900007],
              [21.636973504000082, 60.12368398600006],
              [21.635101759000065, 60.11615631700005],
              [21.62631269600007, 60.10736725500004],
              [21.613129102000073, 60.10211823100008],
              [21.599131707000083, 60.102728583000044],
              [21.57203209700009, 60.10736725500004],
              [21.561778191000087, 60.10659414300005],
              [21.534353061000047, 60.10138580900008],
              [21.524261915000068, 60.09780508000006],
              [21.514414910000085, 60.097357489000046],
              [21.503916863000086, 60.10297272300005],
              [21.49317467500009, 60.11017487200007],
              [21.482269727000073, 60.11481354400007],
              [21.499196811000047, 60.121079820000034],
              [21.51856530000009, 60.12287018400008],
              [21.558116082000083, 60.12164948100008],
              [21.549001498000052, 60.13344961100006],
              [21.533050977000073, 60.13703034100007],
              [21.49659264400009, 60.13532135600008],
            ],
          ],
          [
            [
              [21.743662957000083, 60.190619208000044],
              [21.799571160000085, 60.196600653000075],
              [21.853526238000086, 60.19676341400003],
              [21.88770592500009, 60.18374258000006],
              [21.88770592500009, 60.17633698100008],
              [21.876475457000083, 60.176947333000044],
              [21.86573326900009, 60.17641836100006],
              [21.855642123000052, 60.17413971600007],
              [21.846039259000065, 60.17011139500005],
              [21.852305535000085, 60.167181708000044],
              [21.867849155000044, 60.15582916900007],
              [21.79151451900009, 60.15582916900007],
              [21.826182488000086, 60.149603583000044],
              [21.817149285000085, 60.14545319200005],
              [21.80713951900009, 60.14252350500004],
              [21.79656009200005, 60.14138418200008],
              [21.801036004000082, 60.13971588700008],
              [21.80567467500009, 60.13532135600008],
              [21.783213738000086, 60.12323639500005],
              [21.752126498000052, 60.11517975500004],
              [21.720225457000083, 60.113714911000045],
              [21.69581139400009, 60.12164948100008],
              [21.70443769600007, 60.12689850500004],
              [21.706879102000073, 60.12958405200004],
              [21.702647332000083, 60.14215729400007],
              [21.71729576900009, 60.14838288000004],
              [21.722504102000073, 60.149603583000044],
              [21.722504102000073, 60.15582916900007],
              [21.705088738000086, 60.16071198100008],
              [21.708181186000047, 60.17177969000005],
              [21.723480665000068, 60.183579820000034],
              [21.743662957000083, 60.190619208000044],
            ],
          ],
          [
            [
              [21.35328209700009, 60.21108633000006],
              [21.36890709700009, 60.196600653000075],
              [21.394379102000073, 60.19086334800005],
              [21.44890384200005, 60.190619208000044],
              [21.44890384200005, 60.18374258000006],
              [21.409353061000047, 60.18451569200005],
              [21.39421634200005, 60.17865631700005],
              [21.387380405000044, 60.16266510600008],
              [21.38054446700005, 60.16266510600008],
              [21.372243686000047, 60.170355536000045],
              [21.35710696700005, 60.17446523600006],
              [21.325694207000083, 60.17633698100008],
              [21.310557488000086, 60.179388739000046],
              [21.300791863000086, 60.18573639500005],
              [21.289724155000044, 60.19086334800005],
              [21.270681186000047, 60.190619208000044],
              [21.285166863000086, 60.20384349200003],
              [21.30640709700009, 60.20970286700003],
              [21.35328209700009, 60.21108633000006],
            ],
          ],
          [
            [
              [22.058929884000065, 60.21108633000006],
              [22.07203209700009, 60.19676341400003],
              [22.011241082000083, 60.17011139500005],
              [22.017425977000073, 60.167303778000075],
              [22.031504754000082, 60.15851471600007],
              [22.037852410000085, 60.15582916900007],
              [22.009287957000083, 60.13727448100008],
              [21.977712436000047, 60.13548411700003],
              [21.950694207000083, 60.14907461100006],
              [21.935394727000073, 60.17633698100008],
              [21.95020592500009, 60.18138255400004],
              [21.997569207000083, 60.190619208000044],
              [22.026540561000047, 60.20575592700004],
              [22.041758660000085, 60.21141185100004],
              [22.058929884000065, 60.21108633000006],
            ],
          ],
          [
            [
              [25.81421959700009, 60.20766836100006],
              [25.82203209700009, 60.21629466400003],
              [25.840586785000085, 60.218817450000074],
              [25.876231316000087, 60.217230536000045],
              [25.863129102000073, 60.20425039300005],
              [25.85206139400009, 60.19977448100008],
              [25.83562259200005, 60.19603099200003],
              [25.820648634000065, 60.19721100500004],
              [25.81421959700009, 60.20766836100006],
            ],
          ],
          [
            [
              [22.209239129000082, 60.20425039300005],
              [22.22242272200009, 60.223863023000035],
              [22.24586022200009, 60.243068752000056],
              [22.271657748000052, 60.25299713700008],
              [22.291758660000085, 60.24518463700008],
              [22.296885613000086, 60.22125885600008],
              [22.26929772200009, 60.19586823100008],
              [22.232269727000073, 60.18496328300006],
              [22.209239129000082, 60.20425039300005],
            ],
          ],
          [
            [
              [25.622325066000087, 60.238348700000074],
              [25.592051629000082, 60.24258047100005],
              [25.570160352000073, 60.25804271000004],
              [25.564463738000086, 60.27826569200005],
              [25.58171634200005, 60.29637278900003],
              [25.598317905000044, 60.290716864000046],
              [25.684418165000068, 60.24518463700008],
              [25.677012566000087, 60.238348700000074],
              [25.65992272200009, 60.234442450000074],
              [25.643728061000047, 60.22809479400007],
              [25.63379967500009, 60.21832916900007],
              [25.635996941000087, 60.20425039300005],
              [25.611582879000082, 60.21124909100007],
              [25.603363477000073, 60.21539948100008],
              [25.608164910000085, 60.22239817900004],
              [25.622325066000087, 60.238348700000074],
            ],
          ],
          [
            [
              [22.84351647200009, 60.24176666900007],
              [22.86573326900009, 60.265326239000046],
              [22.890961134000065, 60.28554922100005],
              [22.920746290000068, 60.29669830900008],
              [22.95639082100007, 60.292954820000034],
              [22.949473504000082, 60.27045319200005],
              [22.930430535000085, 60.25722890800006],
              [22.906423373000052, 60.24746328300006],
              [22.88453209700009, 60.23529694200005],
              [22.87745201900009, 60.22565338700008],
              [22.873057488000086, 60.21552155200004],
              [22.86687259200005, 60.207464911000045],
              [22.839854363000086, 60.20111725500004],
              [22.833506707000083, 60.193060614000046],
              [22.833994988000086, 60.182074286000045],
              [22.84034264400009, 60.17011139500005],
              [22.833506707000083, 60.169256903000075],
              [22.828868035000085, 60.16714101800005],
              [22.824554884000065, 60.16461823100008],
              [22.81934655000009, 60.16266510600008],
              [22.825043165000068, 60.161444403000075],
              [22.84034264400009, 60.15582916900007],
              [22.83570397200009, 60.14594147300005],
              [22.83301842500009, 60.14215729400007],
              [22.846853061000047, 60.111029364000046],
              [22.813161655000044, 60.082098700000074],
              [22.730479363000086, 60.046576239000046],
              [22.730479363000086, 60.03974030200004],
              [22.739756707000083, 60.04010651200008],
              [22.74577884200005, 60.03847890800006],
              [22.757985873000052, 60.03229401200008],
              [22.748220248000052, 60.02619049700007],
              [22.735118035000085, 60.00861237200007],
              [22.72982832100007, 60.00495026200008],
              [22.705414259000065, 60.00690338700008],
              [22.694834832000083, 60.005113023000035],
              [22.68213951900009, 59.99750397300005],
              [22.669200066000087, 60.01630280200004],
              [22.654958530000044, 60.03229401200008],
              [22.64625084700009, 60.021918036000045],
              [22.613942905000044, 60.001654364000046],
              [22.60840905000009, 60.00014883000006],
              [22.605316602000073, 59.99591705900008],
              [22.60645592500009, 59.98452383000006],
              [22.600271030000044, 59.98452383000006],
              [22.601898634000065, 59.998480536000045],
              [22.59896894600007, 60.00804271000004],
              [22.59148196700005, 60.010931708000044],
              [22.57911217500009, 60.00495026200008],
              [22.574880405000044, 60.01703522300005],
              [22.580821160000085, 60.024603583000044],
              [22.58961022200009, 60.03278229400007],
              [22.59343509200005, 60.046576239000046],
              [22.581553582000083, 60.03864166900007],
              [22.54623457100007, 60.020819403000075],
              [22.529958530000044, 60.008246161000045],
              [22.486338738000086, 60.00185781500005],
              [22.469899936000047, 59.99750397300005],
              [22.469574415000068, 60.02366771000004],
              [22.47169030000009, 60.03563060100004],
              [22.477305535000085, 60.046576239000046],
              [22.471446160000085, 60.05898672100005],
              [22.473399285000085, 60.07123444200005],
              [22.47632897200009, 60.08222077000005],
              [22.47364342500009, 60.09096914300005],
              [22.461761915000068, 60.09756094000005],
              [22.434825066000087, 60.105129299000055],
              [22.422129754000082, 60.11481354400007],
              [22.44304446700005, 60.11871979400007],
              [22.480479363000086, 60.13231028900003],
              [22.500824415000068, 60.13532135600008],
              [22.600271030000044, 60.13532135600008],
              [22.600271030000044, 60.14215729400007],
              [22.415212436000047, 60.149603583000044],
              [22.426117384000065, 60.17133209800005],
              [22.433929884000065, 60.19940827000005],
              [22.448090040000068, 60.22138092700004],
              [22.477305535000085, 60.224676825000074],
              [22.455902540000068, 60.20001862200007],
              [22.451019727000073, 60.18854401200008],
              [22.46648196700005, 60.18374258000006],
              [22.566579623000052, 60.19330475500004],
              [22.60206139400009, 60.206366278000075],
              [22.620616082000083, 60.21108633000006],
              [22.81495201900009, 60.226996161000045],
              [22.84351647200009, 60.24176666900007],
            ],
          ],
          [
            [
              [22.10678144600007, 60.31346263200004],
              [22.132009311000047, 60.315659898000035],
              [22.24976647200009, 60.31146881700005],
              [22.32129967500009, 60.29706452000005],
              [22.33961022200009, 60.28620026200008],
              [22.337168816000087, 60.27448151200008],
              [22.33179772200009, 60.26943594000005],
              [22.312836134000065, 60.265692450000074],
              [22.30518639400009, 60.26675039300005],
              [22.297699415000068, 60.270738023000035],
              [22.289805535000085, 60.273138739000046],
              [22.281504754000082, 60.26911041900007],
              [22.277598504000082, 60.26630280200004],
              [22.26539147200009, 60.26007721600007],
              [22.260996941000087, 60.25885651200008],
              [22.215505405000044, 60.253119208000044],
              [22.20085696700005, 60.254339911000045],
              [22.216644727000073, 60.265692450000074],
              [22.203949415000068, 60.27631256700005],
              [22.181162957000083, 60.281317450000074],
              [22.156993035000085, 60.28172435100004],
              [22.140879754000082, 60.27871328300006],
              [22.181895379000082, 60.27871328300006],
              [22.163340691000087, 60.25922272300005],
              [22.136892123000052, 60.26239655200004],
              [22.109629754000082, 60.27130768400008],
              [22.089366082000083, 60.26911041900007],
              [22.080088738000086, 60.26947663000004],
              [22.07667076900009, 60.28351471600007],
              [22.083832227000073, 60.30145905200004],
              [22.10678144600007, 60.31346263200004],
            ],
          ],
          [
            [
              [22.387950066000087, 60.32094961100006],
              [22.369883660000085, 60.314520575000074],
              [22.35059655000009, 60.313666083000044],
              [22.312836134000065, 60.32094961100006],
              [22.329356316000087, 60.33734772300005],
              [22.350271030000044, 60.34784577000005],
              [22.373708530000044, 60.35342031500005],
              [22.39820397200009, 60.35504791900007],
              [22.401866082000083, 60.35309479400007],
              [22.40170332100007, 60.34861888200004],
              [22.400645379000082, 60.34398021000004],
              [22.401621941000087, 60.34137604400007],
              [22.428965691000087, 60.33392975500004],
              [22.44385826900009, 60.333238023000035],
              [22.45753014400009, 60.33413320500006],
              [22.469004754000082, 60.33152903900003],
              [22.477305535000085, 60.32094961100006],
              [22.45443769600007, 60.30890534100007],
              [22.425303582000083, 60.29905833500004],
              [22.394786004000082, 60.29315827000005],
              [22.367442254000082, 60.292954820000034],
              [22.374522332000083, 60.29922109600005],
              [22.37989342500009, 60.30609772300005],
              [22.387950066000087, 60.32094961100006],
            ],
          ],
          [
            [
              [21.997569207000083, 60.33392975500004],
              [21.979665561000047, 60.32859935100004],
              [21.96062259200005, 60.32754140800006],
              [21.94109134200005, 60.32957591400003],
              [21.921722852000073, 60.33392975500004],
              [21.918711785000085, 60.33266836100006],
              [21.91382897200009, 60.329413153000075],
              [21.90788821700005, 60.32672760600008],
              [21.90137780000009, 60.32709381700005],
              [21.900726759000065, 60.32953522300005],
              [21.90170332100007, 60.33901601800005],
              [21.90137780000009, 60.34137604400007],
              [21.879242384000065, 60.350897528000075],
              [21.868418816000087, 60.353949286000045],
              [21.837412957000083, 60.35757070500006],
              [21.814463738000086, 60.36424388200004],
              [21.794118686000047, 60.37396881700005],
              [21.785329623000052, 60.38544342700004],
              [21.792246941000087, 60.39695872600004],
              [21.808848504000082, 60.40521881700005],
              [21.828868035000085, 60.40961334800005],
              [21.846039259000065, 60.40965403900003],
              [21.846039259000065, 60.41648997600004],
              [21.798350457000083, 60.443793036000045],
              [21.801931186000047, 60.45677317900004],
              [21.808116082000083, 60.46670156500005],
              [21.817881707000083, 60.471991278000075],
              [21.832367384000065, 60.471136786000045],
              [21.848399285000085, 60.46381256700005],
              [21.89234459700009, 60.449204820000034],
              [21.90137780000009, 60.44037506700005],
              [21.904633009000065, 60.431626695000034],
              [21.912852410000085, 60.42645905200004],
              [21.923024936000047, 60.42397695500006],
              [21.931976759000065, 60.42332591400003],
              [21.950368686000047, 60.40216705900008],
              [21.950368686000047, 60.39598216400003],
              [21.921071811000047, 60.40119049700007],
              [21.906993035000085, 60.40176015800006],
              [21.894541863000086, 60.39598216400003],
              [21.90796959700009, 60.39044830900008],
              [21.936778191000087, 60.38263580900008],
              [21.950368686000047, 60.37555573100008],
              [21.942230665000068, 60.36810944200005],
              [21.974864129000082, 60.36945221600007],
              [21.988617384000065, 60.36591217700004],
              [21.997569207000083, 60.35504791900007],
              [21.973317905000044, 60.34784577000005],
              [21.96338951900009, 60.34760163000004],
              [21.97950280000009, 60.34259674700007],
              [21.98796634200005, 60.34125397300005],
              [21.997569207000083, 60.34137604400007],
              [21.997569207000083, 60.33392975500004],
            ],
          ],
          [
            [
              [21.72592207100007, 60.481675523000035],
              [21.715098504000082, 60.47089264500005],
              [21.700694207000083, 60.45970286700003],
              [21.68799889400009, 60.45530833500004],
              [21.681651238000086, 60.464911200000074],
              [21.690928582000083, 60.484076239000046],
              [21.71420332100007, 60.50861237200007],
              [21.74187259200005, 60.52643463700008],
              [21.76417076900009, 60.52578359600005],
              [21.760508660000085, 60.51203034100007],
              [21.750824415000068, 60.501654364000046],
              [21.72592207100007, 60.481675523000035],
            ],
          ],
          [
            [
              [21.319102410000085, 60.481675523000035],
              [21.30014082100007, 60.48773834800005],
              [21.265961134000065, 60.49005768400008],
              [21.250254754000082, 60.49843984600005],
              [21.260590040000068, 60.51972077000005],
              [21.25294030000009, 60.53139883000006],
              [21.238454623000052, 60.54193756700005],
              [21.229177280000044, 60.559881903000075],
              [21.250254754000082, 60.559881903000075],
              [21.278493686000047, 60.542303778000075],
              [21.304942254000082, 60.51894765800006],
              [21.30762780000009, 60.50958893400008],
              [21.324880405000044, 60.482082424000055],
              [21.319102410000085, 60.481675523000035],
            ],
          ],
          [
            [
              [21.39421634200005, 60.559881903000075],
              [21.410980665000068, 60.54291413000004],
              [21.46192467500009, 60.53937409100007],
              [21.482269727000073, 60.52578359600005],
              [21.477793816000087, 60.52521393400008],
              [21.474782748000052, 60.52407461100006],
              [21.470713738000086, 60.52374909100007],
              [21.463145379000082, 60.52578359600005],
              [21.458506707000083, 60.51609935100004],
              [21.456309441000087, 60.50678131700005],
              [21.45753014400009, 60.49852122600004],
              [21.463145379000082, 60.492254950000074],
              [21.446462436000047, 60.493353583000044],
              [21.433604363000086, 60.48908112200007],
              [21.43067467500009, 60.48114655200004],
              [21.442637566000087, 60.471136786000045],
              [21.41765384200005, 60.47768789300005],
              [21.39226321700005, 60.48997630400004],
              [21.371267123000052, 60.50836823100008],
              [21.360118035000085, 60.533189195000034],
              [21.346934441000087, 60.52289459800005],
              [21.336110873000052, 60.51943594000005],
              [21.32862389400009, 60.52533600500004],
              [21.32593834700009, 60.54315827000005],
              [21.333832227000073, 60.55735911700003],
              [21.35254967500009, 60.561835028000075],
              [21.39421634200005, 60.559881903000075],
            ],
          ],
          [
            [
              [21.298675977000073, 60.56732819200005],
              [21.28101647200009, 60.56635163000004],
              [21.273285352000073, 60.57282135600008],
              [21.269786004000082, 60.581691799000055],
              [21.264414910000085, 60.58783600500004],
              [21.244395379000082, 60.59080638200004],
              [21.233164910000085, 60.59389883000006],
              [21.222911004000082, 60.60146719000005],
              [21.21387780000009, 60.61635976800005],
              [21.219086134000065, 60.62262604400007],
              [21.243418816000087, 60.62872955900008],
              [21.249196811000047, 60.63568756700005],
              [21.25326582100007, 60.64350006700005],
              [21.259287957000083, 60.64752838700008],
              [21.270681186000047, 60.64305247600004],
              [21.271494988000086, 60.634466864000046],
              [21.274912957000083, 60.62677643400008],
              [21.281260613000086, 60.620306708000044],
              [21.291188998000052, 60.61513906500005],
              [21.283376498000052, 60.600897528000075],
              [21.27833092500009, 60.58612702000005],
              [21.281504754000082, 60.57562897300005],
              [21.298675977000073, 60.57416413000004],
              [21.298675977000073, 60.56732819200005],
            ],
          ],
          [
            [
              [21.264414910000085, 60.882025458000044],
              [21.231700066000087, 60.882025458000044],
              [21.21656334700009, 60.884100653000075],
              [21.202403191000087, 60.88947174700007],
              [21.227793816000087, 60.899725653000075],
              [21.276621941000087, 60.889105536000045],
              [21.298675977000073, 60.895697333000044],
              [21.295258009000065, 60.899644273000035],
              [21.293793165000068, 60.90298086100006],
              [21.292816602000073, 60.90615469000005],
              [21.291188998000052, 60.90997955900008],
              [21.29737389400009, 60.91229889500005],
              [21.30640709700009, 60.91933828300006],
              [21.31226647200009, 60.92300039300005],
              [21.283213738000086, 60.94281647300005],
              [21.264821811000047, 60.94961172100005],
              [21.243418816000087, 60.950873114000046],
              [21.27003014400009, 60.967962958000044],
              [21.285004102000073, 60.971991278000075],
              [21.304942254000082, 60.97138092700004],
              [21.32195071700005, 60.956244208000044],
              [21.337087436000047, 60.94672272300005],
              [21.374278191000087, 60.93040599200003],
              [21.354746941000087, 60.91986725500004],
              [21.338552280000044, 60.91669342700004],
              [21.32789147200009, 60.910142320000034],
              [21.32593834700009, 60.88947174700007],
              [21.31812584700009, 60.880194403000075],
              [21.29737389400009, 60.87913646000004],
              [21.275238477000073, 60.88328685100004],
              [21.264414910000085, 60.882025458000044],
            ],
          ],
          [
            [
              [21.422129754000082, 63.24681224200003],
              [21.415212436000047, 63.23346588700008],
              [21.414805535000085, 63.22044505400004],
              [21.41960696700005, 63.208685614000046],
              [21.428396030000044, 63.198431708000044],
              [21.404551629000082, 63.19253164300005],
              [21.37745201900009, 63.19013092700004],
              [21.363942905000044, 63.19367096600007],
              [21.38054446700005, 63.20587799700007],
              [21.362803582000083, 63.206244208000044],
              [21.291188998000052, 63.17792389500005],
              [21.291188998000052, 63.171128648000035],
              [21.29818769600007, 63.17023346600007],
              [21.318532748000052, 63.164943752000056],
              [21.301524285000085, 63.15615469000005],
              [21.283457879000082, 63.15192291900007],
              [21.243418816000087, 63.15070221600007],
              [21.231130405000044, 63.15839264500005],
              [21.21924889400009, 63.169623114000046],
              [21.207367384000065, 63.18333567900004],
              [21.18881269600007, 63.19159577000005],
              [21.175791863000086, 63.18829987200007],
              [21.161631707000083, 63.18195221600007],
              [21.147227410000085, 63.18219635600008],
              [21.133555535000085, 63.198431708000044],
              [21.154551629000082, 63.198431708000044],
              [21.154551629000082, 63.20587799700007],
              [21.14161217500009, 63.21067942900004],
              [21.113129102000073, 63.22748444200005],
              [21.102793816000087, 63.235988674000055],
              [21.096527540000068, 63.24551015800006],
              [21.08179772200009, 63.27728913000004],
              [21.078949415000068, 63.28778717700004],
              [21.120290561000047, 63.27195872600004],
              [21.159434441000087, 63.27374909100007],
              [21.199473504000082, 63.28070709800005],
              [21.243418816000087, 63.28099192900004],
              [21.243418816000087, 63.27480703300006],
              [21.227224155000044, 63.27163320500006],
              [21.215179884000065, 63.26386139500005],
              [21.19507897200009, 63.23940664300005],
              [21.197927280000044, 63.23159414300005],
              [21.199473504000082, 63.23029205900008],
              [21.19890384200005, 63.230169989000046],
              [21.19507897200009, 63.225775458000044],
              [21.20948326900009, 63.22138092700004],
              [21.264414910000085, 63.21954987200007],
              [21.272227410000085, 63.21710846600007],
              [21.279470248000052, 63.21308014500005],
              [21.28679446700005, 63.211371161000045],
              [21.294932488000086, 63.21580638200004],
              [21.29786217500009, 63.22304922100005],
              [21.29460696700005, 63.22890859600005],
              [21.29037519600007, 63.23419830900008],
              [21.291188998000052, 63.23940664300005],
              [21.31576582100007, 63.251939195000034],
              [21.35596764400009, 63.26072825700004],
              [21.396332227000073, 63.26068756700005],
              [21.422129754000082, 63.24681224200003],
            ],
          ],
          [
            [
              [21.318532748000052, 63.28778717700004],
              [21.315277540000068, 63.304022528000075],
              [21.305918816000087, 63.305894273000035],
              [21.29265384200005, 63.30219147300005],
              [21.277517123000052, 63.30145905200004],
              [21.229177280000044, 63.32880280200004],
              [21.23406009200005, 63.33283112200007],
              [21.23878014400009, 63.33437734600005],
              [21.250254754000082, 63.33502838700008],
              [21.276621941000087, 63.34076569200005],
              [21.31104576900009, 63.35561758000006],
              [21.345957879000082, 63.36375560100004],
              [21.374278191000087, 63.349269924000055],
              [21.373871290000068, 63.33340078300006],
              [21.358246290000068, 63.315659898000035],
              [21.318532748000052, 63.28778717700004],
            ],
          ],
          [
            [
              [24.99343691000007, 65.05510357200006],
              [25.033586393000064, 65.05751195800008],
              [25.06181765000008, 65.04347960300004],
              [25.02800871900007, 65.03461882400006],
              [24.962218371000063, 65.03477891100005],
              [24.87737609800007, 65.04525499300007],
              [24.81965686500007, 65.04328027800005],
              [24.801552192000088, 65.02426616500009],
              [24.722366527000077, 65.00346692900007],
              [24.75077494700008, 64.97596560000005],
              [24.812388274000057, 64.97919362900006],
              [24.827321811000047, 64.97296784100007],
              [24.81609134200005, 64.96808502800008],
              [24.804698113000086, 64.96723053600005],
              [24.792816602000073, 64.96771881700005],
              [24.780121290000068, 64.96678294500003],
              [24.77125084700009, 64.96385325700004],
              [24.76107832100007, 64.95644765800006],
              [24.752126498000052, 64.95311107000003],
              [24.734711134000065, 64.95091380400004],
              [24.713145379000082, 64.95172760600008],
              [24.700694207000083, 64.95815664300005],
              [24.71062259200005, 64.97296784100007],
              [24.70606530000009, 64.97650788000004],
              [24.697520379000082, 64.98663971600007],
              [24.683929884000065, 64.99656810100004],
              [24.658376498000052, 64.97199127800008],
              [24.631602410000085, 64.96784088700008],
              [24.59736672200006, 64.99251835200005],
              [24.579008785000042, 65.00953603500005],
              [24.569900396000037, 65.02291480200006],
              [24.562754754000082, 65.03717682500007],
              [24.585785352000073, 65.04938385600008],
              [24.65419012500007, 65.08022052600006],
              [24.740887989000043, 65.08327202200007],
              [24.83450553600005, 65.09480030700007],
              [24.883095541000046, 65.08690405900006],
              [24.896982584000057, 65.07241547400008],
              [24.873012834000065, 65.06583442900006],
              [24.88284235100008, 65.05913917800007],
              [24.906521871000052, 65.06048224000006],
              [24.936266979000038, 65.05914173300005],
              [24.99343691000007, 65.05510357200006],
            ],
          ],
          [
            [
              [23.915212436000047, 59.97345612200007],
              [23.92351321700005, 59.96930573100008],
              [23.920095248000052, 59.96775950700004],
              [23.92042076900009, 59.959418036000045],
              [23.90870201900009, 59.95380280200004],
              [23.896006707000083, 59.954291083000044],
              [23.895681186000047, 59.951239325000074],
              [23.89421634200005, 59.94969310100004],
              [23.88607832100007, 59.94798411700003],
              [23.87077884200005, 59.94672272300005],
              [23.856211785000085, 59.95331452000005],
              [23.850433790000068, 59.95258209800005],
              [23.84742272200009, 59.95465729400007],
              [23.85401451900009, 59.962876695000034],
              [23.870290561000047, 59.97280508000006],
              [23.89226321700005, 59.97650788000004],
              [23.915212436000047, 59.97345612200007],
            ],
          ],
          [
            [
              [22.887380405000044, 60.06777578300006],
              [22.91773522200009, 60.06867096600007],
              [22.926605665000068, 60.06537506700005],
              [22.91960696700005, 60.05833567900004],
              [22.916840040000068, 60.04922109600005],
              [22.910980665000068, 60.04157135600008],
              [22.906586134000065, 60.038397528000075],
              [22.900726759000065, 60.037543036000045],
              [22.893402540000068, 60.03314850500004],
              [22.884043816000087, 60.01935455900008],
              [22.880056186000047, 60.011053778000075],
              [22.872243686000047, 60.00604889500005],
              [22.859548373000052, 60.011419989000046],
              [22.851084832000083, 60.02789948100008],
              [22.855723504000082, 60.04132721600007],
              [22.88331139400009, 60.04311758000006],
              [22.88379967500009, 60.048081773000035],
              [22.875173373000052, 60.05149974200003],
              [22.861989780000044, 60.05190664300005],
              [22.85515384200005, 60.055568752000056],
              [22.863291863000086, 60.062567450000074],
              [22.887380405000044, 60.06777578300006],
            ],
          ],
          [
            [
              [22.95753014400009, 60.11078522300005],
              [22.961680535000085, 60.104396877000056],
              [22.963145379000082, 60.096869208000044],
              [22.957286004000082, 60.08885325700004],
              [22.946787957000083, 60.08470286700003],
              [22.93685957100007, 60.08388906500005],
              [22.931976759000065, 60.08588288000004],
              [22.93327884200005, 60.08974844000005],
              [22.927907748000052, 60.089911200000074],
              [22.91504967500009, 60.08470286700003],
              [22.89893639400009, 60.08100006700005],
              [22.870371941000087, 60.08152903900003],
              [22.861582879000082, 60.08104075700004],
              [22.84546959700009, 60.08222077000005],
              [22.84506269600007, 60.08576080900008],
              [22.856618686000047, 60.09162018400008],
              [22.864024285000085, 60.100816148000035],
              [22.873301629000082, 60.10984935100004],
              [22.879730665000068, 60.11367422100005],
              [22.89161217500009, 60.11908600500004],
              [22.91700280000009, 60.125067450000074],
              [22.937673373000052, 60.124335028000075],
              [22.950043165000068, 60.11863841400003],
              [22.95753014400009, 60.11078522300005],
            ],
          ],
          [
            [
              [21.99154707100007, 60.12995026200008],
              [21.99976647200009, 60.12848541900007],
              [22.012380405000044, 60.122748114000046],
              [22.007334832000083, 60.11546458500004],
              [21.98764082100007, 60.11204661700003],
              [21.971364780000044, 60.111395575000074],
              [21.94385826900009, 60.11347077000005],
              [21.939300977000073, 60.11627838700008],
              [21.929942254000082, 60.12457916900007],
              [21.935720248000052, 60.131293036000045],
              [21.95053144600007, 60.13572825700004],
              [21.962087436000047, 60.137884833000044],
              [21.977224155000044, 60.13076406500005],
              [21.99154707100007, 60.12995026200008],
            ],
          ],
          [
            [
              [22.313161655000044, 60.19196198100008],
              [22.375010613000086, 60.20404694200005],
              [22.385590040000068, 60.19525788000004],
              [22.367930535000085, 60.177394924000055],
              [22.34424889400009, 60.168850002000056],
              [22.31999759200005, 60.164048570000034],
              [22.319102410000085, 60.16010163000004],
              [22.333262566000087, 60.15403880400004],
              [22.33692467500009, 60.148504950000074],
              [22.323741082000083, 60.14687734600005],
              [22.298675977000073, 60.14687734600005],
              [22.288340691000087, 60.14984772300005],
              [22.292165561000047, 60.152044989000046],
              [22.292246941000087, 60.156317450000074],
              [22.29078209700009, 60.16461823100008],
              [22.293711785000085, 60.170355536000045],
              [22.29818769600007, 60.17255280200004],
              [22.299082879000082, 60.17593008000006],
              [22.29932701900009, 60.18219635600008],
              [22.304535352000073, 60.188788153000075],
              [22.313161655000044, 60.19196198100008],
            ],
          ],
          [
            [
              [21.983164910000085, 60.28497955900008],
              [21.976817254000082, 60.28457265800006],
              [21.972911004000082, 60.28534577000005],
              [21.97901451900009, 60.28925202000005],
              [21.996348504000082, 60.296128648000035],
              [22.00831139400009, 60.297308661000045],
              [22.006032748000052, 60.29214101800005],
              [21.99577884200005, 60.28729889500005],
              [21.983164910000085, 60.28497955900008],
            ],
          ],
          [
            [
              [21.956879102000073, 60.28139883000006],
              [21.944590691000087, 60.27708567900004],
              [21.925954623000052, 60.27728913000004],
              [21.909678582000083, 60.28009674700007],
              [21.896006707000083, 60.28969961100006],
              [21.884938998000052, 60.289496161000045],
              [21.875336134000065, 60.30487702000005],
              [21.879730665000068, 60.310532945000034],
              [21.895192905000044, 60.310614325000074],
              [21.908539259000065, 60.30939362200007],
              [21.92546634200005, 60.31264883000006],
              [21.959808790000068, 60.312160549000055],
              [21.973806186000047, 60.30931224200003],
              [21.975352410000085, 60.30255768400008],
              [21.956879102000073, 60.28139883000006],
            ],
          ],
          [
            [
              [22.299652540000068, 60.36758047100005],
              [22.28956139400009, 60.35797760600008],
              [22.20215905000009, 60.34320709800005],
              [22.19109134200005, 60.34174225500004],
              [22.170176629000082, 60.344183661000045],
              [22.15723717500009, 60.35187409100007],
              [22.157074415000068, 60.358303127000056],
              [22.164235873000052, 60.36163971600007],
              [22.255707227000073, 60.37417226800005],
              [22.28492272200009, 60.374986070000034],
              [22.299652540000068, 60.36758047100005],
            ],
          ],
          [
            [
              [22.206228061000047, 60.38255442900004],
              [22.20753014400009, 60.37555573100008],
              [22.112478061000047, 60.35293203300006],
              [22.104258660000085, 60.35415273600006],
              [22.12208092500009, 60.37164948100008],
              [22.137868686000047, 60.37909577000005],
              [22.146820509000065, 60.38043854400007],
              [22.206228061000047, 60.38255442900004],
            ],
          ],
          [
            [
              [21.338063998000052, 60.38336823100008],
              [21.352305535000085, 60.370428778000075],
              [21.35710696700005, 60.35814036700003],
              [21.355316602000073, 60.35179271000004],
              [21.352793816000087, 60.351629950000074],
              [21.345713738000086, 60.35382721600007],
              [21.33838951900009, 60.35309479400007],
              [21.33366946700005, 60.35602448100008],
              [21.333994988000086, 60.362982489000046],
              [21.33106530000009, 60.36517975500004],
              [21.323741082000083, 60.36668528900003],
              [21.303884311000047, 60.36424388200004],
              [21.294444207000083, 60.37051015800006],
              [21.296153191000087, 60.37759023600006],
              [21.302989129000082, 60.383693752000056],
              [21.307790561000047, 60.38959381700005],
              [21.319834832000083, 60.391506252000056],
              [21.338063998000052, 60.38336823100008],
            ],
          ],
          [
            [
              [26.60206139400009, 60.446519273000035],
              [26.644053582000083, 60.43187083500004],
              [26.652598504000082, 60.42690664300005],
              [26.649668816000087, 60.421535549000055],
              [26.63648522200009, 60.41486237200007],
              [26.573090040000068, 60.40534088700008],
              [26.558929884000065, 60.39740631700005],
              [26.54859459700009, 60.37836334800005],
              [26.538340691000087, 60.37807851800005],
              [26.526133660000085, 60.38515859600005],
              [26.50717207100007, 60.40346914300005],
              [26.51343834700009, 60.41128164300005],
              [26.560883009000065, 60.41681549700007],
              [26.57471764400009, 60.42177969000005],
              [26.580739780000044, 60.427394924000055],
              [26.580251498000052, 60.43463776200008],
              [26.58497155000009, 60.441066799000055],
              [26.59343509200005, 60.44594961100006],
              [26.60206139400009, 60.446519273000035],
            ],
          ],
          [
            [
              [22.026215040000068, 63.32221100500004],
              [22.033457879000082, 63.32208893400008],
              [22.060801629000082, 63.30215078300006],
              [22.058116082000083, 63.29486725500004],
              [22.04664147200009, 63.28217194200005],
              [22.02979576900009, 63.277411200000074],
              [22.013845248000052, 63.27773672100005],
              [22.007090691000087, 63.28107330900008],
              [22.008148634000065, 63.28823476800005],
              [22.004567905000044, 63.29116445500006],
              [21.99781334700009, 63.28900788000004],
              [21.995616082000083, 63.28473541900007],
              [21.99463951900009, 63.28009674700007],
              [21.98991946700005, 63.27757396000004],
              [21.984385613000086, 63.27716705900008],
              [21.97828209700009, 63.28001536700003],
              [21.97437584700009, 63.286810614000046],
              [21.977712436000047, 63.29865143400008],
              [21.989024285000085, 63.31037018400008],
              [22.002289259000065, 63.31342194200005],
              [22.021820509000065, 63.30719635600008],
              [22.029958530000044, 63.30841705900008],
              [22.026215040000068, 63.31342194200005],
              [22.011973504000082, 63.320298570000034],
              [22.00757897200009, 63.32489655200004],
              [22.01270592500009, 63.32611725500004],
              [22.01856530000009, 63.326239325000074],
              [22.022227410000085, 63.323431708000044],
              [22.026215040000068, 63.32221100500004],
            ],
          ],
          [
            [
              [22.14421634200005, 63.25141022300005],
              [22.13648522200009, 63.25055573100008],
              [22.085459832000083, 63.261786200000074],
              [22.079356316000087, 63.26630280200004],
              [22.083181186000047, 63.27045319200005],
              [22.078461134000065, 63.27448151200008],
              [22.067067905000044, 63.278998114000046],
              [22.068695509000065, 63.28388092700004],
              [22.075694207000083, 63.28620026200008],
              [22.08334394600007, 63.28803131700005],
              [22.08887780000009, 63.294623114000046],
              [22.082774285000085, 63.30418528900003],
              [22.07276451900009, 63.31281159100007],
              [22.069183790000068, 63.31854889500005],
              [22.07862389400009, 63.321600653000075],
              [22.092621290000068, 63.32306549700007],
              [22.110199415000068, 63.32892487200007],
              [22.12354576900009, 63.32636139500005],
              [22.132090691000087, 63.32591380400004],
              [22.13998457100007, 63.32221100500004],
              [22.147959832000083, 63.31557851800005],
              [22.158213738000086, 63.31102122600004],
              [22.163584832000083, 63.311712958000044],
              [22.164398634000065, 63.31671784100007],
              [22.16968834700009, 63.31915924700007],
              [22.178558790000068, 63.31785716400003],
              [22.186289910000085, 63.31476471600007],
              [22.190603061000047, 63.310532945000034],
              [22.195648634000065, 63.309759833000044],
              [22.202647332000083, 63.31281159100007],
              [22.20801842500009, 63.31793854400007],
              [22.21070397200009, 63.325384833000044],
              [22.21534264400009, 63.33295319200005],
              [22.22169030000009, 63.33856842700004],
              [22.22632897200009, 63.34064362200007],
              [22.231293165000068, 63.33881256700005],
              [22.23568769600007, 63.331244208000044],
              [22.237071160000085, 63.325506903000075],
              [22.238942905000044, 63.313788153000075],
              [22.246267123000052, 63.307074286000045],
              [22.244476759000065, 63.30247630400004],
              [22.234385613000086, 63.29315827000005],
              [22.222666863000086, 63.27997467700004],
              [22.20866946700005, 63.27326080900008],
              [22.18726647200009, 63.273504950000074],
              [22.156504754000082, 63.28856028900003],
              [22.114431186000047, 63.28416575700004],
              [22.114105665000068, 63.28221263200004],
              [22.139008009000065, 63.27912018400008],
              [22.158539259000065, 63.27407461100006],
              [22.16309655000009, 63.263332424000055],
              [22.15723717500009, 63.25653717700004],
              [22.148692254000082, 63.25580475500004],
              [22.144053582000083, 63.25413646000004],
              [22.14421634200005, 63.25141022300005],
            ],
          ],
          [
            [
              [21.957204623000052, 63.33161041900007],
              [21.94898522200009, 63.33380768400008],
              [21.947276238000086, 63.337958075000074],
              [21.94898522200009, 63.34003327000005],
              [21.951345248000052, 63.34365469000005],
              [21.956228061000047, 63.349310614000046],
              [21.961192254000082, 63.35382721600007],
              [21.966075066000087, 63.359808661000045],
              [21.97169030000009, 63.36513906500005],
              [21.97820071700005, 63.36888255400004],
              [21.983653191000087, 63.37327708500004],
              [21.986582879000082, 63.37787506700005],
              [21.996429884000065, 63.38471100500004],
              [22.01465905000009, 63.38540273600006],
              [22.03028405000009, 63.38336823100008],
              [22.04590905000009, 63.38751862200007],
              [22.059825066000087, 63.388373114000046],
              [22.06495201900009, 63.38703034100007],
              [22.069834832000083, 63.385199286000045],
              [22.07943769600007, 63.38349030200004],
              [22.089121941000087, 63.38393789300005],
              [22.096039259000065, 63.38349030200004],
              [22.096039259000065, 63.38031647300005],
              [22.08887780000009, 63.37763092700004],
              [22.07943769600007, 63.37685781500005],
              [22.080251498000052, 63.37360260600008],
              [22.085134311000047, 63.36701080900008],
              [22.076182488000086, 63.36005280200004],
              [22.059336785000085, 63.357855536000045],
              [22.026866082000083, 63.36615631700005],
              [22.01270592500009, 63.363714911000045],
              [22.001963738000086, 63.35419342700004],
              [21.99708092500009, 63.34845612200007],
              [21.98414147200009, 63.341131903000075],
              [21.966075066000087, 63.33315664300005],
              [21.957204623000052, 63.33161041900007],
            ],
          ],
          [
            [
              [22.80795332100007, 63.77952708500004],
              [22.823415561000047, 63.77924225500004],
              [22.828868035000085, 63.77631256700005],
              [22.82553144600007, 63.77285390800006],
              [22.821136915000068, 63.771470445000034],
              [22.82007897200009, 63.768866278000075],
              [22.819102410000085, 63.76325104400007],
              [22.815196160000085, 63.75649648600006],
              [22.812022332000083, 63.75348541900007],
              [22.809418165000068, 63.74713776200008],
              [22.80209394600007, 63.73818594000005],
              [22.793223504000082, 63.740220445000034],
              [22.782074415000068, 63.74481842700004],
              [22.777191602000073, 63.74176666900007],
              [22.780446811000047, 63.73432038000004],
              [22.776052280000044, 63.728176174000055],
              [22.764496290000068, 63.72703685100004],
              [22.756602410000085, 63.722723700000074],
              [22.73959394600007, 63.72052643400008],
              [22.71924889400009, 63.726629950000074],
              [22.70289147200009, 63.736395575000074],
              [22.692230665000068, 63.75112539300005],
              [22.687022332000083, 63.755113023000035],
              [22.683116082000083, 63.75861237200007],
              [22.681488477000073, 63.76341380400004],
              [22.702972852000073, 63.76976146000004],
              [22.71143639400009, 63.77338288000004],
              [22.719574415000068, 63.77887604400007],
              [22.73731530000009, 63.785589911000045],
              [22.763845248000052, 63.791449286000045],
              [22.78174889400009, 63.79043203300006],
              [22.789805535000085, 63.78375885600008],
              [22.795664910000085, 63.77765534100007],
              [22.800303582000083, 63.77606842700004],
              [22.80445397200009, 63.778225002000056],
              [22.80795332100007, 63.77952708500004],
            ],
          ],
          [
            [
              [22.49854576900009, 59.87763092700004],
              [22.51026451900009, 59.876288153000075],
              [22.512868686000047, 59.87372467700004],
              [22.505056186000047, 59.86871979400007],
              [22.443695509000065, 59.85146719000005],
              [22.427744988000086, 59.84951406500005],
              [22.416026238000086, 59.85293203300006],
              [22.41382897200009, 59.86123281500005],
              [22.421885613000086, 59.865668036000045],
              [22.427744988000086, 59.86591217700004],
              [22.433767123000052, 59.86676666900007],
              [22.457041863000086, 59.87299225500004],
              [22.48015384200005, 59.874335028000075],
              [22.488129102000073, 59.876654364000046],
              [22.49854576900009, 59.87763092700004],
            ],
          ],
          [
            [
              [21.600433790000068, 60.25482819200005],
              [21.615896030000044, 60.255194403000075],
              [21.62671959700009, 60.25259023600006],
              [21.62159264400009, 60.24310944200005],
              [21.610118035000085, 60.23484935100004],
              [21.60645592500009, 60.22825755400004],
              [21.601735873000052, 60.22256094000005],
              [21.59229576900009, 60.22174713700008],
              [21.587412957000083, 60.22256094000005],
              [21.57789147200009, 60.22162506700005],
              [21.56348717500009, 60.226223049000055],
              [21.56226647200009, 60.239935614000046],
              [21.571055535000085, 60.255926825000074],
              [21.58692467500009, 60.26935455900008],
              [21.604665561000047, 60.268784898000035],
              [21.60678144600007, 60.26068756700005],
              [21.59742272200009, 60.257025458000044],
              [21.600433790000068, 60.25482819200005],
            ],
          ],
          [
            [
              [21.25953209700009, 60.85309479400007],
              [21.26734459700009, 60.85106028900003],
              [21.267588738000086, 60.83779531500005],
              [21.263194207000083, 60.83026764500005],
              [21.250173373000052, 60.83295319200005],
              [21.209808790000068, 60.84528229400007],
              [21.205332879000082, 60.84324778900003],
              [21.202403191000087, 60.844916083000044],
              [21.201182488000086, 60.84829336100006],
              [21.195485873000052, 60.85224030200004],
              [21.186289910000085, 60.85651276200008],
              [21.189463738000086, 60.860541083000044],
              [21.206553582000083, 60.86318594000005],
              [21.221527540000068, 60.85895416900007],
              [21.224619988000086, 60.85028717700004],
              [21.226573113000086, 60.84711334800005],
              [21.23536217500009, 60.84861888200004],
              [21.242035352000073, 60.84821198100008],
              [21.24586022200009, 60.84601471600007],
              [21.251963738000086, 60.84711334800005],
              [21.25953209700009, 60.85309479400007],
            ],
          ],
          [
            [
              [21.421885613000086, 61.17674388200004],
              [21.42937259200005, 61.17300039300005],
              [21.431651238000086, 61.17145416900007],
              [21.42359459700009, 61.17210521000004],
              [21.388845248000052, 61.180975653000075],
              [21.369395379000082, 61.17609284100007],
              [21.352386915000068, 61.17601146000004],
              [21.34669030000009, 61.17755768400008],
              [21.34815514400009, 61.17788320500006],
              [21.349782748000052, 61.17804596600007],
              [21.347178582000083, 61.18187083500004],
              [21.342946811000047, 61.190619208000044],
              [21.346446160000085, 61.19627513200004],
              [21.353526238000086, 61.19745514500005],
              [21.357432488000086, 61.19977448100008],
              [21.35678144600007, 61.20258209800005],
              [21.363129102000073, 61.20856354400007],
              [21.380056186000047, 61.21401601800005],
              [21.391368035000085, 61.20962148600006],
              [21.38575280000009, 61.20099518400008],
              [21.38917076900009, 61.19220612200007],
              [21.421885613000086, 61.17674388200004],
            ],
          ],
          [
            [
              [21.52125084700009, 61.633978583000044],
              [21.52393639400009, 61.63312409100007],
              [21.526133660000085, 61.62909577000005],
              [21.52198326900009, 61.625433661000045],
              [21.51465905000009, 61.62494538000004],
              [21.510508660000085, 61.62221914300005],
              [21.507823113000086, 61.618068752000056],
              [21.50098717500009, 61.61774323100008],
              [21.478363477000073, 61.62083567900004],
              [21.46192467500009, 61.626166083000044],
              [21.45997155000009, 61.629339911000045],
              [21.470957879000082, 61.63031647300005],
              [21.484548373000052, 61.64044830900008],
              [21.52125084700009, 61.633978583000044],
            ],
          ],
          [
            [
              [21.208506707000083, 62.94623444200005],
              [21.191416863000086, 62.95392487200007],
              [21.182871941000087, 62.950100002000056],
              [21.168142123000052, 62.94599030200004],
              [21.146657748000052, 62.95327383000006],
              [21.135996941000087, 62.962958075000074],
              [21.13648522200009, 62.967230536000045],
              [21.141856316000087, 62.96824778900003],
              [21.14820397200009, 62.96552155200004],
              [21.150563998000052, 62.96356842700004],
              [21.15479576900009, 62.96759674700007],
              [21.159353061000047, 62.97540924700007],
              [21.152679884000065, 62.979681708000044],
              [21.14039147200009, 62.98456452000005],
              [21.13184655000009, 62.99282461100006],
              [21.130381707000083, 63.00079987200007],
              [21.136241082000083, 63.00657786700003],
              [21.145192905000044, 63.01015859600005],
              [21.151621941000087, 63.01032135600008],
              [21.155121290000068, 63.00682200700004],
              [21.15984134200005, 63.004339911000045],
              [21.184743686000047, 62.99941640800006],
              [21.195648634000065, 62.99437083500004],
              [21.207367384000065, 62.98615143400008],
              [21.215993686000047, 62.97516510600008],
              [21.22120201900009, 62.961371161000045],
              [21.221934441000087, 62.95136139500005],
              [21.21656334700009, 62.94708893400008],
              [21.208506707000083, 62.94623444200005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Luxembourg',
        iso3: 'LUX',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [6.11748661300004, 50.12045603500006],
            [6.110561971000038, 50.10598663400002],
            [6.105704386000127, 50.09224070200007],
            [6.099399861000109, 50.06412872300005],
            [6.101156861000078, 50.063405254000045],
            [6.107151327000111, 50.06376698800004],
            [6.10942509000003, 50.063560283000086],
            [6.105704386000127, 50.060304668000086],
            [6.096402629000096, 50.04862579400013],
            [6.10725467900005, 50.04459503200003],
            [6.113765910000012, 50.03637848000001],
            [6.119967081000084, 50.01550120000003],
            [6.117176554000139, 50.00439076800011],
            [6.12151737500011, 49.996277568000025],
            [6.138777303000097, 49.97932769800009],
            [6.153970174000051, 49.951215719000075],
            [6.161928345000092, 49.942482402000095],
            [6.172677043000107, 49.95622833300003],
            [6.18983361800008, 49.93829661100004],
            [6.222699829000106, 49.887136943000044],
            [6.238306111000043, 49.87690500900008],
            [6.27220585200007, 49.867138164000025],
            [6.286778605000109, 49.86104034500006],
            [6.291532837000119, 49.855562643000084],
            [6.295567892000093, 49.84861569200011],
            [6.301558065000052, 49.83830271400008],
            [6.30259159400012, 49.83494374700008],
            [6.310653116000111, 49.834478659000055],
            [6.325639282000083, 49.840369772000045],
            [6.33442427500006, 49.8402147420001],
            [6.351374145000079, 49.83329010000001],
            [6.380106242000068, 49.81556508400011],
            [6.397056111000097, 49.80858876600011],
            [6.414522746000046, 49.80548818000007],
            [6.462478475000069, 49.80548818000007],
            [6.493277629000119, 49.79959706600006],
            [6.4972050370001, 49.79944203800004],
            [6.502579387000139, 49.79566965800011],
            [6.502269327000079, 49.79587636300006],
            [6.500098918000077, 49.794481100000084],
            [6.499995564000045, 49.78605784100007],
            [6.498548624000051, 49.78538604800009],
            [6.493794392000069, 49.76363026899999],
            [6.493691040000044, 49.75655059800006],
            [6.49637821400006, 49.752106425000065],
            [6.495964803000049, 49.748230693000025],
            [6.486249634000018, 49.74270131500002],
            [6.485526163000117, 49.73376129200007],
            [6.487799926000122, 49.72559641600007],
            [6.492554158000132, 49.71841339100011],
            [6.499685506000077, 49.71221221900002],
            [6.49100386500001, 49.71443430600003],
            [6.486352986000043, 49.71293569000004],
            [6.482942342000115, 49.7080781050001],
            [6.489763631000073, 49.70296213800002],
            [6.49172733600011, 49.70079172800003],
            [6.418243449000045, 49.66988922200004],
            [6.402740519000133, 49.655781555],
            [6.404497518000113, 49.652474264],
            [6.410905396000146, 49.64963206000003],
            [6.417003215000108, 49.64575632700006],
            [6.417933390000144, 49.63914174500006],
            [6.415246216000128, 49.63464589400006],
            [6.407701457000087, 49.62741119400009],
            [6.397572876000112, 49.6138719690001],
            [6.371527954000044, 49.592994690000026],
            [6.356438435000143, 49.577595113000044],
            [6.350754028000097, 49.56658803400005],
            [6.350754028000097, 49.534910381000046],
            [6.348808550000058, 49.52528975500012],
            [6.342279094000105, 49.493000794000054],
            [6.345379679000132, 49.46271840400003],
            [6.345307071000093, 49.4553486520001],
            [6.325329224000086, 49.456723938000025],
            [6.298767538000078, 49.466232402000074],
            [6.251116525000043, 49.489459778000096],
            [6.249364868000072, 49.49031361900005],
            [6.221976359000109, 49.49744496700008],
            [6.193554321000079, 49.49940867200009],
            [6.136090129000081, 49.49527455600007],
            [6.142601359000139, 49.48607615200008],
            [6.11438602700008, 49.48437083000003],
            [6.10725467900005, 49.482510478],
            [6.1019836830001, 49.47641265900005],
            [6.102087036000057, 49.470004781000014],
            [6.099813273000109, 49.46463043200005],
            [6.087720988000029, 49.46163319900005],
            [6.078005819000083, 49.45202138300003],
            [6.063329711000108, 49.44845571000006],
            [5.978063599000052, 49.44509674100006],
            [5.960700317000118, 49.44132436200003],
            [5.946954386000101, 49.4699531050001],
            [5.928144165000077, 49.482303772000066],
            [5.864685506000029, 49.49217397100004],
            [5.8395707600001, 49.49987376000003],
            [5.822104126000056, 49.51051910500003],
            [5.790684855000023, 49.53775258500012],
            [5.814456014000086, 49.54514231400013],
            [5.837400350000109, 49.56111033200007],
            [5.846908813000113, 49.57671661400009],
            [5.829958944000111, 49.582762756000065],
            [5.841224406000066, 49.58968739800004],
            [5.849182577000107, 49.599712626000056],
            [5.861998331000109, 49.622760316000026],
            [5.86995650200015, 49.62885813500007],
            [5.879878377000068, 49.63485260100002],
            [5.88545943200009, 49.64353424100007],
            [5.879878377000068, 49.65774526000003],
            [5.872643676000109, 49.661724345000025],
            [5.852593221000063, 49.66322296200012],
            [5.845771932000105, 49.66658193000002],
            [5.842257934000145, 49.67391998300012],
            [5.843704874000139, 49.677485657],
            [5.846702108000045, 49.68068959600005],
            [5.847218872000099, 49.687200827000126],
            [5.848769165000107, 49.692730205000046],
            [5.853626749000028, 49.6962958780001],
            [5.857347453000045, 49.700429993000014],
            [5.856402764000052, 49.70580745000008],
            [5.856003865000076, 49.7080781050001],
            [5.850216105000101, 49.71402089400003],
            [5.843704874000139, 49.714330954],
            [5.837296997000095, 49.71293569000004],
            [5.831715942000073, 49.71360748300002],
            [5.825721476000041, 49.715777894],
            [5.81176884000007, 49.71851674500003],
            [5.805360961000105, 49.721875713000045],
            [5.805774373000133, 49.724201152],
            [5.803603963000057, 49.738153789000066],
            [5.802053670000106, 49.74285634400006],
            [5.7784892170001, 49.77303538000005],
            [5.771874634000113, 49.77939158200009],
            [5.759162231000062, 49.784455872000066],
            [5.748413533000132, 49.78564443000006],
            [5.73828495300009, 49.788848368000046],
            [5.727742960000114, 49.80021718400003],
            [5.721645142000085, 49.812774557000054],
            [5.720198202000091, 49.82471181300009],
            [5.724642374000098, 49.834271953],
            [5.73652795400011, 49.839439596],
            [5.726916137000103, 49.84522735700007],
            [5.728673136000083, 49.848844707000055],
            [5.730533488000077, 49.851170146000086],
            [5.731980428000071, 49.85416738],
            [5.731877075000057, 49.859955139000064],
            [5.758128702000079, 49.858198141000074],
            [5.748826945000047, 49.867293193000066],
            [5.726709432000064, 49.878196920000036],
            [5.714927205000038, 49.88186594600002],
            [5.718957967000051, 49.8913744100001],
            [5.75358117600004, 49.930183411000044],
            [5.757611939000128, 49.93653961200006],
            [5.759989054000101, 49.94160390200004],
            [5.7637097570001, 49.94682322200008],
            [5.771564575000127, 49.95354115800008],
            [5.778592570000058, 49.95659006700002],
            [5.793372029000068, 49.95881215500002],
            [5.801640258000106, 49.963824768000094],
            [5.812595662000092, 49.977570700000015],
            [5.808564901000096, 49.98310007800002],
            [5.801536906000081, 49.98868113300004],
            [5.802673787000089, 50.002478740000086],
            [5.808874959000065, 50.007801412000035],
            [5.829132121000072, 50.01358917300011],
            [5.836366821000126, 50.01855011000005],
            [5.838847290000103, 50.02645660400002],
            [5.838847290000103, 50.03586171500005],
            [5.837710408000106, 50.04743723600011],
            [5.843704874000139, 50.053638408],
            [5.858277628000081, 50.061803284000106],
            [5.864375447000043, 50.06748769100007],
            [5.866855916000134, 50.074308981000016],
            [5.868819621000057, 50.090535381],
            [5.872436971000127, 50.09689158100004],
            [5.888973429000117, 50.106606751000086],
            [5.926180461000058, 50.11833730100007],
            [5.941063273000083, 50.12831085200007],
            [5.949021444000067, 50.14267690000007],
            [5.953155558000077, 50.156371155],
            [5.961630493000087, 50.165621236000035],
            [5.982921183000144, 50.16706817700002],
            [5.998320760000041, 50.17497467100007],
            [6.004728638000074, 50.17047882100003],
            [6.008035929000073, 50.16091868100004],
            [6.014133749000052, 50.15358062800006],
            [6.022966606000097, 50.15082036000011],
            [6.02736291500014, 50.14944651300003],
            [6.038628377000094, 50.148412985000036],
            [6.061366008000078, 50.15073842400007],
            [6.070047648000127, 50.1542007450001],
            [6.076455525000085, 50.158644918000036],
            [6.084206991000087, 50.15931671200009],
            [6.097126098000103, 50.15130686500002],
            [6.101466919000075, 50.14210846000013],
            [6.100330037000077, 50.13265167300007],
            [6.102603800000082, 50.124745179000016],
            [6.11748661300004, 50.12045603500006],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Belgium',
        iso3: 'BEL',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [2.521799927545686, 51.08754088371883],
            [2.542002800000091, 51.096869208000044],
            [2.579925977000073, 51.104803778000075],
            [2.715668165000068, 51.16950104400007],
            [2.92359459700009, 51.24648672100005],
            [3.124847852000073, 51.32965729400007],
            [3.34896894600007, 51.37514883000006],
            [3.349414674000116, 51.37522311800005],
            [3.358068481000061, 51.336712546000015],
            [3.353934366000146, 51.31190785800008],
            [3.353210897000054, 51.28860178700005],
            [3.367370240000099, 51.2634870400001],
            [3.391658163000102, 51.24676971500007],
            [3.398798477000071, 51.24469829300001],
            [3.421940552000109, 51.23798472099999],
            [3.45387658700011, 51.235633444000044],
            [3.501212199000065, 51.2402843230001],
            [3.504106079000053, 51.24974111000007],
            [3.501522258000136, 51.26240183600002],
            [3.503382609000141, 51.27395151800006],
            [3.514338012000024, 51.28103118899999],
            [3.529014120000113, 51.2833307910001],
            [3.54503381300006, 51.28392506900006],
            [3.584824666000088, 51.2895319630001],
            [3.609526001000091, 51.29043630000005],
            [3.635054159000049, 51.287826640000034],
            [3.757320597000046, 51.262324321],
            [3.776234172000102, 51.25452118000008],
            [3.781401815000095, 51.24142120400002],
            [3.779748169000129, 51.230310771000106],
            [3.781401815000095, 51.21987213200008],
            [3.796284627000119, 51.20876169800006],
            [3.8086869710001, 51.20532521600002],
            [3.927026001000058, 51.206255392000074],
            [3.949453572000067, 51.210777080000085],
            [3.995032186000032, 51.23323048900009],
            [4.118952271000097, 51.27240122500005],
            [4.168561645000096, 51.296870016000085],
            [4.207939087000085, 51.33058888800004],
            [4.213520141000089, 51.34053660100004],
            [4.220961547000115, 51.363816834000076],
            [4.221491455000091, 51.36800060300003],
            [4.222178582000083, 51.36774323100008],
            [4.241058790000068, 51.35659414300005],
            [4.249034050000091, 51.34666575700004],
            [4.256114129000082, 51.32843659100007],
            [4.272634311000047, 51.31582265800006],
            [4.29078209700009, 51.305894273000035],
            [4.302989129000082, 51.296087958000044],
            [4.306651238000086, 51.28974030200004],
            [4.308116082000083, 51.283636786000045],
            [4.305430535000085, 51.276597398000035],
            [4.298675977000073, 51.269598700000074],
            [4.296722852000073, 51.267564195000034],
            [4.30836022200009, 51.27122630400004],
            [4.316416863000086, 51.27684153900009],
            [4.330821160000085, 51.296087958000044],
            [4.297129754000082, 51.30516185100004],
            [4.289317254000082, 51.30914948100008],
            [4.285411004000082, 51.318019924000055],
            [4.286143425000091, 51.33966705900008],
            [4.283050977000073, 51.35008372600004],
            [4.275645379000082, 51.35809967700004],
            [4.261067579000098, 51.36937927500007],
            [4.28112422200013, 51.36894651000004],
            [4.290104614000114, 51.36875193300001],
            [4.326278117000129, 51.356427104000076],
            [4.345605103000082, 51.35229299000004],
            [4.392217244000051, 51.35040679900003],
            [4.411234171000018, 51.356737162000044],
            [4.416195109000085, 51.37397125300005],
            [4.410097290000124, 51.383789775000096],
            [4.387669719000115, 51.40053293900006],
            [4.379918253000113, 51.40952463800009],
            [4.3806417240001, 51.41965321900004],
            [4.387152954000072, 51.42745636000008],
            [4.389220011000134, 51.434587708000024],
            [4.37712772600014, 51.44288177500006],
            [4.429424275000059, 51.46197621700004],
            [4.483064412000147, 51.474326884],
            [4.512623331000071, 51.477375794000025],
            [4.525232381000109, 51.47592885400003],
            [4.533190551000075, 51.467583110000064],
            [4.531846964000096, 51.45086578400013],
            [4.523372029000086, 51.43841176400004],
            [4.521511678000081, 51.42864491799999],
            [4.540631958000091, 51.42006663000005],
            [4.553861125000083, 51.419291484000055],
            [4.582696573000106, 51.422598776000044],
            [4.614632609000097, 51.41756032299999],
            [4.630135539000094, 51.418206279000046],
            [4.643571411000067, 51.42141021700003],
            [4.653906697000053, 51.42621612600003],
            [4.731214641000065, 51.485618185000064],
            [4.764184204000117, 51.49623769100005],
            [4.778653605000045, 51.49535919200012],
            [4.796843709000086, 51.49101837200003],
            [4.813586873000133, 51.48411956900007],
            [4.823922159000062, 51.47564463300007],
            [4.826092570000128, 51.46055511500005],
            [4.819891398000067, 51.446214905000076],
            [4.815447224000138, 51.43107371100005],
            [4.822681925000012, 51.413684591000035],
            [4.779067016000056, 51.426422832000085],
            [4.767801554000101, 51.4253893030001],
            [4.762117146000151, 51.41337453200005],
            [4.783304484000013, 51.40763844800007],
            [4.853274373000119, 51.40613983200008],
            [4.871671183000046, 51.403039246000034],
            [4.910325154000134, 51.391902975],
            [4.931925903000092, 51.395623678000035],
            [4.957144002000064, 51.410997416],
            [4.980191691000101, 51.430531108000096],
            [4.995797973000066, 51.4467058310001],
            [5.002722616000142, 51.45900482200004],
            [5.00613326000007, 51.46830658000006],
            [5.012127727000092, 51.474326884],
            [5.027527303000085, 51.47680735300007],
            [5.030317831000048, 51.47443023700002],
            [5.060290161000069, 51.46197621700004],
            [5.079927205000104, 51.43854095500008],
            [5.076413208000048, 51.421901144000046],
            [5.065251099000108, 51.40590728800002],
            [5.061737101000062, 51.38425486300012],
            [5.068144979000095, 51.37453969400009],
            [5.102561483000073, 51.3506651820001],
            [5.107832479000081, 51.34198354100003],
            [5.118064412000081, 51.31991770500004],
            [5.122921997000105, 51.313380636000076],
            [5.140181926000082, 51.30738617000004],
            [5.178835897000084, 51.30950490300002],
            [5.197336059000122, 51.30834218300002],
            [5.214906047000085, 51.29433787],
            [5.215422811000025, 51.25873280800003],
            [5.232992798000112, 51.25591644300006],
            [5.239455934000091, 51.25693018200009],
            [5.270716593000145, 51.26183339500007],
            [5.389055623000104, 51.258706971000024],
            [5.409932901000076, 51.26353871700003],
            [5.451894165000084, 51.282116394000084],
            [5.471634562000133, 51.28808502300011],
            [5.49323531100012, 51.28653472900008],
            [5.516696411000083, 51.27723297200005],
            [5.535196573000121, 51.26204010000002],
            [5.542327921000066, 51.24266143900006],
            [5.54553186000004, 51.219923808],
            [5.551406597000096, 51.21676713400011],
            [5.568372843000134, 51.20765065500005],
            [5.62501021300011, 51.19690195700012],
            [5.638549438000098, 51.19090749100009],
            [5.648161255000105, 51.18395701100009],
            [5.659013306000048, 51.179073588000065],
            [5.676169881000106, 51.17917694100002],
            [5.718027791000083, 51.18460296700009],
            [5.730843547000063, 51.18375030600005],
            [5.74717329900011, 51.17760081000007],
            [5.768050577000082, 51.15946238300005],
            [5.781383098000106, 51.15240854900013],
            [5.812078898000038, 51.157317810000066],
            [5.829132121000072, 51.15646514900003],
            [5.838020467000092, 51.14372690900008],
            [5.840500936000069, 51.138921],
            [5.826444946000038, 51.13016184499999],
            [5.823241007000064, 51.11874135400008],
            [5.845978638000048, 51.10339345400011],
            [5.836780232000137, 51.099491883000056],
            [5.826651652000095, 51.096908061000065],
            [5.81590295400008, 51.09587453200008],
            [5.804947550000094, 51.09662384000008],
            [5.807428019000071, 51.08938914000002],
            [5.808978312000107, 51.08634023000009],
            [5.81176884000007, 51.082309469000094],
            [5.804327434000129, 51.06858937600005],
            [5.798849731000132, 51.061483866000046],
            [5.791304972000091, 51.05499847500006],
            [5.779626098000023, 51.06130299900009],
            [5.771461222000113, 51.05812489900002],
            [5.766396932000134, 51.04843556800007],
            [5.764019816000086, 51.03518056300008],
            [5.777559041000075, 51.02355336600003],
            [5.761746053000081, 50.9991620900001],
            [5.722368612000082, 50.9594229130001],
            [5.744692830000133, 50.96324696900005],
            [5.75430464700014, 50.9630919400001],
            [5.764019816000086, 50.9594229130001],
            [5.752547648000075, 50.94722727500009],
            [5.73528771900007, 50.92397288100007],
            [5.722368612000082, 50.91167389000013],
            [5.717614380000072, 50.90924509700007],
            [5.706038859000046, 50.90660959900005],
            [5.694463338000077, 50.903664042000045],
            [5.622323039000094, 50.85265940400008],
            [5.624493448000067, 50.8302835090001],
            [5.640719849000078, 50.81503896100007],
            [5.657432381000092, 50.80764098200008],
            [5.663250773000101, 50.80506541000007],
            [5.68485152100007, 50.79850250300008],
            [5.700457804000109, 50.795556946000076],
            [5.698700806000119, 50.78377472000007],
            [5.688365519000115, 50.760830384000045],
            [5.706555623000071, 50.75421580000004],
            [5.717407674000128, 50.75282053700006],
            [5.727846313000072, 50.75416412400004],
            [5.732776968000053, 50.75885148900005],
            [5.74355594900004, 50.769098613],
            [5.752444296000135, 50.773439433000064],
            [5.762469523000078, 50.77101064100002],
            [5.782933390000039, 50.75669627000012],
            [5.793165324000114, 50.75214874300009],
            [5.879878377000068, 50.75354400600007],
            [5.891287548000093, 50.75124632700005],
            [5.902202596000024, 50.74904815700005],
            [5.974756307000035, 50.74754954000004],
            [5.994910116000113, 50.749926656000085],
            [5.993256469000073, 50.74806630500008],
            [5.992636353000108, 50.74625763000007],
            [5.992739705000133, 50.744448955000095],
            [5.994186645000127, 50.74258860300007],
            [6.010826457000036, 50.73705922500007],
            [6.011343221000089, 50.72744740800006],
            [6.007622518000062, 50.71690541700009],
            [6.011549926000043, 50.708533835000125],
            [6.02477909300012, 50.707551982000055],
            [6.064363240000091, 50.714476624000056],
            [6.081003052000113, 50.71349477200009],
            [6.100226685000052, 50.70129913400005],
            [6.161101521000063, 50.642181296],
            [6.147769002000047, 50.63675527000002],
            [6.159447876000115, 50.622389222000024],
            [6.180015096000119, 50.61551625600005],
            [6.249054809000086, 50.61443105100007],
            [6.251328572000091, 50.608436585000035],
            [6.244300577000075, 50.599548239000015],
            [6.232931763000096, 50.59076324500005],
            [6.232931763000096, 50.587145894000045],
            [6.210607543000037, 50.578670959000036],
            [6.17908492000015, 50.56197947200012],
            [6.160688110000052, 50.543582663],
            [6.177327922000075, 50.53019846600007],
            [6.169473103000144, 50.522498678],
            [6.170816691000113, 50.51795115200004],
            [6.178878214000093, 50.51578074200005],
            [6.190557088000077, 50.51521230100009],
            [6.182598917000121, 50.50658233700007],
            [6.190660441000091, 50.50182810500006],
            [6.199238729000029, 50.49040761300007],
            [6.207196900000099, 50.48632517500006],
            [6.217118774000085, 50.486015117000065],
            [6.25091516100008, 50.49268137600008],
            [6.253085571000071, 50.494076640000074],
            [6.255566040000133, 50.4945934040001],
            [6.257839803000053, 50.494076640000074],
            [6.260113566000086, 50.49268137600008],
            [6.27540979000014, 50.488030497000025],
            [6.31871464000011, 50.481674296000094],
            [6.336904744000037, 50.481002502000095],
            [6.325742635000097, 50.474026184000095],
            [6.32326216600012, 50.46601633700003],
            [6.326156046000108, 50.45702463800008],
            [6.331633748000115, 50.446896057000046],
            [6.340212036000139, 50.43785268200007],
            [6.347343384000084, 50.43697418300006],
            [6.351167440000012, 50.43356353800003],
            [6.350443969000111, 50.416872051000084],
            [6.34331262200007, 50.39330759700009],
            [6.336387980000097, 50.379923402000045],
            [6.337731567000077, 50.36808949800003],
            [6.372458130000098, 50.32943552700003],
            [6.373399684000105, 50.323080035000075],
            [6.374525187000074, 50.31548289100003],
            [6.36201949000008, 50.30695627900012],
            [6.335457804000043, 50.303855692000084],
            [6.322021932000098, 50.305405986],
            [6.310653116000111, 50.30824819000007],
            [6.299491007000086, 50.308868307000054],
            [6.285951782000097, 50.303855692000084],
            [6.276029907000094, 50.29610422800006],
            [6.269415324000107, 50.28649241200007],
            [6.267348267000045, 50.276415507000124],
            [6.271792439000137, 50.26742380800009],
            [6.253395630000057, 50.25677846300009],
            [6.210400838000083, 50.249026998],
            [6.189626912000023, 50.24272247300006],
            [6.179808390000062, 50.233007304000026],
            [6.15717411300011, 50.22272369400004],
            [6.146838827000096, 50.214042054000075],
            [6.160171346000112, 50.20453359],
            [6.165752400000144, 50.193164775000085],
            [6.165132284000066, 50.181899312000056],
            [6.159137817000044, 50.17244252600007],
            [6.151696411000017, 50.169341939000034],
            [6.13174930800011, 50.16830841100004],
            [6.123171020000058, 50.16489776700003],
            [6.121310668000149, 50.161590475000125],
            [6.11800337700015, 50.15037668900008],
            [6.115832967000074, 50.14546742800003],
            [6.125961547000117, 50.140196432000025],
            [6.129475545000076, 50.134046937000036],
            [6.126581665000089, 50.1273290000001],
            [6.11748661300004, 50.12045603500006],
            [6.102603800000082, 50.124745179000016],
            [6.100330037000077, 50.13265167300007],
            [6.101466919000075, 50.14210846000013],
            [6.097126098000103, 50.15130686500002],
            [6.084206991000087, 50.15931671200009],
            [6.076455525000085, 50.158644918000036],
            [6.070047648000127, 50.1542007450001],
            [6.061366008000078, 50.15073842400007],
            [6.038628377000094, 50.148412985000036],
            [6.02736291500014, 50.14944651300003],
            [6.022966606000097, 50.15082036000011],
            [6.014133749000052, 50.15358062800006],
            [6.008035929000073, 50.16091868100004],
            [6.004728638000074, 50.17047882100003],
            [5.998320760000041, 50.17497467100007],
            [5.982921183000144, 50.16706817700002],
            [5.961630493000087, 50.165621236000035],
            [5.953155558000077, 50.156371155],
            [5.949021444000067, 50.14267690000007],
            [5.941063273000083, 50.12831085200007],
            [5.926180461000058, 50.11833730100007],
            [5.888973429000117, 50.106606751000086],
            [5.872436971000127, 50.09689158100004],
            [5.868819621000057, 50.090535381],
            [5.866855916000134, 50.074308981000016],
            [5.864375447000043, 50.06748769100007],
            [5.858277628000081, 50.061803284000106],
            [5.843704874000139, 50.053638408],
            [5.837710408000106, 50.04743723600011],
            [5.838847290000103, 50.03586171500005],
            [5.838847290000103, 50.02645660400002],
            [5.836366821000126, 50.01855011000005],
            [5.829132121000072, 50.01358917300011],
            [5.808874959000065, 50.007801412000035],
            [5.802673787000089, 50.002478740000086],
            [5.801536906000081, 49.98868113300004],
            [5.808564901000096, 49.98310007800002],
            [5.812595662000092, 49.977570700000015],
            [5.801640258000106, 49.963824768000094],
            [5.793372029000068, 49.95881215500002],
            [5.778592570000058, 49.95659006700002],
            [5.771564575000127, 49.95354115800008],
            [5.7637097570001, 49.94682322200008],
            [5.759989054000101, 49.94160390200004],
            [5.757611939000128, 49.93653961200006],
            [5.75358117600004, 49.930183411000044],
            [5.718957967000051, 49.8913744100001],
            [5.714927205000038, 49.88186594600002],
            [5.726709432000064, 49.878196920000036],
            [5.748826945000047, 49.867293193000066],
            [5.758128702000079, 49.858198141000074],
            [5.731877075000057, 49.859955139000064],
            [5.731980428000071, 49.85416738],
            [5.730533488000077, 49.851170146000086],
            [5.728673136000083, 49.848844707000055],
            [5.726916137000103, 49.84522735700007],
            [5.73652795400011, 49.839439596],
            [5.724642374000098, 49.834271953],
            [5.720198202000091, 49.82471181300009],
            [5.721645142000085, 49.812774557000054],
            [5.727742960000114, 49.80021718400003],
            [5.73828495300009, 49.788848368000046],
            [5.748413533000132, 49.78564443000006],
            [5.759162231000062, 49.784455872000066],
            [5.771874634000113, 49.77939158200009],
            [5.7784892170001, 49.77303538000005],
            [5.802053670000106, 49.74285634400006],
            [5.803603963000057, 49.738153789000066],
            [5.805774373000133, 49.724201152],
            [5.805360961000105, 49.721875713000045],
            [5.81176884000007, 49.71851674500003],
            [5.825721476000041, 49.715777894],
            [5.831715942000073, 49.71360748300002],
            [5.837296997000095, 49.71293569000004],
            [5.843704874000139, 49.714330954],
            [5.850216105000101, 49.71402089400003],
            [5.856003865000076, 49.7080781050001],
            [5.856402764000052, 49.70580745000008],
            [5.857347453000045, 49.700429993000014],
            [5.853626749000028, 49.6962958780001],
            [5.848769165000107, 49.692730205000046],
            [5.847218872000099, 49.687200827000126],
            [5.846702108000045, 49.68068959600005],
            [5.843704874000139, 49.677485657],
            [5.842257934000145, 49.67391998300012],
            [5.845771932000105, 49.66658193000002],
            [5.852593221000063, 49.66322296200012],
            [5.872643676000109, 49.661724345000025],
            [5.879878377000068, 49.65774526000003],
            [5.88545943200009, 49.64353424100007],
            [5.879878377000068, 49.63485260100002],
            [5.86995650200015, 49.62885813500007],
            [5.861998331000109, 49.622760316000026],
            [5.849182577000107, 49.599712626000056],
            [5.841224406000066, 49.58968739800004],
            [5.829958944000111, 49.582762756000065],
            [5.846908813000113, 49.57671661400009],
            [5.837400350000109, 49.56111033200007],
            [5.814456014000086, 49.54514231400013],
            [5.790684855000023, 49.53775258500012],
            [5.779005982000058, 49.539612936000125],
            [5.757095174000114, 49.54839792900002],
            [5.74634647600007, 49.549431458000086],
            [5.735597779000074, 49.54571075500009],
            [5.72267867000005, 49.53460032200006],
            [5.710276327000088, 49.531086325],
            [5.688675578000101, 49.53351511700008],
            [5.667178182000072, 49.54043975900005],
            [5.644647257000145, 49.543798727000066],
            [5.619739217000074, 49.535530497000124],
            [5.607853638000051, 49.524936829000055],
            [5.605579875000046, 49.517753805],
            [5.60227258300003, 49.5137230430001],
            [5.587493124000019, 49.51243113300005],
            [5.578914836000081, 49.51392974900004],
            [5.547598918000091, 49.52343821200013],
            [5.528788696000078, 49.517960511000055],
            [5.503673950000064, 49.50509307900005],
            [5.477732381000095, 49.49522288100006],
            [5.456131633000041, 49.49894358400009],
            [5.449930461000037, 49.50783193000008],
            [5.450963989000115, 49.51677195200001],
            [5.454167928000089, 49.52617706300008],
            [5.454374633000043, 49.53661570300001],
            [5.450240519000118, 49.545762431000085],
            [5.402078084000038, 49.602451477],
            [5.391165749000066, 49.608817006],
            [5.3834745690001, 49.61330352800006],
            [5.352468709000078, 49.62069325800006],
            [5.341099894000081, 49.62513743200007],
            [5.334898722000077, 49.625809225000054],
            [5.331178019000077, 49.62312205000002],
            [5.326940552000025, 49.61764434900003],
            [5.321669555000085, 49.61258005800006],
            [5.314538208000073, 49.61113311800007],
            [5.29789839700004, 49.61325185200003],
            [5.2930408120001, 49.617179261],
            [5.29066369700007, 49.62637766600001],
            [5.293764282000012, 49.64053700800004],
            [5.301825806000096, 49.64389597600005],
            [5.306373332000135, 49.647513327000055],
            [5.299448690000048, 49.662499492],
            [5.280121704000095, 49.67789906900002],
            [5.259244425000134, 49.69133494100005],
            [5.237643677000079, 49.690973206000066],
            [5.192478475000087, 49.682808329000025],
            [5.169430786000135, 49.687200827000126],
            [5.151240682000093, 49.69598582000002],
            [5.13635787000004, 49.705339254000066],
            [5.093776489000078, 49.74533681200002],
            [5.081890909000037, 49.75272654300004],
            [5.04623417200014, 49.75939280200005],
            [5.026287068000045, 49.76673085600005],
            [4.989080037000122, 49.79055369100011],
            [4.970993286000123, 49.797064922000075],
            [4.968370957000019, 49.79698095600007],
            [4.950012654000119, 49.796393128],
            [4.906604451000106, 49.786471252000084],
            [4.884176879000023, 49.78414581300008],
            [4.858028605000129, 49.78657460500004],
            [4.849036906000066, 49.7941710410001],
            [4.849243611000134, 49.83158477800005],
            [4.846763142000071, 49.837527568000084],
            [4.836944620000082, 49.848017884000015],
            [4.834877564000124, 49.85303049800008],
            [4.836737915000128, 49.85912831700004],
            [4.845626261000064, 49.86584625300007],
            [4.848933553000052, 49.87106557200009],
            [4.854307902000102, 49.88331288700003],
            [4.85937219200008, 49.891684469],
            [4.8619560140001, 49.90031443300005],
            [4.860199016000109, 49.91333689400007],
            [4.84459273300007, 49.93173370400008],
            [4.797257120000097, 49.944291077000074],
            [4.783924601000081, 49.95829539000009],
            [4.78826542200008, 49.97426340800003],
            [4.826712687000111, 50.036016744],
            [4.827642863000079, 50.046713766000025],
            [4.826092570000128, 50.05503367200008],
            [4.827229451000051, 50.064077047000026],
            [4.846039673000064, 50.09069041000005],
            [4.852137492000111, 50.09162058600002],
            [4.86288619000004, 50.08407582700006],
            [4.865159953000074, 50.10159413700002],
            [4.870534302000124, 50.12226471000004],
            [4.871877889000075, 50.13978302],
            [4.862679484000097, 50.147586162000025],
            [4.831363566000078, 50.143400371000084],
            [4.820098103000106, 50.14644928000011],
            [4.815550578000085, 50.16133209200005],
            [4.788575480000134, 50.153373922000085],
            [4.681915324000073, 50.08392079700012],
            [4.676127563000108, 50.07606598000008],
            [4.673440389000064, 50.06619578100002],
            [4.675817505000111, 50.06020131500007],
            [4.67953820800011, 50.0551887000001],
            [4.680571737000093, 50.04831573500006],
            [4.672923624000134, 50.01637970000006],
            [4.665895629000119, 50.00051503500005],
            [4.656697225000102, 49.989094544000054],
            [4.645845174000073, 49.9844953420001],
            [4.60419396900005, 49.98020619800003],
            [4.464770956000081, 49.935609436000036],
            [4.435108683000095, 49.932250468000106],
            [4.427651209000089, 49.93357167400008],
            [4.27759891700012, 49.960155742],
            [4.215952935000132, 49.95440767000012],
            [4.201117798000041, 49.95302439400005],
            [4.187681925000078, 49.95550486300003],
            [4.131664672000056, 49.974986878000024],
            [4.132364978000112, 49.974945951],
            [4.139622843000041, 49.97452179],
            [4.138382609000075, 49.98919789700007],
            [4.132904907000096, 50.004494121000036],
            [4.128150675000114, 50.005786031000085],
            [4.132284790000114, 50.017568258],
            [4.137349080000092, 50.025061341000125],
            [4.14458378100008, 50.030797425000074],
            [4.162877238000135, 50.04180450500009],
            [4.186028279000141, 50.05244984900007],
            [4.210006144000147, 50.060149638000055],
            [4.210316203000048, 50.066712545000044],
            [4.203391561000046, 50.074670716000114],
            [4.197397095000042, 50.08407582700006],
            [4.180550578000037, 50.12722564700009],
            [4.170628703000148, 50.13048126200006],
            [4.159880005000048, 50.12939605800007],
            [4.139932902000112, 50.12355662000009],
            [4.125773559000066, 50.12815582300003],
            [4.128150675000114, 50.146242575000045],
            [4.147374308000025, 50.18634348600004],
            [4.152748657000103, 50.20453359],
            [4.157296183000113, 50.212698466000106],
            [4.167941528000114, 50.22246531200007],
            [4.19150598100012, 50.234299215000064],
            [4.20132450300008, 50.24153391600005],
            [4.203701619000128, 50.25197255400009],
            [4.197603800000081, 50.25848378500005],
            [4.185201457000119, 50.26546010400004],
            [4.17176558500006, 50.27088612900012],
            [4.162773885000121, 50.272953187000084],
            [4.150268189000116, 50.26954254200005],
            [4.149751424000073, 50.26313466500001],
            [4.150991658000123, 50.256261698000046],
            [4.143653605000111, 50.25161082000007],
            [4.125256795000041, 50.25714019800007],
            [4.097868286000079, 50.29481231700002],
            [4.077197713000146, 50.30664622000005],
            [4.055907023000088, 50.31455271500009],
            [4.022730753000076, 50.33811716700008],
            [4.003300415000098, 50.344059957000084],
            [3.982113077000122, 50.34261301700009],
            [3.918551066000049, 50.32545644100004],
            [3.895916789000097, 50.32530141300002],
            [3.878036743000052, 50.330779114000094],
            [3.860880168000079, 50.33847890200009],
            [3.840209595000061, 50.345196839000025],
            [3.798661743000082, 50.348452454],
            [3.755046834000041, 50.34633372100002],
            [3.741507609000053, 50.34312978100006],
            [3.733446085000054, 50.33723866800004],
            [3.71546268700007, 50.31765330000003],
            [3.711121867000088, 50.30933339500005],
            [3.708434692000083, 50.30633616200005],
            [3.703887167000119, 50.30432078000011],
            [3.702233520000078, 50.30525095600005],
            [3.700786580000084, 50.304682516000085],
            [3.696859172000131, 50.298222962000054],
            [3.661719198000071, 50.31930694600008],
            [3.652934204000076, 50.36018300400009],
            [3.652830851000147, 50.40684682200005],
            [3.644355916000052, 50.44550079300005],
            [3.628129517000048, 50.46436269200008],
            [3.608285766000051, 50.47650665300007],
            [3.586374959000096, 50.48348297100007],
            [3.56374068100007, 50.48653188100012],
            [3.499145142000089, 50.48679026300009],
            [3.486742798000137, 50.49268137600008],
            [3.496457967000083, 50.50379181000001],
            [3.498008260000091, 50.511853332],
            [3.491497029000129, 50.517072652000095],
            [3.477130982000119, 50.51986318000006],
            [3.462868286000059, 50.51913971000006],
            [3.45263635200007, 50.514850566000106],
            [3.442714477000067, 50.50849436500009],
            [3.429175252000078, 50.50182810500006],
            [3.385353637000094, 50.491647848000085],
            [3.361065714000091, 50.48978749700008],
            [3.343599080000047, 50.492939759000066],
            [3.299880819000066, 50.50746083600011],
            [3.286755005000089, 50.51407542],
            [3.27104537000011, 50.5269428510001],
            [3.265877726000042, 50.53831166600007],
            [3.264327433000091, 50.570196025000044],
            [3.237869100000097, 50.626471660000036],
            [3.229807576000042, 50.65541046200009],
            [3.243760213000115, 50.67210195000003],
            [3.232391398000118, 50.695924785],
            [3.224433227000077, 50.705174866000036],
            [3.210997355000103, 50.707965394000084],
            [3.1969413650001, 50.70920562800002],
            [3.188983195000048, 50.715096742000114],
            [3.176684204000082, 50.73411366800009],
            [3.162810519000061, 50.74993907500003],
            [3.146195109000104, 50.768891907000025],
            [3.129245239000085, 50.7790721650001],
            [3.103303671000049, 50.784084778000064],
            [3.023816593000049, 50.76826211600007],
            [2.971425415000112, 50.757833150000025],
            [2.948377726000047, 50.748686422000034],
            [2.930187622000119, 50.736232402000056],
            [2.900111938000038, 50.70310780900006],
            [2.886882772000149, 50.696648255000085],
            [2.87127648900011, 50.69876698900008],
            [2.866725884000061, 50.70009100300007],
            [2.786733846000033, 50.72336497000005],
            [2.768233683000119, 50.733235169000054],
            [2.762962687000083, 50.73938466500003],
            [2.74952681500011, 50.75959014900009],
            [2.743842407000074, 50.766204732000105],
            [2.706635376000065, 50.78878733400005],
            [2.700020792000089, 50.79628041600007],
            [2.696920207000119, 50.8030500280001],
            [2.691855916000065, 50.808837789000094],
            [2.678730102000088, 50.81323028600006],
            [2.669221639000114, 50.81390207900007],
            [2.650618123000044, 50.8122484340001],
            [2.642453247000049, 50.81245513900008],
            [2.627777140000148, 50.814418844],
            [2.620439087000136, 50.81648590200005],
            [2.615168091000015, 50.822170309000015],
            [2.606589803000077, 50.83483103400006],
            [2.602042277000066, 50.83808664900003],
            [2.589949992000072, 50.84201405900011],
            [2.586746053000098, 50.845424704000024],
            [2.587779582000081, 50.85002390600006],
            [2.595531046000076, 50.861134339],
            [2.596667928000102, 50.86764556900006],
            [2.576927531000138, 50.91151886000007],
            [2.582715291000113, 50.92066558900008],
            [2.605762980000065, 50.93523834300002],
            [2.611654093000055, 50.941232809000056],
            [2.608450154000082, 50.96112823500006],
            [2.592740519000131, 50.97611440000013],
            [2.556980428000116, 51.00117747000006],
            [2.547058553000113, 51.0204786180001],
            [2.537033325000095, 51.06461029100008],
            [2.521799927545686, 51.08754088371883],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'North Macedonia',
        iso3: 'MKD',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.56714725800009, 41.87318166200002],
            [20.590298299000096, 41.854733175],
            [20.602390584000062, 41.84987559100007],
            [20.6187203370001, 41.85052154600005],
            [20.626161743000125, 41.85519826300002],
            [20.63701379300008, 41.87036529500004],
            [20.643421672000017, 41.87364674900003],
            [20.65282678300008, 41.86928009100005],
            [20.671843709000143, 41.849307150000115],
            [20.681455525000047, 41.84401031600008],
            [20.702952921000104, 41.84959137],
            [20.71439819800011, 41.859162991000076],
            [20.723313436000126, 41.86661875500003],
            [20.73995324700013, 41.88803863500006],
            [20.750495240000106, 41.906797180000055],
            [20.751052494000106, 41.91021769500007],
            [20.754422648000087, 41.930904236000075],
            [20.75143912800013, 41.94033778400008],
            [20.741813598000135, 41.970772603000015],
            [20.74305383300009, 41.993484395000095],
            [20.755352824000028, 42.04278371200009],
            [20.765378052000045, 42.06433278500005],
            [20.784911743000066, 42.082031962000045],
            [20.81054325300002, 42.09293569000003],
            [20.904170441000076, 42.11666775500002],
            [20.9751451810001, 42.13465801200006],
            [21.00391646300008, 42.14195078600004],
            [21.02923791500004, 42.1514075730001],
            [21.04093997800007, 42.15996989400004],
            [21.074403117000116, 42.18445465100008],
            [21.098484334000148, 42.19595265700009],
            [21.106235799000075, 42.19579762800005],
            [21.112953735000104, 42.194402364000084],
            [21.126389607000135, 42.188924662],
            [21.164423462000087, 42.16703969400005],
            [21.199873494000116, 42.141149801000026],
            [21.21620324700004, 42.12115102200009],
            [21.22540165200013, 42.106784973000075],
            [21.229298016000115, 42.10382211300008],
            [21.23780399600011, 42.0973540240001],
            [21.245727456000054, 42.096167109000035],
            [21.288860311000093, 42.08970591200004],
            [21.299298950000036, 42.09141123500011],
            [21.30079636100004, 42.09842542700004],
            [21.30126265400014, 42.10060964000009],
            [21.300332479000105, 42.12089263900002],
            [21.298782186000096, 42.129419251000044],
            [21.295784953000066, 42.134793600000094],
            [21.2937178950001, 42.14016794900006],
            [21.294958130000055, 42.148978781000054],
            [21.35376591000002, 42.21597727500004],
            [21.36060206500005, 42.22011423300005],
            [21.36678837100007, 42.22385793000008],
            [21.384255005000114, 42.224943136],
            [21.419084920000074, 42.215021261000075],
            [21.42983361800009, 42.215848084000115],
            [21.42869673700008, 42.22256602000003],
            [21.421462036000037, 42.23135101300004],
            [21.419911743000085, 42.240058492000074],
            [21.436344848000147, 42.24687978200005],
            [21.447920369000116, 42.2441409310001],
            [21.457222127000136, 42.23703542100007],
            [21.467557413000037, 42.23512339300005],
            [21.471973165000094, 42.23913027900004],
            [21.481510051000043, 42.24778411900009],
            [21.499286743000056, 42.23866322800011],
            [21.51985396300006, 42.23902496400011],
            [21.561815226000135, 42.24716400200002],
            [21.564065710000108, 42.24628930200005],
            [21.575044392000052, 42.242022197000026],
            [21.624653768000115, 42.24277150500002],
            [21.659690389000048, 42.23556264300008],
            [21.676886452000076, 42.23494482000011],
            [21.69203983500003, 42.242022197000026],
            [21.706509236000073, 42.25507049600007],
            [21.71952070000009, 42.26095663500011],
            [21.817200154000147, 42.30514495900006],
            [21.837353963000112, 42.3085556030001],
            [21.877351522000083, 42.308219706],
            [21.8843795170001, 42.30951161800006],
            [21.91827925600009, 42.33134491],
            [21.92902795400002, 42.335117289000024],
            [21.94153365000011, 42.333101909000064],
            [21.99496708200013, 42.312612203000086],
            [22.027626587000015, 42.303956401000065],
            [22.045407482000144, 42.302424041],
            [22.060906209000052, 42.301088359000076],
            [22.09552941900006, 42.30581675200007],
            [22.233402140000123, 42.34888905800007],
            [22.259757120000074, 42.36909454400005],
            [22.26885217300014, 42.37033477900009],
            [22.27329634600008, 42.365477194000064],
            [22.274019816000077, 42.34847564700006],
            [22.276913696000065, 42.34124094700009],
            [22.291589803000136, 42.3283993540001],
            [22.3076094970001, 42.31933014000002],
            [22.32528283700009, 42.31431752500008],
            [22.345023234000053, 42.313439026000125],
            [22.443621867000047, 42.21442698200012],
            [22.481449015000123, 42.19331716000009],
            [22.494678182000115, 42.164559225000076],
            [22.50693853400014, 42.14892727600004],
            [22.510181112000026, 42.14479299],
            [22.531058390000112, 42.12910919300005],
            [22.617771443000066, 42.08270375600004],
            [22.627176665000036, 42.079126592000094],
            [22.675855753000036, 42.06061208100003],
            [22.705724731000146, 42.055935364000064],
            [22.71027225800009, 42.05298980800005],
            [22.713992961000116, 42.04862314900008],
            [22.718437134000112, 42.04446319600005],
            [22.7250517170001, 42.042473654],
            [22.770630330000103, 42.043998108000025],
            [22.780862264000064, 42.04317128600009],
            [22.785306437000088, 42.039140523000086],
            [22.787683553000136, 42.0325776160001],
            [22.791094198000053, 42.02580800400007],
            [22.79894901500009, 42.02123464000003],
            [22.805977010000106, 42.02138966900007],
            [22.821273234000046, 42.02536875400007],
            [22.82695764200011, 42.02508453400007],
            [22.838223104000065, 42.01947764100005],
            [22.843700806000044, 42.0144650270001],
            [22.84562115900013, 42.007407729000064],
            [22.845767863000106, 42.00686859200003],
            [22.84659468600003, 41.99363942500004],
            [22.846904744000113, 41.993484395000095],
            [22.85475956200014, 41.982632345000056],
            [22.857136678000103, 41.971883647000126],
            [22.858893677000083, 41.94787994400009],
            [22.86633508300011, 41.92488393200004],
            [22.877083781000124, 41.90204294900006],
            [22.878634073000057, 41.89501495400013],
            [22.878220662000047, 41.880261333000036],
            [22.880804484000123, 41.87269073500006],
            [22.88208830500011, 41.871618275000074],
            [22.88504195200008, 41.86915089900002],
            [22.896720825000045, 41.864448344000024],
            [22.901371704000013, 41.86041758200004],
            [22.907676229000117, 41.848583679000015],
            [22.918321573000128, 41.81434804300004],
            [22.939715617000047, 41.77670176200009],
            [22.94591678800012, 41.769337870000086],
            [22.956872192000105, 41.7656688440001],
            [22.98053999800004, 41.76473866800005],
            [22.991185344000115, 41.76099212700002],
            [23.008858683000113, 41.73993398],
            [23.00958215300011, 41.7163695280001],
            [22.998626750000142, 41.69311513300009],
            [22.9854345280001, 41.67719775700006],
            [22.97661259000006, 41.666553446000066],
            [22.970101359000097, 41.652032369000025],
            [22.967000773000052, 41.64704559400006],
            [22.961523071000073, 41.64448761100006],
            [22.945813436000094, 41.64107696600006],
            [22.94085249800014, 41.63764048300003],
            [22.936098266000045, 41.6261683150001],
            [22.932997681000103, 41.61234486900004],
            [22.93206750500005, 41.59795298300013],
            [22.9337211510001, 41.58459462500009],
            [22.936925090000074, 41.57891021800005],
            [22.946433553000077, 41.56774810800003],
            [22.948707316000082, 41.56097849500007],
            [22.94788049300007, 41.5551390590001],
            [22.943022909000035, 41.53855092400009],
            [22.943599338000126, 41.52320117600006],
            [22.946226848000094, 41.453233135000104],
            [22.947570435000074, 41.44837554900009],
            [22.953358195000135, 41.43819529300002],
            [22.95459842900007, 41.432407532000056],
            [22.952117960000095, 41.42770497600007],
            [22.94054244000006, 41.41690460200003],
            [22.937338501000085, 41.41075510700007],
            [22.939405558000146, 41.389412740000054],
            [22.944469849000114, 41.36843210900007],
            [22.94085249800014, 41.349828593000026],
            [22.916977986000063, 41.3357726040001],
            [22.82602746600014, 41.340991923],
            [22.79681768200004, 41.337039223],
            [22.78096561600009, 41.33489410400004],
            [22.76229345200005, 41.322500211000076],
            [22.751303345000053, 41.315205384000095],
            [22.74200348000008, 41.287029556],
            [22.740864705, 41.283579407],
            [22.736730591000082, 41.204411113],
            [22.72722212700009, 41.165808818000116],
            [22.715749959000078, 41.14560333300001],
            [22.704897908000135, 41.139660543],
            [22.691875448000104, 41.14456980400003],
            [22.674098755000074, 41.15661041300011],
            [22.666347290000147, 41.16451690700005],
            [22.661903117000065, 41.17226837200006],
            [22.657185370000064, 41.17698611900006],
            [22.656115356000072, 41.17805613200004],
            [22.644539835000046, 41.18022654300002],
            [22.62934696500011, 41.17707428000007],
            [22.62593632000008, 41.169787903],
            [22.62676314300009, 41.16079620300006],
            [22.624489380000085, 41.15263132800003],
            [22.607332804000123, 41.135991516],
            [22.590176229000065, 41.12513946600005],
            [22.58663401000007, 41.124084543],
            [22.571262655000112, 41.11950673500003],
            [22.54924849400004, 41.118524882000074],
            [22.51658898900007, 41.12224558600006],
            [22.500672648000148, 41.12214223200006],
            [22.481449015000123, 41.11774973600005],
            [22.467496379000124, 41.1150108850001],
            [22.451476684000085, 41.11366729700005],
            [22.421814413000106, 41.11464915],
            [22.41044559700012, 41.11790476500009],
            [22.389258260000076, 41.128343405000024],
            [22.380163208000113, 41.13170237300004],
            [22.367657512000108, 41.13237416600002],
            [22.342336060000036, 41.128963522],
            [22.323422485000094, 41.128498434000065],
            [22.3150509030001, 41.124415995000064],
            [22.308746379000098, 41.12498443600002],
            [22.306679321000047, 41.12844675800007],
            [22.305232381000053, 41.14162424700005],
            [22.302648560000137, 41.14549998000008],
            [22.29345015400014, 41.14751536100003],
            [22.262961060000066, 41.150460918000036],
            [22.225133912000075, 41.159607646000026],
            [22.21363684100004, 41.16068357500005],
            [22.205806926000037, 41.16141632100003],
            [22.183172648000067, 41.15991770400011],
            [22.160331665000086, 41.151907857000126],
            [22.1243648680001, 41.12720652300003],
            [22.103384237000085, 41.121522115000076],
            [22.09594283000007, 41.12364084900004],
            [22.062766561000075, 41.13718007400003],
            [22.060286092000098, 41.1400222780001],
            [22.058632446000047, 41.14508656800008],
            [22.055531860000087, 41.149892477],
            [22.048193807000104, 41.15185618200012],
            [22.044059692000076, 41.149944153],
            [22.033827759000104, 41.14126251200004],
            [22.029073527, 41.13857533800011],
            [21.96509810400002, 41.12436431900004],
            [21.934712362000084, 41.11191029900006],
            [21.925545235000072, 41.1067537900001],
            [21.909080851000112, 41.09749257400004],
            [21.901226034000075, 41.09077463800013],
            [21.89719527200009, 41.08126617500004],
            [21.89633270900012, 41.06470496500013],
            [21.896161743000107, 41.06142242500006],
            [21.894301391000084, 41.05382598900009],
            [21.88065881400007, 41.038426412],
            [21.84500207500008, 41.01238149000004],
            [21.831462850000037, 40.993726298000055],
            [21.83135949700008, 40.993622945000126],
            [21.831256144000065, 40.993519592],
            [21.79363570200013, 40.97357249000008],
            [21.783713826000053, 40.96416737900002],
            [21.781853475000048, 40.955899150000064],
            [21.78175012200012, 40.94509877600005],
            [21.77813277200002, 40.933729960000065],
            [21.765523722000097, 40.923911438000076],
            [21.757090880000106, 40.92250596400005],
            [21.73699833200004, 40.919157206000094],
            [21.685115194000048, 40.92799387700008],
            [21.656899861000085, 40.91822703000004],
            [21.654832805000126, 40.91429962200006],
            [21.652662394000032, 40.90138051300006],
            [21.648838339000093, 40.89579945900006],
            [21.643877400000065, 40.89445587200008],
            [21.629511353000055, 40.89507598900006],
            [21.62372359200006, 40.894404195000064],
            [21.613698364000044, 40.88830637600002],
            [21.590340617000095, 40.87068471300002],
            [21.581555623000014, 40.86629221700012],
            [21.553650350000026, 40.87042633100005],
            [21.50951867700013, 40.900502014000025],
            [21.505730550000067, 40.90090282200005],
            [21.429420207000078, 40.90897694900012],
            [21.404925577000114, 40.90861521400002],
            [21.381257772000083, 40.900502014000025],
            [21.344877564000114, 40.873061829000065],
            [21.329271281000075, 40.86629221700012],
            [21.295371541000065, 40.860866191000056],
            [21.260955037000116, 40.86081451400004],
            [21.245824293000055, 40.863225788000065],
            [21.209071899, 40.869082744000096],
            [21.183026977000026, 40.87016794800009],
            [21.112126912000065, 40.85394154900008],
            [20.96526249200008, 40.849394023000045],
            [20.964849080000135, 40.87595570900005],
            [20.956684204000027, 40.894765931000066],
            [20.939941040000093, 40.9070649210001],
            [20.89022831200009, 40.918278707000056],
            [20.837414999000117, 40.92406646800002],
            [20.83654426400011, 40.92390375500007],
            [20.81695113100008, 40.920242411000075],
            [20.783671509000044, 40.89905507400003],
            [20.766101522000042, 40.89373240200008],
            [20.7408834230001, 40.89796987000004],
            [20.730572639000087, 40.90461109500002],
            [20.71721561700008, 40.91321441700008],
            [20.702746216000037, 40.936313782000056],
            [20.683419230000084, 40.99382965200009],
            [20.66409224400013, 41.05914866200003],
            [20.65386031000014, 41.07527170800002],
            [20.6430082600001, 41.08157623300012],
            [20.634128612000097, 41.08257619400008],
            [20.63153609200009, 41.082868144000074],
            [20.618927042000053, 41.08240305600005],
            [20.60528446400005, 41.083488261000056],
            [20.597419353000078, 41.086272625000035],
            [20.57696578000005, 41.093513489000074],
            [20.569937785000064, 41.10710439000006],
            [20.570557902000104, 41.124829407000064],
            [20.565493611000136, 41.14741200800002],
            [20.549680623000143, 41.17061472600001],
            [20.512680297000088, 41.21014719700007],
            [20.50007124800007, 41.23552032500005],
            [20.483121379000067, 41.28947052000011],
            [20.477747029000113, 41.31959788100009],
            [20.478108340000063, 41.32158509000003],
            [20.481674439000074, 41.34119862900006],
            [20.496040487000073, 41.33778798500005],
            [20.510406534000083, 41.344402568000035],
            [20.523428995000103, 41.3568049120001],
            [20.532937459000095, 41.37044749000002],
            [20.53996545400011, 41.38713897700005],
            [20.540172160000054, 41.40067820200004],
            [20.539048843000018, 41.402943875000076],
            [20.534074341000093, 41.41297719400008],
            [20.52218876100008, 41.425689596000026],
            [20.514644002000125, 41.42946197600004],
            [20.498004191000092, 41.43147735600009],
            [20.490872843000062, 41.43602488300003],
            [20.488909139000043, 41.44145090800002],
            [20.486842082000067, 41.45778066000004],
            [20.48353479000008, 41.465480449000026],
            [20.48159697500006, 41.46826901200011],
            [20.470822388000016, 41.48377390500009],
            [20.463174275000142, 41.48976837200003],
            [20.452012166000117, 41.49359242700008],
            [20.4449841710001, 41.50847524100003],
            [20.44787805200008, 41.53545033800005],
            [20.44415734900008, 41.5496613560001],
            [20.492939901000028, 41.55767120400007],
            [20.50740930200007, 41.562270406000025],
            [20.5208451740001, 41.56836822500007],
            [20.52932010900011, 41.57487945600006],
            [20.534694458000075, 41.585266419000064],
            [20.534670174000013, 41.58732446800009],
            [20.53459110500006, 41.59402557400007],
            [20.513403768000103, 41.64040517200006],
            [20.50833947800001, 41.66174753900005],
            [20.500381307000055, 41.734094544000115],
            [20.503275187000042, 41.74463653600007],
            [20.511336710000137, 41.757943217],
            [20.521155232000098, 41.767658387000026],
            [20.54440962800001, 41.784763286000086],
            [20.550920858000097, 41.793522441000064],
            [20.550136327000104, 41.80006020100011],
            [20.54844038900012, 41.814193013000065],
            [20.540482218000136, 41.83943695100005],
            [20.54078621900007, 41.84486463200007],
            [20.541722452000073, 41.861580302000064],
            [20.56714725800009, 41.87318166200002],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Albania',
        iso3: 'ALB',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.56714725800009, 41.87318166200002],
            [20.541722452000073, 41.861580302000064],
            [20.54078621900007, 41.84486463200007],
            [20.540482218000136, 41.83943695100005],
            [20.54844038900012, 41.814193013000065],
            [20.550136327000104, 41.80006020100011],
            [20.550920858000097, 41.793522441000064],
            [20.54440962800001, 41.784763286000086],
            [20.521155232000098, 41.767658387000026],
            [20.511336710000137, 41.757943217],
            [20.503275187000042, 41.74463653600007],
            [20.500381307000055, 41.734094544000115],
            [20.50833947800001, 41.66174753900005],
            [20.513403768000103, 41.64040517200006],
            [20.53459110500006, 41.59402557400007],
            [20.534670174000013, 41.58732446800009],
            [20.534694458000075, 41.585266419000064],
            [20.52932010900011, 41.57487945600006],
            [20.5208451740001, 41.56836822500007],
            [20.50740930200007, 41.562270406000025],
            [20.492939901000028, 41.55767120400007],
            [20.44415734900008, 41.5496613560001],
            [20.44787805200008, 41.53545033800005],
            [20.4449841710001, 41.50847524100003],
            [20.452012166000117, 41.49359242700008],
            [20.463174275000142, 41.48976837200003],
            [20.470822388000016, 41.48377390500009],
            [20.48159697500006, 41.46826901200011],
            [20.48353479000008, 41.465480449000026],
            [20.486842082000067, 41.45778066000004],
            [20.488909139000043, 41.44145090800002],
            [20.490872843000062, 41.43602488300003],
            [20.498004191000092, 41.43147735600009],
            [20.514644002000125, 41.42946197600004],
            [20.52218876100008, 41.425689596000026],
            [20.534074341000093, 41.41297719400008],
            [20.539048843000018, 41.402943875000076],
            [20.540172160000054, 41.40067820200004],
            [20.53996545400011, 41.38713897700005],
            [20.532937459000095, 41.37044749000002],
            [20.523428995000103, 41.3568049120001],
            [20.510406534000083, 41.344402568000035],
            [20.496040487000073, 41.33778798500005],
            [20.481674439000074, 41.34119862900006],
            [20.478108340000063, 41.32158509000003],
            [20.477747029000113, 41.31959788100009],
            [20.483121379000067, 41.28947052000011],
            [20.50007124800007, 41.23552032500005],
            [20.512680297000088, 41.21014719700007],
            [20.549680623000143, 41.17061472600001],
            [20.565493611000136, 41.14741200800002],
            [20.570557902000104, 41.124829407000064],
            [20.569937785000064, 41.10710439000006],
            [20.57696578000005, 41.093513489000074],
            [20.597419353000078, 41.086272625000035],
            [20.60528446400005, 41.083488261000056],
            [20.618927042000053, 41.08240305600005],
            [20.63153609200009, 41.082868144000074],
            [20.634128612000097, 41.08257619400008],
            [20.6430082600001, 41.08157623300012],
            [20.65386031000014, 41.07527170800002],
            [20.66409224400013, 41.05914866200003],
            [20.683419230000084, 40.99382965200009],
            [20.702746216000037, 40.936313782000056],
            [20.71721561700008, 40.91321441700008],
            [20.730572639000087, 40.90461109500002],
            [20.7408834230001, 40.89796987000004],
            [20.766101522000042, 40.89373240200008],
            [20.783671509000044, 40.89905507400003],
            [20.81695113100008, 40.920242411000075],
            [20.83654426400011, 40.92390375500007],
            [20.837414999000117, 40.92406646800002],
            [20.89022831200009, 40.918278707000056],
            [20.939941040000093, 40.9070649210001],
            [20.956684204000027, 40.894765931000066],
            [20.964849080000135, 40.87595570900005],
            [20.96526249200008, 40.849394023000045],
            [20.96701949000004, 40.802006734000074],
            [20.96092167100008, 40.78076772100009],
            [20.943661743000092, 40.765264791000064],
            [20.953480265000053, 40.75916697200002],
            [20.95720096800008, 40.75162221300006],
            [20.959164673000117, 40.74356068900009],
            [20.9635054930001, 40.73606760700004],
            [20.992030884000144, 40.71550038700006],
            [21.018592570000067, 40.690902405000074],
            [21.028824503000124, 40.67684641600006],
            [21.035335734000114, 40.65937978100003],
            [21.036679321000065, 40.63974273700008],
            [21.033165324, 40.621397604],
            [21.022519979000037, 40.58661936500003],
            [21.020762980000143, 40.57509552100002],
            [21.020349568000114, 40.566775614000036],
            [21.01879927600001, 40.558972473000026],
            [21.013528280000088, 40.548895570000084],
            [21.00670699000011, 40.54321116200005],
            [20.99750858500002, 40.539180399000045],
            [20.988310181000116, 40.5334959930001],
            [20.981488891000083, 40.52326405800004],
            [20.968569783000078, 40.520576884],
            [20.957924439000067, 40.51494415300006],
            [20.951929973000034, 40.50605580700004],
            [20.95265344200004, 40.493653463000086],
            [20.949759562000054, 40.48786570200009],
            [20.946452270000066, 40.48290476500007],
            [20.93684045400005, 40.47251780200004],
            [20.911932413000073, 40.459547018000094],
            [20.889608195000108, 40.463732809000064],
            [20.8667672120001, 40.4720527140001],
            [20.83999882000012, 40.47163930300009],
            [20.826666301000103, 40.464818014000045],
            [20.82129195100015, 40.45639475600005],
            [20.81736454300008, 40.44683461500007],
            [20.80919966600007, 40.43660268200007],
            [20.80031132000005, 40.43277862600003],
            [20.7795373940001, 40.4290062460001],
            [20.77064904800008, 40.421978251],
            [20.768995402000144, 40.41257314000005],
            [20.773336223000115, 40.38533966100006],
            [20.773852987000055, 40.37490102200012],
            [20.770442342000138, 40.36255035400005],
            [20.765998168000124, 40.35428212500001],
            [20.75504276500004, 40.33862416600006],
            [20.739552404000108, 40.309166372000035],
            [20.736645955000142, 40.30363922100004],
            [20.728791138000105, 40.29826487300009],
            [20.717835734000033, 40.293924052000094],
            [20.70698368400008, 40.288084616000035],
            [20.699128866000137, 40.27836944600007],
            [20.69458133900011, 40.25558013900009],
            [20.696648397000075, 40.23558136000007],
            [20.696441691000132, 40.215065817],
            [20.685279582000078, 40.19119130500009],
            [20.6798018800001, 40.187832337000074],
            [20.6650224200001, 40.184370016000045],
            [20.66037154100013, 40.178892314000066],
            [20.659854777000078, 40.17274281800009],
            [20.663162068000076, 40.16168406200008],
            [20.663472127000148, 40.15661977200001],
            [20.668226359000073, 40.13806793300007],
            [20.66677941900008, 40.133520406000045],
            [20.651793254000097, 40.101015931000106],
            [20.647555786000055, 40.09403961200009],
            [20.640217733000043, 40.09011220300003],
            [20.615361181000083, 40.08101733900007],
            [20.577792602000073, 40.06727122000002],
            [20.552884562000116, 40.06541086900002],
            [20.499864543000115, 40.07145701100008],
            [20.481674439000074, 40.067787985000066],
            [20.465964803000105, 40.06081166600008],
            [20.432788533000092, 40.063808899],
            [20.413771606000125, 40.05719431600009],
            [20.40043908700011, 40.045257060000054],
            [20.38907027200011, 40.02944407200006],
            [20.380698690000116, 40.011667379000116],
            [20.376461222000074, 39.993735657000045],
            [20.359924764000084, 39.99104848200001],
            [20.31000533000011, 39.98985992500009],
            [20.297913045000143, 39.986914368],
            [20.302977335000037, 39.979111227000075],
            [20.317963501000094, 39.91839141900009],
            [20.323131144000087, 39.91239695200004],
            [20.346902303000064, 39.89425852500001],
            [20.392997680000065, 39.835450745000045],
            [20.397028442000078, 39.818087463000026],
            [20.38896691900007, 39.79814036100002],
            [20.371603637000078, 39.78429107700005],
            [20.35455041500012, 39.78578969300004],
            [20.33687707600012, 39.79400624600008],
            [20.299576529000092, 39.805056407000095],
            [20.298326457000144, 39.805426737000076],
            [20.288404581000066, 39.80661529600009],
            [20.28003299900007, 39.80397979700008],
            [20.273005005000073, 39.79648671500006],
            [20.27548547400005, 39.792404277000045],
            [20.28137658700004, 39.78816680900009],
            [20.28468387800004, 39.78031199200005],
            [20.283133586000133, 39.77514434800007],
            [20.276829061000115, 39.76315541600009],
            [20.27569217900009, 39.760054830000044],
            [20.278172648000066, 39.756747538000056],
            [20.285510701000078, 39.74966786800003],
            [20.287267700000143, 39.74667063400001],
            [20.2910917560001, 39.73793731700006],
            [20.296466105000064, 39.733493144000036],
            [20.299463339000056, 39.728222148],
            [20.296466105000064, 39.71737009700006],
            [20.282720174000104, 39.704399312000035],
            [20.264116658000148, 39.696079407000084],
            [20.249027140000067, 39.68481394400003],
            [20.246029907000036, 39.66290313700007],
            [20.237244914000144, 39.66703725200007],
            [20.228563273000105, 39.669155986000064],
            [20.220088338000096, 39.669155986000064],
            [20.212026815000115, 39.66703725200007],
            [20.20417199700006, 39.66031931600007],
            [20.203035116000052, 39.652619527000056],
            [20.203448527000063, 39.64533315100009],
            [20.19993453000012, 39.64006215400006],
            [20.18412154100011, 39.637013245000034],
            [20.163761027000078, 39.644299622000105],
            [20.135235636000033, 39.66419504800011],
            [20.08934696400007, 39.682798564000066],
            [20.049556111000072, 39.69272043800005],
            [20.016069784000052, 39.70140208000002],
            [19.999847852000073, 39.69350820500006],
            [19.996836785000085, 39.692572333000044],
            [19.99586022200009, 39.686712958000044],
            [19.989024285000085, 39.686712958000044],
            [19.983571811000047, 39.70136139500005],
            [19.986989780000044, 39.717962958000044],
            [20.002696160000085, 39.74823639500005],
            [19.985606316000087, 39.75372955900008],
            [19.980642123000052, 39.75731028900009],
            [19.99586022200009, 39.78294505400004],
            [20.01417076900009, 39.83295319200005],
            [20.016286655000044, 39.845038153000075],
            [20.009776238000086, 39.865668036000045],
            [19.999278191000087, 39.87140534100007],
            [19.98373457100007, 39.872381903000075],
            [19.961680535000085, 39.878566799000055],
            [19.960215691000087, 39.88104889500005],
            [19.95997155000009, 39.88507721600007],
            [19.958832227000073, 39.88934967700004],
            [19.95484459700009, 39.89280833500004],
            [19.94117272200009, 39.89899323100008],
            [19.931162957000083, 39.90192291900007],
            [19.914073113000086, 39.902411200000074],
            [19.906423373000052, 39.90643952000005],
            [19.906423373000052, 39.91266510600008],
            [19.92123457100007, 39.926947333000044],
            [19.93100019600007, 39.93451569200005],
            [19.94117272200009, 39.94000885600008],
            [19.923838738000086, 39.952826239000046],
            [19.876800977000073, 40.022365627000056],
            [19.87045332100007, 40.03473541900007],
            [19.863454623000052, 40.045355536000045],
            [19.85523522200009, 40.04987213700008],
            [19.82325280000009, 40.05060455900008],
            [19.807383660000085, 40.05288320500006],
            [19.79656009200005, 40.05731842700004],
            [19.804535352000073, 40.06346263200004],
            [19.777354363000086, 40.077785549000055],
            [19.77312259200005, 40.07123444200005],
            [19.771657748000052, 40.06830475500004],
            [19.77051842500009, 40.06346263200004],
            [19.76726321700005, 40.07245514500005],
            [19.762461785000085, 40.07684967700004],
            [19.75635826900009, 40.07990143400008],
            [19.74935957100007, 40.08462148600006],
            [19.748057488000086, 40.08860911700009],
            [19.740896030000044, 40.10040924700007],
            [19.732676629000082, 40.110256252000056],
            [19.72901451900009, 40.10822174700007],
            [19.719086134000065, 40.11603424700007],
            [19.653168165000068, 40.13239166900007],
            [19.597829623000052, 40.15770091400009],
            [19.56576582100007, 40.17983633000006],
            [19.509287957000083, 40.19448476800005],
            [19.47624759200005, 40.21369049700007],
            [19.381114129000082, 40.29523346600007],
            [19.369965040000068, 40.309027411000045],
            [19.365082227000073, 40.31736888200004],
            [19.351573113000086, 40.36204661700009],
            [19.34424889400009, 40.374335028000075],
            [19.309255405000044, 40.400824286000045],
            [19.296885613000086, 40.41356028900009],
            [19.295176629000082, 40.41754791900007],
            [19.295176629000082, 40.41868724200009],
            [19.28956139400009, 40.42039622600004],
            [19.28956139400009, 40.42723216400009],
            [19.31617272200009, 40.43781159100007],
            [19.33253014400009, 40.43891022300005],
            [19.34815514400009, 40.43065013200004],
            [19.38379967500009, 40.39740631700005],
            [19.393239780000044, 40.38629791900007],
            [19.406504754000082, 40.362616278000075],
            [19.411957227000073, 40.348089911000045],
            [19.414235873000052, 40.334418036000045],
            [19.42359459700009, 40.33002350500004],
            [19.444590691000087, 40.33380768400008],
            [19.465586785000085, 40.341498114000046],
            [19.474945509000065, 40.34837474200009],
            [19.481618686000047, 40.439113674000055],
            [19.478770379000082, 40.45392487200007],
            [19.453135613000086, 40.46531810100004],
            [19.418793165000068, 40.491888739000046],
            [19.391368035000085, 40.52179596600007],
            [19.38640384200005, 40.54328034100007],
            [19.393239780000044, 40.53705475500004],
            [19.396006707000083, 40.52960846600007],
            [19.398610873000052, 40.52094147300005],
            [19.40674889400009, 40.522772528000075],
            [19.414235873000052, 40.522772528000075],
            [19.433604363000086, 40.505926825000074],
            [19.446055535000085, 40.51113515800006],
            [19.452647332000083, 40.52985260600008],
            [19.454600457000083, 40.55385976800005],
            [19.442149285000085, 40.57306549700007],
            [19.41570071700005, 40.58348216400009],
            [19.39161217500009, 40.57831452000005],
            [19.38640384200005, 40.55072663000004],
            [19.379242384000065, 40.56614817900004],
            [19.309825066000087, 40.64435455900008],
            [19.30437259200005, 40.65314362200007],
            [19.309336785000085, 40.66502513200004],
            [19.322927280000044, 40.67487213700008],
            [19.339040561000047, 40.68406810100004],
            [19.351573113000086, 40.69415924700007],
            [19.360524936000047, 40.70978424700007],
            [19.364512566000087, 40.72650788000004],
            [19.365570509000065, 40.78595612200007],
            [19.36882571700005, 40.80215078300006],
            [19.377777540000068, 40.81297435100004],
            [19.39625084700009, 40.81704336100006],
            [19.40674889400009, 40.820746161000045],
            [19.40406334700009, 40.829291083000044],
            [19.396739129000082, 40.83869049700007],
            [19.393239780000044, 40.844916083000044],
            [19.397634311000047, 40.85297272300005],
            [19.40479576900009, 40.86107005400004],
            [19.411387566000087, 40.86709219000005],
            [19.414235873000052, 40.868841864000046],
            [19.406260613000086, 40.88031647300005],
            [19.39112389400009, 40.89524974200003],
            [19.381195509000065, 40.908270575000074],
            [19.389821811000047, 40.91380442900004],
            [19.404958530000044, 40.91815827000005],
            [19.424571160000085, 40.93964264500005],
            [19.440928582000083, 40.94863515800006],
            [19.427012566000087, 40.936835028000075],
            [19.435394727000073, 40.913397528000075],
            [19.427256707000083, 40.89337799700007],
            [19.427256707000083, 40.872259833000044],
            [19.434743686000047, 40.872259833000044],
            [19.437836134000065, 40.88654205900008],
            [19.437673373000052, 40.88344961100006],
            [19.43913821700005, 40.880072333000044],
            [19.440928582000083, 40.872259833000044],
            [19.45411217500009, 40.88580963700008],
            [19.506602410000085, 40.90509674700007],
            [19.523448113000086, 40.92064036700003],
            [19.52515709700009, 40.94525788000004],
            [19.51465905000009, 40.964911200000074],
            [19.501475457000083, 40.98297760600008],
            [19.49545332100007, 41.00263092700004],
            [19.492035352000073, 40.97695547100005],
            [19.479665561000047, 40.95392487200007],
            [19.453868035000085, 40.92397695500006],
            [19.453461134000065, 40.92837148600006],
            [19.44776451900009, 40.93431224200003],
            [19.458506707000083, 40.942613023000035],
            [19.469981316000087, 40.956732489000046],
            [19.477224155000044, 40.97500234600005],
            [19.474945509000065, 40.995794989000046],
            [19.469981316000087, 41.00071849200003],
            [19.453786655000044, 41.005845445000034],
            [19.44776451900009, 41.009466864000046],
            [19.440603061000047, 41.02065664300005],
            [19.441254102000073, 41.02602773600006],
            [19.445485873000052, 41.03070709800005],
            [19.45639082100007, 41.106675523000035],
            [19.451182488000086, 41.122707424000055],
            [19.445485873000052, 41.12946198100008],
            [19.44117272200009, 41.13735586100006],
            [19.44190514400009, 41.143866278000075],
            [19.463715040000068, 41.15131256700005],
            [19.467133009000065, 41.16266510600008],
            [19.467133009000065, 41.17617422100005],
            [19.468760613000086, 41.187567450000074],
            [19.50953209700009, 41.23729075700004],
            [19.51661217500009, 41.25641510600008],
            [19.51335696700005, 41.276678778000075],
            [19.50294030000009, 41.294134833000044],
            [19.48804772200009, 41.30646393400008],
            [19.471934441000087, 41.31110260600008],
            [19.450043165000068, 41.31110260600008],
            [19.431651238000086, 41.313706773000035],
            [19.41895592500009, 41.32257721600007],
            [19.414235873000052, 41.341498114000046],
            [19.414235873000052, 41.382798570000034],
            [19.410817905000044, 41.39166901200008],
            [19.396006707000083, 41.402044989000046],
            [19.393239780000044, 41.41351959800005],
            [19.406423373000052, 41.400376695000034],
            [19.42872155000009, 41.40131256700005],
            [19.445160352000073, 41.41518789300005],
            [19.440928582000083, 41.44086334800005],
            [19.46461022200009, 41.450873114000046],
            [19.48926842500009, 41.466131903000075],
            [19.508636915000068, 41.48688385600008],
            [19.51661217500009, 41.51341380400004],
            [19.51417076900009, 41.52997467700004],
            [19.50717207100007, 41.53628164300005],
            [19.496348504000082, 41.538763739000046],
            [19.482432488000086, 41.543850002000056],
            [19.468028191000087, 41.55426666900007],
            [19.451996290000068, 41.57477448100008],
            [19.440928582000083, 41.58539459800005],
            [19.528086785000085, 41.57656484600005],
            [19.55640709700009, 41.58307526200008],
            [19.565196160000085, 41.58510976800005],
            [19.584808790000068, 41.619574286000045],
            [19.591644727000073, 41.619574286000045],
            [19.59229576900009, 41.608587958000044],
            [19.596039259000065, 41.602728583000044],
            [19.603037957000083, 41.60175202000005],
            [19.61296634200005, 41.60529205900008],
            [19.604991082000083, 41.632147528000075],
            [19.60010826900009, 41.639105536000045],
            [19.591644727000073, 41.63263580900008],
            [19.587087436000047, 41.640692450000074],
            [19.55762780000009, 41.66054922100005],
            [19.578135613000086, 41.68764883000006],
            [19.576345248000052, 41.71893952000005],
            [19.571136915000068, 41.752386786000045],
            [19.57129967500009, 41.770412502000056],
            [19.58952884200005, 41.765692450000074],
            [19.59896894600007, 41.77871328300006],
            [19.599782748000052, 41.79975006700005],
            [19.591644727000073, 41.818793036000045],
            [19.585215691000087, 41.81854889500005],
            [19.465505405000044, 41.855454820000034],
            [19.451182488000086, 41.862534898000035],
            [19.43295332100007, 41.86859772300005],
            [19.365082227000073, 41.85236237200007],
            [19.364223267000057, 41.8628463750001],
            [19.36494673700014, 41.8889946500001],
            [19.356988566000098, 41.899639994],
            [19.34768680800005, 41.90635793100002],
            [19.345309692000114, 41.9103370160001],
            [19.345929810000086, 41.914471130000024],
            [19.345413045000043, 41.92118906700004],
            [19.346653279000066, 41.92617584300011],
            [19.35047733600001, 41.931369324000016],
            [19.352854452000145, 41.938500672000046],
            [19.34644657400011, 41.96154836100003],
            [19.351614217000133, 41.9651657110001],
            [19.359779093000043, 41.96599253400002],
            [19.365773559000075, 41.96971323700005],
            [19.3710445560001, 41.98655975400003],
            [19.363706503000117, 41.993484395000095],
            [19.363396443000113, 41.99363942500004],
            [19.35419803900004, 42.00870310500004],
            [19.35058068900014, 42.02782338500002],
            [19.351717570000062, 42.04761545800001],
            [19.356575155000087, 42.06479787200006],
            [19.374868612000057, 42.09466685000008],
            [19.372491496000094, 42.1042528280001],
            [19.36999787700009, 42.10650667600005],
            [19.35502486100006, 42.12003997900008],
            [19.29776737500009, 42.15166595500007],
            [19.282057739000038, 42.164559225000076],
            [19.281955677000013, 42.164723366000075],
            [19.272032511000106, 42.180682271000066],
            [19.274926392000083, 42.19127594100003],
            [19.30458866300006, 42.215098776],
            [19.400396769000082, 42.32589304700009],
            [19.40132694500005, 42.331060690000115],
            [19.400706828000068, 42.34475494400003],
            [19.402670532000087, 42.35201548300002],
            [19.412075643000065, 42.36839691200005],
            [19.417243286000144, 42.374107158000115],
            [19.468402954000055, 42.418109640000054],
            [19.48173547300007, 42.43449106900003],
            [19.50147587100014, 42.44412872400004],
            [19.517805623000072, 42.45802968400001],
            [19.53165490700013, 42.47477284800006],
            [19.543747192000126, 42.49340220200013],
            [19.543747192000126, 42.493557231000054],
            [19.549328247000062, 42.50859507200006],
            [19.5613171790001, 42.51624318500002],
            [19.5756832270001, 42.5223410040001],
            [19.588085572000068, 42.532857158000056],
            [19.5936666260001, 42.54482025200009],
            [19.599247681000094, 42.57104604100003],
            [19.60503544100007, 42.584843649000064],
            [19.621778605000117, 42.60499745700004],
            [19.64792688000003, 42.627838441000065],
            [19.65803716600007, 42.63461270400002],
            [19.676038859000073, 42.64667450000006],
            [19.699293254000082, 42.654813538000084],
            [19.72213423700009, 42.64608022100002],
            [19.737533814000074, 42.6244019570001],
            [19.746008749000083, 42.598899639000095],
            [19.74688465400007, 42.58892977200013],
            [19.747765747000074, 42.57890085900006],
            [19.746008749000083, 42.57993438700005],
            [19.741357870000115, 42.57440500900013],
            [19.73391646400009, 42.56259694500004],
            [19.73215946400012, 42.55554311100009],
            [19.730299113000115, 42.54042775500001],
            [19.730919230000097, 42.53365814300007],
            [19.7343298750001, 42.524382223000046],
            [19.751589803000087, 42.49340220200013],
            [19.78445601400003, 42.474566143000104],
            [19.801405884000133, 42.468132426000054],
            [19.81959598800009, 42.46647878],
            [19.82906279900007, 42.46872253700003],
            [19.835512329000096, 42.47025116000013],
            [19.873339477000087, 42.48683929500005],
            [19.882537883000083, 42.49340220200013],
            [19.882744588000037, 42.49360890700008],
            [19.907549276000083, 42.506398824000044],
            [19.956331828000117, 42.50531362000005],
            [19.981756632000042, 42.51076548300004],
            [20.017723429000114, 42.54624135300007],
            [20.039220825000143, 42.557765199000116],
            [20.064955688000055, 42.54675811800003],
            [20.085626261000073, 42.530014954000066],
            [20.135545695000133, 42.50962860100013],
            [20.15239221200011, 42.49371226],
            [20.152598918000052, 42.49371226],
            [20.152598918000052, 42.49360890700008],
            [20.152702271000095, 42.49340220200013],
            [20.180814249000036, 42.443095195000055],
            [20.18629195200012, 42.4374366250001],
            [20.199727824000064, 42.42779897100009],
            [20.204688761000114, 42.420099182000016],
            [20.204378703000117, 42.41183095300006],
            [20.194043416000113, 42.40010040300008],
            [20.19280318200009, 42.39369252600004],
            [20.197454061000144, 42.38743967700013],
            [20.21306034300008, 42.37751780200004],
            [20.218848104000074, 42.3714458220001],
            [20.221225220000093, 42.363720195],
            [20.219468221000113, 42.35020680800001],
            [20.220915161000107, 42.34310129800009],
            [20.22959680200009, 42.32671986900003],
            [20.237761678000084, 42.31992441900009],
            [20.24964725700002, 42.31860666900003],
            [20.317963501000094, 42.319821065000056],
            [20.333363078000076, 42.317883200000026],
            [20.45697310400007, 42.25049713200012],
            [20.47366457600009, 42.23712300200002],
            [20.481674439000074, 42.230705058000055],
            [20.500794719000055, 42.21122304300006],
            [20.53862186700013, 42.15011566200006],
            [20.54937056500006, 42.12347646100001],
            [20.551954386000148, 42.10580312200001],
            [20.55216109200012, 42.07378957200011],
            [20.55825891100008, 42.05510854100005],
            [20.589678182000114, 41.99363942500004],
            [20.59432906100008, 41.97371816000002],
            [20.59928999800013, 41.96056650900006],
            [20.59928999800013, 41.94787994400009],
            [20.58874800600006, 41.92958648800003],
            [20.580583130000036, 41.921731669000096],
            [20.573348430000067, 41.9176750700001],
            [20.567250611000105, 41.912171530000094],
            [20.562496379000038, 41.900105082000024],
            [20.562703084000077, 41.892844544000056],
            [20.567767375000074, 41.880519715],
            [20.56714725800009, 41.87318166200002],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Kosovo',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.064955688000055, 42.54675811800003],
            [20.07704797300005, 42.55990977],
            [20.07818485500013, 42.572906393000025],
            [20.075394328000073, 42.58696238200004],
            [20.07570438600007, 42.60308543000012],
            [20.079218384000114, 42.61125030500004],
            [20.09058719900011, 42.62734751400002],
            [20.103919718000043, 42.65310821600012],
            [20.10195601400011, 42.65667389],
            [20.094204549000096, 42.666983337],
            [20.037006251000065, 42.707363097000055],
            [20.0361202390001, 42.70798858700003],
            [20.024751424000016, 42.723414002000126],
            [20.02650842300011, 42.743206075],
            [20.034673299000104, 42.75142262800004],
            [20.05563844800008, 42.763866229000044],
            [20.06505904100007, 42.76945770300004],
            [20.076324503000137, 42.773436789000115],
            [20.112084595000056, 42.76653798500003],
            [20.149498331000103, 42.74987233500009],
            [20.183398071000113, 42.74250844300009],
            [20.208409464000113, 42.763282369000066],
            [20.209959757000036, 42.77297170100009],
            [20.208409464000113, 42.78209259100005],
            [20.209236288000056, 42.79170440700007],
            [20.21760787000011, 42.80273732500008],
            [20.226082805000118, 42.806768087000066],
            [20.26442671700005, 42.817258403000025],
            [20.345352010000028, 42.827438660000084],
            [20.4280343020001, 42.84064198800006],
            [20.47630008900012, 42.855524801000016],
            [20.49883101400013, 42.877874858],
            [20.494366526000135, 42.88746653100013],
            [20.488909139000043, 42.89919138600008],
            [20.466688273000102, 42.90950083400007],
            [20.45097863700005, 42.92203236900009],
            [20.459453572000115, 42.950015158],
            [20.47640344200005, 42.96637074800013],
            [20.493456665000082, 42.97019480400006],
            [20.51113000500007, 42.97019480400006],
            [20.53045699000012, 42.975155742000126],
            [20.538415161000074, 42.98065928100003],
            [20.54389286300008, 42.98724802700009],
            [20.55340132600014, 43.00259592700009],
            [20.56239302600011, 43.00949473100006],
            [20.572831665000137, 43.00933970200002],
            [20.584303833000064, 43.00691090900004],
            [20.596396118000143, 43.0070917770001],
            [20.617273397000105, 43.02212961900007],
            [20.643835083000027, 43.05225697900006],
            [20.664919068000074, 43.08540741000009],
            [20.6691565350001, 43.10979868600002],
            [20.661818481000125, 43.11594818200008],
            [20.651689901000054, 43.11630991600008],
            [20.64094120300004, 43.115276388],
            [20.632052856000115, 43.11726593000013],
            [20.62605839000011, 43.123725485000094],
            [20.62058068900012, 43.133337301],
            [20.612105754000112, 43.15493805000007],
            [20.600116821000142, 43.17382578600011],
            [20.597533, 43.18496205700002],
            [20.604044230000113, 43.19795867900005],
            [20.612312459000066, 43.202273662000025],
            [20.64486861200001, 43.2033071900001],
            [20.66698612400012, 43.20966339200005],
            [20.745327596000095, 43.252864888000076],
            [20.769512166000084, 43.26084889800005],
            [20.794420207000144, 43.26307098400004],
            [20.809717238000076, 43.25961018900004],
            [20.819431600000144, 43.25741241500002],
            [20.83844852700011, 43.24586273200008],
            [20.848473755000043, 43.23813710600008],
            [20.855088338000115, 43.23144500800005],
            [20.864700154000047, 43.21733734200002],
            [20.861599569000106, 43.21751820900006],
            [20.85147098800013, 43.219817811],
            [20.83999882000012, 43.2120921840001],
            [20.8406189370001, 43.20697621700002],
            [20.839068644000065, 43.192455140000064],
            [20.836071411000148, 43.179432678000026],
            [20.832040649000078, 43.1786058550001],
            [20.838551880000125, 43.170466817],
            [20.91249413300011, 43.13880512900006],
            [20.993431297000086, 43.10414825700012],
            [21.005156698000093, 43.099127502],
            [21.02582727100011, 43.093365580000054],
            [21.092593221000072, 43.090678406],
            [21.10850956200008, 43.08155751600013],
            [21.124012491000087, 43.05827728300001],
            [21.139308716000045, 43.00582570400006],
            [21.14788700300008, 42.99262237600006],
            [21.165353638000028, 42.985103455000015],
            [21.17940962700004, 42.99058115700011],
            [21.19305220600006, 42.99789337200009],
            [21.20979536900009, 42.99587799100006],
            [21.225298299000116, 42.97355377200007],
            [21.2267452400001, 42.94252207500004],
            [21.23242964700006, 42.910896098000066],
            [21.260541626000105, 42.88655649900004],
            [21.271600383000106, 42.88428273500004],
            [21.294958130000055, 42.884386088000056],
            [21.306326945000137, 42.882448222000036],
            [21.31697229000011, 42.877616476000114],
            [21.336402628000116, 42.8654725140001],
            [21.34673791500012, 42.86084747300005],
            [21.378777303000106, 42.855292257000045],
            [21.39893111100008, 42.85456878700005],
            [21.408439575000074, 42.84699819000009],
            [21.40841888600005, 42.84174320800007],
            [21.40833622200006, 42.82074656200005],
            [21.404098755000092, 42.8039775590001],
            [21.390559529000114, 42.770413717000096],
            [21.3871488850001, 42.75496246400009],
            [21.383944946000042, 42.74997568800005],
            [21.379190714000117, 42.74700429300013],
            [21.37867395100008, 42.74413625100006],
            [21.38869917800011, 42.73904612300008],
            [21.405545695000086, 42.73529958100006],
            [21.41780040600011, 42.73557016200006],
            [21.44182255000004, 42.736100566000076],
            [21.542488240000097, 42.72581695600006],
            [21.56522587000009, 42.72018422500004],
            [21.58052209500005, 42.71021067300005],
            [21.61266483600008, 42.680393372000125],
            [21.629407999000108, 42.67220265700011],
            [21.64408410700011, 42.67230601000004],
            [21.68738895700008, 42.68682708800007],
            [21.708886352, 42.687188823000085],
            [21.738651977000103, 42.68215037],
            [21.744249788000076, 42.67942452800007],
            [21.7643868400001, 42.669618836],
            [21.772758422000067, 42.6475013230001],
            [21.767074016000038, 42.63871632900002],
            [21.756532023000148, 42.63362620000002],
            [21.74454309100011, 42.629647116000044],
            [21.734724569000036, 42.62424692800006],
            [21.735551392000048, 42.62127553400008],
            [21.73007369000007, 42.60101837200007],
            [21.728833455000114, 42.59830535900004],
            [21.72697310300012, 42.596393331000016],
            [21.720151815000065, 42.593887024000125],
            [21.71829146300007, 42.59101898200005],
            [21.719738403000065, 42.58667816200007],
            [21.72676639800008, 42.577944845],
            [21.72769657400002, 42.574146627000076],
            [21.71767134600009, 42.551150615000026],
            [21.66785526500007, 42.490094910000025],
            [21.6278577060001, 42.46038096100004],
            [21.61896936000008, 42.44924469100003],
            [21.616902303000103, 42.433922628000076],
            [21.621863240000067, 42.40216746000003],
            [21.61741906800006, 42.38663869200012],
            [21.596645141000124, 42.37209177700005],
            [21.537320597000104, 42.358630066],
            [21.516029907000103, 42.34193857900006],
            [21.514893026000095, 42.31783152300004],
            [21.553857056000084, 42.273984070000026],
            [21.564065710000108, 42.24628930200005],
            [21.561815226000135, 42.24716400200002],
            [21.51985396300006, 42.23902496400011],
            [21.499286743000056, 42.23866322800011],
            [21.481510051000043, 42.24778411900009],
            [21.471973165000094, 42.23913027900004],
            [21.467557413000037, 42.23512339300005],
            [21.457222127000136, 42.23703542100007],
            [21.447920369000116, 42.2441409310001],
            [21.436344848000147, 42.24687978200005],
            [21.419911743000085, 42.240058492000074],
            [21.421462036000037, 42.23135101300004],
            [21.42869673700008, 42.22256602000003],
            [21.42983361800009, 42.215848084000115],
            [21.419084920000074, 42.215021261000075],
            [21.384255005000114, 42.224943136],
            [21.36678837100007, 42.22385793000008],
            [21.36060206500005, 42.22011423300005],
            [21.35376591000002, 42.21597727500004],
            [21.294958130000055, 42.148978781000054],
            [21.2937178950001, 42.14016794900006],
            [21.295784953000066, 42.134793600000094],
            [21.298782186000096, 42.129419251000044],
            [21.300332479000105, 42.12089263900002],
            [21.30126265400014, 42.10060964000009],
            [21.30079636100004, 42.09842542700004],
            [21.299298950000036, 42.09141123500011],
            [21.288860311000093, 42.08970591200004],
            [21.245727456000054, 42.096167109000035],
            [21.23780399600011, 42.0973540240001],
            [21.229298016000115, 42.10382211300008],
            [21.22540165200013, 42.106784973000075],
            [21.21620324700004, 42.12115102200009],
            [21.199873494000116, 42.141149801000026],
            [21.164423462000087, 42.16703969400005],
            [21.126389607000135, 42.188924662],
            [21.112953735000104, 42.194402364000084],
            [21.106235799000075, 42.19579762800005],
            [21.098484334000148, 42.19595265700009],
            [21.074403117000116, 42.18445465100008],
            [21.04093997800007, 42.15996989400004],
            [21.02923791500004, 42.1514075730001],
            [21.00391646300008, 42.14195078600004],
            [20.9751451810001, 42.13465801200006],
            [20.904170441000076, 42.11666775500002],
            [20.81054325300002, 42.09293569000003],
            [20.784911743000066, 42.082031962000045],
            [20.765378052000045, 42.06433278500005],
            [20.755352824000028, 42.04278371200009],
            [20.74305383300009, 41.993484395000095],
            [20.741813598000135, 41.970772603000015],
            [20.75143912800013, 41.94033778400008],
            [20.754422648000087, 41.930904236000075],
            [20.751052494000106, 41.91021769500007],
            [20.750495240000106, 41.906797180000055],
            [20.73995324700013, 41.88803863500006],
            [20.723313436000126, 41.86661875500003],
            [20.71439819800011, 41.859162991000076],
            [20.702952921000104, 41.84959137],
            [20.681455525000047, 41.84401031600008],
            [20.671843709000143, 41.849307150000115],
            [20.65282678300008, 41.86928009100005],
            [20.643421672000017, 41.87364674900003],
            [20.63701379300008, 41.87036529500004],
            [20.626161743000125, 41.85519826300002],
            [20.6187203370001, 41.85052154600005],
            [20.602390584000062, 41.84987559100007],
            [20.590298299000096, 41.854733175],
            [20.56714725800009, 41.87318166200002],
            [20.567767375000074, 41.880519715],
            [20.562703084000077, 41.892844544000056],
            [20.562496379000038, 41.900105082000024],
            [20.567250611000105, 41.912171530000094],
            [20.573348430000067, 41.9176750700001],
            [20.580583130000036, 41.921731669000096],
            [20.58874800600006, 41.92958648800003],
            [20.59928999800013, 41.94787994400009],
            [20.59928999800013, 41.96056650900006],
            [20.59432906100008, 41.97371816000002],
            [20.589678182000114, 41.99363942500004],
            [20.55825891100008, 42.05510854100005],
            [20.55216109200012, 42.07378957200011],
            [20.551954386000148, 42.10580312200001],
            [20.54937056500006, 42.12347646100001],
            [20.53862186700013, 42.15011566200006],
            [20.500794719000055, 42.21122304300006],
            [20.481674439000074, 42.230705058000055],
            [20.47366457600009, 42.23712300200002],
            [20.45697310400007, 42.25049713200012],
            [20.333363078000076, 42.317883200000026],
            [20.317963501000094, 42.319821065000056],
            [20.24964725700002, 42.31860666900003],
            [20.237761678000084, 42.31992441900009],
            [20.22959680200009, 42.32671986900003],
            [20.220915161000107, 42.34310129800009],
            [20.219468221000113, 42.35020680800001],
            [20.221225220000093, 42.363720195],
            [20.218848104000074, 42.3714458220001],
            [20.21306034300008, 42.37751780200004],
            [20.197454061000144, 42.38743967700013],
            [20.19280318200009, 42.39369252600004],
            [20.194043416000113, 42.40010040300008],
            [20.204378703000117, 42.41183095300006],
            [20.204688761000114, 42.420099182000016],
            [20.199727824000064, 42.42779897100009],
            [20.18629195200012, 42.4374366250001],
            [20.180814249000036, 42.443095195000055],
            [20.152702271000095, 42.49340220200013],
            [20.152598918000052, 42.49360890700008],
            [20.152598918000052, 42.49371226],
            [20.15239221200011, 42.49371226],
            [20.135545695000133, 42.50962860100013],
            [20.085626261000073, 42.530014954000066],
            [20.064955688000055, 42.54675811800003],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Spain',
        iso3: 'ESP',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-5.340728318999936, 35.847357489000046],
              [-5.362897908999884, 35.863806865000114],
              [-5.378400837999891, 35.881686910000084],
              [-5.389717976999862, 35.90204742500002],
              [-5.398858678999886, 35.924503853000076],
              [-5.385161912999934, 35.92617422100005],
              [-5.366200324999909, 35.92475006700005],
              [-5.344105597999942, 35.91474030200004],
              [-5.327381964999915, 35.90424225500004],
              [-5.309315558999913, 35.900824286000045],
              [-5.283070441999939, 35.91168854400007],
              [-5.291859503999945, 35.89052969000005],
              [-5.335560675999943, 35.86237213700008],
              [-5.340728318999936, 35.847357489000046],
            ],
          ],
          [
            [
              [-2.947824673999946, 35.329779364000046],
              [-2.922027147999927, 35.287990627000056],
              [-2.913197394999941, 35.27724844000005],
              [-2.912912563999953, 35.27692291900007],
              [-2.943045613999885, 35.2678742480001],
              [-2.963767862999902, 35.286219381000095],
              [-2.966920125999877, 35.313866272],
              [-2.947824673999946, 35.329779364000046],
            ],
          ],
          [
            [
              [-1.794074744885912, 43.38601533206285],
              [-1.796448933999955, 43.37438202],
              [-1.797172403999951, 43.353323873000065],
              [-1.796914021999953, 43.341128235000056],
              [-1.768233601999981, 43.330922140000084],
              [-1.755779581999889, 43.3185456340001],
              [-1.752420612999884, 43.29908945800004],
              [-1.74972998599992, 43.29479269100007],
              [-1.747356322999906, 43.29100209600004],
              [-1.736555948999865, 43.29231984400009],
              [-1.724825397999894, 43.29653147400005],
              [-1.703328002999854, 43.2986243700001],
              [-1.683019164999934, 43.304928894000014],
              [-1.673872435999925, 43.30415374800002],
              [-1.654907185999889, 43.297539164000014],
              [-1.645036986999912, 43.292371521000106],
              [-1.645192016999943, 43.28764312800003],
              [-1.647982543999916, 43.281545309000066],
              [-1.646328897999865, 43.2727861530001],
              [-1.63904252099988, 43.255681255000056],
              [-1.634081583999915, 43.251107890000085],
              [-1.621885945999907, 43.246999613000085],
              [-1.611085571999894, 43.24581105600005],
              [-1.598476521999942, 43.246999613000085],
              [-1.587572794999886, 43.251598817000044],
              [-1.581888386999935, 43.26035797100012],
              [-1.57398189299991, 43.277437032000066],
              [-1.559047403999926, 43.28407745400007],
              [-1.539203654999937, 43.283560690000016],
              [-1.508094441999901, 43.276765239000056],
              [-1.466391560999881, 43.26077138300012],
              [-1.455281127999854, 43.26221832300011],
              [-1.444222371999928, 43.2651122030001],
              [-1.432233438999987, 43.265008850000086],
              [-1.403501342999959, 43.243330587000074],
              [-1.399677286999946, 43.20674367300005],
              [-1.41052933799989, 43.16690114400002],
              [-1.425773884999927, 43.13527516700013],
              [-1.438434610999877, 43.12279530900004],
              [-1.479620727999873, 43.090264995],
              [-1.487837279999894, 43.0818158980001],
              [-1.475279906999987, 43.060137634000014],
              [-1.457141478999858, 43.04507395500012],
              [-1.435023965999932, 43.03572052000008],
              [-1.41052933799989, 43.030914612000075],
              [-1.383140827999853, 43.029209290000026],
              [-1.366139282999939, 43.033317567000026],
              [-1.357612670999913, 43.046830953],
              [-1.355183877999934, 43.07303090400002],
              [-1.348259236999866, 43.093081360000056],
              [-1.331050984999905, 43.10734405600003],
              [-1.308623412999907, 43.113571066000034],
              [-1.286040811999953, 43.109178569000036],
              [-1.306969766999941, 43.095975240000044],
              [-1.315082966999853, 43.082875265],
              [-1.310587117999944, 43.06949106900005],
              [-1.293688923999952, 43.05520253500008],
              [-1.274878702999928, 43.046830953],
              [-1.216897745999887, 43.03926035600004],
              [-1.182532918999925, 43.025281881000055],
              [-1.149925088999879, 43.00572235200012],
              [-1.112408, 43.00825449600002],
              [-1.103726358999921, 43.005748190000034],
              [-1.087189900999931, 42.99799672500002],
              [-1.079696817999888, 42.99339752200008],
              [-1.0450736089999, 42.99021942200001],
              [-1.028485473999893, 42.98670542400005],
              [-1.016289834999952, 42.97624094700002],
              [-0.981459920999896, 42.957043152],
              [-0.943219360999905, 42.9478964230001],
              [-0.863534301999948, 42.94306467700001],
              [-0.786433064999926, 42.953270773000085],
              [-0.759664672999861, 42.94650116000004],
              [-0.745031962999889, 42.918727227],
              [-0.740906128999939, 42.910896098000066],
              [-0.741422891999889, 42.90389394200007],
              [-0.744781859999904, 42.8992947390001],
              [-0.745867065999903, 42.89392039000005],
              [-0.740286010999881, 42.88479949900007],
              [-0.730105753999908, 42.8775131230001],
              [-0.720287231999862, 42.876608785000045],
              [-0.710520385999899, 42.877668153000045],
              [-0.700391804999924, 42.876427918],
              [-0.666078653999904, 42.860744120000035],
              [-0.648301961999891, 42.84978871700007],
              [-0.609492960999944, 42.81144480400003],
              [-0.60804602099995, 42.807181498],
              [-0.609958048999971, 42.802840679],
              [-0.610164753999925, 42.79909413700007],
              [-0.603550170999938, 42.79684621200006],
              [-0.587323770999916, 42.79684621200006],
              [-0.582931274999936, 42.79583852100011],
              [-0.577143513999943, 42.78979237900005],
              [-0.578538777999938, 42.7833069870001],
              [-0.578693806999866, 42.77733835900007],
              [-0.56903031399986, 42.7726358040001],
              [-0.561175495999919, 42.773540141000055],
              [-0.544432332999861, 42.782015076000036],
              [-0.535647338999894, 42.784211324000054],
              [-0.533890339999914, 42.80800832200002],
              [-0.508413858999887, 42.80749155700006],
              [-0.454463662999927, 42.78891388000001],
              [-0.423922892999911, 42.790670878000086],
              [-0.399738321999934, 42.801316223000086],
              [-0.351679239999896, 42.82924733500006],
              [-0.342997599999933, 42.822736105],
              [-0.335168619999905, 42.82495819100011],
              [-0.328243977999932, 42.832580465],
              [-0.322792113999952, 42.84250234000008],
              [-0.307418375999873, 42.83183115700008],
              [-0.305134937999952, 42.83081010700006],
              [-0.247034463999853, 42.804830221000046],
              [-0.235148885999934, 42.78622670500009],
              [-0.208354654999937, 42.78387542700004],
              [-0.179390014999882, 42.78974070200003],
              [-0.161406615999908, 42.79534759600007],
              [-0.163628702999887, 42.77798431400005],
              [-0.157789265999924, 42.76069854700005],
              [-0.145722818999928, 42.74589325000004],
              [-0.129238036999936, 42.73589386000002],
              [-0.12311437999989, 42.7303644820001],
              [-0.121822468999937, 42.723310649],
              [-0.119031941999879, 42.71685109500005],
              [-0.108489949999921, 42.71336293600008],
              [-0.095751708999956, 42.71067576100005],
              [-0.088852905999886, 42.70612823500004],
              [-0.084202026999918, 42.70108978300006],
              [-0.078414265999953, 42.69667144800006],
              [-0.038933471999911, 42.68514760400002],
              [-0.004310262999923, 42.68752472000007],
              [0.072842651000144, 42.70847951300006],
              [0.134182576000114, 42.715223288000104],
              [0.152941121000111, 42.72460256000004],
              [0.169167521000134, 42.72646291100004],
              [0.222394246000079, 42.71620514000007],
              [0.238362264000045, 42.71036570300008],
              [0.259807983000144, 42.68238291400006],
              [0.275388428000099, 42.66868866000006],
              [0.290245402000039, 42.67029062900009],
              [0.318305704000039, 42.69953949000005],
              [0.336030721000071, 42.712691142000025],
              [0.354169148000096, 42.71749705000012],
              [0.381816040000103, 42.70010793100009],
              [0.384012288000093, 42.6968523150001],
              [0.383676391000108, 42.69269236300006],
              [0.384399862000095, 42.68858408600006],
              [0.389283285000118, 42.68514760400002],
              [0.409282064000081, 42.68225372300013],
              [0.428789917000074, 42.68302887000006],
              [0.466927124000023, 42.69044443800006],
              [0.483515259000029, 42.68530263300006],
              [0.608158813000102, 42.6879898080001],
              [0.64360884600012, 42.68447581000005],
              [0.656734660000097, 42.6879898080001],
              [0.66342581400005, 42.69621435100008],
              [0.66541630100005, 42.6986609910001],
              [0.666449829000044, 42.71475820000008],
              [0.659628540000085, 42.72989939400007],
              [0.647639608000134, 42.7410356650001],
              [0.633480265000088, 42.744782206000124],
              [0.63957808400005, 42.754833272000056],
              [0.643298787000049, 42.7590707400001],
              [0.650740194000065, 42.76338572300007],
              [0.639681437000149, 42.77467702300005],
              [0.653737427000095, 42.802685649000054],
              [0.651567016000087, 42.82405385400007],
              [0.656321248000097, 42.83841990200007],
              [0.679368937000049, 42.845112],
              [0.706757446000097, 42.84658477900008],
              [0.72432743300007, 42.845292867000026],
              [0.758847290000062, 42.835267640000026],
              [0.776313924000078, 42.832451274000036],
              [0.795744263000074, 42.83384653700004],
              [0.812900838000132, 42.831624451000025],
              [0.856102336000077, 42.8127625530001],
              [0.885764608000045, 42.80423594200009],
              [0.894446248000094, 42.79932668100004],
              [0.910362589000101, 42.78767364600007],
              [0.921111287000116, 42.784366354000085],
              [0.930619751000108, 42.78803538000007],
              [0.940024862000087, 42.79366811200002],
              [0.950256795000143, 42.796122742000065],
              [0.958731730000068, 42.79371978800002],
              [0.975268189000133, 42.78374623600011],
              [0.982916300000113, 42.7803614300001],
              [1.068182414000091, 42.776123963000046],
              [1.089059692000149, 42.77131805400005],
              [1.106733032000079, 42.759613343000055],
              [1.116551554000125, 42.745247294000066],
              [1.124096313000081, 42.72974436500003],
              [1.13432824700007, 42.7159725960001],
              [1.151484823000118, 42.706722514],
              [1.162543579000044, 42.705688986],
              [1.195926554000096, 42.71364715600008],
              [1.319123169000079, 42.71336293600008],
              [1.342584269000042, 42.708660381000115],
              [1.338243449000061, 42.69444936100005],
              [1.343307739000039, 42.69044443800006],
              [1.352712850000103, 42.690056865000045],
              [1.361084432000069, 42.68672373500006],
              [1.378757771000068, 42.66323679600008],
              [1.397981404000092, 42.64362559000004],
              [1.414827921000068, 42.60933827700002],
              [1.42929732200011, 42.59538564100005],
              [1.424853150000104, 42.589365336000085],
              [1.419272095000082, 42.57926259400004],
              [1.418031860000042, 42.56983164500009],
              [1.426403442000122, 42.56564585400007],
              [1.426300090000097, 42.561795960000026],
              [1.409763631000089, 42.54060862200005],
              [1.406456339000101, 42.52923980800007],
              [1.428987264000114, 42.53146189400006],
              [1.446557251000087, 42.51988637400002],
              [1.449967895000043, 42.50407338400002],
              [1.430227498000079, 42.493557231000054],
              [1.424543090000014, 42.49247202600007],
              [1.407593221000099, 42.48676178000004],
              [1.436428670000055, 42.453482158000085],
              [1.436428670000055, 42.44095062300006],
              [1.447900838000066, 42.43464609800007],
              [1.508465617000127, 42.42867747000004],
              [1.516630493000122, 42.42950429300005],
              [1.528206014000091, 42.434232686000044],
              [1.534510539000109, 42.43991709400008],
              [1.538851359000091, 42.44565317800006],
              [1.544432414000084, 42.45035573400013],
              [1.607477661000132, 42.45642771400007],
              [1.639517049000119, 42.466427104],
              [1.650369100000091, 42.49340220200013],
              [1.653986450000076, 42.496528626000085],
              [1.656983683000078, 42.497639669000066],
              [1.659774210000137, 42.496812846000054],
              [1.662358032000043, 42.49371226],
              [1.674243611000065, 42.490508321000036],
              [1.68633589600006, 42.49061167500007],
              [1.697498006000075, 42.49446156900011],
              [1.707006470000067, 42.50278147400006],
              [1.710003703000069, 42.501334534000065],
              [1.711967407000117, 42.49929331500003],
              [1.712690877000114, 42.496787008000055],
              [1.71217411300006, 42.49371226],
              [1.730570923000073, 42.488053691000076],
              [1.792685995000056, 42.48172332800006],
              [1.813666626000042, 42.475237936],
              [1.869787232000107, 42.446790060000055],
              [1.89324833200007, 42.44273346000007],
              [1.911955200000136, 42.44195831300006],
              [1.927458129000058, 42.43689402300008],
              [1.941100708000079, 42.420099182000016],
              [1.954226522000056, 42.382685445000035],
              [1.963734985000116, 42.367234192000055],
              [1.983372030000055, 42.354547628],
              [1.995671020000088, 42.348682353000086],
              [2.009210245000077, 42.34708038300006],
              [2.035255168000049, 42.34925079400007],
              [2.05168827300011, 42.35235138000009],
              [2.063263794000079, 42.35790659700011],
              [2.080110311000055, 42.37126495400004],
              [2.103984823000133, 42.38483001700003],
              [2.108739054000125, 42.39064361600002],
              [2.116283813000081, 42.40539723700003],
              [2.121038045000148, 42.410616557000125],
              [2.136954386000099, 42.41622345000006],
              [2.184186645000125, 42.411805115000064],
              [2.245991659000111, 42.42611948700004],
              [2.277410930000144, 42.428625794000126],
              [2.305316203000132, 42.41697275800006],
              [2.317305135000083, 42.409608867000046],
              [2.375492798000096, 42.38932586700004],
              [2.406602010000142, 42.38426157600007],
              [2.422518351000065, 42.38369313600002],
              [2.429856404000077, 42.367544251000126],
              [2.445566040000131, 42.351963806000086],
              [2.464893025000094, 42.34062082900003],
              [2.483393188000122, 42.33697764100002],
              [2.503650350000015, 42.32845103000001],
              [2.514812459000069, 42.32566050300004],
              [2.525251098000098, 42.32589304700009],
              [2.531969035000117, 42.33077647000003],
              [2.540340617000084, 42.34697703100004],
              [2.548092081000107, 42.35224802700007],
              [2.56741906700006, 42.352635600000085],
              [2.613411092000149, 42.3409567260001],
              [2.635425253000022, 42.33788197900007],
              [2.662193644000098, 42.33901886100007],
              [2.661780232000098, 42.34335968000006],
              [2.649377889000107, 42.353720806000084],
              [2.640282837000143, 42.372841085000076],
              [2.648241007000109, 42.3814710490001],
              [2.690408976000072, 42.406172384000016],
              [2.708082316000059, 42.412890320000045],
              [2.72854618300002, 42.41402720200007],
              [2.767716919000065, 42.40955719100005],
              [2.788594198000055, 42.41201182100009],
              [2.804613892000106, 42.41955658000005],
              [2.834792928000098, 42.441312358000076],
              [2.850812622000149, 42.44836619100009],
              [2.866935669000043, 42.44963226300003],
              [2.88409224500009, 42.449193014000016],
              [2.900835409000138, 42.45126007100008],
              [2.933701619000061, 42.47022532200002],
              [2.966051066000148, 42.46100107900013],
              [2.983104289000096, 42.469320984],
              [2.993749634000096, 42.467615662000114],
              [3.02299849400012, 42.46704722100007],
              [3.029613077000135, 42.465651957],
              [3.036020956000073, 42.45461903900009],
              [3.04387577300011, 42.445265605000046],
              [3.053590942000142, 42.437643331000075],
              [3.065579874000093, 42.432010600000055],
              [3.086147094000097, 42.42717885400005],
              [3.111675252000111, 42.425008444000056],
              [3.137823527000137, 42.42593862000008],
              [3.180969656804698, 42.43148414767083],
              [3.178721550000091, 42.41799551000008],
              [3.170176629000082, 42.396592515000066],
              [3.174489780000044, 42.38088613500008],
              [3.174489780000044, 42.363796291000085],
              [3.187347852000073, 42.34951406500005],
              [3.204193556000064, 42.33958567900004],
              [3.226491733000046, 42.34251536700003],
              [3.249847852000073, 42.34320709800005],
              [3.26303144600007, 42.32920970300006],
              [3.269867384000065, 42.32920970300006],
              [3.28060957100007, 42.33685944200005],
              [3.293711785000085, 42.33498769700009],
              [3.31771894600007, 42.32298411700003],
              [3.294037306000064, 42.28803131700005],
              [3.29037519600007, 42.27806224200003],
              [3.287038608000046, 42.262925523000035],
              [3.279388868000069, 42.25564199400009],
              [3.270355665000068, 42.250108140000066],
              [3.26303144600007, 42.23985423400006],
              [3.247162306000064, 42.24571360900006],
              [3.210134311000047, 42.23973216400009],
              [3.178721550000091, 42.249701239000046],
              [3.170176629000082, 42.25967031500005],
              [3.151621941000087, 42.25682200700004],
              [3.130300326000054, 42.23973216400009],
              [3.11882571700005, 42.21832916900007],
              [3.117442254000082, 42.182847398000035],
              [3.116465691000087, 42.15843333500004],
              [3.122487826000054, 42.14048899900007],
              [3.138601108000046, 42.12763092700004],
              [3.173106316000087, 42.11200592700004],
              [3.192298528000038, 42.09292147100007],
              [3.21449569300006, 42.06833384600009],
              [3.213009237000051, 42.05598607700006],
              [3.199859564000064, 42.046190092000074],
              [3.195896147000042, 42.03311787200005],
              [3.201589389000048, 42.01744212400007],
              [3.206960483000046, 41.99669017100007],
              [3.207855665000068, 41.99001699400009],
              [3.211843295000051, 41.98460521000004],
              [3.230560743000069, 41.97300853100006],
              [3.23568769600007, 41.96552155200004],
              [3.23218834700009, 41.94603099200003],
              [3.207448764000048, 41.91392649900007],
              [3.194916212000066, 41.88829173400006],
              [3.178558790000068, 41.87523021000004],
              [3.150165377000064, 41.845350970000084],
              [3.116829332000066, 41.84756921200005],
              [3.078630960000055, 41.826618274000054],
              [3.069057555000086, 41.79907611200008],
              [3.040341037000076, 41.78689001300006],
              [2.95093834700009, 41.73427969000005],
              [2.932990851000056, 41.71246437600007],
              [2.900870238000039, 41.706706377000046],
              [2.877253539000094, 41.70195770000004],
              [2.851084832000083, 41.69717031500005],
              [2.840179884000065, 41.694647528000075],
              [2.835459832000083, 41.692572333000044],
              [2.820160352000073, 41.68195221600007],
              [2.817067905000044, 41.67763906500005],
              [2.813161655000044, 41.67031484600005],
              [2.803721550000091, 41.66864655200004],
              [2.792002800000091, 41.66901276200008],
              [2.778496578000045, 41.64558226100007],
              [2.651866082000083, 41.60529205900008],
              [2.449473504000082, 41.535223700000074],
              [2.428965691000087, 41.51894765800006],
              [2.371348504000082, 41.48920319200005],
              [2.296722852000073, 41.46531810100004],
              [2.26734459700009, 41.44863515800006],
              [2.240407748000052, 41.42096588700008],
              [2.191905144000089, 41.356756903000075],
              [2.163259311000047, 41.32664622600004],
              [2.13054446700005, 41.30365631700005],
              [2.06031334700009, 41.274603583000044],
              [2.019704623000052, 41.26585521000004],
              [1.951345248000052, 41.26068756700005],
              [1.88412519600007, 41.24750397300005],
              [1.863780144000089, 41.23810455900008],
              [1.854014519000089, 41.235988674000055],
              [1.819834832000083, 41.23712799700007],
              [1.62435957100007, 41.19216543200008],
              [1.539235873000052, 41.18744538000004],
              [1.288096550000091, 41.11627838700008],
              [1.217784050000091, 41.104681708000044],
              [1.210052931000064, 41.09988027600008],
              [1.192474806000064, 41.07599518400008],
              [1.188649936000047, 41.06830475500004],
              [1.183604363000086, 41.062567450000074],
              [1.172943556000064, 41.058661200000074],
              [1.149099155000044, 41.069647528000075],
              [1.141693556000064, 41.07172272300005],
              [1.097666863000086, 41.07086823100008],
              [1.055674675000091, 41.064886786000045],
              [1.017425977000073, 41.05178457200009],
              [0.990407748000052, 41.03969961100006],
              [0.877452019000089, 40.954779364000046],
              [0.822764519000089, 40.899603583000044],
              [0.71420332100007, 40.81521230700008],
              [0.694834832000083, 40.785996812000064],
              [0.721527540000068, 40.774278062000064],
              [0.750173373000052, 40.76557038000004],
              [0.762380405000044, 40.766058661000045],
              [0.76726321700005, 40.77102285400008],
              [0.763519727000073, 40.77838776200008],
              [0.750173373000052, 40.785996812000064],
              [0.76693769600007, 40.78502024900007],
              [0.780528191000087, 40.77948639500005],
              [0.792002800000091, 40.771185614000046],
              [0.815928582000083, 40.74839915600006],
              [0.841807488000086, 40.732123114000046],
              [0.854177280000044, 40.73314036700009],
              [0.873708530000044, 40.72793203300006],
              [0.87240644600007, 40.707098700000074],
              [0.858083530000044, 40.68626536700009],
              [0.848317905000044, 40.67536041900007],
              [0.784027540000068, 40.66095612200007],
              [0.756358269000089, 40.642238674000055],
              [0.707041863000086, 40.58340078300006],
              [0.67709394600007, 40.56517161700009],
              [0.647959832000083, 40.55691152600008],
              [0.615896030000044, 40.55345286700009],
              [0.592458530000044, 40.582098700000074],
              [0.640635613000086, 40.58685944200005],
              [0.663177931000064, 40.574733791000085],
              [0.696218295000051, 40.590358791000085],
              [0.732676629000082, 40.63373444200005],
              [0.712494337000066, 40.63617584800005],
              [0.682220899000072, 40.63422272300005],
              [0.599782748000052, 40.613714911000045],
              [0.580170118000069, 40.60366445500006],
              [0.563487175000091, 40.59003327000005],
              [0.54851321700005, 40.572333075000074],
              [0.517425977000073, 40.51434967700004],
              [0.50131269600007, 40.48419830900008],
              [0.483409050000091, 40.46503327000005],
              [0.46615644600007, 40.45066966400009],
              [0.452647332000083, 40.43406810100004],
              [0.446136915000068, 40.40843333500004],
              [0.420258009000065, 40.38825104400007],
              [0.350596550000091, 40.28489817900004],
              [0.338959181000064, 40.27435944200005],
              [0.312103712000066, 40.257513739000046],
              [0.298838738000086, 40.24677155200004],
              [0.264740431000064, 40.20978424700007],
              [0.205251498000052, 40.171535549000055],
              [0.144541863000086, 40.07884349200009],
              [0.117035352000073, 40.056341864000046],
              [0.06617272200009, 40.03192780200004],
              [0.040497267000092, 40.00287506700005],
              [-0.002919074999909, 39.93195221600007],
              [-0.028675910999937, 39.90180084800005],
              [-0.091297980999911, 39.84792715100008],
              [-0.194488084999932, 39.71544017100007],
              [-0.199818488999938, 39.70494212400007],
              [-0.202137824999909, 39.680853583000044],
              [-0.208933071999923, 39.66408926000008],
              [-0.219838019999941, 39.65139394700009],
              [-0.243723110999952, 39.63104889500005],
              [-0.257435675999943, 39.61623769700009],
              [-0.269561326999906, 39.59870026200008],
              [-0.274891730999911, 39.58181386900009],
              [-0.28148352799991, 39.56936269700009],
              [-0.31273352799991, 39.53400299700007],
              [-0.323353644999941, 39.51622142100007],
              [-0.330593476999923, 39.480406634000076],
              [-0.327471569999943, 39.43067493700005],
              [-0.320668097999942, 39.38812897300005],
              [-0.301340298999946, 39.32200755400004],
              [-0.23870140799994, 39.21544586500005],
              [-0.227817945999959, 39.19933563600006],
              [-0.215492823999909, 39.18183854400007],
              [-0.227857368999935, 39.17524499700005],
              [-0.242182165999907, 39.16627518000007],
              [-0.23650532299996, 39.14805346800006],
              [-0.226703362999956, 39.11178175500004],
              [-0.210026595999921, 39.078690194000046],
              [-0.184040187999926, 39.04225851600006],
              [-0.158029751999948, 39.00214264500005],
              [-0.120676235999952, 38.95111725500004],
              [-0.105946417999917, 38.93650950700004],
              [-0.06859290299991, 38.913397528000075],
              [-0.030995245999918, 38.88275788000004],
              [-0.009755011999914, 38.86969635600008],
              [0.017425977000073, 38.86432526200008],
              [0.063080274000072, 38.86078522300005],
              [0.11101321700005, 38.84992096600007],
              [0.15398196700005, 38.83100006700005],
              [0.18531334700009, 38.80353424700007],
              [0.18100019600007, 38.80190664300005],
              [0.170909050000091, 38.796087958000044],
              [0.182871941000087, 38.79181549700007],
              [0.19076582100007, 38.785223700000074],
              [0.217865431000064, 38.76813385600008],
              [0.227712436000047, 38.77020905200004],
              [0.23406009200005, 38.757879950000074],
              [0.234548373000052, 38.742254950000074],
              [0.227712436000047, 38.73456452000005],
              [0.208994988000086, 38.733710028000075],
              [0.192067905000044, 38.73041413000004],
              [0.176768425000091, 38.72402578300006],
              [0.162608269000089, 38.71352773600006],
              [0.150889519000089, 38.69245026200008],
              [0.148936394000089, 38.68992747600004],
              [0.145030144000089, 38.68634674700007],
              [0.125743035000085, 38.68549225500004],
              [0.118581576000054, 38.682806708000044],
              [0.105316602000073, 38.67255280200004],
              [0.093679233000046, 38.667629299000055],
              [0.083018425000091, 38.66095612200007],
              [0.073130730000059, 38.64520905200004],
              [0.080577019000089, 38.63100820500006],
              [0.060435418000054, 38.634833075000074],
              [0.04664147200009, 38.63222890800006],
              [0.033376498000052, 38.627386786000045],
              [0.015025261000062, 38.62474192900004],
              [-0.014759894999941, 38.62441640800006],
              [-0.028797980999911, 38.62067291900007],
              [-0.042958136999914, 38.61172109600005],
              [-0.054758266999954, 38.59528229400007],
              [-0.055083787999934, 38.58075592700004],
              [-0.053618943999936, 38.56696198100008],
              [-0.060047980999911, 38.552720445000034],
              [-0.075428839999915, 38.539943752000056],
              [-0.090199347999942, 38.53534577000005],
              [-0.131743943999936, 38.53534577000005],
              [-0.176991339999915, 38.52724844000005],
              [-0.202137824999909, 38.519598700000074],
              [-0.233957485999952, 38.501654364000046],
              [-0.329416469999956, 38.470038153000075],
              [-0.344553188999953, 38.46161530200004],
              [-0.350819464999915, 38.45001862200007],
              [-0.358713344999956, 38.44594961100006],
              [-0.39517167899993, 38.413763739000046],
              [-0.406076626999948, 38.398871161000045],
              [-0.410145636999914, 38.379339911000045],
              [-0.409982876999948, 38.36896393400008],
              [-0.413685675999943, 38.36481354400007],
              [-0.445871548999946, 38.36343008000006],
              [-0.460194464999915, 38.36005280200004],
              [-0.470570441999939, 38.35187409100007],
              [-0.474354620999918, 38.33673737200007],
              [-0.509836391999954, 38.33836497600004],
              [-0.518788214999915, 38.29865143400008],
              [-0.504017706999946, 38.20722077000005],
              [-0.515451626999948, 38.19550202000005],
              [-0.532866990999935, 38.19216543200008],
              [-0.568837042999917, 38.194199937000064],
              [-0.591379360999952, 38.18964264500005],
              [-0.609486456999946, 38.17804596600007],
              [-0.62368730399993, 38.16242096600007],
              [-0.634388800999943, 38.145819403000075],
              [-0.640736456999946, 38.13165924700007],
              [-0.645008917999917, 38.11603424700007],
              [-0.648019985999952, 38.07379791900007],
              [-0.652495897999927, 38.00775788000004],
              [-0.65453040299991, 37.98932526200008],
              [-0.663400844999956, 37.98029205900008],
              [-0.689930792999917, 37.97215403900009],
              [-0.708851691999939, 37.956284898000035],
              [-0.718413865999935, 37.943019924000055],
              [-0.758615688999953, 37.863348700000074],
              [-0.760731574999909, 37.84707265800006],
              [-0.760568813999953, 37.84585195500006],
              [-0.75609290299991, 37.80605703300006],
              [-0.760731574999909, 37.796128648000035],
              [-0.787993943999936, 37.82282135600008],
              [-0.812408006999931, 37.77008698100008],
              [-0.825550910999937, 37.761379299000055],
              [-0.847808397999927, 37.75608958500004],
              [-0.85610917899993, 37.74249909100007],
              [-0.852609829999949, 37.72378164300005],
              [-0.819813605999911, 37.67670319200005],
              [-0.809925910999937, 37.666896877000056],
              [-0.777699347999942, 37.650091864000046],
              [-0.754790818999936, 37.64130280200004],
              [-0.734852667999917, 37.63934967700004],
              [-0.726470506999931, 37.65151601800005],
              [-0.707997199999909, 37.643011786000045],
              [-0.701242641999954, 37.63133372600004],
              [-0.70531165299991, 37.61953359600005],
              [-0.719715949999909, 37.610541083000044],
              [-0.727894660999937, 37.60342031500005],
              [-0.73664303299995, 37.59943268400008],
              [-0.745676235999952, 37.59943268400008],
              [-0.754505988999938, 37.60431549700007],
              [-0.764027472999942, 37.599595445000034],
              [-0.791493292999917, 37.591457424000055],
              [-0.807972785999937, 37.58844635600008],
              [-0.836415167999917, 37.57640208500004],
              [-0.873890753999945, 37.57640208500004],
              [-0.886708136999914, 37.574286200000074],
              [-0.90062415299991, 37.56903717700004],
              [-0.925160285999937, 37.555894273000035],
              [-0.933705206999946, 37.56102122600004],
              [-0.973500128999945, 37.57640208500004],
              [-1.006418423999946, 37.58144765800006],
              [-1.069935675999943, 37.58258698100008],
              [-1.087757941999939, 37.58087799700007],
              [-1.103423631999931, 37.57640208500004],
              [-1.114654100999928, 37.56867096600007],
              [-1.119984503999945, 37.559027411000045],
              [-1.116851365999935, 37.54938385600008],
              [-1.10576668799996, 37.532134935000045],
              [-1.137171939999917, 37.53800062300007],
              [-1.167057480999915, 37.543755316000045],
              [-1.173408476999953, 37.55507578800007],
              [-1.178585325999961, 37.563883357000066],
              [-1.199732067999946, 37.56656465400005],
              [-1.228993292999917, 37.57607656500005],
              [-1.242698867999934, 37.57920279700005],
              [-1.25766680299995, 37.567013400000064],
              [-1.261670586999912, 37.55766126800006],
              [-1.289784308999913, 37.55841705900008],
              [-1.323735140999929, 37.56199082100005],
              [-1.353260870999918, 37.54991282800006],
              [-1.369170701999906, 37.54136790600006],
              [-1.413685675999943, 37.50653717700004],
              [-1.430368618999921, 37.498114325000074],
              [-1.450225389999957, 37.49469635600008],
              [-1.455555792999917, 37.492702541000085],
              [-1.463490363999938, 37.487982489000046],
              [-1.470895962999919, 37.48224518400008],
              [-1.474110480999911, 37.47760651200008],
              [-1.476673956999946, 37.472723700000074],
              [-1.487294074999909, 37.43976471600007],
              [-1.488352016999954, 37.43321360900006],
              [-1.496937628999945, 37.427801825000074],
              [-1.502797003999945, 37.42926666900007],
              [-1.508168097999942, 37.43268463700008],
              [-1.515004035999937, 37.43321360900006],
              [-1.523915167999917, 37.42865631700005],
              [-1.543731248999961, 37.41498444200005],
              [-1.55296790299991, 37.412176825000074],
              [-1.567738410999937, 37.40993886900009],
              [-1.618723110999952, 37.392279364000046],
              [-1.64161771299996, 37.38103644700004],
              [-1.645913442999927, 37.36924709500005],
              [-1.65283894199996, 37.36125918700009],
              [-1.670887824999909, 37.36330801000008],
              [-1.680165167999917, 37.35443756700005],
              [-1.68578040299991, 37.33698151200008],
              [-1.698963995999918, 37.31643301000008],
              [-1.728505011999914, 37.282416083000044],
              [-1.787220831999946, 37.235215562000064],
              [-1.81273352799991, 37.20705801000008],
              [-1.830352342999959, 37.16636790600006],
              [-1.837757941999939, 37.13161855700008],
              [-1.84984290299991, 37.10443756700005],
              [-1.855213995999918, 37.076605536000045],
              [-1.88499915299991, 37.01548899900007],
              [-1.906117316999939, 36.987616278000075],
              [-1.906971808999913, 36.97528717700004],
              [-1.904164191999939, 36.96637604400007],
              [-1.900502081999946, 36.95876699400009],
              [-1.89867102799991, 36.950059312000064],
              [-1.900339321999923, 36.94118886900009],
              [-1.905222133999928, 36.935980536000045],
              [-1.912871873999961, 36.93353913000004],
              [-1.935292120999918, 36.93219635600008],
              [-1.941395636999914, 36.92987702000005],
              [-1.953846808999913, 36.91994863500008],
              [-1.98892167899993, 36.900498765000066],
              [-2.002797003999945, 36.88703034100007],
              [-2.013050910999937, 36.845770575000074],
              [-2.024769660999937, 36.83376699400009],
              [-2.04047604099992, 36.824326890000066],
              [-2.05687415299991, 36.81008535400008],
              [-2.060739712999919, 36.802435614000046],
              [-2.065907355999911, 36.78355540600006],
              [-2.071156378999945, 36.77533600500004],
              [-2.08031165299991, 36.77061595300006],
              [-2.091420050999943, 36.76825592700004],
              [-2.100819464999915, 36.76516347900008],
              [-2.111073370999918, 36.74612051000008],
              [-2.126698370999918, 36.736395575000074],
              [-2.14671790299991, 36.72992584800005],
              [-2.166127081999946, 36.72756582200009],
              [-2.203643357999908, 36.73712799700007],
              [-2.231678839999915, 36.76007721600007],
              [-2.256133592999959, 36.78738027600008],
              [-2.282785610999952, 36.81008535400008],
              [-2.318348761999914, 36.82790761900009],
              [-2.339141404999907, 36.83425527600008],
              [-2.361683722999942, 36.836778062000064],
              [-2.380238410999937, 36.83376699400009],
              [-2.412709113999938, 36.820013739000046],
              [-2.433094855999911, 36.81627024900007],
              [-2.442331508999928, 36.81830475500004],
              [-2.46939042899993, 36.82774485900006],
              [-2.481434699999909, 36.82994212400007],
              [-2.56078040299991, 36.818793036000045],
              [-2.576893683999913, 36.81130605700008],
              [-2.596709764999957, 36.773098049000055],
              [-2.617176886999914, 36.72842031500005],
              [-2.642689581999946, 36.707017320000034],
              [-2.647572394999941, 36.70416901200008],
              [-2.658884243999921, 36.69481028900009],
              [-2.684356248999961, 36.685980536000045],
              [-2.718251105999911, 36.68203359600005],
              [-2.736195441999939, 36.68740469000005],
              [-2.756662563999953, 36.68036530200004],
              [-2.782948370999918, 36.694606838000084],
              [-2.802601691999939, 36.70730215100008],
              [-2.820993618999921, 36.71389394700009],
              [-2.829986131999931, 36.71173737200007],
              [-2.839060024999924, 36.702419338000084],
              [-2.848255988999938, 36.70022207200009],
              [-2.858754035999937, 36.70494212400007],
              [-2.886097785999937, 36.73440176000008],
              [-2.913970506999931, 36.75031159100007],
              [-2.933257615999935, 36.751654364000046],
              [-2.987718933999929, 36.73710894900006],
              [-3.076453404999938, 36.749756234000074],
              [-3.156711171999916, 36.744525733000046],
              [-3.227894660999937, 36.75482819200005],
              [-3.329579230999911, 36.74489980700008],
              [-3.34439042899993, 36.73692454600007],
              [-3.358306443999936, 36.72593821800007],
              [-3.378773566999939, 36.71389394700009],
              [-3.415154668999946, 36.69551628700009],
              [-3.477602127999944, 36.696095994000075],
              [-3.515962546999958, 36.72104650500006],
              [-3.536060363999923, 36.71840638700007],
              [-3.54983156499992, 36.71237268600004],
              [-3.586401548999959, 36.72657925700008],
              [-3.601100173999953, 36.74255029400007],
              [-3.632419884999933, 36.74127967000004],
              [-3.665666698999928, 36.73937041600004],
              [-3.679822363999961, 36.728807878000055],
              [-3.731281329999945, 36.72409732400007],
              [-3.803433052999935, 36.74247433600004],
              [-3.838541254999939, 36.751969933000055],
              [-3.889444745999924, 36.74338838400007],
              [-3.960961123999937, 36.72679277900005],
              [-4.056711391999954, 36.74799225500004],
              [-4.079957949999937, 36.743564192000065],
              [-4.110172195999951, 36.725732647000086],
              [-4.197010870999918, 36.71539948100008],
              [-4.224720831999946, 36.71238841400009],
              [-4.403187628999945, 36.723863023000035],
              [-4.420318162999934, 36.71987539300005],
              [-4.433257615999935, 36.71067942900004],
              [-4.46117102799991, 36.67145416900007],
              [-4.466867641999954, 36.66303131700005],
              [-4.480458136999914, 36.65119049700007],
              [-4.491118943999936, 36.63666413000004],
              [-4.495350714999915, 36.62055084800005],
              [-4.524826052999913, 36.58071526400005],
              [-4.58779979399992, 36.57381766100008],
              [-4.615021325999919, 36.53055576100007],
              [-4.649810350999928, 36.51211172100005],
              [-4.659250454999949, 36.50763580900008],
              [-4.680287238999938, 36.50079987200007],
              [-4.722767706999946, 36.49298737200007],
              [-4.764230923999946, 36.49396393400008],
              [-4.88031979099992, 36.50568268400008],
              [-4.90265865799995, 36.50653717700004],
              [-4.912180141999954, 36.504014390000066],
              [-4.923532680999926, 36.49685293200008],
              [-4.994166374999907, 36.45709395800009],
              [-5.062489386999914, 36.45221588700008],
              [-5.108713344999956, 36.429022528000075],
              [-5.121042446999923, 36.42556386900009],
              [-5.157622850999928, 36.421942450000074],
              [-5.173654751999948, 36.41742584800005],
              [-5.186553514999957, 36.41120026200008],
              [-5.199655727999925, 36.39716217700004],
              [-5.227121548999946, 36.357936916000085],
              [-5.227935350999928, 36.348537502000056],
              [-5.244699673999946, 36.31207916900007],
              [-5.253651495999918, 36.29710521000004],
              [-5.258615688999953, 36.29254791900007],
              [-5.26593990799995, 36.287095445000034],
              [-5.274118618999921, 36.282538153000075],
              [-5.290598110999952, 36.277411200000074],
              [-5.289499477999925, 36.26984284100007],
              [-5.285308397999927, 36.26080963700008],
              [-5.296620245999918, 36.247381903000075],
              [-5.329335089999915, 36.198146877000056],
              [-5.334055141999954, 36.18781159100007],
              [-5.338773483242616, 36.14111967199992],
              [-5.358386758461411, 36.141109447000375],
              [-5.366607225999928, 36.16315338700008],
              [-5.382517055999926, 36.172308661000045],
              [-5.406076626999948, 36.17922597900008],
              [-5.425445115999935, 36.179754950000074],
              [-5.428700324999909, 36.169989325000074],
              [-5.437896287999934, 36.16148509300007],
              [-5.442331508999928, 36.14878978100006],
              [-5.441477016999954, 36.13454824400009],
              [-5.434885219999956, 36.121527411000045],
              [-5.439890102999925, 36.11420319200005],
              [-5.437163865999935, 36.09870026200008],
              [-5.431630011999914, 36.08893463700008],
              [-5.428700324999909, 36.08079661700009],
              [-5.431833462999919, 36.069566148000035],
              [-5.438628709999932, 36.06281159100007],
              [-5.445505337999919, 36.05744049700007],
              [-5.466501430999926, 36.05072663000004],
              [-5.566599087999919, 36.02163320500006],
              [-5.581003383999928, 36.01398346600007],
              [-5.611765102999925, 36.00645579600007],
              [-5.629709438999953, 36.036769924000055],
              [-5.671701626999948, 36.055975653000075],
              [-5.689361131999931, 36.06712474200009],
              [-5.71312415299991, 36.05996328300006],
              [-5.733876105999911, 36.065659898000035],
              [-5.753651495999918, 36.07558828300006],
              [-5.796050584999932, 36.08551666900007],
              [-5.811268683999913, 36.09682851800005],
              [-5.832753058999913, 36.122381903000075],
              [-5.89789791599992, 36.173895575000074],
              [-5.917185024999924, 36.18406810100004],
              [-5.938954230999911, 36.18382396000004],
              [-5.983550584999932, 36.176988023000035],
              [-6.036773240999935, 36.189520575000074],
              [-6.062489386999914, 36.217230536000045],
              [-6.082183397999927, 36.25067780200004],
              [-6.104725714999915, 36.28070709800005],
              [-6.159453904999907, 36.30430735900006],
              [-6.165964321999923, 36.31871165600006],
              [-6.168527798999946, 36.33531321800007],
              [-6.175200975999928, 36.353583075000074],
              [-6.184193488999938, 36.37071360900006],
              [-6.218373175999943, 36.402451890000066],
              [-6.242054816999939, 36.446478583000044],
              [-6.257110154999907, 36.47642649900007],
              [-6.27961178299995, 36.51129791900007],
              [-6.30142167899993, 36.52598704600007],
              [-6.31000729099992, 36.53412506700005],
              [-6.297678188999953, 36.538763739000046],
              [-6.28937740799995, 36.53729889500005],
              [-6.257517055999926, 36.513780015000066],
              [-6.248972133999928, 36.504746812000064],
              [-6.254099087999919, 36.49628327000005],
              [-6.246652798999946, 36.48663971600007],
              [-6.231475389999957, 36.47268301000008],
              [-6.21906490799995, 36.47496165600006],
              [-6.211496548999946, 36.480536200000074],
              [-6.200754360999952, 36.493841864000046],
              [-6.179351365999935, 36.51353587400007],
              [-6.186472133999928, 36.51422760600008],
              [-6.206817186999956, 36.50889720300006],
              [-6.224354620999918, 36.51085032800006],
              [-6.232451951999906, 36.52619049700007],
              [-6.22602291599992, 36.55666738500008],
              [-6.234893357999908, 36.57575104400007],
              [-6.283192511999914, 36.61237213700008],
              [-6.293853318999936, 36.616848049000055],
              [-6.361724412999934, 36.62055084800005],
              [-6.379790818999936, 36.624253648000035],
              [-6.394683397999927, 36.63690827000005],
              [-6.406971808999913, 36.67670319200005],
              [-6.417632615999935, 36.69594961100006],
              [-6.431548631999931, 36.71458567900004],
              [-6.437896287999934, 36.733303127000056],
              [-6.433338995999918, 36.751206773000035],
              [-6.414540167999917, 36.767645575000074],
              [-6.396311001999948, 36.775091864000046],
              [-6.358876105999911, 36.78583405200004],
              [-6.345611131999931, 36.794989325000074],
              [-6.335194464999915, 36.81826406500005],
              [-6.343739386999914, 36.85993073100008],
              [-6.33820553299995, 36.88373444200005],
              [-6.304351365999935, 36.90721263200004],
              [-6.223255988999938, 36.902329820000034],
              [-6.194813605999911, 36.93211497600004],
              [-6.214019334999932, 36.92169830900008],
              [-6.239654100999928, 36.913397528000075],
              [-6.265044725999928, 36.91290924700007],
              [-6.283558722999942, 36.92593008000006],
              [-6.325917120999918, 36.91266510600008],
              [-6.344715949999909, 36.901271877000056],
              [-6.352447068999936, 36.88027578300006],
              [-6.346669074999909, 36.81989166900007],
              [-6.352447068999936, 36.808579820000034],
              [-6.388010219999956, 36.80817291900007],
              [-6.41624915299991, 36.83779531500005],
              [-6.448638475999928, 36.90420156500005],
              [-6.471099412999934, 36.935614325000074],
              [-6.499582485999952, 36.95966217700004],
              [-6.744862433999913, 37.10138580900008],
              [-6.771473761999914, 37.11277903900009],
              [-6.794667120999918, 37.11774323100008],
              [-6.811756964999915, 37.12372467700004],
              [-6.853016730999911, 37.15110911700009],
              [-6.87328040299991, 37.15867747600004],
              [-6.89289303299995, 37.16657135600008],
              [-6.910878058999913, 37.18895091400009],
              [-6.917632615999935, 37.21507396000004],
              [-6.910755988999938, 37.22760651200008],
              [-6.89875240799995, 37.23578522300005],
              [-6.864125128999945, 37.27753327000005],
              [-6.852691209999932, 37.29523346600007],
              [-6.903472459999932, 37.24957916900007],
              [-6.931141730999911, 37.23387278900009],
              [-6.962554490999935, 37.23383209800005],
              [-6.962554490999935, 37.22760651200008],
              [-6.940744594999956, 37.20066966400009],
              [-6.930083787999934, 37.18317291900007],
              [-6.928456183999913, 37.17234935100004],
              [-6.94163977799991, 37.171087958000044],
              [-7.029367641999954, 37.205511786000045],
              [-7.061675584999932, 37.21393463700008],
              [-7.101040416999922, 37.224250751000056],
              [-7.127349412999934, 37.21474844000005],
              [-7.098988410999937, 37.21190013200004],
              [-7.085560675999943, 37.20648834800005],
              [-7.327870245999918, 37.20156484600005],
              [-7.343088344999956, 37.19623444200005],
              [-7.362904425999943, 37.181708075000074],
              [-7.381418423999946, 37.17991771000004],
              [-7.398508266999954, 37.18545156500005],
              [-7.414418097999942, 37.19281647300005],
              [-7.429386758999954, 37.236746318000044],
              [-7.434244343999865, 37.259328919],
              [-7.427578083999947, 37.27452179000004],
              [-7.437448282999952, 37.30733632400005],
              [-7.444993041999908, 37.38676300100012],
              [-7.462252970999884, 37.41787221300008],
              [-7.460030883999877, 37.429137675000035],
              [-7.462924763999865, 37.45112599700009],
              [-7.468867553999871, 37.47556895000004],
              [-7.475947224999913, 37.49424998000002],
              [-7.481476603999909, 37.500373638000084],
              [-7.498633178999881, 37.51166493800007],
              [-7.506332967999867, 37.5181244920001],
              [-7.514613427999933, 37.52833392300009],
              [-7.515428018999927, 37.529338277000065],
              [-7.51754675299992, 37.535177715000046],
              [-7.518425252999862, 37.541947327000074],
              [-7.52367040999988, 37.5556674190001],
              [-7.527597819999926, 37.55551239100008],
              [-7.52912227399986, 37.556700948000085],
              [-7.529690714999902, 37.56716542600013],
              [-7.526486775999928, 37.57119618800003],
              [-7.515841430999927, 37.58093719500006],
              [-7.514652872999932, 37.58587229400011],
              [-7.512534138999854, 37.59036814400004],
              [-7.511758992999944, 37.59527740500006],
              [-7.514342813999946, 37.60140106200005],
              [-7.504886026999969, 37.60638783800009],
              [-7.478479369999889, 37.628867086000085],
              [-7.471606404999932, 37.63690277100007],
              [-7.466335407999907, 37.65196645200008],
              [-7.457550414999901, 37.70007721000006],
              [-7.444011189999912, 37.730152893000124],
              [-7.426337849999925, 37.750616761000074],
              [-7.334405476999848, 37.81193084700003],
              [-7.306861937999969, 37.85076568600009],
              [-7.295803181999872, 37.88487213100005],
              [-7.273892374999917, 37.931535950000026],
              [-7.268621378999882, 37.94923512800004],
              [-7.269086465999891, 37.95944122400003],
              [-7.272135375999937, 37.96894968700009],
              [-7.272703816999893, 37.9770112100001],
              [-7.265830850999919, 37.98295400100001],
              [-7.234049844999959, 37.9880699670001],
              [-7.223301146999859, 37.99383188900005],
              [-7.21033036299994, 37.99303090400004],
              [-7.197617960999878, 37.98993031900001],
              [-7.185267293999914, 37.988690084000055],
              [-7.172864949999848, 37.99383188900005],
              [-7.159739135999899, 37.99680328400008],
              [-7.152246052999942, 38.000653178],
              [-7.141910765999853, 38.01158274300009],
              [-7.131988891999953, 38.03238250700004],
              [-7.12325557399987, 38.040004781],
              [-7.105943969999885, 38.038661194000056],
              [-7.049358275999907, 38.02021270800013],
              [-7.023985148999913, 38.022563985000076],
              [-7.015768594999884, 38.04682607100007],
              [-7.006363484999923, 38.059331767000046],
              [-6.997630167999944, 38.089614156],
              [-6.978974975999961, 38.11994822200002],
              [-6.965487426999914, 38.1533311970001],
              [-6.957632609999877, 38.16816233300004],
              [-6.947504027999912, 38.19663604700007],
              [-6.950575759999879, 38.19838588800006],
              [-6.964195516999951, 38.20614451100006],
              [-6.992100789999938, 38.20428416000006],
              [-7.018145710999903, 38.19803131100004],
              [-7.021039591999909, 38.198238017],
              [-7.026413939999969, 38.19963328100009],
              [-7.038712930999907, 38.18622324600004],
              [-7.063052530999926, 38.17754160600008],
              [-7.088322306999885, 38.17338165300005],
              [-7.103515176999906, 38.17358835900011],
              [-7.117068156999977, 38.183633156000056],
              [-7.126872924999873, 38.190899964000025],
              [-7.167180541999898, 38.27208363900006],
              [-7.172399861999935, 38.27652781200008],
              [-7.189453084999855, 38.28652720200007],
              [-7.196326049999925, 38.292159933000036],
              [-7.200666870999896, 38.2983869430001],
              [-7.207126424999956, 38.31169362400003],
              [-7.211363891999923, 38.31753306100002],
              [-7.317145547999871, 38.424580791],
              [-7.345515909999961, 38.44096222000006],
              [-7.359210163999876, 38.446362407000024],
              [-7.344844115999877, 38.45832550100006],
              [-7.335180623999861, 38.46943593400009],
              [-7.334095417999947, 38.48101145500003],
              [-7.34561926299989, 38.4941372680001],
              [-7.335800740999929, 38.50586781900007],
              [-7.317713988999913, 38.556252340000086],
              [-7.275856079999926, 38.6038204960001],
              [-7.27043005399986, 38.61769561800007],
              [-7.273530639999905, 38.62539540600007],
              [-7.279421752999895, 38.62890940400011],
              [-7.28603633599991, 38.63190663700003],
              [-7.290945596999933, 38.63815948500003],
              [-7.292495889999941, 38.6461176560001],
              [-7.292960977999883, 38.65627207400006],
              [-7.290945596999933, 38.67908721900004],
              [-7.284072631999976, 38.71324534100005],
              [-7.280713663999961, 38.72042836600009],
              [-7.272187052999925, 38.733735047],
              [-7.27043005399986, 38.737507427000125],
              [-7.22587838499993, 38.76613382800009],
              [-7.211518920999964, 38.775360413],
              [-7.196429402999854, 38.779985454000055],
              [-7.179737914999919, 38.79088918000012],
              [-7.166198689999931, 38.80342071500003],
              [-7.160617634999937, 38.81290334100002],
              [-7.15100581899992, 38.81928538000004],
              [-7.104858764999988, 38.827191874000086],
              [-7.08868404099988, 38.83336720900006],
              [-7.076540079999887, 38.84323740600006],
              [-7.064292764999948, 38.8511180630001],
              [-7.056076212999926, 38.855148824000096],
              [-7.057264769999932, 38.86943735700008],
              [-7.052200479999954, 38.88499196400009],
              [-7.066049764999917, 38.90460317000013],
              [-7.044500691999872, 38.91863332100003],
              [-7.02212479699989, 38.942869568000035],
              [-6.988638467999891, 38.99377085400006],
              [-6.97881994599993, 39.00382192000008],
              [-6.973290567999925, 39.013950501000025],
              [-6.974892537999949, 39.0230197150001],
              [-6.986313028999859, 39.0300735470001],
              [-6.979388386999887, 39.047178447000064],
              [-6.985692911999905, 39.06676381500007],
              [-6.99969722599991, 39.08469553600007],
              [-7.015768594999884, 39.09681366000005],
              [-7.038816283999921, 39.1091384890001],
              [-7.06491288299992, 39.11477122000012],
              [-7.091267862999899, 39.11244578100009],
              [-7.115194050999889, 39.101102804],
              [-7.127286336999873, 39.09748545300003],
              [-7.14253088399991, 39.099526673000085],
              [-7.157206990999896, 39.1054436240001],
              [-7.167490600999884, 39.11347931000007],
              [-7.168885864999879, 39.12185089200004],
              [-7.157930460999893, 39.14138458300006],
              [-7.155811726999929, 39.15151316300002],
              [-7.168059040999935, 39.170633443],
              [-7.191571817999943, 39.179160055000025],
              [-7.219322062999879, 39.18484446200007],
              [-7.244126749999907, 39.1956448370001],
              [-7.258079386999896, 39.211302795000066],
              [-7.265779174999892, 39.23135325200009],
              [-7.264332233999909, 39.252333883000105],
              [-7.250844685999937, 39.270627340000075],
              [-7.300454060999925, 39.31791127500013],
              [-7.319264282999939, 39.329538473000085],
              [-7.326654011999949, 39.34132069900009],
              [-7.331408243999931, 39.362611390000055],
              [-7.331925008999889, 39.38472890200008],
              [-7.326705688999937, 39.39883656800002],
              [-7.31885087099991, 39.41325429300012],
              [-7.313631550999901, 39.436095276000046],
              [-7.313528197999887, 39.457437643000034],
              [-7.320917927999886, 39.467411194000036],
              [-7.362930866999903, 39.4760928350001],
              [-7.384169880999877, 39.48399932900004],
              [-7.399414428999904, 39.493662821000086],
              [-7.408922891999907, 39.51557362900003],
              [-7.417552856999947, 39.52420359300008],
              [-7.451349242999925, 39.53784617200007],
              [-7.468092406999887, 39.550248515000064],
              [-7.497858032999943, 39.58104766800001],
              [-7.515841430999927, 39.59376007100006],
              [-7.548242553999955, 39.66321319700005],
              [-7.555871748999948, 39.6772073180001],
              [-7.557285929999892, 39.679801331000064],
              [-7.341433470999959, 39.67184316],
              [-7.327842569999859, 39.674788717000084],
              [-7.311409464999912, 39.68031809500009],
              [-7.292754272999929, 39.683315329000024],
              [-7.252860066999887, 39.68233347600004],
              [-7.235755167999855, 39.686519267000065],
              [-7.214051065999854, 39.67618398100008],
              [-7.182890177999894, 39.67509877500008],
              [-7.035767373999903, 39.68925811800001],
              [-7.021142944999923, 39.69401235000002],
              [-7.009619099999895, 39.715458069000036],
              [-7.010704304999905, 39.72279612200005],
              [-7.013649861999909, 39.729617412],
              [-7.013339802999923, 39.7389191700001],
              [-7.008740600999943, 39.74832428000006],
              [-6.996803344999904, 39.76470570900001],
              [-6.993030964999889, 39.77421417300009],
              [-6.994581258999915, 39.782585755000085],
              [-6.998870401999881, 39.79178416000006],
              [-7.000265664999858, 39.802532858000106],
              [-6.993030964999889, 39.816072083000066],
              [-6.985227824999868, 39.821136373000044],
              [-6.962335164999956, 39.82852610300007],
              [-6.952826700999879, 39.832866924000044],
              [-6.927660278999923, 39.86190907800004],
              [-6.924249633999892, 39.871572571000044],
              [-6.923474487999897, 39.888315735],
              [-6.921769164999915, 39.897152405],
              [-6.921562459999961, 39.902165019000066],
              [-6.92512813299993, 39.912241924000014],
              [-6.925231485999888, 39.91792633100006],
              [-6.922285928999884, 39.92242218000008],
              [-6.912570759999937, 39.928106588000034],
              [-6.909521850999909, 39.93198232100006],
              [-6.903682413999917, 39.95668365500008],
              [-6.899755004999861, 39.96562367800003],
              [-6.901615355999866, 39.97647572800007],
              [-6.896912800999871, 39.98712107400006],
              [-6.879704548999911, 40.009186910000054],
              [-6.919908812999921, 40.06489410400009],
              [-6.942129679999965, 40.08633982300002],
              [-6.955720581999856, 40.10292795900001],
              [-6.966417602999854, 40.11031768800002],
              [-6.977166300999983, 40.11341827400007],
              [-7.003676309999889, 40.116312154000056],
              [-7.015768594999884, 40.11905100500009],
              [-7.027654174999896, 40.13264190700009],
              [-7.034837198999867, 40.166748352000056],
              [-7.043105428999894, 40.18137278300013],
              [-7.034578816999982, 40.193051656000094],
              [-7.024760294999908, 40.21620269800009],
              [-7.015768594999884, 40.225504456000024],
              [-6.997785196999899, 40.23170562700001],
              [-6.954687052999873, 40.2533580530001],
              [-6.942100807999878, 40.25497773100007],
              [-6.935411742999946, 40.255838522000076],
              [-6.915826374999909, 40.254443258],
              [-6.896447712999958, 40.255476786000074],
              [-6.878050903999849, 40.26524363200012],
              [-6.875105346999959, 40.27123809900006],
              [-6.874509091999897, 40.279188167000044],
              [-6.873865112999908, 40.28777455600003],
              [-6.870196085999908, 40.29552602200006],
              [-6.863943236999916, 40.300952047000024],
              [-6.820793415999901, 40.32534332300004],
              [-6.811956745999908, 40.33231964100004],
              [-6.794438435999922, 40.35640085900009],
              [-6.828079793999962, 40.38058542900005],
              [-6.85128251099988, 40.40952423100002],
              [-6.857121948999861, 40.44213206000008],
              [-6.838673461999861, 40.47722035800011],
              [-6.815315714999912, 40.502541810000096],
              [-6.812525186999949, 40.51463409500009],
              [-6.818054564999954, 40.53189402300008],
              [-6.828544881999903, 40.54553660100008],
              [-6.839758666999955, 40.55457997600003],
              [-6.848388630999892, 40.564760234000104],
              [-6.850455688999944, 40.582226868000035],
              [-6.844461222999911, 40.59778147400006],
              [-6.821310180999944, 40.630182597000086],
              [-6.814282185999929, 40.6471841430001],
              [-6.814230508999913, 40.659328105],
              [-6.816245889999948, 40.67715647400003],
              [-6.824307413999861, 40.710694478000065],
              [-6.836968139999897, 40.74330230800011],
              [-6.839138549999888, 40.75751332600008],
              [-6.839138549999888, 40.77689198900005],
              [-6.837278197999865, 40.78676218700012],
              [-6.834539347999936, 40.7922398890001],
              [-6.833505818999953, 40.79782094300002],
              [-6.836813109999952, 40.80831126000008],
              [-6.838053343999889, 40.81492584200008],
              [-6.836658080999911, 40.840247294000065],
              [-6.82032832799996, 40.84422638000002],
              [-6.81619421399995, 40.85683542900007],
              [-6.821155151999903, 40.87006459600006],
              [-6.832058877999941, 40.875904033000054],
              [-6.847045043999913, 40.87890126600006],
              [-6.855261596999867, 40.88722117200011],
              [-6.863633178999919, 40.908305156000054],
              [-6.885182251999879, 40.948922832000065],
              [-6.899238240999921, 40.96675120100012],
              [-6.930605834999938, 40.992072652],
              [-6.940424356999898, 41.00338979100009],
              [-6.942491414999949, 41.01599884000011],
              [-6.931794392999961, 41.02912465400006],
              [-6.927866983999877, 41.04793487600007],
              [-6.927447856999947, 41.04809758400005],
              [-6.90683467599996, 41.056099752000094],
              [-6.845288044999933, 41.05191396100007],
              [-6.818002888999928, 41.054136048000075],
              [-6.804360310999925, 41.06441965800006],
              [-6.764776163999954, 41.10886139000003],
              [-6.756507934999917, 41.12705149400007],
              [-6.758988403999894, 41.151752828],
              [-6.755216023999878, 41.158832500000116],
              [-6.742245238999942, 41.17144154900005],
              [-6.706950235999955, 41.19433420900005],
              [-6.701265828999908, 41.202447408000054],
              [-6.693772745999894, 41.21738189700004],
              [-6.658219359999919, 41.25784454400012],
              [-6.646643839999882, 41.267611390000056],
              [-6.628918823999868, 41.26993682900009],
              [-6.563496459999897, 41.270711975000026],
              [-6.554453083999931, 41.27562123700004],
              [-6.495852010999897, 41.29494822200009],
              [-6.463140828999911, 41.31412017800001],
              [-6.430998086999892, 41.33902821900007],
              [-6.399578816999849, 41.37747548500003],
              [-6.395496377999933, 41.37840566000007],
              [-6.3831973879999, 41.376545309000065],
              [-6.379166625999915, 41.37747548500003],
              [-6.376737832999936, 41.38300486300004],
              [-6.37554927599993, 41.39080800400005],
              [-6.376169392999884, 41.39685414600008],
              [-6.379166625999915, 41.39731923400011],
              [-6.366247517999881, 41.40517405300004],
              [-6.352346557999908, 41.40925649100005],
              [-6.321133991999943, 41.411013489000126],
              [-6.321030639999918, 41.419591777000065],
              [-6.282945108999854, 41.46563547800007],
              [-6.282480020999941, 41.47230173800007],
              [-6.285167194999872, 41.4789679980001],
              [-6.285890665999943, 41.48687449200004],
              [-6.279534463999937, 41.497003072],
              [-6.253644571999899, 41.51751861600006],
              [-6.205947224999932, 41.57028025300009],
              [-6.216127481999905, 41.58009877500008],
              [-6.230080118999894, 41.59490407300008],
              [-6.272248087999856, 41.62823537200005],
              [-6.317103230999948, 41.65014618000002],
              [-6.365937459999913, 41.66360789000005],
              [-6.447069457999959, 41.67624277800009],
              [-6.46081538999988, 41.676552836000084],
              [-6.467740030999948, 41.67205698700006],
              [-6.474354614999868, 41.6659333300001],
              [-6.488048868999897, 41.65880198200007],
              [-6.503035033999964, 41.65309173700011],
              [-6.513421996999881, 41.65092132600002],
              [-6.541533976999915, 41.658905335000085],
              [-6.555279906999942, 41.67489919100002],
              [-6.560499226999866, 41.69445872100006],
              [-6.563083048999886, 41.713036397000096],
              [-6.567682250999923, 41.722441508000045],
              [-6.574348510999926, 41.7310456340001],
              [-6.577397419999954, 41.73972727500005],
              [-6.571506306999964, 41.749209900000025],
              [-6.564374958999935, 41.75750396800008],
              [-6.560137491999882, 41.766883240000126],
              [-6.53574621599995, 41.848583679000015],
              [-6.524222371999912, 41.867419740000045],
              [-6.550060587999923, 41.87387929300009],
              [-6.567888956999894, 41.87586883600004],
              [-6.575795450999919, 41.88289683100005],
              [-6.567630574999896, 41.92607249000007],
              [-6.571661335999892, 41.94260894800006],
              [-6.585148885999956, 41.95464955700005],
              [-6.609488484999872, 41.96232350700002],
              [-6.622821003999917, 41.94095530200012],
              [-6.656772419999925, 41.93307464700008],
              [-6.727982543999872, 41.93085255900009],
              [-6.757903197999894, 41.93757049600002],
              [-6.794386759999924, 41.97971262600005],
              [-6.824927530999929, 41.983769226000064],
              [-6.831232055999919, 41.953951925000055],
              [-6.854951537999881, 41.94294484500007],
              [-6.917118285999948, 41.9390949500001],
              [-6.945126911999893, 41.94335825700007],
              [-6.96951818799991, 41.95769846600008],
              [-6.98345618299993, 41.962996166],
              [-6.992359170999919, 41.966380107000035],
              [-7.015768594999884, 41.953667705000086],
              [-7.051270303999928, 41.94201466900002],
              [-7.082741251999948, 41.95278920500003],
              [-7.113178670999929, 41.97242625000008],
              [-7.1453730879999, 41.98748992900006],
              [-7.159739135999899, 41.98573293100007],
              [-7.177309122999873, 41.97836903900007],
              [-7.192605346999926, 41.96960988400009],
              [-7.19994339999991, 41.9637187710001],
              [-7.20211381099989, 41.9497402950001],
              [-7.195654255999955, 41.917365011000115],
              [-7.19792801899996, 41.90150034600002],
              [-7.209316117999947, 41.889160873],
              [-7.218650268999909, 41.8790469370001],
              [-7.251464802999919, 41.86369903600003],
              [-7.322468220999895, 41.84540557900006],
              [-7.340503295999895, 41.84320933100007],
              [-7.376831827999865, 41.84403615300009],
              [-7.391921345999975, 41.84204661100004],
              [-7.405408894999937, 41.835199484000086],
              [-7.429541788999899, 41.81450307300007],
              [-7.442719278999959, 41.805950623000044],
              [-7.446956746999916, 41.82184112600005],
              [-7.456568562999848, 41.83923024500008],
              [-7.469384318999914, 41.8525369260001],
              [-7.483285278999887, 41.85620595400009],
              [-7.493000447999947, 41.85690358600009],
              [-7.508141642999959, 41.86493927000008],
              [-7.515841430999927, 41.86499094700007],
              [-7.523282836999954, 41.86015920100006],
              [-7.525246540999888, 41.85416473400004],
              [-7.526331746999887, 41.847369283],
              [-7.531551066999924, 41.84016042100005],
              [-7.546692260999919, 41.832047221000025],
              [-7.567104451999882, 41.82659535800006],
              [-7.588395141999854, 41.8242182420001],
              [-7.606068480999852, 41.82553599100005],
              [-7.622191528999849, 41.83233144200001],
              [-7.622811644999899, 41.84173655200006],
              [-7.607360391999919, 41.87318166200002],
              [-7.661155557999933, 41.87491282200007],
              [-7.67867386899988, 41.88134653700003],
              [-7.706372436999914, 41.89625518800007],
              [-7.722030395999866, 41.8992524210001],
              [-7.750142374999911, 41.88837453200004],
              [-7.812154092999947, 41.87713490900008],
              [-7.839232543999913, 41.8783751430001],
              [-7.849722859999872, 41.87576548300011],
              [-7.854425414999923, 41.87026194300002],
              [-7.857887735999981, 41.86377655100004],
              [-7.864812377999954, 41.857885437000064],
              [-7.896593383999885, 41.85793711300006],
              [-7.903362995999942, 41.88682424000011],
              [-7.906101846999888, 41.91385101400006],
              [-7.92579056799994, 41.90816660600011],
              [-7.930493122999906, 41.8966686000001],
              [-7.93535070799993, 41.87995127400005],
              [-7.94475581899988, 41.86695465200002],
              [-7.963359334999922, 41.86661875500003],
              [-7.979430704999913, 41.86860829700005],
              [-7.993641723999872, 41.86367319800003],
              [-8.005889037999907, 41.85395802900008],
              [-8.015707560999942, 41.8418915810001],
              [-8.048573770999894, 41.81638926200007],
              [-8.050445716999889, 41.81598643800005],
              [-8.093480590999889, 41.80672576900004],
              [-8.179573526999889, 41.810704854000036],
              [-8.179265100999942, 41.812612525000034],
              [-8.175387735999948, 41.83659474700006],
              [-8.177041381999885, 41.849849752000054],
              [-8.184586140999954, 41.85773040800011],
              [-8.220397908999871, 41.86819488600004],
              [-8.231715047999955, 41.88604909300001],
              [-8.23021643099986, 41.90467844700005],
              [-8.220707966999953, 41.92271352100006],
              [-8.182131509999891, 41.96542409300007],
              [-8.152960163999865, 41.98681813600008],
              [-8.12391800899988, 42.00089996400003],
              [-8.10802750699986, 42.01089935300003],
              [-8.097356322999929, 42.02348256500004],
              [-8.095082559999923, 42.04092336100008],
              [-8.103195760999938, 42.05580617300002],
              [-8.118440307999975, 42.06686492900003],
              [-8.137612263999898, 42.07291107200008],
              [-8.15838618999993, 42.07138661700007],
              [-8.17616288299996, 42.06526296],
              [-8.19130407699987, 42.062084859000024],
              [-8.204016479999922, 42.06955210400007],
              [-8.207375447999937, 42.08577850400006],
              [-8.204326537999918, 42.12879913300007],
              [-8.213395751999883, 42.1440178430001],
              [-8.222361612999919, 42.15362966000002],
              [-8.252333943999957, 42.13758412800006],
              [-8.270679076999926, 42.13200307200013],
              [-8.287835652999888, 42.13143463200008],
              [-8.295380411999957, 42.1300910450001],
              [-8.304268757999864, 42.12582773900006],
              [-8.329951944999948, 42.108438619000125],
              [-8.346746785999898, 42.1016948450001],
              [-8.501207641999883, 42.083091330000045],
              [-8.520017862999879, 42.07771698000009],
              [-8.554434366999942, 42.060069478000074],
              [-8.572805337999938, 42.054410909000055],
              [-8.60941809099998, 42.05366160100006],
              [-8.626884724999911, 42.051026103000126],
              [-8.643886271999946, 42.04149180200004],
              [-8.65256791199991, 42.03144073600002],
              [-8.663213256999882, 42.00989166300006],
              [-8.670809691999864, 41.99981475800011],
              [-8.69127355899991, 41.989608664000045],
              [-8.717008422999896, 41.983769226000064],
              [-8.739591023999935, 41.9751134240001],
              [-8.750803188999953, 41.96898021000004],
              [-8.76195227799991, 41.95258209800005],
              [-8.777088995999918, 41.937160549000055],
              [-8.795399542999917, 41.92568594000005],
              [-8.815988735999952, 41.921210028000075],
              [-8.832834438999953, 41.91396719000005],
              [-8.848784959999932, 41.89948151200008],
              [-8.864654100999928, 41.88890208500004],
              [-8.881255662999934, 41.89329661700003],
              [-8.878732876999948, 41.907131252000056],
              [-8.898589647999927, 42.10175202000005],
              [-8.895497199999909, 42.11908600500004],
              [-8.884592251999948, 42.12604401200008],
              [-8.844960089999915, 42.126613674000055],
              [-8.826527472999942, 42.130519924000055],
              [-8.819081183999913, 42.13971588700008],
              [-8.823719855999911, 42.14760976800005],
              [-8.842762824999909, 42.15444570500006],
              [-8.846994594999956, 42.16083405200004],
              [-8.84203040299991, 42.16429271000004],
              [-8.815988735999952, 42.17450592700004],
              [-8.813465949999909, 42.17869700700004],
              [-8.811024542999917, 42.18813711100006],
              [-8.80577551999994, 42.19749583500004],
              [-8.79523678299995, 42.20172760600008],
              [-8.790638800999943, 42.20453522300005],
              [-8.771962042999917, 42.22223541900007],
              [-8.719553188999953, 42.25234609600005],
              [-8.706450975999928, 42.25641510600008],
              [-8.701893683999913, 42.25853099200003],
              [-8.669911261999914, 42.280910549000055],
              [-8.652007615999935, 42.286322333000044],
              [-8.631743943999936, 42.29682038000004],
              [-8.625152147999927, 42.301947333000044],
              [-8.621652798999946, 42.310207424000055],
              [-8.621652798999946, 42.34080638200004],
              [-8.622710740999935, 42.34747955900008],
              [-8.626454230999911, 42.34833405200004],
              [-8.634755011999914, 42.34638092700004],
              [-8.649891730999911, 42.335598049000055],
              [-8.660755988999938, 42.31679922100005],
              [-8.674794074999909, 42.29901764500005],
              [-8.699574347999942, 42.29116445500006],
              [-8.71983801999994, 42.28758372600004],
              [-8.773915167999917, 42.26898834800005],
              [-8.784982876999948, 42.26007721600007],
              [-8.795765753999945, 42.258246161000045],
              [-8.84829667899993, 42.260972398000035],
              [-8.86750240799995, 42.25641510600008],
              [-8.863636847999942, 42.26898834800005],
              [-8.85342363199993, 42.291083075000074],
              [-8.853260870999918, 42.30483633000006],
              [-8.846994594999956, 42.30483633000006],
              [-8.832997199999909, 42.289129950000074],
              [-8.827219204999949, 42.29669830900008],
              [-8.826527472999942, 42.32904694200005],
              [-8.828521287999934, 42.337225653000075],
              [-8.83071855399993, 42.34162018400008],
              [-8.82725989499994, 42.34414297100005],
              [-8.812855597999942, 42.34638092700004],
              [-8.776926235999952, 42.34015534100007],
              [-8.771962042999917, 42.34271881700005],
              [-8.764637824999909, 42.35569896000004],
              [-8.72687740799995, 42.388739325000074],
              [-8.709828253999945, 42.400376695000034],
              [-8.67686926999994, 42.416449286000045],
              [-8.662505662999934, 42.42690664300005],
              [-8.655262824999909, 42.44135163000004],
              [-8.66437740799995, 42.43797435100004],
              [-8.67251542899993, 42.43842194200005],
              [-8.682525193999936, 42.44135163000004],
              [-8.69127356699994, 42.440619208000044],
              [-8.694488084999932, 42.43964264500005],
              [-8.696766730999911, 42.43797435100004],
              [-8.718820766999954, 42.42796458500004],
              [-8.743641730999911, 42.41323476800005],
              [-8.757639126999948, 42.40721263200004],
              [-8.779367641999954, 42.40289948100008],
              [-8.811024542999917, 42.40070221600007],
              [-8.843576626999948, 42.40371328300006],
              [-8.86750240799995, 42.41469961100006],
              [-8.875721808999913, 42.42597077000005],
              [-8.880238410999937, 42.445013739000046],
              [-8.888010219999956, 42.45563385600008],
              [-8.900949673999946, 42.461004950000074],
              [-8.93545488199993, 42.46539948100008],
              [-8.942616339999915, 42.46930573100008],
              [-8.935047980999911, 42.47907135600008],
              [-8.916737433999913, 42.487616278000075],
              [-8.895985480999911, 42.49388255400004],
              [-8.881255662999934, 42.49656810100004],
              [-8.86900794199994, 42.493394273000035],
              [-8.860829230999911, 42.48501211100006],
              [-8.861154751999948, 42.47557200700004],
              [-8.874338344999956, 42.46930573100008],
              [-8.86554928299995, 42.46503327000005],
              [-8.851551886999914, 42.46076080900008],
              [-8.836984829999949, 42.45892975500004],
              [-8.826527472999942, 42.46185944200005],
              [-8.82249915299991, 42.472357489000046],
              [-8.825184699999909, 42.48411692900004],
              [-8.825062628999945, 42.49494049700007],
              [-8.812855597999942, 42.50275299700007],
              [-8.825184699999909, 42.53742096600007],
              [-8.826527472999942, 42.55463288000004],
              [-8.822987433999913, 42.569525458000044],
              [-8.813832160999937, 42.58144765800006],
              [-8.801584438999953, 42.58930084800005],
              [-8.788400844999956, 42.59218984600005],
              [-8.775502081999946, 42.604722398000035],
              [-8.738758917999917, 42.666083075000074],
              [-8.730946417999917, 42.68842194200005],
              [-8.737172003999945, 42.68842194200005],
              [-8.74404863199993, 42.67243073100008],
              [-8.753895636999914, 42.65688711100006],
              [-8.767323370999918, 42.64516836100006],
              [-8.784982876999948, 42.64057038000004],
              [-8.80382239499994, 42.64594147300005],
              [-8.815988735999952, 42.65851471600007],
              [-8.826242641999954, 42.67413971600007],
              [-8.839507615999935, 42.68244049700007],
              [-8.85460364499994, 42.66156647300005],
              [-8.857004360999952, 42.64911530200004],
              [-8.846994594999956, 42.64057038000004],
              [-8.868763800999943, 42.61749909100007],
              [-8.880523240999935, 42.61180247600004],
              [-8.89484615799995, 42.62010325700004],
              [-8.889475063999953, 42.63060130400004],
              [-8.90343176999994, 42.62547435100004],
              [-8.936390753999945, 42.60643138200004],
              [-8.922230597999942, 42.59369538000004],
              [-8.933990037999934, 42.586818752000056],
              [-8.969878709999932, 42.57916901200008],
              [-8.972767706999946, 42.573919989000046],
              [-8.98078365799995, 42.551214911000045],
              [-8.989165818999936, 42.548895575000074],
              [-8.997059699999909, 42.543402411000045],
              [-9.011545376999948, 42.53070709800005],
              [-9.026356574999909, 42.54311758000006],
              [-9.028553839999915, 42.56146881700005],
              [-9.033355272999927, 42.578111070000034],
              [-9.055816209999932, 42.58539459800005],
              [-9.070871548999946, 42.596136786000045],
              [-9.065744594999956, 42.620306708000044],
              [-9.05142167899993, 42.64594147300005],
              [-9.038807745999918, 42.66107819200005],
              [-9.039458787999934, 42.673041083000044],
              [-9.036284959999932, 42.687933661000045],
              [-9.030140753999945, 42.70770905200004],
              [-9.018788214999915, 42.71975332200009],
              [-9.014027472999942, 42.72683340100008],
              [-9.006255662999934, 42.73383209800005],
              [-8.994496222999942, 42.73700592700004],
              [-8.992014126999948, 42.73908112200007],
              [-8.96312415299991, 42.751288153000075],
              [-8.93736731699994, 42.777777411000045],
              [-8.922230597999942, 42.78811269700009],
              [-8.898264126999948, 42.792303778000075],
              [-8.891346808999913, 42.799343166000085],
              [-8.884917772999927, 42.81500885600008],
              [-8.887684699999909, 42.83112213700008],
              [-8.90843665299991, 42.83946360900006],
              [-8.912587042999917, 42.81659577000005],
              [-8.928089972999942, 42.80251699400009],
              [-8.95103919199994, 42.79511139500005],
              [-8.977365688999953, 42.792303778000075],
              [-9.028187628999945, 42.79787832200009],
              [-9.048939581999946, 42.79474518400008],
              [-9.045643683999913, 42.77802155200004],
              [-9.06867428299995, 42.75971100500004],
              [-9.081288214999915, 42.75482819200005],
              [-9.10024980399993, 42.757513739000046],
              [-9.113433397999927, 42.766058661000045],
              [-9.120106574999909, 42.778998114000046],
              [-9.125477667999917, 42.794989325000074],
              [-9.13499915299991, 42.81277090100008],
              [-9.122547980999911, 42.812608140000066],
              [-9.11318925699993, 42.81635163000004],
              [-9.106190558999913, 42.82330963700008],
              [-9.10024980399993, 42.833278713000084],
              [-9.108387824999909, 42.84483470300006],
              [-9.122222459999932, 42.85175202000005],
              [-9.141224738999938, 42.85744863500008],
              [-9.142323370999918, 42.865301825000074],
              [-9.147531704999949, 42.878607489000046],
              [-9.14867102799991, 42.884466864000046],
              [-9.146636522999927, 42.888373114000046],
              [-9.137521938999953, 42.89606354400007],
              [-9.13499915299991, 42.90216705900008],
              [-9.133697068999936, 42.91120026200008],
              [-9.134510870999918, 42.91754791900007],
              [-9.141428188999953, 42.92141347900008],
              [-9.158599412999934, 42.92263418200008],
              [-9.16787675699993, 42.92682526200008],
              [-9.18346106699994, 42.94525788000004],
              [-9.195871548999946, 42.949326890000066],
              [-9.195871548999946, 42.94314199400009],
              [-9.190012173999946, 42.93239980700008],
              [-9.195790167999917, 42.92658112200007],
              [-9.205189581999946, 42.92475006700005],
              [-9.21007239499994, 42.92572663000004],
              [-9.214344855999911, 42.93903229400007],
              [-9.224232550999943, 42.94021230700008],
              [-9.235585089999915, 42.934881903000075],
              [-9.244252081999946, 42.92877838700008],
              [-9.251698370999918, 42.92023346600007],
              [-9.261708136999914, 42.90017324400009],
              [-9.268422003999945, 42.89130280200004],
              [-9.273060675999943, 42.89333730700008],
              [-9.282948370999918, 42.91661204600007],
              [-9.291981574999909, 42.92263418200008],
              [-9.291981574999909, 42.92877838700008],
              [-9.28538977799991, 42.938340562000064],
              [-9.26475989499994, 42.98033274900007],
              [-9.26398678299995, 42.98651764500005],
              [-9.261830206999946, 42.99449290600006],
              [-9.258656378999945, 43.002386786000045],
              [-9.254790818999936, 43.00800202000005],
              [-9.250965949999909, 43.016791083000044],
              [-9.257313605999911, 43.02326080900008],
              [-9.27212480399993, 43.03127676000008],
              [-9.27953040299991, 43.05499909100007],
              [-9.271107550999943, 43.06049225500004],
              [-9.257923956999946, 43.06089915600006],
              [-9.25108801999994, 43.06976959800005],
              [-9.245716925999943, 43.087998765000066],
              [-9.233957485999952, 43.09650299700007],
              [-9.222320115999935, 43.102728583000044],
              [-9.217600063999953, 43.114447333000044],
              [-9.202951626999948, 43.10504791900007],
              [-9.189808722999942, 43.10232168200008],
              [-9.176828579999949, 43.105576890000066],
              [-9.162261522999927, 43.114447333000044],
              [-9.15689042899993, 43.11973704600007],
              [-9.15420488199993, 43.124701239000046],
              [-9.15029863199993, 43.12958405200004],
              [-9.141224738999938, 43.134873765000066],
              [-9.13312740799995, 43.137966213000084],
              [-9.125803188999953, 43.13959381700005],
              [-9.10773678299995, 43.141140041000085],
              [-9.10773678299995, 43.148504950000074],
              [-9.124663865999935, 43.14252350500004],
              [-9.147084113999938, 43.13869863500008],
              [-9.163319464999915, 43.13975657800006],
              [-9.162261522999927, 43.148504950000074],
              [-9.194203253999945, 43.13654205900008],
              [-9.208363410999937, 43.137884833000044],
              [-9.217600063999953, 43.15534088700008],
              [-9.170074022999927, 43.188747463000084],
              [-9.137928839999915, 43.20152415600006],
              [-9.100412563999953, 43.189520575000074],
              [-9.083159959999932, 43.18976471600007],
              [-9.065174933999913, 43.19232819200005],
              [-9.052398240999935, 43.19635651200008],
              [-9.039784308999913, 43.20453522300005],
              [-9.026966925999943, 43.210150458000044],
              [-9.016753709999932, 43.223863023000035],
              [-9.011545376999948, 43.23875560100004],
              [-9.004058397999927, 43.23875560100004],
              [-8.985747850999928, 43.22687409100007],
              [-8.958973761999914, 43.22748444200005],
              [-8.932525193999936, 43.23529694200005],
              [-8.915272589999915, 43.245021877000056],
              [-8.936390753999945, 43.24408600500004],
              [-8.948150193999936, 43.24994538000004],
              [-8.96312415299991, 43.27228424700007],
              [-8.967518683999913, 43.27195872600004],
              [-8.979807094999956, 43.27692291900007],
              [-8.988026495999918, 43.28302643400008],
              [-8.98078365799995, 43.28595612200007],
              [-8.970855272999927, 43.28656647300005],
              [-8.930490688999953, 43.29975006700005],
              [-8.888010219999956, 43.320746161000045],
              [-8.856597459999932, 43.32689036700003],
              [-8.849110480999911, 43.334051825000074],
              [-8.841175910999937, 43.33893463700008],
              [-8.82998613199993, 43.34121328300006],
              [-8.817005988999938, 43.33584219000005],
              [-8.785552537999934, 43.31244538000004],
              [-8.768544074999909, 43.307074286000045],
              [-8.750477667999917, 43.30491771000004],
              [-8.711740688999953, 43.29555898600006],
              [-8.693104620999918, 43.293402411000045],
              [-8.665394660999937, 43.30117422100005],
              [-8.630034959999932, 43.31586334800005],
              [-8.592518683999913, 43.324204820000034],
              [-8.558420376999948, 43.31321849200003],
              [-8.505970831999946, 43.33152903900009],
              [-8.497547980999911, 43.33779531500005],
              [-8.494252081999946, 43.34662506700005],
              [-8.486073370999918, 43.35431549700007],
              [-8.475982225999928, 43.35968659100007],
              [-8.45571855399993, 43.363348700000074],
              [-8.45140540299991, 43.36737702000005],
              [-8.448963995999918, 43.371975002000056],
              [-8.443023240999935, 43.37531159100007],
              [-8.388295050999943, 43.38589101800005],
              [-8.38467363199993, 43.372707424000055],
              [-8.375721808999913, 43.362982489000046],
              [-8.353586391999954, 43.34861888200004],
              [-8.340809699999909, 43.35993073100008],
              [-8.337269660999937, 43.36904531500005],
              [-8.339914516999954, 43.39272695500006],
              [-8.33071855399993, 43.40566640800006],
              [-8.310617641999954, 43.40314362200007],
              [-8.28156490799995, 43.38959381700005],
              [-8.267201300999943, 43.385931708000044],
              [-8.260812954999949, 43.377020575000074],
              [-8.257069464999915, 43.365668036000045],
              [-8.250559048999946, 43.35488515800006],
              [-8.227528449999909, 43.33812083500004],
              [-8.217274542999917, 43.32831452000005],
              [-8.210194464999915, 43.31321849200003],
              [-8.202463344999956, 43.32925039300005],
              [-8.202951626999948, 43.34467194200005],
              [-8.210194464999915, 43.37531159100007],
              [-8.20962480399993, 43.390692450000074],
              [-8.204823370999918, 43.399725653000075],
              [-8.193959113999938, 43.40680573100008],
              [-8.175404425999943, 43.41632721600007],
              [-8.195057745999918, 43.42324453300006],
              [-8.213286912999934, 43.42495351800005],
              [-8.247141079999949, 43.423081773000035],
              [-8.26475989499994, 43.42731354400007],
              [-8.288726365999935, 43.44623444200005],
              [-8.305165167999917, 43.45107656500005],
              [-8.286488410999937, 43.46198151200008],
              [-8.185617641999954, 43.47150299700007],
              [-8.178781704999949, 43.47329336100006],
              [-8.171457485999952, 43.47797272300005],
              [-8.166981574999909, 43.48456452000005],
              [-8.168568488999938, 43.49201080900008],
              [-8.173451300999943, 43.49274323100008],
              [-8.196522589999915, 43.48517487200007],
              [-8.257313605999911, 43.477728583000044],
              [-8.253651495999918, 43.48126862200007],
              [-8.250884568999936, 43.482855536000045],
              [-8.243723110999952, 43.48517487200007],
              [-8.247547980999911, 43.48773834800005],
              [-8.257313605999911, 43.49201080900008],
              [-8.269195115999935, 43.478949286000045],
              [-8.28897050699993, 43.47296784100007],
              [-8.33311926999994, 43.47150299700007],
              [-8.325347459999932, 43.486761786000045],
              [-8.321685350999928, 43.507879950000074],
              [-8.31663977799991, 43.52289459800005],
              [-8.305165167999917, 43.51935455900008],
              [-8.29210364499994, 43.53294505400004],
              [-8.300160285999937, 43.53823476800005],
              [-8.308216925999943, 43.54633209800005],
              [-8.313221808999913, 43.556341864000046],
              [-8.312652147999927, 43.56712474200003],
              [-8.308705206999946, 43.56712474200003],
              [-8.29133053299995, 43.56484609600005],
              [-8.284657355999911, 43.56712474200003],
              [-8.260975714999915, 43.564520575000074],
              [-8.232248501999948, 43.575506903000075],
              [-8.086659308999913, 43.65648021000004],
              [-8.082997199999909, 43.64545319200005],
              [-8.074615037999934, 43.63963450700004],
              [-8.063547329999949, 43.63886139500005],
              [-8.05186926999994, 43.64280833500004],
              [-8.06240800699993, 43.64232005400004],
              [-8.06554114499994, 43.64280833500004],
              [-8.06554114499994, 43.64907461100006],
              [-8.061268683999913, 43.65094635600008],
              [-8.056467251999948, 43.65424225500004],
              [-8.05186926999994, 43.65648021000004],
              [-8.071156378999945, 43.66787344000005],
              [-8.073963995999918, 43.67853424700007],
              [-8.069162563999953, 43.68927643400008],
              [-8.06554114499994, 43.700873114000046],
              [-8.059315558999913, 43.709418036000045],
              [-8.044504360999952, 43.712103583000044],
              [-8.010975714999915, 43.71173737200007],
              [-7.981190558999913, 43.71784088700008],
              [-7.952951626999948, 43.730129299000055],
              [-7.928130662999934, 43.74677155200004],
              [-7.908558722999942, 43.76634349200003],
              [-7.880848761999914, 43.76325104400007],
              [-7.869048631999931, 43.74884674700007],
              [-7.861480272999927, 43.73118724200003],
              [-7.846506313999953, 43.717962958000044],
              [-7.846506313999953, 43.71173737200007],
              [-7.852284308999913, 43.714178778000075],
              [-7.862294074999909, 43.71625397300005],
              [-7.867583787999934, 43.717962958000044],
              [-7.874623175999943, 43.709418036000045],
              [-7.879261847999942, 43.700506903000075],
              [-7.879790818999936, 43.69196198100008],
              [-7.873768683999913, 43.684475002000056],
              [-7.884103969999956, 43.678615627000056],
              [-7.887318488999938, 43.679673570000034],
              [-7.894886847999942, 43.684475002000056],
              [-7.901234503999945, 43.679754950000074],
              [-7.903879360999952, 43.67829010600008],
              [-7.908558722999942, 43.676988023000035],
              [-7.908558722999942, 43.67015208500004],
              [-7.858387824999909, 43.66819896000004],
              [-7.849232550999943, 43.67560455900008],
              [-7.867583787999934, 43.69745514500005],
              [-7.856027798999946, 43.70343659100007],
              [-7.843861456999946, 43.70380280200004],
              [-7.819162563999953, 43.69745514500005],
              [-7.821400519999941, 43.70075104400007],
              [-7.823963995999918, 43.70807526200008],
              [-7.826039191999939, 43.71173737200007],
              [-7.812001105999911, 43.723089911000045],
              [-7.793853318999936, 43.73411692900004],
              [-7.773793097999942, 43.74258047100005],
              [-7.734038865999935, 43.750067450000074],
              [-7.712757941999939, 43.76068756700005],
              [-7.695708787999934, 43.77488841400009],
              [-7.688832160999937, 43.78998444200005],
              [-7.685536261999914, 43.79344310100004],
              [-7.678334113999938, 43.79047272300005],
              [-7.671294725999928, 43.782863674000055],
              [-7.668324347999942, 43.77252838700008],
              [-7.672596808999913, 43.76666901200008],
              [-7.69562740799995, 43.74591705900008],
              [-7.696156378999945, 43.73151276200008],
              [-7.691558397999927, 43.72724030200004],
              [-7.683990037999934, 43.72870514500005],
              [-7.675160285999937, 43.731634833000044],
              [-7.673573370999918, 43.734361070000034],
              [-7.67414303299995, 43.73920319200005],
              [-7.672474738999938, 43.743841864000046],
              [-7.664621548999946, 43.74591705900008],
              [-7.658029751999948, 43.746527411000045],
              [-7.641021287999934, 43.75267161700003],
              [-7.637603318999936, 43.73908112200007],
              [-7.613026495999918, 43.704291083000044],
              [-7.615956183999913, 43.68854401200008],
              [-7.607167120999918, 43.691107489000046],
              [-7.594593878999945, 43.70368073100008],
              [-7.586415167999917, 43.717962958000044],
              [-7.574289516999954, 43.714544989000046],
              [-7.565419074999909, 43.71979401200008],
              [-7.555775519999941, 43.72760651200008],
              [-7.541411912999934, 43.731634833000044],
              [-7.502023891999954, 43.72833893400008],
              [-7.490142381999931, 43.72532786700003],
              [-7.407622850999928, 43.69122955900008],
              [-7.367054816999939, 43.68008047100005],
              [-7.304107225999928, 43.59857819200005],
              [-7.256743943999936, 43.58161041900007],
              [-7.260161912999934, 43.57750071800007],
              [-7.262277798999946, 43.574286200000074],
              [-7.265126105999911, 43.571478583000044],
              [-7.271066860999952, 43.56863027600008],
              [-7.271066860999952, 43.56114329600007],
              [-7.257720506999931, 43.55666738500008],
              [-7.249623175999943, 43.55939362200007],
              [-7.242014126999948, 43.56480540600006],
              [-7.230091925999943, 43.56863027600008],
              [-7.215443488999938, 43.56867096600007],
              [-7.194894985999952, 43.56350332200009],
              [-7.156971808999913, 43.55927155200004],
              [-7.095855272999927, 43.560980536000045],
              [-7.079335089999915, 43.56863027600008],
              [-7.061594204999949, 43.56159088700008],
              [-7.044300910999937, 43.55939362200007],
              [-7.032338019999941, 43.55300527600008],
              [-7.030873175999943, 43.53322988500008],
              [-7.03774980399993, 43.52224355700008],
              [-7.048410610999952, 43.51044342700004],
              [-7.053618943999936, 43.496527411000045],
              [-7.044585740999935, 43.47919342700004],
              [-7.043853318999936, 43.47919342700004],
              [-7.038319464999915, 43.47919342700004],
              [-7.032704230999911, 43.49546946800007],
              [-7.02953040299991, 43.512152411000045],
              [-7.02375240799995, 43.525824286000045],
              [-7.010365363999938, 43.53322988500008],
              [-7.001372850999928, 43.55666738500008],
              [-6.943959113999938, 43.56598541900007],
              [-6.84593665299991, 43.56863027600008],
              [-6.83071855399993, 43.56513092700004],
              [-6.770822719999956, 43.56863027600008],
              [-6.729644334999932, 43.559759833000044],
              [-6.703724738999938, 43.55756256700005],
              [-6.64867102799991, 43.57904694200005],
              [-6.597727016999954, 43.57522207200009],
              [-6.546620245999918, 43.561835028000075],
              [-6.510121222999942, 43.54747142100007],
              [-6.499663865999935, 43.55308665600006],
              [-6.488270636999914, 43.555121161000045],
              [-6.462961391999954, 43.55495840100008],
              [-6.464751756999931, 43.55967845300006],
              [-6.467274542999917, 43.57086823100008],
              [-6.469105597999942, 43.575384833000044],
              [-6.45531165299991, 43.57335032800006],
              [-6.431792772999927, 43.56342194200005],
              [-6.417632615999935, 43.56114329600007],
              [-6.366118943999936, 43.56863027600008],
              [-6.314605272999927, 43.56863027600008],
              [-6.300038214999915, 43.57062409100007],
              [-6.273915167999917, 43.57961660400008],
              [-6.249989386999914, 43.584051825000074],
              [-6.243885870999918, 43.58930084800005],
              [-6.236398891999954, 43.59430573100008],
              [-6.222767706999946, 43.59589264500005],
              [-6.190988735999952, 43.578558661000045],
              [-6.17804928299995, 43.575384833000044],
              [-6.100412563999953, 43.569199937000064],
              [-6.084950324999909, 43.575384833000044],
              [-6.069162563999953, 43.56968821800007],
              [-6.054188605999911, 43.57457103100006],
              [-6.039214647999927, 43.58311595300006],
              [-6.023508266999954, 43.58844635600008],
              [-5.907378709999932, 43.58844635600008],
              [-5.902170376999948, 43.59752024900007],
              [-5.90884355399993, 43.60492584800005],
              [-5.913075324999909, 43.61286041900007],
              [-5.90062415299991, 43.62323639500005],
              [-5.90257727799991, 43.62649160400008],
              [-5.905344204999949, 43.63381582200009],
              [-5.907378709999932, 43.636826890000066],
              [-5.875152147999927, 43.636786200000074],
              [-5.86351477799991, 43.64142487200007],
              [-5.859038865999935, 43.653631903000075],
              [-5.85220292899993, 43.662949937000064],
              [-5.836333787999934, 43.662217515000066],
              [-5.803822394999941, 43.650498765000066],
              [-5.782338019999941, 43.63703034100007],
              [-5.727406378999945, 43.589544989000046],
              [-5.708851691999939, 43.56863027600008],
              [-5.701975063999953, 43.56863027600008],
              [-5.696766730999911, 43.58283112200007],
              [-5.689198370999918, 43.578558661000045],
              [-5.677479620999918, 43.56114329600007],
              [-5.625599738999938, 43.55495840100008],
              [-5.424224412999934, 43.56114329600007],
              [-5.393869594999956, 43.55524323100008],
              [-5.390736456999946, 43.54132721600007],
              [-5.403553839999915, 43.52541738500008],
              [-5.420806443999936, 43.513373114000046],
              [-5.413929816999939, 43.50653717700004],
              [-5.403675910999937, 43.51109446800007],
              [-5.382639126999948, 43.51638418200008],
              [-5.372425910999937, 43.52020905200004],
              [-5.365101691999939, 43.52671946800007],
              [-5.362212693999936, 43.53339264500005],
              [-5.356800910999937, 43.53860097900008],
              [-5.341949022999927, 43.54063548400006],
              [-5.299875454999949, 43.53766510600008],
              [-5.284006313999953, 43.53347402600008],
              [-5.211903449999909, 43.49835846600007],
              [-5.177886522999927, 43.48936595300006],
              [-5.091664191999939, 43.48627350500004],
              [-5.067697719999956, 43.48139069200005],
              [-5.057036912999934, 43.46861399900007],
              [-5.045033331999946, 43.474310614000046],
              [-4.975168423999946, 43.45876699400009],
              [-4.96711178299995, 43.46088288000004],
              [-4.952544725999928, 43.47007884300007],
              [-4.941029425999943, 43.47174713700008],
              [-4.930246548999946, 43.46950918200008],
              [-4.907622850999928, 43.460638739000046],
              [-4.836537238999938, 43.44977448100008],
              [-4.754994269999941, 43.42165761900009],
              [-4.734934048999946, 43.41710032800006],
              [-4.512318488999938, 43.40273672100005],
              [-4.508168097999942, 43.402451890000066],
              [-4.481678839999915, 43.38361237200007],
              [-4.460804816999939, 43.39870840100008],
              [-4.432525193999936, 43.40261465100008],
              [-4.404896613999938, 43.396999416000085],
              [-4.385568813999953, 43.38361237200007],
              [-4.379261847999942, 43.38361237200007],
              [-4.368763800999943, 43.396185614000046],
              [-4.359364386999914, 43.399684963000084],
              [-4.31281490799995, 43.395778713000084],
              [-4.188588019999941, 43.40538157800006],
              [-4.160959438999953, 43.421169338000084],
              [-4.097727016999954, 43.435614325000074],
              [-4.073963995999918, 43.43825918200008],
              [-4.029204881999931, 43.43825918200008],
              [-4.023426886999914, 43.44094472900008],
              [-4.022572394999941, 43.445746161000045],
              [-4.020904100999928, 43.450384833000044],
              [-4.012766079999949, 43.45250071800007],
              [-4.005686001999948, 43.45079173400006],
              [-3.981434699999909, 43.43825918200008],
              [-3.976470506999931, 43.44293854400007],
              [-3.971994594999956, 43.44415924700007],
              [-3.967152472999942, 43.444199937000064],
              [-3.961008266999954, 43.44509511900009],
              [-3.965443488999938, 43.44684479400007],
              [-3.974598761999914, 43.45250071800007],
              [-3.974598761999914, 43.45876699400009],
              [-3.940052863999938, 43.47711823100008],
              [-3.922718878999945, 43.48261139500005],
              [-3.906320766999954, 43.47919342700004],
              [-3.893788214999915, 43.484890041000085],
              [-3.89085852799991, 43.483710028000075],
              [-3.885853644999941, 43.47919342700004],
              [-3.856800910999937, 43.49237702000005],
              [-3.826730923999946, 43.49701569200005],
              [-3.797027147999927, 43.49274323100008],
              [-3.769154425999943, 43.47919342700004],
              [-3.812652147999927, 43.46487051000008],
              [-3.830962693999936, 43.45600006700005],
              [-3.844309048999946, 43.44509511900009],
              [-3.833851691999939, 43.43589915600006],
              [-3.829253709999932, 43.43313222900008],
              [-3.823841925999943, 43.43077220300006],
              [-3.827259894999941, 43.43003978100006],
              [-3.829986131999931, 43.430121161000045],
              [-3.831532355999911, 43.42906321800007],
              [-3.831288214999915, 43.42458730700008],
              [-3.820220506999931, 43.424261786000045],
              [-3.81118730399993, 43.425482489000046],
              [-3.796498175999943, 43.43077220300006],
              [-3.789540167999917, 43.43585846600007],
              [-3.776193813999953, 43.449652411000045],
              [-3.772287563999953, 43.45250071800007],
              [-3.763498501999948, 43.45026276200008],
              [-3.75413977799991, 43.44049713700008],
              [-3.744984503999945, 43.43825918200008],
              [-3.740712042999917, 43.44232819200005],
              [-3.743031378999945, 43.45136139500005],
              [-3.748890753999945, 43.46072011900009],
              [-3.755523240999935, 43.46552155200004],
              [-3.755523240999935, 43.47174713700008],
              [-3.741525844999956, 43.47024160400008],
              [-3.735747850999928, 43.468817450000074],
              [-3.728871222999942, 43.46552155200004],
              [-3.727162238999938, 43.47052643400008],
              [-3.725819464999915, 43.47052643400008],
              [-3.721424933999913, 43.47174713700008],
              [-3.728871222999942, 43.47919342700004],
              [-3.717925584999932, 43.48273346600007],
              [-3.688384568999936, 43.48423899900007],
              [-3.676991339999915, 43.489447333000044],
              [-3.667062954999949, 43.49664948100008],
              [-3.656076626999948, 43.50067780200004],
              [-3.579416469999956, 43.51825592700004],
              [-3.554351365999935, 43.516913153000075],
              [-3.556263800999943, 43.499701239000046],
              [-3.539051886999914, 43.49896881700005],
              [-3.52562415299991, 43.49164459800005],
              [-3.514719204999949, 43.48322174700007],
              [-3.505360480999911, 43.47919342700004],
              [-3.436634894999941, 43.47048574400009],
              [-3.431507941999939, 43.466864325000074],
              [-3.428293423999946, 43.46173737200007],
              [-3.427154100999928, 43.45563385600008],
              [-3.428618943999936, 43.44684479400007],
              [-3.432606574999909, 43.445420640000066],
              [-3.438872850999928, 43.446559963000084],
              [-3.447010870999918, 43.44509511900009],
              [-3.451161261999914, 43.447699286000045],
              [-3.460601365999935, 43.45221588700008],
              [-3.470041469999956, 43.45416901200008],
              [-3.474354620999918, 43.44879791900007],
              [-3.477772589999915, 43.443060614000046],
              [-3.485829230999911, 43.437567450000074],
              [-3.501698370999918, 43.43077220300006],
              [-3.481800910999937, 43.42804596600007],
              [-3.470448370999918, 43.41677480700008],
              [-3.461089647999927, 43.41246165600006],
              [-3.447010870999918, 43.43077220300006],
              [-3.43618730399993, 43.41901276200008],
              [-3.422230597999942, 43.418076890000066],
              [-3.392486131999931, 43.42458730700008],
              [-3.378041144999941, 43.42255280200004],
              [-3.33031165299991, 43.41034577000005],
              [-3.268950975999928, 43.40412018400008],
              [-3.223540818999936, 43.39162832200009],
              [-3.210519985999952, 43.389837958000044],
              [-3.200021938999953, 43.38552480700008],
              [-3.176909959999932, 43.36623769700009],
              [-3.150868292999917, 43.360215562000064],
              [-3.13149980399993, 43.35578034100007],
              [-3.112375454999949, 43.35407135600008],
              [-3.089507615999935, 43.366888739000046],
              [-3.057850714999915, 43.35236237200007],
              [-3.008168097999942, 43.32090892100007],
              [-3.008168097999942, 43.32843659100007],
              [-3.020008917999917, 43.35256582200009],
              [-3.023426886999914, 43.364935614000046],
              [-3.029286261999914, 43.37213776200008],
              [-3.029286261999914, 43.376166083000044],
              [-3.024322068999936, 43.380926825000074],
              [-3.010975714999915, 43.38414134300007],
              [-2.999419725999928, 43.39435455900008],
              [-2.955922003999945, 43.41384511900009],
              [-2.939930792999917, 43.41710032800006],
              [-2.939930792999917, 43.42458730700008],
              [-2.946685350999928, 43.42458730700008],
              [-2.946685350999928, 43.43077220300006],
              [-2.930083787999934, 43.437933661000045],
              [-2.905262824999909, 43.439886786000045],
              [-2.854237433999913, 43.43825918200008],
              [-2.806996222999942, 43.44167715100008],
              [-2.785959438999953, 43.44786204600007],
              [-2.768625454999949, 43.45250071800007],
              [-2.755848761999914, 43.45026276200008],
              [-2.734934048999946, 43.438788153000075],
              [-2.715199347999942, 43.42450592700004],
              [-2.706532355999911, 43.41368235900006],
              [-2.694935675999943, 43.38861725500004],
              [-2.691029425999943, 43.36753978100006],
              [-2.687001105999911, 43.37144603100006],
              [-2.679269985999952, 43.389837958000044],
              [-2.678456183999913, 43.394639390000066],
              [-2.678781704999949, 43.40058014500005],
              [-2.677805141999954, 43.40619538000004],
              [-2.672963019999941, 43.41034577000005],
              [-2.661203579999949, 43.41193268400008],
              [-2.649322068999936, 43.40953196800007],
              [-2.638091600999928, 43.405951239000046],
              [-2.606922980999911, 43.40188222900008],
              [-2.548898891999954, 43.38361237200007],
              [-2.506011522999927, 43.37714264500005],
              [-2.483509894999941, 43.37063222900008],
              [-2.464426235999952, 43.34922923400006],
              [-2.36742102799991, 43.315700588000084],
              [-2.327056443999936, 43.30683014500005],
              [-2.284657355999911, 43.30349355700008],
              [-2.241118943999936, 43.30723704600007],
              [-2.207875128999945, 43.31399160400008],
              [-2.196278449999909, 43.31476471600007],
              [-2.190419074999909, 43.31159088700008],
              [-2.183461066999939, 43.30451080900008],
              [-2.17446855399993, 43.29743073100008],
              [-2.162220831999946, 43.294256903000075],
              [-2.159575975999928, 43.295355536000045],
              [-2.156320766999954, 43.29767487200007],
              [-2.151519334999932, 43.299994208000044],
              [-2.14484615799995, 43.30109284100007],
              [-2.140044725999928, 43.298895575000074],
              [-2.137806769999941, 43.294216213000084],
              [-2.134836391999954, 43.289577541000085],
              [-2.127797003999945, 43.28742096600007],
              [-2.098866339999915, 43.30414459800005],
              [-2.086415167999917, 43.30723704600007],
              [-2.065541144999941, 43.30959707200009],
              [-1.994618292999917, 43.32843659100007],
              [-1.971791144999941, 43.33921946800007],
              [-1.960357225999928, 43.343085028000075],
              [-1.94562740799995, 43.342637437000064],
              [-1.933705206999946, 43.335638739000046],
              [-1.926584438999953, 43.325873114000046],
              [-1.918690558999913, 43.32099030200004],
              [-1.904652472999942, 43.32843659100007],
              [-1.910227016999954, 43.331366278000075],
              [-1.918853318999936, 43.33856842700004],
              [-1.925689256999931, 43.342637437000064],
              [-1.884917772999927, 43.35602448100008],
              [-1.847401495999918, 43.380926825000074],
              [-1.811268683999913, 43.39508698100008],
              [-1.794074744885912, 43.38601533206285],
            ],
          ],
          [
            [
              [1.983372030000055, 42.44126068100006],
              [1.960634399000071, 42.44371531200004],
              [1.947508585000122, 42.45123423300008],
              [1.945648233000099, 42.46381744500009],
              [1.956603638000075, 42.481775005000074],
              [1.967972453000073, 42.48570241300003],
              [1.978307740000076, 42.474979554000114],
              [1.988436320000119, 42.45818471300005],
              [1.99949507600013, 42.44389618000007],
              [1.996084432000117, 42.442836812000095],
              [1.986162557000114, 42.44126068100006],
              [1.983372030000055, 42.44126068100006],
            ],
          ],
          [
            [
              [-17.933949347999942, 27.852036851000037],
              [-17.914051886999914, 27.849554755000042],
              [-17.896473761999914, 27.840318101000037],
              [-17.884022589999915, 27.82758209800005],
              [-17.879261847999942, 27.814520575000074],
              [-17.885121222999942, 27.79791901200008],
              [-17.92642167899993, 27.74282461100006],
              [-17.92760169199994, 27.73651764500005],
              [-17.926909959999932, 27.73037344000005],
              [-17.926909959999932, 27.724351304000038],
              [-17.930165167999917, 27.71865469000005],
              [-17.93512936099995, 27.715643622000073],
              [-17.940663214999915, 27.713690497000073],
              [-17.945139126999948, 27.710760809000078],
              [-17.946929490999935, 27.70465729400007],
              [-17.95030676999994, 27.69953034100007],
              [-17.957753058999913, 27.69399648600006],
              [-17.965240037999934, 27.68699778900009],
              [-17.96861731699994, 27.677679755000042],
              [-17.971302863999938, 27.654364325000074],
              [-17.97948157499991, 27.642523505000042],
              [-17.994130011999914, 27.642238674000055],
              [-18.015777147999927, 27.653469143000052],
              [-18.03066972599993, 27.66787344000005],
              [-18.039784308999913, 27.681341864000046],
              [-18.053130662999934, 27.691229559000078],
              [-18.126942511999914, 27.70026276200008],
              [-18.146636522999927, 27.70856354400007],
              [-18.16038977799991, 27.722357489000046],
              [-18.167225714999915, 27.757554429000038],
              [-18.14049231699994, 27.768784898000035],
              [-18.097767706999946, 27.765366929000038],
              [-18.056792772999927, 27.75649648600006],
              [-18.04198157499991, 27.76520416900007],
              [-18.003244594999956, 27.79881419500009],
              [-17.995350714999915, 27.80805084800005],
              [-17.994130011999914, 27.818752346000053],
              [-17.989857550999943, 27.82371653900009],
              [-17.96861731699994, 27.83222077000005],
              [-17.933949347999942, 27.852036851000037],
            ],
          ],
          [
            [
              [-15.391590949999909, 28.030218817000048],
              [-15.38345292899993, 28.024318752000056],
              [-15.367583787999934, 28.01581452000005],
              [-15.363636847999942, 28.009711005000042],
              [-15.366281704999949, 27.993475653000075],
              [-15.37413489499994, 27.975490627000056],
              [-15.376698370999918, 27.957505601000037],
              [-15.363636847999942, 27.941473700000074],
              [-15.363636847999942, 27.93463776200008],
              [-15.374623175999943, 27.92987702000005],
              [-15.381906704999949, 27.921210028000075],
              [-15.391590949999909, 27.89984772300005],
              [-15.38272050699993, 27.88548411700009],
              [-15.375965949999909, 27.867580471000053],
              [-15.377837693999936, 27.85228099200009],
              [-15.394683397999927, 27.84589264500005],
              [-15.406971808999913, 27.838324286000045],
              [-15.439198370999918, 27.802679755000042],
              [-15.45303300699993, 27.79124583500004],
              [-15.523426886999914, 27.77167389500005],
              [-15.534901495999918, 27.766424872000073],
              [-15.539662238999938, 27.76561107000009],
              [-15.566029425999943, 27.739406643000052],
              [-15.577951626999948, 27.73436107000009],
              [-15.588246222999942, 27.73891836100006],
              [-15.597727016999954, 27.74628327000005],
              [-15.607248501999948, 27.75031159100007],
              [-15.650502081999946, 27.753119208000044],
              [-15.669545050999943, 27.757147528000075],
              [-15.685699022999927, 27.763332424000055],
              [-15.739654100999928, 27.804348049000055],
              [-15.747873501999948, 27.814520575000074],
              [-15.75186113199993, 27.82135651200008],
              [-15.772816535999937, 27.831976630000042],
              [-15.781971808999913, 27.838446356000077],
              [-15.786000128999945, 27.844224351000037],
              [-15.815052863999938, 27.901271877000056],
              [-15.821197068999936, 27.92177969000005],
              [-15.816070115999935, 27.941473700000074],
              [-15.820057745999918, 27.952866929000038],
              [-15.821766730999911, 27.96832916900007],
              [-15.82062740799995, 27.984076239000046],
              [-15.816070115999935, 27.996039130000042],
              [-15.806996222999942, 28.005031643000052],
              [-15.767689581999946, 28.023993231000077],
              [-15.749826626999948, 28.035956122000073],
              [-15.725209113999938, 28.05687083500004],
              [-15.708363410999937, 28.08193594000005],
              [-15.713693813999953, 28.105902411000045],
              [-15.702137824999909, 28.115057684000078],
              [-15.698109503999945, 28.13304271000004],
              [-15.700062628999945, 28.152899481000077],
              [-15.706206834999932, 28.16738515800006],
              [-15.695057745999918, 28.16819896000004],
              [-15.684396938999953, 28.167629299000055],
              [-15.674427863999938, 28.165269273000035],
              [-15.665272589999915, 28.160549221000053],
              [-15.650786912999934, 28.163885809000078],
              [-15.597035285999937, 28.14752838700008],
              [-15.521311001999948, 28.14752838700008],
              [-15.458729620999918, 28.13422272300005],
              [-15.435047980999911, 28.14093659100007],
              [-15.438710089999915, 28.17487213700008],
              [-15.40929114499994, 28.179754950000074],
              [-15.405262824999909, 28.17792389500005],
              [-15.399891730999911, 28.16502513200004],
              [-15.400135870999918, 28.15721263200004],
              [-15.408558722999942, 28.15375397300005],
              [-15.415638800999943, 28.141506252000056],
              [-15.414947068999936, 28.114488023000035],
              [-15.408558722999942, 28.07489655200004],
              [-15.406239386999914, 28.068060614000046],
              [-15.403920050999943, 28.056301174000055],
              [-15.399647589999915, 28.042669989000046],
              [-15.391590949999909, 28.030218817000048],
            ],
          ],
          [
            [
              [-17.309673192999924, 28.207117355000037],
              [-17.25917329099991, 28.21771663800007],
              [-17.212721082999906, 28.20544933000008],
              [-17.170399542999917, 28.18109772300005],
              [-17.116118943999936, 28.146226304000038],
              [-17.104279473999952, 28.123035265000055],
              [-17.09841969699994, 28.10076358500004],
              [-17.113937354999905, 28.080967118000046],
              [-17.133525170999917, 28.069778589000066],
              [-17.163186525999947, 28.045013603000086],
              [-17.18497531099996, 28.031619039000077],
              [-17.207110520999947, 28.026693299000044],
              [-17.232705541999906, 28.019106132000047],
              [-17.257887594999943, 28.024569541000062],
              [-17.310073186999944, 28.053473574000066],
              [-17.343220901999928, 28.097660414000075],
              [-17.343376510999917, 28.133356288000073],
              [-17.338816928999904, 28.171047137000073],
              [-17.309673192999924, 28.207117355000037],
            ],
          ],
          [
            [
              [-16.427695488999916, 28.149669540000048],
              [-16.441029425999943, 28.132757880000042],
              [-16.456776495999918, 28.11546458500004],
              [-16.521546654999952, 28.057573086000048],
              [-16.536327270999948, 28.036474285000054],
              [-16.545765753999945, 28.023993231000077],
              [-16.57971021299994, 28.030332462000047],
              [-16.63442150499992, 28.01165651200006],
              [-16.657439618999945, 28.003653684000085],
              [-16.676339731999917, 27.99709648700008],
              [-16.692683274999922, 27.99984694200009],
              [-16.703551699999934, 28.01368318300007],
              [-16.705751978999956, 28.023000334000074],
              [-16.70409094999991, 28.034979559000078],
              [-16.713246222999942, 28.038275458000044],
              [-16.721058722999942, 28.04450104400007],
              [-16.72411048099991, 28.052679755000042],
              [-16.725941535999937, 28.071478583000044],
              [-16.727894660999937, 28.078599351000037],
              [-16.74160722599993, 28.093817450000074],
              [-16.780629035999937, 28.127875067000048],
              [-16.788685675999943, 28.143784898000035],
              [-16.795399542999917, 28.165269273000035],
              [-16.810536261999914, 28.18187083500004],
              [-16.82681230399993, 28.195746161000045],
              [-16.837147589999915, 28.20897044500009],
              [-16.84398352799991, 28.253078518000052],
              [-16.84723873599995, 28.262518622000073],
              [-16.86119544199994, 28.28188711100006],
              [-16.873402472999942, 28.305243231000077],
              [-16.906605597999942, 28.335150458000044],
              [-16.91605808999992, 28.354969806000042],
              [-16.891935291999914, 28.368656446000045],
              [-16.837439856999936, 28.391082809000068],
              [-16.817766410999923, 28.383563112000047],
              [-16.794178839999915, 28.36912669500009],
              [-16.782541469999956, 28.366034247000073],
              [-16.770130988999938, 28.36627838700008],
              [-16.741566535999937, 28.373480536000045],
              [-16.71961939299996, 28.383261875000073],
              [-16.687189944999943, 28.392780067000047],
              [-16.664179502999957, 28.400726786000064],
              [-16.64439856699994, 28.396429755000042],
              [-16.604406380999933, 28.399666977000038],
              [-16.584633967999935, 28.40109951000005],
              [-16.564478885999904, 28.41533534100006],
              [-16.53892981699994, 28.41787344000005],
              [-16.528187628999945, 28.42210521000004],
              [-16.507135176999952, 28.424134052000056],
              [-16.486903533999907, 28.438273596000045],
              [-16.439930792999917, 28.47524648600006],
              [-16.420399542999917, 28.490627346000053],
              [-16.41429602799991, 28.499212958000044],
              [-16.41197669199994, 28.513739325000074],
              [-16.408273891999954, 28.51984284100007],
              [-16.389393683999913, 28.52875397300005],
              [-16.381214972999942, 28.53424713700008],
              [-16.363352016999954, 28.543036200000074],
              [-16.341053839999915, 28.546576239000046],
              [-16.322743292999917, 28.55345286700009],
              [-16.316395636999914, 28.572088934000078],
              [-16.300160285999937, 28.56663646000004],
              [-16.20270748599995, 28.56403229400007],
              [-16.141346808999913, 28.58344147300005],
              [-16.117746548999946, 28.572088934000078],
              [-16.127070471999957, 28.54381850200008],
              [-16.157397776999915, 28.524482834000082],
              [-16.231391362999943, 28.488415548000035],
              [-16.248014738999927, 28.46112282000007],
              [-16.268671852999944, 28.44331598100007],
              [-16.29613593399995, 28.417762461000052],
              [-16.32389560799993, 28.39746947100008],
              [-16.341633609999917, 28.39133489200009],
              [-16.35551364899993, 28.38114977200007],
              [-16.365771928999948, 28.362455298000043],
              [-16.366106515999945, 28.341425299000036],
              [-16.36057713999992, 28.324581066000064],
              [-16.35810622799994, 28.314630928000042],
              [-16.361332216999926, 28.30442345700004],
              [-16.371000227999957, 28.29711860900005],
              [-16.380015986999922, 28.288342115000034],
              [-16.386773159999905, 28.264989735000086],
              [-16.419232876999956, 28.211382738000054],
              [-16.427966321999918, 28.167685903000063],
              [-16.427695488999916, 28.149669540000048],
            ],
          ],
          [
            [
              [-13.972645636999914, 28.73590729400007],
              [-13.93541419199994, 28.74949778900009],
              [-13.89867102799991, 28.75389232000009],
              [-13.864572719999956, 28.744208075000074],
              [-13.835519985999952, 28.71548086100006],
              [-13.824370897999927, 28.681789455000057],
              [-13.821156378999945, 28.636664130000042],
              [-13.828684048999946, 28.551581122000073],
              [-13.835194464999915, 28.53074778900009],
              [-13.852935350999928, 28.492743231000077],
              [-13.85655676999994, 28.478989976000037],
              [-13.85773678299995, 28.44550202000005],
              [-13.85655676999994, 28.434881903000075],
              [-13.853627081999946, 28.42841217700004],
              [-13.844349738999938, 28.41429271000004],
              [-13.842925584999932, 28.40692780200004],
              [-13.847767706999946, 28.397406317000048],
              [-13.865712042999917, 28.382879950000074],
              [-13.869618292999917, 28.376898505000042],
              [-13.870106574999909, 28.367743231000077],
              [-13.871815558999913, 28.357977606000077],
              [-13.875152147999927, 28.34906647300005],
              [-13.892079230999911, 28.328192450000074],
              [-13.900217251999948, 28.311102606000077],
              [-13.911284959999932, 28.27724844000005],
              [-13.933705206999946, 28.244208075000074],
              [-13.966786261999914, 28.22797272300005],
              [-14.07258053299995, 28.212836005000042],
              [-14.118560350999928, 28.200506903000075],
              [-14.152007615999935, 28.17999909100007],
              [-14.19163977799991, 28.170843817000048],
              [-14.212228969999956, 28.160549221000053],
              [-14.244536912999934, 28.12921784100007],
              [-14.27139238199993, 28.096136786000045],
              [-14.301340298999946, 28.06785716400009],
              [-14.343169725999928, 28.05068594000005],
              [-14.36900794199994, 28.05076732000009],
              [-14.408314581999946, 28.066961981000077],
              [-14.428618943999936, 28.071193752000056],
              [-14.494862433999913, 28.06781647300005],
              [-14.507069464999915, 28.071193752000056],
              [-14.503407355999911, 28.074774481000077],
              [-14.499256964999915, 28.08657461100006],
              [-14.496449347999942, 28.098537502000056],
              [-14.496896938999953, 28.10252513200004],
              [-14.489735480999911, 28.104315497000073],
              [-14.455555792999917, 28.09910716400009],
              [-14.436024542999917, 28.100531317000048],
              [-14.398915167999917, 28.11123281500005],
              [-14.341175910999937, 28.134507554000038],
              [-14.270130988999938, 28.17597077000005],
              [-14.24014238199993, 28.201564846000053],
              [-14.224436001999948, 28.218573309000078],
              [-14.21353105399993, 28.234930731000077],
              [-14.207386847999942, 28.254380601000037],
              [-14.201893683999913, 28.303900458000044],
              [-14.19322669199994, 28.32184479400007],
              [-14.171294725999928, 28.352362372000073],
              [-14.14639238199993, 28.42332591400009],
              [-14.14085852799991, 28.434881903000075],
              [-14.127919074999909, 28.44358958500004],
              [-14.09829667899993, 28.48663971600007],
              [-14.075550910999937, 28.53611888200004],
              [-14.036122199999909, 28.58738841400009],
              [-14.024566209999932, 28.637111721000053],
              [-14.010121222999942, 28.66746653900009],
              [-14.005279100999928, 28.703599351000037],
              [-13.99990800699993, 28.716742255000042],
              [-13.989491339999915, 28.72687409100007],
              [-13.972645636999914, 28.73590729400007],
            ],
          ],
          [
            [
              [-17.75576738199993, 28.818508205000057],
              [-17.757801886999914, 28.798651434000078],
              [-17.750602426999933, 28.774762657000053],
              [-17.741438084999913, 28.757911764000085],
              [-17.721882904999916, 28.74902884900007],
              [-17.721044159999906, 28.730643804000067],
              [-17.751099500999942, 28.699983927000062],
              [-17.76525351999993, 28.67754859100006],
              [-17.757532133999916, 28.657676527000035],
              [-17.74560419599993, 28.621886961000087],
              [-17.75366039599993, 28.603026217000036],
              [-17.759856402999958, 28.576821003000077],
              [-17.783340290999945, 28.548595946000034],
              [-17.803297796999914, 28.50945607500006],
              [-17.82168535099993, 28.475816148000035],
              [-17.830881313999953, 28.45538971600007],
              [-17.837066209999932, 28.45538971600007],
              [-17.84288489499994, 28.46503327000005],
              [-17.86512205699995, 28.475381034000065],
              [-17.872153170999923, 28.49442620900004],
              [-17.879687701999956, 28.543712542000037],
              [-17.89116643099993, 28.555651122000086],
              [-17.89858985399991, 28.571648749000076],
              [-17.91928936799991, 28.596303282000065],
              [-17.924838353999917, 28.618339006000042],
              [-17.963098057999957, 28.67148878100005],
              [-17.967145670999912, 28.69673583100007],
              [-17.971413903999917, 28.712563172000046],
              [-17.97614498599995, 28.728176174000055],
              [-17.992298956999946, 28.73859284100007],
              [-18.00218665299991, 28.74957916900007],
              [-17.996815558999913, 28.780096747000073],
              [-17.970692511999914, 28.81321849200009],
              [-17.936350063999953, 28.840318101000037],
              [-17.911145077999947, 28.85561903200005],
              [-17.89053453999992, 28.843945767000037],
              [-17.865834113999938, 28.840643622000073],
              [-17.84166419199994, 28.83543528900009],
              [-17.801380988999938, 28.849310614000046],
              [-17.78148352799991, 28.842271226000037],
              [-17.765004035999937, 28.829413153000075],
              [-17.75576738199993, 28.818508205000057],
            ],
          ],
          [
            [
              [-13.482980923999946, 29.239935614000046],
              [-13.465402798999946, 29.243312893000052],
              [-13.446603969999956, 29.232977606000077],
              [-13.417795376999948, 29.208929755000042],
              [-13.42760169199994, 29.188706773000035],
              [-13.43150794199994, 29.172430731000077],
              [-13.438791469999956, 29.159002997000073],
              [-13.458729620999918, 29.147406317000048],
              [-13.462391730999911, 29.132147528000075],
              [-13.459136522999927, 29.11859772300005],
              [-13.454009568999936, 29.104071356000077],
              [-13.451893683999913, 29.086004950000074],
              [-13.453846808999913, 29.078924872000073],
              [-13.462269660999937, 29.065741278000075],
              [-13.465565558999913, 29.05805084800005],
              [-13.466216600999928, 29.049750067000048],
              [-13.464588995999918, 29.032171942000048],
              [-13.465565558999913, 29.023911851000037],
              [-13.482045050999943, 28.99945709800005],
              [-13.510487433999913, 28.977484442000048],
              [-13.543039516999954, 28.961737372000073],
              [-13.589955206999946, 28.95136139500005],
              [-13.599720831999946, 28.94204336100006],
              [-13.607574022999927, 28.93260325700004],
              [-13.61978105399993, 28.92837148600006],
              [-13.635487433999913, 28.92723216400009],
              [-13.65843665299991, 28.92259349200009],
              [-13.674387173999946, 28.921535549000055],
              [-13.70929928299995, 28.91469961100006],
              [-13.736073370999918, 28.89647044500009],
              [-13.757191535999937, 28.870306708000044],
              [-13.774647589999915, 28.839585679000038],
              [-13.780873175999943, 28.839585679000038],
              [-13.791493292999917, 28.853461005000042],
              [-13.812123175999943, 28.859076239000046],
              [-13.85968990799995, 28.859442450000074],
              [-13.867298956999946, 28.864894924000055],
              [-13.873646613999938, 28.87685781500005],
              [-13.876332160999937, 28.888820705000057],
              [-13.873036261999914, 28.894232489000046],
              [-13.861927863999938, 28.897406317000048],
              [-13.85342363199993, 28.90497467700004],
              [-13.842925584999932, 28.921535549000055],
              [-13.839100714999915, 28.937892971000053],
              [-13.83507239499994, 28.987209377000056],
              [-13.832102016999954, 29.000392971000053],
              [-13.798491990999935, 29.048081773000035],
              [-13.780873175999943, 29.064886786000045],
              [-13.766835089999915, 29.074042059000078],
              [-13.750559048999946, 29.080633856000077],
              [-13.731434699999909, 29.08466217700004],
              [-13.70889238199993, 29.086004950000074],
              [-13.690174933999913, 29.09088776200008],
              [-13.65648352799991, 29.116034247000073],
              [-13.636830206999946, 29.12693919500009],
              [-13.61827551999994, 29.13239166900007],
              [-13.602365688999953, 29.13426341400009],
              [-13.551177537999934, 29.13422272300005],
              [-13.537220831999946, 29.13825104400007],
              [-13.526112433999913, 29.15029531500005],
              [-13.51398678299995, 29.174750067000048],
              [-13.503163214999915, 29.208156643000052],
              [-13.495472785999937, 29.225083726000037],
              [-13.482980923999946, 29.239935614000046],
            ],
          ],
          [
            [
              [-13.486683722999942, 29.28461334800005],
              [-13.477894660999937, 29.26626211100006],
              [-13.492014126999948, 29.242661851000037],
              [-13.517079230999911, 29.226263739000046],
              [-13.54124915299991, 29.229396877000056],
              [-13.54124915299991, 29.236802476000037],
              [-13.525746222999942, 29.251206773000035],
              [-13.517933722999942, 29.273504950000074],
              [-13.508168097999942, 29.289455471000053],
              [-13.486683722999942, 29.28461334800005],
            ],
          ],
          [
            [
              [-0.73273678299995, 37.747748114000046],
              [-0.741851365999935, 37.72553131700005],
              [-0.740142381999931, 37.702460028000075],
              [-0.726470506999931, 37.66518789300005],
              [-0.746896938999953, 37.68378327000005],
              [-0.751210089999915, 37.71328359600005],
              [-0.75031490799995, 37.74603913000004],
              [-0.754505988999938, 37.77440013200004],
              [-0.749419725999928, 37.77488841400009],
              [-0.748199022999927, 37.77317942900004],
              [-0.748199022999927, 37.77049388200004],
              [-0.746978318999936, 37.76821523600006],
              [-0.743641730999911, 37.76398346600007],
              [-0.737538214999915, 37.75364817900004],
              [-0.73273678299995, 37.747748114000046],
            ],
          ],
          [
            [
              [1.52638326400006, 38.67776762400007],
              [1.565683815000057, 38.69148550500006],
              [1.582367384000065, 38.67491282800006],
              [1.58139082100007, 38.65306224200009],
              [1.557485750000069, 38.64883885900008],
              [1.523448113000086, 38.64940013200004],
              [1.474222865000058, 38.67459664200004],
              [1.458085631000074, 38.68134073900006],
              [1.438731316000087, 38.67027415600006],
              [1.42904707100007, 38.664943752000056],
              [1.412791680000055, 38.64644583200004],
              [1.396976700000039, 38.638646307000045],
              [1.382950333000053, 38.64206092500007],
              [1.387550540000063, 38.66237786100004],
              [1.383459549000065, 38.67000002800006],
              [1.383474155000044, 38.68040599200009],
              [1.388682488000086, 38.68711985900006],
              [1.393321160000085, 38.69627513200004],
              [1.393728061000047, 38.70420970300006],
              [1.38648522200009, 38.70766836100006],
              [1.382823113000086, 38.71157461100006],
              [1.388612436000074, 38.71911491700007],
              [1.401002263000066, 38.73032634600008],
              [1.408029279000061, 38.724485848000086],
              [1.418142123000052, 38.72789134300007],
              [1.427907748000052, 38.73936595300006],
              [1.43132571700005, 38.75486888200004],
              [1.435394727000073, 38.75535716400009],
              [1.436534050000091, 38.754014390000066],
              [1.436534050000091, 38.751613674000055],
              [1.437510613000086, 38.749253648000035],
              [1.48609459700009, 38.694566148000035],
              [1.52638326400006, 38.67776762400007],
            ],
          ],
          [
            [
              [1.605967644000089, 39.09129466400009],
              [1.600840691000087, 39.08238353100006],
              [1.606944207000083, 39.06236399900007],
              [1.623057488000086, 39.02920156500005],
              [1.606455925000091, 39.02838776200008],
              [1.593272332000083, 39.02024974200009],
              [1.584646030000044, 39.00743235900006],
              [1.58139082100007, 38.99192942900004],
              [1.576182488000086, 38.98582591400009],
              [1.541188998000052, 38.96775950700004],
              [1.509776238000086, 38.93016185100004],
              [1.497243686000047, 38.921861070000034],
              [1.469493035000085, 38.910264390000066],
              [1.45866946700005, 38.90013255400004],
              [1.454925977000073, 38.90403880400004],
              [1.448415561000047, 38.90879954600007],
              [1.44499759200005, 38.91315338700008],
              [1.428558790000068, 38.896592515000066],
              [1.414728475000061, 38.89062173700006],
              [1.404144727000073, 38.856756903000075],
              [1.403104951000046, 38.83227756300005],
              [1.370650433000094, 38.83180940700004],
              [1.360850457000083, 38.85191478100006],
              [1.34351647200009, 38.86237213700008],
              [1.328868035000085, 38.85789622600004],
              [1.32203209700009, 38.85789622600004],
              [1.318614129000082, 38.85911692900004],
              [1.31771894600007, 38.85984935100004],
              [1.307790561000047, 38.85789622600004],
              [1.300303582000083, 38.87046946800007],
              [1.283457879000082, 38.87461985900006],
              [1.266612175000091, 38.870347398000035],
              [1.259938998000052, 38.85789622600004],
              [1.22820071700005, 38.87461985900006],
              [1.216644727000073, 38.88507721600007],
              [1.212168816000087, 38.903225002000056],
              [1.22429446700005, 38.92735423400006],
              [1.227549675000091, 38.94200267100007],
              [1.21843509200005, 38.95408763200004],
              [1.226735873000052, 38.960191148000035],
              [1.236827019000089, 38.96515534100007],
              [1.248220248000052, 38.96637604400007],
              [1.259938998000052, 38.960923570000034],
              [1.26726321700005, 38.966050523000035],
              [1.276866082000083, 38.968003648000035],
              [1.300954623000052, 38.96775950700004],
              [1.292246941000087, 39.009873765000066],
              [1.292816602000073, 39.033270575000074],
              [1.30445397200009, 39.04344310100004],
              [1.317556186000047, 39.04759349200009],
              [1.332530144000089, 39.05723704600007],
              [1.35678144600007, 39.07762278900009],
              [1.36304772200009, 39.07762278900009],
              [1.372243686000047, 39.07139720300006],
              [1.39193769600007, 39.083319403000075],
              [1.403330925000091, 39.07762278900009],
              [1.42318769600007, 39.09056224200009],
              [1.450694207000083, 39.10179271000004],
              [1.478688998000052, 39.10773346600007],
              [1.499522332000083, 39.10488515800006],
              [1.508636915000068, 39.11436595300006],
              [1.522715691000087, 39.11888255400004],
              [1.537119988000086, 39.118028062000064],
              [1.553558790000068, 39.10765208500004],
              [1.560394727000073, 39.10582103100006],
              [1.578379754000082, 39.10488515800006],
              [1.589691602000073, 39.102769273000035],
              [1.597911004000082, 39.09813060100004],
              [1.605967644000089, 39.09129466400009],
            ],
          ],
          [
            [
              [3.354502800000091, 39.784369208000044],
              [3.383148634000065, 39.77794017100007],
              [3.439789259000065, 39.75197988500008],
              [3.47437584700009, 39.749701239000046],
              [3.46851647200009, 39.73932526200008],
              [3.469411655000044, 39.73106517100007],
              [3.472666863000086, 39.72357819200005],
              [3.47437584700009, 39.71552155200004],
              [3.470550977000073, 39.71031321800007],
              [3.464366082000083, 39.70640696800007],
              [3.461436394000089, 39.700059312000064],
              [3.467539910000085, 39.687567450000074],
              [3.453868035000085, 39.65969472900008],
              [3.443207227000073, 39.645778713000084],
              [3.429942254000082, 39.639837958000044],
              [3.413096550000091, 39.63507721600007],
              [3.401866082000083, 39.62323639500005],
              [3.398692254000082, 39.60773346600007],
              [3.40601647200009, 39.59198639500005],
              [3.365407748000052, 39.56305573100008],
              [3.323252800000091, 39.523871161000045],
              [3.291758660000085, 39.475775458000044],
              [3.282481316000087, 39.42011139500005],
              [3.272715691000087, 39.42475006700005],
              [3.268809441000087, 39.42755768400008],
              [3.252614780000044, 39.38617584800005],
              [3.221039259000065, 39.359890041000085],
              [3.129405144000089, 39.315741278000075],
              [3.090993686000047, 39.29006582200009],
              [3.083262566000087, 39.28009674700007],
              [3.079112175000091, 39.27688222900008],
              [3.06999759200005, 39.27175527600008],
              [3.060801629000082, 39.26906972900008],
              [3.056651238000086, 39.27297597900008],
              [3.029307488000086, 39.30463288000004],
              [3.022959832000083, 39.30817291900007],
              [3.007334832000083, 39.313747463000084],
              [3.00131269600007, 39.317694403000075],
              [2.996755405000044, 39.32697174700007],
              [2.994639519000089, 39.337958075000074],
              [2.991384311000047, 39.34727610900006],
              [2.984222852000073, 39.35114166900007],
              [2.974457227000073, 39.35346100500004],
              [2.958832227000073, 39.36322663000004],
              [2.950043165000068, 39.36550527600008],
              [2.938161655000044, 39.36436595300006],
              [2.922373894000089, 39.35972728100006],
              [2.912608269000089, 39.358669338000084],
              [2.825450066000087, 39.36359284100007],
              [2.786631707000083, 39.37592194200005],
              [2.761729363000086, 39.40021393400008],
              [2.751231316000087, 39.454779364000046],
              [2.736582879000082, 39.462103583000044],
              [2.739512566000087, 39.47829824400009],
              [2.754893425000091, 39.50263092700004],
              [2.74350019600007, 39.52338288000004],
              [2.715098504000082, 39.54352448100008],
              [2.681651238000086, 39.558661200000074],
              [2.655284050000091, 39.56472402600008],
              [2.633474155000044, 39.55927155200004],
              [2.569102410000085, 39.53152090100008],
              [2.555674675000091, 39.520046291000085],
              [2.544932488000086, 39.49298737200007],
              [2.520192905000044, 39.47284577000005],
              [2.492686394000089, 39.47024160400008],
              [2.473806187000093, 39.49579498800006],
              [2.471690300000091, 39.49791087400007],
              [2.469004754000082, 39.50588613500008],
              [2.472178582000083, 39.512152411000045],
              [2.480642123000052, 39.51622142100007],
              [2.453949415000068, 39.53742096600007],
              [2.445811394000089, 39.52887604400007],
              [2.438161655000044, 39.52521393400008],
              [2.431162957000083, 39.52769603100006],
              [2.425954623000052, 39.53742096600007],
              [2.398285352000073, 39.52496979400007],
              [2.391856316000087, 39.52374909100007],
              [2.382090691000087, 39.52924225500004],
              [2.373708530000044, 39.54718659100007],
              [2.355642123000052, 39.558661200000074],
              [2.350759311000047, 39.57648346600007],
              [2.351735873000052, 39.59674713700008],
              [2.357676629000082, 39.61188385600008],
              [2.42937259200005, 39.64667389500005],
              [2.450450066000087, 39.65033600500004],
              [2.468272332000083, 39.659369208000044],
              [2.517588738000086, 39.70014069200005],
              [2.532399936000047, 39.706366278000075],
              [2.55241946700005, 39.708685614000046],
              [2.56967207100007, 39.71308014500005],
              [2.586599155000044, 39.723822333000044],
              [2.617686394000089, 39.749701239000046],
              [2.621918165000068, 39.75446198100008],
              [2.629079623000052, 39.766872463000084],
              [2.631358269000089, 39.77012767100007],
              [2.635996941000087, 39.77102285400008],
              [2.647471550000091, 39.769232489000046],
              [2.651866082000083, 39.77012767100007],
              [2.676036004000082, 39.78908926000008],
              [2.679209832000083, 39.79401276200008],
              [2.683604363000086, 39.796210028000075],
              [2.703949415000068, 39.814154364000046],
              [2.71062259200005, 39.81854889500005],
              [2.717946811000047, 39.82013580900008],
              [2.74740644600007, 39.83161041900007],
              [2.761729363000086, 39.84052155200004],
              [2.77320397200009, 39.84963613500008],
              [2.78484134200005, 39.856716213000084],
              [2.799652540000068, 39.85956452000005],
              [2.803233269000089, 39.86159902600008],
              [2.809580925000091, 39.87055084800005],
              [2.813243035000085, 39.87258535400008],
              [2.834157748000052, 39.871161200000074],
              [2.843597852000073, 39.87258535400008],
              [2.873057488000086, 39.88349030200004],
              [2.93327884200005, 39.914496161000045],
              [2.964121941000087, 39.92096588700008],
              [3.020274285000085, 39.92515696800007],
              [3.075694207000083, 39.93610260600008],
              [3.17945397200009, 39.96877676000008],
              [3.19312584700009, 39.95510488500008],
              [3.198415561000047, 39.95929596600007],
              [3.201345248000052, 39.96051666900007],
              [3.21420332100007, 39.95510488500008],
              [3.203623894000089, 39.94916413000004],
              [3.168467644000089, 39.936387437000064],
              [3.15560957100007, 39.934027411000045],
              [3.140879754000082, 39.92808665600006],
              [3.127452019000089, 39.91669342700004],
              [3.115489129000082, 39.90875885600008],
              [3.104340040000068, 39.91351959800005],
              [3.096934441000087, 39.91351959800005],
              [3.094737175000091, 39.88121165600006],
              [3.13021894600007, 39.87641022300005],
              [3.20679772200009, 39.893011786000045],
              [3.20679772200009, 39.886826890000066],
              [3.196787957000083, 39.88121165600006],
              [3.195567254000082, 39.87453847900008],
              [3.196462436000047, 39.86713288000004],
              [3.19312584700009, 39.85956452000005],
              [3.18718509200005, 39.854356187000064],
              [3.181488477000073, 39.85138580900008],
              [3.165212436000047, 39.84589264500005],
              [3.133555535000085, 39.839544989000046],
              [3.12631269600007, 39.83185455900008],
              [3.124847852000073, 39.81110260600008],
              [3.13648522200009, 39.788763739000046],
              [3.162608269000089, 39.76911041900007],
              [3.194834832000083, 39.75499095300006],
              [3.223887566000087, 39.749701239000046],
              [3.292491082000083, 39.749701239000046],
              [3.30990644600007, 39.755072333000044],
              [3.340342644000089, 39.778998114000046],
              [3.354502800000091, 39.784369208000044],
            ],
          ],
          [
            [
              [4.302907748000052, 39.92552317900004],
              [4.307302280000044, 39.91054922100005],
              [4.328786655000044, 39.88344961100006],
              [4.337087436000047, 39.867173570000034],
              [4.330332879000082, 39.867173570000034],
              [4.326263868000069, 39.87343984600005],
              [4.319753451000054, 39.87921784100007],
              [4.311778191000087, 39.88418203300006],
              [4.302907748000052, 39.887600002000056],
              [4.300059441000087, 39.82176341400009],
              [4.248138868000069, 39.816473700000074],
              [4.177175326000054, 39.84332916900007],
              [4.015065951000054, 39.925767320000034],
              [3.981374545000051, 39.936061916000085],
              [3.941335483000046, 39.936753648000035],
              [3.869313998000052, 39.92552317900004],
              [3.830658399000072, 39.936061916000085],
              [3.834890170000051, 39.94798411700009],
              [3.83570397200009, 39.96242910400008],
              [3.839121941000087, 39.97557200700004],
              [3.850515170000051, 39.98387278900009],
              [3.842377149000072, 39.98940664300005],
              [3.82203209700009, 39.99514394700009],
              [3.812917514000048, 40.001206773000035],
              [3.803396030000044, 40.01316966400009],
              [3.803151889000048, 40.01813385600008],
              [3.807058139000048, 40.02326080900008],
              [3.809499545000051, 40.03538646000004],
              [3.821869337000066, 40.04763418200008],
              [3.891530795000051, 40.05955638200004],
              [3.915456576000054, 40.051988023000035],
              [4.011892123000052, 40.05955638200004],
              [4.052012566000087, 40.05817291900007],
              [4.063405795000051, 40.05955638200004],
              [4.077565951000054, 40.06427643400008],
              [4.094330274000072, 40.074733791000085],
              [4.105072462000066, 40.079413153000075],
              [4.107839389000048, 40.067613023000035],
              [4.116791212000066, 40.05963776200008],
              [4.139089389000048, 40.04592519700009],
              [4.136973504000082, 40.043036200000074],
              [4.134857618000069, 40.03571198100008],
              [4.135427280000044, 40.028225002000056],
              [4.14226321700005, 40.02480703300006],
              [4.148529493000069, 40.02781810100004],
              [4.15593509200005, 40.03465403900009],
              [4.16578209700009, 40.04592519700009],
              [4.16382897200009, 40.06057363500008],
              [4.170502149000072, 40.06460195500006],
              [4.176524285000085, 40.05923086100006],
              [4.172618035000085, 40.04592519700009],
              [4.178640170000051, 40.03884511900009],
              [4.20671634200005, 40.02480703300006],
              [4.212494337000066, 40.017238674000055],
              [4.216888868000069, 40.012600002000056],
              [4.227224155000044, 40.00490957200009],
              [4.232676629000082, 40.00271230700008],
              [4.247487826000054, 40.00039297100005],
              [4.254567905000044, 39.99746328300006],
              [4.264903191000087, 39.986395575000074],
              [4.273366733000046, 39.969956773000035],
              [4.272390170000051, 39.95534902600008],
              [4.254567905000044, 39.94969310100004],
              [4.270111524000072, 39.94375234600005],
              [4.285899285000085, 39.944606838000084],
              [4.298024936000047, 39.94196198100008],
              [4.302907748000052, 39.92552317900004],
            ],
          ],
          [
            [
              [2.985366533000047, 39.16617614000006],
              [2.982307966000064, 39.13918350800009],
              [2.962154470000087, 39.11606223500007],
              [2.930866760000072, 39.11817588900004],
              [2.913614193000058, 39.15196267500005],
              [2.940424231000065, 39.17193037800007],
              [2.980582428000048, 39.185560431000056],
              [2.985366533000047, 39.16617614000006],
            ],
          ],
          [
            [
              [-4.300045127999908, 35.17272382800007],
              [-4.298700709999935, 35.17261202000009],
              [-4.296899558999939, 35.17224902600009],
              [-4.297730463999926, 35.171536821000075],
              [-4.299392273999956, 35.17165552200004],
              [-4.30093538299991, 35.172070974000064],
              [-4.301884987999927, 35.17266447800006],
              [-4.30105408299994, 35.17290187900005],
              [-4.300045127999908, 35.17272382800007],
            ],
          ],
          [
            [
              [-3.902962458999923, 35.21530963200007],
              [-3.902329379999912, 35.21590471400009],
              [-3.90195684999992, 35.21546445200005],
              [-3.90253257899991, 35.214787124000054],
              [-3.903131789999918, 35.21503870100008],
              [-3.902962458999923, 35.21530963200007],
            ],
          ],
          [
            [
              [-3.900732397999946, 35.21782706500005],
              [-3.899953471999936, 35.217860931000075],
              [-3.899818006999908, 35.217285203000074],
              [-3.900495333999913, 35.217352935000065],
              [-3.901003328999934, 35.21721747000004],
              [-3.901308126999936, 35.21731906900004],
              [-3.901274259999923, 35.217623866000054],
              [-3.900732397999946, 35.21782706500005],
            ],
          ],
          [
            [
              [-2.434242513999948, 35.18523036700009],
              [-2.429393926999921, 35.18603846500008],
              [-2.426501991999942, 35.182113679000054],
              [-2.431414170999915, 35.178765584000075],
              [-2.435858709999934, 35.181189878000055],
              [-2.434242513999948, 35.18523036700009],
            ],
          ],
          [
            [
              [-5.418773795999925, 35.915597312000045],
              [-5.415969540999924, 35.91353101900006],
              [-5.417888241999947, 35.91087435600008],
              [-5.420249719999958, 35.91161231800004],
              [-5.420840089999956, 35.91426898100008],
              [-5.418773795999925, 35.915597312000045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Denmark',
        iso3: 'DNK',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [8.660775934000071, 54.89631115600007],
              [8.668793165000068, 54.91351959800005],
              [8.661387566000087, 54.92031484600005],
              [8.674815300000091, 54.94794342700004],
              [8.666351759000065, 54.97333405200004],
              [8.650401238000086, 54.99799225500004],
              [8.640961134000065, 55.02338288000004],
              [8.644786004000082, 55.05573151200008],
              [8.656504754000082, 55.08250560100004],
              [8.670909050000091, 55.107123114000046],
              [8.681895379000082, 55.13320547100005],
              [8.57553144600007, 55.14411041900007],
              [8.563649936000047, 55.14337799700007],
              [8.55990644600007, 55.13507721600007],
              [8.557383660000085, 55.09638092700004],
              [8.551117384000065, 55.09137604400007],
              [8.541351759000065, 55.090277411000045],
              [8.528575066000087, 55.08197663000004],
              [8.514821811000047, 55.07078685100004],
              [8.49935957100007, 55.06557851800005],
              [8.483897332000083, 55.067613023000035],
              [8.470225457000083, 55.07859935100004],
              [8.458832227000073, 55.10346100500004],
              [8.460215691000087, 55.127386786000045],
              [8.46648196700005, 55.151597398000035],
              [8.470225457000083, 55.17755768400008],
              [8.488942905000044, 55.19717031500005],
              [8.530528191000087, 55.20075104400007],
              [8.572601759000065, 55.19367096600007],
              [8.593760613000086, 55.180975653000075],
              [8.580332879000082, 55.178941148000035],
              [8.569509311000047, 55.17377350500004],
              [8.55209394600007, 55.16054922100005],
              [8.555186394000089, 55.14935944200005],
              [8.614756707000083, 55.14435455900008],
              [8.66928144600007, 55.13690827000005],
              [8.689463738000086, 55.14158763200004],
              [8.68718509200005, 55.160589911000045],
              [8.668793165000068, 55.194647528000075],
              [8.65593509200005, 55.237494208000044],
              [8.648448113000086, 55.28025950700004],
              [8.650401238000086, 55.29173411700003],
              [8.659353061000047, 55.30581289300005],
              [8.661387566000087, 55.314439195000034],
              [8.659678582000083, 55.32721588700008],
              [8.648448113000086, 55.35228099200003],
              [8.639414910000085, 55.39740631700005],
              [8.632090691000087, 55.41876862200007],
              [8.617686394000089, 55.437933661000045],
              [8.592539910000085, 55.449286200000074],
              [8.556651238000086, 55.454291083000044],
              [8.49000084700009, 55.45530833500004],
              [8.441905144000089, 55.46393463700008],
              [8.401133660000085, 55.485663153000075],
              [8.310394727000073, 55.56268952000005],
              [8.311208530000044, 55.56976959800005],
              [8.332367384000065, 55.57200755400004],
              [8.332367384000065, 55.57827383000006],
              [8.313161655000044, 55.58270905200004],
              [8.290212436000047, 55.58380768400008],
              [8.267832879000082, 55.580511786000045],
              [8.250498894000089, 55.57200755400004],
              [8.239024285000085, 55.557928778000075],
              [8.242035352000073, 55.548529364000046],
              [8.271739129000082, 55.530462958000044],
              [8.262461785000085, 55.52920156500005],
              [8.256358269000089, 55.52680084800005],
              [8.243662957000083, 55.516791083000044],
              [8.266774936000047, 55.51439036700003],
              [8.293955925000091, 55.504339911000045],
              [8.316742384000065, 55.48940664300005],
              [8.326182488000086, 55.47211334800005],
              [8.313324415000068, 55.46930573100008],
              [8.193614129000082, 55.52594635600008],
              [8.169200066000087, 55.534084377000056],
              [8.110606316000087, 55.540228583000044],
              [8.095225457000083, 55.54905833500004],
              [8.094004754000082, 55.56391022300005],
              [8.150238477000073, 55.64923737200007],
              [8.169118686000047, 55.687933661000045],
              [8.181651238000086, 55.72907135600008],
              [8.18336022200009, 55.769598700000074],
              [8.135590040000068, 55.966009833000044],
              [8.130707227000073, 55.97614166900007],
              [8.127777540000068, 55.978216864000046],
              [8.126800977000073, 55.98297760600008],
              [8.127777540000068, 55.987616278000075],
              [8.130707227000073, 55.98973216400003],
              [8.136729363000086, 55.98859284100007],
              [8.139414910000085, 55.986029364000046],
              [8.141123894000089, 55.98346588700008],
              [8.144053582000083, 55.98232656500005],
              [8.150563998000052, 55.97703685100004],
              [8.17546634200005, 55.90033600500004],
              [8.193369988000086, 55.87384674700007],
              [8.195974155000044, 55.86277903900003],
              [8.193614129000082, 55.853216864000046],
              [8.183848504000082, 55.839504299000055],
              [8.181651238000086, 55.82835521000004],
              [8.185069207000083, 55.81464264500005],
              [8.193614129000082, 55.811835028000075],
              [8.238536004000082, 55.82607656500005],
              [8.286306186000047, 55.84747955900008],
              [8.308848504000082, 55.851996161000045],
              [8.347829623000052, 55.86933014500005],
              [8.387705925000091, 55.89288971600007],
              [8.393321160000085, 55.90916575700004],
              [8.386892123000052, 55.92649974200003],
              [8.372894727000073, 55.943426825000074],
              [8.356944207000083, 55.958685614000046],
              [8.319509311000047, 55.986029364000046],
              [8.319509311000047, 56.01703522300005],
              [8.308116082000083, 56.05292389500005],
              [8.282399936000047, 56.075873114000046],
              [8.24773196700005, 56.089829820000034],
              [8.170583530000044, 56.10956452000005],
              [8.149668816000087, 56.11115143400008],
              [8.140635613000086, 56.102728583000044],
              [8.141612175000091, 56.06000397300005],
              [8.139903191000087, 56.03974030200004],
              [8.133799675000091, 56.01703522300005],
              [8.137461785000085, 56.00039297100005],
              [8.134776238000086, 55.99396393400008],
              [8.120127800000091, 55.99656810100004],
              [8.115977410000085, 56.00185781500005],
              [8.111664259000065, 56.01227448100008],
              [8.107920769000089, 56.024318752000056],
              [8.103363477000073, 56.096869208000044],
              [8.106455925000091, 56.11945221600007],
              [8.13062584700009, 56.18195221600007],
              [8.133799675000091, 56.20547109600005],
              [8.12240644600007, 56.551662502000056],
              [8.12663821700005, 56.568426825000074],
              [8.133799675000091, 56.585638739000046],
              [8.178721550000091, 56.67206452000005],
              [8.19898522200009, 56.698879299000055],
              [8.213877800000091, 56.711818752000056],
              [8.219981316000087, 56.70917389500005],
              [8.22396894600007, 56.700425523000035],
              [8.233164910000085, 56.69546133000006],
              [8.232432488000086, 56.688381252000056],
              [8.209971550000091, 56.655951239000046],
              [8.202159050000091, 56.64704010600008],
              [8.202159050000091, 56.64020416900007],
              [8.20834394600007, 56.636786200000074],
              [8.215098504000082, 56.63495514500005],
              [8.233164910000085, 56.633978583000044],
              [8.236582879000082, 56.62970612200007],
              [8.240489129000082, 56.62006256700005],
              [8.24577884200005, 56.61041901200008],
              [8.253916863000086, 56.60610586100006],
              [8.294932488000086, 56.601996161000045],
              [8.305918816000087, 56.59780508000006],
              [8.291514519000089, 56.593003648000035],
              [8.295176629000082, 56.58380768400008],
              [8.292491082000083, 56.567694403000075],
              [8.298350457000083, 56.558294989000046],
              [8.307383660000085, 56.554348049000055],
              [8.315196160000085, 56.55687083500004],
              [8.31804446700005, 56.56362539300005],
              [8.312022332000083, 56.571966864000046],
              [8.312022332000083, 56.57880280200004],
              [8.34351647200009, 56.58454010600008],
              [8.392100457000083, 56.585272528000075],
              [8.436534050000091, 56.58022695500006],
              [8.455902540000068, 56.56854889500005],
              [8.465179884000065, 56.56688060100004],
              [8.514659050000091, 56.54466380400004],
              [8.528493686000047, 56.548163153000075],
              [8.541351759000065, 56.55683014500005],
              [8.55209394600007, 56.568019924000055],
              [8.559580925000091, 56.57880280200004],
              [8.56576582100007, 56.57880280200004],
              [8.596039259000065, 56.53180573100008],
              [8.596853061000047, 56.52415599200003],
              [8.593028191000087, 56.51992422100005],
              [8.594574415000068, 56.51048411700003],
              [8.601084832000083, 56.50112539300005],
              [8.617442254000082, 56.493801174000055],
              [8.636973504000082, 56.479722398000035],
              [8.648448113000086, 56.47573476800005],
              [8.665537957000083, 56.475897528000075],
              [8.726573113000086, 56.48322174700007],
              [8.733164910000085, 56.48505280200004],
              [8.738536004000082, 56.49005768400008],
              [8.742035352000073, 56.497748114000046],
              [8.743418816000087, 56.507066148000035],
              [8.743662957000083, 56.52167389500005],
              [8.744965040000068, 56.53156159100007],
              [8.750824415000068, 56.552069403000075],
              [8.755137566000087, 56.557806708000044],
              [8.760427280000044, 56.56012604400007],
              [8.762543165000068, 56.563381252000056],
              [8.75757897200009, 56.571966864000046],
              [8.726573113000086, 56.585638739000046],
              [8.71656334700009, 56.58616771000004],
              [8.708994988000086, 56.58856842700004],
              [8.70443769600007, 56.59369538000004],
              [8.702972852000073, 56.60236237200007],
              [8.698496941000087, 56.61123281500005],
              [8.681488477000073, 56.61627838700008],
              [8.681895379000082, 56.62653229400007],
              [8.695160352000073, 56.633246161000045],
              [8.740896030000044, 56.63495514500005],
              [8.805430535000085, 56.69546133000006],
              [8.820485873000052, 56.700384833000044],
              [8.861582879000082, 56.707464911000045],
              [8.916758660000085, 56.70880768400008],
              [8.918711785000085, 56.711004950000074],
              [8.894786004000082, 56.71596914300005],
              [8.851084832000083, 56.716782945000034],
              [8.840830925000091, 56.722357489000046],
              [8.850108269000089, 56.74017975500004],
              [8.864756707000083, 56.755845445000034],
              [8.87663821700005, 56.76430898600006],
              [8.908457879000082, 56.777411200000074],
              [8.955739780000044, 56.80296458500004],
              [8.97429446700005, 56.80536530200004],
              [8.985199415000068, 56.80414459800005],
              [9.00367272200009, 56.79905833500004],
              [9.014903191000087, 56.79783763200004],
              [9.026621941000087, 56.79962799700007],
              [9.032725457000083, 56.80377838700008],
              [9.037608269000089, 56.80853913000004],
              [9.045583530000044, 56.812201239000046],
              [9.063161655000044, 56.812567450000074],
              [9.086110873000052, 56.80841705900008],
              [9.105967644000089, 56.800116278000075],
              [9.114512566000087, 56.787990627000056],
              [9.12045332100007, 56.76459381700005],
              [9.13445071700005, 56.75071849200003],
              [9.150563998000052, 56.74091217700004],
              [9.162852410000085, 56.72964101800005],
              [9.176036004000082, 56.70856354400007],
              [9.14820397200009, 56.704738674000055],
              [9.11882571700005, 56.67877838700008],
              [9.09343509200005, 56.674994208000044],
              [9.09343509200005, 56.66754791900007],
              [9.097504102000073, 56.65843333500004],
              [9.086680535000085, 56.649603583000044],
              [9.059336785000085, 56.633978583000044],
              [9.049978061000047, 56.61981842700004],
              [9.048838738000086, 56.60716380400004],
              [9.052989129000082, 56.575384833000044],
              [9.060557488000086, 56.565741278000075],
              [9.076996290000068, 56.56736888200004],
              [9.09343509200005, 56.57807038000004],
              [9.10678144600007, 56.61078522300005],
              [9.121592644000089, 56.61302317900004],
              [9.139659050000091, 56.611029364000046],
              [9.155446811000047, 56.612941799000055],
              [9.149180535000085, 56.62250397300005],
              [9.141123894000089, 56.62604401200008],
              [9.131521030000044, 56.62482330900008],
              [9.121348504000082, 56.620347398000035],
              [9.128916863000086, 56.63125234600005],
              [9.136729363000086, 56.63906484600005],
              [9.143728061000047, 56.647691148000035],
              [9.148610873000052, 56.661322333000044],
              [9.155446811000047, 56.661322333000044],
              [9.149424675000091, 56.63886139500005],
              [9.17554772200009, 56.63544342700004],
              [9.211192254000082, 56.63886139500005],
              [9.233653191000087, 56.637152411000045],
              [9.247243686000047, 56.632025458000044],
              [9.262461785000085, 56.63373444200005],
              [9.276215040000068, 56.63296133000006],
              [9.285329623000052, 56.620347398000035],
              [9.282399936000047, 56.610541083000044],
              [9.25945071700005, 56.59194570500006],
              [9.250336134000065, 56.57880280200004],
              [9.261241082000083, 56.57636139500005],
              [9.26335696700005, 56.571966864000046],
              [9.264008009000065, 56.56590403900003],
              [9.27084394600007, 56.558294989000046],
              [9.28060957100007, 56.552801825000074],
              [9.305674675000091, 56.54466380400004],
              [9.309743686000047, 56.54051341400003],
              [9.31218509200005, 56.53510163000004],
              [9.316416863000086, 56.53082916900007],
              [9.326182488000086, 56.53034088700008],
              [9.340586785000085, 56.54706452000005],
              [9.346690300000091, 56.552069403000075],
              [9.360850457000083, 56.54474518400008],
              [9.373057488000086, 56.552720445000034],
              [9.37273196700005, 56.56537506700005],
              [9.350352410000085, 56.571966864000046],
              [9.319346550000091, 56.561712958000044],
              [9.317393425000091, 56.558661200000074],
              [9.312836134000065, 56.55776601800005],
              [9.302256707000083, 56.558294989000046],
              [9.293711785000085, 56.56102122600004],
              [9.293142123000052, 56.56679922100005],
              [9.296153191000087, 56.571600653000075],
              [9.298838738000086, 56.571966864000046],
              [9.300629102000073, 56.60911692900004],
              [9.317067905000044, 56.64109935100004],
              [9.326019727000073, 56.66941966400003],
              [9.32593834700009, 56.669623114000046],
              [9.305674675000091, 56.69546133000006],
              [9.295909050000091, 56.70156484600005],
              [9.29070071700005, 56.70384349200003],
              [9.27084394600007, 56.702337958000044],
              [9.230642123000052, 56.69208405200004],
              [9.220713738000086, 56.68427155200004],
              [9.199066602000073, 56.67658112200007],
              [9.177907748000052, 56.675848700000074],
              [9.169118686000047, 56.688666083000044],
              [9.180349155000044, 56.70075104400007],
              [9.226410352000073, 56.71625397300005],
              [9.236827019000089, 56.73305898600006],
              [9.242523634000065, 56.74705638200004],
              [9.240489129000082, 56.753973700000074],
              [9.215505405000044, 56.75885651200008],
              [9.205251498000052, 56.76382070500006],
              [9.196543816000087, 56.77045319200005],
              [9.189707879000082, 56.777411200000074],
              [9.184418165000068, 56.78400299700007],
              [9.178721550000091, 56.794134833000044],
              [9.174978061000047, 56.80605703300006],
              [9.176036004000082, 56.818426825000074],
              [9.181162957000083, 56.82172272300005],
              [9.204112175000091, 56.84162018400008],
              [9.20671634200005, 56.84634023600006],
              [9.211436394000089, 56.85150788000004],
              [9.21062259200005, 56.86310455900008],
              [9.205902540000068, 56.87457916900007],
              [9.199554884000065, 56.87982819200005],
              [9.187836134000065, 56.88117096600007],
              [9.178965691000087, 56.88458893400008],
              [9.162852410000085, 56.89411041900007],
              [9.181488477000073, 56.91909414300005],
              [9.200205925000091, 56.93891022300005],
              [9.22046959700009, 56.955064195000034],
              [9.251475457000083, 56.97256094000005],
              [9.258474155000044, 56.97483958500004],
              [9.265961134000065, 56.976223049000055],
              [9.274668816000087, 56.976629950000074],
              [9.279958530000044, 56.979803778000075],
              [9.285492384000065, 56.99396393400008],
              [9.28874759200005, 56.99713776200008],
              [9.437022332000083, 57.02440013200004],
              [9.47006269600007, 57.02383047100005],
              [9.586761915000068, 56.99713776200008],
              [9.586761915000068, 56.98969147300005],
              [9.57398522200009, 56.98501211100006],
              [9.573090040000068, 56.97882721600007],
              [9.580821160000085, 56.97296784100007],
              [9.594248894000089, 56.969183661000045],
              [9.607920769000089, 56.96987539300005],
              [9.617686394000089, 56.975043036000045],
              [9.654144727000073, 57.00678131700005],
              [9.670664910000085, 57.02484772300005],
              [9.688975457000083, 57.039129950000074],
              [9.72820071700005, 57.04706452000005],
              [9.761241082000083, 57.058579820000034],
              [9.809092644000089, 57.05174388200004],
              [9.91578209700009, 57.058579820000034],
              [9.856618686000047, 57.08869049700007],
              [9.826670769000089, 57.09487539300005],
              [9.80640709700009, 57.10423411700003],
              [9.795664910000085, 57.10639069200005],
              [9.787608269000089, 57.103949286000045],
              [9.752452019000089, 57.077785549000055],
              [9.733246290000068, 57.06679922100005],
              [9.711924675000091, 57.06126536700003],
              [9.693207227000073, 57.06915924700007],
              [9.67514082100007, 57.07916901200008],
              [9.656097852000073, 57.07636139500005],
              [9.621104363000086, 57.058579820000034],
              [9.580821160000085, 57.04930247600004],
              [9.493988477000073, 57.04857005400004],
              [9.265147332000083, 57.00340403900003],
              [9.245371941000087, 57.00234609600005],
              [9.226410352000073, 57.007025458000044],
              [9.114512566000087, 57.058579820000034],
              [9.12086022200009, 57.04539622600004],
              [9.112803582000083, 57.03864166900007],
              [9.07984459700009, 57.031236070000034],
              [9.055430535000085, 57.021144924000055],
              [9.04265384200005, 57.01772695500006],
              [9.025726759000065, 57.017564195000034],
              [9.031993035000085, 57.02383047100005],
              [9.014008009000065, 57.030178127000056],
              [8.996755405000044, 57.02806224200003],
              [8.979665561000047, 57.02049388200004],
              [8.963145379000082, 57.010199286000045],
              [8.94695071700005, 57.01117584800005],
              [8.926442905000044, 57.00014883000006],
              [8.909027540000068, 56.98818594000005],
              [8.901621941000087, 56.98627350500004],
              [8.893077019000089, 56.999660549000055],
              [8.873220248000052, 57.00482819200005],
              [8.850433790000068, 57.00348541900007],
              [8.83334394600007, 56.99713776200008],
              [8.847992384000065, 56.98847077000005],
              [8.811696811000047, 56.96987539300005],
              [8.762054884000065, 56.95547109600005],
              [8.726410352000073, 56.96124909100007],
              [8.702972852000073, 56.95844147300005],
              [8.679535352000073, 56.95254140800006],
              [8.668793165000068, 56.945298570000034],
              [8.663340691000087, 56.92593008000006],
              [8.649912957000083, 56.914129950000074],
              [8.63412519600007, 56.905178127000056],
              [8.621104363000086, 56.89411041900007],
              [8.615407748000052, 56.86562734600005],
              [8.614268425000091, 56.863348700000074],
              [8.612559441000087, 56.854681708000044],
              [8.607920769000089, 56.849676825000074],
              [8.60132897200009, 56.84552643400008],
              [8.569590691000087, 56.818426825000074],
              [8.547048373000052, 56.81732819200005],
              [8.536306186000047, 56.814520575000074],
              [8.531748894000089, 56.80878327000005],
              [8.524261915000068, 56.804754950000074],
              [8.507823113000086, 56.80109284100007],
              [8.491384311000047, 56.794256903000075],
              [8.483897332000083, 56.78115469000005],
              [8.492442254000082, 56.747259833000044],
              [8.491465691000087, 56.73139069200005],
              [8.476410352000073, 56.72215403900003],
              [8.476410352000073, 56.71596914300005],
              [8.516368035000085, 56.71820709800005],
              [8.525563998000052, 56.71596914300005],
              [8.533050977000073, 56.70380280200004],
              [8.52702884200005, 56.695298570000034],
              [8.514008009000065, 56.69025299700007],
              [8.500987175000091, 56.688666083000044],
              [8.489268425000091, 56.690741278000075],
              [8.465830925000091, 56.70014069200005],
              [8.45289147200009, 56.702337958000044],
              [8.440928582000083, 56.700384833000044],
              [8.420909050000091, 56.69135163000004],
              [8.408213738000086, 56.688666083000044],
              [8.408213738000086, 56.68121979400007],
              [8.455902540000068, 56.688666083000044],
              [8.470225457000083, 56.68610260600008],
              [8.491221550000091, 56.676988023000035],
              [8.500987175000091, 56.674994208000044],
              [8.571543816000087, 56.69196198100008],
              [8.586273634000065, 56.688666083000044],
              [8.589040561000047, 56.681341864000046],
              [8.586273634000065, 56.66229889500005],
              [8.586273634000065, 56.65387604400007],
              [8.60132897200009, 56.640611070000034],
              [8.608083530000044, 56.63104889500005],
              [8.593272332000083, 56.61635976800005],
              [8.583018425000091, 56.60932038000004],
              [8.569590691000087, 56.60610586100006],
              [8.555430535000085, 56.60488515800006],
              [8.54664147200009, 56.60171133000006],
              [8.547048373000052, 56.59747955900008],
              [8.559580925000091, 56.593003648000035],
              [8.539317254000082, 56.59275950700004],
              [8.51148522200009, 56.60700104400007],
              [8.486989780000044, 56.62531159100007],
              [8.476410352000073, 56.637152411000045],
              [8.467295769000089, 56.652044989000046],
              [8.444834832000083, 56.664048570000034],
              [8.416758660000085, 56.67206452000005],
              [8.391123894000089, 56.674994208000044],
              [8.373383009000065, 56.68024323100008],
              [8.352224155000044, 56.69293854400007],
              [8.332530144000089, 56.70840078300006],
              [8.319509311000047, 56.72215403900003],
              [8.30836022200009, 56.75820547100005],
              [8.302012566000087, 56.763739325000074],
              [8.28842207100007, 56.76634349200003],
              [8.260264519000089, 56.776678778000075],
              [8.243662957000083, 56.777411200000074],
              [8.258067254000082, 56.74054596600007],
              [8.263194207000083, 56.71893952000005],
              [8.260752800000091, 56.70538971600007],
              [8.24586022200009, 56.704006252000056],
              [8.238291863000086, 56.725043036000045],
              [8.236175977000073, 56.771185614000046],
              [8.247894727000073, 56.81244538000004],
              [8.270355665000068, 56.84324778900003],
              [8.449717644000089, 57.003973700000074],
              [8.50359134200005, 57.03465403900003],
              [8.586273634000065, 57.10639069200005],
              [8.618011915000068, 57.12287018400008],
              [8.653819207000083, 57.12250397300005],
              [8.737152540000068, 57.10639069200005],
              [8.783946160000085, 57.104803778000075],
              [8.87435957100007, 57.116115627000056],
              [8.914561394000089, 57.12742747600004],
              [8.96257571700005, 57.15656159100007],
              [8.980479363000086, 57.161037502000056],
              [9.230642123000052, 57.14109935100004],
              [9.321543816000087, 57.14704010600008],
              [9.412119988000086, 57.16543203300006],
              [9.49781334700009, 57.19700755400004],
              [9.573252800000091, 57.24290599200003],
              [9.78842207100007, 57.45929596600007],
              [9.826426629000082, 57.489935614000046],
              [9.895355665000068, 57.53156159100007],
              [9.929860873000052, 57.56745026200008],
              [9.94312584700009, 57.57249583500004],
              [9.966970248000052, 57.59137604400007],
              [10.01539147200009, 57.59662506700005],
              [10.107676629000082, 57.592962958000044],
              [10.197601759000065, 57.601223049000055],
              [10.279551629000082, 57.62091705900008],
              [10.350596550000091, 57.64899323100008],
              [10.472504102000073, 57.71698639500005],
              [10.539073113000086, 57.743841864000046],
              [10.56609134200005, 57.74945709800005],
              [10.596039259000065, 57.751166083000044],
              [10.625010613000086, 57.74750397300005],
              [10.648936394000089, 57.73700592700004],
              [10.594411655000044, 57.725897528000075],
              [10.542491082000083, 57.698919989000046],
              [10.460459832000083, 57.630560614000046],
              [10.430430535000085, 57.57054271000004],
              [10.45834394600007, 57.525458075000074],
              [10.508962436000047, 57.484035549000055],
              [10.54656009200005, 57.43528880400004],
              [10.517425977000073, 57.39130280200004],
              [10.517914259000065, 57.339178778000075],
              [10.539073113000086, 57.23672109600005],
              [10.521983269000089, 57.22174713700008],
              [10.470876498000052, 57.201157945000034],
              [10.446787957000083, 57.184881903000075],
              [10.41146894600007, 57.14443594000005],
              [10.395518425000091, 57.117254950000074],
              [10.384043816000087, 57.074204820000034],
              [10.359222852000073, 57.02610911700003],
              [10.347178582000083, 57.010199286000045],
              [10.338715040000068, 57.003241278000075],
              [10.330577019000089, 56.999335028000075],
              [10.31967207100007, 56.99750397300005],
              [10.272471550000091, 56.99787018400008],
              [10.257985873000052, 56.99583567900004],
              [10.239756707000083, 56.99282461100006],
              [10.15601647200009, 57.02383047100005],
              [10.094004754000082, 57.06049225500004],
              [10.052744988000086, 57.06972890800006],
              [10.019379102000073, 57.08844635600008],
              [9.994639519000089, 57.09271881700005],
              [9.974457227000073, 57.08649323100008],
              [9.946136915000068, 57.06118398600006],
              [9.926931186000047, 57.058579820000034],
              [9.945485873000052, 57.05731842700004],
              [9.96656334700009, 57.07221100500004],
              [9.98414147200009, 57.07904694200005],
              [10.001963738000086, 57.08388906500005],
              [10.022634311000047, 57.07908763200004],
              [10.121267123000052, 57.02212148600006],
              [10.15398196700005, 57.01325104400007],
              [10.192393425000091, 56.99404531500005],
              [10.214366082000083, 56.98969147300005],
              [10.295095248000052, 56.98859284100007],
              [10.313731316000087, 56.982855536000045],
              [10.285655144000089, 56.96369049700007],
              [10.279551629000082, 56.955511786000045],
              [10.27475019600007, 56.942287502000056],
              [10.26929772200009, 56.91502513200004],
              [10.265879754000082, 56.90770091400003],
              [10.27312259200005, 56.89134349200003],
              [10.284027540000068, 56.84031810100004],
              [10.288340691000087, 56.800116278000075],
              [10.295420769000089, 56.77887604400007],
              [10.31999759200005, 56.73647695500006],
              [10.328461134000065, 56.729803778000075],
              [10.338226759000065, 56.723944403000075],
              [10.340586785000085, 56.71735260600008],
              [10.326833530000044, 56.70856354400007],
              [10.318695509000065, 56.708238023000035],
              [10.295176629000082, 56.71430084800005],
              [10.28256269600007, 56.71596914300005],
              [10.237559441000087, 56.71596914300005],
              [10.221853061000047, 56.712103583000044],
              [10.203868035000085, 56.702337958000044],
              [10.187022332000083, 56.712225653000075],
              [10.168142123000052, 56.720038153000075],
              [10.146494988000086, 56.722357489000046],
              [10.121267123000052, 56.71596914300005],
              [10.09896894600007, 56.70612213700008],
              [10.08961022200009, 56.70404694200005],
              [10.073496941000087, 56.702337958000044],
              [10.05836022200009, 56.69822825700004],
              [10.027517123000052, 56.68427155200004],
              [9.990896030000044, 56.676947333000044],
              [9.945567254000082, 56.65814850500004],
              [9.805918816000087, 56.64704010600008],
              [9.805918816000087, 56.64020416900007],
              [9.85132897200009, 56.63572825700004],
              [10.001475457000083, 56.661322333000044],
              [10.03492272200009, 56.67283763200004],
              [10.049571160000085, 56.674994208000044],
              [10.052907748000052, 56.67715078300006],
              [10.053477410000085, 56.68183014500005],
              [10.055430535000085, 56.68650950700004],
              [10.062836134000065, 56.688666083000044],
              [10.070974155000044, 56.687486070000034],
              [10.084320509000065, 56.68235911700003],
              [10.090586785000085, 56.68121979400007],
              [10.10132897200009, 56.68268463700008],
              [10.113617384000065, 56.686712958000044],
              [10.123789910000085, 56.69232819200005],
              [10.128103061000047, 56.698879299000055],
              [10.134776238000086, 56.71238841400003],
              [10.150563998000052, 56.71442291900007],
              [10.18336022200009, 56.70856354400007],
              [10.180837436000047, 56.70490143400008],
              [10.175791863000086, 56.69546133000006],
              [10.193207227000073, 56.69358958500004],
              [10.24195397200009, 56.688381252000056],
              [10.283539259000065, 56.68976471600007],
              [10.31031334700009, 56.698879299000055],
              [10.334239129000082, 56.70384349200003],
              [10.352793816000087, 56.68183014500005],
              [10.357676629000082, 56.64874909100007],
              [10.340342644000089, 56.620347398000035],
              [10.272959832000083, 56.59170156500005],
              [10.223317905000044, 56.560614325000074],
              [10.214366082000083, 56.558294989000046],
              [10.207286004000082, 56.52578359600005],
              [10.203868035000085, 56.51666901200008],
              [10.211436394000089, 56.50531647300005],
              [10.20679772200009, 56.49095286700003],
              [10.195485873000052, 56.47768789300005],
              [10.18336022200009, 56.46954987200007],
              [10.214121941000087, 56.47044505400004],
              [10.225596550000091, 56.47573476800005],
              [10.22437584700009, 56.51361725500004],
              [10.227549675000091, 56.541083075000074],
              [10.23764082100007, 56.554388739000046],
              [10.279551629000082, 56.571966864000046],
              [10.312673373000052, 56.59662506700005],
              [10.330332879000082, 56.603216864000046],
              [10.35092207100007, 56.59589264500005],
              [10.354502800000091, 56.589544989000046],
              [10.359873894000089, 56.56810130400004],
              [10.360850457000083, 56.561712958000044],
              [10.365244988000086, 56.55841705900008],
              [10.394867384000065, 56.54466380400004],
              [10.469899936000047, 56.52090078300006],
              [10.551524285000085, 56.51557038000004],
              [10.789073113000086, 56.536363023000035],
              [10.822276238000086, 56.53424713700008],
              [10.854991082000083, 56.52415599200003],
              [10.869883660000085, 56.51471588700008],
              [10.90211022200009, 56.48322174700007],
              [10.964121941000087, 56.448431708000044],
              [10.964121941000087, 56.44220612200007],
              [10.940928582000083, 56.42951080900008],
              [10.928477410000085, 56.40648021000004],
              [10.92351321700005, 56.37986888200004],
              [10.922618035000085, 56.35626862200007],
              [10.911631707000083, 56.334051825000074],
              [10.819590691000087, 56.260931708000044],
              [10.772959832000083, 56.24298737200007],
              [10.755381707000083, 56.22931549700007],
              [10.750010613000086, 56.216050523000035],
              [10.752614780000044, 56.18496328300006],
              [10.738617384000065, 56.15452708500004],
              [10.707041863000086, 56.15086497600004],
              [10.672211134000065, 56.16518789300005],
              [10.648936394000089, 56.188381252000056],
              [10.674652540000068, 56.19082265800006],
              [10.68523196700005, 56.19623444200005],
              [10.690440300000091, 56.20888906500005],
              [10.687673373000052, 56.22223541900007],
              [10.677582227000073, 56.22630442900004],
              [10.664561394000089, 56.22760651200008],
              [10.652598504000082, 56.23273346600007],
              [10.62859134200005, 56.237534898000035],
              [10.603770379000082, 56.22101471600007],
              [10.581228061000047, 56.199204820000034],
              [10.549164259000065, 56.17820872600004],
              [10.556162957000083, 56.15493398600006],
              [10.569346550000091, 56.12946198100008],
              [10.573741082000083, 56.112616278000075],
              [10.563975457000083, 56.10561758000006],
              [10.548024936000047, 56.101263739000046],
              [10.53101647200009, 56.10016510600008],
              [10.518565300000091, 56.102728583000044],
              [10.508474155000044, 56.111029364000046],
              [10.498545769000089, 56.130194403000075],
              [10.491221550000091, 56.139960028000075],
              [10.499196811000047, 56.14472077000005],
              [10.516123894000089, 56.151597398000035],
              [10.525401238000086, 56.153631903000075],
              [10.518239780000044, 56.16478099200003],
              [10.50945071700005, 56.17011139500005],
              [10.46810957100007, 56.177069403000075],
              [10.458994988000086, 56.17609284100007],
              [10.436696811000047, 56.16791413000004],
              [10.408702019000089, 56.16486237200007],
              [10.391449415000068, 56.17267487200007],
              [10.376231316000087, 56.18667226800005],
              [10.354665561000047, 56.202053127000056],
              [10.376963738000086, 56.20331452000005],
              [10.410411004000082, 56.21849192900004],
              [10.429209832000083, 56.22247955900008],
              [10.443369988000086, 56.21662018400008],
              [10.46070397200009, 56.20620351800005],
              [10.477793816000087, 56.202337958000044],
              [10.491221550000091, 56.21629466400003],
              [10.47429446700005, 56.23224518400008],
              [10.475433790000068, 56.24469635600008],
              [10.504730665000068, 56.277777411000045],
              [10.491221550000091, 56.27765534100007],
              [10.476817254000082, 56.280910549000055],
              [10.463633660000085, 56.28685130400004],
              [10.453623894000089, 56.29450104400007],
              [10.442637566000087, 56.29865143400008],
              [10.416758660000085, 56.291896877000056],
              [10.403005405000044, 56.29824453300006],
              [10.399261915000068, 56.284857489000046],
              [10.393809441000087, 56.27651601800005],
              [10.385020379000082, 56.27216217700004],
              [10.371104363000086, 56.27094147300005],
              [10.363780144000089, 56.26557038000004],
              [10.336924675000091, 56.23273346600007],
              [10.312510613000086, 56.21515534100007],
              [10.258474155000044, 56.19025299700007],
              [10.234222852000073, 56.17133209800005],
              [10.220225457000083, 56.14789459800005],
              [10.226898634000065, 56.133246161000045],
              [10.243418816000087, 56.119574286000045],
              [10.259043816000087, 56.09902578300006],
              [10.265635613000086, 56.07371653900003],
              [10.26148522200009, 56.05442942900004],
              [10.249196811000047, 56.03693268400008],
              [10.231130405000044, 56.01703522300005],
              [10.255137566000087, 56.02362702000005],
              [10.272715691000087, 56.02484772300005],
              [10.277517123000052, 56.01776764500005],
              [10.252452019000089, 55.98623281500005],
              [10.250010613000086, 55.97345612200007],
              [10.25163821700005, 55.94818756700005],
              [10.250743035000085, 55.93073151200008],
              [10.249278191000087, 55.923041083000044],
              [10.245371941000087, 55.91461823100008],
              [10.221364780000044, 55.896918036000045],
              [10.217539910000085, 55.889837958000044],
              [10.21265709700009, 55.889878648000035],
              [10.201833530000044, 55.88589101800005],
              [10.190196160000085, 55.87970612200007],
              [10.18336022200009, 55.87372467700004],
              [10.188324415000068, 55.871161200000074],
              [10.195567254000082, 55.861314195000034],
              [10.199392123000052, 55.85073476800005],
              [10.190603061000047, 55.84349192900004],
              [10.187347852000073, 55.83860911700003],
              [10.182139519000089, 55.833685614000046],
              [10.172699415000068, 55.83148834800005],
              [10.160411004000082, 55.833319403000075],
              [10.151052280000044, 55.83812083500004],
              [10.135508660000085, 55.851996161000045],
              [10.131032748000052, 55.85846588700008],
              [10.128103061000047, 55.86587148600006],
              [10.123789910000085, 55.87327708500004],
              [10.114512566000087, 55.87986888200004],
              [10.101817254000082, 55.88239166900007],
              [10.004649285000085, 55.87986888200004],
              [9.991709832000083, 55.87734609600005],
              [9.983653191000087, 55.87140534100007],
              [9.977386915000068, 55.864569403000075],
              [9.97046959700009, 55.859442450000074],
              [9.944509311000047, 55.853583075000074],
              [9.891774936000047, 55.85537344000005],
              [9.867442254000082, 55.851996161000045],
              [9.892588738000086, 55.83624909100007],
              [10.035655144000089, 55.818426825000074],
              [10.045746290000068, 55.81395091400003],
              [10.042165561000047, 55.80341217700004],
              [10.025645379000082, 55.78302643400008],
              [10.01734459700009, 55.76557038000004],
              [10.019786004000082, 55.757879950000074],
              [10.033702019000089, 55.75604889500005],
              [10.059825066000087, 55.75641510600008],
              [10.059825066000087, 55.74949778900003],
              [10.018809441000087, 55.73627350500004],
              [10.006846550000091, 55.725043036000045],
              [10.018239780000044, 55.70856354400007],
              [10.014496290000068, 55.70685455900008],
              [10.00521894600007, 55.70111725500004],
              [9.981700066000087, 55.709418036000045],
              [9.871836785000085, 55.69122955900008],
              [9.821787957000083, 55.67597077000005],
              [9.792246941000087, 55.67446523600006],
              [9.730967644000089, 55.68813711100006],
              [9.695648634000065, 55.70579661700003],
              [9.686534050000091, 55.70856354400007],
              [9.583018425000091, 55.70888906500005],
              [9.559580925000091, 55.71539948100008],
              [9.55640709700009, 55.71157461100006],
              [9.554535352000073, 55.70880768400008],
              [9.553477410000085, 55.70579661700003],
              [9.552744988000086, 55.70111725500004],
              [9.57357832100007, 55.69546133000006],
              [9.645518425000091, 55.69489166900007],
              [9.658539259000065, 55.69037506700005],
              [9.71029707100007, 55.660142320000034],
              [9.720957879000082, 55.64826080900008],
              [9.72820071700005, 55.63751862200007],
              [9.738291863000086, 55.62970612200007],
              [9.758148634000065, 55.626654364000046],
              [9.853770379000082, 55.626654364000046],
              [9.837412957000083, 55.615220445000034],
              [9.785492384000065, 55.59194570500006],
              [9.757660352000073, 55.571600653000075],
              [9.744151238000086, 55.56635163000004],
              [9.720876498000052, 55.56460195500006],
              [9.712412957000083, 55.56028880400004],
              [9.71062259200005, 55.55093008000006],
              [9.71029707100007, 55.54157135600008],
              [9.706879102000073, 55.53729889500005],
              [9.64389082100007, 55.52830638200004],
              [9.621104363000086, 55.51894765800006],
              [9.607269727000073, 55.516791083000044],
              [9.595225457000083, 55.51837799700007],
              [9.572764519000089, 55.52391185100004],
              [9.559580925000091, 55.52362702000005],
              [9.56218509200005, 55.519517320000034],
              [9.566416863000086, 55.516791083000044],
              [9.551931186000047, 55.505113023000035],
              [9.514903191000087, 55.49819570500006],
              [9.498057488000086, 55.489447333000044],
              [9.515635613000086, 55.48314036700003],
              [9.534434441000087, 55.48383209800005],
              [9.58366946700005, 55.49115631700005],
              [9.592784050000091, 55.49428945500006],
              [9.602386915000068, 55.495794989000046],
              [9.660166863000086, 55.47797272300005],
              [9.664235873000052, 55.46670156500005],
              [9.65992272200009, 55.45302969000005],
              [9.648936394000089, 55.441066799000055],
              [9.635264519000089, 55.43573639500005],
              [9.601410352000073, 55.43183014500005],
              [9.586761915000068, 55.427435614000046],
              [9.592051629000082, 55.41632721600007],
              [9.604340040000068, 55.40119049700007],
              [9.607920769000089, 55.39325592700004],
              [9.60515384200005, 55.382025458000044],
              [9.59929446700005, 55.37335846600007],
              [9.600840691000087, 55.36591217700004],
              [9.621104363000086, 55.35854726800005],
              [9.633474155000044, 55.351996161000045],
              [9.645274285000085, 55.34271881700005],
              [9.648285352000073, 55.332912502000056],
              [9.634613477000073, 55.32501862200007],
              [9.634613477000073, 55.317572333000044],
              [9.644867384000065, 55.31093984600005],
              [9.681895379000082, 55.274644273000035],
              [9.694183790000068, 55.27163320500006],
              [9.706065300000091, 55.26508209800005],
              [9.71029707100007, 55.24868398600006],
              [9.706553582000083, 55.23700592700004],
              [9.699473504000082, 55.229803778000075],
              [9.692881707000083, 55.22101471600007],
              [9.689789259000065, 55.20490143400008],
              [9.684418165000068, 55.19757721600007],
              [9.67156009200005, 55.19245026200008],
              [9.655772332000083, 55.189439195000034],
              [9.642100457000083, 55.18842194200005],
              [9.58334394600007, 55.194647528000075],
              [9.569834832000083, 55.19253164300005],
              [9.561534050000091, 55.187201239000046],
              [9.554942254000082, 55.180568752000056],
              [9.545909050000091, 55.17413971600007],
              [9.521820509000065, 55.16543203300006],
              [9.50717207100007, 55.16193268400008],
              [9.494395379000082, 55.16054922100005],
              [9.486338738000086, 55.156236070000034],
              [9.486338738000086, 55.14740631700005],
              [9.494639519000089, 55.14008209800005],
              [9.511892123000052, 55.14008209800005],
              [9.511892123000052, 55.13320547100005],
              [9.482432488000086, 55.13377513200004],
              [9.468760613000086, 55.13178131700005],
              [9.456553582000083, 55.12571849200003],
              [9.466644727000073, 55.12140534100007],
              [9.479177280000044, 55.11969635600008],
              [9.508067254000082, 55.11953359600005],
              [9.521332227000073, 55.11587148600006],
              [9.535817905000044, 55.10687897300005],
              [9.559580925000091, 55.08539459800005],
              [9.533702019000089, 55.06582265800006],
              [9.516612175000091, 55.05654531500005],
              [9.498057488000086, 55.05068594000005],
              [9.452403191000087, 55.045355536000045],
              [9.434336785000085, 55.037543036000045],
              [9.442881707000083, 55.02338288000004],
              [9.455251498000052, 55.02317942900004],
              [9.511892123000052, 55.036363023000035],
              [9.537364129000082, 55.03538646000004],
              [9.545909050000091, 55.036363023000035],
              [9.553233269000089, 55.03961823100008],
              [9.56023196700005, 55.04441966400003],
              [9.568532748000052, 55.04877350500004],
              [9.579925977000073, 55.05068594000005],
              [9.601573113000086, 55.04539622600004],
              [9.641856316000087, 55.01972077000005],
              [9.662608269000089, 55.00971100500004],
              [9.717539910000085, 55.001166083000044],
              [9.730967644000089, 54.995428778000075],
              [9.738617384000065, 54.98086172100005],
              [9.760752800000091, 54.90497467700004],
              [9.763194207000083, 54.900458075000074],
              [9.761566602000073, 54.89740631700005],
              [9.751963738000086, 54.893011786000045],
              [9.737071160000085, 54.89276764500005],
              [9.722992384000065, 54.897650458000044],
              [9.711436394000089, 54.89858633000006],
              [9.703461134000065, 54.88617584800005],
              [9.715993686000047, 54.88377513200004],
              [9.72787519600007, 54.87946198100008],
              [9.737803582000083, 54.87352122600004],
              [9.744476759000065, 54.86627838700008],
              [9.748301629000082, 54.857855536000045],
              [9.750254754000082, 54.84625885600008],
              [9.745941602000073, 54.836004950000074],
              [9.731211785000085, 54.83152903900003],
              [9.719574415000068, 54.83584219000005],
              [9.705332879000082, 54.85455963700008],
              [9.69662519600007, 54.85887278900003],
              [9.655039910000085, 54.857082424000055],
              [9.642100457000083, 54.85887278900003],
              [9.623301629000082, 54.865301825000074],
              [9.62468509200005, 54.86928945500006],
              [9.632823113000086, 54.873114325000074],
              [9.634613477000073, 54.879339911000045],
              [9.61695397200009, 54.894232489000046],
              [9.610362175000091, 54.903225002000056],
              [9.617523634000065, 54.90729401200008],
              [9.64421634200005, 54.913275458000044],
              [9.638845248000052, 54.92475006700005],
              [9.61500084700009, 54.93268463700008],
              [9.586761915000068, 54.927720445000034],
              [9.581228061000047, 54.92177969000005],
              [9.56804446700005, 54.90143463700008],
              [9.556813998000052, 54.890326239000046],
              [9.55054772200009, 54.88271719000005],
              [9.545909050000091, 54.879339911000045],
              [9.538340691000087, 54.87791575700004],
              [9.522146030000044, 54.87929922100005],
              [9.515147332000083, 54.87592194200005],
              [9.498057488000086, 54.86432526200008],
              [9.45639082100007, 54.843817450000074],
              [9.442881707000083, 54.83152903900003],
              [9.436289910000085, 54.81045156500005],
              [9.437503027053964, 54.81041112738269],
              [9.436922241000048, 54.81014394200007],
              [9.42214278100002, 54.80725006100009],
              [9.405192911000114, 54.80838694300009],
              [9.385039103000054, 54.81939402300007],
              [9.366952352000112, 54.817016907000024],
              [9.35599694800004, 54.81133249900007],
              [9.341734253000084, 54.80905873600007],
              [9.332019084000137, 54.803219300000094],
              [9.317032918000052, 54.80161733000004],
              [9.244065796000143, 54.8017723600001],
              [9.226392456000042, 54.805906474000025],
              [9.219054403000143, 54.81779205400004],
              [9.216057169000123, 54.831744690000036],
              [9.211509644000103, 54.84182159400008],
              [9.194766480000055, 54.85039988200002],
              [8.982686401000109, 54.879338684000075],
              [8.904138224000064, 54.89794220000003],
              [8.82424645900008, 54.90590037000008],
              [8.80088871200013, 54.90383331400004],
              [8.732779175000104, 54.88905385400001],
              [8.695882202000092, 54.88998402900005],
              [8.660775934000071, 54.89631115600007],
            ],
          ],
          [
            [
              [11.845225457000083, 54.73191966400003],
              [11.833832227000073, 54.72455475500004],
              [11.82357832100007, 54.72211334800005],
              [11.814707879000082, 54.71869538000004],
              [11.806976759000065, 54.70799388200004],
              [11.846446160000085, 54.69782135600008],
              [11.842621290000068, 54.676214911000045],
              [11.810720248000052, 54.65509674700007],
              [11.766123894000089, 54.646551825000074],
              [11.610524936000047, 54.66640859600005],
              [11.560069207000083, 54.65961334800005],
              [11.512217644000089, 54.646551825000074],
              [11.47437584700009, 54.62612539300005],
              [11.451833530000044, 54.62836334800005],
              [11.35873457100007, 54.66054922100005],
              [11.297699415000068, 54.69155508000006],
              [11.187754754000082, 54.73224518400008],
              [11.138194207000083, 54.73859284100007],
              [11.084646030000044, 54.753119208000044],
              [11.030528191000087, 54.760646877000056],
              [11.009287957000083, 54.77163320500006],
              [10.999196811000047, 54.786769924000055],
              [11.005707227000073, 54.80365631700005],
              [11.030772332000083, 54.812160549000055],
              [11.061289910000085, 54.80931224200003],
              [11.089691602000073, 54.810614325000074],
              [11.108164910000085, 54.83152903900003],
              [11.091970248000052, 54.83502838700008],
              [11.078379754000082, 54.841131903000075],
              [11.025238477000073, 54.87946198100008],
              [11.018809441000087, 54.88617584800005],
              [11.018809441000087, 54.90338776200008],
              [11.032399936000047, 54.919256903000075],
              [11.07398522200009, 54.94818756700005],
              [11.088145379000082, 54.94415924700007],
              [11.231700066000087, 54.96124909100007],
              [11.256032748000052, 54.95457591400003],
              [11.303477410000085, 54.93244049700007],
              [11.321055535000085, 54.927720445000034],
              [11.338877800000091, 54.919134833000044],
              [11.36890709700009, 54.88108958500004],
              [11.392751498000052, 54.87250397300005],
              [11.416758660000085, 54.86933014500005],
              [11.594737175000091, 54.81110260600008],
              [11.585134311000047, 54.82851797100005],
              [11.57357832100007, 54.83934153900003],
              [11.572764519000089, 54.84796784100007],
              [11.594737175000091, 54.85887278900003],
              [11.622080925000091, 54.85887278900003],
              [11.646332227000073, 54.86538320500006],
              [11.656260613000086, 54.86627838700008],
              [11.647227410000085, 54.87714264500005],
              [11.644786004000082, 54.88963450700004],
              [11.646332227000073, 54.90228913000004],
              [11.649424675000091, 54.91351959800005],
              [11.725759311000047, 54.87335846600007],
              [11.731944207000083, 54.85887278900003],
              [11.75562584700009, 54.841131903000075],
              [11.770681186000047, 54.83429596600007],
              [11.787282748000052, 54.83152903900003],
              [11.777191602000073, 54.82599518400008],
              [11.772959832000083, 54.82469310100004],
              [11.787608269000089, 54.80687083500004],
              [11.837738477000073, 54.78278229400007],
              [11.848643425000091, 54.77317942900004],
              [11.85132897200009, 54.75682200700004],
              [11.855479363000086, 54.74945709800005],
              [11.855479363000086, 54.74359772300005],
              [11.845225457000083, 54.73191966400003],
            ],
          ],
          [
            [
              [10.450205925000091, 54.89980703300006],
              [10.466644727000073, 54.89057038000004],
              [10.48568769600007, 54.883693752000056],
              [10.499196811000047, 54.87457916900007],
              [10.498708530000044, 54.85887278900003],
              [10.508148634000065, 54.85492584800005],
              [10.518565300000091, 54.851996161000045],
              [10.440114780000044, 54.841498114000046],
              [10.418630405000044, 54.827826239000046],
              [10.406260613000086, 54.82469310100004],
              [10.383474155000044, 54.83075592700004],
              [10.211436394000089, 54.93935781500005],
              [10.195160352000073, 54.96185944200005],
              [10.18921959700009, 54.97748444200005],
              [10.203868035000085, 54.968085028000075],
              [10.28874759200005, 54.940741278000075],
              [10.313731316000087, 54.927720445000034],
              [10.33725019600007, 54.905910549000055],
              [10.349619988000086, 54.89671458500004],
              [10.364268425000091, 54.893011786000045],
              [10.379405144000089, 54.89305247600004],
              [10.391368035000085, 54.89545319200005],
              [10.39584394600007, 54.90346914300005],
              [10.388845248000052, 54.92031484600005],
              [10.403086785000085, 54.90839264500005],
              [10.415212436000047, 54.87848541900007],
              [10.426036004000082, 54.87250397300005],
              [10.446787957000083, 54.872381903000075],
              [10.460948113000086, 54.87449778900003],
              [10.463633660000085, 54.882473049000055],
              [10.450205925000091, 54.89980703300006],
            ],
          ],
          [
            [
              [12.417165561000047, 55.03021881700005],
              [12.504730665000068, 55.01976146000004],
              [12.537608269000089, 55.002386786000045],
              [12.553721550000091, 54.968085028000075],
              [12.551768425000091, 54.95718008000006],
              [12.54265384200005, 54.951157945000034],
              [12.526215040000068, 54.94867584800005],
              [12.502777540000068, 54.94818756700005],
              [12.384613477000073, 54.96308014500005],
              [12.348399285000085, 54.96002838700008],
              [12.313975457000083, 54.950873114000046],
              [12.280039910000085, 54.93455638200004],
              [12.226817254000082, 54.892645575000074],
              [12.207774285000085, 54.88617584800005],
              [12.178721550000091, 54.88898346600007],
              [12.11500084700009, 54.90729401200008],
              [12.11500084700009, 54.91351959800005],
              [12.129161004000082, 54.91351959800005],
              [12.12468509200005, 54.92373281500005],
              [12.128916863000086, 54.931626695000034],
              [12.138194207000083, 54.93724192900004],
              [12.149099155000044, 54.94082265800006],
              [12.144053582000083, 54.943793036000045],
              [12.13453209700009, 54.951605536000045],
              [12.129161004000082, 54.954413153000075],
              [12.151377800000091, 54.96889883000006],
              [12.164398634000065, 54.972642320000034],
              [12.177012566000087, 54.968085028000075],
              [12.184336785000085, 54.97553131700005],
              [12.177012566000087, 54.98920319200005],
              [12.19312584700009, 54.988348700000074],
              [12.217295769000089, 54.97866445500006],
              [12.23218834700009, 54.97553131700005],
              [12.242198113000086, 54.976629950000074],
              [12.27475019600007, 54.984442450000074],
              [12.28687584700009, 54.98920319200005],
              [12.281504754000082, 54.99909088700008],
              [12.281260613000086, 55.007147528000075],
              [12.285655144000089, 55.01312897300005],
              [12.294200066000087, 55.01654694200005],
              [12.294200066000087, 55.02338288000004],
              [12.261566602000073, 55.036810614000046],
              [12.252696160000085, 55.043850002000056],
              [12.247569207000083, 55.05385976800005],
              [12.250987175000091, 55.06073639500005],
              [12.261973504000082, 55.06427643400008],
              [12.280039910000085, 55.06427643400008],
              [12.301768425000091, 55.04205963700008],
              [12.33529707100007, 55.033270575000074],
              [12.417165561000047, 55.03021881700005],
            ],
          ],
          [
            [
              [10.01140384200005, 54.97553131700005],
              [10.025889519000089, 54.95978424700007],
              [10.065114780000044, 54.89081452000005],
              [10.064463738000086, 54.88100820500006],
              [10.05046634200005, 54.87885163000004],
              [10.021983269000089, 54.879339911000045],
              [10.007090691000087, 54.87482330900008],
              [9.987559441000087, 54.86591217700004],
              [9.968028191000087, 54.85952383000006],
              [9.953623894000089, 54.862616278000075],
              [9.93718509200005, 54.87091705900008],
              [9.891123894000089, 54.87929922100005],
              [9.874278191000087, 54.88617584800005],
              [9.874278191000087, 54.893011786000045],
              [9.900889519000089, 54.90070221600007],
              [9.932302280000044, 54.89280833500004],
              [9.963877800000091, 54.87995026200008],
              [9.99154707100007, 54.87250397300005],
              [9.99154707100007, 54.879339911000045],
              [9.943695509000065, 54.903631903000075],
              [9.898285352000073, 54.912990627000056],
              [9.887950066000087, 54.91351959800005],
              [9.877940300000091, 54.911322333000044],
              [9.863536004000082, 54.90306224200003],
              [9.853770379000082, 54.89980703300006],
              [9.814707879000082, 54.90106842700004],
              [9.78093509200005, 54.91681549700007],
              [9.761241082000083, 54.943060614000046],
              [9.764414910000085, 54.97553131700005],
              [9.758148634000065, 54.97553131700005],
              [9.758148634000065, 54.981756903000075],
              [9.780284050000091, 54.97284577000005],
              [9.80404707100007, 54.95718008000006],
              [9.827403191000087, 54.94546133000006],
              [9.847504102000073, 54.94818756700005],
              [9.843272332000083, 54.95172760600008],
              [9.836680535000085, 54.95856354400007],
              [9.832774285000085, 54.96515534100007],
              [9.836680535000085, 54.968085028000075],
              [9.842133009000065, 54.97028229400007],
              [9.835215691000087, 54.97516510600008],
              [9.793711785000085, 54.992173570000034],
              [9.78679446700005, 55.00014883000006],
              [9.799082879000082, 55.00971100500004],
              [9.799082879000082, 55.01654694200005],
              [9.720550977000073, 55.01227448100008],
              [9.706879102000073, 55.01312897300005],
              [9.69695071700005, 55.01752350500004],
              [9.684825066000087, 55.01854075700004],
              [9.674164259000065, 55.02106354400007],
              [9.668793165000068, 55.03021881700005],
              [9.672373894000089, 55.03465403900003],
              [9.691254102000073, 55.04279205900008],
              [9.69662519600007, 55.05068594000005],
              [9.678233269000089, 55.05019765800006],
              [9.661631707000083, 55.046535549000055],
              [9.645518425000091, 55.04486725500004],
              [9.628428582000083, 55.05068594000005],
              [9.628428582000083, 55.05805084800005],
              [9.716644727000073, 55.08222077000005],
              [9.751963738000086, 55.08539459800005],
              [9.793467644000089, 55.08075592700004],
              [9.853037957000083, 55.04010651200008],
              [9.884776238000086, 55.03021881700005],
              [9.92904707100007, 55.02619049700007],
              [9.960948113000086, 55.01504140800006],
              [9.986582879000082, 54.997748114000046],
              [10.01140384200005, 54.97553131700005],
            ],
          ],
          [
            [
              [10.854991082000083, 55.043850002000056],
              [10.861989780000044, 55.07208893400008],
              [10.895518425000091, 55.121527411000045],
              [10.934255405000044, 55.15965403900003],
              [10.95671634200005, 55.15371328300006],
              [10.908946160000085, 55.03021881700005],
              [10.889903191000087, 54.997381903000075],
              [10.837738477000073, 54.93724192900004],
              [10.741058790000068, 54.752386786000045],
              [10.731293165000068, 54.74005768400008],
              [10.717539910000085, 54.73578522300005],
              [10.693858269000089, 54.73529694200005],
              [10.681895379000082, 54.74481842700004],
              [10.656423373000052, 54.80365631700005],
              [10.645518425000091, 54.81460195500006],
              [10.632090691000087, 54.823431708000044],
              [10.601084832000083, 54.838324286000045],
              [10.625336134000065, 54.83930084800005],
              [10.640879754000082, 54.84320709800005],
              [10.653493686000047, 54.851629950000074],
              [10.66928144600007, 54.86627838700008],
              [10.678558790000068, 54.88304271000004],
              [10.684418165000068, 54.88784414300005],
              [10.693858269000089, 54.88275788000004],
              [10.69890384200005, 54.88117096600007],
              [10.724457227000073, 54.88617584800005],
              [10.722178582000083, 54.89606354400007],
              [10.717784050000091, 54.90729401200008],
              [10.708994988000086, 54.90298086100006],
              [10.700368686000047, 54.901556708000044],
              [10.691905144000089, 54.90298086100006],
              [10.68295332100007, 54.90729401200008],
              [10.69703209700009, 54.931341864000046],
              [10.718272332000083, 54.94916413000004],
              [10.774099155000044, 54.98655833500004],
              [10.79818769600007, 54.99656810100004],
              [10.854991082000083, 55.043850002000056],
            ],
          ],
          [
            [
              [15.151377800000091, 55.13320547100005],
              [15.146657748000052, 55.128241278000075],
              [15.144541863000086, 55.12482330900008],
              [15.14234459700009, 55.12213776200008],
              [15.137705925000091, 55.11953359600005],
              [15.145030144000089, 55.10488515800006],
              [15.147715691000087, 55.09560781500005],
              [15.144704623000052, 55.087103583000044],
              [15.134287957000083, 55.07485586100006],
              [15.112803582000083, 55.05463288000004],
              [15.106618686000047, 55.04466380400004],
              [15.110362175000091, 55.036363023000035],
              [15.110362175000091, 55.03021881700005],
              [15.113242231000072, 55.01829487400005],
              [15.097353257000066, 55.00782296300008],
              [15.086685936000038, 54.999213378000036],
              [15.07266622600008, 54.99163800600007],
              [15.023663842000076, 54.99933929400004],
              [14.982869819000086, 55.00101340800006],
              [14.92726517400007, 55.013691882000046],
              [14.858606616000088, 55.038226353000084],
              [14.780832726000085, 55.05112832700007],
              [14.699554884000065, 55.089178778000075],
              [14.684172687000057, 55.10134680800007],
              [14.697044746000074, 55.12265371400008],
              [14.701426629000082, 55.16469961100006],
              [14.705739780000044, 55.22565338700008],
              [14.709239129000082, 55.23582591400003],
              [14.717539910000085, 55.24677155200004],
              [14.737071160000085, 55.26666901200008],
              [14.745127800000091, 55.28156159100007],
              [14.752126498000052, 55.29877350500004],
              [14.760915561000047, 55.30927155200004],
              [14.774587436000047, 55.303900458000044],
              [14.814952019000089, 55.270412502000056],
              [14.828949415000068, 55.261704820000034],
              [14.851422204000073, 55.24819985100004],
              [14.889008009000065, 55.23322174700007],
              [14.92679910000004, 55.21579873500008],
              [14.954354434000038, 55.21925441700006],
              [14.973399285000085, 55.216131903000075],
              [14.989756707000083, 55.19603099200003],
              [15.000498894000089, 55.18842194200005],
              [15.012868686000047, 55.18382396000004],
              [15.084542879000082, 55.15457949600005],
              [15.131602410000085, 55.14545319200005],
              [15.151377800000091, 55.13320547100005],
            ],
          ],
          [
            [
              [8.476410352000073, 55.34544505400004],
              [8.451670769000089, 55.33974844000005],
              [8.425303582000083, 55.355536200000074],
              [8.402354363000086, 55.38003164300005],
              [8.370941602000073, 55.427435614000046],
              [8.364268425000091, 55.44904205900008],
              [8.37435957100007, 55.46328359600005],
              [8.408213738000086, 55.468410549000055],
              [8.411957227000073, 55.438706773000035],
              [8.428558790000068, 55.43353913000004],
              [8.44890384200005, 55.435532945000034],
              [8.463389519000089, 55.427435614000046],
              [8.463063998000052, 55.415716864000046],
              [8.450205925000091, 55.39337799700007],
              [8.45289147200009, 55.38336823100008],
              [8.460459832000083, 55.372381903000075],
              [8.467458530000044, 55.35370514500005],
              [8.476410352000073, 55.34544505400004],
            ],
          ],
          [
            [
              [10.666270379000082, 55.06427643400008],
              [10.621429884000065, 55.06427643400008],
              [10.604746941000087, 55.062567450000074],
              [10.586110873000052, 55.057521877000056],
              [10.568858269000089, 55.04987213700008],
              [10.55640709700009, 55.04010651200008],
              [10.538259311000047, 55.029730536000045],
              [10.516856316000087, 55.031317450000074],
              [10.477549675000091, 55.043850002000056],
              [10.410655144000089, 55.046942450000074],
              [10.388845248000052, 55.05068594000005],
              [10.379161004000082, 55.05451080900008],
              [10.371348504000082, 55.059027411000045],
              [10.362559441000087, 55.06273021000004],
              [10.35092207100007, 55.06427643400008],
              [10.32593834700009, 55.06289297100005],
              [10.312754754000082, 55.063666083000044],
              [10.234222852000073, 55.092230536000045],
              [10.205251498000052, 55.09369538000004],
              [10.197601759000065, 55.08608633000006],
              [10.19703209700009, 55.06427643400008],
              [10.181895379000082, 55.07086823100008],
              [10.158376498000052, 55.08665599200003],
              [10.141774936000047, 55.092230536000045],
              [10.121267123000052, 55.09247467700004],
              [10.083506707000083, 55.08698151200008],
              [10.065928582000083, 55.092230536000045],
              [10.142588738000086, 55.12579987200007],
              [10.15601647200009, 55.14008209800005],
              [10.138682488000086, 55.154282945000034],
              [10.126149936000047, 55.17064036700003],
              [10.11296634200005, 55.18378327000005],
              [10.094004754000082, 55.18842194200005],
              [10.078949415000068, 55.18593984600005],
              [10.067556186000047, 55.18227773600006],
              [10.055837436000047, 55.179754950000074],
              [10.039317254000082, 55.180975653000075],
              [10.016612175000091, 55.19428131700005],
              [10.00359134200005, 55.197333075000074],
              [9.99154707100007, 55.18842194200005],
              [9.994476759000065, 55.17279694200005],
              [10.029144727000073, 55.14240143400008],
              [10.025645379000082, 55.12571849200003],
              [10.020681186000047, 55.12445709800005],
              [9.985524936000047, 55.12775299700007],
              [9.982920769000089, 55.13060130400004],
              [9.984385613000086, 55.13467031500005],
              [9.98414147200009, 55.14008209800005],
              [9.986989780000044, 55.13934967700004],
              [9.989756707000083, 55.14337799700007],
              [9.988780144000089, 55.15184153900003],
              [9.97429446700005, 55.17401764500005],
              [9.97201582100007, 55.18471914300005],
              [9.97429446700005, 55.19525788000004],
              [9.980723504000082, 55.20490143400008],
              [9.979502800000091, 55.21283600500004],
              [9.964121941000087, 55.21816640800006],
              [9.924001498000052, 55.223944403000075],
              [9.911387566000087, 55.228501695000034],
              [9.90015709700009, 55.23411692900004],
              [9.895355665000068, 55.23899974200003],
              [9.893239780000044, 55.24445221600007],
              [9.883962436000047, 55.25348541900007],
              [9.881683790000068, 55.25950755400004],
              [9.883962436000047, 55.265611070000034],
              [9.893239780000044, 55.274644273000035],
              [9.895355665000068, 55.28025950700004],
              [9.893239780000044, 55.29124583500004],
              [9.883962436000047, 55.30878327000005],
              [9.881683790000068, 55.314439195000034],
              [9.884776238000086, 55.348863023000035],
              [9.874522332000083, 55.35333893400008],
              [9.858897332000083, 55.35407135600008],
              [9.82984459700009, 55.35228099200003],
              [9.816579623000052, 55.35521067900004],
              [9.80241946700005, 55.36237213700008],
              [9.778086785000085, 55.38027578300006],
              [9.794932488000086, 55.38385651200008],
              [9.813649936000047, 55.38515859600005],
              [9.830088738000086, 55.38890208500004],
              [9.840098504000082, 55.400091864000046],
              [9.785492384000065, 55.413763739000046],
              [9.793711785000085, 55.41278717700004],
              [9.819590691000087, 55.413763739000046],
              [9.809255405000044, 55.425482489000046],
              [9.791026238000086, 55.43183014500005],
              [9.75131269600007, 55.434881903000075],
              [9.737315300000091, 55.43817780200004],
              [9.703461134000065, 55.462144273000035],
              [9.703461134000065, 55.468410549000055],
              [9.73023522200009, 55.46149323100008],
              [9.758474155000044, 55.44749583500004],
              [9.786306186000047, 55.437201239000046],
              [9.81218509200005, 55.441066799000055],
              [9.713389519000089, 55.49103424700007],
              [9.676280144000089, 55.49567291900007],
              [9.683929884000065, 55.50604889500005],
              [9.693532748000052, 55.510199286000045],
              [9.70476321700005, 55.51239655200004],
              [9.717784050000091, 55.516791083000044],
              [9.755137566000087, 55.544134833000044],
              [9.809092644000089, 55.55027903900003],
              [9.827403191000087, 55.54840729400007],
              [9.830821160000085, 55.54311758000006],
              [9.831309441000087, 55.53473541900007],
              [9.840098504000082, 55.52362702000005],
              [9.888194207000083, 55.508693752000056],
              [9.940277540000068, 55.519232489000046],
              [10.039317254000082, 55.55776601800005],
              [10.168630405000044, 55.58226146000004],
              [10.21265709700009, 55.60065338700008],
              [10.237315300000091, 55.605536200000074],
              [10.264170769000089, 55.606634833000044],
              [10.272146030000044, 55.605536200000074],
              [10.27279707100007, 55.60252513200004],
              [10.27906334700009, 55.588324286000045],
              [10.279551629000082, 55.58510976800005],
              [10.293630405000044, 55.58808014500005],
              [10.297129754000082, 55.59564850500004],
              [10.293793165000068, 55.616115627000056],
              [10.307627800000091, 55.61823151200008],
              [10.338389519000089, 55.61009349200003],
              [10.407399936000047, 55.58295319200005],
              [10.423024936000047, 55.57200755400004],
              [10.435394727000073, 55.55971914300005],
              [10.444183790000068, 55.553168036000045],
              [10.453623894000089, 55.55027903900003],
              [10.471934441000087, 55.54901764500005],
              [10.488536004000082, 55.54547760600008],
              [10.518809441000087, 55.53343333500004],
              [10.502452019000089, 55.537176825000074],
              [10.486827019000089, 55.537176825000074],
              [10.475271030000044, 55.53196849200003],
              [10.470713738000086, 55.52020905200004],
              [10.47437584700009, 55.51581452000005],
              [10.489105665000068, 55.509100653000075],
              [10.491221550000091, 55.503119208000044],
              [10.48601321700005, 55.49477773600006],
              [10.477793816000087, 55.49249909100007],
              [10.467784050000091, 55.49213288000004],
              [10.457041863000086, 55.489447333000044],
              [10.41960696700005, 55.45880768400008],
              [10.436045769000089, 55.44212474200003],
              [10.471527540000068, 55.443060614000046],
              [10.491221550000091, 55.465277411000045],
              [10.502452019000089, 55.46356842700004],
              [10.566905144000089, 55.48265208500004],
              [10.604746941000087, 55.489447333000044],
              [10.60914147200009, 55.49258047100005],
              [10.60718834700009, 55.49941640800006],
              [10.602305535000085, 55.50625234600005],
              [10.597666863000086, 55.50934479400007],
              [10.588715040000068, 55.51068756700005],
              [10.579112175000091, 55.514105536000045],
              [10.571055535000085, 55.51870351800005],
              [10.566905144000089, 55.52362702000005],
              [10.569834832000083, 55.532416083000044],
              [10.582286004000082, 55.52912018400008],
              [10.595550977000073, 55.52138906500005],
              [10.601084832000083, 55.516791083000044],
              [10.613780144000089, 55.52789948100008],
              [10.610524936000047, 55.54364655200004],
              [10.600840691000087, 55.56122467700004],
              [10.594248894000089, 55.57827383000006],
              [10.599131707000083, 55.57367584800005],
              [10.61459394600007, 55.56460195500006],
              [10.61500084700009, 55.58144765800006],
              [10.608409050000091, 55.60626862200007],
              [10.608571811000047, 55.612982489000046],
              [10.627614780000044, 55.61359284100007],
              [10.656911655000044, 55.59487539300005],
              [10.704112175000091, 55.55027903900003],
              [10.706065300000091, 55.54389069200005],
              [10.707041863000086, 55.53497955900008],
              [10.709239129000082, 55.527044989000046],
              [10.714366082000083, 55.52362702000005],
              [10.716807488000086, 55.52142975500004],
              [10.738129102000073, 55.50934479400007],
              [10.744476759000065, 55.49555084800005],
              [10.742360873000052, 55.487494208000044],
              [10.733083530000044, 55.48187897300005],
              [10.703949415000068, 55.471136786000045],
              [10.657481316000087, 55.45970286700003],
              [10.588389519000089, 55.46336497600004],
              [10.571299675000091, 55.46124909100007],
              [10.559418165000068, 55.45530833500004],
              [10.55404707100007, 55.442572333000044],
              [10.563324415000068, 55.43622467700004],
              [10.57943769600007, 55.43585846600007],
              [10.594248894000089, 55.441066799000055],
              [10.58961022200009, 55.44623444200005],
              [10.588552280000044, 55.44940827000005],
              [10.595957879000082, 55.45966217700004],
              [10.615733269000089, 55.45685455900008],
              [10.68295332100007, 55.44790273600006],
              [10.697927280000044, 55.44025299700007],
              [10.79664147200009, 55.35854726800005],
              [10.803070509000065, 55.34975820500006],
              [10.828379754000082, 55.30658600500004],
              [10.834320509000065, 55.290269273000035],
              [10.826914910000085, 55.290269273000035],
              [10.815114780000044, 55.300848700000074],
              [10.796885613000086, 55.30768463700008],
              [10.780284050000091, 55.30491771000004],
              [10.772959832000083, 55.287095445000034],
              [10.77865644600007, 55.27484772300005],
              [10.805349155000044, 55.250433661000045],
              [10.813324415000068, 55.235581773000035],
              [10.815196160000085, 55.214056708000044],
              [10.812673373000052, 55.19428131700005],
              [10.80600019600007, 55.177394924000055],
              [10.79078209700009, 55.15692780200004],
              [10.787852410000085, 55.14948151200008],
              [10.786631707000083, 55.12946198100008],
              [10.783376498000052, 55.124212958000044],
              [10.758799675000091, 55.10529205900008],
              [10.74935957100007, 55.093085028000075],
              [10.742686394000089, 55.081691799000055],
              [10.733653191000087, 55.07184479400007],
              [10.717784050000091, 55.06427643400008],
              [10.705577019000089, 55.062567450000074],
              [10.666270379000082, 55.06427643400008],
            ],
          ],
          [
            [
              [12.615733269000089, 55.68813711100006],
              [12.673838738000086, 55.605536200000074],
              [12.674571160000085, 55.601263739000046],
              [12.639414910000085, 55.57827383000006],
              [12.624196811000047, 55.57562897300005],
              [12.605723504000082, 55.56928131700005],
              [12.588877800000091, 55.56134674700007],
              [12.577972852000073, 55.554022528000075],
              [12.55632571700005, 55.550482489000046],
              [12.53484134200005, 55.56932200700004],
              [12.520518425000091, 55.59674713700008],
              [12.520192905000044, 55.619208075000074],
              [12.53101647200009, 55.63190338700008],
              [12.543955925000091, 55.64036692900004],
              [12.556813998000052, 55.64695872600004],
              [12.567393425000091, 55.653998114000046],
              [12.578135613000086, 55.666449286000045],
              [12.59506269600007, 55.69135163000004],
              [12.608409050000091, 55.70111725500004],
              [12.612559441000087, 55.69513580900008],
              [12.614105665000068, 55.69245026200008],
              [12.615733269000089, 55.68813711100006],
            ],
          ],
          [
            [
              [10.559418165000068, 55.86627838700008],
              [10.573090040000068, 55.87885163000004],
              [10.581065300000091, 55.894517320000034],
              [10.580251498000052, 55.91152578300006],
              [10.566905144000089, 55.92829010600008],
              [10.54859459700009, 55.93573639500005],
              [10.528330925000091, 55.940619208000044],
              [10.51539147200009, 55.951239325000074],
              [10.518565300000091, 55.97614166900007],
              [10.528819207000083, 55.98920319200005],
              [10.543955925000091, 55.99799225500004],
              [10.556813998000052, 55.995794989000046],
              [10.56421959700009, 55.95384349200003],
              [10.580251498000052, 55.93650950700004],
              [10.602793816000087, 55.92523834800005],
              [10.62826582100007, 55.92084381700005],
              [10.619395379000082, 55.91095612200007],
              [10.615407748000052, 55.90033600500004],
              [10.616384311000047, 55.88979726800005],
              [10.621429884000065, 55.87986888200004],
              [10.638682488000086, 55.866115627000056],
              [10.650645379000082, 55.87010325700004],
              [10.659190300000091, 55.88076406500005],
              [10.666270379000082, 55.886704820000034],
              [10.66928144600007, 55.88003164300005],
              [10.655039910000085, 55.86538320500006],
              [10.62826582100007, 55.845770575000074],
              [10.623301629000082, 55.82770416900007],
              [10.62435957100007, 55.79433828300006],
              [10.61459394600007, 55.77684153900003],
              [10.582204623000052, 55.759751695000034],
              [10.547129754000082, 55.76520416900007],
              [10.520274285000085, 55.78856028900003],
              [10.511566602000073, 55.82526276200008],
              [10.51726321700005, 55.84552643400008],
              [10.527679884000065, 55.85390859600005],
              [10.542165561000047, 55.85814036700003],
              [10.559418165000068, 55.86627838700008],
            ],
          ],
          [
            [
              [12.04037519600007, 54.893011786000045],
              [12.058929884000065, 54.89435455900008],
              [12.078298373000052, 54.89785390800006],
              [12.096446160000085, 54.898098049000055],
              [12.111827019000089, 54.88959381700005],
              [12.139903191000087, 54.864935614000046],
              [12.170176629000082, 54.84454987200007],
              [12.170176629000082, 54.838324286000045],
              [12.08171634200005, 54.79645416900007],
              [12.067149285000085, 54.786810614000046],
              [12.028005405000044, 54.74355703300006],
              [12.022715691000087, 54.73529694200005],
              [12.012705925000091, 54.73110586100006],
              [11.985850457000083, 54.71230703300006],
              [11.975271030000044, 54.70799388200004],
              [11.96070397200009, 54.69407786700003],
              [11.960215691000087, 54.66233958500004],
              [11.971446160000085, 54.60561758000006],
              [11.969004754000082, 54.56976959800005],
              [11.949066602000073, 54.56858958500004],
              [11.928233269000089, 54.583970445000034],
              [11.923675977000073, 54.59813060100004],
              [11.909353061000047, 54.60952383000006],
              [11.87663821700005, 54.64695872600004],
              [11.869151238000086, 54.65961334800005],
              [11.870616082000083, 54.68036530200004],
              [11.882660352000073, 54.69643789300005],
              [11.910166863000086, 54.72166575700004],
              [11.889903191000087, 54.72418854400007],
              [11.875824415000068, 54.729722398000035],
              [11.872325066000087, 54.739935614000046],
              [11.882823113000086, 54.75641510600008],
              [11.871429884000065, 54.76032135600008],
              [11.865244988000086, 54.76544830900008],
              [11.855479363000086, 54.77692291900007],
              [11.809092644000089, 54.80491771000004],
              [11.805430535000085, 54.80951569200005],
              [11.800954623000052, 54.81785716400003],
              [11.798838738000086, 54.825873114000046],
              [11.800059441000087, 54.83120351800005],
              [11.799815300000091, 54.83657461100006],
              [11.793467644000089, 54.84454987200007],
              [11.776052280000044, 54.85614655200004],
              [11.760590040000068, 54.86322663000004],
              [11.74968509200005, 54.873114325000074],
              [11.745616082000083, 54.893011786000045],
              [11.745371941000087, 54.911322333000044],
              [11.742035352000073, 54.925441799000055],
              [11.731944207000083, 54.93528880400004],
              [11.711436394000089, 54.94082265800006],
              [11.711436394000089, 54.94818756700005],
              [11.74976647200009, 54.965725002000056],
              [11.759287957000083, 54.968085028000075],
              [11.773610873000052, 54.96503327000005],
              [11.792979363000086, 54.95132070500006],
              [11.803965691000087, 54.94818756700005],
              [11.814789259000065, 54.95209381700005],
              [11.83757571700005, 54.966131903000075],
              [11.841807488000086, 54.96466705900008],
              [11.848317905000044, 54.95913320500006],
              [11.862478061000047, 54.96369049700007],
              [11.882823113000086, 54.97553131700005],
              [11.882823113000086, 54.981756903000075],
              [11.872325066000087, 54.989569403000075],
              [11.853526238000086, 55.02008698100008],
              [11.841807488000086, 55.03021881700005],
              [11.774668816000087, 55.04857005400004],
              [11.75562584700009, 55.05068594000005],
              [11.750254754000082, 55.052801825000074],
              [11.736989780000044, 55.062201239000046],
              [11.728770379000082, 55.06427643400008],
              [11.665537957000083, 55.066392320000034],
              [11.646657748000052, 55.072333075000074],
              [11.630381707000083, 55.08112213700008],
              [11.615896030000044, 55.092230536000045],
              [11.66960696700005, 55.085638739000046],
              [11.775238477000073, 55.05744049700007],
              [11.82748457100007, 55.05068594000005],
              [11.805349155000044, 55.073879299000055],
              [11.743418816000087, 55.10053131700005],
              [11.717621290000068, 55.12571849200003],
              [11.803965691000087, 55.134833075000074],
              [11.809580925000091, 55.13886139500005],
              [11.806976759000065, 55.14687734600005],
              [11.785411004000082, 55.15721263200004],
              [11.728526238000086, 55.15477122600004],
              [11.711436394000089, 55.16791413000004],
              [11.72624759200005, 55.176947333000044],
              [11.734711134000065, 55.188666083000044],
              [11.733083530000044, 55.20014069200005],
              [11.717621290000068, 55.208319403000075],
              [11.69507897200009, 55.20807526200008],
              [11.678233269000089, 55.19936758000006],
              [11.66382897200009, 55.18829987200007],
              [11.649424675000091, 55.180975653000075],
              [11.636241082000083, 55.181626695000034],
              [11.59937584700009, 55.19131094000005],
              [11.524180535000085, 55.20209381700005],
              [11.506032748000052, 55.208319403000075],
              [11.492360873000052, 55.20416901200008],
              [11.42318769600007, 55.221909898000035],
              [11.410329623000052, 55.22011953300006],
              [11.382985873000052, 55.21116771000004],
              [11.36890709700009, 55.208319403000075],
              [11.299978061000047, 55.208319403000075],
              [11.299978061000047, 55.20148346600007],
              [11.320485873000052, 55.194647528000075],
              [11.285899285000085, 55.195379950000074],
              [11.260996941000087, 55.20058828300006],
              [11.245371941000087, 55.21478913000004],
              [11.238536004000082, 55.24241771000004],
              [11.253103061000047, 55.23627350500004],
              [11.267832879000082, 55.23590729400007],
              [11.280039910000085, 55.24233633000006],
              [11.286306186000047, 55.25608958500004],
              [11.276052280000044, 55.251613674000055],
              [11.26539147200009, 55.24945709800005],
              [11.24195397200009, 55.24868398600006],
              [11.238780144000089, 55.25413646000004],
              [11.24154707100007, 55.278509833000044],
              [11.235118035000085, 55.28400299700007],
              [11.217133009000065, 55.290228583000044],
              [11.162119988000086, 55.31915924700007],
              [11.152842644000089, 55.32843659100007],
              [11.161957227000073, 55.33087799700007],
              [11.176442905000044, 55.33185455900008],
              [11.188243035000085, 55.335272528000075],
              [11.190114780000044, 55.34544505400004],
              [11.182302280000044, 55.35040924700007],
              [11.167979363000086, 55.352769273000035],
              [11.152598504000082, 55.353216864000046],
              [11.14234459700009, 55.35228099200003],
              [11.135427280000044, 55.346869208000044],
              [11.130869988000086, 55.33844635600008],
              [11.123545769000089, 55.33185455900008],
              [11.108164910000085, 55.33185455900008],
              [11.101898634000065, 55.33633047100005],
              [11.087738477000073, 55.35854726800005],
              [11.087738477000073, 55.36595286700003],
              [11.11459394600007, 55.36440664300005],
              [11.128916863000086, 55.36517975500004],
              [11.138926629000082, 55.36937083500004],
              [11.147715691000087, 55.37592194200005],
              [11.159190300000091, 55.381293036000045],
              [11.171722852000073, 55.38507721600007],
              [11.18327884200005, 55.386419989000046],
              [11.204356316000087, 55.391831773000035],
              [11.21420332100007, 55.40379466400003],
              [11.213145379000082, 55.41575755400004],
              [11.20093834700009, 55.421210028000075],
              [11.20484459700009, 55.431341864000046],
              [11.196462436000047, 55.45384349200003],
              [11.176442905000044, 55.489447333000044],
              [11.163910352000073, 55.50189850500004],
              [11.151133660000085, 55.51032135600008],
              [11.135590040000068, 55.51512278900003],
              [11.11500084700009, 55.516791083000044],
              [11.097178582000083, 55.50950755400004],
              [11.085785352000073, 55.50755442900004],
              [11.080902540000068, 55.51308828300006],
              [11.082774285000085, 55.526556708000044],
              [11.088552280000044, 55.53384023600006],
              [11.098155144000089, 55.53668854400007],
              [11.111582879000082, 55.53729889500005],
              [11.137950066000087, 55.54291413000004],
              [11.148448113000086, 55.55731842700004],
              [11.145681186000047, 55.57611725500004],
              [11.132090691000087, 55.59528229400007],
              [11.087901238000086, 55.626939195000034],
              [11.039235873000052, 55.643459377000056],
              [10.929942254000082, 55.660142320000034],
              [10.929942254000082, 55.667629299000055],
              [11.087738477000073, 55.660142320000034],
              [11.071055535000085, 55.676947333000044],
              [11.008636915000068, 55.692287502000056],
              [10.984629754000082, 55.70111725500004],
              [10.97429446700005, 55.71084219000005],
              [10.968272332000083, 55.718410549000055],
              [10.960215691000087, 55.72435130400004],
              [10.943614129000082, 55.72907135600008],
              [10.891449415000068, 55.73126862200007],
              [10.875498894000089, 55.73651764500005],
              [10.875498894000089, 55.74274323100008],
              [11.033050977000073, 55.72907135600008],
              [11.065684441000087, 55.73224518400008],
              [11.128184441000087, 55.74632396000004],
              [11.162771030000044, 55.74949778900003],
              [11.162771030000044, 55.74274323100008],
              [11.15170332100007, 55.74363841400003],
              [11.141123894000089, 55.74323151200008],
              [11.130869988000086, 55.74103424700007],
              [11.121836785000085, 55.73651764500005],
              [11.137543165000068, 55.71906159100007],
              [11.16342207100007, 55.70538971600007],
              [11.192637566000087, 55.70034414300005],
              [11.218028191000087, 55.70856354400007],
              [11.176442905000044, 55.72907135600008],
              [11.190114780000044, 55.73651764500005],
              [11.199473504000082, 55.73110586100006],
              [11.21615644600007, 55.72874583500004],
              [11.252207879000082, 55.72907135600008],
              [11.268402540000068, 55.73273346600007],
              [11.30241946700005, 55.746527411000045],
              [11.336680535000085, 55.75092194200005],
              [11.352224155000044, 55.75580475500004],
              [11.364024285000085, 55.76512278900003],
              [11.36890709700009, 55.77997467700004],
              [11.369965040000068, 55.78778717700004],
              [11.37468509200005, 55.80158112200007],
              [11.375661655000044, 55.807928778000075],
              [11.372080925000091, 55.81586334800005],
              [11.354665561000047, 55.83022695500006],
              [11.348399285000085, 55.838324286000045],
              [11.373871290000068, 55.82876211100006],
              [11.398448113000086, 55.82640208500004],
              [11.421722852000073, 55.83197663000004],
              [11.443369988000086, 55.845770575000074],
              [11.477549675000091, 55.84153880400004],
              [11.50521894600007, 55.86871979400007],
              [11.510508660000085, 55.908270575000074],
              [11.477386915000068, 55.94135163000004],
              [11.448415561000047, 55.94818756700005],
              [11.384287957000083, 55.950832424000055],
              [11.304535352000073, 55.96784088700008],
              [11.281911655000044, 55.978949286000045],
              [11.272634311000047, 55.99656810100004],
              [11.400563998000052, 55.96198151200008],
              [11.426931186000047, 55.96552155200004],
              [11.581065300000091, 55.95184967700004],
              [11.59937584700009, 55.94208405200004],
              [11.640879754000082, 55.943426825000074],
              [11.711436394000089, 55.95563385600008],
              [11.74781334700009, 55.96824778900003],
              [11.768321160000085, 55.97052643400008],
              [11.779795769000089, 55.96185944200005],
              [11.775401238000086, 55.95184967700004],
              [11.747325066000087, 55.932806708000044],
              [11.738780144000089, 55.92084381700005],
              [11.750498894000089, 55.91038646000004],
              [11.743988477000073, 55.90375397300005],
              [11.72787519600007, 55.90228913000004],
              [11.711436394000089, 55.90717194200005],
              [11.713552280000044, 55.91083405200004],
              [11.717621290000068, 55.92084381700005],
              [11.685801629000082, 55.91986725500004],
              [11.672862175000091, 55.91592031500005],
              [11.663096550000091, 55.90717194200005],
              [11.71265709700009, 55.85809967700004],
              [11.731618686000047, 55.83071523600006],
              [11.717621290000068, 55.810980536000045],
              [11.702403191000087, 55.809475002000056],
              [11.67123457100007, 55.81427643400008],
              [11.656260613000086, 55.810980536000045],
              [11.637950066000087, 55.796087958000044],
              [11.626231316000087, 55.79059479400007],
              [11.607758009000065, 55.79047272300005],
              [11.607758009000065, 55.78302643400008],
              [11.624278191000087, 55.78001536700003],
              [11.67359459700009, 55.78302643400008],
              [11.687022332000083, 55.786444403000075],
              [11.70281009200005, 55.793402411000045],
              [11.72038821700005, 55.79865143400008],
              [11.738780144000089, 55.79734935100004],
              [11.74545332100007, 55.78937409100007],
              [11.755869988000086, 55.77293528900003],
              [11.763682488000086, 55.75682200700004],
              [11.762705925000091, 55.74949778900003],
              [11.682302280000044, 55.74127838700008],
              [11.664561394000089, 55.73712799700007],
              [11.657237175000091, 55.73086172100005],
              [11.669932488000086, 55.72284577000005],
              [11.684336785000085, 55.72162506700005],
              [11.729258660000085, 55.72357819200005],
              [11.738780144000089, 55.72597890800006],
              [11.746348504000082, 55.73102448100008],
              [11.76303144600007, 55.72138092700004],
              [11.787282748000052, 55.70111725500004],
              [11.794444207000083, 55.687933661000045],
              [11.793793165000068, 55.68301015800006],
              [11.787933790000068, 55.676947333000044],
              [11.779795769000089, 55.660142320000034],
              [11.797618035000085, 55.669623114000046],
              [11.810557488000086, 55.67910390800006],
              [11.852305535000085, 55.730902411000045],
              [11.854421420000051, 55.73216380400004],
              [11.855479363000086, 55.73281484600005],
              [11.85328209700009, 55.73997630400004],
              [11.844004754000082, 55.75267161700003],
              [11.841807488000086, 55.75641510600008],
              [11.844981316000087, 55.76788971600007],
              [11.852712436000047, 55.78229401200008],
              [11.869151238000086, 55.804754950000074],
              [11.884043816000087, 55.813666083000044],
              [11.919444207000083, 55.81940338700008],
              [11.937347852000073, 55.82526276200008],
              [11.953623894000089, 55.853501695000034],
              [11.933116082000083, 55.88613515800006],
              [11.90951582100007, 55.91547272300005],
              [11.916840040000068, 55.93451569200005],
              [11.934743686000047, 55.933661200000074],
              [11.969981316000087, 55.91258372600004],
              [11.988617384000065, 55.90717194200005],
              [11.998220248000052, 55.90281810100004],
              [11.997894727000073, 55.89276764500005],
              [11.99382571700005, 55.88153717700004],
              [11.992035352000073, 55.87372467700004],
              [11.996348504000082, 55.86107005400004],
              [12.000173373000052, 55.85651276200008],
              [12.004893425000091, 55.85346100500004],
              [12.012461785000085, 55.845770575000074],
              [12.031260613000086, 55.81659577000005],
              [12.049001498000052, 55.77533600500004],
              [12.051931186000047, 55.73663971600007],
              [12.026133660000085, 55.71539948100008],
              [11.99000084700009, 55.72280508000006],
              [11.972666863000086, 55.72142161700003],
              [11.965342644000089, 55.70490143400008],
              [11.958181186000047, 55.693426825000074],
              [11.923024936000047, 55.67413971600007],
              [11.910166863000086, 55.660142320000034],
              [11.930430535000085, 55.65761953300006],
              [11.959157748000052, 55.66510651200008],
              [11.98218834700009, 55.678900458000044],
              [11.985199415000068, 55.69489166900007],
              [12.001149936000047, 55.69867584800005],
              [12.017588738000086, 55.69570547100005],
              [12.031911655000044, 55.687201239000046],
              [12.04037519600007, 55.67446523600006],
              [12.009287957000083, 55.68048737200007],
              [12.005137566000087, 55.678168036000045],
              [12.01140384200005, 55.66901276200008],
              [12.026621941000087, 55.66205475500004],
              [12.06031334700009, 55.653998114000046],
              [12.069102410000085, 55.67495351800005],
              [12.092051629000082, 55.706732489000046],
              [12.09506269600007, 55.72907135600008],
              [12.053477410000085, 55.838324286000045],
              [12.053477410000085, 55.87372467700004],
              [12.049815300000091, 55.888006903000075],
              [12.026133660000085, 55.94135163000004],
              [12.010590040000068, 55.95526764500005],
              [11.992442254000082, 55.960598049000055],
              [11.970713738000086, 55.959865627000056],
              [11.89429772200009, 55.942287502000056],
              [11.865489129000082, 55.93935781500005],
              [11.848643425000091, 55.94818756700005],
              [11.865570509000065, 55.972723700000074],
              [11.91732832100007, 55.99762604400007],
              [12.012461785000085, 56.03070709800005],
              [12.16537519600007, 56.10370514500005],
              [12.245127800000091, 56.12872955900008],
              [12.328461134000065, 56.12689850500004],
              [12.414886915000068, 56.09902578300006],
              [12.48609459700009, 56.09902578300006],
              [12.505381707000083, 56.09316640800006],
              [12.54037519600007, 56.075384833000044],
              [12.57007897200009, 56.06826406500005],
              [12.621918165000068, 56.04376862200007],
              [12.608409050000091, 56.02802155200004],
              [12.567393425000091, 55.99656810100004],
              [12.552744988000086, 55.979681708000044],
              [12.525563998000052, 55.939886786000045],
              [12.512705925000091, 55.92829010600008],
              [12.512705925000091, 55.92084381700005],
              [12.540293816000087, 55.89826080900008],
              [12.55445397200009, 55.882879950000074],
              [12.560557488000086, 55.86994049700007],
              [12.565114780000044, 55.85114166900007],
              [12.576019727000073, 55.82916901200008],
              [12.589691602000073, 55.809475002000056],
              [12.602224155000044, 55.79734935100004],
              [12.597992384000065, 55.78758372600004],
              [12.595876498000052, 55.77423737200007],
              [12.594737175000091, 55.75299713700008],
              [12.589040561000047, 55.73574453300006],
              [12.587901238000086, 55.72907135600008],
              [12.58920332100007, 55.724269924000055],
              [12.592784050000091, 55.71914297100005],
              [12.602224155000044, 55.70856354400007],
              [12.581228061000047, 55.693060614000046],
              [12.541026238000086, 55.648871161000045],
              [12.50326582100007, 55.634019273000035],
              [12.496755405000044, 55.62177155200004],
              [12.487152540000068, 55.60984935100004],
              [12.465017123000052, 55.605536200000074],
              [12.44857832100007, 55.60887278900003],
              [12.436778191000087, 55.61440664300005],
              [12.423675977000073, 55.618841864000046],
              [12.403575066000087, 55.619208075000074],
              [12.331309441000087, 55.595404364000046],
              [12.312022332000083, 55.583970445000034],
              [12.248383009000065, 55.54625071800007],
              [12.248220248000052, 55.546128648000035],
              [12.198090040000068, 55.487494208000044],
              [12.224864129000082, 55.434881903000075],
              [12.273448113000086, 55.410223700000074],
              [12.290537957000083, 55.40692780200004],
              [12.352061394000089, 55.40444570500006],
              [12.36882571700005, 55.400091864000046],
              [12.412119988000086, 55.37913646000004],
              [12.434743686000047, 55.36367422100005],
              [12.444590691000087, 55.348863023000035],
              [12.446299675000091, 55.331691799000055],
              [12.45085696700005, 55.31720612200007],
              [12.465017123000052, 55.290269273000035],
              [12.450205925000091, 55.27968984600005],
              [12.444590691000087, 55.276556708000044],
              [12.392425977000073, 55.25531647300005],
              [12.182790561000047, 55.22719961100006],
              [12.167002800000091, 55.21735260600008],
              [12.141368035000085, 55.20799388200004],
              [12.121104363000086, 55.191066799000055],
              [12.10906009200005, 55.17072174700007],
              [12.11500084700009, 55.15371328300006],
              [12.107432488000086, 55.14508698100008],
              [12.09896894600007, 55.14142487200007],
              [12.090098504000082, 55.142238674000055],
              [12.080739780000044, 55.14687734600005],
              [12.088145379000082, 55.16836172100005],
              [12.076670769000089, 55.18195221600007],
              [12.05640709700009, 55.18569570500006],
              [12.03679446700005, 55.17755768400008],
              [12.027842644000089, 55.17267487200007],
              [12.020030144000089, 55.17096588700008],
              [12.014659050000091, 55.16746653900003],
              [12.012461785000085, 55.157131252000056],
              [12.017914259000065, 55.15302155200004],
              [12.04664147200009, 55.14008209800005],
              [12.13054446700005, 55.13589101800005],
              [12.168630405000044, 55.12848541900007],
              [12.177012566000087, 55.10529205900008],
              [12.171397332000083, 55.09544505400004],
              [12.165049675000091, 55.09129466400003],
              [12.157725457000083, 55.089178778000075],
              [12.149099155000044, 55.08539459800005],
              [12.128428582000083, 55.07884349200003],
              [12.11850019600007, 55.073553778000075],
              [12.125743035000085, 55.07111237200007],
              [12.163340691000087, 55.02338288000004],
              [12.162282748000052, 55.00438060100004],
              [12.148936394000089, 54.994126695000034],
              [12.128428582000083, 54.98997630400004],
              [12.104991082000083, 54.98920319200005],
              [12.08952884200005, 54.985663153000075],
              [12.055918816000087, 54.970770575000074],
              [12.03296959700009, 54.968085028000075],
              [11.998057488000086, 54.97650788000004],
              [11.943858269000089, 55.00608958500004],
              [11.910166863000086, 55.00971100500004],
              [11.90951582100007, 55.00495026200008],
              [11.911143425000091, 55.00381094000005],
              [11.91382897200009, 55.00385163000004],
              [11.916840040000068, 55.00287506700005],
              [11.911387566000087, 55.00092194200005],
              [11.908376498000052, 54.99860260600008],
              [11.904633009000065, 54.99656810100004],
              [11.897146030000044, 54.995428778000075],
              [11.901540561000047, 54.97638580900008],
              [11.894379102000073, 54.96499258000006],
              [11.885020379000082, 54.955145575000074],
              [11.882823113000086, 54.94082265800006],
              [11.890147332000083, 54.92963288000004],
              [11.903330925000091, 54.92300039300005],
              [11.918467644000089, 54.921942450000074],
              [11.931162957000083, 54.927720445000034],
              [11.928558790000068, 54.93138255400004],
              [11.923675977000073, 54.94082265800006],
              [11.932383660000085, 54.941473700000074],
              [11.957855665000068, 54.94818756700005],
              [11.965993686000047, 54.942613023000035],
              [11.98023522200009, 54.924261786000045],
              [11.98218834700009, 54.92031484600005],
              [11.991465691000087, 54.91632721600007],
              [12.023936394000089, 54.89801666900007],
              [12.04037519600007, 54.893011786000045],
            ],
          ],
          [
            [
              [11.512217644000089, 56.69546133000006],
              [11.50953209700009, 56.710150458000044],
              [11.52084394600007, 56.71539948100008],
              [11.606130405000044, 56.720404364000046],
              [11.649424675000091, 56.72964101800005],
              [11.649424675000091, 56.72215403900003],
              [11.645192905000044, 56.721991278000075],
              [11.64193769600007, 56.72064850500004],
              [11.635752800000091, 56.71596914300005],
              [11.618011915000068, 56.71133047100005],
              [11.604258660000085, 56.701157945000034],
              [11.592539910000085, 56.68984609600005],
              [11.581065300000091, 56.68121979400007],
              [11.56421959700009, 56.677435614000046],
              [11.543711785000085, 56.67865631700005],
              [11.524587436000047, 56.68471914300005],
              [11.512217644000089, 56.69546133000006],
            ],
          ],
          [
            [
              [8.82585696700005, 56.743841864000046],
              [8.812673373000052, 56.73456452000005],
              [8.77125084700009, 56.71596914300005],
              [8.766123894000089, 56.69871653900003],
              [8.686371290000068, 56.68659088700008],
              [8.658376498000052, 56.67812734600005],
              [8.648448113000086, 56.68105703300006],
              [8.621755405000044, 56.71393463700008],
              [8.610850457000083, 56.72215403900003],
              [8.586273634000065, 56.73647695500006],
              [8.56226647200009, 56.74323151200008],
              [8.555918816000087, 56.743841864000046],
              [8.524912957000083, 56.73729075700004],
              [8.514659050000091, 56.73822663000004],
              [8.518077019000089, 56.750067450000074],
              [8.52279707100007, 56.755072333000044],
              [8.530284050000091, 56.75934479400007],
              [8.539235873000052, 56.76251862200007],
              [8.548675977000073, 56.763739325000074],
              [8.553233269000089, 56.76813385600008],
              [8.551605665000068, 56.777777411000045],
              [8.548024936000047, 56.78725820500006],
              [8.545258009000065, 56.791083075000074],
              [8.573008660000085, 56.80255768400008],
              [8.643809441000087, 56.80805084800005],
              [8.668793165000068, 56.825832424000055],
              [8.656260613000086, 56.82514069200005],
              [8.643809441000087, 56.825873114000046],
              [8.632009311000047, 56.82807038000004],
              [8.621104363000086, 56.832017320000034],
              [8.62671959700009, 56.84153880400004],
              [8.646739129000082, 56.856350002000056],
              [8.655121290000068, 56.866848049000055],
              [8.651866082000083, 56.86603424700007],
              [8.64975019600007, 56.874253648000035],
              [8.648448113000086, 56.890692450000074],
              [8.651621941000087, 56.894191799000055],
              [8.659353061000047, 56.89447663000004],
              [8.668223504000082, 56.893784898000035],
              [8.675059441000087, 56.89411041900007],
              [8.703786655000044, 56.900051174000055],
              [8.762461785000085, 56.90542226800005],
              [8.791758660000085, 56.91453685100004],
              [8.813649936000047, 56.91034577000005],
              [8.83375084700009, 56.92475006700005],
              [8.867442254000082, 56.962958075000074],
              [8.89039147200009, 56.95482005400004],
              [8.905039910000085, 56.966009833000044],
              [8.916270379000082, 56.97907135600008],
              [8.928884311000047, 56.976629950000074],
              [8.923106316000087, 56.96857330900008],
              [8.911387566000087, 56.95612213700008],
              [8.908457879000082, 56.94871653900003],
              [8.910411004000082, 56.94440338700008],
              [8.920420769000089, 56.93048737200007],
              [8.922699415000068, 56.92202383000006],
              [8.920420769000089, 56.919907945000034],
              [8.908457879000082, 56.88727448100008],
              [8.900401238000086, 56.87482330900008],
              [8.895274285000085, 56.870306708000044],
              [8.887950066000087, 56.866848049000055],
              [8.887705925000091, 56.87872955900008],
              [8.882660352000073, 56.886379299000055],
              [8.875010613000086, 56.89109935100004],
              [8.867442254000082, 56.89411041900007],
              [8.843760613000086, 56.88344961100006],
              [8.83961022200009, 56.87982819200005],
              [8.836436394000089, 56.86928945500006],
              [8.839040561000047, 56.86286041900007],
              [8.843597852000073, 56.85822174700007],
              [8.84701582100007, 56.85309479400007],
              [8.85515384200005, 56.81976959800005],
              [8.863942905000044, 56.80951569200005],
              [8.881114129000082, 56.80536530200004],
              [8.87476647200009, 56.80036041900007],
              [8.868418816000087, 56.798081773000035],
              [8.861338738000086, 56.79755280200004],
              [8.85328209700009, 56.79783763200004],
              [8.86068769600007, 56.794907945000034],
              [8.867442254000082, 56.791083075000074],
              [8.854177280000044, 56.77993398600006],
              [8.839121941000087, 56.75726959800005],
              [8.82585696700005, 56.743841864000046],
            ],
          ],
          [
            [
              [11.14234459700009, 57.33234284100007],
              [11.169932488000086, 57.33270905200004],
              [11.181488477000073, 57.33030833500004],
              [11.190114780000044, 57.325506903000075],
              [11.197276238000086, 57.313381252000056],
              [11.196501696000041, 57.30282119300006],
              [11.189113397000085, 57.29428264200004],
              [11.166875953000044, 57.29677506300004],
              [11.143231237000066, 57.30135121400008],
              [11.066579623000052, 57.29132721600007],
              [11.082692905000044, 57.28388092700004],
              [11.094164612000043, 57.26899601900004],
              [11.09110071300006, 57.25278405700004],
              [11.067166313000087, 57.23836201100005],
              [11.053517093000039, 57.226202113000056],
              [11.045137624000063, 57.212714961000074],
              [11.028835411000045, 57.201914301000045],
              [10.997904579000078, 57.19790995300008],
              [10.977961920000041, 57.206732946000045],
              [10.95181488500009, 57.23372967700004],
              [10.916536645000065, 57.23736867400004],
              [10.888799328000061, 57.24534416100005],
              [10.871104363000086, 57.25462474200003],
              [10.854991082000083, 57.26463450700004],
              [10.854991082000083, 57.27090078300006],
              [10.888424550000082, 57.274864843000046],
              [10.921263275000058, 57.29227995900004],
              [10.94660123500006, 57.30464328700003],
              [10.986869588000047, 57.30599264400007],
              [11.010083612000074, 57.30987331100005],
              [11.027723181000056, 57.32069050900009],
              [11.101927424000053, 57.320416925000075],
              [11.14234459700009, 57.33234284100007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Romania',
        iso3: 'ROU',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.877600546000053, 47.94673858700013],
            [22.897857706000053, 47.95097605500008],
            [22.91584110500014, 47.95919260700002],
            [22.924212687000107, 47.97273183200009],
            [22.91573775200004, 47.9929889940001],
            [22.924109334000093, 48.00482289600002],
            [22.939302206000036, 48.00564972000005],
            [22.95707889800005, 48.00012034100003],
            [22.97247847500003, 47.99288564100006],
            [22.988188110000095, 47.986374411],
            [23.004414510000117, 47.98306711900001],
            [23.02033085100004, 47.984720764000045],
            [23.06311893700007, 48.00745839500003],
            [23.07655481000012, 48.02451161700007],
            [23.0989823810001, 48.071227112000045],
            [23.118619426000038, 48.09153595000008],
            [23.139083292000095, 48.09812469500007],
            [23.161717570000064, 48.09590260900005],
            [23.23137740100009, 48.07972788600007],
            [23.248637329000076, 48.071227112000045],
            [23.28977176900014, 48.03820587200009],
            [23.337520793000124, 48.01086903900007],
            [23.360051717000147, 47.993144023000056],
            [23.367286418000106, 47.99120615700012],
            [23.374727824000047, 47.990560202000054],
            [23.382169230000045, 47.991128642],
            [23.390127401000115, 47.993066508000126],
            [23.39157434100011, 47.99345408200013],
            [23.393021281000102, 47.993583273000056],
            [23.394468221000096, 47.99345408200013],
            [23.396018514000104, 47.993066508000126],
            [23.46082076000002, 47.971336569000115],
            [23.48159468600008, 47.97216339100005],
            [23.4854755610001, 47.974234157000055],
            [23.488519328000052, 47.97585825700004],
            [23.494307088000113, 47.98053497300002],
            [23.49937137800009, 47.986219381000055],
            [23.50371219900009, 47.99288564100006],
            [23.514460897000106, 47.99898346000002],
            [23.525623006000046, 48.00117970900003],
            [23.56324344900014, 48.005753072000076],
            [23.581743612000082, 48.00156728100002],
            [23.64613244600008, 47.996606344000085],
            [23.687266886000145, 47.98725291000004],
            [23.71052128100007, 47.98508250000005],
            [23.78007775900008, 47.98751129100002],
            [23.79651086400014, 47.9819819130001],
            [23.848394002000134, 47.94965830500003],
            [23.855215291000093, 47.93423289000005],
            [23.876609334000108, 47.934439596000075],
            [23.97727502500004, 47.962293193000065],
            [24.008797648000012, 47.961207988000055],
            [24.025230753000073, 47.95324981800009],
            [24.074943482000094, 47.94418060400004],
            [24.094787231000083, 47.93792775500005],
            [24.13116744000007, 47.91454416900008],
            [24.14873742700013, 47.91211537700012],
            [24.150184367000122, 47.91291636200005],
            [24.209302205000085, 47.89759430000008],
            [24.231006307000087, 47.89702585900004],
            [24.297875610000062, 47.91978932800002],
            [24.347174926000065, 47.9208745320001],
            [24.386242310000057, 47.94368967700011],
            [24.40918664600011, 47.952061259000075],
            [24.428513631000044, 47.9525263470001],
            [24.485564412000144, 47.94319875100008],
            [24.542098429000106, 47.94381886800004],
            [24.561632121000116, 47.94053741500004],
            [24.569808453000093, 47.937288541],
            [24.608450968000056, 47.9219339000001],
            [24.633669067000085, 47.908291321],
            [24.64927535000004, 47.89521718400003],
            [24.65599328600007, 47.87930084300011],
            [24.656923462000123, 47.866200867000046],
            [24.661470988000133, 47.85387603800011],
            [24.679144328000064, 47.840130107000064],
            [24.7128373620001, 47.82591908800002],
            [24.793659302000066, 47.804473369000064],
            [24.808232056000122, 47.795740052],
            [24.820737752000127, 47.78408701600004],
            [24.85443078600008, 47.74313344300002],
            [24.877788533000114, 47.71874216700009],
            [24.896598755000127, 47.71006052700004],
            [24.928857956000115, 47.71393770200011],
            [24.942380238000112, 47.715562921000114],
            [25.017418253000073, 47.72458160400008],
            [25.079946737000057, 47.742926738000065],
            [25.080050089000082, 47.743081767],
            [25.08025679500014, 47.74313344300002],
            [25.121908, 47.770315247],
            [25.218956339000016, 47.87847402000007],
            [25.261744426000064, 47.89857615200005],
            [25.752515503000097, 47.93459462600005],
            [25.81835127800008, 47.95257802400003],
            [25.87095788600007, 47.95702219700003],
            [25.901240275000106, 47.96596221900005],
            [25.918086792000082, 47.968158468000055],
            [25.96573246200012, 47.964902852000066],
            [26.029294474000096, 47.97779612200007],
            [26.102530449000056, 47.97826709400006],
            [26.1257226970001, 47.978416240000044],
            [26.173058309000055, 47.993144023000056],
            [26.182670125000072, 48.00327260400009],
            [26.204787638000084, 48.03737904900005],
            [26.21708663000004, 48.04802439400005],
            [26.243234904000133, 48.062907207000094],
            [26.2553271890001, 48.072338155000054],
            [26.27072676600008, 48.09360300700003],
            [26.286953166000103, 48.12471222000009],
            [26.29749515800006, 48.156338196],
            [26.29615157000009, 48.17899831200005],
            [26.303489624000093, 48.212045390000114],
            [26.31175785300013, 48.20971995100008],
            [26.330258015000084, 48.20850555500006],
            [26.347311239000106, 48.212097067000045],
            [26.380487508000016, 48.223207499000054],
            [26.39743737800012, 48.226204733000074],
            [26.44466963700006, 48.227729187000065],
            [26.461309448000065, 48.2303905240001],
            [26.587399943000037, 48.24935577400005],
            [26.617889038000015, 48.25896759100006],
            [26.665741415000127, 48.27421213800001],
            [26.68853072100012, 48.27483225600007],
            [26.711475057000143, 48.261318868],
            [26.722378784000114, 48.25976857500008],
            [26.733127482000043, 48.270749817000066],
            [26.7440312090001, 48.255582784000055],
            [26.763719930000036, 48.252740580000065],
            [26.804906047000117, 48.25826995900009],
            [26.82190759300005, 48.252533875000026],
            [26.844748576000143, 48.23331024200009],
            [26.855497274000072, 48.23783193000013],
            [26.89766524200013, 48.20897064200007],
            [26.903969767000063, 48.201451722000044],
            [26.90800052900005, 48.18452769000005],
            [26.917715699000098, 48.18796417300008],
            [26.929084513000078, 48.19904876700009],
            [26.938127889000043, 48.20481068900004],
            [26.950581909000107, 48.19752431300007],
            [26.955646199000086, 48.186000469000035],
            [26.9630876060001, 48.17538096200006],
            [26.997607463000094, 48.16657012900005],
            [26.997607463000094, 48.15794016600002],
            [26.986238647000107, 48.15042124400007],
            [26.966601603000072, 48.14959442200005],
            [26.966601603000072, 48.143367412000046],
            [26.99399011200012, 48.13241200800009],
            [27.0126969800001, 48.12812286400002],
            [27.02509932500007, 48.135047506],
            [27.033677612000105, 48.13238617000006],
            [27.04277266400007, 48.12729604100009],
            [27.048043661000094, 48.122231751000115],
            [27.0479547570001, 48.1214093870001],
            [27.047423543000036, 48.11649566600006],
            [27.03688155100008, 48.10734893800007],
            [27.03429772900006, 48.10176788400007],
            [27.041739136000075, 48.07727325400002],
            [27.05920577000012, 48.05804962100008],
            [27.08318363500004, 48.04365773600007],
            [27.109331910000066, 48.03350331700001],
            [27.109331910000066, 48.02608774800008],
            [27.088971395000016, 48.019809062],
            [27.090004924000084, 48.01562327100005],
            [27.091451864000078, 48.01185089100004],
            [27.0933638920001, 48.00844024700008],
            [27.09579268400006, 48.00559804300012],
            [27.121475871000143, 48.013194478000074],
            [27.13460168500012, 48.000456238000126],
            [27.14374841300011, 47.98683949800004],
            [27.15718428500014, 47.99195546500003],
            [27.168759806000082, 47.98306711900001],
            [27.169793335000065, 47.973791199000075],
            [27.162868693000092, 47.9650062060001],
            [27.15098311300008, 47.95779734300005],
            [27.171963746000074, 47.946428528000055],
            [27.178268270000075, 47.94412892700002],
            [27.178268270000075, 47.942095667],
            [27.178268270000075, 47.93792775500005],
            [27.1606982830001, 47.92172719300005],
            [27.17155033300014, 47.91263214200008],
            [27.19418461100011, 47.904053854000026],
            [27.21237471500004, 47.88950693800008],
            [27.211547892000112, 47.88501108800007],
            [27.213201538000078, 47.85413442000008],
            [27.21237471500004, 47.847933248000075],
            [27.222813355000085, 47.84266225200007],
            [27.23490564000008, 47.840207622],
            [27.24580936700005, 47.836590272000095],
            [27.25340580200009, 47.8280894980001],
            [27.21919600400011, 47.81377512600001],
            [27.231081584000037, 47.80708302900008],
            [27.24487919100008, 47.79258778900005],
            [27.256196329000147, 47.77754994800007],
            [27.260847208000115, 47.76907501300006],
            [27.26467126400007, 47.76455332500002],
            [27.282447957000073, 47.755690816000126],
            [27.287512247000052, 47.7523318490001],
            [27.28811445900007, 47.75068006700003],
            [27.291129598000055, 47.74240997400001],
            [27.28957930500013, 47.73168711400011],
            [27.29505700700011, 47.72442657500004],
            [27.29505700700011, 47.718173727000035],
            [27.272009318000045, 47.71496978800006],
            [27.281104370000037, 47.69300730400009],
            [27.30404870600006, 47.66654897100001],
            [27.36916101100013, 47.608309632000086],
            [27.39706628400012, 47.58908599900006],
            [27.428382202000137, 47.58102447500006],
            [27.429403890000117, 47.578129692000104],
            [27.43134229800009, 47.572637535000055],
            [27.43582360800005, 47.559940491000035],
            [27.438975870000036, 47.55371348100006],
            [27.440267782000063, 47.550096131000075],
            [27.44006107600012, 47.54102691700008],
            [27.442128134000086, 47.53663442],
            [27.446055542000124, 47.53487742200012],
            [27.456907593000096, 47.53389556900005],
            [27.459491414000098, 47.53322377500008],
            [27.466726115000142, 47.50635203100008],
            [27.4731339920001, 47.49177927700002],
            [27.483675985000076, 47.48542307600009],
            [27.492564331000068, 47.48454457600006],
            [27.497525268000118, 47.48242584300009],
            [27.501452678000078, 47.47994537400011],
            [27.507240438000053, 47.47798167000006],
            [27.53297530100005, 47.47741322900002],
            [27.534525594000087, 47.47798167000006],
            [27.54816817200009, 47.474260966000045],
            [27.56315433800006, 47.468344015000056],
            [27.575866739000105, 47.4604116820001],
            [27.582998087000135, 47.45067067500004],
            [27.574781535000113, 47.44625234000004],
            [27.569355509000047, 47.43855255200005],
            [27.56553145400011, 47.42826894200006],
            [27.56253422000009, 47.41653839100006],
            [27.58031091300012, 47.4059964],
            [27.572352743000067, 47.37519724500005],
            [27.58640873200008, 47.368763530000095],
            [27.588723990000062, 47.36738939800007],
            [27.59994795700007, 47.36072784400001],
            [27.6240291740001, 47.321427918000026],
            [27.636948283000095, 47.306674296000025],
            [27.644699748000107, 47.303987122000095],
            [27.671726521000068, 47.299853008000056],
            [27.682320191000116, 47.295253805000115],
            [27.68986495000007, 47.29088714600003],
            [27.697823120000038, 47.28750234000002],
            [27.722834513000038, 47.28331654900008],
            [27.733273153000084, 47.275616761],
            [27.753633667000116, 47.25143219000002],
            [27.752393433000066, 47.23892649400001],
            [27.763038778000066, 47.22631744400009],
            [27.788308553000036, 47.204277446],
            [27.80034916200009, 47.17696645200009],
            [27.80210616000008, 47.176346334000115],
            [27.804793335000113, 47.16849151700008],
            [27.8076872150001, 47.16247121200006],
            [27.805878540000094, 47.1582337440001],
            [27.794664754000053, 47.15583079100004],
            [27.806550334000093, 47.144617005],
            [27.849855184000063, 47.12851979600002],
            [27.849855184000063, 47.12172434500006],
            [27.8437573650001, 47.11438629100009],
            [27.848201538000097, 47.111414897000074],
            [27.8577100010001, 47.10932200100011],
            [27.867011759000036, 47.104645285000046],
            [27.897604207000114, 47.08141672800012],
            [27.92592289200013, 47.068756002000086],
            [27.938428589000125, 47.06105621400009],
            [27.938738647000093, 47.046638489000074],
            [27.963129924000043, 47.04338287400007],
            [27.98659102400009, 47.03322845500013],
            [28.008295125000103, 47.02630381300004],
            [28.028035522000067, 47.032970073000044],
            [28.03702722200012, 47.01645945300008],
            [28.038146337000057, 47.015482935000094],
            [28.069066609000117, 46.98850250300008],
            [28.08270918800011, 46.97152679500006],
            [28.10229455600006, 46.935120748000074],
            [28.104994100000113, 46.920184743000064],
            [28.105446818000104, 46.91767995300005],
            [28.09686853100007, 46.90261627300005],
            [28.1135600180001, 46.894761454],
            [28.114335164000124, 46.88339264000011],
            [28.113094930000074, 46.87142954600007],
            [28.1242570390001, 46.86163686100009],
            [28.1242570390001, 46.85419545500007],
            [28.12261528700006, 46.842269519000084],
            [28.121518188000067, 46.83430002900006],
            [28.137796264000087, 46.806239726000044],
            [28.17815555800007, 46.75864573200003],
            [28.17810388200013, 46.739835511000095],
            [28.234121134000077, 46.66242421500009],
            [28.24424971500011, 46.635371603000024],
            [28.245085309000046, 46.631451272000035],
            [28.24735030100007, 46.62082468700008],
            [28.247143595000097, 46.60715627000006],
            [28.24052901200011, 46.59638173500004],
            [28.230503784000092, 46.58390187600004],
            [28.225439494000113, 46.56956166600004],
            [28.234121134000077, 46.553128560000076],
            [28.224767700000115, 46.548736064000096],
            [28.22109867400013, 46.54119130500003],
            [28.219031616000052, 46.50372589100006],
            [28.22109867400013, 46.49576772100009],
            [28.234121134000077, 46.47806854200009],
            [28.238100220000035, 46.4755880740001],
            [28.242337687000088, 46.47651825000007],
            [28.24580000800003, 46.475510559],
            [28.247143595000097, 46.46719065400002],
            [28.247246948000026, 46.436184794],
            [28.246058390000115, 46.42786488900005],
            [28.240218953000124, 46.420268454000066],
            [28.226059611000068, 46.415359192000054],
            [28.233294312000055, 46.40176829000005],
            [28.228643433000087, 46.396109721000116],
            [28.226796348000107, 46.395548249000015],
            [28.219548380000106, 46.393345032000056],
            [28.21293379700009, 46.38869415300009],
            [28.207146037000115, 46.35815338100009],
            [28.202391805000047, 46.35391591400004],
            [28.19035119700007, 46.35107371100007],
            [28.18792240400012, 46.343787333000094],
            [28.191953165000115, 46.32350433400008],
            [28.19288334100014, 46.31123118100005],
            [28.191333049000036, 46.30776886000011],
            [28.177793824000048, 46.28704661100009],
            [28.16575321400009, 46.278830058000054],
            [28.156296428000104, 46.275367738000014],
            [28.144927612000117, 46.272938945000064],
            [28.135212443000086, 46.26932159500008],
            [28.131078329000076, 46.26239695200009],
            [28.13448897300009, 46.245343730000045],
            [28.13211185700004, 46.239917704000064],
            [28.120846394000097, 46.237850647000116],
            [28.108960816000064, 46.23412994400009],
            [28.11097619600011, 46.225603333],
            [28.129321329000078, 46.204674378],
            [28.135625855000086, 46.1988349410001],
            [28.141516968000104, 46.19196197500004],
            [28.14472090600006, 46.18322865900008],
            [28.133248739000067, 46.15997426400007],
            [28.12735762500006, 46.135324605000065],
            [28.110506470000132, 46.10149115700004],
            [28.10782281200005, 46.09610295600008],
            [28.100795939000136, 46.08199452700008],
            [28.092837768000066, 46.07837717700009],
            [28.090150594000136, 46.07336456400013],
            [28.090460652000047, 46.06799021400006],
            [28.096558471000094, 46.065044658000076],
            [28.09686853100007, 46.05967030900011],
            [28.0844661860001, 46.02458201100008],
            [28.08270918800011, 46.01471181200007],
            [28.086119833000055, 46.000552471000034],
            [28.110511109000072, 45.950426331000116],
            [28.112371460000077, 45.939212545000075],
            [28.114851928000064, 45.93321807900004],
            [28.120846394000097, 45.92629343700007],
            [28.124980510000114, 45.9183869430001],
            [28.122810099000105, 45.91079050800006],
            [28.11877933800011, 45.903142395000074],
            [28.117435751000073, 45.89523590100002],
            [28.120226278000104, 45.887846172000124],
            [28.129114624000124, 45.87513376900007],
            [28.131078329000076, 45.87136139000005],
            [28.128184449000088, 45.86640045200009],
            [28.114955282000096, 45.85973419200009],
            [28.110511109000072, 45.85430816600011],
            [28.11330163600013, 45.82536936400005],
            [28.128907918000067, 45.795035299000105],
            [28.146477906000143, 45.77116078700003],
            [28.154952840000135, 45.761807353000066],
            [28.16373783400013, 45.66150339800002],
            [28.161774129000094, 45.64543202700004],
            [28.167975302000087, 45.63246124300012],
            [28.153712606000113, 45.62750030600007],
            [28.120846394000097, 45.62770701100003],
            [28.10772058100011, 45.62439971900004],
            [28.09118412300012, 45.615976461000045],
            [28.074751017000068, 45.604866028000046],
            [28.06214196800005, 45.59360056600006],
            [28.118004191000097, 45.5727232870001],
            [28.140948527000063, 45.5602175910001],
            [28.15774336700011, 45.53892690000002],
            [28.161567423000065, 45.532725729000035],
            [28.164047892000042, 45.53060699500004],
            [28.16539147900008, 45.528281556000124],
            [28.165908244000036, 45.49458852200006],
            [28.172936239000137, 45.4843565880001],
            [28.19949792500006, 45.46177398700006],
            [28.21293379700009, 45.45019846600009],
            [28.215146087000107, 45.45036508200003],
            [28.237635132000037, 45.45205881800011],
            [28.26688399300008, 45.44048329700006],
            [28.28641768400007, 45.42172475200006],
            [28.281198364000147, 45.401829326000055],
            [28.310808960000088, 45.3478274540001],
            [28.330239298000066, 45.32291941300012],
            [28.353286987000047, 45.31242909800007],
            [28.370236857000037, 45.309225159],
            [28.40517012500004, 45.295065817000065],
            [28.494156942000103, 45.27889109400006],
            [28.57704593900013, 45.248091939000076],
            [28.710061076000073, 45.22695627900005],
            [28.747371460000124, 45.230470276000105],
            [28.778687378000114, 45.23109039400008],
            [28.79139978100008, 45.23496612600003],
            [28.802665243000035, 45.24416453100012],
            [28.774294881000117, 45.25336293600013],
            [28.76726688600013, 45.257755433000014],
            [28.762564331000135, 45.265145162000024],
            [28.759670451000147, 45.274188538],
            [28.761530803000056, 45.28183665000007],
            [28.79015954500005, 45.292068583000045],
            [28.788609253000118, 45.30710642500013],
            [28.78974613400004, 45.3214207970001],
            [28.816307820000134, 45.32607167600007],
            [28.831810750000074, 45.32229929700004],
            [28.85811405400011, 45.30907013000005],
            [28.880851684000078, 45.306176249000075],
            [28.893615763000042, 45.29982004900005],
            [28.910048869000036, 45.28736602800005],
            [28.92989261800011, 45.27909779900001],
            [28.952836954000134, 45.285092265000046],
            [28.957384481000076, 45.29201690700002],
            [28.960433390000105, 45.31129221600007],
            [28.96647953300004, 45.31987050400009],
            [28.973662557000097, 45.32369456000005],
            [28.982447550000074, 45.32550323500003],
            [29.004616740000102, 45.32607167600007],
            [29.01815596600008, 45.33087758400008],
            [29.06952233900006, 45.3607982380001],
            [29.11029504300012, 45.36906646800007],
            [29.1275032960001, 45.37454417000005],
            [29.1418693440001, 45.38508616100002],
            [29.150137573000052, 45.387876689000066],
            [29.17432214300004, 45.388961894000076],
            [29.179386434000094, 45.391855774000064],
            [29.183107137, 45.398987122000094],
            [29.191582072000102, 45.406170146000036],
            [29.2066715900001, 45.41542022700007],
            [29.22816898600007, 45.42374013300012],
            [29.244602091000104, 45.42420522100004],
            [29.26082849100004, 45.422034810000056],
            [29.28180912200014, 45.42229319300013],
            [29.290490763000093, 45.424618633000065],
            [29.29927575700009, 45.42890777700002],
            [29.3070272220001, 45.43412709500005],
            [29.312814982000134, 45.43934641500006],
            [29.32211674000007, 45.44384226500007],
            [29.33296879100004, 45.44213694300002],
            [29.343924195000113, 45.43810618100012],
            [29.353742717000046, 45.43593577100005],
            [29.43063724800004, 45.43040639200002],
            [29.56969852700007, 45.39495636],
            [29.61636234600013, 45.36534576500004],
            [29.628144572000053, 45.3607982380001],
            [29.650262085000122, 45.34612213200002],
            [29.66710860200004, 45.311860657000025],
            [29.672276245000035, 45.272948303000035],
            [29.6592537840001, 45.24416453100012],
            [29.664989869000124, 45.23786000600002],
            [29.66648848400007, 45.23062530600005],
            [29.66421472100012, 45.223183899000034],
            [29.659027540000068, 45.21588776200008],
            [29.65015709700009, 45.217230536000045],
            [29.623871290000068, 45.216498114000046],
            [29.623871290000068, 45.210272528000075],
            [29.638845248000052, 45.19562409100007],
            [29.64975019600007, 45.177801825000074],
            [29.667002800000034, 45.16421133000006],
            [29.699554884000065, 45.161810614000046],
            [29.676524285000085, 45.144598700000074],
            [29.664398634000065, 45.11692942900004],
            [29.656260613000086, 45.028957424000055],
            [29.650726759000065, 45.01211172100005],
            [29.637543165000068, 44.983710028000075],
            [29.634938998000052, 44.96954987200007],
            [29.633636915000068, 44.95335521000004],
            [29.630869988000086, 44.938666083000044],
            [29.623871290000068, 44.92910390800006],
            [29.630381707000083, 44.90766022300005],
            [29.60515384200005, 44.88003164300005],
            [29.617849155000044, 44.86147695500006],
            [29.611175977000073, 44.849310614000046],
            [29.60320071700005, 44.845404364000046],
            [29.593760613000086, 44.84430573100008],
            [29.583506707000083, 44.840277411000045],
            [29.569346550000034, 44.82489655200004],
            [29.561778191000087, 44.82025788000004],
            [29.542002800000034, 44.827826239000046],
            [29.531097852000073, 44.826239325000074],
            [29.520518425000034, 44.82249583500004],
            [29.510996941000087, 44.82050202000005],
            [29.315928582000083, 44.79877350500004],
            [29.192067905000044, 44.79287344000005],
            [29.156097852000073, 44.784409898000035],
            [29.055837436000047, 44.73517487200007],
            [29.026377800000034, 44.71466705900008],
            [29.000743035000085, 44.68891022300005],
            [28.99390709700009, 44.69635651200008],
            [28.994883660000085, 44.71112702000005],
            [28.981293165000068, 44.72943756700005],
            [28.974945509000065, 44.74494049700007],
            [28.997325066000087, 44.751613674000055],
            [29.021494988000086, 44.75470612200007],
            [29.05827884200005, 44.76829661700003],
            [29.09815514400009, 44.775376695000034],
            [29.120616082000083, 44.78656647300005],
            [29.138682488000086, 44.804022528000075],
            [29.144704623000052, 44.82664622600004],
            [29.138845248000052, 44.839178778000075],
            [29.125987175000034, 44.85248444200005],
            [29.096364780000044, 44.875067450000074],
            [29.101817254000082, 44.85911692900004],
            [29.103363477000073, 44.85130442900004],
            [29.103770379000082, 44.840277411000045],
            [29.087901238000086, 44.84271881700005],
            [29.073496941000087, 44.83543528900009],
            [29.06031334700009, 44.83234284100007],
            [29.04859459700009, 44.84715403900009],
            [29.044118686000047, 44.86554596600007],
            [29.041758660000085, 44.92568594000005],
            [29.05209394600007, 44.944647528000075],
            [29.098806186000047, 44.95697663000004],
            [29.110606316000087, 44.970038153000075],
            [29.101735873000052, 44.98029205900008],
            [29.05827884200005, 45.00096263200004],
            [29.045176629000082, 45.00482819200005],
            [29.014414910000085, 45.00482819200005],
            [28.983246290000068, 45.01227448100008],
            [28.972829623000052, 45.010972398000035],
            [28.96924889400009, 45.005845445000034],
            [28.966075066000087, 44.99656810100004],
            [28.960215691000087, 44.98769765800006],
            [28.949229363000086, 44.983710028000075],
            [28.927012566000087, 44.98261139500005],
            [28.916840040000068, 44.979681708000044],
            [28.880056186000047, 44.954779364000046],
            [28.869395379000082, 44.943345445000034],
            [28.863536004000082, 44.922308661000045],
            [28.865082227000073, 44.91657135600008],
            [28.87435957100007, 44.91156647300005],
            [28.87663821700005, 44.90485260600008],
            [28.87468509200005, 44.89911530200004],
            [28.870127800000034, 44.89642975500004],
            [28.865489129000082, 44.89468008000006],
            [28.863536004000082, 44.89154694200005],
            [28.866465691000087, 44.88263580900008],
            [28.87354576900009, 44.874986070000034],
            [28.881521030000044, 44.86969635600008],
            [28.90406334700009, 44.86273834800005],
            [28.952403191000087, 44.82664622600004],
            [28.939707879000082, 44.81688060100004],
            [28.93409264400009, 44.81419505400004],
            [28.924978061000047, 44.81305573100008],
            [28.934418165000068, 44.807521877000056],
            [28.938731316000087, 44.80621979400007],
            [28.938731316000087, 44.79877350500004],
            [28.92628014400009, 44.792954820000034],
            [28.92546634200005, 44.78367747600004],
            [28.93295332100007, 44.773504950000074],
            [28.946136915000068, 44.76520416900007],
            [28.936371290000068, 44.75995514500005],
            [28.923838738000086, 44.757798570000034],
            [28.87940514400009, 44.75657786700003],
            [28.86882571700005, 44.753566799000055],
            [28.808441602000073, 44.72687409100007],
            [28.798350457000083, 44.72020091400009],
            [28.78882897200009, 44.706244208000044],
            [28.787119988000086, 44.69330475500004],
            [28.793711785000085, 44.68789297100005],
            [28.80836022200009, 44.69635651200008],
            [28.804209832000083, 44.68423086100006],
            [28.785411004000082, 44.679673570000034],
            [28.78101647200009, 44.665269273000035],
            [28.784027540000068, 44.64923737200007],
            [28.792491082000083, 44.64472077000005],
            [28.845550977000073, 44.651556708000044],
            [28.869476759000065, 44.661810614000046],
            [28.891368035000085, 44.67719147300005],
            [28.911957227000073, 44.69635651200008],
            [28.897715691000087, 44.716782945000034],
            [28.967458530000044, 44.70099518400008],
            [28.983409050000034, 44.692613023000035],
            [28.987559441000087, 44.67527903900009],
            [28.979340040000068, 44.65534088700008],
            [28.962087436000047, 44.63939036700003],
            [28.938731316000087, 44.63426341400009],
            [28.95639082100007, 44.65110911700003],
            [28.972666863000086, 44.67023346600007],
            [28.975352410000085, 44.686835028000075],
            [28.952403191000087, 44.69635651200008],
            [28.952403191000087, 44.68891022300005],
            [28.959971550000034, 44.68195221600007],
            [28.957774285000085, 44.67877838700008],
            [28.938731316000087, 44.67523834800005],
            [28.924164259000065, 44.682074286000045],
            [28.918223504000082, 44.68268463700008],
            [28.91382897200009, 44.67991771000004],
            [28.909434441000087, 44.67519765800006],
            [28.904551629000082, 44.668402411000045],
            [28.885427280000044, 44.65810781500005],
            [28.854177280000044, 44.63434479400007],
            [28.836273634000065, 44.62742747600004],
            [28.787852410000085, 44.60960521000004],
            [28.774180535000085, 44.600775458000044],
            [28.79151451900009, 44.62384674700007],
            [28.79468834700009, 44.63426341400009],
            [28.77979576900009, 44.63580963700008],
            [28.76693769600007, 44.63373444200005],
            [28.757823113000086, 44.62677643400008],
            [28.75367272200009, 44.61375560100004],
            [28.766774936000047, 44.61375560100004],
            [28.760590040000068, 44.60370514500005],
            [28.764414910000085, 44.59589264500005],
            [28.774424675000034, 44.59015534100007],
            [28.787852410000085, 44.58649323100008],
            [28.748057488000086, 44.577785549000055],
            [28.732676629000082, 44.56785716400009],
            [28.732676629000082, 44.55231354400007],
            [28.737152540000068, 44.557074286000045],
            [28.74390709700009, 44.56199778900009],
            [28.746918165000068, 44.56598541900007],
            [28.76107832100007, 44.560207424000055],
            [28.774180535000085, 44.55231354400007],
            [28.765635613000086, 44.53888580900008],
            [28.753428582000083, 44.51349518400008],
            [28.745616082000083, 44.48615143400008],
            [28.750254754000082, 44.46670156500005],
            [28.758474155000044, 44.465277411000045],
            [28.766368035000085, 44.47260163000004],
            [28.77198326900009, 44.483710028000075],
            [28.778330925000034, 44.50739166900007],
            [28.788096550000034, 44.51536692900004],
            [28.80836022200009, 44.525051174000055],
            [28.838145379000082, 44.554022528000075],
            [28.855642123000052, 44.567694403000075],
            [28.87354576900009, 44.573431708000044],
            [28.892425977000073, 44.577053127000056],
            [28.906260613000086, 44.58771393400008],
            [28.914886915000068, 44.60138580900008],
            [28.924978061000047, 44.62055084800005],
            [28.91846764400009, 44.60101959800005],
            [28.909678582000083, 44.58421458500004],
            [28.844004754000082, 44.49371979400007],
            [28.796722852000073, 44.46792226800005],
            [28.706553582000083, 44.38104889500005],
            [28.696299675000034, 44.35834381700005],
            [28.69312584700009, 44.346136786000045],
            [28.68018639400009, 44.35333893400008],
            [28.664398634000065, 44.34837474200003],
            [28.651215040000068, 44.34003327000005],
            [28.640879754000082, 44.328558661000045],
            [28.635101759000065, 44.316392320000034],
            [28.632334832000083, 44.302435614000046],
            [28.631032748000052, 44.26434967700004],
            [28.63526451900009, 44.252020575000074],
            [28.651215040000068, 44.23078034100007],
            [28.665212436000047, 44.199286200000074],
            [28.668142123000052, 44.18431224200003],
            [28.664886915000068, 44.17560455900008],
            [28.671722852000073, 44.16868724200003],
            [28.658376498000052, 44.17446523600006],
            [28.64584394600007, 44.17202383000006],
            [28.636241082000083, 44.16429271000004],
            [28.630869988000086, 44.15448639500005],
            [28.637461785000085, 44.13589101800005],
            [28.654144727000073, 44.05491771000004],
            [28.67123457100007, 44.00332265800006],
            [28.671722852000073, 43.997381903000075],
            [28.669118686000047, 43.989162502000056],
            [28.660004102000073, 43.979803778000075],
            [28.654958530000044, 43.961371161000045],
            [28.640879754000082, 43.93219635600008],
            [28.637705925000034, 43.91864655200004],
            [28.61378014400009, 43.88418203300006],
            [28.609385613000086, 43.87449778900009],
            [28.59351647200009, 43.819525458000044],
            [28.58765709700009, 43.810248114000046],
            [28.58448326900009, 43.800848700000074],
            [28.58920332100007, 43.79132721600007],
            [28.584808790000068, 43.782416083000044],
            [28.58253014400009, 43.772365627000056],
            [28.581879102000073, 43.761704820000034],
            [28.583018425000034, 43.75104401200008],
            [28.578379754000082, 43.74127838700008],
            [28.434574015000123, 43.73521270700003],
            [28.22125370300006, 43.76198110000011],
            [28.014806355000076, 43.830038961000085],
            [27.981009969000098, 43.84934010900004],
            [27.935844767000106, 43.964397685],
            [27.91207360800007, 43.99323313400005],
            [27.91207360800007, 43.993336487000064],
            [27.856469767000135, 43.9886339320001],
            [27.78732670100007, 43.960418600000125],
            [27.72169763100004, 43.948739726000056],
            [27.68251497600008, 43.987256010000024],
            [27.676119019000055, 43.993543193000036],
            [27.65627526800006, 44.02387725900006],
            [27.633434285000135, 44.02976837200008],
            [27.57452315200004, 44.016280823],
            [27.38383711700004, 44.015092265000064],
            [27.372881714000073, 44.02072499600011],
            [27.35355472800009, 44.045271302000074],
            [27.34166914900007, 44.053074443000085],
            [27.28534183800008, 44.072453105000065],
            [27.264309530000048, 44.08976471000007],
            [27.269012085000043, 44.11239898700002],
            [27.252662458000145, 44.1215188660001],
            [27.251132039000083, 44.122372539000125],
            [27.226740763000066, 44.120718893000074],
            [27.20555342600008, 44.129245504],
            [27.100236857000084, 44.14449005200005],
            [27.02747644100012, 44.17704620400009],
            [27.001534871000075, 44.16510894900004],
            [26.884126017000142, 44.15653066],
            [26.789454793000033, 44.11596466100009],
            [26.753694702000104, 44.108109843000065],
            [26.708684530000085, 44.108109843000065],
            [26.697212361000084, 44.10609446300002],
            [26.67731693500008, 44.097051087000054],
            [26.667808471000086, 44.0950873820001],
            [26.647758016000125, 44.09338206000005],
            [26.6141683350001, 44.08485544800003],
            [26.41579067300006, 44.06378879400002],
            [26.332335498000106, 44.05492629800001],
            [26.31051761900011, 44.05260935500006],
            [26.23145267800004, 44.027494609000044],
            [26.15073409100009, 44.01240509000006],
            [26.116214233000107, 43.99886586500007],
            [26.079317260000096, 43.96904856400006],
            [26.061643921000098, 43.94977325400002],
            [26.054305868000085, 43.93432200100004],
            [25.93400313300009, 43.870320740000054],
            [25.924494670000115, 43.85861602800007],
            [25.916433146000116, 43.844379171000085],
            [25.869304240000133, 43.800893453000086],
            [25.839331909000094, 43.78843943300008],
            [25.806258993000085, 43.76366058400005],
            [25.80439864100009, 43.759914042000034],
            [25.781144246000082, 43.732008769000075],
            [25.739596395000092, 43.718934631000096],
            [25.73294793700012, 43.71878101100002],
            [25.67138350400006, 43.71735850000009],
            [25.653503458000102, 43.70813425700008],
            [25.637897176000138, 43.69728220700004],
            [25.61650313400014, 43.687747904000034],
            [25.593868856000086, 43.680668234],
            [25.575058634000072, 43.67738678000002],
            [25.556558472000063, 43.67035878500012],
            [25.53382084100008, 43.66867930100007],
            [25.48875899300012, 43.67053965300006],
            [25.482450035000113, 43.669714753],
            [25.467416626000045, 43.6677491250001],
            [25.426075480000094, 43.654390767000066],
            [25.40313114400007, 43.6500499480001],
            [25.359619588000044, 43.65428741500004],
            [25.323032674000103, 43.66971283000005],
            [25.288719523000083, 43.688962301000075],
            [25.285404775000075, 43.6903913150001],
            [25.252339315000086, 43.704646098000026],
            [25.21130822700013, 43.7118807990001],
            [25.08160038200009, 43.718934631000096],
            [24.963674764000075, 43.74960459400005],
            [24.7526282150001, 43.73880422000009],
            [24.705602661000057, 43.743765158000045],
            [24.661763224000083, 43.75565671600005],
            [24.500137166000115, 43.79949819000011],
            [24.46634077900012, 43.802417908000095],
            [24.431200806000078, 43.794175517000056],
            [24.375493612000042, 43.76386729000002],
            [24.35823368400014, 43.76001739500008],
            [24.336705387000052, 43.759250925000075],
            [24.15938277200013, 43.75293772400006],
            [24.149605832000134, 43.75471994900006],
            [23.799921509000058, 43.81846344000006],
            [23.742870727000053, 43.842699687000035],
            [23.72075321500006, 43.84582611100008],
            [23.636107219000053, 43.83215769500008],
            [23.620853516000068, 43.83400993000002],
            [23.59269901600007, 43.83742869100011],
            [23.484695272000096, 43.88060435000004],
            [23.325150732000054, 43.88659228100006],
            [23.23447798700002, 43.87729705900004],
            [23.19696089600012, 43.86275014300007],
            [23.161924275000104, 43.85732411700012],
            [23.13184859200004, 43.84794484500007],
            [23.052551215000108, 43.84281985600005],
            [22.919561808000054, 43.834224752000026],
            [22.88876265500008, 43.83952158700008],
            [22.863441203, 43.8554120890001],
            [22.85103885900014, 43.87435150200004],
            [22.850522095000088, 43.896985779],
            [22.874706665000076, 43.97204579700009],
            [22.8858687740001, 43.99452504500009],
            [22.905815877000123, 44.003981832000065],
            [22.92648645000014, 44.006152243000045],
            [22.96627730300014, 44.01555735300009],
            [22.98808475700008, 44.01767608700008],
            [23.023018025000084, 44.03162872300008],
            [23.04007124800009, 44.06232452400012],
            [23.03097619600004, 44.093072002000056],
            [23.008306709000095, 44.10044641300006],
            [22.98808475700008, 44.107024638000055],
            [22.942609497000035, 44.11146881100005],
            [22.906435995000095, 44.122889303000065],
            [22.691640373000098, 44.228434539],
            [22.69073856600008, 44.22887766500007],
            [22.685364217000114, 44.24365712500007],
            [22.68949833200014, 44.29171620800004],
            [22.6815401610001, 44.305307109000026],
            [22.66252323400002, 44.31166331000007],
            [22.621182088000097, 44.31590077800011],
            [22.582838175000063, 44.32840647400009],
            [22.549351847000082, 44.348973694000094],
            [22.522686808000117, 44.375070292000075],
            [22.50511682100006, 44.40406077100006],
            [22.503979940000136, 44.41170888300003],
            [22.5063570560001, 44.42752187100005],
            [22.50542688000013, 44.43501495400007],
            [22.500982706000116, 44.44193959600007],
            [22.48000207500013, 44.455788880000014],
            [22.477004842000014, 44.46395375600004],
            [22.47721154800007, 44.476976217000086],
            [22.479795370000062, 44.49041209000002],
            [22.48413618900014, 44.49976552400007],
            [22.49106083200013, 44.504209697000064],
            [22.500362590000066, 44.506380107000055],
            [22.535502563000108, 44.50751698800006],
            [22.548421672000103, 44.51170277900012],
            [22.556689900000066, 44.52146962500005],
            [22.5597904870001, 44.538781230000055],
            [22.565578247000076, 44.55542104100009],
            [22.58046105900013, 44.565497946000036],
            [22.600304810000125, 44.56978709],
            [22.621182088000097, 44.569218649000035],
            [22.642162719000083, 44.563120830000074],
            [22.67854292800007, 44.545550843000015],
            [22.70014367600004, 44.5418301400001],
            [22.719367309000063, 44.544362285],
            [22.741691528000047, 44.5518553670001],
            [22.759261515000105, 44.564671123],
            [22.765152628000095, 44.58280955000002],
            [22.714716431000113, 44.62306549100008],
            [22.70014367600004, 44.63061025100002],
            [22.621182088000097, 44.637431539000076],
            [22.58748905400003, 44.64936879500003],
            [22.553279256000053, 44.669160869000095],
            [22.48372277800013, 44.723989563000075],
            [22.468943319000118, 44.73019073600007],
            [22.450546508000116, 44.73298126300004],
            [22.426051880000074, 44.73365305600002],
            [22.4155098870001, 44.72781362000002],
            [22.380679973000042, 44.70052846300011],
            [22.361146281000032, 44.6920535280001],
            [22.319701782000067, 44.68533559200007],
            [22.30492232300014, 44.67737742200002],
            [22.29903120900005, 44.66166778600005],
            [22.185136352000114, 44.515113424000035],
            [22.172113892000084, 44.50534657900009],
            [22.148239380000092, 44.500902405000076],
            [22.126638631000105, 44.50265940300007],
            [22.104314412000065, 44.509635722000056],
            [22.08695113100012, 44.52177968300005],
            [22.076305786000148, 44.550718486],
            [22.06710738100014, 44.557229717000084],
            [22.05573856600006, 44.56213897700012],
            [22.0451965740001, 44.569218649000035],
            [22.039822225000137, 44.57686676100012],
            [22.036173617000117, 44.58948897000006],
            [22.03424290400008, 44.59616819500009],
            [22.032174113000053, 44.60332509400011],
            [22.004268839000076, 44.651539205000105],
            [21.994346964000073, 44.6585672],
            [21.96241093000009, 44.662287903000035],
            [21.87197717300012, 44.69598093700007],
            [21.855440715000043, 44.69846140500006],
            [21.83828413900008, 44.69520579000006],
            [21.801697225000026, 44.68388865200008],
            [21.75684208100006, 44.67727406900009],
            [21.705165649000094, 44.677067363000035],
            [21.65627974500012, 44.68766103200004],
            [21.619692830000076, 44.71391265900006],
            [21.610287720000116, 44.73194773400006],
            [21.604293254000083, 44.74998280900006],
            [21.59561161200014, 44.76595082600009],
            [21.578041626000072, 44.777681377000064],
            [21.558404582000037, 44.78166046100007],
            [21.497219686000108, 44.77804311100009],
            [21.4121602780001, 44.78481272400002],
            [21.39593387900007, 44.790238749000096],
            [21.378570597000078, 44.81664540700005],
            [21.360587199000065, 44.826412252000026],
            [21.359799635000115, 44.82665722100005],
            [21.34281050600015, 44.83194163100002],
            [21.346427857000037, 44.84563588500005],
            [21.355522908000097, 44.85659128800002],
            [21.36854536900003, 44.864859517000056],
            [21.395313761000097, 44.8716291300001],
            [21.453398072000084, 44.86956207300004],
            [21.481510051000043, 44.87261098300006],
            [21.522127727000083, 44.880775859],
            [21.536287068000036, 44.88930247000009],
            [21.539077596000084, 44.90847442600001],
            [21.531016073000075, 44.92464915],
            [21.51633996600009, 44.93389923200003],
            [21.481510051000043, 44.943562724000046],
            [21.456498657000054, 44.95234771700005],
            [21.408439575000074, 44.958342183000056],
            [21.385185181000054, 44.9695042930001],
            [21.384565063000082, 44.97493031900008],
            [21.38704553200006, 44.98154490200007],
            [21.383944946000042, 44.98666086900006],
            [21.366995077000126, 44.98728098600013],
            [21.35345585200014, 44.98981313100002],
            [21.351388794000087, 44.99823638900001],
            [21.35614302600007, 45.0085716760001],
            [21.363377726000124, 45.016529847000086],
            [21.373299601000042, 45.020095520000055],
            [21.398827758000067, 45.02138743100009],
            [21.409266398000113, 45.023971253000084],
            [21.421875447000048, 45.031412659000026],
            [21.425079386000107, 45.036218567000034],
            [21.425596150000047, 45.04324656200005],
            [21.429523560000092, 45.05730255200005],
            [21.43252079200002, 45.06148834300008],
            [21.440995727000114, 45.06872304300005],
            [21.443786255000077, 45.0729088340001],
            [21.44440637200006, 45.07786977200006],
            [21.44440637200006, 45.085259502000056],
            [21.443786255000077, 45.09146067400003],
            [21.44244266700011, 45.09290761300012],
            [21.44998742700008, 45.101020813000034],
            [21.458565715000105, 45.10732533800005],
            [21.46900435300003, 45.11104604100005],
            [21.481510051000043, 45.111562806000094],
            [21.494119100000148, 45.11931427000009],
            [21.497839803000062, 45.13187164300011],
            [21.493292277000137, 45.1451008100001],
            [21.48438838900006, 45.152701690000086],
            [21.459392537000042, 45.17403961200007],
            [21.43376102700006, 45.18881907100008],
            [21.405545695000086, 45.19967112200003],
            [21.299298950000036, 45.223183899000034],
            [21.257130982000064, 45.22411407500009],
            [21.239250936000104, 45.229385071000095],
            [21.20607466600009, 45.245921529],
            [21.189744914000073, 45.259564108000106],
            [21.15563846900008, 45.29516917000008],
            [21.139412069000088, 45.303695781],
            [21.129180135000098, 45.301887105],
            [21.11305708800012, 45.2893297320001],
            [21.103341919000087, 45.28607411700001],
            [21.09155969200009, 45.28808949800005],
            [21.082774699000083, 45.29367055300007],
            [21.074299764000102, 45.300543518000055],
            [21.063964478000088, 45.30627960200009],
            [21.016668402000107, 45.321481912000095],
            [20.981488891000083, 45.33278961200001],
            [20.966192667000115, 45.341574605000076],
            [20.927642050000145, 45.377489726000064],
            [20.8630465090001, 45.41872751900006],
            [20.830387004000016, 45.45252390600005],
            [20.816020955000113, 45.46285919200004],
            [20.799484497000037, 45.4685436],
            [20.781604451000078, 45.47257436100007],
            [20.767135050000036, 45.47934397400003],
            [20.760727173000078, 45.493348288000035],
            [20.783154745000076, 45.50606069000007],
            [20.797624146000118, 45.51649932900001],
            [20.80020796700012, 45.53050364200003],
            [20.787392212000043, 45.55365468400002],
            [20.758039998000072, 45.589259746],
            [20.754422648000087, 45.60558949900003],
            [20.76217411300007, 45.63060089100013],
            [20.773232869000083, 45.648894349],
            [20.777263631000096, 45.657524312000035],
            [20.7799508060001, 45.671683655],
            [20.7791239820001, 45.72367014600012],
            [20.781604451000078, 45.733953756000105],
            [20.785531861000038, 45.74341054300008],
            [20.785738566000077, 45.75255727200006],
            [20.777470337000125, 45.762324117],
            [20.765171346000102, 45.76676829100002],
            [20.75411259000009, 45.763564352000046],
            [20.745327596000095, 45.75498606400002],
            [20.739436482000116, 45.74341054300008],
            [20.726827433000068, 45.736175842000094],
            [20.713391561000037, 45.73333363900004],
            [20.700059041000117, 45.7354006960001],
            [20.688070109000137, 45.743100484000095],
            [20.678561646000077, 45.756639709000055],
            [20.65561731000014, 45.77731028300009],
            [20.64590214000009, 45.788730775],
            [20.64348956000015, 45.79514134500009],
            [20.642284790000105, 45.798342590000104],
            [20.640114380000114, 45.81870310500004],
            [20.636703735000083, 45.827023011000094],
            [20.629675740000096, 45.833275858],
            [20.612312459000066, 45.84149241200002],
            [20.60528446400005, 45.846143291],
            [20.572108195000055, 45.887691142000065],
            [20.556708618000073, 45.89843984],
            [20.538001749000074, 45.90371083600003],
            [20.499864543000115, 45.906656392000045],
            [20.481674439000074, 45.912702535000065],
            [20.429067830000065, 45.94670562800012],
            [20.41025760900007, 45.955593974000024],
            [20.370983521000085, 45.96778961200003],
            [20.35393029800005, 45.97667795900004],
            [20.33863407400011, 45.99280100500003],
            [20.317653443000097, 46.038586324000065],
            [20.305664510000042, 46.053572490000036],
            [20.24282596900008, 46.10809112600005],
            [20.283236938000044, 46.143799540000074],
            [20.44415734900008, 46.146900126],
            [20.468548625000096, 46.17413360600001],
            [20.50937300600009, 46.16767405200004],
            [20.54895715300006, 46.15615020800003],
            [20.57810266100006, 46.13754669200007],
            [20.588024536000148, 46.13284413700008],
            [20.600116821000142, 46.12964019800002],
            [20.607558227000084, 46.12948516900006],
            [20.663988892000106, 46.1377533980001],
            [20.683522583000098, 46.1446780400001],
            [20.698818807000066, 46.15646026600011],
            [20.704193156000116, 46.16633046500009],
            [20.70436755600008, 46.16852631600004],
            [20.705330037000124, 46.18064483700006],
            [20.710290975000078, 46.188086243],
            [20.717835734000033, 46.18999827100002],
            [20.727137492000054, 46.1877245080001],
            [20.736645955000142, 46.18669097900003],
            [20.744707479000056, 46.19227203400003],
            [20.74481083200007, 46.200281881000095],
            [20.73550907400005, 46.222502747000036],
            [20.73499231000011, 46.2319078580001],
            [20.73933313000009, 46.237488913000035],
            [20.778503866000108, 46.26007151300006],
            [20.7873693330001, 46.26339038000005],
            [20.7986576750001, 46.26761627200001],
            [20.819638306000087, 46.27169871000011],
            [20.839688762000037, 46.27107859400006],
            [20.84899051900007, 46.26777130200004],
            [20.866973917000053, 46.25712595700004],
            [20.875138794000065, 46.25438710500002],
            [20.88506066900007, 46.25500722300008],
            [20.899736775000065, 46.26069163000004],
            [20.906558065000098, 46.26219024700002],
            [20.924438110000068, 46.2595547480001],
            [20.96174849500011, 46.248340963000075],
            [20.981488891000083, 46.2488577270001],
            [20.990583944000036, 46.25159657800005],
            [20.99916223200009, 46.25159657800005],
            [21.007017049000098, 46.2488577270001],
            [21.0139416910001, 46.24306996700004],
            [21.03347538200009, 46.23133941700006],
            [21.051458781000093, 46.23609364900004],
            [21.09920780400006, 46.27634958900008],
            [21.105615682000092, 46.27867502900001],
            [21.13486454200006, 46.27852],
            [21.144476359000066, 46.283739320000095],
            [21.155948527000078, 46.298932190000116],
            [21.1645268150001, 46.31825917600007],
            [21.168660929000026, 46.36275258500005],
            [21.178789510000087, 46.384456686000064],
            [21.19563602700015, 46.39809926400007],
            [21.215169718000055, 46.402905172000075],
            [21.257544393000074, 46.404171245],
            [21.28069543400008, 46.41639272100012],
            [21.27439091000005, 46.43835520500009],
            [21.245142049, 46.47687998500005],
            [21.24762251800007, 46.497473043000056],
            [21.261678508000102, 46.513337707000076],
            [21.27893843600009, 46.52840138800006],
            [21.291340779000052, 46.54672068300003],
            [21.295268188000136, 46.58503875800004],
            [21.300952596000087, 46.60392649400008],
            [21.316248820000027, 46.616638896000026],
            [21.337642863000042, 46.62041127500005],
            [21.374436483000125, 46.61844757100003],
            [21.396037231, 46.626354066000076],
            [21.41681115700007, 46.6452159630001],
            [21.42353891400009, 46.65823096900006],
            [21.425492797000118, 46.66201080300006],
            [21.436241495000047, 46.67374135300004],
            [21.46352665200004, 46.677048645000056],
            [21.483577108000105, 46.68485178600007],
            [21.501767212000033, 46.70350697900004],
            [21.505177856000074, 46.72324737600009],
            [21.478202759000027, 46.73593394000004],
            [21.47520552600011, 46.73784596800006],
            [21.47262170400012, 46.74019724600002],
            [21.470451294000043, 46.74301361100008],
            [21.47138146900008, 46.74903391500003],
            [21.473655232000084, 46.75487335300009],
            [21.477065877000115, 46.76022186300004],
            [21.481510051000043, 46.76497609500005],
            [21.502904094000144, 46.805309551],
            [21.515719848000117, 46.82158762700003],
            [21.536597128000096, 46.83502349900006],
            [21.573080689000108, 46.84176727300009],
            [21.583415975000037, 46.84794260700009],
            [21.59178755700009, 46.86070668600006],
            [21.591477498000103, 46.871532899],
            [21.58806685400009, 46.8822040810001],
            [21.587136678000036, 46.89439971900002],
            [21.588686971000044, 46.9061819460001],
            [21.589927206000084, 46.908869120000034],
            [21.59437137800009, 46.91000600200006],
            [21.64005334400011, 46.93568918900003],
            [21.648528279000118, 46.9429755660001],
            [21.667545207000074, 46.99237823500003],
            [21.671369262000013, 46.993360087],
            [21.67074914600005, 46.99439361600007],
            [21.66175744600011, 47.00607249000005],
            [21.654832805000126, 47.009948222],
            [21.64522098800012, 47.011240133000044],
            [21.636642700000095, 47.01408233700003],
            [21.634269538000098, 47.01942195100004],
            [21.632818644000054, 47.022686463000056],
            [21.67188602700014, 47.05472585100007],
            [21.694210246000125, 47.0691694130001],
            [21.743509562000014, 47.091596985000095],
            [21.76376672400002, 47.10521372600009],
            [21.770484659000147, 47.114024557000064],
            [21.77544559800009, 47.13167205800006],
            [21.779889770000096, 47.14074127200003],
            [21.78939823400009, 47.15030141300004],
            [21.8115157470001, 47.164693298000046],
            [21.819887329000068, 47.172728984000045],
            [21.825985148000115, 47.18505381300007],
            [21.82567508900013, 47.19427805600007],
            [21.82329797300011, 47.20332143200004],
            [21.823608033000085, 47.21492279100009],
            [21.827742147000095, 47.226007386],
            [21.839317668000064, 47.24083852200003],
            [21.84458866400007, 47.24993357300009],
            [21.856060831000093, 47.28574534100004],
            [21.862158651000072, 47.29742421500002],
            [21.900812622000075, 47.33574228900004],
            [21.919002726000087, 47.349669088],
            [21.93698612500009, 47.35716217100004],
            [21.9815312100001, 47.36610219400008],
            [22.00158166500003, 47.39382659900009],
            [22.00023807800008, 47.42718373600006],
            [21.991453084000085, 47.46180694600007],
            [21.988869263000083, 47.492941997000045],
            [22.007886189000146, 47.51741078700009],
            [22.03744510900009, 47.53932159400004],
            [22.099560180000054, 47.57094757200012],
            [22.14854943800006, 47.5793449910001],
            [22.154177334000053, 47.582212640000066],
            [22.162088663000134, 47.58624379500007],
            [22.167359660000074, 47.59378855400003],
            [22.167608011000112, 47.59486230700007],
            [22.169116658000064, 47.60138499],
            [22.16984012900005, 47.60877472],
            [22.172837361000063, 47.6153893030001],
            [22.19764204900011, 47.639315491],
            [22.20074263500007, 47.647945455000055],
            [22.20415327900008, 47.66629058900013],
            [22.20787398200008, 47.67373199500007],
            [22.215212036000082, 47.679933166000055],
            [22.2321619060001, 47.6882530730001],
            [22.23981001800007, 47.69347239200003],
            [22.26172082500011, 47.71584828800009],
            [22.27308964000011, 47.72375478200006],
            [22.291589803000136, 47.73070526100004],
            [22.309366495000063, 47.73504608200001],
            [22.322078898000115, 47.73587290500005],
            [22.368277628000072, 47.73117034900007],
            [22.38264367700009, 47.732023011000095],
            [22.395872843000063, 47.735692037],
            [22.407345012000093, 47.743081767],
            [22.42367476400011, 47.782562562000024],
            [22.454370565000147, 47.78739430800003],
            [22.52847456900011, 47.76103932700006],
            [22.562994426000074, 47.75721527200004],
            [22.601234985000076, 47.76093597500004],
            [22.637718547000077, 47.77155548100005],
            [22.66696740700013, 47.788789571],
            [22.691668741000058, 47.81070037900007],
            [22.70386438000014, 47.817185771000126],
            [22.724224894000088, 47.82349029500004],
            [22.745825643000046, 47.82498891200005],
            [22.75182010900008, 47.82767608600007],
            [22.760295044000088, 47.83891571100004],
            [22.75833134000007, 47.846227926000026],
            [22.75326705000009, 47.852687480000085],
            [22.752853637000072, 47.86123993000011],
            [22.763602335000087, 47.87475331700007],
            [22.779622029000052, 47.88229807500004],
            [22.819722941000123, 47.892323304000044],
            [22.836052693000084, 47.90245188400009],
            [22.861167440000088, 47.93381947800002],
            [22.877600546000053, 47.94673858700013],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Hungary',
        iso3: 'HUN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.877600546000053, 47.94673858700013],
            [22.861167440000088, 47.93381947800002],
            [22.836052693000084, 47.90245188400009],
            [22.819722941000123, 47.892323304000044],
            [22.779622029000052, 47.88229807500004],
            [22.763602335000087, 47.87475331700007],
            [22.752853637000072, 47.86123993000011],
            [22.75326705000009, 47.852687480000085],
            [22.75833134000007, 47.846227926000026],
            [22.760295044000088, 47.83891571100004],
            [22.75182010900008, 47.82767608600007],
            [22.745825643000046, 47.82498891200005],
            [22.724224894000088, 47.82349029500004],
            [22.70386438000014, 47.817185771000126],
            [22.691668741000058, 47.81070037900007],
            [22.66696740700013, 47.788789571],
            [22.637718547000077, 47.77155548100005],
            [22.601234985000076, 47.76093597500004],
            [22.562994426000074, 47.75721527200004],
            [22.52847456900011, 47.76103932700006],
            [22.454370565000147, 47.78739430800003],
            [22.42367476400011, 47.782562562000024],
            [22.407345012000093, 47.743081767],
            [22.395872843000063, 47.735692037],
            [22.38264367700009, 47.732023011000095],
            [22.368277628000072, 47.73117034900007],
            [22.322078898000115, 47.73587290500005],
            [22.309366495000063, 47.73504608200001],
            [22.291589803000136, 47.73070526100004],
            [22.27308964000011, 47.72375478200006],
            [22.26172082500011, 47.71584828800009],
            [22.23981001800007, 47.69347239200003],
            [22.2321619060001, 47.6882530730001],
            [22.215212036000082, 47.679933166000055],
            [22.20787398200008, 47.67373199500007],
            [22.20415327900008, 47.66629058900013],
            [22.20074263500007, 47.647945455000055],
            [22.19764204900011, 47.639315491],
            [22.172837361000063, 47.6153893030001],
            [22.16984012900005, 47.60877472],
            [22.169116658000064, 47.60138499],
            [22.167608011000112, 47.59486230700007],
            [22.167359660000074, 47.59378855400003],
            [22.162088663000134, 47.58624379500007],
            [22.154177334000053, 47.582212640000066],
            [22.14854943800006, 47.5793449910001],
            [22.099560180000054, 47.57094757200012],
            [22.03744510900009, 47.53932159400004],
            [22.007886189000146, 47.51741078700009],
            [21.988869263000083, 47.492941997000045],
            [21.991453084000085, 47.46180694600007],
            [22.00023807800008, 47.42718373600006],
            [22.00158166500003, 47.39382659900009],
            [21.9815312100001, 47.36610219400008],
            [21.93698612500009, 47.35716217100004],
            [21.919002726000087, 47.349669088],
            [21.900812622000075, 47.33574228900004],
            [21.862158651000072, 47.29742421500002],
            [21.856060831000093, 47.28574534100004],
            [21.84458866400007, 47.24993357300009],
            [21.839317668000064, 47.24083852200003],
            [21.827742147000095, 47.226007386],
            [21.823608033000085, 47.21492279100009],
            [21.82329797300011, 47.20332143200004],
            [21.82567508900013, 47.19427805600007],
            [21.825985148000115, 47.18505381300007],
            [21.819887329000068, 47.172728984000045],
            [21.8115157470001, 47.164693298000046],
            [21.78939823400009, 47.15030141300004],
            [21.779889770000096, 47.14074127200003],
            [21.77544559800009, 47.13167205800006],
            [21.770484659000147, 47.114024557000064],
            [21.76376672400002, 47.10521372600009],
            [21.743509562000014, 47.091596985000095],
            [21.694210246000125, 47.0691694130001],
            [21.67188602700014, 47.05472585100007],
            [21.632818644000054, 47.022686463000056],
            [21.634269538000098, 47.01942195100004],
            [21.636642700000095, 47.01408233700003],
            [21.64522098800012, 47.011240133000044],
            [21.654832805000126, 47.009948222],
            [21.66175744600011, 47.00607249000005],
            [21.67074914600005, 46.99439361600007],
            [21.671369262000013, 46.993360087],
            [21.667545207000074, 46.99237823500003],
            [21.648528279000118, 46.9429755660001],
            [21.64005334400011, 46.93568918900003],
            [21.59437137800009, 46.91000600200006],
            [21.589927206000084, 46.908869120000034],
            [21.588686971000044, 46.9061819460001],
            [21.587136678000036, 46.89439971900002],
            [21.58806685400009, 46.8822040810001],
            [21.591477498000103, 46.871532899],
            [21.59178755700009, 46.86070668600006],
            [21.583415975000037, 46.84794260700009],
            [21.573080689000108, 46.84176727300009],
            [21.536597128000096, 46.83502349900006],
            [21.515719848000117, 46.82158762700003],
            [21.502904094000144, 46.805309551],
            [21.481510051000043, 46.76497609500005],
            [21.477065877000115, 46.76022186300004],
            [21.473655232000084, 46.75487335300009],
            [21.47138146900008, 46.74903391500003],
            [21.470451294000043, 46.74301361100008],
            [21.47262170400012, 46.74019724600002],
            [21.47520552600011, 46.73784596800006],
            [21.478202759000027, 46.73593394000004],
            [21.505177856000074, 46.72324737600009],
            [21.501767212000033, 46.70350697900004],
            [21.483577108000105, 46.68485178600007],
            [21.46352665200004, 46.677048645000056],
            [21.436241495000047, 46.67374135300004],
            [21.425492797000118, 46.66201080300006],
            [21.42353891400009, 46.65823096900006],
            [21.41681115700007, 46.6452159630001],
            [21.396037231, 46.626354066000076],
            [21.374436483000125, 46.61844757100003],
            [21.337642863000042, 46.62041127500005],
            [21.316248820000027, 46.616638896000026],
            [21.300952596000087, 46.60392649400008],
            [21.295268188000136, 46.58503875800004],
            [21.291340779000052, 46.54672068300003],
            [21.27893843600009, 46.52840138800006],
            [21.261678508000102, 46.513337707000076],
            [21.24762251800007, 46.497473043000056],
            [21.245142049, 46.47687998500005],
            [21.27439091000005, 46.43835520500009],
            [21.28069543400008, 46.41639272100012],
            [21.257544393000074, 46.404171245],
            [21.215169718000055, 46.402905172000075],
            [21.19563602700015, 46.39809926400007],
            [21.178789510000087, 46.384456686000064],
            [21.168660929000026, 46.36275258500005],
            [21.1645268150001, 46.31825917600007],
            [21.155948527000078, 46.298932190000116],
            [21.144476359000066, 46.283739320000095],
            [21.13486454200006, 46.27852],
            [21.105615682000092, 46.27867502900001],
            [21.09920780400006, 46.27634958900008],
            [21.051458781000093, 46.23609364900004],
            [21.03347538200009, 46.23133941700006],
            [21.0139416910001, 46.24306996700004],
            [21.007017049000098, 46.2488577270001],
            [20.99916223200009, 46.25159657800005],
            [20.990583944000036, 46.25159657800005],
            [20.981488891000083, 46.2488577270001],
            [20.96174849500011, 46.248340963000075],
            [20.924438110000068, 46.2595547480001],
            [20.906558065000098, 46.26219024700002],
            [20.899736775000065, 46.26069163000004],
            [20.88506066900007, 46.25500722300008],
            [20.875138794000065, 46.25438710500002],
            [20.866973917000053, 46.25712595700004],
            [20.84899051900007, 46.26777130200004],
            [20.839688762000037, 46.27107859400006],
            [20.819638306000087, 46.27169871000011],
            [20.7986576750001, 46.26761627200001],
            [20.7873693330001, 46.26339038000005],
            [20.778503866000108, 46.26007151300006],
            [20.73933313000009, 46.237488913000035],
            [20.73499231000011, 46.2319078580001],
            [20.73550907400005, 46.222502747000036],
            [20.74481083200007, 46.200281881000095],
            [20.744707479000056, 46.19227203400003],
            [20.736645955000142, 46.18669097900003],
            [20.727137492000054, 46.1877245080001],
            [20.717835734000033, 46.18999827100002],
            [20.710290975000078, 46.188086243],
            [20.705330037000124, 46.18064483700006],
            [20.70436755600008, 46.16852631600004],
            [20.704193156000116, 46.16633046500009],
            [20.698818807000066, 46.15646026600011],
            [20.683522583000098, 46.1446780400001],
            [20.663988892000106, 46.1377533980001],
            [20.607558227000084, 46.12948516900006],
            [20.600116821000142, 46.12964019800002],
            [20.588024536000148, 46.13284413700008],
            [20.57810266100006, 46.13754669200007],
            [20.54895715300006, 46.15615020800003],
            [20.50937300600009, 46.16767405200004],
            [20.468548625000096, 46.17413360600001],
            [20.44415734900008, 46.146900126],
            [20.283236938000044, 46.143799540000074],
            [20.24282596900008, 46.10809112600005],
            [20.18846236100009, 46.14038889600003],
            [20.17047896400001, 46.14550486200004],
            [20.145364217000093, 46.137081604000045],
            [20.13802616400011, 46.13646148700006],
            [20.130378051000037, 46.13935536800007],
            [20.120146118000036, 46.14922556600003],
            [20.114771769000072, 46.15222279900006],
            [20.09844201700014, 46.15496165000009],
            [20.088623495000064, 46.15413482700008],
            [20.06340539600012, 46.145298157000056],
            [20.0349833570001, 46.14297271800005],
            [19.993125447000125, 46.159405823],
            [19.929150024000137, 46.16353993800003],
            [19.888945760000126, 46.15739044200005],
            [19.873648872000103, 46.15299238600004],
            [19.79045048000006, 46.12907175800005],
            [19.772983846000102, 46.13155222600004],
            [19.711888678000065, 46.15870986600008],
            [19.690094848000086, 46.168397522000035],
            [19.669320923000043, 46.17310007700003],
            [19.6478235270001, 46.17387522400013],
            [19.589739217000044, 46.165968730000074],
            [19.568448527000044, 46.1664338180001],
            [19.5499483640001, 46.164160055000096],
            [19.5252470290001, 46.15640859000008],
            [19.50199263500008, 46.14560821500005],
            [19.487523234000065, 46.13423940100007],
            [19.489280233000045, 46.126022848000034],
            [19.496721639000043, 46.11687612000004],
            [19.499305461000063, 46.1086078900001],
            [19.472950480000094, 46.098686016],
            [19.46592248500008, 46.09196807900007],
            [19.4608581950001, 46.084474996000054],
            [19.45372684700007, 46.07755035500007],
            [19.436880330000093, 46.06799021400006],
            [19.428302043000144, 46.065509746000075],
            [19.417243286000144, 46.06432118800008],
            [19.404737590000053, 46.06023875000007],
            [19.396572713000126, 46.0515571080001],
            [19.389131307000127, 46.04153188100007],
            [19.378899373000138, 46.03367706400003],
            [19.36215620900009, 46.02964630100006],
            [19.32515588400014, 46.02949127300009],
            [19.30696577900008, 46.02664906900013],
            [19.298314567000062, 46.02212279000007],
            [19.286915324000063, 46.016158753000084],
            [19.27947391800012, 46.003808086000035],
            [19.27482303900007, 45.99161244800011],
            [19.263454223000082, 45.981432190000035],
            [19.23565230300011, 45.977711487000036],
            [19.1480090740001, 45.98406768800005],
            [19.125788208000074, 45.99311106400002],
            [19.125788208000074, 45.99326609300006],
            [19.111008748000046, 46.01295481400011],
            [19.088477824000023, 46.0188459270001],
            [19.06543013500007, 46.01202463800006],
            [19.04972050000009, 45.99311106400002],
            [19.048583618000094, 45.96344879200005],
            [19.030910279000096, 45.96003814700005],
            [19.00558882700011, 45.96257029300001],
            [18.981817668000133, 45.9507880660001],
            [18.9787170810001, 45.94717071600003],
            [18.977683553000134, 45.94350168900003],
            [18.978820434000028, 45.93978098600003],
            [18.9864685470001, 45.93125437500002],
            [18.988742310000134, 45.927016907000066],
            [18.987502076000084, 45.923812969],
            [18.981817668000133, 45.921849264000045],
            [18.962697388000066, 45.927947083],
            [18.90130578600008, 45.931202698],
            [18.88652632700007, 45.9304275520001],
            [18.876604452000066, 45.92241770500003],
            [18.865442342000023, 45.91807688400003],
            [18.84539188700009, 45.913942770000105],
            [18.828338664000057, 45.905726217000066],
            [18.82245067200003, 45.90558190400013],
            [18.81779667200007, 45.905467835000096],
            [18.804877563000076, 45.913632711000034],
            [18.794852336000133, 45.90303904200006],
            [18.790408162000034, 45.89389231400007],
            [18.785963989000038, 45.88691599600007],
            [18.775525350000095, 45.88283355700007],
            [18.763329712000086, 45.883970439000066],
            [18.723848918000073, 45.89843984],
            [18.6743428960001, 45.91037709600003],
            [18.655636027000128, 45.90758656800007],
            [18.633001750000062, 45.89192861000002],
            [18.629281046000074, 45.886864319000054],
            [18.626283813000043, 45.874823711],
            [18.623596639000112, 45.86867421500001],
            [18.62214969900012, 45.86841583300004],
            [18.60737023900012, 45.85668528200004],
            [18.58545943200005, 45.82691965800005],
            [18.57347049900011, 45.81668772400009],
            [18.530269002000068, 45.79084950800005],
            [18.504224081000075, 45.784028219],
            [18.481796509000077, 45.791417949000035],
            [18.46546675600007, 45.78371816000002],
            [18.430740194000123, 45.75364247700004],
            [18.411723267000042, 45.743203837000024],
            [18.40438521300007, 45.741808574000046],
            [18.39756392400011, 45.74134348600002],
            [18.390742635000066, 45.741808574000046],
            [18.38412805200005, 45.743100484000095],
            [18.383817993000065, 45.743203837000024],
            [18.367178182000146, 45.758190003],
            [18.351158488000095, 45.75839670900005],
            [18.334932088000073, 45.751988831000105],
            [18.317672160000086, 45.74728627500012],
            [18.30051558400004, 45.751833802000064],
            [18.283255655000062, 45.76490793900011],
            [18.260518026000057, 45.765114644000064],
            [18.229822225000134, 45.78123769200006],
            [18.211218709000065, 45.78537180600007],
            [18.128949829000106, 45.78537180600007],
            [18.12016483500014, 45.78340810200005],
            [18.10290490700004, 45.77462310800006],
            [18.092052856000095, 45.77172922800007],
            [18.08047733500004, 45.77172922800007],
            [17.9753674720001, 45.7921414180001],
            [17.906234389000133, 45.7921414180001],
            [17.889791300000127, 45.7921414180001],
            [17.880489542000106, 45.78852406800003],
            [17.875735311000113, 45.780669251000106],
            [17.870050903000077, 45.77348622600006],
            [17.858061971000012, 45.77172922800007],
            [17.857958618000083, 45.775863342],
            [17.83821822100012, 45.79963450100006],
            [17.809176066000134, 45.81441396100006],
            [17.687323038000045, 45.84061391300007],
            [17.664688761000065, 45.84164744100006],
            [17.65652388500007, 45.84541982000009],
            [17.654669375000083, 45.85211344100004],
            [17.653216593000053, 45.85735707600013],
            [17.652079712000045, 45.868829244000054],
            [17.646912069000052, 45.883712057000096],
            [17.64577518700014, 45.891825256000104],
            [17.638437134000128, 45.90133372000007],
            [17.59110152100007, 45.93621531200007],
            [17.55430790200009, 45.94779083200011],
            [17.51193322800006, 45.95394032800009],
            [17.42666711400011, 45.95673085500003],
            [17.4181921790001, 45.95301015200003],
            [17.415401652000128, 45.949702860000016],
            [17.411577596000114, 45.946602275000075],
            [17.406203247000036, 45.94365671800007],
            [17.399692017000064, 45.959934794],
            [17.389150024000116, 45.96308705700007],
            [17.36527551200004, 45.95673085500003],
            [17.345328410000093, 45.95569732700007],
            [17.34212447100012, 45.95864288300005],
            [17.34367476400007, 45.96753123000006],
            [17.337887003000077, 45.98463612900012],
            [17.32713830600005, 45.97202707999999],
            [17.316596314000094, 45.973784078000065],
            [17.306613213000105, 45.979914052000126],
            [17.304814087000096, 45.981018778000035],
            [17.29013798000011, 45.98463612900012],
            [17.29013798000011, 45.99145741800008],
            [17.29695927000006, 45.99264597600008],
            [17.309361613000135, 45.996625061000074],
            [17.316803019000048, 45.99765859000006],
            [17.3078113200001, 46.00639190700012],
            [17.291481567000062, 46.007942200000045],
            [17.27587528500004, 46.01202463800006],
            [17.268950643000068, 46.02871612600008],
            [17.266573527000105, 46.038793030000036],
            [17.25406783000011, 46.07083241800005],
            [17.248590128000018, 46.080237529],
            [17.208592570000064, 46.11656606000007],
            [17.19732710800008, 46.121165263000094],
            [17.116195109000046, 46.123128967000056],
            [17.101208943000074, 46.128193258000024],
            [17.052943156000055, 46.153463033],
            [17.0412642820001, 46.16219635100005],
            [17.036303344000146, 46.17299672500009],
            [17.028035116000098, 46.18048980800005],
            [16.974808390000135, 46.21056549100011],
            [16.965299926000057, 46.21945383700002],
            [16.940701945000058, 46.25149322600002],
            [16.903288208000106, 46.2819306440001],
            [16.89605350700012, 46.28627146400008],
            [16.889232218000075, 46.29216257800006],
            [16.879311877000134, 46.312061961000055],
            [16.87176558400003, 46.32719919900008],
            [16.875072876000047, 46.34285715800006],
            [16.865461060000115, 46.35913523400008],
            [16.859410685000086, 46.36475790900006],
            [16.850474894000058, 46.37306203200005],
            [16.837659139000067, 46.381872864000044],
            [16.83238814300003, 46.38192454100006],
            [16.83021773200005, 46.37735117600003],
            [16.82753055800012, 46.37401804600002],
            [16.820915975000105, 46.37810048500002],
            [16.816575154000134, 46.38197621700009],
            [16.81233768700008, 46.385025127000105],
            [16.807893514000085, 46.38735056600005],
            [16.80344934100006, 46.38869415300009],
            [16.776474243000052, 46.39287994400003],
            [16.769342895000108, 46.396109721000116],
            [16.76190148900008, 46.381872864000044],
            [16.755080200000123, 46.381872864000044],
            [16.742884562000114, 46.39962371800006],
            [16.712395467000135, 46.41267201800012],
            [16.69358524600011, 46.42962188800003],
            [16.677462199000047, 46.44869049100002],
            [16.65927209500009, 46.46419342100002],
            [16.637671346000047, 46.474477031],
            [16.611109660000096, 46.47806854200009],
            [16.602117960000072, 46.482047628000075],
            [16.59426314300012, 46.4829778040001],
            [16.58806197100006, 46.4795671590001],
            [16.583721151000077, 46.47065297500008],
            [16.577623332000115, 46.47065297500008],
            [16.56429081200008, 46.47992889400008],
            [16.52108931500007, 46.49853241000004],
            [16.515301554000075, 46.50171051000011],
            [16.500832153000147, 46.54480865500001],
            [16.46713911900008, 46.564704082000034],
            [16.430242147000058, 46.604391582000105],
            [16.39458540800007, 46.619016012000074],
            [16.37639530400014, 46.62909291600003],
            [16.372245692000064, 46.63634126300006],
            [16.36843713300007, 46.642993876],
            [16.377635539000067, 46.65286407500007],
            [16.39665246600015, 46.65914276200009],
            [16.40260705700007, 46.66310878600005],
            [16.410501749000105, 46.66836700500009],
            [16.405024048000115, 46.68725474100002],
            [16.39003788200006, 46.694153545000106],
            [16.37143436700009, 46.6949286910001],
            [16.3662163730001, 46.69646683100008],
            [16.36538307300006, 46.69671246800009],
            [16.357585082000128, 46.69901112900003],
            [16.357275024000046, 46.71583180800009],
            [16.34342574100009, 46.71417816200004],
            [16.33412398300007, 46.721748759],
            [16.32554569500013, 46.73327260400002],
            [16.31417687900003, 46.743323670000066],
            [16.300430949000088, 46.77208160500008],
            [16.298157186000083, 46.77580230800008],
            [16.29948988400014, 46.779509942000075],
            [16.302187948000068, 46.78701609300002],
            [16.311097363000044, 46.79751906200006],
            [16.31490035000013, 46.802002259000105],
            [16.321824992000103, 46.81326772100006],
            [16.327509400000054, 46.82546335900007],
            [16.32978316200007, 46.834403382000104],
            [16.325338989000073, 46.839441834000084],
            [16.310662883000077, 46.84001027500004],
            [16.30187788900008, 46.84321421300008],
            [16.297392209000122, 46.84703294300003],
            [16.282240845000047, 46.859931539000044],
            [16.272008911000086, 46.86396230100003],
            [16.17948639500011, 46.85846833900003],
            [16.135376424000043, 46.85584910100003],
            [16.130245696000088, 46.85670849800009],
            [16.09403527800012, 46.862773743],
            [16.110054972000086, 46.86791554800003],
            [16.122870728000066, 46.876364645000095],
            [16.159147583000106, 46.910316061000046],
            [16.170723104000047, 46.91853261300007],
            [16.196147909000075, 46.93129669200003],
            [16.217025187000047, 46.937394511],
            [16.223949829000105, 46.941063538],
            [16.230667765000135, 46.948349915000065],
            [16.231184530000093, 46.95442189500001],
            [16.230357707000053, 46.95997711200003],
            [16.232941528000055, 46.96607493100008],
            [16.243070109000115, 46.972017721],
            [16.25299198400012, 46.973516338000096],
            [16.2610535070001, 46.97808970200005],
            [16.26539432800007, 46.99325673500006],
            [16.274902791000073, 47.00431549100007],
            [16.288545369000076, 47.00558156400011],
            [16.3258557530001, 47.0004397580001],
            [16.366576782000067, 47.003824565000045],
            [16.387764120000043, 47.002041728000066],
            [16.405024048000115, 46.993153382000045],
            [16.41039839600009, 46.9904145310001],
            [16.415566040000073, 46.98943267900002],
            [16.420423625000097, 46.99025950100004],
            [16.42476444500008, 46.9929983520001],
            [16.42476444500008, 46.99310170500003],
            [16.441404256000112, 46.995220439],
            [16.467449178000066, 46.99542714500005],
            [16.486362752000105, 46.998553569000094],
            [16.48191857900011, 47.00937978100005],
            [16.46755253100011, 47.0184231570001],
            [16.453289836000124, 47.02167877300009],
            [16.424661092000065, 47.024081726000034],
            [16.43716678800004, 47.03178151500005],
            [16.48191857900011, 47.04420969700003],
            [16.493184041000063, 47.04914479600005],
            [16.497214803000077, 47.05462249800003],
            [16.493700805000117, 47.05981597900005],
            [16.48191857900011, 47.06389841700006],
            [16.46176477100005, 47.068497620000116],
            [16.454323364000118, 47.081700949],
            [16.46083459500008, 47.09629954000006],
            [16.48191857900011, 47.1052395630001],
            [16.504759563000107, 47.12583262100007],
            [16.50951379300011, 47.13753733400007],
            [16.49731815600009, 47.149681295000065],
            [16.480885051000115, 47.150766501000064],
            [16.447088664000148, 47.139707743000045],
            [16.43365279200009, 47.145753886000094],
            [16.433962850000086, 47.15128326500009],
            [16.4421277270001, 47.16833648700005],
            [16.441817667000123, 47.177121480000025],
            [16.435099732000083, 47.183581034000085],
            [16.426728149000013, 47.18412363700013],
            [16.418769979000047, 47.18365855000009],
            [16.41277551200011, 47.18717254600004],
            [16.409261515000082, 47.20368316600003],
            [16.424661092000065, 47.22559397400009],
            [16.42135380000005, 47.24303477000002],
            [16.42135380000005, 47.243138123000065],
            [16.452463012000095, 47.25458445300008],
            [16.46662235500014, 47.26342112300007],
            [16.473236938000042, 47.276805319000104],
            [16.469206177000046, 47.29323842400008],
            [16.43882043500011, 47.33656911300004],
            [16.436133260000076, 47.338558655000085],
            [16.431689087000052, 47.33972137500011],
            [16.42714156100004, 47.34137502000006],
            [16.42435103400007, 47.34519907700009],
            [16.42497115000012, 47.351116028],
            [16.429311971000118, 47.35380320200004],
            [16.434272908000054, 47.3555602010001],
            [16.436443319000148, 47.35850575800002],
            [16.433962850000086, 47.39684967100003],
            [16.444091430000128, 47.40951039700006],
            [16.456597128000027, 47.411835836000094],
            [16.469929647000043, 47.40553131200009],
            [16.48191857900011, 47.39230214500007],
            [16.589405558000124, 47.42563344400004],
            [16.626973417000045, 47.44554893500002],
            [16.64087528400009, 47.45291860000005],
            [16.636844523000093, 47.493200378],
            [16.64821333900008, 47.50154612200008],
            [16.677358846000118, 47.50986602800005],
            [16.68800419100009, 47.5226301070001],
            [16.689141072000012, 47.538029684],
            [16.681389608000103, 47.55056121900007],
            [16.66754032400013, 47.560095521000065],
            [16.650590454000053, 47.56655507400005],
            [16.656171509000046, 47.585933737000104],
            [16.647696574000065, 47.606139221],
            [16.630229940000106, 47.62200388600009],
            [16.60842248600008, 47.62877349900005],
            [16.575452921000107, 47.624949443],
            [16.509617147000142, 47.64313954700005],
            [16.48191857900011, 47.63895375600002],
            [16.425901326000087, 47.65427581800007],
            [16.40781457500009, 47.66132965100009],
            [16.416599568000066, 47.66882273400002],
            [16.431792440000095, 47.68546254500005],
            [16.43913049300008, 47.69047515900009],
            [16.444918254000072, 47.685540060000065],
            [16.449879191000093, 47.68241363500003],
            [16.45453007000006, 47.68176768000005],
            [16.461144653000076, 47.6845323700001],
            [16.4730302320001, 47.69176707000007],
            [16.51292443800014, 47.706003927000026],
            [16.521399373000122, 47.71153330500003],
            [16.52687707500013, 47.720137431000055],
            [16.525120076000064, 47.73331492100006],
            [16.53111454200007, 47.74297841500008],
            [16.56780481000004, 47.75419220000002],
            [16.60976607300006, 47.75062652600006],
            [16.689864543000112, 47.72956838000003],
            [16.702473592000047, 47.723599752],
            [16.707847941000097, 47.71460805300005],
            [16.711568644000096, 47.704066061],
            [16.719216756000094, 47.69373077400009],
            [16.73037886600011, 47.68590179500005],
            [16.741127564000124, 47.68145762200005],
            [16.79745487400004, 47.67546315600002],
            [16.80623986800012, 47.676884257000026],
            [16.81729862500012, 47.68424814900003],
            [16.83693566900007, 47.705357971000055],
            [16.850164836000147, 47.712928569],
            [16.86473758900013, 47.68672861700007],
            [16.902668091000123, 47.68202606200002],
            [16.98193973800008, 47.69543609600005],
            [17.054803508000077, 47.70202484200006],
            [17.075370728000053, 47.70848439600009],
            [17.064001912000066, 47.71329030400001],
            [17.055526977000056, 47.72091257800007],
            [17.05056604000012, 47.73098948200003],
            [17.048705689000116, 47.76364898700008],
            [17.041987752000097, 47.78390614900009],
            [17.040644165000117, 47.80111440000006],
            [17.0556303300001, 47.81235402500003],
            [17.04911910000004, 47.81868438800005],
            [17.03950728300012, 47.83736541800003],
            [17.031652466000082, 47.841344504000105],
            [17.010671834000078, 47.84788157200008],
            [17.004367310000077, 47.8523774210001],
            [17.00405725100009, 47.86328114800007],
            [17.016562948000086, 47.86769948300007],
            [17.051186157000075, 47.87289296500008],
            [17.06761926200005, 47.881626282000056],
            [17.07754113800013, 47.89172902500009],
            [17.083328898000104, 47.904829],
            [17.087463013000047, 47.922631531],
            [17.08539595500008, 47.92462107400003],
            [17.080124959000045, 47.92575795500004],
            [17.07516402200011, 47.92777333600007],
            [17.074130493000013, 47.93211415700007],
            [17.076817668000047, 47.934956360000044],
            [17.086119426000067, 47.939219666],
            [17.088083130000115, 47.94089915000005],
            [17.09087365700006, 47.94947743800007],
            [17.095731242000085, 47.955730286000076],
            [17.096144653000096, 47.96193145800005],
            [17.085602661000053, 47.97014801100009],
            [17.148337850000075, 48.005443014],
            [17.184821411000087, 48.02027415000002],
            [17.220891560000098, 48.015054830000096],
            [17.262316384000115, 48.007282508000046],
            [17.272671346000067, 48.005339661000065],
            [17.337887003000077, 47.99872507700006],
            [17.36940962800014, 47.9812067670001],
            [17.472039022000047, 47.8888093070001],
            [17.481857544000093, 47.88271148800003],
            [17.492192830000107, 47.87981760700005],
            [17.51730757600012, 47.87625193300009],
            [17.526609334000057, 47.87211781800006],
            [17.560405721000052, 47.83798553500007],
            [17.572601359000146, 47.82953643800009],
            [17.582936646000064, 47.82979482100005],
            [17.592961873000093, 47.83310211200005],
            [17.604227335000132, 47.834238993000056],
            [17.61911014800009, 47.829226380000094],
            [17.639884074000122, 47.819201152000076],
            [17.658384236000074, 47.807315573000054],
            [17.6662390540001, 47.797031963000066],
            [17.676677693000045, 47.78917714500004],
            [17.719244921000097, 47.773669069000036],
            [17.741996704000087, 47.76538014800006],
            [17.82571252400004, 47.75000640900008],
            [17.883531848000132, 47.75252142500007],
            [18.11262007600007, 47.76248626700006],
            [18.235920044000096, 47.753882141000034],
            [18.27302372200006, 47.75625925700008],
            [18.347851196000107, 47.77677480100006],
            [18.552593221000024, 47.79284617200001],
            [18.597448364000115, 47.79064992300003],
            [18.633828572000084, 47.77982371100008],
            [18.66369755000011, 47.77589630100003],
            [18.69284305800005, 47.77796335900008],
            [18.717234334000068, 47.78811777800003],
            [18.750307251000038, 47.813620097000054],
            [18.767670532000068, 47.82230173800012],
            [18.790304810000123, 47.82633249900003],
            [18.814916380000057, 47.83219355500002],
            [18.81645308500012, 47.83255950900009],
            [18.77800581900007, 47.851447245000045],
            [18.748756958000115, 47.870722555000086],
            [18.742245727000068, 47.889455262000055],
            [18.744726196000045, 47.910513408],
            [18.754751424000062, 47.95180287700002],
            [18.751444133000064, 47.96335256000005],
            [18.744519490000073, 47.96735748300004],
            [18.743175903000093, 47.97105234800004],
            [18.756198364000056, 47.981826885000075],
            [18.765293416000105, 47.98539255800004],
            [18.784723754000083, 47.98761464500005],
            [18.794232218000076, 47.993144023000056],
            [18.821000610000056, 48.03045440700008],
            [18.8384672440001, 48.04001454700007],
            [18.933595170000075, 48.05434889200002],
            [18.981817668000133, 48.061615296000056],
            [18.996493774000044, 48.06621449800009],
            [19.019016511000103, 48.065496862000046],
            [19.03866174300009, 48.06487091100003],
            [19.09850305200007, 48.07073618600002],
            [19.222526489000046, 48.06058176700007],
            [19.233481893000118, 48.06208038400008],
            [19.293219849000053, 48.08776357100005],
            [19.428198690000045, 48.08585154300003],
            [19.48173547300007, 48.11132802300004],
            [19.483285767000098, 48.11649566600006],
            [19.483802531000038, 48.12176666300009],
            [19.483285767000098, 48.12719268800005],
            [19.48173547300007, 48.13267039000006],
            [19.481425415000103, 48.13334218300004],
            [19.48121870900013, 48.13396230100001],
            [19.481425415000103, 48.13442738900004],
            [19.48173547300007, 48.134892477000065],
            [19.493621053000112, 48.15070546500006],
            [19.50302616400006, 48.18941111200006],
            [19.513981567000144, 48.20395802900002],
            [19.53124149500013, 48.21065012700005],
            [19.62322554500011, 48.22700571700007],
            [19.6338708910001, 48.226773173000126],
            [19.643896118000043, 48.224809469],
            [19.655264933000126, 48.21834991500005],
            [19.67696903400011, 48.200392354000044],
            [19.686994263000145, 48.1969041950001],
            [19.733089640000088, 48.20289866200004],
            [19.756550740000137, 48.20031484000005],
            [19.77432743300008, 48.18589711600002],
            [19.774844197000107, 48.17607859300004],
            [19.76915979000009, 48.16744862900002],
            [19.76667932100011, 48.15899953200001],
            [19.77608443200006, 48.149516907000034],
            [19.785592895000036, 48.14869008400011],
            [19.821663045000037, 48.157914327000114],
            [19.84626102700011, 48.152669169],
            [19.884294881000073, 48.129621480000125],
            [19.905068806000088, 48.12429880800006],
            [19.92863326000011, 48.13008656800004],
            [19.97390181500009, 48.15837941500003],
            [19.99694950400007, 48.16791371700002],
            [20.0349833570001, 48.1758718870001],
            [20.038302702000124, 48.177233057000095],
            [20.078081502000117, 48.193545228000076],
            [20.096995077000145, 48.1984286510001],
            [20.105263305000108, 48.20279530900011],
            [20.11260135900008, 48.21173533200003],
            [20.11807906100009, 48.229718730000016],
            [20.12200646900004, 48.23674672500003],
            [20.13451216700014, 48.24666860000012],
            [20.143090454000088, 48.24780548100004],
            [20.15332238700006, 48.24527333600004],
            [20.170892375000022, 48.24403310200002],
            [20.18763553900007, 48.24899403900007],
            [20.21781457500009, 48.26759755500011],
            [20.22908003700013, 48.27090484700001],
            [20.249027140000067, 48.26418691],
            [20.260292602000106, 48.255892843000126],
            [20.27238488800009, 48.252456360000096],
            [20.2952258710001, 48.26041453100005],
            [20.324268026000112, 48.27994822300006],
            [20.349279419000084, 48.30547638000009],
            [20.370156697000084, 48.33433766700004],
            [20.409017374000115, 48.4137126670001],
            [20.420592895000084, 48.42924143500004],
            [20.435579060000038, 48.4423930870001],
            [20.46596804300009, 48.46379039200012],
            [20.46823856600011, 48.46538909900006],
            [20.481674439000074, 48.47874745700007],
            [20.482501261000095, 48.48226145500003],
            [20.482914673000096, 48.485827128000025],
            [20.48281132000008, 48.48936696400007],
            [20.4821912030001, 48.49288096200003],
            [20.48022749800009, 48.51021840400004],
            [20.480537557000076, 48.518538310000096],
            [20.481674439000074, 48.52608306900005],
            [20.510509888000115, 48.53378285800004],
            [20.572521606000066, 48.536573385000096],
            [20.784084920000055, 48.569052023000026],
            [20.80031132000005, 48.569232890000066],
            [20.815814250000074, 48.563806864000085],
            [20.84547652100011, 48.545823466000016],
            [20.859945922000065, 48.54331716000003],
            [20.891365193000098, 48.54109507200012],
            [20.945832154000072, 48.51897756000001],
            [20.981488891000083, 48.516858826000046],
            [21.006500285000072, 48.518150737],
            [21.035955851000068, 48.51463673900004],
            [21.06386112400014, 48.506239319000045],
            [21.08401493300005, 48.49301015300007],
            [21.10933638500012, 48.4891085820001],
            [21.186747680000053, 48.51370656400009],
            [21.219923950000066, 48.51871917700005],
            [21.238010702000082, 48.513448182],
            [21.25041304500013, 48.506497701000015],
            [21.261781861000117, 48.503190410000016],
            [21.27656132000004, 48.50871978800002],
            [21.28824019400011, 48.51993357400006],
            [21.29392460100007, 48.530578918000074],
            [21.302296183000124, 48.539906515],
            [21.32182987400006, 48.54758046500008],
            [21.338573038000106, 48.549854228000086],
            [21.37267948400006, 48.55034515400003],
            [21.424562622000053, 48.5612747200001],
            [21.43913537600011, 48.55832916300001],
            [21.472725057000048, 48.544996644],
            [21.490811809000064, 48.540268250000096],
            [21.4993900960001, 48.535074769000076],
            [21.506004679000085, 48.52649648000006],
            [21.515099732000067, 48.5071178190001],
            [21.52181766700008, 48.500089824000085],
            [21.537734008000115, 48.49523223900006],
            [21.57463098100004, 48.495568136000045],
            [21.591684204000074, 48.49301015300007],
            [21.600365844000123, 48.481641337000056],
            [21.613388305000058, 48.440351868000064],
            [21.62155318200007, 48.42965484600005],
            [21.677570434000103, 48.37234568300006],
            [21.701238240000123, 48.35394887300008],
            [21.72769657400002, 48.34090057400003],
            [21.759012492000124, 48.333769226000086],
            [21.78939823400009, 48.335526225000066],
            [21.84117801900007, 48.353173727000055],
            [21.884276164000056, 48.35746287100004],
            [21.91476525900015, 48.36909006800009],
            [21.929338012000102, 48.37291412400002],
            [21.9815312100001, 48.374722799000025],
            [21.999928019000095, 48.37896026700007],
            [22.01801477100011, 48.37973541300009],
            [22.07785607900007, 48.37580800400012],
            [22.096459595000113, 48.379425354],
            [22.11392622900007, 48.3886495980001],
            [22.13283980300011, 48.404798483],
            [22.15650760900013, 48.40205963100006],
            [22.158263205000083, 48.40222218700008],
            [22.159298136000103, 48.402318014000016],
            [22.16922001100008, 48.40952687600007],
            [22.20198286900009, 48.41815684000004],
            [22.236089315000072, 48.41528879800005],
            [22.271849406000086, 48.403454895000024],
            [22.25696659300013, 48.373224182000016],
            [22.25675988800006, 48.357282003000066],
            [22.28435510300008, 48.35839304700009],
            [22.291279744000065, 48.35756622400005],
            [22.29872115100008, 48.34914296500007],
            [22.29872115100008, 48.33932444300011],
            [22.296447388000047, 48.32780059800008],
            [22.29737756300011, 48.31400299100004],
            [22.30812626100004, 48.293694153],
            [22.357115519000047, 48.24310292600005],
            [22.363626749000105, 48.23871042900005],
            [22.370861450000064, 48.2373926800001],
            [22.378612915000076, 48.23886545900011],
            [22.386467732000114, 48.24305125000005],
            [22.390498495000116, 48.2443431600001],
            [22.394529256000112, 48.2447565720001],
            [22.39876672400007, 48.2443431600001],
            [22.418403768000104, 48.23896881100005],
            [22.434216756000097, 48.23674672500003],
            [22.449719686000094, 48.23767690000007],
            [22.469046672000047, 48.24413645400004],
            [22.4732841390001, 48.244498190000044],
            [22.477418254000042, 48.24392974900009],
            [22.481449015000123, 48.24258616200002],
            [22.555759725000115, 48.17716379900004],
            [22.568885539000092, 48.15651906300003],
            [22.58304488100012, 48.12481557300002],
            [22.60009810300005, 48.10112192800007],
            [22.605472453000118, 48.09703949000006],
            [22.60805627400012, 48.096832784000114],
            [22.621182088000097, 48.10176788400007],
            [22.693219035000055, 48.10176788400007],
            [22.71161584500007, 48.10582448400005],
            [22.72856571400007, 48.11313669900004],
            [22.745722290000117, 48.11628896100011],
            [22.762052043000068, 48.10926096600009],
            [22.765566040000124, 48.1045325730001],
            [22.801429484000067, 48.09096750900004],
            [22.830988403000106, 48.0724415080001],
            [22.84432092300011, 48.0610468550001],
            [22.85475956200014, 48.047300924000055],
            [22.8615808510001, 48.02838735000002],
            [22.857963501000114, 48.01802622600009],
            [22.851348918000042, 48.008801982000094],
            [22.84948856600002, 47.993144023000056],
            [22.8324353430001, 47.97893300400007],
            [22.840806925000066, 47.96678904300008],
            [22.877600546000053, 47.94673858700013],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Slovakia',
        iso3: 'SVK',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [22.539636678000136, 49.072199606000126],
            [22.531988566000052, 49.05571482400005],
            [22.524753865000093, 49.03287384100004],
            [22.52010298600004, 49.00982615200009],
            [22.52051639800004, 48.992927958000095],
            [22.50501346900012, 48.98424631800005],
            [22.46656620300007, 48.98052561500002],
            [22.448996216000097, 48.97143056200004],
            [22.427292114000096, 48.92946930000004],
            [22.41488977100005, 48.91169260700012],
            [22.413649536000094, 48.90678334600007],
            [22.413752889000136, 48.89386423800006],
            [22.4117891840001, 48.887766419000016],
            [22.402384074000054, 48.87882639600009],
            [22.378406210000037, 48.86544220000006],
            [22.370798705000112, 48.85824814700008],
            [22.36889774600013, 48.856450501000026],
            [22.36228316200004, 48.844254862000085],
            [22.36155969300006, 48.836451722000064],
            [22.36352339600009, 48.82828684500005],
            [22.36569380700007, 48.79438710600006],
            [22.363420044000065, 48.7876174930001],
            [22.356495402000064, 48.77614532500009],
            [22.34781376100011, 48.76787709600005],
            [22.338408650000048, 48.762967835000026],
            [22.330760539000067, 48.75640492800004],
            [22.327659953000136, 48.74302073200009],
            [22.328900187000073, 48.72157501300005],
            [22.32249230900004, 48.700335999000075],
            [22.310296671000117, 48.68168080700012],
            [22.294276978000056, 48.667624817],
            [22.282184692000072, 48.66240549700008],
            [22.255519654000125, 48.65677276600006],
            [22.243220663000102, 48.65119171100004],
            [22.23567590300013, 48.644163717000126],
            [22.2252372640001, 48.628221538],
            [22.219036092000124, 48.62093516100002],
            [22.15371708100008, 48.5858727010001],
            [22.1387309160001, 48.56959462500008],
            [22.136663859000038, 48.54933746300007],
            [22.148342733000106, 48.508823141000065],
            [22.144828735000146, 48.493113506000086],
            [22.13376997900005, 48.476835429000076],
            [22.13283980300011, 48.404798483],
            [22.11392622900007, 48.3886495980001],
            [22.096459595000113, 48.379425354],
            [22.07785607900007, 48.37580800400012],
            [22.01801477100011, 48.37973541300009],
            [21.999928019000095, 48.37896026700007],
            [21.9815312100001, 48.374722799000025],
            [21.929338012000102, 48.37291412400002],
            [21.91476525900015, 48.36909006800009],
            [21.884276164000056, 48.35746287100004],
            [21.84117801900007, 48.353173727000055],
            [21.78939823400009, 48.335526225000066],
            [21.759012492000124, 48.333769226000086],
            [21.72769657400002, 48.34090057400003],
            [21.701238240000123, 48.35394887300008],
            [21.677570434000103, 48.37234568300006],
            [21.62155318200007, 48.42965484600005],
            [21.613388305000058, 48.440351868000064],
            [21.600365844000123, 48.481641337000056],
            [21.591684204000074, 48.49301015300007],
            [21.57463098100004, 48.495568136000045],
            [21.537734008000115, 48.49523223900006],
            [21.52181766700008, 48.500089824000085],
            [21.515099732000067, 48.5071178190001],
            [21.506004679000085, 48.52649648000006],
            [21.4993900960001, 48.535074769000076],
            [21.490811809000064, 48.540268250000096],
            [21.472725057000048, 48.544996644],
            [21.43913537600011, 48.55832916300001],
            [21.424562622000053, 48.5612747200001],
            [21.37267948400006, 48.55034515400003],
            [21.338573038000106, 48.549854228000086],
            [21.32182987400006, 48.54758046500008],
            [21.302296183000124, 48.539906515],
            [21.29392460100007, 48.530578918000074],
            [21.28824019400011, 48.51993357400006],
            [21.27656132000004, 48.50871978800002],
            [21.261781861000117, 48.503190410000016],
            [21.25041304500013, 48.506497701000015],
            [21.238010702000082, 48.513448182],
            [21.219923950000066, 48.51871917700005],
            [21.186747680000053, 48.51370656400009],
            [21.10933638500012, 48.4891085820001],
            [21.08401493300005, 48.49301015300007],
            [21.06386112400014, 48.506239319000045],
            [21.035955851000068, 48.51463673900004],
            [21.006500285000072, 48.518150737],
            [20.981488891000083, 48.516858826000046],
            [20.945832154000072, 48.51897756000001],
            [20.891365193000098, 48.54109507200012],
            [20.859945922000065, 48.54331716000003],
            [20.84547652100011, 48.545823466000016],
            [20.815814250000074, 48.563806864000085],
            [20.80031132000005, 48.569232890000066],
            [20.784084920000055, 48.569052023000026],
            [20.572521606000066, 48.536573385000096],
            [20.510509888000115, 48.53378285800004],
            [20.481674439000074, 48.52608306900005],
            [20.480537557000076, 48.518538310000096],
            [20.48022749800009, 48.51021840400004],
            [20.4821912030001, 48.49288096200003],
            [20.48281132000008, 48.48936696400007],
            [20.482914673000096, 48.485827128000025],
            [20.482501261000095, 48.48226145500003],
            [20.481674439000074, 48.47874745700007],
            [20.46823856600011, 48.46538909900006],
            [20.46596804300009, 48.46379039200012],
            [20.435579060000038, 48.4423930870001],
            [20.420592895000084, 48.42924143500004],
            [20.409017374000115, 48.4137126670001],
            [20.370156697000084, 48.33433766700004],
            [20.349279419000084, 48.30547638000009],
            [20.324268026000112, 48.27994822300006],
            [20.2952258710001, 48.26041453100005],
            [20.27238488800009, 48.252456360000096],
            [20.260292602000106, 48.255892843000126],
            [20.249027140000067, 48.26418691],
            [20.22908003700013, 48.27090484700001],
            [20.21781457500009, 48.26759755500011],
            [20.18763553900007, 48.24899403900007],
            [20.170892375000022, 48.24403310200002],
            [20.15332238700006, 48.24527333600004],
            [20.143090454000088, 48.24780548100004],
            [20.13451216700014, 48.24666860000012],
            [20.12200646900004, 48.23674672500003],
            [20.11807906100009, 48.229718730000016],
            [20.11260135900008, 48.21173533200003],
            [20.105263305000108, 48.20279530900011],
            [20.096995077000145, 48.1984286510001],
            [20.078081502000117, 48.193545228000076],
            [20.038302702000124, 48.177233057000095],
            [20.0349833570001, 48.1758718870001],
            [19.99694950400007, 48.16791371700002],
            [19.97390181500009, 48.15837941500003],
            [19.92863326000011, 48.13008656800004],
            [19.905068806000088, 48.12429880800006],
            [19.884294881000073, 48.129621480000125],
            [19.84626102700011, 48.152669169],
            [19.821663045000037, 48.157914327000114],
            [19.785592895000036, 48.14869008400011],
            [19.77608443200006, 48.149516907000034],
            [19.76667932100011, 48.15899953200001],
            [19.76915979000009, 48.16744862900002],
            [19.774844197000107, 48.17607859300004],
            [19.77432743300008, 48.18589711600002],
            [19.756550740000137, 48.20031484000005],
            [19.733089640000088, 48.20289866200004],
            [19.686994263000145, 48.1969041950001],
            [19.67696903400011, 48.200392354000044],
            [19.655264933000126, 48.21834991500005],
            [19.643896118000043, 48.224809469],
            [19.6338708910001, 48.226773173000126],
            [19.62322554500011, 48.22700571700007],
            [19.53124149500013, 48.21065012700005],
            [19.513981567000144, 48.20395802900002],
            [19.50302616400006, 48.18941111200006],
            [19.493621053000112, 48.15070546500006],
            [19.48173547300007, 48.134892477000065],
            [19.481425415000103, 48.13442738900004],
            [19.48121870900013, 48.13396230100001],
            [19.481425415000103, 48.13334218300004],
            [19.48173547300007, 48.13267039000006],
            [19.483285767000098, 48.12719268800005],
            [19.483802531000038, 48.12176666300009],
            [19.483285767000098, 48.11649566600006],
            [19.48173547300007, 48.11132802300004],
            [19.428198690000045, 48.08585154300003],
            [19.293219849000053, 48.08776357100005],
            [19.233481893000118, 48.06208038400008],
            [19.222526489000046, 48.06058176700007],
            [19.09850305200007, 48.07073618600002],
            [19.03866174300009, 48.06487091100003],
            [19.019016511000103, 48.065496862000046],
            [18.996493774000044, 48.06621449800009],
            [18.981817668000133, 48.061615296000056],
            [18.933595170000075, 48.05434889200002],
            [18.8384672440001, 48.04001454700007],
            [18.821000610000056, 48.03045440700008],
            [18.794232218000076, 47.993144023000056],
            [18.784723754000083, 47.98761464500005],
            [18.765293416000105, 47.98539255800004],
            [18.756198364000056, 47.981826885000075],
            [18.743175903000093, 47.97105234800004],
            [18.744519490000073, 47.96735748300004],
            [18.751444133000064, 47.96335256000005],
            [18.754751424000062, 47.95180287700002],
            [18.744726196000045, 47.910513408],
            [18.742245727000068, 47.889455262000055],
            [18.748756958000115, 47.870722555000086],
            [18.77800581900007, 47.851447245000045],
            [18.81645308500012, 47.83255950900009],
            [18.814916380000057, 47.83219355500002],
            [18.790304810000123, 47.82633249900003],
            [18.767670532000068, 47.82230173800012],
            [18.750307251000038, 47.813620097000054],
            [18.717234334000068, 47.78811777800003],
            [18.69284305800005, 47.77796335900008],
            [18.66369755000011, 47.77589630100003],
            [18.633828572000084, 47.77982371100008],
            [18.597448364000115, 47.79064992300003],
            [18.552593221000024, 47.79284617200001],
            [18.347851196000107, 47.77677480100006],
            [18.27302372200006, 47.75625925700008],
            [18.235920044000096, 47.753882141000034],
            [18.11262007600007, 47.76248626700006],
            [17.883531848000132, 47.75252142500007],
            [17.82571252400004, 47.75000640900008],
            [17.741996704000087, 47.76538014800006],
            [17.719244921000097, 47.773669069000036],
            [17.676677693000045, 47.78917714500004],
            [17.6662390540001, 47.797031963000066],
            [17.658384236000074, 47.807315573000054],
            [17.639884074000122, 47.819201152000076],
            [17.61911014800009, 47.829226380000094],
            [17.604227335000132, 47.834238993000056],
            [17.592961873000093, 47.83310211200005],
            [17.582936646000064, 47.82979482100005],
            [17.572601359000146, 47.82953643800009],
            [17.560405721000052, 47.83798553500007],
            [17.526609334000057, 47.87211781800006],
            [17.51730757600012, 47.87625193300009],
            [17.492192830000107, 47.87981760700005],
            [17.481857544000093, 47.88271148800003],
            [17.472039022000047, 47.8888093070001],
            [17.36940962800014, 47.9812067670001],
            [17.337887003000077, 47.99872507700006],
            [17.272671346000067, 48.005339661000065],
            [17.262316384000115, 48.007282508000046],
            [17.220891560000098, 48.015054830000096],
            [17.184821411000087, 48.02027415000002],
            [17.148337850000075, 48.005443014],
            [17.12498010300004, 48.01952484100009],
            [17.09263065600004, 48.02725046800002],
            [17.069686320000102, 48.0356737260001],
            [17.075060669000067, 48.052080994000065],
            [17.063071737000115, 48.05877309200007],
            [17.05914432700004, 48.060426737000014],
            [17.064828735000077, 48.079030254000074],
            [17.0699963780001, 48.08915883400003],
            [17.080228312000088, 48.09760793100013],
            [17.06720585100004, 48.10693552700006],
            [17.06245529600008, 48.11272448800004],
            [17.047465454000076, 48.13099090600009],
            [17.036923462000118, 48.13551259400002],
            [17.020903768000068, 48.13716624000007],
            [17.007157837000108, 48.142798971],
            [16.98193973800008, 48.16129913400003],
            [16.974808390000135, 48.176879578000054],
            [16.974705037000092, 48.198557842000056],
            [16.96995080500011, 48.216644593000055],
            [16.95434452300006, 48.252559713000025],
            [16.95393111200005, 48.257339784000024],
            [16.955274699000114, 48.26878611300005],
            [16.95434452300006, 48.273126933000114],
            [16.950623820000146, 48.27658925400006],
            [16.944422648000085, 48.27801035600005],
            [16.933363892000074, 48.284728292000054],
            [16.924268839000092, 48.28751882000002],
            [16.916620727000122, 48.290800273000016],
            [16.913313435000106, 48.29669138600012],
            [16.912073201000084, 48.301238912000045],
            [16.908869263000014, 48.30697499600011],
            [16.905458618000097, 48.31198761000006],
            [16.902771444000052, 48.31410634400005],
            [16.89843062300008, 48.316173401000114],
            [16.900290975000075, 48.32123769100009],
            [16.904218384000046, 48.32702545200006],
            [16.90649214700008, 48.331469625000054],
            [16.90194462100004, 48.33940195800004],
            [16.89171268700005, 48.347024231],
            [16.881170695000094, 48.35281199200007],
            [16.875486287000058, 48.35503407800006],
            [16.855332479000083, 48.356455180000054],
            [16.84758101400007, 48.3595816040001],
            [16.84448042800011, 48.365601909000034],
            [16.845100545000093, 48.37658315100002],
            [16.846857544000073, 48.38113067600007],
            [16.849338012000146, 48.38410207100007],
            [16.851921834000052, 48.39040659600009],
            [16.860810181000147, 48.443788351000094],
            [16.864944295000072, 48.45807688500007],
            [16.875072876000047, 48.471538595000126],
            [16.90122115000014, 48.49660166500003],
            [16.90649214700008, 48.509908346000046],
            [16.913933553000078, 48.51933929500011],
            [16.930470012000086, 48.528201803000016],
            [16.946903117000147, 48.539725647000054],
            [16.9490548790001, 48.54483608300002],
            [16.95434452300006, 48.55739898700004],
            [16.945042766000142, 48.60416615800007],
            [16.9475232340001, 48.62315724700004],
            [16.963336222000123, 48.635947164000086],
            [16.974808390000135, 48.649873963000076],
            [17.025347941000064, 48.746328024],
            [17.049945923000053, 48.77402659200003],
            [17.084362426000098, 48.79371531200006],
            [17.098728475000087, 48.80575592100003],
            [17.104619588000105, 48.82461781800005],
            [17.113714641000087, 48.83391957600007],
            [17.167458130000085, 48.859757792000025],
            [17.212209920000134, 48.86606231800003],
            [17.260269002000086, 48.85779408800006],
            [17.374370565000106, 48.81960520500009],
            [17.391733846000108, 48.82177561400009],
            [17.41122471900013, 48.8302163340001],
            [17.4295609940001, 48.83815704300004],
            [17.453332153000133, 48.84275624700008],
            [17.467904907000104, 48.838105367000125],
            [17.49849735500004, 48.816763001000126],
            [17.535084269000066, 48.812990621],
            [17.72721724400006, 48.86291005400007],
            [17.744890584000075, 48.87257354800009],
            [17.77941044100004, 48.91174428300003],
            [17.795533488000046, 48.92058095300003],
            [17.820131469000103, 48.923371481000075],
            [17.841215454000036, 48.920994365000055],
            [17.860335734000046, 48.92171783500005],
            [17.87873254400003, 48.93355173800005],
            [17.88689742000014, 48.94724599200008],
            [17.894648885000066, 48.97820017600007],
            [17.900850057000127, 48.993031311000024],
            [17.914079223000044, 49.01049794600006],
            [17.935059855000134, 49.01938629200008],
            [17.95924442600011, 49.021866760000066],
            [18.012884562000096, 49.01912791000011],
            [18.04606083200011, 49.029153138000126],
            [18.075516398000104, 49.04718821200002],
            [18.096290323000062, 49.07028757800002],
            [18.10290490700004, 49.092250062000076],
            [18.101629686000138, 49.136928332000096],
            [18.101457967000044, 49.14294464100006],
            [18.105075318000047, 49.16976471000005],
            [18.11778771900009, 49.20257924500005],
            [18.136494588000062, 49.23306833900004],
            [18.16057580600011, 49.2586998500001],
            [18.190031372000107, 49.27694163100007],
            [18.324596802000087, 49.31125478100007],
            [18.36158636600004, 49.33019141800007],
            [18.385161580000045, 49.34226064100001],
            [18.387642049000107, 49.38975128200009],
            [18.416787557000134, 49.38546213800005],
            [18.43921512900002, 49.39507395500006],
            [18.481796509000077, 49.42907704700009],
            [18.514662719000114, 49.44060089100013],
            [18.522930949000056, 49.4460785940001],
            [18.527995239000035, 49.45486358700002],
            [18.53047570800001, 49.47346710200004],
            [18.535643351000118, 49.481683655],
            [18.556210571000094, 49.49015859000009],
            [18.600445598000135, 49.485972799000066],
            [18.628970988000077, 49.49579132100003],
            [18.63589563000005, 49.49672149700008],
            [18.64282027200005, 49.49579132100003],
            [18.675583130000035, 49.4850426230001],
            [18.70452193200009, 49.47925486300004],
            [18.73253055800012, 49.480288391],
            [18.773561645000058, 49.504886373],
            [18.792268514000057, 49.509537252000044],
            [18.833196249000082, 49.51026072200004],
            [18.93220829300006, 49.504317932000035],
            [18.96114709500003, 49.492794088000025],
            [18.952362101000062, 49.47594757100002],
            [18.953395630000045, 49.461684876000064],
            [18.958253214000138, 49.448145650000086],
            [18.960837036000044, 49.43331451500005],
            [18.95670292200012, 49.40044830300012],
            [18.96228397700014, 49.38918284100005],
            [18.981817668000133, 49.38680572600002],
            [19.00713912000012, 49.38809763700006],
            [19.04579309100012, 49.402773743000054],
            [19.06760054500006, 49.40613271100007],
            [19.076798951000058, 49.40406565400009],
            [19.09664270000013, 49.39460886700003],
            [19.106254517000053, 49.39140492800006],
            [19.116589803000068, 49.39093984000003],
            [19.14170454900008, 49.39419545600002],
            [19.172503703000075, 49.402256978000096],
            [19.179738403000044, 49.41026682500008],
            [19.18232222500012, 49.422720846000075],
            [19.18935022000005, 49.44220286100007],
            [19.19224410000004, 49.44261627200008],
            [19.204543091000062, 49.442822978000024],
            [19.208987264000086, 49.444993388000015],
            [19.211364380000106, 49.45165964800013],
            [19.209400676000087, 49.45641388000003],
            [19.206196737000113, 49.45941111300003],
            [19.204439738000133, 49.460547995000056],
            [19.220459432000098, 49.493000794000054],
            [19.2341020100001, 49.507211813000126],
            [19.24867476400007, 49.51625518900009],
            [19.26500451700008, 49.521474508],
            [19.284228150000104, 49.52416168300003],
            [19.31502730300008, 49.52395497700006],
            [19.325362590000083, 49.52504018200007],
            [19.339521931000036, 49.52876088500007],
            [19.347066691000094, 49.532998353000025],
            [19.433779745000066, 49.59516510100012],
            [19.43760380100008, 49.600126038000056],
            [19.443391561000055, 49.60177968400002],
            [19.448889797000078, 49.600313488000026],
            [19.457344197000054, 49.59805898100011],
            [19.474190714000116, 49.57873199500007],
            [19.48173547300007, 49.57351267500003],
            [19.505196574000138, 49.563384095000075],
            [19.517288859000132, 49.543281963000126],
            [19.535478963000088, 49.492845765000126],
            [19.551602010000067, 49.461013082000065],
            [19.556769654000078, 49.453881735000024],
            [19.573926229000023, 49.4452517700001],
            [19.59480350700011, 49.4415827430001],
            [19.63480106600008, 49.44132436200003],
            [19.630150187000112, 49.43501983600002],
            [19.628599894000075, 49.42959381100003],
            [19.629220012000047, 49.41393585200008],
            [19.627097479000042, 49.402165448000076],
            [19.627043767000117, 49.40186758800003],
            [19.684513794000082, 49.389079489000025],
            [19.706321249000098, 49.3875291960001],
            [19.726578409000098, 49.38887278300008],
            [19.760064738000096, 49.39765777600006],
            [19.76905606000011, 49.39321262800006],
            [19.769263143000103, 49.39311025000002],
            [19.77856490100004, 49.37419667600007],
            [19.783629191000102, 49.35755686500006],
            [19.78952030500011, 49.309187725000115],
            [19.787970011000084, 49.30510528600011],
            [19.780321899000114, 49.29761220300007],
            [19.77971320600011, 49.293452792],
            [19.779701783000036, 49.29337473500003],
            [19.783215779000102, 49.290015768],
            [19.796859623000017, 49.28339901700009],
            [19.796961711000023, 49.283349508000086],
            [19.798563188000116, 49.281080748000036],
            [19.798822062000028, 49.28071401000007],
            [19.806415196000103, 49.2754875670001],
            [19.806780233000097, 49.275236308],
            [19.80864058500009, 49.27089548800002],
            [19.806263469000072, 49.26526275700009],
            [19.80047570800008, 49.26304067000008],
            [19.79406783000013, 49.26185211200006],
            [19.78962365700005, 49.259474996],
            [19.75179650800007, 49.21906402600003],
            [19.747765747000074, 49.20588653600005],
            [19.76068485500008, 49.194207663000086],
            [19.785902954000022, 49.18816152000004],
            [19.83199833200004, 49.185887756000014],
            [19.854219197000077, 49.19126210600008],
            [19.86829182300005, 49.200788191000086],
            [19.8878088780001, 49.21399973600005],
            [19.905895630000117, 49.222784729000054],
            [19.937935018000132, 49.225110168000086],
            [19.965736939000095, 49.2156533820001],
            [20.017310018000103, 49.18387237600008],
            [20.050486287000098, 49.17322703100008],
            [20.070019979000108, 49.18309722900007],
            [20.080355265000037, 49.20810862300006],
            [20.086039673000073, 49.24304189100006],
            [20.09844201700014, 49.25286041300002],
            [20.10536665900011, 49.26397084600005],
            [20.111051066000073, 49.27585642500007],
            [20.130171346000054, 49.30391672800009],
            [20.13585575400012, 49.308877665000026],
            [20.138336222000078, 49.30732737300012],
            [20.160350382000075, 49.30562205000005],
            [20.170168904000036, 49.311616516000086],
            [20.19197635900005, 49.32861806300009],
            [20.20716923000009, 49.3341991170001],
            [20.28437382000007, 49.338643291000025],
            [20.28933475700012, 49.34308746400002],
            [20.296466105000064, 49.35693674700009],
            [20.301633748000143, 49.371199443000066],
            [20.30370080600011, 49.38039784800007],
            [20.307421509000022, 49.38659902000005],
            [20.317653443000097, 49.391611633000096],
            [20.32953902100013, 49.39176666300007],
            [20.37046675600007, 49.381689758000036],
            [20.422143188000092, 49.38298167000006],
            [20.421936483000138, 49.40018992200005],
            [20.437542765000074, 49.402515361000084],
            [20.522085408000066, 49.374351705000024],
            [20.543996215000107, 49.37083770800008],
            [20.567664022000116, 49.37636708600006],
            [20.579136189000053, 49.383395081000074],
            [20.59505253100008, 49.396262512000064],
            [20.60528446400005, 49.40003489200011],
            [20.614482870000046, 49.40044830300012],
            [20.636083618000043, 49.39832957000003],
            [20.67391076600009, 49.40230865500003],
            [20.68951704900013, 49.40049998000002],
            [20.77829716000008, 49.331201884],
            [20.794110148000073, 49.32365712600004],
            [20.816537719000053, 49.32138336200005],
            [20.833590943000075, 49.32205515600002],
            [20.849300578000054, 49.32050486200008],
            [20.868007446000036, 49.31140981100002],
            [20.884337199000072, 49.30029937800002],
            [20.900563599000094, 49.29259958900012],
            [20.91896040800009, 49.290325826000085],
            [20.94242150900007, 49.29585520500008],
            [20.964022258000114, 49.30810251900003],
            [20.99668176300011, 49.33936676100002],
            [21.017248983000087, 49.35244089800007],
            [21.032958618000066, 49.35461130800006],
            [21.054042602000095, 49.3547663370001],
            [21.07254276600011, 49.35719513000005],
            [21.080707641000117, 49.36634185800004],
            [21.06851200300011, 49.38143137600004],
            [21.04546431500006, 49.39057810500013],
            [21.033268677000137, 49.399673157],
            [21.05352583800004, 49.41445261600002],
            [21.068822062000095, 49.41920684800003],
            [21.10943973800005, 49.42458119800007],
            [21.12494266700014, 49.423651022000016],
            [21.143029419000072, 49.41553782200002],
            [21.157292114000143, 49.4051508590001],
            [21.172588338000082, 49.39827789300004],
            [21.194085734000055, 49.40060333300006],
            [21.211242310000102, 49.41109364900011],
            [21.242454875000078, 49.441272685000015],
            [21.260541626000105, 49.449437561000124],
            [21.27439091000005, 49.44726715100005],
            [21.330408163000072, 49.427785136000054],
            [21.427869913000052, 49.40980173800007],
            [21.44440637200006, 49.409905091000084],
            [21.481510051000043, 49.41522776400002],
            [21.496186157000125, 49.41238556000006],
            [21.514421954000113, 49.417212682000056],
            [21.52956913300008, 49.421222229000065],
            [21.601192668000067, 49.42649322600009],
            [21.619899536000048, 49.42334096300003],
            [21.63002811700008, 49.41889679000003],
            [21.648631632000047, 49.407062887],
            [21.65876021300008, 49.40246368400007],
            [21.666304972000148, 49.40179189000007],
            [21.68180790200006, 49.40406565400009],
            [21.69172977700015, 49.40215362600007],
            [21.708576294000125, 49.39088816400003],
            [21.742165975000148, 49.357091777000036],
            [21.75756555200013, 49.3489269010001],
            [21.768004191000074, 49.35347442700005],
            [21.78216353300013, 49.36448150600005],
            [21.799423461000117, 49.37481679300005],
            [21.81957727000008, 49.377245586000114],
            [21.837870727000052, 49.37042429700007],
            [21.87456099500011, 49.34835846000006],
            [21.928407836000048, 49.330788472000094],
            [21.96447798600005, 49.30856760700006],
            [21.993210083000065, 49.27818186500009],
            [22.005819133000102, 49.242886861],
            [22.01243371600009, 49.21105418000006],
            [22.040752401000077, 49.19746327800006],
            [22.11154911300011, 49.188626608000064],
            [22.144105265000064, 49.17488067700002],
            [22.15568078600012, 49.171521708000014],
            [22.165706014000136, 49.171108297],
            [22.18968387800004, 49.173020325000024],
            [22.197952108000095, 49.17198679600004],
            [22.208907511000064, 49.16397694900006],
            [22.209010864000106, 49.15694895400004],
            [22.206220337000047, 49.1504894000001],
            [22.208494100000053, 49.1441848760001],
            [22.21593550600008, 49.13999908500004],
            [22.262857707000137, 49.13059397400009],
            [22.31815148900006, 49.13198923800006],
            [22.33944217900003, 49.12645986000008],
            [22.390085083000088, 49.09302520800007],
            [22.42677535000007, 49.08563547800007],
            [22.50501346900012, 49.08341339200008],
            [22.539636678000136, 49.072199606000126],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Poland',
        iso3: 'POL',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.833196249000082, 49.51026072200004],
            [18.837433716000106, 49.52695221000009],
            [18.83453983600012, 49.54762278200009],
            [18.82017378800012, 49.59025583900008],
            [18.815729614000105, 49.599299215000045],
            [18.803947387000107, 49.61676584900009],
            [18.799296508000054, 49.62637766600001],
            [18.792578573000128, 49.660794169000056],
            [18.7884444580001, 49.668597311000084],
            [18.773458293000118, 49.675832011000054],
            [18.757852010000107, 49.67407501300006],
            [18.742245727000068, 49.669682516000066],
            [18.727672974000086, 49.66890736900005],
            [18.715063924000077, 49.67381663],
            [18.695426880000127, 49.688854472000074],
            [18.68240441800009, 49.69577911400005],
            [18.668141724000122, 49.69856964100002],
            [18.637342570000044, 49.700326640000085],
            [18.624010050000038, 49.70637278300005],
            [18.617705526000123, 49.71386586600006],
            [18.607680298000105, 49.742959697000074],
            [18.5841158450001, 49.77437896700012],
            [18.56675256400007, 49.80476471000007],
            [18.56633915200007, 49.83158477800005],
            [18.593831014000045, 49.85220367500007],
            [18.567269328000123, 49.861453756000074],
            [18.562928507000038, 49.8737010710001],
            [18.5654089760001, 49.889048971000065],
            [18.55920780400004, 49.90718739800009],
            [18.544428345000114, 49.912975159000084],
            [18.505050903000097, 49.89669708300006],
            [18.481796509000077, 49.89664540700004],
            [18.407485800000103, 49.92315541600003],
            [18.368831827000093, 49.93204376300007],
            [18.328524211000058, 49.92883982400009],
            [18.330694621000134, 49.92883982400009],
            [18.33245161900001, 49.92827138300002],
            [18.333795206000076, 49.927134501000026],
            [18.334932088000073, 49.92542917900006],
            [18.30692346200007, 49.909667868000085],
            [18.292454061000058, 49.90780751600006],
            [18.27261031100005, 49.91829783100012],
            [18.26702925600003, 49.92506744400005],
            [18.260104614000056, 49.940570374000075],
            [18.25586714700009, 49.946048076000054],
            [18.243981567000077, 49.9517324830001],
            [18.220520467000085, 49.95488474600005],
            [18.208738241000106, 49.95829539000009],
            [18.17721561700003, 49.975813700000046],
            [18.162022746000105, 49.98123972600003],
            [18.098150675000056, 49.98904286700004],
            [18.08512821400012, 49.99875803600007],
            [18.091639445000084, 50.0172065230001],
            [18.0332450760001, 50.04180450500009],
            [18.019073899000148, 50.04408711000012],
            [18.00244592300004, 50.04676544200002],
            [18.006890096000063, 50.02413116500007],
            [18.0121610920001, 50.022684225],
            [18.020119262000065, 50.024286195000016],
            [18.02869755000009, 50.02413116500007],
            [18.035725545000076, 50.0172065230001],
            [18.037482544000056, 50.00723297100008],
            [18.03241825300009, 50.0028404750001],
            [17.999862101000133, 49.996587627000096],
            [17.95976119000005, 49.99581248000008],
            [17.941571085000106, 49.992763570000065],
            [17.91211551900011, 49.975813700000046],
            [17.875735311000113, 49.96868235300009],
            [17.839355102000127, 49.973643291000045],
            [17.774552857000117, 50.015191142000035],
            [17.76328739400006, 50.02521637000008],
            [17.755432577000136, 50.03715362600012],
            [17.749851522000114, 50.04950429400007],
            [17.743030232000052, 50.060563050000084],
            [17.73197147600007, 50.06908966100009],
            [17.72256636500009, 50.07513580400003],
            [17.719465780000064, 50.08087188800009],
            [17.722669719000123, 50.08634959000007],
            [17.73197147600007, 50.091465556000074],
            [17.73238488800007, 50.09218902600007],
            [17.73259159400004, 50.092964173000084],
            [17.73238488800007, 50.093894349000024],
            [17.73197147600007, 50.094876201],
            [17.71791548700014, 50.09678822800002],
            [17.690733683000047, 50.10546986900006],
            [17.6776078690001, 50.107743632000094],
            [17.6669625240001, 50.10614166300006],
            [17.65848758900009, 50.102989400000084],
            [17.648359009000046, 50.10180084300008],
            [17.632752726000092, 50.10634836900003],
            [17.584176880000086, 50.14588083900004],
            [17.582109823000053, 50.15316721600003],
            [17.589447876000122, 50.16324412000007],
            [17.60040327900012, 50.16680979500005],
            [17.648669067000128, 50.167998352000055],
            [17.675334106000065, 50.174716289000074],
            [17.71791548700014, 50.19109771800005],
            [17.738172648000045, 50.20236318000009],
            [17.74757775900011, 50.21750437400003],
            [17.73197147600007, 50.236004538000046],
            [17.721429484000083, 50.24272247300006],
            [17.719155721000078, 50.25279937800009],
            [17.721119425000097, 50.261946106],
            [17.73197147600007, 50.28065297500008],
            [17.734245239000074, 50.283805237000124],
            [17.73496870900007, 50.28680247000004],
            [17.734451945000046, 50.289489645000074],
            [17.73197147600007, 50.29176340700009],
            [17.713574666000056, 50.30767974900003],
            [17.707993611000035, 50.31103871700013],
            [17.691043741000044, 50.31506947800004],
            [17.68453251100007, 50.312382304],
            [17.68194869000007, 50.30556101500004],
            [17.676367635000133, 50.297396139000014],
            [17.64670536300008, 50.27109283500006],
            [17.629548787000118, 50.26210113600003],
            [17.60639774600014, 50.25822540300008],
            [17.51699751800004, 50.26835398400003],
            [17.469351847000098, 50.265563456000066],
            [17.439999634000117, 50.24272247300006],
            [17.434831991000124, 50.24050038700007],
            [17.4295609940001, 50.23977691700007],
            [17.424186645000134, 50.24055206300007],
            [17.41912235500007, 50.24272247300006],
            [17.409820597000135, 50.261325989000014],
            [17.38801314300011, 50.2726431280001],
            [17.365895630000097, 50.271557923],
            [17.35504357900004, 50.25326446600003],
            [17.341711060000108, 50.25972402000009],
            [17.334786418000135, 50.27000763000008],
            [17.3328227130001, 50.28266835600003],
            [17.334062947000035, 50.29569081700005],
            [17.3295154220001, 50.298222962000054],
            [17.32538130700007, 50.30111684200004],
            [17.321867309000112, 50.304475810000056],
            [17.31907678200008, 50.30824819000007],
            [17.337473592000066, 50.313002422000054],
            [17.316803019000048, 50.3186351530001],
            [17.269880819000093, 50.317756653000046],
            [17.24610965900004, 50.322149150000044],
            [17.21086633300007, 50.33641184500003],
            [17.20104781100011, 50.34323313400007],
            [17.195053345000076, 50.351914775000026],
            [17.1888521730001, 50.36483388300006],
            [17.18544152800007, 50.375685934],
            [17.187611939000135, 50.37847646100006],
            [17.175933065000066, 50.38075022400007],
            [17.145443970000088, 50.37671946300007],
            [17.131698038000053, 50.3768228150001],
            [17.11888228400008, 50.38116363600007],
            [17.09562788900007, 50.39366933200007],
            [17.084672485000084, 50.397958476000056],
            [16.98193973800008, 50.41635528600004],
            [16.958788696000084, 50.41459828700006],
            [16.94400462900012, 50.42026669700003],
            [16.915793904000083, 50.43108306900005],
            [16.892952921000102, 50.43294342100005],
            [16.86577111800011, 50.42240142900009],
            [16.86587447100004, 50.4084487920001],
            [16.89791385900014, 50.37821807900009],
            [16.909282674000025, 50.359924622],
            [16.91672408000005, 50.338633932000036],
            [16.926542602000012, 50.319255270000056],
            [16.945249471000096, 50.3069046020001],
            [16.969640747000113, 50.29775787400003],
            [16.98783085100007, 50.284942119000036],
            [16.99837284300014, 50.26701039600006],
            [16.999819783000135, 50.24272247300006],
            [17.01284224400007, 50.231663717000075],
            [17.014805949000106, 50.21848622700007],
            [17.008398071000073, 50.20995961500007],
            [16.99630578600008, 50.21290517200008],
            [16.98566044100008, 50.22313710600004],
            [16.981009563000015, 50.2291832480001],
            [16.975015096000078, 50.23181874700002],
            [16.960338989000093, 50.23197377500004],
            [16.957548462000148, 50.229234925000085],
            [16.9577551670001, 50.21714264000012],
            [16.955274699000114, 50.21347361300012],
            [16.946283, 50.21306020200011],
            [16.927782837000052, 50.21729766900005],
            [16.918997843000056, 50.21709096300002],
            [16.907008911000105, 50.21176829000005],
            [16.8903691000001, 50.196937154000025],
            [16.880963990000026, 50.19156280600008],
            [16.86976208200008, 50.18972886500002],
            [16.857606242000088, 50.18773875000004],
            [16.837555786000053, 50.188617249000075],
            [16.817712036000046, 50.18675689700005],
            [16.795284464000048, 50.17440623],
            [16.777301066000064, 50.15693959600007],
            [16.76644901600011, 50.143400371000084],
            [16.75425337700011, 50.132289938000056],
            [16.732032511000057, 50.12195465200004],
            [16.701233357000092, 50.09492787700002],
            [16.66061568200007, 50.0930158500001],
            [16.618654419000052, 50.10702016300009],
            [16.584237915000102, 50.12743235300003],
            [16.56666792800013, 50.14221181200007],
            [16.557262817000094, 50.154717510000054],
            [16.545894003000086, 50.18882395500002],
            [16.535041952000142, 50.207737529000056],
            [16.504759563000107, 50.22799469100006],
            [16.492047160000055, 50.24272247300006],
            [16.47757775900004, 50.255331523000095],
            [16.45215295400004, 50.28499379500006],
            [16.437786906000014, 50.297964580000084],
            [16.415566040000073, 50.307938131000085],
            [16.37102095600008, 50.31837677000003],
            [16.353244263000136, 50.33351796500004],
            [16.35066044100006, 50.342251282000106],
            [16.35148726400007, 50.35134633400007],
            [16.350763794000073, 50.36064809200009],
            [16.343735799000058, 50.369949850000026],
            [16.334227335000094, 50.37186187800005],
            [16.28864872200009, 50.37186187800005],
            [16.276969849000125, 50.3694330850001],
            [16.269838501000095, 50.36545400100003],
            [16.262500448000083, 50.36442047200005],
            [16.249684692000102, 50.371035055000036],
            [16.24493046000012, 50.3768228150001],
            [16.232011352000114, 50.402609355000024],
            [16.199558553000088, 50.406278381],
            [16.190153443000042, 50.42415842700005],
            [16.19800826000008, 50.44002309200006],
            [16.2179553630001, 50.437129211000084],
            [16.21609501100008, 50.44017812200012],
            [16.21123742700007, 50.45128855400013],
            [16.21733524600012, 50.45165028900003],
            [16.226533651000125, 50.455370992000056],
            [16.232011352000114, 50.45676625600002],
            [16.247410929000097, 50.46498280900006],
            [16.26498091700006, 50.471649068000076],
            [16.27996708200004, 50.479865621],
            [16.287718547000054, 50.492784729],
            [16.30342818200012, 50.49604034400009],
            [16.335467570000105, 50.49035593700005],
            [16.352624145000078, 50.492784729],
            [16.36202925600014, 50.50120798800002],
            [16.382596476000117, 50.51417877200002],
            [16.39117476400014, 50.521826884000106],
            [16.388384237000082, 50.521258443000036],
            [16.388280884000068, 50.527149557000044],
            [16.389624471000047, 50.53484934500004],
            [16.39117476400014, 50.53991363500002],
            [16.395515584000123, 50.5457013960001],
            [16.398306111000096, 50.54849192300004],
            [16.398306111000096, 50.55179921500006],
            [16.394482056000044, 50.5593439740001],
            [16.425901326000087, 50.567560527000026],
            [16.416806275000113, 50.586629130000105],
            [16.331643514000092, 50.644041647],
            [16.30094771400013, 50.65510040300002],
            [16.268288208000058, 50.66042307600007],
            [16.232011352000114, 50.66088816400007],
            [16.2190922450001, 50.65913116500009],
            [16.211754191000097, 50.64910593700007],
            [16.204519491000042, 50.63634185800002],
            [16.19232385200013, 50.62657501300005],
            [16.17547733500004, 50.62409454400007],
            [16.160284465000103, 50.628642070000026],
            [16.128658488000042, 50.644041647],
            [16.08649051900008, 50.64678049800004],
            [16.02447880000011, 50.608591614000076],
            [15.982000773000067, 50.60363067700003],
            [15.9799337150001, 50.60662791000006],
            [15.979210246000036, 50.6097801720001],
            [15.980037068000058, 50.612984111000074],
            [15.982000773000067, 50.616239726000046],
            [15.996366821000095, 50.62368113200007],
            [15.9986405840001, 50.63556671200011],
            [15.99316288200012, 50.64936431900004],
            [15.984481242000044, 50.66290354400003],
            [15.97145878100011, 50.678613180000085],
            [15.958022908000146, 50.68688140900004],
            [15.94148645000007, 50.68838002600005],
            [15.882265258000075, 50.674220683],
            [15.854566691000059, 50.67370391900006],
            [15.848158813000111, 50.675150859000055],
            [15.797619263000087, 50.729772848],
            [15.794415323000095, 50.73587066700007],
            [15.792244914000037, 50.74269195600003],
            [15.767440226000076, 50.74419057200002],
            [15.684344523000107, 50.73142649400005],
            [15.673802530000046, 50.73354522700002],
            [15.666464477000147, 50.73809275300006],
            [15.653235310000042, 50.75096018500007],
            [15.641866496000148, 50.755766094000066],
            [15.441775350000086, 50.800207825000044],
            [15.400124145000092, 50.79798573800004],
            [15.39082238800006, 50.79064768500005],
            [15.381313924000068, 50.78000234000005],
            [15.370255168000057, 50.77261261000005],
            [15.368578785000096, 50.772949110000084],
            [15.356095825000125, 50.775454814000014],
            [15.349687948000081, 50.78372304300005],
            [15.350514770000103, 50.793231506000055],
            [15.353305298000066, 50.80325673500006],
            [15.35299523900008, 50.812971904],
            [15.34100630600011, 50.83173044900009],
            [15.32581343600009, 50.83968861900006],
            [15.307726685000063, 50.844752910000054],
            [15.287779581000052, 50.854881490000096],
            [15.277134236000052, 50.86573354100004],
            [15.265352010000072, 50.88227],
            [15.256050252000136, 50.89989166300002],
            [15.253053019000106, 50.91410268200009],
            [15.260081014000036, 50.93249949100009],
            [15.268762655000074, 50.942989807000046],
            [15.269796183000068, 50.95265330000005],
            [15.253776489000103, 50.96903472900003],
            [15.22711145000008, 50.977406311],
            [15.170164022000108, 50.97797475200004],
            [15.16075891100013, 50.99265085900002],
            [15.156108032000077, 51.00784373000006],
            [15.144429158000094, 51.01156443300006],
            [15.131510051000106, 51.00582834900011],
            [15.122518351000053, 50.992754212000065],
            [15.122518351000053, 50.99265085900002],
            [15.119211059000065, 50.98247060200005],
            [15.107945597000082, 50.981023662000055],
            [15.09388960700008, 50.98541615800006],
            [15.082107381000071, 50.992754212000065],
            [15.073632446000062, 51.00262441000005],
            [15.022989543000108, 51.00965240500004],
            [15.003972616000055, 51.02068532300005],
            [15.001182088000093, 51.01244293200001],
            [14.996531209000125, 51.00784373000006],
            [14.982061808000083, 51.00117747000006],
            [14.976377401000036, 51.000402324000035],
            [14.970692993000085, 50.99869700200007],
            [14.965628703000021, 50.996061503000064],
            [14.961081176000079, 50.99265085900002],
            [14.960977824000054, 50.99265085900002],
            [14.965215291000106, 50.98133372000005],
            [14.981441691000015, 50.973220520000055],
            [14.996634562000054, 50.95921620700004],
            [14.997771444000051, 50.930174052000055],
            [14.994670857000102, 50.925109762000076],
            [14.984852335000141, 50.91808176700006],
            [14.982061808000083, 50.91467112300005],
            [14.981131632000142, 50.909090068000026],
            [14.981751749000097, 50.90526601200007],
            [14.982888631, 50.90242380800002],
            [14.98412886500006, 50.86769724600008],
            [14.982061808000083, 50.85906728200003],
            [14.867856893000067, 50.86438995400009],
            [14.831683390000137, 50.85798207600003],
            [14.810392700000136, 50.858447164000054],
            [14.810496053000065, 50.877050680000124],
            [14.824655395000036, 50.89183013900005],
            [14.860208781000068, 50.916841533000124],
            [14.910644979000097, 50.99265085900002],
            [14.95529341700012, 51.06404185000012],
            [14.958290649000048, 51.07551401800005],
            [14.958497355000077, 51.094737651000074],
            [14.960254354000057, 51.10458201100003],
            [14.965628703000021, 51.111506653000035],
            [14.97338016800012, 51.11613169400009],
            [14.97999475100002, 51.12279795400009],
            [14.982061808000083, 51.13563954700008],
            [14.983198690000108, 51.16090932300004],
            [14.991363566000103, 51.18896962500007],
            [15.004902792000081, 51.215608826],
            [15.022059367000054, 51.23677032500005],
            [15.017925252000026, 51.23956085200011],
            [15.014307901000052, 51.24266143900006],
            [15.019475545000148, 51.271677755000056],
            [15.004902792000081, 51.29128896100006],
            [14.982268514000054, 51.30800628700011],
            [14.963768352000017, 51.32839263900006],
            [14.960977824000054, 51.33529144300003],
            [14.956637004000072, 51.3532231650001],
            [14.956637004000072, 51.35415334100004],
            [14.950647846000038, 51.396539377000025],
            [14.946921835000126, 51.42290883400004],
            [14.95539676900006, 51.435414530000045],
            [14.945061483000131, 51.44918630000008],
            [14.926561320000104, 51.46133026100007],
            [14.910955038000083, 51.46897837300004],
            [14.888320760000113, 51.475747987],
            [14.841398559000083, 51.48442962700004],
            [14.818557576000075, 51.49259450400005],
            [14.818557576000075, 51.49269785600008],
            [14.79747359200013, 51.50210296600004],
            [14.732154582000078, 51.515823059000084],
            [14.710037068000076, 51.5302407840001],
            [14.706769960000116, 51.54082806400008],
            [14.704559367000087, 51.54799163800003],
            [14.71272424300011, 51.567421977],
            [14.732154582000078, 51.58661977200002],
            [14.743936808000086, 51.606644390000056],
            [14.74228316200012, 51.632973532],
            [14.732464640000074, 51.65834665900009],
            [14.719545532000069, 51.675632426],
            [14.670969686000149, 51.70077301100012],
            [14.648438761000136, 51.7172061160001],
            [14.638103475000037, 51.7426309210001],
            [14.634176066000066, 51.76901173900008],
            [14.620326782000092, 51.780535584000106],
            [14.602240031000093, 51.78831288700012],
            [14.585806925000043, 51.803893332000044],
            [14.582809693000115, 51.82508066800001],
            [14.595935507000064, 51.84241811200012],
            [14.653296346000076, 51.87861745300005],
            [14.67169315600006, 51.89388783800008],
            [14.687092733000043, 51.911897074000095],
            [14.695567667000148, 51.931456604000104],
            [14.699081665000108, 51.992512309000105],
            [14.704456014000073, 52.00222747800005],
            [14.726056762000042, 52.02643788700003],
            [14.730294230000084, 52.03589467400009],
            [14.732154582000078, 52.04506724100007],
            [14.735358520000148, 52.05403310200002],
            [14.74300663300005, 52.06253387500003],
            [14.76140344300012, 52.07666737900006],
            [14.696394491000063, 52.10669138600012],
            [14.686369263000131, 52.12103159600012],
            [14.692467082000093, 52.14697316500006],
            [14.703215780000022, 52.16516327],
            [14.707039836000149, 52.17945180300008],
            [14.69257043500005, 52.19337860100008],
            [14.69257043500005, 52.19957977300005],
            [14.712104126000042, 52.21544443800006],
            [14.712414184000124, 52.235908305000024],
            [14.696911255000117, 52.2534782930001],
            [14.668902628000097, 52.26099721300004],
            [14.640480590000067, 52.26505381300005],
            [14.606580851000075, 52.27575083500007],
            [14.584153280000066, 52.29122792600005],
            [14.590147746000099, 52.30941803000009],
            [14.569167114000095, 52.3385118610001],
            [14.54539595600005, 52.382152608000055],
            [14.539814901000113, 52.42186594700006],
            [14.591594686000093, 52.44979705900003],
            [14.615779256000081, 52.473283997000024],
            [14.632315715000061, 52.49674509800009],
            [14.627664836000093, 52.5074162800001],
            [14.609061320000137, 52.51780324300002],
            [14.616812785000064, 52.54103180000003],
            [14.644821411000066, 52.576921082000084],
            [14.613712199000105, 52.59252736400002],
            [14.607964828000092, 52.596462963000064],
            [14.54994348100007, 52.63619395000008],
            [14.49010217300011, 52.65063751200002],
            [14.461370076, 52.67456370100011],
            [14.442353149000041, 52.67996388799999],
            [14.431914510000098, 52.68608754600005],
            [14.39770471200012, 52.72711863299999],
            [14.382201782000095, 52.738151551],
            [14.27595503700013, 52.78571970600002],
            [14.248669882000115, 52.794582215000034],
            [14.216010375000053, 52.817991639000084],
            [14.195959920000092, 52.82336598700006],
            [14.173739054000066, 52.824347839000026],
            [14.152758423000051, 52.8283269250001],
            [14.13539514200005, 52.83659515400005],
            [14.12392297300002, 52.850651144000054],
            [14.150484660000131, 52.86462961900007],
            [14.16081994600006, 52.87674774200006],
            [14.164954061000088, 52.89566131700009],
            [14.162680298000055, 52.908167013000096],
            [14.150484660000131, 52.94364288400003],
            [14.14449019300011, 52.953693950000044],
            [14.14449019300011, 52.95992096000005],
            [14.192859334000048, 52.98165090000005],
            [14.253734172000094, 53.00087453300007],
            [14.312645305000103, 53.02921905500007],
            [14.343341105000036, 53.04862355500005],
            [14.356776977000095, 53.066684469000066],
            [14.359567505000143, 53.07505605100003],
            [14.389539835000107, 53.131667583000095],
            [14.38747277900012, 53.14613698400005],
            [14.381478312000098, 53.160296326],
            [14.377860962000113, 53.1765485640001],
            [14.380651489000087, 53.18985524500003],
            [14.387782837000117, 53.20207672200006],
            [14.39770471200012, 53.21099090600008],
            [14.408246704000078, 53.214401551],
            [14.415584757000062, 53.22099029600007],
            [14.441629680000062, 53.25184112600006],
            [14.4286072190001, 53.259075827000046],
            [14.424679810000043, 53.26465688100005],
            [14.409383586000075, 53.27243418400006],
            [14.403285767000028, 53.278790385],
            [14.40018518000008, 53.28860890800006],
            [14.399565064000114, 53.30674733500008],
            [14.398014770000088, 53.31522227000009],
            [14.391260511000098, 53.334017003000056],
            [14.370316202000083, 53.39229766900003],
            [14.359877564000044, 53.444077454000094],
            [14.338896932000125, 53.465213115000054],
            [14.328458293000097, 53.4860903940001],
            [14.304170370000094, 53.50851796500011],
            [14.29693566900005, 53.5291368620001],
            [14.296212199000138, 53.551306051000026],
            [14.298899373000069, 53.58789296500008],
            [14.297039022000149, 53.59776316400006],
            [14.27605839000006, 53.636623841000116],
            [14.260968872000149, 53.65620920900004],
            [14.265102986000073, 53.67176381500006],
            [14.263862752000136, 53.699875794],
            [14.263900720257396, 53.69997615968076],
            [14.273692254000082, 53.70062897300005],
            [14.291677280000044, 53.70526764500005],
            [14.304860873000052, 53.712551174000055],
            [14.306162957000083, 53.720689195000034],
            [14.288584832000083, 53.72797272300005],
            [14.298350457000083, 53.73143138200004],
            [14.301605665000068, 53.73484935100004],
            [14.298350457000083, 53.738267320000034],
            [14.288584832000083, 53.74164459800005],
            [14.294200066000087, 53.74909088700008],
            [14.30404707100007, 53.74388255400004],
            [14.31804446700005, 53.73973216400003],
            [14.330414259000065, 53.73419830900008],
            [14.342051629000082, 53.714911200000074],
            [14.356211785000085, 53.70844147300005],
            [14.383555535000085, 53.70062897300005],
            [14.403575066000087, 53.68781159100007],
            [14.414561394000089, 53.68235911700003],
            [14.45866946700005, 53.67788320500006],
            [14.512380405000044, 53.666449286000045],
            [14.53101647200009, 53.65778229400007],
            [14.54623457100007, 53.64476146000004],
            [14.579112175000091, 53.60724518400008],
            [14.590586785000085, 53.59837474200003],
            [14.595876498000052, 53.60130442900004],
            [14.59701582100007, 53.61733633000006],
            [14.601573113000086, 53.626654364000046],
            [14.610036655000044, 53.63275788000004],
            [14.623789910000085, 53.63922760600008],
            [14.623057488000086, 53.643011786000045],
            [14.62281334700009, 53.64695872600004],
            [14.623789910000085, 53.65281810100004],
            [14.61304772200009, 53.65468984600005],
            [14.587412957000083, 53.65607330900008],
            [14.57593834700009, 53.65965403900003],
            [14.544932488000086, 53.70404694200005],
            [14.551442905000044, 53.72614166900007],
            [14.57593834700009, 53.769517320000034],
            [14.587412957000083, 53.76349518400008],
            [14.59734134200005, 53.76520416900007],
            [14.608246290000068, 53.76902903900003],
            [14.623789910000085, 53.769517320000034],
            [14.616709832000083, 53.79474518400008],
            [14.620371941000087, 53.81484609600005],
            [14.627289259000065, 53.83270905200004],
            [14.63062584700009, 53.85150788000004],
            [14.623789910000085, 53.85150788000004],
            [14.621348504000082, 53.839544989000046],
            [14.613536004000082, 53.83161041900007],
            [14.58961022200009, 53.81732819200005],
            [14.595876498000052, 53.81049225500004],
            [14.587087436000047, 53.81264883000006],
            [14.580088738000086, 53.815334377000056],
            [14.574473504000082, 53.81907786700003],
            [14.569102410000085, 53.82416413000004],
            [14.574229363000086, 53.82709381700005],
            [14.583262566000087, 53.83421458500004],
            [14.58961022200009, 53.83783600500004],
            [14.57585696700005, 53.854803778000075],
            [14.55209394600007, 53.86277903900003],
            [14.44117272200009, 53.86961497600004],
            [14.42554772200009, 53.87982819200005],
            [14.438161655000044, 53.899318752000056],
            [14.43490644600007, 53.90131256700005],
            [14.434092644000089, 53.901597398000035],
            [14.433767123000052, 53.902411200000074],
            [14.431895379000082, 53.90615469000005],
            [14.422048373000052, 53.896144924000055],
            [14.414235873000052, 53.89472077000005],
            [14.405772332000083, 53.89740631700005],
            [14.393809441000087, 53.899318752000056],
            [14.385101759000065, 53.89728424700007],
            [14.37826582100007, 53.89232005400004],
            [14.371592644000089, 53.88589101800005],
            [14.36304772200009, 53.87938060100004],
            [14.392914259000065, 53.87596263200004],
            [14.409190300000091, 53.87156810100004],
            [14.41765384200005, 53.86513906500005],
            [14.41570071700005, 53.85301341400003],
            [14.405284050000091, 53.844183661000045],
            [14.392588738000086, 53.840725002000056],
            [14.383555535000085, 53.84467194200005],
            [14.356211785000085, 53.83445872600004],
            [14.342621290000068, 53.83185455900008],
            [14.328298373000052, 53.83100006700005],
            [14.328298373000052, 53.82416413000004],
            [14.342051629000082, 53.82099030200004],
            [14.341319207000083, 53.81891510600008],
            [14.328298373000052, 53.81732819200005],
            [14.318858269000089, 53.81818268400008],
            [14.303070509000065, 53.82306549700007],
            [14.291351759000065, 53.82416413000004],
            [14.274668816000087, 53.83079661700003],
            [14.226573113000086, 53.871975002000056],
            [14.203135613000086, 53.87832265800006],
            [14.200818737000134, 53.87815729300003],
            [14.192755981000118, 53.89376576800008],
            [14.175289348000092, 53.90647817000003],
            [14.184797811000067, 53.908131816],
            [14.193066040000105, 53.911490784000094],
            [14.210052931000064, 53.93846263200004],
            [14.226573113000086, 53.934027411000045],
            [14.237478061000047, 53.92865631700005],
            [14.268077019000089, 53.92182038000004],
            [14.367035352000073, 53.91697825700004],
            [14.406748894000089, 53.92182038000004],
            [14.445567254000082, 53.934027411000045],
            [14.51734459700009, 53.96523672100005],
            [14.781911655000044, 54.03461334800005],
            [15.010101759000065, 54.06981028900003],
            [15.288340691000087, 54.13886139500005],
            [15.46851647200009, 54.16714101800005],
            [15.66578209700009, 54.198431708000044],
            [15.859711134000065, 54.249986070000034],
            [16.02084394600007, 54.261786200000074],
            [16.131521030000044, 54.28351471600007],
            [16.11890709700009, 54.27602773600006],
            [16.06934655000009, 54.263006903000075],
            [16.091075066000087, 54.253973700000074],
            [16.179209832000083, 54.263006903000075],
            [16.179209832000083, 54.269191799000055],
            [16.17237389400009, 54.269191799000055],
            [16.17237389400009, 54.276597398000035],
            [16.22006269600007, 54.276597398000035],
            [16.219574415000068, 54.28148021000004],
            [16.21851647200009, 54.28237539300005],
            [16.216644727000073, 54.28204987200007],
            [16.213226759000065, 54.28351471600007],
            [16.215179884000065, 54.29962799700007],
            [16.192149285000085, 54.30027903900003],
            [16.13770592500009, 54.290269273000035],
            [16.172129754000082, 54.30023834800005],
            [16.213552280000044, 54.316107489000046],
            [16.275401238000086, 54.358587958000044],
            [16.262868686000047, 54.34369538000004],
            [16.240489129000082, 54.33002350500004],
            [16.23178144600007, 54.32257721600007],
            [16.240896030000044, 54.32453034100007],
            [16.259043816000087, 54.32672760600008],
            [16.274912957000083, 54.33047109600005],
            [16.28882897200009, 54.34023672100005],
            [16.32390384200005, 54.34992096600007],
            [16.336761915000068, 54.358587958000044],
            [16.324880405000044, 54.373114325000074],
            [16.305023634000065, 54.373480536000045],
            [16.29623457100007, 54.367254950000074],
            [16.281586134000065, 54.358587958000044],
            [16.32398522200009, 54.40131256700005],
            [16.439789259000065, 54.488267320000034],
            [16.439789259000065, 54.482123114000046],
            [16.434418165000068, 54.472357489000046],
            [16.444509311000047, 54.46987539300005],
            [16.46062259200005, 54.47345612200007],
            [16.473399285000085, 54.482123114000046],
            [16.479746941000087, 54.49555084800005],
            [16.473887566000087, 54.499660549000055],
            [16.460948113000086, 54.49648672100005],
            [16.446055535000085, 54.488267320000034],
            [16.46656334700009, 54.512152411000045],
            [16.50131269600007, 54.532416083000044],
            [16.569590691000087, 54.55719635600008],
            [16.778493686000047, 54.57514069200005],
            [16.859629754000082, 54.59393952000005],
            [16.902191602000073, 54.59813060100004],
            [16.93995201900009, 54.60602448100008],
            [17.035817905000044, 54.66705963700008],
            [17.337412957000083, 54.74900950700004],
            [17.715668165000068, 54.79043203300006],
            [17.885427280000044, 54.82412344000005],
            [18.152354363000086, 54.838324286000045],
            [18.31690514400009, 54.838324286000045],
            [18.33952884200005, 54.83348216400003],
            [18.375824415000068, 54.81513092700004],
            [18.38917076900009, 54.81110260600008],
            [18.410166863000086, 54.808294989000046],
            [18.75171959700009, 54.69009023600006],
            [18.813975457000083, 54.64321523600006],
            [18.824066602000073, 54.63222890800006],
            [18.834320509000065, 54.61668528900003],
            [18.83529707100007, 54.60309479400007],
            [18.817637566000087, 54.59813060100004],
            [18.813243035000085, 54.601548570000034],
            [18.80836022200009, 54.60883209800005],
            [18.802256707000083, 54.61603424700007],
            [18.784027540000068, 54.62352122600004],
            [18.771820509000065, 54.642279364000046],
            [18.755381707000083, 54.65448639500005],
            [18.707774285000085, 54.701239325000074],
            [18.698496941000087, 54.70380280200004],
            [18.66342207100007, 54.70799388200004],
            [18.654551629000082, 54.710150458000044],
            [18.64503014400009, 54.71954987200007],
            [18.616709832000083, 54.72524648600006],
            [18.556976759000065, 54.74900950700004],
            [18.498220248000052, 54.76536692900004],
            [18.48878014400009, 54.77317942900004],
            [18.456309441000087, 54.78766510600008],
            [18.44776451900009, 54.78998444200005],
            [18.435557488000086, 54.786810614000046],
            [18.429209832000083, 54.781683661000045],
            [18.41504967500009, 54.753119208000044],
            [18.41309655000009, 54.746527411000045],
            [18.41309655000009, 54.73191966400003],
            [18.41846764400009, 54.728216864000046],
            [18.44239342500009, 54.721991278000075],
            [18.44776451900009, 54.71824778900003],
            [18.459808790000068, 54.70604075700004],
            [18.474457227000073, 54.687567450000074],
            [18.473887566000087, 54.67991771000004],
            [18.47006269600007, 54.67328522300005],
            [18.47038821700005, 54.66673411700003],
            [18.481944207000083, 54.65961334800005],
            [18.47592207100007, 54.64008209800005],
            [18.48731530000009, 54.63178131700005],
            [18.50635826900009, 54.634100653000075],
            [18.522959832000083, 54.646551825000074],
            [18.517100457000083, 54.62995026200008],
            [18.52515709700009, 54.61668528900003],
            [18.53760826900009, 54.605454820000034],
            [18.562836134000065, 54.56000397300005],
            [18.570648634000065, 54.55036041900007],
            [18.566742384000065, 54.527411200000074],
            [18.567556186000047, 54.48786041900007],
            [18.574066602000073, 54.450384833000044],
            [18.588063998000052, 54.433661200000074],
            [18.603770379000082, 54.43060944200005],
            [18.634287957000083, 54.41693756700005],
            [18.649912957000083, 54.41380442900004],
            [18.663340691000087, 54.412990627000056],
            [18.680023634000065, 54.40997955900008],
            [18.69434655000009, 54.40452708500004],
            [18.700450066000087, 54.395819403000075],
            [18.71729576900009, 54.382025458000044],
            [18.885915561000047, 54.35016510600008],
            [18.92318769600007, 54.348537502000056],
            [18.954356316000087, 54.358587958000044],
            [18.962901238000086, 54.353501695000034],
            [18.974619988000086, 54.34975820500006],
            [19.002126498000052, 54.344916083000044],
            [19.377207879000082, 54.37763092700004],
            [19.45997155000009, 54.40102773600006],
            [19.499278191000087, 54.40639883000006],
            [19.53101647200009, 54.414943752000056],
            [19.592539910000085, 54.452378648000035],
            [19.609548373000052, 54.456732489000046],
            [19.630770304000066, 54.44665191700001],
            [19.680276326000126, 54.436678365],
            [19.758255974000093, 54.434255669],
            [19.964703410000112, 54.4278416960001],
            [20.352069946000142, 54.41574941100002],
            [20.64083784950006, 54.40678354950002],
            [20.92960575300009, 54.397817688000046],
            [21.2874133710001, 54.386758932000035],
            [21.720771932000048, 54.37327138300007],
            [21.998946167000042, 54.364667257500074],
            [22.277120402000094, 54.35606313199999],
            [22.510387817000094, 54.3487767540001],
            [22.698386678000077, 54.34293731800004],
            [22.76721968600006, 54.356269837000056],
            [22.786029907000085, 54.365209860000064],
            [22.811343908000055, 54.39263336100008],
            [22.812694946000107, 54.39409698500002],
            [22.837602986000093, 54.40091827500008],
            [22.858893677000083, 54.3992129520001],
            [22.918838338000057, 54.3811262010001],
            [22.929690389000115, 54.38029937800006],
            [22.95242801900008, 54.383089905000034],
            [22.96265995300007, 54.381694642000056],
            [22.97330529800007, 54.37539011700004],
            [22.978989706000107, 54.36758697600003],
            [22.983433878000113, 54.3597838350001],
            [22.989738404000036, 54.35337595600005],
            [23.001003866000076, 54.34888010700003],
            [23.035317016000107, 54.346502991000094],
            [23.041621542000115, 54.34097361300009],
            [23.03800419100014, 54.33146514900001],
            [23.03221643100008, 54.320148010000125],
            [23.032113078000037, 54.309554342000055],
            [23.050096476000135, 54.29482655900004],
            [23.073040812000073, 54.29487823500007],
            [23.096915324000065, 54.300821025000076],
            [23.11706913200004, 54.303456523000094],
            [23.13525923600008, 54.2982888800001],
            [23.197270956000125, 54.26785146100012],
            [23.235408162000084, 54.254157207],
            [23.316023397000095, 54.23627716100005],
            [23.335990126000127, 54.226293796000036],
            [23.35447066200004, 54.21705352800002],
            [23.364082479000047, 54.208268535000045],
            [23.382272583000088, 54.18785634400008],
            [23.391470988000094, 54.18010487900007],
            [23.40180627400008, 54.17597076500006],
            [23.423303670000024, 54.1725084430001],
            [23.432502075000116, 54.169304505000056],
            [23.449038534000124, 54.15493845700006],
            [23.462991170000123, 54.134939678000094],
            [23.47394657400008, 54.11256378200004],
            [23.48159468600008, 54.09122141500002],
            [23.496167440000136, 54.044557597000065],
            [23.496477498000104, 54.021974996000026],
            [23.48159468600008, 54.00662709600006],
            [23.469502401000085, 54.000684306000025],
            [23.464128052000035, 53.996756897000054],
            [23.459270467000096, 53.99231272400006],
            [23.45865035000014, 53.98161570300006],
            [23.46288781700008, 53.97252065000008],
            [23.47094934100008, 53.96528595000011],
            [23.48159468600008, 53.960118307000116],
            [23.48748579900007, 53.955622457000075],
            [23.490379679000057, 53.95060984300004],
            [23.489759562000074, 53.94513214200005],
            [23.485625448000064, 53.93929270400004],
            [23.486865682000087, 53.90999216800007],
            [23.4972009680001, 53.88554921500004],
            [23.510430135000092, 53.86250152700008],
            [23.520662069000082, 53.83733510300006],
            [23.52986047400009, 53.7841600550001],
            [23.540402466000046, 53.76359283500001],
            [23.564690389000134, 53.74240549800005],
            [23.564793742000063, 53.74240549800005],
            [23.56706750400008, 53.68101389600007],
            [23.59094201600007, 53.611250712000114],
            [23.675794719000123, 53.45570465100006],
            [23.722923625000135, 53.39710357700004],
            [23.742974080000096, 53.365477600000034],
            [23.782971639000067, 53.27093556800004],
            [23.80064497900014, 53.24246185400001],
            [23.81862837700004, 53.22796661400007],
            [23.828446899000113, 53.21383311000004],
            [23.836198365000115, 53.199286195000084],
            [23.848083943000063, 53.18380910300009],
            [23.865963989000107, 53.17200103800006],
            [23.88312056500007, 53.163991191],
            [23.893662557000113, 53.151950582000026],
            [23.891388794000108, 53.12771433600004],
            [23.882397095000073, 53.113296611000024],
            [23.87030481000008, 53.101256002000056],
            [23.86069299300007, 53.08748423300001],
            [23.859349406, 53.067976380000104],
            [23.86792769400003, 53.05102651],
            [23.898210083000066, 53.02753957100002],
            [23.909682251000078, 53.012734274000096],
            [23.91133589700013, 53.00506032400001],
            [23.90895878100008, 52.993045553000044],
            [23.909062134000123, 52.98666351400003],
            [23.917537069000105, 52.95880991700004],
            [23.917950480000115, 52.95080007000006],
            [23.914953247000113, 52.94462473500009],
            [23.903894491000102, 52.93113718700003],
            [23.90110396300014, 52.923256532],
            [23.902034139000108, 52.91253367100008],
            [23.90544478300012, 52.906539205000044],
            [23.909475545000134, 52.901500753000064],
            [23.91205936700004, 52.893852641000095],
            [23.920425639000115, 52.7726245300001],
            [23.92249800600007, 52.74259572400008],
            [23.908752075000024, 52.6998593150001],
            [23.86896122200011, 52.67004201300007],
            [23.73615279200004, 52.61490325900009],
            [23.569031209000116, 52.585886943000034],
            [23.48045780500007, 52.55441599500007],
            [23.392297810000116, 52.50963836700002],
            [23.27054813700002, 52.395123394000095],
            [23.23044722500012, 52.36507354700002],
            [23.212050415000135, 52.34750356100004],
            [23.165644979000035, 52.28939341300007],
            [23.16874556500008, 52.28892832500013],
            [23.17609938200013, 52.28513571000012],
            [23.18352502400009, 52.28130605100007],
            [23.19448042800005, 52.271461690000095],
            [23.197684367000136, 52.25831003900002],
            [23.189726196000066, 52.24053334600008],
            [23.21225712100008, 52.23167083700007],
            [23.284190715000136, 52.219733582000046],
            [23.29959029200012, 52.22342844600003],
            [23.312716105000078, 52.21528940800003],
            [23.374831177000146, 52.20094919900002],
            [23.395811808000076, 52.19957977300005],
            [23.395811808000076, 52.19337860100008],
            [23.388473755000064, 52.18415435800007],
            [23.39136763500005, 52.18250071200002],
            [23.40573368400007, 52.18591135700005],
            [23.418239380000045, 52.18250071200002],
            [23.42723107900011, 52.17679046700006],
            [23.436739542000083, 52.17567942400005],
            [23.450485474000118, 52.18591135700005],
            [23.45441288200007, 52.18146718400003],
            [23.464334757000074, 52.17635121700006],
            [23.47094934100008, 52.17162282400007],
            [23.48769250500004, 52.18162221300007],
            [23.491516561000054, 52.17410329200003],
            [23.48872603300009, 52.16214019900009],
            [23.484695272000096, 52.15862620100005],
            [23.51249719200007, 52.12444224100004],
            [23.531927531000036, 52.12064402300011],
            [23.57936649600012, 52.12154836100005],
            [23.598176717000058, 52.114520366000036],
            [23.604791301000148, 52.10676890100005],
            [23.609855591000013, 52.09862986200004],
            [23.615850057000046, 52.092299500000095],
            [23.62525516800011, 52.089715678000104],
            [23.637450806000118, 52.084470521000085],
            [23.641481567000113, 52.07292083800006],
            [23.642515096000096, 52.06139699400002],
            [23.650783325000134, 52.048942973000024],
            [23.664942668000094, 52.01116750100006],
            [23.676414835000088, 51.99408844000003],
            [23.660705200000052, 51.98687957800006],
            [23.647579386000075, 51.97408966100009],
            [23.628665812000122, 51.94633941700006],
            [23.622154582000064, 51.92794260700005],
            [23.621431111000078, 51.89556732200005],
            [23.614919881000105, 51.88425018400007],
            [23.618847290000076, 51.883268332000014],
            [23.62060428900014, 51.88321665500008],
            [23.62132775800012, 51.88202809700009],
            [23.621844523000078, 51.87742889400003],
            [23.609855591000013, 51.873268942],
            [23.6057214760001, 51.85159067800002],
            [23.594559367000073, 51.84329661100004],
            [23.610269002000024, 51.82518402100003],
            [23.628665812000122, 51.809758606000045],
            [23.617503703000096, 51.786504212000025],
            [23.598280070000072, 51.774670309],
            [23.577299439000086, 51.766686300000046],
            [23.560349569000067, 51.754542338000036],
            [23.556318806000064, 51.74735931400009],
            [23.55228804500007, 51.73663645500007],
            [23.546603637000118, 51.71358876600003],
            [23.550220988000035, 51.708421122000104],
            [23.556938924000036, 51.70139312700009],
            [23.55921268700007, 51.69516611800002],
            [23.550014282000063, 51.69242726700007],
            [23.546086873000093, 51.68963673900002],
            [23.549290812000066, 51.68320302300005],
            [23.555388631000113, 51.67630422000009],
            [23.560349569000067, 51.6719634],
            [23.547533813000086, 51.66206736300002],
            [23.54143599400004, 51.659741923000084],
            [23.53244429500009, 51.65896677700006],
            [23.53244429500009, 51.651499533000035],
            [23.543813110000087, 51.64379974400005],
            [23.54515669700004, 51.6341104130001],
            [23.539885702000106, 51.60710947800008],
            [23.543399699000076, 51.592743429000066],
            [23.55208133900004, 51.578816631000095],
            [23.57399214700007, 51.555303854],
            [23.56717085700012, 51.554890442],
            [23.560349569000067, 51.555303854],
            [23.57275191200003, 51.53967173300005],
            [23.588668253000066, 51.53589935300003],
            [23.602310832000057, 51.53078338700006],
            [23.606238241000142, 51.517399191000024],
            [23.608098592000147, 51.51122385700002],
            [23.614816528000063, 51.49721954400012],
            [23.63052616400003, 51.49042409300007],
            [23.648612915000058, 51.48621246400005],
            [23.662772258000103, 51.48019215900008],
            [23.647165975000064, 51.460193380000064],
            [23.648716268000072, 51.45396637000006],
            [23.68943729700004, 51.41642344200007],
            [23.697602173000064, 51.40443450900001],
            [23.686026652000123, 51.40104970300008],
            [23.678895304000065, 51.394073385000084],
            [23.677655070000128, 51.383789775000096],
            [23.68385624200002, 51.37027638800002],
            [23.66556278500005, 51.36580637600012],
            [23.64778609200002, 51.353998312],
            [23.634040161000087, 51.3392963670001],
            [23.628665812000122, 51.325963848000086],
            [23.635177043000084, 51.30469899600011],
            [23.650886678000063, 51.29960886700003],
            [23.6702136640001, 51.29937632300006],
            [23.687266886000145, 51.29240000500006],
            [23.7426640220001, 51.21625478099999],
            [23.765194946000122, 51.19902069200002],
            [23.816044556000037, 51.178789368000096],
            [23.863586873000145, 51.1482744340001],
            [23.874748983000103, 51.13613047300002],
            [23.858212524000095, 51.13073028600006],
            [23.854491821000096, 51.12153188100005],
            [23.869271281000096, 51.10173980700007],
            [23.895522909000135, 51.07610829700009],
            [23.9042045490001, 51.06272410100006],
            [23.915986776000096, 51.020866191],
            [23.915986776000096, 51.014665019000105],
            [23.91174930800014, 51.00681020100008],
            [23.919087361000038, 51.00272776300007],
            [23.93179976400009, 50.999472148000066],
            [23.9439954020001, 50.99420115100004],
            [23.95505415800011, 50.98355580700006],
            [23.957844685000083, 50.97533925400002],
            [23.958878214000066, 50.96634755500007],
            [23.964355916000045, 50.953221741],
            [23.979342081000112, 50.93751210600006],
            [24.046934855000075, 50.898031311000025],
            [24.1302372640001, 50.868937480000014],
            [24.143156372000107, 50.85643178300002],
            [24.130857381000084, 50.83906850200002],
            [24.10047163900012, 50.83498606400009],
            [24.067295369000107, 50.83483103400006],
            [24.046934855000075, 50.82909495100007],
            [24.02047652100009, 50.83855173700006],
            [23.99288130700009, 50.83622629800003],
            [23.969936971000067, 50.8251675420001],
            [23.9576379800001, 50.80801096700007],
            [23.959498332000123, 50.78889068700006],
            [23.974277791000134, 50.776178284000096],
            [23.997945598000058, 50.7692019660001],
            [24.025850871000046, 50.76703155500003],
            [24.025850871000046, 50.760830384000045],
            [24.01282841000011, 50.74331207300007],
            [24.026884400000114, 50.72801584900013],
            [24.054169555000044, 50.71716379800007],
            [24.08104130100014, 50.712978007000046],
            [24.074943482000094, 50.690188701000054],
            [24.082798299000018, 50.66915639300002],
            [24.10816542300006, 50.630287411],
            [24.108429809000086, 50.62988230400005],
            [24.08527876800008, 50.60440582300005],
            [24.09540734900014, 50.55686350500012],
            [24.102538696000096, 50.54363433800002],
            [24.107706340000078, 50.54084381100007],
            [24.106466105000067, 50.538621725000056],
            [24.093960408000044, 50.527149557000044],
            [24.07504683500011, 50.514282125000065],
            [24.010657999000017, 50.492784729],
            [24.007867472000072, 50.48074412100003],
            [24.00941776500008, 50.4614688110001],
            [24.007764120000047, 50.44849802700007],
            [24.003216593000104, 50.43769765200004],
            [23.981305786000036, 50.4047797650001],
            [23.928699178000045, 50.39082712800011],
            [23.747521606000106, 50.38938018800012],
            [23.713001749000057, 50.38240387000012],
            [23.69574182100007, 50.376771138],
            [23.68220259600008, 50.36824452800006],
            [23.671247193000085, 50.353568421],
            [23.658677406000038, 50.32700492700009],
            [23.658018026000093, 50.32561147100007],
            [23.644168741000044, 50.31269236300007],
            [23.565310506000117, 50.25781199200007],
            [23.536371704000146, 50.2428258260001],
            [23.536268351000018, 50.2428258260001],
            [23.536164999000107, 50.24277415000007],
            [23.536061646000064, 50.24277415000007],
            [23.48159468600008, 50.215954082000096],
            [23.436429484000087, 50.19347483400007],
            [23.207916301000097, 50.03394968700003],
            [23.17784061700013, 50.00397735600011],
            [23.141253702000085, 49.98547719400007],
            [23.101462850000075, 49.957106832000065],
            [22.99304569500012, 49.85442576100006],
            [22.95118778500006, 49.826623841000114],
            [22.94591678800012, 49.81835561100006],
            [22.937751913000113, 49.798201803],
            [22.933101034000032, 49.79107045600004],
            [22.92441939200009, 49.78543772500002],
            [22.90674605300009, 49.781200257000066],
            [22.897961060000085, 49.77742787700005],
            [22.888245890000064, 49.769728088000065],
            [22.826647583000124, 49.697381083],
            [22.80980106600012, 49.6863223270001],
            [22.798845662000076, 49.68327341700005],
            [22.77734826600002, 49.68048289000011],
            [22.766186157000078, 49.67423004200002],
            [22.75895145600012, 49.665600078000054],
            [22.741691528000047, 49.63366404200009],
            [22.665830526000036, 49.56736318000007],
            [22.640922485000146, 49.52876088500007],
            [22.660146118000085, 49.493000794000054],
            [22.666864054000087, 49.478376364],
            [22.67306522600009, 49.435846660000024],
            [22.67678592900009, 49.424477845000055],
            [22.679576456000063, 49.41894846700005],
            [22.692598917000083, 49.405512594000086],
            [22.71419966600007, 49.390629781000044],
            [22.71978072100009, 49.38298167000006],
            [22.724224894000088, 49.367065329000056],
            [22.737764120000065, 49.275391338000034],
            [22.73394006300012, 49.26087026000009],
            [22.717093547000047, 49.230432841000024],
            [22.702934204000087, 49.19503448500011],
            [22.687121216000094, 49.17338206000004],
            [22.68174686700013, 49.16123809800003],
            [22.68784468600009, 49.15591542600008],
            [22.69249556500006, 49.15793080700003],
            [22.705724731000146, 49.168834534000084],
            [22.721434367000114, 49.161599833000125],
            [22.720194132000103, 49.161186422000114],
            [22.716370077000136, 49.16056630500013],
            [22.748822876000077, 49.145580140000064],
            [22.77807173700012, 49.12031036400002],
            [22.796468546000114, 49.11137034200006],
            [22.84132369000011, 49.094885559],
            [22.853415975000075, 49.08475697900003],
            [22.853519328000118, 49.07628204400005],
            [22.84442427600004, 49.056696676000016],
            [22.843184041000114, 49.043105774000125],
            [22.847524862000085, 49.03370066400008],
            [22.86375126100009, 49.01535553000009],
            [22.865014020000046, 49.013237354000054],
            [22.866955200000064, 49.009981181000015],
            [22.85527632600008, 48.994013164000094],
            [22.83501916500009, 48.99974924800004],
            [22.81290165200008, 49.01287506200002],
            [22.79502160600012, 49.019024556],
            [22.78396285000011, 49.0213499960001],
            [22.76546268700008, 49.038403219000045],
            [22.755334106000134, 49.044707743000046],
            [22.744482055000077, 49.045534567000075],
            [22.721951132000072, 49.04103871700006],
            [22.685777629000142, 49.04279571600004],
            [22.664383586000042, 49.041452128000074],
            [22.642886190000098, 49.04315745100003],
            [22.61828820800011, 49.05421620700004],
            [22.580771118000115, 49.081449687000045],
            [22.56072066300007, 49.08553212500006],
            [22.539636678000136, 49.072199606000126],
            [22.50501346900012, 49.08341339200008],
            [22.42677535000007, 49.08563547800007],
            [22.390085083000088, 49.09302520800007],
            [22.33944217900003, 49.12645986000008],
            [22.31815148900006, 49.13198923800006],
            [22.262857707000137, 49.13059397400009],
            [22.21593550600008, 49.13999908500004],
            [22.208494100000053, 49.1441848760001],
            [22.206220337000047, 49.1504894000001],
            [22.209010864000106, 49.15694895400004],
            [22.208907511000064, 49.16397694900006],
            [22.197952108000095, 49.17198679600004],
            [22.18968387800004, 49.173020325000024],
            [22.165706014000136, 49.171108297],
            [22.15568078600012, 49.171521708000014],
            [22.144105265000064, 49.17488067700002],
            [22.11154911300011, 49.188626608000064],
            [22.040752401000077, 49.19746327800006],
            [22.01243371600009, 49.21105418000006],
            [22.005819133000102, 49.242886861],
            [21.993210083000065, 49.27818186500009],
            [21.96447798600005, 49.30856760700006],
            [21.928407836000048, 49.330788472000094],
            [21.87456099500011, 49.34835846000006],
            [21.837870727000052, 49.37042429700007],
            [21.81957727000008, 49.377245586000114],
            [21.799423461000117, 49.37481679300005],
            [21.78216353300013, 49.36448150600005],
            [21.768004191000074, 49.35347442700005],
            [21.75756555200013, 49.3489269010001],
            [21.742165975000148, 49.357091777000036],
            [21.708576294000125, 49.39088816400003],
            [21.69172977700015, 49.40215362600007],
            [21.68180790200006, 49.40406565400009],
            [21.666304972000148, 49.40179189000007],
            [21.65876021300008, 49.40246368400007],
            [21.648631632000047, 49.407062887],
            [21.63002811700008, 49.41889679000003],
            [21.619899536000048, 49.42334096300003],
            [21.601192668000067, 49.42649322600009],
            [21.52956913300008, 49.421222229000065],
            [21.514421954000113, 49.417212682000056],
            [21.496186157000125, 49.41238556000006],
            [21.481510051000043, 49.41522776400002],
            [21.44440637200006, 49.409905091000084],
            [21.427869913000052, 49.40980173800007],
            [21.330408163000072, 49.427785136000054],
            [21.27439091000005, 49.44726715100005],
            [21.260541626000105, 49.449437561000124],
            [21.242454875000078, 49.441272685000015],
            [21.211242310000102, 49.41109364900011],
            [21.194085734000055, 49.40060333300006],
            [21.172588338000082, 49.39827789300004],
            [21.157292114000143, 49.4051508590001],
            [21.143029419000072, 49.41553782200002],
            [21.12494266700014, 49.423651022000016],
            [21.10943973800005, 49.42458119800007],
            [21.068822062000095, 49.41920684800003],
            [21.05352583800004, 49.41445261600002],
            [21.033268677000137, 49.399673157],
            [21.04546431500006, 49.39057810500013],
            [21.06851200300011, 49.38143137600004],
            [21.080707641000117, 49.36634185800004],
            [21.07254276600011, 49.35719513000005],
            [21.054042602000095, 49.3547663370001],
            [21.032958618000066, 49.35461130800006],
            [21.017248983000087, 49.35244089800007],
            [20.99668176300011, 49.33936676100002],
            [20.964022258000114, 49.30810251900003],
            [20.94242150900007, 49.29585520500008],
            [20.91896040800009, 49.290325826000085],
            [20.900563599000094, 49.29259958900012],
            [20.884337199000072, 49.30029937800002],
            [20.868007446000036, 49.31140981100002],
            [20.849300578000054, 49.32050486200008],
            [20.833590943000075, 49.32205515600002],
            [20.816537719000053, 49.32138336200005],
            [20.794110148000073, 49.32365712600004],
            [20.77829716000008, 49.331201884],
            [20.68951704900013, 49.40049998000002],
            [20.67391076600009, 49.40230865500003],
            [20.636083618000043, 49.39832957000003],
            [20.614482870000046, 49.40044830300012],
            [20.60528446400005, 49.40003489200011],
            [20.59505253100008, 49.396262512000064],
            [20.579136189000053, 49.383395081000074],
            [20.567664022000116, 49.37636708600006],
            [20.543996215000107, 49.37083770800008],
            [20.522085408000066, 49.374351705000024],
            [20.437542765000074, 49.402515361000084],
            [20.421936483000138, 49.40018992200005],
            [20.422143188000092, 49.38298167000006],
            [20.37046675600007, 49.381689758000036],
            [20.32953902100013, 49.39176666300007],
            [20.317653443000097, 49.391611633000096],
            [20.307421509000022, 49.38659902000005],
            [20.30370080600011, 49.38039784800007],
            [20.301633748000143, 49.371199443000066],
            [20.296466105000064, 49.35693674700009],
            [20.28933475700012, 49.34308746400002],
            [20.28437382000007, 49.338643291000025],
            [20.20716923000009, 49.3341991170001],
            [20.19197635900005, 49.32861806300009],
            [20.170168904000036, 49.311616516000086],
            [20.160350382000075, 49.30562205000005],
            [20.138336222000078, 49.30732737300012],
            [20.13585575400012, 49.308877665000026],
            [20.130171346000054, 49.30391672800009],
            [20.111051066000073, 49.27585642500007],
            [20.10536665900011, 49.26397084600005],
            [20.09844201700014, 49.25286041300002],
            [20.086039673000073, 49.24304189100006],
            [20.080355265000037, 49.20810862300006],
            [20.070019979000108, 49.18309722900007],
            [20.050486287000098, 49.17322703100008],
            [20.017310018000103, 49.18387237600008],
            [19.965736939000095, 49.2156533820001],
            [19.937935018000132, 49.225110168000086],
            [19.905895630000117, 49.222784729000054],
            [19.8878088780001, 49.21399973600005],
            [19.86829182300005, 49.200788191000086],
            [19.854219197000077, 49.19126210600008],
            [19.83199833200004, 49.185887756000014],
            [19.785902954000022, 49.18816152000004],
            [19.76068485500008, 49.194207663000086],
            [19.747765747000074, 49.20588653600005],
            [19.75179650800007, 49.21906402600003],
            [19.78962365700005, 49.259474996],
            [19.79406783000013, 49.26185211200006],
            [19.80047570800008, 49.26304067000008],
            [19.806263469000072, 49.26526275700009],
            [19.80864058500009, 49.27089548800002],
            [19.806780233000097, 49.275236308],
            [19.806415196000103, 49.2754875670001],
            [19.798822062000028, 49.28071401000007],
            [19.798563188000116, 49.281080748000036],
            [19.796961711000023, 49.283349508000086],
            [19.796859623000017, 49.28339901700009],
            [19.783215779000102, 49.290015768],
            [19.779701783000036, 49.29337473500003],
            [19.77971320600011, 49.293452792],
            [19.780321899000114, 49.29761220300007],
            [19.787970011000084, 49.30510528600011],
            [19.78952030500011, 49.309187725000115],
            [19.783629191000102, 49.35755686500006],
            [19.77856490100004, 49.37419667600007],
            [19.769263143000103, 49.39311025000002],
            [19.76905606000011, 49.39321262800006],
            [19.760064738000096, 49.39765777600006],
            [19.726578409000098, 49.38887278300008],
            [19.706321249000098, 49.3875291960001],
            [19.684513794000082, 49.389079489000025],
            [19.627043767000117, 49.40186758800003],
            [19.627097479000042, 49.402165448000076],
            [19.629220012000047, 49.41393585200008],
            [19.628599894000075, 49.42959381100003],
            [19.630150187000112, 49.43501983600002],
            [19.63480106600008, 49.44132436200003],
            [19.59480350700011, 49.4415827430001],
            [19.573926229000023, 49.4452517700001],
            [19.556769654000078, 49.453881735000024],
            [19.551602010000067, 49.461013082000065],
            [19.535478963000088, 49.492845765000126],
            [19.517288859000132, 49.543281963000126],
            [19.505196574000138, 49.563384095000075],
            [19.48173547300007, 49.57351267500003],
            [19.474190714000116, 49.57873199500007],
            [19.457344197000054, 49.59805898100011],
            [19.448889797000078, 49.600313488000026],
            [19.443391561000055, 49.60177968400002],
            [19.43760380100008, 49.600126038000056],
            [19.433779745000066, 49.59516510100012],
            [19.347066691000094, 49.532998353000025],
            [19.339521931000036, 49.52876088500007],
            [19.325362590000083, 49.52504018200007],
            [19.31502730300008, 49.52395497700006],
            [19.284228150000104, 49.52416168300003],
            [19.26500451700008, 49.521474508],
            [19.24867476400007, 49.51625518900009],
            [19.2341020100001, 49.507211813000126],
            [19.220459432000098, 49.493000794000054],
            [19.204439738000133, 49.460547995000056],
            [19.206196737000113, 49.45941111300003],
            [19.209400676000087, 49.45641388000003],
            [19.211364380000106, 49.45165964800013],
            [19.208987264000086, 49.444993388000015],
            [19.204543091000062, 49.442822978000024],
            [19.19224410000004, 49.44261627200008],
            [19.18935022000005, 49.44220286100007],
            [19.18232222500012, 49.422720846000075],
            [19.179738403000044, 49.41026682500008],
            [19.172503703000075, 49.402256978000096],
            [19.14170454900008, 49.39419545600002],
            [19.116589803000068, 49.39093984000003],
            [19.106254517000053, 49.39140492800006],
            [19.09664270000013, 49.39460886700003],
            [19.076798951000058, 49.40406565400009],
            [19.06760054500006, 49.40613271100007],
            [19.04579309100012, 49.402773743000054],
            [19.00713912000012, 49.38809763700006],
            [18.981817668000133, 49.38680572600002],
            [18.96228397700014, 49.38918284100005],
            [18.95670292200012, 49.40044830300012],
            [18.960837036000044, 49.43331451500005],
            [18.958253214000138, 49.448145650000086],
            [18.953395630000045, 49.461684876000064],
            [18.952362101000062, 49.47594757100002],
            [18.96114709500003, 49.492794088000025],
            [18.93220829300006, 49.504317932000035],
            [18.833196249000082, 49.51026072200004],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Ireland',
        iso3: 'IRL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7.247100389999957, 55.06932200700004],
              [-7.266502644999889, 55.06516713500007],
              [-7.275287638999885, 55.05886261000005],
              [-7.282987426999881, 55.05183461600005],
              [-7.291152302999905, 55.0466152960001],
              [-7.355024372999935, 55.04093088800006],
              [-7.366961629999906, 55.035556540000115],
              [-7.376986856999906, 55.028890279],
              [-7.405253865999896, 55.003568827000024],
              [-7.401119750999953, 54.99483551100006],
              [-7.403755248999886, 54.99313018900007],
              [-7.409077921999938, 54.9920449830001],
              [-7.413108682999848, 54.98496531200006],
              [-7.407424275999887, 54.95943715500003],
              [-7.408664510999927, 54.951117248000074],
              [-7.415755225999874, 54.94437242200003],
              [-7.417139444999918, 54.94305572600008],
              [-7.436983194999925, 54.93830149400007],
              [-7.445251423999878, 54.932151998],
              [-7.448972126999877, 54.9203180950001],
              [-7.444734659999909, 54.89489329100009],
              [-7.444734659999909, 54.88445465100007],
              [-7.455069945999924, 54.86300893200003],
              [-7.470831258999908, 54.8452839160001],
              [-7.543384968999931, 54.793090719000034],
              [-7.549741170999937, 54.77960317000007],
              [-7.551704874999899, 54.75469513000009],
              [-7.5483975839999, 54.74720204700007],
              [-7.543023233999918, 54.74379140300003],
              [-7.543074910999849, 54.74167266900007],
              [-7.556149047999895, 54.73836537800007],
              [-7.566639363999855, 54.73867543600004],
              [-7.585397907999948, 54.744721578000096],
              [-7.615370238999986, 54.739347229000046],
              [-7.649683390999911, 54.744876608000126],
              [-7.667511759999854, 54.73877878900008],
              [-7.702289997999912, 54.71888336200006],
              [-7.736603149999922, 54.70746287100006],
              [-7.770502888999943, 54.70601593100007],
              [-7.803575805999913, 54.716144511000024],
              [-7.832152872999899, 54.73061391200007],
              [-7.845898803999916, 54.73102732300008],
              [-7.880108601999922, 54.71102854400003],
              [-7.929666300999884, 54.696714173000046],
              [-7.913233194999918, 54.68865264900005],
              [-7.907135375999871, 54.68668894500003],
              [-7.914835164999943, 54.67165110300003],
              [-7.906618611999932, 54.66131581600003],
              [-7.890082153999913, 54.655062968000024],
              [-7.87277054899991, 54.65222076500005],
              [-7.864347290999945, 54.64906850200002],
              [-7.854270385999911, 54.63640777600007],
              [-7.846415567999969, 54.63144683800003],
              [-7.838043985999889, 54.63124013300005],
              [-7.822541055999892, 54.63811309800012],
              [-7.814996296999936, 54.63945668600009],
              [-7.801198689999893, 54.63480580700012],
              [-7.769159301999878, 54.61801096600006],
              [-7.753553019999941, 54.614496969000115],
              [-7.736758178999878, 54.61925120000011],
              [-7.721203572999855, 54.625865784],
              [-7.710558227999854, 54.62426381500005],
              [-7.707951474999902, 54.60476330300004],
              [-7.707871052999906, 54.6041616830001],
              [-7.749263875999873, 54.59615183600003],
              [-7.848844360999919, 54.54090972900012],
              [-7.887136596999937, 54.53212473600003],
              [-7.926410685999912, 54.53305491200008],
              [-8.002194172999879, 54.543441875],
              [-8.023278157999925, 54.52969594400007],
              [-8.043561156999914, 54.51222930900012],
              [-8.05586014799988, 54.49755320300004],
              [-8.06097611499996, 54.49331573500008],
              [-8.072448282999886, 54.487062887],
              [-8.09704626499996, 54.47858795200007],
              [-8.150169636999891, 54.46938954700009],
              [-8.168466710999894, 54.463476955],
              [-8.173837442999911, 54.46174143500009],
              [-8.161176717999894, 54.45481679300012],
              [-8.15812780799996, 54.44711700500004],
              [-8.156034911999882, 54.43905548100004],
              [-8.146345580999963, 54.43073557600009],
              [-8.12241939299986, 54.415232646000064],
              [-8.079941364999911, 54.380196025000046],
              [-8.056480265999937, 54.36588165400006],
              [-8.031339680999906, 54.35802683500002],
              [-8.002194172999879, 54.357923483],
              [-7.981032673999948, 54.32655588900006],
              [-7.968010213999889, 54.31218984000007],
              [-7.950801961999929, 54.30087270200009],
              [-7.942074756999915, 54.29887328100004],
              [-7.93411047299989, 54.29704864600005],
              [-7.894965576999937, 54.29358632400003],
              [-7.880263631999867, 54.28702341700004],
              [-7.873649047999947, 54.271055400000094],
              [-7.869669961999875, 54.2268720500001],
              [-7.856440796999891, 54.21142079700009],
              [-7.836958780999908, 54.204341126000074],
              [-7.782078409999883, 54.200000305000074],
              [-7.722598836999907, 54.20232574500001],
              [-7.704770466999889, 54.200362041000076],
              [-7.632681843999904, 54.16852935800004],
              [-7.625705525999905, 54.162173157000026],
              [-7.624051879999854, 54.153336487],
              [-7.620796264999854, 54.14496490500004],
              [-7.609014037999941, 54.13990061500006],
              [-7.502302204999864, 54.12512115500003],
              [-7.480753132999922, 54.127653300000034],
              [-7.439618692999943, 54.146928610000074],
              [-7.414658976999959, 54.145688376000024],
              [-7.425769408999884, 54.136955058000055],
              [-7.422255411999913, 54.13545644200006],
              [-7.412230183999895, 54.1364382930001],
              [-7.403961954999943, 54.135043030000034],
              [-7.396623900999941, 54.12625803600004],
              [-7.394660197999912, 54.121917217000075],
              [-7.390216023999898, 54.12119374600006],
              [-7.375488240999914, 54.12331248000005],
              [-7.326964069999917, 54.11359731],
              [-7.316489273999906, 54.11428045000004],
              [-7.310324259999902, 54.11468251600009],
              [-7.333165242999911, 54.14274281900002],
              [-7.333165242999911, 54.14940907900005],
              [-7.325982218999854, 54.154576722000044],
              [-7.295544799999988, 54.165118714000116],
              [-7.292134155999861, 54.162638245000025],
              [-7.295028035999849, 54.155403545000055],
              [-7.29642329999993, 54.146515198000046],
              [-7.296319946999887, 54.13499135400012],
              [-7.297353474999881, 54.125896302000044],
              [-7.293787800999922, 54.1220205690001],
              [-7.280041870999867, 54.126154683000024],
              [-7.270740112999931, 54.13225250200007],
              [-7.263505411999887, 54.14098582000004],
              [-7.260869913999954, 54.1511660770001],
              [-7.265365762999892, 54.16113962900003],
              [-7.245780395999873, 54.16697906500012],
              [-7.247020629999895, 54.17225006200006],
              [-7.256322387999916, 54.17690094000001],
              [-7.261128295999924, 54.18088002500009],
              [-7.255495564999904, 54.190853577],
              [-7.249087686999871, 54.19741648400007],
              [-7.24087113499985, 54.20232574500001],
              [-7.229502319999938, 54.20754506400003],
              [-7.174725300999853, 54.216071676000055],
              [-7.153331257999952, 54.22423655300007],
              [-7.159739135999899, 54.240669657000026],
              [-7.145889851999925, 54.25209014900004],
              [-7.181494913999899, 54.269763489000056],
              [-7.175500446999877, 54.28366444900011],
              [-7.209038452999891, 54.293431296000065],
              [-7.211467244999938, 54.30417999300009],
              [-7.206661336999929, 54.30490346300009],
              [-7.199168253999915, 54.303456523000094],
              [-7.193690551999907, 54.30753896100002],
              [-7.192398640999954, 54.307383932000064],
              [-7.184647175999942, 54.31663401300007],
              [-7.185008910999954, 54.31725413100004],
              [-7.187644408999887, 54.31880442300006],
              [-7.1914684649999, 54.32386871300004],
              [-7.193948933999877, 54.329966532000086],
              [-7.192450316999981, 54.334720764000096],
              [-7.189469552999896, 54.33569177100004],
              [-7.185629028999927, 54.3369428510001],
              [-7.168059040999935, 54.33503082400007],
              [-7.15989416499994, 54.335185852],
              [-7.127027953999914, 54.349758606000066],
              [-7.078503783999906, 54.394717103000076],
              [-7.049254923999882, 54.411511943000065],
              [-7.01783565299985, 54.4131655880001],
              [-6.984090942999956, 54.40308868500007],
              [-6.922027547999903, 54.372702942],
              [-6.915051228999914, 54.36593332900007],
              [-6.905956176999922, 54.34903513700009],
              [-6.897894652999952, 54.34619293300001],
              [-6.885957397999903, 54.345624492000056],
              [-6.879704548999911, 54.34159373000007],
              [-6.870014701999906, 54.326000603000054],
              [-6.85841385899991, 54.30733225600004],
              [-6.856656860999948, 54.29281117800009],
              [-6.864666707999902, 54.28273427300006],
              [-6.882185017999888, 54.27725657200007],
              [-6.846683308999928, 54.26645619700004],
              [-6.837743285999892, 54.26051340800002],
              [-6.833195759999882, 54.25209014900004],
              [-6.829733438999909, 54.24237498000009],
              [-6.823945678999848, 54.232349752000076],
              [-6.807357543999927, 54.216330058000025],
              [-6.78782385299985, 54.202997539000094],
              [-6.766481486999851, 54.192352194000094],
              [-6.74477738499985, 54.18418731700008],
              [-6.732840128999896, 54.18356720000013],
              [-6.724778605999916, 54.188631491000095],
              [-6.717233845999942, 54.19514272100007],
              [-6.706536824999944, 54.19891510100008],
              [-6.694651244999932, 54.19798492500003],
              [-6.683954223999905, 54.194367575000044],
              [-6.663025268999917, 54.1838255820001],
              [-6.648448442999893, 54.17366497000005],
              [-6.640339314999949, 54.1680125940001],
              [-6.634551554999888, 54.15013254800003],
              [-6.643956664999848, 54.13183909100006],
              [-6.666435913999862, 54.114785869000045],
              [-6.655790567999873, 54.103313700000015],
              [-6.657082478999911, 54.09194488600012],
              [-6.672533732999909, 54.06843210900003],
              [-6.657289184999883, 54.06114573200007],
              [-6.630624144999928, 54.041818746],
              [-6.616464803999889, 54.03727122100007],
              [-6.610987100999893, 54.0392349240001],
              [-6.605217158999977, 54.044475258],
              [-6.600290079999894, 54.048950094000034],
              [-6.59507075999997, 54.05241241500009],
              [-6.587164265999917, 54.05334259000004],
              [-6.571868041999949, 54.049518534000086],
              [-6.564013224999911, 54.048950094000034],
              [-6.478540405999894, 54.06770863900003],
              [-6.450893513999887, 54.06843210900003],
              [-6.450221719999917, 54.066675111000066],
              [-6.446242635999937, 54.06243764300011],
              [-6.440299844999913, 54.05799346900001],
              [-6.433891967999955, 54.05530629500008],
              [-6.426760619999925, 54.055409648000094],
              [-6.401025756999928, 54.06088735000007],
              [-6.377512980999938, 54.063264466000035],
              [-6.371156778999932, 54.06677846300009],
              [-6.366919310999975, 54.07509836900006],
              [-6.367642781999876, 54.08341827400001],
              [-6.369348103999926, 54.09111806200009],
              [-6.368107869999903, 54.097319234000096],
              [-6.354827025999896, 54.11065175400002],
              [-6.346662149999872, 54.109876607],
              [-6.338962361999961, 54.10295196600002],
              [-6.327128458999965, 54.09788767500005],
              [-6.313795938999931, 54.09969635000003],
              [-6.299584920999877, 54.104037171000115],
              [-6.284650430999932, 54.105225728000036],
              [-6.269886847999942, 54.09792715100008],
              [-6.207020636999914, 54.061712958000044],
              [-6.191395636999914, 54.05695221600007],
              [-6.184315558999913, 54.05377838700008],
              [-6.169911261999914, 54.03961823100008],
              [-6.163807745999918, 54.036444403000075],
              [-6.142486131999931, 54.035223700000074],
              [-6.133859829999949, 54.03335195500006],
              [-6.126535610999952, 54.03021881700005],
              [-6.107289191999939, 54.01361725500004],
              [-6.110991990999935, 54.001288153000075],
              [-6.143544074999909, 53.97842031500005],
              [-6.160755988999938, 53.97443268400008],
              [-6.185536261999914, 53.979722398000035],
              [-6.209095831999946, 53.98859284100007],
              [-6.222767706999946, 53.995428778000075],
              [-6.237049933999913, 53.993841864000046],
              [-6.307036912999934, 54.01186758000006],
              [-6.359852667999917, 54.01601797100005],
              [-6.359852667999917, 54.00849030200004],
              [-6.347808397999927, 54.003607489000046],
              [-6.353871222999942, 53.994208075000074],
              [-6.366281704999949, 53.98102448100008],
              [-6.372954881999931, 53.96442291900007],
              [-6.378285285999937, 53.934881903000075],
              [-6.378977016999954, 53.916896877000056],
              [-6.372954881999931, 53.899318752000056],
              [-6.350819464999915, 53.88141510600008],
              [-6.317290818999936, 53.871079820000034],
              [-6.243234829999949, 53.86513906500005],
              [-6.243234829999949, 53.85765208500004],
              [-6.254017706999946, 53.839911200000074],
              [-6.254994269999941, 53.82221100500004],
              [-6.244984503999945, 53.80687083500004],
              [-6.222767706999946, 53.79629140800006],
              [-6.243275519999941, 53.782538153000075],
              [-6.248443162999934, 53.75576406500005],
              [-6.245798305999926, 53.72964101800005],
              [-6.241322394999941, 53.685614325000074],
              [-6.236439581999946, 53.67084381700005],
              [-6.229888475999928, 53.65656159100007],
              [-6.222767706999946, 53.64606354400007],
              [-6.213042772999927, 53.64057038000004],
              [-6.197987433999913, 53.634466864000046],
              [-6.187082485999952, 53.630072333000044],
              [-6.169789191999939, 53.60565827000005],
              [-6.142486131999931, 53.59446849200003],
              [-6.112456834999932, 53.58576080900008],
              [-6.092396613999938, 53.57713450700004],
              [-6.084462042999917, 53.568019924000055],
              [-6.077300584999932, 53.55463288000004],
              [-6.074940558999913, 53.53974030200004],
              [-6.081532355999911, 53.52594635600008],
              [-6.098500128999945, 53.50971100500004],
              [-6.103138800999943, 53.503159898000035],
              [-6.105458136999914, 53.49518463700008],
              [-6.112782355999911, 53.48672109600005],
              [-6.124419725999928, 53.46857330900008],
              [-6.133371548999946, 53.46108633000006],
              [-6.14085852799991, 53.471136786000045],
              [-6.158355272999927, 53.47284577000005],
              [-6.178618943999936, 53.46865469000005],
              [-6.194813605999911, 53.46108633000006],
              [-6.130604620999918, 53.442613023000035],
              [-6.125803188999953, 53.43158600500004],
              [-6.122222459999932, 53.41986725500004],
              [-6.112904425999943, 53.41266510600008],
              [-6.116444464999915, 53.409491278000075],
              [-6.122954881999931, 53.40216705900008],
              [-6.126535610999952, 53.39899323100008],
              [-6.110259568999936, 53.39402903900003],
              [-6.069081183999913, 53.39252350500004],
              [-6.050852016999954, 53.38540273600006],
              [-6.062001105999911, 53.36737702000005],
              [-6.074615037999934, 53.366888739000046],
              [-6.08820553299995, 53.37396881700005],
              [-6.102365688999953, 53.37848541900007],
              [-6.106434699999909, 53.38080475500004],
              [-6.118885870999918, 53.39057038000004],
              [-6.122792120999918, 53.39276764500005],
              [-6.132313605999911, 53.39158763200004],
              [-6.149769660999937, 53.38654205900008],
              [-6.156971808999913, 53.38540273600006],
              [-6.215321417999917, 53.35805898600006],
              [-6.218169725999928, 53.34715403900003],
              [-6.211333787999934, 53.33869049700007],
              [-6.187977667999917, 53.323919989000046],
              [-6.168365037999934, 53.306341864000046],
              [-6.155181443999936, 53.29938385600008],
              [-6.127105272999927, 53.29539622600004],
              [-6.116607225999928, 53.290269273000035],
              [-6.109120245999918, 53.289129950000074],
              [-6.096994594999956, 53.28554922100005],
              [-6.096994594999956, 53.27757396000004],
              [-6.102162238999938, 53.26935455900008],
              [-6.105458136999914, 53.26520416900007],
              [-6.106556769999941, 53.24315013200004],
              [-6.104888475999928, 53.22943756700005],
              [-6.099232550999943, 53.21466705900008],
              [-6.088937954999949, 53.20408763200004],
              [-6.088693813999953, 53.20380280200004],
              [-6.076975063999953, 53.19521719000005],
              [-6.071034308999913, 53.18427155200004],
              [-6.078114386999914, 53.16620514500005],
              [-6.06468665299991, 53.154364325000074],
              [-6.030384894999941, 53.111029364000046],
              [-6.032093878999945, 53.10724518400008],
              [-6.032704230999911, 53.106634833000044],
              [-6.033680792999917, 53.106675523000035],
              [-6.037098761999914, 53.104803778000075],
              [-6.032460089999915, 53.08844635600008],
              [-6.033802863999938, 53.064154364000046],
              [-6.039418097999942, 53.040350653000075],
              [-6.047434048999946, 53.02533600500004],
              [-6.051625128999945, 53.00926341400003],
              [-6.038482225999928, 52.993801174000055],
              [-5.996571417999917, 52.964911200000074],
              [-5.993519660999937, 52.95742422100005],
              [-6.006459113999938, 52.954006252000056],
              [-6.011830206999946, 52.949652411000045],
              [-6.021839972999942, 52.930894273000035],
              [-6.026966925999943, 52.926662502000056],
              [-6.037953253999945, 52.91966380400004],
              [-6.071929490999935, 52.87201569200005],
              [-6.064442511999914, 52.864569403000075],
              [-6.107289191999939, 52.83978913000004],
              [-6.119048631999931, 52.83047109600005],
              [-6.130116339999915, 52.81598541900007],
              [-6.153879360999952, 52.76837799700007],
              [-6.147857225999928, 52.746161200000074],
              [-6.15103105399993, 52.74156321800007],
              [-6.168446417999917, 52.716782945000034],
              [-6.215321417999917, 52.66596100500004],
              [-6.220570441999939, 52.64728424700007],
              [-6.219471808999913, 52.63231028900003],
              [-6.209095831999946, 52.60390859600005],
              [-6.206450975999928, 52.58852773600006],
              [-6.209095831999946, 52.54584381700005],
              [-6.222238735999952, 52.52838776200008],
              [-6.282948370999918, 52.46710846600007],
              [-6.30101477799991, 52.45368073100008],
              [-6.317738410999937, 52.44794342700004],
              [-6.333241339999915, 52.43463776200008],
              [-6.356190558999913, 52.40900299700007],
              [-6.36554928299995, 52.39350006700005],
              [-6.366200324999909, 52.37523021000004],
              [-6.364369269999941, 52.35781484600005],
              [-6.366118943999936, 52.34442780200004],
              [-6.373036261999914, 52.351996161000045],
              [-6.380970831999946, 52.356756903000075],
              [-6.390044725999928, 52.35883209800005],
              [-6.448068813999953, 52.355902411000045],
              [-6.468861456999946, 52.36001211100006],
              [-6.462961391999954, 52.37799713700008],
              [-6.472035285999937, 52.37592194200005],
              [-6.48070227799991, 52.37299225500004],
              [-6.488758917999917, 52.369126695000034],
              [-6.496490037999934, 52.36432526200008],
              [-6.496490037999934, 52.35809967700004],
              [-6.481434699999909, 52.35464101800005],
              [-6.467518683999913, 52.346869208000044],
              [-6.456125454999949, 52.33584219000005],
              [-6.448638475999928, 52.322699286000045],
              [-6.454986131999931, 52.31224192900004],
              [-6.423736131999931, 52.307928778000075],
              [-6.414540167999917, 52.29975006700005],
              [-6.409169074999909, 52.28925202000005],
              [-6.396880662999934, 52.298081773000035],
              [-6.372954881999931, 52.322699286000045],
              [-6.372954881999931, 52.316473700000074],
              [-6.389759894999941, 52.29559967700004],
              [-6.36978105399993, 52.27260976800005],
              [-6.318348761999914, 52.24079010600008],
              [-6.347035285999937, 52.197251695000034],
              [-6.359852667999917, 52.18618398600006],
              [-6.369862433999913, 52.17999909100007],
              [-6.377064581999946, 52.17820872600004],
              [-6.386586066999939, 52.179348049000055],
              [-6.399484829999949, 52.18549225500004],
              [-6.397328253999945, 52.190659898000035],
              [-6.390004035999937, 52.195298570000034],
              [-6.380970831999946, 52.20758698100008],
              [-6.382313605999911, 52.21198151200008],
              [-6.394032355999911, 52.21283600500004],
              [-6.400054490999935, 52.210923570000034],
              [-6.408762173999946, 52.203192450000074],
              [-6.420887824999909, 52.19672272300005],
              [-6.422678188999953, 52.19476959800005],
              [-6.425607876999948, 52.193793036000045],
              [-6.469105597999942, 52.19358958500004],
              [-6.469105597999942, 52.19977448100008],
              [-6.448638475999928, 52.19977448100008],
              [-6.462310350999928, 52.20718008000006],
              [-6.472564256999931, 52.20697663000004],
              [-6.489654100999928, 52.19977448100008],
              [-6.537464972999942, 52.19358958500004],
              [-6.579741990999935, 52.17820872600004],
              [-6.597157355999911, 52.17959219000005],
              [-6.623117641999954, 52.19672272300005],
              [-6.641428188999953, 52.202785549000055],
              [-6.715565558999913, 52.21662018400008],
              [-6.786284959999932, 52.21002838700008],
              [-6.805572068999936, 52.21283600500004],
              [-6.805572068999936, 52.220363674000055],
              [-6.790435350999928, 52.22443268400008],
              [-6.775990363999938, 52.23322174700007],
              [-6.76585852799991, 52.245754299000055],
              [-6.764027472999942, 52.26129791900007],
              [-6.775990363999938, 52.250881252000056],
              [-6.792958136999914, 52.24042389500005],
              [-6.812652147999927, 52.23529694200005],
              [-6.83226477799991, 52.24079010600008],
              [-6.839100714999915, 52.23456452000005],
              [-6.838002081999946, 52.226548570000034],
              [-6.836537238999938, 52.22333405200004],
              [-6.836415167999917, 52.22020091400003],
              [-6.839100714999915, 52.21283600500004],
              [-6.828277147999927, 52.21759674700007],
              [-6.824777798999946, 52.220363674000055],
              [-6.81859290299991, 52.220363674000055],
              [-6.821848110999952, 52.20571523600006],
              [-6.824940558999913, 52.19993724200003],
              [-6.83226477799991, 52.19358958500004],
              [-6.825428839999915, 52.19318268400008],
              [-6.81859290299991, 52.19358958500004],
              [-6.81859290299991, 52.18618398600006],
              [-6.821929490999935, 52.18577708500004],
              [-6.828928188999953, 52.18626536700003],
              [-6.83226477799991, 52.18618398600006],
              [-6.824777798999946, 52.179348049000055],
              [-6.897084113999938, 52.152044989000046],
              [-6.907215949999909, 52.14557526200008],
              [-6.918568488999938, 52.13300202000005],
              [-6.932118292999917, 52.124660549000055],
              [-6.948963995999918, 52.130926825000074],
              [-6.93976803299995, 52.14321523600006],
              [-6.927886522999927, 52.14980703300006],
              [-6.915191209999932, 52.15485260600008],
              [-6.903920050999943, 52.16229889500005],
              [-6.903716600999928, 52.17218659100007],
              [-6.921009894999941, 52.21283600500004],
              [-6.926747199999909, 52.21971263200004],
              [-6.936675584999932, 52.22907135600008],
              [-6.948312954999949, 52.23725006700005],
              [-6.958851691999939, 52.24079010600008],
              [-6.970122850999928, 52.247381903000075],
              [-6.984730597999942, 52.278631903000075],
              [-6.997385219999956, 52.28921133000006],
              [-6.994496222999942, 52.27753327000005],
              [-6.991851365999935, 52.266791083000044],
              [-6.990589972999942, 52.26166413000004],
              [-6.989898240999935, 52.251654364000046],
              [-6.986805792999917, 52.24689362200007],
              [-6.97288977799991, 52.23021067900004],
              [-6.969471808999913, 52.220363674000055],
              [-6.982289191999939, 52.19562409100007],
              [-6.979969855999911, 52.18593984600005],
              [-6.955148891999954, 52.18618398600006],
              [-6.955148891999954, 52.179348049000055],
              [-6.97101803299995, 52.17129140800006],
              [-6.999867316999939, 52.14671458500004],
              [-7.017201300999943, 52.138373114000046],
              [-7.039458787999934, 52.135199286000045],
              [-7.084584113999938, 52.13434479400007],
              [-7.106027798999946, 52.130926825000074],
              [-7.100087042999917, 52.14215729400007],
              [-7.071848110999952, 52.165716864000046],
              [-7.093902147999927, 52.17177969000005],
              [-7.106353318999936, 52.17300039300005],
              [-7.120228644999941, 52.171942450000074],
              [-7.120228644999941, 52.165716864000046],
              [-7.114491339999915, 52.16278717700004],
              [-7.111683722999942, 52.15973541900007],
              [-7.109527147999927, 52.156317450000074],
              [-7.106027798999946, 52.152044989000046],
              [-7.116444464999915, 52.15314362200007],
              [-7.129302537999934, 52.15778229400007],
              [-7.137318488999938, 52.15888092700004],
              [-7.149647589999915, 52.156317450000074],
              [-7.156361456999946, 52.150458075000074],
              [-7.161000128999945, 52.14362213700008],
              [-7.167469855999911, 52.138373114000046],
              [-7.187367316999939, 52.13275788000004],
              [-7.205962693999936, 52.13275788000004],
              [-7.243763800999943, 52.138373114000046],
              [-7.435454881999931, 52.12567780200004],
              [-7.504302537999934, 52.10268789300005],
              [-7.541411912999934, 52.09739817900004],
              [-7.546213344999956, 52.094916083000044],
              [-7.549956834999932, 52.08974844000005],
              [-7.555287238999938, 52.08490631700005],
              [-7.565297003999945, 52.08372630400004],
              [-7.572255011999914, 52.087591864000046],
              [-7.57648678299995, 52.094631252000056],
              [-7.579416469999956, 52.101263739000046],
              [-7.582630988999938, 52.10423411700003],
              [-7.599964972999942, 52.10101959800005],
              [-7.619007941999939, 52.092230536000045],
              [-7.63109290299991, 52.07904694200005],
              [-7.627349412999934, 52.06268952000005],
              [-7.617583787999934, 52.07021719000005],
              [-7.602162238999938, 52.07168203300006],
              [-7.583892381999931, 52.06858958500004],
              [-7.554107225999928, 52.060248114000046],
              [-7.546783006999931, 52.05927155200004],
              [-7.54515540299991, 52.05499909100007],
              [-7.55101477799991, 52.04279205900008],
              [-7.582630988999938, 52.028509833000044],
              [-7.586415167999917, 51.998114325000074],
              [-7.589914516999954, 51.99115631700005],
              [-7.598255988999938, 51.98908112200007],
              [-7.608265753999945, 51.987941799000055],
              [-7.616525844999956, 51.98383209800005],
              [-7.63540605399993, 51.97675202000005],
              [-7.688465949999909, 51.98037344000005],
              [-7.70929928299995, 51.973863023000035],
              [-7.717640753999945, 51.95990631700005],
              [-7.717396613999938, 51.94961172100005],
              [-7.72329667899993, 51.944566148000035],
              [-7.829335089999915, 51.95343659100007],
              [-7.832427537999934, 51.95758698100008],
              [-7.834055141999954, 51.96674225500004],
              [-7.838490363999938, 51.975897528000075],
              [-7.84984290299991, 51.980129299000055],
              [-7.85179602799991, 51.97711823100008],
              [-7.853016730999911, 51.97516510600008],
              [-7.85415605399993, 51.95136139500005],
              [-7.856678839999915, 51.94285716400009],
              [-7.869862433999913, 51.92951080900008],
              [-7.884266730999911, 51.91909414300005],
              [-7.901193813999953, 51.91266510600008],
              [-7.922230597999942, 51.911810614000046],
              [-7.892648891999954, 51.89484284100007],
              [-7.880604620999918, 51.89199453300006],
              [-7.891468878999945, 51.88190338700008],
              [-7.914173956999946, 51.87579987200007],
              [-7.95571855399993, 51.87018463700008],
              [-8.008168097999942, 51.85578034100007],
              [-8.023060675999943, 51.84357330900008],
              [-8.00413977799991, 51.82990143400008],
              [-8.020578579999949, 51.823919989000046],
              [-8.096099412999934, 51.814113674000055],
              [-8.134185350999928, 51.804754950000074],
              [-8.19717363199993, 51.80093008000006],
              [-8.224761522999927, 51.80255768400008],
              [-8.23619544199994, 51.802069403000075],
              [-8.246205206999946, 51.802720445000034],
              [-8.250559048999946, 51.806301174000055],
              [-8.24795488199993, 51.81342194200005],
              [-8.241200324999909, 51.81854889500005],
              [-8.232411261999914, 51.82200755400004],
              [-8.223255988999938, 51.82367584800005],
              [-8.225493943999936, 51.82729726800005],
              [-8.230091925999943, 51.83673737200007],
              [-8.215646938999953, 51.83844635600008],
              [-8.201649542999917, 51.84198639500005],
              [-8.188221808999913, 51.84796784100007],
              [-8.175404425999943, 51.85716380400004],
              [-8.181630011999914, 51.85932038000004],
              [-8.186838344999956, 51.861761786000045],
              [-8.193104620999918, 51.86367422100005],
              [-8.202788865999935, 51.86399974200003],
              [-8.195301886999914, 51.877020575000074],
              [-8.190500454999949, 51.88108958500004],
              [-8.182240363999938, 51.88450755400004],
              [-8.187082485999952, 51.89313385600008],
              [-8.193755662999934, 51.895412502000056],
              [-8.201527472999942, 51.89215729400007],
              [-8.210194464999915, 51.88450755400004],
              [-8.223255988999938, 51.89008209800005],
              [-8.243560350999928, 51.89288971600007],
              [-8.284657355999911, 51.89199453300006],
              [-8.284657355999911, 51.898138739000046],
              [-8.29320227799991, 51.90330638200004],
              [-8.310373501999948, 51.900824286000045],
              [-8.328846808999913, 51.895412502000056],
              [-8.347401495999918, 51.89199453300006],
              [-8.388498501999948, 51.893459377000056],
              [-8.40884355399993, 51.891791083000044],
              [-8.429351365999935, 51.88450755400004],
              [-8.396066860999952, 51.87677643400008],
              [-8.35415605399993, 51.87299225500004],
              [-8.329253709999932, 51.861314195000034],
              [-8.347401495999918, 51.82990143400008],
              [-8.309885219999956, 51.832098700000074],
              [-8.298329230999911, 51.82990143400008],
              [-8.298329230999911, 51.82367584800005],
              [-8.305165167999917, 51.82367584800005],
              [-8.305165167999917, 51.81622955900008],
              [-8.296294725999928, 51.81159088700008],
              [-8.29210364499994, 51.81000397300005],
              [-8.30650794199994, 51.807847398000035],
              [-8.313059048999946, 51.80560944200005],
              [-8.319488084999932, 51.80255768400008],
              [-8.284657355999911, 51.80255768400008],
              [-8.301991339999915, 51.78587474200003],
              [-8.305165167999917, 51.782131252000056],
              [-8.303781704999949, 51.776597398000035],
              [-8.299631313999953, 51.77171458500004],
              [-8.297352667999917, 51.76601797100005],
              [-8.301747199999909, 51.75820547100005],
              [-8.334787563999953, 51.735256252000056],
              [-8.345692511999914, 51.724676825000074],
              [-8.372547980999911, 51.71552155200004],
              [-8.41002356699994, 51.70978424700007],
              [-8.422434048999946, 51.70404694200005],
              [-8.435536261999914, 51.692694403000075],
              [-8.441761847999942, 51.70392487200007],
              [-8.455799933999913, 51.71230703300006],
              [-8.471913214999915, 51.71625397300005],
              [-8.483957485999952, 51.71381256700005],
              [-8.469227667999917, 51.70661041900007],
              [-8.464182094999956, 51.695013739000046],
              [-8.46898352799991, 51.68406810100004],
              [-8.483957485999952, 51.67841217700004],
              [-8.491118943999936, 51.69867584800005],
              [-8.512440558999913, 51.70604075700004],
              [-8.558420376999948, 51.706366278000075],
              [-8.558420376999948, 51.70014069200005],
              [-8.548329230999911, 51.69635651200008],
              [-8.52798417899993, 51.695013739000046],
              [-8.51748613199993, 51.692694403000075],
              [-8.508168097999942, 51.699204820000034],
              [-8.502105272999927, 51.70034414300005],
              [-8.497547980999911, 51.692694403000075],
              [-8.499623175999943, 51.68695709800005],
              [-8.50649980399993, 51.68244049700007],
              [-8.514881964999915, 51.67951080900008],
              [-8.521148240999935, 51.67841217700004],
              [-8.536488410999937, 51.654730536000045],
              [-8.539173956999946, 51.64838288000004],
              [-8.53819739499994, 51.63739655200004],
              [-8.533558722999942, 51.622300523000035],
              [-8.531727667999917, 51.61078522300005],
              [-8.544422980999911, 51.61790599200003],
              [-8.558705206999946, 51.638006903000075],
              [-8.572661912999934, 51.644964911000045],
              [-8.589100714999915, 51.64590078300006],
              [-8.638172980999911, 51.63743724200003],
              [-8.757639126999948, 51.644964911000045],
              [-8.74327551999994, 51.635199286000045],
              [-8.726551886999914, 51.63133372600004],
              [-8.690012173999946, 51.631293036000045],
              [-8.690012173999946, 51.62384674700007],
              [-8.696603969999956, 51.62099844000005],
              [-8.702951626999948, 51.61701080900008],
              [-8.682525193999936, 51.61078522300005],
              [-8.693470831999946, 51.604681708000044],
              [-8.699777798999946, 51.59723541900007],
              [-8.700795050999943, 51.58812083500004],
              [-8.696156378999945, 51.57664622600004],
              [-8.733998175999943, 51.579779364000046],
              [-8.742787238999938, 51.57562897300005],
              [-8.750070766999954, 51.579413153000075],
              [-8.757069464999915, 51.586004950000074],
              [-8.765126105999911, 51.590277411000045],
              [-8.801991339999915, 51.590277411000045],
              [-8.812570766999954, 51.59194570500006],
              [-8.82022050699993, 51.594631252000056],
              [-8.826649542999917, 51.59516022300005],
              [-8.833363410999937, 51.590277411000045],
              [-8.853871222999942, 51.59593333500004],
              [-8.868031378999945, 51.58445872600004],
              [-8.878529425999943, 51.56720612200007],
              [-8.888010219999956, 51.555568752000056],
              [-8.923329230999911, 51.548163153000075],
              [-8.928944464999915, 51.54596588700008],
              [-8.933176235999952, 51.53534577000005],
              [-8.94204667899993, 51.53774648600006],
              [-8.950550910999937, 51.54507070500006],
              [-8.953195766999954, 51.54938385600008],
              [-8.959950324999909, 51.55141836100006],
              [-8.979888475999928, 51.56069570500006],
              [-8.991118943999936, 51.56297435100004],
              [-9.002797003999945, 51.562160549000055],
              [-9.017689581999946, 51.55683014500005],
              [-9.072865363999938, 51.54938385600008],
              [-9.085682745999918, 51.55219147300005],
              [-9.108143683999913, 51.56085846600007],
              [-9.120757615999935, 51.56297435100004],
              [-9.120757615999935, 51.555568752000056],
              [-9.11632239499994, 51.55410390800006],
              [-9.10773678299995, 51.54938385600008],
              [-9.115712042999917, 51.53790924700007],
              [-9.128163214999915, 51.529282945000034],
              [-9.143299933999913, 51.523871161000045],
              [-9.158599412999934, 51.52204010600008],
              [-9.184559699999909, 51.52619049700007],
              [-9.192534959999932, 51.524603583000044],
              [-9.189605272999927, 51.51459381700005],
              [-9.189605272999927, 51.50836823100008],
              [-9.203968878999945, 51.50800202000005],
              [-9.21084550699993, 51.50169505400004],
              [-9.215728318999936, 51.493475653000075],
              [-9.223784959999932, 51.48729075700004],
              [-9.234730597999942, 51.48647695500006],
              [-9.243763800999943, 51.48932526200008],
              [-9.25304114499994, 51.49115631700005],
              [-9.26475989499994, 51.48729075700004],
              [-9.265370245999918, 51.494126695000034],
              [-9.26748613199993, 51.49884674700007],
              [-9.270090298999946, 51.50299713700008],
              [-9.27212480399993, 51.50836823100008],
              [-9.29946855399993, 51.49750397300005],
              [-9.301747199999909, 51.488714911000045],
              [-9.307443813999953, 51.48729075700004],
              [-9.315297003999945, 51.487616278000075],
              [-9.323719855999911, 51.48383209800005],
              [-9.335316535999937, 51.476996161000045],
              [-9.349232550999943, 51.47402578300006],
              [-9.381418423999946, 51.47361888200004],
              [-9.369943813999953, 51.478583075000074],
              [-9.360707160999937, 51.48383209800005],
              [-9.353138800999943, 51.49087148600006],
              [-9.346669074999909, 51.50092194200005],
              [-9.361154751999948, 51.494574286000045],
              [-9.37291419199994, 51.49127838700008],
              [-9.37686113199993, 51.49461497600004],
              [-9.367787238999938, 51.50836823100008],
              [-9.357085740999935, 51.51715729400007],
              [-9.332386847999942, 51.52765534100007],
              [-9.319935675999943, 51.53506094000005],
              [-9.32290605399993, 51.53733958500004],
              [-9.32412675699993, 51.53803131700005],
              [-9.325062628999945, 51.539129950000074],
              [-9.327463344999956, 51.54254791900007],
              [-9.33580481699994, 51.53725820500006],
              [-9.367787238999938, 51.525091864000046],
              [-9.371693488999938, 51.51935455900008],
              [-9.38109290299991, 51.51239655200004],
              [-9.401844855999911, 51.50092194200005],
              [-9.413889126999948, 51.51113515800006],
              [-9.412587042999917, 51.520697333000044],
              [-9.405873175999943, 51.53172435100004],
              [-9.401844855999911, 51.54596588700008],
              [-9.40884355399993, 51.55219147300005],
              [-9.425038214999915, 51.55756256700005],
              [-9.44326738199993, 51.55951569200005],
              [-9.456532355999911, 51.555568752000056],
              [-9.447987433999913, 51.54364655200004],
              [-9.476551886999914, 51.53506094000005],
              [-9.547474738999938, 51.52529531500005],
              [-9.551380988999938, 51.52122630400004],
              [-9.552805141999954, 51.51146067900004],
              [-9.556304490999935, 51.50812409100007],
              [-9.573882615999935, 51.508978583000044],
              [-9.58071855399993, 51.50836823100008],
              [-9.599964972999942, 51.49689362200007],
              [-9.611317511999914, 51.493841864000046],
              [-9.628407355999911, 51.49408600500004],
              [-9.629628058999913, 51.50405508000006],
              [-9.641835089999915, 51.51520416900007],
              [-9.655913865999935, 51.52016836100006],
              [-9.662668423999946, 51.51146067900004],
              [-9.717193162999934, 51.48041413000004],
              [-9.71080481699994, 51.47597890800006],
              [-9.708078579999949, 51.47455475500004],
              [-9.703521287999934, 51.47361888200004],
              [-9.771839972999942, 51.453111070000034],
              [-9.768950975999928, 51.46430084800005],
              [-9.777943488999938, 51.462225653000075],
              [-9.806630011999914, 51.44570547100005],
              [-9.813384568999936, 51.453111070000034],
              [-9.82022050699993, 51.44570547100005],
              [-9.818918423999946, 51.45848216400009],
              [-9.817005988999938, 51.46312083500004],
              [-9.813384568999936, 51.46743398600006],
              [-9.813384568999936, 51.47361888200004],
              [-9.82217363199993, 51.47540924700007],
              [-9.826324022999927, 51.477728583000044],
              [-9.83389238199993, 51.48729075700004],
              [-9.812001105999911, 51.491522528000075],
              [-9.793812628999945, 51.499660549000055],
              [-9.758168097999942, 51.52204010600008],
              [-9.740061001999948, 51.52977122600004],
              [-9.70498613199993, 51.53571198100008],
              [-9.683094855999911, 51.54254791900007],
              [-9.665394660999937, 51.55158112200007],
              [-9.621652798999946, 51.58283112200007],
              [-9.602772589999915, 51.59198639500005],
              [-9.566761847999942, 51.60228099200003],
              [-9.545887824999909, 51.61078522300005],
              [-9.59203040299991, 51.613714911000045],
              [-9.78502356699994, 51.55247630400004],
              [-9.84752356699994, 51.54938385600008],
              [-9.805287238999938, 51.56671784100007],
              [-9.796050584999932, 51.569240627000056],
              [-9.786366339999915, 51.573472398000035],
              [-9.779286261999914, 51.58283112200007],
              [-9.770334438999953, 51.592230536000045],
              [-9.731190558999913, 51.600897528000075],
              [-9.607980923999946, 51.64240143400008],
              [-9.594553188999953, 51.655503648000035],
              [-9.561879035999937, 51.65814850500004],
              [-9.524728969999956, 51.67031484600005],
              [-9.487904425999943, 51.67572663000004],
              [-9.458607550999943, 51.68398672100005],
              [-9.456532355999911, 51.70014069200005],
              [-9.451771613999938, 51.70498281500005],
              [-9.447417772999927, 51.71088288000004],
              [-9.442941860999952, 51.71381256700005],
              [-9.442941860999952, 51.720038153000075],
              [-9.45726477799991, 51.724595445000034],
              [-9.472808397999927, 51.718817450000074],
              [-9.489816860999952, 51.714544989000046],
              [-9.51280676999994, 51.725897528000075],
              [-9.521473761999914, 51.72553131700005],
              [-9.525461391999954, 51.72687409100007],
              [-9.526437954999949, 51.73078034100007],
              [-9.52452551999994, 51.743394273000035],
              [-9.525461391999954, 51.747300523000035],
              [-9.531727667999917, 51.75153229400007],
              [-9.540272589999915, 51.755926825000074],
              [-9.550119594999956, 51.75950755400004],
              [-9.560210740999935, 51.76162344000005],
              [-9.555897589999915, 51.74868398600006],
              [-9.55728105399993, 51.739447333000044],
              [-9.556630011999914, 51.730902411000045],
              [-9.545887824999909, 51.720038153000075],
              [-9.566070115999935, 51.71670156500005],
              [-9.579660610999952, 51.710598049000055],
              [-9.60732988199993, 51.692694403000075],
              [-9.62682044199994, 51.68504466400009],
              [-9.648060675999943, 51.68081289300005],
              [-9.713490363999938, 51.67645905200004],
              [-9.74795488199993, 51.66742584800005],
              [-9.87413489499994, 51.65619538000004],
              [-9.915353969999956, 51.644598700000074],
              [-9.930083787999934, 51.63743724200003],
              [-9.93187415299991, 51.63471100500004],
              [-9.932118292999917, 51.63104889500005],
              [-9.932932094999956, 51.62726471600007],
              [-9.936350063999953, 51.62384674700007],
              [-9.941883917999917, 51.62132396000004],
              [-10.004750128999945, 51.60854726800005],
              [-10.028797980999911, 51.59650299700007],
              [-10.040272589999915, 51.597642320000034],
              [-10.059925910999937, 51.602769273000035],
              [-10.070057745999918, 51.603949286000045],
              [-10.116118943999936, 51.60028717700004],
              [-10.138661261999914, 51.59389883000006],
              [-10.156076626999948, 51.58283112200007],
              [-10.162831183999913, 51.590277411000045],
              [-10.155262824999909, 51.593817450000074],
              [-10.153228318999936, 51.599310614000046],
              [-10.152699347999942, 51.60541413000004],
              [-10.149240688999953, 51.61078522300005],
              [-10.143299933999913, 51.61359284100007],
              [-10.075062628999945, 51.62539297100005],
              [-10.059803839999915, 51.631293036000045],
              [-10.059803839999915, 51.63568756700005],
              [-10.061024542999917, 51.63666413000004],
              [-10.063465949999909, 51.63646067900004],
              [-10.06663977799991, 51.63743724200003],
              [-10.062652147999927, 51.64984772300005],
              [-10.070668097999942, 51.65704987200007],
              [-10.085316535999937, 51.65989817900004],
              [-10.100819464999915, 51.65924713700008],
              [-10.08812415299991, 51.67161692900004],
              [-10.066395636999914, 51.67438385600008],
              [-10.025746222999942, 51.67226797100005],
              [-10.00377356699994, 51.67804596600007],
              [-9.956857876999948, 51.706366278000075],
              [-9.956857876999948, 51.71381256700005],
              [-9.997792120999918, 51.71381256700005],
              [-9.98070227799991, 51.73187897300005],
              [-9.949370897999927, 51.74701569200005],
              [-9.914906378999945, 51.75755442900004],
              [-9.88853919199994, 51.76162344000005],
              [-9.891672329999949, 51.757025458000044],
              [-9.897043423999946, 51.74673086100006],
              [-9.90225175699993, 51.74115631700005],
              [-9.884510870999918, 51.743394273000035],
              [-9.867909308999913, 51.74860260600008],
              [-9.856516079999949, 51.75861237200007],
              [-9.854400193999936, 51.77529531500005],
              [-9.841297980999911, 51.76972077000005],
              [-9.823801235999952, 51.76780833500004],
              [-9.785511847999942, 51.76850006700005],
              [-9.785511847999942, 51.77529531500005],
              [-9.793365037999934, 51.77619049700007],
              [-9.813384568999936, 51.782131252000056],
              [-9.813384568999936, 51.788275458000044],
              [-9.799875454999949, 51.79376862200007],
              [-9.774322068999936, 51.812201239000046],
              [-9.754505988999938, 51.81907786700003],
              [-9.742909308999913, 51.832464911000045],
              [-9.737660285999937, 51.83673737200007],
              [-9.729847785999937, 51.83803945500006],
              [-9.703521287999934, 51.83673737200007],
              [-9.671050584999932, 51.843003648000035],
              [-9.612538214999915, 51.86351146000004],
              [-9.58071855399993, 51.87018463700008],
              [-9.58071855399993, 51.87767161700003],
              [-9.653146938999953, 51.87177155200004],
              [-9.75804602799991, 51.846991278000075],
              [-9.777170376999948, 51.83974844000005],
              [-9.785511847999942, 51.833319403000075],
              [-9.791737433999913, 51.82680898600006],
              [-9.824696417999917, 51.82684967700004],
              [-9.84007727799991, 51.82367584800005],
              [-9.83389238199993, 51.81622955900008],
              [-9.863840298999946, 51.80426666900007],
              [-9.87486731699994, 51.80255768400008],
              [-9.872710740999935, 51.80731842700004],
              [-9.869943813999953, 51.81867096600007],
              [-9.868031378999945, 51.82367584800005],
              [-9.882191535999937, 51.82367584800005],
              [-9.89049231699994, 51.819566148000035],
              [-9.896107550999943, 51.814113674000055],
              [-9.90225175699993, 51.81000397300005],
              [-9.914214647999927, 51.80731842700004],
              [-9.938303188999953, 51.80499909100007],
              [-9.949940558999913, 51.80255768400008],
              [-9.993641730999911, 51.780951239000046],
              [-10.016753709999932, 51.774644273000035],
              [-10.03937740799995, 51.782131252000056],
              [-10.059437628999945, 51.76870351800005],
              [-10.084543423999946, 51.755926825000074],
              [-10.11119544199994, 51.74603913000004],
              [-10.135609503999945, 51.74115631700005],
              [-10.129750128999945, 51.754339911000045],
              [-10.224354620999918, 51.782131252000056],
              [-10.186146613999938, 51.78961823100008],
              [-10.177072719999956, 51.813666083000044],
              [-10.194203253999945, 51.839097398000035],
              [-10.23460852799991, 51.85101959800005],
              [-10.246083136999914, 51.84560781500005],
              [-10.271229620999918, 51.82168203300006],
              [-10.282622850999928, 51.81622955900008],
              [-10.294748501999948, 51.81240469000005],
              [-10.325754360999952, 51.794175523000035],
              [-10.341053839999915, 51.788275458000044],
              [-10.346587693999936, 51.80109284100007],
              [-10.334706183999913, 51.83026764500005],
              [-10.341053839999915, 51.84357330900008],
              [-10.35570227799991, 51.84560781500005],
              [-10.375884568999936, 51.84442780200004],
              [-10.38890540299991, 51.84617747600004],
              [-10.38194739499994, 51.85716380400004],
              [-10.382476365999935, 51.86196523600006],
              [-10.384836391999954, 51.863348700000074],
              [-10.38735917899993, 51.86343008000006],
              [-10.388783331999946, 51.86399974200003],
              [-10.386708136999914, 51.86774323100008],
              [-10.38463294199994, 51.87018463700008],
              [-10.382801886999914, 51.87287018400008],
              [-10.38194739499994, 51.87767161700003],
              [-10.385365363999938, 51.87799713700008],
              [-10.392241990999935, 51.87750885600008],
              [-10.39561926999994, 51.87767161700003],
              [-10.39561926999994, 51.88450755400004],
              [-10.362660285999937, 51.88719310100004],
              [-10.27961178299995, 51.905585028000075],
              [-10.262196417999917, 51.905585028000075],
              [-10.25413977799991, 51.90867747600004],
              [-10.250884568999936, 51.91551341400009],
              [-10.251576300999943, 51.92234935100004],
              [-10.255034959999932, 51.925482489000046],
              [-10.269195115999935, 51.93081289300005],
              [-10.277821417999917, 51.94196198100008],
              [-10.287993943999936, 51.95184967700004],
              [-10.30687415299991, 51.95343659100007],
              [-10.30687415299991, 51.95962148600006],
              [-10.295318162999934, 51.96426015800006],
              [-10.270578579999949, 51.96971263200004],
              [-10.25845292899993, 51.973863023000035],
              [-10.266224738999938, 51.98847077000005],
              [-10.245432094999956, 51.99506256700005],
              [-10.217355923999946, 51.998928127000056],
              [-10.191802537999934, 52.009833075000074],
              [-10.128163214999915, 52.028509833000044],
              [-10.033273891999954, 52.041083075000074],
              [-9.992665167999917, 52.055894273000035],
              [-9.971058722999942, 52.089911200000074],
              [-9.963612433999913, 52.089911200000074],
              [-9.963734503999945, 52.071966864000046],
              [-9.954335089999915, 52.064154364000046],
              [-9.940337693999936, 52.06232330900008],
              [-9.926380988999938, 52.06268952000005],
              [-9.92959550699993, 52.071926174000055],
              [-9.90843665299991, 52.130926825000074],
              [-9.877512173999946, 52.11953359600005],
              [-9.846180792999917, 52.11855703300006],
              [-9.771839972999942, 52.124701239000046],
              [-9.778920050999943, 52.128566799000055],
              [-9.787505662999934, 52.13540273600006],
              [-9.792958136999914, 52.138373114000046],
              [-9.758168097999942, 52.152044989000046],
              [-9.956857876999948, 52.14520905200004],
              [-9.943755662999934, 52.124701239000046],
              [-9.950062628999945, 52.11322663000004],
              [-9.954660610999952, 52.10879140800006],
              [-9.960601365999935, 52.12494538000004],
              [-9.970326300999943, 52.13165924700007],
              [-9.98350989499994, 52.13589101800005],
              [-9.997792120999918, 52.138373114000046],
              [-10.028065558999913, 52.13963450700004],
              [-10.16242428299995, 52.11871979400007],
              [-10.186268683999913, 52.109442450000074],
              [-10.19713294199994, 52.11542389500005],
              [-10.207020636999914, 52.125067450000074],
              [-10.217518683999913, 52.130926825000074],
              [-10.227894660999937, 52.12840403900003],
              [-10.23460852799991, 52.122381903000075],
              [-10.24205481699994, 52.11977773600006],
              [-10.267730272999927, 52.13580963700008],
              [-10.278920050999943, 52.136379299000055],
              [-10.30687415299991, 52.130926825000074],
              [-10.30687415299991, 52.124701239000046],
              [-10.296986456999946, 52.12474192900004],
              [-10.288563605999911, 52.12323639500005],
              [-10.272084113999938, 52.11790599200003],
              [-10.272084113999938, 52.11172109600005],
              [-10.297434048999946, 52.11440664300005],
              [-10.344878709999932, 52.124660549000055],
              [-10.368316209999932, 52.124701239000046],
              [-10.36742102799991, 52.11798737200007],
              [-10.36436926999994, 52.114894924000055],
              [-10.354074673999946, 52.11172109600005],
              [-10.375721808999913, 52.11127350500004],
              [-10.415272589999915, 52.099676825000074],
              [-10.436594204999949, 52.09739817900004],
              [-10.460764126999948, 52.10301341400003],
              [-10.467518683999913, 52.11513906500005],
              [-10.469309048999946, 52.132025458000044],
              [-10.478179490999935, 52.152044989000046],
              [-10.469471808999913, 52.15509674700007],
              [-10.450917120999918, 52.165716864000046],
              [-10.450917120999918, 52.171942450000074],
              [-10.461293097999942, 52.17999909100007],
              [-10.449696417999917, 52.18891022300005],
              [-10.428212042999917, 52.19635651200008],
              [-10.40929114499994, 52.19977448100008],
              [-10.41665605399993, 52.18618398600006],
              [-10.394602016999954, 52.17479075700004],
              [-10.382069464999915, 52.171942450000074],
              [-10.372059699999909, 52.17560455900008],
              [-10.369252081999946, 52.183661200000074],
              [-10.372670050999943, 52.190619208000044],
              [-10.373158331999946, 52.19782135600008],
              [-10.361480272999927, 52.206691799000055],
              [-10.371571417999917, 52.21157461100006],
              [-10.375803188999953, 52.21283600500004],
              [-10.366566535999937, 52.228216864000046],
              [-10.354725714999915, 52.23224518400008],
              [-10.33975175699993, 52.23187897300005],
              [-10.32054602799991, 52.23456452000005],
              [-10.308990037999934, 52.241888739000046],
              [-10.28697669199994, 52.26361725500004],
              [-10.275786912999934, 52.26813385600008],
              [-10.171864386999914, 52.286810614000046],
              [-10.156076626999948, 52.278631903000075],
              [-10.16820227799991, 52.240668036000045],
              [-10.16624915299991, 52.23456452000005],
              [-10.100819464999915, 52.24079010600008],
              [-10.071441209999932, 52.251288153000075],
              [-10.044911261999914, 52.26927317900004],
              [-10.036040818999936, 52.290350653000075],
              [-10.059803839999915, 52.30963776200008],
              [-10.024769660999937, 52.31012604400007],
              [-10.01353919199994, 52.306341864000046],
              [-10.018299933999913, 52.29604726800005],
              [-10.01357988199993, 52.28148021000004],
              [-10.01280676999994, 52.26585521000004],
              [-10.008778449999909, 52.25336334800005],
              [-9.99437415299991, 52.24823639500005],
              [-9.978138800999943, 52.24640534100007],
              [-9.94749915299991, 52.237616278000075],
              [-9.913685675999943, 52.23305898600006],
              [-9.872222459999932, 52.23265208500004],
              [-9.85806230399993, 52.23769765800006],
              [-9.837228969999956, 52.25429922100005],
              [-9.825591600999928, 52.258246161000045],
              [-9.813384568999936, 52.255072333000044],
              [-9.82022050699993, 52.251939195000034],
              [-9.82648678299995, 52.24823639500005],
              [-9.810047980999911, 52.24213288000004],
              [-9.737660285999937, 52.24823639500005],
              [-9.753407355999911, 52.25828685100004],
              [-9.767648891999954, 52.260972398000035],
              [-9.799183722999942, 52.26129791900007],
              [-9.831776495999918, 52.272650458000044],
              [-9.84679114499994, 52.27496979400007],
              [-9.861887173999946, 52.26813385600008],
              [-9.86937415299991, 52.273138739000046],
              [-9.87490800699993, 52.27924225500004],
              [-9.87877356699994, 52.286810614000046],
              [-9.88109290299991, 52.29604726800005],
              [-9.868967251999948, 52.288763739000046],
              [-9.85960852799991, 52.28473541900007],
              [-9.849232550999943, 52.28473541900007],
              [-9.83389238199993, 52.28921133000006],
              [-9.84679114499994, 52.29389069200005],
              [-9.853342251999948, 52.29539622600004],
              [-9.861887173999946, 52.29604726800005],
              [-9.861887173999946, 52.30345286700003],
              [-9.851918097999942, 52.30365631700005],
              [-9.82648678299995, 52.30963776200008],
              [-9.837635870999918, 52.32640208500004],
              [-9.834462042999917, 52.37523021000004],
              [-9.850982225999928, 52.38544342700004],
              [-9.903716600999928, 52.39154694200005],
              [-9.931752081999946, 52.39984772300005],
              [-9.949940558999913, 52.412095445000034],
              [-9.934966600999928, 52.421535549000055],
              [-9.91588294199994, 52.42560455900008],
              [-9.848378058999913, 52.42841217700004],
              [-9.748931443999936, 52.456732489000046],
              [-9.735585089999915, 52.46360911700003],
              [-9.72061113199993, 52.47724030200004],
              [-9.703521287999934, 52.48354726800005],
              [-9.677398240999935, 52.48314036700003],
              [-9.651356574999909, 52.478949286000045],
              [-9.63463294199994, 52.47357819200005],
              [-9.638783331999946, 52.48712799700007],
              [-9.650502081999946, 52.493841864000046],
              [-9.666371222999942, 52.495794989000046],
              [-9.683094855999911, 52.49461497600004],
              [-9.677316860999952, 52.499701239000046],
              [-9.675200975999928, 52.50482819200005],
              [-9.677113410999937, 52.51007721600007],
              [-9.683094855999911, 52.51512278900003],
              [-9.683094855999911, 52.52195872600004],
              [-9.67491614499994, 52.52802155200004],
              [-9.673207160999937, 52.53388092700004],
              [-9.67564856699994, 52.54584381700005],
              [-9.671945766999954, 52.55292389500005],
              [-9.64830481699994, 52.570379950000074],
              [-9.64281165299991, 52.56732819200005],
              [-9.636463995999918, 52.57013580900008],
              [-9.628529425999943, 52.57477448100008],
              [-9.617909308999913, 52.57721588700008],
              [-9.576975063999953, 52.570379950000074],
              [-9.497466600999928, 52.570379950000074],
              [-9.489613410999937, 52.56818268400008],
              [-9.48033606699994, 52.563788153000075],
              [-9.470326300999943, 52.561835028000075],
              [-9.460275844999956, 52.56663646000004],
              [-9.452951626999948, 52.57318756700005],
              [-9.446522589999915, 52.576239325000074],
              [-9.438384568999936, 52.57713450700004],
              [-9.362538214999915, 52.575425523000035],
              [-9.358713344999956, 52.57534414300005],
              [-9.350412563999953, 52.57379791900007],
              [-9.33584550699993, 52.57802969000005],
              [-9.27212480399993, 52.57721588700008],
              [-9.236480272999927, 52.58161041900007],
              [-9.220285610999952, 52.585598049000055],
              [-9.206695115999935, 52.59430573100008],
              [-9.192372199999909, 52.600490627000056],
              [-9.07062740799995, 52.62417226800005],
              [-9.052398240999935, 52.63182200700004],
              [-9.044178839999915, 52.62083567900004],
              [-9.025949673999946, 52.618353583000044],
              [-9.005604620999918, 52.62083567900004],
              [-8.991118943999936, 52.624986070000034],
              [-8.985259568999936, 52.63068268400008],
              [-8.978993292999917, 52.639878648000035],
              [-8.97101803299995, 52.648504950000074],
              [-8.959950324999909, 52.65228913000004],
              [-8.784982876999948, 52.66596100500004],
              [-8.751169399999924, 52.67295970300006],
              [-8.769357876999948, 52.673163153000075],
              [-8.834462042999917, 52.689154364000046],
              [-8.86750240799995, 52.69330475500004],
              [-8.932687954999949, 52.68707916900007],
              [-8.949696417999917, 52.68891022300005],
              [-8.96084550699993, 52.69367096600007],
              [-8.962066209999932, 52.70001862200007],
              [-8.949370897999927, 52.70693594000005],
              [-8.949370897999927, 52.713771877000056],
              [-8.953521287999934, 52.72239817900004],
              [-8.952056443999936, 52.73432038000004],
              [-8.954497850999928, 52.74469635600008],
              [-8.969878709999932, 52.748480536000045],
              [-8.961415167999917, 52.75653717700004],
              [-8.95030676999994, 52.769517320000034],
              [-8.942616339999915, 52.77521393400008],
              [-8.968902147999927, 52.770819403000075],
              [-9.00023352799991, 52.76044342700004],
              [-9.023589647999927, 52.74713776200008],
              [-9.025786912999934, 52.73427969000005],
              [-9.058216925999943, 52.69676341400003],
              [-9.14679928299995, 52.62376536700003],
              [-9.165760870999918, 52.61758047100005],
              [-9.254790818999936, 52.611395575000074],
              [-9.259917772999927, 52.608587958000044],
              [-9.275786912999934, 52.59520091400003],
              [-9.28579667899993, 52.59080638200004],
              [-9.298085089999915, 52.58974844000005],
              [-9.310699022999927, 52.59064362200007],
              [-9.322743292999917, 52.593451239000046],
              [-9.333078579999949, 52.597723700000074],
              [-9.317128058999913, 52.60643138200004],
              [-9.29523678299995, 52.615301825000074],
              [-9.278675910999937, 52.62571849200003],
              [-9.278960740999935, 52.63930898600006],
              [-9.310617641999954, 52.62726471600007],
              [-9.383656378999945, 52.61310455900008],
              [-9.434478318999936, 52.61200592700004],
              [-9.45616614499994, 52.614447333000044],
              [-9.475453253999945, 52.619574286000045],
              [-9.483794725999928, 52.62840403900003],
              [-9.490712042999917, 52.634100653000075],
              [-9.524891730999911, 52.63703034100007],
              [-9.538441535999937, 52.64545319200005],
              [-9.533273891999954, 52.66095612200007],
              [-9.544178839999915, 52.66665273600006],
              [-9.58071855399993, 52.66596100500004],
              [-9.58071855399993, 52.65912506700005],
              [-9.571359829999949, 52.657131252000056],
              [-9.563384568999936, 52.65306224200003],
              [-9.556996222999942, 52.64704010600008],
              [-9.552805141999954, 52.63930898600006],
              [-9.628407355999911, 52.61758047100005],
              [-9.672718878999945, 52.61163971600007],
              [-9.694406704999949, 52.60561758000006],
              [-9.703521287999934, 52.59430573100008],
              [-9.706857876999948, 52.58022695500006],
              [-9.714507615999935, 52.57859935100004],
              [-9.723622199999909, 52.58226146000004],
              [-9.730824347999942, 52.584051825000074],
              [-9.757476365999935, 52.571966864000046],
              [-9.936350063999953, 52.556708075000074],
              [-9.936350063999953, 52.562933661000045],
              [-9.91820227799991, 52.56810130400004],
              [-9.87564042899993, 52.586818752000056],
              [-9.82408606699994, 52.59516022300005],
              [-9.621652798999946, 52.713771877000056],
              [-9.624256964999915, 52.71747467700004],
              [-9.628407355999911, 52.727443752000056],
              [-9.617543097999942, 52.73061758000006],
              [-9.603179490999935, 52.73773834800005],
              [-9.59365800699993, 52.74103424700007],
              [-9.58071855399993, 52.743353583000044],
              [-9.549387173999946, 52.74103424700007],
              [-9.53819739499994, 52.742254950000074],
              [-9.519520636999914, 52.747300523000035],
              [-9.508371548999946, 52.748480536000045],
              [-9.498646613999938, 52.75250885600008],
              [-9.494618292999917, 52.76203034100007],
              [-9.49132239499994, 52.77334219000005],
              [-9.483794725999928, 52.78266022300005],
              [-9.489165818999936, 52.786810614000046],
              [-9.489328579999949, 52.78733958500004],
              [-9.486683722999942, 52.788763739000046],
              [-9.483794725999928, 52.79572174700007],
              [-9.491281704999949, 52.803168036000045],
              [-9.480620897999927, 52.80683014500005],
              [-9.469797329999949, 52.81317780200004],
              [-9.459462042999917, 52.82135651200008],
              [-9.450347459999932, 52.83047109600005],
              [-9.444488084999932, 52.83934153900003],
              [-9.441395636999914, 52.84715403900003],
              [-9.437489386999914, 52.85346100500004],
              [-9.429188605999911, 52.85773346600007],
              [-9.429188605999911, 52.864569403000075],
              [-9.427479620999918, 52.87775299700007],
              [-9.365305141999954, 52.914129950000074],
              [-9.354074673999946, 52.93349844000005],
              [-9.372873501999948, 52.937160549000055],
              [-9.45140540299991, 52.93463776200008],
              [-9.47765051999994, 52.940334377000056],
              [-9.44945227799991, 52.95750560100004],
              [-9.437570766999954, 52.96674225500004],
              [-9.407948370999918, 52.99701569200005],
              [-9.398548956999946, 53.00409577000005],
              [-9.387603318999936, 53.00861237200007],
              [-9.395090298999946, 53.01544830900008],
              [-9.341623501999948, 53.07697174700007],
              [-9.319935675999943, 53.091131903000075],
              [-9.303334113999938, 53.10789622600004],
              [-9.289662238999938, 53.12921784100007],
              [-9.272206183999913, 53.14667389500005],
              [-9.25108801999994, 53.15192291900007],
              [-9.227447068999936, 53.14354075700004],
              [-9.180531378999945, 53.11676666900007],
              [-9.158599412999934, 53.111029364000046],
              [-9.139556443999936, 53.11542389500005],
              [-9.118967251999948, 53.12335846600007],
              [-9.096669074999909, 53.127020575000074],
              [-9.072865363999938, 53.118475653000075],
              [-9.070057745999918, 53.134466864000046],
              [-9.084339972999942, 53.143459377000056],
              [-9.128163214999915, 53.15192291900007],
              [-9.128163214999915, 53.159409898000035],
              [-9.069569464999915, 53.16620514500005],
              [-9.053944464999915, 53.16242096600007],
              [-9.023426886999914, 53.14716217700004],
              [-9.004058397999927, 53.145738023000035],
              [-9.004058397999927, 53.15192291900007],
              [-9.045643683999913, 53.16620514500005],
              [-9.045643683999913, 53.17373281500005],
              [-9.02257239499994, 53.16742584800005],
              [-9.00963294199994, 53.166083075000074],
              [-8.998117641999954, 53.173895575000074],
              [-8.986683722999942, 53.176988023000035],
              [-8.978871222999942, 53.175767320000034],
              [-8.984201626999948, 53.16620514500005],
              [-8.974232550999943, 53.15794505400004],
              [-8.963490363999938, 53.15180084800005],
              [-8.95107988199993, 53.147772528000075],
              [-8.936390753999945, 53.145738023000035],
              [-8.94522050699993, 53.16616445500006],
              [-8.950103318999936, 53.17373281500005],
              [-8.956857876999948, 53.17987702000005],
              [-8.94399980399993, 53.195013739000046],
              [-8.928212042999917, 53.20587799700007],
              [-8.89484615799995, 53.22089264500005],
              [-8.90538489499994, 53.220689195000034],
              [-8.92414303299995, 53.21588776200008],
              [-8.932687954999949, 53.21466705900008],
              [-9.03148352799991, 53.21662018400008],
              [-9.045643683999913, 53.22089264500005],
              [-9.028065558999913, 53.22752513200004],
              [-8.98265540299991, 53.234442450000074],
              [-8.96312415299991, 53.23517487200007],
              [-8.96312415299991, 53.24192942900004],
              [-8.991118943999936, 53.24192942900004],
              [-8.991118943999936, 53.24819570500006],
              [-8.981760219999956, 53.253241278000075],
              [-8.955881313999953, 53.257879950000074],
              [-8.942616339999915, 53.261786200000074],
              [-8.942616339999915, 53.26862213700008],
              [-9.022084113999938, 53.275458075000074],
              [-9.042225714999915, 53.27334219000005],
              [-9.077056443999936, 53.26398346600007],
              [-9.401437954999949, 53.24799225500004],
              [-9.432932094999956, 53.23859284100007],
              [-9.447865363999938, 53.23187897300005],
              [-9.470082160999937, 53.22825755400004],
              [-9.511708136999914, 53.22833893400008],
              [-9.532948370999918, 53.234442450000074],
              [-9.544422980999911, 53.24355703300006],
              [-9.553130662999934, 53.25336334800005],
              [-9.566395636999914, 53.261786200000074],
              [-9.547271287999934, 53.27912018400008],
              [-9.55455481699994, 53.290716864000046],
              [-9.571359829999949, 53.29047272300005],
              [-9.58071855399993, 53.27204010600008],
              [-9.585194464999915, 53.250433661000045],
              [-9.596831834999932, 53.23769765800006],
              [-9.612294074999909, 53.23615143400008],
              [-9.628407355999911, 53.24819570500006],
              [-9.628407355999911, 53.25560130400004],
              [-9.609120245999918, 53.27631256700005],
              [-9.617298956999946, 53.321478583000044],
              [-9.597401495999918, 53.330064195000034],
              [-9.594105597999942, 53.32916901200008],
              [-9.58421790299991, 53.32489655200004],
              [-9.576975063999953, 53.323919989000046],
              [-9.572987433999913, 53.32607656500005],
              [-9.566517706999946, 53.33539459800005],
              [-9.563384568999936, 53.337591864000046],
              [-9.56078040299991, 53.34121328300006],
              [-9.601144985999952, 53.364894924000055],
              [-9.590199347999942, 53.372381903000075],
              [-9.552805141999954, 53.38540273600006],
              [-9.588856574999909, 53.386419989000046],
              [-9.60655676999994, 53.38471100500004],
              [-9.621652798999946, 53.37848541900007],
              [-9.60850989499994, 53.36660390800006],
              [-9.606597459999932, 53.34935130400004],
              [-9.61546790299991, 53.33466217700004],
              [-9.63463294199994, 53.330064195000034],
              [-9.652495897999927, 53.34125397300005],
              [-9.647938605999911, 53.35993073100008],
              [-9.637766079999949, 53.37750885600008],
              [-9.638417120999918, 53.38540273600006],
              [-9.644154425999943, 53.38739655200004],
              [-9.64834550699993, 53.391058661000045],
              [-9.65265865799995, 53.39280833500004],
              [-9.65884355399993, 53.38906484600005],
              [-9.67251542899993, 53.37848541900007],
              [-9.684722459999932, 53.37523021000004],
              [-9.692779100999928, 53.367621161000045],
              [-9.703521287999934, 53.35179271000004],
              [-9.727528449999909, 53.32607656500005],
              [-9.743072068999936, 53.31439850500004],
              [-9.790394660999937, 53.30158112200007],
              [-9.806711391999954, 53.30158112200007],
              [-9.82335364499994, 53.31329987200007],
              [-9.842925584999932, 53.32330963700008],
              [-9.88658606699994, 53.31720612200007],
              [-9.90225175699993, 53.323919989000046],
              [-9.897857225999928, 53.32786692900004],
              [-9.89281165299991, 53.34056224200003],
              [-9.890736456999946, 53.35187409100007],
              [-9.887196417999917, 53.35919830900008],
              [-9.880279100999928, 53.36310455900008],
              [-9.871490037999934, 53.364569403000075],
              [-9.85806230399993, 53.364894924000055],
              [-9.841297980999911, 53.36790599200003],
              [-9.800526495999918, 53.384426174000055],
              [-9.785511847999942, 53.39276764500005],
              [-9.785511847999942, 53.39899323100008],
              [-9.82022050699993, 53.39899323100008],
              [-9.82022050699993, 53.40643952000005],
              [-9.799183722999942, 53.41266510600008],
              [-9.799183722999942, 53.41950104400007],
              [-9.814076300999943, 53.41950104400007],
              [-9.825184699999909, 53.41669342700004],
              [-9.84752356699994, 53.40643952000005],
              [-9.846913214999915, 53.39935944200005],
              [-9.860178188999953, 53.394232489000046],
              [-9.875396287999934, 53.39520905200004],
              [-9.88109290299991, 53.40643952000005],
              [-9.875721808999913, 53.41543203300006],
              [-9.856068488999938, 53.42377350500004],
              [-9.84752356699994, 53.43374258000006],
              [-9.860340949999909, 53.432521877000056],
              [-9.868072068999936, 53.42747630400004],
              [-9.87490800699993, 53.42206452000005],
              [-9.884755011999914, 53.41950104400007],
              [-9.893950975999928, 53.421576239000046],
              [-9.902333136999914, 53.42523834800005],
              [-9.911447719999956, 53.42597077000005],
              [-9.922678188999953, 53.41950104400007],
              [-9.92564856699994, 53.40973541900007],
              [-9.922759568999936, 53.398423570000034],
              [-9.922352667999917, 53.38922760600008],
              [-9.933216925999943, 53.38540273600006],
              [-9.944488084999932, 53.38426341400003],
              [-9.961415167999917, 53.37958405200004],
              [-10.00108801999994, 53.37921784100007],
              [-10.014149542999917, 53.38125234600005],
              [-10.025746222999942, 53.38540273600006],
              [-10.035959438999953, 53.393744208000044],
              [-10.041981574999909, 53.40265534100007],
              [-10.049305792999917, 53.409816799000055],
              [-10.063221808999913, 53.41266510600008],
              [-10.103505011999914, 53.40843333500004],
              [-10.127552863999938, 53.409857489000046],
              [-10.141753709999932, 53.41950104400007],
              [-10.149973110999952, 53.414943752000056],
              [-10.158029751999948, 53.41282786700003],
              [-10.176503058999913, 53.41266510600008],
              [-10.167591925999943, 53.42877838700008],
              [-10.156971808999913, 53.43964264500005],
              [-10.142241990999935, 53.44570547100005],
              [-10.12132727799991, 53.44741445500006],
              [-10.083159959999932, 53.442613023000035],
              [-10.067982550999943, 53.44383372600004],
              [-10.05296790299991, 53.45359935100004],
              [-10.05296790299991, 53.46108633000006],
              [-10.064564581999946, 53.46198151200008],
              [-10.074208136999914, 53.46576569200005],
              [-10.081654425999943, 53.472357489000046],
              [-10.087147589999915, 53.48151276200008],
              [-10.065337693999936, 53.47919342700004],
              [-10.040760870999918, 53.47256094000005],
              [-10.020578579999949, 53.47044505400004],
              [-10.012074347999942, 53.48151276200008],
              [-10.031849738999938, 53.48029205900008],
              [-10.069406704999949, 53.48476797100005],
              [-10.10728919199994, 53.49445221600007],
              [-10.128163214999915, 53.50885651200008],
              [-10.12913977799991, 53.51520416900007],
              [-10.134755011999914, 53.52708567900004],
              [-10.143137173999946, 53.53851959800005],
              [-10.15265865799995, 53.54360586100006],
              [-10.181752081999946, 53.53864166900007],
              [-10.193470831999946, 53.53803131700005],
              [-10.203236456999946, 53.54360586100006],
              [-10.180287238999938, 53.55548737200007],
              [-10.156971808999913, 53.55516185100004],
              [-10.132801886999914, 53.55068594000005],
              [-10.10765540299991, 53.54979075700004],
              [-10.109730597999942, 53.55426666900007],
              [-10.113026495999918, 53.565741278000075],
              [-10.11510169199994, 53.570298570000034],
              [-10.070668097999942, 53.570013739000046],
              [-10.025746222999942, 53.56289297100005],
              [-10.020008917999917, 53.55898672100005],
              [-10.005238410999937, 53.54360586100006],
              [-9.995716925999943, 53.546210028000075],
              [-9.981678839999915, 53.55878327000005],
              [-9.971058722999942, 53.56289297100005],
              [-10.03189042899993, 53.587144273000035],
              [-10.04678300699993, 53.599269924000055],
              [-10.008656378999945, 53.60443756700005],
              [-9.930734829999949, 53.59979889500005],
              [-9.90225175699993, 53.60443756700005],
              [-9.867909308999913, 53.61737702000005],
              [-9.854400193999936, 53.61810944200005],
              [-9.843902147999927, 53.61546458500004],
              [-9.822865363999938, 53.60643138200004],
              [-9.775054490999935, 53.60130442900004],
              [-9.696766730999911, 53.59821198100008],
              [-9.696766730999911, 53.60443756700005],
              [-9.714100714999915, 53.60984935100004],
              [-9.783762173999946, 53.60626862200007],
              [-9.82725989499994, 53.61619700700004],
              [-9.90843665299991, 53.64606354400007],
              [-9.922678188999953, 53.690741278000075],
              [-9.916737433999913, 53.712103583000044],
              [-9.905669725999928, 53.728501695000034],
              [-9.89952551999994, 53.743841864000046],
              [-9.90843665299991, 53.76211172100005],
              [-9.898915167999917, 53.766058661000045],
              [-9.860991990999935, 53.77016836100006],
              [-9.83389238199993, 53.77635325700004],
              [-9.810210740999935, 53.77806224200003],
              [-9.79946855399993, 53.78025950700004],
              [-9.789214647999927, 53.78660716400003],
              [-9.78343665299991, 53.787095445000034],
              [-9.763172980999911, 53.77924225500004],
              [-9.752023891999954, 53.77635325700004],
              [-9.566395636999914, 53.79629140800006],
              [-9.566395636999914, 53.80365631700005],
              [-9.581532355999911, 53.80532461100006],
              [-9.621652798999946, 53.81732819200005],
              [-9.616281704999949, 53.81940338700008],
              [-9.612131313999953, 53.821600653000075],
              [-9.607533331999946, 53.82339101800005],
              [-9.601144985999952, 53.82416413000004],
              [-9.601144985999952, 53.83100006700005],
              [-9.605458136999914, 53.839178778000075],
              [-9.59483801999994, 53.84821198100008],
              [-9.560210740999935, 53.86513906500005],
              [-9.568348761999914, 53.86554596600007],
              [-9.586903449999909, 53.871975002000056],
              [-9.578928188999953, 53.87612539300005],
              [-9.572824673999946, 53.88222890800006],
              [-9.56859290299991, 53.89008209800005],
              [-9.566395636999914, 53.899318752000056],
              [-9.573109503999945, 53.898504950000074],
              [-9.577381964999915, 53.89752838700008],
              [-9.581450975999928, 53.895738023000035],
              [-9.586903449999909, 53.89248281500005],
              [-9.61546790299991, 53.89883047100005],
              [-9.758168097999942, 53.899318752000056],
              [-9.856597459999932, 53.86627838700008],
              [-9.910755988999938, 53.858710028000075],
              [-9.943755662999934, 53.87938060100004],
              [-9.931385870999918, 53.88515859600005],
              [-9.925160285999937, 53.91303131700005],
              [-9.90843665299991, 53.920355536000045],
              [-9.911284959999932, 53.92959219000005],
              [-9.911610480999911, 53.93398672100005],
              [-9.90843665299991, 53.94086334800005],
              [-9.90843665299991, 53.94708893400008],
              [-9.91588294199994, 53.94708893400008],
              [-9.91588294199994, 53.95384349200003],
              [-9.868031378999945, 53.961371161000045],
              [-9.85924231699994, 53.958685614000046],
              [-9.837066209999932, 53.94916413000004],
              [-9.82335364499994, 53.94708893400008],
              [-9.81163489499994, 53.94171784100007],
              [-9.807606574999909, 53.91828034100007],
              [-9.796050584999932, 53.91290924700007],
              [-9.787505662999934, 53.916083075000074],
              [-9.787831183999913, 53.924261786000045],
              [-9.789540167999917, 53.935248114000046],
              [-9.785511847999942, 53.94708893400008],
              [-9.794911261999914, 53.95307038000004],
              [-9.803089972999942, 53.96051666900007],
              [-9.812652147999927, 53.96629466400003],
              [-9.82648678299995, 53.96759674700007],
              [-9.82648678299995, 53.961371161000045],
              [-9.82022050699993, 53.95384349200003],
              [-9.831695115999935, 53.956284898000035],
              [-9.83853105399993, 53.96356842700004],
              [-9.850209113999938, 53.98847077000005],
              [-9.84951738199993, 53.99331289300005],
              [-9.849598761999914, 53.99750397300005],
              [-9.854400193999936, 54.00234609600005],
              [-9.860829230999911, 54.003119208000044],
              [-9.877674933999913, 54.00189850500004],
              [-9.88109290299991, 54.00535716400003],
              [-9.884388800999943, 54.01166413000004],
              [-9.891672329999949, 54.01707591400003],
              [-9.898915167999917, 54.02533600500004],
              [-9.90225175699993, 54.04018789300005],
              [-9.897694464999915, 54.055121161000045],
              [-9.886708136999914, 54.05971914300005],
              [-9.873443162999934, 54.062201239000046],
              [-9.861887173999946, 54.07123444200005],
              [-9.875884568999936, 54.07485586100006],
              [-9.87608801999994, 54.08063385600008],
              [-9.867339647999927, 54.08673737200007],
              [-9.854400193999936, 54.091050523000035],
              [-9.861887173999946, 54.09788646000004],
              [-9.83389238199993, 54.11212799700007],
              [-9.843495245999918, 54.11701080900008],
              [-9.855091925999943, 54.11737702000005],
              [-9.88109290299991, 54.11212799700007],
              [-9.878570115999935, 54.103949286000045],
              [-9.879709438999953, 54.10024648600006],
              [-9.88499915299991, 54.098944403000075],
              [-9.895375128999945, 54.09788646000004],
              [-9.895375128999945, 54.091050523000035],
              [-9.88853919199994, 54.091050523000035],
              [-9.917388475999928, 54.06972890800006],
              [-9.94554602799991, 54.06622955900008],
              [-9.970692511999914, 54.078558661000045],
              [-9.990956183999913, 54.104681708000044],
              [-9.971547003999945, 54.10423411700003],
              [-9.926380988999938, 54.11212799700007],
              [-9.90843665299991, 54.118353583000044],
              [-9.938872850999928, 54.13165924700007],
              [-9.95107988199993, 54.14126211100006],
              [-9.956857876999948, 54.15314362200007],
              [-9.950347459999932, 54.15070221600007],
              [-9.93663489499994, 54.14789459800005],
              [-9.930083787999934, 54.145697333000044],
              [-9.942738410999937, 54.157456773000035],
              [-9.977284308999913, 54.18048737200007],
              [-9.963775193999936, 54.17495351800005],
              [-9.952015753999945, 54.17462799700007],
              [-9.942534959999932, 54.178900458000044],
              [-9.936350063999953, 54.18732330900008],
              [-9.98818925699993, 54.21312083500004],
              [-10.010894334999932, 54.21832916900007],
              [-10.025746222999942, 54.20774974200003],
              [-10.011463995999918, 54.19708893400008],
              [-10.016997850999928, 54.188666083000044],
              [-10.033802863999938, 54.18471914300005],
              [-10.05296790299991, 54.18732330900008],
              [-10.04405676999994, 54.176988023000035],
              [-10.03937740799995, 54.17365143400008],
              [-10.03937740799995, 54.16681549700007],
              [-10.053537563999953, 54.168036200000074],
              [-10.065785285999937, 54.16640859600005],
              [-10.087147589999915, 54.15932851800005],
              [-10.087147589999915, 54.15314362200007],
              [-10.07412675699993, 54.15021393400008],
              [-10.069162563999953, 54.14427317900004],
              [-10.06663977799991, 54.12518952000005],
              [-10.075184699999909, 54.12494538000004],
              [-10.094593878999945, 54.118353583000044],
              [-10.081450975999928, 54.112982489000046],
              [-10.069081183999913, 54.10366445500006],
              [-10.066883917999917, 54.094916083000044],
              [-10.083973761999914, 54.091050523000035],
              [-10.102609829999949, 54.091782945000034],
              [-10.11742102799991, 54.09589264500005],
              [-10.126576300999943, 54.10602448100008],
              [-10.128163214999915, 54.12518952000005],
              [-10.122222459999932, 54.13703034100007],
              [-10.099598761999914, 54.16547272300005],
              [-10.094593878999945, 54.176988023000035],
              [-10.091216600999928, 54.194973049000055],
              [-10.082753058999913, 54.20327383000006],
              [-10.071441209999932, 54.20970286700003],
              [-10.059803839999915, 54.22207265800006],
              [-10.091135219999956, 54.22247955900008],
              [-10.10383053299995, 54.226223049000055],
              [-10.11510169199994, 54.23505280200004],
              [-10.096058722999942, 54.23517487200007],
              [-10.08702551999994, 54.24433014500005],
              [-10.081532355999911, 54.257473049000055],
              [-10.073475714999915, 54.269191799000055],
              [-10.062489386999914, 54.275051174000055],
              [-10.018299933999913, 54.290269273000035],
              [-10.014230923999946, 54.29450104400007],
              [-10.011830206999946, 54.29962799700007],
              [-10.007639126999948, 54.30353424700007],
              [-9.997792120999918, 54.303941148000035],
              [-9.991932745999918, 54.30068594000005],
              [-9.989735480999911, 54.29474518400008],
              [-9.988352016999954, 54.288316148000035],
              [-9.984730597999942, 54.28351471600007],
              [-9.97179114499994, 54.27724844000005],
              [-9.954497850999928, 54.27195872600004],
              [-9.936838344999956, 54.270697333000044],
              [-9.922678188999953, 54.276597398000035],
              [-9.915353969999956, 54.268744208000044],
              [-9.907215949999909, 54.26447174700007],
              [-9.89830481699994, 54.26447174700007],
              [-9.88853919199994, 54.269191799000055],
              [-9.886870897999927, 54.266058661000045],
              [-9.88703365799995, 54.26447174700007],
              [-9.885975714999915, 54.263739325000074],
              [-9.88109290299991, 54.263006903000075],
              [-9.903309699999909, 54.237941799000055],
              [-9.927154100999928, 54.22675202000005],
              [-9.952015753999945, 54.228501695000034],
              [-9.977284308999913, 54.24249909100007],
              [-9.983631964999915, 54.22296784100007],
              [-9.968129035999937, 54.21702708500004],
              [-9.94444739499994, 54.216050523000035],
              [-9.926380988999938, 54.21112702000005],
              [-9.909901495999918, 54.204413153000075],
              [-9.896107550999943, 54.21161530200004],
              [-9.882883266999954, 54.22288646000004],
              [-9.868031378999945, 54.228216864000046],
              [-9.881662563999953, 54.24038320500006],
              [-9.875152147999927, 54.25649648600006],
              [-9.858998175999943, 54.27057526200008],
              [-9.843861456999946, 54.276597398000035],
              [-9.82213294199994, 54.27293528900003],
              [-9.787098761999914, 54.25775788000004],
              [-9.765004035999937, 54.255560614000046],
              [-9.770863410999937, 54.26414622600004],
              [-9.778675910999937, 54.269598700000074],
              [-9.799183722999942, 54.276597398000035],
              [-9.799183722999942, 54.28351471600007],
              [-9.789418097999942, 54.28583405200004],
              [-9.780018683999913, 54.28628164300005],
              [-9.758168097999942, 54.28351471600007],
              [-9.776844855999911, 54.28998444200005],
              [-9.82921301999994, 54.296861070000034],
              [-9.84007727799991, 54.307074286000045],
              [-9.84601803299995, 54.32143789300005],
              [-9.84398352799991, 54.32876211100006],
              [-9.785511847999942, 54.33808014500005],
              [-9.76431230399993, 54.33490631700005],
              [-9.726307745999918, 54.32078685100004],
              [-9.70693925699993, 54.317613023000035],
              [-9.53538977799991, 54.310207424000055],
              [-9.524281378999945, 54.31134674700007],
              [-9.505523240999935, 54.316392320000034],
              [-9.49437415299991, 54.317613023000035],
              [-9.485707160999937, 54.31586334800005],
              [-9.471913214999915, 54.307074286000045],
              [-9.46397864499994, 54.303941148000035],
              [-9.384510870999918, 54.29718659100007],
              [-9.374826626999948, 54.29873281500005],
              [-9.362619594999956, 54.302720445000034],
              [-9.351144985999952, 54.30817291900007],
              [-9.34361731699994, 54.31391022300005],
              [-9.33421790299991, 54.31830475500004],
              [-9.322010870999918, 54.31708405200004],
              [-9.27725175699993, 54.30459219000005],
              [-9.268422003999945, 54.303941148000035],
              [-9.260975714999915, 54.299709377000056],
              [-9.252837693999936, 54.280951239000046],
              [-9.247670050999943, 54.276597398000035],
              [-9.229888475999928, 54.27846914300005],
              [-9.219634568999936, 54.280585028000075],
              [-9.217600063999953, 54.28351471600007],
              [-9.211008266999954, 54.27562083500004],
              [-9.209462042999917, 54.267564195000034],
              [-9.211984829999949, 54.26044342700004],
              [-9.217600063999953, 54.255560614000046],
              [-9.217600063999953, 54.24872467700004],
              [-9.195871548999946, 54.24249909100007],
              [-9.195871548999946, 54.23505280200004],
              [-9.21507727799991, 54.22711823100008],
              [-9.210357225999928, 54.21784088700008],
              [-9.16197669199994, 54.19204336100006],
              [-9.149322068999936, 54.18060944200005],
              [-9.141224738999938, 54.165350653000075],
              [-9.141224738999938, 54.145697333000044],
              [-9.13499915299991, 54.145697333000044],
              [-9.134185350999928, 54.163763739000046],
              [-9.130360480999911, 54.17910390800006],
              [-9.128895636999914, 54.193060614000046],
              [-9.13499915299991, 54.20774974200003],
              [-9.112538214999915, 54.213324286000045],
              [-9.090199347999942, 54.226629950000074],
              [-9.072987433999913, 54.24677155200004],
              [-9.066070115999935, 54.27289459800005],
              [-9.051258917999917, 54.289496161000045],
              [-9.01748613199993, 54.291896877000056],
              [-8.956857876999948, 54.28351471600007],
              [-8.94985917899993, 54.284857489000046],
              [-8.944406704999949, 54.28823476800005],
              [-8.939035610999952, 54.28998444200005],
              [-8.927561001999948, 54.28412506700005],
              [-8.910227016999954, 54.27789948100008],
              [-8.894195115999935, 54.27448151200008],
              [-8.871815558999913, 54.26512278900003],
              [-8.856597459999932, 54.263006903000075],
              [-8.807362433999913, 54.263006903000075],
              [-8.785633917999917, 54.266831773000035],
              [-8.765126105999911, 54.276597398000035],
              [-8.737456834999932, 54.264105536000045],
              [-8.67642167899993, 54.27130768400008],
              [-8.64834550699993, 54.263006903000075],
              [-8.64248613199993, 54.253607489000046],
              [-8.639556443999936, 54.24209219000005],
              [-8.633290167999917, 54.23236725500004],
              [-8.605051235999952, 54.22565338700008],
              [-8.593495245999918, 54.21906159100007],
              [-8.572661912999934, 54.20034414300005],
              [-8.559315558999913, 54.20661041900007],
              [-8.543853318999936, 54.208644924000055],
              [-8.511219855999911, 54.20774974200003],
              [-8.511219855999911, 54.214544989000046],
              [-8.525542772999927, 54.21889883000006],
              [-8.54360917899993, 54.22215403900003],
              [-8.55923417899993, 54.227728583000044],
              [-8.565825975999928, 54.23883698100008],
              [-8.57213294199994, 54.246527411000045],
              [-8.587310350999928, 54.25234609600005],
              [-8.605620897999927, 54.255560614000046],
              [-8.62100175699993, 54.255560614000046],
              [-8.62100175699993, 54.263006903000075],
              [-8.614247199999909, 54.26780833500004],
              [-8.60265051999994, 54.27968984600005],
              [-8.593739386999914, 54.28351471600007],
              [-8.571685350999928, 54.27716705900008],
              [-8.558216925999943, 54.27521393400008],
              [-8.552235480999911, 54.28009674700007],
              [-8.540760870999918, 54.284369208000044],
              [-8.470285610999952, 54.276597398000035],
              [-8.485951300999943, 54.28864166900007],
              [-8.50413977799991, 54.29718659100007],
              [-8.52334550699993, 54.30223216400003],
              [-8.542307094999956, 54.303941148000035],
              [-8.562652147999927, 54.30304596600007],
              [-8.569813605999911, 54.30573151200008],
              [-8.572661912999934, 54.31391022300005],
              [-8.567209438999953, 54.32416413000004],
              [-8.554798956999946, 54.321478583000044],
              [-8.531727667999917, 54.310207424000055],
              [-8.511708136999914, 54.31736888200004],
              [-8.519154425999943, 54.32672760600008],
              [-8.540516730999911, 54.33466217700004],
              [-8.562123175999943, 54.33808014500005],
              [-8.661366339999915, 54.33803945500006],
              [-8.666818813999953, 54.34121328300006],
              [-8.66828365799995, 54.35175202000005],
              [-8.663889126999948, 54.35927969000005],
              [-8.653797980999911, 54.36587148600006],
              [-8.641753709999932, 54.370428778000075],
              [-8.612863735999952, 54.37547435100004],
              [-8.496571417999917, 54.423488674000055],
              [-8.480132615999935, 54.42682526200008],
              [-8.474110480999911, 54.42999909100007],
              [-8.471262173999946, 54.43789297100005],
              [-8.470285610999952, 54.45783112200007],
              [-8.46670488199993, 54.47500234600005],
              [-8.45921790299991, 54.471869208000044],
              [-8.451893683999913, 54.461004950000074],
              [-8.44912675699993, 54.454779364000046],
              [-8.445139126999948, 54.45392487200007],
              [-8.443755662999934, 54.45343659100007],
              [-8.443023240999935, 54.447333075000074],
              [-8.41392981699994, 54.45954010600008],
              [-8.384185350999928, 54.46824778900003],
              [-8.381662563999953, 54.46857330900008],
              [-8.300119594999956, 54.47797272300005],
              [-8.28734290299991, 54.47943756700005],
              [-8.24209550699993, 54.497748114000046],
              [-8.210194464999915, 54.501939195000034],
              [-8.210194464999915, 54.509426174000055],
              [-8.24327551999994, 54.510199286000045],
              [-8.257964647999927, 54.51422760600008],
              [-8.270985480999911, 54.52366771000004],
              [-8.216379360999952, 54.55036041900007],
              [-8.218861456999946, 54.56976959800005],
              [-8.17251542899993, 54.59446849200003],
              [-8.175404425999943, 54.61928945500006],
              [-8.164662238999938, 54.615301825000074],
              [-8.157622850999928, 54.61082591400003],
              [-8.150054490999935, 54.607123114000046],
              [-8.137562628999945, 54.60561758000006],
              [-8.12608801999994, 54.637884833000044],
              [-8.120838995999918, 54.646551825000074],
              [-8.123890753999945, 54.64862702000005],
              [-8.12490800699993, 54.64891185100004],
              [-8.125599738999938, 54.649603583000044],
              [-8.127674933999913, 54.652777411000045],
              [-8.14679928299995, 54.64207591400003],
              [-8.16665605399993, 54.63613515800006],
              [-8.234934048999946, 54.62938060100004],
              [-8.271311001999948, 54.61200592700004],
              [-8.29210364499994, 54.60561758000006],
              [-8.29210364499994, 54.61180247600004],
              [-8.281727667999917, 54.62055084800005],
              [-8.280344204999949, 54.62962474200003],
              [-8.287261522999927, 54.636786200000074],
              [-8.301747199999909, 54.63979726800005],
              [-8.316761847999942, 54.63544342700004],
              [-8.342355923999946, 54.61615631700005],
              [-8.36782792899993, 54.608628648000035],
              [-8.414540167999917, 54.57835521000004],
              [-8.42796790299991, 54.57172272300005],
              [-8.44204667899993, 54.56671784100007],
              [-8.456613735999952, 54.56464264500005],
              [-8.456613735999952, 54.57078685100004],
              [-8.43228105399993, 54.58779531500005],
              [-8.41710364499994, 54.59516022300005],
              [-8.398182745999918, 54.59813060100004],
              [-8.384755011999914, 54.60565827000005],
              [-8.387684699999909, 54.61985911700003],
              [-8.400054490999935, 54.628566799000055],
              [-8.415028449999909, 54.61928945500006],
              [-8.421864386999914, 54.61928945500006],
              [-8.418690558999913, 54.64130280200004],
              [-8.431630011999914, 54.64130280200004],
              [-8.448312954999949, 54.62763092700004],
              [-8.456613735999952, 54.608710028000075],
              [-8.461537238999938, 54.602850653000075],
              [-8.472075975999928, 54.607855536000045],
              [-8.481760219999956, 54.61595286700003],
              [-8.48619544199994, 54.62295156500005],
              [-8.485218878999945, 54.627386786000045],
              [-8.486154751999948, 54.631293036000045],
              [-8.494130011999914, 54.63296133000006],
              [-8.500803188999953, 54.632025458000044],
              [-8.511301235999952, 54.62775299700007],
              [-8.51748613199993, 54.62612539300005],
              [-8.541737433999913, 54.62523021000004],
              [-8.553456183999913, 54.62262604400007],
              [-8.564035610999952, 54.60883209800005],
              [-8.576771613999938, 54.61090729400007],
              [-8.596913214999915, 54.61928945500006],
              [-8.672596808999913, 54.61945221600007],
              [-8.690012173999946, 54.62612539300005],
              [-8.68195553299995, 54.63580963700008],
              [-8.691395636999914, 54.64130280200004],
              [-8.774159308999913, 54.659857489000046],
              [-8.791818813999953, 54.65961334800005],
              [-8.788441535999937, 54.663397528000075],
              [-8.786366339999915, 54.66697825700004],
              [-8.78343665299991, 54.67039622600004],
              [-8.778146938999953, 54.673895575000074],
              [-8.778146938999953, 54.68008047100005],
              [-8.791086391999954, 54.684881903000075],
              [-8.797759568999936, 54.69196198100008],
              [-8.795521613999938, 54.698431708000044],
              [-8.78156490799995, 54.701239325000074],
              [-8.766957160999937, 54.70221588700008],
              [-8.755197719999956, 54.70575592700004],
              [-8.747425910999937, 54.71308014500005],
              [-8.744618292999917, 54.72508372600004],
              [-8.733265753999945, 54.73261139500005],
              [-8.662098761999914, 54.76264069200005],
              [-8.63658606699994, 54.768459377000056],
              [-8.536203579999949, 54.766913153000075],
              [-8.483713344999956, 54.75678131700005],
              [-8.456613735999952, 54.75641510600008],
              [-8.456613735999952, 54.76264069200005],
              [-8.526600714999915, 54.772772528000075],
              [-8.545399542999917, 54.78375885600008],
              [-8.529896613999938, 54.78807200700004],
              [-8.484934048999946, 54.78937409100007],
              [-8.473378058999913, 54.786810614000046],
              [-8.46080481699994, 54.77484772300005],
              [-8.444691535999937, 54.76312897300005],
              [-8.426665818999936, 54.75722890800006],
              [-8.408192511999914, 54.76264069200005],
              [-8.461293097999942, 54.79352448100008],
              [-8.498890753999945, 54.801214911000045],
              [-8.534982876999948, 54.816473700000074],
              [-8.558420376999948, 54.81785716400003],
              [-8.554351365999935, 54.82754140800006],
              [-8.546986456999946, 54.82990143400008],
              [-8.537098761999914, 54.829779364000046],
              [-8.524891730999911, 54.83152903900003],
              [-8.515126105999911, 54.836004950000074],
              [-8.50186113199993, 54.84650299700007],
              [-8.490712042999917, 54.851996161000045],
              [-8.47101803299995, 54.84052155200004],
              [-8.44908606699994, 54.83942291900007],
              [-8.401966925999943, 54.84454987200007],
              [-8.346262173999946, 54.831691799000055],
              [-8.325672980999911, 54.83152903900003],
              [-8.325672980999911, 54.838324286000045],
              [-8.343251105999911, 54.839911200000074],
              [-8.365386522999927, 54.845404364000046],
              [-8.381337042999917, 54.85594310100004],
              [-8.380848761999914, 54.87250397300005],
              [-8.366688605999911, 54.88108958500004],
              [-8.327381964999915, 54.877020575000074],
              [-8.312652147999927, 54.879339911000045],
              [-8.325835740999935, 54.88580963700008],
              [-8.33702551999994, 54.903631903000075],
              [-8.350453253999945, 54.90729401200008],
              [-8.368804490999935, 54.908189195000034],
              [-8.374012824999909, 54.90729401200008],
              [-8.378163214999915, 54.902777411000045],
              [-8.379790818999936, 54.895738023000035],
              [-8.380116339999915, 54.88922760600008],
              [-8.380848761999914, 54.88617584800005],
              [-8.40929114499994, 54.88703034100007],
              [-8.432606574999909, 54.901556708000044],
              [-8.450795050999943, 54.92206452000005],
              [-8.463449673999946, 54.94082265800006],
              [-8.450428839999915, 54.94627513200004],
              [-8.440907355999911, 54.943426825000074],
              [-8.43150794199994, 54.93768952000005],
              [-8.418446417999917, 54.93455638200004],
              [-8.40461178299995, 54.93569570500006],
              [-8.391346808999913, 54.938666083000044],
              [-8.366566535999937, 54.94818756700005],
              [-8.396148240999935, 54.95526764500005],
              [-8.41860917899993, 54.968085028000075],
              [-8.456613735999952, 54.995428778000075],
              [-8.456613735999952, 55.00287506700005],
              [-8.448109503999945, 55.00763580900008],
              [-8.43773352799991, 55.009833075000074],
              [-8.42642167899993, 55.00861237200007],
              [-8.415028449999909, 55.00287506700005],
              [-8.404693162999934, 55.012884833000044],
              [-8.401966925999943, 55.01654694200005],
              [-8.408192511999914, 55.01654694200005],
              [-8.403187628999945, 55.03066640800006],
              [-8.395253058999913, 55.03314850500004],
              [-8.385324673999946, 55.032416083000044],
              [-8.374012824999909, 55.036363023000035],
              [-8.354481574999909, 55.060532945000034],
              [-8.347401495999918, 55.06427643400008],
              [-8.337880011999914, 55.05841705900008],
              [-8.33507239499994, 55.03506094000005],
              [-8.325672980999911, 55.03021881700005],
              [-8.319976365999935, 55.03432851800005],
              [-8.31358801999994, 55.05267975500004],
              [-8.305165167999917, 55.05805084800005],
              [-8.316517706999946, 55.08746979400007],
              [-8.320423956999946, 55.10492584800005],
              [-8.316029425999943, 55.11273834800005],
              [-8.304351365999935, 55.119208075000074],
              [-8.288400844999956, 55.15013255400004],
              [-8.278472459999932, 55.16054922100005],
              [-8.263010219999956, 55.16107819200005],
              [-8.206532355999911, 55.14687734600005],
              [-8.188384568999936, 55.14899323100008],
              [-8.157622850999928, 55.15839264500005],
              [-8.14126542899993, 55.16054922100005],
              [-8.147531704999949, 55.15176015800006],
              [-8.154286261999914, 55.14524974200003],
              [-8.159575975999928, 55.138739325000074],
              [-8.161732550999943, 55.12946198100008],
              [-8.15648352799991, 55.12449778900003],
              [-8.144683397999927, 55.130194403000075],
              [-8.114857550999943, 55.154730536000045],
              [-8.054269985999952, 55.176947333000044],
              [-8.034820115999935, 55.180975653000075],
              [-8.020985480999911, 55.188788153000075],
              [-8.011789516999954, 55.205064195000034],
              [-7.999582485999952, 55.219631252000056],
              [-7.97679602799991, 55.221909898000035],
              [-7.950184699999909, 55.210272528000075],
              [-7.958648240999935, 55.199204820000034],
              [-8.00413977799991, 55.180975653000075],
              [-8.00413977799991, 55.17413971600007],
              [-7.961984829999949, 55.187201239000046],
              [-7.95571855399993, 55.18471914300005],
              [-7.949045376999948, 55.17983633000006],
              [-7.933990037999934, 55.18065013200004],
              [-7.918039516999954, 55.18451569200005],
              [-7.908558722999942, 55.18842194200005],
              [-7.894886847999942, 55.17413971600007],
              [-7.894886847999942, 55.16791413000004],
              [-7.898793097999942, 55.15639883000006],
              [-7.890451626999948, 55.158270575000074],
              [-7.875559048999946, 55.164943752000056],
              [-7.860096808999913, 55.16791413000004],
              [-7.865061001999948, 55.15814850500004],
              [-7.872873501999948, 55.151597398000035],
              [-7.882964647999927, 55.14793528900003],
              [-7.894886847999942, 55.14687734600005],
              [-7.894886847999942, 55.14008209800005],
              [-7.876535610999952, 55.14052969000005],
              [-7.865223761999914, 55.13849518400008],
              [-7.856434699999909, 55.13898346600007],
              [-7.846506313999953, 55.14687734600005],
              [-7.834706183999913, 55.16498444200005],
              [-7.837554490999935, 55.175848700000074],
              [-7.860096808999913, 55.194647528000075],
              [-7.866118943999936, 55.214911200000074],
              [-7.85024980399993, 55.22719961100006],
              [-7.823963995999918, 55.23859284100007],
              [-7.798695441999939, 55.25608958500004],
              [-7.796050584999932, 55.25104401200008],
              [-7.795033331999946, 55.250881252000056],
              [-7.79124915299991, 55.24868398600006],
              [-7.814198370999918, 55.20184967700004],
              [-7.815744594999956, 55.194647528000075],
              [-7.813710089999915, 55.19285716400003],
              [-7.810454881999931, 55.188706773000035],
              [-7.805572068999936, 55.18414948100008],
              [-7.798695441999939, 55.180975653000075],
              [-7.789784308999913, 55.180853583000044],
              [-7.77993730399993, 55.18744538000004],
              [-7.770741339999915, 55.18842194200005],
              [-7.757313605999911, 55.184759833000044],
              [-7.73664303299995, 55.176662502000056],
              [-7.717600063999953, 55.16657135600008],
              [-7.70929928299995, 55.157131252000056],
              [-7.707386847999942, 55.15346914300005],
              [-7.698557094999956, 55.14036692900004],
              [-7.69562740799995, 55.13320547100005],
              [-7.69595292899993, 55.12604401200008],
              [-7.701079881999931, 55.10814036700003],
              [-7.702504035999937, 55.09906647300005],
              [-7.694732225999928, 55.10805898600006],
              [-7.678822394999941, 55.134466864000046],
              [-7.671701626999948, 55.14008209800005],
              [-7.66820227799991, 55.14720286700003],
              [-7.674712693999936, 55.16303131700005],
              [-7.684071417999917, 55.17853424700007],
              [-7.688832160999937, 55.18471914300005],
              [-7.690337693999936, 55.194525458000044],
              [-7.695057745999918, 55.207464911000045],
              [-7.703602667999917, 55.218451239000046],
              [-7.716053839999915, 55.221909898000035],
              [-7.723947719999956, 55.21458567900004],
              [-7.721994594999956, 55.20026276200008],
              [-7.715402798999946, 55.184881903000075],
              [-7.70929928299995, 55.17413971600007],
              [-7.723133917999917, 55.17572663000004],
              [-7.732818162999934, 55.18146393400008],
              [-7.741037563999953, 55.18862539300005],
              [-7.75023352799991, 55.194647528000075],
              [-7.779652472999942, 55.199652411000045],
              [-7.791737433999913, 55.20600006700005],
              [-7.788156704999949, 55.21857330900008],
              [-7.760853644999941, 55.250433661000045],
              [-7.760853644999941, 55.25608958500004],
              [-7.725087042999917, 55.25267161700003],
              [-7.70929928299995, 55.25608958500004],
              [-7.673491990999935, 55.273871161000045],
              [-7.660878058999913, 55.276556708000044],
              [-7.643950975999928, 55.272772528000075],
              [-7.633290167999917, 55.26308828300006],
              [-7.62531490799995, 55.253159898000035],
              [-7.616525844999956, 55.24868398600006],
              [-7.611398891999954, 55.241400458000044],
              [-7.613189256999931, 55.225775458000044],
              [-7.61750240799995, 55.210598049000055],
              [-7.619943813999953, 55.20490143400008],
              [-7.614491339999915, 55.19599030200004],
              [-7.601470506999931, 55.18927643400008],
              [-7.572743292999917, 55.180975653000075],
              [-7.572255011999914, 55.169175523000035],
              [-7.564116990999935, 55.15574778900003],
              [-7.552479620999918, 55.14468008000006],
              [-7.541411912999934, 55.14008209800005],
              [-7.527821417999917, 55.13255442900004],
              [-7.525786912999934, 55.11615631700005],
              [-7.531605597999942, 55.099676825000074],
              [-7.541411912999934, 55.092230536000045],
              [-7.556385870999918, 55.08974844000005],
              [-7.568226691999939, 55.083685614000046],
              [-7.586415167999917, 55.07111237200007],
              [-7.641021287999934, 55.05068594000005],
              [-7.641021287999934, 55.043850002000056],
              [-7.581166144999941, 55.050441799000055],
              [-7.561838344999956, 55.04450104400007],
              [-7.572743292999917, 55.02338288000004],
              [-7.584584113999938, 55.016058661000045],
              [-7.634185350999928, 54.995428778000075],
              [-7.667551235999952, 54.96820709800005],
              [-7.681385870999918, 54.96124909100007],
              [-7.681385870999918, 54.954413153000075],
              [-7.661488410999937, 54.95795319200005],
              [-7.643381313999953, 54.965277411000045],
              [-7.548451300999943, 55.018459377000056],
              [-7.537993943999936, 55.01992422100005],
              [-7.529367641999954, 55.03070709800005],
              [-7.509266730999911, 55.03595612200007],
              [-7.486317511999914, 55.03925202000005],
              [-7.469105597999942, 55.043850002000056],
              [-7.456166144999941, 55.05613841400003],
              [-7.450021938999953, 55.072333075000074],
              [-7.454416469999956, 55.08624909100007],
              [-7.472767706999946, 55.092230536000045],
              [-7.477528449999909, 55.09638092700004],
              [-7.473378058999913, 55.105454820000034],
              [-7.462880011999914, 55.11953359600005],
              [-7.462880011999914, 55.143459377000056],
              [-7.470041469999956, 55.14516836100006],
              [-7.51008053299995, 55.180975653000075],
              [-7.533680792999917, 55.19236888200004],
              [-7.541411912999934, 55.19806549700007],
              [-7.545643683999913, 55.204779364000046],
              [-7.549549933999913, 55.21539948100008],
              [-7.549387173999946, 55.22516510600008],
              [-7.527088995999918, 55.236761786000045],
              [-7.516224738999938, 55.25413646000004],
              [-7.513579881999931, 55.27435944200005],
              [-7.524322068999936, 55.290269273000035],
              [-7.507394985999952, 55.289129950000074],
              [-7.492746548999946, 55.28534577000005],
              [-7.478586391999954, 55.28392161700003],
              [-7.462880011999914, 55.290269273000035],
              [-7.465565558999913, 55.29360586100006],
              [-7.466420050999943, 55.29584381700005],
              [-7.46703040299991, 55.29865143400008],
              [-7.469105597999942, 55.303900458000044],
              [-7.449208136999914, 55.29401276200008],
              [-7.42796790299991, 55.28656647300005],
              [-7.405913865999935, 55.28693268400008],
              [-7.367787238999938, 55.310614325000074],
              [-7.347523566999939, 55.31427643400008],
              [-7.327504035999937, 55.30849844000005],
              [-7.312082485999952, 55.290269273000035],
              [-7.333159959999932, 55.28961823100008],
              [-7.339955206999946, 55.290269273000035],
              [-7.320871548999946, 55.28217194200005],
              [-7.298817511999914, 55.276271877000056],
              [-7.276600714999915, 55.275824286000045],
              [-7.256743943999936, 55.28400299700007],
              [-7.320668097999942, 55.31329987200007],
              [-7.350697394999941, 55.335191148000035],
              [-7.353016730999911, 55.35854726800005],
              [-7.37954667899993, 55.36766185100004],
              [-7.391590949999909, 55.37372467700004],
              [-7.400217251999948, 55.38027578300006],
              [-7.384429490999935, 55.386379299000055],
              [-7.366322394999941, 55.383978583000044],
              [-7.332508917999917, 55.37278880400004],
              [-7.263579881999931, 55.35854726800005],
              [-7.247303839999915, 55.35716380400004],
              [-7.208851691999939, 55.34511953300006],
              [-7.195423956999946, 55.33860911700003],
              [-7.144154425999943, 55.29364655200004],
              [-7.129058397999927, 55.28583405200004],
              [-7.079335089999915, 55.272650458000044],
              [-7.041900193999936, 55.268866278000075],
              [-6.996490037999934, 55.25771719000005],
              [-6.975697394999941, 55.24868398600006],
              [-6.953521287999934, 55.254339911000045],
              [-6.939564581999946, 55.23908112200007],
              [-6.942779100999928, 55.21857330900008],
              [-6.972564256999931, 55.208319403000075],
              [-7.00064042899993, 55.205145575000074],
              [-7.034087693999936, 55.19684479400007],
              [-7.065744594999956, 55.18496328300006],
              [-7.099761522999927, 55.16547272300005],
              [-7.132313605999911, 55.155462958000044],
              [-7.159494594999956, 55.15078359600005],
              [-7.172840949999909, 55.14350006700005],
              [-7.216623501999948, 55.10834381700005],
              [-7.232289191999939, 55.091864325000074],
              [-7.244984503999945, 55.073431708000044],
              [-7.247100389999957, 55.06932200700004],
            ],
          ],
          [
            [
              [-9.662668423999946, 53.275458075000074],
              [-9.638335740999935, 53.25104401200008],
              [-9.658314581999946, 53.23265208500004],
              [-9.692372199999909, 53.22638580900008],
              [-9.710357225999928, 53.23859284100007],
              [-9.713612433999913, 53.253119208000044],
              [-9.71898352799991, 53.26044342700004],
              [-9.720082160999937, 53.266058661000045],
              [-9.710357225999928, 53.275458075000074],
              [-9.698882615999935, 53.28066640800006],
              [-9.684722459999932, 53.282416083000044],
              [-9.671457485999952, 53.28074778900003],
              [-9.662668423999946, 53.275458075000074],
            ],
          ],
          [
            [
              [-9.963612433999913, 53.95384349200003],
              [-9.95181230399993, 53.95783112200007],
              [-9.94054114499994, 53.95994700700004],
              [-9.930653449999909, 53.959051825000074],
              [-9.922678188999953, 53.95384349200003],
              [-9.922678188999953, 53.94708893400008],
              [-9.930734829999949, 53.93927643400008],
              [-9.93736731699994, 53.923529364000046],
              [-9.940174933999913, 53.905951239000046],
              [-9.936350063999953, 53.89248281500005],
              [-9.957997199999909, 53.88060130400004],
              [-9.97679602799991, 53.88686758000006],
              [-9.995838995999918, 53.90102773600006],
              [-10.018299933999913, 53.91290924700007],
              [-10.031320766999954, 53.91364166900007],
              [-10.04482988199993, 53.912095445000034],
              [-10.055531378999945, 53.913723049000055],
              [-10.059803839999915, 53.923488674000055],
              [-10.057687954999949, 53.93817780200004],
              [-10.05459550699993, 53.94953034100007],
              [-10.055816209999932, 53.95880768400008],
              [-10.06663977799991, 53.96759674700007],
              [-10.087228969999956, 53.97138092700004],
              [-10.162831183999913, 53.961371161000045],
              [-10.190174933999913, 53.96352773600006],
              [-10.239491339999915, 53.974676825000074],
              [-10.26593990799995, 53.97500234600005],
              [-10.26593990799995, 53.98183828300006],
              [-10.24014238199993, 53.98236725500004],
              [-10.218495245999918, 53.986029364000046],
              [-10.20148678299995, 53.996161200000074],
              [-10.189564581999946, 54.01601797100005],
              [-10.18187415299991, 54.01015859600005],
              [-10.173573370999918, 54.00836823100008],
              [-10.164906378999945, 54.01032135600008],
              [-10.156076626999948, 54.01601797100005],
              [-10.134429490999935, 54.00031159100007],
              [-10.108876105999911, 54.00458405200004],
              [-10.083729620999918, 54.01609935100004],
              [-10.063221808999913, 54.022772528000075],
              [-9.975900844999956, 54.021144924000055],
              [-9.956857876999948, 54.01601797100005],
              [-9.936350063999953, 53.98924388200004],
              [-9.956857876999948, 53.98924388200004],
              [-9.954253709999932, 53.98110586100006],
              [-9.954660610999952, 53.97333405200004],
              [-9.957834438999953, 53.966498114000046],
              [-9.963612433999913, 53.961371161000045],
              [-9.963612433999913, 53.95384349200003],
            ],
          ],
          [
            [
              [-8.524891730999911, 55.00971100500004],
              [-8.509022589999915, 55.005560614000046],
              [-8.496571417999917, 55.00067780200004],
              [-8.48818925699993, 54.99176666900007],
              [-8.483957485999952, 54.97553131700005],
              [-8.527414516999954, 54.96751536700003],
              [-8.549305792999917, 54.968410549000055],
              [-8.565825975999928, 54.97553131700005],
              [-8.565825975999928, 54.981756903000075],
              [-8.563384568999936, 54.98615143400008],
              [-8.56273352799991, 54.986395575000074],
              [-8.56358801999994, 54.98773834800005],
              [-8.565825975999928, 54.995428778000075],
              [-8.550933397999927, 55.00153229400007],
              [-8.545399542999917, 55.00287506700005],
              [-8.547434048999946, 55.00535716400003],
              [-8.550526495999918, 55.00800202000005],
              [-8.552235480999911, 55.00971100500004],
              [-8.543527798999946, 55.015326239000046],
              [-8.536366339999915, 55.01658763200004],
              [-8.53038489499994, 55.01434967700004],
              [-8.524891730999911, 55.00971100500004],
            ],
          ],
          [
            [
              [-9.816965298999946, 51.63886139500005],
              [-9.807199673999946, 51.640285549000055],
              [-9.799305792999917, 51.636786200000074],
              [-9.807362433999913, 51.62970612200007],
              [-9.813547329999949, 51.62763092700004],
              [-9.892160610999952, 51.61127350500004],
              [-9.902699347999942, 51.61432526200008],
              [-9.91787675699993, 51.61937083500004],
              [-9.915516730999911, 51.62905508000006],
              [-9.900990363999938, 51.63666413000004],
              [-9.881662563999953, 51.641058661000045],
              [-9.858265753999945, 51.64240143400008],
              [-9.82408606699994, 51.63890208500004],
              [-9.816965298999946, 51.63886139500005],
            ],
          ],
          [
            [
              [-10.312652147999927, 51.92552317900004],
              [-10.301625128999945, 51.92479075700004],
              [-10.297678188999953, 51.918402411000045],
              [-10.30455481699994, 51.91071198100008],
              [-10.322661912999934, 51.90326569200005],
              [-10.36156165299991, 51.89203522300005],
              [-10.396229620999918, 51.889837958000044],
              [-10.405832485999952, 51.884100653000075],
              [-10.42601477799991, 51.88226959800005],
              [-10.429025844999956, 51.889837958000044],
              [-10.41201738199993, 51.90412018400008],
              [-10.360910610999952, 51.92572663000004],
              [-10.351673956999946, 51.93113841400009],
              [-10.33311926999994, 51.93060944200005],
              [-10.32603919199994, 51.92963288000004],
              [-10.31826738199993, 51.92495351800005],
              [-10.312652147999927, 51.92552317900004],
            ],
          ],
          [
            [
              [-9.64834550699993, 53.10171133000006],
              [-9.645090298999946, 53.10260651200008],
              [-9.64093990799995, 53.101548570000034],
              [-9.64244544199994, 53.093817450000074],
              [-9.660511847999942, 53.09064362200007],
              [-9.778716600999928, 53.123480536000045],
              [-9.811431443999936, 53.137600002000056],
              [-9.801177537999934, 53.146470445000034],
              [-9.777495897999927, 53.14679596600007],
              [-9.75218665299991, 53.13540273600006],
              [-9.740061001999948, 53.135199286000045],
              [-9.715687628999945, 53.13825104400007],
              [-9.696685350999928, 53.13654205900008],
              [-9.671050584999932, 53.130519924000055],
              [-9.663441535999937, 53.12319570500006],
              [-9.672230597999942, 53.11591217700004],
              [-9.671538865999935, 53.10919830900008],
              [-9.64834550699993, 53.10171133000006],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'United Kingdom',
        iso3: 'GBR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7.247100389999957, 55.06932200700004],
              [-7.256743943999936, 55.05068594000005],
              [-7.240956183999913, 55.05027903900003],
              [-7.195423956999946, 55.05805084800005],
              [-7.177479620999918, 55.05695221600007],
              [-7.133900519999941, 55.043850002000056],
              [-7.099476691999939, 55.04096100500004],
              [-7.065052863999938, 55.043850002000056],
              [-7.053700324999909, 55.04873281500005],
              [-7.03189042899993, 55.06492747600004],
              [-7.017201300999943, 55.07111237200007],
              [-7.01781165299991, 55.083970445000034],
              [-7.009917772999927, 55.10224030200004],
              [-6.997954881999931, 55.11863841400003],
              [-6.986480272999927, 55.12571849200003],
              [-6.97492428299995, 55.13544342700004],
              [-6.968658006999931, 55.18065013200004],
              [-6.962554490999935, 55.194647528000075],
              [-6.946685350999928, 55.195379950000074],
              [-6.903553839999915, 55.17865631700005],
              [-6.883778449999909, 55.17413971600007],
              [-6.754505988999938, 55.177801825000074],
              [-6.640451626999948, 55.208319403000075],
              [-6.571278449999909, 55.21124909100007],
              [-6.554514126999948, 55.21857330900008],
              [-6.539173956999946, 55.23065827000005],
              [-6.51984615799995, 55.240668036000045],
              [-6.498117641999954, 55.24713776200008],
              [-6.475941535999937, 55.24868398600006],
              [-6.440012173999946, 55.236029364000046],
              [-6.415923631999931, 55.23187897300005],
              [-6.378163214999915, 55.24624258000006],
              [-6.352894660999937, 55.242621161000045],
              [-6.255848761999914, 55.21088288000004],
              [-6.239816860999952, 55.208319403000075],
              [-6.217640753999945, 55.21039459800005],
              [-6.179554816999939, 55.21971263200004],
              [-6.160023566999939, 55.221909898000035],
              [-6.120838995999918, 55.21784088700008],
              [-6.100982225999928, 55.21238841400003],
              [-6.092396613999938, 55.20490143400008],
              [-6.08421790299991, 55.20221588700008],
              [-6.047230597999942, 55.17853424700007],
              [-6.037098761999914, 55.16791413000004],
              [-6.040638800999943, 55.11204661700003],
              [-6.047434048999946, 55.09564850500004],
              [-6.062082485999952, 55.07412344000005],
              [-6.054351365999935, 55.06513092700004],
              [-6.03538977799991, 55.06362539300005],
              [-6.016672329999949, 55.06427643400008],
              [-6.003529425999943, 55.06317780200004],
              [-5.988677537999934, 55.059475002000056],
              [-5.975738084999932, 55.05304596600007],
              [-5.968251105999911, 55.043850002000056],
              [-5.970204230999911, 55.025824286000045],
              [-5.988270636999914, 54.98867422100005],
              [-5.986236131999931, 54.981756903000075],
              [-5.957142706999946, 54.978949286000045],
              [-5.93032792899993, 54.97089264500005],
              [-5.906605597999942, 54.95795319200005],
              [-5.886341925999943, 54.94082265800006],
              [-5.881988084999932, 54.934027411000045],
              [-5.87523352799991, 54.91791413000004],
              [-5.869252081999946, 54.91038646000004],
              [-5.862782355999911, 54.905951239000046],
              [-5.847035285999937, 54.898138739000046],
              [-5.839182094999956, 54.893011786000045],
              [-5.829986131999931, 54.88515859600005],
              [-5.82095292899993, 54.875067450000074],
              [-5.813954230999911, 54.86277903900003],
              [-5.81118730399993, 54.84833405200004],
              [-5.800526495999918, 54.820746161000045],
              [-5.775257941999939, 54.81150950700004],
              [-5.745594855999911, 54.80459219000005],
              [-5.721831834999932, 54.78375885600008],
              [-5.715646938999953, 54.78375885600008],
              [-5.733754035999937, 54.80524323100008],
              [-5.797596808999913, 54.84454987200007],
              [-5.781727667999917, 54.86172109600005],
              [-5.751616990999935, 54.85687897300005],
              [-5.720611131999931, 54.841009833000044],
              [-5.701975063999953, 54.82469310100004],
              [-5.689849412999934, 54.79311758000006],
              [-5.692616339999915, 54.76520416900007],
              [-5.706898566999939, 54.74298737200007],
              [-5.729318813999953, 54.728501695000034],
              [-5.758900519999941, 54.719916083000044],
              [-5.818430141999954, 54.70962148600006],
              [-5.845366990999935, 54.701239325000074],
              [-5.871490037999934, 54.68732330900008],
              [-5.890736456999946, 54.672308661000045],
              [-5.914336717999959, 54.64683665600006],
              [-5.927235480999911, 54.63296133000006],
              [-5.915150519999941, 54.628241278000075],
              [-5.910959438999953, 54.61945221600007],
              [-5.909982876999948, 54.610541083000044],
              [-5.907378709999932, 54.60561758000006],
              [-5.894886847999942, 54.604803778000075],
              [-5.887277798999946, 54.609808661000045],
              [-5.881988084999932, 54.61615631700005],
              [-5.871001756999931, 54.622300523000035],
              [-5.848784959999932, 54.64321523600006],
              [-5.839019334999932, 54.649725653000075],
              [-5.803822394999941, 54.65961334800005],
              [-5.769520636999914, 54.67462799700007],
              [-5.747954881999931, 54.68040599200003],
              [-5.732411261999914, 54.676988023000035],
              [-5.716623501999948, 54.66986725500004],
              [-5.694691535999937, 54.66868724200003],
              [-5.574696417999917, 54.68008047100005],
              [-5.56899980399993, 54.676947333000044],
              [-5.556711391999954, 54.66278717700004],
              [-5.54710852799991, 54.65961334800005],
              [-5.536610480999911, 54.657456773000035],
              [-5.533273891999954, 54.651678778000075],
              [-5.532785610999952, 54.64321523600006],
              [-5.530100063999953, 54.63296133000006],
              [-5.514393683999913, 54.59788646000004],
              [-5.502552863999938, 54.58348216400003],
              [-5.485707160999937, 54.57770416900007],
              [-5.478911912999934, 54.56948476800005],
              [-5.47288977799991, 54.53009674700007],
              [-5.468617316999939, 54.51626211100006],
              [-5.437082485999952, 54.48786041900007],
              [-5.430775519999941, 54.48517487200007],
              [-5.437570766999954, 54.47565338700008],
              [-5.436512824999909, 54.47020091400003],
              [-5.433461066999939, 54.46625397300005],
              [-5.43382727799991, 54.461004950000074],
              [-5.438832160999937, 54.45490143400008],
              [-5.458119269999941, 54.43740469000005],
              [-5.464263475999928, 54.42523834800005],
              [-5.457386847999942, 54.40867747600004],
              [-5.46117102799991, 54.39207591400003],
              [-5.470855272999927, 54.38434479400007],
              [-5.483998175999943, 54.37759023600006],
              [-5.489125128999945, 54.369574286000045],
              [-5.47484290299991, 54.358587958000044],
              [-5.489572719999956, 54.35370514500005],
              [-5.502023891999954, 54.33966705900008],
              [-5.515777147999927, 54.33808014500005],
              [-5.52765865799995, 54.34528229400007],
              [-5.536976691999939, 54.35927969000005],
              [-5.54710852799991, 54.37909577000005],
              [-5.558990037999934, 54.38263580900008],
              [-5.569488084999932, 54.391506252000056],
              [-5.576649542999917, 54.402777411000045],
              [-5.57843990799995, 54.41380442900004],
              [-5.571685350999928, 54.42560455900008],
              [-5.548695441999939, 54.44281647300005],
              [-5.543690558999913, 54.45783112200007],
              [-5.547352667999917, 54.48908112200007],
              [-5.558013475999928, 54.51190827000005],
              [-5.575306769999941, 54.528998114000046],
              [-5.644886847999942, 54.56777578300006],
              [-5.671864386999914, 54.57680898600006],
              [-5.701975063999953, 54.57770416900007],
              [-5.701975063999953, 54.57078685100004],
              [-5.694650844999956, 54.56110260600008],
              [-5.697417772999927, 54.551214911000045],
              [-5.706044074999909, 54.542669989000046],
              [-5.715646938999953, 54.53668854400007],
              [-5.701527472999942, 54.536322333000044],
              [-5.690419074999909, 54.53204987200007],
              [-5.681507941999939, 54.52684153900003],
              [-5.67406165299991, 54.52366771000004],
              [-5.63695227799991, 54.52204010600008],
              [-5.625599738999938, 54.51626211100006],
              [-5.641916469999956, 54.51264069200005],
              [-5.663929816999939, 54.510199286000045],
              [-5.670318162999934, 54.50568268400008],
              [-5.639963344999956, 54.495754299000055],
              [-5.64476477799991, 54.483710028000075],
              [-5.644602016999954, 54.47211334800005],
              [-5.638498501999948, 54.46356842700004],
              [-5.625599738999938, 54.461004950000074],
              [-5.626698370999918, 54.456691799000055],
              [-5.628000454999949, 54.45380280200004],
              [-5.63312740799995, 54.447333075000074],
              [-5.625599738999938, 54.441107489000046],
              [-5.653553839999915, 54.38898346600007],
              [-5.661447719999956, 54.37958405200004],
              [-5.69790605399993, 54.36229075700004],
              [-5.708851691999939, 54.35175202000005],
              [-5.668324347999942, 54.360663153000075],
              [-5.622141079999949, 54.376654364000046],
              [-5.579701300999943, 54.383693752000056],
              [-5.550526495999918, 54.36542389500005],
              [-5.540679490999935, 54.327337958000044],
              [-5.55304928299995, 54.298529364000046],
              [-5.579497850999928, 54.27570221600007],
              [-5.612619594999956, 54.255560614000046],
              [-5.617176886999914, 54.254787502000056],
              [-5.628529425999943, 54.25653717700004],
              [-5.63312740799995, 54.255560614000046],
              [-5.639963344999956, 54.23505280200004],
              [-5.646839972999942, 54.23216380400004],
              [-5.655751105999911, 54.229681708000044],
              [-5.663400844999956, 54.23086172100005],
              [-5.66665605399993, 54.23883698100008],
              [-5.678822394999941, 54.246161200000074],
              [-5.736887173999946, 54.24909088700008],
              [-5.779449022999927, 54.246527411000045],
              [-5.822661912999934, 54.237209377000056],
              [-5.842274542999917, 54.23505280200004],
              [-5.862049933999913, 54.230536200000074],
              [-5.868031378999945, 54.21849192900004],
              [-5.866037563999953, 54.18414948100008],
              [-5.865834113999938, 54.18048737200007],
              [-5.868519660999937, 54.161322333000044],
              [-5.874623175999943, 54.14052969000005],
              [-5.883208787999934, 54.120754299000055],
              [-5.893788214999915, 54.104681708000044],
              [-5.911976691999939, 54.09129466400003],
              [-5.953846808999913, 54.07868073100008],
              [-5.984730597999942, 54.05931224200003],
              [-6.027251756999931, 54.040228583000044],
              [-6.040516730999911, 54.036444403000075],
              [-6.079579230999911, 54.03457265800006],
              [-6.095448370999918, 54.036363023000035],
              [-6.112904425999943, 54.04389069200005],
              [-6.112904425999943, 54.050116278000075],
              [-6.093006964999915, 54.055894273000035],
              [-6.084950324999909, 54.05695221600007],
              [-6.161529100999928, 54.07371653900003],
              [-6.174305792999917, 54.074286200000074],
              [-6.18586178299995, 54.092678127000056],
              [-6.212554490999935, 54.09845612200007],
              [-6.24250240799995, 54.09975820500006],
              [-6.263661261999914, 54.104681708000044],
              [-6.269886847999942, 54.09792715100008],
              [-6.284650430999932, 54.105225728000036],
              [-6.299584920999877, 54.104037171000115],
              [-6.313795938999931, 54.09969635000003],
              [-6.327128458999965, 54.09788767500005],
              [-6.338962361999961, 54.10295196600002],
              [-6.346662149999872, 54.109876607],
              [-6.354827025999896, 54.11065175400002],
              [-6.368107869999903, 54.097319234000096],
              [-6.369348103999926, 54.09111806200009],
              [-6.367642781999876, 54.08341827400001],
              [-6.366919310999975, 54.07509836900006],
              [-6.371156778999932, 54.06677846300009],
              [-6.377512980999938, 54.063264466000035],
              [-6.401025756999928, 54.06088735000007],
              [-6.426760619999925, 54.055409648000094],
              [-6.433891967999955, 54.05530629500008],
              [-6.440299844999913, 54.05799346900001],
              [-6.446242635999937, 54.06243764300011],
              [-6.450221719999917, 54.066675111000066],
              [-6.450893513999887, 54.06843210900003],
              [-6.478540405999894, 54.06770863900003],
              [-6.564013224999911, 54.048950094000034],
              [-6.571868041999949, 54.049518534000086],
              [-6.587164265999917, 54.05334259000004],
              [-6.59507075999997, 54.05241241500009],
              [-6.600290079999894, 54.048950094000034],
              [-6.605217158999977, 54.044475258],
              [-6.610987100999893, 54.0392349240001],
              [-6.616464803999889, 54.03727122100007],
              [-6.630624144999928, 54.041818746],
              [-6.657289184999883, 54.06114573200007],
              [-6.672533732999909, 54.06843210900003],
              [-6.657082478999911, 54.09194488600012],
              [-6.655790567999873, 54.103313700000015],
              [-6.666435913999862, 54.114785869000045],
              [-6.643956664999848, 54.13183909100006],
              [-6.634551554999888, 54.15013254800003],
              [-6.640339314999949, 54.1680125940001],
              [-6.648448442999893, 54.17366497000005],
              [-6.663025268999917, 54.1838255820001],
              [-6.683954223999905, 54.194367575000044],
              [-6.694651244999932, 54.19798492500003],
              [-6.706536824999944, 54.19891510100008],
              [-6.717233845999942, 54.19514272100007],
              [-6.724778605999916, 54.188631491000095],
              [-6.732840128999896, 54.18356720000013],
              [-6.74477738499985, 54.18418731700008],
              [-6.766481486999851, 54.192352194000094],
              [-6.78782385299985, 54.202997539000094],
              [-6.807357543999927, 54.216330058000025],
              [-6.823945678999848, 54.232349752000076],
              [-6.829733438999909, 54.24237498000009],
              [-6.833195759999882, 54.25209014900004],
              [-6.837743285999892, 54.26051340800002],
              [-6.846683308999928, 54.26645619700004],
              [-6.882185017999888, 54.27725657200007],
              [-6.864666707999902, 54.28273427300006],
              [-6.856656860999948, 54.29281117800009],
              [-6.85841385899991, 54.30733225600004],
              [-6.870014701999906, 54.326000603000054],
              [-6.879704548999911, 54.34159373000007],
              [-6.885957397999903, 54.345624492000056],
              [-6.897894652999952, 54.34619293300001],
              [-6.905956176999922, 54.34903513700009],
              [-6.915051228999914, 54.36593332900007],
              [-6.922027547999903, 54.372702942],
              [-6.984090942999956, 54.40308868500007],
              [-7.01783565299985, 54.4131655880001],
              [-7.049254923999882, 54.411511943000065],
              [-7.078503783999906, 54.394717103000076],
              [-7.127027953999914, 54.349758606000066],
              [-7.15989416499994, 54.335185852],
              [-7.168059040999935, 54.33503082400007],
              [-7.185629028999927, 54.3369428510001],
              [-7.189469552999896, 54.33569177100004],
              [-7.192450316999981, 54.334720764000096],
              [-7.193948933999877, 54.329966532000086],
              [-7.1914684649999, 54.32386871300004],
              [-7.187644408999887, 54.31880442300006],
              [-7.185008910999954, 54.31725413100004],
              [-7.184647175999942, 54.31663401300007],
              [-7.192398640999954, 54.307383932000064],
              [-7.193690551999907, 54.30753896100002],
              [-7.199168253999915, 54.303456523000094],
              [-7.206661336999929, 54.30490346300009],
              [-7.211467244999938, 54.30417999300009],
              [-7.209038452999891, 54.293431296000065],
              [-7.175500446999877, 54.28366444900011],
              [-7.181494913999899, 54.269763489000056],
              [-7.145889851999925, 54.25209014900004],
              [-7.159739135999899, 54.240669657000026],
              [-7.153331257999952, 54.22423655300007],
              [-7.174725300999853, 54.216071676000055],
              [-7.229502319999938, 54.20754506400003],
              [-7.24087113499985, 54.20232574500001],
              [-7.249087686999871, 54.19741648400007],
              [-7.255495564999904, 54.190853577],
              [-7.261128295999924, 54.18088002500009],
              [-7.256322387999916, 54.17690094000001],
              [-7.247020629999895, 54.17225006200006],
              [-7.245780395999873, 54.16697906500012],
              [-7.265365762999892, 54.16113962900003],
              [-7.260869913999954, 54.1511660770001],
              [-7.263505411999887, 54.14098582000004],
              [-7.270740112999931, 54.13225250200007],
              [-7.280041870999867, 54.126154683000024],
              [-7.293787800999922, 54.1220205690001],
              [-7.297353474999881, 54.125896302000044],
              [-7.296319946999887, 54.13499135400012],
              [-7.29642329999993, 54.146515198000046],
              [-7.295028035999849, 54.155403545000055],
              [-7.292134155999861, 54.162638245000025],
              [-7.295544799999988, 54.165118714000116],
              [-7.325982218999854, 54.154576722000044],
              [-7.333165242999911, 54.14940907900005],
              [-7.333165242999911, 54.14274281900002],
              [-7.310324259999902, 54.11468251600009],
              [-7.316489273999906, 54.11428045000004],
              [-7.326964069999917, 54.11359731],
              [-7.375488240999914, 54.12331248000005],
              [-7.390216023999898, 54.12119374600006],
              [-7.394660197999912, 54.121917217000075],
              [-7.396623900999941, 54.12625803600004],
              [-7.403961954999943, 54.135043030000034],
              [-7.412230183999895, 54.1364382930001],
              [-7.422255411999913, 54.13545644200006],
              [-7.425769408999884, 54.136955058000055],
              [-7.414658976999959, 54.145688376000024],
              [-7.439618692999943, 54.146928610000074],
              [-7.480753132999922, 54.127653300000034],
              [-7.502302204999864, 54.12512115500003],
              [-7.609014037999941, 54.13990061500006],
              [-7.620796264999854, 54.14496490500004],
              [-7.624051879999854, 54.153336487],
              [-7.625705525999905, 54.162173157000026],
              [-7.632681843999904, 54.16852935800004],
              [-7.704770466999889, 54.200362041000076],
              [-7.722598836999907, 54.20232574500001],
              [-7.782078409999883, 54.200000305000074],
              [-7.836958780999908, 54.204341126000074],
              [-7.856440796999891, 54.21142079700009],
              [-7.869669961999875, 54.2268720500001],
              [-7.873649047999947, 54.271055400000094],
              [-7.880263631999867, 54.28702341700004],
              [-7.894965576999937, 54.29358632400003],
              [-7.93411047299989, 54.29704864600005],
              [-7.942074756999915, 54.29887328100004],
              [-7.950801961999929, 54.30087270200009],
              [-7.968010213999889, 54.31218984000007],
              [-7.981032673999948, 54.32655588900006],
              [-8.002194172999879, 54.357923483],
              [-8.031339680999906, 54.35802683500002],
              [-8.056480265999937, 54.36588165400006],
              [-8.079941364999911, 54.380196025000046],
              [-8.12241939299986, 54.415232646000064],
              [-8.146345580999963, 54.43073557600009],
              [-8.156034911999882, 54.43905548100004],
              [-8.15812780799996, 54.44711700500004],
              [-8.161176717999894, 54.45481679300012],
              [-8.173837442999911, 54.46174143500009],
              [-8.168466710999894, 54.463476955],
              [-8.150169636999891, 54.46938954700009],
              [-8.09704626499996, 54.47858795200007],
              [-8.072448282999886, 54.487062887],
              [-8.06097611499996, 54.49331573500008],
              [-8.05586014799988, 54.49755320300004],
              [-8.043561156999914, 54.51222930900012],
              [-8.023278157999925, 54.52969594400007],
              [-8.002194172999879, 54.543441875],
              [-7.926410685999912, 54.53305491200008],
              [-7.887136596999937, 54.53212473600003],
              [-7.848844360999919, 54.54090972900012],
              [-7.749263875999873, 54.59615183600003],
              [-7.707871052999906, 54.6041616830001],
              [-7.707951474999902, 54.60476330300004],
              [-7.710558227999854, 54.62426381500005],
              [-7.721203572999855, 54.625865784],
              [-7.736758178999878, 54.61925120000011],
              [-7.753553019999941, 54.614496969000115],
              [-7.769159301999878, 54.61801096600006],
              [-7.801198689999893, 54.63480580700012],
              [-7.814996296999936, 54.63945668600009],
              [-7.822541055999892, 54.63811309800012],
              [-7.838043985999889, 54.63124013300005],
              [-7.846415567999969, 54.63144683800003],
              [-7.854270385999911, 54.63640777600007],
              [-7.864347290999945, 54.64906850200002],
              [-7.87277054899991, 54.65222076500005],
              [-7.890082153999913, 54.655062968000024],
              [-7.906618611999932, 54.66131581600003],
              [-7.914835164999943, 54.67165110300003],
              [-7.907135375999871, 54.68668894500003],
              [-7.913233194999918, 54.68865264900005],
              [-7.929666300999884, 54.696714173000046],
              [-7.880108601999922, 54.71102854400003],
              [-7.845898803999916, 54.73102732300008],
              [-7.832152872999899, 54.73061391200007],
              [-7.803575805999913, 54.716144511000024],
              [-7.770502888999943, 54.70601593100007],
              [-7.736603149999922, 54.70746287100006],
              [-7.702289997999912, 54.71888336200006],
              [-7.667511759999854, 54.73877878900008],
              [-7.649683390999911, 54.744876608000126],
              [-7.615370238999986, 54.739347229000046],
              [-7.585397907999948, 54.744721578000096],
              [-7.566639363999855, 54.73867543600004],
              [-7.556149047999895, 54.73836537800007],
              [-7.543074910999849, 54.74167266900007],
              [-7.543023233999918, 54.74379140300003],
              [-7.5483975839999, 54.74720204700007],
              [-7.551704874999899, 54.75469513000009],
              [-7.549741170999937, 54.77960317000007],
              [-7.543384968999931, 54.793090719000034],
              [-7.470831258999908, 54.8452839160001],
              [-7.455069945999924, 54.86300893200003],
              [-7.444734659999909, 54.88445465100007],
              [-7.444734659999909, 54.89489329100009],
              [-7.448972126999877, 54.9203180950001],
              [-7.445251423999878, 54.932151998],
              [-7.436983194999925, 54.93830149400007],
              [-7.417139444999918, 54.94305572600008],
              [-7.415755225999874, 54.94437242200003],
              [-7.408664510999927, 54.951117248000074],
              [-7.407424275999887, 54.95943715500003],
              [-7.413108682999848, 54.98496531200006],
              [-7.409077921999938, 54.9920449830001],
              [-7.403755248999886, 54.99313018900007],
              [-7.401119750999953, 54.99483551100006],
              [-7.405253865999896, 55.003568827000024],
              [-7.376986856999906, 55.028890279],
              [-7.366961629999906, 55.035556540000115],
              [-7.355024372999935, 55.04093088800006],
              [-7.291152302999905, 55.0466152960001],
              [-7.282987426999881, 55.05183461600005],
              [-7.275287638999885, 55.05886261000005],
              [-7.266502644999889, 55.06516713500007],
              [-7.247100389999957, 55.06932200700004],
            ],
          ],
          [
            [
              [-2.665353969999956, 51.617254950000074],
              [-2.693755662999934, 51.59617747600004],
              [-2.71312415299991, 51.58661530200004],
              [-2.760487433999913, 51.579779364000046],
              [-2.798085089999915, 51.56350332200009],
              [-2.816395636999914, 51.555568752000056],
              [-2.858713344999956, 51.546128648000035],
              [-2.943348761999914, 51.54254791900007],
              [-2.956288214999915, 51.54572174700007],
              [-2.964100714999915, 51.552801825000074],
              [-2.969471808999913, 51.559881903000075],
              [-2.974680141999954, 51.56297435100004],
              [-2.984038865999935, 51.55853913000004],
              [-3.010243292999917, 51.53803131700005],
              [-3.015695766999954, 51.53164297100005],
              [-3.073719855999911, 51.50836823100008],
              [-3.07648678299995, 51.50775788000004],
              [-3.088937954999949, 51.505072333000044],
              [-3.105620897999927, 51.49721914300005],
              [-3.131703253999945, 51.48041413000004],
              [-3.13508053299995, 51.47630442900004],
              [-3.14093990799995, 51.46478913000004],
              [-3.145375128999945, 51.45994700700004],
              [-3.152414516999954, 51.45718008000006],
              [-3.16665605399993, 51.45600006700005],
              [-3.172393357999908, 51.45327383000006],
              [-3.172718878999945, 51.453111070000034],
              [-3.160064256999931, 51.43183014500005],
              [-3.167144334999932, 51.41046784100007],
              [-3.184803839999915, 51.39760976800005],
              [-3.204009568999936, 51.401597398000035],
              [-3.218861456999946, 51.402777411000045],
              [-3.289418097999942, 51.38422272300005],
              [-3.539173956999946, 51.398504950000074],
              [-3.557443813999953, 51.40509674700007],
              [-3.575306769999941, 51.420436916000085],
              [-3.604725714999915, 51.44570547100005],
              [-3.663197394999941, 51.476223049000055],
              [-3.676991339999915, 51.47703685100004],
              [-3.695423956999946, 51.47150299700007],
              [-3.717925584999932, 51.478583075000074],
              [-3.737619594999956, 51.49087148600006],
              [-3.748036261999914, 51.50092194200005],
              [-3.749419725999928, 51.50535716400009],
              [-3.747670050999943, 51.507025458000044],
              [-3.744536912999934, 51.50763580900008],
              [-3.741851365999935, 51.50836823100008],
              [-3.749338344999956, 51.52806224200003],
              [-3.751901821999923, 51.53306712400007],
              [-3.758941209999932, 51.54677969000005],
              [-3.770130988999938, 51.56329987200007],
              [-3.782215949999909, 51.57664622600004],
              [-3.790272589999915, 51.58197663000004],
              [-3.807728644999941, 51.589178778000075],
              [-3.816965298999946, 51.59650299700007],
              [-3.83267167899993, 51.61554596600007],
              [-3.841623501999948, 51.621527411000045],
              [-3.854888475999928, 51.62384674700007],
              [-3.886789516999954, 51.62140534100007],
              [-3.962391730999911, 51.61562734600005],
              [-3.976633266999954, 51.61188385600008],
              [-3.989979620999918, 51.60651276200008],
              [-3.998768683999913, 51.60028717700004],
              [-3.999908006999931, 51.59088776200008],
              [-3.992258266999954, 51.58112213700008],
              [-3.981800910999937, 51.571600653000075],
              [-3.974598761999914, 51.56297435100004],
              [-4.016184048999946, 51.56297435100004],
              [-4.016102667999917, 51.56037018400008],
              [-4.020822719999956, 51.555853583000044],
              [-4.026519334999932, 51.554022528000075],
              [-4.029204881999931, 51.55927155200004],
              [-4.031971808999913, 51.56313711100006],
              [-4.038563605999911, 51.56622955900008],
              [-4.046457485999952, 51.568426825000074],
              [-4.053130662999934, 51.569240627000056],
              [-4.056304490999935, 51.56704336100006],
              [-4.065581834999932, 51.55756256700005],
              [-4.070220506999931, 51.555568752000056],
              [-4.07681230399993, 51.55695221600007],
              [-4.087269660999937, 51.56191640800006],
              [-4.112131313999953, 51.565619208000044],
              [-4.121652798999946, 51.56598541900007],
              [-4.132191535999937, 51.56297435100004],
              [-4.142730272999927, 51.55695221600007],
              [-4.156809048999946, 51.54629140800006],
              [-4.166411912999934, 51.54254791900007],
              [-4.176503058999913, 51.544256903000075],
              [-4.18773352799991, 51.54877350500004],
              [-4.196766730999911, 51.54938385600008],
              [-4.200550910999937, 51.538763739000046],
              [-4.213368292999917, 51.539129950000074],
              [-4.272450324999909, 51.554754950000074],
              [-4.289906378999945, 51.555568752000056],
              [-4.293324347999942, 51.55914948100008],
              [-4.29515540299991, 51.56195709800005],
              [-4.297352667999917, 51.569240627000056],
              [-4.278309699999909, 51.578192450000074],
              [-4.280832485999952, 51.58881256700005],
              [-4.28970292899993, 51.601548570000034],
              [-4.289906378999945, 51.61701080900008],
              [-4.255767381999931, 51.62384674700007],
              [-4.252023891999954, 51.62710195500006],
              [-4.241281704999949, 51.63934967700004],
              [-4.234730597999942, 51.644964911000045],
              [-4.228505011999914, 51.63743724200003],
              [-4.234730597999942, 51.63743724200003],
              [-4.234730597999942, 51.631293036000045],
              [-4.227853969999956, 51.628119208000044],
              [-4.22101803299995, 51.62384674700007],
              [-4.19009355399993, 51.63027578300006],
              [-4.139027472999942, 51.63231028900009],
              [-4.091297980999911, 51.639878648000035],
              [-4.070220506999931, 51.66229889500005],
              [-4.069813605999911, 51.66893138200004],
              [-4.070383266999954, 51.67430247600004],
              [-4.07054602799991, 51.67597077000005],
              [-4.075428839999915, 51.677801825000074],
              [-4.087269660999937, 51.668850002000056],
              [-4.095448370999918, 51.66510651200008],
              [-4.106841600999928, 51.66425202000005],
              [-4.146351691999939, 51.66705963700008],
              [-4.200550910999937, 51.68585846600007],
              [-4.214955206999946, 51.679673570000034],
              [-4.293690558999913, 51.67226797100005],
              [-4.315297003999945, 51.67747630400004],
              [-4.342355923999946, 51.69086334800005],
              [-4.366444464999915, 51.70848216400009],
              [-4.379261847999942, 51.72687409100007],
              [-4.338042772999927, 51.72333405200004],
              [-4.319976365999935, 51.72483958500004],
              [-4.310454881999931, 51.733710028000075],
              [-4.328724738999938, 51.73297760600008],
              [-4.347157355999911, 51.73578522300005],
              [-4.362538214999915, 51.74286530200004],
              [-4.371815558999913, 51.754787502000056],
              [-4.368763800999943, 51.75698476800005],
              [-4.362904425999943, 51.76386139500005],
              [-4.358021613999938, 51.773138739000046],
              [-4.358225063999953, 51.782131252000056],
              [-4.365101691999939, 51.789048570000034],
              [-4.371490037999934, 51.78595612200007],
              [-4.379261847999942, 51.77529531500005],
              [-4.384917772999927, 51.77187734600005],
              [-4.392974412999934, 51.763739325000074],
              [-4.399159308999913, 51.76162344000005],
              [-4.409331834999932, 51.76316966400009],
              [-4.417876756999931, 51.76788971600007],
              [-4.426503058999913, 51.77529531500005],
              [-4.445790167999917, 51.77326080900008],
              [-4.449330206999946, 51.76630280200004],
              [-4.441395636999914, 51.75678131700005],
              [-4.426503058999913, 51.747300523000035],
              [-4.460764126999948, 51.73578522300005],
              [-4.498890753999945, 51.73484935100004],
              [-4.574208136999914, 51.74115631700005],
              [-4.603423631999931, 51.73924388200004],
              [-4.639230923999946, 51.73318105700008],
              [-4.645375128999945, 51.732123114000046],
              [-4.678212042999917, 51.71743398600006],
              [-4.680287238999938, 51.692694403000075],
              [-4.689442511999914, 51.69159577000005],
              [-4.69163977799991, 51.689886786000045],
              [-4.69163977799991, 51.685980536000045],
              [-4.693959113999938, 51.67841217700004],
              [-4.712310350999928, 51.650091864000046],
              [-4.721424933999913, 51.652044989000046],
              [-4.734934048999946, 51.65924713700008],
              [-4.741851365999935, 51.65607330900008],
              [-4.759185350999928, 51.644964911000045],
              [-4.84829667899993, 51.64630768400008],
              [-4.86351477799991, 51.64411041900007],
              [-4.878977016999954, 51.63743724200003],
              [-4.887806769999941, 51.62995026200008],
              [-4.895741339999915, 51.621079820000034],
              [-4.904774542999917, 51.61383698100008],
              [-4.923695441999939, 51.608628648000035],
              [-4.931996222999942, 51.59902578300006],
              [-4.941029425999943, 51.59650299700007],
              [-4.946034308999913, 51.59760163000004],
              [-4.956450975999928, 51.602769273000035],
              [-5.021595831999946, 51.61603424700007],
              [-5.045765753999945, 51.62689850500004],
              [-5.036610480999911, 51.63743724200003],
              [-5.051177537999934, 51.65692780200004],
              [-5.100493943999936, 51.66469961100006],
              [-5.119740363999938, 51.67841217700004],
              [-5.113433397999927, 51.68528880400004],
              [-5.036610480999911, 51.67841217700004],
              [-5.038726365999935, 51.68183014500005],
              [-5.04133053299995, 51.68939850500004],
              [-5.043446417999917, 51.692694403000075],
              [-5.028675910999937, 51.69293854400007],
              [-5.002552863999938, 51.68740469000005],
              [-4.988189256999931, 51.68585846600007],
              [-4.974598761999914, 51.687933661000045],
              [-4.941029425999943, 51.70014069200005],
              [-4.892648891999954, 51.706366278000075],
              [-4.868275519999941, 51.716782945000034],
              [-4.85806230399993, 51.71832916900007],
              [-4.844838019999941, 51.71381256700005],
              [-4.844838019999941, 51.720038153000075],
              [-4.873402472999942, 51.73773834800005],
              [-4.879017706999946, 51.76203034100007],
              [-4.862538214999915, 51.78237539300005],
              [-4.824330206999946, 51.788275458000044],
              [-4.824330206999946, 51.79572174700007],
              [-4.836008266999954, 51.790716864000046],
              [-4.864979620999918, 51.783270575000074],
              [-4.921294725999928, 51.78001536700003],
              [-4.933583136999914, 51.77529531500005],
              [-4.917225714999915, 51.77533600500004],
              [-4.905181443999936, 51.771185614000046],
              [-4.900542772999927, 51.76211172100005],
              [-4.906239386999914, 51.747300523000035],
              [-4.892079230999911, 51.73940664300005],
              [-4.895659959999932, 51.728176174000055],
              [-4.910552537999934, 51.71820709800005],
              [-4.988189256999931, 51.70685455900008],
              [-5.009917772999927, 51.706366278000075],
              [-5.149240688999953, 51.718085028000075],
              [-5.166900193999936, 51.71381256700005],
              [-5.156971808999913, 51.69757721600007],
              [-5.16860917899993, 51.68891022300005],
              [-5.182850714999915, 51.68927643400008],
              [-5.180653449999909, 51.70014069200005],
              [-5.180653449999909, 51.706366278000075],
              [-5.230132615999935, 51.73004791900007],
              [-5.249501105999911, 51.733710028000075],
              [-5.228138800999943, 51.73395416900007],
              [-5.213937954999949, 51.73574453300006],
              [-5.202870245999918, 51.74079010600008],
              [-5.191151495999918, 51.75104401200008],
              [-5.176828579999949, 51.75967031500005],
              [-5.14321855399993, 51.76386139500005],
              [-5.125965949999909, 51.76850006700005],
              [-5.110259568999936, 51.778509833000044],
              [-5.107085740999935, 51.78807200700004],
              [-5.112294074999909, 51.81317780200004],
              [-5.113392706999946, 51.82880280200004],
              [-5.11750240799995, 51.84369538000004],
              [-5.125884568999936, 51.85602448100008],
              [-5.139637824999909, 51.86399974200003],
              [-5.146473761999914, 51.85716380400004],
              [-5.16437740799995, 51.86676666900007],
              [-5.20376542899993, 51.87018463700008],
              [-5.221587693999936, 51.87767161700003],
              [-5.235829230999911, 51.87103913000004],
              [-5.291411912999934, 51.86399974200003],
              [-5.310943162999934, 51.86399974200003],
              [-5.304269985999952, 51.867621161000045],
              [-5.297352667999917, 51.87018463700008],
              [-5.297352667999917, 51.87767161700003],
              [-5.300689256999931, 51.882025458000044],
              [-5.302561001999948, 51.88523997600004],
              [-5.300160285999937, 51.888332424000055],
              [-5.290516730999911, 51.89199453300006],
              [-5.290516730999911, 51.898138739000046],
              [-5.298329230999911, 51.91095612200007],
              [-5.288929816999939, 51.91693756700005],
              [-5.252837693999936, 51.91864655200004],
              [-5.234201626999948, 51.923041083000044],
              [-5.204172329999949, 51.942287502000056],
              [-5.191151495999918, 51.946600653000075],
              [-5.16038977799991, 51.94944896000004],
              [-5.119536912999934, 51.95892975500004],
              [-5.088042772999927, 51.97601959800005],
              [-5.085031704999949, 52.00185781500005],
              [-5.070790167999917, 52.00185781500005],
              [-5.070790167999917, 52.00804271000004],
              [-5.082753058999913, 52.01447174700007],
              [-5.081206834999932, 52.021185614000046],
              [-5.070220506999931, 52.02635325700004],
              [-5.053700324999909, 52.028509833000044],
              [-5.026600714999915, 52.027411200000074],
              [-5.015044725999928, 52.02533600500004],
              [-4.961740688999953, 52.007513739000046],
              [-4.942534959999932, 52.007473049000055],
              [-4.913685675999943, 52.014837958000044],
              [-4.920521613999938, 52.028509833000044],
              [-4.901600714999915, 52.02643463700008],
              [-4.863189256999931, 52.01699453300006],
              [-4.841420050999943, 52.014837958000044],
              [-4.83226477799991, 52.01898834800005],
              [-4.833851691999939, 52.02875397300005],
              [-4.838286912999934, 52.04010651200008],
              [-4.838002081999946, 52.04901764500005],
              [-4.83039303299995, 52.05292389500005],
              [-4.796986456999946, 52.05646393400008],
              [-4.77757727799991, 52.064886786000045],
              [-4.763172980999911, 52.075873114000046],
              [-4.738677537999934, 52.100816148000035],
              [-4.720285610999952, 52.113348700000074],
              [-4.706532355999911, 52.11347077000005],
              [-4.673451300999943, 52.09739817900004],
              [-4.675689256999931, 52.126939195000034],
              [-4.637521938999953, 52.13849518400008],
              [-4.513824022999927, 52.13568756700005],
              [-4.50226803299995, 52.138373114000046],
              [-4.495757615999935, 52.14350006700005],
              [-4.490956183999913, 52.150376695000034],
              [-4.484283006999931, 52.156317450000074],
              [-4.454701300999943, 52.16205475500004],
              [-4.434803839999915, 52.170355536000045],
              [-4.415394660999937, 52.18154531500005],
              [-4.385568813999953, 52.20343659100007],
              [-4.371245897999927, 52.20929596600007],
              [-4.354725714999915, 52.212103583000044],
              [-4.334339972999942, 52.21283600500004],
              [-4.315825975999928, 52.21629466400003],
              [-4.197132941999939, 52.279282945000034],
              [-4.139068162999934, 52.33022695500006],
              [-4.10960852799991, 52.365301825000074],
              [-4.096262173999946, 52.387884833000044],
              [-4.087391730999911, 52.430121161000045],
              [-4.078968878999945, 52.45302969000005],
              [-4.067941860999952, 52.47361888200004],
              [-4.056548631999931, 52.48786041900007],
              [-4.061838344999956, 52.49705638200004],
              [-4.064035610999952, 52.50918203300006],
              [-4.062570766999954, 52.52098216400003],
              [-4.056548631999931, 52.52944570500006],
              [-4.048491990999935, 52.530462958000044],
              [-4.026600714999915, 52.52338288000004],
              [-4.016184048999946, 52.52195872600004],
              [-3.998768683999913, 52.52594635600008],
              [-3.947336391999954, 52.549261786000045],
              [-3.947336391999954, 52.556708075000074],
              [-3.974476691999939, 52.55654531500005],
              [-4.025868292999917, 52.545355536000045],
              [-4.053130662999934, 52.54242584800005],
              [-4.068470831999946, 52.550116278000075],
              [-4.114125128999945, 52.58860911700003],
              [-4.125477667999917, 52.60390859600005],
              [-4.122222459999932, 52.62872955900008],
              [-4.105946417999917, 52.653509833000044],
              [-4.084828253999945, 52.67267487200007],
              [-4.067128058999913, 52.68024323100008],
              [-4.063547329999949, 52.68309153900003],
              [-4.05882727799991, 52.696600653000075],
              [-4.056548631999931, 52.70066966400003],
              [-4.052723761999914, 52.70221588700008],
              [-4.041981574999909, 52.70465729400007],
              [-4.001088019999941, 52.72410716400003],
              [-3.988270636999914, 52.73427969000005],
              [-4.014719204999949, 52.73232656500005],
              [-4.031971808999913, 52.723944403000075],
              [-4.048817511999914, 52.721584377000056],
              [-4.125152147999927, 52.77830638200004],
              [-4.144357876999948, 52.802801825000074],
              [-4.149037238999938, 52.81207916900007],
              [-4.146229620999918, 52.82021719000005],
              [-4.128895636999914, 52.82363515800006],
              [-4.117339647999927, 52.83075592700004],
              [-4.11978105399993, 52.84625885600008],
              [-4.127756313999953, 52.86172109600005],
              [-4.132191535999937, 52.86831289300005],
              [-4.131988084999932, 52.882473049000055],
              [-4.129872199999909, 52.88922760600008],
              [-4.123605923999946, 52.89325592700004],
              [-4.064035610999952, 52.919175523000035],
              [-4.071400519999941, 52.921087958000044],
              [-4.074574347999942, 52.92279694200005],
              [-4.077626105999911, 52.926662502000056],
              [-4.089100714999915, 52.918850002000056],
              [-4.100493943999936, 52.914129950000074],
              [-4.110585089999915, 52.915676174000055],
              [-4.118560350999928, 52.926662502000056],
              [-4.144398566999939, 52.91478099200003],
              [-4.171620245999918, 52.91347890800006],
              [-4.228505011999914, 52.919175523000035],
              [-4.300689256999931, 52.905585028000075],
              [-4.317290818999936, 52.89935944200005],
              [-4.337310350999928, 52.89203522300005],
              [-4.406605597999942, 52.89252350500004],
              [-4.427235480999911, 52.885972398000035],
              [-4.446197068999936, 52.87592194200005],
              [-4.481678839999915, 52.850897528000075],
              [-4.477935350999928, 52.84833405200004],
              [-4.475493943999936, 52.84414297100005],
              [-4.491363084999932, 52.83820221600007],
              [-4.500965949999909, 52.82680898600006],
              [-4.501332160999937, 52.81391022300005],
              [-4.489125128999945, 52.803168036000045],
              [-4.501942511999914, 52.794989325000074],
              [-4.509185350999928, 52.791449286000045],
              [-4.516468878999945, 52.789496161000045],
              [-4.528553839999915, 52.79047272300005],
              [-4.542469855999911, 52.80068594000005],
              [-4.563954230999911, 52.80524323100008],
              [-4.583078579999949, 52.81464264500005],
              [-4.594634568999936, 52.81679922100005],
              [-4.606516079999949, 52.81509023600006],
              [-4.61351477799991, 52.81110260600008],
              [-4.619211391999954, 52.80654531500005],
              [-4.626332160999937, 52.803168036000045],
              [-4.648589647999927, 52.79962799700007],
              [-4.704497850999928, 52.803168036000045],
              [-4.719309048999946, 52.79751211100006],
              [-4.733225063999953, 52.78750234600005],
              [-4.747425910999937, 52.78343333500004],
              [-4.762847459999932, 52.789496161000045],
              [-4.752512173999946, 52.79877350500004],
              [-4.751454230999911, 52.80320872600004],
              [-4.755441860999952, 52.80931224200003],
              [-4.749256964999915, 52.81427643400008],
              [-4.734934048999946, 52.83047109600005],
              [-4.596058722999942, 52.92841217700004],
              [-4.580962693999936, 52.93349844000005],
              [-4.562082485999952, 52.93451569200005],
              [-4.543527798999946, 52.937933661000045],
              [-4.523996548999946, 52.944240627000056],
              [-4.443430141999954, 52.98216380400004],
              [-4.423695441999939, 53.00263092700004],
              [-4.358225063999953, 53.02846914300005],
              [-4.349964972999942, 53.04148997600004],
              [-4.345692511999914, 53.059475002000056],
              [-4.343861456999946, 53.10106028900003],
              [-4.340891079999949, 53.11273834800005],
              [-4.334339972999942, 53.11676666900007],
              [-4.327626105999911, 53.11469147300005],
              [-4.324696417999917, 53.10789622600004],
              [-4.320668097999942, 53.10150788000004],
              [-4.312245245999918, 53.109442450000074],
              [-4.304758266999954, 53.12099844000005],
              [-4.303618943999936, 53.12531159100007],
              [-4.263539191999939, 53.15452708500004],
              [-4.252349412999934, 53.159409898000035],
              [-4.234527147999927, 53.16400788000004],
              [-4.221302863999938, 53.175034898000035],
              [-4.200550910999937, 53.20099518400008],
              [-4.17796790299991, 53.21759674700007],
              [-4.151519334999932, 53.22809479400007],
              [-4.122222459999932, 53.23346588700008],
              [-4.090687628999945, 53.23517487200007],
              [-4.08234615799995, 53.23354726800005],
              [-4.074330206999946, 53.23065827000005],
              [-4.066883917999917, 53.22907135600008],
              [-4.054107225999928, 53.234361070000034],
              [-4.032297329999949, 53.24070872600004],
              [-4.008900519999941, 53.24445221600007],
              [-3.974598761999914, 53.261786200000074],
              [-3.865305141999954, 53.289129950000074],
              [-3.831288214999915, 53.289129950000074],
              [-3.841420050999943, 53.30744049700007],
              [-3.870757615999935, 53.32562897300005],
              [-3.878407355999911, 53.337591864000046],
              [-3.859974738999938, 53.33633047100005],
              [-3.840565558999913, 53.33283112200007],
              [-3.822987433999913, 53.32656484600005],
              [-3.810129360999952, 53.31708405200004],
              [-3.790516730999911, 53.323431708000044],
              [-3.768869594999956, 53.31915924700007],
              [-3.748199022999927, 53.307806708000044],
              [-3.731922980999911, 53.29287344000005],
              [-3.716297980999911, 53.28693268400008],
              [-3.60220292899993, 53.28888580900008],
              [-3.562326626999948, 53.29441966400003],
              [-3.372059699999909, 53.350897528000075],
              [-3.33031165299991, 53.35179271000004],
              [-3.292388475999928, 53.34052155200004],
              [-3.271311001999948, 53.33055247600004],
              [-3.262074347999942, 53.32050202000005],
              [-3.250803188999953, 53.312567450000074],
              [-3.122222459999932, 53.26227448100008],
              [-3.107533331999946, 53.25189850500004],
              [-3.095122850999928, 53.23932526200008],
              [-3.087757941999939, 53.23468659100007],
              [-3.084543423999946, 53.23859284100007],
              [-3.084543423999946, 53.25857717900004],
              [-3.084543423999946, 53.275458075000074],
              [-3.09593665299991, 53.28713613500008],
              [-3.111195441999939, 53.302801825000074],
              [-3.13540605399993, 53.33380768400008],
              [-3.171538865999935, 53.36225006700005],
              [-3.185210740999935, 53.37726471600007],
              [-3.186350063999953, 53.39276764500005],
              [-3.175526495999918, 53.40273672100005],
              [-3.157297329999949, 53.40875885600008],
              [-3.114654100999928, 53.41266510600008],
              [-3.094227667999917, 53.41738515800006],
              [-3.058257615999935, 53.434759833000044],
              [-3.035552537999934, 53.43374258000006],
              [-3.012196417999917, 53.41669342700004],
              [-2.952951626999948, 53.323919989000046],
              [-2.935129360999952, 53.309475002000056],
              [-2.910552537999934, 53.29633209800005],
              [-2.88149980399993, 53.288397528000075],
              [-2.850575324999909, 53.289129950000074],
              [-2.849598761999914, 53.29120514500005],
              [-2.848378058999913, 53.29555898600006],
              [-2.844960089999915, 53.300116278000075],
              [-2.837554490999935, 53.302801825000074],
              [-2.828602667999917, 53.302435614000046],
              [-2.813384568999936, 53.297756252000056],
              [-2.806141730999911, 53.296576239000046],
              [-2.789784308999913, 53.29743073100008],
              [-2.775502081999946, 53.29987213700008],
              [-2.748117641999954, 53.30963776200008],
              [-2.753651495999918, 53.32245514500005],
              [-2.750884568999936, 53.33161041900007],
              [-2.743153449999909, 53.33852773600006],
              [-2.734486456999946, 53.34442780200004],
              [-2.726144985999952, 53.34198639500005],
              [-2.71743730399993, 53.34271881700005],
              [-2.708607550999943, 53.346136786000045],
              [-2.699777798999946, 53.35179271000004],
              [-2.714100714999915, 53.35236237200007],
              [-2.764393683999913, 53.34516022300005],
              [-2.775380011999914, 53.341009833000044],
              [-2.782378709999932, 53.32636139500005],
              [-2.799794074999909, 53.32103099200003],
              [-2.810332811999956, 53.32172272300005],
              [-2.843658006999931, 53.323919989000046],
              [-2.886463995999918, 53.33356354400007],
              [-2.924956834999932, 53.35000234600005],
              [-2.956939256999931, 53.37055084800005],
              [-2.980824347999942, 53.39276764500005],
              [-3.096587693999936, 53.54433828300006],
              [-3.101918097999942, 53.55805084800005],
              [-3.099476691999939, 53.57200755400004],
              [-3.087635870999918, 53.58771393400008],
              [-3.021839972999942, 53.65281810100004],
              [-2.968658006999931, 53.69403717700004],
              [-2.960357225999928, 53.69757721600007],
              [-2.951730923999946, 53.70807526200008],
              [-2.911447719999956, 53.725043036000045],
              [-2.899037238999938, 53.73541901200008],
              [-2.984852667999917, 53.73607005400004],
              [-3.021473761999914, 53.745794989000046],
              [-3.049183722999942, 53.769517320000034],
              [-3.056385870999918, 53.80304596600007],
              [-3.044911261999914, 53.87848541900007],
              [-3.056630011999914, 53.90615469000005],
              [-3.040679490999935, 53.923529364000046],
              [-3.017567511999914, 53.93195221600007],
              [-2.925689256999931, 53.95270416900007],
              [-2.909250454999949, 53.95384349200003],
              [-2.896107550999943, 53.94773997600004],
              [-2.888539191999939, 53.94603099200003],
              [-2.885365363999938, 53.950506903000075],
              [-2.881988084999932, 53.95652903900003],
              [-2.874175584999932, 53.96165599200003],
              [-2.865142381999931, 53.96548086100006],
              [-2.857980923999946, 53.96759674700007],
              [-2.869252081999946, 53.97882721600007],
              [-2.834462042999917, 53.99982330900008],
              [-2.830067511999914, 54.01601797100005],
              [-2.847523566999939, 54.00836823100008],
              [-2.864857550999943, 54.00429922100005],
              [-2.895497199999909, 54.00234609600005],
              [-2.900298631999931, 54.00495026200008],
              [-2.916086391999954, 54.026556708000044],
              [-2.91820227799991, 54.03432851800005],
              [-2.911284959999932, 54.03998444200005],
              [-2.900786912999934, 54.044907945000034],
              [-2.892079230999911, 54.050116278000075],
              [-2.872670050999943, 54.071600653000075],
              [-2.858876105999911, 54.08100006700005],
              [-2.826771613999938, 54.08881256700005],
              [-2.815174933999913, 54.09878164300005],
              [-2.795969204999949, 54.12518952000005],
              [-2.81281490799995, 54.139878648000035],
              [-2.836415167999917, 54.16758860900006],
              [-2.850941535999937, 54.18463776200008],
              [-2.854237433999913, 54.19407786700003],
              [-2.832875128999945, 54.19904205900008],
              [-2.810292120999918, 54.21190013200004],
              [-2.79523678299995, 54.22947825700004],
              [-2.795969204999949, 54.24872467700004],
              [-2.802805141999954, 54.24872467700004],
              [-2.806630011999914, 54.233710028000075],
              [-2.820871548999946, 54.22174713700008],
              [-2.850575324999909, 54.20774974200003],
              [-2.886382615999935, 54.19627513200004],
              [-2.904652472999942, 54.18764883000006],
              [-2.912668423999946, 54.176988023000035],
              [-2.920399542999917, 54.16205475500004],
              [-2.939198370999918, 54.15509674700007],
              [-2.984201626999948, 54.15314362200007],
              [-2.997710740999935, 54.15957265800006],
              [-3.011341925999943, 54.17413971600007],
              [-3.017323370999918, 54.19009023600006],
              [-3.008168097999942, 54.20034414300005],
              [-3.015370245999918, 54.21190013200004],
              [-3.024484829999949, 54.221584377000056],
              [-3.035755988999938, 54.22597890800006],
              [-3.049183722999942, 54.22207265800006],
              [-3.044667120999918, 54.208319403000075],
              [-3.047840949999909, 54.19432200700004],
              [-3.053537563999953, 54.181301174000055],
              [-3.056630011999914, 54.17023346600007],
              [-3.061024542999917, 54.16193268400008],
              [-3.090728318999936, 54.13947174700007],
              [-3.10765540299991, 54.11855703300006],
              [-3.117909308999913, 54.10883209800005],
              [-3.145253058999913, 54.100043036000045],
              [-3.147450324999909, 54.08869049700007],
              [-3.144398566999939, 54.07514069200005],
              [-3.145375128999945, 54.063788153000075],
              [-3.180531378999945, 54.09284088700008],
              [-3.18976803299995, 54.09788646000004],
              [-3.20571855399993, 54.098537502000056],
              [-3.219553188999953, 54.100775458000044],
              [-3.23110917899993, 54.105129299000055],
              [-3.240956183999913, 54.11212799700007],
              [-3.238107876999948, 54.12759023600006],
              [-3.232533331999946, 54.14468008000006],
              [-3.233143683999913, 54.15916575700004],
              [-3.248402472999942, 54.16681549700007],
              [-3.248402472999942, 54.17365143400008],
              [-3.215199347999942, 54.17983633000006],
              [-3.206776495999918, 54.20892975500004],
              [-3.209055141999954, 54.24274323100008],
              [-3.207386847999942, 54.263006903000075],
              [-3.223133917999917, 54.25763580900008],
              [-3.231353318999936, 54.24721914300005],
              [-3.240956183999913, 54.22207265800006],
              [-3.232167120999918, 54.20254140800006],
              [-3.247141079999949, 54.19794342700004],
              [-3.270130988999938, 54.19912344000005],
              [-3.286000128999945, 54.19721100500004],
              [-3.306792772999927, 54.19188060100004],
              [-3.328521287999934, 54.204738674000055],
              [-3.364491339999915, 54.24249909100007],
              [-3.394195115999935, 54.26439036700003],
              [-3.407378709999932, 54.27773672100005],
              [-3.412912563999953, 54.29376862200007],
              [-3.41038977799991, 54.30145905200004],
              [-3.405995245999918, 54.30963776200008],
              [-3.404123501999948, 54.31854889500005],
              [-3.411447719999956, 54.33274974200003],
              [-3.413441535999937, 54.342962958000044],
              [-3.41633053299995, 54.344916083000044],
              [-3.440174933999913, 54.35175202000005],
              [-3.474273240999935, 54.39350006700005],
              [-3.497710740999935, 54.40582916900007],
              [-3.591867641999954, 54.48309967700004],
              [-3.608143683999913, 54.488267320000034],
              [-3.613189256999931, 54.49164459800005],
              [-3.62368730399993, 54.50608958500004],
              [-3.634185350999928, 54.512884833000044],
              [-3.626820441999939, 54.520412502000056],
              [-3.616200324999909, 54.52757396000004],
              [-3.61156165299991, 54.52993398600006],
              [-3.590321417999917, 54.56464264500005],
              [-3.563832160999937, 54.64276764500005],
              [-3.530140753999945, 54.68805573100008],
              [-3.516021287999934, 54.712876695000034],
              [-3.509185350999928, 54.72166575700004],
              [-3.500721808999913, 54.72597890800006],
              [-3.478871222999942, 54.730902411000045],
              [-3.468129035999937, 54.73529694200005],
              [-3.455433722999942, 54.745021877000056],
              [-3.439564581999946, 54.76146067900004],
              [-3.430978969999956, 54.780462958000044],
              [-3.440174933999913, 54.79743073100008],
              [-3.407541469999956, 54.85602448100008],
              [-3.387928839999915, 54.88336823100008],
              [-3.364491339999915, 54.89980703300006],
              [-3.344960089999915, 54.90253327000005],
              [-3.333363410999937, 54.89728424700007],
              [-3.322743292999917, 54.889878648000035],
              [-3.306467251999948, 54.88617584800005],
              [-3.295725063999953, 54.88690827000005],
              [-3.254628058999913, 54.89980703300006],
              [-3.267323370999918, 54.905503648000035],
              [-3.317290818999936, 54.92031484600005],
              [-3.291493292999917, 54.93667226800005],
              [-3.276519334999932, 54.943426825000074],
              [-3.213612433999913, 54.954413153000075],
              [-3.201039191999939, 54.95221588700008],
              [-3.19367428299995, 54.94863515800006],
              [-3.187977667999917, 54.94448476800005],
              [-3.180165167999917, 54.94082265800006],
              [-3.14281165299991, 54.93353913000004],
              [-3.122792120999918, 54.93268463700008],
              [-3.039540167999917, 54.94717031500005],
              [-3.021839972999942, 54.954413153000075],
              [-3.090728318999936, 54.954413153000075],
              [-3.090728318999936, 54.96124909100007],
              [-3.071522589999915, 54.96312083500004],
              [-3.056223110999952, 54.968817450000074],
              [-3.040923631999931, 54.97247955900008],
              [-3.021839972999942, 54.968085028000075],
              [-3.021839972999942, 54.97553131700005],
              [-3.046294725999928, 54.982123114000046],
              [-3.05029137799994, 54.981510325000045],
              [-3.13540605399993, 54.968085028000075],
              [-3.453846808999913, 54.981756903000075],
              [-3.470692511999914, 54.984442450000074],
              [-3.486236131999931, 54.989488023000035],
              [-3.501047329999949, 54.99249909100007],
              [-3.515288865999935, 54.98920319200005],
              [-3.51235917899993, 54.98712799700007],
              [-3.511463995999918, 54.98688385600008],
              [-3.510894334999932, 54.985988674000055],
              [-3.509185350999928, 54.981756903000075],
              [-3.52603105399993, 54.97711823100008],
              [-3.541859503999945, 54.98065827000005],
              [-3.57054602799991, 54.995428778000075],
              [-3.583607550999943, 54.968085028000075],
              [-3.575672980999911, 54.95734284100007],
              [-3.57062740799995, 54.937567450000074],
              [-3.568755662999934, 54.916001695000034],
              [-3.57054602799991, 54.89980703300006],
              [-3.581695115999935, 54.88361237200007],
              [-3.598378058999913, 54.87799713700008],
              [-3.691761847999942, 54.88320547100005],
              [-3.717640753999945, 54.880845445000034],
              [-3.739247199999909, 54.859808661000045],
              [-3.810129360999952, 54.86627838700008],
              [-3.807850714999915, 54.86107005400004],
              [-3.806792772999927, 54.86090729400007],
              [-3.803334113999938, 54.85887278900003],
              [-3.812367316999939, 54.855169989000046],
              [-3.819813605999911, 54.855902411000045],
              [-3.826079881999931, 54.85993073100008],
              [-3.831288214999915, 54.86627838700008],
              [-3.819976365999935, 54.878566799000055],
              [-3.815052863999938, 54.87714264500005],
              [-3.810129360999952, 54.87250397300005],
              [-3.811634894999941, 54.88003164300005],
              [-3.813221808999913, 54.88312409100007],
              [-3.816965298999946, 54.88617584800005],
              [-3.828846808999913, 54.874986070000034],
              [-3.844309048999946, 54.86627838700008],
              [-3.839751756999931, 54.855902411000045],
              [-3.837473110999952, 54.851996161000045],
              [-3.844105597999942, 54.85097890800006],
              [-3.857899542999917, 54.84454987200007],
              [-3.823841925999943, 54.82469310100004],
              [-3.833607550999943, 54.82005442900004],
              [-3.885731574999909, 54.80646393400008],
              [-3.964182094999956, 54.771918036000045],
              [-4.011708136999914, 54.76821523600006],
              [-4.042876756999931, 54.76947663000004],
              [-4.042876756999931, 54.77692291900007],
              [-4.046783006999931, 54.77802155200004],
              [-4.050200975999928, 54.778550523000035],
              [-4.053334113999938, 54.77997467700004],
              [-4.055775519999941, 54.782538153000075],
              [-4.05296790299991, 54.78546784100007],
              [-4.050160285999937, 54.78900788000004],
              [-4.049712693999936, 54.78998444200005],
              [-4.051747199999909, 54.800034898000035],
              [-4.047718878999945, 54.81305573100008],
              [-4.049956834999932, 54.82322825700004],
              [-4.063588019999941, 54.82684967700004],
              [-4.064035610999952, 54.83152903900003],
              [-4.078602667999917, 54.82412344000005],
              [-4.09007727799991, 54.809759833000044],
              [-4.093495245999918, 54.792669989000046],
              [-4.083851691999939, 54.77692291900007],
              [-4.122954881999931, 54.77301666900007],
              [-4.173939581999946, 54.792303778000075],
              [-4.209136522999927, 54.826239325000074],
              [-4.200550910999937, 54.86627838700008],
              [-4.215402798999946, 54.861029364000046],
              [-4.239735480999911, 54.843003648000035],
              [-4.255767381999931, 54.838324286000045],
              [-4.270741339999915, 54.83942291900007],
              [-4.345285610999952, 54.86017487200007],
              [-4.356922980999911, 54.86554596600007],
              [-4.365630662999934, 54.87250397300005],
              [-4.375152147999927, 54.88690827000005],
              [-4.379872199999909, 54.89789459800005],
              [-4.386789516999954, 54.90477122600004],
              [-4.402902798999946, 54.90729401200008],
              [-4.409006313999953, 54.90302155200004],
              [-4.416818813999953, 54.89280833500004],
              [-4.423573370999918, 54.88035716400003],
              [-4.426503058999913, 54.86945221600007],
              [-4.417225714999915, 54.84593333500004],
              [-4.409413214999915, 54.831244208000044],
              [-4.402902798999946, 54.82469310100004],
              [-4.386708136999914, 54.82416413000004],
              [-4.372425910999937, 54.82184479400007],
              [-4.35960852799991, 54.81663646000004],
              [-4.347645636999914, 54.80731842700004],
              [-4.344471808999913, 54.79450104400007],
              [-4.353179490999935, 54.78310781500005],
              [-4.358143683999913, 54.77098216400003],
              [-4.343861456999946, 54.75641510600008],
              [-4.356516079999949, 54.741888739000046],
              [-4.353260870999918, 54.72089264500005],
              [-4.348133917999917, 54.70197174700007],
              [-4.354725714999915, 54.693793036000045],
              [-4.360340949999909, 54.69159577000005],
              [-4.365305141999954, 54.68695709800005],
              [-4.371896938999953, 54.68227773600006],
              [-4.382394985999952, 54.68008047100005],
              [-4.405262824999909, 54.682074286000045],
              [-4.426503058999913, 54.687567450000074],
              [-4.45181230399993, 54.69879791900007],
              [-4.46117102799991, 54.701239325000074],
              [-4.49673417899993, 54.70062897300005],
              [-4.505604620999918, 54.70465729400007],
              [-4.563628709999932, 54.75641510600008],
              [-4.596669074999909, 54.77529531500005],
              [-4.714466925999943, 54.81785716400003],
              [-4.759592251999948, 54.82534414300005],
              [-4.781076626999948, 54.83307526200008],
              [-4.799631313999953, 54.86127350500004],
              [-4.821034308999913, 54.86664459800005],
              [-4.859120245999918, 54.86627838700008],
              [-4.88304602799991, 54.86009349200003],
              [-4.905873175999943, 54.84979889500005],
              [-4.925770636999914, 54.83738841400003],
              [-4.941029425999943, 54.82469310100004],
              [-4.949615037999934, 54.81582265800006],
              [-4.953684048999946, 54.81000397300005],
              [-4.954823370999918, 54.804754950000074],
              [-4.954701300999943, 54.79743073100008],
              [-4.952870245999918, 54.78896719000005],
              [-4.94790605399993, 54.777329820000034],
              [-4.940256313999953, 54.76703522300005],
              [-4.930165167999917, 54.76264069200005],
              [-4.923247850999928, 54.75185781500005],
              [-4.911936001999948, 54.728216864000046],
              [-4.895985480999911, 54.70453522300005],
              [-4.867258266999954, 54.69013092700004],
              [-4.866932745999918, 54.68146393400008],
              [-4.872141079999949, 54.663316148000035],
              [-4.872425910999937, 54.65403880400004],
              [-4.872059699999909, 54.64923737200007],
              [-4.859120245999918, 54.63296133000006],
              [-4.880604620999918, 54.63621653900003],
              [-4.923491990999935, 54.649725653000075],
              [-4.944081183999913, 54.652777411000045],
              [-4.953684048999946, 54.65973541900007],
              [-4.959868943999936, 54.67552317900004],
              [-4.958973761999914, 54.69196198100008],
              [-4.947255011999914, 54.701239325000074],
              [-4.954823370999918, 54.707464911000045],
              [-4.958892381999931, 54.714056708000044],
              [-4.959055141999954, 54.72093333500004],
              [-4.954701300999943, 54.728501695000034],
              [-4.973378058999913, 54.729722398000035],
              [-4.981556769999941, 54.731634833000044],
              [-4.988189256999931, 54.73529694200005],
              [-4.992665167999917, 54.74433014500005],
              [-4.997059699999909, 54.75836823100008],
              [-5.003285285999937, 54.77130768400008],
              [-5.013010219999956, 54.77692291900007],
              [-5.033192511999914, 54.782416083000044],
              [-5.128244594999956, 54.848944403000075],
              [-5.157134568999936, 54.87909577000005],
              [-5.175526495999918, 54.91461823100008],
              [-5.180653449999909, 54.954413153000075],
              [-5.177601691999939, 54.99054596600007],
              [-5.170806443999936, 55.008693752000056],
              [-5.156727667999917, 55.01654694200005],
              [-5.135609503999945, 55.01585521000004],
              [-5.124582485999952, 55.016791083000044],
              [-5.119740363999938, 55.01992422100005],
              [-5.115142381999931, 55.03156159100007],
              [-5.105213995999918, 55.02619049700007],
              [-5.095529751999948, 55.01508209800005],
              [-5.091867641999954, 55.00971100500004],
              [-5.076893683999913, 54.99555084800005],
              [-5.069488084999932, 54.986029364000046],
              [-5.064564581999946, 54.97553131700005],
              [-5.063791469999956, 54.96458567900004],
              [-5.065256313999953, 54.940334377000056],
              [-5.06086178299995, 54.93113841400003],
              [-5.04751542899993, 54.92031484600005],
              [-5.030995245999918, 54.911322333000044],
              [-5.013091600999928, 54.90961334800005],
              [-4.995594855999911, 54.92031484600005],
              [-4.992298956999946, 54.924261786000045],
              [-4.988189256999931, 54.927720445000034],
              [-4.988189256999931, 54.93455638200004],
              [-5.02407792899993, 54.97638580900008],
              [-5.029774542999917, 54.98550039300005],
              [-5.032500779999907, 54.99371979400007],
              [-5.033029751999948, 54.99526601800005],
              [-5.047027147999927, 55.01508209800005],
              [-5.050282355999911, 55.02680084800005],
              [-5.049672003999945, 55.04897695500006],
              [-5.047596808999913, 55.05573151200008],
              [-5.043446417999917, 55.06427643400008],
              [-5.025786912999934, 55.08869049700007],
              [-5.018950975999928, 55.10224030200004],
              [-5.016184048999946, 55.12262604400007],
              [-5.007801886999914, 55.14118073100008],
              [-4.988270636999914, 55.15265534100007],
              [-4.947255011999914, 55.16791413000004],
              [-4.882394985999952, 55.21857330900008],
              [-4.877552863999938, 55.22089264500005],
              [-4.867258266999954, 55.22247955900008],
              [-4.865305141999954, 55.22565338700008],
              [-4.865589972999942, 55.236314195000034],
              [-4.864816860999952, 55.24135976800005],
              [-4.841949022999927, 55.275091864000046],
              [-4.838002081999946, 55.28400299700007],
              [-4.837228969999956, 55.293850002000056],
              [-4.839751756999931, 55.31557851800005],
              [-4.838002081999946, 55.32501862200007],
              [-4.832508917999917, 55.33112213700008],
              [-4.799224412999934, 55.354722398000035],
              [-4.781076626999948, 55.36351146000004],
              [-4.773101365999935, 55.36937083500004],
              [-4.767160610999952, 55.37905508000006],
              [-4.758778449999909, 55.40228913000004],
              [-4.749256964999915, 55.413763739000046],
              [-4.71703040299991, 55.43048737200007],
              [-4.650502081999946, 55.448472398000035],
              [-4.626332160999937, 55.468410549000055],
              [-4.617787238999938, 55.49559153900003],
              [-4.626779751999948, 55.51972077000005],
              [-4.650786912999934, 55.53705475500004],
              [-4.687163865999935, 55.544134833000044],
              [-4.66624915299991, 55.562201239000046],
              [-4.666493292999917, 55.56329987200007],
              [-4.671131964999915, 55.584418036000045],
              [-4.692738410999937, 55.60521067900004],
              [-4.721994594999956, 55.619208075000074],
              [-4.776519334999932, 55.632879950000074],
              [-4.808745897999927, 55.63361237200007],
              [-4.818104620999918, 55.63719310100004],
              [-4.810617641999954, 55.646551825000074],
              [-4.810617641999954, 55.653998114000046],
              [-4.868560350999928, 55.67560455900008],
              [-4.900990363999938, 55.69232819200005],
              [-4.920521613999938, 55.70856354400007],
              [-4.876332160999937, 55.735256252000056],
              [-4.861073370999918, 55.756740627000056],
              [-4.865305141999954, 55.79047272300005],
              [-4.87173417899993, 55.802435614000046],
              [-4.877797003999945, 55.81102122600004],
              [-4.882720506999931, 55.82135651200008],
              [-4.888661261999914, 55.864528713000084],
              [-4.888824022999927, 55.865301825000074],
              [-4.892648891999954, 55.89288971600007],
              [-4.886463995999918, 55.91966380400004],
              [-4.872141079999949, 55.937201239000046],
              [-4.849354620999918, 55.94822825700004],
              [-4.818104620999918, 55.95563385600008],
              [-4.799387173999946, 55.957912502000056],
              [-4.78579667899993, 55.95697663000004],
              [-4.722320115999935, 55.94009023600006],
              [-4.705433722999942, 55.93846263200004],
              [-4.693959113999938, 55.94135163000004],
              [-4.67251542899993, 55.93378327000005],
              [-4.505970831999946, 55.91909414300005],
              [-4.481678839999915, 55.92829010600008],
              [-4.590606248999961, 55.941514390000066],
              [-4.630034959999932, 55.94627513200004],
              [-4.673451300999943, 55.96185944200005],
              [-4.724517381999931, 55.99835846600007],
              [-4.765044725999928, 56.007066148000035],
              [-4.78343665299991, 56.017645575000074],
              [-4.799224412999934, 56.030951239000046],
              [-4.810617641999954, 56.04376862200007],
              [-4.823719855999911, 56.07367584800005],
              [-4.824330206999946, 56.07851797100005],
              [-4.839182094999956, 56.08063385600008],
              [-4.844309048999946, 56.07298411700003],
              [-4.843739386999914, 56.06297435100004],
              [-4.837554490999935, 56.05060455900008],
              [-4.790150519999941, 56.010199286000045],
              [-4.778920050999943, 55.99209219000005],
              [-4.785308397999927, 55.984035549000055],
              [-4.803618943999936, 55.982082424000055],
              [-4.828033006999931, 55.98232656500005],
              [-4.851551886999914, 55.98802317900004],
              [-4.862294074999909, 56.00214264500005],
              [-4.865386522999927, 56.02020905200004],
              [-4.866851365999935, 56.05833567900004],
              [-4.865386522999927, 56.06671784100007],
              [-4.826324022999927, 56.124212958000044],
              [-4.755441860999952, 56.188381252000056],
              [-4.750884568999936, 56.20270416900007],
              [-4.755523240999935, 56.20652903900003],
              [-4.76626542899993, 56.20209381700005],
              [-4.77993730399993, 56.191473700000074],
              [-4.837269660999937, 56.12441640800006],
              [-4.851673956999946, 56.112616278000075],
              [-4.873117641999954, 56.11200592700004],
              [-4.880604620999918, 56.11985911700003],
              [-4.878977016999954, 56.15053945500006],
              [-4.883168097999942, 56.16400788000004],
              [-4.893544074999909, 56.174261786000045],
              [-4.907093878999945, 56.177069403000075],
              [-4.920521613999938, 56.16791413000004],
              [-4.909087693999936, 56.14996979400007],
              [-4.895253058999913, 56.11473216400003],
              [-4.886219855999911, 56.08038971600007],
              [-4.889149542999917, 56.06484609600005],
              [-4.901926235999952, 56.06191640800006],
              [-4.904367641999954, 56.054348049000055],
              [-4.900054490999935, 56.03412506700005],
              [-4.900054490999935, 56.01459381700005],
              [-4.898019985999952, 56.001166083000044],
              [-4.892648891999954, 55.98973216400003],
              [-4.906402147999927, 55.98574453300006],
              [-4.921457485999952, 55.98867422100005],
              [-4.937489386999914, 55.993841864000046],
              [-4.954701300999943, 55.99656810100004],
              [-4.954701300999943, 55.98973216400003],
              [-4.942005988999938, 55.986314195000034],
              [-4.928863084999932, 55.98114655200004],
              [-4.918446417999917, 55.97333405200004],
              [-4.913685675999943, 55.96185944200005],
              [-4.917388475999928, 55.94745514500005],
              [-4.927235480999911, 55.93768952000005],
              [-4.938710089999915, 55.92963288000004],
              [-4.947255011999914, 55.92084381700005],
              [-4.952137824999909, 55.90912506700005],
              [-4.954986131999931, 55.89935944200005],
              [-4.95921790299991, 55.89012278900003],
              [-4.96898352799991, 55.87986888200004],
              [-4.983143683999913, 55.87103913000004],
              [-4.994740363999938, 55.86981842700004],
              [-5.026356574999909, 55.87372467700004],
              [-5.042469855999911, 55.884751695000034],
              [-5.056752081999946, 55.91030508000006],
              [-5.066802537999934, 55.938788153000075],
              [-5.070790167999917, 55.958685614000046],
              [-5.110829230999911, 55.98895905200004],
              [-5.116037563999953, 56.00169505400004],
              [-5.123605923999946, 56.00991445500006],
              [-5.139637824999909, 56.00275299700007],
              [-5.123768683999913, 55.986314195000034],
              [-5.085682745999918, 55.93187083500004],
              [-5.078236456999946, 55.91095612200007],
              [-5.086537238999938, 55.901271877000056],
              [-5.105620897999927, 55.90497467700004],
              [-5.171538865999935, 55.935532945000034],
              [-5.180653449999909, 55.948431708000044],
              [-5.180653449999909, 55.96930573100008],
              [-5.190825975999928, 55.96173737200007],
              [-5.199615037999934, 55.948553778000075],
              [-5.20571855399993, 55.93451569200005],
              [-5.207915818999936, 55.92462799700007],
              [-5.212635870999918, 55.91714101800005],
              [-5.242054816999939, 55.89288971600007],
              [-5.218129035999937, 55.86469147300005],
              [-5.208159959999932, 55.849269924000055],
              [-5.201079881999931, 55.83148834800005],
              [-5.21939042899993, 55.83144765800006],
              [-5.263172980999911, 55.845770575000074],
              [-5.296701626999948, 55.85268789300005],
              [-5.307118292999917, 55.86041901200008],
              [-5.313384568999936, 55.88544342700004],
              [-5.319325324999909, 55.889105536000045],
              [-5.327219204999949, 55.89154694200005],
              [-5.334828253999945, 55.89667389500005],
              [-5.338286912999934, 55.90375397300005],
              [-5.339100714999915, 55.91303131700005],
              [-5.338286912999934, 55.93138255400004],
              [-5.336089647999927, 55.93919505400004],
              [-5.326161261999914, 55.95026276200008],
              [-5.323963995999918, 55.958685614000046],
              [-5.325754360999952, 55.967230536000045],
              [-5.338286912999934, 55.99656810100004],
              [-5.313628709999932, 56.01235586100006],
              [-5.204497850999928, 56.11945221600007],
              [-5.146473761999914, 56.13312409100007],
              [-5.104603644999941, 56.15151601800005],
              [-5.094960089999915, 56.15737539300005],
              [-5.059437628999945, 56.203111070000034],
              [-5.043446417999917, 56.21629466400003],
              [-5.013295050999943, 56.22760651200008],
              [-4.974964972999942, 56.23700592700004],
              [-4.94009355399993, 56.25141022300005],
              [-4.920521613999938, 56.277777411000045],
              [-4.938099738999938, 56.27098216400003],
              [-4.975087042999917, 56.24799225500004],
              [-4.991932745999918, 56.24298737200007],
              [-5.032704230999911, 56.24115631700005],
              [-5.049549933999913, 56.23704661700003],
              [-5.064564581999946, 56.22931549700007],
              [-5.075428839999915, 56.21698639500005],
              [-5.099436001999948, 56.18195221600007],
              [-5.108876105999911, 56.174709377000056],
              [-5.228138800999943, 56.12921784100007],
              [-5.310943162999934, 56.05805084800005],
              [-5.319935675999943, 56.05491771000004],
              [-5.338042772999927, 56.05410390800006],
              [-5.345692511999914, 56.051214911000045],
              [-5.345285610999952, 56.046128648000035],
              [-5.350209113999938, 56.03192780200004],
              [-5.356353318999936, 56.01976146000004],
              [-5.359364386999914, 56.020738023000035],
              [-5.368641730999911, 56.009426174000055],
              [-5.390288865999935, 56.00568268400008],
              [-5.415028449999909, 56.00690338700008],
              [-5.43382727799991, 56.010199286000045],
              [-5.434559699999909, 56.014960028000075],
              [-5.434722459999932, 56.02362702000005],
              [-5.437123175999943, 56.03001536700003],
              [-5.444406704999949, 56.02757396000004],
              [-5.44790605399993, 56.02228424700007],
              [-5.448231574999909, 56.016058661000045],
              [-5.447621222999942, 56.009426174000055],
              [-5.454986131999931, 55.95563385600008],
              [-5.45140540299991, 55.95343659100007],
              [-5.436431443999936, 55.94896067900004],
              [-5.430775519999941, 55.94818756700005],
              [-5.420806443999936, 55.92829010600008],
              [-5.416737433999913, 55.91681549700007],
              [-5.416005011999914, 55.907416083000044],
              [-5.412505662999934, 55.899603583000044],
              [-5.400380011999914, 55.89288971600007],
              [-5.400380011999914, 55.886704820000034],
              [-5.407215949999909, 55.886704820000034],
              [-5.407215949999909, 55.87986888200004],
              [-5.402943488999938, 55.87872955900008],
              [-5.39289303299995, 55.87372467700004],
              [-5.397694464999915, 55.87156810100004],
              [-5.402495897999927, 55.868353583000044],
              [-5.407215949999909, 55.86627838700008],
              [-5.35179602799991, 55.83242422100005],
              [-5.326771613999938, 55.808579820000034],
              [-5.317779100999928, 55.78302643400008],
              [-5.324574347999942, 55.769232489000046],
              [-5.33853105399993, 55.76264069200005],
              [-5.372425910999937, 55.75641510600008],
              [-5.387562628999945, 55.75031159100007],
              [-5.433461066999939, 55.72101471600007],
              [-5.444569464999915, 55.71161530200004],
              [-5.453968878999945, 55.70058828300006],
              [-5.46117102799991, 55.68813711100006],
              [-5.463612433999913, 55.67983633000006],
              [-5.466175910999937, 55.662176825000074],
              [-5.468617316999939, 55.653998114000046],
              [-5.490101691999939, 55.644598700000074],
              [-5.488270636999914, 55.640326239000046],
              [-5.484283006999931, 55.63572825700004],
              [-5.482289191999939, 55.632879950000074],
              [-5.483876105999911, 55.61005280200004],
              [-5.474761522999927, 55.603949286000045],
              [-5.462635870999918, 55.60203685100004],
              [-5.454986131999931, 55.59194570500006],
              [-5.461089647999927, 55.57880280200004],
              [-5.476918097999942, 55.57489655200004],
              [-5.488758917999917, 55.56907786700003],
              [-5.482289191999939, 55.55027903900003],
              [-5.503529425999943, 55.52651601800005],
              [-5.509632941999939, 55.516791083000044],
              [-5.510609503999945, 55.51146067900004],
              [-5.509632941999939, 55.49258047100005],
              [-5.510975714999915, 55.484442450000074],
              [-5.514271613999938, 55.48387278900003],
              [-5.518788214999915, 55.48517487200007],
              [-5.523264126999948, 55.48265208500004],
              [-5.545521613999938, 55.44916413000004],
              [-5.561512824999909, 55.435532945000034],
              [-5.58462480399993, 55.427435614000046],
              [-5.58462480399993, 55.421210028000075],
              [-5.572132941999939, 55.422308661000045],
              [-5.562082485999952, 55.41986725500004],
              [-5.553089972999942, 55.41453685100004],
              [-5.543690558999913, 55.40692780200004],
              [-5.527455206999946, 55.38434479400007],
              [-5.526682094999956, 55.38027578300006],
              [-5.514963344999956, 55.37368398600006],
              [-5.525054490999935, 55.358628648000035],
              [-5.557972785999937, 55.33185455900008],
              [-5.574370897999927, 55.32200755400004],
              [-5.594105597999942, 55.31313711100006],
              [-5.616281704999949, 55.30658600500004],
              [-5.639963344999956, 55.303900458000044],
              [-5.649525519999941, 55.30516185100004],
              [-5.669097459999932, 55.31085846600007],
              [-5.680897589999915, 55.31134674700007],
              [-5.691395636999914, 55.308579820000034],
              [-5.714019334999932, 55.29913971600007],
              [-5.725575324999909, 55.29706452000005],
              [-5.75454667899993, 55.29734935100004],
              [-5.772287563999953, 55.30125560100004],
              [-5.782866990999935, 55.31354401200008],
              [-5.794667120999918, 55.35639069200005],
              [-5.796701626999948, 55.37909577000005],
              [-5.791411912999934, 55.39862702000005],
              [-5.763417120999918, 55.41205475500004],
              [-5.725412563999953, 55.437567450000074],
              [-5.715646938999953, 55.44790273600006],
              [-5.715240037999934, 55.46889883000006],
              [-5.720122850999928, 55.491522528000075],
              [-5.721913214999915, 55.51386139500005],
              [-5.707753058999913, 55.54336172100005],
              [-5.712066209999932, 55.55072663000004],
              [-5.718861456999946, 55.55731842700004],
              [-5.721831834999932, 55.56460195500006],
              [-5.718129035999937, 55.57575104400007],
              [-5.694488084999932, 55.605536200000074],
              [-5.673329230999911, 55.640611070000034],
              [-5.669422980999911, 55.66071198100008],
              [-5.680897589999915, 55.67446523600006],
              [-5.626535610999952, 55.70062897300005],
              [-5.61945553299995, 55.71198151200008],
              [-5.613189256999931, 55.725775458000044],
              [-5.59829667899993, 55.74298737200007],
              [-5.581206834999932, 55.75763580900008],
              [-5.567860480999911, 55.76386139500005],
              [-5.539173956999946, 55.77094147300005],
              [-5.504628058999913, 55.78937409100007],
              [-5.473500128999945, 55.815659898000035],
              [-5.454986131999931, 55.845770575000074],
              [-5.551747199999909, 55.783636786000045],
              [-5.587473110999952, 55.76715729400007],
              [-5.599436001999948, 55.76422760600008],
              [-5.612619594999956, 55.76386139500005],
              [-5.60578365799995, 55.77684153900003],
              [-5.633208787999934, 55.78278229400007],
              [-5.64671790299991, 55.78750234600005],
              [-5.66038977799991, 55.79734935100004],
              [-5.667958136999914, 55.81102122600004],
              [-5.669016079999949, 55.83783600500004],
              [-5.67406165299991, 55.845770575000074],
              [-5.631988084999932, 55.88178131700005],
              [-5.625599738999938, 55.889837958000044],
              [-5.61937415299991, 55.90314362200007],
              [-5.604359503999945, 55.91364166900007],
              [-5.586293097999942, 55.92332591400003],
              [-5.571034308999913, 55.93451569200005],
              [-5.593495245999918, 55.92796458500004],
              [-5.62759355399993, 55.90534088700008],
              [-5.653797980999911, 55.89760976800005],
              [-5.671701626999948, 55.88690827000005],
              [-5.680897589999915, 55.886704820000034],
              [-5.687977667999917, 55.89337799700007],
              [-5.694162563999953, 55.90497467700004],
              [-5.696400519999941, 55.91596100500004],
              [-5.586822068999936, 56.01203034100007],
              [-5.57843990799995, 56.02448151200008],
              [-5.58267167899993, 56.028957424000055],
              [-5.576649542999917, 56.032538153000075],
              [-5.571034308999913, 56.037543036000045],
              [-5.583892381999931, 56.040716864000046],
              [-5.596424933999913, 56.036810614000046],
              [-5.609852667999917, 56.03001536700003],
              [-5.625599738999938, 56.02448151200008],
              [-5.631703253999945, 56.005926825000074],
              [-5.674875454999949, 55.977728583000044],
              [-5.67406165299991, 55.95563385600008],
              [-5.690785285999937, 55.93764883000006],
              [-5.694488084999932, 55.93451569200005],
              [-5.704497850999928, 55.936753648000035],
              [-5.707508917999917, 55.942572333000044],
              [-5.705881313999953, 55.949652411000045],
              [-5.701975063999953, 55.95563385600008],
              [-5.696441209999932, 55.98216380400004],
              [-5.659901495999918, 56.02326080900008],
              [-5.58462480399993, 56.08466217700004],
              [-5.581532355999911, 56.08828359600005],
              [-5.580067511999914, 56.09292226800005],
              [-5.577463344999956, 56.096991278000075],
              [-5.571034308999913, 56.09902578300006],
              [-5.564605272999927, 56.098089911000045],
              [-5.556548631999931, 56.09589264500005],
              [-5.550689256999931, 56.09349192900004],
              [-5.550526495999918, 56.09218984600005],
              [-5.547840949999909, 56.09003327000005],
              [-5.539458787999934, 56.08685944200005],
              [-5.531605597999942, 56.08633047100005],
              [-5.530100063999953, 56.09218984600005],
              [-5.534738735999952, 56.098537502000056],
              [-5.541411912999934, 56.10248444200005],
              [-5.54751542899993, 56.10488515800006],
              [-5.550526495999918, 56.10643138200004],
              [-5.55695553299995, 56.12221914300005],
              [-5.558705206999946, 56.13080475500004],
              [-5.554676886999914, 56.13739655200004],
              [-5.522531704999949, 56.16575755400004],
              [-5.515736456999946, 56.174709377000056],
              [-5.509632941999939, 56.188381252000056],
              [-5.539906378999945, 56.18341705900008],
              [-5.562489386999914, 56.16791413000004],
              [-5.58267167899993, 56.15058014500005],
              [-5.60578365799995, 56.139960028000075],
              [-5.599354620999918, 56.160589911000045],
              [-5.586415167999917, 56.18113841400003],
              [-5.569406704999949, 56.20026276200008],
              [-5.550526495999918, 56.21629466400003],
              [-5.559437628999945, 56.22955963700008],
              [-5.547230597999942, 56.24017975500004],
              [-5.52562415299991, 56.247259833000044],
              [-5.50617428299995, 56.24982330900008],
              [-5.494740363999938, 56.253119208000044],
              [-5.49282792899993, 56.26040273600006],
              [-5.499256964999915, 56.267645575000074],
              [-5.512684699999909, 56.27094147300005],
              [-5.554269985999952, 56.26349518400008],
              [-5.56314042899993, 56.26032135600008],
              [-5.572621222999942, 56.25385163000004],
              [-5.58234615799995, 56.24876536700003],
              [-5.592152472999942, 56.24982330900008],
              [-5.598052537999934, 56.25861237200007],
              [-5.595570441999939, 56.26992422100005],
              [-5.58462480399993, 56.29075755400004],
              [-5.57258053299995, 56.32807038000004],
              [-5.56273352799991, 56.341050523000035],
              [-5.543690558999913, 56.352850653000075],
              [-5.525217251999948, 56.34662506700005],
              [-5.498199022999927, 56.34833405200004],
              [-5.448109503999945, 56.35968659100007],
              [-5.448109503999945, 56.36591217700004],
              [-5.472157355999911, 56.364935614000046],
              [-5.515370245999918, 56.35683828300006],
              [-5.537505662999934, 56.35968659100007],
              [-5.517323370999918, 56.39276764500005],
              [-5.509632941999939, 56.40062083500004],
              [-5.498931443999936, 56.404730536000045],
              [-5.486073370999918, 56.40810781500005],
              [-5.478016730999911, 56.41290924700007],
              [-5.482289191999939, 56.421128648000035],
              [-5.457020636999914, 56.44086334800005],
              [-5.423573370999918, 56.45001862200007],
              [-5.322865363999938, 56.45498281500005],
              [-5.242054816999939, 56.44220612200007],
              [-5.208729620999918, 56.44684479400007],
              [-5.18187415299991, 56.45966217700004],
              [-5.118519660999937, 56.50775788000004],
              [-5.085682745999918, 56.54877350500004],
              [-5.064564581999946, 56.56513092700004],
              [-5.086537238999938, 56.55849844000005],
              [-5.099598761999914, 56.54364655200004],
              [-5.110585089999915, 56.52586497600004],
              [-5.125965949999909, 56.51048411700003],
              [-5.166900193999936, 56.49005768400008],
              [-5.190174933999913, 56.46865469000005],
              [-5.201079881999931, 56.462103583000044],
              [-5.243763800999943, 56.45921458500004],
              [-5.350168423999946, 56.47296784100007],
              [-5.378081834999932, 56.458970445000034],
              [-5.394276495999918, 56.46548086100006],
              [-5.410552537999934, 56.50364817900004],
              [-5.42414303299995, 56.500067450000074],
              [-5.435943162999934, 56.49115631700005],
              [-5.454986131999931, 56.46954987200007],
              [-5.468617316999939, 56.47573476800005],
              [-5.433338995999918, 56.52362702000005],
              [-5.427642381999931, 56.53782786700003],
              [-5.403797980999911, 56.524603583000044],
              [-5.379261847999942, 56.519191799000055],
              [-5.356678839999915, 56.51968008000006],
              [-5.338286912999934, 56.52415599200003],
              [-5.290516730999911, 56.54466380400004],
              [-5.265044725999928, 56.551214911000045],
              [-5.252552863999938, 56.556341864000046],
              [-5.242054816999939, 56.56513092700004],
              [-5.27562415299991, 56.553615627000056],
              [-5.286773240999935, 56.552069403000075],
              [-5.306792772999927, 56.552801825000074],
              [-5.310943162999934, 56.552069403000075],
              [-5.327707485999952, 56.54466380400004],
              [-5.338693813999953, 56.542303778000075],
              [-5.360340949999909, 56.53221263200004],
              [-5.372425910999937, 56.53034088700008],
              [-5.384348110999952, 56.53343333500004],
              [-5.400502081999946, 56.54364655200004],
              [-5.413929816999939, 56.54466380400004],
              [-5.410878058999913, 56.552069403000075],
              [-5.407297329999949, 56.55532461100006],
              [-5.402699347999942, 56.55744049700007],
              [-5.396636522999927, 56.561712958000044],
              [-5.392689581999946, 56.566473700000074],
              [-5.38931230399993, 56.57489655200004],
              [-5.386626756999931, 56.57880280200004],
              [-5.360707160999937, 56.60626862200007],
              [-5.351918097999942, 56.612941799000055],
              [-5.31086178299995, 56.63361237200007],
              [-5.304514126999948, 56.64016347900008],
              [-5.298451300999943, 56.64642975500004],
              [-5.317779100999928, 56.65387604400007],
              [-5.317779100999928, 56.661322333000044],
              [-5.309071417999917, 56.66425202000005],
              [-5.286773240999935, 56.674994208000044],
              [-5.261463995999918, 56.67332591400003],
              [-5.248199022999927, 56.67405833500004],
              [-5.218902147999927, 56.688666083000044],
              [-5.196441209999932, 56.688666083000044],
              [-5.153309699999909, 56.68121979400007],
              [-5.132639126999948, 56.68451569200005],
              [-5.093373175999943, 56.69904205900008],
              [-5.012806769999941, 56.70929596600007],
              [-4.995594855999911, 56.71596914300005],
              [-5.160552537999934, 56.69586823100008],
              [-5.238270636999914, 56.71662018400008],
              [-5.23851477799991, 56.72256094000005],
              [-5.228423631999931, 56.73647695500006],
              [-5.222075975999928, 56.741522528000075],
              [-5.154652472999942, 56.78229401200008],
              [-5.136382615999935, 56.79877350500004],
              [-5.119740363999938, 56.818426825000074],
              [-5.179066535999937, 56.78925202000005],
              [-5.187489386999914, 56.78115469000005],
              [-5.191761847999942, 56.774644273000035],
              [-5.202259894999941, 56.76911041900007],
              [-5.214670376999948, 56.76520416900007],
              [-5.224964972999942, 56.763739325000074],
              [-5.233469204999949, 56.76068756700005],
              [-5.237049933999913, 56.75336334800005],
              [-5.23892167899993, 56.74445221600007],
              [-5.242054816999939, 56.73647695500006],
              [-5.255238410999937, 56.721584377000056],
              [-5.268462693999936, 56.71308014500005],
              [-5.283355272999927, 56.70937734600005],
              [-5.30101477799991, 56.70856354400007],
              [-5.309803839999915, 56.70648834800005],
              [-5.319162563999953, 56.69749583500004],
              [-5.34015865799995, 56.693060614000046],
              [-5.348378058999913, 56.687201239000046],
              [-5.359364386999914, 56.674994208000044],
              [-5.388050910999937, 56.65521881700005],
              [-5.403879360999952, 56.64923737200007],
              [-5.424224412999934, 56.64704010600008],
              [-5.434396938999953, 56.64288971600007],
              [-5.448719855999911, 56.62457916900007],
              [-5.458119269999941, 56.620347398000035],
              [-5.470773891999954, 56.618394273000035],
              [-5.482574022999927, 56.613267320000034],
              [-5.493316209999932, 56.60639069200005],
              [-5.53343665299991, 56.57290273600006],
              [-5.599598761999914, 56.52903880400004],
              [-5.667388475999928, 56.498480536000045],
              [-5.67406165299991, 56.49689362200007],
              [-5.683013475999928, 56.50063711100006],
              [-5.694691535999937, 56.51386139500005],
              [-5.70539303299995, 56.51666901200008],
              [-5.721791144999941, 56.51850006700005],
              [-5.740834113999938, 56.52326080900008],
              [-5.758208787999934, 56.52997467700004],
              [-5.770253058999913, 56.53782786700003],
              [-5.755197719999956, 56.554022528000075],
              [-5.751047329999949, 56.56199778900003],
              [-5.749134894999941, 56.571966864000046],
              [-5.756662563999953, 56.571966864000046],
              [-5.793853318999936, 56.54328034100007],
              [-5.854359503999945, 56.550482489000046],
              [-6.003407355999911, 56.61871979400007],
              [-6.009836391999954, 56.62653229400007],
              [-6.008168097999942, 56.642279364000046],
              [-5.998036261999914, 56.64988841400003],
              [-5.983509894999941, 56.65281810100004],
              [-5.933583136999914, 56.654730536000045],
              [-5.899037238999938, 56.650824286000045],
              [-5.866851365999935, 56.64154694200005],
              [-5.839182094999956, 56.62653229400007],
              [-5.831695115999935, 56.633978583000044],
              [-5.855620897999927, 56.64472077000005],
              [-5.865589972999942, 56.65143463700008],
              [-5.865834113999938, 56.661322333000044],
              [-5.75999915299991, 56.70075104400007],
              [-5.735503709999932, 56.702337958000044],
              [-5.672596808999913, 56.68414948100008],
              [-5.647368943999936, 56.68121979400007],
              [-5.594146287999934, 56.68333567900004],
              [-5.564808722999942, 56.68764883000006],
              [-5.543690558999913, 56.69546133000006],
              [-5.636545376999948, 56.688666083000044],
              [-5.658558722999942, 56.690741278000075],
              [-5.708851691999939, 56.70856354400007],
              [-5.749989386999914, 56.714544989000046],
              [-5.859038865999935, 56.68121979400007],
              [-5.89679928299995, 56.675116278000075],
              [-5.907378709999932, 56.674994208000044],
              [-5.920318162999934, 56.67796458500004],
              [-5.942738410999937, 56.686753648000035],
              [-5.955555792999917, 56.688666083000044],
              [-6.024891730999911, 56.68569570500006],
              [-6.098622199999909, 56.696966864000046],
              [-6.123850063999953, 56.69562409100007],
              [-6.143544074999909, 56.684881903000075],
              [-6.161732550999943, 56.67820872600004],
              [-6.186594204999949, 56.68109772300005],
              [-6.20962480399993, 56.68846263200004],
              [-6.222767706999946, 56.69546133000006],
              [-6.228179490999935, 56.70107656500005],
              [-6.232533331999946, 56.70652903900003],
              [-6.235340949999909, 56.71238841400003],
              [-6.236398891999954, 56.71906159100007],
              [-6.234486456999946, 56.728583075000074],
              [-6.229562954999949, 56.72907135600008],
              [-6.222767706999946, 56.72719961100006],
              [-6.215321417999917, 56.72964101800005],
              [-6.193470831999946, 56.74852122600004],
              [-6.180531378999945, 56.75462474200003],
              [-6.026966925999943, 56.763739325000074],
              [-6.014881964999915, 56.76703522300005],
              [-5.979888475999928, 56.78156159100007],
              [-5.965199347999942, 56.784857489000046],
              [-5.948231574999909, 56.782538153000075],
              [-5.937977667999917, 56.77692291900007],
              [-5.928537563999953, 56.769964911000045],
              [-5.913644985999952, 56.763739325000074],
              [-5.860910610999952, 56.75079987200007],
              [-5.85220292899993, 56.746975002000056],
              [-5.853342251999948, 56.757879950000074],
              [-5.858143683999913, 56.768459377000056],
              [-5.868397589999915, 56.77586497600004],
              [-5.886341925999943, 56.777411200000074],
              [-5.886341925999943, 56.784857489000046],
              [-5.874012824999909, 56.78571198100008],
              [-5.861805792999917, 56.78510163000004],
              [-5.850087042999917, 56.782456773000035],
              [-5.839182094999956, 56.777411200000074],
              [-5.824615037999934, 56.78758372600004],
              [-5.802072719999956, 56.79181549700007],
              [-5.776600714999915, 56.787990627000056],
              [-5.756662563999953, 56.784857489000046],
              [-5.831695115999935, 56.80536530200004],
              [-5.850819464999915, 56.818019924000055],
              [-5.851185675999943, 56.82892487200007],
              [-5.837473110999952, 56.83661530200004],
              [-5.733876105999911, 56.84479401200008],
              [-5.692738410999937, 56.85492584800005],
              [-5.66038977799991, 56.87299225500004],
              [-5.673573370999918, 56.87653229400007],
              [-5.692005988999938, 56.87531159100007],
              [-5.708485480999911, 56.87055084800005],
              [-5.724354620999918, 56.85382721600007],
              [-5.744496222999942, 56.85415273600006],
              [-5.783924933999913, 56.85993073100008],
              [-5.775380011999914, 56.86994049700007],
              [-5.735503709999932, 56.89411041900007],
              [-5.780588344999956, 56.89874909100007],
              [-5.874867316999939, 56.887152411000045],
              [-5.921131964999915, 56.89411041900007],
              [-5.887562628999945, 56.89911530200004],
              [-5.85220292899993, 56.90033600500004],
              [-5.85220292899993, 56.90770091400003],
              [-5.859852667999917, 56.91054922100005],
              [-5.880116339999915, 56.92202383000006],
              [-5.862538214999915, 56.93374258000006],
              [-5.851429816999939, 56.95425039300005],
              [-5.842518683999913, 56.977443752000056],
              [-5.831695115999935, 56.99713776200008],
              [-5.814116990999935, 57.00950755400004],
              [-5.786040818999936, 57.02057526200008],
              [-5.755238410999937, 57.026556708000044],
              [-5.729318813999953, 57.02383047100005],
              [-5.719878709999932, 57.017564195000034],
              [-5.699940558999913, 56.998114325000074],
              [-5.688303188999953, 56.98969147300005],
              [-5.67406165299991, 56.983587958000044],
              [-5.658558722999942, 56.97947825700004],
              [-5.625599738999938, 56.976629950000074],
              [-5.571278449999909, 56.98383209800005],
              [-5.523264126999948, 56.99713776200008],
              [-5.523264126999948, 57.003973700000074],
              [-5.540435350999928, 57.001166083000044],
              [-5.556507941999939, 56.996079820000034],
              [-5.571278449999909, 56.99331289300005],
              [-5.58462480399993, 56.99713776200008],
              [-5.607085740999935, 56.98851146000004],
              [-5.628814256999931, 56.991888739000046],
              [-5.649891730999911, 56.999660549000055],
              [-5.670318162999934, 57.003973700000074],
              [-5.685536261999914, 57.00958893400008],
              [-5.681711391999954, 57.02240631700005],
              [-5.680043097999942, 57.03620026200008],
              [-5.701975063999953, 57.044907945000034],
              [-5.710926886999914, 57.044175523000035],
              [-5.731353318999936, 57.03900788000004],
              [-5.742339647999927, 57.03807200700004],
              [-5.752552863999938, 57.04059479400007],
              [-5.769602016999954, 57.04975006700005],
              [-5.780181443999936, 57.05174388200004],
              [-5.791127081999946, 57.05927155200004],
              [-5.776193813999953, 57.075832424000055],
              [-5.734486456999946, 57.10541413000004],
              [-5.722645636999914, 57.116441148000035],
              [-5.715646938999953, 57.12006256700005],
              [-5.703277147999927, 57.120754299000055],
              [-5.673695441999939, 57.11904531500005],
              [-5.663482225999928, 57.12372467700004],
              [-5.645863410999937, 57.12946198100008],
              [-5.620838995999918, 57.12409088700008],
              [-5.57843990799995, 57.10639069200005],
              [-5.558257615999935, 57.10040924700007],
              [-5.459828253999945, 57.09979889500005],
              [-5.454986131999931, 57.10297272300005],
              [-5.447417772999927, 57.11017487200007],
              [-5.430775519999941, 57.11074453300006],
              [-5.41429602799991, 57.10822174700007],
              [-5.407215949999909, 57.10639069200005],
              [-5.400380011999914, 57.10639069200005],
              [-5.400380011999914, 57.11383698100008],
              [-5.420033331999946, 57.12067291900007],
              [-5.503895636999914, 57.11269765800006],
              [-5.527414516999954, 57.107489325000074],
              [-5.540638800999943, 57.10639069200005],
              [-5.547718878999945, 57.11009349200003],
              [-5.573312954999949, 57.12787506700005],
              [-5.58462480399993, 57.133693752000056],
              [-5.668446417999917, 57.147650458000044],
              [-5.680897589999915, 57.157904364000046],
              [-5.673817511999914, 57.174994208000044],
              [-5.638824022999927, 57.202378648000035],
              [-5.625599738999938, 57.21625397300005],
              [-5.644154425999943, 57.23322174700007],
              [-5.620106574999909, 57.25214264500005],
              [-5.578236456999946, 57.26675039300005],
              [-5.543690558999913, 57.27090078300006],
              [-5.511586066999939, 57.25763580900008],
              [-5.480091925999943, 57.23700592700004],
              [-5.446278449999909, 57.22304922100005],
              [-5.407215949999909, 57.22992584800005],
              [-5.407215949999909, 57.23672109600005],
              [-5.448841925999943, 57.24209219000005],
              [-5.458119269999941, 57.24664948100008],
              [-5.47288977799991, 57.26121653900003],
              [-5.482899542999917, 57.268011786000045],
              [-5.49250240799995, 57.27090078300006],
              [-5.501942511999914, 57.27765534100007],
              [-5.48892167899993, 57.29242584800005],
              [-5.464833136999914, 57.306626695000034],
              [-5.440663214999915, 57.311835028000075],
              [-5.440663214999915, 57.31928131700005],
              [-5.464995897999927, 57.32493724200003],
              [-5.481760219999956, 57.31671784100007],
              [-5.494292772999927, 57.30442942900004],
              [-5.50617428299995, 57.298163153000075],
              [-5.523426886999914, 57.29515208500004],
              [-5.558461066999939, 57.28143952000005],
              [-5.57843990799995, 57.27765534100007],
              [-5.599436001999948, 57.27924225500004],
              [-5.637440558999913, 57.28900788000004],
              [-5.656971808999913, 57.29132721600007],
              [-5.700062628999945, 57.28359609600005],
              [-5.720570441999939, 57.284491278000075],
              [-5.729318813999953, 57.298163153000075],
              [-5.72524980399993, 57.30158112200007],
              [-5.701975063999953, 57.33234284100007],
              [-5.693755662999934, 57.337103583000044],
              [-5.671986456999946, 57.34442780200004],
              [-5.663482225999928, 57.349676825000074],
              [-5.654367641999954, 57.353949286000045],
              [-5.647206183999913, 57.34992096600007],
              [-5.641468878999945, 57.34320709800005],
              [-5.636545376999948, 57.33978913000004],
              [-5.613189256999931, 57.34198639500005],
              [-5.501291469999956, 57.37099844000005],
              [-5.456654425999943, 57.39354075700004],
              [-5.448109503999945, 57.42169830900008],
              [-5.46507727799991, 57.423895575000074],
              [-5.492054816999939, 57.40875885600008],
              [-5.537505662999934, 57.373928127000056],
              [-5.563465949999909, 57.36310455900008],
              [-5.586659308999913, 57.36505768400008],
              [-5.610910610999952, 57.37140534100007],
              [-5.639963344999956, 57.373928127000056],
              [-5.615589972999942, 57.382473049000055],
              [-5.607085740999935, 57.389105536000045],
              [-5.609201626999948, 57.397772528000075],
              [-5.617746548999946, 57.41010163000004],
              [-5.619618292999917, 57.41669342700004],
              [-5.624012824999909, 57.41640859600005],
              [-5.639963344999956, 57.40802643400008],
              [-5.707183397999927, 57.35976797100005],
              [-5.732411261999914, 57.352769273000035],
              [-5.784575975999928, 57.34857819200005],
              [-5.807769334999932, 57.35492584800005],
              [-5.82485917899993, 57.39435455900008],
              [-5.822255011999914, 57.39350006700005],
              [-5.817372199999909, 57.39520905200004],
              [-5.812855597999942, 57.398098049000055],
              [-5.81118730399993, 57.40119049700007],
              [-5.813872850999928, 57.40452708500004],
              [-5.823109503999945, 57.41233958500004],
              [-5.82485917899993, 57.41547272300005],
              [-5.825266079999949, 57.428900458000044],
              [-5.821888800999943, 57.435532945000034],
              [-5.81118730399993, 57.44220612200007],
              [-5.821522589999915, 57.44546133000006],
              [-5.852528449999909, 57.450384833000044],
              [-5.859038865999935, 57.45270416900007],
              [-5.861195441999939, 57.46344635600008],
              [-5.870513475999928, 57.48078034100007],
              [-5.872670050999943, 57.49371979400007],
              [-5.869699673999946, 57.500881252000056],
              [-5.856068488999938, 57.51780833500004],
              [-5.85220292899993, 57.52411530200004],
              [-5.851063605999911, 57.538397528000075],
              [-5.851470506999931, 57.55109284100007],
              [-5.847075975999928, 57.55890534100007],
              [-5.831695115999935, 57.55882396000004],
              [-5.833851691999939, 57.563381252000056],
              [-5.837025519999941, 57.57477448100008],
              [-5.839182094999956, 57.579291083000044],
              [-5.821400519999941, 57.583197333000044],
              [-5.803618943999936, 57.581366278000075],
              [-5.786366339999915, 57.57518138200004],
              [-5.732574022999927, 57.54523346600007],
              [-5.715646938999953, 57.538397528000075],
              [-5.707020636999914, 57.542303778000075],
              [-5.68976803299995, 57.52789948100008],
              [-5.680897589999915, 57.52411530200004],
              [-5.650868292999917, 57.51264069200005],
              [-5.639963344999956, 57.511053778000075],
              [-5.645334438999953, 57.51666901200008],
              [-5.648304816999939, 57.52187734600005],
              [-5.650542772999927, 57.52680084800005],
              [-5.653553839999915, 57.53156159100007],
              [-5.581532355999911, 57.538397528000075],
              [-5.540272589999915, 57.534491278000075],
              [-5.516835089999915, 57.534857489000046],
              [-5.512684699999909, 57.54148997600004],
              [-5.543120897999927, 57.55536530200004],
              [-5.588368292999917, 57.56102122600004],
              [-5.632720506999931, 57.55768463700008],
              [-5.66038977799991, 57.544582424000055],
              [-5.694488084999932, 57.56631094000005],
              [-5.689198370999918, 57.56940338700008],
              [-5.680897589999915, 57.579291083000044],
              [-5.714222785999937, 57.58270905200004],
              [-5.731678839999915, 57.59829336100006],
              [-5.744252081999946, 57.61798737200007],
              [-5.762806769999941, 57.633978583000044],
              [-5.778146938999953, 57.63743724200003],
              [-5.79360917899993, 57.63857656500005],
              [-5.805897589999915, 57.642645575000074],
              [-5.81118730399993, 57.65509674700007],
              [-5.805409308999913, 57.667181708000044],
              [-5.785023566999939, 57.67951080900008],
              [-5.790760870999918, 57.68854401200008],
              [-5.790760870999918, 57.69599030200004],
              [-5.753570115999935, 57.707464911000045],
              [-5.734486456999946, 57.70795319200005],
              [-5.704986131999931, 57.69013092700004],
              [-5.692494269999941, 57.691066799000055],
              [-5.68195553299995, 57.69871653900003],
              [-5.67406165299991, 57.70966217700004],
              [-5.685170050999943, 57.71141185100004],
              [-5.692290818999936, 57.716498114000046],
              [-5.698841925999943, 57.723089911000045],
              [-5.708851691999939, 57.72955963700008],
              [-5.720529751999948, 57.73338450700004],
              [-5.803822394999941, 57.743841864000046],
              [-5.80695553299995, 57.75462474200003],
              [-5.802072719999956, 57.780585028000075],
              [-5.803822394999941, 57.792222398000035],
              [-5.801258917999917, 57.800441799000055],
              [-5.809925910999937, 57.82062409100007],
              [-5.81118730399993, 57.833197333000044],
              [-5.807362433999913, 57.84393952000005],
              [-5.799956834999932, 57.85370514500005],
              [-5.789540167999917, 57.86200592700004],
              [-5.776519334999932, 57.86790599200003],
              [-5.751128709999932, 57.87335846600007],
              [-5.724761522999927, 57.87352122600004],
              [-5.698638475999928, 57.86908600500004],
              [-5.67406165299991, 57.86050039300005],
              [-5.677886522999927, 57.846909898000035],
              [-5.674794074999909, 57.82709381700005],
              [-5.667958136999914, 57.80695221600007],
              [-5.66038977799991, 57.792222398000035],
              [-5.650542772999927, 57.78180573100008],
              [-5.63735917899993, 57.77423737200007],
              [-5.622141079999949, 57.77020905200004],
              [-5.60578365799995, 57.77049388200004],
              [-5.613270636999914, 57.77521393400008],
              [-5.617909308999913, 57.78021881700005],
              [-5.625599738999938, 57.792222398000035],
              [-5.613026495999918, 57.792629299000055],
              [-5.603260870999918, 57.791083075000074],
              [-5.58462480399993, 57.784816799000055],
              [-5.591175910999937, 57.80442942900004],
              [-5.587025519999941, 57.81858958500004],
              [-5.585275844999956, 57.83144765800006],
              [-5.598988410999937, 57.846869208000044],
              [-5.637562628999945, 57.86635976800005],
              [-5.650380011999914, 57.87775299700007],
              [-5.639963344999956, 57.88784414300005],
              [-5.647694464999915, 57.88898346600007],
              [-5.650786912999934, 57.89081452000005],
              [-5.653553839999915, 57.89468008000006],
              [-5.643950975999928, 57.90420156500005],
              [-5.620757615999935, 57.92088450700004],
              [-5.612619594999956, 57.92877838700008],
              [-5.598215298999946, 57.91901276200008],
              [-5.587310350999928, 57.91510651200008],
              [-5.550526495999918, 57.91510651200008],
              [-5.556263800999943, 57.88776276200008],
              [-5.527902798999946, 57.86758047100005],
              [-5.487049933999913, 57.85586172100005],
              [-5.454986131999931, 57.85370514500005],
              [-5.46117102799991, 57.86050039300005],
              [-5.449045376999948, 57.869126695000034],
              [-5.437123175999943, 57.897650458000044],
              [-5.427642381999931, 57.908270575000074],
              [-5.414906378999945, 57.90814850500004],
              [-5.369496222999942, 57.89752838700008],
              [-5.355620897999927, 57.89126211100006],
              [-5.327504035999937, 57.87327708500004],
              [-5.293853318999936, 57.86204661700003],
              [-5.221587693999936, 57.846869208000044],
              [-5.236317511999914, 57.86078522300005],
              [-5.247547980999911, 57.86701080900008],
              [-5.276763475999928, 57.87417226800005],
              [-5.320668097999942, 57.898504950000074],
              [-5.384917772999927, 57.914129950000074],
              [-5.39289303299995, 57.91819896000004],
              [-5.394398566999939, 57.923895575000074],
              [-5.396839972999942, 57.926214911000045],
              [-5.397328253999945, 57.928900458000044],
              [-5.39289303299995, 57.935614325000074],
              [-5.386545376999948, 57.936428127000056],
              [-5.378977016999954, 57.93183014500005],
              [-5.37173417899993, 57.93105703300006],
              [-5.366200324999909, 57.943060614000046],
              [-5.347157355999911, 57.936712958000044],
              [-5.319162563999953, 57.91474030200004],
              [-5.297352667999917, 57.908270575000074],
              [-5.286000128999945, 57.90875885600008],
              [-5.266957160999937, 57.91400788000004],
              [-5.256255662999934, 57.91510651200008],
              [-5.243641730999911, 57.91290924700007],
              [-5.22101803299995, 57.90403880400004],
              [-5.211293097999942, 57.90208567900004],
              [-5.198801235999952, 57.897772528000075],
              [-5.162261522999927, 57.87848541900007],
              [-5.119984503999945, 57.86798737200007],
              [-5.091135219999956, 57.84031810100004],
              [-5.070790167999917, 57.833197333000044],
              [-5.07648678299995, 57.83852773600006],
              [-5.083404100999928, 57.84756094000005],
              [-5.089344855999911, 57.85724518400008],
              [-5.091867641999954, 57.86420319200005],
              [-5.097157355999911, 57.87091705900008],
              [-5.197255011999914, 57.91787344000005],
              [-5.221587693999936, 57.92133209800005],
              [-5.221587693999936, 57.92877838700008],
              [-5.201893683999913, 57.92865631700005],
              [-5.193959113999938, 57.935980536000045],
              [-5.19554602799991, 57.94765859600005],
              [-5.204497850999928, 57.960150458000044],
              [-5.216704881999931, 57.96588776200008],
              [-5.248890753999945, 57.96938711100006],
              [-5.263172980999911, 57.976548570000034],
              [-5.292632615999935, 57.98061758000006],
              [-5.333892381999931, 58.00853099200003],
              [-5.359364386999914, 58.011379299000055],
              [-5.357167120999918, 58.01406484600005],
              [-5.356678839999915, 58.014878648000035],
              [-5.351918097999942, 58.01752350500004],
              [-5.366932745999918, 58.02887604400007],
              [-5.386586066999939, 58.032538153000075],
              [-5.427642381999931, 58.03119538000004],
              [-5.424305792999917, 58.03554922100005],
              [-5.422352667999917, 58.03896719000005],
              [-5.419585740999935, 58.04205963700008],
              [-5.413929816999939, 58.04547760600008],
              [-5.413929816999939, 58.05231354400007],
              [-5.447010870999918, 58.08437734600005],
              [-5.428089972999942, 58.09796784100007],
              [-5.390044725999928, 58.09218984600005],
              [-5.366200324999909, 58.06598541900007],
              [-5.344309048999946, 58.075506903000075],
              [-5.322865363999938, 58.07172272300005],
              [-5.300770636999914, 58.07013580900008],
              [-5.276763475999928, 58.08641185100004],
              [-5.283070441999939, 58.08641185100004],
              [-5.278065558999913, 58.09625885600008],
              [-5.278797980999911, 58.10537344000005],
              [-5.283558722999942, 58.11347077000005],
              [-5.290516730999911, 58.12055084800005],
              [-5.276763475999928, 58.12055084800005],
              [-5.276763475999928, 58.127386786000045],
              [-5.297352667999917, 58.134833075000074],
              [-5.284087693999936, 58.14008209800005],
              [-5.255523240999935, 58.143784898000035],
              [-5.242054816999939, 58.14789459800005],
              [-5.242054816999939, 58.15534088700008],
              [-5.275054490999935, 58.15452708500004],
              [-5.290842251999948, 58.156317450000074],
              [-5.304798956999946, 58.162095445000034],
              [-5.297352667999917, 58.168402411000045],
              [-5.304798956999946, 58.17332591400003],
              [-5.313059048999946, 58.17731354400007],
              [-5.321888800999943, 58.18024323100008],
              [-5.331450975999928, 58.18203359600005],
              [-5.329335089999915, 58.186712958000044],
              [-5.326161261999914, 58.198431708000044],
              [-5.323963995999918, 58.203111070000034],
              [-5.336822068999936, 58.203192450000074],
              [-5.346791144999941, 58.20685455900008],
              [-5.39289303299995, 58.24469635600008],
              [-5.392079230999911, 58.261379299000055],
              [-5.375884568999936, 58.26422760600008],
              [-5.352894660999937, 58.25893789300005],
              [-5.31078040299991, 58.243394273000035],
              [-5.293853318999936, 58.24091217700004],
              [-5.276966925999943, 58.243394273000035],
              [-5.237294074999909, 58.25763580900008],
              [-5.216053839999915, 58.261419989000046],
              [-5.194325324999909, 58.25999583500004],
              [-5.173207160999937, 58.25092194200005],
              [-5.165638800999943, 58.258246161000045],
              [-5.152251756999931, 58.264837958000044],
              [-5.138335740999935, 58.269598700000074],
              [-5.129383917999917, 58.27138906500005],
              [-5.11156165299991, 58.26825592700004],
              [-5.081288214999915, 58.25409577000005],
              [-5.067697719999956, 58.25092194200005],
              [-5.017730272999927, 58.253241278000075],
              [-5.002430792999917, 58.25092194200005],
              [-4.933583136999914, 58.22304922100005],
              [-4.943430141999954, 58.233587958000044],
              [-4.954823370999918, 58.23981354400007],
              [-4.982004360999952, 58.25092194200005],
              [-4.968861456999946, 58.25678131700005],
              [-4.940337693999936, 58.259466864000046],
              [-4.926747199999909, 58.26459381700005],
              [-4.990223761999914, 58.27142975500004],
              [-5.009917772999927, 58.27138906500005],
              [-5.018055792999917, 58.26862213700008],
              [-5.029367641999954, 58.25971100500004],
              [-5.040028449999909, 58.25775788000004],
              [-5.050119594999956, 58.25991445500006],
              [-5.070708787999934, 58.269232489000046],
              [-5.081654425999943, 58.27138906500005],
              [-5.096424933999913, 58.27676015800006],
              [-5.125965949999909, 58.30019765800006],
              [-5.136219855999911, 58.305568752000056],
              [-5.137440558999913, 58.30927155200004],
              [-5.156361456999946, 58.32461172100005],
              [-5.160145636999914, 58.326605536000045],
              [-5.167795376999948, 58.33926015800006],
              [-5.171009894999941, 58.34666575700004],
              [-5.173207160999937, 58.353949286000045],
              [-5.153309699999909, 58.353949286000045],
              [-5.163400844999956, 58.364569403000075],
              [-5.162912563999953, 58.37449778900003],
              [-5.155913865999935, 58.384466864000046],
              [-5.146473761999914, 58.394964911000045],
              [-5.145497199999909, 58.400051174000055],
              [-5.14671790299991, 58.40664297100005],
              [-5.146839972999942, 58.41242096600007],
              [-5.143055792999917, 58.41478099200003],
              [-5.135487433999913, 58.413763739000046],
              [-5.122222459999932, 58.40957265800006],
              [-5.116037563999953, 58.40859609600005],
              [-5.057972785999937, 58.38727448100008],
              [-5.016184048999946, 58.38812897300005],
              [-5.043934699999909, 58.400091864000046],
              [-5.05337480399993, 58.40664297100005],
              [-5.050282355999911, 58.41478099200003],
              [-5.057036912999934, 58.42218659100007],
              [-5.066151495999918, 58.41714101800005],
              [-5.076161261999914, 58.414496161000045],
              [-5.086822068999936, 58.41388580900008],
              [-5.098052537999934, 58.41478099200003],
              [-5.098052537999934, 58.42218659100007],
              [-5.08812415299991, 58.421942450000074],
              [-5.085031704999949, 58.42218659100007],
              [-5.085031704999949, 58.429022528000075],
              [-5.091786261999914, 58.429754950000074],
              [-5.09601803299995, 58.43146393400008],
              [-5.105539516999954, 58.43650950700004],
              [-5.050119594999956, 58.45380280200004],
              [-5.025542772999927, 58.447699286000045],
              [-4.995594855999911, 58.43650950700004],
              [-5.105539516999954, 58.48737213700008],
              [-5.105620897999927, 58.505560614000046],
              [-5.103667772999927, 58.51422760600008],
              [-5.095855272999927, 58.518866278000075],
              [-5.042795376999948, 58.53546784100007],
              [-5.02798417899993, 58.54409414300005],
              [-5.016184048999946, 58.55939362200007],
              [-5.022938605999911, 58.55939362200007],
              [-5.015207485999952, 58.580064195000034],
              [-5.011586066999939, 58.60057200700004],
              [-5.004953579999949, 58.61774323100008],
              [-4.988189256999931, 58.62832265800006],
              [-4.859486456999946, 58.61322663000004],
              [-4.835926886999914, 58.60504791900007],
              [-4.818104620999918, 58.59292226800005],
              [-4.817941860999952, 58.587591864000046],
              [-4.81281490799995, 58.571966864000046],
              [-4.806752081999946, 58.55841705900008],
              [-4.803822394999941, 58.55939362200007],
              [-4.804595506999931, 58.54832591400003],
              [-4.807240363999938, 58.53961823100008],
              [-4.811634894999941, 58.53204987200007],
              [-4.818104620999918, 58.524644273000035],
              [-4.799794074999909, 58.532456773000035],
              [-4.791818813999953, 58.54165273600006],
              [-4.789906378999945, 58.55174388200004],
              [-4.790150519999941, 58.562486070000034],
              [-4.785755988999938, 58.577053127000056],
              [-4.777088995999918, 58.583319403000075],
              [-4.771595831999946, 58.59039948100008],
              [-4.776519334999932, 58.60716380400004],
              [-4.758859829999949, 58.59910716400003],
              [-4.728016730999911, 58.577460028000075],
              [-4.711333787999934, 58.57306549700007],
              [-4.683257615999935, 58.56150950700004],
              [-4.670399542999917, 58.55939362200007],
              [-4.660023566999939, 58.555853583000044],
              [-4.659291144999941, 58.54755280200004],
              [-4.663238084999932, 58.538397528000075],
              [-4.667307094999956, 58.53204987200007],
              [-4.679025844999956, 58.52391185100004],
              [-4.714466925999943, 58.50560130400004],
              [-4.732411261999914, 58.480454820000034],
              [-4.751535610999952, 58.46161530200004],
              [-4.760975714999915, 58.44798411700003],
              [-4.74242102799991, 58.44953034100007],
              [-4.682972785999937, 58.48456452000005],
              [-4.673451300999943, 58.48737213700008],
              [-4.666859503999945, 58.50291575700004],
              [-4.650502081999946, 58.50995514500005],
              [-4.630441860999952, 58.514960028000075],
              [-4.612131313999953, 58.524644273000035],
              [-4.601063605999911, 58.54193756700005],
              [-4.595122850999928, 58.56000397300005],
              [-4.584950324999909, 58.57416413000004],
              [-4.560536261999914, 58.57990143400008],
              [-4.517486131999931, 58.575506903000075],
              [-4.475493943999936, 58.565619208000044],
              [-4.426503058999913, 58.54637278900003],
              [-4.426503058999913, 58.53888580900008],
              [-4.427886522999927, 58.53530508000006],
              [-4.428700324999909, 58.53473541900007],
              [-4.426503058999913, 58.524644273000035],
              [-4.449940558999913, 58.510199286000045],
              [-4.464751756999931, 58.49201080900008],
              [-4.477650519999941, 58.47134023600006],
              [-4.495350714999915, 58.44953034100007],
              [-4.478098110999952, 58.453558661000045],
              [-4.46117102799991, 58.46246979400007],
              [-4.43390865799995, 58.483628648000035],
              [-4.432728644999941, 58.487616278000075],
              [-4.433990037999934, 58.49237702000005],
              [-4.43423417899993, 58.49628327000005],
              [-4.430165167999917, 58.49799225500004],
              [-4.425933397999927, 58.49909088700008],
              [-4.385365363999938, 58.52240631700005],
              [-4.382394985999952, 58.524644273000035],
              [-4.343861456999946, 58.53888580900008],
              [-4.317005988999938, 58.54572174700007],
              [-4.306996222999942, 58.54637278900003],
              [-4.287180141999954, 58.54291413000004],
              [-4.257313605999911, 58.52798086100006],
              [-4.234730597999942, 58.524644273000035],
              [-4.248931443999936, 58.53204987200007],
              [-4.238189256999931, 58.536444403000075],
              [-4.232248501999948, 58.54242584800005],
              [-4.227691209999932, 58.548163153000075],
              [-4.22101803299995, 58.551947333000044],
              [-4.209706183999913, 58.55292389500005],
              [-4.190785285999937, 58.54783763200004],
              [-4.176991339999915, 58.54637278900003],
              [-4.16820227799991, 58.54938385600008],
              [-4.160552537999934, 58.562567450000074],
              [-4.149322068999936, 58.565619208000044],
              [-4.111195441999939, 58.565619208000044],
              [-4.090240037999934, 58.56207916900007],
              [-4.081450975999928, 58.561835028000075],
              [-4.070220506999931, 58.565619208000044],
              [-4.061512824999909, 58.57282135600008],
              [-4.048817511999914, 58.58958567900004],
              [-4.039784308999913, 58.59292226800005],
              [-4.030629035999937, 58.59406159100007],
              [-4.029042120999918, 58.59516022300005],
              [-4.027821417999917, 58.59271881700005],
              [-4.009266730999911, 58.57330963700008],
              [-4.003773566999939, 58.57062409100007],
              [-3.981434699999909, 58.57306549700007],
              [-3.895741339999915, 58.565619208000044],
              [-3.810129360999952, 58.57306549700007],
              [-3.766957160999937, 58.58372630400004],
              [-3.698353644999941, 58.61115143400008],
              [-3.659901495999918, 58.62083567900004],
              [-3.597564256999931, 58.62714264500005],
              [-3.565500454999949, 58.626613674000055],
              [-3.542591925999943, 58.62083567900004],
              [-3.552479620999918, 58.61546458500004],
              [-3.556263800999943, 58.61399974200003],
              [-3.532053188999953, 58.60211823100008],
              [-3.504017706999946, 58.60333893400008],
              [-3.447010870999918, 58.61399974200003],
              [-3.391468878999945, 58.60065338700008],
              [-3.364084438999953, 58.600816148000035],
              [-3.350819464999915, 58.62083567900004],
              [-3.367746548999946, 58.624701239000046],
              [-3.386057094999956, 58.631740627000056],
              [-3.402251756999931, 58.64203522300005],
              [-3.412912563999953, 58.655585028000075],
              [-3.390044725999928, 58.67177969000005],
              [-3.374867316999939, 58.677069403000075],
              [-3.358265753999945, 58.675482489000046],
              [-3.354359503999945, 58.67015208500004],
              [-3.35179602799991, 58.66083405200004],
              [-3.34788977799991, 58.652044989000046],
              [-3.340565558999913, 58.648138739000046],
              [-3.309885219999956, 58.648138739000046],
              [-3.244252081999946, 58.65900299700007],
              [-3.204090949999909, 58.66111888200004],
              [-3.151926235999952, 58.64126211100006],
              [-3.118763800999943, 58.64109935100004],
              [-3.052886522999927, 58.648138739000046],
              [-3.019113735999952, 58.640326239000046],
              [-3.025380011999914, 58.62213776200008],
              [-3.044422980999911, 58.601629950000074],
              [-3.049183722999942, 58.58673737200007],
              [-3.060454881999931, 58.57843659100007],
              [-3.075428839999915, 58.56037018400008],
              [-3.084543423999946, 58.551947333000044],
              [-3.110747850999928, 58.53864166900007],
              [-3.118031378999945, 58.53204987200007],
              [-3.129261847999942, 58.51264069200005],
              [-3.129302537999934, 58.49640534100007],
              [-3.118723110999952, 58.484442450000074],
              [-3.097523566999939, 58.47748444200005],
              [-3.085072394999941, 58.47825755400004],
              [-3.073963995999918, 58.481675523000035],
              [-3.064442511999914, 58.48297760600008],
              [-3.056630011999914, 58.47748444200005],
              [-3.053334113999938, 58.46576569200005],
              [-3.057728644999941, 58.45685455900008],
              [-3.066761847999942, 58.451157945000034],
              [-3.077056443999936, 58.44953034100007],
              [-3.086333787999934, 58.41421133000006],
              [-3.129790818999936, 58.36928945500006],
              [-3.182769334999932, 58.32843659100007],
              [-3.220529751999948, 58.305568752000056],
              [-3.262277798999946, 58.292629299000055],
              [-3.34984290299991, 58.27610911700003],
              [-3.38499915299991, 58.26459381700005],
              [-3.438099738999938, 58.236029364000046],
              [-3.447010870999918, 58.22675202000005],
              [-3.454741990999935, 58.210150458000044],
              [-3.473459438999953, 58.193426825000074],
              [-3.515288865999935, 58.168402411000045],
              [-3.73501542899993, 58.07217031500005],
              [-3.809193488999938, 58.05190664300005],
              [-3.827504035999937, 58.04205963700008],
              [-3.83625240799995, 58.03143952000005],
              [-3.846099412999934, 58.01117584800005],
              [-3.851714647999927, 58.003892320000034],
              [-3.860585089999915, 57.998928127000056],
              [-3.885609503999945, 57.991400458000044],
              [-3.917307094999956, 57.98745351800005],
              [-3.981434699999909, 57.96356842700004],
              [-3.990956183999913, 57.96039459800005],
              [-3.997670050999943, 57.954413153000075],
              [-4.001372850999928, 57.94611237200007],
              [-4.001942511999914, 57.935614325000074],
              [-4.018299933999913, 57.940619208000044],
              [-4.023060675999943, 57.943060614000046],
              [-4.016184048999946, 57.949286200000074],
              [-4.030140753999945, 57.953192450000074],
              [-4.055775519999941, 57.95498281500005],
              [-4.084380662999934, 57.964178778000075],
              [-4.089100714999915, 57.960150458000044],
              [-4.086333787999934, 57.95189036700003],
              [-4.077626105999911, 57.943060614000046],
              [-4.062652147999927, 57.93695709800005],
              [-4.03148352799991, 57.93618398600006],
              [-4.016184048999946, 57.93219635600008],
              [-4.009429490999935, 57.92767975500004],
              [-3.988270636999914, 57.908270575000074],
              [-4.008941209999932, 57.88959381700005],
              [-4.013824022999927, 57.879339911000045],
              [-4.009348110999952, 57.86790599200003],
              [-4.025135870999918, 57.868068752000056],
              [-4.054839647999927, 57.874335028000075],
              [-4.070220506999931, 57.87417226800005],
              [-4.079335089999915, 57.87026601800005],
              [-4.096913214999915, 57.85736725500004],
              [-4.104969855999911, 57.85370514500005],
              [-4.132923956999946, 57.85415273600006],
              [-4.190419074999909, 57.87006256700005],
              [-4.218169725999928, 57.87417226800005],
              [-4.298898891999954, 57.86277903900003],
              [-4.32095292899993, 57.87103913000004],
              [-4.353179490999935, 57.89520905200004],
              [-4.372303839999915, 57.90448639500005],
              [-4.392404751999948, 57.908270575000074],
              [-4.339588995999918, 57.86570872600004],
              [-4.307728644999941, 57.85146719000005],
              [-4.269398566999939, 57.846869208000044],
              [-4.229074673999946, 57.85724518400008],
              [-4.208241339999915, 57.85919830900008],
              [-4.190581834999932, 57.85028717700004],
              [-4.173451300999943, 57.83901601800005],
              [-4.149728969999956, 57.82982005400004],
              [-4.13345292899993, 57.830145575000074],
              [-4.139068162999934, 57.846869208000044],
              [-4.075062628999945, 57.82318756700005],
              [-4.039906378999945, 57.81818268400008],
              [-3.983509894999941, 57.84235260600008],
              [-3.95148678299995, 57.838324286000045],
              [-3.933705206999946, 57.82566966400003],
              [-3.947336391999954, 57.81268952000005],
              [-3.914784308999913, 57.80768463700008],
              [-3.877674933999913, 57.81671784100007],
              [-3.841867641999954, 57.83490631700005],
              [-3.813547329999949, 57.857123114000046],
              [-3.798451300999943, 57.866522528000075],
              [-3.786040818999936, 57.86542389500005],
              [-3.779449022999927, 57.85565827000005],
              [-3.782215949999909, 57.83942291900007],
              [-3.790028449999909, 57.83071523600006],
              [-3.92601477799991, 57.734808661000045],
              [-3.948841925999943, 57.72492096600007],
              [-3.975209113999938, 57.70327383000006],
              [-3.988270636999914, 57.69599030200004],
              [-4.00804602799991, 57.693793036000045],
              [-4.02367102799991, 57.69782135600008],
              [-4.028635219999956, 57.70770905200004],
              [-4.016184048999946, 57.72333405200004],
              [-4.042958136999914, 57.73729075700004],
              [-4.077951626999948, 57.73029205900008],
              [-4.155344204999949, 57.692572333000044],
              [-4.168568488999938, 57.689439195000034],
              [-4.19399980399993, 57.68854401200008],
              [-4.259266730999911, 57.67869700700004],
              [-4.277821417999917, 57.68060944200005],
              [-4.294789191999939, 57.68016185100004],
              [-4.302154100999928, 57.66860586100006],
              [-4.30882727799991, 57.65485260600008],
              [-4.324045376999948, 57.64826080900008],
              [-4.33820553299995, 57.64508698100008],
              [-4.403187628999945, 57.60952383000006],
              [-4.412180141999954, 57.60297272300005],
              [-4.420318162999934, 57.592962958000044],
              [-4.428456183999913, 57.57754140800006],
              [-4.423451300999943, 57.57680898600006],
              [-4.409901495999918, 57.582464911000045],
              [-4.379872199999909, 57.58934153900003],
              [-4.365101691999939, 57.59723541900007],
              [-4.351063605999911, 57.60736725500004],
              [-4.340809699999909, 57.617173570000034],
              [-4.328724738999938, 57.626288153000075],
              [-4.283111131999931, 57.64142487200007],
              [-4.244536912999934, 57.66303131700005],
              [-4.201893683999913, 57.674994208000044],
              [-4.193755662999934, 57.67552317900004],
              [-4.182240363999938, 57.67279694200005],
              [-4.169016079999949, 57.663763739000046],
              [-4.118723110999952, 57.65770091400003],
              [-4.096791144999941, 57.65810781500005],
              [-4.08071855399993, 57.66498444200005],
              [-4.068104620999918, 57.672308661000045],
              [-4.024647589999915, 57.687201239000046],
              [-4.009348110999952, 57.68854401200008],
              [-4.004505988999938, 57.67597077000005],
              [-4.025257941999939, 57.65521881700005],
              [-4.054188605999911, 57.63572825700004],
              [-4.083404100999928, 57.62335846600007],
              [-4.118560350999928, 57.592962958000044],
              [-4.11546790299991, 57.58783600500004],
              [-4.112294074999909, 57.58413320500006],
              [-4.108876105999911, 57.58144765800006],
              [-4.104969855999911, 57.579291083000044],
              [-4.151356574999909, 57.57684967700004],
              [-4.170643683999913, 57.570746161000045],
              [-4.187489386999914, 57.55882396000004],
              [-4.178089972999942, 57.54954661700003],
              [-4.184925910999937, 57.548163153000075],
              [-4.207997199999909, 57.552069403000075],
              [-4.262603318999936, 57.552069403000075],
              [-4.262603318999936, 57.544582424000055],
              [-4.233957485999952, 57.54511139500005],
              [-4.220285610999952, 57.543402411000045],
              [-4.207997199999909, 57.538397528000075],
              [-4.226307745999918, 57.51544830900008],
              [-4.237456834999932, 57.50531647300005],
              [-4.248931443999936, 57.49746328300006],
              [-4.212798631999931, 57.492173570000034],
              [-4.194813605999911, 57.49160390800006],
              [-4.173898891999954, 57.49746328300006],
              [-4.157622850999928, 57.50849030200004],
              [-4.150054490999935, 57.51504140800006],
              [-4.149322068999936, 57.51788971600007],
              [-4.126779751999948, 57.518866278000075],
              [-4.116200324999909, 57.52179596600007],
              [-4.097523566999939, 57.53668854400007],
              [-4.082997199999909, 57.54441966400003],
              [-4.067290818999936, 57.54995351800005],
              [-4.053130662999934, 57.552069403000075],
              [-4.034982876999948, 57.55687083500004],
              [-4.046457485999952, 57.56785716400003],
              [-4.083851691999939, 57.58612702000005],
              [-4.056019660999937, 57.585150458000044],
              [-3.964344855999911, 57.592962958000044],
              [-3.868275519999941, 57.587876695000034],
              [-3.837473110999952, 57.592962958000044],
              [-3.684803839999915, 57.65444570500006],
              [-3.625152147999927, 57.66193268400008],
              [-3.632557745999918, 57.65094635600008],
              [-3.637684699999909, 57.64622630400004],
              [-3.645619269999941, 57.64142487200007],
              [-3.632476365999935, 57.635646877000056],
              [-3.619618292999917, 57.63621653900003],
              [-3.606068488999938, 57.63947174700007],
              [-3.590972459999932, 57.64142487200007],
              [-3.61156165299991, 57.66811758000006],
              [-3.574777798999946, 57.66111888200004],
              [-3.55492102799991, 57.659857489000046],
              [-3.535755988999938, 57.66193268400008],
              [-3.521473761999914, 57.66779205900008],
              [-3.505441860999952, 57.67865631700005],
              [-3.495961066999939, 57.69135163000004],
              [-3.501698370999918, 57.702826239000046],
              [-3.491851365999935, 57.71312083500004],
              [-3.482818162999934, 57.71401601800005],
              [-3.473052537999934, 57.711004950000074],
              [-3.460682745999918, 57.70966217700004],
              [-3.447865363999938, 57.71246979400007],
              [-3.421254035999937, 57.72138092700004],
              [-3.409169074999909, 57.72333405200004],
              [-3.284738735999952, 57.72044505400004],
              [-3.210072394999941, 57.69399648600006],
              [-3.078684048999946, 57.66941966400003],
              [-3.034901495999918, 57.66860586100006],
              [-2.994496222999942, 57.67552317900004],
              [-2.932687954999949, 57.69961172100005],
              [-2.916086391999954, 57.702826239000046],
              [-2.75804602799991, 57.702826239000046],
              [-2.751210089999915, 57.70062897300005],
              [-2.741118943999936, 57.69086334800005],
              [-2.731068488999938, 57.68854401200008],
              [-2.719878709999932, 57.690619208000044],
              [-2.711537238999938, 57.69399648600006],
              [-2.703521287999934, 57.69472890800006],
              [-2.692941860999952, 57.68854401200008],
              [-2.658924933999913, 57.69745514500005],
              [-2.573394334999932, 57.68146393400008],
              [-2.541981574999909, 57.68235911700003],
              [-2.526112433999913, 57.66860586100006],
              [-2.518137173999946, 57.67011139500005],
              [-2.511057094999956, 57.677801825000074],
              [-2.497954881999931, 57.68235911700003],
              [-2.480051235999952, 57.68121979400007],
              [-2.432850714999915, 57.66811758000006],
              [-2.425526495999918, 57.67572663000004],
              [-2.417795376999948, 57.674261786000045],
              [-2.408762173999946, 57.669623114000046],
              [-2.398060675999943, 57.66811758000006],
              [-2.386586066999939, 57.671576239000046],
              [-2.369496222999942, 57.680568752000056],
              [-2.360503709999932, 57.68235911700003],
              [-2.341053839999915, 57.675848700000074],
              [-2.328968878999945, 57.67405833500004],
              [-2.323597785999937, 57.678941148000035],
              [-2.32054602799991, 57.68455638200004],
              [-2.313384568999936, 57.68992747600004],
              [-2.304066535999937, 57.69399648600006],
              [-2.295643683999913, 57.69599030200004],
              [-2.274322068999936, 57.69383372600004],
              [-2.230132615999935, 57.67914459800005],
              [-2.209950324999909, 57.67552317900004],
              [-2.184071417999917, 57.67845286700003],
              [-2.124338344999956, 57.702826239000046],
              [-2.108143683999913, 57.70498281500005],
              [-1.997670050999943, 57.702826239000046],
              [-1.996937628999945, 57.69904205900008],
              [-1.990834113999938, 57.69037506700005],
              [-1.982167120999918, 57.68109772300005],
              [-1.973500128999945, 57.67552317900004],
              [-1.961293097999942, 57.674709377000056],
              [-1.944732225999928, 57.68256256700005],
              [-1.932484503999945, 57.68235911700003],
              [-1.925689256999931, 57.678168036000045],
              [-1.914214647999927, 57.66474030200004],
              [-1.829457160999937, 57.61347077000005],
              [-1.820464647999927, 57.59634023600006],
              [-1.817005988999938, 57.578192450000074],
              [-1.811390753999945, 57.56049225500004],
              [-1.796009894999941, 57.544582424000055],
              [-1.796009894999941, 57.538397528000075],
              [-1.800038214999915, 57.52586497600004],
              [-1.789540167999917, 57.514837958000044],
              [-1.761138475999928, 57.49746328300006],
              [-1.775380011999914, 57.496527411000045],
              [-1.782134568999936, 57.48899974200003],
              [-1.781239386999914, 57.48041413000004],
              [-1.77171790299991, 57.476263739000046],
              [-1.759348110999952, 57.47357819200005],
              [-1.76593990799995, 57.46743398600006],
              [-1.789173956999946, 57.45644765800006],
              [-1.830148891999954, 57.42617422100005],
              [-1.847482876999948, 57.40814850500004],
              [-1.849964972999942, 57.39435455900008],
              [-1.954497850999928, 57.341131903000075],
              [-1.980295376999948, 57.31928131700005],
              [-2.044667120999918, 57.22650788000004],
              [-2.068511522999927, 57.17462799700007],
              [-2.074126756999931, 57.15420156500005],
              [-2.071400519999941, 57.13556549700007],
              [-2.052357550999943, 57.12742747600004],
              [-2.049305792999917, 57.118841864000046],
              [-2.065256313999953, 57.10053131700005],
              [-2.065825975999928, 57.09983958500004],
              [-2.156158006999931, 57.020697333000044],
              [-2.186919725999928, 56.98468659100007],
              [-2.200103318999936, 56.94871653900003],
              [-2.197132941999939, 56.94025299700007],
              [-2.191232876999948, 56.93414948100008],
              [-2.186268683999913, 56.92674388200004],
              [-2.186390753999945, 56.91453685100004],
              [-2.191314256999931, 56.90892161700003],
              [-2.209706183999913, 56.895819403000075],
              [-2.213693813999953, 56.890692450000074],
              [-2.219878709999932, 56.87262604400007],
              [-2.23460852799991, 56.861395575000074],
              [-2.268950975999928, 56.84634023600006],
              [-2.295806443999936, 56.82526276200008],
              [-2.319813605999911, 56.80158112200007],
              [-2.336089647999927, 56.79083893400008],
              [-2.391835089999915, 56.771185614000046],
              [-2.408680792999917, 56.762925523000035],
              [-2.42642167899993, 56.751288153000075],
              [-2.435943162999934, 56.74038320500006],
              [-2.440744594999956, 56.73484935100004],
              [-2.451649542999917, 56.69098541900007],
              [-2.463734503999945, 56.67877838700008],
              [-2.477406378999945, 56.66868724200003],
              [-2.487456834999932, 56.65387604400007],
              [-2.487538214999915, 56.64606354400007],
              [-2.481271938999953, 56.63239166900007],
              [-2.480620897999927, 56.62653229400007],
              [-2.486195441999939, 56.619574286000045],
              [-2.504058397999927, 56.60883209800005],
              [-2.514556443999936, 56.591498114000046],
              [-2.530018683999913, 56.58075592700004],
              [-2.623768683999913, 56.543402411000045],
              [-2.64093990799995, 56.522365627000056],
              [-2.661366339999915, 56.51422760600008],
              [-2.699777798999946, 56.50364817900004],
              [-2.708729620999918, 56.49599844000005],
              [-2.727650519999941, 56.46954987200007],
              [-2.737294074999909, 56.46702708500004],
              [-2.74437415299991, 56.46954987200007],
              [-2.752308722999942, 56.47361888200004],
              [-2.764800584999932, 56.47573476800005],
              [-2.819325324999909, 56.47129954600007],
              [-3.055653449999909, 56.45213450700004],
              [-3.060617641999954, 56.45172760600008],
              [-3.099273240999935, 56.44188060100004],
              [-3.133900519999941, 56.426947333000044],
              [-3.238189256999931, 56.36774323100008],
              [-3.280181443999936, 56.35789622600004],
              [-3.323475714999915, 56.36591217700004],
              [-3.311512824999909, 56.35651276200008],
              [-3.294016079999949, 56.352769273000035],
              [-3.251535610999952, 56.352850653000075],
              [-3.230620897999927, 56.35602448100008],
              [-3.188384568999936, 56.37018463700008],
              [-3.149566209999932, 56.37555573100008],
              [-2.950266079999949, 56.43187083500004],
              [-2.939930792999917, 56.43854401200008],
              [-2.930653449999909, 56.44806549700007],
              [-2.909087693999936, 56.45571523600006],
              [-2.88499915299991, 56.45799388200004],
              [-2.867909308999913, 56.45184967700004],
              [-2.850087042999917, 56.44204336100006],
              [-2.81476803299995, 56.44041575700004],
              [-2.802805141999954, 56.42796458500004],
              [-2.800892706999946, 56.40892161700003],
              [-2.808257615999935, 56.391058661000045],
              [-2.821603969999956, 56.376166083000044],
              [-2.837554490999935, 56.36591217700004],
              [-2.812977667999917, 56.36591217700004],
              [-2.809193488999938, 56.36286041900007],
              [-2.804758266999954, 56.34910716400003],
              [-2.802805141999954, 56.345404364000046],
              [-2.791493292999917, 56.34247467700004],
              [-2.782622850999928, 56.34162018400008],
              [-2.775257941999939, 56.33942291900007],
              [-2.768625454999949, 56.33234284100007],
              [-2.677154100999928, 56.32843659100007],
              [-2.655262824999909, 56.32217031500005],
              [-2.621205206999946, 56.30442942900004],
              [-2.613189256999931, 56.30190664300005],
              [-2.57681230399993, 56.28392161700003],
              [-2.57681230399993, 56.277777411000045],
              [-2.630116339999915, 56.24852122600004],
              [-2.648345506999931, 56.22870514500005],
              [-2.672027147999927, 56.22239817900004],
              [-2.720204230999911, 56.21629466400003],
              [-2.783599412999934, 56.19196198100008],
              [-2.806141730999911, 56.188381252000056],
              [-2.83071855399993, 56.190741278000075],
              [-2.892079230999911, 56.20888906500005],
              [-2.940052863999938, 56.209418036000045],
              [-2.964344855999911, 56.20563385600008],
              [-2.974680141999954, 56.19830963700008],
              [-2.982411261999914, 56.189113674000055],
              [-3.035552537999934, 56.16791413000004],
              [-3.091053839999915, 56.13226959800005],
              [-3.107533331999946, 56.12689850500004],
              [-3.127552863999938, 56.12287018400008],
              [-3.138295050999943, 56.112209377000056],
              [-3.152251756999931, 56.07851797100005],
              [-3.163563605999911, 56.06386953300006],
              [-3.17837480399993, 56.05809153900003],
              [-3.248443162999934, 56.055975653000075],
              [-3.268381313999953, 56.05093008000006],
              [-3.30304928299995, 56.037543036000045],
              [-3.342681443999936, 56.02716705900008],
              [-3.381825324999909, 56.02338288000004],
              [-3.420969204999949, 56.02488841400003],
              [-3.582590298999946, 56.05174388200004],
              [-3.671498175999943, 56.050848700000074],
              [-3.710031704999949, 56.05809153900003],
              [-3.745432094999956, 56.07221100500004],
              [-3.746490037999934, 56.072780666000085],
              [-3.782215949999909, 56.09218984600005],
              [-3.803130662999934, 56.107123114000046],
              [-3.817005988999938, 56.11225006700005],
              [-3.837473110999952, 56.112616278000075],
              [-3.837473110999952, 56.10643138200004],
              [-3.777699347999942, 56.08283112200007],
              [-3.769154425999943, 56.07514069200005],
              [-3.760853644999941, 56.07245514500005],
              [-3.726429816999939, 56.03803131700005],
              [-3.721424933999913, 56.03070709800005],
              [-3.712635870999918, 56.028998114000046],
              [-3.693470831999946, 56.03115469000005],
              [-3.686634894999941, 56.03070709800005],
              [-3.679554816999939, 56.025458075000074],
              [-3.674794074999909, 56.01870351800005],
              [-3.66828365799995, 56.01276276200008],
              [-3.656239386999914, 56.010199286000045],
              [-3.599720831999946, 56.017238674000055],
              [-3.577381964999915, 56.01703522300005],
              [-3.405425584999932, 55.98973216400003],
              [-3.358265753999945, 55.98973216400003],
              [-3.340891079999949, 55.99445221600007],
              [-3.331044074999909, 55.99408600500004],
              [-3.320423956999946, 55.986029364000046],
              [-3.303456183999913, 55.97760651200008],
              [-3.121815558999913, 55.96930573100008],
              [-3.114735480999911, 55.966131903000075],
              [-3.096831834999932, 55.95197174700007],
              [-3.090728318999936, 55.94818756700005],
              [-3.078236456999946, 55.94684479400007],
              [-3.015695766999954, 55.950506903000075],
              [-2.939930792999917, 55.96930573100008],
              [-2.91665605399993, 55.98061758000006],
              [-2.900054490999935, 55.996161200000074],
              [-2.882883266999954, 56.00849030200004],
              [-2.857980923999946, 56.010199286000045],
              [-2.863636847999942, 56.02228424700007],
              [-2.866322394999941, 56.02676015800006],
              [-2.870961066999939, 56.03070709800005],
              [-2.852772589999915, 56.03978099200003],
              [-2.823150193999936, 56.059759833000044],
              [-2.802805141999954, 56.06484609600005],
              [-2.635121222999942, 56.05805084800005],
              [-2.615956183999913, 56.053168036000045],
              [-2.587554490999935, 56.030951239000046],
              [-2.569406704999949, 56.02448151200008],
              [-2.57835852799991, 56.00800202000005],
              [-2.583648240999935, 56.00275299700007],
              [-2.569569464999915, 55.99994538000004],
              [-2.544056769999941, 56.00267161700003],
              [-2.528960740999935, 55.99656810100004],
              [-2.524810350999928, 56.00055573100008],
              [-2.514556443999936, 56.00576406500005],
              [-2.507923956999946, 56.010199286000045],
              [-2.493275519999941, 56.00153229400007],
              [-2.452504035999937, 55.985256252000056],
              [-2.41437740799995, 55.97833893400008],
              [-2.350941535999937, 55.94818756700005],
              [-2.307769334999932, 55.93500397300005],
              [-2.146839972999942, 55.917303778000075],
              [-2.138010219999956, 55.91461823100008],
              [-2.132557745999918, 55.90643952000005],
              [-2.13109290299991, 55.89720286700003],
              [-2.128773566999939, 55.88979726800005],
              [-2.120961066999939, 55.886704820000034],
              [-2.099476691999939, 55.88178131700005],
              [-2.080189581999946, 55.86937083500004],
              [-2.022857225999928, 55.80548737200007],
              [-2.009673631999931, 55.79083893400008],
              [-1.877837693999936, 55.69489166900007],
              [-1.863189256999931, 55.67161692900004],
              [-1.853098110999952, 55.65932851800005],
              [-1.831532355999911, 55.65070221600007],
              [-1.826079881999931, 55.64362213700008],
              [-1.821685350999928, 55.636419989000046],
              [-1.816477016999954, 55.632879950000074],
              [-1.807118292999917, 55.63450755400004],
              [-1.800770636999914, 55.63922760600008],
              [-1.796294725999928, 55.644232489000046],
              [-1.792591925999943, 55.646551825000074],
              [-1.781402147999927, 55.64565664300005],
              [-1.768625454999949, 55.641913153000075],
              [-1.75649980399993, 55.63361237200007],
              [-1.747670050999943, 55.619208075000074],
              [-1.767974412999934, 55.619208075000074],
              [-1.767974412999934, 55.612982489000046],
              [-1.755970831999946, 55.60887278900003],
              [-1.720855272999927, 55.614569403000075],
              [-1.699126756999931, 55.612982489000046],
              [-1.630848761999914, 55.58510976800005],
              [-1.630848761999914, 55.57827383000006],
              [-1.636341925999943, 55.57168203300006],
              [-1.634673631999931, 55.56439850500004],
              [-1.627674933999913, 55.55711497600004],
              [-1.617176886999914, 55.55027903900003],
              [-1.630848761999914, 55.544134833000044],
              [-1.630848761999914, 55.53729889500005],
              [-1.622222459999932, 55.534084377000056],
              [-1.602935350999928, 55.52362702000005],
              [-1.602935350999928, 55.516791083000044],
              [-1.611317511999914, 55.50804271000004],
              [-1.606353318999936, 55.503241278000075],
              [-1.59634355399993, 55.49990469000005],
              [-1.589344855999911, 55.49567291900007],
              [-1.584950324999909, 55.483710028000075],
              [-1.581369594999956, 55.41665273600006],
              [-1.583119269999941, 55.40692780200004],
              [-1.588286912999934, 55.39057038000004],
              [-1.589100714999915, 55.385199286000045],
              [-1.589344855999911, 55.37653229400007],
              [-1.583322719999956, 55.354722398000035],
              [-1.558583136999914, 55.32892487200007],
              [-1.555816209999932, 55.31134674700007],
              [-1.557036912999934, 55.306626695000034],
              [-1.558990037999934, 55.302069403000075],
              [-1.561919725999928, 55.29779694200005],
              [-1.565744594999956, 55.29364655200004],
              [-1.570057745999918, 55.28620026200008],
              [-1.568226691999939, 55.27960846600007],
              [-1.564279751999948, 55.27326080900008],
              [-1.562082485999952, 55.26666901200008],
              [-1.556467251999948, 55.25503164300005],
              [-1.543934699999909, 55.24388255400004],
              [-1.520985480999911, 55.229396877000056],
              [-1.529164191999939, 55.21625397300005],
              [-1.52407792899993, 55.21010976800005],
              [-1.514271613999938, 55.204779364000046],
              [-1.507964647999927, 55.194647528000075],
              [-1.510812954999949, 55.184759833000044],
              [-1.517567511999914, 55.176214911000045],
              [-1.52212480399993, 55.16746653900003],
              [-1.517933722999942, 55.157131252000056],
              [-1.500721808999913, 55.141791083000044],
              [-1.495961066999939, 55.13458893400008],
              [-1.492543097999942, 55.112982489000046],
              [-1.483754035999937, 55.09170156500005],
              [-1.480091925999943, 55.08539459800005],
              [-1.476226365999935, 55.083644924000055],
              [-1.463286912999934, 55.08030833500004],
              [-1.459584113999938, 55.07859935100004],
              [-1.458078579999949, 55.07575104400007],
              [-1.454701300999943, 55.067572333000044],
              [-1.438303188999953, 55.042303778000075],
              [-1.429188605999911, 55.033270575000074],
              [-1.42406165299991, 55.02435944200005],
              [-1.419504360999952, 55.011704820000034],
              [-1.412912563999953, 55.00031159100007],
              [-1.401519334999932, 54.995428778000075],
              [-1.398182745999918, 54.992621161000045],
              [-1.370228644999941, 54.97553131700005],
              [-1.362660285999937, 54.96478913000004],
              [-1.361724412999934, 54.958685614000046],
              [-1.36351477799991, 54.95425039300005],
              [-1.364003058999913, 54.94818756700005],
              [-1.362863735999952, 54.92593008000006],
              [-1.360340949999909, 54.91705963700008],
              [-1.353138800999943, 54.91351959800005],
              [-1.355824347999942, 54.904282945000034],
              [-1.296783006999931, 54.77993398600006],
              [-1.275461391999954, 54.74843984600005],
              [-1.24046790299991, 54.72166575700004],
              [-1.225087042999917, 54.71503327000005],
              [-1.172230597999942, 54.701239325000074],
              [-1.172230597999942, 54.693793036000045],
              [-1.192616339999915, 54.693793036000045],
              [-1.192453579999949, 54.68927643400008],
              [-1.190785285999937, 54.68618398600006],
              [-1.185170050999943, 54.68008047100005],
              [-1.182728644999941, 54.67206452000005],
              [-1.178822394999941, 54.66474030200004],
              [-1.172922329999949, 54.65835195500006],
              [-1.16470292899993, 54.652777411000045],
              [-1.172922329999949, 54.644191799000055],
              [-1.182484503999945, 54.63922760600008],
              [-1.206288214999915, 54.63296133000006],
              [-1.203724738999938, 54.62571849200003],
              [-1.198841925999943, 54.62156810100004],
              [-1.191802537999934, 54.61977773600006],
              [-1.182118292999917, 54.61928945500006],
              [-1.179351365999935, 54.62091705900008],
              [-1.178456183999913, 54.624212958000044],
              [-1.176991339999915, 54.62677643400008],
              [-1.172230597999942, 54.62612539300005],
              [-1.169585740999935, 54.62360260600008],
              [-1.165435350999928, 54.61871979400007],
              [-1.162953253999945, 54.61395905200004],
              [-1.16470292899993, 54.61180247600004],
              [-1.15265865799995, 54.61318594000005],
              [-1.14671790299991, 54.618475653000075],
              [-1.138050910999937, 54.646551825000074],
              [-1.120594855999911, 54.63300202000005],
              [-1.103627081999946, 54.624660549000055],
              [-1.08421790299991, 54.620428778000075],
              [-1.042062954999949, 54.61709219000005],
              [-0.993478969999956, 54.59813060100004],
              [-0.787912563999953, 54.56077708500004],
              [-0.562977667999917, 54.47736237200007],
              [-0.534657355999911, 54.461004950000074],
              [-0.522857225999928, 54.44708893400008],
              [-0.52179928299995, 54.43805573100008],
              [-0.523589647999927, 54.43024323100008],
              [-0.520415818999936, 54.42007070500006],
              [-0.50999915299991, 54.41156647300005],
              [-0.47679602799991, 54.39720286700003],
              [-0.462757941999939, 54.38898346600007],
              [-0.447743292999917, 54.37319570500006],
              [-0.430572068999936, 54.349310614000046],
              [-0.418446417999917, 54.32404205900008],
              [-0.418039516999954, 54.303941148000035],
              [-0.414540167999917, 54.297308661000045],
              [-0.409006313999953, 54.29075755400004],
              [-0.401193813999953, 54.28563060100004],
              [-0.390736456999946, 54.28351471600007],
              [-0.394886847999942, 54.273138739000046],
              [-0.397572394999941, 54.269191799000055],
              [-0.389271613999938, 54.26406484600005],
              [-0.370472785999937, 54.247707424000055],
              [-0.362782355999911, 54.24249909100007],
              [-0.322010870999918, 54.23607005400004],
              [-0.311919725999928, 54.231634833000044],
              [-0.300119594999956, 54.224676825000074],
              [-0.277088995999918, 54.21775950700004],
              [-0.269602016999954, 54.20766836100006],
              [-0.262562628999945, 54.18109772300005],
              [-0.260365363999938, 54.176988023000035],
              [-0.233876105999911, 54.16046784100007],
              [-0.111439581999946, 54.13157786700003],
              [-0.075510219999956, 54.11212799700007],
              [-0.163929816999939, 54.08340078300006],
              [-0.194691535999937, 54.06232330900008],
              [-0.219471808999913, 54.022772528000075],
              [-0.197417772999927, 53.99481842700004],
              [-0.168690558999913, 53.929348049000055],
              [-0.151112433999913, 53.899318752000056],
              [-0.04515540299991, 53.801214911000045],
              [0.133474155000044, 53.642645575000074],
              [0.149261915000068, 53.60960521000004],
              [0.136892123000052, 53.57713450700004],
              [0.131195509000065, 53.573431708000044],
              [0.109629754000082, 53.56289297100005],
              [0.131358269000089, 53.59369538000004],
              [0.135996941000087, 53.610663153000075],
              [0.120209181000064, 53.61810944200005],
              [0.099457227000073, 53.622300523000035],
              [0.056162957000083, 53.64126211100006],
              [0.03451582100007, 53.64606354400007],
              [0.014821811000047, 53.64325592700004],
              [-0.023915167999917, 53.62885163000004],
              [-0.045033331999946, 53.62555573100008],
              [-0.069406704999949, 53.626939195000034],
              [-0.092274542999917, 53.63104889500005],
              [-0.112619594999956, 53.63751862200007],
              [-0.130034959999932, 53.64606354400007],
              [-0.225331183999913, 53.719916083000044],
              [-0.260365363999938, 53.73541901200008],
              [-0.295643683999913, 53.738796291000085],
              [-0.305165167999917, 53.73969147300005],
              [-0.431141730999911, 53.71430084800005],
              [-0.449696417999917, 53.71430084800005],
              [-0.510487433999913, 53.71430084800005],
              [-0.544422980999911, 53.70945872600004],
              [-0.551503058999913, 53.71116771000004],
              [-0.576242641999954, 53.72565338700008],
              [-0.579172329999949, 53.72797272300005],
              [-0.63703365799995, 53.73200104400007],
              [-0.658355272999927, 53.72797272300005],
              [-0.726470506999931, 53.70062897300005],
              [-0.717355923999946, 53.69867584800005],
              [-0.708566860999952, 53.695746161000045],
              [-0.700184699999909, 53.691839911000045],
              [-0.692453579999949, 53.68699778900003],
              [-0.677479620999918, 53.702826239000046],
              [-0.649810350999928, 53.710598049000055],
              [-0.619536912999934, 53.71185944200005],
              [-0.596180792999917, 53.70807526200008],
              [-0.555490688999953, 53.69049713700008],
              [-0.544748501999948, 53.683579820000034],
              [-0.52993730399993, 53.67767975500004],
              [-0.514027472999942, 53.681301174000055],
              [-0.486317511999914, 53.69448476800005],
              [-0.307240363999938, 53.71426015800006],
              [-0.279367641999954, 53.707098700000074],
              [-0.260365363999938, 53.68699778900003],
              [-0.188628709999932, 53.620428778000075],
              [-0.144032355999911, 53.606634833000044],
              [-0.113189256999931, 53.58462148600006],
              [-0.09593665299991, 53.57713450700004],
              [-0.060943162999934, 53.57396067900004],
              [-0.046620245999918, 53.570379950000074],
              [0.000091993000069, 53.53534577000005],
              [0.095957879000082, 53.488348700000074],
              [0.115082227000073, 53.48322174700007],
              [0.134043816000087, 53.48061758000006],
              [0.151866082000083, 53.475816148000035],
              [0.167816602000073, 53.464504299000055],
              [0.170909050000091, 53.457017320000034],
              [0.173106316000087, 53.44676341400003],
              [0.175791863000086, 53.43768952000005],
              [0.181488477000073, 53.43374258000006],
              [0.190603061000047, 53.43187083500004],
              [0.219493035000085, 53.41950104400007],
              [0.211924675000091, 53.41266510600008],
              [0.229340040000068, 53.40477122600004],
              [0.244883660000085, 53.39093659100007],
              [0.256114129000082, 53.375067450000074],
              [0.260427280000044, 53.36147695500006],
              [0.342133009000065, 53.22630442900004],
              [0.356211785000085, 53.18854401200008],
              [0.356618686000047, 53.145738023000035],
              [0.335785352000073, 53.093451239000046],
              [0.32984459700009, 53.08649323100008],
              [0.318695509000065, 53.083685614000046],
              [0.298838738000086, 53.08120351800005],
              [0.282481316000087, 53.07485586100006],
              [0.19304446700005, 53.02008698100008],
              [0.174489780000044, 53.01544830900008],
              [0.160817905000044, 53.008978583000044],
              [0.082123243000069, 52.938666083000044],
              [0.061167839000063, 52.924994208000044],
              [0.037608269000089, 52.919175523000035],
              [0.022146030000044, 52.91258372600004],
              [0.008555535000085, 52.89862702000005],
              [0.010264519000089, 52.88646067900004],
              [0.040660027000058, 52.88507721600007],
              [0.092539910000085, 52.89252350500004],
              [0.105642123000052, 52.88934967700004],
              [0.133474155000044, 52.87518952000005],
              [0.147146030000044, 52.87201569200005],
              [0.170909050000091, 52.86212799700007],
              [0.22242272200009, 52.813666083000044],
              [0.246755405000044, 52.79572174700007],
              [0.264496290000068, 52.80369700700004],
              [0.285655144000089, 52.805568752000056],
              [0.32553144600007, 52.803168036000045],
              [0.341807488000086, 52.79743073100008],
              [0.369883660000085, 52.77301666900007],
              [0.38453209700009, 52.76837799700007],
              [0.38453209700009, 52.77521393400008],
              [0.379242384000065, 52.79083893400008],
              [0.399424675000091, 52.80951569200005],
              [0.42554772200009, 52.827378648000035],
              [0.438649936000047, 52.840725002000056],
              [0.444021030000044, 52.86505768400008],
              [0.45671634200005, 52.89199453300006],
              [0.47234134200005, 52.916449286000045],
              [0.48568769600007, 52.93349844000005],
              [0.520274285000085, 52.95526764500005],
              [0.569590691000087, 52.96930573100008],
              [0.623383009000065, 52.97565338700008],
              [0.671885613000086, 52.97443268400008],
              [0.664398634000065, 52.98187897300005],
              [0.684743686000047, 52.986395575000074],
              [0.70679772200009, 52.98322174700007],
              [0.729177280000044, 52.97748444200005],
              [0.750498894000089, 52.97443268400008],
              [0.83570397200009, 52.97443268400008],
              [0.875498894000089, 52.96816640800006],
              [0.921071811000047, 52.95465729400007],
              [0.96843509200005, 52.94749583500004],
              [1.013926629000082, 52.960150458000044],
              [1.003428582000083, 52.96474844000005],
              [0.99154707100007, 52.96747467700004],
              [0.979014519000089, 52.968410549000055],
              [0.966075066000087, 52.96759674700007],
              [0.966075066000087, 52.97443268400008],
              [1.274668816000087, 52.92918528900003],
              [1.396006707000083, 52.89142487200007],
              [1.64421634200005, 52.775824286000045],
              [1.673350457000083, 52.75568268400008],
              [1.69703209700009, 52.73102448100008],
              [1.715830925000091, 52.68374258000006],
              [1.73414147200009, 52.65460846600007],
              [1.747243686000047, 52.62518952000005],
              [1.740733269000089, 52.60390859600005],
              [1.746836785000085, 52.58852773600006],
              [1.748708530000044, 52.568793036000045],
              [1.747569207000083, 52.53278229400007],
              [1.77116946700005, 52.48590729400007],
              [1.767100457000083, 52.47695547100005],
              [1.754405144000089, 52.46735260600008],
              [1.729258660000085, 52.41559479400007],
              [1.73015384200005, 52.405910549000055],
              [1.72787519600007, 52.39630768400008],
              [1.683604363000086, 52.32453034100007],
              [1.651866082000083, 52.289129950000074],
              [1.641123894000089, 52.28180573100008],
              [1.63054446700005, 52.27045319200005],
              [1.62826582100007, 52.24481842700004],
              [1.630869988000086, 52.19977448100008],
              [1.625498894000089, 52.18036530200004],
              [1.607432488000086, 52.14594147300005],
              [1.603526238000086, 52.127834377000056],
              [1.58920332100007, 52.100816148000035],
              [1.58757571700005, 52.08698151200008],
              [1.582286004000082, 52.08148834800005],
              [1.50367272200009, 52.060980536000045],
              [1.486827019000089, 52.04901764500005],
              [1.47201582100007, 52.05621979400007],
              [1.466807488000086, 52.04800039300005],
              [1.463877800000091, 52.035142320000034],
              [1.455821160000085, 52.028509833000044],
              [1.44898522200009, 52.02496979400007],
              [1.424815300000091, 52.00185781500005],
              [1.35482832100007, 51.95404694200005],
              [1.34351647200009, 51.94285716400009],
              [1.332286004000082, 51.94009023600006],
              [1.264414910000085, 51.99437083500004],
              [1.234873894000089, 52.00031159100007],
              [1.18523196700005, 52.025091864000046],
              [1.15788821700005, 52.028509833000044],
              [1.15788821700005, 52.02167389500005],
              [1.193532748000052, 52.00079987200007],
              [1.214366082000083, 51.991441148000035],
              [1.260264519000089, 51.984808661000045],
              [1.270762566000087, 51.98151276200008],
              [1.27515709700009, 51.976996161000045],
              [1.274424675000091, 51.96088288000004],
              [1.271006707000083, 51.95644765800006],
              [1.250743035000085, 51.95962148600006],
              [1.238942905000044, 51.958644924000055],
              [1.217621290000068, 51.954331773000035],
              [1.205739780000044, 51.95343659100007],
              [1.193207227000073, 51.955511786000045],
              [1.165293816000087, 51.96702708500004],
              [1.143077019000089, 51.966050523000035],
              [1.094493035000085, 51.955959377000056],
              [1.069102410000085, 51.95343659100007],
              [1.09546959700009, 51.945746161000045],
              [1.262054884000065, 51.939154364000046],
              [1.281993035000085, 51.946600653000075],
              [1.278493686000047, 51.92792389500005],
              [1.199554884000065, 51.87767161700003],
              [1.21225019600007, 51.87164948100008],
              [1.22787519600007, 51.86737702000005],
              [1.264414910000085, 51.86399974200003],
              [1.27475019600007, 51.870306708000044],
              [1.282237175000091, 51.880560614000046],
              [1.286631707000083, 51.88165924700007],
              [1.288259311000047, 51.860581773000035],
              [1.276377800000091, 51.84479401200008],
              [1.219248894000089, 51.811835028000075],
              [1.167816602000073, 51.790228583000044],
              [1.135427280000044, 51.78172435100004],
              [1.065440300000091, 51.77529531500005],
              [1.04664147200009, 51.777044989000046],
              [1.037282748000052, 51.78217194200005],
              [1.021332227000073, 51.80255768400008],
              [0.988780144000089, 51.83026764500005],
              [0.97982832100007, 51.84357330900008],
              [0.977061394000089, 51.82461172100005],
              [0.962087436000047, 51.813788153000075],
              [0.92514082100007, 51.80255768400008],
              [0.89429772200009, 51.78461334800005],
              [0.886973504000082, 51.782131252000056],
              [0.88640384200005, 51.776678778000075],
              [0.883474155000044, 51.76471588700008],
              [0.878916863000086, 51.75275299700007],
              [0.873708530000044, 51.747300523000035],
              [0.861989780000044, 51.74555084800005],
              [0.845957879000082, 51.736761786000045],
              [0.83570397200009, 51.733710028000075],
              [0.823496941000087, 51.73383209800005],
              [0.801442905000044, 51.73969147300005],
              [0.791758660000085, 51.74115631700005],
              [0.767100457000083, 51.739447333000044],
              [0.720876498000052, 51.728176174000055],
              [0.69857832100007, 51.720038153000075],
              [0.71420332100007, 51.715277411000045],
              [0.732432488000086, 51.713771877000056],
              [0.749278191000087, 51.70848216400009],
              [0.760752800000091, 51.692694403000075],
              [0.789073113000086, 51.710150458000044],
              [0.853037957000083, 51.71889883000006],
              [0.883555535000085, 51.72687409100007],
              [0.912364129000082, 51.741522528000075],
              [0.930023634000065, 51.74359772300005],
              [0.945567254000082, 51.733710028000075],
              [0.947438998000052, 51.72524648600006],
              [0.944590691000087, 51.71548086100006],
              [0.940440300000091, 51.70799388200004],
              [0.938161655000044, 51.706366278000075],
              [0.940196160000085, 51.698431708000044],
              [0.944021030000044, 51.69057851800005],
              [0.951833530000044, 51.67841217700004],
              [0.941742384000065, 51.673041083000044],
              [0.937998894000089, 51.664496161000045],
              [0.938161655000044, 51.64126211100006],
              [0.934743686000047, 51.63589101800005],
              [0.926768425000091, 51.630926825000074],
              [0.91146894600007, 51.62384674700007],
              [0.938487175000091, 51.624986070000034],
              [0.948090040000068, 51.621527411000045],
              [0.951833530000044, 51.61701080900008],
              [0.924489780000044, 51.588324286000045],
              [0.873301629000082, 51.559475002000056],
              [0.828298373000052, 51.541856187000064],
              [0.816254102000073, 51.537176825000074],
              [0.77125084700009, 51.52826569200005],
              [0.692067905000044, 51.536322333000044],
              [0.664398634000065, 51.53506094000005],
              [0.66374759200005, 51.53554922100005],
              [0.650563998000052, 51.53579336100006],
              [0.646657748000052, 51.53534577000005],
              [0.644053582000083, 51.53506094000005],
              [0.642751498000052, 51.53351471600007],
              [0.623383009000065, 51.52204010600008],
              [0.608653191000087, 51.51898834800005],
              [0.595225457000083, 51.51862213700008],
              [0.582286004000082, 51.51654694200005],
              [0.568858269000089, 51.50836823100008],
              [0.552744988000086, 51.51797109600005],
              [0.547211134000065, 51.51772695500006],
              [0.525401238000086, 51.516913153000075],
              [0.456065300000091, 51.505560614000046],
              [0.45085696700005, 51.49827708500004],
              [0.448008660000085, 51.48822663000004],
              [0.441661004000082, 51.47703685100004],
              [0.428477410000085, 51.46710846600007],
              [0.414073113000086, 51.46190013200004],
              [0.399180535000085, 51.45840078300006],
              [0.38453209700009, 51.453111070000034],
              [0.448415561000047, 51.45994700700004],
              [0.45679772200009, 51.46312083500004],
              [0.461436394000089, 51.47016022300005],
              [0.464854363000086, 51.47724030200004],
              [0.469574415000068, 51.48041413000004],
              [0.53484134200005, 51.49168528900009],
              [0.694834832000083, 51.47703685100004],
              [0.709483269000089, 51.47052643400008],
              [0.721934441000087, 51.456284898000035],
              [0.723155144000089, 51.44672272300005],
              [0.713145379000082, 51.44122955900008],
              [0.692393425000091, 51.439520575000074],
              [0.656504754000082, 51.444525458000044],
              [0.640961134000065, 51.44415924700007],
              [0.609385613000086, 51.425116278000075],
              [0.572764519000089, 51.419582424000055],
              [0.554535352000073, 51.412176825000074],
              [0.56226647200009, 51.40656159100007],
              [0.569102410000085, 51.399603583000044],
              [0.576508009000065, 51.39362213700008],
              [0.585948113000086, 51.391058661000045],
              [0.671885613000086, 51.391058661000045],
              [0.712901238000086, 51.38422272300005],
              [0.704925977000073, 51.39598216400009],
              [0.700368686000047, 51.409816799000055],
              [0.705332879000082, 51.41950104400007],
              [0.726410352000073, 51.41901276200008],
              [0.728363477000073, 51.406236070000034],
              [0.739268425000091, 51.387925523000035],
              [0.753428582000083, 51.371527411000045],
              [0.764414910000085, 51.36440664300005],
              [0.977224155000044, 51.34918854400007],
              [1.10092207100007, 51.37323639500005],
              [1.423838738000086, 51.39207591400009],
              [1.448252800000091, 51.382879950000074],
              [1.43913821700005, 51.35008372600004],
              [1.435557488000086, 51.343736070000034],
              [1.430837436000047, 51.33779531500005],
              [1.42514082100007, 51.33295319200005],
              [1.418630405000044, 51.32965729400007],
              [1.382985873000052, 51.329779364000046],
              [1.377614780000044, 51.326239325000074],
              [1.38062584700009, 51.304754950000074],
              [1.387868686000047, 51.28790924700007],
              [1.404307488000086, 51.261379299000055],
              [1.413096550000091, 51.22174713700008],
              [1.404795769000089, 51.18353913000004],
              [1.38445071700005, 51.151678778000075],
              [1.35718834700009, 51.13100820500006],
              [1.29037519600007, 51.116522528000075],
              [1.262950066000087, 51.10325755400004],
              [1.25163821700005, 51.10252513200004],
              [1.229991082000083, 51.10370514500005],
              [1.21810957100007, 51.10097890800006],
              [1.208262566000087, 51.09467194200005],
              [1.199717644000089, 51.087591864000046],
              [1.192067905000044, 51.08258698100008],
              [1.172211134000065, 51.077378648000035],
              [1.106700066000087, 51.07636139500005],
              [1.087168816000087, 51.07298411700003],
              [1.066905144000089, 51.06439850500004],
              [1.027598504000082, 51.04165273600006],
              [0.976410352000073, 50.99445221600007],
              [0.96648196700005, 50.98273346600007],
              [0.969086134000065, 50.95685455900008],
              [0.97982832100007, 50.91815827000005],
              [0.945160352000073, 50.909369208000044],
              [0.869802280000044, 50.925116278000075],
              [0.802256707000083, 50.93919505400004],
              [0.762461785000085, 50.930894273000035],
              [0.664398634000065, 50.870306708000044],
              [0.624196811000047, 50.858710028000075],
              [0.407481316000087, 50.829331773000035],
              [0.370290561000047, 50.818793036000045],
              [0.365244988000086, 50.81899648600006],
              [0.354258660000085, 50.80963776200008],
              [0.344411655000044, 50.79905833500004],
              [0.342295769000089, 50.79515208500004],
              [0.308116082000083, 50.780951239000046],
              [0.271006707000083, 50.747381903000075],
              [0.233897332000083, 50.74701569200005],
              [0.214121941000087, 50.748928127000056],
              [0.168304884000065, 50.759833075000074],
              [0.157399936000047, 50.761053778000075],
              [0.122080925000091, 50.76080963700008],
              [0.11304772200009, 50.76414622600004],
              [0.095550977000073, 50.775051174000055],
              [0.077036980000059, 50.778998114000046],
              [0.03451582100007, 50.780951239000046],
              [0.017548048000094, 50.784857489000046],
              [-0.173166469999956, 50.829006252000056],
              [-0.206125454999949, 50.83104075700004],
              [-0.208892381999931, 50.83010488500008],
              [-0.233143683999913, 50.821926174000055],
              [-0.269683397999927, 50.831284898000035],
              [-0.397572394999941, 50.802069403000075],
              [-0.568959113999938, 50.802069403000075],
              [-0.73273678299995, 50.767279364000046],
              [-0.741566535999937, 50.769232489000046],
              [-0.749867316999939, 50.773871161000045],
              [-0.758208787999934, 50.77708567900004],
              [-0.767567511999914, 50.774725653000075],
              [-0.773101365999935, 50.76601797100005],
              [-0.76626542899993, 50.74713776200008],
              [-0.770985480999911, 50.73688385600008],
              [-0.789947068999936, 50.73004791900007],
              [-0.81281490799995, 50.73476797100005],
              [-0.904123501999948, 50.77187734600005],
              [-0.911488410999937, 50.77781810100004],
              [-0.905873175999943, 50.78803131700005],
              [-0.892486131999931, 50.794623114000046],
              [-0.863636847999942, 50.802069403000075],
              [-0.863636847999942, 50.808254299000055],
              [-0.873605923999946, 50.812933661000045],
              [-0.893137173999946, 50.82534414300005],
              [-0.904693162999934, 50.829331773000035],
              [-0.909535285999937, 50.82599518400008],
              [-0.921701626999948, 50.821600653000075],
              [-0.928944464999915, 50.82282135600008],
              [-0.919016079999949, 50.83616771000004],
              [-0.929798956999946, 50.83999258000006],
              [-0.939198370999918, 50.84324778900009],
              [-0.970773891999954, 50.846991278000075],
              [-0.994862433999913, 50.84707265800006],
              [-1.001861131999931, 50.84711334800005],
              [-1.020741339999915, 50.84365469000005],
              [-1.033558722999942, 50.82591380400004],
              [-1.042632615999935, 50.80190664300005],
              [-1.056223110999952, 50.78302643400008],
              [-1.082753058999913, 50.780951239000046],
              [-1.103016730999911, 50.79547760600008],
              [-1.093617316999939, 50.812933661000045],
              [-1.075306769999941, 50.83002350500004],
              [-1.069162563999953, 50.84365469000005],
              [-1.087310350999928, 50.84979889500005],
              [-1.08812415299991, 50.84975820500006],
              [-1.149810350999928, 50.84666575700004],
              [-1.16470292899993, 50.84365469000005],
              [-1.129709438999953, 50.825100002000056],
              [-1.123768683999913, 50.818793036000045],
              [-1.121205206999946, 50.79938385600008],
              [-1.124908006999931, 50.788723049000055],
              [-1.138050910999937, 50.780951239000046],
              [-1.151112433999913, 50.78139883000006],
              [-1.169341600999928, 50.78587474200003],
              [-1.185617641999954, 50.79242584800005],
              [-1.192616339999915, 50.79865143400008],
              [-1.199289516999954, 50.807928778000075],
              [-1.231516079999949, 50.81891510600008],
              [-1.255197719999956, 50.83193594000005],
              [-1.288156704999949, 50.839178778000075],
              [-1.30142167899993, 50.84365469000005],
              [-1.31859290299991, 50.85691966400009],
              [-1.338937954999949, 50.872707424000055],
              [-1.449289516999954, 50.91205475500004],
              [-1.466420050999943, 50.91815827000005],
              [-1.466420050999943, 50.91193268400008],
              [-1.456450975999928, 50.90875885600008],
              [-1.437977667999917, 50.90131256700005],
              [-1.425607876999948, 50.900091864000046],
              [-1.401112433999913, 50.88117096600007],
              [-1.323068813999953, 50.82575104400007],
              [-1.314279751999948, 50.812160549000055],
              [-1.317290818999936, 50.80023834800005],
              [-1.339833136999914, 50.79515208500004],
              [-1.403960740999935, 50.79157135600008],
              [-1.418690558999913, 50.788397528000075],
              [-1.411366339999915, 50.78489817900004],
              [-1.40493730399993, 50.780951239000046],
              [-1.40493730399993, 50.774725653000075],
              [-1.450510219999956, 50.76935455900008],
              [-1.476226365999935, 50.76341380400004],
              [-1.487538214999915, 50.75771719000005],
              [-1.491932745999918, 50.75726959800005],
              [-1.524728969999956, 50.761053778000075],
              [-1.557199673999946, 50.72329336100006],
              [-1.559396938999953, 50.71922435100004],
              [-1.56118730399993, 50.71898021000004],
              [-1.58071855399993, 50.722642320000034],
              [-1.602121548999946, 50.731756903000075],
              [-1.670643683999913, 50.74005768400008],
              [-1.672922329999949, 50.74005768400008],
              [-1.693023240999935, 50.739935614000046],
              [-1.71507727799991, 50.73578522300005],
              [-1.753529425999943, 50.72284577000005],
              [-1.77171790299991, 50.72011953300006],
              [-1.797434048999946, 50.723171291000085],
              [-1.835072394999941, 50.72768789300005],
              [-1.857411261999914, 50.72695547100005],
              [-1.877349412999934, 50.72284577000005],
              [-1.896351691999939, 50.71629466400009],
              [-1.896880662999934, 50.716050523000035],
              [-1.913889126999948, 50.70742422100005],
              [-1.929107225999928, 50.69586823100008],
              [-1.940012173999946, 50.69082265800006],
              [-1.944325324999909, 50.69765859600005],
              [-1.946115688999953, 50.707912502000056],
              [-1.949289516999954, 50.713324286000045],
              [-1.987700975999928, 50.72011953300006],
              [-2.01390540299991, 50.71893952000005],
              [-2.021962042999917, 50.72011953300006],
              [-2.025461391999954, 50.723863023000035],
              [-2.026193813999953, 50.72508372600004],
              [-2.03384355399993, 50.73712799700007],
              [-2.038970506999931, 50.739935614000046],
              [-2.048085089999915, 50.734808661000045],
              [-2.08267167899993, 50.69896067900004],
              [-2.069569464999915, 50.700100002000056],
              [-2.057728644999941, 50.702826239000046],
              [-2.046620245999918, 50.70726146000004],
              [-2.035633917999917, 50.713324286000045],
              [-2.014149542999917, 50.688788153000075],
              [-2.002512173999946, 50.681301174000055],
              [-1.984120245999918, 50.67853424700007],
              [-1.96743730399993, 50.67865631700005],
              [-1.952788865999935, 50.67658112200007],
              [-1.945871548999946, 50.668850002000056],
              [-1.952951626999948, 50.65184153900009],
              [-1.938221808999913, 50.645819403000075],
              [-1.932484503999945, 50.64443594000005],
              [-1.967274542999917, 50.61709219000005],
              [-1.965199347999942, 50.60219961100006],
              [-1.983713344999956, 50.59662506700005],
              [-2.065174933999913, 50.59552643400008],
              [-2.082183397999927, 50.59784577000005],
              [-2.157338019999941, 50.62051015800006],
              [-2.342640753999945, 50.63377513200004],
              [-2.377064581999946, 50.64752838700008],
              [-2.398345506999931, 50.64557526200008],
              [-2.435902472999942, 50.63751862200007],
              [-2.447621222999942, 50.62787506700005],
              [-2.460072394999941, 50.60651276200008],
              [-2.465646938999953, 50.585150458000044],
              [-2.456450975999928, 50.575506903000075],
              [-2.431223110999952, 50.57025788000004],
              [-2.428700324999909, 50.55756256700005],
              [-2.439279751999948, 50.54181549700007],
              [-2.45335852799991, 50.52765534100007],
              [-2.459543423999946, 50.52765534100007],
              [-2.460357225999928, 50.56549713700008],
              [-2.483509894999941, 50.59039948100008],
              [-2.692941860999952, 50.69281647300005],
              [-2.864816860999952, 50.73379140800006],
              [-2.887318488999938, 50.734361070000034],
              [-2.94554602799991, 50.725816148000035],
              [-2.962757941999939, 50.72329336100006],
              [-2.998199022999927, 50.708238023000035],
              [-3.021839972999942, 50.70648834800005],
              [-3.059722459999932, 50.713324286000045],
              [-3.071359829999949, 50.711004950000074],
              [-3.094146287999934, 50.69896067900004],
              [-3.099232550999943, 50.69708893400008],
              [-3.115834113999938, 50.68797435100004],
              [-3.125477667999917, 50.68528880400004],
              [-3.135894334999932, 50.68593984600005],
              [-3.155140753999945, 50.69135163000004],
              [-3.166493292999917, 50.69281647300005],
              [-3.185617641999954, 50.690741278000075],
              [-3.219146287999934, 50.68081289300005],
              [-3.259836391999954, 50.67454661700003],
              [-3.271392381999931, 50.664496161000045],
              [-3.280425584999932, 50.65119049700007],
              [-3.29556230399993, 50.63751862200007],
              [-3.368153449999909, 50.61709219000005],
              [-3.390736456999946, 50.61782461100006],
              [-3.407541469999956, 50.62128327000005],
              [-3.420969204999949, 50.62946198100008],
              [-3.433338995999918, 50.64443594000005],
              [-3.446359829999949, 50.66828034100007],
              [-3.450428839999915, 50.672308661000045],
              [-3.453277147999927, 50.67328522300005],
              [-3.455433722999942, 50.675441799000055],
              [-3.458607550999943, 50.67755768400008],
              [-3.464426235999952, 50.67853424700007],
              [-3.467762824999909, 50.67641836100006],
              [-3.468902147999927, 50.67169830900008],
              [-3.467844204999949, 50.66697825700004],
              [-3.45531165299991, 50.657904364000046],
              [-3.44204667899993, 50.62352122600004],
              [-3.433338995999918, 50.610256252000056],
              [-3.451161261999914, 50.59943268400008],
              [-3.467274542999917, 50.585598049000055],
              [-3.481760219999956, 50.56854889500005],
              [-3.494862433999913, 50.548163153000075],
              [-3.505970831999946, 50.520819403000075],
              [-3.505034959999932, 50.501206773000035],
              [-3.487456834999932, 50.459418036000045],
              [-3.509755011999914, 50.45848216400009],
              [-3.532134568999936, 50.454779364000046],
              [-3.549427863999938, 50.446519273000035],
              [-3.556263800999943, 50.43211497600004],
              [-3.549305792999917, 50.41559479400007],
              [-3.531971808999913, 50.410223700000074],
              [-3.487456834999932, 50.41156647300005],
              [-3.487456834999932, 50.40477122600004],
              [-3.497466600999928, 50.38735586100006],
              [-3.49828040299991, 50.383693752000056],
              [-3.507313605999911, 50.382798570000034],
              [-3.514963344999956, 50.37995026200008],
              [-3.520130988999938, 50.37482330900008],
              [-3.526926235999952, 50.34979889500005],
              [-3.538889126999948, 50.34442780200004],
              [-3.554514126999948, 50.347642320000034],
              [-3.57054602799991, 50.35639069200005],
              [-3.577788865999935, 50.334051825000074],
              [-3.599110480999911, 50.325832424000055],
              [-3.621571417999917, 50.321926174000055],
              [-3.631988084999932, 50.31232330900008],
              [-3.63735917899993, 50.29539622600004],
              [-3.647572394999941, 50.27456289300005],
              [-3.653309699999909, 50.25104401200008],
              [-3.645619269999941, 50.22601959800005],
              [-3.660633917999917, 50.22101471600007],
              [-3.700917120999918, 50.21352773600006],
              [-3.718006964999915, 50.21238841400009],
              [-3.740386522999927, 50.21588776200008],
              [-3.758615688999953, 50.22174713700008],
              [-3.774240688999953, 50.22296784100007],
              [-3.788970506999931, 50.21238841400009],
              [-3.826324022999927, 50.23419830900008],
              [-3.884185350999928, 50.280462958000044],
              [-3.949940558999913, 50.31899648600006],
              [-3.961008266999954, 50.322251695000034],
              [-3.970204230999911, 50.320746161000045],
              [-3.995757615999935, 50.311428127000056],
              [-4.005604620999918, 50.30923086100006],
              [-4.011341925999943, 50.30695221600007],
              [-4.024769660999937, 50.29718659100007],
              [-4.032948370999918, 50.294907945000034],
              [-4.044056769999941, 50.29645416900007],
              [-4.054351365999935, 50.30036041900007],
              [-4.070220506999931, 50.30923086100006],
              [-4.067941860999952, 50.31281159100007],
              [-4.064035610999952, 50.322251695000034],
              [-4.086008266999954, 50.326239325000074],
              [-4.108265753999945, 50.33661530200004],
              [-4.118723110999952, 50.35187409100007],
              [-4.104969855999911, 50.37067291900007],
              [-4.141753709999932, 50.36904531500005],
              [-4.152740037999934, 50.37067291900007],
              [-4.165516730999911, 50.37636953300006],
              [-4.171457485999952, 50.382798570000034],
              [-4.175770636999914, 50.39085521000004],
              [-4.18382727799991, 50.40106842700004],
              [-4.191477016999954, 50.417629299000055],
              [-4.18390865799995, 50.431708075000074],
              [-4.170318162999934, 50.44513580900008],
              [-4.159535285999937, 50.459418036000045],
              [-4.179432745999918, 50.45307038000004],
              [-4.189564581999946, 50.45368073100008],
              [-4.200550910999937, 50.459418036000045],
              [-4.203684048999946, 50.45140208500004],
              [-4.204741990999935, 50.44867584800005],
              [-4.212391730999911, 50.441473700000074],
              [-4.222523566999939, 50.43797435100004],
              [-4.234730597999942, 50.43829987200007],
              [-4.234730597999942, 50.43211497600004],
              [-4.220204230999911, 50.425848700000074],
              [-4.216135219999956, 50.415716864000046],
              [-4.219715949999909, 50.40509674700007],
              [-4.228505011999914, 50.397365627000056],
              [-4.241444464999915, 50.39468008000006],
              [-4.289906378999945, 50.397365627000056],
              [-4.273019985999952, 50.38190338700008],
              [-4.216175910999937, 50.38776276200008],
              [-4.193755662999934, 50.37689850500004],
              [-4.228505011999914, 50.37067291900007],
              [-4.228505011999914, 50.36383698100008],
              [-4.220122850999928, 50.365301825000074],
              [-4.200550910999937, 50.36383698100008],
              [-4.207997199999909, 50.35639069200005],
              [-4.180043097999942, 50.35639069200005],
              [-4.180043097999942, 50.35016510600008],
              [-4.191314256999931, 50.34756094000005],
              [-4.197987433999913, 50.342230536000045],
              [-4.199126756999931, 50.33539459800005],
              [-4.193755662999934, 50.32843659100007],
              [-4.193755662999934, 50.322251695000034],
              [-4.214995897999927, 50.323146877000056],
              [-4.225697394999941, 50.33539459800005],
              [-4.235096808999913, 50.34955475500004],
              [-4.252349412999934, 50.35639069200005],
              [-4.337717251999948, 50.37067291900007],
              [-4.383697068999936, 50.36749909100007],
              [-4.456206834999932, 50.33820221600007],
              [-4.495350714999915, 50.32843659100007],
              [-4.659820115999935, 50.322251695000034],
              [-4.659575975999928, 50.32062409100007],
              [-4.662709113999938, 50.31777578300006],
              [-4.667795376999948, 50.315334377000056],
              [-4.673451300999943, 50.31541575700004],
              [-4.687163865999935, 50.34271881700005],
              [-4.694325324999909, 50.343451239000046],
              [-4.700184699999909, 50.34088776200008],
              [-4.705555792999917, 50.337551174000055],
              [-4.711333787999934, 50.33588288000004],
              [-4.731556769999941, 50.33466217700004],
              [-4.752105272999927, 50.33030833500004],
              [-4.763295050999943, 50.32208893400008],
              [-4.755441860999952, 50.30923086100006],
              [-4.755441860999952, 50.30174388200004],
              [-4.76235917899993, 50.298041083000044],
              [-4.771636522999927, 50.29157135600008],
              [-4.779855923999946, 50.28432851800005],
              [-4.783355272999927, 50.27789948100008],
              [-4.78189042899993, 50.27179596600007],
              [-4.776519334999932, 50.26508209800005],
              [-4.776519334999932, 50.26080963700008],
              [-4.788441535999937, 50.24209219000005],
              [-4.790150519999941, 50.23655833500004],
              [-4.800160285999937, 50.22955963700008],
              [-4.849720831999946, 50.23456452000005],
              [-4.868723110999952, 50.22943756700005],
              [-4.887318488999938, 50.21499258000006],
              [-4.904774542999917, 50.20844147300005],
              [-4.947255011999914, 50.19936758000006],
              [-4.960682745999918, 50.19049713700008],
              [-5.002430792999917, 50.14411041900007],
              [-5.014556443999936, 50.15656159100007],
              [-5.020375128999945, 50.19196198100008],
              [-5.033192511999914, 50.19936758000006],
              [-5.05296790299991, 50.19578685100004],
              [-5.053618943999936, 50.18691640800006],
              [-5.051869269999941, 50.17552317900004],
              [-5.064564581999946, 50.16461823100008],
              [-5.064564581999946, 50.15839264500005],
              [-5.058501756999931, 50.155462958000044],
              [-5.043446417999917, 50.14411041900007],
              [-5.051869269999941, 50.144598700000074],
              [-5.058461066999939, 50.14272695500006],
              [-5.070790167999917, 50.13727448100008],
              [-5.08031165299991, 50.13271719000005],
              [-5.081613735999952, 50.12539297100005],
              [-5.080962693999936, 50.117173570000034],
              [-5.085031704999949, 50.10993073100008],
              [-5.093902147999927, 50.105536200000074],
              [-5.125965949999909, 50.09634023600006],
              [-5.114654100999928, 50.09662506700005],
              [-5.106068488999938, 50.09511953300006],
              [-5.091867641999954, 50.089504299000055],
              [-5.086903449999909, 50.089056708000044],
              [-5.075347459999932, 50.09048086100006],
              [-5.070790167999917, 50.089504299000055],
              [-5.068470831999946, 50.085150458000044],
              [-5.064930792999917, 50.07184479400007],
              [-5.06086178299995, 50.06903717700004],
              [-5.056507941999939, 50.060614325000074],
              [-5.069488084999932, 50.042181708000044],
              [-5.098052537999934, 50.01439036700003],
              [-5.107289191999939, 50.013006903000075],
              [-5.127430792999917, 50.01544830900008],
              [-5.139637824999909, 50.01439036700003],
              [-5.146473761999914, 50.01056549700007],
              [-5.176136847999942, 49.987941799000055],
              [-5.18773352799991, 49.964504299000055],
              [-5.191151495999918, 49.95913320500006],
              [-5.200103318999936, 49.961371161000045],
              [-5.210357225999928, 49.96674225500004],
              [-5.240386522999927, 49.988348700000074],
              [-5.245228644999941, 49.99310944200005],
              [-5.249501105999911, 50.000067450000074],
              [-5.253041144999941, 50.01264069200005],
              [-5.25226803299995, 50.020697333000044],
              [-5.252674933999913, 50.027777411000045],
              [-5.259755011999914, 50.03766510600008],
              [-5.288400844999956, 50.067694403000075],
              [-5.304351365999935, 50.08026764500005],
              [-5.323963995999918, 50.089504299000055],
              [-5.384185350999928, 50.10797760600008],
              [-5.424712693999936, 50.11273834800005],
              [-5.458119269999941, 50.125881252000056],
              [-5.47484290299991, 50.13043854400007],
              [-5.495676235999952, 50.12962474200003],
              [-5.521839972999942, 50.12372467700004],
              [-5.540923631999931, 50.11347077000005],
              [-5.540638800999943, 50.09975820500006],
              [-5.534657355999911, 50.08234284100007],
              [-5.54556230399993, 50.06891510600008],
              [-5.563465949999909, 50.05963776200008],
              [-5.57843990799995, 50.054754950000074],
              [-5.61945553299995, 50.046210028000075],
              [-5.667388475999928, 50.04287344000005],
              [-5.705148891999954, 50.05231354400007],
              [-5.715646938999953, 50.08270905200004],
              [-5.705962693999936, 50.08348216400009],
              [-5.698801235999952, 50.08539459800005],
              [-5.694488084999932, 50.089504299000055],
              [-5.694406704999949, 50.095770575000074],
              [-5.697092251999948, 50.10053131700005],
              [-5.700306769999941, 50.103216864000046],
              [-5.701975063999953, 50.103176174000055],
              [-5.707386847999942, 50.12201569200005],
              [-5.70921790299991, 50.13263580900008],
              [-5.70539303299995, 50.13727448100008],
              [-5.703521287999934, 50.140611070000034],
              [-5.684641079999949, 50.16152578300006],
              [-5.676747199999909, 50.16502513200004],
              [-5.647368943999936, 50.17206452000005],
              [-5.583607550999943, 50.19586823100008],
              [-5.549427863999938, 50.20351797100005],
              [-5.510975714999915, 50.21946849200003],
              [-5.489125128999945, 50.21979401200008],
              [-5.458119269999941, 50.20075104400007],
              [-5.437977667999917, 50.19432200700004],
              [-5.417388475999928, 50.202460028000075],
              [-5.402943488999938, 50.21735260600008],
              [-5.395863410999937, 50.22724030200004],
              [-5.39289303299995, 50.23655833500004],
              [-5.387562628999945, 50.240301825000074],
              [-5.351918097999942, 50.240301825000074],
              [-5.314849412999934, 50.253607489000046],
              [-5.200306769999941, 50.33075592700004],
              [-5.163563605999911, 50.34723541900007],
              [-5.149891730999911, 50.35016510600008],
              [-5.146473761999914, 50.35529205900008],
              [-5.145659959999932, 50.366888739000046],
              [-5.147043423999946, 50.37938060100004],
              [-5.153675910999937, 50.39948151200008],
              [-5.142404751999948, 50.40448639500005],
              [-5.12726803299995, 50.40521881700005],
              [-5.119740363999938, 50.40477122600004],
              [-5.050282355999911, 50.42869700700004],
              [-5.048166469999956, 50.43439362200007],
              [-5.038726365999935, 50.44790273600006],
              [-5.029774542999917, 50.486761786000045],
              [-5.028635219999956, 50.507025458000044],
              [-5.025257941999939, 50.52423737200007],
              [-5.015614386999914, 50.53803131700005],
              [-4.995594855999911, 50.548163153000075],
              [-4.975168423999946, 50.548163153000075],
              [-4.967844204999949, 50.55158112200007],
              [-4.954823370999918, 50.56122467700004],
              [-4.947255011999914, 50.56244538000004],
              [-4.941477016999954, 50.55695221600007],
              [-4.937123175999943, 50.54531484600005],
              [-4.934437628999945, 50.53164297100005],
              [-4.933583136999914, 50.52024974200003],
              [-4.926869269999941, 50.52289459800005],
              [-4.924305792999917, 50.52448151200008],
              [-4.920521613999938, 50.52765534100007],
              [-4.902414516999954, 50.52057526200008],
              [-4.860951300999943, 50.519191799000055],
              [-4.844838019999941, 50.51406484600005],
              [-4.855824347999942, 50.527411200000074],
              [-4.87328040299991, 50.534084377000056],
              [-4.906239386999914, 50.54197825700004],
              [-4.921864386999914, 50.55487702000005],
              [-4.92023678299995, 50.564154364000046],
              [-4.915191209999932, 50.57249583500004],
              [-4.920521613999938, 50.58295319200005],
              [-4.920521613999938, 50.589178778000075],
              [-4.895659959999932, 50.585923570000034],
              [-4.821197068999936, 50.589178778000075],
              [-4.792469855999911, 50.59520091400009],
              [-4.776600714999915, 50.60984935100004],
              [-4.765044725999928, 50.62799713700008],
              [-4.749256964999915, 50.64443594000005],
              [-4.755441860999952, 50.659369208000044],
              [-4.751942511999914, 50.67007070500006],
              [-4.741932745999918, 50.67487213700008],
              [-4.728138800999943, 50.672308661000045],
              [-4.657297329999949, 50.71112702000005],
              [-4.645578579999949, 50.723537502000056],
              [-4.637806769999941, 50.74115631700005],
              [-4.619007941999939, 50.754787502000056],
              [-4.577259894999941, 50.774725653000075],
              [-4.550119594999956, 50.80955638200004],
              [-4.55492102799991, 50.897772528000075],
              [-4.543771938999953, 50.93919505400004],
              [-4.536854620999918, 50.94757721600007],
              [-4.522694464999915, 50.972723700000074],
              [-4.526682094999956, 50.98037344000005],
              [-4.530425584999932, 50.99469635600008],
              [-4.531320766999954, 51.008693752000056],
              [-4.526437954999949, 51.014960028000075],
              [-4.437326626999948, 51.014960028000075],
              [-4.42642167899993, 51.01268138200004],
              [-4.405751105999911, 51.00287506700005],
              [-4.395741339999915, 51.00067780200004],
              [-4.337717251999948, 50.99664948100008],
              [-4.317290818999936, 51.00067780200004],
              [-4.302316860999952, 51.007513739000046],
              [-4.234730597999942, 51.05532461100006],
              [-4.22915605399993, 51.06110260600008],
              [-4.224680141999954, 51.06708405200004],
              [-4.218495245999918, 51.07245514500005],
              [-4.207997199999909, 51.07636139500005],
              [-4.214263475999928, 51.086004950000074],
              [-4.226307745999918, 51.11322663000004],
              [-4.228505011999914, 51.120428778000075],
              [-4.231922980999911, 51.12669505400004],
              [-4.249012824999909, 51.14288971600007],
              [-4.255767381999931, 51.15151601800005],
              [-4.222320115999935, 51.149725653000075],
              [-4.214833136999914, 51.15151601800005],
              [-4.208363410999937, 51.16229889500005],
              [-4.209828253999945, 51.17283763200004],
              [-4.217274542999917, 51.18138255400004],
              [-4.228505011999914, 51.18622467700004],
              [-4.228505011999914, 51.19245026200008],
              [-4.152333136999914, 51.21161530200004],
              [-3.969471808999913, 51.22239817900004],
              [-3.931996222999942, 51.231350002000056],
              [-3.913197394999941, 51.23338450700004],
              [-3.840891079999949, 51.23338450700004],
              [-3.818959113999938, 51.23607005400004],
              [-3.787098761999914, 51.24677155200004],
              [-3.769154425999943, 51.247707424000055],
              [-3.639759894999941, 51.22638580900008],
              [-3.559315558999913, 51.22809479400007],
              [-3.434193488999938, 51.20978424700007],
              [-3.404367641999954, 51.19204336100006],
              [-3.38499915299991, 51.18622467700004],
              [-3.270741339999915, 51.18939850500004],
              [-3.198882615999935, 51.203558661000045],
              [-3.16274980399993, 51.206732489000046],
              [-3.096750454999949, 51.20453522300005],
              [-3.057525193999936, 51.20815664300005],
              [-3.029286261999914, 51.220404364000046],
              [-3.021839972999942, 51.21356842700004],
              [-3.035552537999934, 51.199286200000074],
              [-3.021839972999942, 51.19245026200008],
              [-3.004790818999936, 51.21312083500004],
              [-3.001332160999937, 51.220404364000046],
              [-2.999582485999952, 51.23322174700007],
              [-3.001535610999952, 51.23969147300005],
              [-3.004994269999941, 51.24506256700005],
              [-3.008168097999942, 51.25454336100006],
              [-3.007639126999948, 51.29197825700004],
              [-3.010609503999945, 51.310980536000045],
              [-3.021839972999942, 51.32282135600008],
              [-3.002430792999917, 51.31907786700003],
              [-2.992176886999914, 51.321926174000055],
              [-2.992095506999931, 51.32204824400009],
              [-2.988392706999946, 51.33112213700008],
              [-2.987782355999911, 51.34666575700004],
              [-2.979888475999928, 51.35586172100005],
              [-2.965972459999932, 51.364935614000046],
              [-2.959584113999938, 51.374253648000035],
              [-2.974680141999954, 51.38422272300005],
              [-2.952951626999948, 51.398504950000074],
              [-2.921009894999941, 51.39443594000005],
              [-2.884185350999928, 51.41697825700004],
              [-2.816395636999914, 51.47361888200004],
              [-2.798573370999918, 51.48261139500005],
              [-2.780873175999943, 51.48908112200007],
              [-2.761219855999911, 51.49286530200004],
              [-2.737619594999956, 51.49408600500004],
              [-2.716420050999943, 51.49957916900007],
              [-2.696156378999945, 51.51264069200005],
              [-2.607818162999934, 51.60736725500004],
              [-2.599598761999914, 51.611395575000074],
              [-2.589222785999937, 51.61424388200004],
              [-2.580433722999942, 51.61863841400009],
              [-2.57681230399993, 51.62750885600008],
              [-2.57445227799991, 51.63572825700004],
              [-2.568959113999938, 51.644964911000045],
              [-2.562245245999918, 51.65338776200008],
              [-2.556385870999918, 51.65924713700008],
              [-2.499175584999932, 51.69676341400009],
              [-2.464995897999927, 51.725897528000075],
              [-2.447743292999917, 51.73187897300005],
              [-2.404896613999938, 51.74115631700005],
              [-2.388539191999939, 51.750433661000045],
              [-2.380767381999931, 51.76190827000005],
              [-2.383371548999946, 51.77326080900008],
              [-2.398060675999943, 51.782131252000056],
              [-2.402414516999954, 51.76357656500005],
              [-2.420399542999917, 51.753119208000044],
              [-2.443430141999954, 51.74843984600005],
              [-2.463286912999934, 51.747300523000035],
              [-2.482085740999935, 51.74286530200004],
              [-2.495838995999918, 51.73200104400007],
              [-2.507964647999927, 51.71857330900008],
              [-2.52212480399993, 51.706366278000075],
              [-2.581695115999935, 51.681708075000074],
              [-2.591135219999956, 51.67536041900007],
              [-2.600209113999938, 51.66559479400007],
              [-2.665353969999956, 51.617254950000074],
            ],
          ],
          [
            [
              [-1.082753058999913, 50.713324286000045],
              [-1.062326626999948, 50.69281647300005],
              [-1.062326626999948, 50.68528880400004],
              [-1.066965298999946, 50.685248114000046],
              [-1.069650844999956, 50.68349844000005],
              [-1.071888800999943, 50.680975653000075],
              [-1.075306769999941, 50.67853424700007],
              [-1.112700975999928, 50.67145416900007],
              [-1.128651495999918, 50.666449286000045],
              [-1.156361456999946, 50.65078359600005],
              [-1.162220831999946, 50.64598216400009],
              [-1.16470292899993, 50.64093659100007],
              [-1.164133266999954, 50.61937083500004],
              [-1.165028449999909, 50.60822174700007],
              [-1.168446417999917, 50.60346100500004],
              [-1.279204881999931, 50.58250560100004],
              [-1.315541144999941, 50.589178778000075],
              [-1.44595292899993, 50.648138739000046],
              [-1.452788865999935, 50.654282945000034],
              [-1.485951300999943, 50.66933828300006],
              [-1.497425910999937, 50.672308661000045],
              [-1.535145636999914, 50.66937897300005],
              [-1.551503058999913, 50.66510651200008],
              [-1.569488084999932, 50.65802643400008],
              [-1.545318162999934, 50.68610260600008],
              [-1.505930141999954, 50.70770905200004],
              [-1.418690558999913, 50.73379140800006],
              [-1.420887824999909, 50.730454820000034],
              [-1.423451300999943, 50.72370026200008],
              [-1.425363735999952, 50.72011953300006],
              [-1.400868292999917, 50.721991278000075],
              [-1.377552863999938, 50.73419830900008],
              [-1.343495245999918, 50.761053778000075],
              [-1.318511522999927, 50.77216217700004],
              [-1.295765753999945, 50.77317942900004],
              [-1.144276495999918, 50.73379140800006],
              [-1.119536912999934, 50.73419830900008],
              [-1.109120245999918, 50.732855536000045],
              [-1.097035285999937, 50.72695547100005],
              [-1.096424933999913, 50.72443268400008],
              [-1.097645636999914, 50.716009833000044],
              [-1.097035285999937, 50.713324286000045],
              [-1.094227667999917, 50.71263255400004],
              [-1.085560675999943, 50.71401601800005],
              [-1.082753058999913, 50.713324286000045],
            ],
          ],
          [
            [
              [-0.959868943999936, 50.808254299000055],
              [-0.959868943999936, 50.802069403000075],
              [-0.954579230999911, 50.798814195000034],
              [-0.94562740799995, 50.79181549700007],
              [-0.938832160999937, 50.788397528000075],
              [-0.938832160999937, 50.780951239000046],
              [-1.020741339999915, 50.788397528000075],
              [-1.020741339999915, 50.79515208500004],
              [-0.99868730399993, 50.80101146000004],
              [-0.972564256999931, 50.829779364000046],
              [-0.959868943999936, 50.829331773000035],
              [-0.950306769999941, 50.82379791900007],
              [-0.947824673999946, 50.81781647300005],
              [-0.95140540299991, 50.81244538000004],
              [-0.959868943999936, 50.808254299000055],
            ],
          ],
          [
            [
              [0.91146894600007, 51.412176825000074],
              [0.932465040000068, 51.397691148000035],
              [0.942149285000085, 51.38300202000005],
              [0.936371290000068, 51.37103913000004],
              [0.91146894600007, 51.36440664300005],
              [0.794769727000073, 51.37055084800005],
              [0.77507571700005, 51.37531159100007],
              [0.75757897200009, 51.386419989000046],
              [0.74350019600007, 51.400091864000046],
              [0.733897332000083, 51.412176825000074],
              [0.746836785000085, 51.43964264500005],
              [0.753916863000086, 51.44570547100005],
              [0.76693769600007, 51.44794342700004],
              [0.890798373000052, 51.42104726800005],
              [0.900563998000052, 51.41754791900007],
              [0.91146894600007, 51.412176825000074],
            ],
          ],
          [
            [
              [-4.577259894999941, 53.27204010600008],
              [-4.572743292999917, 53.266506252000056],
              [-4.563954230999911, 53.26044342700004],
              [-4.558461066999939, 53.25275299700007],
              [-4.563628709999932, 53.24192942900004],
              [-4.571888800999943, 53.239488023000035],
              [-4.581898566999939, 53.24201080900008],
              [-4.602406378999945, 53.25307851800005],
              [-4.622792120999918, 53.27594635600008],
              [-4.632557745999918, 53.28294505400004],
              [-4.641346808999913, 53.284369208000044],
              [-4.670399542999917, 53.28294505400004],
              [-4.676665818999936, 53.28510163000004],
              [-4.693959113999938, 53.302801825000074],
              [-4.693959113999938, 53.30963776200008],
              [-4.667307094999956, 53.323919989000046],
              [-4.655669725999928, 53.31976959800005],
              [-4.644195115999935, 53.319525458000044],
              [-4.626291469999956, 53.32086823100008],
              [-4.618885870999918, 53.31708405200004],
              [-4.60383053299995, 53.30817291900007],
              [-4.590443488999938, 53.29755280200004],
              [-4.580922003999945, 53.28546784100007],
              [-4.577259894999941, 53.27204010600008],
            ],
          ],
          [
            [
              [-4.098133917999917, 53.30963776200008],
              [-4.068918423999946, 53.31037018400008],
              [-4.055043097999942, 53.30853913000004],
              [-4.042876756999931, 53.302801825000074],
              [-4.063384568999936, 53.28929271000004],
              [-4.098052537999934, 53.25014883000006],
              [-4.121978318999936, 53.24192942900004],
              [-4.14671790299991, 53.23908112200007],
              [-4.171986456999946, 53.23139069200005],
              [-4.19554602799991, 53.22028229400007],
              [-4.214833136999914, 53.20722077000005],
              [-4.218495245999918, 53.20404694200005],
              [-4.220366990999935, 53.20148346600007],
              [-4.22101803299995, 53.19745514500005],
              [-4.22101803299995, 53.19013092700004],
              [-4.222035285999937, 53.18211497600004],
              [-4.225005662999934, 53.18121979400007],
              [-4.229359503999945, 53.18219635600008],
              [-4.264556443999936, 53.16693756700005],
              [-4.280140753999945, 53.15497467700004],
              [-4.343861456999946, 53.132066148000035],
              [-4.354359503999945, 53.12995026200008],
              [-4.366688605999911, 53.13141510600008],
              [-4.392404751999948, 53.138332424000055],
              [-4.392689581999946, 53.136053778000075],
              [-4.39867102799991, 53.13275788000004],
              [-4.406605597999942, 53.13060130400004],
              [-4.412831183999913, 53.132066148000035],
              [-4.41429602799991, 53.13784414300005],
              [-4.413685675999943, 53.14712148600006],
              [-4.411976691999939, 53.155585028000075],
              [-4.409738735999952, 53.159409898000035],
              [-4.401926235999952, 53.163723049000055],
              [-4.390370245999918, 53.173081773000035],
              [-4.385121222999942, 53.18244049700007],
              [-4.395741339999915, 53.186712958000044],
              [-4.410878058999913, 53.18219635600008],
              [-4.432850714999915, 53.16290924700007],
              [-4.44758053299995, 53.159409898000035],
              [-4.448557094999956, 53.162543036000045],
              [-4.481678839999915, 53.17987702000005],
              [-4.484486456999946, 53.18060944200005],
              [-4.49250240799995, 53.179348049000055],
              [-4.495350714999915, 53.17987702000005],
              [-4.496001756999931, 53.18256256700005],
              [-4.494699673999946, 53.19086334800005],
              [-4.495350714999915, 53.19354889500005],
              [-4.495106574999909, 53.196478583000044],
              [-4.49632727799991, 53.20380280200004],
              [-4.499623175999943, 53.21124909100007],
              [-4.519886847999942, 53.22284577000005],
              [-4.553089972999942, 53.26194896000004],
              [-4.571034308999913, 53.275458075000074],
              [-4.571034308999913, 53.28294505400004],
              [-4.565256313999953, 53.293036200000074],
              [-4.563221808999913, 53.308254299000055],
              [-4.563628709999932, 53.330064195000034],
              [-4.558664516999954, 53.363348700000074],
              [-4.56086178299995, 53.377834377000056],
              [-4.571034308999913, 53.39276764500005],
              [-4.553456183999913, 53.40058014500005],
              [-4.425363735999952, 53.42670319200005],
              [-4.412831183999913, 53.426947333000044],
              [-4.343495245999918, 53.42007070500006],
              [-4.324696417999917, 53.41950104400007],
              [-4.286529100999928, 53.40643952000005],
              [-4.276722785999937, 53.40102773600006],
              [-4.271880662999934, 53.38906484600005],
              [-4.269357876999948, 53.37710195500006],
              [-4.266021287999934, 53.37164948100008],
              [-4.266916469999956, 53.36896393400008],
              [-4.254505988999938, 53.36322663000004],
              [-4.240061001999948, 53.35834381700005],
              [-4.234730597999942, 53.35805898600006],
              [-4.233713344999956, 53.35297272300005],
              [-4.234852667999917, 53.346136786000045],
              [-4.235178188999953, 53.34007396000004],
              [-4.231556769999941, 53.337591864000046],
              [-4.230620897999927, 53.335272528000075],
              [-4.214833136999914, 53.323919989000046],
              [-4.209339972999942, 53.31240469000005],
              [-4.207427537999934, 53.303900458000044],
              [-4.203236456999946, 53.298488674000055],
              [-4.190581834999932, 53.296576239000046],
              [-4.177805141999954, 53.29755280200004],
              [-4.154896613999938, 53.30182526200008],
              [-4.142486131999931, 53.302801825000074],
              [-4.136626756999931, 53.30508047100005],
              [-4.127797003999945, 53.31484609600005],
              [-4.121978318999936, 53.31708405200004],
              [-4.115142381999931, 53.31590403900003],
              [-4.102528449999909, 53.31077708500004],
              [-4.098133917999917, 53.30963776200008],
            ],
          ],
          [
            [
              [-6.236398891999954, 55.31134674700007],
              [-6.184803839999915, 55.30683014500005],
              [-6.174305792999917, 55.303900458000044],
              [-6.171864386999914, 55.29319896000004],
              [-6.178089972999942, 55.280585028000075],
              [-6.187570766999954, 55.26935455900008],
              [-6.194813605999911, 55.262925523000035],
              [-6.193267381999931, 55.27098216400003],
              [-6.192860480999911, 55.27578359600005],
              [-6.191761847999942, 55.279364325000074],
              [-6.187977667999917, 55.28400299700007],
              [-6.211089647999927, 55.29531484600005],
              [-6.235829230999911, 55.29669830900008],
              [-6.260609503999945, 55.29507070500006],
              [-6.283558722999942, 55.29706452000005],
              [-6.272531704999949, 55.30304596600007],
              [-6.261463995999918, 55.307521877000056],
              [-6.249623175999943, 55.31028880400004],
              [-6.236398891999954, 55.31134674700007],
            ],
          ],
          [
            [
              [-5.070790167999917, 55.50934479400007],
              [-5.093006964999915, 55.500433661000045],
              [-5.091053839999915, 55.48729075700004],
              [-5.080799933999913, 55.47166575700004],
              [-5.078236456999946, 55.45530833500004],
              [-5.09203040299991, 55.44611237200007],
              [-5.117787238999938, 55.43976471600007],
              [-5.163563605999911, 55.434881903000075],
              [-5.217355923999946, 55.43797435100004],
              [-5.263091600999928, 55.44721100500004],
              [-5.304676886999914, 55.462144273000035],
              [-5.345692511999914, 55.48265208500004],
              [-5.345692511999914, 55.489447333000044],
              [-5.346180792999917, 55.49603913000004],
              [-5.355336066999939, 55.52289459800005],
              [-5.359364386999914, 55.530462958000044],
              [-5.359364386999914, 55.53729889500005],
              [-5.354237433999913, 55.53978099200003],
              [-5.352284308999913, 55.542303778000075],
              [-5.350412563999953, 55.54547760600008],
              [-5.345692511999914, 55.55027903900003],
              [-5.370432094999956, 55.57025788000004],
              [-5.389068162999934, 55.59023672100005],
              [-5.397857225999928, 55.61420319200005],
              [-5.39289303299995, 55.646551825000074],
              [-5.379383917999917, 55.66811758000006],
              [-5.355213995999918, 55.68960195500006],
              [-5.324330206999946, 55.70502350500004],
              [-5.290516730999911, 55.70856354400007],
              [-5.292591925999943, 55.71198151200008],
              [-5.29515540299991, 55.71942780200004],
              [-5.297352667999917, 55.72284577000005],
              [-5.271351691999939, 55.723822333000044],
              [-5.263172980999911, 55.72284577000005],
              [-5.198312954999949, 55.704331773000035],
              [-5.180653449999909, 55.69489166900007],
              [-5.159982876999948, 55.676214911000045],
              [-5.145985480999911, 55.65497467700004],
              [-5.125965949999909, 55.605536200000074],
              [-5.137440558999913, 55.59202708500004],
              [-5.094227667999917, 55.56655508000006],
              [-5.091867641999954, 55.544134833000044],
              [-5.101673956999946, 55.540716864000046],
              [-5.116037563999953, 55.54043203300006],
              [-5.12523352799991, 55.53693268400008],
              [-5.119740363999938, 55.52362702000005],
              [-5.11156165299991, 55.51992422100005],
              [-5.070790167999917, 55.50934479400007],
            ],
          ],
          [
            [
              [-5.029774542999917, 55.74949778900003],
              [-5.019032355999911, 55.745306708000044],
              [-5.011341925999943, 55.73769765800006],
              [-5.009388800999943, 55.72931549700007],
              [-5.016184048999946, 55.72284577000005],
              [-5.028797980999911, 55.72333405200004],
              [-5.038482225999928, 55.73187897300005],
              [-5.050282355999911, 55.74949778900003],
              [-5.115589972999942, 55.784369208000044],
              [-5.125965949999909, 55.80101146000004],
              [-5.137562628999945, 55.82904694200005],
              [-5.139637824999909, 55.84198639500005],
              [-5.174224412999934, 55.85537344000005],
              [-5.180653449999909, 55.86277903900003],
              [-5.188588019999941, 55.878119208000044],
              [-5.200795050999943, 55.89549388200004],
              [-5.19953365799995, 55.91107819200005],
              [-5.166900193999936, 55.92084381700005],
              [-5.135975714999915, 55.905951239000046],
              [-5.105539516999954, 55.886704820000034],
              [-5.096506313999953, 55.88353099200003],
              [-5.087635870999918, 55.88263580900008],
              [-5.080922003999945, 55.87958405200004],
              [-5.075184699999909, 55.85691966400003],
              [-5.068023240999935, 55.85211823100008],
              [-5.05882727799991, 55.85016510600008],
              [-5.050282355999911, 55.845770575000074],
              [-5.038075324999909, 55.83242422100005],
              [-5.028920050999943, 55.81928131700005],
              [-5.021839972999942, 55.80560944200005],
              [-5.011463995999918, 55.77448151200008],
              [-5.012766079999949, 55.76837799700007],
              [-5.019195115999935, 55.76316966400003],
              [-5.029774542999917, 55.74949778900003],
            ],
          ],
          [
            [
              [-6.030384894999941, 55.72907135600008],
              [-6.032785610999952, 55.717678127000056],
              [-6.032338019999941, 55.706366278000075],
              [-6.029286261999914, 55.69623444200005],
              [-6.023508266999954, 55.68813711100006],
              [-6.023508266999954, 55.68187083500004],
              [-6.03538977799991, 55.67845286700003],
              [-6.045725063999953, 55.674261786000045],
              [-6.053618943999936, 55.66836172100005],
              [-6.058257615999935, 55.660142320000034],
              [-6.064442511999914, 55.667629299000055],
              [-6.082427537999934, 55.65208567900004],
              [-6.105458136999914, 55.64020416900007],
              [-6.131906704999949, 55.63182200700004],
              [-6.160023566999939, 55.626654364000046],
              [-6.202544725999928, 55.630560614000046],
              [-6.215321417999917, 55.626654364000046],
              [-6.222767706999946, 55.605536200000074],
              [-6.226958787999934, 55.60175202000005],
              [-6.23656165299991, 55.59560781500005],
              [-6.261870897999927, 55.58380768400008],
              [-6.28734290299991, 55.57843659100007],
              [-6.31118730399993, 55.583238023000035],
              [-6.325184699999909, 55.605536200000074],
              [-6.319243943999936, 55.628241278000075],
              [-6.297474738999938, 55.64248281500005],
              [-6.243234829999949, 55.660142320000034],
              [-6.264800584999932, 55.69550202000005],
              [-6.277088995999918, 55.704006252000056],
              [-6.316761847999942, 55.71507396000004],
              [-6.325184699999909, 55.71539948100008],
              [-6.32095292899993, 55.73346588700008],
              [-6.295521613999938, 55.75189850500004],
              [-6.249989386999914, 55.77684153900003],
              [-6.27179928299995, 55.78302643400008],
              [-6.300445115999935, 55.78579336100006],
              [-6.328724738999938, 55.78314850500004],
              [-6.349029100999928, 55.773423570000034],
              [-6.372547980999911, 55.738714911000045],
              [-6.386586066999939, 55.722316799000055],
              [-6.418568488999938, 55.70962148600006],
              [-6.450306769999941, 55.68256256700005],
              [-6.462961391999954, 55.67446523600006],
              [-6.490956183999913, 55.67182038000004],
              [-6.503529425999943, 55.681341864000046],
              [-6.502430792999917, 55.69765859600005],
              [-6.489654100999928, 55.71539948100008],
              [-6.494699673999946, 55.717230536000045],
              [-6.498605923999946, 55.721136786000045],
              [-6.503895636999914, 55.72284577000005],
              [-6.493234829999949, 55.73924388200004],
              [-6.448638475999928, 55.77684153900003],
              [-6.482167120999918, 55.79047272300005],
              [-6.46906490799995, 55.796942450000074],
              [-6.460804816999939, 55.80320872600004],
              [-6.456654425999943, 55.81264883000006],
              [-6.455474412999934, 55.82835521000004],
              [-6.452788865999935, 55.84088776200008],
              [-6.445220506999931, 55.848822333000044],
              [-6.409087693999936, 55.86359284100007],
              [-6.354481574999909, 55.87742747600004],
              [-6.342640753999945, 55.88491445500006],
              [-6.331369594999956, 55.889960028000075],
              [-6.318348761999914, 55.886704820000034],
              [-6.325917120999918, 55.88035716400003],
              [-6.33820553299995, 55.851996161000045],
              [-6.33820553299995, 55.845770575000074],
              [-6.33071855399993, 55.827826239000046],
              [-6.323231574999909, 55.82050202000005],
              [-6.310902472999942, 55.818426825000074],
              [-6.310902472999942, 55.82526276200008],
              [-6.318430141999954, 55.844916083000044],
              [-6.296986456999946, 55.867173570000034],
              [-6.264800584999932, 55.88540273600006],
              [-6.229074673999946, 55.89728424700007],
              [-6.204253709999932, 55.91657135600008],
              [-6.191395636999914, 55.92084381700005],
              [-6.177154100999928, 55.923081773000035],
              [-6.162220831999946, 55.92845286700003],
              [-6.14907792899993, 55.935207424000055],
              [-6.140126105999911, 55.94135163000004],
              [-6.130116339999915, 55.93939850500004],
              [-6.12368730399993, 55.93549225500004],
              [-6.120228644999941, 55.92942942900004],
              [-6.115956183999913, 55.886786200000074],
              [-6.102365688999953, 55.831244208000044],
              [-6.099232550999943, 55.80101146000004],
              [-6.093088344999956, 55.79169342700004],
              [-6.079090949999909, 55.78148021000004],
              [-6.063954230999911, 55.77338288000004],
              [-6.054554816999939, 55.77000560100004],
              [-6.049794074999909, 55.76634349200003],
              [-6.052316860999952, 55.75804271000004],
              [-6.05687415299991, 55.74884674700007],
              [-6.058257615999935, 55.74274323100008],
              [-6.053212042999917, 55.73729075700004],
              [-6.046620245999918, 55.73354726800005],
              [-6.030384894999941, 55.72907135600008],
            ],
          ],
          [
            [
              [-6.20571855399993, 56.102728583000044],
              [-6.198231574999909, 56.10626862200007],
              [-6.182606574999909, 56.10260651200008],
              [-6.174305792999917, 56.10643138200004],
              [-6.177398240999935, 56.110256252000056],
              [-6.179025844999956, 56.112941799000055],
              [-6.181792772999927, 56.11945221600007],
              [-6.164947068999936, 56.120794989000046],
              [-6.149403449999909, 56.12494538000004],
              [-6.138010219999956, 56.124701239000046],
              [-6.133371548999946, 56.112616278000075],
              [-6.165638800999943, 56.08148834800005],
              [-6.177154100999928, 56.06146881700005],
              [-6.174305792999917, 56.04376862200007],
              [-6.194325324999909, 56.03530508000006],
              [-6.221669074999909, 56.03082916900007],
              [-6.249175584999932, 56.031317450000074],
              [-6.269886847999942, 56.037543036000045],
              [-6.254302537999934, 56.044623114000046],
              [-6.246815558999913, 56.05613841400003],
              [-6.241688605999911, 56.06948476800005],
              [-6.23265540299991, 56.08161041900007],
              [-6.211740688999953, 56.096991278000075],
              [-6.20571855399993, 56.102728583000044],
            ],
          ],
          [
            [
              [-5.797596808999913, 56.112616278000075],
              [-5.746490037999934, 56.14175039300005],
              [-5.715931769999941, 56.15314362200007],
              [-5.694488084999932, 56.14740631700005],
              [-5.690825975999928, 56.13784414300005],
              [-5.687977667999917, 56.12409088700008],
              [-5.689320441999939, 56.111761786000045],
              [-5.705067511999914, 56.10301341400003],
              [-5.720122850999928, 56.08812083500004],
              [-5.740223761999914, 56.07648346600007],
              [-5.780181443999936, 56.020738023000035],
              [-5.864491339999915, 55.92674388200004],
              [-5.886341925999943, 55.886704820000034],
              [-5.896839972999942, 55.88890208500004],
              [-5.921538865999935, 55.87128327000005],
              [-5.93814042899993, 55.86627838700008],
              [-5.945423956999946, 55.858587958000044],
              [-5.95539303299995, 55.82005442900004],
              [-5.962066209999932, 55.804754950000074],
              [-5.987538214999915, 55.794623114000046],
              [-6.026600714999915, 55.796087958000044],
              [-6.062408006999931, 55.809475002000056],
              [-6.078114386999914, 55.83490631700005],
              [-6.086903449999909, 55.88296133000006],
              [-6.084950324999909, 55.90033600500004],
              [-6.075184699999909, 55.91596100500004],
              [-6.060170050999943, 55.92291901200008],
              [-6.043120897999927, 55.92796458500004],
              [-6.026966925999943, 55.937933661000045],
              [-5.997425910999937, 55.95172760600008],
              [-5.919056769999941, 55.96039459800005],
              [-5.886341925999943, 55.97614166900007],
              [-5.910023566999939, 55.97650788000004],
              [-5.946848110999952, 55.97064850500004],
              [-5.98070227799991, 55.969916083000044],
              [-5.995594855999911, 55.986029364000046],
              [-5.983265753999945, 56.00885651200008],
              [-5.955189581999946, 56.03473541900007],
              [-5.924427863999938, 56.055975653000075],
              [-5.903960740999935, 56.06484609600005],
              [-5.87368730399993, 56.07013580900008],
              [-5.797596808999913, 56.112616278000075],
            ],
          ],
          [
            [
              [-5.688303188999953, 56.202053127000056],
              [-5.680897589999915, 56.194566148000035],
              [-5.673654751999948, 56.178941148000035],
              [-5.694203253999945, 56.16860586100006],
              [-5.725209113999938, 56.16282786700003],
              [-5.749134894999941, 56.16107819200005],
              [-5.738352016999954, 56.17747630400004],
              [-5.722238735999952, 56.18707916900007],
              [-5.688303188999953, 56.202053127000056],
            ],
          ],
          [
            [
              [-5.63312740799995, 56.26349518400008],
              [-5.627837693999936, 56.25999583500004],
              [-5.622954881999931, 56.25763580900008],
              [-5.618031378999945, 56.25812409100007],
              [-5.612619594999956, 56.26349518400008],
              [-5.610585089999915, 56.24941640800006],
              [-5.618153449999909, 56.23505280200004],
              [-5.628163214999915, 56.22052643400008],
              [-5.637440558999913, 56.18927643400008],
              [-5.647572394999941, 56.195379950000074],
              [-5.66665605399993, 56.22247955900008],
              [-5.656402147999927, 56.23200104400007],
              [-5.645334438999953, 56.255926825000074],
              [-5.63312740799995, 56.26349518400008],
            ],
          ],
          [
            [
              [-5.63312740799995, 56.31875234600005],
              [-5.620757615999935, 56.324204820000034],
              [-5.59788977799991, 56.32184479400007],
              [-5.58462480399993, 56.32558828300006],
              [-5.590443488999938, 56.31362539300005],
              [-5.599964972999942, 56.30548737200007],
              [-5.605336066999939, 56.296942450000074],
              [-5.598988410999937, 56.28392161700003],
              [-5.621693488999938, 56.27606842700004],
              [-5.640288865999935, 56.28278229400007],
              [-5.64671790299991, 56.29877350500004],
              [-5.63312740799995, 56.31875234600005],
            ],
          ],
          [
            [
              [-5.557972785999937, 56.41429271000004],
              [-5.526519334999932, 56.41356028900003],
              [-5.51235917899993, 56.41543203300006],
              [-5.502756313999953, 56.421128648000035],
              [-5.518055792999917, 56.40387604400007],
              [-5.536203579999949, 56.392238674000055],
              [-5.557972785999937, 56.38646067900004],
              [-5.58462480399993, 56.38703034100007],
              [-5.579823370999918, 56.39642975500004],
              [-5.573963995999918, 56.40289948100008],
              [-5.557972785999937, 56.41429271000004],
            ],
          ],
          [
            [
              [-6.160023566999939, 56.46954987200007],
              [-6.212473110999952, 56.46784088700008],
              [-6.237456834999932, 56.470038153000075],
              [-6.263661261999914, 56.48322174700007],
              [-6.253244594999956, 56.49286530200004],
              [-6.242054816999939, 56.49957916900007],
              [-6.229603644999941, 56.50332265800006],
              [-6.215321417999917, 56.50364817900004],
              [-6.200754360999952, 56.49494049700007],
              [-6.17056230399993, 56.48114655200004],
              [-6.160023566999939, 56.46954987200007],
            ],
          ],
          [
            [
              [-6.81859290299991, 56.53782786700003],
              [-6.767201300999943, 56.54857005400004],
              [-6.741851365999935, 56.54783763200004],
              [-6.729237433999913, 56.53034088700008],
              [-6.743316209999932, 56.51780833500004],
              [-6.803822394999941, 56.51361725500004],
              [-6.805572068999936, 56.49689362200007],
              [-6.825510219999956, 56.48729075700004],
              [-6.847727016999954, 56.484808661000045],
              [-6.869292772999927, 56.47964101800005],
              [-6.887521938999953, 56.462103583000044],
              [-6.881581183999913, 56.44428131700005],
              [-6.902455206999946, 56.44375234600005],
              [-6.965199347999942, 56.459865627000056],
              [-6.973988410999937, 56.47150299700007],
              [-6.979725714999915, 56.48712799700007],
              [-6.989898240999935, 56.50364817900004],
              [-6.968129035999937, 56.51048411700003],
              [-6.900502081999946, 56.51666901200008],
              [-6.878081834999932, 56.52130768400008],
              [-6.841135219999956, 56.53473541900007],
              [-6.81859290299991, 56.53782786700003],
            ],
          ],
          [
            [
              [-5.688303188999953, 56.434800523000035],
              [-5.679554816999939, 56.42796458500004],
              [-5.664947068999936, 56.41388580900008],
              [-5.657622850999928, 56.400091864000046],
              [-5.670318162999934, 56.393784898000035],
              [-5.703033006999931, 56.39337799700007],
              [-5.71743730399993, 56.397365627000056],
              [-5.715646938999953, 56.40810781500005],
              [-5.721669074999909, 56.41233958500004],
              [-5.727894660999937, 56.41429271000004],
              [-5.73468990799995, 56.41478099200003],
              [-5.742339647999927, 56.41429271000004],
              [-5.739084438999953, 56.40119049700007],
              [-5.751088019999941, 56.38939036700003],
              [-5.783924933999913, 56.37335846600007],
              [-5.783924933999913, 56.36591217700004],
              [-5.767974412999934, 56.372748114000046],
              [-5.749989386999914, 56.37714264500005],
              [-5.712228969999956, 56.380194403000075],
              [-5.69595292899993, 56.375433661000045],
              [-5.702707485999952, 56.364569403000075],
              [-5.719960089999915, 56.352769273000035],
              [-5.808705206999946, 56.31891510600008],
              [-5.848215298999946, 56.31362539300005],
              [-5.880116339999915, 56.32558828300006],
              [-5.87368730399993, 56.328558661000045],
              [-5.862700975999928, 56.335150458000044],
              [-5.853505011999914, 56.34369538000004],
              [-5.85220292899993, 56.352850653000075],
              [-5.860422329999949, 56.35834381700005],
              [-5.872670050999943, 56.35773346600007],
              [-5.897206183999913, 56.352850653000075],
              [-5.902333136999914, 56.349676825000074],
              [-5.907785610999952, 56.34259674700007],
              [-5.914784308999913, 56.33551666900007],
              [-5.924183722999942, 56.33234284100007],
              [-5.957875128999945, 56.32807038000004],
              [-6.037464972999942, 56.30524323100008],
              [-6.054554816999939, 56.29450104400007],
              [-6.065988735999952, 56.28921133000006],
              [-6.078521287999934, 56.291083075000074],
              [-6.090931769999941, 56.29572174700007],
              [-6.102365688999953, 56.29824453300006],
              [-6.112538214999915, 56.296210028000075],
              [-6.136301235999952, 56.28693268400008],
              [-6.146962042999917, 56.28392161700003],
              [-6.239816860999952, 56.28392161700003],
              [-6.245757615999935, 56.28074778900003],
              [-6.250355597999942, 56.27374909100007],
              [-6.256459113999938, 56.26666901200008],
              [-6.266835089999915, 56.26349518400008],
              [-6.279286261999914, 56.264105536000045],
              [-6.300038214999915, 56.268011786000045],
              [-6.327504035999937, 56.27724844000005],
              [-6.345611131999931, 56.288316148000035],
              [-6.360178188999953, 56.303615627000056],
              [-6.366118943999936, 56.32217031500005],
              [-6.357004360999952, 56.33633047100005],
              [-6.335438605999911, 56.34454987200007],
              [-6.310292120999918, 56.347357489000046],
              [-6.290394660999937, 56.345404364000046],
              [-6.274525519999941, 56.334865627000056],
              [-6.261219855999911, 56.320298570000034],
              [-6.247222459999932, 56.31167226800005],
              [-6.228911912999934, 56.31875234600005],
              [-6.228911912999934, 56.32558828300006],
              [-6.236805792999917, 56.326605536000045],
              [-6.241118943999936, 56.32827383000006],
              [-6.244536912999934, 56.33026764500005],
              [-6.249989386999914, 56.33234284100007],
              [-6.231760219999956, 56.33690013200004],
              [-6.186634894999941, 56.331244208000044],
              [-6.170887824999909, 56.33576080900008],
              [-6.153920050999943, 56.34479401200008],
              [-6.084950324999909, 56.352850653000075],
              [-6.039906378999945, 56.37103913000004],
              [-6.020822719999956, 56.382025458000044],
              [-6.026966925999943, 56.38703034100007],
              [-6.046945766999954, 56.383978583000044],
              [-6.105458136999914, 56.36591217700004],
              [-6.154042120999918, 56.35895416900007],
              [-6.178944464999915, 56.35993073100008],
              [-6.198557094999956, 56.36961497600004],
              [-6.203236456999946, 56.38031647300005],
              [-6.198841925999943, 56.390326239000046],
              [-6.189198370999918, 56.397772528000075],
              [-6.17804928299995, 56.40062083500004],
              [-6.164784308999913, 56.40253327000005],
              [-6.157215949999909, 56.40737539300005],
              [-6.142648891999954, 56.42796458500004],
              [-6.139637824999909, 56.435248114000046],
              [-6.135121222999942, 56.44232819200005],
              [-6.126535610999952, 56.448431708000044],
              [-6.116932745999918, 56.450384833000044],
              [-6.081532355999911, 56.448431708000044],
              [-6.021839972999942, 56.464097398000035],
              [-6.009836391999954, 56.46954987200007],
              [-6.004017706999946, 56.479681708000044],
              [-6.003285285999937, 56.48940664300005],
              [-6.007476365999935, 56.49762604400007],
              [-6.016672329999949, 56.50364817900004],
              [-6.081125454999949, 56.48505280200004],
              [-6.102365688999953, 56.48322174700007],
              [-6.109974738999938, 56.48069896000004],
              [-6.118478969999956, 56.476263739000046],
              [-6.127430792999917, 56.47435130400004],
              [-6.136789516999954, 56.47943756700005],
              [-6.153065558999913, 56.500067450000074],
              [-6.162098761999914, 56.50922272300005],
              [-6.174305792999917, 56.51666901200008],
              [-6.194935675999943, 56.52334219000005],
              [-6.288482225999928, 56.53229401200008],
              [-6.307728644999941, 56.53729889500005],
              [-6.324330206999946, 56.544256903000075],
              [-6.33820553299995, 56.552069403000075],
              [-6.290394660999937, 56.571966864000046],
              [-6.298695441999939, 56.581244208000044],
              [-6.319203253999945, 56.59398021000004],
              [-6.325184699999909, 56.60610586100006],
              [-6.288441535999937, 56.60797760600008],
              [-6.27212480399993, 56.612209377000056],
              [-6.256255662999934, 56.620347398000035],
              [-6.247425910999937, 56.612616278000075],
              [-6.238636847999942, 56.608587958000044],
              [-6.230213995999918, 56.608587958000044],
              [-6.222767706999946, 56.612941799000055],
              [-6.220285610999952, 56.63226959800005],
              [-6.190744594999956, 56.64492422100005],
              [-6.151275193999936, 56.65180084800005],
              [-6.119048631999931, 56.65387604400007],
              [-6.105336066999939, 56.648504950000074],
              [-6.058257615999935, 56.64020416900007],
              [-6.059925910999937, 56.63568756700005],
              [-6.062652147999927, 56.62482330900008],
              [-6.064442511999914, 56.620347398000035],
              [-6.03351803299995, 56.618841864000046],
              [-6.008778449999909, 56.59870026200008],
              [-5.968251105999911, 56.54466380400004],
              [-5.965199347999942, 56.53766510600008],
              [-5.96515865799995, 56.53107330900008],
              [-5.962554490999935, 56.52610911700003],
              [-5.952137824999909, 56.52415599200003],
              [-5.85220292899993, 56.52415599200003],
              [-5.844146287999934, 56.52057526200008],
              [-5.836903449999909, 56.51463450700004],
              [-5.829457160999937, 56.51080963700008],
              [-5.814035610999952, 56.51666901200008],
              [-5.804188605999911, 56.51776764500005],
              [-5.794341600999928, 56.51666901200008],
              [-5.78734290299991, 56.51361725500004],
              [-5.765207485999952, 56.494208075000074],
              [-5.756662563999953, 56.49005768400008],
              [-5.746937628999945, 56.48843008000006],
              [-5.728423631999931, 56.49017975500004],
              [-5.721831834999932, 56.49005768400008],
              [-5.710357225999928, 56.48484935100004],
              [-5.696766730999911, 56.47565338700008],
              [-5.685536261999914, 56.464056708000044],
              [-5.680897589999915, 56.45184967700004],
              [-5.673451300999943, 56.44969310100004],
              [-5.65884355399993, 56.45172760600008],
              [-5.648426886999914, 56.44773997600004],
              [-5.653553839999915, 56.42796458500004],
              [-5.661854620999918, 56.43138255400004],
              [-5.670033331999946, 56.43309153900003],
              [-5.688303188999953, 56.434800523000035],
            ],
          ],
          [
            [
              [-6.45921790299991, 56.67812734600005],
              [-6.468739386999914, 56.66815827000005],
              [-6.482533331999946, 56.64789459800005],
              [-6.489654100999928, 56.64020416900007],
              [-6.497222459999932, 56.63434479400007],
              [-6.504953579999949, 56.630072333000044],
              [-6.514271613999938, 56.62742747600004],
              [-6.527251756999931, 56.62653229400007],
              [-6.564116990999935, 56.59870026200008],
              [-6.616322394999941, 56.57518138200004],
              [-6.63304602799991, 56.571966864000046],
              [-6.657215949999909, 56.577826239000046],
              [-6.668934699999909, 56.577785549000055],
              [-6.673980272999927, 56.56854889500005],
              [-6.677886522999927, 56.558254299000055],
              [-6.686838344999956, 56.563788153000075],
              [-6.696278449999909, 56.57599518400008],
              [-6.701893683999913, 56.585638739000046],
              [-6.67446855399993, 56.58844635600008],
              [-6.648101365999935, 56.602850653000075],
              [-6.602894660999937, 56.64362213700008],
              [-6.591379360999952, 56.65184153900003],
              [-6.55923417899993, 56.665269273000035],
              [-6.535633917999917, 56.67084381700005],
              [-6.505848761999914, 56.68537018400008],
              [-6.489654100999928, 56.688666083000044],
              [-6.462310350999928, 56.69122955900008],
              [-6.452544725999928, 56.68842194200005],
              [-6.45921790299991, 56.67812734600005],
            ],
          ],
          [
            [
              [-7.393950975999928, 57.010199286000045],
              [-7.389068162999934, 57.003607489000046],
              [-7.386097785999937, 56.995306708000044],
              [-7.381988084999932, 56.987534898000035],
              [-7.373524542999917, 56.982855536000045],
              [-7.402414516999954, 56.98338450700004],
              [-7.411040818999936, 56.979722398000035],
              [-7.419178839999915, 56.97333405200004],
              [-7.427235480999911, 56.96857330900008],
              [-7.435047980999911, 56.965277411000045],
              [-7.442372199999909, 56.962958075000074],
              [-7.436838344999956, 56.95368073100008],
              [-7.445301886999914, 56.94708893400008],
              [-7.460804816999939, 56.94318268400008],
              [-7.476551886999914, 56.94188060100004],
              [-7.541411912999934, 56.94871653900003],
              [-7.556752081999946, 56.95307038000004],
              [-7.556223110999952, 56.96263255400004],
              [-7.544911261999914, 56.972316799000055],
              [-7.528065558999913, 56.976629950000074],
              [-7.516509568999936, 56.98118724200003],
              [-7.511586066999939, 56.99164459800005],
              [-7.514027472999942, 57.00291575700004],
              [-7.524322068999936, 57.010199286000045],
              [-7.499908006999931, 57.02008698100008],
              [-7.475697394999941, 57.02301666900007],
              [-7.457102016999954, 57.03156159100007],
              [-7.449208136999914, 57.058579820000034],
              [-7.444691535999937, 57.05853913000004],
              [-7.441395636999914, 57.05719635600008],
              [-7.434966600999928, 57.05174388200004],
              [-7.428130662999934, 57.05133698100008],
              [-7.422963019999941, 57.050116278000075],
              [-7.418690558999913, 57.048041083000044],
              [-7.414418097999942, 57.044907945000034],
              [-7.428781704999949, 57.02773672100005],
              [-7.434966600999928, 57.02383047100005],
              [-7.402821417999917, 57.01463450700004],
              [-7.393950975999928, 57.010199286000045],
            ],
          ],
          [
            [
              [-6.325184699999909, 57.058579820000034],
              [-6.272938605999911, 57.040228583000044],
              [-6.250965949999909, 57.026556708000044],
              [-6.269886847999942, 57.017564195000034],
              [-6.269886847999942, 57.010199286000045],
              [-6.243234829999949, 57.010199286000045],
              [-6.256743943999936, 56.97378164300005],
              [-6.27603105399993, 56.953111070000034],
              [-6.303618943999936, 56.94399648600006],
              [-6.341867641999954, 56.94188060100004],
              [-6.359771287999934, 56.947333075000074],
              [-6.376128709999932, 56.97117747600004],
              [-6.390288865999935, 56.976629950000074],
              [-6.405384894999941, 56.980536200000074],
              [-6.436756964999915, 56.998480536000045],
              [-6.455474412999934, 57.003973700000074],
              [-6.395253058999913, 57.04193756700005],
              [-6.364247199999909, 57.05565013200004],
              [-6.325184699999909, 57.058579820000034],
            ],
          ],
          [
            [
              [-6.606353318999936, 57.05174388200004],
              [-6.590809699999909, 57.05898672100005],
              [-6.556304490999935, 57.07013580900008],
              [-6.537464972999942, 57.07282135600008],
              [-6.525868292999917, 57.06712474200003],
              [-6.501535610999952, 57.063666083000044],
              [-6.489654100999928, 57.058579820000034],
              [-6.51593990799995, 57.05068594000005],
              [-6.548247850999928, 57.04759349200003],
              [-6.580433722999942, 57.04840729400007],
              [-6.606353318999936, 57.05174388200004],
            ],
          ],
          [
            [
              [-5.958607550999943, 57.284491278000075],
              [-5.984852667999917, 57.29043203300006],
              [-6.007801886999914, 57.303615627000056],
              [-6.01390540299991, 57.31745026200008],
              [-5.989979620999918, 57.325506903000075],
              [-5.95571855399993, 57.321600653000075],
              [-5.929351365999935, 57.30719635600008],
              [-5.925445115999935, 57.29169342700004],
              [-5.958607550999943, 57.284491278000075],
            ],
          ],
          [
            [
              [-7.243763800999943, 57.325506903000075],
              [-7.232004360999952, 57.318793036000045],
              [-7.222645636999914, 57.310614325000074],
              [-7.211822068999936, 57.30487702000005],
              [-7.195423956999946, 57.30560944200005],
              [-7.200347459999932, 57.29096100500004],
              [-7.209706183999913, 57.28546784100007],
              [-7.221424933999913, 57.282131252000056],
              [-7.233225063999953, 57.274318752000056],
              [-7.239165818999936, 57.265285549000055],
              [-7.249582485999952, 57.24469635600008],
              [-7.256743943999936, 57.23672109600005],
              [-7.276112433999913, 57.231756903000075],
              [-7.353016730999911, 57.24290599200003],
              [-7.353016730999911, 57.23672109600005],
              [-7.288807745999918, 57.225897528000075],
              [-7.271066860999952, 57.21625397300005],
              [-7.262196417999917, 57.200873114000046],
              [-7.257720506999931, 57.179754950000074],
              [-7.259917772999927, 57.159816799000055],
              [-7.271066860999952, 57.14793528900003],
              [-7.288441535999937, 57.153998114000046],
              [-7.307606574999909, 57.15582916900007],
              [-7.346180792999917, 57.15477122600004],
              [-7.346180792999917, 57.14793528900003],
              [-7.32843990799995, 57.146185614000046],
              [-7.292469855999911, 57.148871161000045],
              [-7.277251756999931, 57.14793528900003],
              [-7.25999915299991, 57.14004140800006],
              [-7.248402472999942, 57.12946198100008],
              [-7.235951300999943, 57.121161200000074],
              [-7.215891079999949, 57.12006256700005],
              [-7.215891079999949, 57.11383698100008],
              [-7.239125128999945, 57.10053131700005],
              [-7.321685350999928, 57.10993073100008],
              [-7.353016730999911, 57.09955475500004],
              [-7.381988084999932, 57.118353583000044],
              [-7.390695766999954, 57.12905508000006],
              [-7.41665605399993, 57.18158600500004],
              [-7.420399542999917, 57.19773997600004],
              [-7.414418097999942, 57.209418036000045],
              [-7.414418097999942, 57.21625397300005],
              [-7.431467251999948, 57.22943756700005],
              [-7.442290818999936, 57.23460521000004],
              [-7.455433722999942, 57.23672109600005],
              [-7.442738410999937, 57.24477773600006],
              [-7.434966600999928, 57.25189850500004],
              [-7.421945766999954, 57.27090078300006],
              [-7.417307094999956, 57.28143952000005],
              [-7.414947068999936, 57.29010651200008],
              [-7.409982876999948, 57.29596588700008],
              [-7.397084113999938, 57.298163153000075],
              [-7.389719204999949, 57.31195709800005],
              [-7.401519334999932, 57.34235260600008],
              [-7.428130662999934, 57.387600002000056],
              [-7.40843665299991, 57.39557526200008],
              [-7.362863735999952, 57.407863674000055],
              [-7.353016730999911, 57.40802643400008],
              [-7.263579881999931, 57.373928127000056],
              [-7.272084113999938, 57.37026601800005],
              [-7.279123501999948, 57.36994049700007],
              [-7.298410610999952, 57.373928127000056],
              [-7.298410610999952, 57.36709219000005],
              [-7.276356574999909, 57.36473216400003],
              [-7.244862433999913, 57.34845612200007],
              [-7.222645636999914, 57.346584377000056],
              [-7.222645636999914, 57.33978913000004],
              [-7.250355597999942, 57.33185455900008],
              [-7.27179928299995, 57.33746979400007],
              [-7.290150519999941, 57.34739817900004],
              [-7.331613735999952, 57.36090729400007],
              [-7.351389126999948, 57.37669505400004],
              [-7.371083136999914, 57.387600002000056],
              [-7.393950975999928, 57.38076406500005],
              [-7.387766079999949, 57.37750885600008],
              [-7.38109290299991, 57.373032945000034],
              [-7.375721808999913, 57.36810944200005],
              [-7.373524542999917, 57.36359284100007],
              [-7.370472785999937, 57.355129299000055],
              [-7.363189256999931, 57.353216864000046],
              [-7.35415605399993, 57.35374583500004],
              [-7.346180792999917, 57.352769273000035],
              [-7.322010870999918, 57.346584377000056],
              [-7.317941860999952, 57.34446849200003],
              [-7.305287238999938, 57.33234284100007],
              [-7.290272589999915, 57.32831452000005],
              [-7.259388800999943, 57.32802969000005],
              [-7.243763800999943, 57.325506903000075],
            ],
          ],
          [
            [
              [-7.263579881999931, 57.48309967700004],
              [-7.265288865999935, 57.47874583500004],
              [-7.265736456999946, 57.47801341400003],
              [-7.266997850999928, 57.478176174000055],
              [-7.271066860999952, 57.476263739000046],
              [-7.262521938999953, 57.47211334800005],
              [-7.254261847999942, 57.47284577000005],
              [-7.245757615999935, 57.47516510600008],
              [-7.236317511999914, 57.476263739000046],
              [-7.229481574999909, 57.47455475500004],
              [-7.202137824999909, 57.46263255400004],
              [-7.208404100999928, 57.45644765800006],
              [-7.222035285999937, 57.460923570000034],
              [-7.244699673999946, 57.449652411000045],
              [-7.263579881999931, 57.44896067900004],
              [-7.258208787999934, 57.439113674000055],
              [-7.249663865999935, 57.435248114000046],
              [-7.226429816999939, 57.43528880400004],
              [-7.212025519999941, 57.43219635600008],
              [-7.204090949999909, 57.425441799000055],
              [-7.205433722999942, 57.41860586100006],
              [-7.292062954999949, 57.404730536000045],
              [-7.318267381999931, 57.40802643400008],
              [-7.396148240999935, 57.43398672100005],
              [-7.407622850999928, 57.44562409100007],
              [-7.402699347999942, 57.46434153900003],
              [-7.389271613999938, 57.47988515800006],
              [-7.369618292999917, 57.48932526200008],
              [-7.346180792999917, 57.489935614000046],
              [-7.334462042999917, 57.48509349200003],
              [-7.322132941999939, 57.48289622600004],
              [-7.309803839999915, 57.48411692900004],
              [-7.298410610999952, 57.489935614000046],
              [-7.292469855999911, 57.48529694200005],
              [-7.284494594999956, 57.482855536000045],
              [-7.274728969999956, 57.48224518400008],
              [-7.263579881999931, 57.48309967700004],
            ],
          ],
          [
            [
              [-6.064442511999914, 57.346584377000056],
              [-6.075428839999915, 57.35504791900007],
              [-6.077137824999909, 57.37177155200004],
              [-6.069081183999913, 57.43610260600008],
              [-6.061634894999941, 57.45270416900007],
              [-6.045521613999938, 57.460638739000046],
              [-6.016672329999949, 57.46263255400004],
              [-6.016672329999949, 57.46942780200004],
              [-6.023589647999927, 57.47418854400007],
              [-6.029042120999918, 57.479396877000056],
              [-6.037098761999914, 57.489935614000046],
              [-6.025868292999917, 57.49624258000006],
              [-6.01585852799991, 57.49677155200004],
              [-5.995594855999911, 57.489935614000046],
              [-5.995594855999911, 57.49746328300006],
              [-6.009836391999954, 57.511053778000075],
              [-6.000884568999936, 57.50971100500004],
              [-5.993316209999932, 57.507025458000044],
              [-5.987212693999936, 57.50287506700005],
              [-5.982533331999946, 57.49746328300006],
              [-5.986724412999934, 57.48224518400008],
              [-6.003041144999941, 57.452826239000046],
              [-6.017648891999954, 57.41819896000004],
              [-6.016672329999949, 57.387600002000056],
              [-6.008900519999941, 57.380194403000075],
              [-5.995106574999909, 57.363714911000045],
              [-5.989491339999915, 57.347316799000055],
              [-6.006459113999938, 57.33978913000004],
              [-6.022857225999928, 57.33624909100007],
              [-6.038685675999943, 57.329779364000046],
              [-6.054798956999946, 57.32640208500004],
              [-6.071929490999935, 57.33234284100007],
              [-6.069243943999936, 57.339544989000046],
              [-6.067616339999915, 57.34247467700004],
              [-6.064442511999914, 57.346584377000056],
            ],
          ],
          [
            [
              [-5.968251105999911, 57.51788971600007],
              [-5.983713344999956, 57.522365627000056],
              [-5.989979620999918, 57.53294505400004],
              [-5.987294074999909, 57.54629140800006],
              [-5.975697394999941, 57.55882396000004],
              [-5.980091925999943, 57.56146881700005],
              [-5.980376756999931, 57.56244538000004],
              [-5.982533331999946, 57.56631094000005],
              [-5.975697394999941, 57.572333075000074],
              [-5.968658006999931, 57.57656484600005],
              [-5.961903449999909, 57.57729726800005],
              [-5.955189581999946, 57.57249583500004],
              [-5.968006964999915, 57.53392161700003],
              [-5.968251105999911, 57.51788971600007],
            ],
          ],
          [
            [
              [-7.129383917999917, 57.65289948100008],
              [-7.114572719999956, 57.652329820000034],
              [-7.092600063999953, 57.65208567900004],
              [-7.074086066999939, 57.64638906500005],
              [-7.065052863999938, 57.633978583000044],
              [-7.075428839999915, 57.62836334800005],
              [-7.092355923999946, 57.61151764500005],
              [-7.099191860999952, 57.60732656500005],
              [-7.113107876999948, 57.608710028000075],
              [-7.123117641999954, 57.61570872600004],
              [-7.130767381999931, 57.623480536000045],
              [-7.137318488999938, 57.62714264500005],
              [-7.148426886999914, 57.629339911000045],
              [-7.171131964999915, 57.64142487200007],
              [-7.215891079999949, 57.64142487200007],
              [-7.215891079999949, 57.633978583000044],
              [-7.204253709999932, 57.63336823100008],
              [-7.197255011999914, 57.63125234600005],
              [-7.196156378999945, 57.62718333500004],
              [-7.202137824999909, 57.62091705900008],
              [-7.202137824999909, 57.61347077000005],
              [-7.173247850999928, 57.61465078300006],
              [-7.164418097999942, 57.60993073100008],
              [-7.161203579999949, 57.59638092700004],
              [-7.154286261999914, 57.58734772300005],
              [-7.138050910999937, 57.58698151200008],
              [-7.106027798999946, 57.592962958000044],
              [-7.125599738999938, 57.57111237200007],
              [-7.149973110999952, 57.561712958000044],
              [-7.208404100999928, 57.55882396000004],
              [-7.215728318999936, 57.55735911700003],
              [-7.230213995999918, 57.552394924000055],
              [-7.236317511999914, 57.552069403000075],
              [-7.243275519999941, 57.55609772300005],
              [-7.252064581999946, 57.56928131700005],
              [-7.256743943999936, 57.57249583500004],
              [-7.269886847999942, 57.57054271000004],
              [-7.312082485999952, 57.552069403000075],
              [-7.312082485999952, 57.544582424000055],
              [-7.240061001999948, 57.544582424000055],
              [-7.181304490999935, 57.553900458000044],
              [-7.161203579999949, 57.552069403000075],
              [-7.144154425999943, 57.548529364000046],
              [-7.137684699999909, 57.54511139500005],
              [-7.133900519999941, 57.538397528000075],
              [-7.137277798999946, 57.532131252000056],
              [-7.157541469999956, 57.511053778000075],
              [-7.199208136999914, 57.51268138200004],
              [-7.219838019999941, 57.51080963700008],
              [-7.236317511999914, 57.503607489000046],
              [-7.252512173999946, 57.51032135600008],
              [-7.287464972999942, 57.50877513200004],
              [-7.305287238999938, 57.511053778000075],
              [-7.31468665299991, 57.51459381700005],
              [-7.318470831999946, 57.51703522300005],
              [-7.329986131999931, 57.52887604400007],
              [-7.333485480999911, 57.53432851800005],
              [-7.33812415299991, 57.53974030200004],
              [-7.346180792999917, 57.544582424000055],
              [-7.337554490999935, 57.54507070500006],
              [-7.318267381999931, 57.552069403000075],
              [-7.351226365999935, 57.55369700700004],
              [-7.411610480999911, 57.57514069200005],
              [-7.442372199999909, 57.579291083000044],
              [-7.449208136999914, 57.57290273600006],
              [-7.455922003999945, 57.568426825000074],
              [-7.462880011999914, 57.56631094000005],
              [-7.470855272999927, 57.56720612200007],
              [-7.483265753999945, 57.571478583000044],
              [-7.499419725999928, 57.57501862200007],
              [-7.544829881999931, 57.592962958000044],
              [-7.544829881999931, 57.59979889500005],
              [-7.522206183999913, 57.60838450700004],
              [-7.506581183999913, 57.62555573100008],
              [-7.493031378999945, 57.645412502000056],
              [-7.476551886999914, 57.66193268400008],
              [-7.45531165299991, 57.655462958000044],
              [-7.387115037999934, 57.66193268400008],
              [-7.387115037999934, 57.65509674700007],
              [-7.394927537999934, 57.65444570500006],
              [-7.414418097999942, 57.64826080900008],
              [-7.396555141999954, 57.63532135600008],
              [-7.366851365999935, 57.65143463700008],
              [-7.335357225999928, 57.67609284100007],
              [-7.312082485999952, 57.68854401200008],
              [-7.312082485999952, 57.68235911700003],
              [-7.318186001999948, 57.67885976800005],
              [-7.322865363999938, 57.67475006700005],
              [-7.332508917999917, 57.66193268400008],
              [-7.277902798999946, 57.64956289300005],
              [-7.256743943999936, 57.64826080900008],
              [-7.256743943999936, 57.65509674700007],
              [-7.263417120999918, 57.65599192900004],
              [-7.277251756999931, 57.66193268400008],
              [-7.255970831999946, 57.66693756700005],
              [-7.209055141999954, 57.68602122600004],
              [-7.181711391999954, 57.68854401200008],
              [-7.169178839999915, 57.67918528900003],
              [-7.165394660999937, 57.66986725500004],
              [-7.171538865999935, 57.66152578300006],
              [-7.189116990999935, 57.65509674700007],
              [-7.172840949999909, 57.64956289300005],
              [-7.142567511999914, 57.65810781500005],
              [-7.129383917999917, 57.65289948100008],
            ],
          ],
          [
            [
              [-6.564116990999935, 57.346584377000056],
              [-6.580555792999917, 57.33881256700005],
              [-6.672474738999938, 57.35594310100004],
              [-6.69595292899993, 57.36440664300005],
              [-6.714751756999931, 57.376613674000055],
              [-6.722401495999918, 57.39093659100007],
              [-6.731678839999915, 57.41697825700004],
              [-6.773182745999918, 57.43406810100004],
              [-6.78384355399993, 57.45644765800006],
              [-6.722401495999918, 57.45644765800006],
              [-6.736317511999914, 57.46515534100007],
              [-6.745228644999941, 57.475897528000075],
              [-6.747141079999949, 57.487941799000055],
              [-6.739735480999911, 57.50055573100008],
              [-6.726307745999918, 57.511419989000046],
              [-6.715931769999941, 57.51422760600008],
              [-6.706450975999928, 57.510931708000044],
              [-6.653553839999915, 57.46869538000004],
              [-6.647328253999945, 57.45954010600008],
              [-6.638091600999928, 57.45327383000006],
              [-6.620025193999936, 57.44550202000005],
              [-6.606800910999937, 57.44391510600008],
              [-6.612538214999915, 57.45644765800006],
              [-6.612538214999915, 57.46263255400004],
              [-6.608265753999945, 57.46458567900004],
              [-6.60415605399993, 57.46775950700004],
              [-6.599476691999939, 57.46942780200004],
              [-6.616688605999911, 57.480902411000045],
              [-6.61937415299991, 57.48309967700004],
              [-6.622222459999932, 57.486395575000074],
              [-6.631255662999934, 57.49359772300005],
              [-6.63304602799991, 57.49746328300006],
              [-6.630604620999918, 57.50177643400008],
              [-6.62140865799995, 57.50385163000004],
              [-6.61937415299991, 57.50731028900003],
              [-6.611439581999946, 57.51219310100004],
              [-6.593617316999939, 57.510972398000035],
              [-6.564116990999935, 57.503607489000046],
              [-6.573963995999918, 57.52171458500004],
              [-6.599354620999918, 57.537543036000045],
              [-6.629872199999909, 57.548529364000046],
              [-6.654774542999917, 57.552069403000075],
              [-6.641590949999909, 57.56195709800005],
              [-6.631011522999927, 57.57680898600006],
              [-6.628895636999914, 57.591131903000075],
              [-6.640451626999948, 57.59979889500005],
              [-6.640451626999948, 57.60732656500005],
              [-6.61978105399993, 57.60716380400004],
              [-6.605620897999927, 57.59955475500004],
              [-6.594309048999946, 57.59052155200004],
              [-6.572255011999914, 57.58250560100004],
              [-6.568430141999954, 57.574286200000074],
              [-6.566883917999917, 57.56509023600006],
              [-6.564116990999935, 57.55882396000004],
              [-6.554595506999931, 57.55247630400004],
              [-6.547759568999936, 57.54954661700003],
              [-6.501210089999915, 57.53554922100005],
              [-6.490386522999927, 57.53025950700004],
              [-6.479074673999946, 57.52098216400003],
              [-6.464914516999954, 57.51251862200007],
              [-6.451649542999917, 57.513332424000055],
              [-6.437652147999927, 57.517238674000055],
              [-6.420765753999945, 57.51788971600007],
              [-6.443470831999946, 57.48810455900008],
              [-6.433501756999931, 57.48647695500006],
              [-6.412098761999914, 57.50136953300006],
              [-6.400257941999939, 57.52098216400003],
              [-6.38695227799991, 57.517279364000046],
              [-6.310902472999942, 57.46263255400004],
              [-6.310902472999942, 57.46942780200004],
              [-6.315785285999937, 57.47280508000006],
              [-6.32095292899993, 57.47931549700007],
              [-6.325184699999909, 57.48309967700004],
              [-6.324615037999934, 57.49681224200003],
              [-6.33853105399993, 57.509466864000046],
              [-6.372954881999931, 57.53156159100007],
              [-6.389556443999936, 57.55247630400004],
              [-6.385853644999941, 57.56264883000006],
              [-6.372425910999937, 57.57257721600007],
              [-6.359852667999917, 57.592962958000044],
              [-6.371937628999945, 57.591864325000074],
              [-6.383371548999946, 57.59292226800005],
              [-6.393137173999946, 57.59564850500004],
              [-6.400257941999939, 57.59979889500005],
              [-6.395863410999937, 57.61347077000005],
              [-6.401112433999913, 57.621527411000045],
              [-6.409535285999937, 57.62734609600005],
              [-6.414540167999917, 57.633978583000044],
              [-6.415679490999935, 57.645819403000075],
              [-6.413441535999937, 57.64923737200007],
              [-6.406605597999942, 57.65033600500004],
              [-6.366566535999937, 57.66425202000005],
              [-6.359852667999917, 57.66811758000006],
              [-6.351185675999943, 57.680121161000045],
              [-6.345285610999952, 57.69220612200007],
              [-6.337961391999954, 57.69916413000004],
              [-6.325184699999909, 57.69599030200004],
              [-6.317494269999941, 57.697699286000045],
              [-6.314279751999948, 57.69916413000004],
              [-6.310902472999942, 57.702826239000046],
              [-6.302235480999911, 57.69236888200004],
              [-6.293324347999942, 57.68602122600004],
              [-6.269886847999942, 57.67552317900004],
              [-6.260487433999913, 57.66864655200004],
              [-6.236073370999918, 57.646185614000046],
              [-6.23265540299991, 57.64142487200007],
              [-6.187977667999917, 57.62091705900008],
              [-6.168853318999936, 57.60761139500005],
              [-6.158355272999927, 57.59784577000005],
              [-6.153879360999952, 57.589544989000046],
              [-6.144683397999927, 57.52000560100004],
              [-6.135121222999942, 57.49005768400008],
              [-6.133371548999946, 57.476263739000046],
              [-6.136057094999956, 57.46133047100005],
              [-6.145090298999946, 57.43862539300005],
              [-6.146962042999917, 57.425116278000075],
              [-6.152495897999927, 57.41754791900007],
              [-6.178863084999932, 57.403550523000035],
              [-6.187977667999917, 57.39435455900008],
              [-6.175852016999954, 57.400824286000045],
              [-6.159250454999949, 57.40737539300005],
              [-6.141590949999909, 57.41079336100006],
              [-6.126535610999952, 57.40802643400008],
              [-6.117909308999913, 57.397772528000075],
              [-6.123524542999917, 57.38825104400007],
              [-6.134103969999956, 57.38003164300005],
              [-6.140126105999911, 57.373928127000056],
              [-6.135243292999917, 57.35736725500004],
              [-6.120757615999935, 57.34707265800006],
              [-6.10570227799991, 57.33966705900008],
              [-6.099232550999943, 57.33234284100007],
              [-6.106597459999932, 57.323472398000035],
              [-6.140288865999935, 57.31244538000004],
              [-6.153879360999952, 57.30560944200005],
              [-6.068186001999948, 57.311835028000075],
              [-6.045399542999917, 57.308294989000046],
              [-6.041086391999954, 57.300116278000075],
              [-6.052886522999927, 57.291001695000034],
              [-6.078114386999914, 57.284491278000075],
              [-6.078114386999914, 57.27765534100007],
              [-6.050852016999954, 57.27924225500004],
              [-6.028879360999952, 57.28534577000005],
              [-6.00845292899993, 57.286769924000055],
              [-5.986236131999931, 57.274318752000056],
              [-5.976673956999946, 57.27033112200007],
              [-5.963449673999946, 57.26947663000004],
              [-5.93814042899993, 57.27090078300006],
              [-5.923247850999928, 57.266913153000075],
              [-5.913807745999918, 57.257879950000074],
              [-5.907134568999936, 57.248480536000045],
              [-5.90062415299991, 57.24290599200003],
              [-5.886219855999911, 57.24209219000005],
              [-5.877308722999942, 57.24681224200003],
              [-5.87132727799991, 57.253241278000075],
              [-5.865834113999938, 57.257147528000075],
              [-5.824330206999946, 57.25617096600007],
              [-5.795806443999936, 57.27179596600007],
              [-5.76789303299995, 57.277411200000074],
              [-5.73851477799991, 57.27728913000004],
              [-5.721831834999932, 57.26463450700004],
              [-5.647368943999936, 57.26463450700004],
              [-5.663889126999948, 57.23981354400007],
              [-5.663482225999928, 57.233303127000056],
              [-5.659087693999936, 57.22247955900008],
              [-5.662953253999945, 57.21271393400008],
              [-5.670643683999913, 57.20465729400007],
              [-5.690907355999911, 57.189520575000074],
              [-5.727284308999913, 57.17279694200005],
              [-5.742339647999927, 57.16844310100004],
              [-5.782053188999953, 57.16624583500004],
              [-5.788970506999931, 57.159491278000075],
              [-5.790760870999918, 57.13739655200004],
              [-5.800363735999952, 57.12372467700004],
              [-5.821441209999932, 57.114447333000044],
              [-5.842640753999945, 57.10797760600008],
              [-5.85220292899993, 57.10297272300005],
              [-5.860096808999913, 57.095363674000055],
              [-5.918853318999936, 57.050116278000075],
              [-5.934925910999937, 57.04120514500005],
              [-5.95343990799995, 57.03412506700005],
              [-6.006743943999936, 57.02838776200008],
              [-6.020822719999956, 57.03188711100006],
              [-6.030384894999941, 57.044907945000034],
              [-6.027251756999931, 57.062160549000055],
              [-6.00023352799991, 57.08392975500004],
              [-6.003041144999941, 57.09271881700005],
              [-6.003041144999941, 57.09955475500004],
              [-5.997059699999909, 57.10175202000005],
              [-5.994211391999954, 57.10455963700008],
              [-5.989979620999918, 57.11383698100008],
              [-5.986927863999938, 57.11823151200008],
              [-5.980091925999943, 57.123114325000074],
              [-5.961822068999936, 57.14215729400007],
              [-5.952788865999935, 57.14883047100005],
              [-5.941558397999927, 57.15477122600004],
              [-5.845366990999935, 57.18146393400008],
              [-5.845366990999935, 57.18829987200007],
              [-5.872954881999931, 57.17999909100007],
              [-5.900868292999917, 57.17552317900004],
              [-5.986236131999931, 57.17462799700007],
              [-5.991688605999911, 57.17719147300005],
              [-5.993072068999936, 57.18317291900007],
              [-5.993316209999932, 57.19017161700003],
              [-5.995594855999911, 57.195746161000045],
              [-6.019276495999918, 57.21759674700007],
              [-6.032215949999909, 57.22650788000004],
              [-6.044016079999949, 57.22992584800005],
              [-6.039784308999913, 57.21938711100006],
              [-6.03538977799991, 57.21149323100008],
              [-6.023508266999954, 57.195746161000045],
              [-6.034087693999936, 57.18109772300005],
              [-6.040842251999948, 57.17413971600007],
              [-6.050852016999954, 57.16844310100004],
              [-6.044016079999949, 57.161037502000056],
              [-6.056263800999943, 57.15289948100008],
              [-6.064605272999927, 57.14175039300005],
              [-6.073841925999943, 57.13178131700005],
              [-6.088612433999913, 57.12742747600004],
              [-6.101429816999939, 57.135199286000045],
              [-6.107167120999918, 57.15302155200004],
              [-6.111195441999939, 57.17328522300005],
              [-6.112904425999943, 57.18829987200007],
              [-6.120961066999939, 57.193793036000045],
              [-6.126454230999911, 57.19521719000005],
              [-6.132069464999915, 57.19318268400008],
              [-6.140126105999911, 57.18829987200007],
              [-6.147450324999909, 57.194525458000044],
              [-6.155588344999956, 57.198879299000055],
              [-6.164458787999934, 57.20136139500005],
              [-6.174305792999917, 57.20197174700007],
              [-6.174305792999917, 57.195746161000045],
              [-6.159820115999935, 57.18764883000006],
              [-6.177154100999928, 57.18121979400007],
              [-6.318348761999914, 57.161037502000056],
              [-6.318348761999914, 57.16844310100004],
              [-6.306996222999942, 57.173895575000074],
              [-6.276722785999937, 57.195746161000045],
              [-6.276722785999937, 57.20197174700007],
              [-6.295318162999934, 57.202378648000035],
              [-6.313099738999938, 57.19989655200004],
              [-6.329986131999931, 57.195013739000046],
              [-6.345611131999931, 57.18829987200007],
              [-6.364735480999911, 57.20453522300005],
              [-6.379790818999936, 57.223089911000045],
              [-6.368885870999918, 57.225775458000044],
              [-6.359486456999946, 57.22943756700005],
              [-6.351714647999927, 57.234808661000045],
              [-6.345611131999931, 57.24290599200003],
              [-6.391428188999953, 57.24054596600007],
              [-6.408192511999914, 57.243353583000044],
              [-6.455474412999934, 57.27765534100007],
              [-6.457997199999909, 57.28099192900004],
              [-6.462961391999954, 57.29043203300006],
              [-6.466053839999915, 57.29474518400008],
              [-6.471180792999917, 57.29901764500005],
              [-6.475575324999909, 57.30141836100006],
              [-6.47915605399993, 57.304754950000074],
              [-6.482167120999918, 57.311835028000075],
              [-6.43618730399993, 57.329738674000055],
              [-6.416411912999934, 57.33454010600008],
              [-6.394032355999911, 57.33234284100007],
              [-6.376332160999937, 57.32379791900007],
              [-6.358509894999941, 57.311835028000075],
              [-6.337635870999918, 57.30149974200003],
              [-6.310902472999942, 57.298163153000075],
              [-6.323882615999935, 57.311428127000056],
              [-6.386586066999939, 57.33978913000004],
              [-6.399525519999941, 57.34845612200007],
              [-6.406158006999931, 57.351548570000034],
              [-6.417632615999935, 57.352769273000035],
              [-6.428822394999941, 57.35150788000004],
              [-6.450550910999937, 57.34650299700007],
              [-6.462961391999954, 57.346584377000056],
              [-6.448638475999928, 57.352769273000035],
              [-6.448638475999928, 57.360256252000056],
              [-6.456613735999952, 57.36115143400008],
              [-6.475941535999937, 57.36709219000005],
              [-6.468739386999914, 57.36855703300006],
              [-6.465809699999909, 57.370021877000056],
              [-6.462961391999954, 57.373928127000056],
              [-6.472157355999911, 57.37653229400007],
              [-6.478871222999942, 57.38190338700008],
              [-6.480824347999942, 57.39008209800005],
              [-6.475941535999937, 57.40119049700007],
              [-6.490834113999938, 57.39899323100008],
              [-6.510609503999945, 57.38556549700007],
              [-6.523793097999942, 57.38076406500005],
              [-6.518706834999932, 57.389553127000056],
              [-6.517648891999954, 57.398871161000045],
              [-6.521229620999918, 57.407863674000055],
              [-6.530629035999937, 57.41547272300005],
              [-6.538929816999939, 57.402329820000034],
              [-6.550404425999943, 57.39801666900007],
              [-6.562123175999943, 57.39545319200005],
              [-6.571522589999915, 57.387600002000056],
              [-6.573150193999936, 57.37612539300005],
              [-6.562123175999943, 57.357855536000045],
              [-6.564116990999935, 57.346584377000056],
            ],
          ],
          [
            [
              [-7.222645636999914, 57.70966217700004],
              [-7.180165167999917, 57.73468659100007],
              [-7.161203579999949, 57.73700592700004],
              [-7.152007615999935, 57.72630442900004],
              [-7.170033331999946, 57.71515534100007],
              [-7.198963995999918, 57.70795319200005],
              [-7.222645636999914, 57.70966217700004],
            ],
          ],
          [
            [
              [-8.62100175699993, 57.833197333000044],
              [-8.605295376999948, 57.82640208500004],
              [-8.569081183999913, 57.82367584800005],
              [-8.552235480999911, 57.81891510600008],
              [-8.568959113999938, 57.80756256700005],
              [-8.590891079999949, 57.804754950000074],
              [-8.610707160999937, 57.81273021000004],
              [-8.62100175699993, 57.833197333000044],
            ],
          ],
          [
            [
              [-7.044585740999935, 57.90208567900004],
              [-7.048085089999915, 57.89081452000005],
              [-7.055165167999917, 57.88418203300006],
              [-7.065500454999949, 57.88104889500005],
              [-7.079335089999915, 57.88031647300005],
              [-7.077056443999936, 57.88861725500004],
              [-7.076771613999938, 57.890692450000074],
              [-7.077870245999918, 57.89118073100008],
              [-7.079335089999915, 57.89468008000006],
              [-7.03774980399993, 57.91632721600007],
              [-7.015533006999931, 57.921942450000074],
              [-6.997385219999956, 57.91510651200008],
              [-6.997059699999909, 57.89354075700004],
              [-7.009185350999928, 57.88959381700005],
              [-7.044585740999935, 57.90208567900004],
            ],
          ],
          [
            [
              [-6.87328040299991, 58.216782945000034],
              [-6.862863735999952, 58.216457424000055],
              [-6.85960852799991, 58.216782945000034],
              [-6.85960852799991, 58.22304922100005],
              [-6.872222459999932, 58.22679271000004],
              [-6.882313605999911, 58.23627350500004],
              [-6.886219855999911, 58.24762604400007],
              [-6.880034959999932, 58.25775788000004],
              [-6.861154751999948, 58.25336334800005],
              [-6.828928188999953, 58.23379140800006],
              [-6.81859290299991, 58.23725006700005],
              [-6.809641079999949, 58.23224518400008],
              [-6.801991339999915, 58.22614166900007],
              [-6.795765753999945, 58.218817450000074],
              [-6.79124915299991, 58.20994700700004],
              [-6.87328040299991, 58.20994700700004],
              [-6.87328040299991, 58.216782945000034],
            ],
          ],
          [
            [
              [-6.955148891999954, 57.743841864000046],
              [-6.973500128999945, 57.73334381700005],
              [-6.98078365799995, 57.73505280200004],
              [-7.031646287999934, 57.76740143400008],
              [-7.041371222999942, 57.77049388200004],
              [-7.10187740799995, 57.81146881700005],
              [-7.112782355999911, 57.81586334800005],
              [-7.117298956999946, 57.82306549700007],
              [-7.124623175999943, 57.83075592700004],
              [-7.125070766999954, 57.83690013200004],
              [-7.109445766999954, 57.83942291900007],
              [-7.096994594999956, 57.83803945500006],
              [-7.088612433999913, 57.83340078300006],
              [-7.083241339999915, 57.825100002000056],
              [-7.079335089999915, 57.81268952000005],
              [-6.997385219999956, 57.85370514500005],
              [-6.984852667999917, 57.864894924000055],
              [-6.962269660999937, 57.868841864000046],
              [-6.914173956999946, 57.86790599200003],
              [-6.962554490999935, 57.88784414300005],
              [-6.962554490999935, 57.89468008000006],
              [-6.911610480999911, 57.910589911000045],
              [-6.881703253999945, 57.91429271000004],
              [-6.85187740799995, 57.910589911000045],
              [-6.83226477799991, 57.90208567900004],
              [-6.841867641999954, 57.90704987200007],
              [-6.851551886999914, 57.911403713000084],
              [-6.85960852799991, 57.915228583000044],
              [-6.862945115999935, 57.918036200000074],
              [-6.865834113999938, 57.92133209800005],
              [-6.846994594999956, 57.92792389500005],
              [-6.839100714999915, 57.92877838700008],
              [-6.839100714999915, 57.935614325000074],
              [-6.897084113999938, 57.935614325000074],
              [-6.91079667899993, 57.93891022300005],
              [-6.937001105999911, 57.95343659100007],
              [-6.952056443999936, 57.956732489000046],
              [-7.009755011999914, 57.95526764500005],
              [-7.036284959999932, 57.960638739000046],
              [-7.044585740999935, 57.976548570000034],
              [-7.05728105399993, 57.97085195500006],
              [-7.065825975999928, 57.97101471600007],
              [-7.112782355999911, 57.990220445000034],
              [-7.096669074999909, 57.99746328300006],
              [-7.084828253999945, 58.005926825000074],
              [-7.071766730999911, 58.01190827000005],
              [-7.051909959999932, 58.011379299000055],
              [-7.051909959999932, 58.01752350500004],
              [-7.05492102799991, 58.01976146000004],
              [-7.055653449999909, 58.020697333000044],
              [-7.056141730999911, 58.02195872600004],
              [-7.058216925999943, 58.02496979400007],
              [-7.027902798999946, 58.02753327000005],
              [-6.995228644999941, 58.03375885600008],
              [-6.934641079999949, 58.05231354400007],
              [-7.028716600999928, 58.038397528000075],
              [-7.058216925999943, 58.03864166900007],
              [-7.053618943999936, 58.04779694200005],
              [-7.045765753999945, 58.05263906500005],
              [-7.035552537999934, 58.053900458000044],
              [-7.024037238999938, 58.05231354400007],
              [-7.024037238999938, 58.05853913000004],
              [-7.051909959999932, 58.05853913000004],
              [-7.042795376999948, 58.061835028000075],
              [-7.035023566999939, 58.06635163000004],
              [-7.028716600999928, 58.07221100500004],
              [-7.024037238999938, 58.07957591400003],
              [-7.067494269999941, 58.06273021000004],
              [-7.075550910999937, 58.06224192900004],
              [-7.104888475999928, 58.09479401200008],
              [-7.112782355999911, 58.10008372600004],
              [-7.107533331999946, 58.11200592700004],
              [-7.113189256999931, 58.116400458000044],
              [-7.121937628999945, 58.11859772300005],
              [-7.126454230999911, 58.12396881700005],
              [-7.123402472999942, 58.13666413000004],
              [-7.112131313999953, 58.14545319200005],
              [-7.112782355999911, 58.15534088700008],
              [-7.10415605399993, 58.15704987200007],
              [-7.100168423999946, 58.159409898000035],
              [-7.097645636999914, 58.16303131700005],
              [-7.093006964999915, 58.168402411000045],
              [-7.10024980399993, 58.17011139500005],
              [-7.107411261999914, 58.17413971600007],
              [-7.112782355999911, 58.175848700000074],
              [-7.112782355999911, 58.18203359600005],
              [-7.037709113999938, 58.18463776200008],
              [-7.017201300999943, 58.189439195000034],
              [-7.043446417999917, 58.19594961100006],
              [-7.053944464999915, 58.20136139500005],
              [-7.058216925999943, 58.21336497600004],
              [-7.056060350999928, 58.22565338700008],
              [-7.050160285999937, 58.23236725500004],
              [-7.030873175999943, 58.24469635600008],
              [-7.016102667999917, 58.23859284100007],
              [-6.977284308999913, 58.22736237200007],
              [-6.969471808999913, 58.22675202000005],
              [-6.962025519999941, 58.230169989000046],
              [-6.907338019999941, 58.216782945000034],
              [-6.907338019999941, 58.20994700700004],
              [-6.937082485999952, 58.211004950000074],
              [-6.930409308999913, 58.19684479400007],
              [-6.909657355999911, 58.179754950000074],
              [-6.897084113999938, 58.17210521000004],
              [-6.898345506999931, 58.15672435100004],
              [-6.888050910999937, 58.13589101800005],
              [-6.872873501999948, 58.116888739000046],
              [-6.85960852799991, 58.10687897300005],
              [-6.861439581999946, 58.11587148600006],
              [-6.861887173999946, 58.12140534100007],
              [-6.85960852799991, 58.134833075000074],
              [-6.866607225999928, 58.14118073100008],
              [-6.881581183999913, 58.158636786000045],
              [-6.887521938999953, 58.168402411000045],
              [-6.877512173999946, 58.17218659100007],
              [-6.873931443999936, 58.179388739000046],
              [-6.872670050999943, 58.18634674700007],
              [-6.869496222999942, 58.189439195000034],
              [-6.825062628999945, 58.195379950000074],
              [-6.815174933999913, 58.19969310100004],
              [-6.798451300999943, 58.202378648000035],
              [-6.772572394999941, 58.19550202000005],
              [-6.748524542999917, 58.182928778000075],
              [-6.736683722999942, 58.168402411000045],
              [-6.709380662999934, 58.189439195000034],
              [-6.734364386999914, 58.197699286000045],
              [-6.742909308999913, 58.203111070000034],
              [-6.746815558999913, 58.20921458500004],
              [-6.752552863999938, 58.22479889500005],
              [-6.757191535999937, 58.23041413000004],
              [-6.763050910999937, 58.231675523000035],
              [-6.777821417999917, 58.22947825700004],
              [-6.78384355399993, 58.23041413000004],
              [-6.785715298999946, 58.23297760600008],
              [-6.789540167999917, 58.24201080900008],
              [-6.79124915299991, 58.24469635600008],
              [-6.802723761999914, 58.25372955900008],
              [-6.807687954999949, 58.258693752000056],
              [-6.811838344999956, 58.26459381700005],
              [-6.806752081999946, 58.26654694200005],
              [-6.802723761999914, 58.26898834800005],
              [-6.798003709999932, 58.27098216400003],
              [-6.79124915299991, 58.27138906500005],
              [-6.796457485999952, 58.278631903000075],
              [-6.801177537999934, 58.28335195500006],
              [-6.807728644999941, 58.28546784100007],
              [-6.81859290299991, 58.28510163000004],
              [-6.73696855399993, 58.32363515800006],
              [-6.715565558999913, 58.33966705900008],
              [-6.70335852799991, 58.33588288000004],
              [-6.69595292899993, 58.33844635600008],
              [-6.68968665299991, 58.34332916900007],
              [-6.681385870999918, 58.34650299700007],
              [-6.647328253999945, 58.34650299700007],
              [-6.620676235999952, 58.35073476800005],
              [-6.557484503999945, 58.36855703300006],
              [-6.548491990999935, 58.37278880400004],
              [-6.523345506999931, 58.39077383000006],
              [-6.345611131999931, 58.46320221600007],
              [-6.296294725999928, 58.497259833000044],
              [-6.267404751999948, 58.51203034100007],
              [-6.243234829999949, 58.510972398000035],
              [-6.223052537999934, 58.499212958000044],
              [-6.20539303299995, 58.48126862200007],
              [-6.192738410999937, 58.46206289300005],
              [-6.187977667999917, 58.44611237200007],
              [-6.169992641999954, 58.42999909100007],
              [-6.166859503999945, 58.41950104400007],
              [-6.184925910999937, 58.41478099200003],
              [-6.192372199999909, 58.40912506700005],
              [-6.215321417999917, 58.367621161000045],
              [-6.206898566999939, 58.36115143400008],
              [-6.19554602799991, 58.35626862200007],
              [-6.182240363999938, 58.35366445500006],
              [-6.167469855999911, 58.353949286000045],
              [-6.167469855999911, 58.34650299700007],
              [-6.188832160999937, 58.34080638200004],
              [-6.233713344999956, 58.32282135600008],
              [-6.249989386999914, 58.31297435100004],
              [-6.244984503999945, 58.30414459800005],
              [-6.24640865799995, 58.29755280200004],
              [-6.253814256999931, 58.29336172100005],
              [-6.266835089999915, 58.291896877000056],
              [-6.278675910999937, 58.288723049000055],
              [-6.288238084999932, 58.274603583000044],
              [-6.317860480999911, 58.26829661700003],
              [-6.319935675999943, 58.260931708000044],
              [-6.316965298999946, 58.25214264500005],
              [-6.318348761999914, 58.24469635600008],
              [-6.327463344999956, 58.23973216400003],
              [-6.338490363999938, 58.237616278000075],
              [-6.366118943999936, 58.23725006700005],
              [-6.347727016999954, 58.221136786000045],
              [-6.31086178299995, 58.21503327000005],
              [-6.270904100999928, 58.216498114000046],
              [-6.243234829999949, 58.22304922100005],
              [-6.194813605999911, 58.25092194200005],
              [-6.179758266999954, 58.255560614000046],
              [-6.161122199999909, 58.258978583000044],
              [-6.15070553299995, 58.25836823100008],
              [-6.160023566999939, 58.25092194200005],
              [-6.160023566999939, 58.24469635600008],
              [-6.153879360999952, 58.24469635600008],
              [-6.158558722999942, 58.23981354400007],
              [-6.163319464999915, 58.233587958000044],
              [-6.167469855999911, 58.23041413000004],
              [-6.164865688999953, 58.22675202000005],
              [-6.160023566999939, 58.216782945000034],
              [-6.186431443999936, 58.20990631700005],
              [-6.195220506999931, 58.20648834800005],
              [-6.202137824999909, 58.20197174700007],
              [-6.211659308999913, 58.192287502000056],
              [-6.215321417999917, 58.189439195000034],
              [-6.233550584999932, 58.18427155200004],
              [-6.247425910999937, 58.18545156500005],
              [-6.276722785999937, 58.19627513200004],
              [-6.293568488999938, 58.19936758000006],
              [-6.33820553299995, 58.19627513200004],
              [-6.354888475999928, 58.19936758000006],
              [-6.384673631999931, 58.20970286700003],
              [-6.400257941999939, 58.20994700700004],
              [-6.377023891999954, 58.173529364000046],
              [-6.366118943999936, 58.162095445000034],
              [-6.374501105999911, 58.15766022300005],
              [-6.378041144999941, 58.153631903000075],
              [-6.37726803299995, 58.14862702000005],
              [-6.372954881999931, 58.141058661000045],
              [-6.390695766999954, 58.13353099200003],
              [-6.441232876999948, 58.127386786000045],
              [-6.474720831999946, 58.10521067900004],
              [-6.489654100999928, 58.10008372600004],
              [-6.499094204999949, 58.10040924700007],
              [-6.514393683999913, 58.10614655200004],
              [-6.523793097999942, 58.10687897300005],
              [-6.55109615799995, 58.09324778900003],
              [-6.603179490999935, 58.085638739000046],
              [-6.61937415299991, 58.08641185100004],
              [-6.61937415299991, 58.07957591400003],
              [-6.581288214999915, 58.079006252000056],
              [-6.451324022999927, 58.095689195000034],
              [-6.420643683999913, 58.10565827000005],
              [-6.407093878999945, 58.10687897300005],
              [-6.394032355999911, 58.10179271000004],
              [-6.383900519999941, 58.091782945000034],
              [-6.378570115999935, 58.07904694200005],
              [-6.379790818999936, 58.06598541900007],
              [-6.375721808999913, 58.06427643400008],
              [-6.366118943999936, 58.05853913000004],
              [-6.37368730399993, 58.05292389500005],
              [-6.381906704999949, 58.048895575000074],
              [-6.390695766999954, 58.04637278900003],
              [-6.400257941999939, 58.04547760600008],
              [-6.389475063999953, 58.04120514500005],
              [-6.377674933999913, 58.038763739000046],
              [-6.365101691999939, 58.03790924700007],
              [-6.352447068999936, 58.03864166900007],
              [-6.370961066999939, 58.02724844000005],
              [-6.38508053299995, 58.01593659100007],
              [-6.400868292999917, 58.00731028900003],
              [-6.42446855399993, 58.003892320000034],
              [-6.51821855399993, 58.01264069200005],
              [-6.53929602799991, 58.017279364000046],
              [-6.544911261999914, 58.01752350500004],
              [-6.550689256999931, 58.01007721600007],
              [-6.542225714999915, 58.00568268400008],
              [-6.520741339999915, 58.00079987200007],
              [-6.505116339999915, 57.99249909100007],
              [-6.469634568999936, 57.98688385600008],
              [-6.455474412999934, 57.976548570000034],
              [-6.455474412999934, 57.96971263200004],
              [-6.464995897999927, 57.96564362200007],
              [-6.481190558999913, 57.94977448100008],
              [-6.489654100999928, 57.943060614000046],
              [-6.507557745999918, 57.935980536000045],
              [-6.520130988999938, 57.93659088700008],
              [-6.532866990999935, 57.94041575700004],
              [-6.55109615799995, 57.943060614000046],
              [-6.55109615799995, 57.935614325000074],
              [-6.546701626999948, 57.93382396000004],
              [-6.541981574999909, 57.930853583000044],
              [-6.537464972999942, 57.92877838700008],
              [-6.537464972999942, 57.92133209800005],
              [-6.559803839999915, 57.915228583000044],
              [-6.57843990799995, 57.917222398000035],
              [-6.593861456999946, 57.92487213700008],
              [-6.606353318999936, 57.935614325000074],
              [-6.614979620999918, 57.94916413000004],
              [-6.620472785999937, 57.95453522300005],
              [-6.629872199999909, 57.956732489000046],
              [-6.63499915299991, 57.951605536000045],
              [-6.629628058999913, 57.94025299700007],
              [-6.620025193999936, 57.928168036000045],
              [-6.612538214999915, 57.92133209800005],
              [-6.61937415299991, 57.91510651200008],
              [-6.651193813999953, 57.923814195000034],
              [-6.660959438999953, 57.92877838700008],
              [-6.666167772999927, 57.93390534100007],
              [-6.672434048999946, 57.946193752000056],
              [-6.699818488999938, 57.976223049000055],
              [-6.707753058999913, 57.989569403000075],
              [-6.709380662999934, 58.003892320000034],
              [-6.694650844999956, 58.03009674700007],
              [-6.665842251999948, 58.04466380400004],
              [-6.629465298999946, 58.05093008000006],
              [-6.59203040299991, 58.05231354400007],
              [-6.59203040299991, 58.05853913000004],
              [-6.688303188999953, 58.05853913000004],
              [-6.688303188999953, 58.05231354400007],
              [-6.692697719999956, 58.04096100500004],
              [-6.716053839999915, 58.02496979400007],
              [-6.744496222999942, 58.01048411700003],
              [-6.764027472999942, 58.003892320000034],
              [-6.750884568999936, 57.99298737200007],
              [-6.730091925999943, 57.962958075000074],
              [-6.71898352799991, 57.956732489000046],
              [-6.704741990999935, 57.953192450000074],
              [-6.693226691999939, 57.94505442900004],
              [-6.683420376999948, 57.93573639500005],
              [-6.673980272999927, 57.92877838700008],
              [-6.679351365999935, 57.92682526200008],
              [-6.683461066999939, 57.92422109600005],
              [-6.688465949999909, 57.92206452000005],
              [-6.695668097999942, 57.92133209800005],
              [-6.688954230999911, 57.914943752000056],
              [-6.68032792899993, 57.91205475500004],
              [-6.672352667999917, 57.910589911000045],
              [-6.667795376999948, 57.908270575000074],
              [-6.665150519999941, 57.901556708000044],
              [-6.660959438999953, 57.88031647300005],
              [-6.742909308999913, 57.89126211100006],
              [-6.77765865799995, 57.90208567900004],
              [-6.787017381999931, 57.89883047100005],
              [-6.792388475999928, 57.893744208000044],
              [-6.797352667999917, 57.88739655200004],
              [-6.805572068999936, 57.88031647300005],
              [-6.794260219999956, 57.876206773000035],
              [-6.772857225999928, 57.87124258000006],
              [-6.764027472999942, 57.86790599200003],
              [-6.740712042999917, 57.845038153000075],
              [-6.736683722999942, 57.83942291900007],
              [-6.741932745999918, 57.83148834800005],
              [-6.755604620999918, 57.82648346600007],
              [-6.773508266999954, 57.82461172100005],
              [-6.79124915299991, 57.82575104400007],
              [-6.79124915299991, 57.81891510600008],
              [-6.78384355399993, 57.81891510600008],
              [-6.78384355399993, 57.81268952000005],
              [-6.806141730999911, 57.81464264500005],
              [-6.852691209999932, 57.833197333000044],
              [-6.85960852799991, 57.82575104400007],
              [-6.85415605399993, 57.823431708000044],
              [-6.845855272999927, 57.816392320000034],
              [-6.839100714999915, 57.81268952000005],
              [-6.850168423999946, 57.80292389500005],
              [-6.861154751999948, 57.79633209800005],
              [-6.887521938999953, 57.784816799000055],
              [-6.882720506999931, 57.782863674000055],
              [-6.877837693999936, 57.77985260600008],
              [-6.87328040299991, 57.77798086100006],
              [-6.893950975999928, 57.76654694200005],
              [-6.955148891999954, 57.743841864000046],
            ],
          ],
          [
            [
              [-2.952951626999948, 58.83999258000006],
              [-2.906971808999913, 58.83808014500005],
              [-2.883656378999945, 58.83218008000006],
              [-2.885365363999938, 58.82005442900004],
              [-2.913563605999911, 58.81049225500004],
              [-2.919422980999911, 58.80646393400008],
              [-2.921131964999915, 58.79751211100006],
              [-2.915760870999918, 58.790676174000055],
              [-2.913970506999931, 58.784857489000046],
              [-2.926340298999946, 58.77912018400008],
              [-2.915394660999937, 58.762152411000045],
              [-2.911040818999936, 58.74868398600006],
              [-2.917836066999939, 58.738348700000074],
              [-2.939930792999917, 58.73069896000004],
              [-2.987782355999911, 58.75739166900007],
              [-2.987782355999911, 58.764837958000044],
              [-2.974354620999918, 58.77204010600008],
              [-2.984852667999917, 58.787095445000034],
              [-3.015695766999954, 58.81264883000006],
              [-3.003895636999914, 58.80817291900007],
              [-2.991322394999941, 58.806626695000034],
              [-2.978871222999942, 58.80817291900007],
              [-2.967193162999934, 58.81264883000006],
              [-2.967193162999934, 58.82005442900004],
              [-3.035552537999934, 58.82005442900004],
              [-3.035552537999934, 58.82632070500006],
              [-2.996978318999936, 58.835272528000075],
              [-2.952951626999948, 58.83999258000006],
            ],
          ],
          [
            [
              [-3.248402472999942, 58.792181708000044],
              [-3.218495245999918, 58.79328034100007],
              [-3.160145636999914, 58.80801015800006],
              [-3.131703253999945, 58.80646393400008],
              [-3.156320766999954, 58.786769924000055],
              [-3.205922003999945, 58.77903880400004],
              [-3.299305792999917, 58.77912018400008],
              [-3.304269985999952, 58.78384023600006],
              [-3.323475714999915, 58.80951569200005],
              [-3.327788865999935, 58.81830475500004],
              [-3.337635870999918, 58.823919989000046],
              [-3.349191860999952, 58.82843659100007],
              [-3.358265753999945, 58.83315664300005],
              [-3.378773566999939, 58.853583075000074],
              [-3.379872199999909, 58.85927969000005],
              [-3.375965949999909, 58.86359284100007],
              [-3.373524542999917, 58.86798737200007],
              [-3.378773566999939, 58.87409088700008],
              [-3.385731574999909, 58.87539297100005],
              [-3.397613084999932, 58.86953359600005],
              [-3.402333136999914, 58.87067291900007],
              [-3.411976691999939, 58.874986070000034],
              [-3.42218990799995, 58.87400950700004],
              [-3.430165167999917, 58.87482330900008],
              [-3.433338995999918, 58.88495514500005],
              [-3.418446417999917, 58.90448639500005],
              [-3.41633053299995, 58.908270575000074],
              [-3.39321855399993, 58.92023346600007],
              [-3.349354620999918, 58.92853424700007],
              [-3.337147589999915, 58.92869700700004],
              [-3.321848110999952, 58.92365143400008],
              [-3.287587042999917, 58.905951239000046],
              [-3.265451626999948, 58.902044989000046],
              [-3.246083136999914, 58.896185614000046],
              [-3.193186001999948, 58.853583075000074],
              [-3.207386847999942, 58.84739817900004],
              [-3.207386847999942, 58.83999258000006],
              [-3.19554602799991, 58.83942291900007],
              [-3.187245245999918, 58.83649323100008],
              [-3.172718878999945, 58.82632070500006],
              [-3.172718878999945, 58.82005442900004],
              [-3.191802537999934, 58.81867096600007],
              [-3.21548417899993, 58.81427643400008],
              [-3.236683722999942, 58.80573151200008],
              [-3.248402472999942, 58.792181708000044],
            ],
          ],
          [
            [
              [-2.727650519999941, 58.97089264500005],
              [-2.713612433999913, 58.966864325000074],
              [-2.707630988999938, 58.958970445000034],
              [-2.706206834999932, 58.94745514500005],
              [-2.706532355999911, 58.93244049700007],
              [-2.714751756999931, 58.925482489000046],
              [-2.733754035999937, 58.92015208500004],
              [-2.771962042999917, 58.915716864000046],
              [-2.785023566999939, 58.91071198100008],
              [-2.808013475999928, 58.888006903000075],
              [-2.823841925999943, 58.88153717700004],
              [-2.839344855999911, 58.88263580900008],
              [-2.915028449999909, 58.89911530200004],
              [-2.926828579999949, 58.90485260600008],
              [-2.937245245999918, 58.91323476800005],
              [-2.973622199999909, 58.95380280200004],
              [-2.981190558999913, 58.96010976800005],
              [-2.993763800999943, 58.95880768400008],
              [-3.007801886999914, 58.94904205900008],
              [-3.023833787999934, 58.94049713700008],
              [-3.042388475999928, 58.943019924000055],
              [-3.052561001999948, 58.938788153000075],
              [-3.061756964999915, 58.93939850500004],
              [-3.071685350999928, 58.941839911000045],
              [-3.084543423999946, 58.943019924000055],
              [-3.070301886999914, 58.92869700700004],
              [-3.101226365999935, 58.930121161000045],
              [-3.113189256999931, 58.926662502000056],
              [-3.118031378999945, 58.915716864000046],
              [-3.142648891999954, 58.921210028000075],
              [-3.202788865999935, 58.91592031500005],
              [-3.227894660999937, 58.92869700700004],
              [-3.23851477799991, 58.95091380400004],
              [-3.235340949999909, 58.97256094000005],
              [-3.22329667899993, 58.99135976800005],
              [-3.207386847999942, 59.005072333000044],
              [-3.207386847999942, 59.01129791900007],
              [-3.214751756999931, 59.01748281500005],
              [-3.220448370999918, 59.02411530200004],
              [-3.224680141999954, 59.03119538000004],
              [-3.227894660999937, 59.03856028900003],
              [-3.238758917999917, 59.035142320000034],
              [-3.245838995999918, 59.030503648000035],
              [-3.247222459999932, 59.02484772300005],
              [-3.240956183999913, 59.01813385600008],
              [-3.240956183999913, 59.01129791900007],
              [-3.250396287999934, 59.01447174700007],
              [-3.259185350999928, 59.01581452000005],
              [-3.267486131999931, 59.01471588700008],
              [-3.275786912999934, 59.01129791900007],
              [-3.266590949999909, 59.007147528000075],
              [-3.263050910999937, 59.00092194200005],
              [-3.264068162999934, 58.993068752000056],
              [-3.262074347999942, 58.991400458000044],
              [-3.256988084999932, 58.97833893400008],
              [-3.265370245999918, 58.969183661000045],
              [-3.289418097999942, 58.956691799000055],
              [-3.289418097999942, 58.950384833000044],
              [-3.323231574999909, 58.95718008000006],
              [-3.353260870999918, 58.98281484600005],
              [-3.366688605999911, 59.01609935100004],
              [-3.350819464999915, 59.04604726800005],
              [-3.34398352799991, 59.052801825000074],
              [-3.350209113999938, 59.09796784100007],
              [-3.323801235999952, 59.12742747600004],
              [-3.279286261999914, 59.14354075700004],
              [-3.231068488999938, 59.148423570000034],
              [-3.182728644999941, 59.14716217700004],
              [-3.156158006999931, 59.142238674000055],
              [-3.121571417999917, 59.12396881700005],
              [-3.108306443999936, 59.124212958000044],
              [-3.09593665299991, 59.12734609600005],
              [-3.084543423999946, 59.12799713700008],
              [-3.074208136999914, 59.12376536700003],
              [-3.058461066999939, 59.111761786000045],
              [-3.049183722999942, 59.10809967700004],
              [-3.063547329999949, 59.101996161000045],
              [-3.070301886999914, 59.101263739000046],
              [-3.05142167899993, 59.09015534100007],
              [-2.994496222999942, 59.07330963700008],
              [-3.001861131999931, 59.07176341400003],
              [-3.004994269999941, 59.07025788000004],
              [-3.008168097999942, 59.06655508000006],
              [-3.003773566999939, 59.064439195000034],
              [-2.999012824999909, 59.06150950700004],
              [-2.994496222999942, 59.05971914300005],
              [-3.053700324999909, 59.04726797100005],
              [-3.06281490799995, 59.04946523600006],
              [-3.071197068999936, 59.03343333500004],
              [-3.090931769999941, 59.018744208000044],
              [-3.11392167899993, 59.00820547100005],
              [-3.131703253999945, 59.005072333000044],
              [-3.116688605999911, 58.99819570500006],
              [-3.097320115999935, 58.99404531500005],
              [-3.059722459999932, 58.991400458000044],
              [-3.044585740999935, 58.99799225500004],
              [-3.029204881999931, 59.01032135600008],
              [-3.01195227799991, 59.01740143400008],
              [-2.974436001999948, 58.99909088700008],
              [-2.960357225999928, 59.001166083000044],
              [-2.947132941999939, 59.00755442900004],
              [-2.933094855999911, 59.01129791900007],
              [-2.917307094999956, 59.00617096600007],
              [-2.90656490799995, 58.99656810100004],
              [-2.895375128999945, 58.99103424700007],
              [-2.878407355999911, 58.99823639500005],
              [-2.880523240999935, 58.99359772300005],
              [-2.88345292899993, 58.98191966400003],
              [-2.885365363999938, 58.97711823100008],
              [-2.864735480999911, 58.97483958500004],
              [-2.847645636999914, 58.98029205900008],
              [-2.831166144999941, 58.98769765800006],
              [-2.812977667999917, 58.991400458000044],
              [-2.790150519999941, 58.992254950000074],
              [-2.780629035999937, 58.990301825000074],
              [-2.775380011999914, 58.98395416900007],
              [-2.78189042899993, 58.973944403000075],
              [-2.82249915299991, 58.95856354400007],
              [-2.837554490999935, 58.950384833000044],
              [-2.826242641999954, 58.93740469000005],
              [-2.811919725999928, 58.92914459800005],
              [-2.794789191999939, 58.92609284100007],
              [-2.775380011999914, 58.92869700700004],
              [-2.789418097999942, 58.94989655200004],
              [-2.795969204999949, 58.956691799000055],
              [-2.77757727799991, 58.95750560100004],
              [-2.744048631999931, 58.969183661000045],
              [-2.727650519999941, 58.97089264500005],
            ],
          ],
          [
            [
              [-2.541981574999909, 59.12055084800005],
              [-2.548451300999943, 59.109035549000055],
              [-2.542388475999928, 59.10297272300005],
              [-2.514759894999941, 59.093817450000074],
              [-2.532622850999928, 59.08356354400007],
              [-2.576039191999939, 59.080064195000034],
              [-2.597320115999935, 59.07330963700008],
              [-2.599476691999939, 59.09589264500005],
              [-2.614369269999941, 59.10724518400008],
              [-2.634429490999935, 59.108628648000035],
              [-2.651844855999911, 59.101263739000046],
              [-2.649159308999913, 59.08551666900007],
              [-2.670725063999953, 59.08152903900003],
              [-2.686105923999946, 59.089178778000075],
              [-2.665516730999911, 59.10809967700004],
              [-2.650502081999946, 59.111761786000045],
              [-2.634836391999954, 59.11273834800005],
              [-2.622425910999937, 59.116441148000035],
              [-2.617787238999938, 59.12799713700008],
              [-2.624256964999915, 59.13385651200008],
              [-2.655181443999936, 59.151271877000056],
              [-2.665516730999911, 59.15521881700005],
              [-2.62564042899993, 59.16242096600007],
              [-2.61156165299991, 59.161444403000075],
              [-2.61156165299991, 59.15521881700005],
              [-2.614857550999943, 59.15216705900008],
              [-2.617787238999938, 59.148423570000034],
              [-2.59007727799991, 59.148871161000045],
              [-2.577951626999948, 59.14720286700003],
              [-2.569406704999949, 59.142238674000055],
              [-2.58234615799995, 59.14398834800005],
              [-2.592884894999941, 59.13857656500005],
              [-2.595204230999911, 59.12954336100006],
              [-2.583648240999935, 59.12055084800005],
              [-2.571603969999956, 59.118841864000046],
              [-2.558705206999946, 59.12083567900004],
              [-2.535267706999946, 59.12799713700008],
              [-2.534738735999952, 59.12287018400008],
              [-2.536488410999937, 59.12156810100004],
              [-2.53929602799991, 59.12173086100006],
              [-2.541981574999909, 59.12055084800005],
            ],
          ],
          [
            [
              [-3.004790818999936, 59.12799713700008],
              [-3.036447719999956, 59.12909577000005],
              [-3.065581834999932, 59.13361237200007],
              [-3.091786261999914, 59.14280833500004],
              [-3.114654100999928, 59.15835195500006],
              [-3.120432094999956, 59.17658112200007],
              [-3.102406378999945, 59.19025299700007],
              [-3.074208136999914, 59.19749583500004],
              [-3.049183722999942, 59.19684479400007],
              [-3.048085089999915, 59.19489166900007],
              [-3.046294725999928, 59.19086334800005],
              [-3.042551235999952, 59.18634674700007],
              [-3.035552537999934, 59.18317291900007],
              [-3.029123501999948, 59.18235911700003],
              [-3.021839972999942, 59.18231842700004],
              [-2.980824347999942, 59.18744538000004],
              [-2.967884894999941, 59.18744538000004],
              [-2.952951626999948, 59.18317291900007],
              [-2.952463344999956, 59.178168036000045],
              [-2.953846808999913, 59.17674388200004],
              [-2.956776495999918, 59.17670319200005],
              [-2.960357225999928, 59.175767320000034],
              [-2.977162238999938, 59.163397528000075],
              [-2.974029100999928, 59.14752838700008],
              [-2.97524980399993, 59.13377513200004],
              [-3.004790818999936, 59.12799713700008],
            ],
          ],
          [
            [
              [-2.830067511999914, 59.19684479400007],
              [-2.817290818999936, 59.19122955900008],
              [-2.807118292999917, 59.19179922100005],
              [-2.797271287999934, 59.195013739000046],
              [-2.785959438999953, 59.19684479400007],
              [-2.784901495999918, 59.20034414300005],
              [-2.790272589999915, 59.21759674700007],
              [-2.789133266999954, 59.22418854400007],
              [-2.791900193999936, 59.23696523600006],
              [-2.787912563999953, 59.24721914300005],
              [-2.777455206999946, 59.25291575700004],
              [-2.761097785999937, 59.25210195500006],
              [-2.761097785999937, 59.24461497600004],
              [-2.768625454999949, 59.24461497600004],
              [-2.768625454999949, 59.23786041900007],
              [-2.755441860999952, 59.23940664300005],
              [-2.743641730999911, 59.23810455900008],
              [-2.734201626999948, 59.23334381700005],
              [-2.727650519999941, 59.22418854400007],
              [-2.734201626999948, 59.21552155200004],
              [-2.756337042999917, 59.19806549700007],
              [-2.761097785999937, 59.19310130400004],
              [-2.761097785999937, 59.17731354400007],
              [-2.758941209999932, 59.16421133000006],
              [-2.751088019999941, 59.15607330900008],
              [-2.734486456999946, 59.15521881700005],
              [-2.734486456999946, 59.148423570000034],
              [-2.764027472999942, 59.142645575000074],
              [-2.781361456999946, 59.14142487200007],
              [-2.789133266999954, 59.14533112200007],
              [-2.792551235999952, 59.158636786000045],
              [-2.801625128999945, 59.16815827000005],
              [-2.81476803299995, 59.173895575000074],
              [-2.830067511999914, 59.175767320000034],
              [-2.830067511999914, 59.19684479400007],
            ],
          ],
          [
            [
              [-2.446400519999941, 59.293036200000074],
              [-2.424956834999932, 59.31045156500005],
              [-2.411040818999936, 59.31899648600006],
              [-2.404896613999938, 59.31635163000004],
              [-2.395497199999909, 59.29507070500006],
              [-2.392486131999931, 59.28546784100007],
              [-2.439808722999942, 59.28416575700004],
              [-2.458973761999914, 59.27912018400008],
              [-2.466949022999927, 59.26821523600006],
              [-2.477853969999956, 59.26276276200008],
              [-2.497385219999956, 59.23920319200005],
              [-2.504505988999938, 59.23338450700004],
              [-2.514759894999941, 59.23041413000004],
              [-2.51626542899993, 59.25214264500005],
              [-2.533111131999931, 59.251166083000044],
              [-2.57681230399993, 59.22418854400007],
              [-2.571766730999911, 59.23456452000005],
              [-2.569406704999949, 59.23786041900007],
              [-2.569406704999949, 59.24461497600004],
              [-2.588612433999913, 59.23867422100005],
              [-2.596791144999941, 59.239162502000056],
              [-2.60415605399993, 59.24461497600004],
              [-2.641224738999938, 59.217962958000044],
              [-2.661854620999918, 59.207098700000074],
              [-2.679269985999952, 59.20990631700005],
              [-2.68187415299991, 59.19635651200008],
              [-2.687652147999927, 59.19017161700003],
              [-2.692616339999915, 59.192287502000056],
              [-2.692941860999952, 59.20368073100008],
              [-2.687977667999917, 59.217962958000044],
              [-2.681019660999937, 59.22313060100004],
              [-2.671538865999935, 59.22532786700003],
              [-2.658802863999938, 59.23041413000004],
              [-2.649728969999956, 59.23696523600006],
              [-2.633168097999942, 59.25226471600007],
              [-2.624623175999943, 59.25828685100004],
              [-2.612619594999956, 59.26154205900008],
              [-2.602772589999915, 59.261419989000046],
              [-2.595570441999939, 59.264837958000044],
              [-2.591135219999956, 59.27875397300005],
              [-2.596669074999909, 59.28180573100008],
              [-2.61156165299991, 59.293036200000074],
              [-2.587717251999948, 59.29315827000005],
              [-2.547230597999942, 59.30573151200008],
              [-2.52212480399993, 59.306708075000074],
              [-2.52212480399993, 59.299261786000045],
              [-2.536976691999939, 59.29437897300005],
              [-2.551828579999949, 59.28742096600007],
              [-2.57681230399993, 59.27130768400008],
              [-2.569325324999909, 59.27016836100006],
              [-2.566273566999939, 59.268784898000035],
              [-2.563221808999913, 59.26508209800005],
              [-2.551625128999945, 59.270819403000075],
              [-2.518788214999915, 59.274318752000056],
              [-2.49242102799991, 59.28937409100007],
              [-2.47720292899993, 59.29075755400004],
              [-2.46117102799991, 59.290676174000055],
              [-2.446400519999941, 59.293036200000074],
            ],
          ],
          [
            [
              [-3.049183722999942, 59.31976959800005],
              [-3.058705206999946, 59.32298411700003],
              [-3.067005988999938, 59.322699286000045],
              [-3.073353644999941, 59.32453034100007],
              [-3.077056443999936, 59.334051825000074],
              [-3.056263800999943, 59.33429596600007],
              [-3.024322068999936, 59.33038971600007],
              [-3.008168097999942, 59.334051825000074],
              [-2.980336066999939, 59.35504791900007],
              [-2.965199347999942, 59.36090729400007],
              [-2.946685350999928, 59.35390859600005],
              [-2.946359829999949, 59.34955475500004],
              [-2.947661912999934, 59.348537502000056],
              [-2.950184699999909, 59.34861888200004],
              [-2.952951626999948, 59.347723700000074],
              [-2.963937954999949, 59.34023672100005],
              [-2.964507615999935, 59.33535390800006],
              [-2.960357225999928, 59.32656484600005],
              [-2.980946417999917, 59.32591380400004],
              [-2.987782355999911, 59.32656484600005],
              [-2.987782355999911, 59.31976959800005],
              [-2.909535285999937, 59.30703359600005],
              [-2.895497199999909, 59.30296458500004],
              [-2.876535610999952, 59.27692291900007],
              [-2.870961066999939, 59.27130768400008],
              [-2.85960852799991, 59.26752350500004],
              [-2.848866339999915, 59.266791083000044],
              [-2.839019334999932, 59.26508209800005],
              [-2.830067511999914, 59.25828685100004],
              [-2.830067511999914, 59.25210195500006],
              [-2.850087042999917, 59.25214264500005],
              [-2.862172003999945, 59.24721914300005],
              [-2.885365363999938, 59.23041413000004],
              [-2.884022589999915, 59.23924388200004],
              [-2.882232225999928, 59.24603913000004],
              [-2.878407355999911, 59.251939195000034],
              [-2.870961066999939, 59.25828685100004],
              [-2.920318162999934, 59.28314850500004],
              [-2.947417772999927, 59.29120514500005],
              [-2.974680141999954, 59.293036200000074],
              [-2.974680141999954, 59.285589911000045],
              [-2.969797329999949, 59.28192780200004],
              [-2.960357225999928, 59.27130768400008],
              [-2.974680141999954, 59.27875397300005],
              [-2.982411261999914, 59.26992422100005],
              [-2.989654100999928, 59.26707591400003],
              [-2.997792120999918, 59.26813385600008],
              [-3.008168097999942, 59.27130768400008],
              [-3.015126105999911, 59.27488841400003],
              [-3.020253058999913, 59.28034088700008],
              [-3.034657355999911, 59.301214911000045],
              [-3.036691860999952, 59.306708075000074],
              [-3.039947068999936, 59.31199778900003],
              [-3.049183722999942, 59.31976959800005],
            ],
          ],
          [
            [
              [-1.651275193999936, 59.528957424000055],
              [-1.643666144999941, 59.54564036700003],
              [-1.62523352799991, 59.55581289300005],
              [-1.602853969999956, 59.560248114000046],
              [-1.583119269999941, 59.55996328300006],
              [-1.582386847999942, 59.555121161000045],
              [-1.583851691999939, 59.55369700700004],
              [-1.586415167999917, 59.553615627000056],
              [-1.589344855999911, 59.55247630400004],
              [-1.603667772999927, 59.55093008000006],
              [-1.608143683999913, 59.54734935100004],
              [-1.610422329999949, 59.539496161000045],
              [-1.596750454999949, 59.539496161000045],
              [-1.596750454999949, 59.53204987200007],
              [-1.613392706999946, 59.526597398000035],
              [-1.631255662999934, 59.51699453300006],
              [-1.645497199999909, 59.514105536000045],
              [-1.651275193999936, 59.528957424000055],
            ],
          ],
          [
            [
              [-0.784575975999928, 60.61513906500005],
              [-0.769154425999943, 60.61318594000005],
              [-0.758371548999946, 60.60757070500006],
              [-0.754790818999936, 60.598944403000075],
              [-0.760731574999909, 60.58783600500004],
              [-0.785227016999954, 60.57632070500006],
              [-0.81314042899993, 60.58047109600005],
              [-0.842152472999942, 60.588324286000045],
              [-0.870472785999937, 60.58783600500004],
              [-0.870472785999937, 60.58038971600007],
              [-0.864898240999935, 60.57721588700008],
              [-0.861927863999938, 60.574204820000034],
              [-0.85960852799991, 60.57103099200003],
              [-0.856190558999913, 60.56732819200005],
              [-0.883534308999913, 60.57054271000004],
              [-0.905344204999949, 60.58685944200005],
              [-0.938832160999937, 60.62132396000004],
              [-0.938832160999937, 60.62872955900008],
              [-0.822132941999939, 60.62872955900008],
              [-0.811512824999909, 60.625881252000056],
              [-0.810047980999911, 60.61933014500005],
              [-0.811268683999913, 60.61229075700004],
              [-0.809071417999917, 60.608303127000056],
              [-0.800282355999911, 60.60797760600008],
              [-0.793527798999946, 60.61050039300005],
              [-0.788319464999915, 60.61359284100007],
              [-0.784575975999928, 60.61513906500005],
            ],
          ],
          [
            [
              [-1.097035285999937, 60.41648997600004],
              [-1.088002081999946, 60.43301015800006],
              [-1.072743292999917, 60.444525458000044],
              [-1.053944464999915, 60.450506903000075],
              [-1.034413214999915, 60.45062897300005],
              [-1.048695441999939, 60.43333567900004],
              [-1.119252081999946, 60.39130280200004],
              [-1.125070766999954, 60.38373444200005],
              [-1.123768683999913, 60.37555573100008],
              [-1.117543097999942, 60.373928127000056],
              [-1.11001542899993, 60.37872955900008],
              [-1.100209113999938, 60.38857656500005],
              [-1.094471808999913, 60.391506252000056],
              [-1.081450975999928, 60.39622630400004],
              [-1.068267381999931, 60.39630768400008],
              [-1.062326626999948, 60.38544342700004],
              [-1.062896287999934, 60.37986888200004],
              [-1.065419074999909, 60.369574286000045],
              [-1.070423956999946, 60.35952383000006],
              [-1.079172329999949, 60.35504791900007],
              [-1.157215949999909, 60.350775458000044],
              [-1.172230597999942, 60.34760163000004],
              [-1.151600714999915, 60.33730703300006],
              [-1.101226365999935, 60.33112213700008],
              [-1.075306769999941, 60.32094961100006],
              [-1.123117641999954, 60.29633209800005],
              [-1.134348110999952, 60.292954820000034],
              [-1.137928839999915, 60.290716864000046],
              [-1.138579881999931, 60.285589911000045],
              [-1.137115037999934, 60.27977122600004],
              [-1.134348110999952, 60.27558014500005],
              [-1.129505988999938, 60.27399323100008],
              [-1.122222459999932, 60.27924225500004],
              [-1.117014126999948, 60.27871328300006],
              [-1.109364386999914, 60.27619049700007],
              [-1.095855272999927, 60.275091864000046],
              [-1.089751756999931, 60.27252838700008],
              [-1.129709438999953, 60.252834377000056],
              [-1.147857225999928, 60.24884674700007],
              [-1.16470292899993, 60.25141022300005],
              [-1.174672003999945, 60.26463450700004],
              [-1.182932094999956, 60.271918036000045],
              [-1.192616339999915, 60.27252838700008],
              [-1.199126756999931, 60.266913153000075],
              [-1.198109503999945, 60.26056549700007],
              [-1.192534959999932, 60.25495026200008],
              [-1.185170050999943, 60.25141022300005],
              [-1.185170050999943, 60.24518463700008],
              [-1.194935675999943, 60.245347398000035],
              [-1.203277147999927, 60.243841864000046],
              [-1.21939042899993, 60.238348700000074],
              [-1.21939042899993, 60.23216380400004],
              [-1.179025844999956, 60.23216380400004],
              [-1.185536261999914, 60.22540924700007],
              [-1.190907355999911, 60.218451239000046],
              [-1.19945227799991, 60.20425039300005],
              [-1.181019660999937, 60.21784088700008],
              [-1.171131964999915, 60.22256094000005],
              [-1.157866990999935, 60.224676825000074],
              [-1.187245245999918, 60.19122955900008],
              [-1.192616339999915, 60.17633698100008],
              [-1.176503058999913, 60.18789297100005],
              [-1.155140753999945, 60.192572333000044],
              [-1.143950975999928, 60.187567450000074],
              [-1.157866990999935, 60.17011139500005],
              [-1.123768683999913, 60.15582916900007],
              [-1.123768683999913, 60.149603583000044],
              [-1.151722785999937, 60.149603583000044],
              [-1.151722785999937, 60.14215729400007],
              [-1.144276495999918, 60.14215729400007],
              [-1.144276495999918, 60.13532135600008],
              [-1.160878058999913, 60.14118073100008],
              [-1.170969204999949, 60.13621653900003],
              [-1.181548631999931, 60.12929922100005],
              [-1.19945227799991, 60.12909577000005],
              [-1.185170050999943, 60.12164948100008],
              [-1.189849412999934, 60.113348700000074],
              [-1.195139126999948, 60.108710028000075],
              [-1.202544725999928, 60.10691966400003],
              [-1.21320553299995, 60.10736725500004],
              [-1.21320553299995, 60.101223049000055],
              [-1.20531165299991, 60.10016510600008],
              [-1.185170050999943, 60.09438711100006],
              [-1.202259894999941, 60.08307526200008],
              [-1.192860480999911, 60.06981028900003],
              [-1.174427863999938, 60.06028880400004],
              [-1.16470292899993, 60.060248114000046],
              [-1.170074022999927, 60.04596588700008],
              [-1.185170050999943, 60.038275458000044],
              [-1.203724738999938, 60.03652578300006],
              [-1.21939042899993, 60.03974030200004],
              [-1.21507727799991, 60.02619049700007],
              [-1.192616339999915, 59.99750397300005],
              [-1.201242641999954, 59.986395575000074],
              [-1.215809699999909, 59.98688385600008],
              [-1.247303839999915, 59.99750397300005],
              [-1.242990688999953, 59.97687409100007],
              [-1.245228644999941, 59.95575592700004],
              [-1.253570115999935, 59.93695709800005],
              [-1.267730272999927, 59.923041083000044],
              [-1.271839972999942, 59.927801825000074],
              [-1.274566209999932, 59.92987702000005],
              [-1.266590949999909, 59.91819896000004],
              [-1.263417120999918, 59.90717194200005],
              [-1.26593990799995, 59.89557526200008],
              [-1.274566209999932, 59.882066148000035],
              [-1.263742641999954, 59.87490469000005],
              [-1.260975714999915, 59.866400458000044],
              [-1.265004035999937, 59.85883209800005],
              [-1.274566209999932, 59.85419342700004],
              [-1.278431769999941, 59.85911692900004],
              [-1.295033331999946, 59.874660549000055],
              [-1.302886522999927, 59.86432526200008],
              [-1.311105923999946, 59.86554596600007],
              [-1.312855597999942, 59.873114325000074],
              [-1.30142167899993, 59.882066148000035],
              [-1.30142167899993, 59.88890208500004],
              [-1.316477016999954, 59.89598216400003],
              [-1.34788977799991, 59.89199453300006],
              [-1.364003058999913, 59.89630768400008],
              [-1.375965949999909, 59.908636786000045],
              [-1.358021613999938, 59.921576239000046],
              [-1.364003058999913, 59.93732330900008],
              [-1.35570227799991, 59.94546133000006],
              [-1.345855272999927, 59.950384833000044],
              [-1.334787563999953, 59.95213450700004],
              [-1.322987433999913, 59.95099518400008],
              [-1.322987433999913, 59.95661041900007],
              [-1.341053839999915, 59.96775950700004],
              [-1.349720831999946, 59.97089264500005],
              [-1.349720831999946, 59.97768789300005],
              [-1.322987433999913, 59.97768789300005],
              [-1.328724738999938, 59.99551015800006],
              [-1.318023240999935, 60.01113515800006],
              [-1.302886522999927, 60.02802155200004],
              [-1.287709113999938, 60.07562897300005],
              [-1.273060675999943, 60.09520091400003],
              [-1.262603318999936, 60.11505768400008],
              [-1.267730272999927, 60.14215729400007],
              [-1.273060675999943, 60.146185614000046],
              [-1.278960740999935, 60.14508698100008],
              [-1.284535285999937, 60.14594147300005],
              [-1.288889126999948, 60.15582916900007],
              [-1.288156704999949, 60.15961334800005],
              [-1.285267706999946, 60.16461823100008],
              [-1.269357876999948, 60.18545156500005],
              [-1.27953040299991, 60.18512604400007],
              [-1.294056769999941, 60.179673570000034],
              [-1.298166469999956, 60.17633698100008],
              [-1.309193488999938, 60.177069403000075],
              [-1.312408006999931, 60.18065013200004],
              [-1.309315558999913, 60.18903229400007],
              [-1.294667120999918, 60.21539948100008],
              [-1.286773240999935, 60.22528717700004],
              [-1.277699347999942, 60.23322174700007],
              [-1.267730272999927, 60.238348700000074],
              [-1.267730272999927, 60.24518463700008],
              [-1.286936001999948, 60.24628327000005],
              [-1.301584438999953, 60.23578522300005],
              [-1.329253709999932, 60.20425039300005],
              [-1.343006964999915, 60.22748444200005],
              [-1.35765540299991, 60.24433014500005],
              [-1.378570115999935, 60.254787502000056],
              [-1.411122199999909, 60.25885651200008],
              [-1.411122199999909, 60.25141022300005],
              [-1.391835089999915, 60.246527411000045],
              [-1.376088019999941, 60.237941799000055],
              [-1.362456834999932, 60.22597890800006],
              [-1.349720831999946, 60.21108633000006],
              [-1.356556769999941, 60.19676341400003],
              [-1.376088019999941, 60.207098700000074],
              [-1.385324673999946, 60.210598049000055],
              [-1.398101365999935, 60.21108633000006],
              [-1.397572394999941, 60.192694403000075],
              [-1.40461178299995, 60.17951080900008],
              [-1.413644985999952, 60.176988023000035],
              [-1.418690558999913, 60.190619208000044],
              [-1.430775519999941, 60.184881903000075],
              [-1.434925910999937, 60.17446523600006],
              [-1.43773352799991, 60.163397528000075],
              [-1.44595292899993, 60.15582916900007],
              [-1.455433722999942, 60.15619538000004],
              [-1.494292772999927, 60.17011139500005],
              [-1.49640865799995, 60.17218659100007],
              [-1.517933722999942, 60.18451569200005],
              [-1.520985480999911, 60.18374258000006],
              [-1.527251756999931, 60.19293854400007],
              [-1.526722785999937, 60.19757721600007],
              [-1.520985480999911, 60.20425039300005],
              [-1.509510870999918, 60.20994700700004],
              [-1.479400193999936, 60.21401601800005],
              [-1.466420050999943, 60.217230536000045],
              [-1.479237433999913, 60.22223541900007],
              [-1.503651495999918, 60.243353583000044],
              [-1.507964647999927, 60.23529694200005],
              [-1.513335740999935, 60.22166575700004],
              [-1.525054490999935, 60.21234772300005],
              [-1.536773240999935, 60.210923570000034],
              [-1.542144334999932, 60.22093333500004],
              [-1.548247850999928, 60.229722398000035],
              [-1.562652147999927, 60.227443752000056],
              [-1.593006964999915, 60.217230536000045],
              [-1.615142381999931, 60.215725002000056],
              [-1.624663865999935, 60.217230536000045],
              [-1.630238410999937, 60.22089264500005],
              [-1.63117428299995, 60.225897528000075],
              [-1.632801886999914, 60.23029205900008],
              [-1.64085852799991, 60.23216380400004],
              [-1.661284959999932, 60.23387278900003],
              [-1.669748501999948, 60.239569403000075],
              [-1.679351365999935, 60.265692450000074],
              [-1.690174933999913, 60.285142320000034],
              [-1.686390753999945, 60.29092031500005],
              [-1.671864386999914, 60.29979075700004],
              [-1.657378709999932, 60.30621979400007],
              [-1.638742641999954, 60.31146881700005],
              [-1.61937415299991, 60.31435781500005],
              [-1.602935350999928, 60.31346263200004],
              [-1.588286912999934, 60.30703359600005],
              [-1.577219204999949, 60.29873281500005],
              [-1.565297003999945, 60.292669989000046],
              [-1.548410610999952, 60.292954820000034],
              [-1.555816209999932, 60.306626695000034],
              [-1.520985480999911, 60.29979075700004],
              [-1.520985480999911, 60.306626695000034],
              [-1.528431769999941, 60.306626695000034],
              [-1.528431769999941, 60.31346263200004],
              [-1.481434699999909, 60.316473700000074],
              [-1.467600063999953, 60.30853913000004],
              [-1.466420050999943, 60.27871328300006],
              [-1.461415167999917, 60.279730536000045],
              [-1.450184699999909, 60.28375885600008],
              [-1.44595292899993, 60.28620026200008],
              [-1.450917120999918, 60.29173411700003],
              [-1.456450975999928, 60.30231354400007],
              [-1.459584113999938, 60.306626695000034],
              [-1.439035610999952, 60.306626695000034],
              [-1.441802537999934, 60.31069570500006],
              [-1.44595292899993, 60.32094961100006],
              [-1.422759568999936, 60.32611725500004],
              [-1.396351691999939, 60.32184479400007],
              [-1.374256964999915, 60.30841705900008],
              [-1.364003058999913, 60.28620026200008],
              [-1.350005662999934, 60.297756252000056],
              [-1.336089647999927, 60.306626695000034],
              [-1.364003058999913, 60.32094961100006],
              [-1.343495245999918, 60.34760163000004],
              [-1.33657792899993, 60.343451239000046],
              [-1.33031165299991, 60.34202708500004],
              [-1.315541144999941, 60.34137604400007],
              [-1.328114386999914, 60.35268789300005],
              [-1.310170050999943, 60.35586172100005],
              [-1.260365363999938, 60.35504791900007],
              [-1.284291144999941, 60.36351146000004],
              [-1.313832160999937, 60.366848049000055],
              [-1.337554490999935, 60.37445709800005],
              [-1.343495245999918, 60.39598216400003],
              [-1.362538214999915, 60.38471100500004],
              [-1.373402472999942, 60.38108958500004],
              [-1.384429490999935, 60.38239166900007],
              [-1.395008917999917, 60.389960028000075],
              [-1.398589647999927, 60.399603583000044],
              [-1.395253058999913, 60.40916575700004],
              [-1.384429490999935, 60.41648997600004],
              [-1.384429490999935, 60.42332591400003],
              [-1.415638800999943, 60.423163153000075],
              [-1.429107225999928, 60.42523834800005],
              [-1.439035610999952, 60.43081289300005],
              [-1.436268683999913, 60.44318268400008],
              [-1.438099738999938, 60.46051666900007],
              [-1.44595292899993, 60.492254950000074],
              [-1.459380662999934, 60.47280508000006],
              [-1.469838019999941, 60.462225653000075],
              [-1.480091925999943, 60.457464911000045],
              [-1.495594855999911, 60.46088288000004],
              [-1.499094204999949, 60.46906159100007],
              [-1.493072068999936, 60.47846100500004],
              [-1.480091925999943, 60.48541901200008],
              [-1.50023352799991, 60.48517487200007],
              [-1.516753709999932, 60.48261139500005],
              [-1.532093878999945, 60.48309967700004],
              [-1.548410610999952, 60.492254950000074],
              [-1.557484503999945, 60.48065827000005],
              [-1.572010870999918, 60.47675202000005],
              [-1.606678839999915, 60.47797272300005],
              [-1.609364386999914, 60.48334381700005],
              [-1.60415605399993, 60.495021877000056],
              [-1.595122850999928, 60.50678131700005],
              [-1.58617102799991, 60.51211172100005],
              [-1.561512824999909, 60.51068756700005],
              [-1.555816209999932, 60.51211172100005],
              [-1.550689256999931, 60.51902903900003],
              [-1.550200975999928, 60.52635325700004],
              [-1.550689256999931, 60.53339264500005],
              [-1.548410610999952, 60.53937409100007],
              [-1.538726365999935, 60.54897695500006],
              [-1.526966925999943, 60.55683014500005],
              [-1.51398678299995, 60.557806708000044],
              [-1.500559048999946, 60.54682038000004],
              [-1.488189256999931, 60.525824286000045],
              [-1.455067511999914, 60.50885651200008],
              [-1.417469855999911, 60.50218333500004],
              [-1.384429490999935, 60.51211172100005],
              [-1.395741339999915, 60.51666901200008],
              [-1.410715298999946, 60.51862213700008],
              [-1.435943162999934, 60.51894765800006],
              [-1.443186001999948, 60.52252838700008],
              [-1.451975063999953, 60.530178127000056],
              [-1.463856574999909, 60.53742096600007],
              [-1.480091925999943, 60.53937409100007],
              [-1.471587693999936, 60.54645416900007],
              [-1.457997199999909, 60.56386953300006],
              [-1.452788865999935, 60.56732819200005],
              [-1.44163977799991, 60.568793036000045],
              [-1.411122199999909, 60.58038971600007],
              [-1.421457485999952, 60.58616771000004],
              [-1.425363735999952, 60.58783600500004],
              [-1.416493292999917, 60.595038153000075],
              [-1.414051886999914, 60.59992096600007],
              [-1.415638800999943, 60.60382721600007],
              [-1.418690558999913, 60.608303127000056],
              [-1.394154425999943, 60.61432526200008],
              [-1.366851365999935, 60.61225006700005],
              [-1.339751756999931, 60.60464101800005],
              [-1.315541144999941, 60.59406159100007],
              [-1.312489386999914, 60.59829336100006],
              [-1.308705206999946, 60.60146719000005],
              [-1.326161261999914, 60.61115143400008],
              [-1.323963995999918, 60.62132396000004],
              [-1.30142167899993, 60.64305247600004],
              [-1.291411912999934, 60.623114325000074],
              [-1.290679490999935, 60.61513906500005],
              [-1.295033331999946, 60.608303127000056],
              [-1.292103644999941, 60.599595445000034],
              [-1.293527798999946, 60.59324778900003],
              [-1.29914303299995, 60.58926015800006],
              [-1.308705206999946, 60.58783600500004],
              [-1.30142167899993, 60.56484609600005],
              [-1.309437628999945, 60.55410390800006],
              [-1.323963995999918, 60.54645416900007],
              [-1.336089647999927, 60.533189195000034],
              [-1.315541144999941, 60.533189195000034],
              [-1.320301886999914, 60.52826569200005],
              [-1.324818488999938, 60.526556708000044],
              [-1.336089647999927, 60.52578359600005],
              [-1.330555792999917, 60.523871161000045],
              [-1.327300584999932, 60.52167389500005],
              [-1.323353644999941, 60.51984284100007],
              [-1.315541144999941, 60.51894765800006],
              [-1.336089647999927, 60.48541901200008],
              [-1.326527472999942, 60.486395575000074],
              [-1.317494269999941, 60.48891836100006],
              [-1.309152798999946, 60.49290599200003],
              [-1.30142167899993, 60.49843984600005],
              [-1.295033331999946, 60.492254950000074],
              [-1.309152798999946, 60.47703685100004],
              [-1.311919725999928, 60.47089264500005],
              [-1.308705206999946, 60.464911200000074],
              [-1.308705206999946, 60.457464911000045],
              [-1.327951626999948, 60.453192450000074],
              [-1.35179602799991, 60.41836172100005],
              [-1.370228644999941, 60.40965403900003],
              [-1.370228644999941, 60.40216705900008],
              [-1.357492641999954, 60.40143463700008],
              [-1.345041469999956, 60.402329820000034],
              [-1.333363410999937, 60.40501536700003],
              [-1.322987433999913, 60.40965403900003],
              [-1.324330206999946, 60.427720445000034],
              [-1.296986456999946, 60.43797435100004],
              [-1.233631964999915, 60.443793036000045],
              [-1.280995245999918, 60.46185944200005],
              [-1.295033331999946, 60.471136786000045],
              [-1.284738735999952, 60.47870514500005],
              [-1.271962042999917, 60.48427969000005],
              [-1.26195227799991, 60.48159414300005],
              [-1.260365363999938, 60.464911200000074],
              [-1.251210089999915, 60.47085195500006],
              [-1.23078365799995, 60.488714911000045],
              [-1.22687740799995, 60.495306708000044],
              [-1.217518683999913, 60.49799225500004],
              [-1.199289516999954, 60.49237702000005],
              [-1.186268683999913, 60.48224518400008],
              [-1.192616339999915, 60.471136786000045],
              [-1.180165167999917, 60.46820709800005],
              [-1.169911261999914, 60.46312083500004],
              [-1.16234290299991, 60.45526764500005],
              [-1.157866990999935, 60.443793036000045],
              [-1.163075324999909, 60.43927643400008],
              [-1.16470292899993, 60.43695709800005],
              [-1.151722785999937, 60.43081289300005],
              [-1.163970506999931, 60.425482489000046],
              [-1.185902472999942, 60.43158600500004],
              [-1.196034308999913, 60.427069403000075],
              [-1.204335089999915, 60.42015208500004],
              [-1.214019334999932, 60.41498444200005],
              [-1.224191860999952, 60.411444403000075],
              [-1.220773891999954, 60.40912506700005],
              [-1.208648240999935, 60.41071198100008],
              [-1.185170050999943, 60.41648997600004],
              [-1.189116990999935, 60.41400788000004],
              [-1.19945227799991, 60.40965403900003],
              [-1.19945227799991, 60.40216705900008],
              [-1.165435350999928, 60.41205475500004],
              [-1.153675910999937, 60.407904364000046],
              [-1.151722785999937, 60.38857656500005],
              [-1.144276495999918, 60.38857656500005],
              [-1.140288865999935, 60.398871161000045],
              [-1.13695227799991, 60.39948151200008],
              [-1.132150844999956, 60.39801666900007],
              [-1.123768683999913, 60.40216705900008],
              [-1.119740363999938, 60.40814850500004],
              [-1.116688605999911, 60.415676174000055],
              [-1.112049933999913, 60.42365143400008],
              [-1.103423631999931, 60.43081289300005],
              [-1.099964972999942, 60.42747630400004],
              [-1.098378058999913, 60.42422109600005],
              [-1.097035285999937, 60.41648997600004],
            ],
          ],
          [
            [
              [-0.987172003999945, 60.697699286000045],
              [-0.997954881999931, 60.685614325000074],
              [-0.997059699999909, 60.67609284100007],
              [-0.979725714999915, 60.656683661000045],
              [-0.985707160999937, 60.64590078300006],
              [-0.993478969999956, 60.635646877000056],
              [-1.025868292999917, 60.65448639500005],
              [-1.042591925999943, 60.66156647300005],
              [-1.062326626999948, 60.66290924700007],
              [-1.050526495999918, 60.655585028000075],
              [-1.036773240999935, 60.64288971600007],
              [-1.01390540299991, 60.61513906500005],
              [-1.027088995999918, 60.61009349200003],
              [-1.041005011999914, 60.60797760600008],
              [-1.055287238999938, 60.609442450000074],
              [-1.069162563999953, 60.61513906500005],
              [-1.064279751999948, 60.60407135600008],
              [-1.052072719999956, 60.597642320000034],
              [-1.036366339999915, 60.59471263200004],
              [-1.020741339999915, 60.59406159100007],
              [-1.022694464999915, 60.590725002000056],
              [-1.022938605999911, 60.589829820000034],
              [-1.028187628999945, 60.58783600500004],
              [-1.011057094999956, 60.57770416900007],
              [-1.010731574999909, 60.56549713700008],
              [-1.022531704999949, 60.55565013200004],
              [-1.041859503999945, 60.55304596600007],
              [-1.026966925999943, 60.53583405200004],
              [-1.022450324999909, 60.52724844000005],
              [-1.020741339999915, 60.51552969000005],
              [-1.023793097999942, 60.50299713700008],
              [-1.031727667999917, 60.50067780200004],
              [-1.055490688999953, 60.505845445000034],
              [-1.080067511999914, 60.505194403000075],
              [-1.09203040299991, 60.50771719000005],
              [-1.097035285999937, 60.51552969000005],
              [-1.100697394999941, 60.51504140800006],
              [-1.106556769999941, 60.511053778000075],
              [-1.10773678299995, 60.505072333000044],
              [-1.097035285999937, 60.49843984600005],
              [-1.097035285999937, 60.492254950000074],
              [-1.130523240999935, 60.49603913000004],
              [-1.153879360999952, 60.50836823100008],
              [-1.167795376999948, 60.530462958000044],
              [-1.180043097999942, 60.624660549000055],
              [-1.171376105999911, 60.64598216400003],
              [-1.138050910999937, 60.64923737200007],
              [-1.138050910999937, 60.64305247600004],
              [-1.141021287999934, 60.63117096600007],
              [-1.130116339999915, 60.61933014500005],
              [-1.114491339999915, 60.61245351800005],
              [-1.103423631999931, 60.61513906500005],
              [-1.106556769999941, 60.61977773600006],
              [-1.120594855999911, 60.646185614000046],
              [-1.123768683999913, 60.659816799000055],
              [-1.120961066999939, 60.66640859600005],
              [-1.111480272999927, 60.68113841400003],
              [-1.11392167899993, 60.684027411000045],
              [-1.119536912999934, 60.68789297100005],
              [-1.120432094999956, 60.696926174000055],
              [-1.118031378999945, 60.70722077000005],
              [-1.11392167899993, 60.71474844000005],
              [-1.103993292999917, 60.725775458000044],
              [-1.09211178299995, 60.73533763200004],
              [-1.079904751999948, 60.735541083000044],
              [-1.069162563999953, 60.71816640800006],
              [-1.057606574999909, 60.729722398000035],
              [-1.036976691999939, 60.73314036700003],
              [-0.993478969999956, 60.73114655200004],
              [-0.993153449999909, 60.71771881700005],
              [-0.994740363999938, 60.71360911700003],
              [-1.000884568999936, 60.711371161000045],
              [-1.000884568999936, 60.70392487200007],
              [-0.995961066999939, 60.702460028000075],
              [-0.991607225999928, 60.69953034100007],
              [-0.987172003999945, 60.697699286000045],
            ],
          ],
          [
            [
              [-0.904693162999934, 60.684027411000045],
              [-0.934803839999915, 60.68211497600004],
              [-0.950306769999941, 60.68431224200003],
              [-0.966175910999937, 60.69017161700003],
              [-0.961333787999934, 60.70001862200007],
              [-0.959950324999909, 60.709418036000045],
              [-0.961822068999936, 60.71792226800005],
              [-0.966175910999937, 60.72500234600005],
              [-0.948597785999937, 60.717962958000044],
              [-0.943226691999939, 60.72601959800005],
              [-0.945790167999917, 60.740301825000074],
              [-0.952463344999956, 60.75234609600005],
              [-0.935699022999927, 60.75600820500006],
              [-0.926136847999942, 60.769598700000074],
              [-0.926177537999934, 60.78465403900003],
              [-0.938832160999937, 60.792669989000046],
              [-0.938832160999937, 60.800116278000075],
              [-0.923085089999915, 60.80410390800006],
              [-0.904164191999939, 60.81395091400003],
              [-0.890533006999931, 60.82558828300006],
              [-0.891021287999934, 60.834865627000056],
              [-0.88149980399993, 60.845038153000075],
              [-0.870106574999909, 60.84520091400003],
              [-0.860340949999909, 60.837551174000055],
              [-0.856190558999913, 60.82396067900004],
              [-0.860340949999909, 60.812933661000045],
              [-0.870187954999949, 60.80638255400004],
              [-0.881662563999953, 60.800848700000074],
              [-0.891021287999934, 60.792669989000046],
              [-0.888335740999935, 60.78974030200004],
              [-0.876128709999932, 60.792669989000046],
              [-0.86196855399993, 60.79824453300006],
              [-0.853138800999943, 60.80353424700007],
              [-0.831776495999918, 60.840277411000045],
              [-0.822132941999939, 60.84788646000004],
              [-0.815581834999932, 60.843085028000075],
              [-0.809722459999932, 60.84170156500005],
              [-0.795480923999946, 60.841009833000044],
              [-0.782785610999952, 60.83820221600007],
              [-0.771839972999942, 60.83340078300006],
              [-0.76390540299991, 60.825425523000035],
              [-0.760731574999909, 60.81313711100006],
              [-0.768788214999915, 60.81268952000005],
              [-0.787993943999936, 60.80695221600007],
              [-0.768544074999909, 60.80097077000005],
              [-0.760731574999909, 60.800116278000075],
              [-0.775786912999934, 60.79157135600008],
              [-0.795765753999945, 60.78563060100004],
              [-0.808461066999939, 60.778631903000075],
              [-0.801665818999936, 60.76654694200005],
              [-0.801665818999936, 60.759100653000075],
              [-0.821400519999941, 60.75853099200003],
              [-0.814564581999946, 60.757147528000075],
              [-0.808013475999928, 60.755113023000035],
              [-0.801665818999936, 60.75234609600005],
              [-0.801665818999936, 60.74481842700004],
              [-0.842762824999909, 60.72402578300006],
              [-0.850005662999934, 60.71816640800006],
              [-0.843006964999915, 60.70600006700005],
              [-0.828846808999913, 60.69489166900007],
              [-0.821888800999943, 60.68500397300005],
              [-0.836415167999917, 60.67658112200007],
              [-0.846180792999917, 60.67597077000005],
              [-0.854481574999909, 60.67829010600008],
              [-0.862212693999936, 60.68158600500004],
              [-0.870472785999937, 60.684027411000045],
              [-0.890126105999911, 60.68496328300006],
              [-0.904693162999934, 60.684027411000045],
            ],
          ],
          [
            [
              [-6.298817511999914, 49.93549225500004],
              [-6.292225714999915, 49.932074286000045],
              [-6.284169074999909, 49.922756252000056],
              [-6.287505662999934, 49.91400788000004],
              [-6.297271287999934, 49.90961334800005],
              [-6.309152798999946, 49.91364166900007],
              [-6.307443813999953, 49.927435614000046],
              [-6.298817511999914, 49.93549225500004],
            ],
          ],
          [
            [
              [-6.333648240999935, 49.95970286700003],
              [-6.328033006999931, 49.95661041900007],
              [-6.32648678299995, 49.949204820000034],
              [-6.332508917999917, 49.94171784100007],
              [-6.341216600999928, 49.94476959800005],
              [-6.348052537999934, 49.95620351800005],
              [-6.348947719999956, 49.96434153900009],
              [-6.341786261999914, 49.96360911700003],
              [-6.336822068999936, 49.960923570000034],
              [-6.333648240999935, 49.95970286700003],
            ],
          ],
          [
            [
              [-4.665435350999928, 51.183579820000034],
              [-4.663970506999931, 51.177069403000075],
              [-4.663482225999928, 51.16486237200007],
              [-4.670480923999946, 51.16010163000004],
              [-4.678537563999953, 51.16705963700008],
              [-4.679798956999946, 51.180568752000056],
              [-4.67642167899993, 51.19310130400004],
              [-4.671213344999956, 51.19505442900004],
              [-4.666981574999909, 51.18768952000005],
              [-4.665435350999928, 51.183579820000034],
            ],
          ],
          [
            [
              [-13.690419074999909, 57.59625885600008],
              [-13.69131425699993, 57.59650299700007],
              [-13.69131425699993, 57.59715403900003],
              [-13.690419074999909, 57.59780508000006],
              [-13.68858801999994, 57.59780508000006],
              [-13.687652147999927, 57.59715403900003],
              [-13.687652147999927, 57.596869208000044],
              [-13.68858801999994, 57.59625885600008],
              [-13.690419074999909, 57.59625885600008],
            ],
          ],
          [
            [
              [-1.31509355399993, 60.093736070000034],
              [-1.308257615999935, 60.09414297100005],
              [-1.304798956999946, 60.08657461100006],
              [-1.309803839999915, 60.07636139500005],
              [-1.317738410999937, 60.06622955900008],
              [-1.326771613999938, 60.05060455900008],
              [-1.333566860999952, 60.04360586100006],
              [-1.339019334999932, 60.04389069200005],
              [-1.338002081999946, 60.05109284100007],
              [-1.333851691999939, 60.06150950700004],
              [-1.333119269999941, 60.07367584800005],
              [-1.33462480399993, 60.07632070500006],
              [-1.335804816999939, 60.07005442900004],
              [-1.338368292999917, 60.06403229400007],
              [-1.353871222999942, 60.051214911000045],
              [-1.367909308999913, 60.04482656500005],
              [-1.369862433999913, 60.04913971600007],
              [-1.357004360999952, 60.05817291900007],
              [-1.352040167999917, 60.069525458000044],
              [-1.347564256999931, 60.08344147300005],
              [-1.338002081999946, 60.093451239000046],
              [-1.340443488999938, 60.099676825000074],
              [-1.346994594999956, 60.10455963700008],
              [-1.345692511999914, 60.10895416900007],
              [-1.327788865999935, 60.111395575000074],
              [-1.321156378999945, 60.115668036000045],
              [-1.315825975999928, 60.11546458500004],
              [-1.315052863999938, 60.10639069200005],
              [-1.321766730999911, 60.093085028000075],
              [-1.323353644999941, 60.08820221600007],
              [-1.31509355399993, 60.093736070000034],
            ],
          ],
          [
            [
              [-2.053212042999917, 60.155503648000035],
              [-2.048898891999954, 60.14712148600006],
              [-2.048085089999915, 60.12921784100007],
              [-2.062977667999917, 60.11798737200007],
              [-2.086903449999909, 60.12327708500004],
              [-2.105376756999931, 60.132066148000035],
              [-2.112294074999909, 60.138006903000075],
              [-2.110340949999909, 60.14533112200007],
              [-2.103423631999931, 60.150051174000055],
              [-2.087880011999914, 60.155462958000044],
              [-2.06468665299991, 60.15729401200008],
              [-2.053212042999917, 60.155503648000035],
            ],
          ],
          [
            [
              [-1.062855597999942, 60.164048570000034],
              [-1.050526495999918, 60.169623114000046],
              [-1.050445115999935, 60.16278717700004],
              [-1.052723761999914, 60.148423570000034],
              [-1.059478318999936, 60.13764069200005],
              [-1.066761847999942, 60.12921784100007],
              [-1.073801235999952, 60.10773346600007],
              [-1.083892381999931, 60.105169989000046],
              [-1.112945115999935, 60.11627838700008],
              [-1.122222459999932, 60.123114325000074],
              [-1.119252081999946, 60.155585028000075],
              [-1.135650193999936, 60.167954820000034],
              [-1.134917772999927, 60.17869700700004],
              [-1.115793423999946, 60.18016185100004],
              [-1.097523566999939, 60.17572663000004],
              [-1.089588995999918, 60.178168036000045],
              [-1.086415167999917, 60.18646881700005],
              [-1.079457160999937, 60.18829987200007],
              [-1.074940558999913, 60.182806708000044],
              [-1.073150193999936, 60.17300039300005],
              [-1.069935675999943, 60.16421133000006],
              [-1.062855597999942, 60.164048570000034],
            ],
          ],
          [
            [
              [-0.918771938999953, 60.38617584800005],
              [-0.912668423999946, 60.386786200000074],
              [-0.911203579999949, 60.38231028900003],
              [-0.917713995999918, 60.376654364000046],
              [-0.931385870999918, 60.368475653000075],
              [-0.948597785999937, 60.35586172100005],
              [-0.975982225999928, 60.34031810100004],
              [-1.015207485999952, 60.33413320500006],
              [-1.034087693999936, 60.34015534100007],
              [-1.028920050999943, 60.34564850500004],
              [-1.023589647999927, 60.34943268400008],
              [-1.021555141999954, 60.35447825700004],
              [-1.016428188999953, 60.36200592700004],
              [-1.006418423999946, 60.36896393400008],
              [-0.995228644999941, 60.37164948100008],
              [-0.983631964999915, 60.372300523000035],
              [-0.974476691999939, 60.37592194200005],
              [-0.967600063999953, 60.38104889500005],
              [-0.93228105399993, 60.38275788000004],
              [-0.921783006999931, 60.38458893400008],
              [-0.918771938999953, 60.38617584800005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Greece',
        iso3: 'GRC',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [20.96526249200008, 40.849394023000045],
              [21.112126912000065, 40.85394154900008],
              [21.183026977000026, 40.87016794800009],
              [21.209071899, 40.869082744000096],
              [21.245824293000055, 40.863225788000065],
              [21.260955037000116, 40.86081451400004],
              [21.295371541000065, 40.860866191000056],
              [21.329271281000075, 40.86629221700012],
              [21.344877564000114, 40.873061829000065],
              [21.381257772000083, 40.900502014000025],
              [21.404925577000114, 40.90861521400002],
              [21.429420207000078, 40.90897694900012],
              [21.505730550000067, 40.90090282200005],
              [21.50951867700013, 40.900502014000025],
              [21.553650350000026, 40.87042633100005],
              [21.581555623000014, 40.86629221700012],
              [21.590340617000095, 40.87068471300002],
              [21.613698364000044, 40.88830637600002],
              [21.62372359200006, 40.894404195000064],
              [21.629511353000055, 40.89507598900006],
              [21.643877400000065, 40.89445587200008],
              [21.648838339000093, 40.89579945900006],
              [21.652662394000032, 40.90138051300006],
              [21.654832805000126, 40.91429962200006],
              [21.656899861000085, 40.91822703000004],
              [21.685115194000048, 40.92799387700008],
              [21.73699833200004, 40.919157206000094],
              [21.757090880000106, 40.92250596400005],
              [21.765523722000097, 40.923911438000076],
              [21.77813277200002, 40.933729960000065],
              [21.78175012200012, 40.94509877600005],
              [21.781853475000048, 40.955899150000064],
              [21.783713826000053, 40.96416737900002],
              [21.79363570200013, 40.97357249000008],
              [21.831256144000065, 40.993519592],
              [21.83135949700008, 40.993622945000126],
              [21.831462850000037, 40.993726298000055],
              [21.84500207500008, 41.01238149000004],
              [21.88065881400007, 41.038426412],
              [21.894301391000084, 41.05382598900009],
              [21.896161743000107, 41.06142242500006],
              [21.89633270900012, 41.06470496500013],
              [21.89719527200009, 41.08126617500004],
              [21.901226034000075, 41.09077463800013],
              [21.909080851000112, 41.09749257400004],
              [21.925545235000072, 41.1067537900001],
              [21.934712362000084, 41.11191029900006],
              [21.96509810400002, 41.12436431900004],
              [22.029073527, 41.13857533800011],
              [22.033827759000104, 41.14126251200004],
              [22.044059692000076, 41.149944153],
              [22.048193807000104, 41.15185618200012],
              [22.055531860000087, 41.149892477],
              [22.058632446000047, 41.14508656800008],
              [22.060286092000098, 41.1400222780001],
              [22.062766561000075, 41.13718007400003],
              [22.09594283000007, 41.12364084900004],
              [22.103384237000085, 41.121522115000076],
              [22.1243648680001, 41.12720652300003],
              [22.160331665000086, 41.151907857000126],
              [22.183172648000067, 41.15991770400011],
              [22.205806926000037, 41.16141632100003],
              [22.21363684100004, 41.16068357500005],
              [22.225133912000075, 41.159607646000026],
              [22.262961060000066, 41.150460918000036],
              [22.29345015400014, 41.14751536100003],
              [22.302648560000137, 41.14549998000008],
              [22.305232381000053, 41.14162424700005],
              [22.306679321000047, 41.12844675800007],
              [22.308746379000098, 41.12498443600002],
              [22.3150509030001, 41.124415995000064],
              [22.323422485000094, 41.128498434000065],
              [22.342336060000036, 41.128963522],
              [22.367657512000108, 41.13237416600002],
              [22.380163208000113, 41.13170237300004],
              [22.389258260000076, 41.128343405000024],
              [22.41044559700012, 41.11790476500009],
              [22.421814413000106, 41.11464915],
              [22.451476684000085, 41.11366729700005],
              [22.467496379000124, 41.1150108850001],
              [22.481449015000123, 41.11774973600005],
              [22.500672648000148, 41.12214223200006],
              [22.51658898900007, 41.12224558600006],
              [22.54924849400004, 41.118524882000074],
              [22.571262655000112, 41.11950673500003],
              [22.58663401000007, 41.124084543],
              [22.590176229000065, 41.12513946600005],
              [22.607332804000123, 41.135991516],
              [22.624489380000085, 41.15263132800003],
              [22.62676314300009, 41.16079620300006],
              [22.62593632000008, 41.169787903],
              [22.62934696500011, 41.17707428000007],
              [22.644539835000046, 41.18022654300002],
              [22.656115356000072, 41.17805613200004],
              [22.657185370000064, 41.17698611900006],
              [22.661903117000065, 41.17226837200006],
              [22.666347290000147, 41.16451690700005],
              [22.674098755000074, 41.15661041300011],
              [22.691875448000104, 41.14456980400003],
              [22.704897908000135, 41.139660543],
              [22.715749959000078, 41.14560333300001],
              [22.72722212700009, 41.165808818000116],
              [22.736730591000082, 41.204411113],
              [22.740864705, 41.283579407],
              [22.74200348000008, 41.287029556],
              [22.751303345000053, 41.315205384000095],
              [22.76229345200005, 41.322500211000076],
              [22.78096561600009, 41.33489410400004],
              [22.79681768200004, 41.337039223],
              [22.82602746600014, 41.340991923],
              [22.916977986000063, 41.3357726040001],
              [23.115208781000035, 41.312673238000016],
              [23.15717004300012, 41.31634226500002],
              [23.179700968000134, 41.32135487900008],
              [23.190656372000035, 41.32605743500004],
              [23.19954471900013, 41.33298207600002],
              [23.204815714000063, 41.34269724500008],
              [23.2063660070001, 41.360939026000025],
              [23.2097766520001, 41.36858713800011],
              [23.22424605300006, 41.37902577800004],
              [23.2465702720001, 41.38972279900004],
              [23.269928019000048, 41.39726755800008],
              [23.287704712000078, 41.39819773400005],
              [23.306204875000105, 41.38837921200009],
              [23.315609985000066, 41.37685536700006],
              [23.326048625000112, 41.36931060800002],
              [23.34723596200007, 41.37122263600013],
              [23.36511600700004, 41.3785606900001],
              [23.39550175000008, 41.395252177000046],
              [23.414518677000046, 41.3999030560001],
              [23.513013957000112, 41.39773264600002],
              [23.57895308400012, 41.371997783000026],
              [23.61243941200013, 41.37101593100006],
              [23.624846740000066, 41.37709384500006],
              [23.627735637000086, 41.3785090140001],
              [23.6528503830001, 41.397629293000094],
              [23.672177368000064, 41.40295196500004],
              [23.705353638000076, 41.4031586710001],
              [23.738219848000085, 41.39747426400005],
              [23.754446248000107, 41.40067820200004],
              [23.77708052600005, 41.42904856400013],
              [23.792066691000116, 41.434474589],
              [23.809740031000047, 41.43380279500012],
              [23.83092736800009, 41.4356114700001],
              [23.851597941000108, 41.439590556],
              [23.867720988000087, 41.4454816690001],
              [23.894799438000035, 41.46434356700003],
              [23.90286096200012, 41.463516745],
              [23.949886515000117, 41.43757517500005],
              [23.964665975000116, 41.43835032200006],
              [23.981305786000036, 41.45085601900006],
              [23.986886841000057, 41.45369822200003],
              [23.992364542000132, 41.45462839800008],
              [23.997118774000057, 41.457005514000045],
              [24.000736125000117, 41.46413686100006],
              [24.02285363700014, 41.453078105000074],
              [24.034739217000066, 41.451321106000094],
              [24.04590132700008, 41.45545522100009],
              [24.051999146000043, 41.46299998000005],
              [24.052515910000096, 41.47147491500006],
              [24.049828736000052, 41.49364410400007],
              [24.047348267000075, 41.5257351690001],
              [24.076597127000127, 41.53601877900009],
              [24.116491333000084, 41.53338328000008],
              [24.146256958000066, 41.526768697000094],
              [24.15400842300008, 41.522117818000126],
              [24.158452596000075, 41.51633005800004],
              [24.162793416000056, 41.51204091400008],
              [24.170234823000072, 41.511575826000055],
              [24.173128703000145, 41.515296529000054],
              [24.177469523000127, 41.53100616500005],
              [24.18160363800007, 41.53736236600007],
              [24.196279744000066, 41.54702585900007],
              [24.197697918000074, 41.54771063500009],
              [24.214366496000082, 41.55575917600005],
              [24.23328007, 41.561805318],
              [24.25074670400005, 41.56345896400005],
              [24.26686975100003, 41.54976471000005],
              [24.28640344200005, 41.54035959900007],
              [24.287333618000105, 41.531626282],
              [24.28505985500007, 41.52315134700011],
              [24.28681685400005, 41.5176219690001],
              [24.296118612000072, 41.515244853000056],
              [24.303043254000073, 41.51695017500002],
              [24.309554484000046, 41.519792379000094],
              [24.318236124000094, 41.52077423100006],
              [24.345004517000064, 41.5183971150001],
              [24.353892863000084, 41.519120586],
              [24.387482544000108, 41.52666534500007],
              [24.40288212100009, 41.527853902000075],
              [24.42396610500012, 41.525218405000075],
              [24.438848917000144, 41.527698873000034],
              [24.45920943200008, 41.54950632800005],
              [24.48132694500009, 41.55322703100008],
              [24.510162395000123, 41.56165028900007],
              [24.53093632000008, 41.547542623000126],
              [24.543338664000146, 41.52134267200002],
              [24.54654260300012, 41.49364410400007],
              [24.549436483000108, 41.48542755200005],
              [24.553570598000135, 41.480776673],
              [24.55873824100013, 41.47684926400002],
              [24.564112589000104, 41.47106150400005],
              [24.56772993900009, 41.468115947000044],
              [24.577238403000052, 41.463568421],
              [24.581062459000094, 41.460209453000104],
              [24.58219934100012, 41.455248515000065],
              [24.57971887200003, 41.444189759000054],
              [24.58044234200014, 41.44052073200005],
              [24.595841919000122, 41.42977203400004],
              [24.60948449700004, 41.427239888000045],
              [24.644314413000075, 41.427653300000046],
              [24.638216594000113, 41.417679749000044],
              [24.661264282000104, 41.417679749000044],
              [24.68090132600011, 41.415509338000064],
              [24.69919478300011, 41.408946432000064],
              [24.71872847500009, 41.39571726500007],
              [24.7526282150001, 41.36274770100003],
              [24.774435669000127, 41.348071595000036],
              [24.794279419000134, 41.34739980100004],
              [24.802857706000054, 41.361920878],
              [24.80017053200004, 41.37933583600004],
              [24.803271118000083, 41.392668355000055],
              [24.84213179500003, 41.39473541300002],
              [24.863009074000104, 41.40031646800013],
              [24.872930949000107, 41.40186676100005],
              [24.88636682200007, 41.40062652600001],
              [24.916959269000074, 41.386363831000025],
              [25.080360148000068, 41.33406728200002],
              [25.09679325400012, 41.33670277900005],
              [25.101857544000097, 41.33665110300002],
              [25.104854777000128, 41.33406728200002],
              [25.112606242000112, 41.32414540600003],
              [25.116533650000093, 41.3207347620001],
              [25.153847445000054, 41.307535008000045],
              [25.15787479700012, 41.306110332000046],
              [25.177098430000058, 41.29386301700002],
              [25.219679810000116, 41.24973134400001],
              [25.239110148000094, 41.24089467400002],
              [25.26226119000009, 41.238104147000044],
              [25.285722290000052, 41.23939605700009],
              [25.453463989000056, 41.28042714400006],
              [25.479095500000113, 41.28378611200007],
              [25.489482462000126, 41.283062643000065],
              [25.497337280000067, 41.28120229100007],
              [25.50508874500008, 41.28058217400009],
              [25.514907267000126, 41.283476054000076],
              [25.52369226100012, 41.291692607000115],
              [25.530203491000094, 41.302751364000116],
              [25.537954956000107, 41.312208150000075],
              [25.551494182000084, 41.31567047100013],
              [25.639757528000047, 41.31107126900007],
              [25.64957605000012, 41.308487447000076],
              [25.670453328000093, 41.299185689000055],
              [25.679961792000086, 41.297170309000094],
              [25.691227255000058, 41.29841054300003],
              [25.698048543000084, 41.30192454000009],
              [25.70517989100003, 41.30729888900005],
              [25.71747888200008, 41.31412017800001],
              [25.72874434400012, 41.3170657350001],
              [25.763470906000066, 41.31902944000005],
              [25.800781290000117, 41.338046366000114],
              [25.811013224000078, 41.34104360000002],
              [25.83333744300006, 41.33463572200007],
              [25.862689657000118, 41.3100894170001],
              [25.88201664200008, 41.30404327400008],
              [25.896279338000056, 41.30626536100006],
              [25.921187378000127, 41.31603220600003],
              [25.935140015000115, 41.315928854],
              [25.94857588700006, 41.31396515000007],
              [25.959634643000072, 41.31499867800004],
              [25.982268921000127, 41.323266907000075],
              [26.008933960000064, 41.33680613200006],
              [26.02185306800007, 41.34166371700009],
              [26.107325887000087, 41.356598206000044],
              [26.11466394100009, 41.355202942000076],
              [26.120865112000075, 41.35778676400007],
              [26.132440633000016, 41.371532695],
              [26.147840210000112, 41.3969058230001],
              [26.159002319000138, 41.421813863000054],
              [26.164273316000077, 41.42786000600002],
              [26.170577840000078, 41.429565328000066],
              [26.175642130000142, 41.4318907670001],
              [26.177399129000037, 41.4399522910001],
              [26.174298543000106, 41.44599843400003],
              [26.16044926000012, 41.45586863200002],
              [26.15621179200008, 41.46041615800006],
              [26.145876506000064, 41.47803782200005],
              [26.147633504000055, 41.48475575800008],
              [26.15931237800004, 41.49379913400013],
              [26.16292972800011, 41.50645986000008],
              [26.164480021000116, 41.51772532200003],
              [26.16313643400005, 41.52914581300003],
              [26.158072144000073, 41.542323303],
              [26.15249108900008, 41.54702585900007],
              [26.13678145300011, 41.54919626900006],
              [26.13120039800009, 41.55265859000012],
              [26.1294434000001, 41.559376527000055],
              [26.130993693000022, 41.57513783800003],
              [26.13027022300014, 41.58268259700007],
              [26.121071818000132, 41.608210755000115],
              [26.115284057000054, 41.61663401300011],
              [26.106705770000133, 41.62428212500008],
              [26.09523360200012, 41.628390401],
              [26.08117761200009, 41.630457459000056],
              [26.066914917000105, 41.63549591100012],
              [26.05948958500008, 41.64377677000006],
              [26.055029337000093, 41.648750916000026],
              [26.0502751060001, 41.66045562700002],
              [26.047484578000137, 41.674614970000064],
              [26.04810469500009, 41.689084371],
              [26.053685750000113, 41.70151255300006],
              [26.06050704000009, 41.70730031400005],
              [26.0672249750001, 41.70885060600007],
              [26.07404626500005, 41.70913482700003],
              [26.081487671000076, 41.711511943000076],
              [26.10835941500008, 41.727893372000025],
              [26.13512780800005, 41.73339691200003],
              [26.189904826000117, 41.73468882300007],
              [26.2118156330001, 41.750475973000064],
              [26.2261816810001, 41.74967498800005],
              [26.234449910000137, 41.74582509400001],
              [26.26101159700005, 41.72306162600002],
              [26.273930705000055, 41.714896749],
              [26.29491133600007, 41.71032338500005],
              [26.333358602000118, 41.713036397000096],
              [26.359610230000044, 41.714896749],
              [26.377386923000074, 41.71063344300005],
              [26.404362020000093, 41.691823222000025],
              [26.442809286000056, 41.68445933100013],
              [26.460379272000125, 41.67877492300009],
              [26.47619226000012, 41.675726013000045],
              [26.473195028000106, 41.661127421000074],
              [26.46441003400011, 41.648518372000055],
              [26.521150757000044, 41.61642730800004],
              [26.566522664000075, 41.598753967000036],
              [26.576444540000068, 41.59100250300004],
              [26.59546146600013, 41.612448222000054],
              [26.595254760000074, 41.604955139000126],
              [26.596288289000142, 41.5975395710001],
              [26.598562052000062, 41.590847473000096],
              [26.60228275500009, 41.58516306600005],
              [26.597838582000065, 41.57327748700003],
              [26.60166263900001, 41.54733591700007],
              [26.59546146600013, 41.53741404300008],
              [26.606106811000103, 41.523047994000066],
              [26.610964396000043, 41.50573638900006],
              [26.615925333000092, 41.468529358000055],
              [26.632151734000104, 41.41974680600002],
              [26.636389201000043, 41.399592998000045],
              [26.6365959070001, 41.378457337000086],
              [26.631738321000086, 41.3575283820001],
              [26.62264327000011, 41.34037180600005],
              [26.609724162000106, 41.33070831300002],
              [26.591120646000064, 41.32931305000004],
              [26.56962325000009, 41.333602194],
              [26.550606323000125, 41.34176707000002],
              [26.540167684000096, 41.351792298000035],
              [26.489318074000096, 41.31086456300004],
              [26.478776083000128, 41.30962432900007],
              [26.474435262000043, 41.3063687140001],
              [26.471954793000066, 41.30192454000009],
              [26.466373738000044, 41.297170309000094],
              [26.438468465000085, 41.283579407],
              [26.412113484000116, 41.265699361000046],
              [26.395060262000072, 41.258981425000016],
              [26.331704956000067, 41.254123841000094],
              [26.320542846000137, 41.24621734700007],
              [26.33604577600005, 41.228905742000066],
              [26.32550378500008, 41.20699493500008],
              [26.321059611000067, 41.18761627200003],
              [26.32416019700011, 41.1698912560001],
              [26.33604577600005, 41.15257965100001],
              [26.317338908000067, 41.130462138],
              [26.317338908000067, 41.12229726200009],
              [26.33232507300005, 41.11904164700009],
              [26.33945642100008, 41.11449412100008],
              [26.32240319800013, 41.088552552000024],
              [26.32509037300008, 41.074083151000096],
              [26.33904301000007, 41.051552226000055],
              [26.347621297000074, 41.04095855800007],
              [26.37418298300011, 41.03114003500012],
              [26.37500980700011, 41.01946116200004],
              [26.368085164000064, 41.00773061200006],
              [26.359610230000044, 41.00240793900009],
              [26.344624064000072, 41.00106435200006],
              [26.33594242300012, 40.997136943000086],
              [26.33315189600006, 40.99072906500005],
              [26.33604577600005, 40.98189239500003],
              [26.346484416000067, 40.97171213800006],
              [26.356199585000127, 40.96814646500009],
              [26.359093465000115, 40.96468414300007],
              [26.34906823700007, 40.95455556300003],
              [26.335012247000066, 40.94623565700006],
              [26.30648685700001, 40.93600372300007],
              [26.294394572000044, 40.92665028900002],
              [26.297288452000117, 40.922412821000066],
              [26.303282918000036, 40.91548818000008],
              [26.30400638900005, 40.90902862600005],
              [26.290673869000102, 40.906134745000045],
              [26.28219893400012, 40.907219951000044],
              [26.275170939000105, 40.91026886000007],
              [26.270003295000095, 40.91481638600003],
              [26.266489299000057, 40.920449118000036],
              [26.260391480000095, 40.920449118000036],
              [26.252226603000082, 40.90055369100004],
              [26.246335490000064, 40.89145863900008],
              [26.23920414200012, 40.885670878],
              [26.232382853000075, 40.885670878],
              [26.23114261900014, 40.88980499300003],
              [26.2261816810001, 40.899313457000105],
              [26.226285034000114, 40.88882314000004],
              [26.22525150500013, 40.88360382100002],
              [26.220910685000064, 40.88133005800002],
              [26.211918986000114, 40.87946970600011],
              [26.211195516000117, 40.874715475000116],
              [26.212539103000097, 40.87311350500009],
              [26.215122925000088, 40.87285512300009],
              [26.218636922000144, 40.871976623000066],
              [26.208715047000055, 40.86841095000001],
              [26.205821167000067, 40.865000305000066],
              [26.20509769700007, 40.85838572200008],
              [26.212022338000054, 40.84743031900011],
              [26.158278849000055, 40.81218699100002],
              [26.142982625000087, 40.79379018200002],
              [26.134507690000078, 40.76712514300009],
              [26.11228682500004, 40.746971334000094],
              [26.08159102400009, 40.73555084200011],
              [26.04395592500009, 40.73847077000005],
              [26.046885613000086, 40.74249909100007],
              [26.035980665000068, 40.75775788000004],
              [26.033539259000065, 40.77826569200005],
              [26.027354363000086, 40.796128648000035],
              [26.005869988000086, 40.803941148000035],
              [26.005869988000086, 40.81077708500004],
              [26.019704623000052, 40.810532945000034],
              [26.037852410000085, 40.812567450000074],
              [26.05372155000009, 40.81622955900008],
              [26.060557488000086, 40.820746161000045],
              [26.053965691000087, 40.830959377000056],
              [26.038910352000073, 40.83250560100004],
              [26.022634311000047, 40.82916901200008],
              [26.01221764400009, 40.82444896000004],
              [26.00831139400009, 40.83120351800005],
              [26.005869988000086, 40.838771877000056],
              [25.998383009000065, 40.838771877000056],
              [25.998383009000065, 40.831284898000035],
              [26.002777540000068, 40.82607656500005],
              [26.005869988000086, 40.81704336100006],
              [25.998383009000065, 40.81704336100006],
              [25.98292076900009, 40.83087799700007],
              [25.95167076900009, 40.84552643400008],
              [25.918630405000044, 40.85297272300005],
              [25.896657748000052, 40.844916083000044],
              [25.87989342500009, 40.84833405200004],
              [25.825694207000083, 40.849676825000074],
              [25.81421959700009, 40.855169989000046],
              [25.80323326900009, 40.85651276200008],
              [25.73218834700009, 40.85175202000005],
              [25.69117272200009, 40.85814036700003],
              [25.647146030000044, 40.870021877000056],
              [25.60450280000009, 40.876166083000044],
              [25.567149285000085, 40.86542389500005],
              [25.558848504000082, 40.86709219000005],
              [25.537771030000044, 40.870428778000075],
              [25.516856316000087, 40.87909577000005],
              [25.502207879000082, 40.88963450700004],
              [25.48682701900009, 40.89712148600006],
              [25.436778191000087, 40.90542226800005],
              [25.41968834700009, 40.90639883000006],
              [25.382985873000052, 40.91901276200008],
              [25.34083092500009, 40.94171784100007],
              [25.299652540000068, 40.95184967700004],
              [25.26612389400009, 40.92690664300005],
              [25.259287957000083, 40.92690664300005],
              [25.25879967500009, 40.93195221600007],
              [25.18067467500009, 40.942694403000075],
              [25.159678582000083, 40.95172760600008],
              [25.14698326900009, 40.958970445000034],
              [25.13803144600007, 40.96010976800005],
              [25.134043816000087, 40.962876695000034],
              [25.13575280000009, 40.97528717700004],
              [25.140147332000083, 40.983587958000044],
              [25.14820397200009, 40.99005768400008],
              [25.158457879000082, 40.99428945500006],
              [25.169932488000086, 40.995794989000046],
              [25.15137780000009, 41.00531647300005],
              [25.13843834700009, 41.01007721600007],
              [25.057302280000044, 41.009466864000046],
              [25.039073113000086, 41.00604889500005],
              [25.03956139400009, 40.989569403000075],
              [25.018809441000087, 40.97508372600004],
              [25.006521030000044, 40.96971263200004],
              [24.991709832000083, 40.968451239000046],
              [24.99903405000009, 40.94993724200003],
              [24.989756707000083, 40.94212474200003],
              [24.972178582000083, 40.940741278000075],
              [24.953868035000085, 40.94114817900004],
              [24.940684441000087, 40.937933661000045],
              [24.908050977000073, 40.923895575000074],
              [24.892100457000083, 40.92064036700003],
              [24.863536004000082, 40.90521881700005],
              [24.833994988000086, 40.87474192900004],
              [24.802012566000087, 40.85346100500004],
              [24.765798373000052, 40.86542389500005],
              [24.728363477000073, 40.852728583000044],
              [24.70875084700009, 40.85175202000005],
              [24.690114780000044, 40.858587958000044],
              [24.694834832000083, 40.86123281500005],
              [24.695323113000086, 40.86212799700007],
              [24.697520379000082, 40.86542389500005],
              [24.662771030000044, 40.87970612200007],
              [24.641368035000085, 40.864569403000075],
              [24.635427280000044, 40.858587958000044],
              [24.62867272200009, 40.858587958000044],
              [24.61963951900009, 40.874660549000055],
              [24.60906009200005, 40.88849518400008],
              [24.59620201900009, 40.90119049700007],
              [24.600759311000047, 40.91380442900004],
              [24.586273634000065, 40.91909414300005],
              [24.57553144600007, 40.92670319200005],
              [24.56885826900009, 40.93740469000005],
              [24.566661004000082, 40.95172760600008],
              [24.517751498000052, 40.95815664300005],
              [24.505137566000087, 40.96161530200004],
              [24.495616082000083, 40.95587799700007],
              [24.48406009200005, 40.95457591400009],
              [24.472911004000082, 40.95172760600008],
              [24.464121941000087, 40.94114817900004],
              [24.44312584700009, 40.94806549700007],
              [24.415537957000083, 40.94554271000004],
              [24.391774936000047, 40.93646881700005],
              [24.372243686000047, 40.914129950000074],
              [24.327647332000083, 40.88621653900009],
              [24.312673373000052, 40.87970612200007],
              [24.32471764400009, 40.87205638200004],
              [24.332367384000065, 40.86286041900007],
              [24.331309441000087, 40.85504791900007],
              [24.309825066000087, 40.85053131700005],
              [24.30600019600007, 40.84707265800006],
              [24.30567467500009, 40.84174225500004],
              [24.30958092500009, 40.83502838700008],
              [24.315277540000068, 40.83222077000005],
              [24.331879102000073, 40.833197333000044],
              [24.340668165000068, 40.831284898000035],
              [24.211192254000082, 40.77317942900004],
              [24.110118035000085, 40.727850653000075],
              [24.073090040000068, 40.72142161700009],
              [24.030039910000085, 40.72333405200004],
              [23.986338738000086, 40.73216380400004],
              [23.87403405000009, 40.77765534100007],
              [23.854340040000068, 40.78115469000005],
              [23.842051629000082, 40.78335195500006],
              [23.809255405000044, 40.78042226800005],
              [23.754079623000052, 40.763006903000075],
              [23.731700066000087, 40.75185781500005],
              [23.71070397200009, 40.737616278000075],
              [23.69703209700009, 40.72142161700009],
              [23.691742384000065, 40.695379950000074],
              [23.70020592500009, 40.67365143400008],
              [23.718028191000087, 40.65867747600004],
              [23.740977410000085, 40.65314362200007],
              [23.75562584700009, 40.64565664300005],
              [23.77247155000009, 40.62763092700004],
              [23.786631707000083, 40.60614655200004],
              [23.79265384200005, 40.587958075000074],
              [23.799001498000052, 40.58661530200004],
              [23.833506707000083, 40.563788153000075],
              [23.84669030000009, 40.56028880400004],
              [23.862478061000047, 40.55914948100008],
              [23.877614780000044, 40.560248114000046],
              [23.888845248000052, 40.563788153000075],
              [23.895274285000085, 40.55304596600007],
              [23.914886915000068, 40.53888580900008],
              [23.915537957000083, 40.52960846600007],
              [23.90723717500009, 40.525376695000034],
              [23.838226759000065, 40.518744208000044],
              [23.823008660000085, 40.50698476800005],
              [23.819021030000044, 40.48773834800005],
              [23.82667076900009, 40.461371161000045],
              [23.86817467500009, 40.41351959800005],
              [23.87794030000009, 40.40615469000005],
              [23.909678582000083, 40.394232489000046],
              [23.915537957000083, 40.38934967700004],
              [23.95362389400009, 40.38263580900008],
              [23.96387780000009, 40.37946198100008],
              [23.975352410000085, 40.38336823100008],
              [24.00245201900009, 40.386379299000055],
              [24.011729363000086, 40.39248281500005],
              [24.011566602000073, 40.40184153900009],
              [24.00554446700005, 40.41461823100008],
              [23.99122155000009, 40.43406810100004],
              [23.998708530000044, 40.44086334800005],
              [23.99122155000009, 40.447699286000045],
              [24.01140384200005, 40.44916413000004],
              [24.028819207000083, 40.432074286000045],
              [24.05323326900009, 40.39248281500005],
              [24.065196160000085, 40.38100820500006],
              [24.085785352000073, 40.36603424700007],
              [24.108897332000083, 40.357407945000034],
              [24.128428582000083, 40.36517975500004],
              [24.138926629000082, 40.360663153000075],
              [24.169200066000087, 40.352850653000075],
              [24.179860873000052, 40.35150788000004],
              [24.18685957100007, 40.34662506700005],
              [24.198008660000085, 40.32416413000004],
              [24.203949415000068, 40.31736888200004],
              [24.23340905000009, 40.31688060100004],
              [24.266286655000044, 40.289048570000034],
              [24.320648634000065, 40.22797272300005],
              [24.38331139400009, 40.17914459800005],
              [24.393809441000087, 40.15249258000006],
              [24.36109459700009, 40.13239166900007],
              [24.318614129000082, 40.124701239000046],
              [24.299978061000047, 40.12807851800005],
              [24.292246941000087, 40.142645575000074],
              [24.28614342500009, 40.16054922100005],
              [24.271739129000082, 40.17096588700008],
              [24.253916863000086, 40.17829010600008],
              [24.238291863000086, 40.18699778900009],
              [24.21192467500009, 40.21747467700004],
              [24.19271894600007, 40.24896881700005],
              [24.16895592500009, 40.27529531500005],
              [24.128428582000083, 40.29002513200004],
              [24.04786217500009, 40.30117422100005],
              [24.01921634200005, 40.31049225500004],
              [23.99382571700005, 40.323919989000046],
              [23.957367384000065, 40.35260651200008],
              [23.93653405000009, 40.36517975500004],
              [23.922618035000085, 40.36933014500005],
              [23.885020379000082, 40.36517975500004],
              [23.848317905000044, 40.372707424000055],
              [23.833506707000083, 40.37201569200005],
              [23.78223717500009, 40.35268789300005],
              [23.759613477000073, 40.34918854400007],
              [23.730479363000086, 40.35895416900007],
              [23.72754967500009, 40.35346100500004],
              [23.720713738000086, 40.34479401200008],
              [23.716807488000086, 40.34528229400007],
              [23.69971764400009, 40.32636139500005],
              [23.693614129000082, 40.30923086100006],
              [23.695648634000065, 40.29291413000004],
              [23.71143639400009, 40.26113515800006],
              [23.716319207000083, 40.25531647300005],
              [23.72364342500009, 40.24909088700008],
              [23.757660352000073, 40.231675523000035],
              [23.764333530000044, 40.21539948100008],
              [23.778575066000087, 40.20270416900007],
              [23.792816602000073, 40.19599030200004],
              [23.799489780000044, 40.19757721600007],
              [23.86768639400009, 40.172756252000056],
              [23.88021894600007, 40.17633698100008],
              [23.896739129000082, 40.17133209800005],
              [23.913340691000087, 40.161363023000035],
              [23.926036004000082, 40.14980703300006],
              [23.940684441000087, 40.14154694200005],
              [23.98023522200009, 40.13068268400008],
              [23.99122155000009, 40.11871979400007],
              [23.99000084700009, 40.11001211100006],
              [23.977386915000068, 40.100490627000056],
              [23.97754967500009, 40.09080638200004],
              [23.983246290000068, 40.08490631700005],
              [24.001149936000047, 40.07493724200009],
              [24.00489342500009, 40.06720612200007],
              [24.00171959700009, 40.05878327000005],
              [23.99463951900009, 40.05731842700004],
              [23.987559441000087, 40.05744049700007],
              [23.984222852000073, 40.053615627000056],
              [23.98682701900009, 40.042181708000044],
              [23.993418816000087, 40.037543036000045],
              [24.002207879000082, 40.03851959800005],
              [24.011729363000086, 40.04364655200004],
              [24.01148522200009, 40.03343333500004],
              [24.01221764400009, 40.026556708000044],
              [24.014414910000085, 40.02130768400008],
              [24.01921634200005, 40.01630280200004],
              [23.992523634000065, 39.99884674700007],
              [23.98804772200009, 39.98997630400004],
              [23.998708530000044, 39.98159414300005],
              [23.998708530000044, 39.97475820500006],
              [23.979340040000068, 39.974310614000046],
              [23.969899936000047, 39.968085028000075],
              [23.972829623000052, 39.96185944200005],
              [23.99122155000009, 39.96108633000006],
              [23.99122155000009, 39.95359935100004],
              [23.93995201900009, 39.952460028000075],
              [23.91968834700009, 39.956366278000075],
              [23.92286217500009, 39.96792226800005],
              [23.92286217500009, 39.97475820500006],
              [23.915537957000083, 39.97475820500006],
              [23.907725457000083, 39.96979401200008],
              [23.900645379000082, 39.97117747600004],
              [23.897634311000047, 39.97793203300006],
              [23.902517123000052, 39.98843008000006],
              [23.867035352000073, 40.00409577000005],
              [23.860850457000083, 40.00580475500004],
              [23.856211785000085, 40.01675039300005],
              [23.844899936000047, 40.02411530200004],
              [23.831228061000047, 40.02651601800005],
              [23.824066602000073, 40.021918036000045],
              [23.823090040000068, 40.017279364000046],
              [23.82667076900009, 40.00885651200008],
              [23.789886915000068, 40.055975653000075],
              [23.785166863000086, 40.06720612200007],
              [23.79151451900009, 40.08380768400008],
              [23.793304884000065, 40.093817450000074],
              [23.78882897200009, 40.09829336100006],
              [23.77833092500009, 40.101629950000074],
              [23.77247155000009, 40.10956452000005],
              [23.768728061000047, 40.118841864000046],
              [23.764496290000068, 40.126166083000044],
              [23.67546634200005, 40.21792226800005],
              [23.641774936000047, 40.23541901200008],
              [23.62273196700005, 40.23965078300006],
              [23.540293816000087, 40.24477773600006],
              [23.48414147200009, 40.269598700000074],
              [23.43848717500009, 40.27920156500005],
              [23.398285352000073, 40.27773672100005],
              [23.36500084700009, 40.261704820000034],
              [23.340098504000082, 40.22797272300005],
              [23.33765709700009, 40.20844147300005],
              [23.34538821700005, 40.19155508000006],
              [23.355479363000086, 40.175034898000035],
              [23.360606316000087, 40.15664297100005],
              [23.363617384000065, 40.150458075000074],
              [23.371348504000082, 40.14740631700005],
              [23.39161217500009, 40.14606354400007],
              [23.400645379000082, 40.14398834800005],
              [23.406504754000082, 40.13890208500004],
              [23.41578209700009, 40.126166083000044],
              [23.46924889400009, 40.06708405200004],
              [23.498871290000068, 40.042303778000075],
              [23.602712436000047, 39.998480536000045],
              [23.670258009000065, 39.98607005400004],
              [23.67286217500009, 39.97996653900009],
              [23.67286217500009, 39.97125885600008],
              [23.675954623000052, 39.96108633000006],
              [23.685394727000073, 39.94904205900008],
              [23.697276238000086, 39.94049713700008],
              [23.713063998000052, 39.93545156500005],
              [23.733897332000083, 39.93378327000005],
              [23.747894727000073, 39.93048737200007],
              [23.740244988000086, 39.92328522300005],
              [23.72169030000009, 39.91596100500004],
              [23.703135613000086, 39.91266510600008],
              [23.616465691000087, 39.92332591400009],
              [23.470957879000082, 39.97162506700005],
              [23.446543816000087, 39.97475820500006],
              [23.37208092500009, 39.96515534100007],
              [23.360606316000087, 39.96108633000006],
              [23.365977410000085, 39.97215403900009],
              [23.378754102000073, 39.991115627000056],
              [23.381602410000085, 40.00267161700009],
              [23.378428582000083, 40.010972398000035],
              [23.363942905000044, 40.026597398000035],
              [23.360606316000087, 40.03278229400007],
              [23.352712436000047, 40.057074286000045],
              [23.335134311000047, 40.07444896000004],
              [23.316579623000052, 40.08885325700004],
              [23.305918816000087, 40.10447825700004],
              [23.319590691000087, 40.136786200000074],
              [23.324554884000065, 40.17495351800005],
              [23.318614129000082, 40.21051666900007],
              [23.299082879000082, 40.23541901200008],
              [23.258636915000068, 40.253119208000044],
              [23.236664259000065, 40.25958893400008],
              [23.199554884000065, 40.26626211100006],
              [23.182383660000085, 40.274318752000056],
              [23.166188998000052, 40.27985260600008],
              [23.14893639400009, 40.27643463700008],
              [23.096934441000087, 40.30609772300005],
              [23.086761915000068, 40.307074286000045],
              [23.076182488000086, 40.314439195000034],
              [23.052744988000086, 40.31867096600007],
              [23.029144727000073, 40.32575104400007],
              [23.010915561000047, 40.351223049000055],
              [22.96387780000009, 40.37946198100008],
              [22.944834832000083, 40.38629791900007],
              [22.92750084700009, 40.38849518400008],
              [22.888194207000083, 40.38629791900007],
              [22.897715691000087, 40.402044989000046],
              [22.88965905000009, 40.41836172100005],
              [22.860199415000068, 40.447699286000045],
              [22.863291863000086, 40.448553778000075],
              [22.865977410000085, 40.448472398000035],
              [22.867442254000082, 40.44944896000004],
              [22.867198113000086, 40.45392487200007],
              [22.830902540000068, 40.48578522300005],
              [22.82162519600007, 40.50214264500005],
              [22.84351647200009, 40.50918203300006],
              [22.907399936000047, 40.51203034100007],
              [22.941579623000052, 40.51715729400007],
              [22.95639082100007, 40.526271877000056],
              [22.962901238000086, 40.535142320000034],
              [22.97510826900009, 40.54242584800005],
              [22.983164910000085, 40.55267975500004],
              [22.976898634000065, 40.57062409100007],
              [22.95248457100007, 40.58242422100005],
              [22.946136915000068, 40.58429596600007],
              [22.941742384000065, 40.58734772300005],
              [22.943614129000082, 40.594183661000045],
              [22.949554884000065, 40.60541413000004],
              [22.933767123000052, 40.630926825000074],
              [22.910492384000065, 40.644598700000074],
              [22.883067254000082, 40.64728424700007],
              [22.85401451900009, 40.63947174700007],
              [22.86109459700009, 40.62055084800005],
              [22.858653191000087, 40.60529205900008],
              [22.85059655000009, 40.593410549000055],
              [22.84034264400009, 40.58429596600007],
              [22.824473504000082, 40.57807038000004],
              [22.815114780000044, 40.57294342700004],
              [22.815928582000083, 40.57062409100007],
              [22.795664910000085, 40.57078685100004],
              [22.787119988000086, 40.57294342700004],
              [22.77833092500009, 40.57807038000004],
              [22.758555535000085, 40.56777578300006],
              [22.745941602000073, 40.55524323100008],
              [22.742523634000065, 40.540350653000075],
              [22.750336134000065, 40.522772528000075],
              [22.744151238000086, 40.522772528000075],
              [22.736664259000065, 40.52960846600007],
              [22.736664259000065, 40.515326239000046],
              [22.730479363000086, 40.515326239000046],
              [22.730479363000086, 40.522772528000075],
              [22.72315514400009, 40.522772528000075],
              [22.719004754000082, 40.510972398000035],
              [22.710948113000086, 40.51162344000005],
              [22.700368686000047, 40.51780833500004],
              [22.688975457000083, 40.522772528000075],
              [22.68848717500009, 40.52749258000006],
              [22.67351321700005, 40.52684153900009],
              [22.657725457000083, 40.51666901200008],
              [22.656260613000086, 40.50454336100006],
              [22.675303582000083, 40.496161200000074],
              [22.666026238000086, 40.495347398000035],
              [22.659678582000083, 40.49290599200009],
              [22.65601647200009, 40.487616278000075],
              [22.654958530000044, 40.47809479400007],
              [22.650726759000065, 40.47280508000006],
              [22.64161217500009, 40.474676825000074],
              [22.626800977000073, 40.48187897300005],
              [22.60287519600007, 40.48126862200007],
              [22.590505405000044, 40.477443752000056],
              [22.57911217500009, 40.46820709800005],
              [22.59343509200005, 40.458197333000044],
              [22.603770379000082, 40.44399648600006],
              [22.60873457100007, 40.428168036000045],
              [22.60645592500009, 40.41356028900009],
              [22.61850019600007, 40.40509674700007],
              [22.62826582100007, 40.39362213700008],
              [22.63998457100007, 40.383693752000056],
              [22.658376498000052, 40.37946198100008],
              [22.66114342500009, 40.36904531500005],
              [22.647634311000047, 40.34589264500005],
              [22.620616082000083, 40.31049225500004],
              [22.59034264400009, 40.24164459800005],
              [22.59083092500009, 40.230169989000046],
              [22.55250084700009, 40.16657135600008],
              [22.549652540000068, 40.143866278000075],
              [22.557302280000044, 40.12718333500004],
              [22.56771894600007, 40.11050039300005],
              [22.572927280000044, 40.08771393400008],
              [22.56885826900009, 40.06484609600005],
              [22.57129967500009, 40.05426666900007],
              [22.583181186000047, 40.04987213700008],
              [22.58765709700009, 40.044907945000034],
              [22.600271030000044, 40.01630280200004],
              [22.652517123000052, 39.982082424000055],
              [22.661631707000083, 39.978216864000046],
              [22.667165561000047, 39.97435130400004],
              [22.690928582000083, 39.96816640800006],
              [22.696462436000047, 39.964544989000046],
              [22.69857832100007, 39.96088288000004],
              [22.707855665000068, 39.961371161000045],
              [22.710134311000047, 39.95734284100007],
              [22.708994988000086, 39.93903229400007],
              [22.709808790000068, 39.93504466400009],
              [22.710134311000047, 39.93378327000005],
              [22.722992384000065, 39.897772528000075],
              [22.730479363000086, 39.88540273600006],
              [22.740896030000044, 39.874701239000046],
              [22.77865644600007, 39.84983958500004],
              [22.801117384000065, 39.84031810100004],
              [22.815277540000068, 39.82904694200005],
              [22.84034264400009, 39.80341217700004],
              [22.850271030000044, 39.79051341400009],
              [22.858653191000087, 39.77326080900008],
              [22.864756707000083, 39.753159898000035],
              [22.867198113000086, 39.731756903000075],
              [22.871755405000044, 39.71580638200004],
              [22.901866082000083, 39.65884023600006],
              [22.92514082100007, 39.59951406500005],
              [22.939463738000086, 39.58063385600008],
              [22.95289147200009, 39.570013739000046],
              [23.00489342500009, 39.543402411000045],
              [23.055918816000087, 39.52724844000005],
              [23.094493035000085, 39.50409577000005],
              [23.09742272200009, 39.50177643400008],
              [23.101817254000082, 39.497381903000075],
              [23.114105665000068, 39.46698639500005],
              [23.125661655000044, 39.454413153000075],
              [23.210948113000086, 39.379339911000045],
              [23.223806186000047, 39.358587958000044],
              [23.271332227000073, 39.32294342700004],
              [23.292246941000087, 39.26898834800005],
              [23.34229576900009, 39.192613023000035],
              [23.343760613000086, 39.17963288000004],
              [23.333262566000087, 39.17438385600008],
              [23.30128014400009, 39.15135325700004],
              [23.28174889400009, 39.146144924000055],
              [23.243662957000083, 39.14166901200008],
              [23.224619988000086, 39.13711172100005],
              [23.209727410000085, 39.13182200700004],
              [23.215098504000082, 39.12946198100008],
              [23.21924889400009, 39.12710195500006],
              [23.223480665000068, 39.12518952000005],
              [23.23023522200009, 39.12441640800006],
              [23.23023522200009, 39.11815013200004],
              [23.221527540000068, 39.11603424700007],
              [23.21420332100007, 39.112616278000075],
              [23.208262566000087, 39.108710028000075],
              [23.20362389400009, 39.10455963700008],
              [23.191416863000086, 39.10781484600005],
              [23.169200066000087, 39.10659414300005],
              [23.14625084700009, 39.10175202000005],
              [23.131602410000085, 39.09430573100008],
              [23.115489129000082, 39.08828359600005],
              [23.092133009000065, 39.08934153900009],
              [23.052012566000087, 39.097723700000074],
              [23.061371290000068, 39.111761786000045],
              [23.073090040000068, 39.12441640800006],
              [23.06771894600007, 39.138006903000075],
              [23.08106530000009, 39.14720286700009],
              [23.114105665000068, 39.15912506700005],
              [23.113942905000044, 39.14630768400008],
              [23.10059655000009, 39.10455963700008],
              [23.171722852000073, 39.13495514500005],
              [23.182383660000085, 39.146144924000055],
              [23.17554772200009, 39.155462958000044],
              [23.18132571700005, 39.15867747600004],
              [23.190928582000083, 39.15810781500005],
              [23.196055535000085, 39.15574778900009],
              [23.199229363000086, 39.15143463700008],
              [23.206309441000087, 39.15704987200007],
              [23.213552280000044, 39.16811758000006],
              [23.217133009000065, 39.17963288000004],
              [23.21225019600007, 39.19049713700008],
              [23.186371290000068, 39.22443268400008],
              [23.17554772200009, 39.23427969000005],
              [23.179860873000052, 39.25079987200007],
              [23.169118686000047, 39.26854075700004],
              [23.15137780000009, 39.284857489000046],
              [23.134613477000073, 39.296942450000074],
              [23.115489129000082, 39.30744049700007],
              [23.09815514400009, 39.312201239000046],
              [23.02051842500009, 39.31753164300005],
              [23.019786004000082, 39.32099030200004],
              [23.021006707000083, 39.32558828300006],
              [23.01856530000009, 39.33047109600005],
              [23.013682488000086, 39.336371161000045],
              [23.003428582000083, 39.352443752000056],
              [22.998057488000086, 39.357123114000046],
              [22.99073326900009, 39.35809967700004],
              [22.96387780000009, 39.357123114000046],
              [22.94117272200009, 39.361761786000045],
              [22.935883009000065, 39.360581773000035],
              [22.942881707000083, 39.35097890800006],
              [22.942881707000083, 39.34414297100005],
              [22.932790561000047, 39.336004950000074],
              [22.92904707100007, 39.324204820000034],
              [22.93213951900009, 39.312201239000046],
              [22.942881707000083, 39.303168036000045],
              [22.91928144600007, 39.29865143400008],
              [22.87989342500009, 39.29555898600006],
              [22.842539910000085, 39.28847890800006],
              [22.826182488000086, 39.27216217700004],
              [22.824229363000086, 39.23346588700008],
              [22.826182488000086, 39.22125885600008],
              [22.85401451900009, 39.15912506700005],
              [22.860199415000068, 39.15912506700005],
              [22.868011915000068, 39.16974518400008],
              [22.880869988000086, 39.17963288000004],
              [22.876963738000086, 39.19037506700005],
              [22.882090691000087, 39.19098541900007],
              [22.890147332000083, 39.18427155200004],
              [22.89503014400009, 39.17279694200005],
              [22.901866082000083, 39.17963288000004],
              [22.910899285000085, 39.163316148000035],
              [22.91456139400009, 39.143784898000035],
              [22.920583530000044, 39.12514883000006],
              [22.93604576900009, 39.111395575000074],
              [22.935883009000065, 39.116115627000056],
              [22.93718509200005, 39.117254950000074],
              [22.939463738000086, 39.11713288000004],
              [22.942881707000083, 39.11815013200004],
              [22.938731316000087, 39.12494538000004],
              [22.93604576900009, 39.13182200700004],
              [22.961110873000052, 39.11904531500005],
              [22.973317905000044, 39.10195547100005],
              [22.982432488000086, 39.084418036000045],
              [22.998057488000086, 39.06976959800005],
              [22.99195397200009, 39.05731842700004],
              [22.993418816000087, 39.05463288000004],
              [22.998057488000086, 39.049261786000045],
              [22.96648196700005, 39.03465403900009],
              [22.958832227000073, 39.02513255400004],
              [22.96387780000009, 39.008978583000044],
              [23.01531009200005, 39.033189195000034],
              [23.042491082000083, 39.04010651200008],
              [23.073090040000068, 39.04246653900009],
              [23.073090040000068, 39.03628164300005],
              [23.064707879000082, 39.02875397300005],
              [23.03223717500009, 39.01512278900009],
              [23.023285352000073, 39.00844961100006],
              [23.019053582000083, 39.001288153000075],
              [23.011729363000086, 38.98102448100008],
              [23.00717207100007, 38.973944403000075],
              [23.000254754000082, 38.966457424000055],
              [22.99667402400007, 38.963405666000085],
              [22.992198113000086, 38.95962148600006],
              [22.984548373000052, 38.954331773000035],
              [22.978688998000052, 38.95327383000006],
              [22.964121941000087, 38.95526764500005],
              [22.95639082100007, 38.954331773000035],
              [22.94971764400009, 38.94961172100005],
              [22.94434655000009, 38.947333075000074],
              [22.93604576900009, 38.94684479400007],
              [22.940603061000047, 38.93646881700005],
              [22.942881707000083, 38.93260325700004],
              [22.928558790000068, 38.93158600500004],
              [22.908457879000082, 38.921942450000074],
              [22.898448113000086, 38.919623114000046],
              [22.88640384200005, 38.92169830900008],
              [22.873301629000082, 38.92593008000006],
              [22.85987389400009, 38.92853424700007],
              [22.846527540000068, 38.92641836100006],
              [22.841807488000086, 38.919175523000035],
              [22.836680535000085, 38.896470445000034],
              [22.829600457000083, 38.89166901200008],
              [22.804698113000086, 38.89101797100005],
              [22.79656009200005, 38.88711172100005],
              [22.79200280000009, 38.87799713700008],
              [22.777679884000065, 38.87848541900007],
              [22.754567905000044, 38.87396881700005],
              [22.732676629000082, 38.872381903000075],
              [22.72315514400009, 38.881740627000056],
              [22.718272332000083, 38.88979726800005],
              [22.707774285000085, 38.88739655200004],
              [22.688975457000083, 38.87799713700008],
              [22.680430535000085, 38.880519924000055],
              [22.663584832000083, 38.88959381700005],
              [22.658376498000052, 38.89166901200008],
              [22.656423373000052, 38.89435455900008],
              [22.62159264400009, 38.914496161000045],
              [22.613291863000086, 38.91307200700004],
              [22.594981316000087, 38.90281810100004],
              [22.58887780000009, 38.89801666900007],
              [22.580821160000085, 38.89362213700008],
              [22.569834832000083, 38.89166901200008],
              [22.55990644600007, 38.89109935100004],
              [22.55209394600007, 38.88922760600008],
              [22.545258009000065, 38.88507721600007],
              [22.53882897200009, 38.87799713700008],
              [22.53492272200009, 38.88068268400008],
              [22.52507571700005, 38.88544342700004],
              [22.52507571700005, 38.85814036700009],
              [22.572927280000044, 38.86432526200008],
              [22.572927280000044, 38.85814036700009],
              [22.553884311000047, 38.848089911000045],
              [22.563324415000068, 38.83624909100007],
              [22.582774285000085, 38.83197663000004],
              [22.59343509200005, 38.84446849200009],
              [22.600271030000044, 38.84446849200009],
              [22.59343509200005, 38.83022695500006],
              [22.608164910000085, 38.83075592700004],
              [22.621429884000065, 38.83388906500005],
              [22.632660352000073, 38.835150458000044],
              [22.64112389400009, 38.83022695500006],
              [22.690277540000068, 38.85000234600005],
              [22.702647332000083, 38.85065338700008],
              [22.726817254000082, 38.819647528000075],
              [22.748057488000086, 38.79922109600005],
              [22.758962436000047, 38.79409414300005],
              [22.769541863000086, 38.784816799000055],
              [22.77833092500009, 38.78172435100004],
              [22.786387566000087, 38.782416083000044],
              [22.805837436000047, 38.78790924700007],
              [22.815928582000083, 38.78925202000005],
              [22.829274936000047, 38.78607819200005],
              [22.845550977000073, 38.77802155200004],
              [22.85987389400009, 38.76703522300005],
              [22.867198113000086, 38.755072333000044],
              [22.887543165000068, 38.771144924000055],
              [22.89820397200009, 38.77529531500005],
              [22.914886915000068, 38.77558014500005],
              [22.925629102000073, 38.77171458500004],
              [22.945323113000086, 38.75812409100007],
              [22.960215691000087, 38.755072333000044],
              [23.016286655000044, 38.75446198100008],
              [23.04200280000009, 38.74673086100006],
              [23.059418165000068, 38.727728583000044],
              [23.090505405000044, 38.64911530200004],
              [23.10450280000009, 38.63841380400004],
              [23.12354576900009, 38.63690827000005],
              [23.13331139400009, 38.63971588700008],
              [23.145192905000044, 38.64899323100008],
              [23.156423373000052, 38.65346914300005],
              [23.16895592500009, 38.65228913000004],
              [23.182465040000068, 38.65375397300005],
              [23.196055535000085, 38.66632721600007],
              [23.17676842500009, 38.67658112200007],
              [23.168142123000052, 38.679388739000046],
              [23.186778191000087, 38.685980536000045],
              [23.204925977000073, 38.68268463700008],
              [23.23764082100007, 38.66632721600007],
              [23.253754102000073, 38.661810614000046],
              [23.286957227000073, 38.65814850500004],
              [23.305918816000087, 38.65265534100007],
              [23.320974155000044, 38.64325592700004],
              [23.331228061000047, 38.63027578300006],
              [23.33570397200009, 38.616400458000044],
              [23.333262566000087, 38.60423411700009],
              [23.321136915000068, 38.59442780200004],
              [23.306488477000073, 38.58885325700004],
              [23.293304884000065, 38.57908763200004],
              [23.285411004000082, 38.55646393400008],
              [23.29542076900009, 38.56810130400004],
              [23.307383660000085, 38.56854889500005],
              [23.319590691000087, 38.56199778900009],
              [23.32984459700009, 38.552720445000034],
              [23.340586785000085, 38.54555898600006],
              [23.367442254000082, 38.54047272300005],
              [23.381602410000085, 38.53534577000005],
              [23.381602410000085, 38.528550523000035],
              [23.37281334700009, 38.52594635600008],
              [23.349864129000082, 38.52558014500005],
              [23.340098504000082, 38.522365627000056],
              [23.33179772200009, 38.514878648000035],
              [23.329274936000047, 38.50836823100008],
              [23.33497155000009, 38.503607489000046],
              [23.35059655000009, 38.50185781500005],
              [23.41846764400009, 38.504339911000045],
              [23.519379102000073, 38.490668036000045],
              [23.531911655000044, 38.498114325000074],
              [23.542979363000086, 38.511704820000034],
              [23.567230665000068, 38.50112539300005],
              [23.60132897200009, 38.473944403000075],
              [23.580821160000085, 38.46356842700004],
              [23.573496941000087, 38.46088288000004],
              [23.573496941000087, 38.45343659100007],
              [23.585948113000086, 38.451157945000034],
              [23.59620201900009, 38.44676341400009],
              [23.60010826900009, 38.440619208000044],
              [23.594004754000082, 38.432928778000075],
              [23.594004754000082, 38.42609284100007],
              [23.625010613000086, 38.41400788000004],
              [23.67286217500009, 38.35643138200004],
              [23.70997155000009, 38.33673737200007],
              [23.724864129000082, 38.33612702000005],
              [23.781993035000085, 38.34357330900008],
              [23.805023634000065, 38.33250560100004],
              [23.81617272200009, 38.330511786000045],
              [23.912445509000065, 38.29824453300006],
              [23.932871941000087, 38.295803127000056],
              [23.951019727000073, 38.29092031500005],
              [23.966970248000052, 38.279282945000034],
              [23.99122155000009, 38.25421784100007],
              [24.038584832000083, 38.223944403000075],
              [24.046397332000083, 38.21694570500006],
              [24.050629102000073, 38.21067942900004],
              [24.069021030000044, 38.204738674000055],
              [24.073090040000068, 38.196478583000044],
              [24.070974155000044, 38.18842194200005],
              [24.06804446700005, 38.180894273000035],
              [24.069509311000047, 38.173529364000046],
              [24.08057701900009, 38.166001695000034],
              [24.06999759200005, 38.16278717700004],
              [24.06413821700005, 38.15509674700007],
              [24.06104576900009, 38.144191799000055],
              [24.059418165000068, 38.131293036000045],
              [24.05323326900009, 38.14524974200009],
              [24.037771030000044, 38.143744208000044],
              [23.989024285000085, 38.12262604400007],
              [23.99000084700009, 38.10211823100008],
              [24.00489342500009, 38.05927155200004],
              [24.00912519600007, 38.04059479400007],
              [24.01856530000009, 38.026678778000075],
              [24.028168165000068, 38.01618073100008],
              [24.032725457000083, 38.00775788000004],
              [24.030039910000085, 37.99843984600005],
              [24.01661217500009, 37.97695547100005],
              [24.011729363000086, 37.966864325000074],
              [24.011892123000052, 37.958319403000075],
              [24.014496290000068, 37.948472398000035],
              [24.015879754000082, 37.93744538000004],
              [24.011729363000086, 37.92523834800005],
              [24.02279707100007, 37.92572663000004],
              [24.034434441000087, 37.92291901200008],
              [24.043304884000065, 37.916449286000045],
              [24.046397332000083, 37.90599192900004],
              [24.042246941000087, 37.90070221600007],
              [24.011729363000086, 37.89175039300005],
              [24.01889082100007, 37.88515859600005],
              [24.02784264400009, 37.88031647300005],
              [24.038910352000073, 37.87787506700005],
              [24.05323326900009, 37.87807851800005],
              [24.046397332000083, 37.87059153900009],
              [24.051931186000047, 37.86969635600008],
              [24.06690514400009, 37.86440664300005],
              [24.060801629000082, 37.85561758000006],
              [24.059336785000085, 37.848537502000056],
              [24.061778191000087, 37.84251536700009],
              [24.06690514400009, 37.837103583000044],
              [24.061778191000087, 37.83470286700009],
              [24.05762780000009, 37.83218008000006],
              [24.054942254000082, 37.82851797100005],
              [24.05323326900009, 37.82282135600008],
              [24.076996290000068, 37.81110260600008],
              [24.084646030000044, 37.80174388200004],
              [24.087412957000083, 37.785223700000074],
              [24.086192254000082, 37.763739325000074],
              [24.081879102000073, 37.75250885600008],
              [24.059418165000068, 37.73346588700008],
              [24.073090040000068, 37.72724030200004],
              [24.073090040000068, 37.71979401200008],
              [24.059418165000068, 37.71979401200008],
              [24.059418165000068, 37.71356842700004],
              [24.06576582100007, 37.71279531500005],
              [24.066742384000065, 37.70970286700009],
              [24.06576582100007, 37.70502350500004],
              [24.06690514400009, 37.699286200000074],
              [24.065684441000087, 37.70189036700009],
              [24.065277540000068, 37.70482005400004],
              [24.063975457000083, 37.70502350500004],
              [24.059418165000068, 37.699286200000074],
              [24.072113477000073, 37.689520575000074],
              [24.063731316000087, 37.67845286700009],
              [24.046397332000083, 37.66583893400008],
              [24.032725457000083, 37.65151601800005],
              [24.021332227000073, 37.65778229400007],
              [23.983083530000044, 37.67031484600005],
              [23.96729576900009, 37.67259349200009],
              [23.94971764400009, 37.677435614000046],
              [23.94304446700005, 37.68992747600004],
              [23.943369988000086, 37.72724030200004],
              [23.93653405000009, 37.72724030200004],
              [23.922699415000068, 37.72117747600004],
              [23.913340691000087, 37.73969147300005],
              [23.902517123000052, 37.78188711100006],
              [23.898692254000082, 37.779282945000034],
              [23.888845248000052, 37.77440013200004],
              [23.881602410000085, 37.791083075000074],
              [23.865570509000065, 37.80768463700008],
              [23.847504102000073, 37.81810130400004],
              [23.833506707000083, 37.81598541900007],
              [23.82911217500009, 37.81940338700008],
              [23.825368686000047, 37.82135651200008],
              [23.822113477000073, 37.82416413000004],
              [23.819183790000068, 37.82965729400007],
              [23.81299889400009, 37.82965729400007],
              [23.807302280000044, 37.808579820000034],
              [23.797211134000065, 37.80849844000005],
              [23.786631707000083, 37.812160549000055],
              [23.77898196700005, 37.80231354400007],
              [23.777354363000086, 37.80906810100004],
              [23.776621941000087, 37.81427643400008],
              [23.773610873000052, 37.81688060100004],
              [23.764496290000068, 37.81598541900007],
              [23.77084394600007, 37.82831452000005],
              [23.766449415000068, 37.83893463700008],
              [23.744802280000044, 37.85761139500005],
              [23.742198113000086, 37.876654364000046],
              [23.70053144600007, 37.92519765800006],
              [23.69703209700009, 37.939520575000074],
              [23.68018639400009, 37.94586823100008],
              [23.663340691000087, 37.94293854400007],
              [23.646006707000083, 37.93667226800005],
              [23.628103061000047, 37.93268463700008],
              [23.627696160000085, 37.93764883000006],
              [23.628103061000047, 37.939520575000074],
              [23.63770592500009, 37.94293854400007],
              [23.640798373000052, 37.94578685100004],
              [23.641774936000047, 37.95254140800006],
              [23.62663821700005, 37.94749583500004],
              [23.618011915000068, 37.95327383000006],
              [23.61036217500009, 37.962144273000035],
              [23.597666863000086, 37.966864325000074],
              [23.58334394600007, 37.96710846600007],
              [23.571055535000085, 37.96869538000004],
              [23.560801629000082, 37.97280508000006],
              [23.552989129000082, 37.980454820000034],
              [23.58887780000009, 38.00633372600004],
              [23.597911004000082, 38.021144924000055],
              [23.590586785000085, 38.03880442900004],
              [23.581309441000087, 38.04629140800006],
              [23.574554884000065, 38.04677969000005],
              [23.568207227000073, 38.044256903000075],
              [23.559825066000087, 38.04254791900007],
              [23.521820509000065, 38.04254791900007],
              [23.51148522200009, 38.04043203300006],
              [23.50489342500009, 38.03571198100008],
              [23.499847852000073, 38.03099192900004],
              [23.49463951900009, 38.02887604400007],
              [23.470876498000052, 38.027777411000045],
              [23.460459832000083, 38.025458075000074],
              [23.449961785000085, 38.02142975500004],
              [23.41187584700009, 37.99437083500004],
              [23.395274285000085, 37.987941799000055],
              [23.42945397200009, 37.980454820000034],
              [23.408946160000085, 37.974310614000046],
              [23.32984459700009, 37.980454820000034],
              [23.226817254000082, 37.97361888200004],
              [23.18921959700009, 37.95880768400008],
              [23.159434441000087, 37.94053782800006],
              [23.14234459700009, 37.93008047100005],
              [23.094086134000065, 37.911037502000056],
              [23.052012566000087, 37.92523834800005],
              [23.04273522200009, 37.921942450000074],
              [23.03484134200005, 37.922308661000045],
              [23.026133660000085, 37.92413971600007],
              [23.015147332000083, 37.92523834800005],
              [23.01148522200009, 37.919989325000074],
              [23.011729363000086, 37.90851471600007],
              [23.01026451900009, 37.89695872600004],
              [23.001475457000083, 37.89175039300005],
              [22.99512780000009, 37.882147528000075],
              [22.999522332000083, 37.86269765800006],
              [23.012543165000068, 37.84756094000005],
              [23.03223717500009, 37.850775458000044],
              [23.049652540000068, 37.84357330900008],
              [23.073496941000087, 37.841131903000075],
              [23.097178582000083, 37.84357330900008],
              [23.114105665000068, 37.850775458000044],
              [23.14625084700009, 37.825832424000055],
              [23.16382897200009, 37.81525299700007],
              [23.182383660000085, 37.80914948100008],
              [23.177989129000082, 37.79930247600004],
              [23.176442905000044, 37.78998444200005],
              [23.177989129000082, 37.78156159100007],
              [23.182383660000085, 37.77440013200004],
              [23.168711785000085, 37.772365627000056],
              [23.150401238000086, 37.763373114000046],
              [23.128184441000087, 37.76048411700009],
              [23.125010613000086, 37.75726959800005],
              [23.12403405000009, 37.75096263200004],
              [23.120941602000073, 37.74091217700004],
              [23.14584394600007, 37.725816148000035],
              [23.159353061000047, 37.720770575000074],
              [23.17554772200009, 37.71979401200008],
              [23.166270379000082, 37.69700755400004],
              [23.16382897200009, 37.68158600500004],
              [23.167246941000087, 37.666449286000045],
              [23.17554772200009, 37.64468008000006],
              [23.16187584700009, 37.64468008000006],
              [23.16456139400009, 37.623032945000034],
              [23.168630405000044, 37.614162502000056],
              [23.190114780000044, 37.60732656500005],
              [23.23023522200009, 37.58258698100008],
              [23.23764082100007, 37.59003327000005],
              [23.274668816000087, 37.56122467700004],
              [23.27906334700009, 37.55996328300006],
              [23.28419030000009, 37.55923086100006],
              [23.292246941000087, 37.555894273000035],
              [23.312347852000073, 37.54254791900007],
              [23.323008660000085, 37.53742096600007],
              [23.336680535000085, 37.53546784100007],
              [23.36036217500009, 37.54767487200007],
              [23.35914147200009, 37.574286200000074],
              [23.340586785000085, 37.60028717700004],
              [23.31218509200005, 37.610541083000044],
              [23.31218509200005, 37.61737702000005],
              [23.32911217500009, 37.628241278000075],
              [23.347829623000052, 37.634426174000055],
              [23.398692254000082, 37.637884833000044],
              [23.409027540000068, 37.62592194200005],
              [23.404307488000086, 37.599269924000055],
              [23.390798373000052, 37.57135651200008],
              [23.374278191000087, 37.555894273000035],
              [23.384287957000083, 37.54743073100008],
              [23.39503014400009, 37.54140859600005],
              [23.407399936000047, 37.53750234600005],
              [23.422048373000052, 37.53546784100007],
              [23.422048373000052, 37.52802155200004],
              [23.402679884000065, 37.52252838700008],
              [23.395274285000085, 37.52179596600007],
              [23.395274285000085, 37.514960028000075],
              [23.40211022200009, 37.514960028000075],
              [23.41065514400009, 37.51190827000005],
              [23.436289910000085, 37.50812409100007],
              [23.458832227000073, 37.496161200000074],
              [23.479177280000044, 37.490668036000045],
              [23.525645379000082, 37.45970286700009],
              [23.52051842500009, 37.455064195000034],
              [23.51889082100007, 37.45302969000005],
              [23.520681186000047, 37.450873114000046],
              [23.525645379000082, 37.44603099200009],
              [23.525645379000082, 37.43919505400004],
              [23.505381707000083, 37.43048737200007],
              [23.446543816000087, 37.41461823100008],
              [23.44182376400005, 37.41441478100006],
              [23.32325280000009, 37.40973541900007],
              [23.305918816000087, 37.41193268400008],
              [23.307383660000085, 37.40839264500005],
              [23.308116082000083, 37.40525950700004],
              [23.309418165000068, 37.402044989000046],
              [23.31218509200005, 37.39826080900008],
              [23.276052280000044, 37.40224844000005],
              [23.26270592500009, 37.40102773600006],
              [23.264414910000085, 37.39081452000005],
              [23.23023522200009, 37.38458893400008],
              [23.229991082000083, 37.37494538000004],
              [23.237071160000085, 37.370306708000044],
              [23.24740644600007, 37.36945221600007],
              [23.25757897200009, 37.37091705900008],
              [23.25131269600007, 37.36351146000004],
              [23.25131269600007, 37.35732656500005],
              [23.258962436000047, 37.35639069200005],
              [23.278005405000044, 37.34983958500004],
              [23.262380405000044, 37.34398021000004],
              [23.243988477000073, 37.34243398600006],
              [23.20671634200005, 37.34369538000004],
              [23.18604576900009, 37.34064362200007],
              [23.185394727000073, 37.33218008000006],
              [23.194509311000047, 37.319240627000056],
              [23.20362389400009, 37.30267975500004],
              [23.182871941000087, 37.299261786000045],
              [23.168630405000044, 37.29950592700004],
              [23.156260613000086, 37.30312734600005],
              [23.141449415000068, 37.30951569200005],
              [23.141449415000068, 37.31635163000004],
              [23.16187584700009, 37.31635163000004],
              [23.16187584700009, 37.323146877000056],
              [23.15015709700009, 37.32575104400007],
              [23.136241082000083, 37.32371653900009],
              [23.123383009000065, 37.32477448100008],
              [23.114105665000068, 37.33616771000004],
              [23.134613477000073, 37.329331773000035],
              [23.129730665000068, 37.338771877000056],
              [23.12240644600007, 37.345689195000034],
              [23.10059655000009, 37.35732656500005],
              [23.09278405000009, 37.350775458000044],
              [23.082774285000085, 37.35053131700005],
              [23.073090040000068, 37.35521067900004],
              [23.073090040000068, 37.35732656500005],
              [23.07007897200009, 37.38890208500004],
              [23.072601759000065, 37.40110911700009],
              [23.08375084700009, 37.394517320000034],
              [23.094981316000087, 37.389553127000056],
              [23.10523522200009, 37.396918036000045],
              [23.112559441000087, 37.41087474200009],
              [23.114105665000068, 37.42560455900008],
              [23.135996941000087, 37.41547272300005],
              [23.141449415000068, 37.41193268400008],
              [23.141449415000068, 37.41815827000005],
              [23.136566602000073, 37.42731354400007],
              [23.135101759000065, 37.43349844000005],
              [23.134613477000073, 37.442613023000035],
              [23.132009311000047, 37.44863515800006],
              [23.12549889400009, 37.45111725500004],
              [23.117930535000085, 37.452826239000046],
              [23.111338738000086, 37.45661041900007],
              [23.097178582000083, 37.462225653000075],
              [23.062022332000083, 37.45498281500005],
              [23.04590905000009, 37.45970286700009],
              [23.059418165000068, 37.46653880400004],
              [23.04590905000009, 37.48700592700004],
              [23.021006707000083, 37.47528717700004],
              [23.011241082000083, 37.46906159100007],
              [23.00489342500009, 37.45970286700009],
              [22.990896030000044, 37.495754299000055],
              [22.980723504000082, 37.50877513200004],
              [22.96387780000009, 37.52179596600007],
              [22.959239129000082, 37.522772528000075],
              [22.947601759000065, 37.52130768400008],
              [22.942881707000083, 37.52179596600007],
              [22.93913821700005, 37.52496979400007],
              [22.937347852000073, 37.52944570500006],
              [22.936696811000047, 37.53351471600007],
              [22.93604576900009, 37.53546784100007],
              [22.92156009200005, 37.540350653000075],
              [22.912852410000085, 37.54181549700007],
              [22.901866082000083, 37.54165273600006],
              [22.914317254000082, 37.53880442900004],
              [22.91846764400009, 37.535589911000045],
              [22.92237389400009, 37.52802155200004],
              [22.902354363000086, 37.534857489000046],
              [22.885020379000082, 37.53314850500004],
              [22.869395379000082, 37.52562083500004],
              [22.85401451900009, 37.514960028000075],
              [22.847178582000083, 37.52098216400009],
              [22.81934655000009, 37.53546784100007],
              [22.821543816000087, 37.539129950000074],
              [22.826182488000086, 37.54905833500004],
              [22.81348717500009, 37.55341217700004],
              [22.802012566000087, 37.56085846600007],
              [22.79590905000009, 37.56915924700007],
              [22.798838738000086, 37.57640208500004],
              [22.788340691000087, 37.588771877000056],
              [22.77833092500009, 37.596869208000044],
              [22.756521030000044, 37.58966705900008],
              [22.738454623000052, 37.58087799700007],
              [22.726410352000073, 37.56635163000004],
              [22.72315514400009, 37.54165273600006],
              [22.725352410000085, 37.53656647300005],
              [22.734629754000082, 37.52456289300005],
              [22.736664259000065, 37.51837799700007],
              [22.735524936000047, 37.51190827000005],
              [22.730723504000082, 37.50023021000004],
              [22.730479363000086, 37.49445221600007],
              [22.734711134000065, 37.48334381700005],
              [22.73991946700005, 37.47748444200005],
              [22.745371941000087, 37.47313060100004],
              [22.750336134000065, 37.46653880400004],
              [22.751475457000083, 37.46161530200004],
              [22.750336134000065, 37.442613023000035],
              [22.752696160000085, 37.43968333500004],
              [22.764821811000047, 37.43178945500006],
              [22.76417076900009, 37.421535549000055],
              [22.757334832000083, 37.408270575000074],
              [22.757985873000052, 37.39826080900008],
              [22.810394727000073, 37.34837474200009],
              [22.81934655000009, 37.34369538000004],
              [22.812510613000086, 37.329331773000035],
              [22.826182488000086, 37.329331773000035],
              [22.826182488000086, 37.323146877000056],
              [22.81934655000009, 37.323146877000056],
              [22.81934655000009, 37.31635163000004],
              [22.82984459700009, 37.308294989000046],
              [22.853770379000082, 37.273871161000045],
              [22.860850457000083, 37.25568268400008],
              [22.89503014400009, 37.20648834800005],
              [22.898448113000086, 37.20368073100008],
              [22.906586134000065, 37.19391510600008],
              [22.911631707000083, 37.18341705900008],
              [22.90528405000009, 37.17853424700007],
              [22.900401238000086, 37.17291901200008],
              [22.897227410000085, 37.159857489000046],
              [22.89503014400009, 37.13385651200008],
              [22.903168165000068, 37.12128327000005],
              [22.922048373000052, 37.11798737200007],
              [22.94271894600007, 37.12010325700004],
              [22.95639082100007, 37.12396881700005],
              [22.957041863000086, 37.11933014500005],
              [22.958832227000073, 37.116522528000075],
              [22.961192254000082, 37.11399974200009],
              [22.96387780000009, 37.11029694200005],
              [22.95679772200009, 37.106756903000075],
              [22.95801842500009, 37.10578034100007],
              [22.96387780000009, 37.10342031500005],
              [22.95639082100007, 37.09593333500004],
              [22.973480665000068, 37.09096914300005],
              [22.981700066000087, 37.08270905200004],
              [22.979177280000044, 37.077826239000046],
              [22.96387780000009, 37.08295319200005],
              [22.972911004000082, 37.06513092700004],
              [22.999847852000073, 37.033270575000074],
              [22.998057488000086, 37.021470445000034],
              [23.006114129000082, 37.00458405200004],
              [23.011729363000086, 36.986761786000045],
              [23.006521030000044, 36.987209377000056],
              [22.99586022200009, 36.98647695500006],
              [22.99073326900009, 36.986761786000045],
              [22.99317467500009, 36.98183828300006],
              [23.000824415000068, 36.97117747600004],
              [23.00489342500009, 36.966864325000074],
              [23.00684655000009, 36.97016022300005],
              [23.00757897200009, 36.97085195500006],
              [23.008474155000044, 36.97109609600005],
              [23.011729363000086, 36.973089911000045],
              [23.01498457100007, 36.96385325700004],
              [23.016368035000085, 36.95526764500005],
              [23.01531009200005, 36.94708893400008],
              [23.011729363000086, 36.93891022300005],
              [23.021739129000082, 36.92572663000004],
              [23.041677280000044, 36.88544342700004],
              [23.049001498000052, 36.87689850500004],
              [23.04590905000009, 36.86908600500004],
              [23.059255405000044, 36.85150788000004],
              [23.086761915000068, 36.82908763200004],
              [23.093272332000083, 36.81826406500005],
              [23.095550977000073, 36.80703359600005],
              [23.091807488000086, 36.79832591400009],
              [23.08057701900009, 36.794989325000074],
              [23.08057701900009, 36.788763739000046],
              [23.091075066000087, 36.788275458000044],
              [23.098806186000047, 36.78693268400008],
              [23.114105665000068, 36.781317450000074],
              [23.10987389400009, 36.77366771000004],
              [23.098399285000085, 36.76666901200008],
              [23.094411655000044, 36.76080963700008],
              [23.092946811000047, 36.755194403000075],
              [23.093028191000087, 36.752020575000074],
              [23.093760613000086, 36.748928127000056],
              [23.094411655000044, 36.74371979400007],
              [23.088633660000085, 36.73289622600004],
              [23.07585696700005, 36.73383209800005],
              [23.061696811000047, 36.74054596600007],
              [23.052012566000087, 36.74713776200008],
              [23.04346764400009, 36.736029364000046],
              [23.03093509200005, 36.72557200700004],
              [23.025645379000082, 36.71564362200007],
              [23.039073113000086, 36.70620351800005],
              [23.036957227000073, 36.70286692900004],
              [23.03419030000009, 36.69586823100008],
              [23.03223717500009, 36.692572333000044],
              [23.059418165000068, 36.692572333000044],
              [23.034434441000087, 36.67487213700008],
              [23.03565514400009, 36.64907461100006],
              [23.05046634200005, 36.62246328300006],
              [23.070160352000073, 36.596991278000075],
              [23.08057701900009, 36.579291083000044],
              [23.084808790000068, 36.576157945000034],
              [23.104665561000047, 36.56932200700004],
              [23.115977410000085, 36.56224192900004],
              [23.134613477000073, 36.55536530200004],
              [23.138845248000052, 36.55052317900004],
              [23.141286655000044, 36.54559967700004],
              [23.145355665000068, 36.54193756700005],
              [23.155039910000085, 36.541083075000074],
              [23.145762566000087, 36.53563060100004],
              [23.141449415000068, 36.53424713700008],
              [23.141449415000068, 36.52802155200004],
              [23.14747155000009, 36.522365627000056],
              [23.14820397200009, 36.51715729400007],
              [23.14389082100007, 36.51227448100008],
              [23.134613477000073, 36.50755442900004],
              [23.151866082000083, 36.48729075700004],
              [23.181813998000052, 36.472316799000055],
              [23.20362389400009, 36.45612213700008],
              [23.196055535000085, 36.432521877000056],
              [23.16187584700009, 36.446193752000056],
              [23.151866082000083, 36.435614325000074],
              [23.139333530000044, 36.43406810100004],
              [23.09473717500009, 36.44318268400008],
              [23.08570397200009, 36.45359935100004],
              [23.078379754000082, 36.465277411000045],
              [23.066254102000073, 36.47345612200007],
              [23.066254102000073, 36.47964101800005],
              [23.072113477000073, 36.49310944200005],
              [23.065114780000044, 36.509100653000075],
              [23.051036004000082, 36.52244700700004],
              [23.03565514400009, 36.52802155200004],
              [22.99268639400009, 36.52033112200007],
              [22.97242272200009, 36.52020905200004],
              [22.96387780000009, 36.53115469000005],
              [22.959239129000082, 36.54743073100008],
              [22.936778191000087, 36.58616771000004],
              [22.929209832000083, 36.59634023600006],
              [22.917816602000073, 36.605169989000046],
              [22.87468509200005, 36.630519924000055],
              [22.888926629000082, 36.64248281500005],
              [22.884287957000083, 36.65424225500004],
              [22.842539910000085, 36.68500397300005],
              [22.837168816000087, 36.68650950700004],
              [22.833181186000047, 36.678900458000044],
              [22.81934655000009, 36.665228583000044],
              [22.81495201900009, 36.67055898600006],
              [22.813731316000087, 36.679388739000046],
              [22.81934655000009, 36.702785549000055],
              [22.817149285000085, 36.717962958000044],
              [22.807871941000087, 36.739569403000075],
              [22.800791863000086, 36.77578359600005],
              [22.78687584700009, 36.79344310100004],
              [22.765147332000083, 36.80418528900009],
              [22.736664259000065, 36.808579820000034],
              [22.685557488000086, 36.809475002000056],
              [22.622569207000083, 36.80345286700009],
              [22.577403191000087, 36.78302643400008],
              [22.57911217500009, 36.74038320500006],
              [22.546153191000087, 36.72142161700009],
              [22.533457879000082, 36.70722077000005],
              [22.52507571700005, 36.68512604400007],
              [22.540293816000087, 36.685207424000055],
              [22.54981530000009, 36.67829010600008],
              [22.55372155000009, 36.66620514500005],
              [22.55250084700009, 36.65094635600008],
              [22.545664910000085, 36.65094635600008],
              [22.543793165000068, 36.65802643400008],
              [22.54004967500009, 36.665269273000035],
              [22.533864780000044, 36.67055898600006],
              [22.52507571700005, 36.67145416900007],
              [22.516774936000047, 36.66616445500006],
              [22.51140384200005, 36.65688711100006],
              [22.510020379000082, 36.64801666900007],
              [22.514496290000068, 36.64411041900007],
              [22.53101647200009, 36.632798570000034],
              [22.526052280000044, 36.61237213700008],
              [22.51270592500009, 36.602769273000035],
              [22.504649285000085, 36.624253648000035],
              [22.49000084700009, 36.61701080900008],
              [22.48406009200005, 36.606634833000044],
              [22.483571811000047, 36.54791901200008],
              [22.486582879000082, 36.525091864000046],
              [22.49268639400009, 36.506293036000045],
              [22.51148522200009, 36.46662018400008],
              [22.507334832000083, 36.46108633000006],
              [22.51148522200009, 36.452337958000044],
              [22.498301629000082, 36.44525788000004],
              [22.49390709700009, 36.434759833000044],
              [22.496755405000044, 36.422756252000056],
              [22.504649285000085, 36.411363023000035],
              [22.504649285000085, 36.40452708500004],
              [22.49545332100007, 36.40534088700008],
              [22.493011915000068, 36.40249258000006],
              [22.492849155000044, 36.39728424700007],
              [22.490977410000085, 36.39093659100007],
              [22.479746941000087, 36.402044989000046],
              [22.47632897200009, 36.419256903000075],
              [22.47510826900009, 36.437567450000074],
              [22.469899936000047, 36.452337958000044],
              [22.455332879000082, 36.462225653000075],
              [22.42042076900009, 36.473537502000056],
              [22.408376498000052, 36.48712799700007],
              [22.401621941000087, 36.48712799700007],
              [22.391368035000085, 36.478501695000034],
              [22.38135826900009, 36.480454820000034],
              [22.371918165000068, 36.48822663000004],
              [22.364024285000085, 36.49701569200005],
              [22.35450280000009, 36.51190827000005],
              [22.355316602000073, 36.52293528900009],
              [22.361501498000052, 36.53375885600008],
              [22.367442254000082, 36.54791901200008],
              [22.383555535000085, 36.544175523000035],
              [22.388194207000083, 36.55605703300006],
              [22.384043816000087, 36.57249583500004],
              [22.373708530000044, 36.58270905200004],
              [22.37867272200009, 36.587591864000046],
              [22.387950066000087, 36.60252513200004],
              [22.367442254000082, 36.60252513200004],
              [22.369313998000052, 36.61538320500006],
              [22.367930535000085, 36.630845445000034],
              [22.371348504000082, 36.64272695500006],
              [22.387950066000087, 36.64411041900007],
              [22.387950066000087, 36.65094635600008],
              [22.368418816000087, 36.65648021000004],
              [22.370616082000083, 36.67357005400004],
              [22.387950066000087, 36.70620351800005],
              [22.358571811000047, 36.70209381700005],
              [22.339366082000083, 36.72646719000005],
              [22.323741082000083, 36.757879950000074],
              [22.305430535000085, 36.775091864000046],
              [22.306976759000065, 36.794582424000055],
              [22.291677280000044, 36.82013580900008],
              [22.221527540000068, 36.89752838700008],
              [22.20020592500009, 36.90639883000006],
              [22.175059441000087, 36.89118073100008],
              [22.148692254000082, 36.90717194200005],
              [22.137868686000047, 36.91714101800005],
              [22.133474155000044, 36.93211497600004],
              [22.13575280000009, 36.931626695000034],
              [22.140635613000086, 36.937160549000055],
              [22.145355665000068, 36.94611237200007],
              [22.147715691000087, 36.95604075700004],
              [22.148773634000065, 36.96743398600006],
              [22.153575066000087, 36.98688385600008],
              [22.155121290000068, 37.014105536000045],
              [22.153168165000068, 37.021185614000046],
              [22.08562259200005, 37.03339264500005],
              [22.048106316000087, 37.035142320000034],
              [22.030039910000085, 37.030951239000046],
              [21.992198113000086, 37.01211172100005],
              [21.954600457000083, 37.00364817900004],
              [21.94312584700009, 36.99331289300005],
              [21.937347852000073, 36.97996653900009],
              [21.927256707000083, 36.884466864000046],
              [21.922211134000065, 36.872300523000035],
              [21.921722852000073, 36.86322663000004],
              [21.925954623000052, 36.85171133000006],
              [21.93213951900009, 36.843003648000035],
              [21.93490644600007, 36.83421458500004],
              [21.928558790000068, 36.822251695000034],
              [21.945648634000065, 36.809027411000045],
              [21.956228061000047, 36.80345286700009],
              [21.970225457000083, 36.80174388200004],
              [21.970225457000083, 36.794989325000074],
              [21.95679772200009, 36.794134833000044],
              [21.94507897200009, 36.789943752000056],
              [21.93881269600007, 36.783189195000034],
              [21.942230665000068, 36.775091864000046],
              [21.935883009000065, 36.76601797100005],
              [21.89429772200009, 36.73505280200004],
              [21.888682488000086, 36.72992584800005],
              [21.88257897200009, 36.726548570000034],
              [21.87403405000009, 36.72671133000006],
              [21.85678144600007, 36.755072333000044],
              [21.853526238000086, 36.75739166900007],
              [21.82276451900009, 36.808579820000034],
              [21.804860873000052, 36.80760325700004],
              [21.789724155000044, 36.804754950000074],
              [21.76417076900009, 36.794989325000074],
              [21.752289259000065, 36.80499909100007],
              [21.728770379000082, 36.81264883000006],
              [21.722504102000073, 36.822251695000034],
              [21.716319207000083, 36.822251695000034],
              [21.707367384000065, 36.818019924000055],
              [21.701914910000085, 36.82562897300005],
              [21.69662519600007, 36.83844635600008],
              [21.68848717500009, 36.84955475500004],
              [21.69239342500009, 36.859035549000055],
              [21.691661004000082, 36.867254950000074],
              [21.68921959700009, 36.877020575000074],
              [21.68848717500009, 36.89118073100008],
              [21.691579623000052, 36.90029531500005],
              [21.70476321700005, 36.91714101800005],
              [21.70948326900009, 36.92593008000006],
              [21.70997155000009, 36.942694403000075],
              [21.702647332000083, 36.95726146000004],
              [21.688161655000044, 36.964544989000046],
              [21.667979363000086, 36.959418036000045],
              [21.67741946700005, 36.96328359600005],
              [21.680430535000085, 36.966457424000055],
              [21.681651238000086, 36.973089911000045],
              [21.672699415000068, 36.97357819200005],
              [21.66773522200009, 36.97093333500004],
              [21.66179446700005, 36.959418036000045],
              [21.65479576900009, 36.99469635600008],
              [21.629242384000065, 37.02090078300006],
              [21.59929446700005, 37.04572174700007],
              [21.57862389400009, 37.07672760600008],
              [21.56967207100007, 37.11619700700004],
              [21.567556186000047, 37.156317450000074],
              [21.574392123000052, 37.19236888200004],
              [21.592133009000065, 37.22016022300005],
              [21.654958530000044, 37.26072825700004],
              [21.682302280000044, 37.28392161700009],
              [21.69581139400009, 37.31635163000004],
              [21.691416863000086, 37.356634833000044],
              [21.681976759000065, 37.378973700000074],
              [21.67481530000009, 37.39598216400009],
              [21.60710696700005, 37.49949778900009],
              [21.569021030000044, 37.545355536000045],
              [21.549978061000047, 37.56146881700005],
              [21.463633660000085, 37.610256252000056],
              [21.44304446700005, 37.61859772300005],
              [21.431813998000052, 37.62763092700004],
              [21.412364129000082, 37.64801666900007],
              [21.402191602000073, 37.65542226800005],
              [21.343272332000083, 37.66933828300006],
              [21.323741082000083, 37.664943752000056],
              [21.318532748000052, 37.637884833000044],
              [21.31226647200009, 37.637884833000044],
              [21.31023196700005, 37.64740631700005],
              [21.310394727000073, 37.657416083000044],
              [21.30827884200005, 37.66624583500004],
              [21.298675977000073, 37.67259349200009],
              [21.31104576900009, 37.69310130400004],
              [21.314707879000082, 37.70954010600008],
              [21.31185957100007, 37.72630442900004],
              [21.295258009000065, 37.77167389500005],
              [21.28492272200009, 37.78510163000004],
              [21.271006707000083, 37.793402411000045],
              [21.227305535000085, 37.81191640800006],
              [21.12208092500009, 37.83738841400009],
              [21.11304772200009, 37.84332916900007],
              [21.107595248000052, 37.855454820000034],
              [21.111582879000082, 37.870428778000075],
              [21.106211785000085, 37.87807851800005],
              [21.133555535000085, 37.94635651200008],
              [21.14039147200009, 37.94635651200008],
              [21.164398634000065, 37.92963288000004],
              [21.207774285000085, 37.94603099200009],
              [21.25163821700005, 37.976223049000055],
              [21.277517123000052, 38.00096263200004],
              [21.29151451900009, 37.99721914300005],
              [21.303477410000085, 38.00332265800006],
              [21.314626498000052, 38.013373114000046],
              [21.32593834700009, 38.02142975500004],
              [21.32593834700009, 38.02887604400007],
              [21.322276238000086, 38.030910549000055],
              [21.321136915000068, 38.031683661000045],
              [21.320648634000065, 38.03266022300005],
              [21.318532748000052, 38.03510163000004],
              [21.308848504000082, 38.03172435100004],
              [21.299082879000082, 38.02651601800005],
              [21.290537957000083, 38.02065664300005],
              [21.284353061000047, 38.015285549000055],
              [21.329356316000087, 38.06989166900007],
              [21.331309441000087, 38.07640208500004],
              [21.367035352000073, 38.121079820000034],
              [21.371429884000065, 38.13149648600006],
              [21.373708530000044, 38.14447663000004],
              [21.375743035000085, 38.204291083000044],
              [21.374278191000087, 38.22064850500004],
              [21.384938998000052, 38.21112702000005],
              [21.398285352000073, 38.19293854400007],
              [21.408539259000065, 38.18593984600005],
              [21.407725457000083, 38.19794342700004],
              [21.40528405000009, 38.207464911000045],
              [21.40088951900009, 38.21478913000004],
              [21.406097852000073, 38.20840078300006],
              [21.420664910000085, 38.202337958000044],
              [21.438243035000085, 38.200384833000044],
              [21.459727410000085, 38.20018138200004],
              [21.47396894600007, 38.19603099200009],
              [21.52393639400009, 38.166001695000034],
              [21.603037957000083, 38.15180084800005],
              [21.622325066000087, 38.15477122600004],
              [21.64234459700009, 38.162095445000034],
              [21.67481530000009, 38.179673570000034],
              [21.701345248000052, 38.20526764500005],
              [21.74154707100007, 38.26972077000005],
              [21.76417076900009, 38.295803127000056],
              [21.840505405000044, 38.333644924000055],
              [21.849457227000073, 38.34129466400009],
              [21.915537957000083, 38.330511786000045],
              [21.937022332000083, 38.33063385600008],
              [21.946543816000087, 38.33234284100007],
              [21.955902540000068, 38.33673737200007],
              [21.965505405000044, 38.32990143400008],
              [21.978037957000083, 38.323553778000075],
              [21.992523634000065, 38.31875234600005],
              [22.007823113000086, 38.31688060100004],
              [22.020355665000068, 38.31321849200009],
              [22.026621941000087, 38.304348049000055],
              [22.030772332000083, 38.292954820000034],
              [22.037852410000085, 38.282131252000056],
              [22.048838738000086, 38.27480703300006],
              [22.07862389400009, 38.26341380400004],
              [22.089366082000083, 38.26166413000004],
              [22.09734134200005, 38.26276276200008],
              [22.108653191000087, 38.26740143400008],
              [22.113617384000065, 38.26780833500004],
              [22.12208092500009, 38.26080963700008],
              [22.128916863000086, 38.256293036000045],
              [22.13721764400009, 38.25421784100007],
              [22.143321160000085, 38.24909088700008],
              [22.15406334700009, 38.22345612200007],
              [22.161387566000087, 38.21320221600007],
              [22.16968834700009, 38.20970286700009],
              [22.20606530000009, 38.20018138200004],
              [22.209157748000052, 38.19794342700004],
              [22.212901238000086, 38.193060614000046],
              [22.21851647200009, 38.18817780200004],
              [22.226573113000086, 38.18593984600005],
              [22.25757897200009, 38.18593984600005],
              [22.300791863000086, 38.17747630400004],
              [22.312836134000065, 38.17226797100005],
              [22.331228061000047, 38.178900458000044],
              [22.346853061000047, 38.170803127000056],
              [22.363454623000052, 38.158270575000074],
              [22.39421634200005, 38.148423570000034],
              [22.404307488000086, 38.141913153000075],
              [22.414805535000085, 38.137884833000044],
              [22.42554772200009, 38.141831773000035],
              [22.432790561000047, 38.14325592700004],
              [22.51148522200009, 38.12929922100005],
              [22.620616082000083, 38.08348216400009],
              [22.680430535000085, 38.06659577000005],
              [22.688975457000083, 38.05927155200004],
              [22.698496941000087, 38.056708075000074],
              [22.77833092500009, 38.00096263200004],
              [22.796397332000083, 37.97679271000004],
              [22.802256707000083, 37.97361888200004],
              [22.82129967500009, 37.969183661000045],
              [22.852386915000068, 37.94749583500004],
              [22.867198113000086, 37.939520575000074],
              [22.882660352000073, 37.937567450000074],
              [22.89820397200009, 37.93976471600007],
              [22.92237389400009, 37.94635651200008],
              [22.930023634000065, 37.946600653000075],
              [22.938324415000068, 37.94594961100006],
              [22.94629967500009, 37.94623444200005],
              [22.952972852000073, 37.94940827000005],
              [22.97315514400009, 37.97361888200004],
              [22.975352410000085, 37.97898997600004],
              [22.965505405000044, 37.99070872600004],
              [22.95093834700009, 38.00242747600004],
              [22.939463738000086, 38.00775788000004],
              [22.923838738000086, 38.011786200000074],
              [22.899180535000085, 38.027777411000045],
              [22.880869988000086, 38.02887604400007],
              [22.88412519600007, 38.03221263200004],
              [22.887461785000085, 38.033636786000045],
              [22.85401451900009, 38.03510163000004],
              [22.87549889400009, 38.04930247600004],
              [22.885427280000044, 38.05426666900007],
              [22.898448113000086, 38.05621979400007],
              [22.911631707000083, 38.06012604400007],
              [22.933767123000052, 38.07827383000006],
              [22.942881707000083, 38.08348216400009],
              [22.96973717500009, 38.08197663000004],
              [23.019053582000083, 38.06525299700007],
              [23.039073113000086, 38.06989166900007],
              [23.068614129000082, 38.05890534100007],
              [23.10092207100007, 38.06240469000005],
              [23.17286217500009, 38.07949453300006],
              [23.189707879000082, 38.09438711100006],
              [23.20671634200005, 38.09780508000006],
              [23.216644727000073, 38.10333893400008],
              [23.21029707100007, 38.11538320500006],
              [23.194183790000068, 38.126939195000034],
              [23.17554772200009, 38.131293036000045],
              [23.175303582000083, 38.13629791900007],
              [23.17554772200009, 38.144964911000045],
              [23.188243035000085, 38.14606354400007],
              [23.21070397200009, 38.15058014500005],
              [23.223399285000085, 38.15180084800005],
              [23.223399285000085, 38.15924713700008],
              [23.21338951900009, 38.160264390000066],
              [23.144053582000083, 38.16742584800005],
              [23.128428582000083, 38.17226797100005],
              [23.14893639400009, 38.18593984600005],
              [23.12273196700005, 38.20807526200008],
              [23.109629754000082, 38.21010976800005],
              [23.07748457100007, 38.18577708500004],
              [23.066661004000082, 38.18317291900007],
              [23.03223717500009, 38.18593984600005],
              [23.03223717500009, 38.19277578300006],
              [23.052012566000087, 38.19277578300006],
              [23.03882897200009, 38.208319403000075],
              [23.02507571700005, 38.21662018400008],
              [23.010427280000044, 38.220038153000075],
              [22.951914910000085, 38.22528717700004],
              [22.933767123000052, 38.22207265800006],
              [22.92237389400009, 38.207017320000034],
              [22.935883009000065, 38.210598049000055],
              [22.95053144600007, 38.20978424700007],
              [22.963063998000052, 38.20404694200005],
              [22.969493035000085, 38.19277578300006],
              [22.952321811000047, 38.19310130400004],
              [22.922536655000044, 38.19745514500005],
              [22.90870201900009, 38.19277578300006],
              [22.89503014400009, 38.24115631700005],
              [22.888194207000083, 38.24115631700005],
              [22.880869988000086, 38.22695547100005],
              [22.879567905000044, 38.231675523000035],
              [22.876475457000083, 38.236314195000034],
              [22.87468509200005, 38.24115631700005],
              [22.85645592500009, 38.236395575000074],
              [22.81999759200005, 38.23297760600008],
              [22.80567467500009, 38.22695547100005],
              [22.764821811000047, 38.24799225500004],
              [22.77320397200009, 38.25828685100004],
              [22.791270379000082, 38.27045319200005],
              [22.798838738000086, 38.282131252000056],
              [22.78028405000009, 38.28856028900009],
              [22.742360873000052, 38.29706452000005],
              [22.719411655000044, 38.31028880400004],
              [22.70289147200009, 38.31403229400007],
              [22.696462436000047, 38.31688060100004],
              [22.691416863000086, 38.32217031500005],
              [22.675303582000083, 38.34357330900008],
              [22.684418165000068, 38.36107005400004],
              [22.670176629000082, 38.38153717700004],
              [22.646494988000086, 38.389960028000075],
              [22.626800977000073, 38.371527411000045],
              [22.644867384000065, 38.36961497600004],
              [22.64616946700005, 38.36180247600004],
              [22.636729363000086, 38.35626862200007],
              [22.623789910000085, 38.360988674000055],
              [22.61231530000009, 38.36383698100008],
              [22.60092207100007, 38.35565827000005],
              [22.591807488000086, 38.344183661000045],
              [22.587168816000087, 38.33673737200007],
              [22.587168816000087, 38.330511786000045],
              [22.59229576900009, 38.328192450000074],
              [22.595225457000083, 38.326239325000074],
              [22.599131707000083, 38.32461172100005],
              [22.60645592500009, 38.32306549700007],
              [22.60645592500009, 38.31688060100004],
              [22.599131707000083, 38.31281159100007],
              [22.59815514400009, 38.31073639500005],
              [22.599782748000052, 38.30817291900007],
              [22.600271030000044, 38.30263906500005],
              [22.588633660000085, 38.293036200000074],
              [22.576426629000082, 38.29018789300005],
              [22.562510613000086, 38.29352448100008],
              [22.545664910000085, 38.30263906500005],
              [22.545258009000065, 38.305568752000056],
              [22.533946160000085, 38.32265859600005],
              [22.531993035000085, 38.32306549700007],
              [22.52898196700005, 38.32880280200004],
              [22.526215040000068, 38.331732489000046],
              [22.52833092500009, 38.33392975500004],
              [22.53882897200009, 38.33673737200007],
              [22.52515709700009, 38.35883209800005],
              [22.477305535000085, 38.40566640800006],
              [22.46843509200005, 38.421128648000035],
              [22.463063998000052, 38.42609284100007],
              [22.458832227000073, 38.42792389500005],
              [22.44825280000009, 38.43048737200007],
              [22.401621941000087, 38.45343659100007],
              [22.40284264400009, 38.443060614000046],
              [22.407399936000047, 38.425116278000075],
              [22.408376498000052, 38.41559479400007],
              [22.381114129000082, 38.39883047100005],
              [22.373708530000044, 38.39203522300005],
              [22.381032748000052, 38.383978583000044],
              [22.385996941000087, 38.380194403000075],
              [22.38998457100007, 38.380519924000055],
              [22.394786004000082, 38.38515859600005],
              [22.398610873000052, 38.37592194200005],
              [22.39625084700009, 38.368353583000044],
              [22.389821811000047, 38.36225006700005],
              [22.381114129000082, 38.357855536000045],
              [22.387950066000087, 38.35101959800005],
              [22.382334832000083, 38.342678127000056],
              [22.367523634000065, 38.341864325000074],
              [22.348399285000085, 38.347357489000046],
              [22.322520379000082, 38.35101959800005],
              [22.28492272200009, 38.347316799000055],
              [22.279307488000086, 38.35309479400007],
              [22.266449415000068, 38.35854726800005],
              [22.252614780000044, 38.360988674000055],
              [22.243337436000047, 38.357855536000045],
              [22.237071160000085, 38.357855536000045],
              [22.224864129000082, 38.36005280200004],
              [22.209320509000065, 38.35293203300006],
              [22.195974155000044, 38.339544989000046],
              [22.18921959700009, 38.32306549700007],
              [22.180918816000087, 38.32998281500005],
              [22.175303582000083, 38.34332916900007],
              [22.168793165000068, 38.35101959800005],
              [22.15951582100007, 38.353949286000045],
              [22.150726759000065, 38.352769273000035],
              [22.145762566000087, 38.35398997600004],
              [22.147715691000087, 38.36408112200007],
              [22.13257897200009, 38.372748114000046],
              [22.100759311000047, 38.38031647300005],
              [22.049082879000082, 38.398504950000074],
              [22.029551629000082, 38.39923737200007],
              [22.011241082000083, 38.39203522300005],
              [21.98764082100007, 38.410589911000045],
              [21.957855665000068, 38.41168854400007],
              [21.928965691000087, 38.40289948100008],
              [21.888519727000073, 38.379787502000056],
              [21.879242384000065, 38.37799713700008],
              [21.864105665000068, 38.37767161700009],
              [21.856130405000044, 38.380926825000074],
              [21.85124759200005, 38.388006903000075],
              [21.84620201900009, 38.39533112200007],
              [21.840505405000044, 38.398871161000045],
              [21.831228061000047, 38.39667389500005],
              [21.78223717500009, 38.36367422100005],
              [21.774587436000047, 38.35260651200008],
              [21.771657748000052, 38.333644924000055],
              [21.762543165000068, 38.32835521000004],
              [21.743011915000068, 38.33783600500004],
              [21.716319207000083, 38.357855536000045],
              [21.65796959700009, 38.357855536000045],
              [21.64161217500009, 38.35443756700005],
              [21.627126498000052, 38.34813060100004],
              [21.613536004000082, 38.344956773000035],
              [21.599619988000086, 38.35101959800005],
              [21.535411004000082, 38.31395091400009],
              [21.52393639400009, 38.295803127000056],
              [21.517751498000052, 38.295803127000056],
              [21.508474155000044, 38.30223216400009],
              [21.494395379000082, 38.30463288000004],
              [21.481618686000047, 38.305121161000045],
              [21.476084832000083, 38.30605703300006],
              [21.46924889400009, 38.312933661000045],
              [21.428396030000044, 38.330511786000045],
              [21.445323113000086, 38.334051825000074],
              [21.461192254000082, 38.32697174700007],
              [21.476084832000083, 38.31635163000004],
              [21.489756707000083, 38.309475002000056],
              [21.489756707000083, 38.31688060100004],
              [21.485118035000085, 38.32123444200005],
              [21.482676629000082, 38.32461172100005],
              [21.48373457100007, 38.32904694200005],
              [21.489756707000083, 38.33673737200007],
              [21.48023522200009, 38.342230536000045],
              [21.476084832000083, 38.34357330900008],
              [21.476084832000083, 38.35101959800005],
              [21.479991082000083, 38.35248444200005],
              [21.489756707000083, 38.357855536000045],
              [21.469981316000087, 38.357855536000045],
              [21.476084832000083, 38.371527411000045],
              [21.466970248000052, 38.36786530200004],
              [21.458506707000083, 38.36635976800005],
              [21.450450066000087, 38.36741771000004],
              [21.442637566000087, 38.371527411000045],
              [21.43685957100007, 38.36766185100004],
              [21.43262780000009, 38.36619700700004],
              [21.422129754000082, 38.36408112200007],
              [21.428477410000085, 38.38373444200005],
              [21.416270379000082, 38.39411041900007],
              [21.39584394600007, 38.398138739000046],
              [21.37745201900009, 38.398871161000045],
              [21.369883660000085, 38.408189195000034],
              [21.360118035000085, 38.46771881700005],
              [21.339040561000047, 38.487534898000035],
              [21.32748457100007, 38.494574286000045],
              [21.322520379000082, 38.49628327000005],
              [21.318207227000073, 38.495306708000044],
              [21.308604363000086, 38.49437083500004],
              [21.312022332000083, 38.48655833500004],
              [21.35328209700009, 38.432928778000075],
              [21.339040561000047, 38.432928778000075],
              [21.34115644600007, 38.42926666900007],
              [21.342133009000065, 38.42853424700007],
              [21.34343509200005, 38.42837148600006],
              [21.346446160000085, 38.42609284100007],
              [21.34278405000009, 38.41575755400004],
              [21.34034264400009, 38.40460846600007],
              [21.336599155000044, 38.395697333000044],
              [21.329356316000087, 38.39203522300005],
              [21.319102410000085, 38.39020416900007],
              [21.29786217500009, 38.38141510600008],
              [21.291188998000052, 38.37767161700009],
              [21.293630405000044, 38.37368398600006],
              [21.29468834700009, 38.37343984600005],
              [21.298675977000073, 38.371527411000045],
              [21.291188998000052, 38.36408112200007],
              [21.277679884000065, 38.37091705900008],
              [21.269541863000086, 38.36786530200004],
              [21.266368035000085, 38.361395575000074],
              [21.267588738000086, 38.357855536000045],
              [21.272227410000085, 38.35443756700005],
              [21.264903191000087, 38.346909898000035],
              [21.250254754000082, 38.33673737200007],
              [21.23926842500009, 38.33112213700008],
              [21.232432488000086, 38.329413153000075],
              [21.21265709700009, 38.330511786000045],
              [21.204600457000083, 38.33417389500005],
              [21.197113477000073, 38.34015534100007],
              [21.189626498000052, 38.34137604400007],
              [21.18132571700005, 38.330511786000045],
              [21.186371290000068, 38.326605536000045],
              [21.192556186000047, 38.32412344000005],
              [21.199961785000085, 38.32306549700007],
              [21.19507897200009, 38.321966864000046],
              [21.182871941000087, 38.31915924700007],
              [21.175059441000087, 38.31329987200007],
              [21.174489780000044, 38.30263906500005],
              [21.15560957100007, 38.303900458000044],
              [21.148610873000052, 38.31403229400007],
              [21.14584394600007, 38.327053127000056],
              [21.14039147200009, 38.33673737200007],
              [21.128428582000083, 38.34015534100007],
              [21.097911004000082, 38.340725002000056],
              [21.085215691000087, 38.34357330900008],
              [21.096934441000087, 38.34788646000004],
              [21.105723504000082, 38.35297272300005],
              [21.109385613000086, 38.36041901200008],
              [21.106211785000085, 38.371527411000045],
              [21.096446160000085, 38.36692942900004],
              [21.092539910000085, 38.36408112200007],
              [21.10132897200009, 38.37970612200007],
              [21.106211785000085, 38.38515859600005],
              [21.10328209700009, 38.378159898000035],
              [21.113536004000082, 38.373928127000056],
              [21.125010613000086, 38.37995026200008],
              [21.133636915000068, 38.388657945000034],
              [21.14039147200009, 38.398871161000045],
              [21.12240644600007, 38.41034577000005],
              [21.114756707000083, 38.40961334800005],
              [21.106211785000085, 38.398871161000045],
              [21.09473717500009, 38.40298086100006],
              [21.086761915000068, 38.41046784100007],
              [21.08179772200009, 38.42072174700007],
              [21.078949415000068, 38.432928778000075],
              [21.082041863000086, 38.43496328300006],
              [21.08301842500009, 38.43504466400009],
              [21.08366946700005, 38.435980536000045],
              [21.085215691000087, 38.44037506700005],
              [21.095225457000083, 38.43024323100008],
              [21.10678144600007, 38.425441799000055],
              [21.11622155000009, 38.42804596600007],
              [21.119883660000085, 38.44037506700005],
              [21.106211785000085, 38.432928778000075],
              [21.110850457000083, 38.44611237200007],
              [21.101410352000073, 38.46474844000005],
              [21.106211785000085, 38.473944403000075],
              [21.106211785000085, 38.48139069200005],
              [21.09669030000009, 38.48143138200004],
              [21.090179884000065, 38.48314036700009],
              [21.078949415000068, 38.487534898000035],
              [21.088145379000082, 38.49201080900008],
              [21.092621290000068, 38.49359772300005],
              [21.09937584700009, 38.49437083500004],
              [21.09538821700005, 38.49648672100005],
              [21.089691602000073, 38.500433661000045],
              [21.085215691000087, 38.50185781500005],
              [21.09473717500009, 38.51788971600007],
              [21.09742272200009, 38.52594635600008],
              [21.095957879000082, 38.53192780200004],
              [21.086680535000085, 38.536444403000075],
              [21.078868035000085, 38.532416083000044],
              [21.071055535000085, 38.525824286000045],
              [21.061778191000087, 38.522365627000056],
              [21.058116082000083, 38.51850006700005],
              [21.047211134000065, 38.511379299000055],
              [21.035817905000044, 38.50690338700008],
              [21.030528191000087, 38.511419989000046],
              [21.02833092500009, 38.52057526200008],
              [21.019053582000083, 38.53497955900008],
              [21.016856316000087, 38.54588450700004],
              [21.024587436000047, 38.58673737200007],
              [21.024668816000087, 38.60846588700008],
              [21.00367272200009, 38.62645091400009],
              [20.988129102000073, 38.66400788000004],
              [20.97901451900009, 38.67255280200004],
              [20.940114780000044, 38.67291901200008],
              [20.926605665000068, 38.67674388200004],
              [20.914398634000065, 38.68622467700004],
              [20.907399936000047, 38.698553778000075],
              [20.883148634000065, 38.779364325000074],
              [20.873383009000065, 38.79531484600005],
              [20.85987389400009, 38.80353424700007],
              [20.845225457000083, 38.79962799700007],
              [20.83057701900009, 38.78778717700004],
              [20.818532748000052, 38.773504950000074],
              [20.811371290000068, 38.76251862200007],
              [20.80404707100007, 38.77338288000004],
              [20.798106316000087, 38.771551825000074],
              [20.791840040000068, 38.76654694200005],
              [20.784027540000068, 38.76813385600008],
              [20.773285352000073, 38.760931708000044],
              [20.76929772200009, 38.76504140800006],
              [20.767425977000073, 38.77411530200004],
              [20.763682488000086, 38.78172435100004],
              [20.729340040000068, 38.80353424700007],
              [20.729340040000068, 38.809759833000044],
              [20.736989780000044, 38.82257721600007],
              [20.741465691000087, 38.84088776200008],
              [20.74935957100007, 38.85724518400008],
              [20.76734459700009, 38.86432526200008],
              [20.78882897200009, 38.863714911000045],
              [20.800303582000083, 38.864569403000075],
              [20.80518639400009, 38.86774323100008],
              [20.801931186000047, 38.87409088700008],
              [20.794200066000087, 38.879787502000056],
              [20.785980665000068, 38.88385651200008],
              [20.764496290000068, 38.891791083000044],
              [20.756032748000052, 38.90688711100006],
              [20.754079623000052, 38.92495351800005],
              [20.75749759200005, 38.94009023600006],
              [20.769786004000082, 38.958970445000034],
              [20.77515709700009, 38.951605536000045],
              [20.781586134000065, 38.93500397300005],
              [20.797699415000068, 38.92641836100006],
              [20.817067905000044, 38.92137278900009],
              [20.835948113000086, 38.928900458000044],
              [20.849782748000052, 38.94367096600007],
              [20.85987389400009, 38.96051666900007],
              [20.866709832000083, 38.96051666900007],
              [20.869965040000068, 38.95258209800005],
              [20.871104363000086, 38.947251695000034],
              [20.87012780000009, 38.943426825000074],
              [20.866709832000083, 38.94009023600006],
              [20.86850019600007, 38.938381252000056],
              [20.87159264400009, 38.93634674700007],
              [20.872243686000047, 38.932806708000044],
              [20.866709832000083, 38.92641836100006],
              [20.886973504000082, 38.92617422100005],
              [20.903819207000083, 38.92804596600007],
              [20.91578209700009, 38.93610260600008],
              [20.920664910000085, 38.954331773000035],
              [20.92750084700009, 38.954331773000035],
              [20.93718509200005, 38.94403717700004],
              [20.947276238000086, 38.94358958500004],
              [20.95948326900009, 38.94672272300005],
              [20.975352410000085, 38.94684479400007],
              [20.98878014400009, 38.94281647300005],
              [20.998301629000082, 38.93805573100008],
              [21.00945071700005, 38.93423086100006],
              [21.027354363000086, 38.93260325700004],
              [21.029958530000044, 38.926214911000045],
              [21.02670332100007, 38.912176825000074],
              [21.025563998000052, 38.89801666900007],
              [21.033946160000085, 38.89166901200008],
              [21.047536655000044, 38.88898346600007],
              [21.060801629000082, 38.88222890800006],
              [21.085215691000087, 38.86432526200008],
              [21.08643639400009, 38.87335846600007],
              [21.08887780000009, 38.87848541900007],
              [21.09310957100007, 38.881740627000056],
              [21.09937584700009, 38.88544342700004],
              [21.09937584700009, 38.89166901200008],
              [21.091644727000073, 38.90452708500004],
              [21.102305535000085, 38.91083405200004],
              [21.12086022200009, 38.910223700000074],
              [21.136973504000082, 38.90253327000005],
              [21.160411004000082, 38.88068268400008],
              [21.160817905000044, 38.87799713700008],
              [21.16700280000009, 38.87518952000005],
              [21.172618035000085, 38.87352122600004],
              [21.17741946700005, 38.87604401200008],
              [21.18132571700005, 38.88544342700004],
              [21.173106316000087, 38.89118073100008],
              [21.16968834700009, 38.895819403000075],
              [21.166840040000068, 38.91087474200009],
              [21.163340691000087, 38.911810614000046],
              [21.158864780000044, 38.91083405200004],
              [21.154551629000082, 38.913397528000075],
              [21.141856316000087, 38.93081289300005],
              [21.140147332000083, 38.94131094000005],
              [21.147227410000085, 38.954331773000035],
              [21.14193769600007, 38.96238841400009],
              [21.14503014400009, 38.97138092700004],
              [21.152598504000082, 38.97671133000006],
              [21.160817905000044, 38.97418854400007],
              [21.15992272200009, 38.997748114000046],
              [21.135590040000068, 39.02338288000004],
              [21.085215691000087, 39.062933661000045],
              [21.078135613000086, 39.05654531500005],
              [21.074392123000052, 39.050034898000035],
              [21.074473504000082, 39.04336172100005],
              [21.078949415000068, 39.03628164300005],
              [21.065277540000068, 39.04051341400009],
              [21.06031334700009, 39.039048570000034],
              [21.05518639400009, 39.03750234600005],
              [21.037364129000082, 39.02195872600004],
              [21.05836022200009, 39.008978583000044],
              [21.003184441000087, 39.01512278900009],
              [21.003184441000087, 39.02195872600004],
              [20.990896030000044, 39.02423737200007],
              [20.979177280000044, 39.03070709800005],
              [20.969981316000087, 39.037176825000074],
              [20.965668165000068, 39.03937409100007],
              [20.953786655000044, 39.03416575700004],
              [20.944183790000068, 39.03856028900009],
              [20.937510613000086, 39.04767487200007],
              [20.934825066000087, 39.056708075000074],
              [20.936778191000087, 39.056708075000074],
              [20.939789259000065, 39.06102122600004],
              [20.948496941000087, 39.062933661000045],
              [20.948496941000087, 39.06976959800005],
              [20.94109134200005, 39.06976959800005],
              [20.93140709700009, 39.06476471600007],
              [20.920176629000082, 39.064520575000074],
              [20.909434441000087, 39.06867096600007],
              [20.90137780000009, 39.07721588700008],
              [20.89389082100007, 39.07721588700008],
              [20.888194207000083, 39.06720612200007],
              [20.870371941000087, 39.05931224200009],
              [20.866709832000083, 39.05304596600007],
              [20.870941602000073, 39.04311758000006],
              [20.882009311000047, 39.04120514500005],
              [20.88648522200009, 39.036444403000075],
              [20.844899936000047, 39.03693268400008],
              [20.85987389400009, 39.04246653900009],
              [20.858164910000085, 39.049261786000045],
              [20.857758009000065, 39.05890534100007],
              [20.854991082000083, 39.06549713700008],
              [20.84620201900009, 39.062933661000045],
              [20.846446160000085, 39.06679922100005],
              [20.84546959700009, 39.06915924700007],
              [20.844899936000047, 39.07086823100008],
              [20.846527540000068, 39.07208893400008],
              [20.84620201900009, 39.07721588700008],
              [20.83765709700009, 39.07831452000005],
              [20.832367384000065, 39.07689036700009],
              [20.82911217500009, 39.07371653900009],
              [20.825694207000083, 39.06976959800005],
              [20.838063998000052, 39.09174225500004],
              [20.834157748000052, 39.10846588700008],
              [20.822438998000052, 39.114488023000035],
              [20.811371290000068, 39.10455963700008],
              [20.80518639400009, 39.111395575000074],
              [20.80128014400009, 39.10419342700004],
              [20.79542076900009, 39.09861888200004],
              [20.787364129000082, 39.09438711100006],
              [20.777191602000073, 39.09088776200008],
              [20.777191602000073, 39.08344147300005],
              [20.791840040000068, 39.08079661700009],
              [20.787933790000068, 39.07245514500005],
              [20.78760826900009, 39.06102122600004],
              [20.784027540000068, 39.049261786000045],
              [20.77670332100007, 39.04193756700005],
              [20.768728061000047, 39.03774648600006],
              [20.761566602000073, 39.032416083000044],
              [20.75749759200005, 39.02195872600004],
              [20.74317467500009, 39.02948639500005],
              [20.74390709700009, 39.01927317900004],
              [20.745371941000087, 39.01471588700008],
              [20.74935957100007, 39.01398346600007],
              [20.75749759200005, 39.01512278900009],
              [20.803884311000047, 38.98529694200005],
              [20.823496941000087, 38.977850653000075],
              [20.829600457000083, 38.970770575000074],
              [20.83179772200009, 38.96369049700007],
              [20.828786655000044, 38.96051666900007],
              [20.82007897200009, 38.962225653000075],
              [20.80209394600007, 38.97064850500004],
              [20.772715691000087, 38.97825755400004],
              [20.766368035000085, 38.97760651200008],
              [20.75749759200005, 38.97418854400007],
              [20.757009311000047, 38.96979401200008],
              [20.746918165000068, 38.95795319200005],
              [20.735118035000085, 38.950100002000056],
              [20.729340040000068, 38.957464911000045],
              [20.72632897200009, 38.966782945000034],
              [20.719086134000065, 38.97357819200005],
              [20.712168816000087, 38.97907135600008],
              [20.708994988000086, 38.984442450000074],
              [20.707855665000068, 38.99038320500006],
              [20.70557701900009, 38.99363841400009],
              [20.703298373000052, 38.995794989000046],
              [20.70215905000009, 38.99835846600007],
              [20.704356316000087, 39.00495026200008],
              [20.709239129000082, 39.008978583000044],
              [20.71387780000009, 39.01190827000005],
              [20.71583092500009, 39.01512278900009],
              [20.705739780000044, 39.04857005400004],
              [20.68653405000009, 39.07245514500005],
              [20.660004102000073, 39.08999258000006],
              [20.627696160000085, 39.10455963700008],
              [20.595876498000052, 39.12384674700007],
              [20.517832879000082, 39.20075104400007],
              [20.488291863000086, 39.21662018400008],
              [20.478851759000065, 39.22516510600008],
              [20.482432488000086, 39.23427969000005],
              [20.477386915000068, 39.243394273000035],
              [20.47510826900009, 39.255072333000044],
              [20.476410352000073, 39.26658763200004],
              [20.482432488000086, 39.27521393400008],
              [20.482432488000086, 39.28266022300005],
              [20.47038821700005, 39.27846914300005],
              [20.460215691000087, 39.27728913000004],
              [20.45281009200005, 39.280462958000044],
              [20.44825280000009, 39.289496161000045],
              [20.433441602000073, 39.282863674000055],
              [20.419200066000087, 39.28335195500006],
              [20.405772332000083, 39.28880442900004],
              [20.39356530000009, 39.296942450000074],
              [20.365570509000065, 39.28766510600008],
              [20.324880405000044, 39.30377838700008],
              [20.292816602000073, 39.33344147300005],
              [20.29070071700005, 39.36465078300006],
              [20.277191602000073, 39.374701239000046],
              [20.269704623000052, 39.38735586100006],
              [20.258962436000047, 39.39728424700007],
              [20.23601321700005, 39.39935944200005],
              [20.23601321700005, 39.40619538000004],
              [20.242849155000044, 39.40619538000004],
              [20.242849155000044, 39.41242096600007],
              [20.234711134000065, 39.420355536000045],
              [20.22364342500009, 39.43585846600007],
              [20.215586785000085, 39.440334377000056],
              [20.232758009000065, 39.444647528000075],
              [20.25359134200005, 39.44415924700007],
              [20.26734459700009, 39.446926174000055],
              [20.263926629000082, 39.46076080900008],
              [20.254242384000065, 39.468817450000074],
              [20.215586785000085, 39.488714911000045],
              [20.215586785000085, 39.49494049700007],
              [20.23292076900009, 39.494208075000074],
              [20.245371941000087, 39.49164459800005],
              [20.255056186000047, 39.49237702000005],
              [20.263926629000082, 39.50177643400008],
              [20.263926629000082, 39.50861237200007],
              [20.25359134200005, 39.51422760600008],
              [20.23601321700005, 39.520819403000075],
              [20.22201582100007, 39.52130768400008],
              [20.22242272200009, 39.50861237200007],
              [20.213633660000085, 39.514960028000075],
              [20.20215905000009, 39.520412502000056],
              [20.190684441000087, 39.52167389500005],
              [20.201914910000085, 39.529730536000045],
              [20.183116082000083, 39.533270575000074],
              [20.16578209700009, 39.53473541900007],
              [20.149587436000047, 39.533636786000045],
              [20.133555535000085, 39.529730536000045],
              [20.141286655000044, 39.53782786700009],
              [20.14551842500009, 39.54706452000005],
              [20.147146030000044, 39.557806708000044],
              [20.146657748000052, 39.57070547100005],
              [20.15406334700009, 39.56391022300005],
              [20.160899285000085, 39.56435781500005],
              [20.16765384200005, 39.569525458000044],
              [20.174571160000085, 39.57684967700004],
              [20.174978061000047, 39.58026764500005],
              [20.174164259000065, 39.59320709800005],
              [20.174571160000085, 39.59796784100007],
              [20.176524285000085, 39.59861888200004],
              [20.18604576900009, 39.60382721600007],
              [20.188243035000085, 39.60419342700004],
              [20.181813998000052, 39.62445709800005],
              [20.165212436000047, 39.63361237200007],
              [20.14820397200009, 39.63751862200007],
              [20.14039147200009, 39.64240143400008],
              [20.137054884000065, 39.646551825000074],
              [20.121348504000082, 39.65680573100008],
              [20.11622155000009, 39.65884023600006],
              [20.10482832100007, 39.66107819200005],
              [20.096527540000068, 39.66596100500004],
              [20.08887780000009, 39.673081773000035],
              [20.04460696700005, 39.680894273000035],
              [20.021657748000052, 39.68768952000005],
              [20.010020379000082, 39.69354889500005],
              [20.00440514400009, 39.69277578300006],
              [19.999847852000073, 39.69350820500006],
              [20.016069784000052, 39.70140208000002],
              [20.049556111000072, 39.69272043800005],
              [20.08934696400007, 39.682798564000066],
              [20.135235636000033, 39.66419504800011],
              [20.163761027000078, 39.644299622000105],
              [20.18412154100011, 39.637013245000034],
              [20.19993453000012, 39.64006215400006],
              [20.203448527000063, 39.64533315100009],
              [20.203035116000052, 39.652619527000056],
              [20.20417199700006, 39.66031931600007],
              [20.212026815000115, 39.66703725200007],
              [20.220088338000096, 39.669155986000064],
              [20.228563273000105, 39.669155986000064],
              [20.237244914000144, 39.66703725200007],
              [20.246029907000036, 39.66290313700007],
              [20.249027140000067, 39.68481394400003],
              [20.264116658000148, 39.696079407000084],
              [20.282720174000104, 39.704399312000035],
              [20.296466105000064, 39.71737009700006],
              [20.299463339000056, 39.728222148],
              [20.296466105000064, 39.733493144000036],
              [20.2910917560001, 39.73793731700006],
              [20.287267700000143, 39.74667063400001],
              [20.285510701000078, 39.74966786800003],
              [20.278172648000066, 39.756747538000056],
              [20.27569217900009, 39.760054830000044],
              [20.276829061000115, 39.76315541600009],
              [20.283133586000133, 39.77514434800007],
              [20.28468387800004, 39.78031199200005],
              [20.28137658700004, 39.78816680900009],
              [20.27548547400005, 39.792404277000045],
              [20.273005005000073, 39.79648671500006],
              [20.28003299900007, 39.80397979700008],
              [20.288404581000066, 39.80661529600009],
              [20.298326457000144, 39.805426737000076],
              [20.299576529000092, 39.805056407000095],
              [20.33687707600012, 39.79400624600008],
              [20.35455041500012, 39.78578969300004],
              [20.371603637000078, 39.78429107700005],
              [20.38896691900007, 39.79814036100002],
              [20.397028442000078, 39.818087463000026],
              [20.392997680000065, 39.835450745000045],
              [20.346902303000064, 39.89425852500001],
              [20.323131144000087, 39.91239695200004],
              [20.317963501000094, 39.91839141900009],
              [20.302977335000037, 39.979111227000075],
              [20.297913045000143, 39.986914368],
              [20.31000533000011, 39.98985992500009],
              [20.359924764000084, 39.99104848200001],
              [20.376461222000074, 39.993735657000045],
              [20.380698690000116, 40.011667379000116],
              [20.38907027200011, 40.02944407200006],
              [20.40043908700011, 40.045257060000054],
              [20.413771606000125, 40.05719431600009],
              [20.432788533000092, 40.063808899],
              [20.465964803000105, 40.06081166600008],
              [20.481674439000074, 40.067787985000066],
              [20.499864543000115, 40.07145701100008],
              [20.552884562000116, 40.06541086900002],
              [20.577792602000073, 40.06727122000002],
              [20.615361181000083, 40.08101733900007],
              [20.640217733000043, 40.09011220300003],
              [20.647555786000055, 40.09403961200009],
              [20.651793254000097, 40.101015931000106],
              [20.66677941900008, 40.133520406000045],
              [20.668226359000073, 40.13806793300007],
              [20.663472127000148, 40.15661977200001],
              [20.663162068000076, 40.16168406200008],
              [20.659854777000078, 40.17274281800009],
              [20.66037154100013, 40.178892314000066],
              [20.6650224200001, 40.184370016000045],
              [20.6798018800001, 40.187832337000074],
              [20.685279582000078, 40.19119130500009],
              [20.696441691000132, 40.215065817],
              [20.696648397000075, 40.23558136000007],
              [20.69458133900011, 40.25558013900009],
              [20.699128866000137, 40.27836944600007],
              [20.70698368400008, 40.288084616000035],
              [20.717835734000033, 40.293924052000094],
              [20.728791138000105, 40.29826487300009],
              [20.736645955000142, 40.30363922100004],
              [20.739552404000108, 40.309166372000035],
              [20.75504276500004, 40.33862416600006],
              [20.765998168000124, 40.35428212500001],
              [20.770442342000138, 40.36255035400005],
              [20.773852987000055, 40.37490102200012],
              [20.773336223000115, 40.38533966100006],
              [20.768995402000144, 40.41257314000005],
              [20.77064904800008, 40.421978251],
              [20.7795373940001, 40.4290062460001],
              [20.80031132000005, 40.43277862600003],
              [20.80919966600007, 40.43660268200007],
              [20.81736454300008, 40.44683461500007],
              [20.82129195100015, 40.45639475600005],
              [20.826666301000103, 40.464818014000045],
              [20.83999882000012, 40.47163930300009],
              [20.8667672120001, 40.4720527140001],
              [20.889608195000108, 40.463732809000064],
              [20.911932413000073, 40.459547018000094],
              [20.93684045400005, 40.47251780200004],
              [20.946452270000066, 40.48290476500007],
              [20.949759562000054, 40.48786570200009],
              [20.95265344200004, 40.493653463000086],
              [20.951929973000034, 40.50605580700004],
              [20.957924439000067, 40.51494415300006],
              [20.968569783000078, 40.520576884],
              [20.981488891000083, 40.52326405800004],
              [20.988310181000116, 40.5334959930001],
              [20.99750858500002, 40.539180399000045],
              [21.00670699000011, 40.54321116200005],
              [21.013528280000088, 40.548895570000084],
              [21.01879927600001, 40.558972473000026],
              [21.020349568000114, 40.566775614000036],
              [21.020762980000143, 40.57509552100002],
              [21.022519979000037, 40.58661936500003],
              [21.033165324, 40.621397604],
              [21.036679321000065, 40.63974273700008],
              [21.035335734000114, 40.65937978100003],
              [21.028824503000124, 40.67684641600006],
              [21.018592570000067, 40.690902405000074],
              [20.992030884000144, 40.71550038700006],
              [20.9635054930001, 40.73606760700004],
              [20.959164673000117, 40.74356068900009],
              [20.95720096800008, 40.75162221300006],
              [20.953480265000053, 40.75916697200002],
              [20.943661743000092, 40.765264791000064],
              [20.96092167100008, 40.78076772100009],
              [20.96701949000004, 40.802006734000074],
              [20.96526249200008, 40.849394023000045],
            ],
          ],
          [
            [
              [24.128428582000083, 34.85529205900008],
              [24.122325066000087, 34.84650299700007],
              [24.121429884000065, 34.83612702000005],
              [24.125743035000085, 34.82689036700009],
              [24.13526451900009, 34.82176341400009],
              [24.13526451900009, 34.81500885600008],
              [24.108571811000047, 34.81655508000006],
              [24.086110873000052, 34.82632070500006],
              [24.046397332000083, 34.84906647300005],
              [24.046397332000083, 34.85529205900008],
              [24.057871941000087, 34.85541413000004],
              [24.06690514400009, 34.85846588700008],
              [24.074392123000052, 34.86343008000006],
              [24.08057701900009, 34.86896393400008],
              [24.09310957100007, 34.86953359600005],
              [24.10515384200005, 34.868068752000056],
              [24.128428582000083, 34.86273834800005],
              [24.128428582000083, 34.85529205900008],
            ],
          ],
          [
            [
              [26.976084832000083, 35.431341864000046],
              [27.00245201900009, 35.43695709800005],
              [27.011973504000082, 35.43768952000005],
              [27.01335696700005, 35.431341864000046],
              [27.007090691000087, 35.427435614000046],
              [26.99968509200005, 35.42450592700004],
              [27.007090691000087, 35.403998114000046],
              [27.007090691000087, 35.397772528000075],
              [26.992360873000052, 35.39720286700009],
              [26.967946811000047, 35.39337799700007],
              [26.95875084700009, 35.390326239000046],
              [26.946055535000085, 35.38353099200009],
              [26.937022332000083, 35.376939195000034],
              [26.927744988000086, 35.37189362200007],
              [26.914724155000044, 35.36985911700009],
              [26.905772332000083, 35.36664459800005],
              [26.88835696700005, 35.35268789300005],
              [26.87671959700009, 35.34935130400004],
              [26.86426842500009, 35.353583075000074],
              [26.853770379000082, 35.362982489000046],
              [26.848399285000085, 35.372381903000075],
              [26.851898634000065, 35.37669505400004],
              [26.861664259000065, 35.380926825000074],
              [26.87940514400009, 35.399725653000075],
              [26.886566602000073, 35.403998114000046],
              [26.890147332000083, 35.40717194200005],
              [26.896739129000082, 35.42133209800005],
              [26.900238477000073, 35.42450592700004],
              [26.908539259000065, 35.42324453300006],
              [26.919769727000073, 35.41828034100007],
              [26.924571160000085, 35.417669989000046],
              [26.96070397200009, 35.42959219000005],
              [26.976084832000083, 35.431341864000046],
            ],
          ],
          [
            [
              [26.321136915000068, 35.31525299700007],
              [26.312347852000073, 35.296942450000074],
              [26.29786217500009, 35.28489817900004],
              [26.28101647200009, 35.274318752000056],
              [26.265961134000065, 35.25999583500004],
              [26.283864780000044, 35.208238023000035],
              [26.299489780000044, 35.185532945000034],
              [26.321136915000068, 35.19794342700004],
              [26.311778191000087, 35.18235911700009],
              [26.29542076900009, 35.16632721600007],
              [26.285004102000073, 35.15070221600007],
              [26.29395592500009, 35.13646067900004],
              [26.28687584700009, 35.11823151200008],
              [26.277517123000052, 35.100043036000045],
              [26.266856316000087, 35.08388906500005],
              [26.256114129000082, 35.071600653000075],
              [26.25098717500009, 35.06305573100008],
              [26.240977410000085, 35.039048570000034],
              [26.23536217500009, 35.034084377000056],
              [26.223806186000047, 35.03237539300005],
              [26.21387780000009, 35.028225002000056],
              [26.205088738000086, 35.023504950000074],
              [26.147227410000085, 35.00226471600007],
              [26.132985873000052, 34.999335028000075],
              [26.10523522200009, 34.999335028000075],
              [26.103688998000052, 35.00214264500005],
              [26.089121941000087, 35.01552969000005],
              [26.08171634200005, 35.01976146000004],
              [26.05795332100007, 35.02289459800005],
              [26.03809655000009, 35.020819403000075],
              [26.020274285000085, 35.02094147300005],
              [26.002207879000082, 35.03066640800006],
              [25.99317467500009, 35.03705475500004],
              [25.98487389400009, 35.039129950000074],
              [25.976735873000052, 35.03693268400008],
              [25.968028191000087, 35.03066640800006],
              [25.96029707100007, 35.028957424000055],
              [25.924082879000082, 35.034084377000056],
              [25.881521030000044, 35.02708567900004],
              [25.808116082000083, 35.00576406500005],
              [25.60124759200005, 35.01357656500005],
              [25.53809655000009, 34.99701569200005],
              [25.522715691000087, 34.98940664300005],
              [25.506195509000065, 34.98456452000005],
              [25.415212436000047, 34.99371979400007],
              [25.347666863000086, 34.991522528000075],
              [25.328461134000065, 34.98725006700005],
              [25.303965691000087, 34.98476797100005],
              [25.294769727000073, 34.98094310100004],
              [25.27979576900009, 34.97260163000004],
              [25.22315514400009, 34.95416901200008],
              [25.207692905000044, 34.95148346600007],
              [25.15088951900009, 34.95571523600006],
              [25.128916863000086, 34.95148346600007],
              [25.12273196700005, 34.94818756700005],
              [25.114512566000087, 34.94017161700009],
              [25.107758009000065, 34.93789297100005],
              [25.09742272200009, 34.93789297100005],
              [25.090993686000047, 34.94037506700005],
              [25.08529707100007, 34.94330475500004],
              [25.077403191000087, 34.94472890800006],
              [25.059743686000047, 34.94358958500004],
              [25.044932488000086, 34.940741278000075],
              [25.019053582000083, 34.931626695000034],
              [25.003184441000087, 34.93695709800005],
              [24.98373457100007, 34.938706773000035],
              [24.738536004000082, 34.931626695000034],
              [24.738536004000082, 34.93789297100005],
              [24.75171959700009, 34.946478583000044],
              [24.75521894600007, 34.957912502000056],
              [24.752126498000052, 34.99591705900008],
              [24.753916863000086, 35.00804271000004],
              [24.759938998000052, 35.027329820000034],
              [24.758962436000047, 35.04148997600004],
              [24.755869988000086, 35.05145905200004],
              [24.750173373000052, 35.06513092700004],
              [24.742849155000044, 35.07721588700008],
              [24.735118035000085, 35.082464911000045],
              [24.729746941000087, 35.08466217700004],
              [24.724782748000052, 35.08930084800005],
              [24.71810957100007, 35.09398021000004],
              [24.70753014400009, 35.096136786000045],
              [24.618988477000073, 35.09739817900004],
              [24.59473717500009, 35.10150788000004],
              [24.580251498000052, 35.10919830900008],
              [24.57398522200009, 35.10919830900008],
              [24.564626498000052, 35.10614655200004],
              [24.553396030000044, 35.114569403000075],
              [24.532399936000047, 35.13646067900004],
              [24.519053582000083, 35.14443594000005],
              [24.500743035000085, 35.152411200000074],
              [24.481211785000085, 35.155910549000055],
              [24.464121941000087, 35.15013255400004],
              [24.403819207000083, 35.175034898000035],
              [24.40211022200009, 35.184881903000075],
              [24.40211022200009, 35.191107489000046],
              [24.293223504000082, 35.18227773600006],
              [24.21778405000009, 35.191107489000046],
              [24.21338951900009, 35.19383372600004],
              [24.208506707000083, 35.19879791900007],
              [24.204925977000073, 35.20343659100007],
              [24.203949415000068, 35.20538971600007],
              [24.197276238000086, 35.205145575000074],
              [24.19190514400009, 35.202460028000075],
              [24.187510613000086, 35.19940827000005],
              [24.18295332100007, 35.19794342700004],
              [24.111338738000086, 35.19794342700004],
              [24.094004754000082, 35.20465729400007],
              [24.084646030000044, 35.20453522300005],
              [24.08057701900009, 35.194525458000044],
              [24.076426629000082, 35.19546133000006],
              [24.04981530000009, 35.191107489000046],
              [24.031423373000052, 35.197699286000045],
              [24.00326582100007, 35.22671133000006],
              [23.98764082100007, 35.233303127000056],
              [23.901866082000083, 35.23118724200009],
              [23.860199415000068, 35.236314195000034],
              [23.82667076900009, 35.25259023600006],
              [23.818369988000086, 35.247300523000035],
              [23.81226647200009, 35.24477773600006],
              [23.806488477000073, 35.244574286000045],
              [23.799489780000044, 35.24632396000004],
              [23.782074415000068, 35.23468659100007],
              [23.711680535000085, 35.23672109600005],
              [23.68336022200009, 35.225816148000035],
              [23.669118686000047, 35.23729075700004],
              [23.610524936000047, 35.23493073100008],
              [23.587168816000087, 35.239488023000035],
              [23.582286004000082, 35.24518463700008],
              [23.58448326900009, 35.25429922100005],
              [23.580332879000082, 35.25999583500004],
              [23.573008660000085, 35.26341380400004],
              [23.559418165000068, 35.26459381700005],
              [23.552989129000082, 35.266831773000035],
              [23.544932488000086, 35.27383047100005],
              [23.538584832000083, 35.28143952000005],
              [23.53101647200009, 35.28847890800006],
              [23.518239780000044, 35.294134833000044],
              [23.525645379000082, 35.30097077000005],
              [23.521657748000052, 35.30170319200005],
              [23.51929772200009, 35.30174388200004],
              [23.518321160000085, 35.303168036000045],
              [23.518239780000044, 35.30776601800005],
              [23.53288821700005, 35.31403229400007],
              [23.538910352000073, 35.31517161700009],
              [23.546153191000087, 35.31525299700007],
              [23.54737389400009, 35.31818268400008],
              [23.547211134000065, 35.32025788000004],
              [23.54818769600007, 35.321478583000044],
              [23.552989129000082, 35.321478583000044],
              [23.546722852000073, 35.32876211100006],
              [23.541840040000068, 35.336371161000045],
              [23.54078209700009, 35.34516022300005],
              [23.546153191000087, 35.35618724200009],
              [23.538584832000083, 35.37409088700008],
              [23.54932701900009, 35.396918036000045],
              [23.565196160000085, 35.41909414300005],
              [23.573496941000087, 35.434759833000044],
              [23.571462436000047, 35.441107489000046],
              [23.566661004000082, 35.44745514500005],
              [23.562022332000083, 35.45172760600008],
              [23.559825066000087, 35.45180898600006],
              [23.560883009000065, 35.45840078300006],
              [23.570974155000044, 35.483710028000075],
              [23.577647332000083, 35.49290599200009],
              [23.578461134000065, 35.50055573100008],
              [23.56609134200005, 35.507025458000044],
              [23.56609134200005, 35.51325104400007],
              [23.571055535000085, 35.51813385600008],
              [23.572601759000065, 35.52045319200005],
              [23.571055535000085, 35.522691148000035],
              [23.56609134200005, 35.52749258000006],
              [23.581228061000047, 35.55267975500004],
              [23.58448326900009, 35.564520575000074],
              [23.580332879000082, 35.57591380400004],
              [23.600433790000068, 35.60309479400007],
              [23.604746941000087, 35.612616278000075],
              [23.607676629000082, 35.59247467700004],
              [23.608164910000085, 35.55170319200005],
              [23.614431186000047, 35.534369208000044],
              [23.619883660000085, 35.52407461100006],
              [23.623708530000044, 35.521470445000034],
              [23.631683790000068, 35.520697333000044],
              [23.639496290000068, 35.51898834800005],
              [23.64039147200009, 35.51508209800005],
              [23.639496290000068, 35.51056549700007],
              [23.641774936000047, 35.507025458000044],
              [23.650401238000086, 35.503566799000055],
              [23.659434441000087, 35.501206773000035],
              [23.68336022200009, 35.49957916900007],
              [23.702972852000073, 35.50287506700005],
              [23.71843509200005, 35.51284414300005],
              [23.72787519600007, 35.52985260600008],
              [23.730479363000086, 35.55418528900009],
              [23.724864129000082, 35.57363515800006],
              [23.716075066000087, 35.59194570500006],
              [23.712738477000073, 35.60700104400007],
              [23.72364342500009, 35.616888739000046],
              [23.71387780000009, 35.634833075000074],
              [23.711192254000082, 35.648871161000045],
              [23.71583092500009, 35.66152578300006],
              [23.72706139400009, 35.67495351800005],
              [23.74154707100007, 35.68695709800005],
              [23.750010613000086, 35.68659088700008],
              [23.759776238000086, 35.67942942900004],
              [23.77898196700005, 35.671535549000055],
              [23.77898196700005, 35.664048570000034],
              [23.767832879000082, 35.65387604400007],
              [23.76807701900009, 35.641058661000045],
              [23.77898196700005, 35.609442450000074],
              [23.777679884000065, 35.58372630400004],
              [23.77898196700005, 35.57591380400004],
              [23.799489780000044, 35.544623114000046],
              [23.817149285000085, 35.534816799000055],
              [23.90137780000009, 35.52716705900008],
              [23.92904707100007, 35.520697333000044],
              [23.944183790000068, 35.52496979400007],
              [24.00049889400009, 35.51992422100005],
              [24.025401238000086, 35.520697333000044],
              [24.035817905000044, 35.523423570000034],
              [24.04468834700009, 35.52765534100007],
              [24.050954623000052, 35.534369208000044],
              [24.05323326900009, 35.544623114000046],
              [24.05762780000009, 35.55292389500005],
              [24.068369988000086, 35.55548737200007],
              [24.094086134000065, 35.55418528900009],
              [24.08179772200009, 35.589911200000074],
              [24.115244988000086, 35.60130442900004],
              [24.160411004000082, 35.59707265800006],
              [24.18295332100007, 35.585598049000055],
              [24.203298373000052, 35.54181549700007],
              [24.20053144600007, 35.534369208000044],
              [24.19581139400009, 35.53156159100007],
              [24.187754754000082, 35.51805247600004],
              [24.18295332100007, 35.51325104400007],
              [24.17359459700009, 35.50958893400008],
              [24.16374759200005, 35.50775788000004],
              [24.142588738000086, 35.507025458000044],
              [24.103526238000086, 35.51398346600007],
              [24.081228061000047, 35.514960028000075],
              [24.06690514400009, 35.507025458000044],
              [24.07195071700005, 35.49835846600007],
              [24.089040561000047, 35.48920319200005],
              [24.107758009000065, 35.48200104400007],
              [24.13721764400009, 35.47483958500004],
              [24.170176629000082, 35.45604075700004],
              [24.186696811000047, 35.45180898600006],
              [24.204356316000087, 35.454413153000075],
              [24.222504102000073, 35.46116771000004],
              [24.239105665000068, 35.470038153000075],
              [24.25245201900009, 35.47907135600008],
              [24.264008009000065, 35.43317291900007],
              [24.265472852000073, 35.41425202000005],
              [24.26343834700009, 35.37848541900007],
              [24.265472852000073, 35.36985911700009],
              [24.27312259200005, 35.364894924000055],
              [24.29346764400009, 35.36375560100004],
              [24.302989129000082, 35.35932038000004],
              [24.340098504000082, 35.34833405200004],
              [24.428070509000065, 35.36969635600008],
              [24.464121941000087, 35.36245351800005],
              [24.48536217500009, 35.37213776200008],
              [24.566661004000082, 35.38418203300006],
              [24.593597852000073, 35.39118073100008],
              [24.65593509200005, 35.417669989000046],
              [24.676931186000047, 35.423488674000055],
              [24.698496941000087, 35.42682526200008],
              [24.720957879000082, 35.42723216400009],
              [24.820160352000073, 35.41303131700005],
              [24.84083092500009, 35.403998114000046],
              [24.850352410000085, 35.40973541900007],
              [24.867198113000086, 35.41648997600004],
              [24.89551842500009, 35.42450592700004],
              [24.95753014400009, 35.403998114000046],
              [24.96338951900009, 35.410223700000074],
              [24.967133009000065, 35.412543036000045],
              [24.969574415000068, 35.41575755400004],
              [24.97120201900009, 35.42450592700004],
              [25.018728061000047, 35.41502513200004],
              [25.029633009000065, 35.40326569200005],
              [25.04737389400009, 35.405503648000035],
              [25.05323326900009, 35.403998114000046],
              [25.054535352000073, 35.39740631700005],
              [25.052256707000083, 35.39199453300006],
              [25.048675977000073, 35.38666413000004],
              [25.047048373000052, 35.38043854400007],
              [25.055349155000044, 35.35521067900004],
              [25.076996290000068, 35.34446849200009],
              [25.10678144600007, 35.34247467700004],
              [25.153168165000068, 35.34471263200004],
              [25.181651238000086, 35.35008372600004],
              [25.197113477000073, 35.34935130400004],
              [25.20053144600007, 35.346909898000035],
              [25.205332879000082, 35.34227122600004],
              [25.212087436000047, 35.33779531500005],
              [25.221364780000044, 35.33567942900004],
              [25.251800977000073, 35.33567942900004],
              [25.306976759000065, 35.34316640800006],
              [25.33171634200005, 35.33685944200005],
              [25.346364780000044, 35.33608633000006],
              [25.361664259000065, 35.34316640800006],
              [25.36850019600007, 35.33567942900004],
              [25.37598717500009, 35.34316640800006],
              [25.39421634200005, 35.32880280200004],
              [25.408050977000073, 35.31268952000005],
              [25.425303582000083, 35.29954661700009],
              [25.45362389400009, 35.294134833000044],
              [25.481944207000083, 35.29743073100008],
              [25.638845248000052, 35.34589264500005],
              [25.65992272200009, 35.34935130400004],
              [25.671397332000083, 35.34723541900007],
              [25.692556186000047, 35.33783600500004],
              [25.707774285000085, 35.33567942900004],
              [25.766368035000085, 35.33567942900004],
              [25.75912519600007, 35.32208893400008],
              [25.74773196700005, 35.310614325000074],
              [25.724782748000052, 35.294134833000044],
              [25.73218834700009, 35.28790924700007],
              [25.726084832000083, 35.27875397300005],
              [25.72510826900009, 35.270819403000075],
              [25.729258660000085, 35.264553127000056],
              [25.739024285000085, 35.25999583500004],
              [25.737803582000083, 35.277411200000074],
              [25.742849155000044, 35.28534577000005],
              [25.75098717500009, 35.28412506700005],
              [25.758962436000047, 35.274318752000056],
              [25.75367272200009, 35.26748281500005],
              [25.75367272200009, 35.264105536000045],
              [25.758962436000047, 35.25999583500004],
              [25.75326582100007, 35.25259023600006],
              [25.748220248000052, 35.25608958500004],
              [25.74463951900009, 35.257147528000075],
              [25.74000084700009, 35.25438060100004],
              [25.73218834700009, 35.24632396000004],
              [25.735118035000085, 35.237494208000044],
              [25.726817254000082, 35.226263739000046],
              [25.719493035000085, 35.211371161000045],
              [25.724782748000052, 35.191107489000046],
              [25.712738477000073, 35.182847398000035],
              [25.714121941000087, 35.17397695500006],
              [25.720713738000086, 35.16429271000004],
              [25.724782748000052, 35.153550523000035],
              [25.728526238000086, 35.13336823100008],
              [25.73878014400009, 35.13100820500006],
              [25.753184441000087, 35.13312409100007],
              [25.769786004000082, 35.12653229400007],
              [25.78288821700005, 35.11798737200007],
              [25.795258009000065, 35.11513906500005],
              [25.817637566000087, 35.11595286700009],
              [25.830332879000082, 35.122381903000075],
              [25.847666863000086, 35.15058014500005],
              [25.85914147200009, 35.15696849200009],
              [25.867523634000065, 35.157416083000044],
              [25.873301629000082, 35.15867747600004],
              [25.883067254000082, 35.16445547100005],
              [25.89551842500009, 35.18211497600004],
              [25.896657748000052, 35.184881903000075],
              [25.908539259000065, 35.18740469000005],
              [25.94117272200009, 35.189154364000046],
              [25.978526238000086, 35.19546133000006],
              [25.98536217500009, 35.19794342700004],
              [26.01661217500009, 35.214544989000046],
              [26.02588951900009, 35.221909898000035],
              [26.033213738000086, 35.225816148000035],
              [26.04273522200009, 35.227769273000035],
              [26.049489780000044, 35.22675202000005],
              [26.055023634000065, 35.22711823100008],
              [26.060557488000086, 35.233303127000056],
              [26.06739342500009, 35.233303127000056],
              [26.08139082100007, 35.22357819200005],
              [26.11963951900009, 35.21531810100004],
              [26.108246290000068, 35.20538971600007],
              [26.129730665000068, 35.19586823100008],
              [26.155121290000068, 35.19794342700004],
              [26.17945397200009, 35.20718008000006],
              [26.19776451900009, 35.21906159100007],
              [26.192637566000087, 35.22093333500004],
              [26.192637566000087, 35.22207265800006],
              [26.190928582000083, 35.225816148000035],
              [26.21843509200005, 35.24713776200008],
              [26.237803582000083, 35.268784898000035],
              [26.25953209700009, 35.284491278000075],
              [26.29395592500009, 35.28790924700007],
              [26.28646894600007, 35.30097077000005],
              [26.297211134000065, 35.30060455900008],
              [26.300791863000086, 35.30097077000005],
              [26.29859459700009, 35.304388739000046],
              [26.296071811000047, 35.311712958000044],
              [26.29395592500009, 35.31525299700007],
              [26.321136915000068, 35.31525299700007],
            ],
          ],
          [
            [
              [27.21192467500009, 35.520697333000044],
              [27.233164910000085, 35.50409577000005],
              [27.23731530000009, 35.493394273000035],
              [27.232432488000086, 35.47223541900007],
              [27.20679772200009, 35.47752513200004],
              [27.180918816000087, 35.46893952000005],
              [27.161631707000083, 35.450100002000056],
              [27.15674889400009, 35.42450592700004],
              [27.158946160000085, 35.427435614000046],
              [27.160817905000044, 35.43036530200004],
              [27.164235873000052, 35.432074286000045],
              [27.171071811000047, 35.431341864000046],
              [27.165863477000073, 35.42332591400009],
              [27.158050977000073, 35.41559479400007],
              [27.14812259200005, 35.40888092700004],
              [27.136241082000083, 35.403998114000046],
              [27.14307701900009, 35.42039622600004],
              [27.13526451900009, 35.426214911000045],
              [27.121104363000086, 35.42767975500004],
              [27.108897332000083, 35.431341864000046],
              [27.099782748000052, 35.44049713700008],
              [27.093028191000087, 35.45184967700004],
              [27.09424889400009, 35.46157461100006],
              [27.108897332000083, 35.466050523000035],
              [27.108897332000083, 35.47223541900007],
              [27.10206139400009, 35.47223541900007],
              [27.10206139400009, 35.47907135600008],
              [27.11882571700005, 35.48265208500004],
              [27.119802280000044, 35.49310944200005],
              [27.108897332000083, 35.520697333000044],
              [27.109629754000082, 35.53489817900004],
              [27.11264082100007, 35.54360586100006],
              [27.11378014400009, 35.55097077000005],
              [27.108897332000083, 35.56167226800005],
              [27.100840691000087, 35.56708405200004],
              [27.074880405000044, 35.58022695500006],
              [27.067881707000083, 35.58893463700008],
              [27.06934655000009, 35.60224030200004],
              [27.07667076900009, 35.61579010600008],
              [27.08570397200009, 35.626288153000075],
              [27.091807488000086, 35.630560614000046],
              [27.115407748000052, 35.642238674000055],
              [27.123708530000044, 35.66779205900008],
              [27.12794030000009, 35.693345445000034],
              [27.154144727000073, 35.717962958000044],
              [27.16179446700005, 35.74689362200007],
              [27.162445509000065, 35.77728913000004],
              [27.15674889400009, 35.79437897300005],
              [27.15674889400009, 35.801214911000045],
              [27.171071811000047, 35.808661200000074],
              [27.177744988000086, 35.808661200000074],
              [27.177744988000086, 35.801214911000045],
              [27.18458092500009, 35.801214911000045],
              [27.190114780000044, 35.807074286000045],
              [27.205088738000086, 35.822333075000074],
              [27.213715040000068, 35.82802969000005],
              [27.220957879000082, 35.82925039300005],
              [27.226898634000065, 35.82709381700005],
              [27.232432488000086, 35.822333075000074],
              [27.228851759000065, 35.80898672100005],
              [27.215017123000052, 35.79002513200004],
              [27.21192467500009, 35.777329820000034],
              [27.21192467500009, 35.75340403900009],
              [27.213226759000065, 35.74477773600006],
              [27.21851647200009, 35.73468659100007],
              [27.218760613000086, 35.72614166900007],
              [27.212901238000086, 35.718736070000034],
              [27.201345248000052, 35.709418036000045],
              [27.189789259000065, 35.69741445500006],
              [27.18458092500009, 35.68178945500006],
              [27.180349155000044, 35.67291901200008],
              [27.170664910000085, 35.66356028900009],
              [27.160980665000068, 35.65131256700005],
              [27.15674889400009, 35.633978583000044],
              [27.156504754000082, 35.618801174000055],
              [27.158539259000065, 35.61204661700009],
              [27.18458092500009, 35.595770575000074],
              [27.20875084700009, 35.56004466400009],
              [27.21534264400009, 35.55418528900009],
              [27.220876498000052, 35.55101146000004],
              [27.21648196700005, 35.54401276200008],
              [27.208994988000086, 35.537095445000034],
              [27.205088738000086, 35.534369208000044],
              [27.204356316000087, 35.52765534100007],
              [27.203786655000044, 35.52716705900008],
              [27.205414259000065, 35.52684153900009],
              [27.21192467500009, 35.520697333000044],
            ],
          ],
          [
            [
              [23.278005405000044, 35.89744700700004],
              [23.29590905000009, 35.885972398000035],
              [23.31576582100007, 35.87954336100006],
              [23.330739780000044, 35.864935614000046],
              [23.333262566000087, 35.82916901200008],
              [23.326426629000082, 35.82916901200008],
              [23.320567254000082, 35.83852773600006],
              [23.295664910000085, 35.85956452000005],
              [23.287364129000082, 35.87055084800005],
              [23.28093509200005, 35.882473049000055],
              [23.271739129000082, 35.90424225500004],
              [23.276052280000044, 35.90468984600005],
              [23.277191602000073, 35.90326569200005],
              [23.277191602000073, 35.90062083500004],
              [23.278005405000044, 35.89744700700004],
            ],
          ],
          [
            [
              [23.011729363000086, 36.308294989000046],
              [23.076914910000085, 36.270738023000035],
              [23.094411655000044, 36.254339911000045],
              [23.103851759000065, 36.237209377000056],
              [23.097829623000052, 36.23297760600008],
              [23.082855665000068, 36.232489325000074],
              [23.066254102000073, 36.22638580900008],
              [23.058441602000073, 36.216457424000055],
              [23.05445397200009, 36.20335521000004],
              [23.052012566000087, 36.14484284100007],
              [23.046885613000086, 36.14321523600006],
              [23.03223717500009, 36.14447663000004],
              [23.014414910000085, 36.14834219000005],
              [23.00245201900009, 36.14663320500006],
              [22.99073326900009, 36.13703034100007],
              [22.987559441000087, 36.151556708000044],
              [22.977224155000044, 36.15794505400004],
              [22.949554884000065, 36.16498444200005],
              [22.948415561000047, 36.168036200000074],
              [22.949554884000065, 36.17234935100004],
              [22.950043165000068, 36.17625560100004],
              [22.946136915000068, 36.17796458500004],
              [22.932302280000044, 36.17723216400009],
              [22.929209832000083, 36.17796458500004],
              [22.924001498000052, 36.18439362200007],
              [22.91456139400009, 36.200506903000075],
              [22.90870201900009, 36.205959377000056],
              [22.91732832100007, 36.262152411000045],
              [22.916188998000052, 36.28510163000004],
              [22.90870201900009, 36.308294989000046],
              [22.903005405000044, 36.31932200700004],
              [22.899668816000087, 36.328192450000074],
              [22.901621941000087, 36.338324286000045],
              [22.93262780000009, 36.38125234600005],
              [22.944590691000087, 36.38939036700009],
              [22.95639082100007, 36.38344961100006],
              [22.996267123000052, 36.32416413000004],
              [23.011729363000086, 36.308294989000046],
            ],
          ],
          [
            [
              [25.735606316000087, 36.38344961100006],
              [25.749522332000083, 36.38768138200004],
              [25.758962436000047, 36.39598216400009],
              [25.767832879000082, 36.401597398000035],
              [25.802989129000082, 36.38959381700005],
              [25.835459832000083, 36.36615631700005],
              [25.85515384200005, 36.36359284100007],
              [25.846853061000047, 36.35028717700004],
              [25.838063998000052, 36.35179271000004],
              [25.828461134000065, 36.35919830900008],
              [25.817637566000087, 36.36359284100007],
              [25.80176842500009, 36.36123281500005],
              [25.789805535000085, 36.35659414300005],
              [25.776866082000083, 36.35382721600007],
              [25.75098717500009, 36.35822174700007],
              [25.746429884000065, 36.35797760600008],
              [25.743337436000047, 36.35883209800005],
              [25.73682701900009, 36.36615631700005],
              [25.732432488000086, 36.373032945000034],
              [25.73023522200009, 36.380113023000035],
              [25.735606316000087, 36.38344961100006],
            ],
          ],
          [
            [
              [28.239756707000083, 36.432521877000056],
              [28.225840691000087, 36.417954820000034],
              [28.236338738000086, 36.373032945000034],
              [28.215830925000034, 36.36359284100007],
              [28.211192254000082, 36.35765208500004],
              [28.205088738000086, 36.32265859600005],
              [28.197438998000052, 36.31195709800005],
              [28.17546634200005, 36.29043203300006],
              [28.170909050000034, 36.27798086100006],
              [28.16846764400009, 36.24982330900008],
              [28.16342207100007, 36.23769765800006],
              [28.154551629000082, 36.23261139500005],
              [28.148448113000086, 36.22606028900009],
              [28.135915561000047, 36.19521719000005],
              [28.13054446700005, 36.18545156500005],
              [28.127696160000085, 36.18646881700005],
              [28.110036655000044, 36.18659088700008],
              [28.10328209700009, 36.18545156500005],
              [28.10092207100007, 36.18138255400004],
              [28.099131707000083, 36.17446523600006],
              [28.095225457000083, 36.16787344000005],
              [28.085785352000073, 36.16498444200005],
              [28.061696811000047, 36.116522528000075],
              [28.07081139400009, 36.111029364000046],
              [28.078786655000044, 36.107407945000034],
              [28.086680535000085, 36.105129299000055],
              [28.096446160000085, 36.103501695000034],
              [28.093760613000086, 36.09528229400007],
              [28.089854363000086, 36.08828359600005],
              [28.08375084700009, 36.08193594000005],
              [28.07593834700009, 36.07558828300006],
              [28.080088738000086, 36.07135651200008],
              [28.08961022200009, 36.055121161000045],
              [28.03760826900009, 36.068426825000074],
              [28.01693769600007, 36.06899648600006],
              [27.993418816000087, 36.06195709800005],
              [27.948415561000047, 36.03900788000004],
              [27.932302280000044, 36.02533600500004],
              [27.89234459700009, 35.971909898000035],
              [27.863536004000082, 35.94098541900007],
              [27.827403191000087, 35.913763739000046],
              [27.780446811000047, 35.89004140800006],
              [27.739268425000034, 35.91315338700008],
              [27.732676629000082, 35.91510651200008],
              [27.730316602000073, 35.92177969000005],
              [27.71225019600007, 35.95270416900007],
              [27.725352410000085, 35.96718984600005],
              [27.754079623000052, 36.037176825000074],
              [27.760020379000082, 36.06195709800005],
              [27.757090691000087, 36.08437734600005],
              [27.746836785000085, 36.09617747600004],
              [27.733164910000085, 36.10464101800005],
              [27.708832227000073, 36.12710195500006],
              [27.707286004000082, 36.132025458000044],
              [27.713552280000044, 36.13979726800005],
              [27.71225019600007, 36.14447663000004],
              [27.70289147200009, 36.150458075000074],
              [27.696543816000087, 36.14956289300005],
              [27.690928582000083, 36.14948151200008],
              [27.684255405000044, 36.15814850500004],
              [27.700694207000083, 36.163397528000075],
              [27.739512566000087, 36.18545156500005],
              [27.76335696700005, 36.19220612200007],
              [27.77198326900009, 36.19782135600008],
              [27.767425977000073, 36.205959377000056],
              [27.776052280000044, 36.21161530200004],
              [27.778086785000085, 36.21710846600007],
              [27.778168165000068, 36.22370026200008],
              [27.780446811000047, 36.23261139500005],
              [27.787119988000086, 36.24518463700008],
              [27.794118686000047, 36.254339911000045],
              [27.80323326900009, 36.27020905200004],
              [27.807871941000087, 36.27423737200007],
              [27.837412957000083, 36.28099192900004],
              [27.841970248000052, 36.28473541900007],
              [27.849457227000073, 36.29352448100008],
              [27.882823113000086, 36.321478583000044],
              [27.89031009200005, 36.33258698100008],
              [27.899668816000087, 36.34015534100007],
              [27.959239129000082, 36.356756903000075],
              [28.07081139400009, 36.40534088700008],
              [28.085785352000073, 36.41478099200009],
              [28.118418816000087, 36.42767975500004],
              [28.183929884000065, 36.42446523600006],
              [28.213877800000034, 36.45547109600005],
              [28.22242272200009, 36.45600006700005],
              [28.231130405000044, 36.44977448100008],
              [28.239756707000083, 36.438666083000044],
              [28.239756707000083, 36.432521877000056],
            ],
          ],
          [
            [
              [25.382090691000087, 36.47964101800005],
              [25.417979363000086, 36.470404364000046],
              [25.452403191000087, 36.45026276200008],
              [25.479177280000044, 36.42438385600008],
              [25.491384311000047, 36.397691148000035],
              [25.48926842500009, 36.377834377000056],
              [25.479991082000083, 36.357855536000045],
              [25.465098504000082, 36.34243398600006],
              [25.44662519600007, 36.33633047100005],
              [25.426442905000044, 36.337958075000074],
              [25.37989342500009, 36.348944403000075],
              [25.361664259000065, 36.356756903000075],
              [25.373383009000065, 36.36163971600007],
              [25.39698326900009, 36.361314195000034],
              [25.409434441000087, 36.36359284100007],
              [25.419200066000087, 36.37006256700005],
              [25.42872155000009, 36.38544342700004],
              [25.436778191000087, 36.39093659100007],
              [25.430023634000065, 36.41714101800005],
              [25.425303582000083, 36.42715078300006],
              [25.416270379000082, 36.432521877000056],
              [25.416270379000082, 36.438666083000044],
              [25.421885613000086, 36.45111725500004],
              [25.407074415000068, 36.45799388200004],
              [25.36850019600007, 36.46662018400008],
              [25.36850019600007, 36.47345612200007],
              [25.373057488000086, 36.47528717700004],
              [25.377777540000068, 36.47801341400009],
              [25.382090691000087, 36.47964101800005],
            ],
          ],
          [
            [
              [27.396820509000065, 36.438666083000044],
              [27.387461785000085, 36.42084381700005],
              [27.399587436000047, 36.410142320000034],
              [27.420664910000085, 36.408636786000045],
              [27.438487175000034, 36.41815827000005],
              [27.44190514400009, 36.41510651200008],
              [27.443369988000086, 36.41205475500004],
              [27.44467207100007, 36.40452708500004],
              [27.438731316000087, 36.39447663000004],
              [27.42823326900009, 36.385199286000045],
              [27.415863477000073, 36.38031647300005],
              [27.404307488000086, 36.38344961100006],
              [27.399261915000068, 36.37872955900008],
              [27.390147332000083, 36.38344961100006],
              [27.37794030000009, 36.382025458000044],
              [27.364756707000083, 36.39337799700007],
              [27.357432488000086, 36.410223700000074],
              [27.362803582000083, 36.424994208000044],
              [27.349619988000086, 36.43121979400007],
              [27.338145379000082, 36.42841217700004],
              [27.328868035000085, 36.42055898600006],
              [27.321787957000083, 36.411363023000035],
              [27.31495201900009, 36.411363023000035],
              [27.309336785000085, 36.42015208500004],
              [27.296885613000086, 36.42755768400008],
              [27.294444207000083, 36.435532945000034],
              [27.295176629000082, 36.45563385600008],
              [27.297048373000052, 36.46515534100007],
              [27.300629102000073, 36.47345612200007],
              [27.31023196700005, 36.45770905200004],
              [27.325043165000068, 36.46190013200004],
              [27.34156334700009, 36.47345612200007],
              [27.355804884000065, 36.47964101800005],
              [27.36850019600007, 36.47239817900004],
              [27.381683790000068, 36.44415924700007],
              [27.396820509000065, 36.438666083000044],
            ],
          ],
          [
            [
              [26.362152540000068, 36.637884833000044],
              [26.393321160000085, 36.63654205900008],
              [26.430511915000068, 36.61871979400007],
              [26.45948326900009, 36.59666575700004],
              [26.465993686000047, 36.58270905200004],
              [26.45997155000009, 36.57770416900007],
              [26.454925977000073, 36.57684967700004],
              [26.450043165000068, 36.58055247600004],
              [26.44467207100007, 36.589504299000055],
              [26.429698113000086, 36.57859935100004],
              [26.415863477000073, 36.57489655200004],
              [26.386729363000086, 36.575873114000046],
              [26.373301629000082, 36.57241445500006],
              [26.36304772200009, 36.563666083000044],
              [26.34864342500009, 36.541083075000074],
              [26.347666863000086, 36.52802155200004],
              [26.349457227000073, 36.515611070000034],
              [26.341644727000073, 36.50934479400007],
              [26.31771894600007, 36.50755442900004],
              [26.300954623000052, 36.51325104400007],
              [26.28223717500009, 36.53986237200007],
              [26.265961134000065, 36.54791901200008],
              [26.268321160000085, 36.55499909100007],
              [26.269786004000082, 36.55776601800005],
              [26.273448113000086, 36.56159088700008],
              [26.264333530000044, 36.57330963700008],
              [26.26148522200009, 36.58763255400004],
              [26.266449415000068, 36.59593333500004],
              [26.28028405000009, 36.589504299000055],
              [26.294769727000073, 36.596584377000056],
              [26.311778191000087, 36.58808014500005],
              [26.328461134000065, 36.57526276200008],
              [26.341644727000073, 36.56903717700004],
              [26.350840691000087, 36.57273997600004],
              [26.360606316000087, 36.58649323100008],
              [26.365977410000085, 36.589504299000055],
              [26.377289259000065, 36.58820221600007],
              [26.385915561000047, 36.58608633000006],
              [26.39389082100007, 36.58567942900004],
              [26.403819207000083, 36.589504299000055],
              [26.39031009200005, 36.59544505400004],
              [26.384938998000052, 36.604803778000075],
              [26.388926629000082, 36.613348700000074],
              [26.389414910000085, 36.61619700700004],
              [26.37867272200009, 36.619208075000074],
              [26.369965040000068, 36.62441640800006],
              [26.362152540000068, 36.630519924000055],
              [26.362152540000068, 36.637884833000044],
            ],
          ],
          [
            [
              [27.869883660000085, 36.589504299000055],
              [27.870616082000083, 36.577785549000055],
              [27.872569207000083, 36.569240627000056],
              [27.87671959700009, 36.56159088700008],
              [27.867523634000065, 36.55683014500005],
              [27.86304772200009, 36.55536530200004],
              [27.868011915000068, 36.55320872600004],
              [27.872080925000034, 36.55036041900007],
              [27.874847852000073, 36.54645416900007],
              [27.87671959700009, 36.541083075000074],
              [27.854502800000034, 36.530503648000035],
              [27.843028191000087, 36.52789948100008],
              [27.828298373000052, 36.52802155200004],
              [27.828298373000052, 36.53424713700008],
              [27.834157748000052, 36.53652578300006],
              [27.842621290000068, 36.54360586100006],
              [27.84937584700009, 36.54791901200008],
              [27.805918816000087, 36.56012604400007],
              [27.792491082000083, 36.56696198100008],
              [27.807871941000087, 36.575873114000046],
              [27.760020379000082, 36.575873114000046],
              [27.766856316000087, 36.585191148000035],
              [27.77784264400009, 36.59560781500005],
              [27.786957227000073, 36.60626862200007],
              [27.787852410000085, 36.616848049000055],
              [27.792491082000083, 36.617173570000034],
              [27.795258009000065, 36.61871979400007],
              [27.801524285000085, 36.624253648000035],
              [27.801524285000085, 36.616848049000055],
              [27.81812584700009, 36.634019273000035],
              [27.841970248000052, 36.64472077000005],
              [27.86101321700005, 36.64671458500004],
              [27.86304772200009, 36.637884833000044],
              [27.835215691000087, 36.63108958500004],
              [27.822276238000086, 36.62376536700009],
              [27.815277540000068, 36.61001211100006],
              [27.824473504000082, 36.612941799000055],
              [27.82862389400009, 36.612982489000046],
              [27.83570397200009, 36.60252513200004],
              [27.869883660000085, 36.624253648000035],
              [27.872080925000034, 36.62055084800005],
              [27.87281334700009, 36.61961497600004],
              [27.873789910000085, 36.61908600500004],
              [27.87671959700009, 36.616848049000055],
              [27.871348504000082, 36.613348700000074],
              [27.867930535000085, 36.609442450000074],
              [27.865489129000082, 36.605536200000074],
              [27.86304772200009, 36.60252513200004],
              [27.869883660000085, 36.606675523000035],
              [27.873220248000052, 36.605454820000034],
              [27.872894727000073, 36.599595445000034],
              [27.869883660000085, 36.589504299000055],
            ],
          ],
          [
            [
              [24.86817467500009, 36.665228583000044],
              [24.947927280000044, 36.624335028000075],
              [24.963715040000068, 36.60252513200004],
              [24.963715040000068, 36.59634023600006],
              [24.93799889400009, 36.597723700000074],
              [24.92286217500009, 36.60228099200009],
              [24.89551842500009, 36.624253648000035],
              [24.87940514400009, 36.632798570000034],
              [24.863454623000052, 36.63816966400009],
              [24.849782748000052, 36.646918036000045],
              [24.84083092500009, 36.665228583000044],
              [24.861664259000065, 36.66596100500004],
              [24.86817467500009, 36.665228583000044],
            ],
          ],
          [
            [
              [25.14625084700009, 36.71987539300005],
              [25.185801629000082, 36.71914297100005],
              [25.183116082000083, 36.71637604400007],
              [25.182465040000068, 36.71190013200004],
              [25.183441602000073, 36.70620351800005],
              [25.129567905000044, 36.66034577000005],
              [25.09310957100007, 36.63662344000005],
              [25.06739342500009, 36.637884833000044],
              [25.104665561000047, 36.69936758000006],
              [25.116465691000087, 36.70258209800005],
              [25.13640384200005, 36.71670156500005],
              [25.14625084700009, 36.71987539300005],
            ],
          ],
          [
            [
              [21.76417076900009, 36.753973700000074],
              [21.780039910000085, 36.74750397300005],
              [21.781586134000065, 36.736395575000074],
              [21.778005405000044, 36.720363674000055],
              [21.77784264400009, 36.69936758000006],
              [21.771657748000052, 36.70555247600004],
              [21.76807701900009, 36.70807526200008],
              [21.765961134000065, 36.71133047100005],
              [21.76417076900009, 36.71987539300005],
              [21.75049889400009, 36.71238841400009],
              [21.756114129000082, 36.741115627000056],
              [21.75953209700009, 36.75189850500004],
              [21.76417076900009, 36.753973700000074],
            ],
          ],
          [
            [
              [24.47437584700009, 36.74713776200008],
              [24.51270592500009, 36.76398346600007],
              [24.533376498000052, 36.768011786000045],
              [24.546071811000047, 36.753973700000074],
              [24.543223504000082, 36.74310944200005],
              [24.546071811000047, 36.688788153000075],
              [24.53760826900009, 36.68138255400004],
              [24.518402540000068, 36.67365143400008],
              [24.484629754000082, 36.665228583000044],
              [24.36459394600007, 36.66303131700005],
              [24.326996290000068, 36.65094635600008],
              [24.322927280000044, 36.665350653000075],
              [24.331309441000087, 36.687160549000055],
              [24.326996290000068, 36.69936758000006],
              [24.331309441000087, 36.70213450700004],
              [24.335785352000073, 36.70807526200008],
              [24.340668165000068, 36.71238841400009],
              [24.33139082100007, 36.71816640800006],
              [24.326996290000068, 36.71987539300005],
              [24.336680535000085, 36.727769273000035],
              [24.34473717500009, 36.74567291900007],
              [24.354258660000085, 36.753973700000074],
              [24.35906009200005, 36.748480536000045],
              [24.365489129000082, 36.74298737200007],
              [24.373057488000086, 36.737941799000055],
              [24.381602410000085, 36.73354726800005],
              [24.395355665000068, 36.73590729400007],
              [24.40723717500009, 36.70726146000004],
              [24.426524285000085, 36.69936758000006],
              [24.46070397200009, 36.69936758000006],
              [24.471446160000085, 36.70425039300005],
              [24.46851647200009, 36.71515534100007],
              [24.459157748000052, 36.72671133000006],
              [24.45053144600007, 36.73354726800005],
              [24.43685957100007, 36.72748444200005],
              [24.42709394600007, 36.73383209800005],
              [24.418711785000085, 36.74510325700004],
              [24.408864780000044, 36.753973700000074],
              [24.408864780000044, 36.76080963700008],
              [24.420258009000065, 36.77106354400007],
              [24.43327884200005, 36.76504140800006],
              [24.450450066000087, 36.75340403900009],
              [24.47437584700009, 36.74713776200008],
            ],
          ],
          [
            [
              [24.64226321700005, 36.788763739000046],
              [24.656260613000086, 36.782904364000046],
              [24.66578209700009, 36.774644273000035],
              [24.66773522200009, 36.76398346600007],
              [24.659353061000047, 36.75055573100008],
              [24.644786004000082, 36.747259833000044],
              [24.629730665000068, 36.75755442900004],
              [24.608164910000085, 36.781317450000074],
              [24.621836785000085, 36.794989325000074],
              [24.638682488000086, 36.794623114000046],
              [24.643809441000087, 36.792954820000034],
              [24.64226321700005, 36.788763739000046],
            ],
          ],
          [
            [
              [25.272959832000083, 36.71987539300005],
              [25.275238477000073, 36.721909898000035],
              [25.27637780000009, 36.72256094000005],
              [25.277598504000082, 36.723537502000056],
              [25.27979576900009, 36.72671133000006],
              [25.27116946700005, 36.725816148000035],
              [25.251800977000073, 36.72671133000006],
              [25.257090691000087, 36.73590729400007],
              [25.262380405000044, 36.749701239000046],
              [25.26498457100007, 36.762152411000045],
              [25.26270592500009, 36.767645575000074],
              [25.306976759000065, 36.794989325000074],
              [25.319509311000047, 36.78192780200004],
              [25.336192254000082, 36.75771719000005],
              [25.347992384000065, 36.74713776200008],
              [25.365896030000044, 36.739569403000075],
              [25.38379967500009, 36.73509349200009],
              [25.39942467500009, 36.72797272300005],
              [25.409434441000087, 36.71238841400009],
              [25.39698326900009, 36.71051666900007],
              [25.390147332000083, 36.70368073100008],
              [25.389496290000068, 36.694240627000056],
              [25.395192905000044, 36.68512604400007],
              [25.395192905000044, 36.678900458000044],
              [25.373220248000052, 36.65371328300006],
              [25.337901238000086, 36.66828034100007],
              [25.272959832000083, 36.71987539300005],
            ],
          ],
          [
            [
              [21.69581139400009, 36.74038320500006],
              [21.69695071700005, 36.775824286000045],
              [21.70085696700005, 36.791083075000074],
              [21.70948326900009, 36.80174388200004],
              [21.71452884200005, 36.79938385600008],
              [21.71843509200005, 36.796576239000046],
              [21.722829623000052, 36.794623114000046],
              [21.729340040000068, 36.794989325000074],
              [21.729340040000068, 36.788763739000046],
              [21.724945509000065, 36.786769924000055],
              [21.72038821700005, 36.78351471600007],
              [21.716319207000083, 36.781317450000074],
              [21.71656334700009, 36.77094147300005],
              [21.710459832000083, 36.76166413000004],
              [21.702321811000047, 36.751939195000034],
              [21.69581139400009, 36.74038320500006],
            ],
          ],
          [
            [
              [24.608164910000085, 36.835923570000034],
              [24.608164910000085, 36.82908763200004],
              [24.600433790000068, 36.82208893400008],
              [24.57276451900009, 36.78192780200004],
              [24.55640709700009, 36.78034088700008],
              [24.539805535000085, 36.784491278000075],
              [24.532399936000047, 36.791896877000056],
              [24.529551629000082, 36.80365631700005],
              [24.524099155000044, 36.81049225500004],
              [24.52116946700005, 36.81736888200004],
              [24.526133660000085, 36.82908763200004],
              [24.53419030000009, 36.83612702000005],
              [24.547211134000065, 36.84247467700004],
              [24.561778191000087, 36.84564850500004],
              [24.57398522200009, 36.84275950700004],
              [24.580088738000086, 36.83860911700009],
              [24.585948113000086, 36.83649323100008],
              [24.592458530000044, 36.83746979400007],
              [24.600759311000047, 36.84275950700004],
              [24.60254967500009, 36.839829820000034],
              [24.602305535000085, 36.83808014500005],
              [24.603037957000083, 36.83690013200004],
              [24.608164910000085, 36.835923570000034],
            ],
          ],
          [
            [
              [25.423106316000087, 36.83250560100004],
              [25.430349155000044, 36.84406159100007],
              [25.44695071700005, 36.857407945000034],
              [25.470957879000082, 36.87067291900007],
              [25.478363477000073, 36.87067291900007],
              [25.470957879000082, 36.86322663000004],
              [25.476410352000073, 36.86269765800006],
              [25.478526238000086, 36.86001211100006],
              [25.477793816000087, 36.835150458000044],
              [25.457855665000068, 36.82485586100006],
              [25.434418165000068, 36.82265859600005],
              [25.423106316000087, 36.83250560100004],
            ],
          ],
          [
            [
              [27.28093509200005, 36.907904364000046],
              [27.29151451900009, 36.891831773000035],
              [27.340993686000047, 36.88190338700008],
              [27.355804884000065, 36.86322663000004],
              [27.323415561000047, 36.84870026200008],
              [27.21420332100007, 36.823879299000055],
              [27.19076582100007, 36.81232330900008],
              [27.12989342500009, 36.76080963700008],
              [27.10906009200005, 36.75828685100004],
              [27.083181186000047, 36.76121653900009],
              [27.060069207000083, 36.76740143400008],
              [27.047536655000044, 36.775091864000046],
              [26.992035352000073, 36.753607489000046],
              [26.975759311000047, 36.74079010600008],
              [26.98601321700005, 36.71987539300005],
              [26.97169030000009, 36.71625397300005],
              [26.965668165000068, 36.70555247600004],
              [26.96656334700009, 36.69171784100007],
              [26.972911004000082, 36.678900458000044],
              [26.955332879000082, 36.681708075000074],
              [26.93726647200009, 36.69277578300006],
              [26.923350457000083, 36.70620351800005],
              [26.91773522200009, 36.716131903000075],
              [26.920258009000065, 36.751166083000044],
              [26.92628014400009, 36.765611070000034],
              [26.937673373000052, 36.76080963700008],
              [26.94239342500009, 36.76626211100006],
              [26.953868035000085, 36.77594635600008],
              [26.95875084700009, 36.781317450000074],
              [26.964040561000047, 36.77802155200004],
              [26.98601321700005, 36.767645575000074],
              [26.999522332000083, 36.778509833000044],
              [27.00749759200005, 36.78782786700009],
              [27.020762566000087, 36.808579820000034],
              [27.05518639400009, 36.83266836100006],
              [27.061208530000044, 36.83934153900009],
              [27.164235873000052, 36.89118073100008],
              [27.265635613000086, 36.90403880400004],
              [27.28093509200005, 36.907904364000046],
            ],
          ],
          [
            [
              [25.608653191000087, 36.88373444200005],
              [25.61459394600007, 36.893744208000044],
              [25.624847852000073, 36.89874909100007],
              [25.637461785000085, 36.903225002000056],
              [25.649668816000087, 36.91160716400009],
              [25.659434441000087, 36.907456773000035],
              [25.684418165000068, 36.89118073100008],
              [25.674001498000052, 36.87946198100008],
              [25.654633009000065, 36.878892320000034],
              [25.631602410000085, 36.88263580900008],
              [25.608653191000087, 36.88373444200005],
            ],
          ],
          [
            [
              [26.005869988000086, 36.93891022300005],
              [26.019053582000083, 36.925116278000075],
              [26.035411004000082, 36.912990627000056],
              [26.054209832000083, 36.903550523000035],
              [26.074229363000086, 36.89801666900007],
              [26.07471764400009, 36.89329661700009],
              [26.073090040000068, 36.89207591400009],
              [26.070485873000052, 36.89207591400009],
              [26.06739342500009, 36.89118073100008],
              [26.05014082100007, 36.89695872600004],
              [26.031993035000085, 36.89394765800006],
              [26.015961134000065, 36.88947174700007],
              [26.005869988000086, 36.89118073100008],
              [25.990977410000085, 36.87909577000005],
              [25.94857832100007, 36.85423411700009],
              [25.934255405000044, 36.84955475500004],
              [25.921397332000083, 36.841050523000035],
              [25.89356530000009, 36.80345286700009],
              [25.879649285000085, 36.794989325000074],
              [25.798675977000073, 36.772772528000075],
              [25.75554446700005, 36.769964911000045],
              [25.739024285000085, 36.794989325000074],
              [25.75326582100007, 36.788763739000046],
              [25.76075280000009, 36.79905833500004],
              [25.774099155000044, 36.80711497600004],
              [25.788910352000073, 36.80923086100006],
              [25.80054772200009, 36.80174388200004],
              [25.807383660000085, 36.80174388200004],
              [25.81413821700005, 36.80683014500005],
              [25.823008660000085, 36.80874258000006],
              [25.84546959700009, 36.808579820000034],
              [25.84937584700009, 36.812201239000046],
              [25.863129102000073, 36.835923570000034],
              [25.851573113000086, 36.83112213700008],
              [25.84546959700009, 36.83661530200004],
              [25.843760613000086, 36.84511953300006],
              [25.84546959700009, 36.84955475500004],
              [25.856618686000047, 36.85106028900009],
              [25.971853061000047, 36.89801666900007],
              [25.971853061000047, 36.90420156500005],
              [25.966075066000087, 36.90664297100005],
              [25.96265709700009, 36.90875885600008],
              [25.95866946700005, 36.91054922100005],
              [25.950694207000083, 36.91160716400009],
              [25.950694207000083, 36.91844310100004],
              [25.978363477000073, 36.92495351800005],
              [25.990244988000086, 36.93073151200008],
              [25.998383009000065, 36.93891022300005],
              [26.005869988000086, 36.93891022300005],
            ],
          ],
          [
            [
              [25.08106530000009, 36.95262278900009],
              [25.066661004000082, 36.955145575000074],
              [25.047048373000052, 36.96922435100004],
              [25.030528191000087, 36.98895905200004],
              [25.02588951900009, 37.007879950000074],
              [25.035492384000065, 37.021918036000045],
              [25.05323326900009, 37.034369208000044],
              [25.07276451900009, 37.042181708000044],
              [25.087901238000086, 37.04197825700004],
              [25.069590691000087, 36.989569403000075],
              [25.05990644600007, 36.973089911000045],
              [25.066254102000073, 36.96869538000004],
              [25.07195071700005, 36.96385325700004],
              [25.08106530000009, 36.95262278900009],
            ],
          ],
          [
            [
              [24.704356316000087, 37.035142320000034],
              [24.71615644600007, 37.02008698100008],
              [24.75163821700005, 36.98578522300005],
              [24.76465905000009, 36.95661041900007],
              [24.765798373000052, 36.949204820000034],
              [24.76270592500009, 36.945379950000074],
              [24.74854576900009, 36.93935781500005],
              [24.745290561000047, 36.935532945000034],
              [24.71062259200005, 36.90420156500005],
              [24.69581139400009, 36.92324453300006],
              [24.678884311000047, 36.95148346600007],
              [24.669200066000087, 36.97846100500004],
              [24.676524285000085, 36.99359772300005],
              [24.676524285000085, 37.000433661000045],
              [24.665863477000073, 37.007473049000055],
              [24.65406334700009, 37.024318752000056],
              [24.64226321700005, 37.02773672100005],
              [24.642832879000082, 37.03266022300005],
              [24.644053582000083, 37.03563060100004],
              [24.649668816000087, 37.04197825700004],
              [24.645681186000047, 37.04287344000005],
              [24.643402540000068, 37.04287344000005],
              [24.642588738000086, 37.044175523000035],
              [24.64226321700005, 37.048814195000034],
              [24.65593509200005, 37.048814195000034],
              [24.679698113000086, 37.032863674000055],
              [24.689300977000073, 37.02920156500005],
              [24.697520379000082, 37.035142320000034],
              [24.704356316000087, 37.035142320000034],
            ],
          ],
          [
            [
              [26.911631707000083, 36.94578685100004],
              [26.920258009000065, 36.95880768400008],
              [26.924978061000047, 36.96308014500005],
              [26.93140709700009, 36.966864325000074],
              [26.925303582000083, 36.981675523000035],
              [26.929860873000052, 36.99396393400008],
              [26.938649936000047, 37.00454336100006],
              [26.94507897200009, 37.014105536000045],
              [26.947276238000086, 37.01618073100008],
              [26.951182488000086, 37.021185614000046],
              [26.953868035000085, 37.02789948100008],
              [26.951914910000085, 37.035142320000034],
              [26.943614129000082, 37.040716864000046],
              [26.935069207000083, 37.03961823100008],
              [26.928396030000044, 37.036363023000035],
              [26.924571160000085, 37.035142320000034],
              [26.917165561000047, 37.04165273600006],
              [26.912445509000065, 37.046942450000074],
              [26.903493686000047, 37.062486070000034],
              [26.896006707000083, 37.06891510600008],
              [26.888926629000082, 37.07099030200004],
              [26.885590040000068, 37.07558828300006],
              [26.889821811000047, 37.08978913000004],
              [26.901621941000087, 37.07729726800005],
              [26.98601321700005, 37.048814195000034],
              [26.98601321700005, 37.04197825700004],
              [26.972911004000082, 37.04197825700004],
              [26.98218834700009, 37.02875397300005],
              [26.995290561000047, 37.02289459800005],
              [27.005869988000086, 37.01618073100008],
              [27.007090691000087, 37.000433661000045],
              [27.01539147200009, 37.00873444200005],
              [27.02393639400009, 37.01268138200004],
              [27.032481316000087, 37.01235586100006],
              [27.041270379000082, 37.007879950000074],
              [27.04428144600007, 36.99624258000006],
              [27.03687584700009, 36.97846100500004],
              [27.041270379000082, 36.966864325000074],
              [27.036306186000047, 36.960150458000044],
              [27.03492272200009, 36.95718008000006],
              [27.033864780000044, 36.95262278900009],
              [27.041270379000082, 36.95262278900009],
              [27.041270379000082, 36.959418036000045],
              [27.047536655000044, 36.959418036000045],
              [27.04037519600007, 36.94505442900004],
              [27.023610873000052, 36.945013739000046],
              [26.993418816000087, 36.95262278900009],
              [26.988291863000086, 36.94668203300006],
              [26.986175977000073, 36.93768952000005],
              [26.98340905000009, 36.92951080900008],
              [26.976084832000083, 36.92593008000006],
              [26.966319207000083, 36.927801825000074],
              [26.95875084700009, 36.930975653000075],
              [26.951914910000085, 36.931626695000034],
              [26.94507897200009, 36.92593008000006],
              [26.937754754000082, 36.93504466400009],
              [26.929860873000052, 36.94277578300006],
              [26.921153191000087, 36.94708893400008],
              [26.911631707000083, 36.94578685100004],
            ],
          ],
          [
            [
              [25.807383660000085, 37.10342031500005],
              [25.805430535000085, 37.09918854400007],
              [25.805023634000065, 37.09829336100006],
              [25.804209832000083, 37.09804922100005],
              [25.80054772200009, 37.09593333500004],
              [25.780528191000087, 37.12396881700005],
              [25.79737389400009, 37.12323639500005],
              [25.809825066000087, 37.12689850500004],
              [25.834646030000044, 37.137600002000056],
              [25.832041863000086, 37.130194403000075],
              [25.828379754000082, 37.12396881700005],
              [25.837168816000087, 37.11367422100005],
              [25.842051629000082, 37.11029694200005],
              [25.836761915000068, 37.10236237200007],
              [25.82911217500009, 37.097316799000055],
              [25.819102410000085, 37.096909898000035],
              [25.807383660000085, 37.10342031500005],
            ],
          ],
          [
            [
              [25.27979576900009, 37.048814195000034],
              [25.268809441000087, 37.046128648000035],
              [25.26303144600007, 37.039943752000056],
              [25.258636915000068, 37.031317450000074],
              [25.251800977000073, 37.021470445000034],
              [25.244802280000044, 37.01459381700005],
              [25.23218834700009, 37.005113023000035],
              [25.20443769600007, 36.98895905200004],
              [25.18848717500009, 36.98529694200005],
              [25.15284264400009, 36.986761786000045],
              [25.143321160000085, 36.99005768400008],
              [25.121918165000068, 37.00458405200004],
              [25.111501498000052, 37.007879950000074],
              [25.103363477000073, 37.012884833000044],
              [25.103037957000083, 37.024318752000056],
              [25.11296634200005, 37.06273021000004],
              [25.125336134000065, 37.07453034100007],
              [25.156260613000086, 37.08978913000004],
              [25.149261915000068, 37.09349192900004],
              [25.142425977000073, 37.094916083000044],
              [25.13575280000009, 37.093817450000074],
              [25.15007571700005, 37.110541083000044],
              [25.178558790000068, 37.12946198100008],
              [25.209808790000068, 37.14402903900009],
              [25.23878014400009, 37.15184153900009],
              [25.22396894600007, 37.13434479400007],
              [25.231944207000083, 37.12750885600008],
              [25.259287957000083, 37.12396881700005],
              [25.272959832000083, 37.137600002000056],
              [25.270274285000085, 37.14154694200005],
              [25.26612389400009, 37.15184153900009],
              [25.27979576900009, 37.15273672100005],
              [25.293304884000065, 37.15184153900009],
              [25.291351759000065, 37.144232489000046],
              [25.28809655000009, 37.13654205900008],
              [25.28419030000009, 37.12946198100008],
              [25.27979576900009, 37.12396881700005],
              [25.262950066000087, 37.089829820000034],
              [25.262868686000047, 37.07558828300006],
              [25.27979576900009, 37.06928131700005],
              [25.27979576900009, 37.062486070000034],
              [25.26612389400009, 37.062486070000034],
              [25.26612389400009, 37.05499909100007],
              [25.27979576900009, 37.05499909100007],
              [25.27979576900009, 37.048814195000034],
            ],
          ],
          [
            [
              [25.526133660000085, 37.19623444200005],
              [25.53370201900009, 37.20066966400009],
              [25.55014082100007, 37.193793036000045],
              [25.574554884000065, 37.17853424700007],
              [25.586273634000065, 37.16063060100004],
              [25.592458530000044, 37.14252350500004],
              [25.59506269600007, 37.099676825000074],
              [25.59278405000009, 37.08087799700007],
              [25.58301842500009, 37.03978099200009],
              [25.580821160000085, 37.01776764500005],
              [25.55250084700009, 36.96893952000005],
              [25.54737389400009, 36.96531810100004],
              [25.54037519600007, 36.964097398000035],
              [25.526133660000085, 36.959418036000045],
              [25.491384311000047, 36.93211497600004],
              [25.479991082000083, 36.92841217700004],
              [25.461110873000052, 36.92450592700004],
              [25.449880405000044, 36.91844310100004],
              [25.447601759000065, 36.92475006700005],
              [25.443695509000065, 36.92609284100007],
              [25.436778191000087, 36.93211497600004],
              [25.432383660000085, 36.93927643400008],
              [25.426442905000044, 36.95937734600005],
              [25.423106316000087, 36.966864325000074],
              [25.416677280000044, 36.97313060100004],
              [25.388926629000082, 36.986761786000045],
              [25.393321160000085, 36.992173570000034],
              [25.394053582000083, 36.998114325000074],
              [25.391286655000044, 37.00438060100004],
              [25.385508660000085, 37.010972398000035],
              [25.380707227000073, 37.018744208000044],
              [25.379730665000068, 37.02684153900009],
              [25.381032748000052, 37.03314850500004],
              [25.382090691000087, 37.035142320000034],
              [25.36695397200009, 37.05955638200004],
              [25.355479363000086, 37.07135651200008],
              [25.341807488000086, 37.07672760600008],
              [25.341807488000086, 37.08295319200005],
              [25.347504102000073, 37.08738841400009],
              [25.352386915000068, 37.089097398000035],
              [25.356700066000087, 37.08771393400008],
              [25.361664259000065, 37.08295319200005],
              [25.371836785000085, 37.089056708000044],
              [25.409434441000087, 37.12396881700005],
              [25.474619988000086, 37.161810614000046],
              [25.48023522200009, 37.16791413000004],
              [25.49512780000009, 37.189113674000055],
              [25.502289259000065, 37.19171784100007],
              [25.522146030000044, 37.19318268400008],
              [25.526133660000085, 37.19623444200005],
            ],
          ],
          [
            [
              [24.443695509000065, 37.17853424700007],
              [24.436208530000044, 37.18537018400008],
              [24.468272332000083, 37.20209381700005],
              [24.485606316000087, 37.20612213700008],
              [24.498301629000082, 37.199652411000045],
              [24.505137566000087, 37.199652411000045],
              [24.509776238000086, 37.20490143400008],
              [24.514903191000087, 37.20600006700005],
              [24.52051842500009, 37.20392487200007],
              [24.526133660000085, 37.199652411000045],
              [24.532074415000068, 37.185614325000074],
              [24.534678582000083, 37.167669989000046],
              [24.53451582100007, 37.14834219000005],
              [24.532399936000047, 37.130113023000035],
              [24.526133660000085, 37.14443594000005],
              [24.518809441000087, 37.14443594000005],
              [24.51889082100007, 37.132066148000035],
              [24.51531009200005, 37.12287018400008],
              [24.508148634000065, 37.11591217700004],
              [24.498301629000082, 37.11029694200005],
              [24.495941602000073, 37.11310455900008],
              [24.495371941000087, 37.11440664300005],
              [24.494395379000082, 37.11542389500005],
              [24.491465691000087, 37.11774323100008],
              [24.490977410000085, 37.122259833000044],
              [24.492849155000044, 37.12319570500006],
              [24.49545332100007, 37.12287018400008],
              [24.498301629000082, 37.12396881700005],
              [24.489756707000083, 37.128119208000044],
              [24.48096764400009, 37.12970612200007],
              [24.472504102000073, 37.12836334800005],
              [24.464121941000087, 37.12396881700005],
              [24.462087436000047, 37.13349030200004],
              [24.45948326900009, 37.13719310100004],
              [24.455821160000085, 37.13589101800005],
              [24.45053144600007, 37.130113023000035],
              [24.442067905000044, 37.134466864000046],
              [24.434418165000068, 37.13418203300006],
              [24.428070509000065, 37.13031647300005],
              [24.422536655000044, 37.12396881700005],
              [24.419118686000047, 37.135646877000056],
              [24.421885613000086, 37.13816966400009],
              [24.430511915000068, 37.14443594000005],
              [24.42351321700005, 37.14984772300005],
              [24.423024936000047, 37.154730536000045],
              [24.427744988000086, 37.15961334800005],
              [24.436208530000044, 37.16486237200007],
              [24.432790561000047, 37.17226797100005],
              [24.434743686000047, 37.175482489000046],
              [24.443695509000065, 37.17853424700007],
            ],
          ],
          [
            [
              [23.128428582000083, 37.288397528000075],
              [23.134287957000083, 37.28457265800006],
              [23.151052280000044, 37.27680084800005],
              [23.158457879000082, 37.27138906500005],
              [23.162445509000065, 37.26434967700004],
              [23.164724155000044, 37.25381094000005],
              [23.162364129000082, 37.244208075000074],
              [23.15202884200005, 37.23997630400004],
              [23.131032748000052, 37.24371979400007],
              [23.118988477000073, 37.252834377000056],
              [23.10914147200009, 37.26414622600004],
              [23.094411655000044, 37.274725653000075],
              [23.101410352000073, 37.280951239000046],
              [23.109548373000052, 37.28534577000005],
              [23.11850019600007, 37.28778717700004],
              [23.128428582000083, 37.288397528000075],
            ],
          ],
          [
            [
              [23.587168816000087, 37.37091705900008],
              [23.571136915000068, 37.35834381700005],
              [23.547699415000068, 37.34983958500004],
              [23.523285352000073, 37.34662506700005],
              [23.505137566000087, 37.34983958500004],
              [23.50879967500009, 37.32990143400008],
              [23.496836785000085, 37.320013739000046],
              [23.476084832000083, 37.31671784100007],
              [23.45362389400009, 37.31635163000004],
              [23.396494988000086, 37.30320872600004],
              [23.374278191000087, 37.30267975500004],
              [23.374278191000087, 37.30951569200005],
              [23.463633660000085, 37.35732656500005],
              [23.48764082100007, 37.36351146000004],
              [23.53256269600007, 37.36391836100006],
              [23.552989129000082, 37.37091705900008],
              [23.587168816000087, 37.37091705900008],
            ],
          ],
          [
            [
              [24.367930535000085, 37.41193268400008],
              [24.374847852000073, 37.43846263200004],
              [24.395681186000047, 37.45685455900008],
              [24.41960696700005, 37.471584377000056],
              [24.436208530000044, 37.48700592700004],
              [24.443695509000065, 37.48700592700004],
              [24.443695509000065, 37.472723700000074],
              [24.44117272200009, 37.464911200000074],
              [24.434336785000085, 37.45075104400007],
              [24.430511915000068, 37.44603099200009],
              [24.469411655000044, 37.42747630400004],
              [24.482676629000082, 37.41242096600007],
              [24.477793816000087, 37.39081452000005],
              [24.46338951900009, 37.39447663000004],
              [24.45281009200005, 37.38344961100006],
              [24.446136915000068, 37.36579010600008],
              [24.443695509000065, 37.34983958500004],
              [24.429698113000086, 37.33881256700005],
              [24.41179446700005, 37.32396067900004],
              [24.389008009000065, 37.31391022300005],
              [24.367930535000085, 37.30951569200005],
              [24.37671959700009, 37.344956773000035],
              [24.385590040000068, 37.36115143400008],
              [24.40211022200009, 37.37091705900008],
              [24.40211022200009, 37.37714264500005],
              [24.397634311000047, 37.37929922100005],
              [24.393321160000085, 37.38275788000004],
              [24.38843834700009, 37.38458893400008],
              [24.38843834700009, 37.39081452000005],
              [24.396820509000065, 37.40151601800005],
              [24.394786004000082, 37.411769924000055],
              [24.38453209700009, 37.41681549700007],
              [24.367930535000085, 37.41193268400008],
            ],
          ],
          [
            [
              [25.395192905000044, 37.41815827000005],
              [25.38257897200009, 37.41974518400008],
              [25.306976759000065, 37.41193268400008],
              [25.309255405000044, 37.41974518400008],
              [25.308848504000082, 37.42267487200007],
              [25.307790561000047, 37.42446523600006],
              [25.306976759000065, 37.42865631700005],
              [25.309255405000044, 37.43618398600006],
              [25.313975457000083, 37.43842194200005],
              [25.31885826900009, 37.43842194200005],
              [25.32129967500009, 37.43919505400004],
              [25.326426629000082, 37.462876695000034],
              [25.322438998000052, 37.47101471600007],
              [25.306976759000065, 37.472723700000074],
              [25.312673373000052, 37.48822663000004],
              [25.324392123000052, 37.49510325700004],
              [25.337738477000073, 37.49957916900007],
              [25.347992384000065, 37.50812409100007],
              [25.377289259000065, 37.46743398600006],
              [25.382090691000087, 37.46967194200005],
              [25.385590040000068, 37.489935614000046],
              [25.395355665000068, 37.49396393400008],
              [25.42676842500009, 37.48700592700004],
              [25.430837436000047, 37.484808661000045],
              [25.436289910000085, 37.47988515800006],
              [25.443614129000082, 37.475043036000045],
              [25.462901238000086, 37.470038153000075],
              [25.465586785000085, 37.46336497600004],
              [25.463145379000082, 37.454738674000055],
              [25.457286004000082, 37.44603099200009],
              [25.442556186000047, 37.44090403900009],
              [25.42359459700009, 37.441107489000046],
              [25.407725457000083, 37.436835028000075],
              [25.402598504000082, 37.41815827000005],
              [25.395192905000044, 37.41815827000005],
            ],
          ],
          [
            [
              [24.943369988000086, 37.43549225500004],
              [24.946055535000085, 37.43301015800006],
              [24.952321811000047, 37.429673570000034],
              [24.959157748000052, 37.42487213700008],
              [24.963715040000068, 37.41815827000005],
              [24.96615644600007, 37.40778229400007],
              [24.964040561000047, 37.40176015800006],
              [24.956553582000083, 37.39704010600008],
              [24.89625084700009, 37.37164948100008],
              [24.88184655000009, 37.36351146000004],
              [24.88135826900009, 37.37323639500005],
              [24.88217207100007, 37.38035716400009],
              [24.884613477000073, 37.385931708000044],
              [24.888682488000086, 37.39081452000005],
              [24.888682488000086, 37.39826080900008],
              [24.882009311000047, 37.397691148000035],
              [24.861338738000086, 37.39826080900008],
              [24.864024285000085, 37.40729401200008],
              [24.86817467500009, 37.41469961100006],
              [24.87403405000009, 37.42072174700007],
              [24.88184655000009, 37.42560455900008],
              [24.877777540000068, 37.42690664300005],
              [24.86817467500009, 37.43178945500006],
              [24.886729363000086, 37.43528880400004],
              [24.89812259200005, 37.44867584800005],
              [24.902679884000065, 37.46576569200005],
              [24.902354363000086, 37.480169989000046],
              [24.89625084700009, 37.501939195000034],
              [24.895355665000068, 37.51044342700004],
              [24.904958530000044, 37.51080963700008],
              [24.929698113000086, 37.50812409100007],
              [24.93881269600007, 37.49974192900004],
              [24.948090040000068, 37.485581773000035],
              [24.955088738000086, 37.47064850500004],
              [24.95753014400009, 37.45970286700009],
              [24.954925977000073, 37.45262278900009],
              [24.945323113000086, 37.443345445000034],
              [24.943369988000086, 37.43549225500004],
            ],
          ],
          [
            [
              [23.477305535000085, 37.555894273000035],
              [23.48178144600007, 37.55646393400008],
              [23.483164910000085, 37.55499909100007],
              [23.483164910000085, 37.55231354400007],
              [23.48414147200009, 37.54905833500004],
              [23.492035352000073, 37.539129950000074],
              [23.500824415000068, 37.53261953300006],
              [23.511566602000073, 37.52903880400004],
              [23.525645379000082, 37.52802155200004],
              [23.525645379000082, 37.52179596600007],
              [23.50635826900009, 37.51284414300005],
              [23.481211785000085, 37.50958893400008],
              [23.455902540000068, 37.51251862200007],
              [23.436289910000085, 37.52179596600007],
              [23.436289910000085, 37.52802155200004],
              [23.46461022200009, 37.53375885600008],
              [23.475433790000068, 37.54083893400008],
              [23.477305535000085, 37.555894273000035],
            ],
          ],
          [
            [
              [25.091319207000083, 37.58258698100008],
              [25.08057701900009, 37.58685944200005],
              [25.047048373000052, 37.61737702000005],
              [25.008636915000068, 37.63178131700005],
              [24.997894727000073, 37.637884833000044],
              [24.990977410000085, 37.64598216400009],
              [24.984385613000086, 37.65802643400008],
              [24.98145592500009, 37.67023346600007],
              [24.98487389400009, 37.67885976800005],
              [24.997894727000073, 37.68187083500004],
              [25.05323326900009, 37.67885976800005],
              [25.057790561000047, 37.67731354400007],
              [25.06739342500009, 37.67259349200009],
              [25.06739342500009, 37.66518789300005],
              [25.05990644600007, 37.66518789300005],
              [25.05990644600007, 37.65835195500006],
              [25.07007897200009, 37.65778229400007],
              [25.07748457100007, 37.65493398600006],
              [25.083262566000087, 37.650376695000034],
              [25.087901238000086, 37.64468008000006],
              [25.103770379000082, 37.65375397300005],
              [25.12273196700005, 37.651678778000075],
              [25.139821811000047, 37.64272695500006],
              [25.14942467500009, 37.63104889500005],
              [25.164805535000085, 37.645819403000075],
              [25.192637566000087, 37.64130280200004],
              [25.222992384000065, 37.62982819200005],
              [25.245616082000083, 37.624212958000044],
              [25.23878014400009, 37.61737702000005],
              [25.247325066000087, 37.614894924000055],
              [25.252777540000068, 37.608710028000075],
              [25.256602410000085, 37.60008372600004],
              [25.259287957000083, 37.59003327000005],
              [25.234711134000065, 37.56289297100005],
              [25.227305535000085, 37.53742096600007],
              [25.215993686000047, 37.532904364000046],
              [25.169932488000086, 37.53864166900007],
              [25.142100457000083, 37.552720445000034],
              [25.12549889400009, 37.555894273000035],
              [25.115570509000065, 37.56012604400007],
              [25.10328209700009, 37.57843659100007],
              [25.091319207000083, 37.58258698100008],
            ],
          ],
          [
            [
              [24.37476647200009, 37.68626536700009],
              [24.402517123000052, 37.65574778900009],
              [24.395762566000087, 37.624660549000055],
              [24.37012780000009, 37.59511953300006],
              [24.340668165000068, 37.569566148000035],
              [24.31299889400009, 37.53823476800005],
              [24.29346764400009, 37.52570221600007],
              [24.275401238000086, 37.531683661000045],
              [24.27515709700009, 37.54559967700004],
              [24.279958530000044, 37.595770575000074],
              [24.278575066000087, 37.60431549700007],
              [24.278086785000085, 37.62287018400008],
              [24.289317254000082, 37.64533112200007],
              [24.30567467500009, 37.66083405200004],
              [24.320648634000065, 37.65835195500006],
              [24.32789147200009, 37.66498444200005],
              [24.333832227000073, 37.67259349200009],
              [24.32357832100007, 37.67206452000005],
              [24.320648634000065, 37.67259349200009],
              [24.320648634000065, 37.67885976800005],
              [24.330414259000065, 37.68398672100005],
              [24.339691602000073, 37.68626536700009],
              [24.347992384000065, 37.684881903000075],
              [24.354258660000085, 37.67885976800005],
              [24.36109459700009, 37.67885976800005],
              [24.361664259000065, 37.68504466400009],
              [24.36459394600007, 37.68610260600008],
              [24.369151238000086, 37.68537018400008],
              [24.37476647200009, 37.68626536700009],
            ],
          ],
          [
            [
              [26.362152540000068, 37.68626536700009],
              [26.344574415000068, 37.659491278000075],
              [26.319102410000085, 37.63426341400009],
              [26.230642123000052, 37.57135651200008],
              [26.21387780000009, 37.56513092700004],
              [26.12794030000009, 37.55581289300005],
              [26.108246290000068, 37.54905833500004],
              [26.097911004000082, 37.54279205900008],
              [26.078298373000052, 37.52757396000004],
              [26.06739342500009, 37.52179596600007],
              [26.057871941000087, 37.519232489000046],
              [26.050791863000086, 37.51947663000004],
              [26.04273522200009, 37.52094147300005],
              [26.02979576900009, 37.52179596600007],
              [25.99073326900009, 37.51316966400009],
              [25.97632897200009, 37.51601797100005],
              [25.971853061000047, 37.53546784100007],
              [25.979746941000087, 37.54865143400008],
              [26.012380405000044, 37.57501862200007],
              [26.019704623000052, 37.58633047100005],
              [26.02637780000009, 37.600816148000035],
              [26.04200280000009, 37.61701080900008],
              [26.06031334700009, 37.63068268400008],
              [26.074229363000086, 37.637884833000044],
              [26.09896894600007, 37.63906484600005],
              [26.156423373000052, 37.632798570000034],
              [26.177256707000083, 37.637884833000044],
              [26.197438998000052, 37.63226959800005],
              [26.227224155000044, 37.63959381700005],
              [26.254242384000065, 37.652004299000055],
              [26.280772332000083, 37.675441799000055],
              [26.313649936000047, 37.68317291900007],
              [26.362152540000068, 37.68626536700009],
            ],
          ],
          [
            [
              [23.546153191000087, 37.77440013200004],
              [23.563161655000044, 37.76825592700004],
              [23.556813998000052, 37.75763580900008],
              [23.544932488000086, 37.74506256700005],
              [23.546153191000087, 37.73346588700008],
              [23.532074415000068, 37.72532786700009],
              [23.529551629000082, 37.714504299000055],
              [23.530121290000068, 37.70294830900008],
              [23.525645379000082, 37.69245026200008],
              [23.51734459700009, 37.68829987200007],
              [23.49463951900009, 37.68349844000005],
              [23.48414147200009, 37.67885976800005],
              [23.476573113000086, 37.68496328300006],
              [23.471364780000044, 37.68817780200004],
              [23.457367384000065, 37.69245026200008],
              [23.457367384000065, 37.699286200000074],
              [23.469004754000082, 37.70502350500004],
              [23.468272332000083, 37.714504299000055],
              [23.459320509000065, 37.72333405200004],
              [23.446543816000087, 37.72724030200004],
              [23.434418165000068, 37.733587958000044],
              [23.42709394600007, 37.747748114000046],
              [23.424489780000044, 37.761786200000074],
              [23.425629102000073, 37.76821523600006],
              [23.546153191000087, 37.77440013200004],
            ],
          ],
          [
            [
              [27.047536655000044, 37.72724030200004],
              [27.058767123000052, 37.73379140800006],
              [27.065277540000068, 37.72907135600008],
              [27.066579623000052, 37.71832916900007],
              [27.061208530000044, 37.706732489000046],
              [27.036957227000073, 37.712876695000034],
              [27.000824415000068, 37.70661041900007],
              [26.910004102000073, 37.67804596600007],
              [26.900726759000065, 37.67340729400007],
              [26.889821811000047, 37.66518789300005],
              [26.88379967500009, 37.65814850500004],
              [26.88184655000009, 37.65302155200004],
              [26.878754102000073, 37.648871161000045],
              [26.869313998000052, 37.64468008000006],
              [26.860850457000083, 37.64337799700007],
              [26.79737389400009, 37.64468008000006],
              [26.787445509000065, 37.64720286700009],
              [26.783376498000052, 37.65338776200008],
              [26.781097852000073, 37.661322333000044],
              [26.77711022200009, 37.66889069200005],
              [26.760915561000047, 37.68968333500004],
              [26.75098717500009, 37.69668203300006],
              [26.727305535000085, 37.70156484600005],
              [26.71648196700005, 37.711371161000045],
              [26.708262566000087, 37.71356842700004],
              [26.699392123000052, 37.71246979400007],
              [26.683604363000086, 37.70783112200007],
              [26.65723717500009, 37.70490143400008],
              [26.640879754000082, 37.69944896000004],
              [26.628428582000083, 37.690659898000035],
              [26.622894727000073, 37.67885976800005],
              [26.615489129000082, 37.67885976800005],
              [26.615489129000082, 37.68626536700009],
              [26.609222852000073, 37.68626536700009],
              [26.598399285000085, 37.67719147300005],
              [26.58952884200005, 37.68707916900007],
              [26.583506707000083, 37.70416901200008],
              [26.581309441000087, 37.71670156500005],
              [26.580251498000052, 37.74079010600008],
              [26.583994988000086, 37.75226471600007],
              [26.594981316000087, 37.761379299000055],
              [26.612071160000085, 37.765611070000034],
              [26.62989342500009, 37.767645575000074],
              [26.64389082100007, 37.77240631700005],
              [26.649587436000047, 37.785223700000074],
              [26.658050977000073, 37.79279205900008],
              [26.771820509000065, 37.814113674000055],
              [26.80640709700009, 37.814520575000074],
              [26.842051629000082, 37.80914948100008],
              [26.855723504000082, 37.80267975500004],
              [26.88184655000009, 37.78538646000004],
              [26.916677280000044, 37.77781810100004],
              [26.955332879000082, 37.75690338700008],
              [26.966075066000087, 37.747748114000046],
              [26.969899936000047, 37.75877513200004],
              [26.96420332100007, 37.76752350500004],
              [26.954356316000087, 37.776556708000044],
              [26.94507897200009, 37.788723049000055],
              [26.961599155000044, 37.784409898000035],
              [26.97364342500009, 37.784491278000075],
              [26.983571811000047, 37.78856028900009],
              [26.993418816000087, 37.796128648000035],
              [26.993988477000073, 37.78400299700007],
              [27.021006707000083, 37.77716705900008],
              [27.067881707000083, 37.77440013200004],
              [27.039317254000082, 37.76406484600005],
              [27.033864780000044, 37.761379299000055],
              [27.03223717500009, 37.753159898000035],
              [27.03614342500009, 37.74603913000004],
              [27.042246941000087, 37.737982489000046],
              [27.047536655000044, 37.72724030200004],
            ],
          ],
          [
            [
              [20.90137780000009, 37.79242584800005],
              [20.917979363000086, 37.765285549000055],
              [20.98682701900009, 37.72988515800006],
              [20.996348504000082, 37.699286200000074],
              [20.983083530000044, 37.71230703300006],
              [20.954356316000087, 37.723863023000035],
              [20.92090905000009, 37.731675523000035],
              [20.89389082100007, 37.73346588700008],
              [20.879161004000082, 37.728216864000046],
              [20.869883660000085, 37.71914297100005],
              [20.863291863000086, 37.710598049000055],
              [20.85645592500009, 37.706732489000046],
              [20.84351647200009, 37.70156484600005],
              [20.843760613000086, 37.68992747600004],
              [20.84937584700009, 37.67829010600008],
              [20.853037957000083, 37.67259349200009],
              [20.85132897200009, 37.659409898000035],
              [20.846853061000047, 37.65330638200004],
              [20.835948113000086, 37.65151601800005],
              [20.815114780000044, 37.65151601800005],
              [20.807871941000087, 37.65607330900008],
              [20.777191602000073, 37.68626536700009],
              [20.727793816000087, 37.71849192900004],
              [20.704356316000087, 37.738348700000074],
              [20.70215905000009, 37.75454336100006],
              [20.680430535000085, 37.769964911000045],
              [20.642425977000073, 37.81110260600008],
              [20.619476759000065, 37.82282135600008],
              [20.626475457000083, 37.834418036000045],
              [20.62208092500009, 37.85130442900004],
              [20.627696160000085, 37.85761139500005],
              [20.619476759000065, 37.86440664300005],
              [20.660004102000073, 37.91054922100005],
              [20.685720248000052, 37.92959219000005],
              [20.708994988000086, 37.92523834800005],
              [20.709727410000085, 37.92206452000005],
              [20.709808790000068, 37.919623114000046],
              [20.714366082000083, 37.915269273000035],
              [20.713633660000085, 37.91315338700008],
              [20.73414147200009, 37.88190338700008],
              [20.74195397200009, 37.86229075700004],
              [20.75245201900009, 37.85488515800006],
              [20.777191602000073, 37.84332916900007],
              [20.808848504000082, 37.84955475500004],
              [20.85010826900009, 37.83641185100004],
              [20.885996941000087, 37.81395091400009],
              [20.90137780000009, 37.79242584800005],
            ],
          ],
          [
            [
              [24.991709832000083, 37.76821523600006],
              [24.994395379000082, 37.75409577000005],
              [24.985524936000047, 37.735988674000055],
              [24.97120201900009, 37.71865469000005],
              [24.95753014400009, 37.706732489000046],
              [24.959646030000044, 37.70258209800005],
              [24.963715040000068, 37.68626536700009],
              [24.95753014400009, 37.68626536700009],
              [24.94971764400009, 37.69611237200007],
              [24.926931186000047, 37.71010976800005],
              [24.916026238000086, 37.71979401200008],
              [24.89747155000009, 37.761786200000074],
              [24.892100457000083, 37.76821523600006],
              [24.87671959700009, 37.769517320000034],
              [24.865244988000086, 37.77383047100005],
              [24.854991082000083, 37.78139883000006],
              [24.84424889400009, 37.79242584800005],
              [24.828135613000086, 37.817287502000056],
              [24.816579623000052, 37.823879299000055],
              [24.799978061000047, 37.81598541900007],
              [24.794200066000087, 37.843817450000074],
              [24.775726759000065, 37.86225006700005],
              [24.753916863000086, 37.87641022300005],
              [24.738536004000082, 37.89175039300005],
              [24.731700066000087, 37.89175039300005],
              [24.724619988000086, 37.88190338700008],
              [24.71615644600007, 37.87909577000005],
              [24.712168816000087, 37.88434479400007],
              [24.718028191000087, 37.89858633000006],
              [24.709320509000065, 37.90656159100007],
              [24.695485873000052, 37.92462799700007],
              [24.683848504000082, 37.93268463700008],
              [24.695648634000065, 37.935532945000034],
              [24.696543816000087, 37.94025299700007],
              [24.692637566000087, 37.94708893400008],
              [24.690114780000044, 37.956284898000035],
              [24.693614129000082, 37.96576569200005],
              [24.701914910000085, 37.972642320000034],
              [24.757009311000047, 37.99656810100004],
              [24.77906334700009, 38.00023021000004],
              [24.793711785000085, 37.99408600500004],
              [24.79232832100007, 37.98334381700005],
              [24.79468834700009, 37.97711823100008],
              [24.80054772200009, 37.974310614000046],
              [24.810557488000086, 37.97361888200004],
              [24.82081139400009, 37.970363674000055],
              [24.830088738000086, 37.96308014500005],
              [24.834646030000044, 37.95579661700009],
              [24.830739780000044, 37.95254140800006],
              [24.830414259000065, 37.94773997600004],
              [24.83757571700005, 37.925482489000046],
              [24.84083092500009, 37.91901276200008],
              [24.848399285000085, 37.91486237200007],
              [24.875010613000086, 37.90599192900004],
              [24.953868035000085, 37.90599192900004],
              [24.963715040000068, 37.89679596600007],
              [24.959157748000052, 37.87636953300006],
              [24.943369988000086, 37.84332916900007],
              [24.98487389400009, 37.81598541900007],
              [24.978363477000073, 37.81146881700005],
              [24.97559655000009, 37.81012604400007],
              [24.97120201900009, 37.80914948100008],
              [24.97201582100007, 37.79637278900009],
              [24.965586785000085, 37.78782786700009],
              [24.95834394600007, 37.781236070000034],
              [24.95753014400009, 37.77440013200004],
              [24.964366082000083, 37.768744208000044],
              [24.980479363000086, 37.77399323100008],
              [24.991709832000083, 37.76821523600006],
            ],
          ],
          [
            [
              [23.408376498000052, 37.89858633000006],
              [23.40211022200009, 37.90599192900004],
              [23.40211022200009, 37.912176825000074],
              [23.408946160000085, 37.921942450000074],
              [23.42286217500009, 37.93301015800006],
              [23.439463738000086, 37.93960195500006],
              [23.46851647200009, 37.93203359600005],
              [23.481700066000087, 37.94171784100007],
              [23.492035352000073, 37.956284898000035],
              [23.49773196700005, 37.966864325000074],
              [23.485606316000087, 37.96625397300005],
              [23.476817254000082, 37.96112702000005],
              [23.46924889400009, 37.95530833500004],
              [23.460459832000083, 37.95254140800006],
              [23.451833530000044, 37.95416901200008],
              [23.433116082000083, 37.960150458000044],
              [23.422048373000052, 37.96002838700008],
              [23.457367384000065, 37.97361888200004],
              [23.444183790000068, 37.97915273600006],
              [23.42945397200009, 37.987941799000055],
              [23.44076582100007, 37.98883698100008],
              [23.451508009000065, 37.988267320000034],
              [23.461599155000044, 37.985663153000075],
              [23.47046959700009, 37.980454820000034],
              [23.472666863000086, 37.98786041900007],
              [23.474864129000082, 37.98940664300005],
              [23.474864129000082, 37.989935614000046],
              [23.47046959700009, 37.99408600500004],
              [23.47820071700005, 37.99884674700007],
              [23.486338738000086, 38.001206773000035],
              [23.495290561000047, 38.00185781500005],
              [23.518239780000044, 37.99909088700008],
              [23.530528191000087, 37.994574286000045],
              [23.53687584700009, 37.98802317900004],
              [23.531911655000044, 37.980454820000034],
              [23.532725457000083, 37.97508372600004],
              [23.53492272200009, 37.96820709800005],
              [23.540863477000073, 37.96234772300005],
              [23.547129754000082, 37.95888906500005],
              [23.545583530000044, 37.95758698100008],
              [23.546153191000087, 37.95254140800006],
              [23.573496941000087, 37.95254140800006],
              [23.539317254000082, 37.939520575000074],
              [23.54346764400009, 37.92885976800005],
              [23.521739129000082, 37.91396719000005],
              [23.518239780000044, 37.89858633000006],
              [23.511973504000082, 37.89858633000006],
              [23.50131269600007, 37.90607330900008],
              [23.492035352000073, 37.900091864000046],
              [23.48145592500009, 37.88971588700008],
              [23.467051629000082, 37.88422272300005],
              [23.452403191000087, 37.88540273600006],
              [23.421397332000083, 37.89297109600005],
              [23.408376498000052, 37.89858633000006],
            ],
          ],
          [
            [
              [20.733571811000047, 38.06240469000005],
              [20.71843509200005, 38.06631094000005],
              [20.70557701900009, 38.07562897300005],
              [20.681651238000086, 38.09780508000006],
              [20.653005405000044, 38.11115143400008],
              [20.61459394600007, 38.11981842700004],
              [20.580739780000044, 38.11546458500004],
              [20.56495201900009, 38.09031810100004],
              [20.546397332000083, 38.10203685100004],
              [20.509776238000086, 38.11078522300005],
              [20.496104363000086, 38.12445709800005],
              [20.493011915000068, 38.13336823100008],
              [20.491058790000068, 38.15192291900007],
              [20.48926842500009, 38.15924713700008],
              [20.472911004000082, 38.182074286000045],
              [20.468760613000086, 38.19277578300006],
              [20.481211785000085, 38.19013092700004],
              [20.497894727000073, 38.17690664300005],
              [20.509776238000086, 38.17226797100005],
              [20.509776238000086, 38.179673570000034],
              [20.49382571700005, 38.19171784100007],
              [20.483897332000083, 38.20685455900008],
              [20.457041863000086, 38.26121653900009],
              [20.445323113000086, 38.27619049700007],
              [20.435069207000083, 38.27879466400009],
              [20.427907748000052, 38.26166413000004],
              [20.42823326900009, 38.24555084800005],
              [20.43604576900009, 38.21246979400007],
              [20.434743686000047, 38.19277578300006],
              [20.425303582000083, 38.17527903900009],
              [20.412364129000082, 38.16811758000006],
              [20.398448113000086, 38.16303131700005],
              [20.386241082000083, 38.15180084800005],
              [20.380056186000047, 38.15180084800005],
              [20.37403405000009, 38.16901276200008],
              [20.34538821700005, 38.18211497600004],
              [20.339040561000047, 38.20018138200004],
              [20.343028191000087, 38.20844147300005],
              [20.350840691000087, 38.218451239000046],
              [20.356944207000083, 38.228583075000074],
              [20.355479363000086, 38.237494208000044],
              [20.351573113000086, 38.24591705900008],
              [20.353770379000082, 38.253241278000075],
              [20.359385613000086, 38.25877513200004],
              [20.36573326900009, 38.26166413000004],
              [20.379649285000085, 38.27399323100008],
              [20.392100457000083, 38.300116278000075],
              [20.39820397200009, 38.33270905200004],
              [20.399912957000083, 38.36408112200007],
              [20.405446811000047, 38.34983958500004],
              [20.40674889400009, 38.34357330900008],
              [20.413584832000083, 38.34357330900008],
              [20.427256707000083, 38.363348700000074],
              [20.435069207000083, 38.35618724200009],
              [20.442556186000047, 38.33771393400008],
              [20.455088738000086, 38.32306549700007],
              [20.463226759000065, 38.33148834800005],
              [20.466970248000052, 38.32566966400009],
              [20.47046959700009, 38.31513092700004],
              [20.47901451900009, 38.309475002000056],
              [20.489024285000085, 38.31273021000004],
              [20.506521030000044, 38.32721588700008],
              [20.52979576900009, 38.33746979400007],
              [20.53874759200005, 38.35407135600008],
              [20.53956139400009, 38.374212958000044],
              [20.53093509200005, 38.39203522300005],
              [20.55128014400009, 38.38515859600005],
              [20.539235873000052, 38.41864655200004],
              [20.537771030000044, 38.42609284100007],
              [20.539724155000044, 38.43927643400008],
              [20.542979363000086, 38.45001862200007],
              [20.543630405000044, 38.45917389500005],
              [20.537771030000044, 38.46771881700005],
              [20.537771030000044, 38.473944403000075],
              [20.571787957000083, 38.473944403000075],
              [20.625824415000068, 38.35175202000005],
              [20.627696160000085, 38.34357330900008],
              [20.626149936000047, 38.32843659100007],
              [20.62012780000009, 38.32021719000005],
              [20.61068769600007, 38.313381252000056],
              [20.599131707000083, 38.30263906500005],
              [20.60718834700009, 38.29352448100008],
              [20.63054446700005, 38.25796133000006],
              [20.642914259000065, 38.25340403900009],
              [20.656993035000085, 38.26251862200007],
              [20.670664910000085, 38.27529531500005],
              [20.681651238000086, 38.282131252000056],
              [20.67945397200009, 38.27871328300006],
              [20.67676842500009, 38.27171458500004],
              [20.67481530000009, 38.26780833500004],
              [20.693532748000052, 38.26463450700004],
              [20.699554884000065, 38.254339911000045],
              [20.701996290000068, 38.24062734600005],
              [20.708994988000086, 38.22695547100005],
              [20.75131269600007, 38.19676341400009],
              [20.76221764400009, 38.17039622600004],
              [20.797699415000068, 38.131293036000045],
              [20.805023634000065, 38.11579010600008],
              [20.807790561000047, 38.09955475500004],
              [20.804698113000086, 38.08295319200005],
              [20.79468834700009, 38.066107489000046],
              [20.789317254000082, 38.06500885600008],
              [20.763682488000086, 38.06989166900007],
              [20.75440514400009, 38.068793036000045],
              [20.743418816000087, 38.06362539300005],
              [20.733571811000047, 38.06240469000005],
            ],
          ],
          [
            [
              [20.71583092500009, 38.39203522300005],
              [20.728037957000083, 38.38922760600008],
              [20.73878014400009, 38.38426341400009],
              [20.75749759200005, 38.371527411000045],
              [20.752696160000085, 38.37205638200004],
              [20.737559441000087, 38.371527411000045],
              [20.743662957000083, 38.34438711100006],
              [20.750010613000086, 38.33470286700009],
              [20.763682488000086, 38.330511786000045],
              [20.763682488000086, 38.32306549700007],
              [20.73609459700009, 38.32005442900004],
              [20.719411655000044, 38.315619208000044],
              [20.705821160000085, 38.31826406500005],
              [20.687836134000065, 38.33673737200007],
              [20.695323113000086, 38.34357330900008],
              [20.680430535000085, 38.35639069200005],
              [20.66732832100007, 38.371527411000045],
              [20.647634311000047, 38.40566640800006],
              [20.645762566000087, 38.413275458000044],
              [20.64307701900009, 38.43602122600004],
              [20.640147332000083, 38.446600653000075],
              [20.63257897200009, 38.452378648000035],
              [20.621348504000082, 38.45840078300006],
              [20.614512566000087, 38.46710846600007],
              [20.619476759000065, 38.48139069200005],
              [20.635508660000085, 38.47296784100007],
              [20.64421634200005, 38.47866445500006],
              [20.654470248000052, 38.50185781500005],
              [20.671885613000086, 38.49754466400009],
              [20.674082879000082, 38.48501211100006],
              [20.668142123000052, 38.47064850500004],
              [20.66114342500009, 38.46088288000004],
              [20.67823326900009, 38.46185944200005],
              [20.68921959700009, 38.45799388200004],
              [20.698090040000068, 38.45209381700005],
              [20.708994988000086, 38.446600653000075],
              [20.70289147200009, 38.42601146000004],
              [20.695160352000073, 38.40867747600004],
              [20.67481530000009, 38.37767161700009],
              [20.682383660000085, 38.373928127000056],
              [20.69239342500009, 38.37132396000004],
              [20.703868035000085, 38.37051015800006],
              [20.71583092500009, 38.371527411000045],
              [20.71583092500009, 38.37767161700009],
              [20.70215905000009, 38.38515859600005],
              [20.722504102000073, 38.38515859600005],
              [20.71583092500009, 38.39203522300005],
            ],
          ],
          [
            [
              [20.94109134200005, 38.60423411700009],
              [20.91928144600007, 38.57908763200004],
              [20.909353061000047, 38.562933661000045],
              [20.90756269600007, 38.54901764500005],
              [20.89389082100007, 38.54901764500005],
              [20.89389082100007, 38.55646393400008],
              [20.93213951900009, 38.60301341400009],
              [20.94109134200005, 38.60423411700009],
            ],
          ],
          [
            [
              [26.163584832000083, 38.54279205900008],
              [26.15088951900009, 38.53042226800005],
              [26.149180535000085, 38.51048411700009],
              [26.144379102000073, 38.49290599200009],
              [26.121918165000068, 38.487534898000035],
              [26.129730665000068, 38.47846100500004],
              [26.133962436000047, 38.475897528000075],
              [26.142425977000073, 38.473944403000075],
              [26.13640384200005, 38.46771881700005],
              [26.15406334700009, 38.46727122600004],
              [26.154551629000082, 38.46088288000004],
              [26.142425977000073, 38.446600653000075],
              [26.139414910000085, 38.43146393400008],
              [26.139333530000044, 38.41889069200005],
              [26.149912957000083, 38.34357330900008],
              [26.163584832000083, 38.30263906500005],
              [26.137054884000065, 38.29962799700007],
              [26.113536004000082, 38.28424713700008],
              [26.102224155000044, 38.261704820000034],
              [26.112071160000085, 38.237494208000044],
              [26.112071160000085, 38.22260163000004],
              [26.088145379000082, 38.212591864000046],
              [26.04004967500009, 38.20018138200004],
              [26.032074415000068, 38.18968333500004],
              [26.02588951900009, 38.16714101800005],
              [26.019704623000052, 38.15924713700008],
              [26.009776238000086, 38.15672435100004],
              [25.989105665000068, 38.16380442900004],
              [25.974864129000082, 38.166001695000034],
              [25.96461022200009, 38.171861070000034],
              [25.94239342500009, 38.194973049000055],
              [25.938243035000085, 38.196478583000044],
              [25.93409264400009, 38.19550202000005],
              [25.924489780000044, 38.203111070000034],
              [25.914886915000068, 38.21503327000005],
              [25.910411004000082, 38.22695547100005],
              [25.905772332000083, 38.225043036000045],
              [25.894379102000073, 38.22247955900008],
              [25.889821811000047, 38.22064850500004],
              [25.89031009200005, 38.227443752000056],
              [25.889333530000044, 38.24127838700008],
              [25.889821811000047, 38.24799225500004],
              [25.873301629000082, 38.23973216400009],
              [25.866058790000068, 38.24567291900007],
              [25.867523634000065, 38.25971100500004],
              [25.876231316000087, 38.27529531500005],
              [25.885915561000047, 38.28188711100006],
              [25.89893639400009, 38.28571198100008],
              [25.917246941000087, 38.28896719000005],
              [25.922618035000085, 38.292181708000044],
              [25.934255405000044, 38.30263906500005],
              [25.95875084700009, 38.301214911000045],
              [25.964366082000083, 38.30263906500005],
              [25.970876498000052, 38.31435781500005],
              [25.971446160000085, 38.32664622600004],
              [25.97559655000009, 38.337225653000075],
              [25.992198113000086, 38.34357330900008],
              [25.986989780000044, 38.354803778000075],
              [25.989024285000085, 38.37929922100005],
              [25.98536217500009, 38.39203522300005],
              [25.983571811000047, 38.388006903000075],
              [25.98340905000009, 38.38703034100007],
              [25.982269727000073, 38.38686758000006],
              [25.978037957000083, 38.38515859600005],
              [25.973480665000068, 38.39272695500006],
              [25.967458530000044, 38.398504950000074],
              [25.959808790000068, 38.40273672100005],
              [25.950694207000083, 38.40566640800006],
              [25.956309441000087, 38.41453685100004],
              [25.95557701900009, 38.42820872600004],
              [25.95053144600007, 38.442572333000044],
              [25.94385826900009, 38.45343659100007],
              [25.931895379000082, 38.46320221600007],
              [25.920664910000085, 38.466457424000055],
              [25.907481316000087, 38.46832916900007],
              [25.889821811000047, 38.473944403000075],
              [25.875254754000082, 38.48354726800005],
              [25.843272332000083, 38.515326239000046],
              [25.834646030000044, 38.528550523000035],
              [25.832774285000085, 38.54409414300005],
              [25.838145379000082, 38.55516185100004],
              [25.845225457000083, 38.56590403900009],
              [25.848887566000087, 38.58038971600007],
              [25.995371941000087, 38.60423411700009],
              [26.015879754000082, 38.60203685100004],
              [26.063975457000083, 38.59003327000005],
              [26.066254102000073, 38.583197333000044],
              [26.108246290000068, 38.54279205900008],
              [26.110850457000083, 38.54718659100007],
              [26.11231530000009, 38.55170319200005],
              [26.115407748000052, 38.55516185100004],
              [26.121918165000068, 38.55646393400008],
              [26.122569207000083, 38.56085846600007],
              [26.121348504000082, 38.56232330900008],
              [26.11890709700009, 38.562567450000074],
              [26.11573326900009, 38.56329987200007],
              [26.130707227000073, 38.56720612200007],
              [26.14356530000009, 38.56439850500004],
              [26.154551629000082, 38.555975653000075],
              [26.163584832000083, 38.54279205900008],
            ],
          ],
          [
            [
              [25.58887780000009, 38.61172109600005],
              [25.595225457000083, 38.603949286000045],
              [25.622325066000087, 38.58380768400008],
              [25.62281334700009, 38.57908763200004],
              [25.621348504000082, 38.577785549000055],
              [25.61850019600007, 38.577785549000055],
              [25.61491946700005, 38.57697174700007],
              [25.60710696700005, 38.541449286000045],
              [25.604991082000083, 38.53534577000005],
              [25.59115644600007, 38.53733958500004],
              [25.580821160000085, 38.54059479400007],
              [25.571543816000087, 38.54124583500004],
              [25.560801629000082, 38.53534577000005],
              [25.557383660000085, 38.544623114000046],
              [25.559255405000044, 38.55125560100004],
              [25.56185957100007, 38.55687083500004],
              [25.560801629000082, 38.56329987200007],
              [25.556813998000052, 38.56781647300005],
              [25.545258009000065, 38.57697174700007],
              [25.54037519600007, 38.58380768400008],
              [25.528168165000068, 38.59174225500004],
              [25.52320397200009, 38.59739817900004],
              [25.526133660000085, 38.60423411700009],
              [25.53296959700009, 38.60687897300005],
              [25.539235873000052, 38.60464101800005],
              [25.54395592500009, 38.600490627000056],
              [25.54664147200009, 38.59739817900004],
              [25.552582227000073, 38.604396877000056],
              [25.560069207000083, 38.60932038000004],
              [25.567881707000083, 38.61001211100006],
              [25.574554884000065, 38.60423411700009],
              [25.580821160000085, 38.60423411700009],
              [25.580821160000085, 38.61172109600005],
              [25.58887780000009, 38.61172109600005],
            ],
          ],
          [
            [
              [20.585459832000083, 38.61790599200009],
              [20.576182488000086, 38.60797760600008],
              [20.56544030000009, 38.59369538000004],
              [20.55128014400009, 38.569525458000044],
              [20.54460696700005, 38.569525458000044],
              [20.544932488000086, 38.59471263200004],
              [20.562347852000073, 38.69122955900008],
              [20.581228061000047, 38.72435130400004],
              [20.585459832000083, 38.744574286000045],
              [20.60254967500009, 38.78172435100004],
              [20.612152540000068, 38.78583405200004],
              [20.620290561000047, 38.79559967700004],
              [20.63331139400009, 38.81655508000006],
              [20.645274285000085, 38.828192450000074],
              [20.663910352000073, 38.841009833000044],
              [20.686289910000085, 38.85008372600004],
              [20.688649936000047, 38.84650299700007],
              [20.690196160000085, 38.84137604400007],
              [20.70215905000009, 38.83698151200008],
              [20.71778405000009, 38.822699286000045],
              [20.721934441000087, 38.80735911700009],
              [20.722911004000082, 38.79315827000005],
              [20.729340040000068, 38.78172435100004],
              [20.723887566000087, 38.769964911000045],
              [20.724457227000073, 38.76040273600006],
              [20.72754967500009, 38.75214264500005],
              [20.729340040000068, 38.744574286000045],
              [20.729746941000087, 38.73582591400009],
              [20.728851759000065, 38.73061758000006],
              [20.72510826900009, 38.724676825000074],
              [20.701508009000065, 38.69798411700009],
              [20.69695071700005, 38.68984609600005],
              [20.698741082000083, 38.682806708000044],
              [20.70606530000009, 38.68040599200009],
              [20.710785352000073, 38.68805573100008],
              [20.715505405000044, 38.69912344000005],
              [20.722504102000073, 38.70726146000004],
              [20.723887566000087, 38.69245026200008],
              [20.720713738000086, 38.63841380400004],
              [20.715993686000047, 38.627020575000074],
              [20.70948326900009, 38.62567780200004],
              [20.70215905000009, 38.63841380400004],
              [20.695323113000086, 38.63841380400004],
              [20.697438998000052, 38.63373444200005],
              [20.70215905000009, 38.61790599200009],
              [20.69825280000009, 38.620347398000035],
              [20.687836134000065, 38.62474192900004],
              [20.68718509200005, 38.617254950000074],
              [20.68531334700009, 38.613267320000034],
              [20.683116082000083, 38.61001211100006],
              [20.681651238000086, 38.60423411700009],
              [20.664805535000085, 38.61090729400007],
              [20.64893639400009, 38.608587958000044],
              [20.640879754000082, 38.60057200700004],
              [20.647634311000047, 38.59003327000005],
              [20.647634311000047, 38.58380768400008],
              [20.636973504000082, 38.58466217700004],
              [20.630869988000086, 38.588324286000045],
              [20.629242384000065, 38.59487539300005],
              [20.63331139400009, 38.60423411700009],
              [20.613617384000065, 38.60700104400007],
              [20.602305535000085, 38.62677643400008],
              [20.585459832000083, 38.61790599200009],
            ],
          ],
          [
            [
              [24.676524285000085, 38.809759833000044],
              [24.678558790000068, 38.80678945500006],
              [24.68100019600007, 38.80442942900004],
              [24.68295332100007, 38.800482489000046],
              [24.683848504000082, 38.792669989000046],
              [24.682871941000087, 38.78424713700008],
              [24.679942254000082, 38.783270575000074],
              [24.675629102000073, 38.78416575700004],
              [24.670258009000065, 38.78172435100004],
              [24.664073113000086, 38.775051174000055],
              [24.657481316000087, 38.769232489000046],
              [24.650238477000073, 38.76821523600006],
              [24.64226321700005, 38.77558014500005],
              [24.635427280000044, 38.77558014500005],
              [24.625254754000082, 38.769232489000046],
              [24.61378014400009, 38.773098049000055],
              [24.60450280000009, 38.782538153000075],
              [24.600759311000047, 38.792669989000046],
              [24.59473717500009, 38.79157135600008],
              [24.581879102000073, 38.78729889500005],
              [24.56999759200005, 38.77814362200007],
              [24.566661004000082, 38.76251862200007],
              [24.532399936000047, 38.796087958000044],
              [24.57398522200009, 38.809759833000044],
              [24.56381269600007, 38.83856842700004],
              [24.556976759000065, 38.845689195000034],
              [24.546071811000047, 38.83698151200008],
              [24.54037519600007, 38.83698151200008],
              [24.536957227000073, 38.84821198100008],
              [24.52833092500009, 38.851548570000034],
              [24.516856316000087, 38.84955475500004],
              [24.505137566000087, 38.84446849200009],
              [24.50521894600007, 38.85504791900007],
              [24.482595248000052, 38.86277903900009],
              [24.477793816000087, 38.87799713700008],
              [24.474131707000083, 38.876166083000044],
              [24.470957879000082, 38.871161200000074],
              [24.46338951900009, 38.88027578300006],
              [24.454600457000083, 38.884833075000074],
              [24.445485873000052, 38.88426341400009],
              [24.436208530000044, 38.87799713700008],
              [24.434825066000087, 38.88812897300005],
              [24.43881269600007, 38.89712148600006],
              [24.44581139400009, 38.90346914300005],
              [24.453949415000068, 38.905951239000046],
              [24.462168816000087, 38.91095612200007],
              [24.462412957000083, 38.92218659100007],
              [24.457286004000082, 38.94009023600006],
              [24.457692905000044, 38.95482005400004],
              [24.461110873000052, 38.967678127000056],
              [24.47120201900009, 38.97687409100007],
              [24.491465691000087, 38.98102448100008],
              [24.560720248000052, 38.94415924700007],
              [24.57398522200009, 38.93260325700004],
              [24.57593834700009, 38.92291901200008],
              [24.572520379000082, 38.898504950000074],
              [24.57398522200009, 38.88544342700004],
              [24.57862389400009, 38.87555573100008],
              [24.584157748000052, 38.87091705900008],
              [24.600759311000047, 38.86432526200008],
              [24.642588738000086, 38.84170156500005],
              [24.663259311000047, 38.82664622600004],
              [24.676524285000085, 38.809759833000044],
            ],
          ],
          [
            [
              [24.58765709700009, 38.15924713700008],
              [24.578949415000068, 38.10932038000004],
              [24.579925977000073, 38.08421458500004],
              [24.594493035000085, 38.06240469000005],
              [24.586192254000082, 38.04832591400009],
              [24.57553144600007, 38.00446198100008],
              [24.566661004000082, 37.987941799000055],
              [24.55209394600007, 37.978176174000055],
              [24.53174889400009, 37.969183661000045],
              [24.509287957000083, 37.962551174000055],
              [24.48804772200009, 37.96002838700008],
              [24.476898634000065, 37.96246979400007],
              [24.472911004000082, 37.968410549000055],
              [24.470957879000082, 37.980454820000034],
              [24.44776451900009, 38.01056549700007],
              [24.443695509000065, 38.01154205900008],
              [24.429698113000086, 38.021185614000046],
              [24.403086785000085, 38.01190827000005],
              [24.38640384200005, 37.996527411000045],
              [24.40211022200009, 37.987941799000055],
              [24.40211022200009, 37.980454820000034],
              [24.386892123000052, 37.970363674000055],
              [24.371755405000044, 37.971909898000035],
              [24.35718834700009, 37.980454820000034],
              [24.338633660000085, 37.99673086100006],
              [24.333832227000073, 38.00299713700008],
              [24.326996290000068, 38.015285549000055],
              [24.320485873000052, 38.02317942900004],
              [24.31381269600007, 38.02924225500004],
              [24.313975457000083, 38.03510163000004],
              [24.326996290000068, 38.04254791900007],
              [24.314789259000065, 38.064886786000045],
              [24.30567467500009, 38.07176341400009],
              [24.292246941000087, 38.06989166900007],
              [24.286306186000047, 38.08624909100007],
              [24.26929772200009, 38.095404364000046],
              [24.248708530000044, 38.096869208000044],
              [24.23145592500009, 38.09031810100004],
              [24.21778405000009, 38.096869208000044],
              [24.21257571700005, 38.09589264500005],
              [24.203949415000068, 38.09031810100004],
              [24.20411217500009, 38.09487539300005],
              [24.20476321700005, 38.09682851800005],
              [24.20671634200005, 38.097357489000046],
              [24.210785352000073, 38.09780508000006],
              [24.210785352000073, 38.12445709800005],
              [24.20281009200005, 38.130072333000044],
              [24.18604576900009, 38.127386786000045],
              [24.18295332100007, 38.13499583500004],
              [24.18718509200005, 38.14215729400007],
              [24.205902540000068, 38.15688711100006],
              [24.210785352000073, 38.166001695000034],
              [24.20875084700009, 38.178615627000056],
              [24.194021030000044, 38.19212474200009],
              [24.18531334700009, 38.217962958000044],
              [24.172699415000068, 38.226548570000034],
              [24.156993035000085, 38.22955963700008],
              [24.142588738000086, 38.22695547100005],
              [24.148773634000065, 38.21320221600007],
              [24.126231316000087, 38.21747467700004],
              [24.131114129000082, 38.23582591400009],
              [24.148610873000052, 38.25657786700009],
              [24.16309655000009, 38.26780833500004],
              [24.153493686000047, 38.281317450000074],
              [24.14551842500009, 38.280910549000055],
              [24.137868686000047, 38.273871161000045],
              [24.128428582000083, 38.26780833500004],
              [24.12671959700009, 38.26508209800005],
              [24.127126498000052, 38.26044342700004],
              [24.125743035000085, 38.25608958500004],
              [24.11817467500009, 38.25421784100007],
              [24.109385613000086, 38.256293036000045],
              [24.108897332000083, 38.26072825700004],
              [24.11231530000009, 38.26544830900008],
              [24.114756707000083, 38.26780833500004],
              [24.114756707000083, 38.27529531500005],
              [24.10092207100007, 38.27529531500005],
              [24.12159264400009, 38.309475002000056],
              [24.101084832000083, 38.31875234600005],
              [24.07943769600007, 38.325384833000044],
              [24.054860873000052, 38.329291083000044],
              [24.025401238000086, 38.330511786000045],
              [24.049652540000068, 38.33649323100008],
              [24.059743686000047, 38.34125397300005],
              [24.06690514400009, 38.35101959800005],
              [24.05909264400009, 38.36005280200004],
              [24.05713951900009, 38.36896393400008],
              [24.058116082000083, 38.37555573100008],
              [24.059418165000068, 38.37767161700009],
              [24.049082879000082, 38.394517320000034],
              [24.042246941000087, 38.40151601800005],
              [24.038910352000073, 38.395412502000056],
              [23.980804884000065, 38.398871161000045],
              [23.912364129000082, 38.39203522300005],
              [23.89234459700009, 38.39411041900007],
              [23.858083530000044, 38.403509833000044],
              [23.843760613000086, 38.40566640800006],
              [23.824473504000082, 38.40412018400008],
              [23.79395592500009, 38.398504950000074],
              [23.77898196700005, 38.398871161000045],
              [23.70997155000009, 38.41250234600005],
              [23.695160352000073, 38.41120026200008],
              [23.663340691000087, 38.40420156500005],
              [23.649180535000085, 38.40566640800006],
              [23.638519727000073, 38.41551341400009],
              [23.614431186000047, 38.46088288000004],
              [23.61101321700005, 38.45693594000005],
              [23.607432488000086, 38.45380280200004],
              [23.602305535000085, 38.452378648000035],
              [23.594004754000082, 38.45343659100007],
              [23.60401451900009, 38.468410549000055],
              [23.62281334700009, 38.484808661000045],
              [23.63575280000009, 38.50092194200005],
              [23.628103061000047, 38.514878648000035],
              [23.628103061000047, 38.522365627000056],
              [23.635508660000085, 38.522365627000056],
              [23.635508660000085, 38.528550523000035],
              [23.614105665000068, 38.557928778000075],
              [23.599945509000065, 38.57135651200008],
              [23.58375084700009, 38.57697174700007],
              [23.54004967500009, 38.58226146000004],
              [23.518809441000087, 38.58869049700007],
              [23.505137566000087, 38.59739817900004],
              [23.50171959700009, 38.60504791900007],
              [23.500743035000085, 38.62262604400007],
              [23.49773196700005, 38.63100820500006],
              [23.47437584700009, 38.645697333000044],
              [23.47046959700009, 38.64899323100008],
              [23.46729576900009, 38.65228913000004],
              [23.460215691000087, 38.65375397300005],
              [23.453135613000086, 38.65802643400008],
              [23.449961785000085, 38.66941966400009],
              [23.445974155000044, 38.67674388200004],
              [23.436696811000047, 38.683254299000055],
              [23.406504754000082, 38.69806549700007],
              [23.381602410000085, 38.70726146000004],
              [23.353363477000073, 38.73139069200005],
              [23.343760613000086, 38.73456452000005],
              [23.33765709700009, 38.73895905200004],
              [23.327972852000073, 38.75820547100005],
              [23.323008660000085, 38.76251862200007],
              [23.300059441000087, 38.77216217700004],
              [23.202321811000047, 38.82990143400008],
              [23.168142123000052, 38.84446849200009],
              [23.14356530000009, 38.85065338700008],
              [23.130707227000073, 38.85150788000004],
              [23.114105665000068, 38.85065338700008],
              [23.083506707000083, 38.84564850500004],
              [23.069102410000085, 38.846584377000056],
              [23.055837436000047, 38.85443756700005],
              [23.036387566000087, 38.87445709800005],
              [23.02865644600007, 38.877386786000045],
              [23.015147332000083, 38.87799713700008],
              [22.998789910000085, 38.88080475500004],
              [22.983571811000047, 38.885972398000035],
              [22.969411655000044, 38.889105536000045],
              [22.95639082100007, 38.88544342700004],
              [22.95639082100007, 38.87799713700008],
              [22.97046959700009, 38.87767161700009],
              [22.983897332000083, 38.87352122600004],
              [22.99195397200009, 38.86469147300005],
              [22.99073326900009, 38.85065338700008],
              [22.98178144600007, 38.845038153000075],
              [22.965505405000044, 38.84096914300005],
              [22.855804884000065, 38.83295319200005],
              [22.83301842500009, 38.82273997600004],
              [22.832286004000082, 38.83388906500005],
              [22.83375084700009, 38.845404364000046],
              [22.837412957000083, 38.85447825700004],
              [22.84351647200009, 38.85814036700009],
              [22.851410352000073, 38.86127350500004],
              [22.874847852000073, 38.87490469000005],
              [22.88453209700009, 38.87799713700008],
              [22.907481316000087, 38.88231028900009],
              [22.95281009200005, 38.901597398000035],
              [22.98292076900009, 38.90766022300005],
              [23.011729363000086, 38.919623114000046],
              [23.03565514400009, 38.92641836100006],
              [23.039317254000082, 38.929388739000046],
              [23.043711785000085, 38.943060614000046],
              [23.04590905000009, 38.94684479400007],
              [23.057465040000068, 38.94993724200009],
              [23.077972852000073, 38.950506903000075],
              [23.086761915000068, 38.954331773000035],
              [23.093760613000086, 38.962591864000046],
              [23.09734134200005, 38.97207265800006],
              [23.09742272200009, 38.98094310100004],
              [23.094411655000044, 38.98786041900007],
              [23.10906009200005, 38.99176666900007],
              [23.12745201900009, 39.00580475500004],
              [23.13803144600007, 39.008978583000044],
              [23.19971764400009, 39.008978583000044],
              [23.220713738000086, 39.01471588700008],
              [23.272959832000083, 39.038763739000046],
              [23.299082879000082, 39.04246653900009],
              [23.309255405000044, 39.03823476800005],
              [23.32398522200009, 39.02480703300006],
              [23.32984459700009, 39.02195872600004],
              [23.342946811000047, 39.020697333000044],
              [23.357758009000065, 39.01675039300005],
              [23.37159264400009, 39.01032135600008],
              [23.381602410000085, 39.00153229400007],
              [23.37435957100007, 38.982489325000074],
              [23.384613477000073, 38.96751536700009],
              [23.404551629000082, 38.95783112200007],
              [23.425629102000073, 38.954331773000035],
              [23.425629102000073, 38.94428131700005],
              [23.442230665000068, 38.89834219000005],
              [23.449961785000085, 38.88544342700004],
              [23.450694207000083, 38.87457916900007],
              [23.46225019600007, 38.85586172100005],
              [23.480479363000086, 38.83808014500005],
              [23.524668816000087, 38.82318756700005],
              [23.567881707000083, 38.793850002000056],
              [23.594004754000082, 38.78925202000005],
              [23.594004754000082, 38.78172435100004],
              [23.591319207000083, 38.77415599200009],
              [23.594004754000082, 38.77020905200004],
              [23.60010826900009, 38.77049388200004],
              [23.607595248000052, 38.77558014500005],
              [23.619965040000068, 38.76552969000005],
              [23.648448113000086, 38.76117584800005],
              [23.662282748000052, 38.755072333000044],
              [23.672699415000068, 38.76044342700004],
              [23.68336022200009, 38.755072333000044],
              [23.702647332000083, 38.76508209800005],
              [23.722666863000086, 38.76194896000004],
              [23.738454623000052, 38.74941640800006],
              [23.744802280000044, 38.73118724200009],
              [23.75359134200005, 38.719183661000045],
              [23.773692254000082, 38.70815664300005],
              [23.81299889400009, 38.69367096600007],
              [23.857595248000052, 38.682521877000056],
              [23.90593509200005, 38.679388739000046],
              [23.927582227000073, 38.675482489000046],
              [23.94776451900009, 38.66941966400009],
              [23.96656334700009, 38.67011139500005],
              [23.984222852000073, 38.68622467700004],
              [24.005707227000073, 38.67804596600007],
              [24.028819207000083, 38.67792389500005],
              [24.05176842500009, 38.68016185100004],
              [24.073090040000068, 38.679388739000046],
              [24.13648522200009, 38.661810614000046],
              [24.15560957100007, 38.65265534100007],
              [24.145355665000068, 38.64996979400007],
              [24.134938998000052, 38.643866278000075],
              [24.126231316000087, 38.635199286000045],
              [24.12159264400009, 38.62474192900004],
              [24.121104363000086, 38.60809967700004],
              [24.126475457000083, 38.59857819200005],
              [24.216075066000087, 38.53953685100004],
              [24.23145592500009, 38.522365627000056],
              [24.206553582000083, 38.50682200700004],
              [24.188161655000044, 38.47410716400009],
              [24.184336785000085, 38.43964264500005],
              [24.203949415000068, 38.41868724200009],
              [24.203949415000068, 38.41250234600005],
              [24.185069207000083, 38.40761953300006],
              [24.188161655000044, 38.39883047100005],
              [24.210785352000073, 38.37767161700009],
              [24.212901238000086, 38.36579010600008],
              [24.213145379000082, 38.350043036000045],
              [24.214854363000086, 38.33641185100004],
              [24.238291863000086, 38.31317780200004],
              [24.240407748000052, 38.30329010600008],
              [24.245371941000087, 38.29800039300005],
              [24.250254754000082, 38.29507070500006],
              [24.25245201900009, 38.29238515800006],
              [24.251800977000073, 38.274644273000035],
              [24.252614780000044, 38.26557038000004],
              [24.257823113000086, 38.258978583000044],
              [24.24773196700005, 38.24591705900008],
              [24.24512780000009, 38.24115631700005],
              [24.25245201900009, 38.22797272300005],
              [24.26531009200005, 38.21629466400009],
              [24.292246941000087, 38.20018138200004],
              [24.326996290000068, 38.18593984600005],
              [24.330251498000052, 38.17999909100007],
              [24.333262566000087, 38.17096588700008],
              [24.33757571700005, 38.16282786700009],
              [24.344411655000044, 38.15924713700008],
              [24.37859134200005, 38.16445547100005],
              [24.392588738000086, 38.16400788000004],
              [24.420664910000085, 38.147365627000056],
              [24.46062259200005, 38.14402903900009],
              [24.477793816000087, 38.138739325000074],
              [24.496918165000068, 38.14630768400008],
              [24.58765709700009, 38.15924713700008],
            ],
          ],
          [
            [
              [23.436289910000085, 39.146144924000055],
              [23.425303582000083, 39.14866771000004],
              [23.41456139400009, 39.14980703300006],
              [23.404307488000086, 39.14911530200004],
              [23.395274285000085, 39.146144924000055],
              [23.398692254000082, 39.16364166900007],
              [23.41065514400009, 39.170355536000045],
              [23.42351321700005, 39.17243073100008],
              [23.42945397200009, 39.176214911000045],
              [23.433848504000082, 39.18695709800005],
              [23.44467207100007, 39.198472398000035],
              [23.458181186000047, 39.208319403000075],
              [23.47046959700009, 39.21381256700005],
              [23.48682701900009, 39.20612213700008],
              [23.503754102000073, 39.19428131700005],
              [23.512868686000047, 39.17853424700007],
              [23.505137566000087, 39.15912506700005],
              [23.489024285000085, 39.16876862200007],
              [23.47510826900009, 39.15778229400007],
              [23.460459832000083, 39.13182200700004],
              [23.45289147200009, 39.13344961100006],
              [23.444590691000087, 39.14203522300005],
              [23.436289910000085, 39.146144924000055],
            ],
          ],
          [
            [
              [23.66968834700009, 39.11815013200004],
              [23.65919030000009, 39.12299225500004],
              [23.627777540000068, 39.14728424700007],
              [23.621267123000052, 39.15574778900009],
              [23.617442254000082, 39.169134833000044],
              [23.587168816000087, 39.20758698100008],
              [23.60132897200009, 39.21381256700005],
              [23.602224155000044, 39.208644924000055],
              [23.604991082000083, 39.20750560100004],
              [23.60914147200009, 39.20807526200008],
              [23.614431186000047, 39.20758698100008],
              [23.637950066000087, 39.187567450000074],
              [23.665537957000083, 39.16966380400004],
              [23.69662519600007, 39.15534088700008],
              [23.730479363000086, 39.146144924000055],
              [23.726735873000052, 39.13149648600006],
              [23.74586022200009, 39.12881094000005],
              [23.772715691000087, 39.129339911000045],
              [23.79265384200005, 39.12441640800006],
              [23.79265384200005, 39.11815013200004],
              [23.76026451900009, 39.09064362200007],
              [23.74122155000009, 39.08026764500005],
              [23.716807488000086, 39.07721588700008],
              [23.707041863000086, 39.07982005400004],
              [23.692556186000047, 39.08893463700008],
              [23.666026238000086, 39.09275950700004],
              [23.658050977000073, 39.097723700000074],
              [23.658457879000082, 39.10431549700007],
              [23.66968834700009, 39.111395575000074],
              [23.66968834700009, 39.11815013200004],
            ],
          ],
          [
            [
              [20.14039147200009, 39.24168528900009],
              [20.15560957100007, 39.228501695000034],
              [20.173350457000083, 39.217230536000045],
              [20.190114780000044, 39.20262278900009],
              [20.201914910000085, 39.17963288000004],
              [20.181488477000073, 39.18016185100004],
              [20.168711785000085, 39.182806708000044],
              [20.15870201900009, 39.189154364000046],
              [20.13843834700009, 39.20929596600007],
              [20.128103061000047, 39.22313060100004],
              [20.125336134000065, 39.236029364000046],
              [20.14039147200009, 39.24168528900009],
            ],
          ],
          [
            [
              [23.93653405000009, 39.22125885600008],
              [23.92164147200009, 39.19041575700004],
              [23.89584394600007, 39.161769924000055],
              [23.864512566000087, 39.14398834800005],
              [23.833506707000083, 39.146144924000055],
              [23.847178582000083, 39.16030508000006],
              [23.86101321700005, 39.169175523000035],
              [23.873057488000086, 39.18016185100004],
              [23.889333530000044, 39.21747467700004],
              [23.939789259000065, 39.27977122600004],
              [23.957041863000086, 39.289496161000045],
              [23.955739780000044, 39.28579336100006],
              [23.955088738000086, 39.28217194200005],
              [23.953868035000085, 39.27875397300005],
              [23.95020592500009, 39.27521393400008],
              [23.972178582000083, 39.271918036000045],
              [23.966970248000052, 39.251166083000044],
              [23.949961785000085, 39.22898997600004],
              [23.93653405000009, 39.22125885600008],
            ],
          ],
          [
            [
              [26.61231530000009, 39.049261786000045],
              [26.61231530000009, 39.040228583000044],
              [26.610036655000044, 39.02293528900009],
              [26.59742272200009, 39.01194896000004],
              [26.567637566000087, 39.02195872600004],
              [26.551442905000044, 39.01504140800006],
              [26.539398634000065, 39.01935455900008],
              [26.529551629000082, 39.028550523000035],
              [26.51929772200009, 39.03628164300005],
              [26.526621941000087, 39.04246653900009],
              [26.517588738000086, 39.04751211100006],
              [26.51612389400009, 39.05263906500005],
              [26.51807701900009, 39.057806708000044],
              [26.51929772200009, 39.062933661000045],
              [26.520355665000068, 39.06631094000005],
              [26.526052280000044, 39.07721588700008],
              [26.526621941000087, 39.08344147300005],
              [26.515147332000083, 39.091009833000044],
              [26.51303144600007, 39.09430573100008],
              [26.505869988000086, 39.10919830900008],
              [26.48926842500009, 39.11367422100005],
              [26.454925977000073, 39.111395575000074],
              [26.437022332000083, 39.103501695000034],
              [26.452972852000073, 39.08641185100004],
              [26.49195397200009, 39.062933661000045],
              [26.528819207000083, 39.02106354400007],
              [26.547129754000082, 39.008978583000044],
              [26.547129754000082, 39.00153229400007],
              [26.54460696700005, 38.99721914300005],
              [26.543711785000085, 38.997381903000075],
              [26.54468834700009, 38.99624258000006],
              [26.547129754000082, 38.98786041900007],
              [26.52116946700005, 38.978949286000045],
              [26.48926842500009, 38.97256094000005],
              [26.424164259000065, 38.96735260600008],
              [26.407074415000068, 38.96946849200009],
              [26.375173373000052, 38.97890859600005],
              [26.339366082000083, 38.982855536000045],
              [26.32553144600007, 38.98769765800006],
              [26.300791863000086, 39.00153229400007],
              [26.27637780000009, 39.010646877000056],
              [26.217133009000065, 39.020697333000044],
              [26.16570071700005, 39.02240631700005],
              [26.15528405000009, 39.02496979400007],
              [26.146332227000073, 39.032131252000056],
              [26.115570509000065, 39.06671784100007],
              [26.104258660000085, 39.074652411000045],
              [26.087901238000086, 39.07721588700008],
              [26.087901238000086, 39.08344147300005],
              [26.093760613000086, 39.085272528000075],
              [26.10206139400009, 39.09088776200008],
              [26.109222852000073, 39.092678127000056],
              [26.113536004000082, 39.09210846600007],
              [26.117198113000086, 39.091009833000044],
              [26.121918165000068, 39.09088776200008],
              [26.160166863000086, 39.097723700000074],
              [26.16456139400009, 39.10065338700008],
              [26.18067467500009, 39.12128327000005],
              [26.191416863000086, 39.12759023600006],
              [26.202403191000087, 39.12909577000005],
              [26.213715040000068, 39.129339911000045],
              [26.22559655000009, 39.13182200700004],
              [26.252289259000065, 39.152329820000034],
              [26.28223717500009, 39.16986725500004],
              [26.283376498000052, 39.17279694200005],
              [26.29346764400009, 39.17715078300006],
              [26.290212436000047, 39.186753648000035],
              [26.280039910000085, 39.19643789300005],
              [26.269786004000082, 39.20075104400007],
              [26.23764082100007, 39.20685455900008],
              [26.22559655000009, 39.20758698100008],
              [26.204356316000087, 39.20579661700009],
              [26.187347852000073, 39.202053127000056],
              [26.173350457000083, 39.195013739000046],
              [26.160166863000086, 39.18333567900004],
              [26.145274285000085, 39.15566640800006],
              [26.142425977000073, 39.15574778900009],
              [26.09742272200009, 39.10565827000005],
              [26.082774285000085, 39.09516022300005],
              [26.063975457000083, 39.09088776200008],
              [26.042979363000086, 39.09320709800005],
              [25.95834394600007, 39.11766185100004],
              [25.94385826900009, 39.12441640800006],
              [25.92937259200005, 39.133246161000045],
              [25.919932488000086, 39.13711172100005],
              [25.906993035000085, 39.138657945000034],
              [25.888926629000082, 39.14472077000005],
              [25.854340040000068, 39.17206452000005],
              [25.834646030000044, 39.17963288000004],
              [25.834646030000044, 39.18707916900007],
              [25.845957879000082, 39.19037506700005],
              [25.849945509000065, 39.19940827000005],
              [25.851573113000086, 39.21088288000004],
              [25.85515384200005, 39.22125885600008],
              [25.85092207100007, 39.222316799000055],
              [25.848317905000044, 39.223944403000075],
              [25.845876498000052, 39.225897528000075],
              [25.842051629000082, 39.22801341400009],
              [25.849782748000052, 39.23216380400004],
              [25.853526238000086, 39.236395575000074],
              [25.854991082000083, 39.24249909100007],
              [25.85515384200005, 39.25226471600007],
              [25.858653191000087, 39.25922272300005],
              [25.866709832000083, 39.26325104400007],
              [25.876231316000087, 39.26601797100005],
              [25.883067254000082, 39.26898834800005],
              [25.91065514400009, 39.28961823100008],
              [25.917246941000087, 39.296942450000074],
              [25.924082879000082, 39.296942450000074],
              [25.936371290000068, 39.276556708000044],
              [25.968923373000052, 39.278631903000075],
              [26.006195509000065, 39.286322333000044],
              [26.033213738000086, 39.28266022300005],
              [26.037282748000052, 39.28823476800005],
              [26.041188998000052, 39.29238515800006],
              [26.04460696700005, 39.296861070000034],
              [26.046885613000086, 39.303168036000045],
              [26.05250084700009, 39.29401276200008],
              [26.05372155000009, 39.289496161000045],
              [26.060557488000086, 39.289496161000045],
              [26.073090040000068, 39.30320872600004],
              [26.094004754000082, 39.31049225500004],
              [26.13640384200005, 39.31622955900008],
              [26.162771030000044, 39.32363515800006],
              [26.172536655000044, 39.33539459800005],
              [26.17090905000009, 39.353216864000046],
              [26.163584832000083, 39.37885163000004],
              [26.343028191000087, 39.38300202000005],
              [26.362152540000068, 39.37885163000004],
              [26.354746941000087, 39.35651276200008],
              [26.373383009000065, 39.346909898000035],
              [26.400238477000073, 39.34125397300005],
              [26.417491082000083, 39.33047109600005],
              [26.411387566000087, 39.32094961100006],
              [26.379649285000085, 39.28266022300005],
              [26.38217207100007, 39.27708567900004],
              [26.424164259000065, 39.24510325700004],
              [26.45834394600007, 39.23427969000005],
              [26.466319207000083, 39.22923411700009],
              [26.470713738000086, 39.22516510600008],
              [26.504730665000068, 39.18500397300005],
              [26.517914259000065, 39.17597077000005],
              [26.539724155000044, 39.16596100500004],
              [26.526621941000087, 39.15912506700005],
              [26.530772332000083, 39.15062083500004],
              [26.537771030000044, 39.14305247600004],
              [26.547129754000082, 39.13532135600008],
              [26.547699415000068, 39.12531159100007],
              [26.55054772200009, 39.119208075000074],
              [26.556813998000052, 39.116888739000046],
              [26.567637566000087, 39.11815013200004],
              [26.566254102000073, 39.09796784100007],
              [26.57943769600007, 39.07534414300005],
              [26.597911004000082, 39.05687083500004],
              [26.61231530000009, 39.049261786000045],
            ],
          ],
          [
            [
              [25.01221764400009, 39.56386953300006],
              [25.04737389400009, 39.545355536000045],
              [25.04037519600007, 39.52057526200008],
              [24.991709832000083, 39.46698639500005],
              [24.98487389400009, 39.46698639500005],
              [24.97364342500009, 39.51463450700004],
              [24.976573113000086, 39.53766510600008],
              [24.997894727000073, 39.55019765800006],
              [24.994476759000065, 39.55817291900007],
              [24.996755405000044, 39.56195709800005],
              [25.003184441000087, 39.56321849200009],
              [25.01221764400009, 39.56386953300006],
            ],
          ],
          [
            [
              [20.092051629000082, 39.43353913000004],
              [20.096853061000047, 39.42279694200005],
              [20.105723504000082, 39.39252350500004],
              [20.11768639400009, 39.37799713700008],
              [20.117930535000085, 39.37099844000005],
              [20.105723504000082, 39.36465078300006],
              [20.096853061000047, 39.37055084800005],
              [20.07203209700009, 39.376288153000075],
              [20.048838738000086, 39.38959381700005],
              [20.032399936000047, 39.39500560100004],
              [20.014903191000087, 39.39826080900008],
              [19.999278191000087, 39.39935944200005],
              [19.990407748000052, 39.40326569200005],
              [19.964854363000086, 39.42096588700008],
              [19.95484459700009, 39.42609284100007],
              [19.937754754000082, 39.42788320500006],
              [19.923838738000086, 39.427720445000034],
              [19.91179446700005, 39.43032461100006],
              [19.907481316000087, 39.43500397300005],
              [19.914886915000068, 39.43390534100007],
              [19.921722852000073, 39.43781159100007],
              [19.92750084700009, 39.44717031500005],
              [19.892751498000052, 39.455959377000056],
              [19.879730665000068, 39.46076080900008],
              [19.879242384000065, 39.458319403000075],
              [19.878754102000073, 39.45457591400009],
              [19.878916863000086, 39.453192450000074],
              [19.865570509000065, 39.46857330900008],
              [19.85482832100007, 39.48895905200004],
              [19.847666863000086, 39.50967031500005],
              [19.84083092500009, 39.551988023000035],
              [19.828868035000085, 39.572333075000074],
              [19.809825066000087, 39.589056708000044],
              [19.78419030000009, 39.60419342700004],
              [19.760996941000087, 39.612982489000046],
              [19.74854576900009, 39.620021877000056],
              [19.72169030000009, 39.66620514500005],
              [19.718923373000052, 39.673081773000035],
              [19.701426629000082, 39.67283763200004],
              [19.689707879000082, 39.67413971600007],
              [19.68132571700005, 39.67999909100007],
              [19.67432701900009, 39.69354889500005],
              [19.677012566000087, 39.71670156500005],
              [19.671722852000073, 39.72406647300005],
              [19.653168165000068, 39.71466705900008],
              [19.653575066000087, 39.73041413000004],
              [19.65015709700009, 39.74176666900007],
              [19.64161217500009, 39.74795156500005],
              [19.626475457000083, 39.74823639500005],
              [19.63640384200005, 39.75641510600008],
              [19.662282748000052, 39.784491278000075],
              [19.667491082000083, 39.79352448100008],
              [19.676931186000047, 39.79515208500004],
              [19.769704623000052, 39.798081773000035],
              [19.799082879000082, 39.802801825000074],
              [19.824961785000085, 39.81146881700005],
              [19.851817254000082, 39.82453034100007],
              [19.865570509000065, 39.82103099200009],
              [19.874847852000073, 39.815334377000056],
              [19.882985873000052, 39.80890534100007],
              [19.892832879000082, 39.80341217700004],
              [19.918793165000068, 39.79682038000004],
              [19.928965691000087, 39.79205963700008],
              [19.934336785000085, 39.78294505400004],
              [19.94117272200009, 39.78294505400004],
              [19.94117272200009, 39.790350653000075],
              [19.948008660000085, 39.790350653000075],
              [19.94629967500009, 39.75922272300005],
              [19.933767123000052, 39.74115631700005],
              [19.912933790000068, 39.730454820000034],
              [19.851573113000086, 39.71051666900007],
              [19.84156334700009, 39.70416901200008],
              [19.835948113000086, 39.69245026200008],
              [19.839121941000087, 39.67987702000005],
              [19.847666863000086, 39.669989325000074],
              [19.858653191000087, 39.66624583500004],
              [19.858653191000087, 39.65884023600006],
              [19.844981316000087, 39.65884023600006],
              [19.844981316000087, 39.65265534100007],
              [19.903819207000083, 39.62905508000006],
              [19.92750084700009, 39.62531159100007],
              [19.92351321700005, 39.603501695000034],
              [19.917165561000047, 39.598863023000035],
              [19.90015709700009, 39.60419342700004],
              [19.91187584700009, 39.58340078300006],
              [19.932465040000068, 39.47870514500005],
              [19.93653405000009, 39.47296784100007],
              [19.948008660000085, 39.46698639500005],
              [19.96143639400009, 39.462958075000074],
              [19.989431186000047, 39.45840078300006],
              [20.002696160000085, 39.454006252000056],
              [20.023692254000082, 39.44135163000004],
              [20.032725457000083, 39.43927643400008],
              [20.05046634200005, 39.440334377000056],
              [20.065114780000044, 39.444525458000044],
              [20.074066602000073, 39.44896067900004],
              [20.081879102000073, 39.447333075000074],
              [20.092051629000082, 39.43353913000004],
            ],
          ],
          [
            [
              [25.449880405000044, 40.03620026200008],
              [25.44117272200009, 40.02606842700004],
              [25.436778191000087, 40.02252838700008],
              [25.436778191000087, 40.01630280200004],
              [25.441661004000082, 40.01675039300005],
              [25.44271894600007, 40.01504140800006],
              [25.442556186000047, 40.01211172100005],
              [25.44581139400009, 40.003159898000035],
              [25.447276238000086, 39.99323151200008],
              [25.449880405000044, 39.98843008000006],
              [25.426524285000085, 39.978216864000046],
              [25.401621941000087, 39.963771877000056],
              [25.385590040000068, 39.94440338700008],
              [25.388926629000082, 39.91950104400007],
              [25.375173373000052, 39.91974518400008],
              [25.364105665000068, 39.917222398000035],
              [25.355479363000086, 39.91258372600004],
              [25.347992384000065, 39.90643952000005],
              [25.361664259000065, 39.89988841400009],
              [25.36850019600007, 39.89899323100008],
              [25.35320071700005, 39.892645575000074],
              [25.341644727000073, 39.88385651200008],
              [25.34034264400009, 39.874212958000044],
              [25.355479363000086, 39.86554596600007],
              [25.34278405000009, 39.85464101800005],
              [25.348399285000085, 39.843736070000034],
              [25.36068769600007, 39.83356354400007],
              [25.36850019600007, 39.82453034100007],
              [25.369883660000085, 39.81712474200009],
              [25.368662957000083, 39.81631094000005],
              [25.364024285000085, 39.81598541900007],
              [25.355479363000086, 39.810248114000046],
              [25.353688998000052, 39.803168036000045],
              [25.352793816000087, 39.79328034100007],
              [25.34896894600007, 39.78766510600008],
              [25.33838951900009, 39.79352448100008],
              [25.332204623000052, 39.796087958000044],
              [25.303558790000068, 39.80341217700004],
              [25.295258009000065, 39.80768463700008],
              [25.293630405000044, 39.81708405200004],
              [25.293630405000044, 39.82648346600007],
              [25.290293816000087, 39.83075592700004],
              [25.27312259200005, 39.83567942900004],
              [25.256602410000085, 39.855902411000045],
              [25.23878014400009, 39.85805898600006],
              [25.261729363000086, 39.870428778000075],
              [25.274261915000068, 39.880072333000044],
              [25.27979576900009, 39.889105536000045],
              [25.27515709700009, 39.903631903000075],
              [25.264008009000065, 39.913275458000044],
              [25.250661655000044, 39.91852448100008],
              [25.23878014400009, 39.91950104400007],
              [25.197113477000073, 39.89280833500004],
              [25.20639082100007, 39.89288971600007],
              [25.21387780000009, 39.891791083000044],
              [25.219981316000087, 39.88930898600006],
              [25.22510826900009, 39.88540273600006],
              [25.207286004000082, 39.88312409100007],
              [25.194183790000068, 39.87360260600008],
              [25.18458092500009, 39.859808661000045],
              [25.177256707000083, 39.845038153000075],
              [25.185557488000086, 39.84804922100005],
              [25.187673373000052, 39.84906647300005],
              [25.190928582000083, 39.85187409100007],
              [25.20215905000009, 39.841009833000044],
              [25.21452884200005, 39.82469310100004],
              [25.221039259000065, 39.80996328300006],
              [25.21452884200005, 39.80341217700004],
              [25.19271894600007, 39.804388739000046],
              [25.175059441000087, 39.80703359600005],
              [25.143239780000044, 39.81708405200004],
              [25.16578209700009, 39.844916083000044],
              [25.169932488000086, 39.84845612200007],
              [25.164886915000068, 39.859076239000046],
              [25.153819207000083, 39.85578034100007],
              [25.14226321700005, 39.84609609600005],
              [25.13575280000009, 39.837591864000046],
              [25.128916863000086, 39.837591864000046],
              [25.128428582000083, 39.845404364000046],
              [25.12671959700009, 39.849676825000074],
              [25.12435957100007, 39.85297272300005],
              [25.12208092500009, 39.85805898600006],
              [25.06413821700005, 39.84414297100005],
              [25.05323326900009, 39.837591864000046],
              [25.047048373000052, 39.837591864000046],
              [25.05046634200005, 39.84393952000005],
              [25.053965691000087, 39.84910716400009],
              [25.05909264400009, 39.85366445500006],
              [25.06739342500009, 39.85805898600006],
              [25.061778191000087, 39.85993073100008],
              [25.054535352000073, 39.86395905200004],
              [25.047048373000052, 39.86554596600007],
              [25.04851321700005, 39.874212958000044],
              [25.047048373000052, 39.878566799000055],
              [25.05323326900009, 39.88271719000005],
              [25.05990644600007, 39.88540273600006],
              [25.05990644600007, 39.89280833500004],
              [25.05323326900009, 39.89280833500004],
              [25.05323326900009, 39.89899323100008],
              [25.057790561000047, 39.90021393400008],
              [25.060557488000086, 39.901678778000075],
              [25.06739342500009, 39.90643952000005],
              [25.05990644600007, 39.90643952000005],
              [25.068207227000073, 39.920803127000056],
              [25.063975457000083, 39.92951080900008],
              [25.054535352000073, 39.93695709800005],
              [25.047048373000052, 39.94745514500005],
              [25.046071811000047, 39.96161530200004],
              [25.047618035000085, 39.97492096600007],
              [25.04542076900009, 39.98468659100007],
              [25.033376498000052, 39.98843008000006],
              [25.033376498000052, 39.99526601800005],
              [25.068614129000082, 39.99689362200007],
              [25.132334832000083, 40.00885651200008],
              [25.14234459700009, 40.00678131700005],
              [25.148773634000065, 40.00218333500004],
              [25.153005405000044, 39.99750397300005],
              [25.156260613000086, 39.99526601800005],
              [25.171885613000086, 39.996975002000056],
              [25.22510826900009, 40.00885651200008],
              [25.247325066000087, 40.00242747600004],
              [25.260996941000087, 39.99091217700004],
              [25.272308790000068, 39.97638580900008],
              [25.287119988000086, 39.96108633000006],
              [25.285166863000086, 39.95335521000004],
              [25.306976759000065, 39.96002838700008],
              [25.334239129000082, 39.972357489000046],
              [25.347992384000065, 39.98159414300005],
              [25.347992384000065, 39.990301825000074],
              [25.369313998000052, 40.01422760600008],
              [25.382090691000087, 40.02252838700008],
              [25.385996941000087, 40.02187734600005],
              [25.412852410000085, 40.02252838700008],
              [25.42156009200005, 40.024318752000056],
              [25.449880405000044, 40.03620026200008],
            ],
          ],
          [
            [
              [25.690684441000087, 40.447699286000045],
              [25.695323113000086, 40.43268463700008],
              [25.68262780000009, 40.423081773000035],
              [25.589121941000087, 40.398138739000046],
              [25.567149285000085, 40.39988841400009],
              [25.53256269600007, 40.41502513200004],
              [25.466319207000083, 40.45575592700004],
              [25.451996290000068, 40.46869538000004],
              [25.443532748000052, 40.48187897300005],
              [25.461680535000085, 40.48159414300005],
              [25.520355665000068, 40.50771719000005],
              [25.54664147200009, 40.515326239000046],
              [25.57585696700005, 40.51471588700008],
              [25.656504754000082, 40.496161200000074],
              [25.671885613000086, 40.487494208000044],
              [25.688649936000047, 40.47500234600005],
              [25.697520379000082, 40.461004950000074],
              [25.690684441000087, 40.447699286000045],
            ],
          ],
          [
            [
              [24.786387566000087, 40.73505280200004],
              [24.765472852000073, 40.73432038000004],
              [24.759287957000083, 40.72337474200009],
              [24.76661217500009, 40.71149323100008],
              [24.786387566000087, 40.70783112200007],
              [24.786387566000087, 40.687933661000045],
              [24.76929772200009, 40.68341705900008],
              [24.765798373000052, 40.66966380400004],
              [24.772634311000047, 40.63947174700007],
              [24.779551629000082, 40.62799713700008],
              [24.782399936000047, 40.62018463700008],
              [24.780121290000068, 40.612209377000056],
              [24.77320397200009, 40.61147695500006],
              [24.755707227000073, 40.61994049700007],
              [24.752126498000052, 40.61562734600005],
              [24.744476759000065, 40.60846588700008],
              [24.726817254000082, 40.603176174000055],
              [24.69385826900009, 40.59857819200005],
              [24.681813998000052, 40.594956773000035],
              [24.657481316000087, 40.577378648000035],
              [24.64226321700005, 40.57062409100007],
              [24.637543165000068, 40.57982005400004],
              [24.63062584700009, 40.58706289300005],
              [24.61500084700009, 40.59857819200005],
              [24.61182701900009, 40.59910716400009],
              [24.603526238000086, 40.59780508000006],
              [24.600759311000047, 40.59857819200005],
              [24.600271030000044, 40.601223049000055],
              [24.60132897200009, 40.609808661000045],
              [24.600759311000047, 40.612209377000056],
              [24.586761915000068, 40.62201569200005],
              [24.580251498000052, 40.62518952000005],
              [24.552582227000073, 40.63035716400009],
              [24.530772332000083, 40.630926825000074],
              [24.516774936000047, 40.639105536000045],
              [24.511973504000082, 40.66681549700007],
              [24.518321160000085, 40.692694403000075],
              [24.533376498000052, 40.71820709800005],
              [24.566661004000082, 40.755560614000046],
              [24.64226321700005, 40.803941148000035],
              [24.674571160000085, 40.79169342700004],
              [24.71534264400009, 40.78803131700005],
              [24.731700066000087, 40.78351471600007],
              [24.73568769600007, 40.77728913000004],
              [24.738454623000052, 40.76788971600007],
              [24.74382571700005, 40.75934479400007],
              [24.75554446700005, 40.755560614000046],
              [24.765961134000065, 40.75364817900004],
              [24.775401238000086, 40.74876536700009],
              [24.78256269600007, 40.74213288000004],
              [24.786387566000087, 40.73505280200004],
            ],
          ],
          [
            [
              [23.884287957000083, 36.84357330900008],
              [23.887461785000085, 36.83860911700009],
              [23.889008009000065, 36.83429596600007],
              [23.884287957000083, 36.83234284100007],
              [23.876963738000086, 36.83649323100008],
              [23.87671959700009, 36.84369538000004],
              [23.884287957000083, 36.84357330900008],
            ],
          ],
          [
            [
              [23.459646030000044, 36.92137278900009],
              [23.46420332100007, 36.91705963700008],
              [23.46729576900009, 36.90639883000006],
              [23.46387780000009, 36.903998114000046],
              [23.457774285000085, 36.90643952000005],
              [23.454925977000073, 36.913275458000044],
              [23.454600457000083, 36.91518789300005],
              [23.45248457100007, 36.916449286000045],
              [23.453135613000086, 36.92137278900009],
              [23.44971764400009, 36.92914459800005],
              [23.45606530000009, 36.927801825000074],
              [23.459646030000044, 36.92137278900009],
            ],
          ],
          [
            [
              [27.565684441000087, 36.24494049700007],
              [27.616465691000087, 36.242621161000045],
              [27.618988477000073, 36.237941799000055],
              [27.618662957000083, 36.22809479400007],
              [27.614431186000047, 36.21967194200005],
              [27.610118035000085, 36.216498114000046],
              [27.602386915000068, 36.21694570500006],
              [27.582855665000068, 36.212551174000055],
              [27.568532748000052, 36.21515534100007],
              [27.55054772200009, 36.21588776200008],
              [27.531504754000082, 36.21173737200007],
              [27.51889082100007, 36.216864325000074],
              [27.517425977000073, 36.230902411000045],
              [27.526540561000047, 36.24005768400008],
              [27.53370201900009, 36.241888739000046],
              [27.548675977000073, 36.24408600500004],
              [27.565684441000087, 36.24494049700007],
            ],
          ],
          [
            [
              [27.185801629000082, 36.615668036000045],
              [27.19467207100007, 36.60691966400009],
              [27.20606530000009, 36.587103583000044],
              [27.198008660000085, 36.56830475500004],
              [27.174571160000085, 36.560532945000034],
              [27.161387566000087, 36.56037018400008],
              [27.140147332000083, 36.56321849200009],
              [27.129730665000068, 36.569525458000044],
              [27.126149936000047, 36.580064195000034],
              [27.13721764400009, 36.60008372600004],
              [27.166758660000085, 36.61505768400008],
              [27.185801629000082, 36.615668036000045],
            ],
          ],
          [
            [
              [26.871836785000085, 37.134100653000075],
              [26.87794030000009, 37.128973700000074],
              [26.886892123000052, 37.11660390800006],
              [26.886892123000052, 37.10569896000004],
              [26.879730665000068, 37.10382721600007],
              [26.87549889400009, 37.10370514500005],
              [26.875173373000052, 37.10008372600004],
              [26.869883660000085, 37.09804922100005],
              [26.861582879000082, 37.097316799000055],
              [26.849945509000065, 37.09845612200007],
              [26.83757571700005, 37.104722398000035],
              [26.83757571700005, 37.11212799700007],
              [26.84864342500009, 37.11786530200004],
              [26.852305535000085, 37.12457916900007],
              [26.843028191000087, 37.12514883000006],
              [26.82976321700005, 37.11871979400007],
              [26.817230665000068, 37.11985911700009],
              [26.810394727000073, 37.12938060100004],
              [26.81421959700009, 37.13812897300005],
              [26.81690514400009, 37.146551825000074],
              [26.80640709700009, 37.151678778000075],
              [26.795095248000052, 37.155462958000044],
              [26.788340691000087, 37.16205475500004],
              [26.776215040000068, 37.16966380400004],
              [26.772715691000087, 37.18268463700008],
              [26.78419030000009, 37.191473700000074],
              [26.798024936000047, 37.19057851800005],
              [26.801036004000082, 37.192572333000044],
              [26.800303582000083, 37.199286200000074],
              [26.80827884200005, 37.20026276200008],
              [26.817230665000068, 37.19481028900009],
              [26.823090040000068, 37.19330475500004],
              [26.826833530000044, 37.194240627000056],
              [26.830902540000068, 37.19281647300005],
              [26.834727410000085, 37.191066799000055],
              [26.841075066000087, 37.189154364000046],
              [26.849782748000052, 37.18732330900008],
              [26.85287519600007, 37.18178945500006],
              [26.84620201900009, 37.171210028000075],
              [26.844086134000065, 37.16201406500005],
              [26.854258660000085, 37.15851471600007],
              [26.86426842500009, 37.15330638200004],
              [26.869802280000044, 37.14101797100005],
              [26.871836785000085, 37.134100653000075],
            ],
          ],
          [
            [
              [26.598806186000047, 37.35541413000004],
              [26.603688998000052, 37.34943268400008],
              [26.606130405000044, 37.339544989000046],
              [26.600840691000087, 37.33734772300005],
              [26.59546959700009, 37.34162018400008],
              [26.588715040000068, 37.34479401200008],
              [26.58497155000009, 37.34560781500005],
              [26.581309441000087, 37.34674713700008],
              [26.572438998000052, 37.34715403900009],
              [26.563731316000087, 37.34170156500005],
              [26.559743686000047, 37.33437734600005],
              [26.558441602000073, 37.329738674000055],
              [26.554698113000086, 37.32713450700004],
              [26.548838738000086, 37.32656484600005],
              [26.553884311000047, 37.31989166900007],
              [26.565196160000085, 37.30841705900008],
              [26.56771894600007, 37.274644273000035],
              [26.557302280000044, 37.27122630400004],
              [26.546397332000083, 37.27716705900008],
              [26.54737389400009, 37.283636786000045],
              [26.544769727000073, 37.288397528000075],
              [26.532725457000083, 37.29173411700009],
              [26.528575066000087, 37.30072663000004],
              [26.533864780000044, 37.32514069200005],
              [26.537364129000082, 37.33148834800005],
              [26.53882897200009, 37.33812083500004],
              [26.535817905000044, 37.34707265800006],
              [26.53370201900009, 37.360663153000075],
              [26.536387566000087, 37.372707424000055],
              [26.545095248000052, 37.373114325000074],
              [26.55640709700009, 37.37205638200004],
              [26.568614129000082, 37.37441640800006],
              [26.58057701900009, 37.37010325700004],
              [26.59034264400009, 37.364447333000044],
              [26.59669030000009, 37.35919830900008],
              [26.598806186000047, 37.35541413000004],
            ],
          ],
          [
            [
              [24.739431186000047, 37.61383698100008],
              [24.737803582000083, 37.607855536000045],
              [24.74122155000009, 37.595689195000034],
              [24.71810957100007, 37.59357330900008],
              [24.67237389400009, 37.600490627000056],
              [24.659678582000083, 37.60687897300005],
              [24.677907748000052, 37.609442450000074],
              [24.694021030000044, 37.61517975500004],
              [24.703868035000085, 37.624701239000046],
              [24.716075066000087, 37.63104889500005],
              [24.73292076900009, 37.632066148000035],
              [24.741058790000068, 37.62592194200005],
              [24.739431186000047, 37.61383698100008],
            ],
          ],
          [
            [
              [20.945160352000073, 38.65249258000006],
              [20.95167076900009, 38.64923737200007],
              [20.95289147200009, 38.63886139500005],
              [20.941661004000082, 38.627386786000045],
              [20.92904707100007, 38.61933014500005],
              [20.91456139400009, 38.612616278000075],
              [20.906097852000073, 38.60976797100005],
              [20.89812259200005, 38.60602448100008],
              [20.886973504000082, 38.59634023600006],
              [20.87867272200009, 38.584418036000045],
              [20.870616082000083, 38.58250560100004],
              [20.867360873000052, 38.592230536000045],
              [20.87012780000009, 38.603501695000034],
              [20.88835696700005, 38.628973700000074],
              [20.903819207000083, 38.64276764500005],
              [20.921397332000083, 38.648098049000055],
              [20.945160352000073, 38.65249258000006],
            ],
          ],
          [
            [
              [20.800954623000052, 38.665269273000035],
              [20.805023634000065, 38.665676174000055],
              [20.805349155000044, 38.66193268400008],
              [20.801931186000047, 38.656683661000045],
              [20.79664147200009, 38.65106842700004],
              [20.788584832000083, 38.64472077000005],
              [20.762868686000047, 38.639105536000045],
              [20.759613477000073, 38.627386786000045],
              [20.773285352000073, 38.618475653000075],
              [20.781586134000065, 38.61188385600008],
              [20.783213738000086, 38.609361070000034],
              [20.79070071700005, 38.60521067900004],
              [20.800059441000087, 38.59544505400004],
              [20.787119988000086, 38.59979889500005],
              [20.75171959700009, 38.62604401200008],
              [20.736989780000044, 38.65216705900008],
              [20.746429884000065, 38.66347890800006],
              [20.761973504000082, 38.666083075000074],
              [20.783050977000073, 38.674994208000044],
              [20.78842207100007, 38.67084381700005],
              [20.79273522200009, 38.66864655200004],
              [20.797618035000085, 38.669989325000074],
              [20.79981530000009, 38.66876862200007],
              [20.798838738000086, 38.665716864000046],
              [20.800954623000052, 38.665269273000035],
            ],
          ],
          [
            [
              [24.081309441000087, 39.35236237200007],
              [24.090586785000085, 39.34902578300006],
              [24.09473717500009, 39.34552643400008],
              [24.094004754000082, 39.33002350500004],
              [24.081879102000073, 39.304754950000074],
              [24.063161655000044, 39.29702383000006],
              [24.05372155000009, 39.30524323100008],
              [24.054698113000086, 39.312201239000046],
              [24.059418165000068, 39.314439195000034],
              [24.05600019600007, 39.31891510600008],
              [24.045746290000068, 39.32330963700008],
              [24.04151451900009, 39.330511786000045],
              [24.044932488000086, 39.341498114000046],
              [24.050791863000086, 39.351996161000045],
              [24.058604363000086, 39.36127350500004],
              [24.067149285000085, 39.36302317900004],
              [24.069102410000085, 39.35333893400008],
              [24.069834832000083, 39.345689195000034],
              [24.07398522200009, 39.348944403000075],
              [24.081309441000087, 39.35236237200007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Austria',
        iso3: 'AUT',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [16.945042766000142, 48.60416615800007],
            [16.95434452300006, 48.55739898700004],
            [16.9490548790001, 48.54483608300002],
            [16.946903117000147, 48.539725647000054],
            [16.930470012000086, 48.528201803000016],
            [16.913933553000078, 48.51933929500011],
            [16.90649214700008, 48.509908346000046],
            [16.90122115000014, 48.49660166500003],
            [16.875072876000047, 48.471538595000126],
            [16.864944295000072, 48.45807688500007],
            [16.860810181000147, 48.443788351000094],
            [16.851921834000052, 48.39040659600009],
            [16.849338012000146, 48.38410207100007],
            [16.846857544000073, 48.38113067600007],
            [16.845100545000093, 48.37658315100002],
            [16.84448042800011, 48.365601909000034],
            [16.84758101400007, 48.3595816040001],
            [16.855332479000083, 48.356455180000054],
            [16.875486287000058, 48.35503407800006],
            [16.881170695000094, 48.35281199200007],
            [16.89171268700005, 48.347024231],
            [16.90194462100004, 48.33940195800004],
            [16.90649214700008, 48.331469625000054],
            [16.904218384000046, 48.32702545200006],
            [16.900290975000075, 48.32123769100009],
            [16.89843062300008, 48.316173401000114],
            [16.902771444000052, 48.31410634400005],
            [16.905458618000097, 48.31198761000006],
            [16.908869263000014, 48.30697499600011],
            [16.912073201000084, 48.301238912000045],
            [16.913313435000106, 48.29669138600012],
            [16.916620727000122, 48.290800273000016],
            [16.924268839000092, 48.28751882000002],
            [16.933363892000074, 48.284728292000054],
            [16.944422648000085, 48.27801035600005],
            [16.950623820000146, 48.27658925400006],
            [16.95434452300006, 48.273126933000114],
            [16.955274699000114, 48.26878611300005],
            [16.95393111200005, 48.257339784000024],
            [16.95434452300006, 48.252559713000025],
            [16.96995080500011, 48.216644593000055],
            [16.974705037000092, 48.198557842000056],
            [16.974808390000135, 48.176879578000054],
            [16.98193973800008, 48.16129913400003],
            [17.007157837000108, 48.142798971],
            [17.020903768000068, 48.13716624000007],
            [17.036923462000118, 48.13551259400002],
            [17.047465454000076, 48.13099090600009],
            [17.06245529600008, 48.11272448800004],
            [17.06720585100004, 48.10693552700006],
            [17.080228312000088, 48.09760793100013],
            [17.0699963780001, 48.08915883400003],
            [17.064828735000077, 48.079030254000074],
            [17.05914432700004, 48.060426737000014],
            [17.063071737000115, 48.05877309200007],
            [17.075060669000067, 48.052080994000065],
            [17.069686320000102, 48.0356737260001],
            [17.09263065600004, 48.02725046800002],
            [17.12498010300004, 48.01952484100009],
            [17.148337850000075, 48.005443014],
            [17.085602661000053, 47.97014801100009],
            [17.096144653000096, 47.96193145800005],
            [17.095731242000085, 47.955730286000076],
            [17.09087365700006, 47.94947743800007],
            [17.088083130000115, 47.94089915000005],
            [17.086119426000067, 47.939219666],
            [17.076817668000047, 47.934956360000044],
            [17.074130493000013, 47.93211415700007],
            [17.07516402200011, 47.92777333600007],
            [17.080124959000045, 47.92575795500004],
            [17.08539595500008, 47.92462107400003],
            [17.087463013000047, 47.922631531],
            [17.083328898000104, 47.904829],
            [17.07754113800013, 47.89172902500009],
            [17.06761926200005, 47.881626282000056],
            [17.051186157000075, 47.87289296500008],
            [17.016562948000086, 47.86769948300007],
            [17.00405725100009, 47.86328114800007],
            [17.004367310000077, 47.8523774210001],
            [17.010671834000078, 47.84788157200008],
            [17.031652466000082, 47.841344504000105],
            [17.03950728300012, 47.83736541800003],
            [17.04911910000004, 47.81868438800005],
            [17.0556303300001, 47.81235402500003],
            [17.040644165000117, 47.80111440000006],
            [17.041987752000097, 47.78390614900009],
            [17.048705689000116, 47.76364898700008],
            [17.05056604000012, 47.73098948200003],
            [17.055526977000056, 47.72091257800007],
            [17.064001912000066, 47.71329030400001],
            [17.075370728000053, 47.70848439600009],
            [17.054803508000077, 47.70202484200006],
            [16.98193973800008, 47.69543609600005],
            [16.902668091000123, 47.68202606200002],
            [16.86473758900013, 47.68672861700007],
            [16.850164836000147, 47.712928569],
            [16.83693566900007, 47.705357971000055],
            [16.81729862500012, 47.68424814900003],
            [16.80623986800012, 47.676884257000026],
            [16.79745487400004, 47.67546315600002],
            [16.741127564000124, 47.68145762200005],
            [16.73037886600011, 47.68590179500005],
            [16.719216756000094, 47.69373077400009],
            [16.711568644000096, 47.704066061],
            [16.707847941000097, 47.71460805300005],
            [16.702473592000047, 47.723599752],
            [16.689864543000112, 47.72956838000003],
            [16.60976607300006, 47.75062652600006],
            [16.56780481000004, 47.75419220000002],
            [16.53111454200007, 47.74297841500008],
            [16.525120076000064, 47.73331492100006],
            [16.52687707500013, 47.720137431000055],
            [16.521399373000122, 47.71153330500003],
            [16.51292443800014, 47.706003927000026],
            [16.4730302320001, 47.69176707000007],
            [16.461144653000076, 47.6845323700001],
            [16.45453007000006, 47.68176768000005],
            [16.449879191000093, 47.68241363500003],
            [16.444918254000072, 47.685540060000065],
            [16.43913049300008, 47.69047515900009],
            [16.431792440000095, 47.68546254500005],
            [16.416599568000066, 47.66882273400002],
            [16.40781457500009, 47.66132965100009],
            [16.425901326000087, 47.65427581800007],
            [16.48191857900011, 47.63895375600002],
            [16.509617147000142, 47.64313954700005],
            [16.575452921000107, 47.624949443],
            [16.60842248600008, 47.62877349900005],
            [16.630229940000106, 47.62200388600009],
            [16.647696574000065, 47.606139221],
            [16.656171509000046, 47.585933737000104],
            [16.650590454000053, 47.56655507400005],
            [16.66754032400013, 47.560095521000065],
            [16.681389608000103, 47.55056121900007],
            [16.689141072000012, 47.538029684],
            [16.68800419100009, 47.5226301070001],
            [16.677358846000118, 47.50986602800005],
            [16.64821333900008, 47.50154612200008],
            [16.636844523000093, 47.493200378],
            [16.64087528400009, 47.45291860000005],
            [16.626973417000045, 47.44554893500002],
            [16.589405558000124, 47.42563344400004],
            [16.48191857900011, 47.39230214500007],
            [16.469929647000043, 47.40553131200009],
            [16.456597128000027, 47.411835836000094],
            [16.444091430000128, 47.40951039700006],
            [16.433962850000086, 47.39684967100003],
            [16.436443319000148, 47.35850575800002],
            [16.434272908000054, 47.3555602010001],
            [16.429311971000118, 47.35380320200004],
            [16.42497115000012, 47.351116028],
            [16.42435103400007, 47.34519907700009],
            [16.42714156100004, 47.34137502000006],
            [16.431689087000052, 47.33972137500011],
            [16.436133260000076, 47.338558655000085],
            [16.43882043500011, 47.33656911300004],
            [16.469206177000046, 47.29323842400008],
            [16.473236938000042, 47.276805319000104],
            [16.46662235500014, 47.26342112300007],
            [16.452463012000095, 47.25458445300008],
            [16.42135380000005, 47.243138123000065],
            [16.42135380000005, 47.24303477000002],
            [16.424661092000065, 47.22559397400009],
            [16.409261515000082, 47.20368316600003],
            [16.41277551200011, 47.18717254600004],
            [16.418769979000047, 47.18365855000009],
            [16.426728149000013, 47.18412363700013],
            [16.435099732000083, 47.183581034000085],
            [16.441817667000123, 47.177121480000025],
            [16.4421277270001, 47.16833648700005],
            [16.433962850000086, 47.15128326500009],
            [16.43365279200009, 47.145753886000094],
            [16.447088664000148, 47.139707743000045],
            [16.480885051000115, 47.150766501000064],
            [16.49731815600009, 47.149681295000065],
            [16.50951379300011, 47.13753733400007],
            [16.504759563000107, 47.12583262100007],
            [16.48191857900011, 47.1052395630001],
            [16.46083459500008, 47.09629954000006],
            [16.454323364000118, 47.081700949],
            [16.46176477100005, 47.068497620000116],
            [16.48191857900011, 47.06389841700006],
            [16.493700805000117, 47.05981597900005],
            [16.497214803000077, 47.05462249800003],
            [16.493184041000063, 47.04914479600005],
            [16.48191857900011, 47.04420969700003],
            [16.43716678800004, 47.03178151500005],
            [16.424661092000065, 47.024081726000034],
            [16.453289836000124, 47.02167877300009],
            [16.46755253100011, 47.0184231570001],
            [16.48191857900011, 47.00937978100005],
            [16.486362752000105, 46.998553569000094],
            [16.467449178000066, 46.99542714500005],
            [16.441404256000112, 46.995220439],
            [16.42476444500008, 46.99310170500003],
            [16.42476444500008, 46.9929983520001],
            [16.420423625000097, 46.99025950100004],
            [16.415566040000073, 46.98943267900002],
            [16.41039839600009, 46.9904145310001],
            [16.405024048000115, 46.993153382000045],
            [16.387764120000043, 47.002041728000066],
            [16.366576782000067, 47.003824565000045],
            [16.3258557530001, 47.0004397580001],
            [16.288545369000076, 47.00558156400011],
            [16.274902791000073, 47.00431549100007],
            [16.26539432800007, 46.99325673500006],
            [16.2610535070001, 46.97808970200005],
            [16.25299198400012, 46.973516338000096],
            [16.243070109000115, 46.972017721],
            [16.232941528000055, 46.96607493100008],
            [16.230357707000053, 46.95997711200003],
            [16.231184530000093, 46.95442189500001],
            [16.230667765000135, 46.948349915000065],
            [16.223949829000105, 46.941063538],
            [16.217025187000047, 46.937394511],
            [16.196147909000075, 46.93129669200003],
            [16.170723104000047, 46.91853261300007],
            [16.159147583000106, 46.910316061000046],
            [16.122870728000066, 46.876364645000095],
            [16.110054972000086, 46.86791554800003],
            [16.09403527800012, 46.862773743],
            [16.05293554600007, 46.846059852000096],
            [16.032023560000084, 46.83755564400006],
            [16.028440945000114, 46.83694743300002],
            [15.987581828000089, 46.83001088500002],
            [15.981690715000099, 46.827685446],
            [15.97197554500005, 46.82063161200007],
            [15.972905721000103, 46.81843536400005],
            [15.977349894000014, 46.816213277000074],
            [15.978176717000053, 46.80913360700005],
            [15.971252075000052, 46.7780760700001],
            [15.97098466500006, 46.77504987900009],
            [15.96970178200013, 46.76053192200003],
            [15.970528606000073, 46.74301361100008],
            [15.982000773000067, 46.71854482000002],
            [16.003291463000068, 46.709191386000086],
            [16.014556925000107, 46.69371429500008],
            [16.01672257900006, 46.67069134200001],
            [16.016593059000115, 46.67075696900004],
            [15.997917114000103, 46.68691884400003],
            [15.986961710000116, 46.69218984000007],
            [15.946344034000077, 46.697150777],
            [15.878544555000076, 46.72071523100003],
            [15.850742635000103, 46.72448761100004],
            [15.822940714000055, 46.72283396400009],
            [15.784609910000057, 46.71219950300009],
            [15.755141235000053, 46.704023743000064],
            [15.72868290200006, 46.7029902150001],
            [15.652098429000148, 46.71081919300012],
            [15.635975382000055, 46.71756296800005],
            [15.632874796000124, 46.702473450000056],
            [15.632978150000042, 46.689631857000066],
            [15.626983684000038, 46.6808727010001],
            [15.621745271000123, 46.67817491800007],
            [15.61664839700012, 46.675550028000046],
            [15.603729288000096, 46.67301788400006],
            [15.58863977100009, 46.67596344000005],
            [15.567349080000014, 46.675756735],
            [15.545955037000112, 46.671881002000035],
            [15.530658814000049, 46.66384531700005],
            [15.520840292000088, 46.649608460000096],
            [15.520308138000104, 46.647720171000074],
            [15.517636353000114, 46.63823964500001],
            [15.513939450000123, 46.63254522100003],
            [15.511228475000081, 46.62836944600012],
            [15.492624959000096, 46.61829254200008],
            [15.462652628000058, 46.614649353000104],
            [15.440018352000038, 46.62439036100004],
            [15.435380874000089, 46.62719528700005],
            [15.417590780000126, 46.637955424000026],
            [15.388135214000016, 46.64557769800008],
            [15.332783734000117, 46.643579675000055],
            [15.204890585000044, 46.638963115000095],
            [15.172556751000087, 46.64135951300004],
            [15.105591442000076, 46.646322596000076],
            [15.085722504000046, 46.64779516700007],
            [15.061953572000107, 46.64955678300008],
            [15.004386027000066, 46.63684438100002],
            [14.96717899500004, 46.60025746700008],
            [14.94795536200013, 46.619274394000044],
            [14.93358931500012, 46.62113474600007],
            [14.919506769000122, 46.6150167520001],
            [14.897725871000063, 46.60555430200013],
            [14.894062722000115, 46.60521546100007],
            [14.877055298000073, 46.60364227400002],
            [14.862999308000042, 46.60483083100003],
            [14.850390259000108, 46.60113596700002],
            [14.83364709500006, 46.58439280200007],
            [14.822278279000074, 46.567546285],
            [14.814519309000076, 46.55133747600003],
            [14.807188762000067, 46.536023662000034],
            [14.796662504000068, 46.51940094700011],
            [14.788585245000121, 46.506645610000064],
            [14.783004191000089, 46.50326080400002],
            [14.760886678000105, 46.49628448500003],
            [14.735255167000048, 46.49333892800003],
            [14.726366821000113, 46.49770558700003],
            [14.70972701000008, 46.492512106],
            [14.703732544000076, 46.487757874000025],
            [14.698771607000111, 46.480962423000065],
            [14.687092733000043, 46.471221416000034],
            [14.679961385000098, 46.45887074800008],
            [14.672545840000083, 46.45979050600006],
            [14.666628865000092, 46.46052439400002],
            [14.662081339000054, 46.45969757100009],
            [14.642030884000093, 46.44522817000005],
            [14.631695597000089, 46.44057729100008],
            [14.621567017000132, 46.43851023400005],
            [14.59986291500013, 46.43716664600008],
            [14.590147746000099, 46.43442779500002],
            [14.5753682860001, 46.419725851000024],
            [14.566996704000104, 46.40037302700007],
            [14.562108198000118, 46.39173666600003],
            [14.557694946000083, 46.38393992100002],
            [14.540331665000082, 46.37864308700007],
            [14.527102498000062, 46.38822906500006],
            [14.515837036000107, 46.405359803000024],
            [14.502194458000105, 46.418356426000074],
            [14.467674601000112, 46.41267201800012],
            [14.450931437000065, 46.4144806930001],
            [14.437144752000052, 46.41888413300002],
            [14.420028931000076, 46.42435089200008],
            [14.414447876000054, 46.429001770000056],
            [14.41124393700008, 46.434634502000094],
            [14.406489705000098, 46.43933705700006],
            [14.395844361000115, 46.44099070200009],
            [14.36215132700005, 46.435874736000116],
            [14.242323222000095, 46.43823746200003],
            [14.149864543000064, 46.44006052700006],
            [14.147933084000044, 46.44042465400007],
            [14.137255493000055, 46.442437643000105],
            [14.08103153500008, 46.47594980900003],
            [14.066355428000094, 46.481039938],
            [14.050025676000132, 46.48439890500002],
            [14.032455688000084, 46.484708965],
            [14.014921609000055, 46.48253065200005],
            [13.998762654000103, 46.480523174000055],
            [13.98232954900007, 46.48191843700003],
            [13.890862264000106, 46.51178741500006],
            [13.860683228000113, 46.51524973600009],
            [13.79577762900007, 46.507885845],
            [13.782135051000068, 46.50778249200006],
            [13.716092570000114, 46.51886708700006],
            [13.700951375000102, 46.51974558600001],
            [13.685345093000052, 46.51762685100003],
            [13.670255574000066, 46.51871205700003],
            [13.549229370000091, 46.545842184],
            [13.506751343000133, 46.54692738900009],
            [13.49910323000006, 46.55062225400009],
            [13.484943889000107, 46.5617326860001],
            [13.478019246000116, 46.56356720000012],
            [13.417041056000073, 46.56049245200008],
            [13.373322794000075, 46.565789286000026],
            [13.271416870000081, 46.550777283000045],
            [13.231109253000056, 46.55217254700001],
            [13.210025269000113, 46.5580119830001],
            [13.14646325700005, 46.58496124300002],
            [13.064504435000089, 46.59803538000007],
            [12.830410197000077, 46.60963674000003],
            [12.773566122000119, 46.63519073500008],
            [12.74849950400008, 46.64099604100009],
            [12.739873088000081, 46.642993876],
            [12.73201827000014, 46.64227040700008],
            [12.71599857600009, 46.637955424000026],
            [12.706593465000111, 46.63774871900007],
            [12.697395061000122, 46.640539246000046],
            [12.679204956000092, 46.65002187100002],
            [12.671367650000093, 46.65246576300008],
            [12.669593139000085, 46.65301910500001],
            [12.620190471000058, 46.65648142500005],
            [12.562002807000056, 46.651210429000045],
            [12.547326701000145, 46.6521922810001],
            [12.530790242000052, 46.657669984000094],
            [12.499887736000062, 46.67213938500002],
            [12.46963219000014, 46.67579886500003],
            [12.445627482000106, 46.6787022920001],
            [12.405009806000095, 46.690122783],
            [12.370386596000088, 46.71115509000002],
            [12.35147302300004, 46.74324615500005],
            [12.342688029000044, 46.76513112400009],
            [12.32604821800004, 46.77249501600009],
            [12.305274292000092, 46.77445872000003],
            [12.284397013000103, 46.77998809900002],
            [12.274785197000114, 46.784638977000085],
            [12.26910078900005, 46.788566387000046],
            [12.266723673000115, 46.79533599900007],
            [12.266930380000076, 46.808255107],
            [12.269617554000092, 46.81983062800005],
            [12.27333825700012, 46.82675527000002],
            [12.276128784000065, 46.833989970000076],
            [12.275818726000097, 46.84628896100013],
            [12.266620320000072, 46.868148092000084],
            [12.250807332000079, 46.8756153370001],
            [12.208742716000074, 46.876623027000065],
            [12.195100138000043, 46.88008534800012],
            [12.189002319000082, 46.884942932000044],
            [12.183524617000103, 46.891221619000035],
            [12.172155802000105, 46.89917978900009],
            [12.16099369300008, 46.90302968400006],
            [12.137429240000074, 46.90592356400005],
            [12.126887247000127, 46.908869120000034],
            [12.141563355000102, 46.91884267200005],
            [12.141666708000031, 46.927989400000044],
            [12.134742065000069, 46.937446188000095],
            [12.128230835000096, 46.94858245900012],
            [12.122133015000117, 46.9716559860001],
            [12.117792196000039, 46.9830764770001],
            [12.111177612000063, 46.9929983520001],
            [12.121719604000106, 47.01051666300005],
            [12.18228438300008, 47.033616028000026],
            [12.203575073000138, 47.053330588000094],
            [12.203896989000043, 47.067011988],
            [12.20419519100011, 47.079685567000055],
            [12.180630737000115, 47.08521494500006],
            [12.1331463140001, 47.078831606000094],
            [12.116241903000116, 47.0765591430001],
            [12.014956096000105, 47.040488994],
            [11.943642618000126, 47.038163555000054],
            [11.899510946000134, 47.027724915000036],
            [11.85703291900009, 47.01201527900007],
            [11.822513061000109, 46.99325673500006],
            [11.777141154000077, 46.98829579700002],
            [11.766082397000076, 46.9834382130001],
            [11.746445353000041, 46.97245697100003],
            [11.7348698320001, 46.97062245700003],
            [11.71616296400012, 46.97548004200003],
            [11.683813517000118, 46.991913147],
            [11.664796590000066, 46.99325673500006],
            [11.65725183100011, 46.99253326400007],
            [11.64970707200007, 46.9929983520001],
            [11.648466838000047, 46.99325673500006],
            [11.64795007300009, 46.99325673500006],
            [11.596480347000096, 47.0004397580001],
            [11.572709188000147, 46.99891530400002],
            [11.543667033000048, 46.99310170500003],
            [11.54356368000012, 46.99310170500003],
            [11.543356974000062, 46.9929983520001],
            [11.543253621000133, 46.9929983520001],
            [11.533848511000087, 46.98953603200006],
            [11.524443400000024, 46.98834747300005],
            [11.515348348000146, 46.989484355000045],
            [11.506976766000093, 46.9929983520001],
            [11.501705770000058, 46.99785593700001],
            [11.495918009000093, 47.00160247800004],
            [11.48940677900012, 47.00421213800006],
            [11.471836792000119, 47.007080181000035],
            [11.4618115640001, 47.005504049000095],
            [11.452923217000091, 47.00087900900003],
            [11.44527510600011, 46.99310170500003],
            [11.445171753000096, 46.9929983520001],
            [11.411168661000147, 46.97049326600008],
            [11.38057621200005, 46.97155263300006],
            [11.349467001000079, 46.98193959600009],
            [11.31381026200009, 46.98726226800004],
            [11.243737020000054, 46.97925242200007],
            [11.174490601000059, 46.96385284500006],
            [11.1566105550001, 46.95651479100009],
            [11.091911662000115, 46.912434795000095],
            [11.083643432000144, 46.90013580400007],
            [11.073101441000091, 46.86496999200001],
            [11.054291219000078, 46.83414499900003],
            [11.053464396000066, 46.8303209430001],
            [11.054601277000074, 46.81993398000007],
            [11.052844279000084, 46.81492136700011],
            [11.048503458000113, 46.811691590000024],
            [11.037444702000101, 46.808255107],
            [11.033310588000091, 46.80556793200007],
            [11.010883016000093, 46.779212952000094],
            [10.996930379000105, 46.76911021000005],
            [10.98266768400012, 46.76774078400008],
            [10.96571781400013, 46.771642354000065],
            [10.93088789900014, 46.773993633000075],
            [10.913731323000093, 46.772339986000034],
            [10.880348348000041, 46.76458852200004],
            [10.870426473000123, 46.76407175700008],
            [10.860194539000133, 46.766991476000086],
            [10.843141317000118, 46.77704254200002],
            [10.834149617000065, 46.78024648000009],
            [10.823917684000094, 46.78034983300002],
            [10.804900757000041, 46.7766291300001],
            [10.795082235000052, 46.77688751300006],
            [10.766350138000064, 46.78810129900002],
            [10.754774618000113, 46.790762634000046],
            [10.733690633000066, 46.78618927100011],
            [10.722941935000051, 46.786447652000064],
            [10.716947469000047, 46.79520680800006],
            [10.7215983480001, 46.80014190700008],
            [10.743819213000023, 46.81251841300006],
            [10.748676798000133, 46.819443055000036],
            [10.738961629000102, 46.829545797],
            [10.662480509000119, 46.86096506800003],
            [10.647080932000051, 46.863755596],
            [10.629407593000053, 46.86241200800002],
            [10.527708374000099, 46.84321421300008],
            [10.486263875000134, 46.84636647500007],
            [10.453811076000136, 46.864427389000056],
            [10.451433960000088, 46.88576975600007],
            [10.46383630300005, 46.91974700900009],
            [10.458461955000104, 46.936619365000084],
            [10.449573608000094, 46.94390574200007],
            [10.41557051600006, 46.96240590500007],
            [10.39469323700007, 46.98540191600004],
            [10.384357950000066, 46.9929983520001],
            [10.384357950000066, 46.993153382000045],
            [10.384254598000041, 46.993153382000045],
            [10.37898360200009, 46.995504659000076],
            [10.373402547000097, 46.99625396700007],
            [10.367924846000108, 46.995504659000076],
            [10.338882691000094, 46.98411000600008],
            [10.313664592000066, 46.96431793300009],
            [10.296197957000118, 46.941373597000066],
            [10.295681193000064, 46.922692566000094],
            [10.27077315200009, 46.92189158100008],
            [10.251342814000111, 46.925379740000025],
            [10.235116415000107, 46.92331268400007],
            [10.219923543000078, 46.90576853500009],
            [10.215169311000096, 46.89310780900006],
            [10.214342488000057, 46.884684550000074],
            [10.21165531400004, 46.877036438000076],
            [10.201423381000069, 46.86683034300002],
            [10.157808471000095, 46.851611634000065],
            [10.131970255000084, 46.84657318200003],
            [10.125187508000124, 46.846751229000105],
            [10.111299683000084, 46.84711578400005],
            [10.068098185000025, 46.856624248000045],
            [10.045567260000098, 46.86556427100008],
            [10.006913289000096, 46.89075653100012],
            [9.899943075000039, 46.91439849900003],
            [9.875138387000106, 46.92742096000008],
            [9.86242598400014, 46.93977162700013],
            [9.860772339000107, 46.94915089900009],
            [9.86397627800008, 46.959925436],
            [9.86645674600004, 46.98338653600008],
            [9.870590861000068, 46.992946676000074],
            [9.870590861000068, 46.99883779000008],
            [9.866766805000026, 47.00193837500002],
            [9.860565633000135, 47.00160247800004],
            [9.856328165000093, 47.0040829470001],
            [9.857981812000048, 47.01547760000001],
            [9.669052775000097, 47.056198629000065],
            [9.65230961100005, 47.057929790000046],
            [9.599909709000116, 47.05348561600003],
            [9.581202840000032, 47.05687042300006],
            [9.608798055000136, 47.080770773000054],
            [9.615722697000109, 47.10676401800002],
            [9.605594116000077, 47.13226633700005],
            [9.5818229570001, 47.154900615000074],
            [9.552057332000118, 47.16688954700005],
            [9.551953979000103, 47.175571188],
            [9.561875854000078, 47.19060902900007],
            [9.562909383000061, 47.19774037700002],
            [9.554331095000123, 47.211615499000104],
            [9.544822632000148, 47.220322978000056],
            [9.540378458000134, 47.22910797200005],
            [9.547096395000068, 47.24303477000002],
            [9.530249878000092, 47.253654277000024],
            [9.52115482500011, 47.2628010050001],
            [9.553297567000072, 47.299853008000056],
            [9.587404012000121, 47.32780995700007],
            [9.591228068000078, 47.334682923000045],
            [9.59639571100007, 47.35230458600002],
            [9.601046590000124, 47.36127044700005],
            [9.639803914000055, 47.39452423100009],
            [9.649519084000104, 47.409717103000034],
            [9.650345907000116, 47.452091777000035],
            [9.621717163000142, 47.46919667600007],
            [9.584510132000048, 47.480720521000094],
            [9.554951212000105, 47.510899557000116],
            [9.553058591000081, 47.51689133800009],
            [9.547481674000068, 47.53454710200005],
            [9.549886922000042, 47.53353383400007],
            [9.554143852000095, 47.5327431110001],
            [9.612622111000064, 47.5218807990001],
            [9.676700887000095, 47.5226301070001],
            [9.7039860430001, 47.531415100000075],
            [9.718455444000114, 47.54671132400004],
            [9.730857788000094, 47.564901429000074],
            [9.75266524200012, 47.58205800400005],
            [9.767134643000048, 47.587277324000056],
            [9.782120809000048, 47.58841420500006],
            [9.796280152000065, 47.584951885000024],
            [9.80795902500006, 47.5763219200001],
            [9.811266317000047, 47.56448801700007],
            [9.809302612000124, 47.552318217000064],
            [9.81312666900007, 47.541750387],
            [9.833487182000084, 47.53461903900005],
            [9.841548706000083, 47.53503245000006],
            [9.853847697000106, 47.54040680000013],
            [9.858911988000102, 47.541336975],
            [9.88898767100008, 47.53379221600004],
            [9.918753296000148, 47.53219024700009],
            [9.933842814000059, 47.53420562800004],
            [9.945935099000053, 47.54076853400004],
            [9.948725626000083, 47.524232077000036],
            [9.95916426600013, 47.5148786430001],
            [9.971669962000135, 47.506403707000075],
            [9.980765015000088, 47.492941997000045],
            [9.980765015000088, 47.489918925000026],
            [9.981075073000085, 47.48687001600008],
            [9.982625366000093, 47.481030579],
            [9.99358077000008, 47.476586406000095],
            [10.002365764000075, 47.4791702270001],
            [10.011254110000095, 47.48444122400012],
            [10.022622924000075, 47.487955221000064],
            [10.071818888000053, 47.43912099300012],
            [10.080603881000116, 47.42739044200003],
            [10.07595300300008, 47.41687428800007],
            [10.053215373000086, 47.404859518000094],
            [10.064170776000054, 47.396177878000046],
            [10.066857951000088, 47.385790914000026],
            [10.067788127000142, 47.375042217],
            [10.073162475000117, 47.36548207600002],
            [10.082877644000064, 47.35907419900006],
            [10.089595581000083, 47.359280904000016],
            [10.097243693000053, 47.363130799000075],
            [10.110369507000115, 47.36739410400013],
            [10.11533044400008, 47.36695485500009],
            [10.125665731000083, 47.36269154900005],
            [10.130833374000076, 47.36266571100005],
            [10.135070842000118, 47.36488779700004],
            [10.146956420000066, 47.373801982000074],
            [10.190881388000093, 47.37922800800003],
            [10.209278198000078, 47.372484233000094],
            [10.208554729000099, 47.35447499600009],
            [10.190467977000083, 47.317474671000056],
            [10.192741739000098, 47.31091176400007],
            [10.193258504000141, 47.304917298000035],
            [10.190778036000069, 47.29825103800003],
            [10.185920451000129, 47.29499542300006],
            [10.172691284000052, 47.292308248000026],
            [10.168660522000067, 47.290422058],
            [10.15946211800005, 47.27913075800005],
            [10.155431355000076, 47.27287790900003],
            [10.159875529000061, 47.27112091100007],
            [10.17495085000013, 47.27237555400005],
            [10.239353882000074, 47.277735494000055],
            [10.2611613360001, 47.28349741600003],
            [10.305913126000064, 47.30217844700009],
            [10.325446818000046, 47.3143224090001],
            [10.343430216000058, 47.330755514000074],
            [10.365651082000085, 47.36111541800001],
            [10.371645549000107, 47.36739410400013],
            [10.381980835000121, 47.37212249800011],
            [10.403064819000036, 47.37710927300007],
            [10.411643107000089, 47.38103668300003],
            [10.428282918000093, 47.3960486860001],
            [10.442855672000064, 47.41628001000002],
            [10.451950724000113, 47.438759257000115],
            [10.451744018000085, 47.46020497700003],
            [10.447609904000046, 47.4725814830001],
            [10.442235555000082, 47.481392314000104],
            [10.433657267000058, 47.48785186800005],
            [10.41960127800013, 47.49304535000006],
            [10.429729858000087, 47.532913717],
            [10.430970093000042, 47.542163798],
            [10.424355509000122, 47.55335174600005],
            [10.415673868000084, 47.56438466500005],
            [10.41422692900008, 47.57301462800008],
            [10.429213094000147, 47.57701955200007],
            [10.445956258000109, 47.579060771000044],
            [10.453604370000079, 47.58110199],
            [10.457118368000124, 47.579241638000084],
            [10.461562540000045, 47.569914043000054],
            [10.460322306000108, 47.565986633000065],
            [10.455464721000084, 47.561180726000075],
            [10.451744018000085, 47.55482452400004],
            [10.453501017000065, 47.546246236000016],
            [10.458772013000072, 47.541647034000064],
            [10.466936890000085, 47.53771962500009],
            [10.482543172000135, 47.53286204000007],
            [10.525124552000108, 47.52846954400009],
            [10.536906779000105, 47.529864808000056],
            [10.549619181000054, 47.53678945000006],
            [10.569876343000061, 47.55593556700005],
            [10.58372562700012, 47.56247263600004],
            [10.607910197000109, 47.562265930000066],
            [10.73989180500007, 47.52846954400009],
            [10.74392256700014, 47.52531728100003],
            [10.74722985800014, 47.52014963800012],
            [10.752190795000104, 47.515395406000025],
            [10.760769083000127, 47.513638407000045],
            [10.79032800300007, 47.51606720000002],
            [10.830635620000123, 47.528572896000114],
            [10.844794962000066, 47.53131174700006],
            [10.858644247000115, 47.530665792],
            [10.86928959100004, 47.52658335400007],
            [10.892233928000053, 47.5148786430001],
            [10.883862346000086, 47.508005676000025],
            [10.851616252000014, 47.493097026000086],
            [10.858437540000068, 47.485164693000016],
            [10.909907267000051, 47.46898997000004],
            [10.959826701000111, 47.43250640900003],
            [10.962823934000141, 47.42795888300007],
            [10.96313399200011, 47.421240947000044],
            [10.960860229000104, 47.41431630500007],
            [10.95765629100012, 47.409717103000034],
            [10.955279175000072, 47.40961375000008],
            [10.965511108000072, 47.3960745240001],
            [10.979463745000146, 47.39054514600009],
            [11.083746785000102, 47.38951161800013],
            [11.103280477000084, 47.39356821800003],
            [11.168599487000051, 47.42426401800007],
            [11.193817587000098, 47.42894073500004],
            [11.215211629000095, 47.422997945000034],
            [11.213041219000019, 47.395816142000044],
            [11.23701908300012, 47.39395579000005],
            [11.25882653800005, 47.40072540300007],
            [11.273089233000121, 47.4111123660001],
            [11.286318400000113, 47.42320465100009],
            [11.305645385000076, 47.43540029000009],
            [11.324248901000118, 47.439431051],
            [11.36765710500012, 47.44012868300008],
            [11.383883504000039, 47.444857076000076],
            [11.392461792000063, 47.45477895100005],
            [11.388637736000135, 47.462220357],
            [11.377785685000077, 47.4670521040001],
            [11.36548669400014, 47.46932586700002],
            [11.412615600000038, 47.506093648],
            [11.435353231000107, 47.50971099900009],
            [11.459951212000107, 47.50743723600006],
            [11.482585490000048, 47.50257965100006],
            [11.529507690000116, 47.50785064800009],
            [11.551211792000089, 47.51369008400006],
            [11.569401896000045, 47.527384339],
            [11.574466186000109, 47.53663442],
            [11.58232100400005, 47.559785462],
            [11.589142293000094, 47.57037913100008],
            [11.6170475670001, 47.58676056000003],
            [11.620458211000113, 47.58965444000002],
            [11.63895837400014, 47.5892410280001],
            [11.682573283000096, 47.583349915],
            [11.764015340000128, 47.58311737100003],
            [11.820342651000118, 47.575288391000115],
            [11.830677938000122, 47.57761383100005],
            [11.840703166000054, 47.59461537700007],
            [11.851968627000105, 47.599162903],
            [11.935891154000018, 47.61073842400005],
            [12.165644572000133, 47.60396881100009],
            [12.1736027420001, 47.605079855],
            [12.202128133000144, 47.62983286600003],
            [12.205745483000044, 47.636214905000074],
            [12.206779012000112, 47.64556833900009],
            [12.20512536600009, 47.672285055000074],
            [12.202334839000116, 47.67778859500005],
            [12.197270549000052, 47.680088196000085],
            [12.18910567200004, 47.685565898000064],
            [12.181767619000112, 47.69212880500005],
            [12.178563680000053, 47.69765818300006],
            [12.17659997600012, 47.70582305900008],
            [12.192412964000113, 47.71016388000005],
            [12.216494181000058, 47.723703105000126],
            [12.22517582200004, 47.72737213200013],
            [12.239748576000096, 47.73168711400011],
            [12.242229044000055, 47.732023011000095],
            [12.239128459000113, 47.72744964600004],
            [12.236544637000122, 47.71677846300004],
            [12.233030639000049, 47.7088719690001],
            [12.226622762000119, 47.70287750200008],
            [12.223315470000017, 47.69590118400008],
            [12.22879317200011, 47.684868266000066],
            [12.238715047000113, 47.67889963900005],
            [12.249567098000057, 47.68001068200006],
            [12.271891317000012, 47.68789133700001],
            [12.293698771000038, 47.69001007100009],
            [12.35147302300004, 47.681690166000024],
            [12.36842289200004, 47.68355051700003],
            [12.407696980000111, 47.69373077400009],
            [12.424130086000076, 47.691560365],
            [12.428780965000044, 47.685798442000035],
            [12.439219604000073, 47.664481914000035],
            [12.44469730600008, 47.65629119900002],
            [12.45275883000005, 47.649754130000034],
            [12.482524454000043, 47.633579407000056],
            [12.496580444000074, 47.62890269000006],
            [12.51714766400005, 47.62854095500008],
            [12.538231649000096, 47.63133148200005],
            [12.553837931000118, 47.6360081990001],
            [12.563374919000069, 47.641761370000054],
            [12.59838301500011, 47.66287994400001],
            [12.617399943000095, 47.66933949800007],
            [12.653056681000095, 47.675127259000035],
            [12.688713419000067, 47.675127259000035],
            [12.744834025000017, 47.66536041300007],
            [12.761990600000075, 47.66685902900009],
            [12.751655314000061, 47.64939239600004],
            [12.767364950000058, 47.636369935000104],
            [12.793306518000094, 47.62479441300006],
            [12.81315026900009, 47.61182362900003],
            [12.785865112000067, 47.60267690100004],
            [12.773669474000144, 47.579500021000044],
            [12.778940470000094, 47.55482452400004],
            [12.803641805000098, 47.541336975],
            [12.81904138100009, 47.5395283000001],
            [12.828446492000126, 47.537254538000084],
            [12.83692142700005, 47.53265533500003],
            [12.882603393000068, 47.498574728000065],
            [12.931592651000074, 47.47351165800005],
            [12.942548055000145, 47.47048858700005],
            [12.951022990000126, 47.472478130000084],
            [12.959291219000079, 47.475527039],
            [12.969729858000022, 47.475733745000056],
            [12.979341674000125, 47.47224558600003],
            [12.984922729000061, 47.46826650000013],
            [12.991123901000037, 47.46568267900004],
            [13.001872599000052, 47.466018576000025],
            [13.008797241000138, 47.47010101400012],
            [13.03732263100008, 47.49304535000006],
            [13.037012573000112, 47.50136525500004],
            [13.034428751000092, 47.50743723600006],
            [13.031224812000119, 47.51255320300005],
            [13.028951050000103, 47.51803090500006],
            [13.028124227000092, 47.524232077000036],
            [13.028124227000092, 47.541647034000064],
            [13.030604696000069, 47.54425669400008],
            [13.040113159000043, 47.56045725500009],
            [13.041250041000069, 47.56190419600007],
            [13.039079631000078, 47.561335755000115],
            [13.038252807000049, 47.58402170900008],
            [13.040939982000083, 47.583349915],
            [13.057063029000062, 47.5976642860001],
            [13.057683146000016, 47.60042897600003],
            [13.069568725000067, 47.62024688700002],
            [13.072049194000044, 47.622417298000116],
            [13.07421960400012, 47.63450958300008],
            [13.074839722000092, 47.646653545],
            [13.072049194000044, 47.659469299000065],
            [13.064091024000078, 47.67399037700004],
            [13.044557332000068, 47.69657297800005],
            [13.032258341000102, 47.706624044000094],
            [13.01985599800014, 47.712928569],
            [13.004353068000029, 47.71460805300005],
            [12.979031616000043, 47.70708913200012],
            [12.96404545100009, 47.705357971000055],
            [12.90833825600015, 47.71236012900006],
            [12.892008504000103, 47.723548076],
            [12.91061201900007, 47.742926738000065],
            [12.910818726000116, 47.743081767],
            [12.917226603000074, 47.75016143800012],
            [12.91898360200014, 47.75677602200001],
            [12.91929366100004, 47.763183899000055],
            [12.921257365000145, 47.76954010100009],
            [12.926735067000038, 47.77739491800013],
            [12.99122725400008, 47.84710642600005],
            [12.986576375000112, 47.85025868800001],
            [12.964975626000125, 47.87196279000001],
            [12.931075887000105, 47.924879456],
            [12.914229370000044, 47.93598988900003],
            [12.906167847000063, 47.9389096070001],
            [12.88601403800007, 47.95288808200009],
            [12.86203617300015, 47.962551575000035],
            [12.853974650000083, 47.97048390700009],
            [12.848600301000118, 47.98094838500002],
            [12.84824627100005, 47.98238892000002],
            [12.845603068000088, 47.993144023000056],
            [12.830616903000134, 48.01546824200001],
            [12.760233602000113, 48.06487091100003],
            [12.750931844000064, 48.07474111],
            [12.742043498000072, 48.08678171800007],
            [12.736979207000076, 48.09995920900006],
            [12.738942912000113, 48.113446757000034],
            [12.745040731000074, 48.12062978200008],
            [12.751448608000118, 48.12210256000007],
            [12.75795983900008, 48.121895854000016],
            [12.764057658000127, 48.12375620500002],
            [12.778320353000112, 48.138716533],
            [12.782351115000012, 48.142023825000095],
            [12.82214196800004, 48.16067901700005],
            [12.835164429000145, 48.170704244],
            [12.85345788600003, 48.189979553000015],
            [12.862552938000107, 48.196645813000046],
            [12.877642456000103, 48.202046001],
            [12.933039591000068, 48.209254863000055],
            [12.931696004000088, 48.2116319790001],
            [12.947198934000113, 48.22000356100007],
            [12.979445027000054, 48.23201833200004],
            [13.01665205900008, 48.255892843000126],
            [13.032775106000145, 48.26356679300001],
            [13.136438029000118, 48.29105865500007],
            [13.274207397000055, 48.307104187000036],
            [13.307797079000068, 48.31963572200006],
            [13.405568888000062, 48.37658315100002],
            [13.41952152500005, 48.39216359500007],
            [13.425205932000068, 48.41337677000003],
            [13.427169637000105, 48.41854441300002],
            [13.431717163000144, 48.42371205700003],
            [13.436161336000055, 48.4305850220001],
            [13.438228394000106, 48.44099782400012],
            [13.436368042000112, 48.469238994000094],
            [13.438228394000106, 48.47854075200003],
            [13.442982625000099, 48.48771331900012],
            [13.456418498000062, 48.506652731000074],
            [13.45920902500012, 48.51639373800002],
            [13.457038615000045, 48.5251787320001],
            [13.447736857000109, 48.53481638600003],
            [13.443706095000096, 48.55285146100003],
            [13.440708862000093, 48.55734731100004],
            [13.44008874500011, 48.56096466100003],
            [13.445566447000118, 48.567915141000114],
            [13.454558146000068, 48.57344451900012],
            [13.487217652000112, 48.58158355700003],
            [13.520703979000132, 48.58458079100005],
            [13.624366902000105, 48.565357158000026],
            [13.641833537000139, 48.55910430900012],
            [13.658059936000143, 48.55109446300004],
            [13.673356160000111, 48.53548818000009],
            [13.71433557100005, 48.52321502700006],
            [13.716505981000125, 48.521690572000054],
            [13.72539432800005, 48.54838145000009],
            [13.733869263000145, 48.559776103],
            [13.737279907000072, 48.559259339000064],
            [13.758053833000105, 48.56148142500005],
            [13.766012003000071, 48.56375518800009],
            [13.774280233000127, 48.56920705200007],
            [13.77903446400012, 48.57393544600005],
            [13.796191040000082, 48.59858510400004],
            [13.802392211000068, 48.6117109180001],
            [13.805492798000103, 48.626128642000126],
            [13.8062162680001, 48.642923483000075],
            [13.800945272000064, 48.67522125300006],
            [13.803529093000066, 48.687158508000024],
            [13.816861612000082, 48.69558176700009],
            [13.804355916000105, 48.69956085200009],
            [13.799394979000056, 48.70260976200011],
            [13.788749634000055, 48.71651072300007],
            [13.783581991000062, 48.71527048800006],
            [13.785855754000067, 48.72477895100003],
            [13.815724731000074, 48.766430156000055],
            [13.855928996000102, 48.759298808000025],
            [13.87494592300007, 48.75242584300004],
            [13.89313602700011, 48.74302073200009],
            [13.915046834000066, 48.73098012400003],
            [13.98232954900007, 48.70648549400006],
            [13.991114543000037, 48.70018097000006],
            [14.00775435400007, 48.68328277600007],
            [14.014162231000114, 48.67506622300003],
            [14.019226521000093, 48.67191396100007],
            [14.026151164000055, 48.67005361000007],
            [14.032145630000088, 48.66726308200002],
            [14.03472945100009, 48.66116526300006],
            [14.032869100000084, 48.65491241400004],
            [14.028321574000046, 48.65398223900009],
            [14.02346398900005, 48.65460235600007],
            [14.020466756000104, 48.653155416000075],
            [14.013748820000103, 48.64380198200003],
            [14.008064412000039, 48.64240671800006],
            [14.00620406000013, 48.63951283800007],
            [14.010854939000097, 48.62587026000007],
            [14.015195760000097, 48.62039255800006],
            [14.032455688000084, 48.606129863],
            [14.040827270000136, 48.60116892500004],
            [14.074830363000075, 48.59171213900008],
            [14.216527140000096, 48.58117014600002],
            [14.31574589000013, 48.557915752],
            [14.325357706000148, 48.55863922100009],
            [14.333212525000079, 48.56070627900006],
            [14.353366333000082, 48.571429139000074],
            [14.4053528230001, 48.5862861130001],
            [14.421165812000083, 48.59706064900003],
            [14.443593384000081, 48.63651560500004],
            [14.458166137000148, 48.643181865000074],
            [14.48214400200007, 48.624474997000064],
            [14.522038208000083, 48.610625712000015],
            [14.533820434000091, 48.60871368400008],
            [14.548806599000073, 48.610935771000086],
            [14.578778930000112, 48.620495911],
            [14.594178507000095, 48.62132273400003],
            [14.600586385000042, 48.617576193],
            [14.601826619000065, 48.611194153000056],
            [14.601929973000097, 48.60452789300005],
            [14.605133911000081, 48.600316264000114],
            [14.612885376000094, 48.59974782300007],
            [14.628181600000033, 48.60328765900003],
            [14.634692831000109, 48.60233164500006],
            [14.645441529000038, 48.592900696000086],
            [14.651332641000124, 48.58349558500005],
            [14.659187459000066, 48.57695851700008],
            [14.675620565000116, 48.576235046000065],
            [14.691140439000037, 48.58653496300009],
            [14.695671020000077, 48.58954172800007],
            [14.700735310000141, 48.615534974000056],
            [14.700218546000116, 48.64610158300006],
            [14.70383589700009, 48.673102519000096],
            [14.722749471000043, 48.693411357000016],
            [14.775356079000119, 48.72400380500004],
            [14.780420370000087, 48.74312408500002],
            [14.790445597000115, 48.754854635000086],
            [14.794476359000015, 48.76699859700001],
            [14.800367472000119, 48.77650706000007],
            [14.815456991000104, 48.78033111600003],
            [14.867650187000095, 48.77557688400013],
            [14.91932662000005, 48.76157257100003],
            [14.939583781000039, 48.76281280600007],
            [14.951055949000079, 48.78033111600003],
            [14.94888553800007, 48.78213979100012],
            [14.944441366000149, 48.788599345000065],
            [14.940100545000092, 48.79650583900012],
            [14.93813684000014, 48.802810364000024],
            [14.939790487000096, 48.80978668200002],
            [14.947025187000065, 48.82239573200006],
            [14.968212524000108, 48.88502756800007],
            [14.968315877000066, 48.91267445900009],
            [14.964181763000028, 48.94326690700008],
            [14.964595174000038, 48.97174062200013],
            [14.978237753000144, 48.99282460500005],
            [14.97730757700009, 48.99825063100003],
            [14.97730757700009, 49.002901510000086],
            [14.978857869000109, 49.006260478000016],
            [14.982061808000083, 49.00791412400007],
            [15.003972616000055, 49.00977447500007],
            [15.059576457000048, 48.99721710200005],
            [15.137401164000096, 48.993031311000024],
            [15.14473921700008, 48.97892364500008],
            [15.148976684000047, 48.965332743],
            [15.148563273000036, 48.951741842],
            [15.141948689000117, 48.93747914700002],
            [15.161792440000113, 48.93722076400006],
            [15.238066854000039, 48.95075998900005],
            [15.24323449700006, 48.95293040000003],
            [15.25708378100012, 48.963885803],
            [15.260391073000108, 48.96915680000002],
            [15.262871542000084, 48.98259267200008],
            [15.26690230300008, 48.98667511100008],
            [15.27455041500005, 48.98672678700011],
            [15.279614706000132, 48.98259267200008],
            [15.283748820000142, 48.97763173500003],
            [15.288709757000106, 48.975357972000026],
            [15.335528605000036, 48.9749962370001],
            [15.357852823000087, 48.97081044600007],
            [15.405911906000142, 48.95468739900009],
            [15.45035363800011, 48.94481720000003],
            [15.471851033000064, 48.93670400000012],
            [15.521253703000099, 48.90848866800006],
            [15.54418668100007, 48.90261173300006],
            [15.603729288000096, 48.8873530070001],
            [15.681347290000076, 48.85846588200006],
            [15.703774861000085, 48.8549518840001],
            [15.726822550000037, 48.8549518840001],
            [15.743669067000042, 48.85846588200006],
            [15.779222453000074, 48.870868225000024],
            [15.787904093000037, 48.87226348900002],
            [15.818496541000059, 48.87231516500002],
            [15.82428430100012, 48.86942128500003],
            [15.828315064000037, 48.85712229500008],
            [15.833276001000058, 48.85200632800009],
            [15.84009729000013, 48.850094300000066],
            [15.859217570000112, 48.849164124000126],
            [15.87017297300008, 48.843893128],
            [15.877614379000107, 48.841671041],
            [15.885985961000102, 48.842032776000096],
            [15.875754028000102, 48.83309275300006],
            [15.888363077000122, 48.835056458000096],
            [15.899628540000094, 48.8347464000001],
            [15.90706994600012, 48.8302505490001],
            [15.908103475000104, 48.819708558000016],
            [15.925053345000094, 48.822602438],
            [15.93032434100013, 48.81831329400005],
            [15.93032434100013, 48.811388652000076],
            [15.931771281000124, 48.806427714],
            [16.032333618000052, 48.75805857400006],
            [16.085353638000072, 48.74286570200006],
            [16.177751098000073, 48.74653472900003],
            [16.317587524000146, 48.73284047500003],
            [16.318724406000058, 48.7335122680001],
            [16.3394983310001, 48.735579326000064],
            [16.352727498, 48.728447978000034],
            [16.358308553000114, 48.72725942000001],
            [16.374018188000093, 48.73030832900004],
            [16.38497359200008, 48.737077943000074],
            [16.435719848000048, 48.79454213500007],
            [16.453083130000067, 48.80219024700007],
            [16.48191857900011, 48.79939971900011],
            [16.492253865000123, 48.79970977900008],
            [16.510340617000026, 48.80477406900006],
            [16.519539022000117, 48.805600891],
            [16.528737426000134, 48.80353383400002],
            [16.54579065000007, 48.79629913400005],
            [16.605528605000103, 48.78482696500005],
            [16.624028767000112, 48.783380026000046],
            [16.643149047000122, 48.77826405900005],
            [16.651003866000053, 48.76622345],
            [16.654724569000052, 48.751857402],
            [16.661959269000135, 48.74002349900006],
            [16.675085083000084, 48.73392567900002],
            [16.69100142400012, 48.73206532800002],
            [16.729035279000044, 48.73309885700009],
            [16.744331502000108, 48.72963653600006],
            [16.780505005000123, 48.71377187100005],
            [16.798901814000118, 48.70922434500001],
            [16.818125447000057, 48.71077463800002],
            [16.856572713000105, 48.71981801400007],
            [16.87300581900007, 48.71899119100006],
            [16.89667362500009, 48.69697703000007],
            [16.910522908000075, 48.63077952100009],
            [16.945042766000142, 48.60416615800007],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Italy',
        iso3: 'ITA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7.022082560000115, 45.925259909],
              [7.066937703000093, 45.89022328800006],
              [7.090192097000113, 45.88050811800012],
              [7.120887899000138, 45.87611562100004],
              [7.153547404000022, 45.87652903300004],
              [7.183726440000044, 45.880456442000096],
              [7.245428100000083, 45.89812978200011],
              [7.273540079000043, 45.91027374300002],
              [7.286665893000105, 45.91342600500006],
              [7.361803426000108, 45.90784495100006],
              [7.393842814000038, 45.915699768000096],
              [7.452960652000087, 45.94587880500008],
              [7.482726278000058, 45.95487050400003],
              [7.503706909000073, 45.95673085500003],
              [7.514662312000041, 45.96670440700005],
              [7.524377482000091, 45.97807322300004],
              [7.541120646000138, 45.98411936500007],
              [7.643026571000121, 45.96634267200004],
              [7.6587362060001, 45.96003814700005],
              [7.673722371000053, 45.9503229780001],
              [7.692532593000067, 45.931202698],
              [7.693979533000061, 45.92867055300012],
              [7.706278523, 45.9257249970001],
              [7.714650105000089, 45.92712026],
              [7.72219486500012, 45.92960072800007],
              [7.732013387000109, 45.93037587500008],
              [7.780072469000061, 45.918128561000046],
              [7.807564331000037, 45.91849029600006],
              [7.825444376000092, 45.914666239],
              [7.831232137000143, 45.914459534000045],
              [7.843737833000148, 45.919213766000055],
              [7.846114949000111, 45.92257273300005],
              [7.845288127000089, 45.92779205300006],
              [7.848388712000116, 45.93807566300008],
              [7.84962011600004, 45.93971206200011],
              [7.870201292731351, 45.94036963077025],
              [7.872917431422034, 45.95938260160503],
              [7.883781986184766, 45.97386867462201],
              [7.898204794000065, 45.98194895400009],
              [7.969104858000037, 45.99311106400002],
              [7.978716674000026, 45.99517812100008],
              [7.985848022000084, 45.99931223600002],
              [7.998353719000079, 46.01062937500008],
              [7.999077189000076, 46.01279978400008],
              [8.008792358000107, 46.027682597000094],
              [8.010652710000102, 46.02969797800007],
              [8.015923706000137, 46.0581716920001],
              [8.016027059000066, 46.06938547800006],
              [8.018197469000143, 46.08085764600007],
              [8.025328817000087, 46.09114125600006],
              [8.035354044000115, 46.09651560500002],
              [8.056024617000048, 46.09806589800003],
              [8.066876668000077, 46.10059804300003],
              [8.110594930000076, 46.12695302300007],
              [8.132299032000077, 46.15935414700009],
              [8.129508504000114, 46.19604441300005],
              [8.099949585000076, 46.23562856100001],
              [8.076591837000109, 46.24973622600005],
              [8.073077840000082, 46.25361195900008],
              [8.07731530700002, 46.26203521800009],
              [8.087340535000038, 46.27180206300004],
              [8.106874227000048, 46.28554799500007],
              [8.128474975000131, 46.292472636000056],
              [8.171883178000115, 46.299190573],
              [8.192553752000038, 46.30916412400008],
              [8.241749715000111, 46.35412262000001],
              [8.270068400000099, 46.3640444950001],
              [8.28154056800011, 46.370116475000046],
              [8.291462443000114, 46.378358866],
              [8.297456909000033, 46.38750559600008],
              [8.297043497000118, 46.39763417600004],
              [8.290428914000131, 46.40112233500007],
              [8.286604859000079, 46.405359803000024],
              [8.294976441000074, 46.41804636600007],
              [8.316267130000142, 46.433652649000024],
              [8.343448934000037, 46.4438845830001],
              [8.385906925000114, 46.45020601800009],
              [8.399156128000072, 46.45217865000005],
              [8.427888224000071, 46.44869049100002],
              [8.441634155000116, 46.43494456000006],
              [8.445768270000116, 46.41236195900002],
              [8.446285034000084, 46.38218292300003],
              [8.442874389000053, 46.3533733120001],
              [8.426647990000049, 46.30156768800002],
              [8.423237345000103, 46.27583282500005],
              [8.427164754000074, 46.251441549],
              [8.43812015800006, 46.23537017800005],
              [8.456516968000045, 46.224828187000085],
              [8.482665242000053, 46.21754180900008],
              [8.510260457000072, 46.207878317000066],
              [8.538682495000074, 46.18762115500006],
              [8.601831095000136, 46.12281890900006],
              [8.611546264000083, 46.119356588000116],
              [8.630873250000121, 46.11470570900006],
              [8.67748539200008, 46.095792135000025],
              [8.695055379000081, 46.09517201800004],
              [8.702186727000111, 46.0979625450001],
              [8.717689656000118, 46.107522685],
              [8.723890828000094, 46.10953806600004],
              [8.728983368000115, 46.108233103000074],
              [8.732159057000047, 46.10741933200008],
              [8.739497111000048, 46.09806589800003],
              [8.747145223000103, 46.094448548000045],
              [8.763164917000068, 46.09289825500004],
              [8.793860717000115, 46.09341501900006],
              [8.8089502360001, 46.08974599300008],
              [8.834375041000015, 46.06638824500003],
              [8.819595581000101, 46.042927145000064],
              [8.790966838000116, 46.01869089800006],
              [8.773396850000069, 45.99057891900013],
              [8.769572794000112, 45.98577301000002],
              [8.767919149000079, 45.983085836],
              [8.785075724000109, 45.98231069000009],
              [8.800371948000077, 45.97853831000005],
              [8.857732788000078, 45.957092591000034],
              [8.86445072400008, 45.95342356400003],
              [8.870961954000052, 45.9470673630001],
              [8.88078047600004, 45.93109934500008],
              [8.89814375800006, 45.90955027300002],
              [8.906515340000112, 45.89647613500007],
              [8.91209639400003, 45.88340199800011],
              [8.9137500410001, 45.86609039300002],
              [8.909719279000086, 45.85368805000003],
              [8.903724812000064, 45.841802470000104],
              [8.900004109000065, 45.82640289300012],
              [8.93958825700011, 45.83482615200002],
              [8.972351115, 45.824645895000046],
              [9.002426798000073, 45.820718486],
              [9.034362834000149, 45.84810699500012],
              [9.05927087400002, 45.881955058000116],
              [9.063094930000148, 45.89895660400005],
              [9.051726115000065, 45.915544739000055],
              [9.042321004000115, 45.91973053000008],
              [9.0205135490001, 45.92277944000001],
              [9.010798380000068, 45.92665517200005],
              [9.001703329000094, 45.93606028300012],
              [8.993435099000124, 45.95425038700007],
              [8.982686401000109, 45.96184682200003],
              [8.980515991000118, 45.96437896800002],
              [8.979792521000121, 45.966911113],
              [8.980515991000118, 45.96949493400011],
              [8.982686401000109, 45.97197540300009],
              [9.015552612000135, 45.99311106400002],
              [8.997775919000105, 46.02794097900009],
              [9.002116740000105, 46.03930979500008],
              [9.027748250000059, 46.05310740200012],
              [9.049659057000014, 46.05791331000002],
              [9.059167521000091, 46.061789043],
              [9.067125692000076, 46.07114247700012],
              [9.07032963100005, 46.08344146700007],
              [9.068159220000041, 46.10597239200008],
              [9.072086629000097, 46.11889150000009],
              [9.090586792000124, 46.138166809000026],
              [9.163243856000065, 46.172273255],
              [9.16378802500006, 46.172989267],
              [9.171098673000103, 46.18260854100002],
              [9.17574955200007, 46.19413238500003],
              [9.181330607000092, 46.204054260000035],
              [9.192182658000121, 46.20963531500006],
              [9.2041715900001, 46.21356272400003],
              [9.215747111000042, 46.22105580700004],
              [9.224842163000119, 46.231184387],
              [9.239724975000058, 46.26699615500003],
              [9.2689738360001, 46.30937083000005],
              [9.275175008000076, 46.331384990000046],
              [9.273831420000107, 46.34425242100012],
              [9.260395548000076, 46.37972829200005],
              [9.260292195000147, 46.394016826000055],
              [9.262876017000053, 46.406625875000074],
              [9.26091231300012, 46.416651103],
              [9.247579794000103, 46.42303314200002],
              [9.237967977000068, 46.43654653],
              [9.245822794000105, 46.46104115800007],
              [9.263186076000125, 46.485122376],
              [9.282306355000117, 46.49736969100003],
              [9.330985555000069, 46.50150380500004],
              [9.350829305000047, 46.49786061600007],
              [9.35155277500013, 46.485484111000105],
              [9.377080933000087, 46.46868927000004],
              [9.384625691000025, 46.466415508000026],
              [9.395477742000082, 46.46941274000004],
              [9.400335327000107, 46.47540720700006],
              [9.403849324000134, 46.4825127160001],
              [9.41067061400011, 46.48889475600002],
              [9.426793660000072, 46.49711130800007],
              [9.434648478000014, 46.498325704000095],
              [9.437852417000101, 46.49204701800009],
              [9.443846883000106, 46.39613555900003],
              [9.442399943000112, 46.38089101200008],
              [9.444363648000149, 46.37528411900006],
              [9.451598348000118, 46.370374858000034],
              [9.47371586100013, 46.36187408500011],
              [9.482604207000065, 46.35680979400003],
              [9.502551310000058, 46.320739645000046],
              [9.51526371300011, 46.308595683000036],
              [9.536451050000068, 46.298622132000034],
              [9.559705444000087, 46.292731018000026],
              [9.674323771000047, 46.291800842000086],
              [9.693133992000043, 46.29707183900011],
              [9.708430217000114, 46.3117479460001],
              [9.708843628000125, 46.31962860100005],
              [9.707293335000088, 46.330971579000035],
              [9.709257039000136, 46.342392070000116],
              [9.72010909000008, 46.35089284300004],
              [9.730857788000094, 46.35071197500007],
              [9.755249064000026, 46.34053171800012],
              [9.768064819000102, 46.3386196900001],
              [9.78883874500005, 46.34329640800006],
              [9.855397990000142, 46.36696421300009],
              [9.899012899000098, 46.37215769500001],
              [9.918443237000076, 46.37115000400003],
              [9.939010457000052, 46.36745514000005],
              [9.96402185100007, 46.35608632500005],
              [9.970636434000141, 46.33980824900003],
              [9.971049846000057, 46.32001617500005],
              [9.977561076000114, 46.298105367000076],
              [9.99223718200011, 46.28435943600006],
              [10.031717977000142, 46.26007151300006],
              [10.041846557000099, 46.24306996700004],
              [10.04267338000011, 46.220487366],
              [10.075746297000109, 46.22002227800006],
              [10.11791426600007, 46.231132711],
              [10.145819539000058, 46.243328349000095],
              [10.15894535300012, 46.262448629000104],
              [10.14612959800013, 46.28027699800005],
              [10.104891805000136, 46.30937083000005],
              [10.095796753000059, 46.320532939000074],
              [10.091765991000074, 46.32895619800006],
              [10.092386108000113, 46.33810292600005],
              [10.097450398000092, 46.351642151000036],
              [10.104995158000065, 46.361357321000085],
              [10.125975789000051, 46.37437978200002],
              [10.133210490000124, 46.38109771700003],
              [10.14075524900008, 46.402905172000075],
              [10.133417195000078, 46.414015605000074],
              [10.11615726700009, 46.41882151400007],
              [10.071405477000042, 46.42481598000002],
              [10.04205326300007, 46.43272247400007],
              [10.026343627000074, 46.44626169900003],
              [10.04401696800008, 46.46698394800008],
              [10.035335327000041, 46.47106638600009],
              [10.03047774300012, 46.47667327900011],
              [10.028100627000072, 46.48393381800007],
              [10.026860392000117, 46.49318390000009],
              [10.031201212000099, 46.50382924500009],
              [10.03140791900006, 46.525791728000044],
              [10.032751506000125, 46.5329747520001],
              [10.041329793000074, 46.54186309800012],
              [10.062930542000117, 46.55674591100005],
              [10.07119877100007, 46.56439402300005],
              [10.083497762000121, 46.59700185100009],
              [10.087838582000103, 46.604391582000105],
              [10.097450398000092, 46.60803477000009],
              [10.192121623000048, 46.6268191540001],
              [10.21785648600013, 46.62697418200004],
              [10.233772827000053, 46.617982484],
              [10.235736531000072, 46.606691183000024],
              [10.230258830000082, 46.58614980100005],
              [10.234703003000106, 46.575297750000104],
              [10.27594079500011, 46.565530905000045],
              [10.283795614000041, 46.56072499600005],
              [10.28906660900006, 46.55568654400007],
              [10.295371135000096, 46.55108734100013],
              [10.306636597000136, 46.547495829000056],
              [10.319452351000024, 46.54604888900006],
              [10.354282267000087, 46.548322653000085],
              [10.425905803000148, 46.535326030000036],
              [10.443992554000147, 46.53772898400008],
              [10.45183267900012, 46.54670157200006],
              [10.457945190000146, 46.55369700100003],
              [10.465903361000102, 46.57847585100008],
              [10.466626831000013, 46.60428822900009],
              [10.459082072000058, 46.62356353800003],
              [10.438204793000097, 46.63565582300002],
              [10.395623413000123, 46.638808085000065],
              [10.377536662000097, 46.653277486],
              [10.36916508000013, 46.67239776600009],
              [10.373919312000112, 46.68190623000008],
              [10.384771363000084, 46.689011739000094],
              [10.394383179000073, 46.700819804],
              [10.396553588000074, 46.71500498400006],
              [10.395623413000123, 46.726399639000064],
              [10.399654175000109, 46.735546367000055],
              [10.41660404400011, 46.74301361100008],
              [10.42869633, 46.75564849900009],
              [10.426215861000031, 46.76942026800005],
              [10.419084513000087, 46.78396718300009],
              [10.417224162000082, 46.79884999700003],
              [10.439031616000108, 46.816885071000044],
              [10.444922730000116, 46.82324127200006],
              [10.4485400800001, 46.83223297100001],
              [10.453811076000136, 46.864427389000056],
              [10.486263875000134, 46.84636647500007],
              [10.527708374000099, 46.84321421300008],
              [10.629407593000053, 46.86241200800002],
              [10.647080932000051, 46.863755596],
              [10.662480509000119, 46.86096506800003],
              [10.738961629000102, 46.829545797],
              [10.748676798000133, 46.819443055000036],
              [10.743819213000023, 46.81251841300006],
              [10.7215983480001, 46.80014190700008],
              [10.716947469000047, 46.79520680800006],
              [10.722941935000051, 46.786447652000064],
              [10.733690633000066, 46.78618927100011],
              [10.754774618000113, 46.790762634000046],
              [10.766350138000064, 46.78810129900002],
              [10.795082235000052, 46.77688751300006],
              [10.804900757000041, 46.7766291300001],
              [10.823917684000094, 46.78034983300002],
              [10.834149617000065, 46.78024648000009],
              [10.843141317000118, 46.77704254200002],
              [10.860194539000133, 46.766991476000086],
              [10.870426473000123, 46.76407175700008],
              [10.880348348000041, 46.76458852200004],
              [10.913731323000093, 46.772339986000034],
              [10.93088789900014, 46.773993633000075],
              [10.96571781400013, 46.771642354000065],
              [10.98266768400012, 46.76774078400008],
              [10.996930379000105, 46.76911021000005],
              [11.010883016000093, 46.779212952000094],
              [11.033310588000091, 46.80556793200007],
              [11.037444702000101, 46.808255107],
              [11.048503458000113, 46.811691590000024],
              [11.052844279000084, 46.81492136700011],
              [11.054601277000074, 46.81993398000007],
              [11.053464396000066, 46.8303209430001],
              [11.054291219000078, 46.83414499900003],
              [11.073101441000091, 46.86496999200001],
              [11.083643432000144, 46.90013580400007],
              [11.091911662000115, 46.912434795000095],
              [11.1566105550001, 46.95651479100009],
              [11.174490601000059, 46.96385284500006],
              [11.243737020000054, 46.97925242200007],
              [11.31381026200009, 46.98726226800004],
              [11.349467001000079, 46.98193959600009],
              [11.38057621200005, 46.97155263300006],
              [11.411168661000147, 46.97049326600008],
              [11.445171753000096, 46.9929983520001],
              [11.44527510600011, 46.99310170500003],
              [11.452923217000091, 47.00087900900003],
              [11.4618115640001, 47.005504049000095],
              [11.471836792000119, 47.007080181000035],
              [11.48940677900012, 47.00421213800006],
              [11.495918009000093, 47.00160247800004],
              [11.501705770000058, 46.99785593700001],
              [11.506976766000093, 46.9929983520001],
              [11.515348348000146, 46.989484355000045],
              [11.524443400000024, 46.98834747300005],
              [11.533848511000087, 46.98953603200006],
              [11.543253621000133, 46.9929983520001],
              [11.543356974000062, 46.9929983520001],
              [11.54356368000012, 46.99310170500003],
              [11.543667033000048, 46.99310170500003],
              [11.572709188000147, 46.99891530400002],
              [11.596480347000096, 47.0004397580001],
              [11.64795007300009, 46.99325673500006],
              [11.648466838000047, 46.99325673500006],
              [11.64970707200007, 46.9929983520001],
              [11.65725183100011, 46.99253326400007],
              [11.664796590000066, 46.99325673500006],
              [11.683813517000118, 46.991913147],
              [11.71616296400012, 46.97548004200003],
              [11.7348698320001, 46.97062245700003],
              [11.746445353000041, 46.97245697100003],
              [11.766082397000076, 46.9834382130001],
              [11.777141154000077, 46.98829579700002],
              [11.822513061000109, 46.99325673500006],
              [11.85703291900009, 47.01201527900007],
              [11.899510946000134, 47.027724915000036],
              [11.943642618000126, 47.038163555000054],
              [12.014956096000105, 47.040488994],
              [12.116241903000116, 47.0765591430001],
              [12.1331463140001, 47.078831606000094],
              [12.180630737000115, 47.08521494500006],
              [12.20419519100011, 47.079685567000055],
              [12.203896989000043, 47.067011988],
              [12.203575073000138, 47.053330588000094],
              [12.18228438300008, 47.033616028000026],
              [12.121719604000106, 47.01051666300005],
              [12.111177612000063, 46.9929983520001],
              [12.117792196000039, 46.9830764770001],
              [12.122133015000117, 46.9716559860001],
              [12.128230835000096, 46.94858245900012],
              [12.134742065000069, 46.937446188000095],
              [12.141666708000031, 46.927989400000044],
              [12.141563355000102, 46.91884267200005],
              [12.126887247000127, 46.908869120000034],
              [12.137429240000074, 46.90592356400005],
              [12.16099369300008, 46.90302968400006],
              [12.172155802000105, 46.89917978900009],
              [12.183524617000103, 46.891221619000035],
              [12.189002319000082, 46.884942932000044],
              [12.195100138000043, 46.88008534800012],
              [12.208742716000074, 46.876623027000065],
              [12.250807332000079, 46.8756153370001],
              [12.266620320000072, 46.868148092000084],
              [12.275818726000097, 46.84628896100013],
              [12.276128784000065, 46.833989970000076],
              [12.27333825700012, 46.82675527000002],
              [12.269617554000092, 46.81983062800005],
              [12.266930380000076, 46.808255107],
              [12.266723673000115, 46.79533599900007],
              [12.26910078900005, 46.788566387000046],
              [12.274785197000114, 46.784638977000085],
              [12.284397013000103, 46.77998809900002],
              [12.305274292000092, 46.77445872000003],
              [12.32604821800004, 46.77249501600009],
              [12.342688029000044, 46.76513112400009],
              [12.35147302300004, 46.74324615500005],
              [12.370386596000088, 46.71115509000002],
              [12.405009806000095, 46.690122783],
              [12.445627482000106, 46.6787022920001],
              [12.46963219000014, 46.67579886500003],
              [12.499887736000062, 46.67213938500002],
              [12.530790242000052, 46.657669984000094],
              [12.547326701000145, 46.6521922810001],
              [12.562002807000056, 46.651210429000045],
              [12.620190471000058, 46.65648142500005],
              [12.669593139000085, 46.65301910500001],
              [12.671367650000093, 46.65246576300008],
              [12.679204956000092, 46.65002187100002],
              [12.697395061000122, 46.640539246000046],
              [12.706593465000111, 46.63774871900007],
              [12.71599857600009, 46.637955424000026],
              [12.73201827000014, 46.64227040700008],
              [12.739873088000081, 46.642993876],
              [12.74849950400008, 46.64099604100009],
              [12.773566122000119, 46.63519073500008],
              [12.830410197000077, 46.60963674000003],
              [13.064504435000089, 46.59803538000007],
              [13.14646325700005, 46.58496124300002],
              [13.210025269000113, 46.5580119830001],
              [13.231109253000056, 46.55217254700001],
              [13.271416870000081, 46.550777283000045],
              [13.373322794000075, 46.565789286000026],
              [13.417041056000073, 46.56049245200008],
              [13.478019246000116, 46.56356720000012],
              [13.484943889000107, 46.5617326860001],
              [13.49910323000006, 46.55062225400009],
              [13.506751343000133, 46.54692738900009],
              [13.549229370000091, 46.545842184],
              [13.670255574000066, 46.51871205700003],
              [13.685345093000052, 46.51762685100003],
              [13.700951375000102, 46.51974558600001],
              [13.701054728000116, 46.51189076800007],
              [13.699194376000037, 46.50483693500006],
              [13.695473673, 46.49863576200006],
              [13.68989261900009, 46.49333892800003],
              [13.688445678000107, 46.46775909500009],
              [13.685852877000059, 46.464047231000094],
              [13.67749027500011, 46.45207529700012],
              [13.658783407000044, 46.445124817000035],
              [13.634082072000126, 46.445719097000094],
              [13.600182332000117, 46.44264434900005],
              [13.575687703000057, 46.426676331000024],
              [13.554397013000084, 46.405954081000075],
              [13.530005737000067, 46.388332418000104],
              [13.483703654000067, 46.37115000400003],
              [13.45972579000005, 46.359031881000035],
              [13.44732344500008, 46.354846090000095],
              [13.434094279000107, 46.35386423800004],
              [13.423242229000039, 46.344846700000076],
              [13.409806355000086, 46.323607687000035],
              [13.395637648000076, 46.30672792800006],
              [13.391306193000077, 46.30156768800002],
              [13.365261271000094, 46.290302226000065],
              [13.373012736000106, 46.28027699800005],
              [13.37859379000011, 46.26839141900011],
              [13.384691610000061, 46.243328349000095],
              [13.384794963000104, 46.24322499600008],
              [13.384898316000118, 46.243121644000055],
              [13.39812748200012, 46.23051259400002],
              [13.40164148000008, 46.21666331000007],
              [13.41011641500009, 46.20798167],
              [13.437401570000105, 46.210927226000095],
              [13.422828816000049, 46.22860056600011],
              [13.43833174600013, 46.22487986300008],
              [13.468304077000084, 46.22343292300009],
              [13.482256713000083, 46.217903545000084],
              [13.510161988000078, 46.21397613600003],
              [13.528972208000084, 46.20482940700005],
              [13.559047892000137, 46.18410715800012],
              [13.584472697000137, 46.18131663100006],
              [13.613928264000066, 46.18353871700005],
              [13.627366324, 46.18173316300006],
              [13.637389363000125, 46.18038645500009],
              [13.64107145100013, 46.17140514500004],
              [13.645037475, 46.16173126300005],
              [13.616408732000139, 46.12504099500008],
              [13.522585297000091, 46.07529802300003],
              [13.505097697000082, 46.06602651000013],
              [13.482256713000083, 46.044839173000085],
              [13.490318237000082, 46.03894805900008],
              [13.492798706000144, 46.03248850500002],
              [13.490008179000085, 46.025563863000045],
              [13.482256713000083, 46.0184325150001],
              [13.47708907000009, 46.01605540000004],
              [13.461792846000037, 46.00639190700012],
              [13.474815307000142, 45.995746562000036],
              [13.47946618600011, 45.99311106400002],
              [13.480396362000079, 45.99228424100009],
              [13.481223186000108, 45.99135406500004],
              [13.481843302000073, 45.99037221300007],
              [13.482256713000083, 45.989235332000064],
              [13.509438517000149, 45.96742787700005],
              [13.539410848000102, 45.96902984700007],
              [13.571656942000061, 45.97983022100003],
              [13.60073487200009, 45.98457405300003],
              [13.605866740000067, 45.98541127600002],
              [13.622816610000086, 45.966394349000055],
              [13.615325176000084, 45.945912448000016],
              [13.608243856000115, 45.92655181900004],
              [13.599306242000097, 45.91232749900003],
              [13.569279826000127, 45.86454010100009],
              [13.56597253400011, 45.830330303],
              [13.574172202000085, 45.8190280570001],
              [13.581268758000078, 45.80924631800006],
              [13.609174032000055, 45.79860097300006],
              [13.643590535000016, 45.79565541600006],
              [13.660333699000148, 45.792038066000075],
              [13.699908416000142, 45.77052373600007],
              [13.70947798600011, 45.765321351000026],
              [13.778724406000038, 45.74341054300008],
              [13.85840946500008, 45.64935943600001],
              [13.869158163000094, 45.641142884],
              [13.884144327000087, 45.63514841700005],
              [13.89313602700011, 45.634683329000026],
              [13.893640530000113, 45.63375840600007],
              [13.894686320000034, 45.631841125000065],
              [13.887038208000149, 45.618766988000104],
              [13.86792570600008, 45.602169289000116],
              [13.84776411900009, 45.584660543000055],
              [13.800531860000149, 45.581249899000014],
              [13.76105106600005, 45.596236064],
              [13.711761915000068, 45.59320709800005],
              [13.718760613000086, 45.60065338700008],
              [13.73015384200005, 45.61310455900008],
              [13.757009311000047, 45.61367422100005],
              [13.78687584700009, 45.61115143400008],
              [13.808116082000083, 45.61432526200008],
              [13.795583530000044, 45.61701080900008],
              [13.78646894600007, 45.624335028000075],
              [13.77711022200009, 45.63544342700004],
              [13.739268425000091, 45.64911530200004],
              [13.757660352000073, 45.65497467700004],
              [13.75367272200009, 45.672308661000045],
              [13.739105665000068, 45.69159577000005],
              [13.72624759200005, 45.70376211100006],
              [13.647308790000068, 45.76203034100007],
              [13.628916863000086, 45.77260976800005],
              [13.574229363000086, 45.78961823100008],
              [13.551280144000089, 45.79242584800005],
              [13.534434441000087, 45.78204987200007],
              [13.524180535000085, 45.76007721600007],
              [13.528330925000091, 45.74054596600007],
              [13.554942254000082, 45.737209377000056],
              [13.518402540000068, 45.72483958500004],
              [13.51335696700005, 45.720770575000074],
              [13.507823113000086, 45.71442291900007],
              [13.48023522200009, 45.71067942900004],
              [13.469248894000089, 45.70685455900008],
              [13.451670769000089, 45.693793036000045],
              [13.427989129000082, 45.68113841400009],
              [13.40170332100007, 45.675441799000055],
              [13.37671959700009, 45.68317291900007],
              [13.390961134000065, 45.68577708500004],
              [13.409190300000091, 45.69131094000005],
              [13.424815300000091, 45.698553778000075],
              [13.43140709700009, 45.70685455900008],
              [13.422618035000085, 45.72406647300005],
              [13.381683790000068, 45.73004791900007],
              [13.369395379000082, 45.74461497600004],
              [13.351817254000082, 45.740301825000074],
              [13.254893425000091, 45.75604889500005],
              [13.24586022200009, 45.75893789300005],
              [13.221853061000047, 45.77606842700004],
              [13.215505405000044, 45.77879466400009],
              [13.204925977000073, 45.77773672100005],
              [13.169444207000083, 45.768744208000044],
              [13.157725457000083, 45.75458405200004],
              [13.149668816000087, 45.75153229400007],
              [13.139821811000047, 45.75486888200004],
              [13.131358269000089, 45.768866278000075],
              [13.119313998000052, 45.77195872600004],
              [13.110850457000083, 45.767645575000074],
              [13.108164910000085, 45.75820547100005],
              [13.111827019000089, 45.74884674700007],
              [13.122894727000073, 45.74461497600004],
              [13.122894727000073, 45.737209377000056],
              [13.100596550000091, 45.73623281500005],
              [13.080577019000089, 45.72760651200008],
              [13.069590691000087, 45.71369049700007],
              [13.075043165000068, 45.69684479400007],
              [13.09148196700005, 45.68919505400004],
              [13.111664259000065, 45.69135163000004],
              [13.149668816000087, 45.70376211100006],
              [13.13803144600007, 45.68939850500004],
              [13.103037957000083, 45.66901276200008],
              [13.095632358000046, 45.652329820000034],
              [13.095550977000073, 45.65216705900008],
              [13.084971550000091, 45.641913153000075],
              [13.060557488000086, 45.63666413000004],
              [12.981700066000087, 45.634833075000074],
              [12.943858269000089, 45.628566799000055],
              [12.780772332000083, 45.55353424700007],
              [12.611664259000065, 45.496161200000074],
              [12.512705925000091, 45.47044505400004],
              [12.495941602000073, 45.46039459800005],
              [12.487803582000083, 45.456732489000046],
              [12.451426629000082, 45.450425523000035],
              [12.423675977000073, 45.43805573100008],
              [12.410329623000052, 45.43622467700004],
              [12.418223504000082, 45.45111725500004],
              [12.429209832000083, 45.46401601800005],
              [12.435801629000082, 45.47492096600007],
              [12.430918816000087, 45.484035549000055],
              [12.440603061000047, 45.48297760600008],
              [12.447276238000086, 45.48432038000004],
              [12.451019727000073, 45.48899974200003],
              [12.451426629000082, 45.49823639500005],
              [12.458181186000047, 45.49823639500005],
              [12.462901238000086, 45.48973216400009],
              [12.466970248000052, 45.485581773000035],
              [12.471934441000087, 45.48590729400007],
              [12.478688998000052, 45.49079010600008],
              [12.465017123000052, 45.50446198100008],
              [12.47632897200009, 45.503566799000055],
              [12.487152540000068, 45.50409577000005],
              [12.497325066000087, 45.506740627000056],
              [12.499196811000047, 45.50446198100008],
              [12.499847852000073, 45.505845445000034],
              [12.503184441000087, 45.50287506700005],
              [12.506195509000065, 45.49909088700008],
              [12.506602410000085, 45.49823639500005],
              [12.503184441000087, 45.49787018400008],
              [12.492930535000085, 45.49823639500005],
              [12.492930535000085, 45.49079010600008],
              [12.515147332000083, 45.49274323100008],
              [12.520518425000091, 45.50503164300005],
              [12.521494988000086, 45.51898834800005],
              [12.530446811000047, 45.52558014500005],
              [12.548106316000087, 45.527004299000055],
              [12.562510613000086, 45.53164297100005],
              [12.57357832100007, 45.54002513200004],
              [12.58171634200005, 45.55288320500006],
              [12.56967207100007, 45.54938385600008],
              [12.544200066000087, 45.53656647300005],
              [12.537282748000052, 45.53583405200004],
              [12.518321160000085, 45.54995351800005],
              [12.510508660000085, 45.55906810100004],
              [12.506602410000085, 45.57330963700008],
              [12.485199415000068, 45.56500885600008],
              [12.458506707000083, 45.54832591400009],
              [12.441905144000089, 45.53034088700008],
              [12.451426629000082, 45.51813385600008],
              [12.451426629000082, 45.51190827000005],
              [12.43490644600007, 45.51235586100006],
              [12.41773522200009, 45.52358633000006],
              [12.410329623000052, 45.51813385600008],
              [12.403575066000087, 45.51813385600008],
              [12.396739129000082, 45.53925202000005],
              [12.38412519600007, 45.52301666900007],
              [12.39039147200009, 45.51398346600007],
              [12.424001498000052, 45.50446198100008],
              [12.424001498000052, 45.49823639500005],
              [12.411631707000083, 45.49331289300005],
              [12.393402540000068, 45.49164459800005],
              [12.38054446700005, 45.49477773600006],
              [12.383067254000082, 45.50446198100008],
              [12.350433790000068, 45.50486888200004],
              [12.309580925000091, 45.48891836100006],
              [12.272715691000087, 45.46360911700003],
              [12.252696160000085, 45.43622467700004],
              [12.252696160000085, 45.42999909100007],
              [12.258962436000047, 45.42999909100007],
              [12.250010613000086, 45.42072174700007],
              [12.246104363000086, 45.411322333000044],
              [12.248545769000089, 45.40253327000005],
              [12.258962436000047, 45.39520905200004],
              [12.249196811000047, 45.38548411700003],
              [12.24740644600007, 45.378241278000075],
              [12.248057488000086, 45.37099844000005],
              [12.245290561000047, 45.36107005400004],
              [12.237803582000083, 45.35773346600007],
              [12.22828209700009, 45.357489325000074],
              [12.223806186000047, 45.353949286000045],
              [12.23218834700009, 45.34056224200003],
              [12.220876498000052, 45.327053127000056],
              [12.216319207000083, 45.31622955900008],
              [12.20875084700009, 45.30906810100004],
              [12.187510613000086, 45.30646393400008],
              [12.174327019000089, 45.310532945000034],
              [12.162933790000068, 45.31622955900008],
              [12.154470248000052, 45.31346263200004],
              [12.149099155000044, 45.292181708000044],
              [12.15984134200005, 45.28310781500005],
              [12.168793165000068, 45.262152411000045],
              [12.180674675000091, 45.25804271000004],
              [12.191661004000082, 45.262884833000044],
              [12.199392123000052, 45.274603583000044],
              [12.201914910000085, 45.288316148000035],
              [12.197438998000052, 45.29962799700007],
              [12.217295769000089, 45.293850002000056],
              [12.221446160000085, 45.283270575000074],
              [12.220550977000073, 45.268784898000035],
              [12.224864129000082, 45.251166083000044],
              [12.213877800000091, 45.248114325000074],
              [12.211110873000052, 45.24298737200007],
              [12.215179884000065, 45.23680247600004],
              [12.224864129000082, 45.23069896000004],
              [12.221364780000044, 45.21625397300005],
              [12.230479363000086, 45.20425039300005],
              [12.247325066000087, 45.196926174000055],
              [12.266368035000085, 45.196600653000075],
              [12.263519727000073, 45.20034414300005],
              [12.262543165000068, 45.20075104400007],
              [12.258962436000047, 45.202826239000046],
              [12.273692254000082, 45.21084219000005],
              [12.296071811000047, 45.226629950000074],
              [12.307302280000044, 45.23069896000004],
              [12.298024936000047, 45.21539948100008],
              [12.303965691000087, 45.20075104400007],
              [12.315114780000044, 45.18646881700005],
              [12.321055535000085, 45.17234935100004],
              [12.32195071700005, 45.138739325000074],
              [12.328461134000065, 45.10101959800005],
              [12.318369988000086, 45.10346100500004],
              [12.307302280000044, 45.107855536000045],
              [12.308441602000073, 45.114447333000044],
              [12.307302280000044, 45.12417226800005],
              [12.307302280000044, 45.12836334800005],
              [12.297373894000089, 45.106350002000056],
              [12.296722852000073, 45.08856842700004],
              [12.306651238000086, 45.078558661000045],
              [12.328461134000065, 45.07990143400008],
              [12.325205925000091, 45.083685614000046],
              [12.32357832100007, 45.08673737200007],
              [12.321055535000085, 45.09357330900008],
              [12.340830925000091, 45.08144765800006],
              [12.353037957000083, 45.06696198100008],
              [12.363291863000086, 45.05219147300005],
              [12.376231316000087, 45.03896719000005],
              [12.376231316000087, 45.03217194200005],
              [12.368337436000047, 45.03115469000005],
              [12.364105665000068, 45.029364325000074],
              [12.360850457000083, 45.02708567900004],
              [12.35515384200005, 45.024644273000035],
              [12.36882571700005, 45.010972398000035],
              [12.383555535000085, 45.02643463700008],
              [12.386566602000073, 45.038763739000046],
              [12.38062584700009, 45.05093008000006],
              [12.36882571700005, 45.065619208000044],
              [12.383311394000089, 45.056341864000046],
              [12.401377800000091, 45.04987213700008],
              [12.41342207100007, 45.04287344000005],
              [12.410329623000052, 45.03217194200005],
              [12.426280144000089, 45.02000560100004],
              [12.434092644000089, 45.01552969000005],
              [12.444590691000087, 45.010972398000035],
              [12.464691602000073, 44.99201080900008],
              [12.486175977000073, 44.97650788000004],
              [12.499196811000047, 44.983710028000075],
              [12.49586022200009, 44.98395416900007],
              [12.489105665000068, 44.983303127000056],
              [12.48609459700009, 44.983710028000075],
              [12.48609459700009, 44.99115631700005],
              [12.502614780000044, 44.991441148000035],
              [12.516774936000047, 44.987616278000075],
              [12.527598504000082, 44.980169989000046],
              [12.533864780000044, 44.970038153000075],
              [12.53296959700009, 44.96084219000005],
              [12.52312259200005, 44.95001862200007],
              [12.52702884200005, 44.943345445000034],
              [12.518809441000087, 44.93378327000005],
              [12.51539147200009, 44.92837148600006],
              [12.512705925000091, 44.922308661000045],
              [12.506602410000085, 44.922308661000045],
              [12.499034050000091, 44.92145416900007],
              [12.494883660000085, 44.91046784100007],
              [12.492930535000085, 44.878159898000035],
              [12.487315300000091, 44.86225006700005],
              [12.474131707000083, 44.845770575000074],
              [12.444590691000087, 44.82050202000005],
              [12.44312584700009, 44.82501862200007],
              [12.438731316000087, 44.83490631700005],
              [12.432139519000089, 44.84601471600007],
              [12.424001498000052, 44.85464101800005],
              [12.43921959700009, 44.87759023600006],
              [12.44304446700005, 44.89008209800005],
              [12.438324415000068, 44.90110911700003],
              [12.426931186000047, 44.90497467700004],
              [12.415537957000083, 44.89984772300005],
              [12.406911655000044, 44.89130280200004],
              [12.403575066000087, 44.88471100500004],
              [12.392100457000083, 44.868394273000035],
              [12.391612175000091, 44.85883209800005],
              [12.416514519000089, 44.85114166900007],
              [12.415863477000073, 44.84357330900008],
              [12.408213738000086, 44.83624909100007],
              [12.396739129000082, 44.83348216400009],
              [12.396739129000082, 44.82664622600004],
              [12.403819207000083, 44.825425523000035],
              [12.416270379000082, 44.82143789300005],
              [12.424001498000052, 44.82050202000005],
              [12.416188998000052, 44.80329010600008],
              [12.397959832000083, 44.79376862200007],
              [12.375661655000044, 44.792222398000035],
              [12.357432488000086, 44.80414459800005],
              [12.346853061000047, 44.815334377000056],
              [12.321055535000085, 44.83348216400009],
              [12.302989129000082, 44.84292226800005],
              [12.29232832100007, 44.84324778900009],
              [12.266368035000085, 44.82664622600004],
              [12.266368035000085, 44.82050202000005],
              [12.280039910000085, 44.82050202000005],
              [12.25359134200005, 44.751288153000075],
              [12.246592644000089, 44.71161530200004],
              [12.252696160000085, 44.668402411000045],
              [12.265879754000082, 44.63617584800005],
              [12.274912957000083, 44.62051015800006],
              [12.283457879000082, 44.61375560100004],
              [12.285817905000044, 44.60268789300005],
              [12.280039910000085, 44.53188711100006],
              [12.283702019000089, 44.487616278000075],
              [12.31421959700009, 44.38719310100004],
              [12.318207227000073, 44.36115143400008],
              [12.321055535000085, 44.35370514500005],
              [12.325450066000087, 44.34780508000006],
              [12.33920332100007, 44.33429596600007],
              [12.342133009000065, 44.32949453300006],
              [12.344248894000089, 44.308294989000046],
              [12.350271030000044, 44.28815338700008],
              [12.36882571700005, 44.25067780200004],
              [12.38998457100007, 44.222723700000074],
              [12.417165561000047, 44.19546133000006],
              [12.458018425000091, 44.16640859600005],
              [12.478770379000082, 44.13934967700004],
              [12.510915561000047, 44.114569403000075],
              [12.547373894000089, 44.093451239000046],
              [12.574229363000086, 44.085598049000055],
              [12.631358269000089, 44.03009674700007],
              [12.660899285000085, 44.00828685100004],
              [12.691579623000052, 43.99062734600005],
              [12.71029707100007, 43.98289622600004],
              [12.753835483000046, 43.97239817900004],
              [12.756114129000082, 43.971869208000044],
              [12.803965691000087, 43.966864325000074],
              [12.823008660000085, 43.95856354400007],
              [12.862152540000068, 43.93537018400008],
              [12.928884311000047, 43.91583893400008],
              [12.938649936000047, 43.90460846600007],
              [12.947276238000086, 43.89760976800005],
              [13.25326582100007, 43.703192450000074],
              [13.370127800000091, 43.650458075000074],
              [13.389821811000047, 43.644598700000074],
              [13.399668816000087, 43.635646877000056],
              [13.44662519600007, 43.62372467700004],
              [13.473399285000085, 43.61200592700004],
              [13.483164910000085, 43.61627838700008],
              [13.490733269000089, 43.62360260600008],
              [13.496267123000052, 43.62750885600008],
              [13.499034050000091, 43.62848541900007],
              [13.501231316000087, 43.63060130400004],
              [13.504405144000089, 43.63275788000004],
              [13.510264519000089, 43.63373444200005],
              [13.516123894000089, 43.631740627000056],
              [13.519053582000083, 43.62718333500004],
              [13.521006707000083, 43.622707424000055],
              [13.524180535000085, 43.62067291900007],
              [13.543223504000082, 43.61322663000004],
              [13.557790561000047, 43.59674713700008],
              [13.569183790000068, 43.58030833500004],
              [13.578868035000085, 43.57290273600006],
              [13.597911004000082, 43.569525458000044],
              [13.615570509000065, 43.56049225500004],
              [13.624522332000083, 43.54718659100007],
              [13.61695397200009, 43.531317450000074],
              [13.760264519000089, 43.263739325000074],
              [13.776052280000044, 43.24359772300005],
              [13.780284050000091, 43.23651764500005],
              [13.786631707000083, 43.20058828300006],
              [13.79078209700009, 43.19208405200004],
              [13.802744988000086, 43.17820872600004],
              [13.834808790000068, 43.12726471600007],
              [13.848643425000091, 43.09174225500004],
              [13.865407748000052, 43.00731028900009],
              [13.905528191000087, 42.901556708000044],
              [13.94467207100007, 42.79828522300005],
              [13.980479363000086, 42.73037344000005],
              [14.001231316000087, 42.698431708000044],
              [14.063243035000085, 42.62482330900008],
              [14.068858269000089, 42.60956452000005],
              [14.075368686000047, 42.598822333000044],
              [14.220550977000073, 42.47016022300005],
              [14.284190300000091, 42.42829010600008],
              [14.356211785000085, 42.39297109600005],
              [14.387380405000044, 42.37295156500005],
              [14.42904707100007, 42.32172272300005],
              [14.56023196700005, 42.22565338700008],
              [14.595876498000052, 42.20856354400007],
              [14.653493686000047, 42.191066799000055],
              [14.693695509000065, 42.18537018400008],
              [14.709239129000082, 42.175482489000046],
              [14.717051629000082, 42.16006094000005],
              [14.722829623000052, 42.118801174000055],
              [14.729502800000091, 42.09910716400009],
              [14.740733269000089, 42.08462148600006],
              [14.75749759200005, 42.07884349200003],
              [14.76335696700005, 42.07794830900008],
              [14.780121290000068, 42.07526276200008],
              [14.799815300000091, 42.06635163000004],
              [14.835459832000083, 42.044134833000044],
              [14.871104363000086, 42.03180573100008],
              [14.951996290000068, 42.02106354400007],
              [14.993662957000083, 42.010646877000056],
              [15.007334832000083, 42.00136953300006],
              [15.03451582100007, 41.974595445000034],
              [15.045176629000082, 41.96898021000004],
              [15.063161655000044, 41.96430084800005],
              [15.104340040000068, 41.94188060100004],
              [15.123383009000065, 41.93427155200004],
              [15.143565300000091, 41.93117910400008],
              [15.16537519600007, 41.927801825000074],
              [15.281748894000089, 41.92804596600007],
              [15.400563998000052, 41.90778229400007],
              [15.446055535000085, 41.90692780200004],
              [15.611338738000086, 41.92804596600007],
              [15.774424675000091, 41.921210028000075],
              [16.02711022200009, 41.94407786700003],
              [16.110850457000083, 41.92804596600007],
              [16.111989780000044, 41.92633698100008],
              [16.140472852000073, 41.919907945000034],
              [16.160899285000085, 41.892645575000074],
              [16.179209832000083, 41.89329661700003],
              [16.176036004000082, 41.877386786000045],
              [16.183604363000086, 41.85846588700008],
              [16.192230665000068, 41.82135651200008],
              [16.19304446700005, 41.80841705900008],
              [16.192881707000083, 41.79092031500005],
              [16.184336785000085, 41.77960846600007],
              [16.166677280000044, 41.76341380400004],
              [16.145762566000087, 41.74884674700007],
              [16.127614780000044, 41.74249909100007],
              [16.10718834700009, 41.737616278000075],
              [16.089691602000073, 41.72601959800005],
              [16.063161655000044, 41.70148346600007],
              [16.027517123000052, 41.67991771000004],
              [15.925303582000083, 41.64004140800006],
              [15.90007571700005, 41.61465078300006],
              [15.891368035000085, 41.57684967700004],
              [15.896332227000073, 41.536444403000075],
              [15.91179446700005, 41.50287506700005],
              [15.933604363000086, 41.47943756700005],
              [15.961110873000052, 41.45945872600004],
              [16.021657748000052, 41.427801825000074],
              [16.085134311000047, 41.41266510600008],
              [16.100352410000085, 41.403550523000035],
              [16.114105665000068, 41.39288971600007],
              [16.301442905000044, 41.32786692900004],
              [16.46029707100007, 41.26264069200005],
              [16.520681186000047, 41.25014883000006],
              [16.538584832000083, 41.23940664300005],
              [16.55437259200005, 41.22748444200005],
              [16.593923373000052, 41.20697663000004],
              [16.83057701900009, 41.14630768400008],
              [16.851410352000073, 41.13296133000006],
              [16.858164910000085, 41.13296133000006],
              [16.858164910000085, 41.14036692900004],
              [16.864431186000047, 41.14036692900004],
              [16.88526451900009, 41.12396881700005],
              [17.05713951900009, 41.08185455900008],
              [17.203135613000086, 41.02098216400009],
              [17.27637780000009, 40.98021067900004],
              [17.310069207000083, 40.954779364000046],
              [17.347911004000082, 40.912095445000034],
              [17.361175977000073, 40.90639883000006],
              [17.377696160000085, 40.90228913000004],
              [17.413584832000083, 40.88108958500004],
              [17.476084832000083, 40.830145575000074],
              [17.49195397200009, 40.82444896000004],
              [17.51221764400009, 40.820298570000034],
              [17.548350457000083, 40.801947333000044],
              [17.63453209700009, 40.78497955900008],
              [17.645274285000085, 40.77977122600004],
              [17.748383009000065, 40.74762604400007],
              [17.843923373000052, 40.69415924700007],
              [17.921885613000086, 40.68301015800006],
              [17.955821160000085, 40.67047760600008],
              [17.954925977000073, 40.646918036000045],
              [17.966319207000083, 40.64679596600007],
              [17.99195397200009, 40.65314362200007],
              [18.007009311000047, 40.65070221600007],
              [18.01107832100007, 40.644191799000055],
              [18.01148522200009, 40.63523997600004],
              [18.015798373000052, 40.62518952000005],
              [18.039235873000052, 40.60822174700007],
              [18.043223504000082, 40.601996161000045],
              [18.037445509000065, 40.55695221600007],
              [18.119965040000068, 40.50458405200004],
              [18.211680535000085, 40.46474844000005],
              [18.23145592500009, 40.461371161000045],
              [18.238291863000086, 40.45766836100006],
              [18.25879967500009, 40.43065013200004],
              [18.270192905000044, 40.421210028000075],
              [18.30323326900009, 40.39988841400009],
              [18.32911217500009, 40.36668528900009],
              [18.343760613000086, 40.351629950000074],
              [18.361501498000052, 40.34528229400007],
              [18.37045332100007, 40.33869049700007],
              [18.43726647200009, 40.26788971600007],
              [18.500010613000086, 40.15249258000006],
              [18.504242384000065, 40.14642975500004],
              [18.50945071700005, 40.141831773000035],
              [18.51612389400009, 40.13922760600008],
              [18.51107832100007, 40.12759023600006],
              [18.513682488000086, 40.12055084800005],
              [18.517425977000073, 40.114162502000056],
              [18.51612389400009, 40.10447825700004],
              [18.508067254000082, 40.09454987200007],
              [18.49187259200005, 40.08466217700004],
              [18.483571811000047, 40.05516185100004],
              [18.47038821700005, 40.04344310100004],
              [18.43409264400009, 40.02252838700008],
              [18.411387566000087, 39.97882721600007],
              [18.40788821700005, 39.96849192900004],
              [18.40406334700009, 39.94749583500004],
              [18.394786004000082, 39.92560455900008],
              [18.392588738000086, 39.916083075000074],
              [18.399668816000087, 39.890326239000046],
              [18.40007571700005, 39.878566799000055],
              [18.38648522200009, 39.82534414300005],
              [18.38917076900009, 39.81708405200004],
              [18.383962436000047, 39.81391022300005],
              [18.373708530000044, 39.79979075700004],
              [18.368337436000047, 39.79661692900004],
              [18.346527540000068, 39.798041083000044],
              [18.33838951900009, 39.800116278000075],
              [18.330414259000065, 39.80341217700004],
              [18.282074415000068, 39.833197333000044],
              [18.265635613000086, 39.837591864000046],
              [18.22437584700009, 39.837591864000046],
              [18.211273634000065, 39.83934153900009],
              [18.18653405000009, 39.85187409100007],
              [18.16187584700009, 39.860541083000044],
              [18.13062584700009, 39.88349030200004],
              [18.09424889400009, 39.90273672100005],
              [18.080902540000068, 39.90643952000005],
              [18.071543816000087, 39.91152578300006],
              [18.007334832000083, 39.98607005400004],
              [17.995371941000087, 39.99526601800005],
              [17.995371941000087, 40.00267161700009],
              [18.01107832100007, 40.00336334800005],
              [18.020274285000085, 40.010199286000045],
              [18.022146030000044, 40.02167389500005],
              [18.015798373000052, 40.03620026200008],
              [18.005137566000087, 40.04486725500004],
              [17.978363477000073, 40.051662502000056],
              [17.967458530000044, 40.05731842700004],
              [18.00294030000009, 40.07444896000004],
              [18.010996941000087, 40.09601471600007],
              [17.997243686000047, 40.120428778000075],
              [17.967458530000044, 40.14606354400007],
              [17.940684441000087, 40.16303131700005],
              [17.926036004000082, 40.17625560100004],
              [17.91960696700005, 40.190741278000075],
              [17.919200066000087, 40.20994700700004],
              [17.91700280000009, 40.22687409100007],
              [17.91114342500009, 40.240301825000074],
              [17.899668816000087, 40.24909088700008],
              [17.912771030000044, 40.24909088700008],
              [17.912771030000044, 40.25531647300005],
              [17.863129102000073, 40.28563060100004],
              [17.847666863000086, 40.29002513200004],
              [17.512054884000065, 40.30369700700004],
              [17.49390709700009, 40.30744049700007],
              [17.44044030000009, 40.33100006700005],
              [17.430430535000085, 40.33161041900007],
              [17.40951582100007, 40.33002350500004],
              [17.39942467500009, 40.33100006700005],
              [17.392100457000083, 40.33502838700008],
              [17.37468509200005, 40.34857819200005],
              [17.36817467500009, 40.35150788000004],
              [17.35124759200005, 40.354803778000075],
              [17.296397332000083, 40.37946198100008],
              [17.24000084700009, 40.39533112200007],
              [17.212901238000086, 40.40619538000004],
              [17.20020592500009, 40.42039622600004],
              [17.223480665000068, 40.42841217700004],
              [17.243011915000068, 40.441392320000034],
              [17.247894727000073, 40.45734284100007],
              [17.22754967500009, 40.47443268400008],
              [17.24740644600007, 40.48029205900008],
              [17.295746290000068, 40.47321198100008],
              [17.316254102000073, 40.48187897300005],
              [17.32325280000009, 40.498480536000045],
              [17.30404707100007, 40.49945709800005],
              [17.261729363000086, 40.488714911000045],
              [17.263519727000073, 40.49103424700007],
              [17.26856530000009, 40.496161200000074],
              [17.24740644600007, 40.502834377000056],
              [17.22901451900009, 40.49689362200007],
              [17.21070397200009, 40.48700592700004],
              [17.18995201900009, 40.48187897300005],
              [17.181813998000052, 40.48529694200005],
              [17.176442905000044, 40.49315013200004],
              [17.171722852000073, 40.50226471600007],
              [17.166188998000052, 40.50918203300006],
              [17.15601647200009, 40.51239655200004],
              [17.133474155000044, 40.51264069200005],
              [17.124522332000083, 40.515326239000046],
              [17.049571160000085, 40.51911041900007],
              [16.976084832000083, 40.492621161000045],
              [16.912119988000086, 40.44521719000005],
              [16.863291863000086, 40.39093659100007],
              [16.782725457000083, 40.30158112200007],
              [16.76140384200005, 40.269598700000074],
              [16.737559441000087, 40.211004950000074],
              [16.730723504000082, 40.20066966400009],
              [16.715993686000047, 40.19358958500004],
              [16.67945397200009, 40.14606354400007],
              [16.640065951000054, 40.11876048400006],
              [16.624522332000083, 40.10797760600008],
              [16.604746941000087, 40.08445872600004],
              [16.596934441000087, 40.04677969000005],
              [16.59937584700009, 40.03412506700005],
              [16.613617384000065, 39.99664948100008],
              [16.631602410000085, 39.96621328300006],
              [16.621755405000044, 39.953558661000045],
              [16.605479363000086, 39.94293854400007],
              [16.58920332100007, 39.91982656500005],
              [16.542246941000087, 39.88540273600006],
              [16.508148634000065, 39.837591864000046],
              [16.491709832000083, 39.80548737200007],
              [16.489756707000083, 39.77521393400008],
              [16.502126498000052, 39.74705638200004],
              [16.528575066000087, 39.72150299700007],
              [16.528575066000087, 39.71466705900008],
              [16.515635613000086, 39.68960195500006],
              [16.54590905000009, 39.66087474200009],
              [16.59148196700005, 39.636786200000074],
              [16.624847852000073, 39.62531159100007],
              [16.74976647200009, 39.620021877000056],
              [16.782481316000087, 39.61163971600007],
              [16.798106316000087, 39.60346100500004],
              [16.81609134200005, 39.591050523000035],
              [16.830902540000068, 39.576157945000034],
              [16.837168816000087, 39.56045156500005],
              [16.84620201900009, 39.55267975500004],
              [16.90601647200009, 39.529730536000045],
              [16.952972852000073, 39.499212958000044],
              [16.970876498000052, 39.49494049700007],
              [16.995371941000087, 39.49274323100008],
              [17.01148522200009, 39.48615143400008],
              [17.023448113000086, 39.47540924700007],
              [17.035817905000044, 39.46076080900008],
              [17.05713951900009, 39.44163646000004],
              [17.088552280000044, 39.42259349200009],
              [17.124196811000047, 39.40900299700007],
              [17.15870201900009, 39.40619538000004],
              [17.122243686000047, 39.338324286000045],
              [17.11491946700005, 39.28278229400007],
              [17.114512566000087, 39.26935455900008],
              [17.11768639400009, 39.25600820500006],
              [17.12476647200009, 39.24461497600004],
              [17.142100457000083, 39.222316799000055],
              [17.145681186000047, 39.21067942900004],
              [17.14039147200009, 39.178900458000044],
              [17.122243686000047, 39.12103913000004],
              [17.124522332000083, 39.09088776200008],
              [17.147959832000083, 39.05418528900009],
              [17.151866082000083, 39.04588450700004],
              [17.158457879000082, 39.04047272300005],
              [17.192556186000047, 39.03107330900008],
              [17.20639082100007, 39.02948639500005],
              [17.18685957100007, 39.01902903900009],
              [17.176605665000068, 39.01211172100005],
              [17.17237389400009, 39.005194403000075],
              [17.17156009200005, 38.966009833000044],
              [17.17237389400009, 38.96051666900007],
              [17.138845248000052, 38.936712958000044],
              [17.135020379000082, 38.93260325700004],
              [17.127696160000085, 38.92877838700008],
              [17.11890709700009, 38.91966380400004],
              [17.10401451900009, 38.89907461100006],
              [17.094981316000087, 38.919134833000044],
              [17.070567254000082, 38.92279694200005],
              [17.042246941000087, 38.91624583500004],
              [17.02198326900009, 38.905951239000046],
              [16.996348504000082, 38.92951080900008],
              [16.981293165000068, 38.937201239000046],
              [16.957286004000082, 38.94009023600006],
              [16.935069207000083, 38.938706773000035],
              [16.838552280000044, 38.91819896000004],
              [16.727793816000087, 38.87885163000004],
              [16.687754754000082, 38.85586172100005],
              [16.67945397200009, 38.84756094000005],
              [16.670746290000068, 38.84064362200007],
              [16.610606316000087, 38.81655508000006],
              [16.58562259200005, 38.79783763200004],
              [16.574392123000052, 38.78506094000005],
              [16.563731316000087, 38.756740627000056],
              [16.550954623000052, 38.741400458000044],
              [16.53882897200009, 38.72333405200004],
              [16.53484134200005, 38.69989655200004],
              [16.546885613000086, 38.69318268400008],
              [16.549082879000082, 38.68992747600004],
              [16.54851321700005, 38.67206452000005],
              [16.558848504000082, 38.59601471600007],
              [16.576996290000068, 38.528550523000035],
              [16.57715905000009, 38.50287506700005],
              [16.569590691000087, 38.42951080900008],
              [16.561371290000068, 38.41632721600007],
              [16.52198326900009, 38.387152411000045],
              [16.508148634000065, 38.371527411000045],
              [16.497569207000083, 38.36928945500006],
              [16.467051629000082, 38.34870026200008],
              [16.435069207000083, 38.33999258000006],
              [16.339854363000086, 38.300848700000074],
              [16.30632571700005, 38.27708567900004],
              [16.169444207000083, 38.14321523600006],
              [16.151866082000083, 38.11082591400009],
              [16.12549889400009, 38.00482819200005],
              [16.110850457000083, 37.97361888200004],
              [16.10132897200009, 37.96051666900007],
              [16.090017123000052, 37.949204820000034],
              [16.07715905000009, 37.939886786000045],
              [16.063161655000044, 37.93268463700008],
              [16.015879754000082, 37.924709377000056],
              [16.00098717500009, 37.91901276200008],
              [15.942149285000085, 37.93309153900009],
              [15.76148522200009, 37.92523834800005],
              [15.734873894000089, 37.930975653000075],
              [15.708262566000087, 37.94098541900007],
              [15.684418165000068, 37.95351797100005],
              [15.66578209700009, 37.966864325000074],
              [15.645518425000091, 37.988348700000074],
              [15.635101759000065, 38.009100653000075],
              [15.63835696700005, 38.02773672100005],
              [15.658457879000082, 38.04254791900007],
              [15.632660352000073, 38.074204820000034],
              [15.624034050000091, 38.09210846600007],
              [15.627452019000089, 38.10736725500004],
              [15.641612175000091, 38.12592194200005],
              [15.64779707100007, 38.14313385600008],
              [15.646494988000086, 38.162095445000034],
              [15.637950066000087, 38.18593984600005],
              [15.632823113000086, 38.22028229400007],
              [15.650563998000052, 38.24103424700007],
              [15.684255405000044, 38.253119208000044],
              [15.78646894600007, 38.27802155200004],
              [15.795664910000085, 38.28554922100005],
              [15.798675977000073, 38.290716864000046],
              [15.812836134000065, 38.30060455900008],
              [15.81617272200009, 38.30605703300006],
              [15.82976321700005, 38.35101959800005],
              [15.904795769000089, 38.473944403000075],
              [15.917816602000073, 38.516791083000044],
              [15.916026238000086, 38.55036041900007],
              [15.90007571700005, 38.57827383000006],
              [15.87077884200005, 38.60423411700009],
              [15.863536004000082, 38.60822174700007],
              [15.849945509000065, 38.613348700000074],
              [15.844004754000082, 38.61790599200009],
              [15.835459832000083, 38.628241278000075],
              [15.83366946700005, 38.63377513200004],
              [15.835215691000087, 38.63922760600008],
              [15.836599155000044, 38.64899323100008],
              [15.844493035000085, 38.66038646000004],
              [15.863129102000073, 38.66828034100007],
              [15.904795769000089, 38.679388739000046],
              [15.968028191000087, 38.712591864000046],
              [16.002614780000044, 38.72540924700007],
              [16.048838738000086, 38.727728583000044],
              [16.12086022200009, 38.72093333500004],
              [16.135996941000087, 38.723822333000044],
              [16.152598504000082, 38.730902411000045],
              [16.179209832000083, 38.74827708500004],
              [16.20093834700009, 38.77643463700008],
              [16.215098504000082, 38.814154364000046],
              [16.22169030000009, 38.85659414300005],
              [16.22006269600007, 38.89907461100006],
              [16.214691602000073, 38.91901276200008],
              [16.204600457000083, 38.93406810100004],
              [16.189626498000052, 38.94354889500005],
              [16.16895592500009, 38.94684479400007],
              [16.154307488000086, 38.95502350500004],
              [16.13965905000009, 38.97378164300005],
              [16.08301842500009, 39.07526276200008],
              [16.04200280000009, 39.310614325000074],
              [16.03402716100004, 39.34524176800005],
              [15.995396030000052, 39.438768236000044],
              [15.958075525000083, 39.47756361200004],
              [15.933116082000083, 39.513657945000034],
              [15.904795769000089, 39.53595612200007],
              [15.876231316000087, 39.55145905200004],
              [15.867523634000065, 39.56391022300005],
              [15.859716355000046, 39.58876446000005],
              [15.850271030000044, 39.61473216400009],
              [15.836599155000044, 39.65265534100007],
              [15.815684441000087, 39.678900458000044],
              [15.80640709700009, 39.69550202000005],
              [15.78874759200005, 39.79661692900004],
              [15.78874759200005, 39.790350653000075],
              [15.783946160000085, 39.81000397300005],
              [15.778819207000083, 39.82013580900008],
              [15.771332227000073, 39.82453034100007],
              [15.769704623000052, 39.830145575000074],
              [15.781911655000044, 39.86859772300005],
              [15.774424675000091, 39.89109935100004],
              [15.74154707100007, 39.92959219000005],
              [15.73414147200009, 39.94375234600005],
              [15.728037957000083, 39.964178778000075],
              [15.713145379000082, 39.98102448100008],
              [15.678884311000047, 40.00885651200008],
              [15.651621941000087, 40.04364655200004],
              [15.630381707000083, 40.05768463700008],
              [15.62468509200005, 40.064886786000045],
              [15.624278191000087, 40.077785549000055],
              [15.610199415000068, 40.07318756700005],
              [15.53492272200009, 40.077785549000055],
              [15.513127170000075, 40.067680206000034],
              [15.49531187100007, 40.04671893700004],
              [15.459808790000068, 40.029364325000074],
              [15.429601880000064, 39.99979266000008],
              [15.410099591000062, 39.99396986000005],
              [15.360943483000085, 39.998890575000075],
              [15.343159872000058, 40.00414865200008],
              [15.314300977000073, 40.03375885600008],
              [15.302744988000086, 40.03620026200008],
              [15.293304884000065, 40.032416083000044],
              [15.283050977000073, 40.02985260600008],
              [15.272227410000085, 40.02875397300005],
              [15.261241082000083, 40.029364325000074],
              [15.261241082000083, 40.03620026200008],
              [15.279144727000073, 40.04767487200007],
              [15.26343834700009, 40.07371653900009],
              [15.233897332000083, 40.10000234600005],
              [15.209646030000044, 40.11188385600008],
              [15.189952019000089, 40.119126695000034],
              [15.127207879000082, 40.169623114000046],
              [15.112803582000083, 40.17479075700004],
              [15.095876498000052, 40.173081773000035],
              [15.065684441000087, 40.16657135600008],
              [15.047211134000065, 40.16893138200004],
              [15.03492272200009, 40.17536041900007],
              [15.02280382400005, 40.195626867000044],
              [15.003122129000076, 40.210258570000065],
              [14.975904024000045, 40.219313312000054],
              [14.966319207000083, 40.22455475500004],
              [14.957087508000086, 40.231549930000085],
              [14.93813785900005, 40.22783932200008],
              [14.922129754000082, 40.23802317900004],
              [14.911143425000091, 40.24164459800005],
              [14.906911655000044, 40.25861237200007],
              [14.931895379000082, 40.28554922100005],
              [14.93913821700005, 40.307074286000045],
              [14.932383660000085, 40.324286200000074],
              [14.932383660000085, 40.33372630400004],
              [14.942149285000085, 40.33783600500004],
              [14.953949415000068, 40.339911200000074],
              [14.964366082000083, 40.34516022300005],
              [14.972911004000082, 40.351996161000045],
              [14.994489870000052, 40.35843381300003],
              [15.000432928000066, 40.36882818300006],
              [14.998266587000046, 40.39755866100006],
              [14.97592207100007, 40.43146393400008],
              [14.888845248000052, 40.57306549700007],
              [14.861501498000052, 40.60716380400004],
              [14.835459832000083, 40.63263580900008],
              [14.809743686000047, 40.65298086100006],
              [14.781993035000085, 40.66986725500004],
              [14.752207879000082, 40.67670319200005],
              [14.719981316000087, 40.66681549700007],
              [14.690440300000091, 40.64911530200004],
              [14.678070509000065, 40.64663320500006],
              [14.625743035000085, 40.64907461100006],
              [14.613291863000086, 40.64590078300006],
              [14.571299675000091, 40.61774323100008],
              [14.544200066000087, 40.61359284100007],
              [14.516368035000085, 40.61985911700009],
              [14.486582879000082, 40.63263580900008],
              [14.471364780000044, 40.624660549000055],
              [14.422048373000052, 40.61554596600007],
              [14.401540561000047, 40.60211823100008],
              [14.355804884000065, 40.583644924000055],
              [14.342621290000068, 40.57062409100007],
              [14.32984459700009, 40.58445872600004],
              [14.327972852000073, 40.60541413000004],
              [14.337738477000073, 40.62441640800006],
              [14.359629754000082, 40.63263580900008],
              [14.379730665000068, 40.63385651200008],
              [14.387380405000044, 40.63694896000004],
              [14.398213357000088, 40.64384157400008],
              [14.404798645000085, 40.65603259200009],
              [14.444210811000062, 40.68598713600005],
              [14.476369627000054, 40.69510212700004],
              [14.479746941000087, 40.71149323100008],
              [14.474131707000083, 40.729681708000044],
              [14.46062259200005, 40.744208075000074],
              [14.442637566000087, 40.755072333000044],
              [14.421290079000073, 40.750930081000035],
              [14.405402903000038, 40.75688689500004],
              [14.39443265300008, 40.76156623900005],
              [14.382554016000086, 40.772265565000055],
              [14.366608709000047, 40.78017824600005],
              [14.348887566000087, 40.796861070000034],
              [14.312347852000073, 40.828111070000034],
              [14.294200066000087, 40.838771877000056],
              [14.275726759000065, 40.84003327000005],
              [14.248383009000065, 40.83771393400008],
              [14.223643425000091, 40.831366278000075],
              [14.212738477000073, 40.820746161000045],
              [14.203461134000065, 40.801214911000045],
              [14.182202959000051, 40.80091803100004],
              [14.165596632000074, 40.81575233700005],
              [14.135233189000076, 40.81855425300006],
              [14.111501498000052, 40.82953522300005],
              [14.095957879000082, 40.83380768400008],
              [14.082530144000089, 40.831284898000035],
              [14.076182488000086, 40.82221100500004],
              [14.077403191000087, 40.81037018400008],
              [14.081228061000047, 40.79710521000004],
              [14.082530144000089, 40.78351471600007],
              [14.075281919000076, 40.786277590000054],
              [14.04769740100005, 40.78958927300005],
              [14.041151478000074, 40.79648412900008],
              [14.052256707000083, 40.837591864000046],
              [14.044464903000062, 40.87420513200004],
              [14.021343774000059, 40.921828936000054],
              [13.965342644000089, 40.99640534100007],
              [13.930186394000089, 41.01414622600004],
              [13.917979363000086, 41.02366771000004],
              [13.914561394000089, 41.03314850500004],
              [13.912771030000044, 41.05442942900004],
              [13.910655144000089, 41.06464264500005],
              [13.884318292000046, 41.104799842000034],
              [13.851725251000062, 41.14731569400004],
              [13.79049088000005, 41.205864029000054],
              [13.721853061000047, 41.252386786000045],
              [13.708506707000083, 41.25641510600008],
              [13.678721550000091, 41.25055573100008],
              [13.663340691000087, 41.25067780200004],
              [13.656586134000065, 41.25958893400008],
              [13.594411655000044, 41.253119208000044],
              [13.563649936000047, 41.237982489000046],
              [13.575450066000087, 41.20807526200008],
              [13.543955925000091, 41.20661041900007],
              [13.534434441000087, 41.20807526200008],
              [13.525238477000073, 41.21539948100008],
              [13.519541863000086, 41.22516510600008],
              [13.514414910000085, 41.229681708000044],
              [13.507090691000087, 41.22174713700008],
              [13.49968509200005, 41.22174713700008],
              [13.48023522200009, 41.239162502000056],
              [13.324392123000052, 41.29482656500005],
              [13.285817905000044, 41.29572174700007],
              [13.20484459700009, 41.28375885600008],
              [13.187022332000083, 41.27802155200004],
              [13.151215040000068, 41.260199286000045],
              [13.114512566000087, 41.250881252000056],
              [13.090505405000044, 41.226548570000034],
              [13.068207227000073, 41.22174713700008],
              [13.04460696700005, 41.22752513200004],
              [13.03679446700005, 41.24042389500005],
              [13.033457879000082, 41.25690338700008],
              [13.023692254000082, 41.27358633000006],
              [13.011973504000082, 41.28652578300006],
              [12.992686394000089, 41.315619208000044],
              [12.979502800000091, 41.33100006700005],
              [12.923838738000086, 41.379787502000056],
              [12.893565300000091, 41.399318752000056],
              [12.862152540000068, 41.41351959800005],
              [12.84156334700009, 41.418402411000045],
              [12.762950066000087, 41.42137278900009],
              [12.748545769000089, 41.42373281500005],
              [12.678558790000068, 41.45795319200005],
              [12.65398196700005, 41.46564362200007],
              [12.642425977000073, 41.458197333000044],
              [12.635264519000089, 41.44749583500004],
              [12.619395379000082, 41.45913320500006],
              [12.545583530000044, 41.544134833000044],
              [12.448008660000085, 41.63076406500005],
              [12.342784050000091, 41.70229726800005],
              [12.327159050000091, 41.711371161000045],
              [12.300629102000073, 41.71743398600006],
              [12.285004102000073, 41.72719961100006],
              [12.276621941000087, 41.72943756700005],
              [12.246918165000068, 41.733710028000075],
              [12.239024285000085, 41.73627350500004],
              [12.223480665000068, 41.75067780200004],
              [12.215179884000065, 41.76813385600008],
              [12.211761915000068, 41.787543036000045],
              [12.211192254000082, 41.807928778000075],
              [12.206228061000047, 41.827337958000044],
              [12.194590691000087, 41.847357489000046],
              [12.170176629000082, 41.87958405200004],
              [12.147471550000091, 41.90346914300005],
              [12.049978061000047, 41.960150458000044],
              [12.03882897200009, 41.96515534100007],
              [12.029795769000089, 41.97284577000005],
              [12.026133660000085, 41.98578522300005],
              [12.020355665000068, 41.993068752000056],
              [11.992035352000073, 41.99628327000005],
              [11.98218834700009, 41.99974192900004],
              [11.969004754000082, 42.011419989000046],
              [11.952647332000083, 42.02228424700007],
              [11.934580925000091, 42.03148021000004],
              [11.916840040000068, 42.03790924700007],
              [11.839691602000073, 42.036444403000075],
              [11.82748457100007, 42.03416575700004],
              [11.822113477000073, 42.04677969000005],
              [11.809418165000068, 42.06635163000004],
              [11.793630405000044, 42.08445872600004],
              [11.779795769000089, 42.09251536700003],
              [11.771983269000089, 42.10626862200007],
              [11.750173373000052, 42.12791575700004],
              [11.745616082000083, 42.13662344000005],
              [11.742930535000085, 42.15228913000004],
              [11.736175977000073, 42.16889069200005],
              [11.682139519000089, 42.25214264500005],
              [11.658213738000086, 42.279364325000074],
              [11.539073113000086, 42.348863023000035],
              [11.489268425000091, 42.359361070000034],
              [11.420664910000085, 42.38662344000005],
              [11.39616946700005, 42.39297109600005],
              [11.39616946700005, 42.400376695000034],
              [11.386892123000052, 42.404282945000034],
              [11.37663821700005, 42.40688711100006],
              [11.365733269000089, 42.407904364000046],
              [11.354665561000047, 42.40721263200004],
              [11.362071160000085, 42.400376695000034],
              [11.333018425000091, 42.40058014500005],
              [11.259043816000087, 42.42084381700005],
              [11.245616082000083, 42.422308661000045],
              [11.227386915000068, 42.42218659100007],
              [11.211273634000065, 42.41889069200005],
              [11.204356316000087, 42.41095612200007],
              [11.20093834700009, 42.39545319200005],
              [11.186289910000085, 42.37929922100005],
              [11.183848504000082, 42.36627838700008],
              [11.174652540000068, 42.36933014500005],
              [11.164724155000044, 42.36933014500005],
              [11.157399936000047, 42.36774323100008],
              [11.15593509200005, 42.36627838700008],
              [11.14779707100007, 42.37140534100007],
              [11.13453209700009, 42.38418203300006],
              [11.106618686000047, 42.39126211100006],
              [11.094493035000085, 42.40273672100005],
              [11.086761915000068, 42.41836172100005],
              [11.08694107100007, 42.429456508000044],
              [11.099131707000083, 42.44285716400009],
              [11.113021206000042, 42.44635807800006],
              [11.141815527000063, 42.43879721600007],
              [11.164190816000087, 42.43982808100009],
              [11.179691769000044, 42.45649774900005],
              [11.18844752800004, 42.480267455000046],
              [11.188975457000083, 42.50470612200007],
              [11.18685957100007, 42.520819403000075],
              [11.166026238000086, 42.546210028000075],
              [11.158457879000082, 42.56403229400007],
              [11.148610873000052, 42.56317780200004],
              [11.137217644000089, 42.55890534100007],
              [11.12867272200009, 42.55805084800005],
              [11.115977410000085, 42.571966864000046],
              [11.107269727000073, 42.59076569200005],
              [11.09742272200009, 42.60687897300005],
              [11.080902540000068, 42.61269765800006],
              [11.07781009200005, 42.63222890800006],
              [11.053477410000085, 42.64704010600008],
              [11.005707227000073, 42.66791413000004],
              [11.000254754000082, 42.67987702000005],
              [10.995616082000083, 42.69603099200003],
              [10.99000084700009, 42.710272528000075],
              [10.981211785000085, 42.71629466400009],
              [10.97234134200005, 42.720038153000075],
              [10.943614129000082, 42.74298737200007],
              [10.890879754000082, 42.76390208500004],
              [10.731293165000068, 42.80442942900004],
              [10.755381707000083, 42.81915924700007],
              [10.764903191000087, 42.835272528000075],
              [10.766368035000085, 42.85419342700004],
              [10.765635613000086, 42.87710195500006],
              [10.768728061000047, 42.88393789300005],
              [10.774587436000047, 42.88825104400007],
              [10.777679884000065, 42.89472077000005],
              [10.772959832000083, 42.90814850500004],
              [10.763519727000073, 42.91828034100007],
              [10.750743035000085, 42.92527903900009],
              [10.68140709700009, 42.94904205900008],
              [10.63249759200005, 42.95848216400009],
              [10.583262566000087, 42.95970286700003],
              [10.539073113000086, 42.94912344000005],
              [10.543467644000089, 42.938788153000075],
              [10.54656009200005, 42.934759833000044],
              [10.518565300000091, 42.92527903900009],
              [10.499522332000083, 42.94049713700008],
              [10.477549675000091, 42.99005768400008],
              [10.502696160000085, 43.005560614000046],
              [10.517100457000083, 43.02391185100004],
              [10.539073113000086, 43.079413153000075],
              [10.535655144000089, 43.09137604400007],
              [10.535655144000089, 43.112616278000075],
              [10.539317254000082, 43.13418203300006],
              [10.54656009200005, 43.14712148600006],
              [10.538340691000087, 43.16425202000005],
              [10.534434441000087, 43.18528880400004],
              [10.53288821700005, 43.226223049000055],
              [10.528168165000068, 43.24677155200004],
              [10.51693769600007, 43.266791083000044],
              [10.437022332000083, 43.38857656500005],
              [10.373383009000065, 43.453192450000074],
              [10.35914147200009, 43.465277411000045],
              [10.326345248000052, 43.47687409100007],
              [10.317230665000068, 43.492621161000045],
              [10.294769727000073, 43.56854889500005],
              [10.264008009000065, 43.80939362200007],
              [10.25163821700005, 43.84662506700005],
              [10.210134311000047, 43.92023346600007],
              [10.180674675000091, 43.95526764500005],
              [10.13648522200009, 43.97870514500005],
              [10.105804884000065, 44.01675039300005],
              [10.090586785000085, 44.025376695000034],
              [10.07203209700009, 44.02952708500004],
              [10.035329623000052, 44.04783763200004],
              [10.014821811000047, 44.052069403000075],
              [9.998545769000089, 44.05805084800005],
              [9.988536004000082, 44.059759833000044],
              [9.98414147200009, 44.05548737200007],
              [9.980723504000082, 44.04987213700008],
              [9.972666863000086, 44.04572174700007],
              [9.962738477000073, 44.04466380400004],
              [9.953623894000089, 44.04865143400008],
              [9.937836134000065, 44.06037018400008],
              [9.904307488000086, 44.07990143400008],
              [9.887950066000087, 44.093003648000035],
              [9.876800977000073, 44.08783600500004],
              [9.844737175000091, 44.108628648000035],
              [9.826426629000082, 44.10724518400008],
              [9.833262566000087, 44.09983958500004],
              [9.828623894000089, 44.09813060100004],
              [9.82398522200009, 44.09511953300006],
              [9.819590691000087, 44.093003648000035],
              [9.824473504000082, 44.08490631700005],
              [9.830577019000089, 44.07884349200003],
              [9.838145379000082, 44.07477448100008],
              [9.847504102000073, 44.07249583500004],
              [9.847504102000073, 44.06631094000005],
              [9.841644727000073, 44.063381252000056],
              [9.838877800000091, 44.06037018400008],
              [9.833262566000087, 44.052069403000075],
              [9.846364780000044, 44.04629140800006],
              [9.842539910000085, 44.04116445500006],
              [9.832286004000082, 44.042303778000075],
              [9.826426629000082, 44.05548737200007],
              [9.819834832000083, 44.063381252000056],
              [9.771820509000065, 44.079413153000075],
              [9.720876498000052, 44.11347077000005],
              [9.709727410000085, 44.11774323100008],
              [9.682627800000091, 44.13654205900008],
              [9.672536655000044, 44.14081452000005],
              [9.643239780000044, 44.14232005400004],
              [9.631032748000052, 44.144598700000074],
              [9.621104363000086, 44.14826080900008],
              [9.586192254000082, 44.177720445000034],
              [9.579925977000073, 44.178941148000035],
              [9.573008660000085, 44.19159577000005],
              [9.556488477000073, 44.20014069200005],
              [9.511241082000083, 44.21523672100005],
              [9.499034050000091, 44.22182851800005],
              [9.489756707000083, 44.230902411000045],
              [9.484385613000086, 44.243841864000046],
              [9.472504102000073, 44.23981354400007],
              [9.453868035000085, 44.23769765800006],
              [9.436778191000087, 44.239488023000035],
              [9.429209832000083, 44.247259833000044],
              [9.422373894000089, 44.25678131700005],
              [9.374522332000083, 44.27179596600007],
              [9.367686394000089, 44.29441966400009],
              [9.262705925000091, 44.33641185100004],
              [9.230642123000052, 44.35370514500005],
              [9.221039259000065, 44.34406159100007],
              [9.213715040000068, 44.33344147300005],
              [9.209808790000068, 44.32086823100008],
              [9.21070397200009, 44.30532461100006],
              [9.165049675000091, 44.31830475500004],
              [9.146657748000052, 44.328558661000045],
              [9.148610873000052, 44.34003327000005],
              [9.130056186000047, 44.363348700000074],
              [9.102061394000089, 44.37396881700005],
              [9.001231316000087, 44.38727448100008],
              [8.95289147200009, 44.39980703300006],
              [8.923675977000073, 44.41156647300005],
              [8.914561394000089, 44.40892161700003],
              [8.868418816000087, 44.40973541900007],
              [8.84538821700005, 44.41347890800006],
              [8.837738477000073, 44.417181708000044],
              [8.826996290000068, 44.42845286700003],
              [8.762380405000044, 44.43211497600004],
              [8.737152540000068, 44.42877838700008],
              [8.724782748000052, 44.42397695500006],
              [8.695811394000089, 44.40672435100004],
              [8.68531334700009, 44.398098049000055],
              [8.678558790000068, 44.39468008000006],
              [8.670909050000091, 44.39472077000005],
              [8.662771030000044, 44.39557526200008],
              [8.655121290000068, 44.39468008000006],
              [8.593760613000086, 44.36273834800005],
              [8.576670769000089, 44.360541083000044],
              [8.564789259000065, 44.35716380400004],
              [8.540293816000087, 44.34003327000005],
              [8.466075066000087, 44.30426666900007],
              [8.444509311000047, 44.28388092700004],
              [8.449717644000089, 44.26434967700004],
              [8.439463738000086, 44.253159898000035],
              [8.436534050000091, 44.24754466400009],
              [8.435394727000073, 44.24042389500005],
              [8.432383660000085, 44.23802317900004],
              [8.417246941000087, 44.23065827000005],
              [8.41187584700009, 44.22703685100004],
              [8.406504754000082, 44.21503327000005],
              [8.408539259000065, 44.20408763200004],
              [8.408213738000086, 44.19350820500006],
              [8.394541863000086, 44.18235911700003],
              [8.369395379000082, 44.173529364000046],
              [8.313487175000091, 44.16046784100007],
              [8.284678582000083, 44.14826080900008],
              [8.269541863000086, 44.138739325000074],
              [8.256521030000044, 44.12836334800005],
              [8.233164910000085, 44.103583075000074],
              [8.229991082000083, 44.09634023600006],
              [8.231211785000085, 44.08030833500004],
              [8.229991082000083, 44.07249583500004],
              [8.223806186000047, 44.05719635600008],
              [8.216319207000083, 44.04523346600007],
              [8.169118686000047, 44.00665924700007],
              [8.152679884000065, 43.98322174700007],
              [8.167979363000086, 43.96263255400004],
              [8.167979363000086, 43.95648834800005],
              [8.144704623000052, 43.95258209800005],
              [8.115244988000086, 43.92767975500004],
              [8.08920332100007, 43.91986725500004],
              [8.081553582000083, 43.915228583000044],
              [8.075450066000087, 43.90965403900009],
              [8.073008660000085, 43.90460846600007],
              [8.06771894600007, 43.89667389500005],
              [8.055674675000091, 43.89207591400009],
              [8.031423373000052, 43.88751862200007],
              [7.959727410000085, 43.852850653000075],
              [7.785817905000044, 43.821966864000046],
              [7.736582879000082, 43.79824453300006],
              [7.69499759200005, 43.79120514500005],
              [7.57203209700009, 43.79132721600007],
              [7.544118686000047, 43.784491278000075],
              [7.531097852000073, 43.784491278000075],
              [7.52320397200009, 43.789048570000034],
              [7.512868686000047, 43.79214101800005],
              [7.502289259000065, 43.792222398000035],
              [7.482726278000058, 43.840219219000076],
              [7.477868693000062, 43.86551483200013],
              [7.493474976000101, 43.88623708100006],
              [7.536779826000071, 43.92078277600005],
              [7.556933634000131, 43.94408884700009],
              [7.608610066000068, 43.97561147100005],
              [7.630934285000137, 43.993543193000036],
              [7.63868575000015, 44.005067037000046],
              [7.646953979000102, 44.027494609000044],
              [7.65336185700005, 44.03969024700005],
              [7.664317261000093, 44.04857859300007],
              [7.67878666200005, 44.056588441000045],
              [7.689948771000076, 44.06733713800007],
              [7.691912475000095, 44.08464874300007],
              [7.687942587000094, 44.090799457000074],
              [7.676202840000144, 44.10898834300009],
              [7.654085327000132, 44.12495636000004],
              [7.64188968900001, 44.14355987600008],
              [7.655635620000055, 44.1760643520001],
              [7.624733114000065, 44.180095113],
              [7.583598674000086, 44.160716451000056],
              [7.554763224000055, 44.15906280600008],
              [7.380820353000075, 44.12294098000008],
              [7.34061608900015, 44.12366444900009],
              [7.331004272000143, 44.12526641900011],
              [7.32159916100008, 44.131881002000014],
              [7.316224813000133, 44.14020090800007],
              [7.309300171000132, 44.147487284000064],
              [7.296174357000069, 44.15115631100004],
              [7.270129435000115, 44.1543085740001],
              [7.251319214000091, 44.16004465700006],
              [7.144969116000084, 44.207225240000085],
              [7.104868205000088, 44.21776723300006],
              [7.046060425000121, 44.240298157000055],
              [7.033451375000084, 44.24293365500007],
              [7.020015503000138, 44.24210683200006],
              [7.008026570000084, 44.239212952000074],
              [6.996140991000061, 44.23781768800008],
              [6.982808471000055, 44.24174509800007],
              [6.973403361000095, 44.249444885000045],
              [6.968855835000056, 44.258178202000025],
              [6.96554854300004, 44.26753163600007],
              [6.959244019000039, 44.27735015900005],
              [6.950045613000043, 44.285101624000035],
              [6.930201864000139, 44.29538523400005],
              [6.921210164000087, 44.30215484600008],
              [6.915629110000083, 44.309699605000034],
              [6.903846883000085, 44.33000844400006],
              [6.895992065000144, 44.33982696600002],
              [6.873977905000061, 44.358378805000044],
              [6.869843791000051, 44.362926331],
              [6.866123088000052, 44.37212473600009],
              [6.866329793000091, 44.37718902600007],
              [6.868810262000068, 44.3831834920001],
              [6.877181844000035, 44.414396057000076],
              [6.88420983900005, 44.42302602200003],
              [6.917799519000084, 44.43630686400003],
              [6.891651245000077, 44.451964824000086],
              [6.861265503000112, 44.474909160000024],
              [6.838837931000114, 44.502917786000026],
              [6.835737345000069, 44.53402699800007],
              [6.84638269000007, 44.547462871000036],
              [6.89733565200001, 44.575419821000125],
              [6.931648804000133, 44.61794952500007],
              [6.945601441000122, 44.625442607000096],
              [6.934335978000149, 44.64668162],
              [6.941467326000094, 44.66699045900002],
              [6.959864135000089, 44.683165182],
              [6.982808471000055, 44.69215688100003],
              [7.001205282000029, 44.692260234000074],
              [7.03727543200003, 44.684612122],
              [7.055155476000095, 44.684870504000074],
              [7.049367717000109, 44.697892965],
              [7.01898197400007, 44.73887237600003],
              [7.015157918000114, 44.74739898700004],
              [7.009783569000149, 44.77210032200007],
              [6.998414754000066, 44.793752747000056],
              [6.999138224000063, 44.795044658000094],
              [7.004099162000017, 44.81080596900007],
              [7.00595951400004, 44.811529440000086],
              [7.005856160000093, 44.81633534800007],
              [7.006786336000062, 44.81902252200011],
              [7.007096395000133, 44.822071432000044],
              [7.004925985000057, 44.827962545000034],
              [7.000791870000114, 44.8329751590001],
              [6.982808471000055, 44.846979472],
              [6.932682332000127, 44.8616555790001],
              [6.915319051000097, 44.86268910800008],
              [6.866019735000094, 44.85566111300007],
              [6.847106161000056, 44.8590717580001],
              [6.778169800000029, 44.887648825000056],
              [6.745406941000027, 44.90780263300003],
              [6.727940307000097, 44.92873158800002],
              [6.729904012000105, 44.984697164000025],
              [6.723496134000072, 45.013377584000025],
              [6.69724450700005, 45.02691681],
              [6.662207885000043, 45.029242249000035],
              [6.651665894000075, 45.03565012600008],
              [6.639676961000106, 45.05037791000008],
              [6.63698978700009, 45.05942128500003],
              [6.638126669000087, 45.067431132000095],
              [6.636576375000061, 45.07445912700011],
              [6.620298299000126, 45.08443267900013],
              [6.602728312000067, 45.1034496060001],
              [6.614613892000108, 45.11476674500007],
              [6.629385185000046, 45.12354511300005],
              [6.632700643000106, 45.12551544200009],
              [6.66737552900014, 45.13962310900003],
              [6.676263875000132, 45.140759990000035],
              [6.694350626000073, 45.140294902],
              [6.702205445000089, 45.14122507800006],
              [6.710887085000138, 45.14473907500012],
              [6.728870483000037, 45.15460927300008],
              [6.736415242000078, 45.15734812500004],
              [6.77145186300001, 45.1531623340001],
              [6.808142131000068, 45.13910634400007],
              [6.84410892700015, 45.130114645000035],
              [6.876665079000105, 45.14122507800006],
              [6.878628784000028, 45.14742625000004],
              [6.872841023000149, 45.152025452000075],
              [6.868190144000096, 45.157451477000066],
              [6.873461141000121, 45.165926412000076],
              [6.881315958000073, 45.16840688100005],
              [6.904673706000096, 45.168613587],
              [6.913768758000089, 45.17016388000012],
              [6.928444865000074, 45.17956899000008],
              [6.945808146000076, 45.20106638600002],
              [6.958727254000081, 45.20979970300009],
              [6.99448734500001, 45.22132354800003],
              [7.029730672000085, 45.22819651300007],
              [7.037688843000041, 45.225767721000025],
              [7.050194539000131, 45.215019023000096],
              [7.055465536000071, 45.21367543600003],
              [7.062183471000111, 45.218533021000056],
              [7.081200399000068, 45.24307932500004],
              [7.108382202000143, 45.259202373],
              [7.108382202000143, 45.27491200800007],
              [7.097633504000044, 45.29496246400002],
              [7.092569213000075, 45.323952942000105],
              [7.097736857000058, 45.32984405600011],
              [7.130086304000145, 45.3570775350001],
              [7.150756877000077, 45.38322581000001],
              [7.159645223000098, 45.39847035800004],
              [7.160678752000081, 45.41092437800005],
              [7.15292728600005, 45.41511016900007],
              [7.110139201000038, 45.42828765900005],
              [7.096806681000118, 45.43541900700008],
              [7.088745158000108, 45.446632793000035],
              [7.081820515000032, 45.45908681300001],
              [7.075368543000081, 45.466285856000056],
              [7.072001993000072, 45.470042217000085],
              [7.028490437000045, 45.493141581000074],
              [6.982808471000055, 45.51112498000005],
              [6.9752637120001, 45.525646058000106],
              [6.96978601100011, 45.56698720300004],
              [6.965858601000122, 45.574428609000066],
              [6.954903198000068, 45.58621083600006],
              [6.952939494000105, 45.59427236000006],
              [6.95562666800015, 45.60259226500001],
              [6.967098836000076, 45.62016225200007],
              [6.96947595200001, 45.62584665900003],
              [6.963378133000049, 45.640729472000075],
              [6.951079142000111, 45.646775615000124],
              [6.918626343000085, 45.6525633750001],
              [6.905293823000079, 45.65969472300013],
              [6.882556193000084, 45.67550771100012],
              [6.869223673000079, 45.679021708000064],
              [6.843075398000082, 45.682742412],
              [6.816100301000034, 45.69685007700012],
              [6.79594649200007, 45.71814076800011],
              [6.784681030000115, 45.75958526600006],
              [6.781993856000071, 45.77746531200002],
              [6.782717325000078, 45.795293681000075],
              [6.788091675000118, 45.81172678700004],
              [6.800804077000095, 45.82645457000005],
              [6.816203654000077, 45.832914124000084],
              [6.843355552194634, 45.83864285996073],
              [6.851996927951799, 45.83622327474872],
              [6.858564373527243, 45.83345803450643],
              [6.864440509042115, 45.826890588930986],
              [6.870662299587273, 45.82827320905213],
              [6.871699264678133, 45.832766724445854],
              [6.872736229768993, 45.83967982505159],
              [6.873461141000121, 45.844799704000124],
              [6.880385782000104, 45.84552317300002],
              [6.905087117000107, 45.84536814400006],
              [6.926377808000098, 45.84976064100006],
              [6.949012085000049, 45.85782216400007],
              [6.969165893000138, 45.86975942000002],
              [6.982808471000055, 45.885779114000044],
              [6.989112997000063, 45.899266663000034],
              [6.997174519000055, 45.911307272],
              [7.007716512000115, 45.920505677000094],
              [7.022082560000115, 45.925259909],
            ],
            [
              [12.4294503590001, 43.892055515],
              [12.460456219000037, 43.895259454000055],
              [12.478286774000082, 43.917037885000084],
              [12.477493853000112, 43.92005098400007],
              [12.478026206000095, 43.92321640400006],
              [12.479576499000132, 43.92580022500006],
              [12.482160321000038, 43.92791895900005],
              [12.48309447400004, 43.92920489800004],
              [12.490325196000128, 43.93915858300009],
              [12.492392254000094, 43.956418511],
              [12.48918831500012, 43.9731099990001],
              [12.482160321000038, 43.98256678600008],
              [12.453324871000092, 43.97905278900005],
              [12.42138883600012, 43.96721888500012],
              [12.411048669000138, 43.95966101200004],
              [12.395653973000037, 43.94840866400001],
              [12.385628745000105, 43.924534153000124],
              [12.399581381000075, 43.903217625000124],
              [12.4294503590001, 43.892055515],
            ],
            [
              [12.45313691700008, 41.90275194100009],
              [12.454035442000077, 41.90275194100009],
              [12.453982588000144, 41.903861884],
              [12.45303120800014, 41.903914738000125],
              [12.452766936000103, 41.903439049],
              [12.452714082000085, 41.903016213000015],
              [12.45313691700008, 41.90275194100009],
            ],
          ],
          [
            [
              [11.999522332000083, 36.835923570000034],
              [12.037608269000089, 36.806626695000034],
              [12.051524285000085, 36.790350653000075],
              [12.053477410000085, 36.767645575000074],
              [12.03060957100007, 36.74135976800005],
              [11.996104363000086, 36.74494049700007],
              [11.961192254000082, 36.76520416900007],
              [11.937347852000073, 36.788763739000046],
              [11.93295332100007, 36.79564036700009],
              [11.924978061000047, 36.81195709800005],
              [11.922211134000065, 36.82835521000004],
              [11.934336785000085, 36.835923570000034],
              [11.93881269600007, 36.83706289300005],
              [11.946136915000068, 36.84170156500005],
              [11.951345248000052, 36.84275950700004],
              [11.957692905000044, 36.84056224200009],
              [11.967295769000089, 36.83120351800005],
              [11.971446160000085, 36.82908763200004],
              [11.980642123000052, 36.82709381700005],
              [11.987315300000091, 36.82416413000004],
              [11.992930535000085, 36.825384833000044],
              [11.999522332000083, 36.835923570000034],
            ],
          ],
          [
            [
              [12.27320397200009, 37.939520575000074],
              [12.286957227000073, 37.93854401200008],
              [12.297048373000052, 37.94131094000005],
              [12.305430535000085, 37.944973049000055],
              [12.31421959700009, 37.94635651200008],
              [12.321299675000091, 37.94049713700008],
              [12.336761915000068, 37.93305084800005],
              [12.354665561000047, 37.926988023000035],
              [12.36882571700005, 37.92523834800005],
              [12.357676629000082, 37.914048570000034],
              [12.342133009000065, 37.91323476800005],
              [12.326182488000086, 37.91836172100005],
              [12.31421959700009, 37.92523834800005],
              [12.299652540000068, 37.919256903000075],
              [12.287771030000044, 37.921535549000055],
              [12.27865644600007, 37.92918528900009],
              [12.27320397200009, 37.939520575000074],
            ],
          ],
          [
            [
              [15.52865644600007, 38.30263906500005],
              [15.559255405000044, 38.300116278000075],
              [15.615977410000085, 38.28021881700005],
              [15.651621941000087, 38.27529531500005],
              [15.648285352000073, 38.26675039300005],
              [15.642425977000073, 38.26227448100008],
              [15.63445071700005, 38.260931708000044],
              [15.624278191000087, 38.26166413000004],
              [15.58375084700009, 38.24042389500005],
              [15.56967207100007, 38.22695547100005],
              [15.562998894000089, 38.21430084800005],
              [15.55990644600007, 38.19977448100008],
              [15.57593834700009, 38.20018138200004],
              [15.52702884200005, 38.136786200000074],
              [15.500336134000065, 38.08494700700004],
              [15.392588738000086, 37.97614166900007],
              [15.302744988000086, 37.86440664300005],
              [15.283457879000082, 37.83295319200005],
              [15.266286655000044, 37.81191640800006],
              [15.241221550000091, 37.79555898600006],
              [15.213063998000052, 37.76146067900004],
              [15.206553582000083, 37.747748114000046],
              [15.208262566000087, 37.73704661700009],
              [15.218597852000073, 37.718085028000075],
              [15.220225457000083, 37.706732489000046],
              [15.216075066000087, 37.69672272300005],
              [15.202159050000091, 37.68537018400008],
              [15.199066602000073, 37.67572663000004],
              [15.196787957000083, 37.65509674700007],
              [15.184580925000091, 37.62579987200007],
              [15.178558790000068, 37.60431549700007],
              [15.16382897200009, 37.567694403000075],
              [15.115896030000044, 37.52228424700007],
              [15.096690300000091, 37.49445221600007],
              [15.09156334700009, 37.47748444200005],
              [15.08952884200005, 37.45945872600004],
              [15.092051629000082, 37.360541083000044],
              [15.096690300000091, 37.34369538000004],
              [15.103526238000086, 37.329779364000046],
              [15.11068769600007, 37.32184479400007],
              [15.180023634000065, 37.29075755400004],
              [15.217458530000044, 37.28497955900008],
              [15.236664259000065, 37.274725653000075],
              [15.251963738000086, 37.25771719000005],
              [15.261241082000083, 37.23383209800005],
              [15.244883660000085, 37.246161200000074],
              [15.235606316000087, 37.24192942900004],
              [15.228851759000065, 37.23029205900008],
              [15.220225457000083, 37.22016022300005],
              [15.221690300000091, 37.23745351800005],
              [15.215830925000091, 37.24469635600008],
              [15.205414259000065, 37.24469635600008],
              [15.192881707000083, 37.23997630400004],
              [15.199066602000073, 37.22760651200008],
              [15.183441602000073, 37.207464911000045],
              [15.19467207100007, 37.17633698100008],
              [15.21648196700005, 37.15521881700005],
              [15.233246290000068, 37.16486237200007],
              [15.247569207000083, 37.15867747600004],
              [15.247569207000083, 37.15184153900009],
              [15.229177280000044, 37.149644273000035],
              [15.23178144600007, 37.13491445500006],
              [15.246592644000089, 37.11823151200008],
              [15.264659050000091, 37.11029694200005],
              [15.28882897200009, 37.10838450700004],
              [15.303233269000089, 37.101223049000055],
              [15.307871941000087, 37.08665599200009],
              [15.302744988000086, 37.062486070000034],
              [15.287933790000068, 37.06899648600006],
              [15.281993035000085, 37.06085846600007],
              [15.283702019000089, 37.04840729400007],
              [15.291840040000068, 37.04197825700004],
              [15.31226647200009, 37.04401276200008],
              [15.321055535000085, 37.040228583000044],
              [15.32943769600007, 37.02773672100005],
              [15.332367384000065, 37.01162344000005],
              [15.324717644000089, 37.00849030200004],
              [15.31421959700009, 37.01243724200009],
              [15.308929884000065, 37.01776764500005],
              [15.303396030000044, 37.01618073100008],
              [15.268077019000089, 37.000433661000045],
              [15.274912957000083, 36.99359772300005],
              [15.266123894000089, 36.98940664300005],
              [15.263845248000052, 36.98712799700007],
              [15.268077019000089, 36.980536200000074],
              [15.268077019000089, 36.973089911000045],
              [15.244476759000065, 36.97207265800006],
              [15.226735873000052, 36.96478913000004],
              [15.211680535000085, 36.95648834800005],
              [15.196055535000085, 36.95262278900009],
              [15.174652540000068, 36.94407786700009],
              [15.158376498000052, 36.92422109600005],
              [15.107676629000082, 36.82013580900008],
              [15.106618686000047, 36.808579820000034],
              [15.094004754000082, 36.79954661700009],
              [15.098887566000087, 36.77944570500006],
              [15.117198113000086, 36.74713776200008],
              [15.134938998000052, 36.68768952000005],
              [15.134287957000083, 36.67519765800006],
              [15.114512566000087, 36.65989817900004],
              [15.093923373000052, 36.65493398600006],
              [15.07357832100007, 36.65912506700005],
              [15.055186394000089, 36.67145416900007],
              [15.04070071700005, 36.68768952000005],
              [15.033050977000073, 36.69391510600008],
              [15.021006707000083, 36.69936758000006],
              [15.00717207100007, 36.702785549000055],
              [14.99781334700009, 36.70221588700008],
              [14.993662957000083, 36.69594961100006],
              [14.982432488000086, 36.68886953300006],
              [14.957286004000082, 36.69782135600008],
              [14.918630405000044, 36.71987539300005],
              [14.88217207100007, 36.73065827000005],
              [14.846853061000047, 36.726263739000046],
              [14.780772332000083, 36.69936758000006],
              [14.776133660000085, 36.70770905200004],
              [14.773448113000086, 36.71002838700008],
              [14.760915561000047, 36.70620351800005],
              [14.744313998000052, 36.71914297100005],
              [14.684580925000091, 36.72601959800005],
              [14.67164147200009, 36.74371979400007],
              [14.658946160000085, 36.75381094000005],
              [14.600108269000089, 36.77212148600006],
              [14.582204623000052, 36.781317450000074],
              [14.565928582000083, 36.77830638200004],
              [14.487315300000091, 36.79336172100005],
              [14.475759311000047, 36.80491771000004],
              [14.394541863000086, 36.945013739000046],
              [14.369883660000085, 36.973089911000045],
              [14.278819207000083, 37.04401276200008],
              [14.208506707000083, 37.08112213700008],
              [14.12631269600007, 37.11225006700005],
              [14.088633660000085, 37.11774323100008],
              [13.97632897200009, 37.11029694200005],
              [13.967295769000089, 37.10822174700007],
              [13.94857832100007, 37.098822333000044],
              [13.938487175000091, 37.09593333500004],
              [13.894379102000073, 37.100816148000035],
              [13.832692905000044, 37.139553127000056],
              [13.79460696700005, 37.15184153900009],
              [13.75163821700005, 37.15900299700007],
              [13.715830925000091, 37.17137278900009],
              [13.683441602000073, 37.18935781500005],
              [13.598806186000047, 37.256740627000056],
              [13.569183790000068, 37.273504950000074],
              [13.534434441000087, 37.28217194200005],
              [13.488617384000065, 37.28847890800006],
              [13.452647332000083, 37.298814195000034],
              [13.42156009200005, 37.31439850500004],
              [13.372243686000047, 37.346136786000045],
              [13.329600457000083, 37.36627838700008],
              [13.311289910000085, 37.380845445000034],
              [13.302012566000087, 37.38572825700004],
              [13.289235873000052, 37.38914622600004],
              [13.278005405000044, 37.39370351800005],
              [13.25326582100007, 37.43178945500006],
              [13.247325066000087, 37.43593984600005],
              [13.225352410000085, 37.44603099200009],
              [13.214040561000047, 37.45807526200008],
              [13.206065300000091, 37.46393463700008],
              [13.194590691000087, 37.46653880400004],
              [13.18921959700009, 37.46971263200004],
              [13.17937259200005, 37.48383209800005],
              [13.174082879000082, 37.48700592700004],
              [13.051524285000085, 37.50067780200004],
              [13.03679446700005, 37.49485911700009],
              [13.026377800000091, 37.49323151200008],
              [13.016856316000087, 37.49754466400009],
              [13.010427280000044, 37.50690338700008],
              [13.004161004000082, 37.52708567900004],
              [13.000010613000086, 37.53546784100007],
              [12.974131707000083, 37.55744049700007],
              [12.942637566000087, 37.56850820500006],
              [12.862152540000068, 37.57640208500004],
              [12.78093509200005, 37.574204820000034],
              [12.697764519000089, 37.56273021000004],
              [12.659353061000047, 37.56513092700004],
              [12.636241082000083, 37.58222077000005],
              [12.594737175000091, 37.637884833000044],
              [12.57781009200005, 37.652004299000055],
              [12.563487175000091, 37.65778229400007],
              [12.523610873000052, 37.65835195500006],
              [12.506195509000065, 37.66551341400009],
              [12.489024285000085, 37.68268463700008],
              [12.47437584700009, 37.70294830900008],
              [12.465017123000052, 37.71979401200008],
              [12.460459832000083, 37.73460521000004],
              [12.459157748000052, 37.747748114000046],
              [12.456309441000087, 37.759751695000034],
              [12.448008660000085, 37.77130768400008],
              [12.436289910000085, 37.78314850500004],
              [12.427012566000087, 37.79702383000006],
              [12.42741946700005, 37.80927155200004],
              [12.444590691000087, 37.81598541900007],
              [12.446055535000085, 37.811835028000075],
              [12.460459832000083, 37.81903717700004],
              [12.465017123000052, 37.82282135600008],
              [12.463063998000052, 37.82575104400007],
              [12.470225457000083, 37.85342031500005],
              [12.47242272200009, 37.85419342700004],
              [12.477712436000047, 37.87254466400009],
              [12.478688998000052, 37.88117096600007],
              [12.476735873000052, 37.885931708000044],
              [12.467784050000091, 37.89712148600006],
              [12.465017123000052, 37.90599192900004],
              [12.464121941000087, 37.91290924700007],
              [12.46452884200005, 37.914129950000074],
              [12.467051629000082, 37.91616445500006],
              [12.490489129000082, 37.954006252000056],
              [12.496592644000089, 37.98061758000006],
              [12.502940300000091, 37.99705638200004],
              [12.504161004000082, 38.01121653900009],
              [12.492930535000085, 38.02142975500004],
              [12.523448113000086, 38.03143952000005],
              [12.549652540000068, 38.05483633000006],
              [12.576345248000052, 38.07172272300005],
              [12.608409050000091, 38.06240469000005],
              [12.638682488000086, 38.07949453300006],
              [12.651621941000087, 38.091498114000046],
              [12.656911655000044, 38.10736725500004],
              [12.662445509000065, 38.11627838700008],
              [12.676036004000082, 38.11587148600006],
              [12.691905144000089, 38.11212799700007],
              [12.704600457000083, 38.11082591400009],
              [12.725352410000085, 38.12592194200005],
              [12.72396894600007, 38.15033600500004],
              [12.719899936000047, 38.175482489000046],
              [12.73178144600007, 38.19277578300006],
              [12.737803582000083, 38.180975653000075],
              [12.74935957100007, 38.182074286000045],
              [12.760915561000047, 38.180975653000075],
              [12.766123894000089, 38.16266510600008],
              [12.79078209700009, 38.11709219000005],
              [12.818369988000086, 38.07794830900008],
              [12.828786655000044, 38.06989166900007],
              [12.856944207000083, 38.058579820000034],
              [12.86890709700009, 38.05133698100008],
              [12.869639519000089, 38.04254791900007],
              [12.901133660000085, 38.02806224200009],
              [12.944183790000068, 38.032863674000055],
              [13.027354363000086, 38.06240469000005],
              [13.061371290000068, 38.08348216400009],
              [13.06967207100007, 38.091131903000075],
              [13.071299675000091, 38.09552643400008],
              [13.069590691000087, 38.10146719000005],
              [13.068207227000073, 38.11395905200004],
              [13.06617272200009, 38.123032945000034],
              [13.056813998000052, 38.13271719000005],
              [13.054698113000086, 38.141831773000035],
              [13.089366082000083, 38.166001695000034],
              [13.08375084700009, 38.174709377000056],
              [13.08961022200009, 38.18333567900004],
              [13.10092207100007, 38.19009023600006],
              [13.112478061000047, 38.19277578300006],
              [13.12240644600007, 38.19098541900007],
              [13.156993035000085, 38.179673570000034],
              [13.17937259200005, 38.176214911000045],
              [13.207204623000052, 38.17609284100007],
              [13.230316602000073, 38.18463776200008],
              [13.239024285000085, 38.207017320000034],
              [13.254405144000089, 38.20254140800006],
              [13.265961134000065, 38.20526764500005],
              [13.27702884200005, 38.21043528900009],
              [13.29664147200009, 38.21442291900007],
              [13.31023196700005, 38.21954987200007],
              [13.31812584700009, 38.22064850500004],
              [13.323252800000091, 38.217962958000044],
              [13.325043165000068, 38.21165599200009],
              [13.326019727000073, 38.204779364000046],
              [13.328379754000082, 38.20018138200004],
              [13.366221550000091, 38.179673570000034],
              [13.371918165000068, 38.17279694200005],
              [13.373301629000082, 38.140692450000074],
              [13.37671959700009, 38.131293036000045],
              [13.391368035000085, 38.103176174000055],
              [13.513519727000073, 38.110541083000044],
              [13.541270379000082, 38.09406159100007],
              [13.539317254000082, 38.07684967700004],
              [13.540863477000073, 38.06753164300005],
              [13.547373894000089, 38.05621979400007],
              [13.557465040000068, 38.04913971600007],
              [13.587087436000047, 38.039129950000074],
              [13.62240644600007, 38.01520416900007],
              [13.651133660000085, 38.00096263200004],
              [13.697764519000089, 37.99359772300005],
              [13.711924675000091, 37.987941799000055],
              [13.707774285000085, 37.98509349200009],
              [13.707286004000082, 37.984035549000055],
              [13.705088738000086, 37.980454820000034],
              [13.726735873000052, 37.980902411000045],
              [13.79078209700009, 37.97361888200004],
              [13.812673373000052, 37.97793203300006],
              [13.85718834700009, 37.99673086100006],
              [13.898285352000073, 38.00446198100008],
              [13.912282748000052, 38.01264069200005],
              [13.924815300000091, 38.02195872600004],
              [13.938487175000091, 38.02887604400007],
              [14.00717207100007, 38.038275458000044],
              [14.020518425000091, 38.04938385600008],
              [14.062510613000086, 38.03021881700005],
              [14.083262566000087, 38.02383047100005],
              [14.106293165000068, 38.02142975500004],
              [14.120941602000073, 38.02260976800005],
              [14.151377800000091, 38.02887604400007],
              [14.27320397200009, 38.01512278900009],
              [14.331228061000047, 38.018011786000045],
              [14.384613477000073, 38.02952708500004],
              [14.431895379000082, 38.04938385600008],
              [14.464121941000087, 38.037176825000074],
              [14.511729363000086, 38.04437897300005],
              [14.634613477000073, 38.08148834800005],
              [14.66773522200009, 38.09918854400007],
              [14.695974155000044, 38.12103913000004],
              [14.73373457100007, 38.15761953300006],
              [14.744802280000044, 38.161363023000035],
              [14.777598504000082, 38.15924713700008],
              [14.798106316000087, 38.16034577000005],
              [14.874034050000091, 38.17568594000005],
              [14.88803144600007, 38.18260325700004],
              [14.897471550000091, 38.18593984600005],
              [14.907074415000068, 38.18768952000005],
              [14.93531334700009, 38.18593984600005],
              [14.94499759200005, 38.18178945500006],
              [14.963063998000052, 38.163397528000075],
              [14.969737175000091, 38.15924713700008],
              [14.98178144600007, 38.158270575000074],
              [15.007334832000083, 38.15180084800005],
              [15.039073113000086, 38.15330638200004],
              [15.049001498000052, 38.15180084800005],
              [15.053070509000065, 38.14838288000004],
              [15.063243035000085, 38.13568756700005],
              [15.068695509000065, 38.131293036000045],
              [15.087901238000086, 38.128241278000075],
              [15.105316602000073, 38.13349030200004],
              [15.122569207000083, 38.141058661000045],
              [15.17741946700005, 38.156317450000074],
              [15.203298373000052, 38.183294989000046],
              [15.240733269000089, 38.24115631700005],
              [15.23764082100007, 38.24884674700007],
              [15.23609459700009, 38.25104401200008],
              [15.236989780000044, 38.25348541900007],
              [15.240733269000089, 38.26166413000004],
              [15.237152540000068, 38.26479726800005],
              [15.243174675000091, 38.26479726800005],
              [15.246348504000082, 38.254339911000045],
              [15.240733269000089, 38.23029205900008],
              [15.245371941000087, 38.217230536000045],
              [15.25757897200009, 38.210191148000035],
              [15.274180535000085, 38.20750560100004],
              [15.291840040000068, 38.207017320000034],
              [15.321055535000085, 38.21088288000004],
              [15.399668816000087, 38.23257070500006],
              [15.421885613000086, 38.244574286000045],
              [15.433767123000052, 38.253159898000035],
              [15.472911004000082, 38.26780833500004],
              [15.512868686000047, 38.29759349200009],
              [15.52865644600007, 38.30263906500005],
            ],
          ],
          [
            [
              [14.966319207000083, 38.432928778000075],
              [14.966319207000083, 38.41868724200009],
              [14.982432488000086, 38.41242096600007],
              [14.993662957000083, 38.40302155200004],
              [15.00171959700009, 38.39126211100006],
              [15.007334832000083, 38.37767161700009],
              [14.998545769000089, 38.37103913000004],
              [14.986827019000089, 38.36408112200007],
              [14.963552280000044, 38.38165924700007],
              [14.948252800000091, 38.39642975500004],
              [14.945323113000086, 38.41225820500006],
              [14.958832227000073, 38.432928778000075],
              [14.966319207000083, 38.432928778000075],
            ],
          ],
          [
            [
              [14.907725457000083, 38.473944403000075],
              [14.899424675000091, 38.481675523000035],
              [14.900645379000082, 38.49868398600006],
              [14.909678582000083, 38.515326239000046],
              [14.924815300000091, 38.522365627000056],
              [14.957855665000068, 38.52204010600008],
              [14.966075066000087, 38.51626211100006],
              [14.958832227000073, 38.50185781500005],
              [14.965505405000044, 38.49754466400009],
              [14.974131707000083, 38.49005768400008],
              [14.979340040000068, 38.487534898000035],
              [14.979340040000068, 38.48139069200005],
              [14.952647332000083, 38.48139069200005],
              [14.957855665000068, 38.46954987200007],
              [14.961192254000082, 38.46499258000006],
              [14.966319207000083, 38.46088288000004],
              [14.966319207000083, 38.45343659100007],
              [14.948741082000083, 38.45091380400004],
              [14.934580925000091, 38.458644924000055],
              [14.92156009200005, 38.468817450000074],
              [14.907725457000083, 38.473944403000075],
            ],
          ],
          [
            [
              [14.863291863000086, 38.54901764500005],
              [14.861664259000065, 38.53929271000004],
              [14.82398522200009, 38.55182526200008],
              [14.793793165000068, 38.571600653000075],
              [14.814952019000089, 38.58380768400008],
              [14.851410352000073, 38.58490631700005],
              [14.86695397200009, 38.58112213700008],
              [14.876963738000086, 38.569525458000044],
              [14.871918165000068, 38.56525299700007],
              [14.86890709700009, 38.56049225500004],
              [14.863291863000086, 38.54901764500005],
            ],
          ],
          [
            [
              [8.455902540000068, 39.073553778000075],
              [8.458018425000091, 39.068060614000046],
              [8.463145379000082, 39.06525299700007],
              [8.469899936000047, 39.065659898000035],
              [8.476410352000073, 39.06976959800005],
              [8.477305535000085, 39.07070547100005],
              [8.479177280000044, 39.07221100500004],
              [8.483897332000083, 39.06976959800005],
              [8.464040561000047, 39.05654531500005],
              [8.459320509000065, 39.04979075700004],
              [8.463389519000089, 39.04246653900009],
              [8.453949415000068, 39.02814362200007],
              [8.446543816000087, 38.99433014500005],
              [8.437022332000083, 38.96718984600005],
              [8.432465040000068, 38.96283600500004],
              [8.421885613000086, 38.96051666900007],
              [8.40984134200005, 38.961818752000056],
              [8.40601647200009, 38.96694570500006],
              [8.405039910000085, 38.97402578300006],
              [8.401377800000091, 38.98102448100008],
              [8.36491946700005, 39.02948639500005],
              [8.34929446700005, 39.062160549000055],
              [8.353526238000086, 39.08344147300005],
              [8.353526238000086, 39.09088776200008],
              [8.346039259000065, 39.09088776200008],
              [8.346039259000065, 39.097723700000074],
              [8.360362175000091, 39.11815013200004],
              [8.385915561000047, 39.10504791900007],
              [8.41765384200005, 39.10659414300005],
              [8.444590691000087, 39.102728583000044],
              [8.455902540000068, 39.073553778000075],
            ],
          ],
          [
            [
              [8.305837436000047, 39.19330475500004],
              [8.30632571700005, 39.16079336100006],
              [8.312022332000083, 39.120306708000044],
              [8.305837436000047, 39.10455963700008],
              [8.290049675000091, 39.098822333000044],
              [8.269379102000073, 39.10016510600008],
              [8.254730665000068, 39.107123114000046],
              [8.257334832000083, 39.11815013200004],
              [8.257334832000083, 39.12441640800006],
              [8.232676629000082, 39.14411041900007],
              [8.224619988000086, 39.15704987200007],
              [8.229991082000083, 39.17279694200005],
              [8.245290561000047, 39.180975653000075],
              [8.290293816000087, 39.18842194200005],
              [8.305837436000047, 39.19330475500004],
            ],
          ],
          [
            [
              [13.94467207100007, 40.701605536000045],
              [13.934825066000087, 40.70563385600008],
              [13.919769727000073, 40.70449453300006],
              [13.903493686000047, 40.70001862200007],
              [13.890147332000083, 40.69415924700007],
              [13.882009311000047, 40.69953034100007],
              [13.859711134000065, 40.70774974200009],
              [13.849131707000083, 40.715277411000045],
              [13.856130405000044, 40.73484935100004],
              [13.861501498000052, 40.74404531500005],
              [13.870127800000091, 40.74872467700004],
              [13.867198113000086, 40.75263092700004],
              [13.862803582000083, 40.76239655200004],
              [13.883148634000065, 40.76239655200004],
              [13.946299675000091, 40.74518463700008],
              [13.965830925000091, 40.73505280200004],
              [13.96265709700009, 40.728949286000045],
              [13.962412957000083, 40.72313060100004],
              [13.965830925000091, 40.715277411000045],
              [13.95866946700005, 40.711818752000056],
              [13.94467207100007, 40.701605536000045],
            ],
          ],
          [
            [
              [8.27475019600007, 41.05727773600006],
              [8.251149936000047, 41.04376862200007],
              [8.250987175000091, 41.01609935100004],
              [8.246429884000065, 40.99363841400009],
              [8.209646030000044, 40.995794989000046],
              [8.217621290000068, 41.00503164300005],
              [8.221690300000091, 41.01439036700003],
              [8.223155144000089, 41.02399323100008],
              [8.223155144000089, 41.033636786000045],
              [8.228851759000065, 41.04173411700003],
              [8.241384311000047, 41.052069403000075],
              [8.260752800000091, 41.06464264500005],
              [8.275645379000082, 41.06976959800005],
              [8.277842644000089, 41.081732489000046],
              [8.275645379000082, 41.095404364000046],
              [8.277842644000089, 41.10565827000005],
              [8.284353061000047, 41.10687897300005],
              [8.30209394600007, 41.10504791900007],
              [8.305837436000047, 41.109076239000046],
              [8.30795332100007, 41.11383698100008],
              [8.313324415000068, 41.11859772300005],
              [8.326182488000086, 41.12612539300005],
              [8.32593834700009, 41.118353583000044],
              [8.327972852000073, 41.112494208000044],
              [8.332367384000065, 41.10565827000005],
              [8.341970248000052, 41.09784577000005],
              [8.344737175000091, 41.08624909100007],
              [8.341319207000083, 41.07412344000005],
              [8.332367384000065, 41.06464264500005],
              [8.27475019600007, 41.05727773600006],
            ],
          ],
          [
            [
              [9.792246941000087, 40.55695221600007],
              [9.820567254000082, 40.536363023000035],
              [9.826426629000082, 40.52960846600007],
              [9.826670769000089, 40.519598700000074],
              [9.815196160000085, 40.50250885600008],
              [9.81218509200005, 40.49237702000005],
              [9.808767123000052, 40.470770575000074],
              [9.800303582000083, 40.455511786000045],
              [9.778086785000085, 40.42723216400009],
              [9.761729363000086, 40.390692450000074],
              [9.74935957100007, 40.37726471600007],
              [9.727386915000068, 40.37201569200005],
              [9.712412957000083, 40.366400458000044],
              [9.70085696700005, 40.35297272300005],
              [9.683116082000083, 40.324204820000034],
              [9.670176629000082, 40.31268952000005],
              [9.645518425000091, 40.296087958000044],
              [9.634613477000073, 40.28261953300006],
              [9.626149936000047, 40.26308828300006],
              [9.624847852000073, 40.247748114000046],
              [9.629079623000052, 40.20555247600004],
              [9.631114129000082, 40.196193752000056],
              [9.654633009000065, 40.144598700000074],
              [9.665049675000091, 40.13157786700009],
              [9.679698113000086, 40.126166083000044],
              [9.687836134000065, 40.12067291900007],
              [9.710215691000087, 40.09634023600006],
              [9.732269727000073, 40.08392975500004],
              [9.730316602000073, 40.06854889500005],
              [9.693369988000086, 39.99290599200009],
              [9.68726647200009, 39.96116771000004],
              [9.69662519600007, 39.93378327000005],
              [9.70248457100007, 39.937201239000046],
              [9.709727410000085, 39.940334377000056],
              [9.715668165000068, 39.94013092700004],
              [9.717784050000091, 39.93378327000005],
              [9.71452884200005, 39.92450592700004],
              [9.708181186000047, 39.92218659100007],
              [9.701426629000082, 39.92206452000005],
              [9.69662519600007, 39.91950104400007],
              [9.689463738000086, 39.90656159100007],
              [9.684336785000085, 39.894232489000046],
              [9.683848504000082, 39.882513739000046],
              [9.689789259000065, 39.87173086100006],
              [9.683116082000083, 39.87173086100006],
              [9.683116082000083, 39.86554596600007],
              [9.687754754000082, 39.86351146000004],
              [9.691905144000089, 39.86005280200004],
              [9.69662519600007, 39.85805898600006],
              [9.69662519600007, 39.85187409100007],
              [9.684255405000044, 39.839911200000074],
              [9.67554772200009, 39.81891510600008],
              [9.670258009000065, 39.79376862200007],
              [9.668793165000068, 39.76927317900004],
              [9.669932488000086, 39.75657786700009],
              [9.675059441000087, 39.732082424000055],
              [9.676280144000089, 39.718085028000075],
              [9.674082879000082, 39.70799388200004],
              [9.664805535000085, 39.691392320000034],
              [9.662608269000089, 39.67682526200008],
              [9.660411004000082, 39.67072174700007],
              [9.655772332000083, 39.66290924700007],
              [9.651133660000085, 39.65249258000006],
              [9.648936394000089, 39.63898346600007],
              [9.655772332000083, 39.59454987200007],
              [9.653005405000044, 39.566839911000045],
              [9.628428582000083, 39.50177643400008],
              [9.644867384000065, 39.48395416900007],
              [9.639008009000065, 39.452460028000075],
              [9.614105665000068, 39.39935944200005],
              [9.602061394000089, 39.35565827000005],
              [9.600433790000068, 39.341009833000044],
              [9.603526238000086, 39.326239325000074],
              [9.611582879000082, 39.31655508000006],
              [9.634613477000073, 39.303168036000045],
              [9.634613477000073, 39.296942450000074],
              [9.607269727000073, 39.28900788000004],
              [9.581879102000073, 39.26630280200004],
              [9.567556186000047, 39.23810455900008],
              [9.573252800000091, 39.21381256700005],
              [9.565603061000047, 39.205064195000034],
              [9.568858269000089, 39.199286200000074],
              [9.576019727000073, 39.19391510600008],
              [9.579925977000073, 39.18707916900007],
              [9.57789147200009, 39.179388739000046],
              [9.568532748000052, 39.159369208000044],
              [9.566416863000086, 39.14923737200007],
              [9.557790561000047, 39.13971588700008],
              [9.539561394000089, 39.134019273000035],
              [9.522715691000087, 39.12490469000005],
              [9.518565300000091, 39.10455963700008],
              [9.510752800000091, 39.10797760600008],
              [9.507090691000087, 39.111395575000074],
              [9.50757897200009, 39.11635976800005],
              [9.511892123000052, 39.12441640800006],
              [9.496348504000082, 39.13361237200007],
              [9.480723504000082, 39.13556549700007],
              [9.465342644000089, 39.13190338700008],
              [9.450368686000047, 39.12441640800006],
              [9.442881707000083, 39.12441640800006],
              [9.437998894000089, 39.13336823100008],
              [9.428965691000087, 39.13861725500004],
              [9.408702019000089, 39.146144924000055],
              [9.383474155000044, 39.169256903000075],
              [9.377696160000085, 39.17279694200005],
              [9.367930535000085, 39.17715078300006],
              [9.34506269600007, 39.19643789300005],
              [9.336680535000085, 39.20075104400007],
              [9.326182488000086, 39.202785549000055],
              [9.31226647200009, 39.207912502000056],
              [9.299571160000085, 39.214504299000055],
              [9.292165561000047, 39.22125885600008],
              [9.285329623000052, 39.21381256700005],
              [9.27125084700009, 39.22052643400008],
              [9.252452019000089, 39.22516510600008],
              [9.216319207000083, 39.22801341400009],
              [9.197438998000052, 39.221136786000045],
              [9.180918816000087, 39.20718008000006],
              [9.16968834700009, 39.193345445000034],
              [9.166026238000086, 39.18707916900007],
              [9.136892123000052, 39.19432200700004],
              [9.113536004000082, 39.21149323100008],
              [9.073008660000085, 39.24852122600004],
              [9.063731316000087, 39.243068752000056],
              [9.055511915000068, 39.24754466400009],
              [9.047536655000044, 39.25600820500006],
              [9.03874759200005, 39.26219310100004],
              [9.024424675000091, 39.264837958000044],
              [9.013926629000082, 39.26390208500004],
              [9.012543165000068, 39.26056549700007],
              [9.025726759000065, 39.25600820500006],
              [9.025726759000065, 39.24852122600004],
              [9.021006707000083, 39.24042389500005],
              [9.026866082000083, 39.23574453300006],
              [9.035166863000086, 39.23216380400004],
              [9.037852410000085, 39.22711823100008],
              [9.03874759200005, 39.22801341400009],
              [9.050059441000087, 39.22565338700008],
              [9.074961785000085, 39.22988515800006],
              [9.07984459700009, 39.224595445000034],
              [9.07984459700009, 39.21653880400004],
              [9.078949415000068, 39.21234772300005],
              [9.038584832000083, 39.179022528000075],
              [9.026215040000068, 39.165228583000044],
              [9.018321160000085, 39.146144924000055],
              [9.015961134000065, 39.12384674700007],
              [9.018728061000047, 39.103949286000045],
              [9.024587436000047, 39.08612702000005],
              [9.031993035000085, 39.06976959800005],
              [9.037771030000044, 39.063666083000044],
              [9.043793165000068, 39.05841705900008],
              [9.044932488000086, 39.05125560100004],
              [9.029307488000086, 39.03025950700004],
              [9.018321160000085, 38.995306708000044],
              [9.025726759000065, 38.995306708000044],
              [9.015147332000083, 38.98965078300006],
              [9.012054884000065, 38.990668036000045],
              [9.004649285000085, 38.995306708000044],
              [8.996348504000082, 38.98281484600005],
              [8.894704623000052, 38.90228913000004],
              [8.887950066000087, 38.89984772300005],
              [8.877452019000089, 38.89907461100006],
              [8.87240644600007, 38.89606354400007],
              [8.861338738000086, 38.882066148000035],
              [8.85328209700009, 38.87799713700008],
              [8.84148196700005, 38.880560614000046],
              [8.82789147200009, 38.88882070500006],
              [8.805430535000085, 38.905951239000046],
              [8.805430535000085, 38.88544342700004],
              [8.791026238000086, 38.90444570500006],
              [8.766612175000091, 38.92039622600004],
              [8.739512566000087, 38.93065013200004],
              [8.71656334700009, 38.93260325700004],
              [8.694590691000087, 38.92523834800005],
              [8.668793165000068, 38.910589911000045],
              [8.651621941000087, 38.89154694200005],
              [8.655121290000068, 38.871161200000074],
              [8.640961134000065, 38.86432526200008],
              [8.634776238000086, 38.871161200000074],
              [8.642832879000082, 38.889960028000075],
              [8.633148634000065, 38.89557526200008],
              [8.615570509000065, 38.89594147300005],
              [8.599864129000082, 38.89907461100006],
              [8.599864129000082, 38.905951239000046],
              [8.61500084700009, 38.92300039300005],
              [8.615489129000082, 38.94757721600007],
              [8.60328209700009, 38.964911200000074],
              [8.580088738000086, 38.96051666900007],
              [8.572276238000086, 39.01361725500004],
              [8.559580925000091, 39.056708075000074],
              [8.55209394600007, 39.056708075000074],
              [8.54428144600007, 39.05125560100004],
              [8.52084394600007, 39.06085846600007],
              [8.504405144000089, 39.062933661000045],
              [8.509043816000087, 39.06793854400007],
              [8.518077019000089, 39.08344147300005],
              [8.504405144000089, 39.09088776200008],
              [8.482758009000065, 39.08038971600007],
              [8.48210696700005, 39.08417389500005],
              [8.477549675000091, 39.09048086100006],
              [8.473317905000044, 39.10736725500004],
              [8.465098504000082, 39.11945221600007],
              [8.454274936000047, 39.12490469000005],
              [8.442230665000068, 39.11815013200004],
              [8.437998894000089, 39.12848541900007],
              [8.438649936000047, 39.15314362200007],
              [8.435394727000073, 39.16596100500004],
              [8.428396030000044, 39.173163153000075],
              [8.418793165000068, 39.17731354400007],
              [8.412608269000089, 39.17572663000004],
              [8.41570071700005, 39.16596100500004],
              [8.40951582100007, 39.16933828300006],
              [8.405039910000085, 39.17438385600008],
              [8.402354363000086, 39.181341864000046],
              [8.401377800000091, 39.19017161700009],
              [8.398692254000082, 39.201157945000034],
              [8.392588738000086, 39.20404694200005],
              [8.385508660000085, 39.204413153000075],
              [8.380137566000087, 39.20758698100008],
              [8.37281334700009, 39.22207265800006],
              [8.371755405000044, 39.23061758000006],
              [8.37671959700009, 39.23786041900007],
              [8.426442905000044, 39.283270575000074],
              [8.432139519000089, 39.30182526200008],
              [8.41570071700005, 39.32367584800005],
              [8.417246941000087, 39.33901601800005],
              [8.382090691000087, 39.35968659100007],
              [8.374034050000091, 39.37885163000004],
              [8.378184441000087, 39.387925523000035],
              [8.395681186000047, 39.40424225500004],
              [8.401377800000091, 39.41242096600007],
              [8.405039910000085, 39.42719147300005],
              [8.403819207000083, 39.43585846600007],
              [8.389496290000068, 39.46234772300005],
              [8.385996941000087, 39.46552155200004],
              [8.386892123000052, 39.46979401200008],
              [8.394541863000086, 39.481350002000056],
              [8.421885613000086, 39.50861237200007],
              [8.43531334700009, 39.52521393400008],
              [8.451670769000089, 39.558294989000046],
              [8.463389519000089, 39.57684967700004],
              [8.455902540000068, 39.58437734600005],
              [8.463877800000091, 39.59788646000004],
              [8.462168816000087, 39.61713288000004],
              [8.449717644000089, 39.65884023600006],
              [8.446787957000083, 39.70408763200004],
              [8.442230665000068, 39.71466705900008],
              [8.442230665000068, 39.72150299700007],
              [8.446462436000047, 39.73086172100005],
              [8.444021030000044, 39.757025458000044],
              [8.446055535000085, 39.76251862200007],
              [8.459727410000085, 39.76048411700009],
              [8.468597852000073, 39.75495026200008],
              [8.49976647200009, 39.71621328300006],
              [8.51693769600007, 39.70213450700004],
              [8.538259311000047, 39.69603099200009],
              [8.56576582100007, 39.70107656500005],
              [8.514496290000068, 39.71369049700007],
              [8.504405144000089, 39.72150299700007],
              [8.506846550000091, 39.73847077000005],
              [8.519867384000065, 39.75543854400007],
              [8.535492384000065, 39.770819403000075],
              [8.545258009000065, 39.78294505400004],
              [8.538584832000083, 39.78294505400004],
              [8.535166863000086, 39.77606842700004],
              [8.530528191000087, 39.770412502000056],
              [8.524912957000083, 39.76581452000005],
              [8.518077019000089, 39.76251862200007],
              [8.529795769000089, 39.77252838700008],
              [8.54078209700009, 39.78925202000005],
              [8.548838738000086, 39.80719635600008],
              [8.55209394600007, 39.82078685100004],
              [8.555186394000089, 39.85268789300005],
              [8.553558790000068, 39.86395905200004],
              [8.545258009000065, 39.878566799000055],
              [8.523448113000086, 39.898871161000045],
              [8.494151238000086, 39.91242096600007],
              [8.463063998000052, 39.914129950000074],
              [8.435394727000073, 39.89899323100008],
              [8.442230665000068, 39.89280833500004],
              [8.445567254000082, 39.898098049000055],
              [8.449961785000085, 39.89911530200004],
              [8.455821160000085, 39.898504950000074],
              [8.463389519000089, 39.89899323100008],
              [8.451833530000044, 39.89288971600007],
              [8.44467207100007, 39.88361237200007],
              [8.435394727000073, 39.85805898600006],
              [8.428721550000091, 39.86554596600007],
              [8.437510613000086, 39.87677643400008],
              [8.43100019600007, 39.885199286000045],
              [8.418304884000065, 39.892279364000046],
              [8.403575066000087, 39.90289948100008],
              [8.400726759000065, 39.903509833000044],
              [8.398285352000073, 39.90534088700008],
              [8.394541863000086, 39.91266510600008],
              [8.393565300000091, 39.92047760600008],
              [8.396332227000073, 39.926947333000044],
              [8.399912957000083, 39.93317291900007],
              [8.401377800000091, 39.94000885600008],
              [8.393565300000091, 39.97687409100007],
              [8.394541863000086, 39.98843008000006],
              [8.406504754000082, 40.009833075000074],
              [8.407074415000068, 40.02220286700009],
              [8.394541863000086, 40.03620026200008],
              [8.380137566000087, 40.03009674700007],
              [8.377207879000082, 40.03375885600008],
              [8.38453209700009, 40.04193756700005],
              [8.401377800000091, 40.04987213700008],
              [8.404470248000052, 40.04950592700004],
              [8.434825066000087, 40.05101146000004],
              [8.452403191000087, 40.05609772300005],
              [8.459727410000085, 40.05731842700004],
              [8.468597852000073, 40.062160549000055],
              [8.479014519000089, 40.07416413000004],
              [8.487315300000091, 40.089544989000046],
              [8.49000084700009, 40.10447825700004],
              [8.485118035000085, 40.11810944200005],
              [8.467295769000089, 40.14472077000005],
              [8.463389519000089, 40.16315338700008],
              [8.459646030000044, 40.216009833000044],
              [8.476410352000073, 40.262152411000045],
              [8.476084832000083, 40.29214101800005],
              [8.462901238000086, 40.314520575000074],
              [8.441254102000073, 40.33144765800006],
              [8.41570071700005, 40.34528229400007],
              [8.408213738000086, 40.33783600500004],
              [8.385996941000087, 40.35179271000004],
              [8.383555535000085, 40.37177155200004],
              [8.394541863000086, 40.423814195000034],
              [8.390472852000073, 40.44232819200005],
              [8.379893425000091, 40.46869538000004],
              [8.365570509000065, 40.49213288000004],
              [8.349864129000082, 40.50234609600005],
              [8.33171634200005, 40.51068756700005],
              [8.32390384200005, 40.53082916900007],
              [8.319590691000087, 40.55560944200005],
              [8.312022332000083, 40.57807038000004],
              [8.291514519000089, 40.595363674000055],
              [8.26734459700009, 40.59406159100007],
              [8.216319207000083, 40.57062409100007],
              [8.195974155000044, 40.57807038000004],
              [8.205332879000082, 40.59780508000006],
              [8.216319207000083, 40.612209377000056],
              [8.193369988000086, 40.61749909100007],
              [8.176605665000068, 40.60659414300005],
              [8.166188998000052, 40.58641185100004],
              [8.16179446700005, 40.563788153000075],
              [8.153086785000085, 40.577785549000055],
              [8.147308790000068, 40.59320709800005],
              [8.140635613000086, 40.61904531500005],
              [8.140635613000086, 40.62518952000005],
              [8.157725457000083, 40.63226959800005],
              [8.173838738000086, 40.64158763200004],
              [8.18531334700009, 40.65656159100007],
              [8.188487175000091, 40.68048737200007],
              [8.19109134200005, 40.68040599200009],
              [8.195567254000082, 40.68528880400004],
              [8.197438998000052, 40.69122955900008],
              [8.192149285000085, 40.69415924700007],
              [8.178965691000087, 40.69476959800005],
              [8.173838738000086, 40.696966864000046],
              [8.167979363000086, 40.701605536000045],
              [8.153330925000091, 40.71971263200004],
              [8.14584394600007, 40.72601959800005],
              [8.133799675000091, 40.72890859600005],
              [8.209646030000044, 40.86542389500005],
              [8.215342644000089, 40.88141510600008],
              [8.216319207000083, 40.899603583000044],
              [8.209727410000085, 40.91445547100005],
              [8.192149285000085, 40.92064036700003],
              [8.178884311000047, 40.928168036000045],
              [8.182302280000044, 40.945298570000034],
              [8.19304446700005, 40.963771877000056],
              [8.202159050000091, 40.97528717700004],
              [8.209646030000044, 40.97528717700004],
              [8.21257571700005, 40.96344635600008],
              [8.219981316000087, 40.96230703300006],
              [8.229014519000089, 40.962551174000055],
              [8.236175977000073, 40.954779364000046],
              [8.235524936000047, 40.946478583000044],
              [8.231618686000047, 40.93451569200005],
              [8.229258660000085, 40.921576239000046],
              [8.233164910000085, 40.91010163000004],
              [8.277842644000089, 40.86542389500005],
              [8.31023196700005, 40.85065338700008],
              [8.421885613000086, 40.838771877000056],
              [8.47787519600007, 40.826157945000034],
              [8.500987175000091, 40.82444896000004],
              [8.520518425000091, 40.82697174700007],
              [8.598399285000085, 40.85297272300005],
              [8.618337436000047, 40.86615631700005],
              [8.634287957000083, 40.88157786700003],
              [8.640961134000065, 40.896470445000034],
              [8.709157748000052, 40.92064036700003],
              [8.733897332000083, 40.92129140800006],
              [8.751231316000087, 40.919134833000044],
              [8.764414910000085, 40.91380442900004],
              [8.822520379000082, 40.947333075000074],
              [8.83961022200009, 40.96161530200004],
              [8.875336134000065, 41.00812409100007],
              [8.887950066000087, 41.01626211100006],
              [8.885915561000047, 41.02008698100008],
              [8.885915561000047, 41.02122630400004],
              [8.885264519000089, 41.02179596600007],
              [8.881114129000082, 41.02366771000004],
              [8.913096550000091, 41.03266022300005],
              [8.922699415000068, 41.036769924000055],
              [8.92945397200009, 41.04364655200004],
              [8.940114780000044, 41.06118398600006],
              [8.946299675000091, 41.06464264500005],
              [8.95875084700009, 41.070013739000046],
              [8.975759311000047, 41.08266836100006],
              [8.990733269000089, 41.097357489000046],
              [9.00554446700005, 41.12189362200007],
              [9.02475019600007, 41.12885163000004],
              [9.093028191000087, 41.135199286000045],
              [9.107758009000065, 41.13947174700007],
              [9.135590040000068, 41.16030508000006],
              [9.141856316000087, 41.152777411000045],
              [9.15756269600007, 41.16889069200005],
              [9.16342207100007, 41.18414948100008],
              [9.162852410000085, 41.22540924700007],
              [9.171071811000047, 41.24290599200003],
              [9.189952019000089, 41.25112539300005],
              [9.212412957000083, 41.25580475500004],
              [9.230642123000052, 41.26264069200005],
              [9.232676629000082, 41.253566799000055],
              [9.238291863000086, 41.24884674700007],
              [9.246918165000068, 41.247748114000046],
              [9.257823113000086, 41.249660549000055],
              [9.268077019000089, 41.23663971600007],
              [9.267425977000073, 41.20197174700007],
              [9.278330925000091, 41.195013739000046],
              [9.274668816000087, 41.19953034100007],
              [9.273610873000052, 41.205145575000074],
              [9.274912957000083, 41.21238841400009],
              [9.278330925000091, 41.22174713700008],
              [9.285329623000052, 41.22174713700008],
              [9.289317254000082, 41.20872630400004],
              [9.288340691000087, 41.20575592700004],
              [9.285329623000052, 41.201239325000074],
              [9.285329623000052, 41.195013739000046],
              [9.299571160000085, 41.196478583000044],
              [9.305430535000085, 41.19794342700004],
              [9.312510613000086, 41.201239325000074],
              [9.316579623000052, 41.196478583000044],
              [9.333018425000091, 41.187567450000074],
              [9.335215691000087, 41.21165599200003],
              [9.352061394000089, 41.20726146000004],
              [9.388194207000083, 41.18073151200008],
              [9.388194207000083, 41.187567450000074],
              [9.396657748000052, 41.18390534100007],
              [9.40406334700009, 41.181708075000074],
              [9.412282748000052, 41.18073151200008],
              [9.422373894000089, 41.18073151200008],
              [9.422373894000089, 41.17450592700004],
              [9.417002800000091, 41.17145416900007],
              [9.414317254000082, 41.16819896000004],
              [9.412119988000086, 41.16453685100004],
              [9.408702019000089, 41.16030508000006],
              [9.420176629000082, 41.15643952000005],
              [9.426605665000068, 41.14923737200007],
              [9.432790561000047, 41.14077383000006],
              [9.442881707000083, 41.13296133000006],
              [9.437022332000083, 41.125433661000045],
              [9.436778191000087, 41.11538320500006],
              [9.442881707000083, 41.09198639500005],
              [9.454112175000091, 41.11196523600006],
              [9.460459832000083, 41.12051015800006],
              [9.47006269600007, 41.12612539300005],
              [9.466807488000086, 41.13068268400008],
              [9.465098504000082, 41.134426174000055],
              [9.462412957000083, 41.137600002000056],
              [9.456553582000083, 41.14036692900004],
              [9.469086134000065, 41.146185614000046],
              [9.481455925000091, 41.14557526200008],
              [9.494395379000082, 41.14232005400004],
              [9.508067254000082, 41.14036692900004],
              [9.513926629000082, 41.14350006700005],
              [9.518402540000068, 41.14866771000004],
              [9.523936394000089, 41.149725653000075],
              [9.532237175000091, 41.14036692900004],
              [9.52475019600007, 41.13296133000006],
              [9.534353061000047, 41.128119208000044],
              [9.54078209700009, 41.12287018400008],
              [9.546153191000087, 41.12091705900008],
              [9.552744988000086, 41.12612539300005],
              [9.559580925000091, 41.12612539300005],
              [9.561208530000044, 41.12181224200003],
              [9.561778191000087, 41.121079820000034],
              [9.562998894000089, 41.12124258000006],
              [9.566416863000086, 41.11933014500005],
              [9.565114780000044, 41.107123114000046],
              [9.56226647200009, 41.09711334800005],
              [9.55640709700009, 41.08783600500004],
              [9.545909050000091, 41.07770416900007],
              [9.543793165000068, 41.08250560100004],
              [9.54078209700009, 41.08734772300005],
              [9.539073113000086, 41.09198639500005],
              [9.52125084700009, 41.031683661000045],
              [9.511892123000052, 41.01626211100006],
              [9.532237175000091, 41.01626211100006],
              [9.52475019600007, 41.030503648000035],
              [9.543142123000052, 41.03693268400008],
              [9.554209832000083, 41.03461334800005],
              [9.557627800000091, 41.025051174000055],
              [9.552744988000086, 41.009466864000046],
              [9.557790561000047, 41.009426174000055],
              [9.558604363000086, 41.011053778000075],
              [9.55827884200005, 41.01361725500004],
              [9.559580925000091, 41.01626211100006],
              [9.565684441000087, 41.010931708000044],
              [9.568614129000082, 41.00950755400004],
              [9.573252800000091, 41.009466864000046],
              [9.588145379000082, 41.020697333000044],
              [9.615733269000089, 41.019598700000074],
              [9.64429772200009, 41.01166413000004],
              [9.662608269000089, 41.00263092700004],
              [9.651215040000068, 40.991115627000056],
              [9.635996941000087, 40.99237702000005],
              [9.619639519000089, 40.99876536700003],
              [9.604258660000085, 41.00263092700004],
              [9.58757571700005, 40.995794989000046],
              [9.582530144000089, 40.97992584800005],
              [9.578868035000085, 40.96198151200008],
              [9.566416863000086, 40.94863515800006],
              [9.571136915000068, 40.934881903000075],
              [9.557465040000068, 40.93121979400007],
              [9.511892123000052, 40.93431224200003],
              [9.511241082000083, 40.929388739000046],
              [9.512543165000068, 40.92796458500004],
              [9.504242384000065, 40.92690664300005],
              [9.511973504000082, 40.91518789300005],
              [9.520030144000089, 40.91502513200004],
              [9.52898196700005, 40.919256903000075],
              [9.539073113000086, 40.92064036700003],
              [9.549327019000089, 40.917222398000035],
              [9.567230665000068, 40.90839264500005],
              [9.573252800000091, 40.90639883000006],
              [9.592784050000091, 40.90989817900004],
              [9.607676629000082, 40.91787344000005],
              [9.622569207000083, 40.92377350500004],
              [9.642100457000083, 40.92064036700003],
              [9.637217644000089, 40.91156647300005],
              [9.631521030000044, 40.90485260600008],
              [9.623871290000068, 40.90070221600007],
              [9.614105665000068, 40.899603583000044],
              [9.614105665000068, 40.89337799700007],
              [9.65007571700005, 40.87946198100008],
              [9.655772332000083, 40.87604401200008],
              [9.657725457000083, 40.86395905200004],
              [9.663259311000047, 40.85822174700007],
              [9.671722852000073, 40.858710028000075],
              [9.683116082000083, 40.86542389500005],
              [9.689789259000065, 40.85586172100005],
              [9.699392123000052, 40.850043036000045],
              [9.710948113000086, 40.846869208000044],
              [9.72396894600007, 40.844916083000044],
              [9.69109134200005, 40.83624909100007],
              [9.68100019600007, 40.829779364000046],
              [9.689789259000065, 40.81704336100006],
              [9.689789259000065, 40.81077708500004],
              [9.674489780000044, 40.81391022300005],
              [9.66179446700005, 40.809027411000045],
              [9.65788821700005, 40.79987213700008],
              [9.668793165000068, 40.790350653000075],
              [9.669769727000073, 40.80145905200004],
              [9.675791863000086, 40.78864166900007],
              [9.703949415000068, 40.759426174000055],
              [9.71029707100007, 40.74559153900009],
              [9.71420332100007, 40.72724030200004],
              [9.744476759000065, 40.68048737200007],
              [9.748301629000082, 40.667222398000035],
              [9.753184441000087, 40.60529205900008],
              [9.756521030000044, 40.59516022300005],
              [9.761566602000073, 40.58734772300005],
              [9.768077019000089, 40.58429596600007],
              [9.781911655000044, 40.58197663000004],
              [9.785817905000044, 40.575873114000046],
              [9.78687584700009, 40.56712474200009],
              [9.792246941000087, 40.55695221600007],
            ],
          ],
          [
            [
              [10.89584394600007, 42.386704820000034],
              [10.913460071000088, 42.37524135100006],
              [10.92730742000009, 42.35330133300005],
              [10.929557895000073, 42.340560131000075],
              [10.939764452000077, 42.33065971000008],
              [10.92333095500004, 42.31872803200008],
              [10.908946160000085, 42.32526276200008],
              [10.87170165100008, 42.35405211200003],
              [10.861827019000089, 42.36627838700008],
              [10.876368251000088, 42.37443936400007],
              [10.875824415000068, 42.386786200000074],
              [10.882985873000052, 42.39215729400007],
              [10.89584394600007, 42.386704820000034],
            ],
          ],
          [
            [
              [10.443369988000086, 42.84544505400004],
              [10.436045769000089, 42.83812083500004],
              [10.431162957000083, 42.82786692900004],
              [10.430674675000091, 42.81614817900004],
              [10.436696811000047, 42.80442942900004],
              [10.430023634000065, 42.78758372600004],
              [10.420258009000065, 42.77643463700008],
              [10.406911655000044, 42.76898834800005],
              [10.388845248000052, 42.76349518400008],
              [10.40796959700009, 42.75726959800005],
              [10.42514082100007, 42.74079010600008],
              [10.430674675000091, 42.72211334800005],
              [10.415537957000083, 42.70888906500005],
              [10.410980665000068, 42.717962958000044],
              [10.403330925000091, 42.71889883000006],
              [10.393239780000044, 42.71820709800005],
              [10.381358269000089, 42.72256094000005],
              [10.377289259000065, 42.72797272300005],
              [10.367198113000086, 42.74599844000005],
              [10.364268425000091, 42.74982330900008],
              [10.35124759200005, 42.75568268400008],
              [10.337901238000086, 42.764837958000044],
              [10.325043165000068, 42.764837958000044],
              [10.313731316000087, 42.74298737200007],
              [10.304535352000073, 42.759751695000034],
              [10.26539147200009, 42.744574286000045],
              [10.245371941000087, 42.75726959800005],
              [10.24000084700009, 42.741888739000046],
              [10.235199415000068, 42.73590729400007],
              [10.229665561000047, 42.73541901200008],
              [10.147227410000085, 42.73729075700004],
              [10.124847852000073, 42.74310944200005],
              [10.10678144600007, 42.75739166900007],
              [10.101410352000073, 42.78400299700007],
              [10.111664259000065, 42.80125560100004],
              [10.132985873000052, 42.81191640800006],
              [10.158213738000086, 42.817287502000056],
              [10.179535352000073, 42.81875234600005],
              [10.189952019000089, 42.81688060100004],
              [10.212168816000087, 42.807847398000035],
              [10.22437584700009, 42.80442942900004],
              [10.242198113000086, 42.803168036000045],
              [10.265879754000082, 42.80442942900004],
              [10.264903191000087, 42.80939362200007],
              [10.264333530000044, 42.81045156500005],
              [10.262705925000091, 42.810248114000046],
              [10.259043816000087, 42.81191640800006],
              [10.272146030000044, 42.81875234600005],
              [10.272146030000044, 42.826239325000074],
              [10.272146030000044, 42.827337958000044],
              [10.289317254000082, 42.82562897300005],
              [10.326833530000044, 42.826239325000074],
              [10.322113477000073, 42.811712958000044],
              [10.332774285000085, 42.805975653000075],
              [10.34734134200005, 42.805853583000044],
              [10.354665561000047, 42.80817291900007],
              [10.358083530000044, 42.81753164300005],
              [10.365977410000085, 42.82294342700004],
              [10.37476647200009, 42.82709381700005],
              [10.381358269000089, 42.83242422100005],
              [10.392100457000083, 42.85797760600008],
              [10.399912957000083, 42.868841864000046],
              [10.412364129000082, 42.87335846600007],
              [10.422048373000052, 42.87083567900004],
              [10.43100019600007, 42.864447333000044],
              [10.438487175000091, 42.855454820000034],
              [10.443369988000086, 42.84544505400004],
            ],
          ],
          [
            [
              [9.840098504000082, 43.06517161700003],
              [9.841807488000086, 43.06342194200005],
              [9.843923373000052, 43.06069570500006],
              [9.847504102000073, 43.058579820000034],
              [9.854810932000078, 43.04427469700005],
              [9.842127292000043, 43.024955918000046],
              [9.822953622000057, 43.00845909000009],
              [9.801498481000067, 43.007805218000044],
              [9.78459484800004, 43.028441834000034],
              [9.806944043000044, 43.06640771800005],
              [9.825776759000064, 43.07462970800009],
              [9.840098504000082, 43.06517161700003],
            ],
          ],
          [
            [
              [12.352061394000089, 45.405462958000044],
              [12.371836785000085, 45.42487213700008],
              [12.389170769000089, 45.43353913000004],
              [12.407481316000087, 45.43065013200004],
              [12.430918816000087, 45.415676174000055],
              [12.418223504000082, 45.420355536000045],
              [12.404795769000089, 45.42226797100005],
              [12.376231316000087, 45.42255280200004],
              [12.321462436000047, 45.34800853100006],
              [12.31999759200005, 45.35415273600006],
              [12.32789147200009, 45.372259833000044],
              [12.352061394000089, 45.405462958000044],
            ],
          ],
          [
            [
              [12.859873894000089, 35.87221914300005],
              [12.867035352000073, 35.872259833000044],
              [12.874034050000091, 35.866441148000035],
              [12.87671959700009, 35.85586172100005],
              [12.872569207000083, 35.85228099200009],
              [12.856944207000083, 35.85228099200009],
              [12.85092207100007, 35.855902411000045],
              [12.845876498000052, 35.86269765800006],
              [12.84701582100007, 35.86831289300005],
              [12.853526238000086, 35.87124258000006],
              [12.859873894000089, 35.87221914300005],
            ],
          ],
          [
            [
              [14.346446160000085, 38.535142320000034],
              [14.342784050000091, 38.54726797100005],
              [14.35718834700009, 38.551214911000045],
              [14.360850457000083, 38.539048570000034],
              [14.346446160000085, 38.535142320000034],
            ],
          ],
          [
            [
              [14.576019727000073, 38.57664622600004],
              [14.579600457000083, 38.56614817900004],
              [14.585215691000087, 38.560980536000045],
              [14.585459832000083, 38.55744049700007],
              [14.57357832100007, 38.55654531500005],
              [14.551605665000068, 38.56159088700008],
              [14.543711785000085, 38.57453034100007],
              [14.542491082000083, 38.58685944200005],
              [14.54623457100007, 38.587958075000074],
              [14.563975457000083, 38.58454010600008],
              [14.576019727000073, 38.57664622600004],
            ],
          ],
          [
            [
              [13.16928144600007, 38.71727122600004],
              [13.185720248000052, 38.71751536700009],
              [13.195974155000044, 38.71149323100008],
              [13.197438998000052, 38.708319403000075],
              [13.176768425000091, 38.693019924000055],
              [13.165212436000047, 38.691066799000055],
              [13.153493686000047, 38.69476959800005],
              [13.153086785000085, 38.70229726800005],
              [13.15788821700005, 38.709865627000056],
              [13.16928144600007, 38.71727122600004],
            ],
          ],
          [
            [
              [15.227793816000087, 38.81028880400004],
              [15.234629754000082, 38.807806708000044],
              [15.239268425000091, 38.804022528000075],
              [15.237478061000047, 38.79596588700008],
              [15.232432488000086, 38.78929271000004],
              [15.229665561000047, 38.78302643400008],
              [15.224619988000086, 38.77680084800005],
              [15.217458530000044, 38.77301666900007],
              [15.206065300000091, 38.77521393400008],
              [15.187022332000083, 38.78900788000004],
              [15.187022332000083, 38.79271067900004],
              [15.194102410000085, 38.798081773000035],
              [15.203623894000089, 38.80158112200007],
              [15.20875084700009, 38.805894273000035],
              [15.212087436000047, 38.81045156500005],
              [15.218597852000073, 38.81195709800005],
              [15.227793816000087, 38.81028880400004],
            ],
          ],
          [
            [
              [13.418955925000091, 40.79559967700004],
              [13.424164259000065, 40.80023834800005],
              [13.431976759000065, 40.80145905200004],
              [13.426931186000047, 40.79083893400008],
              [13.414724155000044, 40.78587474200009],
              [13.418955925000091, 40.79559967700004],
            ],
          ],
          [
            [
              [12.621755405000044, 35.509751695000034],
              [12.621267123000052, 35.508246161000045],
              [12.623871290000068, 35.501613674000055],
              [12.621267123000052, 35.49233633000006],
              [12.61109459700009, 35.48924388200004],
              [12.603037957000083, 35.491400458000044],
              [12.598317905000044, 35.49433014500005],
              [12.593923373000052, 35.49445221600007],
              [12.555674675000091, 35.50804271000004],
              [12.536143425000091, 35.512600002000056],
              [12.526133660000085, 35.51666901200008],
              [12.533864780000044, 35.52163320500006],
              [12.555674675000091, 35.52122630400004],
              [12.566905144000089, 35.51902903900009],
              [12.612803582000083, 35.515326239000046],
              [12.621267123000052, 35.513373114000046],
              [12.623708530000044, 35.51190827000005],
              [12.621755405000044, 35.509751695000034],
            ],
          ],
          [
            [
              [12.072276238000086, 37.96792226800005],
              [12.07789147200009, 37.96010976800005],
              [12.079274936000047, 37.95026276200008],
              [12.064789259000065, 37.950832424000055],
              [12.047618035000085, 37.96076080900008],
              [12.037119988000086, 37.97370026200008],
              [12.030446811000047, 37.984361070000034],
              [12.035980665000068, 37.99103424700007],
              [12.053558790000068, 37.99241771000004],
              [12.064463738000086, 37.98623281500005],
              [12.072276238000086, 37.96792226800005],
            ],
          ],
          [
            [
              [9.474782748000052, 41.23607005400004],
              [9.478363477000073, 41.22846100500004],
              [9.479502800000091, 41.22418854400007],
              [9.479258660000085, 41.21694570500006],
              [9.471039259000065, 41.18960195500006],
              [9.47437584700009, 41.18427155200004],
              [9.474864129000082, 41.17926666900007],
              [9.47038821700005, 41.17210521000004],
              [9.464366082000083, 41.17267487200007],
              [9.45639082100007, 41.18065013200004],
              [9.448741082000083, 41.185532945000034],
              [9.441661004000082, 41.18305084800005],
              [9.437022332000083, 41.18593984600005],
              [9.447764519000089, 41.205064195000034],
              [9.443532748000052, 41.21149323100008],
              [9.446462436000047, 41.220404364000046],
              [9.453868035000085, 41.23395416900007],
              [9.459971550000091, 41.24237702000005],
              [9.468028191000087, 41.241115627000056],
              [9.474782748000052, 41.23607005400004],
            ],
          ],
          [
            [
              [9.430918816000087, 41.22479889500005],
              [9.434255405000044, 41.22060781500005],
              [9.43531334700009, 41.21702708500004],
              [9.395274285000085, 41.210598049000055],
              [9.376963738000086, 41.213324286000045],
              [9.373057488000086, 41.221909898000035],
              [9.373057488000086, 41.22988515800006],
              [9.377614780000044, 41.23383209800005],
              [9.384938998000052, 41.23651764500005],
              [9.391856316000087, 41.24070872600004],
              [9.39625084700009, 41.247748114000046],
              [9.397959832000083, 41.25604889500005],
              [9.402191602000073, 41.257513739000046],
              [9.40796959700009, 41.25812409100007],
              [9.414235873000052, 41.26243724200003],
              [9.421885613000086, 41.26089101800005],
              [9.42741946700005, 41.25409577000005],
              [9.430511915000068, 41.24628327000005],
              [9.430430535000085, 41.23777903900009],
              [9.42904707100007, 41.229396877000056],
              [9.430918816000087, 41.22479889500005],
            ],
          ],
          [
            [
              [10.297048373000052, 42.34487539300005],
              [10.30640709700009, 42.351548570000034],
              [10.315928582000083, 42.34076569200005],
              [10.313243035000085, 42.323919989000046],
              [10.294444207000083, 42.32802969000005],
              [10.297048373000052, 42.34487539300005],
            ],
          ],
          [
            [
              [10.091644727000073, 42.595770575000074],
              [10.096039259000065, 42.590725002000056],
              [10.097911004000082, 42.587958075000074],
              [10.097911004000082, 42.58388906500005],
              [10.09538821700005, 42.57697174700007],
              [10.085785352000073, 42.57245514500005],
              [10.071787957000083, 42.57273997600004],
              [10.058604363000086, 42.57599518400008],
              [10.050303582000083, 42.58193594000005],
              [10.052582227000073, 42.58901601800005],
              [10.062754754000082, 42.59202708500004],
              [10.072601759000065, 42.60040924700007],
              [10.07943769600007, 42.61391836100006],
              [10.084320509000065, 42.61469147300005],
              [10.08765709700009, 42.60398997600004],
              [10.091644727000073, 42.595770575000074],
            ],
          ],
          [
            [
              [12.32984459700009, 45.45880768400008],
              [12.347178582000083, 45.45880768400008],
              [12.363780144000089, 45.449652411000045],
              [12.362071160000085, 45.43813711100006],
              [12.352224155000044, 45.43398672100005],
              [12.33725019600007, 45.427394924000055],
              [12.320648634000065, 45.42983633000006],
              [12.316579623000052, 45.443060614000046],
              [12.32984459700009, 45.45880768400008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Switzerland',
        iso3: 'CHE',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [10.453811076000136, 46.864427389000056],
            [10.4485400800001, 46.83223297100001],
            [10.444922730000116, 46.82324127200006],
            [10.439031616000108, 46.816885071000044],
            [10.417224162000082, 46.79884999700003],
            [10.419084513000087, 46.78396718300009],
            [10.426215861000031, 46.76942026800005],
            [10.42869633, 46.75564849900009],
            [10.41660404400011, 46.74301361100008],
            [10.399654175000109, 46.735546367000055],
            [10.395623413000123, 46.726399639000064],
            [10.396553588000074, 46.71500498400006],
            [10.394383179000073, 46.700819804],
            [10.384771363000084, 46.689011739000094],
            [10.373919312000112, 46.68190623000008],
            [10.36916508000013, 46.67239776600009],
            [10.377536662000097, 46.653277486],
            [10.395623413000123, 46.638808085000065],
            [10.438204793000097, 46.63565582300002],
            [10.459082072000058, 46.62356353800003],
            [10.466626831000013, 46.60428822900009],
            [10.465903361000102, 46.57847585100008],
            [10.457945190000146, 46.55369700100003],
            [10.45183267900012, 46.54670157200006],
            [10.443992554000147, 46.53772898400008],
            [10.425905803000148, 46.535326030000036],
            [10.354282267000087, 46.548322653000085],
            [10.319452351000024, 46.54604888900006],
            [10.306636597000136, 46.547495829000056],
            [10.295371135000096, 46.55108734100013],
            [10.28906660900006, 46.55568654400007],
            [10.283795614000041, 46.56072499600005],
            [10.27594079500011, 46.565530905000045],
            [10.234703003000106, 46.575297750000104],
            [10.230258830000082, 46.58614980100005],
            [10.235736531000072, 46.606691183000024],
            [10.233772827000053, 46.617982484],
            [10.21785648600013, 46.62697418200004],
            [10.192121623000048, 46.6268191540001],
            [10.097450398000092, 46.60803477000009],
            [10.087838582000103, 46.604391582000105],
            [10.083497762000121, 46.59700185100009],
            [10.07119877100007, 46.56439402300005],
            [10.062930542000117, 46.55674591100005],
            [10.041329793000074, 46.54186309800012],
            [10.032751506000125, 46.5329747520001],
            [10.03140791900006, 46.525791728000044],
            [10.031201212000099, 46.50382924500009],
            [10.026860392000117, 46.49318390000009],
            [10.028100627000072, 46.48393381800007],
            [10.03047774300012, 46.47667327900011],
            [10.035335327000041, 46.47106638600009],
            [10.04401696800008, 46.46698394800008],
            [10.026343627000074, 46.44626169900003],
            [10.04205326300007, 46.43272247400007],
            [10.071405477000042, 46.42481598000002],
            [10.11615726700009, 46.41882151400007],
            [10.133417195000078, 46.414015605000074],
            [10.14075524900008, 46.402905172000075],
            [10.133210490000124, 46.38109771700003],
            [10.125975789000051, 46.37437978200002],
            [10.104995158000065, 46.361357321000085],
            [10.097450398000092, 46.351642151000036],
            [10.092386108000113, 46.33810292600005],
            [10.091765991000074, 46.32895619800006],
            [10.095796753000059, 46.320532939000074],
            [10.104891805000136, 46.30937083000005],
            [10.14612959800013, 46.28027699800005],
            [10.15894535300012, 46.262448629000104],
            [10.145819539000058, 46.243328349000095],
            [10.11791426600007, 46.231132711],
            [10.075746297000109, 46.22002227800006],
            [10.04267338000011, 46.220487366],
            [10.041846557000099, 46.24306996700004],
            [10.031717977000142, 46.26007151300006],
            [9.99223718200011, 46.28435943600006],
            [9.977561076000114, 46.298105367000076],
            [9.971049846000057, 46.32001617500005],
            [9.970636434000141, 46.33980824900003],
            [9.96402185100007, 46.35608632500005],
            [9.939010457000052, 46.36745514000005],
            [9.918443237000076, 46.37115000400003],
            [9.899012899000098, 46.37215769500001],
            [9.855397990000142, 46.36696421300009],
            [9.78883874500005, 46.34329640800006],
            [9.768064819000102, 46.3386196900001],
            [9.755249064000026, 46.34053171800012],
            [9.730857788000094, 46.35071197500007],
            [9.72010909000008, 46.35089284300004],
            [9.709257039000136, 46.342392070000116],
            [9.707293335000088, 46.330971579000035],
            [9.708843628000125, 46.31962860100005],
            [9.708430217000114, 46.3117479460001],
            [9.693133992000043, 46.29707183900011],
            [9.674323771000047, 46.291800842000086],
            [9.559705444000087, 46.292731018000026],
            [9.536451050000068, 46.298622132000034],
            [9.51526371300011, 46.308595683000036],
            [9.502551310000058, 46.320739645000046],
            [9.482604207000065, 46.35680979400003],
            [9.47371586100013, 46.36187408500011],
            [9.451598348000118, 46.370374858000034],
            [9.444363648000149, 46.37528411900006],
            [9.442399943000112, 46.38089101200008],
            [9.443846883000106, 46.39613555900003],
            [9.437852417000101, 46.49204701800009],
            [9.434648478000014, 46.498325704000095],
            [9.426793660000072, 46.49711130800007],
            [9.41067061400011, 46.48889475600002],
            [9.403849324000134, 46.4825127160001],
            [9.400335327000107, 46.47540720700006],
            [9.395477742000082, 46.46941274000004],
            [9.384625691000025, 46.466415508000026],
            [9.377080933000087, 46.46868927000004],
            [9.35155277500013, 46.485484111000105],
            [9.350829305000047, 46.49786061600007],
            [9.330985555000069, 46.50150380500004],
            [9.282306355000117, 46.49736969100003],
            [9.263186076000125, 46.485122376],
            [9.245822794000105, 46.46104115800007],
            [9.237967977000068, 46.43654653],
            [9.247579794000103, 46.42303314200002],
            [9.26091231300012, 46.416651103],
            [9.262876017000053, 46.406625875000074],
            [9.260292195000147, 46.394016826000055],
            [9.260395548000076, 46.37972829200005],
            [9.273831420000107, 46.34425242100012],
            [9.275175008000076, 46.331384990000046],
            [9.2689738360001, 46.30937083000005],
            [9.239724975000058, 46.26699615500003],
            [9.224842163000119, 46.231184387],
            [9.215747111000042, 46.22105580700004],
            [9.2041715900001, 46.21356272400003],
            [9.192182658000121, 46.20963531500006],
            [9.181330607000092, 46.204054260000035],
            [9.17574955200007, 46.19413238500003],
            [9.171098673000103, 46.18260854100002],
            [9.16378802500006, 46.172989267],
            [9.163243856000065, 46.172273255],
            [9.090586792000124, 46.138166809000026],
            [9.072086629000097, 46.11889150000009],
            [9.068159220000041, 46.10597239200008],
            [9.07032963100005, 46.08344146700007],
            [9.067125692000076, 46.07114247700012],
            [9.059167521000091, 46.061789043],
            [9.049659057000014, 46.05791331000002],
            [9.027748250000059, 46.05310740200012],
            [9.002116740000105, 46.03930979500008],
            [8.997775919000105, 46.02794097900009],
            [9.015552612000135, 45.99311106400002],
            [8.982686401000109, 45.97197540300009],
            [8.980515991000118, 45.96949493400011],
            [8.979792521000121, 45.966911113],
            [8.980515991000118, 45.96437896800002],
            [8.982686401000109, 45.96184682200003],
            [8.993435099000124, 45.95425038700007],
            [9.001703329000094, 45.93606028300012],
            [9.010798380000068, 45.92665517200005],
            [9.0205135490001, 45.92277944000001],
            [9.042321004000115, 45.91973053000008],
            [9.051726115000065, 45.915544739000055],
            [9.063094930000148, 45.89895660400005],
            [9.05927087400002, 45.881955058000116],
            [9.034362834000149, 45.84810699500012],
            [9.002426798000073, 45.820718486],
            [8.972351115, 45.824645895000046],
            [8.93958825700011, 45.83482615200002],
            [8.900004109000065, 45.82640289300012],
            [8.903724812000064, 45.841802470000104],
            [8.909719279000086, 45.85368805000003],
            [8.9137500410001, 45.86609039300002],
            [8.91209639400003, 45.88340199800011],
            [8.906515340000112, 45.89647613500007],
            [8.89814375800006, 45.90955027300002],
            [8.88078047600004, 45.93109934500008],
            [8.870961954000052, 45.9470673630001],
            [8.86445072400008, 45.95342356400003],
            [8.857732788000078, 45.957092591000034],
            [8.800371948000077, 45.97853831000005],
            [8.785075724000109, 45.98231069000009],
            [8.767919149000079, 45.983085836],
            [8.769572794000112, 45.98577301000002],
            [8.773396850000069, 45.99057891900013],
            [8.790966838000116, 46.01869089800006],
            [8.819595581000101, 46.042927145000064],
            [8.834375041000015, 46.06638824500003],
            [8.8089502360001, 46.08974599300008],
            [8.793860717000115, 46.09341501900006],
            [8.763164917000068, 46.09289825500004],
            [8.747145223000103, 46.094448548000045],
            [8.739497111000048, 46.09806589800003],
            [8.732159057000047, 46.10741933200008],
            [8.728983368000115, 46.108233103000074],
            [8.723890828000094, 46.10953806600004],
            [8.717689656000118, 46.107522685],
            [8.702186727000111, 46.0979625450001],
            [8.695055379000081, 46.09517201800004],
            [8.67748539200008, 46.095792135000025],
            [8.630873250000121, 46.11470570900006],
            [8.611546264000083, 46.119356588000116],
            [8.601831095000136, 46.12281890900006],
            [8.538682495000074, 46.18762115500006],
            [8.510260457000072, 46.207878317000066],
            [8.482665242000053, 46.21754180900008],
            [8.456516968000045, 46.224828187000085],
            [8.43812015800006, 46.23537017800005],
            [8.427164754000074, 46.251441549],
            [8.423237345000103, 46.27583282500005],
            [8.426647990000049, 46.30156768800002],
            [8.442874389000053, 46.3533733120001],
            [8.446285034000084, 46.38218292300003],
            [8.445768270000116, 46.41236195900002],
            [8.441634155000116, 46.43494456000006],
            [8.427888224000071, 46.44869049100002],
            [8.399156128000072, 46.45217865000005],
            [8.385906925000114, 46.45020601800009],
            [8.343448934000037, 46.4438845830001],
            [8.316267130000142, 46.433652649000024],
            [8.294976441000074, 46.41804636600007],
            [8.286604859000079, 46.405359803000024],
            [8.290428914000131, 46.40112233500007],
            [8.297043497000118, 46.39763417600004],
            [8.297456909000033, 46.38750559600008],
            [8.291462443000114, 46.378358866],
            [8.28154056800011, 46.370116475000046],
            [8.270068400000099, 46.3640444950001],
            [8.241749715000111, 46.35412262000001],
            [8.192553752000038, 46.30916412400008],
            [8.171883178000115, 46.299190573],
            [8.128474975000131, 46.292472636000056],
            [8.106874227000048, 46.28554799500007],
            [8.087340535000038, 46.27180206300004],
            [8.07731530700002, 46.26203521800009],
            [8.073077840000082, 46.25361195900008],
            [8.076591837000109, 46.24973622600005],
            [8.099949585000076, 46.23562856100001],
            [8.129508504000114, 46.19604441300005],
            [8.132299032000077, 46.15935414700009],
            [8.110594930000076, 46.12695302300007],
            [8.066876668000077, 46.10059804300003],
            [8.056024617000048, 46.09806589800003],
            [8.035354044000115, 46.09651560500002],
            [8.025328817000087, 46.09114125600006],
            [8.018197469000143, 46.08085764600007],
            [8.016027059000066, 46.06938547800006],
            [8.015923706000137, 46.0581716920001],
            [8.010652710000102, 46.02969797800007],
            [8.008792358000107, 46.027682597000094],
            [7.999077189000076, 46.01279978400008],
            [7.998353719000079, 46.01062937500008],
            [7.985848022000084, 45.99931223600002],
            [7.978716674000026, 45.99517812100008],
            [7.969104858000037, 45.99311106400002],
            [7.898204794000065, 45.98194895400009],
            [7.883781986184766, 45.97386867462201],
            [7.872917431422034, 45.95938260160503],
            [7.870201292731351, 45.94036963077025],
            [7.84962011600004, 45.93971206200011],
            [7.848388712000116, 45.93807566300008],
            [7.845288127000089, 45.92779205300006],
            [7.846114949000111, 45.92257273300005],
            [7.843737833000148, 45.919213766000055],
            [7.831232137000143, 45.914459534000045],
            [7.825444376000092, 45.914666239],
            [7.807564331000037, 45.91849029600006],
            [7.780072469000061, 45.918128561000046],
            [7.732013387000109, 45.93037587500008],
            [7.72219486500012, 45.92960072800007],
            [7.714650105000089, 45.92712026],
            [7.706278523, 45.9257249970001],
            [7.693979533000061, 45.92867055300012],
            [7.692532593000067, 45.931202698],
            [7.673722371000053, 45.9503229780001],
            [7.6587362060001, 45.96003814700005],
            [7.643026571000121, 45.96634267200004],
            [7.541120646000138, 45.98411936500007],
            [7.524377482000091, 45.97807322300004],
            [7.514662312000041, 45.96670440700005],
            [7.503706909000073, 45.95673085500003],
            [7.482726278000058, 45.95487050400003],
            [7.452960652000087, 45.94587880500008],
            [7.393842814000038, 45.915699768000096],
            [7.361803426000108, 45.90784495100006],
            [7.286665893000105, 45.91342600500006],
            [7.273540079000043, 45.91027374300002],
            [7.245428100000083, 45.89812978200011],
            [7.183726440000044, 45.880456442000096],
            [7.153547404000022, 45.87652903300004],
            [7.120887899000138, 45.87611562100004],
            [7.090192097000113, 45.88050811800012],
            [7.066937703000093, 45.89022328800006],
            [7.022082560000115, 45.925259909],
            [7.015157918000114, 45.93332143100007],
            [7.009783569000149, 45.9433983360001],
            [7.002755575000066, 45.96169179300007],
            [6.991283406000122, 45.98246571900002],
            [6.987666056000052, 45.99311106400002],
            [6.982808471000055, 45.99538482700005],
            [6.91511234500004, 46.0486115530001],
            [6.892374715000074, 46.0555878710001],
            [6.884003133000078, 46.05321075500005],
            [6.876871786000066, 46.04809478800006],
            [6.869223673000079, 46.04406402600007],
            [6.859715210000104, 46.04499420200001],
            [6.850930216000108, 46.049645081000065],
            [6.850310099000126, 46.052745667000025],
            [6.852377156000102, 46.05693145800005],
            [6.851963745000091, 46.064682922000074],
            [6.853410685000085, 46.06566477500003],
            [6.853100627000089, 46.07610341400006],
            [6.851343628000109, 46.08602529000005],
            [6.848553100000061, 46.085043437000095],
            [6.853100627000089, 46.090211081000106],
            [6.861162150000098, 46.09703236900005],
            [6.868190144000096, 46.104680482000035],
            [6.869223673000079, 46.1123285930001],
            [6.853927449000111, 46.12261220300009],
            [6.774345743000083, 46.13480784100001],
            [6.765664103000034, 46.151602681000085],
            [6.774862508000126, 46.185864156],
            [6.792225789000071, 46.221675924000024],
            [6.827675822000089, 46.269476624],
            [6.804938192000094, 46.296606751000084],
            [6.769488159000076, 46.322677511000066],
            [6.750367879000095, 46.345518494000075],
            [6.755742228000145, 46.3570681770001],
            [6.782097209000113, 46.37846222000012],
            [6.789228556000126, 46.39520538300006],
            [6.78810673300012, 46.40500797800006],
            [6.787058146000049, 46.41417063500002],
            [6.77771555400011, 46.424106493000025],
            [6.762666870000118, 46.429260152000026],
            [6.613683716000139, 46.45589935400007],
            [6.547021118000117, 46.45737213200006],
            [6.482942342000115, 46.448587138000065],
            [6.397676229000069, 46.40817616800008],
            [6.365223430000128, 46.40244008400005],
            [6.332357218000112, 46.40138071700004],
            [6.301558065000052, 46.39448191400008],
            [6.269105265000121, 46.37502573700009],
            [6.240579874000076, 46.348954977000105],
            [6.219495890000132, 46.32911122700001],
            [6.214121541000083, 46.315468649000096],
            [6.21825565600011, 46.305495097000104],
            [6.227454060000099, 46.28849355100009],
            [6.227970825000057, 46.284462789000074],
            [6.237582642000064, 46.26792633100008],
            [6.241820109000116, 46.26368886400003],
            [6.252258748000145, 46.2599164840001],
            [6.269001912000078, 46.26523915600005],
            [6.276029907000094, 46.263120423],
            [6.281197550000115, 46.24007273400012],
            [6.255359335000094, 46.22110748400006],
            [6.191383911000088, 46.19170359400009],
            [6.140327596000134, 46.15020741800002],
            [6.107874796000118, 46.13863189700005],
            [6.073871704000084, 46.14917389000003],
            [6.028293090000091, 46.147933655000074],
            [5.982921183000144, 46.14044057200006],
            [5.958839966000113, 46.13046702100003],
            [5.972172485000044, 46.15217112200004],
            [5.979820597000128, 46.162248027000075],
            [5.982921183000144, 46.17082631400011],
            [5.965247843000071, 46.18622589100009],
            [5.954809204000128, 46.19992014600011],
            [5.958529907000127, 46.21196075400009],
            [5.982921183000144, 46.2227094520001],
            [6.042865844000062, 46.24306996700004],
            [6.044519491000102, 46.243431702000024],
            [6.04617313600005, 46.243535055000066],
            [6.048033488000044, 46.243431702000024],
            [6.055888305000082, 46.24167470400006],
            [6.061882772000104, 46.24115793900002],
            [6.067670532000079, 46.241623027000045],
            [6.089684692000077, 46.24637725900003],
            [6.094025513000133, 46.25304351800004],
            [6.093095337000108, 46.26229360000006],
            [6.093612101000133, 46.273093974000076],
            [6.100743448000088, 46.30141265900009],
            [6.104050740000076, 46.3092158000001],
            [6.118607037000089, 46.331771085000085],
            [6.136400187000078, 46.35934194000002],
            [6.135056600000098, 46.37040069600003],
            [6.12286096200009, 46.385541891000045],
            [6.108184855000104, 46.39649729400013],
            [6.059019361000082, 46.417383211000086],
            [6.054234660000134, 46.41941579200004],
            [6.065706827000071, 46.427012228000095],
            [6.06756717900015, 46.43360097300011],
            [6.065500122000088, 46.44037058600004],
            [6.065500122000088, 46.44799285900011],
            [6.064776652000091, 46.45106760700004],
            [6.062399536000072, 46.45520172200007],
            [6.060229126000081, 46.459904277000064],
            [6.060229126000081, 46.46502024400003],
            [6.064156535000052, 46.471118063000105],
            [6.075525349000117, 46.479592998],
            [6.110355265000095, 46.52083079],
            [6.145701945000098, 46.551629944000084],
            [6.12151737500011, 46.570285137000056],
            [6.118416789000065, 46.58346262600013],
            [6.131852661000039, 46.595606588000024],
            [6.266314738000062, 46.680355937000044],
            [6.337938273000105, 46.707408550000096],
            [6.347860148000109, 46.71317047200007],
            [6.374215128000088, 46.733608501000035],
            [6.407391398000101, 46.745700786],
            [6.417933390000144, 46.75110097300008],
            [6.429198853000116, 46.76081614200011],
            [6.433022908000055, 46.76911021000005],
            [6.432609497000044, 46.785982565000054],
            [6.425168090000113, 46.791615296000074],
            [6.419897095000096, 46.79652455700001],
            [6.417106568000122, 46.80215728800003],
            [6.418553507000127, 46.80701487200007],
            [6.434263143000095, 46.8395451870001],
            [6.441187785000068, 46.848149313000036],
            [6.443117662000049, 46.851455121000086],
            [6.4467688390001, 46.85770945300003],
            [6.44842248600014, 46.871558737],
            [6.445218546000063, 46.88261749300001],
            [6.431886027000132, 46.90003245100003],
            [6.427751913000122, 46.909075827],
            [6.442634725000062, 46.94416412400004],
            [6.491107218000138, 46.96338775700006],
            [6.598697550000082, 46.98653879800004],
            [6.665411824000103, 47.02129119900009],
            [6.688252807000111, 47.043847961000026],
            [6.676263875000132, 47.06239980100004],
            [6.689699747000105, 47.07829030400008],
            [6.699104858000055, 47.084620667000095],
            [6.724219604000069, 47.090770162000055],
            [6.727940307000097, 47.09712636300007],
            [6.731661011000085, 47.09888336300007],
            [6.746027059000113, 47.10394765300005],
            [6.744786824000073, 47.12105255100009],
            [6.774759155000112, 47.12818389900012],
            [6.838076256000079, 47.168131597000055],
            [6.840284871000108, 47.16952504500007],
            [6.859301798000075, 47.19091908800006],
            [6.88834395300006, 47.21130544100002],
            [6.956246785000104, 47.245231018000126],
            [6.952216024000023, 47.27003570500007],
            [6.958623901000067, 47.290551250000036],
            [6.97743412300008, 47.30372873900002],
            [6.986529174000054, 47.304503887000024],
            [6.991903524000094, 47.30595082700002],
            [7.00647627800015, 47.31936086000006],
            [7.016914917000094, 47.32352081300009],
            [7.027146850000094, 47.32543284100002],
            [7.036551961000043, 47.329515279000034],
            [7.044303426000056, 47.34049652100002],
            [7.033864787000113, 47.35065094000008],
            [7.018878621000056, 47.359901021000084],
            [7.003995809000088, 47.36814341300003],
            [6.985598999000104, 47.36212310800009],
            [6.866639852000077, 47.35416493700002],
            [6.871600789000126, 47.36695485500009],
            [6.884003133000078, 47.38258697600004],
            [6.898782593000107, 47.39571279000002],
            [6.924517456000103, 47.4059964],
            [6.926067749000111, 47.42485829700003],
            [6.952319376000048, 47.4288373830001],
            [6.968545777000145, 47.43519358300004],
            [6.983428589000113, 47.443797709000066],
            [6.990973348000068, 47.45222096800008],
            [6.986115763000043, 47.4641323850001],
            [6.975780477000114, 47.477955831000074],
            [6.973300008000137, 47.48909210300009],
            [6.991903524000094, 47.492941997000045],
            [7.000791870000114, 47.49767039000001],
            [7.009783569000149, 47.499246522000035],
            [7.018878621000056, 47.49767039000001],
            [7.027973674000094, 47.492941997000045],
            [7.053915242000073, 47.49038401300005],
            [7.10373132300009, 47.49627512600004],
            [7.127295776000096, 47.492941997000045],
            [7.140318237000116, 47.48785186800005],
            [7.142169389000088, 47.48765096800004],
            [7.15365075700015, 47.486404928000056],
            [7.180832560000056, 47.48826528000005],
            [7.1626424560001, 47.459894918000046],
            [7.168326863000061, 47.44356516500001],
            [7.190030965000034, 47.434728496000034],
            [7.219383179000118, 47.4284756470001],
            [7.223517293000043, 47.42622772300011],
            [7.226307820000102, 47.42263621100004],
            [7.230338583000105, 47.419018861000055],
            [7.2380900470001, 47.41679677300006],
            [7.244807984000118, 47.417726949],
            [7.282635132000109, 47.42888905900013],
            [7.309093465000103, 47.43266143800007],
            [7.336930048000085, 47.43185368000009],
            [7.37854659000007, 47.43064605800002],
            [7.388218887000107, 47.433288860000104],
            [7.406348511000118, 47.43824249300006],
            [7.420563120000111, 47.4508570280001],
            [7.426088908000082, 47.45576080300005],
            [7.429292847000056, 47.46511423800008],
            [7.427639200000101, 47.4707469690001],
            [7.422781616000094, 47.47542368600007],
            [7.419474325000095, 47.47785247800003],
            [7.414410034000099, 47.48402781200009],
            [7.414306681000085, 47.49017730700008],
            [7.425985555000068, 47.49250274700002],
            [7.44148848500015, 47.48883372000002],
            [7.445995797000137, 47.4868841290001],
            [7.454510946000113, 47.48320098900008],
            [7.467430053000101, 47.481909078000044],
            [7.482726278000058, 47.49126251200006],
            [7.484483276000049, 47.492941997000045],
            [7.485826864000103, 47.4957842000001],
            [7.485930217000146, 47.49839386000012],
            [7.485776134000076, 47.498767511000025],
            [7.484896688000049, 47.5009001670001],
            [7.477765340000104, 47.50769561800006],
            [7.475594930000028, 47.51172637900005],
            [7.476938517000093, 47.5148786430001],
            [7.482726278000058, 47.51699737600008],
            [7.493061564000072, 47.51549875900007],
            [7.501123087000082, 47.517307434000045],
            [7.505463908000138, 47.52301768100001],
            [7.505153850000056, 47.53301707000013],
            [7.501743205000139, 47.5329653940001],
            [7.485103394000106, 47.54159535700005],
            [7.482726278000058, 47.54226715100005],
            [7.520866596000104, 47.56341604800009],
            [7.52634118600011, 47.56645172100009],
            [7.550319051000116, 47.57549509700006],
            [7.585482836000097, 47.584479135],
            [7.586028488000125, 47.584618544000065],
            [7.637032104000099, 47.59497711200005],
            [7.65966638200004, 47.596579082000076],
            [7.646540568000091, 47.57154185000009],
            [7.635895223000091, 47.56459137000009],
            [7.612337281000094, 47.564731041000115],
            [7.609746948000094, 47.56474639900004],
            [7.64690103500007, 47.55144523600005],
            [7.661423380000116, 47.546246236000016],
            [7.683437540000114, 47.54425669400008],
            [7.727320447000125, 47.55042262400006],
            [7.766739949000055, 47.555961406000065],
            [7.78555017100004, 47.56319610600012],
            [7.801466512000076, 47.57608937600013],
            [7.819656616000117, 47.595338847000065],
            [7.83371260600012, 47.59048126300003],
            [7.898204794000065, 47.58784576400002],
            [7.904302613000112, 47.58355662100006],
            [7.907506551000097, 47.57417734800002],
            [7.909470256000105, 47.56479807600006],
            [7.91215743000015, 47.5605606080001],
            [8.042278686000088, 47.5605606080001],
            [8.08723718200011, 47.56738189700006],
            [8.09695235100014, 47.571851909000074],
            [8.10139652500007, 47.576192729000056],
            [8.105427286000065, 47.581257019000034],
            [8.113902221000075, 47.58784576400002],
            [8.122067098000088, 47.59213490800009],
            [8.14377119900007, 47.60006724100005],
            [8.162064656000041, 47.60376210500006],
            [8.168885946000103, 47.60864552800008],
            [8.173846883000067, 47.613528951],
            [8.17901452600006, 47.6158027150001],
            [8.232964721000116, 47.62195221000009],
            [8.251051473000132, 47.62200388600009],
            [8.276993042000072, 47.61662953700004],
            [8.288568562000108, 47.6158027150001],
            [8.293942912000091, 47.611461894000044],
            [8.299317260000038, 47.60182423900001],
            [8.306345255000053, 47.592186585],
            [8.316163777000014, 47.58784576400002],
            [8.354094279000037, 47.58102447500006],
            [8.41806970200011, 47.58076609400008],
            [8.421100326000044, 47.5811118700001],
            [8.448868856000075, 47.58428009100005],
            [8.450109090000097, 47.589034323000035],
            [8.46178796400008, 47.606139221],
            [8.492380411000084, 47.61983347600001],
            [8.522352742000038, 47.62190053400006],
            [8.53775231900002, 47.6121336880001],
            [8.54963789900006, 47.59859446200004],
            [8.551719149000036, 47.59686332900007],
            [8.560696655000072, 47.58939605700003],
            [8.574132527000103, 47.59244496700008],
            [8.576305366000042, 47.59502305800005],
            [8.580643758000093, 47.60017059400006],
            [8.581780639000101, 47.607663677000104],
            [8.581263875000047, 47.61476918600003],
            [8.582504110000087, 47.621590475000076],
            [8.582090698000087, 47.62502695700003],
            [8.579713583000114, 47.62892852900008],
            [8.578059936000074, 47.6334760540001],
            [8.580333699000107, 47.63900543200002],
            [8.583951050000081, 47.6411241660001],
            [8.589222046000117, 47.642467754000066],
            [8.593562866000099, 47.64257110600009],
            [8.594493042000039, 47.640969137000056],
            [8.595113159000107, 47.634819641],
            [8.601624390000069, 47.63259755500009],
            [8.607308797000115, 47.65629119900002],
            [8.598213745000066, 47.65688547800006],
            [8.593588683000092, 47.65816856000002],
            [8.582194051000101, 47.66132965100009],
            [8.568241414000113, 47.66293162100003],
            [8.519665568000107, 47.657350566],
            [8.504679402000136, 47.65226043700004],
            [8.490830119000066, 47.64556833900009],
            [8.476050659000066, 47.6404006960001],
            [8.458273966000121, 47.639883932000046],
            [8.43760339400012, 47.647842102000126],
            [8.411971883000149, 47.661045430000016],
            [8.40701094500011, 47.66156219500006],
            [8.39130131000013, 47.6654637650001],
            [8.397709188000078, 47.67628997900006],
            [8.395228719000102, 47.68481659000007],
            [8.39099125100006, 47.69212880500005],
            [8.392128133000142, 47.69951853500005],
            [8.401946655000131, 47.70708913200012],
            [8.427268107000117, 47.716468404000054],
            [8.437913452000089, 47.7231863410001],
            [8.445458211000044, 47.74318512000012],
            [8.450109090000097, 47.75047149700002],
            [8.463648315000086, 47.76390737000007],
            [8.471503133000112, 47.76705963200003],
            [8.482665242000053, 47.766852926000055],
            [8.536512085000084, 47.774087626000025],
            [8.55160160300008, 47.77925527000012],
            [8.542299846000077, 47.7950165810001],
            [8.558216187000085, 47.801166077000076],
            [8.58312422700007, 47.80023590100002],
            [8.601624390000069, 47.79460317000009],
            [8.603174682000088, 47.787316793000016],
            [8.604104858000142, 47.77439768500001],
            [8.607618856000101, 47.762253723000114],
            [8.61743737800009, 47.757318624000064],
            [8.629839721000053, 47.76279632600004],
            [8.635007365000149, 47.78460378000007],
            [8.644102417000113, 47.791011658000016],
            [8.657021525000118, 47.78811777800003],
            [8.66663334200004, 47.77827341700005],
            [8.674488159000077, 47.7666978970001],
            [8.681929565000104, 47.75873972600006],
            [8.692264852000108, 47.75716359500002],
            [8.703323608000119, 47.75871388700004],
            [8.71314213000008, 47.757421977],
            [8.719756714000084, 47.747319234000045],
            [8.71706954000004, 47.74354685500002],
            [8.70373702000012, 47.73003346800006],
            [8.700429728000131, 47.72349639900007],
            [8.70466719500007, 47.715331523000046],
            [8.712625366000054, 47.70869110100004],
            [8.715105835000116, 47.70106882700007],
            [8.71706954000004, 47.6945575970001],
            [8.769882853000098, 47.69507436100007],
            [8.761717977000075, 47.701249695000044],
            [8.77070967600011, 47.72086090100005],
            [8.797581420000114, 47.72003407900003],
            [8.830240926000101, 47.70719248500005],
            [8.856079142000112, 47.69068186400007],
            [8.837682333000117, 47.68778798500007],
            [8.837785685000142, 47.68083750400008],
            [8.851935119000075, 47.67128172300009],
            [8.8526684980001, 47.670786438000064],
            [8.881710652000095, 47.65613617000007],
            [8.906205281000041, 47.651795349000096],
            [8.945376017000086, 47.65430165600007],
            [8.981756225000055, 47.6621564740001],
            [8.997672566000091, 47.67383534800008],
            [9.016586141000118, 47.67889963900005],
            [9.12810388100013, 47.67042470400007],
            [9.183397664000069, 47.67042470400007],
            [9.196936890000131, 47.65613617000007],
            [9.234350627000083, 47.65616200800007],
            [9.273211304000142, 47.65009002700005],
            [9.547481674000068, 47.53454710200005],
            [9.553058591000081, 47.51689133800009],
            [9.554951212000105, 47.510899557000116],
            [9.584510132000048, 47.480720521000094],
            [9.621717163000142, 47.46919667600007],
            [9.650345907000116, 47.452091777000035],
            [9.649519084000104, 47.409717103000034],
            [9.639803914000055, 47.39452423100009],
            [9.601046590000124, 47.36127044700005],
            [9.59639571100007, 47.35230458600002],
            [9.591228068000078, 47.334682923000045],
            [9.587404012000121, 47.32780995700007],
            [9.553297567000072, 47.299853008000056],
            [9.52115482500011, 47.2628010050001],
            [9.504618368000138, 47.24373240200002],
            [9.487358439000047, 47.21001352900005],
            [9.484981323000085, 47.176346334000115],
            [9.492629435000083, 47.15980987600001],
            [9.503481486000112, 47.14539215100011],
            [9.511853068000107, 47.12937245700006],
            [9.512369832000047, 47.10803009100006],
            [9.50286136800014, 47.09469757200013],
            [9.487565145000104, 47.083948874],
            [9.475886271000121, 47.0732260140001],
            [9.477023153000118, 47.06389841700006],
            [9.499554077000141, 47.05935089100002],
            [9.560635620000141, 47.05240041200004],
            [9.581202840000032, 47.05687042300006],
            [9.599909709000116, 47.05348561600003],
            [9.65230961100005, 47.057929790000046],
            [9.669052775000097, 47.056198629000065],
            [9.857981812000048, 47.01547760000001],
            [9.856328165000093, 47.0040829470001],
            [9.860565633000135, 47.00160247800004],
            [9.866766805000026, 47.00193837500002],
            [9.870590861000068, 46.99883779000008],
            [9.870590861000068, 46.992946676000074],
            [9.86645674600004, 46.98338653600008],
            [9.86397627800008, 46.959925436],
            [9.860772339000107, 46.94915089900009],
            [9.86242598400014, 46.93977162700013],
            [9.875138387000106, 46.92742096000008],
            [9.899943075000039, 46.91439849900003],
            [10.006913289000096, 46.89075653100012],
            [10.045567260000098, 46.86556427100008],
            [10.068098185000025, 46.856624248000045],
            [10.111299683000084, 46.84711578400005],
            [10.125187508000124, 46.846751229000105],
            [10.131970255000084, 46.84657318200003],
            [10.157808471000095, 46.851611634000065],
            [10.201423381000069, 46.86683034300002],
            [10.21165531400004, 46.877036438000076],
            [10.214342488000057, 46.884684550000074],
            [10.215169311000096, 46.89310780900006],
            [10.219923543000078, 46.90576853500009],
            [10.235116415000107, 46.92331268400007],
            [10.251342814000111, 46.925379740000025],
            [10.27077315200009, 46.92189158100008],
            [10.295681193000064, 46.922692566000094],
            [10.296197957000118, 46.941373597000066],
            [10.313664592000066, 46.96431793300009],
            [10.338882691000094, 46.98411000600008],
            [10.367924846000108, 46.995504659000076],
            [10.373402547000097, 46.99625396700007],
            [10.37898360200009, 46.995504659000076],
            [10.384254598000041, 46.993153382000045],
            [10.384357950000066, 46.993153382000045],
            [10.384357950000066, 46.9929983520001],
            [10.39469323700007, 46.98540191600004],
            [10.41557051600006, 46.96240590500007],
            [10.449573608000094, 46.94390574200007],
            [10.458461955000104, 46.936619365000084],
            [10.46383630300005, 46.91974700900009],
            [10.451433960000088, 46.88576975600007],
            [10.453811076000136, 46.864427389000056],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Netherlands',
        iso3: 'NLD',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [7.194590691000087, 53.245021877000056],
              [7.19747237100006, 53.2166236370001],
              [7.198505900000043, 53.20057810500005],
              [7.195405314000112, 53.18499766100011],
              [7.18858402500004, 53.16778940800002],
              [7.174424682000108, 53.14577524900004],
              [7.171944214000121, 53.13771372500007],
              [7.172667684000118, 53.12575063100009],
              [7.176491740000074, 53.11939443000007],
              [7.181349324000081, 53.11417511100005],
              [7.18507002700008, 53.10544179300008],
              [7.194371786000119, 53.03384409600004],
              [7.19282149300011, 52.998006490000094],
              [7.183623088000104, 52.966122131000034],
              [7.161918986000103, 52.93263580400013],
              [7.079856812000116, 52.854423523],
              [7.072150759000124, 52.841316552000066],
              [7.061976766000043, 52.824011942000126],
              [7.053295125000091, 52.79057729100005],
              [7.04399336700007, 52.682625224],
              [7.036655314000058, 52.647381897000045],
              [7.018465210000045, 52.625987854000115],
              [6.982808471000055, 52.632783305000075],
              [6.967718953000144, 52.63665903800002],
              [6.918419637000056, 52.632189026],
              [6.865399617000037, 52.641955872000054],
              [6.77052168700007, 52.641025696],
              [6.73703536000005, 52.63469533300007],
              [6.719083149000085, 52.626758982000055],
              [6.701792032000071, 52.619114889000045],
              [6.710163615000056, 52.60865041200002],
              [6.708199911000122, 52.59968455000008],
              [6.703652384000094, 52.59139048300001],
              [6.70396244300008, 52.58307057700004],
              [6.710990438000096, 52.576636862],
              [6.743753296000079, 52.559712830000095],
              [6.688252807000111, 52.542582093000064],
              [6.671716349000121, 52.541677755000094],
              [6.684015340000144, 52.52599395800006],
              [6.687529337000115, 52.508139751],
              [6.688976278000098, 52.49051808700001],
              [6.695074097000145, 52.475609437000045],
              [6.714814494000109, 52.46155344700004],
              [6.741169474000088, 52.4536727910001],
              [6.820337769000105, 52.44682566300004],
              [6.872014200000137, 52.43473337800005],
              [6.9002295330001, 52.43191701299999],
              [6.92648116100014, 52.432976380000085],
              [6.951492553000037, 52.437472229],
              [6.960794311000143, 52.442846578000044],
              [6.966995483000034, 52.44956451500009],
              [6.973300008000137, 52.45137319000007],
              [7.034174845000081, 52.390782573000095],
              [7.048230835000112, 52.36507354700002],
              [7.039755900000102, 52.32861582500003],
              [7.019705444000067, 52.30003875800004],
              [7.012470744000098, 52.284949239000056],
              [7.011850626000125, 52.26662994400009],
              [7.02073897300005, 52.24526173900007],
              [7.026600152000071, 52.23862268699999],
              [7.029110555000017, 52.235779114000096],
              [7.026320027000054, 52.2306373090001],
              [6.981878296000076, 52.21399749800007],
              [6.971129598000061, 52.206271871000084],
              [6.94766849700008, 52.182810771],
              [6.927721395000077, 52.17190704400004],
              [6.884829956000118, 52.160331523000096],
              [6.865399617000037, 52.147799988000074],
              [6.843282105000128, 52.119998067000026],
              [6.830673055000091, 52.11289255800001],
              [6.77157568400014, 52.10879250200004],
              [6.765870808000102, 52.108396709],
              [6.749851115000126, 52.10286733000008],
              [6.73290124500005, 52.091989441000024],
              [6.7276302490001, 52.08630503300007],
              [6.719465373000077, 52.07356679300001],
              [6.711403849000106, 52.067288107000095],
              [6.699414917000126, 52.063567404000096],
              [6.688872925000084, 52.06310231600007],
              [6.679881225000116, 52.06046681800005],
              [6.672956583000143, 52.05005401600003],
              [6.675023641000109, 52.034809469],
              [6.690939982000117, 52.027858988],
              [6.7128507890001, 52.023854065000094],
              [6.778169800000029, 52.00127146500007],
              [6.804008016000068, 51.984373271],
              [6.809175659000061, 51.97954152500007],
              [6.811656127000049, 51.972797751000044],
              [6.81072595200007, 51.96057627400002],
              [6.805661661000102, 51.957527365],
              [6.798013550000121, 51.956700542000064],
              [6.789848673000108, 51.95114532500007],
              [6.767007690000099, 51.925513815],
              [6.743753296000079, 51.90833140100004],
              [6.716674846000046, 51.89926218700005],
              [6.628153117000068, 51.897505189000086],
              [6.528624308000133, 51.87642120400007],
              [6.47942834400007, 51.8530117800001],
              [6.462891887000069, 51.84836090100002],
              [6.442531372000133, 51.84836090100002],
              [6.378452596000045, 51.86011728900003],
              [6.38661747200004, 51.83756052700009],
              [6.382483358000115, 51.827586975000074],
              [6.344966268000121, 51.82110158300013],
              [6.341969034000016, 51.836682028000055],
              [6.325742635000097, 51.842547303000046],
              [6.287398722000091, 51.84616465300003],
              [6.282851196000138, 51.84960113500007],
              [6.271792439000137, 51.86190012700011],
              [6.264661092000011, 51.86618927100007],
              [6.256392862000069, 51.86680938700003],
              [6.225180298000083, 51.862546082000094],
              [6.191383911000088, 51.87115020800012],
              [6.159241170000058, 51.887299093000095],
              [6.1269950760001, 51.89673004100008],
              [6.09299198400015, 51.88530955000006],
              [6.105394327000056, 51.87947011300007],
              [6.142704712000068, 51.85518219000009],
              [6.156140584000127, 51.842056376000116],
              [6.140017537000062, 51.84453684500009],
              [6.116453084000057, 51.84828338700002],
              [6.084000284000126, 51.853657735000056],
              [6.043279256000062, 51.84686228500003],
              [6.028913208000063, 51.84210805300005],
              [6.008242635000045, 51.832573751000055],
              [5.988915650000081, 51.82745778400006],
              [5.948091268000098, 51.82296193500012],
              [5.931451457000065, 51.81564972000005],
              [5.928040812000063, 51.8067355350001],
              [5.950778442000114, 51.79590932200007],
              [5.964110962000063, 51.77655649900002],
              [5.962353963000083, 51.75635101300013],
              [5.946056400000117, 51.746288216000025],
              [5.940133097000029, 51.7426309210001],
              [5.939306274000103, 51.731882223000085],
              [5.949228150000096, 51.729375916],
              [5.978270304000091, 51.729789327],
              [5.989742472000103, 51.72637868200009],
              [6.012066691000086, 51.715862528000045],
              [6.02198856600009, 51.70950632800002],
              [6.008552694000116, 51.681187643],
              [6.031497030000054, 51.662997539000074],
              [6.099193156000069, 51.64447153800005],
              [6.087514282000086, 51.62209564200005],
              [6.082139933000121, 51.60780710900006],
              [6.086480754000092, 51.59553395600004],
              [6.153039998000082, 51.538431499000026],
              [6.19334761500005, 51.50933766700011],
              [6.20047896300008, 51.47657480900001],
              [6.205336548000105, 51.45843638200007],
              [6.201719197000102, 51.438644308],
              [6.194071086000122, 51.417379456000035],
              [6.192727499000057, 51.39895680800002],
              [6.207817016000149, 51.38766550800007],
              [6.202029256000088, 51.378880513000055],
              [6.198928670000043, 51.3569697060001],
              [6.193554321000079, 51.34451568600004],
              [6.183632446000104, 51.33570485400004],
              [6.158207641000075, 51.32459442200012],
              [6.147769002000047, 51.31816070600006],
              [6.096505981000121, 51.25881032400004],
              [6.075421997000092, 51.24266143900006],
              [6.065190063000102, 51.23162852000006],
              [6.056611776000096, 51.211707255000036],
              [6.053717895000091, 51.18938303700007],
              [6.060849243000121, 51.17090871200007],
              [6.084310344000102, 51.16269215900003],
              [6.134126424000044, 51.18421539400008],
              [6.157070760000067, 51.17925445600012],
              [6.149112589000111, 51.17633473700003],
              [6.12627160700012, 51.16457834900005],
              [6.147252238000107, 51.15225352],
              [6.132369426000082, 51.13982533800002],
              [6.075421997000092, 51.12036916100003],
              [5.982921183000144, 51.07468719500012],
              [5.969485311000113, 51.064920350000065],
              [5.950261678000089, 51.03946970700004],
              [5.937962687000038, 51.03094309500004],
              [5.919565877000139, 51.02970286],
              [5.906233358000122, 51.03740264900007],
              [5.894347778000082, 51.047143657000035],
              [5.88049849500004, 51.05205291800006],
              [5.852489868000106, 51.04275116000004],
              [5.858174275000067, 51.01934173600007],
              [5.87357385200005, 50.99058380100006],
              [5.874607381000118, 50.96536570300002],
              [5.888249959000035, 50.96712270100009],
              [5.914191529000078, 50.97523590100009],
              [5.927730754000066, 50.97766469400007],
              [5.941580037000023, 50.97647613500003],
              [5.967831665000062, 50.97099843400004],
              [6.003695109000091, 50.973737284],
              [6.005762167000057, 50.96851796500006],
              [5.999664348000096, 50.96009470600008],
              [5.995840291000064, 50.95177480100001],
              [5.997287232000076, 50.93735707600011],
              [5.999871053000078, 50.92939890600003],
              [6.007519165000133, 50.92407623300009],
              [6.031083618000139, 50.914722799000046],
              [6.063743124000041, 50.90753977500002],
              [6.061779419000089, 50.90350901300009],
              [6.056508423000139, 50.89808298800004],
              [6.054648071000145, 50.89146840400004],
              [6.063123006000069, 50.87090118400006],
              [6.062812948000072, 50.862943014000095],
              [6.056715129000111, 50.85265940400008],
              [6.045553019000067, 50.8441844690001],
              [6.023022095000073, 50.845424704000024],
              [6.009276164000113, 50.84046376500008],
              [6.000491170000117, 50.83043853800005],
              [6.001421346000086, 50.821808574],
              [6.003591756000077, 50.812610169000024],
              [5.998320760000041, 50.80072458900007],
              [5.983954712000127, 50.79219797800006],
              [5.968761841000116, 50.79462677000002],
              [5.972999308000055, 50.78181101500003],
              [5.980647420000139, 50.773439433000064],
              [5.990569295000057, 50.769046936000066],
              [5.997080525000115, 50.76294911700002],
              [5.994910116000113, 50.749926656000085],
              [5.974756307000035, 50.74754954000004],
              [5.902202596000024, 50.74904815700005],
              [5.891287548000093, 50.75124632700005],
              [5.879878377000068, 50.75354400600007],
              [5.793165324000114, 50.75214874300009],
              [5.782933390000039, 50.75669627000012],
              [5.762469523000078, 50.77101064100002],
              [5.752444296000135, 50.773439433000064],
              [5.74355594900004, 50.769098613],
              [5.732776968000053, 50.75885148900005],
              [5.727846313000072, 50.75416412400004],
              [5.717407674000128, 50.75282053700006],
              [5.706555623000071, 50.75421580000004],
              [5.688365519000115, 50.760830384000045],
              [5.698700806000119, 50.78377472000007],
              [5.700457804000109, 50.795556946000076],
              [5.68485152100007, 50.79850250300008],
              [5.663250773000101, 50.80506541000007],
              [5.657432381000092, 50.80764098200008],
              [5.640719849000078, 50.81503896100007],
              [5.624493448000067, 50.8302835090001],
              [5.622323039000094, 50.85265940400008],
              [5.694463338000077, 50.903664042000045],
              [5.706038859000046, 50.90660959900005],
              [5.717614380000072, 50.90924509700007],
              [5.722368612000082, 50.91167389000013],
              [5.73528771900007, 50.92397288100007],
              [5.752547648000075, 50.94722727500009],
              [5.764019816000086, 50.9594229130001],
              [5.75430464700014, 50.9630919400001],
              [5.744692830000133, 50.96324696900005],
              [5.722368612000082, 50.9594229130001],
              [5.761746053000081, 50.9991620900001],
              [5.777559041000075, 51.02355336600003],
              [5.764019816000086, 51.03518056300008],
              [5.766396932000134, 51.04843556800007],
              [5.771461222000113, 51.05812489900002],
              [5.779626098000023, 51.06130299900009],
              [5.791304972000091, 51.05499847500006],
              [5.798849731000132, 51.061483866000046],
              [5.804327434000129, 51.06858937600005],
              [5.81176884000007, 51.082309469000094],
              [5.808978312000107, 51.08634023000009],
              [5.807428019000071, 51.08938914000002],
              [5.804947550000094, 51.09662384000008],
              [5.81590295400008, 51.09587453200008],
              [5.826651652000095, 51.096908061000065],
              [5.836780232000137, 51.099491883000056],
              [5.845978638000048, 51.10339345400011],
              [5.823241007000064, 51.11874135400008],
              [5.826444946000038, 51.13016184499999],
              [5.840500936000069, 51.138921],
              [5.838020467000092, 51.14372690900008],
              [5.829132121000072, 51.15646514900003],
              [5.812078898000038, 51.157317810000066],
              [5.781383098000106, 51.15240854900013],
              [5.768050577000082, 51.15946238300005],
              [5.74717329900011, 51.17760081000007],
              [5.730843547000063, 51.18375030600005],
              [5.718027791000083, 51.18460296700009],
              [5.676169881000106, 51.17917694100002],
              [5.659013306000048, 51.179073588000065],
              [5.648161255000105, 51.18395701100009],
              [5.638549438000098, 51.19090749100009],
              [5.62501021300011, 51.19690195700012],
              [5.568372843000134, 51.20765065500005],
              [5.551406597000096, 51.21676713400011],
              [5.54553186000004, 51.219923808],
              [5.542327921000066, 51.24266143900006],
              [5.535196573000121, 51.26204010000002],
              [5.516696411000083, 51.27723297200005],
              [5.49323531100012, 51.28653472900008],
              [5.471634562000133, 51.28808502300011],
              [5.451894165000084, 51.282116394000084],
              [5.409932901000076, 51.26353871700003],
              [5.389055623000104, 51.258706971000024],
              [5.270716593000145, 51.26183339500007],
              [5.239455934000091, 51.25693018200009],
              [5.232992798000112, 51.25591644300006],
              [5.215422811000025, 51.25873280800003],
              [5.214906047000085, 51.29433787],
              [5.197336059000122, 51.30834218300002],
              [5.178835897000084, 51.30950490300002],
              [5.140181926000082, 51.30738617000004],
              [5.122921997000105, 51.313380636000076],
              [5.118064412000081, 51.31991770500004],
              [5.107832479000081, 51.34198354100003],
              [5.102561483000073, 51.3506651820001],
              [5.068144979000095, 51.37453969400009],
              [5.061737101000062, 51.38425486300012],
              [5.065251099000108, 51.40590728800002],
              [5.076413208000048, 51.421901144000046],
              [5.079927205000104, 51.43854095500008],
              [5.060290161000069, 51.46197621700004],
              [5.030317831000048, 51.47443023700002],
              [5.027527303000085, 51.47680735300007],
              [5.012127727000092, 51.474326884],
              [5.00613326000007, 51.46830658000006],
              [5.002722616000142, 51.45900482200004],
              [4.995797973000066, 51.4467058310001],
              [4.980191691000101, 51.430531108000096],
              [4.957144002000064, 51.410997416],
              [4.931925903000092, 51.395623678000035],
              [4.910325154000134, 51.391902975],
              [4.871671183000046, 51.403039246000034],
              [4.853274373000119, 51.40613983200008],
              [4.783304484000013, 51.40763844800007],
              [4.762117146000151, 51.41337453200005],
              [4.767801554000101, 51.4253893030001],
              [4.779067016000056, 51.426422832000085],
              [4.822681925000012, 51.413684591000035],
              [4.815447224000138, 51.43107371100005],
              [4.819891398000067, 51.446214905000076],
              [4.826092570000128, 51.46055511500005],
              [4.823922159000062, 51.47564463300007],
              [4.813586873000133, 51.48411956900007],
              [4.796843709000086, 51.49101837200003],
              [4.778653605000045, 51.49535919200012],
              [4.764184204000117, 51.49623769100005],
              [4.731214641000065, 51.485618185000064],
              [4.653906697000053, 51.42621612600003],
              [4.643571411000067, 51.42141021700003],
              [4.630135539000094, 51.418206279000046],
              [4.614632609000097, 51.41756032299999],
              [4.582696573000106, 51.422598776000044],
              [4.553861125000083, 51.419291484000055],
              [4.540631958000091, 51.42006663000005],
              [4.521511678000081, 51.42864491799999],
              [4.523372029000086, 51.43841176400004],
              [4.531846964000096, 51.45086578400013],
              [4.533190551000075, 51.467583110000064],
              [4.525232381000109, 51.47592885400003],
              [4.512623331000071, 51.477375794000025],
              [4.483064412000147, 51.474326884],
              [4.429424275000059, 51.46197621700004],
              [4.37712772600014, 51.44288177500006],
              [4.389220011000134, 51.434587708000024],
              [4.387152954000072, 51.42745636000008],
              [4.3806417240001, 51.41965321900004],
              [4.379918253000113, 51.40952463800009],
              [4.387669719000115, 51.40053293900006],
              [4.410097290000124, 51.383789775000096],
              [4.416195109000085, 51.37397125300005],
              [4.411234171000018, 51.356737162000044],
              [4.392217244000051, 51.35040679900003],
              [4.345605103000082, 51.35229299000004],
              [4.326278117000129, 51.356427104000076],
              [4.290104614000114, 51.36875193300001],
              [4.28112422200013, 51.36894651000004],
              [4.261067579000098, 51.36937927500007],
              [4.257090691000087, 51.37250397300005],
              [4.249034050000091, 51.38422272300005],
              [4.246348504000082, 51.39642975500004],
              [4.246836785000085, 51.40672435100004],
              [4.244883660000085, 51.414496161000045],
              [4.234711134000065, 51.41901276200008],
              [4.222992384000065, 51.409491278000075],
              [4.201019727000073, 51.40534088700008],
              [4.11109459700009, 51.40696849200003],
              [4.090342644000089, 51.41128164300005],
              [4.070160352000073, 51.41901276200008],
              [4.015147332000083, 51.448919989000046],
              [3.998789910000085, 51.453111070000034],
              [3.957041863000086, 51.45579661700003],
              [3.94312584700009, 51.450384833000044],
              [3.91342207100007, 51.415269273000035],
              [3.90211022200009, 51.40493398600006],
              [3.886729363000086, 51.39980703300006],
              [3.850759311000047, 51.397365627000056],
              [3.837901238000086, 51.392238674000055],
              [3.827159050000091, 51.391058661000045],
              [3.816416863000086, 51.39411041900007],
              [3.789073113000086, 51.412176825000074],
              [3.728770379000082, 51.43081289300005],
              [3.689707879000082, 51.454291083000044],
              [3.674001498000052, 51.45538971600007],
              [3.63257897200009, 51.44570547100005],
              [3.610036655000044, 51.44505442900004],
              [3.553396030000044, 51.453111070000034],
              [3.535411004000082, 51.45921458500004],
              [3.520192905000044, 51.47337474200003],
              [3.506846550000091, 51.48932526200008],
              [3.494802280000044, 51.50092194200005],
              [3.461924675000091, 51.51898834800005],
              [3.451019727000073, 51.529730536000045],
              [3.44703209700009, 51.54596588700008],
              [3.457530144000089, 51.55508047100005],
              [3.560394727000073, 51.594631252000056],
              [3.828868035000085, 51.61273834800005],
              [3.851084832000083, 51.61078522300005],
              [3.866058790000068, 51.60541413000004],
              [3.88217207100007, 51.59609609600005],
              [3.896494988000086, 51.58380768400008],
              [3.905772332000083, 51.569240627000056],
              [3.895274285000085, 51.56659577000005],
              [3.87826582100007, 51.55939362200007],
              [3.871592644000089, 51.555568752000056],
              [3.871592644000089, 51.54938385600008],
              [3.967295769000089, 51.54311758000006],
              [4.015879754000082, 51.53082916900007],
              [4.057139519000089, 51.50836823100008],
              [4.070323113000086, 51.49274323100008],
              [4.090017123000052, 51.458238023000035],
              [4.10482832100007, 51.44570547100005],
              [4.128754102000073, 51.44135163000004],
              [4.180837436000047, 51.44586823100008],
              [4.200450066000087, 51.439520575000074],
              [4.220225457000083, 51.44354889500005],
              [4.252777540000068, 51.44253164300005],
              [4.263845248000052, 51.44440338700008],
              [4.283213738000086, 51.447699286000045],
              [4.296722852000073, 51.47052643400008],
              [4.288584832000083, 51.49213288000004],
              [4.267751498000052, 51.50828685100004],
              [4.239756707000083, 51.51850006700005],
              [4.230479363000086, 51.51955801000008],
              [4.19467207100007, 51.52358633000006],
              [4.153330925000091, 51.53506094000005],
              [4.137950066000087, 51.53587474200003],
              [4.106293165000068, 51.53351471600007],
              [4.091319207000083, 51.53506094000005],
              [4.067230665000068, 51.54401276200008],
              [3.988129102000073, 51.590277411000045],
              [4.041188998000052, 51.60602448100008],
              [4.06771894600007, 51.610663153000075],
              [4.157237175000091, 51.60789622600004],
              [4.18336022200009, 51.60293203300006],
              [4.206879102000073, 51.59052155200004],
              [4.207286004000082, 51.590277411000045],
              [4.202647332000083, 51.60911692900004],
              [4.189952019000089, 51.61668528900009],
              [4.186127149000072, 51.61680735900006],
              [4.146657748000052, 51.61786530200004],
              [4.135996941000087, 51.620428778000075],
              [4.125987175000091, 51.624701239000046],
              [4.118011915000068, 51.63068268400008],
              [4.11296634200005, 51.63939036700003],
              [4.109873894000089, 51.65086497600004],
              [4.109629754000082, 51.66229889500005],
              [4.11264082100007, 51.670803127000056],
              [4.125661655000044, 51.67963288000004],
              [4.142914259000065, 51.68414948100008],
              [4.176931186000047, 51.68585846600007],
              [4.166351759000065, 51.692694403000075],
              [4.141123894000089, 51.70392487200007],
              [4.071543816000087, 51.71718984600005],
              [4.057139519000089, 51.73029205900008],
              [4.050791863000086, 51.76349518400008],
              [4.033946160000085, 51.78424713700008],
              [4.009776238000086, 51.79791901200008],
              [3.981455925000091, 51.81000397300005],
              [3.96257571700005, 51.801214911000045],
              [3.93718509200005, 51.79633209800005],
              [3.911387566000087, 51.79637278900009],
              [3.891856316000087, 51.792954820000034],
              [3.888194207000083, 51.78888580900008],
              [3.881114129000082, 51.78807200700004],
              [3.871592644000089, 51.788275458000044],
              [3.862315300000091, 51.816066799000055],
              [3.891368035000085, 51.82827383000006],
              [3.954112175000091, 51.84015534100007],
              [3.96265709700009, 51.847357489000046],
              [3.98218834700009, 51.84829336100006],
              [4.015635613000086, 51.84357330900008],
              [4.043467644000089, 51.83421458500004],
              [4.047618035000085, 51.833685614000046],
              [4.055023634000065, 51.83421458500004],
              [4.065440300000091, 51.837103583000044],
              [4.077647332000083, 51.84357330900008],
              [4.07007897200009, 51.852728583000044],
              [4.04460696700005, 51.87449778900009],
              [4.037852410000085, 51.87791575700004],
              [4.032074415000068, 51.882025458000044],
              [4.029795769000089, 51.88825104400007],
              [4.031993035000085, 51.89606354400007],
              [4.036631707000083, 51.901556708000044],
              [4.041270379000082, 51.905503648000035],
              [4.043467644000089, 51.90867747600004],
              [4.040212436000047, 51.92405833500004],
              [4.02116946700005, 51.963324286000045],
              [4.010020379000082, 51.980129299000055],
              [4.015635613000086, 51.98769765800006],
              [4.022471550000091, 51.99437083500004],
              [4.069021030000044, 51.987941799000055],
              [4.107676629000082, 51.991888739000046],
              [4.141856316000087, 52.00560130400004],
              [4.284678582000083, 52.112941799000055],
              [4.406911655000044, 52.22345612200007],
              [4.508148634000065, 52.336371161000045],
              [4.568614129000082, 52.44525788000004],
              [4.577321811000047, 52.47357819200005],
              [4.577321811000047, 52.48094310100004],
              [4.596934441000087, 52.50657786700003],
              [4.639333530000044, 52.70066966400003],
              [4.657074415000068, 52.75018952000005],
              [4.65984134200005, 52.765285549000055],
              [4.669444207000083, 52.796576239000046],
              [4.711680535000085, 52.86310455900008],
              [4.721364780000044, 52.89594147300005],
              [4.72242272200009, 52.914496161000045],
              [4.726410352000073, 52.93829987200007],
              [4.733897332000083, 52.95888906500005],
              [4.74545332100007, 52.96759674700007],
              [4.806976759000065, 52.961818752000056],
              [4.816905144000089, 52.96759674700007],
              [4.824392123000052, 52.960150458000044],
              [4.809418165000068, 52.92959219000005],
              [4.832774285000085, 52.911322333000044],
              [4.873789910000085, 52.903957424000055],
              [4.913096550000091, 52.905585028000075],
              [4.935801629000082, 52.913397528000075],
              [4.97828209700009, 52.93569570500006],
              [4.999034050000091, 52.940334377000056],
              [5.038910352000073, 52.94350820500006],
              [5.078135613000086, 52.954006252000056],
              [5.279470248000052, 53.062933661000045],
              [5.294200066000087, 53.073431708000044],
              [5.312754754000082, 53.08283112200007],
              [5.358897332000083, 53.08934153900003],
              [5.379242384000065, 53.097357489000046],
              [5.39975019600007, 53.12205638200004],
              [5.42709394600007, 53.190334377000056],
              [5.447438998000052, 53.22089264500005],
              [5.482595248000052, 53.24555084800005],
              [5.504242384000065, 53.257025458000044],
              [5.541026238000086, 53.26658763200004],
              [5.557871941000087, 53.27802155200004],
              [5.573496941000087, 53.29165273600006],
              [5.59156334700009, 53.302801825000074],
              [5.611827019000089, 53.30711497600004],
              [5.659678582000083, 53.31195709800005],
              [5.694590691000087, 53.330064195000034],
              [5.854746941000087, 53.368801174000055],
              [5.890798373000052, 53.38426341400003],
              [5.91374759200005, 53.38540273600006],
              [5.980804884000065, 53.40607330900008],
              [6.077321811000047, 53.40892161700003],
              [6.186045769000089, 53.410996812000064],
              [6.273936394000089, 53.41266510600008],
              [6.284353061000047, 53.41054922100005],
              [6.301931186000047, 53.40110911700003],
              [6.311534050000091, 53.39899323100008],
              [6.32007897200009, 53.40070221600007],
              [6.345550977000073, 53.41266510600008],
              [6.494395379000082, 53.438706773000035],
              [6.73023522200009, 53.460638739000046],
              [6.829112175000091, 53.45058828300006],
              [6.849782748000052, 53.44489166900007],
              [6.86687259200005, 53.43427155200004],
              [6.900563998000052, 53.35179271000004],
              [6.905772332000083, 53.350490627000056],
              [6.930023634000065, 53.34007396000004],
              [6.931895379000082, 53.337591864000046],
              [6.936696811000047, 53.33539459800005],
              [6.941661004000082, 53.33071523600006],
              [6.94857832100007, 53.32607656500005],
              [6.98015384200005, 53.31976959800005],
              [7.020030144000089, 53.30613841400003],
              [7.037771030000044, 53.30963776200008],
              [7.04623457100007, 53.30385976800005],
              [7.05827884200005, 53.301947333000044],
              [7.07007897200009, 53.303941148000035],
              [7.078623894000089, 53.30963776200008],
              [7.085459832000083, 53.30963776200008],
              [7.085459832000083, 53.302801825000074],
              [7.07748457100007, 53.29865143400008],
              [7.073496941000087, 53.29564036700003],
              [7.073741082000083, 53.29132721600007],
              [7.078623894000089, 53.28294505400004],
              [7.080739780000044, 53.266791083000044],
              [7.11109459700009, 53.25633372600004],
              [7.18336022200009, 53.24510325700004],
              [7.194590691000087, 53.245021877000056],
            ],
          ],
          [
            [
              [3.349414674000116, 51.37522311800005],
              [3.510915561000047, 51.40794505400004],
              [3.525726759000065, 51.41559479400007],
              [3.541351759000065, 51.41673411700003],
              [3.604665561000047, 51.391058661000045],
              [3.702159050000091, 51.37360260600008],
              [3.734222852000073, 51.35578034100007],
              [3.75554446700005, 51.35008372600004],
              [3.795909050000091, 51.35008372600004],
              [3.833994988000086, 51.34324778900009],
              [3.858164910000085, 51.34544505400004],
              [3.955821160000085, 51.37177155200004],
              [3.969248894000089, 51.38165924700007],
              [3.974619988000086, 51.401597398000035],
              [3.98414147200009, 51.41046784100007],
              [4.005707227000073, 51.409816799000055],
              [4.02906334700009, 51.40420156500005],
              [4.043467644000089, 51.398504950000074],
              [4.050059441000087, 51.392238674000055],
              [4.061289910000085, 51.376654364000046],
              [4.070160352000073, 51.37055084800005],
              [4.081309441000087, 51.36815013200004],
              [4.105479363000086, 51.366115627000056],
              [4.115489129000082, 51.360988674000055],
              [4.121918165000068, 51.359361070000034],
              [4.156504754000082, 51.35757070500006],
              [4.173675977000073, 51.37372467700004],
              [4.180023634000065, 51.37742747600004],
              [4.199554884000065, 51.37604401200008],
              [4.221491455000091, 51.36800060300003],
              [4.220961547000115, 51.363816834000076],
              [4.213520141000089, 51.34053660100004],
              [4.207939087000085, 51.33058888800004],
              [4.168561645000096, 51.296870016000085],
              [4.118952271000097, 51.27240122500005],
              [3.995032186000032, 51.23323048900009],
              [3.949453572000067, 51.210777080000085],
              [3.927026001000058, 51.206255392000074],
              [3.8086869710001, 51.20532521600002],
              [3.796284627000119, 51.20876169800006],
              [3.781401815000095, 51.21987213200008],
              [3.779748169000129, 51.230310771000106],
              [3.781401815000095, 51.24142120400002],
              [3.776234172000102, 51.25452118000008],
              [3.757320597000046, 51.262324321],
              [3.635054159000049, 51.287826640000034],
              [3.609526001000091, 51.29043630000005],
              [3.584824666000088, 51.2895319630001],
              [3.54503381300006, 51.28392506900006],
              [3.529014120000113, 51.2833307910001],
              [3.514338012000024, 51.28103118899999],
              [3.503382609000141, 51.27395151800006],
              [3.501522258000136, 51.26240183600002],
              [3.504106079000053, 51.24974111000007],
              [3.501212199000065, 51.2402843230001],
              [3.45387658700011, 51.235633444000044],
              [3.421940552000109, 51.23798472099999],
              [3.398798477000071, 51.24469829300001],
              [3.391658163000102, 51.24676971500007],
              [3.367370240000099, 51.2634870400001],
              [3.353210897000054, 51.28860178700005],
              [3.353934366000146, 51.31190785800008],
              [3.358068481000061, 51.336712546000015],
              [3.349414674000116, 51.37522311800005],
            ],
          ],
          [
            [
              [-68.21153723899994, 12.228094794000071],
              [-68.20466061099995, 12.223211981000077],
              [-68.19420325399994, 12.21393463700008],
              [-68.19001217399995, 12.204820054000038],
              [-68.20156816299993, 12.200832424000055],
              [-68.21084550699993, 12.19009023600006],
              [-68.20360266799992, 12.13776276200008],
              [-68.20531165299991, 12.11823151200008],
              [-68.21393795499995, 12.111802476000037],
              [-68.23216712099992, 12.110744533000059],
              [-68.23884029899995, 12.10455963700008],
              [-68.23835201699995, 12.095770575000074],
              [-68.22834225199995, 12.069973049000055],
              [-68.22581946499992, 12.060248114000046],
              [-68.22752844999991, 12.050726630000042],
              [-68.23184160099993, 12.037990627000056],
              [-68.23729407499991, 12.02680084800005],
              [-68.24254309799994, 12.022040106000077],
              [-68.25422115799995, 12.023627020000049],
              [-68.25967363199993, 12.02806224200009],
              [-68.28062903599994, 12.072211005000042],
              [-68.28538977799991, 12.09007396000004],
              [-68.28726152299993, 12.108303127000056],
              [-68.28282630099994, 12.139593817000048],
              [-68.28221594999991, 12.159898179000038],
              [-68.28726152299993, 12.18032461100006],
              [-68.30256100199995, 12.202948309000078],
              [-68.32127844999991, 12.21385325700004],
              [-68.36978105399993, 12.221258856000077],
              [-68.39183508999992, 12.227769273000092],
              [-68.41071529899995, 12.240301825000074],
              [-68.41738847599993, 12.257025458000044],
              [-68.40330969999991, 12.276516018000052],
              [-68.41075598899994, 12.282700914000088],
              [-68.40648352799991, 12.294623114000046],
              [-68.40005449099993, 12.304388739000046],
              [-68.39045162699995, 12.310207424000055],
              [-68.37661699099993, 12.310044664000088],
              [-68.36148027299993, 12.30219147300005],
              [-68.34044348899994, 12.274969794000071],
              [-68.33189856699994, 12.269029039000088],
              [-68.31484941299993, 12.264837958000044],
              [-68.25251217399995, 12.235541083000044],
              [-68.22052975199995, 12.231146552000041],
              [-68.21153723899994, 12.228094794000071],
            ],
          ],
          [
            [
              [-62.99714107999995, 17.52562083500004],
              [-62.983796982999934, 17.517682944000057],
              [-62.97725385399991, 17.50413683800008],
              [-62.96525672899992, 17.49891596300006],
              [-62.94506450999995, 17.485384431000057],
              [-62.9489035709999, 17.47237460300005],
              [-62.958723137999925, 17.46457117400007],
              [-62.981085521999944, 17.467723731000092],
              [-62.994699673999946, 17.492132880000042],
              [-62.99714107999995, 17.52562083500004],
            ],
          ],
          [
            [
              [4.036631707000083, 51.68585846600007],
              [4.078379754000082, 51.678615627000056],
              [4.09734134200005, 51.67023346600007],
              [4.09937584700009, 51.65412018400008],
              [4.089040561000047, 51.64402903900009],
              [4.072601759000065, 51.63690827000005],
              [4.054860873000052, 51.63263580900008],
              [3.978037957000083, 51.62327708500004],
              [3.96029707100007, 51.62384674700007],
              [3.923106316000087, 51.632473049000055],
              [3.901540561000047, 51.64199453300006],
              [3.89193769600007, 51.655503648000035],
              [3.885590040000068, 51.66836172100005],
              [3.869802280000044, 51.67609284100007],
              [3.830577019000089, 51.68585846600007],
              [3.82390384200005, 51.689886786000045],
              [3.817637566000087, 51.69525788000004],
              [3.809255405000044, 51.69953034100007],
              [3.795909050000091, 51.70014069200005],
              [3.77125084700009, 51.68183014500005],
              [3.76539147200009, 51.67841217700004],
              [3.720550977000073, 51.67682526200008],
              [3.700043165000068, 51.68060944200005],
              [3.686696811000047, 51.692694403000075],
              [3.689463738000086, 51.725043036000045],
              [3.725840691000087, 51.73973216400009],
              [3.810069207000083, 51.747300523000035],
              [3.81421959700009, 51.74823639500005],
              [3.830577019000089, 51.747300523000035],
              [3.843760613000086, 51.74282461100006],
              [3.939626498000052, 51.74115631700005],
              [3.961761915000068, 51.73810455900008],
              [3.978037957000083, 51.73029205900008],
              [4.01539147200009, 51.70172760600008],
              [4.020274285000085, 51.696478583000044],
              [4.026621941000087, 51.691107489000046],
              [4.036631707000083, 51.68585846600007],
            ],
          ],
          [
            [
              [4.892588738000086, 53.111029364000046],
              [4.892588738000086, 53.104803778000075],
              [4.913096550000091, 53.104803778000075],
              [4.906097852000073, 53.09170156500005],
              [4.893077019000089, 53.07611725500004],
              [4.865244988000086, 53.05019765800006],
              [4.81812584700009, 53.02676015800006],
              [4.795664910000085, 53.00031159100007],
              [4.761973504000082, 52.99433014500005],
              [4.726817254000082, 53.00307851800005],
              [4.707692905000044, 53.02846914300005],
              [4.713877800000091, 53.05463288000004],
              [4.733653191000087, 53.08421458500004],
              [4.758474155000044, 53.10846588700008],
              [4.805674675000091, 53.13300202000005],
              [4.829274936000047, 53.162990627000056],
              [4.854340040000068, 53.18773021000004],
              [4.885752800000091, 53.186712958000044],
              [4.889821811000047, 53.180853583000044],
              [4.892100457000083, 53.17572663000004],
              [4.891368035000085, 53.17096588700008],
              [4.885752800000091, 53.16620514500005],
              [4.899912957000083, 53.152329820000034],
              [4.910166863000086, 53.13458893400008],
              [4.90992272200009, 53.118841864000046],
              [4.892588738000086, 53.111029364000046],
            ],
          ],
          [
            [
              [4.878916863000086, 53.22089264500005],
              [4.92123457100007, 53.25372955900008],
              [4.986501498000052, 53.28998444200005],
              [5.05445397200009, 53.313788153000075],
              [5.10482832100007, 53.30963776200008],
              [5.10482832100007, 53.302801825000074],
              [5.078135613000086, 53.302801825000074],
              [5.065603061000047, 53.298488674000055],
              [5.03646894600007, 53.29181549700007],
              [4.957530144000089, 53.24555084800005],
              [4.935720248000052, 53.22597890800006],
              [4.910166863000086, 53.21246979400007],
              [4.878916863000086, 53.22089264500005],
            ],
          ],
          [
            [
              [5.42359459700009, 53.43036530200004],
              [5.437022332000083, 53.43646881700005],
              [5.58529707100007, 53.45359935100004],
              [5.562022332000083, 53.43431224200003],
              [5.533702019000089, 53.42837148600006],
              [5.475433790000068, 53.426947333000044],
              [5.477386915000068, 53.423529364000046],
              [5.479746941000087, 53.41620514500005],
              [5.481700066000087, 53.41266510600008],
              [5.468597852000073, 53.40851471600007],
              [5.427012566000087, 53.40643952000005],
              [5.38249759200005, 53.39468008000006],
              [5.346934441000087, 53.38922760600008],
              [5.20834394600007, 53.35268789300005],
              [5.179860873000052, 53.35309479400007],
              [5.16765384200005, 53.36823151200008],
              [5.178884311000047, 53.38544342700004],
              [5.232432488000086, 53.39671458500004],
              [5.250173373000052, 53.40643952000005],
              [5.272959832000083, 53.40607330900008],
              [5.407237175000091, 53.42255280200004],
              [5.42359459700009, 53.43036530200004],
            ],
          ],
          [
            [
              [5.674001498000052, 53.46792226800005],
              [5.91382897200009, 53.473863023000035],
              [5.954600457000083, 53.46108633000006],
              [5.855642123000052, 53.44741445500006],
              [5.752777540000068, 53.44741445500006],
              [5.727061394000089, 53.443345445000034],
              [5.678965691000087, 53.430121161000045],
              [5.653575066000087, 53.43374258000006],
              [5.63607832100007, 53.44867584800005],
              [5.64193769600007, 53.46336497600004],
              [5.658864780000044, 53.471869208000044],
              [5.674001498000052, 53.46792226800005],
            ],
          ],
          [
            [
              [6.211761915000068, 53.50885651200008],
              [6.310801629000082, 53.51414622600004],
              [6.338715040000068, 53.50885651200008],
              [6.338715040000068, 53.502020575000074],
              [6.325043165000068, 53.502020575000074],
              [6.153168165000068, 53.468817450000074],
              [6.133311394000089, 53.45359935100004],
              [6.127452019000089, 53.45990631700005],
              [6.127126498000052, 53.46308014500005],
              [6.133311394000089, 53.46792226800005],
              [6.12281334700009, 53.481634833000044],
              [6.147959832000083, 53.49485911700003],
              [6.185394727000073, 53.50486888200004],
              [6.211761915000068, 53.50885651200008],
            ],
          ],
          [
            [
              [6.44117272200009, 53.556626695000034],
              [6.455088738000086, 53.55809153900003],
              [6.510101759000065, 53.54360586100006],
              [6.50562584700009, 53.54376862200007],
              [6.501963738000086, 53.54254791900007],
              [6.498871290000068, 53.53998444200005],
              [6.496429884000065, 53.53620026200008],
              [6.46070397200009, 53.54336172100005],
              [6.44304446700005, 53.549994208000044],
              [6.44117272200009, 53.556626695000034],
            ],
          ],
          [
            [
              [-63.23843339799993, 17.646918036000045],
              [-63.23029537699995, 17.642320054000038],
              [-63.22370357999995, 17.62921784100007],
              [-63.22948157499991, 17.61823151200008],
              [-63.238392706999946, 17.61469147300005],
              [-63.25133216099994, 17.62376536700009],
              [-63.248931443999936, 17.640366929000038],
              [-63.23843339799993, 17.646918036000045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Liechtenstein',
        iso3: 'LIE',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [9.52115482500011, 47.2628010050001],
            [9.530249878000092, 47.253654277000024],
            [9.547096395000068, 47.24303477000002],
            [9.540378458000134, 47.22910797200005],
            [9.544822632000148, 47.220322978000056],
            [9.554331095000123, 47.211615499000104],
            [9.562909383000061, 47.19774037700002],
            [9.561875854000078, 47.19060902900007],
            [9.551953979000103, 47.175571188],
            [9.552057332000118, 47.16688954700005],
            [9.5818229570001, 47.154900615000074],
            [9.605594116000077, 47.13226633700005],
            [9.615722697000109, 47.10676401800002],
            [9.608798055000136, 47.080770773000054],
            [9.581202840000032, 47.05687042300006],
            [9.560635620000141, 47.05240041200004],
            [9.499554077000141, 47.05935089100002],
            [9.477023153000118, 47.06389841700006],
            [9.475886271000121, 47.0732260140001],
            [9.487565145000104, 47.083948874],
            [9.50286136800014, 47.09469757200013],
            [9.512369832000047, 47.10803009100006],
            [9.511853068000107, 47.12937245700006],
            [9.503481486000112, 47.14539215100011],
            [9.492629435000083, 47.15980987600001],
            [9.484981323000085, 47.176346334000115],
            [9.487358439000047, 47.21001352900005],
            [9.504618368000138, 47.24373240200002],
            [9.52115482500011, 47.2628010050001],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Serbia',
        iso3: 'SRB',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [20.24282596900008, 46.10809112600005],
            [20.305664510000042, 46.053572490000036],
            [20.317653443000097, 46.038586324000065],
            [20.33863407400011, 45.99280100500003],
            [20.35393029800005, 45.97667795900004],
            [20.370983521000085, 45.96778961200003],
            [20.41025760900007, 45.955593974000024],
            [20.429067830000065, 45.94670562800012],
            [20.481674439000074, 45.912702535000065],
            [20.499864543000115, 45.906656392000045],
            [20.538001749000074, 45.90371083600003],
            [20.556708618000073, 45.89843984],
            [20.572108195000055, 45.887691142000065],
            [20.60528446400005, 45.846143291],
            [20.612312459000066, 45.84149241200002],
            [20.629675740000096, 45.833275858],
            [20.636703735000083, 45.827023011000094],
            [20.640114380000114, 45.81870310500004],
            [20.642284790000105, 45.798342590000104],
            [20.64348956000015, 45.79514134500009],
            [20.64590214000009, 45.788730775],
            [20.65561731000014, 45.77731028300009],
            [20.678561646000077, 45.756639709000055],
            [20.688070109000137, 45.743100484000095],
            [20.700059041000117, 45.7354006960001],
            [20.713391561000037, 45.73333363900004],
            [20.726827433000068, 45.736175842000094],
            [20.739436482000116, 45.74341054300008],
            [20.745327596000095, 45.75498606400002],
            [20.75411259000009, 45.763564352000046],
            [20.765171346000102, 45.76676829100002],
            [20.777470337000125, 45.762324117],
            [20.785738566000077, 45.75255727200006],
            [20.785531861000038, 45.74341054300008],
            [20.781604451000078, 45.733953756000105],
            [20.7791239820001, 45.72367014600012],
            [20.7799508060001, 45.671683655],
            [20.777263631000096, 45.657524312000035],
            [20.773232869000083, 45.648894349],
            [20.76217411300007, 45.63060089100013],
            [20.754422648000087, 45.60558949900003],
            [20.758039998000072, 45.589259746],
            [20.787392212000043, 45.55365468400002],
            [20.80020796700012, 45.53050364200003],
            [20.797624146000118, 45.51649932900001],
            [20.783154745000076, 45.50606069000007],
            [20.760727173000078, 45.493348288000035],
            [20.767135050000036, 45.47934397400003],
            [20.781604451000078, 45.47257436100007],
            [20.799484497000037, 45.4685436],
            [20.816020955000113, 45.46285919200004],
            [20.830387004000016, 45.45252390600005],
            [20.8630465090001, 45.41872751900006],
            [20.927642050000145, 45.377489726000064],
            [20.966192667000115, 45.341574605000076],
            [20.981488891000083, 45.33278961200001],
            [21.016668402000107, 45.321481912000095],
            [21.063964478000088, 45.30627960200009],
            [21.074299764000102, 45.300543518000055],
            [21.082774699000083, 45.29367055300007],
            [21.09155969200009, 45.28808949800005],
            [21.103341919000087, 45.28607411700001],
            [21.11305708800012, 45.2893297320001],
            [21.129180135000098, 45.301887105],
            [21.139412069000088, 45.303695781],
            [21.15563846900008, 45.29516917000008],
            [21.189744914000073, 45.259564108000106],
            [21.20607466600009, 45.245921529],
            [21.239250936000104, 45.229385071000095],
            [21.257130982000064, 45.22411407500009],
            [21.299298950000036, 45.223183899000034],
            [21.405545695000086, 45.19967112200003],
            [21.43376102700006, 45.18881907100008],
            [21.459392537000042, 45.17403961200007],
            [21.48438838900006, 45.152701690000086],
            [21.493292277000137, 45.1451008100001],
            [21.497839803000062, 45.13187164300011],
            [21.494119100000148, 45.11931427000009],
            [21.481510051000043, 45.111562806000094],
            [21.46900435300003, 45.11104604100005],
            [21.458565715000105, 45.10732533800005],
            [21.44998742700008, 45.101020813000034],
            [21.44244266700011, 45.09290761300012],
            [21.443786255000077, 45.09146067400003],
            [21.44440637200006, 45.085259502000056],
            [21.44440637200006, 45.07786977200006],
            [21.443786255000077, 45.0729088340001],
            [21.440995727000114, 45.06872304300005],
            [21.43252079200002, 45.06148834300008],
            [21.429523560000092, 45.05730255200005],
            [21.425596150000047, 45.04324656200005],
            [21.425079386000107, 45.036218567000034],
            [21.421875447000048, 45.031412659000026],
            [21.409266398000113, 45.023971253000084],
            [21.398827758000067, 45.02138743100009],
            [21.373299601000042, 45.020095520000055],
            [21.363377726000124, 45.016529847000086],
            [21.35614302600007, 45.0085716760001],
            [21.351388794000087, 44.99823638900001],
            [21.35345585200014, 44.98981313100002],
            [21.366995077000126, 44.98728098600013],
            [21.383944946000042, 44.98666086900006],
            [21.38704553200006, 44.98154490200007],
            [21.384565063000082, 44.97493031900008],
            [21.385185181000054, 44.9695042930001],
            [21.408439575000074, 44.958342183000056],
            [21.456498657000054, 44.95234771700005],
            [21.481510051000043, 44.943562724000046],
            [21.51633996600009, 44.93389923200003],
            [21.531016073000075, 44.92464915],
            [21.539077596000084, 44.90847442600001],
            [21.536287068000036, 44.88930247000009],
            [21.522127727000083, 44.880775859],
            [21.481510051000043, 44.87261098300006],
            [21.453398072000084, 44.86956207300004],
            [21.395313761000097, 44.8716291300001],
            [21.36854536900003, 44.864859517000056],
            [21.355522908000097, 44.85659128800002],
            [21.346427857000037, 44.84563588500005],
            [21.34281050600015, 44.83194163100002],
            [21.359799635000115, 44.82665722100005],
            [21.360587199000065, 44.826412252000026],
            [21.378570597000078, 44.81664540700005],
            [21.39593387900007, 44.790238749000096],
            [21.4121602780001, 44.78481272400002],
            [21.497219686000108, 44.77804311100009],
            [21.558404582000037, 44.78166046100007],
            [21.578041626000072, 44.777681377000064],
            [21.59561161200014, 44.76595082600009],
            [21.604293254000083, 44.74998280900006],
            [21.610287720000116, 44.73194773400006],
            [21.619692830000076, 44.71391265900006],
            [21.65627974500012, 44.68766103200004],
            [21.705165649000094, 44.677067363000035],
            [21.75684208100006, 44.67727406900009],
            [21.801697225000026, 44.68388865200008],
            [21.83828413900008, 44.69520579000006],
            [21.855440715000043, 44.69846140500006],
            [21.87197717300012, 44.69598093700007],
            [21.96241093000009, 44.662287903000035],
            [21.994346964000073, 44.6585672],
            [22.004268839000076, 44.651539205000105],
            [22.032174113000053, 44.60332509400011],
            [22.03424290400008, 44.59616819500009],
            [22.036173617000117, 44.58948897000006],
            [22.039822225000137, 44.57686676100012],
            [22.0451965740001, 44.569218649000035],
            [22.05573856600006, 44.56213897700012],
            [22.06710738100014, 44.557229717000084],
            [22.076305786000148, 44.550718486],
            [22.08695113100012, 44.52177968300005],
            [22.104314412000065, 44.509635722000056],
            [22.126638631000105, 44.50265940300007],
            [22.148239380000092, 44.500902405000076],
            [22.172113892000084, 44.50534657900009],
            [22.185136352000114, 44.515113424000035],
            [22.29903120900005, 44.66166778600005],
            [22.30492232300014, 44.67737742200002],
            [22.319701782000067, 44.68533559200007],
            [22.361146281000032, 44.6920535280001],
            [22.380679973000042, 44.70052846300011],
            [22.4155098870001, 44.72781362000002],
            [22.426051880000074, 44.73365305600002],
            [22.450546508000116, 44.73298126300004],
            [22.468943319000118, 44.73019073600007],
            [22.48372277800013, 44.723989563000075],
            [22.553279256000053, 44.669160869000095],
            [22.58748905400003, 44.64936879500003],
            [22.621182088000097, 44.637431539000076],
            [22.70014367600004, 44.63061025100002],
            [22.714716431000113, 44.62306549100008],
            [22.765152628000095, 44.58280955000002],
            [22.759261515000105, 44.564671123],
            [22.741691528000047, 44.5518553670001],
            [22.719367309000063, 44.544362285],
            [22.70014367600004, 44.5418301400001],
            [22.67854292800007, 44.545550843000015],
            [22.642162719000083, 44.563120830000074],
            [22.621182088000097, 44.569218649000035],
            [22.600304810000125, 44.56978709],
            [22.58046105900013, 44.565497946000036],
            [22.565578247000076, 44.55542104100009],
            [22.5597904870001, 44.538781230000055],
            [22.556689900000066, 44.52146962500005],
            [22.548421672000103, 44.51170277900012],
            [22.535502563000108, 44.50751698800006],
            [22.500362590000066, 44.506380107000055],
            [22.49106083200013, 44.504209697000064],
            [22.48413618900014, 44.49976552400007],
            [22.479795370000062, 44.49041209000002],
            [22.47721154800007, 44.476976217000086],
            [22.477004842000014, 44.46395375600004],
            [22.48000207500013, 44.455788880000014],
            [22.500982706000116, 44.44193959600007],
            [22.50542688000013, 44.43501495400007],
            [22.5063570560001, 44.42752187100005],
            [22.503979940000136, 44.41170888300003],
            [22.50511682100006, 44.40406077100006],
            [22.522686808000117, 44.375070292000075],
            [22.549351847000082, 44.348973694000094],
            [22.582838175000063, 44.32840647400009],
            [22.621182088000097, 44.31590077800011],
            [22.66252323400002, 44.31166331000007],
            [22.6815401610001, 44.305307109000026],
            [22.68949833200014, 44.29171620800004],
            [22.685364217000114, 44.24365712500007],
            [22.69073856600008, 44.22887766500007],
            [22.691640373000098, 44.228434539],
            [22.648777303000088, 44.2139948530001],
            [22.63999231000011, 44.207328593000014],
            [22.624799438000082, 44.18939687200013],
            [22.608573039000078, 44.17585764600007],
            [22.606195923000115, 44.174565735],
            [22.604852335000146, 44.16846791600004],
            [22.605989217000058, 44.16314524400009],
            [22.607952921000106, 44.15999298100006],
            [22.6093998610001, 44.15994130500003],
            [22.599064575000085, 44.13033070900009],
            [22.597100871000038, 44.11906524700002],
            [22.598134399000116, 44.10929840100006],
            [22.604645630000107, 44.08816274000013],
            [22.604748982000018, 44.07937774700004],
            [22.592966757000113, 44.06392649400006],
            [22.575190064000083, 44.061394348000064],
            [22.554622844000107, 44.06242787700005],
            [22.53415897600013, 44.0571568810001],
            [22.522583455000103, 44.04470286100012],
            [22.51493534300002, 44.0302851360001],
            [22.503669882000054, 44.01989817300007],
            [22.481449015000123, 44.019433085000045],
            [22.46588525700014, 44.01762414000005],
            [22.43432010900011, 44.013955384000056],
            [22.4117891840001, 44.00692738900007],
            [22.39959354600009, 43.993336487000064],
            [22.397319783000057, 43.9809341440001],
            [22.396803019000117, 43.95194366500003],
            [22.394529256000112, 43.936337382],
            [22.39194543500011, 43.93186737100005],
            [22.382023560000107, 43.918560690000064],
            [22.379026326000087, 43.91349639900007],
            [22.377062622000068, 43.88352406800003],
            [22.367554159000065, 43.85275075300008],
            [22.354738403000084, 43.829703065],
            [22.349467407000077, 43.80792144800007],
            [22.362593221000026, 43.780842998000125],
            [22.38853479000008, 43.758286235000085],
            [22.389568319000148, 43.75050893200007],
            [22.385847616000063, 43.73381744400005],
            [22.386054321000103, 43.725497538000084],
            [22.390498495000116, 43.712449240000055],
            [22.396906372000046, 43.6994009400001],
            [22.404864543000116, 43.68717946400007],
            [22.41395959500008, 43.67666331000002],
            [22.426465291000085, 43.66821421300004],
            [22.4559208580001, 43.65640614900012],
            [22.466256144000084, 43.64911977200005],
            [22.47287072800009, 43.63594228200007],
            [22.47380090300004, 43.61299794600002],
            [22.481449015000123, 43.60064727800007],
            [22.48175907400011, 43.59997548500009],
            [22.481965780000053, 43.599458720000044],
            [22.48175907400011, 43.59894195600002],
            [22.481449015000123, 43.59852854500009],
            [22.478141723000107, 43.59491119400012],
            [22.47710819400004, 43.59129384400002],
            [22.478141723000107, 43.58757314100002],
            [22.481449015000123, 43.584136658],
            [22.48268925000005, 43.58173370400003],
            [22.48310266100006, 43.57927907300005],
            [22.48268925000005, 43.57669525200005],
            [22.481449015000123, 43.57411143000006],
            [22.478658488000065, 43.56917633100004],
            [22.47762495900008, 43.564163717000056],
            [22.47845178300011, 43.5592286170001],
            [22.49064742000013, 43.54088348500004],
            [22.50935428800011, 43.493341166],
            [22.518862752000075, 43.47424672500004],
            [22.53260868400011, 43.464841614000065],
            [22.565784953000048, 43.453343608000054],
            [22.572709595000106, 43.448150127000034],
            [22.58676558400012, 43.43443003300011],
            [22.59627404800011, 43.429159038000066],
            [22.606919393000112, 43.427402038000096],
            [22.62852014100008, 43.428254700000124],
            [22.63782190000012, 43.42636851100012],
            [22.645366658000057, 43.420296529000055],
            [22.6565287680001, 43.40319163100013],
            [22.658926066000106, 43.40129503400003],
            [22.664693644000096, 43.39673207700007],
            [22.674202108000088, 43.394148255000076],
            [22.693219035000055, 43.39487172500007],
            [22.702934204000087, 43.39404490200003],
            [22.719367309000063, 43.38867055300007],
            [22.724343132000087, 43.38606013100009],
            [22.733009888000083, 43.381513367000125],
            [22.804530070000112, 43.328984274000064],
            [22.817139119000046, 43.315496724000084],
            [22.820756469000116, 43.30753855400003],
            [22.823857056000065, 43.28929677300006],
            [22.82695764200011, 43.281390279000036],
            [22.833158814000086, 43.27464650500009],
            [22.857343384000046, 43.256947327],
            [22.88380171700004, 43.230592347000126],
            [22.89775435300004, 43.220334574000034],
            [22.91553104600007, 43.212247213000055],
            [22.964727010000047, 43.204418234000016],
            [22.98136682200007, 43.198992208000035],
            [22.982901935000143, 43.18731791900008],
            [22.98457076000011, 43.17462677100012],
            [22.974028768000068, 43.141192118000035],
            [22.955631958000055, 43.108274232],
            [22.93527144300012, 43.085562439000014],
            [22.927106568000113, 43.08114410500012],
            [22.910156698000094, 43.07527882900003],
            [22.901681763000113, 43.06974945100002],
            [22.896720825000045, 43.06272145700011],
            [22.889486124000086, 43.04437632300004],
            [22.88421512800005, 43.036650696000024],
            [22.842253865000146, 43.007505188000025],
            [22.82902469900006, 42.99365590500004],
            [22.82902469900006, 42.993500875],
            [22.82892134600013, 42.99344919800008],
            [22.828817993000115, 42.99344919800008],
            [22.815795532000067, 42.98970265700008],
            [22.788096964000147, 42.98489674900007],
            [22.776418091000068, 42.97972910600005],
            [22.769390096000052, 42.97128000900007],
            [22.763188924000076, 42.95864512100003],
            [22.74551558400006, 42.910069275000026],
            [22.73957861800011, 42.89885754300009],
            [22.73879764800006, 42.897382711],
            [22.727015422000136, 42.88689239500003],
            [22.696629680000086, 42.87740977000006],
            [22.666243937000047, 42.87193206800008],
            [22.590899699000147, 42.88689239500003],
            [22.56361454200004, 42.88428273500004],
            [22.549971965000054, 42.87735809300004],
            [22.544785162000068, 42.87170643800006],
            [22.544494262000057, 42.871389466000025],
            [22.537569621000074, 42.86834055600009],
            [22.51979292800013, 42.87035593700004],
            [22.506046997000112, 42.87012339300007],
            [22.497055298000078, 42.864413147000036],
            [22.481449015000123, 42.84673980700002],
            [22.470907023000052, 42.84012522400003],
            [22.445482218000052, 42.83017751100003],
            [22.43680057800009, 42.824286398000126],
            [22.430446174000025, 42.81707659300007],
            [22.427395467000053, 42.81361521400002],
            [22.425845174000102, 42.809842835],
            [22.429359172000062, 42.806122131000095],
            [22.453130331000125, 42.76359242800005],
            [22.46656620300007, 42.748528748000055],
            [22.481449015000123, 42.739821269000075],
            [22.482585897000035, 42.73682403600007],
            [22.482895955000117, 42.733775126000026],
            [22.482585897000035, 42.730674541],
            [22.481449015000123, 42.727677307000064],
            [22.468116496000107, 42.71832387300013],
            [22.442071573000106, 42.68168528200009],
            [22.44920292100005, 42.66796519000006],
            [22.444552042000083, 42.643289694000046],
            [22.44131821900004, 42.632891463000064],
            [22.428842407000047, 42.59277598100003],
            [22.425328410000077, 42.572854716],
            [22.42966923000006, 42.571407776000015],
            [22.481449015000123, 42.5356218460001],
            [22.512144816000074, 42.519188742000026],
            [22.524857218000108, 42.507664897],
            [22.532505330000106, 42.493557231000054],
            [22.532505330000106, 42.49340220200013],
            [22.53653609200009, 42.47839019800004],
            [22.533125448000078, 42.457590434000096],
            [22.519482870000047, 42.42092600500003],
            [22.508837525000075, 42.40493215],
            [22.497572062000103, 42.39919606500003],
            [22.485066365000108, 42.39715484600008],
            [22.46977014100014, 42.39170298300009],
            [22.454370565000147, 42.37676849400013],
            [22.438454223000036, 42.340052388000046],
            [22.423984822000108, 42.32589304700009],
            [22.405794718000067, 42.32155222600004],
            [22.364143514000148, 42.32098378500008],
            [22.345023234000053, 42.313439026000125],
            [22.32528283700009, 42.31431752500008],
            [22.3076094970001, 42.31933014000002],
            [22.291589803000136, 42.3283993540001],
            [22.276913696000065, 42.34124094700009],
            [22.274019816000077, 42.34847564700006],
            [22.27329634600008, 42.365477194000064],
            [22.26885217300014, 42.37033477900009],
            [22.259757120000074, 42.36909454400005],
            [22.233402140000123, 42.34888905800007],
            [22.09552941900006, 42.30581675200007],
            [22.060906209000052, 42.301088359000076],
            [22.045407482000144, 42.302424041],
            [22.027626587000015, 42.303956401000065],
            [21.99496708200013, 42.312612203000086],
            [21.94153365000011, 42.333101909000064],
            [21.92902795400002, 42.335117289000024],
            [21.91827925600009, 42.33134491],
            [21.8843795170001, 42.30951161800006],
            [21.877351522000083, 42.308219706],
            [21.837353963000112, 42.3085556030001],
            [21.817200154000147, 42.30514495900006],
            [21.71952070000009, 42.26095663500011],
            [21.706509236000073, 42.25507049600007],
            [21.69203983500003, 42.242022197000026],
            [21.676886452000076, 42.23494482000011],
            [21.659690389000048, 42.23556264300008],
            [21.624653768000115, 42.24277150500002],
            [21.575044392000052, 42.242022197000026],
            [21.564065710000108, 42.24628930200005],
            [21.553857056000084, 42.273984070000026],
            [21.514893026000095, 42.31783152300004],
            [21.516029907000103, 42.34193857900006],
            [21.537320597000104, 42.358630066],
            [21.596645141000124, 42.37209177700005],
            [21.61741906800006, 42.38663869200012],
            [21.621863240000067, 42.40216746000003],
            [21.616902303000103, 42.433922628000076],
            [21.61896936000008, 42.44924469100003],
            [21.6278577060001, 42.46038096100004],
            [21.66785526500007, 42.490094910000025],
            [21.71767134600009, 42.551150615000026],
            [21.72769657400002, 42.574146627000076],
            [21.72676639800008, 42.577944845],
            [21.719738403000065, 42.58667816200007],
            [21.71829146300007, 42.59101898200005],
            [21.720151815000065, 42.593887024000125],
            [21.72697310300012, 42.596393331000016],
            [21.728833455000114, 42.59830535900004],
            [21.73007369000007, 42.60101837200007],
            [21.735551392000048, 42.62127553400008],
            [21.734724569000036, 42.62424692800006],
            [21.74454309100011, 42.629647116000044],
            [21.756532023000148, 42.63362620000002],
            [21.767074016000038, 42.63871632900002],
            [21.772758422000067, 42.6475013230001],
            [21.7643868400001, 42.669618836],
            [21.744249788000076, 42.67942452800007],
            [21.738651977000103, 42.68215037],
            [21.708886352, 42.687188823000085],
            [21.68738895700008, 42.68682708800007],
            [21.64408410700011, 42.67230601000004],
            [21.629407999000108, 42.67220265700011],
            [21.61266483600008, 42.680393372000125],
            [21.58052209500005, 42.71021067300005],
            [21.56522587000009, 42.72018422500004],
            [21.542488240000097, 42.72581695600006],
            [21.44182255000004, 42.736100566000076],
            [21.41780040600011, 42.73557016200006],
            [21.405545695000086, 42.73529958100006],
            [21.38869917800011, 42.73904612300008],
            [21.37867395100008, 42.74413625100006],
            [21.379190714000117, 42.74700429300013],
            [21.383944946000042, 42.74997568800005],
            [21.3871488850001, 42.75496246400009],
            [21.390559529000114, 42.770413717000096],
            [21.404098755000092, 42.8039775590001],
            [21.40833622200006, 42.82074656200005],
            [21.40841888600005, 42.84174320800007],
            [21.408439575000074, 42.84699819000009],
            [21.39893111100008, 42.85456878700005],
            [21.378777303000106, 42.855292257000045],
            [21.34673791500012, 42.86084747300005],
            [21.336402628000116, 42.8654725140001],
            [21.31697229000011, 42.877616476000114],
            [21.306326945000137, 42.882448222000036],
            [21.294958130000055, 42.884386088000056],
            [21.271600383000106, 42.88428273500004],
            [21.260541626000105, 42.88655649900004],
            [21.23242964700006, 42.910896098000066],
            [21.2267452400001, 42.94252207500004],
            [21.225298299000116, 42.97355377200007],
            [21.20979536900009, 42.99587799100006],
            [21.19305220600006, 42.99789337200009],
            [21.17940962700004, 42.99058115700011],
            [21.165353638000028, 42.985103455000015],
            [21.14788700300008, 42.99262237600006],
            [21.139308716000045, 43.00582570400006],
            [21.124012491000087, 43.05827728300001],
            [21.10850956200008, 43.08155751600013],
            [21.092593221000072, 43.090678406],
            [21.02582727100011, 43.093365580000054],
            [21.005156698000093, 43.099127502],
            [20.993431297000086, 43.10414825700012],
            [20.91249413300011, 43.13880512900006],
            [20.838551880000125, 43.170466817],
            [20.832040649000078, 43.1786058550001],
            [20.836071411000148, 43.179432678000026],
            [20.839068644000065, 43.192455140000064],
            [20.8406189370001, 43.20697621700002],
            [20.83999882000012, 43.2120921840001],
            [20.85147098800013, 43.219817811],
            [20.861599569000106, 43.21751820900006],
            [20.864700154000047, 43.21733734200002],
            [20.855088338000115, 43.23144500800005],
            [20.848473755000043, 43.23813710600008],
            [20.83844852700011, 43.24586273200008],
            [20.819431600000144, 43.25741241500002],
            [20.809717238000076, 43.25961018900004],
            [20.794420207000144, 43.26307098400004],
            [20.769512166000084, 43.26084889800005],
            [20.745327596000095, 43.252864888000076],
            [20.66698612400012, 43.20966339200005],
            [20.64486861200001, 43.2033071900001],
            [20.612312459000066, 43.202273662000025],
            [20.604044230000113, 43.19795867900005],
            [20.597533, 43.18496205700002],
            [20.600116821000142, 43.17382578600011],
            [20.612105754000112, 43.15493805000007],
            [20.62058068900012, 43.133337301],
            [20.62605839000011, 43.123725485000094],
            [20.632052856000115, 43.11726593000013],
            [20.64094120300004, 43.115276388],
            [20.651689901000054, 43.11630991600008],
            [20.661818481000125, 43.11594818200008],
            [20.6691565350001, 43.10979868600002],
            [20.664919068000074, 43.08540741000009],
            [20.643835083000027, 43.05225697900006],
            [20.617273397000105, 43.02212961900007],
            [20.596396118000143, 43.0070917770001],
            [20.584303833000064, 43.00691090900004],
            [20.572831665000137, 43.00933970200002],
            [20.56239302600011, 43.00949473100006],
            [20.55340132600014, 43.00259592700009],
            [20.54389286300008, 42.98724802700009],
            [20.538415161000074, 42.98065928100003],
            [20.53045699000012, 42.975155742000126],
            [20.51113000500007, 42.97019480400006],
            [20.493456665000082, 42.97019480400006],
            [20.47640344200005, 42.96637074800013],
            [20.459453572000115, 42.950015158],
            [20.45097863700005, 42.92203236900009],
            [20.466688273000102, 42.90950083400007],
            [20.488909139000043, 42.89919138600008],
            [20.494366526000135, 42.88746653100013],
            [20.49883101400013, 42.877874858],
            [20.47630008900012, 42.855524801000016],
            [20.4280343020001, 42.84064198800006],
            [20.345352010000028, 42.827438660000084],
            [20.355170532000102, 42.866170146000016],
            [20.353620239000065, 42.89097483400006],
            [20.337083781000075, 42.906968689000095],
            [20.275588827000064, 42.92988718700012],
            [20.223188924000056, 42.957663269000065],
            [20.19456018100007, 42.96683583600007],
            [20.140920044000097, 42.97081492200003],
            [20.129464296000094, 42.97360479100003],
            [20.116942179000063, 42.97665435800003],
            [20.056344255000113, 43.02079597800004],
            [20.05438842400011, 43.022220673000064],
            [20.019893840000094, 43.04734771800004],
            [19.959742472000073, 43.07856028200011],
            [19.949820598000144, 43.08592417400011],
            [19.942275838000114, 43.09563934300006],
            [19.936591431000068, 43.10589711600004],
            [19.929150024000137, 43.11390696300002],
            [19.91664432800013, 43.11705922500006],
            [19.907135864000054, 43.11326100700005],
            [19.883778117000105, 43.095691020000075],
            [19.87220259600008, 43.090368348000126],
            [19.83830285600007, 43.08835296700006],
            [19.80512658700013, 43.0899549360001],
            [19.781768839000108, 43.09646616600007],
            [19.761201619000104, 43.108739319],
            [19.74280481000011, 43.12651601200004],
            [19.713555949000067, 43.16560923300007],
            [19.70549442500007, 43.166177673000035],
            [19.697329549000074, 43.16020904600002],
            [19.684617147000097, 43.15672088700005],
            [19.66301639800014, 43.15850372300004],
            [19.6186780190001, 43.16824473100009],
            [19.598110799000096, 43.17620290200004],
            [19.58085087100011, 43.187804261000096],
            [19.5499483640001, 43.21751820900006],
            [19.54784473600006, 43.21881486600007],
            [19.512431274000107, 43.24064341300006],
            [19.502302693000075, 43.251934713000125],
            [19.485146118000102, 43.28009836900007],
            [19.473053833000108, 43.29327585900005],
            [19.414039347000084, 43.338389384000024],
            [19.372284790000037, 43.384226379000054],
            [19.355644979000118, 43.39306304900008],
            [19.21839237500012, 43.43820241300004],
            [19.19224410000004, 43.45453216500006],
            [19.175914347000088, 43.48088714600003],
            [19.17519087700009, 43.50961924300013],
            [19.195344686000055, 43.53279612200005],
            [19.217462199000067, 43.53279612200005],
            [19.229451131000133, 43.54974599200004],
            [19.238856242000082, 43.57212188700002],
            [19.252705525000067, 43.588632507000014],
            [19.26366093000013, 43.590957947000035],
            [19.289189087000068, 43.5879348750001],
            [19.300867960000033, 43.58829661100002],
            [19.312650187000145, 43.593154195000025],
            [19.335801228000037, 43.60651255300006],
            [19.346549926000137, 43.60883799200009],
            [19.363396443000113, 43.60157745400004],
            [19.38044966600006, 43.58558359800007],
            [19.394609009000106, 43.56646331800009],
            [19.402877238000144, 43.54964263900011],
            [19.410732056000086, 43.54075429300009],
            [19.41931034400011, 43.549255067],
            [19.431816040000115, 43.571140035000056],
            [19.44390832500011, 43.57186350600004],
            [19.48173547300007, 43.56083058700004],
            [19.4895902910001, 43.564447937000025],
            [19.491760702000107, 43.56860789000005],
            [19.488970174000144, 43.57318125500011],
            [19.48173547300007, 43.578116353000055],
            [19.476877889000065, 43.58868418400003],
            [19.47563765400011, 43.60255930600009],
            [19.477498006000133, 43.61697703],
            [19.48173547300007, 43.62891428700006],
            [19.507366984000043, 43.647181905000096],
            [19.505713338000106, 43.67364023900011],
            [19.48173547300007, 43.7292182420001],
            [19.46168501800014, 43.76213612900004],
            [19.359469035000075, 43.842208761],
            [19.305932251000115, 43.904737244],
            [19.275443156000023, 43.93326263400006],
            [19.241026652000073, 43.95235707700003],
            [19.22934777800009, 43.957679748000075],
            [19.240716594000105, 43.96574127200007],
            [19.242887003000078, 43.972820944],
            [19.238132771000096, 43.98537831600002],
            [19.23802941900007, 43.99250966400005],
            [19.24350712100005, 44.00201812800013],
            [19.252085409000074, 44.007495830000025],
            [19.272755981000103, 44.01240509000006],
            [19.287328735000074, 44.01302520800003],
            [19.300557902000065, 44.00951121000007],
            [19.32587935400005, 43.996592102000065],
            [19.351717570000062, 43.979125468000106],
            [19.364636678000068, 43.97328603100003],
            [19.37910607900008, 43.97385447200007],
            [19.39398889200004, 43.977058411000044],
            [19.447112264000083, 43.979797262],
            [19.504059692000055, 43.97566314700008],
            [19.528554321000087, 43.977213441000075],
            [19.55222212700005, 43.98341461200006],
            [19.593356567000114, 44.005583802],
            [19.610409790000034, 44.01927805700002],
            [19.618884725000044, 44.035711161000066],
            [19.611443319000017, 44.05452138300008],
            [19.598937622000022, 44.06258290600009],
            [19.589945923000073, 44.06030914400007],
            [19.58384810400011, 44.05431467800004],
            [19.580230753000137, 44.05152415000008],
            [19.570928995000116, 44.05689849900004],
            [19.55459924300007, 44.07126454700004],
            [19.52204309100003, 44.085010478000086],
            [19.516189487000133, 44.09119350600007],
            [19.498168579000037, 44.11022857700003],
            [19.482665649000126, 44.120667217000076],
            [19.47636112500004, 44.127023417000075],
            [19.474190714000116, 44.14490346300006],
            [19.46571577900002, 44.152809957],
            [19.459721313000102, 44.15270660400007],
            [19.448455851000034, 44.144438375000036],
            [19.442564738000044, 44.14319814],
            [19.435536743000114, 44.14609202100006],
            [19.424891398000028, 44.15379181000007],
            [19.381173136000143, 44.17709788000009],
            [19.362362915000062, 44.191205547000024],
            [19.356058390000044, 44.20402130100011],
            [19.353991333000067, 44.22433014000002],
            [19.341588989000087, 44.24582753500006],
            [19.3243290610001, 44.26396596300002],
            [19.30737919100011, 44.274197896],
            [19.295907023000098, 44.275799866000014],
            [19.26366093000013, 44.27016713500008],
            [19.249501587000083, 44.270735576000035],
            [19.240716594000105, 44.27269928000008],
            [19.22004602000007, 44.280244039000124],
            [19.177154582000128, 44.28696197600006],
            [19.15700077300005, 44.293576559000044],
            [19.13891402200005, 44.309337871000125],
            [19.116693156000082, 44.34370269800006],
            [19.108941691000098, 44.36364980100008],
            [19.107184693000107, 44.38271840400007],
            [19.115762980000056, 44.403595683000034],
            [19.129612264000116, 44.416153056000056],
            [19.141394490000096, 44.43082916300004],
            [19.143358195000133, 44.45821767200009],
            [19.127338500000093, 44.50255605100004],
            [19.129922323000102, 44.518317363],
            [19.165269002000088, 44.52668894500009],
            [19.173123820000114, 44.53144317700007],
            [19.179635051000105, 44.53826446500004],
            [19.185319458000038, 44.546222636],
            [19.187283162000085, 44.553302307000095],
            [19.186249633000102, 44.56932200200008],
            [19.188316691000068, 44.57603993700009],
            [19.19327762800009, 44.58058746400003],
            [19.20412967900006, 44.58513499000007],
            [19.2086772050001, 44.58839060500004],
            [19.25570275900006, 44.645648092],
            [19.270068807000058, 44.67562042200005],
            [19.277613566000127, 44.684870504000074],
            [19.2882589110001, 44.69303538000007],
            [19.308412720000092, 44.70512766500006],
            [19.31802453600011, 44.71546295200007],
            [19.328359822000095, 44.733963115],
            [19.363706503000117, 44.854627584000085],
            [19.367840617000127, 44.85927846300005],
            [19.373111613000077, 44.86026031500002],
            [19.376625610000104, 44.86299916600005],
            [19.37569543400008, 44.87312774700011],
            [19.37280155400009, 44.88144765300008],
            [19.368667440000053, 44.88713206000001],
            [19.362776327000063, 44.891111145000096],
            [19.3569823040001, 44.895877196000086],
            [19.353164510000056, 44.899017639000036],
            [19.352957805000102, 44.898087463000095],
            [19.35027062900005, 44.89700225900002],
            [19.340142049000093, 44.89622711200009],
            [19.330220174000118, 44.89870758100007],
            [19.310169718000054, 44.91235015900007],
            [19.301281372000062, 44.91235015900007],
            [19.29301314300011, 44.909404602000066],
            [19.283814738000103, 44.90837107300008],
            [19.239476359000065, 44.91514068700003],
            [19.22955448400006, 44.91374542300004],
            [19.211881144000074, 44.90837107300008],
            [19.201855916000028, 44.90837107300008],
            [19.196894979000092, 44.913176982],
            [19.193174276000065, 44.92154856400008],
            [19.186869751000074, 44.92754303],
            [19.174260701000037, 44.92542429700002],
            [19.084550415000052, 44.87896718400002],
            [19.068427368000073, 44.874833069000076],
            [19.047756795000055, 44.8727143360001],
            [19.015820760000082, 44.86563466400007],
            [18.994323364000138, 44.894831848000095],
            [18.991429484000065, 44.91493398000007],
            [19.0184045820001, 44.925682678],
            [19.03194380700006, 44.92263376900006],
            [19.052097615000037, 44.906975810000105],
            [19.066670369000093, 44.90568389900007],
            [19.078659302000062, 44.91085154200006],
            [19.08785770700007, 44.91932647700007],
            [19.103567342000133, 44.93824005100002],
            [19.113075806000012, 44.94242584200005],
            [19.12454797300012, 44.945939840000094],
            [19.131679321000064, 44.95317454000006],
            [19.12764856000007, 44.96841908800009],
            [19.118553507000087, 44.975550436000034],
            [19.098089640000126, 44.97002105700004],
            [19.087237589000097, 44.97710072800005],
            [19.085170533000024, 44.98728098600013],
            [19.088477824000023, 44.999476623000035],
            [19.093232055000016, 45.01151723300002],
            [19.09540246600011, 45.020922343000066],
            [19.094265584000112, 45.031412659000026],
            [19.085997355000046, 45.06091990200004],
            [19.082276652000132, 45.08494944300007],
            [19.079176066000088, 45.094612936],
            [19.071527954000118, 45.10706695600008],
            [19.06408654800009, 45.113578186000055],
            [19.054164673000116, 45.12060618100004],
            [19.046206502000132, 45.128357646000055],
            [19.044862915000067, 45.137245993000064],
            [19.060055786000106, 45.146857809],
            [19.116073039000128, 45.14287872400011],
            [19.137673787000097, 45.14603098600007],
            [19.14170454900008, 45.16215403200003],
            [19.128785441000076, 45.18106760700009],
            [19.121860799000103, 45.19579539000007],
            [19.143874959000073, 45.1995160930001],
            [19.155760539000113, 45.19496856700006],
            [19.17457076000011, 45.17579661100005],
            [19.185319458000038, 45.16804514600004],
            [19.204543091000062, 45.16287750300005],
            [19.225937133000087, 45.16194732700008],
            [19.267795044000138, 45.16582305900003],
            [19.272755981000103, 45.168355205000026],
            [19.275753215000123, 45.17285105400005],
            [19.27947391800012, 45.177243551000046],
            [19.28670861800009, 45.17951731400005],
            [19.291359497000144, 45.17770863900007],
            [19.29942102000004, 45.168975322000094],
            [19.304278605000064, 45.16654653000005],
            [19.39068160000005, 45.16933705700008],
            [19.393929400000104, 45.17162424000007],
            [19.40535770700012, 45.179672343],
            [19.40783817500011, 45.20313344400007],
            [19.397296183000037, 45.223287253000066],
            [19.3780725500001, 45.22959177700007],
            [19.289749828046425, 45.236310130920906],
            [19.259906946745797, 45.24297299844372],
            [19.197179086357888, 45.264922815722535],
            [19.158482332733676, 45.27617137937752],
            [19.1041470909989, 45.29872565166281],
            [19.098813110000037, 45.31987050400009],
            [19.09622928900012, 45.32912058500001],
            [19.08295634672233, 45.33922435741553],
            [19.067199126619247, 45.343425395500674],
            [19.052942637832235, 45.34539523149766],
            [19.03023976194655, 45.34513680936867],
            [19.01416241931824, 45.3534226579868],
            [19.00752271265713, 45.35953414166431],
            [18.996434054757348, 45.362087840347755],
            [18.995688265962187, 45.36225959007709],
            [18.97749138712034, 45.371208750191805],
            [18.97552740798483, 45.39112963434833],
            [18.997352280168116, 45.39977478124705],
            [19.02261964664812, 45.402391896848464],
            [19.031318659791033, 45.4162010447496],
            [19.01643270784189, 45.43355784154464],
            [19.002282341656723, 45.443686428385945],
            [18.997144016269534, 45.45551694122265],
            [18.996390422000104, 45.473814596000025],
            [19.009619588000106, 45.49867095900008],
            [19.01792614700011, 45.49780728000012],
            [19.07721236200007, 45.491642965000054],
            [19.106254517000053, 45.51164174500009],
            [19.09509240700004, 45.52605946900012],
            [19.082276652000132, 45.53117543600011],
            [19.06780725100012, 45.5333975220001],
            [19.05096073400003, 45.53892690000002],
            [19.04093550600001, 45.54502471900007],
            [19.0364913330001, 45.54946889300008],
            [19.033390747000055, 45.554636536],
            [19.02718957500008, 45.56259470700006],
            [19.018094523000116, 45.56740061400005],
            [19.009206177000095, 45.56548858600003],
            [19.00062788900007, 45.56119944300006],
            [18.983161255000113, 45.5547398880001],
            [18.973136027000095, 45.54626495400002],
            [18.96021691900009, 45.53913360700007],
            [18.94171675700005, 45.53892690000002],
            [18.932001586000098, 45.54554148400011],
            [18.912054484000095, 45.56822743800008],
            [18.903579549000085, 45.573085022],
            [18.906990194000116, 45.581663310000025],
            [18.908230428000138, 45.60042185500002],
            [18.91236454200009, 45.619232076000046],
            [18.924456828000075, 45.62770701100003],
            [18.935412231000043, 45.63339141900009],
            [18.962904093000105, 45.660108134000055],
            [18.968485148000127, 45.66873809800008],
            [18.962697388000066, 45.68305247000008],
            [18.948124634000095, 45.6920441700001],
            [18.93107141100006, 45.69891713500009],
            [18.917325480000045, 45.70656524700006],
            [18.90895389800005, 45.719432679000064],
            [18.90481978400004, 45.7497667440001],
            [18.900168904000054, 45.76490793900011],
            [18.871126750000087, 45.78997100900004],
            [18.86399540200003, 45.798549297000065],
            [18.84869917800009, 45.80955637600006],
            [18.84497847500006, 45.81570587200012],
            [18.84673547400004, 45.81999501600008],
            [18.85035282400011, 45.824232483000046],
            [18.85241988100009, 45.83007192000012],
            [18.855313761000076, 45.85735707600013],
            [18.88714644300012, 45.85947581],
            [18.899755493000043, 45.86138783800003],
            [18.906990194000116, 45.8679507450001],
            [18.903992960000096, 45.87570221000003],
            [18.893450969000128, 45.88386708600005],
            [18.87288374800005, 45.89523590100002],
            [18.881978800000127, 45.90262563100005],
            [18.889833619000058, 45.907896627000056],
            [18.906990194000116, 45.915699768000096],
            [18.90130578600008, 45.931202698],
            [18.962697388000066, 45.927947083],
            [18.981817668000133, 45.921849264000045],
            [18.987502076000084, 45.923812969],
            [18.988742310000134, 45.927016907000066],
            [18.9864685470001, 45.93125437500002],
            [18.978820434000028, 45.93978098600003],
            [18.977683553000134, 45.94350168900003],
            [18.9787170810001, 45.94717071600003],
            [18.981817668000133, 45.9507880660001],
            [19.00558882700011, 45.96257029300001],
            [19.030910279000096, 45.96003814700005],
            [19.048583618000094, 45.96344879200005],
            [19.04972050000009, 45.99311106400002],
            [19.06543013500007, 46.01202463800006],
            [19.088477824000023, 46.0188459270001],
            [19.111008748000046, 46.01295481400011],
            [19.125788208000074, 45.99326609300006],
            [19.125788208000074, 45.99311106400002],
            [19.1480090740001, 45.98406768800005],
            [19.23565230300011, 45.977711487000036],
            [19.263454223000082, 45.981432190000035],
            [19.27482303900007, 45.99161244800011],
            [19.27947391800012, 46.003808086000035],
            [19.286915324000063, 46.016158753000084],
            [19.298314567000062, 46.02212279000007],
            [19.30696577900008, 46.02664906900013],
            [19.32515588400014, 46.02949127300009],
            [19.36215620900009, 46.02964630100006],
            [19.378899373000138, 46.03367706400003],
            [19.389131307000127, 46.04153188100007],
            [19.396572713000126, 46.0515571080001],
            [19.404737590000053, 46.06023875000007],
            [19.417243286000144, 46.06432118800008],
            [19.428302043000144, 46.065509746000075],
            [19.436880330000093, 46.06799021400006],
            [19.45372684700007, 46.07755035500007],
            [19.4608581950001, 46.084474996000054],
            [19.46592248500008, 46.09196807900007],
            [19.472950480000094, 46.098686016],
            [19.499305461000063, 46.1086078900001],
            [19.496721639000043, 46.11687612000004],
            [19.489280233000045, 46.126022848000034],
            [19.487523234000065, 46.13423940100007],
            [19.50199263500008, 46.14560821500005],
            [19.5252470290001, 46.15640859000008],
            [19.5499483640001, 46.164160055000096],
            [19.568448527000044, 46.1664338180001],
            [19.589739217000044, 46.165968730000074],
            [19.6478235270001, 46.17387522400013],
            [19.669320923000043, 46.17310007700003],
            [19.690094848000086, 46.168397522000035],
            [19.711888678000065, 46.15870986600008],
            [19.772983846000102, 46.13155222600004],
            [19.79045048000006, 46.12907175800005],
            [19.873648872000103, 46.15299238600004],
            [19.888945760000126, 46.15739044200005],
            [19.929150024000137, 46.16353993800003],
            [19.993125447000125, 46.159405823],
            [20.0349833570001, 46.14297271800005],
            [20.06340539600012, 46.145298157000056],
            [20.088623495000064, 46.15413482700008],
            [20.09844201700014, 46.15496165000009],
            [20.114771769000072, 46.15222279900006],
            [20.120146118000036, 46.14922556600003],
            [20.130378051000037, 46.13935536800007],
            [20.13802616400011, 46.13646148700006],
            [20.145364217000093, 46.137081604000045],
            [20.17047896400001, 46.14550486200004],
            [20.18846236100009, 46.14038889600003],
            [20.24282596900008, 46.10809112600005],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Croatia',
        iso3: 'HRV',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [16.515301554000075, 46.50171051000011],
              [16.52108931500007, 46.49853241000004],
              [16.56429081200008, 46.47992889400008],
              [16.577623332000115, 46.47065297500008],
              [16.583721151000077, 46.47065297500008],
              [16.58806197100006, 46.4795671590001],
              [16.59426314300012, 46.4829778040001],
              [16.602117960000072, 46.482047628000075],
              [16.611109660000096, 46.47806854200009],
              [16.637671346000047, 46.474477031],
              [16.65927209500009, 46.46419342100002],
              [16.677462199000047, 46.44869049100002],
              [16.69358524600011, 46.42962188800003],
              [16.712395467000135, 46.41267201800012],
              [16.742884562000114, 46.39962371800006],
              [16.755080200000123, 46.381872864000044],
              [16.76190148900008, 46.381872864000044],
              [16.769342895000108, 46.396109721000116],
              [16.776474243000052, 46.39287994400003],
              [16.80344934100006, 46.38869415300009],
              [16.807893514000085, 46.38735056600005],
              [16.81233768700008, 46.385025127000105],
              [16.816575154000134, 46.38197621700009],
              [16.820915975000105, 46.37810048500002],
              [16.82753055800012, 46.37401804600002],
              [16.83021773200005, 46.37735117600003],
              [16.83238814300003, 46.38192454100006],
              [16.837659139000067, 46.381872864000044],
              [16.850474894000058, 46.37306203200005],
              [16.859410685000086, 46.36475790900006],
              [16.865461060000115, 46.35913523400008],
              [16.875072876000047, 46.34285715800006],
              [16.87176558400003, 46.32719919900008],
              [16.879311877000134, 46.312061961000055],
              [16.889232218000075, 46.29216257800006],
              [16.89605350700012, 46.28627146400008],
              [16.903288208000106, 46.2819306440001],
              [16.940701945000058, 46.25149322600002],
              [16.965299926000057, 46.21945383700002],
              [16.974808390000135, 46.21056549100011],
              [17.028035116000098, 46.18048980800005],
              [17.036303344000146, 46.17299672500009],
              [17.0412642820001, 46.16219635100005],
              [17.052943156000055, 46.153463033],
              [17.101208943000074, 46.128193258000024],
              [17.116195109000046, 46.123128967000056],
              [17.19732710800008, 46.121165263000094],
              [17.208592570000064, 46.11656606000007],
              [17.248590128000018, 46.080237529],
              [17.25406783000011, 46.07083241800005],
              [17.266573527000105, 46.038793030000036],
              [17.268950643000068, 46.02871612600008],
              [17.27587528500004, 46.01202463800006],
              [17.291481567000062, 46.007942200000045],
              [17.3078113200001, 46.00639190700012],
              [17.316803019000048, 45.99765859000006],
              [17.309361613000135, 45.996625061000074],
              [17.29695927000006, 45.99264597600008],
              [17.29013798000011, 45.99145741800008],
              [17.29013798000011, 45.98463612900012],
              [17.304814087000096, 45.981018778000035],
              [17.306613213000105, 45.979914052000126],
              [17.316596314000094, 45.973784078000065],
              [17.32713830600005, 45.97202707999999],
              [17.337887003000077, 45.98463612900012],
              [17.34367476400007, 45.96753123000006],
              [17.34212447100012, 45.95864288300005],
              [17.345328410000093, 45.95569732700007],
              [17.36527551200004, 45.95673085500003],
              [17.389150024000116, 45.96308705700007],
              [17.399692017000064, 45.959934794],
              [17.406203247000036, 45.94365671800007],
              [17.411577596000114, 45.946602275000075],
              [17.415401652000128, 45.949702860000016],
              [17.4181921790001, 45.95301015200003],
              [17.42666711400011, 45.95673085500003],
              [17.51193322800006, 45.95394032800009],
              [17.55430790200009, 45.94779083200011],
              [17.59110152100007, 45.93621531200007],
              [17.638437134000128, 45.90133372000007],
              [17.64577518700014, 45.891825256000104],
              [17.646912069000052, 45.883712057000096],
              [17.652079712000045, 45.868829244000054],
              [17.653216593000053, 45.85735707600013],
              [17.654669375000083, 45.85211344100004],
              [17.65652388500007, 45.84541982000009],
              [17.664688761000065, 45.84164744100006],
              [17.687323038000045, 45.84061391300007],
              [17.809176066000134, 45.81441396100006],
              [17.83821822100012, 45.79963450100006],
              [17.857958618000083, 45.775863342],
              [17.858061971000012, 45.77172922800007],
              [17.870050903000077, 45.77348622600006],
              [17.875735311000113, 45.780669251000106],
              [17.880489542000106, 45.78852406800003],
              [17.889791300000127, 45.7921414180001],
              [17.906234389000133, 45.7921414180001],
              [17.9753674720001, 45.7921414180001],
              [18.08047733500004, 45.77172922800007],
              [18.092052856000095, 45.77172922800007],
              [18.10290490700004, 45.77462310800006],
              [18.12016483500014, 45.78340810200005],
              [18.128949829000106, 45.78537180600007],
              [18.211218709000065, 45.78537180600007],
              [18.229822225000134, 45.78123769200006],
              [18.260518026000057, 45.765114644000064],
              [18.283255655000062, 45.76490793900011],
              [18.30051558400004, 45.751833802000064],
              [18.317672160000086, 45.74728627500012],
              [18.334932088000073, 45.751988831000105],
              [18.351158488000095, 45.75839670900005],
              [18.367178182000146, 45.758190003],
              [18.383817993000065, 45.743203837000024],
              [18.38412805200005, 45.743100484000095],
              [18.390742635000066, 45.741808574000046],
              [18.39756392400011, 45.74134348600002],
              [18.40438521300007, 45.741808574000046],
              [18.411723267000042, 45.743203837000024],
              [18.430740194000123, 45.75364247700004],
              [18.46546675600007, 45.78371816000002],
              [18.481796509000077, 45.791417949000035],
              [18.504224081000075, 45.784028219],
              [18.530269002000068, 45.79084950800005],
              [18.57347049900011, 45.81668772400009],
              [18.58545943200005, 45.82691965800005],
              [18.60737023900012, 45.85668528200004],
              [18.62214969900012, 45.86841583300004],
              [18.623596639000112, 45.86867421500001],
              [18.626283813000043, 45.874823711],
              [18.629281046000074, 45.886864319000054],
              [18.633001750000062, 45.89192861000002],
              [18.655636027000128, 45.90758656800007],
              [18.6743428960001, 45.91037709600003],
              [18.723848918000073, 45.89843984],
              [18.763329712000086, 45.883970439000066],
              [18.775525350000095, 45.88283355700007],
              [18.785963989000038, 45.88691599600007],
              [18.790408162000034, 45.89389231400007],
              [18.794852336000133, 45.90303904200006],
              [18.804877563000076, 45.913632711000034],
              [18.81779667200007, 45.905467835000096],
              [18.82245067200003, 45.90558190400013],
              [18.828338664000057, 45.905726217000066],
              [18.84539188700009, 45.913942770000105],
              [18.865442342000023, 45.91807688400003],
              [18.876604452000066, 45.92241770500003],
              [18.88652632700007, 45.9304275520001],
              [18.90130578600008, 45.931202698],
              [18.906990194000116, 45.915699768000096],
              [18.889833619000058, 45.907896627000056],
              [18.881978800000127, 45.90262563100005],
              [18.87288374800005, 45.89523590100002],
              [18.893450969000128, 45.88386708600005],
              [18.903992960000096, 45.87570221000003],
              [18.906990194000116, 45.8679507450001],
              [18.899755493000043, 45.86138783800003],
              [18.88714644300012, 45.85947581],
              [18.855313761000076, 45.85735707600013],
              [18.85241988100009, 45.83007192000012],
              [18.85035282400011, 45.824232483000046],
              [18.84673547400004, 45.81999501600008],
              [18.84497847500006, 45.81570587200012],
              [18.84869917800009, 45.80955637600006],
              [18.86399540200003, 45.798549297000065],
              [18.871126750000087, 45.78997100900004],
              [18.900168904000054, 45.76490793900011],
              [18.90481978400004, 45.7497667440001],
              [18.90895389800005, 45.719432679000064],
              [18.917325480000045, 45.70656524700006],
              [18.93107141100006, 45.69891713500009],
              [18.948124634000095, 45.6920441700001],
              [18.962697388000066, 45.68305247000008],
              [18.968485148000127, 45.66873809800008],
              [18.962904093000105, 45.660108134000055],
              [18.935412231000043, 45.63339141900009],
              [18.924456828000075, 45.62770701100003],
              [18.91236454200009, 45.619232076000046],
              [18.908230428000138, 45.60042185500002],
              [18.906990194000116, 45.581663310000025],
              [18.903579549000085, 45.573085022],
              [18.912054484000095, 45.56822743800008],
              [18.932001586000098, 45.54554148400011],
              [18.94171675700005, 45.53892690000002],
              [18.96021691900009, 45.53913360700007],
              [18.973136027000095, 45.54626495400002],
              [18.983161255000113, 45.5547398880001],
              [19.00062788900007, 45.56119944300006],
              [19.009206177000095, 45.56548858600003],
              [19.018094523000116, 45.56740061400005],
              [19.02718957500008, 45.56259470700006],
              [19.033390747000055, 45.554636536],
              [19.0364913330001, 45.54946889300008],
              [19.04093550600001, 45.54502471900007],
              [19.05096073400003, 45.53892690000002],
              [19.06780725100012, 45.5333975220001],
              [19.082276652000132, 45.53117543600011],
              [19.09509240700004, 45.52605946900012],
              [19.106254517000053, 45.51164174500009],
              [19.07721236200007, 45.491642965000054],
              [19.01792614700011, 45.49780728000012],
              [19.009619588000106, 45.49867095900008],
              [18.996390422000104, 45.473814596000025],
              [18.997144016269534, 45.45551694122265],
              [19.002282341656723, 45.443686428385945],
              [19.01643270784189, 45.43355784154464],
              [19.031318659791033, 45.4162010447496],
              [19.02261964664812, 45.402391896848464],
              [18.997352280168116, 45.39977478124705],
              [18.97552740798483, 45.39112963434833],
              [18.97749138712034, 45.371208750191805],
              [18.995688265962187, 45.36225959007709],
              [18.996434054757348, 45.362087840347755],
              [19.00752271265713, 45.35953414166431],
              [19.01416241931824, 45.3534226579868],
              [19.03023976194655, 45.34513680936867],
              [19.052942637832235, 45.34539523149766],
              [19.067199126619247, 45.343425395500674],
              [19.08295634672233, 45.33922435741553],
              [19.09622928900012, 45.32912058500001],
              [19.098813110000037, 45.31987050400009],
              [19.1041470909989, 45.29872565166281],
              [19.158482332733676, 45.27617137937752],
              [19.197179086357888, 45.264922815722535],
              [19.259906946745797, 45.24297299844372],
              [19.289749828046425, 45.236310130920906],
              [19.3780725500001, 45.22959177700007],
              [19.397296183000037, 45.223287253000066],
              [19.40783817500011, 45.20313344400007],
              [19.40535770700012, 45.179672343],
              [19.393929400000104, 45.17162424000007],
              [19.39068160000005, 45.16933705700008],
              [19.304278605000064, 45.16654653000005],
              [19.29942102000004, 45.168975322000094],
              [19.291359497000144, 45.17770863900007],
              [19.28670861800009, 45.17951731400005],
              [19.27947391800012, 45.177243551000046],
              [19.275753215000123, 45.17285105400005],
              [19.272755981000103, 45.168355205000026],
              [19.267795044000138, 45.16582305900003],
              [19.225937133000087, 45.16194732700008],
              [19.204543091000062, 45.16287750300005],
              [19.185319458000038, 45.16804514600004],
              [19.17457076000011, 45.17579661100005],
              [19.155760539000113, 45.19496856700006],
              [19.143874959000073, 45.1995160930001],
              [19.121860799000103, 45.19579539000007],
              [19.128785441000076, 45.18106760700009],
              [19.14170454900008, 45.16215403200003],
              [19.137673787000097, 45.14603098600007],
              [19.116073039000128, 45.14287872400011],
              [19.060055786000106, 45.146857809],
              [19.044862915000067, 45.137245993000064],
              [19.046206502000132, 45.128357646000055],
              [19.054164673000116, 45.12060618100004],
              [19.06408654800009, 45.113578186000055],
              [19.071527954000118, 45.10706695600008],
              [19.079176066000088, 45.094612936],
              [19.082276652000132, 45.08494944300007],
              [19.085997355000046, 45.06091990200004],
              [19.094265584000112, 45.031412659000026],
              [19.09540246600011, 45.020922343000066],
              [19.093232055000016, 45.01151723300002],
              [19.088477824000023, 44.999476623000035],
              [19.085170533000024, 44.98728098600013],
              [19.087237589000097, 44.97710072800005],
              [19.098089640000126, 44.97002105700004],
              [19.118553507000087, 44.975550436000034],
              [19.12764856000007, 44.96841908800009],
              [19.131679321000064, 44.95317454000006],
              [19.12454797300012, 44.945939840000094],
              [19.113075806000012, 44.94242584200005],
              [19.103567342000133, 44.93824005100002],
              [19.08785770700007, 44.91932647700007],
              [19.078659302000062, 44.91085154200006],
              [19.066670369000093, 44.90568389900007],
              [19.052097615000037, 44.906975810000105],
              [19.03194380700006, 44.92263376900006],
              [19.0184045820001, 44.925682678],
              [18.991429484000065, 44.91493398000007],
              [18.994323364000138, 44.894831848000095],
              [19.015820760000082, 44.86563466400007],
              [19.00496870900014, 44.86330922500004],
              [18.974915914052342, 44.86275717986024],
              [18.889626912000097, 44.86119049100007],
              [18.858724406000107, 44.868528545000075],
              [18.842129476000054, 44.87623932000007],
              [18.81779667200007, 44.88754547200004],
              [18.783380167000132, 44.91374542300004],
              [18.772631469000117, 44.942477519000064],
              [18.779866170000076, 44.952244364000094],
              [18.801570271000088, 44.963974915000094],
              [18.80456750500008, 44.97384511300008],
              [18.80301721200007, 44.977307435000014],
              [18.797952921000103, 44.98221669500005],
              [18.795782512000102, 44.98505889900012],
              [18.795162394000045, 44.98800445600004],
              [18.795162394000045, 44.993327129000065],
              [18.794645630000105, 44.99544586200004],
              [18.7917517490001, 45.001543681],
              [18.78896122200004, 45.005729472000056],
              [18.784930461000044, 45.00846832300009],
              [18.77800581900007, 45.01032867400009],
              [18.750100546000084, 45.0122407030001],
              [18.738318319000086, 45.015909729],
              [18.726329386000117, 45.026141663],
              [18.689019002000094, 45.080246888],
              [18.684058065000045, 45.08479441400003],
              [18.678166951000037, 45.08737823500003],
              [18.67134566200008, 45.08686147000007],
              [18.66607466600007, 45.08298573900002],
              [18.663284139000098, 45.07714630100004],
              [18.661217082000036, 45.071100159000096],
              [18.658116495000087, 45.0662942500001],
              [18.648711385000126, 45.06267690000003],
              [18.640546509000018, 45.06536407500003],
              [18.633621867000045, 45.07197865800005],
              [18.627937459000094, 45.08004018200005],
              [18.62111617000005, 45.093114319000094],
              [18.61667199700014, 45.09766184500002],
              [18.6091272380001, 45.100090637000065],
              [18.602512654000094, 45.09926381500004],
              [18.588560018000095, 45.09321767200002],
              [18.581842082000065, 45.09135732100002],
              [18.573780558000095, 45.09156402600006],
              [18.557657511000087, 45.09440623000005],
              [18.549595988000107, 45.09476796500003],
              [18.53491988100012, 45.09042714500005],
              [18.534802705000118, 45.0884117180001],
              [18.534403117000096, 45.08153879900003],
              [18.539260702000092, 45.06934316000003],
              [18.541121053000097, 45.0552871710001],
              [18.517039835000077, 45.05585561200006],
              [18.49078820800014, 45.06278025300004],
              [18.48170818400007, 45.066921352000065],
              [18.46608687300011, 45.0740457160001],
              [18.45182985200009, 45.08495874500004],
              [18.42929325400013, 45.10220937200005],
              [18.41203332500004, 45.11244130500005],
              [18.392913045000057, 45.11864247600003],
              [18.322323039000054, 45.122879944000076],
              [18.307440227000114, 45.12753082300013],
              [18.26196496600005, 45.150681865000124],
              [18.237883748000115, 45.157451477000066],
              [18.213285766000126, 45.153782450000065],
              [18.202330363000073, 45.144067281000034],
              [18.20005659900005, 45.131613262000045],
              [18.199333130000127, 45.119004212000036],
              [18.192511841000083, 45.108513896000076],
              [18.17494185400011, 45.100762431000064],
              [18.153651164000024, 45.09755849300008],
              [18.143698040000118, 45.09770000500008],
              [18.131843709000094, 45.097868551000076],
              [18.112413371000116, 45.10060740200002],
              [18.090295857000115, 45.10799713100003],
              [18.03500207500008, 45.143343812000026],
              [18.019085734000072, 45.14944163100007],
              [18.003479451000118, 45.14933827800006],
              [17.98849328600005, 45.14380890000005],
              [17.927721802000036, 45.092029114000084],
              [17.911185343000056, 45.08107371100003],
              [17.902607056000107, 45.077766419000014],
              [17.87521854600007, 45.073994039000084],
              [17.845659628000135, 45.065260723],
              [17.835737752000057, 45.06443389900009],
              [17.815583944000082, 45.07016998300004],
              [17.797497193000055, 45.08195221000004],
              [17.741376587000104, 45.13326690700008],
              [17.71450484200011, 45.152025452000075],
              [17.68473921700013, 45.16396270800003],
              [17.651562948000105, 45.165357971],
              [17.629962199000147, 45.15734812500004],
              [17.593065226000107, 45.129597880000105],
              [17.57239465300009, 45.120399476],
              [17.56143925000012, 45.11936594700002],
              [17.53952844300008, 45.120967916000055],
              [17.48929895000012, 45.11626536100006],
              [17.481857544000093, 45.114405009000066],
              [17.487025187000114, 45.12086456400003],
              [17.496223592000092, 45.14169016500007],
              [17.4723490800001, 45.13275014200006],
              [17.460360148000063, 45.13125152600004],
              [17.44775109900013, 45.13430043600006],
              [17.4549857990001, 45.14060496000009],
              [17.45808638500006, 45.146134339000085],
              [17.456949503000118, 45.151818746000046],
              [17.451161743000057, 45.15848500600005],
              [17.443306925000115, 45.16205068],
              [17.438759399000077, 45.158123271000036],
              [17.436175578000075, 45.15192209900006],
              [17.434108520000024, 45.148563131000046],
              [17.40082889800007, 45.14101837200009],
              [17.382432088000087, 45.13962310900003],
              [17.368582804000113, 45.1451008100001],
              [17.359384399000106, 45.150681865000124],
              [17.32651818800008, 45.165926412000076],
              [17.3078113200001, 45.171404115000044],
              [17.268950643000068, 45.18954254200007],
              [17.24972701000013, 45.15988026900003],
              [17.245489543000076, 45.15538442000009],
              [17.197843872000135, 45.15295562800004],
              [17.18709517400012, 45.148563131000046],
              [17.124628433000083, 45.16905775500008],
              [17.0984184160001, 45.17765696200006],
              [17.055733683000113, 45.20044626900004],
              [17.036303344000146, 45.230470276000105],
              [17.03020552500007, 45.22695627900005],
              [17.014392537000077, 45.219773255000106],
              [17.008294718000116, 45.216155905],
              [17.012532186000072, 45.22447581000007],
              [17.013565715000055, 45.230573629000034],
              [17.012015421000058, 45.236464742000024],
              [17.008294718000116, 45.24416453100012],
              [16.998682902000013, 45.231400452000045],
              [16.988140909000066, 45.23651641900004],
              [16.975945271000057, 45.24716176400004],
              [16.96116581200002, 45.250934143000066],
              [16.965299926000057, 45.244216207000036],
              [16.96798710100009, 45.23729156600005],
              [16.947316529000148, 45.23568959600003],
              [16.941528768000097, 45.241218974000034],
              [16.94214888500005, 45.249848939000074],
              [16.940701945000058, 45.257755433000014],
              [16.932640421000087, 45.27878774100013],
              [16.924372193000124, 45.28452382500008],
              [16.896983683000087, 45.268142396000044],
              [16.893986450000085, 45.263543192],
              [16.885821574000147, 45.25522328700002],
              [16.87538293500012, 45.24695505800007],
              [16.86732141100012, 45.243389385000015],
              [16.861740357000116, 45.23222727400007],
              [16.851921834000052, 45.227421367000076],
              [16.84075972500011, 45.224010722000045],
              [16.830734497000094, 45.21698272700003],
              [16.825050089000058, 45.205045472000094],
              [16.82577356000013, 45.19636383100003],
              [16.824223266000104, 45.18907745400007],
              [16.811717570000013, 45.18122263700012],
              [16.7862927650001, 45.17884552100007],
              [16.587028443000065, 45.22085846],
              [16.528944133000095, 45.22225372400008],
              [16.48191857900011, 45.1995160930001],
              [16.449155721000096, 45.14809804300002],
              [16.435513143000094, 45.13285349600007],
              [16.42476444500008, 45.12727244100007],
              [16.39851281700004, 45.12143300400008],
              [16.389211060000036, 45.11683380100003],
              [16.381769654000095, 45.10758372000002],
              [16.38197635900005, 45.10195098900009],
              [16.38404341600011, 45.09543975900003],
              [16.38197635900005, 45.08370920800003],
              [16.37732548000008, 45.07559600900002],
              [16.35696496600005, 45.0486209110001],
              [16.346019392000073, 45.02001001200006],
              [16.34063521300004, 45.005936178000084],
              [16.31624393700008, 45.00123362300012],
              [16.27934696500006, 45.00717641200005],
              [16.241209757000092, 45.01895863900005],
              [16.212994426000137, 45.031464335000024],
              [16.121527140000097, 45.09616322900011],
              [16.104060506000053, 45.11254465800006],
              [16.082769816000052, 45.151612041000064],
              [16.067473592000113, 45.16959543900008],
              [16.054967896000107, 45.176416728000035],
              [16.033057088000135, 45.17972402000002],
              [16.024375447000097, 45.18432322200006],
              [16.02499556500007, 45.18892242500003],
              [16.028716268000068, 45.19626047800001],
              [16.029233032, 45.205045472000094],
              [16.020448039000115, 45.21393381800003],
              [16.00845910600006, 45.218171285000054],
              [15.997503703000092, 45.218533021000056],
              [15.974559367000069, 45.21538075800002],
              [15.878854614000147, 45.21724110900003],
              [15.824801066000077, 45.21098826100011],
              [15.802568519000147, 45.196473382000036],
              [15.792348267000136, 45.18980092400007],
              [15.780979451000064, 45.16799347000004],
              [15.780049276000113, 45.16029368100003],
              [15.783769979000112, 45.100917460000105],
              [15.779429158000141, 45.08536285500007],
              [15.755968059000054, 45.04221303300007],
              [15.755554647000054, 45.023557841000084],
              [15.767440226000076, 44.99322377600005],
              [15.763616170000148, 44.975550436000034],
              [15.738811482000102, 44.944854635000084],
              [15.734108149000065, 44.93444011200002],
              [15.730853312000136, 44.92723297200011],
              [15.734263957000081, 44.9021182260001],
              [15.748009888000098, 44.882016094000036],
              [15.764029581000045, 44.864032695000034],
              [15.773434692000109, 44.84501576800007],
              [15.768680460000013, 44.82734242800008],
              [15.751213827000072, 44.821554667],
              [15.730646607000097, 44.817007142000065],
              [15.716073852000108, 44.80320953400012],
              [15.717314087000148, 44.78646637000007],
              [15.728476196000088, 44.76910308800005],
              [15.75369429500006, 44.73928578700004],
              [15.759275350000053, 44.73416982000005],
              [15.782839803000059, 44.7225943000001],
              [15.790487915000142, 44.71339589500012],
              [15.796999146000104, 44.70326731400006],
              [15.805680786000067, 44.696652730000054],
              [15.820356893000053, 44.698254700000106],
              [15.82996870900007, 44.70052846300011],
              [15.847848755000115, 44.70151031500008],
              [15.856427043000053, 44.703577372000055],
              [15.86386844900008, 44.70998525000009],
              [15.86924279800013, 44.71856353700012],
              [15.876270792000042, 44.72481638600003],
              [15.888776489000065, 44.72424794500007],
              [15.89559777800011, 44.71856353700012],
              [15.899318481000108, 44.709210103000075],
              [15.902005656000142, 44.69882314100006],
              [15.90541630100006, 44.6901415],
              [15.91306441200004, 44.68450876900006],
              [15.921539347000135, 44.686110739000085],
              [15.929807577000105, 44.689469707000015],
              [15.93735233600006, 44.68895294200006],
              [15.948101034000075, 44.67810089100003],
              [15.955645792000013, 44.65319285100004],
              [15.968978312000047, 44.639240214000054],
              [15.979106893000079, 44.63438263000005],
              [15.991612589000084, 44.63143707300004],
              [16.0160038650001, 44.62895660400007],
              [16.028302856000067, 44.624719137000014],
              [16.036157674000094, 44.615314026000064],
              [16.041118612000048, 44.60280833000006],
              [16.044735962000118, 44.589372457000096],
              [16.04318566900011, 44.58844228200006],
              [16.034917440000072, 44.58539337200004],
              [16.030473266000058, 44.572215882000066],
              [16.013936809000143, 44.55702301100003],
              [16.00608199000004, 44.54100331600007],
              [16.0266492100001, 44.52519032800008],
              [16.04731978300012, 44.523329977000074],
              [16.083699991000117, 44.53490549700011],
              [16.104887329000064, 44.532373353000125],
              [16.11646285000012, 44.52146962500005],
              [16.123077433000105, 44.50389963800008],
              [16.12834842900014, 44.48431427100006],
              [16.15294641100013, 44.435066630000094],
              [16.159664347000046, 44.41610138000003],
              [16.159871053000103, 44.40070180300005],
              [16.15387658700007, 44.3935704550001],
              [16.14540165200009, 44.38959137000005],
              [16.138787069000074, 44.38540557900008],
              [16.13827030500005, 44.37760243800007],
              [16.141991008000048, 44.380754700000026],
              [16.153153117000073, 44.38044464200006],
              [16.171343221000114, 44.377085673000025],
              [16.192117146000072, 44.367422181],
              [16.202865844000087, 44.35977406800002],
              [16.20564364200007, 44.35053070800005],
              [16.205863078000107, 44.34980051700002],
              [16.203175903000073, 44.33305735300006],
              [16.199661906000102, 44.32468577100009],
              [16.18953332500007, 44.308511048000085],
              [16.186639445000083, 44.29760732000004],
              [16.18756962000012, 44.28241445000002],
              [16.19707808400011, 44.25115020800011],
              [16.21578495300011, 44.208155416000025],
              [16.23211470500013, 44.19099884000006],
              [16.275522908000113, 44.15735748300004],
              [16.28999230900007, 44.13911570200007],
              [16.312213175000096, 44.09999664400006],
              [16.32688928200008, 44.08237498000007],
              [16.346112915000106, 44.06847401900008],
              [16.35737837700006, 44.06216949500008],
              [16.367196899000135, 44.058138733000064],
              [16.377945597000064, 44.05736358700007],
              [16.403990519000047, 44.058758850000046],
              [16.414015747000064, 44.05581329300004],
              [16.42693485500007, 44.04051707000009],
              [16.43148238100011, 44.02578928700008],
              [16.439647258000036, 44.01400706000008],
              [16.483468872000117, 44.00253489200007],
              [16.50103885900009, 43.99271637],
              [16.516541788000012, 43.97953888000002],
              [16.5274466730001, 43.967859174000054],
              [16.5558158770001, 43.93747426400007],
              [16.604805135000106, 43.901068217],
              [16.637361288000136, 43.86840871200012],
              [16.678599081000044, 43.840684306000085],
              [16.686143839000096, 43.82613739000003],
              [16.68976119000007, 43.80931671200007],
              [16.69823612500008, 43.788077698000095],
              [16.71260217300008, 43.771515401],
              [16.823809855000093, 43.70730743400004],
              [16.98193973800008, 43.5896918750001],
              [17.030515585000074, 43.548479919],
              [17.06231406800012, 43.52774706500007],
              [17.08456913200007, 43.51323659300003],
              [17.142756795000054, 43.489336243000125],
              [17.239495077000043, 43.47840667700005],
              [17.270500936000076, 43.46321380700003],
              [17.286417277000083, 43.43737559],
              [17.2676070550001, 43.353323873000065],
              [17.289931275000043, 43.30343027800002],
              [17.32868859900009, 43.26035797100012],
              [17.36940962800014, 43.23255605100006],
              [17.389666788000056, 43.223099264],
              [17.400208781000117, 43.21604543100007],
              [17.406823365, 43.205425924000096],
              [17.41519494700009, 43.18496205700002],
              [17.42677046700004, 43.165712585000094],
              [17.442066691000093, 43.15243174300009],
              [17.450913270000115, 43.14815159700005],
              [17.58738081800007, 43.08212595700009],
              [17.59802550000009, 43.07290235300003],
              [17.62841190500012, 43.04657257100003],
              [17.659004354000047, 42.99365590500004],
              [17.659107707000146, 42.99363006600005],
              [17.659211060000075, 42.99344919800008],
              [17.6593144120001, 42.99339752200008],
              [17.662725057000046, 42.965698955000065],
              [17.634509724000083, 42.950402731000096],
              [17.58065839900007, 42.94208405200004],
              [17.580088738000086, 42.94232819200005],
              [17.549652540000068, 42.95530833500004],
              [17.53451582100007, 42.95062897300005],
              [17.515635613000086, 42.95888906500005],
              [17.49854576900009, 42.97215403900009],
              [17.488291863000086, 42.98261139500005],
              [17.474619988000086, 43.001166083000044],
              [17.470876498000052, 43.01341380400004],
              [17.479177280000044, 43.02240631700005],
              [17.501963738000086, 43.03099192900004],
              [17.48796634200005, 43.03497955900008],
              [17.47169030000009, 43.030462958000044],
              [17.453379754000082, 43.022772528000075],
              [17.433604363000086, 43.01740143400008],
              [17.440684441000087, 43.019964911000045],
              [17.460215691000087, 43.03099192900004],
              [17.450450066000087, 43.03115469000005],
              [17.440684441000087, 43.03229401200008],
              [17.432302280000044, 43.03620026200008],
              [17.426117384000065, 43.044623114000046],
              [17.433604363000086, 43.05149974200003],
              [17.42741946700005, 43.06085846600007],
              [17.426117384000065, 43.06517161700003],
              [17.404551629000082, 43.05149974200003],
              [17.37086022200009, 43.073879299000055],
              [17.316254102000073, 43.12726471600007],
              [17.17237389400009, 43.18183014500005],
              [17.13803144600007, 43.202337958000044],
              [17.121348504000082, 43.20880768400008],
              [17.113942905000044, 43.21320221600007],
              [17.107758009000065, 43.22638580900008],
              [17.100271030000044, 43.231675523000035],
              [17.090179884000065, 43.23517487200007],
              [17.080088738000086, 43.23651764500005],
              [17.073496941000087, 43.23895905200004],
              [17.066661004000082, 43.24485911700003],
              [17.05632571700005, 43.25698476800005],
              [17.05445397200009, 43.26121653900009],
              [17.051117384000065, 43.27423737200007],
              [17.049489780000044, 43.27802155200004],
              [17.045095248000052, 43.27977122600004],
              [17.032399936000047, 43.28237539300005],
              [17.028168165000068, 43.28424713700008],
              [16.933929884000065, 43.37360260600008],
              [16.90601647200009, 43.38727448100008],
              [16.895762566000087, 43.394598700000074],
              [16.888519727000073, 43.40119049700007],
              [16.88062584700009, 43.405951239000046],
              [16.75245201900009, 43.41950104400007],
              [16.69385826900009, 43.43829987200007],
              [16.625824415000068, 43.44904205900008],
              [16.53484134200005, 43.49713776200008],
              [16.533457879000082, 43.499701239000046],
              [16.53256269600007, 43.504339911000045],
              [16.530039910000085, 43.50877513200004],
              [16.524668816000087, 43.51080963700008],
              [16.51856530000009, 43.50971100500004],
              [16.50953209700009, 43.505072333000044],
              [16.50440514400009, 43.503973700000074],
              [16.46656334700009, 43.51080963700008],
              [16.391449415000068, 43.51080963700008],
              [16.391449415000068, 43.517645575000074],
              [16.411387566000087, 43.51780833500004],
              [16.434255405000044, 43.52187734600005],
              [16.455902540000068, 43.528957424000055],
              [16.473399285000085, 43.53815338700008],
              [16.45679772200009, 43.54588450700004],
              [16.433848504000082, 43.54975006700005],
              [16.336761915000068, 43.55117422100005],
              [16.324961785000085, 43.548529364000046],
              [16.30632571700005, 43.539943752000056],
              [16.29932701900009, 43.53815338700008],
              [16.281097852000073, 43.536037502000056],
              [16.23959394600007, 43.526556708000044],
              [16.11768639400009, 43.52448151200008],
              [16.11768639400009, 43.517645575000074],
              [16.150726759000065, 43.511379299000055],
              [16.164886915000068, 43.50409577000005],
              [16.17237389400009, 43.48969147300005],
              [16.110850457000083, 43.48969147300005],
              [16.113129102000073, 43.47890859600005],
              [16.098480665000068, 43.48004791900007],
              [16.06617272200009, 43.48969147300005],
              [16.03956139400009, 43.49079010600008],
              [16.02833092500009, 43.49494049700007],
              [16.014008009000065, 43.503973700000074],
              [16.007823113000086, 43.503973700000074],
              [16.007823113000086, 43.49713776200008],
              [15.99577884200005, 43.50336334800005],
              [15.973480665000068, 43.503119208000044],
              [15.966319207000083, 43.51080963700008],
              [15.965505405000044, 43.509100653000075],
              [15.965586785000085, 43.50617096600007],
              [15.964366082000083, 43.503892320000034],
              [15.959483269000089, 43.503973700000074],
              [15.961273634000065, 43.51504140800006],
              [15.96656334700009, 43.516913153000075],
              [15.97437584700009, 43.51675039300005],
              [15.983653191000087, 43.52106354400007],
              [15.986989780000044, 43.52728913000004],
              [15.984222852000073, 43.53204987200007],
              [15.982269727000073, 43.53729889500005],
              [15.987315300000091, 43.544907945000034],
              [15.970957879000082, 43.54352448100008],
              [15.965098504000082, 43.54193756700005],
              [15.959483269000089, 43.53815338700008],
              [15.956228061000047, 43.54791901200008],
              [15.948090040000068, 43.55288320500006],
              [15.925303582000083, 43.558579820000034],
              [15.941905144000089, 43.56000397300005],
              [15.944183790000068, 43.56671784100007],
              [15.935394727000073, 43.57294342700004],
              [15.917979363000086, 43.57290273600006],
              [15.917979363000086, 43.57908763200004],
              [15.922618035000085, 43.58112213700008],
              [15.927582227000073, 43.58429596600007],
              [15.932139519000089, 43.58657461100006],
              [15.922129754000082, 43.59198639500005],
              [15.917979363000086, 43.59332916900007],
              [15.925303582000083, 43.59955475500004],
              [15.917979363000086, 43.60639069200005],
              [15.925303582000083, 43.61383698100008],
              [15.918955925000091, 43.62872955900008],
              [15.929535352000073, 43.63422272300005],
              [15.966319207000083, 43.63373444200005],
              [15.966319207000083, 43.64118073100008],
              [15.921397332000083, 43.648138739000046],
              [15.904795769000089, 43.64801666900007],
              [15.916758660000085, 43.653631903000075],
              [15.926605665000068, 43.65302155200004],
              [15.934825066000087, 43.64984772300005],
              [15.942393425000091, 43.64801666900007],
              [15.952972852000073, 43.65086497600004],
              [15.951426629000082, 43.657416083000044],
              [15.942637566000087, 43.66429271000004],
              [15.932139519000089, 43.66844310100004],
              [15.945974155000044, 43.672308661000045],
              [15.952403191000087, 43.679754950000074],
              [15.950450066000087, 43.68854401200008],
              [15.938975457000083, 43.69643789300005],
              [15.939707879000082, 43.67763906500005],
              [15.931162957000083, 43.67649974200003],
              [15.906748894000089, 43.691473700000074],
              [15.892914259000065, 43.700506903000075],
              [15.885996941000087, 43.70034414300005],
              [15.876800977000073, 43.70164622600004],
              [15.87077884200005, 43.703192450000074],
              [15.864512566000087, 43.70815664300005],
              [15.850759311000047, 43.723944403000075],
              [15.844004754000082, 43.72992584800005],
              [15.803477410000085, 43.74640534100007],
              [15.792165561000047, 43.75446198100008],
              [15.771006707000083, 43.75995514500005],
              [15.706309441000087, 43.76341380400004],
              [15.692637566000087, 43.774603583000044],
              [15.682139519000089, 43.79718659100007],
              [15.658457879000082, 43.80508047100005],
              [15.632985873000052, 43.81045156500005],
              [15.617442254000082, 43.825506903000075],
              [15.647308790000068, 43.81586334800005],
              [15.663096550000091, 43.81297435100004],
              [15.678884311000047, 43.811835028000075],
              [15.678884311000047, 43.81928131700005],
              [15.673024936000047, 43.82123444200005],
              [15.668955925000091, 43.82099030200004],
              [15.666758660000085, 43.819973049000055],
              [15.66578209700009, 43.81928131700005],
              [15.638845248000052, 43.83612702000005],
              [15.574066602000073, 43.85952383000006],
              [15.546885613000086, 43.87657298400006],
              [15.545176629000082, 43.87763092700004],
              [15.524912957000083, 43.900458075000074],
              [15.512217644000089, 43.91107819200005],
              [15.49773196700005, 43.91551341400009],
              [15.482432488000086, 43.91714101800005],
              [15.473643425000091, 43.919134833000044],
              [15.466075066000087, 43.92169830900008],
              [15.455088738000086, 43.92804596600007],
              [15.449717644000089, 43.93439362200007],
              [15.445648634000065, 43.94135163000004],
              [15.438731316000087, 43.949652411000045],
              [15.384043816000087, 43.997381903000075],
              [15.358083530000044, 44.02570221600007],
              [15.33961022200009, 44.03937409100007],
              [15.319509311000047, 44.04523346600007],
              [15.277598504000082, 44.08234284100007],
              [15.278330925000091, 44.085598049000055],
              [15.233246290000068, 44.12091705900008],
              [15.22201582100007, 44.12563711100006],
              [15.212901238000086, 44.13104889500005],
              [15.208832227000073, 44.13816966400009],
              [15.212738477000073, 44.14826080900008],
              [15.19695071700005, 44.15648021000004],
              [15.144541863000086, 44.19546133000006],
              [15.160411004000082, 44.21320221600007],
              [15.152191602000073, 44.23529694200005],
              [15.131521030000044, 44.25462474200003],
              [15.110362175000091, 44.26434967700004],
              [15.122243686000047, 44.27480703300006],
              [15.140635613000086, 44.282456773000035],
              [15.15756269600007, 44.28034088700008],
              [15.165049675000091, 44.26121653900009],
              [15.176605665000068, 44.24994538000004],
              [15.197927280000044, 44.25731028900009],
              [15.207774285000085, 44.272772528000075],
              [15.185394727000073, 44.28538646000004],
              [15.19304446700005, 44.28685130400004],
              [15.194183790000068, 44.28864166900007],
              [15.194590691000087, 44.28880442900004],
              [15.199066602000073, 44.28538646000004],
              [15.206553582000083, 44.28538646000004],
              [15.201182488000086, 44.29751211100006],
              [15.198090040000068, 44.301662502000056],
              [15.247569207000083, 44.27798086100006],
              [15.268402540000068, 44.25844961100006],
              [15.279551629000082, 44.25177643400008],
              [15.295258009000065, 44.25067780200004],
              [15.281748894000089, 44.28538646000004],
              [15.290537957000083, 44.28742096600007],
              [15.294932488000086, 44.290228583000044],
              [15.297862175000091, 44.29401276200008],
              [15.302744988000086, 44.29913971600007],
              [15.289317254000082, 44.30219147300005],
              [15.278168165000068, 44.309800523000035],
              [15.26889082100007, 44.32046133000006],
              [15.261241082000083, 44.33258698100008],
              [15.280528191000087, 44.32754140800006],
              [15.308604363000086, 44.30927155200004],
              [15.336924675000091, 44.301662502000056],
              [15.408539259000065, 44.27228424700007],
              [15.424489780000044, 44.26797109600005],
              [15.50359134200005, 44.25922272300005],
              [15.525238477000073, 44.26068756700005],
              [15.52865644600007, 44.27179596600007],
              [15.514821811000047, 44.278509833000044],
              [15.449229363000086, 44.28538646000004],
              [15.444183790000068, 44.28847890800006],
              [15.414073113000086, 44.31655508000006],
              [15.40601647200009, 44.32062409100007],
              [15.30795332100007, 44.354396877000056],
              [15.293793165000068, 44.36481354400007],
              [15.155039910000085, 44.46670156500005],
              [15.108083530000044, 44.51386139500005],
              [15.080088738000086, 44.53607819200005],
              [15.052012566000087, 44.54547760600008],
              [15.047862175000091, 44.55036041900007],
              [15.01531009200005, 44.56907786700003],
              [15.007334832000083, 44.56972890800006],
              [15.00131269600007, 44.57851797100005],
              [14.901377800000091, 44.69017161700003],
              [14.883799675000091, 44.72361888200004],
              [14.895192905000044, 44.73615143400008],
              [14.89389082100007, 44.75096263200004],
              [14.887461785000085, 44.76837799700007],
              [14.883799675000091, 44.788763739000046],
              [14.881358269000089, 44.84406159100007],
              [14.883799675000091, 44.86147695500006],
              [14.905284050000091, 44.92462799700007],
              [14.914886915000068, 44.93992747600004],
              [14.92164147200009, 44.95880768400008],
              [14.914317254000082, 44.98143138200004],
              [14.856455925000091, 45.07648346600007],
              [14.852793816000087, 45.09365469000005],
              [14.842539910000085, 45.105536200000074],
              [14.827403191000087, 45.11395905200004],
              [14.765961134000065, 45.13735586100006],
              [14.65788821700005, 45.196600653000075],
              [14.606700066000087, 45.24437083500004],
              [14.592784050000091, 45.24982330900008],
              [14.576019727000073, 45.26227448100008],
              [14.568614129000082, 45.27594635600008],
              [14.582204623000052, 45.28534577000005],
              [14.570811394000089, 45.29364655200004],
              [14.534353061000047, 45.31268952000005],
              [14.552256707000083, 45.29767487200007],
              [14.555430535000085, 45.29588450700004],
              [14.551931186000047, 45.28807200700004],
              [14.543304884000065, 45.28384023600006],
              [14.533050977000073, 45.28388092700004],
              [14.524424675000091, 45.288763739000046],
              [14.510508660000085, 45.29975006700005],
              [14.402354363000086, 45.33860911700003],
              [14.363617384000065, 45.344631252000056],
              [14.345876498000052, 45.351629950000074],
              [14.32976321700005, 45.35398997600004],
              [14.311534050000091, 45.34398021000004],
              [14.29078209700009, 45.32050202000005],
              [14.271983269000089, 45.29010651200008],
              [14.258474155000044, 45.25576406500005],
              [14.24773196700005, 45.18646881700005],
              [14.234711134000065, 45.15456777600008],
              [14.23406009200005, 45.15306224200003],
              [14.232595248000052, 45.14935944200005],
              [14.209239129000082, 45.12636953300006],
              [14.17937259200005, 45.13450755400004],
              [14.195323113000086, 45.12059153900009],
              [14.19312584700009, 45.10561758000006],
              [14.180430535000085, 45.091457424000055],
              [14.164398634000065, 45.07990143400008],
              [14.158213738000086, 45.08734772300005],
              [14.154307488000086, 45.07892487200007],
              [14.15406334700009, 45.071966864000046],
              [14.158213738000086, 45.05320872600004],
              [14.154307488000086, 45.05499909100007],
              [14.147471550000091, 45.05727773600006],
              [14.14389082100007, 45.05939362200007],
              [14.14389082100007, 45.05320872600004],
              [14.159434441000087, 45.040350653000075],
              [14.166188998000052, 45.01894765800006],
              [14.16374759200005, 44.995754299000055],
              [14.151377800000091, 44.97748444200005],
              [14.139903191000087, 44.97134023600006],
              [14.131846550000091, 44.97207265800006],
              [14.124196811000047, 44.97540924700007],
              [14.113291863000086, 44.97748444200005],
              [14.10132897200009, 44.974269924000055],
              [14.089691602000073, 44.966498114000046],
              [14.080414259000065, 44.95726146000004],
              [14.075694207000083, 44.94953034100007],
              [14.068858269000089, 44.94953034100007],
              [14.07162519600007, 44.96906159100007],
              [14.079600457000083, 44.97793203300006],
              [14.083832227000073, 44.986395575000074],
              [14.075694207000083, 45.00482819200005],
              [14.054535352000073, 45.018459377000056],
              [14.051524285000085, 45.02602773600006],
              [14.053070509000065, 45.03314850500004],
              [14.051931186000047, 45.03803131700005],
              [14.040293816000087, 45.03896719000005],
              [14.044118686000047, 45.02716705900008],
              [14.039886915000068, 45.009426174000055],
              [14.04428144600007, 45.00141022300005],
              [14.054698113000086, 44.996527411000045],
              [14.06413821700005, 44.995754299000055],
              [14.071543816000087, 44.993353583000044],
              [14.075694207000083, 44.983710028000075],
              [14.064789259000065, 44.97614166900007],
              [14.050791863000086, 44.95648834800005],
              [14.044444207000083, 44.95140208500004],
              [14.040293816000087, 44.956366278000075],
              [14.034678582000083, 44.956366278000075],
              [14.03874759200005, 44.94940827000005],
              [14.040212436000047, 44.941066799000055],
              [14.039073113000086, 44.93183014500005],
              [14.034678582000083, 44.922308661000045],
              [14.026621941000087, 44.92405833500004],
              [14.022471550000091, 44.923488674000055],
              [14.022634311000047, 44.92059967700004],
              [14.027842644000089, 44.91543203300006],
              [14.027842644000089, 44.908636786000045],
              [14.022715691000087, 44.908270575000074],
              [14.021494988000086, 44.90737539300005],
              [14.021739129000082, 44.90509674700007],
              [14.020518425000091, 44.90110911700003],
              [14.010590040000068, 44.90525950700004],
              [13.988454623000052, 44.90078359600005],
              [13.972666863000086, 44.90110911700003],
              [13.980723504000082, 44.896551825000074],
              [13.985850457000083, 44.89207591400009],
              [13.993011915000068, 44.881293036000045],
              [13.986175977000073, 44.881293036000045],
              [13.986175977000073, 44.875067450000074],
              [13.993011915000068, 44.875067450000074],
              [13.993011915000068, 44.867621161000045],
              [13.985850457000083, 44.864162502000056],
              [13.981293165000068, 44.859808661000045],
              [13.972666863000086, 44.84715403900009],
              [13.974619988000086, 44.83966705900008],
              [13.97632897200009, 44.83746979400007],
              [13.97624759200005, 44.83490631700005],
              [13.972666863000086, 44.82664622600004],
              [13.983246290000068, 44.827053127000056],
              [13.989431186000047, 44.825100002000056],
              [13.993988477000073, 44.82050202000005],
              [14.000010613000086, 44.81305573100008],
              [13.963877800000091, 44.811835028000075],
              [13.946299675000091, 44.813788153000075],
              [13.931651238000086, 44.82050202000005],
              [13.929698113000086, 44.81635163000004],
              [13.929535352000073, 44.81525299700007],
              [13.924815300000091, 44.81305573100008],
              [13.918711785000085, 44.82904694200005],
              [13.909678582000083, 44.830959377000056],
              [13.899587436000047, 44.82904694200005],
              [13.890147332000083, 44.83348216400009],
              [13.883148634000065, 44.82664622600004],
              [13.89389082100007, 44.82339101800005],
              [13.904307488000086, 44.817287502000056],
              [13.909353061000047, 44.80898672100005],
              [13.904470248000052, 44.79877350500004],
              [13.91342207100007, 44.782416083000044],
              [13.917979363000086, 44.77826569200005],
              [13.903168165000068, 44.77240631700005],
              [13.899424675000091, 44.78196849200003],
              [13.89975019600007, 44.79828522300005],
              [13.896983269000089, 44.81305573100008],
              [13.889659050000091, 44.81708405200004],
              [13.860036655000044, 44.82566966400009],
              [13.849131707000083, 44.82664622600004],
              [13.85124759200005, 44.83002350500004],
              [13.853851759000065, 44.83706289300005],
              [13.855967644000089, 44.840277411000045],
              [13.852793816000087, 44.84076569200005],
              [13.845550977000073, 44.84015534100007],
              [13.842295769000089, 44.840277411000045],
              [13.849131707000083, 44.84715403900009],
              [13.842295769000089, 44.85464101800005],
              [13.83139082100007, 44.852728583000044],
              [13.815684441000087, 44.85659414300005],
              [13.799327019000089, 44.864569403000075],
              [13.787119988000086, 44.875067450000074],
              [13.79460696700005, 44.881293036000045],
              [13.804860873000052, 44.87059153900009],
              [13.819590691000087, 44.86766185100004],
              [13.83375084700009, 44.87335846600007],
              [13.842295769000089, 44.88812897300005],
              [13.815277540000068, 44.88353099200003],
              [13.804860873000052, 44.88540273600006],
              [13.79460696700005, 44.894964911000045],
              [13.79460696700005, 44.90110911700003],
              [13.798675977000073, 44.903957424000055],
              [13.803477410000085, 44.91063060100004],
              [13.808116082000083, 44.91543203300006],
              [13.796722852000073, 44.92487213700008],
              [13.774099155000044, 44.96381256700005],
              [13.732758009000065, 44.99494049700007],
              [13.68132571700005, 45.04637278900009],
              [13.673350457000083, 45.05109284100007],
              [13.660817905000044, 45.06122467700004],
              [13.643809441000087, 45.07050202000005],
              [13.623220248000052, 45.07306549700007],
              [13.627696160000085, 45.079413153000075],
              [13.633067254000082, 45.08942291900007],
              [13.636892123000052, 45.09357330900008],
              [13.612559441000087, 45.11786530200004],
              [13.638519727000073, 45.13003164300005],
              [13.72624759200005, 45.13450755400004],
              [13.70671634200005, 45.14109935100004],
              [13.683604363000086, 45.14337799700007],
              [13.636892123000052, 45.14203522300005],
              [13.611989780000044, 45.136786200000074],
              [13.600596550000091, 45.13727448100008],
              [13.595957879000082, 45.145412502000056],
              [13.597911004000082, 45.155951239000046],
              [13.600596550000091, 45.16461823100008],
              [13.59937584700009, 45.17129140800006],
              [13.589121941000087, 45.175482489000046],
              [13.593760613000086, 45.18227773600006],
              [13.594411655000044, 45.18732330900008],
              [13.590586785000085, 45.19179922100005],
              [13.582286004000082, 45.196600653000075],
              [13.582286004000082, 45.202826239000046],
              [13.590505405000044, 45.20648834800005],
              [13.594493035000085, 45.21263255400004],
              [13.594248894000089, 45.220770575000074],
              [13.589121941000087, 45.23069896000004],
              [13.595713738000086, 45.24054596600007],
              [13.595225457000083, 45.25079987200007],
              [13.588226759000065, 45.25958893400008],
              [13.575450066000087, 45.264878648000035],
              [13.578786655000044, 45.27098216400009],
              [13.584239129000082, 45.27606842700004],
              [13.592051629000082, 45.27912018400008],
              [13.602712436000047, 45.27912018400008],
              [13.602712436000047, 45.28534577000005],
              [13.592539910000085, 45.28880442900004],
              [13.584646030000044, 45.29319896000004],
              [13.578949415000068, 45.29901764500005],
              [13.575450066000087, 45.30646393400008],
              [13.58570397200009, 45.307806708000044],
              [13.594493035000085, 45.31110260600008],
              [13.609548373000052, 45.32013580900008],
              [13.597911004000082, 45.32436758000006],
              [13.571055535000085, 45.32501862200007],
              [13.561778191000087, 45.32636139500005],
              [13.550629102000073, 45.33429596600007],
              [13.541270379000082, 45.346136786000045],
              [13.540537957000083, 45.356756903000075],
              [13.554942254000082, 45.36107005400004],
              [13.554942254000082, 45.36733633000006],
              [13.543142123000052, 45.376166083000044],
              [13.51335696700005, 45.43622467700004],
              [13.51539147200009, 45.43813711100006],
              [13.518565300000091, 45.440334377000056],
              [13.520762566000087, 45.443019924000055],
              [13.515961134000065, 45.44745514500005],
              [13.515635613000086, 45.448146877000056],
              [13.517832879000082, 45.44977448100008],
              [13.520762566000087, 45.45726146000004],
              [13.504567905000044, 45.48387278900009],
              [13.501475457000083, 45.49860260600008],
              [13.507090691000087, 45.51190827000005],
              [13.51335696700005, 45.51190827000005],
              [13.52312259200005, 45.50625234600005],
              [13.568614129000082, 45.49079010600008],
              [13.585139075400429, 45.48924692030404],
              [13.58952884200005, 45.48883698100008],
              [13.624106924762254, 45.46274523643508],
              [13.642820334798104, 45.459447780786306],
              [13.642920370625196, 45.45943015365675],
              [13.659969793000073, 45.45997795100003],
              [13.759294068000145, 45.463169251000025],
              [13.806526327000086, 45.44213694300002],
              [13.819858846000102, 45.43262848000005],
              [13.835568481000081, 45.42911448200009],
              [13.889001912000083, 45.42363678],
              [13.899647257000083, 45.4292178350001],
              [13.908432251000079, 45.43888132700003],
              [13.923005004000032, 45.44895823200007],
              [13.969823852000047, 45.46296254500008],
              [13.982639608000056, 45.475313212000046],
              [13.96145227000008, 45.493141581000074],
              [13.96145227000008, 45.50389027900009],
              [13.964966268000126, 45.510969951000035],
              [13.971890910000127, 45.514225566],
              [13.98747649000012, 45.51190879000008],
              [14.013955526000132, 45.5079727170001],
              [14.028321574000046, 45.50265004500007],
              [14.041550741000037, 45.49319325800009],
              [14.06666548700008, 45.480274150000085],
              [14.092917114000102, 45.47391794800005],
              [14.116747016000119, 45.47299787500005],
              [14.117320712000065, 45.47297572500007],
              [14.119685506000081, 45.47288442000006],
              [14.145523722000092, 45.47624338800007],
              [14.193066040000105, 45.49190134700005],
              [14.218697551000076, 45.49717234400008],
              [14.240608358000117, 45.493348288000035],
              [14.280399211000145, 45.481100973000096],
              [14.326804646000141, 45.474899801000035],
              [14.37279667100006, 45.477845358000124],
              [14.41124393700008, 45.49319325800009],
              [14.429744100000107, 45.5053888960001],
              [14.468914835000078, 45.52559438100009],
              [14.48214400200007, 45.542440898000066],
              [14.487414999000094, 45.55660024000012],
              [14.4915018290001, 45.579164764000055],
              [14.492272583000101, 45.58342030900009],
              [14.49857710800012, 45.59618438800008],
              [14.507878866000055, 45.6058478800001],
              [14.533096964000094, 45.625691631000095],
              [14.54363895600008, 45.636440329000024],
              [14.556144654000065, 45.65669749000001],
              [14.56389611800006, 45.66269195500006],
              [14.569094979000084, 45.66425161300005],
              [14.580949341000093, 45.66780792200002],
              [14.59190474400009, 45.66336375000013],
              [14.59407515500007, 45.64801584900006],
              [14.592938273000073, 45.629670716000064],
              [14.593868449000098, 45.6161831670001],
              [14.603066853000115, 45.603574117000065],
              [14.61598596200011, 45.59406565400009],
              [14.65029911300013, 45.574842021000066],
              [14.657327107000071, 45.57277496400012],
              [14.663674874000094, 45.57018702800012],
              [14.66404504400009, 45.57003611300006],
              [14.669832804000066, 45.56455841100008],
              [14.67169315600006, 45.556806946000066],
              [14.6681791580001, 45.53913360700007],
              [14.668489217000086, 45.53396596300006],
              [14.688332967000093, 45.52202870700002],
              [14.781143839000094, 45.493348288000035],
              [14.781247192000109, 45.493348288000035],
              [14.781350545000066, 45.49319325800009],
              [14.78145389800008, 45.493141581000074],
              [14.79716353300006, 45.46518463200009],
              [14.838814738000082, 45.458983460000084],
              [14.881602823000094, 45.46978383400004],
              [14.900826456000118, 45.493141581000074],
              [14.904443807000092, 45.514432272000064],
              [14.922633911000048, 45.51494903600009],
              [14.945371541000014, 45.50451039700006],
              [14.962631470000105, 45.493141581000074],
              [14.977340822000087, 45.49172845500003],
              [14.986299275000135, 45.49086781800007],
              [14.997461385000065, 45.48719879200006],
              [15.007383260000069, 45.48084259100004],
              [15.056165812000131, 45.47991241500007],
              [15.066128234000104, 45.473933723000115],
              [15.1392615150001, 45.43004465800003],
              [15.184220011000036, 45.42560048500012],
              [15.22584915200008, 45.436449693],
              [15.281578410000066, 45.45097361200003],
              [15.314031209000092, 45.450508525000075],
              [15.325193318000117, 45.45283396400002],
              [15.333874960000088, 45.45851837200006],
              [15.35175500400004, 45.47614003600005],
              [15.361366821000047, 45.482031149000065],
              [15.31103397700008, 45.50590566000004],
              [15.296667928000062, 45.52295888300007],
              [15.288606405000081, 45.54455963200006],
              [15.28261193800006, 45.570604553000024],
              [15.282178582000085, 45.571494074000086],
              [15.27672082500004, 45.582696839],
              [15.269589477000096, 45.59344553700002],
              [15.268555948000113, 45.60166208900007],
              [15.281061646000126, 45.606157939000084],
              [15.287882934000095, 45.610343730000025],
              [15.291603637000094, 45.61825022400008],
              [15.297391398000059, 45.625691631000095],
              [15.326743612000143, 45.63225453800008],
              [15.339145955000106, 45.63690541700005],
              [15.353098592000094, 45.640316060000075],
              [15.373769165000112, 45.64021270800005],
              [15.368291463000048, 45.64904937800013],
              [15.351961711000087, 45.668066305000096],
              [15.350034463000071, 45.66961911600005],
              [15.333874960000088, 45.68263905900007],
              [15.330774373000054, 45.68455108700009],
              [15.327053670000112, 45.683155823],
              [15.314961385000032, 45.68088206000009],
              [15.310413859000107, 45.67819488500005],
              [15.309070272000042, 45.67416412400006],
              [15.304936158000118, 45.67214874300002],
              [15.29191369600008, 45.67555938800005],
              [15.28302535000006, 45.680106913000074],
              [15.277754354000137, 45.685016175],
              [15.267832479000049, 45.69845204700006],
              [15.258220663000117, 45.70511830700006],
              [15.250882609000115, 45.70765045200007],
              [15.248918904000107, 45.71183624300009],
              [15.249912989000109, 45.71373174300008],
              [15.255016723000068, 45.72346344000006],
              [15.26349165800005, 45.73038808300005],
              [15.303799276000092, 45.74614939400003],
              [15.331031283000073, 45.752485554000074],
              [15.429062947000148, 45.77529490200003],
              [15.429754502000065, 45.775691354000074],
              [15.4410518790001, 45.782167868],
              [15.43950158700008, 45.79167633000007],
              [15.43557417800011, 45.802114970000034],
              [15.440328410000092, 45.81146840400005],
              [15.451283813000089, 45.81513743100005],
              [15.462549275000129, 45.81420725500003],
              [15.473918091000115, 45.811571757000095],
              [15.485390259000042, 45.81017649400012],
              [15.49531213300014, 45.812656963000094],
              [15.513915649000097, 45.823405661000024],
              [15.523527466000104, 45.82681630500004],
              [15.549748079000068, 45.82369278000006],
              [15.58729618300012, 45.81921987000008],
              [15.62605350800007, 45.82020172100003],
              [15.645587199000062, 45.82412913000009],
              [15.666051066000136, 45.83167389000006],
              [15.676076294000069, 45.84169911700009],
              [15.675456177000086, 45.855961813000064],
              [15.663673950000089, 45.87606394500001],
              [15.659436483000036, 45.88882802400009],
              [15.663363892000092, 45.90081695600004],
              [15.670391887000108, 45.91265085900007],
              [15.675559530000015, 45.92515655600006],
              [15.67710982200012, 45.94179636600008],
              [15.675380807000067, 45.972486394000086],
              [15.67421594300015, 45.993162740000045],
              [15.674319295000089, 45.993317770000075],
              [15.681967407000059, 46.01352325500007],
              [15.693646281000042, 46.02577057000009],
              [15.697987101000109, 46.036209208000045],
              [15.692879847000114, 46.04163566600003],
              [15.683931112000096, 46.051143697000086],
              [15.671735474000087, 46.05739654600008],
              [15.643726847000067, 46.065509746000075],
              [15.631531209000059, 46.07057403600005],
              [15.623604838000063, 46.07641529800013],
              [15.603832641000025, 46.0909862270001],
              [15.589880005000055, 46.11351715100004],
              [15.589983358000069, 46.13868357400007],
              [15.604349406000068, 46.16700225800007],
              [15.622849568000106, 46.19170359400009],
              [15.626571312000095, 46.195209748000096],
              [15.639799438000097, 46.20767161000002],
              [15.66129683400004, 46.21531972300009],
              [15.67797529200007, 46.21446241900013],
              [15.749766886000089, 46.210772197000054],
              [15.76888716600007, 46.21935048400009],
              [15.789144328000077, 46.24306996700004],
              [15.799526193000133, 46.24860696100005],
              [15.803096965000066, 46.250511373000066],
              [15.818289835000087, 46.25552398700002],
              [15.834206176000123, 46.25836619100009],
              [15.879323324000012, 46.25930809400005],
              [15.880894659000091, 46.259340899000094],
              [15.883712199000087, 46.259399720000076],
              [15.918903311000093, 46.27282717100003],
              [15.94872115000004, 46.28420440700002],
              [15.982000773000067, 46.288338522000046],
              [15.99366824000009, 46.29061331100006],
              [15.99843387900006, 46.29154246000009],
              [16.019207804000075, 46.29882883700007],
              [16.038948201000068, 46.308440654],
              [16.049922398000092, 46.316734615000044],
              [16.0523840730001, 46.318595073000054],
              [16.059618774000057, 46.33231516600007],
              [16.0597221270001, 46.34531178800002],
              [16.057448365000084, 46.35965199800002],
              [16.05796512800012, 46.37753204400006],
              [16.088654305000148, 46.37308560000004],
              [16.094345337000107, 46.37226104700004],
              [16.10602421100009, 46.37373382600005],
              [16.115532674000065, 46.37928904200005],
              [16.12318078600012, 46.38688547800011],
              [16.131552368000115, 46.3930608110001],
              [16.143851359000053, 46.39471445800005],
              [16.153566528000084, 46.391433004000035],
              [16.17754439300012, 46.37559417800004],
              [16.191807088000076, 46.36978057900005],
              [16.208653605000052, 46.367093404000045],
              [16.217128540000147, 46.36735178700009],
              [16.252785279000136, 46.37342376700006],
              [16.27562626200006, 46.37316538500009],
              [16.280277140000123, 46.37621429400009],
              [16.279936481000078, 46.378661362000074],
              [16.278726847000087, 46.38735056600005],
              [16.27407596800012, 46.392104798000034],
              [16.257022746000104, 46.399907939000045],
              [16.250924927000142, 46.40499806800004],
              [16.248237752000108, 46.413343811000104],
              [16.250098103000113, 46.429441020000084],
              [16.24937463400002, 46.43752838200008],
              [16.237489054000093, 46.46507192000006],
              [16.23366499900007, 46.47874033600006],
              [16.234187647000056, 46.48489233600007],
              [16.23490523300009, 46.49333892800003],
              [16.260931084000106, 46.51357611200008],
              [16.263947388000076, 46.51592153000006],
              [16.29536665900011, 46.52444814100009],
              [16.310662883000077, 46.530985209000065],
              [16.32998986800004, 46.53545522100008],
              [16.340276431000092, 46.54382713200009],
              [16.34414921000007, 46.546979065000116],
              [16.351254482000087, 46.53992246000003],
              [16.351693970000042, 46.53948598200007],
              [16.357895142000103, 46.546979065000116],
              [16.36947066200014, 46.54057118800007],
              [16.382183065000106, 46.53938263000005],
              [16.394895467000055, 46.540106100000045],
              [16.406264282000052, 46.53948598200007],
              [16.415152628000072, 46.535558574],
              [16.431999145000134, 46.52320790600005],
              [16.44037072700013, 46.51902211500003],
              [16.449052368000082, 46.518350322000046],
              [16.470756469000065, 46.52026235000004],
              [16.48129846200004, 46.51902211500003],
              [16.491116984000115, 46.51514638300007],
              [16.515301554000075, 46.50171051000011],
            ],
          ],
          [
            [
              [18.43735477700011, 42.55921213800009],
              [18.442005656000077, 42.54301157700009],
              [18.436424602000073, 42.51076548300004],
              [18.437148071000053, 42.49340220200013],
              [18.444279419000082, 42.477925110000015],
              [18.454924764000083, 42.464721782000126],
              [18.467740519000074, 42.45337880500004],
              [18.475491984000087, 42.449813131000084],
              [18.492855265000088, 42.44237172400007],
              [18.497816202000138, 42.431157939000016],
              [18.496429884000065, 42.41632721600007],
              [18.474457227000073, 42.44135163000004],
              [18.460948113000086, 42.44794342700004],
              [18.427582227000073, 42.45526764500005],
              [18.41309655000009, 42.46185944200005],
              [18.41187584700009, 42.47601959800005],
              [18.238942905000044, 42.55906810100004],
              [18.220550977000073, 42.57916901200008],
              [18.220876498000052, 42.588324286000045],
              [18.22315514400009, 42.60211823100008],
              [18.223480665000068, 42.61469147300005],
              [18.217539910000085, 42.62010325700004],
              [18.166026238000086, 42.626939195000034],
              [18.124847852000073, 42.644598700000074],
              [18.108653191000087, 42.64740631700005],
              [18.091644727000073, 42.64826080900008],
              [18.076019727000073, 42.65131256700005],
              [18.063975457000083, 42.65761953300006],
              [18.057383660000085, 42.66791413000004],
              [18.077321811000047, 42.66791413000004],
              [18.055918816000087, 42.68301015800006],
              [18.04786217500009, 42.690619208000044],
              [18.043223504000082, 42.702053127000056],
              [18.02833092500009, 42.69131094000005],
              [18.00326582100007, 42.70066966400009],
              [17.961192254000082, 42.729396877000056],
              [17.901621941000087, 42.75189850500004],
              [17.880707227000073, 42.768744208000044],
              [17.892832879000082, 42.79083893400008],
              [17.865082227000073, 42.789943752000056],
              [17.83497155000009, 42.80719635600008],
              [17.806651238000086, 42.81191640800006],
              [17.800059441000087, 42.810980536000045],
              [17.79232832100007, 42.80853913000004],
              [17.78565514400009, 42.80516185100004],
              [17.780121290000068, 42.796942450000074],
              [17.773773634000065, 42.79857005400004],
              [17.767751498000052, 42.80231354400007],
              [17.76539147200009, 42.80442942900004],
              [17.75879967500009, 42.80760325700004],
              [17.735118035000085, 42.821966864000046],
              [17.720957879000082, 42.826239325000074],
              [17.73959394600007, 42.81305573100008],
              [17.748708530000044, 42.80341217700004],
              [17.761892123000052, 42.77871328300006],
              [17.761892123000052, 42.774318752000056],
              [17.755137566000087, 42.77094147300005],
              [17.748708530000044, 42.77204010600008],
              [17.748708530000044, 42.77814362200007],
              [17.750254754000082, 42.78571198100008],
              [17.748871290000068, 42.79083893400008],
              [17.728770379000082, 42.800767320000034],
              [17.678558790000068, 42.81622955900008],
              [17.633474155000044, 42.82294342700004],
              [17.580088738000086, 42.84125397300005],
              [17.525238477000073, 42.84861888200004],
              [17.44044030000009, 42.87335846600007],
              [17.44271894600007, 42.89862702000005],
              [17.417246941000087, 42.91120026200008],
              [17.35092207100007, 42.92177969000005],
              [17.271332227000073, 42.96336497600004],
              [17.237478061000047, 42.97138092700004],
              [17.221527540000068, 42.979803778000075],
              [17.21387780000009, 42.98261139500005],
              [17.201914910000085, 42.98432038000004],
              [17.09538821700005, 42.984442450000074],
              [17.062510613000086, 42.99005768400008],
              [17.046153191000087, 42.99506256700005],
              [17.027517123000052, 43.003566799000055],
              [17.017914259000065, 43.01382070500006],
              [17.028168165000068, 43.02415599200003],
              [17.028168165000068, 43.03099192900004],
              [17.018809441000087, 43.034084377000056],
              [17.012950066000087, 43.03921133000006],
              [17.008067254000082, 43.04531484600005],
              [17.00163821700005, 43.05149974200003],
              [17.02312259200005, 43.04865143400008],
              [17.05567467500009, 43.028957424000055],
              [17.07325280000009, 43.02415599200003],
              [17.15870201900009, 43.03099192900004],
              [17.240244988000086, 43.022772528000075],
              [17.390472852000073, 42.977728583000044],
              [17.425791863000086, 42.96088288000004],
              [17.45411217500009, 42.942287502000056],
              [17.455739780000044, 42.93842194200005],
              [17.455902540000068, 42.932928778000075],
              [17.45679772200009, 42.926988023000035],
              [17.460215691000087, 42.92177969000005],
              [17.464854363000086, 42.92072174700007],
              [17.476573113000086, 42.92243073100008],
              [17.48145592500009, 42.92177969000005],
              [17.499278191000087, 42.91185130400004],
              [17.507660352000073, 42.909084377000056],
              [17.51889082100007, 42.90814850500004],
              [17.522634311000047, 42.910223700000074],
              [17.522146030000044, 42.919623114000046],
              [17.526133660000085, 42.92177969000005],
              [17.532074415000068, 42.92059967700004],
              [17.54151451900009, 42.91547272300005],
              [17.54656009200005, 42.91429271000004],
              [17.558929884000065, 42.91282786700003],
              [17.56812584700009, 42.909084377000056],
              [17.58375084700009, 42.90070221600007],
              [17.622894727000073, 42.89130280200004],
              [17.64161217500009, 42.884466864000046],
              [17.652679884000065, 42.87335846600007],
              [17.658946160000085, 42.87335846600007],
              [17.673675977000073, 42.875067450000074],
              [17.715993686000047, 42.844183661000045],
              [17.741465691000087, 42.83926015800006],
              [17.710948113000086, 42.856634833000044],
              [17.701914910000085, 42.868475653000075],
              [17.713633660000085, 42.88080475500004],
              [17.707367384000065, 42.88703034100007],
              [17.67872155000009, 42.87938060100004],
              [17.65333092500009, 42.89093659100007],
              [17.665928996000105, 42.905160014],
              [17.679468221000093, 42.91567616800005],
              [17.701585734000105, 42.919500225],
              [17.723599894000074, 42.91624460900003],
              [17.76545780400005, 42.90412648600004],
              [17.78674849500004, 42.90138763500006],
              [17.794706665000092, 42.90459157300005],
              [17.802664836000076, 42.909630026000016],
              [17.81175988700005, 42.90986257000007],
              [17.823335408000077, 42.898364563000044],
              [17.826229288000064, 42.8886493940001],
              [17.825092408000074, 42.86454233900007],
              [17.82715946400012, 42.853121847000054],
              [17.858475382000023, 42.81697418200004],
              [17.869430786000095, 42.81180653900013],
              [17.904467407000112, 42.804546],
              [17.928858684000147, 42.79080006900004],
              [17.971853475000046, 42.75496246400009],
              [17.995314575000094, 42.74044138700005],
              [18.049368124000097, 42.71475820000008],
              [18.22413781700007, 42.62807098500012],
              [18.25710738100014, 42.61489349400004],
              [18.31157434100004, 42.60122507800013],
              [18.3386527910001, 42.60251698900008],
              [18.349608195000087, 42.596289979000076],
              [18.369782537000077, 42.574392828],
              [18.370485474000134, 42.57362986300002],
              [18.385264933000144, 42.566524353],
              [18.42102502500009, 42.563630473],
              [18.43735477700011, 42.55921213800009],
            ],
          ],
          [
            [
              [16.858164910000085, 42.78400299700007],
              [16.921071811000047, 42.77716705900008],
              [16.933929884000065, 42.77094147300005],
              [16.936371290000068, 42.755519924000055],
              [16.924652540000068, 42.741400458000044],
              [16.905446811000047, 42.731756903000075],
              [16.884938998000052, 42.729396877000056],
              [16.88217207100007, 42.736395575000074],
              [16.87403405000009, 42.737616278000075],
              [16.858164910000085, 42.74298737200007],
              [16.847666863000086, 42.733587958000044],
              [16.834320509000065, 42.73094310100004],
              [16.82081139400009, 42.73607005400004],
              [16.809825066000087, 42.74982330900008],
              [16.822276238000086, 42.755113023000035],
              [16.824066602000073, 42.76406484600005],
              [16.81885826900009, 42.76935455900008],
              [16.809825066000087, 42.76349518400008],
              [16.802989129000082, 42.76349518400008],
              [16.81023196700005, 42.77533600500004],
              [16.828135613000086, 42.780951239000046],
              [16.858164910000085, 42.78400299700007],
            ],
          ],
          [
            [
              [17.658946160000085, 42.74298737200007],
              [17.67937259200005, 42.72988515800006],
              [17.730479363000086, 42.71344635600008],
              [17.748871290000068, 42.694566148000035],
              [17.385915561000047, 42.77094147300005],
              [17.373789910000085, 42.75999583500004],
              [17.353770379000082, 42.76666901200008],
              [17.33448326900009, 42.78034088700008],
              [17.323741082000083, 42.79083893400008],
              [17.34156334700009, 42.793402411000045],
              [17.373789910000085, 42.80263906500005],
              [17.39234459700009, 42.80170319200005],
              [17.387380405000044, 42.80023834800005],
              [17.382009311000047, 42.79783763200004],
              [17.37159264400009, 42.79083893400008],
              [17.382660352000073, 42.79165273600006],
              [17.393321160000085, 42.79116445500006],
              [17.403493686000047, 42.788763739000046],
              [17.412445509000065, 42.78400299700007],
              [17.419932488000086, 42.79083893400008],
              [17.43685957100007, 42.78261953300006],
              [17.48601321700005, 42.78217194200005],
              [17.523692254000082, 42.764837958000044],
              [17.574473504000082, 42.757513739000046],
              [17.597504102000073, 42.74982330900008],
              [17.594411655000044, 42.747748114000046],
              [17.59351647200009, 42.74721914300005],
              [17.590668165000068, 42.74298737200007],
              [17.64820397200009, 42.73851146000004],
              [17.658946160000085, 42.74298737200007],
            ],
          ],
          [
            [
              [17.13184655000009, 42.96954987200007],
              [17.148692254000082, 42.95258209800005],
              [17.164317254000082, 42.941473700000074],
              [17.20020592500009, 42.92177969000005],
              [17.193369988000086, 42.91429271000004],
              [17.17432701900009, 42.92202383000006],
              [17.153086785000085, 42.921128648000035],
              [17.107432488000086, 42.91429271000004],
              [17.01531009200005, 42.928615627000056],
              [16.972911004000082, 42.92670319200005],
              [16.898692254000082, 42.90582916900007],
              [16.851410352000073, 42.90070221600007],
              [16.739756707000083, 42.917181708000044],
              [16.691416863000086, 42.92820872600004],
              [16.67286217500009, 42.92674388200004],
              [16.672618035000085, 42.92177969000005],
              [16.655446811000047, 42.92625560100004],
              [16.63843834700009, 42.934759833000044],
              [16.70679772200009, 42.962103583000044],
              [16.70679772200009, 42.96954987200007],
              [16.687754754000082, 42.973944403000075],
              [16.648285352000073, 42.977769273000035],
              [16.631683790000068, 42.98261139500005],
              [16.652679884000065, 42.99237702000005],
              [16.67481530000009, 42.99290599200003],
              [16.697520379000082, 42.99017975500004],
              [16.72046959700009, 42.99005768400008],
              [16.741384311000047, 42.98061758000006],
              [16.76856530000009, 42.97223541900007],
              [16.824066602000073, 42.962103583000044],
              [16.87867272200009, 42.962103583000044],
              [16.892588738000086, 42.96531810100004],
              [16.915537957000083, 42.97451406500005],
              [17.032074415000068, 42.98261139500005],
              [17.11109459700009, 42.96430084800005],
              [17.13184655000009, 42.96954987200007],
            ],
          ],
          [
            [
              [16.24122155000009, 43.071966864000046],
              [16.24545332100007, 43.07636139500005],
              [16.249847852000073, 43.079413153000075],
              [16.253428582000083, 43.07786692900004],
              [16.25489342500009, 43.06854889500005],
              [16.252126498000052, 43.06240469000005],
              [16.24545332100007, 43.05776601800005],
              [16.23373457100007, 43.05149974200003],
              [16.221934441000087, 43.040269273000035],
              [16.21029707100007, 43.033270575000074],
              [16.121348504000082, 43.013373114000046],
              [16.087168816000087, 43.01146067900004],
              [16.063161655000044, 43.01740143400008],
              [16.08448326900009, 43.02594635600008],
              [16.087087436000047, 43.04140859600005],
              [16.07911217500009, 43.05329010600008],
              [16.06934655000009, 43.05149974200003],
              [16.063161655000044, 43.05149974200003],
              [16.048838738000086, 43.06517161700003],
              [16.052989129000082, 43.06830475500004],
              [16.057302280000044, 43.07021719000005],
              [16.06226647200009, 43.07127513200004],
              [16.06934655000009, 43.071966864000046],
              [16.092539910000085, 43.08274974200003],
              [16.13021894600007, 43.08844635600008],
              [16.170176629000082, 43.08771393400008],
              [16.19971764400009, 43.079413153000075],
              [16.19467207100007, 43.07440827000005],
              [16.192881707000083, 43.071966864000046],
              [16.21583092500009, 43.07916901200008],
              [16.22820071700005, 43.07868073100008],
              [16.24122155000009, 43.071966864000046],
            ],
          ],
          [
            [
              [16.69312584700009, 43.12726471600007],
              [16.670176629000082, 43.12547435100004],
              [16.559825066000087, 43.14297109600005],
              [16.475352410000085, 43.16648997600004],
              [16.445160352000073, 43.170803127000056],
              [16.427256707000083, 43.17987702000005],
              [16.416026238000086, 43.18183014500005],
              [16.37159264400009, 43.19550202000005],
              [16.375824415000068, 43.19993724200003],
              [16.380381707000083, 43.20197174700007],
              [16.391449415000068, 43.202337958000044],
              [16.40398196700005, 43.19717031500005],
              [16.415293816000087, 43.198472398000035],
              [16.439789259000065, 43.20978424700007],
              [16.446055535000085, 43.202337958000044],
              [16.449066602000073, 43.20648834800005],
              [16.46029707100007, 43.21596914300005],
              [16.46029707100007, 43.20978424700007],
              [16.496429884000065, 43.218085028000075],
              [16.52702884200005, 43.204291083000044],
              [16.554942254000082, 43.187933661000045],
              [16.583262566000087, 43.188666083000044],
              [16.555918816000087, 43.20978424700007],
              [16.529307488000086, 43.22162506700005],
              [16.52051842500009, 43.22898997600004],
              [16.535004102000073, 43.227728583000044],
              [16.562754754000082, 43.22898997600004],
              [16.583262566000087, 43.21596914300005],
              [16.587087436000047, 43.21625397300005],
              [16.596934441000087, 43.22174713700008],
              [16.603770379000082, 43.22345612200007],
              [16.616384311000047, 43.223537502000056],
              [16.646006707000083, 43.219916083000044],
              [16.65951582100007, 43.21596914300005],
              [16.666270379000082, 43.21084219000005],
              [16.672536655000044, 43.20302969000005],
              [16.68067467500009, 43.19476959800005],
              [16.69312584700009, 43.188666083000044],
              [16.693614129000082, 43.184027411000045],
              [16.692230665000068, 43.182806708000044],
              [16.689463738000086, 43.182806708000044],
              [16.686289910000085, 43.18183014500005],
              [16.705821160000085, 43.170803127000056],
              [16.727712436000047, 43.16461823100008],
              [16.751231316000087, 43.16193268400008],
              [16.84815514400009, 43.16233958500004],
              [16.864431186000047, 43.168850002000056],
              [16.878428582000083, 43.15884023600006],
              [16.896739129000082, 43.15477122600004],
              [16.95875084700009, 43.152411200000074],
              [17.01856530000009, 43.14085521000004],
              [17.10987389400009, 43.143784898000035],
              [17.15528405000009, 43.140326239000046],
              [17.193369988000086, 43.12726471600007],
              [16.943247917500088, 43.12726471600007],
              [16.69312584700009, 43.12726471600007],
            ],
          ],
          [
            [
              [16.500743035000085, 43.28424713700008],
              [16.421885613000086, 43.317572333000044],
              [16.405772332000083, 43.33270905200004],
              [16.41382897200009, 43.32884349200003],
              [16.419444207000083, 43.32518138200004],
              [16.42628014400009, 43.32518138200004],
              [16.42676842500009, 43.33148834800005],
              [16.429698113000086, 43.332464911000045],
              [16.434336785000085, 43.331732489000046],
              [16.439789259000065, 43.33270905200004],
              [16.434255405000044, 43.339911200000074],
              [16.43490644600007, 43.34642161700003],
              [16.441661004000082, 43.351223049000055],
              [16.453461134000065, 43.353176174000055],
              [16.439707879000082, 43.37091705900008],
              [16.42628014400009, 43.39411041900007],
              [16.44703209700009, 43.39484284100007],
              [16.453461134000065, 43.39411041900007],
              [16.49390709700009, 43.38231028900009],
              [16.687673373000052, 43.377020575000074],
              [16.809825066000087, 43.353176174000055],
              [16.809825066000087, 43.34638092700004],
              [16.796153191000087, 43.34638092700004],
              [16.806813998000052, 43.34247467700004],
              [16.816254102000073, 43.34023672100005],
              [16.824229363000086, 43.341009833000044],
              [16.830332879000082, 43.34638092700004],
              [16.839366082000083, 43.34088776200008],
              [16.858164910000085, 43.32518138200004],
              [16.868988477000073, 43.32257721600007],
              [16.877696160000085, 43.323431708000044],
              [16.885101759000065, 43.321966864000046],
              [16.89234459700009, 43.312201239000046],
              [16.879567905000044, 43.29393138200004],
              [16.872325066000087, 43.287990627000056],
              [16.864431186000047, 43.29169342700004],
              [16.84620201900009, 43.27338288000004],
              [16.813161655000044, 43.26776764500005],
              [16.62826582100007, 43.263739325000074],
              [16.563975457000083, 43.27008698100008],
              [16.500743035000085, 43.28424713700008],
            ],
          ],
          [
            [
              [16.391449415000068, 43.34638092700004],
              [16.37598717500009, 43.33344147300005],
              [16.34864342500009, 43.33869049700007],
              [16.28174889400009, 43.36937083500004],
              [16.232269727000073, 43.384466864000046],
              [16.207041863000086, 43.38727448100008],
              [16.20639082100007, 43.391791083000044],
              [16.207774285000085, 43.39313385600008],
              [16.21029707100007, 43.39321523600006],
              [16.213226759000065, 43.39411041900007],
              [16.203379754000082, 43.39996979400007],
              [16.200450066000087, 43.40704987200007],
              [16.20557701900009, 43.41290924700007],
              [16.22006269600007, 43.415228583000044],
              [16.27702884200005, 43.41193268400008],
              [16.29818769600007, 43.403631903000075],
              [16.302744988000086, 43.38727448100008],
              [16.32984459700009, 43.38971588700008],
              [16.34864342500009, 43.37832265800006],
              [16.366709832000083, 43.36115143400008],
              [16.391449415000068, 43.34638092700004],
            ],
          ],
          [
            [
              [15.678884311000047, 43.64801666900007],
              [15.740407748000052, 43.62750885600008],
              [15.68132571700005, 43.640326239000046],
              [15.672048373000052, 43.63743724200003],
              [15.663096550000091, 43.645697333000044],
              [15.619639519000089, 43.66893138200004],
              [15.603770379000082, 43.674709377000056],
              [15.611338738000086, 43.68211497600004],
              [15.615489129000082, 43.676988023000035],
              [15.619639519000089, 43.675441799000055],
              [15.65015709700009, 43.673041083000044],
              [15.661631707000083, 43.66547272300005],
              [15.66968834700009, 43.65574778900009],
              [15.678884311000047, 43.64801666900007],
            ],
          ],
          [
            [
              [15.261241082000083, 43.86709219000005],
              [15.266368035000085, 43.85700104400007],
              [15.342458530000044, 43.811835028000075],
              [15.354340040000068, 43.80036041900007],
              [15.367360873000052, 43.79010651200008],
              [15.395681186000047, 43.77240631700005],
              [15.386973504000082, 43.77684153900009],
              [15.327972852000073, 43.79633209800005],
              [15.308929884000065, 43.80560944200005],
              [15.28842207100007, 43.825506903000075],
              [15.261241082000083, 43.83978913000004],
              [15.247894727000073, 43.84902578300006],
              [15.233409050000091, 43.862209377000056],
              [15.227793816000087, 43.87445709800005],
              [15.240733269000089, 43.88076406500005],
              [15.261241082000083, 43.86709219000005],
            ],
          ],
          [
            [
              [15.302744988000086, 43.96637604400007],
              [15.297129754000082, 43.97809479400007],
              [15.270192905000044, 44.00031159100007],
              [15.261241082000083, 44.011053778000075],
              [15.280284050000091, 44.01080963700008],
              [15.296397332000083, 44.00560130400004],
              [15.349945509000065, 43.97630442900004],
              [15.37859134200005, 43.97166575700004],
              [15.384043816000087, 43.97016022300005],
              [15.386566602000073, 43.96442291900007],
              [15.389414910000085, 43.94765859600005],
              [15.391612175000091, 43.94220612200007],
              [15.397634311000047, 43.937201239000046],
              [15.411143425000091, 43.932928778000075],
              [15.418793165000068, 43.92914459800005],
              [15.426768425000091, 43.92206452000005],
              [15.435394727000073, 43.91128164300005],
              [15.44271894600007, 43.89907461100006],
              [15.446055535000085, 43.88751862200007],
              [15.438731316000087, 43.890692450000074],
              [15.43140709700009, 43.89276764500005],
              [15.423675977000073, 43.89398834800005],
              [15.415049675000091, 43.89443594000005],
              [15.407074415000068, 43.896144924000055],
              [15.403575066000087, 43.90021393400008],
              [15.401540561000047, 43.90477122600004],
              [15.397715691000087, 43.90810781500005],
              [15.372080925000091, 43.91388580900008],
              [15.358653191000087, 43.91937897300005],
              [15.349945509000065, 43.92914459800005],
              [15.354340040000068, 43.93146393400008],
              [15.35678144600007, 43.93537018400008],
              [15.34351647200009, 43.93964264500005],
              [15.325450066000087, 43.948431708000044],
              [15.309580925000091, 43.95844147300005],
              [15.302744988000086, 43.96637604400007],
            ],
          ],
          [
            [
              [15.254405144000089, 44.01788971600007],
              [15.24187259200005, 44.027777411000045],
              [15.232269727000073, 44.041449286000045],
              [15.223317905000044, 44.05027903900009],
              [15.212738477000073, 44.04523346600007],
              [15.206553582000083, 44.04523346600007],
              [15.205332879000082, 44.04975006700005],
              [15.203379754000082, 44.05247630400004],
              [15.201426629000082, 44.05499909100007],
              [15.199066602000073, 44.05882396000004],
              [15.18913821700005, 44.04779694200005],
              [15.16968834700009, 44.058661200000074],
              [15.148773634000065, 44.07636139500005],
              [15.121836785000085, 44.092230536000045],
              [15.087087436000047, 44.12372467700004],
              [15.068695509000065, 44.133978583000044],
              [15.070811394000089, 44.13764069200005],
              [15.071136915000068, 44.13849518400008],
              [15.07203209700009, 44.13882070500006],
              [15.07553144600007, 44.14081452000005],
              [15.071462436000047, 44.14638906500005],
              [15.062510613000086, 44.16193268400008],
              [15.225759311000047, 44.06622955900008],
              [15.247080925000091, 44.04669830900008],
              [15.254405144000089, 44.01788971600007],
            ],
          ],
          [
            [
              [14.842784050000091, 44.14826080900008],
              [14.850433790000068, 44.15224844000005],
              [14.857269727000073, 44.152044989000046],
              [14.863780144000089, 44.148138739000046],
              [14.869151238000086, 44.14052969000005],
              [14.856130405000044, 44.13686758000006],
              [14.835215691000087, 44.14166901200008],
              [14.819834832000083, 44.15302155200004],
              [14.822438998000052, 44.16868724200003],
              [14.827403191000087, 44.157904364000046],
              [14.835459832000083, 44.15102773600006],
              [14.842784050000091, 44.14826080900008],
            ],
          ],
          [
            [
              [15.144541863000086, 43.949652411000045],
              [15.216807488000086, 43.91278717700004],
              [15.220225457000083, 43.90119049700007],
              [15.195485873000052, 43.89520905200004],
              [15.145518425000091, 43.923895575000074],
              [15.133311394000089, 43.921210028000075],
              [15.137705925000091, 43.91787344000005],
              [15.14031009200005, 43.91303131700005],
              [15.144541863000086, 43.90810781500005],
              [15.16968834700009, 43.894964911000045],
              [15.17554772200009, 43.89093659100007],
              [15.183441602000073, 43.88694896000004],
              [15.19109134200005, 43.88751862200007],
              [15.196787957000083, 43.886379299000055],
              [15.199066602000073, 43.87763092700004],
              [15.194509311000047, 43.87262604400007],
              [15.184580925000091, 43.87710195500006],
              [15.17514082100007, 43.88426341400009],
              [15.172373894000089, 43.88751862200007],
              [15.13648522200009, 43.90302155200004],
              [15.121348504000082, 43.91258372600004],
              [15.106618686000047, 43.925441799000055],
              [15.066905144000089, 43.96954987200007],
              [15.042816602000073, 43.99042389500005],
              [15.003103061000047, 44.05231354400007],
              [14.983083530000044, 44.06631094000005],
              [14.955088738000086, 44.07558828300006],
              [14.870127800000091, 44.14081452000005],
              [14.867849155000044, 44.152044989000046],
              [14.86296634200005, 44.161037502000056],
              [14.849619988000086, 44.17560455900008],
              [14.85523522200009, 44.17649974200003],
              [14.859629754000082, 44.17601146000004],
              [14.863291863000086, 44.17560455900008],
              [14.882823113000086, 44.15916575700004],
              [14.93913821700005, 44.12714264500005],
              [14.944183790000068, 44.12026601800005],
              [14.948741082000083, 44.11115143400008],
              [14.95443769600007, 44.103216864000046],
              [14.96265709700009, 44.09983958500004],
              [14.97632897200009, 44.09666575700004],
              [14.985118035000085, 44.09096914300005],
              [14.99382571700005, 44.08783600500004],
              [15.007334832000083, 44.093003648000035],
              [15.002777540000068, 44.08315664300005],
              [15.000498894000089, 44.079413153000075],
              [15.014414910000085, 44.07794830900008],
              [15.022715691000087, 44.07221100500004],
              [15.02670332100007, 44.06232330900008],
              [15.027842644000089, 44.04865143400008],
              [15.031911655000044, 44.036363023000035],
              [15.041351759000065, 44.02643463700008],
              [15.088226759000065, 43.98965078300006],
              [15.099131707000083, 43.98509349200003],
              [15.113780144000089, 43.98379140800006],
              [15.11695397200009, 43.97882721600007],
              [15.144541863000086, 43.949652411000045],
            ],
          ],
          [
            [
              [14.876963738000086, 44.559759833000044],
              [14.865896030000044, 44.56635163000004],
              [14.76148522200009, 44.658636786000045],
              [14.743662957000083, 44.68048737200007],
              [14.733653191000087, 44.703192450000074],
              [14.738129102000073, 44.703111070000034],
              [14.741221550000091, 44.701605536000045],
              [14.779958530000044, 44.66950104400007],
              [14.845225457000083, 44.60053131700005],
              [14.883799675000091, 44.57965729400007],
              [14.880137566000087, 44.60919830900008],
              [14.90406334700009, 44.61001211100006],
              [14.938243035000085, 44.59414297100005],
              [14.966319207000083, 44.573431708000044],
              [14.989105665000068, 44.54661692900004],
              [15.003916863000086, 44.53607819200005],
              [15.041188998000052, 44.52749258000006],
              [15.051768425000091, 44.51618073100008],
              [15.061696811000047, 44.50071849200003],
              [15.07553144600007, 44.484076239000046],
              [15.055918816000087, 44.48623281500005],
              [15.028168165000068, 44.503159898000035],
              [15.007334832000083, 44.50454336100006],
              [15.011729363000086, 44.514878648000035],
              [15.014170769000089, 44.518744208000044],
              [14.972911004000082, 44.53611888200004],
              [14.95289147200009, 44.54148997600004],
              [14.942067905000044, 44.54743073100008],
              [14.928558790000068, 44.55231354400007],
              [14.911143425000091, 44.55231354400007],
              [14.911143425000091, 44.54547760600008],
              [14.965993686000047, 44.523871161000045],
              [15.048024936000047, 44.439439195000034],
              [15.096690300000091, 44.41518789300005],
              [15.080821160000085, 44.42454661700003],
              [15.064952019000089, 44.437933661000045],
              [15.051036004000082, 44.45526764500005],
              [15.041514519000089, 44.476629950000074],
              [15.083262566000087, 44.46185944200005],
              [15.176605665000068, 44.39130280200004],
              [15.199066602000073, 44.38104889500005],
              [15.213226759000065, 44.369208075000074],
              [15.241384311000047, 44.35106028900009],
              [15.254405144000089, 44.34003327000005],
              [15.235118035000085, 44.33624909100007],
              [15.211761915000068, 44.346136786000045],
              [15.187347852000073, 44.359808661000045],
              [15.165049675000091, 44.36737702000005],
              [15.165049675000091, 44.360541083000044],
              [15.182871941000087, 44.357855536000045],
              [15.200450066000087, 44.34951406500005],
              [15.215830925000091, 44.33812083500004],
              [15.227061394000089, 44.32636139500005],
              [15.206553582000083, 44.32636139500005],
              [15.208262566000087, 44.320746161000045],
              [15.210948113000086, 44.31732819200005],
              [15.215017123000052, 44.31492747600004],
              [15.220225457000083, 44.31273021000004],
              [15.19890384200005, 44.31704336100006],
              [15.154551629000082, 44.33100006700005],
              [15.130869988000086, 44.33258698100008],
              [15.130869988000086, 44.32636139500005],
              [15.172373894000089, 44.30532461100006],
              [15.172373894000089, 44.29913971600007],
              [15.149261915000068, 44.303168036000045],
              [15.128754102000073, 44.31199778900009],
              [15.111175977000073, 44.32461172100005],
              [15.096690300000091, 44.34003327000005],
              [15.096690300000091, 44.34625885600008],
              [15.110362175000091, 44.34625885600008],
              [15.110362175000091, 44.35370514500005],
              [15.102305535000085, 44.35716380400004],
              [15.097178582000083, 44.361314195000034],
              [15.08920332100007, 44.374212958000044],
              [15.099782748000052, 44.37360260600008],
              [15.106944207000083, 44.37518952000005],
              [15.112152540000068, 44.37958405200004],
              [15.117198113000086, 44.38719310100004],
              [15.091644727000073, 44.39935944200005],
              [15.083018425000091, 44.40151601800005],
              [15.07357832100007, 44.400458075000074],
              [15.057790561000047, 44.394191799000055],
              [15.049001498000052, 44.39468008000006],
              [15.038340691000087, 44.40326569200005],
              [15.020762566000087, 44.42999909100007],
              [14.958832227000073, 44.46670156500005],
              [14.949717644000089, 44.468085028000075],
              [14.897471550000091, 44.49091217700004],
              [14.897471550000091, 44.49705638200004],
              [14.903168165000068, 44.498480536000045],
              [14.912852410000085, 44.50275299700007],
              [14.918630405000044, 44.50454336100006],
              [14.906260613000086, 44.52090078300006],
              [14.877614780000044, 44.55133698100008],
              [14.876963738000086, 44.559759833000044],
            ],
          ],
          [
            [
              [14.445567254000082, 44.56598541900007],
              [14.526621941000087, 44.50372955900008],
              [14.534353061000047, 44.484076239000046],
              [14.511973504000082, 44.48224518400008],
              [14.485036655000044, 44.50063711100006],
              [14.451914910000085, 44.53188711100006],
              [14.438161655000044, 44.53864166900007],
              [14.438161655000044, 44.54547760600008],
              [14.459239129000082, 44.54116445500006],
              [14.466075066000087, 44.53864166900007],
              [14.437998894000089, 44.56464264500005],
              [14.422618035000085, 44.573879299000055],
              [14.40406334700009, 44.57965729400007],
              [14.396983269000089, 44.56915924700007],
              [14.386566602000073, 44.565619208000044],
              [14.37468509200005, 44.567572333000044],
              [14.36304772200009, 44.573431708000044],
              [14.36304772200009, 44.57965729400007],
              [14.369883660000085, 44.57965729400007],
              [14.369883660000085, 44.57982005400004],
              [14.368662957000083, 44.582017320000034],
              [14.364756707000083, 44.587225653000075],
              [14.38257897200009, 44.60325755400004],
              [14.375987175000091, 44.623032945000034],
              [14.34937584700009, 44.65534088700008],
              [14.344574415000068, 44.66852448100008],
              [14.337087436000047, 44.699652411000045],
              [14.335785352000073, 44.716782945000034],
              [14.355723504000082, 44.707098700000074],
              [14.381114129000082, 44.69863515800006],
              [14.397471550000091, 44.685614325000074],
              [14.39039147200009, 44.662176825000074],
              [14.395192905000044, 44.65338776200008],
              [14.399587436000047, 44.63751862200007],
              [14.40406334700009, 44.61033763200004],
              [14.410004102000073, 44.60097890800006],
              [14.445567254000082, 44.56598541900007],
            ],
          ],
          [
            [
              [14.740489129000082, 44.77826569200005],
              [14.740489129000082, 44.77049388200004],
              [14.742930535000085, 44.76577383000006],
              [14.754079623000052, 44.75775788000004],
              [14.740896030000044, 44.76439036700003],
              [14.724945509000065, 44.767645575000074],
              [14.709971550000091, 44.76788971600007],
              [14.699473504000082, 44.76520416900007],
              [14.65788821700005, 44.79877350500004],
              [14.670420769000089, 44.79950592700004],
              [14.682871941000087, 44.79877350500004],
              [14.694834832000083, 44.79645416900007],
              [14.705739780000044, 44.79254791900007],
              [14.705739780000044, 44.79877350500004],
              [14.702321811000047, 44.80215078300006],
              [14.701426629000082, 44.804348049000055],
              [14.701345248000052, 44.80731842700004],
              [14.699473504000082, 44.81305573100008],
              [14.715830925000091, 44.803168036000045],
              [14.719981316000087, 44.79877350500004],
              [14.726817254000082, 44.79877350500004],
              [14.714121941000087, 44.818426825000074],
              [14.705821160000085, 44.82684967700004],
              [14.692067905000044, 44.83348216400009],
              [14.689789259000065, 44.83673737200007],
              [14.685801629000082, 44.84715403900009],
              [14.70679772200009, 44.844956773000035],
              [14.726817254000082, 44.840277411000045],
              [14.724131707000083, 44.84442780200004],
              [14.719981316000087, 44.85464101800005],
              [14.739024285000085, 44.85342031500005],
              [14.75326582100007, 44.84585195500006],
              [14.756114129000082, 44.83567942900004],
              [14.740489129000082, 44.82664622600004],
              [14.740489129000082, 44.82050202000005],
              [14.748057488000086, 44.81679922100005],
              [14.787364129000082, 44.78925202000005],
              [14.811534050000091, 44.77920156500005],
              [14.822438998000052, 44.77142975500004],
              [14.85124759200005, 44.73729075700004],
              [14.85906009200005, 44.71735260600008],
              [14.849619988000086, 44.703192450000074],
              [14.821462436000047, 44.72064850500004],
              [14.772959832000083, 44.76032135600008],
              [14.740489129000082, 44.77826569200005],
            ],
          ],
          [
            [
              [14.513926629000082, 44.662176825000074],
              [14.508067254000082, 44.65330638200004],
              [14.508555535000085, 44.64533112200007],
              [14.51498457100007, 44.64215729400007],
              [14.527517123000052, 44.64789459800005],
              [14.534353061000047, 44.63426341400009],
              [14.527354363000086, 44.62714264500005],
              [14.520355665000068, 44.621527411000045],
              [14.51335696700005, 44.618841864000046],
              [14.502289259000065, 44.62026601800005],
              [14.472992384000065, 44.62026601800005],
              [14.427907748000052, 44.65656159100007],
              [14.394541863000086, 44.70758698100008],
              [14.397227410000085, 44.751613674000055],
              [14.392751498000052, 44.75250885600008],
              [14.389903191000087, 44.75405508000006],
              [14.387380405000044, 44.75580475500004],
              [14.383555535000085, 44.75775788000004],
              [14.374522332000083, 44.75385163000004],
              [14.368174675000091, 44.761053778000075],
              [14.364268425000091, 44.77440013200004],
              [14.36304772200009, 44.80654531500005],
              [14.361582879000082, 44.81598541900007],
              [14.356618686000047, 44.81976959800005],
              [14.346039259000065, 44.82050202000005],
              [14.32984459700009, 44.83392975500004],
              [14.31413821700005, 44.893784898000035],
              [14.294200066000087, 44.908636786000045],
              [14.295176629000082, 44.91307200700004],
              [14.29623457100007, 44.91592031500005],
              [14.301524285000085, 44.922308661000045],
              [14.292491082000083, 44.940334377000056],
              [14.301524285000085, 44.943426825000074],
              [14.325205925000091, 44.93650950700004],
              [14.332286004000082, 44.93219635600008],
              [14.350271030000044, 44.91290924700007],
              [14.359629754000082, 44.908636786000045],
              [14.377126498000052, 44.90814850500004],
              [14.387380405000044, 44.90900299700007],
              [14.393239780000044, 44.91478099200003],
              [14.397227410000085, 44.92910390800006],
              [14.393565300000091, 44.934759833000044],
              [14.389008009000065, 44.95034414300005],
              [14.39031009200005, 44.96039459800005],
              [14.40406334700009, 44.94953034100007],
              [14.411387566000087, 44.956366278000075],
              [14.391449415000068, 44.96942780200004],
              [14.37671959700009, 44.98688385600008],
              [14.346690300000091, 45.04755280200004],
              [14.340830925000091, 45.05560944200005],
              [14.287445509000065, 45.10106028900009],
              [14.278493686000047, 45.113348700000074],
              [14.277679884000065, 45.12799713700008],
              [14.288584832000083, 45.14883047100005],
              [14.299571160000085, 45.16233958500004],
              [14.313649936000047, 45.17243073100008],
              [14.331879102000073, 45.175848700000074],
              [14.356211785000085, 45.169256903000075],
              [14.364105665000068, 45.15761953300006],
              [14.360524936000047, 45.117621161000045],
              [14.36304772200009, 45.09357330900008],
              [14.369639519000089, 45.075506903000075],
              [14.387705925000091, 45.039048570000034],
              [14.412282748000052, 45.00364817900004],
              [14.41765384200005, 44.99799225500004],
              [14.430837436000047, 44.990301825000074],
              [14.453868035000085, 44.987982489000046],
              [14.466075066000087, 44.983710028000075],
              [14.473480665000068, 44.97142161700003],
              [14.471039259000065, 44.95392487200007],
              [14.46257571700005, 44.935980536000045],
              [14.451914910000085, 44.922308661000045],
              [14.459239129000082, 44.91543203300006],
              [14.449961785000085, 44.89801666900007],
              [14.448496941000087, 44.88373444200005],
              [14.451914910000085, 44.850897528000075],
              [14.464854363000086, 44.82143789300005],
              [14.46656334700009, 44.80483633000006],
              [14.451914910000085, 44.79877350500004],
              [14.457041863000086, 44.78774648600006],
              [14.469248894000089, 44.773098049000055],
              [14.472911004000082, 44.76520416900007],
              [14.473887566000087, 44.75454336100006],
              [14.467621290000068, 44.74213288000004],
              [14.466075066000087, 44.729803778000075],
              [14.472178582000083, 44.70795319200005],
              [14.485606316000087, 44.69208405200004],
              [14.50131269600007, 44.678168036000045],
              [14.513926629000082, 44.662176825000074],
            ],
          ],
          [
            [
              [14.723399285000085, 44.943345445000034],
              [14.70639082100007, 44.94672272300005],
              [14.65788821700005, 44.970038153000075],
              [14.628916863000086, 44.978176174000055],
              [14.624522332000083, 44.98550039300005],
              [14.623789910000085, 45.00141022300005],
              [14.62631269600007, 45.03725820500006],
              [14.62086022200009, 45.04559967700004],
              [14.60328209700009, 45.03896719000005],
              [14.60328209700009, 45.03217194200005],
              [14.61695397200009, 45.024644273000035],
              [14.590668165000068, 45.02326080900008],
              [14.510508660000085, 45.03217194200005],
              [14.485362175000091, 45.03803131700005],
              [14.460134311000047, 45.052394924000055],
              [14.438731316000087, 45.07050202000005],
              [14.425059441000087, 45.08734772300005],
              [14.433116082000083, 45.09585195500006],
              [14.441579623000052, 45.09979889500005],
              [14.451182488000086, 45.10101959800005],
              [14.46265709700009, 45.10101959800005],
              [14.46648196700005, 45.10529205900008],
              [14.465830925000091, 45.11469147300005],
              [14.467051629000082, 45.12409088700008],
              [14.47632897200009, 45.12836334800005],
              [14.514008009000065, 45.12905508000006],
              [14.530121290000068, 45.134833075000074],
              [14.52125084700009, 45.14883047100005],
              [14.534190300000091, 45.162176825000074],
              [14.539561394000089, 45.17039622600004],
              [14.541758660000085, 45.178900458000044],
              [14.539398634000065, 45.186835028000075],
              [14.535899285000085, 45.19415924700007],
              [14.53687584700009, 45.20172760600008],
              [14.548024936000047, 45.210272528000075],
              [14.549815300000091, 45.22142161700003],
              [14.548838738000086, 45.230169989000046],
              [14.543793165000068, 45.23574453300006],
              [14.534353061000047, 45.237534898000035],
              [14.548838738000086, 45.24872467700004],
              [14.563324415000068, 45.24974192900004],
              [14.595876498000052, 45.237534898000035],
              [14.585459832000083, 45.23786041900007],
              [14.582204623000052, 45.237534898000035],
              [14.583994988000086, 45.230169989000046],
              [14.587168816000087, 45.22435130400004],
              [14.591319207000083, 45.21987539300005],
              [14.595876498000052, 45.216498114000046],
              [14.61068769600007, 45.19806549700007],
              [14.623789910000085, 45.175482489000046],
              [14.59742272200009, 45.166449286000045],
              [14.612559441000087, 45.15924713700008],
              [14.643728061000047, 45.15680573100008],
              [14.665293816000087, 45.161810614000046],
              [14.670909050000091, 45.143459377000056],
              [14.658946160000085, 45.10834381700005],
              [14.665293816000087, 45.08734772300005],
              [14.678070509000065, 45.077460028000075],
              [14.695974155000044, 45.073431708000044],
              [14.740489129000082, 45.07306549700007],
              [14.74000084700009, 45.04433828300006],
              [14.799815300000091, 45.005194403000075],
              [14.814952019000089, 44.97748444200005],
              [14.808767123000052, 44.97748444200005],
              [14.797211134000065, 44.97134023600006],
              [14.784678582000083, 44.96930573100008],
              [14.772227410000085, 44.97134023600006],
              [14.760915561000047, 44.97748444200005],
              [14.747243686000047, 44.970038153000075],
              [14.747243686000047, 44.96381256700005],
              [14.760752800000091, 44.955145575000074],
              [14.756846550000091, 44.94871653900009],
              [14.742035352000073, 44.94472890800006],
              [14.723399285000085, 44.943345445000034],
            ],
          ],
          [
            [
              [16.31031334700009, 43.50775788000004],
              [16.334157748000052, 43.50153229400007],
              [16.375254754000082, 43.49017975500004],
              [16.37077884200005, 43.48432038000004],
              [16.33334394600007, 43.48139069200005],
              [16.281993035000085, 43.487941799000055],
              [16.26734459700009, 43.48688385600008],
              [16.25879967500009, 43.48354726800005],
              [16.246429884000065, 43.48143138200004],
              [16.230642123000052, 43.48322174700007],
              [16.218272332000083, 43.486314195000034],
              [16.21143639400009, 43.49005768400008],
              [16.211761915000068, 43.49555084800005],
              [16.218923373000052, 43.497748114000046],
              [16.223317905000044, 43.497381903000075],
              [16.229991082000083, 43.496161200000074],
              [16.24350019600007, 43.49494049700007],
              [16.252207879000082, 43.49994538000004],
              [16.248057488000086, 43.50828685100004],
              [16.264414910000085, 43.512884833000044],
              [16.31031334700009, 43.50775788000004],
            ],
          ],
          [
            [
              [14.759776238000086, 44.29205963700008],
              [14.773448113000086, 44.285142320000034],
              [14.791677280000044, 44.27252838700008],
              [14.789724155000044, 44.266913153000075],
              [14.775401238000086, 44.26658763200004],
              [14.765961134000065, 44.26504140800006],
              [14.759938998000052, 44.259833075000074],
              [14.748545769000089, 44.26166413000004],
              [14.738129102000073, 44.27212148600006],
              [14.73959394600007, 44.280178127000056],
              [14.74968509200005, 44.28021881700005],
              [14.753184441000087, 44.28351471600007],
              [14.753184441000087, 44.291001695000034],
              [14.759776238000086, 44.29205963700008],
            ],
          ],
          [
            [
              [14.613454623000052, 44.34080638200004],
              [14.643565300000091, 44.32575104400007],
              [14.661387566000087, 44.308661200000074],
              [14.657399936000047, 44.30524323100008],
              [14.640798373000052, 44.311835028000075],
              [14.598887566000087, 44.339056708000044],
              [14.59506269600007, 44.34711334800005],
              [14.613454623000052, 44.34080638200004],
            ],
          ],
          [
            [
              [14.797862175000091, 44.37767161700003],
              [14.805674675000091, 44.36782461100006],
              [14.811208530000044, 44.350043036000045],
              [14.801036004000082, 44.343085028000075],
              [14.785166863000086, 44.346869208000044],
              [14.774180535000085, 44.35248444200005],
              [14.756195509000065, 44.36399974200003],
              [14.757823113000086, 44.372259833000044],
              [14.768239780000044, 44.38422272300005],
              [14.76343834700009, 44.415350653000075],
              [14.767100457000083, 44.41665273600006],
              [14.771657748000052, 44.41787344000005],
              [14.78288821700005, 44.41893138200004],
              [14.794769727000073, 44.414496161000045],
              [14.803233269000089, 44.405503648000035],
              [14.805023634000065, 44.395738023000035],
              [14.799652540000068, 44.38764069200005],
              [14.796722852000073, 44.381293036000045],
              [14.797862175000091, 44.37767161700003],
            ],
          ],
          [
            [
              [14.244151238000086, 44.661444403000075],
              [14.265798373000052, 44.67951080900008],
              [14.280446811000047, 44.67755768400008],
              [14.280039910000085, 44.66779205900008],
              [14.274180535000085, 44.66168854400007],
              [14.260915561000047, 44.659491278000075],
              [14.25945071700005, 44.658189195000034],
              [14.257334832000083, 44.65672435100004],
              [14.256846550000091, 44.65306224200003],
              [14.258474155000044, 44.64785390800006],
              [14.256358269000089, 44.64240143400008],
              [14.256683790000068, 44.63703034100007],
              [14.259043816000087, 44.634100653000075],
              [14.265798373000052, 44.62539297100005],
              [14.27116946700005, 44.612534898000035],
              [14.264008009000065, 44.61155833500004],
              [14.252207879000082, 44.616848049000055],
              [14.239756707000083, 44.61985911700003],
              [14.232595248000052, 44.62604401200008],
              [14.233571811000047, 44.634833075000074],
              [14.235606316000087, 44.642238674000055],
              [14.244151238000086, 44.661444403000075],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Slovenia',
        iso3: 'SVN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [13.642920370625196, 45.45943015365675],
            [13.642820334798104, 45.459447780786306],
            [13.624106924762254, 45.46274523643508],
            [13.58952884200005, 45.48883698100008],
            [13.591644727000073, 45.49310944200005],
            [13.589121941000087, 45.501613674000055],
            [13.595957879000082, 45.51190827000005],
            [13.595957879000082, 45.51813385600008],
            [13.586192254000082, 45.51947663000004],
            [13.578623894000089, 45.52338288000004],
            [13.572764519000089, 45.52997467700004],
            [13.568614129000082, 45.53925202000005],
            [13.58961022200009, 45.53579336100006],
            [13.67514082100007, 45.54474518400008],
            [13.752940300000091, 45.55288320500006],
            [13.752940300000091, 45.55906810100004],
            [13.742360873000052, 45.56976959800005],
            [13.727386915000068, 45.58120351800005],
            [13.711761915000068, 45.59320709800005],
            [13.76105106600005, 45.596236064],
            [13.800531860000149, 45.581249899000014],
            [13.84776411900009, 45.584660543000055],
            [13.86792570600008, 45.602169289000116],
            [13.887038208000149, 45.618766988000104],
            [13.894686320000034, 45.631841125000065],
            [13.893640530000113, 45.63375840600007],
            [13.89313602700011, 45.634683329000026],
            [13.884144327000087, 45.63514841700005],
            [13.869158163000094, 45.641142884],
            [13.85840946500008, 45.64935943600001],
            [13.778724406000038, 45.74341054300008],
            [13.70947798600011, 45.765321351000026],
            [13.699908416000142, 45.77052373600007],
            [13.660333699000148, 45.792038066000075],
            [13.643590535000016, 45.79565541600006],
            [13.609174032000055, 45.79860097300006],
            [13.581268758000078, 45.80924631800006],
            [13.574172202000085, 45.8190280570001],
            [13.56597253400011, 45.830330303],
            [13.569279826000127, 45.86454010100009],
            [13.599306242000097, 45.91232749900003],
            [13.608243856000115, 45.92655181900004],
            [13.615325176000084, 45.945912448000016],
            [13.622816610000086, 45.966394349000055],
            [13.605866740000067, 45.98541127600002],
            [13.60073487200009, 45.98457405300003],
            [13.571656942000061, 45.97983022100003],
            [13.539410848000102, 45.96902984700007],
            [13.509438517000149, 45.96742787700005],
            [13.482256713000083, 45.989235332000064],
            [13.481843302000073, 45.99037221300007],
            [13.481223186000108, 45.99135406500004],
            [13.480396362000079, 45.99228424100009],
            [13.47946618600011, 45.99311106400002],
            [13.474815307000142, 45.995746562000036],
            [13.461792846000037, 46.00639190700012],
            [13.47708907000009, 46.01605540000004],
            [13.482256713000083, 46.0184325150001],
            [13.490008179000085, 46.025563863000045],
            [13.492798706000144, 46.03248850500002],
            [13.490318237000082, 46.03894805900008],
            [13.482256713000083, 46.044839173000085],
            [13.505097697000082, 46.06602651000013],
            [13.522585297000091, 46.07529802300003],
            [13.616408732000139, 46.12504099500008],
            [13.645037475, 46.16173126300005],
            [13.64107145100013, 46.17140514500004],
            [13.637389363000125, 46.18038645500009],
            [13.627366324, 46.18173316300006],
            [13.613928264000066, 46.18353871700005],
            [13.584472697000137, 46.18131663100006],
            [13.559047892000137, 46.18410715800012],
            [13.528972208000084, 46.20482940700005],
            [13.510161988000078, 46.21397613600003],
            [13.482256713000083, 46.217903545000084],
            [13.468304077000084, 46.22343292300009],
            [13.43833174600013, 46.22487986300008],
            [13.422828816000049, 46.22860056600011],
            [13.437401570000105, 46.210927226000095],
            [13.41011641500009, 46.20798167],
            [13.40164148000008, 46.21666331000007],
            [13.39812748200012, 46.23051259400002],
            [13.384898316000118, 46.243121644000055],
            [13.384794963000104, 46.24322499600008],
            [13.384691610000061, 46.243328349000095],
            [13.37859379000011, 46.26839141900011],
            [13.373012736000106, 46.28027699800005],
            [13.365261271000094, 46.290302226000065],
            [13.391306193000077, 46.30156768800002],
            [13.395637648000076, 46.30672792800006],
            [13.409806355000086, 46.323607687000035],
            [13.423242229000039, 46.344846700000076],
            [13.434094279000107, 46.35386423800004],
            [13.44732344500008, 46.354846090000095],
            [13.45972579000005, 46.359031881000035],
            [13.483703654000067, 46.37115000400003],
            [13.530005737000067, 46.388332418000104],
            [13.554397013000084, 46.405954081000075],
            [13.575687703000057, 46.426676331000024],
            [13.600182332000117, 46.44264434900005],
            [13.634082072000126, 46.445719097000094],
            [13.658783407000044, 46.445124817000035],
            [13.67749027500011, 46.45207529700012],
            [13.685852877000059, 46.464047231000094],
            [13.688445678000107, 46.46775909500009],
            [13.68989261900009, 46.49333892800003],
            [13.695473673, 46.49863576200006],
            [13.699194376000037, 46.50483693500006],
            [13.701054728000116, 46.51189076800007],
            [13.700951375000102, 46.51974558600001],
            [13.716092570000114, 46.51886708700006],
            [13.782135051000068, 46.50778249200006],
            [13.79577762900007, 46.507885845],
            [13.860683228000113, 46.51524973600009],
            [13.890862264000106, 46.51178741500006],
            [13.98232954900007, 46.48191843700003],
            [13.998762654000103, 46.480523174000055],
            [14.014921609000055, 46.48253065200005],
            [14.032455688000084, 46.484708965],
            [14.050025676000132, 46.48439890500002],
            [14.066355428000094, 46.481039938],
            [14.08103153500008, 46.47594980900003],
            [14.137255493000055, 46.442437643000105],
            [14.147933084000044, 46.44042465400007],
            [14.149864543000064, 46.44006052700006],
            [14.242323222000095, 46.43823746200003],
            [14.36215132700005, 46.435874736000116],
            [14.395844361000115, 46.44099070200009],
            [14.406489705000098, 46.43933705700006],
            [14.41124393700008, 46.434634502000094],
            [14.414447876000054, 46.429001770000056],
            [14.420028931000076, 46.42435089200008],
            [14.437144752000052, 46.41888413300002],
            [14.450931437000065, 46.4144806930001],
            [14.467674601000112, 46.41267201800012],
            [14.502194458000105, 46.418356426000074],
            [14.515837036000107, 46.405359803000024],
            [14.527102498000062, 46.38822906500006],
            [14.540331665000082, 46.37864308700007],
            [14.557694946000083, 46.38393992100002],
            [14.562108198000118, 46.39173666600003],
            [14.566996704000104, 46.40037302700007],
            [14.5753682860001, 46.419725851000024],
            [14.590147746000099, 46.43442779500002],
            [14.59986291500013, 46.43716664600008],
            [14.621567017000132, 46.43851023400005],
            [14.631695597000089, 46.44057729100008],
            [14.642030884000093, 46.44522817000005],
            [14.662081339000054, 46.45969757100009],
            [14.666628865000092, 46.46052439400002],
            [14.672545840000083, 46.45979050600006],
            [14.679961385000098, 46.45887074800008],
            [14.687092733000043, 46.471221416000034],
            [14.698771607000111, 46.480962423000065],
            [14.703732544000076, 46.487757874000025],
            [14.70972701000008, 46.492512106],
            [14.726366821000113, 46.49770558700003],
            [14.735255167000048, 46.49333892800003],
            [14.760886678000105, 46.49628448500003],
            [14.783004191000089, 46.50326080400002],
            [14.788585245000121, 46.506645610000064],
            [14.796662504000068, 46.51940094700011],
            [14.807188762000067, 46.536023662000034],
            [14.814519309000076, 46.55133747600003],
            [14.822278279000074, 46.567546285],
            [14.83364709500006, 46.58439280200007],
            [14.850390259000108, 46.60113596700002],
            [14.862999308000042, 46.60483083100003],
            [14.877055298000073, 46.60364227400002],
            [14.894062722000115, 46.60521546100007],
            [14.897725871000063, 46.60555430200013],
            [14.919506769000122, 46.6150167520001],
            [14.93358931500012, 46.62113474600007],
            [14.94795536200013, 46.619274394000044],
            [14.96717899500004, 46.60025746700008],
            [15.004386027000066, 46.63684438100002],
            [15.061953572000107, 46.64955678300008],
            [15.085722504000046, 46.64779516700007],
            [15.105591442000076, 46.646322596000076],
            [15.172556751000087, 46.64135951300004],
            [15.204890585000044, 46.638963115000095],
            [15.332783734000117, 46.643579675000055],
            [15.388135214000016, 46.64557769800008],
            [15.417590780000126, 46.637955424000026],
            [15.435380874000089, 46.62719528700005],
            [15.440018352000038, 46.62439036100004],
            [15.462652628000058, 46.614649353000104],
            [15.492624959000096, 46.61829254200008],
            [15.511228475000081, 46.62836944600012],
            [15.513939450000123, 46.63254522100003],
            [15.517636353000114, 46.63823964500001],
            [15.520308138000104, 46.647720171000074],
            [15.520840292000088, 46.649608460000096],
            [15.530658814000049, 46.66384531700005],
            [15.545955037000112, 46.671881002000035],
            [15.567349080000014, 46.675756735],
            [15.58863977100009, 46.67596344000005],
            [15.603729288000096, 46.67301788400006],
            [15.61664839700012, 46.675550028000046],
            [15.621745271000123, 46.67817491800007],
            [15.626983684000038, 46.6808727010001],
            [15.632978150000042, 46.689631857000066],
            [15.632874796000124, 46.702473450000056],
            [15.635975382000055, 46.71756296800005],
            [15.652098429000148, 46.71081919300012],
            [15.72868290200006, 46.7029902150001],
            [15.755141235000053, 46.704023743000064],
            [15.784609910000057, 46.71219950300009],
            [15.822940714000055, 46.72283396400009],
            [15.850742635000103, 46.72448761100004],
            [15.878544555000076, 46.72071523100003],
            [15.946344034000077, 46.697150777],
            [15.986961710000116, 46.69218984000007],
            [15.997917114000103, 46.68691884400003],
            [16.016593059000115, 46.67075696900004],
            [16.01672257900006, 46.67069134200001],
            [16.014556925000107, 46.69371429500008],
            [16.003291463000068, 46.709191386000086],
            [15.982000773000067, 46.71854482000002],
            [15.970528606000073, 46.74301361100008],
            [15.96970178200013, 46.76053192200003],
            [15.97098466500006, 46.77504987900009],
            [15.971252075000052, 46.7780760700001],
            [15.978176717000053, 46.80913360700005],
            [15.977349894000014, 46.816213277000074],
            [15.972905721000103, 46.81843536400005],
            [15.97197554500005, 46.82063161200007],
            [15.981690715000099, 46.827685446],
            [15.987581828000089, 46.83001088500002],
            [16.028440945000114, 46.83694743300002],
            [16.032023560000084, 46.83755564400006],
            [16.05293554600007, 46.846059852000096],
            [16.09403527800012, 46.862773743],
            [16.130245696000088, 46.85670849800009],
            [16.135376424000043, 46.85584910100003],
            [16.17948639500011, 46.85846833900003],
            [16.272008911000086, 46.86396230100003],
            [16.282240845000047, 46.859931539000044],
            [16.297392209000122, 46.84703294300003],
            [16.30187788900008, 46.84321421300008],
            [16.310662883000077, 46.84001027500004],
            [16.325338989000073, 46.839441834000084],
            [16.32978316200007, 46.834403382000104],
            [16.327509400000054, 46.82546335900007],
            [16.321824992000103, 46.81326772100006],
            [16.31490035000013, 46.802002259000105],
            [16.311097363000044, 46.79751906200006],
            [16.302187948000068, 46.78701609300002],
            [16.29948988400014, 46.779509942000075],
            [16.298157186000083, 46.77580230800008],
            [16.300430949000088, 46.77208160500008],
            [16.31417687900003, 46.743323670000066],
            [16.32554569500013, 46.73327260400002],
            [16.33412398300007, 46.721748759],
            [16.34342574100009, 46.71417816200004],
            [16.357275024000046, 46.71583180800009],
            [16.357585082000128, 46.69901112900003],
            [16.36538307300006, 46.69671246800009],
            [16.3662163730001, 46.69646683100008],
            [16.37143436700009, 46.6949286910001],
            [16.39003788200006, 46.694153545000106],
            [16.405024048000115, 46.68725474100002],
            [16.410501749000105, 46.66836700500009],
            [16.40260705700007, 46.66310878600005],
            [16.39665246600015, 46.65914276200009],
            [16.377635539000067, 46.65286407500007],
            [16.36843713300007, 46.642993876],
            [16.372245692000064, 46.63634126300006],
            [16.37639530400014, 46.62909291600003],
            [16.39458540800007, 46.619016012000074],
            [16.430242147000058, 46.604391582000105],
            [16.46713911900008, 46.564704082000034],
            [16.500832153000147, 46.54480865500001],
            [16.515301554000075, 46.50171051000011],
            [16.491116984000115, 46.51514638300007],
            [16.48129846200004, 46.51902211500003],
            [16.470756469000065, 46.52026235000004],
            [16.449052368000082, 46.518350322000046],
            [16.44037072700013, 46.51902211500003],
            [16.431999145000134, 46.52320790600005],
            [16.415152628000072, 46.535558574],
            [16.406264282000052, 46.53948598200007],
            [16.394895467000055, 46.540106100000045],
            [16.382183065000106, 46.53938263000005],
            [16.36947066200014, 46.54057118800007],
            [16.357895142000103, 46.546979065000116],
            [16.351693970000042, 46.53948598200007],
            [16.351254482000087, 46.53992246000003],
            [16.34414921000007, 46.546979065000116],
            [16.340276431000092, 46.54382713200009],
            [16.32998986800004, 46.53545522100008],
            [16.310662883000077, 46.530985209000065],
            [16.29536665900011, 46.52444814100009],
            [16.263947388000076, 46.51592153000006],
            [16.260931084000106, 46.51357611200008],
            [16.23490523300009, 46.49333892800003],
            [16.234187647000056, 46.48489233600007],
            [16.23366499900007, 46.47874033600006],
            [16.237489054000093, 46.46507192000006],
            [16.24937463400002, 46.43752838200008],
            [16.250098103000113, 46.429441020000084],
            [16.248237752000108, 46.413343811000104],
            [16.250924927000142, 46.40499806800004],
            [16.257022746000104, 46.399907939000045],
            [16.27407596800012, 46.392104798000034],
            [16.278726847000087, 46.38735056600005],
            [16.279936481000078, 46.378661362000074],
            [16.280277140000123, 46.37621429400009],
            [16.27562626200006, 46.37316538500009],
            [16.252785279000136, 46.37342376700006],
            [16.217128540000147, 46.36735178700009],
            [16.208653605000052, 46.367093404000045],
            [16.191807088000076, 46.36978057900005],
            [16.17754439300012, 46.37559417800004],
            [16.153566528000084, 46.391433004000035],
            [16.143851359000053, 46.39471445800005],
            [16.131552368000115, 46.3930608110001],
            [16.12318078600012, 46.38688547800011],
            [16.115532674000065, 46.37928904200005],
            [16.10602421100009, 46.37373382600005],
            [16.094345337000107, 46.37226104700004],
            [16.088654305000148, 46.37308560000004],
            [16.05796512800012, 46.37753204400006],
            [16.057448365000084, 46.35965199800002],
            [16.0597221270001, 46.34531178800002],
            [16.059618774000057, 46.33231516600007],
            [16.0523840730001, 46.318595073000054],
            [16.049922398000092, 46.316734615000044],
            [16.038948201000068, 46.308440654],
            [16.019207804000075, 46.29882883700007],
            [15.99843387900006, 46.29154246000009],
            [15.99366824000009, 46.29061331100006],
            [15.982000773000067, 46.288338522000046],
            [15.94872115000004, 46.28420440700002],
            [15.918903311000093, 46.27282717100003],
            [15.883712199000087, 46.259399720000076],
            [15.880894659000091, 46.259340899000094],
            [15.879323324000012, 46.25930809400005],
            [15.834206176000123, 46.25836619100009],
            [15.818289835000087, 46.25552398700002],
            [15.803096965000066, 46.250511373000066],
            [15.799526193000133, 46.24860696100005],
            [15.789144328000077, 46.24306996700004],
            [15.76888716600007, 46.21935048400009],
            [15.749766886000089, 46.210772197000054],
            [15.67797529200007, 46.21446241900013],
            [15.66129683400004, 46.21531972300009],
            [15.639799438000097, 46.20767161000002],
            [15.626571312000095, 46.195209748000096],
            [15.622849568000106, 46.19170359400009],
            [15.604349406000068, 46.16700225800007],
            [15.589983358000069, 46.13868357400007],
            [15.589880005000055, 46.11351715100004],
            [15.603832641000025, 46.0909862270001],
            [15.623604838000063, 46.07641529800013],
            [15.631531209000059, 46.07057403600005],
            [15.643726847000067, 46.065509746000075],
            [15.671735474000087, 46.05739654600008],
            [15.683931112000096, 46.051143697000086],
            [15.692879847000114, 46.04163566600003],
            [15.697987101000109, 46.036209208000045],
            [15.693646281000042, 46.02577057000009],
            [15.681967407000059, 46.01352325500007],
            [15.674319295000089, 45.993317770000075],
            [15.67421594300015, 45.993162740000045],
            [15.675380807000067, 45.972486394000086],
            [15.67710982200012, 45.94179636600008],
            [15.675559530000015, 45.92515655600006],
            [15.670391887000108, 45.91265085900007],
            [15.663363892000092, 45.90081695600004],
            [15.659436483000036, 45.88882802400009],
            [15.663673950000089, 45.87606394500001],
            [15.675456177000086, 45.855961813000064],
            [15.676076294000069, 45.84169911700009],
            [15.666051066000136, 45.83167389000006],
            [15.645587199000062, 45.82412913000009],
            [15.62605350800007, 45.82020172100003],
            [15.58729618300012, 45.81921987000008],
            [15.549748079000068, 45.82369278000006],
            [15.523527466000104, 45.82681630500004],
            [15.513915649000097, 45.823405661000024],
            [15.49531213300014, 45.812656963000094],
            [15.485390259000042, 45.81017649400012],
            [15.473918091000115, 45.811571757000095],
            [15.462549275000129, 45.81420725500003],
            [15.451283813000089, 45.81513743100005],
            [15.440328410000092, 45.81146840400005],
            [15.43557417800011, 45.802114970000034],
            [15.43950158700008, 45.79167633000007],
            [15.4410518790001, 45.782167868],
            [15.429754502000065, 45.775691354000074],
            [15.429062947000148, 45.77529490200003],
            [15.331031283000073, 45.752485554000074],
            [15.303799276000092, 45.74614939400003],
            [15.26349165800005, 45.73038808300005],
            [15.255016723000068, 45.72346344000006],
            [15.249912989000109, 45.71373174300008],
            [15.248918904000107, 45.71183624300009],
            [15.250882609000115, 45.70765045200007],
            [15.258220663000117, 45.70511830700006],
            [15.267832479000049, 45.69845204700006],
            [15.277754354000137, 45.685016175],
            [15.28302535000006, 45.680106913000074],
            [15.29191369600008, 45.67555938800005],
            [15.304936158000118, 45.67214874300002],
            [15.309070272000042, 45.67416412400006],
            [15.310413859000107, 45.67819488500005],
            [15.314961385000032, 45.68088206000009],
            [15.327053670000112, 45.683155823],
            [15.330774373000054, 45.68455108700009],
            [15.333874960000088, 45.68263905900007],
            [15.350034463000071, 45.66961911600005],
            [15.351961711000087, 45.668066305000096],
            [15.368291463000048, 45.64904937800013],
            [15.373769165000112, 45.64021270800005],
            [15.353098592000094, 45.640316060000075],
            [15.339145955000106, 45.63690541700005],
            [15.326743612000143, 45.63225453800008],
            [15.297391398000059, 45.625691631000095],
            [15.291603637000094, 45.61825022400008],
            [15.287882934000095, 45.610343730000025],
            [15.281061646000126, 45.606157939000084],
            [15.268555948000113, 45.60166208900007],
            [15.269589477000096, 45.59344553700002],
            [15.27672082500004, 45.582696839],
            [15.282178582000085, 45.571494074000086],
            [15.28261193800006, 45.570604553000024],
            [15.288606405000081, 45.54455963200006],
            [15.296667928000062, 45.52295888300007],
            [15.31103397700008, 45.50590566000004],
            [15.361366821000047, 45.482031149000065],
            [15.35175500400004, 45.47614003600005],
            [15.333874960000088, 45.45851837200006],
            [15.325193318000117, 45.45283396400002],
            [15.314031209000092, 45.450508525000075],
            [15.281578410000066, 45.45097361200003],
            [15.22584915200008, 45.436449693],
            [15.184220011000036, 45.42560048500012],
            [15.1392615150001, 45.43004465800003],
            [15.066128234000104, 45.473933723000115],
            [15.056165812000131, 45.47991241500007],
            [15.007383260000069, 45.48084259100004],
            [14.997461385000065, 45.48719879200006],
            [14.986299275000135, 45.49086781800007],
            [14.977340822000087, 45.49172845500003],
            [14.962631470000105, 45.493141581000074],
            [14.945371541000014, 45.50451039700006],
            [14.922633911000048, 45.51494903600009],
            [14.904443807000092, 45.514432272000064],
            [14.900826456000118, 45.493141581000074],
            [14.881602823000094, 45.46978383400004],
            [14.838814738000082, 45.458983460000084],
            [14.79716353300006, 45.46518463200009],
            [14.78145389800008, 45.493141581000074],
            [14.781350545000066, 45.49319325800009],
            [14.781247192000109, 45.493348288000035],
            [14.781143839000094, 45.493348288000035],
            [14.688332967000093, 45.52202870700002],
            [14.668489217000086, 45.53396596300006],
            [14.6681791580001, 45.53913360700007],
            [14.67169315600006, 45.556806946000066],
            [14.669832804000066, 45.56455841100008],
            [14.66404504400009, 45.57003611300006],
            [14.663674874000094, 45.57018702800012],
            [14.657327107000071, 45.57277496400012],
            [14.65029911300013, 45.574842021000066],
            [14.61598596200011, 45.59406565400009],
            [14.603066853000115, 45.603574117000065],
            [14.593868449000098, 45.6161831670001],
            [14.592938273000073, 45.629670716000064],
            [14.59407515500007, 45.64801584900006],
            [14.59190474400009, 45.66336375000013],
            [14.580949341000093, 45.66780792200002],
            [14.569094979000084, 45.66425161300005],
            [14.56389611800006, 45.66269195500006],
            [14.556144654000065, 45.65669749000001],
            [14.54363895600008, 45.636440329000024],
            [14.533096964000094, 45.625691631000095],
            [14.507878866000055, 45.6058478800001],
            [14.49857710800012, 45.59618438800008],
            [14.492272583000101, 45.58342030900009],
            [14.4915018290001, 45.579164764000055],
            [14.487414999000094, 45.55660024000012],
            [14.48214400200007, 45.542440898000066],
            [14.468914835000078, 45.52559438100009],
            [14.429744100000107, 45.5053888960001],
            [14.41124393700008, 45.49319325800009],
            [14.37279667100006, 45.477845358000124],
            [14.326804646000141, 45.474899801000035],
            [14.280399211000145, 45.481100973000096],
            [14.240608358000117, 45.493348288000035],
            [14.218697551000076, 45.49717234400008],
            [14.193066040000105, 45.49190134700005],
            [14.145523722000092, 45.47624338800007],
            [14.119685506000081, 45.47288442000006],
            [14.117320712000065, 45.47297572500007],
            [14.116747016000119, 45.47299787500005],
            [14.092917114000102, 45.47391794800005],
            [14.06666548700008, 45.480274150000085],
            [14.041550741000037, 45.49319325800009],
            [14.028321574000046, 45.50265004500007],
            [14.013955526000132, 45.5079727170001],
            [13.98747649000012, 45.51190879000008],
            [13.971890910000127, 45.514225566],
            [13.964966268000126, 45.510969951000035],
            [13.96145227000008, 45.50389027900009],
            [13.96145227000008, 45.493141581000074],
            [13.982639608000056, 45.475313212000046],
            [13.969823852000047, 45.46296254500008],
            [13.923005004000032, 45.44895823200007],
            [13.908432251000079, 45.43888132700003],
            [13.899647257000083, 45.4292178350001],
            [13.889001912000083, 45.42363678],
            [13.835568481000081, 45.42911448200009],
            [13.819858846000102, 45.43262848000005],
            [13.806526327000086, 45.44213694300002],
            [13.759294068000145, 45.463169251000025],
            [13.659969793000073, 45.45997795100003],
            [13.642920370625196, 45.45943015365675],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bulgaria',
        iso3: 'BGR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.333358602000118, 41.713036397000096],
            [26.29491133600007, 41.71032338500005],
            [26.273930705000055, 41.714896749],
            [26.26101159700005, 41.72306162600002],
            [26.234449910000137, 41.74582509400001],
            [26.2261816810001, 41.74967498800005],
            [26.2118156330001, 41.750475973000064],
            [26.189904826000117, 41.73468882300007],
            [26.13512780800005, 41.73339691200003],
            [26.10835941500008, 41.727893372000025],
            [26.081487671000076, 41.711511943000076],
            [26.07404626500005, 41.70913482700003],
            [26.0672249750001, 41.70885060600007],
            [26.06050704000009, 41.70730031400005],
            [26.053685750000113, 41.70151255300006],
            [26.04810469500009, 41.689084371],
            [26.047484578000137, 41.674614970000064],
            [26.0502751060001, 41.66045562700002],
            [26.055029337000093, 41.648750916000026],
            [26.05948958500008, 41.64377677000006],
            [26.066914917000105, 41.63549591100012],
            [26.08117761200009, 41.630457459000056],
            [26.09523360200012, 41.628390401],
            [26.106705770000133, 41.62428212500008],
            [26.115284057000054, 41.61663401300011],
            [26.121071818000132, 41.608210755000115],
            [26.13027022300014, 41.58268259700007],
            [26.130993693000022, 41.57513783800003],
            [26.1294434000001, 41.559376527000055],
            [26.13120039800009, 41.55265859000012],
            [26.13678145300011, 41.54919626900006],
            [26.15249108900008, 41.54702585900007],
            [26.158072144000073, 41.542323303],
            [26.16313643400005, 41.52914581300003],
            [26.164480021000116, 41.51772532200003],
            [26.16292972800011, 41.50645986000008],
            [26.15931237800004, 41.49379913400013],
            [26.147633504000055, 41.48475575800008],
            [26.145876506000064, 41.47803782200005],
            [26.15621179200008, 41.46041615800006],
            [26.16044926000012, 41.45586863200002],
            [26.174298543000106, 41.44599843400003],
            [26.177399129000037, 41.4399522910001],
            [26.175642130000142, 41.4318907670001],
            [26.170577840000078, 41.429565328000066],
            [26.164273316000077, 41.42786000600002],
            [26.159002319000138, 41.421813863000054],
            [26.147840210000112, 41.3969058230001],
            [26.132440633000016, 41.371532695],
            [26.120865112000075, 41.35778676400007],
            [26.11466394100009, 41.355202942000076],
            [26.107325887000087, 41.356598206000044],
            [26.02185306800007, 41.34166371700009],
            [26.008933960000064, 41.33680613200006],
            [25.982268921000127, 41.323266907000075],
            [25.959634643000072, 41.31499867800004],
            [25.94857588700006, 41.31396515000007],
            [25.935140015000115, 41.315928854],
            [25.921187378000127, 41.31603220600003],
            [25.896279338000056, 41.30626536100006],
            [25.88201664200008, 41.30404327400008],
            [25.862689657000118, 41.3100894170001],
            [25.83333744300006, 41.33463572200007],
            [25.811013224000078, 41.34104360000002],
            [25.800781290000117, 41.338046366000114],
            [25.763470906000066, 41.31902944000005],
            [25.72874434400012, 41.3170657350001],
            [25.71747888200008, 41.31412017800001],
            [25.70517989100003, 41.30729888900005],
            [25.698048543000084, 41.30192454000009],
            [25.691227255000058, 41.29841054300003],
            [25.679961792000086, 41.297170309000094],
            [25.670453328000093, 41.299185689000055],
            [25.64957605000012, 41.308487447000076],
            [25.639757528000047, 41.31107126900007],
            [25.551494182000084, 41.31567047100013],
            [25.537954956000107, 41.312208150000075],
            [25.530203491000094, 41.302751364000116],
            [25.52369226100012, 41.291692607000115],
            [25.514907267000126, 41.283476054000076],
            [25.50508874500008, 41.28058217400009],
            [25.497337280000067, 41.28120229100007],
            [25.489482462000126, 41.283062643000065],
            [25.479095500000113, 41.28378611200007],
            [25.453463989000056, 41.28042714400006],
            [25.285722290000052, 41.23939605700009],
            [25.26226119000009, 41.238104147000044],
            [25.239110148000094, 41.24089467400002],
            [25.219679810000116, 41.24973134400001],
            [25.177098430000058, 41.29386301700002],
            [25.15787479700012, 41.306110332000046],
            [25.153847445000054, 41.307535008000045],
            [25.116533650000093, 41.3207347620001],
            [25.112606242000112, 41.32414540600003],
            [25.104854777000128, 41.33406728200002],
            [25.101857544000097, 41.33665110300002],
            [25.09679325400012, 41.33670277900005],
            [25.080360148000068, 41.33406728200002],
            [24.916959269000074, 41.386363831000025],
            [24.88636682200007, 41.40062652600001],
            [24.872930949000107, 41.40186676100005],
            [24.863009074000104, 41.40031646800013],
            [24.84213179500003, 41.39473541300002],
            [24.803271118000083, 41.392668355000055],
            [24.80017053200004, 41.37933583600004],
            [24.802857706000054, 41.361920878],
            [24.794279419000134, 41.34739980100004],
            [24.774435669000127, 41.348071595000036],
            [24.7526282150001, 41.36274770100003],
            [24.71872847500009, 41.39571726500007],
            [24.69919478300011, 41.408946432000064],
            [24.68090132600011, 41.415509338000064],
            [24.661264282000104, 41.417679749000044],
            [24.638216594000113, 41.417679749000044],
            [24.644314413000075, 41.427653300000046],
            [24.60948449700004, 41.427239888000045],
            [24.595841919000122, 41.42977203400004],
            [24.58044234200014, 41.44052073200005],
            [24.57971887200003, 41.444189759000054],
            [24.58219934100012, 41.455248515000065],
            [24.581062459000094, 41.460209453000104],
            [24.577238403000052, 41.463568421],
            [24.56772993900009, 41.468115947000044],
            [24.564112589000104, 41.47106150400005],
            [24.55873824100013, 41.47684926400002],
            [24.553570598000135, 41.480776673],
            [24.549436483000108, 41.48542755200005],
            [24.54654260300012, 41.49364410400007],
            [24.543338664000146, 41.52134267200002],
            [24.53093632000008, 41.547542623000126],
            [24.510162395000123, 41.56165028900007],
            [24.48132694500009, 41.55322703100008],
            [24.45920943200008, 41.54950632800005],
            [24.438848917000144, 41.527698873000034],
            [24.42396610500012, 41.525218405000075],
            [24.40288212100009, 41.527853902000075],
            [24.387482544000108, 41.52666534500007],
            [24.353892863000084, 41.519120586],
            [24.345004517000064, 41.5183971150001],
            [24.318236124000094, 41.52077423100006],
            [24.309554484000046, 41.519792379000094],
            [24.303043254000073, 41.51695017500002],
            [24.296118612000072, 41.515244853000056],
            [24.28681685400005, 41.5176219690001],
            [24.28505985500007, 41.52315134700011],
            [24.287333618000105, 41.531626282],
            [24.28640344200005, 41.54035959900007],
            [24.26686975100003, 41.54976471000005],
            [24.25074670400005, 41.56345896400005],
            [24.23328007, 41.561805318],
            [24.214366496000082, 41.55575917600005],
            [24.197697918000074, 41.54771063500009],
            [24.196279744000066, 41.54702585900007],
            [24.18160363800007, 41.53736236600007],
            [24.177469523000127, 41.53100616500005],
            [24.173128703000145, 41.515296529000054],
            [24.170234823000072, 41.511575826000055],
            [24.162793416000056, 41.51204091400008],
            [24.158452596000075, 41.51633005800004],
            [24.15400842300008, 41.522117818000126],
            [24.146256958000066, 41.526768697000094],
            [24.116491333000084, 41.53338328000008],
            [24.076597127000127, 41.53601877900009],
            [24.047348267000075, 41.5257351690001],
            [24.049828736000052, 41.49364410400007],
            [24.052515910000096, 41.47147491500006],
            [24.051999146000043, 41.46299998000005],
            [24.04590132700008, 41.45545522100009],
            [24.034739217000066, 41.451321106000094],
            [24.02285363700014, 41.453078105000074],
            [24.000736125000117, 41.46413686100006],
            [23.997118774000057, 41.457005514000045],
            [23.992364542000132, 41.45462839800008],
            [23.986886841000057, 41.45369822200003],
            [23.981305786000036, 41.45085601900006],
            [23.964665975000116, 41.43835032200006],
            [23.949886515000117, 41.43757517500005],
            [23.90286096200012, 41.463516745],
            [23.894799438000035, 41.46434356700003],
            [23.867720988000087, 41.4454816690001],
            [23.851597941000108, 41.439590556],
            [23.83092736800009, 41.4356114700001],
            [23.809740031000047, 41.43380279500012],
            [23.792066691000116, 41.434474589],
            [23.77708052600005, 41.42904856400013],
            [23.754446248000107, 41.40067820200004],
            [23.738219848000085, 41.39747426400005],
            [23.705353638000076, 41.4031586710001],
            [23.672177368000064, 41.40295196500004],
            [23.6528503830001, 41.397629293000094],
            [23.627735637000086, 41.3785090140001],
            [23.624846740000066, 41.37709384500006],
            [23.61243941200013, 41.37101593100006],
            [23.57895308400012, 41.371997783000026],
            [23.513013957000112, 41.39773264600002],
            [23.414518677000046, 41.3999030560001],
            [23.39550175000008, 41.395252177000046],
            [23.36511600700004, 41.3785606900001],
            [23.34723596200007, 41.37122263600013],
            [23.326048625000112, 41.36931060800002],
            [23.315609985000066, 41.37685536700006],
            [23.306204875000105, 41.38837921200009],
            [23.287704712000078, 41.39819773400005],
            [23.269928019000048, 41.39726755800008],
            [23.2465702720001, 41.38972279900004],
            [23.22424605300006, 41.37902577800004],
            [23.2097766520001, 41.36858713800011],
            [23.2063660070001, 41.360939026000025],
            [23.204815714000063, 41.34269724500008],
            [23.19954471900013, 41.33298207600002],
            [23.190656372000035, 41.32605743500004],
            [23.179700968000134, 41.32135487900008],
            [23.15717004300012, 41.31634226500002],
            [23.115208781000035, 41.312673238000016],
            [22.916977986000063, 41.3357726040001],
            [22.94085249800014, 41.349828593000026],
            [22.944469849000114, 41.36843210900007],
            [22.939405558000146, 41.389412740000054],
            [22.937338501000085, 41.41075510700007],
            [22.94054244000006, 41.41690460200003],
            [22.952117960000095, 41.42770497600007],
            [22.95459842900007, 41.432407532000056],
            [22.953358195000135, 41.43819529300002],
            [22.947570435000074, 41.44837554900009],
            [22.946226848000094, 41.453233135000104],
            [22.943599338000126, 41.52320117600006],
            [22.943022909000035, 41.53855092400009],
            [22.94788049300007, 41.5551390590001],
            [22.948707316000082, 41.56097849500007],
            [22.946433553000077, 41.56774810800003],
            [22.936925090000074, 41.57891021800005],
            [22.9337211510001, 41.58459462500009],
            [22.93206750500005, 41.59795298300013],
            [22.932997681000103, 41.61234486900004],
            [22.936098266000045, 41.6261683150001],
            [22.94085249800014, 41.63764048300003],
            [22.945813436000094, 41.64107696600006],
            [22.961523071000073, 41.64448761100006],
            [22.967000773000052, 41.64704559400006],
            [22.970101359000097, 41.652032369000025],
            [22.97661259000006, 41.666553446000066],
            [22.9854345280001, 41.67719775700006],
            [22.998626750000142, 41.69311513300009],
            [23.00958215300011, 41.7163695280001],
            [23.008858683000113, 41.73993398],
            [22.991185344000115, 41.76099212700002],
            [22.98053999800004, 41.76473866800005],
            [22.956872192000105, 41.7656688440001],
            [22.94591678800012, 41.769337870000086],
            [22.939715617000047, 41.77670176200009],
            [22.918321573000128, 41.81434804300004],
            [22.907676229000117, 41.848583679000015],
            [22.901371704000013, 41.86041758200004],
            [22.896720825000045, 41.864448344000024],
            [22.88504195200008, 41.86915089900002],
            [22.88208830500011, 41.871618275000074],
            [22.880804484000123, 41.87269073500006],
            [22.878220662000047, 41.880261333000036],
            [22.878634073000057, 41.89501495400013],
            [22.877083781000124, 41.90204294900006],
            [22.86633508300011, 41.92488393200004],
            [22.858893677000083, 41.94787994400009],
            [22.857136678000103, 41.971883647000126],
            [22.85475956200014, 41.982632345000056],
            [22.846904744000113, 41.993484395000095],
            [22.84659468600003, 41.99363942500004],
            [22.845767863000106, 42.00686859200003],
            [22.84562115900013, 42.007407729000064],
            [22.843700806000044, 42.0144650270001],
            [22.838223104000065, 42.01947764100005],
            [22.82695764200011, 42.02508453400007],
            [22.821273234000046, 42.02536875400007],
            [22.805977010000106, 42.02138966900007],
            [22.79894901500009, 42.02123464000003],
            [22.791094198000053, 42.02580800400007],
            [22.787683553000136, 42.0325776160001],
            [22.785306437000088, 42.039140523000086],
            [22.780862264000064, 42.04317128600009],
            [22.770630330000103, 42.043998108000025],
            [22.7250517170001, 42.042473654],
            [22.718437134000112, 42.04446319600005],
            [22.713992961000116, 42.04862314900008],
            [22.71027225800009, 42.05298980800005],
            [22.705724731000146, 42.055935364000064],
            [22.675855753000036, 42.06061208100003],
            [22.627176665000036, 42.079126592000094],
            [22.617771443000066, 42.08270375600004],
            [22.531058390000112, 42.12910919300005],
            [22.510181112000026, 42.14479299],
            [22.50693853400014, 42.14892727600004],
            [22.494678182000115, 42.164559225000076],
            [22.481449015000123, 42.19331716000009],
            [22.443621867000047, 42.21442698200012],
            [22.345023234000053, 42.313439026000125],
            [22.364143514000148, 42.32098378500008],
            [22.405794718000067, 42.32155222600004],
            [22.423984822000108, 42.32589304700009],
            [22.438454223000036, 42.340052388000046],
            [22.454370565000147, 42.37676849400013],
            [22.46977014100014, 42.39170298300009],
            [22.485066365000108, 42.39715484600008],
            [22.497572062000103, 42.39919606500003],
            [22.508837525000075, 42.40493215],
            [22.519482870000047, 42.42092600500003],
            [22.533125448000078, 42.457590434000096],
            [22.53653609200009, 42.47839019800004],
            [22.532505330000106, 42.49340220200013],
            [22.532505330000106, 42.493557231000054],
            [22.524857218000108, 42.507664897],
            [22.512144816000074, 42.519188742000026],
            [22.481449015000123, 42.5356218460001],
            [22.42966923000006, 42.571407776000015],
            [22.425328410000077, 42.572854716],
            [22.428842407000047, 42.59277598100003],
            [22.44131821900004, 42.632891463000064],
            [22.444552042000083, 42.643289694000046],
            [22.44920292100005, 42.66796519000006],
            [22.442071573000106, 42.68168528200009],
            [22.468116496000107, 42.71832387300013],
            [22.481449015000123, 42.727677307000064],
            [22.482585897000035, 42.730674541],
            [22.482895955000117, 42.733775126000026],
            [22.482585897000035, 42.73682403600007],
            [22.481449015000123, 42.739821269000075],
            [22.46656620300007, 42.748528748000055],
            [22.453130331000125, 42.76359242800005],
            [22.429359172000062, 42.806122131000095],
            [22.425845174000102, 42.809842835],
            [22.427395467000053, 42.81361521400002],
            [22.430446174000025, 42.81707659300007],
            [22.43680057800009, 42.824286398000126],
            [22.445482218000052, 42.83017751100003],
            [22.470907023000052, 42.84012522400003],
            [22.481449015000123, 42.84673980700002],
            [22.497055298000078, 42.864413147000036],
            [22.506046997000112, 42.87012339300007],
            [22.51979292800013, 42.87035593700004],
            [22.537569621000074, 42.86834055600009],
            [22.544494262000057, 42.871389466000025],
            [22.544785162000068, 42.87170643800006],
            [22.549971965000054, 42.87735809300004],
            [22.56361454200004, 42.88428273500004],
            [22.590899699000147, 42.88689239500003],
            [22.666243937000047, 42.87193206800008],
            [22.696629680000086, 42.87740977000006],
            [22.727015422000136, 42.88689239500003],
            [22.73879764800006, 42.897382711],
            [22.73957861800011, 42.89885754300009],
            [22.74551558400006, 42.910069275000026],
            [22.763188924000076, 42.95864512100003],
            [22.769390096000052, 42.97128000900007],
            [22.776418091000068, 42.97972910600005],
            [22.788096964000147, 42.98489674900007],
            [22.815795532000067, 42.98970265700008],
            [22.828817993000115, 42.99344919800008],
            [22.82892134600013, 42.99344919800008],
            [22.82902469900006, 42.993500875],
            [22.82902469900006, 42.99365590500004],
            [22.842253865000146, 43.007505188000025],
            [22.88421512800005, 43.036650696000024],
            [22.889486124000086, 43.04437632300004],
            [22.896720825000045, 43.06272145700011],
            [22.901681763000113, 43.06974945100002],
            [22.910156698000094, 43.07527882900003],
            [22.927106568000113, 43.08114410500012],
            [22.93527144300012, 43.085562439000014],
            [22.955631958000055, 43.108274232],
            [22.974028768000068, 43.141192118000035],
            [22.98457076000011, 43.17462677100012],
            [22.982901935000143, 43.18731791900008],
            [22.98136682200007, 43.198992208000035],
            [22.964727010000047, 43.204418234000016],
            [22.91553104600007, 43.212247213000055],
            [22.89775435300004, 43.220334574000034],
            [22.88380171700004, 43.230592347000126],
            [22.857343384000046, 43.256947327],
            [22.833158814000086, 43.27464650500009],
            [22.82695764200011, 43.281390279000036],
            [22.823857056000065, 43.28929677300006],
            [22.820756469000116, 43.30753855400003],
            [22.817139119000046, 43.315496724000084],
            [22.804530070000112, 43.328984274000064],
            [22.733009888000083, 43.381513367000125],
            [22.724343132000087, 43.38606013100009],
            [22.719367309000063, 43.38867055300007],
            [22.702934204000087, 43.39404490200003],
            [22.693219035000055, 43.39487172500007],
            [22.674202108000088, 43.394148255000076],
            [22.664693644000096, 43.39673207700007],
            [22.658926066000106, 43.40129503400003],
            [22.6565287680001, 43.40319163100013],
            [22.645366658000057, 43.420296529000055],
            [22.63782190000012, 43.42636851100012],
            [22.62852014100008, 43.428254700000124],
            [22.606919393000112, 43.427402038000096],
            [22.59627404800011, 43.429159038000066],
            [22.58676558400012, 43.43443003300011],
            [22.572709595000106, 43.448150127000034],
            [22.565784953000048, 43.453343608000054],
            [22.53260868400011, 43.464841614000065],
            [22.518862752000075, 43.47424672500004],
            [22.50935428800011, 43.493341166],
            [22.49064742000013, 43.54088348500004],
            [22.47845178300011, 43.5592286170001],
            [22.47762495900008, 43.564163717000056],
            [22.478658488000065, 43.56917633100004],
            [22.481449015000123, 43.57411143000006],
            [22.48268925000005, 43.57669525200005],
            [22.48310266100006, 43.57927907300005],
            [22.48268925000005, 43.58173370400003],
            [22.481449015000123, 43.584136658],
            [22.478141723000107, 43.58757314100002],
            [22.47710819400004, 43.59129384400002],
            [22.478141723000107, 43.59491119400012],
            [22.481449015000123, 43.59852854500009],
            [22.48175907400011, 43.59894195600002],
            [22.481965780000053, 43.599458720000044],
            [22.48175907400011, 43.59997548500009],
            [22.481449015000123, 43.60064727800007],
            [22.47380090300004, 43.61299794600002],
            [22.47287072800009, 43.63594228200007],
            [22.466256144000084, 43.64911977200005],
            [22.4559208580001, 43.65640614900012],
            [22.426465291000085, 43.66821421300004],
            [22.41395959500008, 43.67666331000002],
            [22.404864543000116, 43.68717946400007],
            [22.396906372000046, 43.6994009400001],
            [22.390498495000116, 43.712449240000055],
            [22.386054321000103, 43.725497538000084],
            [22.385847616000063, 43.73381744400005],
            [22.389568319000148, 43.75050893200007],
            [22.38853479000008, 43.758286235000085],
            [22.362593221000026, 43.780842998000125],
            [22.349467407000077, 43.80792144800007],
            [22.354738403000084, 43.829703065],
            [22.367554159000065, 43.85275075300008],
            [22.377062622000068, 43.88352406800003],
            [22.379026326000087, 43.91349639900007],
            [22.382023560000107, 43.918560690000064],
            [22.39194543500011, 43.93186737100005],
            [22.394529256000112, 43.936337382],
            [22.396803019000117, 43.95194366500003],
            [22.397319783000057, 43.9809341440001],
            [22.39959354600009, 43.993336487000064],
            [22.4117891840001, 44.00692738900007],
            [22.43432010900011, 44.013955384000056],
            [22.46588525700014, 44.01762414000005],
            [22.481449015000123, 44.019433085000045],
            [22.503669882000054, 44.01989817300007],
            [22.51493534300002, 44.0302851360001],
            [22.522583455000103, 44.04470286100012],
            [22.53415897600013, 44.0571568810001],
            [22.554622844000107, 44.06242787700005],
            [22.575190064000083, 44.061394348000064],
            [22.592966757000113, 44.06392649400006],
            [22.604748982000018, 44.07937774700004],
            [22.604645630000107, 44.08816274000013],
            [22.598134399000116, 44.10929840100006],
            [22.597100871000038, 44.11906524700002],
            [22.599064575000085, 44.13033070900009],
            [22.6093998610001, 44.15994130500003],
            [22.607952921000106, 44.15999298100006],
            [22.605989217000058, 44.16314524400009],
            [22.604852335000146, 44.16846791600004],
            [22.606195923000115, 44.174565735],
            [22.608573039000078, 44.17585764600007],
            [22.624799438000082, 44.18939687200013],
            [22.63999231000011, 44.207328593000014],
            [22.648777303000088, 44.2139948530001],
            [22.691640373000098, 44.228434539],
            [22.906435995000095, 44.122889303000065],
            [22.942609497000035, 44.11146881100005],
            [22.98808475700008, 44.107024638000055],
            [23.008306709000095, 44.10044641300006],
            [23.03097619600004, 44.093072002000056],
            [23.04007124800009, 44.06232452400012],
            [23.023018025000084, 44.03162872300008],
            [22.98808475700008, 44.01767608700008],
            [22.96627730300014, 44.01555735300009],
            [22.92648645000014, 44.006152243000045],
            [22.905815877000123, 44.003981832000065],
            [22.8858687740001, 43.99452504500009],
            [22.874706665000076, 43.97204579700009],
            [22.850522095000088, 43.896985779],
            [22.85103885900014, 43.87435150200004],
            [22.863441203, 43.8554120890001],
            [22.88876265500008, 43.83952158700008],
            [22.919561808000054, 43.834224752000026],
            [23.052551215000108, 43.84281985600005],
            [23.13184859200004, 43.84794484500007],
            [23.161924275000104, 43.85732411700012],
            [23.19696089600012, 43.86275014300007],
            [23.23447798700002, 43.87729705900004],
            [23.325150732000054, 43.88659228100006],
            [23.484695272000096, 43.88060435000004],
            [23.59269901600007, 43.83742869100011],
            [23.620853516000068, 43.83400993000002],
            [23.636107219000053, 43.83215769500008],
            [23.72075321500006, 43.84582611100008],
            [23.742870727000053, 43.842699687000035],
            [23.799921509000058, 43.81846344000006],
            [24.149605832000134, 43.75471994900006],
            [24.15938277200013, 43.75293772400006],
            [24.336705387000052, 43.759250925000075],
            [24.35823368400014, 43.76001739500008],
            [24.375493612000042, 43.76386729000002],
            [24.431200806000078, 43.794175517000056],
            [24.46634077900012, 43.802417908000095],
            [24.500137166000115, 43.79949819000011],
            [24.661763224000083, 43.75565671600005],
            [24.705602661000057, 43.743765158000045],
            [24.7526282150001, 43.73880422000009],
            [24.963674764000075, 43.74960459400005],
            [25.08160038200009, 43.718934631000096],
            [25.21130822700013, 43.7118807990001],
            [25.252339315000086, 43.704646098000026],
            [25.285404775000075, 43.6903913150001],
            [25.288719523000083, 43.688962301000075],
            [25.323032674000103, 43.66971283000005],
            [25.359619588000044, 43.65428741500004],
            [25.40313114400007, 43.6500499480001],
            [25.426075480000094, 43.654390767000066],
            [25.467416626000045, 43.6677491250001],
            [25.482450035000113, 43.669714753],
            [25.48875899300012, 43.67053965300006],
            [25.53382084100008, 43.66867930100007],
            [25.556558472000063, 43.67035878500012],
            [25.575058634000072, 43.67738678000002],
            [25.593868856000086, 43.680668234],
            [25.61650313400014, 43.687747904000034],
            [25.637897176000138, 43.69728220700004],
            [25.653503458000102, 43.70813425700008],
            [25.67138350400006, 43.71735850000009],
            [25.73294793700012, 43.71878101100002],
            [25.739596395000092, 43.718934631000096],
            [25.781144246000082, 43.732008769000075],
            [25.80439864100009, 43.759914042000034],
            [25.806258993000085, 43.76366058400005],
            [25.839331909000094, 43.78843943300008],
            [25.869304240000133, 43.800893453000086],
            [25.916433146000116, 43.844379171000085],
            [25.924494670000115, 43.85861602800007],
            [25.93400313300009, 43.870320740000054],
            [26.054305868000085, 43.93432200100004],
            [26.061643921000098, 43.94977325400002],
            [26.079317260000096, 43.96904856400006],
            [26.116214233000107, 43.99886586500007],
            [26.15073409100009, 44.01240509000006],
            [26.23145267800004, 44.027494609000044],
            [26.31051761900011, 44.05260935500006],
            [26.332335498000106, 44.05492629800001],
            [26.41579067300006, 44.06378879400002],
            [26.6141683350001, 44.08485544800003],
            [26.647758016000125, 44.09338206000005],
            [26.667808471000086, 44.0950873820001],
            [26.67731693500008, 44.097051087000054],
            [26.697212361000084, 44.10609446300002],
            [26.708684530000085, 44.108109843000065],
            [26.753694702000104, 44.108109843000065],
            [26.789454793000033, 44.11596466100009],
            [26.884126017000142, 44.15653066],
            [27.001534871000075, 44.16510894900004],
            [27.02747644100012, 44.17704620400009],
            [27.100236857000084, 44.14449005200005],
            [27.20555342600008, 44.129245504],
            [27.226740763000066, 44.120718893000074],
            [27.251132039000083, 44.122372539000125],
            [27.252662458000145, 44.1215188660001],
            [27.269012085000043, 44.11239898700002],
            [27.264309530000048, 44.08976471000007],
            [27.28534183800008, 44.072453105000065],
            [27.34166914900007, 44.053074443000085],
            [27.35355472800009, 44.045271302000074],
            [27.372881714000073, 44.02072499600011],
            [27.38383711700004, 44.015092265000064],
            [27.57452315200004, 44.016280823],
            [27.633434285000135, 44.02976837200008],
            [27.65627526800006, 44.02387725900006],
            [27.676119019000055, 43.993543193000036],
            [27.68251497600008, 43.987256010000024],
            [27.72169763100004, 43.948739726000056],
            [27.78732670100007, 43.960418600000125],
            [27.856469767000135, 43.9886339320001],
            [27.91207360800007, 43.993336487000064],
            [27.91207360800007, 43.99323313400005],
            [27.935844767000106, 43.964397685],
            [27.981009969000098, 43.84934010900004],
            [28.014806355000076, 43.830038961000085],
            [28.22125370300006, 43.76198110000011],
            [28.434574015000123, 43.73521270700003],
            [28.578379754000082, 43.74127838700008],
            [28.576182488000086, 43.72752513200004],
            [28.573090040000068, 43.60614655200004],
            [28.57553144600007, 43.59332916900007],
            [28.58570397200009, 43.575832424000055],
            [28.595876498000052, 43.563706773000035],
            [28.602712436000047, 43.552720445000034],
            [28.603526238000086, 43.53815338700008],
            [28.594574415000068, 43.51251862200007],
            [28.578461134000065, 43.48078034100007],
            [28.56031334700009, 43.45384349200003],
            [28.545176629000082, 43.44253164300005],
            [28.535004102000073, 43.43862539300005],
            [28.488617384000065, 43.40643952000005],
            [28.479258660000085, 43.39679596600007],
            [28.473887566000087, 43.38426341400009],
            [28.47315514400009, 43.366848049000055],
            [28.45948326900009, 43.38068268400008],
            [28.41456139400009, 43.398871161000045],
            [28.404958530000044, 43.40468984600005],
            [28.393809441000087, 43.41429271000004],
            [28.368662957000083, 43.42177969000005],
            [28.32162519600007, 43.42829010600008],
            [28.299164259000065, 43.425034898000035],
            [28.261566602000073, 43.41095612200007],
            [28.243174675000034, 43.40778229400007],
            [28.177989129000082, 43.40997955900008],
            [28.157237175000034, 43.40778229400007],
            [28.11882571700005, 43.39154694200005],
            [28.09156334700009, 43.36395905200004],
            [28.087006056000064, 43.35525136900009],
            [28.031097852000073, 43.24896881700005],
            [28.017588738000086, 43.23273346600007],
            [28.000173373000052, 43.22321198100008],
            [27.931976759000065, 43.20978424700007],
            [27.920583530000044, 43.20404694200005],
            [27.91382897200009, 43.202337958000044],
            [27.90398196700005, 43.202337958000044],
            [27.90398196700005, 43.19550202000005],
            [27.938731316000087, 43.17649974200003],
            [27.945567254000082, 43.168850002000056],
            [27.944346550000034, 43.157131252000056],
            [27.92514082100007, 43.11359284100007],
            [27.911387566000087, 43.06517161700003],
            [27.904307488000086, 43.055853583000044],
            [27.895518425000034, 43.049261786000045],
            [27.887705925000034, 43.04214101800005],
            [27.883555535000085, 43.03099192900004],
            [27.885427280000044, 43.00861237200007],
            [27.900401238000086, 42.962876695000034],
            [27.90398196700005, 42.942287502000056],
            [27.898448113000086, 42.874660549000055],
            [27.90398196700005, 42.85968659100007],
            [27.883962436000047, 42.84837474200003],
            [27.883555535000085, 42.83193594000005],
            [27.891612175000034, 42.81037018400008],
            [27.897146030000044, 42.78400299700007],
            [27.897146030000044, 42.73623281500005],
            [27.894704623000052, 42.71747467700004],
            [27.89226321700005, 42.71051666900007],
            [27.841075066000087, 42.708319403000075],
            [27.787364129000082, 42.71515534100007],
            [27.743174675000034, 42.716050523000035],
            [27.732676629000082, 42.714504299000055],
            [27.725596550000034, 42.70848216400009],
            [27.719004754000082, 42.694566148000035],
            [27.715830925000034, 42.68374258000006],
            [27.716970248000052, 42.67450592700004],
            [27.724131707000083, 42.66697825700004],
            [27.739512566000087, 42.66107819200005],
            [27.712738477000073, 42.65766022300005],
            [27.669200066000087, 42.64370351800005],
            [27.646739129000082, 42.64057038000004],
            [27.628428582000083, 42.628973700000074],
            [27.630381707000083, 42.602728583000044],
            [27.641449415000068, 42.57477448100008],
            [27.65015709700009, 42.55805084800005],
            [27.634043816000087, 42.563706773000035],
            [27.540863477000073, 42.56549713700008],
            [27.51148522200009, 42.55304596600007],
            [27.49854576900009, 42.532456773000035],
            [27.491465691000087, 42.50775788000004],
            [27.48015384200005, 42.48289622600004],
            [27.46225019600007, 42.489569403000075],
            [27.45289147200009, 42.480129299000055],
            [27.453379754000082, 42.46523672100005],
            [27.465668165000068, 42.45563385600008],
            [27.462087436000047, 42.44871653900009],
            [27.461110873000052, 42.44354889500005],
            [27.465668165000068, 42.42829010600008],
            [27.46843509200005, 42.43577708500004],
            [27.469899936000047, 42.43707916900007],
            [27.469411655000044, 42.437201239000046],
            [27.465668165000068, 42.44135163000004],
            [27.472666863000086, 42.46185944200005],
            [27.503916863000086, 42.43732330900008],
            [27.51417076900009, 42.43512604400007],
            [27.526377800000034, 42.44367096600007],
            [27.534434441000087, 42.45526764500005],
            [27.544444207000083, 42.46002838700008],
            [27.562022332000083, 42.44818756700005],
            [27.571055535000085, 42.45848216400009],
            [27.579600457000083, 42.45722077000005],
            [27.587738477000073, 42.45148346600007],
            [27.595550977000073, 42.44818756700005],
            [27.609629754000082, 42.451157945000034],
            [27.619476759000065, 42.45587799700007],
            [27.62940514400009, 42.458644924000055],
            [27.643321160000085, 42.45563385600008],
            [27.642832879000082, 42.450506903000075],
            [27.641774936000047, 42.44953034100007],
            [27.639821811000047, 42.44977448100008],
            [27.63648522200009, 42.44818756700005],
            [27.642425977000073, 42.430894273000035],
            [27.652191602000073, 42.41852448100008],
            [27.66773522200009, 42.416083075000074],
            [27.691661004000082, 42.42829010600008],
            [27.693532748000052, 42.41889069200005],
            [27.699066602000073, 42.41388580900008],
            [27.707855665000068, 42.41274648600006],
            [27.719004754000082, 42.41469961100006],
            [27.719004754000082, 42.40721263200004],
            [27.713226759000065, 42.405951239000046],
            [27.698008660000085, 42.400376695000034],
            [27.705414259000065, 42.390611070000034],
            [27.709646030000044, 42.38812897300005],
            [27.719004754000082, 42.386704820000034],
            [27.70948326900009, 42.37677643400008],
            [27.70834394600007, 42.36310455900008],
            [27.714366082000083, 42.34918854400007],
            [27.725840691000087, 42.33893463700008],
            [27.740407748000052, 42.33429596600007],
            [27.752126498000052, 42.33539459800005],
            [27.764496290000068, 42.338324286000045],
            [27.780446811000047, 42.33893463700008],
            [27.780446811000047, 42.33270905200004],
            [27.774587436000047, 42.32721588700008],
            [27.774424675000034, 42.32172272300005],
            [27.779144727000073, 42.31631094000005],
            [27.787852410000085, 42.310980536000045],
            [27.762950066000087, 42.29559967700004],
            [27.751149936000047, 42.277044989000046],
            [27.755869988000086, 42.25849030200004],
            [27.780446811000047, 42.243353583000044],
            [27.776052280000044, 42.240668036000045],
            [27.775645379000082, 42.23965078300006],
            [27.773692254000082, 42.23590729400007],
            [27.809743686000047, 42.218410549000055],
            [27.815277540000068, 42.21198151200008],
            [27.81999759200005, 42.20465729400007],
            [27.83139082100007, 42.195013739000046],
            [27.844899936000047, 42.18610260600008],
            [27.856211785000085, 42.181301174000055],
            [27.854177280000044, 42.17792389500005],
            [27.851410352000073, 42.17011139500005],
            [27.84937584700009, 42.16705963700008],
            [27.879079623000052, 42.15424225500004],
            [27.886729363000086, 42.147365627000056],
            [27.90398196700005, 42.11981842700004],
            [27.957774285000085, 42.09430573100008],
            [27.964366082000083, 42.08462148600006],
            [27.972666863000086, 42.075384833000044],
            [27.986582879000082, 42.07208893400008],
            [27.982432488000086, 42.06110260600008],
            [27.987315300000034, 42.05174388200004],
            [27.996918165000068, 42.04401276200008],
            [28.007009311000047, 42.03790924700007],
            [28.00757897200009, 42.032904364000046],
            [28.006114129000082, 42.03156159100007],
            [28.003428582000083, 42.03148021000004],
            [28.000173373000052, 42.030462958000044],
            [28.011566602000073, 42.02138906500005],
            [28.019053582000083, 42.00844961100006],
            [28.020355665000068, 41.994574286000045],
            [28.013845248000052, 41.98265208500004],
            [28.016774936000047, 41.97256094000005],
            [27.981009969000098, 41.978524069000045],
            [27.965920451000102, 41.982141419000115],
            [27.91703454600011, 41.97790395100007],
            [27.903391968000108, 41.98105621300003],
            [27.876933634000096, 41.99071970700005],
            [27.85223230000011, 41.99544810000002],
            [27.843033895000104, 41.995758159],
            [27.824016968000137, 41.993484395000095],
            [27.819934529000108, 41.99469879200002],
            [27.815955445000043, 41.99513804200005],
            [27.81192468200004, 41.99469879200002],
            [27.807997274000087, 41.993484395000095],
            [27.80494836400007, 41.98343332900005],
            [27.804896687000053, 41.96989410400009],
            [27.802726278000137, 41.96004974400002],
            [27.818280884000075, 41.952866720000046],
            [27.81533532700007, 41.946794739000026],
            [27.802829631000066, 41.943074036],
            [27.78980717000013, 41.9426864630001],
            [27.776164592000043, 41.94612294500003],
            [27.723971395000063, 41.96759450300006],
            [27.68707442200011, 41.968602193000024],
            [27.609301392000106, 41.95348683700003],
            [27.60687259900004, 41.943513285],
            [27.60335860200007, 41.93862986300009],
            [27.598087606000064, 41.93860402500009],
            [27.59054284700011, 41.942893169000044],
            [27.582377970000067, 41.93488332200006],
            [27.572197713, 41.92984486900009],
            [27.55075199400008, 41.92421213800007],
            [27.55209558100006, 41.921835022000025],
            [27.55488610800012, 41.920336405000015],
            [27.557935018000137, 41.91907033400007],
            [27.560673869000084, 41.9176750700001],
            [27.55746993000011, 41.91550465900009],
            [27.55126875800002, 41.913101705000045],
            [27.548891642000086, 41.910879619000056],
            [27.56274092600006, 41.90643544500004],
            [27.54641117300011, 41.90116444900009],
            [27.533182007000107, 41.908063253000094],
            [27.50946252400007, 41.93317799900011],
            [27.494321330000048, 41.94284149200003],
            [27.420837443000096, 41.97371816000002],
            [27.39685957800006, 41.98932444300006],
            [27.374845418000092, 42.00870310500004],
            [27.33247074400009, 42.057433981000074],
            [27.305288940000082, 42.07758778900005],
            [27.2733529060001, 42.091747132000094],
            [27.238212931000078, 42.09792246500008],
            [27.216405477000137, 42.09562286400005],
            [27.203796427000015, 42.08812978100009],
            [27.181575561000074, 42.065883077000066],
            [27.178991740000072, 42.06187815400007],
            [27.17816491700006, 42.058364156000025],
            [27.17382409700008, 42.05707224600006],
            [27.149587849000085, 42.06182647800007],
            [27.127211954000103, 42.06257578600007],
            [27.116049845000077, 42.06182647800007],
            [27.100650268000095, 42.071102397000075],
            [27.083700398000076, 42.07841461200006],
            [27.065510294000035, 42.08270375600004],
            [27.047903041000097, 42.08291964900006],
            [27.046545044000084, 42.0829363000001],
            [27.022618856000094, 42.07389292400005],
            [27.000397990000067, 42.04280955000009],
            [26.981071004000086, 42.032861837],
            [26.967170044000113, 42.0284951790001],
            [26.958230021000105, 42.018237406000125],
            [26.950065144000064, 42.006170960000034],
            [26.93890303500004, 41.99622324700003],
            [26.930221395000075, 41.99451792400008],
            [26.911462850000078, 41.996791687],
            [26.901075887000076, 41.993484395000095],
            [26.89032718900006, 41.985422873000104],
            [26.881128784000055, 41.985526225000044],
            [26.871723674000094, 41.988135885000034],
            [26.86076826900012, 41.98790334100006],
            [26.850019572000093, 41.98286488900003],
            [26.837899181000097, 41.975219503000076],
            [26.82769535300011, 41.96878306100008],
            [26.81942712400007, 41.96565663600005],
            [26.808420044000087, 41.967878724000045],
            [26.78991988100006, 41.97994517000002],
            [26.780566447000126, 41.98343332900005],
            [26.76857751500006, 41.98077199400005],
            [26.746976766000103, 41.9644939170001],
            [26.736744833000103, 41.95896453900012],
            [26.717572876000105, 41.95731089300007],
            [26.62357344600008, 41.96904144400004],
            [26.605693400000092, 41.96741363600002],
            [26.589467, 41.95875783400005],
            [26.560631552000075, 41.935684306],
            [26.553293497000084, 41.93157603000007],
            [26.547092326000097, 41.926899312],
            [26.54295821100007, 41.92036224400003],
            [26.54471521000005, 41.91643483500006],
            [26.556807495000044, 41.910750427000025],
            [26.55980472800013, 41.9073397830001],
            [26.55897790500012, 41.901732890000076],
            [26.554740438000067, 41.89294789700007],
            [26.553603557000145, 41.88770273900006],
            [26.552894853000026, 41.88164332500007],
            [26.55205326300012, 41.87444773400004],
            [26.547815796000094, 41.856283468000115],
            [26.539547567000028, 41.83799001100006],
            [26.526111694000093, 41.8242440800001],
            [26.4783626710001, 41.81328867600003],
            [26.37552657100008, 41.81662180600004],
            [26.334185425000044, 41.789543355],
            [26.320026082000084, 41.76546213800013],
            [26.316305379000084, 41.743758036000045],
            [26.323230021000143, 41.723681743000085],
            [26.333358602000118, 41.713036397000096],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'San Marino',
        iso3: 'SMR',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [12.4294503590001, 43.892055515],
            [12.399581381000075, 43.903217625000124],
            [12.385628745000105, 43.924534153000124],
            [12.395653973000037, 43.94840866400001],
            [12.411048669000138, 43.95966101200004],
            [12.42138883600012, 43.96721888500012],
            [12.453324871000092, 43.97905278900005],
            [12.482160321000038, 43.98256678600008],
            [12.48918831500012, 43.9731099990001],
            [12.492392254000094, 43.956418511],
            [12.490325196000128, 43.93915858300009],
            [12.48309447400004, 43.92920489800004],
            [12.482160321000038, 43.92791895900005],
            [12.479576499000132, 43.92580022500006],
            [12.478026206000095, 43.92321640400006],
            [12.477493853000112, 43.92005098400007],
            [12.478286774000082, 43.917037885000084],
            [12.460456219000037, 43.895259454000055],
            [12.4294503590001, 43.892055515],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Monaco',
        iso3: 'MCO',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [7.43745403212602, 43.74336054083465],
            [7.432845087000089, 43.739852548000044],
            [7.417956880000077, 43.73090382500004],
            [7.404319061000081, 43.71796907700008],
            [7.380722515000059, 43.71927314100009],
            [7.365750207000076, 43.72273028300002],
            [7.367262599000071, 43.73412453300007],
            [7.372655477000052, 43.74583221500002],
            [7.387538289000105, 43.7578986620001],
            [7.406968628000072, 43.76350555400002],
            [7.426246111000125, 43.755464229000026],
            [7.43745403212602, 43.74336054083465],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Andorra',
        iso3: 'AND',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [1.707006470000067, 42.50278147400006],
            [1.697498006000075, 42.49446156900011],
            [1.68633589600006, 42.49061167500007],
            [1.674243611000065, 42.490508321000036],
            [1.662358032000043, 42.49371226],
            [1.659774210000137, 42.496812846000054],
            [1.656983683000078, 42.497639669000066],
            [1.653986450000076, 42.496528626000085],
            [1.650369100000091, 42.49340220200013],
            [1.639517049000119, 42.466427104],
            [1.607477661000132, 42.45642771400007],
            [1.544432414000084, 42.45035573400013],
            [1.538851359000091, 42.44565317800006],
            [1.534510539000109, 42.43991709400008],
            [1.528206014000091, 42.434232686000044],
            [1.516630493000122, 42.42950429300005],
            [1.508465617000127, 42.42867747000004],
            [1.447900838000066, 42.43464609800007],
            [1.436428670000055, 42.44095062300006],
            [1.436428670000055, 42.453482158000085],
            [1.407593221000099, 42.48676178000004],
            [1.424543090000014, 42.49247202600007],
            [1.430227498000079, 42.493557231000054],
            [1.449967895000043, 42.50407338400002],
            [1.446557251000087, 42.51988637400002],
            [1.428987264000114, 42.53146189400006],
            [1.406456339000101, 42.52923980800007],
            [1.409763631000089, 42.54060862200005],
            [1.426300090000097, 42.561795960000026],
            [1.426403442000122, 42.56564585400007],
            [1.418031860000042, 42.56983164500009],
            [1.419272095000082, 42.57926259400004],
            [1.424853150000104, 42.589365336000085],
            [1.42929732200011, 42.59538564100005],
            [1.451414836000112, 42.60205190100005],
            [1.466814412000105, 42.64145518000005],
            [1.498440389000109, 42.64024078400003],
            [1.527792602000062, 42.64853485200008],
            [1.543088827000133, 42.64936167400002],
            [1.597349081000061, 42.62192148900006],
            [1.608304484000143, 42.618123271000016],
            [1.721992635000049, 42.60985504200006],
            [1.713310995000086, 42.58954620400006],
            [1.729434041000076, 42.5820014450001],
            [1.752688435000067, 42.57667877200005],
            [1.761107147000132, 42.567646197],
            [1.765090780000151, 42.56337209100003],
            [1.739976033000119, 42.56164093000005],
            [1.721682577000138, 42.54851511600002],
            [1.710623820000137, 42.52774119100006],
            [1.707006470000067, 42.50278147400006],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Montenegro',
        iso3: 'MNE',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [18.496429884000065, 42.41632721600007],
            [18.497816202000138, 42.431157939000016],
            [18.492855265000088, 42.44237172400007],
            [18.475491984000087, 42.449813131000084],
            [18.467740519000074, 42.45337880500004],
            [18.454924764000083, 42.464721782000126],
            [18.444279419000082, 42.477925110000015],
            [18.437148071000053, 42.49340220200013],
            [18.436424602000073, 42.51076548300004],
            [18.442005656000077, 42.54301157700009],
            [18.43735477700011, 42.55921213800009],
            [18.447690064000113, 42.56621429500011],
            [18.45895552500008, 42.56972829200005],
            [18.470531047000122, 42.56905649900007],
            [18.481796509000077, 42.56368214900003],
            [18.49213179500009, 42.564767355000114],
            [18.49585249800012, 42.570865174000076],
            [18.493682088000128, 42.579831034],
            [18.486654093000112, 42.58983042400003],
            [18.506797873000068, 42.59849020800006],
            [18.517246542000123, 42.602982077],
            [18.53843387800009, 42.618304139000074],
            [18.542832323000113, 42.62642904400006],
            [18.549595988000107, 42.638923035000076],
            [18.550009400000107, 42.668068543000075],
            [18.539674113000103, 42.69545705200004],
            [18.522517537000056, 42.7118901570001],
            [18.50215702300011, 42.727444763],
            [18.467430460000088, 42.76919932100007],
            [18.4538912350001, 42.79315134700006],
            [18.44458947700008, 42.81707753600007],
            [18.44365930200013, 42.8344666550001],
            [18.45347782400009, 42.84565460300003],
            [18.465983520000094, 42.85281178800007],
            [18.473321574000096, 42.86255279500004],
            [18.467637166000145, 42.881698914000125],
            [18.44396936000001, 42.91686472600007],
            [18.43404748600011, 42.93688934400002],
            [18.433530721000068, 42.954200949000025],
            [18.452754354000092, 42.99339752200008],
            [18.483036743000127, 43.014636536000054],
            [18.538950643000106, 43.02388661700006],
            [18.598378540000056, 43.024455058000015],
            [18.638996215000105, 43.020243429000075],
            [18.62111617000005, 43.09644032800007],
            [18.62059940600011, 43.12256276500007],
            [18.62112782100013, 43.124578152000126],
            [18.62907434100009, 43.15488637300005],
            [18.645300741000113, 43.18018198600002],
            [18.68839888500011, 43.22446869000005],
            [18.66431766700009, 43.23317616800004],
            [18.67951053900012, 43.24948008200006],
            [18.80715132600008, 43.31802887],
            [18.83350630700005, 43.32415252700004],
            [18.830302368000076, 43.328157450000035],
            [18.824617960000126, 43.33740753200006],
            [18.821207316000113, 43.341386617000026],
            [18.839604126000097, 43.34782033300009],
            [18.89913537600009, 43.35190277100007],
            [18.923423299000092, 43.34683848100009],
            [18.950295044000086, 43.333066712000075],
            [18.957323038000084, 43.32585785000002],
            [18.957943156000056, 43.318984884000045],
            [18.957116333000045, 43.3118276980001],
            [18.959493449000092, 43.30345611600002],
            [18.968588501000056, 43.292216492000065],
            [18.988949015000088, 43.27294118300004],
            [18.98950569700014, 43.27201610900006],
            [18.992463013000133, 43.26710174600005],
            [19.002901652000077, 43.273948873],
            [19.010859823000146, 43.28232045500009],
            [19.01716434700006, 43.29115712500008],
            [19.022535153000092, 43.29654632500002],
            [19.024709106000103, 43.29872772300003],
            [19.036284627000043, 43.30332692500009],
            [19.062536255000083, 43.304386292000075],
            [19.069667603000113, 43.30883046500007],
            [19.039591919000145, 43.350714213000074],
            [19.009929647000092, 43.41099477200005],
            [18.975306437000086, 43.44427439400009],
            [18.96827844300006, 43.4480984500001],
            [18.9462642820001, 43.443938497],
            [18.946367635000115, 43.44908030300009],
            [18.950708455000097, 43.457296855000024],
            [18.951225219000037, 43.463808085],
            [18.937892700000106, 43.47894928],
            [18.93065799900006, 43.482282410000025],
            [18.91525842300007, 43.48538299600004],
            [18.90564660700005, 43.49062815400008],
            [18.90512984200012, 43.49905141300006],
            [18.91102095500011, 43.507267965],
            [18.920529419000104, 43.51220306400005],
            [18.93892622900009, 43.518946839000066],
            [18.962697388000066, 43.53829966200003],
            [18.977476847000077, 43.54623199500007],
            [19.000214477000043, 43.547885641000036],
            [19.014270467000074, 43.53778289800009],
            [19.02501916500009, 43.523029277],
            [19.038144979000066, 43.5110145070001],
            [19.054991495000138, 43.50669952400004],
            [19.07638553800004, 43.507242127],
            [19.096022583000092, 43.51290069600013],
            [19.122790975000044, 43.535948385],
            [19.147699015000114, 43.53814463300007],
            [19.195344686000055, 43.53279612200005],
            [19.17519087700009, 43.50961924300013],
            [19.175914347000088, 43.48088714600003],
            [19.19224410000004, 43.45453216500006],
            [19.21839237500012, 43.43820241300004],
            [19.355644979000118, 43.39306304900008],
            [19.372284790000037, 43.384226379000054],
            [19.414039347000084, 43.338389384000024],
            [19.473053833000108, 43.29327585900005],
            [19.485146118000102, 43.28009836900007],
            [19.502302693000075, 43.251934713000125],
            [19.512431274000107, 43.24064341300006],
            [19.54784473600006, 43.21881486600007],
            [19.5499483640001, 43.21751820900006],
            [19.58085087100011, 43.187804261000096],
            [19.598110799000096, 43.17620290200004],
            [19.6186780190001, 43.16824473100009],
            [19.66301639800014, 43.15850372300004],
            [19.684617147000097, 43.15672088700005],
            [19.697329549000074, 43.16020904600002],
            [19.70549442500007, 43.166177673000035],
            [19.713555949000067, 43.16560923300007],
            [19.74280481000011, 43.12651601200004],
            [19.761201619000104, 43.108739319],
            [19.781768839000108, 43.09646616600007],
            [19.80512658700013, 43.0899549360001],
            [19.83830285600007, 43.08835296700006],
            [19.87220259600008, 43.090368348000126],
            [19.883778117000105, 43.095691020000075],
            [19.907135864000054, 43.11326100700005],
            [19.91664432800013, 43.11705922500006],
            [19.929150024000137, 43.11390696300002],
            [19.936591431000068, 43.10589711600004],
            [19.942275838000114, 43.09563934300006],
            [19.949820598000144, 43.08592417400011],
            [19.959742472000073, 43.07856028200011],
            [20.019893840000094, 43.04734771800004],
            [20.05438842400011, 43.022220673000064],
            [20.056344255000113, 43.02079597800004],
            [20.116942179000063, 42.97665435800003],
            [20.129464296000094, 42.97360479100003],
            [20.140920044000097, 42.97081492200003],
            [20.19456018100007, 42.96683583600007],
            [20.223188924000056, 42.957663269000065],
            [20.275588827000064, 42.92988718700012],
            [20.337083781000075, 42.906968689000095],
            [20.353620239000065, 42.89097483400006],
            [20.355170532000102, 42.866170146000016],
            [20.345352010000028, 42.827438660000084],
            [20.26442671700005, 42.817258403000025],
            [20.226082805000118, 42.806768087000066],
            [20.21760787000011, 42.80273732500008],
            [20.209236288000056, 42.79170440700007],
            [20.208409464000113, 42.78209259100005],
            [20.209959757000036, 42.77297170100009],
            [20.208409464000113, 42.763282369000066],
            [20.183398071000113, 42.74250844300009],
            [20.149498331000103, 42.74987233500009],
            [20.112084595000056, 42.76653798500003],
            [20.076324503000137, 42.773436789000115],
            [20.06505904100007, 42.76945770300004],
            [20.05563844800008, 42.763866229000044],
            [20.034673299000104, 42.75142262800004],
            [20.02650842300011, 42.743206075],
            [20.024751424000016, 42.723414002000126],
            [20.0361202390001, 42.70798858700003],
            [20.037006251000065, 42.707363097000055],
            [20.094204549000096, 42.666983337],
            [20.10195601400011, 42.65667389],
            [20.103919718000043, 42.65310821600012],
            [20.09058719900011, 42.62734751400002],
            [20.079218384000114, 42.61125030500004],
            [20.07570438600007, 42.60308543000012],
            [20.075394328000073, 42.58696238200004],
            [20.07818485500013, 42.572906393000025],
            [20.07704797300005, 42.55990977],
            [20.064955688000055, 42.54675811800003],
            [20.039220825000143, 42.557765199000116],
            [20.017723429000114, 42.54624135300007],
            [19.981756632000042, 42.51076548300004],
            [19.956331828000117, 42.50531362000005],
            [19.907549276000083, 42.506398824000044],
            [19.882744588000037, 42.49360890700008],
            [19.882537883000083, 42.49340220200013],
            [19.873339477000087, 42.48683929500005],
            [19.835512329000096, 42.47025116000013],
            [19.82906279900007, 42.46872253700003],
            [19.81959598800009, 42.46647878],
            [19.801405884000133, 42.468132426000054],
            [19.78445601400003, 42.474566143000104],
            [19.751589803000087, 42.49340220200013],
            [19.7343298750001, 42.524382223000046],
            [19.730919230000097, 42.53365814300007],
            [19.730299113000115, 42.54042775500001],
            [19.73215946400012, 42.55554311100009],
            [19.73391646400009, 42.56259694500004],
            [19.741357870000115, 42.57440500900013],
            [19.746008749000083, 42.57993438700005],
            [19.747765747000074, 42.57890085900006],
            [19.74688465400007, 42.58892977200013],
            [19.746008749000083, 42.598899639000095],
            [19.737533814000074, 42.6244019570001],
            [19.72213423700009, 42.64608022100002],
            [19.699293254000082, 42.654813538000084],
            [19.676038859000073, 42.64667450000006],
            [19.65803716600007, 42.63461270400002],
            [19.64792688000003, 42.627838441000065],
            [19.621778605000117, 42.60499745700004],
            [19.60503544100007, 42.584843649000064],
            [19.599247681000094, 42.57104604100003],
            [19.5936666260001, 42.54482025200009],
            [19.588085572000068, 42.532857158000056],
            [19.5756832270001, 42.5223410040001],
            [19.5613171790001, 42.51624318500002],
            [19.549328247000062, 42.50859507200006],
            [19.543747192000126, 42.493557231000054],
            [19.543747192000126, 42.49340220200013],
            [19.53165490700013, 42.47477284800006],
            [19.517805623000072, 42.45802968400001],
            [19.50147587100014, 42.44412872400004],
            [19.48173547300007, 42.43449106900003],
            [19.468402954000055, 42.418109640000054],
            [19.417243286000144, 42.374107158000115],
            [19.412075643000065, 42.36839691200005],
            [19.402670532000087, 42.35201548300002],
            [19.400706828000068, 42.34475494400003],
            [19.40132694500005, 42.331060690000115],
            [19.400396769000082, 42.32589304700009],
            [19.30458866300006, 42.215098776],
            [19.274926392000083, 42.19127594100003],
            [19.272032511000106, 42.180682271000066],
            [19.281955677000013, 42.164723366000075],
            [19.282057739000038, 42.164559225000076],
            [19.29776737500009, 42.15166595500007],
            [19.35502486100006, 42.12003997900008],
            [19.36999787700009, 42.10650667600005],
            [19.372491496000094, 42.1042528280001],
            [19.374868612000057, 42.09466685000008],
            [19.356575155000087, 42.06479787200006],
            [19.351717570000062, 42.04761545800001],
            [19.35058068900014, 42.02782338500002],
            [19.35419803900004, 42.00870310500004],
            [19.363396443000113, 41.99363942500004],
            [19.363706503000117, 41.993484395000095],
            [19.3710445560001, 41.98655975400003],
            [19.365773559000075, 41.96971323700005],
            [19.359779093000043, 41.96599253400002],
            [19.351614217000133, 41.9651657110001],
            [19.34644657400011, 41.96154836100003],
            [19.352854452000145, 41.938500672000046],
            [19.35047733600001, 41.931369324000016],
            [19.346653279000066, 41.92617584300011],
            [19.345413045000043, 41.92118906700004],
            [19.345929810000086, 41.914471130000024],
            [19.345309692000114, 41.9103370160001],
            [19.34768680800005, 41.90635793100002],
            [19.356988566000098, 41.899639994],
            [19.36494673700014, 41.8889946500001],
            [19.364223267000057, 41.8628463750001],
            [19.365082227000073, 41.85236237200007],
            [19.346934441000087, 41.86395905200004],
            [19.31023196700005, 41.894517320000034],
            [19.293223504000082, 41.90078359600005],
            [19.220225457000083, 41.918850002000056],
            [19.202972852000073, 41.927069403000075],
            [19.178477410000085, 41.93390534100007],
            [19.170258009000065, 41.93797435100004],
            [19.162282748000052, 41.94794342700004],
            [19.161957227000073, 41.95343659100007],
            [19.163259311000047, 41.958970445000034],
            [19.160329623000052, 41.96898021000004],
            [19.15560957100007, 41.97064850500004],
            [19.145274285000085, 41.97760651200008],
            [19.137950066000087, 41.98529694200005],
            [19.142914259000065, 41.98883698100008],
            [19.14356530000009, 41.993068752000056],
            [19.13917076900009, 42.04242584800005],
            [19.08253014400009, 42.08120351800005],
            [19.07471764400009, 42.09564850500004],
            [19.083832227000073, 42.11009349200003],
            [19.076426629000082, 42.11595286700003],
            [19.063975457000083, 42.12018463700008],
            [19.048675977000073, 42.14020416900007],
            [19.010590040000068, 42.139553127000056],
            [19.002126498000052, 42.15021393400008],
            [18.999847852000073, 42.16107819200005],
            [18.994802280000044, 42.16364166900007],
            [18.98804772200009, 42.163723049000055],
            [18.981618686000047, 42.16705963700008],
            [18.968028191000087, 42.188706773000035],
            [18.953461134000065, 42.19985586100006],
            [18.913340691000087, 42.22223541900007],
            [18.90170332100007, 42.237494208000044],
            [18.894704623000052, 42.27049388200004],
            [18.885996941000087, 42.284369208000044],
            [18.87159264400009, 42.29047272300005],
            [18.85401451900009, 42.29047272300005],
            [18.83887780000009, 42.28571198100008],
            [18.83139082100007, 42.27753327000005],
            [18.826508009000065, 42.28221263200004],
            [18.820485873000052, 42.28668854400007],
            [18.817637566000087, 42.29116445500006],
            [18.801524285000085, 42.284369208000044],
            [18.79395592500009, 42.28034088700008],
            [18.78874759200005, 42.27602773600006],
            [18.786387566000087, 42.27411530200004],
            [18.778575066000087, 42.271470445000034],
            [18.77198326900009, 42.27692291900007],
            [18.762461785000085, 42.29116445500006],
            [18.72950280000009, 42.31159088700008],
            [18.71452884200005, 42.32526276200008],
            [18.714121941000087, 42.33893463700008],
            [18.70834394600007, 42.34247467700004],
            [18.69971764400009, 42.34983958500004],
            [18.693614129000082, 42.353216864000046],
            [18.693614129000082, 42.359442450000074],
            [18.69581139400009, 42.37376536700003],
            [18.678477410000085, 42.385972398000035],
            [18.658539259000065, 42.38662344000005],
            [18.653168165000068, 42.36627838700008],
            [18.646494988000086, 42.36627838700008],
            [18.63843834700009, 42.370306708000044],
            [18.616709832000083, 42.368068752000056],
            [18.61231530000009, 42.36994049700007],
            [18.60710696700005, 42.37641022300005],
            [18.594899936000047, 42.38373444200005],
            [18.580902540000068, 42.389837958000044],
            [18.570648634000065, 42.39297109600005],
            [18.573008660000085, 42.39642975500004],
            [18.573090040000068, 42.39752838700008],
            [18.574066602000073, 42.39826080900008],
            [18.578135613000086, 42.400376695000034],
            [18.552989129000082, 42.41364166900007],
            [18.545176629000082, 42.42357005400004],
            [18.55014082100007, 42.43512604400007],
            [18.562836134000065, 42.43854401200008],
            [18.64494876400005, 42.41836172100005],
            [18.656504754000082, 42.41551341400009],
            [18.685557488000086, 42.403998114000046],
            [18.700450066000087, 42.39297109600005],
            [18.708181186000047, 42.40851471600007],
            [18.706553582000083, 42.42104726800005],
            [18.683848504000082, 42.45880768400008],
            [18.68327884200005, 42.468085028000075],
            [18.687347852000073, 42.48289622600004],
            [18.654144727000073, 42.45180898600006],
            [18.608653191000087, 42.445379950000074],
            [18.50245201900009, 42.45563385600008],
            [18.50245201900009, 42.44818756700005],
            [18.52125084700009, 42.43797435100004],
            [18.512950066000087, 42.40900299700007],
            [18.52979576900009, 42.400376695000034],
            [18.51026451900009, 42.40525950700004],
            [18.496429884000065, 42.41632721600007],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Bosnia and Herz.',
        iso3: 'BIH',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [17.65333092500009, 42.89093659100007],
            [17.65284264400009, 42.89118073100008],
            [17.556488477000073, 42.934759833000044],
            [17.57398522200009, 42.93427155200004],
            [17.601084832000083, 42.92523834800005],
            [17.617930535000085, 42.92177969000005],
            [17.603037957000083, 42.93256256700005],
            [17.58065839900007, 42.94208405200004],
            [17.634509724000083, 42.950402731000096],
            [17.662725057000046, 42.965698955000065],
            [17.6593144120001, 42.99339752200008],
            [17.659211060000075, 42.99344919800008],
            [17.659107707000146, 42.99363006600005],
            [17.659004354000047, 42.99365590500004],
            [17.62841190500012, 43.04657257100003],
            [17.59802550000009, 43.07290235300003],
            [17.58738081800007, 43.08212595700009],
            [17.450913270000115, 43.14815159700005],
            [17.442066691000093, 43.15243174300009],
            [17.42677046700004, 43.165712585000094],
            [17.41519494700009, 43.18496205700002],
            [17.406823365, 43.205425924000096],
            [17.400208781000117, 43.21604543100007],
            [17.389666788000056, 43.223099264],
            [17.36940962800014, 43.23255605100006],
            [17.32868859900009, 43.26035797100012],
            [17.289931275000043, 43.30343027800002],
            [17.2676070550001, 43.353323873000065],
            [17.286417277000083, 43.43737559],
            [17.270500936000076, 43.46321380700003],
            [17.239495077000043, 43.47840667700005],
            [17.142756795000054, 43.489336243000125],
            [17.08456913200007, 43.51323659300003],
            [17.06231406800012, 43.52774706500007],
            [17.030515585000074, 43.548479919],
            [16.98193973800008, 43.5896918750001],
            [16.823809855000093, 43.70730743400004],
            [16.71260217300008, 43.771515401],
            [16.69823612500008, 43.788077698000095],
            [16.68976119000007, 43.80931671200007],
            [16.686143839000096, 43.82613739000003],
            [16.678599081000044, 43.840684306000085],
            [16.637361288000136, 43.86840871200012],
            [16.604805135000106, 43.901068217],
            [16.5558158770001, 43.93747426400007],
            [16.5274466730001, 43.967859174000054],
            [16.516541788000012, 43.97953888000002],
            [16.50103885900009, 43.99271637],
            [16.483468872000117, 44.00253489200007],
            [16.439647258000036, 44.01400706000008],
            [16.43148238100011, 44.02578928700008],
            [16.42693485500007, 44.04051707000009],
            [16.414015747000064, 44.05581329300004],
            [16.403990519000047, 44.058758850000046],
            [16.377945597000064, 44.05736358700007],
            [16.367196899000135, 44.058138733000064],
            [16.35737837700006, 44.06216949500008],
            [16.346112915000106, 44.06847401900008],
            [16.32688928200008, 44.08237498000007],
            [16.312213175000096, 44.09999664400006],
            [16.28999230900007, 44.13911570200007],
            [16.275522908000113, 44.15735748300004],
            [16.23211470500013, 44.19099884000006],
            [16.21578495300011, 44.208155416000025],
            [16.19707808400011, 44.25115020800011],
            [16.18756962000012, 44.28241445000002],
            [16.186639445000083, 44.29760732000004],
            [16.18953332500007, 44.308511048000085],
            [16.199661906000102, 44.32468577100009],
            [16.203175903000073, 44.33305735300006],
            [16.205863078000107, 44.34980051700002],
            [16.20564364200007, 44.35053070800005],
            [16.202865844000087, 44.35977406800002],
            [16.192117146000072, 44.367422181],
            [16.171343221000114, 44.377085673000025],
            [16.153153117000073, 44.38044464200006],
            [16.141991008000048, 44.380754700000026],
            [16.13827030500005, 44.37760243800007],
            [16.138787069000074, 44.38540557900008],
            [16.14540165200009, 44.38959137000005],
            [16.15387658700007, 44.3935704550001],
            [16.159871053000103, 44.40070180300005],
            [16.159664347000046, 44.41610138000003],
            [16.15294641100013, 44.435066630000094],
            [16.12834842900014, 44.48431427100006],
            [16.123077433000105, 44.50389963800008],
            [16.11646285000012, 44.52146962500005],
            [16.104887329000064, 44.532373353000125],
            [16.083699991000117, 44.53490549700011],
            [16.04731978300012, 44.523329977000074],
            [16.0266492100001, 44.52519032800008],
            [16.00608199000004, 44.54100331600007],
            [16.013936809000143, 44.55702301100003],
            [16.030473266000058, 44.572215882000066],
            [16.034917440000072, 44.58539337200004],
            [16.04318566900011, 44.58844228200006],
            [16.044735962000118, 44.589372457000096],
            [16.041118612000048, 44.60280833000006],
            [16.036157674000094, 44.615314026000064],
            [16.028302856000067, 44.624719137000014],
            [16.0160038650001, 44.62895660400007],
            [15.991612589000084, 44.63143707300004],
            [15.979106893000079, 44.63438263000005],
            [15.968978312000047, 44.639240214000054],
            [15.955645792000013, 44.65319285100004],
            [15.948101034000075, 44.67810089100003],
            [15.93735233600006, 44.68895294200006],
            [15.929807577000105, 44.689469707000015],
            [15.921539347000135, 44.686110739000085],
            [15.91306441200004, 44.68450876900006],
            [15.90541630100006, 44.6901415],
            [15.902005656000142, 44.69882314100006],
            [15.899318481000108, 44.709210103000075],
            [15.89559777800011, 44.71856353700012],
            [15.888776489000065, 44.72424794500007],
            [15.876270792000042, 44.72481638600003],
            [15.86924279800013, 44.71856353700012],
            [15.86386844900008, 44.70998525000009],
            [15.856427043000053, 44.703577372000055],
            [15.847848755000115, 44.70151031500008],
            [15.82996870900007, 44.70052846300011],
            [15.820356893000053, 44.698254700000106],
            [15.805680786000067, 44.696652730000054],
            [15.796999146000104, 44.70326731400006],
            [15.790487915000142, 44.71339589500012],
            [15.782839803000059, 44.7225943000001],
            [15.759275350000053, 44.73416982000005],
            [15.75369429500006, 44.73928578700004],
            [15.728476196000088, 44.76910308800005],
            [15.717314087000148, 44.78646637000007],
            [15.716073852000108, 44.80320953400012],
            [15.730646607000097, 44.817007142000065],
            [15.751213827000072, 44.821554667],
            [15.768680460000013, 44.82734242800008],
            [15.773434692000109, 44.84501576800007],
            [15.764029581000045, 44.864032695000034],
            [15.748009888000098, 44.882016094000036],
            [15.734263957000081, 44.9021182260001],
            [15.730853312000136, 44.92723297200011],
            [15.734108149000065, 44.93444011200002],
            [15.738811482000102, 44.944854635000084],
            [15.763616170000148, 44.975550436000034],
            [15.767440226000076, 44.99322377600005],
            [15.755554647000054, 45.023557841000084],
            [15.755968059000054, 45.04221303300007],
            [15.779429158000141, 45.08536285500007],
            [15.783769979000112, 45.100917460000105],
            [15.780049276000113, 45.16029368100003],
            [15.780979451000064, 45.16799347000004],
            [15.792348267000136, 45.18980092400007],
            [15.802568519000147, 45.196473382000036],
            [15.824801066000077, 45.21098826100011],
            [15.878854614000147, 45.21724110900003],
            [15.974559367000069, 45.21538075800002],
            [15.997503703000092, 45.218533021000056],
            [16.00845910600006, 45.218171285000054],
            [16.020448039000115, 45.21393381800003],
            [16.029233032, 45.205045472000094],
            [16.028716268000068, 45.19626047800001],
            [16.02499556500007, 45.18892242500003],
            [16.024375447000097, 45.18432322200006],
            [16.033057088000135, 45.17972402000002],
            [16.054967896000107, 45.176416728000035],
            [16.067473592000113, 45.16959543900008],
            [16.082769816000052, 45.151612041000064],
            [16.104060506000053, 45.11254465800006],
            [16.121527140000097, 45.09616322900011],
            [16.212994426000137, 45.031464335000024],
            [16.241209757000092, 45.01895863900005],
            [16.27934696500006, 45.00717641200005],
            [16.31624393700008, 45.00123362300012],
            [16.34063521300004, 45.005936178000084],
            [16.346019392000073, 45.02001001200006],
            [16.35696496600005, 45.0486209110001],
            [16.37732548000008, 45.07559600900002],
            [16.38197635900005, 45.08370920800003],
            [16.38404341600011, 45.09543975900003],
            [16.38197635900005, 45.10195098900009],
            [16.381769654000095, 45.10758372000002],
            [16.389211060000036, 45.11683380100003],
            [16.39851281700004, 45.12143300400008],
            [16.42476444500008, 45.12727244100007],
            [16.435513143000094, 45.13285349600007],
            [16.449155721000096, 45.14809804300002],
            [16.48191857900011, 45.1995160930001],
            [16.528944133000095, 45.22225372400008],
            [16.587028443000065, 45.22085846],
            [16.7862927650001, 45.17884552100007],
            [16.811717570000013, 45.18122263700012],
            [16.824223266000104, 45.18907745400007],
            [16.82577356000013, 45.19636383100003],
            [16.825050089000058, 45.205045472000094],
            [16.830734497000094, 45.21698272700003],
            [16.84075972500011, 45.224010722000045],
            [16.851921834000052, 45.227421367000076],
            [16.861740357000116, 45.23222727400007],
            [16.86732141100012, 45.243389385000015],
            [16.87538293500012, 45.24695505800007],
            [16.885821574000147, 45.25522328700002],
            [16.893986450000085, 45.263543192],
            [16.896983683000087, 45.268142396000044],
            [16.924372193000124, 45.28452382500008],
            [16.932640421000087, 45.27878774100013],
            [16.940701945000058, 45.257755433000014],
            [16.94214888500005, 45.249848939000074],
            [16.941528768000097, 45.241218974000034],
            [16.947316529000148, 45.23568959600003],
            [16.96798710100009, 45.23729156600005],
            [16.965299926000057, 45.244216207000036],
            [16.96116581200002, 45.250934143000066],
            [16.975945271000057, 45.24716176400004],
            [16.988140909000066, 45.23651641900004],
            [16.998682902000013, 45.231400452000045],
            [17.008294718000116, 45.24416453100012],
            [17.012015421000058, 45.236464742000024],
            [17.013565715000055, 45.230573629000034],
            [17.012532186000072, 45.22447581000007],
            [17.008294718000116, 45.216155905],
            [17.014392537000077, 45.219773255000106],
            [17.03020552500007, 45.22695627900005],
            [17.036303344000146, 45.230470276000105],
            [17.055733683000113, 45.20044626900004],
            [17.0984184160001, 45.17765696200006],
            [17.124628433000083, 45.16905775500008],
            [17.18709517400012, 45.148563131000046],
            [17.197843872000135, 45.15295562800004],
            [17.245489543000076, 45.15538442000009],
            [17.24972701000013, 45.15988026900003],
            [17.268950643000068, 45.18954254200007],
            [17.3078113200001, 45.171404115000044],
            [17.32651818800008, 45.165926412000076],
            [17.359384399000106, 45.150681865000124],
            [17.368582804000113, 45.1451008100001],
            [17.382432088000087, 45.13962310900003],
            [17.40082889800007, 45.14101837200009],
            [17.434108520000024, 45.148563131000046],
            [17.436175578000075, 45.15192209900006],
            [17.438759399000077, 45.158123271000036],
            [17.443306925000115, 45.16205068],
            [17.451161743000057, 45.15848500600005],
            [17.456949503000118, 45.151818746000046],
            [17.45808638500006, 45.146134339000085],
            [17.4549857990001, 45.14060496000009],
            [17.44775109900013, 45.13430043600006],
            [17.460360148000063, 45.13125152600004],
            [17.4723490800001, 45.13275014200006],
            [17.496223592000092, 45.14169016500007],
            [17.487025187000114, 45.12086456400003],
            [17.481857544000093, 45.114405009000066],
            [17.48929895000012, 45.11626536100006],
            [17.53952844300008, 45.120967916000055],
            [17.56143925000012, 45.11936594700002],
            [17.57239465300009, 45.120399476],
            [17.593065226000107, 45.129597880000105],
            [17.629962199000147, 45.15734812500004],
            [17.651562948000105, 45.165357971],
            [17.68473921700013, 45.16396270800003],
            [17.71450484200011, 45.152025452000075],
            [17.741376587000104, 45.13326690700008],
            [17.797497193000055, 45.08195221000004],
            [17.815583944000082, 45.07016998300004],
            [17.835737752000057, 45.06443389900009],
            [17.845659628000135, 45.065260723],
            [17.87521854600007, 45.073994039000084],
            [17.902607056000107, 45.077766419000014],
            [17.911185343000056, 45.08107371100003],
            [17.927721802000036, 45.092029114000084],
            [17.98849328600005, 45.14380890000005],
            [18.003479451000118, 45.14933827800006],
            [18.019085734000072, 45.14944163100007],
            [18.03500207500008, 45.143343812000026],
            [18.090295857000115, 45.10799713100003],
            [18.112413371000116, 45.10060740200002],
            [18.131843709000094, 45.097868551000076],
            [18.143698040000118, 45.09770000500008],
            [18.153651164000024, 45.09755849300008],
            [18.17494185400011, 45.100762431000064],
            [18.192511841000083, 45.108513896000076],
            [18.199333130000127, 45.119004212000036],
            [18.20005659900005, 45.131613262000045],
            [18.202330363000073, 45.144067281000034],
            [18.213285766000126, 45.153782450000065],
            [18.237883748000115, 45.157451477000066],
            [18.26196496600005, 45.150681865000124],
            [18.307440227000114, 45.12753082300013],
            [18.322323039000054, 45.122879944000076],
            [18.392913045000057, 45.11864247600003],
            [18.41203332500004, 45.11244130500005],
            [18.42929325400013, 45.10220937200005],
            [18.45182985200009, 45.08495874500004],
            [18.46608687300011, 45.0740457160001],
            [18.48170818400007, 45.066921352000065],
            [18.49078820800014, 45.06278025300004],
            [18.517039835000077, 45.05585561200006],
            [18.541121053000097, 45.0552871710001],
            [18.539260702000092, 45.06934316000003],
            [18.534403117000096, 45.08153879900003],
            [18.534802705000118, 45.0884117180001],
            [18.53491988100012, 45.09042714500005],
            [18.549595988000107, 45.09476796500003],
            [18.557657511000087, 45.09440623000005],
            [18.573780558000095, 45.09156402600006],
            [18.581842082000065, 45.09135732100002],
            [18.588560018000095, 45.09321767200002],
            [18.602512654000094, 45.09926381500004],
            [18.6091272380001, 45.100090637000065],
            [18.61667199700014, 45.09766184500002],
            [18.62111617000005, 45.093114319000094],
            [18.627937459000094, 45.08004018200005],
            [18.633621867000045, 45.07197865800005],
            [18.640546509000018, 45.06536407500003],
            [18.648711385000126, 45.06267690000003],
            [18.658116495000087, 45.0662942500001],
            [18.661217082000036, 45.071100159000096],
            [18.663284139000098, 45.07714630100004],
            [18.66607466600007, 45.08298573900002],
            [18.67134566200008, 45.08686147000007],
            [18.678166951000037, 45.08737823500003],
            [18.684058065000045, 45.08479441400003],
            [18.689019002000094, 45.080246888],
            [18.726329386000117, 45.026141663],
            [18.738318319000086, 45.015909729],
            [18.750100546000084, 45.0122407030001],
            [18.77800581900007, 45.01032867400009],
            [18.784930461000044, 45.00846832300009],
            [18.78896122200004, 45.005729472000056],
            [18.7917517490001, 45.001543681],
            [18.794645630000105, 44.99544586200004],
            [18.795162394000045, 44.993327129000065],
            [18.795162394000045, 44.98800445600004],
            [18.795782512000102, 44.98505889900012],
            [18.797952921000103, 44.98221669500005],
            [18.80301721200007, 44.977307435000014],
            [18.80456750500008, 44.97384511300008],
            [18.801570271000088, 44.963974915000094],
            [18.779866170000076, 44.952244364000094],
            [18.772631469000117, 44.942477519000064],
            [18.783380167000132, 44.91374542300004],
            [18.81779667200007, 44.88754547200004],
            [18.842129476000054, 44.87623932000007],
            [18.858724406000107, 44.868528545000075],
            [18.889626912000097, 44.86119049100007],
            [18.974915914052342, 44.86275717986024],
            [19.00496870900014, 44.86330922500004],
            [19.015820760000082, 44.86563466400007],
            [19.047756795000055, 44.8727143360001],
            [19.068427368000073, 44.874833069000076],
            [19.084550415000052, 44.87896718400002],
            [19.174260701000037, 44.92542429700002],
            [19.186869751000074, 44.92754303],
            [19.193174276000065, 44.92154856400008],
            [19.196894979000092, 44.913176982],
            [19.201855916000028, 44.90837107300008],
            [19.211881144000074, 44.90837107300008],
            [19.22955448400006, 44.91374542300004],
            [19.239476359000065, 44.91514068700003],
            [19.283814738000103, 44.90837107300008],
            [19.29301314300011, 44.909404602000066],
            [19.301281372000062, 44.91235015900007],
            [19.310169718000054, 44.91235015900007],
            [19.330220174000118, 44.89870758100007],
            [19.340142049000093, 44.89622711200009],
            [19.35027062900005, 44.89700225900002],
            [19.352957805000102, 44.898087463000095],
            [19.353164510000056, 44.899017639000036],
            [19.3569823040001, 44.895877196000086],
            [19.362776327000063, 44.891111145000096],
            [19.368667440000053, 44.88713206000001],
            [19.37280155400009, 44.88144765300008],
            [19.37569543400008, 44.87312774700011],
            [19.376625610000104, 44.86299916600005],
            [19.373111613000077, 44.86026031500002],
            [19.367840617000127, 44.85927846300005],
            [19.363706503000117, 44.854627584000085],
            [19.328359822000095, 44.733963115],
            [19.31802453600011, 44.71546295200007],
            [19.308412720000092, 44.70512766500006],
            [19.2882589110001, 44.69303538000007],
            [19.277613566000127, 44.684870504000074],
            [19.270068807000058, 44.67562042200005],
            [19.25570275900006, 44.645648092],
            [19.2086772050001, 44.58839060500004],
            [19.20412967900006, 44.58513499000007],
            [19.19327762800009, 44.58058746400003],
            [19.188316691000068, 44.57603993700009],
            [19.186249633000102, 44.56932200200008],
            [19.187283162000085, 44.553302307000095],
            [19.185319458000038, 44.546222636],
            [19.179635051000105, 44.53826446500004],
            [19.173123820000114, 44.53144317700007],
            [19.165269002000088, 44.52668894500009],
            [19.129922323000102, 44.518317363],
            [19.127338500000093, 44.50255605100004],
            [19.143358195000133, 44.45821767200009],
            [19.141394490000096, 44.43082916300004],
            [19.129612264000116, 44.416153056000056],
            [19.115762980000056, 44.403595683000034],
            [19.107184693000107, 44.38271840400007],
            [19.108941691000098, 44.36364980100008],
            [19.116693156000082, 44.34370269800006],
            [19.13891402200005, 44.309337871000125],
            [19.15700077300005, 44.293576559000044],
            [19.177154582000128, 44.28696197600006],
            [19.22004602000007, 44.280244039000124],
            [19.240716594000105, 44.27269928000008],
            [19.249501587000083, 44.270735576000035],
            [19.26366093000013, 44.27016713500008],
            [19.295907023000098, 44.275799866000014],
            [19.30737919100011, 44.274197896],
            [19.3243290610001, 44.26396596300002],
            [19.341588989000087, 44.24582753500006],
            [19.353991333000067, 44.22433014000002],
            [19.356058390000044, 44.20402130100011],
            [19.362362915000062, 44.191205547000024],
            [19.381173136000143, 44.17709788000009],
            [19.424891398000028, 44.15379181000007],
            [19.435536743000114, 44.14609202100006],
            [19.442564738000044, 44.14319814],
            [19.448455851000034, 44.144438375000036],
            [19.459721313000102, 44.15270660400007],
            [19.46571577900002, 44.152809957],
            [19.474190714000116, 44.14490346300006],
            [19.47636112500004, 44.127023417000075],
            [19.482665649000126, 44.120667217000076],
            [19.498168579000037, 44.11022857700003],
            [19.516189487000133, 44.09119350600007],
            [19.52204309100003, 44.085010478000086],
            [19.55459924300007, 44.07126454700004],
            [19.570928995000116, 44.05689849900004],
            [19.580230753000137, 44.05152415000008],
            [19.58384810400011, 44.05431467800004],
            [19.589945923000073, 44.06030914400007],
            [19.598937622000022, 44.06258290600009],
            [19.611443319000017, 44.05452138300008],
            [19.618884725000044, 44.035711161000066],
            [19.610409790000034, 44.01927805700002],
            [19.593356567000114, 44.005583802],
            [19.55222212700005, 43.98341461200006],
            [19.528554321000087, 43.977213441000075],
            [19.504059692000055, 43.97566314700008],
            [19.447112264000083, 43.979797262],
            [19.39398889200004, 43.977058411000044],
            [19.37910607900008, 43.97385447200007],
            [19.364636678000068, 43.97328603100003],
            [19.351717570000062, 43.979125468000106],
            [19.32587935400005, 43.996592102000065],
            [19.300557902000065, 44.00951121000007],
            [19.287328735000074, 44.01302520800003],
            [19.272755981000103, 44.01240509000006],
            [19.252085409000074, 44.007495830000025],
            [19.24350712100005, 44.00201812800013],
            [19.23802941900007, 43.99250966400005],
            [19.238132771000096, 43.98537831600002],
            [19.242887003000078, 43.972820944],
            [19.240716594000105, 43.96574127200007],
            [19.22934777800009, 43.957679748000075],
            [19.241026652000073, 43.95235707700003],
            [19.275443156000023, 43.93326263400006],
            [19.305932251000115, 43.904737244],
            [19.359469035000075, 43.842208761],
            [19.46168501800014, 43.76213612900004],
            [19.48173547300007, 43.7292182420001],
            [19.505713338000106, 43.67364023900011],
            [19.507366984000043, 43.647181905000096],
            [19.48173547300007, 43.62891428700006],
            [19.477498006000133, 43.61697703],
            [19.47563765400011, 43.60255930600009],
            [19.476877889000065, 43.58868418400003],
            [19.48173547300007, 43.578116353000055],
            [19.488970174000144, 43.57318125500011],
            [19.491760702000107, 43.56860789000005],
            [19.4895902910001, 43.564447937000025],
            [19.48173547300007, 43.56083058700004],
            [19.44390832500011, 43.57186350600004],
            [19.431816040000115, 43.571140035000056],
            [19.41931034400011, 43.549255067],
            [19.410732056000086, 43.54075429300009],
            [19.402877238000144, 43.54964263900011],
            [19.394609009000106, 43.56646331800009],
            [19.38044966600006, 43.58558359800007],
            [19.363396443000113, 43.60157745400004],
            [19.346549926000137, 43.60883799200009],
            [19.335801228000037, 43.60651255300006],
            [19.312650187000145, 43.593154195000025],
            [19.300867960000033, 43.58829661100002],
            [19.289189087000068, 43.5879348750001],
            [19.26366093000013, 43.590957947000035],
            [19.252705525000067, 43.588632507000014],
            [19.238856242000082, 43.57212188700002],
            [19.229451131000133, 43.54974599200004],
            [19.217462199000067, 43.53279612200005],
            [19.195344686000055, 43.53279612200005],
            [19.147699015000114, 43.53814463300007],
            [19.122790975000044, 43.535948385],
            [19.096022583000092, 43.51290069600013],
            [19.07638553800004, 43.507242127],
            [19.054991495000138, 43.50669952400004],
            [19.038144979000066, 43.5110145070001],
            [19.02501916500009, 43.523029277],
            [19.014270467000074, 43.53778289800009],
            [19.000214477000043, 43.547885641000036],
            [18.977476847000077, 43.54623199500007],
            [18.962697388000066, 43.53829966200003],
            [18.93892622900009, 43.518946839000066],
            [18.920529419000104, 43.51220306400005],
            [18.91102095500011, 43.507267965],
            [18.90512984200012, 43.49905141300006],
            [18.90564660700005, 43.49062815400008],
            [18.91525842300007, 43.48538299600004],
            [18.93065799900006, 43.482282410000025],
            [18.937892700000106, 43.47894928],
            [18.951225219000037, 43.463808085],
            [18.950708455000097, 43.457296855000024],
            [18.946367635000115, 43.44908030300009],
            [18.9462642820001, 43.443938497],
            [18.96827844300006, 43.4480984500001],
            [18.975306437000086, 43.44427439400009],
            [19.009929647000092, 43.41099477200005],
            [19.039591919000145, 43.350714213000074],
            [19.069667603000113, 43.30883046500007],
            [19.062536255000083, 43.304386292000075],
            [19.036284627000043, 43.30332692500009],
            [19.024709106000103, 43.29872772300003],
            [19.022535153000092, 43.29654632500002],
            [19.01716434700006, 43.29115712500008],
            [19.010859823000146, 43.28232045500009],
            [19.002901652000077, 43.273948873],
            [18.992463013000133, 43.26710174600005],
            [18.98950569700014, 43.27201610900006],
            [18.988949015000088, 43.27294118300004],
            [18.968588501000056, 43.292216492000065],
            [18.959493449000092, 43.30345611600002],
            [18.957116333000045, 43.3118276980001],
            [18.957943156000056, 43.318984884000045],
            [18.957323038000084, 43.32585785000002],
            [18.950295044000086, 43.333066712000075],
            [18.923423299000092, 43.34683848100009],
            [18.89913537600009, 43.35190277100007],
            [18.839604126000097, 43.34782033300009],
            [18.821207316000113, 43.341386617000026],
            [18.824617960000126, 43.33740753200006],
            [18.830302368000076, 43.328157450000035],
            [18.83350630700005, 43.32415252700004],
            [18.80715132600008, 43.31802887],
            [18.67951053900012, 43.24948008200006],
            [18.66431766700009, 43.23317616800004],
            [18.68839888500011, 43.22446869000005],
            [18.645300741000113, 43.18018198600002],
            [18.62907434100009, 43.15488637300005],
            [18.62112782100013, 43.124578152000126],
            [18.62059940600011, 43.12256276500007],
            [18.62111617000005, 43.09644032800007],
            [18.638996215000105, 43.020243429000075],
            [18.598378540000056, 43.024455058000015],
            [18.538950643000106, 43.02388661700006],
            [18.483036743000127, 43.014636536000054],
            [18.452754354000092, 42.99339752200008],
            [18.433530721000068, 42.954200949000025],
            [18.43404748600011, 42.93688934400002],
            [18.44396936000001, 42.91686472600007],
            [18.467637166000145, 42.881698914000125],
            [18.473321574000096, 42.86255279500004],
            [18.465983520000094, 42.85281178800007],
            [18.45347782400009, 42.84565460300003],
            [18.44365930200013, 42.8344666550001],
            [18.44458947700008, 42.81707753600007],
            [18.4538912350001, 42.79315134700006],
            [18.467430460000088, 42.76919932100007],
            [18.50215702300011, 42.727444763],
            [18.522517537000056, 42.7118901570001],
            [18.539674113000103, 42.69545705200004],
            [18.550009400000107, 42.668068543000075],
            [18.549595988000107, 42.638923035000076],
            [18.542832323000113, 42.62642904400006],
            [18.53843387800009, 42.618304139000074],
            [18.517246542000123, 42.602982077],
            [18.506797873000068, 42.59849020800006],
            [18.486654093000112, 42.58983042400003],
            [18.493682088000128, 42.579831034],
            [18.49585249800012, 42.570865174000076],
            [18.49213179500009, 42.564767355000114],
            [18.481796509000077, 42.56368214900003],
            [18.470531047000122, 42.56905649900007],
            [18.45895552500008, 42.56972829200005],
            [18.447690064000113, 42.56621429500011],
            [18.43735477700011, 42.55921213800009],
            [18.42102502500009, 42.563630473],
            [18.385264933000144, 42.566524353],
            [18.370485474000134, 42.57362986300002],
            [18.369782537000077, 42.574392828],
            [18.349608195000087, 42.596289979000076],
            [18.3386527910001, 42.60251698900008],
            [18.31157434100004, 42.60122507800013],
            [18.25710738100014, 42.61489349400004],
            [18.22413781700007, 42.62807098500012],
            [18.049368124000097, 42.71475820000008],
            [17.995314575000094, 42.74044138700005],
            [17.971853475000046, 42.75496246400009],
            [17.928858684000147, 42.79080006900004],
            [17.904467407000112, 42.804546],
            [17.869430786000095, 42.81180653900013],
            [17.858475382000023, 42.81697418200004],
            [17.82715946400012, 42.853121847000054],
            [17.825092408000074, 42.86454233900007],
            [17.826229288000064, 42.8886493940001],
            [17.823335408000077, 42.898364563000044],
            [17.81175988700005, 42.90986257000007],
            [17.802664836000076, 42.909630026000016],
            [17.794706665000092, 42.90459157300005],
            [17.78674849500004, 42.90138763500006],
            [17.76545780400005, 42.90412648600004],
            [17.723599894000074, 42.91624460900003],
            [17.701585734000105, 42.919500225],
            [17.679468221000093, 42.91567616800005],
            [17.665928996000105, 42.905160014],
            [17.65333092500009, 42.89093659100007],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Portugal',
        iso3: 'PRT',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-7.104858764999988, 38.827191874000086],
              [-7.15100581899992, 38.81928538000004],
              [-7.160617634999937, 38.81290334100002],
              [-7.166198689999931, 38.80342071500003],
              [-7.179737914999919, 38.79088918000012],
              [-7.196429402999854, 38.779985454000055],
              [-7.211518920999964, 38.775360413],
              [-7.22587838499993, 38.76613382800009],
              [-7.27043005399986, 38.737507427000125],
              [-7.272187052999925, 38.733735047],
              [-7.280713663999961, 38.72042836600009],
              [-7.284072631999976, 38.71324534100005],
              [-7.290945596999933, 38.67908721900004],
              [-7.292960977999883, 38.65627207400006],
              [-7.292495889999941, 38.6461176560001],
              [-7.290945596999933, 38.63815948500003],
              [-7.28603633599991, 38.63190663700003],
              [-7.279421752999895, 38.62890940400011],
              [-7.273530639999905, 38.62539540600007],
              [-7.27043005399986, 38.61769561800007],
              [-7.275856079999926, 38.6038204960001],
              [-7.317713988999913, 38.556252340000086],
              [-7.335800740999929, 38.50586781900007],
              [-7.34561926299989, 38.4941372680001],
              [-7.334095417999947, 38.48101145500003],
              [-7.335180623999861, 38.46943593400009],
              [-7.344844115999877, 38.45832550100006],
              [-7.359210163999876, 38.446362407000024],
              [-7.345515909999961, 38.44096222000006],
              [-7.317145547999871, 38.424580791],
              [-7.211363891999923, 38.31753306100002],
              [-7.207126424999956, 38.31169362400003],
              [-7.200666870999896, 38.2983869430001],
              [-7.196326049999925, 38.292159933000036],
              [-7.189453084999855, 38.28652720200007],
              [-7.172399861999935, 38.27652781200008],
              [-7.167180541999898, 38.27208363900006],
              [-7.126872924999873, 38.190899964000025],
              [-7.117068156999977, 38.183633156000056],
              [-7.103515176999906, 38.17358835900011],
              [-7.088322306999885, 38.17338165300005],
              [-7.063052530999926, 38.17754160600008],
              [-7.038712930999907, 38.18622324600004],
              [-7.026413939999969, 38.19963328100009],
              [-7.021039591999909, 38.198238017],
              [-7.018145710999903, 38.19803131100004],
              [-6.992100789999938, 38.20428416000006],
              [-6.964195516999951, 38.20614451100006],
              [-6.950575759999879, 38.19838588800006],
              [-6.947504027999912, 38.19663604700007],
              [-6.957632609999877, 38.16816233300004],
              [-6.965487426999914, 38.1533311970001],
              [-6.978974975999961, 38.11994822200002],
              [-6.997630167999944, 38.089614156],
              [-7.006363484999923, 38.059331767000046],
              [-7.015768594999884, 38.04682607100007],
              [-7.023985148999913, 38.022563985000076],
              [-7.049358275999907, 38.02021270800013],
              [-7.105943969999885, 38.038661194000056],
              [-7.12325557399987, 38.040004781],
              [-7.131988891999953, 38.03238250700004],
              [-7.141910765999853, 38.01158274300009],
              [-7.152246052999942, 38.000653178],
              [-7.159739135999899, 37.99680328400008],
              [-7.172864949999848, 37.99383188900005],
              [-7.185267293999914, 37.988690084000055],
              [-7.197617960999878, 37.98993031900001],
              [-7.21033036299994, 37.99303090400004],
              [-7.223301146999859, 37.99383188900005],
              [-7.234049844999959, 37.9880699670001],
              [-7.265830850999919, 37.98295400100001],
              [-7.272703816999893, 37.9770112100001],
              [-7.272135375999937, 37.96894968700009],
              [-7.269086465999891, 37.95944122400003],
              [-7.268621378999882, 37.94923512800004],
              [-7.273892374999917, 37.931535950000026],
              [-7.295803181999872, 37.88487213100005],
              [-7.306861937999969, 37.85076568600009],
              [-7.334405476999848, 37.81193084700003],
              [-7.426337849999925, 37.750616761000074],
              [-7.444011189999912, 37.730152893000124],
              [-7.457550414999901, 37.70007721000006],
              [-7.466335407999907, 37.65196645200008],
              [-7.471606404999932, 37.63690277100007],
              [-7.478479369999889, 37.628867086000085],
              [-7.504886026999969, 37.60638783800009],
              [-7.514342813999946, 37.60140106200005],
              [-7.511758992999944, 37.59527740500006],
              [-7.512534138999854, 37.59036814400004],
              [-7.514652872999932, 37.58587229400011],
              [-7.515841430999927, 37.58093719500006],
              [-7.526486775999928, 37.57119618800003],
              [-7.529690714999902, 37.56716542600013],
              [-7.52912227399986, 37.556700948000085],
              [-7.527597819999926, 37.55551239100008],
              [-7.52367040999988, 37.5556674190001],
              [-7.518425252999862, 37.541947327000074],
              [-7.51754675299992, 37.535177715000046],
              [-7.515428018999927, 37.529338277000065],
              [-7.514613427999933, 37.52833392300009],
              [-7.506332967999867, 37.5181244920001],
              [-7.498633178999881, 37.51166493800007],
              [-7.481476603999909, 37.500373638000084],
              [-7.475947224999913, 37.49424998000002],
              [-7.468867553999871, 37.47556895000004],
              [-7.462924763999865, 37.45112599700009],
              [-7.460030883999877, 37.429137675000035],
              [-7.462252970999884, 37.41787221300008],
              [-7.444993041999908, 37.38676300100012],
              [-7.437448282999952, 37.30733632400005],
              [-7.427578083999947, 37.27452179000004],
              [-7.434244343999865, 37.259328919],
              [-7.429386758999954, 37.236746318000044],
              [-7.414418097999942, 37.19281647300005],
              [-7.411488410999937, 37.187933661000045],
              [-7.409413214999915, 37.18374258000006],
              [-7.406402147999927, 37.18048737200007],
              [-7.400217251999948, 37.17853424700007],
              [-7.400217251999948, 37.17234935100004],
              [-7.407622850999928, 37.16486237200007],
              [-7.424305792999917, 37.175034898000035],
              [-7.445708787999934, 37.17963288000004],
              [-7.468658006999931, 37.18032461100006],
              [-7.490142381999931, 37.17853424700007],
              [-7.511789516999954, 37.17177969000005],
              [-7.552235480999911, 37.14923737200007],
              [-7.56899980399993, 37.14443594000005],
              [-7.627349412999934, 37.11395905200004],
              [-7.635161912999934, 37.10541413000004],
              [-7.786610480999911, 37.022691148000035],
              [-7.819569464999915, 36.99872467700004],
              [-7.834055141999954, 36.998928127000056],
              [-7.849598761999914, 37.00438060100004],
              [-7.870716925999943, 37.007879950000074],
              [-7.932443813999953, 37.00853099200009],
              [-7.94953365799995, 37.014105536000045],
              [-7.958119269999941, 37.00263092700004],
              [-7.968820766999954, 37.00372955900008],
              [-7.981597459999932, 37.01007721600007],
              [-7.991200324999909, 37.014105536000045],
              [-7.981353318999936, 37.00169505400004],
              [-7.978098110999952, 36.995347398000035],
              [-7.97679602799991, 36.986761786000045],
              [-7.999256964999915, 37.01325104400007],
              [-8.035267706999946, 37.03750234600005],
              [-8.10655676999994, 37.06928131700005],
              [-8.147475007999958, 37.07653102900008],
              [-8.179151775999912, 37.08809908300009],
              [-8.212896014999956, 37.08691032300004],
              [-8.29320227799991, 37.07770416900007],
              [-8.327381964999915, 37.08738841400009],
              [-8.365383983999948, 37.097998535000045],
              [-8.395214820999911, 37.08713944100003],
              [-8.438834223999947, 37.08273401100007],
              [-8.482256767999957, 37.095754396000075],
              [-8.484251971999925, 37.09416437300007],
              [-8.537464972999942, 37.11782461100006],
              [-8.580148891999954, 37.12396881700005],
              [-8.626779751999948, 37.121161200000074],
              [-8.641590949999909, 37.11774323100008],
              [-8.654652472999942, 37.11029694200005],
              [-8.686268683999913, 37.08295319200005],
              [-8.747670050999943, 37.08295319200005],
              [-8.75967363199993, 37.08026764500005],
              [-8.785552537999934, 37.06720612200007],
              [-8.798573370999918, 37.062486070000034],
              [-8.813710089999915, 37.06159088700008],
              [-8.837215191999917, 37.05658783100006],
              [-8.859157616999937, 37.040797603000044],
              [-8.87891910199994, 37.04720877900007],
              [-8.896962042999917, 37.03278229400007],
              [-8.905100063999953, 37.02773672100005],
              [-8.915598110999952, 37.024603583000044],
              [-8.935617641999954, 37.010972398000035],
              [-8.946034308999913, 37.007879950000074],
              [-8.96117102799991, 37.01239655200004],
              [-8.972075975999928, 37.021185614000046],
              [-8.982899542999917, 37.026597398000035],
              [-8.997873501999948, 37.021470445000034],
              [-8.991037563999953, 37.04950592700004],
              [-8.985585089999915, 37.063381252000056],
              [-8.98078365799995, 37.06928131700005],
              [-8.94179321699994, 37.11870607000009],
              [-8.926909959999932, 37.146144924000055],
              [-8.913563605999911, 37.169907945000034],
              [-8.922718878999945, 37.199652411000045],
              [-8.904652472999942, 37.21320221600007],
              [-8.88136486399992, 37.23248011000004],
              [-8.86708995999993, 37.27672464900007],
              [-8.87491876599995, 37.29411948100005],
              [-8.882767549999926, 37.30993128100005],
              [-8.866676224999935, 37.335154388000035],
              [-8.838656939999908, 37.360318145000065],
              [-8.833363410999937, 37.38458893400008],
              [-8.815988735999952, 37.41791413000004],
              [-8.80406415199991, 37.462787190000086],
              [-8.797861434999959, 37.489600059000054],
              [-8.795496837999906, 37.53536243600007],
              [-8.801305057999912, 37.559064618000036],
              [-8.81114359299994, 37.57489650400004],
              [-8.824370897999927, 37.587551174000055],
              [-8.826527472999942, 37.60057200700004],
              [-8.812855597999942, 37.64468008000006],
              [-8.808257615999935, 37.67202383000006],
              [-8.799305792999917, 37.69757721600007],
              [-8.786206346999961, 37.70261488500006],
              [-8.757639126999948, 37.706732489000046],
              [-8.75218665299991, 37.73078034100007],
              [-8.75218665299991, 37.73456452000005],
              [-8.761830206999946, 37.727769273000035],
              [-8.784056434999911, 37.72312947100005],
              [-8.808705206999946, 37.72288646000004],
              [-8.817005988999938, 37.740301825000074],
              [-8.809582468999906, 37.79123117000006],
              [-8.797181740999918, 37.844872863000035],
              [-8.79895597399991, 37.87809298600007],
              [-8.804814876999956, 37.90187254600005],
              [-8.820668952999938, 37.92726681400006],
              [-8.853871222999942, 37.93227773600006],
              [-8.89484615799995, 37.95254140800006],
              [-8.890044725999928, 37.960923570000034],
              [-8.883168097999942, 37.964504299000055],
              [-8.875396287999934, 37.96735260600008],
              [-8.86750240799995, 37.97361888200004],
              [-8.81568343999993, 38.06211534800008],
              [-8.796993236999924, 38.13324640800005],
              [-8.774395582999944, 38.18694927000007],
              [-8.777952340999946, 38.24069108300006],
              [-8.785465988999931, 38.303908239000066],
              [-8.795070658999919, 38.35922726900009],
              [-8.82094092299991, 38.398820544000046],
              [-8.84679114499994, 38.42007070500006],
              [-8.878285285999937, 38.44916413000004],
              [-8.914662238999938, 38.47284577000005],
              [-8.942616339999915, 38.48139069200005],
              [-8.927316860999952, 38.493801174000055],
              [-8.90453040299991, 38.486395575000074],
              [-8.86750240799995, 38.46088288000004],
              [-8.821848110999952, 38.448553778000075],
              [-8.800160285999937, 38.439113674000055],
              [-8.798573370999918, 38.42609284100007],
              [-8.756988084999932, 38.42731354400007],
              [-8.65689042899993, 38.405951239000046],
              [-8.606800910999937, 38.41868724200009],
              [-8.636830206999946, 38.42015208500004],
              [-8.66274980399993, 38.42450592700004],
              [-8.736154751999948, 38.45184967700004],
              [-8.745025193999936, 38.460272528000075],
              [-8.750803188999953, 38.473944403000075],
              [-8.752512173999946, 38.487982489000046],
              [-8.750884568999936, 38.50063711100006],
              [-8.745757615999935, 38.51007721600007],
              [-8.737172003999945, 38.514878648000035],
              [-8.737172003999945, 38.522365627000056],
              [-8.751454230999911, 38.52643463700008],
              [-8.761219855999911, 38.53807200700004],
              [-8.764230923999946, 38.552069403000075],
              [-8.757639126999948, 38.56329987200007],
              [-8.77334550699993, 38.565334377000056],
              [-8.792958136999914, 38.53359609600005],
              [-8.812855597999942, 38.528550523000035],
              [-8.812855597999942, 38.522365627000056],
              [-8.790638800999943, 38.51992422100005],
              [-8.780262824999909, 38.50543854400007],
              [-8.780018683999913, 38.48908112200007],
              [-8.788400844999956, 38.48139069200005],
              [-8.812326626999948, 38.482855536000045],
              [-8.83226477799991, 38.48704661700009],
              [-8.86750240799995, 38.50185781500005],
              [-8.905832485999952, 38.51239655200004],
              [-8.954890212999942, 38.50514373300007],
              [-8.999765319999938, 38.46425312000008],
              [-8.991864489999955, 38.45947786000005],
              [-9.048595104999947, 38.440670552000086],
              [-9.145657471999925, 38.431382985000084],
              [-9.165908652999917, 38.42508941600005],
              [-9.182141078999905, 38.41562365600004],
              [-9.200356960999954, 38.41248093300004],
              [-9.226185675999943, 38.418402411000045],
              [-9.230620897999927, 38.41868724200009],
              [-9.233998175999943, 38.42422109600005],
              [-9.233754035999937, 38.43146393400008],
              [-9.231068488999938, 38.43768952000005],
              [-9.22720292899993, 38.44037506700005],
              [-9.219960089999915, 38.44904205900008],
              [-9.19002655199995, 38.472531708000076],
              [-9.183867601999907, 38.50412810500006],
              [-9.18379286499993, 38.551536973000054],
              [-9.208070232999944, 38.597417318000055],
              [-9.238463896999917, 38.635411598000076],
              [-9.252674913999954, 38.665483907000066],
              [-9.234395243999927, 38.67336074900004],
              [-9.187681016999932, 38.678009735000046],
              [-9.145041681999942, 38.68106793700008],
              [-9.12413489499994, 38.67096588700008],
              [-9.11392167899993, 38.65888092700004],
              [-9.10773678299995, 38.65888092700004],
              [-9.11392167899993, 38.679388739000046],
              [-9.098866339999915, 38.685614325000074],
              [-9.067290818999936, 38.69232819200005],
              [-9.052398240999935, 38.69367096600007],
              [-9.052398240999935, 38.69989655200004],
              [-9.037433729999918, 38.713940526000044],
              [-9.021167539999908, 38.726530265000065],
              [-8.992709282999954, 38.74381367700005],
              [-8.956857876999948, 38.76813385600008],
              [-8.952951626999948, 38.77024974200009],
              [-8.94713294199994, 38.77423737200007],
              [-8.942616339999915, 38.77558014500005],
              [-8.942616339999915, 38.78172435100004],
              [-8.952626105999911, 38.794907945000034],
              [-8.964263475999928, 38.81484609600005],
              [-8.970285610999952, 38.83543528900009],
              [-8.96312415299991, 38.85065338700008],
              [-8.986317511999914, 38.84943268400008],
              [-8.996815558999913, 38.86554596600007],
              [-9.00259355399993, 38.889837958000044],
              [-9.011545376999948, 38.913397528000075],
              [-8.969105597999942, 38.98395416900007],
              [-8.94322669199994, 39.01520416900007],
              [-8.90843665299991, 39.03628164300005],
              [-8.888417120999918, 39.04010651200008],
              [-8.845529751999948, 39.04291413000004],
              [-8.826527472999942, 39.049261786000045],
              [-8.790353969999956, 39.07062409100007],
              [-8.774647589999915, 39.08344147300005],
              [-8.765126105999911, 39.097723700000074],
              [-8.791737433999913, 39.08242422100005],
              [-8.836415167999917, 39.056708075000074],
              [-8.922718878999945, 39.049261786000045],
              [-8.93586178299995, 39.040716864000046],
              [-8.955067511999914, 39.01219310100004],
              [-9.003529425999943, 38.95774974200009],
              [-9.05890865799995, 38.87140534100007],
              [-9.089670376999948, 38.84357330900008],
              [-9.10024980399993, 38.83022695500006],
              [-9.10655676999994, 38.813788153000075],
              [-9.104217233999918, 38.79481578000008],
              [-9.102257423999959, 38.76159338000008],
              [-9.098247540999921, 38.73785767600009],
              [-9.112503309999909, 38.71418229100004],
              [-9.163287066999942, 38.70167186300006],
              [-9.220170787999905, 38.69389544000006],
              [-9.28520930399992, 38.69875756500005],
              [-9.30348529899993, 38.68770490300005],
              [-9.321777364999946, 38.67032451300008],
              [-9.360585089999915, 38.689520575000074],
              [-9.404774542999917, 38.70408763200004],
              [-9.429188605999911, 38.70726146000004],
              [-9.471669074999909, 38.702460028000075],
              [-9.491688605999911, 38.70758698100008],
              [-9.491281704999949, 38.727728583000044],
              [-9.484730597999942, 38.74469635600008],
              [-9.497466600999928, 38.78823476800005],
              [-9.497466600999928, 38.809759833000044],
              [-9.491932745999918, 38.819240627000056],
              [-9.479888475999928, 38.83075592700004],
              [-9.455495665999933, 38.850468694000085],
              [-9.422724913999957, 38.93140379100004],
              [-9.425363735999952, 38.99164459800005],
              [-9.43663489499994, 39.02948639500005],
              [-9.42664680799993, 39.05172399400004],
              [-9.42254887799993, 39.07862519400004],
              [-9.383696135999912, 39.134031769000046],
              [-9.371417906999909, 39.160919652000075],
              [-9.350859757999956, 39.19730924500004],
              [-9.34678102199996, 39.23522589600009],
              [-9.340590389999932, 39.26682959900006],
              [-9.354074673999946, 39.31622955900008],
              [-9.365834113999938, 39.336004950000074],
              [-9.401763475999928, 39.365220445000034],
              [-9.40929114499994, 39.37518952000005],
              [-9.397816535999937, 39.37799713700008],
              [-9.352921539999954, 39.36793401400007],
              [-9.279244908999942, 39.40582171900007],
              [-9.260803351999925, 39.418442396000046],
              [-9.240314902999955, 39.419997091000084],
              [-9.227894660999937, 39.40843333500004],
              [-9.217600063999953, 39.40619538000004],
              [-9.205922003999945, 39.41547272300005],
              [-9.21353105399993, 39.428615627000056],
              [-9.229888475999928, 39.440741278000075],
              [-9.213649287999942, 39.46103549900005],
              [-9.191085031999933, 39.48153602000008],
              [-9.182873267999923, 39.49258381800007],
              [-9.164413231999958, 39.50202368500004],
              [-9.135694137999906, 39.51618029900004],
              [-9.121300040999927, 39.535104663000084],
              [-9.111008998999921, 39.55087924400004],
              [-9.090434486999925, 39.57927490600008],
              [-9.088341062999916, 39.596661622000056],
              [-9.09034313199993, 39.615641037000046],
              [-9.077946754999914, 39.64247909000005],
              [-9.071692364999933, 39.68043688600005],
              [-8.993031378999945, 39.84316640800006],
              [-8.868153449999909, 40.12482330900008],
              [-8.853260870999918, 40.13922760600008],
              [-8.841623501999948, 40.12596263200004],
              [-8.825062628999945, 40.12006256700005],
              [-8.784982876999948, 40.11871979400007],
              [-8.784982876999948, 40.126166083000044],
              [-8.80109615799995, 40.137925523000035],
              [-8.816151495999918, 40.146551825000074],
              [-8.833607550999943, 40.151678778000075],
              [-8.879383917999917, 40.156236070000034],
              [-8.896473761999914, 40.16474030200004],
              [-8.906605597999942, 40.179388739000046],
              [-8.90843665299991, 40.20066966400009],
              [-8.895741339999915, 40.22874583500004],
              [-8.865386522999927, 40.275458075000074],
              [-8.798573370999918, 40.47443268400008],
              [-8.784855297999911, 40.53681779200008],
              [-8.765788097999916, 40.58254100400006],
              [-8.753000454999949, 40.64081452000005],
              [-8.750355597999942, 40.64394765800006],
              [-8.744618292999917, 40.646918036000045],
              [-8.743967251999948, 40.62579987200007],
              [-8.744618292999917, 40.61904531500005],
              [-8.724680141999954, 40.644517320000034],
              [-8.710275844999956, 40.65346914300005],
              [-8.696156378999945, 40.646918036000045],
              [-8.690012173999946, 40.646918036000045],
              [-8.690012173999946, 40.65314362200007],
              [-8.692372199999909, 40.65570709800005],
              [-8.69640051999994, 40.661322333000044],
              [-8.698801235999952, 40.667954820000034],
              [-8.696156378999945, 40.67365143400008],
              [-8.686390753999945, 40.67792389500005],
              [-8.68077551999994, 40.674994208000044],
              [-8.67686926999994, 40.66966380400004],
              [-8.671986456999946, 40.66681549700007],
              [-8.662098761999914, 40.66986725500004],
              [-8.653635219999956, 40.67719147300005],
              [-8.641590949999909, 40.69415924700007],
              [-8.657460089999915, 40.70140208500004],
              [-8.66633053299995, 40.71320221600007],
              [-8.663644985999952, 40.72406647300005],
              [-8.644927537999934, 40.72890859600005],
              [-8.621815558999913, 40.73065827000005],
              [-8.603871222999942, 40.73578522300005],
              [-8.588368292999917, 40.744208075000074],
              [-8.572661912999934, 40.755560614000046],
              [-8.589507615999935, 40.75470612200007],
              [-8.614735480999911, 40.74494049700007],
              [-8.635975714999915, 40.74160390800006],
              [-8.639881964999915, 40.74005768400008],
              [-8.645375128999945, 40.73973216400009],
              [-8.668446417999917, 40.74746328300006],
              [-8.67568925699993, 40.755560614000046],
              [-8.683705206999946, 40.78310781500005],
              [-8.645578579999949, 40.82367584800005],
              [-8.655262824999909, 40.844916083000044],
              [-8.656971808999913, 40.828558661000045],
              [-8.66319739499994, 40.81492747600004],
              [-8.670521613999938, 40.81118398600006],
              [-8.67568925699993, 40.82444896000004],
              [-8.689808722999942, 40.80410390800006],
              [-8.700550910999937, 40.77798086100006],
              [-8.707386847999942, 40.75031159100007],
              [-8.709828253999945, 40.72516510600008],
              [-8.714263475999928, 40.709051825000074],
              [-8.725087042999917, 40.685980536000045],
              [-8.738433397999927, 40.664496161000045],
              [-8.750803188999953, 40.65314362200007],
              [-8.655100063999953, 40.993801174000055],
              [-8.655262824999909, 41.030503648000035],
              [-8.66710364499994, 41.09756094000005],
              [-8.666127081999946, 41.13275788000004],
              [-8.64834550699993, 41.14663320500006],
              [-8.64834550699993, 41.152777411000045],
              [-8.68578040299991, 41.159491278000075],
              [-8.705189581999946, 41.18691640800006],
              [-8.718373175999943, 41.22150299700007],
              [-8.737172003999945, 41.249660549000055],
              [-8.73228919199994, 41.262925523000035],
              [-8.73460852799991, 41.27407461100006],
              [-8.740061001999948, 41.28497955900008],
              [-8.744618292999917, 41.29743073100008],
              [-8.74445553299995, 41.328111070000034],
              [-8.74913489499994, 41.33779531500005],
              [-8.756132205999961, 41.34054],
              [-8.760324673999946, 41.350897528000075],
              [-8.764027472999942, 41.361314195000034],
              [-8.778146938999953, 41.379339911000045],
              [-8.783802863999938, 41.393866278000075],
              [-8.78377336299991, 41.406108551000045],
              [-8.785563586999956, 41.434878223000055],
              [-8.774849231999951, 41.46833848600005],
              [-8.786469626999917, 41.49106709600005],
              [-8.788260342999934, 41.511798431000045],
              [-8.792733322999936, 41.52583822300005],
              [-8.79542022399994, 41.54255277400006],
              [-8.808338995999918, 41.57294342700004],
              [-8.812855597999942, 41.595404364000046],
              [-8.819488084999932, 41.61188385600008],
              [-8.820449, 41.630096826000056],
              [-8.828603353999938, 41.64815749600007],
              [-8.830511327999943, 41.671585564000054],
              [-8.827056443999936, 41.682806708000044],
              [-8.804676886999914, 41.68927643400008],
              [-8.74327551999994, 41.696966864000046],
              [-8.725941535999937, 41.703111070000034],
              [-8.710031704999949, 41.71185944200005],
              [-8.696156378999945, 41.721991278000075],
              [-8.80687415299991, 41.696966864000046],
              [-8.82998613199993, 41.694647528000075],
              [-8.84288489499994, 41.69578685100004],
              [-8.86111256299995, 41.70436810700005],
              [-8.88030624399994, 41.73686160300008],
              [-8.88031700299996, 41.76553269200008],
              [-8.872038936999957, 41.81056866200004],
              [-8.878895636999914, 41.83901601800005],
              [-8.874745245999918, 41.84955475500004],
              [-8.86750240799995, 41.85911692900004],
              [-8.796620245999918, 41.90330638200004],
              [-8.762766079999949, 41.93195221600007],
              [-8.750803188999953, 41.96898021000004],
              [-8.739591023999935, 41.9751134240001],
              [-8.717008422999896, 41.983769226000064],
              [-8.69127355899991, 41.989608664000045],
              [-8.670809691999864, 41.99981475800011],
              [-8.663213256999882, 42.00989166300006],
              [-8.65256791199991, 42.03144073600002],
              [-8.643886271999946, 42.04149180200004],
              [-8.626884724999911, 42.051026103000126],
              [-8.60941809099998, 42.05366160100006],
              [-8.572805337999938, 42.054410909000055],
              [-8.554434366999942, 42.060069478000074],
              [-8.520017862999879, 42.07771698000009],
              [-8.501207641999883, 42.083091330000045],
              [-8.346746785999898, 42.1016948450001],
              [-8.329951944999948, 42.108438619000125],
              [-8.304268757999864, 42.12582773900006],
              [-8.295380411999957, 42.1300910450001],
              [-8.287835652999888, 42.13143463200008],
              [-8.270679076999926, 42.13200307200013],
              [-8.252333943999957, 42.13758412800006],
              [-8.222361612999919, 42.15362966000002],
              [-8.213395751999883, 42.1440178430001],
              [-8.204326537999918, 42.12879913300007],
              [-8.207375447999937, 42.08577850400006],
              [-8.204016479999922, 42.06955210400007],
              [-8.19130407699987, 42.062084859000024],
              [-8.17616288299996, 42.06526296],
              [-8.15838618999993, 42.07138661700007],
              [-8.137612263999898, 42.07291107200008],
              [-8.118440307999975, 42.06686492900003],
              [-8.103195760999938, 42.05580617300002],
              [-8.095082559999923, 42.04092336100008],
              [-8.097356322999929, 42.02348256500004],
              [-8.10802750699986, 42.01089935300003],
              [-8.12391800899988, 42.00089996400003],
              [-8.152960163999865, 41.98681813600008],
              [-8.182131509999891, 41.96542409300007],
              [-8.220707966999953, 41.92271352100006],
              [-8.23021643099986, 41.90467844700005],
              [-8.231715047999955, 41.88604909300001],
              [-8.220397908999871, 41.86819488600004],
              [-8.184586140999954, 41.85773040800011],
              [-8.177041381999885, 41.849849752000054],
              [-8.175387735999948, 41.83659474700006],
              [-8.179265100999942, 41.812612525000034],
              [-8.179573526999889, 41.810704854000036],
              [-8.093480590999889, 41.80672576900004],
              [-8.050445716999889, 41.81598643800005],
              [-8.048573770999894, 41.81638926200007],
              [-8.015707560999942, 41.8418915810001],
              [-8.005889037999907, 41.85395802900008],
              [-7.993641723999872, 41.86367319800003],
              [-7.979430704999913, 41.86860829700005],
              [-7.963359334999922, 41.86661875500003],
              [-7.94475581899988, 41.86695465200002],
              [-7.93535070799993, 41.87995127400005],
              [-7.930493122999906, 41.8966686000001],
              [-7.92579056799994, 41.90816660600011],
              [-7.906101846999888, 41.91385101400006],
              [-7.903362995999942, 41.88682424000011],
              [-7.896593383999885, 41.85793711300006],
              [-7.864812377999954, 41.857885437000064],
              [-7.857887735999981, 41.86377655100004],
              [-7.854425414999923, 41.87026194300002],
              [-7.849722859999872, 41.87576548300011],
              [-7.839232543999913, 41.8783751430001],
              [-7.812154092999947, 41.87713490900008],
              [-7.750142374999911, 41.88837453200004],
              [-7.722030395999866, 41.8992524210001],
              [-7.706372436999914, 41.89625518800007],
              [-7.67867386899988, 41.88134653700003],
              [-7.661155557999933, 41.87491282200007],
              [-7.607360391999919, 41.87318166200002],
              [-7.622811644999899, 41.84173655200006],
              [-7.622191528999849, 41.83233144200001],
              [-7.606068480999852, 41.82553599100005],
              [-7.588395141999854, 41.8242182420001],
              [-7.567104451999882, 41.82659535800006],
              [-7.546692260999919, 41.832047221000025],
              [-7.531551066999924, 41.84016042100005],
              [-7.526331746999887, 41.847369283],
              [-7.525246540999888, 41.85416473400004],
              [-7.523282836999954, 41.86015920100006],
              [-7.515841430999927, 41.86499094700007],
              [-7.508141642999959, 41.86493927000008],
              [-7.493000447999947, 41.85690358600009],
              [-7.483285278999887, 41.85620595400009],
              [-7.469384318999914, 41.8525369260001],
              [-7.456568562999848, 41.83923024500008],
              [-7.446956746999916, 41.82184112600005],
              [-7.442719278999959, 41.805950623000044],
              [-7.429541788999899, 41.81450307300007],
              [-7.405408894999937, 41.835199484000086],
              [-7.391921345999975, 41.84204661100004],
              [-7.376831827999865, 41.84403615300009],
              [-7.340503295999895, 41.84320933100007],
              [-7.322468220999895, 41.84540557900006],
              [-7.251464802999919, 41.86369903600003],
              [-7.218650268999909, 41.8790469370001],
              [-7.209316117999947, 41.889160873],
              [-7.19792801899996, 41.90150034600002],
              [-7.195654255999955, 41.917365011000115],
              [-7.20211381099989, 41.9497402950001],
              [-7.19994339999991, 41.9637187710001],
              [-7.192605346999926, 41.96960988400009],
              [-7.177309122999873, 41.97836903900007],
              [-7.159739135999899, 41.98573293100007],
              [-7.1453730879999, 41.98748992900006],
              [-7.113178670999929, 41.97242625000008],
              [-7.082741251999948, 41.95278920500003],
              [-7.051270303999928, 41.94201466900002],
              [-7.015768594999884, 41.953667705000086],
              [-6.992359170999919, 41.966380107000035],
              [-6.98345618299993, 41.962996166],
              [-6.96951818799991, 41.95769846600008],
              [-6.945126911999893, 41.94335825700007],
              [-6.917118285999948, 41.9390949500001],
              [-6.854951537999881, 41.94294484500007],
              [-6.831232055999919, 41.953951925000055],
              [-6.824927530999929, 41.983769226000064],
              [-6.794386759999924, 41.97971262600005],
              [-6.757903197999894, 41.93757049600002],
              [-6.727982543999872, 41.93085255900009],
              [-6.656772419999925, 41.93307464700008],
              [-6.622821003999917, 41.94095530200012],
              [-6.609488484999872, 41.96232350700002],
              [-6.585148885999956, 41.95464955700005],
              [-6.571661335999892, 41.94260894800006],
              [-6.567630574999896, 41.92607249000007],
              [-6.575795450999919, 41.88289683100005],
              [-6.567888956999894, 41.87586883600004],
              [-6.550060587999923, 41.87387929300009],
              [-6.524222371999912, 41.867419740000045],
              [-6.53574621599995, 41.848583679000015],
              [-6.560137491999882, 41.766883240000126],
              [-6.564374958999935, 41.75750396800008],
              [-6.571506306999964, 41.749209900000025],
              [-6.577397419999954, 41.73972727500005],
              [-6.574348510999926, 41.7310456340001],
              [-6.567682250999923, 41.722441508000045],
              [-6.563083048999886, 41.713036397000096],
              [-6.560499226999866, 41.69445872100006],
              [-6.555279906999942, 41.67489919100002],
              [-6.541533976999915, 41.658905335000085],
              [-6.513421996999881, 41.65092132600002],
              [-6.503035033999964, 41.65309173700011],
              [-6.488048868999897, 41.65880198200007],
              [-6.474354614999868, 41.6659333300001],
              [-6.467740030999948, 41.67205698700006],
              [-6.46081538999988, 41.676552836000084],
              [-6.447069457999959, 41.67624277800009],
              [-6.365937459999913, 41.66360789000005],
              [-6.317103230999948, 41.65014618000002],
              [-6.272248087999856, 41.62823537200005],
              [-6.230080118999894, 41.59490407300008],
              [-6.216127481999905, 41.58009877500008],
              [-6.205947224999932, 41.57028025300009],
              [-6.253644571999899, 41.51751861600006],
              [-6.279534463999937, 41.497003072],
              [-6.285890665999943, 41.48687449200004],
              [-6.285167194999872, 41.4789679980001],
              [-6.282480020999941, 41.47230173800007],
              [-6.282945108999854, 41.46563547800007],
              [-6.321030639999918, 41.419591777000065],
              [-6.321133991999943, 41.411013489000126],
              [-6.352346557999908, 41.40925649100005],
              [-6.366247517999881, 41.40517405300004],
              [-6.379166625999915, 41.39731923400011],
              [-6.376169392999884, 41.39685414600008],
              [-6.37554927599993, 41.39080800400005],
              [-6.376737832999936, 41.38300486300004],
              [-6.379166625999915, 41.37747548500003],
              [-6.3831973879999, 41.376545309000065],
              [-6.395496377999933, 41.37840566000007],
              [-6.399578816999849, 41.37747548500003],
              [-6.430998086999892, 41.33902821900007],
              [-6.463140828999911, 41.31412017800001],
              [-6.495852010999897, 41.29494822200009],
              [-6.554453083999931, 41.27562123700004],
              [-6.563496459999897, 41.270711975000026],
              [-6.628918823999868, 41.26993682900009],
              [-6.646643839999882, 41.267611390000056],
              [-6.658219359999919, 41.25784454400012],
              [-6.693772745999894, 41.21738189700004],
              [-6.701265828999908, 41.202447408000054],
              [-6.706950235999955, 41.19433420900005],
              [-6.742245238999942, 41.17144154900005],
              [-6.755216023999878, 41.158832500000116],
              [-6.758988403999894, 41.151752828],
              [-6.756507934999917, 41.12705149400007],
              [-6.764776163999954, 41.10886139000003],
              [-6.804360310999925, 41.06441965800006],
              [-6.818002888999928, 41.054136048000075],
              [-6.845288044999933, 41.05191396100007],
              [-6.90683467599996, 41.056099752000094],
              [-6.927447856999947, 41.04809758400005],
              [-6.927866983999877, 41.04793487600007],
              [-6.931794392999961, 41.02912465400006],
              [-6.942491414999949, 41.01599884000011],
              [-6.940424356999898, 41.00338979100009],
              [-6.930605834999938, 40.992072652],
              [-6.899238240999921, 40.96675120100012],
              [-6.885182251999879, 40.948922832000065],
              [-6.863633178999919, 40.908305156000054],
              [-6.855261596999867, 40.88722117200011],
              [-6.847045043999913, 40.87890126600006],
              [-6.832058877999941, 40.875904033000054],
              [-6.821155151999903, 40.87006459600006],
              [-6.81619421399995, 40.85683542900007],
              [-6.82032832799996, 40.84422638000002],
              [-6.836658080999911, 40.840247294000065],
              [-6.838053343999889, 40.81492584200008],
              [-6.836813109999952, 40.80831126000008],
              [-6.833505818999953, 40.79782094300002],
              [-6.834539347999936, 40.7922398890001],
              [-6.837278197999865, 40.78676218700012],
              [-6.839138549999888, 40.77689198900005],
              [-6.839138549999888, 40.75751332600008],
              [-6.836968139999897, 40.74330230800011],
              [-6.824307413999861, 40.710694478000065],
              [-6.816245889999948, 40.67715647400003],
              [-6.814230508999913, 40.659328105],
              [-6.814282185999929, 40.6471841430001],
              [-6.821310180999944, 40.630182597000086],
              [-6.844461222999911, 40.59778147400006],
              [-6.850455688999944, 40.582226868000035],
              [-6.848388630999892, 40.564760234000104],
              [-6.839758666999955, 40.55457997600003],
              [-6.828544881999903, 40.54553660100008],
              [-6.818054564999954, 40.53189402300008],
              [-6.812525186999949, 40.51463409500009],
              [-6.815315714999912, 40.502541810000096],
              [-6.838673461999861, 40.47722035800011],
              [-6.857121948999861, 40.44213206000008],
              [-6.85128251099988, 40.40952423100002],
              [-6.828079793999962, 40.38058542900005],
              [-6.794438435999922, 40.35640085900009],
              [-6.811956745999908, 40.33231964100004],
              [-6.820793415999901, 40.32534332300004],
              [-6.863943236999916, 40.300952047000024],
              [-6.870196085999908, 40.29552602200006],
              [-6.873865112999908, 40.28777455600003],
              [-6.874509091999897, 40.279188167000044],
              [-6.875105346999959, 40.27123809900006],
              [-6.878050903999849, 40.26524363200012],
              [-6.896447712999958, 40.255476786000074],
              [-6.915826374999909, 40.254443258],
              [-6.935411742999946, 40.255838522000076],
              [-6.942100807999878, 40.25497773100007],
              [-6.954687052999873, 40.2533580530001],
              [-6.997785196999899, 40.23170562700001],
              [-7.015768594999884, 40.225504456000024],
              [-7.024760294999908, 40.21620269800009],
              [-7.034578816999982, 40.193051656000094],
              [-7.043105428999894, 40.18137278300013],
              [-7.034837198999867, 40.166748352000056],
              [-7.027654174999896, 40.13264190700009],
              [-7.015768594999884, 40.11905100500009],
              [-7.003676309999889, 40.116312154000056],
              [-6.977166300999983, 40.11341827400007],
              [-6.966417602999854, 40.11031768800002],
              [-6.955720581999856, 40.10292795900001],
              [-6.942129679999965, 40.08633982300002],
              [-6.919908812999921, 40.06489410400009],
              [-6.879704548999911, 40.009186910000054],
              [-6.896912800999871, 39.98712107400006],
              [-6.901615355999866, 39.97647572800007],
              [-6.899755004999861, 39.96562367800003],
              [-6.903682413999917, 39.95668365500008],
              [-6.909521850999909, 39.93198232100006],
              [-6.912570759999937, 39.928106588000034],
              [-6.922285928999884, 39.92242218000008],
              [-6.925231485999888, 39.91792633100006],
              [-6.92512813299993, 39.912241924000014],
              [-6.921562459999961, 39.902165019000066],
              [-6.921769164999915, 39.897152405],
              [-6.923474487999897, 39.888315735],
              [-6.924249633999892, 39.871572571000044],
              [-6.927660278999923, 39.86190907800004],
              [-6.952826700999879, 39.832866924000044],
              [-6.962335164999956, 39.82852610300007],
              [-6.985227824999868, 39.821136373000044],
              [-6.993030964999889, 39.816072083000066],
              [-7.000265664999858, 39.802532858000106],
              [-6.998870401999881, 39.79178416000006],
              [-6.994581258999915, 39.782585755000085],
              [-6.993030964999889, 39.77421417300009],
              [-6.996803344999904, 39.76470570900001],
              [-7.008740600999943, 39.74832428000006],
              [-7.013339802999923, 39.7389191700001],
              [-7.013649861999909, 39.729617412],
              [-7.010704304999905, 39.72279612200005],
              [-7.009619099999895, 39.715458069000036],
              [-7.021142944999923, 39.69401235000002],
              [-7.035767373999903, 39.68925811800001],
              [-7.182890177999894, 39.67509877500008],
              [-7.214051065999854, 39.67618398100008],
              [-7.235755167999855, 39.686519267000065],
              [-7.252860066999887, 39.68233347600004],
              [-7.292754272999929, 39.683315329000024],
              [-7.311409464999912, 39.68031809500009],
              [-7.327842569999859, 39.674788717000084],
              [-7.341433470999959, 39.67184316],
              [-7.557285929999892, 39.679801331000064],
              [-7.555871748999948, 39.6772073180001],
              [-7.548242553999955, 39.66321319700005],
              [-7.515841430999927, 39.59376007100006],
              [-7.497858032999943, 39.58104766800001],
              [-7.468092406999887, 39.550248515000064],
              [-7.451349242999925, 39.53784617200007],
              [-7.417552856999947, 39.52420359300008],
              [-7.408922891999907, 39.51557362900003],
              [-7.399414428999904, 39.493662821000086],
              [-7.384169880999877, 39.48399932900004],
              [-7.362930866999903, 39.4760928350001],
              [-7.320917927999886, 39.467411194000036],
              [-7.313528197999887, 39.457437643000034],
              [-7.313631550999901, 39.436095276000046],
              [-7.31885087099991, 39.41325429300012],
              [-7.326705688999937, 39.39883656800002],
              [-7.331925008999889, 39.38472890200008],
              [-7.331408243999931, 39.362611390000055],
              [-7.326654011999949, 39.34132069900009],
              [-7.319264282999939, 39.329538473000085],
              [-7.300454060999925, 39.31791127500013],
              [-7.250844685999937, 39.270627340000075],
              [-7.264332233999909, 39.252333883000105],
              [-7.265779174999892, 39.23135325200009],
              [-7.258079386999896, 39.211302795000066],
              [-7.244126749999907, 39.1956448370001],
              [-7.219322062999879, 39.18484446200007],
              [-7.191571817999943, 39.179160055000025],
              [-7.168059040999935, 39.170633443],
              [-7.155811726999929, 39.15151316300002],
              [-7.157930460999893, 39.14138458300006],
              [-7.168885864999879, 39.12185089200004],
              [-7.167490600999884, 39.11347931000007],
              [-7.157206990999896, 39.1054436240001],
              [-7.14253088399991, 39.099526673000085],
              [-7.127286336999873, 39.09748545300003],
              [-7.115194050999889, 39.101102804],
              [-7.091267862999899, 39.11244578100009],
              [-7.06491288299992, 39.11477122000012],
              [-7.038816283999921, 39.1091384890001],
              [-7.015768594999884, 39.09681366000005],
              [-6.99969722599991, 39.08469553600007],
              [-6.985692911999905, 39.06676381500007],
              [-6.979388386999887, 39.047178447000064],
              [-6.986313028999859, 39.0300735470001],
              [-6.974892537999949, 39.0230197150001],
              [-6.973290567999925, 39.013950501000025],
              [-6.97881994599993, 39.00382192000008],
              [-6.988638467999891, 38.99377085400006],
              [-7.02212479699989, 38.942869568000035],
              [-7.044500691999872, 38.91863332100003],
              [-7.066049764999917, 38.90460317000013],
              [-7.052200479999954, 38.88499196400009],
              [-7.057264769999932, 38.86943735700008],
              [-7.056076212999926, 38.855148824000096],
              [-7.064292764999948, 38.8511180630001],
              [-7.076540079999887, 38.84323740600006],
              [-7.08868404099988, 38.83336720900006],
              [-7.104858764999988, 38.827191874000086],
            ],
          ],
          [
            [
              [-16.487049933999913, 32.49168528900009],
              [-16.521839972999942, 32.539496161000045],
              [-16.530425584999932, 32.548529364000046],
              [-16.536773240999935, 32.55801015800006],
              [-16.540760870999918, 32.56850820500006],
              [-16.542347785999937, 32.580511786000045],
              [-16.52525794199994, 32.56720612200007],
              [-16.506662563999953, 32.544175523000035],
              [-16.49205481699994, 32.51715729400007],
              [-16.487049933999913, 32.49168528900009],
            ],
          ],
          [
            [
              [-16.788685675999943, 32.68667226800005],
              [-16.806385870999918, 32.65680573100008],
              [-16.847808397999927, 32.64402903900009],
              [-16.89590410099993, 32.64158763200004],
              [-16.97679602799991, 32.64720286700009],
              [-17.142974412999934, 32.70555247600004],
              [-17.18065344999991, 32.72597890800006],
              [-17.214466925999943, 32.75063711100006],
              [-17.24120032499991, 32.77912018400008],
              [-17.24990800699993, 32.796535549000055],
              [-17.252105272999927, 32.814520575000074],
              [-17.246449347999942, 32.82859935100004],
              [-17.231271938999953, 32.83437734600005],
              [-17.224964972999942, 32.83930084800005],
              [-17.20026607999995, 32.868475653000075],
              [-17.191395636999914, 32.872748114000046],
              [-17.184885219999956, 32.87417226800005],
              [-17.177561001999948, 32.872748114000046],
              [-17.166127081999946, 32.868475653000075],
              [-17.15575110599991, 32.86123281500005],
              [-17.13194739499994, 32.839056708000044],
              [-17.121693488999938, 32.83437734600005],
              [-17.11554928299995, 32.83344147300005],
              [-17.093902147999927, 32.82770416900007],
              [-17.067982550999943, 32.814154364000046],
              [-17.041167772999927, 32.812201239000046],
              [-17.01431230399993, 32.81704336100006],
              [-16.99478105399993, 32.82754140800006],
              [-16.97996985599991, 32.833238023000035],
              [-16.957875128999945, 32.83779531500005],
              [-16.919748501999948, 32.84121328300006],
              [-16.903065558999913, 32.83633047100005],
              [-16.872873501999948, 32.81745026200008],
              [-16.86074785099993, 32.81321849200009],
              [-16.808705206999946, 32.78001536700009],
              [-16.797474738999938, 32.77456289300005],
              [-16.785633917999917, 32.77228424700007],
              [-16.74746660099993, 32.770819403000075],
              [-16.730132615999935, 32.766791083000044],
              [-16.713612433999913, 32.75861237200007],
              [-16.703684048999946, 32.76463450700004],
              [-16.693023240999935, 32.76666901200008],
              [-16.682484503999945, 32.76463450700004],
              [-16.672678188999953, 32.75861237200007],
              [-16.68976803299995, 32.75486888200004],
              [-16.725087042999917, 32.74115631700005],
              [-16.73786373599995, 32.73810455900008],
              [-16.749989386999914, 32.73061758000006],
              [-16.78221594999991, 32.69611237200007],
              [-16.788685675999943, 32.68667226800005],
            ],
          ],
          [
            [
              [-16.339955206999946, 33.05719635600008],
              [-16.352691209999932, 33.04376862200007],
              [-16.36432857999995, 33.034369208000044],
              [-16.378285285999937, 33.03204987200007],
              [-16.39834550699993, 33.03978099200009],
              [-16.39834550699993, 33.04661692900004],
              [-16.388010219999956, 33.04734935100004],
              [-16.37987219999991, 33.05133698100008],
              [-16.37413489499994, 33.05817291900007],
              [-16.361683722999942, 33.09031810100004],
              [-16.34129798099991, 33.10594310100004],
              [-16.317128058999913, 33.11078522300005],
              [-16.29588782499991, 33.101263739000046],
              [-16.289133266999954, 33.108710028000075],
              [-16.289784308999913, 33.079413153000075],
              [-16.286000128999945, 33.06753164300005],
              [-16.275380011999914, 33.060248114000046],
              [-16.31078040299991, 33.066066799000055],
              [-16.32567298099991, 33.06582265800006],
              [-16.339955206999946, 33.05719635600008],
            ],
          ],
          [
            [
              [-7.95571855399993, 36.980536200000074],
              [-7.903960740999935, 36.97483958500004],
              [-7.884022589999915, 36.98086172100005],
              [-7.860096808999913, 37.000433661000045],
              [-7.857818162999934, 36.99746328300006],
              [-7.856068488999938, 36.994208075000074],
              [-7.853260870999918, 36.986761786000045],
              [-7.859120245999918, 36.98338450700004],
              [-7.860096808999913, 36.980536200000074],
              [-7.878488735999952, 36.97085195500006],
              [-7.903879360999952, 36.96588776200008],
              [-7.931385870999918, 36.966498114000046],
              [-7.95571855399993, 36.973089911000045],
              [-7.95571855399993, 36.980536200000074],
            ],
          ],
          [
            [
              [-25.066802537999934, 37.021470445000034],
              [-25.04674231699994, 37.01072825700004],
              [-25.02920488199993, 36.99237702000005],
              [-25.016916469999956, 36.97044505400004],
              [-25.012196417999917, 36.949204820000034],
              [-25.027088995999918, 36.93431224200009],
              [-25.060658331999946, 36.93724192900004],
              [-25.11900794199994, 36.95262278900009],
              [-25.151722785999937, 36.94586823100008],
              [-25.169097459999932, 36.94599030200004],
              [-25.176665818999936, 36.95604075700004],
              [-25.183216925999943, 36.96889883000006],
              [-25.195301886999914, 36.980169989000046],
              [-25.201649542999917, 36.99042389500005],
              [-25.19098873599995, 37.000433661000045],
              [-25.170318162999934, 37.01552969000005],
              [-25.133615688999953, 37.02301666900007],
              [-25.094471808999913, 37.02448151200008],
              [-25.066802537999934, 37.021470445000034],
            ],
          ],
          [
            [
              [-25.197824673999946, 37.86440664300005],
              [-25.15916907499991, 37.85203685100004],
              [-25.135161912999934, 37.822333075000074],
              [-25.13231360599991, 37.78620026200008],
              [-25.156849738999938, 37.75454336100006],
              [-25.19473222599993, 37.74070872600004],
              [-25.32754472599993, 37.72724030200004],
              [-25.372425910999937, 37.71743398600006],
              [-25.420318162999934, 37.71356842700004],
              [-25.465443488999938, 37.71539948100008],
              [-25.488270636999914, 37.71369049700007],
              [-25.505686001999948, 37.706732489000046],
              [-25.53270423099991, 37.72011953300006],
              [-25.559071417999917, 37.72907135600008],
              [-25.61554928299995, 37.74091217700004],
              [-25.704253709999932, 37.74404531500005],
              [-25.825062628999945, 37.81541575700004],
              [-25.859486456999946, 37.85390859600005],
              [-25.841460740999935, 37.90599192900004],
              [-25.764556443999936, 37.91156647300005],
              [-25.739084438999953, 37.90599192900004],
              [-25.70421301999994, 37.88263580900008],
              [-25.698109503999945, 37.874335028000075],
              [-25.69717363199993, 37.862534898000035],
              [-25.694203253999945, 37.85268789300005],
              [-25.688832160999937, 37.84585195500006],
              [-25.68073482999995, 37.84332916900007],
              [-25.55378170499995, 37.82965729400007],
              [-25.538889126999948, 37.83295319200005],
              [-25.512562628999945, 37.84747955900008],
              [-25.498890753999945, 37.850775458000044],
              [-25.489857550999943, 37.84804922100005],
              [-25.468861456999946, 37.83466217700004],
              [-25.45848548099991, 37.82965729400007],
              [-25.44204667899993, 37.83730703300006],
              [-25.33975175699993, 37.86180247600004],
              [-25.197824673999946, 37.86440664300005],
            ],
          ],
          [
            [
              [-28.109486456999946, 38.446600653000075],
              [-28.063832160999937, 38.44277578300006],
              [-28.04710852799991, 38.43256256700005],
              [-28.04059811099995, 38.409084377000056],
              [-28.05418860599991, 38.398504950000074],
              [-28.084868943999936, 38.39817942900004],
              [-28.162709113999938, 38.40717194200005],
              [-28.185210740999935, 38.405951239000046],
              [-28.20531165299991, 38.40033600500004],
              [-28.241851365999935, 38.37759023600006],
              [-28.253651495999918, 38.38255442900004],
              [-28.262928839999915, 38.39484284100007],
              [-28.274566209999932, 38.40566640800006],
              [-28.29678300699993, 38.411322333000044],
              [-28.439442511999914, 38.41351959800005],
              [-28.459543423999946, 38.40566640800006],
              [-28.525380011999914, 38.45392487200007],
              [-28.548898891999954, 38.484442450000074],
              [-28.548898891999954, 38.528550523000035],
              [-28.51866614499994, 38.550116278000075],
              [-28.485259568999936, 38.557806708000044],
              [-28.414540167999917, 38.55646393400008],
              [-28.37450110599991, 38.550482489000046],
              [-28.274566209999932, 38.50185781500005],
              [-28.239125128999945, 38.48965078300006],
              [-28.236683722999942, 38.487534898000035],
              [-28.226226365999935, 38.484442450000074],
              [-28.206288214999915, 38.47085195500006],
              [-28.195790167999917, 38.46771881700005],
              [-28.17446855399993, 38.46478913000004],
              [-28.109486456999946, 38.446600653000075],
            ],
          ],
          [
            [
              [-28.609730597999942, 38.59739817900004],
              [-28.596058722999942, 38.552720445000034],
              [-28.60301673099991, 38.55149974200009],
              [-28.63499915299991, 38.54059479400007],
              [-28.64395097599993, 38.53534577000005],
              [-28.63780676999994, 38.52944570500006],
              [-28.635365363999938, 38.52578359600005],
              [-28.632069464999915, 38.52362702000005],
              [-28.623402472999942, 38.522365627000056],
              [-28.63621985599991, 38.51552969000005],
              [-28.647816535999937, 38.51581452000005],
              [-28.67178300699993, 38.522365627000056],
              [-28.683949347999942, 38.52142975500004],
              [-28.71434485599991, 38.515326239000046],
              [-28.727040167999917, 38.514878648000035],
              [-28.74958248599995, 38.523504950000074],
              [-28.775380011999914, 38.554388739000046],
              [-28.795318162999934, 38.569525458000044],
              [-28.841135219999956, 38.591131903000075],
              [-28.842396613999938, 38.59943268400008],
              [-28.808949347999942, 38.60423411700009],
              [-28.779896613999938, 38.60488515800006],
              [-28.766346808999913, 38.606756903000075],
              [-28.75377356699994, 38.61172109600005],
              [-28.74510657499991, 38.619208075000074],
              [-28.728586391999954, 38.63898346600007],
              [-28.719593878999945, 38.64520905200004],
              [-28.632639126999948, 38.61399974200009],
              [-28.609730597999942, 38.59739817900004],
            ],
          ],
          [
            [
              [-27.890980597999942, 38.60423411700009],
              [-27.81663977799991, 38.58283112200007],
              [-27.778920050999943, 38.56708405200004],
              [-27.760609503999945, 38.54901764500005],
              [-27.777455206999946, 38.544134833000044],
              [-27.79645748599995, 38.54157135600008],
              [-27.835764126999948, 38.54279205900008],
              [-27.85220292899993, 38.54726797100005],
              [-27.884917772999927, 38.560532945000034],
              [-27.91515051999994, 38.56517161700009],
              [-27.931996222999942, 38.570298570000034],
              [-27.948597785999937, 38.577826239000046],
              [-27.96239173099991, 38.58685944200005],
              [-27.97687740799995, 38.593085028000075],
              [-28.00377356699994, 38.58942291900007],
              [-28.020741339999915, 38.59739817900004],
              [-28.034535285999937, 38.59007396000004],
              [-28.044178839999915, 38.59393952000005],
              [-28.06163489499994, 38.61172109600005],
              [-28.074370897999927, 38.617621161000045],
              [-28.177886522999927, 38.64508698100008],
              [-28.195790167999917, 38.65574778900009],
              [-28.215565558999913, 38.68211497600004],
              [-28.223052537999934, 38.68622467700004],
              [-28.23110917899993, 38.68504466400009],
              [-28.234730597999942, 38.683254299000055],
              [-28.238636847999942, 38.682847398000035],
              [-28.247222459999932, 38.68622467700004],
              [-28.249623175999943, 38.68992747600004],
              [-28.248524542999917, 38.69440338700008],
              [-28.249256964999915, 38.69818756700005],
              [-28.257191535999937, 38.69989655200004],
              [-28.26549231699994, 38.703192450000074],
              [-28.312123175999943, 38.735256252000056],
              [-28.315785285999937, 38.74209219000005],
              [-28.31554114499994, 38.755072333000044],
              [-28.297474738999938, 38.749253648000035],
              [-28.264475063999953, 38.73151276200008],
              [-28.250355597999942, 38.727728583000044],
              [-28.232533331999946, 38.72557200700004],
              [-28.034331834999932, 38.66632721600007],
              [-27.890980597999942, 38.60423411700009],
            ],
          ],
          [
            [
              [-27.020130988999938, 38.69367096600007],
              [-27.025746222999942, 38.69000885600008],
              [-27.047759568999936, 38.682928778000075],
              [-27.054351365999935, 38.679388739000046],
              [-27.05614173099991, 38.67133209800005],
              [-27.05174719999991, 38.654282945000034],
              [-27.054351365999935, 38.64520905200004],
              [-27.060292120999918, 38.64142487200007],
              [-27.089100714999915, 38.63100820500006],
              [-27.114165818999936, 38.63898346600007],
              [-27.181711391999954, 38.63934967700004],
              [-27.20449785099993, 38.65265534100007],
              [-27.217152472999942, 38.64130280200004],
              [-27.22838294199994, 38.64109935100004],
              [-27.25291907499991, 38.65265534100007],
              [-27.27879798099991, 38.657416083000044],
              [-27.304758266999954, 38.65888092700004],
              [-27.32762610599991, 38.66632721600007],
              [-27.352691209999932, 38.68439362200007],
              [-27.373402472999942, 38.70697663000004],
              [-27.383290167999917, 38.727728583000044],
              [-27.39171301999994, 38.75885651200008],
              [-27.368763800999943, 38.78266022300005],
              [-27.331776495999918, 38.798041083000044],
              [-27.298207160999937, 38.80353424700007],
              [-27.144276495999918, 38.796087958000044],
              [-27.11554928299995, 38.78607819200005],
              [-27.075062628999945, 38.76699453300006],
              [-27.04255123599995, 38.74445221600007],
              [-27.037505662999934, 38.72435130400004],
              [-27.04088294199994, 38.71442291900007],
              [-27.032826300999943, 38.70856354400007],
              [-27.022816535999937, 38.702826239000046],
              [-27.020130988999938, 38.69367096600007],
            ],
          ],
          [
            [
              [-27.98346920499995, 39.01512278900009],
              [-28.003895636999914, 39.01593659100007],
              [-28.025217251999948, 39.01911041900007],
              [-28.04515540299991, 39.02558014500005],
              [-28.06163489499994, 39.03628164300005],
              [-28.072987433999913, 39.05296458500004],
              [-28.071522589999915, 39.067613023000035],
              [-28.054839647999927, 39.097723700000074],
              [-28.04482988199993, 39.103216864000046],
              [-28.034331834999932, 39.10504791900007],
              [-28.023833787999934, 39.103216864000046],
              [-28.013824022999927, 39.097723700000074],
              [-28.007069464999915, 39.10455963700008],
              [-27.99128170499995, 39.08779531500005],
              [-27.95807857999995, 39.066473700000074],
              [-27.942209438999953, 39.05304596600007],
              [-27.935902472999942, 39.03595612200007],
              [-27.94717363199993, 39.02423737200007],
              [-27.96621660099993, 39.01732005400004],
              [-27.98346920499995, 39.01512278900009],
            ],
          ],
          [
            [
              [-31.207915818999936, 39.50861237200007],
              [-31.198557094999956, 39.50218333500004],
              [-31.186268683999913, 39.49664948100008],
              [-31.172718878999945, 39.495347398000035],
              [-31.159535285999937, 39.50177643400008],
              [-31.140736456999946, 39.48273346600007],
              [-31.13267981699994, 39.46552155200004],
              [-31.131581183999913, 39.42300039300005],
              [-31.139027472999942, 39.40029531500005],
              [-31.156646287999934, 39.37262604400007],
              [-31.17723548099991, 39.35561758000006],
              [-31.19367428299995, 39.36465078300006],
              [-31.212513800999943, 39.35773346600007],
              [-31.234445766999954, 39.35569896000004],
              [-31.254750128999945, 39.35809967700004],
              [-31.268788214999915, 39.36465078300006],
              [-31.278146938999953, 39.37840403900009],
              [-31.28465735599991, 39.39789459800005],
              [-31.284901495999918, 39.41616445500006],
              [-31.27562415299991, 39.42609284100007],
              [-31.280913865999935, 39.44310130400004],
              [-31.27562415299991, 39.457098700000074],
              [-31.26707923099991, 39.47207265800006],
              [-31.262562628999945, 39.491888739000046],
              [-31.25576738199993, 39.507473049000055],
              [-31.23932857999995, 39.517564195000034],
              [-31.21898352799991, 39.52240631700005],
              [-31.200510219999956, 39.52220286700009],
              [-31.207915818999936, 39.50861237200007],
            ],
          ],
          [
            [
              [-31.117298956999946, 39.72833893400008],
              [-31.08267167899993, 39.722723700000074],
              [-31.080230272999927, 39.69330475500004],
              [-31.099964972999942, 39.66400788000004],
              [-31.131581183999913, 39.65884023600006],
              [-31.13304602799991, 39.665350653000075],
              [-31.148915167999917, 39.69635651200008],
              [-31.152699347999942, 39.70107656500005],
              [-31.149647589999915, 39.71149323100008],
              [-31.141102667999917, 39.72089264500005],
              [-31.129383917999917, 39.72711823100008],
              [-31.117298956999946, 39.72833893400008],
            ],
          ],
          [
            [
              [-16.02798417899993, 30.033596096000053],
              [-16.023101365999935, 30.03229401200008],
              [-16.02301998599995, 30.029242255000042],
              [-16.02725175699993, 30.02960846600007],
              [-16.02798417899993, 30.033596096000053],
            ],
          ],
          [
            [
              [-15.864409959999932, 30.15253327000005],
              [-15.855458136999914, 30.146918036000045],
              [-15.854969855999911, 30.139593817000048],
              [-15.859771287999934, 30.133286851000037],
              [-15.863270636999914, 30.13467031500005],
              [-15.87022864499994, 30.13617584800005],
              [-15.874745245999918, 30.137925523000035],
              [-15.874094204999949, 30.13971588700008],
              [-15.87413489499994, 30.14166901200008],
              [-15.873443162999934, 30.14354075700004],
              [-15.864409959999932, 30.15253327000005],
            ],
          ],
          [
            [
              [-9.041127081999946, 38.867621161000045],
              [-9.035267706999946, 38.87055084800005],
              [-9.034575975999928, 38.86420319200005],
              [-9.041411912999934, 38.84918854400007],
              [-9.05455481699994, 38.83299388200004],
              [-9.073150193999936, 38.81818268400008],
              [-9.079660610999952, 38.82013580900008],
              [-9.07140051999994, 38.837591864000046],
              [-9.061390753999945, 38.85224030200004],
              [-9.050119594999956, 38.86172109600005],
              [-9.043934699999909, 38.86579010600008],
              [-9.041127081999946, 38.867621161000045],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Moldova',
        iso3: 'MDA',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [26.617889038000015, 48.25896759100006],
            [26.618612508000126, 48.26718414300011],
            [26.625123739000088, 48.28289377800006],
            [26.636079142000057, 48.29488271100003],
            [26.669100382000124, 48.30880950900011],
            [26.67400964400008, 48.32170277900012],
            [26.679797404000055, 48.330177714000015],
            [26.69943444900008, 48.32511342400004],
            [26.712973674000068, 48.314907328000075],
            [26.72361901900004, 48.302582499000025],
            [26.73591801000009, 48.291833801000095],
            [26.754573202000074, 48.28614939400005],
            [26.774365275000036, 48.28718292300003],
            [26.78573409000012, 48.294107564000015],
            [26.79007491100009, 48.30705251100004],
            [26.789351440000104, 48.32594024700008],
            [26.784080444000068, 48.34516388000007],
            [26.77818933100008, 48.35720448800005],
            [26.777517538000097, 48.366170350000104],
            [26.788059530000055, 48.37596303300005],
            [26.79358890800006, 48.376273092000034],
            [26.810073690000138, 48.371880595000036],
            [26.816946655000095, 48.37172556600011],
            [26.825628296000076, 48.377771708000054],
            [26.82841882400004, 48.385135600000055],
            [26.831932821000066, 48.39136261000003],
            [26.84278487200004, 48.393739726],
            [26.875961141000033, 48.38399871900005],
            [26.90872399900013, 48.36524017400005],
            [26.943243856000038, 48.351261699000034],
            [26.981071004000086, 48.35568003400006],
            [26.990579468000078, 48.36237213100007],
            [26.997814168000048, 48.36154530900005],
            [27.00463545800011, 48.35875478100009],
            [27.015590861000078, 48.35940073700006],
            [27.027683146000072, 48.35774709100009],
            [27.033057495000037, 48.36020172200007],
            [27.031817260000082, 48.36524017400005],
            [27.028509969000083, 48.370795390000055],
            [27.027786499000086, 48.37477447600013],
            [27.028199910000097, 48.38138905900003],
            [27.02540938300004, 48.38986399400004],
            [27.026339559000093, 48.39709869400009],
            [27.037398315000104, 48.399682516],
            [27.048043661000094, 48.39766713500005],
            [27.068817586000137, 48.38888214200007],
            [27.175787801000098, 48.36180369100002],
            [27.20855065900011, 48.36061513300008],
            [27.246481160000116, 48.37374094700006],
            [27.25193001700012, 48.37831004100009],
            [27.306012411000097, 48.423660380000015],
            [27.342185913000037, 48.4361144010001],
            [27.361409546000033, 48.43280710900011],
            [27.389831583000074, 48.41500457800005],
            [27.403474161000076, 48.41149058100011],
            [27.420217325000124, 48.41714915000004],
            [27.480885458000103, 48.451410625000065],
            [27.503829794000126, 48.47236541800005],
            [27.54517093900006, 48.47236541800005],
            [27.5570565190001, 48.47435496100009],
            [27.582998087000135, 48.486033834000054],
            [27.604805542000065, 48.48412180600003],
            [27.60687259900004, 48.45781850200008],
            [27.62702640800012, 48.45125559500012],
            [27.751773315000094, 48.45197906600002],
            [27.785259643000103, 48.44156626400009],
            [27.849855184000063, 48.409630229000086],
            [27.86484134900013, 48.3989073690001],
            [27.885371499000144, 48.37844387600008],
            [27.896674032000078, 48.36717804000007],
            [27.904528849000116, 48.362475484000086],
            [27.92643965600007, 48.33942779500002],
            [27.96705733200011, 48.32888580400005],
            [28.003176857000085, 48.32588284300003],
            [28.055940796000044, 48.32149607400005],
            [28.07640466300012, 48.31493316700006],
            [28.092837768000066, 48.302065735000085],
            [28.098315471000063, 48.2841081750001],
            [28.078678426000124, 48.244911601000055],
            [28.093251180000095, 48.237444357000115],
            [28.115575399000136, 48.23674672500003],
            [28.131078329000076, 48.23958892900002],
            [28.16208418800008, 48.257184754],
            [28.17851729300014, 48.258864238000044],
            [28.185751994000015, 48.24237945600005],
            [28.189369344000113, 48.2230524700001],
            [28.19991133600007, 48.21173533200003],
            [28.216964559000104, 48.208143820000046],
            [28.240322307000042, 48.2116319790001],
            [28.261716349000068, 48.219951884000054],
            [28.277529337000146, 48.22912445100006],
            [28.29447920700005, 48.23648834300006],
            [28.3405745850001, 48.24010569300005],
            [28.35773116100006, 48.23860707600004],
            [28.36816980000009, 48.23062306800007],
            [28.370030151000094, 48.2116319790001],
            [28.36336389200008, 48.191013082],
            [28.352253458000064, 48.18186635400012],
            [28.337887410000064, 48.17548431500008],
            [28.322177775000085, 48.16321116100006],
            [28.3155631920001, 48.14928436300006],
            [28.317423543000103, 48.13535756500009],
            [28.32858565300012, 48.12701182000002],
            [28.349566284000048, 48.129724833000054],
            [28.364965861000115, 48.14150706000005],
            [28.3755595290001, 48.156648255000064],
            [28.388633667000136, 48.16858551100002],
            [28.411578003000074, 48.170704244],
            [28.427287639000042, 48.163366191000094],
            [28.43689945500006, 48.14985280400002],
            [28.435659221000037, 48.13468577100009],
            [28.4190194090001, 48.122231751000115],
            [28.44744144700013, 48.08275095700007],
            [28.459378703000056, 48.07445688900005],
            [28.479584188000047, 48.064922588000044],
            [28.490022827000104, 48.065491028000096],
            [28.493743531000092, 48.07481862400003],
            [28.494156942000103, 48.091846009000065],
            [28.49979009800009, 48.10891363000003],
            [28.501081584000104, 48.11282664000005],
            [28.51932336400006, 48.14912933400002],
            [28.54159590600011, 48.15595062300007],
            [28.573635295000116, 48.1549687710001],
            [28.665619344000106, 48.12933726000004],
            [28.735072469000073, 48.12869130500006],
            [28.771245972000088, 48.12445383700002],
            [28.799254598000118, 48.11179311100007],
            [28.805920858000036, 48.10380910300002],
            [28.808349650000082, 48.09657440200006],
            [28.809176473, 48.08977895200009],
            [28.81155358900014, 48.08290598600003],
            [28.827573283000106, 48.057016094000105],
            [28.83077722100009, 48.030867819],
            [28.83253422100006, 48.02482167600006],
            [28.83925215600007, 48.01828460700007],
            [28.855685262000037, 48.007923483000056],
            [28.862085148000034, 48.00050207700009],
            [28.88255700700006, 47.976762594],
            [28.914803101000103, 47.953146464000085],
            [28.93608673600005, 47.94216435600002],
            [28.95035648600006, 47.93480133100009],
            [28.980845581000068, 47.92637807200002],
            [29.017225790000055, 47.93108062800009],
            [29.061047404000135, 47.969760438],
            [29.092725057000052, 47.98017323800012],
            [29.11003666200014, 47.979656474000066],
            [29.12398929800014, 47.975987447000065],
            [29.136288290000095, 47.968184306000055],
            [29.147967163000146, 47.95536855100006],
            [29.155821981000088, 47.93986562100007],
            [29.164606974000094, 47.90560414700006],
            [29.172565145000135, 47.891005554000074],
            [29.186621134000063, 47.88364166300009],
            [29.225998576000052, 47.87558014000008],
            [29.23602380300008, 47.870722555000086],
            [29.23276818800008, 47.857079976000065],
            [29.21742028800014, 47.84289479600001],
            [29.198920125000114, 47.829484762000064],
            [29.186724487000077, 47.81821930000011],
            [29.177732788000043, 47.80070098900005],
            [29.177836141000085, 47.78971974700006],
            [29.187447957000074, 47.783208517],
            [29.221967814000095, 47.77481109600002],
            [29.23473189300006, 47.76680125000006],
            [29.2386076250001, 47.756000875000026],
            [29.226670369000146, 47.74323679600003],
            [29.196956421000067, 47.71750193300004],
            [29.191478719000088, 47.68626352900007],
            [29.192408895000142, 47.65091685000006],
            [29.182073609000042, 47.61321889300011],
            [29.1561837160001, 47.58278147400004],
            [29.130500529000102, 47.559630433000066],
            [29.117426391000066, 47.53332712800001],
            [29.130397176000088, 47.493200378],
            [29.130500529000102, 47.493097026000086],
            [29.13060388200006, 47.49304535000006],
            [29.130655558000058, 47.492941997000045],
            [29.137188792000074, 47.48400843200001],
            [29.140008993000095, 47.48015208000005],
            [29.15561527500003, 47.44999888100007],
            [29.163883504000097, 47.43937937400007],
            [29.182073609000042, 47.429870911000094],
            [29.192408895000142, 47.4358137010001],
            [29.20186568200012, 47.44658823700003],
            [29.218350464000082, 47.45160085000002],
            [29.23261315900004, 47.44632985500006],
            [29.250699910000094, 47.42537506100008],
            [29.28139571100013, 47.41147410100008],
            [29.288217001000078, 47.40077708000008],
            [29.2927128500001, 47.38886566200004],
            [29.30082605000007, 47.378194479000044],
            [29.31467533300014, 47.372716777000065],
            [29.330384969000136, 47.37049469000006],
            [29.345836222000116, 47.365843811],
            [29.358910360000095, 47.352717998000045],
            [29.3640780020001, 47.336879171000035],
            [29.36449141500009, 47.32243560800002],
            [29.367592, 47.30822459000005],
            [29.37088151900008, 47.30443393300003],
            [29.380821167000136, 47.29298004100009],
            [29.394463745000053, 47.284711813000044],
            [29.409553263000134, 47.27975087600002],
            [29.4255729570001, 47.27866567000011],
            [29.44169600400005, 47.28212799100005],
            [29.459162638000123, 47.29349680600005],
            [29.466087280000067, 47.30744944200005],
            [29.470634806000135, 47.32274566700009],
            [29.480866740000124, 47.338274435000116],
            [29.501072225000087, 47.33982472800004],
            [29.52096765200008, 47.33892039000007],
            [29.539881225000045, 47.3342178350001],
            [29.556572714000083, 47.324037578000045],
            [29.57006026200014, 47.30677764900004],
            [29.579258667000147, 47.283600769000046],
            [29.580188843000087, 47.26044972700005],
            [29.568716675000076, 47.243138123000065],
            [29.544015340000044, 47.234249777000045],
            [29.540397990000088, 47.212545675000044],
            [29.550629923000088, 47.160171611000024],
            [29.544842163000112, 47.135573629000035],
            [29.53037276200007, 47.12368805000001],
            [29.50866866000007, 47.11939890600003],
            [29.480866740000124, 47.11748687800012],
            [29.478592976000073, 47.11464467400005],
            [29.477869507000094, 47.11154408800009],
            [29.478696330000048, 47.10846934100006],
            [29.480866740000124, 47.1052395630001],
            [29.511459188000117, 47.066017151000025],
            [29.52014082900007, 47.059919332000064],
            [29.530992879000053, 47.066017151000025],
            [29.539726197000107, 47.07888458200004],
            [29.551353394000046, 47.0902017210001],
            [29.57016361500007, 47.091441956000054],
            [29.583392781000043, 47.08521494500006],
            [29.5948649500001, 47.07459543900008],
            [29.60209965000007, 47.06100453800006],
            [29.603029826000125, 47.04575998900005],
            [29.59543339000004, 47.03214325000003],
            [29.583392781000043, 47.0227898160001],
            [29.57248905500012, 47.0117568970001],
            [29.564995972000077, 46.97449819000006],
            [29.56062574300006, 46.96125639500009],
            [29.559828329000084, 46.95884023000012],
            [29.558691447000058, 46.94574025500005],
            [29.567476440000064, 46.93465566000005],
            [29.5731608480001, 46.933725485000096],
            [29.598482300000057, 46.935379130000044],
            [29.607577352000135, 46.93202016300002],
            [29.623286987000085, 46.91954030400005],
            [29.631865275000052, 46.91439849900003],
            [29.648091675000046, 46.91041941400006],
            [29.68085453300006, 46.908559062000066],
            [29.69615075700011, 46.90468332900009],
            [29.712480509000045, 46.89344370600004],
            [29.73583825700007, 46.867192078000116],
            [29.75413171400004, 46.85801951100002],
            [29.78575769000014, 46.854660543000094],
            [29.81521325700004, 46.856624248000045],
            [29.84363529400008, 46.85414377900007],
            [29.872212361000038, 46.8377106730001],
            [29.876914917000136, 46.83078603100002],
            [29.884873087000074, 46.812673442000104],
            [29.889627319000056, 46.80716990200001],
            [29.898515666000094, 46.80665313800007],
            [29.90771407000011, 46.81094228200003],
            [29.917429240000047, 46.81396535300006],
            [29.928177938000147, 46.8097537230001],
            [29.930658406000134, 46.803087464],
            [29.930451701000095, 46.781641744000055],
            [29.931795288000046, 46.77244333900008],
            [29.935671021000076, 46.765156963],
            [29.94667810100009, 46.750739238000065],
            [29.951122273000067, 46.743116964000095],
            [29.952620890000105, 46.72469431600008],
            [29.94440433800014, 46.662475891],
            [29.94027022300014, 46.650797017000016],
            [29.935412638000116, 46.64185699500008],
            [29.931898641000146, 46.632374369],
            [29.931278524000106, 46.61917104100003],
            [29.93494755000006, 46.6088357550001],
            [29.947401570000068, 46.58834604900004],
            [29.949675334000062, 46.57886342400006],
            [29.938099812000132, 46.55734019000003],
            [29.91608565200005, 46.554368795000116],
            [29.898825724000062, 46.553128561000065],
            [29.901926310000135, 46.530830180000024],
            [29.91608565200005, 46.518815410000045],
            [29.960217326000077, 46.505947978000066],
            [29.96207767700008, 46.50344167100009],
            [29.967038614000103, 46.49385569300007],
            [29.970552612000063, 46.4917369600001],
            [29.977063843000053, 46.49318390000009],
            [29.989259481000147, 46.498687439],
            [29.99494388900007, 46.49853241000004],
            [30.002850383000123, 46.494217428000084],
            [30.00941329000011, 46.48806793200002],
            [30.021712280000145, 46.47065297500008],
            [30.01406416800006, 46.46202301000004],
            [30.06000451600005, 46.43680491100007],
            [30.077006063000113, 46.42282643700007],
            [30.086927938000088, 46.42887258000012],
            [30.102017456000056, 46.43073293100012],
            [30.118243856000106, 46.42869171200006],
            [30.131576375000122, 46.42282643700007],
            [30.107185100000095, 46.39189809200006],
            [30.081140177000123, 46.374198914000075],
            [30.03726688600011, 46.36892791800004],
            [29.91866947400007, 46.37365631100003],
            [29.90254642700006, 46.371175843000046],
            [29.884666382000034, 46.36419952400006],
            [29.847769410000126, 46.34146189400006],
            [29.828132365000045, 46.339394837],
            [29.808185262000052, 46.354691061000054],
            [29.80616988200012, 46.36156402600004],
            [29.806738322000058, 46.38089101200008],
            [29.805084676000092, 46.38998606400004],
            [29.80033044400011, 46.39835764600012],
            [29.779556519000096, 46.42109527600009],
            [29.726949910000087, 46.455796],
            [29.714134155000067, 46.47116973900002],
            [29.7138240970001, 46.44305776000006],
            [29.70286869300014, 46.42832997600006],
            [29.682714885000053, 46.422929789000094],
            [29.654396199000075, 46.42269724500004],
            [29.647988322000117, 46.41639272100012],
            [29.65294925900008, 46.39189809200006],
            [29.64550785300014, 46.37559417800004],
            [29.63207198100008, 46.36605987600005],
            [29.615638875000116, 46.361822409000084],
            [29.5985856530001, 46.36306264300005],
            [29.582979370000146, 46.36965138800012],
            [29.5694401450001, 46.38228627600007],
            [29.555642538000143, 46.40419708300003],
            [29.54143151900007, 46.41303375300002],
            [29.527478882000082, 46.416651103],
            [29.496059611000135, 46.42081105600003],
            [29.480866740000124, 46.42515187700009],
            [29.475078980000035, 46.432257386000046],
            [29.473321981000083, 46.43980214500009],
            [29.475285685000074, 46.44755360900008],
            [29.480866740000124, 46.455511780000066],
            [29.48624108900009, 46.462488098000065],
            [29.48820479300008, 46.46936106400001],
            [29.486447795000117, 46.47587229500009],
            [29.480866740000124, 46.482047628000075],
            [29.457612345000086, 46.484708965],
            [29.456723690000103, 46.48436632400008],
            [29.436838420000072, 46.47669911800001],
            [29.418234904000087, 46.462488098000065],
            [29.37472334800009, 46.416186015000065],
            [29.36211429900004, 46.415927633000095],
            [29.34423425300008, 46.43416941400007],
            [29.32077315300012, 46.46874094700006],
            [29.306717163000087, 46.47199656200003],
            [29.289147176000142, 46.45163604700009],
            [29.285943238000073, 46.4394920860001],
            [29.290697469000065, 46.41926076300011],
            [29.290077352000083, 46.41024322500006],
            [29.283256062000135, 46.39742747000007],
            [29.278191772000127, 46.39587717800005],
            [29.2713704840001, 46.39742747000007],
            [29.259174845000075, 46.39435272300004],
            [29.222897990000035, 46.36647328800005],
            [29.200677124000094, 46.35711985300013],
            [29.183727254000075, 46.36717091900006],
            [29.18341719600008, 46.37760955800009],
            [29.190341837000062, 46.387195536],
            [29.1992818600001, 46.39649729400013],
            [29.205638061000116, 46.40610911100005],
            [29.20760176600004, 46.41789133800005],
            [29.20677494300014, 46.50251149500012],
            [29.20021203600004, 46.523983053000066],
            [29.1842440180001, 46.53803904300007],
            [29.18305928500004, 46.53804189100005],
            [29.16274662200007, 46.538090719000095],
            [29.074948364000107, 46.50367421500003],
            [29.055914596000093, 46.49874020100002],
            [29.02032637500008, 46.4895148720001],
            [28.945808960000136, 46.45478831000007],
            [28.925448446000104, 46.43277415000007],
            [28.919247274000014, 46.404662171000055],
            [28.92730879700011, 46.36802358000007],
            [28.944878784000082, 46.320739645000046],
            [28.945808960000136, 46.30497833300005],
            [28.939917847000117, 46.28699493500007],
            [28.93288985200013, 46.27262888600008],
            [28.933509969000085, 46.25898630800005],
            [28.95061486800003, 46.243121644000055],
            [28.95076989800009, 46.24306996700004],
            [28.98411214300006, 46.22122102400006],
            [29.009836059000122, 46.20436431900002],
            [29.015365438000117, 46.18260854100002],
            [29.003479858000105, 46.158940736000076],
            [28.980845581000068, 46.132120667],
            [28.94642907700009, 46.105093893000046],
            [28.938780965000035, 46.08928090500005],
            [28.941158081000083, 46.064682922000074],
            [28.958934773000095, 46.021016338],
            [28.956867717000137, 46.001379293000056],
            [28.931959676000076, 45.993162740000045],
            [28.757603393000096, 45.961175029000046],
            [28.740240112000066, 45.95321685800009],
            [28.729181356000083, 45.93864410400003],
            [28.72840620900007, 45.92195261700009],
            [28.742307170000032, 45.88732940700008],
            [28.74644128400007, 45.870586243000034],
            [28.745046021000093, 45.85048411100006],
            [28.738276407000058, 45.83756500300005],
            [28.7255640060001, 45.828780009000056],
            [28.70639205000009, 45.821131897],
            [28.67729821800009, 45.81658437100005],
            [28.66975345900002, 45.81203684500012],
            [28.669391724000036, 45.80630076100006],
            [28.671923868000107, 45.79725738600011],
            [28.673267456000076, 45.78687042300008],
            [28.66975345900002, 45.77731028300009],
            [28.64360518400011, 45.76650990800006],
            [28.57668420400003, 45.761910706],
            [28.560612834000068, 45.743203837000024],
            [28.563525429000094, 45.7354940260001],
            [28.567640828000094, 45.72460032200006],
            [28.561439657000108, 45.716590475],
            [28.532500855000137, 45.71007924400003],
            [28.515240926000047, 45.70201772100002],
            [28.504182169000046, 45.69369781500008],
            [28.48092777500011, 45.66946156900009],
            [28.474003133000053, 45.65793772500005],
            [28.482891480000063, 45.6507547],
            [28.498497762000085, 45.64429514600003],
            [28.511313517000076, 45.63504506500003],
            [28.516894572000098, 45.62098907500011],
            [28.518754923000103, 45.60703643800012],
            [28.523095744000074, 45.59323883100008],
            [28.536893351000117, 45.57980295900002],
            [28.510435018000123, 45.571017965000024],
            [28.504595581000046, 45.56724558600011],
            [28.50374338900008, 45.56610240200011],
            [28.498239380000115, 45.558718974],
            [28.49798099800006, 45.55644521100008],
            [28.500048055000036, 45.55458486000008],
            [28.50645593200005, 45.520581767000024],
            [28.502011760000045, 45.50874786400003],
            [28.48092777500011, 45.50197825100007],
            [28.41684899900011, 45.503786926000075],
            [28.341918172000135, 45.517636211000124],
            [28.270501343000063, 45.52151194300008],
            [28.27042337800009, 45.521470690000044],
            [28.217274617000072, 45.493348288000035],
            [28.217171264000058, 45.49319325800009],
            [28.208489624000094, 45.48141103100009],
            [28.201564982000036, 45.46885365800007],
            [28.19949792500006, 45.46177398700006],
            [28.172936239000137, 45.4843565880001],
            [28.165908244000036, 45.49458852200006],
            [28.16539147900008, 45.528281556000124],
            [28.164047892000042, 45.53060699500004],
            [28.161567423000065, 45.532725729000035],
            [28.15774336700011, 45.53892690000002],
            [28.140948527000063, 45.5602175910001],
            [28.118004191000097, 45.5727232870001],
            [28.06214196800005, 45.59360056600006],
            [28.074751017000068, 45.604866028000046],
            [28.09118412300012, 45.615976461000045],
            [28.10772058100011, 45.62439971900004],
            [28.120846394000097, 45.62770701100003],
            [28.153712606000113, 45.62750030600007],
            [28.167975302000087, 45.63246124300012],
            [28.161774129000094, 45.64543202700004],
            [28.16373783400013, 45.66150339800002],
            [28.154952840000135, 45.761807353000066],
            [28.146477906000143, 45.77116078700003],
            [28.128907918000067, 45.795035299000105],
            [28.11330163600013, 45.82536936400005],
            [28.110511109000072, 45.85430816600011],
            [28.114955282000096, 45.85973419200009],
            [28.128184449000088, 45.86640045200009],
            [28.131078329000076, 45.87136139000005],
            [28.129114624000124, 45.87513376900007],
            [28.120226278000104, 45.887846172000124],
            [28.117435751000073, 45.89523590100002],
            [28.11877933800011, 45.903142395000074],
            [28.122810099000105, 45.91079050800006],
            [28.124980510000114, 45.9183869430001],
            [28.120846394000097, 45.92629343700007],
            [28.114851928000064, 45.93321807900004],
            [28.112371460000077, 45.939212545000075],
            [28.110511109000072, 45.950426331000116],
            [28.086119833000055, 46.000552471000034],
            [28.08270918800011, 46.01471181200007],
            [28.0844661860001, 46.02458201100008],
            [28.09686853100007, 46.05967030900011],
            [28.096558471000094, 46.065044658000076],
            [28.090460652000047, 46.06799021400006],
            [28.090150594000136, 46.07336456400013],
            [28.092837768000066, 46.07837717700009],
            [28.100795939000136, 46.08199452700008],
            [28.10782281200005, 46.09610295600008],
            [28.110506470000132, 46.10149115700004],
            [28.12735762500006, 46.135324605000065],
            [28.133248739000067, 46.15997426400007],
            [28.14472090600006, 46.18322865900008],
            [28.141516968000104, 46.19196197500004],
            [28.135625855000086, 46.1988349410001],
            [28.129321329000078, 46.204674378],
            [28.11097619600011, 46.225603333],
            [28.108960816000064, 46.23412994400009],
            [28.120846394000097, 46.237850647000116],
            [28.13211185700004, 46.239917704000064],
            [28.13448897300009, 46.245343730000045],
            [28.131078329000076, 46.26239695200009],
            [28.135212443000086, 46.26932159500008],
            [28.144927612000117, 46.272938945000064],
            [28.156296428000104, 46.275367738000014],
            [28.16575321400009, 46.278830058000054],
            [28.177793824000048, 46.28704661100009],
            [28.191333049000036, 46.30776886000011],
            [28.19288334100014, 46.31123118100005],
            [28.191953165000115, 46.32350433400008],
            [28.18792240400012, 46.343787333000094],
            [28.19035119700007, 46.35107371100007],
            [28.202391805000047, 46.35391591400004],
            [28.207146037000115, 46.35815338100009],
            [28.21293379700009, 46.38869415300009],
            [28.219548380000106, 46.393345032000056],
            [28.226796348000107, 46.395548249000015],
            [28.228643433000087, 46.396109721000116],
            [28.233294312000055, 46.40176829000005],
            [28.226059611000068, 46.415359192000054],
            [28.240218953000124, 46.420268454000066],
            [28.246058390000115, 46.42786488900005],
            [28.247246948000026, 46.436184794],
            [28.247143595000097, 46.46719065400002],
            [28.24580000800003, 46.475510559],
            [28.242337687000088, 46.47651825000007],
            [28.238100220000035, 46.4755880740001],
            [28.234121134000077, 46.47806854200009],
            [28.22109867400013, 46.49576772100009],
            [28.219031616000052, 46.50372589100006],
            [28.22109867400013, 46.54119130500003],
            [28.224767700000115, 46.548736064000096],
            [28.234121134000077, 46.553128560000076],
            [28.225439494000113, 46.56956166600004],
            [28.230503784000092, 46.58390187600004],
            [28.24052901200011, 46.59638173500004],
            [28.247143595000097, 46.60715627000006],
            [28.24735030100007, 46.62082468700008],
            [28.245085309000046, 46.631451272000035],
            [28.24424971500011, 46.635371603000024],
            [28.234121134000077, 46.66242421500009],
            [28.17810388200013, 46.739835511000095],
            [28.17815555800007, 46.75864573200003],
            [28.137796264000087, 46.806239726000044],
            [28.121518188000067, 46.83430002900006],
            [28.12261528700006, 46.842269519000084],
            [28.1242570390001, 46.85419545500007],
            [28.1242570390001, 46.86163686100009],
            [28.113094930000074, 46.87142954600007],
            [28.114335164000124, 46.88339264000011],
            [28.1135600180001, 46.894761454],
            [28.09686853100007, 46.90261627300005],
            [28.105446818000104, 46.91767995300005],
            [28.104994100000113, 46.920184743000064],
            [28.10229455600006, 46.935120748000074],
            [28.08270918800011, 46.97152679500006],
            [28.069066609000117, 46.98850250300008],
            [28.038146337000057, 47.015482935000094],
            [28.03702722200012, 47.01645945300008],
            [28.028035522000067, 47.032970073000044],
            [28.008295125000103, 47.02630381300004],
            [27.98659102400009, 47.03322845500013],
            [27.963129924000043, 47.04338287400007],
            [27.938738647000093, 47.046638489000074],
            [27.938428589000125, 47.06105621400009],
            [27.92592289200013, 47.068756002000086],
            [27.897604207000114, 47.08141672800012],
            [27.867011759000036, 47.104645285000046],
            [27.8577100010001, 47.10932200100011],
            [27.848201538000097, 47.111414897000074],
            [27.8437573650001, 47.11438629100009],
            [27.849855184000063, 47.12172434500006],
            [27.849855184000063, 47.12851979600002],
            [27.806550334000093, 47.144617005],
            [27.794664754000053, 47.15583079100004],
            [27.805878540000094, 47.1582337440001],
            [27.8076872150001, 47.16247121200006],
            [27.804793335000113, 47.16849151700008],
            [27.80210616000008, 47.176346334000115],
            [27.80034916200009, 47.17696645200009],
            [27.788308553000036, 47.204277446],
            [27.763038778000066, 47.22631744400009],
            [27.752393433000066, 47.23892649400001],
            [27.753633667000116, 47.25143219000002],
            [27.733273153000084, 47.275616761],
            [27.722834513000038, 47.28331654900008],
            [27.697823120000038, 47.28750234000002],
            [27.68986495000007, 47.29088714600003],
            [27.682320191000116, 47.295253805000115],
            [27.671726521000068, 47.299853008000056],
            [27.644699748000107, 47.303987122000095],
            [27.636948283000095, 47.306674296000025],
            [27.6240291740001, 47.321427918000026],
            [27.59994795700007, 47.36072784400001],
            [27.588723990000062, 47.36738939800007],
            [27.58640873200008, 47.368763530000095],
            [27.572352743000067, 47.37519724500005],
            [27.58031091300012, 47.4059964],
            [27.56253422000009, 47.41653839100006],
            [27.56553145400011, 47.42826894200006],
            [27.569355509000047, 47.43855255200005],
            [27.574781535000113, 47.44625234000004],
            [27.582998087000135, 47.45067067500004],
            [27.575866739000105, 47.4604116820001],
            [27.56315433800006, 47.468344015000056],
            [27.54816817200009, 47.474260966000045],
            [27.534525594000087, 47.47798167000006],
            [27.53297530100005, 47.47741322900002],
            [27.507240438000053, 47.47798167000006],
            [27.501452678000078, 47.47994537400011],
            [27.497525268000118, 47.48242584300009],
            [27.492564331000068, 47.48454457600006],
            [27.483675985000076, 47.48542307600009],
            [27.4731339920001, 47.49177927700002],
            [27.466726115000142, 47.50635203100008],
            [27.459491414000098, 47.53322377500008],
            [27.456907593000096, 47.53389556900005],
            [27.446055542000124, 47.53487742200012],
            [27.442128134000086, 47.53663442],
            [27.44006107600012, 47.54102691700008],
            [27.440267782000063, 47.550096131000075],
            [27.438975870000036, 47.55371348100006],
            [27.43582360800005, 47.559940491000035],
            [27.43134229800009, 47.572637535000055],
            [27.429403890000117, 47.578129692000104],
            [27.428382202000137, 47.58102447500006],
            [27.39706628400012, 47.58908599900006],
            [27.36916101100013, 47.608309632000086],
            [27.30404870600006, 47.66654897100001],
            [27.281104370000037, 47.69300730400009],
            [27.272009318000045, 47.71496978800006],
            [27.29505700700011, 47.718173727000035],
            [27.29505700700011, 47.72442657500004],
            [27.28957930500013, 47.73168711400011],
            [27.291129598000055, 47.74240997400001],
            [27.28811445900007, 47.75068006700003],
            [27.287512247000052, 47.7523318490001],
            [27.282447957000073, 47.755690816000126],
            [27.26467126400007, 47.76455332500002],
            [27.260847208000115, 47.76907501300006],
            [27.256196329000147, 47.77754994800007],
            [27.24487919100008, 47.79258778900005],
            [27.231081584000037, 47.80708302900008],
            [27.21919600400011, 47.81377512600001],
            [27.25340580200009, 47.8280894980001],
            [27.24580936700005, 47.836590272000095],
            [27.23490564000008, 47.840207622],
            [27.222813355000085, 47.84266225200007],
            [27.21237471500004, 47.847933248000075],
            [27.213201538000078, 47.85413442000008],
            [27.211547892000112, 47.88501108800007],
            [27.21237471500004, 47.88950693800008],
            [27.19418461100011, 47.904053854000026],
            [27.17155033300014, 47.91263214200008],
            [27.1606982830001, 47.92172719300005],
            [27.178268270000075, 47.93792775500005],
            [27.178268270000075, 47.942095667],
            [27.178268270000075, 47.94412892700002],
            [27.171963746000074, 47.946428528000055],
            [27.15098311300008, 47.95779734300005],
            [27.162868693000092, 47.9650062060001],
            [27.169793335000065, 47.973791199000075],
            [27.168759806000082, 47.98306711900001],
            [27.15718428500014, 47.99195546500003],
            [27.14374841300011, 47.98683949800004],
            [27.13460168500012, 48.000456238000126],
            [27.121475871000143, 48.013194478000074],
            [27.09579268400006, 48.00559804300012],
            [27.0933638920001, 48.00844024700008],
            [27.091451864000078, 48.01185089100004],
            [27.090004924000084, 48.01562327100005],
            [27.088971395000016, 48.019809062],
            [27.109331910000066, 48.02608774800008],
            [27.109331910000066, 48.03350331700001],
            [27.08318363500004, 48.04365773600007],
            [27.05920577000012, 48.05804962100008],
            [27.041739136000075, 48.07727325400002],
            [27.03429772900006, 48.10176788400007],
            [27.03688155100008, 48.10734893800007],
            [27.047423543000036, 48.11649566600006],
            [27.0479547570001, 48.1214093870001],
            [27.048043661000094, 48.122231751000115],
            [27.04277266400007, 48.12729604100009],
            [27.033677612000105, 48.13238617000006],
            [27.02509932500007, 48.135047506],
            [27.0126969800001, 48.12812286400002],
            [26.99399011200012, 48.13241200800009],
            [26.966601603000072, 48.143367412000046],
            [26.966601603000072, 48.14959442200005],
            [26.986238647000107, 48.15042124400007],
            [26.997607463000094, 48.15794016600002],
            [26.997607463000094, 48.16657012900005],
            [26.9630876060001, 48.17538096200006],
            [26.955646199000086, 48.186000469000035],
            [26.950581909000107, 48.19752431300007],
            [26.938127889000043, 48.20481068900004],
            [26.929084513000078, 48.19904876700009],
            [26.917715699000098, 48.18796417300008],
            [26.90800052900005, 48.18452769000005],
            [26.903969767000063, 48.201451722000044],
            [26.89766524200013, 48.20897064200007],
            [26.855497274000072, 48.23783193000013],
            [26.844748576000143, 48.23331024200009],
            [26.82190759300005, 48.252533875000026],
            [26.804906047000117, 48.25826995900009],
            [26.763719930000036, 48.252740580000065],
            [26.7440312090001, 48.255582784000055],
            [26.733127482000043, 48.270749817000066],
            [26.722378784000114, 48.25976857500008],
            [26.711475057000143, 48.261318868],
            [26.68853072100012, 48.27483225600007],
            [26.665741415000127, 48.27421213800001],
            [26.617889038000015, 48.25896759100006],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Gibraltar',
        iso3: 'GIB',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-5.358386758461411, 36.141109447000375],
            [-5.338773483242616, 36.14111967199992],
            [-5.339914516999954, 36.12982819200005],
            [-5.339060024999924, 36.12384674700007],
            [-5.34203040299991, 36.11050039300005],
            [-5.35024980399993, 36.11928945500006],
            [-5.358386758461411, 36.141109447000375],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Vatican',
        iso3: 'VAT',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [12.45313691700008, 41.90275194100009],
            [12.452714082000085, 41.903016213000015],
            [12.452766936000103, 41.903439049],
            [12.45303120800014, 41.903914738000125],
            [12.453982588000144, 41.903861884],
            [12.454035442000077, 41.90275194100009],
            [12.45313691700008, 41.90275194100009],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Iceland',
        iso3: 'ISL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-14.563628709999932, 66.38450755400004],
              [-14.610747850999928, 66.36322663000004],
              [-14.78819739499994, 66.33038971600007],
              [-14.867176886999914, 66.30585358300004],
              [-14.959136522999927, 66.29645416900007],
              [-14.990589972999942, 66.28583405200004],
              [-15.014800584999932, 66.26837799700007],
              [-14.990305141999954, 66.26459381700005],
              [-14.978260870999918, 66.25950755400004],
              [-14.973215298999946, 66.25161367400005],
              [-14.968129035999937, 66.24966054900005],
              [-14.94640051999994, 66.23183828300006],
              [-14.942209438999953, 66.22736237200007],
              [-14.935210740999935, 66.22190989800004],
              [-14.93976803299995, 66.21010976800005],
              [-14.952137824999909, 66.19330475500004],
              [-14.960357225999928, 66.18577708500004],
              [-15.056019660999937, 66.14813873900005],
              [-15.072865363999938, 66.14484284100007],
              [-15.13463294199994, 66.14325592700004],
              [-15.161000128999945, 66.13361237200007],
              [-15.179351365999935, 66.11131419500003],
              [-15.148589647999927, 66.10146719000005],
              [-15.13345292899993, 66.09870026200008],
              [-15.07412675699993, 66.09711334800005],
              [-15.061390753999945, 66.08934153900003],
              [-15.05577551999994, 66.07037995000007],
              [-15.06627356699994, 66.06732819200005],
              [-15.08462480399993, 66.05955638200004],
              [-15.096750454999949, 66.05609772300005],
              [-15.075998501999948, 66.04962799700007],
              [-14.96320553299995, 66.04804108300004],
              [-14.898060675999943, 66.03558991100005],
              [-14.852691209999932, 66.03717682500007],
              [-14.770415818999936, 66.06785716400003],
              [-14.719349738999938, 66.07037995000007],
              [-14.697010870999918, 66.06549713700008],
              [-14.677316860999952, 66.05621979400007],
              [-14.663238084999932, 66.04116445500006],
              [-14.657866990999935, 66.01850006700005],
              [-14.65147864499994, 66.00674062700006],
              [-14.637440558999913, 66.00275299700007],
              [-14.623402472999942, 66.00141022300005],
              [-14.616932745999918, 65.99774811400005],
              [-14.614613410999937, 65.98627350500004],
              [-14.604725714999915, 65.96393463700008],
              [-14.603342251999948, 65.95302969000005],
              [-14.606353318999936, 65.94891998900005],
              [-14.619130011999914, 65.94354889500005],
              [-14.623768683999913, 65.93939850500004],
              [-14.624379035999937, 65.93480052300004],
              [-14.622873501999948, 65.92389557500007],
              [-14.623768683999913, 65.91958242400005],
              [-14.646839972999942, 65.89496491100005],
              [-14.650461391999954, 65.88816966400003],
              [-14.66201738199993, 65.88393789300005],
              [-14.72679602799991, 65.85065338700008],
              [-14.800526495999918, 65.82794830900008],
              [-14.822987433999913, 65.81586334800005],
              [-14.821156378999945, 65.79840729400007],
              [-14.840809699999909, 65.78412506700005],
              [-14.89126542899993, 65.76121653900003],
              [-14.861439581999946, 65.76203034100007],
              [-14.834868943999936, 65.77090078300006],
              [-14.78819739499994, 65.79604726800005],
              [-14.803618943999936, 65.77558014500005],
              [-14.83234615799995, 65.75315989800004],
              [-14.844105597999942, 65.73517487200007],
              [-14.808705206999946, 65.72772858300004],
              [-14.772816535999937, 65.73200104400007],
              [-14.694406704999949, 65.75079987200007],
              [-14.479725714999915, 65.77488841400003],
              [-14.402455206999946, 65.79242584800005],
              [-14.36156165299991, 65.79677969000005],
              [-14.329497850999928, 65.78237539300005],
              [-14.372873501999948, 65.74038320500006],
              [-14.397613084999932, 65.73004791900007],
              [-14.395130988999938, 65.72150299700007],
              [-14.38780676999994, 65.71312083500004],
              [-14.383615688999953, 65.70970286700003],
              [-14.378977016999954, 65.70718008000006],
              [-14.356271938999953, 65.69985586100006],
              [-14.292958136999914, 65.68219635600008],
              [-14.274322068999936, 65.67251211100006],
              [-14.328684048999946, 65.66559479400007],
              [-14.357818162999934, 65.65607330900008],
              [-14.382232225999928, 65.63027578300006],
              [-14.43390865799995, 65.60480377800008],
              [-14.45421301999994, 65.58344147300005],
              [-14.530181443999936, 65.54547760600008],
              [-14.545399542999917, 65.53290436400005],
              [-14.557036912999934, 65.51788971600007],
              [-14.56236731699994, 65.50116608300004],
              [-14.549631313999953, 65.50901927300004],
              [-14.528309699999909, 65.53082916900007],
              [-14.517648891999954, 65.53534577000005],
              [-14.50617428299995, 65.53803131700005],
              [-14.472645636999914, 65.55231354400007],
              [-14.462310350999928, 65.55890534100007],
              [-14.444081183999913, 65.57514069200005],
              [-14.32022050699993, 65.65241120000007],
              [-14.298491990999935, 65.65884023600006],
              [-14.27171790299991, 65.65595123900005],
              [-14.192372199999909, 65.63153717700004],
              [-14.208078579999949, 65.64105866100005],
              [-14.236480272999927, 65.65395742400005],
              [-14.247629360999952, 65.66502513200004],
              [-14.027902798999946, 65.61041901200008],
              [-13.99990800699993, 65.60858795800004],
              [-13.890044725999928, 65.62018463700008],
              [-13.87140865799995, 65.61904531500005],
              [-13.85968990799995, 65.61416250200006],
              [-13.852284308999913, 65.60219961100006],
              [-13.850941535999937, 65.59198639500005],
              [-13.856516079999949, 65.58502838700008],
              [-13.869618292999917, 65.58315664300005],
              [-13.869618292999917, 65.57689036700003],
              [-13.83820553299995, 65.57737864800004],
              [-13.824370897999927, 65.57538483300004],
              [-13.815012173999946, 65.56940338700008],
              [-13.813954230999911, 65.56244538000004],
              [-13.816477016999954, 65.55329010600008],
              [-13.821278449999909, 65.54148997600004],
              [-13.814442511999914, 65.53416575700004],
              [-13.80577551999994, 65.52863190300008],
              [-13.787668423999946, 65.52167389500005],
              [-13.741118943999936, 65.55036041900007],
              [-13.715443488999938, 65.55829498900005],
              [-13.685292120999918, 65.55516185100004],
              [-13.680083787999934, 65.55097077000005],
              [-13.678863084999932, 65.54458242400005],
              [-13.679066535999937, 65.53856028900003],
              [-13.677845831999946, 65.53534577000005],
              [-13.671620245999918, 65.53457265800006],
              [-13.657215949999909, 65.53644440300008],
              [-13.651193813999953, 65.53534577000005],
              [-13.615956183999913, 65.51886627800008],
              [-13.60960852799991, 65.51422760600008],
              [-13.607980923999946, 65.49213288000004],
              [-13.622222459999932, 65.47825755400004],
              [-13.640614386999914, 65.46869538000004],
              [-13.651193813999953, 65.45962148600006],
              [-13.64867102799991, 65.45380280200004],
              [-13.637196417999917, 65.43475983300004],
              [-13.636830206999946, 65.42609284100007],
              [-13.643462693999936, 65.42218659100007],
              [-13.677845831999946, 65.41181061400005],
              [-13.667632615999935, 65.40570709800005],
              [-13.66783606699994, 65.39809804900005],
              [-13.671376105999911, 65.38886139500005],
              [-13.670969204999949, 65.37763092700004],
              [-13.704741990999935, 65.36733633000006],
              [-13.795806443999936, 65.37311432500007],
              [-13.835519985999952, 65.36399974200003],
              [-13.81086178299995, 65.35504791900007],
              [-13.73306230399993, 65.34349192900004],
              [-13.729847785999937, 65.32709381700005],
              [-13.752674933999913, 65.31586334800005],
              [-13.784535285999937, 65.30980052300004],
              [-13.834339972999942, 65.30963776200008],
              [-13.855458136999914, 65.30683014500005],
              [-13.897531704999949, 65.29572174700007],
              [-13.981027798999946, 65.28912995000007],
              [-14.006743943999936, 65.28204987200007],
              [-13.991118943999936, 65.27269114800004],
              [-13.832508917999917, 65.29759349200003],
              [-13.784250454999949, 65.29572174700007],
              [-13.687652147999927, 65.30638255400004],
              [-13.657378709999932, 65.30255768400008],
              [-13.607818162999934, 65.28864166900007],
              [-13.58226477799991, 65.27692291900007],
              [-13.572987433999913, 65.26654694200005],
              [-13.567982550999943, 65.26097239800004],
              [-13.591786261999914, 65.25307851800005],
              [-13.632435675999943, 65.22589752800008],
              [-13.65420488199993, 65.21995677300004],
              [-13.780873175999943, 65.20636627800008],
              [-13.914621548999946, 65.20636627800008],
              [-13.972645636999914, 65.20014069200005],
              [-14.034087693999936, 65.20014069200005],
              [-14.003325975999928, 65.18976471600007],
              [-13.88695227799991, 65.20014069200005],
              [-13.73306230399993, 65.19269440300008],
              [-13.664173956999946, 65.20014069200005],
              [-13.626616990999935, 65.20014069200005],
              [-13.616607225999928, 65.19676341400003],
              [-13.62132727799991, 65.18943919500003],
              [-13.636830206999946, 65.17841217700004],
              [-13.639475063999953, 65.17210521000004],
              [-13.63857988199993, 65.16754791900007],
              [-13.63857988199993, 65.16364166900007],
              [-13.64366614499994, 65.15916575700004],
              [-13.68154863199993, 65.15176015800006],
              [-13.715240037999934, 65.15033600500004],
              [-13.746693488999938, 65.14492422100005],
              [-13.746693488999938, 65.13743724200003],
              [-13.669300910999937, 65.14435455900008],
              [-13.651193813999953, 65.13743724200003],
              [-13.651193813999953, 65.13129303600005],
              [-13.660755988999938, 65.13019440300008],
              [-13.669545050999943, 65.12738678600005],
              [-13.677723761999914, 65.12299225500004],
              [-13.685292120999918, 65.11701080900008],
              [-13.65420488199993, 65.11701080900008],
              [-13.64439856699994, 65.11493561400005],
              [-13.63662675699993, 65.11041901200008],
              [-13.630848761999914, 65.10594310100004],
              [-13.626616990999935, 65.10394928600005],
              [-13.616607225999928, 65.10700104400007],
              [-13.600575324999909, 65.12067291900007],
              [-13.592193162999934, 65.12376536700003],
              [-13.59015865799995, 65.12767161700003],
              [-13.561105923999946, 65.15176015800006],
              [-13.52017167899993, 65.17218659100007],
              [-13.517404751999948, 65.15753815300008],
              [-13.51781165299991, 65.13629791900007],
              [-13.521066860999952, 65.11591217700004],
              [-13.526966925999943, 65.10394928600005],
              [-13.526966925999943, 65.09650299700007],
              [-13.508371548999946, 65.09076569200005],
              [-13.502919074999909, 65.08128489800004],
              [-13.509592251999948, 65.06915924700007],
              [-13.526966925999943, 65.05548737200007],
              [-13.547230597999942, 65.04759349200003],
              [-13.589588995999918, 65.04230377800008],
              [-13.60960852799991, 65.03506094000005],
              [-13.591786261999914, 65.02142975500004],
              [-13.58267167899993, 65.01203034100007],
              [-13.585316535999937, 65.00771719000005],
              [-13.600900844999956, 65.00446198100008],
              [-13.632150844999956, 64.98993561400005],
              [-13.647368943999936, 64.98663971600007],
              [-13.719471808999913, 64.99408600500004],
              [-13.781605597999942, 64.98932526200008],
              [-13.801991339999915, 64.99408600500004],
              [-13.811512824999909, 65.00340403900003],
              [-13.819813605999911, 65.01723867400005],
              [-13.83031165299991, 65.02960846600007],
              [-13.846058722999942, 65.03506094000005],
              [-13.862294074999909, 65.03729889500005],
              [-13.895415818999936, 65.04706452000005],
              [-13.947865363999938, 65.05451080900008],
              [-14.003325975999928, 65.07762278900003],
              [-14.034087693999936, 65.08283112200007],
              [-14.027740037999934, 65.07184479400007],
              [-14.017323370999918, 65.06378815300008],
              [-14.005116339999915, 65.05841705900008],
              [-13.993763800999943, 65.05548737200007],
              [-14.029774542999917, 65.03839752800008],
              [-14.233387824999909, 65.03506094000005],
              [-14.233387824999909, 65.02757396000004],
              [-13.918039516999954, 65.01459381700005],
              [-13.907826300999943, 65.01068756700005],
              [-13.893950975999928, 65.00307851800005],
              [-13.881703253999945, 64.99339427300004],
              [-13.876454230999911, 64.98354726800005],
              [-13.867909308999913, 64.97821686400005],
              [-13.821278449999909, 64.95994700700004],
              [-13.718169725999928, 64.93960195500006],
              [-13.698312954999949, 64.92519765800006],
              [-13.739898240999935, 64.91120026200008],
              [-13.78892981699994, 64.91437409100007],
              [-13.876454230999911, 64.93260325700004],
              [-13.976063605999911, 64.92519765800006],
              [-14.037464972999942, 64.93646881700005],
              [-14.05459550699993, 64.93260325700004],
              [-13.995513475999928, 64.91449616100005],
              [-13.852284308999913, 64.90029531500005],
              [-13.787668423999946, 64.87738678600005],
              [-13.779693162999934, 64.87152741100005],
              [-13.77017167899993, 64.86237213700008],
              [-13.766916469999956, 64.85382721600007],
              [-13.777699347999942, 64.85008372600004],
              [-13.794016079999949, 64.84686920800004],
              [-13.818918423999946, 64.83274974200003],
              [-13.832102016999954, 64.82957591400003],
              [-13.936594204999949, 64.84707265800006],
              [-13.966420050999943, 64.83584219000005],
              [-13.858021613999938, 64.81683991100005],
              [-13.839833136999914, 64.80931224200003],
              [-13.839222785999937, 64.79857005400004],
              [-13.867787238999938, 64.79474518400008],
              [-13.981922980999911, 64.79677969000005],
              [-14.013661261999914, 64.80231354400007],
              [-14.019886847999942, 64.79755280200004],
              [-14.028146938999953, 64.79409414300005],
              [-14.048451300999943, 64.78864166900007],
              [-14.048451300999943, 64.78119538000004],
              [-14.017689581999946, 64.76483795800004],
              [-14.001454230999911, 64.75381094000005],
              [-13.986317511999914, 64.74022044500003],
              [-14.00259355399993, 64.73761627800008],
              [-14.048451300999943, 64.71971263200004],
              [-14.27061926999994, 64.69928620000007],
              [-14.306385870999918, 64.70416901200008],
              [-14.326242641999954, 64.70962148600006],
              [-14.339466925999943, 64.71629466400003],
              [-14.368072068999936, 64.75531647300005],
              [-14.393625454999949, 64.76654694200005],
              [-14.42056230399993, 64.78961823100008],
              [-14.435373501999948, 64.79486725500004],
              [-14.51390540299991, 64.80231354400007],
              [-14.504017706999946, 64.79657623900005],
              [-14.49327551999994, 64.79458242400005],
              [-14.469553188999953, 64.79486725500004],
              [-14.455799933999913, 64.79022858300004],
              [-14.457142706999946, 64.77985260600008],
              [-14.463775193999936, 64.76854075700004],
              [-14.466135219999956, 64.76129791900007],
              [-14.450672980999911, 64.75287506700005],
              [-14.400135870999918, 64.74103424700007],
              [-14.383615688999953, 64.74022044500003],
              [-14.383615688999953, 64.73338450700004],
              [-14.385243292999917, 64.72085195500006],
              [-14.371449347999942, 64.70498281500005],
              [-14.35265051999994, 64.69135163000004],
              [-14.339466925999943, 64.68561432500007],
              [-14.288685675999943, 64.67812734600005],
              [-14.27017167899993, 64.66950104400007],
              [-14.28115800699993, 64.65827057500007],
              [-14.274322068999936, 64.65143463700008],
              [-14.441965298999946, 64.67572663000004],
              [-14.493478969999956, 64.65827057500007],
              [-14.477162238999938, 64.64972565300008],
              [-14.437082485999952, 64.64077383000006],
              [-14.417713995999918, 64.63100820500006],
              [-14.40807044199994, 64.61977773600006],
              [-14.409250454999949, 64.61025625200006],
              [-14.41982988199993, 64.60248444200005],
              [-14.438832160999937, 64.59686920800004],
              [-14.57217363199993, 64.59686920800004],
              [-14.584380662999934, 64.59031810100004],
              [-14.572092251999948, 64.57697174700007],
              [-14.552235480999911, 64.56574127800008],
              [-14.541818813999953, 64.56586334800005],
              [-14.531605597999942, 64.55560944200005],
              [-14.50999915299991, 64.54901764500005],
              [-14.49046790299991, 64.54840729400007],
              [-14.48656165299991, 64.55585358300004],
              [-14.445383266999954, 64.56069570500006],
              [-14.383615688999953, 64.60073476800005],
              [-14.352528449999909, 64.61050039300005],
              [-14.346180792999917, 64.60561758000006],
              [-14.36156165299991, 64.59446849200003],
              [-14.453236456999946, 64.54633209800005],
              [-14.466135219999956, 64.53473541900007],
              [-14.469593878999945, 64.52545807500007],
              [-14.47256425699993, 64.50482819200005],
              [-14.476673956999946, 64.49689362200007],
              [-14.509348110999952, 64.47190989800004],
              [-14.51390540299991, 64.46279531500005],
              [-14.51280676999994, 64.45661041900007],
              [-14.511667446999923, 64.45311107000003],
              [-14.509388800999943, 64.44611237200007],
              [-14.510487433999913, 64.44232819200005],
              [-14.51549231699994, 64.43919505400004],
              [-14.521066860999952, 64.43744538000004],
              [-14.52562415299991, 64.43451569200005],
              [-14.52757727799991, 64.42829010600008],
              [-14.529855923999946, 64.42397695500006],
              [-14.54088294199994, 64.40843333500004],
              [-14.544911261999914, 64.40509674700007],
              [-14.64875240799995, 64.40009186400005],
              [-14.720692511999914, 64.38890208500004],
              [-14.746693488999938, 64.38397858300004],
              [-14.70335852799991, 64.39887116100005],
              [-14.61392167899993, 64.41006094000005],
              [-14.568511522999927, 64.41811758000006],
              [-14.59406490799995, 64.42560455900008],
              [-14.705230272999927, 64.43329498900005],
              [-14.71312415299991, 64.43170807500007],
              [-14.714426235999952, 64.42747630400004],
              [-14.712513800999943, 64.41412995000007],
              [-14.716297980999911, 64.41128164300005],
              [-14.723622199999909, 64.40912506700005],
              [-14.744984503999945, 64.39972565300008],
              [-14.757191535999937, 64.39765045800004],
              [-14.761789516999954, 64.39496491100005],
              [-14.782053188999953, 64.37775299700007],
              [-14.79360917899993, 64.37254466400003],
              [-14.848947719999956, 64.35712311400005],
              [-14.871652798999946, 64.34674713700008],
              [-14.892079230999911, 64.33466217700004],
              [-14.904896613999938, 64.32245514500005],
              [-14.899484829999949, 64.33392975500004],
              [-14.896107550999943, 64.33877187700006],
              [-14.89126542899993, 64.34296295800004],
              [-14.89126542899993, 64.34979889500005],
              [-14.898060675999943, 64.34979889500005],
              [-14.904896613999938, 64.33982982000003],
              [-14.920318162999934, 64.33112213700008],
              [-14.937245245999918, 64.32489655200004],
              [-14.949045376999948, 64.32245514500005],
              [-14.952748175999943, 64.31924062700006],
              [-14.949818488999938, 64.31195709800005],
              [-14.942209438999953, 64.30467357000003],
              [-14.93195553299995, 64.30141836100006],
              [-14.910308397999927, 64.30247630400004],
              [-14.900746222999942, 64.30463288000004],
              [-14.89126542899993, 64.30882396000004],
              [-14.886382615999935, 64.29474518400008],
              [-14.87759355399993, 64.28148021000004],
              [-14.899973110999952, 64.28164297100005],
              [-14.929432745999918, 64.26483795800004],
              [-14.949045376999948, 64.26044342700004],
              [-14.995472785999937, 64.26260000200006],
              [-15.01585852799991, 64.26675039300005],
              [-15.035267706999946, 64.27411530200004],
              [-15.066883917999917, 64.29083893400008],
              [-15.086048956999946, 64.29828522300005],
              [-15.106678839999915, 64.30141836100006],
              [-15.115630662999934, 64.29857005400004],
              [-15.134388800999943, 64.28546784100007],
              [-15.143950975999928, 64.28148021000004],
              [-15.15611731699994, 64.28261953300006],
              [-15.167551235999952, 64.28652578300006],
              [-15.179269985999952, 64.28790924700007],
              [-15.192290818999936, 64.28148021000004],
              [-15.179351365999935, 64.27411530200004],
              [-15.190052863999938, 64.26919179900005],
              [-15.201568162999934, 64.26748281500005],
              [-15.22647050699993, 64.26788971600007],
              [-15.206613735999952, 64.29523346600007],
              [-15.206613735999952, 64.30141836100006],
              [-15.238840298999946, 64.29751211100006],
              [-15.254505988999938, 64.29804108300004],
              [-15.261219855999911, 64.30512116100005],
              [-15.265777147999927, 64.32054271000004],
              [-15.276844855999911, 64.33087799700007],
              [-15.290272589999915, 64.33437734600005],
              [-15.302154100999928, 64.32933177300004],
              [-15.302154100999928, 64.32245514500005],
              [-15.293934699999909, 64.31761302300004],
              [-15.28819739499994, 64.31256745000007],
              [-15.284169074999909, 64.30560944200005],
              [-15.28111731699994, 64.29523346600007],
              [-15.294667120999918, 64.29926178600005],
              [-15.323150193999936, 64.30390045800004],
              [-15.336293097999942, 64.30882396000004],
              [-15.336293097999942, 64.31500885600008],
              [-15.326568162999934, 64.32900625200006],
              [-15.341297980999911, 64.35004303600005],
              [-15.366444464999915, 64.36933014500005],
              [-15.387847459999932, 64.37775299700007],
              [-15.40843665299991, 64.38764069200005],
              [-15.447987433999913, 64.39447663000004],
              [-15.473500128999945, 64.39765045800004],
              [-15.456450975999928, 64.39154694200005],
              [-15.42210852799991, 64.38519928600005],
              [-15.40147864499994, 64.38080475500004],
              [-15.390777147999927, 64.36969635600008],
              [-15.372466600999928, 64.34520091400003],
              [-15.363636847999942, 64.33681875200006],
              [-15.372141079999949, 64.33136627800008],
              [-15.380686001999948, 64.32977936400005],
              [-15.389271613999938, 64.33173248900005],
              [-15.397816535999937, 64.33681875200006],
              [-15.397816535999937, 64.32933177300004],
              [-15.377552863999938, 64.32127513200004],
              [-15.374012824999909, 64.30589427300004],
              [-15.382313605999911, 64.28839752800008],
              [-15.397816535999937, 64.27411530200004],
              [-15.422271287999934, 64.26850006700005],
              [-15.478016730999911, 64.27513255400004],
              [-15.500884568999936, 64.26788971600007],
              [-15.486805792999917, 64.26251862200007],
              [-15.471547003999945, 64.26044342700004],
              [-15.438710089999915, 64.26044342700004],
              [-15.464019334999932, 64.25128815300008],
              [-15.528065558999913, 64.24115631700005],
              [-15.585519985999952, 64.23875560100004],
              [-15.645904100999928, 64.22882721600007],
              [-15.67210852799991, 64.21942780200004],
              [-15.67686926999994, 64.22443268400008],
              [-15.683216925999943, 64.22894928600005],
              [-15.685699022999927, 64.23379140800006],
              [-15.713612433999913, 64.21662018400008],
              [-15.802398240999935, 64.18537018400008],
              [-15.719105597999942, 64.19769928600005],
              [-15.69945227799991, 64.19155508000006],
              [-15.733021613999938, 64.17926666900007],
              [-15.99205481699994, 64.14447663000004],
              [-16.02830969999991, 64.13007233300004],
              [-15.981190558999913, 64.13007233300004],
              [-15.981190558999913, 64.12392812700006],
              [-16.04478919199994, 64.09979889500005],
              [-16.06627356699994, 64.09658437700006],
              [-16.075998501999948, 64.09393952000005],
              [-16.11034094999991, 64.07611725500004],
              [-16.134022589999915, 64.06842682500007],
              [-16.14362545499995, 64.06354401200008],
              [-16.151275193999936, 64.05499909100007],
              [-16.161732550999943, 64.06464264500005],
              [-16.171701626999948, 64.06635163000004],
              [-16.181792772999927, 64.06232330900008],
              [-16.19286048099991, 64.05499909100007],
              [-16.19286048099991, 64.04816315300008],
              [-16.17926998599995, 64.04816315300008],
              [-16.17926998599995, 64.04193756700005],
              [-16.23932857999995, 64.02350495000007],
              [-16.26113847599993, 64.02081940300008],
              [-16.25487219999991, 64.03510163000004],
              [-16.30890865799995, 64.01707591400003],
              [-16.334787563999953, 64.00324127800008],
              [-16.350493943999936, 63.98672109600005],
              [-16.334095831999946, 63.986314195000034],
              [-16.321034308999913, 63.99164459800005],
              [-16.311024542999917, 63.997259833000044],
              [-16.33690344999991, 63.97406647300005],
              [-16.350493943999936, 63.96556224200003],
              [-16.422352667999917, 63.93813711100006],
              [-16.47020423099991, 63.90477122600004],
              [-16.501332160999937, 63.897365627000056],
              [-16.488880988999938, 63.900376695000034],
              [-16.476307745999918, 63.90521881700005],
              [-16.465972459999932, 63.91290924700007],
              [-16.46035722599993, 63.92462799700007],
              [-16.61119544199994, 63.86937083500004],
              [-16.745350714999915, 63.85211823100008],
              [-16.765370245999918, 63.854722398000035],
              [-16.782541469999956, 63.86318594000005],
              [-16.77489173099991, 63.857123114000046],
              [-16.76659094999991, 63.852850653000075],
              [-16.757639126999948, 63.85028717700004],
              [-16.747792120999918, 63.84955475500004],
              [-16.766346808999913, 63.84454987200007],
              [-16.782541469999956, 63.84271881700005],
              [-16.77920488199993, 63.83218008000006],
              [-16.779774542999917, 63.81830475500004],
              [-16.78506425699993, 63.80646393400008],
              [-16.796213344999956, 63.80170319200005],
              [-16.80109615799995, 63.80487702000005],
              [-16.80296790299991, 63.811712958000044],
              [-16.80296790299991, 63.825384833000044],
              [-16.805531378999945, 63.828558661000045],
              [-16.823475714999915, 63.83588288000004],
              [-16.861073370999918, 63.85879140800006],
              [-16.87132727799991, 63.86318594000005],
              [-16.88735917899993, 63.865668036000045],
              [-16.89549719999991, 63.86277903900003],
              [-16.898264126999948, 63.85407135600008],
              [-16.898548956999946, 63.83930084800005],
              [-16.895253058999913, 63.820746161000045],
              [-16.895822719999956, 63.80776601800005],
              [-16.901966925999943, 63.80170319200005],
              [-16.915353969999956, 63.80516185100004],
              [-16.91746985599991, 63.81403229400007],
              [-16.912220831999946, 63.83930084800005],
              [-16.91551673099991, 63.84833405200004],
              [-16.922759568999936, 63.86001211100006],
              [-16.930043097999942, 63.866400458000044],
              [-16.933338995999918, 63.859808661000045],
              [-16.932972785999937, 63.83307526200008],
              [-16.93468176999994, 63.82062409100007],
              [-16.939564581999946, 63.80914948100008],
              [-16.926136847999942, 63.800034898000035],
              [-16.930897589999915, 63.79319896000004],
              [-16.94684811099995, 63.78888580900008],
              [-16.966908331999946, 63.78750234600005],
              [-16.955637173999946, 63.81012604400007],
              [-16.954904751999948, 63.820013739000046],
              [-16.960682745999918, 63.82843659100007],
              [-16.95653235599991, 63.837144273000035],
              [-16.953846808999913, 63.841050523000035],
              [-16.950428839999915, 63.84271881700005],
              [-16.94127356699994, 63.84552643400008],
              [-16.940744594999956, 63.851263739000046],
              [-16.944162563999953, 63.85618724200003],
              [-16.947010870999918, 63.85639069200005],
              [-16.941395636999914, 63.88320547100005],
              [-16.940297003999945, 63.897772528000075],
              [-16.94326738199993, 63.90420156500005],
              [-16.94668535099993, 63.908189195000034],
              [-16.957508917999917, 63.91583893400008],
              [-16.96898352799991, 63.92031484600005],
              [-16.974354620999918, 63.91474030200004],
              [-16.977040167999917, 63.88882070500006],
              [-16.975331183999913, 63.878241278000075],
              [-16.966908331999946, 63.86937083500004],
              [-16.983225063999953, 63.86286041900007],
              [-17.001942511999914, 63.86347077000005],
              [-17.01854407499991, 63.86200592700004],
              [-17.028920050999943, 63.84955475500004],
              [-17.01671301999994, 63.83930084800005],
              [-17.011463995999918, 63.827785549000055],
              [-17.004750128999945, 63.81708405200004],
              [-16.987945115999935, 63.80914948100008],
              [-17.006214972999942, 63.79783763200004],
              [-17.04328365799995, 63.79401276200008],
              [-17.114857550999943, 63.794907945000034],
              [-17.130116339999915, 63.79718659100007],
              [-17.166127081999946, 63.80914948100008],
              [-17.179676886999914, 63.80487702000005],
              [-17.19322669199994, 63.798041083000044],
              [-17.20343990799995, 63.79828522300005],
              [-17.207102016999954, 63.81537506700005],
              [-17.330555792999917, 63.781236070000034],
              [-17.46776282499991, 63.76072825700004],
              [-17.560943162999934, 63.75079987200007],
              [-17.54991614499994, 63.75800202000005],
              [-17.543568488999938, 63.766791083000044],
              [-17.54401607999995, 63.77749258000006],
              [-17.549672003999945, 63.78750234600005],
              [-17.557118292999917, 63.77326080900008],
              [-17.569081183999913, 63.76357656500005],
              [-17.583363410999937, 63.76072825700004],
              [-17.598052537999934, 63.767564195000034],
              [-17.595692511999914, 63.76203034100007],
              [-17.59557044199994, 63.759466864000046],
              [-17.594960089999915, 63.75755442900004],
              [-17.590646938999953, 63.753973700000074],
              [-17.590646938999953, 63.746527411000045],
              [-17.72101803299995, 63.705511786000045],
              [-17.71117102799991, 63.72736237200007],
              [-17.685292120999918, 63.73969147300005],
              [-17.653228318999936, 63.74526601800005],
              [-17.624826626999948, 63.746527411000045],
              [-17.624826626999948, 63.753973700000074],
              [-17.69098873599995, 63.76927317900004],
              [-17.71475175699993, 63.781236070000034],
              [-17.719878709999932, 63.76772695500006],
              [-17.71898352799991, 63.76227448100008],
              [-17.71475175699993, 63.753973700000074],
              [-17.74046790299991, 63.74599844000005],
              [-17.765004035999937, 63.74823639500005],
              [-17.79002844999991, 63.75340403900003],
              [-17.817209438999953, 63.753973700000074],
              [-17.79674231699994, 63.746527411000045],
              [-17.79674231699994, 63.740301825000074],
              [-17.821929490999935, 63.74054596600007],
              [-17.833322719999956, 63.73851146000004],
              [-17.843861456999946, 63.732855536000045],
              [-17.860259568999936, 63.73700592700004],
              [-17.87840735599991, 63.73102448100008],
              [-17.893055792999917, 63.719956773000035],
              [-17.899159308999913, 63.70892975500004],
              [-17.90453040299991, 63.69122955900008],
              [-17.918080206999946, 63.679022528000075],
              [-17.935902472999942, 63.675767320000034],
              [-17.954416469999956, 63.68504466400003],
              [-17.967355923999946, 63.67649974200003],
              [-17.97207597599993, 63.667669989000046],
              [-17.966949022999927, 63.660589911000045],
              [-17.95067298099991, 63.65770091400003],
              [-17.937977667999917, 63.659857489000046],
              [-17.918080206999946, 63.669256903000075],
              [-17.902821417999917, 63.67137278900003],
              [-17.823882615999935, 63.66742584800005],
              [-17.79674231699994, 63.67137278900003],
              [-17.83975175699993, 63.634100653000075],
              [-17.865834113999938, 63.62384674700007],
              [-17.892323370999918, 63.63043854400007],
              [-17.88898678299995, 63.63226959800005],
              [-17.887847459999932, 63.63226959800005],
              [-17.887318488999938, 63.632798570000034],
              [-17.885487433999913, 63.63666413000004],
              [-17.92642167899993, 63.63666413000004],
              [-17.924956834999932, 63.62734609600005],
              [-17.953114386999914, 63.628607489000046],
              [-17.96861731699994, 63.62299225500004],
              [-17.95571855399993, 63.62368398600006],
              [-17.946888800999943, 63.620794989000046],
              [-17.94359290299991, 63.61391836100006],
              [-17.946929490999935, 63.60248444200005],
              [-17.87246660099993, 63.604396877000056],
              [-17.858225063999953, 63.60993073100008],
              [-17.88304602799991, 63.57611725500004],
              [-17.91905676999994, 63.54515208500004],
              [-17.964955206999946, 63.52252838700008],
              [-18.06737219999991, 63.50153229400007],
              [-18.132923956999946, 63.47931549700007],
              [-18.195383266999954, 63.47280508000006],
              [-18.228138800999943, 63.49323151200008],
              [-18.21548417899993, 63.50055573100008],
              [-18.18736731699994, 63.505194403000075],
              [-18.176584438999953, 63.510646877000056],
              [-18.16319739499994, 63.52142975500004],
              [-18.15062415299991, 63.52631256700005],
              [-18.118885870999918, 63.527411200000074],
              [-18.118885870999918, 63.53424713700008],
              [-18.147287563999953, 63.534491278000075],
              [-18.200917120999918, 63.527044989000046],
              [-18.228138800999943, 63.527411200000074],
              [-18.29637610599991, 63.54645416900007],
              [-18.316802537999934, 63.548529364000046],
              [-18.310658331999946, 63.541001695000034],
              [-18.318104620999918, 63.53945547100005],
              [-18.321197068999936, 63.53766510600008],
              [-18.324330206999946, 63.53424713700008],
              [-18.31468665299991, 63.52814362200007],
              [-18.29328365799995, 63.511053778000075],
              [-18.286447719999956, 63.507513739000046],
              [-18.27676347599993, 63.501166083000044],
              [-18.271962042999917, 63.48704661700003],
              [-18.269154425999943, 63.47296784100007],
              [-18.265695766999954, 63.46653880400004],
              [-18.223866339999915, 63.46531810100004],
              [-18.20030676999994, 63.46531810100004],
              [-18.183664516999954, 63.46385325700004],
              [-18.397694464999915, 63.449204820000034],
              [-18.521595831999946, 63.42251211100006],
              [-18.732045050999943, 63.39671458500004],
              [-18.783029751999948, 63.397650458000044],
              [-18.974761522999927, 63.42438385600008],
              [-19.05565344999991, 63.41437409100007],
              [-19.08462480399993, 63.41815827000005],
              [-19.073597785999937, 63.41876862200007],
              [-19.069081183999913, 63.42031484600005],
              [-19.064116990999935, 63.42438385600008],
              [-19.09984290299991, 63.42796458500004],
              [-19.117665167999917, 63.43244049700007],
              [-19.132435675999943, 63.438666083000044],
              [-19.15265865799995, 63.42572663000004],
              [-19.287261522999927, 63.438666083000044],
              [-19.299956834999932, 63.44122955900008],
              [-19.352162238999938, 63.45913320500006],
              [-19.434152798999946, 63.46653880400004],
              [-19.550933397999927, 63.502020575000074],
              [-19.71157792899993, 63.521551825000074],
              [-19.74323482999995, 63.53424713700008],
              [-19.729725714999915, 63.53538646000004],
              [-19.722035285999937, 63.53925202000005],
              [-19.723052537999934, 63.544175523000035],
              [-19.73574785099993, 63.548529364000046],
              [-19.74795488199993, 63.548895575000074],
              [-19.76475989499994, 63.54279205900008],
              [-19.777088995999918, 63.541001695000034],
              [-19.87291419199994, 63.548529364000046],
              [-19.869984503999945, 63.54352448100008],
              [-19.769886847999942, 63.53424713700008],
              [-20.033802863999938, 63.54238515800006],
              [-20.05101477799991, 63.554754950000074],
              [-20.055409308999913, 63.55377838700008],
              [-20.057972785999937, 63.55231354400007],
              [-20.06041419199994, 63.550482489000046],
              [-20.064076300999943, 63.548529364000046],
              [-20.068959113999938, 63.55288320500006],
              [-20.071888800999943, 63.55385976800005],
              [-20.07835852799991, 63.554754950000074],
              [-20.071522589999915, 63.541001695000034],
              [-20.14830481699994, 63.540350653000075],
              [-20.185699022999927, 63.54441966400003],
              [-20.337717251999948, 63.60171133000006],
              [-20.352691209999932, 63.60993073100008],
              [-20.338612433999913, 63.60419342700004],
              [-20.32249915299991, 63.60175202000005],
              [-20.305978969999956, 63.60346100500004],
              [-20.290638800999943, 63.60993073100008],
              [-20.303456183999913, 63.611029364000046],
              [-20.326242641999954, 63.615668036000045],
              [-20.339100714999915, 63.61676666900007],
              [-20.33429928299995, 63.63226959800005],
              [-20.33226477799991, 63.63666413000004],
              [-20.35057532499991, 63.624660549000055],
              [-20.36709550699993, 63.61981842700004],
              [-20.38499915299991, 63.62189362200007],
              [-20.40733801999994, 63.63043854400007],
              [-20.40733801999994, 63.63666413000004],
              [-20.373158331999946, 63.63043854400007],
              [-20.386545376999948, 63.645697333000044],
              [-20.404774542999917, 63.65460846600007],
              [-20.42446855399993, 63.66168854400007],
              [-20.442128058999913, 63.67137278900003],
              [-20.458241339999915, 63.68821849200003],
              [-20.466949022999927, 63.70026276200008],
              [-20.478667772999927, 63.706366278000075],
              [-20.503529425999943, 63.705511786000045],
              [-20.503529425999943, 63.699286200000074],
              [-20.46865800699993, 63.67715078300006],
              [-20.448475714999915, 63.66071198100008],
              [-20.43464107999995, 63.64411041900007],
              [-20.50108801999994, 63.671128648000035],
              [-20.531605597999942, 63.68891022300005],
              [-20.55068925699993, 63.71234772300005],
              [-20.546864386999914, 63.71401601800005],
              [-20.537098761999914, 63.71979401200008],
              [-20.54450436099995, 63.72451406500005],
              [-20.558216925999943, 63.740301825000074],
              [-20.530181443999936, 63.75470612200007],
              [-20.498524542999917, 63.763006903000075],
              [-20.431263800999943, 63.767564195000034],
              [-20.399647589999915, 63.761053778000075],
              [-20.344146287999934, 63.73476797100005],
              [-20.311146613999938, 63.732855536000045],
              [-20.327788865999935, 63.74249909100007],
              [-20.35220292899993, 63.76113515800006],
              [-20.365793423999946, 63.767564195000034],
              [-20.442128058999913, 63.78750234600005],
              [-20.41201738199993, 63.812567450000074],
              [-20.40733801999994, 63.82221100500004],
              [-20.41112219999991, 63.83624909100007],
              [-20.422271287999934, 63.839911200000074],
              [-20.43114173099991, 63.836371161000045],
              [-20.427845831999946, 63.82843659100007],
              [-20.427845831999946, 63.82221100500004],
              [-20.43976803299995, 63.812567450000074],
              [-20.483021613999938, 63.78750234600005],
              [-20.511097785999937, 63.77317942900004],
              [-20.530181443999936, 63.76434967700004],
              [-20.554514126999948, 63.76072825700004],
              [-20.56240800699993, 63.75682200700004],
              [-20.56346594999991, 63.747300523000035],
              [-20.562652147999927, 63.73590729400007],
              [-20.565052863999938, 63.72601959800005],
              [-20.572661912999934, 63.71625397300005],
              [-20.577504035999937, 63.714178778000075],
              [-20.62246660099993, 63.725775458000044],
              [-20.666574673999946, 63.74290599200003],
              [-20.70030676999994, 63.749701239000046],
              [-20.770415818999936, 63.77440013200004],
              [-20.705230272999927, 63.77440013200004],
              [-20.693470831999946, 63.77179596600007],
              [-20.66942298099991, 63.76146067900004],
              [-20.654367641999954, 63.76072825700004],
              [-20.652333136999914, 63.76654694200005],
              [-20.639149542999917, 63.76837799700007],
              [-20.605946417999917, 63.767564195000034],
              [-20.605946417999917, 63.77440013200004],
              [-20.63385982999995, 63.77440013200004],
              [-20.63385982999995, 63.781236070000034],
              [-20.63036048099991, 63.78143952000005],
              [-20.623158331999946, 63.78099192900004],
              [-20.619618292999917, 63.781236070000034],
              [-20.619618292999917, 63.78750234600005],
              [-20.690663214999915, 63.77944570500006],
              [-20.71580969999991, 63.781236070000034],
              [-20.71580969999991, 63.78750234600005],
              [-20.681792772999927, 63.80731842700004],
              [-20.67178300699993, 63.83763255400004],
              [-20.685617641999954, 63.86343008000006],
              [-20.723255988999938, 63.86937083500004],
              [-20.723255988999938, 63.86318594000005],
              [-20.695139126999948, 63.85797760600008],
              [-20.69831295499995, 63.844183661000045],
              [-20.717193162999934, 63.82802969000005],
              [-20.754505988999938, 63.80565013200004],
              [-20.77839107999995, 63.79743073100008],
              [-20.805287238999938, 63.79474518400008],
              [-20.832508917999917, 63.80170319200005],
              [-20.82176673099991, 63.78530508000006],
              [-20.81822669199994, 63.781236070000034],
              [-20.858631964999915, 63.800441799000055],
              [-20.948841925999943, 63.82721588700008],
              [-21.076730923999946, 63.84845612200007],
              [-21.12010657499991, 63.862494208000044],
              [-21.144276495999918, 63.86749909100007],
              [-21.168324347999942, 63.87555573100008],
              [-21.188791469999956, 63.89109935100004],
              [-21.18301347599993, 63.898871161000045],
              [-21.184478318999936, 63.90875885600008],
              [-21.194935675999943, 63.932074286000045],
              [-21.117014126999948, 63.92987702000005],
              [-21.07412675699993, 63.93427155200004],
              [-21.04478919199994, 63.945746161000045],
              [-21.119943813999953, 63.945746161000045],
              [-21.167591925999943, 63.95770905200004],
              [-21.18504798099991, 63.959418036000045],
              [-21.236439581999946, 63.95335521000004],
              [-21.24705969999991, 63.94916413000004],
              [-21.25609290299991, 63.943019924000055],
              [-21.28742428299995, 63.928168036000045],
              [-21.29869544199994, 63.92462799700007],
              [-21.29869544199994, 63.918402411000045],
              [-21.247792120999918, 63.90839264500005],
              [-21.222035285999937, 63.898871161000045],
              [-21.20929928299995, 63.883693752000056],
              [-21.230132615999935, 63.888739325000074],
              [-21.275380011999914, 63.891791083000044],
              [-21.32168535099993, 63.88934967700004],
              [-21.349761522999927, 63.88418203300006],
              [-21.365834113999938, 63.87376536700003],
              [-21.35265051999994, 63.85639069200005],
              [-21.357411261999914, 63.85610586100006],
              [-21.36042232999995, 63.85423411700003],
              [-21.363107876999948, 63.85179271000004],
              [-21.366932745999918, 63.84955475500004],
              [-21.659901495999918, 63.83185455900008],
              [-21.695301886999914, 63.84271881700005],
              [-21.728911912999934, 63.85854726800005],
              [-21.75999915299991, 63.868394273000035],
              [-21.79320227799991, 63.87055084800005],
              [-21.959462042999917, 63.843736070000034],
              [-22.00031490799995, 63.84280019700003],
              [-22.014393683999913, 63.84320709800005],
              [-22.065785285999937, 63.83588288000004],
              [-22.336415167999917, 63.86318594000005],
              [-22.357492641999954, 63.856634833000044],
              [-22.375884568999936, 63.84414297100005],
              [-22.39439856699994, 63.835923570000034],
              [-22.41588294199994, 63.84271881700005],
              [-22.401600714999915, 63.84955475500004],
              [-22.425160285999937, 63.84951406500005],
              [-22.46275794199994, 63.83869049700007],
              [-22.49478105399993, 63.83417389500005],
              [-22.51390540299991, 63.82562897300005],
              [-22.525135870999918, 63.82221100500004],
              [-22.535878058999913, 63.821193752000056],
              [-22.63267981699994, 63.82611725500004],
              [-22.654855923999946, 63.82221100500004],
              [-22.65965735599991, 63.81940338700008],
              [-22.664906378999945, 63.81500885600008],
              [-22.671254035999937, 63.810980536000045],
              [-22.679066535999937, 63.80914948100008],
              [-22.691232876999948, 63.812201239000046],
              [-22.70645097599993, 63.825384833000044],
              [-22.717518683999913, 63.82843659100007],
              [-22.71125240799995, 63.83869049700007],
              [-22.703480597999942, 63.84511953300006],
              [-22.697417772999927, 63.85187409100007],
              [-22.695871548999946, 63.86318594000005],
              [-22.70018469999991, 63.87417226800005],
              [-22.70848548099991, 63.87905508000006],
              [-22.719227667999917, 63.88304271000004],
              [-22.730580206999946, 63.89109935100004],
              [-22.71507727799991, 63.901271877000056],
              [-22.694976365999935, 63.93773021000004],
              [-22.685902472999942, 63.945746161000045],
              [-22.641835089999915, 63.94586823100008],
              [-22.63499915299991, 63.94916413000004],
              [-22.639230923999946, 63.95954010600008],
              [-22.64940344999991, 63.95954010600008],
              [-22.67251542899993, 63.95258209800005],
              [-22.69172115799995, 63.954779364000046],
              [-22.712880011999914, 63.96198151200008],
              [-22.72996985599991, 63.974676825000074],
              [-22.736805792999917, 63.993475653000075],
              [-22.721424933999913, 64.01268138200004],
              [-22.717518683999913, 64.02081940300008],
              [-22.716460740999935, 64.03229401200008],
              [-22.718088344999956, 64.05320872600004],
              [-22.717518683999913, 64.06244538000004],
              [-22.718739386999914, 64.07050202000005],
              [-22.71275794199994, 64.07892487200007],
              [-22.70213782499991, 64.08592357000003],
              [-22.689605272999927, 64.08974844000005],
              [-22.675160285999937, 64.08738841400003],
              [-22.64476477799991, 64.07225169500003],
              [-22.609974738999938, 64.06159088700008],
              [-22.582915818999936, 64.04364655200004],
              [-22.55846106699994, 64.01943594000005],
              [-22.544911261999914, 63.993475653000075],
              [-22.55923417899993, 63.993475653000075],
              [-22.542795376999948, 63.98273346600007],
              [-22.518462693999936, 63.97943756700005],
              [-22.42088782499991, 63.97724030200004],
              [-22.396839972999942, 63.979803778000075],
              [-22.38117428299995, 63.98672109600005],
              [-22.392323370999918, 63.99408600500004],
              [-22.386382615999935, 64.00210195500006],
              [-22.372792120999918, 64.00922272300005],
              [-22.360707160999937, 64.01406484600005],
              [-22.346058722999942, 64.01727936400005],
              [-22.298573370999918, 64.02081940300008],
              [-22.262074347999942, 64.03335195500006],
              [-22.250884568999936, 64.03510163000004],
              [-22.238392706999946, 64.03290436400005],
              [-22.21247311099995, 64.02309804900005],
              [-22.199208136999914, 64.02081940300008],
              [-22.172759568999936, 64.02509186400005],
              [-22.124175584999932, 64.04389069200005],
              [-22.040679490999935, 64.05109284100007],
              [-22.01357988199993, 64.05927155200004],
              [-21.99010169199994, 64.07611725500004],
              [-21.981678839999915, 64.07037995000007],
              [-21.975168423999946, 64.06928131700005],
              [-21.969349738999938, 64.07147858300004],
              [-21.963368292999917, 64.07611725500004],
              [-21.963368292999917, 64.08226146000004],
              [-21.980620897999927, 64.09023672100005],
              [-22.004750128999945, 64.09772370000007],
              [-22.028635219999956, 64.10101959800005],
              [-22.045318162999934, 64.09658437700006],
              [-22.034901495999918, 64.11273834800005],
              [-22.010121222999942, 64.12059153900003],
              [-21.982492641999954, 64.12164948100008],
              [-21.963368292999917, 64.11709219000005],
              [-21.971262173999946, 64.11603424700007],
              [-21.99010169199994, 64.10956452000005],
              [-21.971994594999956, 64.10537344000005],
              [-21.951771613999938, 64.10423411700003],
              [-21.931996222999942, 64.10590241100005],
              [-21.91502844999991, 64.10956452000005],
              [-21.91502844999991, 64.11709219000005],
              [-21.93545488199993, 64.11709219000005],
              [-21.921254035999937, 64.12262604400007],
              [-21.91502844999991, 64.12392812700006],
              [-21.977162238999938, 64.14915599200003],
              [-22.01085364499994, 64.15704987200007],
              [-22.045318162999934, 64.15802643400008],
              [-22.01512610599991, 64.16828034100007],
              [-21.864857550999943, 64.15631745000007],
              [-21.857533331999946, 64.15228913000004],
              [-21.852447068999936, 64.14769114800004],
              [-21.84666907499991, 64.14435455900008],
              [-21.815581834999932, 64.13662344000005],
              [-21.799672003999945, 64.13727448100008],
              [-21.78465735599991, 64.14435455900008],
              [-21.796050584999932, 64.14345937700006],
              [-21.806752081999946, 64.14398834800005],
              [-21.816802537999934, 64.14647044500003],
              [-21.826242641999954, 64.15119049700007],
              [-21.81432044199994, 64.15892161700003],
              [-21.80687415299991, 64.16217682500007],
              [-21.79824785099993, 64.16486237200007],
              [-21.818755662999934, 64.17169830900008],
              [-21.79283606699994, 64.17597077000005],
              [-21.757476365999935, 64.17108795800004],
              [-21.74404863199993, 64.17125071800007],
              [-21.723784959999932, 64.17145416900007],
              [-21.702748175999943, 64.19155508000006],
              [-21.73741614499994, 64.18284739800004],
              [-21.75609290299991, 64.18178945500006],
              [-21.764149542999917, 64.18842194200005],
              [-21.75723222599993, 64.20034414300005],
              [-21.74120032499991, 64.20628489800004],
              [-21.709584113999938, 64.21320221600007],
              [-21.729725714999915, 64.21881745000007],
              [-21.75999915299991, 64.22040436400005],
              [-21.790760870999918, 64.21841054900005],
              [-21.812652147999927, 64.21320221600007],
              [-21.806467251999948, 64.23021067900004],
              [-21.81786048099991, 64.23798248900005],
              [-21.837717251999948, 64.24005768400008],
              [-21.865712042999917, 64.23956940300008],
              [-21.875111456999946, 64.23810455900008],
              [-21.883941209999932, 64.23517487200007],
              [-21.891102667999917, 64.23037344000005],
              [-21.928618943999936, 64.23379140800006],
              [-21.899281378999945, 64.24494049700007],
              [-21.889556443999936, 64.25311920800004],
              [-21.894520636999914, 64.26788971600007],
              [-21.833241339999915, 64.28681061400005],
              [-21.803212042999917, 64.30174388200004],
              [-21.781239386999914, 64.31879303600005],
              [-21.764027472999942, 64.33930084800005],
              [-21.754505988999938, 64.34520091400003],
              [-21.73741614499994, 64.34979889500005],
              [-21.715687628999945, 64.35203685100004],
              [-21.671213344999956, 64.34918854400007],
              [-21.65257727799991, 64.34918854400007],
              [-21.672474738999938, 64.35293203300006],
              [-21.68114173099991, 64.35663483300004],
              [-21.689076300999943, 64.35663483300004],
              [-21.648548956999946, 64.37148672100005],
              [-21.626779751999948, 64.37604401200008],
              [-21.60309811099995, 64.37775299700007],
              [-21.465402798999946, 64.36180247600004],
              [-21.442005988999938, 64.36408112200007],
              [-21.425119594999956, 64.37612539300005],
              [-21.414133266999954, 64.38397858300004],
              [-21.459095831999946, 64.37287018400008],
              [-21.483021613999938, 64.37775299700007],
              [-21.483021613999938, 64.38397858300004],
              [-21.473459438999953, 64.38377513200004],
              [-21.465321417999917, 64.38532135600008],
              [-21.44945227799991, 64.39077383000006],
              [-21.448882615999935, 64.39533112200007],
              [-21.45030676999994, 64.39655182500007],
              [-21.452951626999948, 64.39655182500007],
              [-21.45571855399993, 64.39765045800004],
              [-21.44945227799991, 64.39765045800004],
              [-21.63117428299995, 64.40265534100007],
              [-21.716542120999918, 64.39386627800008],
              [-21.79210364499994, 64.36408112200007],
              [-21.79600989499994, 64.35993073100008],
              [-21.799183722999942, 64.35443756700005],
              [-21.803944464999915, 64.34845612200007],
              [-21.812652147999927, 64.34296295800004],
              [-21.821156378999945, 64.34007396000004],
              [-21.840565558999913, 64.33710358300004],
              [-21.850087042999917, 64.33681875200006],
              [-21.865834113999938, 64.33417389500005],
              [-21.91112219999991, 64.31972890800006],
              [-21.92528235599991, 64.31195709800005],
              [-21.962635870999918, 64.29730866100005],
              [-22.00999915299991, 64.30011627800008],
              [-22.099964972999942, 64.31500885600008],
              [-22.099964972999942, 64.32245514500005],
              [-22.057972785999937, 64.33331940300008],
              [-22.018055792999917, 64.34979889500005],
              [-21.984771287999934, 64.37026601800005],
              [-21.963368292999917, 64.37612539300005],
              [-21.94172115799995, 64.37030670800004],
              [-21.92324785099993, 64.37889232000003],
              [-21.879017706999946, 64.38507721600007],
              [-21.859730597999942, 64.39077383000006],
              [-21.948882615999935, 64.39496491100005],
              [-21.97642981699994, 64.39077383000006],
              [-21.995716925999943, 64.38499583500004],
              [-22.011341925999943, 64.38275788000004],
              [-22.026600714999915, 64.38812897300005],
              [-22.045318162999934, 64.40509674700007],
              [-22.03189042899993, 64.41445547100005],
              [-22.02961178299995, 64.42645905200004],
              [-22.02920488199993, 64.44057851800005],
              [-22.021473761999914, 64.45600006700005],
              [-22.014800584999932, 64.45722077000005],
              [-22.006703253999945, 64.45429108300004],
              [-21.99986731699994, 64.45392487200007],
              [-21.994699673999946, 64.47125885600008],
              [-21.98924719999991, 64.47931549700007],
              [-21.97642981699994, 64.49315013200004],
              [-21.975087042999917, 64.50372955900008],
              [-21.949818488999938, 64.51390208500004],
              [-21.837269660999937, 64.53900788000004],
              [-21.777821417999917, 64.54157135600008],
              [-21.782582160999937, 64.55048248900005],
              [-21.79206295499995, 64.55548737200007],
              [-21.80459550699993, 64.55707428600005],
              [-21.818755662999934, 64.55585358300004],
              [-21.818755662999934, 64.56207916900007],
              [-21.800526495999918, 64.56956614800004],
              [-21.762277798999946, 64.59210846600007],
              [-21.72874915299991, 64.59857819200005],
              [-21.712513800999943, 64.60716380400004],
              [-21.702748175999943, 64.61050039300005],
              [-21.68936113199993, 64.61180247600004],
              [-21.64745032499991, 64.61050039300005],
              [-21.65143795499995, 64.59251536700003],
              [-21.631255662999934, 64.58958567900004],
              [-21.605580206999946, 64.58934153900003],
              [-21.59288489499994, 64.57916901200008],
              [-21.579904751999948, 64.57184479400007],
              [-21.496652798999946, 64.56952545800004],
              [-21.51309160099993, 64.57518138200004],
              [-21.548003709999932, 64.57363515800006],
              [-21.56554114499994, 64.57575104400007],
              [-21.57994544199994, 64.58258698100008],
              [-21.601958787999934, 64.59804922100005],
              [-21.62018795499995, 64.60301341400003],
              [-21.57921301999994, 64.61050039300005],
              [-21.57921301999994, 64.61664459800005],
              [-21.682240363999938, 64.61664459800005],
              [-21.682240363999938, 64.62417226800005],
              [-21.624989386999914, 64.63930898600006],
              [-21.60651607999995, 64.64769114800004],
              [-21.589955206999946, 64.64960358300004],
              [-21.510894334999932, 64.64398834800005],
              [-21.510894334999932, 64.65143463700008],
              [-21.588734503999945, 64.65863678600005],
              [-21.613352016999954, 64.65827057500007],
              [-21.67731686099995, 64.63251373900005],
              [-21.702748175999943, 64.63100820500006],
              [-21.702748175999943, 64.63784414300005],
              [-21.676584438999953, 64.64858633000006],
              [-21.66698157499991, 64.65595123900005],
              [-21.66112219999991, 64.66571686400005],
              [-21.70103919199994, 64.64691803600005],
              [-21.712635870999918, 64.64398834800005],
              [-21.721831834999932, 64.63882070500006],
              [-21.72842363199993, 64.61570872600004],
              [-21.740589972999942, 64.61050039300005],
              [-21.750477667999917, 64.60773346600007],
              [-21.79210364499994, 64.59003327000005],
              [-21.844105597999942, 64.58148834800005],
              [-21.859730597999942, 64.57575104400007],
              [-21.853505011999914, 64.56207916900007],
              [-21.883168097999942, 64.56659577000005],
              [-21.91120357999995, 64.56321849200003],
              [-21.969593878999945, 64.54157135600008],
              [-21.99327551999994, 64.52924225500004],
              [-22.009022589999915, 64.52509186400005],
              [-22.02489173099991, 64.52798086100006],
              [-22.035633917999917, 64.53766510600008],
              [-22.03416907499991, 64.54755280200004],
              [-22.018055792999917, 64.56952545800004],
              [-22.038807745999918, 64.56659577000005],
              [-22.048654751999948, 64.55540599200003],
              [-22.051503058999913, 64.54010651200008],
              [-22.051584438999953, 64.52456289300005],
              [-22.055409308999913, 64.51976146000004],
              [-22.079457160999937, 64.50063711100006],
              [-22.083648240999935, 64.49160390800006],
              [-22.083648240999935, 64.48456452000005],
              [-22.08503170499995, 64.47866445500006],
              [-22.093088344999956, 64.47272370000007],
              [-22.129058397999927, 64.47288646000004],
              [-22.134755011999914, 64.46930573100008],
              [-22.138335740999935, 64.46564362200007],
              [-22.14679928299995, 64.46259186400005],
              [-22.156727667999917, 64.46043528900003],
              [-22.164784308999913, 64.45966217700004],
              [-22.181019660999937, 64.46295807500007],
              [-22.199045376999948, 64.47186920800004],
              [-22.214588995999918, 64.48493073100008],
              [-22.223500128999945, 64.50063711100006],
              [-22.232085740999935, 64.49469635600008],
              [-22.239857550999943, 64.49087148600006],
              [-22.247873501999948, 64.48847077000005],
              [-22.257639126999948, 64.48700592700004],
              [-22.243397589999915, 64.49970123900005],
              [-22.23110917899993, 64.51528554900005],
              [-22.227040167999917, 64.53034088700008],
              [-22.237172003999945, 64.54157135600008],
              [-22.232899542999917, 64.54311758000006],
              [-22.223500128999945, 64.54840729400007],
              [-22.231190558999913, 64.55231354400007],
              [-22.23924719999991, 64.55483633000006],
              [-22.248036261999914, 64.55605703300006],
              [-22.257639126999948, 64.55585358300004],
              [-22.25340735599991, 64.55914948100008],
              [-22.243397589999915, 64.56952545800004],
              [-22.243397589999915, 64.57575104400007],
              [-22.28937740799995, 64.56085846600007],
              [-22.317738410999937, 64.55499909100007],
              [-22.339507615999935, 64.55585358300004],
              [-22.357533331999946, 64.56801992400005],
              [-22.36481686099995, 64.58441803600005],
              [-22.36119544199994, 64.60024648600006],
              [-22.346994594999956, 64.61050039300005],
              [-22.346994594999956, 64.61664459800005],
              [-22.36432857999995, 64.61810944200005],
              [-22.377023891999954, 64.62555573100008],
              [-22.38573157499991, 64.63385651200008],
              [-22.391021287999934, 64.63784414300005],
              [-22.40387936099995, 64.64069245000007],
              [-22.418324347999942, 64.64789459800005],
              [-22.432118292999917, 64.65696849200003],
              [-22.442534959999932, 64.66571686400005],
              [-22.417591925999943, 64.66095612200007],
              [-22.391509568999936, 64.64960358300004],
              [-22.36510169199994, 64.64264557500007],
              [-22.339507615999935, 64.65143463700008],
              [-22.360707160999937, 64.65143463700008],
              [-22.35460364499994, 64.66278717700004],
              [-22.345041469999956, 64.67031484600005],
              [-22.33307857999995, 64.67523834800005],
              [-22.319650844999956, 64.67877838700008],
              [-22.329253709999932, 64.68423086100006],
              [-22.333363410999937, 64.68561432500007],
              [-22.333363410999937, 64.69245026200008],
              [-22.217518683999913, 64.71743398600006],
              [-22.188710089999915, 64.73338450700004],
              [-22.188710089999915, 64.74022044500003],
              [-22.250721808999913, 64.71710846600007],
              [-22.283762173999946, 64.70954010600008],
              [-22.31590735599991, 64.70673248900005],
              [-22.34316972599993, 64.69920482000003],
              [-22.373890753999945, 64.68500397300005],
              [-22.402088995999918, 64.67633698100008],
              [-22.42210852799991, 64.68561432500007],
              [-22.409047003999945, 64.68964264500005],
              [-22.38117428299995, 64.70673248900005],
              [-22.36082923099991, 64.71580638200004],
              [-22.349232550999943, 64.72308991100005],
              [-22.339507615999935, 64.73338450700004],
              [-22.346994594999956, 64.74022044500003],
              [-22.338002081999946, 64.74201080900008],
              [-22.332427537999934, 64.74485911700003],
              [-22.319650844999956, 64.75385163000004],
              [-22.34203040299991, 64.76512278900003],
              [-22.37214107999995, 64.76874420800004],
              [-22.436390753999945, 64.76752350500004],
              [-22.42210852799991, 64.78119538000004],
              [-22.442534959999932, 64.78119538000004],
              [-22.435536261999914, 64.79132721600007],
              [-22.41710364499994, 64.81098053600005],
              [-22.40843665299991, 64.82273997600004],
              [-22.418771938999953, 64.82151927300004],
              [-22.427886522999927, 64.81757233300004],
              [-22.43578040299991, 64.81102122600004],
              [-22.442534959999932, 64.80231354400007],
              [-22.448841925999943, 64.81159088700008],
              [-22.457020636999914, 64.81533437700006],
              [-22.466420050999943, 64.81419505400004],
              [-22.476714647999927, 64.80914948100008],
              [-22.476714647999927, 64.80231354400007],
              [-22.53189042899993, 64.80914948100008],
              [-22.547474738999938, 64.80581289300005],
              [-22.577015753999945, 64.79157135600008],
              [-22.593413865999935, 64.78864166900007],
              [-22.593413865999935, 64.78119538000004],
              [-22.585560675999943, 64.78021881700005],
              [-22.566070115999935, 64.77435944200005],
              [-22.658192511999914, 64.76666901200008],
              [-22.682118292999917, 64.77435944200005],
              [-22.658558722999942, 64.77293528900003],
              [-22.646555141999954, 64.77374909100007],
              [-22.638050910999937, 64.77777741100005],
              [-22.64093990799995, 64.78339264500005],
              [-22.651234503999945, 64.79157135600008],
              [-22.663685675999943, 64.79901764500005],
              [-22.67251542899993, 64.80231354400007],
              [-22.77839107999995, 64.80231354400007],
              [-22.76276607999995, 64.79498932500007],
              [-22.71007239499994, 64.78119538000004],
              [-22.71007239499994, 64.77435944200005],
              [-22.736887173999946, 64.77480703300006],
              [-22.783924933999913, 64.79271067900004],
              [-22.812570766999954, 64.79486725500004],
              [-22.80573482999995, 64.79486725500004],
              [-22.93114173099991, 64.79979075700004],
              [-23.05036373599995, 64.79979075700004],
              [-23.188099738999938, 64.80414459800005],
              [-23.246245897999927, 64.83047109600005],
              [-23.301665818999936, 64.83222077000005],
              [-23.398426886999914, 64.82273997600004],
              [-23.399037238999938, 64.81989166900007],
              [-23.416493292999917, 64.80638255400004],
              [-23.42332923099991, 64.80231354400007],
              [-23.43390865799995, 64.79804108300004],
              [-23.445057745999918, 64.79490794500003],
              [-23.457142706999946, 64.79364655200004],
              [-23.573475714999915, 64.80914948100008],
              [-23.56273352799991, 64.81338125200006],
              [-23.550933397999927, 64.81590403900003],
              [-23.538441535999937, 64.81679922100005],
              [-23.555246548999946, 64.81981028900003],
              [-23.593495245999918, 64.81098053600005],
              [-23.623524542999917, 64.79425690300008],
              [-23.628081834999932, 64.77435944200005],
              [-23.646595831999946, 64.75088125200006],
              [-23.673939581999946, 64.74111562700006],
              [-23.747873501999948, 64.74022044500003],
              [-23.769520636999914, 64.73761627800008],
              [-23.813303188999953, 64.72711823100008],
              [-23.83356686099995, 64.72589752800008],
              [-23.905873175999943, 64.74396393400008],
              [-23.92129472599993, 64.75360748900005],
              [-23.935617641999954, 64.75604889500005],
              [-23.946115688999953, 64.76089101800005],
              [-23.95026607999995, 64.77777741100005],
              [-23.955881313999953, 64.78668854400007],
              [-23.998646613999938, 64.81590403900003],
              [-24.016957160999937, 64.83173248900005],
              [-24.032460089999915, 64.84853750200006],
              [-24.06004798099991, 64.89105866100005],
              [-24.053293423999946, 64.89850495000007],
              [-24.03311113199993, 64.88963450700004],
              [-24.014271613999938, 64.89337799700007],
              [-23.97752844999991, 64.91217682500007],
              [-23.95840410099993, 64.91730377800008],
              [-23.849761522999927, 64.93056875200006],
              [-23.828521287999934, 64.92951080900008],
              [-23.748117641999954, 64.90692780200004],
              [-23.638010219999956, 64.89850495000007],
              [-23.628529425999943, 64.90110911700003],
              [-23.610259568999936, 64.91380442900004],
              [-23.600819464999915, 64.91836172100005],
              [-23.559437628999945, 64.91738515800006],
              [-23.549305792999917, 64.92177969000005],
              [-23.512847459999932, 64.94635651200008],
              [-23.47175045499995, 64.95237864800004],
              [-23.38109290299991, 64.94562409100007],
              [-23.38109290299991, 64.95311107000003],
              [-23.386830206999946, 64.95600006700005],
              [-23.38975989499994, 64.95888906500005],
              [-23.391835089999915, 64.96230703300006],
              [-23.395334438999953, 64.96678294500003],
              [-23.35342363199993, 64.96800364800004],
              [-23.33975175699993, 64.96263255400004],
              [-23.346913214999915, 64.94562409100007],
              [-23.333729620999918, 64.94139232000003],
              [-23.325103318999936, 64.94672272300005],
              [-23.317209438999953, 64.95343659100007],
              [-23.306019660999937, 64.95311107000003],
              [-23.302398240999935, 64.94350820500006],
              [-23.30223548099991, 64.92951080900008],
              [-23.297027147999927, 64.92226797100005],
              [-23.278675910999937, 64.93260325700004],
              [-23.26309160099993, 64.92625560100004],
              [-23.245025193999936, 64.93012116100005],
              [-23.230213995999918, 64.93952057500007],
              [-23.22402910099993, 64.94940827000005],
              [-23.227772589999915, 64.95962148600006],
              [-23.23534094999991, 64.97260163000004],
              [-23.240589972999942, 64.98688385600008],
              [-23.237660285999937, 65.00092194200005],
              [-23.210194464999915, 65.01691315300008],
              [-23.168568488999938, 65.02008698100008],
              [-23.086822068999936, 65.01459381700005],
              [-23.094349738999938, 65.00315989800004],
              [-23.106800910999937, 64.99542877800008],
              [-23.135324673999946, 64.98663971600007],
              [-23.132435675999943, 64.98273346600007],
              [-23.127797003999945, 64.97296784100007],
              [-23.139515753999945, 64.97186920800004],
              [-23.14793860599991, 64.96808502800008],
              [-23.15493730399993, 64.96173737200007],
              [-23.162587042999917, 64.95311107000003],
              [-23.10728919199994, 64.91836172100005],
              [-23.113270636999914, 64.93353913000004],
              [-23.114003058999913, 64.94611237200007],
              [-23.109527147999927, 64.95685455900008],
              [-23.09984290299991, 64.96678294500003],
              [-23.093413865999935, 64.96898021000004],
              [-23.07445227799991, 64.97052643400008],
              [-23.066395636999914, 64.97296784100007],
              [-23.059925910999937, 64.97858307500007],
              [-23.053578253999945, 64.99140045800004],
              [-23.048980272999927, 64.99750397300005],
              [-23.02139238199993, 65.01300690300008],
              [-22.992787238999938, 65.01422760600008],
              [-22.965646938999953, 65.00429922100005],
              [-22.94286048099991, 64.98663971600007],
              [-22.926991339999915, 64.99701569200005],
              [-22.906076626999948, 65.00348541900007],
              [-22.84471594999991, 65.00991445500006],
              [-22.785227016999954, 65.02757396000004],
              [-22.801136847999942, 65.03192780200004],
              [-22.873890753999945, 65.02757396000004],
              [-22.873890753999945, 65.03506094000005],
              [-22.831857876999948, 65.03912995000007],
              [-22.757069464999915, 65.07192617400005],
              [-22.717518683999913, 65.07599518400008],
              [-22.723255988999938, 65.07196686400005],
              [-22.730580206999946, 65.06915924700007],
              [-22.71275794199994, 65.06712474200003],
              [-22.695871548999946, 65.06232330900008],
              [-22.697417772999927, 65.05463288000004],
              [-22.697987433999913, 65.05329010600008],
              [-22.69749915299991, 65.05320872600004],
              [-22.695871548999946, 65.04930247600004],
              [-22.709868943999936, 65.04059479400007],
              [-22.740061001999948, 65.03343333500004],
              [-22.75108801999994, 65.02757396000004],
              [-22.73786373599995, 65.02602773600006],
              [-22.721180792999917, 65.02655670800004],
              [-22.704009568999936, 65.02948639500005],
              [-22.689605272999927, 65.03506094000005],
              [-22.682932094999956, 65.01569245000007],
              [-22.674427863999938, 65.00755442900004],
              [-22.641184048999946, 65.00092194200005],
              [-22.596506313999953, 64.98334381700005],
              [-22.579741990999935, 64.98041413000004],
              [-22.579741990999935, 64.98663971600007],
              [-22.592193162999934, 64.98981354400007],
              [-22.60342363199993, 64.99607982000003],
              [-22.628163214999915, 65.01459381700005],
              [-22.60106360599991, 65.02997467700004],
              [-22.58617102799991, 65.03485748900005],
              [-22.566070115999935, 65.03506094000005],
              [-22.564116990999935, 65.04832591400003],
              [-22.545399542999917, 65.05219147300005],
              [-22.46190344999991, 65.05048248900005],
              [-22.37999426999994, 65.05878327000005],
              [-22.244740363999938, 65.04726797100005],
              [-22.155181443999936, 65.02757396000004],
              [-22.145008917999917, 65.03021881700005],
              [-22.129709438999953, 65.03921133000006],
              [-22.120432094999956, 65.04189687700006],
              [-22.045318162999934, 65.04189687700006],
              [-22.025054490999935, 65.03790924700007],
              [-22.003570115999935, 65.03082916900007],
              [-21.982533331999946, 65.02753327000005],
              [-21.980620897999927, 65.02830638200004],
              [-21.963368292999917, 65.03506094000005],
              [-21.937163865999935, 65.02753327000005],
              [-21.826242641999954, 65.03506094000005],
              [-21.799672003999945, 65.04462311400005],
              [-21.798654751999948, 65.05703359600005],
              [-21.816477016999954, 65.06696198100008],
              [-21.84666907499991, 65.06915924700007],
              [-21.83657792899993, 65.08242422100005],
              [-21.824696417999917, 65.08681875200006],
              [-21.810170050999943, 65.08926015800006],
              [-21.79210364499994, 65.09650299700007],
              [-21.779286261999914, 65.10805898600006],
              [-21.73741614499994, 65.15916575700004],
              [-21.734120245999918, 65.19379303600005],
              [-21.766102667999917, 65.20795319200005],
              [-21.809478318999936, 65.20612213700008],
              [-21.84048417899993, 65.19269440300008],
              [-21.84048417899993, 65.18585846600007],
              [-21.83307857999995, 65.18585846600007],
              [-21.83307857999995, 65.17841217700004],
              [-21.98387610599991, 65.12376536700003],
              [-22.03384355399993, 65.11493561400005],
              [-22.318959113999938, 65.13841380400004],
              [-22.390736456999946, 65.16327545800004],
              [-22.401600714999915, 65.16535065300008],
              [-22.40648352799991, 65.16474030200004],
              [-22.420725063999953, 65.16022370000007],
              [-22.511870897999927, 65.15420156500005],
              [-22.538726365999935, 65.15916575700004],
              [-22.55768795499995, 65.16893138200004],
              [-22.542347785999937, 65.17316315300008],
              [-22.51309160099993, 65.17706940300008],
              [-22.490345831999946, 65.18585846600007],
              [-22.48273678299995, 65.18065013200004],
              [-22.47524980399993, 65.17853424700007],
              [-22.456857876999948, 65.17841217700004],
              [-22.456857876999948, 65.18585846600007],
              [-22.478993292999917, 65.19277578300006],
              [-22.504302537999934, 65.19383372600004],
              [-22.552479620999918, 65.18585846600007],
              [-22.542225714999915, 65.20066966400003],
              [-22.524037238999938, 65.21499258000006],
              [-22.490345831999946, 65.23362864800004],
              [-22.443837042999917, 65.24298737200007],
              [-22.426177537999934, 65.25145091400003],
              [-22.428863084999932, 65.26776764500005],
              [-22.414173956999946, 65.27045319200005],
              [-22.37804114499994, 65.26776764500005],
              [-22.369130011999914, 65.27167389500005],
              [-22.339507615999935, 65.29572174700007],
              [-22.312855597999942, 65.30434804900005],
              [-22.201283331999946, 65.31769440300008],
              [-22.10700436099995, 65.34833405200004],
              [-22.070871548999946, 65.36737702000005],
              [-22.00682532499991, 65.38125234600005],
              [-21.98387610599991, 65.39191315300008],
              [-21.986154751999948, 65.39301178600005],
              [-21.988636847999942, 65.39276764500005],
              [-21.990386522999927, 65.39362213700008],
              [-21.99010169199994, 65.39813873900005],
              [-21.975087042999917, 65.39740631700005],
              [-21.950550910999937, 65.38589101800005],
              [-21.93545488199993, 65.38507721600007],
              [-21.94440670499995, 65.40053945500006],
              [-21.94908606699994, 65.40558502800008],
              [-21.887074347999942, 65.42072174700007],
              [-21.75723222599993, 65.43789297100005],
              [-21.719349738999938, 65.44737376500007],
              [-21.695301886999914, 65.45335521000004],
              [-21.79133053299995, 65.44013092700004],
              [-21.826242641999954, 65.43976471600007],
              [-21.89757239499994, 65.44651927300004],
              [-21.95689856699994, 65.43911367400005],
              [-21.97642981699994, 65.43976471600007],
              [-21.956776495999918, 65.45526764500005],
              [-21.93545488199993, 65.46702708500004],
              [-21.971547003999945, 65.48187897300005],
              [-21.985096808999913, 65.49274323100008],
              [-21.99010169199994, 65.50800202000005],
              [-22.003163214999915, 65.50389232000003],
              [-22.016957160999937, 65.50141022300005],
              [-22.03115800699993, 65.50043366100005],
              [-22.045318162999934, 65.50116608300004],
              [-22.039662238999938, 65.48712799700007],
              [-22.048573370999918, 65.48261139500005],
              [-22.06281490799995, 65.48403554900005],
              [-22.07323157499991, 65.48749420800004],
              [-22.082427537999934, 65.49648672100005],
              [-22.101185675999943, 65.52045319200005],
              [-22.11424719999991, 65.52850983300004],
              [-22.109038865999935, 65.51162344000005],
              [-22.111398891999954, 65.49746328300006],
              [-22.120269334999932, 65.48509349200003],
              [-22.134755011999914, 65.47386302300004],
              [-22.152414516999954, 65.46458567900004],
              [-22.162587042999917, 65.46100495000007],
              [-22.171620245999918, 65.45962148600006],
              [-22.17528235599991, 65.45530833500004],
              [-22.18150794199994, 65.44594961100006],
              [-22.189605272999927, 65.43659088700008],
              [-22.199208136999914, 65.43231842700004],
              [-22.236927863999938, 65.43081289300005],
              [-22.25381425699993, 65.43366120000007],
              [-22.28066972599993, 65.45132070500006],
              [-22.339507615999935, 65.47386302300004],
              [-22.381581183999913, 65.48285553600005],
              [-22.387196417999917, 65.49168528900003],
              [-22.36750240799995, 65.50800202000005],
              [-22.345814581999946, 65.51471588700008],
              [-22.235096808999913, 65.52480703300006],
              [-22.188710089999915, 65.53839752800008],
              [-22.164784308999913, 65.54148997600004],
              [-22.15371660099993, 65.54588450700004],
              [-22.150746222999942, 65.55613841400003],
              [-22.15062415299991, 65.56793854400007],
              [-22.14834550699993, 65.57689036700003],
              [-22.13971920499995, 65.58392975500004],
              [-22.128651495999918, 65.58930084800005],
              [-22.106800910999937, 65.59674713700008],
              [-22.136382615999935, 65.59332916900007],
              [-22.209828253999945, 65.54897695500006],
              [-22.243885870999918, 65.53709544500003],
              [-22.27643795499995, 65.53070709800005],
              [-22.346994594999956, 65.52850983300004],
              [-22.346994594999956, 65.53534577000005],
              [-22.304676886999914, 65.54804108300004],
              [-22.291737433999913, 65.55516185100004],
              [-22.291737433999913, 65.56264883000006],
              [-22.312489386999914, 65.56199778900003],
              [-22.327381964999915, 65.55609772300005],
              [-22.353260870999918, 65.54148997600004],
              [-22.373931443999936, 65.53815338700008],
              [-22.38658606699994, 65.54222239800004],
              [-22.398182745999918, 65.54779694200005],
              [-22.41588294199994, 65.54897695500006],
              [-22.41588294199994, 65.54148997600004],
              [-22.40371660099993, 65.53384023600006],
              [-22.40884355399993, 65.52484772300005],
              [-22.42341061099995, 65.51732005400004],
              [-22.478627081999946, 65.50800202000005],
              [-22.493397589999915, 65.51117584800005],
              [-22.504017706999946, 65.52850983300004],
              [-22.505034959999932, 65.54490794500003],
              [-22.501210089999915, 65.55719635600008],
              [-22.50145423099991, 65.56964752800008],
              [-22.514556443999936, 65.58657461100006],
              [-22.533924933999913, 65.62177155200004],
              [-22.54588782499991, 65.63401927300004],
              [-22.558379686999956, 65.62474192900004],
              [-22.55768795499995, 65.61937083500004],
              [-22.558420376999948, 65.60854726800005],
              [-22.55695553299995, 65.59788646000004],
              [-22.541005011999914, 65.57660553600005],
              [-22.54088294199994, 65.56842682500007],
              [-22.546538865999935, 65.56073639500005],
              [-22.565744594999956, 65.54311758000006],
              [-22.576649542999917, 65.53628164300005],
              [-22.589182094999956, 65.53558991100005],
              [-22.603993292999917, 65.54523346600007],
              [-22.62295488199993, 65.56415436400005],
              [-22.631459113999938, 65.56582265800006],
              [-22.63776607999995, 65.53978099200003],
              [-22.645334438999953, 65.53188711100006],
              [-22.65615800699993, 65.52806224200003],
              [-22.669097459999932, 65.52850983300004],
              [-22.67682857999995, 65.53278229400007],
              [-22.684803839999915, 65.54083893400008],
              [-22.707630988999938, 65.57221100500004],
              [-22.71198482999995, 65.58852773600006],
              [-22.704741990999935, 65.60529205900008],
              [-22.682118292999917, 65.62409088700008],
              [-22.691232876999948, 65.62958405200004],
              [-22.69627844999991, 65.62815989800004],
              [-22.701242641999954, 65.62474192900004],
              [-22.71007239499994, 65.62409088700008],
              [-22.736805792999917, 65.63153717700004],
              [-22.753651495999918, 65.63153717700004],
              [-22.759388800999943, 65.62982819200005],
              [-22.764027472999942, 65.62409088700008],
              [-22.763417120999918, 65.61835358300004],
              [-22.754465298999946, 65.59674713700008],
              [-22.744862433999913, 65.58437734600005],
              [-22.717518683999913, 65.50800202000005],
              [-22.73151607999995, 65.50177643400008],
              [-22.748605923999946, 65.50332265800006],
              [-22.76707923099991, 65.50722890800006],
              [-22.785227016999954, 65.50800202000005],
              [-22.785227016999954, 65.51422760600008],
              [-22.77953040299991, 65.52252838700008],
              [-22.784413214999915, 65.52928294500003],
              [-22.795725063999953, 65.53367747600004],
              [-22.809152798999946, 65.53534577000005],
              [-22.842274542999917, 65.53082916900007],
              [-22.853260870999918, 65.53204987200007],
              [-22.854115363999938, 65.54148997600004],
              [-22.86229407499991, 65.54071686400005],
              [-22.887603318999936, 65.54148997600004],
              [-22.887603318999936, 65.54897695500006],
              [-22.863392706999946, 65.55906810100004],
              [-22.818714972999942, 65.58454010600008],
              [-22.79198157499991, 65.58999258000006],
              [-22.801991339999915, 65.60097890800006],
              [-22.818837042999917, 65.60858795800004],
              [-22.854115363999938, 65.61790599200003],
              [-22.85960852799991, 65.59560781500005],
              [-22.87995357999995, 65.57648346600007],
              [-22.90526282499991, 65.56688060100004],
              [-22.925770636999914, 65.57318756700005],
              [-22.932240363999938, 65.58417389500005],
              [-22.936756964999915, 65.59638092700004],
              [-22.942738410999937, 65.60635000200006],
              [-22.95343990799995, 65.61041901200008],
              [-22.95604407499991, 65.60366445500006],
              [-22.961008266999954, 65.57208893400008],
              [-22.96397864499994, 65.56264883000006],
              [-22.985218878999945, 65.55121491100005],
              [-23.045318162999934, 65.54507070500006],
              [-23.073475714999915, 65.53839752800008],
              [-23.128651495999918, 65.54975006700005],
              [-23.15811113199993, 65.56220123900005],
              [-23.155140753999945, 65.57689036700003],
              [-23.155140753999945, 65.58315664300005],
              [-23.18301347599993, 65.57636139500005],
              [-23.200021938999953, 65.55658600500004],
              [-23.201324022999927, 65.53473541900007],
              [-23.182443813999953, 65.52167389500005],
              [-23.182443813999953, 65.51422760600008],
              [-23.195383266999954, 65.50861237200007],
              [-23.218088344999956, 65.49310944200005],
              [-23.23143469999991, 65.48749420800004],
              [-23.247425910999937, 65.48541901200008],
              [-23.31403561099995, 65.48871491100005],
              [-23.341420050999943, 65.49384186400005],
              [-23.357492641999954, 65.49494049700007],
              [-23.373036261999914, 65.49819570500006],
              [-23.384917772999927, 65.50560130400004],
              [-23.39590410099993, 65.51447174700007],
              [-23.401519334999932, 65.51422760600008],
              [-23.408273891999954, 65.51373932500007],
              [-23.41307532499991, 65.51235586100006],
              [-23.42332923099991, 65.50800202000005],
              [-23.418812628999945, 65.50665924700007],
              [-23.41588294199994, 65.50531647300005],
              [-23.409006313999953, 65.50116608300004],
              [-23.43773352799991, 65.49616120000007],
              [-23.490345831999946, 65.47793203300006],
              [-23.625396287999934, 65.46645742400005],
              [-23.656076626999948, 65.47386302300004],
              [-23.656971808999913, 65.46185944200005],
              [-23.661284959999932, 65.45799388200004],
              [-23.668039516999954, 65.45697663000004],
              [-23.676503058999913, 65.45335521000004],
              [-23.714100714999915, 65.42609284100007],
              [-23.89753170499995, 65.40460846600007],
              [-23.943837042999917, 65.40692780200004],
              [-23.984364386999914, 65.41864655200004],
              [-23.984364386999914, 65.42609284100007],
              [-23.97874915299991, 65.43402741100005],
              [-23.982980923999946, 65.44131094000005],
              [-23.993031378999945, 65.44782135600008],
              [-24.00487219999991, 65.45335521000004],
              [-23.98664303299995, 65.45282623900005],
              [-23.978911912999934, 65.45075104400007],
              [-23.970692511999914, 65.44651927300004],
              [-23.96776282499991, 65.46491120000007],
              [-23.98619544199994, 65.47418854400007],
              [-24.009022589999915, 65.47284577000005],
              [-24.019154425999943, 65.45962148600006],
              [-24.043080206999946, 65.47455475500004],
              [-24.19668535099993, 65.50116608300004],
              [-24.481760219999956, 65.48847077000005],
              [-24.518299933999913, 65.49135976800005],
              [-24.539906378999945, 65.50800202000005],
              [-24.49600175699993, 65.51898834800005],
              [-24.473784959999932, 65.52822500200006],
              [-24.464182094999956, 65.53839752800008],
              [-24.451568162999934, 65.54523346600007],
              [-24.393137173999946, 65.56073639500005],
              [-24.375396287999934, 65.56940338700008],
              [-24.37132727799991, 65.58494700700004],
              [-24.371490037999934, 65.60297272300005],
              [-24.365793423999946, 65.61790599200003],
              [-24.33503170499995, 65.62636953300006],
              [-24.317534959999932, 65.63613515800006],
              [-24.30337480399993, 65.63837311400005],
              [-24.277943488999938, 65.63641998900005],
              [-24.18065344999991, 65.61237213700008],
              [-24.15257727799991, 65.61041901200008],
              [-24.13540605399993, 65.60614655200004],
              [-24.080555792999917, 65.57689036700003],
              [-24.041167772999927, 65.56647370000007],
              [-23.971302863999938, 65.55866120000007],
              [-23.954701300999943, 65.54913971600007],
              [-23.940174933999913, 65.53790924700007],
              [-23.92296301999994, 65.52850983300004],
              [-23.89281165299991, 65.52216217700004],
              [-23.863636847999942, 65.52301666900007],
              [-23.806792772999927, 65.53534577000005],
              [-23.852447068999936, 65.53461334800005],
              [-23.87608801999994, 65.53729889500005],
              [-23.895008917999917, 65.54148997600004],
              [-23.911366339999915, 65.55048248900005],
              [-23.925404425999943, 65.56224192900004],
              [-23.940785285999937, 65.57249583500004],
              [-23.96080481699994, 65.57689036700003],
              [-24.00999915299991, 65.59943268400008],
              [-24.03734290299991, 65.61920807500007],
              [-24.069243943999936, 65.63703034100007],
              [-24.086781378999945, 65.65135325700004],
              [-23.935943162999934, 65.63837311400005],
              [-23.838002081999946, 65.61444733300004],
              [-23.806792772999927, 65.61041901200008],
              [-23.825917120999918, 65.62592194200005],
              [-23.85265051999994, 65.63898346600007],
              [-23.881214972999942, 65.64809804900005],
              [-23.924672003999945, 65.65473053600005],
              [-23.976551886999914, 65.66913483300004],
              [-24.02285722599993, 65.67617422100005],
              [-24.044911261999914, 65.68500397300005],
              [-24.080555792999917, 65.70600006700005],
              [-24.121571417999917, 65.74079010600008],
              [-24.12486731699994, 65.75348541900007],
              [-24.12368730399993, 65.76557038000004],
              [-24.124826626999948, 65.77732982000003],
              [-24.135161912999934, 65.78912995000007],
              [-24.09284420499995, 65.80475495000007],
              [-24.04987545499995, 65.80353424700007],
              [-23.628081834999932, 65.70600006700005],
              [-23.61856035099993, 65.70107656500005],
              [-23.600819464999915, 65.68618398600006],
              [-23.573597785999937, 65.67743561400005],
              [-23.56663977799991, 65.67251211100006],
              [-23.556385870999918, 65.65468984600005],
              [-23.56086178299995, 65.64337799700007],
              [-23.571441209999932, 65.63300202000005],
              [-23.579701300999943, 65.61790599200003],
              [-23.561756964999915, 65.61367422100005],
              [-23.538807745999918, 65.62128327000005],
              [-23.497792120999918, 65.64520905200004],
              [-23.493804490999935, 65.64020416900007],
              [-23.477894660999937, 65.63153717700004],
              [-23.46703040299991, 65.64093659100007],
              [-23.412668423999946, 65.63523997600004],
              [-23.38853919199994, 65.63837311400005],
              [-23.38853919199994, 65.64520905200004],
              [-23.397328253999945, 65.64720286700003],
              [-23.40143795499995, 65.64948151200008],
              [-23.409006313999953, 65.65884023600006],
              [-23.39159094999991, 65.65936920800004],
              [-23.346913214999915, 65.67251211100006],
              [-23.33071855399993, 65.67332591400003],
              [-23.31468665299991, 65.67234935100004],
              [-23.299427863999938, 65.67316315300008],
              [-23.28547115799995, 65.67934804900005],
              [-23.404123501999948, 65.67519765800006],
              [-23.458241339999915, 65.68244049700007],
              [-23.497792120999918, 65.69301992400005],
              [-23.51162675699993, 65.69969310100004],
              [-23.529408331999946, 65.71149323100008],
              [-23.539173956999946, 65.72272370000007],
              [-23.52916419199994, 65.72772858300004],
              [-23.466908331999946, 65.73969147300005],
              [-23.45335852799991, 65.73737213700008],
              [-23.43781490799995, 65.73163483300004],
              [-23.356190558999913, 65.73623281500005],
              [-23.330189581999946, 65.74599844000005],
              [-23.30968176999994, 65.74823639500005],
              [-23.26593990799995, 65.74127838700008],
              [-23.244536912999934, 65.74038320500006],
              [-23.22402910099993, 65.74823639500005],
              [-23.23664303299995, 65.75348541900007],
              [-23.242909308999913, 65.75519440300008],
              [-23.251332160999937, 65.75507233300004],
              [-23.251332160999937, 65.76121653900003],
              [-23.20421301999994, 65.77484772300005],
              [-23.189849412999934, 65.78237539300005],
              [-23.244699673999946, 65.77912018400008],
              [-23.276275193999936, 65.77313873900005],
              [-23.319243943999936, 65.75702545800004],
              [-23.588775193999936, 65.75975169500003],
              [-23.64171301999994, 65.76870351800005],
              [-23.676503058999913, 65.78237539300005],
              [-23.72915605399993, 65.77435944200005],
              [-23.741078253999945, 65.77863190300008],
              [-23.75495357999995, 65.78900788000004],
              [-23.813099738999938, 65.81586334800005],
              [-23.84520423099991, 65.84296295800004],
              [-23.86660722599993, 65.87555573100008],
              [-23.86314856699994, 65.90582916900007],
              [-23.82054602799991, 65.92572663000004],
              [-23.800852016999954, 65.92621491100005],
              [-23.744130011999914, 65.91209544500003],
              [-23.669667120999918, 65.90521881700005],
              [-23.650949673999946, 65.90021393400008],
              [-23.619211391999954, 65.88401927300004],
              [-23.600819464999915, 65.87791575700004],
              [-23.58189856699994, 65.87693919500003],
              [-23.518869594999956, 65.88475169500003],
              [-23.395334438999953, 65.86432526200008],
              [-23.354359503999945, 65.86432526200008],
              [-23.28311113199993, 65.84267812700006],
              [-23.244536912999934, 65.83612702000005],
              [-23.209787563999953, 65.84320709800005],
              [-23.29246985599991, 65.85423411700003],
              [-23.318837042999917, 65.86786530200004],
              [-23.401519334999932, 65.87107982000003],
              [-23.427357550999943, 65.87738678600005],
              [-23.474273240999935, 65.89484284100007],
              [-23.577870245999918, 65.90501536700003],
              [-23.600819464999915, 65.91209544500003],
              [-23.655100063999953, 65.94257233300004],
              [-23.682525193999936, 65.94896067900004],
              [-23.695912238999938, 65.95831940300008],
              [-23.717518683999913, 65.96206289300005],
              [-23.763295050999943, 65.97992584800005],
              [-23.80418860599991, 66.00324127800008],
              [-23.813099738999938, 66.01137929900005],
              [-23.813221808999913, 66.04222239800004],
              [-23.807484503999945, 66.05841705900008],
              [-23.792591925999943, 66.07037995000007],
              [-23.75137285099993, 66.07656484600005],
              [-23.699574347999942, 66.07172272300005],
              [-23.518299933999913, 66.02667877800008],
              [-23.465199347999942, 66.02098216400003],
              [-23.429432745999918, 66.02944570500006],
              [-23.42479407499991, 66.01373932500007],
              [-23.412505662999934, 66.00031159100007],
              [-23.395130988999938, 65.99103424700007],
              [-23.37486731699994, 65.98777903900003],
              [-23.37486731699994, 65.99404531500005],
              [-23.391835089999915, 66.00470612200007],
              [-23.42251542899993, 66.03587474200003],
              [-23.443104620999918, 66.04242584800005],
              [-23.465972459999932, 66.04458242400005],
              [-23.51195227799991, 66.05394114800004],
              [-23.535878058999913, 66.05609772300005],
              [-23.547027147999927, 66.05951569200005],
              [-23.577504035999937, 66.07660553600005],
              [-23.636057094999956, 66.09821198100008],
              [-23.669667120999918, 66.11749909100007],
              [-23.637318488999938, 66.12848541900007],
              [-23.550160285999937, 66.13198476800005],
              [-23.484120245999918, 66.12759023600006],
              [-23.395334438999953, 66.09764232000003],
              [-23.419097459999932, 66.10663483300004],
              [-23.45840410099993, 66.13304271000004],
              [-23.481027798999946, 66.13861725500004],
              [-23.577056443999936, 66.13768138200004],
              [-23.600819464999915, 66.14484284100007],
              [-23.600819464999915, 66.15228913000004],
              [-23.590972459999932, 66.15985748900005],
              [-23.57640540299991, 66.16889069200005],
              [-23.55955969999991, 66.17645905200004],
              [-23.54991614499994, 66.17829010600008],
              [-23.542713995999918, 66.17963288000004],
              [-23.501291469999956, 66.18048737200007],
              [-23.485585089999915, 66.18622467700004],
              [-23.484120245999918, 66.19944896000004],
              [-23.461415167999917, 66.20416901200008],
              [-23.304351365999935, 66.18577708500004],
              [-23.202504035999937, 66.15509674700007],
              [-23.172474738999938, 66.15228913000004],
              [-23.152699347999942, 66.14581940300008],
              [-23.127430792999917, 66.13056061400005],
              [-23.110218878999945, 66.11253489800004],
              [-23.114165818999936, 66.09764232000003],
              [-23.10728919199994, 66.07591380400004],
              [-23.057972785999937, 66.10761139500005],
              [-23.038441535999937, 66.11131419500003],
              [-23.027699347999942, 66.10871002800008],
              [-23.01821855399993, 66.10260651200008],
              [-23.004302537999934, 66.09023672100005],
              [-22.986073370999918, 66.07953522300005],
              [-22.984038865999935, 66.07412344000005],
              [-22.983754035999937, 66.05951569200005],
              [-22.97838294199994, 66.04336172100005],
              [-22.97687740799995, 66.03367747600004],
              [-22.98350989499994, 66.02631256700005],
              [-23.000355597999942, 66.01337311400005],
              [-23.004302537999934, 66.01137929900005],
              [-23.04914303299995, 65.97650788000004],
              [-23.058949347999942, 65.96670156500005],
              [-23.052723761999914, 65.96670156500005],
              [-23.031239386999914, 65.98094310100004],
              [-22.976551886999914, 66.00844961100006],
              [-22.95653235599991, 66.02191803600005],
              [-22.950917120999918, 66.03001536700003],
              [-22.94640051999994, 66.03912995000007],
              [-22.940052863999938, 66.04645416900007],
              [-22.92918860599991, 66.04926178600005],
              [-22.917225714999915, 66.04612864800004],
              [-22.90965735599991, 66.03864166900007],
              [-22.895090298999946, 66.01508209800005],
              [-22.899769660999937, 66.01064687700006],
              [-22.90184485599991, 66.00763580900008],
              [-22.887440558999913, 66.01341380400004],
              [-22.871571417999917, 66.02301666900007],
              [-22.855539516999954, 66.02850983300004],
              [-22.840443488999938, 66.02191803600005],
              [-22.857492641999954, 65.99868398600006],
              [-22.880970831999946, 65.97528717700004],
              [-22.909779425999943, 65.95636627800008],
              [-22.94286048099991, 65.94684479400007],
              [-22.902699347999942, 65.94790273600006],
              [-22.884429490999935, 65.95180898600006],
              [-22.867746548999946, 65.96051666900007],
              [-22.84862219999991, 65.98615143400008],
              [-22.834095831999946, 66.00141022300005],
              [-22.823109503999945, 66.00458405200004],
              [-22.809152798999946, 65.97760651200008],
              [-22.81554114499994, 65.94977448100008],
              [-22.824696417999917, 65.92625560100004],
              [-22.81932532499991, 65.91209544500003],
              [-22.785227016999954, 65.96051666900007],
              [-22.787098761999914, 65.98285553600005],
              [-22.782948370999918, 66.00861237200007],
              [-22.774566209999932, 66.03253815300008],
              [-22.764027472999942, 66.04926178600005],
              [-22.755970831999946, 66.05683014500005],
              [-22.750477667999917, 66.05841705900008],
              [-22.68272864499994, 66.05585358300004],
              [-22.675933397999927, 66.05267975500004],
              [-22.673573370999918, 66.03912995000007],
              [-22.667225714999915, 66.03091054900005],
              [-22.65851803299995, 66.02586497600004],
              [-22.620269334999932, 66.00922272300005],
              [-22.584136522999927, 65.98118724200003],
              [-22.578277147999927, 65.97760651200008],
              [-22.577381964999915, 65.97308991100005],
              [-22.58193925699993, 65.95140208500004],
              [-22.58617102799991, 65.94037506700005],
              [-22.592274542999917, 65.93065013200004],
              [-22.600209113999938, 65.92572663000004],
              [-22.597645636999914, 65.92206452000005],
              [-22.593413865999935, 65.91958242400005],
              [-22.644886847999942, 65.86058177300004],
              [-22.655425584999932, 65.84218984600005],
              [-22.648182745999918, 65.83368561400005],
              [-22.635161912999934, 65.83527252800008],
              [-22.611683722999942, 65.87384674700007],
              [-22.545318162999934, 65.94696686400005],
              [-22.538726365999935, 65.96670156500005],
              [-22.538726365999935, 65.97418854400007],
              [-22.517323370999918, 65.97577545800004],
              [-22.503732876999948, 65.96629466400003],
              [-22.492176886999914, 65.95209381700005],
              [-22.476714647999927, 65.93939850500004],
              [-22.469471808999913, 65.93866608300004],
              [-22.463693813999953, 65.94110748900005],
              [-22.457508917999917, 65.94106679900005],
              [-22.449370897999927, 65.93256256700005],
              [-22.449940558999913, 65.92450592700004],
              [-22.45531165299991, 65.91673411700003],
              [-22.45616614499994, 65.90997955900008],
              [-22.442534959999932, 65.90521881700005],
              [-22.440785285999937, 65.91030508000006],
              [-22.436105923999946, 65.92035553600005],
              [-22.429432745999918, 65.92796458500004],
              [-22.42210852799991, 65.92572663000004],
              [-22.422027147999927, 65.91889069200005],
              [-22.428863084999932, 65.88475169500003],
              [-22.437163865999935, 65.87352122600004],
              [-22.460275844999956, 65.85431549700007],
              [-22.469878709999932, 65.84320709800005],
              [-22.469878709999932, 65.83698151200008],
              [-22.431630011999914, 65.84589264500005],
              [-22.392648891999954, 65.90167877800008],
              [-22.360707160999937, 65.91209544500003],
              [-22.360707160999937, 65.91958242400005],
              [-22.381255662999934, 65.92877838700008],
              [-22.392648891999954, 65.94806549700007],
              [-22.39989173099991, 65.97016022300005],
              [-22.40843665299991, 65.98777903900003],
              [-22.423003709999932, 66.00202057500007],
              [-22.44204667899993, 66.01544830900008],
              [-22.46320553299995, 66.02545807500007],
              [-22.484201626999948, 66.02944570500006],
              [-22.473866339999915, 66.04242584800005],
              [-22.469471808999913, 66.05463288000004],
              [-22.463734503999945, 66.06586334800005],
              [-22.449370897999927, 66.07591380400004],
              [-22.430287238999938, 66.07990143400008],
              [-22.410308397999927, 66.08038971600007],
              [-22.39281165299991, 66.08405182500007],
              [-22.38117428299995, 66.09764232000003],
              [-22.401722785999937, 66.09731679900005],
              [-22.45107988199993, 66.08714427300004],
              [-22.469878709999932, 66.07965729400007],
              [-22.488392706999946, 66.07672760600008],
              [-22.57217363199993, 66.09369538000004],
              [-22.628163214999915, 66.11749909100007],
              [-22.865956183999913, 66.15949127800008],
              [-22.93586178299995, 66.18976471600007],
              [-22.97760982999995, 66.23419830900008],
              [-22.930897589999915, 66.24640534100007],
              [-22.782460089999915, 66.26276276200008],
              [-22.75108801999994, 66.26215241100005],
              [-22.644886847999942, 66.24848053600005],
              [-22.617298956999946, 66.24848053600005],
              [-22.60655676999994, 66.24677155200004],
              [-22.601185675999943, 66.24266185100004],
              [-22.59788977799991, 66.23794179900005],
              [-22.593413865999935, 66.23419830900008],
              [-22.566517706999946, 66.22284577000005],
              [-22.552357550999943, 66.22138092700004],
              [-22.538726365999935, 66.22736237200007],
              [-22.545480923999946, 66.23078034100007],
              [-22.55036373599995, 66.23529694200005],
              [-22.55923417899993, 66.24848053600005],
              [-22.509836391999954, 66.24835846600007],
              [-22.484486456999946, 66.25116608300004],
              [-22.44054114499994, 66.26544830900008],
              [-22.390614386999914, 66.26752350500004],
              [-22.36750240799995, 66.27521393400008],
              [-22.50340735599991, 66.26642487200007],
              [-22.544911261999914, 66.27521393400008],
              [-22.564564581999946, 66.28363678600005],
              [-22.56041419199994, 66.28497955900008],
              [-22.544300910999937, 66.28571198100008],
              [-22.528187628999945, 66.29262929900005],
              [-22.517567511999914, 66.30011627800008],
              [-22.50291907499991, 66.30609772300005],
              [-22.486317511999914, 66.30951569200005],
              [-22.469878709999932, 66.30931224200003],
              [-22.469878709999932, 66.31679922100005],
              [-22.49209550699993, 66.32196686400005],
              [-22.50536048099991, 66.32005442900004],
              [-22.544911261999914, 66.30312734600005],
              [-22.595692511999914, 66.29173411700003],
              [-22.654855923999946, 66.28945547100005],
              [-22.701649542999917, 66.29340241100005],
              [-22.71007239499994, 66.29564036700003],
              [-22.711415167999917, 66.30646393400008],
              [-22.702748175999943, 66.31370677300004],
              [-22.682118292999917, 66.32363515800006],
              [-22.678456183999913, 66.33075592700004],
              [-22.673085089999915, 66.35081614800004],
              [-22.669097459999932, 66.35712311400005],
              [-22.655425584999932, 66.36318594000005],
              [-22.60765540299991, 66.37140534100007],
              [-22.651112433999913, 66.36774323100008],
              [-22.683949347999942, 66.35830312700006],
              [-22.763050910999937, 66.32367584800005],
              [-22.781646287999934, 66.31952545800004],
              [-22.823109503999945, 66.31679922100005],
              [-22.83535722599993, 66.32265859600005],
              [-22.828602667999917, 66.33576080900008],
              [-22.81314042899993, 66.34951406500005],
              [-22.79946855399993, 66.35712311400005],
              [-22.79946855399993, 66.36456940300008],
              [-22.833729620999918, 66.35883209800005],
              [-22.85069739499994, 66.35293203300006],
              [-22.867746548999946, 66.34406159100007],
              [-22.90762285099993, 66.31513092700004],
              [-22.91559811099995, 66.31305573100008],
              [-22.93968665299991, 66.30145905200004],
              [-23.098052537999934, 66.31830475500004],
              [-23.13931230399993, 66.32778554900005],
              [-23.166493292999917, 66.34227122600004],
              [-23.182850714999915, 66.34878164300005],
              [-23.18968665299991, 66.35529205900008],
              [-23.176258917999917, 66.36456940300008],
              [-23.137847459999932, 66.36566803600005],
              [-23.089507615999935, 66.35809967700004],
              [-23.04674231699994, 66.36066315300008],
              [-23.02481035099993, 66.39183177300004],
              [-23.05304928299995, 66.39354075700004],
              [-23.08462480399993, 66.40326569200005],
              [-23.113880988999938, 66.41746653900003],
              [-23.135324673999946, 66.43280670800004],
              [-23.104725714999915, 66.44281647300005],
              [-23.07331295499995, 66.43695709800005],
              [-23.041900193999936, 66.42560455900008],
              [-23.011708136999914, 66.41917552300004],
              [-23.01911373599995, 66.43040599200003],
              [-23.024159308999913, 66.43524811400005],
              [-23.03229732999995, 66.44025299700007],
              [-22.922718878999945, 66.44765859600005],
              [-22.91559811099995, 66.44647858300004],
              [-22.909494594999956, 66.44245026200008],
              [-22.901112433999913, 66.43024323100008],
              [-22.895090298999946, 66.42601146000004],
              [-22.873524542999917, 66.42377350500004],
              [-22.864491339999915, 66.43138255400004],
              [-22.86815344999991, 66.44139232000003],
              [-22.884510870999918, 66.44647858300004],
              [-22.900868292999917, 66.44904205900008],
              [-22.95030676999994, 66.46698639500005],
              [-22.850331183999913, 66.46698639500005],
              [-22.832630988999938, 66.46381256700005],
              [-22.797271287999934, 66.44969310100004],
              [-22.75218665299991, 66.44269440300008],
              [-22.716135219999956, 66.42487213700008],
              [-22.695871548999946, 66.41917552300004],
              [-22.67023678299995, 66.42096588700008],
              [-22.63117428299995, 66.43960195500006],
              [-22.60765540299991, 66.44647858300004],
              [-22.609852667999917, 66.45014069200005],
              [-22.613880988999938, 66.46015045800004],
              [-22.57453365799995, 66.46588776200008],
              [-22.542225714999915, 66.45538971600007],
              [-22.51073157499991, 66.44041575700004],
              [-22.44172115799995, 66.42666250200006],
              [-22.426625128999945, 66.42792389500005],
              [-22.42210852799991, 66.44025299700007],
              [-22.429351365999935, 66.45014069200005],
              [-22.455555792999917, 66.45746491100005],
              [-22.46312415299991, 66.46698639500005],
              [-22.431019660999937, 66.46474844000005],
              [-22.400135870999918, 66.45221588700008],
              [-22.376698370999918, 66.43256256700005],
              [-22.36750240799995, 66.40892161700003],
              [-22.350005662999934, 66.39419179900005],
              [-22.26862545499995, 66.37592194200005],
              [-22.243397589999915, 66.35712311400005],
              [-22.257639126999948, 66.34715403900003],
              [-22.244740363999938, 66.34113190300008],
              [-22.202300584999932, 66.33722565300008],
              [-22.202300584999932, 66.33038971600007],
              [-22.22061113199993, 66.33283112200007],
              [-22.228260870999918, 66.32855866100005],
              [-22.229725714999915, 66.31997304900005],
              [-22.229644334999932, 66.30931224200003],
              [-22.224680141999954, 66.30414459800005],
              [-22.21589107999995, 66.29718659100007],
              [-22.214100714999915, 66.28969961100006],
              [-22.229644334999932, 66.28261953300006],
              [-22.229644334999932, 66.27521393400008],
              [-22.21666419199994, 66.26837799700007],
              [-22.20303300699993, 66.27448151200008],
              [-22.187123175999943, 66.27948639500005],
              [-22.17056230399993, 66.28253815300008],
              [-22.155181443999936, 66.28261953300006],
              [-22.14598548099991, 66.27814362200007],
              [-22.137928839999915, 66.27130768400008],
              [-22.128285285999937, 66.26829661700003],
              [-22.120432094999956, 66.27521393400008],
              [-22.105620897999927, 66.28782786700003],
              [-22.089588995999918, 66.28986237200007],
              [-22.08039303299995, 66.28286367400005],
              [-22.086293097999942, 66.26837799700007],
              [-22.01504472599993, 66.27142975500004],
              [-21.996937628999945, 66.26837799700007],
              [-21.98818925699993, 66.27464427300004],
              [-21.979318813999953, 66.27496979400007],
              [-21.97093665299991, 66.27195872600004],
              [-21.963368292999917, 66.26837799700007],
              [-21.95771236899992, 66.26463450700004],
              [-21.92178300699993, 66.24103424700007],
              [-21.931263800999943, 66.23395416900007],
              [-21.99010169199994, 66.21377187700006],
              [-21.97679602799991, 66.21010976800005],
              [-21.96397864499994, 66.21287669500003],
              [-21.950550910999937, 66.21808502800008],
              [-21.93545488199993, 66.22117747600004],
              [-21.920725063999953, 66.21967194200005],
              [-21.87401282499991, 66.20380280200004],
              [-21.861439581999946, 66.19611237200007],
              [-21.853505011999914, 66.19330475500004],
              [-21.84361731699994, 66.19306061400005],
              [-21.82335364499994, 66.19830963700008],
              [-21.812652147999927, 66.19944896000004],
              [-21.74986731699994, 66.18577708500004],
              [-21.752837693999936, 66.18219635600008],
              [-21.75731360599991, 66.17275625200006],
              [-21.740061001999948, 66.16819896000004],
              [-21.730091925999943, 66.15623607000003],
              [-21.73033606699994, 66.14411041900007],
              [-21.74364173099991, 66.13861725500004],
              [-21.739898240999935, 66.13239166900007],
              [-21.731800910999937, 66.12250397300005],
              [-21.73005123599995, 66.11749909100007],
              [-21.729725714999915, 66.11786530200004],
              [-21.72809811099995, 66.10146719000005],
              [-21.723011847999942, 66.08222077000005],
              [-21.71637936099995, 66.07550690300008],
              [-21.702748175999943, 66.07037995000007],
              [-21.68854732999995, 66.07127513200004],
              [-21.67100989499994, 66.07575104400007],
              [-21.653960740999935, 66.07758209800005],
              [-21.641224738999938, 66.07037995000007],
              [-21.639271613999938, 66.05654531500005],
              [-21.648060675999943, 66.04401276200008],
              [-21.66002356699994, 66.03253815300008],
              [-21.667958136999914, 66.02191803600005],
              [-21.655181443999936, 66.02338288000004],
              [-21.63931230399993, 66.02802155200004],
              [-21.625884568999936, 66.03384023600006],
              [-21.62018795499995, 66.03900788000004],
              [-21.619699673999946, 66.05573151200008],
              [-21.620716925999943, 66.06346263200004],
              [-21.641224738999938, 66.08344147300005],
              [-21.62881425699993, 66.08901601800005],
              [-21.59325110599991, 66.09638092700004],
              [-21.548817511999914, 66.09764232000003],
              [-21.54133053299995, 66.09422435100004],
              [-21.535878058999913, 66.08681875200006],
              [-21.531605597999942, 66.07933177300004],
              [-21.52765865799995, 66.07591380400004],
              [-21.50918535099993, 66.07233307500007],
              [-21.521229620999918, 66.06452057500007],
              [-21.54255123599995, 66.05744049700007],
              [-21.55186926999994, 66.05609772300005],
              [-21.55846106699994, 66.04653554900005],
              [-21.554025844999956, 66.03925202000005],
              [-21.534779425999943, 66.02570221600007],
              [-21.509388800999943, 66.01707591400003],
              [-21.40103105399993, 66.02944570500006],
              [-21.372303839999915, 66.02631256700005],
              [-21.34870357999995, 66.02069733300004],
              [-21.330637173999946, 66.00901927300004],
              [-21.318511522999927, 65.98777903900003],
              [-21.45929928299995, 65.98232656500005],
              [-21.486073370999918, 65.97321198100008],
              [-21.591623501999948, 65.96039459800005],
              [-21.60651607999995, 65.96051666900007],
              [-21.58812415299991, 65.94635651200008],
              [-21.56012936099995, 65.94794342700004],
              [-21.50377356699994, 65.96051666900007],
              [-21.41002356699994, 65.96747467700004],
              [-21.380604620999918, 65.96051666900007],
              [-21.392689581999946, 65.95205312700006],
              [-21.43578040299991, 65.93939850500004],
              [-21.43578040299991, 65.93256256700005],
              [-21.328114386999914, 65.94525788000004],
              [-21.30174719999991, 65.93598053600005],
              [-21.287180141999954, 65.91583893400008],
              [-21.284047003999945, 65.89862702000005],
              [-21.29588782499991, 65.88556549700007],
              [-21.325917120999918, 65.87791575700004],
              [-21.278187628999945, 65.86432526200008],
              [-21.278187628999945, 65.85687897300005],
              [-21.327788865999935, 65.80902741100005],
              [-21.345814581999946, 65.79604726800005],
              [-21.37531490799995, 65.78489817900004],
              [-21.47679602799991, 65.76870351800005],
              [-21.47679602799991, 65.76121653900003],
              [-21.455148891999954, 65.76056549700007],
              [-21.41787675699993, 65.76349518400008],
              [-21.40103105399993, 65.76121653900003],
              [-21.34788977799991, 65.74713776200008],
              [-21.332142706999946, 65.74079010600008],
              [-21.414133266999954, 65.69985586100006],
              [-21.443511522999927, 65.69049713700008],
              [-21.57921301999994, 65.69301992400005],
              [-21.58885657499991, 65.69765859600005],
              [-21.60533606699994, 65.71067942900004],
              [-21.609934048999946, 65.71344635600008],
              [-21.62922115799995, 65.71938711100006],
              [-21.647206183999913, 65.73261139500005],
              [-21.659331834999932, 65.74656810100004],
              [-21.66112219999991, 65.75507233300004],
              [-21.685943162999934, 65.76943594000005],
              [-21.71670488199993, 65.77643463700008],
              [-21.748890753999945, 65.77606842700004],
              [-21.777821417999917, 65.76870351800005],
              [-21.758412238999938, 65.76740143400008],
              [-21.711333787999934, 65.75462474200003],
              [-21.695301886999914, 65.74823639500005],
              [-21.69322669199994, 65.74551015800006],
              [-21.672230597999942, 65.72919342700004],
              [-21.667958136999914, 65.72772858300004],
              [-21.665394660999937, 65.71564362200007],
              [-21.668527798999946, 65.70766836100006],
              [-21.676584438999953, 65.70099518400008],
              [-21.689076300999943, 65.69301992400005],
              [-21.67296301999994, 65.68618398600006],
              [-21.664662238999938, 65.68113841400003],
              [-21.66112219999991, 65.67593008000006],
              [-21.655873175999943, 65.66266510600008],
              [-21.64439856699994, 65.65509674700007],
              [-21.632883266999954, 65.65102773600006],
              [-21.627674933999913, 65.64826080900008],
              [-21.609934048999946, 65.64154694200005],
              [-21.442982550999943, 65.64337799700007],
              [-21.41429602799991, 65.63715241100005],
              [-21.40103105399993, 65.62409088700008],
              [-21.41120357999995, 65.61269765800006],
              [-21.462880011999914, 65.57851797100005],
              [-21.483021613999938, 65.56940338700008],
              [-21.483021613999938, 65.56264883000006],
              [-21.43455969999991, 65.57379791900007],
              [-21.37336178299995, 65.59690989800004],
              [-21.320912238999938, 65.60187409100007],
              [-21.29869544199994, 65.55890534100007],
              [-21.31981360599991, 65.52236562700006],
              [-21.369862433999913, 65.48712799700007],
              [-21.42882239499994, 65.46149323100008],
              [-21.47679602799991, 65.45335521000004],
              [-21.47679602799991, 65.44651927300004],
              [-21.375884568999936, 65.46287669500003],
              [-21.337147589999915, 65.47736237200007],
              [-21.31541907499991, 65.48069896000004],
              [-21.292958136999914, 65.47874583500004],
              [-21.27843176999994, 65.47329336100006],
              [-21.25023352799991, 65.45335521000004],
              [-21.212147589999915, 65.43817780200004],
              [-21.201893683999913, 65.42841217700004],
              [-21.20929928299995, 65.41181061400005],
              [-21.19517981699994, 65.40810781500005],
              [-21.193023240999935, 65.40058014500005],
              [-21.195423956999946, 65.39020416900007],
              [-21.194935675999943, 65.37763092700004],
              [-21.18895423099991, 65.35553620000007],
              [-21.188791469999956, 65.34007396000004],
              [-21.193348761999914, 65.32001373900005],
              [-21.19286048099991, 65.31012604400007],
              [-21.153960740999935, 65.25755442900004],
              [-21.140370245999918, 65.24730052300004],
              [-21.14439856699994, 65.24551015800006],
              [-21.145375128999945, 65.24485911700003],
              [-21.14561926999994, 65.24396393400008],
              [-21.147816535999937, 65.24115631700005],
              [-21.127837693999936, 65.23216380400004],
              [-21.10765540299991, 65.21552155200004],
              [-21.09707597599993, 65.19599030200004],
              [-21.106190558999913, 65.17841217700004],
              [-21.106190558999913, 65.17218659100007],
              [-21.089914516999954, 65.16616445500006],
              [-21.08356686099995, 65.16840241100005],
              [-21.07331295499995, 65.17206452000005],
              [-21.06541907499991, 65.18577708500004],
              [-21.07998613199993, 65.21015045800004],
              [-21.082875128999945, 65.22630442900004],
              [-21.085682745999918, 65.23362864800004],
              [-21.094471808999913, 65.24384186400005],
              [-21.112049933999913, 65.25893789300005],
              [-21.119943813999953, 65.26776764500005],
              [-21.105213995999918, 65.27895742400005],
              [-21.099436001999948, 65.28204987200007],
              [-21.10301673099991, 65.29071686400005],
              [-21.096587693999936, 65.29706452000005],
              [-21.086496548999946, 65.30263906500005],
              [-21.078968878999945, 65.30878327000005],
              [-21.073557094999956, 65.32416413000004],
              [-21.07408606699994, 65.33803945500006],
              [-21.09483801999994, 65.41376373900005],
              [-21.098866339999915, 65.44546133000006],
              [-21.086048956999946, 65.45962148600006],
              [-21.055246548999946, 65.45233795800004],
              [-21.033802863999938, 65.43447500200006],
              [-21.003244594999956, 65.39191315300008],
              [-20.97402910099993, 65.36749909100007],
              [-20.96971594999991, 65.36058177300004],
              [-20.962961391999954, 65.35333893400008],
              [-20.92882239499994, 65.34870026200008],
              [-20.91510982999995, 65.34349192900004],
              [-20.90762285099993, 65.35101959800005],
              [-20.933705206999946, 65.37400950700004],
              [-20.95726477799991, 65.40473053600005],
              [-20.975005662999934, 65.43756745000007],
              [-20.983306443999936, 65.46702708500004],
              [-20.98696855399993, 65.49054596600007],
              [-20.98729407499991, 65.50678131700005],
              [-20.983306443999936, 65.52167389500005],
              [-20.978871222999942, 65.52716705900008],
              [-20.96666419199994, 65.53668854400007],
              [-20.962228969999956, 65.54148997600004],
              [-20.951771613999938, 65.57037995000007],
              [-20.948597785999937, 65.57689036700003],
              [-20.918080206999946, 65.60138580900008],
              [-20.805246548999946, 65.63837311400005],
              [-20.74372311099995, 65.67251211100006],
              [-20.725209113999938, 65.67674388200004],
              [-20.70604407499991, 65.67902252800008],
              [-20.691965298999946, 65.68317291900007],
              [-20.68854732999995, 65.69301992400005],
              [-20.67536373599995, 65.69391510600008],
              [-20.665760870999918, 65.69086334800005],
              [-20.646962042999917, 65.67934804900005],
              [-20.642648891999954, 65.67902252800008],
              [-20.629790818999936, 65.68024323100008],
              [-20.62637285099993, 65.67934804900005],
              [-20.623443162999934, 65.67072174700007],
              [-20.62637285099993, 65.66795482000003],
              [-20.631255662999934, 65.66738515800006],
              [-20.63385982999995, 65.66502513200004],
              [-20.64085852799991, 65.62498607000003],
              [-20.64171301999994, 65.60480377800008],
              [-20.63385982999995, 65.58999258000006],
              [-20.645863410999937, 65.57306549700007],
              [-20.646473761999914, 65.55565013200004],
              [-20.63573157499991, 65.54515208500004],
              [-20.613392706999946, 65.54897695500006],
              [-20.623646613999938, 65.56728750200006],
              [-20.621896938999953, 65.58344147300005],
              [-20.60895748599995, 65.59096914300005],
              [-20.58551998599995, 65.58315664300005],
              [-20.576771613999938, 65.57664622600004],
              [-20.575795050999943, 65.57265859600005],
              [-20.576283331999946, 65.56683991100005],
              [-20.572417772999927, 65.55516185100004],
              [-20.576527472999942, 65.54755280200004],
              [-20.578724738999938, 65.54083893400008],
              [-20.578684048999946, 65.53534577000005],
              [-20.57518469999991, 65.53571198100008],
              [-20.55650794199994, 65.53107330900008],
              [-20.55068925699993, 65.52850983300004],
              [-20.543690558999913, 65.52016836100006],
              [-20.54002844999991, 65.51341380400004],
              [-20.53502356699994, 65.50739166900007],
              [-20.523996548999946, 65.50116608300004],
              [-20.512847459999932, 65.49738190300008],
              [-20.500884568999936, 65.49494049700007],
              [-20.488352016999954, 65.49404531500005],
              [-20.47565670499995, 65.49494049700007],
              [-20.472320115999935, 65.49591705900008],
              [-20.45343990799995, 65.50145091400003],
              [-20.444691535999937, 65.51211172100005],
              [-20.439564581999946, 65.52757396000004],
              [-20.427845831999946, 65.54897695500006],
              [-20.43932044199994, 65.55316803600005],
              [-20.45466061099995, 65.56659577000005],
              [-20.465972459999932, 65.56940338700008],
              [-20.500396287999934, 65.56818268400008],
              [-20.51699785099993, 65.57013580900008],
              [-20.530873175999943, 65.57689036700003],
              [-20.49754798099991, 65.58226146000004],
              [-20.465972459999932, 65.58315664300005],
              [-20.45270748599995, 65.58527252800008],
              [-20.425160285999937, 65.59467194200005],
              [-20.410715298999946, 65.59674713700008],
              [-20.39801998599995, 65.58734772300005],
              [-20.402007615999935, 65.54287344000005],
              [-20.387521938999953, 65.52850983300004],
              [-20.391184048999946, 65.54462311400005],
              [-20.38194739499994, 65.55658600500004],
              [-20.375559048999946, 65.56810130400004],
              [-20.387521938999953, 65.58315664300005],
              [-20.376128709999932, 65.59642161700003],
              [-20.34398352799991, 65.61591217700004],
              [-20.328521287999934, 65.62783437700006],
              [-20.324777798999946, 65.63515859600005],
              [-20.323597785999937, 65.65143463700008],
              [-20.31859290299991, 65.65884023600006],
              [-20.309193488999938, 65.66266510600008],
              [-20.290760870999918, 65.66254303600005],
              [-20.270130988999938, 65.66502513200004],
              [-20.292347785999937, 65.66693756700005],
              [-20.306019660999937, 65.67926666900007],
              [-20.307850714999915, 65.69318268400008],
              [-20.294300910999937, 65.69985586100006],
              [-20.281320766999954, 65.70376211100006],
              [-20.271595831999946, 65.71401601800005],
              [-20.26549231699994, 65.72825755400004],
              [-20.263295050999943, 65.74453359600005],
              [-20.271229620999918, 65.77016836100006],
              [-20.290679490999935, 65.79364655200004],
              [-20.31541907499991, 65.81216054900005],
              [-20.339100714999915, 65.82269928600005],
              [-20.339100714999915, 65.83014557500007],
              [-20.312489386999914, 65.84039948100008],
              [-20.32258053299995, 65.86945221600007],
              [-20.348459438999953, 65.90192291900007],
              [-20.386382615999935, 65.93720123900005],
              [-20.393422003999945, 65.94651927300004],
              [-20.39989173099991, 65.98094310100004],
              [-20.40615800699993, 65.99750397300005],
              [-20.41698157499991, 66.01040273600006],
              [-20.43150794199994, 66.02069733300004],
              [-20.448882615999935, 66.02944570500006],
              [-20.433583136999914, 66.03921133000006],
              [-20.41950436099995, 66.05438873900005],
              [-20.414865688999953, 66.07062409100007],
              [-20.427845831999946, 66.08344147300005],
              [-20.40770423099991, 66.09076569200005],
              [-20.383697068999936, 66.09247467700004],
              [-20.342152472999942, 66.09023672100005],
              [-20.332142706999946, 66.09198639500005],
              [-20.314076300999943, 66.10053131700005],
              [-20.304351365999935, 66.10390859600005],
              [-20.29124915299991, 66.10561758000006],
              [-20.255930141999954, 66.10390859600005],
              [-20.236683722999942, 66.10838450700004],
              [-20.20067298099991, 66.12702057500007],
              [-20.184803839999915, 66.13117096600007],
              [-20.13581295499995, 66.12384674700007],
              [-20.12490800699993, 66.12335846600007],
              [-20.113433397999927, 66.12287018400008],
              [-20.09203040299991, 66.13117096600007],
              [-20.08690344999991, 66.10980866100005],
              [-20.07363847599993, 66.09735748900005],
              [-20.054351365999935, 66.08978913000004],
              [-20.030588344999956, 66.08344147300005],
              [-20.03742428299995, 66.07591380400004],
              [-20.027007615999935, 66.07192617400005],
              [-20.019642706999946, 66.06439850500004],
              [-20.010121222999942, 66.04926178600005],
              [-19.996937628999945, 66.03440989800004],
              [-19.954823370999918, 66.00145091400003],
              [-19.94871985599991, 65.99262116100005],
              [-19.945301886999914, 65.98480866100005],
              [-19.940052863999938, 65.97842031500005],
              [-19.928130662999934, 65.97418854400007],
              [-19.931630011999914, 65.97109609600005],
              [-19.93773352799991, 65.96356842700004],
              [-19.941232876999948, 65.96051666900007],
              [-19.92178300699993, 65.94717031500005],
              [-19.896107550999943, 65.93622467700004],
              [-19.87759355399993, 65.92357005400004],
              [-19.879790818999936, 65.90521881700005],
              [-19.861724412999934, 65.89813873900005],
              [-19.807850714999915, 65.89447663000004],
              [-19.76781165299991, 65.88349030200004],
              [-19.75576738199993, 65.88373444200005],
              [-19.74478105399993, 65.88279857000003],
              [-19.73232988199993, 65.87449778900003],
              [-19.726551886999914, 65.87177155200004],
              [-19.713734503999945, 65.87274811400005],
              [-19.70840410099993, 65.87107982000003],
              [-19.70213782499991, 65.86383698100008],
              [-19.69945227799991, 65.85675690300008],
              [-19.697865363999938, 65.84979889500005],
              [-19.69481360599991, 65.84320709800005],
              [-19.672759568999936, 65.82322825700004],
              [-19.666859503999945, 65.81586334800005],
              [-19.662505662999934, 65.80345286700003],
              [-19.656971808999913, 65.77643463700008],
              [-19.650380011999914, 65.76496002800008],
              [-19.62877356699994, 65.75275299700007],
              [-19.577748175999943, 65.74640534100007],
              [-19.55760657499991, 65.73395416900007],
              [-19.551380988999938, 65.75527578300006],
              [-19.544300910999937, 65.76284414300005],
              [-19.51353919199994, 65.76121653900003],
              [-19.50967363199993, 65.75946686400005],
              [-19.495920376999948, 65.75104401200008],
              [-19.488677537999934, 65.74823639500005],
              [-19.477406378999945, 65.74689362200007],
              [-19.44908606699994, 65.74750397300005],
              [-19.457915818999936, 65.74530670800004],
              [-19.465240037999934, 65.74188873900005],
              [-19.46825110599991, 65.73737213700008],
              [-19.464670376999948, 65.72923411700003],
              [-19.45616614499994, 65.72894928600005],
              [-19.437855597999942, 65.73395416900007],
              [-19.42723548099991, 65.73993561400005],
              [-19.418039516999954, 65.75385163000004],
              [-19.406809048999946, 65.78237539300005],
              [-19.39981035099993, 65.81150950700004],
              [-19.399240688999953, 65.83661530200004],
              [-19.40583248599995, 65.86017487200007],
              [-19.420399542999917, 65.88475169500003],
              [-19.448841925999943, 65.91941966400003],
              [-19.451527472999942, 65.92572663000004],
              [-19.51040605399993, 65.95302969000005],
              [-19.51085364499994, 65.96015045800004],
              [-19.506459113999938, 65.96954987200007],
              [-19.49791419199994, 65.97752513200004],
              [-19.485585089999915, 65.98094310100004],
              [-19.467396613999938, 65.98265208500004],
              [-19.44749915299991, 65.98777903900003],
              [-19.428578253999945, 65.99616120000007],
              [-19.41364498599995, 66.00763580900008],
              [-19.424631313999953, 66.01337311400005],
              [-19.434315558999913, 66.02142975500004],
              [-19.442209438999953, 66.03131745000007],
              [-19.451771613999938, 66.05255768400008],
              [-19.451893683999913, 66.05597565300008],
              [-19.44758053299995, 66.05866120000007],
              [-19.437855597999942, 66.06663646000004],
              [-19.41982988199993, 66.07583242400005],
              [-19.36270097599993, 66.08836497600004],
              [-19.229318813999953, 66.09764232000003],
              [-19.182484503999945, 66.08295319200005],
              [-19.157582160999937, 66.08112213700008],
              [-19.15973873599995, 66.09764232000003],
              [-19.15192623599995, 66.10162995000007],
              [-19.14395097599993, 66.10407135600008],
              [-19.135243292999917, 66.10492584800005],
              [-19.125599738999938, 66.10390859600005],
              [-19.12840735599991, 66.10004303600005],
              [-19.132435675999943, 66.09023672100005],
              [-19.11237545499995, 66.08698151200008],
              [-19.07843990799995, 66.07249583500004],
              [-19.057932094999956, 66.07037995000007],
              [-19.07054602799991, 66.07526276200008],
              [-19.07966061099995, 66.08100006700005],
              [-19.08625240799995, 66.08828359600005],
              [-19.091460740999935, 66.09764232000003],
              [-19.08462480399993, 66.09764232000003],
              [-19.08462480399993, 66.10390859600005],
              [-19.090199347999942, 66.10553620000007],
              [-19.099680141999954, 66.10968659100007],
              [-19.105132615999935, 66.11131419500003],
              [-19.105132615999935, 66.11749909100007],
              [-19.095773891999954, 66.12445709800005],
              [-19.08503170499995, 66.14793528900003],
              [-19.07843990799995, 66.15851471600007],
              [-19.06867428299995, 66.16461823100008],
              [-19.034047003999945, 66.17719147300005],
              [-18.944691535999937, 66.19065989800004],
              [-18.912912563999953, 66.18439362200007],
              [-18.92015540299991, 66.15228913000004],
              [-18.90103105399993, 66.15546295800004],
              [-18.88768469999991, 66.16425202000005],
              [-18.864898240999935, 66.18577708500004],
              [-18.86937415299991, 66.19562409100007],
              [-18.872425910999937, 66.19944896000004],
              [-18.854115363999938, 66.20538971600007],
              [-18.827015753999945, 66.20343659100007],
              [-18.77684485599991, 66.19330475500004],
              [-18.78465735599991, 66.17837148600006],
              [-18.801503058999913, 66.15664297100005],
              [-18.804676886999914, 66.14175039300005],
              [-18.793568488999938, 66.14207591400003],
              [-18.721547003999945, 66.17275625200006],
              [-18.692250128999945, 66.16998932500007],
              [-18.668120897999927, 66.15794505400004],
              [-18.64757239499994, 66.14484284100007],
              [-18.629058397999927, 66.13861725500004],
              [-18.619618292999917, 66.13149648600006],
              [-18.631214972999942, 66.11562734600005],
              [-18.659535285999937, 66.09023672100005],
              [-18.646880662999934, 66.08978913000004],
              [-18.632557745999918, 66.09137604400007],
              [-18.618967251999948, 66.09503815300008],
              [-18.60887610599991, 66.10077545800004],
              [-18.59715735599991, 66.10455963700008],
              [-18.584095831999946, 66.10032786700003],
              [-18.57135982999995, 66.09369538000004],
              [-18.560170050999943, 66.09023672100005],
              [-18.544545050999943, 66.08274974200003],
              [-18.534820115999935, 66.06525299700007],
              [-18.52684485599991, 66.04498932500007],
              [-18.516102667999917, 66.02944570500006],
              [-18.53457597599993, 65.99949778900003],
              [-18.54246985599991, 65.98191966400003],
              [-18.54002844999991, 65.97418854400007],
              [-18.46833248599995, 65.96670156500005],
              [-18.422230597999942, 65.95465729400007],
              [-18.348011847999942, 65.95018138200004],
              [-18.338002081999946, 65.94684479400007],
              [-18.32725989499994, 65.93903229400007],
              [-18.31045488199993, 65.92267487200007],
              [-18.28734290299991, 65.91510651200008],
              [-18.27961178299995, 65.90485260600008],
              [-18.27440344999991, 65.89325592700004],
              [-18.26553300699993, 65.88007233300004],
              [-18.263661261999914, 65.87567780200004],
              [-18.260324673999946, 65.87238190300008],
              [-18.252308722999942, 65.87107982000003],
              [-18.233998175999943, 65.87221914300005],
              [-18.224964972999942, 65.87140534100007],
              [-18.21816972599993, 65.86774323100008],
              [-18.208159959999932, 65.85529205900008],
              [-18.205474412999934, 65.84707265800006],
              [-18.207630988999938, 65.81928131700005],
              [-18.203684048999946, 65.80792877800008],
              [-18.185292120999918, 65.79002513200004],
              [-18.179676886999914, 65.78237539300005],
              [-18.179839647999927, 65.74042389500005],
              [-18.176584438999953, 65.73395416900007],
              [-18.167958136999914, 65.73114655200004],
              [-18.138742641999954, 65.71344635600008],
              [-18.091542120999918, 65.69301992400005],
              [-18.096913214999915, 65.67963288000004],
              [-18.091949022999927, 65.66181061400005],
              [-18.079904751999948, 65.64760976800005],
              [-18.06358801999994, 65.64520905200004],
              [-18.05101477799991, 65.65766022300005],
              [-18.05186926999994, 65.67597077000005],
              [-18.060373501999948, 65.69407786700003],
              [-18.070423956999946, 65.70600006700005],
              [-18.078480597999942, 65.70978424700007],
              [-18.099232550999943, 65.71637604400007],
              [-18.105132615999935, 65.72028229400007],
              [-18.109486456999946, 65.73159414300005],
              [-18.10655676999994, 65.73802317900004],
              [-18.101185675999943, 65.74262116100005],
              [-18.097767706999946, 65.74823639500005],
              [-18.098378058999913, 65.75763580900008],
              [-18.10069739499994, 65.76455312700006],
              [-18.101633266999954, 65.77171458500004],
              [-18.097767706999946, 65.78237539300005],
              [-18.092518683999913, 65.78628164300005],
              [-18.075347459999932, 65.79279205900008],
              [-18.070423956999946, 65.79604726800005],
              [-18.064564581999946, 65.81460195500006],
              [-18.067616339999915, 65.83055247600004],
              [-18.097767706999946, 65.87791575700004],
              [-18.098500128999945, 65.88104889500005],
              [-18.097767706999946, 65.89496491100005],
              [-18.100331183999913, 65.89874909100007],
              [-18.10643469999991, 65.89858633000006],
              [-18.11351477799991, 65.89744700700004],
              [-18.118885870999918, 65.89838288000004],
              [-18.13857988199993, 65.91616445500006],
              [-18.146148240999935, 65.91958242400005],
              [-18.147206183999913, 65.92059967700004],
              [-18.14867102799991, 65.92279694200005],
              [-18.151519334999932, 65.92479075700004],
              [-18.156727667999917, 65.92572663000004],
              [-18.16169186099995, 65.92357005400004],
              [-18.169911261999914, 65.91400788000004],
              [-18.173451300999943, 65.91209544500003],
              [-18.18700110599991, 65.91583893400008],
              [-18.217925584999932, 65.93207428600005],
              [-18.228138800999943, 65.93939850500004],
              [-18.218739386999914, 65.95355866100005],
              [-18.22252356699994, 65.96698639500005],
              [-18.235218878999945, 65.97699616100005],
              [-18.264068162999934, 65.98484935100004],
              [-18.28425045499995, 66.00551992400005],
              [-18.296986456999946, 66.01508209800005],
              [-18.296986456999946, 66.02191803600005],
              [-18.289540167999917, 66.02191803600005],
              [-18.289540167999917, 66.02944570500006],
              [-18.31672115799995, 66.05735911700003],
              [-18.32921301999994, 66.10394928600005],
              [-18.323841925999943, 66.15078359600005],
              [-18.296986456999946, 66.17963288000004],
              [-18.283680792999917, 66.18203359600005],
              [-18.193959113999938, 66.17963288000004],
              [-18.18032792899993, 66.17633698100008],
              [-18.156239386999914, 66.16771067900004],
              [-18.14244544199994, 66.16596100500004],
              [-18.099720831999946, 66.16771067900004],
              [-18.084136522999927, 66.16596100500004],
              [-18.08617102799991, 66.16229889500005],
              [-18.08617102799991, 66.16095612200007],
              [-18.086822068999936, 66.16030508000006],
              [-18.091542120999918, 66.15851471600007],
              [-18.054066535999937, 66.14956289300005],
              [-17.955433722999942, 66.16014232000003],
              [-17.91274980399993, 66.15228913000004],
              [-17.90453040299991, 66.14459870000007],
              [-17.894154425999943, 66.12490469000005],
              [-17.885487433999913, 66.11749909100007],
              [-17.87441972599993, 66.11522044500003],
              [-17.833973761999914, 66.11749909100007],
              [-17.816477016999954, 66.11326732000003],
              [-17.784413214999915, 66.09446849200003],
              [-17.765736456999946, 66.09023672100005],
              [-17.752349412999934, 66.08539459800005],
              [-17.71312415299991, 66.06028880400004],
              [-17.700510219999956, 66.04926178600005],
              [-17.684396938999953, 66.02045319200005],
              [-17.67296301999994, 66.00706614800004],
              [-17.64085852799991, 65.99721914300005],
              [-17.623768683999913, 65.98720937700006],
              [-17.598052537999934, 65.96670156500005],
              [-17.564076300999943, 65.92511627800008],
              [-17.549672003999945, 65.91209544500003],
              [-17.545643683999913, 65.93113841400003],
              [-17.554025844999956, 65.94603099200003],
              [-17.567128058999913, 65.95945872600004],
              [-17.57762610599991, 65.97418854400007],
              [-17.55817623599995, 65.97370026200008],
              [-17.535267706999946, 65.97626373900005],
              [-17.512928839999915, 65.98118724200003],
              [-17.49510657499991, 65.98777903900003],
              [-17.58690344999991, 65.98578522300005],
              [-17.611154751999948, 65.99404531500005],
              [-17.452015753999945, 65.99518463700008],
              [-17.440337693999936, 65.99038320500006],
              [-17.433664516999954, 65.97898997600004],
              [-17.41934160099993, 65.96051666900007],
              [-17.41319739499994, 65.96051666900007],
              [-17.407826300999943, 65.96759674700007],
              [-17.406646287999934, 65.97500234600005],
              [-17.41038977799991, 65.98187897300005],
              [-17.41934160099993, 65.98777903900003],
              [-17.41934160099993, 65.99404531500005],
              [-17.40648352799991, 65.99860260600008],
              [-17.395130988999938, 66.00608958500004],
              [-17.38898678299995, 66.01634349200003],
              [-17.39199785099993, 66.02944570500006],
              [-17.37608801999994, 66.03681061400005],
              [-17.369699673999946, 66.04173411700003],
              [-17.36465410099993, 66.04926178600005],
              [-17.364003058999913, 66.05499909100007],
              [-17.36632239499994, 66.07050202000005],
              [-17.36465410099993, 66.08344147300005],
              [-17.352162238999938, 66.09711334800005],
              [-17.326771613999938, 66.11033763200004],
              [-17.297230597999942, 66.12042877800008],
              [-17.272287563999953, 66.12433502800008],
              [-17.261463995999918, 66.12970612200007],
              [-17.25572669199994, 66.14142487200007],
              [-17.254790818999936, 66.15314362200007],
              [-17.25890051999994, 66.15851471600007],
              [-17.269886847999942, 66.16152578300006],
              [-17.264963344999956, 66.16864655200004],
              [-17.244618292999917, 66.18268463700008],
              [-17.217355923999946, 66.19424062700006],
              [-17.15611731699994, 66.20368073100008],
              [-17.14561926999994, 66.22117747600004],
              [-17.119252081999946, 66.21112702000005],
              [-17.01866614499994, 66.20693594000005],
              [-16.99242102799991, 66.19953034100007],
              [-16.991525844999956, 66.19875722900008],
              [-16.972035285999937, 66.18146393400008],
              [-16.933338995999918, 66.13861725500004],
              [-16.934396938999953, 66.13320547100005],
              [-16.934437628999945, 66.13108958500004],
              [-16.933949347999942, 66.12913646000004],
              [-16.933338995999918, 66.12433502800008],
              [-16.947010870999918, 66.12433502800008],
              [-16.947010870999918, 66.11749909100007],
              [-16.935292120999918, 66.11322663000004],
              [-16.922759568999936, 66.11102936400005],
              [-16.910267706999946, 66.11200592700004],
              [-16.898548956999946, 66.11749909100007],
              [-16.905181443999936, 66.11831289300005],
              [-16.919748501999948, 66.12433502800008],
              [-16.884103969999956, 66.13532135600008],
              [-16.75812740799995, 66.14960358300004],
              [-16.721058722999942, 66.14484284100007],
              [-16.737172003999945, 66.14508698100008],
              [-16.75304114499994, 66.14288971600007],
              [-16.76821855399993, 66.13837311400005],
              [-16.782541469999956, 66.13117096600007],
              [-16.76976477799991, 66.12763092700004],
              [-16.75182044199994, 66.11318594000005],
              [-16.744699673999946, 66.11444733300004],
              [-16.724436001999948, 66.13442617400005],
              [-16.712513800999943, 66.14248281500005],
              [-16.700550910999937, 66.14484284100007],
              [-16.672352667999917, 66.13369375200006],
              [-16.651682094999956, 66.11595286700003],
              [-16.62954667899993, 66.10081614800004],
              [-16.596913214999915, 66.09764232000003],
              [-16.596913214999915, 66.10390859600005],
              [-16.628895636999914, 66.11334870000007],
              [-16.64484615799995, 66.12051015800006],
              [-16.655629035999937, 66.12775299700007],
              [-16.663441535999937, 66.14085521000004],
              [-16.663726365999935, 66.15070221600007],
              [-16.667713995999918, 66.15851471600007],
              [-16.686268683999913, 66.16596100500004],
              [-16.640736456999946, 66.17934804900005],
              [-16.57249915299991, 66.18854401200008],
              [-16.531361456999946, 66.19916413000004],
              [-16.508168097999942, 66.19944896000004],
              [-16.59666907499991, 66.17829010600008],
              [-16.624256964999915, 66.16596100500004],
              [-16.53652910099993, 66.18012116100005],
              [-16.515695766999954, 66.17963288000004],
              [-16.491363084999932, 66.17059967700004],
              [-16.452463344999956, 66.14642975500004],
              [-16.426258917999917, 66.14484284100007],
              [-16.426258917999917, 66.15228913000004],
              [-16.461537238999938, 66.16718170800004],
              [-16.479359503999945, 66.17841217700004],
              [-16.487049933999913, 66.18952057500007],
              [-16.483143683999913, 66.20477936400005],
              [-16.472767706999946, 66.21767812700006],
              [-16.45767167899993, 66.22760651200008],
              [-16.439930792999917, 66.23419830900008],
              [-16.43936113199993, 66.23891836100006],
              [-16.44090735599991, 66.24013906500005],
              [-16.437489386999914, 66.24494049700007],
              [-16.42870032499991, 66.25275299700007],
              [-16.421986456999946, 66.26239655200004],
              [-16.41942298099991, 66.27179596600007],
              [-16.421945766999954, 66.28709544500003],
              [-16.428618943999936, 66.29547760600008],
              [-16.438303188999953, 66.30231354400007],
              [-16.45421301999994, 66.31745026200008],
              [-16.459095831999946, 66.32074616100005],
              [-16.46475175699993, 66.32290273600006],
              [-16.47093665299991, 66.32363515800006],
              [-16.476185675999943, 66.32733795800004],
              [-16.47801673099991, 66.33576080900008],
              [-16.47883053299995, 66.34479401200008],
              [-16.480824347999942, 66.35028717700004],
              [-16.508534308999913, 66.35932038000004],
              [-16.515370245999918, 66.36733633000006],
              [-16.508168097999942, 66.38507721600007],
              [-16.511463995999918, 66.38544342700004],
              [-16.521839972999942, 66.38507721600007],
              [-16.518299933999913, 66.38837311400005],
              [-16.511830206999946, 66.39598216400003],
              [-16.508168097999942, 66.39931875200006],
              [-16.515248175999943, 66.40216705900008],
              [-16.520130988999938, 66.40643952000005],
              [-16.529286261999914, 66.41917552300004],
              [-16.508168097999942, 66.41917552300004],
              [-16.508168097999942, 66.42601146000004],
              [-16.525502081999946, 66.43573639500005],
              [-16.544667120999918, 66.46759674700007],
              [-16.572987433999913, 66.48102448100008],
              [-16.56395423099991, 66.49481842700004],
              [-16.543324347999942, 66.50698476800005],
              [-16.521839972999942, 66.50853099200003],
              [-16.515980597999942, 66.50263092700004],
              [-16.51520748599995, 66.49502187700006],
              [-16.512603318999936, 66.48883698100008],
              [-16.501332160999937, 66.48749420800004],
              [-16.498605923999946, 66.49201080900008],
              [-16.494496222999942, 66.50161367400005],
              [-16.487049933999913, 66.51105377800008],
              [-16.473988410999937, 66.51536692900004],
              [-16.445912238999938, 66.52020905200004],
              [-16.429676886999914, 66.51984284100007],
              [-16.429351365999935, 66.51194896000004],
              [-16.434437628999945, 66.50092194200005],
              [-16.431019660999937, 66.49160390800006],
              [-16.422434048999946, 66.48468659100007],
              [-16.41197669199994, 66.48126862200007],
              [-16.41392981699994, 66.48672109600005],
              [-16.414662238999938, 66.49111562700006],
              [-16.41588294199994, 66.49555084800005],
              [-16.41942298099991, 66.50112539300005],
              [-16.403635219999956, 66.50360748900005],
              [-16.37413489499994, 66.51373932500007],
              [-16.36473548099991, 66.51536692900004],
              [-16.350005662999934, 66.51019928600005],
              [-16.339019334999932, 66.50250885600008],
              [-16.327015753999945, 66.49616120000007],
              [-16.30955969999991, 66.49494049700007],
              [-16.323597785999937, 66.48883698100008],
              [-16.330067511999914, 66.48749420800004],
              [-16.312855597999942, 66.48126862200007],
              [-16.294260219999956, 66.48273346600007],
              [-16.274728969999956, 66.48655833500004],
              [-16.26862545499995, 66.48749420800004],
              [-16.26862545499995, 66.49494049700007],
              [-16.257557745999918, 66.50202057500007],
              [-16.247303839999915, 66.51162344000005],
              [-16.235585089999915, 66.51788971600007],
              [-16.23379472599993, 66.51536692900004],
              [-16.22679602799991, 66.50389232000003],
              [-16.215199347999942, 66.50218333500004],
              [-16.204457160999937, 66.50796133000006],
              [-16.19627844999991, 66.52684153900003],
              [-16.187652147999927, 66.53143952000005],
              [-16.16551673099991, 66.53587474200003],
              [-16.13780676999994, 66.53587474200003],
              [-16.080799933999913, 66.52594635600008],
              [-16.06940670499995, 66.52846914300005],
              [-16.02293860599991, 66.53660716400003],
              [-15.938710089999915, 66.50267161700003],
              [-15.891224738999938, 66.49494049700007],
              [-15.904693162999934, 66.48578522300005],
              [-15.920318162999934, 66.48167552300004],
              [-15.933338995999918, 66.47549062700006],
              [-15.939605272999927, 66.46015045800004],
              [-15.929351365999935, 66.46043528900003],
              [-15.925933397999927, 66.46015045800004],
              [-15.925933397999927, 66.45392487200007],
              [-15.94640051999994, 66.44647858300004],
              [-15.941029425999943, 66.44367096600007],
              [-15.931060350999928, 66.43573639500005],
              [-15.925933397999927, 66.43280670800004],
              [-15.937652147999927, 66.42381419500003],
              [-15.92406165299991, 66.42234935100004],
              [-15.888091600999928, 66.42601146000004],
              [-15.84797115799995, 66.42230866100005],
              [-15.83039303299995, 66.42601146000004],
              [-15.83226477799991, 66.42145416900007],
              [-15.834868943999936, 66.41030508000006],
              [-15.836537238999938, 66.40550364800004],
              [-15.741037563999953, 66.40550364800004],
              [-15.72297115799995, 66.40281810100004],
              [-15.706695115999935, 66.39590078300006],
              [-15.697417772999927, 66.38686758000006],
              [-15.69945227799991, 66.37763092700004],
              [-15.69945227799991, 66.37140534100007],
              [-15.67955481699994, 66.34406159100007],
              [-15.721302863999938, 66.31240469000005],
              [-15.744862433999913, 66.29954661700003],
              [-15.775135870999918, 66.28945547100005],
              [-15.761463995999918, 66.27521393400008],
              [-15.749501105999911, 66.28066640800006],
              [-15.737294074999909, 66.27757396000004],
              [-15.723459438999953, 66.27163320500006],
              [-15.69054114499994, 66.26577383000006],
              [-15.687001105999911, 66.25869375200006],
              [-15.691395636999914, 66.24787018400008],
              [-15.69945227799991, 66.23419830900008],
              [-15.68390865799995, 66.22874583500004],
              [-15.610666469999956, 66.22736237200007],
              [-15.575428839999915, 66.23395416900007],
              [-15.56358801999994, 66.23261139500005],
              [-15.558583136999914, 66.22809479400007],
              [-15.548573370999918, 66.22117747600004],
              [-15.544260219999956, 66.22125885600008],
              [-15.538319464999915, 66.22304922100005],
              [-15.528716600999928, 66.22736237200007],
              [-15.52647864499994, 66.21649811400005],
              [-15.520130988999938, 66.20770905200004],
              [-15.510121222999942, 66.20164622600004],
              [-15.481922980999911, 66.19635651200008],
              [-15.452015753999945, 66.18268463700008],
              [-15.419667120999918, 66.17230866100005],
              [-15.400135870999918, 66.15851471600007],
              [-15.380360480999911, 66.14996979400007],
              [-15.356760219999956, 66.15851471600007],
              [-15.364816860999952, 66.16010163000004],
              [-15.368031378999945, 66.16205475500004],
              [-15.371083136999914, 66.16596100500004],
              [-15.353505011999914, 66.17121002800008],
              [-15.340443488999938, 66.18219635600008],
              [-15.33234615799995, 66.19794342700004],
              [-15.329457160999937, 66.21747467700004],
              [-15.333485480999911, 66.23761627800008],
              [-15.337880011999914, 66.25177643400008],
              [-15.331288214999915, 66.26146067900004],
              [-15.302154100999928, 66.26837799700007],
              [-15.179025844999956, 66.26837799700007],
              [-15.108754035999937, 66.27838776200008],
              [-15.103260870999918, 66.28611888200004],
              [-15.102284308999913, 66.29535553600005],
              [-15.096750454999949, 66.30312734600005],
              [-15.025949673999946, 66.32184479400007],
              [-15.014800584999932, 66.33380768400008],
              [-15.007801886999914, 66.34910716400003],
              [-14.991118943999936, 66.36131419500003],
              [-14.952137824999909, 66.37763092700004],
              [-14.925445115999935, 66.38532135600008],
              [-14.83975175699993, 66.39183177300004],
              [-14.816151495999918, 66.38910553600005],
              [-14.777699347999942, 66.37579987200007],
              [-14.75413977799991, 66.37140534100007],
              [-14.563628709999932, 66.38450755400004],
            ],
          ],
          [
            [
              [-17.751291469999956, 63.71784088700008],
              [-17.743763800999943, 63.71161530200004],
              [-17.74315344999991, 63.703192450000074],
              [-17.749256964999915, 63.69196198100008],
              [-17.764963344999956, 63.68195221600007],
              [-17.771107550999943, 63.68073151200008],
              [-17.764068162999934, 63.684881903000075],
              [-17.759022589999915, 63.69017161700003],
              [-17.760609503999945, 63.69599030200004],
              [-17.76895097599993, 63.698919989000046],
              [-17.779693162999934, 63.69822825700004],
              [-17.82331295499995, 63.691392320000034],
              [-17.820708787999934, 63.699652411000045],
              [-17.79015051999994, 63.71320221600007],
              [-17.773101365999935, 63.718085028000075],
              [-17.765695766999954, 63.71914297100005],
              [-17.751291469999956, 63.71784088700008],
            ],
          ],
          [
            [
              [-18.008941209999932, 66.56415436400005],
              [-17.983998175999943, 66.55060455900008],
              [-17.976307745999918, 66.54828522300005],
              [-17.980458136999914, 66.53904857000003],
              [-17.999826626999948, 66.53339264500005],
              [-18.017201300999943, 66.54498932500007],
              [-18.019520636999914, 66.56134674700007],
              [-18.008941209999932, 66.56415436400005],
            ],
          ],
          [
            [
              [-20.261870897999927, 63.444647528000075],
              [-20.257923956999946, 63.44098541900007],
              [-20.252552863999938, 63.42951080900008],
              [-20.260161912999934, 63.41864655200004],
              [-20.269642706999946, 63.40912506700005],
              [-20.27953040299991, 63.40273672100005],
              [-20.286773240999935, 63.40648021000004],
              [-20.291615363999938, 63.415350653000075],
              [-20.298085089999915, 63.423081773000035],
              [-20.305572068999936, 63.434759833000044],
              [-20.30260169199994, 63.44594961100006],
              [-20.28262285099993, 63.45058828300006],
              [-20.25885982999995, 63.45136139500005],
              [-20.25694739499994, 63.449652411000045],
              [-20.261870897999927, 63.444647528000075],
            ],
          ],
          [
            [
              [-18.380238410999937, 66.01211172100005],
              [-18.37132727799991, 66.00653717700004],
              [-18.356760219999956, 65.99323151200008],
              [-18.356760219999956, 65.98163483300004],
              [-18.369943813999953, 65.97801341400003],
              [-18.38182532499991, 65.97968170800004],
              [-18.39049231699994, 65.98346588700008],
              [-18.396595831999946, 65.98948802300004],
              [-18.398793097999942, 65.99725983300004],
              [-18.40461178299995, 66.00946686400005],
              [-18.414418097999942, 66.02366771000004],
              [-18.408558722999942, 66.02741120000007],
              [-18.38931230399993, 66.01854075700004],
              [-18.380238410999937, 66.01211172100005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Malta',
        iso3: 'MLT',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [14.548024936000047, 35.89004140800006],
              [14.563161655000044, 35.870021877000056],
              [14.567149285000085, 35.84560781500005],
              [14.561778191000087, 35.82982005400004],
              [14.548024936000047, 35.836004950000074],
              [14.532481316000087, 35.821966864000046],
              [14.527517123000052, 35.81354401200008],
              [14.527517123000052, 35.801214911000045],
              [14.51148522200009, 35.80646393400008],
              [14.507090691000087, 35.808661200000074],
              [14.472666863000086, 35.811428127000056],
              [14.424489780000044, 35.82367584800005],
              [14.381521030000044, 35.842962958000044],
              [14.36304772200009, 35.86668528900009],
              [14.359873894000089, 35.86969635600008],
              [14.345713738000086, 35.87592194200005],
              [14.342621290000068, 35.88068268400008],
              [14.342621290000068, 35.91168854400007],
              [14.338226759000065, 35.946966864000046],
              [14.332530144000089, 35.96283600500004],
              [14.32203209700009, 35.97313060100004],
              [14.334727410000085, 35.98236725500004],
              [14.347504102000073, 35.988714911000045],
              [14.361501498000052, 35.99241771000004],
              [14.377289259000065, 35.99363841400009],
              [14.377289259000065, 35.98623281500005],
              [14.368174675000091, 35.98484935100004],
              [14.362315300000091, 35.982407945000034],
              [14.34937584700009, 35.97313060100004],
              [14.428477410000085, 35.965725002000056],
              [14.44507897200009, 35.96035390800006],
              [14.478688998000052, 35.93695709800005],
              [14.507823113000086, 35.92853424700007],
              [14.512868686000047, 35.920803127000056],
              [14.514008009000065, 35.91083405200004],
              [14.513926629000082, 35.900824286000045],
              [14.51929772200009, 35.89996979400007],
              [14.548024936000047, 35.89004140800006],
            ],
          ],
          [
            [
              [14.256602410000085, 36.07558828300006],
              [14.28256269600007, 36.06785716400009],
              [14.314789259000065, 36.05109284100007],
              [14.334239129000082, 36.034369208000044],
              [14.32203209700009, 36.02716705900008],
              [14.30445397200009, 36.026597398000035],
              [14.277598504000082, 36.01666901200008],
              [14.260020379000082, 36.01349518400008],
              [14.241465691000087, 36.01463450700004],
              [14.220876498000052, 36.019191799000055],
              [14.201182488000086, 36.02606842700004],
              [14.18490644600007, 36.03461334800005],
              [14.187998894000089, 36.04539622600004],
              [14.184336785000085, 36.056301174000055],
              [14.183604363000086, 36.06476471600007],
              [14.195485873000052, 36.06810130400004],
              [14.256602410000085, 36.07558828300006],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Jersey',
        iso3: 'JEY',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-2.08267167899993, 49.26023997600004],
            [-2.067860480999911, 49.25067780200004],
            [-2.020659959999932, 49.235256252000056],
            [-2.021962042999917, 49.225490627000056],
            [-2.017323370999918, 49.22138092700004],
            [-2.011870897999927, 49.215277411000045],
            [-2.008290167999917, 49.21246979400007],
            [-2.016997850999928, 49.20722077000005],
            [-2.020985480999911, 49.20075104400007],
            [-2.022043423999946, 49.19245026200008],
            [-2.021962042999917, 49.18138255400004],
            [-2.024525519999941, 49.17133209800005],
            [-2.031158006999931, 49.17145416900007],
            [-2.040028449999909, 49.17572663000004],
            [-2.049224412999934, 49.17829010600008],
            [-2.079986131999931, 49.17869700700004],
            [-2.096994594999956, 49.183661200000074],
            [-2.120228644999941, 49.19916413000004],
            [-2.128895636999914, 49.20307038000004],
            [-2.137928839999915, 49.20563385600008],
            [-2.14484615799995, 49.20563385600008],
            [-2.152943488999938, 49.19993724200003],
            [-2.160633917999917, 49.190741278000075],
            [-2.168690558999913, 49.17829010600008],
            [-2.177154100999928, 49.18016185100004],
            [-2.18968665299991, 49.189113674000055],
            [-2.200103318999936, 49.19196198100008],
            [-2.202951626999948, 49.19041575700004],
            [-2.223378058999913, 49.18471914300005],
            [-2.233631964999915, 49.18451569200005],
            [-2.226470506999931, 49.20600006700005],
            [-2.233225063999953, 49.228501695000034],
            [-2.242014126999948, 49.24795156500005],
            [-2.241118943999936, 49.26023997600004],
            [-2.229359503999945, 49.263006903000075],
            [-2.215199347999942, 49.26023997600004],
            [-2.196278449999909, 49.25340403900009],
            [-2.182728644999941, 49.25405508000006],
            [-2.172352667999917, 49.25625234600005],
            [-2.162709113999938, 49.26040273600006],
            [-2.151682094999956, 49.26703522300005],
            [-2.143788214999915, 49.26186758000006],
            [-2.121978318999936, 49.25828685100004],
            [-2.110666469999956, 49.25340403900009],
            [-2.103871222999942, 49.25820547100005],
            [-2.097564256999931, 49.25967031500005],
            [-2.08267167899993, 49.26023997600004],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Guernsey',
        iso3: 'GGY',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-2.580230272999927, 49.49359772300005],
              [-2.559559699999909, 49.499335028000075],
              [-2.538197394999941, 49.509833075000074],
              [-2.51821855399993, 49.51552969000005],
              [-2.501698370999918, 49.50665924700007],
              [-2.505767381999931, 49.49799225500004],
              [-2.52212480399993, 49.47996653900009],
              [-2.526722785999937, 49.45848216400009],
              [-2.532948370999918, 49.44285716400009],
              [-2.532785610999952, 49.43891022300005],
              [-2.534087693999936, 49.43622467700004],
              [-2.541981574999909, 49.430894273000035],
              [-2.552072719999956, 49.42670319200005],
              [-2.558705206999946, 49.42719147300005],
              [-2.564849412999934, 49.42951080900008],
              [-2.573109503999945, 49.430894273000035],
              [-2.669341600999928, 49.430894273000035],
              [-2.673451300999943, 49.43349844000005],
              [-2.670765753999945, 49.438788153000075],
              [-2.662953253999945, 49.443793036000045],
              [-2.651844855999911, 49.44521719000005],
              [-2.65656490799995, 49.459418036000045],
              [-2.650257941999939, 49.46369049700007],
              [-2.637928839999915, 49.46385325700004],
              [-2.624623175999943, 49.465725002000056],
              [-2.580230272999927, 49.49359772300005],
            ],
          ],
          [
            [
              [-2.363758917999917, 49.44684479400007],
              [-2.356353318999936, 49.44037506700005],
              [-2.354400193999936, 49.427801825000074],
              [-2.364654100999928, 49.41787344000005],
              [-2.373524542999917, 49.41156647300005],
              [-2.378081834999932, 49.41274648600006],
              [-2.374826626999948, 49.419175523000035],
              [-2.373117641999954, 49.424261786000045],
              [-2.375884568999936, 49.43040599200003],
              [-2.375477667999917, 49.43545156500005],
              [-2.372629360999952, 49.43805573100008],
              [-2.369862433999913, 49.44208405200004],
              [-2.366118943999936, 49.445746161000045],
              [-2.363758917999917, 49.44684479400007],
            ],
          ],
          [
            [
              [-2.17446855399993, 49.73139069200005],
              [-2.170318162999934, 49.72874583500004],
              [-2.170318162999934, 49.72321198100008],
              [-2.187896287999934, 49.710638739000046],
              [-2.200835740999935, 49.70571523600006],
              [-2.216867641999954, 49.70302969000005],
              [-2.226226365999935, 49.70783112200007],
              [-2.218495245999918, 49.71869538000004],
              [-2.204701300999943, 49.72410716400009],
              [-2.194813605999911, 49.72479889500005],
              [-2.178618943999936, 49.730902411000045],
              [-2.17446855399993, 49.73139069200005],
            ],
          ],
          [
            [
              [-2.453684048999946, 49.48187897300005],
              [-2.447824673999946, 49.48395416900007],
              [-2.445220506999931, 49.474595445000034],
              [-2.45335852799991, 49.462144273000035],
              [-2.454497850999928, 49.466131903000075],
              [-2.455067511999914, 49.475043036000045],
              [-2.453684048999946, 49.48187897300005],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Isle of Man',
        iso3: 'IMN',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-4.612131313999953, 54.05695221600007],
            [-4.620757615999935, 54.069647528000075],
            [-4.631255662999934, 54.07062409100007],
            [-4.64321855399993, 54.06659577000005],
            [-4.656402147999927, 54.063788153000075],
            [-4.671009894999941, 54.06704336100006],
            [-4.68968665299991, 54.08152903900003],
            [-4.704497850999928, 54.084865627000056],
            [-4.725982225999928, 54.079006252000056],
            [-4.745594855999911, 54.06736888200004],
            [-4.766224738999938, 54.05923086100006],
            [-4.790150519999941, 54.063788153000075],
            [-4.790150519999941, 54.07123444200005],
            [-4.784820115999935, 54.07306549700007],
            [-4.781320766999954, 54.07477448100008],
            [-4.777088995999918, 54.076239325000074],
            [-4.769683397999927, 54.077460028000075],
            [-4.770863410999937, 54.09682851800005],
            [-4.737172003999945, 54.12490469000005],
            [-4.728138800999943, 54.142564195000034],
            [-4.727650519999941, 54.17259349200003],
            [-4.723784959999932, 54.18545156500005],
            [-4.714466925999943, 54.20034414300005],
            [-4.711089647999927, 54.20990631700005],
            [-4.712269660999937, 54.21662018400008],
            [-4.710275844999956, 54.22064850500004],
            [-4.68814042899993, 54.22378164300005],
            [-4.663970506999931, 54.23354726800005],
            [-4.643055792999917, 54.24941640800006],
            [-4.612456834999932, 54.26544830900008],
            [-4.598378058999913, 54.276597398000035],
            [-4.554595506999931, 54.339178778000075],
            [-4.530995245999918, 54.366115627000056],
            [-4.495350714999915, 54.38589101800005],
            [-4.442005988999938, 54.404364325000074],
            [-4.404449022999927, 54.40965403900003],
            [-4.385731574999909, 54.415716864000046],
            [-4.367787238999938, 54.41901276200008],
            [-4.351307745999918, 54.41380442900004],
            [-4.357085740999935, 54.39940013200004],
            [-4.377552863999938, 54.36188385600008],
            [-4.375599738999938, 54.34833405200004],
            [-4.370228644999941, 54.34088776200008],
            [-4.363758917999917, 54.324286200000074],
            [-4.358225063999953, 54.317613023000035],
            [-4.350493943999936, 54.31476471600007],
            [-4.332183397999927, 54.31342194200005],
            [-4.324696417999917, 54.310207424000055],
            [-4.319406704999949, 54.30459219000005],
            [-4.313221808999913, 54.29559967700004],
            [-4.311919725999928, 54.287176825000074],
            [-4.32095292899993, 54.28351471600007],
            [-4.326730923999946, 54.28034088700008],
            [-4.340809699999909, 54.263006903000075],
            [-4.348255988999938, 54.25950755400004],
            [-4.354359503999945, 54.25153229400007],
            [-4.359771287999934, 54.242254950000074],
            [-4.365630662999934, 54.23505280200004],
            [-4.371815558999913, 54.23126862200007],
            [-4.399159308999913, 54.22207265800006],
            [-4.390777147999927, 54.19472890800006],
            [-4.412587042999917, 54.18008047100005],
            [-4.446888800999943, 54.169134833000044],
            [-4.475493943999936, 54.15314362200007],
            [-4.474598761999914, 54.14081452000005],
            [-4.529286261999914, 54.11908600500004],
            [-4.543771938999953, 54.10846588700008],
            [-4.549794074999909, 54.10065338700008],
            [-4.563832160999937, 54.09682851800005],
            [-4.579579230999911, 54.09442780200004],
            [-4.590931769999941, 54.091050523000035],
            [-4.598947719999956, 54.08388906500005],
            [-4.612131313999953, 54.05695221600007],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Åland',
        iso3: 'ALA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [20.277598504000082, 60.14215729400007],
              [20.297618035000085, 60.121527411000045],
              [20.285166863000086, 60.103583075000074],
              [20.26889082100007, 60.086004950000074],
              [20.277598504000082, 60.066473700000074],
              [20.266286655000044, 60.06049225500004],
              [20.259043816000087, 60.062567450000074],
              [20.252289259000065, 60.068345445000034],
              [20.242849155000044, 60.073919989000046],
              [20.208994988000086, 60.083319403000075],
              [20.201914910000085, 60.087551174000055],
              [20.19825280000009, 60.10407135600008],
              [20.204925977000073, 60.120347398000035],
              [20.21534264400009, 60.13568756700005],
              [20.22242272200009, 60.149603583000044],
              [20.24463951900009, 60.11969635600008],
              [20.258067254000082, 60.10797760600008],
              [20.263926629000082, 60.11823151200008],
              [20.25326582100007, 60.13857656500005],
              [20.255707227000073, 60.145412502000056],
              [20.277598504000082, 60.14215729400007],
            ],
          ],
          [
            [
              [19.639496290000068, 60.22093333500004],
              [19.64307701900009, 60.21344635600008],
              [19.660492384000065, 60.202826239000046],
              [19.667491082000083, 60.19676341400003],
              [19.67090905000009, 60.19057851800005],
              [19.673106316000087, 60.18423086100006],
              [19.67432701900009, 60.16632721600007],
              [19.671071811000047, 60.15810781500005],
              [19.663340691000087, 60.156683661000045],
              [19.654307488000086, 60.157538153000075],
              [19.64698326900009, 60.15582916900007],
              [19.63249759200005, 60.16543203300006],
              [19.609548373000052, 60.187486070000034],
              [19.591644727000073, 60.19676341400003],
              [19.599457227000073, 60.17987702000005],
              [19.60328209700009, 60.16400788000004],
              [19.599619988000086, 60.14911530200004],
              [19.584808790000068, 60.13532135600008],
              [19.565196160000085, 60.12995026200008],
              [19.54460696700005, 60.134751695000034],
              [19.52702884200005, 60.14862702000005],
              [19.51661217500009, 60.17011139500005],
              [19.513926629000082, 60.17910390800006],
              [19.513194207000083, 60.18378327000005],
              [19.517588738000086, 60.18764883000006],
              [19.53028405000009, 60.19367096600007],
              [19.537282748000052, 60.20111725500004],
              [19.536957227000073, 60.21112702000005],
              [19.535166863000086, 60.22207265800006],
              [19.537119988000086, 60.23216380400004],
              [19.542246941000087, 60.23696523600006],
              [19.560394727000073, 60.24896881700005],
              [19.567881707000083, 60.255113023000035],
              [19.578868035000085, 60.26048411700003],
              [19.593760613000086, 60.26048411700003],
              [19.60840905000009, 60.25690338700008],
              [19.628103061000047, 60.24664948100008],
              [19.63445071700005, 60.24013906500005],
              [19.63835696700005, 60.231634833000044],
              [19.639496290000068, 60.22093333500004],
            ],
          ],
          [
            [
              [20.427907748000052, 60.265692450000074],
              [20.434825066000087, 60.26239655200004],
              [20.438975457000083, 60.25820547100005],
              [20.44076582100007, 60.25263092700004],
              [20.441416863000086, 60.24518463700008],
              [20.392914259000065, 60.19676341400003],
              [20.380869988000086, 60.198879299000055],
              [20.380869988000086, 60.20404694200005],
              [20.385508660000085, 60.21076080900008],
              [20.386241082000083, 60.217230536000045],
              [20.38770592500009, 60.221869208000044],
              [20.387543165000068, 60.23297760600008],
              [20.382660352000073, 60.24070872600004],
              [20.353037957000083, 60.22882721600007],
              [20.34538821700005, 60.23769765800006],
              [20.34701582100007, 60.25287506700005],
              [20.358897332000083, 60.265692450000074],
              [20.379649285000085, 60.26968008000006],
              [20.410980665000068, 60.25950755400004],
              [20.427907748000052, 60.265692450000074],
            ],
          ],
          [
            [
              [20.81885826900009, 60.23216380400004],
              [20.790537957000083, 60.238714911000045],
              [20.781097852000073, 60.263657945000034],
              [20.787282748000052, 60.286322333000044],
              [20.80518639400009, 60.28620026200008],
              [20.815277540000068, 60.28099192900004],
              [20.845957879000082, 60.27033112200007],
              [20.853037957000083, 60.265692450000074],
              [20.85059655000009, 60.253607489000046],
              [20.83887780000009, 60.24681224200003],
              [20.82398522200009, 60.24445221600007],
              [20.811371290000068, 60.24518463700008],
              [20.81885826900009, 60.23216380400004],
            ],
          ],
          [
            [
              [20.20875084700009, 60.224676825000074],
              [20.22201582100007, 60.20990631700005],
              [20.229746941000087, 60.20425039300005],
              [20.218923373000052, 60.20132070500006],
              [20.209646030000044, 60.200873114000046],
              [20.20093834700009, 60.19940827000005],
              [20.191661004000082, 60.19367096600007],
              [20.186371290000068, 60.18732330900008],
              [20.177989129000082, 60.173529364000046],
              [20.174571160000085, 60.17011139500005],
              [20.161957227000073, 60.16714101800005],
              [20.154633009000065, 60.16974518400008],
              [20.14779707100007, 60.17401764500005],
              [20.136973504000082, 60.17633698100008],
              [20.09546959700009, 60.17633698100008],
              [20.087087436000047, 60.18219635600008],
              [20.08887780000009, 60.19586823100008],
              [20.095550977000073, 60.21088288000004],
              [20.102305535000085, 60.22093333500004],
              [20.122894727000073, 60.23078034100007],
              [20.17237389400009, 60.23281484600005],
              [20.188243035000085, 60.24518463700008],
              [20.147715691000087, 60.24477773600006],
              [20.11101321700005, 60.239447333000044],
              [20.081879102000073, 60.22337474200003],
              [20.064707879000082, 60.190619208000044],
              [20.057871941000087, 60.190619208000044],
              [20.060883009000065, 60.21474844000005],
              [20.04818769600007, 60.22650788000004],
              [20.031911655000044, 60.236395575000074],
              [20.023692254000082, 60.255113023000035],
              [20.036387566000087, 60.27187734600005],
              [20.05713951900009, 60.29315827000005],
              [20.061289910000085, 60.31004466400003],
              [20.023692254000082, 60.31346263200004],
              [20.023692254000082, 60.306626695000034],
              [20.033864780000044, 60.29389069200005],
              [20.024912957000083, 60.27643463700008],
              [20.00326582100007, 60.26703522300005],
              [19.97592207100007, 60.27871328300006],
              [19.979746941000087, 60.261053778000075],
              [19.993988477000073, 60.241441148000035],
              [20.012950066000087, 60.22516510600008],
              [20.030528191000087, 60.217230536000045],
              [20.020762566000087, 60.21035390800006],
              [20.014903191000087, 60.202337958000044],
              [20.013194207000083, 60.193426825000074],
              [20.016286655000044, 60.18374258000006],
              [19.964121941000087, 60.19481028900003],
              [19.948008660000085, 60.20425039300005],
              [19.953868035000085, 60.209418036000045],
              [19.955739780000044, 60.21283600500004],
              [19.95484459700009, 60.224676825000074],
              [19.927744988000086, 60.22280508000006],
              [19.91456139400009, 60.21820709800005],
              [19.917246941000087, 60.20766836100006],
              [19.929698113000086, 60.19635651200008],
              [19.943614129000082, 60.18622467700004],
              [19.958832227000073, 60.17910390800006],
              [19.98731530000009, 60.173041083000044],
              [19.99659264400009, 60.166001695000034],
              [20.003916863000086, 60.15892161700003],
              [20.010020379000082, 60.15582916900007],
              [20.019867384000065, 60.15810781500005],
              [20.027517123000052, 60.163316148000035],
              [20.03492272200009, 60.169989325000074],
              [20.044200066000087, 60.17633698100008],
              [20.03296959700009, 60.14435455900008],
              [20.030121290000068, 60.128973700000074],
              [20.030528191000087, 60.11481354400007],
              [20.03419030000009, 60.111395575000074],
              [20.040863477000073, 60.10911692900004],
              [20.047536655000044, 60.10541413000004],
              [20.05046634200005, 60.09780508000006],
              [20.044769727000073, 60.08746979400007],
              [20.031586134000065, 60.08738841400003],
              [20.00635826900009, 60.09438711100006],
              [19.965993686000047, 60.091131903000075],
              [19.94898522200009, 60.08388906500005],
              [19.951426629000082, 60.07013580900008],
              [19.958181186000047, 60.05377838700008],
              [19.948496941000087, 60.04767487200007],
              [19.937754754000082, 60.05036041900007],
              [19.94117272200009, 60.060248114000046],
              [19.924001498000052, 60.09153880400004],
              [19.910329623000052, 60.10106028900003],
              [19.886566602000073, 60.101223049000055],
              [19.873301629000082, 60.09642161700003],
              [19.870290561000047, 60.091009833000044],
              [19.868337436000047, 60.08551666900007],
              [19.858653191000087, 60.08075592700004],
              [19.84506269600007, 60.07868073100008],
              [19.83171634200005, 60.07949453300006],
              [19.82325280000009, 60.08429596600007],
              [19.824473504000082, 60.09438711100006],
              [19.806976759000065, 60.09983958500004],
              [19.788910352000073, 60.09625885600008],
              [19.773448113000086, 60.08649323100008],
              [19.76303144600007, 60.073919989000046],
              [19.747569207000083, 60.10138580900008],
              [19.71029707100007, 60.14520905200004],
              [19.69467207100007, 60.17011139500005],
              [19.68799889400009, 60.199286200000074],
              [19.682383660000085, 60.21198151200008],
              [19.67090905000009, 60.217230536000045],
              [19.668793165000068, 60.224676825000074],
              [19.64698326900009, 60.265692450000074],
              [19.666677280000044, 60.266058661000045],
              [19.682871941000087, 60.26434967700004],
              [19.691416863000086, 60.25653717700004],
              [19.68848717500009, 60.238348700000074],
              [19.69629967500009, 60.24876536700003],
              [19.70248457100007, 60.26007721600007],
              [19.709320509000065, 60.268866278000075],
              [19.718923373000052, 60.27252838700008],
              [19.73210696700005, 60.27391185100004],
              [19.77051842500009, 60.28620026200008],
              [19.762868686000047, 60.29051341400003],
              [19.757823113000086, 60.29547760600008],
              [19.74935957100007, 60.306626695000034],
              [19.77003014400009, 60.30329010600008],
              [19.777354363000086, 60.29979075700004],
              [19.783457879000082, 60.30304596600007],
              [19.786306186000047, 60.30353424700007],
              [19.79656009200005, 60.29979075700004],
              [19.780772332000083, 60.27094147300005],
              [19.765147332000083, 60.24896881700005],
              [19.76807701900009, 60.24042389500005],
              [19.77637780000009, 60.23334381700005],
              [19.78419030000009, 60.224676825000074],
              [19.79200280000009, 60.20014069200005],
              [19.79859459700009, 60.193060614000046],
              [19.81421959700009, 60.190619208000044],
              [19.821787957000083, 60.19599030200004],
              [19.823496941000087, 60.20848216400003],
              [19.82129967500009, 60.22247955900008],
              [19.817637566000087, 60.23216380400004],
              [19.835459832000083, 60.22638580900008],
              [19.851817254000082, 60.217230536000045],
              [19.858653191000087, 60.24518463700008],
              [19.879730665000068, 60.25885651200008],
              [19.884613477000073, 60.27252838700008],
              [19.88640384200005, 60.29364655200004],
              [19.892832879000082, 60.306626695000034],
              [19.89812259200005, 60.29197825700004],
              [19.899587436000047, 60.28461334800005],
              [19.90015709700009, 60.27558014500005],
              [19.905528191000087, 60.27179596600007],
              [19.917246941000087, 60.27293528900003],
              [19.92904707100007, 60.27716705900008],
              [19.934336785000085, 60.282416083000044],
              [19.931488477000073, 60.29975006700005],
              [19.924001498000052, 60.31427643400008],
              [19.912933790000068, 60.32575104400007],
              [19.90015709700009, 60.33392975500004],
              [19.893321160000085, 60.33958567900004],
              [19.889496290000068, 60.34467194200005],
              [19.885101759000065, 60.34520091400003],
              [19.87598717500009, 60.33763255400004],
              [19.865082227000073, 60.319647528000075],
              [19.857676629000082, 60.31321849200003],
              [19.848399285000085, 60.31720612200007],
              [19.83334394600007, 60.334051825000074],
              [19.819183790000068, 60.34682851800005],
              [19.802012566000087, 60.35419342700004],
              [19.777354363000086, 60.35504791900007],
              [19.792979363000086, 60.360541083000044],
              [19.80176842500009, 60.368841864000046],
              [19.80836022200009, 60.378566799000055],
              [19.817637566000087, 60.38857656500005],
              [19.838145379000082, 60.400458075000074],
              [19.859629754000082, 60.405585028000075],
              [19.882334832000083, 60.405585028000075],
              [19.906423373000052, 60.40216705900008],
              [19.913584832000083, 60.38886139500005],
              [19.91846764400009, 60.37018463700008],
              [19.92750084700009, 60.35643138200004],
              [19.969981316000087, 60.361395575000074],
              [19.995616082000083, 60.35643138200004],
              [20.019704623000052, 60.34625885600008],
              [20.03679446700005, 60.33392975500004],
              [20.028493686000047, 60.35407135600008],
              [20.023692254000082, 60.36127350500004],
              [20.03842207100007, 60.35956452000005],
              [20.07203209700009, 60.34992096600007],
              [20.082204623000052, 60.35130442900004],
              [20.093028191000087, 60.355129299000055],
              [20.104665561000047, 60.34992096600007],
              [20.126149936000047, 60.33392975500004],
              [20.178070509000065, 60.32298411700003],
              [20.192067905000044, 60.31232330900008],
              [20.18140709700009, 60.28620026200008],
              [20.19629967500009, 60.290269273000035],
              [20.201914910000085, 60.292954820000034],
              [20.217621290000068, 60.28628164300005],
              [20.23804772200009, 60.28156159100007],
              [20.277598504000082, 60.27871328300006],
              [20.242849155000044, 60.24518463700008],
              [20.23601321700005, 60.23216380400004],
              [20.20875084700009, 60.224676825000074],
            ],
          ],
          [
            [
              [20.875254754000082, 59.914129950000074],
              [20.867930535000085, 59.91791413000004],
              [20.862071160000085, 59.928168036000045],
              [20.87086022200009, 59.936753648000035],
              [20.88453209700009, 59.93976471600007],
              [20.89747155000009, 59.94013092700004],
              [20.906586134000065, 59.93353913000004],
              [20.912852410000085, 59.92072174700007],
              [20.920176629000082, 59.90924713700008],
              [20.912364129000082, 59.90448639500005],
              [20.88770592500009, 59.90912506700005],
              [20.875254754000082, 59.914129950000074],
            ],
          ],
          [
            [
              [20.983571811000047, 59.94277578300006],
              [20.969411655000044, 59.94383372600004],
              [20.96924889400009, 59.94208405200004],
              [20.98414147200009, 59.93626536700003],
              [20.99122155000009, 59.92674388200004],
              [20.982758009000065, 59.921535549000055],
              [20.93213951900009, 59.93585846600007],
              [20.91846764400009, 59.943060614000046],
              [20.913259311000047, 59.948431708000044],
              [20.915212436000047, 59.94936758000006],
              [20.919932488000086, 59.95331452000005],
              [20.934743686000047, 59.95799388200004],
              [20.978688998000052, 59.952053127000056],
              [20.989756707000083, 59.95189036700003],
              [20.99586022200009, 59.94989655200004],
              [20.99659264400009, 59.945013739000046],
              [20.983571811000047, 59.94277578300006],
            ],
          ],
          [
            [
              [20.610118035000085, 60.044989325000074],
              [20.612559441000087, 60.04344310100004],
              [20.617930535000085, 60.042222398000035],
              [20.615244988000086, 60.041083075000074],
              [20.603363477000073, 60.03978099200003],
              [20.60092207100007, 60.03921133000006],
              [20.608246290000068, 60.03595612200007],
              [20.60987389400009, 60.02985260600008],
              [20.606293165000068, 60.022650458000044],
              [20.596446160000085, 60.016058661000045],
              [20.587168816000087, 60.00812409100007],
              [20.57748457100007, 60.00665924700007],
              [20.55046634200005, 60.018866278000075],
              [20.546153191000087, 60.016506252000056],
              [20.539886915000068, 60.00950755400004],
              [20.52702884200005, 60.005072333000044],
              [20.511892123000052, 60.00633372600004],
              [20.500824415000068, 60.01268138200004],
              [20.50554446700005, 60.02423737200007],
              [20.53093509200005, 60.04840729400007],
              [20.544932488000086, 60.05609772300005],
              [20.55836022200009, 60.05760325700004],
              [20.568207227000073, 60.05695221600007],
              [20.576182488000086, 60.05914948100008],
              [20.582855665000068, 60.05914948100008],
              [20.587087436000047, 60.055894273000035],
              [20.587901238000086, 60.051947333000044],
              [20.591075066000087, 60.050848700000074],
              [20.59864342500009, 60.05267975500004],
              [20.604991082000083, 60.052069403000075],
              [20.608653191000087, 60.04759349200003],
              [20.610118035000085, 60.044989325000074],
            ],
          ],
          [
            [
              [20.424082879000082, 60.05524323100008],
              [20.44890384200005, 60.06513092700004],
              [20.46257571700005, 60.06679922100005],
              [20.451019727000073, 60.04010651200008],
              [20.43213951900009, 60.025091864000046],
              [20.402354363000086, 60.02130768400008],
              [20.390147332000083, 60.028225002000056],
              [20.403493686000047, 60.04051341400003],
              [20.424082879000082, 60.05524323100008],
            ],
          ],
          [
            [
              [20.52116946700005, 60.048041083000044],
              [20.519379102000073, 60.042954820000034],
              [20.500336134000065, 60.036363023000035],
              [20.471364780000044, 60.04132721600007],
              [20.46973717500009, 60.05735911700003],
              [20.48804772200009, 60.06240469000005],
              [20.522227410000085, 60.06476471600007],
              [20.525401238000086, 60.06549713700008],
              [20.516449415000068, 60.06696198100008],
              [20.518402540000068, 60.070379950000074],
              [20.533376498000052, 60.07363515800006],
              [20.541840040000068, 60.07099030200004],
              [20.535817905000044, 60.064154364000046],
              [20.526215040000068, 60.05683014500005],
              [20.52116946700005, 60.048041083000044],
            ],
          ],
          [
            [
              [20.68336022200009, 60.130519924000055],
              [20.68653405000009, 60.12653229400007],
              [20.688243035000085, 60.11701080900008],
              [20.681976759000065, 60.11017487200007],
              [20.67156009200005, 60.10919830900008],
              [20.655772332000083, 60.11591217700004],
              [20.638682488000086, 60.13133372600004],
              [20.635508660000085, 60.14394765800006],
              [20.644053582000083, 60.14935944200005],
              [20.653575066000087, 60.15135325700004],
              [20.65992272200009, 60.149725653000075],
              [20.668630405000044, 60.14500560100004],
              [20.67945397200009, 60.13629791900007],
              [20.68336022200009, 60.130519924000055],
            ],
          ],
          [
            [
              [20.683767123000052, 60.229396877000056],
              [20.705902540000068, 60.21824778900003],
              [20.716319207000083, 60.20929596600007],
              [20.707692905000044, 60.199652411000045],
              [20.686778191000087, 60.194566148000035],
              [20.670664910000085, 60.199204820000034],
              [20.664073113000086, 60.20502350500004],
              [20.66342207100007, 60.21637604400007],
              [20.66846764400009, 60.22671133000006],
              [20.683767123000052, 60.229396877000056],
            ],
          ],
          [
            [
              [20.777354363000086, 60.32648346600007],
              [20.74000084700009, 60.31240469000005],
              [20.732676629000082, 60.31435781500005],
              [20.73145592500009, 60.32099030200004],
              [20.73178144600007, 60.32440827000005],
              [20.732676629000082, 60.33274974200003],
              [20.73536217500009, 60.33779531500005],
              [20.74350019600007, 60.34845612200007],
              [20.746918165000068, 60.35187409100007],
              [20.750661655000044, 60.35488515800006],
              [20.75489342500009, 60.36074453300006],
              [20.75717207100007, 60.366115627000056],
              [20.764333530000044, 60.36786530200004],
              [20.776133660000085, 60.366400458000044],
              [20.787364129000082, 60.36196523600006],
              [20.79200280000009, 60.352769273000035],
              [20.789398634000065, 60.34271881700005],
              [20.785329623000052, 60.33356354400007],
              [20.777354363000086, 60.32648346600007],
            ],
          ],
          [
            [
              [20.28131531100007, 59.97661612300004],
              [20.301908032000085, 59.99897521400004],
              [20.33944692500006, 60.020109724000065],
              [20.362417727000036, 60.01767049000006],
              [20.398457475000043, 60.009128720000035],
              [20.43674603700009, 60.00498941600006],
              [20.44705937100008, 59.99518055800007],
              [20.398575509000068, 59.98134905100005],
              [20.367134795000084, 59.98199385200007],
              [20.33932488000005, 59.98020791300007],
              [20.324819234000074, 59.97719531700005],
              [20.322365859000058, 59.96268552400005],
              [20.306648030000076, 59.95362434600008],
              [20.28370709400008, 59.95847545600003],
              [20.28131531100007, 59.97661612300004],
            ],
          ],
          [
            [
              [20.033649523000065, 60.06362600400007],
              [20.06819326100009, 60.07265423500007],
              [20.101269174000038, 60.094974635000085],
              [20.130041679000044, 60.08692804800006],
              [20.163259320000066, 60.08784534100005],
              [20.193190627000035, 60.06556971100008],
              [20.21265842200006, 60.035918234000064],
              [20.222526497000047, 60.01487984700003],
              [20.225218278000057, 60.00547772200008],
              [20.21179127000005, 59.99115005600004],
              [20.18764083600007, 59.97636703000006],
              [20.17512091800006, 59.97143592200007],
              [20.18403657400006, 59.99293783500008],
              [20.171495088000086, 59.99875382600004],
              [20.151812520000078, 59.99292279400004],
              [20.12317881100006, 59.98887241600005],
              [20.10525492100004, 59.99646916900008],
              [20.116869430000065, 60.00543387000005],
              [20.121317588000068, 60.01662719500007],
              [20.104257697000037, 60.02824800500008],
              [20.078257158000042, 60.02822362100005],
              [20.058456981000063, 60.03939637900004],
              [20.02525632700008, 60.04248523600006],
              [20.033649523000065, 60.06362600400007],
            ],
          ],
          [
            [
              [21.088633660000085, 60.480129299000055],
              [21.09473717500009, 60.47557200700004],
              [21.09669030000009, 60.46344635600008],
              [21.088226759000065, 60.45221588700008],
              [21.078379754000082, 60.44896067900004],
              [21.06495201900009, 60.454779364000046],
              [21.059255405000044, 60.46674225500004],
              [21.064300977000073, 60.47435130400004],
              [21.076426629000082, 60.48041413000004],
              [21.084646030000044, 60.48078034100007],
              [21.088633660000085, 60.480129299000055],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Faeroe Is.',
        iso3: 'FRO',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-6.654774542999917, 61.39594147300005],
              [-6.677601691999939, 61.39411041900007],
              [-6.699777798999946, 61.40424225500004],
              [-6.736683722999942, 61.43073151200008],
              [-6.827463344999956, 61.471869208000044],
              [-6.870472785999937, 61.50153229400007],
              [-6.865834113999938, 61.52692291900007],
              [-6.892241990999935, 61.54242584800005],
              [-6.923085089999915, 61.566107489000046],
              [-6.946034308999913, 61.590725002000056],
              [-6.948963995999918, 61.60883209800005],
              [-6.953521287999934, 61.61367422100005],
              [-6.962554490999935, 61.62872955900008],
              [-6.942128058999913, 61.62872955900008],
              [-6.944325324999909, 61.63239166900007],
              [-6.944691535999937, 61.63336823100008],
              [-6.948963995999918, 61.63613515800006],
              [-6.912220831999946, 61.64789459800005],
              [-6.894642706999946, 61.64911530200004],
              [-6.880034959999932, 61.64232005400004],
              [-6.900217251999948, 61.63157786700003],
              [-6.907338019999941, 61.62872955900008],
              [-6.897857225999928, 61.624335028000075],
              [-6.887766079999949, 61.62221914300005],
              [-6.877023891999954, 61.62173086100006],
              [-6.865834113999938, 61.62250397300005],
              [-6.914173956999946, 61.60138580900008],
              [-6.914173956999946, 61.59520091400003],
              [-6.825672980999911, 61.60016510600008],
              [-6.79906165299991, 61.58344147300005],
              [-6.737456834999932, 61.57904694200005],
              [-6.715565558999913, 61.56785716400003],
              [-6.71320553299995, 61.55442942900004],
              [-6.724273240999935, 61.54645416900007],
              [-6.740630662999934, 61.54486725500004],
              [-6.753773566999939, 61.550482489000046],
              [-6.766102667999917, 61.55801015800006],
              [-6.782622850999928, 61.56159088700008],
              [-6.797718878999945, 61.560614325000074],
              [-6.805572068999936, 61.55418528900003],
              [-6.786203579999949, 61.55170319200005],
              [-6.774525519999941, 61.54328034100007],
              [-6.766428188999953, 61.53359609600005],
              [-6.757191535999937, 61.52692291900007],
              [-6.747222459999932, 61.52594635600008],
              [-6.725331183999913, 61.52846914300005],
              [-6.715565558999913, 61.52692291900007],
              [-6.70571855399993, 61.52106354400007],
              [-6.701649542999917, 61.51471588700008],
              [-6.704660610999952, 61.50934479400007],
              [-6.715565558999913, 61.50580475500004],
              [-6.715565558999913, 61.49896881700005],
              [-6.673980272999927, 61.48847077000005],
              [-6.677601691999939, 61.47992584800005],
              [-6.686594204999949, 61.47842031500005],
              [-6.698068813999953, 61.47955963700008],
              [-6.709380662999934, 61.47915273600006],
              [-6.743641730999911, 61.469956773000035],
              [-6.761097785999937, 61.46889883000006],
              [-6.78384355399993, 61.472316799000055],
              [-6.78384355399993, 61.464829820000034],
              [-6.772450324999909, 61.46356842700004],
              [-6.762684699999909, 61.46002838700008],
              [-6.755197719999956, 61.45368073100008],
              [-6.750355597999942, 61.44432200700004],
              [-6.738840298999946, 61.45571523600006],
              [-6.721180792999917, 61.45937734600005],
              [-6.681385870999918, 61.45799388200004],
              [-6.68382727799991, 61.454291083000044],
              [-6.688303188999953, 61.44432200700004],
              [-6.66624915299991, 61.43984609600005],
              [-6.651234503999945, 61.42523834800005],
              [-6.646351691999939, 61.40814850500004],
              [-6.654774542999917, 61.39594147300005],
            ],
          ],
          [
            [
              [-6.612538214999915, 61.82111237200007],
              [-6.626454230999911, 61.81049225500004],
              [-6.633168097999942, 61.80369700700004],
              [-6.629872199999909, 61.80060455900008],
              [-6.627674933999913, 61.79531484600005],
              [-6.629872199999909, 61.76654694200005],
              [-6.634632941999939, 61.763332424000055],
              [-6.641916469999956, 61.756293036000045],
              [-6.65103105399993, 61.749253648000035],
              [-6.660959438999953, 61.74603913000004],
              [-6.668039516999954, 61.74884674700007],
              [-6.733225063999953, 61.81391022300005],
              [-6.746652798999946, 61.82111237200007],
              [-6.838286912999934, 61.829006252000056],
              [-6.854359503999945, 61.83222077000005],
              [-6.867665167999917, 61.83934153900003],
              [-6.87328040299991, 61.85211823100008],
              [-6.877552863999938, 61.869574286000045],
              [-6.89907792899993, 61.893866278000075],
              [-6.907338019999941, 61.909857489000046],
              [-6.884266730999911, 61.907863674000055],
              [-6.841867641999954, 61.898871161000045],
              [-6.821685350999928, 61.89687734600005],
              [-6.78970292899993, 61.89940013200004],
              [-6.77765865799995, 61.89687734600005],
              [-6.76821855399993, 61.891791083000044],
              [-6.754058397999927, 61.87982819200005],
              [-6.742909308999913, 61.87641022300005],
              [-6.666859503999945, 61.86603424700007],
              [-6.654774542999917, 61.85895416900007],
              [-6.648182745999918, 61.84479401200008],
              [-6.619211391999954, 61.83087799700007],
              [-6.612538214999915, 61.82111237200007],
            ],
          ],
          [
            [
              [-7.383697068999936, 62.09487539300005],
              [-7.410755988999938, 62.10569896000004],
              [-7.429554816999939, 62.12848541900007],
              [-7.431548631999931, 62.14817942900004],
              [-7.407622850999928, 62.150091864000046],
              [-7.372059699999909, 62.13296133000006],
              [-7.359852667999917, 62.12958405200004],
              [-7.352406378999945, 62.12885163000004],
              [-7.329172329999949, 62.12958405200004],
              [-7.321359829999949, 62.131740627000056],
              [-7.318837042999917, 62.136419989000046],
              [-7.318023240999935, 62.14109935100004],
              [-7.315174933999913, 62.14325592700004],
              [-7.303618943999936, 62.14549388200004],
              [-7.286122199999909, 62.15525950700004],
              [-7.215891079999949, 62.163763739000046],
              [-7.215891079999949, 62.157538153000075],
              [-7.222645636999914, 62.157538153000075],
              [-7.222645636999914, 62.150091864000046],
              [-7.18390865799995, 62.13743724200003],
              [-7.171131964999915, 62.13580963700008],
              [-7.160145636999914, 62.13255442900004],
              [-7.144154425999943, 62.11615631700005],
              [-7.133900519999941, 62.10911692900004],
              [-7.109038865999935, 62.10492584800005],
              [-7.082630988999938, 62.10569896000004],
              [-7.057972785999937, 62.103176174000055],
              [-7.038319464999915, 62.08860911700003],
              [-7.050689256999931, 62.075832424000055],
              [-7.059803839999915, 62.06289297100005],
              [-7.071848110999952, 62.05255768400008],
              [-7.093006964999915, 62.04767487200007],
              [-7.110910610999952, 62.04930247600004],
              [-7.12726803299995, 62.05304596600007],
              [-7.143544074999909, 62.054022528000075],
              [-7.161203579999949, 62.04767487200007],
              [-7.153228318999936, 62.044134833000044],
              [-7.145008917999917, 62.04169342700004],
              [-7.136138475999928, 62.04047272300005],
              [-7.126454230999911, 62.040228583000044],
              [-7.184885219999956, 62.026556708000044],
              [-7.202137824999909, 62.01972077000005],
              [-7.19359290299991, 62.030585028000075],
              [-7.189116990999935, 62.03400299700007],
              [-7.196034308999913, 62.04791901200008],
              [-7.207427537999934, 62.060207424000055],
              [-7.221424933999913, 62.06622955900008],
              [-7.236317511999914, 62.06134674700007],
              [-7.228016730999911, 62.05805084800005],
              [-7.215687628999945, 62.05117422100005],
              [-7.206613735999952, 62.04254791900007],
              [-7.208404100999928, 62.03400299700007],
              [-7.21898352799991, 62.032863674000055],
              [-7.263579881999931, 62.04767487200007],
              [-7.325754360999952, 62.053900458000044],
              [-7.366200324999909, 62.06745026200008],
              [-7.380279100999928, 62.06818268400008],
              [-7.380279100999928, 62.07493724200003],
              [-7.284820115999935, 62.07493724200003],
              [-7.307118292999917, 62.083197333000044],
              [-7.332834438999953, 62.089504299000055],
              [-7.383697068999936, 62.09487539300005],
            ],
          ],
          [
            [
              [-7.222645636999914, 62.17059967700004],
              [-7.232085740999935, 62.17641836100006],
              [-7.235218878999945, 62.18016185100004],
              [-7.236317511999914, 62.18764883000006],
              [-7.233957485999952, 62.19839101800005],
              [-7.228260870999918, 62.20111725500004],
              [-7.221587693999936, 62.20140208500004],
              [-7.215891079999949, 62.204738674000055],
              [-7.210357225999928, 62.218451239000046],
              [-7.209462042999917, 62.22870514500005],
              [-7.205067511999914, 62.235663153000075],
              [-7.189116990999935, 62.239447333000044],
              [-7.208159959999932, 62.25421784100007],
              [-7.208119269999941, 62.27521393400008],
              [-7.195423956999946, 62.31460195500006],
              [-7.190256313999953, 62.309800523000035],
              [-7.185617641999954, 62.30882396000004],
              [-7.180816209999932, 62.30914948100008],
              [-7.174956834999932, 62.30776601800005],
              [-7.106434699999909, 62.300034898000035],
              [-7.072621222999942, 62.290269273000035],
              [-7.058216925999943, 62.276678778000075],
              [-7.045480923999946, 62.252386786000045],
              [-6.997222459999932, 62.20718008000006],
              [-6.997385219999956, 62.18423086100006],
              [-6.963775193999936, 62.178900458000044],
              [-6.906605597999942, 62.155462958000044],
              [-6.856068488999938, 62.14789459800005],
              [-6.847320115999935, 62.14203522300005],
              [-6.84634355399993, 62.13336823100008],
              [-6.852691209999932, 62.122748114000046],
              [-6.862212693999936, 62.11542389500005],
              [-6.875477667999917, 62.10895416900007],
              [-6.88931230399993, 62.10431549700007],
              [-6.900502081999946, 62.10228099200003],
              [-6.812977667999917, 62.10423411700003],
              [-6.798085089999915, 62.09174225500004],
              [-6.784087693999936, 62.07672760600008],
              [-6.779367641999954, 62.066107489000046],
              [-6.787587042999917, 62.06134674700007],
              [-6.84593665299991, 62.06134674700007],
              [-6.84593665299991, 62.053900458000044],
              [-6.810536261999914, 62.04633209800005],
              [-6.742909308999913, 62.04710521000004],
              [-6.715565558999913, 62.03400299700007],
              [-6.726144985999952, 62.02171458500004],
              [-6.734038865999935, 62.00535716400003],
              [-6.731922980999911, 61.991115627000056],
              [-6.698841925999943, 61.982082424000055],
              [-6.700754360999952, 61.97370026200008],
              [-6.705881313999953, 61.96076080900008],
              [-6.701893683999913, 61.94403717700004],
              [-6.734486456999946, 61.93821849200003],
              [-6.765004035999937, 61.95368073100008],
              [-6.793853318999936, 61.97451406500005],
              [-6.856922980999911, 61.99477773600006],
              [-6.910145636999914, 62.03790924700007],
              [-6.94554602799991, 62.04767487200007],
              [-6.959828253999945, 62.049994208000044],
              [-6.969146287999934, 62.05695221600007],
              [-6.974110480999911, 62.06858958500004],
              [-6.975697394999941, 62.08490631700005],
              [-6.982167120999918, 62.09406159100007],
              [-6.997670050999943, 62.10374583500004],
              [-7.016021287999934, 62.11188385600008],
              [-7.030873175999943, 62.11660390800006],
              [-7.109445766999954, 62.122748114000046],
              [-7.126942511999914, 62.12714264500005],
              [-7.137115037999934, 62.13666413000004],
              [-7.136138475999928, 62.146144924000055],
              [-7.120228644999941, 62.150091864000046],
              [-7.128814256999931, 62.16205475500004],
              [-7.142486131999931, 62.16079336100006],
              [-7.158558722999942, 62.15412018400008],
              [-7.174956834999932, 62.150091864000046],
              [-7.185617641999954, 62.152411200000074],
              [-7.213693813999953, 62.16474030200004],
              [-7.222645636999914, 62.17059967700004],
            ],
          ],
          [
            [
              [-7.055083787999934, 62.290350653000075],
              [-7.063588019999941, 62.29637278900003],
              [-7.075021938999953, 62.301947333000044],
              [-7.084055141999954, 62.30776601800005],
              [-7.085560675999943, 62.31460195500006],
              [-7.077137824999909, 62.321600653000075],
              [-7.06663977799991, 62.32050202000005],
              [-7.055246548999946, 62.316392320000034],
              [-7.044585740999935, 62.31460195500006],
              [-7.022857225999928, 62.31899648600006],
              [-6.986439581999946, 62.33226146000004],
              [-6.940663214999915, 62.33698151200008],
              [-6.928456183999913, 62.33502838700008],
              [-6.918120897999927, 62.33104075700004],
              [-6.909331834999932, 62.326239325000074],
              [-6.899973110999952, 62.32241445500006],
              [-6.887521938999953, 62.32143789300005],
              [-6.883208787999934, 62.31122467700004],
              [-6.90070553299995, 62.30414459800005],
              [-6.923410610999952, 62.29791901200008],
              [-6.934641079999949, 62.290350653000075],
              [-6.93423417899993, 62.27358633000006],
              [-6.931304490999935, 62.26007721600007],
              [-6.923207160999937, 62.24900950700004],
              [-6.907338019999941, 62.239447333000044],
              [-6.917388475999928, 62.26992422100005],
              [-6.912953253999945, 62.28180573100008],
              [-6.838490363999938, 62.294175523000035],
              [-6.813832160999937, 62.293402411000045],
              [-6.798085089999915, 62.280462958000044],
              [-6.805978969999956, 62.27948639500005],
              [-6.824777798999946, 62.27301666900007],
              [-6.746652798999946, 62.266791083000044],
              [-6.737131313999953, 62.26211172100005],
              [-6.745432094999956, 62.252020575000074],
              [-6.763498501999948, 62.24241771000004],
              [-6.78384355399993, 62.239447333000044],
              [-6.78384355399993, 62.23200104400007],
              [-6.772287563999953, 62.230169989000046],
              [-6.753325975999928, 62.22109609600005],
              [-6.742909308999913, 62.218410549000055],
              [-6.734730597999942, 62.219183661000045],
              [-6.715728318999936, 62.22455475500004],
              [-6.705637173999946, 62.225816148000035],
              [-6.650949673999946, 62.21625397300005],
              [-6.608631964999915, 62.202378648000035],
              [-6.605539516999954, 62.19599030200004],
              [-6.618763800999943, 62.192287502000056],
              [-6.643950975999928, 62.191066799000055],
              [-6.703968878999945, 62.19513580900008],
              [-6.722401495999918, 62.191066799000055],
              [-6.722401495999918, 62.18423086100006],
              [-6.600087042999917, 62.15338776200008],
              [-6.564116990999935, 62.13580963700008],
              [-6.616200324999909, 62.13914622600004],
              [-6.667795376999948, 62.150091864000046],
              [-6.667795376999948, 62.14325592700004],
              [-6.645822719999956, 62.14101797100005],
              [-6.625477667999917, 62.13344961100006],
              [-6.59203040299991, 62.11660390800006],
              [-6.59203040299991, 62.10911692900004],
              [-6.610096808999913, 62.11041901200008],
              [-6.630686001999948, 62.109076239000046],
              [-6.649159308999913, 62.10419342700004],
              [-6.660959438999953, 62.09487539300005],
              [-6.656605597999942, 62.092962958000044],
              [-6.652251756999931, 62.09003327000005],
              [-6.647328253999945, 62.08860911700003],
              [-6.647328253999945, 62.081244208000044],
              [-6.655751105999911, 62.077053127000056],
              [-6.659535285999937, 62.07294342700004],
              [-6.659087693999936, 62.068060614000046],
              [-6.654774542999917, 62.06134674700007],
              [-6.691395636999914, 62.07339101800005],
              [-6.701242641999954, 62.094183661000045],
              [-6.701527472999942, 62.119126695000034],
              [-6.709380662999934, 62.14325592700004],
              [-6.72679602799991, 62.16128164300005],
              [-6.753570115999935, 62.181708075000074],
              [-6.78384355399993, 62.19481028900003],
              [-6.811838344999956, 62.191066799000055],
              [-6.788400844999956, 62.17804596600007],
              [-6.758656378999945, 62.16559479400007],
              [-6.733021613999938, 62.14883047100005],
              [-6.722401495999918, 62.122748114000046],
              [-6.740305141999954, 62.10114166900007],
              [-6.780873175999943, 62.11668528900003],
              [-6.85960852799991, 62.163763739000046],
              [-6.900257941999939, 62.162543036000045],
              [-6.910755988999938, 62.167181708000044],
              [-6.916981574999909, 62.171576239000046],
              [-6.937977667999917, 62.18211497600004],
              [-6.94554602799991, 62.18423086100006],
              [-6.957508917999917, 62.18960195500006],
              [-7.020334438999953, 62.23969147300005],
              [-7.055083787999934, 62.290350653000075],
            ],
          ],
          [
            [
              [-6.537464972999942, 62.191066799000055],
              [-6.571278449999909, 62.213324286000045],
              [-6.582753058999913, 62.228583075000074],
              [-6.57835852799991, 62.24567291900007],
              [-6.571359829999949, 62.25177643400008],
              [-6.567494269999941, 62.25112539300005],
              [-6.564808722999942, 62.247707424000055],
              [-6.561024542999917, 62.24567291900007],
              [-6.553089972999942, 62.24701569200005],
              [-6.551503058999913, 62.250881252000056],
              [-6.55142167899993, 62.25649648600006],
              [-6.547963019999941, 62.263373114000046],
              [-6.546009894999941, 62.27195872600004],
              [-6.548898891999954, 62.29950592700004],
              [-6.55109615799995, 62.30776601800005],
              [-6.563303188999953, 62.32831452000005],
              [-6.571685350999928, 62.34674713700008],
              [-6.566517706999946, 62.36127350500004],
              [-6.537464972999942, 62.36981842700004],
              [-6.544911261999914, 62.36237213700008],
              [-6.516916469999956, 62.32306549700007],
              [-6.48273678299995, 62.29511139500005],
              [-6.440174933999913, 62.27513255400004],
              [-6.386586066999939, 62.25995514500005],
              [-6.405262824999909, 62.24461497600004],
              [-6.436512824999909, 62.24237702000005],
              [-6.468576626999948, 62.248928127000056],
              [-6.489654100999928, 62.25995514500005],
              [-6.496490037999934, 62.25250885600008],
              [-6.459339972999942, 62.22809479400007],
              [-6.439849412999934, 62.22011953300006],
              [-6.420765753999945, 62.225816148000035],
              [-6.417795376999948, 62.208319403000075],
              [-6.41429602799991, 62.20258209800005],
              [-6.407093878999945, 62.19782135600008],
              [-6.407093878999945, 62.191066799000055],
              [-6.423817511999914, 62.18549225500004],
              [-6.444162563999953, 62.18309153900003],
              [-6.463856574999909, 62.185532945000034],
              [-6.479074673999946, 62.19448476800005],
              [-6.506459113999938, 62.22174713700008],
              [-6.52212480399993, 62.22955963700008],
              [-6.537464972999942, 62.225816148000035],
              [-6.516021287999934, 62.19179922100005],
              [-6.506988084999932, 62.18109772300005],
              [-6.503163214999915, 62.17405833500004],
              [-6.509917772999927, 62.173814195000034],
              [-6.519398566999939, 62.17641836100006],
              [-6.529367641999954, 62.18060944200005],
              [-6.532093878999945, 62.18390534100007],
              [-6.534087693999936, 62.187567450000074],
              [-6.537464972999942, 62.191066799000055],
            ],
          ],
          [
            [
              [-7.559722459999932, 62.10773346600007],
              [-7.546009894999941, 62.10179271000004],
              [-7.536732550999943, 62.09878164300005],
              [-7.546254035999937, 62.096991278000075],
              [-7.558705206999946, 62.096136786000045],
              [-7.640695766999954, 62.09983958500004],
              [-7.644154425999943, 62.10700104400007],
              [-7.617258266999954, 62.114447333000044],
              [-7.588042772999927, 62.11513906500005],
              [-7.559722459999932, 62.10773346600007],
            ],
          ],
          [
            [
              [-6.321441209999932, 62.30809153900003],
              [-6.29133053299995, 62.30768463700008],
              [-6.275786912999934, 62.302720445000034],
              [-6.276844855999911, 62.29629140800006],
              [-6.306141730999911, 62.28180573100008],
              [-6.299549933999913, 62.271551825000074],
              [-6.299427863999938, 62.26227448100008],
              [-6.304107225999928, 62.25600820500006],
              [-6.31314042899993, 62.25079987200007],
              [-6.326079881999931, 62.24713776200008],
              [-6.341867641999954, 62.24433014500005],
              [-6.358509894999941, 62.24583567900004],
              [-6.370350714999915, 62.255926825000074],
              [-6.380726691999939, 62.26911041900007],
              [-6.384348110999952, 62.28021881700005],
              [-6.372466600999928, 62.287990627000056],
              [-6.355620897999927, 62.291896877000056],
              [-6.321441209999932, 62.30809153900003],
            ],
          ],
          [
            [
              [-6.585275844999956, 62.28986237200007],
              [-6.58071855399993, 62.28156159100007],
              [-6.579701300999943, 62.266791083000044],
              [-6.594471808999913, 62.26117584800005],
              [-6.616200324999909, 62.26630280200004],
              [-6.636382615999935, 62.28009674700007],
              [-6.646311001999948, 62.28961823100008],
              [-6.673329230999911, 62.32103099200003],
              [-6.684315558999913, 62.34406159100007],
              [-6.680816209999932, 62.366115627000056],
              [-6.66429602799991, 62.374212958000044],
              [-6.648060675999943, 62.366522528000075],
              [-6.639271613999938, 62.351996161000045],
              [-6.596262173999946, 62.304754950000074],
              [-6.585275844999956, 62.28986237200007],
            ],
          ],
          [
            [
              [-6.654693162999934, 62.26406484600005],
              [-6.648182745999918, 62.259833075000074],
              [-6.639149542999917, 62.24900950700004],
              [-6.643299933999913, 62.23851146000004],
              [-6.658599412999934, 62.23647695500006],
              [-6.676665818999936, 62.241400458000044],
              [-6.691029425999943, 62.25226471600007],
              [-6.698963995999918, 62.268459377000056],
              [-6.708973761999914, 62.283270575000074],
              [-6.716053839999915, 62.28961823100008],
              [-6.735829230999911, 62.30414459800005],
              [-6.762277798999946, 62.32770416900007],
              [-6.769439256999931, 62.336004950000074],
              [-6.787220831999946, 62.36127350500004],
              [-6.789051886999914, 62.37531159100007],
              [-6.779123501999948, 62.37958405200004],
              [-6.765288865999935, 62.37372467700004],
              [-6.751942511999914, 62.36212799700007],
              [-6.724354620999918, 62.32884349200003],
              [-6.654693162999934, 62.26406484600005],
            ],
          ],
          [
            [
              [-6.409169074999909, 62.32404205900008],
              [-6.401519334999932, 62.320013739000046],
              [-6.394602016999954, 62.309881903000075],
              [-6.399403449999909, 62.30109284100007],
              [-6.405913865999935, 62.294256903000075],
              [-6.423695441999939, 62.290350653000075],
              [-6.45571855399993, 62.29596588700008],
              [-6.485463019999941, 62.31000397300005],
              [-6.509266730999911, 62.329779364000046],
              [-6.52407792899993, 62.34650299700007],
              [-6.53343665299991, 62.37189362200007],
              [-6.546294725999928, 62.378119208000044],
              [-6.555897589999915, 62.39093659100007],
              [-6.542551235999952, 62.39891185100004],
              [-6.519032355999911, 62.39533112200007],
              [-6.504628058999913, 62.387600002000056],
              [-6.494740363999938, 62.37494538000004],
              [-6.487049933999913, 62.36033763200004],
              [-6.474761522999927, 62.34935130400004],
              [-6.460438605999911, 62.339829820000034],
              [-6.454701300999943, 62.33104075700004],
              [-6.454823370999918, 62.324204820000034],
              [-6.449126756999931, 62.31781647300005],
              [-6.438465949999909, 62.31907786700003],
              [-6.427479620999918, 62.325873114000046],
              [-6.415516730999911, 62.326239325000074],
              [-6.409169074999909, 62.32404205900008],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Papua New Guinea',
        iso3: 'PNG',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [140.97445722700002, -2.600518487999921],
              [140.9873153000001, -2.599786065999922],
              [141.0078231130001, -2.608168226999908],
              [141.0429793630001, -2.589776299999926],
              [141.08130944100003, -2.594333591999941],
              [141.121429884, -2.607517184999949],
              [141.16228274800005, -2.615004164999959],
              [141.1933699880001, -2.615004164999959],
              [141.20582116000003, -2.619561455999929],
              [141.214203321, -2.625095309999949],
              [141.2207137380001, -2.630629164999959],
              [141.2275496750001, -2.634942315999922],
              [141.23902428500003, -2.637465101999908],
              [141.2646590500001, -2.638604424999926],
              [141.2758895190001, -2.642347914999959],
              [141.28052819100003, -2.648614190999922],
              [141.29086347700002, -2.669691664999959],
              [141.296234571, -2.676446221999925],
              [141.309418165, -2.671319268999923],
              [141.338226759, -2.701836846999925],
              [141.36085045700008, -2.71062590899993],
              [141.38233483200008, -2.713555596999925],
              [141.5761824880001, -2.794040622999944],
              [141.8012801440001, -2.90007903399993],
              [141.83277428500003, -2.90593840899993],
              [141.83611087300005, -2.91334400799991],
              [141.8364363940001, -2.923272393999923],
              [141.840668165, -2.933200778999947],
              [141.88542728000004, -2.963799737999921],
              [141.90552819100003, -2.967217705999929],
              [141.94304446700005, -2.960137627999927],
              [142.0000106130001, -2.955987237999921],
              [142.01042728000004, -2.960381768999923],
              [142.0649520190001, -3.008965752999927],
              [142.0703231130001, -3.018487237999921],
              [142.06812584700003, -3.02703215899993],
              [142.0634871750001, -3.038262627999927],
              [142.06031334700003, -3.049981377999927],
              [142.062836134, -3.060153903999947],
              [142.069672071, -3.062107028999947],
              [142.09522545700008, -3.06414153399993],
              [142.1045028000001, -3.066989841999941],
              [142.13746178500003, -3.055596612999921],
              [142.15935306100005, -3.066013278999947],
              [142.18189537900003, -3.080173434999949],
              [142.20386803500003, -3.087497653999947],
              [142.2265731130001, -3.089450778999947],
              [142.241547071, -3.094414971999925],
              [142.2695418630001, -3.107842705999929],
              [142.39470462300005, -3.144463799999926],
              [142.5019637380001, -3.196058851999908],
              [142.615570509, -3.231052341999941],
              [142.81226647200003, -3.290948174999926],
              [142.8344832690001, -3.293389580999929],
              [142.84595787900003, -3.29615650799991],
              [142.87916100400003, -3.313897393999923],
              [142.89226321700005, -3.31568775799991],
              [142.90650475400003, -3.31609465899993],
              [142.9199324880001, -3.31804778399993],
              [142.94898522200003, -3.335056247999944],
              [143.0293074880001, -3.355564059999949],
              [143.05193118600005, -3.356052341999941],
              [143.08513431100005, -3.353122653999947],
              [143.102386915, -3.351657809999949],
              [143.11866295700008, -3.355564059999949],
              [143.1254988940001, -3.348077080999929],
              [143.14226321700005, -3.354913018999923],
              [143.21119225400003, -3.361748955999929],
              [143.2207137380001, -3.36492278399993],
              [143.23951256600003, -3.379082940999922],
              [143.25220787900003, -3.382256768999923],
              [143.26441491000003, -3.382989190999922],
              [143.477875196, -3.420586846999925],
              [143.52295983200008, -3.435967705999929],
              [143.540375196, -3.447686455999929],
              [143.59791100400003, -3.505059502999927],
              [143.6079207690001, -3.532972914999959],
              [143.61207116000003, -3.539808851999908],
              [143.61866295700008, -3.544854424999926],
              [143.63445071700005, -3.551446221999925],
              [143.6425887380001, -3.556573174999926],
              [143.6508895190001, -3.560723565999922],
              [143.68043053500003, -3.570245049999926],
              [143.68433678500003, -3.574314059999949],
              [143.69320722700002, -3.570082289999959],
              [143.70777428500003, -3.559747002999927],
              [143.71355228000004, -3.559991143999923],
              [143.72022545700008, -3.562269789999959],
              [143.72234134200005, -3.568536065999922],
              [143.71461022200003, -3.580824476999908],
              [143.72388756600003, -3.59343840899993],
              [143.73422285200002, -3.602146091999941],
              [143.74781334700003, -3.607191664999959],
              [143.78345787900003, -3.610039971999925],
              [143.80250084700003, -3.614353122999944],
              [143.81804446700005, -3.621677341999941],
              [143.85515384200005, -3.680108330999929],
              [143.8676863940001, -3.68914153399993],
              [143.90894616000003, -3.707696221999925],
              [143.92367597700002, -3.711195570999905],
              [143.94711347700002, -3.72234465899993],
              [143.99586022200003, -3.793145440999922],
              [144.0214949880001, -3.802992445999905],
              [144.0546981130001, -3.804945570999905],
              [144.11988366000003, -3.800551039999959],
              [144.13038170700008, -3.80201588299991],
              [144.14185631600003, -3.800225518999923],
              [144.1670028000001, -3.800551039999959],
              [144.1587020190001, -3.808770440999922],
              [144.14909915500004, -3.813653252999927],
              [144.13795006600003, -3.815362237999921],
              [144.12614993600005, -3.81414153399993],
              [144.1337996750001, -3.825941664999959],
              [144.14283287900003, -3.831963799999926],
              [144.15259850400003, -3.836602471999925],
              [144.16334069100003, -3.844659112999921],
              [144.17888431100005, -3.85125090899993],
              [144.2036238940001, -3.837823174999926],
              [144.21827233200008, -3.844659112999921],
              [144.22584069100003, -3.859144789999959],
              [144.230804884, -3.865980726999908],
              [144.2387801440001, -3.86882903399993],
              [144.24968509200005, -3.867852471999925],
              [144.25212649800005, -3.865166924999926],
              [144.25212649800005, -3.860935153999947],
              [144.2558699880001, -3.85515715899993],
              [144.26539147200003, -3.844821872999944],
              [144.27418053500003, -3.831149997999944],
              [144.27881920700008, -3.817559502999927],
              [144.27621504, -3.807305596999925],
              [144.309906446, -3.798435153999947],
              [144.35499108200008, -3.798028252999927],
              [144.40007571700005, -3.80396900799991],
              [144.43384850400003, -3.81414153399993],
              [144.44695071700005, -3.81178150799991],
              [144.49870853000004, -3.813897393999923],
              [144.51343834700003, -3.817559502999927],
              [144.52702884200005, -3.831231377999927],
              [144.538422071, -3.846286716999941],
              [144.5468856130001, -3.863213799999926],
              [144.5512801440001, -3.883070570999905],
              [144.5512801440001, -3.96843840899993],
              [144.55779056100005, -3.979424737999921],
              [144.57292728000004, -3.990980726999908],
              [144.58171634200005, -3.99578215899993],
              [144.59107506600003, -4.000746351999908],
              [144.605804884, -4.006605726999908],
              [144.73031660200002, -4.026055596999925],
              [144.76970462300005, -4.04070403399993],
              [144.79607181100005, -4.06373463299991],
              [144.81364993600005, -4.07586028399993],
              [144.8437606130001, -4.084161065999922],
              [144.86784915500004, -4.099216403999947],
              [144.87281334700003, -4.104668877999927],
              [144.87387129, -4.107842705999929],
              [144.87614993600005, -4.109633070999905],
              [144.87859134200005, -4.112725518999923],
              [144.87956790500004, -4.118747653999947],
              [144.8769637380001, -4.125420830999929],
              [144.8642684250001, -4.130954684999949],
              [144.859711134, -4.136325778999947],
              [144.85922285200002, -4.148207289999959],
              [144.86500084700003, -4.161553643999923],
              [144.8774520190001, -4.172133070999905],
              [144.9218856130001, -4.180108330999929],
              [144.93921959700003, -4.189222914999959],
              [144.96900475400003, -4.218357028999947],
              [144.9912215500001, -4.232354424999926],
              [144.99626712300005, -4.238702080999929],
              [144.9961043630001, -4.274997653999947],
              [144.99968509200005, -4.280368747999944],
              [145.0141707690001, -4.288669528999947],
              [145.05095462300005, -4.341892184999949],
              [145.07781009200005, -4.356622002999927],
              [145.18132571700005, -4.390232028999947],
              [145.2212020190001, -4.389825127999927],
              [145.2641707690001, -4.379571221999925],
              [145.30689537900003, -4.37468840899993],
              [145.3457137380001, -4.390232028999947],
              [145.3867293630001, -4.441501559999949],
              [145.44809004, -4.492608330999929],
              [145.48414147200003, -4.534356377999927],
              [145.492523634, -4.549899997999944],
              [145.5136824880001, -4.578301690999922],
              [145.52320397200003, -4.584405205999929],
              [145.53150475400003, -4.584079684999949],
              [145.53858483200008, -4.581638278999947],
              [145.544281446, -4.581963799999926],
              [145.55982506600003, -4.59929778399993],
              [145.5810653000001, -4.646254164999959],
              [145.69019616000003, -4.768243096999925],
              [145.70573978000004, -4.781833591999941],
              [145.72445722700002, -4.789483330999929],
              [145.7402449880001, -4.799981377999927],
              [145.74366295700008, -4.804294528999947],
              [145.777679884, -4.81414153399993],
              [145.78663170700008, -4.82350025799991],
              [145.80144290500004, -4.842461846999925],
              [145.811859571, -4.86101653399993],
              [145.80884850400003, -4.869317315999922],
              [145.7973738940001, -4.878513278999947],
              [145.79029381600003, -4.899834893999923],
              [145.784515821, -4.945082289999959],
              [145.78541100400003, -4.968682549999926],
              [145.79566491000003, -5.009698174999926],
              [145.798187696, -5.030043226999908],
              [145.80046634200005, -5.035821221999925],
              [145.80974368600005, -5.049574476999908],
              [145.811859571, -5.058038018999923],
              [145.81080162900003, -5.066501559999949],
              [145.80347741000003, -5.077894789999959],
              [145.798187696, -5.089043877999927],
              [145.79900149800005, -5.091729424999926],
              [145.79656009200005, -5.127536716999941],
              [145.79224694100003, -5.14967213299991],
              [145.79127037900003, -5.160088799999926],
              [145.79273522200003, -5.202569268999923],
              [145.7910262380001, -5.220879815999922],
              [145.784515821, -5.239353122999944],
              [145.74878991000003, -5.289727471999925],
              [145.74366295700008, -5.311293226999908],
              [145.74480228000004, -5.319431247999944],
              [145.749359571, -5.334649346999925],
              [145.750336134, -5.345798434999949],
              [145.74789472700002, -5.358168226999908],
              [145.72999108200008, -5.390232028999947],
              [145.727386915, -5.422458591999941],
              [145.73845462300005, -5.453708591999941],
              [145.75961347700002, -5.476983330999929],
              [145.78785241000003, -5.486423434999949],
              [145.848480665, -5.475762627999927],
              [145.872406446, -5.48211028399993],
              [145.88697350400003, -5.513604424999926],
              [145.89380944100003, -5.513604424999926],
              [145.89527428500003, -5.506524346999925],
              [145.89958743600005, -5.494073174999926],
              [145.90064537900003, -5.486423434999949],
              [145.90748131600003, -5.488702080999929],
              [145.91041100400003, -5.490166924999926],
              [145.91431725400003, -5.493096612999921],
              [145.92644290500004, -5.478936455999929],
              [145.94117272200003, -5.476006768999923],
              [145.95630944100003, -5.474704684999949],
              [145.96949303500003, -5.465264580999929],
              [145.98715254, -5.483086846999925],
              [146.00416100400003, -5.489434502999927],
              [146.0224715500001, -5.494235934999949],
              [146.04468834700003, -5.506931247999944],
              [146.05225670700008, -5.500420830999929],
              [146.0571395190001, -5.499607028999947],
              [146.060883009, -5.502373955999929],
              [146.06519616000003, -5.506931247999944],
              [146.07593834700003, -5.506442966999941],
              [146.1098738940001, -5.521742445999905],
              [146.12720787900003, -5.527276299999926],
              [146.15162194100003, -5.52662525799991],
              [146.16325931100005, -5.529066664999959],
              [146.16822350400003, -5.537530205999929],
              [146.1728621750001, -5.549493096999925],
              [146.1840926440001, -5.553155205999929],
              [146.20915774800005, -5.554620049999926],
              [146.22828209700003, -5.563653252999927],
              [146.23902428500003, -5.566989841999941],
              [146.25700931100005, -5.561944268999923],
              [146.2666121750001, -5.567966403999947],
              [146.27613366000003, -5.576918226999908],
              [146.28492272200003, -5.582614841999941],
              [146.2954207690001, -5.582777601999908],
              [146.31617272200003, -5.576755466999941],
              [146.329437696, -5.575127862999921],
              [146.34131920700008, -5.575372002999927],
              [146.348968946, -5.577243747999944],
              [146.36744225400003, -5.588799737999921],
              [146.37427819100003, -5.59343840899993],
              [146.38298587300005, -5.600762627999927],
              [146.39380944100003, -5.604099216999941],
              [146.407074415, -5.602959893999923],
              [146.4008895190001, -5.602959893999923],
              [146.4228621750001, -5.60279713299991],
              [146.4423934250001, -5.598809502999927],
              [146.4609481130001, -5.59929778399993],
              [146.47974694100003, -5.61296965899993],
              [146.484711134, -5.622491143999923],
              [146.48853600400003, -5.632419528999947],
              [146.49488366000003, -5.640232028999947],
              [146.518890821, -5.645440362999921],
              [146.53077233200008, -5.650648695999905],
              [146.656586134, -5.749118747999944],
              [146.722992384, -5.76685963299991],
              [146.757172071, -5.787367445999905],
              [146.77995853000004, -5.792413018999923],
              [146.788422071, -5.797784112999921],
              [146.7933862640001, -5.816176039999959],
              [146.79802493600005, -5.833591403999947],
              [146.81275475400003, -5.838555596999925],
              [146.83082116000003, -5.834079684999949],
              [146.84652754, -5.828301690999922],
              [146.869476759, -5.825127862999921],
              [146.887054884, -5.828220309999949],
              [146.9023543630001, -5.833184502999927],
              [146.91822350400003, -5.835707289999959],
              [146.93287194100003, -5.841973565999922],
              [146.94092858200008, -5.856866143999923],
              [146.94711347700002, -5.874932549999926],
              [146.95582116000003, -5.890394789999959],
              [147.0078231130001, -5.924493096999925],
              [147.01579837300005, -5.92546965899993],
              [147.0258895190001, -5.927829684999949],
              [147.03467858200008, -5.931247653999947],
              [147.04224694100003, -5.938653252999927],
              [147.05103600400003, -5.934665622999944],
              [147.06511478000004, -5.924493096999925],
              [147.07601972700002, -5.924004815999922],
              [147.08228600400003, -5.926039320999905],
              [147.09351647200003, -5.938164971999925],
              [147.10661868600005, -5.959161065999922],
              [147.11646569100003, -5.969008070999905],
              [147.12086022200003, -5.962497653999947],
              [147.1328231130001, -5.957696221999925],
              [147.2251082690001, -5.968845309999949],
              [147.2343856130001, -5.968845309999949],
              [147.24382571700005, -5.96607838299991],
              [147.25562584700003, -5.957207940999922],
              [147.26490319100003, -5.945570570999905],
              [147.27491295700008, -5.935642184999949],
              [147.2890731130001, -5.93132903399993],
              [147.2978621750001, -5.933526299999926],
              [147.32292728000004, -5.94500090899993],
              [147.32960045700008, -5.944512627999927],
              [147.33179772200003, -5.942803643999923],
              [147.3330184250001, -5.939629815999922],
              [147.33659915500004, -5.934747002999927],
              [147.34359785200002, -5.930759372999944],
              [147.348480665, -5.932305596999925],
              [147.35368899800005, -5.938164971999925],
              [147.40308678500003, -5.955824476999908],
              [147.44906660200002, -5.961602471999925],
              [147.46656334700003, -5.969414971999925],
              [147.48015384200005, -5.980238539999959],
              [147.49146569100003, -5.992852471999925],
              [147.495453321, -5.994886976999908],
              [147.50733483200008, -5.997653903999947],
              [147.51140384200005, -6.000258070999905],
              [147.5136824880001, -6.00554778399993],
              [147.51539147200003, -6.015883070999905],
              [147.5175887380001, -6.02076588299991],
              [147.5244246750001, -6.027601820999905],
              [147.551605665, -6.040622653999947],
              [147.62175540500004, -6.106622002999927],
              [147.6484481130001, -6.15398528399993],
              [147.65845787900003, -6.164727471999925],
              [147.67465254, -6.174248955999929],
              [147.68433678500003, -6.196872653999947],
              [147.69214928500003, -6.223809502999927],
              [147.7031356130001, -6.239353122999944],
              [147.72624759200005, -6.272230726999908],
              [147.8007918630001, -6.309747002999927],
              [147.8266707690001, -6.335381768999923],
              [147.83033287900003, -6.349216403999947],
              [147.82886803500003, -6.358330987999921],
              [147.82601972700002, -6.36646900799991],
              [147.8266707690001, -6.377618096999925],
              [147.83326256600003, -6.390557549999926],
              [147.84245853000004, -6.400648695999905],
              [147.85043379, -6.411879164999959],
              [147.85613040500004, -6.439711195999905],
              [147.86548912900003, -6.463148695999905],
              [147.867523634, -6.476332289999959],
              [147.8642684250001, -6.485121351999908],
              [147.8584090500001, -6.492364190999922],
              [147.85523522200003, -6.500746351999908],
              [147.860687696, -6.513604424999926],
              [147.849945509, -6.526788018999923],
              [147.85132897200003, -6.541599216999941],
              [147.85718834700003, -6.558526299999926],
              [147.860687696, -6.57935963299991],
              [147.85759524800005, -6.583916924999926],
              [147.84351647200003, -6.593194268999923],
              [147.8403426440001, -6.596123955999929],
              [147.84205162900003, -6.608493747999944],
              [147.84693444100003, -6.615166924999926],
              [147.8535262380001, -6.615899346999925],
              [147.860687696, -6.609795830999929],
              [147.8540145190001, -6.691013278999947],
              [147.77564537900003, -6.717868747999944],
              [147.6001082690001, -6.727146091999941],
              [147.59050540500004, -6.733086846999925],
              [147.57300866000003, -6.749200127999927],
              [147.56527754, -6.753838799999926],
              [147.55420983200008, -6.753350518999923],
              [147.54322350400003, -6.748793226999908],
              [147.53239993600005, -6.74578215899993],
              [147.52125084700003, -6.750420830999929],
              [147.50310306100005, -6.754978122999944],
              [147.43620853000004, -6.733330987999921],
              [147.41325931100005, -6.733493747999944],
              [147.3720809250001, -6.744235934999949],
              [147.3505965500001, -6.747002862999921],
              [147.19483483200008, -6.738539320999905],
              [147.18238366000003, -6.740166924999926],
              [147.1767684250001, -6.73015715899993],
              [147.169281446, -6.722426039999959],
              [147.15967858200008, -6.716729424999926],
              [147.14763431100005, -6.712823174999926],
              [147.13209069100003, -6.711032809999949],
              [147.08277428500003, -6.712823174999926],
              [147.0693465500001, -6.717054945999905],
              [147.04444420700008, -6.735935153999947],
              [147.0278426440001, -6.740166924999926],
              [146.99439537900003, -6.738702080999929],
              [146.97730553500003, -6.740411065999922],
              [146.96265709700003, -6.747002862999921],
              [146.96119225400003, -6.771091403999947],
              [146.94597415500004, -6.812920830999929],
              [146.94214928500003, -6.835707289999959],
              [146.94320722700002, -6.883884372999944],
              [146.949554884, -6.93132903399993],
              [146.95622806100005, -6.954685153999947],
              [146.98902428500003, -6.995049737999921],
              [147.01042728000004, -7.014418226999908],
              [147.020843946, -7.027520440999922],
              [147.02719160200002, -7.032321872999944],
              [147.03834069100003, -7.034926039999959],
              [147.046234571, -7.033298434999949],
              [147.0595809250001, -7.02076588299991],
              [147.07252037900003, -7.014418226999908],
              [147.07105553500003, -7.027927341999941],
              [147.06592858200008, -7.038262627999927],
              [147.0605574880001, -7.046970309999949],
              [147.05827884200005, -7.054864190999922],
              [147.06039472700002, -7.067315362999921],
              [147.0693465500001, -7.08367278399993],
              [147.07252037900003, -7.096368096999925],
              [147.07105553500003, -7.10906340899993],
              [147.063812696, -7.132745049999926],
              [147.06511478000004, -7.144789320999905],
              [147.06910241000003, -7.14617278399993],
              [147.12077884200005, -7.185967705999929],
              [147.13233483200008, -7.19850025799991],
              [147.14136803500003, -7.213067315999922],
              [147.144867384, -7.234144789999959],
              [147.14087975400003, -7.281426690999922],
              [147.14763431100005, -7.295017184999949],
              [147.15259850400003, -7.30592213299991],
              [147.1494246750001, -7.310642184999949],
              [147.143890821, -7.314629815999922],
              [147.14136803500003, -7.322930596999925],
              [147.1469832690001, -7.332614841999941],
              [147.15447024800005, -7.350274346999925],
              [147.1591903000001, -7.380791924999926],
              [147.16187584700003, -7.390557549999926],
              [147.178070509, -7.416273695999905],
              [147.18238366000003, -7.425388278999947],
              [147.188324415, -7.429620049999926],
              [147.19304446700005, -7.433689059999949],
              [147.19605553500003, -7.438409112999921],
              [147.19483483200008, -7.444105726999908],
              [147.1894637380001, -7.447198174999926],
              [147.18384850400003, -7.449151299999926],
              [147.18238366000003, -7.452080987999921],
              [147.1884871750001, -7.46257903399993],
              [147.19288170700008, -7.463148695999905],
              [147.19890384200005, -7.461683851999908],
              [147.20964603000004, -7.466403903999947],
              [147.21436608200008, -7.473728122999944],
              [147.21363366000003, -7.480075778999947],
              [147.21607506600003, -7.484633070999905],
              [147.23015384200005, -7.486911716999941],
              [147.23462975400003, -7.484144789999959],
              [147.25123131600003, -7.466403903999947],
              [147.25757897200003, -7.466403903999947],
              [147.26343834700003, -7.471286716999941],
              [147.2680770190001, -7.476332289999959],
              [147.268890821, -7.481622002999927],
              [147.26433353000004, -7.486911716999941],
              [147.3247176440001, -7.501397393999923],
              [147.3545028000001, -7.51531340899993],
              [147.36744225400003, -7.53834400799991],
              [147.37126712300005, -7.548597914999959],
              [147.380218946, -7.553643487999921],
              [147.39087975400003, -7.555596612999921],
              [147.3989363940001, -7.555759372999944],
              [147.41382897200003, -7.558200778999947],
              [147.42310631600003, -7.564629815999922],
              [147.43116295700008, -7.573174737999921],
              [147.44304446700005, -7.582452080999929],
              [147.43482506600003, -7.591566664999959],
              [147.44060306100005, -7.593926690999922],
              [147.45264733200008, -7.594170830999929],
              [147.4629012380001, -7.596774997999944],
              [147.4873153000001, -7.616306247999944],
              [147.49887129, -7.629001559999949],
              [147.5039168630001, -7.640801690999922],
              [147.503265821, -7.678317966999941],
              [147.51295006600003, -7.687595309999949],
              [147.56714928500003, -7.696058851999908],
              [147.58130944100003, -7.703708591999941],
              [147.5859481130001, -7.71843840899993],
              [147.5864363940001, -7.744073174999926],
              [147.59343509200005, -7.764825127999927],
              [147.60670006600003, -7.78093840899993],
              [147.61491946700005, -7.796644789999959],
              [147.60694420700008, -7.816501559999949],
              [147.6552840500001, -7.809665622999944],
              [147.6552840500001, -7.802178643999923],
              [147.64600670700008, -7.797946872999944],
              [147.63892662900003, -7.791110934999949],
              [147.63502037900003, -7.781345309999949],
              [147.6347762380001, -7.767998955999929],
              [147.66179446700005, -7.78875090899993],
              [147.68336022200003, -7.810723565999922],
              [147.6977645190001, -7.83953215899993],
              [147.70582116000003, -7.903903903999947],
              [147.7138778000001, -7.920586846999925],
              [147.72681725400003, -7.932061455999929],
              [147.7446395190001, -7.939222914999959],
              [147.76091556100005, -7.94068775799991],
              [147.79127037900003, -7.933689059999949],
              [147.8129988940001, -7.932549737999921],
              [147.81902103000004, -7.935804945999905],
              [147.82488040500004, -7.941501559999949],
              [147.83228600400003, -7.943536065999922],
              [147.8437606130001, -7.935804945999905],
              [147.85320071700005, -7.931817315999922],
              [147.86491946700005, -7.932793877999927],
              [147.87647545700008, -7.93718840899993],
              [147.92351321700005, -7.971449476999908],
              [147.94556725400003, -7.982598565999922],
              [147.9672957690001, -7.987074476999908],
              [147.974945509, -7.996677341999941],
              [147.977386915, -8.004082940999922],
              [147.9892684250001, -8.041436455999929],
              [147.9985457690001, -8.055352471999925],
              [148.0180770190001, -8.057712497999944],
              [148.03882897200003, -8.05282968499995],
              [148.05640709700003, -8.050957940999922],
              [148.06617272200003, -8.062758070999905],
              [148.0771590500001, -8.057061455999929],
              [148.08863366000003, -8.055759372999944],
              [148.11402428500003, -8.055352471999925],
              [148.11931399800005, -8.05201588299991],
              [148.13502037900003, -8.046075127999927],
              [148.14633222700002, -8.045668226999908],
              [148.13819420700008, -8.059177341999941],
              [148.137543165, -8.075372002999927],
              [148.1582137380001, -8.166273695999905],
              [148.1728621750001, -8.18922291499996],
              [148.1782332690001, -8.218194268999923],
              [148.19654381600003, -8.254652601999908],
              [148.20460045700008, -8.277601820999905],
              [148.21078535200002, -8.306084893999923],
              [148.2114363940001, -8.334567966999941],
              [148.20281009200005, -8.357598565999922],
              [148.23072350400003, -8.419122002999927],
              [148.23609459700003, -8.44150155999995],
              [148.23414147200003, -8.45907968499995],
              [148.22388756600003, -8.494805596999925],
              [148.22282962300005, -8.513604424999926],
              [148.2246199880001, -8.53484465899993],
              [148.2295028000001, -8.554620049999926],
              [148.23755944100003, -8.56926848799992],
              [148.25359134200005, -8.580824476999908],
              [148.28923587300005, -8.597832940999922],
              [148.29900149800005, -8.610935153999947],
              [148.32211347700002, -8.603448174999926],
              [148.3418074880001, -8.60914478999996],
              [148.35816491000003, -8.619317315999922],
              [148.37126712300005, -8.624607028999947],
              [148.37875410200002, -8.626560153999947],
              [148.38656660200002, -8.631931247999944],
              [148.39275149800005, -8.63958098799992],
              [148.39527428500003, -8.64853280999995],
              [148.400726759, -8.65520598799992],
              [148.43677819100003, -8.666192315999922],
              [148.4453231130001, -8.67473723799992],
              [148.45655358200008, -8.700290622999944],
              [148.4668074880001, -8.715101820999905],
              [148.48113040500004, -8.730645440999922],
              [148.4868270190001, -8.747247002999927],
              [148.48454837300005, -8.816338799999926],
              [148.49634850400003, -8.882989190999922],
              [148.5019637380001, -8.892022393999923],
              [148.51099694100003, -8.89348723799992],
              [148.51905358200008, -8.89739348799992],
              [148.52466881600003, -8.902764580999929],
              [148.526703321, -8.908868096999925],
              [148.52556399800005, -8.91529713299991],
              [148.5200301440001, -8.92473723799992],
              [148.51872806100005, -8.929620049999926],
              [148.52068118600005, -8.935479424999926],
              [148.529633009, -8.947198174999926],
              [148.53239993600005, -8.954196872999944],
              [148.54175866000003, -8.994317315999922],
              [148.55925540500004, -9.03248463299991],
              [148.58562259200005, -9.064060153999947],
              [148.6211043630001, -9.08375416499996],
              [148.707855665, -9.09937916499996],
              [148.7431746750001, -9.098239841999941],
              [148.7583113940001, -9.103692315999922],
              [148.76742597700002, -9.100030205999929],
              [148.80982506600003, -9.090020440999922],
              [148.82634524800005, -9.08912525799991],
              [148.83936608200008, -9.086521091999941],
              [148.85043379, -9.082207940999922],
              [148.87126712300005, -9.070245049999926],
              [148.88249759200005, -9.061618747999944],
              [148.8916121750001, -9.051039320999905],
              [148.895355665, -9.039483330999929],
              [148.903168165, -9.04265715899993],
              [148.92139733200008, -9.04420338299991],
              [148.94206790500004, -9.04265715899993],
              [148.9575301440001, -9.03606536299992],
              [148.97803795700008, -9.051446221999925],
              [149.005218946, -9.04973723799992],
              [149.06910241000003, -9.035088799999926],
              [149.07488040500004, -9.032810153999947],
              [149.07935631600003, -9.029473565999922],
              [149.0810653000001, -9.026055596999925],
              [149.08326256600003, -9.016371351999908],
              [149.08863366000003, -9.012790622999944],
              [149.09546959700003, -9.01148853999996],
              [149.1015731130001, -9.00872161299992],
              [149.11736087300005, -8.990655205999929],
              [149.12777754, -8.981540622999944],
              [149.14185631600003, -8.974541924999926],
              [149.15357506600003, -9.00359465899993],
              [149.24366295700008, -8.997165622999944],
              [149.26539147200003, -9.015557549999926],
              [149.27564537900003, -9.010023695999905],
              [149.28435306100005, -9.008477471999925],
              [149.290375196, -9.012302341999941],
              [149.29273522200003, -9.023044528999947],
              [149.29957116000003, -9.023044528999947],
              [149.30933678500003, -9.017022393999923],
              [149.31804446700005, -9.022556247999944],
              [149.32439212300005, -9.033949476999908],
              [149.32683353000004, -9.046075127999927],
              [149.32447350400003, -9.059991143999923],
              [149.3188582690001, -9.071384372999944],
              [149.30640709700003, -9.090020440999922],
              [149.31177819100003, -9.092868747999944],
              [149.31560306100005, -9.09539153399993],
              [149.32007897200003, -9.097100518999923],
              [149.32683353000004, -9.097588799999926],
              [149.31080162900003, -9.102959893999923],
              [149.30250084700003, -9.104099216999941],
              [149.29273522200003, -9.103692315999922],
              [149.3066512380001, -9.117445570999905],
              [149.3247176440001, -9.120212497999944],
              [149.337250196, -9.124932549999926],
              [149.33423912900003, -9.145277601999908],
              [149.32349694100003, -9.160577080999929],
              [149.3071395190001, -9.172621351999908],
              [149.28882897200003, -9.177911065999922],
              [149.27222741000003, -9.172621351999908],
              [149.2646590500001, -9.182224216999941],
              [149.24789472700002, -9.21217213299991],
              [149.24488366000003, -9.224216403999947],
              [149.2426863940001, -9.24578215899993],
              [149.2334090500001, -9.27906666499996],
              [149.23121178500003, -9.299493096999925],
              [149.2236434250001, -9.316013278999947],
              [149.1904403000001, -9.343926690999922],
              [149.18287194100003, -9.36809661299992],
              [149.18726647200003, -9.39072030999995],
              [149.206390821, -9.42937590899993],
              [149.21070397200003, -9.450778903999947],
              [149.2265731130001, -9.486748955999929],
              [149.26319420700008, -9.503513278999947],
              [149.33423912900003, -9.515801690999922],
              [149.36101321700005, -9.529473565999922],
              [149.36670983200008, -9.534356377999927],
              [149.37720787900003, -9.546075127999927],
              [149.38209069100003, -9.549981377999927],
              [149.3867293630001, -9.55087655999995],
              [149.39812259200005, -9.549086195999905],
              [149.40259850400003, -9.549981377999927],
              [149.41529381600003, -9.561944268999923],
              [149.41627037900003, -9.563653252999927],
              [149.45093834700003, -9.577325127999927],
              [149.4414168630001, -9.590508721999925],
              [149.45720462300005, -9.594170830999929],
              [149.461355014, -9.594089450999945],
              [149.5410262380001, -9.593194268999923],
              [149.56023196700005, -9.597100518999923],
              [149.61988366000003, -9.62086353999996],
              [149.63550866000003, -9.619398695999905],
              [149.65308678500003, -9.607679945999905],
              [149.66285241000003, -9.60361093499995],
              [149.67310631600003, -9.60515715899993],
              [149.68734785200002, -9.610772393999923],
              [149.69752037900003, -9.608819268999923],
              [149.72144616000003, -9.599786065999922],
              [149.7309676440001, -9.597832940999922],
              [149.75375410200002, -9.600762627999927],
              [149.7929793630001, -9.61451588299991],
              [149.84001712300005, -9.620212497999944],
              [149.88851972700002, -9.63876718499995],
              [149.91130618600005, -9.640069268999923],
              [149.97486412900003, -9.631280205999929],
              [150.0009871750001, -9.63404713299991],
              [150.0122176440001, -9.642185153999947],
              [150.0263778000001, -9.672946872999944],
              [150.03435306100005, -9.67896900799991],
              [150.0420028000001, -9.680271091999941],
              [150.0488387380001, -9.68450286299992],
              [150.05355879, -9.70012786299992],
              [150.05591881600003, -9.715020440999922],
              [150.0546981130001, -9.717950127999927],
              [150.047699415, -9.717054945999905],
              [150.03248131600003, -9.720635674999926],
              [149.97836347700002, -9.748304945999905],
              [149.95875084700003, -9.755466403999947],
              [149.88851972700002, -9.769138278999947],
              [149.84986412900003, -9.78101978999996],
              [149.82642662900003, -9.783135674999926],
              [149.8066512380001, -9.775323174999926],
              [149.79363040500004, -9.787286065999922],
              [149.7465926440001, -9.800957940999922],
              [149.7309676440001, -9.809340101999908],
              [149.72095787900003, -9.830661716999941],
              [149.72535241000003, -9.847832940999922],
              [149.7519637380001, -9.87900155999995],
              [149.8252059250001, -9.937676690999922],
              [149.85670006600003, -9.975192966999941],
              [149.8545028000001, -10.01490650799991],
              [149.879730665, -10.016778252999927],
              [149.89576256600003, -10.02320728999996],
              [149.9267684250001, -10.05364348799992],
              [149.9394637380001, -10.062432549999926],
              [149.9575301440001, -10.07000090899993],
              [149.97730553500003, -10.07545338299991],
              [149.99537194100003, -10.077569268999923],
              [150.05298912900003, -10.074639580999929],
              [150.0742293630001, -10.077569268999923],
              [150.0937606130001, -10.083591403999947],
              [150.12867272200003, -10.104587497999944],
              [150.13591556100005, -10.106052341999941],
              [150.149750196, -10.104913018999923],
              [150.15886478000004, -10.102146091999941],
              [150.17725670700008, -10.093194268999923],
              [150.1875106130001, -10.091241143999923],
              [150.19678795700008, -10.095147393999923],
              [150.203949415, -10.104261976999908],
              [150.21469160200002, -10.121677341999941],
              [150.24626712300005, -10.131280205999929],
              [150.25367272200003, -10.13567473799992],
              [150.26929772200003, -10.156426690999922],
              [150.28777103000004, -10.17197030999995],
              [150.30103600400003, -10.179294528999947],
              [150.34107506600003, -10.18678150799991],
              [150.382172071, -10.201592705999929],
              [150.40414472700002, -10.206149997999944],
              [150.42359459700003, -10.20045338299991],
              [150.430023634, -10.20240650799991],
              [150.44166100400003, -10.203057549999926],
              [150.45281009200005, -10.201592705999929],
              [150.45777428500003, -10.19703541499996],
              [150.49927819100003, -10.20671965899993],
              [150.524261915, -10.21648528399993],
              [150.53500410200002, -10.21493905999995],
              [150.55054772200003, -10.203545830999929],
              [150.55933678500003, -10.201836846999925],
              [150.60173587300005, -10.20671965899993],
              [150.59636478000004, -10.214288018999923],
              [150.58326256600003, -10.228448174999926],
              [150.58122806100005, -10.234633070999905],
              [150.58765709700003, -10.244724216999941],
              [150.6103621750001, -10.259698174999926],
              [150.61540774800005, -10.272556247999944],
              [150.62720787900003, -10.277927341999941],
              [150.65381920700008, -10.274509372999944],
              [150.71843509200005, -10.25872161299992],
              [150.783539259, -10.25562916499996],
              [150.79867597700002, -10.250583591999941],
              [150.8286238940001, -10.227227471999925],
              [150.8481551440001, -10.220961195999905],
              [150.8740340500001, -10.22470468499995],
              [150.87134850400003, -10.236748955999929],
              [150.85279381600003, -10.24976978999996],
              [150.81226647200003, -10.259698174999926],
              [150.688812696, -10.32545338299991],
              [150.65308678500003, -10.338474216999941],
              [150.61540774800005, -10.344496351999908],
              [150.598480665, -10.344333591999941],
              [150.59294681100005, -10.342217705999929],
              [150.58806399800005, -10.33766041499996],
              [150.5683699880001, -10.339450778999947],
              [150.52320397200003, -10.321465752999927],
              [150.502289259, -10.316582940999922],
              [150.46045983200008, -10.313897393999923],
              [150.440765821, -10.308851820999905],
              [150.4267684250001, -10.30006275799991],
              [150.39991295700008, -10.300225518999923],
              [150.36646569100003, -10.326918226999908],
              [150.34693444100003, -10.36532968499995],
              [150.36150149800005, -10.39967213299991],
              [150.36638431100005, -10.40016041499996],
              [150.368011915, -10.399021091999941],
              [150.36890709700003, -10.39226653399993],
              [150.38347415500004, -10.40007903399993],
              [150.42896569100003, -10.402276299999926],
              [150.44752037900003, -10.409600518999923],
              [150.45573978000004, -10.414483330999929],
              [150.46656334700003, -10.41765715899993],
              [150.49984785200002, -10.422621351999908],
              [150.50993899800005, -10.428480726999908],
              [150.52605228000004, -10.440606377999927],
              [150.64730879, -10.476983330999929],
              [150.67066491000003, -10.49586353999996],
              [150.67750084700003, -10.530043226999908],
              [150.68921959700003, -10.546319268999923],
              [150.69288170700008, -10.55673593499995],
              [150.68734785200002, -10.567559502999927],
              [150.6718856130001, -10.576836846999925],
              [150.55062910200002, -10.62086353999996],
              [150.53972415500004, -10.615411065999922],
              [150.535980665, -10.612725518999923],
              [150.50928795700008, -10.61882903399993],
              [150.49488366000003, -10.619398695999905],
              [150.48698978000004, -10.621677341999941],
              [150.47136478000004, -10.63250090899993],
              [150.469574415, -10.636651299999926],
              [150.45980879, -10.64853280999995],
              [150.44906660200002, -10.658379815999922],
              [150.44410241000003, -10.656914971999925],
              [150.44109134200005, -10.660577080999929],
              [150.43482506600003, -10.66570403399993],
              [150.42953535200002, -10.674248955999929],
              [150.42986087300005, -10.687676690999922],
              [150.41570071700005, -10.681898695999905],
              [150.39820397200003, -10.681084893999923],
              [150.381195509, -10.683526299999926],
              [150.36890709700003, -10.687676690999922],
              [150.3564559250001, -10.66497161299992],
              [150.34009850400003, -10.657810153999947],
              [150.3193465500001, -10.662041924999926],
              [150.27295983200008, -10.685723565999922],
              [150.27271569100003, -10.687676690999922],
              [150.26587975400003, -10.685723565999922],
              [150.257172071, -10.681573174999926],
              [150.2509871750001, -10.676934502999927],
              [150.25163821700005, -10.674086195999905],
              [150.24097741000003, -10.677992445999905],
              [150.230804884, -10.684340101999908],
              [150.211273634, -10.701348565999922],
              [150.20435631600003, -10.69304778399993],
              [150.1806746750001, -10.677178643999923],
              [150.17798912900003, -10.670668226999908],
              [150.18189537900003, -10.664646091999941],
              [150.18775475400003, -10.65789153399993],
              [150.19092858200008, -10.649834893999923],
              [150.1801863940001, -10.643243096999925],
              [150.1562606130001, -10.647149346999925],
              [150.1308699880001, -10.656670830999929],
              [150.1157332690001, -10.666680596999925],
              [150.09937584700003, -10.645114841999941],
              [150.094574415, -10.63990650799991],
              [150.08480879, -10.63567473799992],
              [150.08082116000003, -10.638116143999923],
              [150.07691491000003, -10.641371351999908],
              [150.0673934250001, -10.63990650799991],
              [150.05420983200008, -10.623793226999908],
              [150.04672285200002, -10.61882903399993],
              [150.0400496750001, -10.618340752999927],
              [150.0317488940001, -10.619398695999905],
              [150.02222741000003, -10.618584893999923],
              [150.012054884, -10.611993096999925],
              [150.030609571, -10.600030205999929],
              [150.02849368600005, -10.58879973799992],
              [150.01832116000003, -10.578057549999926],
              [150.012054884, -10.567559502999927],
              [150.0087996750001, -10.56373463299991],
              [150.0019637380001, -10.572930596999925],
              [149.9921981130001, -10.59148528399993],
              [149.983734571, -10.591729424999926],
              [149.97478274800005, -10.588474216999941],
              [149.95875084700003, -10.57781340899993],
              [149.9609481130001, -10.57350025799991],
              [149.96436608200008, -10.556817315999922],
              [149.95378665500004, -10.566013278999947],
              [149.95069420700008, -10.570977471999925],
              [149.943695509, -10.570977471999925],
              [149.93775475400003, -10.56178150799991],
              [149.925140821, -10.553887627999927],
              [149.89600670700008, -10.543633721999925],
              [149.9028426440001, -10.556817315999922],
              [149.89958743600005, -10.55787525799991],
              [149.8969832690001, -10.55787525799991],
              [149.89576256600003, -10.559177341999941],
              [149.89600670700008, -10.56422291499996],
              [149.88640384200005, -10.55868905999995],
              [149.87647545700008, -10.554620049999926],
              [149.86597741000003, -10.551934502999927],
              [149.8545028000001, -10.55046965899993],
              [149.86597741000003, -10.53883228999996],
              [149.88160241000003, -10.533868096999925],
              [149.89405358200008, -10.52703215899993],
              [149.89600670700008, -10.508965752999927],
              [149.89047285200002, -10.511651299999926],
              [149.87614993600005, -10.515801690999922],
              [149.880218946, -10.508233330999929],
              [149.88624108200008, -10.502536716999941],
              [149.89372806100005, -10.498467705999929],
              [149.9028426440001, -10.49586353999996],
              [149.90967858200008, -10.506931247999944],
              [149.9204207690001, -10.50790780999995],
              [149.9472762380001, -10.502129815999922],
              [149.99195397200003, -10.513929945999905],
              [150.0380965500001, -10.49976978999996],
              [150.04672285200002, -10.49586353999996],
              [150.04900149800005, -10.490166924999926],
              [150.0512801440001, -10.473321221999925],
              [150.05355879, -10.467950127999927],
              [150.05933678500003, -10.465508721999925],
              [150.08155358200008, -10.461114190999922],
              [150.06853274800005, -10.455661716999941],
              [150.055023634, -10.45476653399993],
              [150.04118899800005, -10.455336195999905],
              [150.0263778000001, -10.45435963299991],
              [150.01587975400003, -10.449883721999925],
              [149.99537194100003, -10.436618747999944],
              [149.973968946, -10.432712497999944],
              [149.96216881600003, -10.42750416499996],
              [149.95476321700005, -10.426446221999925],
              [149.95069420700008, -10.42864348799992],
              [149.94418379, -10.43840911299992],
              [149.94027754, -10.440606377999927],
              [149.9384871750001, -10.44736093499995],
              [149.9360457690001, -10.462497653999947],
              [149.9316512380001, -10.47861093499995],
              [149.92335045700008, -10.488457940999922],
              [149.91578209700003, -10.481866143999923],
              [149.91163170700008, -10.475030205999929],
              [149.90992272200003, -10.467217705999929],
              [149.90967858200008, -10.457696221999925],
              [149.90788821700005, -10.449883721999925],
              [149.90381920700008, -10.446465752999927],
              [149.899261915, -10.44426848799992],
              [149.89600670700008, -10.440606377999927],
              [149.88746178500003, -10.415948174999926],
              [149.8818465500001, -10.406426690999922],
              [149.8720809250001, -10.396091403999947],
              [149.8457137380001, -10.379978122999944],
              [149.79053795700008, -10.36305103999996],
              [149.76937910200002, -10.348239841999941],
              [149.748383009, -10.338311455999929],
              [149.715179884, -10.33489348799992],
              [149.64966881600003, -10.33766041499996],
              [149.61605879, -10.344903252999927],
              [149.5976668630001, -10.346368096999925],
              [149.572601759, -10.337497653999947],
              [149.56202233200008, -10.344496351999908],
              [149.54965254, -10.350681247999944],
              [149.53296959700003, -10.344496351999908],
              [149.52613366000003, -10.351983330999929],
              [149.53980553500003, -10.358086846999925],
              [149.53980553500003, -10.36492278399993],
              [149.5087996750001, -10.36492278399993],
              [149.50074303500003, -10.361260674999926],
              [149.49773196700005, -10.34351978999996],
              [149.4912215500001, -10.33766041499996],
              [149.48031660200002, -10.339776299999926],
              [149.47144616000003, -10.34775155999995],
              [149.46062259200005, -10.352308851999908],
              [149.44353274800005, -10.344496351999908],
              [149.45476321700005, -10.337497653999947],
              [149.45492597700002, -10.330824476999908],
              [149.44711347700002, -10.32594166499996],
              [149.4218856130001, -10.320977471999925],
              [149.418793165, -10.313571872999944],
              [149.41814212300005, -10.30364348799992],
              [149.41285241000003, -10.293226820999905],
              [149.36841881600003, -10.276136976999908],
              [149.3554793630001, -10.281833591999941],
              [149.3369246750001, -10.30169036299992],
              [149.32683353000004, -10.31031666499996],
              [149.314789259, -10.302178643999923],
              [149.2949324880001, -10.295586846999925],
              [149.27295983200008, -10.291436455999929],
              [149.254730665, -10.289808851999908],
              [149.24170983200008, -10.286553643999923],
              [149.16968834700003, -10.24976978999996],
              [149.15503991000003, -10.244317315999922],
              [149.12842858200008, -10.240899346999925],
              [149.11011803500003, -10.235772393999923],
              [149.1015731130001, -10.234633070999905],
              [149.08220462300005, -10.23756275799991],
              [149.0732528000001, -10.23796965899993],
              [149.0673934250001, -10.234633070999905],
              [149.04411868600005, -10.24391041499996],
              [149.0322371750001, -10.247165622999944],
              [149.02230879, -10.248223565999922],
              [149.00896243600005, -10.252129815999922],
              [148.996918165, -10.260837497999944],
              [148.98650149800005, -10.270277601999908],
              [148.97803795700008, -10.276136976999908],
              [148.95826256600003, -10.278090101999908],
              [148.93921959700003, -10.271416924999926],
              [148.87126712300005, -10.23837655999995],
              [148.85922285200002, -10.235528252999927],
              [148.84400475400003, -10.234633070999905],
              [148.792328321, -10.242120049999926],
              [148.779633009, -10.241631768999923],
              [148.76124108200008, -10.23601653399993],
              [148.74781334700003, -10.234633070999905],
              [148.73780358200008, -10.230075778999947],
              [148.74000084700003, -10.208184502999927],
              [148.7309676440001, -10.20045338299991],
              [148.73316491000003, -10.197198174999926],
              [148.735687696, -10.19036223799992],
              [148.73780358200008, -10.18678150799991],
              [148.7275496750001, -10.18718840899993],
              [148.72413170700008, -10.18678150799991],
              [148.7295028000001, -10.175225518999923],
              [148.73755944100003, -10.169122002999927],
              [148.74822024800005, -10.166680596999925],
              [148.7617293630001, -10.166273695999905],
              [148.76742597700002, -10.15829843499995],
              [148.7583113940001, -10.14348723799992],
              [148.74480228000004, -10.13600025799991],
              [148.73780358200008, -10.149834893999923],
              [148.7329207690001, -10.156914971999925],
              [148.72185306100005, -10.155857028999947],
              [148.71021569100003, -10.150974216999941],
              [148.7036238940001, -10.146416924999926],
              [148.69898522200003, -10.137465101999908],
              [148.68930097700002, -10.104913018999923],
              [148.68311608200008, -10.104913018999923],
              [148.676605665, -10.145277601999908],
              [148.66911868600005, -10.164483330999929],
              [148.65186608200008, -10.172539971999925],
              [148.6416121750001, -10.183770440999922],
              [148.6386824880001, -10.187920830999929],
              [148.63209069100003, -10.186293226999908],
              [148.6211043630001, -10.18059661299992],
              [148.57390384200005, -10.18059661299992],
              [148.55054772200003, -10.174004815999922],
              [148.53785241000003, -10.172295830999929],
              [148.53239993600005, -10.176527601999908],
              [148.52711022200003, -10.184991143999923],
              [148.51482181100005, -10.190199476999908],
              [148.50017337300005, -10.192803643999923],
              [148.42164147200003, -10.193780205999929],
              [148.40202884200005, -10.20045338299991],
              [148.33708743600005, -10.17546965899993],
              [148.32691491000003, -10.162855726999908],
              [148.31812584700003, -10.14226653399993],
              [148.29900149800005, -10.127129815999922],
              [148.28012129, -10.12395598799992],
              [148.27230879, -10.138929945999905],
              [148.2578231130001, -10.12981536299992],
              [148.24577884200005, -10.117445570999905],
              [148.231293165, -10.105645440999922],
              [148.21021569100003, -10.098077080999929],
              [148.2011824880001, -10.09775155999995],
              [148.18279056100005, -10.099216403999947],
              [148.17603600400003, -10.098077080999929],
              [148.1699324880001, -10.092461846999925],
              [148.163422071, -10.077732028999947],
              [148.15503991000003, -10.070733330999929],
              [148.142914259, -10.105889580999929],
              [148.10377037900003, -10.12818775799991],
              [148.056000196, -10.135430596999925],
              [148.01832116000003, -10.12476978999996],
              [148.00342858200008, -10.148370049999926],
              [147.99236087300005, -10.158949476999908],
              [147.977386915, -10.166273695999905],
              [147.9589949880001, -10.154961846999925],
              [147.9477645190001, -10.13600025799991],
              [147.93930097700002, -10.115166924999926],
              [147.929047071, -10.098077080999929],
              [147.91334069100003, -10.08879973799992],
              [147.8974715500001, -10.090915622999944],
              [147.87867272200003, -10.09661223799992],
              [147.8540145190001, -10.098077080999929],
              [147.8540145190001, -10.091241143999923],
              [147.87289472700002, -10.085137627999927],
              [147.88152103000004, -10.069105726999908],
              [147.87964928500003, -10.052178643999923],
              [147.867523634, -10.043389580999929],
              [147.85906009200005, -10.044854424999926],
              [147.8525496750001, -10.05006275799991],
              [147.84839928500003, -10.05787525799991],
              [147.8447371750001, -10.078545830999929],
              [147.83912194100003, -10.076348565999922],
              [147.8266707690001, -10.063246351999908],
              [147.78541100400003, -10.05445728999996],
              [147.7617293630001, -10.059747002999927],
              [147.7236434250001, -10.098077080999929],
              [147.7168074880001, -10.098077080999929],
              [147.69939212300005, -10.01490650799991],
              [147.69011478000004, -10.013278903999947],
              [147.67725670700008, -10.008965752999927],
              [147.666351759, -10.00367603999996],
              [147.661468946, -9.998711846999925],
              [147.65650475400003, -9.991631768999923],
              [147.64470462300005, -9.989841403999947],
              [147.631195509, -9.99000416499996],
              [147.62126712300005, -9.988864841999941],
              [147.6084090500001, -9.979913018999923],
              [147.5727645190001, -9.945245049999926],
              [147.56527754, -9.930108330999929],
              [147.55974368600005, -9.914483330999929],
              [147.54639733200008, -9.901788018999923],
              [147.53052819100003, -9.890557549999926],
              [147.5175887380001, -9.87900155999995],
              [147.50953209700003, -9.86492278399993],
              [147.50538170700008, -9.849053643999923],
              [147.5039168630001, -9.80632903399993],
              [147.50017337300005, -9.785821221999925],
              [147.49097741000003, -9.76767343499995],
              [147.40113366000003, -9.651950778999947],
              [147.37419681100005, -9.62509530999995],
              [147.36443118600005, -9.611911716999941],
              [147.35613040500004, -9.59539153399993],
              [147.34498131600003, -9.580254815999922],
              [147.32634524800005, -9.570489190999922],
              [147.31959069100003, -9.577325127999927],
              [147.3188582690001, -9.554864190999922],
              [147.31006920700008, -9.53883228999996],
              [147.2959090500001, -9.526950778999947],
              [147.27800540500004, -9.515801690999922],
              [147.26197350400003, -9.50872161299992],
              [147.24968509200005, -9.508070570999905],
              [147.24626712300005, -9.51653411299992],
              [147.25757897200003, -9.536309502999927],
              [147.2343856130001, -9.537774346999925],
              [147.2031356130001, -9.52825286299992],
              [147.17261803500003, -9.513278903999947],
              [147.15105228000004, -9.498467705999929],
              [147.14519290500004, -9.486911716999941],
              [147.14014733200008, -9.453301690999922],
              [147.13396243600005, -9.440118096999925],
              [147.12224368600005, -9.431247653999947],
              [147.1098738940001, -9.428155205999929],
              [147.09595787900003, -9.42945728999996],
              [147.07935631600003, -9.43328215899993],
              [147.0844832690001, -9.44150155999995],
              [147.10035241000003, -9.446709893999923],
              [147.10661868600005, -9.453789971999925],
              [147.10906009200005, -9.46493905999995],
              [147.10767662900003, -9.474541924999926],
              [147.10417728000004, -9.480726820999905],
              [147.099945509, -9.48170338299991],
              [147.09978274800005, -9.48170338299991],
              [147.0883895190001, -9.48137786299992],
              [147.06999759200005, -9.473402601999908],
              [147.0527449880001, -9.46021900799991],
              [147.03980553500003, -9.42896900799991],
              [147.01384524800005, -9.39039478999996],
              [147.00416100400003, -9.371840101999908],
              [146.99170983200008, -9.32317473799992],
              [146.982758009, -9.301039320999905],
              [146.96607506600003, -9.27906666499996],
              [146.94646243600005, -9.27312590899993],
              [146.90552819100003, -9.281996351999908],
              [146.894867384, -9.268243096999925],
              [146.90699303500003, -9.265801690999922],
              [146.91586347700002, -9.260349216999941],
              [146.91920006600003, -9.252129815999922],
              [146.914886915, -9.24146900799991],
              [146.90552819100003, -9.235121351999908],
              [146.89633222700002, -9.210870049999926],
              [146.894867384, -9.181247653999947],
              [146.908539259, -9.158949476999908],
              [146.90300540500004, -9.154229424999926],
              [146.89763431100005, -9.14771900799991],
              [146.89242597700002, -9.140069268999923],
              [146.88819420700008, -9.131605726999908],
              [146.895843946, -9.128350518999923],
              [146.914886915, -9.124200127999927],
              [146.937836134, -9.108575127999927],
              [146.94214928500003, -9.10751718499995],
              [146.94849694100003, -9.09734465899993],
              [146.97681725400003, -9.076104424999926],
              [146.98365319100003, -9.06340911299992],
              [146.98308353000004, -9.053399346999925],
              [146.97999108200008, -9.042575778999947],
              [146.97535241000003, -9.033461195999905],
              [146.96949303500003, -9.029229424999926],
              [146.95655358200008, -9.031996351999908],
              [146.95036868600005, -9.041680596999925],
              [146.94947350400003, -9.051853122999944],
              [146.95264733200008, -9.056573174999926],
              [146.951508009, -9.063571872999944],
              [146.920258009, -9.095147393999923],
              [146.908539259, -9.103692315999922],
              [146.87281334700003, -9.106540622999944],
              [146.84205162900003, -9.093194268999923],
              [146.81218509200005, -9.073337497999944],
              [146.7783309250001, -9.056573174999926],
              [146.76636803500003, -9.05437590899993],
              [146.74822024800005, -9.057386976999908],
              [146.736664259, -9.056573174999926],
              [146.72925866000003, -9.053399346999925],
              [146.71501712300005, -9.04461028399993],
              [146.6455184250001, -9.02939218499995],
              [146.62680097700002, -9.023044528999947],
              [146.60181725400003, -9.006036065999922],
              [146.5859481130001, -8.98365650799991],
              [146.57349694100003, -8.960381768999923],
              [146.55844160200002, -8.940524997999944],
              [146.56275475400003, -8.927178643999923],
              [146.56006920700008, -8.911228122999944],
              [146.55420983200008, -8.89771900799991],
              [146.54835045700008, -8.892022393999923],
              [146.55445397200003, -8.88258228999996],
              [146.55640709700003, -8.86419036299992],
              [146.561859571, -8.851169528999947],
              [146.5791121750001, -8.858005466999941],
              [146.59400475400003, -8.846286716999941],
              [146.6045028000001, -8.834161065999922],
              [146.60914147200003, -8.82000090899993],
              [146.6064559250001, -8.80201588299991],
              [146.59245853000004, -8.815850518999923],
              [146.57585696700005, -8.82195403399993],
              [146.56592858200008, -8.81812916499996],
              [146.57211347700002, -8.80201588299991],
              [146.56714928500003, -8.79810963299991],
              [146.56275475400003, -8.79273853999996],
              [146.55974368600005, -8.78606536299992],
              [146.55844160200002, -8.778497002999927],
              [146.5532332690001, -8.765801690999922],
              [146.54118899800005, -8.76336028399993],
              [146.5283309250001, -8.765069268999923],
              [146.52076256600003, -8.765232028999947],
              [146.5166121750001, -8.75709400799991],
              [146.5166121750001, -8.74700286299992],
              [146.51775149800005, -8.736586195999905],
              [146.516937696, -8.726983330999929],
              [146.51246178500003, -8.71493905999995],
              [146.50709069100003, -8.705254815999922],
              [146.4594832690001, -8.65211353999996],
              [146.44703209700003, -8.63453541499996],
              [146.4419051440001, -8.62118905999995],
              [146.43531334700003, -8.61060963299991],
              [146.3872176440001, -8.58294036299992],
              [146.36304772200003, -8.560967705999929],
              [146.27719160200002, -8.43523528399993],
              [146.264984571, -8.404717705999929],
              [146.26384524800005, -8.36451588299991],
              [146.26099694100003, -8.356133721999925],
              [146.2524520190001, -8.344414971999925],
              [146.25074303500003, -8.340264580999929],
              [146.25074303500003, -8.309258721999925],
              [146.24488366000003, -8.29225025799991],
              [146.23511803500003, -8.27434661299992],
              [146.22193444100003, -8.260430596999925],
              [146.18897545700008, -8.248223565999922],
              [146.15984134200005, -8.21998463299991],
              [146.15113366000003, -8.213636976999908],
              [146.1274520190001, -8.210137627999927],
              [146.116547071, -8.20012786299992],
              [146.09986412900003, -8.165215752999927],
              [146.11280358200008, -8.15439218499995],
              [146.1098738940001, -8.138116143999923],
              [146.098480665, -8.121758721999925],
              [146.08562259200005, -8.11060963299991],
              [146.09587649800005, -8.106215101999908],
              [146.10279381600003, -8.100274346999925],
              [146.10474694100003, -8.09270598799992],
              [146.09986412900003, -8.08326588299991],
              [146.07935631600003, -8.087497653999947],
              [146.04965254, -8.076348565999922],
              [145.99683678500003, -8.049086195999905],
              [145.9394637380001, -8.035088799999926],
              [145.9067488940001, -8.033461195999905],
              [145.88070722700002, -8.041680596999925],
              [145.8613387380001, -8.027927341999941],
              [145.79810631600003, -8.007012627999927],
              [145.784515821, -7.990492445999905],
              [145.78239993600005, -7.987074476999908],
              [145.777679884, -7.983168226999908],
              [145.77312259200005, -7.97779713299991],
              [145.770843946, -7.96998463299991],
              [145.773773634, -7.966892184999949],
              [145.7871199880001, -7.965101820999905],
              [145.79127037900003, -7.959730726999908],
              [145.7900496750001, -7.953871351999908],
              [145.78541100400003, -7.949965101999908],
              [145.78012129, -7.94654713299991],
              [145.777679884, -7.942478122999944],
              [145.77947024800005, -7.935642184999949],
              [145.79127037900003, -7.911879164999959],
              [145.784515821, -7.911879164999959],
              [145.7724715500001, -7.92742278399993],
              [145.7578231130001, -7.92701588299991],
              [145.74097741000003, -7.924086195999905],
              [145.72250410200002, -7.932549737999921],
              [145.73698978000004, -7.952732028999947],
              [145.719086134, -7.960381768999923],
              [145.65796959700003, -7.959730726999908],
              [145.645355665, -7.955987237999921],
              [145.62671959700003, -7.938164971999925],
              [145.6132918630001, -7.932549737999921],
              [145.5981551440001, -7.933363539999959],
              [145.58326256600003, -7.937269789999959],
              [145.56788170700008, -7.938897393999923],
              [145.5517684250001, -7.932549737999921],
              [145.5517684250001, -7.939222914999959],
              [145.5332137380001, -7.932793877999927],
              [145.46558678500003, -7.945489190999922],
              [145.4419051440001, -7.944105726999908],
              [145.42335045700008, -7.939711195999905],
              [145.40796959700003, -7.931735934999949],
              [145.3501082690001, -7.876722914999959],
              [145.321625196, -7.861993096999925],
              [145.2837020190001, -7.857354424999926],
              [145.27491295700008, -7.859470309999949],
              [145.26514733200008, -7.86296965899993],
              [145.25456790500004, -7.865411065999922],
              [145.24341881600003, -7.864190362999921],
              [145.2343856130001, -7.858819268999923],
              [145.213226759, -7.839776299999926],
              [145.2060653000001, -7.828220309999949],
              [145.1919051440001, -7.818454684999949],
              [145.1840926440001, -7.805596612999921],
              [145.1748153000001, -7.816013278999947],
              [145.16724694100003, -7.830743096999925],
              [145.16822350400003, -7.836195570999905],
              [145.14966881600003, -7.83757903399993],
              [145.12427819100003, -7.830743096999925],
              [145.1020613940001, -7.817478122999944],
              [145.09253991000003, -7.799004815999922],
              [145.089203321, -7.788018487999921],
              [145.08187910200002, -7.778741143999923],
              [145.0747176440001, -7.776136976999908],
              [145.07146243600005, -7.785088799999926],
              [145.071136915, -7.806410414999959],
              [145.06755618600005, -7.811700127999927],
              [145.05836022200003, -7.816501559999949],
              [144.99626712300005, -7.816501559999949],
              [144.9853621750001, -7.809665622999944],
              [144.95533287900003, -7.775485934999949],
              [144.94263756600003, -7.79225025799991],
              [144.93181399800005, -7.790459893999923],
              [144.91968834700003, -7.781019789999959],
              [144.90381920700008, -7.775485934999949],
              [144.89730879, -7.776788018999923],
              [144.88542728000004, -7.781670830999929],
              [144.87956790500004, -7.781670830999929],
              [144.87769616000003, -7.779229424999926],
              [144.872406446, -7.769952080999929],
              [144.8696395190001, -7.767998955999929],
              [144.8613387380001, -7.765069268999923],
              [144.850922071, -7.758070570999905],
              [144.84302819100003, -7.750176690999922],
              [144.84205162900003, -7.744073174999926],
              [144.8584090500001, -7.72429778399993],
              [144.8662215500001, -7.705743096999925],
              [144.86744225400003, -7.608493747999944],
              [144.8642684250001, -7.586032809999949],
              [144.85230553500003, -7.569431247999944],
              [144.84449303500003, -7.588555596999925],
              [144.8403426440001, -7.636814059999949],
              [144.83122806100005, -7.658135674999926],
              [144.83716881600003, -7.674248955999929],
              [144.82496178500003, -7.682549737999921],
              [144.80486087300005, -7.685642184999949],
              [144.7871199880001, -7.686130466999941],
              [144.77100670700008, -7.681084893999923],
              [144.757172071, -7.66920338299991],
              [144.73560631600003, -7.64381275799991],
              [144.69947350400003, -7.616794528999947],
              [144.6899520190001, -7.594414971999925],
              [144.67888431100005, -7.582289320999905],
              [144.65357506600003, -7.561293226999908],
              [144.64771569100003, -7.580010674999926],
              [144.65113366000003, -7.598239841999941],
              [144.657562696, -7.616387627999927],
              [144.6611434250001, -7.634209893999923],
              [144.65162194100003, -7.649102471999925],
              [144.6294051440001, -7.656345309999949],
              [144.6040145190001, -7.656914971999925],
              [144.58472741000003, -7.651950778999947],
              [144.57545006600003, -7.64226653399993],
              [144.5644637380001, -7.625258070999905],
              [144.5551863940001, -7.606866143999923],
              [144.5512801440001, -7.592950127999927],
              [144.55103600400003, -7.58171965899993],
              [144.5498153000001, -7.572849216999941],
              [144.54656009200005, -7.565524997999944],
              [144.54070071700005, -7.558526299999926],
              [144.53663170700008, -7.549086195999905],
              [144.53923587300005, -7.524590752999927],
              [144.5376082690001, -7.514092705999929],
              [144.52230879, -7.496189059999949],
              [144.5166121750001, -7.508477471999925],
              [144.51710045700008, -7.579278252999927],
              [144.50904381600003, -7.611423434999949],
              [144.50961347700002, -7.623955987999921],
              [144.51514733200008, -7.632582289999959],
              [144.5376082690001, -7.651950778999947],
              [144.53296959700003, -7.661716403999947],
              [144.52328535200002, -7.669040622999944],
              [144.51392662900003, -7.671970309999949],
              [144.50961347700002, -7.668633721999925],
              [144.5044051440001, -7.655694268999923],
              [144.47836347700002, -7.634942315999922],
              [144.4687606130001, -7.623955987999921],
              [144.46599368600005, -7.616794528999947],
              [144.46241295700008, -7.599216403999947],
              [144.4619246750001, -7.592950127999927],
              [144.45915774800005, -7.587660414999959],
              [144.45289147200003, -7.583591403999947],
              [144.44597415500004, -7.579847914999959],
              [144.4414168630001, -7.576267184999949],
              [144.43287194100003, -7.558689059999949],
              [144.42156009200005, -7.526543877999927],
              [144.413422071, -7.514092705999929],
              [144.4072371750001, -7.514092705999929],
              [144.41163170700008, -7.531426690999922],
              [144.413422071, -7.569431247999944],
              [144.41814212300005, -7.584730726999908],
              [144.43132571700005, -7.612237237999921],
              [144.43384850400003, -7.627373955999929],
              [144.43580162900003, -7.659926039999959],
              [144.4414168630001, -7.686130466999941],
              [144.4472762380001, -7.696221612999921],
              [144.45671634200005, -7.707777601999908],
              [144.46501712300005, -7.721368096999925],
              [144.4687606130001, -7.737237237999921],
              [144.47999108200008, -7.748142184999949],
              [144.5000106130001, -7.774102471999925],
              [144.5078231130001, -7.798028252999927],
              [144.4824324880001, -7.802178643999923],
              [144.47974694100003, -7.79615650799991],
              [144.45980879, -7.769301039999959],
              [144.4550887380001, -7.76490650799991],
              [144.44996178500003, -7.754327080999929],
              [144.43816165500004, -7.740329684999949],
              [144.4243270190001, -7.727308851999908],
              [144.413422071, -7.720147393999923],
              [144.4028426440001, -7.743340752999927],
              [144.38453209700003, -7.751885674999926],
              [144.3671981130001, -7.743584893999923],
              [144.35954837300005, -7.716729424999926],
              [144.35531660200002, -7.68678150799991],
              [144.34441165500004, -7.65943775799991],
              [144.3110457690001, -7.610284112999921],
              [144.31568444100003, -7.636651299999926],
              [144.3271590500001, -7.665134372999944],
              [144.33383222700002, -7.688653252999927],
              [144.32398522200003, -7.700372002999927],
              [144.30746504, -7.69264088299991],
              [144.2851668630001, -7.646661065999922],
              [144.2695418630001, -7.630791924999926],
              [144.26319420700008, -7.642510674999926],
              [144.25342858200008, -7.650485934999949],
              [144.24138431100005, -7.655368747999944],
              [144.2285262380001, -7.658135674999926],
              [144.2285262380001, -7.665622653999947],
              [144.2544051440001, -7.66725025799991],
              [144.26091556100005, -7.683689059999949],
              [144.25464928500003, -7.706149997999944],
              [144.2421981130001, -7.726332289999959],
              [144.2524520190001, -7.730726820999905],
              [144.26531009200005, -7.74187590899993],
              [144.27491295700008, -7.755791924999926],
              [144.27621504, -7.767998955999929],
              [144.26628665500004, -7.775567315999922],
              [144.2285262380001, -7.789157809999949],
              [144.2148543630001, -7.795993747999944],
              [144.1962996750001, -7.777601820999905],
              [144.1865340500001, -7.771661065999922],
              [144.1738387380001, -7.767998955999929],
              [144.16285241000003, -7.769626559999949],
              [144.1508895190001, -7.774346612999921],
              [144.1391707690001, -7.776788018999923],
              [144.12916100400003, -7.771661065999922],
              [144.11198978000004, -7.758396091999941],
              [143.9243270190001, -7.694268487999921],
              [143.85141035200002, -7.651788018999923],
              [143.82789147200003, -7.63209400799991],
              [143.81763756600003, -7.614027601999908],
              [143.81267337300005, -7.594170830999929],
              [143.77662194100003, -7.527764580999929],
              [143.76937910200002, -7.510349216999941],
              [143.76579837300005, -7.506036065999922],
              [143.75611412900003, -7.500420830999929],
              [143.74626712300005, -7.496758721999925],
              [143.7226668630001, -7.49382903399993],
              [143.71119225400003, -7.493747653999947],
              [143.69605553500003, -7.488051039999959],
              [143.66187584700003, -7.461521091999941],
              [143.65251712300005, -7.452080987999921],
              [143.65023847700002, -7.448663018999923],
              [143.64625084700003, -7.438409112999921],
              [143.63884524800005, -7.452080987999921],
              [143.64909915500004, -7.467705987999921],
              [143.68116295700008, -7.501560153999947],
              [143.69068444100003, -7.507907809999949],
              [143.70045006600003, -7.510023695999905],
              [143.72250410200002, -7.519301039999959],
              [143.74561608200008, -7.523695570999905],
              [143.747406446, -7.529066664999959],
              [143.74398847700002, -7.535821221999925],
              [143.74244225400003, -7.542087497999944],
              [143.75953209700003, -7.583184502999927],
              [143.8408309250001, -7.720147393999923],
              [143.84734134200005, -7.740166924999926],
              [143.85075931100005, -7.761325778999947],
              [143.85173587300005, -7.785088799999926],
              [143.85621178500003, -7.80828215899993],
              [143.8671981130001, -7.826429945999905],
              [143.89275149800005, -7.857354424999926],
              [143.94068444100003, -7.930271091999941],
              [143.95679772200003, -7.972263278999947],
              [143.94288170700008, -7.99155038899994],
              [143.94117272200003, -7.993910414999959],
              [143.922699415, -7.988539320999905],
              [143.90796959700003, -7.972100518999923],
              [143.89429772200003, -7.952894789999959],
              [143.87907962300005, -7.939222914999959],
              [143.8623153000001, -7.93523528399993],
              [143.80396569100003, -7.932549737999921],
              [143.81006920700008, -7.93678150799991],
              [143.81763756600003, -7.947849216999941],
              [143.82447350400003, -7.952894789999959],
              [143.8330184250001, -7.955824476999908],
              [143.8501082690001, -7.957452080999929],
              [143.85857181100005, -7.959730726999908],
              [143.87614993600005, -7.969659112999921],
              [143.91382897200003, -8.00758228999996],
              [143.89828535200002, -8.027927341999941],
              [143.881195509, -8.037855726999908],
              [143.860687696, -8.041273695999905],
              [143.76734459700003, -8.040215752999927],
              [143.74870853000004, -8.03492603999996],
              [143.740570509, -8.02939218499995],
              [143.723480665, -8.013929945999905],
              [143.71461022200003, -8.00758228999996],
              [143.67986087300005, -7.996758721999925],
              [143.67017662900003, -7.990492445999905],
              [143.6508895190001, -7.981377862999921],
              [143.62761478000004, -7.982028903999947],
              [143.56316165500004, -7.997979424999926],
              [143.5063582690001, -7.993910414999959],
              [143.48894290500004, -7.989027601999908],
              [143.477875196, -7.976332289999959],
              [143.461273634, -7.939222914999959],
              [143.44841556100005, -7.918877862999921],
              [143.4340926440001, -7.908949476999908],
              [143.41553795700008, -7.90593840899993],
              [143.38933353000004, -7.905857028999947],
              [143.3857528000001, -7.903090101999908],
              [143.37517337300005, -7.898532809999949],
              [143.36402428500003, -7.896416924999926],
              [143.35889733200008, -7.90203215899993],
              [143.36109459700003, -7.910902601999908],
              [143.36695397200003, -7.91765715899993],
              [143.375336134, -7.922458591999941],
              [143.38559004, -7.925713799999926],
              [143.4262801440001, -7.929782809999949],
              [143.43718509200005, -7.938409112999921],
              [143.44092858200008, -7.963148695999905],
              [143.44841556100005, -7.981540622999944],
              [143.46656334700003, -7.99578215899993],
              [143.54802493600005, -8.031670830999929],
              [143.55982506600003, -8.044854424999926],
              [143.56983483200008, -8.084567966999941],
              [143.62761478000004, -8.186293226999908],
              [143.63502037900003, -8.211358330999929],
              [143.62916100400003, -8.230401299999926],
              [143.61247806100005, -8.23919036299992],
              [143.59205162900003, -8.24195728999996],
              [143.3379012380001, -8.24773528399993],
              [143.32789147200003, -8.25204843499995],
              [143.300140821, -8.26881275799991],
              [143.21501712300005, -8.27507903399993],
              [142.9804793630001, -8.33562590899993],
              [142.957855665, -8.33717213299991],
              [142.93962649800005, -8.33326588299991],
              [142.84148196700005, -8.28834400799991],
              [142.71452884200005, -8.267998955999929],
              [142.71021569100003, -8.266778252999927],
              [142.70036868600005, -8.26140715899993],
              [142.6836043630001, -8.26921965899993],
              [142.6337996750001, -8.280368747999944],
              [142.61500084700003, -8.281914971999925],
              [142.59253991000003, -8.28687916499996],
              [142.53589928500003, -8.32350025799991],
              [142.514008009, -8.331963799999926],
              [142.494476759, -8.33326588299991],
              [142.450531446, -8.32976653399993],
              [142.4287215500001, -8.324151299999926],
              [142.41382897200003, -8.310479424999926],
              [142.404633009, -8.29265715899993],
              [142.3813582690001, -8.19345468499995],
              [142.36003665500004, -8.167087497999944],
              [142.316742384, -8.158949476999908],
              [142.26002037900003, -8.170668226999908],
              [142.22478274800005, -8.173272393999923],
              [142.21705162900003, -8.17546965899993],
              [142.21119225400003, -8.18059661299992],
              [142.20386803500003, -8.189385674999926],
              [142.19288170700008, -8.197930596999925],
              [142.18181399800005, -8.20094166499996],
              [142.17058353000004, -8.202732028999947],
              [142.15967858200008, -8.20680103999996],
              [142.14616946700005, -8.217380466999941],
              [142.14047285200002, -8.226495049999926],
              [142.14437910200002, -8.23447030999995],
              [142.15967858200008, -8.240899346999925],
              [142.181976759, -8.21998463299991],
              [142.195648634, -8.21070728999996],
              [142.21070397200003, -8.20680103999996],
              [142.21851647200003, -8.203789971999925],
              [142.2251082690001, -8.198011976999908],
              [142.23121178500003, -8.193942966999941],
              [142.24732506600003, -8.20012786299992],
              [142.25993899800005, -8.19931405999995],
              [142.30225670700008, -8.187920830999929],
              [142.32960045700008, -8.183851820999905],
              [142.3540145190001, -8.18873463299991],
              [142.36451256600003, -8.21021900799991],
              [142.36703535200002, -8.232354424999926],
              [142.39730879, -8.328057549999926],
              [142.41968834700003, -8.355401299999926],
              [142.4521590500001, -8.373304945999905],
              [142.49431399800005, -8.377536716999941],
              [142.5297957690001, -8.365411065999922],
              [142.59636478000004, -8.320733330999929],
              [142.63209069100003, -8.309258721999925],
              [142.71168053500003, -8.322686455999929],
              [142.72828209700003, -8.316664320999905],
              [142.76929772200003, -8.32976653399993],
              [142.80355879, -8.359795830999929],
              [142.81397545700008, -8.36451588299991],
              [142.835297071, -8.37037525799991],
              [142.89966881600003, -8.412855726999908],
              [142.938324415, -8.42782968499995],
              [143.0634871750001, -8.45322030999995],
              [143.1020613940001, -8.467217705999929],
              [143.13160241000003, -8.48601653399993],
              [143.26156660200002, -8.592380466999941],
              [143.31788170700008, -8.658786716999941],
              [143.34791100400003, -8.707614841999941],
              [143.386078321, -8.753106377999927],
              [143.39527428500003, -8.768731377999927],
              [143.39991295700008, -8.78215911299992],
              [143.39991295700008, -8.91187916499996],
              [143.40601647200003, -8.944512627999927],
              [143.40552819100003, -8.96217213299991],
              [143.3964949880001, -8.977715752999927],
              [143.37256920700008, -8.99976978999996],
              [143.3613387380001, -9.007419528999947],
              [143.3447371750001, -9.015557549999926],
              [143.314789259, -9.02353280999995],
              [143.25806725400003, -9.023695570999905],
              [143.2285262380001, -9.029229424999926],
              [143.2353621750001, -9.03606536299992],
              [143.22527103000004, -9.039320570999905],
              [143.20435631600003, -9.04070403399993],
              [143.188812696, -9.043552341999941],
              [143.1782332690001, -9.042413018999923],
              [143.17335045700008, -9.042901299999926],
              [143.17074629, -9.046482028999947],
              [143.16765384200005, -9.053399346999925],
              [143.16293379, -9.06023528399993],
              [143.1562606130001, -9.06340911299992],
              [143.1416121750001, -9.06609465899993],
              [143.0527449880001, -9.093357028999947],
              [143.03589928500003, -9.10165780999995],
              [143.01140384200005, -9.121677341999941],
              [142.98804772200003, -9.135837497999944],
              [142.97836347700002, -9.13844166499996],
              [142.96705162900003, -9.143731377999927],
              [142.95769290500004, -9.15553150799991],
              [142.94906660200002, -9.16920338299991],
              [142.94060306100005, -9.17937590899993],
              [142.920258009, -9.19036223799992],
              [142.8735457690001, -9.209405205999929],
              [142.83814537900003, -9.236504815999922],
              [142.7309676440001, -9.277764580999929],
              [142.71452884200005, -9.287855726999908],
              [142.70777428500003, -9.299493096999925],
              [142.65259850400003, -9.330254815999922],
              [142.61247806100005, -9.334649346999925],
              [142.57732181100005, -9.323825778999947],
              [142.54712975400003, -9.304131768999923],
              [142.49919681100005, -9.26336028399993],
              [142.46509850400003, -9.240492445999905],
              [142.42896569100003, -9.225030205999929],
              [142.399261915, -9.22779713299991],
              [142.3730574880001, -9.21453215899993],
              [142.35767662900003, -9.209405205999929],
              [142.33423912900003, -9.207452080999929],
              [142.31910241000003, -9.203708591999941],
              [142.275726759, -9.17937590899993],
              [142.22339928500003, -9.161228122999944],
              [142.21070397200003, -9.158949476999908],
              [142.19996178500003, -9.16220468499995],
              [142.18091881600003, -9.176202080999929],
              [142.169281446, -9.17937590899993],
              [142.13559004, -9.178399346999925],
              [141.99398847700002, -9.188653252999927],
              [141.973968946, -9.192803643999923],
              [141.91334069100003, -9.21461353999996],
              [141.892914259, -9.218926690999922],
              [141.86841881600003, -9.22039153399993],
              [141.84742272200003, -9.217217705999929],
              [141.805511915, -9.203301690999922],
              [141.78296959700003, -9.199883721999925],
              [141.6982528000001, -9.215101820999905],
              [141.67310631600003, -9.213555596999925],
              [141.66480553500003, -9.220147393999923],
              [141.65064537900003, -9.226739190999922],
              [141.63493899800005, -9.232028903999947],
              [141.62126712300005, -9.23406340899993],
              [141.60572350400003, -9.228773695999905],
              [141.5927840500001, -9.21884530999995],
              [141.57935631600003, -9.21298593499995],
              [141.56324303500003, -9.22039153399993],
              [141.55103600400003, -9.21843840899993],
              [141.53003991000003, -9.218194268999923],
              [141.51002037900003, -9.215020440999922],
              [141.49488366000003, -9.194512627999927],
              [141.45337975400003, -9.16578541499996],
              [141.42172285200002, -9.150323174999926],
              [141.38453209700003, -9.141696872999944],
              [141.34587649800005, -9.14153411299992],
              [141.31006920700008, -9.15211353999996],
              [141.23194420700008, -9.21266041499996],
              [141.2002059250001, -9.22779713299991],
              [141.15259850400003, -9.23219166499996],
              [141.11500084700003, -9.21843840899993],
              [141.0078231130001, -9.124200127999927],
              [140.9769800140001, -9.106133721999925],
              [140.9771619060001, -8.99107798199995],
              [140.97752364100012, -8.798221536999947],
              [140.97762699400005, -8.611152851999933],
              [140.97731693600014, -8.434936217999862],
              [140.97700687700006, -8.1701461789999],
              [140.97690352400002, -8.001991068999914],
              [140.97690352400002, -7.962096862999971],
              [140.97690352400002, -7.772857767999952],
              [140.97690352400002, -7.587546080999914],
              [140.97690352400002, -7.323686217999921],
              [140.97690352400002, -7.282758482999895],
              [140.97700687700006, -7.157081399999939],
              [140.97700687700006, -7.004739277999946],
              [140.9771619060001, -6.896632181999891],
              [140.962175741, -6.897975768999942],
              [140.9433138440001, -6.888053893999952],
              [140.93969649300004, -6.856324564999923],
              [140.916028687, -6.862732441999881],
              [140.9083288980001, -6.849296569999922],
              [140.90672692900006, -6.828212584999989],
              [140.90161096300005, -6.812192890999938],
              [140.88243900600008, -6.798240254999939],
              [140.87417077700002, -6.789455260999958],
              [140.87086348600013, -6.778396503999957],
              [140.87324060100008, -6.773642272999965],
              [140.88269738800005, -6.760619811999931],
              [140.884506063, -6.753901875999901],
              [140.87871830300003, -6.742223001999932],
              [140.8578410240001, -6.723619486999965],
              [140.85039961800015, -6.712974140999975],
              [140.84921106000002, -6.702845559999929],
              [140.85174320500005, -6.693957213999909],
              [140.8571692310001, -6.682174986999911],
              [140.86579919400003, -6.649205423999945],
              [140.86492069500002, -6.630601908999907],
              [140.85039961800015, -6.623573913999891],
              [140.8592879640001, -6.608381041999863],
              [140.87391239500005, -6.603420104999913],
              [140.89055220600005, -6.599802754999928],
              [140.9049699310001, -6.589467467999924],
              [140.90331628400014, -6.582129413999922],
              [140.896494996, -6.573034362999863],
              [140.8929809980001, -6.565386249999975],
              [140.90161096300005, -6.562078958999891],
              [140.90987919100013, -6.561355488999894],
              [140.91509851100005, -6.558461608999906],
              [140.917837362, -6.553087259999941],
              [140.91876753800005, -6.527869160999984],
              [140.92098962400013, -6.516396992999958],
              [140.9282243250001, -6.509679055999939],
              [140.94346887200004, -6.507508645999863],
              [140.950186809, -6.498723652999956],
              [140.9531323660001, -6.480533548999929],
              [140.94858483900015, -6.465547383999947],
              [140.93282352700015, -6.465960794999958],
              [140.93318526200005, -6.453765156999864],
              [140.9299813240001, -6.444980163999958],
              [140.92316003500002, -6.439812519999862],
              [140.91251469000014, -6.438572285999925],
              [140.92129968300003, -6.433921406999957],
              [140.93101485200015, -6.431440937999895],
              [140.94155684400005, -6.430924173999941],
              [140.9528223060001, -6.431750996999966],
              [140.950186809, -6.41893524199989],
              [140.95561283400002, -6.411287129999906],
              [140.963157593, -6.404259135],
              [140.96708500200015, -6.393923847999901],
              [140.9646562100001, -6.388032734999896],
              [140.9549927170001, -6.379661152999915],
              [140.9528223060001, -6.373770039999911],
              [140.95385583500007, -6.370152689999927],
              [140.9586617440001, -6.368085631999875],
              [140.96372603400005, -6.348035175999925],
              [140.97287276200012, -6.336563008999903],
              [140.97690352400002, -6.33511606799992],
              [140.97690352400002, -6.229386087999984],
              [140.97690352400002, -6.002113137999928],
              [140.97690352400002, -5.806466165999964],
              [140.97690352400002, -5.621154478999927],
              [140.97690352400002, -5.363805846999909],
              [140.97690352400002, -5.322878112999973],
              [140.97690352400002, -5.197407734999985],
              [140.97690352400002, -5.002277526999876],
              [140.97690352400002, -4.999487],
              [140.976870791, -4.988486058999896],
              [140.97623173000005, -4.77371266699987],
              [140.97576664300004, -4.595945739999962],
              [140.97473311400006, -4.173645934999925],
              [140.97421635, -4.002286884999961],
              [140.9735445560001, -3.800025329999912],
              [140.97318282100002, -3.581744079999908],
              [140.972355998, -3.250601500999935],
              [140.97328617400007, -3.002451272999906],
              [140.9739062910001, -2.807321064999897],
              [140.9744747320001, -2.63120778399994],
              [140.97445722700002, -2.600518487999921],
            ],
          ],
          [
            [
              [153.76156660200002, -11.585870049999926],
              [153.766449415, -11.58879973799992],
              [153.77295983200008, -11.59075286299992],
              [153.77881920700008, -11.59343840899993],
              [153.78093509200005, -11.59889088299991],
              [153.77808678500003, -11.608982028999947],
              [153.772797071, -11.611993096999925],
              [153.76677493600005, -11.610121351999908],
              [153.76156660200002, -11.605075778999947],
              [153.753265821, -11.610446872999944],
              [153.74724368600005, -11.612074476999908],
              [153.74105879, -11.610446872999944],
              [153.73308353000004, -11.605075778999947],
              [153.72242272200003, -11.613539320999905],
              [153.710297071, -11.61809661299992],
              [153.697601759, -11.617933851999908],
              [153.68531334700003, -11.612481377999927],
              [153.68132571700005, -11.62468840899993],
              [153.6757918630001, -11.625746351999908],
              [153.6689559250001, -11.62200286299992],
              [153.6611434250001, -11.619398695999905],
              [153.61695397200003, -11.619398695999905],
              [153.61158287900003, -11.61842213299991],
              [153.60824629, -11.61256275799991],
              [153.60279381600003, -11.612481377999927],
              [153.59742272200003, -11.615411065999922],
              [153.58936608200008, -11.62428150799991],
              [153.586273634, -11.626153252999927],
              [153.575043165, -11.630303643999923],
              [153.5644637380001, -11.636325778999947],
              [153.55534915500004, -11.63567473799992],
              [153.5488387380001, -11.619398695999905],
              [153.5576278000001, -11.62037525799991],
              [153.56609134200005, -11.61882903399993],
              [153.5712996750001, -11.614027601999908],
              [153.56983483200008, -11.605075778999947],
              [153.56413821700005, -11.59929778399993],
              [153.55689537900003, -11.599867445999905],
              [153.54835045700008, -11.60320403399993],
              [153.538422071, -11.605075778999947],
              [153.52955162900003, -11.602146091999941],
              [153.524261915, -11.59547291499996],
              [153.52076256600003, -11.58879973799992],
              [153.51734459700003, -11.585870049999926],
              [153.5068465500001, -11.587497653999947],
              [153.498383009, -11.590264580999929],
              [153.4902449880001, -11.59075286299992],
              [153.479828321, -11.585870049999926],
              [153.48267662900003, -11.58171965899993],
              [153.4873153000001, -11.570977471999925],
              [153.47803795700008, -11.57000090899993],
              [153.47339928500003, -11.566827080999929],
              [153.47193444100003, -11.56064218499995],
              [153.472992384, -11.55046965899993],
              [153.46273847700002, -11.558526299999926],
              [153.45460045700008, -11.567803643999923],
              [153.446136915, -11.575372002999927],
              [153.4355574880001, -11.578383070999905],
              [153.39795983200008, -11.557305596999925],
              [153.38233483200008, -11.56609465899993],
              [153.37281334700003, -11.559014580999929],
              [153.36882571700005, -11.544366143999923],
              [153.36996504, -11.529961846999925],
              [153.37647545700008, -11.522230726999908],
              [153.3857528000001, -11.513929945999905],
              [153.3906356130001, -11.504978122999944],
              [153.383636915, -11.495212497999944],
              [153.37281334700003, -11.490899346999925],
              [153.3681746750001, -11.49423593499995],
              [153.36548912900003, -11.500176690999922],
              [153.36011803500003, -11.50318775799991],
              [153.35328209700003, -11.501071872999944],
              [153.3481551440001, -11.49618905999995],
              [153.34327233200008, -11.489027601999908],
              [153.3281356130001, -11.494073174999926],
              [153.31316165500004, -11.50318775799991],
              [153.2880965500001, -11.52312590899993],
              [153.2832137380001, -11.502618096999925],
              [153.32252037900003, -11.484307549999926],
              [153.3222762380001, -11.46851978999996],
              [153.31324303500003, -11.463311455999929],
              [153.2910262380001, -11.463474216999941],
              [153.2812606130001, -11.461114190999922],
              [153.27173912900003, -11.453301690999922],
              [153.26002037900003, -11.434665622999944],
              [153.2504988940001, -11.42392343499995],
              [153.24293053500003, -11.422458591999941],
              [153.2348738940001, -11.42587655999995],
              [153.2285262380001, -11.426527601999908],
              [153.22608483200008, -11.417087497999944],
              [153.2314559250001, -11.39576588299991],
              [153.22925866000003, -11.38876718499995],
              [153.21607506600003, -11.385918877999927],
              [153.20915774800005, -11.382989190999922],
              [153.2011824880001, -11.37590911299992],
              [153.19459069100003, -11.367852471999925],
              [153.191742384, -11.361748955999929],
              [153.19288170700008, -11.349541924999926],
              [153.19597415500004, -11.338474216999941],
              [153.2055770190001, -11.317071221999925],
              [153.2578231130001, -11.353448174999926],
              [153.27751712300005, -11.35865650799991],
              [153.296234571, -11.35320403399993],
              [153.30494225400003, -11.35328541499996],
              [153.31218509200005, -11.369805596999925],
              [153.32105553500003, -11.373467705999929],
              [153.332367384, -11.375746351999908],
              [153.34327233200008, -11.379164320999905],
              [153.36695397200003, -11.394952080999929],
              [153.3774520190001, -11.39967213299991],
              [153.4008895190001, -11.404473565999922],
              [153.4111434250001, -11.40829843499995],
              [153.43930097700002, -11.431084893999923],
              [153.5009871750001, -11.45484791499996],
              [153.5478621750001, -11.484633070999905],
              [153.5590926440001, -11.489027601999908],
              [153.580414259, -11.490166924999926],
              [153.695648634, -11.52125416499996],
              [153.70582116000003, -11.526543877999927],
              [153.70850670700008, -11.537286065999922],
              [153.71599368600005, -11.547133070999905],
              [153.72584069100003, -11.55437590899993],
              [153.74773196700005, -11.56064218499995],
              [153.7539168630001, -11.568536065999922],
              [153.76156660200002, -11.585870049999926],
            ],
          ],
          [
            [
              [154.2817488940001, -11.348239841999941],
              [154.28337649800005, -11.357842705999929],
              [154.2876082690001, -11.37004973799992],
              [154.29420006600003, -11.38062916499996],
              [154.30225670700008, -11.385918877999927],
              [154.2954207690001, -11.397881768999923],
              [154.28834069100003, -11.407403252999927],
              [154.27955162900003, -11.414808851999908],
              [154.2680770190001, -11.420668226999908],
              [154.25993899800005, -11.405694268999923],
              [154.24170983200008, -11.397881768999923],
              [154.21949303500003, -11.39617278399993],
              [154.198578321, -11.39967213299991],
              [154.163422071, -11.41773853999996],
              [154.1489363940001, -11.416273695999905],
              [154.14470462300005, -11.392185153999947],
              [154.13843834700003, -11.392185153999947],
              [154.132172071, -11.418389580999929],
              [154.117523634, -11.42945728999996],
              [154.0962020190001, -11.429131768999923],
              [154.06950931100005, -11.420668226999908],
              [154.05486087300005, -11.421807549999926],
              [154.04615319100003, -11.41725025799991],
              [154.04224694100003, -11.403090101999908],
              [154.03834069100003, -11.396661065999922],
              [154.02881920700008, -11.391289971999925],
              [154.01734459700003, -11.387465101999908],
              [154.00749759200005, -11.385918877999927],
              [154.01238040500004, -11.37859465899993],
              [154.01880944100003, -11.37273528399993],
              [154.0263778000001, -11.368259372999944],
              [154.03541100400003, -11.36492278399993],
              [154.0302840500001, -11.36101653399993],
              [154.02116946700005, -11.34498463299991],
              [154.02759850400003, -11.344333591999941],
              [154.03101647200003, -11.34579843499995],
              [154.03541100400003, -11.35125090899993],
              [154.052093946, -11.36060963299991],
              [154.0962020190001, -11.363457940999922],
              [154.11736087300005, -11.37232838299991],
              [154.12476647200003, -11.36492278399993],
              [154.1372176440001, -11.370700778999947],
              [154.14332116000003, -11.368340752999927],
              [154.1435653000001, -11.360935153999947],
              [154.13843834700003, -11.35125090899993],
              [154.13103274800005, -11.35125090899993],
              [154.13103274800005, -11.35865650799991],
              [154.12476647200003, -11.35865650799991],
              [154.11744225400003, -11.354668877999927],
              [154.110687696, -11.350030205999929],
              [154.1074324880001, -11.34465911299992],
              [154.11052493600005, -11.338148695999905],
              [154.1015731130001, -11.33407968499995],
              [154.09522545700008, -11.328301690999922],
              [154.091156446, -11.320570570999905],
              [154.09001712300005, -11.310804945999905],
              [154.10954837300005, -11.316989841999941],
              [154.1372176440001, -11.317152601999908],
              [154.1787215500001, -11.310804945999905],
              [154.19019616000003, -11.316338799999926],
              [154.19890384200005, -11.31568775799991],
              [154.20679772200003, -11.312758070999905],
              [154.21631920700008, -11.310804945999905],
              [154.22535241000003, -11.31536223799992],
              [154.22966556100005, -11.323825778999947],
              [154.2348738940001, -11.329196872999944],
              [154.2470809250001, -11.324476820999905],
              [154.2675887380001, -11.333184502999927],
              [154.27759850400003, -11.339450778999947],
              [154.2817488940001, -11.348239841999941],
            ],
          ],
          [
            [
              [153.18506920700008, -11.27743905999995],
              [153.19483483200008, -11.271416924999926],
              [153.1992293630001, -11.269952080999929],
              [153.1992293630001, -11.263116143999923],
              [153.17139733200008, -11.242608330999929],
              [153.1640731130001, -11.248793226999908],
              [153.15984134200005, -11.24700286299992],
              [153.15609785200002, -11.241306247999944],
              [153.1508895190001, -11.235772393999923],
              [153.1162215500001, -11.215264580999929],
              [153.10108483200008, -11.197930596999925],
              [153.1045028000001, -11.185479424999926],
              [153.11703535200002, -11.180840752999927],
              [153.129730665, -11.187432549999926],
              [153.14234459700003, -11.197523695999905],
              [153.191742384, -11.207777601999908],
              [153.23560631600003, -11.238539320999905],
              [153.2539168630001, -11.242608330999929],
              [153.25025475400003, -11.251560153999947],
              [153.24333743600005, -11.26344166499996],
              [153.23389733200008, -11.270928643999923],
              [153.22291100400003, -11.26653411299992],
              [153.22055097700002, -11.270928643999923],
              [153.2109481130001, -11.276055596999925],
              [153.1977645190001, -11.279229424999926],
              [153.18506920700008, -11.27743905999995],
            ],
          ],
          [
            [
              [152.80827884200005, -10.63250090899993],
              [152.81625410200002, -10.632989190999922],
              [152.8505965500001, -10.645928643999923],
              [152.86280358200008, -10.653497002999927],
              [152.87183678500003, -10.665459893999923],
              [152.8711043630001, -10.674411716999941],
              [152.86312910200002, -10.681573174999926],
              [152.84986412900003, -10.687676690999922],
              [152.83904056100005, -10.69068775799991],
              [152.79468834700003, -10.694512627999927],
              [152.7832137380001, -10.696872653999947],
              [152.7636824880001, -10.705254815999922],
              [152.75367272200003, -10.708184502999927],
              [152.73121178500003, -10.70680103999996],
              [152.70329837300005, -10.69898853999996],
              [152.64380944100003, -10.674086195999905],
              [152.58228600400003, -10.660332940999922],
              [152.54078209700003, -10.63250090899993],
              [152.54078209700003, -10.625664971999925],
              [152.547699415, -10.626397393999923],
              [152.5507918630001, -10.624444268999923],
              [152.55225670700008, -10.621514580999929],
              [152.55445397200003, -10.61882903399993],
              [152.619476759, -10.637872002999927],
              [152.63355553500003, -10.636163018999923],
              [152.64323978000004, -10.63648853999996],
              [152.67335045700008, -10.655368747999944],
              [152.68482506600003, -10.660332940999922],
              [152.7153426440001, -10.651543877999927],
              [152.7500106130001, -10.63372161299992],
              [152.78288821700005, -10.622247002999927],
              [152.80827884200005, -10.63250090899993],
            ],
          ],
          [
            [
              [151.0747176440001, -10.605726820999905],
              [151.04704837300005, -10.627373955999929],
              [151.0449324880001, -10.63681405999995],
              [151.06788170700008, -10.63990650799991],
              [151.06226647200003, -10.644707940999922],
              [151.05225670700008, -10.65553150799991],
              [151.04672285200002, -10.660332940999922],
              [151.04639733200008, -10.66969166499996],
              [151.03199303500003, -10.671075127999927],
              [151.01514733200008, -10.662530205999929],
              [151.00709069100003, -10.642998955999929],
              [150.99830162900003, -10.635430596999925],
              [150.95476321700005, -10.635511976999908],
              [150.936859571, -10.63250090899993],
              [150.93287194100003, -10.647067966999941],
              [150.9340926440001, -10.660739841999941],
              [150.93376712300005, -10.672133070999905],
              [150.92448978000004, -10.680271091999941],
              [150.9145613940001, -10.65211353999996],
              [150.91236412900003, -10.637790622999944],
              [150.9170028000001, -10.61882903399993],
              [150.92367597700002, -10.60833098799992],
              [150.9340926440001, -10.599867445999905],
              [150.94792728000004, -10.594170830999929],
              [150.9648543630001, -10.59148528399993],
              [151.0200301440001, -10.59148528399993],
              [151.02881920700008, -10.594333591999941],
              [151.03825931100005, -10.602959893999923],
              [151.04672285200002, -10.605726820999905],
              [151.05445397200003, -10.603448174999926],
              [151.05779056100005, -10.59734465899993],
              [151.06080162900003, -10.59384530999995],
              [151.06788170700008, -10.598321221999925],
              [151.0688582690001, -10.601820570999905],
              [151.068695509, -10.604668877999927],
              [151.06999759200005, -10.606215101999908],
              [151.0747176440001, -10.605726820999905],
            ],
          ],
          [
            [
              [150.8754988940001, -10.536309502999927],
              [150.88795006600003, -10.542168877999927],
              [150.89918053500003, -10.55087655999995],
              [150.90186608200008, -10.56259530999995],
              [150.8891707690001, -10.57781340899993],
              [150.8964949880001, -10.584649346999925],
              [150.892914259, -10.59465911299992],
              [150.8925887380001, -10.608982028999947],
              [150.8891707690001, -10.61882903399993],
              [150.89568118600005, -10.629327080999929],
              [150.8964949880001, -10.638929945999905],
              [150.891937696, -10.647149346999925],
              [150.88233483200008, -10.653497002999927],
              [150.86304772200003, -10.64430103999996],
              [150.83806399800005, -10.636163018999923],
              [150.8129988940001, -10.633396091999941],
              [150.7934676440001, -10.63990650799991],
              [150.78288821700005, -10.619805596999925],
              [150.77556399800005, -10.61109791499996],
              [150.76685631600003, -10.605726820999905],
              [150.77369225400003, -10.598321221999925],
              [150.7876082690001, -10.60833098799992],
              [150.80396569100003, -10.61687590899993],
              [150.82203209700003, -10.62273528399993],
              [150.84131920700008, -10.625664971999925],
              [150.860199415, -10.62590911299992],
              [150.8657332690001, -10.623467705999929],
              [150.86060631600003, -10.617120049999926],
              [150.7934676440001, -10.55836353999996],
              [150.7880965500001, -10.549411716999941],
              [150.790375196, -10.53997161299992],
              [150.79957116000003, -10.534600518999923],
              [150.80884850400003, -10.536309502999927],
              [150.816742384, -10.542575778999947],
              [150.82146243600005, -10.55046965899993],
              [150.835297071, -10.54859791499996],
              [150.84913170700008, -10.548272393999923],
              [150.86255944100003, -10.545586846999925],
              [150.8754988940001, -10.536309502999927],
            ],
          ],
          [
            [
              [151.17701256600003, -9.954685153999947],
              [151.20492597700002, -9.935967705999929],
              [151.24634850400003, -9.922295830999929],
              [151.28394616000003, -9.927911065999922],
              [151.30062910200002, -9.96770598799992],
              [151.29639733200008, -9.988702080999929],
              [151.27759850400003, -10.031914971999925],
              [151.26929772200003, -10.074639580999929],
              [151.239105665, -10.13290780999995],
              [151.23226972700002, -10.138929945999905],
              [151.236664259, -10.149590752999927],
              [151.22681725400003, -10.182061455999929],
              [151.23226972700002, -10.20045338299991],
              [151.2119246750001, -10.186700127999927],
              [151.1757918630001, -10.156426690999922],
              [151.156586134, -10.146416924999926],
              [151.05420983200008, -10.118584893999923],
              [151.00709069100003, -10.111748955999929],
              [150.985687696, -10.111748955999929],
              [150.970062696, -10.110039971999925],
              [150.9580184250001, -10.104913018999923],
              [150.95386803500003, -10.08961353999996],
              [150.95036868600005, -10.060153903999947],
              [150.95232181100005, -10.03411223799992],
              [150.9648543630001, -10.02906666499996],
              [150.9726668630001, -10.01921965899993],
              [150.98560631600003, -10.00562916499996],
              [150.992523634, -9.99382903399993],
              [150.98218834700003, -9.988864841999941],
              [150.97543379, -9.984307549999926],
              [150.96550540500004, -9.973809502999927],
              [150.95045006600003, -9.954685153999947],
              [150.9443465500001, -9.954685153999947],
              [150.94654381600003, -9.980889580999929],
              [150.92896569100003, -9.996758721999925],
              [150.9072371750001, -9.99732838299991],
              [150.8964949880001, -9.977959893999923],
              [150.8945418630001, -9.970147393999923],
              [150.89014733200008, -9.96656666499996],
              [150.8852645190001, -9.964450778999947],
              [150.88233483200008, -9.960870049999926],
              [150.881195509, -9.952732028999947],
              [150.88233483200008, -9.903008721999925],
              [150.8789168630001, -9.896091403999947],
              [150.85816491000003, -9.868340752999927],
              [150.85499108200008, -9.861504815999922],
              [150.85222415500004, -9.848809502999927],
              [150.845062696, -9.839043877999927],
              [150.83521569100003, -9.832777601999908],
              [150.81470787900003, -9.82781340899993],
              [150.8110457690001, -9.821384372999944],
              [150.80982506600003, -9.81414153399993],
              [150.8071395190001, -9.809340101999908],
              [150.80152428500003, -9.80787525799991],
              [150.78589928500003, -9.805759372999944],
              [150.7797957690001, -9.803317966999941],
              [150.76905358200008, -9.793715101999908],
              [150.76050866000003, -9.78329843499995],
              [150.75513756600003, -9.770114841999941],
              [150.75318444100003, -9.75204843499995],
              [150.75416100400003, -9.735446872999944],
              [150.75757897200003, -9.715590101999908],
              [150.76392662900003, -9.70281340899993],
              [150.7929793630001, -9.717543226999908],
              [150.81275475400003, -9.732354424999926],
              [150.82829837300005, -9.750664971999925],
              [150.8344832690001, -9.772230726999908],
              [150.844086134, -9.794528903999947],
              [150.86695397200003, -9.808200778999947],
              [150.89421634200005, -9.818536065999922],
              [150.9170028000001, -9.830498955999929],
              [150.98218834700003, -9.902927341999941],
              [150.99984785200002, -9.91334400799991],
              [151.02466881600003, -9.922621351999908],
              [151.04810631600003, -9.935153903999947],
              [151.06169681100005, -9.954685153999947],
              [151.03825931100005, -9.94850025799991],
              [151.03150475400003, -9.96379973799992],
              [151.03541100400003, -9.984551690999922],
              [151.04363040500004, -9.99504973799992],
              [151.05445397200003, -10.000746351999908],
              [151.08969160200002, -10.027927341999941],
              [151.10889733200008, -10.036553643999923],
              [151.12761478000004, -10.042168877999927],
              [151.13502037900003, -10.04192473799992],
              [151.142914259, -10.036553643999923],
              [151.14869225400003, -10.026543877999927],
              [151.15015709700003, -10.01531340899993],
              [151.14722741000003, -10.006117445999905],
              [151.13949629, -10.002536716999941],
              [151.13884524800005, -9.994886976999908],
              [151.15251712300005, -9.978448174999926],
              [151.17701256600003, -9.954685153999947],
            ],
          ],
          [
            [
              [150.80095462300005, -9.65243905999995],
              [150.8046981130001, -9.669528903999947],
              [150.78500410200002, -9.66765715899993],
              [150.74236087300005, -9.65243905999995],
              [150.67945397200003, -9.659356377999927],
              [150.65699303500003, -9.659274997999944],
              [150.62256920700008, -9.649997653999947],
              [150.58765709700003, -9.634698174999926],
              [150.5493270190001, -9.623223565999922],
              [150.50554446700005, -9.62509530999995],
              [150.46648196700005, -9.631117445999905],
              [150.4336043630001, -9.631280205999929],
              [150.42986087300005, -9.62428150799991],
              [150.44450931100005, -9.608819268999923],
              [150.47820071700005, -9.584161065999922],
              [150.50220787900003, -9.57203541499996],
              [150.512054884, -9.560967705999929],
              [150.5136824880001, -9.54697030999995],
              [150.51295006600003, -9.525811455999929],
              [150.50562584700003, -9.51572030999995],
              [150.45777428500003, -9.48796965899993],
              [150.42693118600005, -9.418715101999908],
              [150.42359459700003, -9.388929945999905],
              [150.4321395190001, -9.36532968499995],
              [150.4531356130001, -9.34856536299992],
              [150.47999108200008, -9.33912525799991],
              [150.50554446700005, -9.33766041499996],
              [150.563812696, -9.367852471999925],
              [150.59742272200003, -9.37704843499995],
              [150.61052493600005, -9.389092705999929],
              [150.62907962300005, -9.412774346999925],
              [150.65609785200002, -9.431084893999923],
              [150.6738387380001, -9.438653252999927],
              [150.68734785200002, -9.436700127999927],
              [150.70655358200008, -9.42701588299991],
              [150.72641035200002, -9.424248955999929],
              [150.74488366000003, -9.418389580999929],
              [150.75945071700005, -9.399183851999908],
              [150.79835045700008, -9.425713799999926],
              [150.829437696, -9.454685153999947],
              [150.8344832690001, -9.461195570999905],
              [150.835297071, -9.467217705999929],
              [150.83326256600003, -9.48219166499996],
              [150.8344832690001, -9.48796965899993],
              [150.84441165500004, -9.497165622999944],
              [150.8584090500001, -9.506117445999905],
              [150.87330162900003, -9.513116143999923],
              [150.8857528000001, -9.515801690999922],
              [150.88835696700005, -9.521416924999926],
              [150.88233483200008, -9.56023528399993],
              [150.87769616000003, -9.567559502999927],
              [150.86931399800005, -9.570489190999922],
              [150.86353600400003, -9.57431405999995],
              [150.868011915, -9.584161065999922],
              [150.8798934250001, -9.59156666499996],
              [150.8911238940001, -9.59189218499995],
              [150.8994246750001, -9.594170830999929],
              [150.90650475400003, -9.619724216999941],
              [150.914886915, -9.625583591999941],
              [150.9243270190001, -9.63014088299991],
              [150.9306746750001, -9.63876718499995],
              [150.93091881600003, -9.65243905999995],
              [150.92465254, -9.664239190999922],
              [150.9145613940001, -9.67359791499996],
              [150.902679884, -9.67978280999995],
              [150.89234459700003, -9.669040622999944],
              [150.87517337300005, -9.68059661299992],
              [150.84131920700008, -9.713962497999944],
              [150.8418074880001, -9.697442315999922],
              [150.85230553500003, -9.67359791499996],
              [150.85499108200008, -9.662367445999905],
              [150.8481551440001, -9.65398528399993],
              [150.83228600400003, -9.65129973799992],
              [150.80095462300005, -9.65243905999995],
            ],
          ],
          [
            [
              [150.36890709700003, -9.371840101999908],
              [150.3701278000001, -9.371514580999929],
              [150.37859134200005, -9.38176848799992],
              [150.38062584700003, -9.386895440999922],
              [150.377289259, -9.39072030999995],
              [150.37232506600003, -9.39421965899993],
              [150.36890709700003, -9.399183851999908],
              [150.36394290500004, -9.41497161299992],
              [150.34742272200003, -9.451592705999929],
              [150.33765709700003, -9.464288018999923],
              [150.33521569100003, -9.471286716999941],
              [150.34400475400003, -9.473809502999927],
              [150.36150149800005, -9.47429778399993],
              [150.36207116000003, -9.483493747999944],
              [150.36060631600003, -9.49032968499995],
              [150.35523522200003, -9.50164153399993],
              [150.33765709700003, -9.519707940999922],
              [150.31226647200003, -9.519463799999926],
              [150.28435306100005, -9.50872161299992],
              [150.25961347700002, -9.49537525799991],
              [150.25757897200003, -9.497979424999926],
              [150.2568465500001, -9.498793226999908],
              [150.25570722700002, -9.49968840899993],
              [150.25163821700005, -9.50164153399993],
              [150.25261478000004, -9.486504815999922],
              [150.25147545700008, -9.470961195999905],
              [150.24626712300005, -9.45875416499996],
              [150.235199415, -9.453789971999925],
              [150.2192488940001, -9.451592705999929],
              [150.1806746750001, -9.440118096999925],
              [150.17164147200003, -9.43564218499995],
              [150.16529381600003, -9.424981377999927],
              [150.15967858200008, -9.412692966999941],
              [150.153168165, -9.402520440999922],
              [150.114105665, -9.36923593499995],
              [150.10824629, -9.36101653399993],
              [150.10889733200008, -9.328301690999922],
              [150.11280358200008, -9.299411716999941],
              [150.12289472700002, -9.27271900799991],
              [150.14234459700003, -9.24773528399993],
              [150.16553795700008, -9.227146091999941],
              [150.1899520190001, -9.21184661299992],
              [150.21452884200005, -9.205824476999908],
              [150.238617384, -9.213555596999925],
              [150.29167728000004, -9.241794528999947],
              [150.3154403000001, -9.25945403399993],
              [150.33423912900003, -9.28248463299991],
              [150.35279381600003, -9.326348565999922],
              [150.35710696700005, -9.350192966999941],
              [150.365570509, -9.364027601999908],
              [150.36890709700003, -9.371840101999908],
            ],
          ],
          [
            [
              [152.995468651, -9.141298770999924],
              [153.012054884, -9.149102471999925],
              [152.996131461, -9.160917007999956],
              [152.989105665, -9.172295830999929],
              [152.99424725200004, -9.178646982999908],
              [152.99040537300004, -9.184346237999932],
              [152.985923113, -9.192576925999958],
              [152.97565442100006, -9.195742468999924],
              [152.96537025600003, -9.190042839999933],
              [152.95764887400003, -9.181810878999954],
              [152.945443082, -9.174848199999929],
              [152.9390409140001, -9.179914314999905],
              [152.929446643, -9.191946342999927],
              [152.93202914100004, -9.19954627699991],
              [152.95066998900006, -9.213484363999953],
              [152.96994734200007, -9.229314563999935],
              [152.97574463600006, -9.245777701999941],
              [152.96741572200006, -9.256545694999943],
              [152.96099869300008, -9.257179975999918],
              [152.9558457400001, -9.241982049999933],
              [152.94235621100006, -9.228055407999932],
              [152.92182855400006, -9.228692529999933],
              [152.89427218000003, -9.250228825999955],
              [152.854512375, -9.254030478999937],
              [152.8346385870001, -9.259733643999937],
              [152.827581634, -9.25340087099994],
              [152.81155399200009, -9.25467256199994],
              [152.80321411300008, -9.240113975999918],
              [152.78782386900002, -9.222394108999936],
              [152.7737204550001, -9.216069390999905],
              [152.75900595400003, -9.203320868999924],
              [152.7513066460001, -9.190076055999953],
              [152.7442341630001, -9.181268336999949],
              [152.73846605200004, -9.193925450999927],
              [152.7269349070001, -9.204042562999916],
              [152.72954475400002, -9.219139425999913],
              [152.75320902700003, -9.22366956299993],
              [152.75192575900007, -9.242034075999925],
              [152.7358956920001, -9.260399648999908],
              [152.7205216000001, -9.231891417999918],
              [152.70063735400004, -9.223685269999919],
              [152.67245175800008, -9.213539830999935],
              [152.65575612600003, -9.204073237999921],
              [152.64421583700005, -9.182558160999918],
              [152.6506342560001, -9.168000889999917],
              [152.67243119800003, -9.185085557999912],
              [152.695545884, -9.18631681599993],
              [152.6899520190001, -9.17156340899993],
              [152.6953231130001, -9.162367445999905],
              [152.70240319100003, -9.157810153999947],
              [152.70883222700002, -9.156914971999925],
              [152.71436608200008, -9.154473565999922],
              [152.70451060900007, -9.144571262999932],
              [152.696815142, -9.13951377299992],
              [152.685275337, -9.133822215999942],
              [152.66475824500003, -9.12370126199994],
              [152.63591240900007, -9.100287315999935],
              [152.61347342400006, -9.084462870999914],
              [152.59809672400002, -9.06863883199992],
              [152.57305665900003, -9.078119615999924],
              [152.56407988600006, -9.07241949999991],
              [152.551884459, -9.061019022999915],
              [152.53583165400005, -9.050877686999911],
              [152.50630032200002, -9.038825072999941],
              [152.47161988800008, -9.045130077999943],
              [152.4645443290001, -9.036886724999931],
              [152.49976647200003, -9.023044528999947],
              [152.49976647200003, -9.015557549999926],
              [152.4947338940001, -9.000178281999922],
              [152.4728854010001, -8.976076736999914],
              [152.45166620100008, -8.965270166999915],
              [152.42594857300003, -8.982342280999944],
              [152.4246616690001, -9.000085416999923],
              [152.42723572500006, -9.018466787999955],
              [152.42787130300007, -9.057751438999958],
              [152.42722362900008, -9.069788373999927],
              [152.42142441200008, -9.083721220999905],
              [152.4117924310001, -9.03365505499994],
              [152.38862331100006, -8.991154732999917],
              [152.40471454400006, -8.970896725999921],
              [152.4523043810001, -8.944989765999935],
              [152.4715900550001, -8.949458695999908],
              [152.5178699600001, -8.996409484999958],
              [152.59935580600006, -8.988879486999906],
              [152.642954346, -8.993334672999936],
              [152.66795984700002, -9.000312360999942],
              [152.70448423200003, -9.00601421999994],
              [152.73587481700008, -9.000318376999928],
              [152.75381293600003, -9.000947997999958],
              [152.77495363900005, -9.000954468999907],
              [152.794170807, -9.003496708999933],
              [152.808905718, -9.01043967499993],
              [152.817878016, -9.023721552999916],
              [152.8300487790001, -9.028147598999908],
              [152.84799866800006, -9.05913056099996],
              [152.8659414130001, -9.069884048999938],
              [152.89862374200004, -9.079355267999915],
              [152.91782971600003, -9.069856865999952],
              [152.94154168, -9.083757592999916],
              [152.95118870200008, -9.094505604999938],
              [152.94860867900002, -9.119811864999917],
              [152.973006306, -9.128024953999955],
              [152.995468651, -9.141298770999924],
            ],
          ],
          [
            [
              [151.11255944100003, -8.768649997999944],
              [151.12680097700002, -8.77662525799991],
              [151.13835696700005, -8.795342705999929],
              [151.1445418630001, -8.81617603999996],
              [151.142914259, -8.830661716999941],
              [151.13152103000004, -8.81845468499995],
              [151.1020613940001, -8.768649997999944],
              [151.0454207690001, -8.732842705999929],
              [151.04363040500004, -8.726983330999929],
              [151.04810631600003, -8.71884530999995],
              [151.0966903000001, -8.65357838299991],
              [151.1191512380001, -8.601739190999922],
              [151.122406446, -8.58294036299992],
              [151.119476759, -8.57903411299992],
              [151.1020613940001, -8.562432549999926],
              [151.08952884200005, -8.553806247999944],
              [151.08090254, -8.550225518999923],
              [151.02312259200005, -8.545342705999929],
              [151.0058699880001, -8.537530205999929],
              [150.9990340500001, -8.518161716999941],
              [151.01685631600003, -8.49382903399993],
              [151.0200301440001, -8.483982028999947],
              [151.02214603000004, -8.471774997999944],
              [151.02751712300005, -8.46184661299992],
              [151.04363040500004, -8.443291924999926],
              [151.0610457690001, -8.429620049999926],
              [151.0825301440001, -8.422458591999941],
              [151.129242384, -8.419122002999927],
              [151.1298934250001, -8.423760674999926],
              [151.128265821, -8.424981377999927],
              [151.1254988940001, -8.424899997999944],
              [151.122406446, -8.425957940999922],
              [151.1211043630001, -8.47429778399993],
              [151.11695397200003, -8.494724216999941],
              [151.10889733200008, -8.514743747999944],
              [151.139008009, -8.547621351999908],
              [151.13835696700005, -8.590590101999908],
              [151.10572350400003, -8.730645440999922],
              [151.10336347700002, -8.75709400799991],
              [151.11255944100003, -8.768649997999944],
            ],
          ],
          [
            [
              [143.6084090500001, -8.638116143999923],
              [143.62916100400003, -8.644707940999922],
              [143.64437910200002, -8.661309502999927],
              [143.652679884, -8.68336353999996],
              [143.65251712300005, -8.706475518999923],
              [143.64234459700003, -8.726169528999947],
              [143.6289168630001, -8.730401299999926],
              [143.61703535200002, -8.721856377999927],
              [143.61207116000003, -8.703383070999905],
              [143.605804884, -8.68922291499996],
              [143.59058678500003, -8.67937590899993],
              [143.47380618600005, -8.62468840899993],
              [143.4511824880001, -8.60751718499995],
              [143.439789259, -8.602227471999925],
              [143.42497806100005, -8.599541924999926],
              [143.41228274800005, -8.595635674999926],
              [143.4067488940001, -8.586683851999908],
              [143.400726759, -8.573418877999927],
              [143.33814537900003, -8.521742445999905],
              [143.28191165500004, -8.506280205999929],
              [143.255218946, -8.494805596999925],
              [143.244476759, -8.485446872999944],
              [143.2212020190001, -8.45322030999995],
              [143.2094832690001, -8.443617445999905],
              [143.1884871750001, -8.429864190999922],
              [143.17888431100005, -8.419122002999927],
              [143.19402103000004, -8.417413018999923],
              [143.207367384, -8.41415780999995],
              [143.219086134, -8.415134372999944],
              [143.25603274800005, -8.456963799999926],
              [143.27100670700008, -8.468926690999922],
              [143.3593856130001, -8.488539320999905],
              [143.4433699880001, -8.51848723799992],
              [143.46509850400003, -8.52157968499995],
              [143.47486412900003, -8.525323174999926],
              [143.481781446, -8.53443775799991],
              [143.49203535200002, -8.55250416499996],
              [143.5879012380001, -8.631442966999941],
              [143.6084090500001, -8.638116143999923],
            ],
          ],
          [
            [
              [143.3794051440001, -8.425957940999922],
              [143.35808353000004, -8.414727471999925],
              [143.33033287900003, -8.394138278999947],
              [143.31666100400003, -8.372247002999927],
              [143.3379012380001, -8.357598565999922],
              [143.35132897200003, -8.35719166499996],
              [143.3593856130001, -8.361748955999929],
              [143.36540774800005, -8.367608330999929],
              [143.37322024800005, -8.371270440999922],
              [143.3852645190001, -8.371270440999922],
              [143.41684004, -8.36451588299991],
              [143.4843856130001, -8.363539320999905],
              [143.57374108200008, -8.373711846999925],
              [143.58480879, -8.381280205999929],
              [143.58562259200005, -8.406426690999922],
              [143.58863366000003, -8.42083098799992],
              [143.60474694100003, -8.44703541499996],
              [143.61150149800005, -8.46217213299991],
              [143.61060631600003, -8.475030205999929],
              [143.60108483200008, -8.483575127999927],
              [143.58179772200003, -8.486748955999929],
              [143.53012129, -8.485528252999927],
              [143.5097762380001, -8.481133721999925],
              [143.4619246750001, -8.458184502999927],
              [143.44516035200002, -8.439060153999947],
              [143.42359459700003, -8.433038018999923],
              [143.3794051440001, -8.425957940999922],
            ],
          ],
          [
            [
              [148.049164259, -5.606133721999925],
              [148.07154381600003, -5.631605726999908],
              [148.077484571, -5.657810153999947],
              [148.06763756600003, -5.746840101999908],
              [148.04566491000003, -5.795830987999921],
              [148.03891035200002, -5.822035414999959],
              [148.02857506600003, -5.817478122999944],
              [148.02458743600005, -5.814629815999922],
              [148.02515709700003, -5.821465752999927],
              [148.024261915, -5.83521900799991],
              [148.02458743600005, -5.841973565999922],
              [148.01449629, -5.840020440999922],
              [148.006195509, -5.841973565999922],
              [147.9985457690001, -5.847588799999926],
              [147.99105879, -5.856215101999908],
              [147.98609459700003, -5.84343840899993],
              [147.98324629, -5.80982838299991],
              [147.977386915, -5.79420338299991],
              [147.96900475400003, -5.786228122999944],
              [147.9570418630001, -5.780450127999927],
              [147.929047071, -5.773695570999905],
              [147.89576256600003, -5.770684502999927],
              [147.88111412900003, -5.763767184999949],
              [147.867523634, -5.746351820999905],
              [147.86491946700005, -5.739353122999944],
              [147.860687696, -5.71843840899993],
              [147.85474694100003, -5.709730726999908],
              [147.81706790500004, -5.677504164999959],
              [147.8051863940001, -5.663506768999923],
              [147.78500410200002, -5.630303643999923],
              [147.76905358200008, -5.611748955999929],
              [147.76514733200008, -5.602959893999923],
              [147.76514733200008, -5.594821872999944],
              [147.77133222700002, -5.568942966999941],
              [147.76734459700003, -5.521254164999959],
              [147.77133222700002, -5.506931247999944],
              [147.78191165500004, -5.495293877999927],
              [147.8071395190001, -5.490817966999941],
              [147.81983483200008, -5.478936455999929],
              [147.8222762380001, -5.48406340899993],
              [147.825043165, -5.486097914999959],
              [147.8286238940001, -5.488051039999959],
              [147.83350670700008, -5.493096612999921],
              [147.83659915500004, -5.489434502999927],
              [147.8398543630001, -5.488051039999959],
              [147.84327233200008, -5.48756275799991],
              [147.84717858200008, -5.486423434999949],
              [147.85889733200008, -5.496758721999925],
              [147.881195509, -5.522556247999944],
              [147.894867384, -5.534112237999921],
              [147.90943444100003, -5.541192315999922],
              [147.949554884, -5.547784112999921],
              [147.9751082690001, -5.558200778999947],
              [148.00074303500003, -5.572360934999949],
              [148.049164259, -5.606133721999925],
            ],
          ],
          [
            [
              [155.93344160200002, -6.640801690999922],
              [155.93930097700002, -6.663018487999921],
              [155.9638778000001, -6.701918226999908],
              [155.96753991000003, -6.727146091999941],
              [155.9609481130001, -6.750176690999922],
              [155.94752037900003, -6.773207289999959],
              [155.9301863940001, -6.793633721999925],
              [155.91236412900003, -6.809014580999929],
              [155.9228621750001, -6.763441664999959],
              [155.92448978000004, -6.738213799999926],
              [155.91578209700003, -6.727146091999941],
              [155.90748131600003, -6.736993096999925],
              [155.87818444100003, -6.801527601999908],
              [155.8535262380001, -6.773532809999949],
              [155.8164168630001, -6.782159112999921],
              [155.77947024800005, -6.807549737999921],
              [155.755218946, -6.829522393999923],
              [155.73031660200002, -6.862399997999944],
              [155.7177840500001, -6.872816664999959],
              [155.69703209700003, -6.87664153399993],
              [155.685883009, -6.874607028999947],
              [155.66765384200005, -6.865166924999926],
              [155.655609571, -6.863051039999959],
              [155.610687696, -6.863051039999959],
              [155.56804446700005, -6.854099216999941],
              [155.52361087300005, -6.83912525799991],
              [155.44678795700008, -6.801527601999908],
              [155.40455162900003, -6.766778252999927],
              [155.3950301440001, -6.761325778999947],
              [155.37867272200003, -6.756768487999921],
              [155.36085045700008, -6.745863539999959],
              [155.3300887380001, -6.719659112999921],
              [155.3208113940001, -6.70826588299991],
              [155.30836022200003, -6.686455987999921],
              [155.18726647200003, -6.554457289999959],
              [155.17310631600003, -6.527927341999941],
              [155.19125410200002, -6.528008721999925],
              [155.19906660200002, -6.530043226999908],
              [155.20720462300005, -6.534763278999947],
              [155.22486412900003, -6.500746351999908],
              [155.2348738940001, -6.45435963299991],
              [155.23804772200003, -6.405368747999944],
              [155.23462975400003, -6.363376559999949],
              [155.2148543630001, -6.317071221999925],
              [155.1816512380001, -6.291680596999925],
              [155.0820418630001, -6.262139580999929],
              [155.0459090500001, -6.242282809999949],
              [155.02361087300005, -6.223402601999908],
              [155.00123131600003, -6.215101820999905],
              [154.99089603000004, -6.208754164999959],
              [154.981781446, -6.199476820999905],
              [154.97868899800005, -6.192966403999947],
              [154.97437584700003, -6.17156340899993],
              [154.95964603000004, -6.130629164999959],
              [154.9423934250001, -6.111423434999949],
              [154.93970787900003, -6.106377862999921],
              [154.93238366000003, -6.097263278999947],
              [154.88502037900003, -6.075941664999959],
              [154.85670006600003, -6.043226820999905],
              [154.83130944100003, -6.02662525799991],
              [154.81763756600003, -6.01531340899993],
              [154.80648847700002, -6.002129815999922],
              [154.80201256600003, -5.989434502999927],
              [154.793304884, -5.975355726999908],
              [154.7558699880001, -5.947849216999941],
              [154.74732506600003, -5.927911065999922],
              [154.74634850400003, -5.916761976999908],
              [154.74195397200003, -5.897149346999925],
              [154.74105879, -5.886976820999905],
              [154.74732506600003, -5.877373955999929],
              [154.75163821700005, -5.867852471999925],
              [154.75342858200008, -5.856215101999908],
              [154.74878991000003, -5.834730726999908],
              [154.73780358200008, -5.81804778399993],
              [154.71371504, -5.79420338299991],
              [154.70525149800005, -5.781833591999941],
              [154.7016707690001, -5.773858330999929],
              [154.7002059250001, -5.76685963299991],
              [154.70264733200008, -5.757907809999949],
              [154.72022545700008, -5.71648528399993],
              [154.73218834700003, -5.631442966999941],
              [154.74000084700003, -5.610935153999947],
              [154.741547071, -5.592380466999941],
              [154.727386915, -5.575127862999921],
              [154.727386915, -5.568942966999941],
              [154.7304793630001, -5.566582940999922],
              [154.731293165, -5.565362237999921],
              [154.73210696700005, -5.564060153999947],
              [154.73422285200002, -5.561455987999921],
              [154.75220787900003, -5.578301690999922],
              [154.76050866000003, -5.581638278999947],
              [154.76775149800005, -5.575127862999921],
              [154.770355665, -5.558770440999922],
              [154.76490319100003, -5.543633721999925],
              [154.75733483200008, -5.529717705999929],
              [154.75342858200008, -5.517022393999923],
              [154.74195397200003, -5.494235934999949],
              [154.69841556100005, -5.451918226999908],
              [154.7002059250001, -5.431084893999923],
              [154.73316491000003, -5.426690362999921],
              [154.7744246750001, -5.449395440999922],
              [154.81080162900003, -5.483575127999927],
              [154.82984459700003, -5.513604424999926],
              [154.84693444100003, -5.510511976999908],
              [154.865570509, -5.520114841999941],
              [154.88200931100005, -5.536553643999923],
              [154.891937696, -5.554620049999926],
              [154.89771569100003, -5.545098565999922],
              [154.905609571, -5.541273695999905],
              [154.9150496750001, -5.542413018999923],
              [154.92546634200005, -5.534112237999921],
              [154.93677819100003, -5.539239190999922],
              [154.9511824880001, -5.541110934999949],
              [155.01832116000003, -5.541273695999905],
              [155.02857506600003, -5.545098565999922],
              [155.02173912900003, -5.554620049999926],
              [155.02173912900003, -5.561455987999921],
              [155.03239993600005, -5.567559502999927],
              [155.037445509, -5.562269789999959],
              [155.04167728000004, -5.553317966999941],
              [155.04957116000003, -5.547784112999921],
              [155.0649520190001, -5.547784112999921],
              [155.0693465500001, -5.552178643999923],
              [155.0688582690001, -5.559747002999927],
              [155.06950931100005, -5.568942966999941],
              [155.0634871750001, -5.579034112999921],
              [155.06202233200008, -5.585707289999959],
              [155.06625410200002, -5.588799737999921],
              [155.0864363940001, -5.595310153999947],
              [155.0898543630001, -5.595635674999926],
              [155.09538821700005, -5.608330987999921],
              [155.1001082690001, -5.631036065999922],
              [155.12566165500004, -5.660577080999929],
              [155.146820509, -5.706963799999926],
              [155.1626082690001, -5.729099216999941],
              [155.16765384200005, -5.733005466999941],
              [155.17530358200008, -5.735772393999923],
              [155.17937259200005, -5.73951588299991],
              [155.18702233200008, -5.752129815999922],
              [155.1904403000001, -5.756280205999929],
              [155.19214928500003, -5.765883070999905],
              [155.18677819100003, -5.801039320999905],
              [155.194672071, -5.81764088299991],
              [155.203949415, -5.853610934999949],
              [155.2133895190001, -5.869886976999908],
              [155.22877037900003, -5.865166924999926],
              [155.2446395190001, -5.870538018999923],
              [155.26148522200003, -5.879164320999905],
              [155.27898196700005, -5.883558851999908],
              [155.32829837300005, -5.937432549999926],
              [155.33130944100003, -5.941989841999941],
              [155.335297071, -5.946221612999921],
              [155.34327233200008, -5.951836846999925],
              [155.34791100400003, -5.952732028999947],
              [155.3593856130001, -5.950941664999959],
              [155.3642684250001, -5.951836846999925],
              [155.37037194100003, -5.957289320999905],
              [155.3813582690001, -5.976006768999923],
              [155.39568118600005, -5.992445570999905],
              [155.40381920700008, -6.006036065999922],
              [155.414398634, -6.05787525799991],
              [155.418304884, -6.069024346999925],
              [155.4521590500001, -6.137139580999929],
              [155.50277754, -6.189222914999959],
              [155.5083113940001, -6.192071221999925],
              [155.52125084700003, -6.189222914999959],
              [155.53052819100003, -6.182224216999941],
              [155.53931725400003, -6.17156340899993],
              [155.55103600400003, -6.178806247999944],
              [155.55836022200003, -6.194512627999927],
              [155.5688582690001, -6.211114190999922],
              [155.5908309250001, -6.21998463299991],
              [155.615570509, -6.216973565999922],
              [155.62086022200003, -6.205661716999941],
              [155.6230574880001, -6.190850518999923],
              [155.63851972700002, -6.178399346999925],
              [155.63851972700002, -6.185804945999905],
              [155.636078321, -6.190118096999925],
              [155.6347762380001, -6.193780205999929],
              [155.63697350400003, -6.19850025799991],
              [155.645355665, -6.205743096999925],
              [155.6416121750001, -6.216973565999922],
              [155.66578209700003, -6.241143487999921],
              [155.67595462300005, -6.263929945999905],
              [155.68376712300005, -6.269463799999926],
              [155.6938582690001, -6.272881768999923],
              [155.70386803500003, -6.274021091999941],
              [155.7138778000001, -6.279229424999926],
              [155.72250410200002, -6.291192315999922],
              [155.7348738940001, -6.315036716999941],
              [155.74594160200002, -6.330743096999925],
              [155.75855553500003, -6.343682549999926],
              [155.77361087300005, -6.352715752999927],
              [155.79281660200002, -6.355889580999929],
              [155.813324415, -6.364841403999947],
              [155.828949415, -6.38600025799991],
              [155.85027103000004, -6.431735934999949],
              [155.87224368600005, -6.461521091999941],
              [155.8964949880001, -6.488051039999959],
              [155.91675866000003, -6.517510674999926],
              [155.92603600400003, -6.555108330999929],
              [155.92505944100003, -6.566338799999926],
              [155.92017662900003, -6.585544528999947],
              [155.91920006600003, -6.596123955999929],
              [155.92164147200003, -6.608086846999925],
              [155.93132571700005, -6.63054778399993],
              [155.93344160200002, -6.640801690999922],
            ],
          ],
          [
            [
              [148.10035241000003, -5.376560153999947],
              [148.1269637380001, -5.391778252999927],
              [148.1464949880001, -5.41961028399993],
              [148.14812259200005, -5.448011976999908],
              [148.12086022200003, -5.465264580999929],
              [148.09131920700008, -5.456638278999947],
              [148.07634524800005, -5.428643487999921],
              [148.07837975400003, -5.396661065999922],
              [148.10035241000003, -5.376560153999947],
            ],
          ],
          [
            [
              [147.60694420700008, -5.287204684999949],
              [147.6250106130001, -5.289483330999929],
              [147.6333113940001, -5.298923434999949],
              [147.63851972700002, -5.310967705999929],
              [147.647797071, -5.321221612999921],
              [147.6386824880001, -5.338474216999941],
              [147.62867272200003, -5.347263278999947],
              [147.6001082690001, -5.362888278999947],
              [147.57960045700008, -5.334893487999921],
              [147.57683353000004, -5.334405205999929],
              [147.567718946, -5.335544528999947],
              [147.56527754, -5.334893487999921],
              [147.56430097700002, -5.330498955999929],
              [147.56470787900003, -5.326348565999922],
              [147.56470787900003, -5.322360934999949],
              [147.56218509200005, -5.318129164999959],
              [147.56202233200008, -5.307793877999927],
              [147.57439212300005, -5.297051690999922],
              [147.5918074880001, -5.288995049999926],
              [147.60694420700008, -5.287204684999949],
            ],
          ],
          [
            [
              [147.20964603000004, -5.269952080999929],
              [147.211761915, -5.293877862999921],
              [147.21827233200008, -5.317315362999921],
              [147.2290145190001, -5.337009372999944],
              [147.24382571700005, -5.349216403999947],
              [147.24382571700005, -5.355401299999926],
              [147.2290145190001, -5.37078215899993],
              [147.22632897200003, -5.39031340899993],
              [147.22730553500003, -5.409600518999923],
              [147.22331790500004, -5.424248955999929],
              [147.215179884, -5.430352471999925],
              [147.2094832690001, -5.428887627999927],
              [147.20386803500003, -5.42506275799991],
              [147.19605553500003, -5.424248955999929],
              [147.18531334700003, -5.428643487999921],
              [147.16187584700003, -5.444756768999923],
              [147.12720787900003, -5.443291924999926],
              [147.09913170700008, -5.423760674999926],
              [147.05827884200005, -5.376560153999947],
              [147.02116946700005, -5.34929778399993],
              [147.01042728000004, -5.334893487999921],
              [147.00513756600003, -5.319431247999944],
              [147.0044051440001, -5.30201588299991],
              [147.01042728000004, -5.266696872999944],
              [147.0180770190001, -5.243910414999959],
              [147.02751712300005, -5.235446872999944],
              [147.06511478000004, -5.225030205999929],
              [147.0800887380001, -5.214939059999949],
              [147.09522545700008, -5.201918226999908],
              [147.11255944100003, -5.191827080999929],
              [147.13396243600005, -5.190850518999923],
              [147.1684676440001, -5.228610934999949],
              [147.18238366000003, -5.239353122999944],
              [147.20582116000003, -5.250176690999922],
              [147.2089949880001, -5.255791924999926],
              [147.20964603000004, -5.269952080999929],
            ],
          ],
          [
            [
              [154.727386915, -5.211358330999929],
              [154.72608483200008, -5.242120049999926],
              [154.7002059250001, -5.334893487999921],
              [154.6977645190001, -5.40007903399993],
              [154.68873131600003, -5.427341403999947],
              [154.6660262380001, -5.438571872999944],
              [154.672211134, -5.417413018999923],
              [154.65699303500003, -5.422539971999925],
              [154.65015709700003, -5.434747002999927],
              [154.64429772200003, -5.448825778999947],
              [154.6318465500001, -5.459079684999949],
              [154.614105665, -5.389743747999944],
              [154.57390384200005, -5.29070403399993],
              [154.56983483200008, -5.263278903999947],
              [154.56218509200005, -5.239678643999923],
              [154.56218509200005, -5.225274346999925],
              [154.5732528000001, -5.218845309999949],
              [154.5800887380001, -5.211358330999929],
              [154.58318118600005, -5.194512627999927],
              [154.58269290500004, -5.14031340899993],
              [154.57764733200008, -5.119561455999929],
              [154.56324303500003, -5.115166924999926],
              [154.5356551440001, -5.137465101999908],
              [154.5415145190001, -5.103285414999959],
              [154.564789259, -5.066338799999926],
              [154.5957137380001, -5.033949476999908],
              [154.624359571, -5.01336028399993],
              [154.657074415, -5.019707940999922],
              [154.679047071, -5.04656340899993],
              [154.690765821, -5.080661716999941],
              [154.6933699880001, -5.108982028999947],
              [154.68718509200005, -5.139743747999944],
              [154.68702233200008, -5.154880466999941],
              [154.6933699880001, -5.170505466999941],
              [154.70281009200005, -5.179782809999949],
              [154.7129012380001, -5.185642184999949],
              [154.72185306100005, -5.194105726999908],
              [154.727386915, -5.211358330999929],
            ],
          ],
          [
            [
              [149.121918165, -4.883070570999905],
              [149.12964928500003, -4.877373955999929],
              [149.16920006600003, -4.862481377999927],
              [149.18043053500003, -4.879164320999905],
              [149.17758222700002, -4.894138278999947],
              [149.15609785200002, -4.924004815999922],
              [149.1430770190001, -4.91765715899993],
              [149.12956790500004, -4.908786716999941],
              [149.12061608200008, -4.897230726999908],
              [149.121918165, -4.883070570999905],
            ],
          ],
          [
            [
              [146.20289147200003, -4.824639580999929],
              [146.20533287900003, -4.809177341999941],
              [146.21265709700003, -4.795586846999925],
              [146.22527103000004, -4.787286065999922],
              [146.24333743600005, -4.787367445999905],
              [146.258148634, -4.809258721999925],
              [146.26343834700003, -4.820977471999925],
              [146.26384524800005, -4.83521900799991],
              [146.25709069100003, -4.832207940999922],
              [146.25074303500003, -4.82781340899993],
              [146.249359571, -4.83171965899993],
              [146.24952233200008, -4.833916924999926],
              [146.248383009, -4.834893487999921],
              [146.24333743600005, -4.83521900799991],
              [146.24732506600003, -4.852308851999908],
              [146.23226972700002, -4.853285414999959],
              [146.21265709700003, -4.842543226999908],
              [146.20289147200003, -4.824639580999929],
            ],
          ],
          [
            [
              [149.51929772200003, -4.643487237999921],
              [149.53337649800005, -4.649509372999944],
              [149.54908287900003, -4.659763278999947],
              [149.56177819100003, -4.672784112999921],
              [149.56706790500004, -4.687595309999949],
              [149.56592858200008, -4.704278252999927],
              [149.563812696, -4.712823174999926],
              [149.56023196700005, -4.717950127999927],
              [149.55152428500003, -4.719903252999927],
              [149.5478621750001, -4.714939059999949],
              [149.5459090500001, -4.707289320999905],
              [149.54322350400003, -4.701104424999926],
              [149.5356551440001, -4.690524997999944],
              [149.53109785200002, -4.678887627999927],
              [149.52491295700008, -4.668877862999921],
              [149.51246178500003, -4.66334400799991],
              [149.49756920700008, -4.666273695999905],
              [149.49244225400003, -4.676446221999925],
              [149.49732506600003, -4.686944268999923],
              [149.51246178500003, -4.691176039999959],
              [149.506195509, -4.699476820999905],
              [149.49822024800005, -4.704196872999944],
              [149.47828209700003, -4.711683851999908],
              [149.45460045700008, -4.692478122999944],
              [149.465668165, -4.670505466999941],
              [149.49341881600003, -4.65203215899993],
              [149.51929772200003, -4.643487237999921],
            ],
          ],
          [
            [
              [145.99683678500003, -4.534274997999944],
              [146.01099694100003, -4.545993747999944],
              [146.04810631600003, -4.585137627999927],
              [146.05339603000004, -4.600192966999941],
              [146.0556746750001, -4.625176690999922],
              [146.0551863940001, -4.659926039999959],
              [146.05030358200008, -4.667738539999959],
              [146.0468856130001, -4.67896900799991],
              [146.04468834700003, -4.701104424999926],
              [146.03972415500004, -4.712334893999923],
              [146.02857506600003, -4.721449476999908],
              [145.99170983200008, -4.744317315999922],
              [145.9648543630001, -4.754815362999921],
              [145.93921959700003, -4.760918877999927],
              [145.9248153000001, -4.754815362999921],
              [145.89226321700005, -4.725030205999929],
              [145.88697350400003, -4.717950127999927],
              [145.87916100400003, -4.702732028999947],
              [145.87574303500003, -4.68678150799991],
              [145.876312696, -4.669366143999923],
              [145.88070722700002, -4.649590752999927],
              [145.89576256600003, -4.608086846999925],
              [145.90650475400003, -4.590508721999925],
              [145.95590254, -4.538995049999926],
              [145.97535241000003, -4.52898528399993],
              [145.99683678500003, -4.534274997999944],
            ],
          ],
          [
            [
              [152.4179793630001, -4.345310153999947],
              [152.4145613940001, -4.360446872999944],
              [152.3652449880001, -4.472100518999923],
              [152.36085045700008, -4.506524346999925],
              [152.36939537900003, -4.54029713299991],
              [152.3989363940001, -4.602471612999921],
              [152.40992272200003, -4.641371351999908],
              [152.41163170700008, -4.683770440999922],
              [152.3935653000001, -4.748304945999905],
              [152.38640384200005, -4.791192315999922],
              [152.3222762380001, -4.891208591999941],
              [152.31177819100003, -4.897230726999908],
              [152.30787194100003, -4.902113539999959],
              [152.29184004, -4.935479424999926],
              [152.284515821, -4.941176039999959],
              [152.266937696, -4.951918226999908],
              [152.24626712300005, -4.975192966999941],
              [152.2324324880001, -4.983086846999925],
              [152.18873131600003, -4.988864841999941],
              [152.15772545700008, -4.99928150799991],
              [152.1367293630001, -4.999118747999944],
              [152.08619225400003, -4.98756275799991],
              [152.07154381600003, -4.98601653399993],
              [152.05054772200003, -4.980238539999959],
              [152.03882897200003, -4.978610934999949],
              [152.02759850400003, -4.987725518999923],
              [152.0141707690001, -4.983086846999925],
              [151.9926863940001, -4.971774997999944],
              [151.97437584700003, -4.984144789999959],
              [151.96892337300005, -5.004978122999944],
              [151.9716903000001, -5.123223565999922],
              [151.9775496750001, -5.148614190999922],
              [151.98796634200005, -5.163995049999926],
              [152.03834069100003, -5.204847914999959],
              [152.04468834700003, -5.211683851999908],
              [152.047211134, -5.22193775799991],
              [152.05201256600003, -5.228936455999929],
              [152.06275475400003, -5.233575127999927],
              [152.08155358200008, -5.239353122999944],
              [152.1230574880001, -5.290785414999959],
              [152.12777754, -5.308200778999947],
              [152.1474715500001, -5.345798434999949],
              [152.1504012380001, -5.369724216999941],
              [152.11980228000004, -5.424248955999929],
              [152.11451256600003, -5.42701588299991],
              [152.10889733200008, -5.433363539999959],
              [152.1045028000001, -5.441338799999926],
              [152.1025496750001, -5.448174737999921],
              [152.09888756600003, -5.455743096999925],
              [152.0898543630001, -5.457696221999925],
              [152.078461134, -5.457614841999941],
              [152.067718946, -5.459079684999949],
              [152.02076256600003, -5.483819268999923],
              [152.01319420700008, -5.489678643999923],
              [151.9716903000001, -5.534112237999921],
              [151.96355228000004, -5.536553643999923],
              [151.93116295700008, -5.540948174999926],
              [151.8994246750001, -5.553155205999929],
              [151.88689212300005, -5.554620049999926],
              [151.87077884200005, -5.56218840899993],
              [151.85425866000003, -5.578383070999905],
              [151.83423912900003, -5.592950127999927],
              [151.80779056100005, -5.595635674999926],
              [151.785980665, -5.584893487999921],
              [151.757172071, -5.548760674999926],
              [151.73943118600005, -5.534112237999921],
              [151.72046959700003, -5.528903903999947],
              [151.69556725400003, -5.52703215899993],
              [151.67115319100003, -5.529554945999905],
              [151.65381920700008, -5.537530205999929],
              [151.63005618600005, -5.570489190999922],
              [151.61931399800005, -5.575127862999921],
              [151.60661868600005, -5.57195403399993],
              [151.60377037900003, -5.564222914999959],
              [151.60336347700002, -5.554294528999947],
              [151.59888756600003, -5.544366143999923],
              [151.58082116000003, -5.535332940999922],
              [151.51343834700003, -5.534112237999921],
              [151.4790145190001, -5.529880466999941],
              [151.46412194100003, -5.534274997999944],
              [151.45142662900003, -5.547784112999921],
              [151.4453231130001, -5.569431247999944],
              [151.45093834700003, -5.586521091999941],
              [151.46021569100003, -5.600355726999908],
              [151.46509850400003, -5.61296965899993],
              [151.470062696, -5.61646900799991],
              [151.49398847700002, -5.617364190999922],
              [151.50261478000004, -5.620212497999944],
              [151.5302840500001, -5.647149346999925],
              [151.532562696, -5.664727471999925],
              [151.51539147200003, -5.681573174999926],
              [151.489105665, -5.690606377999927],
              [151.46509850400003, -5.684991143999923],
              [151.4497176440001, -5.693780205999929],
              [151.43140709700003, -5.707452080999929],
              [151.41627037900003, -5.722588799999926],
              [151.40992272200003, -5.735935153999947],
              [151.4082137380001, -5.756036065999922],
              [151.4033309250001, -5.775160414999959],
              [151.395843946, -5.791761976999908],
              [151.38648522200003, -5.804457289999959],
              [151.3554793630001, -5.834161065999922],
              [151.342133009, -5.841973565999922],
              [151.31080162900003, -5.854668877999927],
              [151.29607181100005, -5.858005466999941],
              [151.28687584700003, -5.856215101999908],
              [151.27320397200003, -5.873630466999941],
              [151.23560631600003, -5.900567315999922],
              [151.2187606130001, -5.917738539999959],
              [151.2133895190001, -5.928155205999929],
              [151.21168053500003, -5.935723565999922],
              [151.20850670700008, -5.942803643999923],
              [151.18279056100005, -5.964288018999923],
              [151.1757918630001, -5.963636976999908],
              [151.17156009200005, -5.951836846999925],
              [151.11540774800005, -5.972100518999923],
              [151.0869246750001, -5.985772393999923],
              [151.0747176440001, -6.003350518999923],
              [151.0610457690001, -6.029392184999949],
              [151.02995853000004, -6.032321872999944],
              [150.97234134200005, -6.02076588299991],
              [150.90056399800005, -6.036879164999959],
              [150.8891707690001, -6.044366143999923],
              [150.88038170700008, -6.053887627999927],
              [150.860687696, -6.043633721999925],
              [150.82764733200008, -6.013929945999905],
              [150.82146243600005, -6.013929945999905],
              [150.81714928500003, -6.024834893999923],
              [150.81080162900003, -6.036716403999947],
              [150.806976759, -6.048272393999923],
              [150.8164168630001, -6.071221612999921],
              [150.81218509200005, -6.083754164999959],
              [150.80494225400003, -6.095635674999926],
              [150.79607181100005, -6.120293877999927],
              [150.78484134200005, -6.127211195999905],
              [150.76685631600003, -6.130629164999959],
              [150.73218834700003, -6.14421965899993],
              [150.69597415500004, -6.150160414999959],
              [150.68734785200002, -6.154229424999926],
              [150.67644290500004, -6.163262627999927],
              [150.67115319100003, -6.162774346999925],
              [150.66724694100003, -6.156182549999926],
              [150.66041100400003, -6.147393487999921],
              [150.64576256600003, -6.147067966999941],
              [150.6250106130001, -6.157647393999923],
              [150.60564212300005, -6.172784112999921],
              [150.59489993600005, -6.185804945999905],
              [150.59205162900003, -6.183851820999905],
              [150.59058678500003, -6.183851820999905],
              [150.58961022200003, -6.183200778999947],
              [150.58806399800005, -6.178399346999925],
              [150.55225670700008, -6.213555596999925],
              [150.530609571, -6.22779713299991],
              [150.50928795700008, -6.23365650799991],
              [150.50074303500003, -6.239190362999921],
              [150.47624759200005, -6.26531340899993],
              [150.46509850400003, -6.274021091999941],
              [150.42139733200008, -6.286065362999921],
              [150.395355665, -6.28875090899993],
              [150.37859134200005, -6.284274997999944],
              [150.3671981130001, -6.279066664999959],
              [150.35670006600003, -6.283379815999922],
              [150.347015821, -6.29070403399993],
              [150.33765709700003, -6.294528903999947],
              [150.3344832690001, -6.29225025799991],
              [150.3325301440001, -6.287692966999941],
              [150.32984459700003, -6.282972914999959],
              [150.32398522200003, -6.280857028999947],
              [150.3212996750001, -6.281833591999941],
              [150.31324303500003, -6.286309502999927],
              [150.27295983200008, -6.295017184999949],
              [150.24675540500004, -6.296970309999949],
              [150.22868899800005, -6.291110934999949],
              [150.21949303500003, -6.275485934999949],
              [150.213226759, -6.269952080999929],
              [150.19166100400003, -6.265557549999926],
              [150.1855574880001, -6.26100025799991],
              [150.17790774800005, -6.257989190999922],
              [150.163422071, -6.259698174999926],
              [150.1464949880001, -6.27117278399993],
              [150.12525475400003, -6.289646091999941],
              [150.10336347700002, -6.302666924999926],
              [150.08472741000003, -6.297946872999944],
              [150.08220462300005, -6.293389580999929],
              [150.08130944100003, -6.288262627999927],
              [150.08155358200008, -6.277439059999949],
              [150.079437696, -6.271742445999905],
              [150.07447350400003, -6.26881275799991],
              [150.068695509, -6.26685963299991],
              [150.054047071, -6.257745049999926],
              [150.0473738940001, -6.262790622999944],
              [150.039886915, -6.280857028999947],
              [150.03785241000003, -6.282321872999944],
              [150.0263778000001, -6.287692966999941],
              [150.03825931100005, -6.297946872999944],
              [150.0371199880001, -6.307712497999944],
              [150.02702884200005, -6.31568775799991],
              [150.012054884, -6.321221612999921],
              [150.01539147200003, -6.306573174999926],
              [150.011078321, -6.291192315999922],
              [150.00163821700005, -6.27898528399993],
              [149.9887801440001, -6.274021091999941],
              [149.9751082690001, -6.276462497999944],
              [149.9575301440001, -6.283379815999922],
              [149.93930097700002, -6.294366143999923],
              [149.92335045700008, -6.308200778999947],
              [149.91138756600003, -6.294854424999926],
              [149.90113366000003, -6.291924737999921],
              [149.89185631600003, -6.293715101999908],
              [149.88233483200008, -6.294528903999947],
              [149.85515384200005, -6.292738539999959],
              [149.84888756600003, -6.294528903999947],
              [149.82300866000003, -6.289971612999921],
              [149.72779381600003, -6.287692966999941],
              [149.72095787900003, -6.29070403399993],
              [149.70232181100005, -6.304457289999959],
              [149.69060306100005, -6.308200778999947],
              [149.6665145190001, -6.303317966999941],
              [149.6508895190001, -6.30242278399993],
              [149.63542728000004, -6.308200778999947],
              [149.6294051440001, -6.299248955999929],
              [149.591156446, -6.270928643999923],
              [149.5805770190001, -6.259860934999949],
              [149.5747176440001, -6.248630466999941],
              [149.56023196700005, -6.226169528999947],
              [149.54566491000003, -6.195977471999925],
              [149.48812910200002, -6.120049737999921],
              [149.46404056100005, -6.102634372999944],
              [149.36841881600003, -6.075941664999959],
              [149.34937584700003, -6.063571872999944],
              [149.33765709700003, -6.057793877999927],
              [149.32056725400003, -6.054864190999922],
              [149.30420983200008, -6.058689059999949],
              [149.27906334700003, -6.07781340899993],
              [149.26880944100003, -6.082207940999922],
              [149.26042728000004, -6.084405205999929],
              [149.2363387380001, -6.093682549999926],
              [149.2207137380001, -6.095879815999922],
              [149.18921959700003, -6.094821872999944],
              [149.17725670700008, -6.090915622999944],
              [149.16920006600003, -6.082207940999922],
              [149.16293379, -6.082207940999922],
              [149.16521243600005, -6.096612237999921],
              [149.160492384, -6.115411065999922],
              [149.151703321, -6.133233330999929],
              [149.14185631600003, -6.14421965899993],
              [149.1279403000001, -6.149183851999908],
              [149.0879012380001, -6.150485934999949],
              [149.0805770190001, -6.154961846999925],
              [149.06527754, -6.161879164999959],
              [149.05290774800005, -6.161716403999947],
              [149.053070509, -6.14421965899993],
              [149.06169681100005, -6.139580987999921],
              [149.07374108200008, -6.141289971999925],
              [149.0805770190001, -6.139336846999925],
              [149.073578321, -6.123793226999908],
              [149.0800887380001, -6.110039971999925],
              [149.0732528000001, -6.090915622999944],
              [149.05648847700002, -6.074476820999905],
              [149.0332137380001, -6.068536065999922],
              [149.0429793630001, -6.051934502999927],
              [149.05453535200002, -6.038262627999927],
              [149.06039472700002, -6.024346612999921],
              [149.053070509, -6.006524346999925],
              [149.04517662900003, -6.026055596999925],
              [149.036468946, -6.028008721999925],
              [149.02605228000004, -6.024346612999921],
              [149.012054884, -6.027601820999905],
              [148.9360457690001, -5.996758721999925],
              [148.89405358200008, -5.98560963299991],
              [148.8681746750001, -5.992852471999925],
              [148.86052493600005, -5.986748955999929],
              [148.853851759, -5.97975025799991],
              [148.85889733200008, -5.970635674999926],
              [148.86508222700002, -5.962823174999926],
              [148.87256920700008, -5.956475518999923],
              [148.8818465500001, -5.951836846999925],
              [148.87525475400003, -5.94264088299991],
              [148.8691512380001, -5.941338799999926],
              [148.86247806100005, -5.941827080999929],
              [148.853851759, -5.938164971999925],
              [148.849945509, -5.931817315999922],
              [148.8496199880001, -5.92506275799991],
              [148.84717858200008, -5.919854424999926],
              [148.83716881600003, -5.917738539999959],
              [148.80445397200003, -5.915134372999944],
              [148.79265384200005, -5.918633721999925],
              [148.7793074880001, -5.93132903399993],
              [148.7719832690001, -5.924493096999925],
              [148.77898196700005, -5.909763278999947],
              [148.778168165, -5.896905205999929],
              [148.774261915, -5.884942315999922],
              [148.7719832690001, -5.873304945999905],
              [148.76441491000003, -5.862725518999923],
              [148.7480574880001, -5.861911716999941],
              [148.73170006600003, -5.863213799999926],
              [148.72413170700008, -5.859470309999949],
              [148.71802819100003, -5.847588799999926],
              [148.7036238940001, -5.845879815999922],
              [148.67562910200002, -5.848809502999927],
              [148.6591903000001, -5.840508721999925],
              [148.6357528000001, -5.817071221999925],
              [148.6211043630001, -5.80787525799991],
              [148.59742272200003, -5.828301690999922],
              [148.583343946, -5.837985934999949],
              [148.57016035200002, -5.841973565999922],
              [148.55152428500003, -5.837009372999944],
              [148.52125084700003, -5.811618747999944],
              [148.50513756600003, -5.801039320999905],
              [148.48414147200003, -5.797051690999922],
              [148.43718509200005, -5.793715101999908],
              [148.41944420700008, -5.783949476999908],
              [148.40984134200005, -5.779961846999925],
              [148.39722741000003, -5.778903903999947],
              [148.38624108200008, -5.77507903399993],
              [148.38160241000003, -5.763441664999959],
              [148.3466903000001, -5.726006768999923],
              [148.328949415, -5.683770440999922],
              [148.3247176440001, -5.646416924999926],
              [148.34205162900003, -5.533298434999949],
              [148.359711134, -5.497816664999959],
              [148.3867293630001, -5.468519789999959],
              [148.42253665500004, -5.451592705999929],
              [148.42741946700005, -5.450616143999923],
              [148.42839603000004, -5.449965101999908],
              [148.4282332690001, -5.44850025799991],
              [148.42994225400003, -5.444756768999923],
              [148.4458113940001, -5.450778903999947],
              [148.45769290500004, -5.456801039999959],
              [148.48113040500004, -5.475762627999927],
              [148.48902428500003, -5.48015715899993],
              [148.5063582690001, -5.483819268999923],
              [148.51531009200005, -5.489678643999923],
              [148.520355665, -5.49773528399993],
              [148.5254012380001, -5.516045830999929],
              [148.52955162900003, -5.523858330999929],
              [148.55640709700003, -5.539971612999921],
              [148.5859481130001, -5.534274997999944],
              [148.614593946, -5.51490650799991],
              [148.63884524800005, -5.489678643999923],
              [148.65186608200008, -5.480889580999929],
              [148.665375196, -5.482028903999947],
              [148.696136915, -5.493096612999921],
              [148.73121178500003, -5.490329684999949],
              [148.74398847700002, -5.493096612999921],
              [148.75359134200005, -5.500258070999905],
              [148.76319420700008, -5.510430596999925],
              [148.77523847700002, -5.520277601999908],
              [148.792328321, -5.527276299999926],
              [148.83277428500003, -5.533868096999925],
              [148.8476668630001, -5.540948174999926],
              [148.84937584700003, -5.528252862999921],
              [148.8554793630001, -5.522149346999925],
              [148.8750106130001, -5.513604424999926],
              [148.8906356130001, -5.501153252999927],
              [148.8969832690001, -5.499607028999947],
              [148.912445509, -5.49928150799991],
              [148.92603600400003, -5.495538018999923],
              [148.97803795700008, -5.465264580999929],
              [149.05534915500004, -5.498711846999925],
              [149.0673934250001, -5.510349216999941],
              [149.08480879, -5.511895440999922],
              [149.15967858200008, -5.545993747999944],
              [149.17302493600005, -5.554620049999926],
              [149.18140709700003, -5.554864190999922],
              [149.18775475400003, -5.55592213299991],
              [149.19353274800005, -5.559258721999925],
              [149.19996178500003, -5.565199476999908],
              [149.21208743600005, -5.58326588299991],
              [149.21070397200003, -5.582614841999941],
              [149.219574415, -5.594414971999925],
              [149.22437584700003, -5.59929778399993],
              [149.35035241000003, -5.58521900799991],
              [149.37525475400003, -5.575127862999921],
              [149.39047285200002, -5.587334893999923],
              [149.403168165, -5.583103122999944],
              [149.41553795700008, -5.571221612999921],
              [149.43043053500003, -5.561455987999921],
              [149.43702233200008, -5.571709893999923],
              [149.44800866000003, -5.581149997999944],
              [149.4589949880001, -5.582452080999929],
              [149.46461022200003, -5.568942966999941],
              [149.4921981130001, -5.586602471999925],
              [149.49878991000003, -5.588799737999921],
              [149.5087996750001, -5.580336195999905],
              [149.51783287900003, -5.553480726999908],
              [149.52955162900003, -5.547784112999921],
              [149.5478621750001, -5.543633721999925],
              [149.61491946700005, -5.513604424999926],
              [149.6176863940001, -5.51921965899993],
              [149.6211043630001, -5.521905205999929],
              [149.62484785200002, -5.523858330999929],
              [149.62916100400003, -5.527276299999926],
              [149.6347762380001, -5.51921965899993],
              [149.6430770190001, -5.514825127999927],
              [149.6528426440001, -5.51490650799991],
              [149.66325931100005, -5.520440362999921],
              [149.67261803500003, -5.51140715899993],
              [149.67644290500004, -5.500909112999921],
              [149.67530358200008, -5.489678643999923],
              [149.67009524800005, -5.478936455999929],
              [149.67497806100005, -5.478610934999949],
              [149.67603600400003, -5.480075778999947],
              [149.67603600400003, -5.483005466999941],
              [149.67693118600005, -5.486423434999949],
              [149.68580162900003, -5.488213799999926],
              [149.69166100400003, -5.503024997999944],
              [149.69288170700008, -5.522230726999908],
              [149.68311608200008, -5.552178643999923],
              [149.69402103000004, -5.561944268999923],
              [149.709320509, -5.567478122999944],
              [149.71843509200005, -5.568942966999941],
              [149.73194420700008, -5.563897393999923],
              [149.74138431100005, -5.556817315999922],
              [149.75212649800005, -5.55046965899993],
              [149.76937910200002, -5.547784112999921],
              [149.77800540500004, -5.544122002999927],
              [149.78679446700005, -5.534763278999947],
              [149.79281660200002, -5.521416924999926],
              [149.7929793630001, -5.506931247999944],
              [149.7998153000001, -5.506931247999944],
              [149.83350670700008, -5.526543877999927],
              [149.87281334700003, -5.527601820999905],
              [149.911468946, -5.515069268999923],
              [149.943695509, -5.493096612999921],
              [149.9541121750001, -5.480645440999922],
              [149.98023522200003, -5.438083591999941],
              [149.9853621750001, -5.420830987999921],
              [149.98194420700008, -5.408786716999941],
              [149.9731551440001, -5.404473565999922],
              [149.961761915, -5.402276299999926],
              [149.95069420700008, -5.397067966999941],
              [149.94214928500003, -5.387302341999941],
              [149.92644290500004, -5.361260674999926],
              [149.9165145190001, -5.349216403999947],
              [149.92335045700008, -5.339288018999923],
              [149.93140709700003, -5.318129164999959],
              [149.936859571, -5.307549737999921],
              [149.9423934250001, -5.301446221999925],
              [149.95476321700005, -5.290785414999959],
              [149.96159915500004, -5.283786716999941],
              [149.97641035200002, -5.272230726999908],
              [149.99594160200002, -5.261814059999949],
              [150.01441491000003, -5.247491143999923],
              [150.0263778000001, -5.225030205999929],
              [150.02719160200002, -5.214043877999927],
              [150.02564537900003, -5.203789971999925],
              [150.0195418630001, -5.184747002999927],
              [150.0175887380001, -5.184014580999929],
              [150.0058699880001, -5.177341403999947],
              [150.00570722700002, -5.170098565999922],
              [150.0107528000001, -5.159112237999921],
              [150.01433353000004, -5.141534112999921],
              [150.02409915500004, -5.123467705999929],
              [150.0263778000001, -5.112399997999944],
              [150.02409915500004, -5.106622002999927],
              [150.01433353000004, -5.098077080999929],
              [150.012054884, -5.092461846999925],
              [150.01319420700008, -5.085544528999947],
              [150.0156356130001, -5.082452080999929],
              [150.01823978000004, -5.080254815999922],
              [150.03492272200003, -5.034356377999927],
              [150.06902103000004, -5.012139580999929],
              [150.11255944100003, -5.007745049999926],
              [150.156586134, -5.020196221999925],
              [150.17888431100005, -5.031182549999926],
              [150.1899520190001, -5.038669528999947],
              [150.197601759, -5.047539971999925],
              [150.20240319100003, -5.062107028999947],
              [150.19947350400003, -5.070570570999905],
              [150.1938582690001, -5.076918226999908],
              [150.19092858200008, -5.085056247999944],
              [150.181976759, -5.102471612999921],
              [150.16089928500003, -5.112481377999927],
              [150.1157332690001, -5.123223565999922],
              [150.0976668630001, -5.136163018999923],
              [150.07536868600005, -5.159112237999921],
              [150.061859571, -5.181084893999923],
              [150.07886803500003, -5.201429945999905],
              [150.08318118600005, -5.225274346999925],
              [150.08415774800005, -5.250909112999921],
              [150.08155358200008, -5.266696872999944],
              [150.07447350400003, -5.272637627999927],
              [150.0551863940001, -5.276462497999944],
              [150.04672285200002, -5.280368747999944],
              [150.03443444100003, -5.290622653999947],
              [150.032074415, -5.295179945999905],
              [150.050140821, -5.311293226999908],
              [150.0546981130001, -5.320489190999922],
              [150.05811608200008, -5.342868747999944],
              [150.08375084700003, -5.383396091999941],
              [150.11247806100005, -5.442152601999908],
              [150.1157332690001, -5.455336195999905],
              [150.11695397200003, -5.47389088299991],
              [150.12126712300005, -5.49537525799991],
              [150.1294051440001, -5.516696872999944],
              [150.14234459700003, -5.534112237999921],
              [150.16130618600005, -5.546644789999959],
              [150.1821395190001, -5.552504164999959],
              [150.25114993600005, -5.557793877999927],
              [150.27133222700002, -5.563653252999927],
              [150.28980553500003, -5.566582940999922],
              [150.30689537900003, -5.561455987999921],
              [150.31421959700003, -5.551364841999941],
              [150.32252037900003, -5.535251559999949],
              [150.3325301440001, -5.520196221999925],
              [150.34449303500003, -5.513604424999926],
              [150.35865319100003, -5.508233330999929],
              [150.3891707690001, -5.484307549999926],
              [150.3994246750001, -5.478936455999929],
              [150.41187584700003, -5.463148695999905],
              [150.41675866000003, -5.459079684999949],
              [150.42335045700008, -5.456638278999947],
              [150.47413170700008, -5.447930596999925],
              [150.49341881600003, -5.447442315999922],
              [150.51189212300005, -5.450941664999959],
              [150.57154381600003, -5.474053643999923],
              [150.59253991000003, -5.486993096999925],
              [150.60173587300005, -5.503106377999927],
              [150.6059676440001, -5.522067966999941],
              [150.61744225400003, -5.543389580999929],
              [150.63396243600005, -5.556735934999949],
              [150.6533309250001, -5.551202080999929],
              [150.66911868600005, -5.542738539999959],
              [150.70337975400003, -5.539971612999921],
              [150.71900475400003, -5.534112237999921],
              [150.746429884, -5.512139580999929],
              [150.75855553500003, -5.497247002999927],
              [150.76685631600003, -5.478936455999929],
              [150.76099694100003, -5.466241143999923],
              [150.76392662900003, -5.456475518999923],
              [150.77165774800005, -5.452894789999959],
              [150.7797957690001, -5.459079684999949],
              [150.8095809250001, -5.443291924999926],
              [150.83716881600003, -5.452894789999959],
              [150.859711134, -5.47429778399993],
              [150.8754988940001, -5.493096612999921],
              [150.90593509200005, -5.490004164999959],
              [150.9170028000001, -5.486423434999949],
              [150.9243270190001, -5.480401299999926],
              [150.94060306100005, -5.459079684999949],
              [150.9609481130001, -5.453789971999925],
              [150.98161868600005, -5.440850518999923],
              [150.99984785200002, -5.424981377999927],
              [151.012543165, -5.410577080999929],
              [151.02222741000003, -5.39031340899993],
              [151.0239363940001, -5.369317315999922],
              [151.0200301440001, -5.324883721999925],
              [151.0219832690001, -5.303887627999927],
              [151.03337649800005, -5.258884372999944],
              [151.059418165, -5.200290622999944],
              [151.082855665, -5.163832289999959],
              [151.10906009200005, -5.132745049999926],
              [151.136078321, -5.108982028999947],
              [151.14283287900003, -5.105238539999959],
              [151.15748131600003, -5.099786065999922],
              [151.1640731130001, -5.095879815999922],
              [151.18246504, -5.071709893999923],
              [151.197601759, -5.061618747999944],
              [151.2255965500001, -5.020196221999925],
              [151.239105665, -5.006524346999925],
              [151.24195397200003, -5.006036065999922],
              [151.2500106130001, -5.007256768999923],
              [151.25277754, -5.006524346999925],
              [151.253265821, -5.003838799999926],
              [151.25212649800005, -4.99537525799991],
              [151.25277754, -4.992852471999925],
              [151.26197350400003, -4.988946221999925],
              [151.28834069100003, -4.981377862999921],
              [151.29761803500003, -4.975518487999921],
              [151.30591881600003, -4.967950127999927],
              [151.31820722700002, -4.96021900799991],
              [151.33228600400003, -4.954278252999927],
              [151.34555097700002, -4.951918226999908],
              [151.3579207690001, -4.94654713299991],
              [151.36312910200002, -4.933526299999926],
              [151.36890709700003, -4.903497002999927],
              [151.37574303500003, -4.903497002999927],
              [151.388031446, -4.914483330999929],
              [151.45142662900003, -4.931410414999959],
              [151.47339928500003, -4.940199476999908],
              [151.49244225400003, -4.942559502999927],
              [151.51156660200002, -4.935642184999949],
              [151.53402754, -4.916599216999941],
              [151.57439212300005, -4.937676690999922],
              [151.61247806100005, -4.965590101999908],
              [151.63209069100003, -4.961032809999949],
              [151.64771569100003, -4.948988539999959],
              [151.66041100400003, -4.93328215899993],
              [151.67896569100003, -4.900160414999959],
              [151.68572024800005, -4.882256768999923],
              [151.69011478000004, -4.862074476999908],
              [151.69166100400003, -4.838636976999908],
              [151.69263756600003, -4.835707289999959],
              [151.694672071, -4.833591403999947],
              [151.69695071700005, -4.830498955999929],
              [151.69792728000004, -4.824639580999929],
              [151.695648634, -4.818780205999929],
              [151.69109134200005, -4.81568775799991],
              [151.68637129, -4.81373463299991],
              [151.68425540500004, -4.810967705999929],
              [151.68140709700003, -4.799899997999944],
              [151.66822350400003, -4.777601820999905],
              [151.66374759200005, -4.766289971999925],
              [151.66187584700003, -4.726983330999929],
              [151.6670028000001, -4.646254164999959],
              [151.65748131600003, -4.608086846999925],
              [151.6367293630001, -4.579685153999947],
              [151.6269637380001, -4.561293226999908],
              [151.62273196700005, -4.537286065999922],
              [151.62289472700002, -4.493910414999959],
              [151.6191512380001, -4.47429778399993],
              [151.60914147200003, -4.451755466999941],
              [151.596039259, -4.435642184999949],
              [151.56527754, -4.41139088299991],
              [151.55388431100005, -4.396416924999926],
              [151.55030358200008, -4.387302341999941],
              [151.54835045700008, -4.37859465899993],
              [151.54761803500003, -4.358575127999927],
              [151.54411868600005, -4.346612237999921],
              [151.52662194100003, -4.330743096999925],
              [151.51978600400003, -4.320733330999929],
              [151.5185653000001, -4.310642184999949],
              [151.52125084700003, -4.301934502999927],
              [151.52466881600003, -4.295017184999949],
              [151.52662194100003, -4.290215752999927],
              [151.52515709700003, -4.280205987999921],
              [151.51343834700003, -4.252373955999929],
              [151.50733483200008, -4.229180596999925],
              [151.50945071700005, -4.213067315999922],
              [151.5205184250001, -4.197686455999929],
              [151.54029381600003, -4.176690362999921],
              [151.55543053500003, -4.182386976999908],
              [151.61060631600003, -4.192559502999927],
              [151.65015709700003, -4.191013278999947],
              [151.66358483200008, -4.193536065999922],
              [151.68148847700002, -4.201592705999929],
              [151.69166100400003, -4.204685153999947],
              [151.70427493600005, -4.20281340899993],
              [151.717133009, -4.19890715899993],
              [151.72584069100003, -4.201348565999922],
              [151.72575931100005, -4.218357028999947],
              [151.7426863940001, -4.207696221999925],
              [151.7627059250001, -4.206149997999944],
              [151.80453535200002, -4.210870049999926],
              [151.81714928500003, -4.213962497999944],
              [151.852875196, -4.230645440999922],
              [151.86304772200003, -4.238702080999929],
              [151.86890709700003, -4.257989190999922],
              [151.87330162900003, -4.283135674999926],
              [151.88209069100003, -4.305108330999929],
              [151.9008895190001, -4.314548434999949],
              [151.92310631600003, -4.318291924999926],
              [151.96469160200002, -4.331231377999927],
              [151.98585045700008, -4.328220309999949],
              [151.9985457690001, -4.318780205999929],
              [152.0302840500001, -4.27662525799991],
              [152.0361434250001, -4.256931247999944],
              [152.0239363940001, -4.239841403999947],
              [152.007172071, -4.224704684999949],
              [151.99952233200008, -4.210870049999926],
              [152.008636915, -4.191664320999905],
              [152.025726759, -4.193942966999941],
              [152.0459090500001, -4.20435963299991],
              [152.06430097700002, -4.210870049999926],
              [152.0727645190001, -4.210056247999944],
              [152.0830184250001, -4.207940362999921],
              [152.09205162900003, -4.204847914999959],
              [152.0957137380001, -4.201267184999949],
              [152.10075931100005, -4.198418877999927],
              [152.12623131600003, -4.20435963299991],
              [152.1367293630001, -4.204685153999947],
              [152.1494246750001, -4.189629815999922],
              [152.15406334700003, -4.16765715899993],
              [152.1621199880001, -4.148532809999949],
              [152.18506920700008, -4.142510674999926],
              [152.20045006600003, -4.15984465899993],
              [152.21851647200003, -4.173923434999949],
              [152.2334090500001, -4.190362237999921],
              [152.24577884200005, -4.235121351999908],
              [152.243500196, -4.243096612999921],
              [152.22925866000003, -4.246189059999949],
              [152.2231551440001, -4.24578215899993],
              [152.2055770190001, -4.241957289999959],
              [152.19874108200008, -4.238702080999929],
              [152.1958113940001, -4.231052341999941],
              [152.19353274800005, -4.219170830999929],
              [152.1884871750001, -4.210137627999927],
              [152.17758222700002, -4.210870049999926],
              [152.17204837300005, -4.220310153999947],
              [152.17261803500003, -4.234795830999929],
              [152.17758222700002, -4.259209893999923],
              [152.17790774800005, -4.296807549999926],
              [152.18572024800005, -4.308526299999926],
              [152.2055770190001, -4.314548434999949],
              [152.2109481130001, -4.312269789999959],
              [152.21753991000003, -4.307712497999944],
              [152.22673587300005, -4.304457289999959],
              [152.23975670700008, -4.307061455999929],
              [152.247406446, -4.313653252999927],
              [152.2544051440001, -4.323011976999908],
              [152.26319420700008, -4.33131275799991],
              [152.27686608200008, -4.335056247999944],
              [152.33855228000004, -4.341892184999949],
              [152.3564559250001, -4.341892184999949],
              [152.39820397200003, -4.329196872999944],
              [152.41236412900003, -4.32935963299991],
              [152.4179793630001, -4.345310153999947],
            ],
          ],
          [
            [
              [145.07886803500003, -4.047051690999922],
              [145.09644616000003, -4.054782809999949],
              [145.10613040500004, -4.066582940999922],
              [145.10889733200008, -4.082126559999949],
              [145.10613040500004, -4.101006768999923],
              [145.1001082690001, -4.116306247999944],
              [145.09050540500004, -4.12468840899993],
              [145.07593834700003, -4.12818775799991],
              [145.0546981130001, -4.128838799999926],
              [145.03834069100003, -4.122816664999959],
              [145.02898196700005, -4.108005466999941],
              [145.02458743600005, -4.088799737999921],
              [145.02369225400003, -4.070489190999922],
              [145.02711022200003, -4.058200778999947],
              [145.03492272200003, -4.055759372999944],
              [145.042328321, -4.058200778999947],
              [145.04468834700003, -4.060642184999949],
              [145.061859571, -4.04656340899993],
              [145.0693465500001, -4.043226820999905],
              [145.07886803500003, -4.047051690999922],
            ],
          ],
          [
            [
              [153.191742384, -3.470961195999962],
              [153.22193444100003, -3.448174737999921],
              [153.2334090500001, -3.444268487999921],
              [153.25123131600003, -3.467217705999929],
              [153.25896243600005, -3.482354424999926],
              [153.260101759, -3.498955987999921],
              [153.25220787900003, -3.494805596999925],
              [153.25025475400003, -3.495049737999921],
              [153.24976647200003, -3.497247002999927],
              [153.2470809250001, -3.498955987999921],
              [153.23414147200003, -3.488457940999922],
              [153.20435631600003, -3.478122653999947],
              [153.191742384, -3.470961195999962],
            ],
          ],
          [
            [
              [153.301605665, -3.368584893999923],
              [153.32789147200003, -3.368584893999923],
              [153.3427840500001, -3.378676039999959],
              [153.34782962300005, -3.395684502999927],
              [153.34327233200008, -3.416273695999962],
              [153.33090254, -3.398858330999929],
              [153.3115340500001, -3.397149346999925],
              [153.28923587300005, -3.401950778999947],
              [153.2675887380001, -3.403252862999921],
              [153.2724715500001, -3.391778252999927],
              [153.28077233200008, -3.38250090899993],
              [153.301605665, -3.368584893999923],
            ],
          ],
          [
            [
              [154.64197130700006, -3.262331511999946],
              [154.6656632910001, -3.309587452999949],
              [154.71656654900005, -3.393437964999919],
              [154.73785821500007, -3.441850164999948],
              [154.7317787080001, -3.460813799999926],
              [154.70393049400002, -3.402978654999913],
              [154.6830684580001, -3.349738461999948],
              [154.64594681000005, -3.296539998999947],
              [154.613478988, -3.241010156999948],
              [154.55318034700008, -3.206315333999953],
              [154.595762251, -3.211502326999948],
              [154.6277627730001, -3.226887846999944],
              [154.64197130700006, -3.262331511999946],
            ],
          ],
          [
            [
              [152.65064537900003, -3.114678643999923],
              [152.6552840500001, -3.120700778999947],
              [152.66724694100003, -3.12273528399993],
              [152.67115319100003, -3.128350518999923],
              [152.67172285200002, -3.13836028399993],
              [152.66968834700003, -3.147067966999941],
              [152.66431725400003, -3.162530205999929],
              [152.65066004900007, -3.195351046999917],
              [152.65349368600005, -3.215101820999962],
              [152.64380944100003, -3.224541924999926],
              [152.6337996750001, -3.219903252999927],
              [152.60271243600005, -3.194756768999923],
              [152.59595787900003, -3.186944268999923],
              [152.54424285300001, -3.130871498999909],
              [152.53569467, -3.118024310999942],
              [152.52717974400002, -3.097701447999953],
              [152.53155693300005, -3.075272107999922],
              [152.55202871300003, -3.057152468999959],
              [152.57466065200003, -3.040101097999923],
              [152.6123961510001, -3.035903068999914],
              [152.65064537900003, -3.046482028999947],
              [152.648773634, -3.101657809999949],
              [152.65064537900003, -3.114678643999923],
            ],
          ],
          [
            [
              [150.9921981130001, -2.957696221999925],
              [151.00342858200008, -2.959730726999908],
              [151.01286868600005, -2.958591403999947],
              [151.020355665, -2.960137627999927],
              [151.02621504, -2.970635674999926],
              [151.00904381600003, -2.975192966999941],
              [150.9921981130001, -2.984307549999926],
              [150.98601321700005, -2.969170830999929],
              [150.97584069100003, -2.965915622999944],
              [150.95045006600003, -2.970635674999926],
              [150.90650475400003, -2.970635674999926],
              [150.85694420700008, -2.959567966999941],
              [150.8349715500001, -2.960137627999927],
              [150.82146243600005, -2.977634372999944],
              [150.80616295700008, -2.971856377999927],
              [150.79712975400003, -2.975030205999929],
              [150.7890731130001, -2.981133721999925],
              [150.776703321, -2.984307549999926],
              [150.76978600400003, -2.979587497999944],
              [150.778168165, -2.968519789999959],
              [150.80095462300005, -2.950290622999944],
              [150.8164168630001, -2.953545830999929],
              [150.84009850400003, -2.938164971999925],
              [150.88233483200008, -2.903008721999925],
              [150.9423934250001, -2.923272393999923],
              [150.9648543630001, -2.936618747999944],
              [150.98316491000003, -2.952732028999947],
              [150.9921981130001, -2.957696221999925],
            ],
          ],
          [
            [
              [152.07154381600003, -2.916680596999925],
              [152.07790849100002, -2.92900893999996],
              [152.07887095900003, -2.956761363999931],
              [152.06277344600005, -2.972736054999928],
              [152.0512801440001, -2.995212497999944],
              [152.02535590800005, -2.996071559999962],
              [152.00515503600002, -2.967225491999955],
              [151.99241416200005, -2.944789454999921],
              [151.99359877000006, -2.909568666999917],
              [151.98975670700008, -2.896661065999922],
              [151.9785262380001, -2.893161716999941],
              [151.96745853000004, -2.887627862999921],
              [151.95850670700008, -2.875176690999922],
              [151.9653426440001, -2.875176690999922],
              [151.96436608200008, -2.861504815999922],
              [151.97193444100003, -2.847832940999922],
              [151.9829207690001, -2.842868747999944],
              [151.9926863940001, -2.854668877999927],
              [152.00554446700005, -2.876885674999926],
              [152.023773634, -2.896742445999962],
              [152.04484589000003, -2.909734735999962],
              [152.07154381600003, -2.916680596999925],
            ],
          ],
          [
            [
              [152.01319420700008, -2.806817315999922],
              [152.0058699880001, -2.820407809999949],
              [151.98707116000003, -2.831231377999927],
              [151.9653426440001, -2.838311455999929],
              [151.92756208700007, -2.851771608999911],
              [151.91584022900008, -2.844289881999941],
              [151.9159342590001, -2.81338438399996],
              [151.91279925600008, -2.788780043999907],
              [151.90862625600005, -2.753468257999941],
              [151.9130377360001, -2.705389387999958],
              [151.93580162900003, -2.705987237999921],
              [151.97820071700005, -2.720879815999922],
              [151.98585045700008, -2.724867445999962],
              [152.00505618600005, -2.742120049999926],
              [152.0097762380001, -2.744805596999925],
              [152.008636915, -2.753838799999926],
              [152.01148522200003, -2.773370049999926],
              [152.00928795700008, -2.792575778999947],
              [151.9926863940001, -2.799981377999927],
              [151.99431399800005, -2.802666924999926],
              [151.99952233200008, -2.814222914999959],
              [152.00896243600005, -2.808363539999959],
              [152.01319420700008, -2.806817315999922],
            ],
          ],
          [
            [
              [151.9824324880001, -2.662774346999925],
              [151.96021569100003, -2.651543877999927],
              [151.960297071, -2.626722914999959],
              [151.9755965500001, -2.603122653999947],
              [151.99952233200008, -2.594496351999908],
              [152.01539147200003, -2.602715752999927],
              [152.02857506600003, -2.619073174999926],
              [152.03679446700005, -2.635186455999929],
              [152.03736412900003, -2.642347914999959],
              [152.0341903000001, -2.645603122999944],
              [152.03142337300005, -2.652601820999962],
              [152.02654056100005, -2.659600518999923],
              [152.0166121750001, -2.662774346999925],
              [151.9824324880001, -2.662774346999925],
            ],
          ],
          [
            [
              [153.1372176440001, -4.269463799999926],
              [153.1279403000001, -4.324883721999925],
              [153.12680097700002, -4.350192966999941],
              [153.1372176440001, -4.375909112999921],
              [153.11215254, -4.403903903999947],
              [153.054047071, -4.452325127999927],
              [153.0410262380001, -4.485772393999923],
              [153.04420006600003, -4.505059502999927],
              [153.05396569100003, -4.517185153999947],
              [153.06568444100003, -4.527276299999926],
              [153.0752059250001, -4.54029713299991],
              [153.0791121750001, -4.554457289999959],
              [153.0805770190001, -4.57000090899993],
              [153.0791121750001, -4.586114190999922],
              [153.0752059250001, -4.601820570999905],
              [153.06788170700008, -4.610284112999921],
              [153.0434676440001, -4.625583591999941],
              [153.03484134200005, -4.63600025799991],
              [153.03630618600005, -4.661228122999944],
              [153.03484134200005, -4.670098565999922],
              [153.02906334700003, -4.679620049999926],
              [153.01482181100005, -4.69068775799991],
              [153.00757897200003, -4.698011976999908],
              [153.000336134, -4.711195570999905],
              [152.9887801440001, -4.743584893999923],
              [152.98023522200003, -4.75945403399993],
              [152.9712020190001, -4.768731377999927],
              [152.96159915500004, -4.775648695999905],
              [152.95264733200008, -4.78484465899993],
              [152.94605553500003, -4.80046965899993],
              [152.92408287900003, -4.793877862999921],
              [152.914886915, -4.80787525799991],
              [152.9091903000001, -4.830173434999949],
              [152.89771569100003, -4.848321221999925],
              [152.88933353000004, -4.818129164999959],
              [152.87378991000003, -4.788832289999959],
              [152.84945722700002, -4.763848565999922],
              [152.81511478000004, -4.745863539999959],
              [152.81812584700003, -4.721368096999925],
              [152.7910262380001, -4.695977471999925],
              [152.75538170700008, -4.67156340899993],
              [152.73259524800005, -4.649590752999927],
              [152.72771243600005, -4.633477471999925],
              [152.72632897200003, -4.578301690999922],
              [152.72193444100003, -4.571709893999923],
              [152.700531446, -4.561211846999925],
              [152.69214928500003, -4.554782809999949],
              [152.689789259, -4.547784112999921],
              [152.6821395190001, -4.497491143999923],
              [152.67212975400003, -4.465264580999929],
              [152.67115319100003, -4.451755466999941],
              [152.68970787900003, -4.404392184999949],
              [152.6914168630001, -4.397149346999925],
              [152.70386803500003, -4.289971612999921],
              [152.69214928500003, -4.266045830999929],
              [152.69800866000003, -4.254001559999949],
              [152.697601759, -4.240980726999908],
              [152.69288170700008, -4.228692315999922],
              [152.68482506600003, -4.218357028999947],
              [152.69402103000004, -4.199314059999949],
              [152.694672071, -4.18132903399993],
              [152.687836134, -4.163832289999959],
              [152.66187584700003, -4.129978122999944],
              [152.6123153000001, -4.031508070999905],
              [152.6059676440001, -4.003024997999944],
              [152.59880618600005, -3.98601653399993],
              [152.58228600400003, -3.957614841999941],
              [152.56128991000003, -3.936618747999944],
              [152.55241946700005, -3.924004815999922],
              [152.5488387380001, -3.906426690999922],
              [152.5454207690001, -3.901950778999947],
              [152.53052819100003, -3.891696872999944],
              [152.52711022200003, -3.886163018999923],
              [152.52605228000004, -3.87468840899993],
              [152.52320397200003, -3.863864841999941],
              [152.518890821, -3.854668877999927],
              [152.51343834700003, -3.848321221999925],
              [152.50570722700002, -3.845147393999923],
              [152.48755944100003, -3.844170830999929],
              [152.47868899800005, -3.840915622999944],
              [152.4726668630001, -3.833184502999927],
              [152.46208743600005, -3.81178150799991],
              [152.4443465500001, -3.799086195999905],
              [152.3598738940001, -3.694105726999908],
              [152.3564559250001, -3.684258721999925],
              [152.36060631600003, -3.661065362999921],
              [152.35962975400003, -3.653008721999925],
              [152.35035241000003, -3.645277601999908],
              [152.335297071, -3.635430596999925],
              [152.3105574880001, -3.610935153999947],
              [152.29957116000003, -3.596856377999927],
              [152.28858483200008, -3.569756768999923],
              [152.27361087300005, -3.563083591999941],
              [152.25538170700008, -3.559177341999941],
              [152.23975670700008, -3.553480726999908],
              [152.2363387380001, -3.54851653399993],
              [152.2290145190001, -3.531426690999922],
              [152.22543379, -3.525567315999922],
              [152.21631920700008, -3.519138278999947],
              [152.19752037900003, -3.510186455999929],
              [152.17107181100005, -3.490166924999926],
              [152.15251712300005, -3.487237237999921],
              [152.13209069100003, -3.487481377999927],
              [151.98406009200005, -3.458916924999926],
              [151.94548587300005, -3.444268487999921],
              [151.8090926440001, -3.361097914999959],
              [151.61247806100005, -3.166192315999922],
              [151.59652754, -3.156182549999926],
              [151.53402754, -3.142022393999923],
              [151.47388756600003, -3.117608330999929],
              [151.46509850400003, -3.111260674999926],
              [151.4629012380001, -3.106377862999921],
              [151.45826256600003, -3.101332289999959],
              [151.4536238940001, -3.094496351999908],
              [151.4497176440001, -3.074639580999929],
              [151.4453231130001, -3.066989841999941],
              [151.43043053500003, -3.053317966999941],
              [151.36443118600005, -3.016778252999927],
              [151.34555097700002, -3.001722914999959],
              [151.33855228000004, -2.99773528399993],
              [151.2929793630001, -2.980075778999947],
              [151.27076256600003, -2.958428643999923],
              [151.2602645190001, -2.950290622999944],
              [151.24244225400003, -2.945082289999959],
              [151.22445722700002, -2.941989841999941],
              [151.21070397200003, -2.935316664999959],
              [151.2050887380001, -2.919854424999926],
              [151.1806746750001, -2.89617278399993],
              [151.16032962300005, -2.89617278399993],
              [151.15251712300005, -2.894707940999922],
              [151.151703321, -2.891045830999929],
              [151.1528426440001, -2.886488539999959],
              [151.1504012380001, -2.88250090899993],
              [151.1357528000001, -2.873304945999962],
              [151.122406446, -2.862074476999908],
              [151.12061608200008, -2.85906340899993],
              [151.1181746750001, -2.85125090899993],
              [151.1162215500001, -2.848402601999908],
              [151.102875196, -2.840997002999927],
              [151.0986434250001, -2.83757903399993],
              [151.09058678500003, -2.832696221999925],
              [151.07976321700005, -2.829522393999923],
              [151.045258009, -2.825127862999921],
              [151.03736412900003, -2.819919528999947],
              [151.02621504, -2.806817315999922],
              [151.01392662900003, -2.795505466999941],
              [151.00757897200003, -2.790948174999926],
              [150.9990340500001, -2.786309502999927],
              [150.98845462300005, -2.783461195999962],
              [150.9638778000001, -2.780368747999944],
              [150.93580162900003, -2.766534112999921],
              [150.91521243600005, -2.76490650799991],
              [150.83708743600005, -2.779392184999949],
              [150.7954207690001, -2.779229424999926],
              [150.7597762380001, -2.76881275799991],
              [150.73894290500004, -2.744805596999925],
              [150.73991946700005, -2.732517184999949],
              [150.74732506600003, -2.717950127999927],
              [150.76002037900003, -2.711032809999949],
              [150.776703321, -2.721123955999929],
              [150.7949324880001, -2.729099216999941],
              [150.81592858200008, -2.720961195999962],
              [150.85499108200008, -2.69695403399993],
              [150.87614993600005, -2.712660414999959],
              [150.89242597700002, -2.697523695999962],
              [150.89332116000003, -2.675225518999923],
              [150.868011915, -2.669040622999944],
              [150.883636915, -2.654066664999959],
              [150.88111412900003, -2.643487237999921],
              [150.86988366000003, -2.637139580999929],
              [150.858734571, -2.634942315999922],
              [150.83936608200008, -2.633558851999908],
              [150.82601972700002, -2.629978122999944],
              [150.7934676440001, -2.615004164999959],
              [150.81397545700008, -2.573988539999959],
              [150.81202233200008, -2.570977471999925],
              [150.81039472700002, -2.562107028999947],
              [150.81267337300005, -2.555840752999927],
              [150.8339949880001, -2.566827080999929],
              [150.84245853000004, -2.576592705999929],
              [150.84945722700002, -2.587497653999947],
              [150.858734571, -2.597751559999949],
              [150.89087975400003, -2.616631768999923],
              [150.8964949880001, -2.618096612999921],
              [150.901703321, -2.63014088299991],
              [150.91334069100003, -2.638116143999923],
              [150.936859571, -2.649183851999908],
              [150.961761915, -2.680759372999944],
              [150.97234134200005, -2.690118096999925],
              [150.97999108200008, -2.692559502999927],
              [151.02230879, -2.699151299999926],
              [151.0312606130001, -2.703789971999925],
              [151.03785241000003, -2.708428643999923],
              [151.04363040500004, -2.71062590899993],
              [151.0473738940001, -2.715101820999962],
              [151.05616295700008, -2.736911716999941],
              [151.06169681100005, -2.744805596999925],
              [151.07300866000003, -2.749444268999923],
              [151.08480879, -2.750583591999941],
              [151.09685306100005, -2.753838799999926],
              [151.10889733200008, -2.75904713299991],
              [151.1704207690001, -2.785088799999926],
              [151.19109134200005, -2.807061455999929],
              [151.19890384200005, -2.844659112999921],
              [151.21631920700008, -2.869235934999949],
              [151.25668379, -2.877536716999941],
              [151.33171634200005, -2.875176690999922],
              [151.34294681100005, -2.877536716999941],
              [151.34913170700008, -2.883558851999908],
              [151.3535262380001, -2.891534112999921],
              [151.35922285200002, -2.899590752999927],
              [151.36890709700003, -2.904066664999959],
              [151.37907962300005, -2.902113539999959],
              [151.38843834700003, -2.89812590899993],
              [151.39616946700005, -2.89617278399993],
              [151.41822350400003, -2.900485934999949],
              [151.43734785200002, -2.908868096999925],
              [151.45484459700003, -2.921075127999927],
              [151.47193444100003, -2.936618747999944],
              [151.50261478000004, -2.974216403999947],
              [151.5087996750001, -2.97584400799991],
              [151.53101647200003, -2.97625090899993],
              [151.54029381600003, -2.977634372999944],
              [151.5976668630001, -3.019707940999922],
              [151.60914147200003, -3.018487237999921],
              [151.68677819100003, -3.066989841999941],
              [151.70533287900003, -3.087497653999947],
              [151.715668165, -3.105238539999959],
              [151.73218834700003, -3.127129815999922],
              [151.7539168630001, -3.141045830999929],
              [151.78044681100005, -3.135837497999944],
              [151.78638756600003, -3.160821221999925],
              [151.79859459700003, -3.177829684999949],
              [151.813812696, -3.187432549999926],
              [151.8281356130001, -3.190362237999921],
              [151.86500084700003, -3.188571872999944],
              [151.87671959700003, -3.190362237999921],
              [151.8969832690001, -3.201755466999941],
              [151.90935306100005, -3.204196872999944],
              [151.9243270190001, -3.197360934999949],
              [151.93482506600003, -3.203301690999922],
              [151.95101972700002, -3.218519789999959],
              [151.9697371750001, -3.23170338299991],
              [151.97339928500003, -3.23211028399993],
              [152.00464928500003, -3.23211028399993],
              [152.01433353000004, -3.234958591999941],
              [152.027679884, -3.244886976999908],
              [152.03296959700003, -3.245863539999959],
              [152.04420006600003, -3.245700778999947],
              [152.05250084700003, -3.246677341999941],
              [152.05347741000003, -3.24928150799991],
              [152.05241946700005, -3.253676039999959],
              [152.0546981130001, -3.259372653999947],
              [152.05591881600003, -3.26336028399993],
              [152.054047071, -3.275323174999926],
              [152.0546981130001, -3.279880466999941],
              [152.0571395190001, -3.281345309999949],
              [152.0654403000001, -3.284600518999923],
              [152.067718946, -3.286065362999921],
              [152.07398522200003, -3.293877862999921],
              [152.11101321700005, -3.330173434999949],
              [152.1601668630001, -3.402113539999959],
              [152.18677819100003, -3.431573174999926],
              [152.21745853000004, -3.456963799999926],
              [152.25342858200008, -3.478448174999926],
              [152.3242293630001, -3.51100025799991],
              [152.33961022200003, -3.527439059999949],
              [152.35889733200008, -3.537692966999941],
              [152.3632918630001, -3.543226820999905],
              [152.36939537900003, -3.580824476999908],
              [152.3735457690001, -3.585056247999944],
              [152.38200931100005, -3.587009372999944],
              [152.38746178500003, -3.590752862999921],
              [152.391449415, -3.596123955999929],
              [152.3969832690001, -3.60711028399993],
              [152.40845787900003, -3.621514580999929],
              [152.41724694100003, -3.644952080999929],
              [152.42465254, -3.656508070999905],
              [152.444672071, -3.669122002999927],
              [152.4648543630001, -3.668389580999929],
              [152.48194420700008, -3.658135674999926],
              [152.49293053500003, -3.642836195999905],
              [152.506195509, -3.657321872999944],
              [152.5195418630001, -3.676202080999929],
              [152.5297957690001, -3.696465752999927],
              [152.53394616000003, -3.714613539999959],
              [152.53825931100005, -3.724379164999959],
              [152.556976759, -3.744317315999922],
              [152.56128991000003, -3.75554778399993],
              [152.55925540500004, -3.767673434999949],
              [152.5551863940001, -3.777601820999905],
              [152.55250084700003, -3.787692966999941],
              [152.55738366000003, -3.799574476999908],
              [152.566742384, -3.80828215899993],
              [152.5752059250001, -3.818129164999959],
              [152.57496178500003, -3.821058851999908],
              [152.585297071, -3.824883721999925],
              [152.59595787900003, -3.826918226999908],
              [152.619476759, -3.827894789999959],
              [152.6445418630001, -3.832696221999925],
              [152.66228274800005, -3.844903252999927],
              [152.6782332690001, -3.860446872999944],
              [152.69841556100005, -3.875664971999925],
              [152.71753991000003, -3.885511976999908],
              [152.73601321700005, -3.89226653399993],
              [152.755218946, -3.89617278399993],
              [152.77759850400003, -3.897393487999921],
              [152.79810631600003, -3.888767184999949],
              [152.81226647200003, -3.87428150799991],
              [152.82349694100003, -3.871351820999905],
              [152.83619225400003, -3.897393487999921],
              [152.8383895190001, -3.907403252999927],
              [152.84009850400003, -3.927829684999949],
              [152.84245853000004, -3.937758070999905],
              [152.84750410200002, -3.947523695999905],
              [152.8603621750001, -3.965508721999925],
              [152.86280358200008, -3.975274346999925],
              [152.8711043630001, -3.990899346999925],
              [152.89047285200002, -3.998142184999949],
              [152.913422071, -3.999769789999959],
              [152.93181399800005, -3.999200127999927],
              [152.93238366000003, -3.99732838299991],
              [152.94605553500003, -3.985528252999927],
              [152.95630944100003, -3.998630466999941],
              [152.95777428500003, -4.011814059999949],
              [152.95655358200008, -4.025648695999905],
              [152.9589949880001, -4.04070403399993],
              [152.969574415, -4.055271091999941],
              [153.00147545700008, -4.081231377999927],
              [153.01441491000003, -4.094821872999944],
              [153.0410262380001, -4.149997653999947],
              [153.05738366000003, -4.172784112999921],
              [153.06666100400003, -4.189873955999929],
              [153.06519616000003, -4.197849216999941],
              [153.08375084700003, -4.205498955999929],
              [153.107758009, -4.224541924999926],
              [153.12842858200008, -4.248142184999949],
              [153.1372176440001, -4.269463799999926],
            ],
          ],
          [
            [
              [150.46509850400003, -2.53248463299991],
              [150.4707137380001, -2.546970309999949],
              [150.46509850400003, -2.560804945999962],
              [150.45582116000003, -2.575127862999921],
              [150.45093834700003, -2.590915622999944],
              [150.4516707690001, -2.607598565999922],
              [150.453949415, -2.621026299999926],
              [150.458343946, -2.632256768999923],
              [150.46509850400003, -2.642347914999959],
              [150.45826256600003, -2.653497002999927],
              [150.45134524800005, -2.658379815999922],
              [150.42986087300005, -2.662774346999925],
              [150.39242597700002, -2.676446221999925],
              [150.3818465500001, -2.678806247999944],
              [150.37175540500004, -2.682224216999941],
              [150.36443118600005, -2.681817315999922],
              [150.36150149800005, -2.672784112999921],
              [150.354828321, -2.661553643999923],
              [150.3398543630001, -2.664239190999922],
              [150.32374108200008, -2.673760674999926],
              [150.31373131600003, -2.68328215899993],
              [150.30827884200005, -2.679294528999947],
              [150.298187696, -2.673597914999959],
              [150.29322350400003, -2.669040622999944],
              [150.27711022200003, -2.673760674999926],
              [150.2021590500001, -2.677504164999959],
              [150.19410241000003, -2.679131768999923],
              [150.18677819100003, -2.679457289999959],
              [150.17725670700008, -2.676446221999925],
              [150.16871178500003, -2.669854424999926],
              [150.13624108200008, -2.634942315999922],
              [150.11475670700008, -2.622979424999926],
              [150.10572350400003, -2.615899346999925],
              [150.08936608200008, -2.566582940999922],
              [150.04712975400003, -2.516289971999925],
              [150.03248131600003, -2.50514088299991],
              [150.0097762380001, -2.512872002999927],
              [149.97974694100003, -2.498955987999921],
              [149.95777428500003, -2.477634372999944],
              [149.95875084700003, -2.462985934999949],
              [149.96550540500004, -2.459242445999962],
              [149.9716903000001, -2.462823174999926],
              [149.97803795700008, -2.468357028999947],
              [149.9853621750001, -2.47039153399993],
              [149.9946395190001, -2.46648528399993],
              [150.0673934250001, -2.416436455999929],
              [150.08326256600003, -2.413832289999959],
              [150.09685306100005, -2.41375090899993],
              [150.1084090500001, -2.412367445999962],
              [150.11882571700005, -2.40553150799991],
              [150.15902754, -2.391371351999908],
              [150.16000410200002, -2.388441664999959],
              [150.17302493600005, -2.386325778999947],
              [150.1933699880001, -2.377048434999949],
              [150.207855665, -2.374769789999959],
              [150.23023522200003, -2.383477471999925],
              [150.28467858200008, -2.416599216999941],
              [150.30689537900003, -2.416436455999929],
              [150.31568444100003, -2.42156340899993],
              [150.3418074880001, -2.433363539999959],
              [150.3515731130001, -2.435723565999922],
              [150.35499108200008, -2.437676690999922],
              [150.3642684250001, -2.447198174999926],
              [150.36890709700003, -2.45045338299991],
              [150.39576256600003, -2.45671965899993],
              [150.42359459700003, -2.467217705999929],
              [150.4472762380001, -2.484470309999949],
              [150.45883222700002, -2.508477471999925],
              [150.45093834700003, -2.539320570999962],
              [150.461273634, -2.534763278999947],
              [150.46509850400003, -2.53248463299991],
            ],
          ],
          [
            [
              [147.8266707690001, -2.23756275799991],
              [147.84839928500003, -2.264743747999944],
              [147.863617384, -2.278252862999921],
              [147.881195509, -2.286065362999921],
              [147.85816491000003, -2.324476820999962],
              [147.84001712300005, -2.340915622999944],
              [147.8164168630001, -2.347426039999959],
              [147.77515709700003, -2.347426039999959],
              [147.760101759, -2.345798434999949],
              [147.75074303500003, -2.341241143999923],
              [147.7304793630001, -2.326429945999962],
              [147.73267662900003, -2.31959400799991],
              [147.73454837300005, -2.316827080999929],
              [147.7373153000001, -2.313409112999921],
              [147.76319420700008, -2.321058851999908],
              [147.7871199880001, -2.311700127999927],
              [147.79997806100005, -2.291192315999922],
              [147.79249108200008, -2.265557549999926],
              [147.80152428500003, -2.260186455999929],
              [147.80925540500004, -2.252618096999925],
              [147.81364993600005, -2.244724216999941],
              [147.8129988940001, -2.23756275799991],
              [147.8266707690001, -2.23756275799991],
            ],
          ],
          [
            [
              [147.43279056100005, -1.983819268999923],
              [147.44206790500004, -1.990166924999926],
              [147.44459069100003, -2.004815362999921],
              [147.44304446700005, -2.035577080999929],
              [147.43116295700008, -2.060804945999962],
              [147.4023543630001, -2.066827080999929],
              [147.36646569100003, -2.065036716999941],
              [147.33318118600005, -2.066989841999941],
              [147.33814537900003, -2.06178150799991],
              [147.34742272200003, -2.045830987999921],
              [147.3271590500001, -2.045505466999941],
              [147.31666100400003, -2.050957940999922],
              [147.3110457690001, -2.062432549999926],
              [147.30591881600003, -2.080010674999926],
              [147.29908287900003, -2.080010674999926],
              [147.29175866000003, -2.064222914999959],
              [147.28199303500003, -2.081149997999944],
              [147.27458743600005, -2.107679945999962],
              [147.27491295700008, -2.121514580999929],
              [147.26335696700005, -2.130303643999923],
              [147.23170006600003, -2.170830987999921],
              [147.21648196700005, -2.183038018999923],
              [147.20573978000004, -2.186130466999941],
              [147.19703209700003, -2.18678150799991],
              [147.1879988940001, -2.185723565999922],
              [147.176117384, -2.183038018999923],
              [147.13949629, -2.16529713299991],
              [147.13070722700002, -2.162530205999929],
              [147.10865319100003, -2.167413018999923],
              [147.07007897200003, -2.187595309999949],
              [147.04517662900003, -2.189873955999929],
              [147.04517662900003, -2.185316664999959],
              [147.04656009200005, -2.182305596999925],
              [147.05201256600003, -2.176202080999929],
              [147.0200301440001, -2.18678150799991],
              [146.98894290500004, -2.193291924999926],
              [146.95492597700002, -2.194756768999923],
              [146.8403426440001, -2.176202080999929],
              [146.83570397200003, -2.173760674999926],
              [146.82797285200002, -2.164646091999941],
              [146.8227645190001, -2.162530205999929],
              [146.81666100400003, -2.163669528999947],
              [146.80746504, -2.168226820999962],
              [146.80250084700003, -2.169366143999923],
              [146.79672285200002, -2.166192315999922],
              [146.79118899800005, -2.159112237999921],
              [146.7841903000001, -2.15203215899993],
              [146.77458743600005, -2.148858330999929],
              [146.7695418630001, -2.146091403999947],
              [146.76091556100005, -2.132419528999947],
              [146.757172071, -2.127699476999908],
              [146.7500106130001, -2.123223565999922],
              [146.745453321, -2.121514580999929],
              [146.72681725400003, -2.121514580999929],
              [146.70240319100003, -2.114353122999944],
              [146.69646243600005, -2.114841403999947],
              [146.69117272200003, -2.123711846999925],
              [146.69157962300005, -2.13250090899993],
              [146.69695071700005, -2.139336846999925],
              [146.7060653000001, -2.142185153999947],
              [146.72095787900003, -2.148532809999949],
              [146.72925866000003, -2.162530205999929],
              [146.72771243600005, -2.176690362999921],
              [146.7129012380001, -2.183038018999923],
              [146.67546634200005, -2.189385674999926],
              [146.65788821700005, -2.186211846999925],
              [146.64795983200008, -2.169366143999923],
              [146.62916100400003, -2.177504164999959],
              [146.61117597700002, -2.181898695999962],
              [146.597992384, -2.189385674999926],
              [146.58659915500004, -2.224379164999959],
              [146.57154381600003, -2.228122653999947],
              [146.55347741000003, -2.220310153999947],
              [146.5380965500001, -2.203545830999929],
              [146.53199303500003, -2.189711195999962],
              [146.52019290500004, -2.149590752999927],
              [146.52076256600003, -2.138767184999949],
              [146.53638756600003, -2.119724216999941],
              [146.545258009, -2.114190362999921],
              [146.5625106130001, -2.12078215899993],
              [146.5727645190001, -2.120212497999944],
              [146.60474694100003, -2.111911716999941],
              [146.6123153000001, -2.111097914999959],
              [146.6171981130001, -2.106866143999923],
              [146.62061608200008, -2.093682549999926],
              [146.618500196, -2.08326588299991],
              [146.61207116000003, -2.070489190999922],
              [146.58863366000003, -2.040459893999923],
              [146.58326256600003, -2.030857028999947],
              [146.5800887380001, -2.020277601999908],
              [146.5791121750001, -2.008396091999941],
              [146.5805770190001, -1.995212497999944],
              [146.58472741000003, -1.992364190999922],
              [146.6001082690001, -1.998142184999949],
              [146.60377037900003, -2.001885674999926],
              [146.6084090500001, -2.008721612999921],
              [146.61548912900003, -2.013767184999949],
              [146.62680097700002, -2.011651299999926],
              [146.63038170700008, -2.004082940999922],
              [146.63795006600003, -1.97625090899993],
              [146.6445418630001, -1.970147393999923],
              [146.6474715500001, -1.969008070999962],
              [146.64918053500003, -1.966729424999926],
              [146.65211022200003, -1.964450778999947],
              [146.65788821700005, -1.963311455999929],
              [146.66374759200005, -1.965508721999925],
              [146.67302493600005, -1.975274346999925],
              [146.67855879, -1.977634372999944],
              [146.6894637380001, -1.97625090899993],
              [146.70582116000003, -1.970879815999922],
              [146.71631920700008, -1.970147393999923],
              [146.72877037900003, -1.972832940999922],
              [146.75310306100005, -1.981866143999923],
              [146.76775149800005, -1.983819268999923],
              [146.780609571, -1.980564059999949],
              [146.8193465500001, -1.957126559999949],
              [146.8457137380001, -1.94850025799991],
              [146.86980228000004, -1.947035414999959],
              [146.89234459700003, -1.952080987999921],
              [146.914886915, -1.963311455999929],
              [146.94011478000004, -1.954847914999959],
              [147.11003665500004, -1.963311455999929],
              [147.11939537900003, -1.968357028999947],
              [147.13103274800005, -1.98015715899993],
              [147.1416121750001, -1.993910414999959],
              [147.14763431100005, -2.004978122999944],
              [147.15447024800005, -2.004978122999944],
              [147.15894616000003, -1.989027601999908],
              [147.17107181100005, -1.980401299999926],
              [147.18336022200003, -1.979668877999927],
              [147.18921959700003, -1.987481377999927],
              [147.19516035200002, -1.998630466999941],
              [147.2094832690001, -2.000583591999941],
              [147.23755944100003, -1.998142184999949],
              [147.27857506600003, -2.015394789999959],
              [147.285980665, -2.015069268999923],
              [147.292328321, -2.019138278999947],
              [147.33318118600005, -2.032321872999944],
              [147.34937584700003, -2.02857838299991],
              [147.3759871750001, -2.02898528399993],
              [147.401703321, -2.034356377999927],
              [147.41578209700003, -2.045830987999921],
              [147.42261803500003, -2.045830987999921],
              [147.42261803500003, -2.018487237999921],
              [147.41960696700005, -2.009860934999949],
              [147.41032962300005, -1.994317315999922],
              [147.40837649800005, -1.987481377999927],
              [147.40064537900003, -1.978122653999947],
              [147.38697350400003, -1.968926690999922],
              [147.3808699880001, -1.961521091999941],
              [147.395843946, -1.957126559999949],
              [147.40593509200005, -1.962823174999926],
              [147.42204837300005, -1.98015715899993],
              [147.43279056100005, -1.983819268999923],
            ],
          ],
          [
            [
              [149.73503665500004, -1.473565362999921],
              [149.739105665, -1.480645440999922],
              [149.7519637380001, -1.51140715899993],
              [149.762543165, -1.530450127999927],
              [149.7841903000001, -1.56023528399993],
              [149.7929793630001, -1.580336195999962],
              [149.77662194100003, -1.581475518999923],
              [149.753265821, -1.593519789999959],
              [149.73902428500003, -1.594008070999962],
              [149.7295028000001, -1.590508721999925],
              [149.7265731130001, -1.586195570999962],
              [149.72478274800005, -1.580824476999908],
              [149.71843509200005, -1.57350025799991],
              [149.70199629, -1.560723565999922],
              [149.6938582690001, -1.55592213299991],
              [149.68433678500003, -1.55242278399993],
              [149.68336022200003, -1.58131275799991],
              [149.6670028000001, -1.57586028399993],
              [149.632172071, -1.54615650799991],
              [149.62232506600003, -1.543145440999922],
              [149.61280358200008, -1.535739841999941],
              [149.59205162900003, -1.51490650799991],
              [149.58765709700003, -1.505791924999926],
              [149.58415774800005, -1.501153252999927],
              [149.57837975400003, -1.498467705999929],
              [149.5654403000001, -1.499444268999923],
              [149.56023196700005, -1.49773528399993],
              [149.5468856130001, -1.482191664999959],
              [149.5410262380001, -1.464450778999947],
              [149.53980553500003, -1.42546965899993],
              [149.5722762380001, -1.358575127999927],
              [149.58073978000004, -1.346368096999925],
              [149.5869246750001, -1.352227471999925],
              [149.5957137380001, -1.354261976999908],
              [149.61866295700008, -1.353773695999962],
              [149.62761478000004, -1.35711028399993],
              [149.64966881600003, -1.381117445999962],
              [149.7109481130001, -1.415134372999944],
              [149.72478274800005, -1.428887627999927],
              [149.72722415500004, -1.440850518999923],
              [149.725922071, -1.451918226999908],
              [149.7265731130001, -1.462823174999926],
              [149.73503665500004, -1.473565362999921],
            ],
          ],
          [
            [
              [154.19214928500003, -4.464613539999959],
              [154.22038821700005, -4.476495049999926],
              [154.24195397200003, -4.498793226999908],
              [154.25407962300005, -4.526543877999927],
              [154.25367272200003, -4.554782809999949],
              [154.23226972700002, -4.580661716999941],
              [154.20525149800005, -4.57195403399993],
              [154.18531334700003, -4.546075127999927],
              [154.18531334700003, -4.519952080999929],
              [154.19117272200003, -4.529880466999941],
              [154.19947350400003, -4.55242278399993],
              [154.20582116000003, -4.560967705999929],
              [154.21697024800005, -4.567966403999947],
              [154.22380618600005, -4.567071221999925],
              [154.2368270190001, -4.551364841999941],
              [154.24195397200003, -4.527927341999941],
              [154.22632897200003, -4.50359465899993],
              [154.20329837300005, -4.483575127999927],
              [154.18531334700003, -4.472100518999923],
              [154.18384850400003, -4.473402601999908],
              [154.18279056100005, -4.475030205999929],
              [154.18116295700008, -4.476983330999929],
              [154.17847741000003, -4.478936455999929],
              [154.17945397200003, -4.47193775799991],
              [154.1826278000001, -4.468682549999926],
              [154.19214928500003, -4.464613539999959],
            ],
          ],
          [
            [
              [154.1513778000001, -4.438083591999941],
              [154.14673912900003, -4.41725025799991],
              [154.13819420700008, -4.395196221999925],
              [154.13453209700003, -4.377211195999905],
              [154.14470462300005, -4.369073174999926],
              [154.15121504, -4.378838799999926],
              [154.15552819100003, -4.397556247999944],
              [154.1582137380001, -4.438083591999941],
              [154.1513778000001, -4.438083591999941],
            ],
          ],
          [
            [
              [152.48658287900003, -4.136325778999947],
              [152.50310306100005, -4.153497002999927],
              [152.506195509, -4.171970309999949],
              [152.50123131600003, -4.191176039999959],
              [152.4926863940001, -4.210870049999926],
              [152.48658287900003, -4.210870049999926],
              [152.48015384200005, -4.208428643999923],
              [152.457367384, -4.203057549999926],
              [152.45240319100003, -4.201267184999949],
              [152.45183353000004, -4.187920830999929],
              [152.44939212300005, -4.177341403999947],
              [152.44304446700005, -4.169122002999927],
              [152.43132571700005, -4.163018487999921],
              [152.4570418630001, -4.14576588299991],
              [152.46501712300005, -4.13640715899993],
              [152.47291100400003, -4.122165622999944],
              [152.4834090500001, -4.131931247999944],
              [152.48658287900003, -4.136325778999947],
            ],
          ],
          [
            [
              [153.66480553500003, -4.04070403399993],
              [153.65748131600003, -4.047051690999922],
              [153.67058353000004, -4.090264580999929],
              [153.65691165500004, -4.122165622999944],
              [153.62964928500003, -4.129978122999944],
              [153.60279381600003, -4.101006768999923],
              [153.59986412900003, -4.09929778399993],
              [153.59587649800005, -4.100355726999908],
              [153.59205162900003, -4.100192966999941],
              [153.58969160200002, -4.094821872999944],
              [153.5898543630001, -4.088067315999922],
              [153.59197024800005, -4.083591403999947],
              [153.59441165500004, -4.079522393999923],
              [153.60108483200008, -4.064548434999949],
              [153.6142684250001, -4.048597914999959],
              [153.61695397200003, -4.043877862999921],
              [153.62566165500004, -4.032972914999959],
              [153.64380944100003, -4.022556247999944],
              [153.6606551440001, -4.022067966999941],
              [153.66480553500003, -4.04070403399993],
            ],
          ],
          [
            [
              [153.7192488940001, -3.999200127999927],
              [153.73804772200003, -4.001885674999926],
              [153.7470809250001, -4.01490650799991],
              [153.74561608200008, -4.03053150799991],
              [153.7329207690001, -4.04070403399993],
              [153.71941165500004, -4.038832289999959],
              [153.70850670700008, -4.030205987999921],
              [153.69654381600003, -4.023207289999959],
              [153.67888431100005, -4.026462497999944],
              [153.6865340500001, -4.016371351999908],
              [153.70850670700008, -4.006524346999925],
              [153.7192488940001, -3.999200127999927],
            ],
          ],
          [
            [
              [152.09449303500003, -10.40203215899993],
              [152.09913170700008, -10.390883070999905],
              [152.11011803500003, -10.391289971999925],
              [152.10767662900003, -10.400567315999922],
              [152.09449303500003, -10.40203215899993],
            ],
          ],
          [
            [
              [151.8696395190001, -10.344821872999944],
              [151.86841881600003, -10.337823174999926],
              [151.8774520190001, -10.334161065999922],
              [151.8696395190001, -10.344821872999944],
            ],
          ],
          [
            [
              [151.85271243600005, -10.25953541499996],
              [151.8623153000001, -10.250258070999905],
              [151.864593946, -10.254652601999908],
              [151.85661868600005, -10.26490650799991],
              [151.85271243600005, -10.25953541499996],
            ],
          ],
          [
            [
              [144.60027103000004, -3.499769789999959],
              [144.610199415, -3.502536716999941],
              [144.61866295700008, -3.508721612999921],
              [144.61980228000004, -3.516289971999925],
              [144.613617384, -3.519626559999949],
              [144.60767662900003, -3.517836195999905],
              [144.59986412900003, -3.518161716999941],
              [144.59587649800005, -3.517347914999959],
              [144.5922957690001, -3.513441664999959],
              [144.59302819100003, -3.505791924999926],
              [144.60027103000004, -3.499769789999959],
            ],
          ],
          [
            [
              [144.061568544, -3.215307817999928],
              [144.073471712, -3.197472435999941],
              [144.09579935800002, -3.188538649999941],
              [144.12109483200004, -3.215253842999914],
              [144.134498582, -3.230087855999955],
              [144.11515472500002, -3.247934893999911],
              [144.08092280300002, -3.239055936999932],
              [144.061568544, -3.215307817999928],
            ],
          ],
          [
            [
              [142.81812584700003, -1.733330987999921],
              [142.81853274800005, -1.712009372999944],
              [142.83350670700008, -1.697035414999959],
              [142.852386915, -1.69264088299991],
              [142.86548912900003, -1.703301690999922],
              [142.85914147200003, -1.705336195999962],
              [142.84489993600005, -1.712660414999959],
              [142.8291121750001, -1.722914320999962],
              [142.81812584700003, -1.733330987999921],
            ],
          ],
          [
            [
              [151.02466881600003, -9.638929945999905],
              [151.03012129, -9.643161716999941],
              [151.0341903000001, -9.65016041499996],
              [151.0312606130001, -9.660821221999925],
              [151.017914259, -9.66887786299992],
              [151.01238040500004, -9.664320570999905],
              [151.01091556100005, -9.652601820999905],
              [151.00603274800005, -9.64657968499995],
              [151.00318444100003, -9.642510674999926],
              [150.99683678500003, -9.634942315999922],
              [150.96892337300005, -9.620212497999944],
              [150.95533287900003, -9.607354424999926],
              [150.95980879, -9.592380466999941],
              [150.977875196, -9.582452080999929],
              [150.99634850400003, -9.580336195999905],
              [151.0117293630001, -9.585056247999944],
              [151.02222741000003, -9.591403903999947],
              [151.02491295700008, -9.600762627999927],
              [151.0278426440001, -9.602227471999925],
              [151.02808678500003, -9.60751718499995],
              [151.024261915, -9.62395598799992],
              [151.01937910200002, -9.626153252999927],
              [151.01677493600005, -9.62704843499995],
              [151.01783287900003, -9.63486093499995],
              [151.01978600400003, -9.63844166499996],
              [151.02466881600003, -9.638929945999905],
            ],
          ],
          [
            [
              [143.81592858200008, -8.49537525799991],
              [143.82211347700002, -8.49968840899993],
              [143.82292728000004, -8.50953541499996],
              [143.8134871750001, -8.530857028999947],
              [143.79607181100005, -8.538262627999927],
              [143.782562696, -8.527601820999905],
              [143.7802840500001, -8.513278903999947],
              [143.79224694100003, -8.504082940999922],
              [143.8032332690001, -8.500746351999908],
              [143.809906446, -8.496514580999929],
              [143.81592858200008, -8.49537525799991],
            ],
          ],
          [
            [
              [143.6743270190001, -8.390557549999926],
              [143.6762801440001, -8.399590752999927],
              [143.6816512380001, -8.412692966999941],
              [143.67896569100003, -8.421482028999947],
              [143.66773522200003, -8.427992445999905],
              [143.64828535200002, -8.42587655999995],
              [143.62574303500003, -8.412367445999905],
              [143.5898543630001, -8.371758721999925],
              [143.54086347700002, -8.350030205999929],
              [143.55062910200002, -8.336195570999905],
              [143.5996199880001, -8.332614841999941],
              [143.63795006600003, -8.340590101999908],
              [143.65691165500004, -8.35475025799991],
              [143.66863040500004, -8.372653903999947],
              [143.6743270190001, -8.390557549999926],
            ],
          ],
          [
            [
              [143.66293379, -8.109307549999926],
              [143.67986087300005, -8.121026299999926],
              [143.69011478000004, -8.136651299999926],
              [143.68824303500003, -8.15357838299991],
              [143.66667728000004, -8.167413018999923],
              [143.6337996750001, -8.164727471999925],
              [143.6137801440001, -8.138848565999922],
              [143.59937584700003, -8.110772393999923],
              [143.6132918630001, -8.094903252999927],
              [143.6406356130001, -8.09889088299991],
              [143.65406334700003, -8.104261976999908],
              [143.66293379, -8.109307549999926],
            ],
          ],
          [
            [
              [143.67562910200002, -8.053806247999944],
              [143.68637129, -8.066338799999926],
              [143.697601759, -8.090915622999944],
              [143.6904403000001, -8.100192966999941],
              [143.67595462300005, -8.093357028999947],
              [143.6484481130001, -8.084730726999908],
              [143.60710696700005, -8.08171965899993],
              [143.58179772200003, -8.068617445999905],
              [143.57390384200005, -8.051039320999905],
              [143.56421959700003, -8.029961846999925],
              [143.57781009200005, -8.018243096999925],
              [143.61255944100003, -8.020114841999941],
              [143.65601647200003, -8.039646091999941],
              [143.67562910200002, -8.053806247999944],
            ],
          ],
          [
            [
              [151.1884871750001, -4.891534112999921],
              [151.20582116000003, -4.901543877999927],
              [151.22331790500004, -4.918389580999929],
              [151.22331790500004, -4.93328215899993],
              [151.20679772200003, -4.947523695999905],
              [151.19597415500004, -4.951755466999941],
              [151.17107181100005, -4.956231377999927],
              [151.153168165, -4.953383070999905],
              [151.1450301440001, -4.946709893999923],
              [151.13152103000004, -4.938164971999925],
              [151.119476759, -4.925713799999926],
              [151.1215926440001, -4.914157809999949],
              [151.13640384200005, -4.901299737999921],
              [151.14380944100003, -4.896091403999947],
              [151.1601668630001, -4.888116143999923],
              [151.17554772200003, -4.887139580999929],
              [151.1884871750001, -4.891534112999921],
            ],
          ],
          [
            [
              [143.58521569100003, -3.378676039999959],
              [143.56853274800005, -3.378838799999926],
              [143.540375196, -3.367608330999929],
              [143.53394616000003, -3.365899346999925],
              [143.52312259200005, -3.36101653399993],
              [143.507172071, -3.347588799999926],
              [143.50855553500003, -3.338555596999925],
              [143.5146590500001, -3.331475518999923],
              [143.51587975400003, -3.320407809999949],
              [143.52295983200008, -3.314222914999959],
              [143.54281660200002, -3.316827080999929],
              [143.5688582690001, -3.330173434999949],
              [143.59392337300005, -3.348728122999944],
              [143.60027103000004, -3.367608330999929],
              [143.58521569100003, -3.378676039999959],
            ],
          ],
          [
            [
              [150.004242384, -1.672621351999908],
              [150.01880944100003, -1.671970309999949],
              [150.0234481130001, -1.674737237999921],
              [150.0175887380001, -1.681247653999947],
              [150.0004988940001, -1.685804945999962],
              [149.9746199880001, -1.684177341999941],
              [149.95972741000003, -1.678643487999921],
              [149.9560653000001, -1.675388278999947],
              [149.9482528000001, -1.67310963299991],
              [149.9399520190001, -1.67546965899993],
              [149.9375106130001, -1.678643487999921],
              [149.93580162900003, -1.683038018999923],
              [149.92725670700008, -1.684991143999923],
              [149.917328321, -1.676934502999927],
              [149.9121199880001, -1.664157809999949],
              [149.9121199880001, -1.653741143999923],
              [149.9204207690001, -1.651299737999921],
              [149.9433699880001, -1.658461195999962],
              [149.95232181100005, -1.650323174999926],
              [149.95630944100003, -1.633477471999925],
              [149.96412194100003, -1.630303643999923],
              [149.97543379, -1.642754815999922],
              [149.98121178500003, -1.656914971999925],
              [149.9892684250001, -1.668389580999929],
              [150.004242384, -1.672621351999908],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Australia',
        iso3: 'AUS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [131.53589928500003, -31.60556405999995],
              [131.34555097700002, -31.53093840899993],
              [131.17750084700003, -31.477634372999944],
              [131.13542728000004, -31.474786065999922],
              [131.0922957690001, -31.491957289999903],
              [130.993500196, -31.554294528999947],
              [130.83375084700003, -31.601739190999922],
              [130.7900496750001, -31.608086846999925],
              [130.69678795700008, -31.60556405999995],
              [130.547699415, -31.58562590899993],
              [130.311859571, -31.585544528999947],
              [130.26742597700002, -31.574476820999905],
              [130.15691165500004, -31.57390715899993],
              [130.1367293630001, -31.576836846999925],
              [130.07878665500004, -31.59433359199994],
              [129.94361412900003, -31.589288018999923],
              [129.75318444100003, -31.615492445999905],
              [129.53687584700003, -31.622247002999927],
              [129.471039259, -31.640801690999922],
              [129.4511824880001, -31.643324476999908],
              [129.36548912900003, -31.643324476999908],
              [129.30836022200003, -31.65471770599993],
              [129.28663170700008, -31.656426690999922],
              [129.22136478000004, -31.65439218499995],
              [129.20045006600003, -31.656426690999922],
              [129.13835696700005, -31.677504164999903],
              [129.12370853000004, -31.678887627999927],
              [129.093109571, -31.67742278399993],
              [129.00009199300007, -31.689222914999903],
              [128.99000084700003, -31.690524997999944],
              [128.9316512380001, -31.708103122999944],
              [128.77068118600005, -31.77825286299992],
              [128.75538170700008, -31.793633721999925],
              [128.72388756600003, -31.80364348799992],
              [128.6552840500001, -31.84579843499995],
              [128.21892337300005, -32.01767343499995],
              [128.01734459700003, -32.084242445999905],
              [127.76628665500004, -32.12314218499995],
              [127.58594811300009, -32.18238697699991],
              [127.56609134200005, -32.184665622999944],
              [127.55543053500003, -32.18889739399992],
              [127.53785241000003, -32.20712655999995],
              [127.53199303500003, -32.21135833099993],
              [127.28874759200005, -32.273370049999926],
              [127.11011803500003, -32.29338958099993],
              [127.09009850400003, -32.300713799999926],
              [127.08326256600003, -32.29387786299992],
              [127.05298912900003, -32.303806247999944],
              [126.93580162900003, -32.300713799999926],
              [126.820648634, -32.310804945999905],
              [126.78891035200002, -32.300713799999926],
              [126.76026451900009, -32.31096770599993],
              [126.67774498800009, -32.31658294099992],
              [126.37232506600003, -32.28281015399995],
              [126.27759850400003, -32.25628020599993],
              [126.24878991000003, -32.24163176899992],
              [126.20362389400009, -32.238539320999905],
              [126.18572024800005, -32.23251718499995],
              [126.17408287900003, -32.23691171699994],
              [126.13786868600005, -32.24537525799991],
              [126.12696373800009, -32.25212981599992],
              [126.11085045700008, -32.26816171699994],
              [126.10377037900003, -32.273370049999926],
              [126.07878665500004, -32.28053150799991],
              [126.00757897200003, -32.273370049999926],
              [125.97744898500002, -32.2843401099999],
              [125.92676916300002, -32.306943376999925],
              [125.870000043, -32.33298300999991],
              [125.803118562, -32.37447839299995],
              [125.67333547200008, -32.45897097799991],
              [125.53727469500006, -32.54837878899991],
              [125.47422755700006, -32.56386030199991],
              [125.33782708800004, -32.60151488899993],
              [125.2562648060001, -32.63912016899991],
              [125.09644616000003, -32.71217213299991],
              [125.03630618600005, -32.72991301899992],
              [125.01758873800009, -32.73211028399993],
              [125.00025475400003, -32.73723723799992],
              [124.90191360200004, -32.83365908799993],
              [124.83399147, -32.86769794899993],
              [124.74586022200003, -32.89218515399995],
              [124.70883222700002, -32.90390390399995],
              [124.51847717400005, -32.92780660599993],
              [124.35694420700008, -32.95281340899993],
              [124.31495201900009, -32.96607838299991],
              [124.29656009200005, -32.97812265399995],
              [124.25489342500009, -33.01336028399993],
              [124.24293053500003, -33.02068450299993],
              [124.22266686300009, -33.025648695999905],
              [124.20118248800009, -33.03801848799992],
              [124.16480553500003, -33.06796640399995],
              [124.11654707100001, -33.12151458099993],
              [124.09473717500009, -33.15569426899992],
              [124.08155358200008, -33.19085051899992],
              [124.07553144600001, -33.233086846999925],
              [124.06967207100001, -33.25359465899993],
              [124.05836022200003, -33.270196221999925],
              [124.04566491000003, -33.28460051899992],
              [124.00831139400009, -33.354180596999925],
              [124.00709069100003, -33.361993096999925],
              [124.00749759200005, -33.36842213299991],
              [124.00709069100003, -33.37704843499995],
              [124.00391686300009, -33.38827890399995],
              [123.99463951900009, -33.41090260199991],
              [123.98878014400009, -33.43564218499995],
              [123.97071373800009, -33.47975025799991],
              [123.96550540500004, -33.4997697899999],
              [123.96111087300005, -33.547133070999905],
              [123.95248457100001, -33.56731536299992],
              [123.93441816500001, -33.57561614399992],
              [123.91089928500003, -33.57903411299992],
              [123.89161217500009, -33.588148695999905],
              [123.87574303500003, -33.60125090899993],
              [123.86304772200003, -33.61646900799991],
              [123.86345462300005, -33.618259372999944],
              [123.86451256600003, -33.62151458099993],
              [123.86475670700008, -33.62558359199994],
              [123.86304772200003, -33.629571221999925],
              [123.85816491000003, -33.63396575299993],
              [123.81519616000003, -33.65837981599992],
              [123.75684655000009, -33.71412525799991],
              [123.74317467500009, -33.7380510399999],
              [123.73487389400009, -33.75798919099992],
              [123.73267662900003, -33.76677825299993],
              [123.73462975400003, -33.78069426899992],
              [123.738617384, -33.78801848799992],
              [123.73878014400009, -33.794040622999944],
              [123.72901451900009, -33.804945570999905],
              [123.71078535200002, -33.816338799999926],
              [123.66667728000004, -33.83294036299992],
              [123.64958743600005, -33.842461846999925],
              [123.64161217500009, -33.85125090899993],
              [123.62769616000003, -33.87151458099993],
              [123.62281334700003, -33.87664153399993],
              [123.61207116000003, -33.87737395599993],
              [123.58106530000009, -33.87623463299991],
              [123.56666100400003, -33.88437265399995],
              [123.52662194100003, -33.93865325299993],
              [123.51124108200008, -33.93962981599992],
              [123.49333743600005, -33.93124765399995],
              [123.47836347700002, -33.91887786299992],
              [123.47201582100001, -33.90764739399992],
              [123.45972741000003, -33.9001604149999],
              [123.38331139400009, -33.890883070999905],
              [123.34359785200002, -33.90349700299993],
              [123.31413821700005, -33.93059661299992],
              [123.26661217500009, -33.98650481599992],
              [123.23194420700008, -34.00074635199991],
              [123.22877037900003, -33.99928150799991],
              [123.22388756600003, -33.996026299999926],
              [123.21778405000009, -33.993259372999944],
              [123.211273634, -33.99334075299993],
              [123.20573978000004, -33.99667734199994],
              [123.19410241000003, -34.00530364399992],
              [123.18751061300009, -34.00701262799993],
              [123.154633009, -34.00945403399993],
              [123.14698326900009, -34.00212981599992],
              [123.13282311300009, -33.93906015399995],
              [123.113617384, -33.90447356599992],
              [123.08497155000009, -33.87835051899992],
              [123.04688561300009, -33.86296965899993],
              [123.02312259200005, -33.86060963299991],
              [123.00757897200003, -33.863539320999905],
              [122.99341881600003, -33.86809661299992],
              [122.95411217500009, -33.8728166649999],
              [122.87712649800005, -33.897149346999925],
              [122.84083092500009, -33.90374114399992],
              [122.81788170700008, -33.904554945999905],
              [122.80762780000009, -33.9001604149999],
              [122.78785241000003, -33.88103606599992],
              [122.77662194100003, -33.87664153399993],
              [122.76343834700003, -33.87900155999995],
              [122.73560631600003, -33.890883070999905],
              [122.64828535200002, -33.88941822699991],
              [122.60743248800009, -33.894789320999905],
              [122.574554884, -33.910821221999925],
              [122.58423912900003, -33.92392343499995],
              [122.58301842500009, -33.93694426899992],
              [122.57398522200003, -33.9489885399999],
              [122.56031334700003, -33.95916106599992],
              [122.54086347700002, -33.9411760399999],
              [122.53663170700008, -33.93865325299993],
              [122.53077233200008, -33.936618747999944],
              [122.52637780000009, -33.93287525799991],
              [122.521820509, -33.93108489399992],
              [122.50196373800009, -33.94548919099992],
              [122.48894290500004, -33.94353606599992],
              [122.39014733200008, -33.9157854149999],
              [122.34986412900003, -33.91529713299991],
              [122.31226647200003, -33.924899997999944],
              [122.279633009, -33.94548919099992],
              [122.26775149800005, -33.959242445999905],
              [122.264008009, -33.970961195999905],
              [122.26612389400009, -34.003838799999926],
              [122.25782311300009, -34.02206796699994],
              [122.24024498800009, -34.01620859199994],
              [122.22339928500003, -34.00156015399995],
              [122.21762129000001, -33.99334075299993],
              [122.20728600400003, -33.99749114399992],
              [122.19922936300009, -34.006931247999944],
              [122.19271894600001, -34.01637135199991],
              [122.18726647200003, -34.02068450299993],
              [122.09473717500009, -34.01913827899995],
              [122.07357832100001, -34.01441822699991],
              [122.07357832100001, -34.00701262799993],
              [122.10279381600003, -33.98015715899993],
              [122.105804884, -33.96404387799993],
              [122.082367384, -33.92717864399992],
              [122.07422936300009, -33.89153411299992],
              [122.06739342500009, -33.87664153399993],
              [122.06104576900009, -33.87078215899993],
              [122.03956139400009, -33.856133721999925],
              [122.01563561300009, -33.82537200299993],
              [122.00570722700002, -33.82073333099993],
              [121.99545332100001, -33.82244231599992],
              [121.98145592500009, -33.828789971999925],
              [121.93702233200008, -33.828789971999925],
              [121.91374759200005, -33.838555596999925],
              [121.879242384, -33.86988697699991],
              [121.86475670700008, -33.87664153399993],
              [121.84848066500001, -33.88014088299991],
              [121.81299889400009, -33.89511484199994],
              [121.79371178500003, -33.897149346999925],
              [121.775726759, -33.890557549999926],
              [121.74382571700005, -33.86793385199991],
              [121.72828209700003, -33.86296965899993],
              [121.71697024800005, -33.86191171699994],
              [121.69727623800009, -33.8571916649999],
              [121.68726647200003, -33.856133721999925],
              [121.67514082100001, -33.85898202899995],
              [121.66521243600005, -33.865166924999926],
              [121.65691165500004, -33.872165622999944],
              [121.64966881600003, -33.87664153399993],
              [121.62842858200008, -33.87639739399992],
              [121.61475670700008, -33.86402760199991],
              [121.60222415500004, -33.849541924999926],
              [121.58423912900003, -33.842461846999925],
              [121.57642662900003, -33.84042734199994],
              [121.55062910200002, -33.82976653399993],
              [121.53288821700005, -33.81951262799993],
              [121.52149498800009, -33.81910572699991],
              [121.49830162900003, -33.8220354149999],
              [121.33375084700003, -33.81519947699991],
              [121.31421959700003, -33.81951262799993],
              [121.27849368600005, -33.83277760199991],
              [121.22852623800009, -33.8376604149999],
              [121.21168053500003, -33.84343840899993],
              [121.166351759, -33.86793385199991],
              [121.16211998800009, -33.868259372999944],
              [121.15674889400009, -33.86419036299992],
              [121.13257897200003, -33.85173919099992],
              [121.10857181100005, -33.84384530999995],
              [121.09766686300009, -33.842461846999925],
              [121.07960045700008, -33.84539153399993],
              [121.03956139400009, -33.85865650799991],
              [121.01905358200008, -33.86296965899993],
              [120.99341881600003, -33.86296965899993],
              [120.98170006600003, -33.86451588299991],
              [120.97055097700002, -33.87037525799991],
              [120.94971764400009, -33.86174895599993],
              [120.92017662900003, -33.85711028399993],
              [120.86768639400009, -33.856133721999925],
              [120.84229576900009, -33.86386484199994],
              [120.81625410200002, -33.87664153399993],
              [120.79037519600001, -33.88600025799991],
              [120.76531009200005, -33.883477471999925],
              [120.74708092500009, -33.890883070999905],
              [120.57227623800009, -33.89153411299992],
              [120.56218509200005, -33.89299895599993],
              [120.55298912900003, -33.897149346999925],
              [120.54517662900003, -33.90593840899993],
              [120.54428144600001, -33.91423919099992],
              [120.54517662900003, -33.921807549999926],
              [120.54273522200003, -33.92815520599993],
              [120.52735436300009, -33.93678150799991],
              [120.42269941500001, -33.96990325299993],
              [120.39429772200003, -33.97380950299993],
              [120.38160241000003, -33.96257903399993],
              [120.27857506600003, -33.93865325299993],
              [120.17896569100003, -33.93124765399995],
              [120.15845787900003, -33.93499114399992],
              [120.12256920700008, -33.95037200299993],
              [120.10043379000001, -33.95232512799993],
              [120.08448326900009, -33.94784921699994],
              [120.05543053500003, -33.93092213299991],
              [120.03907311300009, -33.92506275799991],
              [120.02027428500003, -33.92351653399993],
              [120.00220787900003, -33.926039320999905],
              [119.98536217500009, -33.9314104149999],
              [119.97022545700008, -33.93865325299993],
              [119.94336998800009, -33.95598723799992],
              [119.92847741000003, -33.962823174999926],
              [119.90870201900009, -33.96599700299993],
              [119.85889733200008, -33.96795012799993],
              [119.80616295700008, -33.98495859199994],
              [119.79363040500004, -33.99309661299992],
              [119.73047936300009, -34.04851653399993],
              [119.70264733200008, -34.06340911299992],
              [119.64063561300009, -34.08521900799991],
              [119.61312910200002, -34.10320403399993],
              [119.623383009, -34.1110979149999],
              [119.61817467500009, -34.12004973799992],
              [119.60621178500003, -34.12753671699994],
              [119.58204186300009, -34.13372161299992],
              [119.57203209700003, -34.14202239399992],
              [119.53882897200003, -34.20907968499995],
              [119.53272545700008, -34.21648528399993],
              [119.49708092500009, -34.23902760199991],
              [119.48487389400009, -34.25945403399993],
              [119.474945509, -34.28590260199991],
              [119.46949303500003, -34.31340911299992],
              [119.46989993600005, -34.33603280999995],
              [119.48389733200008, -34.35857512799993],
              [119.50782311300009, -34.36679452899995],
              [119.53500410200002, -34.37151458099993],
              [119.55925540500004, -34.38372161299992],
              [119.54656009200005, -34.38836028399993],
              [119.53321373800009, -34.39031340899993],
              [119.51140384200005, -34.39804452899995],
              [119.47950280000009, -34.404554945999905],
              [119.44239342500009, -34.37444426899992],
              [119.40845787900003, -34.37004973799992],
              [119.38502037900003, -34.38486093499995],
              [119.37647545700008, -34.41171640399995],
              [119.38209069100003, -34.440118096999925],
              [119.40154056100005, -34.4587541649999],
              [119.39087975400003, -34.46331145599993],
              [119.36744225400003, -34.47991301899992],
              [119.36548912900003, -34.48455169099992],
              [119.36622155000009, -34.49081796699994],
              [119.36402428500003, -34.49504973799992],
              [119.35320071700005, -34.49358489399992],
              [119.34937584700003, -34.48967864399992],
              [119.34115644600001, -34.47405364399992],
              [119.33366946700005, -34.45191822699991],
              [119.31918379000001, -34.44491952899995],
              [119.30144290500004, -34.44589609199994],
              [119.28484134200005, -34.45256926899992],
              [119.27418053500003, -34.46038176899992],
              [119.26954186300009, -34.46648528399993],
              [119.26441491000003, -34.48674895599993],
              [119.26498457100001, -34.50945403399993],
              [119.26059004000001, -34.522149346999925],
              [119.24708092500009, -34.52776458099993],
              [119.22999108200008, -34.53215911299992],
              [119.22071373800009, -34.53183359199994],
              [119.21656334700003, -34.52467213299991],
              [119.21485436300009, -34.511651299999926],
              [119.20948326900009, -34.50335051899992],
              [119.20093834700003, -34.497979424999926],
              [119.18930097700002, -34.49358489399992],
              [119.17839603000004, -34.4919572899999],
              [119.15967858200008, -34.49504973799992],
              [119.14771569100003, -34.49358489399992],
              [119.13892662900003, -34.48886484199994],
              [119.12354576900009, -34.475274346999925],
              [119.11695397200003, -34.4724260399999],
              [118.931976759, -34.44589609199994],
              [118.92212975400003, -34.44784921699994],
              [118.90406334700003, -34.4568010399999],
              [118.89795983200008, -34.4587541649999],
              [118.84595787900003, -34.45256926899992],
              [118.83985436300009, -34.45256926899992],
              [118.88200931100005, -34.49065520599993],
              [118.88770592500009, -34.50042083099993],
              [118.87549889400009, -34.50644296699994],
              [118.80884850400003, -34.5134416649999],
              [118.78988691500001, -34.51881275799991],
              [118.75367272200003, -34.5427385399999],
              [118.74000084700003, -34.54827239399992],
              [118.72730553500003, -34.55803801899992],
              [118.72380618600005, -34.57887135199991],
              [118.73243248800009, -34.598321221999925],
              [118.75733483200008, -34.603448174999926],
              [118.724945509, -34.635837497999944],
              [118.70590254000001, -34.64771900799991],
              [118.66627037900003, -34.65683359199994],
              [118.63249759200005, -34.67791106599992],
              [118.61329186300009, -34.68596770599993],
              [118.52344811300009, -34.703383070999905],
              [118.47982832100001, -34.717054945999905],
              [118.44263756600003, -34.7400041649999],
              [118.43018639400009, -34.754571221999925],
              [118.40992272200003, -34.7888322899999],
              [118.39771569100003, -34.80527109199994],
              [118.38738040500004, -34.8259416649999],
              [118.38933353000004, -34.84628671699994],
              [118.40113366000003, -34.877211195999905],
              [118.39844811300009, -34.90097421699994],
              [118.385101759, -34.90837981599992],
              [118.34262129000001, -34.90504322699991],
              [118.26441491000003, -34.91130950299993],
              [118.244476759, -34.91676197699991],
              [118.20240319100003, -34.9392229149999],
              [118.16773522200003, -34.94255950299993],
              [118.16081790500004, -34.94548919099992],
              [118.15886478000004, -34.95663827899995],
              [118.16553795700008, -34.96152109199994],
              [118.17505944100003, -34.963555596999925],
              [118.18140709700003, -34.965915622999944],
              [118.19288170700008, -34.98357512799993],
              [118.20101972700002, -35.00237395599993],
              [118.19939212300005, -35.01677825299993],
              [118.18140709700003, -35.02117278399993],
              [118.16920006600003, -35.016696872999944],
              [118.11988366000003, -34.98707447699991],
              [118.11304772200003, -34.99382903399993],
              [118.10621178500003, -34.98707447699991],
              [118.092133009, -34.99382903399993],
              [118.04468834700003, -35.00750090899993],
              [118.03419030000009, -35.011976820999905],
              [118.02670332100001, -35.013929945999905],
              [118.01685631600003, -35.01490650799991],
              [118.00831139400009, -35.013929945999905],
              [117.98845462300005, -35.00872161299992],
              [117.97901451900009, -35.00750090899993],
              [117.97169030000009, -35.00872161299992],
              [117.95443769600001, -35.01384856599992],
              [117.94483483200008, -35.01490650799991],
              [117.93881269600001, -35.01336028399993],
              [117.93425540500004, -35.01034921699994],
              [117.92872155000009, -35.0075822899999],
              [117.92058353000004, -35.00750090899993],
              [117.91684004000001, -35.00994231599992],
              [117.90886478000004, -35.01913827899995],
              [117.90756269600001, -35.02117278399993],
              [117.84929446700005, -35.02556731599992],
              [117.83545983200008, -35.03142669099992],
              [117.83204186300009, -35.04583098799992],
              [117.84376061300009, -35.06023528399993],
              [117.86003665500004, -35.071384372999944],
              [117.88892662900003, -35.08171965899993],
              [117.89771569100003, -35.08147551899992],
              [117.90137780000009, -35.07268645599993],
              [117.89869225400003, -35.0642229149999],
              [117.89405358200008, -35.05478280999995],
              [117.89323978000004, -35.04656340899993],
              [117.90137780000009, -35.041680596999925],
              [117.91765384200005, -35.04705169099992],
              [117.93482506600003, -35.08131275799991],
              [117.95199629000001, -35.08953215899993],
              [117.988617384, -35.08473072699991],
              [118.00147545700008, -35.088148695999905],
              [117.99634850400003, -35.10369231599992],
              [117.982758009, -35.099541924999926],
              [117.97046959700003, -35.10393645599993],
              [117.94857832100001, -35.11736419099992],
              [117.93287194100003, -35.12037525799991],
              [117.89047285200002, -35.11736419099992],
              [117.86036217500009, -35.10881926899992],
              [117.80982506600003, -35.071384372999944],
              [117.74724368600005, -35.05136484199994],
              [117.68433678500003, -35.04631926899992],
              [117.66732832100001, -35.049086195999905],
              [117.64128665500004, -35.06129322699991],
              [117.62680097700002, -35.08025481599992],
              [117.62086022200003, -35.10588958099993],
              [117.61963951900009, -35.13787200299993],
              [117.58904056100005, -35.12558359199994],
              [117.53858483200008, -35.09221770599993],
              [117.50359134200005, -35.08326588299991],
              [117.471039259, -35.07968515399995],
              [117.45997155000009, -35.076104424999926],
              [117.40235436300009, -35.0466447899999],
              [117.38990319100003, -35.03826262799993],
              [117.35954837300005, -35.02418385199991],
              [117.34058678500003, -35.017836195999905],
              [117.33220462300005, -35.01816171699994],
              [117.32398522200003, -35.0329729149999],
              [117.30494225400003, -35.03020598799992],
              [117.26693769600001, -35.01490650799991],
              [117.24887129000001, -35.01409270599993],
              [117.23959394600001, -35.01482512799993],
              [117.23292076900009, -35.01816171699994],
              [117.22339928500003, -35.02076588299991],
              [117.21216881600003, -35.01677825299993],
              [117.20093834700003, -35.01067473799992],
              [117.19166100400003, -35.00750090899993],
              [117.17164147200003, -35.01327890399995],
              [117.15894616000003, -35.02743905999995],
              [117.14039147200003, -35.062758070999905],
              [117.12794030000009, -35.05608489399992],
              [117.10678144600001, -35.03834400799991],
              [117.09546959700003, -35.03484465899993],
              [117.07797285200002, -35.03264739399992],
              [117.05258222700002, -35.023370049999926],
              [117.04037519600001, -35.02117278399993],
              [117.02808678500003, -35.023370049999926],
              [117.01490319100003, -35.027276299999926],
              [117.00245201900009, -35.02898528399993],
              [116.99244225400003, -35.02459075299993],
              [116.98170006600003, -35.01848723799992],
              [116.96607506600003, -35.01425546699994],
              [116.94996178500003, -35.0134416649999],
              [116.93775475400003, -35.01816171699994],
              [116.91724694100003, -35.03753020599993],
              [116.89958743600005, -35.05038827899995],
              [116.87769616000003, -35.05486419099992],
              [116.84498131600003, -35.049086195999905],
              [116.83090254000001, -35.04338958099993],
              [116.79086347700002, -35.02117278399993],
              [116.74952233200008, -35.012383721999925],
              [116.73633873800009, -35.00750090899993],
              [116.73096764400009, -35.01441822699991],
              [116.72803795700008, -35.01767343499995],
              [116.72730553500003, -35.02076588299991],
              [116.728851759, -35.028008721999925],
              [116.65837649800005, -35.028008721999925],
              [116.64698326900009, -35.03826262799993],
              [116.63786868600005, -35.05022551899992],
              [116.61768639400009, -35.04306405999995],
              [116.58480879000001, -35.02117278399993],
              [116.531586134, -35.014743747999944],
              [116.51295006600003, -35.00408294099992],
              [116.50318444100003, -34.999932549999926],
              [116.49008222700002, -34.99920012799993],
              [116.46509850400003, -35.000664971999925],
              [116.45850670700008, -34.99700286299992],
              [116.43474368600005, -34.97340260199991],
              [116.39503014400009, -34.949476820999905],
              [116.37525475400003, -34.932712497999944],
              [116.38298587300005, -34.92498137799993],
              [116.46876061300009, -34.9392229149999],
              [116.48829186300009, -34.94573333099993],
              [116.49773196700005, -34.94622161299992],
              [116.50367272200003, -34.9392229149999],
              [116.50049889400009, -34.92888762799993],
              [116.48943118600005, -34.92001718499995],
              [116.47559655000009, -34.91366952899995],
              [116.44223066500001, -34.90553150799991],
              [116.42660566500001, -34.89185963299991],
              [116.41382897200003, -34.87615325299993],
              [116.39926191500001, -34.863539320999905],
              [116.392914259, -34.85979583099993],
              [116.38754316500001, -34.85751718499995],
              [116.38135826900009, -34.85816822699991],
              [116.37256920700008, -34.863539320999905],
              [116.39893639400009, -34.90390390399995],
              [116.37614993600005, -34.91741301899992],
              [116.33082116000003, -34.91269296699994],
              [116.289398634, -34.89763762799993],
              [116.248383009, -34.87753671699994],
              [116.09620201900009, -34.83863697699991],
              [116.01978600400003, -34.82935963299991],
              [116.00953209700003, -34.830336195999905],
              [115.98959394600001, -34.834649346999925],
              [115.97852623800009, -34.83562590899993],
              [115.97388756600003, -34.83025481599992],
              [115.97559655000009, -34.81845468499995],
              [115.98161868600005, -34.801446221999925],
              [115.97242272200003, -34.7829729149999],
              [115.94654381600003, -34.75750090899993],
              [115.93360436300009, -34.722588799999926],
              [115.91578209700003, -34.70191822699991],
              [115.88672936300009, -34.67734140399995],
              [115.74545332100001, -34.54021575299993],
              [115.61231530000009, -34.44589609199994],
              [115.570648634, -34.42473723799992],
              [115.53492272200003, -34.41838958099993],
              [115.52637780000009, -34.41480885199991],
              [115.51905358200008, -34.40520598799992],
              [115.514008009, -34.39511484199994],
              [115.508148634, -34.386976820999905],
              [115.49903405000009, -34.38372161299992],
              [115.48926842500009, -34.38209400799991],
              [115.33472741000003, -34.3142229149999],
              [115.29078209700003, -34.301853122999944],
              [115.26286868600005, -34.29851653399993],
              [115.18376712300005, -34.301853122999944],
              [115.16488691500001, -34.31023528399993],
              [115.13754316500001, -34.349867445999905],
              [115.11882571700005, -34.36337655999995],
              [115.10840905000009, -34.34433359199994],
              [115.01783287900003, -34.26213958099993],
              [115.01042728000004, -34.24504973799992],
              [115.00896243600005, -34.218682549999926],
              [115.01172936300009, -34.17913176899992],
              [115.00993899800005, -34.163181247999944],
              [115.00269616000003, -34.144789320999905],
              [114.97445722700002, -34.09189218499995],
              [114.971039259, -34.082696221999925],
              [114.97437584700003, -34.06170012799993],
              [114.97266686300009, -33.92278411299992],
              [114.96338951900009, -33.88201262799993],
              [114.96119225400003, -33.85955169099992],
              [114.96387780000009, -33.84303150799991],
              [114.97950280000009, -33.7985979149999],
              [114.98853600400003, -33.7810197899999],
              [114.97144616000003, -33.75628020599993],
              [114.95899498800009, -33.71990325299993],
              [114.95679772200003, -33.682305596999925],
              [114.971039259, -33.65390390399995],
              [114.99789472700002, -33.63103606599992],
              [115.00391686300009, -33.6169572899999],
              [115.00269616000003, -33.5954729149999],
              [114.99000084700003, -33.54192473799992],
              [114.98853600400003, -33.52109140399995],
              [115.00269616000003, -33.52109140399995],
              [115.04566491000003, -33.53720468499995],
              [115.07056725400003, -33.56373463299991],
              [115.09066816500001, -33.59295012799993],
              [115.11882571700005, -33.61646900799991],
              [115.15552819100003, -33.6325822899999],
              [115.19467207100001, -33.64462655999995],
              [115.23707116000003, -33.65113697699991],
              [115.28272545700008, -33.650648695999905],
              [115.32374108200008, -33.64381275799991],
              [115.36719811300009, -33.63128020599993],
              [115.40601647200003, -33.61467864399992],
              [115.43409264400009, -33.5954729149999],
              [115.51710045700008, -33.512383721999925],
              [115.57553144600001, -33.42669036299992],
              [115.60482832100001, -33.36956145599993],
              [115.61882571700005, -33.32073333099993],
              [115.62598717500009, -33.30803801899992],
              [115.63697350400003, -33.29924895599993],
              [115.64616946700005, -33.30038827899995],
              [115.65772545700008, -33.30510833099993],
              [115.67709394600001, -33.30803801899992],
              [115.70167076900009, -33.297133070999905],
              [115.71013431100005, -33.27068450299993],
              [115.70785566500001, -33.20842864399992],
              [115.70484459700003, -33.192478122999944],
              [115.69792728000004, -33.1931291649999],
              [115.69109134200005, -33.2048479149999],
              [115.68637129000001, -33.240492445999905],
              [115.67367597700002, -33.28769296699994],
              [115.66684004000001, -33.28769296699994],
              [115.67188561300009, -33.12053801899992],
              [115.67457116000003, -33.02499765399995],
              [115.66000410200002, -32.938164971999925],
              [115.62468509200005, -32.81178150799991],
              [115.61280358200008, -32.728448174999926],
              [115.603851759, -32.69500090899993],
              [115.60092207100001, -32.66171640399995],
              [115.61231530000009, -32.6228166649999],
              [115.62964928500003, -32.59238046699994],
              [115.67579186300009, -32.5349260399999],
              [115.70093834700003, -32.51295338299991],
              [115.69336998800009, -32.552666924999926],
              [115.63990319100003, -32.60857512799993],
              [115.63965905000009, -32.656914971999925],
              [115.66797936300009, -32.73064544099992],
              [115.69109134200005, -32.770603122999944],
              [115.71412194100003, -32.78045012799993],
              [115.722992384, -32.76376718499995],
              [115.717133009, -32.74163176899992],
              [115.69792728000004, -32.70322030999995],
              [115.68376712300005, -32.69019947699991],
              [115.68051191500001, -32.68124765399995],
              [115.68018639400009, -32.66545989399992],
              [115.67823326900009, -32.656182549999926],
              [115.67367597700002, -32.64275481599992],
              [115.66187584700003, -32.63396575299993],
              [115.65886478000004, -32.62851327899995],
              [115.66684004000001, -32.6228166649999],
              [115.67676842500009, -32.6228166649999],
              [115.69385826900009, -32.63372161299992],
              [115.70443769600001, -32.6364885399999],
              [115.74870853000004, -32.63730234199994],
              [115.76286868600005, -32.62769947699991],
              [115.76929772200003, -32.60230885199991],
              [115.76295006600003, -32.57903411299992],
              [115.74634850400003, -32.5700822899999],
              [115.72925866000003, -32.56609465899993],
              [115.72152754000001, -32.557305596999925],
              [115.71452884200005, -32.537041924999926],
              [115.71412194100003, -32.52662525799991],
              [115.71705162900003, -32.51921965899993],
              [115.72974694100003, -32.501885674999926],
              [115.73511803500003, -32.492445570999905],
              [115.74545332100001, -32.45566171699994],
              [115.74561608200008, -32.41871510199991],
              [115.73365319100003, -32.38795338299991],
              [115.70785566500001, -32.36956145599993],
              [115.73194420700008, -32.34587981599992],
              [115.73585045700008, -32.33318450299993],
              [115.72779381600003, -32.31503671699994],
              [115.71436608200008, -32.302992445999905],
              [115.68677819100003, -32.29021575299993],
              [115.67367597700002, -32.273370049999926],
              [115.71973717500009, -32.2732072899999],
              [115.73585045700008, -32.26441822699991],
              [115.74195397200003, -32.24236419099992],
              [115.74529056100005, -32.22283294099992],
              [115.75684655000009, -32.18564218499995],
              [115.75562584700003, -32.16350676899992],
              [115.75098717500009, -32.153415622999944],
              [115.73878014400009, -32.13941822699991],
              [115.73511803500003, -32.12948984199994],
              [115.74089603000004, -32.11451588299991],
              [115.74268639400009, -32.10230885199991],
              [115.73853600400003, -32.09148528399993],
              [115.72934004000001, -32.07463958099993],
              [115.72779381600003, -32.05510833099993],
              [115.74366295700008, -31.92782968499995],
              [115.72152754000001, -31.772637627999927],
              [115.70093834700003, -31.691176039999903],
              [115.68034915500004, -31.648614190999922],
              [115.60482832100001, -31.54656340899993],
              [115.55062910200002, -31.434747002999927],
              [115.45460045700008, -31.303480726999908],
              [115.38306725400003, -31.133884372999944],
              [115.31299889400009, -30.99081796699994],
              [115.23853600400003, -30.878676039999903],
              [115.18091881600003, -30.827243747999944],
              [115.16651451900009, -30.765883070999905],
              [115.16602623800009, -30.75554778399993],
              [115.16195722700002, -30.742120049999926],
              [115.10108483200008, -30.63339609199994],
              [115.09839928500003, -30.625176690999922],
              [115.09506269600001, -30.605726820999905],
              [115.06080162900003, -30.52239348799992],
              [115.056976759, -30.505466403999947],
              [115.05738366000003, -30.467461846999925],
              [115.05494225400003, -30.448011976999908],
              [115.03419030000009, -30.37037525799991],
              [115.02263431100005, -30.340590101999908],
              [115.01978600400003, -30.33562590899993],
              [115.01107832100001, -30.324965101999908],
              [115.00896243600005, -30.320082289999903],
              [115.01050866000003, -30.312676690999922],
              [115.02027428500003, -30.302504164999903],
              [115.02263431100005, -30.29615650799991],
              [115.023773634, -30.274183851999908],
              [115.02279707100001, -30.262872002999927],
              [115.01921634200005, -30.254571221999925],
              [115.01042728000004, -30.248223565999922],
              [114.98902428500003, -30.237074476999908],
              [114.98170006600003, -30.232028903999947],
              [114.97486412900003, -30.214043877999927],
              [114.97820071700005, -30.19182708099993],
              [114.98487389400009, -30.168145440999922],
              [114.98853600400003, -30.145684502999927],
              [114.98633873800009, -30.13600025799991],
              [114.97706139400009, -30.115492445999905],
              [114.97120201900009, -30.09238046699994],
              [114.96290123800009, -30.082696221999925],
              [114.95378665500004, -30.074476820999905],
              [114.94752037900003, -30.06682708099993],
              [114.94263756600003, -30.031019789999903],
              [114.96745853000004, -29.90243905999995],
              [114.96558678500003, -29.880629164999903],
              [114.95101972700002, -29.844903252999927],
              [114.94752037900003, -29.830010674999926],
              [114.94068444100003, -29.744073174999926],
              [114.94605553500003, -29.658135674999926],
              [114.96119225400003, -29.580254815999922],
              [114.97934004000001, -29.523207289999903],
              [114.98170006600003, -29.501722914999903],
              [114.97877037900003, -29.479913018999923],
              [114.95378665500004, -29.42937590899993],
              [114.93995201900009, -29.387465101999908],
              [114.93506920700008, -29.36451588299991],
              [114.93327884200005, -29.343682549999926],
              [114.92969811300009, -29.32781340899993],
              [114.91236412900003, -29.292087497999944],
              [114.89625084700003, -29.23365650799991],
              [114.84245853000004, -29.108575127999927],
              [114.83204186300009, -29.092054945999905],
              [114.65259850400003, -28.912367445999905],
              [114.64828535200002, -28.902276299999926],
              [114.61451256600003, -28.85751718499995],
              [114.60377037900003, -28.838555596999925],
              [114.59278405000009, -28.79778411299992],
              [114.57748457100001, -28.785088799999926],
              [114.59555097700002, -28.748304945999905],
              [114.59782962300005, -28.701836846999925],
              [114.58985436300009, -28.655857028999947],
              [114.53109785200002, -28.52239348799992],
              [114.50863691500001, -28.490899346999925],
              [114.42286217500009, -28.40097421699994],
              [114.36931399800005, -28.32284921699994],
              [114.36475670700008, -28.30901458099993],
              [114.35694420700008, -28.292575778999947],
              [114.31006920700008, -28.23015715899993],
              [114.29558353000004, -28.221449476999908],
              [114.26050866000003, -28.205254815999922],
              [114.24488366000003, -28.192478122999944],
              [114.16602623800009, -28.10670338299991],
              [114.15414472700002, -28.078057549999926],
              [114.14869225400003, -28.068536065999922],
              [114.146820509, -28.061618747999944],
              [114.14568118600005, -28.027601820999905],
              [114.14389082100001, -28.018649997999944],
              [114.10596764400009, -27.904066664999903],
              [114.09791100400003, -27.862725518999923],
              [114.09717858200008, -27.819431247999944],
              [114.10254967500009, -27.797946872999944],
              [114.12061608200008, -27.759698174999926],
              [114.12435957100001, -27.740166924999926],
              [114.12769616000003, -27.73015715899993],
              [114.14234459700003, -27.709161065999922],
              [114.14568118600005, -27.69890715899993],
              [114.14389082100001, -27.687758070999905],
              [114.07447350400003, -27.447198174999926],
              [114.01254316500001, -27.31536223799992],
              [113.92318769600001, -27.171319268999923],
              [113.76441491000003, -26.918145440999922],
              [113.65452817300002, -26.775586154999928],
              [113.59057934400005, -26.67565070699993],
              [113.53174889400009, -26.623223565999922],
              [113.4657078780001, -26.557143379999957],
              [113.35726972700002, -26.45517343499995],
              [113.34294681100005, -26.44304778399993],
              [113.31262467600004, -26.415945664999924],
              [113.29778180300002, -26.397288639999942],
              [113.29786928400006, -26.374657398999943],
              [113.29198687200005, -26.353349907999927],
              [113.29948920200002, -26.338721122999914],
              [113.28465726000002, -26.31872853199991],
              [113.27133686600007, -26.288088107999954],
              [113.24466993600004, -26.240097732999914],
              [113.213226759, -26.215101820999905],
              [113.17628577300002, -26.17730809099993],
              [113.156979514, -26.15192572299992],
              [113.1614948350001, -26.139952799999946],
              [113.18685015800008, -26.15603819499995],
              [113.21021569100003, -26.174493096999925],
              [113.22852623800009, -26.18059661299992],
              [113.25825157200006, -26.185558827999955],
              [113.26412986500009, -26.210868768999944],
              [113.27597094100008, -26.23485742899993],
              [113.27906329100006, -26.19759717699992],
              [113.28510429300002, -26.165671522999958],
              [113.29261379900004, -26.131083063999938],
              [113.2882222390001, -26.093787882999948],
              [113.2853235770001, -26.056503248999945],
              [113.291314155, -26.02456711399992],
              [113.30622429900006, -25.99665148899993],
              [113.32090186200003, -26.121847310999954],
              [113.32964057600009, -26.23502926799995],
              [113.32799829200007, -26.274896247999948],
              [113.33533467300003, -26.310836714999937],
              [113.34719063700004, -26.33081505599995],
              [113.36201033600003, -26.357447072999946],
              [113.36790520900001, -26.37874341999992],
              [113.38426984, -26.38275538399995],
              [113.37543065600005, -26.350811834999945],
              [113.3561868060001, -26.308202559999927],
              [113.353299676, -26.274943609999923],
              [113.36382826800002, -26.22839917099992],
              [113.37725300900001, -26.209800320999932],
              [113.38039788800006, -26.099377947999926],
              [113.35669825600007, -26.042085622999934],
              [113.36267350100002, -26.012815375999935],
              [113.38787140200009, -26.060804308999934],
              [113.396642477, -26.176580028999922],
              [113.41301506100001, -26.15532757099993],
              [113.42341582200004, -26.156676656999934],
              [113.451631141, -26.159384038999917],
              [113.45008961600001, -26.200609224999937],
              [113.45898015, -26.221898714999952],
              [113.461910568, -26.24982853599994],
              [113.47377529200003, -26.263140042999908],
              [113.47820283600004, -26.283087484999953],
              [113.48708229400006, -26.300382889999923],
              [113.49596333000011, -26.326982534999956],
              [113.50331738500006, -26.376189396999905],
              [113.48988000200006, -26.400127993999945],
              [113.4927875950001, -26.434714735999933],
              [113.479318723, -26.473292387999948],
              [113.48675520400002, -26.479942594999955],
              [113.50762279500009, -26.46929550799996],
              [113.50767474000008, -26.43471354199994],
              [113.50771532700003, -26.410769500999947],
              [113.51369323000006, -26.393482948999917],
              [113.52565339600005, -26.354918486999907],
              [113.50936280600001, -26.312362588999918],
              [113.51383990700003, -26.295081963999905],
              [113.51386966700011, -26.273808995999957],
              [113.53021570600004, -26.267171757999904],
              [113.5435654800001, -26.287117507999938],
              [113.54948779100005, -26.304403150999917],
              [113.55392424400009, -26.324345381999933],
              [113.56132618800007, -26.352265451999926],
              [113.55237689400008, -26.384173338999915],
              [113.55976983200003, -26.412099002999923],
              [113.567155437, -26.445347240999922],
              [113.55674349000003, -26.47060401999994],
              [113.56711369900006, -26.490560531999904],
              [113.56708512700004, -26.529125955999916],
              [113.56550653700003, -26.565081173999943],
              [113.58183384600011, -26.56510856999995],
              [113.59376470500001, -26.553116677999924],
              [113.59676436300003, -26.53847189299995],
              [113.59828287800008, -26.518506729999956],
              [113.6042501500001, -26.507855605999907],
              [113.62360808000005, -26.487885879999908],
              [113.62065210500009, -26.469265686999904],
              [113.61771593800006, -26.446654315999922],
              [113.62514747600005, -26.439997254999923],
              [113.64442595900005, -26.481220263999944],
              [113.64441346500007, -26.499843222999914],
              [113.6429074780001, -26.526452071999927],
              [113.64288718800003, -26.54907254099993],
              [113.63393307900003, -26.573040040999956],
              [113.63837913100008, -26.587682662999953],
              [113.62875410200002, -26.59807708099993],
              [113.64431468500004, -26.60232502899993],
              [113.66217673800008, -26.600975107999943],
              [113.66663085900007, -26.615616031999934],
              [113.67108433600004, -26.63558217399992],
              [113.6695859890001, -26.65289320499994],
              [113.68628991000003, -26.654229424999926],
              [113.68746819900002, -26.631558905999952],
              [113.69491774700009, -26.614240177999932],
              [113.71129244800011, -26.61021390299993],
              [113.73509564100004, -26.60086876699995],
              [113.76037771600011, -26.59551131899991],
              [113.77227137800003, -26.58750683799991],
              [113.78044681100005, -26.60125090899993],
              [113.81243183200002, -26.59941535799993],
              [113.81387874500001, -26.56348554999994],
              [113.83319100900007, -26.55413276799993],
              [113.85249967300001, -26.54477170699994],
              [113.87028641900008, -26.52212985099993],
              [113.886567409, -26.492838358999904],
              [113.88947929300002, -26.464915118999954],
              [113.88345461900008, -26.42239964399994],
              [113.87303118700004, -26.398492863999934],
              [113.88336947700009, -26.378543220999916],
              [113.88477257400007, -26.34267323499995],
              [113.86841113800006, -26.318799665999904],
              [113.84107506600003, -26.295668226999908],
              [113.81421959700003, -26.266778252999927],
              [113.78174889400009, -26.241387627999927],
              [113.7492402690001, -26.23851459599996],
              [113.68413774600003, -26.221604058999958],
              [113.67995596500009, -26.20082700599994],
              [113.67997054700004, -26.183826775999933],
              [113.66778410500001, -26.16620368899993],
              [113.64887769200004, -26.139385570999934],
              [113.61108205200003, -26.09648206299994],
              [113.57723934700005, -26.08934255799994],
              [113.571315293, -26.057156338999903],
              [113.56735597300008, -26.03660241999995],
              [113.57634713200002, -26.008897900999955],
              [113.56242580000003, -25.99996374199992],
              [113.553517016, -25.97226134099992],
              [113.55755289900003, -25.94098946899993],
              [113.51876452700003, -25.919535906999954],
              [113.52376629900004, -25.89184578699991],
              [113.51781767300008, -25.870399954999925],
              [113.51187159100004, -25.85342167999994],
              [113.49995248800008, -25.84268664399991],
              [113.48802899900011, -25.82748203299991],
              [113.47411117600006, -25.81763210699995],
              [113.46815785500007, -25.805111001999933],
              [113.46916494800007, -25.791707278999922],
              [113.46045983200008, -25.77662525799991],
              [113.44752037900003, -25.764825127999927],
              [113.420780616, -25.72821518099994],
              [113.413528229, -25.702046802999917],
              [113.41900061000001, -25.680810563999955],
              [113.42264731300008, -25.654662642999938],
              [113.43356907900011, -25.633437128999958],
              [113.45175387100005, -25.604054096999903],
              [113.46445674900008, -25.573011393999934],
              [113.48986926400005, -25.545269040999926],
              [113.502547811, -25.514213104999953],
              [113.51525018300003, -25.509336557999916],
              [113.51890945800005, -25.540428835999933],
              [113.52438791600002, -25.578056765999918],
              [113.52079622800011, -25.600955309999904],
              [113.53288821700005, -25.618259372999944],
              [113.54664147200003, -25.61760833099993],
              [113.55591881600003, -25.61956145599993],
              [113.56251061300009, -25.631524346999925],
              [113.5843395500001, -25.63211286099994],
              [113.59343622600011, -25.66643155199995],
              [113.60798037400002, -25.70401525299991],
              [113.63103274800005, -25.736260674999926],
              [113.66064140900005, -25.749767208999913],
              [113.67518432500003, -25.78079118699992],
              [113.70093834700003, -25.791761976999908],
              [113.72783161400002, -25.795439698999928],
              [113.72240932700004, -25.82812089999993],
              [113.71697710700005, -25.846074194999915],
              [113.72234134200005, -25.866631768999923],
              [113.72730553500003, -25.872816664999903],
              [113.74424373700003, -25.880324146999953],
              [113.7569508150001, -25.885216980999928],
              [113.7606088230001, -25.90479261899992],
              [113.75336595200008, -25.921114992999946],
              [113.73521628800006, -25.93581464999994],
              [113.738849372, -25.955400411999904],
              [113.7388863760001, -25.984769710999956],
              [113.73163929600003, -26.00762127899992],
              [113.71891322400006, -26.03211590199993],
              [113.7225502450001, -26.04843895299996],
              [113.71527590000005, -26.07783182499992],
              [113.71345978900001, -26.121913786999926],
              [113.70435979400008, -26.14804569799992],
              [113.72801348200005, -26.18068504999991],
              [113.72800445300004, -26.197034895999934],
              [113.76260514, -26.196973145999948],
              [113.76625146700007, -26.210033950999957],
              [113.79538591000005, -26.206714794999925],
              [113.848070001, -26.121710470999915],
              [113.86800394700003, -26.079241880999916],
              [113.87884183300002, -26.043321153999955],
              [113.86443118600005, -25.999444268999923],
              [113.86231530000009, -25.988946221999925],
              [113.85287519600001, -25.97128671699994],
              [113.85075931100005, -25.961602471999925],
              [113.85157311300009, -25.94768645599993],
              [113.85450280000009, -25.94426848799992],
              [113.85873457100001, -25.94622161299992],
              [113.86443118600005, -25.947930596999925],
              [113.88550866000003, -25.95175546699994],
              [113.90957726300007, -25.976372584999922],
              [113.90599552800006, -25.99921960599994],
              [113.90243314300005, -26.03185393499996],
              [113.91163653000001, -26.088939142999948],
              [113.90601647200003, -26.119317315999922],
              [113.9280956130001, -26.137868083999933],
              [113.94808736000005, -26.139464061999945],
              [113.93546936200005, -26.191722032999905],
              [113.94282682000005, -26.22764042299991],
              [113.95563704900007, -26.260278057999926],
              [113.9575080090001, -26.28314728199996],
              [113.96484876400007, -26.309278518999918],
              [113.96998131600003, -26.33171965899993],
              [114.02153405500007, -26.390887682999903],
              [114.06908318, -26.436559867999904],
              [114.08553721600003, -26.447952217999955],
              [114.10377562300005, -26.447881519999953],
              [114.12376328500011, -26.42981402399994],
              [114.14374885300003, -26.41339266299991],
              [114.15642125800002, -26.393729401999906],
              [114.18370443700007, -26.38217795399993],
              [114.207360504, -26.375541297999916],
              [114.2163089610001, -26.344445048999944],
              [114.23437149200004, -26.31658372399994],
              [114.21958137700005, -26.274162496999907],
              [114.20487535400002, -26.246445997999956],
              [114.1992831, -26.21869493199995],
              [114.191895004, -26.195861506999904],
              [114.19721268900003, -26.168086546999916],
              [114.2043779500001, -26.146840097999927],
              [114.21729576900009, -26.105645440999922],
              [114.22331790500004, -26.100681247999944],
              [114.22681725400003, -26.08879973799992],
              [114.22828209700003, -26.075290622999944],
              [114.22754967500009, -26.064629815999922],
              [114.21778405000009, -26.04306405999995],
              [114.191742384, -26.00400155999995],
              [114.18653405000009, -25.97893645599993],
              [114.19076582100001, -25.970879815999922],
              [114.20020592500009, -25.97665780999995],
              [114.21387780000009, -25.99277109199994],
              [114.21957441500001, -25.996758721999925],
              [114.23267662900003, -25.996026299999926],
              [114.24683678500003, -25.992852471999925],
              [114.25554446700005, -25.98951588299991],
              [114.258148634, -25.988946221999925],
              [114.26856530000009, -25.98951588299991],
              [114.26026451900009, -25.97112395599993],
              [114.24805748800009, -25.960870049999926],
              [114.23747806100005, -25.94963958099993],
              [114.23422285200002, -25.92742278399993],
              [114.24170983200008, -25.90878671699994],
              [114.25440514400009, -25.885837497999944],
              [114.26319420700008, -25.86223723799992],
              [114.25855553500003, -25.84189218499995],
              [114.24268639400009, -25.828871351999908],
              [114.19312584700003, -25.802178643999923],
              [114.15528405000009, -25.789727471999925],
              [114.14869225400003, -25.773207289999903],
              [114.144867384, -25.757012627999927],
              [114.13200931100005, -25.749932549999926],
              [114.13648522200003, -25.73333098799992],
              [114.12916100400003, -25.71526458099993],
              [114.11548912900003, -25.700778903999947],
              [114.10059655000009, -25.694756768999923],
              [114.09750410200002, -25.690524997999944],
              [114.09302819100003, -25.67164478999996],
              [114.08692467500009, -25.667413018999923],
              [114.04932701900009, -25.64690520599993],
              [114.04102623800009, -25.633558851999908],
              [114.01563561300009, -25.56959400799991],
              [113.95167076900009, -25.48919036299992],
              [113.92839603000004, -25.44980234199994],
              [113.86207116000003, -25.302666924999926],
              [113.85816491000003, -25.280043226999908],
              [113.85328209700003, -25.263929945999905],
              [113.81666100400003, -25.20875416499996],
              [113.80811608200008, -25.18222421699994],
              [113.80241946700005, -25.171807549999926],
              [113.78931725400003, -25.160332940999922],
              [113.74732506600003, -25.136651299999926],
              [113.71306399800005, -25.124932549999926],
              [113.69214928500003, -25.10523853999996],
              [113.67790774800005, -25.081638278999947],
              [113.66944420700008, -25.047539971999925],
              [113.65528405000009, -25.026136976999908],
              [113.65105228000004, -25.005303643999923],
              [113.64576256600003, -24.99309661299992],
              [113.64470462300005, -24.98560963299991],
              [113.64730879000001, -24.977308851999908],
              [113.66041100400003, -24.96257903399993],
              [113.66521243600005, -24.95484791499996],
              [113.66675866000003, -24.933770440999922],
              [113.65821373800009, -24.912041924999926],
              [113.63965905000009, -24.89617278399993],
              [113.61060631600003, -24.892754815999922],
              [113.609711134, -24.871351820999905],
              [113.60572350400003, -24.85019296699994],
              [113.60515384200005, -24.83049895599993],
              [113.61402428500003, -24.814060153999947],
              [113.62094160200002, -24.79583098799992],
              [113.61866295700008, -24.77044036299992],
              [113.611664259, -24.74537525799991],
              [113.60434004000001, -24.72828541499996],
              [113.54249108200008, -24.64348723799992],
              [113.43946373800009, -24.532810153999947],
              [113.41675866000003, -24.497653903999947],
              [113.40023847700002, -24.45794036299992],
              [113.39144941500001, -24.413669528999947],
              [113.38526451900009, -24.249118747999944],
              [113.38941491000003, -24.22779713299991],
              [113.39722741000003, -24.21412525799991],
              [113.42269941500001, -24.190524997999944],
              [113.43327884200005, -24.170179945999905],
              [113.43181399800005, -24.148044528999947],
              [113.41928144600001, -24.104587497999944],
              [113.41382897200003, -24.07040780999995],
              [113.41456139400009, -24.04941171699994],
              [113.42269941500001, -24.033135674999926],
              [113.43572024800005, -24.021091403999947],
              [113.44678795700008, -24.00758228999996],
              [113.45533287900003, -23.99065520599993],
              [113.46045983200008, -23.967950127999927],
              [113.45948326900009, -23.94459400799991],
              [113.45655358200008, -23.927178643999923],
              [113.45972741000003, -23.910332940999922],
              [113.49187259200005, -23.872165622999944],
              [113.50212649800005, -23.85279713299991],
              [113.52637780000009, -23.764743747999944],
              [113.53834069100003, -23.74846770599993],
              [113.55933678500003, -23.74195728999996],
              [113.59945722700002, -23.633965752999927],
              [113.60434004000001, -23.62468840899993],
              [113.61109459700003, -23.62037525799991],
              [113.61996504000001, -23.617120049999926],
              [113.62769616000003, -23.61191171699994],
              [113.63103274800005, -23.601169528999947],
              [113.63624108200008, -23.596856377999927],
              [113.66041100400003, -23.58603280999995],
              [113.68213951900009, -23.579685153999947],
              [113.68897545700008, -23.569756768999923],
              [113.69361412900003, -23.55836353999996],
              [113.69996178500003, -23.549574476999908],
              [113.73755944100003, -23.52703215899993],
              [113.74984785200002, -23.511651299999926],
              [113.75456790500004, -23.485039971999925],
              [113.75684655000009, -23.47909921699994],
              [113.76661217500009, -23.465915622999944],
              [113.76880944100003, -23.457696221999925],
              [113.77100670700008, -23.38958098799992],
              [113.78028405000009, -23.348809502999927],
              [113.78248131600003, -23.32708098799992],
              [113.76880944100003, -23.24114348799992],
              [113.75114993600005, -23.180840752999927],
              [113.74830162900003, -23.162286065999922],
              [113.75367272200003, -23.138278903999947],
              [113.75456790500004, -23.12818775799991],
              [113.75831139400009, -23.11882903399993],
              [113.76742597700002, -23.111504815999922],
              [113.77865644600001, -23.105075778999947],
              [113.78931725400003, -23.097100518999923],
              [113.805023634, -23.07512786299992],
              [113.81153405000009, -23.05136484199994],
              [113.80738366000003, -22.93059661299992],
              [113.80176842500009, -22.899834893999923],
              [113.78589928500003, -22.874932549999926],
              [113.77540123800009, -22.85247161299992],
              [113.75977623800009, -22.78875090899993],
              [113.71363366000003, -22.74146900799991],
              [113.70289147200003, -22.73560963299991],
              [113.69068444100003, -22.730645440999922],
              [113.67603600400003, -22.727715752999927],
              [113.65894616000003, -22.72779713299991],
              [113.67164147200003, -22.690199476999908],
              [113.67212975400003, -22.668715101999908],
              [113.66195722700002, -22.648695570999905],
              [113.65951582100001, -22.640801690999922],
              [113.65894616000003, -22.60711028399993],
              [113.65577233200008, -22.59465911299992],
              [113.64966881600003, -22.58652109199994],
              [113.64665774800005, -22.577732028999947],
              [113.65211022200003, -22.562676690999922],
              [113.66081790500004, -22.553399346999925],
              [113.68262780000009, -22.54355234199994],
              [113.69312584700003, -22.535414320999905],
              [113.71680748800009, -22.492120049999926],
              [113.73145592500009, -22.479587497999944],
              [113.73462975400003, -22.470310153999947],
              [113.74089603000004, -22.42555103999996],
              [113.74773196700005, -22.401543877999927],
              [113.75879967500009, -22.382419528999947],
              [113.79273522200003, -22.34734465899993],
              [113.80396569100003, -22.330824476999908],
              [113.88550866000003, -22.110935153999947],
              [113.89079837300005, -22.08912525799991],
              [113.89323978000004, -22.068536065999922],
              [113.89795983200008, -22.04924895599993],
              [113.92310631600003, -22.013116143999923],
              [113.94703209700003, -21.952569268999923],
              [114.01148522200003, -21.85995859199994],
              [114.03581790500004, -21.837823174999926],
              [114.06714928500003, -21.819024346999925],
              [114.086273634, -21.811944268999923],
              [114.10743248800009, -21.809258721999925],
              [114.12777754000001, -21.804294528999947],
              [114.14470462300005, -21.79550546699994],
              [114.15919030000009, -21.79192473799992],
              [114.172211134, -21.802992445999905],
              [114.17603600400003, -21.822198174999926],
              [114.16602623800009, -21.835056247999944],
              [114.15251712300005, -21.846368096999925],
              [114.14568118600005, -21.86101653399993],
              [114.14234459700003, -21.880466403999947],
              [114.12769616000003, -21.92278411299992],
              [114.09644616000003, -22.10637786299992],
              [114.08301842500009, -22.14072030999995],
              [114.07748457100001, -22.17546965899993],
              [114.09376061300009, -22.210137627999927],
              [114.10271243600005, -22.22275155999995],
              [114.12094160200002, -22.260430596999925],
              [114.12435957100001, -22.275323174999926],
              [114.11133873800009, -22.312107028999947],
              [114.109711134, -22.33098723799992],
              [114.12435957100001, -22.336683851999908],
              [114.13160241000003, -22.32626718499995],
              [114.13754316500001, -22.307305596999925],
              [114.14747155000009, -22.294528903999947],
              [114.16602623800009, -22.302666924999926],
              [114.17139733200008, -22.317478122999944],
              [114.17042076900009, -22.33847421699994],
              [114.16382897200003, -22.35556405999995],
              [114.15186608200008, -22.35800546699994],
              [114.12273196700005, -22.38909270599993],
              [114.11768639400009, -22.39885833099993],
              [114.11817467500009, -22.413262627999927],
              [114.12574303500003, -22.438164971999925],
              [114.11085045700008, -22.477715752999927],
              [114.12240644600001, -22.504164320999905],
              [114.14812259200005, -22.521416924999926],
              [114.17969811300009, -22.521742445999905],
              [114.19629967500009, -22.507745049999926],
              [114.20687910200002, -22.48691171699994],
              [114.22193444100003, -22.467950127999927],
              [114.25171959700003, -22.459649346999925],
              [114.26221764400009, -22.45549895599993],
              [114.27409915500004, -22.447523695999905],
              [114.28663170700008, -22.443291924999926],
              [114.29981530000009, -22.44980234199994],
              [114.30689537900003, -22.462497653999947],
              [114.31177819100003, -22.476169528999947],
              [114.31983483200008, -22.48756275799991],
              [114.33741295700008, -22.49382903399993],
              [114.35694420700008, -22.48601653399993],
              [114.36703535200002, -22.47828541499996],
              [114.37086022200003, -22.465590101999908],
              [114.37159264400009, -22.442966403999947],
              [114.37378991000003, -22.43417734199994],
              [114.38355553500003, -22.414239190999922],
              [114.38575280000009, -22.402276299999926],
              [114.38721764400009, -22.37948984199994],
              [114.39193769600001, -22.35800546699994],
              [114.42172285200002, -22.29851653399993],
              [114.42847741000003, -22.27125416499996],
              [114.439789259, -22.24456145599993],
              [114.44385826900009, -22.237481377999927],
              [114.46762129000001, -22.206475518999923],
              [114.46851647200003, -22.194756768999923],
              [114.46363366000003, -22.181084893999923],
              [114.46762129000001, -22.17229583099993],
              [114.47681725400003, -22.16806405999995],
              [114.48829186300009, -22.16765715899993],
              [114.49781334700003, -22.163669528999947],
              [114.50570722700002, -22.126397393999923],
              [114.52125084700003, -22.089043877999927],
              [114.52230879000001, -22.06926848799992],
              [114.51872806100005, -22.060723565999922],
              [114.50635826900009, -22.04851653399993],
              [114.50180097700002, -22.04192473799992],
              [114.49952233200008, -22.03492603999996],
              [114.49610436300009, -22.01604583099993],
              [114.49561608200008, -22.00448984199994],
              [114.50318444100003, -21.996026299999926],
              [114.52051842500009, -22.01100025799991],
              [114.53891035200002, -22.031996351999908],
              [114.55030358200008, -22.04192473799992],
              [114.59880618600005, -21.95598723799992],
              [114.61109459700003, -21.925225518999923],
              [114.61378014400009, -21.92351653399993],
              [114.61744225400003, -21.923272393999923],
              [114.62126712300005, -21.92229583099993],
              [114.62476647200003, -21.91855234199994],
              [114.62720787900003, -21.91301848799992],
              [114.63160241000003, -21.898044528999947],
              [114.63770592500009, -21.857354424999926],
              [114.64673912900003, -21.843357028999947],
              [114.66944420700008, -21.837823174999926],
              [114.67823326900009, -21.83456796699994],
              [114.69157962300005, -21.817478122999944],
              [114.70045006600003, -21.809258721999925],
              [114.77898196700005, -21.78134530999995],
              [114.92896569100003, -21.69394296699994],
              [114.97071373800009, -21.68206145599993],
              [115.00896243600005, -21.69312916499996],
              [115.05518639400009, -21.676527601999908],
              [115.06739342500009, -21.668633721999925],
              [115.07740319100003, -21.659763278999947],
              [115.08863366000003, -21.65276458099993],
              [115.09864342500009, -21.65276458099993],
              [115.10515384200005, -21.665215752999927],
              [115.22388756600003, -21.598809502999927],
              [115.45460045700008, -21.51376718499995],
              [115.47852623800009, -21.501153252999927],
              [115.48878014400009, -21.48333098799992],
              [115.49463951900009, -21.46607838299991],
              [115.50831139400009, -21.45012786299992],
              [115.53646894600001, -21.42441171699994],
              [115.60271243600005, -21.34351978999996],
              [115.62598717500009, -21.32195403399993],
              [115.66228274800005, -21.298028252999927],
              [115.80616295700008, -21.235446872999944],
              [115.818695509, -21.225762627999927],
              [115.830414259, -21.190850518999923],
              [115.85906009200005, -21.154961846999925],
              [115.87761478000004, -21.115166924999926],
              [115.90552819100003, -21.08456796699994],
              [115.93669681100005, -21.05901458099993],
              [115.95801842500009, -21.048272393999923],
              [115.97413170700008, -21.044854424999926],
              [116.02320397200003, -21.02157968499995],
              [116.05640709700003, -21.010837497999944],
              [116.07105553500003, -21.003838799999926],
              [116.08521569100003, -20.993584893999923],
              [116.12126712300005, -20.98642343499995],
              [116.15154056100005, -20.96998463299991],
              [116.17408287900003, -20.94304778399993],
              [116.18767337300005, -20.904229424999926],
              [116.18930097700002, -20.858819268999923],
              [116.19629967500009, -20.846856377999927],
              [116.21859785200002, -20.842868747999944],
              [116.23023522200003, -20.846856377999927],
              [116.24594160200002, -20.855401299999926],
              [116.26587975400003, -20.86256275799991],
              [116.289398634, -20.863213799999926],
              [116.30860436300009, -20.85556405999995],
              [116.334320509, -20.833184502999927],
              [116.347992384, -20.82854583099993],
              [116.39193769600001, -20.82789478999996],
              [116.43474368600005, -20.82236093499995],
              [116.451508009, -20.814711195999905],
              [116.48226972700002, -20.79273853999996],
              [116.49219811300009, -20.788181247999944],
              [116.49805748800009, -20.786228122999944],
              [116.506195509, -20.780857028999947],
              [116.51351972700002, -20.77320728999996],
              [116.52051842500009, -20.751153252999927],
              [116.53003991000003, -20.746840101999908],
              [116.55079186300009, -20.747247002999927],
              [116.58708743600005, -20.73528411299992],
              [116.69939212300005, -20.659356377999927],
              [116.74317467500009, -20.61687590899993],
              [116.77930748800009, -20.56023528399993],
              [116.79712975400003, -20.54859791499996],
              [116.79086347700002, -20.53492603999996],
              [116.80640709700003, -20.52906666499996],
              [116.81446373800009, -20.52776458099993],
              [116.82447350400003, -20.528090101999908],
              [116.83513431100005, -20.53093840899993],
              [116.84351647200003, -20.53525155999995],
              [116.84538821700005, -20.539320570999905],
              [116.83513431100005, -20.54111093499995],
              [116.82032311300009, -20.549899997999944],
              [116.81446373800009, -20.57000090899993],
              [116.81080162900003, -20.610039971999925],
              [116.80551191500001, -20.617852471999925],
              [116.78874759200005, -20.63372161299992],
              [116.78419030000009, -20.644789320999905],
              [116.78394616000003, -20.65715911299992],
              [116.78728274800005, -20.664239190999922],
              [116.83594811300009, -20.704278252999927],
              [116.85547936300009, -20.712090752999927],
              [116.87964928500003, -20.713067315999922],
              [116.89918053500003, -20.708103122999944],
              [116.92164147200003, -20.698337497999944],
              [116.94027754000001, -20.686618747999944],
              [116.94800866000003, -20.67546965899993],
              [116.95704186300009, -20.66806405999995],
              [117.06251061300009, -20.62167734199994],
              [117.07154381600003, -20.620538018999923],
              [117.090179884, -20.634698174999926],
              [117.09546959700003, -20.637383721999925],
              [117.10767662900003, -20.63518645599993],
              [117.11793053500003, -20.629652601999908],
              [117.14437910200002, -20.60711028399993],
              [117.15406334700003, -20.596368096999925],
              [117.16016686300009, -20.596368096999925],
              [117.16716556100005, -20.603692315999922],
              [117.16863040500004, -20.60947030999995],
              [117.16773522200003, -20.61565520599993],
              [117.16773522200003, -20.62428150799991],
              [117.16098066500001, -20.638604424999926],
              [117.16016686300009, -20.644789320999905],
              [117.16285241000003, -20.649834893999923],
              [117.17237389400009, -20.658461195999905],
              [117.17457116000003, -20.661553643999923],
              [117.18132571700005, -20.67351653399993],
              [117.197601759, -20.683770440999922],
              [117.27247155000009, -20.71298593499995],
              [117.31153405000009, -20.722832940999922],
              [117.35377037900003, -20.727715752999927],
              [117.43751061300009, -20.722588799999926],
              [117.51343834700003, -20.70631275799991],
              [117.54379316500001, -20.692559502999927],
              [117.57911217500009, -20.667087497999944],
              [117.60271243600005, -20.657321872999944],
              [117.62330162900003, -20.661553643999923],
              [117.63575280000009, -20.673272393999923],
              [117.65064537900003, -20.672133070999905],
              [117.66114342500009, -20.661553643999923],
              [117.66423587300005, -20.657321872999944],
              [117.67042076900009, -20.661309502999927],
              [117.67530358200008, -20.66806405999995],
              [117.67481530000009, -20.672133070999905],
              [117.68995201900009, -20.668145440999922],
              [117.72950280000009, -20.65097421699994],
              [117.73633873800009, -20.658461195999905],
              [117.74984785200002, -20.64967213299991],
              [117.78679446700005, -20.636325778999947],
              [117.81006920700008, -20.623223565999922],
              [117.83082116000003, -20.619886976999908],
              [117.83936608200008, -20.61687590899993],
              [117.84913170700008, -20.60711028399993],
              [117.86060631600003, -20.584730726999908],
              [117.86719811300009, -20.57586028399993],
              [117.87875410200002, -20.565118096999925],
              [117.88550866000003, -20.56292083099993],
              [117.91114342500009, -20.56023528399993],
              [117.91863040500004, -20.55510833099993],
              [117.93181399800005, -20.53801848799992],
              [117.93531334700003, -20.52988046699994],
              [117.93336022200003, -20.50986093499995],
              [117.93482506600003, -20.500746351999908],
              [117.94068444100003, -20.49277109199994],
              [118.13559004000001, -20.362074476999908],
              [118.15088951900009, -20.356133721999925],
              [118.16187584700003, -20.354261976999908],
              [118.16920006600003, -20.350681247999944],
              [118.17701256600003, -20.34807708099993],
              [118.18873131600003, -20.34929778399993],
              [118.19157962300005, -20.35588958099993],
              [118.19141686300009, -20.36614348799992],
              [118.19507897200003, -20.371351820999905],
              [118.20923912900003, -20.36296965899993],
              [118.230804884, -20.37167734199994],
              [118.248383009, -20.36581796699994],
              [118.26433353000004, -20.355075778999947],
              [118.28093509200005, -20.34929778399993],
              [118.29175866000003, -20.347263278999947],
              [118.31226647200003, -20.337823174999926],
              [118.32227623800009, -20.33570728999996],
              [118.33529707100001, -20.33879973799992],
              [118.33904056100005, -20.346368096999925],
              [118.34205162900003, -20.35556405999995],
              [118.35328209700003, -20.36296965899993],
              [118.36882571700005, -20.362074476999908],
              [118.41081790500004, -20.346449476999908],
              [118.55193118600005, -20.321465752999927],
              [118.55079186300009, -20.32203541499996],
              [118.55469811300009, -20.32236093499995],
              [118.56544030000009, -20.321465752999927],
              [118.57048587300005, -20.319512627999927],
              [118.57300866000003, -20.317559502999927],
              [118.57593834700003, -20.316013278999947],
              [118.60629316500001, -20.30950286299992],
              [118.61670983200008, -20.30836353999996],
              [118.62810306100005, -20.30982838299991],
              [118.63445071700005, -20.313246351999908],
              [118.63965905000009, -20.31764088299991],
              [118.64747155000009, -20.321465752999927],
              [118.66236412900003, -20.32398853999996],
              [118.68181399800005, -20.323663018999923],
              [118.70191491000003, -20.317803643999923],
              [118.73804772200003, -20.292168877999927],
              [118.76050866000003, -20.288262627999927],
              [118.78402754000001, -20.286553643999923],
              [118.80567467500009, -20.28101978999996],
              [118.83179772200003, -20.261976820999905],
              [118.85173587300005, -20.236504815999922],
              [118.88086998800009, -20.185479424999926],
              [118.95883222700002, -20.104180596999925],
              [118.97022545700008, -20.072198174999926],
              [118.97461998800009, -20.050388278999947],
              [118.98568769600001, -20.040622653999947],
              [119.00017337300005, -20.034600518999923],
              [119.01490319100003, -20.02434661299992],
              [119.04810631600003, -20.013604424999926],
              [119.05616295700008, -20.00986093499995],
              [119.06080162900003, -20.001071872999944],
              [119.06421959700003, -19.99081796699994],
              [119.06853274800005, -19.98284270599993],
              [119.09546959700003, -19.966729424999926],
              [119.11833743600005, -19.97161223799992],
              [119.16138756600003, -20.007419528999947],
              [119.16098066500001, -19.980726820999905],
              [119.16325931100005, -19.966241143999923],
              [119.17212975400003, -19.960137627999927],
              [119.19239342500009, -19.958916924999926],
              [119.21241295700008, -19.961195570999905],
              [119.29200280000009, -19.985039971999925],
              [119.33326256600003, -19.992120049999926],
              [119.35694420700008, -19.99309661299992],
              [119.37647545700008, -19.996270440999922],
              [119.41700280000009, -20.01018645599993],
              [119.43580162900003, -20.013604424999926],
              [119.44507897200003, -20.011325778999947],
              [119.45728600400003, -20.001153252999927],
              [119.46306399800005, -19.999932549999926],
              [119.47396894600001, -20.005466403999947],
              [119.47852623800009, -20.01344166499996],
              [119.48129316500001, -20.022556247999944],
              [119.48715254000001, -20.03093840899993],
              [119.52344811300009, -20.05315520599993],
              [119.54664147200003, -20.063571872999944],
              [119.56666100400003, -20.06878020599993],
              [119.58985436300009, -20.065850518999923],
              [119.62330162900003, -20.04615650799991],
              [119.63786868600005, -20.04159921699994],
              [119.642914259, -20.037774346999925],
              [119.66480553500003, -20.010430596999925],
              [119.67212975400003, -20.008558851999908],
              [119.69092858200008, -20.014825127999927],
              [119.70264733200008, -20.013604424999926],
              [119.71753991000003, -20.00367603999996],
              [119.71900475400003, -19.993340752999927],
              [119.71566816500001, -19.983086846999925],
              [119.71615644600001, -19.97323984199994],
              [119.73438561300009, -19.96266041499996],
              [119.75562584700003, -19.961195570999905],
              [119.80225670700008, -19.96575286299992],
              [119.906586134, -19.94654713299991],
              [120.07056725400003, -19.92164478999996],
              [120.23829186300009, -19.90683359199994],
              [120.36850019600001, -19.867120049999926],
              [120.65056399800005, -19.763278903999947],
              [120.80323326900009, -19.698011976999908],
              [120.95435631600003, -19.63372161299992],
              [121.12826582100001, -19.520684502999927],
              [121.16602623800009, -19.484551690999922],
              [121.17986087300005, -19.47975025799991],
              [121.19353274800005, -19.47242603999996],
              [121.31153405000009, -19.35409921699994],
              [121.41618899800005, -19.22161223799992],
              [121.51937910200002, -19.06959400799991],
              [121.53980553500003, -19.013604424999926],
              [121.55795332100001, -18.99000416499996],
              [121.56413821700005, -18.975681247999944],
              [121.56657962300005, -18.955254815999922],
              [121.56918379000001, -18.94459400799991],
              [121.57569420700008, -18.935723565999922],
              [121.59107506600003, -18.92115650799991],
              [121.59742272200003, -18.911228122999944],
              [121.61280358200008, -18.86500416499996],
              [121.63184655000009, -18.82398853999996],
              [121.64258873800009, -18.81023528399993],
              [121.64869225400003, -18.786228122999944],
              [121.64966881600003, -18.776788018999923],
              [121.64625084700003, -18.76344166499996],
              [121.63819420700008, -18.75481536299992],
              [121.62891686300009, -18.74773528399993],
              [121.62175540500004, -18.739353122999944],
              [121.61329186300009, -18.712497653999947],
              [121.62452233200008, -18.71062590899993],
              [121.64389082100001, -18.717054945999905],
              [121.65967858200008, -18.715020440999922],
              [121.66773522200003, -18.70907968499995],
              [121.67823326900009, -18.706149997999944],
              [121.71558678500003, -18.70370859199994],
              [121.72380618600005, -18.699476820999905],
              [121.76905358200008, -18.657403252999927],
              [121.77719160200002, -18.640883070999905],
              [121.78003991000003, -18.61923593499995],
              [121.77475019600001, -18.606133721999925],
              [121.76197350400003, -18.59693775799991],
              [121.73161868600005, -18.58098723799992],
              [121.75961347700002, -18.56096770599993],
              [121.77393639400009, -18.545668226999908],
              [121.79664147200003, -18.48691171699994],
              [121.81104576900009, -18.46257903399993],
              [121.82374108200008, -18.451836846999925],
              [121.83741295700008, -18.455743096999925],
              [121.85075931100005, -18.463636976999908],
              [121.86654707100001, -18.47079843499995],
              [121.88868248800009, -18.471856377999927],
              [121.91032962300005, -18.464450778999947],
              [122.02214603000004, -18.384698174999926],
              [122.04420006600003, -18.360528252999927],
              [122.053070509, -18.331475518999923],
              [122.06226647200003, -18.32000090899993],
              [122.12208092500009, -18.293633721999925],
              [122.14210045700008, -18.279473565999922],
              [122.15805097700002, -18.26344166499996],
              [122.18344160200002, -18.225355726999908],
              [122.18637129000001, -18.229668877999927],
              [122.19239342500009, -18.234307549999926],
              [122.19711347700002, -18.238946221999925],
              [122.21045983200008, -18.211114190999922],
              [122.22038821700005, -18.197198174999926],
              [122.25066165500004, -18.18678150799991],
              [122.32398522200003, -18.150567315999922],
              [122.34701582100001, -18.12118905999995],
              [122.36304772200003, -18.08798593499995],
              [122.36915123800009, -18.063897393999923],
              [122.36768639400009, -18.026136976999908],
              [122.36068769600001, -18.000176690999922],
              [122.344086134, -17.98300546699994],
              [122.31373131600003, -17.971449476999908],
              [122.28345787900003, -17.964288018999923],
              [122.24854576900009, -17.960870049999926],
              [122.21705162900003, -17.96965911299992],
              [122.19711347700002, -17.998793226999908],
              [122.19092858200008, -17.998793226999908],
              [122.18726647200003, -17.99195728999996],
              [122.18238366000003, -17.986504815999922],
              [122.17676842500009, -17.98211028399993],
              [122.16976972700002, -17.97828541499996],
              [122.19613691500001, -17.94540780999995],
              [122.20785566500001, -17.911309502999927],
              [122.20728600400003, -17.873223565999922],
              [122.19336998800009, -17.805840752999927],
              [122.19711347700002, -17.742445570999905],
              [122.19947350400003, -17.733086846999925],
              [122.20362389400009, -17.722100518999923],
              [122.205414259, -17.710870049999926],
              [122.20053144600001, -17.70086028399993],
              [122.18848717500009, -17.68368905999995],
              [122.17725670700008, -17.66301848799992],
              [122.17432701900009, -17.65398528399993],
              [122.16976972700002, -17.628838799999926],
              [122.15626061300009, -17.597832940999922],
              [122.15406334700003, -17.588148695999905],
              [122.14519290500004, -17.572198174999926],
              [122.14323978000004, -17.563653252999927],
              [122.14112389400009, -17.45875416499996],
              [122.14942467500009, -17.34148528399993],
              [122.16700280000009, -17.295668226999908],
              [122.17204837300005, -17.261163018999923],
              [122.17872155000009, -17.24423593499995],
              [122.19044030000009, -17.23056405999995],
              [122.20769290500004, -17.224786065999922],
              [122.21412194100003, -17.210870049999926],
              [122.26685631600003, -17.150648695999905],
              [122.279633009, -17.13925546699994],
              [122.27369225400003, -17.128350518999923],
              [122.26254316500001, -17.12623463299991],
              [122.25660241000003, -17.121270440999922],
              [122.26612389400009, -17.10125090899993],
              [122.27605228000004, -17.089288018999923],
              [122.41277103000004, -16.97275155999995],
              [122.45101972700002, -16.95045338299991],
              [122.44450931100005, -16.968926690999922],
              [122.45085696700005, -16.981622002999927],
              [122.46412194100003, -16.983819268999923],
              [122.47828209700003, -16.970961195999905],
              [122.48161868600005, -16.949965101999908],
              [122.47527103000004, -16.932386976999908],
              [122.47291100400003, -16.920179945999905],
              [122.48829186300009, -16.91570403399993],
              [122.50611412900003, -16.91961028399993],
              [122.51539147200003, -16.92937590899993],
              [122.52133222700002, -16.941664320999905],
              [122.52955162900003, -16.953871351999908],
              [122.54297936300009, -16.960870049999926],
              [122.59498131600003, -16.970961195999905],
              [122.58204186300009, -16.956231377999927],
              [122.56031334700003, -16.90943775799991],
              [122.53044681100005, -16.87395598799992],
              [122.52613366000003, -16.86174895599993],
              [122.52751712300005, -16.850274346999925],
              [122.53126061300009, -16.84417083099993],
              [122.53598066500001, -16.840101820999905],
              [122.54029381600003, -16.83440520599993],
              [122.54167728000004, -16.837497653999947],
              [122.54615319100003, -16.839043877999927],
              [122.55103600400003, -16.837497653999947],
              [122.55347741000003, -16.83098723799992],
              [122.55258222700002, -16.81731536299992],
              [122.55347741000003, -16.813897393999923],
              [122.56177819100003, -16.79973723799992],
              [122.57056725400003, -16.788506768999923],
              [122.582367384, -16.779554945999905],
              [122.60124759200005, -16.772230726999908],
              [122.60661868600005, -16.78687916499996],
              [122.61443118600005, -16.796075127999927],
              [122.62598717500009, -16.800388278999947],
              [122.64283287900003, -16.800225518999923],
              [122.65015709700003, -16.797621351999908],
              [122.66456139400009, -16.788506768999923],
              [122.67359459700003, -16.786716403999947],
              [122.69727623800009, -16.78769296699994],
              [122.70427493600005, -16.786716403999947],
              [122.71892337300005, -16.778903903999947],
              [122.72901451900009, -16.76921965899993],
              [122.74048912900003, -16.761325778999947],
              [122.75879967500009, -16.75872161299992],
              [122.77369225400003, -16.761651299999926],
              [122.82097415500004, -16.77971770599993],
              [122.76319420700008, -16.730075778999947],
              [122.74610436300009, -16.70289478999996],
              [122.74512780000009, -16.669854424999926],
              [122.74830162900003, -16.662367445999905],
              [122.75709069100003, -16.64657968499995],
              [122.75879967500009, -16.638848565999922],
              [122.75879967500009, -16.60442473799992],
              [122.76246178500003, -16.59417083099993],
              [122.77149498800009, -16.579278252999927],
              [122.78394616000003, -16.565850518999923],
              [122.79712975400003, -16.560153903999947],
              [122.82553144600001, -16.56308359199994],
              [122.83741295700008, -16.561618747999944],
              [122.84888756600003, -16.55315520599993],
              [122.85596764400009, -16.541192315999922],
              [122.861664259, -16.52776458099993],
              [122.87045332100001, -16.516778252999927],
              [122.88640384200005, -16.51230234199994],
              [122.89454186300009, -16.492120049999926],
              [122.90284264400009, -16.450616143999923],
              [122.91618899800005, -16.415948174999926],
              [122.93824303500003, -16.41611093499995],
              [123.00660241000003, -16.374444268999923],
              [123.02027428500003, -16.38258228999996],
              [123.01807701900009, -16.396091403999947],
              [122.998383009, -16.422946872999944],
              [123.04151451900009, -16.44109465899993],
              [123.05836022200003, -16.45354583099993],
              [123.05372155000009, -16.470635674999926],
              [123.04078209700003, -16.478122653999947],
              [123.02833092500009, -16.477227471999925],
              [123.01587975400003, -16.47323984199994],
              [123.00261478000004, -16.470635674999926],
              [122.99000084700003, -16.473402601999908],
              [122.98487389400009, -16.48105234199994],
              [122.97787519600001, -16.505466403999947],
              [122.99040774800005, -16.529229424999926],
              [122.95980879000001, -16.580336195999905],
              [122.97169030000009, -16.59417083099993],
              [122.97673587300005, -16.61646900799991],
              [122.98072350400003, -16.62542083099993],
              [122.98878014400009, -16.62900155999995],
              [123.00904381600003, -16.61687590899993],
              [123.02100670700008, -16.614353122999944],
              [123.02637780000009, -16.62558359199994],
              [123.02670332100001, -16.649102471999925],
              [123.03077233200008, -16.67620208099993],
              [123.04281660200002, -16.692478122999944],
              [123.06739342500009, -16.683526299999926],
              [123.08187910200002, -16.70322030999995],
              [123.090179884, -16.709649346999925],
              [123.10206139400009, -16.712090752999927],
              [123.11255944100003, -16.709730726999908],
              [123.11703535200002, -16.70354583099993],
              [123.11988366000003, -16.69540780999995],
              [123.12574303500003, -16.686944268999923],
              [123.13217207100001, -16.686293226999908],
              [123.13355553500003, -16.696872653999947],
              [123.13103274800005, -16.71103280999995],
              [123.12574303500003, -16.72112395599993],
              [123.11491946700005, -16.727634372999944],
              [123.10710696700005, -16.72893645599993],
              [123.10084069100003, -16.732354424999926],
              [123.09457441500001, -16.745700778999947],
              [123.09449303500003, -16.76930103999996],
              [123.10645592500009, -16.78639088299991],
              [123.12378991000003, -16.796807549999926],
              [123.13941491000003, -16.800225518999923],
              [123.15088951900009, -16.807712497999944],
              [123.15626061300009, -16.82480234199994],
              [123.15772545700008, -16.84343840899993],
              [123.15674889400009, -16.85556405999995],
              [123.14356530000009, -16.89234791499996],
              [123.14332116000003, -16.91375090899993],
              [123.16016686300009, -16.92310963299991],
              [123.18376712300005, -16.92896900799991],
              [123.19825280000009, -16.94312916499996],
              [123.21810957100001, -16.977715752999927],
              [123.26042728000004, -17.014743747999944],
              [123.26661217500009, -17.02939218499995],
              [123.26758873800009, -17.069512627999927],
              [123.27173912900003, -17.08562590899993],
              [123.28028405000009, -17.10125090899993],
              [123.31544030000009, -17.138278903999947],
              [123.33375084700003, -17.162367445999905],
              [123.34180748800009, -17.18726978999996],
              [123.35075931100005, -17.204685153999947],
              [123.36817467500009, -17.228448174999926],
              [123.37940514400009, -17.25481536299992],
              [123.36963951900009, -17.279473565999922],
              [123.38795006600003, -17.315606377999927],
              [123.39966881600003, -17.329278252999927],
              [123.43441816500001, -17.344414971999925],
              [123.44809004000001, -17.36500416499996],
              [123.45777428500003, -17.384372653999947],
              [123.46583092500009, -17.389336846999925],
              [123.47706139400009, -17.405450127999927],
              [123.49040774800005, -17.416273695999905],
              [123.50147545700008, -17.42978280999995],
              [123.51172936300009, -17.471856377999927],
              [123.54053795700008, -17.501397393999923],
              [123.55396569100003, -17.518975518999923],
              [123.56031334700003, -17.536228122999944],
              [123.56690514400009, -17.576348565999922],
              [123.56763756600003, -17.591403903999947],
              [123.57081139400009, -17.595147393999923],
              [123.57789147200003, -17.590508721999925],
              [123.58497155000009, -17.58098723799992],
              [123.58814537900003, -17.570570570999905],
              [123.58765709700003, -17.515069268999923],
              [123.58659915500004, -17.50750090899993],
              [123.58130944100003, -17.492364190999922],
              [123.56332441500001, -17.45761484199994],
              [123.56080162900003, -17.44736093499995],
              [123.56169681100005, -17.404473565999922],
              [123.56763756600003, -17.361993096999925],
              [123.57325280000009, -17.35019296699994],
              [123.58985436300009, -17.32675546699994],
              [123.59498131600003, -17.313571872999944],
              [123.59522545700008, -17.302666924999926],
              [123.594086134, -17.290459893999923],
              [123.59441165500004, -17.278741143999923],
              [123.59839928500003, -17.269463799999926],
              [123.60434004000001, -17.260511976999908],
              [123.60767662900003, -17.250664971999925],
              [123.60922285200002, -17.22820403399993],
              [123.61280358200008, -17.21575286299992],
              [123.62061608200008, -17.20794036299992],
              [123.62964928500003, -17.202569268999923],
              [123.63453209700003, -17.20159270599993],
              [123.63697350400003, -17.20289478999996],
              [123.64332116000003, -17.20370859199994],
              [123.64429772200003, -17.184747002999927],
              [123.63965905000009, -17.17278411299992],
              [123.62281334700003, -17.15593840899993],
              [123.57960045700008, -17.094008070999905],
              [123.57447350400003, -17.042901299999926],
              [123.57764733200008, -17.02548593499995],
              [123.59131920700008, -16.999932549999926],
              [123.59498131600003, -16.985121351999908],
              [123.60613040500004, -16.996351820999905],
              [123.61540774800005, -16.99651458099993],
              [123.62468509200005, -16.99260833099993],
              [123.63591556100005, -16.991387627999927],
              [123.65040123800009, -16.99391041499996],
              [123.65601647200003, -16.99578215899993],
              [123.66724694100003, -17.008477471999925],
              [123.66993248800009, -17.01572030999995],
              [123.68018639400009, -17.06031666499996],
              [123.68628991000003, -17.05787525799991],
              [123.69312584700003, -17.050713799999926],
              [123.69800866000003, -17.04664478999996],
              [123.71273847700002, -17.05282968499995],
              [123.73340905000009, -17.06609465899993],
              [123.75147545700008, -17.08261484199994],
              [123.75945071700005, -17.097832940999922],
              [123.76107832100001, -17.10800546699994],
              [123.76547285200002, -17.11760833099993],
              [123.77125084700003, -17.126071872999944],
              [123.77711022200003, -17.132419528999947],
              [123.78891035200002, -17.14072030999995],
              [123.81153405000009, -17.15048593499995],
              [123.82154381600003, -17.15593840899993],
              [123.83448326900009, -17.17164478999996],
              [123.84652754000001, -17.19231536299992],
              [123.86085045700008, -17.210381768999923],
              [123.87973066500001, -17.217950127999927],
              [123.902679884, -17.21851978999996],
              [123.91334069100003, -17.215590101999908],
              [123.91773522200003, -17.20745208099993],
              [123.91407311300009, -17.19898853999996],
              [123.90479576900009, -17.196058851999908],
              [123.89340254000001, -17.194512627999927],
              [123.88298587300005, -17.19068775799991],
              [123.85377037900003, -17.163262627999927],
              [123.83708743600005, -17.132419528999947],
              [123.81470787900003, -17.053480726999908],
              [123.79883873800009, -17.019789320999905],
              [123.79460696700005, -17.00009530999995],
              [123.80445397200003, -16.991387627999927],
              [123.81763756600003, -16.99618905999995],
              [123.85401451900009, -17.01848723799992],
              [123.86304772200003, -17.025567315999922],
              [123.86963951900009, -17.004652601999908],
              [123.85865319100003, -16.991631768999923],
              [123.84310957100001, -16.979261976999908],
              [123.83521569100003, -16.96070728999996],
              [123.84164472700002, -16.94654713299991],
              [123.87012780000009, -16.92359791499996],
              [123.87671959700003, -16.91269296699994],
              [123.88379967500009, -16.89690520599993],
              [123.900726759, -16.886651299999926],
              [123.92090905000009, -16.878350518999923],
              [123.93751061300009, -16.867852471999925],
              [123.94849694100003, -16.85051848799992],
              [123.95329837300005, -16.82854583099993],
              [123.94857832100001, -16.809258721999925],
              [123.93140709700003, -16.800225518999923],
              [123.92359459700003, -16.83879973799992],
              [123.90259850400003, -16.858982028999947],
              [123.83521569100003, -16.881524346999925],
              [123.79249108200008, -16.89072030999995],
              [123.76807701900009, -16.878513278999947],
              [123.73267662900003, -16.813897393999923],
              [123.72608483200008, -16.796482028999947],
              [123.71680748800009, -16.757419528999947],
              [123.70826256600003, -16.74187590899993],
              [123.69312584700003, -16.729913018999923],
              [123.65935306100005, -16.714450778999947],
              [123.64332116000003, -16.70403411299992],
              [123.61158287900003, -16.673760674999926],
              [123.59555097700002, -16.66529713299991],
              [123.50993899800005, -16.653903903999947],
              [123.50912519600001, -16.649834893999923],
              [123.51295006600003, -16.642022393999923],
              [123.52930748800009, -16.632419528999947],
              [123.55250084700003, -16.62623463299991],
              [123.56617272200003, -16.615980726999908],
              [123.55396569100003, -16.59417083099993],
              [123.59506269600001, -16.574883721999925],
              [123.60914147200003, -16.563897393999923],
              [123.60922285200002, -16.546319268999923],
              [123.59644616000003, -16.535902601999908],
              [123.55518639400009, -16.539727471999925],
              [123.53345787900003, -16.53215911299992],
              [123.54574629000001, -16.562676690999922],
              [123.54346764400009, -16.56698984199994],
              [123.51254316500001, -16.566664320999905],
              [123.49854576900009, -16.561944268999923],
              [123.492523634, -16.54973723799992],
              [123.48804772200003, -16.54387786299992],
              [123.45850670700008, -16.52597421699994],
              [123.45883222700002, -16.52467213299991],
              [123.44597415500004, -16.51230234199994],
              [123.44467207100001, -16.51230234199994],
              [123.43946373800009, -16.50790780999995],
              [123.43336022200003, -16.504571221999925],
              [123.42758222700002, -16.49976978999996],
              [123.424164259, -16.49114348799992],
              [123.46949303500003, -16.50367603999996],
              [123.48267662900003, -16.505466403999947],
              [123.492523634, -16.500258070999905],
              [123.48609459700003, -16.48837655999995],
              [123.46583092500009, -16.46379973799992],
              [123.48951256600003, -16.468926690999922],
              [123.52426191500001, -16.49846770599993],
              [123.54346764400009, -16.505466403999947],
              [123.56763756600003, -16.51100025799991],
              [123.59294681100005, -16.522149346999925],
              [123.61841881600003, -16.529961846999925],
              [123.64332116000003, -16.52597421699994],
              [123.635101759, -16.51539478999996],
              [123.62061608200008, -16.51034921699994],
              [123.58814537900003, -16.505466403999947],
              [123.60743248800009, -16.494073174999926],
              [123.63819420700008, -16.48951588299991],
              [123.65406334700003, -16.48447030999995],
              [123.53874759200005, -16.426446221999925],
              [123.50611412900003, -16.41611093499995],
              [123.50611412900003, -16.40797291499996],
              [123.53785241000003, -16.41464609199994],
              [123.54932701900009, -16.41187916499996],
              [123.55396569100003, -16.395603122999944],
              [123.64844811300009, -16.42782968499995],
              [123.71168053500003, -16.42978280999995],
              [123.68816165500004, -16.40797291499996],
              [123.67554772200003, -16.399102471999925],
              [123.66041100400003, -16.395603122999944],
              [123.65186608200008, -16.392510674999926],
              [123.64405358200008, -16.38534921699994],
              [123.63249759200005, -16.371351820999905],
              [123.63160241000003, -16.364678643999923],
              [123.64047285200002, -16.36060963299991],
              [123.65162194100003, -16.36028411299992],
              [123.664398634, -16.369886976999908],
              [123.68132571700005, -16.37623463299991],
              [123.69971764400009, -16.381036065999922],
              [123.71168053500003, -16.38128020599993],
              [123.71509850400003, -16.37346770599993],
              [123.71656334700003, -16.35865650799991],
              [123.71558678500003, -16.343357028999947],
              [123.71168053500003, -16.333591403999947],
              [123.69825280000009, -16.330010674999926],
              [123.65796959700003, -16.327732028999947],
              [123.64958743600005, -16.323337497999944],
              [123.64576256600003, -16.31536223799992],
              [123.63697350400003, -16.305352471999925],
              [123.62696373800009, -16.296807549999926],
              [123.61915123800009, -16.293145440999922],
              [123.61011803500003, -16.295179945999905],
              [123.60336347700002, -16.29973723799992],
              [123.60287519600001, -16.304131768999923],
              [123.61231530000009, -16.306247653999947],
              [123.61589603000004, -16.308526299999926],
              [123.61500084700003, -16.31340911299992],
              [123.61019941500001, -16.31812916499996],
              [123.60181725400003, -16.319919528999947],
              [123.594086134, -16.31682708099993],
              [123.58887780000009, -16.310723565999922],
              [123.58480879000001, -16.30437590899993],
              [123.58130944100003, -16.299981377999927],
              [123.55836022200003, -16.286716403999947],
              [123.54737389400009, -16.277520440999922],
              [123.53972415500004, -16.265232028999947],
              [123.56714928500003, -16.260918877999927],
              [123.57642662900003, -16.242445570999905],
              [123.570648634, -16.221856377999927],
              [123.55396569100003, -16.21062590899993],
              [123.56373131600003, -16.18531666499996],
              [123.57016035200002, -16.176934502999927],
              [123.58130944100003, -16.16961028399993],
              [123.58545983200008, -16.174004815999922],
              [123.59669030000009, -16.178806247999944],
              [123.60336347700002, -16.17555103999996],
              [123.59498131600003, -16.15593840899993],
              [123.69092858200008, -16.148695570999905],
              [123.719086134, -16.15593840899993],
              [123.72413170700008, -16.136325778999947],
              [123.73259524800005, -16.14104583099993],
              [123.74187259200005, -16.15488046699994],
              [123.74952233200008, -16.162774346999925],
              [123.77100670700008, -16.16334400799991],
              [123.77369225400003, -16.162774346999925],
              [123.77849368600005, -16.167413018999923],
              [123.78581790500004, -16.180433851999908],
              [123.79053795700008, -16.18328215899993],
              [123.79965254000001, -16.185479424999926],
              [123.80689537900003, -16.19109465899993],
              [123.80933678500003, -16.19890715899993],
              [123.80445397200003, -16.20745208099993],
              [123.79607181100005, -16.20875416499996],
              [123.77426191500001, -16.201918226999908],
              [123.76685631600003, -16.20435963299991],
              [123.76929772200003, -16.21656666499996],
              [123.78785241000003, -16.225355726999908],
              [123.81128991000003, -16.23023853999996],
              [123.82837975400003, -16.231133721999925],
              [123.81348717500009, -16.246026299999926],
              [123.78711998800009, -16.251560153999947],
              [123.75749759200005, -16.25367603999996],
              [123.73267662900003, -16.258965752999927],
              [123.80347741000003, -16.308200778999947],
              [123.82837975400003, -16.319919528999947],
              [123.84245853000004, -16.322523695999905],
              [123.85377037900003, -16.323337497999944],
              [123.86264082100001, -16.327325127999927],
              [123.86931399800005, -16.34042734199994],
              [123.87061608200008, -16.356622002999927],
              [123.86605879000001, -16.36809661299992],
              [123.85808353000004, -16.37078215899993],
              [123.84880618600005, -16.360772393999923],
              [123.83521569100003, -16.368259372999944],
              [123.85328209700003, -16.415948174999926],
              [123.86304772200003, -16.42978280999995],
              [123.86931399800005, -16.41611093499995],
              [123.87671959700003, -16.41611093499995],
              [123.879242384, -16.420668226999908],
              [123.88502037900003, -16.424981377999927],
              [123.88965905000009, -16.42978280999995],
              [123.89470462300005, -16.409763278999947],
              [123.89136803500003, -16.369805596999925],
              [123.89722741000003, -16.35393645599993],
              [123.89185631600003, -16.33879973799992],
              [123.90674889400009, -16.338636976999908],
              [123.92872155000009, -16.34612395599993],
              [123.94507897200003, -16.35393645599993],
              [123.95036868600005, -16.35995859199994],
              [123.96697024800005, -16.374444268999923],
              [123.98462975400003, -16.384698174999926],
              [123.99284915500004, -16.37786223799992],
              [123.95777428500003, -16.32089609199994],
              [123.95142662900003, -16.293633721999925],
              [123.98601321700005, -16.286309502999927],
              [123.98601321700005, -16.278903903999947],
              [123.96461022200003, -16.268649997999944],
              [123.94239342500009, -16.25286223799992],
              [123.92335045700008, -16.23479583099993],
              [123.91089928500003, -16.217461846999925],
              [123.93287194100003, -16.221774997999944],
              [123.97217858200008, -16.240411065999922],
              [123.99626712300005, -16.244805596999925],
              [124.01889082100001, -16.246026299999926],
              [124.02930748800009, -16.24928150799991],
              [124.03386478000004, -16.25554778399993],
              [124.03785241000003, -16.26344166499996],
              [124.04761803500003, -16.263604424999926],
              [124.06853274800005, -16.258965752999927],
              [124.107758009, -16.26539478999996],
              [124.12623131600003, -16.272230726999908],
              [124.14795983200008, -16.288262627999927],
              [124.16716556100005, -16.29697030999995],
              [124.17090905000009, -16.302992445999905],
              [124.19939212300005, -16.37509530999995],
              [124.20997155000009, -16.38958098799992],
              [124.22266686300009, -16.395603122999944],
              [124.30062910200002, -16.40243905999995],
              [124.33220462300005, -16.410088799999926],
              [124.342133009, -16.40797291499996],
              [124.36646569100003, -16.36451588299991],
              [124.38607832100001, -16.351169528999947],
              [124.40015709700003, -16.353122653999947],
              [124.42481530000009, -16.374444268999923],
              [124.44922936300009, -16.386976820999905],
              [124.47364342500009, -16.393324476999908],
              [124.59245853000004, -16.40129973799992],
              [124.62330162900003, -16.399997653999947],
              [124.65015709700003, -16.388116143999923],
              [124.65748131600003, -16.395603122999944],
              [124.68132571700005, -16.386976820999905],
              [124.72575931100005, -16.38250090899993],
              [124.76872806100005, -16.38534921699994],
              [124.78785241000003, -16.39902109199994],
              [124.80372155000009, -16.418226820999905],
              [124.83969160200002, -16.425713799999926],
              [124.87891686300009, -16.420668226999908],
              [124.90398196700005, -16.40243905999995],
              [124.88404381600003, -16.399183851999908],
              [124.84083092500009, -16.40520598799992],
              [124.82520592500009, -16.39902109199994],
              [124.80941816500001, -16.38762786299992],
              [124.791351759, -16.381931247999944],
              [124.75318444100003, -16.374444268999923],
              [124.69727623800009, -16.344414971999925],
              [124.59620201900009, -16.32659270599993],
              [124.57325280000009, -16.32586028399993],
              [124.49927819100003, -16.33570728999996],
              [124.48552493600005, -16.34547291499996],
              [124.47632897200003, -16.347832940999922],
              [124.45679772200003, -16.33326588299991],
              [124.45337975400003, -16.335056247999944],
              [124.44996178500003, -16.33847421699994],
              [124.44459069100003, -16.34042734199994],
              [124.42872155000009, -16.340508721999925],
              [124.41325931100005, -16.338148695999905],
              [124.40154056100005, -16.329278252999927],
              [124.39478600400003, -16.29924895599993],
              [124.38998457100001, -16.29265715899993],
              [124.38542728000004, -16.287855726999908],
              [124.38331139400009, -16.282647393999923],
              [124.38526451900009, -16.270196221999925],
              [124.39478600400003, -16.249607028999947],
              [124.396820509, -16.238539320999905],
              [124.39210045700008, -16.229180596999925],
              [124.38306725400003, -16.222914320999905],
              [124.37842858200008, -16.21493905999995],
              [124.38656660200002, -16.200616143999923],
              [124.39185631600003, -16.188164971999925],
              [124.39185631600003, -16.175957940999922],
              [124.39454186300009, -16.16659921699994],
              [124.41822350400003, -16.16057708099993],
              [124.42554772200003, -16.15357838299991],
              [124.42969811300009, -16.14185963299991],
              [124.43091881600003, -16.07000090899993],
              [124.43433678500003, -16.057793877999927],
              [124.44312584700003, -16.051853122999944],
              [124.45427493600005, -16.052666924999926],
              [124.46583092500009, -16.060479424999926],
              [124.47242272200003, -16.07350025799991],
              [124.47266686300009, -16.087823174999926],
              [124.471039259, -16.101820570999905],
              [124.47266686300009, -16.11500416499996],
              [124.476898634, -16.120538018999923],
              [124.49984785200002, -16.14226653399993],
              [124.51091556100005, -16.15829843499995],
              [124.52035566500001, -16.176446221999925],
              [124.52955162900003, -16.154961846999925],
              [124.54672285200002, -16.128106377999927],
              [124.56967207100001, -16.10995859199994],
              [124.59620201900009, -16.11500416499996],
              [124.59001712300005, -16.09417083099993],
              [124.58936608200008, -16.02507903399993],
              [124.58375084700003, -15.988864841999941],
              [124.59115644600001, -15.977308851999908],
              [124.61597741000003, -15.977227471999925],
              [124.60767662900003, -15.957614841999941],
              [124.60629316500001, -15.93678150799991],
              [124.609711134, -15.898695570999905],
              [124.61988366000003, -15.881931247999944],
              [124.64258873800009, -15.865655205999929],
              [124.66586347700002, -15.861504815999922],
              [124.67798912900003, -15.881036065999922],
              [124.68425540500004, -15.881036065999922],
              [124.69459069100003, -15.85637786299992],
              [124.69922936300009, -15.83684661299992],
              [124.70875084700003, -15.820733330999929],
              [124.73267662900003, -15.806573174999926],
              [124.69711347700002, -15.794040622999944],
              [124.67888431100005, -15.791680596999925],
              [124.63168379000001, -15.79420338299991],
              [124.62183678500003, -15.79778411299992],
              [124.609711134, -15.806573174999926],
              [124.58668053500003, -15.847832940999922],
              [124.55844160200002, -15.874932549999926],
              [124.51514733200008, -15.970147393999923],
              [124.48633873800009, -15.998304945999905],
              [124.48365319100003, -15.985528252999927],
              [124.486664259, -15.975030205999929],
              [124.49138431100005, -15.96412525799991],
              [124.49317467500009, -15.95045338299991],
              [124.48943118600005, -15.94068775799991],
              [124.48226972700002, -15.934991143999923],
              [124.47559655000009, -15.927341403999947],
              [124.46949303500003, -15.895928643999923],
              [124.45045006600003, -15.843194268999923],
              [124.43848717500009, -15.826348565999922],
              [124.43995201900009, -15.839043877999927],
              [124.43873131600003, -15.84970468499995],
              [124.43409264400009, -15.855645440999922],
              [124.42481530000009, -15.854261976999908],
              [124.42090905000009, -15.86060963299991],
              [124.41675866000003, -15.864841403999947],
              [124.40430748800009, -15.87476978999996],
              [124.39918053500003, -15.80478280999995],
              [124.39340254000001, -15.78883228999996],
              [124.38453209700003, -15.771416924999926],
              [124.38152103000004, -15.748467705999929],
              [124.38347415500004, -15.727634372999944],
              [124.38998457100001, -15.717054945999905],
              [124.37794030000009, -15.68726978999996],
              [124.37647545700008, -15.676202080999929],
              [124.37745201900009, -15.66692473799992],
              [124.38062584700003, -15.664483330999929],
              [124.38526451900009, -15.66773853999996],
              [124.38998457100001, -15.676202080999929],
              [124.396820509, -15.676202080999929],
              [124.39568118600005, -15.663995049999926],
              [124.39673912900003, -15.652276299999926],
              [124.39975019600001, -15.64226653399993],
              [124.40430748800009, -15.635186455999929],
              [124.41797936300009, -15.669366143999923],
              [124.42628014400009, -15.647556247999944],
              [124.42750084700003, -15.621514580999929],
              [124.41846764400009, -15.604099216999941],
              [124.396820509, -15.608005466999941],
              [124.40333092500009, -15.559258721999925],
              [124.39698326900009, -15.53915780999995],
              [124.37647545700008, -15.525323174999926],
              [124.38990319100003, -15.522556247999944],
              [124.40601647200003, -15.528008721999925],
              [124.41920006600003, -15.534600518999923],
              [124.42481530000009, -15.535577080999929],
              [124.42896569100003, -15.530450127999927],
              [124.44776451900009, -15.52507903399993],
              [124.45199629000001, -15.521661065999922],
              [124.45199629000001, -15.49114348799992],
              [124.47291100400003, -15.468682549999926],
              [124.504242384, -15.467461846999925],
              [124.53760826900009, -15.480726820999905],
              [124.56527754000001, -15.501560153999947],
              [124.57813561300009, -15.506931247999944],
              [124.597992384, -15.509942315999922],
              [124.61768639400009, -15.50953541499996],
              [124.62964928500003, -15.504978122999944],
              [124.62964928500003, -15.43254973799992],
              [124.63111412900003, -15.42546965899993],
              [124.63461347700002, -15.419040622999944],
              [124.64014733200008, -15.415948174999926],
              [124.64673912900003, -15.41887786299992],
              [124.64942467500009, -15.426853122999944],
              [124.64283287900003, -15.446384372999944],
              [124.64332116000003, -15.45712655999995],
              [124.65406334700003, -15.47234465899993],
              [124.66863040500004, -15.478448174999926],
              [124.68262780000009, -15.47389088299991],
              [124.691742384, -15.45712655999995],
              [124.67286217500009, -15.44264088299991],
              [124.67261803500003, -15.418226820999905],
              [124.68344160200002, -15.39234791499996],
              [124.69800866000003, -15.37395598799992],
              [124.72779381600003, -15.361260674999926],
              [124.73267662900003, -15.35751718499995],
              [124.72803795700008, -15.347588799999926],
              [124.70850670700008, -15.345635674999926],
              [124.70533287900003, -15.33294036299992],
              [124.68100019600001, -15.349786065999922],
              [124.66968834700003, -15.352308851999908],
              [124.66374759200005, -15.339776299999926],
              [124.66700280000009, -15.324395440999922],
              [124.67725670700008, -15.321058851999908],
              [124.68921959700003, -15.320489190999922],
              [124.69800866000003, -15.313083591999941],
              [124.69792728000004, -15.298435153999947],
              [124.68685957100001, -15.294366143999923],
              [124.67286217500009, -15.294366143999923],
              [124.66374759200005, -15.29192473799992],
              [124.66032962300005, -15.283786716999941],
              [124.66016686300009, -15.274183851999908],
              [124.66374759200005, -15.250420830999929],
              [124.68238366000003, -15.26067473799992],
              [124.68816165500004, -15.262790622999944],
              [124.69800866000003, -15.264743747999944],
              [124.69605553500003, -15.261976820999905],
              [124.69800866000003, -15.25709400799991],
              [124.70264733200008, -15.252536716999941],
              [124.70875084700003, -15.250420830999929],
              [124.71176191500001, -15.253513278999947],
              [124.71306399800005, -15.268649997999944],
              [124.71558678500003, -15.274590752999927],
              [124.72038821700005, -15.275323174999926],
              [124.75660241000003, -15.28525155999995],
              [124.76148522200003, -15.292168877999927],
              [124.75489342500009, -15.307793877999927],
              [124.73951256600003, -15.33294036299992],
              [124.74586022200003, -15.335381768999923],
              [124.78223717500009, -15.301446221999925],
              [124.79786217500009, -15.29192473799992],
              [124.80396569100003, -15.295179945999905],
              [124.81560306100005, -15.30982838299991],
              [124.82520592500009, -15.313083591999941],
              [124.83545983200008, -15.31804778399993],
              [124.83480879000001, -15.32976653399993],
              [124.82862389400009, -15.343357028999947],
              [124.82203209700003, -15.354099216999941],
              [124.84343509200005, -15.35279713299991],
              [124.86931399800005, -15.34775155999995],
              [124.88347415500004, -15.347263278999947],
              [124.90552819100003, -15.35165780999995],
              [124.92042076900009, -15.36101653399993],
              [124.94556725400003, -15.388848565999922],
              [124.94971764400009, -15.395684502999927],
              [124.95215905000009, -15.40203215899993],
              [124.95753014400009, -15.406833591999941],
              [124.97624759200005, -15.41025155999995],
              [124.98340905000009, -15.41383228999996],
              [124.98959394600001, -15.418389580999929],
              [124.99333743600005, -15.422295830999929],
              [124.99317467500009, -15.438083591999941],
              [124.97624759200005, -15.469170830999929],
              [124.97974694100003, -15.477634372999944],
              [124.99170983200008, -15.478122653999947],
              [125.00074303500003, -15.472914320999905],
              [125.00855553500003, -15.46648528399993],
              [125.01758873800009, -15.463311455999929],
              [125.02759850400003, -15.466729424999926],
              [125.02711022200003, -15.474786065999922],
              [125.02442467500009, -15.48406340899993],
              [125.02759850400003, -15.49114348799992],
              [125.04981530000009, -15.498223565999922],
              [125.05396569100003, -15.485772393999923],
              [125.05355879000001, -15.465590101999908],
              [125.06169681100005, -15.449639580999929],
              [125.08659915500004, -15.45476653399993],
              [125.15796959700003, -15.50514088299991],
              [125.18523196700005, -15.517836195999905],
              [125.17237389400009, -15.502373955999929],
              [125.13217207100001, -15.471774997999944],
              [125.12370853000004, -15.460137627999927],
              [125.07252037900003, -15.41887786299992],
              [125.07349694100003, -15.40748463299991],
              [125.08961022200003, -15.347263278999947],
              [125.09888756600003, -15.338067315999922],
              [125.11304772200003, -15.329278252999927],
              [125.129242384, -15.32236093499995],
              [125.14429772200003, -15.31926848799992],
              [125.14429772200003, -15.313083591999941],
              [125.12761478000004, -15.31373463299991],
              [125.11443118600005, -15.30868905999995],
              [125.10401451900009, -15.298760674999926],
              [125.09644616000003, -15.28525155999995],
              [125.09050540500004, -15.305108330999929],
              [125.07292728000004, -15.30445728999996],
              [125.05258222700002, -15.293226820999905],
              [125.03809655000009, -15.281426690999922],
              [125.02662194100003, -15.283949476999908],
              [124.98438561300009, -15.31218840899993],
              [124.951508009, -15.323011976999908],
              [124.92888431100005, -15.338148695999905],
              [124.91773522200003, -15.339776299999926],
              [124.906586134, -15.333184502999927],
              [124.90162194100003, -15.32236093499995],
              [124.89714603000004, -15.299411716999941],
              [124.89380944100003, -15.297295830999929],
              [124.88933353000004, -15.298028252999927],
              [124.88526451900009, -15.296807549999926],
              [124.88347415500004, -15.288669528999947],
              [124.88453209700003, -15.280450127999927],
              [124.88746178500003, -15.27548593499995],
              [124.89714603000004, -15.264743747999944],
              [124.90699303500003, -15.257745049999926],
              [124.91871178500003, -15.253024997999944],
              [124.92465254000001, -15.247165622999944],
              [124.91773522200003, -15.237399997999944],
              [124.92465254000001, -15.229261976999908],
              [124.93620853000004, -15.222588799999926],
              [124.94792728000004, -15.217950127999927],
              [124.96558678500003, -15.213067315999922],
              [124.97055097700002, -15.207777601999908],
              [124.97681725400003, -15.207777601999908],
              [124.98991946700005, -15.21998463299991],
              [125.00652103000004, -15.221286716999941],
              [125.025726759, -15.203708591999941],
              [125.05543053500003, -15.162286065999922],
              [125.04672285200002, -15.158379815999922],
              [125.02507571700005, -15.153008721999925],
              [125.01384524800005, -15.148614190999922],
              [125.00586998800009, -15.17750416499996],
              [125.00359134200005, -15.182061455999929],
              [124.99366295700008, -15.18141041499996],
              [124.98633873800009, -15.178480726999908],
              [124.98170006600003, -15.172539971999925],
              [124.97974694100003, -15.162286065999922],
              [124.97388756600003, -15.16806405999995],
              [124.96363366000003, -15.186293226999908],
              [124.96265709700003, -15.190199476999908],
              [124.95492597700002, -15.191827080999929],
              [124.93189537900003, -15.20322030999995],
              [124.88721764400009, -15.239678643999923],
              [124.86988366000003, -15.250420830999929],
              [124.87012780000009, -15.233819268999923],
              [124.87224368600005, -15.22861093499995],
              [124.87671959700003, -15.223728122999944],
              [124.86988366000003, -15.216241143999923],
              [124.86304772200003, -15.229913018999923],
              [124.85621178500003, -15.229913018999923],
              [124.85792076900009, -15.219496351999908],
              [124.85678144600001, -15.19850025799991],
              [124.85621178500003, -15.19508228999996],
              [124.85987389400009, -15.186211846999925],
              [124.86817467500009, -15.174411716999941],
              [124.86988366000003, -15.165948174999926],
              [124.86150149800005, -15.162855726999908],
              [124.84506269600001, -15.16725025799991],
              [124.83423912900003, -15.164727471999925],
              [124.84197024800005, -15.141208591999941],
              [124.84351647200003, -15.14153411299992],
              [124.85621178500003, -15.134942315999922],
              [124.85808353000004, -15.131280205999929],
              [124.86052493600005, -15.11891041499996],
              [124.86304772200003, -15.114434502999927],
              [124.87159264400009, -15.109307549999926],
              [124.88363691500001, -15.10475025799991],
              [124.89665774800005, -15.101495049999926],
              [124.90772545700008, -15.100274346999925],
              [124.91700280000009, -15.10247161299992],
              [124.93067467500009, -15.11223723799992],
              [124.95248457100001, -15.115899346999925],
              [124.95997155000009, -15.119886976999908],
              [124.97291100400003, -15.134942315999922],
              [124.99708092500009, -15.097914320999905],
              [125.01303144600001, -15.084649346999925],
              [125.02125084700003, -15.100274346999925],
              [125.02759850400003, -15.084567966999941],
              [125.03150475400003, -15.061618747999944],
              [125.02784264400009, -15.040948174999926],
              [125.01042728000004, -15.031914971999925],
              [125.01270592500009, -15.023695570999905],
              [125.01197350400003, -15.00514088299991],
              [125.00806725400003, -14.984551690999922],
              [125.00017337300005, -14.97039153399993],
              [125.01343834700003, -14.972100518999923],
              [125.02361087300005, -14.976739190999922],
              [125.04175866000003, -14.990980726999908],
              [125.04802493600005, -14.981866143999923],
              [125.05958092500009, -14.97234465899993],
              [125.07227623800009, -14.96851978999996],
              [125.08204186300009, -14.97665780999995],
              [125.08318118600005, -14.993259372999944],
              [125.06324303500003, -15.013604424999926],
              [125.06169681100005, -15.031914971999925],
              [125.06910241000003, -15.02507903399993],
              [125.07593834700003, -15.05982838299991],
              [125.08741295700008, -15.051202080999929],
              [125.09839928500003, -15.02906666499996],
              [125.11003665500004, -15.02507903399993],
              [125.11036217500009, -15.027520440999922],
              [125.11540774800005, -15.03289153399993],
              [125.12134850400003, -15.037692966999941],
              [125.12370853000004, -15.03875090899993],
              [125.12614993600005, -15.049493096999925],
              [125.12330162900003, -15.055271091999941],
              [125.11898847700002, -15.060479424999926],
              [125.11687259200005, -15.069512627999927],
              [125.13282311300009, -15.107842705999929],
              [125.13404381600003, -15.114434502999927],
              [125.14047285200002, -15.12037525799991],
              [125.15430748800009, -15.150323174999926],
              [125.16529381600003, -15.162286065999922],
              [125.17156009200005, -15.15601978999996],
              [125.16724694100003, -15.149834893999923],
              [125.16627037900003, -15.14185963299991],
              [125.16895592500009, -15.133233330999929],
              [125.17457116000003, -15.124444268999923],
              [125.176117384, -15.116306247999944],
              [125.15886478000004, -15.062758070999905],
              [125.14795983200008, -15.044854424999926],
              [125.14576256600003, -15.028008721999925],
              [125.16529381600003, -15.01140715899993],
              [125.16504967500009, -15.031996351999908],
              [125.17261803500003, -15.044528903999947],
              [125.185883009, -15.050713799999926],
              [125.20191491000003, -15.05242278399993],
              [125.21558678500003, -15.05754973799992],
              [125.22201582100001, -15.067071221999925],
              [125.22974694100003, -15.072686455999929],
              [125.24659264400009, -15.06609465899993],
              [125.24984785200002, -15.07822030999995],
              [125.25570722700002, -15.085056247999944],
              [125.26221764400009, -15.089288018999923],
              [125.28077233200008, -15.107598565999922],
              [125.28174889400009, -15.11337655999995],
              [125.27906334700003, -15.119886976999908],
              [125.27393639400009, -15.128106377999927],
              [125.28825931100005, -15.140557549999926],
              [125.31080162900003, -15.150648695999905],
              [125.32878665500004, -15.152764580999929],
              [125.32911217500009, -15.141208591999941],
              [125.35710696700005, -15.13648853999996],
              [125.41993248800009, -15.14934661299992],
              [125.43213951900009, -15.13795338299991],
              [125.43067467500009, -15.120538018999923],
              [125.42514082100001, -15.11614348799992],
              [125.39405358200008, -15.120700778999947],
              [125.38209069100003, -15.11687590899993],
              [125.37378991000003, -15.107598565999922],
              [125.36939537900003, -15.096449476999908],
              [125.369476759, -15.086521091999941],
              [125.37330162900003, -15.085056247999944],
              [125.38038170700008, -15.08407968499995],
              [125.38746178500003, -15.08180103999996],
              [125.39063561300009, -15.076592705999929],
              [125.38738040500004, -15.06812916499996],
              [125.38013756600003, -15.06609465899993],
              [125.37281334700003, -15.065036716999941],
              [125.369476759, -15.05982838299991],
              [125.36646569100003, -15.051446221999925],
              [125.36939537900003, -15.04778411299992],
              [125.38062584700003, -15.04615650799991],
              [125.38892662900003, -15.042901299999926],
              [125.40577233200008, -15.028415622999944],
              [125.43083743600005, -15.019707940999922],
              [125.42953535200002, -15.00904713299991],
              [125.41749108200008, -15.002211195999905],
              [125.38404381600003, -15.013929945999905],
              [125.36695397200003, -15.008396091999941],
              [125.35450280000009, -14.99391041499996],
              [125.34652754000001, -14.996270440999922],
              [125.33529707100001, -14.99773528399993],
              [125.32992597700002, -14.996270440999922],
              [125.32691491000003, -14.98642343499995],
              [125.32162519600001, -14.98406340899993],
              [125.31714928500003, -14.985121351999908],
              [125.31128991000003, -14.98723723799992],
              [125.30762780000009, -14.989678643999923],
              [125.30860436300009, -14.990980726999908],
              [125.29769941500001, -14.99195728999996],
              [125.28858483200008, -14.994398695999905],
              [125.28093509200005, -14.99342213299991],
              [125.27393639400009, -14.98406340899993],
              [125.27369225400003, -14.976169528999947],
              [125.277679884, -14.967950127999927],
              [125.28760826900009, -14.956231377999927],
              [125.275726759, -14.956963799999926],
              [125.26417076900009, -14.962009372999944],
              [125.25570722700002, -14.96770598799992],
              [125.25342858200008, -14.97039153399993],
              [125.24284915500004, -14.96607838299991],
              [125.23812910200002, -14.95281340899993],
              [125.22925866000003, -14.949965101999908],
              [125.22169030000009, -14.951918226999908],
              [125.21827233200008, -14.955661716999941],
              [125.21412194100003, -14.958103122999944],
              [125.20492597700002, -14.956231377999927],
              [125.19703209700003, -14.952325127999927],
              [125.18677819100003, -14.945489190999922],
              [125.18295332100001, -14.93914153399993],
              [125.19507897200003, -14.936293226999908],
              [125.20427493600005, -14.932061455999929],
              [125.20899498800009, -14.922295830999929],
              [125.21208743600005, -14.912774346999925],
              [125.21583092500009, -14.908379815999922],
              [125.22722415500004, -14.906914971999925],
              [125.24463951900009, -14.90129973799992],
              [125.25342858200008, -14.901543877999927],
              [125.256195509, -14.905450127999927],
              [125.25782311300009, -14.912367445999905],
              [125.26319420700008, -14.919122002999927],
              [125.27735436300009, -14.922051690999922],
              [125.28972415500004, -14.920098565999922],
              [125.29476972700002, -14.914727471999925],
              [125.29395592500009, -14.90601978999996],
              [125.28760826900009, -14.894707940999922],
              [125.30884850400003, -14.885023695999905],
              [125.29761803500003, -14.868340752999927],
              [125.26758873800009, -14.856215101999908],
              [125.23292076900009, -14.860528252999927],
              [125.22771243600005, -14.850192966999941],
              [125.20215905000009, -14.844821872999944],
              [125.19141686300009, -14.832696221999925],
              [125.18873131600003, -14.77939218499995],
              [125.18140709700003, -14.771905205999929],
              [125.16814212300005, -14.776788018999923],
              [125.16089928500003, -14.778415622999944],
              [125.15788821700005, -14.774997653999947],
              [125.15495853000004, -14.762872002999927],
              [125.14820397200003, -14.759698174999926],
              [125.14136803500003, -14.75986093499995],
              [125.13746178500003, -14.75750090899993],
              [125.13599694100003, -14.735935153999947],
              [125.14429772200003, -14.728448174999926],
              [125.156586134, -14.728692315999922],
              [125.16846764400009, -14.73023853999996],
              [125.17750084700003, -14.72747161299992],
              [125.17725670700008, -14.720961195999905],
              [125.17400149800005, -14.713067315999922],
              [125.17457116000003, -14.70598723799992],
              [125.18165123800009, -14.698825778999947],
              [125.18531334700003, -14.698337497999944],
              [125.18873131600003, -14.700778903999947],
              [125.19507897200003, -14.702325127999927],
              [125.21143639400009, -14.70086028399993],
              [125.20134524800005, -14.684991143999923],
              [125.20492597700002, -14.668145440999922],
              [125.21778405000009, -14.66383228999996],
              [125.25310306100005, -14.672946872999944],
              [125.26026451900009, -14.67156340899993],
              [125.26319420700008, -14.653741143999923],
              [125.27149498800009, -14.650811455999929],
              [125.28435306100005, -14.649021091999941],
              [125.30128014400009, -14.634698174999926],
              [125.281586134, -14.62981536299992],
              [125.25806725400003, -14.632745049999926],
              [125.23902428500003, -14.631524346999925],
              [125.23292076900009, -14.61419036299992],
              [125.24366295700008, -14.594170830999929],
              [125.26587975400003, -14.575616143999923],
              [125.29053795700008, -14.56617603999996],
              [125.30860436300009, -14.57317473799992],
              [125.314789259, -14.57317473799992],
              [125.32243899800005, -14.558038018999923],
              [125.32894941500001, -14.55046965899993],
              [125.33350670700008, -14.543145440999922],
              [125.33692467500009, -14.514255466999941],
              [125.34107506600003, -14.503106377999927],
              [125.34766686300009, -14.498711846999925],
              [125.35645592500009, -14.504327080999929],
              [125.35523522200003, -14.570489190999922],
              [125.35222415500004, -14.582777601999908],
              [125.34278405000009, -14.607354424999926],
              [125.35564212300005, -14.587497653999947],
              [125.37370853000004, -14.57390715899993],
              [125.38819420700008, -14.559991143999923],
              [125.39063561300009, -14.53915780999995],
              [125.40430748800009, -14.553155205999929],
              [125.43799889400009, -14.631931247999944],
              [125.43946373800009, -14.638848565999922],
              [125.44068444100003, -14.636651299999926],
              [125.44516035200002, -14.62037525799991],
              [125.43962649800005, -14.598809502999927],
              [125.44263756600003, -14.589288018999923],
              [125.45948326900009, -14.59303150799991],
              [125.45826256600003, -14.581475518999923],
              [125.45997155000009, -14.570489190999922],
              [125.46485436300009, -14.560723565999922],
              [125.47315514400009, -14.55282968499995],
              [125.46615644600001, -14.54810963299991],
              [125.46290123800009, -14.541761976999908],
              [125.46290123800009, -14.533949476999908],
              [125.46631920700008, -14.524834893999923],
              [125.49366295700008, -14.545342705999929],
              [125.48715254000001, -14.517510674999926],
              [125.48658287900003, -14.503024997999944],
              [125.49366295700008, -14.490655205999929],
              [125.50131269600001, -14.486260674999926],
              [125.50928795700008, -14.485772393999923],
              [125.51693769600001, -14.488457940999922],
              [125.52442467500009, -14.494073174999926],
              [125.53248131600003, -14.49773528399993],
              [125.55054772200003, -14.496514580999929],
              [125.555023634, -14.497491143999923],
              [125.55543053500003, -14.513848565999922],
              [125.54468834700003, -14.52743905999995],
              [125.53223717500009, -14.53801848799992],
              [125.52784264400009, -14.545342705999929],
              [125.53956139400009, -14.553317966999941],
              [125.55779056100005, -14.55396900799991],
              [125.57618248800009, -14.550388278999947],
              [125.58920332100001, -14.545342705999929],
              [125.58399498800009, -14.534763278999947],
              [125.58383222700002, -14.526543877999927],
              [125.58920332100001, -14.511163018999923],
              [125.59115644600001, -14.510511976999908],
              [125.59571373800009, -14.510430596999925],
              [125.60035241000003, -14.508884372999944],
              [125.60352623800009, -14.504327080999929],
              [125.60328209700003, -14.499607028999947],
              [125.597992384, -14.493584893999923],
              [125.59669030000009, -14.48723723799992],
              [125.60572350400003, -14.433200778999947],
              [125.61500084700003, -14.410088799999926],
              [125.61719811300009, -14.40129973799992],
              [125.61060631600003, -14.38445403399993],
              [125.59766686300009, -14.36728280999995],
              [125.58838951900009, -14.351006768999923],
              [125.59302819100003, -14.336521091999941],
              [125.59205162900003, -14.32626718499995],
              [125.58643639400009, -14.308038018999923],
              [125.58497155000009, -14.287692966999941],
              [125.59669030000009, -14.270928643999923],
              [125.59669030000009, -14.264825127999927],
              [125.58545983200008, -14.25562916499996],
              [125.58562259200005, -14.245700778999947],
              [125.59457441500001, -14.23992278399993],
              [125.61036217500009, -14.243584893999923],
              [125.605804884, -14.229261976999908],
              [125.61817467500009, -14.223728122999944],
              [125.63526451900009, -14.231540622999944],
              [125.64437910200002, -14.257256768999923],
              [125.65186608200008, -14.257256768999923],
              [125.65186608200008, -14.250420830999929],
              [125.65805097700002, -14.250420830999929],
              [125.66529381600003, -14.264255466999941],
              [125.69361412900003, -14.279880466999941],
              [125.70655358200008, -14.291436455999929],
              [125.70875084700003, -14.283461195999905],
              [125.71273847700002, -14.27662525799991],
              [125.71876061300009, -14.270684502999927],
              [125.72706139400009, -14.264825127999927],
              [125.73316491000003, -14.270928643999923],
              [125.72657311300009, -14.279473565999922],
              [125.71273847700002, -14.305108330999929],
              [125.71941165500004, -14.313897393999923],
              [125.71843509200005, -14.32431405999995],
              [125.71094811300009, -14.33367278399993],
              [125.69906660200002, -14.33993905999995],
              [125.68873131600003, -14.33766041499996],
              [125.68140709700003, -14.330010674999926],
              [125.67261803500003, -14.32545338299991],
              [125.65805097700002, -14.333103122999944],
              [125.66358483200008, -14.34107838299991],
              [125.66285241000003, -14.348402601999908],
              [125.65967858200008, -14.354913018999923],
              [125.65805097700002, -14.36028411299992],
              [125.67261803500003, -14.45826588299991],
              [125.681976759, -14.47356536299992],
              [125.68433678500003, -14.50676848799992],
              [125.63697350400003, -14.598077080999929],
              [125.63770592500009, -14.634698174999926],
              [125.65235436300009, -14.622247002999927],
              [125.69605553500003, -14.504327080999929],
              [125.70573978000004, -14.494317315999922],
              [125.71070397200003, -14.470879815999922],
              [125.71273847700002, -14.42587655999995],
              [125.71957441500001, -14.400974216999941],
              [125.73292076900009, -14.39853280999995],
              [125.74105879000001, -14.410414320999905],
              [125.73316491000003, -14.429294528999947],
              [125.74341881600003, -14.434991143999923],
              [125.74415123800009, -14.444756768999923],
              [125.73316491000003, -14.470147393999923],
              [125.76823978000004, -14.463555596999925],
              [125.78223717500009, -14.457452080999929],
              [125.78785241000003, -14.445977471999925],
              [125.79102623800009, -14.43718840899993],
              [125.79810631600003, -14.43482838299991],
              [125.80518639400009, -14.437920830999929],
              [125.80836022200003, -14.445977471999925],
              [125.80632571700005, -14.45322030999995],
              [125.80355879000001, -14.456963799999926],
              [125.80518639400009, -14.459567966999941],
              [125.81576582100001, -14.463311455999929],
              [125.82211347700002, -14.461195570999905],
              [125.82740319100003, -14.454278252999927],
              [125.83350670700008, -14.44817473799992],
              [125.84253991000003, -14.449151299999926],
              [125.849945509, -14.457614841999941],
              [125.84896894600001, -14.466729424999926],
              [125.842133009, -14.474053643999923],
              [125.83253014400009, -14.476983330999929],
              [125.81723066500001, -14.484307549999926],
              [125.83301842500009, -14.519463799999926],
              [125.82203209700003, -14.531670830999929],
              [125.82203209700003, -14.53915780999995],
              [125.83725019600001, -14.545098565999922],
              [125.83716881600003, -14.55282968499995],
              [125.83106530000009, -14.562107028999947],
              [125.82886803500003, -14.57317473799992],
              [125.83301842500009, -14.584567966999941],
              [125.83985436300009, -14.594821872999944],
              [125.847992384, -14.601006768999923],
              [125.85670006600003, -14.60051848799992],
              [125.88965905000009, -14.626885674999926],
              [125.90943444100003, -14.639418226999908],
              [125.91814212300005, -14.637790622999944],
              [125.92505944100003, -14.596856377999927],
              [125.92310631600003, -14.59148528399993],
              [125.91863040500004, -14.58570728999996],
              [125.90821373800009, -14.576348565999922],
              [125.90381920700008, -14.569512627999927],
              [125.90560957100001, -14.56414153399993],
              [125.90984134200005, -14.560479424999926],
              [125.91187584700003, -14.559014580999929],
              [125.91602623800009, -14.537530205999929],
              [125.92009524800005, -14.525974216999941],
              [125.92505944100003, -14.518649997999944],
              [125.95964603000004, -14.519789320999905],
              [125.96599368600005, -14.521661065999922],
              [125.96810957100001, -14.526462497999944],
              [125.97901451900009, -14.54192473799992],
              [125.98340905000009, -14.545342705999929],
              [125.99781334700003, -14.54111093499995],
              [125.99927819100003, -14.53093840899993],
              [125.99708092500009, -14.51962655999995],
              [126.00074303500003, -14.511163018999923],
              [126.01124108200008, -14.509698174999926],
              [126.02670332100001, -14.519952080999929],
              [126.03492272200003, -14.518649997999944],
              [126.04127037900003, -14.50872161299992],
              [126.04053795700008, -14.497491143999923],
              [126.03695722700002, -14.485528252999927],
              [126.03492272200003, -14.47356536299992],
              [126.03174889400009, -14.46257903399993],
              [126.01758873800009, -14.447686455999929],
              [126.01441491000003, -14.43914153399993],
              [126.01286868600005, -14.424411716999941],
              [126.00847415500004, -14.419122002999927],
              [126.00180097700002, -14.416273695999905],
              [125.99390709700003, -14.408786716999941],
              [125.98845462300005, -14.404554945999905],
              [125.98210696700005, -14.400811455999929],
              [125.97828209700003, -14.39381275799991],
              [125.98023522200003, -14.380791924999926],
              [125.98568769600001, -14.38290780999995],
              [125.99968509200005, -14.377699476999908],
              [126.01172936300009, -14.37078215899993],
              [126.01099694100003, -14.367120049999926],
              [126.01677493600005, -14.36492278399993],
              [126.03492272200003, -14.355645440999922],
              [126.060883009, -14.350030205999929],
              [126.06446373800009, -14.34156666499996],
              [126.06267337300005, -14.330498955999929],
              [126.06226647200003, -14.319431247999944],
              [126.06568444100003, -14.311700127999927],
              [126.07422936300009, -14.30282968499995],
              [126.07585696700005, -14.295098565999922],
              [126.07374108200008, -14.28679778399993],
              [126.06430097700002, -14.27044036299992],
              [126.06226647200003, -14.26100025799991],
              [126.06153405000009, -14.24781666499996],
              [126.06299889400009, -14.23560963299991],
              [126.07178795700008, -14.22665780999995],
              [126.10206139400009, -14.22242603999996],
              [126.10816491000003, -14.22079843499995],
              [126.11670983200008, -14.216403903999947],
              [126.14128665500004, -14.195489190999922],
              [126.14478600400003, -14.195245049999926],
              [126.14633222700002, -14.176934502999927],
              [126.14185631600003, -14.158461195999905],
              [126.14039147200003, -14.142998955999929],
              [126.15162194100003, -14.13372161299992],
              [126.13445071700005, -14.094903252999927],
              [126.10710696700005, -14.079522393999923],
              [126.00660241000003, -14.07822030999995],
              [125.99244225400003, -14.071465752999927],
              [125.98650149800005, -14.05559661299992],
              [125.98422285200002, -14.045668226999908],
              [125.974945509, -14.03093840899993],
              [125.97282962300005, -14.021416924999926],
              [125.97388756600003, -14.01344166499996],
              [125.97901451900009, -14.00090911299992],
              [125.98023522200003, -13.990411065999922],
              [125.99236087300005, -13.99968840899993],
              [126.01002037900003, -14.026055596999925],
              [126.02051842500009, -14.031914971999925],
              [126.03386478000004, -14.028497002999927],
              [126.03516686300009, -14.018243096999925],
              [126.03296959700003, -14.004327080999929],
              [126.03492272200003, -13.990411065999922],
              [126.04737389400009, -13.98406340899993],
              [126.07406660200002, -14.026055596999925],
              [126.09636478000004, -14.02507903399993],
              [126.09156334700003, -14.01685963299991],
              [126.09099368600005, -14.00709400799991],
              [126.09148196700005, -13.996026299999926],
              [126.09009850400003, -13.983575127999927],
              [126.08594811300009, -13.969414971999925],
              [126.08187910200002, -13.96453215899993],
              [126.07504316500001, -13.962334893999923],
              [126.03589928500003, -13.94231536299992],
              [126.02800540500004, -13.935804945999905],
              [126.01734459700003, -13.922051690999922],
              [126.02027428500003, -13.920586846999925],
              [126.03142337300005, -13.92473723799992],
              [126.06006920700008, -13.931817315999922],
              [126.06641686300009, -13.927666924999926],
              [126.06910241000003, -13.911553643999923],
              [126.07447350400003, -13.899102471999925],
              [126.08643639400009, -13.889418226999908],
              [126.09839928500003, -13.887383721999925],
              [126.10377037900003, -13.897637627999927],
              [126.09937584700003, -13.909274997999944],
              [126.092133009, -13.91887786299992],
              [126.09156334700003, -13.925388278999947],
              [126.12012780000009, -13.92945728999996],
              [126.129242384, -13.932061455999929],
              [126.13843834700003, -13.93092213299991],
              [126.15162194100003, -13.922133070999905],
              [126.14958743600005, -13.932793877999927],
              [126.14429772200003, -13.941338799999926],
              [126.13038170700008, -13.956231377999927],
              [126.13607832100001, -13.957777601999908],
              [126.14576256600003, -13.96184661299992],
              [126.15162194100003, -13.963067315999922],
              [126.15162194100003, -13.969903252999927],
              [126.13697350400003, -13.97584400799991],
              [126.12476647200003, -13.987074476999908],
              [126.115570509, -14.00172291499996],
              [126.11060631600003, -14.017754815999922],
              [126.12842858200008, -14.012139580999929],
              [126.14323978000004, -14.002536716999941],
              [126.17212975400003, -13.977308851999908],
              [126.18165123800009, -13.97079843499995],
              [126.19239342500009, -13.965508721999925],
              [126.22046959700003, -13.956231377999927],
              [126.20964603000004, -13.976820570999905],
              [126.17839603000004, -13.99537525799991],
              [126.16586347700002, -14.010918877999927],
              [126.19239342500009, -14.014418226999908],
              [126.21070397200003, -14.02662525799991],
              [126.21420332100001, -14.039646091999941],
              [126.19629967500009, -14.045668226999908],
              [126.16911868600005, -14.049004815999922],
              [126.16488691500001, -14.057793877999927],
              [126.16871178500003, -14.070570570999905],
              [126.16586347700002, -14.085381768999923],
              [126.19825280000009, -14.07781340899993],
              [126.21225019600001, -14.081475518999923],
              [126.21363366000003, -14.09970468499995],
              [126.18751061300009, -14.122491143999923],
              [126.18034915500004, -14.133233330999929],
              [126.19996178500003, -14.126885674999926],
              [126.19109134200005, -14.159600518999923],
              [126.21452884200005, -14.17546965899993],
              [126.24146569100003, -14.185153903999947],
              [126.24398847700002, -14.19890715899993],
              [126.23731530000009, -14.20281340899993],
              [126.23178144600001, -14.20322030999995],
              [126.22803795700008, -14.20484791499996],
              [126.22657311300009, -14.21298593499995],
              [126.22974694100003, -14.21493905999995],
              [126.24366295700008, -14.22161223799992],
              [126.24773196700005, -14.223239841999941],
              [126.25928795700008, -14.217054945999905],
              [126.27149498800009, -14.20826588299991],
              [126.28207441500001, -14.208591403999947],
              [126.28882897200003, -14.230075778999947],
              [126.29558353000004, -14.230075778999947],
              [126.29761803500003, -14.214288018999923],
              [126.30201256600003, -14.20126718499995],
              [126.31080162900003, -14.19231536299992],
              [126.34506269600001, -14.184665622999944],
              [126.34546959700003, -14.174248955999929],
              [126.33594811300009, -14.161553643999923],
              [126.31934655000009, -14.145114841999941],
              [126.31373131600003, -14.14185963299991],
              [126.30730228000004, -14.140801690999922],
              [126.29867597700002, -14.140557549999926],
              [126.29371178500003, -14.13648853999996],
              [126.29802493600005, -14.127373955999929],
              [126.30925540500004, -14.11337655999995],
              [126.31226647200003, -14.096774997999944],
              [126.31592858200008, -14.08684661299992],
              [126.324554884, -14.08017343499995],
              [126.34327233200008, -14.072930596999925],
              [126.33855228000004, -14.06959400799991],
              [126.33350670700008, -14.063083591999941],
              [126.32911217500009, -14.059258721999925],
              [126.34359785200002, -14.045505466999941],
              [126.361664259, -14.045342705999929],
              [126.37720787900003, -14.04265715899993],
              [126.39031009200005, -14.005059502999927],
              [126.42164147200003, -13.982354424999926],
              [126.43213951900009, -13.969903252999927],
              [126.44996178500003, -13.991794528999947],
              [126.46998131600003, -13.99195728999996],
              [126.48812910200002, -13.97942473799992],
              [126.50098717500009, -13.963067315999922],
              [126.51693769600001, -13.937432549999926],
              [126.52751712300005, -13.92896900799991],
              [126.54184004000001, -13.932386976999908],
              [126.56918379000001, -13.941989841999941],
              [126.55583743600005, -13.945977471999925],
              [126.54004967500009, -13.953708591999941],
              [126.52686608200008, -13.963474216999941],
              [126.52149498800009, -13.97356536299992],
              [126.51905358200008, -13.98365650799991],
              [126.51319420700008, -13.988539320999905],
              [126.50635826900009, -13.991794528999947],
              [126.50098717500009, -13.997247002999927],
              [126.49634850400003, -14.023614190999922],
              [126.49366295700008, -14.031914971999925],
              [126.46501712300005, -14.05982838299991],
              [126.45329837300005, -14.077569268999923],
              [126.46273847700002, -14.085381768999923],
              [126.48340905000009, -14.081475518999923],
              [126.515961134, -14.069105726999908],
              [126.527679884, -14.072930596999925],
              [126.49366295700008, -14.11337655999995],
              [126.50180097700002, -14.120293877999927],
              [126.51392662900003, -14.141371351999908],
              [126.52149498800009, -14.14739348799992],
              [126.53614342500009, -14.14617278399993],
              [126.54835045700008, -14.139418226999908],
              [126.55884850400003, -14.134942315999922],
              [126.56918379000001, -14.140557549999926],
              [126.57203209700003, -14.15162525799991],
              [126.568695509, -14.182793877999927],
              [126.56918379000001, -14.195245049999926],
              [126.57593834700003, -14.20989348799992],
              [126.58285566500001, -14.214043877999927],
              [126.59156334700003, -14.217461846999925],
              [126.60352623800009, -14.230075778999947],
              [126.60328209700003, -14.201104424999926],
              [126.60531660200002, -14.18726978999996],
              [126.61085045700008, -14.175388278999947],
              [126.62086022200003, -14.16920338299991],
              [126.63453209700003, -14.16497161299992],
              [126.64673912900003, -14.158135674999926],
              [126.65186608200008, -14.143975518999923],
              [126.64991295700008, -14.13258228999996],
              [126.64698326900009, -14.123304945999905],
              [126.64730879000001, -14.11419036299992],
              [126.65528405000009, -14.103122653999947],
              [126.65699303500003, -14.095310153999947],
              [126.65170332100001, -14.08717213299991],
              [126.64722741000003, -14.07781340899993],
              [126.65186608200008, -14.06609465899993],
              [126.65870201900009, -14.071384372999944],
              [126.67359459700003, -14.080336195999905],
              [126.67904707100001, -14.085381768999923],
              [126.68336022200003, -14.094821872999944],
              [126.68799889400009, -14.11532968499995],
              [126.69271894600001, -14.12078215899993],
              [126.70484459700003, -14.11809661299992],
              [126.72038821700005, -14.086114190999922],
              [126.73373457100001, -14.072930596999925],
              [126.72681725400003, -14.05836353999996],
              [126.73389733200008, -14.044854424999926],
              [126.74439537900003, -14.029880466999941],
              [126.74740644600001, -14.010918877999927],
              [126.74122155000009, -14.010918877999927],
              [126.73715254000001, -14.017754815999922],
              [126.73194420700008, -14.02271900799991],
              [126.72022545700008, -14.031914971999925],
              [126.70850670700008, -14.020684502999927],
              [126.70118248800009, -14.00709400799991],
              [126.70004316500001, -13.99382903399993],
              [126.70720462300005, -13.983575127999927],
              [126.713226759, -13.98333098799992],
              [126.73414147200003, -13.989841403999947],
              [126.74740644600001, -13.990411065999922],
              [126.75123131600003, -13.980726820999905],
              [126.76172936300009, -13.969903252999927],
              [126.77426191500001, -13.97470468499995],
              [126.78825931100005, -13.972588799999926],
              [126.78891035200002, -13.969903252999927],
              [126.81657962300005, -13.982354424999926],
              [126.82976321700005, -13.982598565999922],
              [126.84302819100003, -13.969903252999927],
              [126.82406660200002, -13.963311455999929],
              [126.81324303500003, -13.956963799999926],
              [126.81006920700008, -13.949395440999922],
              [126.81820722700002, -13.94264088299991],
              [126.83106530000009, -13.94345468499995],
              [126.85726972700002, -13.949395440999922],
              [126.85157311300009, -13.939385674999926],
              [126.84473717500009, -13.932712497999944],
              [126.83472741000003, -13.928887627999927],
              [126.81983483200008, -13.927666924999926],
              [126.80787194100003, -13.92351653399993],
              [126.80054772200003, -13.912855726999908],
              [126.79688561300009, -13.898695570999905],
              [126.79574629000001, -13.883965752999927],
              [126.79200280000009, -13.877129815999922],
              [126.77369225400003, -13.85515715899993],
              [126.76783287900003, -13.846368096999925],
              [126.75554446700005, -13.804945570999905],
              [126.74740644600001, -13.791761976999908],
              [126.76465905000009, -13.79078541499996],
              [126.78541100400003, -13.787367445999905],
              [126.80290774800005, -13.780043226999908],
              [126.81006920700008, -13.76767343499995],
              [126.81446373800009, -13.768324476999908],
              [126.82276451900009, -13.776462497999944],
              [126.82789147200003, -13.79111093499995],
              [126.82325280000009, -13.81226978999996],
              [126.83277428500003, -13.81609465899993],
              [126.84302819100003, -13.818536065999922],
              [126.84587649800005, -13.80754973799992],
              [126.85328209700003, -13.800957940999922],
              [126.86410566500001, -13.798028252999927],
              [126.87720787900003, -13.798028252999927],
              [126.87720787900003, -13.791761976999908],
              [126.85962975400003, -13.78289153399993],
              [126.84644616000003, -13.768975518999923],
              [126.84538821700005, -13.754327080999929],
              [126.86353600400003, -13.743340752999927],
              [126.88184655000009, -13.74578215899993],
              [126.89779707100001, -13.756442966999941],
              [126.91374759200005, -13.763929945999905],
              [126.93238366000003, -13.75758228999996],
              [126.91285241000003, -13.74578215899993],
              [126.90503991000003, -13.743340752999927],
              [126.91553795700008, -13.735935153999947],
              [126.92774498800009, -13.730889580999929],
              [126.95289147200003, -13.72356536299992],
              [126.97820071700005, -13.75400155999995],
              [126.99317467500009, -13.766289971999925],
              [127.01124108200008, -13.77125416499996],
              [127.02003014400009, -13.777764580999929],
              [127.02173912900003, -13.793226820999905],
              [127.02116946700005, -13.82594166499996],
              [127.03760826900009, -13.81617603999996],
              [127.05062910200002, -13.81340911299992],
              [127.05591881600003, -13.82008228999996],
              [127.04908287900003, -13.83953215899993],
              [127.07016035200002, -13.828057549999926],
              [127.07211347700002, -13.842543226999908],
              [127.06413821700005, -13.867771091999941],
              [127.05534915500004, -13.887383721999925],
              [127.08513431100005, -13.883884372999944],
              [127.09351647200003, -13.90007903399993],
              [127.09571373800009, -13.926364841999941],
              [127.10743248800009, -13.95281340899993],
              [127.12973066500001, -13.96770598799992],
              [127.14258873800009, -13.956231377999927],
              [127.15406334700003, -13.933770440999922],
              [127.17261803500003, -13.915215752999927],
              [127.16358483200008, -13.910821221999925],
              [127.15935306100005, -13.902764580999929],
              [127.15967858200008, -13.892185153999947],
              [127.16521243600005, -13.88054778399993],
              [127.18140709700003, -13.89031340899993],
              [127.18726647200003, -13.901788018999923],
              [127.18628991000003, -13.931817315999922],
              [127.18930097700002, -13.94695403399993],
              [127.19695071700005, -13.94931405999995],
              [127.20590254000001, -13.943617445999905],
              [127.21363366000003, -13.935804945999905],
              [127.22632897200003, -13.904473565999922],
              [127.23682701900009, -13.892022393999923],
              [127.25131269600001, -13.897637627999927],
              [127.28793379000001, -13.938246351999908],
              [127.30298912900003, -13.949395440999922],
              [127.33269290500004, -13.961195570999905],
              [127.33122806100005, -13.944024346999925],
              [127.32243899800005, -13.917413018999923],
              [127.33025149800005, -13.901055596999925],
              [127.34424889400009, -13.904473565999922],
              [127.35328209700003, -13.916680596999925],
              [127.36036217500009, -13.92978280999995],
              [127.36768639400009, -13.935804945999905],
              [127.38152103000004, -13.937758070999905],
              [127.38949629000001, -13.943536065999922],
              [127.39429772200003, -13.952243747999944],
              [127.39861087300005, -13.963067315999922],
              [127.40479576900009, -13.963067315999922],
              [127.40707441500001, -13.95712655999995],
              [127.41846764400009, -13.941989841999941],
              [127.43043053500003, -13.953871351999908],
              [127.44076582100001, -13.969414971999925],
              [127.44849694100003, -13.986911716999941],
              [127.45248457100001, -14.004082940999922],
              [127.45215905000009, -14.013848565999922],
              [127.44629967500009, -14.048760674999926],
              [127.45020592500009, -14.057305596999925],
              [127.47046959700003, -14.069919528999947],
              [127.48047936300009, -14.079196872999944],
              [127.48926842500009, -14.05836353999996],
              [127.504242384, -14.065606377999927],
              [127.52027428500003, -14.083103122999944],
              [127.53199303500003, -14.092868747999944],
              [127.54712975400003, -14.097914320999905],
              [127.57496178500003, -14.123304945999905],
              [127.59034264400009, -14.13372161299992],
              [127.59506269600001, -14.134372653999947],
              [127.60613040500004, -14.132989190999922],
              [127.61085045700008, -14.13372161299992],
              [127.61524498800009, -14.137139580999929],
              [127.62452233200008, -14.14739348799992],
              [127.66602623800009, -14.178399346999925],
              [127.67074629000001, -14.197198174999926],
              [127.68262780000009, -14.216973565999922],
              [127.69825280000009, -14.235446872999944],
              [127.75586998800009, -14.28484465899993],
              [127.76156660200002, -14.295098565999922],
              [127.78956139400009, -14.367120049999926],
              [127.79672285200002, -14.37086353999996],
              [127.81592858200008, -14.374932549999926],
              [127.82357832100001, -14.380791924999926],
              [127.82585696700005, -14.38958098799992],
              [127.82357832100001, -14.42587655999995],
              [127.82691491000003, -14.436618747999944],
              [127.83399498800009, -14.442559502999927],
              [127.84107506600003, -14.443536065999922],
              [127.84424889400009, -14.43914153399993],
              [127.84595787900003, -14.42587655999995],
              [127.85108483200008, -14.41725025799991],
              [127.85987389400009, -14.415459893999923],
              [127.871429884, -14.422458591999941],
              [127.87940514400009, -14.43954843499995],
              [127.85523522200003, -14.465101820999905],
              [127.85792076900009, -14.483819268999923],
              [127.87427819100003, -14.469903252999927],
              [127.88721764400009, -14.474053643999923],
              [127.90560957100001, -14.497491143999923],
              [127.94019616000003, -14.518975518999923],
              [127.95476321700005, -14.53289153399993],
              [127.94385826900009, -14.53915780999995],
              [127.93946373800009, -14.54387786299992],
              [127.93995201900009, -14.55445728999996],
              [127.94320722700002, -14.566013278999947],
              [127.94727623800009, -14.57317473799992],
              [127.95753014400009, -14.578871351999908],
              [127.96697024800005, -14.578545830999929],
              [127.99244225400003, -14.568617445999905],
              [127.99878991000003, -14.56226978999996],
              [128.00538170700008, -14.560723565999922],
              [128.0185653000001, -14.569756768999923],
              [128.0415145190001, -14.590427341999941],
              [128.04656009200005, -14.59303150799991],
              [128.054047071, -14.60051848799992],
              [128.05933678500003, -14.61695728999996],
              [128.0664168630001, -14.633477471999925],
              [128.08033287900003, -14.640801690999922],
              [128.09595787900003, -14.641289971999925],
              [128.10694420700008, -14.643731377999927],
              [128.11784915500004, -14.649997653999947],
              [128.1591903000001, -14.68840911299992],
              [128.17530358200008, -14.698418877999927],
              [128.19678795700008, -14.702325127999927],
              [128.20866946700005, -14.700778903999947],
              [128.21469160200002, -14.69890715899993],
              [128.21949303500003, -14.70045338299991],
              [128.22779381600003, -14.709730726999908],
              [128.231293165, -14.718194268999923],
              [128.23194420700008, -14.727959893999923],
              [128.2304793630001, -14.73723723799992],
              [128.22779381600003, -14.74391041499996],
              [128.21363366000003, -14.734958591999941],
              [128.1977645190001, -14.731622002999927],
              [128.18482506600003, -14.736993096999925],
              [128.17945397200003, -14.754082940999922],
              [128.18140709700003, -14.769952080999929],
              [128.19361412900003, -14.80592213299991],
              [128.1943465500001, -14.82195403399993],
              [128.19060306100005, -14.82984791499996],
              [128.1806746750001, -14.832452080999929],
              [128.16228274800005, -14.832696221999925],
              [128.1489363940001, -14.834242445999905],
              [128.13835696700005, -14.83879973799992],
              [128.11793053500003, -14.853773695999905],
              [128.13746178500003, -14.86256275799991],
              [128.1328231130001, -14.895196221999925],
              [128.11109459700003, -14.95989348799992],
              [128.10824629, -14.972832940999922],
              [128.09498131600003, -14.997247002999927],
              [128.09058678500003, -15.01140715899993],
              [128.090179884, -15.031182549999926],
              [128.09197024800005, -15.04664478999996],
              [128.0903426440001, -15.060804945999905],
              [128.07309004, -15.08912525799991],
              [128.06853274800005, -15.106622002999927],
              [128.06706790500004, -15.125176690999922],
              [128.06959069100003, -15.141208591999941],
              [128.08122806100005, -15.162692966999941],
              [128.08464603000004, -15.174574476999908],
              [128.07569420700008, -15.277764580999929],
              [128.07056725400003, -15.287692966999941],
              [128.06023196700005, -15.292168877999927],
              [128.04273522200003, -15.29192473799992],
              [128.0712996750001, -15.367933851999908],
              [128.0722762380001, -15.404473565999922],
              [128.05591881600003, -15.44345468499995],
              [128.02027428500003, -15.478448174999926],
              [128.01490319100003, -15.487481377999927],
              [128.024261915, -15.496514580999929],
              [128.04558353000004, -15.48756275799991],
              [128.068695509, -15.470961195999905],
              [128.08375084700003, -15.45712655999995],
              [128.10132897200003, -15.424574476999908],
              [128.11280358200008, -15.38176848799992],
              [128.11841881600003, -15.335137627999927],
              [128.11793053500003, -15.29192473799992],
              [128.1005965500001, -15.229913018999923],
              [128.11060631600003, -15.224867445999905],
              [128.11117597700002, -15.213148695999905],
              [128.10914147200003, -15.199965101999908],
              [128.11109459700003, -15.190199476999908],
              [128.12517337300005, -15.182061455999929],
              [128.13453209700003, -15.187676690999922],
              [128.14332116000003, -15.197849216999941],
              [128.17448978000004, -15.213311455999929],
              [128.22445722700002, -15.260186455999929],
              [128.23462975400003, -15.274590752999927],
              [128.23812910200002, -15.281996351999908],
              [128.25562584700003, -15.31023528399993],
              [128.2802840500001, -15.383558851999908],
              [128.28305097700002, -15.401788018999923],
              [128.28931725400003, -15.401788018999923],
              [128.29664147200003, -15.31617603999996],
              [128.29175866000003, -15.29070403399993],
              [128.278656446, -15.271661065999922],
              [128.24146569100003, -15.237399997999944],
              [128.2304793630001, -15.224053643999923],
              [128.22022545700008, -15.205661716999941],
              [128.21631920700008, -15.18523528399993],
              [128.22437584700003, -15.165948174999926],
              [128.22584069100003, -15.16025155999995],
              [128.21827233200008, -15.11809661299992],
              [128.21216881600003, -15.11101653399993],
              [128.20525149800005, -15.10637786299992],
              [128.19988040500004, -15.100274346999925],
              [128.1958113940001, -15.056817315999922],
              [128.2158309250001, -15.021905205999929],
              [128.26872806100005, -14.97039153399993],
              [128.27165774800005, -14.96851978999996],
              [128.27947024800005, -14.96648528399993],
              [128.28305097700002, -14.963636976999908],
              [128.28394616000003, -14.95907968499995],
              [128.2822371750001, -14.947198174999926],
              [128.28305097700002, -14.942559502999927],
              [128.29517662900003, -14.924981377999927],
              [128.3134871750001, -14.904961846999925],
              [128.32300866000003, -14.910739841999941],
              [128.33025149800005, -14.936293226999908],
              [128.3427840500001, -15.021091403999947],
              [128.3501082690001, -15.037286065999922],
              [128.36491946700005, -15.04615650799991],
              [128.35914147200003, -15.014092705999929],
              [128.3584090500001, -14.999118747999944],
              [128.36491946700005, -14.98406340899993],
              [128.3994246750001, -15.023858330999929],
              [128.4179793630001, -15.039727471999925],
              [128.44410241000003, -15.04615650799991],
              [128.4502059250001, -15.04265715899993],
              [128.45582116000003, -15.03411223799992],
              [128.45972741000003, -15.023695570999905],
              [128.46119225400003, -15.014825127999927],
              [128.45980879, -15.00164153399993],
              [128.45679772200003, -14.99504973799992],
              [128.45240319100003, -14.990492445999905],
              [128.44752037900003, -14.98406340899993],
              [128.4228621750001, -14.940118096999925],
              [128.417328321, -14.91578541499996],
              [128.40805097700002, -14.895277601999908],
              [128.40601647200003, -14.88445403399993],
              [128.40748131600003, -14.86882903399993],
              [128.41195722700002, -14.865655205999929],
              [128.41871178500003, -14.865899346999925],
              [128.42701256600003, -14.860528252999927],
              [128.4336043630001, -14.85523853999996],
              [128.43824303500003, -14.85328541499996],
              [128.43897545700008, -14.849867445999905],
              [128.43327884200005, -14.840101820999905],
              [128.42741946700005, -14.835056247999944],
              [128.41032962300005, -14.828301690999922],
              [128.40259850400003, -14.823011976999908],
              [128.38843834700003, -14.803399346999925],
              [128.39576256600003, -14.795993747999944],
              [128.44068444100003, -14.79225025799991],
              [128.479828321, -14.779473565999922],
              [128.49927819100003, -14.770114841999941],
              [128.51246178500003, -14.760918877999927],
              [128.53239993600005, -14.75286223799992],
              [128.55420983200008, -14.75872161299992],
              [128.5908309250001, -14.778008721999925],
              [128.67554772200003, -14.787774346999925],
              [128.7133895190001, -14.797539971999925],
              [128.7485457690001, -14.826429945999905],
              [128.76710045700008, -14.821709893999923],
              [128.7900496750001, -14.82708098799992],
              [128.81373131600003, -14.83562590899993],
              [128.83415774800005, -14.840101820999905],
              [128.91976972700002, -14.840101820999905],
              [128.94027754, -14.846123955999929],
              [128.973480665, -14.863702080999929],
              [128.99187259200005, -14.867364190999922],
              [129.0097762380001, -14.869073174999926],
              [129.05103600400003, -14.88014088299991],
              [129.09205162900003, -14.89820728999996],
              [129.10230553500003, -14.905368747999944],
              [129.11158287900003, -14.91578541499996],
              [129.11548912900003, -14.926364841999941],
              [129.11703535200002, -14.937432549999926],
              [129.12029056100005, -14.946384372999944],
              [129.12867272200003, -14.949965101999908],
              [129.15503991000003, -14.953789971999925],
              [129.173187696, -14.964776299999926],
              [129.183929884, -14.981866143999923],
              [129.18734785200002, -15.004571221999925],
              [129.18384850400003, -15.021091403999947],
              [129.1777449880001, -15.039483330999929],
              [129.17554772200003, -15.058526299999926],
              [129.183929884, -15.076592705999929],
              [129.19800866000003, -15.098402601999908],
              [129.1992293630001, -15.117364190999922],
              [129.1919051440001, -15.135918877999927],
              [129.17172285200002, -15.173435153999947],
              [129.15259850400003, -15.223728122999944],
              [129.17204837300005, -15.221856377999927],
              [129.19996178500003, -15.167413018999923],
              [129.22144616000003, -15.16969166499996],
              [129.21273847700002, -15.185804945999905],
              [129.20818118600005, -15.204278252999927],
              [129.20826256600003, -15.22234465899993],
              [129.21412194100003, -15.237399997999944],
              [129.24366295700008, -15.11337655999995],
              [129.263031446, -15.107598565999922],
              [129.26335696700005, -15.090590101999908],
              [129.25562584700003, -15.031182549999926],
              [129.25180097700002, -15.018243096999925],
              [129.24333743600005, -15.008233330999929],
              [129.23902428500003, -14.984633070999905],
              [129.235687696, -14.936293226999908],
              [129.222992384, -14.867771091999941],
              [129.22144616000003, -14.84351978999996],
              [129.22877037900003, -14.836602471999925],
              [129.24439537900003, -14.844170830999929],
              [129.25896243600005, -14.86256275799991],
              [129.263031446, -14.887872002999927],
              [129.26929772200003, -14.887872002999927],
              [129.28923587300005, -14.861911716999941],
              [129.32439212300005, -14.862074476999908],
              [129.3579207690001, -14.879571221999925],
              [129.37289472700002, -14.904961846999925],
              [129.4765731130001, -14.933770440999922],
              [129.49586022200003, -14.953057549999926],
              [129.49830162900003, -14.957777601999908],
              [129.51295006600003, -15.007989190999922],
              [129.52515709700003, -15.016696872999944],
              [129.55355879, -15.030368747999944],
              [129.56413821700005, -15.03875090899993],
              [129.57243899800005, -15.05364348799992],
              [129.5844832690001, -15.088067315999922],
              [129.5947371750001, -15.103936455999929],
              [129.5981551440001, -15.117120049999926],
              [129.58757571700005, -15.153090101999908],
              [129.58521569100003, -15.16969166499996],
              [129.6294051440001, -15.139336846999925],
              [129.6455184250001, -15.134942315999922],
              [129.66195722700002, -15.13836028399993],
              [129.66675866000003, -15.14812590899993],
              [129.6665145190001, -15.175957940999922],
              [129.67172285200002, -15.19426848799992],
              [129.67725670700008, -15.199151299999926],
              [129.6972762380001, -15.19508228999996],
              [129.71599368600005, -15.19540780999995],
              [129.7270613940001, -15.193617445999905],
              [129.7309676440001, -15.186293226999908],
              [129.7285262380001, -15.16969166499996],
              [129.7216903000001, -15.159356377999927],
              [129.65902754, -15.08993905999995],
              [129.65202884200005, -15.076918226999908],
              [129.6298934250001, -15.019463799999926],
              [129.61931399800005, -14.957696221999925],
              [129.6118270190001, -14.942559502999927],
              [129.61980228000004, -14.93336353999996],
              [129.63453209700003, -14.90789153399993],
              [129.63990319100003, -14.894707940999922],
              [129.6455184250001, -14.840590101999908],
              [129.64918053500003, -14.832696221999925],
              [129.66480553500003, -14.83603280999995],
              [129.68970787900003, -14.85051848799992],
              [129.7041121750001, -14.853773695999905],
              [129.734711134, -14.853773695999905],
              [129.7695418630001, -14.860528252999927],
              [129.7856551440001, -14.861504815999922],
              [129.80054772200003, -14.859958591999941],
              [129.8247176440001, -14.853773695999905],
              [129.847992384, -14.84189218499995],
              [129.85523522200003, -14.840101820999905],
              [129.86646569100003, -14.839043877999927],
              [129.86980228000004, -14.83603280999995],
              [129.87094160200002, -14.830661716999941],
              [129.8759871750001, -14.823011976999908],
              [129.91968834700003, -14.790215752999927],
              [129.92725670700008, -14.788669528999947],
              [129.93539472700002, -14.783379815999922],
              [129.9536238940001, -14.790134372999944],
              [129.9824324880001, -14.80592213299991],
              [129.98015384200005, -14.780368747999944],
              [129.99333743600005, -14.725030205999929],
              [129.9824324880001, -14.709730726999908],
              [129.97486412900003, -14.740166924999926],
              [129.95525149800005, -14.75562916499996],
              [129.8930770190001, -14.771905205999929],
              [129.79859459700003, -14.816827080999929],
              [129.7627059250001, -14.81959400799991],
              [129.79566491000003, -14.776055596999925],
              [129.7968856130001, -14.764418226999908],
              [129.78858483200008, -14.764255466999941],
              [129.75538170700008, -14.78484465899993],
              [129.73698978000004, -14.79029713299991],
              [129.72413170700008, -14.79070403399993],
              [129.71159915500004, -14.78484465899993],
              [129.6699324880001, -14.753106377999927],
              [129.6650496750001, -14.73992278399993],
              [129.67335045700008, -14.722832940999922],
              [129.65211022200003, -14.71062590899993],
              [129.62720787900003, -14.692478122999944],
              [129.606781446, -14.67156340899993],
              [129.59009850400003, -14.627373955999929],
              [129.58806399800005, -14.613457940999922],
              [129.5947371750001, -14.607354424999926],
              [129.60865319100003, -14.606622002999927],
              [129.6455184250001, -14.60051848799992],
              [129.692718946, -14.602146091999941],
              [129.71762129, -14.595879815999922],
              [129.7285262380001, -14.576348565999922],
              [129.73747806100005, -14.568536065999922],
              [129.777679884, -14.543633721999925],
              [129.789398634, -14.531670830999929],
              [129.7680770190001, -14.532647393999923],
              [129.7431746750001, -14.53997161299992],
              [129.720062696, -14.550713799999926],
              [129.6865340500001, -14.57398853999996],
              [129.667328321, -14.575372002999927],
              [129.62623131600003, -14.566338799999926],
              [129.61597741000003, -14.56568775799991],
              [129.59538821700005, -14.56731536299992],
              [129.58521569100003, -14.566338799999926],
              [129.57992597700002, -14.563571872999944],
              [129.574554884, -14.559014580999929],
              [129.56666100400003, -14.554620049999926],
              [129.55388431100005, -14.55282968499995],
              [129.53532962300005, -14.545342705999929],
              [129.47535241000003, -14.497491143999923],
              [129.4707137380001, -14.496677341999941],
              [129.45964603000004, -14.498223565999922],
              [129.45484459700003, -14.497491143999923],
              [129.45329837300005, -14.494073174999926],
              [129.44906660200002, -14.480645440999922],
              [129.44743899800005, -14.476983330999929],
              [129.44312584700003, -14.475274346999925],
              [129.43043053500003, -14.47193775799991],
              [129.42701256600003, -14.470147393999923],
              [129.42367597700002, -14.463962497999944],
              [129.4199324880001, -14.45094166499996],
              [129.41675866000003, -14.445977471999925],
              [129.36736087300005, -14.418633721999925],
              [129.35808353000004, -14.408786716999941],
              [129.37289472700002, -14.329278252999927],
              [129.37671959700003, -14.323418877999927],
              [129.40308678500003, -14.295098565999922],
              [129.40935306100005, -14.284600518999923],
              [129.41089928500003, -14.273614190999922],
              [129.4111434250001, -14.262383721999925],
              [129.41334069100003, -14.250420830999929],
              [129.4209090500001, -14.23251718499995],
              [129.43034915500004, -14.218926690999922],
              [129.47380618600005, -14.176934502999927],
              [129.48560631600003, -14.161553643999923],
              [129.4931746750001, -14.144463799999926],
              [129.49586022200003, -14.123793226999908],
              [129.49586022200003, -14.08912525799991],
              [129.49333743600005, -14.078545830999929],
              [129.48324629, -14.06023528399993],
              [129.48218834700003, -14.051853122999944],
              [129.488617384, -14.04810963299991],
              [129.50025475400003, -14.055840752999927],
              [129.51482181100005, -14.06145598799992],
              [129.53003991000003, -14.051853122999944],
              [129.53337649800005, -14.06064218499995],
              [129.53532962300005, -14.071872653999947],
              [129.53882897200003, -14.08131275799991],
              [129.54712975400003, -14.085381768999923],
              [129.55974368600005, -14.081475518999923],
              [129.571136915, -14.075372002999927],
              [129.57992597700002, -14.07626718499995],
              [129.58521569100003, -14.092868747999944],
              [129.60466556100005, -14.06617603999996],
              [129.60084069100003, -14.035902601999908],
              [129.5942488940001, -14.010186455999929],
              [129.60572350400003, -13.997247002999927],
              [129.60914147200003, -14.028497002999927],
              [129.63257897200003, -14.03525155999995],
              [129.6904403000001, -14.02507903399993],
              [129.71753991000003, -14.015557549999926],
              [129.73560631600003, -13.991794528999947],
              [129.74586022200003, -13.961195570999905],
              [129.74919681100005, -13.931817315999922],
              [129.74488366000003, -13.913506768999923],
              [129.73503665500004, -13.90357838299991],
              [129.7236434250001, -13.894952080999929],
              [129.7148543630001, -13.88054778399993],
              [129.71599368600005, -13.867445570999905],
              [129.7231551440001, -13.851820570999905],
              [129.74170983200008, -13.82594166499996],
              [129.79615319100003, -13.785414320999905],
              [129.81592858200008, -13.761976820999905],
              [129.8037215500001, -13.743340752999927],
              [129.80030358200008, -13.749444268999923],
              [129.7929793630001, -13.758233330999929],
              [129.789398634, -13.763848565999922],
              [129.7832137380001, -13.75758228999996],
              [129.78923587300005, -13.74195728999996],
              [129.788422071, -13.725762627999927],
              [129.7832137380001, -13.691827080999929],
              [129.785492384, -13.675713799999926],
              [129.80982506600003, -13.61500416499996],
              [129.82740319100003, -13.582614841999941],
              [129.83090254, -13.568617445999905],
              [129.83155358200008, -13.53720468499995],
              [129.83350670700008, -13.522149346999925],
              [129.83773847700002, -13.510511976999908],
              [129.84742272200003, -13.503024997999944],
              [129.85906009200005, -13.49928150799991],
              [129.86866295700008, -13.493584893999923],
              [129.875336134, -13.467054945999905],
              [129.88257897200003, -13.45086028399993],
              [129.89128665500004, -13.437676690999922],
              [129.899261915, -13.43482838299991],
              [129.906586134, -13.44695403399993],
              [129.90845787900003, -13.465264580999929],
              [129.9067488940001, -13.500664971999925],
              [129.91472415500004, -13.51140715899993],
              [129.932953321, -13.519952080999929],
              [129.96892337300005, -13.530450127999927],
              [129.98194420700008, -13.52353280999995],
              [130.04322350400003, -13.504489841999941],
              [130.06234785200002, -13.49342213299991],
              [130.11280358200008, -13.449151299999926],
              [130.13396243600005, -13.46103280999995],
              [130.16374759200005, -13.43287525799991],
              [130.21461022200003, -13.360446872999944],
              [130.2373153000001, -13.33562590899993],
              [130.25416100400003, -13.323825778999947],
              [130.27320397200003, -13.318780205999929],
              [130.292328321, -13.32789478999996],
              [130.31666100400003, -13.343357028999947],
              [130.33228600400003, -13.346368096999925],
              [130.32447350400003, -13.318780205999929],
              [130.31397545700008, -13.308526299999926],
              [130.29476972700002, -13.297295830999929],
              [130.27263431100005, -13.28834400799991],
              [130.2524520190001, -13.284763278999947],
              [130.242523634, -13.278415622999944],
              [130.23121178500003, -13.263929945999905],
              [130.21461022200003, -13.236260674999926],
              [130.160492384, -13.171482028999947],
              [130.15552819100003, -13.168226820999905],
              [130.1313582690001, -13.167168877999927],
              [130.12273196700005, -13.164646091999941],
              [130.11866295700008, -13.156182549999926],
              [130.11890709700003, -13.047051690999922],
              [130.12256920700008, -13.032403252999927],
              [130.1298934250001, -13.020196221999925],
              [130.13461347700002, -12.998630466999941],
              [130.13013756600003, -12.969008070999905],
              [130.1298934250001, -12.940524997999944],
              [130.1469832690001, -12.92156340899993],
              [130.15886478000004, -12.922051690999922],
              [130.16863040500004, -12.918552341999941],
              [130.17603600400003, -12.911309502999927],
              [130.181000196, -12.901055596999925],
              [130.19320722700002, -12.912774346999925],
              [130.1972762380001, -12.926364841999941],
              [130.2041121750001, -12.937432549999926],
              [130.2251082690001, -12.942071221999925],
              [130.24675540500004, -12.937758070999905],
              [130.28345787900003, -12.919040622999944],
              [130.30054772200003, -12.914727471999925],
              [130.31861412900003, -12.90601978999996],
              [130.33513431100005, -12.885430596999925],
              [130.34717858200008, -12.86142343499995],
              [130.35181725400003, -12.842461846999925],
              [130.350922071, -12.780857028999947],
              [130.360687696, -12.750746351999908],
              [130.3554793630001, -12.732028903999947],
              [130.34742272200003, -12.712823174999926],
              [130.34498131600003, -12.69500090899993],
              [130.35434004, -12.672051690999922],
              [130.36744225400003, -12.672621351999908],
              [130.38306725400003, -12.68092213299991],
              [130.40015709700003, -12.68132903399993],
              [130.40202884200005, -12.674899997999944],
              [130.40202884200005, -12.663262627999927],
              [130.40357506600003, -12.65211353999996],
              [130.41000410200002, -12.647230726999908],
              [130.42115319100003, -12.64430103999996],
              [130.4375106130001, -12.63062916499996],
              [130.44800866000003, -12.62672291499996],
              [130.4614363940001, -12.630059502999927],
              [130.4980574880001, -12.64853280999995],
              [130.5161238940001, -12.65406666499996],
              [130.50147545700008, -12.63290780999995],
              [130.49496504, -12.619073174999926],
              [130.49634850400003, -12.605075778999947],
              [130.5068465500001, -12.596449476999908],
              [130.51685631600003, -12.603692315999922],
              [130.55844160200002, -12.68132903399993],
              [130.56804446700005, -12.68645598799992],
              [130.57878665500004, -12.688653252999927],
              [130.5864363940001, -12.694105726999908],
              [130.5864363940001, -12.709242445999905],
              [130.597992384, -12.703708591999941],
              [130.6064559250001, -12.706231377999927],
              [130.614593946, -12.71184661299992],
              [130.6259871750001, -12.71493905999995],
              [130.62671959700003, -12.712823174999926],
              [130.63005618600005, -12.708428643999923],
              [130.63502037900003, -12.703871351999908],
              [130.6411238940001, -12.701836846999925],
              [130.6469832690001, -12.703057549999926],
              [130.65748131600003, -12.708103122999944],
              [130.66431725400003, -12.709242445999905],
              [130.67554772200003, -12.70867278399993],
              [130.68572024800005, -12.706149997999944],
              [130.69288170700008, -12.700616143999923],
              [130.69556725400003, -12.691338799999926],
              [130.61304772200003, -12.66765715899993],
              [130.61402428500003, -12.669854424999926],
              [130.610199415, -12.67278411299992],
              [130.60425866000003, -12.674981377999927],
              [130.59880618600005, -12.674493096999925],
              [130.59685306100005, -12.672051690999922],
              [130.59205162900003, -12.662855726999908],
              [130.58912194100003, -12.660821221999925],
              [130.58765709700003, -12.656833591999941],
              [130.5747176440001, -12.639743747999944],
              [130.57154381600003, -12.636651299999926],
              [130.5673934250001, -12.63176848799992],
              [130.56039472700002, -12.628350518999923],
              [130.5590926440001, -12.62476978999996],
              [130.57154381600003, -12.619317315999922],
              [130.57984459700003, -12.619073174999926],
              [130.5879012380001, -12.621351820999905],
              [130.59644616000003, -12.62273528399993],
              [130.60564212300005, -12.619317315999922],
              [130.61605879, -12.610039971999925],
              [130.617523634, -12.603936455999929],
              [130.61500084700003, -12.597588799999926],
              [130.61304772200003, -12.588555596999925],
              [130.60767662900003, -12.584649346999925],
              [130.58375084700003, -12.58562590899993],
              [130.57837975400003, -12.58171965899993],
              [130.579437696, -12.56845468499995],
              [130.60417728000004, -12.504571221999925],
              [130.6045028000001, -12.48756275799991],
              [130.5903426440001, -12.462497653999947],
              [130.59253991000003, -12.45240650799991],
              [130.5996199880001, -12.444431247999944],
              [130.62037194100003, -12.436944268999923],
              [130.6152449880001, -12.42750416499996],
              [130.59880618600005, -12.41383228999996],
              [130.594574415, -12.411553643999923],
              [130.57837975400003, -12.406996351999908],
              [130.57837975400003, -12.400811455999929],
              [130.605804884, -12.38600025799991],
              [130.6411238940001, -12.383233330999929],
              [130.6743270190001, -12.39234791499996],
              [130.69556725400003, -12.41383228999996],
              [130.71257571700005, -12.410902601999908],
              [130.7392684250001, -12.415622653999947],
              [130.7661238940001, -12.42473723799992],
              [130.78386478000004, -12.434991143999923],
              [130.77369225400003, -12.454278252999927],
              [130.77328535200002, -12.469170830999929],
              [130.78386478000004, -12.50318775799991],
              [130.78443444100003, -12.564873955999929],
              [130.7900496750001, -12.585137627999927],
              [130.7959090500001, -12.57154713299991],
              [130.797211134, -12.558200778999947],
              [130.80030358200008, -12.54615650799991],
              [130.8110457690001, -12.537367445999905],
              [130.84302819100003, -12.559340101999908],
              [130.8774520190001, -12.617120049999926],
              [130.89991295700008, -12.639825127999927],
              [130.89828535200002, -12.623793226999908],
              [130.89673912900003, -12.61842213299991],
              [130.89372806100005, -12.61305103999996],
              [130.9091903000001, -12.597832940999922],
              [130.930511915, -12.60328541499996],
              [130.96859785200002, -12.62672291499996],
              [130.95777428500003, -12.598809502999927],
              [130.93376712300005, -12.580743096999925],
              [130.90650475400003, -12.564873955999929],
              [130.88624108200008, -12.54420338299991],
              [130.87623131600003, -12.52467213299991],
              [130.87378991000003, -12.513604424999926],
              [130.8808699880001, -12.50904713299991],
              [130.89991295700008, -12.50945403399993],
              [130.9199324880001, -12.514092705999929],
              [130.95085696700005, -12.53093840899993],
              [130.96859785200002, -12.537367445999905],
              [130.96241295700008, -12.519952080999929],
              [130.952484571, -12.50676848799992],
              [130.93091881600003, -12.48609791499996],
              [130.92359459700003, -12.48333098799992],
              [130.90381920700008, -12.48251718499995],
              [130.89991295700008, -12.479099216999941],
              [130.897797071, -12.471449476999908],
              [130.89332116000003, -12.463555596999925],
              [130.8828231130001, -12.451348565999922],
              [130.86695397200003, -12.44459400799991],
              [130.8559676440001, -12.453057549999926],
              [130.84359785200002, -12.459649346999925],
              [130.8247176440001, -12.447930596999925],
              [130.82195071700005, -12.43914153399993],
              [130.8266707690001, -12.430352471999925],
              [130.830414259, -12.418715101999908],
              [130.8247176440001, -12.400811455999929],
              [130.858734571, -12.393324476999908],
              [130.8476668630001, -12.379489841999941],
              [130.8554793630001, -12.368259372999944],
              [130.88624108200008, -12.35247161299992],
              [130.8935653000001, -12.344903252999927],
              [130.89519290500004, -12.338636976999908],
              [130.89763431100005, -12.334242445999905],
              [130.9072371750001, -12.331963799999926],
              [130.9165145190001, -12.332777601999908],
              [130.92139733200008, -12.33684661299992],
              [130.9257918630001, -12.341973565999922],
              [130.933929884, -12.346123955999929],
              [131.02515709700003, -12.360528252999927],
              [131.0512801440001, -12.373467705999929],
              [131.0517684250001, -12.353773695999905],
              [131.04615319100003, -12.340508721999925],
              [131.03012129, -12.318291924999926],
              [131.0263778000001, -12.304131768999923],
              [131.03012129, -12.253106377999927],
              [131.024750196, -12.23414478999996],
              [131.00147545700008, -12.206231377999927],
              [130.9961043630001, -12.191338799999926],
              [131.00017337300005, -12.171319268999923],
              [131.01091556100005, -12.15601978999996],
              [131.02613366000003, -12.147149346999925],
              [131.043793165, -12.14625416499996],
              [131.05290774800005, -12.150567315999922],
              [131.07146243600005, -12.164483330999929],
              [131.07789147200003, -12.167413018999923],
              [131.08521569100003, -12.16415780999995],
              [131.0962020190001, -12.14934661299992],
              [131.1059676440001, -12.14625416499996],
              [131.11638431100005, -12.154880466999941],
              [131.12671959700003, -12.17083098799992],
              [131.13786868600005, -12.18254973799992],
              [131.16277103000004, -12.17392343499995],
              [131.18816165500004, -12.200778903999947],
              [131.2055770190001, -12.208428643999923],
              [131.21648196700005, -12.21493905999995],
              [131.22193444100003, -12.22820403399993],
              [131.23226972700002, -12.238539320999905],
              [131.25733483200008, -12.236260674999926],
              [131.23902428500003, -12.21217213299991],
              [131.23617597700002, -12.201592705999929],
              [131.239105665, -12.19345468499995],
              [131.2539168630001, -12.177178643999923],
              [131.25733483200008, -12.17083098799992],
              [131.25798587300005, -12.14934661299992],
              [131.260101759, -12.134942315999922],
              [131.27100670700008, -12.09856536299992],
              [131.27295983200008, -12.067071221999925],
              [131.27711022200003, -12.05754973799992],
              [131.28736412900003, -12.047295830999929],
              [131.296234571, -12.04387786299992],
              [131.30258222700002, -12.04810963299991],
              [131.3071395190001, -12.07154713299991],
              [131.31617272200003, -12.084161065999922],
              [131.31820722700002, -12.09539153399993],
              [131.31820722700002, -12.140232028999947],
              [131.32789147200003, -12.18531666499996],
              [131.34685306100005, -12.21965911299992],
              [131.37378991000003, -12.246758721999925],
              [131.40691165500004, -12.27044036299992],
              [131.4262801440001, -12.281182549999926],
              [131.4477645190001, -12.289808851999908],
              [131.47038821700005, -12.295668226999908],
              [131.49293053500003, -12.29778411299992],
              [131.5146590500001, -12.295179945999905],
              [131.55689537900003, -12.285088799999926],
              [131.57886803500003, -12.28411223799992],
              [131.5908309250001, -12.28720468499995],
              [131.61280358200008, -12.29664478999996],
              [131.62419681100005, -12.29387786299992],
              [131.70687910200002, -12.28215911299992],
              [131.78435306100005, -12.27044036299992],
              [131.82007897200003, -12.25750090899993],
              [131.83969160200002, -12.246758721999925],
              [131.8642684250001, -12.22584400799991],
              [131.874359571, -12.220635674999926],
              [131.88550866000003, -12.217054945999905],
              [131.8969832690001, -12.215915622999944],
              [131.904633009, -12.219821872999944],
              [131.907562696, -12.229180596999925],
              [131.90967858200008, -12.240411065999922],
              [131.9140731130001, -12.25009530999995],
              [131.93384850400003, -12.263929945999905],
              [131.9770613940001, -12.277927341999941],
              [132.0019637380001, -12.29265715899993],
              [132.02515709700003, -12.29656340899993],
              [132.04566491000003, -12.307386976999908],
              [132.05787194100003, -12.30673593499995],
              [132.078461134, -12.29778411299992],
              [132.115570509, -12.275567315999922],
              [132.1508895190001, -12.246270440999922],
              [132.1665145190001, -12.225030205999929],
              [132.171234571, -12.222100518999923],
              [132.21631920700008, -12.208428643999923],
              [132.22217858200008, -12.198825778999947],
              [132.22999108200008, -12.170342705999929],
              [132.23617597700002, -12.160577080999929],
              [132.251312696, -12.15634530999995],
              [132.2622176440001, -12.16497161299992],
              [132.26880944100003, -12.180840752999927],
              [132.270843946, -12.19817473799992],
              [132.2783309250001, -12.22820403399993],
              [132.29672285200002, -12.22665780999995],
              [132.321136915, -12.211602471999925],
              [132.346039259, -12.201592705999929],
              [132.3613387380001, -12.202243747999944],
              [132.37183678500003, -12.206963799999926],
              [132.3798934250001, -12.215997002999927],
              [132.41187584700003, -12.27312590899993],
              [132.41684004, -12.29469166499996],
              [132.41960696700005, -12.299004815999922],
              [132.42164147200003, -12.30364348799992],
              [132.42115319100003, -12.31145598799992],
              [132.4170028000001, -12.317152601999908],
              [132.40406334700003, -12.324151299999926],
              [132.3994246750001, -12.332289320999905],
              [132.3906356130001, -12.341241143999923],
              [132.387543165, -12.346123955999929],
              [132.38648522200003, -12.354180596999925],
              [132.387543165, -12.380303643999923],
              [132.4052840500001, -12.358168226999908],
              [132.431976759, -12.331149997999944],
              [132.44939212300005, -12.300388278999947],
              [132.4228621750001, -12.231622002999927],
              [132.424164259, -12.189711195999905],
              [132.43962649800005, -12.154880466999941],
              [132.466156446, -12.140232028999947],
              [132.48894290500004, -12.13567473799992],
              [132.54468834700003, -12.09856536299992],
              [132.56397545700008, -12.09156666499996],
              [132.57732181100005, -12.094008070999905],
              [132.60670006600003, -12.11223723799992],
              [132.640961134, -12.126397393999923],
              [132.679047071, -12.13681405999995],
              [132.71859785200002, -12.140232028999947],
              [132.75757897200003, -12.133396091999941],
              [132.7470809250001, -12.12867603999996],
              [132.7270613940001, -12.128350518999923],
              [132.71599368600005, -12.126560153999947],
              [132.70622806100005, -12.12200286299992],
              [132.69711347700002, -12.11223723799992],
              [132.68873131600003, -12.106052341999941],
              [132.6489363940001, -12.083103122999944],
              [132.63453209700003, -12.067152601999908],
              [132.62720787900003, -12.04387786299992],
              [132.6269637380001, -12.004327080999929],
              [132.65105228000004, -11.865817966999941],
              [132.65219160200002, -11.84856536299992],
              [132.649261915, -11.83326588299991],
              [132.64087975400003, -11.818617445999905],
              [132.59986412900003, -11.792087497999944],
              [132.59302819100003, -11.78443775799991],
              [132.6005965500001, -11.76685963299991],
              [132.64079837300005, -11.72633228999996],
              [132.65447024800005, -11.70875416499996],
              [132.66675866000003, -11.674248955999929],
              [132.6762801440001, -11.664239190999922],
              [132.69556725400003, -11.660332940999922],
              [132.69556725400003, -11.653497002999927],
              [132.64966881600003, -11.635511976999908],
              [132.61255944100003, -11.629978122999944],
              [132.59498131600003, -11.62200286299992],
              [132.57886803500003, -11.61101653399993],
              [132.56519616000003, -11.59889088299991],
              [132.552093946, -11.583428643999923],
              [132.5512801440001, -11.575616143999923],
              [132.55591881600003, -11.568291924999926],
              [132.558929884, -11.553887627999927],
              [132.5512801440001, -11.544528903999947],
              [132.53589928500003, -11.538181247999944],
              [132.52515709700003, -11.52857838299991],
              [132.53101647200003, -11.50953541499996],
              [132.51156660200002, -11.506605726999908],
              [132.49537194100003, -11.476169528999947],
              [132.434906446, -11.446709893999923],
              [132.41553795700008, -11.440606377999927],
              [132.36988366000003, -11.434991143999923],
              [132.34693444100003, -11.438246351999908],
              [132.31128991000003, -11.461521091999941],
              [132.28882897200003, -11.46103280999995],
              [132.264984571, -11.45631275799991],
              [132.24366295700008, -11.45484791499996],
              [132.232758009, -11.457696221999925],
              [132.22632897200003, -11.46217213299991],
              [132.21989993600005, -11.467950127999927],
              [132.2094832690001, -11.474786065999922],
              [132.200531446, -11.48560963299991],
              [132.1958113940001, -11.489027601999908],
              [132.188812696, -11.488946221999925],
              [132.18344160200002, -11.485039971999925],
              [132.1782332690001, -11.48219166499996],
              [132.171234571, -11.48560963299991],
              [132.14242597700002, -11.509372653999947],
              [132.12452233200008, -11.518975518999923],
              [132.1064559250001, -11.52312590899993],
              [132.08472741000003, -11.517998955999929],
              [132.07007897200003, -11.506280205999929],
              [132.0590926440001, -11.494398695999905],
              [132.04810631600003, -11.489027601999908],
              [132.04281660200002, -11.48414478999996],
              [132.0371199880001, -11.473077080999929],
              [132.032562696, -11.460381768999923],
              [132.03077233200008, -11.45086028399993],
              [132.0356551440001, -11.44695403399993],
              [132.0459090500001, -11.445570570999905],
              [132.055511915, -11.442803643999923],
              [132.057953321, -11.434340101999908],
              [132.04070071700005, -11.418633721999925],
              [132.01392662900003, -11.423435153999947],
              [131.99048912900003, -11.42506275799991],
              [131.98218834700003, -11.39967213299991],
              [131.97608483200008, -11.39967213299991],
              [131.96607506600003, -11.40601978999996],
              [131.95525149800005, -11.403903903999947],
              [131.9477645190001, -11.394463799999926],
              [131.94809004, -11.379164320999905],
              [131.96949303500003, -11.373793226999908],
              [131.9795028000001, -11.36646900799991],
              [131.97608483200008, -11.35125090899993],
              [131.96558678500003, -11.34498463299991],
              [131.93962649800005, -11.352634372999944],
              [131.9277449880001, -11.35125090899993],
              [131.92261803500003, -11.34107838299991],
              [131.9257918630001, -11.330010674999926],
              [131.92554772200003, -11.320896091999941],
              [131.91130618600005, -11.317071221999925],
              [131.89616946700005, -11.314873955999929],
              [131.87094160200002, -11.30559661299992],
              [131.85621178500003, -11.303399346999925],
              [131.84693444100003, -11.30559661299992],
              [131.82439212300005, -11.314873955999929],
              [131.81568444100003, -11.317071221999925],
              [131.7675887380001, -11.310804945999905],
              [131.76587975400003, -11.307224216999941],
              [131.774261915, -11.299574476999908],
              [131.78882897200003, -11.29225025799991],
              [131.80486087300005, -11.290459893999923],
              [131.78972415500004, -11.26336028399993],
              [131.80054772200003, -11.26336028399993],
              [131.82203209700003, -11.273614190999922],
              [131.8388778000001, -11.27743905999995],
              [131.84693444100003, -11.26336028399993],
              [131.83814537900003, -11.244398695999905],
              [131.82488040500004, -11.223077080999929],
              [131.81910241000003, -11.201592705999929],
              [131.82683353000004, -11.20403411299992],
              [131.848480665, -11.207289320999905],
              [131.85621178500003, -11.211602471999925],
              [131.868500196, -11.22079843499995],
              [131.87476647200003, -11.215997002999927],
              [131.87680097700002, -11.20671965899993],
              [131.87647545700008, -11.201592705999929],
              [131.86988366000003, -11.194756768999923],
              [131.874359571, -11.181247653999947],
              [131.88249759200005, -11.17197030999995],
              [131.8867293630001, -11.17742278399993],
              [131.89014733200008, -11.18450286299992],
              [131.90503991000003, -11.199883721999925],
              [131.9360457690001, -11.246758721999925],
              [131.94027754, -11.251397393999923],
              [131.94695071700005, -11.249932549999926],
              [131.96241295700008, -11.242608330999929],
              [131.98324629, -11.22625090899993],
              [131.98259524800005, -11.209405205999929],
              [131.97339928500003, -11.19036223799992],
              [131.96859785200002, -11.167575778999947],
              [131.986664259, -11.176527601999908],
              [131.98975670700008, -11.168633721999925],
              [131.98218834700003, -11.147067966999941],
              [131.98161868600005, -11.130059502999927],
              [131.98560631600003, -11.129164320999905],
              [131.9961043630001, -11.135430596999925],
              [132.01433353000004, -11.13958098799992],
              [132.02222741000003, -11.147067966999941],
              [132.0317488940001, -11.163506768999923],
              [132.04460696700005, -11.179945570999905],
              [132.07781009200005, -11.192478122999944],
              [132.07390384200005, -11.21803150799991],
              [132.0859481130001, -11.228936455999929],
              [132.0962020190001, -11.22470468499995],
              [132.10621178500003, -11.213636976999908],
              [132.11451256600003, -11.20875416499996],
              [132.1201278000001, -11.222100518999923],
              [132.11833743600005, -11.228448174999926],
              [132.10865319100003, -11.24586353999996],
              [132.1064559250001, -11.25286223799992],
              [132.10759524800005, -11.26148853999996],
              [132.11215254, -11.276788018999923],
              [132.1132918630001, -11.287041924999926],
              [132.10710696700005, -11.317071221999925],
              [132.10726972700002, -11.331963799999926],
              [132.11670983200008, -11.338148695999905],
              [132.121918165, -11.340020440999922],
              [132.12476647200003, -11.34303150799991],
              [132.12777754, -11.343682549999926],
              [132.1337996750001, -11.338148695999905],
              [132.1347762380001, -11.33131275799991],
              [132.13168379, -11.32317473799992],
              [132.1313582690001, -11.31373463299991],
              [132.1406356130001, -11.303399346999925],
              [132.15300540500004, -11.326348565999922],
              [132.15105228000004, -11.355726820999905],
              [132.15251712300005, -11.384698174999926],
              [132.17465254, -11.406426690999922],
              [132.20386803500003, -11.410332940999922],
              [132.2031356130001, -11.391696872999944],
              [132.19166100400003, -11.36646900799991],
              [132.188324415, -11.35125090899993],
              [132.2036238940001, -11.349541924999926],
              [132.21631920700008, -11.358575127999927],
              [132.226898634, -11.363864841999941],
              [132.23617597700002, -11.35125090899993],
              [132.23560631600003, -11.339450778999947],
              [132.22828209700003, -11.328708591999941],
              [132.2094832690001, -11.310804945999905],
              [132.20337975400003, -11.30787525799991],
              [132.19792728000004, -11.30950286299992],
              [132.19288170700008, -11.309747002999927],
              [132.188324415, -11.303399346999925],
              [132.18873131600003, -11.299574476999908],
              [132.19410241000003, -11.290215752999927],
              [132.1958113940001, -11.283623955999929],
              [132.1962996750001, -11.268243096999925],
              [132.19483483200008, -11.256036065999922],
              [132.19027754, -11.244073174999926],
              [132.18148847700002, -11.228936455999929],
              [132.190765821, -11.21689218499995],
              [132.18344160200002, -11.196058851999908],
              [132.169281446, -11.176364841999941],
              [132.15796959700003, -11.167575778999947],
              [132.1474715500001, -11.157321872999944],
              [132.14812259200005, -11.137302341999941],
              [132.16130618600005, -11.123711846999925],
              [132.188324415, -11.132745049999926],
              [132.19890384200005, -11.146905205999929],
              [132.20671634200005, -11.16497161299992],
              [132.21648196700005, -11.180759372999944],
              [132.23316491000003, -11.187432549999926],
              [132.24097741000003, -11.196465752999927],
              [132.255218946, -11.240411065999922],
              [132.2641707690001, -11.256280205999929],
              [132.2851668630001, -11.26848723799992],
              [132.28785241000003, -11.255466403999947],
              [132.277679884, -11.218682549999926],
              [132.27230879, -11.17750416499996],
              [132.27751712300005, -11.16220468499995],
              [132.298187696, -11.15325286299992],
              [132.31031334700003, -11.154554945999905],
              [132.31470787900003, -11.15984465899993],
              [132.31959069100003, -11.16179778399993],
              [132.332367384, -11.15325286299992],
              [132.3320418630001, -11.14771900799991],
              [132.3369246750001, -11.132745049999926],
              [132.34302819100003, -11.12200286299992],
              [132.346039259, -11.129327080999929],
              [132.349945509, -11.14625416499996],
              [132.38347415500004, -11.214450778999947],
              [132.38445071700005, -11.219170830999929],
              [132.38347415500004, -11.223402601999908],
              [132.38070722700002, -11.228936455999929],
              [132.38689212300005, -11.24578215899993],
              [132.3779403000001, -11.283135674999926],
              [132.390961134, -11.290459893999923],
              [132.40398196700005, -11.283135674999926],
              [132.411468946, -11.265883070999905],
              [132.42115319100003, -11.228936455999929],
              [132.44507897200003, -11.212497653999947],
              [132.474945509, -11.23414478999996],
              [132.5019637380001, -11.273695570999905],
              [132.51734459700003, -11.310804945999905],
              [132.513031446, -11.32203541499996],
              [132.51238040500004, -11.330336195999905],
              [132.51734459700003, -11.338148695999905],
              [132.52312259200005, -11.339043877999927],
              [132.53003991000003, -11.336358330999929],
              [132.53581790500004, -11.332696221999925],
              [132.53785241000003, -11.330743096999925],
              [132.54322350400003, -11.33489348799992],
              [132.5551863940001, -11.348239841999941],
              [132.56080162900003, -11.356215101999908],
              [132.56918379, -11.375420830999929],
              [132.61353600400003, -11.406426690999922],
              [132.633148634, -11.43726978999996],
              [132.65007571700005, -11.47665780999995],
              [132.674164259, -11.508396091999941],
              [132.71599368600005, -11.516289971999925],
              [132.73698978000004, -11.508233330999929],
              [132.75953209700003, -11.492364190999922],
              [132.77751712300005, -11.472263278999947],
              [132.7880965500001, -11.443617445999905],
              [132.79574629, -11.440118096999925],
              [132.805023634, -11.437758070999905],
              [132.81275475400003, -11.434340101999908],
              [132.82634524800005, -11.422295830999929],
              [132.82960045700008, -11.420668226999908],
              [132.8339949880001, -11.417901299999926],
              [132.83350670700008, -11.41139088299991],
              [132.83179772200003, -11.40439218499995],
              [132.83326256600003, -11.39967213299991],
              [132.8559676440001, -11.400323174999926],
              [132.87818444100003, -11.413506768999923],
              [132.894867384, -11.41887786299992],
              [132.90162194100003, -11.395928643999923],
              [132.8989363940001, -11.371840101999908],
              [132.891937696, -11.358493747999944],
              [132.86744225400003, -11.338148695999905],
              [132.87289472700002, -11.32789478999996],
              [132.87916100400003, -11.326348565999922],
              [132.8872176440001, -11.328871351999908],
              [132.910980665, -11.33180103999996],
              [132.91529381600003, -11.334730726999908],
              [132.91716556100005, -11.339288018999923],
              [132.92204837300005, -11.34498463299991],
              [132.9287215500001, -11.348077080999929],
              [132.9355574880001, -11.350192966999941],
              [132.94092858200008, -11.353936455999929],
              [132.94312584700003, -11.361748955999929],
              [132.95573978000004, -11.387465101999908],
              [132.95980879, -11.392185153999947],
              [132.98552493600005, -11.404229424999926],
              [133.011078321, -11.432793877999927],
              [133.03239993600005, -11.46689218499995],
              [133.0449324880001, -11.495212497999944],
              [133.0517684250001, -11.495212497999944],
              [133.0595809250001, -11.500258070999905],
              [133.06861412900003, -11.504327080999929],
              [133.07601972700002, -11.509942315999922],
              [133.0791121750001, -11.519707940999922],
              [133.07374108200008, -11.54778411299992],
              [133.0742293630001, -11.560967705999929],
              [133.09945722700002, -11.597100518999923],
              [133.1411238940001, -11.674574476999908],
              [133.15186608200008, -11.68873463299991],
              [133.16675866000003, -11.70435963299991],
              [133.18506920700008, -11.717054945999905],
              [133.20630944100003, -11.72234465899993],
              [133.26124108200008, -11.729587497999944],
              [133.28288821700005, -11.720879815999922],
              [133.2920028000001, -11.688246351999908],
              [133.30811608200008, -11.691989841999941],
              [133.33464603000004, -11.687676690999922],
              [133.3466903000001, -11.688246351999908],
              [133.36443118600005, -11.69736093499995],
              [133.35889733200008, -11.70435963299991],
              [133.34294681100005, -11.711114190999922],
              [133.329437696, -11.718682549999926],
              [133.3183699880001, -11.734633070999905],
              [133.315765821, -11.749118747999944],
              [133.32374108200008, -11.75945403399993],
              [133.3437606130001, -11.76336028399993],
              [133.36508222700002, -11.76336028399993],
              [133.372406446, -11.76100025799991],
              [133.37663821700005, -11.753024997999944],
              [133.38819420700008, -11.73601653399993],
              [133.39730879, -11.72747161299992],
              [133.4072371750001, -11.723809502999927],
              [133.41618899800005, -11.72779713299991],
              [133.422211134, -11.742852471999925],
              [133.4189559250001, -11.748630466999941],
              [133.41081790500004, -11.754164320999905],
              [133.40414472700002, -11.760023695999905],
              [133.4052840500001, -11.766778252999927],
              [133.41195722700002, -11.770196221999925],
              [133.421234571, -11.771091403999947],
              [133.43930097700002, -11.770196221999925],
              [133.4648543630001, -11.785821221999925],
              [133.4785262380001, -11.79078541499996],
              [133.4843856130001, -11.780694268999923],
              [133.49138431100005, -11.776462497999944],
              [133.5068465500001, -11.771091403999947],
              [133.52320397200003, -11.762790622999944],
              [133.532074415, -11.749118747999944],
              [133.54322350400003, -11.76734791499996],
              [133.5420028000001, -11.799899997999944],
              [133.53394616000003, -11.834161065999922],
              [133.52466881600003, -11.85833098799992],
              [133.532074415, -11.865817966999941],
              [133.5395613940001, -11.853122653999947],
              [133.55005944100003, -11.82350025799991],
              [133.55836022200003, -11.811211846999925],
              [133.58350670700008, -11.799899997999944],
              [133.5898543630001, -11.79810963299991],
              [133.60027103000004, -11.800957940999922],
              [133.60328209700003, -11.807224216999941],
              [133.603851759, -11.814060153999947],
              [133.60670006600003, -11.818617445999905],
              [133.61548912900003, -11.82984791499996],
              [133.6220809250001, -11.83326588299991],
              [133.63786868600005, -11.82398853999996],
              [133.6552840500001, -11.821384372999944],
              [133.66187584700003, -11.818617445999905],
              [133.67009524800005, -11.808851820999905],
              [133.68238366000003, -11.770196221999925],
              [133.69898522200003, -11.775974216999941],
              [133.71656334700003, -11.777520440999922],
              [133.73454837300005, -11.77548593499995],
              [133.75123131600003, -11.770196221999925],
              [133.76514733200008, -11.758965752999927],
              [133.80250084700003, -11.71493905999995],
              [133.82984459700003, -11.71493905999995],
              [133.83757571700005, -11.717217705999929],
              [133.8422957690001, -11.722100518999923],
              [133.84595787900003, -11.726983330999929],
              [133.8505965500001, -11.729180596999925],
              [133.86793053500003, -11.73333098799992],
              [133.8852645190001, -11.739434502999927],
              [133.90162194100003, -11.738864841999941],
              [133.91578209700003, -11.72234465899993],
              [133.93327884200005, -11.745212497999944],
              [133.93897545700008, -11.75790780999995],
              [133.93287194100003, -11.76336028399993],
              [133.9189559250001, -11.766289971999925],
              [133.90894616000003, -11.773858330999929],
              [133.9013778000001, -11.78492603999996],
              [133.89527428500003, -11.79810963299991],
              [133.8701278000001, -11.79225025799991],
              [133.84636478000004, -11.806817315999922],
              [133.83415774800005, -11.831475518999923],
              [133.8437606130001, -11.85523853999996],
              [133.89128665500004, -11.88762786299992],
              [133.94312584700003, -11.913669528999947],
              [133.9848738940001, -11.889336846999925],
              [134.00749759200005, -11.881280205999929],
              [134.0136824880001, -11.869561455999929],
              [134.0180770190001, -11.856133721999925],
              [134.02564537900003, -11.845879815999922],
              [134.040375196, -11.84156666499996],
              [134.056000196, -11.844821872999944],
              [134.0683699880001, -11.85442473799992],
              [134.07341556100005, -11.86923593499995],
              [134.075531446, -11.873793226999908],
              [134.08025149800005, -11.877373955999929],
              [134.08480879, -11.882012627999927],
              [134.08708743600005, -11.88990650799991],
              [134.08570397200003, -11.901462497999944],
              [134.08350670700008, -11.90992603999996],
              [134.08318118600005, -11.91806405999995],
              [134.08708743600005, -11.927911065999922],
              [134.132172071, -11.88640715899993],
              [134.13795006600003, -11.879489841999941],
              [134.14429772200003, -11.886895440999922],
              [134.1587020190001, -11.92115650799991],
              [134.16163170700008, -11.93092213299991],
              [134.168304884, -11.938164971999925],
              [134.18279056100005, -11.941664320999905],
              [134.19507897200003, -11.947686455999929],
              [134.1962996750001, -11.962009372999944],
              [134.19206790500004, -11.963311455999929],
              [134.17465254, -11.964288018999923],
              [134.1689559250001, -11.968194268999923],
              [134.16781660200002, -11.97665780999995],
              [134.17172285200002, -11.98333098799992],
              [134.1777449880001, -11.989434502999927],
              [134.1826278000001, -11.99618905999995],
              [134.18775475400003, -12.00872161299992],
              [134.18970787900003, -12.018243096999925],
              [134.1894637380001, -12.04078541499996],
              [134.1884871750001, -12.04810963299991],
              [134.18384850400003, -12.058770440999922],
              [134.1826278000001, -12.06812916499996],
              [134.18580162900003, -12.076429945999905],
              [134.19288170700008, -12.078708591999941],
              [134.19996178500003, -12.075616143999923],
              [134.21078535200002, -12.052178643999923],
              [134.24683678500003, -12.026950778999947],
              [134.2578231130001, -12.016696872999944],
              [134.262054884, -11.997979424999926],
              [134.26189212300005, -11.985039971999925],
              [134.26628665500004, -11.975762627999927],
              [134.28500410200002, -11.968194268999923],
              [134.3466903000001, -12.020277601999908],
              [134.382172071, -12.04265715899993],
              [134.42896569100003, -12.05754973799992],
              [134.52222741000003, -12.064385674999926],
              [134.56202233200008, -12.05242278399993],
              [134.58269290500004, -12.050957940999922],
              [134.5942488940001, -12.064385674999926],
              [134.60466556100005, -12.049493096999925],
              [134.63266035200002, -12.03093840899993],
              [134.69654381600003, -11.968194268999923],
              [134.70476321700005, -11.96062590899993],
              [134.72291100400003, -11.952243747999944],
              [134.74756920700008, -11.94850025799991],
              [134.7685653000001, -11.947686455999929],
              [134.77369225400003, -11.952732028999947],
              [134.7744246750001, -11.96412525799991],
              [134.77222741000003, -11.985935153999947],
              [134.77458743600005, -11.99504973799992],
              [134.78003991000003, -12.003024997999944],
              [134.79224694100003, -12.016696872999944],
              [134.7959090500001, -12.024183851999908],
              [134.80095462300005, -12.038669528999947],
              [134.80640709700003, -12.04387786299992],
              [134.81462649800005, -12.042901299999926],
              [134.82593834700003, -12.038669528999947],
              [134.83619225400003, -12.037855726999908],
              [134.84058678500003, -12.047295830999929],
              [134.8466903000001, -12.090997002999927],
              [134.85320071700005, -12.11305103999996],
              [134.86109459700003, -12.126560153999947],
              [134.88062584700003, -12.133884372999944],
              [134.92741946700005, -12.134698174999926],
              [134.9399520190001, -12.13681405999995],
              [134.9472762380001, -12.14031340899993],
              [134.96705162900003, -12.146091403999947],
              [134.97095787900003, -12.15007903399993],
              [134.9736434250001, -12.15593840899993],
              [134.99138431100005, -12.18173593499995],
              [135.00123131600003, -12.20281340899993],
              [135.00505618600005, -12.208428643999923],
              [135.04053795700008, -12.226820570999905],
              [135.04607181100005, -12.232842705999929],
              [135.0488387380001, -12.237074476999908],
              [135.07016035200002, -12.259942315999922],
              [135.08033287900003, -12.263604424999926],
              [135.09245853000004, -12.260511976999908],
              [135.11491946700005, -12.25009530999995],
              [135.13355553500003, -12.243747653999947],
              [135.14722095700006, -12.24376743299996],
              [135.15812355000003, -12.253439100999913],
              [135.17199304500002, -12.269890244999942],
              [135.18785371600006, -12.280524241999956],
              [135.202717323, -12.294066046999944],
              [135.21759003700004, -12.300822868999944],
              [135.23780358200008, -12.291599216999941],
              [135.22999108200008, -12.274590752999927],
              [135.18889024400005, -12.251444354999933],
              [135.1700750010001, -12.228221738999935],
              [135.20777428500003, -12.229099216999941],
              [135.23255585900006, -12.227149252999936],
              [135.2583113940001, -12.222100518999923],
              [135.26922450900008, -12.234831667999913],
              [135.28309543, -12.250292798999908],
              [135.30192885300005, -12.25895825899994],
              [135.32349694100003, -12.25009530999995],
              [135.33814537900003, -12.245700778999947],
              [135.34929446700005, -12.23601653399993],
              [135.34937584700003, -12.22633228999996],
              [135.32866573800004, -12.234724339999957],
              [135.304896105, -12.23186139899991],
              [135.2900370430001, -12.224145299999918],
              [135.26428751800006, -12.208696288999931],
              [135.24149763600008, -12.20679582899993],
              [135.222683512, -12.191330316999938],
              [135.23756034400003, -12.17968985799996],
              [135.2653017030001, -12.178681050999955],
              [135.306976759, -12.157647393999923],
              [135.3134871750001, -12.153741143999923],
              [135.322601759, -12.144138278999947],
              [135.32390384200005, -12.139825127999927],
              [135.308889432, -12.136040257999923],
              [135.3029482280001, -12.128309756999954],
              [135.3247279420001, -12.110869512999955],
              [135.35143977000007, -12.105034380999939],
              [135.366267193, -12.087612683999907],
              [135.389011579, -12.091452363999906],
              [135.4150496750001, -12.084242445999905],
              [135.41767867600004, -12.087551308999934],
              [135.408793639, -12.105929886999945],
              [135.42859185600003, -12.115544705999923],
              [135.460218961, -12.113571590999925],
              [135.4848738940001, -12.106052341999941],
              [135.50513756600003, -12.098077080999929],
              [135.51551516400002, -12.078717808999954],
              [135.5154974520001, -12.065190505999908],
              [135.5362418630001, -12.06226502599992],
              [135.53527955800007, -12.080620951999947],
              [135.57154381600003, -12.097263278999947],
              [135.5879012380001, -12.09856536299992],
              [135.6220809250001, -12.06812916499996],
              [135.62671959700003, -12.064873955999929],
              [135.6489363940001, -12.054864190999922],
              [135.65609785200002, -12.050713799999926],
              [135.71199680300003, -12.01848340999993],
              [135.70209173800004, -12.00787164399992],
              [135.651703321, -12.020196221999925],
              [135.6357528000001, -12.02353280999995],
              [135.59294681100005, -12.05559661299992],
              [135.5810653000001, -12.05754973799992],
              [135.5722762380001, -12.04420338299991],
              [135.565826292, -12.025500677999958],
              [135.57071741900006, -11.99457454499992],
              [135.59253991000003, -11.965101820999905],
              [135.6005965500001, -11.95671965899993],
              [135.6220809250001, -11.954522393999923],
              [135.628265821, -11.956963799999926],
              [135.6308699880001, -11.961602471999925],
              [135.63502037900003, -11.966241143999923],
              [135.64568118600005, -11.968194268999923],
              [135.65503991000003, -11.966403903999947],
              [135.65935306100005, -11.961358330999929],
              [135.6626082690001, -11.95476653399993],
              [135.66976972700002, -11.947686455999929],
              [135.683929884, -11.93914153399993],
              [135.70093834700003, -11.93254973799992],
              [135.7197371750001, -11.931817315999922],
              [135.7392684250001, -11.94150155999995],
              [135.77515709700003, -11.919366143999923],
              [135.80982506600003, -11.88990650799991],
              [135.836761915, -11.87395598799992],
              [135.84107506600003, -11.86923593499995],
              [135.845062696, -11.855075778999947],
              [135.85466556100005, -11.850762627999927],
              [135.86589603000004, -11.849867445999905],
              [135.87525475400003, -11.845879815999922],
              [135.88697350400003, -11.824639580999929],
              [135.883148634, -11.80673593499995],
              [135.87378991000003, -11.788669528999947],
              [135.86841881600003, -11.766778252999927],
              [135.87818444100003, -11.756280205999929],
              [135.9004012380001, -11.759209893999923],
              [135.92359459700003, -11.76848723799992],
              [135.93677819100003, -11.77703215899993],
              [135.92212846000007, -11.816001012999948],
              [135.90341651000006, -11.849898623999934],
              [135.84107506600003, -11.913669528999947],
              [135.81120853000004, -11.951918226999908],
              [135.79363040500004, -11.963962497999944],
              [135.75847415500004, -11.969903252999927],
              [135.75123131600003, -11.975030205999929],
              [135.746918165, -11.982842705999929],
              [135.716907439, -12.00301907699992],
              [135.72384344900001, -12.010737625999923],
              [135.7646590500001, -11.99618905999995],
              [135.786468946, -11.989353122999944],
              [135.85108483200008, -11.98251718499995],
              [135.86703535200002, -11.978448174999926],
              [135.89722741000003, -11.96257903399993],
              [135.91627037900003, -11.962009372999944],
              [135.91627037900003, -11.968194268999923],
              [135.90259850400003, -11.976739190999922],
              [135.85474694100003, -11.989353122999944],
              [135.82837975400003, -12.00554778399993],
              [135.79281660200002, -12.03679778399993],
              [135.76539147200003, -12.071872653999947],
              [135.73072350400003, -12.10165780999995],
              [135.71816596000008, -12.108385464999913],
              [135.69053489400005, -12.129703650999943],
              [135.6688225470001, -12.147143196999934],
              [135.65007276200004, -12.16457614399991],
              [135.6521378870001, -12.203285641999912],
              [135.669030669, -12.237137624999946],
              [135.68885596200005, -12.250670503999913],
              [135.70373921400005, -12.265177396999945],
              [135.71366908700008, -12.276786508999919],
              [135.73194420700008, -12.31145598799992],
              [135.75180097700002, -12.27076588299991],
              [135.76531009200005, -12.25709400799991],
              [135.77906334700003, -12.263604424999926],
              [135.786468946, -12.263604424999926],
              [135.79444420700008, -12.23528411299992],
              [135.80689537900003, -12.216973565999922],
              [135.84742272200003, -12.187920830999929],
              [135.88013756600003, -12.15162525799991],
              [135.88892662900003, -12.14625416499996],
              [135.89576256600003, -12.15048593499995],
              [135.90259850400003, -12.15992603999996],
              [135.90748131600003, -12.170505466999941],
              [135.90943444100003, -12.177911065999922],
              [135.9126082690001, -12.182305596999925],
              [135.9199324880001, -12.174411716999941],
              [135.930511915, -12.15715911299992],
              [135.9345809250001, -12.146742445999905],
              [135.9443465500001, -12.146091403999947],
              [135.95655358200008, -12.14739348799992],
              [135.9677840500001, -12.143243096999925],
              [136.02857506600003, -12.082207940999922],
              [136.05347741000003, -12.064385674999926],
              [136.0493270190001, -12.08294036299992],
              [136.03589928500003, -12.10328541499996],
              [136.019867384, -12.119724216999941],
              [136.008636915, -12.126560153999947],
              [136.00464928500003, -12.129978122999944],
              [135.99366295700008, -12.145603122999944],
              [135.99138431100005, -12.15007903399993],
              [135.989593946, -12.160902601999908],
              [135.98503665500004, -12.166273695999905],
              [135.95386803500003, -12.184747002999927],
              [135.94361412900003, -12.192478122999944],
              [135.93677819100003, -12.201592705999929],
              [135.93539472700002, -12.213636976999908],
              [135.9404403000001, -12.221449476999908],
              [135.94703209700003, -12.227146091999941],
              [135.95045006600003, -12.232842705999929],
              [135.957367384, -12.25750090899993],
              [135.97445722700002, -12.26458098799992],
              [135.99488366000003, -12.260023695999905],
              [136.01246178500003, -12.25009530999995],
              [136.0258895190001, -12.240166924999926],
              [136.04420006600003, -12.231133721999925],
              [136.06023196700005, -12.23219166499996],
              [136.06714928500003, -12.253106377999927],
              [136.062836134, -12.26458098799992],
              [136.05347741000003, -12.26921965899993],
              [136.0439559250001, -12.270928643999923],
              [136.03980553500003, -12.273858330999929],
              [136.03825931100005, -12.282321872999944],
              [136.02613366000003, -12.31145598799992],
              [135.9902449880001, -12.353692315999922],
              [135.98511803500003, -12.36296965899993],
              [135.985687696, -12.37273528399993],
              [135.98804772200003, -12.385186455999929],
              [135.99333743600005, -12.393243096999925],
              [136.00180097700002, -12.39031340899993],
              [136.01384524800005, -12.383396091999941],
              [136.01628665500004, -12.392185153999947],
              [136.01246178500003, -12.41383228999996],
              [136.0166121750001, -12.435723565999922],
              [136.02320397200003, -12.455661716999941],
              [136.03394616000003, -12.465915622999944],
              [136.05005944100003, -12.458184502999927],
              [136.05445397200003, -12.448418877999927],
              [136.05494225400003, -12.43840911299992],
              [136.05811608200008, -12.43059661299992],
              [136.0708113940001, -12.42750416499996],
              [136.07642662900003, -12.42937590899993],
              [136.07935631600003, -12.434177341999941],
              [136.081390821, -12.439711195999905],
              [136.0844832690001, -12.444512627999927],
              [136.0908309250001, -12.447849216999941],
              [136.0962020190001, -12.446058851999908],
              [136.10181725400003, -12.442966403999947],
              [136.14136803500003, -12.435153903999947],
              [136.14909915500004, -12.434991143999923],
              [136.157074415, -12.440524997999944],
              [136.169281446, -12.45794036299992],
              [136.17359459700003, -12.461602471999925],
              [136.19605553500003, -12.45989348799992],
              [136.2172957690001, -12.455254815999922],
              [136.25269616000003, -12.44109465899993],
              [136.284515821, -12.41578541499996],
              [136.30453535200002, -12.383558851999908],
              [136.3339949880001, -12.304620049999926],
              [136.36394290500004, -12.256442966999941],
              [136.3681746750001, -12.239434502999927],
              [136.36304772200003, -12.222914320999905],
              [136.34978274800005, -12.210870049999926],
              [136.33220462300005, -12.203545830999929],
              [136.3134871750001, -12.201592705999929],
              [136.30062910200002, -12.20435963299991],
              [136.2773973410001, -12.20822957699994],
              [136.25941563600009, -12.20898431799992],
              [136.23494254700006, -12.211159572999918],
              [136.2251082690001, -12.191827080999929],
              [136.21469160200002, -12.187920830999929],
              [136.18824303500003, -12.192071221999925],
              [136.180023634, -12.187758070999905],
              [136.17701256600003, -12.17083098799992],
              [136.18238366000003, -12.162530205999929],
              [136.19556725400003, -12.15829843499995],
              [136.2246199880001, -12.153741143999923],
              [136.2309676440001, -12.13209400799991],
              [136.283539259, -12.06568775799991],
              [136.30046634200005, -12.050713799999926],
              [136.3203231130001, -12.049004815999922],
              [136.32960045700008, -12.051364841999941],
              [136.336273634, -12.05006275799991],
              [136.3618270190001, -12.02353280999995],
              [136.38542728000004, -12.005303643999923],
              [136.41822350400003, -11.97356536299992],
              [136.42945397200003, -11.965264580999929],
              [136.4404403000001, -11.962009372999944],
              [136.45071310100002, -11.94233345099991],
              [136.46506552300002, -11.945811682999931],
              [136.48085759800006, -11.950690850999933],
              [136.51230977800003, -11.94079174199993],
              [136.5258147950001, -11.921820858999922],
              [136.55298255900004, -11.916128496999931],
              [136.56583184800002, -11.909079521999956],
              [136.56432197200002, -11.89156023299995],
              [136.572215014, -11.896442752999917],
              [136.58156494700006, -11.906925487999956],
              [136.57803150100005, -11.91675022399994],
              [136.56305219, -11.927309200999957],
              [136.54808052500005, -11.939271839999947],
              [136.52809258800005, -11.949150664999934],
              [136.51594084700002, -11.951993118999951],
              [136.498790579, -11.958348440999941],
              [136.48016872300002, -11.95839254799995],
              [136.4694465980001, -11.96681134299996],
              [136.47025109100002, -11.986424620999912],
              [136.4774893550001, -12.002518360999943],
              [136.4896826690001, -12.006687463999924],
              [136.504655124, -11.993334149999953],
              [136.5196620380001, -11.987685387999932],
              [136.53328864000002, -11.99324609599995],
              [136.54851245300006, -12.03870171099993],
              [136.56013401200005, -12.079250938999905],
              [136.586625862, -12.083353149999937],
              [136.581739652, -12.112055144999943],
              [136.5818893930001, -12.148430154999915],
              [136.59057533700002, -12.17427816199995],
              [136.61207116000003, -12.192559502999927],
              [136.621918165, -12.208428643999923],
              [136.64991295700008, -12.236260674999926],
              [136.6587020190001, -12.256117445999905],
              [136.66358483200008, -12.263604424999926],
              [136.69060306100005, -12.282810153999947],
              [136.719086134, -12.28134530999995],
              [136.74537194100003, -12.265801690999922],
              [136.76587975400003, -12.242608330999929],
              [136.75953209700003, -12.233168226999908],
              [136.75277754, -12.225762627999927],
              [136.72816896400002, -12.219878132999952],
              [136.711650717, -12.206660383999917],
              [136.70084580000002, -12.190619640999955],
              [136.6794395290001, -12.204698561999919],
              [136.6857929800001, -12.184385302999942],
              [136.71370372400008, -12.185668814999929],
              [136.72938905, -12.173011751999923],
              [136.76091556100005, -12.164483330999929],
              [136.77995853000004, -12.172051690999922],
              [136.80746504, -12.194756768999923],
              [136.8247758440001, -12.213857282999925],
              [136.8491143660001, -12.214442061999932],
              [136.87637950600003, -12.22341389199994],
              [136.9066670100001, -12.261752860999934],
              [136.92691069300008, -12.28896756599994],
              [136.93412694100005, -12.322354551999922],
              [136.92781627300008, -12.34898340199993],
              [136.94933956600005, -12.35586896299992],
              [136.96998131600003, -12.345879815999922],
              [136.98365319100003, -12.34547291499996],
              [136.97144616000003, -12.365980726999908],
              [136.96363366000003, -12.372491143999923],
              [136.95622806100005, -12.374932549999926],
              [136.94792728000004, -12.376397393999923],
              [136.92795848800006, -12.376974209999958],
              [136.90867731600008, -12.388972398999954],
              [136.86163788200008, -12.434679398999947],
              [136.79398690800008, -12.516122783999947],
              [136.78332302600006, -12.534358814999905],
              [136.77117711300002, -12.541406028999916],
              [136.76824012300006, -12.52462860099996],
              [136.78003991000003, -12.50790780999995],
              [136.80062910200002, -12.482679945999905],
              [136.80250084700003, -12.477715752999927],
              [136.8051863940001, -12.467543226999908],
              [136.805511915, -12.456475518999923],
              [136.80062910200002, -12.447930596999925],
              [136.78980553500003, -12.445489190999922],
              [136.78142337300005, -12.450616143999923],
              [136.77466881600003, -12.45794036299992],
              [136.76970462300005, -12.461602471999925],
              [136.7402449880001, -12.475762627999927],
              [136.73804772200003, -12.507989190999922],
              [136.74467946700008, -12.547828249999952],
              [136.76128537700004, -12.574338011999942],
              [136.74170983200008, -12.57350025799991],
              [136.731781446, -12.578301690999922],
              [136.7011824880001, -12.61614348799992],
              [136.6792219670001, -12.671291745999952],
              [136.69725954400008, -12.698527971999908],
              [136.69013797700006, -12.713272209999957],
              [136.67009524800005, -12.70517343499995],
              [136.62769616000003, -12.70240650799991],
              [136.6084090500001, -12.71493905999995],
              [136.601898634, -12.73365650799991],
              [136.60906009200005, -12.75090911299992],
              [136.62176275600007, -12.764006382999924],
              [136.62256920700008, -12.786553643999923],
              [136.62086022200003, -12.796482028999947],
              [136.62322024800005, -12.807061455999929],
              [136.621918165, -12.818536065999922],
              [136.610687696, -12.830336195999905],
              [136.59742272200003, -12.831231377999927],
              [136.586273634, -12.823011976999908],
              [136.58155358200008, -12.80828215899993],
              [136.57935631600003, -12.792575778999947],
              [136.56959069100003, -12.765232028999947],
              [136.567230665, -12.753350518999923],
              [136.56511478000004, -12.748223565999922],
              [136.55925540500004, -12.745212497999944],
              [136.55144290500004, -12.74382903399993],
              [136.5434676440001, -12.74342213299991],
              [136.53302481100002, -12.74831273399991],
              [136.52730063600006, -12.754733703999932],
              [136.52571533900004, -12.769170084999928],
              [136.53232639700002, -12.779570922999937],
              [136.53402318400003, -12.793198573999916],
              [136.53242844800002, -12.804426400999944],
              [136.51190194100002, -12.80529667299993],
              [136.49634850400003, -12.780368747999944],
              [136.47925866000003, -12.766696872999944],
              [136.4716903000001, -12.773858330999929],
              [136.47380618600005, -12.79225025799991],
              [136.482758009, -12.825778903999947],
              [136.4848738940001, -12.842461846999925],
              [136.48975670700008, -12.850762627999927],
              [136.5263778000001, -12.88054778399993],
              [136.54566491000003, -12.871840101999908],
              [136.54672285200002, -12.891208591999941],
              [136.5454207690001, -12.912855726999908],
              [136.5571395190001, -12.911716403999947],
              [136.56788170700008, -12.91187916499996],
              [136.61290811800006, -12.938678460999938],
              [136.63694389700004, -12.954940948999933],
              [136.6406291950001, -12.975950654999906],
              [136.65749396, -12.99573930999992],
              [136.6567488940001, -13.006605726999908],
              [136.65202884200005, -13.01344166499996],
              [136.64185631600003, -13.00872161299992],
              [136.63233483200008, -13.000583591999941],
              [136.6294051440001, -12.996677341999941],
              [136.62126712300005, -12.98919036299992],
              [136.6201278000001, -12.982842705999929],
              [136.61687259200005, -12.979913018999923],
              [136.6020613940001, -12.982354424999926],
              [136.58171569500007, -13.01406796799995],
              [136.56528081500005, -13.01172934999994],
              [136.56433450300005, -12.979729221999946],
              [136.55524021500003, -12.963761793999936],
              [136.5400496750001, -12.96184661299992],
              [136.5395613940001, -12.96412525799991],
              [136.5332137380001, -12.97429778399993],
              [136.532562696, -12.97625090899993],
              [136.52686608200008, -12.975681247999944],
              [136.5180770190001, -12.968357028999947],
              [136.5127059250001, -12.96884530999995],
              [136.49675540500004, -12.975192966999941],
              [136.49333743600005, -12.98023853999996],
              [136.4921981130001, -12.992933851999908],
              [136.49398847700002, -13.000258070999905],
              [136.49830162900003, -13.007989190999922],
              [136.5039168630001, -13.014092705999929],
              [136.50928795700008, -13.01653411299992],
              [136.52214603000004, -13.018649997999944],
              [136.52369225400003, -13.023858330999929],
              [136.5224715500001, -13.03053150799991],
              [136.5342234630001, -13.050250837999954],
              [136.567230665, -13.058200778999947],
              [136.539351688, -13.102241592999917],
              [136.53133380600002, -13.155082657999912],
              [136.513212458, -13.143144240999959],
              [136.492688273, -13.148819085999946],
              [136.48124522500007, -13.166464421999933],
              [136.47803795700008, -13.191989841999941],
              [136.47803795700008, -13.227634372999944],
              [136.47234134200005, -13.242364190999922],
              [136.457367384, -13.250583591999941],
              [136.45769290500004, -13.240899346999925],
              [136.4560653000001, -13.232598565999922],
              [136.450531446, -13.216403903999947],
              [136.4438582690001, -13.216403903999947],
              [136.43474368600005, -13.227715752999927],
              [136.3992470070001, -13.242004468999937],
              [136.38851972700002, -13.264255466999941],
              [136.367523634, -13.297621351999908],
              [136.35330924900006, -13.310276058999932],
              [136.34262465400002, -13.321538448999945],
              [136.331087389, -13.319979111999942],
              [136.3327156050001, -13.310353935999956],
              [136.3220007980001, -13.30798913399991],
              [136.321153685, -13.295969144999958],
              [136.3447371750001, -13.28134530999995],
              [136.34169158300006, -13.27025120199994],
              [136.335077641, -13.259059063999928],
              [136.33752407200006, -13.24863618899991],
              [136.3515207910001, -13.248586823999915],
              [136.36553157600008, -13.254944874999921],
              [136.38196712, -13.245275707999951],
              [136.38819420700008, -13.225762627999927],
              [136.38190050600008, -13.213231591999943],
              [136.36703605800005, -13.194870487999935],
              [136.37106944200002, -13.165235967999934],
              [136.3644415450001, -13.150850944999945],
              [136.3681746750001, -13.095635674999926],
              [136.3715926440001, -13.06536223799992],
              [136.36548912900003, -13.055108330999929],
              [136.3435525440001, -13.046855122999943],
              [136.33285632900004, -13.046882375999928],
              [136.318695509, -13.063083591999941],
              [136.31023196700005, -13.076104424999926],
              [136.304194262, -13.090993215999958],
              [136.305885643, -13.10619992799991],
              [136.32097415500004, -13.121270440999922],
              [136.31173296000009, -13.138207533999946],
              [136.3117745730001, -13.154220786999929],
              [136.30836022200003, -13.162774346999925],
              [136.2900496750001, -13.16570403399993],
              [136.2734481130001, -13.160414320999905],
              [136.26099694100003, -13.129327080999929],
              [136.24927819100003, -13.129652601999908],
              [136.23755944100003, -13.13876718499995],
              [136.23218834700003, -13.150567315999922],
              [136.23650149800005, -13.166680596999925],
              [136.24390709700003, -13.18254973799992],
              [136.24537194100003, -13.19703541499996],
              [136.23218834700003, -13.208916924999926],
              [136.22486412900003, -13.203545830999929],
              [136.2177840500001, -13.204685153999947],
              [136.21265709700003, -13.211521091999941],
              [136.21111087300005, -13.222588799999926],
              [136.21111087300005, -13.216403903999947],
              [136.2070418630001, -13.23211028399993],
              [136.1938582690001, -13.23528411299992],
              [136.17741946700005, -13.23560963299991],
              [136.15861788200004, -13.262878108999928],
              [136.14785442900006, -13.238857754999913],
              [136.13873426100008, -13.206813317999945],
              [136.15699303500003, -13.172458591999941],
              [136.15650475400003, -13.146905205999929],
              [136.14763431100005, -13.122247002999927],
              [136.13656660200002, -13.125176690999922],
              [136.10399003300006, -13.15880533099994],
              [136.08585547000007, -13.199746099999913],
              [136.08586749100004, -13.230227315999912],
              [136.0767793550001, -13.231054473999905],
              [136.06397545700008, -13.22275155999995],
              [136.05836022200003, -13.224867445999905],
              [136.05347741000003, -13.230075778999947],
              [136.05241946700005, -13.245293877999927],
              [136.0590926440001, -13.29265715899993],
              [136.05347741000003, -13.311944268999923],
              [136.04664147200003, -13.311944268999923],
              [136.03980553500003, -13.287041924999926],
              [136.03695722700002, -13.260023695999905],
              [136.03044681100005, -13.236586195999905],
              [136.00828480500002, -13.215504805999956],
              [135.99141666100002, -13.219386293999946],
              [135.97754497000005, -13.231960651999941],
              [135.967706808, -13.275441815999955],
              [135.95681118800007, -13.288021288999914],
              [135.95191491000003, -13.26344166499996],
              [135.94283850300008, -13.256149131999905],
              [135.923994559, -13.266797495999924],
              [135.9111106580001, -13.28419787599995],
              [135.90716932200007, -13.302557298999943],
              [135.88336490100005, -13.325764369999945],
              [135.883429278, -13.36730579999994],
              [135.91285241000003, -13.374118747999944],
              [135.92089700100007, -13.37749502999992],
              [135.9253859690001, -13.386248148999925],
              [135.926270166, -13.398496403999957],
              [135.91636154800005, -13.403732618999925],
              [135.92264669400004, -13.415117274999943],
              [135.93637129, -13.416761976999908],
              [135.9594832690001, -13.415134372999944],
              [135.96461022200003, -13.415134372999944],
              [135.9694349250001, -13.425652422999917],
              [135.96762308300003, -13.436147759999926],
              [135.96461022200003, -13.449151299999926],
              [135.9458113940001, -13.446465752999927],
              [135.93677819100003, -13.45094166499996],
              [135.91987672100004, -13.46410437599991],
              [135.899432724, -13.437799430999917],
              [135.8805278650001, -13.43009384599992],
              [135.860657392, -13.437843090999934],
              [135.85474694100003, -13.45598723799992],
              [135.86101321700005, -13.48015715899993],
              [135.86101321700005, -13.504489841999941],
              [135.86939537900003, -13.539808851999908],
              [135.86841881600003, -13.551527601999908],
              [135.86402428500003, -13.557386976999908],
              [135.8574324880001, -13.561618747999944],
              [135.85084069100003, -13.567478122999944],
              [135.84742272200003, -13.578301690999922],
              [135.8448373440001, -13.600186004999955],
              [135.85280574500007, -13.615638460999946],
              [135.87074007, -13.653305842999941],
              [135.884686064, -13.666812082999911],
              [135.91627037900003, -13.65398528399993],
              [135.9184676440001, -13.658461195999905],
              [135.92212975400003, -13.669854424999926],
              [135.92310631600003, -13.67506275799991],
              [135.89372806100005, -13.687920830999929],
              [135.8867293630001, -13.713636976999908],
              [135.9013778000001, -13.738864841999941],
              [135.93677819100003, -13.750176690999922],
              [135.96989993600005, -13.74228280999995],
              [135.9965926440001, -13.722588799999926],
              [136.03296959700003, -13.67506275799991],
              [136.0361434250001, -13.666192315999922],
              [136.03589928500003, -13.65984465899993],
              [136.03736412900003, -13.65439218499995],
              [136.04664147200003, -13.64771900799991],
              [136.05534915500004, -13.645928643999923],
              [136.0634871750001, -13.647556247999944],
              [136.0703231130001, -13.650974216999941],
              [136.07447350400003, -13.65398528399993],
              [136.07789147200003, -13.662692966999941],
              [136.07178795700008, -13.67115650799991],
              [136.05347741000003, -13.688164971999925],
              [136.047211134, -13.70126718499995],
              [136.03296959700003, -13.750176690999922],
              [136.0048934250001, -13.798028252999927],
              [136.0127059250001, -13.808200778999947],
              [136.0127059250001, -13.82195403399993],
              [136.0048934250001, -13.846368096999925],
              [136.00171959700003, -13.851006768999923],
              [135.99724368600005, -13.854913018999923],
              [135.993011915, -13.86060963299991],
              [135.99138431100005, -13.870700778999947],
              [135.99244225400003, -13.89421965899993],
              [135.99138431100005, -13.901055596999925],
              [135.96461022200003, -13.935804945999905],
              [135.92310631600003, -13.959649346999925],
              [135.9033309250001, -14.135837497999944],
              [135.90943444100003, -14.195245049999926],
              [135.88990319100003, -14.18954843499995],
              [135.8696395190001, -14.192071221999925],
              [135.85377037900003, -14.20086028399993],
              [135.84742272200003, -14.21298593499995],
              [135.84197024800005, -14.219170830999929],
              [135.81853274800005, -14.22356536299992],
              [135.81324303500003, -14.22665780999995],
              [135.8086043630001, -14.22665780999995],
              [135.78931725400003, -14.240655205999929],
              [135.786468946, -14.243584893999923],
              [135.759125196, -14.26539478999996],
              [135.73414147200003, -14.29810963299991],
              [135.67530358200008, -14.406182549999926],
              [135.66774099400004, -14.427263997999944],
              [135.650237919, -14.436481707999917],
              [135.62468509200005, -14.431573174999926],
              [135.6093856130001, -14.452569268999923],
              [135.55460248500003, -14.545692537999912],
              [135.532257748, -14.581084406999935],
              [135.517865679, -14.616486202999909],
              [135.52263431100005, -14.651543877999927],
              [135.50342858200008, -14.662692966999941],
              [135.47934004, -14.67083098799992],
              [135.45378665500004, -14.68564218499995],
              [135.4433699880001, -14.699883721999925],
              [135.44011478000004, -14.71217213299991],
              [135.4340926440001, -14.720635674999926],
              [135.4160262380001, -14.722832940999922],
              [135.40406334700003, -14.719008070999905],
              [135.39087975400003, -14.713148695999905],
              [135.378265821, -14.712334893999923],
              [135.3681746750001, -14.722832940999922],
              [135.38404381600003, -14.725681247999944],
              [135.39128665500004, -14.73992278399993],
              [135.3955184250001, -14.778008721999925],
              [135.40398196700005, -14.813897393999923],
              [135.4477645190001, -14.916273695999905],
              [135.469574415, -14.948011976999908],
              [135.551117384, -15.019138278999947],
              [135.5810653000001, -15.035902601999908],
              [135.6152449880001, -15.04615650799991],
              [135.62574303500003, -15.045505466999941],
              [135.64568118600005, -15.03997161299992],
              [135.652679884, -15.042413018999923],
              [135.66976972700002, -15.06609465899993],
              [135.69752037900003, -15.08684661299992],
              [135.7089949880001, -15.097588799999926],
              [135.71762129, -15.114434502999927],
              [135.7363387380001, -15.109551690999922],
              [135.75904381600003, -15.115411065999922],
              [135.77849368600005, -15.12672291499996],
              [135.786468946, -15.13795338299991],
              [135.79615319100003, -15.146661065999922],
              [135.86101321700005, -15.175957940999922],
              [135.88795006600003, -15.199802341999941],
              [135.91822350400003, -15.233982028999947],
              [135.9516707690001, -15.264418226999908],
              [135.9882918630001, -15.277764580999929],
              [136.00310306100005, -15.28134530999995],
              [136.0434676440001, -15.30169036299992],
              [136.06031334700003, -15.313083591999941],
              [136.090668165, -15.33993905999995],
              [136.10124759200005, -15.347263278999947],
              [136.1123153000001, -15.35165780999995],
              [136.13640384200005, -15.357842705999929],
              [136.16578209700003, -15.38014088299991],
              [136.2060653000001, -15.396742445999905],
              [136.2246199880001, -15.408623955999929],
              [136.23707116000003, -15.41920338299991],
              [136.24008222700002, -15.424086195999905],
              [136.25733483200008, -15.470879815999922],
              [136.267914259, -15.54501718499995],
              [136.27320397200003, -15.55950286299992],
              [136.28443444100003, -15.570977471999925],
              [136.33082116000003, -15.60442473799992],
              [136.34839928500003, -15.613864841999941],
              [136.395843946, -15.61728280999995],
              [136.4165145190001, -15.621514580999929],
              [136.46802819100003, -15.674248955999929],
              [136.49382571700005, -15.690036716999941],
              [136.50904381600003, -15.70476653399993],
              [136.52857506600003, -15.719008070999905],
              [136.5537215500001, -15.724053643999923],
              [136.56267337300005, -15.720310153999947],
              [136.57252037900003, -15.713636976999908],
              [136.58318118600005, -15.70907968499995],
              [136.5947371750001, -15.710870049999926],
              [136.598480665, -15.71803150799991],
              [136.60621178500003, -15.744805596999925],
              [136.61207116000003, -15.754652601999908],
              [136.6582137380001, -15.787774346999925],
              [136.6704207690001, -15.799086195999905],
              [136.704437696, -15.84734465899993],
              [136.71509850400003, -15.854261976999908],
              [136.72291100400003, -15.86223723799992],
              [136.71794681100005, -15.88014088299991],
              [136.70875084700003, -15.900567315999922],
              [136.70460045700008, -15.915215752999927],
              [136.71558678500003, -15.935967705999929],
              [136.73414147200003, -15.938571872999944],
              [136.7519637380001, -15.928480726999908],
              [136.7597762380001, -15.912041924999926],
              [136.767914259, -15.900811455999929],
              [136.78695722700002, -15.90048593499995],
              [136.8281356130001, -15.908949476999908],
              [136.859711134, -15.90748463299991],
              [136.8696395190001, -15.908949476999908],
              [136.8794051440001, -15.914727471999925],
              [136.89958743600005, -15.93254973799992],
              [136.90650475400003, -15.936211846999925],
              [136.92554772200003, -15.934665622999944],
              [136.9257918630001, -15.92864348799992],
              [136.922211134, -15.91611093499995],
              [136.92986087300005, -15.895277601999908],
              [136.94263756600003, -15.885511976999908],
              [136.98316491000003, -15.865899346999925],
              [136.99187259200005, -15.86419036299992],
              [137.00806725400003, -15.89185963299991],
              [137.0459090500001, -15.922295830999929],
              [137.0903426440001, -15.946709893999923],
              [137.1347762380001, -15.95989348799992],
              [137.153656446, -15.974053643999923],
              [137.16041100400003, -15.977227471999925],
              [137.17945397200003, -15.978773695999905],
              [137.18897545700008, -15.981133721999925],
              [137.19800866000003, -15.984633070999905],
              [137.25025475400003, -16.020603122999944],
              [137.25953209700003, -16.028741143999923],
              [137.264984571, -16.04078541499996],
              [137.29175866000003, -16.071872653999947],
              [137.36117597700002, -16.122165622999944],
              [137.3798934250001, -16.12867603999996],
              [137.40259850400003, -16.128106377999927],
              [137.4130965500001, -16.130791924999926],
              [137.41773522200003, -16.138604424999926],
              [137.42172285200002, -16.149183851999908],
              [137.43140709700003, -16.15081145599993],
              [137.4423934250001, -16.14902109199994],
              [137.4511824880001, -16.149102471999925],
              [137.4751082690001, -16.17115650799991],
              [137.4853621750001, -16.176446221999925],
              [137.497406446, -16.17742278399993],
              [137.51921634200005, -16.171482028999947],
              [137.53003991000003, -16.16961028399993],
              [137.55046634200005, -16.17197030999995],
              [137.66089928500003, -16.21135833099993],
              [137.689789259, -16.231215101999908],
              [137.73023522200003, -16.24382903399993],
              [137.7461043630001, -16.252129815999922],
              [137.78012129, -16.302992445999905],
              [137.78467858200008, -16.31845468499995],
              [137.8447371750001, -16.400567315999922],
              [137.84913170700008, -16.412041924999926],
              [137.86687259200005, -16.437107028999947],
              [137.91285241000003, -16.477634372999944],
              [137.94996178500003, -16.510511976999908],
              [138.00017337300005, -16.54159921699994],
              [138.000824415, -16.542087497999944],
              [138.0615340500001, -16.612725518999923],
              [138.1020613940001, -16.633965752999927],
              [138.15349368600005, -16.676853122999944],
              [138.18425540500004, -16.697198174999926],
              [138.21998131600003, -16.70989348799992],
              [138.23715254, -16.71843840899993],
              [138.262054884, -16.723728122999944],
              [138.270843946, -16.724541924999926],
              [138.277679884, -16.727634372999944],
              [138.2895613940001, -16.74146900799991],
              [138.29411868600005, -16.745700778999947],
              [138.311859571, -16.749607028999947],
              [138.37322024800005, -16.745700778999947],
              [138.40308678500003, -16.757256768999923],
              [138.44654381600003, -16.779554945999905],
              [138.4926863940001, -16.794366143999923],
              [138.54468834700003, -16.77898528399993],
              [138.64795983200008, -16.778008721999925],
              [138.6572371750001, -16.77971770599993],
              [138.684418165, -16.808851820999905],
              [138.69507897200003, -16.813897393999923],
              [138.71021569100003, -16.81731536299992],
              [138.7382918630001, -16.834242445999905],
              [138.75342858200008, -16.841241143999923],
              [138.80445397200003, -16.851006768999923],
              [138.8403426440001, -16.87086353999996],
              [138.8696395190001, -16.878024997999944],
              [138.97136478000004, -16.884698174999926],
              [139.0083113940001, -16.89544036299992],
              [139.03728274800005, -16.915622653999947],
              [139.06218509200005, -16.977634372999944],
              [139.09343509200005, -17.002211195999905],
              [139.15805097700002, -17.03297291499996],
              [139.1406356130001, -17.06617603999996],
              [139.1416121750001, -17.11687590899993],
              [139.15251712300005, -17.16855234199994],
              [139.16431725400003, -17.20370859199994],
              [139.2094832690001, -17.28606536299992],
              [139.23991946700005, -17.323418877999927],
              [139.27418053500003, -17.348321221999925],
              [139.31430097700002, -17.35914478999996],
              [139.40162194100003, -17.366387627999927],
              [139.43864993600005, -17.375664971999925],
              [139.44890384200005, -17.38176848799992],
              [139.47282962300005, -17.403008721999925],
              [139.5087996750001, -17.42001718499995],
              [139.51783287900003, -17.426853122999944],
              [139.531586134, -17.440850518999923],
              [139.57585696700005, -17.47128671699994],
              [139.61793053500003, -17.513929945999905],
              [139.640961134, -17.532403252999927],
              [139.66863040500004, -17.540134372999944],
              [139.69654381600003, -17.543145440999922],
              [139.7812606130001, -17.56682708099993],
              [139.8046981130001, -17.568536065999922],
              [139.819672071, -17.578383070999905],
              [139.83171634200005, -17.58953215899993],
              [139.92530358200008, -17.621351820999905],
              [139.93336022200003, -17.632012627999927],
              [139.954437696, -17.668633721999925],
              [139.99048912900003, -17.70086028399993],
              [139.99952233200008, -17.706149997999944],
              [140.11744225400003, -17.715590101999908],
              [140.24048912900003, -17.70208098799992],
              [140.4043074880001, -17.667901299999926],
              [140.42408287900003, -17.66057708099993],
              [140.43238366000003, -17.653090101999908],
              [140.4414168630001, -17.641778252999927],
              [140.46265709700003, -17.638278903999947],
              [140.50749759200005, -17.636325778999947],
              [140.52320397200003, -17.630303643999923],
              [140.53858483200008, -17.620700778999947],
              [140.56617272200003, -17.597832940999922],
              [140.57536868600005, -17.59343840899993],
              [140.59791100400003, -17.59026458099993],
              [140.6074324880001, -17.58456796699994],
              [140.61589603000004, -17.577243747999944],
              [140.64470462300005, -17.56064218499995],
              [140.6738387380001, -17.53289153399993],
              [140.68897545700008, -17.522881768999923],
              [140.73414147200003, -17.51620859199994],
              [140.74333743600005, -17.507989190999922],
              [140.7470809250001, -17.49504973799992],
              [140.75513756600003, -17.478122653999947],
              [140.76832116000003, -17.46803150799991],
              [140.78931725400003, -17.459242445999905],
              [140.8129988940001, -17.453057549999926],
              [140.83326256600003, -17.450778903999947],
              [140.84522545700008, -17.44117603999996],
              [140.856293165, -17.419854424999926],
              [140.88306725400003, -17.346449476999908],
              [140.8945418630001, -17.26213958099993],
              [140.904633009, -17.224786065999922],
              [140.91089928500003, -17.21526458099993],
              [140.9326278000001, -17.19068775799991],
              [140.93824303500003, -17.16073984199994],
              [140.94312584700003, -17.152520440999922],
              [140.94898522200003, -17.138848565999922],
              [140.9599715500001, -17.07398853999996],
              [140.9560653000001, -17.056573174999926],
              [140.94939212300005, -17.03720468499995],
              [140.94703209700003, -17.018324476999908],
              [140.95622806100005, -17.00204843499995],
              [141.05054772200003, -16.88762786299992],
              [141.08350670700008, -16.800225518999923],
              [141.0903426440001, -16.797133070999905],
              [141.11003665500004, -16.79534270599993],
              [141.1176863940001, -16.79338958099993],
              [141.12427819100003, -16.787286065999922],
              [141.1455184250001, -16.75872161299992],
              [141.19947350400003, -16.703057549999926],
              [141.206390821, -16.686944268999923],
              [141.20964603000004, -16.672051690999922],
              [141.22413170700008, -16.63925546699994],
              [141.23422285200002, -16.573011976999908],
              [141.24480228000004, -16.556084893999923],
              [141.26156660200002, -16.560153903999947],
              [141.2837020190001, -16.518731377999927],
              [141.29265384200005, -16.495538018999923],
              [141.296234571, -16.47437916499996],
              [141.30225670700008, -16.454278252999927],
              [141.30396569100003, -16.44198984199994],
              [141.29948978000004, -16.43645598799992],
              [141.29127037900003, -16.431573174999926],
              [141.288422071, -16.42050546699994],
              [141.2895613940001, -16.40243905999995],
              [141.29566491000003, -16.38876718499995],
              [141.31861412900003, -16.36028411299992],
              [141.32374108200008, -16.344008070999905],
              [141.32732181100005, -16.323663018999923],
              [141.3442488940001, -16.283461195999905],
              [141.34978274800005, -16.265232028999947],
              [141.34978274800005, -16.22429778399993],
              [141.35279381600003, -16.21526458099993],
              [141.36207116000003, -16.200290622999944],
              [141.36931399800005, -16.179131768999923],
              [141.4248153000001, -16.08171965899993],
              [141.43116295700008, -16.06178150799991],
              [141.41293379, -16.041761976999908],
              [141.37875410200002, -15.937920830999929],
              [141.37769616000003, -15.92937590899993],
              [141.3837996750001, -15.91765715899993],
              [141.401703321, -15.90357838299991],
              [141.40552819100003, -15.89185963299991],
              [141.40650475400003, -15.85133228999996],
              [141.43970787900003, -15.648858330999929],
              [141.48707116000003, -15.478936455999929],
              [141.57056725400003, -15.287286065999922],
              [141.5752059250001, -15.271661065999922],
              [141.57764733200008, -15.236504815999922],
              [141.58090254, -15.218682549999926],
              [141.589203321, -15.205824476999908],
              [141.60425866000003, -15.20322030999995],
              [141.597992384, -15.182305596999925],
              [141.6093856130001, -15.168715101999908],
              [141.62680097700002, -15.156996351999908],
              [141.639008009, -15.141208591999941],
              [141.63738040500004, -15.12476978999996],
              [141.63257897200003, -15.106540622999944],
              [141.63599694100003, -15.093682549999926],
              [141.65894616000003, -15.093926690999922],
              [141.6533309250001, -15.075372002999927],
              [141.65691165500004, -15.055271091999941],
              [141.66325931100005, -15.033868096999925],
              [141.66570071700005, -15.01140715899993],
              [141.66163170700008, -14.99032968499995],
              [141.65406334700003, -14.971123955999929],
              [141.64372806100005, -14.955010674999926],
              [141.63152103000004, -14.942559502999927],
              [141.63152103000004, -14.936293226999908],
              [141.6372176440001, -14.927178643999923],
              [141.6118270190001, -14.895603122999944],
              [141.60425866000003, -14.877699476999908],
              [141.5459090500001, -14.62004973799992],
              [141.54281660200002, -14.555840752999927],
              [141.53980553500003, -14.539808851999908],
              [141.52613366000003, -14.50367603999996],
              [141.52165774800005, -14.483819268999923],
              [141.52320397200003, -14.44068775799991],
              [141.53337649800005, -14.40016041499996],
              [141.59205162900003, -14.245293877999927],
              [141.60108483200008, -14.204278252999927],
              [141.60425866000003, -14.16106536299992],
              [141.598480665, -14.11451588299991],
              [141.5839949880001, -14.076104424999926],
              [141.56226647200003, -14.044528903999947],
              [141.53541100400003, -14.017754815999922],
              [141.48503665500004, -13.94850025799991],
              [141.4677840500001, -13.865492445999905],
              [141.47413170700008, -13.77629973799992],
              [141.52702884200005, -13.571384372999944],
              [141.55046634200005, -13.524021091999941],
              [141.55583743600005, -13.500664971999925],
              [141.55982506600003, -13.49195728999996],
              [141.5898543630001, -13.454685153999947],
              [141.5996199880001, -13.438571872999944],
              [141.62566165500004, -13.36923593499995],
              [141.63152103000004, -13.346123955999929],
              [141.642914259, -13.351739190999922],
              [141.65414472700002, -13.353122653999947],
              [141.6645613940001, -13.35084400799991],
              [141.67310631600003, -13.346123955999929],
              [141.660980665, -13.328383070999905],
              [141.6645613940001, -13.314385674999926],
              [141.67400149800005, -13.30169036299992],
              [141.67937259200005, -13.287774346999925],
              [141.68132571700005, -13.279229424999926],
              [141.690765821, -13.25986093499995],
              [141.69361412900003, -13.250583591999941],
              [141.6933699880001, -13.241306247999944],
              [141.68816165500004, -13.22942473799992],
              [141.68677819100003, -13.219496351999908],
              [141.68506920700008, -13.215264580999929],
              [141.681000196, -13.209567966999941],
              [141.67546634200005, -13.204278252999927],
              [141.662445509, -13.199802341999941],
              [141.658539259, -13.194105726999908],
              [141.65552819100003, -13.18726978999996],
              [141.65211022200003, -13.181573174999926],
              [141.64332116000003, -13.17156340899993],
              [141.63599694100003, -13.160088799999926],
              [141.62468509200005, -13.133884372999944],
              [141.62061608200008, -13.118584893999923],
              [141.6157332690001, -13.049004815999922],
              [141.60425866000003, -13.006605726999908],
              [141.600922071, -13.003513278999947],
              [141.59400475400003, -13.000176690999922],
              [141.5869246750001, -12.994886976999908],
              [141.58375084700003, -12.985772393999923],
              [141.58545983200008, -12.97747161299992],
              [141.6054793630001, -12.94345468499995],
              [141.61744225400003, -12.928155205999929],
              [141.62769616000003, -12.910902601999908],
              [141.63152103000004, -12.893649997999944],
              [141.6445418630001, -12.90797291499996],
              [141.66138756600003, -12.899021091999941],
              [141.6796981130001, -12.882256768999923],
              [141.71607506600003, -12.863946221999925],
              [141.73747806100005, -12.842461846999925],
              [141.754730665, -12.81845468499995],
              [141.76197350400003, -12.801202080999929],
              [141.76539147200003, -12.785414320999905],
              [141.78923587300005, -12.722914320999905],
              [141.7954207690001, -12.693536065999922],
              [141.8012801440001, -12.677992445999905],
              [141.80974368600005, -12.66765715899993],
              [141.82007897200003, -12.666436455999929],
              [141.82203209700003, -12.677992445999905],
              [141.81714928500003, -12.701836846999925],
              [141.8232528000001, -12.701836846999925],
              [141.8359481130001, -12.67945728999996],
              [141.85336347700002, -12.684747002999927],
              [141.86890709700003, -12.700372002999927],
              [141.88209069100003, -12.71803150799991],
              [141.89283287900003, -12.777520440999922],
              [141.89210045700008, -12.821465752999927],
              [141.89405358200008, -12.843357028999947],
              [141.90211022200003, -12.852715752999927],
              [141.91130618600005, -12.859958591999941],
              [141.93873131600003, -12.908461195999905],
              [141.9379988940001, -12.890883070999905],
              [141.93921959700003, -12.869317315999922],
              [141.9379988940001, -12.84742603999996],
              [141.92139733200008, -12.812432549999926],
              [141.91391035200002, -12.770603122999944],
              [141.9052840500001, -12.75709400799991],
              [141.98902428500003, -12.73023853999996],
              [142.0083113940001, -12.71493905999995],
              [141.98226972700002, -12.716729424999926],
              [141.95264733200008, -12.715020440999922],
              [141.92530358200008, -12.710056247999944],
              [141.9052840500001, -12.701836846999925],
              [141.891449415, -12.68287525799991],
              [141.88152103000004, -12.672295830999929],
              [141.83179772200003, -12.657810153999947],
              [141.8232528000001, -12.65406666499996],
              [141.8369246750001, -12.640069268999923],
              [141.87419681100005, -12.62004973799992],
              [141.89763431100005, -12.603448174999926],
              [141.9189559250001, -12.596449476999908],
              [141.92945397200003, -12.588555596999925],
              [141.9379988940001, -12.584649346999925],
              [141.95045006600003, -12.58375416499996],
              [141.97413170700008, -12.585137627999927],
              [141.94703209700003, -12.575290622999944],
              [141.93091881600003, -12.565606377999927],
              [141.91773522200003, -12.56568775799991],
              [141.89909915500004, -12.585137627999927],
              [141.88550866000003, -12.578871351999908],
              [141.87029056100005, -12.579685153999947],
              [141.83757571700005, -12.585137627999927],
              [141.81137129, -12.58407968499995],
              [141.79761803500003, -12.580010674999926],
              [141.78296959700003, -12.571465752999927],
              [141.77173912900003, -12.560153903999947],
              [141.7578231130001, -12.535577080999929],
              [141.74822024800005, -12.523695570999905],
              [141.7363387380001, -12.516045830999929],
              [141.69361412900003, -12.50318775799991],
              [141.73422285200002, -12.47551848799992],
              [141.75114993600005, -12.461114190999922],
              [141.74480228000004, -12.45476653399993],
              [141.69996178500003, -12.457696221999925],
              [141.68376712300005, -12.454278252999927],
              [141.66570071700005, -12.44109465899993],
              [141.6640731130001, -12.445489190999922],
              [141.66358483200008, -12.44622161299992],
              [141.66236412900003, -12.446058851999908],
              [141.65894616000003, -12.447930596999925],
              [141.66089928500003, -12.465915622999944],
              [141.65894616000003, -12.52711353999996],
              [141.66358483200008, -12.52825286299992],
              [141.686859571, -12.52906666499996],
              [141.696625196, -12.533949476999908],
              [141.69996178500003, -12.544366143999923],
              [141.68873131600003, -12.546807549999926],
              [141.66570071700005, -12.54420338299991],
              [141.62183678500003, -12.562107028999947],
              [141.599945509, -12.561944268999923],
              [141.59058678500003, -12.54078541499996],
              [141.5947371750001, -12.526055596999925],
              [141.69361412900003, -12.31145598799992],
              [141.70826256600003, -12.248304945999905],
              [141.717133009, -12.232842705999929],
              [141.7324324880001, -12.229180596999925],
              [141.77076256600003, -12.243259372999944],
              [141.78923587300005, -12.242608330999929],
              [141.79908287900003, -12.238946221999925],
              [141.80974368600005, -12.236260674999926],
              [141.79957116000003, -12.231215101999908],
              [141.792328321, -12.223809502999927],
              [141.78874759200005, -12.21379973799992],
              [141.78923587300005, -12.201592705999929],
              [141.78296959700003, -12.201592705999929],
              [141.7793074880001, -12.208103122999944],
              [141.7734481130001, -12.215997002999927],
              [141.76628665500004, -12.220961195999905],
              [141.75855553500003, -12.218926690999922],
              [141.75342858200008, -12.208103122999944],
              [141.75513756600003, -12.19500090899993],
              [141.7661238940001, -12.153415622999944],
              [141.78492272200003, -12.115655205999929],
              [141.80103600400003, -12.055108330999929],
              [141.83122806100005, -12.00595468499995],
              [141.87134850400003, -11.966241143999923],
              [141.91334069100003, -11.954522393999923],
              [141.90308678500003, -11.975355726999908],
              [141.89820397200003, -11.990980726999908],
              [141.8989363940001, -12.007419528999947],
              [141.916351759, -12.06609465899993],
              [141.91968834700003, -12.085544528999947],
              [141.91960696700005, -12.106052341999941],
              [141.9521590500001, -12.046075127999927],
              [141.9638778000001, -12.037774346999925],
              [141.97575931100005, -12.041436455999929],
              [142.0219832690001, -12.071872653999947],
              [142.03296959700003, -12.041192315999922],
              [142.03003991000003, -12.02857838299991],
              [142.0117293630001, -12.02353280999995],
              [141.9970809250001, -11.994317315999922],
              [141.991547071, -11.985935153999947],
              [141.97925866000003, -11.978773695999905],
              [141.96900475400003, -11.97828541499996],
              [141.960297071, -11.979099216999941],
              [141.95297285200002, -11.975681247999944],
              [141.94418379, -11.944105726999908],
              [141.947601759, -11.89617278399993],
              [141.9672957690001, -11.811211846999925],
              [142.01002037900003, -11.757989190999922],
              [142.0117293630001, -11.746026299999926],
              [142.00660241000003, -11.729261976999908],
              [142.01050866000003, -11.70517343499995],
              [142.1318465500001, -11.338148695999905],
              [142.134125196, -11.315606377999927],
              [142.1318465500001, -11.259698174999926],
              [142.13347415500004, -11.236748955999929],
              [142.13819420700008, -11.220961195999905],
              [142.1523543630001, -11.187432549999926],
              [142.15935306100005, -11.151136976999908],
              [142.15805097700002, -11.066664320999905],
              [142.145355665, -10.983086846999925],
              [142.15105228000004, -10.950616143999923],
              [142.17457116000003, -10.930108330999929],
              [142.2212020190001, -10.919854424999926],
              [142.22803795700008, -10.927341403999947],
              [142.23902428500003, -10.91773853999996],
              [142.25766035200002, -10.911228122999944],
              [142.27955162900003, -10.907403252999927],
              [142.29997806100005, -10.906182549999926],
              [142.32341556100005, -10.90162525799991],
              [142.3403426440001, -10.890232028999947],
              [142.36451256600003, -10.858493747999944],
              [142.40113366000003, -10.82040780999995],
              [142.40609785200002, -10.806898695999905],
              [142.40894616000003, -10.791761976999908],
              [142.42497806100005, -10.74504973799992],
              [142.4340926440001, -10.728122653999947],
              [142.448578321, -10.71453215899993],
              [142.463226759, -10.711195570999905],
              [142.50513756600003, -10.715020440999922],
              [142.51059004, -10.71184661299992],
              [142.52686608200008, -10.697686455999929],
              [142.53248131600003, -10.694512627999927],
              [142.53532962300005, -10.69345468499995],
              [142.53728274800005, -10.69109465899993],
              [142.54029381600003, -10.68873463299991],
              [142.54615319100003, -10.687676690999922],
              [142.55005944100003, -10.690199476999908],
              [142.54957116000003, -10.696384372999944],
              [142.54835045700008, -10.70322030999995],
              [142.54957116000003, -10.708184502999927],
              [142.56373131600003, -10.717054945999905],
              [142.60084069100003, -10.734958591999941],
              [142.61500084700003, -10.74537525799991],
              [142.61589603000004, -10.752373955999929],
              [142.6118270190001, -10.762383721999925],
              [142.60621178500003, -10.77239348799992],
              [142.60108483200008, -10.779554945999905],
              [142.59302819100003, -10.786309502999927],
              [142.5771590500001, -10.792087497999944],
              [142.57007897200003, -10.79697030999995],
              [142.56397545700008, -10.80641041499996],
              [142.5551863940001, -10.82903411299992],
              [142.54957116000003, -10.83798593499995],
              [142.54184004, -10.84156666499996],
              [142.5214949880001, -10.84693775799991],
              [142.51539147200003, -10.85165780999995],
              [142.5102645190001, -10.876560153999947],
              [142.51384524800005, -10.90016041499996],
              [142.51482181100005, -10.92351653399993],
              [142.50171959700003, -10.947849216999941],
              [142.52271569100003, -10.941582940999922],
              [142.5400496750001, -10.92546965899993],
              [142.55201256600003, -10.904229424999926],
              [142.55640709700003, -10.882256768999923],
              [142.56714928500003, -10.870212497999944],
              [142.5908309250001, -10.86492278399993],
              [142.61451256600003, -10.868259372999944],
              [142.62525475400003, -10.882256768999923],
              [142.63445071700005, -10.930840752999927],
              [142.64039147200003, -10.931898695999905],
              [142.64918053500003, -10.92945728999996],
              [142.65943444100003, -10.933526299999926],
              [142.66822350400003, -10.95126718499995],
              [142.659515821, -10.983493747999944],
              [142.66627037900003, -11.003106377999927],
              [142.67839603000004, -10.98219166499996],
              [142.70093834700003, -10.970147393999923],
              [142.7251082690001, -10.96770598799992],
              [142.74195397200003, -10.975030205999929],
              [142.74626712300005, -10.985772393999923],
              [142.752289259, -11.01531340899993],
              [142.75896243600005, -11.02662525799991],
              [142.7695418630001, -11.038995049999926],
              [142.77808678500003, -11.05364348799992],
              [142.78980553500003, -11.08489348799992],
              [142.79517662900003, -11.112888278999947],
              [142.79664147200003, -11.143243096999925],
              [142.80681399800005, -11.167575778999947],
              [142.81006920700008, -11.17115650799991],
              [142.80616295700008, -11.17945728999996],
              [142.79664147200003, -11.194756768999923],
              [142.79371178500003, -11.217543226999908],
              [142.79420006600003, -11.248304945999905],
              [142.8012801440001, -11.277764580999929],
              [142.81763756600003, -11.29656340899993],
              [142.82960045700008, -11.29461028399993],
              [142.84058678500003, -11.308038018999923],
              [142.8486434250001, -11.326918226999908],
              [142.85181725400003, -11.34156666499996],
              [142.85499108200008, -11.351169528999947],
              [142.8691512380001, -11.37200286299992],
              [142.87224368600005, -11.38250090899993],
              [142.8696395190001, -11.391289971999925],
              [142.86353600400003, -11.399997653999947],
              [142.85181725400003, -11.413262627999927],
              [142.8300887380001, -11.452243747999944],
              [142.82105553500003, -11.477634372999944],
              [142.82764733200008, -11.489027601999908],
              [142.83961022200003, -11.498630466999941],
              [142.8408309250001, -11.520684502999927],
              [142.83757571700005, -11.564711195999905],
              [142.8418074880001, -11.574476820999905],
              [142.85417728000004, -11.594008070999905],
              [142.8579207690001, -11.605075778999947],
              [142.86548912900003, -11.73601653399993],
              [142.8579207690001, -11.821709893999923],
              [142.8623153000001, -11.83684661299992],
              [142.87289472700002, -11.850681247999944],
              [142.92750084700003, -11.893731377999927],
              [142.94019616000003, -11.892754815999922],
              [142.97429446700005, -11.925225518999923],
              [142.9921981130001, -11.934014580999929],
              [143.02068118600005, -11.931573174999926],
              [143.04021243600005, -11.92506275799991],
              [143.0771590500001, -11.906833591999941],
              [143.10417728000004, -11.90211353999996],
              [143.123383009, -11.910577080999929],
              [143.17530358200008, -11.962334893999923],
              [143.18384850400003, -11.963555596999925],
              [143.200531446, -11.962009372999944],
              [143.22803795700008, -11.95484791499996],
              [143.23951256600003, -11.95631275799991],
              [143.2490340500001, -11.968194268999923],
              [143.239105665, -11.978122653999947],
              [143.22722415500004, -11.98211028399993],
              [143.203949415, -11.98251718499995],
              [143.105804884, -12.135430596999925],
              [143.10132897200003, -12.140232028999947],
              [143.09099368600005, -12.14267343499995],
              [143.086273634, -12.149021091999941],
              [143.08383222700002, -12.167413018999923],
              [143.08521569100003, -12.170586846999925],
              [143.090668165, -12.19817473799992],
              [143.0903426440001, -12.210381768999923],
              [143.0888778000001, -12.21998463299991],
              [143.08480879, -12.22820403399993],
              [143.0771590500001, -12.236260674999926],
              [143.08171634200005, -12.239841403999947],
              [143.086273634, -12.246351820999905],
              [143.090668165, -12.25009530999995],
              [143.0825301440001, -12.268161716999941],
              [143.078461134, -12.287041924999926],
              [143.0771590500001, -12.328789971999925],
              [143.0849715500001, -12.33684661299992],
              [143.10336347700002, -12.342380466999941],
              [143.1391707690001, -12.346123955999929],
              [143.17603600400003, -12.339288018999923],
              [143.18539472700002, -12.342543226999908],
              [143.2050887380001, -12.356622002999927],
              [143.21119225400003, -12.359958591999941],
              [143.2529403000001, -12.388929945999905],
              [143.2563582690001, -12.392754815999922],
              [143.262054884, -12.400811455999929],
              [143.27173912900003, -12.417901299999926],
              [143.2758895190001, -12.433038018999923],
              [143.2783309250001, -12.49504973799992],
              [143.28435306100005, -12.516045830999929],
              [143.2949324880001, -12.53484465899993],
              [143.31039472700002, -12.550957940999922],
              [143.32349694100003, -12.557793877999927],
              [143.36207116000003, -12.569512627999927],
              [143.37623131600003, -12.571465752999927],
              [143.3911238940001, -12.576592705999929],
              [143.4072371750001, -12.588311455999929],
              [143.433929884, -12.61305103999996],
              [143.433929884, -12.619317315999922],
              [143.4111434250001, -12.64771900799991],
              [143.40219160200002, -12.666192315999922],
              [143.41000410200002, -12.674493096999925],
              [143.41187584700003, -12.68254973799992],
              [143.3794051440001, -12.732842705999929],
              [143.37769616000003, -12.750664971999925],
              [143.36508222700002, -12.804864190999922],
              [143.3642684250001, -12.861748955999929],
              [143.35889733200008, -12.88054778399993],
              [143.3794051440001, -12.852715752999927],
              [143.38819420700008, -12.859551690999922],
              [143.4004012380001, -12.865817966999941],
              [143.41325931100005, -12.86809661299992],
              [143.42367597700002, -12.863213799999926],
              [143.438324415, -12.85133228999996],
              [143.44841556100005, -12.85133228999996],
              [143.4580184250001, -12.85637786299992],
              [143.47193444100003, -12.859551690999922],
              [143.49724368600005, -12.856540622999944],
              [143.5117293630001, -12.849216403999947],
              [143.5244246750001, -12.840427341999941],
              [143.543793165, -12.832777601999908],
              [143.495453321, -12.92156340899993],
              [143.51148522200003, -12.95435963299991],
              [143.51246178500003, -12.99700286299992],
              [143.5029403000001, -13.07512786299992],
              [143.52759850400003, -13.198418877999927],
              [143.52662194100003, -13.32976653399993],
              [143.52995853000004, -13.341973565999922],
              [143.533539259, -13.349541924999926],
              [143.57056725400003, -13.377129815999922],
              [143.57300866000003, -13.388278903999947],
              [143.58545983200008, -13.40520598799992],
              [143.59107506600003, -13.415134372999944],
              [143.59441165500004, -13.427178643999923],
              [143.594574415, -13.435804945999905],
              [143.58171634200005, -13.498711846999925],
              [143.58326256600003, -13.516778252999927],
              [143.59791100400003, -13.524183851999908],
              [143.591156446, -13.543552341999941],
              [143.5644637380001, -13.59937916499996],
              [143.5556746750001, -13.63290780999995],
              [143.54761803500003, -13.691989841999941],
              [143.53345787900003, -13.731540622999944],
              [143.53012129, -13.750176690999922],
              [143.53443444100003, -13.76572030999995],
              [143.5532332690001, -13.802992445999905],
              [143.5576278000001, -13.822198174999926],
              [143.56226647200003, -13.83212655999995],
              [143.59449303500003, -13.877129815999922],
              [143.59831790500004, -13.885023695999905],
              [143.59791100400003, -13.915215752999927],
              [143.60108483200008, -13.926527601999908],
              [143.60564212300005, -13.936944268999923],
              [143.6113387380001, -13.946872653999947],
              [143.61841881600003, -13.956231377999927],
              [143.67839603000004, -14.00359465899993],
              [143.68726647200003, -14.014336846999925],
              [143.695648634, -14.075290622999944],
              [143.69410241000003, -14.092868747999944],
              [143.704437696, -14.114353122999944],
              [143.70777428500003, -14.209567966999941],
              [143.74870853000004, -14.33993905999995],
              [143.78272545700008, -14.402276299999926],
              [143.80494225400003, -14.431573174999926],
              [143.83130944100003, -14.456475518999923],
              [143.8462020190001, -14.467217705999929],
              [143.859711134, -14.474867445999905],
              [143.87427819100003, -14.48023853999996],
              [143.89275149800005, -14.483819268999923],
              [143.92603600400003, -14.486504815999922],
              [143.93506920700008, -14.493259372999944],
              [143.94117272200003, -14.511163018999923],
              [143.95199629, -14.49895598799992],
              [143.9629012380001, -14.494561455999929],
              [143.98894290500004, -14.490655205999929],
              [144.03052819100003, -14.467054945999905],
              [144.067230665, -14.452569268999923],
              [144.11345462300005, -14.40520598799992],
              [144.12916100400003, -14.394463799999926],
              [144.14633222700002, -14.388116143999923],
              [144.16163170700008, -14.37314218499995],
              [144.17335045700008, -14.355075778999947],
              [144.180023634, -14.33993905999995],
              [144.18279056100005, -14.314060153999947],
              [144.18189537900003, -14.28606536299992],
              [144.18539472700002, -14.26262786299992],
              [144.2011824880001, -14.250420830999929],
              [144.204437696, -14.256442966999941],
              [144.2114363940001, -14.265232028999947],
              [144.2148543630001, -14.270928643999923],
              [144.2197371750001, -14.266208591999941],
              [144.22291100400003, -14.264255466999941],
              [144.2255965500001, -14.262139580999929],
              [144.2285262380001, -14.257256768999923],
              [144.2353621750001, -14.257256768999923],
              [144.2509871750001, -14.291680596999925],
              [144.2558699880001, -14.29892343499995],
              [144.2680770190001, -14.30364348799992],
              [144.2802840500001, -14.302911065999922],
              [144.29216556100005, -14.303480726999908],
              [144.30355879, -14.31259530999995],
              [144.44027754, -14.250258070999905],
              [144.4482528000001, -14.243584893999923],
              [144.46705162900003, -14.19654713299991],
              [144.47217858200008, -14.189060153999947],
              [144.47527103000004, -14.186130466999941],
              [144.47608483200008, -14.179131768999923],
              [144.4755965500001, -14.164808851999908],
              [144.478851759, -14.15992603999996],
              [144.4863387380001, -14.16187916499996],
              [144.49976647200003, -14.168552341999941],
              [144.51490319100003, -14.17278411299992],
              [144.5224715500001, -14.181817315999922],
              [144.5273543630001, -14.191013278999947],
              [144.53386478000004, -14.195245049999926],
              [144.54371178500003, -14.204278252999927],
              [144.58472741000003, -14.264825127999927],
              [144.576508009, -14.281182549999926],
              [144.5727645190001, -14.302911065999922],
              [144.57178795700008, -14.343194268999923],
              [144.580414259, -14.36419036299992],
              [144.6001082690001, -14.365411065999922],
              [144.62094160200002, -14.354668877999927],
              [144.633148634, -14.33993905999995],
              [144.63746178500003, -14.356215101999908],
              [144.63347415500004, -14.37664153399993],
              [144.62525475400003, -14.393975518999923],
              [144.61646569100003, -14.40129973799992],
              [144.61247806100005, -14.41301848799992],
              [144.61597741000003, -14.46770598799992],
              [144.619476759, -14.483819268999923],
              [144.6259871750001, -14.49114348799992],
              [144.65357506600003, -14.511163018999923],
              [144.65984134200005, -14.52125416499996],
              [144.67058353000004, -14.546807549999926],
              [144.67758222700002, -14.555840752999927],
              [144.69752037900003, -14.561944268999923],
              [144.73975670700008, -14.552178643999923],
              [144.75660241000003, -14.55282968499995],
              [144.77100670700008, -14.56609465899993],
              [144.782074415, -14.584242445999905],
              [144.79672285200002, -14.600355726999908],
              [144.82154381600003, -14.607354424999926],
              [144.88599694100003, -14.609633070999905],
              [144.900726759, -14.61419036299992],
              [144.90845787900003, -14.622165622999944],
              [144.91041100400003, -14.62981536299992],
              [144.910980665, -14.638278903999947],
              [144.91431725400003, -14.647637627999927],
              [144.92009524800005, -14.65601978999996],
              [144.9379988940001, -14.67156340899993],
              [144.936859571, -14.676202080999929],
              [144.941742384, -14.72633228999996],
              [144.94410241000003, -14.73333098799992],
              [144.95533287900003, -14.74391041499996],
              [145.01384524800005, -14.78411223799992],
              [145.03052819100003, -14.80592213299991],
              [145.055023634, -14.79265715899993],
              [145.07732181100005, -14.801446221999925],
              [145.09913170700008, -14.817803643999923],
              [145.12289472700002, -14.826429945999905],
              [145.136078321, -14.828383070999905],
              [145.1547957690001, -14.837497653999947],
              [145.16822350400003, -14.840101820999905],
              [145.18246504, -14.838962497999944],
              [145.207855665, -14.832614841999941],
              [145.22282962300005, -14.832696221999925],
              [145.21168053500003, -14.859551690999922],
              [145.21998131600003, -14.88095468499995],
              [145.27711022200003, -14.94703541499996],
              [145.2934676440001, -14.949883721999925],
              [145.3134871750001, -14.944024346999925],
              [145.3457137380001, -14.942559502999927],
              [145.33228600400003, -14.97047291499996],
              [145.25733483200008, -15.075616143999923],
              [145.24732506600003, -15.09498463299991],
              [145.23585045700008, -15.165948174999926],
              [145.23902428500003, -15.18254973799992],
              [145.25318444100003, -15.212090752999927],
              [145.25993899800005, -15.239678643999923],
              [145.26880944100003, -15.249444268999923],
              [145.28101647200003, -15.25562916499996],
              [145.29420006600003, -15.25790780999995],
              [145.31006920700008, -15.254489841999941],
              [145.317718946, -15.245212497999944],
              [145.324554884, -15.216241143999923],
              [145.34197024800005, -15.229668877999927],
              [145.34945722700002, -15.250420830999929],
              [145.3437606130001, -15.269463799999926],
              [145.30258222700002, -15.284600518999923],
              [145.28589928500003, -15.30046965899993],
              [145.28101647200003, -15.319024346999925],
              [145.2978621750001, -15.33294036299992],
              [145.28825931100005, -15.343194268999923],
              [145.28663170700008, -15.35320403399993],
              [145.2871199880001, -15.36337655999995],
              [145.2837020190001, -15.37395598799992],
              [145.278656446, -15.377536716999941],
              [145.262054884, -15.384942315999922],
              [145.2563582690001, -15.388848565999922],
              [145.2480574880001, -15.40601978999996],
              [145.24390709700003, -15.428399346999925],
              [145.24586022200003, -15.44264088299991],
              [145.2563582690001, -15.435967705999929],
              [145.26441491000003, -15.435967705999929],
              [145.2778426440001, -15.475355726999908],
              [145.2797957690001, -15.49586353999996],
              [145.26726321700005, -15.504978122999944],
              [145.26392662900003, -15.50904713299991],
              [145.26490319100003, -15.51848723799992],
              [145.26840254, -15.527927341999941],
              [145.2734481130001, -15.53215911299992],
              [145.273773634, -15.535739841999941],
              [145.309906446, -15.56259530999995],
              [145.31397545700008, -15.567966403999947],
              [145.32146243600005, -15.590101820999905],
              [145.3227645190001, -15.599786065999922],
              [145.321136915, -15.60914478999996],
              [145.30738366000003, -15.62859465899993],
              [145.30933678500003, -15.633965752999927],
              [145.31519616000003, -15.638116143999923],
              [145.35377037900003, -15.72242603999996],
              [145.36280358200008, -15.734551690999922],
              [145.36638431100005, -15.74928150799991],
              [145.3593856130001, -15.79656340899993],
              [145.3593856130001, -15.812676690999922],
              [145.36508222700002, -15.822523695999905],
              [145.3701278000001, -15.827325127999927],
              [145.37322024800005, -15.83171965899993],
              [145.3730574880001, -15.840590101999908],
              [145.368500196, -15.852146091999941],
              [145.35531660200002, -15.872247002999927],
              [145.3525496750001, -15.88486093499995],
              [145.355804884, -15.903415622999944],
              [145.36402428500003, -15.916192315999922],
              [145.3867293630001, -15.936211846999925],
              [145.4301863940001, -15.991631768999923],
              [145.450531446, -16.02711353999996],
              [145.46241295700008, -16.060479424999926],
              [145.46241295700008, -16.098728122999944],
              [145.44027754, -16.165459893999923],
              [145.434418165, -16.200616143999923],
              [145.437836134, -16.201918226999908],
              [145.4589949880001, -16.214043877999927],
              [145.462250196, -16.220310153999947],
              [145.46859785200002, -16.244805596999925],
              [145.46859785200002, -16.26067473799992],
              [145.46241295700008, -16.27320728999996],
              [145.431000196, -16.302992445999905],
              [145.4145613940001, -16.33440520599993],
              [145.41431725400003, -16.408868096999925],
              [145.4004012380001, -16.443291924999926],
              [145.40398196700005, -16.455010674999926],
              [145.40902754, -16.46542734199994],
              [145.41675866000003, -16.473321221999925],
              [145.42758222700002, -16.478122653999947],
              [145.44809004, -16.47039153399993],
              [145.4633895190001, -16.481215101999908],
              [145.47282962300005, -16.501560153999947],
              [145.47608483200008, -16.52190520599993],
              [145.4814559250001, -16.531914971999925],
              [145.51710045700008, -16.56698984199994],
              [145.530609571, -16.601006768999923],
              [145.54900149800005, -16.62086353999996],
              [145.5517684250001, -16.62558359199994],
              [145.55583743600005, -16.640069268999923],
              [145.56609134200005, -16.656508070999905],
              [145.5791121750001, -16.67197030999995],
              [145.62623131600003, -16.712090752999927],
              [145.6377059250001, -16.71851978999996],
              [145.661468946, -16.727959893999923],
              [145.671234571, -16.73479583099993],
              [145.67595462300005, -16.743340752999927],
              [145.680023634, -16.76572030999995],
              [145.68531334700003, -16.776055596999925],
              [145.694672071, -16.78443775799991],
              [145.71355228000004, -16.793633721999925],
              [145.72250410200002, -16.800225518999923],
              [145.74341881600003, -16.848321221999925],
              [145.75855553500003, -16.858982028999947],
              [145.774261915, -16.877211195999905],
              [145.777679884, -16.88534921699994],
              [145.77369225400003, -16.898370049999926],
              [145.76433353000004, -16.90203215899993],
              [145.7529403000001, -16.903497002999927],
              [145.74366295700008, -16.90943775799991],
              [145.74048912900003, -16.922051690999922],
              [145.74756920700008, -16.93254973799992],
              [145.75945071700005, -16.94345468499995],
              [145.770843946, -16.957289320999905],
              [145.7724715500001, -16.964776299999926],
              [145.77076256600003, -16.98137786299992],
              [145.774261915, -16.98837655999995],
              [145.78345787900003, -16.991631768999923],
              [145.7929793630001, -16.989434502999927],
              [145.79835045700008, -16.983168226999908],
              [145.78858483200008, -16.962090752999927],
              [145.78589928500003, -16.94500090899993],
              [145.7876082690001, -16.92978280999995],
              [145.79476972700002, -16.92310963299991],
              [145.80298912900003, -16.91806405999995],
              [145.83090254, -16.892185153999947],
              [145.83912194100003, -16.881524346999925],
              [145.85694420700008, -16.892836195999905],
              [145.8676863940001, -16.904554945999905],
              [145.88038170700008, -16.905857028999947],
              [145.90406334700003, -16.88534921699994],
              [145.91163170700008, -16.876397393999923],
              [145.917328321, -16.87118905999995],
              [145.9248153000001, -16.868584893999923],
              [145.93824303500003, -16.867852471999925],
              [145.9550887380001, -16.87314218499995],
              [145.95728600400003, -16.884698174999926],
              [145.952484571, -16.896661065999922],
              [145.94898522200003, -16.902601820999905],
              [145.9472762380001, -16.902520440999922],
              [145.93734785200002, -16.912367445999905],
              [145.93482506600003, -16.91570403399993],
              [145.933929884, -16.920993747999944],
              [145.94166100400003, -16.924899997999944],
              [145.94166100400003, -16.929945570999905],
              [145.93140709700003, -16.950290622999944],
              [145.9243270190001, -16.960056247999944],
              [145.91773522200003, -16.96412525799991],
              [145.90984134200005, -16.97161223799992],
              [145.8916121750001, -17.007012627999927],
              [145.88697350400003, -17.01930103999996],
              [145.88233483200008, -17.039727471999925],
              [145.8818465500001, -17.059665622999944],
              [145.888031446, -17.07480234199994],
              [145.90406334700003, -17.080824476999908],
              [145.91179446700005, -17.088962497999944],
              [145.952484571, -17.162286065999922],
              [145.95915774800005, -17.183038018999923],
              [145.96257571700005, -17.205010674999926],
              [145.9633895190001, -17.22820403399993],
              [145.96843509200005, -17.242364190999922],
              [146.00367272200003, -17.293715101999908],
              [146.02995853000004, -17.356540622999944],
              [146.04127037900003, -17.372247002999927],
              [146.05974368600005, -17.386163018999923],
              [146.07105553500003, -17.392022393999923],
              [146.0752059250001, -17.402520440999922],
              [146.07243899800005, -17.44589609199994],
              [146.07536868600005, -17.505303643999923],
              [146.0683699880001, -17.515883070999905],
              [146.0800887380001, -17.539320570999905],
              [146.10670006600003, -17.57431405999995],
              [146.13502037900003, -17.600274346999925],
              [146.14429772200003, -17.613946221999925],
              [146.14771569100003, -17.63258228999996],
              [146.14242597700002, -17.64739348799992],
              [146.11646569100003, -17.668715101999908],
              [146.10670006600003, -17.68417734199994],
              [146.10271243600005, -17.70598723799992],
              [146.10670006600003, -17.769463799999926],
              [146.10132897200003, -17.773044528999947],
              [146.090668165, -17.783868096999925],
              [146.0839949880001, -17.79550546699994],
              [146.08936608200008, -17.80087655999995],
              [146.0962020190001, -17.805352471999925],
              [146.0962020190001, -17.81568775799991],
              [146.09359785200002, -17.82708098799992],
              [146.09302819100003, -17.83489348799992],
              [146.1074324880001, -17.853692315999922],
              [146.11353600400003, -17.864353122999944],
              [146.10474694100003, -17.876560153999947],
              [146.09937584700003, -17.90943775799991],
              [146.09644616000003, -17.91692473799992],
              [146.09791100400003, -17.93132903399993],
              [146.06983483200008, -17.998711846999925],
              [146.0214949880001, -18.085870049999926],
              [146.01514733200008, -18.116631768999923],
              [146.0058699880001, -18.142022393999923],
              [146.00367272200003, -18.156426690999922],
              [146.004242384, -18.17197030999995],
              [146.006195509, -18.18596770599993],
              [146.01050866000003, -18.19898853999996],
              [146.01734459700003, -18.211683851999908],
              [146.010101759, -18.236504815999922],
              [146.023773634, -18.263116143999923],
              [146.100922071, -18.349541924999926],
              [146.1196395190001, -18.36191171699994],
              [146.132172071, -18.364434502999927],
              [146.16358483200008, -18.36581796699994],
              [146.17505944100003, -18.369317315999922],
              [146.18344160200002, -18.38014088299991],
              [146.186859571, -18.39421965899993],
              [146.18921959700003, -18.424004815999922],
              [146.21371504, -18.492120049999926],
              [146.20915774800005, -18.51336028399993],
              [146.22925866000003, -18.50709400799991],
              [146.2509871750001, -18.511163018999923],
              [146.26823978000004, -18.518731377999927],
              [146.27466881600003, -18.523614190999922],
              [146.28882897200003, -18.515801690999922],
              [146.304047071, -18.517185153999947],
              [146.33936608200008, -18.52703215899993],
              [146.33741295700008, -18.57284921699994],
              [146.3310653000001, -18.61256275799991],
              [146.32048587300005, -18.647149346999925],
              [146.2920028000001, -18.71062590899993],
              [146.27808678500003, -18.82870859199994],
              [146.27613366000003, -18.835381768999923],
              [146.27312259200005, -18.84270598799992],
              [146.27076256600003, -18.85165780999995],
              [146.27125084700003, -18.862888278999947],
              [146.27662194100003, -18.87428150799991],
              [146.29460696700005, -18.89690520599993],
              [146.29851321700005, -18.90715911299992],
              [146.3017684250001, -18.912367445999905],
              [146.31568444100003, -18.92278411299992],
              [146.32105553500003, -18.931898695999905],
              [146.33326256600003, -18.95907968499995],
              [146.41089928500003, -19.01018645599993],
              [146.4257918630001, -19.027276299999926],
              [146.44654381600003, -19.059747002999927],
              [146.462250196, -19.074965101999908],
              [146.47925866000003, -19.083591403999947],
              [146.5185653000001, -19.09547291499996],
              [146.53467858200008, -19.105726820999905],
              [146.5556746750001, -19.128106377999927],
              [146.56169681100005, -19.13925546699994],
              [146.56902103000004, -19.140801690999922],
              [146.5781356130001, -19.140883070999905],
              [146.58659915500004, -19.142754815999922],
              [146.6547957690001, -19.18254973799992],
              [146.69304446700005, -19.192966403999947],
              [146.74634850400003, -19.17278411299992],
              [146.7607528000001, -19.18254973799992],
              [146.7783309250001, -19.21217213299991],
              [146.80445397200003, -19.237399997999944],
              [146.81918379, -19.24814218499995],
              [146.829437696, -19.252618096999925],
              [146.85035241000003, -19.264743747999944],
              [146.8750106130001, -19.28834400799991],
              [146.90512129, -19.304620049999926],
              [146.94214928500003, -19.294122002999927],
              [146.95720462300005, -19.296807549999926],
              [146.97820071700005, -19.283868096999925],
              [147.01042728000004, -19.252618096999925],
              [147.01929772200003, -19.23674895599993],
              [147.02312259200005, -19.217950127999927],
              [147.02230879, -19.19768645599993],
              [147.01783287900003, -19.17742278399993],
              [147.02409915500004, -19.17742278399993],
              [147.02881920700008, -19.19231536299992],
              [147.0478621750001, -19.21103280999995],
              [147.05201256600003, -19.22909921699994],
              [147.05396569100003, -19.233982028999947],
              [147.0629988940001, -19.242120049999926],
              [147.06511478000004, -19.246351820999905],
              [147.06397545700008, -19.25123463299991],
              [147.05933678500003, -19.258884372999944],
              [147.05201256600003, -19.290459893999923],
              [147.05201256600003, -19.300957940999922],
              [147.0586043630001, -19.31609465899993],
              [147.08122806100005, -19.34270598799992],
              [147.08619225400003, -19.35247161299992],
              [147.13396243600005, -19.410821221999925],
              [147.14665774800005, -19.398614190999922],
              [147.16724694100003, -19.399997653999947],
              [147.22250410200002, -19.41301848799992],
              [147.2446395190001, -19.42245859199994],
              [147.2544051440001, -19.424493096999925],
              [147.2627059250001, -19.42278411299992],
              [147.285980665, -19.410821221999925],
              [147.42139733200008, -19.412774346999925],
              [147.44988040500004, -19.39657968499995],
              [147.45045006600003, -19.37867603999996],
              [147.44166100400003, -19.358819268999923],
              [147.42920983200008, -19.342543226999908],
              [147.4062606130001, -19.32781340899993],
              [147.398773634, -19.312758070999905],
              [147.4023543630001, -19.303887627999927],
              [147.42261803500003, -19.314629815999922],
              [147.44483483200008, -19.34156666499996],
              [147.49146569100003, -19.451836846999925],
              [147.55046634200005, -19.520928643999923],
              [147.5590926440001, -19.53753020599993],
              [147.5615340500001, -19.562107028999947],
              [147.56853274800005, -19.58847421699994],
              [147.57927493600005, -19.613946221999925],
              [147.59327233200008, -19.636163018999923],
              [147.589203321, -19.66253020599993],
              [147.59913170700008, -19.686700127999927],
              [147.59913170700008, -19.70289478999996],
              [147.56527754, -19.70517343499995],
              [147.58033287900003, -19.712090752999927],
              [147.59205162900003, -19.722100518999923],
              [147.6137801440001, -19.753513278999947],
              [147.68425540500004, -19.828057549999926],
              [147.71941165500004, -19.833103122999944],
              [147.78500410200002, -19.835381768999923],
              [147.760101759, -19.776788018999923],
              [147.754242384, -19.767185153999947],
              [147.755218946, -19.75676848799992],
              [147.750824415, -19.69150155999995],
              [147.82390384200005, -19.714288018999923],
              [147.84595787900003, -19.73479583099993],
              [147.85922285200002, -19.824883721999925],
              [147.87427819100003, -19.85442473799992],
              [147.89795983200008, -19.87623463299991],
              [147.929047071, -19.897556247999944],
              [147.94947350400003, -19.907810153999947],
              [147.969086134, -19.911553643999923],
              [148.01490319100003, -19.911228122999944],
              [148.0180770190001, -19.906914971999925],
              [148.01970462300005, -19.897556247999944],
              [148.02214603000004, -19.888116143999923],
              [148.02857506600003, -19.883884372999944],
              [148.03467858200008, -19.88486093499995],
              [148.0439559250001, -19.88909270599993],
              [148.049164259, -19.890069268999923],
              [148.055511915, -19.887872002999927],
              [148.07243899800005, -19.87704843499995],
              [148.08375084700003, -19.88453541499996],
              [148.11451256600003, -19.91643645599993],
              [148.12086022200003, -19.92831796699994],
              [148.13038170700008, -19.936211846999925],
              [148.19654381600003, -19.945245049999926],
              [148.2539168630001, -19.96347421699994],
              [148.27857506600003, -19.96575286299992],
              [148.2719832690001, -19.985935153999947],
              [148.2793074880001, -20.00253671699994],
              [148.30640709700003, -20.033949476999908],
              [148.28500410200002, -20.038995049999926],
              [148.26490319100003, -20.047621351999908],
              [148.27523847700002, -20.055840752999927],
              [148.27881920700008, -20.06536223799992],
              [148.27523847700002, -20.074965101999908],
              [148.26490319100003, -20.083103122999944],
              [148.2900496750001, -20.093194268999923],
              [148.30152428500003, -20.09937916499996],
              [148.327484571, -20.13258228999996],
              [148.33033287900003, -20.13762786299992],
              [148.33773847700002, -20.141289971999925],
              [148.37476647200003, -20.16497161299992],
              [148.40211022200003, -20.17392343499995],
              [148.4087020190001, -20.18222421699994],
              [148.40202884200005, -20.19850025799991],
              [148.41627037900003, -20.202243747999944],
              [148.43580162900003, -20.199965101999908],
              [148.45378665500004, -20.19394296699994],
              [148.46404056100005, -20.185479424999926],
              [148.46558678500003, -20.174086195999905],
              [148.4555770190001, -20.17156340899993],
              [148.4394637380001, -20.170668226999908],
              [148.42253665500004, -20.16497161299992],
              [148.43344160200002, -20.15325286299992],
              [148.44605553500003, -20.15016041499996],
              [148.4589949880001, -20.149509372999944],
              [148.47022545700008, -20.14381275799991],
              [148.47641035200002, -20.132012627999927],
              [148.47339928500003, -20.121026299999926],
              [148.46461022200003, -20.11296965899993],
              [148.453461134, -20.10979583099993],
              [148.4438582690001, -20.104180596999925],
              [148.4375106130001, -20.09075286299992],
              [148.43702233200008, -20.074965101999908],
              [148.44418379, -20.061944268999923],
              [148.45915774800005, -20.056817315999922],
              [148.47022545700008, -20.065118096999925],
              [148.48113040500004, -20.07708098799992],
              [148.4951278000001, -20.083103122999944],
              [148.52165774800005, -20.083184502999927],
              [148.5302840500001, -20.07822030999995],
              [148.54281660200002, -20.06536223799992],
              [148.56006920700008, -20.052666924999926],
              [148.56666100400003, -20.059991143999923],
              [148.56820722700002, -20.115411065999922],
              [148.5752059250001, -20.147230726999908],
              [148.5898543630001, -20.172539971999925],
              [148.6142684250001, -20.17864348799992],
              [148.60661868600005, -20.19150155999995],
              [148.6045028000001, -20.205010674999926],
              [148.61085045700008, -20.213636976999908],
              [148.6279403000001, -20.211602471999925],
              [148.6386824880001, -20.203057549999926],
              [148.6416121750001, -20.19182708099993],
              [148.64275149800005, -20.178887627999927],
              [148.6484481130001, -20.16497161299992],
              [148.65739993600005, -20.17245859199994],
              [148.660980665, -20.180759372999944],
              [148.66032962300005, -20.18954843499995],
              [148.6552840500001, -20.19850025799991],
              [148.67530358200008, -20.190199476999908],
              [148.68311608200008, -20.185479424999926],
              [148.68311608200008, -20.19768645599993],
              [148.67937259200005, -20.20867278399993],
              [148.67212975400003, -20.218194268999923],
              [148.66277103000004, -20.226495049999926],
              [148.68311608200008, -20.237074476999908],
              [148.68930097700002, -20.239434502999927],
              [148.68531334700003, -20.24537525799991],
              [148.68287194100003, -20.25367603999996],
              [148.6821395190001, -20.26344166499996],
              [148.68311608200008, -20.274183851999908],
              [148.7216903000001, -20.257256768999923],
              [148.7407332690001, -20.251153252999927],
              [148.7583113940001, -20.253106377999927],
              [148.75668379, -20.229668877999927],
              [148.78199303500003, -20.24081796699994],
              [148.80388431100005, -20.266696872999944],
              [148.792328321, -20.287286065999922],
              [148.7973738940001, -20.294854424999926],
              [148.81072024800005, -20.30722421699994],
              [148.8134871750001, -20.31178150799991],
              [148.816742384, -20.321465752999927],
              [148.82447350400003, -20.32431405999995],
              [148.83326256600003, -20.324965101999908],
              [148.840179884, -20.328871351999908],
              [148.84937584700003, -20.348728122999944],
              [148.8476668630001, -20.362725518999923],
              [148.842133009, -20.375258070999905],
              [148.840179884, -20.390883070999905],
              [148.85084069100003, -20.421075127999927],
              [148.8711043630001, -20.43987395599993],
              [148.92335045700008, -20.472832940999922],
              [148.89812259200005, -20.477308851999908],
              [148.9052840500001, -20.494398695999905],
              [148.9248153000001, -20.51620859199994],
              [148.93702233200008, -20.53492603999996],
              [148.9282332690001, -20.53093840899993],
              [148.91968834700003, -20.529554945999905],
              [148.91130618600005, -20.53093840899993],
              [148.90219160200002, -20.53492603999996],
              [148.89600670700008, -20.52434661299992],
              [148.88599694100003, -20.51995208099993],
              [148.87574303500003, -20.521416924999926],
              [148.8681746750001, -20.528090101999908],
              [148.860199415, -20.51376718499995],
              [148.85132897200003, -20.50318775799991],
              [148.84058678500003, -20.496351820999905],
              [148.8271590500001, -20.493340752999927],
              [148.8325301440001, -20.48219166499996],
              [148.8344832690001, -20.46933359199994],
              [148.83277428500003, -20.45631275799991],
              [148.8271590500001, -20.445570570999905],
              [148.82252037900003, -20.44150155999995],
              [148.80827884200005, -20.43336353999996],
              [148.80258222700002, -20.431817315999922],
              [148.7929793630001, -20.433851820999905],
              [148.79070071700005, -20.438246351999908],
              [148.792328321, -20.445570570999905],
              [148.78541100400003, -20.455254815999922],
              [148.781586134, -20.46453215899993],
              [148.77466881600003, -20.470961195999905],
              [148.7583113940001, -20.472832940999922],
              [148.7431746750001, -20.469496351999908],
              [148.73796634200005, -20.46298593499995],
              [148.73414147200003, -20.454522393999923],
              [148.72413170700008, -20.445570570999905],
              [148.70101972700002, -20.43922291499996],
              [148.70386803500003, -20.455336195999905],
              [148.71705162900003, -20.480401299999926],
              [148.72413170700008, -20.500746351999908],
              [148.71607506600003, -20.52206796699994],
              [148.698578321, -20.543226820999905],
              [148.67693118600005, -20.556898695999905],
              [148.6552840500001, -20.555433851999908],
              [148.6601668630001, -20.572198174999926],
              [148.66871178500003, -20.586195570999905],
              [148.68930097700002, -20.610039971999925],
              [148.69117272200003, -20.61419036299992],
              [148.69418379, -20.626560153999947],
              [148.696136915, -20.63054778399993],
              [148.70264733200008, -20.633558851999908],
              [148.716156446, -20.632745049999926],
              [148.7207137380001, -20.633965752999927],
              [148.72828209700003, -20.646416924999926],
              [148.72575931100005, -20.65667083099993],
              [148.70980879, -20.678887627999927],
              [148.72575931100005, -20.685479424999926],
              [148.73975670700008, -20.718926690999922],
              [148.7617293630001, -20.726739190999922],
              [148.76726321700005, -20.731540622999944],
              [148.78239993600005, -20.755303643999923],
              [148.785492384, -20.76425546699994],
              [148.79029381600003, -20.768975518999923],
              [148.8007918630001, -20.766778252999927],
              [148.81226647200003, -20.76230234199994],
              [148.819672071, -20.76018645599993],
              [148.8320418630001, -20.763929945999905],
              [148.83904056100005, -20.76962655999995],
              [148.84351647200003, -20.777520440999922],
              [148.8476668630001, -20.788181247999944],
              [148.853851759, -20.832207940999922],
              [148.85173587300005, -20.837823174999926],
              [148.847015821, -20.84270598799992],
              [148.84245853000004, -20.849216403999947],
              [148.840179884, -20.85995859199994],
              [148.83936608200008, -20.870293877999927],
              [148.83668053500003, -20.878350518999923],
              [148.8325301440001, -20.88486093499995],
              [148.8271590500001, -20.890557549999926],
              [148.84538821700005, -20.887465101999908],
              [148.85889733200008, -20.873793226999908],
              [148.8750106130001, -20.842868747999944],
              [148.88884524800005, -20.85328541499996],
              [148.8994246750001, -20.86451588299991],
              [148.91081790500004, -20.873304945999905],
              [148.92644290500004, -20.876885674999926],
              [148.95655358200008, -20.87037525799991],
              [148.97144616000003, -20.870538018999923],
              [148.97803795700008, -20.880303643999923],
              [149.00163821700005, -20.901136976999908],
              [149.01319420700008, -20.908461195999905],
              [149.0180770190001, -20.906508070999905],
              [149.02068118600005, -20.901136976999908],
              [149.025726759, -20.898044528999947],
              [149.03972415500004, -20.89739348799992],
              [149.05632571700005, -20.89853280999995],
              [149.06950931100005, -20.90601978999996],
              [149.073578321, -20.92473723799992],
              [149.05640709700003, -20.919040622999944],
              [149.03687584700003, -20.915459893999923],
              [149.0263778000001, -20.91920338299991],
              [149.03630618600005, -20.93523528399993],
              [149.03980553500003, -20.951348565999922],
              [149.03052819100003, -20.965915622999944],
              [149.02662194100003, -20.97625090899993],
              [149.046234571, -20.979913018999923],
              [149.07935631600003, -20.96998463299991],
              [149.09498131600003, -20.969821872999944],
              [149.1015731130001, -20.98333098799992],
              [149.110199415, -20.99277109199994],
              [149.15064537900003, -20.99618905999995],
              [149.16293379, -21.00790780999995],
              [149.1665145190001, -21.02434661299992],
              [149.17505944100003, -21.037041924999926],
              [149.186859571, -21.04534270599993],
              [149.19996178500003, -21.048272393999923],
              [149.2021590500001, -21.054620049999926],
              [149.23121178500003, -21.089776299999926],
              [149.23121178500003, -21.126071872999944],
              [149.196136915, -21.18092213299991],
              [149.19654381600003, -21.220147393999923],
              [149.22584069100003, -21.27320728999996],
              [149.2343856130001, -21.28167083099993],
              [149.2421981130001, -21.27743905999995],
              [149.24976647200003, -21.258558851999908],
              [149.254730665, -21.25432708099993],
              [149.26343834700003, -21.25432708099993],
              [149.2646590500001, -21.25554778399993],
              [149.26539147200003, -21.25953541499996],
              [149.27222741000003, -21.26799895599993],
              [149.27328535200002, -21.271742445999905],
              [149.27222741000003, -21.27629973799992],
              [149.271820509, -21.279961846999925],
              [149.27564537900003, -21.28167083099993],
              [149.289886915, -21.28101978999996],
              [149.29273522200003, -21.28167083099993],
              [149.29900149800005, -21.29583098799992],
              [149.30054772200003, -21.305352471999925],
              [149.29615319100003, -21.30950286299992],
              [149.2929793630001, -21.31926848799992],
              [149.30103600400003, -21.341241143999923],
              [149.32056725400003, -21.377211195999905],
              [149.31397545700008, -21.38534921699994],
              [149.30640709700003, -21.39120859199994],
              [149.2973738940001, -21.395277601999908],
              [149.286468946, -21.39771900799991],
              [149.29639733200008, -21.409274997999944],
              [149.32642662900003, -21.414320570999905],
              [149.34107506600003, -21.42441171699994],
              [149.32496178500003, -21.437676690999922],
              [149.3071395190001, -21.447930596999925],
              [149.29249108200008, -21.461114190999922],
              [149.286468946, -21.48333098799992],
              [149.29216556100005, -21.51067473799992],
              [149.30640709700003, -21.509209893999923],
              [149.34734134200005, -21.479668877999927],
              [149.35564212300005, -21.49472421699994],
              [149.37183678500003, -21.50009530999995],
              [149.38795006600003, -21.50123463299991],
              [149.39519290500004, -21.503838799999926],
              [149.39283287900003, -21.534274997999944],
              [149.3974715500001, -21.549004815999922],
              [149.41285241000003, -21.555352471999925],
              [149.41325931100005, -21.56218840899993],
              [149.41773522200003, -21.575372002999927],
              [149.42937259200005, -21.58375416499996],
              [149.45093834700003, -21.57586028399993],
              [149.45866946700005, -21.565524997999944],
              [149.46900475400003, -21.53753020599993],
              [149.47828209700003, -21.528008721999925],
              [149.48715254, -21.535902601999908],
              [149.49170983200008, -21.545098565999922],
              [149.49878991000003, -21.56959400799991],
              [149.4472762380001, -21.620293877999927],
              [149.4419051440001, -21.637383721999925],
              [149.44703209700003, -21.66057708099993],
              [149.46461022200003, -21.698663018999923],
              [149.47437584700003, -21.711195570999905],
              [149.47828209700003, -21.71843840899993],
              [149.47828209700003, -21.726739190999922],
              [149.4716903000001, -21.73796965899993],
              [149.463226759, -21.740492445999905],
              [149.45297285200002, -21.74228280999995],
              [149.44011478000004, -21.751560153999947],
              [149.43246504, -21.76921965899993],
              [149.43539472700002, -21.789727471999925],
              [149.44507897200003, -21.81064218499995],
              [149.45720462300005, -21.829685153999947],
              [149.4658309250001, -21.84026458099993],
              [149.4716903000001, -21.845310153999947],
              [149.4755965500001, -21.85125090899993],
              [149.47828209700003, -21.864434502999927],
              [149.4775496750001, -21.873304945999905],
              [149.47217858200008, -21.896742445999905],
              [149.47087649800005, -21.908461195999905],
              [149.47437584700003, -21.92937590899993],
              [149.48316491000003, -21.951348565999922],
              [149.5214949880001, -22.01262786299992],
              [149.52491295700008, -22.028741143999923],
              [149.528656446, -22.07594166499996],
              [149.53581790500004, -22.09579843499995],
              [149.57447350400003, -22.15862395599993],
              [149.55933678500003, -22.170668226999908],
              [149.55420983200008, -22.177911065999922],
              [149.55339603000004, -22.186618747999944],
              [149.57447350400003, -22.192803643999923],
              [149.5805770190001, -22.21184661299992],
              [149.58415774800005, -22.21738046699994],
              [149.60857181100005, -22.244317315999922],
              [149.60499108200008, -22.255059502999927],
              [149.5898543630001, -22.273695570999905],
              [149.58757571700005, -22.28215911299992],
              [149.592133009, -22.28557708099993],
              [149.63941491000003, -22.302992445999905],
              [149.64478600400003, -22.306084893999923],
              [149.65308678500003, -22.313164971999925],
              [149.66163170700008, -22.327325127999927],
              [149.668793165, -22.343357028999947],
              [149.67920983200008, -22.35214609199994],
              [149.69743899800005, -22.34433359199994],
              [149.70329837300005, -22.362888278999947],
              [149.7050887380001, -22.383884372999944],
              [149.7041121750001, -22.42245859199994],
              [149.6992293630001, -22.44695403399993],
              [149.68726647200003, -22.46135833099993],
              [149.6738387380001, -22.474216403999947],
              [149.66325931100005, -22.49382903399993],
              [149.69402103000004, -22.48870208099993],
              [149.731293165, -22.46933359199994],
              [149.76539147200003, -22.445245049999926],
              [149.7861434250001, -22.42555103999996],
              [149.80152428500003, -22.38876718499995],
              [149.81275475400003, -22.378106377999927],
              [149.83082116000003, -22.388604424999926],
              [149.85816491000003, -22.421075127999927],
              [149.87086022200003, -22.44036223799992],
              [149.87614993600005, -22.456638278999947],
              [149.8808699880001, -22.46738046699994],
              [149.96404056100005, -22.53362395599993],
              [149.9716903000001, -22.545668226999908],
              [149.98023522200003, -22.57659270599993],
              [150.00066165500004, -22.60865650799991],
              [150.02523847700002, -22.633965752999927],
              [150.04672285200002, -22.645277601999908],
              [150.0224715500001, -22.553399346999925],
              [149.9555770190001, -22.401136976999908],
              [149.93718509200005, -22.380059502999927],
              [149.92847741000003, -22.35605234199994],
              [149.92994225400003, -22.338067315999922],
              [149.95069420700008, -22.34433359199994],
              [149.9433699880001, -22.328301690999922],
              [149.9306746750001, -22.31373463299991],
              [149.92351321700005, -22.298272393999923],
              [149.93344160200002, -22.278741143999923],
              [149.94312584700003, -22.264743747999944],
              [149.96111087300005, -22.220961195999905],
              [149.96827233200008, -22.188164971999925],
              [149.97820071700005, -22.173760674999926],
              [149.99048912900003, -22.162855726999908],
              [150.00220787900003, -22.15862395599993],
              [150.01783287900003, -22.155694268999923],
              [150.05355879, -22.14153411299992],
              [150.057953321, -22.14934661299992],
              [150.07732181100005, -22.157321872999944],
              [150.08155358200008, -22.162367445999905],
              [150.08318118600005, -22.171075127999927],
              [150.10222415500004, -22.217461846999925],
              [150.11060631600003, -22.23251718499995],
              [150.1196395190001, -22.244886976999908],
              [150.1294051440001, -22.25481536299992],
              [150.138031446, -22.25904713299991],
              [150.1469832690001, -22.26140715899993],
              [150.15381920700008, -22.266289971999925],
              [150.156586134, -22.278741143999923],
              [150.15691165500004, -22.28948333099993],
              [150.15796959700003, -22.297539971999925],
              [150.15992272200003, -22.304131768999923],
              [150.163422071, -22.310153903999947],
              [150.18767337300005, -22.326836846999925],
              [150.1933699880001, -22.33879973799992],
              [150.17725670700008, -22.35051848799992],
              [150.19402103000004, -22.37867603999996],
              [150.21558678500003, -22.394789320999905],
              [150.2998153000001, -22.418226820999905],
              [150.31324303500003, -22.425388278999947],
              [150.34107506600003, -22.445977471999925],
              [150.355804884, -22.45403411299992],
              [150.387054884, -22.46575286299992],
              [150.40308678500003, -22.47389088299991],
              [150.412445509, -22.482028903999947],
              [150.43091881600003, -22.503350518999923],
              [150.44410241000003, -22.514336846999925],
              [150.46078535200002, -22.52239348799992],
              [150.51295006600003, -22.535414320999905],
              [150.53394616000003, -22.548272393999923],
              [150.60914147200003, -22.610528252999927],
              [150.61540774800005, -22.603692315999922],
              [150.59913170700008, -22.58757903399993],
              [150.58326256600003, -22.55901458099993],
              [150.57488040500004, -22.530368747999944],
              [150.58122806100005, -22.514336846999925],
              [150.58122806100005, -22.508070570999905],
              [150.545258009, -22.48137786299992],
              [150.534515821, -22.42701588299991],
              [150.54371178500003, -22.36695728999996],
              [150.56763756600003, -22.32317473799992],
              [150.57593834700003, -22.330254815999922],
              [150.60173587300005, -22.34433359199994],
              [150.61841881600003, -22.33440520599993],
              [150.63624108200008, -22.342543226999908],
              [150.64372806100005, -22.356622002999927],
              [150.62907962300005, -22.364678643999923],
              [150.6337996750001, -22.37363046699994],
              [150.63502037900003, -22.38128020599993],
              [150.63160241000003, -22.38762786299992],
              [150.62281334700003, -22.392022393999923],
              [150.63428795700008, -22.39576588299991],
              [150.644867384, -22.401788018999923],
              [150.6547957690001, -22.409763278999947],
              [150.66382897200003, -22.419366143999923],
              [150.67066491000003, -22.41253020599993],
              [150.66293379, -22.40007903399993],
              [150.6606551440001, -22.384209893999923],
              [150.664886915, -22.36882903399993],
              [150.67750084700003, -22.35800546699994],
              [150.67986087300005, -22.37981536299992],
              [150.68580162900003, -22.403741143999923],
              [150.69450931100005, -22.42506275799991],
              [150.70476321700005, -22.43987395599993],
              [150.71314537900003, -22.444431247999944],
              [150.73991946700005, -22.452243747999944],
              [150.74952233200008, -22.45354583099993],
              [150.756195509, -22.45875416499996],
              [150.7597762380001, -22.47047291499996],
              [150.7583113940001, -22.482354424999926],
              [150.74952233200008, -22.48756275799991],
              [150.72339928500003, -22.51995208099993],
              [150.70582116000003, -22.528741143999923],
              [150.69792728000004, -22.504652601999908],
              [150.69011478000004, -22.499200127999927],
              [150.6762801440001, -22.506524346999925],
              [150.67164147200003, -22.520603122999944],
              [150.69109134200005, -22.535414320999905],
              [150.67750084700003, -22.562676690999922],
              [150.70386803500003, -22.55632903399993],
              [150.71607506600003, -22.562676690999922],
              [150.7192488940001, -22.580254815999922],
              [150.71900475400003, -22.60711028399993],
              [150.7226668630001, -22.623793226999908],
              [150.73194420700008, -22.628106377999927],
              [150.74333743600005, -22.622653903999947],
              [150.75318444100003, -22.610528252999927],
              [150.757172071, -22.59929778399993],
              [150.75904381600003, -22.586114190999922],
              [150.75945071700005, -22.559258721999925],
              [150.7636824880001, -22.534763278999947],
              [150.7734481130001, -22.53020598799992],
              [150.78296959700003, -22.54273853999996],
              [150.78736412900003, -22.56959400799991],
              [150.7797957690001, -22.626560153999947],
              [150.784515821, -22.653008721999925],
              [150.8071395190001, -22.65211353999996],
              [150.8134871750001, -22.671807549999926],
              [150.82642662900003, -22.697930596999925],
              [150.82764733200008, -22.713555596999925],
              [150.8232528000001, -22.733575127999927],
              [150.809906446, -22.771742445999905],
              [150.80494225400003, -22.81292083099993],
              [150.79566491000003, -22.848321221999925],
              [150.78972415500004, -22.897881768999923],
              [150.78736412900003, -22.90593840899993],
              [150.78687584700003, -22.91057708099993],
              [150.788422071, -22.922539971999925],
              [150.78736412900003, -22.926446221999925],
              [150.7817488940001, -22.927992445999905],
              [150.7656356130001, -22.92555103999996],
              [150.74146569100003, -22.929131768999923],
              [150.73650149800005, -22.93287525799991],
              [150.74236087300005, -22.94312916499996],
              [150.75074303500003, -22.950372002999927],
              [150.76880944100003, -22.96184661299992],
              [150.77369225400003, -22.96689218499995],
              [150.7739363940001, -22.97698333099993],
              [150.76929772200003, -22.986504815999922],
              [150.765961134, -22.995538018999923],
              [150.77027428500003, -23.004652601999908],
              [150.7758895190001, -23.01148853999996],
              [150.778656446, -23.01921965899993],
              [150.7797957690001, -23.03915780999995],
              [150.76099694100003, -23.12078215899993],
              [150.76441491000003, -23.158868096999925],
              [150.80095462300005, -23.179620049999926],
              [150.7939559250001, -23.19784921699994],
              [150.79468834700003, -23.213148695999905],
              [150.8017684250001, -23.22714609199994],
              [150.81397545700008, -23.24114348799992],
              [150.81609134200005, -23.23674895599993],
              [150.81959069100003, -23.232598565999922],
              [150.82146243600005, -23.22747161299992],
              [150.83904056100005, -23.24895598799992],
              [150.8325301440001, -23.27597421699994],
              [150.81177819100003, -23.29924895599993],
              [150.78736412900003, -23.309340101999908],
              [150.81421959700003, -23.411309502999927],
              [150.8418074880001, -23.43531666499996],
              [150.875824415, -23.47584400799991],
              [150.88233483200008, -23.48886484199994],
              [150.87224368600005, -23.500176690999922],
              [150.853851759, -23.50400155999995],
              [150.81397545700008, -23.50253671699994],
              [150.81397545700008, -23.509209893999923],
              [150.8369246750001, -23.51262786299992],
              [150.85661868600005, -23.51995208099993],
              [150.87037194100003, -23.53297291499996],
              [150.8754988940001, -23.553399346999925],
              [150.8857528000001, -23.57154713299991],
              [150.9082137380001, -23.56536223799992],
              [150.9296981130001, -23.55055103999996],
              [150.936859571, -23.54273853999996],
              [150.95728600400003, -23.54469166499996],
              [150.98601321700005, -23.564060153999947],
              [151.011277435, -23.56650198099993],
              [151.0274423740001, -23.57999716899991],
              [151.0415325670001, -23.612799412999948],
              [151.06983483200008, -23.62395598799992],
              [151.10271507900006, -23.653270474999943],
              [151.11468541300007, -23.665482897999937],
              [151.1259871750001, -23.675388278999947],
              [151.14340254, -23.70940520599993],
              [151.1504012380001, -23.727715752999927],
              [151.15406334700003, -23.75237395599993],
              [151.156586134, -23.761895440999922],
              [151.16089928500003, -23.77076588299991],
              [151.1743270190001, -23.790948174999926],
              [151.17701256600003, -23.793226820999905],
              [151.18718509200005, -23.804131768999923],
              [151.21045983200008, -23.813164971999925],
              [151.25277754, -23.82390715899993],
              [151.26002037900003, -23.82431405999995],
              [151.2695418630001, -23.82350025799991],
              [151.2778426440001, -23.82390715899993],
              [151.28142337300005, -23.827325127999927],
              [151.2822371750001, -23.836114190999922],
              [151.28467858200008, -23.844414971999925],
              [151.28882897200003, -23.851739190999922],
              [151.29444420700008, -23.858086846999925],
              [151.2973738940001, -23.857028903999947],
              [151.3056746750001, -23.85637786299992],
              [151.31617272200003, -23.857354424999926],
              [151.32488040500004, -23.861504815999922],
              [151.3305770190001, -23.86891041499996],
              [151.33952884200005, -23.88730234199994],
              [151.34555097700002, -23.895928643999923],
              [151.403656446, -23.949965101999908],
              [151.424164259, -23.974786065999922],
              [151.4360457690001, -23.99863046699994],
              [151.44092858200008, -24.00554778399993],
              [151.4482528000001, -24.00904713299991],
              [151.4531356130001, -24.003024997999944],
              [151.4580184250001, -23.994073174999926],
              [151.46509850400003, -23.988457940999922],
              [151.4809676440001, -23.988946221999925],
              [151.49732506600003, -23.99456145599993],
              [151.51197350400003, -24.003106377999927],
              [151.53003991000003, -24.01816171699994],
              [151.53728274800005, -24.021742445999905],
              [151.5434676440001, -24.026950778999947],
              [151.54761803500003, -24.036309502999927],
              [151.54656009200005, -24.042413018999923],
              [151.54175866000003, -24.046075127999927],
              [151.536468946, -24.04924895599993],
              [151.53402754, -24.05364348799992],
              [151.53532962300005, -24.07284921699994],
              [151.54029381600003, -24.08407968499995],
              [151.55054772200003, -24.091403903999947],
              [151.56812584700003, -24.098321221999925],
              [151.5688582690001, -24.09384530999995],
              [151.57048587300005, -24.090997002999927],
              [151.57252037900003, -24.08847421699994],
              [151.57439212300005, -24.084649346999925],
              [151.57154381600003, -24.076836846999925],
              [151.5805770190001, -24.05754973799992],
              [151.58179772200003, -24.043715101999908],
              [151.58619225400003, -24.04810963299991],
              [151.59253991000003, -24.052992445999905],
              [151.59546959700003, -24.05673593499995],
              [151.62224368600005, -24.05087655999995],
              [151.64470462300005, -24.06503671699994],
              [151.66667728000004, -24.085381768999923],
              [151.69166100400003, -24.098321221999925],
              [151.682953321, -24.062432549999926],
              [151.676117384, -24.04664478999996],
              [151.66374759200005, -24.030043226999908],
              [151.65113366000003, -24.021416924999926],
              [151.621429884, -24.006036065999922],
              [151.61589603000004, -23.99586353999996],
              [151.62378991000003, -23.98406340899993],
              [151.64136803500003, -23.97828541499996],
              [151.66187584700003, -23.977715752999927],
              [151.67798912900003, -23.981622002999927],
              [151.69068444100003, -23.991306247999944],
              [151.70069420700008, -24.002618096999925],
              [151.71306399800005, -24.01213958099993],
              [151.73259524800005, -24.016371351999908],
              [151.73259524800005, -24.022556247999944],
              [151.7099715500001, -24.04273853999996],
              [151.721039259, -24.05868905999995],
              [151.739593946, -24.06340911299992],
              [151.73943118600005, -24.05046965899993],
              [151.74976647200003, -24.046075127999927],
              [151.78044681100005, -24.022556247999944],
              [151.7802840500001, -24.05315520599993],
              [151.7861434250001, -24.088636976999908],
              [151.79704837300005, -24.12118905999995],
              [151.81137129, -24.14234791499996],
              [151.83619225400003, -24.163506768999923],
              [151.85181725400003, -24.17156340899993],
              [151.86988366000003, -24.173435153999947],
              [151.87574303500003, -24.17310963299991],
              [151.87671959700003, -24.173435153999947],
              [151.87769616000003, -24.17164478999996],
              [151.88347415500004, -24.165948174999926],
              [151.88697350400003, -24.15984465899993],
              [151.887543165, -24.153741143999923],
              [151.8896590500001, -24.148614190999922],
              [151.89771569100003, -24.14544036299992],
              [151.90007571700005, -24.155368747999944],
              [151.90121504, -24.177911065999922],
              [151.90398196700005, -24.187107028999947],
              [151.912445509, -24.196465752999927],
              [151.93336022200003, -24.21103280999995],
              [151.93734785200002, -24.217868747999944],
              [151.94092858200008, -24.23560963299991],
              [152.00367272200003, -24.410414320999905],
              [152.0586043630001, -24.513929945999905],
              [152.08464603000004, -24.53167083099993],
              [152.1230574880001, -24.591729424999926],
              [152.1504012380001, -24.619073174999926],
              [152.30616295700008, -24.724216403999947],
              [152.32569420700008, -24.72828541499996],
              [152.34595787900003, -24.73015715899993],
              [152.4047957690001, -24.748711846999925],
              [152.4394637380001, -24.77117278399993],
              [152.4697371750001, -24.80559661299992],
              [152.49146569100003, -24.847588799999926],
              [152.49976647200003, -24.892754815999922],
              [152.49976647200003, -24.978692315999922],
              [152.50603274800005, -24.999444268999923],
              [152.57781009200005, -25.099867445999905],
              [152.58228600400003, -25.108819268999923],
              [152.592133009, -25.12086353999996],
              [152.63233483200008, -25.142754815999922],
              [152.63697350400003, -25.160332940999922],
              [152.63233483200008, -25.169122002999927],
              [152.6254988940001, -25.173028252999927],
              [152.60279381600003, -25.174574476999908],
              [152.59888756600003, -25.17351653399993],
              [152.585297071, -25.16838958099993],
              [152.5786238940001, -25.167168877999927],
              [152.57154381600003, -25.169366143999923],
              [152.56788170700008, -25.174004815999922],
              [152.567718946, -25.17864348799992],
              [152.57154381600003, -25.180840752999927],
              [152.5962020190001, -25.183526299999926],
              [152.61882571700005, -25.191013278999947],
              [152.63746178500003, -25.20159270599993],
              [152.65064537900003, -25.214288018999923],
              [152.6621199880001, -25.228448174999926],
              [152.677093946, -25.24187590899993],
              [152.69703209700003, -25.251885674999926],
              [152.74634850400003, -25.25823333099993],
              [152.77230879, -25.26458098799992],
              [152.79639733200008, -25.27353280999995],
              [152.81511478000004, -25.283868096999925],
              [152.81706790500004, -25.27190520599993],
              [152.81592858200008, -25.258558851999908],
              [152.817718946, -25.247491143999923],
              [152.82878665500004, -25.24228280999995],
              [152.83570397200003, -25.247247002999927],
              [152.84253991000003, -25.270928643999923],
              [152.85328209700003, -25.276462497999944],
              [152.90113366000003, -25.283868096999925],
              [152.91382897200003, -25.28769296699994],
              [152.91814212300005, -25.29729583099993],
              [152.91814212300005, -25.324151299999926],
              [152.93181399800005, -25.416680596999925],
              [152.92603600400003, -25.42310963299991],
              [152.887054884, -25.44459400799991],
              [152.88013756600003, -25.45354583099993],
              [152.874359571, -25.46493905999995],
              [152.87037194100003, -25.475681247999944],
              [152.89039147200003, -25.46851978999996],
              [152.94418379, -25.43726978999996],
              [152.96241295700008, -25.437432549999926],
              [152.969086134, -25.45281340899993],
              [152.95972741000003, -25.46331145599993],
              [152.945648634, -25.47039153399993],
              [152.93864993600005, -25.475681247999944],
              [152.9458113940001, -25.486504815999922],
              [152.9589949880001, -25.490980726999908],
              [152.966156446, -25.497247002999927],
              [152.95573978000004, -25.513116143999923],
              [152.918793165, -25.543715101999908],
              [152.90503991000003, -25.560723565999922],
              [152.89771569100003, -25.58489348799992],
              [152.909515821, -25.64430103999996],
              [152.90796959700003, -25.66961028399993],
              [152.88404381600003, -25.67424895599993],
              [152.89380944100003, -25.688164971999925],
              [152.90837649800005, -25.69890715899993],
              [152.93864993600005, -25.715915622999944],
              [152.9243270190001, -25.72128671699994],
              [152.91814212300005, -25.722100518999923],
              [152.92701256600003, -25.740166924999926],
              [152.94288170700008, -25.75318775799991],
              [152.96265709700003, -25.760918877999927],
              [152.9834090500001, -25.763604424999926],
              [153.02125084700003, -25.82512786299992],
              [153.0278426440001, -25.844821872999944],
              [153.0341903000001, -25.88534921699994],
              [153.03484134200005, -25.90357838299991],
              [153.03305097700002, -25.907810153999947],
              [153.024261915, -25.91961028399993],
              [153.02125084700003, -25.92742278399993],
              [153.0200301440001, -25.937432549999926],
              [153.02125084700003, -25.969008070999905],
              [153.02800540500004, -25.969008070999905],
              [153.05738366000003, -25.915459893999923],
              [153.0615340500001, -25.90357838299991],
              [153.0605574880001, -25.871026299999926],
              [153.06421959700003, -25.85279713299991],
              [153.0752059250001, -25.838067315999922],
              [153.065765821, -25.82268645599993],
              [153.0615340500001, -25.817559502999927],
              [153.0771590500001, -25.825290622999944],
              [153.0839949880001, -25.83603280999995],
              [153.08936608200008, -25.865411065999922],
              [153.11003665500004, -25.917168877999927],
              [153.1215926440001, -25.933770440999922],
              [153.1489363940001, -25.943536065999922],
              [153.1806746750001, -25.944756768999923],
              [153.2055770190001, -25.934991143999923],
              [153.200043165, -25.94890715899993],
              [153.1821395190001, -25.97519296699994],
              [153.1748153000001, -25.99814218499995],
              [153.15650475400003, -26.034926039999903],
              [153.1474715500001, -26.047621351999908],
              [153.14177493600005, -26.06145598799992],
              [153.13209069100003, -26.10393645599993],
              [153.12671959700003, -26.113051039999903],
              [153.11003665500004, -26.164239190999922],
              [153.1074324880001, -26.179131768999923],
              [153.077484571, -26.280857028999947],
              [153.07406660200002, -26.316582940999922],
              [153.0752059250001, -26.335056247999944],
              [153.07976321700005, -26.35198333099993],
              [153.08936608200008, -26.366306247999944],
              [153.1035262380001, -26.37346770599993],
              [153.1171981130001, -26.374444268999923],
              [153.12916100400003, -26.378106377999927],
              [153.1372176440001, -26.39299895599993],
              [153.122406446, -26.423272393999923],
              [153.11345462300005, -26.45745208099993],
              [153.11003665500004, -26.64690520599993],
              [153.11402428500003, -26.662774346999925],
              [153.11703535200002, -26.67115650799991],
              [153.11988366000003, -26.674899997999944],
              [153.1508895190001, -26.684747002999927],
              [153.14421634200005, -26.73284270599993],
              [153.14405358200008, -26.75058359199994],
              [153.15007571700005, -26.78183359199994],
              [153.15512129, -26.79355234199994],
              [153.1611434250001, -26.798272393999923],
              [153.15211022200003, -26.80592213299991],
              [153.1464949880001, -26.82390715899993],
              [153.14380944100003, -26.844496351999908],
              [153.14405358200008, -26.860446872999944],
              [153.14405358200008, -26.852308851999908],
              [153.14616946700005, -26.891778252999927],
              [153.15251712300005, -26.924981377999927],
              [153.20622806100005, -27.046075127999927],
              [153.21021569100003, -27.077243747999944],
              [153.191742384, -27.09929778399993],
              [153.15455162900003, -27.084242445999905],
              [153.116547071, -27.08993905999995],
              [153.08220462300005, -27.110446872999944],
              [153.05534915500004, -27.14031340899993],
              [153.0478621750001, -27.152276299999926],
              [153.038422071, -27.173435153999947],
              [153.03825931100005, -27.19345468499995],
              [153.05836022200003, -27.202325127999927],
              [153.07992597700002, -27.203383070999905],
              [153.09107506600003, -27.202569268999923],
              [153.09937584700003, -27.19890715899993],
              [153.11280358200008, -27.191013278999947],
              [153.11744225400003, -27.19695403399993],
              [153.113617384, -27.242364190999922],
              [153.103851759, -27.254164320999905],
              [153.08912194100003, -27.261651299999926],
              [153.07203209700003, -27.27467213299991],
              [153.06137129, -27.294528903999947],
              [153.0649520190001, -27.310479424999926],
              [153.07634524800005, -27.323011976999908],
              [153.08936608200008, -27.33212655999995],
              [153.10914147200003, -27.340508721999925],
              [153.15113366000003, -27.352227471999925],
              [153.1679793630001, -27.36370208099993],
              [153.17750084700003, -27.38250090899993],
              [153.1840926440001, -27.428399346999925],
              [153.191742384, -27.449395440999922],
              [153.20777428500003, -27.465020440999922],
              [153.22380618600005, -27.468194268999923],
              [153.23845462300005, -27.467868747999944],
              [153.2504988940001, -27.47275155999995],
              [153.2602645190001, -27.48406340899993],
              [153.26832116000003, -27.496270440999922],
              [153.2812606130001, -27.52385833099993],
              [153.283539259, -27.532810153999947],
              [153.28394616000003, -27.539727471999925],
              [153.285492384, -27.54656340899993],
              [153.30453535200002, -27.570245049999926],
              [153.3076278000001, -27.578057549999926],
              [153.31080162900003, -27.64031340899993],
              [153.3154403000001, -27.65488046699994],
              [153.32447350400003, -27.66692473799992],
              [153.34546959700003, -27.686700127999927],
              [153.34945722700002, -27.69890715899993],
              [153.35043379, -27.700941664999903],
              [153.356293165, -27.72307708099993],
              [153.36198978000004, -27.73211028399993],
              [153.36695397200003, -27.73642343499995],
              [153.37183678500003, -27.73919036299992],
              [153.39991295700008, -27.76620859199994],
              [153.40984134200005, -27.781914971999925],
              [153.40788821700005, -27.795098565999922],
              [153.40186608200008, -27.80917734199994],
              [153.411468946, -27.815606377999927],
              [153.427093946, -27.810723565999922],
              [153.43897545700008, -27.79143645599993],
              [153.4458113940001, -27.79143645599993],
              [153.44556725400003, -27.810479424999926],
              [153.4321395190001, -27.86028411299992],
              [153.4301863940001, -27.878513278999947],
              [153.4321395190001, -27.935316664999903],
              [153.418304884, -27.90878671699994],
              [153.40902754, -27.917901299999926],
              [153.40219160200002, -27.934991143999923],
              [153.39991295700008, -27.954196872999944],
              [153.40406334700003, -27.970147393999923],
              [153.41334069100003, -27.976169528999947],
              [153.42204837300005, -27.969008070999905],
              [153.4301863940001, -27.957207940999922],
              [153.43897545700008, -27.948988539999903],
              [153.44507897200003, -27.98088958099993],
              [153.44947350400003, -28.07317473799992],
              [153.46273847700002, -28.092461846999925],
              [153.48226972700002, -28.110528252999927],
              [153.505218946, -28.14771900799991],
              [153.50652103000004, -28.149265231999948],
              [153.53199303500003, -28.177911065999922],
              [153.5625106130001, -28.174981377999927],
              [153.57056725400003, -28.19378020599993],
              [153.58122806100005, -28.246758721999925],
              [153.59107506600003, -28.26848723799992],
              [153.5908309250001, -28.318536065999922],
              [153.5634871750001, -28.460870049999926],
              [153.5625106130001, -28.504571221999925],
              [153.57601972700002, -28.589613539999903],
              [153.58423912900003, -28.608086846999925],
              [153.62094160200002, -28.644463799999926],
              [153.63062584700003, -28.661553643999923],
              [153.62907962300005, -28.66725025799991],
              [153.61988366000003, -28.686618747999944],
              [153.61695397200003, -28.69573333099993],
              [153.617523634, -28.705824476999908],
              [153.6196395190001, -28.717543226999908],
              [153.6196395190001, -28.729587497999944],
              [153.60132897200003, -28.76140715899993],
              [153.6001082690001, -28.783379815999922],
              [153.61011803500003, -28.826104424999926],
              [153.6059676440001, -28.867445570999905],
              [153.58228600400003, -28.896091403999947],
              [153.52133222700002, -28.94345468499995],
              [153.4755965500001, -29.000176690999922],
              [153.45378665500004, -29.03557708099993],
              [153.43897545700008, -29.073011976999908],
              [153.43620853000004, -29.085137627999927],
              [153.4355574880001, -29.09384530999995],
              [153.44507897200003, -29.140069268999923],
              [153.4458113940001, -29.15162525799991],
              [153.4414168630001, -29.155368747999944],
              [153.422699415, -29.16106536299992],
              [153.418304884, -29.16497161299992],
              [153.41521243600005, -29.175957940999922],
              [153.37086022200003, -29.241631768999923],
              [153.3505965500001, -29.281019789999903],
              [153.3403426440001, -29.32268645599993],
              [153.34945722700002, -29.361097914999903],
              [153.36670983200008, -29.382745049999926],
              [153.36996504, -29.396661065999922],
              [153.36011803500003, -29.412041924999926],
              [153.3564559250001, -29.424004815999922],
              [153.35759524800005, -29.443129164999903],
              [153.36085045700008, -29.46152109199994],
              [153.3637801440001, -29.47039153399993],
              [153.3520613940001, -29.490004164999903],
              [153.34400475400003, -29.535414320999905],
              [153.327484571, -29.56503671699994],
              [153.32447350400003, -29.57586028399993],
              [153.3222762380001, -29.597588799999926],
              [153.3232528000001, -29.602634372999944],
              [153.32789147200003, -29.612074476999908],
              [153.3291121750001, -29.61809661299992],
              [153.32699629, -29.624444268999923],
              [153.317718946, -29.63518645599993],
              [153.3154403000001, -29.64226653399993],
              [153.31788170700008, -29.66659921699994],
              [153.32300866000003, -29.682305596999925],
              [153.321625196, -29.697523695999905],
              [153.29639733200008, -29.735039971999925],
              [153.29118899800005, -29.75318775799991],
              [153.288422071, -29.771254164999903],
              [153.2880965500001, -29.78573984199994],
              [153.2949324880001, -29.82659270599993],
              [153.29078209700003, -29.835544528999947],
              [153.276703321, -29.850762627999927],
              [153.273773634, -29.857354424999926],
              [153.2714949880001, -29.90162525799991],
              [153.26734459700003, -29.92424895599993],
              [153.260101759, -29.943291924999926],
              [153.22445722700002, -29.98691171699994],
              [153.21989993600005, -30.001397393999923],
              [153.21656334700003, -30.007256768999923],
              [153.20240319100003, -30.02467213299991],
              [153.1992293630001, -30.035821221999925],
              [153.200043165, -30.04656340899993],
              [153.2055770190001, -30.073663018999923],
              [153.20378665500004, -30.129164320999905],
              [153.18962649800005, -30.174981377999927],
              [153.1372176440001, -30.257989190999922],
              [153.1464949880001, -30.28606536299992],
              [153.13209069100003, -30.323825778999947],
              [153.08936608200008, -30.388929945999905],
              [153.0825301440001, -30.406426690999922],
              [153.07545006600003, -30.43840911299992],
              [153.05054772200003, -30.473321221999925],
              [153.04314212300005, -30.49382903399993],
              [153.0230703860001, -30.575506187999906],
              [153.0180770190001, -30.633070570999905],
              [153.00798587300005, -30.65162525799991],
              [153.01099694100003, -30.655368747999944],
              [152.987796365, -30.734633817999907],
              [152.99985921400003, -30.751121504999958],
              [153.00500143300007, -30.83581429599991],
              [153.02751712300005, -30.87558359199994],
              [153.03484134200005, -30.88250090899993],
              [153.04314212300005, -30.88795338299991],
              [153.05453535200002, -30.89299895599993],
              [153.06462649800005, -30.89348723799992],
              [153.0688582690001, -30.885511976999908],
              [153.07211347700002, -30.881931247999944],
              [153.0791121750001, -30.885918877999927],
              [153.086273634, -30.894707940999922],
              [153.08936608200008, -30.905694268999923],
              [153.0879012380001, -30.92669036299992],
              [153.08570397200003, -30.935153903999947],
              [153.08187910200002, -30.94394296699994],
              [153.063327253, -30.95959308999994],
              [153.04659917000004, -30.992753975999904],
              [153.03987997700006, -31.029965145999938],
              [153.04592385500007, -31.04657286899993],
              [153.0578921770001, -31.05163744799995],
              [153.0609191100001, -31.060583280999936],
              [153.05950072100006, -31.077209977999928],
              [153.04163114200003, -31.090102655999942],
              [153.0088801720001, -31.122248232999937],
              [152.98061504100008, -31.16591475599995],
              [152.97921828900007, -31.199245471999916],
              [152.9598940190001, -31.24031530499991],
              [152.97041187900004, -31.255676558999937],
              [152.97673587300005, -31.32000090899993],
              [152.93258908100006, -31.366007817999957],
              [152.9178282690001, -31.395254330999933],
              [152.91643539300003, -31.420656614999928],
              [152.9343544840001, -31.43839212699993],
              [152.938874445, -31.454869447999954],
              [152.94038106200003, -31.462483670999916],
              [152.93450208600007, -31.482810541999925],
              [152.90629782000008, -31.505727677999914],
              [152.87658743400004, -31.532446145999927],
              [152.845380728, -31.56931860499992],
              [152.84991511500004, -31.59978016799994],
              [152.836561964, -31.625196178999943],
              [152.84853264600008, -31.644220246999907],
              [152.83214695900006, -31.655678984999952],
              [152.812788211, -31.676031504999912],
              [152.788948559, -31.704008613999918],
              [152.80390147000003, -31.71922688199993],
              [152.800929022, -31.733208108999918],
              [152.775547597, -31.754852626999934],
              [152.74418543900003, -31.793022631999918],
              [152.7367281930001, -31.827349075999905],
              [152.74721504000001, -31.842584729999942],
              [152.7157758840001, -31.85917013799991],
              [152.69288170700008, -31.88534921699994],
              [152.66431725400003, -31.903497002999927],
              [152.609255093, -31.945848262999903],
              [152.54637267400005, -32.04367920499993],
              [152.55534572500005, -32.071630892999906],
              [152.5283309250001, -32.09710051899992],
              [152.52027428500003, -32.11581796699994],
              [152.51531009200005, -32.1364885399999],
              [152.51008293200005, -32.16188136699992],
              [152.51695268900005, -32.17739220199991],
              [152.5356789450001, -32.183199517999924],
              [152.54538154700003, -32.1968881759999],
              [152.56478720200005, -32.20602140799991],
              [152.56950931100005, -32.21933359199994],
              [152.5566512380001, -32.23202890399995],
              [152.54656009200005, -32.24627044099992],
              [152.53998826600002, -32.25979707699992],
              [152.53351548800003, -32.268907929999955],
              [152.52595710900005, -32.281664572999944],
              [152.52487141200004, -32.29442562399993],
              [152.52704290200006, -32.31266082999991],
              [152.539976734, -32.31448874799992],
              [152.55445397200003, -32.32122161299992],
              [152.55201256600003, -32.328057549999926],
              [152.54835045700008, -32.33212655999995],
              [152.54420006600003, -32.3357072899999],
              [152.54078209700003, -32.341729424999926],
              [152.53663170700008, -32.354587497999944],
              [152.53394616000003, -32.36956145599993],
              [152.5248349430001, -32.38830528299991],
              [152.5204991710001, -32.41017641299993],
              [152.521559969, -32.42749406799993],
              [152.53988629600008, -32.442091940999944],
              [152.40239353700008, -32.48942857199995],
              [152.353559882, -32.51492334799991],
              [152.29476390000002, -32.55958889499993],
              [152.285929613, -32.58880396099994],
              [152.264174174, -32.59425608399994],
              [152.23586181400003, -32.60699906299993],
              [152.21066994900002, -32.63073865299992],
              [152.19198882, -32.65267038499991],
              [152.18750083500004, -32.669135910999955],
              [152.2037207300001, -32.68653589899992],
              [152.2192488940001, -32.697198174999926],
              [152.2055770190001, -32.697930596999925],
              [152.2021590500001, -32.69589609199994],
              [152.19410241000003, -32.68718840899993],
              [152.19068444100003, -32.684258721999925],
              [152.1860457690001, -32.683526299999926],
              [152.17530358200008, -32.68515390399995],
              [152.17074629, -32.684258721999925],
              [152.14527428500003, -32.66659921699994],
              [152.1367293630001, -32.66375090899993],
              [152.1352645190001, -32.666680596999925],
              [152.11670983200008, -32.68010833099993],
              [152.1093856130001, -32.684258721999925],
              [152.060883009, -32.697930596999925],
              [152.086761915, -32.715915622999944],
              [152.0922957690001, -32.71843840899993],
              [152.167328321, -32.71843840899993],
              [152.17798912900003, -32.720635674999926],
              [152.19019616000003, -32.725274346999925],
              [152.1977645190001, -32.72991301899992],
              [152.19483483200008, -32.73211028399993],
              [152.19092858200008, -32.736586195999905],
              [152.1894637380001, -32.75855885199991],
              [152.18506920700008, -32.76677825299993],
              [152.1748153000001, -32.76921965899993],
              [152.15015709700003, -32.76604583099993],
              [152.14014733200008, -32.770196221999925],
              [152.131195509, -32.78085702899995],
              [152.12761478000004, -32.78655364399992],
              [152.12256920700008, -32.790134372999944],
              [152.1093856130001, -32.79412200299993],
              [152.059428755, -32.78525386599995],
              [151.984926879, -32.79874572499995],
              [151.935188047, -32.81582907299992],
              [151.87566248200005, -32.842087877999916],
              [151.85621926700003, -32.85585894999991],
              [151.83403307100002, -32.86496712899992],
              [151.79923736400008, -32.89368037799994],
              [151.80355879, -32.91936614399992],
              [151.78785241000003, -32.931898695999905],
              [151.7725070570001, -32.94560852899991],
              [151.74886303000005, -32.95702337899991],
              [151.737634974, -32.97200186099991],
              [151.736035076, -32.993997022999906],
              [151.7343856130001, -33.01482512799993],
              [151.72053510700005, -33.01937119099995],
              [151.703800128, -33.028521321999904],
              [151.68148847700002, -33.04998137799993],
              [151.67058353000004, -33.06113046699994],
              [151.6670028000001, -33.073337497999944],
              [151.665688671, -33.08734320599996],
              [151.652915075, -33.11043283899994],
              [151.64673912900003, -33.14470794099992],
              [151.63493899800005, -33.15862395599993],
              [151.62956790500004, -33.17424895599993],
              [151.6259871750001, -33.19158294099992],
              [151.612263438, -33.2075509199999],
              [151.58999436200008, -33.21893725499996],
              [151.5689527520001, -33.24422481799991],
              [151.56318102500006, -33.26500994299994],
              [151.57601972700002, -33.28248463299991],
              [151.568957243, -33.292227829999945],
              [151.53068564400007, -33.319118731999936],
              [151.515341164, -33.327082411999925],
              [151.5154626100001, -33.31666608099994],
              [151.53225880800005, -33.30292875299995],
              [151.54086740000002, -33.27754199099991],
              [151.5161095640001, -33.26110945399995],
              [151.491019552, -33.27361137999992],
              [151.453795174, -33.30419893499993],
              [151.45272653900008, -33.31151484599991],
              [151.4697371750001, -33.32822030999995],
              [151.45639236800002, -33.33108822299994],
              [151.44270356200002, -33.33421552699991],
              [151.44402103000004, -33.345635674999926],
              [151.451228098, -33.35546050799991],
              [151.45995662400003, -33.35961144699991],
              [151.47454563100007, -33.363001254999915],
              [151.48835678300009, -33.34929092899995],
              [151.4952936100001, -33.33958650399995],
              [151.50499521100005, -33.34374347599993],
              [151.503829472, -33.36001011199994],
              [151.4899998950001, -33.374534001999905],
              [151.48584632400002, -33.39402452499991],
              [151.45722737800008, -33.41980528999994],
              [151.44530034600007, -33.43597156799996],
              [151.45199776800007, -33.444985834999954],
              [151.4509103160001, -33.45311444199996],
              [151.4390654990001, -33.46358462099994],
              [151.44276001700007, -33.478269724999905],
              [151.447521446, -33.48645360699993],
              [151.44159580200005, -33.491283239999916],
              [151.42787570300004, -33.494413953999924],
              [151.43246504, -33.5095354149999],
              [151.430023634, -33.51506926899992],
              [151.42888431100005, -33.521742445999905],
              [151.424164259, -33.52776458099993],
              [151.41431725400003, -33.53289153399993],
              [151.40699303500003, -33.53460051899992],
              [151.38648522200003, -33.53394947699991],
              [151.38005618600005, -33.53679778399993],
              [151.36268184000005, -33.53210331999992],
              [151.35371742900008, -33.541796319999946],
              [151.343109571, -33.54827239399992],
              [151.32056725400003, -33.55136484199994],
              [151.30876712300005, -33.54762135199991],
              [151.28288821700005, -33.56210702899995],
              [151.266449415, -33.561211846999925],
              [151.25554446700005, -33.546807549999926],
              [151.24594160200002, -33.52109140399995],
              [151.23072350400003, -33.5349260399999],
              [151.22681725400003, -33.55486419099992],
              [151.23406009200005, -33.573337497999944],
              [151.25277754, -33.58245208099993],
              [151.2480574880001, -33.590101820999905],
              [151.24195397200003, -33.59587981599992],
              [151.23454837300005, -33.599867445999905],
              [151.2255965500001, -33.602227471999925],
              [151.2255965500001, -33.60906340899993],
              [151.24952233200008, -33.60637786299992],
              [151.28164068, -33.57290182899993],
              [151.2993381240001, -33.570624204999945],
              [151.3099926120001, -33.578874700999904],
              [151.29873635900003, -33.60648934099993],
              [151.291502, -33.636533019999945],
              [151.29525982100006, -33.648780177999924],
              [151.30909433, -33.637533463999944],
              [151.317123143, -33.62214794099992],
              [151.32547154300005, -33.59205840899995],
              [151.340752909, -33.61746553599994],
              [151.3213419770001, -33.66781743699994],
              [151.309178674, -33.69297289799994],
              [151.3056746750001, -33.72014739399992],
              [151.30445397200003, -33.72616952899995],
              [151.31177819100003, -33.7360979149999],
              [151.31763756600003, -33.746758721999925],
              [151.31714928500003, -33.75750090899993],
              [151.30876712300005, -33.7810197899999],
              [151.3046981130001, -33.82537200299993],
              [151.29175866000003, -33.8298479149999],
              [151.27914472700002, -33.82756926899992],
              [151.26636803500003, -33.828383070999905],
              [151.25277754, -33.842461846999925],
              [151.246918165, -33.85637786299992],
              [151.24732506600003, -33.86728280999995],
              [151.254730665, -33.87420012799993],
              [151.269867384, -33.87664153399993],
              [151.28012129, -33.87070077899995],
              [151.28467858200008, -33.86012135199991],
              [151.28785241000003, -33.85637786299992],
              [151.29444420700008, -33.87037525799991],
              [151.29249108200008, -33.89177825299993],
              [151.27369225400003, -33.937432549999926],
              [151.28142337300005, -33.95232512799993],
              [151.26742597700002, -33.98170338299991],
              [151.2602645190001, -33.99260833099993],
              [151.249359571, -34.003838799999926],
              [151.24170983200008, -33.99863046699994],
              [151.21314537900003, -33.966729424999926],
              [151.20191491000003, -33.95916106599992],
              [151.18230228000004, -33.96347421699994],
              [151.17790774800005, -33.97380950299993],
              [151.17603600400003, -33.98748137799993],
              [151.1640731130001, -34.00074635199991],
              [151.145355665, -34.0036760399999],
              [151.12468509200005, -34.00042083099993],
              [151.106293165, -34.00090911299992],
              [151.09522545700008, -34.01441822699991],
              [151.1254988940001, -34.02044036299992],
              [151.13266035200002, -34.024102471999925],
              [151.1435653000001, -34.03281015399995],
              [151.14918053500003, -34.03199635199991],
              [151.16032962300005, -34.017510674999926],
              [151.22144616000003, -34.02499765399995],
              [151.23226972700002, -34.024102471999925],
              [151.23121178500003, -34.04045989399992],
              [151.22584069100003, -34.04705169099992],
              [151.1796981130001, -34.047946872999944],
              [151.17554772200003, -34.0466447899999],
              [151.1723738940001, -34.047946872999944],
              [151.1640731130001, -34.05478280999995],
              [151.15845787900003, -34.06259530999995],
              [151.15503991000003, -34.07089609199994],
              [151.14918053500003, -34.07830169099992],
              [151.136078321, -34.082696221999925],
              [151.146820509, -34.08603280999995],
              [151.1704207690001, -34.08603280999995],
              [151.17701256600003, -34.08953215899993],
              [151.177093946, -34.10035572699991],
              [151.1689559250001, -34.11012135199991],
              [151.1504012380001, -34.12428150799991],
              [151.11286100300003, -34.14947020799991],
              [151.09611743200003, -34.16293837999996],
              [151.06835713500004, -34.17511123499992],
              [151.027957464, -34.20079609599992],
              [151.00968590700006, -34.219916955999906],
              [150.96895251600006, -34.26267519399994],
              [150.94062838800005, -34.30215910299995],
              [150.92491812700007, -34.33041888099996],
              [150.92827475900003, -34.36348678099995],
              [150.908050376, -34.40764140099992],
              [150.90304956300008, -34.45086084299993],
              [150.9188675050001, -34.4864041159999],
              [150.89777917700007, -34.502081173999954],
              [150.8872176440001, -34.53020598799992],
              [150.87330162900003, -34.54550546699994],
              [150.85499108200008, -34.54143645599993],
              [150.86703535200002, -34.522556247999944],
              [150.86085045700008, -34.51327890399995],
              [150.8481551440001, -34.51051197699991],
              [150.84131920700008, -34.51067473799992],
              [150.83513431100005, -34.51376718499995],
              [150.80095462300005, -34.54827239399992],
              [150.80583743600005, -34.55722421699994],
              [150.81218509200005, -34.561211846999925],
              [150.8203231130001, -34.56210702899995],
              [150.84205162900003, -34.56170012799993],
              [150.85499108200008, -34.56991952899995],
              [150.88233483200008, -34.59221770599993],
              [150.89722741000003, -34.60116952899995],
              [150.9170028000001, -34.603448174999926],
              [150.883636915, -34.60702890399995],
              [150.870453321, -34.6267229149999],
              [150.84791100400003, -34.7517229149999],
              [150.83375084700003, -34.78240325299993],
              [150.8105574880001, -34.795179945999905],
              [150.7793074880001, -34.806898695999905],
              [150.75342858200008, -34.858086846999925],
              [150.72868899800005, -34.869805596999925],
              [150.7270613940001, -34.874118747999944],
              [150.7387801440001, -34.88372161299992],
              [150.75407962300005, -34.89332447699991],
              [150.76319420700008, -34.89763762799993],
              [150.77849368600005, -34.90162525799991],
              [150.77686608200008, -34.910088799999926],
              [150.764008009, -34.91741301899992],
              [150.74577884200005, -34.91814544099992],
              [150.75416100400003, -34.92815520599993],
              [150.77613366000003, -34.935804945999905],
              [150.78736412900003, -34.94548919099992],
              [150.7797957690001, -34.9528947899999],
              [150.78736412900003, -34.95973072699991],
              [150.77621504, -34.986993096999925],
              [150.79615319100003, -35.00400155999995],
              [150.82764733200008, -35.01262786299992],
              [150.8515731130001, -35.01490650799991],
              [150.85499108200008, -35.02166106599992],
              [150.84359785200002, -35.05413176899992],
              [150.8447371750001, -35.077243747999944],
              [150.832855665, -35.090915622999944],
              [150.8071395190001, -35.11052825299993],
              [150.7988387380001, -35.0993791649999],
              [150.7861434250001, -35.08912525799991],
              [150.77808678500003, -35.07854583099993],
              [150.783539259, -35.0661760399999],
              [150.79281660200002, -35.05046965899993],
              [150.7812606130001, -35.02857838299991],
              [150.78736412900003, -35.01490650799991],
              [150.7675887380001, -35.00725676899992],
              [150.74878991000003, -35.01034921699994],
              [150.7314559250001, -35.01726653399993],
              [150.69556725400003, -35.02613697699991],
              [150.68702233200008, -35.038995049999926],
              [150.67750084700003, -35.07577890399995],
              [150.69695071700005, -35.07976653399993],
              [150.701508009, -35.092868747999944],
              [150.70093834700003, -35.10947030999995],
              [150.70378665500004, -35.12045663899994],
              [150.70476321700005, -35.12420012799993],
              [150.721039259, -35.13518645599993],
              [150.73715254, -35.13176848799992],
              [150.75261478000004, -35.12468840899993],
              [150.76685631600003, -35.12420012799993],
              [150.770355665, -35.13290780999995],
              [150.7695418630001, -35.14885833099993],
              [150.76539147200003, -35.16619231599992],
              [150.75945071700005, -35.17888762799993],
              [150.75147545700008, -35.18320077899995],
              [150.742523634, -35.18254973799992],
              [150.735199415, -35.18084075299993],
              [150.73218834700003, -35.182305596999925],
              [150.72877037900003, -35.18670012799993],
              [150.72087649800005, -35.19182708099993],
              [150.7119246750001, -35.19654713299991],
              [150.70476321700005, -35.19939544099992],
              [150.684418165, -35.176039320999905],
              [150.6372176440001, -35.17929452899995],
              [150.61304772200003, -35.1872697899999],
              [150.5859481130001, -35.19622161299992],
              [150.55396569100003, -35.213555596999925],
              [150.54810631600003, -35.221368096999925],
              [150.54371178500003, -35.23796965899993],
              [150.53972415500004, -35.24773528399993],
              [150.53443444100003, -35.254978122999944],
              [150.52312259200005, -35.264336846999925],
              [150.49952233200008, -35.289727471999925],
              [150.489105665, -35.305759372999944],
              [150.48462975400003, -35.32431405999995],
              [150.48503665500004, -35.35019296699994],
              [150.48845462300005, -35.36451588299991],
              [150.49187259200005, -35.369398695999905],
              [150.49203535200002, -35.37314218499995],
              [150.48503665500004, -35.38437265399995],
              [150.45582116000003, -35.40398528399993],
              [150.45093834700003, -35.408461195999905],
              [150.44548587300005, -35.42546965899993],
              [150.432953321, -35.44068775799991],
              [150.41920006600003, -35.45452239399992],
              [150.40992272200003, -35.46689218499995],
              [150.40699303500003, -35.487399997999944],
              [150.40935306100005, -35.53850676899992],
              [150.40650475400003, -35.548760674999926],
              [150.3896590500001, -35.55787525799991],
              [150.37232506600003, -35.57887135199991],
              [150.3325301440001, -35.63941822699991],
              [150.30689537900003, -35.700290622999944],
              [150.29167728000004, -35.72283294099992],
              [150.27369225400003, -35.73064544099992],
              [150.25342858200008, -35.72625090899993],
              [150.231781446, -35.71331145599993],
              [150.22193444100003, -35.71770598799992],
              [150.19092858200008, -35.726820570999905],
              [150.218109571, -35.75115325299993],
              [150.22584069100003, -35.77890390399995],
              [150.22868899800005, -35.78525155999995],
              [150.23853600400003, -35.799493096999925],
              [150.24097741000003, -35.80974700299993],
              [150.238617384, -35.833103122999944],
              [150.2324324880001, -35.84384530999995],
              [150.218109571, -35.85019296699994],
              [150.19092858200008, -35.8571916649999],
              [150.18930097700002, -35.85955169099992],
              [150.15259850400003, -35.89373137799993],
              [150.149750196, -35.8982072899999],
              [150.15023847700002, -35.91253020599993],
              [150.16081790500004, -35.939711195999905],
              [150.163422071, -35.95663827899995],
              [150.156586134, -36.02507903399993],
              [150.14869225400003, -36.06259530999995],
              [150.12964928500003, -36.05950286299992],
              [150.106781446, -36.0485979149999],
              [150.08773847700002, -36.06267669099992],
              [150.091156446, -36.070245049999926],
              [150.090179884, -36.075290622999944],
              [150.08155358200008, -36.0837541649999],
              [150.08765709700003, -36.08277760199991],
              [150.09253991000003, -36.082696221999925],
              [150.097015821, -36.08131275799991],
              [150.1020613940001, -36.07634856599992],
              [150.1191512380001, -36.085056247999944],
              [150.1357528000001, -36.09775155999995],
              [150.14332116000003, -36.11443450299993],
              [150.1230574880001, -36.152601820999905],
              [150.1211043630001, -36.173760674999926],
              [150.12419681100005, -36.195245049999926],
              [150.14478600400003, -36.25286223799992],
              [150.1464949880001, -36.27353280999995],
              [150.1328231130001, -36.28240325299993],
              [150.1328231130001, -36.28679778399993],
              [150.14039147200003, -36.30974700299993],
              [150.14234459700003, -36.32000090899993],
              [150.13819420700008, -36.330010674999926],
              [150.12842858200008, -36.33831145599993],
              [150.10824629, -36.3513322899999],
              [150.0922957690001, -36.367852471999925],
              [150.07927493600005, -36.38600025799991],
              [150.07048587300005, -36.40634530999995],
              [150.0673934250001, -36.42929452899995],
              [150.07300866000003, -36.453057549999926],
              [150.0742293630001, -36.46331145599993],
              [150.07097415500004, -36.47014739399992],
              [150.05681399800005, -36.488946221999925],
              [150.05355879, -36.50090911299992],
              [150.06364993600005, -36.54314544099992],
              [150.065765821, -36.56658294099992],
              [150.056976759, -36.58717213299991],
              [150.02906334700003, -36.62428150799991],
              [149.99537194100003, -36.68645598799992],
              [149.989105665, -36.70468515399995],
              [149.98609459700003, -36.722914320999905],
              [149.9853621750001, -36.744805596999925],
              [149.9795028000001, -36.76995208099993],
              [149.96509850400003, -36.79452890399995],
              [149.94703209700003, -36.81568775799991],
              [149.930023634, -36.83049895599993],
              [149.9399520190001, -36.85295989399992],
              [149.93482506600003, -36.87070077899995],
              [149.90967858200008, -36.90553150799991],
              [149.90381920700008, -36.928399346999925],
              [149.91138756600003, -36.938571872999944],
              [149.92652428500003, -36.94410572699991],
              [149.943695509, -36.953383070999905],
              [149.9321395190001, -36.965508721999925],
              [149.92310631600003, -36.983493747999944],
              [149.92017662900003, -37.002618096999925],
              [149.9267684250001, -37.018243096999925],
              [149.93482506600003, -37.02662525799991],
              [149.9399520190001, -37.033868096999925],
              [149.94288170700008, -37.04216887799993],
              [149.943695509, -37.053399346999925],
              [149.94157962300005, -37.06218840899993],
              [149.936859571, -37.06894296699994],
              [149.93230228000004, -37.070977471999925],
              [149.930023634, -37.066338799999926],
              [149.92253665500004, -37.06178150799991],
              [149.90577233200008, -37.070977471999925],
              [149.89031009200005, -37.08407968499995],
              [149.88550866000003, -37.090508721999925],
              [149.87614993600005, -37.09587981599992],
              [149.88209069100003, -37.10759856599992],
              [149.89665774800005, -37.11931731599992],
              [149.9130965500001, -37.12468840899993],
              [149.9301863940001, -37.1228166649999],
              [149.93897545700008, -37.119805596999925],
              [149.94605553500003, -37.11923593499995],
              [149.95875084700003, -37.12468840899993],
              [149.99756920700008, -37.15048593499995],
              [150.0058699880001, -37.158868096999925],
              [150.01140384200005, -37.17343515399995],
              [150.01441491000003, -37.205336195999905],
              [150.0195418630001, -37.22087981599992],
              [150.05355879, -37.26873137799993],
              [150.05355879, -37.27613697699991],
              [150.03003991000003, -37.26604583099993],
              [150.00733483200008, -37.25937265399995],
              [149.9853621750001, -37.25904713299991],
              [149.96436608200008, -37.26873137799993],
              [149.95101972700002, -37.284274997999944],
              [149.95134524800005, -37.29973723799992],
              [149.9716903000001, -37.33757903399993],
              [149.95728600400003, -37.37786223799992],
              [149.95679772200003, -37.41545989399992],
              [149.967133009, -37.45370859199994],
              [149.9853621750001, -37.4958635399999],
              [149.972097201, -37.51026783599991],
              [149.9531356130001, -37.53085702899995],
              [149.89633222700002, -37.5485979149999],
              [149.778656446, -37.55608489399992],
              [149.7871199880001, -37.55282968499995],
              [149.791351759, -37.547946872999944],
              [149.79127037900003, -37.542087497999944],
              [149.7861434250001, -37.53557708099993],
              [149.7978621750001, -37.51970794099992],
              [149.7939559250001, -37.510837497999944],
              [149.78272545700008, -37.512790622999944],
              [149.7724715500001, -37.52939218499995],
              [149.76002037900003, -37.52402109199994],
              [149.71843509200005, -37.51580169099992],
              [149.76148522200003, -37.566338799999926],
              [149.76628665500004, -37.58407968499995],
              [149.75757897200003, -37.59710051899992],
              [149.72543379, -37.62029387799993],
              [149.71168053500003, -37.64853280999995],
              [149.67847741000003, -37.69101327899995],
              [149.66667728000004, -37.70012786299992],
              [149.6152449880001, -37.71038176899992],
              [149.6098738940001, -37.717461846999925],
              [149.604828321, -37.7263322899999],
              [149.59498131600003, -37.73479583099993],
              [149.575043165, -37.74098072699991],
              [149.532074415, -37.74627044099992],
              [149.51246178500003, -37.75530364399992],
              [149.50733483200008, -37.76140715899993],
              [149.49781334700003, -37.777601820999905],
              [149.4912215500001, -37.78329843499995],
              [149.4790145190001, -37.78590260199991],
              [149.34107506600003, -37.78671640399995],
              [149.29900149800005, -37.79851653399993],
              [149.27222741000003, -37.82350025799991],
              [149.26539147200003, -37.817071221999925],
              [149.261078321, -37.8103166649999],
              [149.259125196, -37.8025041649999],
              [149.25855553500003, -37.792901299999926],
              [149.25318444100003, -37.78948333099993],
              [149.17310631600003, -37.79021575299993],
              [149.1523543630001, -37.78639088299991],
              [149.13559004, -37.77581145599993],
              [149.0927840500001, -37.78964609199994],
              [148.9438582690001, -37.78948333099993],
              [148.90219160200002, -37.79631926899992],
              [148.78630618600005, -37.79810963299991],
              [148.76514733200008, -37.803806247999944],
              [148.73601321700005, -37.82048919099992],
              [148.72413170700008, -37.82350025799991],
              [148.6040145190001, -37.81113046699994],
              [148.30640709700003, -37.82341887799993],
              [148.13062584700003, -37.85711028399993],
              [147.9165145190001, -37.91855234199994],
              [147.75757897200003, -37.98512135199991],
              [147.58936608200008, -38.08066171699994],
              [147.3955184250001, -38.22014739399992],
              [147.1806746750001, -38.39788176899992],
              [147.08277428500003, -38.47283294099992],
              [146.98365319100003, -38.572198174999926],
              [146.894867384, -38.63420989399992],
              [146.88445071700005, -38.638604424999926],
              [146.87859134200005, -38.6443010399999],
              [146.8476668630001, -38.68499114399992],
              [146.8364363940001, -38.68238697699991],
              [146.8320418630001, -38.67278411299992],
              [146.84652754, -38.65960051899992],
              [146.83025149800005, -38.65471770599993],
              [146.688812696, -38.68010833099993],
              [146.641449415, -38.676853122999944],
              [146.6176863940001, -38.67913176899992],
              [146.5747176440001, -38.70322030999995],
              [146.55347741000003, -38.70452239399992],
              [146.530609571, -38.70134856599992],
              [146.5039168630001, -38.70061614399992],
              [146.45866946700005, -38.71013762799993],
              [146.43279056100005, -38.71965911299992],
              [146.42139733200008, -38.73162200299993],
              [146.41179446700005, -38.73984140399995],
              [146.3911238940001, -38.72600676899992],
              [146.37224368600005, -38.70745208099993],
              [146.36744225400003, -38.70061614399992],
              [146.35043379, -38.69500090899993],
              [146.25570722700002, -38.70175546699994],
              [146.2382918630001, -38.70582447699991],
              [146.22413170700008, -38.71445077899995],
              [146.18238366000003, -38.75595468499995],
              [146.21599368600005, -38.78378671699994],
              [146.22095787900003, -38.791680596999925],
              [146.2295028000001, -38.808851820999905],
              [146.23707116000003, -38.81796640399995],
              [146.2412215500001, -38.819024346999925],
              [146.26059004, -38.81796640399995],
              [146.26392662900003, -38.82040780999995],
              [146.26392662900003, -38.82626718499995],
              [146.26319420700008, -38.833103122999944],
              [146.26384524800005, -38.83847421699994],
              [146.26677493600005, -38.85125090899993],
              [146.2666121750001, -38.86337655999995],
              [146.27027428500003, -38.87322356599992],
              [146.28492272200003, -38.87932708099993],
              [146.277679884, -38.89934661299992],
              [146.28638756600003, -38.90984465899993],
              [146.30290774800005, -38.9118791649999],
              [146.31902103000004, -38.90667083099993],
              [146.33423912900003, -38.89348723799992],
              [146.35499108200008, -38.86858489399992],
              [146.37370853000004, -38.85833098799992],
              [146.38298587300005, -38.8571916649999],
              [146.4023543630001, -38.85857512799993],
              [146.41089928500003, -38.85515715899993],
              [146.41675866000003, -38.84685637799993],
              [146.418304884, -38.83733489399992],
              [146.4189559250001, -38.82756926899992],
              [146.42139733200008, -38.81796640399995],
              [146.4326278000001, -38.801446221999925],
              [146.4477645190001, -38.79029713299991],
              [146.46355228000004, -38.791273695999905],
              [146.47673587300005, -38.810479424999926],
              [146.47046959700003, -38.82382577899995],
              [146.46851647200003, -38.84026458099993],
              [146.4692488940001, -38.86923593499995],
              [146.47095787900003, -38.879164320999905],
              [146.47486412900003, -38.88591887799993],
              [146.4795028000001, -38.89185963299991],
              [146.4829207690001, -38.89999765399995],
              [146.48414147200003, -38.90740325299993],
              [146.48406009200005, -38.91090260199991],
              [146.48324629, -38.915134372999944],
              [146.4829207690001, -38.924086195999905],
              [146.4775496750001, -38.9294572899999],
              [146.4658309250001, -38.93767669099992],
              [146.4541121750001, -38.94931405999995],
              [146.448578321, -38.96502044099992],
              [146.44654381600003, -38.97576262799993],
              [146.43726647200003, -39.00514088299991],
              [146.43506920700008, -39.01995208099993],
              [146.4379988940001, -39.02695077899995],
              [146.444672071, -39.030368747999944],
              [146.45264733200008, -39.030368747999944],
              [146.46599368600005, -39.02361419099992],
              [146.47055097700002, -39.02825286299992],
              [146.4834090500001, -39.06462981599992],
              [146.477875196, -39.07170989399992],
              [146.4648543630001, -39.073337497999944],
              [146.448578321, -39.078057549999926],
              [146.43433678500003, -39.08912525799991],
              [146.434906446, -39.0974260399999],
              [146.43897545700008, -39.108086846999925],
              [146.43506920700008, -39.12639739399992],
              [146.42554772200003, -39.13640715899993],
              [146.4106551440001, -39.14316171699994],
              [146.39421634200005, -39.14495208099993],
              [146.38038170700008, -39.14006926899992],
              [146.3505965500001, -39.128024997999944],
              [146.33578535200002, -39.11858489399992],
              [146.32585696700005, -39.10588958099993],
              [146.322601759, -39.088962497999944],
              [146.3305770190001, -39.08277760199991],
              [146.34148196700005, -39.07781340899993],
              [146.34693444100003, -39.064385674999926],
              [146.3403426440001, -39.05527109199994],
              [146.29851321700005, -39.03769296699994],
              [146.2890731130001, -39.02809010199991],
              [146.26384524800005, -38.996026299999926],
              [146.2509871750001, -38.93962981599992],
              [146.1816512380001, -38.86834075299993],
              [146.0918074880001, -38.81975676899992],
              [146.01734459700003, -38.83163827899995],
              [146.008148634, -38.84693775799991],
              [146.004242384, -38.865492445999905],
              [146.00367272200003, -38.896416924999926],
              [145.99244225400003, -38.9001604149999],
              [145.93897545700008, -38.90878671699994],
              [145.92115319100003, -38.90667083099993],
              [145.91578209700003, -38.89576588299991],
              [145.8964949880001, -38.829196872999944],
              [145.85523522200003, -38.7595354149999],
              [145.82154381600003, -38.71795012799993],
              [145.76783287900003, -38.67473723799992],
              [145.757172071, -38.65960051899992],
              [145.78500410200002, -38.668633721999925],
              [145.825531446, -38.69622161299992],
              [145.8535262380001, -38.70061614399992],
              [145.8330184250001, -38.66912200299993],
              [145.80933678500003, -38.6501604149999],
              [145.7773543630001, -38.640883070999905],
              [145.73308353000004, -38.638604424999926],
              [145.6992293630001, -38.6462541649999],
              [145.63949629, -38.67742278399993],
              [145.5996199880001, -38.68010833099993],
              [145.5708113940001, -38.66171640399995],
              [145.52947024800005, -38.59343840899993],
              [145.5136824880001, -38.578383070999905],
              [145.50180097700002, -38.57463958099993],
              [145.44809004, -38.55046965899993],
              [145.3916121750001, -38.5427385399999],
              [145.3730574880001, -38.53679778399993],
              [145.3730574880001, -38.53053150799991],
              [145.3950301440001, -38.52581145599993],
              [145.420258009, -38.51531340899993],
              [145.43384850400003, -38.50212981599992],
              [145.42074629, -38.488946221999925],
              [145.43116295700008, -38.47576262799993],
              [145.4345809250001, -38.45973072699991],
              [145.43116295700008, -38.44280364399992],
              [145.42074629, -38.42693450299993],
              [145.45183353000004, -38.41326262799993],
              [145.46216881600003, -38.41521575299993],
              [145.47087649800005, -38.419854424999926],
              [145.47771243600005, -38.424493096999925],
              [145.48226972700002, -38.42693450299993],
              [145.50611412900003, -38.424086195999905],
              [145.52133222700002, -38.412041924999926],
              [145.531586134, -38.39902109199994],
              [145.54086347700002, -38.39275481599992],
              [145.55689537900003, -38.38518645599993],
              [145.55437259200005, -38.36858489399992],
              [145.5400496750001, -38.35198333099993],
              [145.5205184250001, -38.344414971999925],
              [145.51547285200002, -38.33904387799993],
              [145.51726321700005, -38.32756926899992],
              [145.5239363940001, -38.310804945999905],
              [145.5185653000001, -38.301853122999944],
              [145.5029403000001, -38.28525155999995],
              [145.4765731130001, -38.24488697699991],
              [145.46436608200008, -38.23455169099992],
              [145.44809004, -38.2282854149999],
              [145.42986087300005, -38.226820570999905],
              [145.3833113940001, -38.23455169099992],
              [145.3457137380001, -38.23455169099992],
              [145.33855228000004, -38.23886484199994],
              [145.3339949880001, -38.24537525799991],
              [145.32764733200008, -38.24724700299993],
              [145.3149520190001, -38.23796965899993],
              [145.29656009200005, -38.23170338299991],
              [145.27173912900003, -38.23316822699991],
              [145.2558699880001, -38.24146900799991],
              [145.26441491000003, -38.25554778399993],
              [145.25611412900003, -38.26482512799993],
              [145.24683678500003, -38.27288176899992],
              [145.239105665, -38.281914971999925],
              [145.23170006600003, -38.30624765399995],
              [145.2216903000001, -38.310804945999905],
              [145.21062259200005, -38.314385674999926],
              [145.20240319100003, -38.324476820999905],
              [145.20281009200005, -38.3357072899999],
              [145.21859785200002, -38.35035572699991],
              [145.22282962300005, -38.361993096999925],
              [145.22380618600005, -38.38600025799991],
              [145.2290145190001, -38.41326262799993],
              [145.13656660200002, -38.40081145599993],
              [145.11296634200005, -38.40642669099992],
              [145.10572350400003, -38.41521575299993],
              [145.10075931100005, -38.42652760199991],
              [145.0922957690001, -38.43629322699991],
              [145.06072024800005, -38.44500090899993],
              [145.05046634200005, -38.45598723799992],
              [145.03728274800005, -38.48211028399993],
              [145.04468834700003, -38.488946221999925],
              [145.02466881600003, -38.4939104149999],
              [144.95533287900003, -38.49879322699991],
              [144.94459069100003, -38.51034921699994],
              [144.92107181100005, -38.503024997999944],
              [144.88640384200005, -38.48211028399993],
              [144.7290145190001, -38.3513322899999],
              [144.71119225400003, -38.342054945999905],
              [144.69125410200002, -38.338148695999905],
              [144.6767684250001, -38.33318450299993],
              [144.67302493600005, -38.323337497999944],
              [144.676605665, -38.31658294099992],
              [144.68474368600005, -38.32048919099992],
              [144.6933699880001, -38.32634856599992],
              [144.72877037900003, -38.33131275799991],
              [144.7480574880001, -38.34221770599993],
              [144.78345787900003, -38.37273528399993],
              [144.80396569100003, -38.37908294099992],
              [144.8496199880001, -38.37851327899995],
              [144.89323978000004, -38.3728166649999],
              [144.95289147200003, -38.347914320999905],
              [144.9829207690001, -38.34140390399995],
              [144.9931746750001, -38.3337541649999],
              [144.9980574880001, -38.32390715899993],
              [144.99284915500004, -38.31365325299993],
              [144.99146569100003, -38.304945570999905],
              [145.00180097700002, -38.29607512799993],
              [145.02369225400003, -38.28289153399993],
              [145.02719160200002, -38.27581145599993],
              [145.03272545700008, -38.25839609199994],
              [145.03728274800005, -38.24879322699991],
              [145.04444420700008, -38.23984140399995],
              [145.06177819100003, -38.22356536299992],
              [145.07243899800005, -38.20623137799993],
              [145.11931399800005, -38.15935637799993],
              [145.12916100400003, -38.12615325299993],
              [145.1254988940001, -38.088148695999905],
              [145.110199415, -38.05169036299992],
              [145.0849715500001, -38.02353280999995],
              [145.07536868600005, -38.01816171699994],
              [145.04468834700003, -38.00920989399992],
              [145.03296959700003, -38.00237395599993],
              [145.02711022200003, -37.99627044099992],
              [145.0024520190001, -37.960056247999944],
              [144.99244225400003, -37.92009856599992],
              [144.98267662900003, -37.89934661299992],
              [144.96314537900003, -37.881931247999944],
              [144.93482506600003, -37.86793385199991],
              [144.911468946, -37.869805596999925],
              [144.90699303500003, -37.89934661299992],
              [144.84205162900003, -37.89316171699994],
              [144.82545006600003, -37.89853280999995],
              [144.817230665, -37.91139088299991],
              [144.81202233200008, -37.92734140399995],
              [144.80445397200003, -37.94085051899992],
              [144.79444420700008, -37.94768645599993],
              [144.7783309250001, -37.95427825299993],
              [144.76091556100005, -37.95940520599993],
              [144.7461043630001, -37.96135833099993],
              [144.73365319100003, -37.96795012799993],
              [144.6958113940001, -37.99749114399992],
              [144.687836134, -38.005791924999926],
              [144.67204837300005, -38.01718515399995],
              [144.55844160200002, -38.04762135199991],
              [144.543304884, -38.05828215899993],
              [144.5312606130001, -38.07154713299991],
              [144.52328535200002, -38.084242445999905],
              [144.523773634, -38.09148528399993],
              [144.5278426440001, -38.09823984199994],
              [144.52808678500003, -38.10491301899992],
              [144.51710045700008, -38.111586195999905],
              [144.5078231130001, -38.11207447699991],
              [144.4980574880001, -38.10865650799991],
              [144.48902428500003, -38.10320403399993],
              [144.4824324880001, -38.09734465899993],
              [144.4541121750001, -38.10637786299992],
              [144.3950301440001, -38.10662200299993],
              [144.3730574880001, -38.11842213299991],
              [144.36255944100003, -38.14657968499995],
              [144.3818465500001, -38.15781015399995],
              [144.43384850400003, -38.15935637799993],
              [144.52361087300005, -38.177992445999905],
              [144.55811608200008, -38.17302825299993],
              [144.5820418630001, -38.16326262799993],
              [144.65357506600003, -38.12468840899993],
              [144.70476321700005, -38.14609140399995],
              [144.7251082690001, -38.16480885199991],
              [144.71827233200008, -38.190118096999925],
              [144.7158309250001, -38.195977471999925],
              [144.71664472700002, -38.20956796699994],
              [144.71509850400003, -38.2146135399999],
              [144.7089949880001, -38.21835702899995],
              [144.6953231130001, -38.21843840899993],
              [144.687836134, -38.22144947699991],
              [144.6704207690001, -38.2380510399999],
              [144.6611434250001, -38.24968840899993],
              [144.65357506600003, -38.26181405999995],
              [144.6528426440001, -38.285821221999925],
              [144.61158287900003, -38.29257577899995],
              [144.53012129, -38.29029713299991],
              [144.51880944100003, -38.29501718499995],
              [144.5107528000001, -38.29941171699994],
              [144.50212649800005, -38.302666924999926],
              [144.4892684250001, -38.303399346999925],
              [144.4790145190001, -38.301039320999905],
              [144.4560653000001, -38.29225025799991],
              [144.44483483200008, -38.29029713299991],
              [144.4223738940001, -38.29338958099993],
              [144.40186608200008, -38.30120208099993],
              [144.30974368600005, -38.35670338299991],
              [144.25953209700003, -38.39576588299991],
              [144.2490340500001, -38.40162525799991],
              [144.227875196, -38.403415622999944],
              [144.2148543630001, -38.40642669099992],
              [144.2075301440001, -38.41179778399993],
              [144.19410241000003, -38.428399346999925],
              [144.1875106130001, -38.43434010199991],
              [144.13640384200005, -38.44736093499995],
              [144.1313582690001, -38.45061614399992],
              [144.12126712300005, -38.46526458099993],
              [144.1162215500001, -38.4685197899999],
              [144.07146243600005, -38.475274346999925],
              [144.05250084700003, -38.48577239399992],
              [143.99919681100005, -38.53362395599993],
              [143.99683678500003, -38.540134372999944],
              [143.99927819100003, -38.54745859199994],
              [144.00017337300005, -38.5564104149999],
              [143.99236087300005, -38.56780364399992],
              [143.9795028000001, -38.57561614399992],
              [143.95386803500003, -38.580336195999905],
              [143.94117272200003, -38.58513762799993],
              [143.92847741000003, -38.60051848799992],
              [143.90552819100003, -38.64381275799991],
              [143.8896590500001, -38.65292734199994],
              [143.8798934250001, -38.656914971999925],
              [143.86988366000003, -38.66619231599992],
              [143.85515384200005, -38.683526299999926],
              [143.84489993600005, -38.6911760399999],
              [143.745453321, -38.71933359199994],
              [143.7251082690001, -38.721774997999944],
              [143.70460045700008, -38.72812265399995],
              [143.6923934250001, -38.74309661299992],
              [143.6836043630001, -38.76116301899992],
              [143.67107181100005, -38.780368747999944],
              [143.6709090500001, -38.78337981599992],
              [143.67058353000004, -38.78630950299993],
              [143.66675866000003, -38.790134372999944],
              [143.66228274800005, -38.790948174999926],
              [143.6508895190001, -38.78923919099992],
              [143.64625084700003, -38.790134372999944],
              [143.61085045700008, -38.806573174999926],
              [143.60132897200003, -38.8142229149999],
              [143.5732528000001, -38.84295012799993],
              [143.55640709700003, -38.85393645599993],
              [143.53695722700002, -38.85833098799992],
              [143.51734459700003, -38.85019296699994],
              [143.4834090500001, -38.82366301899992],
              [143.47193444100003, -38.81796640399995],
              [143.46697024800005, -38.81462981599992],
              [143.45630944100003, -38.80006275799991],
              [143.4511824880001, -38.796807549999926],
              [143.413422071, -38.78378671699994],
              [143.37614993600005, -38.764336846999925],
              [143.3574324880001, -38.75823333099993],
              [143.3344832690001, -38.75595468499995],
              [143.241547071, -38.762790622999944],
              [143.22339928500003, -38.75628020599993],
              [143.20281009200005, -38.742852471999925],
              [143.185883009, -38.726495049999926],
              [143.17888431100005, -38.71111419099992],
              [143.11866295700008, -38.66643645599993],
              [143.08090254, -38.644789320999905],
              [143.06006920700008, -38.63591887799993],
              [142.94743899800005, -38.61874765399995],
              [142.90023847700002, -38.60116952899995],
              [142.87134850400003, -38.59661223799992],
              [142.8540145190001, -38.58733489399992],
              [142.847992384, -38.58513762799993],
              [142.81023196700005, -38.578383070999905],
              [142.76197350400003, -38.537041924999926],
              [142.7353621750001, -38.52581145599993],
              [142.65381920700008, -38.47275155999995],
              [142.5898543630001, -38.4431291649999],
              [142.553070509, -38.41952890399995],
              [142.5390731130001, -38.41464609199994],
              [142.53248131600003, -38.40984465899993],
              [142.5283309250001, -38.40789153399993],
              [142.51872806100005, -38.40748463299991],
              [142.51539147200003, -38.40642669099992],
              [142.50375410200002, -38.38486093499995],
              [142.5048934250001, -38.37851327899995],
              [142.5024520190001, -38.37444426899992],
              [142.48780358200008, -38.3728166649999],
              [142.4785262380001, -38.37656015399995],
              [142.47291100400003, -38.38534921699994],
              [142.46949303500003, -38.396416924999926],
              [142.46753991000003, -38.40642669099992],
              [142.4443465500001, -38.39706796699994],
              [142.43246504, -38.39031340899993],
              [142.4106551440001, -38.371758721999925],
              [142.39771569100003, -38.367120049999926],
              [142.312836134, -38.3669572899999],
              [142.28191165500004, -38.37379322699991],
              [142.2695418630001, -38.39275481599992],
              [142.2246199880001, -38.40569426899992],
              [142.17546634200005, -38.398695570999905],
              [142.0908309250001, -38.36541106599992],
              [141.985199415, -38.29900481599992],
              [141.94678795700008, -38.28289153399993],
              [141.93531334700003, -38.28142669099992],
              [141.89909915500004, -38.28289153399993],
              [141.887543165, -38.279961846999925],
              [141.86451256600003, -38.27109140399995],
              [141.76197350400003, -38.26181405999995],
              [141.72144616000003, -38.267510674999926],
              [141.67253665500004, -38.284274997999944],
              [141.63209069100003, -38.30877044099992],
              [141.61784915500004, -38.338148695999905],
              [141.62378991000003, -38.35361093499995],
              [141.64405358200008, -38.372979424999926],
              [141.65211022200003, -38.3864885399999],
              [141.65398196700005, -38.39983489399992],
              [141.64795983200008, -38.40276458099993],
              [141.62126712300005, -38.39902109199994],
              [141.61451256600003, -38.397149346999925],
              [141.60808353000004, -38.39373137799993],
              [141.60141035200002, -38.39226653399993],
              [141.59400475400003, -38.39576588299991],
              [141.5732528000001, -38.41326262799993],
              [141.56804446700005, -38.41952890399995],
              [141.56462649800005, -38.4314104149999],
              [141.55787194100003, -38.439711195999905],
              [141.54281660200002, -38.43434010199991],
              [141.5332137380001, -38.423760674999926],
              [141.51937910200002, -38.39812590899993],
              [141.50798587300005, -38.3864885399999],
              [141.49675540500004, -38.38054778399993],
              [141.48308353000004, -38.37623463299991],
              [141.4672957690001, -38.37379322699991],
              [141.4497176440001, -38.3728166649999],
              [141.434418165, -38.37509530999995],
              [141.42986087300005, -38.38128020599993],
              [141.42847741000003, -38.39072030999995],
              [141.4223738940001, -38.40276458099993],
              [141.41032962300005, -38.406508070999905],
              [141.3945418630001, -38.40162525799991],
              [141.37964928500003, -38.39299895599993],
              [141.37086022200003, -38.3864885399999],
              [141.37614993600005, -38.376885674999926],
              [141.39136803500003, -38.35865650799991],
              [141.39828535200002, -38.34433359199994],
              [141.39991295700008, -38.33635833099993],
              [141.39812259200005, -38.32048919099992],
              [141.3911238940001, -38.30608489399992],
              [141.37476647200003, -38.29119231599992],
              [141.2138778000001, -38.17302825299993],
              [141.13428795700008, -38.127618096999925],
              [140.98755944100003, -38.06991952899995],
              [140.97055097700002, -38.06015390399995],
              [140.95142662900003, -38.05429452899995],
              [140.71355228000004, -38.070570570999905],
              [140.69019616000003, -38.0681291649999],
              [140.66920006600003, -38.06178150799991],
              [140.6508895190001, -38.05217864399992],
              [140.6347762380001, -38.04021575299993],
              [140.6250106130001, -38.0368791649999],
              [140.602386915, -38.037774346999925],
              [140.5937606130001, -38.03337981599992],
              [140.58383222700002, -38.0232072899999],
              [140.57593834700003, -38.018243096999925],
              [140.55534915500004, -38.00920989399992],
              [140.4770613940001, -37.95086028399993],
              [140.45728600400003, -37.93914153399993],
              [140.4165145190001, -37.927666924999926],
              [140.39820397200003, -37.919854424999926],
              [140.39625084700003, -37.91619231599992],
              [140.39242597700002, -37.90309010199991],
              [140.39079837300005, -37.89934661299992],
              [140.3867293630001, -37.89763762799993],
              [140.37476647200003, -37.89495208099993],
              [140.37086022200003, -37.89316171699994],
              [140.3598738940001, -37.88209400799991],
              [140.3574324880001, -37.87517669099992],
              [140.35670006600003, -37.86174895599993],
              [140.3535262380001, -37.84710051899992],
              [140.33716881600003, -37.81609465899993],
              [140.28777103000004, -37.74879322699991],
              [140.28150475400003, -37.731540622999944],
              [140.240570509, -37.665948174999926],
              [140.21314537900003, -37.642510674999926],
              [140.1372176440001, -37.59531015399995],
              [140.110199415, -37.57040780999995],
              [140.110199415, -37.563571872999944],
              [140.13428795700008, -37.55673593499995],
              [140.13168379, -37.537367445999905],
              [140.1142684250001, -37.517510674999926],
              [140.09351647200003, -37.50839609199994],
              [140.08269290500004, -37.50505950299993],
              [140.06324303500003, -37.49098072699991],
              [140.052093946, -37.48788827899995],
              [140.04615319100003, -37.48691171699994],
              [140.036468946, -37.48251718499995],
              [140.03142337300005, -37.48162200299993],
              [140.02523847700002, -37.484633070999905],
              [140.0219832690001, -37.49146900799991],
              [140.02100670700008, -37.498304945999905],
              [140.0214949880001, -37.50156015399995],
              [139.98804772200003, -37.48707447699991],
              [139.7949324880001, -37.26873137799993],
              [139.7700301440001, -37.22087981599992],
              [139.741547071, -37.18084075299993],
              [139.747406446, -37.17083098799992],
              [139.7641707690001, -37.16464609199994],
              [139.7812606130001, -37.152601820999905],
              [139.78834069100003, -37.12623463299991],
              [139.77418053500003, -37.10369231599992],
              [139.75342858200008, -37.08163827899995],
              [139.73975670700008, -37.0564104149999],
              [139.735687696, -37.01873137799993],
              [139.72917728000004, -37.003838799999926],
              [139.712250196, -36.9880510399999],
              [139.68620853000004, -36.976495049999926],
              [139.67562910200002, -36.96819426899992],
              [139.67204837300005, -36.953383070999905],
              [139.78484134200005, -36.90203215899993],
              [139.8154403000001, -36.87900155999995],
              [139.842133009, -36.84587981599992],
              [139.85718834700003, -36.80877044099992],
              [139.86353600400003, -36.76726653399993],
              [139.85710696700005, -36.63494231599992],
              [139.85368899800005, -36.621758721999925],
              [139.7290145190001, -36.37232838299991],
              [139.63461347700002, -36.20354583099993],
              [139.5673934250001, -36.075290622999944],
              [139.548187696, -36.05820077899995],
              [139.514984571, -36.03533294099992],
              [139.4726668630001, -35.98455169099992],
              [139.46656334700003, -35.97014739399992],
              [139.45671634200005, -35.95794036299992],
              [139.27214603000004, -35.80510833099993],
              [139.19890384200005, -35.746758721999925],
              [139.16138756600003, -35.72779713299991],
              [139.1298934250001, -35.69931405999995],
              [139.09888756600003, -35.68645598799992],
              [139.06234785200002, -35.658135674999926],
              [139.03150475400003, -35.64544036299992],
              [138.9990340500001, -35.61728280999995],
              [138.96827233200008, -35.60662200299993],
              [138.91781660200002, -35.57675546699994],
              [138.95923912900003, -35.566664320999905],
              [139.0009871750001, -35.58538176899992],
              [139.3481551440001, -35.84783294099992],
              [139.44752037900003, -35.92734140399995],
              [139.49822024800005, -35.977227471999925],
              [139.56519616000003, -36.04973723799992],
              [139.60043379, -36.11101653399993],
              [139.66521243600005, -36.22779713299991],
              [139.67204837300005, -36.22779713299991],
              [139.66570071700005, -36.183851820999905],
              [139.61052493600005, -36.07634856599992],
              [139.60027103000004, -36.03785572699991],
              [139.5937606130001, -36.022556247999944],
              [139.47543379, -35.896416924999926],
              [139.45777428500003, -35.88298919099992],
              [139.41814212300005, -35.87167734199994],
              [139.4013778000001, -35.857354424999926],
              [139.3759871750001, -35.830010674999926],
              [139.18677819100003, -35.69068775799991],
              [139.16773522200003, -35.68596770599993],
              [139.1035262380001, -35.641289971999925],
              [139.094574415, -35.63209400799991],
              [139.05339603000004, -35.611993096999925],
              [139.041351759, -35.60409921699994],
              [139.0361434250001, -35.58684661299992],
              [139.041351759, -35.5739885399999],
              [139.0551863940001, -35.569431247999944],
              [139.075531446, -35.57675546699994],
              [139.07683353000004, -35.551446221999925],
              [139.0859481130001, -35.53533294099992],
              [139.11345462300005, -35.51116301899992],
              [139.13542728000004, -35.498304945999905],
              [139.1552840500001, -35.50335051899992],
              [139.18482506600003, -35.52825286299992],
              [139.20142662900003, -35.53525155999995],
              [139.21949303500003, -35.53948333099993],
              [139.23414147200003, -35.547539971999925],
              [139.24000084700003, -35.565524997999944],
              [139.23585045700008, -35.59002044099992],
              [139.22836347700002, -35.604180596999925],
              [139.22486412900003, -35.61541106599992],
              [139.23259524800005, -35.63128020599993],
              [139.24187259200005, -35.635837497999944],
              [139.25123131600003, -35.63437265399995],
              [139.25652103000004, -35.63640715899993],
              [139.25367272200003, -35.65178801899992],
              [139.2461043630001, -35.658135674999926],
              [139.23357181100005, -35.6657854149999],
              [139.22486412900003, -35.67587655999995],
              [139.2295028000001, -35.689385674999926],
              [139.24390709700003, -35.69451262799993],
              [139.29761803500003, -35.70061614399992],
              [139.31519616000003, -35.700290622999944],
              [139.33806399800005, -35.687432549999926],
              [139.34009850400003, -35.66871510199991],
              [139.33765709700003, -35.64763762799993],
              [139.3462020190001, -35.62786223799992],
              [139.3603621750001, -35.60784270599993],
              [139.35572350400003, -35.59335702899995],
              [139.28443444100003, -35.53850676899992],
              [139.27076256600003, -35.53134530999995],
              [139.23617597700002, -35.52459075299993],
              [139.2226668630001, -35.51799895599993],
              [139.21892337300005, -35.50725676899992],
              [139.2304793630001, -35.50058359199994],
              [139.26050866000003, -35.49423593499995],
              [139.26685631600003, -35.49041106599992],
              [139.26978600400003, -35.48593515399995],
              [139.2739363940001, -35.48211028399993],
              [139.28443444100003, -35.48056405999995],
              [139.29509524800005, -35.481133721999925],
              [139.35043379, -35.49293385199991],
              [139.36101321700005, -35.48951588299991],
              [139.3730574880001, -35.47673919099992],
              [139.3754988940001, -35.463962497999944],
              [139.36687259200005, -35.45256926899992],
              [139.3554793630001, -35.44150155999995],
              [139.34986412900003, -35.42896900799991],
              [139.3642684250001, -35.388929945999905],
              [139.36296634200005, -35.376885674999926],
              [139.35132897200003, -35.370212497999944],
              [139.33863366000003, -35.376885674999926],
              [139.31519616000003, -35.39788176899992],
              [139.30144290500004, -35.35662200299993],
              [139.2675887380001, -35.33131275799991],
              [139.2231551440001, -35.31878020599993],
              [139.17798912900003, -35.31536223799992],
              [139.1826278000001, -35.320570570999905],
              [139.18523196700005, -35.32439544099992],
              [139.18930097700002, -35.32708098799992],
              [139.19849694100003, -35.32903411299992],
              [139.18425540500004, -35.344008070999905],
              [139.137543165, -35.36728280999995],
              [139.1196395190001, -35.38054778399993],
              [139.1020613940001, -35.38925546699994],
              [139.0747176440001, -35.3923479149999],
              [139.04664147200003, -35.39072030999995],
              [139.027679884, -35.38437265399995],
              [138.98170006600003, -35.40007903399993],
              [138.96119225400003, -35.4138322899999],
              [138.95264733200008, -35.435804945999905],
              [138.95687910200002, -35.46379973799992],
              [138.969086134, -35.47535572699991],
              [139.014008009, -35.48674895599993],
              [139.03142337300005, -35.49700286299992],
              [139.03793379, -35.50839609199994],
              [139.03093509200005, -35.517510674999926],
              [139.007172071, -35.521416924999926],
              [138.99488366000003, -35.51921965899993],
              [138.97445722700002, -35.50994231599992],
              [138.91781660200002, -35.501071872999944],
              [138.9087020190001, -35.49472421699994],
              [138.89861087300005, -35.479180596999925],
              [138.8906356130001, -35.47307708099993],
              [138.88111412900003, -35.47112395599993],
              [138.8037215500001, -35.47576262799993],
              [138.793793165, -35.48398202899995],
              [138.8086043630001, -35.501071872999944],
              [138.82634524800005, -35.50701262799993],
              [138.89730879, -35.507745049999926],
              [138.91000410200002, -35.50994231599992],
              [138.91911868600005, -35.5153947899999],
              [138.93523196700005, -35.53167083099993],
              [138.946625196, -35.53639088299991],
              [138.958343946, -35.53378671699994],
              [138.96949303500003, -35.52939218499995],
              [138.97934004, -35.52825286299992],
              [138.99976647200003, -35.53875090899993],
              [138.99341881600003, -35.547539971999925],
              [138.97234134200005, -35.55388762799993],
              [138.94898522200003, -35.55624765399995],
              [138.93864993600005, -35.554945570999905],
              [138.91911868600005, -35.54998137799993],
              [138.907562696, -35.548760674999926],
              [138.897797071, -35.551039320999905],
              [138.88200931100005, -35.56064218499995],
              [138.869476759, -35.56178150799991],
              [138.852386915, -35.55673593499995],
              [138.8144637380001, -35.538995049999926],
              [138.79127037900003, -35.535088799999926],
              [138.74586022200003, -35.53875090899993],
              [138.6606551440001, -35.558526299999926],
              [138.639008009, -35.567071221999925],
              [138.6298934250001, -35.57976653399993],
              [138.62281334700003, -35.595635674999926],
              [138.605804884, -35.610039971999925],
              [138.56910241000003, -35.63128020599993],
              [138.5312606130001, -35.64592864399992],
              [138.43702233200008, -35.65781015399995],
              [138.28052819100003, -35.65178801899992],
              [138.28052819100003, -35.6443010399999],
              [138.2646590500001, -35.65374114399992],
              [138.2441512380001, -35.66253020599993],
              [138.222015821, -35.669040622999944],
              [138.2016707690001, -35.6716447899999],
              [138.1767684250001, -35.668226820999905],
              [138.15837649800005, -35.65984465899993],
              [138.1074324880001, -35.62070077899995],
              [138.10499108200008, -35.610446872999944],
              [138.1113387380001, -35.59775155999995],
              [138.11597741000003, -35.572930596999925],
              [138.12273196700005, -35.555352471999925],
              [138.139008009, -35.54045989399992],
              [138.15943444100003, -35.52890390399995],
              [138.25757897200003, -35.49065520599993],
              [138.28728274800005, -35.46990325299993],
              [138.31519616000003, -35.43889739399992],
              [138.3398543630001, -35.40276458099993],
              [138.3564559250001, -35.3845354149999],
              [138.37322024800005, -35.376885674999926],
              [138.38884524800005, -35.372979424999926],
              [138.40894616000003, -35.36386484199994],
              [138.42741946700005, -35.352634372999944],
              [138.43816165500004, -35.34270598799992],
              [138.44450931100005, -35.3220354149999],
              [138.44109134200005, -35.28167083099993],
              [138.44556725400003, -35.260837497999944],
              [138.45191491000003, -35.25253671699994],
              [138.4599715500001, -35.246758721999925],
              [138.4672957690001, -35.23967864399992],
              [138.47217858200008, -35.227227471999925],
              [138.47193444100003, -35.2146135399999],
              [138.46753991000003, -35.20468515399995],
              [138.462250196, -35.19540780999995],
              [138.45923912900003, -35.18564218499995],
              [138.45850670700008, -35.166680596999925],
              [138.46656334700003, -35.11052825299993],
              [138.4765731130001, -35.09189218499995],
              [138.50733483200008, -35.056573174999926],
              [138.51392662900003, -35.03826262799993],
              [138.50953209700003, -34.99553801899992],
              [138.4907332690001, -34.91375090899993],
              [138.48650149800005, -34.87346770599993],
              [138.49390709700003, -34.79159921699994],
              [138.5009871750001, -34.77092864399992],
              [138.516937696, -34.76913827899995],
              [138.53500410200002, -34.78085702899995],
              [138.54802493600005, -34.801446221999925],
              [138.55062910200002, -34.781914971999925],
              [138.54704837300005, -34.75945403399993],
              [138.53630618600005, -34.740899346999925],
              [138.5175887380001, -34.73316822699991],
              [138.5063582690001, -34.73056405999995],
              [138.49634850400003, -34.723728122999944],
              [138.4892684250001, -34.713962497999944],
              [138.48650149800005, -34.70281340899993],
              [138.4809676440001, -34.69841887799993],
              [138.45460045700008, -34.69101327899995],
              [138.44556725400003, -34.68596770599993],
              [138.44019616000003, -34.6755510399999],
              [138.43970787900003, -34.66570403399993],
              [138.44019616000003, -34.65545012799993],
              [138.43816165500004, -34.644463799999926],
              [138.4336043630001, -34.6364885399999],
              [138.39795983200008, -34.60784270599993],
              [138.36882571700005, -34.590508721999925],
              [138.35670006600003, -34.576104424999926],
              [138.34131920700008, -34.53785572699991],
              [138.32960045700008, -34.520603122999944],
              [138.29420006600003, -34.504571221999925],
              [138.27906334700003, -34.48357512799993],
              [138.25993899800005, -34.43840911299992],
              [138.2265731130001, -34.32048919099992],
              [138.20533287900003, -34.288181247999944],
              [138.172211134, -34.2712541649999],
              [138.155609571, -34.260430596999925],
              [138.15381920700008, -34.250258070999905],
              [138.1640731130001, -34.23015715899993],
              [138.15886478000004, -34.21184661299992],
              [138.10027103000004, -34.14413827899995],
              [138.0781356130001, -34.12835051899992],
              [138.06812584700003, -34.14080169099992],
              [138.063812696, -34.16285572699991],
              [138.05339603000004, -34.18092213299991],
              [138.01628665500004, -34.22730885199991],
              [138.00928795700008, -34.24431731599992],
              [138.010101759, -34.26327890399995],
              [138.02320397200003, -34.28435637799993],
              [138.02995853000004, -34.29111093499995],
              [138.0361434250001, -34.29892343499995],
              [138.03777103000004, -34.30803801899992],
              [137.99927819100003, -34.356540622999944],
              [137.93091881600003, -34.41480885199991],
              [137.92790774800005, -34.429620049999926],
              [137.89226321700005, -34.526055596999925],
              [137.889984571, -34.54143645599993],
              [137.89014733200008, -34.56926848799992],
              [137.88892662900003, -34.58098723799992],
              [137.883148634, -34.589776299999926],
              [137.91041100400003, -34.62395598799992],
              [137.89730879, -34.6443010399999],
              [137.88648522200003, -34.66659921699994],
              [137.87907962300005, -34.69060637799993],
              [137.87330162900003, -34.76018645599993],
              [137.8701278000001, -34.774102471999925],
              [137.86402428500003, -34.78671640399995],
              [137.84595787900003, -34.81194426899992],
              [137.8422957690001, -34.81894296699994],
              [137.8379012380001, -34.830743096999925],
              [137.81918379, -34.85125090899993],
              [137.814789259, -34.86012135199991],
              [137.813324415, -34.87420012799993],
              [137.80054772200003, -34.91814544099992],
              [137.7744246750001, -34.97625090899993],
              [137.7661238940001, -35.008070570999905],
              [137.7739363940001, -35.03484465899993],
              [137.75220787900003, -35.047946872999944],
              [137.746918165, -35.058851820999905],
              [137.75277754, -35.09319426899992],
              [137.750824415, -35.126071872999944],
              [137.74952233200008, -35.13103606599992],
              [137.74724368600005, -35.13298919099992],
              [137.7187606130001, -35.14470794099992],
              [137.69361412900003, -35.17229583099993],
              [137.6845809250001, -35.17888762799993],
              [137.67139733200008, -35.18084075299993],
              [137.61988366000003, -35.16659921699994],
              [137.58179772200003, -35.1403947899999],
              [137.5610457690001, -35.13103606599992],
              [137.54957116000003, -35.12965260199991],
              [137.52019290500004, -35.13103606599992],
              [137.50896243600005, -35.12786223799992],
              [137.49105879, -35.11923593499995],
              [137.48194420700008, -35.11736419099992],
              [137.44418379, -35.11638762799993],
              [137.42554772200003, -35.118259372999944],
              [137.40349368600005, -35.12420012799993],
              [137.38355553500003, -35.13616301899992],
              [137.35075931100005, -35.16611093499995],
              [137.3320418630001, -35.17205169099992],
              [137.26099694100003, -35.1657854149999],
              [137.23894290500004, -35.17205169099992],
              [137.20883222700002, -35.19768645599993],
              [137.191742384, -35.2243791649999],
              [137.16920006600003, -35.24228280999995],
              [137.12281334700003, -35.240899346999925],
              [137.06202233200008, -35.22665780999995],
              [137.03972415500004, -35.227227471999925],
              [136.9809676440001, -35.25530364399992],
              [136.95337975400003, -35.28394947699991],
              [136.91358483200008, -35.29656340899993],
              [136.87387129, -35.2946916649999],
              [136.8559676440001, -35.27109140399995],
              [136.85303795700008, -35.26604583099993],
              [136.83936608200008, -35.256117445999905],
              [136.83545983200008, -35.24773528399993],
              [136.83708743600005, -35.241306247999944],
              [136.84636478000004, -35.226495049999926],
              [136.848480665, -35.216729424999926],
              [136.8554793630001, -35.20468515399995],
              [136.88982181100005, -35.18865325299993],
              [136.90308678500003, -35.17888762799993],
              [136.89568118600005, -35.17205169099992],
              [136.9043074880001, -35.1657854149999],
              [136.92253665500004, -35.15667083099993],
              [136.92986087300005, -35.15154387799993],
              [136.93384850400003, -35.14592864399992],
              [136.93970787900003, -35.13201262799993],
              [136.9609481130001, -35.09644947699991],
              [136.96265709700003, -35.0818010399999],
              [136.95777428500003, -35.062758070999905],
              [136.94890384200005, -35.04745859199994],
              [136.9419051440001, -35.03866952899995],
              [136.94125410200002, -35.02988046699994],
              [136.951508009, -35.01490650799991],
              [136.97575931100005, -34.996758721999925],
              [136.98072350400003, -34.98495859199994],
              [136.97144616000003, -34.965915622999944],
              [137.0141707690001, -34.917901299999926],
              [137.01978600400003, -34.901462497999944],
              [137.030609571, -34.89983489399992],
              [137.09498131600003, -34.92498137799993],
              [137.13949629, -34.926039320999905],
              [137.2236434250001, -34.90699635199991],
              [137.26685631600003, -34.90504322699991],
              [137.287445509, -34.911228122999944],
              [137.29712975400003, -34.920179945999905],
              [137.30787194100003, -34.92831796699994],
              [137.35718834700003, -34.93759530999995],
              [137.3740340500001, -34.94801197699991],
              [137.39128665500004, -34.95403411299992],
              [137.41773522200003, -34.94548919099992],
              [137.446136915, -34.91741301899992],
              [137.45297285200002, -34.88339609199994],
              [137.45232181100005, -34.844414971999925],
              [137.4580184250001, -34.801446221999925],
              [137.47437584700003, -34.77263762799993],
              [137.4785262380001, -34.76116301899992],
              [137.47925866000003, -34.74920012799993],
              [137.47771243600005, -34.72470468499995],
              [137.4785262380001, -34.7126604149999],
              [137.5127059250001, -34.61777109199994],
              [137.4990340500001, -34.589776299999926],
              [137.49398847700002, -34.55413176899992],
              [137.48023522200003, -34.52654387799993],
              [137.4824324880001, -34.48398202899995],
              [137.4785262380001, -34.46624114399992],
              [137.4594832690001, -34.447523695999905],
              [137.44483483200008, -34.451836846999925],
              [137.43116295700008, -34.46502044099992],
              [137.41431725400003, -34.4724260399999],
              [137.41529381600003, -34.46331145599993],
              [137.43580162900003, -34.41920338299991],
              [137.44499759200005, -34.404229424999926],
              [137.44874108200008, -34.40325286299992],
              [137.46111087300005, -34.40504322699991],
              [137.4648543630001, -34.404229424999926],
              [137.46705162900003, -34.39983489399992],
              [137.47022545700008, -34.38827890399995],
              [137.47632897200003, -34.37664153399993],
              [137.48389733200008, -34.355401299999926],
              [137.4921981130001, -34.28248463299991],
              [137.4921981130001, -34.26018645599993],
              [137.489105665, -34.23772551899992],
              [137.48316491000003, -34.2146135399999],
              [137.47413170700008, -34.19296640399995],
              [137.45386803500003, -34.163995049999926],
              [137.45240319100003, -34.15569426899992],
              [137.4555770190001, -34.148370049999926],
              [137.4614363940001, -34.14080169099992],
              [137.47055097700002, -34.13787200299993],
              [137.4946395190001, -34.14885833099993],
              [137.50652103000004, -34.150323174999926],
              [137.5195418630001, -34.13787200299993],
              [137.54859459700003, -34.08717213299991],
              [137.55420983200008, -34.0720354149999],
              [137.5537215500001, -34.05868905999995],
              [137.551605665, -34.04957447699991],
              [137.54053795700008, -34.02752044099992],
              [137.53443444100003, -34.01799895599993],
              [137.53191165500004, -34.0153947899999],
              [137.54053795700008, -34.00074635199991],
              [137.5527449880001, -33.98455169099992],
              [137.5712996750001, -33.96640390399995],
              [137.59050540500004, -33.95175546699994],
              [137.61508222700002, -33.94150155999995],
              [137.62289472700002, -33.931573174999926],
              [137.6279403000001, -33.92009856599992],
              [137.6294051440001, -33.910821221999925],
              [137.62525475400003, -33.899102471999925],
              [137.6181746750001, -33.89137135199991],
              [137.6098738940001, -33.88486093499995],
              [137.6020613940001, -33.87664153399993],
              [137.617523634, -33.86923593499995],
              [137.63111412900003, -33.857679945999905],
              [137.65357506600003, -33.83220794099992],
              [137.7041121750001, -33.79314544099992],
              [137.7153426440001, -33.78728606599992],
              [137.7519637380001, -33.72616952899995],
              [137.77662194100003, -33.69353606599992],
              [137.79444420700008, -33.69850025799991],
              [137.80054772200003, -33.69850025799991],
              [137.86296634200005, -33.62615325299993],
              [137.87884232200008, -33.59786985299991],
              [137.903678097, -33.58769376799995],
              [137.91006669400008, -33.59623740199993],
              [137.89807892700003, -33.61365734299994],
              [137.906058648, -33.627566187999946],
              [137.93091881600003, -33.61646900799991],
              [137.93327884200005, -33.60320403399993],
              [137.930656699, -33.577968970999905],
              [137.93677263300003, -33.55246487699992],
              [137.9374920360001, -33.52784029499992],
              [137.9290168880001, -33.51123364999995],
              [137.918460814, -33.48787957899992],
              [137.90367165500004, -33.4559982369999],
              [137.8925318360001, -33.43846545999992],
              [137.88351282000008, -33.42497649399991],
              [137.87399790300003, -33.41309620599992],
              [137.8623395300001, -33.39600969399993],
              [137.86466775100007, -33.37408177399993],
              [137.869624585, -33.3584370879999],
              [137.8617117870001, -33.34316440799995],
              [137.84365399800004, -33.32335511999992],
              [137.8181878800001, -33.29363528999994],
              [137.810443781, -33.259984963999955],
              [137.82178795700008, -33.24667734199994],
              [137.8300887380001, -33.22600676899992],
              [137.8408309250001, -33.20598723799992],
              [137.85499108200008, -33.19060637799993],
              [137.89429772200003, -33.17929452899995],
              [137.9521590500001, -33.143649997999944],
              [137.9575301440001, -33.143649997999944],
              [137.9668074880001, -33.14902109199994],
              [137.9726668630001, -33.14983489399992],
              [137.97730553500003, -33.147149346999925],
              [137.9887801440001, -33.13762786299992],
              [137.99244225400003, -33.13551197699991],
              [138.00416100400003, -33.139336846999925],
              [138.0146590500001, -33.14592864399992],
              [138.02515709700003, -33.14853280999995],
              [138.0371199880001, -33.13958098799992],
              [138.043304884, -33.12981536299992],
              [138.0439559250001, -33.12509530999995],
              [138.04175866000003, -33.12053801899992],
              [138.04021243600005, -33.11223723799992],
              [138.04118899800005, -33.08928801899992],
              [138.04021243600005, -33.08163827899995],
              [138.035492384, -33.06609465899993],
              [138.02898196700005, -33.050713799999926],
              [138.0205184250001, -33.03655364399992],
              [138.010101759, -33.024102471999925],
              [138.000824415, -33.020196221999925],
              [137.97836347700002, -33.02117278399993],
              [137.9692488940001, -33.01726653399993],
              [137.96119225400003, -33.00945403399993],
              [137.95777428500003, -33.00465260199991],
              [137.9023543630001, -32.78753020599993],
              [137.9023543630001, -32.77402109199994],
              [137.91334069100003, -32.76523202899995],
              [137.9384871750001, -32.752618096999925],
              [137.896820509, -32.72161223799992],
              [137.889984571, -32.71526458099993],
              [137.88746178500003, -32.70989348799992],
              [137.8808699880001, -32.70720794099992],
              [137.87322024800005, -32.705010674999926],
              [137.86247806100005, -32.69963958099993],
              [137.851898634, -32.69890715899993],
              [137.84913170700008, -32.697930596999925],
              [137.8476668630001, -32.69394296699994],
              [137.8481551440001, -32.689711195999905],
              [137.8481551440001, -32.685479424999926],
              [137.8457137380001, -32.68124765399995],
              [137.84498131600003, -32.67636484199994],
              [137.84978274800005, -32.65878671699994],
              [137.84913170700008, -32.6501604149999],
              [137.84351647200003, -32.640883070999905],
              [137.82178795700008, -32.6228166649999],
              [137.81080162900003, -32.60906340899993],
              [137.80396569100003, -32.59465911299992],
              [137.80591881600003, -32.58066171699994],
              [137.82178795700008, -32.568291924999926],
              [137.81275475400003, -32.56023528399993],
              [137.8032332690001, -32.55803801899992],
              [137.794281446, -32.557305596999925],
              [137.78695722700002, -32.55388762799993],
              [137.7832137380001, -32.54583098799992],
              [137.77906334700003, -32.52548593499995],
              [137.7739363940001, -32.519789320999905],
              [137.76441491000003, -32.52418385199991],
              [137.760101759, -32.54062265399995],
              [137.75757897200003, -32.56023528399993],
              [137.75277754, -32.57439544099992],
              [137.76042728000004, -32.5935197899999],
              [137.7622176440001, -32.61760833099993],
              [137.7602645190001, -32.66033294099992],
              [137.7529403000001, -32.68287525799991],
              [137.7539168630001, -32.69345468499995],
              [137.78003991000003, -32.70240650799991],
              [137.78980553500003, -32.71306731599992],
              [137.79656009200005, -32.726495049999926],
              [137.80054772200003, -32.738946221999925],
              [137.8066512380001, -32.77988046699994],
              [137.80925540500004, -32.84693775799991],
              [137.80827884200005, -32.85800546699994],
              [137.80437259200005, -32.86614348799992],
              [137.79607181100005, -32.87769947699991],
              [137.7871199880001, -32.90113697699991],
              [137.78012129, -32.910821221999925],
              [137.77173912900003, -32.91285572699991],
              [137.76579837300005, -32.90781015399995],
              [137.76002037900003, -32.90593840899993],
              [137.75277754, -32.91765715899993],
              [137.7519637380001, -32.92717864399992],
              [137.75416100400003, -32.93808359199994],
              [137.75855553500003, -32.94817473799992],
              [137.77515709700003, -32.9704729149999],
              [137.7783309250001, -32.98284270599993],
              [137.76978600400003, -32.99081796699994],
              [137.7461043630001, -32.99277109199994],
              [137.73308353000004, -32.99179452899995],
              [137.72413170700008, -32.98984140399995],
              [137.70492597700002, -32.97975025799991],
              [137.67400149800005, -32.95525481599992],
              [137.6562606130001, -32.95134856599992],
              [137.63209069100003, -32.96152109199994],
              [137.60922285200002, -32.97779713299991],
              [137.595062696, -32.99277109199994],
              [137.59449303500003, -32.999118747999944],
              [137.5962020190001, -33.01962655999995],
              [137.595062696, -33.02752044099992],
              [137.5903426440001, -33.03484465899993],
              [137.5127059250001, -33.10881926899992],
              [137.49195397200003, -33.11956145599993],
              [137.4697371750001, -33.12810637799993],
              [137.4521590500001, -33.14006926899992],
              [137.44499759200005, -33.16073984199994],
              [137.44402103000004, -33.18515390399995],
              [137.44060306100005, -33.20468515399995],
              [137.43433678500003, -33.22185637799993],
              [137.388031446, -33.29387786299992],
              [137.38298587300005, -33.31145598799992],
              [137.37671959700003, -33.38990650799991],
              [137.3696395190001, -33.41326262799993],
              [137.35922285200002, -33.43124765399995],
              [137.31666100400003, -33.48121510199991],
              [137.3056746750001, -33.49920012799993],
              [137.25163821700005, -33.61248137799993],
              [137.22486412900003, -33.65325286299992],
              [137.20142662900003, -33.67115650799991],
              [137.18433678500003, -33.6775041649999],
              [137.15503991000003, -33.705743096999925],
              [137.13249759200005, -33.71217213299991],
              [137.08350670700008, -33.71648528399993],
              [137.02019290500004, -33.73015715899993],
              [137.01319420700008, -33.72942473799992],
              [137.00554446700005, -33.7263322899999],
              [136.99390709700003, -33.719414971999925],
              [136.99097741000003, -33.713555596999925],
              [136.99008222700002, -33.70712655999995],
              [136.98511803500003, -33.69850025799991],
              [136.9653426440001, -33.68450286299992],
              [136.94556725400003, -33.682305596999925],
              [136.93043053500003, -33.69255950299993],
              [136.9243270190001, -33.715508721999925],
              [136.92017662900003, -33.724541924999926],
              [136.91089928500003, -33.73211028399993],
              [136.90023847700002, -33.73748137799993],
              [136.8925887380001, -33.73943450299993],
              [136.883148634, -33.74431731599992],
              [136.883148634, -33.75481536299992],
              [136.88697350400003, -33.765557549999926],
              [136.88941491000003, -33.77044036299992],
              [136.94654381600003, -33.75123463299991],
              [136.96461022200003, -33.75310637799993],
              [136.91236412900003, -33.78093840899993],
              [136.8994246750001, -33.790948174999926],
              [136.8789168630001, -33.8025041649999],
              [136.8554793630001, -33.80486419099992],
              [136.8310653000001, -33.804620049999926],
              [136.80746504, -33.8083635399999],
              [136.7900496750001, -33.8181291649999],
              [136.77711022200003, -33.82935963299991],
              [136.76124108200008, -33.838555596999925],
              [136.735199415, -33.842461846999925],
              [136.72478274800005, -33.84685637799993],
              [136.71111087300005, -33.86614348799992],
              [136.7011824880001, -33.87037525799991],
              [136.695648634, -33.87200286299992],
              [136.6704207690001, -33.883477471999925],
              [136.6074324880001, -33.90292734199994],
              [136.59131920700008, -33.91448333099993],
              [136.58521569100003, -33.921807549999926],
              [136.5825301440001, -33.92848072699991],
              [136.58155358200008, -33.94890715899993],
              [136.5400496750001, -33.97283294099992],
              [136.51124108200008, -33.99822356599992],
              [136.493500196, -34.009698174999926],
              [136.4511824880001, -34.017836195999905],
              [136.4316512380001, -34.02703215899993],
              [136.36939537900003, -34.07341887799993],
              [136.36198978000004, -34.082696221999925],
              [136.35808353000004, -34.09335702899995],
              [136.35718834700003, -34.11370208099993],
              [136.35434004, -34.12428150799991],
              [136.3486434250001, -34.13323333099993],
              [136.33423912900003, -34.1482072899999],
              [136.32781009200005, -34.15781015399995],
              [136.31812584700003, -34.185479424999926],
              [136.2934676440001, -34.208916924999926],
              [136.23218834700003, -34.30868905999995],
              [136.1992293630001, -34.33098723799992],
              [136.138031446, -34.35475025799991],
              [136.11475670700008, -34.38372161299992],
              [136.12663821700005, -34.398370049999926],
              [136.12037194100003, -34.40862395599993],
              [136.11085045700008, -34.41757577899995],
              [136.111664259, -34.42815520599993],
              [136.12232506600003, -34.44215260199991],
              [136.12484785200002, -34.4528947899999],
              [136.12232506600003, -34.48333098799992],
              [136.1157332690001, -34.51677825299993],
              [136.10141035200002, -34.53484465899993],
              [136.08716881600003, -34.53240325299993],
              [136.08073978000004, -34.504164320999905],
              [136.0693465500001, -34.48186614399992],
              [136.04281660200002, -34.48650481599992],
              [135.99138431100005, -34.5134416649999],
              [135.96607506600003, -34.515557549999926],
              [135.95142662900003, -34.52068450299993],
              [135.93677819100003, -34.53460051899992],
              [135.93043053500003, -34.54900481599992],
              [135.9243270190001, -34.57887135199991],
              [135.91627037900003, -34.589776299999926],
              [135.93970787900003, -34.62004973799992],
              [135.94361412900003, -34.63746510199991],
              [135.930511915, -34.65252044099992],
              [135.910980665, -34.63339609199994],
              [135.89079837300005, -34.631117445999905],
              [135.87476647200003, -34.64373137799993],
              [135.86841881600003, -34.668633721999925],
              [135.86736087300005, -34.678806247999944],
              [135.86207116000003, -34.69817473799992],
              [135.86101321700005, -34.709649346999925],
              [135.86491946700005, -34.718682549999926],
              [135.883148634, -34.735446872999944],
              [135.88892662900003, -34.74684010199991],
              [135.88298587300005, -34.76848723799992],
              [135.86117597700002, -34.769463799999926],
              [135.8379012380001, -34.766696872999944],
              [135.82691491000003, -34.77752044099992],
              [135.82252037900003, -34.78769296699994],
              [135.80388431100005, -34.79924895599993],
              [135.79948978000004, -34.80527109199994],
              [135.8051863940001, -34.81698984199994],
              [135.8183699880001, -34.82170989399992],
              [135.84742272200003, -34.82195403399993],
              [135.86736087300005, -34.819431247999944],
              [135.88697350400003, -34.81324635199991],
              [135.90495853000004, -34.80388762799993],
              [135.9419051440001, -34.77044036299992],
              [135.94703209700003, -34.7673479149999],
              [135.95923912900003, -34.77190520599993],
              [135.96631920700008, -34.78053150799991],
              [135.97339928500003, -34.78606536299992],
              [135.98511803500003, -34.78093840899993],
              [135.99048912900003, -34.7712541649999],
              [135.98853600400003, -34.74879322699991],
              [135.99138431100005, -34.7400041649999],
              [135.99976647200003, -34.73512135199991],
              [136.00904381600003, -34.73674895599993],
              [136.01636803500003, -34.744073174999926],
              [136.01929772200003, -34.75741952899995],
              [136.0180770190001, -34.80136484199994],
              [136.0122176440001, -34.81845468499995],
              [135.99878991000003, -34.83562590899993],
              [135.982758009, -34.85019296699994],
              [135.972015821, -34.862399997999944],
              [135.96949303500003, -34.87664153399993],
              [135.99878991000003, -34.94548919099992],
              [135.99789472700002, -34.94670989399992],
              [135.998383009, -34.96217213299991],
              [136.000336134, -34.96575286299992],
              [136.01246178500003, -34.97966887799993],
              [136.00310306100005, -34.99081796699994],
              [135.97730553500003, -34.99700286299992],
              [135.96461022200003, -35.00750090899993],
              [135.94516035200002, -34.99773528399993],
              [135.92750084700003, -34.95517343499995],
              [135.91285241000003, -34.94548919099992],
              [135.90259850400003, -34.943291924999926],
              [135.87867272200003, -34.93181731599992],
              [135.86402428500003, -34.9294572899999],
              [135.85962975400003, -34.92343515399995],
              [135.85865319100003, -34.91497161299992],
              [135.85474694100003, -34.90504322699991],
              [135.8222762380001, -34.87428150799991],
              [135.78272545700008, -34.85759856599992],
              [135.74146569100003, -34.86101653399993],
              [135.703949415, -34.89080169099992],
              [135.6977645190001, -34.91130950299993],
              [135.69459069100003, -34.91497161299992],
              [135.69011478000004, -34.91676197699991],
              [135.6840926440001, -34.91814544099992],
              [135.68572024800005, -34.92652760199991],
              [135.689789259, -34.938164971999925],
              [135.69019616000003, -34.94850025799991],
              [135.6806746750001, -34.9528947899999],
              [135.63257897200003, -34.9528947899999],
              [135.6235457690001, -34.947930596999925],
              [135.6215926440001, -34.93596770599993],
              [135.622406446, -34.922133070999905],
              [135.6220809250001, -34.91130950299993],
              [135.6040145190001, -34.88014088299991],
              [135.5122176440001, -34.795179945999905],
              [135.47641035200002, -34.7497697899999],
              [135.4575301440001, -34.731540622999944],
              [135.42953535200002, -34.7126604149999],
              [135.3837996750001, -34.69646575299993],
              [135.3715926440001, -34.68914153399993],
              [135.3598738940001, -34.68523528399993],
              [135.33220462300005, -34.68987395599993],
              [135.319672071, -34.68596770599993],
              [135.3422957690001, -34.65129973799992],
              [135.34009850400003, -34.63811614399992],
              [135.32349694100003, -34.62078215899993],
              [135.28785241000003, -34.592461846999925],
              [135.25147545700008, -34.56991952899995],
              [135.2304793630001, -34.56503671699994],
              [135.21216881600003, -34.56780364399992],
              [135.19402103000004, -34.57317473799992],
              [135.17335045700008, -34.576104424999926],
              [135.1572371750001, -34.58318450299993],
              [135.13892662900003, -34.596368096999925],
              [135.12134850400003, -34.60442473799992],
              [135.10808353000004, -34.595961195999905],
              [135.1098738940001, -34.57830169099992],
              [135.140961134, -34.540948174999926],
              [135.14909915500004, -34.52467213299991],
              [135.153168165, -34.502211195999905],
              [135.16382897200003, -34.48943450299993],
              [135.177093946, -34.47966887799993],
              [135.1899520190001, -34.46624114399992],
              [135.19361412900003, -34.45647551899992],
              [135.19605553500003, -34.4450822899999],
              [135.20045006600003, -34.43564218499995],
              [135.20980879, -34.431573174999926],
              [135.21851647200003, -34.43613046699994],
              [135.21753991000003, -34.44687265399995],
              [135.20980879, -34.469414971999925],
              [135.21371504, -34.49236419099992],
              [135.22478274800005, -34.50432708099993],
              [135.2421981130001, -34.50986093499995],
              [135.31397545700008, -34.52353280999995],
              [135.3271590500001, -34.52776458099993],
              [135.30933678500003, -34.53866952899995],
              [135.3027449880001, -34.550713799999926],
              [135.30632571700005, -34.56340911299992],
              [135.319672071, -34.576104424999926],
              [135.34913170700008, -34.5857072899999],
              [135.3554793630001, -34.59238046699994],
              [135.3408309250001, -34.603448174999926],
              [135.3515731130001, -34.61467864399992],
              [135.37086022200003, -34.62818775799991],
              [135.39128665500004, -34.63958098799992],
              [135.40577233200008, -34.644463799999926],
              [135.41553795700008, -34.64226653399993],
              [135.4360457690001, -34.63290780999995],
              [135.49789472700002, -34.62395598799992],
              [135.50359134200005, -34.61191171699994],
              [135.48113040500004, -34.60564544099992],
              [135.43702233200008, -34.59978606599992],
              [135.4379988940001, -34.588555596999925],
              [135.442230665, -34.56894296699994],
              [135.44320722700002, -34.55877044099992],
              [135.4384871750001, -34.54566822699991],
              [135.428070509, -34.54892343499995],
              [135.41871178500003, -34.55779387799993],
              [135.4160262380001, -34.56178150799991],
              [135.40788821700005, -34.57040780999995],
              [135.406586134, -34.57756926899992],
              [135.40495853000004, -34.580336195999905],
              [135.3955184250001, -34.576104424999926],
              [135.3891707690001, -34.56926848799992],
              [135.38502037900003, -34.55877044099992],
              [135.38257897200003, -34.54729583099993],
              [135.3818465500001, -34.53801848799992],
              [135.379730665, -34.533461195999905],
              [135.37663821700005, -34.52312590899993],
              [135.3769637380001, -34.51262786299992],
              [135.3916121750001, -34.504164320999905],
              [135.394867384, -34.49504973799992],
              [135.395843946, -34.48333098799992],
              [135.3955184250001, -34.4724260399999],
              [135.38843834700003, -34.451429945999905],
              [135.36605879, -34.42197030999995],
              [135.3613387380001, -34.40789153399993],
              [135.34644616000003, -34.27556731599992],
              [135.3286238940001, -34.22128671699994],
              [135.3012801440001, -34.17978280999995],
              [135.26514733200008, -34.17831796699994],
              [135.24537194100003, -34.15935637799993],
              [135.23747806100005, -34.14885833099993],
              [135.2309676440001, -34.13681405999995],
              [135.2490340500001, -34.1345354149999],
              [135.26547285200002, -34.12704843499995],
              [135.27312259200005, -34.115899346999925],
              [135.26514733200008, -34.10320403399993],
              [135.27116946700005, -34.0915666649999],
              [135.2705184250001, -34.081963799999926],
              [135.26742597700002, -34.07284921699994],
              [135.26514733200008, -34.06218840899993],
              [135.26514733200008, -34.017510674999926],
              [135.25953209700003, -33.997979424999926],
              [135.2461043630001, -33.98056405999995],
              [135.21794681100005, -33.95232512799993],
              [135.189789259, -33.89299895599993],
              [135.17701256600003, -33.883477471999925],
              [135.1543074880001, -33.87932708099993],
              [135.13851972700002, -33.869073174999926],
              [135.06430097700002, -33.79436614399992],
              [135.00505618600005, -33.74627044099992],
              [134.94556725400003, -33.711195570999905],
              [134.93620853000004, -33.70191822699991],
              [134.91285241000003, -33.68710702899995],
              [134.90552819100003, -33.68124765399995],
              [134.88819420700008, -33.65699635199991],
              [134.88209069100003, -33.650648695999905],
              [134.84986412900003, -33.63836028399993],
              [134.8408309250001, -33.63128020599993],
              [134.85425866000003, -33.62273528399993],
              [134.84734134200005, -33.60271575299993],
              [134.85303795700008, -33.58407968499995],
              [134.862640821, -33.56503671699994],
              [134.86793053500003, -33.54461028399993],
              [134.8652449880001, -33.4997697899999],
              [134.86101321700005, -33.47942473799992],
              [134.85425866000003, -33.458916924999926],
              [134.8242293630001, -33.39299895599993],
              [134.81397545700008, -33.35279713299991],
              [134.79900149800005, -33.33603280999995],
              [134.76490319100003, -33.30803801899992],
              [134.73072350400003, -33.273370049999926],
              [134.7197371750001, -33.26677825299993],
              [134.696136915, -33.25676848799992],
              [134.6860457690001, -33.25009530999995],
              [134.676605665, -33.23333098799992],
              [134.6923934250001, -33.22861093499995],
              [134.71607506600003, -33.228448174999926],
              [134.73072350400003, -33.22551848799992],
              [134.72868899800005, -33.21347421699994],
              [134.7192488940001, -33.19264088299991],
              [134.70622806100005, -33.172946872999944],
              [134.69320722700002, -33.16415780999995],
              [134.67017662900003, -33.16179778399993],
              [134.607758009, -33.143649997999944],
              [134.58155358200008, -33.14592864399992],
              [134.570648634, -33.160414320999905],
              [134.57439212300005, -33.176853122999944],
              [134.5908309250001, -33.184665622999944],
              [134.61866295700008, -33.18287525799991],
              [134.63038170700008, -33.185479424999926],
              [134.635101759, -33.19451262799993],
              [134.63843834700003, -33.20582447699991],
              [134.64600670700008, -33.21168385199991],
              [134.65503991000003, -33.216729424999926],
              [134.66236412900003, -33.22551848799992],
              [134.6523543630001, -33.22714609199994],
              [134.64405358200008, -33.231133721999925],
              [134.63656660200002, -33.23772551899992],
              [134.628265821, -33.24667734199994],
              [134.604828321, -33.2126604149999],
              [134.58936608200008, -33.20208098799992],
              [134.54175866000003, -33.19296640399995],
              [134.4775496750001, -33.157321872999944],
              [134.44605553500003, -33.15398528399993],
              [134.4228621750001, -33.16171640399995],
              [134.40211022200003, -33.17245859199994],
              [134.3779403000001, -33.17782968499995],
              [134.37842858200008, -33.17197030999995],
              [134.3696395190001, -33.160821221999925],
              [134.35914147200003, -33.15398528399993],
              [134.3540145190001, -33.16073984199994],
              [134.353851759, -33.17546965899993],
              [134.35222415500004, -33.188164971999925],
              [134.3462020190001, -33.19801197699991],
              [134.33350670700008, -33.205010674999926],
              [134.27881920700008, -33.16269296699994],
              [134.2714949880001, -33.14666106599992],
              [134.26970462300005, -33.125664971999925],
              [134.26514733200008, -33.10711028399993],
              [134.24195397200003, -33.05820077899995],
              [134.233734571, -33.04729583099993],
              [134.22144616000003, -33.04159921699994],
              [134.1997176440001, -33.03997161299992],
              [134.17066491000003, -33.04314544099992],
              [134.16032962300005, -33.040134372999944],
              [134.14861087300005, -33.02752044099992],
              [134.16480553500003, -33.01832447699991],
              [134.19849694100003, -33.0114885399999],
              [134.2099715500001, -33.00017669099992],
              [134.2119246750001, -32.981540622999944],
              [134.20435631600003, -32.96217213299991],
              [134.19068444100003, -32.94646575299993],
              [134.175140821, -32.938164971999925],
              [134.1640731130001, -32.93865325299993],
              [134.1567488940001, -32.94353606599992],
              [134.15186608200008, -32.949151299999926],
              [134.14861087300005, -32.951836846999925],
              [134.1386824880001, -32.949476820999905],
              [134.12061608200008, -32.938164971999925],
              [134.0825301440001, -32.93596770599993],
              [134.068695509, -32.92929452899995],
              [134.05982506600003, -32.910821221999925],
              [134.06763756600003, -32.90634530999995],
              [134.078949415, -32.89080169099992],
              [134.08708743600005, -32.88290780999995],
              [134.11500084700003, -32.86638762799993],
              [134.1240340500001, -32.859307549999926],
              [134.1328231130001, -32.83562590899993],
              [134.12452233200008, -32.806898695999905],
              [134.10824629, -32.77939218499995],
              [134.06959069100003, -32.733086846999925],
              [134.06657962300005, -32.72584400799991],
              [134.07406660200002, -32.713962497999944],
              [134.08708743600005, -32.71257903399993],
              [134.1171981130001, -32.71843840899993],
              [134.19320722700002, -32.721368096999925],
              [134.2168074880001, -32.72584400799991],
              [134.20460045700008, -32.74138762799993],
              [134.20036868600005, -32.74928150799991],
              [134.1962996750001, -32.760023695999905],
              [134.1953231130001, -32.7693010399999],
              [134.19548587300005, -32.7829729149999],
              [134.19695071700005, -32.795586846999925],
              [134.1997176440001, -32.80095794099992],
              [134.21404056100005, -32.80624765399995],
              [134.2207137380001, -32.80396900799991],
              [134.22632897200003, -32.77971770599993],
              [134.23226972700002, -32.76848723799992],
              [134.24480228000004, -32.752618096999925],
              [134.2646590500001, -32.73919036299992],
              [134.2714949880001, -32.73211028399993],
              [134.27613366000003, -32.722914320999905],
              [134.283539259, -32.702243747999944],
              [134.29761803500003, -32.67848072699991],
              [134.29664147200003, -32.66033294099992],
              [134.27328535200002, -32.58806731599992],
              [134.25407962300005, -32.55429452899995],
              [134.229828321, -32.523695570999905],
              [134.195648634, -32.4958635399999],
              [134.14828535200002, -32.456963799999926],
              [134.13111412900003, -32.45159270599993],
              [134.118011915, -32.45208098799992],
              [134.10865319100003, -32.45435963299991],
              [134.10027103000004, -32.459649346999925],
              [134.09050540500004, -32.4685197899999],
              [134.082855665, -32.4704729149999],
              [134.06324303500003, -32.461602471999925],
              [134.05298912900003, -32.45907968499995],
              [134.03199303500003, -32.46640390399995],
              [134.01775149800005, -32.48259856599992],
              [134.0063582690001, -32.49879322699991],
              [133.994476759, -32.506117445999905],
              [133.9692488940001, -32.50269947699991],
              [133.95232181100005, -32.49822356599992],
              [133.93669681100005, -32.50090911299992],
              [133.91578209700003, -32.519789320999905],
              [133.90984134200005, -32.52939218499995],
              [133.9067488940001, -32.53720468499995],
              [133.90121504, -32.54306405999995],
              [133.8877059250001, -32.54705169099992],
              [133.875336134, -32.54843515399995],
              [133.86443118600005, -32.546807549999926],
              [133.85670006600003, -32.54111093499995],
              [133.85368899800005, -32.52971770599993],
              [133.854828321, -32.52556731599992],
              [133.86117597700002, -32.51336028399993],
              [133.86394290500004, -32.5095354149999],
              [133.86508222700002, -32.505791924999926],
              [133.86158287900003, -32.494805596999925],
              [133.86052493600005, -32.48886484199994],
              [133.85914147200003, -32.45907968499995],
              [133.86052493600005, -32.45159270599993],
              [133.8691512380001, -32.43254973799992],
              [133.88306725400003, -32.41025155999995],
              [133.89625084700003, -32.39918385199991],
              [133.90211022200003, -32.413995049999926],
              [133.91089928500003, -32.42245859199994],
              [133.92986087300005, -32.42001718499995],
              [133.946625196, -32.40837981599992],
              [133.94996178500003, -32.38941822699991],
              [133.9399520190001, -32.375664971999925],
              [133.9087020190001, -32.34295012799993],
              [133.90211022200003, -32.324883721999925],
              [133.8950301440001, -32.31365325299993],
              [133.84742272200003, -32.273370049999926],
              [133.83228600400003, -32.249932549999926],
              [133.82642662900003, -32.24537525799991],
              [133.81226647200003, -32.247165622999944],
              [133.80241946700005, -32.254571221999925],
              [133.79509524800005, -32.262790622999944],
              [133.78882897200003, -32.26653411299992],
              [133.776703321, -32.26425546699994],
              [133.76929772200003, -32.2575822899999],
              [133.76539147200003, -32.247979424999926],
              [133.7636824880001, -32.220635674999926],
              [133.7607528000001, -32.21648528399993],
              [133.75456790500004, -32.21575286299992],
              [133.73503665500004, -32.207696221999925],
              [133.71257571700005, -32.201836846999925],
              [133.703461134, -32.19768645599993],
              [133.69361412900003, -32.19109465899993],
              [133.69206790500004, -32.189385674999926],
              [133.6943465500001, -32.185804945999905],
              [133.69605553500003, -32.174086195999905],
              [133.69263756600003, -32.16350676899992],
              [133.68433678500003, -32.160088799999926],
              [133.674164259, -32.15837981599992],
              [133.664886915, -32.15325286299992],
              [133.6621199880001, -32.14373137799993],
              [133.66944420700008, -32.1364885399999],
              [133.6787215500001, -32.129978122999944],
              [133.68238366000003, -32.12265390399995],
              [133.671234571, -32.110039971999925],
              [133.64918053500003, -32.10165780999995],
              [133.62378991000003, -32.09685637799993],
              [133.60328209700003, -32.09531015399995],
              [133.58619225400003, -32.10312265399995],
              [133.581390821, -32.121758721999925],
              [133.57984459700003, -32.1443010399999],
              [133.57252037900003, -32.16350676899992],
              [133.56137129, -32.172133070999905],
              [133.55201256600003, -32.17229583099993],
              [133.50928795700008, -32.15252044099992],
              [133.49634850400003, -32.14470794099992],
              [133.490570509, -32.139336846999925],
              [133.486664259, -32.11484140399995],
              [133.47681725400003, -32.11191171699994],
              [133.45036868600005, -32.12948984199994],
              [133.4394637380001, -32.1306291649999],
              [133.42798912900003, -32.13014088299991],
              [133.41871178500003, -32.133477471999925],
              [133.41480553500003, -32.146416924999926],
              [133.41822350400003, -32.156914971999925],
              [133.4267684250001, -32.16090260199991],
              [133.45036868600005, -32.16350676899992],
              [133.4726668630001, -32.17302825299993],
              [133.4907332690001, -32.18694426899992],
              [133.49431399800005, -32.19963958099993],
              [133.473480665, -32.20517343499995],
              [133.464203321, -32.20256926899992],
              [133.44849694100003, -32.192071221999925],
              [133.435883009, -32.19085051899992],
              [133.43132571700005, -32.194431247999944],
              [133.427093946, -32.20134856599992],
              [133.42139733200008, -32.20818450299993],
              [133.41179446700005, -32.21135833099993],
              [133.356781446, -32.20598723799992],
              [133.32601972700002, -32.199476820999905],
              [133.305511915, -32.19085051899992],
              [133.27947024800005, -32.21493905999995],
              [133.270843946, -32.21884530999995],
              [133.2622176440001, -32.21575286299992],
              [133.24488366000003, -32.201104424999926],
              [133.22429446700005, -32.195570570999905],
              [133.20232181100005, -32.18670012799993],
              [133.19263756600003, -32.184665622999944],
              [133.1806746750001, -32.18670012799993],
              [133.16187584700003, -32.19589609199994],
              [133.1547957690001, -32.19768645599993],
              [133.147797071, -32.19670989399992],
              [133.14568118600005, -32.19378020599993],
              [133.14283287900003, -32.187758070999905],
              [133.13428795700008, -32.17717864399992],
              [133.0556746750001, -32.10816822699991],
              [133.03394616000003, -32.09710051899992],
              [133.0107528000001, -32.09531015399995],
              [133.00342858200008, -32.09970468499995],
              [132.99626712300005, -32.10662200299993],
              [132.98780358200008, -32.11142343499995],
              [132.9765731130001, -32.10898202899995],
              [132.9731551440001, -32.100681247999944],
              [132.9712020190001, -32.08652109199994],
              [132.96607506600003, -32.07317473799992],
              [132.95297285200002, -32.06731536299992],
              [132.93425540500004, -32.06170012799993],
              [132.86882571700005, -32.01531340899993],
              [132.844086134, -31.99065520599993],
              [132.79802493600005, -31.95631275799991],
              [132.77621504, -31.95086028399993],
              [132.75269616000003, -31.949476820999905],
              [132.70484459700003, -31.95208098799992],
              [132.65894616000003, -31.94931405999995],
              [132.587250196, -31.934747002999927],
              [132.56364993600005, -31.93417734199994],
              [132.5161238940001, -31.941338799999926],
              [132.494476759, -31.947198174999926],
              [132.47584069100003, -31.955010674999926],
              [132.46273847700002, -31.96493905999995],
              [132.45289147200003, -31.983982028999947],
              [132.45769290500004, -31.99732838299991],
              [132.47022545700008, -32.00994231599992],
              [132.48316491000003, -32.026462497999944],
              [132.47185306100005, -32.03045012799993],
              [132.46257571700005, -32.02890390399995],
              [132.44166100400003, -32.01962655999995],
              [132.42009524800005, -32.01384856599992],
              [132.397797071, -32.012790622999944],
              [132.37484785200002, -32.01506926899992],
              [132.3261824880001, -32.033135674999926],
              [132.27808678500003, -32.03801848799992],
              [132.233734571, -32.0329729149999],
              [132.19459069100003, -32.017836195999905],
              [132.16163170700008, -31.991631768999923],
              [132.1074324880001, -31.932386976999908],
              [132.07789147200003, -31.907810153999947],
              [131.92310631600003, -31.823988539999903],
              [131.78296959700003, -31.72779713299991],
              [131.53589928500003, -31.60556405999995],
            ],
          ],
          [
            [
              [128.15886478000004, -15.090264580999929],
              [128.1626082690001, -15.097263278999947],
              [128.17139733200008, -15.101006768999923],
              [128.1806746750001, -15.103936455999929],
              [128.18677819100003, -15.107598565999922],
              [128.19450931100005, -15.126885674999926],
              [128.198578321, -15.15203215899993],
              [128.19678795700008, -15.17555103999996],
              [128.18677819100003, -15.190199476999908],
              [128.18189537900003, -15.181898695999905],
              [128.17408287900003, -15.174086195999905],
              [128.16382897200003, -15.16725025799991],
              [128.15202884200005, -15.162286065999922],
              [128.13396243600005, -15.14657968499995],
              [128.1259871750001, -15.134698174999926],
              [128.12427819100003, -15.119561455999929],
              [128.12378991000003, -15.04859791499996],
              [128.1313582690001, -15.037530205999929],
              [128.15202884200005, -15.05242278399993],
              [128.15772545700008, -15.087090752999927],
              [128.15886478000004, -15.090264580999929],
            ],
          ],
          [
            [
              [128.41618899800005, -14.956231377999927],
              [128.42953535200002, -14.965915622999944],
              [128.437836134, -14.988946221999925],
              [128.44125410200002, -15.016289971999925],
              [128.44068444100003, -15.03875090899993],
              [128.41277103000004, -15.018243096999925],
              [128.35824629, -14.95631275799991],
              [128.35132897200003, -14.932712497999944],
              [128.34839928500003, -14.882989190999922],
              [128.35377037900003, -14.86923593499995],
              [128.37175540500004, -14.87428150799991],
              [128.38493899800005, -14.891696872999944],
              [128.40935306100005, -14.944919528999947],
              [128.41618899800005, -14.956231377999927],
            ],
          ],
          [
            [
              [129.63249759200005, -14.84693775799991],
              [129.63493899800005, -14.859307549999926],
              [129.633636915, -14.870700778999947],
              [129.62663821700005, -14.875258070999905],
              [129.6118270190001, -14.867364190999922],
              [129.6064559250001, -14.857598565999922],
              [129.59009850400003, -14.836358330999929],
              [129.58521569100003, -14.826429945999905],
              [129.58130944100003, -14.808770440999922],
              [129.5830184250001, -14.803806247999944],
              [129.58904056100005, -14.806573174999926],
              [129.6064559250001, -14.817071221999925],
              [129.61646569100003, -14.824883721999925],
              [129.6259871750001, -14.835056247999944],
              [129.63249759200005, -14.84693775799991],
            ],
          ],
          [
            [
              [129.53345787900003, -14.79851653399993],
              [129.57781009200005, -14.860528252999927],
              [129.58708743600005, -14.883477471999925],
              [129.59099368600005, -14.909356377999927],
              [129.59148196700005, -14.963636976999908],
              [129.58912194100003, -14.952325127999927],
              [129.58480879, -14.942478122999944],
              [129.578949415, -14.93450286299992],
              [129.57154381600003, -14.928887627999927],
              [129.55779056100005, -14.907810153999947],
              [129.53484134200005, -14.858168226999908],
              [129.51978600400003, -14.836358330999929],
              [129.50464928500003, -14.802911065999922],
              [129.5019637380001, -14.79851653399993],
              [129.508148634, -14.785739841999941],
              [129.51547285200002, -14.78720468499995],
              [129.5239363940001, -14.79420338299991],
              [129.53345787900003, -14.79851653399993],
            ],
          ],
          [
            [
              [126.50098717500009, -13.873711846999925],
              [126.52320397200003, -13.87086353999996],
              [126.55396569100003, -13.875258070999905],
              [126.58570397200003, -13.884209893999923],
              [126.61085045700008, -13.89421965899993],
              [126.61085045700008, -13.901055596999925],
              [126.59864342500009, -13.90520598799992],
              [126.58562259200005, -13.90211353999996],
              [126.57129967500009, -13.896905205999929],
              [126.55567467500009, -13.89421965899993],
              [126.53956139400009, -13.897881768999923],
              [126.52588951900009, -13.903741143999923],
              [126.51514733200008, -13.904880466999941],
              [126.50782311300009, -13.89421965899993],
              [126.50562584700003, -13.889825127999927],
              [126.50098717500009, -13.873711846999925],
            ],
          ],
          [
            [
              [134.8852645190001, -12.05754973799992],
              [134.9072371750001, -12.05982838299991],
              [134.91822350400003, -12.063164971999925],
              [134.9262801440001, -12.06812916499996],
              [134.93287194100003, -12.087334893999923],
              [134.9248153000001, -12.10670338299991],
              [134.90796959700003, -12.117852471999925],
              [134.88835696700005, -12.11223723799992],
              [134.87810306100005, -12.100274346999925],
              [134.8671981130001, -12.076755466999941],
              [134.85425866000003, -12.037774346999925],
              [134.880218946, -12.054945570999905],
              [134.8852645190001, -12.05754973799992],
            ],
          ],
          [
            [
              [134.9652562990001, -12.026464800999918],
              [134.98448453600008, -12.03616086799991],
              [134.9859855410001, -12.041450338999937],
              [134.948728706, -12.054668868999954],
              [134.93521018800004, -12.050258563999932],
              [134.92078857500007, -12.04026293399994],
              [134.90936964700006, -12.035850012999958],
              [134.90847178500007, -12.022624855999936],
              [134.95624613500001, -12.016468623999913],
              [134.9652562990001, -12.026464800999918],
            ],
          ],
          [
            [
              [135.12196248100008, -11.929696364999927],
              [135.10748438400003, -11.942097811999929],
              [135.08485199300003, -11.946092824999937],
              [135.057696803, -11.953185170999916],
              [135.04607181100005, -11.94150155999995],
              [135.053888497, -11.919436661999953],
              [135.08446761100004, -11.920041030999926],
              [135.11085444600008, -11.924958444999959],
              [135.12196248100008, -11.929696364999927],
            ],
          ],
          [
            [
              [133.4087020190001, -11.592054945999905],
              [133.429047071, -11.586683851999908],
              [133.45427493600005, -11.58367278399993],
              [133.47543379, -11.58717213299991],
              [133.4843856130001, -11.601983330999929],
              [133.47437584700003, -11.61109791499996],
              [133.4516707690001, -11.616387627999927],
              [133.41179446700005, -11.619398695999905],
              [133.39616946700005, -11.623223565999922],
              [133.3984481130001, -11.63258228999996],
              [133.40650475400003, -11.64381275799991],
              [133.4087020190001, -11.653497002999927],
              [133.398773634, -11.662367445999905],
              [133.3857528000001, -11.666192315999922],
              [133.3720809250001, -11.66529713299991],
              [133.360199415, -11.660332940999922],
              [133.36703535200002, -11.653497002999927],
              [133.3584090500001, -11.628838799999926],
              [133.35954837300005, -11.617364190999922],
              [133.37086022200003, -11.612481377999927],
              [133.3808699880001, -11.609633070999905],
              [133.4087020190001, -11.592054945999905],
            ],
          ],
          [
            [
              [133.476898634, -11.45484791499996],
              [133.480804884, -11.470879815999922],
              [133.48894290500004, -11.48406340899993],
              [133.49952233200008, -11.494561455999929],
              [133.51099694100003, -11.50318775799991],
              [133.49333743600005, -11.508965752999927],
              [133.47584069100003, -11.507256768999923],
              [133.4589949880001, -11.50359465899993],
              [133.44288170700008, -11.50318775799991],
              [133.4296981130001, -11.50904713299991],
              [133.41529381600003, -11.519952080999929],
              [133.40259850400003, -11.532647393999923],
              [133.3950301440001, -11.54420338299991],
              [133.3955184250001, -11.536553643999923],
              [133.396820509, -11.531914971999925],
              [133.40186608200008, -11.52312590899993],
              [133.40300540500004, -11.512383721999925],
              [133.4023543630001, -11.502618096999925],
              [133.39958743600005, -11.494724216999941],
              [133.3950301440001, -11.489027601999908],
              [133.42400149800005, -11.485039971999925],
              [133.443695509, -11.47551848799992],
              [133.45972741000003, -11.464288018999923],
              [133.476898634, -11.45484791499996],
            ],
          ],
          [
            [
              [147.9985457690001, -43.230401299999926],
              [147.97803795700008, -43.22820403399993],
              [147.96404056100005, -43.2224260399999],
              [147.90455162900003, -43.18027109199994],
              [147.894867384, -43.169040622999944],
              [147.8896590500001, -43.15309010199991],
              [147.88795006600003, -43.13795338299991],
              [147.8828231130001, -43.131524346999925],
              [147.867523634, -43.141696872999944],
              [147.856781446, -43.156182549999926],
              [147.85377037900003, -43.17229583099993],
              [147.8574324880001, -43.18824635199991],
              [147.867523634, -43.203057549999926],
              [147.83757571700005, -43.20191822699991],
              [147.82146243600005, -43.21428801899992],
              [147.80974368600005, -43.23121510199991],
              [147.79249108200008, -43.244073174999926],
              [147.7719832690001, -43.21689218499995],
              [147.7002059250001, -43.162774346999925],
              [147.69556725400003, -43.13420989399992],
              [147.70850670700008, -43.13005950299993],
              [147.73389733200008, -43.118259372999944],
              [147.74789472700002, -43.105726820999905],
              [147.6645613940001, -43.0818010399999],
              [147.647797071, -43.07284921699994],
              [147.63819420700008, -43.06129322699991],
              [147.62720787900003, -43.0427385399999],
              [147.62061608200008, -43.02312590899993],
              [147.62427819100003, -43.00823333099993],
              [147.63355553500003, -43.00115325299993],
              [147.6660262380001, -42.98943450299993],
              [147.679047071, -42.98642343499995],
              [147.6826278000001, -42.98455169099992],
              [147.6860457690001, -42.97673919099992],
              [147.684906446, -42.97193775799991],
              [147.6826278000001, -42.96835702899995],
              [147.6826278000001, -42.963555596999925],
              [147.681000196, -42.955743096999925],
              [147.67701256600003, -42.94687265399995],
              [147.6782332690001, -42.9392229149999],
              [147.69255618600005, -42.936211846999925],
              [147.715179884, -42.937432549999926],
              [147.72584069100003, -42.940524997999944],
              [147.7304793630001, -42.94687265399995],
              [147.730804884, -42.976820570999905],
              [147.72722415500004, -42.98796965899993],
              [147.7168074880001, -43.00514088299991],
              [147.763031446, -43.03753020599993],
              [147.78581790500004, -43.0485979149999],
              [147.8164168630001, -43.05291106599992],
              [147.8232528000001, -43.05193450299993],
              [147.83383222700002, -43.047539971999925],
              [147.8403426440001, -43.04607512799993],
              [147.84099368600005, -43.04615650799991],
              [147.85865319100003, -43.045586846999925],
              [147.860687696, -43.04607512799993],
              [147.8754988940001, -43.040948174999926],
              [147.887054884, -43.03443775799991],
              [147.9091903000001, -43.01873137799993],
              [147.879242384, -43.01799895599993],
              [147.85906009200005, -43.00750090899993],
              [147.845062696, -42.98870208099993],
              [147.83350670700008, -42.963555596999925],
              [147.84351647200003, -42.96404387799993],
              [147.84978274800005, -42.96233489399992],
              [147.860687696, -42.95671965899993],
              [147.860687696, -42.95045338299991],
              [147.83383222700002, -42.94451262799993],
              [147.83155358200008, -42.931898695999905],
              [147.8388778000001, -42.91659921699994],
              [147.8403426440001, -42.90203215899993],
              [147.82691491000003, -42.89397551899992],
              [147.76514733200008, -42.90203215899993],
              [147.75700931100005, -42.89967213299991],
              [147.73991946700005, -42.891289971999925],
              [147.7304793630001, -42.8884416649999],
              [147.72038821700005, -42.88909270599993],
              [147.6894637380001, -42.89527760199991],
              [147.67652428500003, -42.88982512799993],
              [147.66920006600003, -42.88250090899993],
              [147.66358483200008, -42.87468840899993],
              [147.6552840500001, -42.86736419099992],
              [147.64771569100003, -42.86532968499995],
              [147.62818444100003, -42.86386484199994],
              [147.62126712300005, -42.8610979149999],
              [147.61793053500003, -42.85426197699991],
              [147.61695397200003, -42.84514739399992],
              [147.61451256600003, -42.83521900799991],
              [147.60694420700008, -42.82634856599992],
              [147.5957137380001, -42.82146575299993],
              [147.58562259200005, -42.82122161299992],
              [147.533539259, -42.836602471999925],
              [147.51531009200005, -42.84514739399992],
              [147.5039168630001, -42.85426197699991],
              [147.5029403000001, -42.88209400799991],
              [147.51929772200003, -42.91855234199994],
              [147.5590926440001, -42.977227471999925],
              [147.53980553500003, -43.00432708099993],
              [147.5293074880001, -43.01490650799991],
              [147.51140384200005, -43.02499765399995],
              [147.45435631600003, -43.03826262799993],
              [147.43620853000004, -43.04607512799993],
              [147.426117384, -43.03866952899995],
              [147.41334069100003, -43.025323174999926],
              [147.40349368600005, -43.010430596999925],
              [147.40211022200003, -42.99822356599992],
              [147.41667728000004, -42.98455169099992],
              [147.430511915, -42.99358489399992],
              [147.44288170700008, -43.00994231599992],
              [147.45329837300005, -43.01873137799993],
              [147.46900475400003, -43.01132577899995],
              [147.47966556100005, -42.994805596999925],
              [147.483734571, -42.978448174999926],
              [147.48031660200002, -42.970961195999905],
              [147.46648196700005, -42.963555596999925],
              [147.46607506600003, -42.94589609199994],
              [147.47730553500003, -42.908868096999925],
              [147.45826256600003, -42.91366952899995],
              [147.43824303500003, -42.92351653399993],
              [147.422211134, -42.92693450299993],
              [147.41578209700003, -42.91228606599992],
              [147.40967858200008, -42.88811614399992],
              [147.39437910200002, -42.87769947699991],
              [147.37427819100003, -42.87200286299992],
              [147.35368899800005, -42.8610979149999],
              [147.29908287900003, -42.78875090899993],
              [147.29420006600003, -42.77857838299991],
              [147.2837020190001, -42.77849700299993],
              [147.27295983200008, -42.78264739399992],
              [147.26002037900003, -42.790134372999944],
              [147.2680770190001, -42.79998137799993],
              [147.28052819100003, -42.80934010199991],
              [147.285980665, -42.81267669099992],
              [147.30437259200005, -42.829196872999944],
              [147.31959069100003, -42.84685637799993],
              [147.33659915500004, -42.88241952899995],
              [147.35914147200003, -42.910821221999925],
              [147.360199415, -42.92522551899992],
              [147.34001712300005, -42.95671965899993],
              [147.33082116000003, -42.97861093499995],
              [147.329437696, -42.997979424999926],
              [147.33318118600005, -43.04265715899993],
              [147.32374108200008, -43.04631926899992],
              [147.30298912900003, -43.03443775799991],
              [147.27173912900003, -43.01132577899995],
              [147.2544051440001, -43.027276299999926],
              [147.26295006600003, -43.04420338299991],
              [147.29224694100003, -43.06601327899995],
              [147.3012801440001, -43.083103122999944],
              [147.29371178500003, -43.092461846999925],
              [147.276703321, -43.100681247999944],
              [147.25757897200003, -43.114353122999944],
              [147.24773196700005, -43.129164320999905],
              [147.24488366000003, -43.14462655999995],
              [147.24683678500003, -43.16025155999995],
              [147.25660241000003, -43.197198174999926],
              [147.258148634, -43.21502044099992],
              [147.25757897200003, -43.25432708099993],
              [147.24927819100003, -43.26816171699994],
              [147.23023522200003, -43.28045012799993],
              [147.20866946700005, -43.28671640399995],
              [147.19263756600003, -43.28167083099993],
              [147.184906446, -43.27654387799993],
              [147.16382897200003, -43.27011484199994],
              [147.15447024800005, -43.26458098799992],
              [147.15414472700002, -43.25741952899995],
              [147.15886478000004, -43.24846770599993],
              [147.1587020190001, -43.24098072699991],
              [147.1445418630001, -43.23788827899995],
              [147.10303795700008, -43.23870208099993],
              [147.092133009, -43.23186614399992],
              [147.10320071700005, -43.21331145599993],
              [147.118011915, -43.19695403399993],
              [147.11898847700002, -43.18914153399993],
              [147.11280358200008, -43.178806247999944],
              [147.10661868600005, -43.15471770599993],
              [147.09782962300005, -43.174899997999944],
              [147.0791121750001, -43.19182708099993],
              [147.0605574880001, -43.20159270599993],
              [147.05201256600003, -43.19963958099993],
              [147.02849368600005, -43.18515390399995],
              [147.02409915500004, -43.17929452899995],
              [147.02409915500004, -43.13795338299991],
              [147.01783287900003, -43.112399997999944],
              [147.00318444100003, -43.10995859199994],
              [146.98609459700003, -43.11972421699994],
              [146.97291100400003, -43.131117445999905],
              [146.96558678500003, -43.14771900799991],
              [146.96265709700003, -43.17441171699994],
              [146.96648196700005, -43.1989885399999],
              [146.97999108200008, -43.20989348799992],
              [146.9912215500001, -43.21412525799991],
              [147.06226647200003, -43.2536760399999],
              [147.08130944100003, -43.26718515399995],
              [147.09595787900003, -43.28281015399995],
              [147.09978274800005, -43.29941171699994],
              [147.09441165500004, -43.306573174999926],
              [147.08383222700002, -43.31560637799993],
              [147.07252037900003, -43.32317473799992],
              [147.06511478000004, -43.32659270599993],
              [147.05298912900003, -43.326104424999926],
              [147.0478621750001, -43.32195403399993],
              [147.04476972700002, -43.316664320999905],
              [147.03834069100003, -43.31292083099993],
              [147.01937910200002, -43.31218840899993],
              [146.99675540500004, -43.31658294099992],
              [146.975922071, -43.32586028399993],
              [146.96265709700003, -43.34026458099993],
              [147.02133222700002, -43.33717213299991],
              [147.03834069100003, -43.34026458099993],
              [147.0551863940001, -43.34889088299991],
              [147.05534915500004, -43.35621510199991],
              [147.03150475400003, -43.37444426899992],
              [147.02133222700002, -43.38640715899993],
              [147.00505618600005, -43.41375090899993],
              [146.99732506600003, -43.42278411299992],
              [146.98121178500003, -43.429620049999926],
              [146.961273634, -43.43132903399993],
              [146.92164147200003, -43.429620049999926],
              [146.9419051440001, -43.44378020599993],
              [147.00114993600005, -43.45566171699994],
              [147.01783287900003, -43.47812265399995],
              [146.96241295700008, -43.4724260399999],
              [146.9433699880001, -43.47665780999995],
              [146.9360457690001, -43.495212497999944],
              [146.94068444100003, -43.50269947699991],
              [146.9497176440001, -43.50937265399995],
              [146.95533287900003, -43.517836195999905],
              [146.949554884, -43.53199635199991],
              [146.9399520190001, -43.53728606599992],
              [146.92603600400003, -43.53834400799991],
              [146.91179446700005, -43.53639088299991],
              [146.901703321, -43.53199635199991],
              [146.89405358200008, -43.55787525799991],
              [146.90609785200002, -43.56682708099993],
              [146.92603600400003, -43.570570570999905],
              [146.94214928500003, -43.581149997999944],
              [146.942230665, -43.598321221999925],
              [146.92701256600003, -43.61174895599993],
              [146.85572350400003, -43.63958098799992],
              [146.84652754, -43.641289971999925],
              [146.83155358200008, -43.63990650799991],
              [146.83025149800005, -43.63600025799991],
              [146.8320418630001, -43.62981536299992],
              [146.8261824880001, -43.62151458099993],
              [146.8032332690001, -43.610446872999944],
              [146.78150475400003, -43.608493747999944],
              [146.75961347700002, -43.61296965899993],
              [146.71070397200003, -43.62900155999995],
              [146.70045006600003, -43.62363046699994],
              [146.69288170700008, -43.60857512799993],
              [146.675140821, -43.58733489399992],
              [146.6084090500001, -43.558851820999905],
              [146.6001082690001, -43.5525041649999],
              [146.591156446, -43.53573984199994],
              [146.5820418630001, -43.49472421699994],
              [146.57211347700002, -43.47812265399995],
              [146.5546981130001, -43.469414971999925],
              [146.548187696, -43.48186614399992],
              [146.550140821, -43.504164320999905],
              [146.55844160200002, -43.5251604149999],
              [146.543793165, -43.52157968499995],
              [146.5380965500001, -43.51848723799992],
              [146.51351972700002, -43.53394947699991],
              [146.489105665, -43.53720468499995],
              [146.3779403000001, -43.52849700299993],
              [146.35865319100003, -43.52027760199991],
              [146.33936608200008, -43.50481536299992],
              [146.31861412900003, -43.52288176899992],
              [146.305511915, -43.53045012799993],
              [146.29167728000004, -43.53199635199991],
              [146.27898196700005, -43.525648695999905],
              [146.2744246750001, -43.51523202899995],
              [146.2714949880001, -43.503024997999944],
              [146.26384524800005, -43.49179452899995],
              [146.25367272200003, -43.48723723799992],
              [146.23812910200002, -43.48455169099992],
              [146.22185306100005, -43.485446872999944],
              [146.20915774800005, -43.49179452899995],
              [146.20386803500003, -43.50448984199994],
              [146.20337975400003, -43.51913827899995],
              [146.20069420700008, -43.53199635199991],
              [146.18921959700003, -43.53948333099993],
              [146.1801863940001, -43.52385833099993],
              [146.17164147200003, -43.51213958099993],
              [146.16138756600003, -43.50481536299992],
              [146.14991295700008, -43.5056291649999],
              [146.11540774800005, -43.51506926899992],
              [146.10670006600003, -43.51848723799992],
              [146.10564212300005, -43.52385833099993],
              [146.10808353000004, -43.541273695999905],
              [146.10670006600003, -43.54631926899992],
              [146.09937584700003, -43.54778411299992],
              [146.09253991000003, -43.5446916649999],
              [146.0859481130001, -43.5407854149999],
              [146.07935631600003, -43.53948333099993],
              [146.02418053500003, -43.5525041649999],
              [146.03077233200008, -43.482679945999905],
              [146.0239363940001, -43.451836846999925],
              [146.00025475400003, -43.41936614399992],
              [145.9438582690001, -43.38640715899993],
              [145.93482506600003, -43.37810637799993],
              [145.94320722700002, -43.36484140399995],
              [145.9633895190001, -43.3689104149999],
              [145.98609459700003, -43.3786760399999],
              [146.00367272200003, -43.381931247999944],
              [145.9980574880001, -43.37127044099992],
              [145.97575931100005, -43.34775155999995],
              [145.99390709700003, -43.34498463299991],
              [146.08562259200005, -43.35393645599993],
              [146.11304772200003, -43.364353122999944],
              [146.12916100400003, -43.38160572699991],
              [146.14226321700005, -43.400648695999905],
              [146.16138756600003, -43.415948174999926],
              [146.16586347700002, -43.404229424999926],
              [146.159515821, -43.38518645599993],
              [146.16138756600003, -43.37444426899992],
              [146.16724694100003, -43.37818775799991],
              [146.17139733200008, -43.37965260199991],
              [146.18238366000003, -43.381931247999944],
              [146.17546634200005, -43.36842213299991],
              [146.1801863940001, -43.36484140399995],
              [146.1894637380001, -43.36638762799993],
              [146.19548587300005, -43.368259372999944],
              [146.20671634200005, -43.37444426899992],
              [146.22217858200008, -43.39185963299991],
              [146.23023522200003, -43.395603122999944],
              [146.23780358200008, -43.38437265399995],
              [146.23796634200005, -43.35947030999995],
              [146.23389733200008, -43.33367278399993],
              [146.2295028000001, -43.31975676899992],
              [146.222992384, -43.31503671699994],
              [146.19548587300005, -43.29941171699994],
              [146.17945397200003, -43.283461195999905],
              [146.16822350400003, -43.277601820999905],
              [146.15796959700003, -43.28167083099993],
              [146.1298934250001, -43.32561614399992],
              [146.11101321700005, -43.33603280999995],
              [146.08562259200005, -43.31975676899992],
              [146.0839949880001, -43.31340911299992],
              [146.08090254, -43.291273695999905],
              [146.07935631600003, -43.28573984199994],
              [146.06763756600003, -43.281914971999925],
              [146.0590926440001, -43.285088799999926],
              [146.05347741000003, -43.2927385399999],
              [146.05152428500003, -43.30282968499995],
              [146.04363040500004, -43.3259416649999],
              [146.0254012380001, -43.324883721999925],
              [146.0048934250001, -43.31178150799991],
              [145.99000084700003, -43.29941171699994],
              [145.97535241000003, -43.28394947699991],
              [145.9672957690001, -43.268243096999925],
              [145.96404056100005, -43.25017669099992],
              [145.9633895190001, -43.22698333099993],
              [145.95883222700002, -43.222588799999926],
              [145.93816165500004, -43.21103280999995],
              [145.91716556100005, -43.19589609199994],
              [145.91325931100005, -43.2009416649999],
              [145.91431725400003, -43.22356536299992],
              [145.91773522200003, -43.238539320999905],
              [145.91570071700005, -43.246758721999925],
              [145.90406334700003, -43.250258070999905],
              [145.89600670700008, -43.25058359199994],
              [145.88697350400003, -43.251885674999926],
              [145.87867272200003, -43.25432708099993],
              [145.87330162900003, -43.25839609199994],
              [145.86931399800005, -43.27304452899995],
              [145.8813582690001, -43.27629973799992],
              [145.91773522200003, -43.27206796699994],
              [145.92855879, -43.27743905999995],
              [145.9257918630001, -43.28915780999995],
              [145.9140731130001, -43.300713799999926],
              [145.89722741000003, -43.30608489399992],
              [145.86003665500004, -43.304620049999926],
              [145.8442488940001, -43.3005510399999],
              [145.83179772200003, -43.29257577899995],
              [145.8056746750001, -43.244073174999926],
              [145.80420983200008, -43.23748137799993],
              [145.8056746750001, -43.21331145599993],
              [145.8027449880001, -43.208103122999944],
              [145.774750196, -43.18792083099993],
              [145.76392662900003, -43.18238697699991],
              [145.757172071, -43.17587655999995],
              [145.755218946, -43.16920338299991],
              [145.7544051440001, -43.160088799999926],
              [145.752289259, -43.15203215899993],
              [145.746918165, -43.14853280999995],
              [145.73462975400003, -43.14332447699991],
              [145.72803795700008, -43.13054778399993],
              [145.72681725400003, -43.11467864399992],
              [145.72999108200008, -43.10003020599993],
              [145.7212020190001, -43.103773695999905],
              [145.71045983200008, -43.10702890399995],
              [145.69890384200005, -43.108493747999944],
              [145.688324415, -43.10686614399992],
              [145.67408287900003, -43.09929778399993],
              [145.67066491000003, -43.09148528399993],
              [145.67465254, -43.069431247999944],
              [145.6787215500001, -43.06585051899992],
              [145.68572024800005, -43.05787525799991],
              [145.68824303500003, -43.04973723799992],
              [145.67839603000004, -43.04607512799993],
              [145.66667728000004, -43.044040622999944],
              [145.6547957690001, -43.038995049999926],
              [145.6337996750001, -43.02499765399995],
              [145.59750410200002, -42.97185637799993],
              [145.58228600400003, -42.963555596999925],
              [145.51978600400003, -42.96233489399992],
              [145.5102645190001, -42.95842864399992],
              [145.47242272200003, -42.915134372999944],
              [145.4497176440001, -42.88250090899993],
              [145.42994225400003, -42.84628671699994],
              [145.40967858200008, -42.795586846999925],
              [145.3989363940001, -42.778008721999925],
              [145.3935653000001, -42.77109140399995],
              [145.387054884, -42.76685963299991],
              [145.3715926440001, -42.76230234199994],
              [145.3662215500001, -42.75750090899993],
              [145.36475670700008, -42.751071872999944],
              [145.36744225400003, -42.746758721999925],
              [145.37126712300005, -42.74358489399992],
              [145.38428795700008, -42.72503020599993],
              [145.38648522200003, -42.71445077899995],
              [145.37647545700008, -42.709649346999925],
              [145.37061608200008, -42.70427825299993],
              [145.35271243600005, -42.65081145599993],
              [145.34913170700008, -42.6482072899999],
              [145.32886803500003, -42.64918385199991],
              [145.324554884, -42.6482072899999],
              [145.31706790500004, -42.63591887799993],
              [145.31202233200008, -42.62249114399992],
              [145.30591881600003, -42.611586195999905],
              [145.29420006600003, -42.6071916649999],
              [145.26547285200002, -42.60426197699991],
              [145.2641707690001, -42.59531015399995],
              [145.2978621750001, -42.558851820999905],
              [145.27173912900003, -42.538995049999926],
              [145.24724368600005, -42.50432708099993],
              [145.2343856130001, -42.46453215899993],
              [145.24341881600003, -42.42913176899992],
              [145.21843509200005, -42.37037525799991],
              [145.20826256600003, -42.33717213299991],
              [145.20240319100003, -42.30559661299992],
              [145.20240319100003, -42.24749114399992],
              [145.1997176440001, -42.235446872999944],
              [145.18962649800005, -42.212823174999926],
              [145.18873131600003, -42.19573333099993],
              [145.20199629, -42.203383070999905],
              [145.21762129, -42.2185197899999],
              [145.2304793630001, -42.235446872999944],
              [145.23585045700008, -42.24749114399992],
              [145.24105879, -42.26458098799992],
              [145.25416100400003, -42.27190520599993],
              [145.29053795700008, -42.27825286299992],
              [145.30396569100003, -42.28329843499995],
              [145.30974368600005, -42.28728606599992],
              [145.3183699880001, -42.29941171699994],
              [145.322601759, -42.306898695999905],
              [145.325531446, -42.31568775799991],
              [145.33082116000003, -42.32301197699991],
              [145.35857181100005, -42.33017343499995],
              [145.42448978000004, -42.37070077899995],
              [145.43482506600003, -42.37932708099993],
              [145.44027754, -42.391289971999925],
              [145.44312584700003, -42.43059661299992],
              [145.450531446, -42.46648528399993],
              [145.46314537900003, -42.50253671699994],
              [145.472015821, -42.512790622999944],
              [145.47925866000003, -42.509698174999926],
              [145.48226972700002, -42.48748137799993],
              [145.48226972700002, -42.41545989399992],
              [145.50945071700005, -42.42848072699991],
              [145.51978600400003, -42.42693450299993],
              [145.52711022200003, -42.39413827899995],
              [145.53500410200002, -42.377211195999905],
              [145.55494225400003, -42.350681247999944],
              [145.55811608200008, -42.3415666649999],
              [145.54672285200002, -42.34319426899992],
              [145.533539259, -42.34929778399993],
              [145.530609571, -42.35409921699994],
              [145.53239993600005, -42.35588958099993],
              [145.52906334700003, -42.35784270599993],
              [145.5239363940001, -42.35955169099992],
              [145.5205184250001, -42.36012135199991],
              [145.5166121750001, -42.35865650799991],
              [145.516937696, -42.35507577899995],
              [145.51823978000004, -42.350681247999944],
              [145.51710045700008, -42.34726327899995],
              [145.51351972700002, -42.340508721999925],
              [145.5141707690001, -42.333103122999944],
              [145.5127059250001, -42.32577890399995],
              [145.50342858200008, -42.31926848799992],
              [145.4926863940001, -42.31894296699994],
              [145.49000084700003, -42.326429945999905],
              [145.4887801440001, -42.33554452899995],
              [145.48226972700002, -42.339776299999926],
              [145.46314537900003, -42.327243747999944],
              [145.405609571, -42.27076588299991],
              [145.3896590500001, -42.249932549999926],
              [145.371918165, -42.24098072699991],
              [145.3662215500001, -42.237399997999944],
              [145.3593856130001, -42.20940520599993],
              [145.346039259, -42.18222421699994],
              [145.34131920700008, -42.1638322899999],
              [145.3457137380001, -42.14723072699991],
              [145.33326256600003, -42.14177825299993],
              [145.32374108200008, -42.14275481599992],
              [145.30420983200008, -42.15545012799993],
              [145.30396569100003, -42.15699635199991],
              [145.2978621750001, -42.16838958099993],
              [145.29411868600005, -42.170993747999944],
              [145.28150475400003, -42.17701588299991],
              [145.27686608200008, -42.18206145599993],
              [145.27662194100003, -42.19410572699991],
              [145.2822371750001, -42.205743096999925],
              [145.28337649800005, -42.215915622999944],
              [145.2700301440001, -42.223728122999944],
              [145.2622176440001, -42.22079843499995],
              [145.2290145190001, -42.19573333099993],
              [145.26636803500003, -42.12346770599993],
              [145.25147545700008, -42.04143645599993],
              [145.20655358200008, -41.9665666649999],
              [145.15455162900003, -41.9157854149999],
              [145.07349694100003, -41.85816822699991],
              [145.06609134200005, -41.85515715899993],
              [145.06039472700002, -41.849541924999926],
              [145.05591881600003, -41.82317473799992],
              [145.0498153000001, -41.81715260199991],
              [145.04078209700003, -41.81324635199991],
              [145.03052819100003, -41.80592213299991],
              [144.99203535200002, -41.746758721999925],
              [144.97250410200002, -41.732679945999905],
              [144.96705162900003, -41.72340260199991],
              [144.95972741000003, -41.71404387799993],
              [144.9482528000001, -41.70973072699991],
              [144.93433678500003, -41.71013762799993],
              [144.92603600400003, -41.70907968499995],
              [144.92017662900003, -41.7028947899999],
              [144.91431725400003, -41.68865325299993],
              [144.912445509, -41.67929452899995],
              [144.91431725400003, -41.65129973799992],
              [144.86646569100003, -41.54461028399993],
              [144.81080162900003, -41.4763322899999],
              [144.79444420700008, -41.44646575299993],
              [144.7871199880001, -41.44215260199991],
              [144.776703321, -41.43865325299993],
              [144.7656356130001, -41.43043385199991],
              [144.74984785200002, -41.41423919099992],
              [144.7539168630001, -41.41106536299992],
              [144.75513756600003, -41.40781015399995],
              [144.75538170700008, -41.40439218499995],
              [144.75660241000003, -41.40056731599992],
              [144.78191165500004, -41.39153411299992],
              [144.78109785200002, -41.365166924999926],
              [144.76734459700003, -41.33554452899995],
              [144.70036868600005, -41.242445570999905],
              [144.6816512380001, -41.22307708099993],
              [144.6894637380001, -41.199151299999926],
              [144.69125410200002, -41.16806405999995],
              [144.68474368600005, -41.13884856599992],
              [144.66724694100003, -41.12070077899995],
              [144.67530358200008, -41.080743096999925],
              [144.65650475400003, -41.048760674999926],
              [144.605804884, -40.99651458099993],
              [144.62037194100003, -40.993259372999944],
              [144.6313582690001, -40.98560963299991],
              [144.63819420700008, -40.97421640399995],
              [144.6406356130001, -40.95907968499995],
              [144.62289472700002, -40.938571872999944],
              [144.61736087300005, -40.929620049999926],
              [144.6240340500001, -40.92506275799991],
              [144.6406356130001, -40.92148202899995],
              [144.65642337300005, -40.89983489399992],
              [144.6665145190001, -40.89511484199994],
              [144.68474368600005, -40.89348723799992],
              [144.69695071700005, -40.88689544099992],
              [144.70378665500004, -40.871351820999905],
              [144.70826256600003, -40.838962497999944],
              [144.70875084700003, -40.810479424999926],
              [144.68921959700003, -40.70452239399992],
              [144.68921959700003, -40.6814104149999],
              [144.698578321, -40.66025155999995],
              [144.72136478000004, -40.64031340899993],
              [144.724945509, -40.65715911299992],
              [144.73511803500003, -40.67148202899995],
              [144.75660241000003, -40.69548919099992],
              [144.759125196, -40.7028947899999],
              [144.76295006600003, -40.7204729149999],
              [144.76628665500004, -40.726495049999926],
              [144.7724715500001, -40.727634372999944],
              [144.77955162900003, -40.72380950299993],
              [144.7871199880001, -40.7185197899999],
              [144.7939559250001, -40.71599700299993],
              [144.828461134, -40.721368096999925],
              [144.89478600400003, -40.744805596999925],
              [144.93116295700008, -40.75017669099992],
              [144.96794681100005, -40.74456145599993],
              [144.984711134, -40.744805596999925],
              [144.99968509200005, -40.753838799999926],
              [145.014008009, -40.766696872999944],
              [145.02686608200008, -40.77304452899995],
              [145.05836022200003, -40.784274997999944],
              [145.07536868600005, -40.80706145599993],
              [145.08464603000004, -40.80999114399992],
              [145.09522545700008, -40.81218840899993],
              [145.11882571700005, -40.821384372999944],
              [145.1372176440001, -40.8181291649999],
              [145.14625084700003, -40.807712497999944],
              [145.13355553500003, -40.791680596999925],
              [145.22673587300005, -40.79778411299992],
              [145.25025475400003, -40.791680596999925],
              [145.26148522200003, -40.77548593499995],
              [145.26392662900003, -40.75286223799992],
              [145.25945071700005, -40.73064544099992],
              [145.25025475400003, -40.71599700299993],
              [145.26921634200005, -40.71998463299991],
              [145.29517662900003, -40.73691171699994],
              [145.30787194100003, -40.75514088299991],
              [145.2778426440001, -40.766696872999944],
              [145.270355665, -40.77418385199991],
              [145.26685631600003, -40.78484465899993],
              [145.2700301440001, -40.79729583099993],
              [145.278656446, -40.80543385199991],
              [145.3183699880001, -40.82586028399993],
              [145.332367384, -40.83806731599992],
              [145.342133009, -40.8435197899999],
              [145.3559676440001, -40.84579843499995],
              [145.38843834700003, -40.84710051899992],
              [145.4052840500001, -40.850274346999925],
              [145.44304446700005, -40.86793385199991],
              [145.471039259, -40.86492278399993],
              [145.5239363940001, -40.84579843499995],
              [145.5337020190001, -40.885023695999905],
              [145.57211347700002, -40.90943775799991],
              [145.62094160200002, -40.922539971999925],
              [145.71159915500004, -40.93043385199991],
              [145.72925866000003, -40.93906015399995],
              [145.73609459700003, -40.95907968499995],
              [145.74390709700003, -40.97535572699991],
              [145.76156660200002, -40.99358489399992],
              [145.79127037900003, -41.01702239399992],
              [145.80982506600003, -41.02695077899995],
              [145.83033287900003, -41.03329843499995],
              [145.85279381600003, -41.03655364399992],
              [145.902679884, -41.03826262799993],
              [145.91553795700008, -41.041273695999905],
              [145.92115319100003, -41.04802825299993],
              [145.925140821, -41.05877044099992],
              [145.93474368600005, -41.061211846999925],
              [145.95533287900003, -41.05868905999995],
              [145.9785262380001, -41.06519947699991],
              [146.0166121750001, -41.087823174999926],
              [146.0415145190001, -41.09490325299993],
              [146.06226647200003, -41.105401299999926],
              [146.0688582690001, -41.10979583099993],
              [146.078949415, -41.11443450299993],
              [146.1196395190001, -41.12070077899995],
              [146.21436608200008, -41.155368747999944],
              [146.35377037900003, -41.167901299999926],
              [146.42367597700002, -41.16619231599992],
              [146.491547071, -41.15113697699991],
              [146.54639733200008, -41.132745049999926],
              [146.5551863940001, -41.13787200299993],
              [146.55844160200002, -41.15789153399993],
              [146.5625106130001, -41.168226820999905],
              [146.57211347700002, -41.17669036299992],
              [146.58562259200005, -41.18010833099993],
              [146.6001082690001, -41.17538827899995],
              [146.5825301440001, -41.16106536299992],
              [146.59107506600003, -41.147149346999925],
              [146.62680097700002, -41.126885674999926],
              [146.63599694100003, -41.11842213299991],
              [146.64861087300005, -41.09921640399995],
              [146.6547957690001, -41.092868747999944],
              [146.66675866000003, -41.08806731599992],
              [146.689789259, -41.08749765399995],
              [146.70264733200008, -41.08521900799991],
              [146.71469160200002, -41.07976653399993],
              [146.73064212300005, -41.06853606599992],
              [146.7441512380001, -41.065524997999944],
              [146.75367272200003, -41.066338799999926],
              [146.76539147200003, -41.06975676899992],
              [146.776703321, -41.07439544099992],
              [146.78500410200002, -41.07903411299992],
              [146.7959090500001, -41.091729424999926],
              [146.80827884200005, -41.11256275799991],
              [146.8125106130001, -41.13209400799991],
              [146.79867597700002, -41.140557549999926],
              [146.80811608200008, -41.15667083099993],
              [146.8247176440001, -41.16090260199991],
              [146.84351647200003, -41.162041924999926],
              [146.860199415, -41.16855234199994],
              [146.87289472700002, -41.15960051899992],
              [146.88168379, -41.15553150799991],
              [146.8911238940001, -41.15471770599993],
              [146.90512129, -41.15488046699994],
              [146.9165145190001, -41.15764739399992],
              [146.92644290500004, -41.162774346999925],
              [146.936859571, -41.16545989399992],
              [146.949554884, -41.16106536299992],
              [146.9340926440001, -41.151462497999944],
              [146.9223738940001, -41.14023202899995],
              [146.90788821700005, -41.13095468499995],
              [146.858734571, -41.12428150799991],
              [146.83806399800005, -41.11581796699994],
              [146.8242293630001, -41.09978606599992],
              [146.8193465500001, -41.07537200299993],
              [146.83773847700002, -41.039727471999925],
              [146.88152103000004, -41.02613697699991],
              [146.9326278000001, -41.018243096999925],
              [146.97291100400003, -40.999932549999926],
              [146.97917728000004, -40.994398695999905],
              [146.98658287900003, -40.98967864399992],
              [146.99488366000003, -40.98577239399992],
              [147.00904381600003, -40.981133721999925],
              [147.013031446, -40.97869231599992],
              [147.0175887380001, -40.97665780999995],
              [147.02409915500004, -40.97600676899992],
              [147.03003991000003, -40.97820403399993],
              [147.03305097700002, -40.986993096999925],
              [147.03834069100003, -40.98984140399995],
              [147.17107181100005, -41.006524346999925],
              [147.21021569100003, -40.98992278399993],
              [147.285980665, -40.941338799999926],
              [147.29566491000003, -40.95712655999995],
              [147.3427840500001, -40.94215260199991],
              [147.35368899800005, -40.952243747999944],
              [147.3545028000001, -40.96453215899993],
              [147.35816491000003, -40.971774997999944],
              [147.36548912900003, -40.97519296699994],
              [147.392914259, -40.97861093499995],
              [147.397797071, -40.985039971999925],
              [147.4004012380001, -40.9939104149999],
              [147.40837649800005, -41.00335051899992],
              [147.44483483200008, -41.00839609199994],
              [147.48462975400003, -40.98601653399993],
              [147.520355665, -40.95208098799992],
              [147.581390821, -40.87184010199991],
              [147.5864363940001, -40.85621510199991],
              [147.59742272200003, -40.84685637799993],
              [147.65056399800005, -40.82854583099993],
              [147.6689559250001, -40.82586028399993],
              [147.68376712300005, -40.8357072899999],
              [147.7002059250001, -40.85393645599993],
              [147.717133009, -40.86736419099992],
              [147.75367272200003, -40.85662200299993],
              [147.77605228000004, -40.86793385199991],
              [147.79867597700002, -40.88445403399993],
              [147.81983483200008, -40.89348723799992],
              [147.84945722700002, -40.88876718499995],
              [147.8857528000001, -40.87379322699991],
              [147.91618899800005, -40.85271575299993],
              [147.929047071, -40.82903411299992],
              [147.9321395190001, -40.82040780999995],
              [147.9462996750001, -40.79550546699994],
              [147.9516707690001, -40.76246510199991],
              [147.95826256600003, -40.75115325299993],
              [147.9692488940001, -40.74374765399995],
              [147.98422285200002, -40.73650481599992],
              [147.99097741000003, -40.741306247999944],
              [147.996918165, -40.74260833099993],
              [148.02027428500003, -40.74374765399995],
              [148.0293074880001, -40.746758721999925],
              [148.035980665, -40.752211195999905],
              [148.04273522200003, -40.76970794099992],
              [148.05193118600005, -40.769789320999905],
              [148.0693465500001, -40.76384856599992],
              [148.08090254, -40.76775481599992],
              [148.09400475400003, -40.77703215899993],
              [148.11402428500003, -40.79729583099993],
              [148.13111412900003, -40.82480234199994],
              [148.14380944100003, -40.83489348799992],
              [148.16553795700008, -40.838962497999944],
              [148.19898522200003, -40.837009372999944],
              [148.209320509, -40.84075286299992],
              [148.28736412900003, -40.92302825299993],
              [148.31462649800005, -40.961602471999925],
              [148.32569420700008, -40.982679945999905],
              [148.331390821, -41.002211195999905],
              [148.32349694100003, -41.010837497999944],
              [148.30884850400003, -41.01482512799993],
              [148.29265384200005, -41.024509372999944],
              [148.27906334700003, -41.035821221999925],
              [148.27230879, -41.04501718499995],
              [148.28402754, -41.04778411299992],
              [148.29444420700008, -41.05169036299992],
              [148.30225670700008, -41.05754973799992],
              [148.30640709700003, -41.065524997999944],
              [148.29053795700008, -41.10621510199991],
              [148.2890731130001, -41.113213799999926],
              [148.274750196, -41.124932549999926],
              [148.268890821, -41.15162525799991],
              [148.268890821, -41.181573174999926],
              [148.27230879, -41.20256926899992],
              [148.27751712300005, -41.21559010199991],
              [148.28199303500003, -41.22193775799991],
              [148.31625410200002, -41.25530364399992],
              [148.32154381600003, -41.26848723799992],
              [148.3164168630001, -41.28142669099992],
              [148.2719832690001, -41.30828215899993],
              [148.25416100400003, -41.3259416649999],
              [148.25798587300005, -41.34661223799992],
              [148.33326256600003, -41.29216887799993],
              [148.35417728000004, -41.29143645599993],
              [148.3310653000001, -41.322523695999905],
              [148.27947024800005, -41.45037200299993],
              [148.28003991000003, -41.46624114399992],
              [148.28386478000004, -41.48284270599993],
              [148.28589928500003, -41.50709400799991],
              [148.28402754, -41.51995208099993],
              [148.28109785200002, -41.52825286299992],
              [148.2812606130001, -41.53630950299993],
              [148.307953321, -41.57512786299992],
              [148.31267337300005, -41.586195570999905],
              [148.3149520190001, -41.606540622999944],
              [148.3110457690001, -41.62981536299992],
              [148.30201256600003, -41.65252044099992],
              [148.2890731130001, -41.67156340899993],
              [148.2861434250001, -41.689385674999926],
              [148.30640709700003, -41.750664971999925],
              [148.29468834700003, -41.76295338299991],
              [148.2744246750001, -41.779961846999925],
              [148.26099694100003, -41.80038827899995],
              [148.2685653000001, -41.82268645599993],
              [148.27361087300005, -41.83049895599993],
              [148.28394616000003, -41.8552385399999],
              [148.28589928500003, -41.86370208099993],
              [148.2890731130001, -41.87232838299991],
              [148.31267337300005, -41.89470794099992],
              [148.315765821, -41.90154387799993],
              [148.3164168630001, -41.90683359199994],
              [148.318695509, -41.911228122999944],
              [148.32691491000003, -41.9157854149999],
              [148.3134871750001, -41.94866301899992],
              [148.30030358200008, -42.00156015399995],
              [148.2993270190001, -42.0505510399999],
              [148.3637801440001, -42.11028411299992],
              [148.36394290500004, -42.11565520599993],
              [148.3564559250001, -42.11923593499995],
              [148.3466903000001, -42.12753671699994],
              [148.3193465500001, -42.15683359199994],
              [148.31592858200008, -42.170179945999905],
              [148.360687696, -42.18450286299992],
              [148.3642684250001, -42.20435963299991],
              [148.35417728000004, -42.24081796699994],
              [148.349945509, -42.24667734199994],
              [148.3310653000001, -42.26262786299992],
              [148.32691491000003, -42.26775481599992],
              [148.32178795700008, -42.278008721999925],
              [148.3110457690001, -42.27304452899995],
              [148.3012801440001, -42.26295338299991],
              [148.29900149800005, -42.25839609199994],
              [148.2646590500001, -42.250258070999905],
              [148.25798587300005, -42.24423593499995],
              [148.26050866000003, -42.23560963299991],
              [148.28101647200003, -42.225681247999944],
              [148.28589928500003, -42.21990325299993],
              [148.2890731130001, -42.21428801899992],
              [148.29615319100003, -42.206963799999926],
              [148.3032332690001, -42.197523695999905],
              [148.30640709700003, -42.185804945999905],
              [148.30250084700003, -42.17888762799993],
              [148.29322350400003, -42.1696916649999],
              [148.28199303500003, -42.16090260199991],
              [148.27230879, -42.15545012799993],
              [148.30062910200002, -42.14373137799993],
              [148.31397545700008, -42.134698174999926],
              [148.32007897200003, -42.119398695999905],
              [148.29273522200003, -42.11956145599993],
              [148.274750196, -42.113213799999926],
              [148.24431399800005, -42.085870049999926],
              [148.2265731130001, -42.075290622999944],
              [148.162445509, -42.05917734199994],
              [148.18970787900003, -42.041273695999905],
              [148.20582116000003, -42.034274997999944],
              [148.22046959700003, -42.031182549999926],
              [148.23194420700008, -42.023695570999905],
              [148.24170983200008, -42.00741952899995],
              [148.24244225400003, -41.990899346999925],
              [148.21119225400003, -41.97698333099993],
              [148.2050887380001, -41.9626604149999],
              [148.20240319100003, -41.94841887799993],
              [148.1962996750001, -41.94182708099993],
              [148.181000196, -41.94736093499995],
              [148.18287194100003, -41.95956796699994],
              [148.19654381600003, -41.97966887799993],
              [148.193695509, -42.00090911299992],
              [148.18628991000003, -42.00123463299991],
              [148.17554772200003, -41.99358489399992],
              [148.162445509, -41.99032968499995],
              [148.1469832690001, -41.99928150799991],
              [148.14673912900003, -42.01262786299992],
              [148.15251712300005, -42.02874114399992],
              [148.15503991000003, -42.045586846999925],
              [148.1494246750001, -42.04802825299993],
              [148.1386824880001, -42.051039320999905],
              [148.13013756600003, -42.05543385199991],
              [148.1313582690001, -42.06194426899992],
              [148.14136803500003, -42.07146575299993],
              [148.1469832690001, -42.07561614399992],
              [148.15503991000003, -42.07968515399995],
              [148.1679793630001, -42.0837541649999],
              [148.21705162900003, -42.09335702899995],
              [148.11939537900003, -42.09140390399995],
              [148.09294681100005, -42.10019296699994],
              [148.0825301440001, -42.11565520599993],
              [148.078949415, -42.13876718499995],
              [148.07984459700003, -42.185804945999905],
              [148.07447350400003, -42.19736093499995],
              [148.03891035200002, -42.223728122999944],
              [148.03467858200008, -42.23495859199994],
              [148.03443444100003, -42.24627044099992],
              [148.030609571, -42.254978122999944],
              [148.01490319100003, -42.25839609199994],
              [148.0180770190001, -42.264336846999925],
              [148.0122176440001, -42.27792734199994],
              [147.9834090500001, -42.319024346999925],
              [147.9638778000001, -42.339776299999926],
              [147.97584069100003, -42.33554452899995],
              [147.99382571700005, -42.31731536299992],
              [148.004730665, -42.312432549999926],
              [148.0224715500001, -42.31780364399992],
              [148.03093509200005, -42.332289320999905],
              [148.03044681100005, -42.34726327899995],
              [148.005218946, -42.36687590899993],
              [148.00318444100003, -42.39568450299993],
              [148.01156660200002, -42.44345468499995],
              [148.011078321, -42.48943450299993],
              [148.00603274800005, -42.51409270599993],
              [147.99488366000003, -42.52467213299991],
              [147.9809676440001, -42.52898528399993],
              [147.965668165, -42.54827239399992],
              [147.95329837300005, -42.552666924999926],
              [147.94288170700008, -42.54778411299992],
              [147.92790774800005, -42.52499765399995],
              [147.91529381600003, -42.51726653399993],
              [147.91578209700003, -42.52971770599993],
              [147.9106551440001, -42.53785572699991],
              [147.9013778000001, -42.54265715899993],
              [147.8886824880001, -42.54509856599992],
              [147.936859571, -42.590915622999944],
              [147.9433699880001, -42.610446872999944],
              [147.9423934250001, -42.628024997999944],
              [147.9433699880001, -42.6345354149999],
              [147.9462996750001, -42.640557549999926],
              [147.95085696700005, -42.64544036299992],
              [147.9550887380001, -42.64902109199994],
              [147.9570418630001, -42.65162525799991],
              [147.957367384, -42.67896900799991],
              [147.95533287900003, -42.691664320999905],
              [147.949554884, -42.70281340899993],
              [147.9531356130001, -42.71998463299991],
              [147.9399520190001, -42.73552825299993],
              [147.9204207690001, -42.74684010199991],
              [147.90544681100005, -42.75123463299991],
              [147.88933353000004, -42.76067473799992],
              [147.88111412900003, -42.781914971999925],
              [147.8808699880001, -42.804945570999905],
              [147.8886824880001, -42.81951262799993],
              [147.883636915, -42.82822030999995],
              [147.8798934250001, -42.83098723799992],
              [147.87525475400003, -42.8298479149999],
              [147.867523634, -42.82634856599992],
              [147.8505965500001, -42.851820570999905],
              [147.844574415, -42.86614348799992],
              [147.84717858200008, -42.88095468499995],
              [147.8584090500001, -42.8884416649999],
              [147.87777754, -42.892836195999905],
              [147.89909915500004, -42.893243096999925],
              [147.91529381600003, -42.8884416649999],
              [147.91529381600003, -42.88095468499995],
              [147.88160241000003, -42.87167734199994],
              [147.8930770190001, -42.85019296699994],
              [147.92074629, -42.83831145599993],
              [147.9365340500001, -42.857679945999905],
              [147.93930097700002, -42.87232838299991],
              [147.94646243600005, -42.87428150799991],
              [147.95630944100003, -42.87029387799993],
              [147.9672957690001, -42.86736419099992],
              [147.97535241000003, -42.868259372999944],
              [147.98072350400003, -42.87118905999995],
              [147.9834090500001, -42.87639739399992],
              [147.98422285200002, -42.884698174999926],
              [147.98698978000004, -42.893243096999925],
              [147.99976647200003, -42.900648695999905],
              [148.004730665, -42.908868096999925],
              [148.00277754, -42.91375090899993],
              [147.99732506600003, -42.919854424999926],
              [147.9921981130001, -42.92742278399993],
              [147.99105879, -42.936211846999925],
              [147.99439537900003, -42.93840911299992],
              [148.00123131600003, -42.94150155999995],
              [148.00806725400003, -42.94540780999995],
              [148.01156660200002, -42.95045338299991],
              [148.0097762380001, -42.96990325299993],
              [148.00066165500004, -42.97747161299992],
              [147.98755944100003, -42.98088958099993],
              [147.973968946, -42.98772551899992],
              [147.9638778000001, -43.01051197699991],
              [147.965179884, -43.0603166649999],
              [147.949554884, -43.07284921699994],
              [147.9731551440001, -43.09807708099993],
              [147.977386915, -43.10686614399992],
              [147.97836347700002, -43.11834075299993],
              [147.97632897200003, -43.125258070999905],
              [147.9638778000001, -43.141696872999944],
              [147.9863387380001, -43.14299895599993],
              [147.99952233200008, -43.14788176899992],
              [148.00342858200008, -43.158135674999926],
              [147.9985457690001, -43.17587655999995],
              [147.99341881600003, -43.1814104149999],
              [147.9863387380001, -43.185479424999926],
              [147.97999108200008, -43.19158294099992],
              [147.977386915, -43.203057549999926],
              [147.98845462300005, -43.211602471999925],
              [147.99577884200005, -43.21998463299991],
              [147.9985457690001, -43.230401299999926],
            ],
          ],
          [
            [
              [158.89340254, -54.510837497999944],
              [158.90772545700008, -54.49618905999995],
              [158.94849694100003, -54.48601653399993],
              [158.96241295700008, -54.46933359199994],
              [158.963226759, -54.48919036299992],
              [158.9555770190001, -54.55120208099993],
              [158.94841556100005, -54.57122161299992],
              [158.92562910200002, -54.61565520599993],
              [158.91553795700008, -54.65097421699994],
              [158.8925887380001, -54.68694426899992],
              [158.8872176440001, -54.70598723799992],
              [158.88624108200008, -54.73259856599992],
              [158.88054446700005, -54.74570077899995],
              [158.8657332690001, -54.749932549999926],
              [158.838226759, -54.75042083099993],
              [158.8320418630001, -54.7380510399999],
              [158.832367384, -54.73365650799991],
              [158.838226759, -54.72991301899992],
              [158.832367384, -54.71168385199991],
              [158.83513431100005, -54.68987395599993],
              [158.8457137380001, -54.65488046699994],
              [158.8481551440001, -54.64959075299993],
              [158.8564559250001, -54.639336846999925],
              [158.8593856130001, -54.63372161299992],
              [158.85824629, -54.630791924999926],
              [158.85531660200002, -54.62558359199994],
              [158.85279381600003, -54.61923593499995],
              [158.8525496750001, -54.613213799999926],
              [158.8564559250001, -54.603773695999905],
              [158.86060631600003, -54.59929778399993],
              [158.8657332690001, -54.59490325299993],
              [158.87232506600003, -54.585870049999926],
              [158.8813582690001, -54.566338799999926],
              [158.89340254, -54.510837497999944],
            ],
          ],
          [
            [
              [147.33659915500004, -43.34026458099993],
              [147.33757571700005, -43.34449635199991],
              [147.36052493600005, -43.368259372999944],
              [147.36402428500003, -43.37932708099993],
              [147.36548912900003, -43.38787200299993],
              [147.36451256600003, -43.396742445999905],
              [147.36052493600005, -43.40862395599993],
              [147.3554793630001, -43.417901299999926],
              [147.344574415, -43.42986419099992],
              [147.34001712300005, -43.43645598799992],
              [147.3349715500001, -43.44768645599993],
              [147.32634524800005, -43.47812265399995],
              [147.31592858200008, -43.500664971999925],
              [147.30388431100005, -43.508884372999944],
              [147.28736412900003, -43.504978122999944],
              [147.26433353000004, -43.49179452899995],
              [147.25757897200003, -43.48967864399992],
              [147.250824415, -43.48992278399993],
              [147.24439537900003, -43.489353122999944],
              [147.23755944100003, -43.484307549999926],
              [147.2368270190001, -43.47975025799991],
              [147.23780358200008, -43.47340260199991],
              [147.24040774800005, -43.46892669099992],
              [147.24382571700005, -43.46998463299991],
              [147.23617597700002, -43.45077890399995],
              [147.22999108200008, -43.44426848799992],
              [147.21648196700005, -43.44264088299991],
              [147.22331790500004, -43.43906015399995],
              [147.23194420700008, -43.43238697699991],
              [147.23755944100003, -43.429620049999926],
              [147.21558678500003, -43.41521575299993],
              [147.20460045700008, -43.425713799999926],
              [147.19605553500003, -43.46998463299991],
              [147.184906446, -43.48984140399995],
              [147.16773522200003, -43.50164153399993],
              [147.14918053500003, -43.50115325299993],
              [147.13396243600005, -43.484307549999926],
              [147.125336134, -43.464776299999926],
              [147.10962975400003, -43.45077890399995],
              [147.094086134, -43.43987395599993],
              [147.08619225400003, -43.429620049999926],
              [147.090668165, -43.41090260199991],
              [147.10922285200002, -43.41497161299992],
              [147.16163170700008, -43.45403411299992],
              [147.172211134, -43.458916924999926],
              [147.17920983200008, -43.45403411299992],
              [147.18238366000003, -43.43645598799992],
              [147.18043053500003, -43.39723072699991],
              [147.17595462300005, -43.37932708099993],
              [147.16814212300005, -43.368259372999944],
              [147.17351321700005, -43.360039971999925],
              [147.181000196, -43.35426197699991],
              [147.19011478000004, -43.35271575299993],
              [147.200043165, -43.35702890399995],
              [147.215668165, -43.37753671699994],
              [147.2255965500001, -43.38551197699991],
              [147.23357181100005, -43.37151458099993],
              [147.2392684250001, -43.36484140399995],
              [147.241547071, -43.35621510199991],
              [147.23389733200008, -43.344008070999905],
              [147.2285262380001, -43.33220794099992],
              [147.2348738940001, -43.32301197699991],
              [147.2544051440001, -43.30950286299992],
              [147.285980665, -43.27556731599992],
              [147.30445397200003, -43.26181405999995],
              [147.31275475400003, -43.268243096999925],
              [147.33659915500004, -43.34026458099993],
            ],
          ],
          [
            [
              [147.40211022200003, -43.131117445999905],
              [147.40259850400003, -43.14470794099992],
              [147.404633009, -43.155368747999944],
              [147.40886478000004, -43.16497161299992],
              [147.41578209700003, -43.17587655999995],
              [147.4199324880001, -43.18840911299992],
              [147.43116295700008, -43.213962497999944],
              [147.4375106130001, -43.238946221999925],
              [147.42603600400003, -43.250258070999905],
              [147.40121504, -43.24504973799992],
              [147.39185631600003, -43.244073174999926],
              [147.379242384, -43.2478166649999],
              [147.3691512380001, -43.25465260199991],
              [147.36085045700008, -43.25790780999995],
              [147.35368899800005, -43.250258070999905],
              [147.34734134200005, -43.22795989399992],
              [147.35726972700002, -43.21795012799993],
              [147.3740340500001, -43.2107072899999],
              [147.38786868600005, -43.19622161299992],
              [147.36890709700003, -43.18287525799991],
              [147.31812584700003, -43.17717864399992],
              [147.29566491000003, -43.16562265399995],
              [147.29175866000003, -43.153008721999925],
              [147.3046981130001, -43.14568450299993],
              [147.35417728000004, -43.13941822699991],
              [147.348968946, -43.133884372999944],
              [147.3349715500001, -43.126885674999926],
              [147.32634524800005, -43.12053801899992],
              [147.33033287900003, -43.10100676899992],
              [147.344574415, -43.08220794099992],
              [147.36003665500004, -43.074883721999925],
              [147.37281334700003, -43.10125090899993],
              [147.39665774800005, -43.117120049999926],
              [147.40211022200003, -43.131117445999905],
            ],
          ],
          [
            [
              [148.14185631600003, -42.603773695999905],
              [148.14372806100005, -42.62029387799993],
              [148.149261915, -42.632745049999926],
              [148.15984134200005, -42.64185963299991],
              [148.17603600400003, -42.6482072899999],
              [148.14958743600005, -42.66643645599993],
              [148.10466556100005, -42.664727471999925],
              [148.07300866000003, -42.66676197699991],
              [148.08668053500003, -42.69654713299991],
              [148.11011803500003, -42.71648528399993],
              [148.104828321, -42.71949635199991],
              [148.0434676440001, -42.729180596999925],
              [148.02906334700003, -42.73650481599992],
              [148.01832116000003, -42.75123463299991],
              [148.01156660200002, -42.75123463299991],
              [148.01156660200002, -42.730726820999905],
              [148.024261915, -42.71933359199994],
              [148.03296959700003, -42.70387135199991],
              [148.04517662900003, -42.66871510199991],
              [148.02271569100003, -42.666273695999905],
              [148.01286868600005, -42.65162525799991],
              [148.0136824880001, -42.63176848799992],
              [148.02458743600005, -42.61345794099992],
              [148.0395613940001, -42.60320403399993],
              [148.06755618600005, -42.59303150799991],
              [148.07984459700003, -42.57927825299993],
              [148.09636478000004, -42.58440520599993],
              [148.11695397200003, -42.5857072899999],
              [148.13445071700005, -42.590101820999905],
              [148.14185631600003, -42.603773695999905],
            ],
          ],
          [
            [
              [148.29900149800005, -42.30559661299992],
              [148.3169051440001, -42.314385674999926],
              [148.3247176440001, -42.32366301899992],
              [148.3300887380001, -42.33603280999995],
              [148.34058678500003, -42.35409921699994],
              [148.3344832690001, -42.35662200299993],
              [148.32976321700005, -42.35711028399993],
              [148.32007897200003, -42.35409921699994],
              [148.3046981130001, -42.34628671699994],
              [148.29281660200002, -42.337009372999944],
              [148.28003991000003, -42.32935963299991],
              [148.24919681100005, -42.32390715899993],
              [148.2426863940001, -42.3181291649999],
              [148.23072350400003, -42.29941171699994],
              [148.24634850400003, -42.29509856599992],
              [148.2656356130001, -42.29648202899995],
              [148.29900149800005, -42.30559661299992],
            ],
          ],
          [
            [
              [145.0136824880001, -40.668226820999905],
              [145.03101647200003, -40.672539971999925],
              [145.04615319100003, -40.68303801899992],
              [145.05811608200008, -40.69646575299993],
              [145.06519616000003, -40.70916106599992],
              [145.03728274800005, -40.70916106599992],
              [145.01587975400003, -40.69426848799992],
              [144.982758009, -40.69931405999995],
              [144.92741946700005, -40.72340260199991],
              [144.92212975400003, -40.723321221999925],
              [144.914886915, -40.72185637799993],
              [144.9062606130001, -40.72185637799993],
              [144.8969832690001, -40.726495049999926],
              [144.89031009200005, -40.72812265399995],
              [144.88298587300005, -40.724867445999905],
              [144.87647545700008, -40.71998463299991],
              [144.87281334700003, -40.71599700299993],
              [144.87175540500004, -40.67131926899992],
              [144.8696395190001, -40.66480885199991],
              [144.91749108200008, -40.62322356599992],
              [144.930511915, -40.61532968499995],
              [144.93718509200005, -40.62509530999995],
              [144.94499759200005, -40.63990650799991],
              [144.96216881600003, -40.64771900799991],
              [144.97722415500004, -40.65097421699994],
              [144.9965926440001, -40.66497161299992],
              [145.0136824880001, -40.668226820999905],
            ],
          ],
          [
            [
              [148.11402428500003, -40.52418385199991],
              [148.13111412900003, -40.51376718499995],
              [148.17115319100003, -40.50709400799991],
              [148.1860457690001, -40.50009530999995],
              [148.25114993600005, -40.48943450299993],
              [148.24577884200005, -40.498304945999905],
              [148.2353621750001, -40.510430596999925],
              [148.23072350400003, -40.5173479149999],
              [148.22877037900003, -40.5290666649999],
              [148.2295028000001, -40.540134372999944],
              [148.22681725400003, -40.54827239399992],
              [148.21363366000003, -40.55152760199991],
              [148.2094832690001, -40.56218840899993],
              [148.20533287900003, -40.58277760199991],
              [148.19418379, -40.59628671699994],
              [148.16871178500003, -40.58562590899993],
              [148.16187584700003, -40.570570570999905],
              [148.145355665, -40.56609465899993],
              [148.12859134200005, -40.56536223799992],
              [148.12086022200003, -40.56170012799993],
              [148.11890709700003, -40.55803801899992],
              [148.10954837300005, -40.54420338299991],
              [148.10718834700003, -40.53785572699991],
              [148.10572350400003, -40.53045012799993],
              [148.10499108200008, -40.53004322699991],
              [148.10710696700005, -40.53004322699991],
              [148.11402428500003, -40.52418385199991],
            ],
          ],
          [
            [
              [144.79086347700002, -40.42115650799991],
              [144.79216556100005, -40.42791106599992],
              [144.79053795700008, -40.50212981599992],
              [144.7871199880001, -40.50994231599992],
              [144.7656356130001, -40.524509372999944],
              [144.7646590500001, -40.58456796699994],
              [144.74244225400003, -40.592461846999925],
              [144.7329207690001, -40.57740650799991],
              [144.7295028000001, -40.56991952899995],
              [144.72877037900003, -40.513604424999926],
              [144.72535241000003, -40.505791924999926],
              [144.71078535200002, -40.49578215899993],
              [144.70826256600003, -40.48943450299993],
              [144.71599368600005, -40.47665780999995],
              [144.73015384200005, -40.475274346999925],
              [144.746918165, -40.47616952899995],
              [144.76295006600003, -40.46949635199991],
              [144.76726321700005, -40.460056247999944],
              [144.77711022200003, -40.41090260199991],
              [144.77914472700002, -40.405368747999944],
              [144.7837020190001, -40.408868096999925],
              [144.79086347700002, -40.42115650799991],
            ],
          ],
          [
            [
              [144.900726759, -40.46949635199991],
              [144.87452233200008, -40.46754322699991],
              [144.85906009200005, -40.45631275799991],
              [144.84693444100003, -40.44150155999995],
              [144.83122806100005, -40.427992445999905],
              [144.83952884200005, -40.425713799999926],
              [144.85906009200005, -40.423760674999926],
              [144.86646569100003, -40.42115650799991],
              [144.87370853000004, -40.41521575299993],
              [144.88160241000003, -40.40593840899993],
              [144.88445071700005, -40.39763762799993],
              [144.87614993600005, -40.39381275799991],
              [144.873383009, -40.391696872999944],
              [144.879242384, -40.38681405999995],
              [144.88851972700002, -40.38176848799992],
              [144.8969832690001, -40.379571221999925],
              [144.920258009, -40.3806291649999],
              [144.9306746750001, -40.382745049999926],
              [144.94109134200005, -40.38640715899993],
              [144.96045983200008, -40.39788176899992],
              [144.9609481130001, -40.40748463299991],
              [144.953461134, -40.41952890399995],
              [144.94849694100003, -40.43792083099993],
              [144.95264733200008, -40.44890715899993],
              [144.9502059250001, -40.453383070999905],
              [144.92701256600003, -40.45598723799992],
              [144.91724694100003, -40.45826588299991],
              [144.908539259, -40.4626604149999],
              [144.900726759, -40.46949635199991],
            ],
          ],
          [
            [
              [148.42994225400003, -40.373304945999905],
              [148.46802819100003, -40.41529713299991],
              [148.48454837300005, -40.427992445999905],
              [148.47681725400003, -40.43808359199994],
              [148.46892337300005, -40.44068775799991],
              [148.461761915, -40.43718840899993],
              [148.45655358200008, -40.427992445999905],
              [148.45264733200008, -40.432712497999944],
              [148.44418379, -40.44850025799991],
              [148.42530358200008, -40.455010674999926],
              [148.42253665500004, -40.45525481599992],
              [148.410980665, -40.46843840899993],
              [148.40788821700005, -40.47665780999995],
              [148.40886478000004, -40.48943450299993],
              [148.38933353000004, -40.48186614399992],
              [148.37094160200002, -40.484307549999926],
              [148.3545028000001, -40.49293385199991],
              [148.34058678500003, -40.5036760399999],
              [148.34058678500003, -40.46949635199991],
              [148.32732181100005, -40.43596770599993],
              [148.29566491000003, -40.434665622999944],
              [148.23072350400003, -40.46209075299993],
              [148.22413170700008, -40.45159270599993],
              [148.21697024800005, -40.44548919099992],
              [148.2080184250001, -40.44255950299993],
              [148.19654381600003, -40.441664320999905],
              [148.189789259, -40.44353606599992],
              [148.18091881600003, -40.4528947899999],
              [148.17603600400003, -40.45525481599992],
              [148.168793165, -40.45452239399992],
              [148.15739993600005, -40.44963958099993],
              [148.15162194100003, -40.44850025799991],
              [148.0820418630001, -40.45427825299993],
              [148.05884850400003, -40.44850025799991],
              [148.05030358200008, -40.44304778399993],
              [148.03980553500003, -40.43181731599992],
              [148.03272545700008, -40.427992445999905],
              [148.01189212300005, -40.42848072699991],
              [148.0024520190001, -40.42652760199991],
              [147.9985457690001, -40.4177385399999],
              [148.00220787900003, -40.39202239399992],
              [148.013031446, -40.37810637799993],
              [148.07406660200002, -40.35116952899995],
              [148.09253991000003, -40.34693775799991],
              [148.13819420700008, -40.34539153399993],
              [148.16041100400003, -40.34783294099992],
              [148.17156009200005, -40.35116952899995],
              [148.19410241000003, -40.36565520599993],
              [148.2031356130001, -40.358493747999944],
              [148.21021569100003, -40.33863697699991],
              [148.2529403000001, -40.33603280999995],
              [148.28003991000003, -40.33123137799993],
              [148.29216556100005, -40.32122161299992],
              [148.2973738940001, -40.31951262799993],
              [148.31959069100003, -40.30738697699991],
              [148.32349694100003, -40.3044572899999],
              [148.3379012380001, -40.305759372999944],
              [148.34595787900003, -40.30950286299992],
              [148.391449415, -40.35605234199994],
              [148.40015709700003, -40.36174895599993],
              [148.42066491000003, -40.36834075299993],
              [148.42994225400003, -40.373304945999905],
            ],
          ],
          [
            [
              [148.01490319100003, -40.15056731599992],
              [148.01783287900003, -40.137383721999925],
              [148.01246178500003, -40.119398695999905],
              [148.0024520190001, -40.10247161299992],
              [147.99105879, -40.09221770599993],
              [147.97193444100003, -40.08912525799991],
              [147.9589949880001, -40.09148528399993],
              [147.9516707690001, -40.08635833099993],
              [147.949554884, -40.06145598799992],
              [147.9414168630001, -40.04509856599992],
              [147.9223738940001, -40.03573984199994],
              [147.900726759, -40.03167083099993],
              [147.88502037900003, -40.03085702899995],
              [147.88591556100005, -40.024102471999925],
              [147.90447024800005, -39.99032968499995],
              [147.9091903000001, -39.97616952899995],
              [147.90601647200003, -39.962009372999944],
              [147.89185631600003, -39.93206145599993],
              [147.8886824880001, -39.91757577899995],
              [147.8808699880001, -39.89495208099993],
              [147.86247806100005, -39.89592864399992],
              [147.8266707690001, -39.91415780999995],
              [147.80746504, -39.91073984199994],
              [147.75766035200002, -39.87932708099993],
              [147.77369225400003, -39.869073174999926],
              [147.7959090500001, -39.84726327899995],
              [147.8129988940001, -39.83831145599993],
              [147.85368899800005, -39.82773202899995],
              [147.863617384, -39.81698984199994],
              [147.8540145190001, -39.79745859199994],
              [147.86280358200008, -39.79420338299991],
              [147.881195509, -39.783135674999926],
              [147.868500196, -39.76913827899995],
              [147.86304772200003, -39.76116301899992],
              [147.860687696, -39.75269947699991],
              [147.86508222700002, -39.742852471999925],
              [147.875336134, -39.74570077899995],
              [147.8867293630001, -39.75286223799992],
              [147.894867384, -39.75644296699994],
              [147.91089928500003, -39.74928150799991],
              [147.95329837300005, -39.71168385199991],
              [148.14185631600003, -39.89934661299992],
              [148.14812259200005, -39.91073984199994],
              [148.1670028000001, -39.93564218499995],
              [148.2109481130001, -39.95134856599992],
              [148.29900149800005, -39.96184661299992],
              [148.29224694100003, -39.9841447899999],
              [148.29216556100005, -40.06145598799992],
              [148.2832137380001, -40.08147551899992],
              [148.24000084700003, -40.10702890399995],
              [148.22388756600003, -40.12639739399992],
              [148.24537194100003, -40.13290780999995],
              [148.26742597700002, -40.12737395599993],
              [148.28663170700008, -40.11451588299991],
              [148.29900149800005, -40.09905364399992],
              [148.30884850400003, -40.113539320999905],
              [148.31983483200008, -40.135837497999944],
              [148.33375084700003, -40.17473723799992],
              [148.3320418630001, -40.19215260199991],
              [148.321136915, -40.19019947699991],
              [148.29216556100005, -40.167901299999926],
              [148.28630618600005, -40.189711195999905],
              [148.30347741000003, -40.201104424999926],
              [148.323578321, -40.20956796699994],
              [148.32691491000003, -40.222588799999926],
              [148.30738366000003, -40.23772551899992],
              [148.288422071, -40.231133721999925],
              [148.26905358200008, -40.21689218499995],
              [148.24773196700005, -40.208916924999926],
              [148.225922071, -40.20452239399992],
              [148.21412194100003, -40.204196872999944],
              [148.20281009200005, -40.208916924999926],
              [148.1977645190001, -40.218682549999926],
              [148.19255618600005, -40.24504973799992],
              [148.1860457690001, -40.25058359199994],
              [148.16749108200008, -40.25546640399995],
              [148.14665774800005, -40.26490650799991],
              [148.12427819100003, -40.270603122999944],
              [148.0747176440001, -40.25514088299991],
              [148.04997806100005, -40.24098072699991],
              [148.039886915, -40.22283294099992],
              [148.05884850400003, -40.20208098799992],
              [148.02881920700008, -40.178806247999944],
              [148.01449629, -40.16423919099992],
              [148.01490319100003, -40.15056731599992],
            ],
          ],
          [
            [
              [144.1054793630001, -39.89299895599993],
              [144.11296634200005, -39.902601820999905],
              [144.12289472700002, -39.9060197899999],
              [144.13298587300005, -39.90829843499995],
              [144.14039147200003, -39.91415780999995],
              [144.14478600400003, -39.926446221999925],
              [144.14429772200003, -39.936211846999925],
              [144.14185631600003, -39.945977471999925],
              [144.1386824880001, -39.98137786299992],
              [144.1352645190001, -39.992120049999926],
              [144.12916100400003, -39.99667734199994],
              [144.12037194100003, -40.00090911299992],
              [144.1171981130001, -40.01100025799991],
              [144.11589603000004, -40.02239348799992],
              [144.11247806100005, -40.03085702899995],
              [144.10303795700008, -40.037041924999926],
              [144.08171634200005, -40.04534270599993],
              [144.07146243600005, -40.05120208099993],
              [144.06430097700002, -40.05917734199994],
              [144.05811608200008, -40.06804778399993],
              [144.0507918630001, -40.07537200299993],
              [144.040375196, -40.07854583099993],
              [144.01905358200008, -40.08163827899995],
              [143.92253665500004, -40.12737395599993],
              [143.9028426440001, -40.12615325299993],
              [143.88648522200003, -40.106540622999944],
              [143.8808699880001, -40.09238046699994],
              [143.87224368600005, -40.05120208099993],
              [143.88648522200003, -40.05217864399992],
              [143.89242597700002, -40.03476327899995],
              [143.89275149800005, -39.992852471999925],
              [143.88599694100003, -39.967868747999944],
              [143.8701278000001, -39.95671965899993],
              [143.851898634, -39.949151299999926],
              [143.83814537900003, -39.93450286299992],
              [143.83716881600003, -39.918633721999925],
              [143.84294681100005, -39.86443450299993],
              [143.84831790500004, -39.852634372999944],
              [143.8613387380001, -39.84254322699991],
              [143.866547071, -39.819431247999944],
              [143.86597741000003, -39.77695077899995],
              [143.8637801440001, -39.772149346999925],
              [143.85425866000003, -39.76132577899995],
              [143.85173587300005, -39.75644296699994],
              [143.8535262380001, -39.752618096999925],
              [143.86345462300005, -39.74098072699991],
              [143.86597741000003, -39.73528411299992],
              [143.86011803500003, -39.71217213299991],
              [143.86198978000004, -39.70061614399992],
              [143.87566165500004, -39.695570570999905],
              [143.89478600400003, -39.69150155999995],
              [143.91724694100003, -39.68084075299993],
              [143.93702233200008, -39.66725025799991],
              [143.94800866000003, -39.65398528399993],
              [143.94646243600005, -39.63437265399995],
              [143.93816165500004, -39.609307549999926],
              [143.9340926440001, -39.58798593499995],
              [143.94459069100003, -39.57887135199991],
              [143.9555770190001, -39.57773202899995],
              [143.97437584700003, -39.572523695999905],
              [143.98552493600005, -39.57146575299993],
              [143.9931746750001, -39.57512786299992],
              [144.02369225400003, -39.5993791649999],
              [144.0654403000001, -39.6150041649999],
              [144.08415774800005, -39.62615325299993],
              [144.095062696, -39.648695570999905],
              [144.10222415500004, -39.656182549999926],
              [144.10922285200002, -39.6657854149999],
              [144.11247806100005, -39.67791106599992],
              [144.1054793630001, -39.72226327899995],
              [144.10816491000003, -39.746026299999926],
              [144.12273196700005, -39.7868791649999],
              [144.12614993600005, -39.807712497999944],
              [144.1215926440001, -39.82887135199991],
              [144.10499108200008, -39.87249114399992],
              [144.1054793630001, -39.89299895599993],
            ],
          ],
          [
            [
              [146.62680097700002, -38.75595468499995],
              [146.63453209700003, -38.75318775799991],
              [146.6425887380001, -38.75253671699994],
              [146.6513778000001, -38.75351327899995],
              [146.66089928500003, -38.75595468499995],
              [146.657562696, -38.76441822699991],
              [146.65202884200005, -38.76881275799991],
              [146.64405358200008, -38.77027760199991],
              [146.58277428500003, -38.769463799999926],
              [146.57601972700002, -38.7732072899999],
              [146.56617272200003, -38.7907854149999],
              [146.55844160200002, -38.796807549999926],
              [146.53891035200002, -38.79705169099992],
              [146.5161238940001, -38.78948333099993],
              [146.4946395190001, -38.778008721999925],
              [146.47974694100003, -38.76620859199994],
              [146.47136478000004, -38.74724700299993],
              [146.48975670700008, -38.74570077899995],
              [146.53467858200008, -38.75595468499995],
              [146.5805770190001, -38.7478166649999],
              [146.60230553500003, -38.74684010199991],
              [146.62680097700002, -38.75595468499995],
            ],
          ],
          [
            [
              [145.33521569100003, -38.50945403399993],
              [145.34343509200005, -38.51051197699991],
              [145.34441165500004, -38.51336028399993],
              [145.34327233200008, -38.51775481599992],
              [145.3457137380001, -38.52312590899993],
              [145.3545028000001, -38.53443775799991],
              [145.36101321700005, -38.54851653399993],
              [145.3613387380001, -38.56178150799991],
              [145.3525496750001, -38.570977471999925],
              [145.35230553500003, -38.56650155999995],
              [145.3505965500001, -38.563571872999944],
              [145.34831790500004, -38.560804945999905],
              [145.3457137380001, -38.55722421699994],
              [145.31959069100003, -38.539320570999905],
              [145.29281660200002, -38.525648695999905],
              [145.2636824880001, -38.51921965899993],
              [145.2290145190001, -38.52312590899993],
              [145.22038821700005, -38.53004322699991],
              [145.21314537900003, -38.53460051899992],
              [145.20573978000004, -38.53679778399993],
              [145.19800866000003, -38.53476327899995],
              [145.1816512380001, -38.52548593499995],
              [145.17505944100003, -38.52312590899993],
              [145.1591903000001, -38.52385833099993],
              [145.129730665, -38.53045012799993],
              [145.11296634200005, -38.53053150799991],
              [145.12061608200008, -38.51962655999995],
              [145.15455162900003, -38.495212497999944],
              [145.1757918630001, -38.47551848799992],
              [145.18767337300005, -38.46697356599992],
              [145.20240319100003, -38.46111419099992],
              [145.26441491000003, -38.45549895599993],
              [145.27320397200003, -38.45370859199994],
              [145.2793074880001, -38.45159270599993],
              [145.28630618600005, -38.451429945999905],
              [145.2978621750001, -38.45549895599993],
              [145.3046981130001, -38.45916106599992],
              [145.31316165500004, -38.46575286299992],
              [145.3183699880001, -38.4685197899999],
              [145.30827884200005, -38.47380950299993],
              [145.30420983200008, -38.475274346999925],
              [145.3129988940001, -38.490492445999905],
              [145.3183699880001, -38.495212497999944],
              [145.3149520190001, -38.5036760399999],
              [145.3173934250001, -38.50790780999995],
              [145.32447350400003, -38.50937265399995],
              [145.33521569100003, -38.50945403399993],
            ],
          ],
          [
            [
              [145.4419051440001, -38.31650155999995],
              [145.45435631600003, -38.32170989399992],
              [145.46314537900003, -38.32854583099993],
              [145.49439537900003, -38.365166924999926],
              [145.4887801440001, -38.369073174999926],
              [145.46859785200002, -38.3728166649999],
              [145.42701256600003, -38.374932549999926],
              [145.4140731130001, -38.37908294099992],
              [145.37663821700005, -38.41545989399992],
              [145.35328209700003, -38.428399346999925],
              [145.324554884, -38.42066822699991],
              [145.315765821, -38.414320570999905],
              [145.2837020190001, -38.402601820999905],
              [145.28248131600003, -38.390557549999926],
              [145.2797957690001, -38.37932708099993],
              [145.2700301440001, -38.35865650799991],
              [145.2978621750001, -38.324476820999905],
              [145.2929793630001, -38.31780364399992],
              [145.29021243600005, -38.31015390399995],
              [145.29127037900003, -38.302666924999926],
              [145.2978621750001, -38.29656340899993],
              [145.30689537900003, -38.29534270599993],
              [145.31324303500003, -38.299899997999944],
              [145.31861412900003, -38.30632903399993],
              [145.324554884, -38.310804945999905],
              [145.364105665, -38.32341887799993],
              [145.3798934250001, -38.324476820999905],
              [145.42505944100003, -38.31503671699994],
              [145.4419051440001, -38.31650155999995],
            ],
          ],
          [
            [
              [138.12964928500003, -35.816338799999926],
              [138.1235457690001, -35.83098723799992],
              [138.12818444100003, -35.84880950299993],
              [138.125824415, -35.863946221999925],
              [138.09888756600003, -35.87029387799993],
              [138.086761915, -35.87737395599993],
              [138.05982506600003, -35.90976327899995],
              [138.047699415, -35.918633721999925],
              [138.026703321, -35.91912200299993],
              [138.00375410200002, -35.91350676899992],
              [137.98316491000003, -35.90447356599992],
              [137.950531446, -35.880791924999926],
              [137.93246504, -35.875258070999905],
              [137.91293379, -35.875258070999905],
              [137.889984571, -35.87769947699991],
              [137.87427819100003, -35.876885674999926],
              [137.84498131600003, -35.86663176899992],
              [137.82178795700008, -35.86402760199991],
              [137.79712975400003, -35.86484140399995],
              [137.75668379, -35.87151458099993],
              [137.67335045700008, -35.90203215899993],
              [137.62875410200002, -35.91033294099992],
              [137.6132918630001, -35.92424895599993],
              [137.60694420700008, -35.94394296699994],
              [137.60889733200008, -35.96648528399993],
              [137.6118270190001, -35.97210051899992],
              [137.61646569100003, -35.97698333099993],
              [137.62061608200008, -35.982679945999905],
              [137.62256920700008, -35.99081796699994],
              [137.62037194100003, -36.00009530999995],
              [137.6157332690001, -36.0075822899999],
              [137.61109459700003, -36.013604424999926],
              [137.60889733200008, -36.01799895599993],
              [137.60230553500003, -36.02581145599993],
              [137.55420983200008, -36.03533294099992],
              [137.4931746750001, -36.07040780999995],
              [137.45923912900003, -36.082696221999925],
              [137.44499759200005, -36.06951262799993],
              [137.41586347700002, -36.05543385199991],
              [137.3711043630001, -36.010837497999944],
              [137.33855228000004, -36.00123463299991],
              [137.29029381600003, -35.99879322699991],
              [137.243500196, -35.983086846999925],
              [137.227875196, -35.97975025799991],
              [137.21168053500003, -35.98015715899993],
              [137.1879988940001, -35.99309661299992],
              [137.181000196, -36.01409270599993],
              [137.171234571, -36.03362395599993],
              [137.13990319100003, -36.04225025799991],
              [137.12427819100003, -36.040134372999944],
              [137.092133009, -36.03069426899992],
              [137.07447350400003, -36.02849700299993],
              [137.04420006600003, -36.03460051899992],
              [137.0302840500001, -36.03337981599992],
              [137.01978600400003, -36.021742445999905],
              [136.95191491000003, -36.04607512799993],
              [136.9204207690001, -36.049493096999925],
              [136.88941491000003, -36.04225025799991],
              [136.869476759, -36.03053150799991],
              [136.86215254, -36.02849700299993],
              [136.85075931100005, -36.03045012799993],
              [136.83326256600003, -36.03997161299992],
              [136.8247176440001, -36.04225025799991],
              [136.80290774800005, -36.04119231599992],
              [136.791351759, -36.04192473799992],
              [136.78337649800005, -36.04566822699991],
              [136.771820509, -36.05608489399992],
              [136.76514733200008, -36.05722421699994],
              [136.75847415500004, -36.054945570999905],
              [136.7461043630001, -36.05584075299993],
              [136.7285262380001, -36.060804945999905],
              [136.71558678500003, -36.062758070999905],
              [136.70728600400003, -36.056898695999905],
              [136.70460045700008, -36.03875090899993],
              [136.69874108200008, -36.02654387799993],
              [136.68523196700005, -36.00701262799993],
              [136.6567488940001, -35.97389088299991],
              [136.642914259, -35.9685197899999],
              [136.6054793630001, -35.963148695999905],
              [136.59131920700008, -35.95663827899995],
              [136.532562696, -35.9118791649999],
              [136.53687584700003, -35.9021135399999],
              [136.53736412900003, -35.88225676899992],
              [136.5400496750001, -35.87029387799993],
              [136.54460696700005, -35.86532968499995],
              [136.55152428500003, -35.86142343499995],
              [136.5576278000001, -35.85426197699991],
              [136.56202233200008, -35.82952239399992],
              [136.56625410200002, -35.820570570999905],
              [136.57178795700008, -35.812758070999905],
              [136.57789147200003, -35.80632903399993],
              [136.582367384, -35.79697030999995],
              [136.578949415, -35.77752044099992],
              [136.58155358200008, -35.76848723799992],
              [136.59782962300005, -35.75750090899993],
              [136.6211043630001, -35.75123463299991],
              [136.69125410200002, -35.746026299999926],
              [136.738617384, -35.726820570999905],
              [136.7680770190001, -35.72429778399993],
              [136.7802840500001, -35.72079843499995],
              [136.79574629, -35.71168385199991],
              [136.8051863940001, -35.70794036299992],
              [137.07447350400003, -35.6716447899999],
              [137.09392337300005, -35.66570403399993],
              [137.143890821, -35.6443010399999],
              [137.27995853000004, -35.6169572899999],
              [137.2929793630001, -35.6091447899999],
              [137.305023634, -35.59775155999995],
              [137.31820722700002, -35.58733489399992],
              [137.33513431100005, -35.58294036299992],
              [137.35222415500004, -35.58562590899993],
              [137.435883009, -35.61060963299991],
              [137.44499759200005, -35.61093515399995],
              [137.45378665500004, -35.608086846999925],
              [137.47234134200005, -35.59661223799992],
              [137.48975670700008, -35.59612395599993],
              [137.5161238940001, -35.598321221999925],
              [137.53305097700002, -35.59661223799992],
              [137.5688582690001, -35.58554452899995],
              [137.586761915, -35.58359140399995],
              [137.6020613940001, -35.59042734199994],
              [137.62289472700002, -35.58212655999995],
              [137.63428795700008, -35.590508721999925],
              [137.633636915, -35.603773695999905],
              [137.61939537900003, -35.61093515399995],
              [137.597992384, -35.61728280999995],
              [137.583343946, -35.63128020599993],
              [137.58155358200008, -35.64544036299992],
              [137.5986434250001, -35.65178801899992],
              [137.6328231130001, -35.65178801899992],
              [137.64714603000004, -35.6540666649999],
              [137.64771569100003, -35.65943775799991],
              [137.6240340500001, -35.6872697899999],
              [137.58082116000003, -35.726820570999905],
              [137.60181725400003, -35.7439104149999],
              [137.62378991000003, -35.74456145599993],
              [137.64600670700008, -35.74236419099992],
              [137.6860457690001, -35.75750090899993],
              [137.71159915500004, -35.75628020599993],
              [137.75277754, -35.747979424999926],
              [137.76490319100003, -35.74358489399992],
              [137.77222741000003, -35.73943450299993],
              [137.77849368600005, -35.73951588299991],
              [137.78695722700002, -35.747979424999926],
              [137.79175866000003, -35.75725676899992],
              [137.79127037900003, -35.76458098799992],
              [137.78858483200008, -35.77288176899992],
              [137.78695722700002, -35.78525155999995],
              [137.79444420700008, -35.80478280999995],
              [137.81275475400003, -35.81145598799992],
              [137.835297071, -35.809258721999925],
              [137.8559676440001, -35.802666924999926],
              [137.87134850400003, -35.79306405999995],
              [137.88445071700005, -35.779229424999926],
              [137.89340254, -35.76246510199991],
              [137.896820509, -35.74431731599992],
              [137.908539259, -35.72909921699994],
              [137.9355574880001, -35.726495049999926],
              [137.96558678500003, -35.7302385399999],
              [138.0068465500001, -35.74041106599992],
              [138.04810631600003, -35.75750090899993],
              [138.06470787900003, -35.76100025799991],
              [138.0669051440001, -35.766289971999925],
              [138.07439212300005, -35.79924895599993],
              [138.08033287900003, -35.809258721999925],
              [138.09400475400003, -35.81462981599992],
              [138.11011803500003, -35.81650155999995],
              [138.12964928500003, -35.816338799999926],
            ],
          ],
          [
            [
              [136.4472762380001, -35.14812590899993],
              [136.4629012380001, -35.139743747999944],
              [136.47632897200003, -35.14470794099992],
              [136.48796634200005, -35.15740325299993],
              [136.4985457690001, -35.17205169099992],
              [136.4921981130001, -35.17888762799993],
              [136.4848738940001, -35.17205169099992],
              [136.464203321, -35.172539971999925],
              [136.44752037900003, -35.16936614399992],
              [136.4399520190001, -35.16171640399995],
              [136.4472762380001, -35.14812590899993],
            ],
          ],
          [
            [
              [136.17359459700003, -35.01132577899995],
              [136.18506920700008, -35.02117278399993],
              [136.19361412900003, -35.02581145599993],
              [136.1997176440001, -35.03281015399995],
              [136.20484459700003, -35.049086195999905],
              [136.20655358200008, -35.061211846999925],
              [136.20590254, -35.071384372999944],
              [136.20134524800005, -35.07537200299993],
              [136.19060306100005, -35.06959400799991],
              [136.1621199880001, -35.065524997999944],
              [136.1528426440001, -35.04851653399993],
              [136.15056399800005, -35.02467213299991],
              [136.14283287900003, -35.000664971999925],
              [136.09929446700005, -34.96819426899992],
              [136.08611087300005, -34.94817473799992],
              [136.111664259, -34.9392229149999],
              [136.1269637380001, -34.94841887799993],
              [136.17359459700003, -35.01132577899995],
            ],
          ],
          [
            [
              [137.3691512380001, -34.4724260399999],
              [137.37378991000003, -34.49822356599992],
              [137.3671981130001, -34.524102471999925],
              [137.354828321, -34.53801848799992],
              [137.34197024800005, -34.52776458099993],
              [137.33619225400003, -34.51531340899993],
              [137.344086134, -34.50074635199991],
              [137.3691512380001, -34.4724260399999],
            ],
          ],
          [
            [
              [134.54639733200008, -33.71217213299991],
              [134.55062910200002, -33.73365650799991],
              [134.5434676440001, -33.740166924999926],
              [134.52881920700008, -33.741306247999944],
              [134.51156660200002, -33.74627044099992],
              [134.49048912900003, -33.775648695999905],
              [134.4790145190001, -33.78362395599993],
              [134.47136478000004, -33.76677825299993],
              [134.48259524800005, -33.73796965899993],
              [134.4843856130001, -33.729587497999944],
              [134.48454837300005, -33.71648528399993],
              [134.4863387380001, -33.71168385199991],
              [134.49927819100003, -33.705336195999905],
              [134.526703321, -33.699476820999905],
              [134.52898196700005, -33.69850025799991],
              [134.5395613940001, -33.69646575299993],
              [134.5420028000001, -33.69996510199991],
              [134.54639733200008, -33.71217213299991],
            ],
          ],
          [
            [
              [133.56568444100003, -32.32122161299992],
              [133.5415145190001, -32.31259530999995],
              [133.543793165, -32.29461028399993],
              [133.56039472700002, -32.27459075299993],
              [133.57935631600003, -32.259698174999926],
              [133.597992384, -32.25115325299993],
              [133.62330162900003, -32.2439104149999],
              [133.65064537900003, -32.23943450299993],
              [133.67554772200003, -32.239353122999944],
              [133.67554772200003, -32.24537525799991],
              [133.62037194100003, -32.259698174999926],
              [133.62916100400003, -32.275323174999926],
              [133.63396243600005, -32.28020598799992],
              [133.62256920700008, -32.285088799999926],
              [133.6162215500001, -32.29436614399992],
              [133.612640821, -32.303399346999925],
              [133.61011803500003, -32.30754973799992],
              [133.59782962300005, -32.308851820999905],
              [133.56568444100003, -32.32122161299992],
            ],
          ],
          [
            [
              [159.04444420700008, -31.51921965899993],
              [159.0688582690001, -31.520928643999923],
              [159.083343946, -31.53484465899993],
              [159.0937606130001, -31.552992445999905],
              [159.1064559250001, -31.56764088299991],
              [159.09839928500003, -31.579278252999927],
              [159.08961022200003, -31.589043877999927],
              [159.07886803500003, -31.593357028999947],
              [159.064789259, -31.588148695999905],
              [159.0800887380001, -31.57626718499995],
              [159.0830184250001, -31.558363539999903],
              [159.0752059250001, -31.539808851999908],
              [159.057953321, -31.526055596999925],
              [159.0517684250001, -31.533461195999905],
              [159.04704837300005, -31.526543877999927],
              [159.04444420700008, -31.51921965899993],
            ],
          ],
          [
            [
              [153.4873153000001, -27.415215752999927],
              [153.50114993600005, -27.41765715899993],
              [153.5488387380001, -27.415215752999927],
              [153.52751712300005, -27.45566171699994],
              [153.50855553500003, -27.504082940999922],
              [153.45590254, -27.72079843499995],
              [153.45069420700008, -27.72307708099993],
              [153.4355574880001, -27.72307708099993],
              [153.42172285200002, -27.72503020599993],
              [153.41130618600005, -27.727634372999944],
              [153.4033309250001, -27.72625090899993],
              [153.39136803500003, -27.701836846999925],
              [153.39226321700005, -27.687758070999905],
              [153.39795983200008, -27.65789153399993],
              [153.40007571700005, -27.654554945999905],
              [153.4047957690001, -27.650567315999922],
              [153.40943444100003, -27.64511484199994],
              [153.411468946, -27.63713958099993],
              [153.40967858200008, -27.628350518999923],
              [153.40064537900003, -27.615004164999903],
              [153.39795983200008, -27.60637786299992],
              [153.3994246750001, -27.59238046699994],
              [153.4091903000001, -27.562107028999947],
              [153.411468946, -27.548028252999927],
              [153.40943444100003, -27.531914971999925],
              [153.39795983200008, -27.49309661299992],
              [153.40251712300005, -27.47820403399993],
              [153.4243270190001, -27.45045338299991],
              [153.4321395190001, -27.435723565999922],
              [153.43238366000003, -27.406426690999922],
              [153.4340926440001, -27.39299895599993],
              [153.4423934250001, -27.38730234199994],
              [153.45850670700008, -27.390883070999905],
              [153.469086134, -27.399183851999908],
              [153.47730553500003, -27.408461195999905],
              [153.4873153000001, -27.415215752999927],
            ],
          ],
          [
            [
              [153.411468946, -27.33953215899993],
              [153.4121199880001, -27.32268645599993],
              [153.406586134, -27.29501718499995],
              [153.3974715500001, -27.269138278999947],
              [153.38738040500004, -27.257582289999903],
              [153.37647545700008, -27.247816664999903],
              [153.369476759, -27.22551848799992],
              [153.3637801440001, -27.16334400799991],
              [153.36996504, -27.102715752999927],
              [153.36597741000003, -27.08049895599993],
              [153.36052493600005, -27.066013278999947],
              [153.36312910200002, -27.05527109199994],
              [153.383636915, -27.044122002999927],
              [153.418304884, -27.037855726999908],
              [153.43962649800005, -27.022556247999944],
              [153.45134524800005, -27.017022393999923],
              [153.46273847700002, -27.020603122999944],
              [153.46900475400003, -27.037041924999926],
              [153.46607506600003, -27.060153903999947],
              [153.4257918630001, -27.180433851999908],
              [153.41822350400003, -27.222832940999922],
              [153.418304884, -27.271254164999903],
              [153.42115319100003, -27.283135674999926],
              [153.4301863940001, -27.30868905999995],
              [153.4321395190001, -27.322442315999922],
              [153.4316512380001, -27.339043877999927],
              [153.42920983200008, -27.35442473799992],
              [153.42302493600005, -27.358168226999908],
              [153.411468946, -27.33953215899993],
            ],
          ],
          [
            [
              [113.21664472700002, -26.06804778399993],
              [113.22461998800009, -26.085381768999923],
              [113.22510826900009, -26.10833098799992],
              [113.21900475400003, -26.128838799999926],
              [113.20704186300009, -26.139743747999944],
              [113.19613691500001, -26.13600025799991],
              [113.17725670700008, -26.12558359199994],
              [113.17068463400005, -26.092617267999913],
              [113.15569932800008, -26.05405937499995],
              [113.13559004000001, -26.033461195999905],
              [113.12769616000003, -26.023695570999905],
              [113.0826984360001, -25.965497944999925],
              [113.04615319100003, -25.94003671699994],
              [113.0124257550001, -25.845132236999916],
              [112.96452884200005, -25.794040622999944],
              [112.95386803500003, -25.773044528999947],
              [112.96290123800009, -25.763604424999926],
              [112.96355228000004, -25.75448984199994],
              [112.95479137900008, -25.697520597999926],
              [112.91959906600005, -25.631555239999955],
              [112.91984880900009, -25.577110744999914],
              [112.92245869600004, -25.558974976999934],
              [112.91944420700008, -25.523614190999922],
              [112.93181399800005, -25.507012627999927],
              [112.94605553500003, -25.49187590899993],
              [112.95948326900009, -25.48251718499995],
              [112.96900475400003, -25.494317315999922],
              [112.98365319100003, -25.49309661299992],
              [112.998383009, -25.48992278399993],
              [113.00782311300009, -25.49618905999995],
              [113.00652103000004, -25.504571221999925],
              [113.006181932, -25.531650030999913],
              [113.00606420300005, -25.552923024999927],
              [113.0200114910001, -25.589134573999957],
              [113.04337940000005, -25.62964689499995],
              [113.05018125200002, -25.680761771999926],
              [113.05128014400009, -25.716973565999922],
              [113.07108422600004, -25.746847870999943],
              [113.08976308500007, -25.795818924999935],
              [113.11785411200003, -25.847127118999936],
              [113.13754316500001, -25.885918877999927],
              [113.11524498800009, -25.937758070999905],
              [113.115570509, -25.96331145599993],
              [113.14503014400009, -25.969008070999905],
              [113.14039147200003, -25.96257903399993],
              [113.13477623800009, -25.952243747999944],
              [113.13135826900009, -25.947930596999925],
              [113.14470462300005, -25.94622161299992],
              [113.15503991000003, -25.95867278399993],
              [113.16456139400009, -25.97698333099993],
              [113.17579186300009, -25.99277109199994],
              [113.18327884200005, -26.00090911299992],
              [113.19605553500003, -26.018975518999923],
              [113.20337975400003, -26.02703215899993],
              [113.20899498800009, -26.036553643999923],
              [113.21216881600003, -26.05917734199994],
              [113.21664472700002, -26.06804778399993],
            ],
          ],
          [
            [
              [152.96241295700008, -25.26962655999995],
              [152.99366295700008, -25.30396900799991],
              [153.0063582690001, -25.327732028999947],
              [152.99390709700003, -25.33847421699994],
              [152.96371504, -25.299086195999905],
              [152.9536238940001, -25.278497002999927],
              [152.96241295700008, -25.26962655999995],
            ],
          ],
          [
            [
              [113.05567467500009, -25.262790622999944],
              [113.05128014400009, -25.239678643999923],
              [113.07585696700005, -25.169854424999926],
              [113.08301842500009, -25.136651299999926],
              [113.07911217500009, -25.062432549999926],
              [113.08838951900009, -25.02906666499996],
              [113.11768639400009, -25.00945403399993],
              [113.11060631600003, -25.04469166499996],
              [113.11011803500003, -25.06308359199994],
              [113.11426842500009, -25.070977471999925],
              [113.10547936300009, -25.07984791499996],
              [113.10303795700008, -25.100762627999927],
              [113.10336347700002, -25.14039478999996],
              [113.09766686300009, -25.156508070999905],
              [113.07984459700003, -25.190524997999944],
              [113.07618248800009, -25.205010674999926],
              [113.07667076900009, -25.24228280999995],
              [113.07471764400009, -25.26018645599993],
              [113.06934655000009, -25.276462497999944],
              [113.06316165500004, -25.276462497999944],
              [113.05738366000003, -25.26726653399993],
              [113.05567467500009, -25.262790622999944],
            ],
          ],
          [
            [
              [113.15186608200008, -24.926934502999927],
              [113.12956790500004, -24.956231377999927],
              [113.12094160200002, -24.974053643999923],
              [113.11768639400009, -24.995212497999944],
              [113.11768639400009, -24.985772393999923],
              [113.11646569100003, -24.97714609199994],
              [113.11426842500009, -24.968926690999922],
              [113.11085045700008, -24.961114190999922],
              [113.13282311300009, -24.802341403999947],
              [113.15186608200008, -24.75562916499996],
              [113.15919030000009, -24.775648695999905],
              [113.15845787900003, -24.80169036299992],
              [113.13493899800005, -24.892022393999923],
              [113.13599694100003, -24.917168877999927],
              [113.15186608200008, -24.926934502999927],
            ],
          ],
          [
            [
              [153.36996504, -24.989027601999908],
              [153.3735457690001, -25.01181405999995],
              [153.3657332690001, -25.029554945999905],
              [153.354828321, -25.04534270599993],
              [153.34945722700002, -25.06096770599993],
              [153.34546959700003, -25.081638278999947],
              [153.26742597700002, -25.25554778399993],
              [153.1606551440001, -25.463148695999905],
              [153.08350670700008, -25.66578541499996],
              [153.08570397200003, -25.691338799999926],
              [153.10173587300005, -25.721856377999927],
              [153.09986412900003, -25.757745049999926],
              [153.08326256600003, -25.786879164999903],
              [153.05534915500004, -25.797133070999905],
              [153.01628665500004, -25.75400155999995],
              [152.999359571, -25.72861093499995],
              [152.99732506600003, -25.712090752999927],
              [153.00220787900003, -25.69304778399993],
              [152.98422285200002, -25.64576588299991],
              [152.98650149800005, -25.61956145599993],
              [152.95826256600003, -25.61174895599993],
              [152.9462996750001, -25.58294036299992],
              [152.9482528000001, -25.552178643999923],
              [152.96241295700008, -25.53769296699994],
              [152.98585045700008, -25.52507903399993],
              [152.9941512380001, -25.495700778999947],
              [153.00074303500003, -25.43401458099993],
              [153.00855553500003, -25.42164478999996],
              [153.0180770190001, -25.41334400799991],
              [153.02751712300005, -25.40683359199994],
              [153.03484134200005, -25.399834893999923],
              [153.05005944100003, -25.366387627999927],
              [153.05836022200003, -25.35515715899993],
              [153.06853274800005, -25.32903411299992],
              [153.05616295700008, -25.27320728999996],
              [153.0688582690001, -25.24846770599993],
              [153.06226647200003, -25.23723723799992],
              [153.05445397200003, -25.233493747999944],
              [153.0454207690001, -25.23219166499996],
              [153.021820509, -25.223402601999908],
              [153.015961134, -25.223321221999925],
              [153.01441491000003, -25.22161223799992],
              [153.01441491000003, -25.21152109199994],
              [153.02133222700002, -25.19817473799992],
              [153.03834069100003, -25.183526299999926],
              [153.14795983200008, -25.11419036299992],
              [153.1787215500001, -25.087497653999947],
              [153.2055770190001, -25.057305596999925],
              [153.22608483200008, -25.027520440999922],
              [153.242523634, -24.993259372999944],
              [153.24919681100005, -24.95484791499996],
              [153.239593946, -24.913262627999927],
              [153.22234134200005, -24.881524346999925],
              [153.19410241000003, -24.84075286299992],
              [153.16325931100005, -24.812432549999926],
              [153.1372176440001, -24.817071221999925],
              [153.19556725400003, -24.748711846999925],
              [153.2050887380001, -24.745212497999944],
              [153.2334090500001, -24.721449476999908],
              [153.2724715500001, -24.699883721999925],
              [153.2812606130001, -24.693536065999922],
              [153.2861434250001, -24.736504815999922],
              [153.2812606130001, -24.858575127999927],
              [153.28492272200003, -24.87664153399993],
              [153.30225670700008, -24.92945728999996],
              [153.311859571, -24.940606377999927],
              [153.3212996750001, -24.946384372999944],
              [153.35889733200008, -24.976006768999923],
              [153.36996504, -24.989027601999908],
            ],
          ],
          [
            [
              [151.37232506600003, -23.820245049999926],
              [151.38306725400003, -23.840101820999905],
              [151.38835696700005, -23.864434502999927],
              [151.38306725400003, -23.879571221999925],
              [151.362640821, -23.871758721999925],
              [151.35962975400003, -23.847832940999922],
              [151.3520613940001, -23.83245208099993],
              [151.3286238940001, -23.802911065999922],
              [151.322601759, -23.77190520599993],
              [151.32105553500003, -23.768731377999927],
              [151.32634524800005, -23.757256768999923],
              [151.33326256600003, -23.750176690999922],
              [151.33952884200005, -23.751397393999923],
              [151.3447371750001, -23.782403252999927],
              [151.35181725400003, -23.796482028999947],
              [151.37232506600003, -23.820245049999926],
            ],
          ],
          [
            [
              [151.269867384, -23.666273695999905],
              [151.28777103000004, -23.679131768999923],
              [151.29615319100003, -23.707289320999905],
              [151.29851321700005, -23.735446872999944],
              [151.29761803500003, -23.748223565999922],
              [151.2910262380001, -23.749932549999926],
              [151.28679446700005, -23.75400155999995],
              [151.28142337300005, -23.761895440999922],
              [151.2773543630001, -23.76604583099993],
              [151.2758895190001, -23.768975518999923],
              [151.27361087300005, -23.77206796699994],
              [151.266449415, -23.776136976999908],
              [151.26335696700005, -23.77516041499996],
              [151.229828321, -23.777276299999926],
              [151.22185306100005, -23.779473565999922],
              [151.2138778000001, -23.778090101999908],
              [151.2050887380001, -23.768731377999927],
              [151.19418379, -23.754164320999905],
              [151.180511915, -23.742852471999925],
              [151.1689559250001, -23.729913018999923],
              [151.1591903000001, -23.693617445999905],
              [151.14730879, -23.675225518999923],
              [151.10523522200003, -23.628024997999944],
              [151.07886803500003, -23.60865650799991],
              [151.06788170700008, -23.59807708099993],
              [151.05420983200008, -23.57870859199994],
              [151.021066497, -23.535602672999914],
              [150.997871163, -23.50667279399994],
              [150.979607397, -23.487385632999917],
              [151.01607439500003, -23.474481527999956],
              [151.02238121200003, -23.469327049999947],
              [151.022370561, -23.46160581299995],
              [151.01815091000003, -23.45324564099991],
              [151.02751712300005, -23.444512627999927],
              [151.03687584700003, -23.45086028399993],
              [151.04363040500004, -23.45354583099993],
              [151.05225670700008, -23.451836846999925],
              [151.061859571, -23.44890715899993],
              [151.0712996750001, -23.447198174999926],
              [151.07797285200002, -23.450778903999947],
              [151.0791121750001, -23.45907968499995],
              [151.07886803500003, -23.468357028999947],
              [151.08155358200008, -23.474541924999926],
              [151.09929446700005, -23.479913018999923],
              [151.14185631600003, -23.487888278999947],
              [151.1504012380001, -23.498711846999925],
              [151.1606551440001, -23.503838799999926],
              [151.1801863940001, -23.507256768999923],
              [151.1914168630001, -23.513848565999922],
              [151.17701256600003, -23.52906666499996],
              [151.19507897200003, -23.533868096999925],
              [151.21070397200003, -23.520684502999927],
              [151.224945509, -23.501560153999947],
              [151.239105665, -23.48886484199994],
              [151.2387801440001, -23.516289971999925],
              [151.2270613940001, -23.56145598799992],
              [151.2255965500001, -23.58375416499996],
              [151.22934004, -23.60751718499995],
              [151.23780358200008, -23.63453541499996],
              [151.25123131600003, -23.656996351999908],
              [151.269867384, -23.666273695999905],
            ],
          ],
          [
            [
              [149.72779381600003, -22.340508721999925],
              [149.73617597700002, -22.339043877999927],
              [149.74675540500004, -22.346856377999927],
              [149.76628665500004, -22.364678643999923],
              [149.7558699880001, -22.368747653999947],
              [149.75375410200002, -22.376560153999947],
              [149.7544051440001, -22.386895440999922],
              [149.7519637380001, -22.39885833099993],
              [149.73121178500003, -22.42815520599993],
              [149.72478274800005, -22.43987395599993],
              [149.7133895190001, -22.429294528999947],
              [149.710297071, -22.42555103999996],
              [149.71558678500003, -22.415215752999927],
              [149.718109571, -22.404473565999922],
              [149.7168074880001, -22.39430103999996],
              [149.710297071, -22.38518645599993],
              [149.71705162900003, -22.374200127999927],
              [149.72250410200002, -22.350762627999927],
              [149.72779381600003, -22.340508721999925],
            ],
          ],
          [
            [
              [150.53663170700008, -22.275323174999926],
              [150.544281446, -22.27743905999995],
              [150.55250084700003, -22.282321872999944],
              [150.5586043630001, -22.288995049999926],
              [150.56080162900003, -22.29583098799992],
              [150.55583743600005, -22.30632903399993],
              [150.54656009200005, -22.312432549999926],
              [150.537445509, -22.316338799999926],
              [150.53345787900003, -22.319756768999923],
              [150.53142337300005, -22.328301690999922],
              [150.5263778000001, -22.335056247999944],
              [150.51978600400003, -22.340508721999925],
              [150.51295006600003, -22.34433359199994],
              [150.49537194100003, -22.35084400799991],
              [150.48226972700002, -22.34498463299991],
              [150.47934004, -22.331963799999926],
              [150.49187259200005, -22.316338799999926],
              [150.47624759200005, -22.304945570999905],
              [150.47136478000004, -22.302666924999926],
              [150.4677840500001, -22.306247653999947],
              [150.46607506600003, -22.30722421699994],
              [150.46371504, -22.307793877999927],
              [150.45777428500003, -22.310153903999947],
              [150.46656334700003, -22.293715101999908],
              [150.48259524800005, -22.274590752999927],
              [150.49366295700008, -22.255059502999927],
              [150.48845462300005, -22.237481377999927],
              [150.4804793630001, -22.229587497999944],
              [150.47584069100003, -22.22193775799991],
              [150.47836347700002, -22.216241143999923],
              [150.49187259200005, -22.213962497999944],
              [150.50456790500004, -22.216729424999926],
              [150.51140384200005, -22.224216403999947],
              [150.515961134, -22.23414478999996],
              [150.52263431100005, -22.244317315999922],
              [150.5263778000001, -22.253106377999927],
              [150.52759850400003, -22.26336028399993],
              [150.5297957690001, -22.271742445999905],
              [150.53663170700008, -22.275323174999926],
            ],
          ],
          [
            [
              [149.9165145190001, -22.04192473799992],
              [149.91032962300005, -22.07512786299992],
              [149.90967858200008, -22.086602471999925],
              [149.91285241000003, -22.10133228999996],
              [149.92701256600003, -22.121026299999926],
              [149.930023634, -22.13445403399993],
              [149.9282332690001, -22.160088799999926],
              [149.92156009200005, -22.19068775799991],
              [149.9087020190001, -22.216403903999947],
              [149.88851972700002, -22.226820570999905],
              [149.87761478000004, -22.21998463299991],
              [149.8774520190001, -22.21257903399993],
              [149.8813582690001, -22.203789971999925],
              [149.88233483200008, -22.192803643999923],
              [149.8789168630001, -22.186211846999925],
              [149.8740340500001, -22.181898695999905],
              [149.86988366000003, -22.17555103999996],
              [149.868011915, -22.162367445999905],
              [149.86939537900003, -22.14226653399993],
              [149.8740340500001, -22.118584893999923],
              [149.8828231130001, -22.09693775799991],
              [149.89600670700008, -22.08294036299992],
              [149.8896590500001, -22.07317473799992],
              [149.8935653000001, -22.06113046699994],
              [149.90381920700008, -22.049574476999908],
              [149.9165145190001, -22.04192473799992],
            ],
          ],
          [
            [
              [150.29322350400003, -21.740899346999925],
              [150.317718946, -21.73406340899993],
              [150.32960045700008, -21.73447030999995],
              [150.34107506600003, -21.740899346999925],
              [150.36890709700003, -21.726739190999922],
              [150.35889733200008, -21.742933851999908],
              [150.35173587300005, -21.76067473799992],
              [150.3427840500001, -21.771742445999905],
              [150.32740319100003, -21.76881275799991],
              [150.29322350400003, -21.74773528399993],
              [150.29322350400003, -21.740899346999925],
            ],
          ],
          [
            [
              [150.30005944100003, -21.678887627999927],
              [150.29810631600003, -21.67669036299992],
              [150.29761803500003, -21.675388278999947],
              [150.29664147200003, -21.674086195999905],
              [150.29322350400003, -21.672051690999922],
              [150.29053795700008, -21.681084893999923],
              [150.2861434250001, -21.684258721999925],
              [150.28044681100005, -21.68328215899993],
              [150.27271569100003, -21.678887627999927],
              [150.26482181100005, -21.670668226999908],
              [150.25749759200005, -21.66838958099993],
              [150.2509871750001, -21.671075127999927],
              [150.2461043630001, -21.678887627999927],
              [150.24195397200003, -21.670668226999908],
              [150.24195397200003, -21.663506768999923],
              [150.24537194100003, -21.65715911299992],
              [150.25163821700005, -21.651543877999927],
              [150.24878991000003, -21.64421965899993],
              [150.24756920700008, -21.638116143999923],
              [150.2461043630001, -21.62363046699994],
              [150.25163821700005, -21.62363046699994],
              [150.26531009200005, -21.63844166499996],
              [150.288422071, -21.64853280999995],
              [150.30534915500004, -21.659763278999947],
              [150.30005944100003, -21.678887627999927],
            ],
          ],
          [
            [
              [115.46452884200005, -20.73015715899993],
              [115.47046959700003, -20.74618905999995],
              [115.46306399800005, -20.763848565999922],
              [115.44027754000001, -20.794366143999923],
              [115.43921959700003, -20.802341403999947],
              [115.43995201900009, -20.81145598799992],
              [115.43848717500009, -20.819024346999925],
              [115.43043053500003, -20.82236093499995],
              [115.42676842500009, -20.824883721999925],
              [115.41537519600001, -20.836195570999905],
              [115.41309655000009, -20.839450778999947],
              [115.40805097700002, -20.853692315999922],
              [115.39576256600003, -20.86370208099993],
              [115.36524498800009, -20.876885674999926],
              [115.35938561300009, -20.86451588299991],
              [115.34750410200002, -20.85442473799992],
              [115.33570397200003, -20.84970468499995],
              [115.330414259, -20.853122653999947],
              [115.32691491000003, -20.865899346999925],
              [115.31812584700003, -20.87273528399993],
              [115.306976759, -20.870538018999923],
              [115.29639733200008, -20.856540622999944],
              [115.30241946700005, -20.843194268999923],
              [115.31055748800009, -20.801853122999944],
              [115.32960045700008, -20.773370049999926],
              [115.39942467500009, -20.69378020599993],
              [115.42896569100003, -20.669122002999927],
              [115.45118248800009, -20.66838958099993],
              [115.45671634200005, -20.68222421699994],
              [115.45704186300009, -20.715997002999927],
              [115.46452884200005, -20.73015715899993],
            ],
          ],
          [
            [
              [149.094086134, -20.418226820999905],
              [149.09498131600003, -20.43873463299991],
              [149.09839928500003, -20.45322030999995],
              [149.10499108200008, -20.465508721999925],
              [149.11508222700002, -20.479668877999927],
              [149.09262129, -20.48609791499996],
              [149.08179772200003, -20.500176690999922],
              [149.07211347700002, -20.51620859199994],
              [149.053070509, -20.528090101999908],
              [149.04867597700002, -20.524183851999908],
              [149.04314212300005, -20.517510674999926],
              [149.03931725400003, -20.50945403399993],
              [149.039398634, -20.500746351999908],
              [149.04517662900003, -20.49423593499995],
              [149.06177819100003, -20.494398695999905],
              [149.07056725400003, -20.48992278399993],
              [149.08179772200003, -20.472263278999947],
              [149.0859481130001, -20.455010674999926],
              [149.08814537900003, -20.43759530999995],
              [149.094086134, -20.418226820999905],
            ],
          ],
          [
            [
              [149.0673934250001, -20.315199476999908],
              [149.0590926440001, -20.309665622999944],
              [149.05225670700008, -20.303480726999908],
              [149.039398634, -20.287286065999922],
              [149.02613366000003, -20.31926848799992],
              [149.018890821, -20.328871351999908],
              [149.00375410200002, -20.311618747999944],
              [148.99105879, -20.315118096999925],
              [148.98064212300005, -20.323825778999947],
              [148.9712020190001, -20.321465752999927],
              [148.9712020190001, -20.28101978999996],
              [148.953461134, -20.292413018999923],
              [148.94703209700003, -20.294122002999927],
              [148.9399520190001, -20.29387786299992],
              [148.93116295700008, -20.292168877999927],
              [148.92701256600003, -20.287286065999922],
              [148.93327884200005, -20.277601820999905],
              [148.96404056100005, -20.25058359199994],
              [148.96892337300005, -20.237725518999923],
              [148.950043165, -20.232679945999905],
              [148.95883222700002, -20.21152109199994],
              [148.96314537900003, -20.186618747999944],
              [148.96949303500003, -20.16448333099993],
              [148.9848738940001, -20.151462497999944],
              [148.98804772200003, -20.16529713299991],
              [149.00212649800005, -20.190199476999908],
              [149.005218946, -20.202243747999944],
              [149.00407962300005, -20.229261976999908],
              [149.0107528000001, -20.23691171699994],
              [149.02955162900003, -20.239434502999927],
              [149.029633009, -20.24504973799992],
              [149.046234571, -20.274183851999908],
              [149.06714928500003, -20.289239190999922],
              [149.07341556100005, -20.299981377999927],
              [149.0673934250001, -20.315199476999908],
            ],
          ],
          [
            [
              [148.9575301440001, -20.14381275799991],
              [148.95297285200002, -20.15048593499995],
              [148.92335045700008, -20.17864348799992],
              [148.927093946, -20.15789153399993],
              [148.925140821, -20.151462497999944],
              [148.92212975400003, -20.15276458099993],
              [148.91586347700002, -20.15748463299991],
              [148.91480553500003, -20.155857028999947],
              [148.914886915, -20.153497002999927],
              [148.91391035200002, -20.151543877999927],
              [148.90902754, -20.151462497999944],
              [148.90219160200002, -20.16497161299992],
              [148.89437910200002, -20.16025155999995],
              [148.88843834700003, -20.15439218499995],
              [148.88428795700008, -20.14690520599993],
              [148.8818465500001, -20.13762786299992],
              [148.88795006600003, -20.121840101999908],
              [148.91586347700002, -20.089288018999923],
              [148.91277103000004, -20.086602471999925],
              [148.908539259, -20.081638278999947],
              [148.90650475400003, -20.075372002999927],
              [148.90902754, -20.06878020599993],
              [148.92017662900003, -20.060804945999905],
              [148.926117384, -20.06292083099993],
              [148.9306746750001, -20.067966403999947],
              [148.93702233200008, -20.06878020599993],
              [148.94800866000003, -20.06373463299991],
              [148.954437696, -20.058851820999905],
              [148.95883222700002, -20.05201588299991],
              [148.96371504, -20.04159921699994],
              [148.98023522200003, -20.056898695999905],
              [148.9712020190001, -20.07675546699994],
              [148.953461134, -20.096856377999927],
              [148.9438582690001, -20.113457940999922],
              [148.9462996750001, -20.120293877999927],
              [148.9560653000001, -20.134209893999923],
              [148.9575301440001, -20.14381275799991],
            ],
          ],
          [
            [
              [148.45045006600003, -19.96575286299992],
              [148.47429446700005, -19.983086846999925],
              [148.4809676440001, -20.004571221999925],
              [148.47730553500003, -20.02711353999996],
              [148.47022545700008, -20.047621351999908],
              [148.4653426440001, -20.04338958099993],
              [148.4609481130001, -20.042413018999923],
              [148.45622806100005, -20.042575778999947],
              [148.45045006600003, -20.04159921699994],
              [148.45101972700002, -20.01034921699994],
              [148.44939212300005, -19.99618905999995],
              [148.44418379, -19.986260674999926],
              [148.45045006600003, -19.96575286299992],
            ],
          ],
          [
            [
              [146.860199415, -19.115980726999908],
              [146.86394290500004, -19.10515715899993],
              [146.86866295700008, -19.102308851999908],
              [146.87281334700003, -19.107354424999926],
              [146.87452233200008, -19.119398695999905],
              [146.87370853000004, -19.14299895599993],
              [146.87134850400003, -19.15357838299991],
              [146.86703535200002, -19.16383228999996],
              [146.8564559250001, -19.15129973799992],
              [146.82007897200003, -19.17506275799991],
              [146.79867597700002, -19.16383228999996],
              [146.79371178500003, -19.150648695999905],
              [146.785492384, -19.14072030999995],
              [146.7802840500001, -19.132012627999927],
              [146.78500410200002, -19.12281666499996],
              [146.79835045700008, -19.117445570999905],
              [146.810883009, -19.11842213299991],
              [146.82243899800005, -19.11646900799991],
              [146.832855665, -19.102308851999908],
              [146.83773847700002, -19.107028903999947],
              [146.844086134, -19.11028411299992],
              [146.860199415, -19.115980726999908],
            ],
          ],
          [
            [
              [146.31902103000004, -18.382989190999922],
              [146.32593834700003, -18.391371351999908],
              [146.34742272200003, -18.40439218499995],
              [146.35303795700008, -18.410332940999922],
              [146.35328209700003, -18.42164478999996],
              [146.347015821, -18.42620208099993],
              [146.33871504, -18.427992445999905],
              [146.33326256600003, -18.43141041499996],
              [146.3203231130001, -18.464776299999926],
              [146.31080162900003, -18.478692315999922],
              [146.29167728000004, -18.492852471999925],
              [146.2754012380001, -18.483168226999908],
              [146.23951256600003, -18.474867445999905],
              [146.22339928500003, -18.465508721999925],
              [146.21461022200003, -18.44182708099993],
              [146.2050887380001, -18.39031340899993],
              [146.1992293630001, -18.375258070999905],
              [146.1723738940001, -18.334730726999908],
              [146.1626082690001, -18.325290622999944],
              [146.12037194100003, -18.29924895599993],
              [146.10824629, -18.289239190999922],
              [146.09888756600003, -18.278090101999908],
              [146.09302819100003, -18.266289971999925],
              [146.09734134200005, -18.245212497999944],
              [146.12183678500003, -18.245538018999923],
              [146.17505944100003, -18.266289971999925],
              [146.21745853000004, -18.27792734199994],
              [146.22339928500003, -18.260837497999944],
              [146.21892337300005, -18.229180596999925],
              [146.2295028000001, -18.198011976999908],
              [146.2353621750001, -18.22323984199994],
              [146.2485457690001, -18.232598565999922],
              [146.28825931100005, -18.23211028399993],
              [146.302093946, -18.23723723799992],
              [146.297699415, -18.25042083099993],
              [146.28589928500003, -18.268243096999925],
              [146.27808678500003, -18.287367445999905],
              [146.2783309250001, -18.307386976999908],
              [146.2841903000001, -18.32284921699994],
              [146.30876712300005, -18.35198333099993],
              [146.3164168630001, -18.35588958099993],
              [146.3339949880001, -18.357598565999922],
              [146.33936608200008, -18.36191171699994],
              [146.34156334700003, -18.37314218499995],
              [146.3379012380001, -18.380303643999923],
              [146.32984459700003, -18.383558851999908],
              [146.31902103000004, -18.382989190999922],
            ],
          ],
          [
            [
              [139.56218509200005, -17.039239190999922],
              [139.554047071, -17.05445728999996],
              [139.55982506600003, -17.06617603999996],
              [139.5703231130001, -17.07480234199994],
              [139.57585696700005, -17.080824476999908],
              [139.5693465500001, -17.100355726999908],
              [139.55453535200002, -17.10711028399993],
              [139.52068118600005, -17.108086846999925],
              [139.51449629, -17.11191171699994],
              [139.51091556100005, -17.117445570999905],
              [139.50538170700008, -17.121840101999908],
              [139.49390709700003, -17.121758721999925],
              [139.4853621750001, -17.11728280999995],
              [139.4824324880001, -17.11060963299991],
              [139.48170006600003, -17.10442473799992],
              [139.48023522200003, -17.10125090899993],
              [139.46265709700003, -17.100762627999927],
              [139.44556725400003, -17.10751718499995],
              [139.433929884, -17.12151458099993],
              [139.43238366000003, -17.142836195999905],
              [139.42505944100003, -17.142836195999905],
              [139.42505944100003, -17.138116143999923],
              [139.42351321700005, -17.13518645599993],
              [139.4209090500001, -17.132745049999926],
              [139.41822350400003, -17.129164320999905],
              [139.40398196700005, -17.100681247999944],
              [139.40967858200008, -17.088555596999925],
              [139.42741946700005, -17.080336195999905],
              [139.4492293630001, -17.06340911299992],
              [139.47282962300005, -17.025567315999922],
              [139.48951256600003, -17.010430596999925],
              [139.4946395190001, -17.001071872999944],
              [139.49390709700003, -16.985121351999908],
              [139.50855553500003, -16.99277109199994],
              [139.5488387380001, -17.022556247999944],
              [139.56218509200005, -17.039239190999922],
            ],
          ],
          [
            [
              [139.089203321, -16.827569268999923],
              [139.10670006600003, -16.820245049999926],
              [139.1333113940001, -16.81292083099993],
              [139.15503991000003, -16.81292083099993],
              [139.15805097700002, -16.827569268999923],
              [139.1484481130001, -16.834649346999925],
              [139.121918165, -16.83635833099993],
              [139.11646569100003, -16.84465911299992],
              [139.11394290500004, -16.857354424999926],
              [139.10767662900003, -16.862481377999927],
              [139.10108483200008, -16.85947030999995],
              [139.0966903000001, -16.84807708099993],
              [139.096039259, -16.84026458099993],
              [139.0966903000001, -16.834242445999905],
              [139.09546959700003, -16.830010674999926],
              [139.089203321, -16.827569268999923],
            ],
          ],
          [
            [
              [139.73414147200003, -16.443291924999926],
              [139.73951256600003, -16.454685153999947],
              [139.74000084700003, -16.473321221999925],
              [139.7373153000001, -16.492445570999905],
              [139.73414147200003, -16.505466403999947],
              [139.7309676440001, -16.50009530999995],
              [139.72242272200003, -16.489841403999947],
              [139.719086134, -16.484307549999926],
              [139.70866946700005, -16.49537525799991],
              [139.70728600400003, -16.503838799999926],
              [139.71021569100003, -16.511976820999905],
              [139.712250196, -16.52190520599993],
              [139.70769290500004, -16.526462497999944],
              [139.6972762380001, -16.524509372999944],
              [139.6782332690001, -16.517836195999905],
              [139.65650475400003, -16.51995208099993],
              [139.636078321, -16.52662525799991],
              [139.61996504, -16.537855726999908],
              [139.61052493600005, -16.55315520599993],
              [139.60043379, -16.540459893999923],
              [139.58033287900003, -16.505303643999923],
              [139.5727645190001, -16.497979424999926],
              [139.56983483200008, -16.494398695999905],
              [139.56128991000003, -16.487481377999927],
              [139.55250084700003, -16.48333098799992],
              [139.54851321700005, -16.487725518999923],
              [139.54566491000003, -16.492120049999926],
              [139.52808678500003, -16.51230234199994],
              [139.51905358200008, -16.51376718499995],
              [139.4941512380001, -16.514743747999944],
              [139.48707116000003, -16.517836195999905],
              [139.48585045700008, -16.528415622999944],
              [139.49439537900003, -16.535088799999926],
              [139.5068465500001, -16.538669528999947],
              [139.51783287900003, -16.53964609199994],
              [139.52686608200008, -16.54534270599993],
              [139.52466881600003, -16.556898695999905],
              [139.51539147200003, -16.565850518999923],
              [139.50407962300005, -16.563571872999944],
              [139.4931746750001, -16.55559661299992],
              [139.4829207690001, -16.55364348799992],
              [139.4736434250001, -16.557386976999908],
              [139.46656334700003, -16.56698984199994],
              [139.4726668630001, -16.597914320999905],
              [139.47282962300005, -16.60784270599993],
              [139.46859785200002, -16.615411065999922],
              [139.45622806100005, -16.632419528999947],
              [139.45533287900003, -16.635837497999944],
              [139.45875084700003, -16.64104583099993],
              [139.45386803500003, -16.65292734199994],
              [139.444672071, -16.66464609199994],
              [139.4355574880001, -16.669854424999926],
              [139.42505944100003, -16.665459893999923],
              [139.40967858200008, -16.64617278399993],
              [139.39771569100003, -16.642022393999923],
              [139.38550866000003, -16.65097421699994],
              [139.37183678500003, -16.688653252999927],
              [139.359711134, -16.697198174999926],
              [139.34131920700008, -16.700616143999923],
              [139.31861412900003, -16.717543226999908],
              [139.302093946, -16.724541924999926],
              [139.23755944100003, -16.724867445999905],
              [139.22632897200003, -16.72112395599993],
              [139.22022545700008, -16.70989348799992],
              [139.19011478000004, -16.67164478999996],
              [139.17798912900003, -16.662367445999905],
              [139.18425540500004, -16.683200778999947],
              [139.185883009, -16.711602471999925],
              [139.181976759, -16.732679945999905],
              [139.17115319100003, -16.73137786299992],
              [139.16325931100005, -16.745293877999927],
              [139.15300540500004, -16.75595468499995],
              [139.144867384, -16.756036065999922],
              [139.14226321700005, -16.727308851999908],
              [139.1367293630001, -16.707207940999922],
              [139.13697350400003, -16.697198174999926],
              [139.14128665500004, -16.690199476999908],
              [139.14828535200002, -16.68222421699994],
              [139.15503991000003, -16.67229583099993],
              [139.15805097700002, -16.658949476999908],
              [139.159515821, -16.63567473799992],
              [139.16431725400003, -16.616306247999944],
              [139.17261803500003, -16.600355726999908],
              [139.18482506600003, -16.587334893999923],
              [139.20875084700003, -16.569105726999908],
              [139.216156446, -16.556573174999926],
              [139.21892337300005, -16.535821221999925],
              [139.22185306100005, -16.525567315999922],
              [139.22934004, -16.518243096999925],
              [139.23943118600005, -16.51376718499995],
              [139.25025475400003, -16.51230234199994],
              [139.2583113940001, -16.506931247999944],
              [139.27849368600005, -16.48023853999996],
              [139.28785241000003, -16.470635674999926],
              [139.30827884200005, -16.461195570999905],
              [139.329437696, -16.45761484199994],
              [139.3730574880001, -16.457696221999925],
              [139.48755944100003, -16.433526299999926],
              [139.54607181100005, -16.402276299999926],
              [139.58269290500004, -16.395603122999944],
              [139.60377037900003, -16.398370049999926],
              [139.6132918630001, -16.405857028999947],
              [139.61980228000004, -16.416680596999925],
              [139.63054446700005, -16.42978280999995],
              [139.64405358200008, -16.437758070999905],
              [139.66041100400003, -16.44182708099993],
              [139.69939212300005, -16.443291924999926],
              [139.6972762380001, -16.44768645599993],
              [139.6938582690001, -16.45940520599993],
              [139.6919051440001, -16.46379973799992],
              [139.71013431100005, -16.46884530999995],
              [139.71794681100005, -16.457696221999925],
              [139.7231551440001, -16.444512627999927],
              [139.73414147200003, -16.443291924999926],
            ],
          ],
          [
            [
              [136.6704207690001, -15.663181247999944],
              [136.67595462300005, -15.67896900799991],
              [136.69011478000004, -15.686944268999923],
              [136.70476321700005, -15.69304778399993],
              [136.7119246750001, -15.703545830999929],
              [136.70769290500004, -15.71965911299992],
              [136.69548587300005, -15.73992278399993],
              [136.66358483200008, -15.77857838299991],
              [136.6567488940001, -15.77117278399993],
              [136.642914259, -15.762383721999925],
              [136.629730665, -15.749118747999944],
              [136.6196395190001, -15.732598565999922],
              [136.6157332690001, -15.714043877999927],
              [136.62183678500003, -15.692559502999927],
              [136.63656660200002, -15.682305596999925],
              [136.65455162900003, -15.675225518999923],
              [136.6704207690001, -15.663181247999944],
            ],
          ],
          [
            [
              [136.80062910200002, -15.642022393999923],
              [136.815765821, -15.652927341999941],
              [136.83025149800005, -15.668226820999905],
              [136.8349715500001, -15.682386976999908],
              [136.8212996750001, -15.689873955999929],
              [136.811859571, -15.687107028999947],
              [136.803070509, -15.672133070999905],
              [136.793793165, -15.669366143999923],
              [136.78003991000003, -15.672946872999944],
              [136.77857506600003, -15.67978280999995],
              [136.78858483200008, -15.702569268999923],
              [136.79175866000003, -15.70598723799992],
              [136.79420006600003, -15.710056247999944],
              [136.793793165, -15.717054945999905],
              [136.79078209700003, -15.722263278999947],
              [136.78532962300005, -15.72584400799991],
              [136.7734481130001, -15.73137786299992],
              [136.7524520190001, -15.74578215899993],
              [136.74146569100003, -15.749444268999923],
              [136.731781446, -15.744398695999905],
              [136.73414147200003, -15.72079843499995],
              [136.74089603000004, -15.698825778999947],
              [136.74293053500003, -15.67587655999995],
              [136.731781446, -15.648858330999929],
              [136.7480574880001, -15.64625416499996],
              [136.783539259, -15.648695570999905],
              [136.80062910200002, -15.642022393999923],
            ],
          ],
          [
            [
              [137.07789147200003, -15.75123463299991],
              [137.079509197, -15.758743645999914],
              [137.087284899, -15.762779166999906],
              [137.09441165500004, -15.766045830999929],
              [137.10637860300005, -15.774224309999909],
              [137.1001824020001, -15.80342103199996],
              [137.09040339, -15.821780987999944],
              [137.07289448400002, -15.846961041999919],
              [137.04390859, -15.834202404999928],
              [137.04216556100005, -15.817803643999923],
              [137.03858483200008, -15.80641041499996],
              [137.03337649800005, -15.79656340899993],
              [137.02320397200003, -15.79225025799991],
              [137.00749759200005, -15.791192315999922],
              [137.000336134, -15.787041924999926],
              [136.98585045700008, -15.750258070999905],
              [136.98414147200003, -15.742608330999929],
              [136.98511803500003, -15.720635674999926],
              [136.98161868600005, -15.712009372999944],
              [136.97331790500004, -15.711114190999922],
              [136.96412194100003, -15.71257903399993],
              [136.95777428500003, -15.710870049999926],
              [136.951508009, -15.710870049999926],
              [136.9481791620001, -15.72942351599994],
              [136.9453518680001, -15.728754661999915],
              [136.93970021000007, -15.728095654999947],
              [136.93472486400003, -15.72132449499992],
              [136.938324415, -15.699883721999925],
              [136.938324415, -15.68287525799991],
              [136.94304446700005, -15.66765715899993],
              [136.951508009, -15.655694268999923],
              [136.96396927400008, -15.640428984999915],
              [136.97527103000004, -15.65601978999996],
              [136.98316491000003, -15.664320570999905],
              [136.988765909, -15.660716618999913],
              [136.9815752510001, -15.634258030999945],
              [136.99213755300002, -15.63082660699996],
              [136.999812958, -15.615178186999913],
              [136.99475584700008, -15.592776142999924],
              [137.004730665, -15.593682549999926],
              [137.015961134, -15.593357028999947],
              [137.02369225400003, -15.602634372999944],
              [137.02738144, -15.62798246899996],
              [137.0471761980001, -15.63876887799995],
              [137.05769806, -15.62921975599994],
              [137.06544705700003, -15.628508654999905],
              [137.0669542070001, -15.646833950999905],
              [137.08319276400005, -15.652196240999956],
              [137.08196633500006, -15.686817994999956],
              [137.08146586100008, -15.726175310999906],
              [137.08224450400007, -15.741771791999952],
              [137.07789147200003, -15.75123463299991],
            ],
          ],
          [
            [
              [136.6157332690001, -15.538995049999926],
              [136.60230553500003, -15.563653252999927],
              [136.60035241000003, -15.611586195999905],
              [136.5879012380001, -15.635186455999929],
              [136.5766707690001, -15.631117445999905],
              [136.55836022200003, -15.633884372999944],
              [136.5468856130001, -15.627699476999908],
              [136.5410262380001, -15.635186455999929],
              [136.53492272200003, -15.638929945999905],
              [136.5195418630001, -15.642022393999923],
              [136.5141707690001, -15.639743747999944],
              [136.50928795700008, -15.63681405999995],
              [136.4985457690001, -15.627699476999908],
              [136.5102645190001, -15.62118905999995],
              [136.5122176440001, -15.60906340899993],
              [136.507172071, -15.596286716999941],
              [136.4985457690001, -15.587497653999947],
              [136.5156356130001, -15.57431405999995],
              [136.5214949880001, -15.567803643999923],
              [136.5263778000001, -15.55950286299992],
              [136.52662194100003, -15.548435153999947],
              [136.52271569100003, -15.539727471999925],
              [136.52491295700008, -15.534274997999944],
              [136.5434676440001, -15.53215911299992],
              [136.56511478000004, -15.526055596999925],
              [136.58521569100003, -15.516371351999908],
              [136.60279381600003, -15.516371351999908],
              [136.6157332690001, -15.538995049999926],
            ],
          ],
          [
            [
              [136.89568118600005, -15.587497653999947],
              [136.883148634, -15.590915622999944],
              [136.87387129, -15.59742603999996],
              [136.87037194100003, -15.607679945999905],
              [136.87525475400003, -15.621514580999929],
              [136.86670983200008, -15.62395598799992],
              [136.8613387380001, -15.626071872999944],
              [136.848480665, -15.635186455999929],
              [136.84791100400003, -15.630466403999947],
              [136.84644616000003, -15.627618096999925],
              [136.8442488940001, -15.625258070999905],
              [136.84164472700002, -15.621514580999929],
              [136.84791100400003, -15.619886976999908],
              [136.8481551440001, -15.617120049999926],
              [136.84164472700002, -15.608005466999941],
              [136.837250196, -15.59929778399993],
              [136.84009850400003, -15.594903252999927],
              [136.84538821700005, -15.591729424999926],
              [136.848480665, -15.587497653999947],
              [136.84986412900003, -15.583591403999947],
              [136.854828321, -15.57545338299991],
              [136.8559676440001, -15.57000090899993],
              [136.8535262380001, -15.56536223799992],
              [136.84359785200002, -15.556573174999926],
              [136.84164472700002, -15.553317966999941],
              [136.84742272200003, -15.535821221999925],
              [136.8574324880001, -15.520196221999925],
              [136.86988366000003, -15.507419528999947],
              [136.8833113940001, -15.49814218499995],
              [136.87468509200005, -15.522149346999925],
              [136.87769616000003, -15.544122002999927],
              [136.89568118600005, -15.587497653999947],
            ],
          ],
          [
            [
              [124.41797936300009, -15.254082940999922],
              [124.42286217500009, -15.24618905999995],
              [124.43384850400003, -15.246514580999929],
              [124.44548587300005, -15.25318775799991],
              [124.45199629000001, -15.264743747999944],
              [124.44727623800009, -15.274834893999923],
              [124.43653405000009, -15.283868096999925],
              [124.43181399800005, -15.292168877999927],
              [124.44459069100003, -15.299411716999941],
              [124.43165123800009, -15.30868905999995],
              [124.42074629000001, -15.30641041499996],
              [124.40992272200003, -15.30087655999995],
              [124.396820509, -15.299411716999941],
              [124.39307701900009, -15.30282968499995],
              [124.38990319100003, -15.309177341999941],
              [124.385101759, -15.315524997999944],
              [124.37647545700008, -15.31926848799992],
              [124.37281334700003, -15.31731536299992],
              [124.342133009, -15.306247653999947],
              [124.33619225400003, -15.30006275799991],
              [124.33472741000003, -15.296807549999926],
              [124.33472741000003, -15.29192473799992],
              [124.38412519600001, -15.281182549999926],
              [124.40796959700003, -15.272067966999941],
              [124.41797936300009, -15.254082940999922],
            ],
          ],
          [
            [
              [124.57569420700008, -15.33294036299992],
              [124.60173587300005, -15.34384530999995],
              [124.62794030000009, -15.387383721999925],
              [124.65015709700003, -15.395114841999941],
              [124.63542728000004, -15.40439218499995],
              [124.549164259, -15.436293226999908],
              [124.53126061300009, -15.44036223799992],
              [124.52035566500001, -15.435967705999929],
              [124.51498457100001, -15.423028252999927],
              [124.51775149800005, -15.413262627999927],
              [124.52523847700002, -15.409763278999947],
              [124.53467858200008, -15.415459893999923],
              [124.55437259200005, -15.389336846999925],
              [124.56706790500004, -15.379327080999929],
              [124.58253014400009, -15.37395598799992],
              [124.57032311300009, -15.373711846999925],
              [124.53777103000004, -15.367771091999941],
              [124.52849368600005, -15.369724216999941],
              [124.51710045700008, -15.37859465899993],
              [124.50668379000001, -15.381442966999941],
              [124.51417076900009, -15.360935153999947],
              [124.49773196700005, -15.377618096999925],
              [124.48568769600001, -15.377618096999925],
              [124.47429446700005, -15.36923593499995],
              [124.45883222700002, -15.360935153999947],
              [124.47055097700002, -15.351006768999923],
              [124.472992384, -15.340997002999927],
              [124.47193444100003, -15.332289320999905],
              [124.47266686300009, -15.326104424999926],
              [124.47974694100003, -15.317966403999947],
              [124.48707116000003, -15.31373463299991],
              [124.49561608200008, -15.315850518999923],
              [124.50668379000001, -15.326104424999926],
              [124.50245201900009, -15.317152601999908],
              [124.50171959700003, -15.30868905999995],
              [124.50538170700008, -15.300388278999947],
              [124.51417076900009, -15.29192473799992],
              [124.49317467500009, -15.29192473799992],
              [124.50440514400009, -15.27939218499995],
              [124.55201256600003, -15.249444268999923],
              [124.568695509, -15.24423593499995],
              [124.56324303500003, -15.256524346999925],
              [124.54957116000003, -15.297458591999941],
              [124.55144290500004, -15.306247653999947],
              [124.56128991000003, -15.306817315999922],
              [124.57447350400003, -15.309991143999923],
              [124.58220462300005, -15.317966403999947],
              [124.57569420700008, -15.33294036299992],
            ],
          ],
          [
            [
              [124.92823326900009, -14.97356536299992],
              [124.92164147200003, -14.983982028999947],
              [124.92603600400003, -14.991387627999927],
              [124.93384850400003, -14.996026299999926],
              [124.93816165500004, -14.99773528399993],
              [124.939789259, -15.013929945999905],
              [124.93628991000003, -15.026055596999925],
              [124.92701256600003, -15.029229424999926],
              [124.91146894600001, -15.018243096999925],
              [124.90805097700002, -15.01262786299992],
              [124.90015709700003, -14.995700778999947],
              [124.89714603000004, -14.990980726999908],
              [124.89063561300009, -14.989841403999947],
              [124.87468509200005, -14.992120049999926],
              [124.86988366000003, -14.990980726999908],
              [124.86378014400009, -14.972588799999926],
              [124.871429884, -14.95671965899993],
              [124.88697350400003, -14.95281340899993],
              [124.90398196700005, -14.97039153399993],
              [124.90691165500004, -14.96103280999995],
              [124.91130618600005, -14.952243747999944],
              [124.91716556100005, -14.944105726999908],
              [124.92457116000003, -14.936293226999908],
              [124.92847741000003, -14.944105726999908],
              [124.93189537900003, -14.954685153999947],
              [124.93262780000009, -14.965427341999941],
              [124.92823326900009, -14.97356536299992],
            ],
          ],
          [
            [
              [135.76675385300007, -14.868209643999933],
              [135.7645079360001, -14.890059442999927],
              [135.76267882900004, -14.900901502999943],
              [135.7465776460001, -14.897361959999955],
              [135.72700816100007, -14.895596990999934],
              [135.70520121800007, -14.91311282199996],
              [135.69255271400004, -14.908794325999907],
              [135.6872456100001, -14.902891910999926],
              [135.698473906, -14.895193630999927],
              [135.703949415, -14.887872002999927],
              [135.7151935500001, -14.880022234999956],
              [135.720700642, -14.867019016999905],
              [135.71947862700006, -14.860127005999914],
              [135.71050714900002, -14.858752226999911],
              [135.70806051300008, -14.853040843999906],
              [135.71519786600004, -14.850872920999905],
              [135.720088272, -14.841026281999916],
              [135.72782866600005, -14.834526971999935],
              [135.749222702, -14.83846626399992],
              [135.7606347520001, -14.849888870999905],
              [135.76675385300007, -14.868209643999933],
            ],
          ],
          [
            [
              [125.19507897200003, -14.470147393999923],
              [125.20639082100001, -14.47356536299992],
              [125.20875084700003, -14.481622002999927],
              [125.20053144600001, -14.510430596999925],
              [125.18189537900003, -14.534274997999944],
              [125.17774498800009, -14.542168877999927],
              [125.18140709700003, -14.55282968499995],
              [125.19922936300009, -14.578301690999922],
              [125.20492597700002, -14.59303150799991],
              [125.19288170700008, -14.595879815999922],
              [125.16960696700005, -14.61109791499996],
              [125.16529381600003, -14.610772393999923],
              [125.16138756600003, -14.607842705999929],
              [125.15357506600003, -14.610935153999947],
              [125.14698326900009, -14.617120049999926],
              [125.14763431100005, -14.624118747999944],
              [125.15162194100003, -14.631931247999944],
              [125.14991295700008, -14.63844166499996],
              [125.14454186300009, -14.643975518999923],
              [125.13746178500003, -14.647637627999927],
              [125.12712649800005, -14.628024997999944],
              [125.12061608200008, -14.618340752999927],
              [125.11345462300005, -14.61419036299992],
              [125.10377037900003, -14.61646900799991],
              [125.09644616000003, -14.619805596999925],
              [125.09156334700003, -14.618584893999923],
              [125.08961022200003, -14.607354424999926],
              [125.09473717500009, -14.579196872999944],
              [125.09644616000003, -14.549004815999922],
              [125.10222415500004, -14.538995049999926],
              [125.11524498800009, -14.542168877999927],
              [125.12916100400003, -14.551364841999941],
              [125.13746178500003, -14.559014580999929],
              [125.13550866000003, -14.541273695999905],
              [125.13892662900003, -14.509698174999926],
              [125.13054446700005, -14.511163018999923],
              [125.115570509, -14.496840101999908],
              [125.12281334700003, -14.481215101999908],
              [125.14087975400003, -14.466973565999922],
              [125.15788821700005, -14.456475518999923],
              [125.15284264400009, -14.443780205999929],
              [125.16065514400009, -14.437920830999929],
              [125.17188561300009, -14.440606377999927],
              [125.17774498800009, -14.45281340899993],
              [125.17847741000003, -14.46103280999995],
              [125.18140709700003, -14.466403903999947],
              [125.18677819100003, -14.469333591999941],
              [125.19507897200003, -14.470147393999923],
            ],
          ],
          [
            [
              [136.80746504, -13.818536065999922],
              [136.80811608200008, -13.812920830999929],
              [136.81031334700003, -13.80828215899993],
              [136.81397545700008, -13.80445728999996],
              [136.81812584700003, -13.801364841999941],
              [136.81169681100005, -13.808851820999905],
              [136.8090926440001, -13.81340911299992],
              [136.80746504, -13.818536065999922],
            ],
          ],
          [
            [
              [136.28687584700003, -13.705824476999908],
              [136.28825931100005, -13.71884530999995],
              [136.2900496750001, -13.724541924999926],
              [136.28858483200008, -13.72861093499995],
              [136.28003991000003, -13.736504815999922],
              [136.26872806100005, -13.740492445999905],
              [136.25798587300005, -13.739434502999927],
              [136.24952233200008, -13.74228280999995],
              [136.2451278000001, -13.75758228999996],
              [136.26042728000004, -13.758070570999905],
              [136.2675887380001, -13.76653411299992],
              [136.27222741000003, -13.778903903999947],
              [136.28003991000003, -13.791761976999908],
              [136.26140384200005, -13.793552341999941],
              [136.25416100400003, -13.806084893999923],
              [136.25114993600005, -13.823663018999923],
              [136.2451278000001, -13.83953215899993],
              [136.23609459700003, -13.847263278999947],
              [136.2226668630001, -13.85320403399993],
              [136.20850670700008, -13.855889580999929],
              [136.19743899800005, -13.85320403399993],
              [136.20484459700003, -13.846368096999925],
              [136.2055770190001, -13.840264580999929],
              [136.2055770190001, -13.835381768999923],
              [136.20679772200003, -13.830743096999925],
              [136.21111087300005, -13.82594166499996],
              [136.20232181100005, -13.812920830999929],
              [136.18628991000003, -13.77312590899993],
              [136.17701256600003, -13.763848565999922],
              [136.15349368600005, -13.770684502999927],
              [136.15113366000003, -13.794040622999944],
              [136.15650475400003, -13.82122161299992],
              [136.15650475400003, -13.83953215899993],
              [136.1230574880001, -13.824883721999925],
              [136.11670983200008, -13.816664320999905],
              [136.11475670700008, -13.72356536299992],
              [136.15162194100003, -13.740899346999925],
              [136.164886915, -13.742364190999922],
              [136.17017662900003, -13.72665780999995],
              [136.17335045700008, -13.70712655999995],
              [136.18238366000003, -13.68645598799992],
              [136.1953231130001, -13.66961028399993],
              [136.21111087300005, -13.66139088299991],
              [136.22022545700008, -13.662530205999929],
              [136.23422285200002, -13.666436455999929],
              [136.2470809250001, -13.672051690999922],
              [136.25269616000003, -13.678480726999908],
              [136.25798587300005, -13.690036716999941],
              [136.26978600400003, -13.697198174999926],
              [136.28150475400003, -13.701755466999941],
              [136.28687584700003, -13.705824476999908],
            ],
          ],
          [
            [
              [136.951508009, -14.181573174999926],
              [136.94752037900003, -14.183851820999905],
              [136.94312584700003, -14.182386976999908],
              [136.93962649800005, -14.182386976999908],
              [136.93726647200003, -14.189060153999947],
              [136.93775475400003, -14.19622161299992],
              [136.94288170700008, -14.207207940999922],
              [136.94410241000003, -14.21298593499995],
              [136.9477645190001, -14.215508721999925],
              [136.95460045700008, -14.22389088299991],
              [136.95883222700002, -14.232679945999905],
              [136.95460045700008, -14.236748955999929],
              [136.94125410200002, -14.24195728999996],
              [136.9379988940001, -14.25400155999995],
              [136.94214928500003, -14.267754815999922],
              [136.951508009, -14.277764580999929],
              [136.9394637380001, -14.273858330999929],
              [136.932953321, -14.276543877999927],
              [136.931976759, -14.28329843499995],
              [136.93726647200003, -14.291436455999929],
              [136.92457116000003, -14.282403252999927],
              [136.91358483200008, -14.279961846999925],
              [136.90577233200008, -14.28525155999995],
              [136.90308678500003, -14.29892343499995],
              [136.86784915500004, -14.279880466999941],
              [136.8515731130001, -14.275567315999922],
              [136.83545983200008, -14.28525155999995],
              [136.82447350400003, -14.274102471999925],
              [136.80494225400003, -14.267836195999905],
              [136.76286868600005, -14.264825127999927],
              [136.74561608200008, -14.258070570999905],
              [136.73308353000004, -14.256117445999905],
              [136.72193444100003, -14.26100025799991],
              [136.680511915, -14.28525155999995],
              [136.63941491000003, -14.28020598799992],
              [136.46078535200002, -14.216403903999947],
              [136.45533287900003, -14.213067315999922],
              [136.43775475400003, -14.198418877999927],
              [136.4267684250001, -14.195245049999926],
              [136.4160262380001, -14.196384372999944],
              [136.38070722700002, -14.20680103999996],
              [136.35718834700003, -14.22551848799992],
              [136.34131920700008, -14.230075778999947],
              [136.3379012380001, -14.231540622999944],
              [136.32984459700003, -14.233086846999925],
              [136.32406660200002, -14.229587497999944],
              [136.32781009200005, -14.216403903999947],
              [136.33521569100003, -14.20875416499996],
              [136.35816491000003, -14.19654713299991],
              [136.3681746750001, -14.189060153999947],
              [136.39828535200002, -14.176039320999905],
              [136.41130618600005, -14.16578541499996],
              [136.42139733200008, -14.139336846999925],
              [136.43083743600005, -14.129571221999925],
              [136.43734785200002, -14.12037525799991],
              [136.4336043630001, -14.109958591999941],
              [136.4223738940001, -14.088555596999925],
              [136.41553795700008, -14.057305596999925],
              [136.40967858200008, -13.997247002999927],
              [136.410980665, -13.96493905999995],
              [136.4262801440001, -13.908461195999905],
              [136.4301863940001, -13.877129815999922],
              [136.42505944100003, -13.86451588299991],
              [136.4150496750001, -13.84889088299991],
              [136.4072371750001, -13.832696221999925],
              [136.40967858200008, -13.818536065999922],
              [136.42457116000003, -13.81031666499996],
              [136.4399520190001, -13.816827080999929],
              [136.464203321, -13.83953215899993],
              [136.47217858200008, -13.833428643999923],
              [136.49775950100002, -13.834098059999917],
              [136.51216933600006, -13.834081574999914],
              [136.52566920800007, -13.818323620999934],
              [136.5195418630001, -13.80445728999996],
              [136.530145307, -13.785955776999913],
              [136.5361434250001, -13.79029713299991],
              [136.54810631600003, -13.810723565999922],
              [136.5610457690001, -13.819756768999923],
              [136.57406660200002, -13.798028252999927],
              [136.5791121750001, -13.802911065999922],
              [136.5947371750001, -13.81226978999996],
              [136.5947371750001, -13.784356377999927],
              [136.60808353000004, -13.79225025799991],
              [136.62273196700005, -13.787774346999925],
              [136.62859134200005, -13.77629973799992],
              [136.6157332690001, -13.763848565999922],
              [136.6084090500001, -13.77125416499996],
              [136.60303795700008, -13.754327080999929],
              [136.60075931100005, -13.736911716999941],
              [136.59351647200003, -13.72470468499995],
              [136.57406660200002, -13.72356536299992],
              [136.58073978000004, -13.713474216999941],
              [136.5825301440001, -13.70435963299991],
              [136.57829837300005, -13.697930596999925],
              [136.567230665, -13.695489190999922],
              [136.5722762380001, -13.686211846999925],
              [136.5800887380001, -13.681898695999905],
              [136.59009850400003, -13.681084893999923],
              [136.6020613940001, -13.681898695999905],
              [136.615570509, -13.684747002999927],
              [136.61841881600003, -13.68873463299991],
              [136.61646569100003, -13.692803643999923],
              [136.6157332690001, -13.695489190999922],
              [136.61670983200008, -13.699802341999941],
              [136.61491946700005, -13.71184661299992],
              [136.6157332690001, -13.715997002999927],
              [136.62094160200002, -13.71770598799992],
              [136.62614993600005, -13.715101820999905],
              [136.62964928500003, -13.711358330999929],
              [136.6294051440001, -13.709242445999905],
              [136.63404381600003, -13.70598723799992],
              [136.63786868600005, -13.699802341999941],
              [136.64421634200005, -13.696465752999927],
              [136.6567488940001, -13.70240650799991],
              [136.67448978000004, -13.674899997999944],
              [136.677093946, -13.664808851999908],
              [136.68181399800005, -13.657403252999927],
              [136.70655358200008, -13.65593840899993],
              [136.71827233200008, -13.64771900799991],
              [136.72535241000003, -13.664320570999905],
              [136.72413170700008, -13.68718840899993],
              [136.71412194100003, -13.707289320999905],
              [136.68433678500003, -13.72047291499996],
              [136.678070509, -13.731133721999925],
              [136.67652428500003, -13.743747653999947],
              [136.680511915, -13.75400155999995],
              [136.691742384, -13.761651299999926],
              [136.70337975400003, -13.763604424999926],
              [136.7148543630001, -13.763116143999923],
              [136.7255965500001, -13.763848565999922],
              [136.71892337300005, -13.770684502999927],
              [136.70460045700008, -13.791761976999908],
              [136.71265709700003, -13.806817315999922],
              [136.7148543630001, -13.818617445999905],
              [136.71851647200003, -13.82903411299992],
              [136.731781446, -13.83953215899993],
              [136.74496504, -13.844170830999929],
              [136.797211134, -13.85320403399993],
              [136.81421959700003, -13.84970468499995],
              [136.82837975400003, -13.840020440999922],
              [136.83806399800005, -13.82586028399993],
              [136.84164472700002, -13.808770440999922],
              [136.83936608200008, -13.801039320999905],
              [136.83366946700005, -13.797621351999908],
              [136.82601972700002, -13.797946872999944],
              [136.81918379, -13.800225518999923],
              [136.82496178500003, -13.794366143999923],
              [136.8271590500001, -13.791192315999922],
              [136.84164472700002, -13.750176690999922],
              [136.85621178500003, -13.757419528999947],
              [136.8867293630001, -13.75359465899993],
              [136.90308678500003, -13.75758228999996],
              [136.90886478000004, -13.764336846999925],
              [136.91684004, -13.777927341999941],
              [136.92335045700008, -13.793145440999922],
              [136.9243270190001, -13.805352471999925],
              [136.91570071700005, -13.81731536299992],
              [136.8857528000001, -13.84579843499995],
              [136.87525475400003, -13.860039971999925],
              [136.8559676440001, -13.915215752999927],
              [136.8227645190001, -13.90520598799992],
              [136.791351759, -13.91773853999996],
              [136.76832116000003, -13.94459400799991],
              [136.7597762380001, -13.977308851999908],
              [136.763031446, -13.996840101999908],
              [136.77076256600003, -14.004978122999944],
              [136.781586134, -14.009372653999947],
              [136.793793165, -14.017754815999922],
              [136.797211134, -14.018731377999927],
              [136.8056746750001, -14.023695570999905],
              [136.81080162900003, -14.02939218499995],
              [136.804047071, -14.031914971999925],
              [136.7949324880001, -14.033135674999926],
              [136.78785241000003, -14.03679778399993],
              [136.78296959700003, -14.04306405999995],
              [136.7802840500001, -14.051853122999944],
              [136.76490319100003, -14.045505466999941],
              [136.7544051440001, -14.050957940999922],
              [136.74968509200005, -14.06373463299991],
              [136.752289259, -14.079196872999944],
              [136.741547071, -14.066989841999941],
              [136.7295028000001, -14.061700127999927],
              [136.7168074880001, -14.063653252999927],
              [136.70460045700008, -14.072930596999925],
              [136.70980879, -14.085056247999944],
              [136.70923912900003, -14.09929778399993],
              [136.70460045700008, -14.126885674999926],
              [136.71607506600003, -14.165948174999926],
              [136.71827233200008, -14.178399346999925],
              [136.72339928500003, -14.185479424999926],
              [136.7363387380001, -14.18914153399993],
              [136.75212649800005, -14.190199476999908],
              [136.780609571, -14.18718840899993],
              [136.7841903000001, -14.186211846999925],
              [136.7822371750001, -14.18059661299992],
              [136.7802840500001, -14.164808851999908],
              [136.78923587300005, -14.149509372999944],
              [136.8105574880001, -14.15911223799992],
              [136.87183678500003, -14.20794036299992],
              [136.88070722700002, -14.208591403999947],
              [136.8925887380001, -14.19890715899993],
              [136.90121504, -14.188083591999941],
              [136.90837649800005, -14.176934502999927],
              [136.91358483200008, -14.16383228999996],
              [136.91675866000003, -14.14739348799992],
              [136.9243270190001, -14.14739348799992],
              [136.934906446, -14.15520598799992],
              [136.94890384200005, -14.154473565999922],
              [136.96412194100003, -14.149997653999947],
              [136.978851759, -14.14739348799992],
              [136.969574415, -14.15520598799992],
              [136.9619246750001, -14.16497161299992],
              [136.951508009, -14.181573174999926],
            ],
          ],
          [
            [
              [136.13591556100005, -13.43482838299991],
              [136.13542728000004, -13.40797291499996],
              [136.122336894, -13.393387946999951],
              [136.11898847700002, -13.374200127999927],
              [136.09498131600003, -13.360446872999944],
              [136.11784915500004, -13.36223723799992],
              [136.13402494600007, -13.386394695999911],
              [136.1484070460001, -13.38989605799992],
              [136.16334069100003, -13.411553643999923],
              [136.181000196, -13.439060153999947],
              [136.18433678500003, -13.445733330999929],
              [136.18897545700008, -13.451755466999941],
              [136.1977645190001, -13.45484791499996],
              [136.2031356130001, -13.461195570999905],
              [136.19743899800005, -13.476495049999926],
              [136.17017662900003, -13.45598723799992],
              [136.17017662900003, -13.476495049999926],
              [136.15455162900003, -13.472914320999905],
              [136.15642337300005, -13.489353122999944],
              [136.16334069100003, -13.512790622999944],
              [136.1492628530001, -13.535072723999917],
              [136.142956443, -13.56045047799995],
              [136.13036716500005, -13.547318572999927],
              [136.13307410800007, -13.530693311999926],
              [136.1465705710001, -13.51321018099992],
              [136.1402790520001, -13.502710970999942],
              [136.13233483200008, -13.495293877999927],
              [136.1241071290001, -13.472084202999952],
              [136.13591556100005, -13.43482838299991],
            ],
          ],
          [
            [
              [136.81695553200007, -12.076077101999942],
              [136.82200382100007, -12.08444888799994],
              [136.82424320400003, -12.104028124999957],
              [136.82146135200003, -12.120831756999905],
              [136.82935631600003, -12.132256768999923],
              [136.82097415500004, -12.13795338299991],
              [136.8129988940001, -12.136163018999923],
              [136.80746504, -12.126560153999947],
              [136.79706918400007, -12.108354610999925],
              [136.79910508500006, -12.08455848199992],
              [136.81695553200007, -12.076077101999942],
            ],
          ],
          [
            [
              [132.387543165, -12.071872653999947],
              [132.41187584700003, -12.08367278399993],
              [132.41578209700003, -12.11028411299992],
              [132.40577233200008, -12.132989190999922],
              [132.387543165, -12.133396091999941],
              [132.3398543630001, -12.09856536299992],
              [132.344574415, -12.085870049999926],
              [132.357758009, -12.07781340899993],
              [132.3740340500001, -12.073418877999927],
              [132.387543165, -12.071872653999947],
            ],
          ],
          [
            [
              [136.29021243600005, -11.975681247999944],
              [136.31625410200002, -11.987399997999944],
              [136.3027449880001, -12.013278903999947],
              [136.26929772200003, -12.038995049999926],
              [136.23560631600003, -12.050713799999926],
              [136.21827233200008, -12.054131768999923],
              [136.2080184250001, -12.06218840899993],
              [136.19874108200008, -12.071384372999944],
              [136.18433678500003, -12.078057549999926],
              [136.16944420700008, -12.078383070999905],
              [136.15105228000004, -12.074476820999905],
              [136.13550866000003, -12.06731536299992],
              [136.12916100400003, -12.05754973799992],
              [136.13404381600003, -12.047946872999944],
              [136.13493899800005, -12.037774346999925],
              [136.1328231130001, -12.027276299999926],
              [136.12916100400003, -12.016696872999944],
              [136.14437910200002, -12.024102471999925],
              [136.153656446, -12.031914971999925],
              [136.16187584700003, -12.034763278999947],
              [136.17359459700003, -12.026950778999947],
              [136.19060306100005, -12.006280205999929],
              [136.200043165, -11.999932549999926],
              [136.21111087300005, -12.002373955999929],
              [136.208343946, -12.006117445999905],
              [136.20492597700002, -12.015801690999922],
              [136.20386803500003, -12.025811455999929],
              [136.2080184250001, -12.030368747999944],
              [136.21745853000004, -12.029229424999926],
              [136.23324629, -12.024590752999927],
              [136.24203535200002, -12.02353280999995],
              [136.2597762380001, -12.016045830999929],
              [136.27947024800005, -11.983086846999925],
              [136.29021243600005, -11.975681247999944],
            ],
          ],
          [
            [
              [136.464203321, -11.893731377999927],
              [136.47055097700002, -11.868259372999944],
              [136.47185306100005, -11.83961353999996],
              [136.47779381600003, -11.81422291499996],
              [136.4985457690001, -11.79810963299991],
              [136.496918165, -11.81650155999995],
              [136.47803795700008, -11.865817966999941],
              [136.47836347700002, -11.875583591999941],
              [136.481781446, -11.882419528999947],
              [136.48324629, -11.889418226999908],
              [136.47803795700008, -11.899834893999923],
              [136.4726668630001, -11.905450127999927],
              [136.469086134, -11.906508070999905],
              [136.46648196700005, -11.902764580999929],
              [136.464203321, -11.893731377999927],
            ],
          ],
          [
            [
              [136.60523522200003, -11.746026299999926],
              [136.618500196, -11.735446872999944],
              [136.62370853000004, -11.736586195999905],
              [136.62232506600003, -11.745212497999944],
              [136.6157332690001, -11.756524346999925],
              [136.5957137380001, -11.774183851999908],
              [136.58659915500004, -11.784356377999927],
              [136.58155358200008, -11.79810963299991],
              [136.56128991000003, -11.793633721999925],
              [136.52800540500004, -11.79851653399993],
              [136.5195418630001, -11.79070403399993],
              [136.52898196700005, -11.776543877999927],
              [136.5371199880001, -11.77312590899993],
              [136.5571395190001, -11.77703215899993],
              [136.57016035200002, -11.77320728999996],
              [136.58423912900003, -11.764336846999925],
              [136.60523522200003, -11.746026299999926],
            ],
          ],
          [
            [
              [135.95590564500003, -11.70716452399995],
              [135.951528102, -11.683485400999928],
              [135.980865246, -11.661368186999937],
              [136.02405066100005, -11.640872120999916],
              [136.05520549200003, -11.650047770999947],
              [136.0215604340001, -11.687457054999925],
              [136.00604533, -11.708677842999919],
              [135.9861769790001, -11.716368852999949],
              [135.95590564500003, -11.70716452399995],
            ],
          ],
          [
            [
              [132.61980228000004, -11.646661065999922],
              [132.6411238940001, -11.644707940999922],
              [132.6455184250001, -11.65016041499996],
              [132.64771569100003, -11.667168877999927],
              [132.645843946, -11.678887627999927],
              [132.6406356130001, -11.69117603999996],
              [132.6337996750001, -11.701918226999908],
              [132.62720787900003, -11.70875416499996],
              [132.61003665500004, -11.715508721999925],
              [132.58383222700002, -11.720147393999923],
              [132.55884850400003, -11.719170830999929],
              [132.54468834700003, -11.70875416499996],
              [132.528168165, -11.691664320999905],
              [132.51197350400003, -11.670586846999925],
              [132.5087996750001, -11.649590752999927],
              [132.53101647200003, -11.632989190999922],
              [132.54517662900003, -11.631605726999908],
              [132.55689537900003, -11.63567473799992],
              [132.56804446700005, -11.64185963299991],
              [132.57935631600003, -11.646661065999922],
              [132.59197024800005, -11.648614190999922],
              [132.61980228000004, -11.646661065999922],
            ],
          ],
          [
            [
              [136.42335045700008, -11.50953541499996],
              [136.4531356130001, -11.489353122999944],
              [136.46851647200003, -11.476006768999923],
              [136.47803795700008, -11.461114190999922],
              [136.4834090500001, -11.48447030999995],
              [136.47486412900003, -11.50595468499995],
              [136.457367384, -11.523858330999929],
              [136.40251712300005, -11.55478280999995],
              [136.39234459700003, -11.557305596999925],
              [136.3891707690001, -11.562432549999926],
              [136.37566165500004, -11.592054945999905],
              [136.3252059250001, -11.614678643999923],
              [136.31617272200003, -11.624118747999944],
              [136.31031334700003, -11.626153252999927],
              [136.30534915500004, -11.62468840899993],
              [136.30005944100003, -11.62086353999996],
              [136.29761803500003, -11.616387627999927],
              [136.28467858200008, -11.62476978999996],
              [136.27328535200002, -11.639092705999929],
              [136.25855553500003, -11.65211353999996],
              [136.23218834700003, -11.660332940999922],
              [136.2304793630001, -11.65211353999996],
              [136.195648634, -11.680433851999908],
              [136.17701256600003, -11.688246351999908],
              [136.181976759, -11.682793877999927],
              [136.182953321, -11.678155205999929],
              [136.18287194100003, -11.67310963299991],
              [136.19019616000003, -11.646416924999926],
              [136.19849694100003, -11.63958098799992],
              [136.21159915500004, -11.636163018999923],
              [136.23218834700003, -11.626153252999927],
              [136.2426863940001, -11.612481377999927],
              [136.25367272200003, -11.59189218499995],
              [136.26685631600003, -11.572930596999925],
              [136.28345787900003, -11.564711195999905],
              [136.28630618600005, -11.573663018999923],
              [136.30201256600003, -11.59107838299991],
              [136.31950931100005, -11.602959893999923],
              [136.32781009200005, -11.59547291499996],
              [136.3325301440001, -11.587090752999927],
              [136.3681746750001, -11.54420338299991],
              [136.3711043630001, -11.547621351999908],
              [136.37566165500004, -11.55046965899993],
              [136.37964928500003, -11.53606536299992],
              [136.39380944100003, -11.524834893999923],
              [136.42335045700008, -11.50953541499996],
            ],
          ],
          [
            [
              [130.53679446700005, -11.705010674999926],
              [130.54859459700003, -11.701429945999905],
              [130.57496178500003, -11.715427341999941],
              [130.61988366000003, -11.749118747999944],
              [130.63160241000003, -11.762383721999925],
              [130.63502037900003, -11.768161716999941],
              [130.6328231130001, -11.787530205999929],
              [130.62818444100003, -11.804620049999926],
              [130.61736087300005, -11.813164971999925],
              [130.5732528000001, -11.83098723799992],
              [130.52100670700008, -11.829522393999923],
              [130.49634850400003, -11.839043877999927],
              [130.47046959700003, -11.824802341999941],
              [130.43873131600003, -11.811618747999944],
              [130.40593509200005, -11.801853122999944],
              [130.3759871750001, -11.79810963299991],
              [130.36011803500003, -11.793715101999908],
              [130.3369246750001, -11.774590752999927],
              [130.32105553500003, -11.770196221999925],
              [130.30632571700005, -11.772556247999944],
              [130.281586134, -11.782321872999944],
              [130.23511803500003, -11.789727471999925],
              [130.1469832690001, -11.824802341999941],
              [130.11890709700003, -11.82781340899993],
              [130.08423912900003, -11.82781340899993],
              [130.05347741000003, -11.822849216999941],
              [130.0371199880001, -11.811211846999925],
              [130.02409915500004, -11.795179945999905],
              [130.01832116000003, -11.78525155999995],
              [130.0166121750001, -11.77703215899993],
              [130.02295983200008, -11.762383721999925],
              [130.03150475400003, -11.759209893999923],
              [130.054047071, -11.76336028399993],
              [130.06959069100003, -11.75562916499996],
              [130.07154381600003, -11.736748955999929],
              [130.06430097700002, -11.691338799999926],
              [130.07154381600003, -11.67115650799991],
              [130.08814537900003, -11.67359791499996],
              [130.11898847700002, -11.694512627999927],
              [130.14568118600005, -11.699395440999922],
              [130.167328321, -11.69264088299991],
              [130.18539472700002, -11.676527601999908],
              [130.201508009, -11.653497002999927],
              [130.194672071, -11.631117445999905],
              [130.1840926440001, -11.547295830999929],
              [130.19410241000003, -11.533868096999925],
              [130.198578321, -11.519952080999929],
              [130.19849694100003, -11.506605726999908],
              [130.19410241000003, -11.495212497999944],
              [130.18572024800005, -11.48642343499995],
              [130.17546634200005, -11.483575127999927],
              [130.16293379, -11.485121351999908],
              [130.1469832690001, -11.489027601999908],
              [130.17058353000004, -11.44703541499996],
              [130.181000196, -11.434340101999908],
              [130.19353274800005, -11.424411716999941],
              [130.2177840500001, -11.409600518999923],
              [130.22828209700003, -11.39967213299991],
              [130.2587996750001, -11.34889088299991],
              [130.26978600400003, -11.338148695999905],
              [130.2895613940001, -11.333103122999944],
              [130.3086043630001, -11.33294036299992],
              [130.32699629, -11.33017343499995],
              [130.34498131600003, -11.317071221999925],
              [130.349945509, -11.339450778999947],
              [130.36011803500003, -11.366387627999927],
              [130.37378991000003, -11.393731377999927],
              [130.39918053500003, -11.433038018999923],
              [130.39861087300005, -11.444512627999927],
              [130.38648522200003, -11.46851978999996],
              [130.38347415500004, -11.484307549999926],
              [130.38648522200003, -11.519707940999922],
              [130.396820509, -11.534600518999923],
              [130.44556725400003, -11.567152601999908],
              [130.46168053500003, -11.592054945999905],
              [130.46501712300005, -11.62004973799992],
              [130.4629012380001, -11.65007903399993],
              [130.45679772200003, -11.67669036299992],
              [130.44800866000003, -11.694512627999927],
              [130.44800866000003, -11.701348565999922],
              [130.45883222700002, -11.697686455999929],
              [130.4658309250001, -11.693291924999926],
              [130.4731551440001, -11.689711195999905],
              [130.48552493600005, -11.688246351999908],
              [130.49773196700005, -11.690036716999941],
              [130.53012129, -11.699802341999941],
              [130.53679446700005, -11.705010674999926],
            ],
          ],
          [
            [
              [131.53736412900003, -11.413262627999927],
              [131.53891035200002, -11.446058851999908],
              [131.53663170700008, -11.463067315999922],
              [131.53044681100005, -11.474786065999922],
              [131.51937910200002, -11.478773695999905],
              [131.49675540500004, -11.471123955999929],
              [131.48267662900003, -11.474786065999922],
              [131.471039259, -11.493340752999927],
              [131.4609481130001, -11.526950778999947],
              [131.45826256600003, -11.56218840899993],
              [131.46900475400003, -11.585870049999926],
              [131.46900475400003, -11.578383070999905],
              [131.473968946, -11.600192966999941],
              [131.45582116000003, -11.608086846999925],
              [131.43238366000003, -11.607028903999947],
              [131.42058353000004, -11.601983330999929],
              [131.41773522200003, -11.59661223799992],
              [131.3969832690001, -11.58212655999995],
              [131.38656660200002, -11.57781340899993],
              [131.37810306100005, -11.58407968499995],
              [131.32593834700003, -11.681898695999905],
              [131.30298912900003, -11.701104424999926],
              [131.29314212300005, -11.724053643999923],
              [131.28199303500003, -11.72779713299991],
              [131.26872806100005, -11.727959893999923],
              [131.25733483200008, -11.729180596999925],
              [131.22877037900003, -11.744886976999908],
              [131.2148543630001, -11.756280205999929],
              [131.2089949880001, -11.766778252999927],
              [131.201508009, -11.77516041499996],
              [131.098968946, -11.828383070999905],
              [130.97999108200008, -11.926446221999925],
              [130.96119225400003, -11.933851820999905],
              [130.9414168630001, -11.927911065999922],
              [130.92212975400003, -11.90048593499995],
              [130.894867384, -11.87786223799992],
              [130.86003665500004, -11.859958591999941],
              [130.80844160200002, -11.84270598799992],
              [130.76042728000004, -11.814060153999947],
              [130.75277754, -11.811211846999925],
              [130.735199415, -11.807793877999927],
              [130.71257571700005, -11.799493096999925],
              [130.69060306100005, -11.78834400799991],
              [130.67457116000003, -11.77703215899993],
              [130.67351321700005, -11.772881768999923],
              [130.681976759, -11.76726653399993],
              [130.6806746750001, -11.76336028399993],
              [130.67546634200005, -11.760511976999908],
              [130.66423587300005, -11.758396091999941],
              [130.66032962300005, -11.756524346999925],
              [130.61280358200008, -11.71656666499996],
              [130.58228600400003, -11.697930596999925],
              [130.5747176440001, -11.68954843499995],
              [130.56373131600003, -11.672133070999905],
              [130.55844160200002, -11.667168877999927],
              [130.53785241000003, -11.661553643999923],
              [130.51490319100003, -11.65789153399993],
              [130.4965926440001, -11.649509372999944],
              [130.48894290500004, -11.629571221999925],
              [130.48585045700008, -11.56218840899993],
              [130.48210696700005, -11.54420338299991],
              [130.4785262380001, -11.54070403399993],
              [130.46607506600003, -11.533623955999929],
              [130.46168053500003, -11.529961846999925],
              [130.43775475400003, -11.499200127999927],
              [130.43034915500004, -11.484307549999926],
              [130.40772545700008, -11.37468840899993],
              [130.4062606130001, -11.354913018999923],
              [130.40414472700002, -11.350030205999929],
              [130.39958743600005, -11.346774997999944],
              [130.394867384, -11.342461846999925],
              [130.39275149800005, -11.334405205999929],
              [130.3935653000001, -11.323663018999923],
              [130.395843946, -11.314060153999947],
              [130.40015709700003, -11.305108330999929],
              [130.4062606130001, -11.29656340899993],
              [130.38038170700008, -11.269138278999947],
              [130.3701278000001, -11.25204843499995],
              [130.36597741000003, -11.232354424999926],
              [130.36744225400003, -11.204278252999927],
              [130.37281334700003, -11.183770440999922],
              [130.383148634, -11.167901299999926],
              [130.40015709700003, -11.15325286299992],
              [130.43637129, -11.202732028999947],
              [130.50652103000004, -11.27703215899993],
              [130.5161238940001, -11.29656340899993],
              [130.525726759, -11.289320570999905],
              [130.53492272200003, -11.280043226999908],
              [130.54517662900003, -11.27239348799992],
              [130.55844160200002, -11.269952080999929],
              [130.573578321, -11.275323174999926],
              [130.58716881600003, -11.28679778399993],
              [130.59636478000004, -11.301527601999908],
              [130.59880618600005, -11.317071221999925],
              [130.59050540500004, -11.33326588299991],
              [130.56202233200008, -11.36109791499996],
              [130.55844160200002, -11.379164320999905],
              [130.56617272200003, -11.39462655999995],
              [130.57781009200005, -11.397067966999941],
              [130.59001712300005, -11.392185153999947],
              [130.59880618600005, -11.385918877999927],
              [130.63892662900003, -11.34384530999995],
              [130.65845787900003, -11.33131275799991],
              [130.668304884, -11.34498463299991],
              [130.65381920700008, -11.377536716999941],
              [130.65772545700008, -11.38404713299991],
              [130.668304884, -11.392185153999947],
              [130.69166100400003, -11.42278411299992],
              [130.69556725400003, -11.434340101999908],
              [130.7236434250001, -11.384698174999926],
              [130.78467858200008, -11.36842213299991],
              [130.84546959700003, -11.36028411299992],
              [130.87322024800005, -11.334405205999929],
              [130.888031446, -11.313164971999925],
              [130.9209090500001, -11.309340101999908],
              [130.95386803500003, -11.316338799999926],
              [130.96859785200002, -11.327569268999923],
              [130.9751082690001, -11.336114190999922],
              [131.003265821, -11.34742603999996],
              [131.0097762380001, -11.354913018999923],
              [131.01872806100005, -11.400567315999922],
              [131.02328535200002, -11.413262627999927],
              [131.02947024800005, -11.399834893999923],
              [131.0488387380001, -11.315036716999941],
              [131.06177819100003, -11.30592213299991],
              [131.079437696, -11.300225518999923],
              [131.09913170700008, -11.290459893999923],
              [131.13453209700003, -11.257745049999926],
              [131.15308678500003, -11.24928150799991],
              [131.1611434250001, -11.26653411299992],
              [131.16293379, -11.28883228999996],
              [131.16822350400003, -11.310153903999947],
              [131.176605665, -11.32903411299992],
              [131.21794681100005, -11.391045830999929],
              [131.2192488940001, -11.39967213299991],
              [131.230804884, -11.390801690999922],
              [131.22868899800005, -11.371026299999926],
              [131.2158309250001, -11.338148695999905],
              [131.21509850400003, -11.32789478999996],
              [131.21656334700003, -11.30673593499995],
              [131.2158309250001, -11.29656340899993],
              [131.21241295700008, -11.296075127999927],
              [131.20582116000003, -11.29615650799991],
              [131.19890384200005, -11.295098565999922],
              [131.19516035200002, -11.290459893999923],
              [131.1958113940001, -11.284274997999944],
              [131.20093834700003, -11.273370049999926],
              [131.20533287900003, -11.246514580999929],
              [131.2148543630001, -11.226169528999947],
              [131.22999108200008, -11.208103122999944],
              [131.24984785200002, -11.194756768999923],
              [131.2744246750001, -11.189629815999922],
              [131.2920028000001, -11.197523695999905],
              [131.30241946700005, -11.215997002999927],
              [131.305023634, -11.242608330999929],
              [131.3007918630001, -11.246677341999941],
              [131.29281660200002, -11.25872161299992],
              [131.29021243600005, -11.271416924999926],
              [131.30144290500004, -11.27743905999995],
              [131.31519616000003, -11.272637627999927],
              [131.3212996750001, -11.261976820999905],
              [131.32488040500004, -11.250258070999905],
              [131.33130944100003, -11.242608330999929],
              [131.34343509200005, -11.240980726999908],
              [131.35181725400003, -11.24618905999995],
              [131.3593856130001, -11.25286223799992],
              [131.36939537900003, -11.256280205999929],
              [131.38200931100005, -11.253838799999926],
              [131.40219160200002, -11.24382903399993],
              [131.41431725400003, -11.242608330999929],
              [131.4277449880001, -11.24968840899993],
              [131.436859571, -11.26490650799991],
              [131.439789259, -11.284274997999944],
              [131.434906446, -11.303399346999925],
              [131.45582116000003, -11.309747002999927],
              [131.46045983200008, -11.33098723799992],
              [131.46070397200003, -11.35751718499995],
              [131.46989993600005, -11.382256768999923],
              [131.4746199880001, -11.390557549999926],
              [131.48015384200005, -11.395684502999927],
              [131.48267662900003, -11.389092705999929],
              [131.50318444100003, -11.379164320999905],
              [131.517914259, -11.38062916499996],
              [131.5278426440001, -11.386651299999926],
              [131.5337020190001, -11.39739348799992],
              [131.53736412900003, -11.413262627999927],
            ],
          ],
          [
            [
              [136.7636850770001, -11.04007049799992],
              [136.74715157700007, -11.093376206999949],
              [136.73363813000003, -11.13765191799996],
              [136.7200881120001, -11.174425354999926],
              [136.71648196700005, -11.206231377999927],
              [136.70818118600005, -11.209567966999941],
              [136.70460045700008, -11.211602471999925],
              [136.70240319100003, -11.211358330999929],
              [136.680024429, -11.223023928999908],
              [136.66873688700002, -11.256050233999929],
              [136.63911015100007, -11.286166855999909],
              [136.62712649800005, -11.330254815999922],
              [136.611867104, -11.334231445999933],
              [136.589947822, -11.377764569999954],
              [136.54286119000005, -11.429655410999942],
              [136.53529012600006, -11.443169189999935],
              [136.52461451800002, -11.446964216999959],
              [136.5222860230001, -11.439487724999935],
              [136.51614945300003, -11.43427571399991],
              [136.50928948500007, -11.437303224999937],
              [136.49409793200005, -11.455346281999937],
              [136.47801939800001, -11.447933862999946],
              [136.494765282, -11.435125554999956],
              [136.5000507630001, -11.422372054999926],
              [136.48243585, -11.412721096999917],
              [136.4976434680001, -11.398424637999938],
              [136.52961291300005, -11.376562547999924],
              [136.5605574880001, -11.354913018999923],
              [136.56373131600003, -11.345879815999922],
              [136.58033287900003, -11.32740650799991],
              [136.5788762850001, -11.303700559999925],
              [136.58565270000008, -11.284945863999951],
              [136.6167072830001, -11.23610483199991],
              [136.653871772, -11.186454964999939],
              [136.688028787, -11.177596051999956],
              [136.7000443400001, -11.140086541999949],
              [136.7098685200001, -11.120558385999914],
              [136.71126871, -11.09658146299995],
              [136.72291100400003, -11.086358330999929],
              [136.7310354130001, -11.079236089999938],
              [136.734775894, -11.064228440999955],
              [136.71866713500003, -11.050836081999933],
              [136.738617384, -11.029717705999929],
              [136.74244225400003, -11.032810153999947],
              [136.74561608200008, -11.034356377999927],
              [136.74887129, -11.035414320999905],
              [136.752289259, -11.03720468499995],
              [136.75603274800005, -11.026788018999923],
              [136.76246178500003, -11.01930103999996],
              [136.7636850770001, -11.04007049799992],
            ],
          ],
          [
            [
              [132.48943118600005, -11.160088799999926],
              [132.49382571700005, -11.150648695999905],
              [132.5019637380001, -11.146905205999929],
              [132.51099694100003, -11.14462655999995],
              [132.51734459700003, -11.13958098799992],
              [132.517914259, -11.127211195999905],
              [132.51148522200003, -11.08684661299992],
              [132.50709069100003, -11.07822030999995],
              [132.49537194100003, -11.07390715899993],
              [132.48707116000003, -11.063571872999944],
              [132.48023522200003, -11.051039320999905],
              [132.4726668630001, -11.040215752999927],
              [132.468109571, -11.029961846999925],
              [132.4824324880001, -11.03215911299992],
              [132.50114993600005, -11.03997161299992],
              [132.51050866000003, -11.047051690999922],
              [132.5180770190001, -11.04078541499996],
              [132.53467858200008, -11.037774346999925],
              [132.5512801440001, -11.032403252999927],
              [132.558929884, -11.019789320999905],
              [132.5605574880001, -11.000176690999922],
              [132.56666100400003, -10.98211028399993],
              [132.57886803500003, -10.970147393999923],
              [132.59929446700005, -10.968357028999947],
              [132.59546959700003, -10.981622002999927],
              [132.58228600400003, -10.99968840899993],
              [132.57935631600003, -11.01262786299992],
              [132.581390821, -11.025648695999905],
              [132.586273634, -11.039239190999922],
              [132.59929446700005, -11.063897393999923],
              [132.59302819100003, -11.063897393999923],
              [132.59945722700002, -11.073011976999908],
              [132.60621178500003, -11.085544528999947],
              [132.6113387380001, -11.098402601999908],
              [132.61353600400003, -11.108819268999923],
              [132.61060631600003, -11.12273528399993],
              [132.60368899800005, -11.124607028999947],
              [132.59449303500003, -11.124607028999947],
              [132.58570397200003, -11.132745049999926],
              [132.5820418630001, -11.153415622999944],
              [132.59693444100003, -11.158786716999941],
              [132.61841881600003, -11.161553643999923],
              [132.63404381600003, -11.173760674999926],
              [132.61255944100003, -11.185723565999922],
              [132.61255944100003, -11.19898853999996],
              [132.621429884, -11.21770598799992],
              [132.62720787900003, -11.246026299999926],
              [132.62183678500003, -11.272067966999941],
              [132.60075931100005, -11.31568775799991],
              [132.59929446700005, -11.34498463299991],
              [132.56519616000003, -11.310804945999905],
              [132.560883009, -11.276788018999923],
              [132.54997806100005, -11.246270440999922],
              [132.534515821, -11.218926690999922],
              [132.493011915, -11.16692473799992],
              [132.48943118600005, -11.160088799999926],
            ],
          ],
          [
            [
              [142.25538170700008, -10.666680596999925],
              [142.27881920700008, -10.690524997999944],
              [142.282562696, -10.701348565999922],
              [142.28305097700002, -10.71453215899993],
              [142.28003991000003, -10.718926690999922],
              [142.2734481130001, -10.718357028999947],
              [142.26343834700003, -10.716241143999923],
              [142.2529403000001, -10.717217705999929],
              [142.23031660200002, -10.726006768999923],
              [142.2177840500001, -10.728122653999947],
              [142.2060653000001, -10.733086846999925],
              [142.19678795700008, -10.744724216999941],
              [142.19027754, -10.758477471999925],
              [142.18702233200008, -10.76962655999995],
              [142.153168165, -10.75562916499996],
              [142.1455184250001, -10.749200127999927],
              [142.13656660200002, -10.730645440999922],
              [142.121918165, -10.709567966999941],
              [142.1123153000001, -10.684340101999908],
              [142.1181746750001, -10.653497002999927],
              [142.12077884200005, -10.647881768999923],
              [142.1235457690001, -10.643649997999944],
              [142.12777754, -10.640801690999922],
              [142.14576256600003, -10.639092705999929],
              [142.14966881600003, -10.63648853999996],
              [142.1523543630001, -10.632012627999927],
              [142.15967858200008, -10.625664971999925],
              [142.17701256600003, -10.616306247999944],
              [142.1801863940001, -10.615411065999922],
              [142.18230228000004, -10.609958591999941],
              [142.19320722700002, -10.59148528399993],
              [142.212250196, -10.597588799999926],
              [142.22934004, -10.619805596999925],
              [142.25538170700008, -10.666680596999925],
            ],
          ],
          [
            [
              [142.2622176440001, -10.57781340899993],
              [142.294281446, -10.57317473799992],
              [142.3188582690001, -10.588636976999908],
              [142.3252059250001, -10.612399997999944],
              [142.303070509, -10.63250090899993],
              [142.2744246750001, -10.640801690999922],
              [142.25367272200003, -10.625420830999929],
              [142.24732506600003, -10.599786065999922],
              [142.2622176440001, -10.57781340899993],
            ],
          ],
          [
            [
              [142.2934676440001, -10.138929945999905],
              [142.3144637380001, -10.148614190999922],
              [142.3320418630001, -10.16969166499996],
              [142.34050540500004, -10.190850518999923],
              [142.33423912900003, -10.20045338299991],
              [142.31666100400003, -10.213474216999941],
              [142.28980553500003, -10.260186455999929],
              [142.275726759, -10.25562916499996],
              [142.2636824880001, -10.246514580999929],
              [142.2485457690001, -10.24032968499995],
              [142.23365319100003, -10.23837655999995],
              [142.2212020190001, -10.242120049999926],
              [142.21062259200005, -10.23211028399993],
              [142.2011824880001, -10.22039153399993],
              [142.19483483200008, -10.207289320999905],
              [142.19320722700002, -10.193617445999905],
              [142.20386803500003, -10.18840911299992],
              [142.21111087300005, -10.183038018999923],
              [142.21436608200008, -10.176527601999908],
              [142.213226759, -10.157647393999923],
              [142.21436608200008, -10.15325286299992],
              [142.23170006600003, -10.14185963299991],
              [142.25416100400003, -10.13795338299991],
              [142.2934676440001, -10.138929945999905],
            ],
          ],
          [
            [
              [142.19011478000004, -10.08098723799992],
              [142.19752037900003, -10.092461846999925],
              [142.1977645190001, -10.102146091999941],
              [142.19011478000004, -10.143731377999927],
              [142.182953321, -10.15325286299992],
              [142.17595462300005, -10.160821221999925],
              [142.1670028000001, -10.182061455999929],
              [142.1547957690001, -10.188083591999941],
              [142.142914259, -10.18564218499995],
              [142.1386824880001, -10.172539971999925],
              [142.12468509200005, -10.15829843499995],
              [142.1098738940001, -10.147556247999944],
              [142.09913170700008, -10.13567473799992],
              [142.097015821, -10.118584893999923],
              [142.14210045700008, -10.050388278999947],
              [142.1572371750001, -10.052992445999905],
              [142.16960696700005, -10.060153903999947],
              [142.19011478000004, -10.08098723799992],
            ],
          ],
          [
            [
              [115.66000410200002, -32.14983489399992],
              [115.66374759200005, -32.17310963299991],
              [115.67847741000003, -32.21648528399993],
              [115.68051191500001, -32.239353122999944],
              [115.66456139400009, -32.234633070999905],
              [115.66000410200002, -32.23251718499995],
              [115.65699303500003, -32.20940520599993],
              [115.64942467500009, -32.18434010199991],
              [115.64722741000003, -32.16269296699994],
              [115.66000410200002, -32.14983489399992],
            ],
          ],
          [
            [
              [115.49210733500001, -31.995649012999934],
              [115.52460704100008, -31.993806526999947],
              [115.5426098480001, -32.00003109599993],
              [115.55219218900004, -32.00620348499996],
              [115.53165461700007, -32.01832432599991],
              [115.51475905300003, -32.02536222099991],
              [115.49073098400004, -32.01909750599992],
              [115.45939988100008, -32.02297931499993],
              [115.44014224400007, -32.021833949999916],
              [115.458296389, -32.00971254099994],
              [115.48236636000001, -32.01088546199992],
              [115.49210733500001, -31.995649012999934],
            ],
          ],
          [
            [
              [113.67961755400006, -28.452241432999926],
              [113.7033514420001, -28.448420550999913],
              [113.71147272200005, -28.439097571999923],
              [113.72021320600004, -28.428123549999953],
              [113.735183785, -28.427570596999942],
              [113.74953908200007, -28.427575765999904],
              [113.73206280700003, -28.442939809999928],
              [113.715209791, -28.462148790999947],
              [113.70209119200001, -28.47201769499992],
              [113.69334439900001, -28.483538319999923],
              [113.68459830400002, -28.486276559999908],
              [113.68148317700002, -28.468161041999906],
              [113.67961755400006, -28.452241432999926],
            ],
          ],
          [
            [
              [146.65113366000003, -18.74578215899993],
              [146.68344160200002, -18.743584893999923],
              [146.68425540500004, -18.75204843499995],
              [146.67400149800005, -18.764336846999925],
              [146.6630965500001, -18.76816171699994],
              [146.65447024800005, -18.770196221999925],
              [146.637543165, -18.76816171699994],
              [146.6250106130001, -18.76344166499996],
              [146.61695397200003, -18.76230234199994],
              [146.60279381600003, -18.761895440999922],
              [146.582855665, -18.764743747999944],
              [146.57016035200002, -18.760837497999944],
              [146.57056725400003, -18.745212497999944],
              [146.58277428500003, -18.71770598799992],
              [146.5820418630001, -18.703383070999905],
              [146.5766707690001, -18.68808359199994],
              [146.58130944100003, -18.68222421699994],
              [146.5922957690001, -18.689711195999905],
              [146.60132897200003, -18.698418877999927],
              [146.61117597700002, -18.70322030999995],
              [146.62232506600003, -18.715915622999944],
              [146.634125196, -18.736504815999922],
              [146.65113366000003, -18.74578215899993],
            ],
          ],
          [
            [
              [142.75456790500004, -9.369805596999925],
              [142.77100670700008, -9.373711846999925],
              [142.782562696, -9.386325778999947],
              [142.7680770190001, -9.39820728999996],
              [142.752289259, -9.408379815999922],
              [142.74195397200003, -9.41920338299991],
              [142.731781446, -9.424899997999944],
              [142.7138778000001, -9.42864348799992],
              [142.6416121750001, -9.428399346999925],
              [142.62859134200005, -9.424981377999927],
              [142.61215254, -9.416273695999905],
              [142.60124759200005, -9.399509372999944],
              [142.6123153000001, -9.383233330999929],
              [142.63746178500003, -9.37395598799992],
              [142.66480553500003, -9.37428150799991],
              [142.69361412900003, -9.379571221999925],
              [142.71949303500003, -9.377618096999925],
              [142.75456790500004, -9.369805596999925],
            ],
          ],
          [
            [
              [142.20687910200002, -9.240166924999926],
              [142.28012129, -9.261651299999926],
              [142.2841903000001, -9.277520440999922],
              [142.27914472700002, -9.287041924999926],
              [142.26059004, -9.290215752999927],
              [142.22217858200008, -9.29111093499995],
              [142.18083743600005, -9.284763278999947],
              [142.1508895190001, -9.271416924999926],
              [142.16423587300005, -9.250746351999908],
              [142.20687910200002, -9.240166924999926],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Fiji',
        iso3: 'FJI',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-180, -16.16961373999993],
              [-180, -16.14911104199996],
              [-179.98753821499992, -16.138116143999923],
              [-179.9730118479999, -16.131036065999922],
              [-179.9385880199999, -16.121270440999922],
              [-179.94847571499992, -16.142185153999947],
              [-179.96178137899992, -16.15471770599993],
              [-179.9788712229999, -16.162774346999925],
              [-180, -16.16961373999993],
            ],
          ],
          [
            [
              [-180, -16.541114827999934],
              [-180, -16.48993884999993],
              [-179.99140377499992, -16.475762627999927],
              [-179.9647110669999, -16.45745208099993],
              [-179.95905514199993, -16.446872653999947],
              [-179.95099850199992, -16.44304778399993],
              [-179.91181393099993, -16.431573174999926],
              [-179.89765377499992, -16.42978280999995],
              [-179.89765377499992, -16.43645598799992],
              [-179.90705318899992, -16.438246351999908],
              [-179.91120357999992, -16.44117603999996],
              [-179.9100235669999, -16.44508228999996],
              [-179.9037979809999, -16.450290622999944],
              [-179.9037979809999, -16.457696221999925],
              [-179.90990149599992, -16.45956796699994],
              [-179.9142960279999, -16.461602471999925],
              [-179.91962643099993, -16.463148695999905],
              [-179.9283341139999, -16.46379973799992],
              [-179.93329830599993, -16.46803150799991],
              [-179.93744869699992, -16.47747161299992],
              [-179.9370011059999, -16.48691171699994],
              [-179.9283341139999, -16.49114348799992],
              [-179.92198645699992, -16.497491143999923],
              [-179.93480383999992, -16.510837497999944],
              [-179.95201575399992, -16.523044528999947],
              [-180, -16.541114827999934],
            ],
          ],
          [
            [
              [-180, -16.964143905999947],
              [-180, -16.786732945999916],
              [-179.98985755099991, -16.77117278399993],
              [-179.9158829419999, -16.694512627999927],
              [-179.89765377499992, -16.683526299999926],
              [-179.87714596299992, -16.67782968499995],
              [-179.86408443899992, -16.68132903399993],
              [-179.8557022779999, -16.69304778399993],
              [-179.84650631399992, -16.72128671699994],
              [-179.8428848949999, -16.738213799999926],
              [-179.8423966139999, -16.748711846999925],
              [-179.83002682199992, -16.756117445999905],
              [-179.8209122389999, -16.76344166499996],
              [-179.81566321499992, -16.772230726999908],
              [-179.82099361899992, -16.779961846999925],
              [-179.85663814999992, -16.813897393999923],
              [-179.8665258449999, -16.831638278999947],
              [-179.86933346299992, -16.840590101999908],
              [-179.87157141799992, -16.86386484199994],
              [-179.87531490799992, -16.865492445999905],
              [-179.8814591139999, -16.86451588299991],
              [-179.8901261059999, -16.867852471999925],
              [-179.9511612619999, -16.90593840899993],
              [-179.98289954299992, -16.932386976999908],
              [-180, -16.964143905999947],
            ],
          ],
          [
            [
              [180, -16.489518921999945],
              [180, -16.51656142799993],
              [180, -16.541274866999913],
              [179.99921551400007, -16.541452313999912],
              [179.992523634, -16.543145440999922],
              [179.98747806100005, -16.542413018999923],
              [179.98454837300005, -16.538262627999927],
              [179.9843856130001, -16.53020598799992],
              [179.98715254, -16.518324476999908],
              [179.99915023800008, -16.491329657999927],
              [180, -16.489518921999945],
            ],
          ],
          [
            [
              [180, -16.78534884699991],
              [180, -16.96278239299994],
              [179.99898190800002, -16.964612233999958],
              [179.9921981130001, -16.97503020599993],
              [179.98121178500003, -16.984307549999926],
              [179.9668074880001, -16.993340752999927],
              [179.953949415, -16.998793226999908],
              [179.94109134200005, -17.001885674999926],
              [179.9287215500001, -17.002129815999922],
              [179.91749108200008, -16.998793226999908],
              [179.912445509, -16.98300546699994],
              [179.89421634200005, -16.967461846999925],
              [179.89014733200008, -16.953871351999908],
              [179.89527428500003, -16.93914153399993],
              [179.9072371750001, -16.92701588299991],
              [179.93116295700008, -16.90943775799991],
              [179.9672957690001, -16.85833098799992],
              [179.972992384, -16.844821872999944],
              [179.9775496750001, -16.82822030999995],
              [179.99920928100005, -16.78684802999993],
              [180, -16.78534884699991],
            ],
          ],
          [
            [
              [180, -16.149111724999955],
              [180, -16.168951069999935],
              [179.99897849600006, -16.169877740999937],
              [179.9379988940001, -16.22429778399993],
              [179.92994225400003, -16.22714609199994],
              [179.9121199880001, -16.227959893999923],
              [179.90381920700008, -16.231133721999925],
              [179.89568118600005, -16.23870208099993],
              [179.88648522200003, -16.25448984199994],
              [179.87964928500003, -16.26213958099993],
              [179.86540774800005, -16.274509372999944],
              [179.85824629, -16.282647393999923],
              [179.85914147200003, -16.286309502999927],
              [179.85124759200005, -16.290948174999926],
              [179.83814537900003, -16.314060153999947],
              [179.79810631600003, -16.36956145599993],
              [179.78093509200005, -16.38128020599993],
              [179.78101647200003, -16.403008721999925],
              [179.76343834700003, -16.432793877999927],
              [179.73845462300005, -16.459242445999905],
              [179.7158309250001, -16.470635674999926],
              [179.6938582690001, -16.477308851999908],
              [179.59791100400003, -16.539808851999908],
              [179.5918074880001, -16.54534270599993],
              [179.58765709700003, -16.552911065999922],
              [179.58228600400003, -16.56698984199994],
              [179.58073978000004, -16.579278252999927],
              [179.5810653000001, -16.59498463299991],
              [179.5791121750001, -16.61142343499995],
              [179.57146243600005, -16.62558359199994],
              [179.56006920700008, -16.63453541499996],
              [179.53443444100003, -16.65048593499995],
              [179.52361087300005, -16.658949476999908],
              [179.51872806100005, -16.665134372999944],
              [179.50660241000003, -16.683526299999926],
              [179.50066165500004, -16.68718840899993],
              [179.48422285200002, -16.69312916499996],
              [179.47868899800005, -16.697198174999926],
              [179.4887801440001, -16.70761484199994],
              [179.4921981130001, -16.72503020599993],
              [179.4887801440001, -16.74382903399993],
              [179.47868899800005, -16.75872161299992],
              [179.48609459700003, -16.76604583099993],
              [179.5019637380001, -16.754652601999908],
              [179.52027428500003, -16.749607028999947],
              [179.5371199880001, -16.752618096999925],
              [179.54810631600003, -16.76604583099993],
              [179.5625106130001, -16.75481536299992],
              [179.58521569100003, -16.72942473799992],
              [179.59937584700003, -16.724541924999926],
              [179.60954837300005, -16.72275155999995],
              [179.6220809250001, -16.717868747999944],
              [179.63257897200003, -16.71021900799991],
              [179.63697350400003, -16.700616143999923],
              [179.64087975400003, -16.68726978999996],
              [179.65056399800005, -16.68222421699994],
              [179.66187584700003, -16.68027109199994],
              [179.67107181100005, -16.676853122999944],
              [179.672699415, -16.672946872999944],
              [179.676117384, -16.659356377999927],
              [179.67790774800005, -16.65553150799991],
              [179.6821395190001, -16.65406666499996],
              [179.69450931100005, -16.651462497999944],
              [179.69841556100005, -16.649509372999944],
              [179.70582116000003, -16.638116143999923],
              [179.716156446, -16.613457940999922],
              [179.7226668630001, -16.60442473799992],
              [179.73210696700005, -16.599216403999947],
              [179.74203535200002, -16.596368096999925],
              [179.74976647200003, -16.592461846999925],
              [179.7529403000001, -16.583916924999926],
              [179.75668379, -16.57675546699994],
              [179.76539147200003, -16.57195403399993],
              [179.78093509200005, -16.56698984199994],
              [179.81413821700005, -16.546319268999923],
              [179.83326256600003, -16.530368747999944],
              [179.8418074880001, -16.515069268999923],
              [179.85108483200008, -16.508558851999908],
              [179.90381920700008, -16.484307549999926],
              [179.90894616000003, -16.478773695999905],
              [179.9126082690001, -16.47234465899993],
              [179.91716556100005, -16.46689218499995],
              [179.9243270190001, -16.46379973799992],
              [179.9394637380001, -16.46331145599993],
              [179.9423934250001, -16.467461846999925],
              [179.9423934250001, -16.47584400799991],
              [179.953461134, -16.499607028999947],
              [179.94906660200002, -16.50904713299991],
              [179.941742384, -16.51653411299992],
              [179.93620853000004, -16.52467213299991],
              [179.9243270190001, -16.55315520599993],
              [179.89014733200008, -16.614678643999923],
              [179.88941491000003, -16.619398695999905],
              [179.8911238940001, -16.63128020599993],
              [179.89014733200008, -16.635837497999944],
              [179.88624108200008, -16.63681405999995],
              [179.87370853000004, -16.63486093499995],
              [179.8696395190001, -16.635837497999944],
              [179.8486434250001, -16.662367445999905],
              [179.8750106130001, -16.664320570999905],
              [179.891937696, -16.675957940999922],
              [179.90113366000003, -16.694756768999923],
              [179.90381920700008, -16.71770598799992],
              [179.91749108200008, -16.71656666499996],
              [179.9355574880001, -16.72039153399993],
              [179.9497176440001, -16.730075778999947],
              [179.9516707690001, -16.745700778999947],
              [179.9419051440001, -16.752618096999925],
              [179.92652428500003, -16.749607028999947],
              [179.89633222700002, -16.738213799999926],
              [179.89991295700008, -16.74423593499995],
              [179.907074415, -16.760023695999905],
              [179.9106551440001, -16.76604583099993],
              [179.89576256600003, -16.76181405999995],
              [179.89014733200008, -16.75872161299992],
              [179.87574303500003, -16.769463799999926],
              [179.863617384, -16.764825127999927],
              [179.8579207690001, -16.751885674999926],
              [179.86215254, -16.738213799999926],
              [179.82634524800005, -16.737074476999908],
              [179.81202233200008, -16.731215101999908],
              [179.80201256600003, -16.71770598799992],
              [179.78077233200008, -16.72503020599993],
              [179.75928795700008, -16.723728122999944],
              [179.7402449880001, -16.71933359199994],
              [179.72632897200003, -16.71770598799992],
              [179.71648196700005, -16.72193775799991],
              [179.69988040500004, -16.73528411299992],
              [179.688324415, -16.738213799999926],
              [179.67603600400003, -16.738457940999922],
              [179.66627037900003, -16.74065520599993],
              [179.65984134200005, -16.746758721999925],
              [179.6567488940001, -16.75872161299992],
              [179.65186608200008, -16.74928150799991],
              [179.65056399800005, -16.745700778999947],
              [179.64380944100003, -16.745700778999947],
              [179.6333113940001, -16.765883070999905],
              [179.59685306100005, -16.78875090899993],
              [179.58228600400003, -16.80706145599993],
              [179.56511478000004, -16.791680596999925],
              [179.5449324880001, -16.79078541499996],
              [179.50318444100003, -16.800225518999923],
              [179.47144616000003, -16.80120208099993],
              [179.453949415, -16.80510833099993],
              [179.43824303500003, -16.813897393999923],
              [179.40381920700008, -16.802341403999947],
              [179.37574303500003, -16.801039320999905],
              [179.2968856130001, -16.806817315999922],
              [179.2978621750001, -16.80445728999996],
              [179.307953321, -16.79745859199994],
              [179.31421959700003, -16.78329843499995],
              [179.32341556100005, -16.77117278399993],
              [179.34148196700005, -16.765069268999923],
              [179.35474694100003, -16.758477471999925],
              [179.34888756600003, -16.745700778999947],
              [179.35141035200002, -16.73137786299992],
              [179.33961022200003, -16.72437916499996],
              [179.307953321, -16.71770598799992],
              [179.28296959700003, -16.69890715899993],
              [179.26636803500003, -16.68987395599993],
              [179.25896243600005, -16.69378020599993],
              [179.24822024800005, -16.694105726999908],
              [179.17204837300005, -16.722588799999926],
              [179.1528426440001, -16.73447030999995],
              [179.12289472700002, -16.75872161299992],
              [179.1294051440001, -16.77581145599993],
              [179.123383009, -16.78964609199994],
              [179.110199415, -16.799981377999927],
              [179.0957137380001, -16.80706145599993],
              [179.0654403000001, -16.79892343499995],
              [179.04444420700008, -16.823825778999947],
              [179.019867384, -16.895196221999925],
              [179.0454207690001, -16.88014088299991],
              [179.0566512380001, -16.878024997999944],
              [179.0752059250001, -16.881524346999925],
              [179.06560306100005, -16.89348723799992],
              [179.03728274800005, -16.91269296699994],
              [179.02686608200008, -16.92310963299991],
              [179.019867384, -16.92310963299991],
              [179.0068465500001, -16.91773853999996],
              [178.96745853000004, -16.90634530999995],
              [178.954437696, -16.89902109199994],
              [178.9502059250001, -16.89072030999995],
              [178.94890384200005, -16.882989190999922],
              [178.9453231130001, -16.87753671699994],
              [178.92595462300005, -16.87314218499995],
              [178.920258009, -16.86695728999996],
              [178.91724694100003, -16.85833098799992],
              [178.9170028000001, -16.84807708099993],
              [178.91000410200002, -16.84807708099993],
              [178.91000410200002, -16.867852471999925],
              [178.8945418630001, -16.859307549999926],
              [178.8837996750001, -16.857679945999905],
              [178.8740340500001, -16.86109791499996],
              [178.861664259, -16.867852471999925],
              [178.8212996750001, -16.902601820999905],
              [178.81706790500004, -16.912041924999926],
              [178.8071395190001, -16.95045338299991],
              [178.79948978000004, -16.957207940999922],
              [178.79021243600005, -16.962009372999944],
              [178.78777103000004, -16.967868747999944],
              [178.80095462300005, -16.977715752999927],
              [178.76547285200002, -17.001153252999927],
              [178.7627059250001, -17.005059502999927],
              [178.73389733200008, -17.007012627999927],
              [178.72087649800005, -17.00554778399993],
              [178.70533287900003, -16.998793226999908],
              [178.6919051440001, -16.985772393999923],
              [178.6806746750001, -16.95826588299991],
              [178.673187696, -16.926039320999905],
              [178.6704207690001, -16.89902109199994],
              [178.66041100400003, -16.87948984199994],
              [178.6406356130001, -16.860528252999927],
              [178.6274520190001, -16.83766041499996],
              [178.63640384200005, -16.80706145599993],
              [178.61500084700003, -16.79973723799992],
              [178.60621178500003, -16.792901299999926],
              [178.60230553500003, -16.77971770599993],
              [178.54070071700005, -16.80917734199994],
              [178.51156660200002, -16.81422291499996],
              [178.48560631600003, -16.79338958099993],
              [178.4902449880001, -16.791192315999922],
              [178.49040774800005, -16.790215752999927],
              [178.49244225400003, -16.786716403999947],
              [178.48121178500003, -16.777276299999926],
              [178.4790145190001, -16.765883070999905],
              [178.48357181100005, -16.759942315999922],
              [178.49244225400003, -16.76604583099993],
              [178.49927819100003, -16.76604583099993],
              [178.4965926440001, -16.747165622999944],
              [178.50652103000004, -16.730401299999926],
              [178.54021243600005, -16.70403411299992],
              [178.54021243600005, -16.724541924999926],
              [178.54851321700005, -16.716241143999923],
              [178.55250084700003, -16.70484791499996],
              [178.5571395190001, -16.698337497999944],
              [178.56804446700005, -16.70403411299992],
              [178.57292728000004, -16.688897393999923],
              [178.58562259200005, -16.665134372999944],
              [178.58863366000003, -16.649509372999944],
              [178.56706790500004, -16.660088799999926],
              [178.5527449880001, -16.658949476999908],
              [178.54281660200002, -16.647881768999923],
              [178.53394616000003, -16.62900155999995],
              [178.57178795700008, -16.615492445999905],
              [178.58179772200003, -16.614678643999923],
              [178.589203321, -16.619398695999905],
              [178.60075931100005, -16.635511976999908],
              [178.6084090500001, -16.642022393999923],
              [178.61882571700005, -16.645196221999925],
              [178.65007571700005, -16.649509372999944],
              [178.68091881600003, -16.66806405999995],
              [178.69109134200005, -16.669854424999926],
              [178.70427493600005, -16.667087497999944],
              [178.7089949880001, -16.66301848799992],
              [178.7114363940001, -16.657321872999944],
              [178.71762129, -16.649509372999944],
              [178.77328535200002, -16.60328541499996],
              [178.78834069100003, -16.59693775799991],
              [178.797699415, -16.606622002999927],
              [178.80095462300005, -16.635837497999944],
              [178.81397545700008, -16.629978122999944],
              [178.8173934250001, -16.62273528399993],
              [178.81397545700008, -16.597588799999926],
              [178.8183699880001, -16.58684661299992],
              [178.8486434250001, -16.546319268999923],
              [178.85035241000003, -16.551446221999925],
              [178.85466556100005, -16.56031666499996],
              [178.8554793630001, -16.56698984199994],
              [178.86345462300005, -16.56218840899993],
              [178.86793053500003, -16.55706145599993],
              [178.8696395190001, -16.55006275799991],
              [178.8691512380001, -16.53964609199994],
              [178.8759871750001, -16.53964609199994],
              [178.88624108200008, -16.552341403999947],
              [178.89763431100005, -16.54306405999995],
              [178.90943444100003, -16.526543877999927],
              [178.9204207690001, -16.517836195999905],
              [178.93091881600003, -16.51262786299992],
              [178.92790774800005, -16.499932549999926],
              [178.9204207690001, -16.48447030999995],
              [178.9170028000001, -16.470635674999926],
              [178.921234571, -16.47275155999995],
              [178.93287194100003, -16.476169528999947],
              [178.93734785200002, -16.478122653999947],
              [178.942718946, -16.460381768999923],
              [178.9521590500001, -16.459649346999925],
              [178.96111087300005, -16.466403903999947],
              [178.96509850400003, -16.470635674999926],
              [178.98015384200005, -16.468194268999923],
              [179.0078231130001, -16.45956796699994],
              [179.05420983200008, -16.45403411299992],
              [179.10661868600005, -16.43613046699994],
              [179.1367293630001, -16.42978280999995],
              [179.16749108200008, -16.43132903399993],
              [179.17758222700002, -16.42978280999995],
              [179.1801863940001, -16.42636484199994],
              [179.187836134, -16.41220468499995],
              [179.19125410200002, -16.40797291499996],
              [179.19898522200003, -16.405368747999944],
              [179.21631920700008, -16.40243905999995],
              [179.22234134200005, -16.39902109199994],
              [179.24040774800005, -16.39812590899993],
              [179.26978600400003, -16.405694268999923],
              [179.29835045700008, -16.40911223799992],
              [179.31421959700003, -16.395603122999944],
              [179.32927493600005, -16.40797291499996],
              [179.338226759, -16.40398528399993],
              [179.3462020190001, -16.39381275799991],
              [179.358734571, -16.388116143999923],
              [179.3657332690001, -16.391289971999925],
              [179.3720809250001, -16.40488046699994],
              [179.37964928500003, -16.40797291499996],
              [179.388031446, -16.40715911299992],
              [179.39242597700002, -16.40601978999996],
              [179.3964949880001, -16.405694268999923],
              [179.40357506600003, -16.40797291499996],
              [179.40202884200005, -16.39299895599993],
              [179.39576256600003, -16.378838799999926],
              [179.38648522200003, -16.367445570999905],
              [179.37614993600005, -16.360772393999923],
              [179.38648522200003, -16.35133228999996],
              [179.39771569100003, -16.347832940999922],
              [179.408539259, -16.349053643999923],
              [179.41781660200002, -16.35393645599993],
              [179.42261803500003, -16.33684661299992],
              [179.43140709700003, -16.319024346999925],
              [179.44320722700002, -16.31023528399993],
              [179.45818118600005, -16.319919528999947],
              [179.46509850400003, -16.302666924999926],
              [179.4668074880001, -16.28687916499996],
              [179.4712020190001, -16.27402109199994],
              [179.48609459700003, -16.265232028999947],
              [179.52165774800005, -16.26799895599993],
              [179.5356551440001, -16.262465101999908],
              [179.52027428500003, -16.244805596999925],
              [179.53345787900003, -16.244886976999908],
              [179.54249108200008, -16.250746351999908],
              [179.54900149800005, -16.260511976999908],
              [179.55437259200005, -16.272637627999927],
              [179.56316165500004, -16.237399997999944],
              [179.56804446700005, -16.22429778399993],
              [179.57292728000004, -16.23642343499995],
              [179.58187910200002, -16.24195728999996],
              [179.59294681100005, -16.245700778999947],
              [179.60279381600003, -16.252129815999922],
              [179.61150149800005, -16.243340752999927],
              [179.61890709700003, -16.24260833099993],
              [179.62484785200002, -16.248304945999905],
              [179.63013756600003, -16.258965752999927],
              [179.63013756600003, -16.24342213299991],
              [179.63404381600003, -16.237888278999947],
              [179.64014733200008, -16.23756275799991],
              [179.64714603000004, -16.238539320999905],
              [179.6533309250001, -16.23528411299992],
              [179.65601647200003, -16.227959893999923],
              [179.65650475400003, -16.220635674999926],
              [179.65642337300005, -16.217461846999925],
              [179.66334069100003, -16.218194268999923],
              [179.66749108200008, -16.220635674999926],
              [179.67066491000003, -16.22307708099993],
              [179.67448978000004, -16.22429778399993],
              [179.69353274800005, -16.225762627999927],
              [179.70183353000004, -16.22307708099993],
              [179.70525149800005, -16.214043877999927],
              [179.710297071, -16.207777601999908],
              [179.734711134, -16.197930596999925],
              [179.76441491000003, -16.18141041499996],
              [179.77068118600005, -16.19654713299991],
              [179.77271569100003, -16.219414971999925],
              [179.78093509200005, -16.231133721999925],
              [179.7929793630001, -16.226495049999926],
              [179.8144637380001, -16.207696221999925],
              [179.82878665500004, -16.20435963299991],
              [179.83961022200003, -16.207696221999925],
              [179.84131920700008, -16.21347421699994],
              [179.83659915500004, -16.219496351999908],
              [179.82878665500004, -16.22429778399993],
              [179.83961022200003, -16.228122653999947],
              [179.85084069100003, -16.227959893999923],
              [179.8559676440001, -16.231133721999925],
              [179.8681746750001, -16.215997002999927],
              [179.9033309250001, -16.188653252999927],
              [179.9106551440001, -16.179864190999922],
              [179.98316491000003, -16.149102471999925],
              [179.998817314, -16.149102471999925],
              [180, -16.149111724999955],
            ],
          ],
          [
            [
              [-178.58857174399992, -19.12281666499996],
              [-178.58197994699992, -19.13730234199994],
              [-178.56635494699992, -19.151055596999925],
              [-178.54804439999992, -19.159274997999944],
              [-178.53331458199992, -19.156996351999908],
              [-178.5369766919999, -19.177178643999923],
              [-178.55585689999992, -19.174981377999927],
              [-178.5916641919999, -19.156996351999908],
              [-178.6003311839999, -19.14771900799991],
              [-178.59711666599992, -19.128513278999947],
              [-178.58165442599991, -19.111504815999922],
              [-178.5538223949999, -19.10914478999996],
              [-178.5596817699999, -19.11882903399993],
              [-178.56635494699992, -19.12086353999996],
              [-178.57542883999992, -19.120538018999923],
              [-178.58857174399992, -19.12281666499996],
            ],
          ],
          [
            [
              [-178.9721573559999, -18.965101820999905],
              [-178.96906490799992, -18.94264088299991],
              [-178.95787512899992, -18.927911065999922],
              [-178.9435929029999, -18.92636484199994],
              [-178.93122311099992, -18.944105726999908],
              [-178.9309789699999, -18.971368096999925],
              [-178.9444473949999, -18.98723723799992],
              [-178.9615372389999, -18.98674895599993],
              [-178.9721573559999, -18.965101820999905],
            ],
          ],
          [
            [
              [-179.8630671869999, -18.965834242999904],
              [-179.86286373599992, -18.965101820999905],
              [-179.84968014199993, -18.923435153999947],
              [-179.81269283799992, -18.927341403999947],
              [-179.78718014199993, -18.955336195999905],
              [-179.80821692599991, -18.98642343499995],
              [-179.8167618479999, -18.952243747999944],
              [-179.8377579419999, -18.948825778999947],
              [-179.85521399599992, -18.963148695999905],
              [-179.8528946609999, -18.982598565999922],
              [-179.8443497389999, -19.002129815999922],
              [-179.85826575399992, -19.00595468499995],
              [-179.87193762899992, -18.993747653999947],
              [-179.8630671869999, -18.965834242999904],
            ],
          ],
          [
            [
              [-178.7667130199999, -18.191257419999943],
              [-178.7491348949999, -18.20322030999995],
              [-178.74567623599992, -18.22161223799992],
              [-178.7518204419999, -18.238457940999922],
              [-178.76329505099991, -18.24586353999996],
              [-178.79743404899992, -18.24586353999996],
              [-178.80658932199992, -18.243747653999947],
              [-178.81419837099992, -18.238946221999925],
              [-178.82026119699992, -18.234307549999926],
              [-178.82477779899992, -18.23211028399993],
              [-178.84540768099993, -18.21738046699994],
              [-178.82489986899992, -18.18914153399993],
              [-178.7897843089999, -18.172133070999905],
              [-178.7667130199999, -18.19117603999996],
              [-178.7667130199999, -18.191257419999943],
            ],
          ],
          [
            [
              [-179.0502939389999, -17.955952364999916],
              [-179.0318305229999, -17.96632850599991],
              [-179.0279689729999, -17.989899607999916],
              [-179.0278654939999, -18.00301406899996],
              [-179.0462154029999, -18.007515360999946],
              [-179.0591221379999, -18.000656670999945],
              [-179.0693357669999, -17.98931881099992],
              [-179.07870402999993, -17.966642212999943],
              [-179.0595113709999, -17.952518247999933],
              [-179.0502939389999, -17.955952364999916],
            ],
          ],
          [
            [
              [-178.29316158799992, -17.882745049999926],
              [-178.28107662699992, -17.88876718499995],
              [-178.26292883999992, -17.90129973799992],
              [-178.24640865799992, -17.917575778999947],
              [-178.23912512899992, -17.934258721999925],
              [-178.2486466139999, -17.952569268999923],
              [-178.27122962099992, -17.961683851999908],
              [-178.29828854099992, -17.96331145599993],
              [-178.3210343089999, -17.958428643999923],
              [-178.3522843089999, -17.94573333099993],
              [-178.3577774729999, -17.914320570999905],
              [-178.3378800119999, -17.88600025799991],
              [-178.29316158799992, -17.882745049999926],
            ],
          ],
          [
            [
              [-178.9647110669999, -17.176934502999927],
              [-178.9329320949999, -17.19150155999995],
              [-178.9173477859999, -17.20126718499995],
              [-178.91071529899992, -17.21453215899993],
              [-178.92597408799992, -17.247247002999927],
              [-178.92747962099992, -17.252699476999908],
              [-178.9462784499999, -17.259209893999923],
              [-178.9659317699999, -17.27507903399993],
              [-178.98094641799992, -17.29501718499995],
              [-178.9858292309999, -17.313571872999944],
              [-179.00068111899992, -17.30250416499996],
              [-178.99767005099991, -17.283135674999926],
              [-178.9853409499999, -17.26376718499995],
              [-178.9721573559999, -17.252699476999908],
              [-178.97577877499992, -17.239841403999947],
              [-178.97065182199992, -17.233819268999923],
              [-178.96283932199992, -17.23023853999996],
              [-178.9584854809999, -17.224786065999922],
              [-178.9583227199999, -17.21135833099993],
              [-178.9602758449999, -17.20549895599993],
              [-178.9721573559999, -17.197442315999922],
              [-178.98204505099991, -17.192559502999927],
              [-179.0037735669999, -17.188653252999927],
              [-179.01313229099992, -17.183851820999905],
              [-179.0170792309999, -17.176527601999908],
              [-179.0185440749999, -17.156914971999925],
              [-179.01996822799993, -17.149102471999925],
              [-179.00605221299992, -17.15471770599993],
              [-178.99689693899992, -17.16611093499995],
              [-178.98542232999992, -17.17587655999995],
              [-178.9647110669999, -17.176934502999927],
            ],
          ],
          [
            [
              [179.77751712300005, -19.12281666499996],
              [179.78858483200008, -19.130466403999947],
              [179.79411868600005, -19.148044528999947],
              [179.79753665500004, -19.16838958099993],
              [179.80201256600003, -19.184258721999925],
              [179.77214603000004, -19.191338799999926],
              [179.76042728000004, -19.19231536299992],
              [179.74594160200002, -19.190118096999925],
              [179.74187259200005, -19.186211846999925],
              [179.74000084700003, -19.17742278399993],
              [179.74724368600005, -19.17392343499995],
              [179.7490340500001, -19.173272393999923],
              [179.74952233200008, -19.171482028999947],
              [179.7529403000001, -19.16383228999996],
              [179.75798587300005, -19.16570403399993],
              [179.76921634200005, -19.16855234199994],
              [179.77409915500004, -19.170668226999908],
              [179.76783287900003, -19.155450127999927],
              [179.7578231130001, -19.13990650799991],
              [179.75660241000003, -19.127699476999908],
              [179.77751712300005, -19.12281666499996],
            ],
          ],
          [
            [
              [178.43034915500004, -18.955254815999922],
              [178.43816165500004, -18.954685153999947],
              [178.4746199880001, -18.96062590899993],
              [178.48560631600003, -18.965101820999905],
              [178.4931746750001, -18.97820403399993],
              [178.498383009, -18.996758721999925],
              [178.4965926440001, -19.013278903999947],
              [178.4755965500001, -19.02320728999996],
              [178.4609481130001, -19.032647393999923],
              [178.45386803500003, -19.026788018999923],
              [178.4438582690001, -19.02385833099993],
              [178.42408287900003, -19.02044036299992],
              [178.42855879, -19.02939218499995],
              [178.42896569100003, -19.03679778399993],
              [178.425140821, -19.04306405999995],
              [178.41667728000004, -19.04778411299992],
              [178.40503991000003, -19.044528903999947],
              [178.38257897200003, -19.042901299999926],
              [178.3584090500001, -19.043715101999908],
              [178.34148196700005, -19.04778411299992],
              [178.34392337300005, -19.04111093499995],
              [178.34636478000004, -19.027276299999926],
              [178.34831790500004, -19.02044036299992],
              [178.33936608200008, -19.024590752999927],
              [178.332855665, -19.025648695999905],
              [178.3271590500001, -19.024183851999908],
              [178.32048587300005, -19.02044036299992],
              [178.3252059250001, -19.015883070999905],
              [178.3300887380001, -19.00953541499996],
              [178.3339949880001, -19.00676848799992],
              [178.30730228000004, -18.997165622999944],
              [178.28150475400003, -19.007419528999947],
              [178.23853600400003, -19.040948174999926],
              [178.222992384, -19.044854424999926],
              [178.20728600400003, -19.045098565999922],
              [178.19507897200003, -19.04745859199994],
              [178.19011478000004, -19.057712497999944],
              [178.1904403000001, -19.07870859199994],
              [178.18873131600003, -19.083591403999947],
              [178.18384850400003, -19.06894296699994],
              [178.1743270190001, -19.07586028399993],
              [178.1709090500001, -19.08717213299991],
              [178.17310631600003, -19.09775155999995],
              [178.1801863940001, -19.102308851999908],
              [178.19499759200005, -19.10556405999995],
              [178.19947350400003, -19.114027601999908],
              [178.19752037900003, -19.139336846999925],
              [178.194672071, -19.14657968499995],
              [178.187836134, -19.15325286299992],
              [178.17896569100003, -19.15748463299991],
              [178.17017662900003, -19.156996351999908],
              [178.16163170700008, -19.150567315999922],
              [178.1601668630001, -19.14185963299991],
              [178.16285241000003, -19.115980726999908],
              [178.14820397200003, -19.12753671699994],
              [178.142914259, -19.129652601999908],
              [178.12867272200003, -19.129652601999908],
              [178.1191512380001, -19.13958098799992],
              [178.1137801440001, -19.148370049999926],
              [178.10661868600005, -19.154554945999905],
              [178.09164472700002, -19.156996351999908],
              [178.07601972700002, -19.15471770599993],
              [178.050140821, -19.14495208099993],
              [178.0371199880001, -19.142754815999922],
              [178.01539147200003, -19.15593840899993],
              [178.00367272200003, -19.15748463299991],
              [177.99887129, -19.142754815999922],
              [177.99203535200002, -19.142754815999922],
              [177.98414147200003, -19.14706796699994],
              [177.973968946, -19.144789320999905],
              [177.96265709700003, -19.138116143999923],
              [177.9511824880001, -19.129652601999908],
              [177.9814559250001, -19.10125090899993],
              [177.99952233200008, -19.094821872999944],
              [178.01937910200002, -19.102308851999908],
              [178.0297957690001, -19.09384530999995],
              [178.03345787900003, -19.07203541499996],
              [178.04118899800005, -19.06145598799992],
              [178.0517684250001, -19.05673593499995],
              [178.06324303500003, -19.05641041499996],
              [178.119476759, -19.07040780999995],
              [178.12867272200003, -19.06894296699994],
              [178.13493899800005, -19.06145598799992],
              [178.13648522200003, -19.05169036299992],
              [178.13941491000003, -19.04192473799992],
              [178.149750196, -19.03411223799992],
              [178.16325931100005, -19.044040622999944],
              [178.17212975400003, -19.035332940999922],
              [178.17644290500004, -19.01734791499996],
              [178.17644290500004, -18.99928150799991],
              [178.19068444100003, -18.977227471999925],
              [178.22608483200008, -18.96412525799991],
              [178.26587975400003, -18.962090752999927],
              [178.29371178500003, -18.972588799999926],
              [178.30193118600005, -18.944024346999925],
              [178.30884850400003, -18.93954843499995],
              [178.32406660200002, -18.938571872999944],
              [178.3286238940001, -18.936293226999908],
              [178.33220462300005, -18.93173593499995],
              [178.336761915, -18.92701588299991],
              [178.34498131600003, -18.924899997999944],
              [178.35499108200008, -18.92669036299992],
              [178.36345462300005, -18.92978280999995],
              [178.371918165, -18.930352471999925],
              [178.38257897200003, -18.924899997999944],
              [178.38982181100005, -18.938164971999925],
              [178.422699415, -18.939711195999905],
              [178.43034915500004, -18.955254815999922],
            ],
          ],
          [
            [
              [178.52654056100005, -18.876560153999947],
              [178.53484134200005, -18.88453541499996],
              [178.53825931100005, -18.89226653399993],
              [178.5376082690001, -18.90048593499995],
              [178.53394616000003, -18.91057708099993],
              [178.5205184250001, -18.906182549999926],
              [178.5136824880001, -18.915948174999926],
              [178.5083113940001, -18.926446221999925],
              [178.49927819100003, -18.924899997999944],
              [178.47193444100003, -18.90715911299992],
              [178.47413170700008, -18.895277601999908],
              [178.4834090500001, -18.880303643999923],
              [178.48560631600003, -18.87314218499995],
              [178.49586022200003, -18.86296965899993],
              [178.51636803500003, -18.857354424999926],
              [178.531586134, -18.860446872999944],
              [178.52654056100005, -18.876560153999947],
            ],
          ],
          [
            [
              [179.94342659400002, -18.556345549999946],
              [179.94811675300002, -18.563502239999934],
              [179.95240319100003, -18.568536065999922],
              [179.94470018100003, -18.580617084999915],
              [179.92078669900002, -18.58604431699996],
              [179.9097704730001, -18.595909350999932],
              [179.89183103800008, -18.609643829999925],
              [179.89884032500004, -18.61746632699993],
              [179.91277848200002, -18.611465750999912],
              [179.91744375400003, -18.611500797999952],
              [179.92101882000009, -18.622642640999914],
              [179.90186897, -18.63814686899991],
              [179.90079132900007, -18.658595160999937],
              [179.88275399200006, -18.662524017999942],
              [179.872213611, -18.645926431999953],
              [179.8715659620001, -18.628824151999936],
              [179.8605027330001, -18.62103015999992],
              [179.85293366100007, -18.611049101999924],
              [179.83307367100008, -18.600249413999904],
              [179.83066570000005, -18.589302244999942],
              [179.850446164, -18.580904285999907],
              [179.888188699, -18.566928499999904],
              [179.92767067500006, -18.557988535999925],
              [179.94342659400002, -18.556345549999946],
            ],
          ],
          [
            [
              [177.648773634, -18.492852471999925],
              [177.65406334700003, -18.504082940999922],
              [177.65593509200005, -18.517022393999923],
              [177.6562606130001, -18.54070403399993],
              [177.6630965500001, -18.58847421699994],
              [177.648773634, -18.579278252999927],
              [177.63648522200003, -18.562758070999905],
              [177.6269637380001, -18.543715101999908],
              [177.6215926440001, -18.52703215899993],
              [177.61898847700002, -18.511895440999922],
              [177.62077884200005, -18.504082940999922],
              [177.635101759, -18.48601653399993],
              [177.63843834700003, -18.489678643999923],
              [177.64177493600005, -18.490980726999908],
              [177.6450301440001, -18.491631768999923],
              [177.648773634, -18.492852471999925],
            ],
          ],
          [
            [
              [178.12232506600003, -18.369317315999922],
              [178.12761478000004, -18.35165780999995],
              [178.13892662900003, -18.348728122999944],
              [178.15007571700005, -18.35784270599993],
              [178.15601647200003, -18.376153252999927],
              [178.15259850400003, -18.39739348799992],
              [178.14234459700003, -18.41187916499996],
              [178.1269637380001, -18.415459893999923],
              [178.108734571, -18.403497002999927],
              [178.1181746750001, -18.401543877999927],
              [178.12183678500003, -18.399183851999908],
              [178.12086022200003, -18.395684502999927],
              [178.1162215500001, -18.389825127999927],
              [178.12037194100003, -18.384942315999922],
              [178.121429884, -18.380466403999947],
              [178.1215926440001, -18.37542083099993],
              [178.12232506600003, -18.369317315999922],
            ],
          ],
          [
            [
              [179.34546959700003, -17.998793226999908],
              [179.36085045700008, -18.02597421699994],
              [179.36296634200005, -18.07976653399993],
              [179.35027103000004, -18.11882903399993],
              [179.32097415500004, -18.101820570999905],
              [179.310883009, -18.089776299999926],
              [179.3032332690001, -18.06218840899993],
              [179.2973738940001, -18.050388278999947],
              [179.2783309250001, -18.027601820999905],
              [179.27173912900003, -18.01572030999995],
              [179.266937696, -17.998793226999908],
              [179.263031446, -18.00953541499996],
              [179.26579837300005, -18.02988046699994],
              [179.26295006600003, -18.036716403999947],
              [179.25407962300005, -18.03915780999995],
              [179.24952233200008, -18.03215911299992],
              [179.24537194100003, -18.00359465899993],
              [179.246429884, -17.974867445999905],
              [179.24439537900003, -17.970147393999923],
              [179.23511803500003, -17.954685153999947],
              [179.232758009, -17.944756768999923],
              [179.24341881600003, -17.95094166499996],
              [179.250336134, -17.95126718499995],
              [179.27214603000004, -17.93450286299992],
              [179.27751712300005, -17.93401458099993],
              [179.28394616000003, -17.936293226999908],
              [179.2973738940001, -17.93792083099993],
              [179.3125106130001, -17.947442315999922],
              [179.336761915, -17.989353122999944],
              [179.34546959700003, -17.998793226999908],
            ],
          ],
          [
            [
              [179.43083743600005, -17.794040622999944],
              [179.43083743600005, -17.79851653399993],
              [179.42945397200003, -17.80136484199994],
              [179.42408287900003, -17.80706145599993],
              [179.42725670700008, -17.813653252999927],
              [179.430511915, -17.822930596999925],
              [179.43230228000004, -17.832777601999908],
              [179.43083743600005, -17.84107838299991],
              [179.42261803500003, -17.85051848799992],
              [179.41684004, -17.84547291499996],
              [179.41041100400003, -17.828057549999926],
              [179.402679884, -17.818617445999905],
              [179.3950301440001, -17.80641041499996],
              [179.39177493600005, -17.79306405999995],
              [179.39673912900003, -17.780368747999944],
              [179.41374759200005, -17.788995049999926],
              [179.43083743600005, -17.794040622999944],
            ],
          ],
          [
            [
              [178.725761917, -17.72470998999995],
              [178.74191495700006, -17.74958410599993],
              [178.7627059250001, -17.761976820999905],
              [178.77955162900003, -17.76604583099993],
              [178.77711022200003, -17.77320728999996],
              [178.77564537900003, -17.776462497999944],
              [178.77271569100003, -17.780368747999944],
              [178.76587975400003, -17.772881768999923],
              [178.759125196, -17.777520440999922],
              [178.75261478000004, -17.776136976999908],
              [178.74781334700003, -17.76995208099993],
              [178.73468542800003, -17.767566005999925],
              [178.71945461400003, -17.729840682999907],
              [178.71318927000004, -17.71097844199994],
              [178.725761917, -17.72470998999995],
            ],
          ],
          [
            [
              [178.7763778000001, -17.628838799999926],
              [178.78261733300008, -17.622901233999926],
              [178.7978866740001, -17.61860540799995],
              [178.816757672, -17.628951368999935],
              [178.825718187, -17.652098360999958],
              [178.83018832900007, -17.66577428799991],
              [178.831963471, -17.67945025599994],
              [178.83554366700002, -17.693159091999917],
              [178.83282862500005, -17.707721612999933],
              [178.82921779800006, -17.718855850999944],
              [178.82290917300008, -17.72913008899991],
              [178.79771376400004, -17.73595393599993],
              [178.78511382500005, -17.740221472999906],
              [178.7680770190001, -17.747165622999944],
              [178.75818956700004, -17.729916032999938],
              [178.75261478000004, -17.71298593499995],
              [178.73935472900007, -17.673330455999917],
              [178.75109388300007, -17.643363147999935],
              [178.7763778000001, -17.628838799999926],
            ],
          ],
          [
            [
              [179.00538170700008, -17.621351820999905],
              [178.997406446, -17.60800546699994],
              [178.9985457690001, -17.597100518999923],
              [179.0068465500001, -17.593194268999923],
              [179.01970462300005, -17.60084400799991],
              [179.02605228000004, -17.61060963299991],
              [179.0380965500001, -17.642022393999923],
              [179.04078209700003, -17.656182549999926],
              [179.03337649800005, -17.656182549999926],
              [179.02898196700005, -17.64430103999996],
              [179.02320397200003, -17.635430596999925],
              [179.0156356130001, -17.62818775799991],
              [179.00538170700008, -17.621351820999905],
            ],
          ],
          [
            [
              [178.7114363940001, -17.99195728999996],
              [178.7089949880001, -17.999200127999927],
              [178.70069420700008, -18.012872002999927],
              [178.69841556100005, -18.01930103999996],
              [178.69792728000004, -18.03378671699994],
              [178.69841556100005, -18.043145440999922],
              [178.69450931100005, -18.056898695999905],
              [178.6845809250001, -18.07040780999995],
              [178.67310631600003, -18.081475518999923],
              [178.66358483200008, -18.088148695999905],
              [178.61296634200005, -18.112399997999944],
              [178.58863366000003, -18.13600025799991],
              [178.58863366000003, -18.115492445999905],
              [178.55974368600005, -18.12704843499995],
              [178.54761803500003, -18.129082940999922],
              [178.55933678500003, -18.112725518999923],
              [178.5605574880001, -18.10865650799991],
              [178.555023634, -18.099216403999947],
              [178.5507918630001, -18.09775155999995],
              [178.54566491000003, -18.097263278999947],
              [178.53695722700002, -18.091241143999923],
              [178.52711022200003, -18.090020440999922],
              [178.498383009, -18.10442473799992],
              [178.48560631600003, -18.10865650799991],
              [178.48780358200008, -18.129082940999922],
              [178.47022545700008, -18.14185963299991],
              [178.44841556100005, -18.147556247999944],
              [178.43775475400003, -18.14657968499995],
              [178.438812696, -18.131605726999908],
              [178.4399520190001, -18.126071872999944],
              [178.43816165500004, -18.122979424999926],
              [178.42164147200003, -18.10800546699994],
              [178.4130965500001, -18.103448174999926],
              [178.40308678500003, -18.10133228999996],
              [178.38990319100003, -18.101820570999905],
              [178.3925887380001, -18.106215101999908],
              [178.39340254, -18.106622002999927],
              [178.39616946700005, -18.10865650799991],
              [178.39128665500004, -18.11809661299992],
              [178.3857528000001, -18.123793226999908],
              [178.37842858200008, -18.127211195999905],
              [178.36890709700003, -18.129082940999922],
              [178.36939537900003, -18.12664153399993],
              [178.36605879, -18.12200286299992],
              [178.36085045700008, -18.117445570999905],
              [178.35523522200003, -18.115492445999905],
              [178.34839928500003, -18.11687590899993],
              [178.3364363940001, -18.121270440999922],
              [178.33090254, -18.122247002999927],
              [178.32292728000004, -18.12558359199994],
              [178.3169051440001, -18.13290780999995],
              [178.30933678500003, -18.140232028999947],
              [178.2968856130001, -18.14348723799992],
              [178.2841903000001, -18.144138278999947],
              [178.27702884200005, -18.14625416499996],
              [178.271820509, -18.150323174999926],
              [178.26587975400003, -18.156426690999922],
              [178.26189212300005, -18.162774346999925],
              [178.25660241000003, -18.177666924999926],
              [178.25220787900003, -18.183770440999922],
              [178.243500196, -18.188653252999927],
              [178.22291100400003, -18.196058851999908],
              [178.214203321, -18.201104424999926],
              [178.18539472700002, -18.233819268999923],
              [178.168304884, -18.24846770599993],
              [178.149750196, -18.252699476999908],
              [178.14136803500003, -18.252699476999908],
              [178.13550866000003, -18.25945403399993],
              [178.11304772200003, -18.239434502999927],
              [178.03891035200002, -18.26490650799991],
              [178.0063582690001, -18.25945403399993],
              [177.99146569100003, -18.258884372999944],
              [177.985199415, -18.257419528999947],
              [177.97836347700002, -18.252699476999908],
              [177.97193444100003, -18.25872161299992],
              [177.95980879, -18.26572030999995],
              [177.9458113940001, -18.268731377999927],
              [177.9340926440001, -18.262872002999927],
              [177.92107181100005, -18.26067473799992],
              [177.90609785200002, -18.26930103999996],
              [177.89405358200008, -18.27312590899993],
              [177.889008009, -18.256036065999922],
              [177.8857528000001, -18.25164153399993],
              [177.87842858200008, -18.25367603999996],
              [177.870453321, -18.258558851999908],
              [177.86540774800005, -18.262872002999927],
              [177.8593856130001, -18.265801690999922],
              [177.85368899800005, -18.263116143999923],
              [177.8344832690001, -18.24667734199994],
              [177.831390821, -18.23992278399993],
              [177.8271590500001, -18.23447030999995],
              [177.78337649800005, -18.22315846099991],
              [177.698578321, -18.201348565999922],
              [177.67302493600005, -18.198011976999908],
              [177.6450301440001, -18.19109465899993],
              [177.59164472700002, -18.166680596999925],
              [177.56763756600003, -18.170098565999922],
              [177.53687584700003, -18.15683359199994],
              [177.52491295700008, -18.155368747999944],
              [177.47445722700002, -18.157810153999947],
              [177.46509850400003, -18.156426690999922],
              [177.45427493600005, -18.151950778999947],
              [177.447601759, -18.146091403999947],
              [177.44255618600005, -18.140232028999947],
              [177.43718509200005, -18.13600025799991],
              [177.36670983200008, -18.119073174999926],
              [177.3359481130001, -18.10556405999995],
              [177.31364993600005, -18.07390715899993],
              [177.30681399800005, -18.08131275799991],
              [177.30225670700008, -18.07089609199994],
              [177.301605665, -18.051039320999905],
              [177.30005944100003, -18.039727471999925],
              [177.29664147200003, -18.034274997999944],
              [177.29184004, -18.029473565999922],
              [177.2876082690001, -18.022149346999925],
              [177.28581790500004, -18.008965752999927],
              [177.28109785200002, -18.00367603999996],
              [177.26295006600003, -17.99382903399993],
              [177.26246178500003, -17.988539320999905],
              [177.266449415, -17.97942473799992],
              [177.262054884, -17.971368096999925],
              [177.25513756600003, -17.962823174999926],
              [177.25163821700005, -17.952243747999944],
              [177.25456790500004, -17.94459400799991],
              [177.267914259, -17.927178643999923],
              [177.27214603000004, -17.91692473799992],
              [177.2714949880001, -17.904229424999926],
              [177.26677493600005, -17.896416924999926],
              [177.26156660200002, -17.889336846999925],
              [177.25904381600003, -17.87932708099993],
              [177.2656356130001, -17.859551690999922],
              [177.282074415, -17.851739190999922],
              [177.32732181100005, -17.84856536299992],
              [177.35417728000004, -17.838636976999908],
              [177.36150149800005, -17.83489348799992],
              [177.371429884, -17.823418877999927],
              [177.37289472700002, -17.815199476999908],
              [177.37061608200008, -17.807793877999927],
              [177.36890709700003, -17.79745859199994],
              [177.36890709700003, -17.76262786299992],
              [177.37029056100005, -17.74968840899993],
              [177.37427819100003, -17.747491143999923],
              [177.3808699880001, -17.750176690999922],
              [177.4160262380001, -17.75986093499995],
              [177.42351321700005, -17.759209893999923],
              [177.43433678500003, -17.750176690999922],
              [177.43531334700003, -17.743259372999944],
              [177.431976759, -17.736504815999922],
              [177.4296981130001, -17.72820403399993],
              [177.4287215500001, -17.717054945999905],
              [177.42448978000004, -17.697523695999905],
              [177.42351321700005, -17.68759530999995],
              [177.42058353000004, -17.67831796699994],
              [177.41325931100005, -17.674086195999905],
              [177.40398196700005, -17.670586846999925],
              [177.39568118600005, -17.66301848799992],
              [177.38892662900003, -17.640557549999926],
              [177.40211022200003, -17.63054778399993],
              [177.4204207690001, -17.62232838299991],
              [177.4296981130001, -17.604668877999927],
              [177.43433678500003, -17.597914320999905],
              [177.45655358200008, -17.59270598799992],
              [177.46509850400003, -17.58798593499995],
              [177.46900475400003, -17.576348565999922],
              [177.467133009, -17.56536223799992],
              [177.46745853000004, -17.555352471999925],
              [177.47820071700005, -17.546319268999923],
              [177.489593946, -17.558851820999905],
              [177.49952233200008, -17.555759372999944],
              [177.5039168630001, -17.544528903999947],
              [177.49927819100003, -17.532647393999923],
              [177.5063582690001, -17.517836195999905],
              [177.51514733200008, -17.505059502999927],
              [177.5244246750001, -17.500746351999908],
              [177.53337649800005, -17.51213958099993],
              [177.5395613940001, -17.51213958099993],
              [177.58130944100003, -17.478122653999947],
              [177.6220809250001, -17.454685153999947],
              [177.6250106130001, -17.450778903999947],
              [177.62818444100003, -17.44850025799991],
              [177.6289168630001, -17.44394296699994],
              [177.63111412900003, -17.43922291499996],
              [177.63892662900003, -17.437107028999947],
              [177.645355665, -17.438164971999925],
              [177.65259850400003, -17.440524997999944],
              [177.6562606130001, -17.442803643999923],
              [177.65259850400003, -17.44394296699994],
              [177.646820509, -17.45175546699994],
              [177.65007571700005, -17.469414971999925],
              [177.6572371750001, -17.48796965899993],
              [177.6630965500001, -17.49846770599993],
              [177.669281446, -17.492364190999922],
              [177.6630965500001, -17.479668877999927],
              [177.6591903000001, -17.46803150799991],
              [177.65894616000003, -17.456638278999947],
              [177.6630965500001, -17.44394296699994],
              [177.67058353000004, -17.43840911299992],
              [177.7041121750001, -17.42034270599993],
              [177.71013431100005, -17.417901299999926],
              [177.74878991000003, -17.43027109199994],
              [177.7539168630001, -17.424899997999944],
              [177.756195509, -17.413262627999927],
              [177.76091556100005, -17.401543877999927],
              [177.76547285200002, -17.396661065999922],
              [177.77361087300005, -17.392754815999922],
              [177.7802840500001, -17.388278903999947],
              [177.78728274800005, -17.38453541499996],
              [177.8076278000001, -17.38095468499995],
              [177.8115340500001, -17.376153252999927],
              [177.81413821700005, -17.371270440999922],
              [177.82545006600003, -17.366631768999923],
              [177.82992597700002, -17.364027601999908],
              [177.83326256600003, -17.36646900799991],
              [177.8344832690001, -17.37932708099993],
              [177.83366946700005, -17.390232028999947],
              [177.8310653000001, -17.399834893999923],
              [177.8266707690001, -17.40878671699994],
              [177.82016035200002, -17.417168877999927],
              [177.836273634, -17.421319268999923],
              [177.84986412900003, -17.413181247999944],
              [177.8623153000001, -17.40007903399993],
              [177.8759871750001, -17.389336846999925],
              [177.89730879, -17.40292734199994],
              [177.926605665, -17.40593840899993],
              [177.95622806100005, -17.402520440999922],
              [177.97836347700002, -17.396661065999922],
              [178.007172071, -17.383477471999925],
              [178.01937910200002, -17.375176690999922],
              [178.03003991000003, -17.365411065999922],
              [178.04224694100003, -17.356866143999923],
              [178.06592858200008, -17.35588958099993],
              [178.081390821, -17.348321221999925],
              [178.1137801440001, -17.35320403399993],
              [178.15105228000004, -17.346856377999927],
              [178.18083743600005, -17.329278252999927],
              [178.19011478000004, -17.30055103999996],
              [178.21168053500003, -17.307712497999944],
              [178.239105665, -17.32008228999996],
              [178.2627059250001, -17.33562590899993],
              [178.27271569100003, -17.351739190999922],
              [178.27556399800005, -17.36370208099993],
              [178.286468946, -17.38372161299992],
              [178.28630618600005, -17.396661065999922],
              [178.27955162900003, -17.407403252999927],
              [178.2544051440001, -17.431817315999922],
              [178.24537194100003, -17.44394296699994],
              [178.25603274800005, -17.44963958099993],
              [178.25806725400003, -17.45745208099993],
              [178.25375410200002, -17.465508721999925],
              [178.24537194100003, -17.47128671699994],
              [178.258636915, -17.468926690999922],
              [178.285980665, -17.43808359199994],
              [178.3037215500001, -17.43027109199994],
              [178.327484571, -17.432793877999927],
              [178.34831790500004, -17.440118096999925],
              [178.364593946, -17.45289478999996],
              [178.37574303500003, -17.47128671699994],
              [178.37720787900003, -17.47975025799991],
              [178.37427819100003, -17.491387627999927],
              [178.37574303500003, -17.49846770599993],
              [178.3794051440001, -17.500258070999905],
              [178.3974715500001, -17.51531340899993],
              [178.39991295700008, -17.518975518999923],
              [178.40357506600003, -17.52239348799992],
              [178.44548587300005, -17.549899997999944],
              [178.4555770190001, -17.55120208099993],
              [178.46607506600003, -17.550957940999922],
              [178.47877037900003, -17.55315520599993],
              [178.49626712300005, -17.565118096999925],
              [178.52295983200008, -17.60084400799991],
              [178.5302840500001, -17.60833098799992],
              [178.55193118600005, -17.610772393999923],
              [178.57300866000003, -17.617933851999908],
              [178.5908309250001, -17.63095468499995],
              [178.60230553500003, -17.649997653999947],
              [178.60328209700003, -17.674574476999908],
              [178.59294681100005, -17.69345468499995],
              [178.5805770190001, -17.710056247999944],
              [178.5742293630001, -17.72820403399993],
              [178.57252037900003, -17.737725518999923],
              [178.5693465500001, -17.74651458099993],
              [178.567718946, -17.754978122999944],
              [178.571136915, -17.76262786299992],
              [178.578949415, -17.76921965899993],
              [178.59750410200002, -17.78183359199994],
              [178.60230553500003, -17.786553643999923],
              [178.60303795700008, -17.798435153999947],
              [178.5996199880001, -17.809340101999908],
              [178.59888756600003, -17.819431247999944],
              [178.6084090500001, -17.828057549999926],
              [178.62061608200008, -17.82350025799991],
              [178.62720787900003, -17.826836846999925],
              [178.626312696, -17.83407968499995],
              [178.61589603000004, -17.84107838299991],
              [178.6279403000001, -17.84579843499995],
              [178.63502037900003, -17.853448174999926],
              [178.63599694100003, -17.86370208099993],
              [178.62956790500004, -17.87590911299992],
              [178.625824415, -17.87363046699994],
              [178.61589603000004, -17.869073174999926],
              [178.61793053500003, -17.873793226999908],
              [178.62273196700005, -17.890232028999947],
              [178.59107506600003, -17.897556247999944],
              [178.59489993600005, -17.926039320999905],
              [178.61312910200002, -17.956963799999926],
              [178.62614993600005, -17.971449476999908],
              [178.64576256600003, -17.97323984199994],
              [178.6543074880001, -17.978448174999926],
              [178.65967858200008, -17.986993096999925],
              [178.6704207690001, -17.998793226999908],
              [178.674164259, -18.00432708099993],
              [178.67457116000003, -18.00872161299992],
              [178.67701256600003, -18.01140715899993],
              [178.68767337300005, -18.012383721999925],
              [178.6938582690001, -18.009942315999922],
              [178.6992293630001, -18.003838799999926],
              [178.70329837300005, -17.99700286299992],
              [178.70533287900003, -17.99195728999996],
              [178.7114363940001, -17.99195728999996],
            ],
          ],
          [
            [
              [177.09392337300005, -17.245293877999927],
              [177.1201278000001, -17.255466403999947],
              [177.13257897200003, -17.25448984199994],
              [177.14918053500003, -17.245293877999927],
              [177.16285241000003, -17.265801690999922],
              [177.15601647200003, -17.267022393999923],
              [177.15308678500003, -17.270684502999927],
              [177.15186608200008, -17.27516041499996],
              [177.1377059250001, -17.294854424999926],
              [177.12452233200008, -17.306817315999922],
              [177.1118270190001, -17.31031666499996],
              [177.10132897200003, -17.30055103999996],
              [177.09945722700002, -17.283949476999908],
              [177.1040145190001, -17.270277601999908],
              [177.10523522200003, -17.259698174999926],
              [177.09392337300005, -17.252699476999908],
              [177.09392337300005, -17.245293877999927],
            ],
          ],
          [
            [
              [179.45191491000003, -17.29029713299991],
              [179.44988040500004, -17.31609465899993],
              [179.4433699880001, -17.338636976999908],
              [179.43287194100003, -17.35833098799992],
              [179.41781660200002, -17.375664971999925],
              [179.39087975400003, -17.39625416499996],
              [179.38347415500004, -17.390557549999926],
              [179.38347415500004, -17.331231377999927],
              [179.3813582690001, -17.315199476999908],
              [179.376312696, -17.30055103999996],
              [179.36882571700005, -17.28679778399993],
              [179.3720809250001, -17.273370049999926],
              [179.37134850400003, -17.25986093499995],
              [179.37867272200003, -17.249444268999923],
              [179.41968834700003, -17.243747653999947],
              [179.42920983200008, -17.24114348799992],
              [179.437836134, -17.241794528999947],
              [179.4482528000001, -17.249118747999944],
              [179.44809004, -17.25514088299991],
              [179.45191491000003, -17.29029713299991],
            ],
          ],
          [
            [
              [177.27214603000004, -17.080824476999908],
              [177.2758895190001, -17.074151299999926],
              [177.28581790500004, -17.04664478999996],
              [177.29224694100003, -17.058526299999926],
              [177.29265384200005, -17.07236093499995],
              [177.28785241000003, -17.08521900799991],
              [177.27955162900003, -17.094414971999925],
              [177.27173912900003, -17.112725518999923],
              [177.24170983200008, -17.132745049999926],
              [177.23804772200003, -17.149102471999925],
              [177.23365319100003, -17.145684502999927],
              [177.23031660200002, -17.14381275799991],
              [177.227386915, -17.14120859199994],
              [177.22429446700005, -17.135430596999925],
              [177.21461022200003, -17.141289971999925],
              [177.2075301440001, -17.14820728999996],
              [177.20378665500004, -17.157321872999944],
              [177.20378665500004, -17.16961028399993],
              [177.17595462300005, -17.16334400799991],
              [177.17595462300005, -17.15593840899993],
              [177.18677819100003, -17.15634530999995],
              [177.19019616000003, -17.15593840899993],
              [177.18637129, -17.14625416499996],
              [177.184418165, -17.13258228999996],
              [177.1860457690001, -17.120293877999927],
              [177.19361412900003, -17.11492278399993],
              [177.202484571, -17.11101653399993],
              [177.20622806100005, -17.101495049999926],
              [177.20777428500003, -17.09026458099993],
              [177.21119225400003, -17.080824476999908],
              [177.21827233200008, -17.073825778999947],
              [177.240570509, -17.056817315999922],
              [177.2485457690001, -17.053480726999908],
              [177.24968509200005, -17.057712497999944],
              [177.26140384200005, -17.07594166499996],
              [177.26587975400003, -17.080824476999908],
              [177.27214603000004, -17.080824476999908],
            ],
          ],
          [
            [
              [177.443695509, -16.867852471999925],
              [177.41293379, -16.891289971999925],
              [177.403656446, -16.902601820999905],
              [177.4165145190001, -16.90943775799991],
              [177.41325931100005, -16.91725025799991],
              [177.40845787900003, -16.924493096999925],
              [177.40259850400003, -16.931084893999923],
              [177.395355665, -16.93678150799991],
              [177.3925887380001, -16.93132903399993],
              [177.38559004, -16.92245859199994],
              [177.3730574880001, -16.90292734199994],
              [177.3789168630001, -16.893649997999944],
              [177.4028426440001, -16.881524346999925],
              [177.39576256600003, -16.86614348799992],
              [177.4082137380001, -16.86109791499996],
              [177.4282332690001, -16.862888278999947],
              [177.443695509, -16.867852471999925],
            ],
          ],
          [
            [
              [178.3339949880001, -16.79338958099993],
              [178.3300887380001, -16.814060153999947],
              [178.33562259200005, -16.82512786299992],
              [178.33366946700005, -16.828871351999908],
              [178.30738366000003, -16.827569268999923],
              [178.29021243600005, -16.83440520599993],
              [178.28296959700003, -16.82236093499995],
              [178.28003991000003, -16.786716403999947],
              [178.28630618600005, -16.786716403999947],
              [178.29468834700003, -16.792087497999944],
              [178.30640709700003, -16.79387786299992],
              [178.3339949880001, -16.79338958099993],
            ],
          ],
          [
            [
              [177.56072024800005, -16.676853122999944],
              [177.57992597700002, -16.67815520599993],
              [177.591156446, -16.686211846999925],
              [177.59400475400003, -16.699965101999908],
              [177.58741295700008, -16.71770598799992],
              [177.58033287900003, -16.728448174999926],
              [177.56397545700008, -16.73992278399993],
              [177.56072024800005, -16.748711846999925],
              [177.55648847700002, -16.753838799999926],
              [177.49341881600003, -16.802666924999926],
              [177.47925866000003, -16.817071221999925],
              [177.47136478000004, -16.83440520599993],
              [177.4614363940001, -16.83017343499995],
              [177.45777428500003, -16.827569268999923],
              [177.4531356130001, -16.833184502999927],
              [177.44556725400003, -16.838555596999925],
              [177.43718509200005, -16.840020440999922],
              [177.4296981130001, -16.83440520599993],
              [177.43034915500004, -16.82822030999995],
              [177.43637129, -16.80364348799992],
              [177.43718509200005, -16.79338958099993],
              [177.44402103000004, -16.79338958099993],
              [177.45655358200008, -16.80559661299992],
              [177.47535241000003, -16.79664478999996],
              [177.51295006600003, -16.75872161299992],
              [177.5586043630001, -16.721449476999908],
              [177.57252037900003, -16.699476820999905],
              [177.56072024800005, -16.676853122999944],
            ],
          ],
          [
            [
              [179.91749108200008, -16.65553150799991],
              [179.8833113940001, -16.65553150799991],
              [179.90007571700005, -16.65016041499996],
              [179.9072371750001, -16.649509372999944],
              [179.91089928500003, -16.64625416499996],
              [179.9101668630001, -16.63209400799991],
              [179.9140731130001, -16.62900155999995],
              [179.92335045700008, -16.62818775799991],
              [179.9345809250001, -16.62509530999995],
              [179.94499759200005, -16.618747653999947],
              [179.9516707690001, -16.60784270599993],
              [179.95264733200008, -16.628350518999923],
              [179.94743899800005, -16.644463799999926],
              [179.93580162900003, -16.65406666499996],
              [179.91749108200008, -16.65553150799991],
            ],
          ],
          [
            [
              [178.588226759, -16.573011976999908],
              [178.5966903000001, -16.578383070999905],
              [178.60515384200005, -16.580010674999926],
              [178.6137801440001, -16.578057549999926],
              [178.62256920700008, -16.573011976999908],
              [178.6157332690001, -16.58375416499996],
              [178.60613040500004, -16.591729424999926],
              [178.59245853000004, -16.595635674999926],
              [178.57398522200003, -16.59417083099993],
              [178.566742384, -16.592461846999925],
              [178.56364993600005, -16.590915622999944],
              [178.56039472700002, -16.587334893999923],
              [178.588226759, -16.573011976999908],
            ],
          ],
          [
            [
              [179.3623153000001, -16.32659270599993],
              [179.37663821700005, -16.328871351999908],
              [179.3896590500001, -16.333591403999947],
              [179.3774520190001, -16.339043877999927],
              [179.36117597700002, -16.34075286299992],
              [179.3437606130001, -16.338962497999944],
              [179.3281356130001, -16.333591403999947],
              [179.3281356130001, -16.32659270599993],
              [179.3623153000001, -16.32659270599993],
            ],
          ],
          [
            [
              [177.12476647200003, -12.48609791499996],
              [177.12907962300005, -12.50164153399993],
              [177.113617384, -12.51140715899993],
              [177.09107506600003, -12.516371351999908],
              [177.07341556100005, -12.51685963299991],
              [177.0595809250001, -12.511976820999905],
              [177.04363040500004, -12.508477471999925],
              [177.02711022200003, -12.507256768999923],
              [177.01148522200003, -12.50945403399993],
              [177.00660241000003, -12.494724216999941],
              [177.0058699880001, -12.48951588299991],
              [177.020843946, -12.493584893999923],
              [177.03296959700003, -12.491387627999927],
              [177.05974368600005, -12.475274346999925],
              [177.0752059250001, -12.480645440999922],
              [177.11117597700002, -12.480645440999922],
              [177.12476647200003, -12.48609791499996],
            ],
          ],
          [
            [
              [174.61589603000004, -21.711114190999922],
              [174.59685306100005, -21.698418877999927],
              [174.5888778000001, -21.681573174999926],
              [174.59400475400003, -21.668715101999908],
              [174.614105665, -21.668226820999905],
              [174.62663821700005, -21.676527601999908],
              [174.631195509, -21.689629815999922],
              [174.62777754, -21.702569268999923],
              [174.61589603000004, -21.711114190999922],
            ],
          ],
          [
            [
              [-178.71906490799992, -20.670993747999944],
              [-178.72724361899992, -20.664727471999925],
              [-178.73102779899992, -20.657647393999923],
              [-178.73029537699992, -20.65007903399993],
              [-178.7249649729999, -20.64234791499996],
              [-178.72423255099991, -20.65097421699994],
              [-178.72081458199992, -20.659274997999944],
              [-178.71528072799993, -20.666192315999922],
              [-178.7081192699999, -20.671319268999923],
              [-178.71100826699993, -20.671807549999926],
              [-178.71906490799992, -20.670993747999944],
            ],
          ],
          [
            [
              [-178.2267960279999, -19.840020440999922],
              [-178.23053951699993, -19.83521900799991],
              [-178.22895260299993, -19.82903411299992],
              [-178.2236221999999, -19.822198174999926],
              [-178.2161352199999, -19.815199476999908],
              [-178.21760006399992, -19.821872653999947],
              [-178.2200414699999, -19.82789478999996],
              [-178.2267960279999, -19.840020440999922],
            ],
          ],
          [
            [
              [-178.4197891919999, -19.167413018999923],
              [-178.4011124339999, -19.133477471999925],
              [-178.3929337229999, -19.12753671699994],
              [-178.3892716139999, -19.146416924999926],
              [-178.3919571609999, -19.16578541499996],
              [-178.39960689999992, -19.170993747999944],
              [-178.40937252499992, -19.171807549999926],
              [-178.41881262899992, -19.17864348799992],
              [-178.42170162699992, -19.17620208099993],
              [-178.42198645699992, -19.173760674999926],
              [-178.4197891919999, -19.167413018999923],
            ],
          ],
          [
            [
              [-178.89964758999992, -18.877129815999922],
              [-178.9072159499999, -18.881524346999925],
              [-178.91486568899992, -18.88404713299991],
              [-178.9225968089999, -18.884372653999947],
              [-178.9306127589999, -18.88209400799991],
              [-178.91950436099992, -18.872653903999947],
              [-178.90729732999992, -18.864027601999908],
              [-178.89399166599992, -18.857598565999922],
              [-178.8798721999999, -18.854261976999908],
              [-178.88385982999992, -18.860772393999923],
              [-178.8885391919999, -18.866794528999947],
              [-178.89378821499992, -18.872247002999927],
              [-178.89964758999992, -18.877129815999922],
            ],
          ],
          [
            [
              [-178.5071508449999, -18.665215752999927],
              [-178.51630611899992, -18.649997653999947],
              [-178.5110977859999, -18.63795338299991],
              [-178.49921627499992, -18.63372161299992],
              [-178.48798580599993, -18.641371351999908],
              [-178.48607337099992, -18.651788018999923],
              [-178.49030514199993, -18.66073984199994],
              [-178.49811764199993, -18.665948174999926],
              [-178.5071508449999, -18.665215752999927],
            ],
          ],
          [
            [
              [-179.32258053299992, -17.770196221999925],
              [-179.33613033799992, -17.758477471999925],
              [-179.3342179029999, -17.74000416499996],
              [-179.3203018869999, -17.724867445999905],
              [-179.29808508999992, -17.72323984199994],
              [-179.27973385299993, -17.739434502999927],
              [-179.2807511059999, -17.76018645599993],
              [-179.29645748599992, -17.774183851999908],
              [-179.32258053299992, -17.770196221999925],
            ],
          ],
          [
            [
              [-179.1566055979999, -17.471368096999925],
              [-179.1728002589999, -17.45794036299992],
              [-179.17548580599993, -17.439711195999905],
              [-179.1660050119999, -17.42555103999996],
              [-179.14557857999992, -17.42424895599993],
              [-179.13471432199992, -17.43531666499996],
              [-179.13080807199992, -17.45370859199994],
              [-179.1370743479999, -17.468926690999922],
              [-179.1566055979999, -17.471368096999925],
            ],
          ],
          [
            [
              [-179.15729732999992, -17.27271900799991],
              [-179.15668697799993, -17.254082940999922],
              [-179.1464737619999, -17.247979424999926],
              [-179.13438880099991, -17.252129815999922],
              [-179.1278783839999, -17.26490650799991],
              [-179.13080807199992, -17.27703215899993],
              [-179.1392716139999, -17.28329843499995],
              [-179.14948482999992, -17.28215911299992],
              [-179.15729732999992, -17.27271900799991],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'New Zealand',
        iso3: 'NZL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [166.13697350400003, -50.864353122999944],
              [166.20525149800005, -50.875664971999925],
              [166.22632897200003, -50.885430596999925],
              [166.212250196, -50.89023202899995],
              [166.18425540500004, -50.89413827899995],
              [166.1572371750001, -50.90325286299992],
              [166.14340254, -50.904554945999905],
              [166.12964928500003, -50.902601820999905],
              [166.12273196700005, -50.912041924999926],
              [165.98552493600005, -50.90439218499995],
              [165.97828209700003, -50.9001604149999],
              [165.97388756600003, -50.89373137799993],
              [165.96501712300005, -50.885430596999925],
              [165.9419051440001, -50.87200286299992],
              [165.93181399800005, -50.86370208099993],
              [165.92408287900003, -50.85125090899993],
              [165.9423934250001, -50.85295989399992],
              [165.958343946, -50.85906340899993],
              [165.985687696, -50.87460702899995],
              [165.99984785200002, -50.8747697899999],
              [166.07683353000004, -50.862399997999944],
              [166.08961022200003, -50.853448174999926],
              [166.09587649800005, -50.85125090899993],
              [166.10710696700005, -50.85230885199991],
              [166.13697350400003, -50.864353122999944],
            ],
          ],
          [
            [
              [169.2504205030001, -52.52025656899991],
              [169.26043805900008, -52.544456442999945],
              [169.26157356700003, -52.55454375699992],
              [169.2450014640001, -52.56263498599992],
              [169.23728123400008, -52.57273179899994],
              [169.22957151100002, -52.58753157399991],
              [169.195295622, -52.60031327099995],
              [169.16654098000004, -52.59828147399992],
              [169.13223884400009, -52.5955919349999],
              [169.11897578100002, -52.588187013999914],
              [169.100190043, -52.579436039999905],
              [169.08474669600002, -52.574707926999906],
              [169.07372449900004, -52.564612946999944],
              [169.06151037300003, -52.56127017499995],
              [169.05148731100007, -52.56868165499992],
              [169.02564537900003, -52.55348072699991],
              [169.01539147200003, -52.54265715899993],
              [169.024843648, -52.53374952999991],
              [169.04590301200005, -52.535096997999915],
              [169.08253733900005, -52.54178847999992],
              [169.11359322500005, -52.5464534699999],
              [169.1201422050001, -52.52700069999992],
              [169.12890825500006, -52.50954676099991],
              [169.1443050370001, -52.49006050999992],
              [169.159764881, -52.480641747999925],
              [169.18625471100006, -52.46919912099992],
              [169.205022085, -52.469188155999916],
              [169.21275979100005, -52.47456229399995],
              [169.2089949880001, -52.48406340899993],
              [169.222015821, -52.48316822699991],
              [169.234711134, -52.488539320999905],
              [169.24170983200008, -52.497165622999944],
              [169.27468932200009, -52.50542996599995],
              [169.293523962, -52.520198459999904],
              [169.27475114600009, -52.524258183999905],
              [169.2504205030001, -52.52025656899991],
            ],
          ],
          [
            [
              [166.24341881600003, -50.60076262799993],
              [166.22624759200005, -50.61142343499995],
              [166.21404056100005, -50.60865650799991],
              [166.20183353000004, -50.60466887799993],
              [166.18474368600005, -50.61101653399993],
              [166.1953231130001, -50.61842213299991],
              [166.20240319100003, -50.62818775799991],
              [166.21208743600005, -50.652601820999905],
              [166.205414259, -50.65048593499995],
              [166.19117272200003, -50.64804452899995],
              [166.18474368600005, -50.64576588299991],
              [166.18913821700005, -50.66057708099993],
              [166.19214928500003, -50.666273695999905],
              [166.18433678500003, -50.670586846999925],
              [166.16431725400003, -50.68678150799991],
              [166.17945397200003, -50.68320077899995],
              [166.1958113940001, -50.68328215899993],
              [166.21208743600005, -50.68678150799991],
              [166.22632897200003, -50.69353606599992],
              [166.20240319100003, -50.70077890399995],
              [166.1494246750001, -50.69687265399995],
              [166.12273196700005, -50.70037200299993],
              [166.12273196700005, -50.70720794099992],
              [166.14234459700003, -50.70712655999995],
              [166.17725670700008, -50.719821872999944],
              [166.19841556100005, -50.72087981599992],
              [166.18921959700003, -50.73845794099992],
              [166.17790774800005, -50.75505950299993],
              [166.1933699880001, -50.755791924999926],
              [166.21941165500004, -50.75351327899995],
              [166.23259524800005, -50.75505950299993],
              [166.22820071700005, -50.76376718499995],
              [166.22681725400003, -50.77239348799992],
              [166.22828209700003, -50.781182549999926],
              [166.23259524800005, -50.789727471999925],
              [166.22413170700008, -50.78915780999995],
              [166.20679772200003, -50.79029713299991],
              [166.19841556100005, -50.789727471999925],
              [166.19841556100005, -50.79656340899993],
              [166.21208743600005, -50.797539971999925],
              [166.22999108200008, -50.802992445999905],
              [166.24594160200002, -50.810479424999926],
              [166.25367272200003, -50.817071221999925],
              [166.25114993600005, -50.83416106599992],
              [166.24008222700002, -50.85100676899992],
              [166.22437584700003, -50.86012135199991],
              [166.20883222700002, -50.85466887799993],
              [166.184906446, -50.8415666649999],
              [166.15357506600003, -50.83456796699994],
              [166.1250106130001, -50.824476820999905],
              [166.10889733200008, -50.80282968499995],
              [166.09831790500004, -50.813164971999925],
              [166.08668053500003, -50.820245049999926],
              [166.06120853000004, -50.830743096999925],
              [166.06755618600005, -50.81755950299993],
              [166.07740319100003, -50.80242278399993],
              [166.08350670700008, -50.78679778399993],
              [166.0786238940001, -50.77239348799992],
              [166.06763756600003, -50.761976820999905],
              [166.05437259200005, -50.75359465899993],
              [166.04021243600005, -50.75204843499995],
              [166.02711022200003, -50.76246510199991],
              [166.0361434250001, -50.76775481599992],
              [166.0473738940001, -50.77703215899993],
              [166.05290774800005, -50.78590260199991],
              [166.04444420700008, -50.789727471999925],
              [166.030609571, -50.7868791649999],
              [166.00749759200005, -50.77629973799992],
              [165.99293053500003, -50.77613697699991],
              [166.0039168630001, -50.78533294099992],
              [166.0141707690001, -50.79119231599992],
              [166.02230879, -50.79802825299993],
              [166.02711022200003, -50.81023528399993],
              [166.02686608200008, -50.82537200299993],
              [166.0214949880001, -50.83603280999995],
              [166.011078321, -50.84238046699994],
              [165.99634850400003, -50.844414971999925],
              [165.97868899800005, -50.8435197899999],
              [165.9653426440001, -50.840101820999905],
              [165.95386803500003, -50.83294036299992],
              [165.9414168630001, -50.82048919099992],
              [165.93311608200008, -50.821384372999944],
              [165.92017662900003, -50.83049895599993],
              [165.89673912900003, -50.85125090899993],
              [165.88648522200003, -50.79461028399993],
              [165.92530358200008, -50.75400155999995],
              [166.0590926440001, -50.69353606599992],
              [166.07878665500004, -50.6755510399999],
              [166.09148196700005, -50.65195077899995],
              [166.09587649800005, -50.62127044099992],
              [166.10320071700005, -50.59856536299992],
              [166.1152449880001, -50.574476820999905],
              [166.1176863940001, -50.55242278399993],
              [166.09587649800005, -50.53590260199991],
              [166.1132918630001, -50.53248463299991],
              [166.12647545700008, -50.52776458099993],
              [166.13990319100003, -50.526055596999925],
              [166.15748131600003, -50.53215911299992],
              [166.17115319100003, -50.53281015399995],
              [166.21941165500004, -50.526055596999925],
              [166.23259524800005, -50.52223072699991],
              [166.23072350400003, -50.52874114399992],
              [166.2285262380001, -50.54257577899995],
              [166.22632897200003, -50.54900481599992],
              [166.242523634, -50.549493096999925],
              [166.28777103000004, -50.5427385399999],
              [166.2841903000001, -50.54843515399995],
              [166.28825931100005, -50.56015390399995],
              [166.29558353000004, -50.57154713299991],
              [166.30201256600003, -50.57691822699991],
              [166.26050866000003, -50.57691822699991],
              [166.250824415, -50.57935963299991],
              [166.24781334700003, -50.58554452899995],
              [166.2470809250001, -50.59319426899992],
              [166.24341881600003, -50.60076262799993],
            ],
          ],
          [
            [
              [178.83904056100005, -49.629164320999905],
              [178.84392337300005, -49.64609140399995],
              [178.83904056100005, -49.66269296699994],
              [178.83155358200008, -49.6794572899999],
              [178.827484571, -49.69646575299993],
              [178.82634524800005, -49.713148695999905],
              [178.82211347700002, -49.719821872999944],
              [178.81397545700008, -49.72079843499995],
              [178.77320397200003, -49.71990325299993],
              [178.74170983200008, -49.71453215899993],
              [178.71900475400003, -49.70012786299992],
              [178.71762129, -49.672539971999925],
              [178.72803795700008, -49.66073984199994],
              [178.77076256600003, -49.627211195999905],
              [178.7871199880001, -49.617852471999925],
              [178.80062910200002, -49.61492278399993],
              [178.81519616000003, -49.61541106599992],
              [178.82886803500003, -49.61988697699991],
              [178.83904056100005, -49.629164320999905],
            ],
          ],
          [
            [
              [-176.1452530589999, -44.24814218499995],
              [-176.13886471299992, -44.25269947699991],
              [-176.1138809889999, -44.26506926899992],
              [-176.14887447799993, -44.28240325299993],
              [-176.1588028639999, -44.29509856599992],
              [-176.1623429029999, -44.31658294099992],
              [-176.19884192599991, -44.335056247999944],
              [-176.2189835279999, -44.34124114399992],
              [-176.21760006399992, -44.327243747999944],
              [-176.22118079299992, -44.3239885399999],
              [-176.2275284499999, -44.3161760399999],
              [-176.2311905589999, -44.31292083099993],
              [-176.2274877589999, -44.30974700299993],
              [-176.2311905589999, -44.30673593499995],
              [-176.22565670499992, -44.2985979149999],
              [-176.21247311099992, -44.27263762799993],
              [-176.21068274599992, -44.26506926899992],
              [-176.22138424399992, -44.25237395599993],
              [-176.23261471299992, -44.24700286299992],
              [-176.23607337099992, -44.2419572899999],
              [-176.2237442699999, -44.23088958099993],
              [-176.20905514199993, -44.22478606599992],
              [-176.18915768099993, -44.22144947699991],
              [-176.16950436099992, -44.22112395599993],
              [-176.15546627499992, -44.22421640399995],
              [-176.15021725199992, -44.229180596999925],
              [-176.14887447799993, -44.23552825299993],
              [-176.1483048169999, -44.2419572899999],
              [-176.1452530589999, -44.24814218499995],
            ],
          ],
          [
            [
              [-176.38202877499992, -43.89861419099992],
              [-176.3851212229999, -43.90667083099993],
              [-176.3919571609999, -43.9099260399999],
              [-176.3987930979999, -43.90764739399992],
              [-176.40192623599992, -43.89861419099992],
              [-176.40160071499992, -43.87468840899993],
              [-176.4036759109999, -43.86419036299992],
              [-176.40937252499992, -43.854180596999925],
              [-176.3940323559999, -43.84514739399992],
              [-176.3741348949999, -43.82675546699994],
              [-176.3580216139999, -43.80486419099992],
              [-176.3541153639999, -43.78590260199991],
              [-176.37226314999992, -43.765883070999905],
              [-176.40192623599992, -43.758477471999925],
              [-176.4565323559999, -43.75798919099992],
              [-176.5130509109999, -43.75017669099992],
              [-176.5353897779999, -43.7556291649999],
              [-176.53290768099993, -43.7790666649999],
              [-176.51423092399992, -43.79143645599993],
              [-176.42304439999992, -43.80584075299993],
              [-176.49640865799992, -43.85116952899995],
              [-176.50153561099992, -43.86443450299993],
              [-176.46735592399992, -43.89861419099992],
              [-176.4597061839999, -43.91171640399995],
              [-176.4592179029999, -43.92457447699991],
              [-176.4600723949999, -43.9372697899999],
              [-176.4565323559999, -43.94980234199994],
              [-176.43321692599991, -43.96298593499995],
              [-176.39521236899992, -43.938571872999944],
              [-176.38886471299992, -43.96062590899993],
              [-176.38719641799992, -43.97616952899995],
              [-176.38239498599992, -43.98577239399992],
              [-176.36469479099992, -44.00164153399993],
              [-176.35163326699993, -44.00920989399992],
              [-176.3244522779999, -44.014336846999925],
              [-176.31318111899992, -44.0193010399999],
              [-176.30003821499992, -44.04257577899995],
              [-176.3290909499999, -44.05046965899993],
              [-176.3714493479999, -44.05217864399992],
              [-176.39850826699993, -44.056573174999926],
              [-176.40876217399992, -44.06210702899995],
              [-176.43549557199992, -44.0700822899999],
              [-176.4600723949999, -44.08652109199994],
              [-176.50495357999992, -44.10125090899993],
              [-176.51178951699993, -44.121758721999925],
              [-176.51915442599991, -44.12314218499995],
              [-176.58149166599992, -44.12314218499995],
              [-176.5999649729999, -44.12004973799992],
              [-176.60798092399992, -44.11150481599992],
              [-176.61058508999992, -44.090101820999905],
              [-176.6177872389999, -44.071384372999944],
              [-176.64146887899992, -44.0329729149999],
              [-176.6493627589999, -44.02792734199994],
              [-176.65961666599992, -44.02385833099993],
              [-176.66437740799992, -44.01921965899993],
              [-176.6557511059999, -44.01189544099992],
              [-176.63337154899992, -44.00351327899995],
              [-176.57433020699992, -43.969414971999925],
              [-176.56330318899992, -43.96062590899993],
              [-176.55817623599992, -43.949476820999905],
              [-176.5351456369999, -43.93808359199994],
              [-176.51593990799992, -43.92229583099993],
              [-176.52228756399992, -43.89861419099992],
              [-176.56615149599992, -43.837823174999926],
              [-176.5881241529999, -43.8200822899999],
              [-176.6113175119999, -43.80584075299993],
              [-176.62372799399992, -43.80136484199994],
              [-176.63837643099993, -43.79957447699991],
              [-176.6530655589999, -43.80217864399992],
              [-176.6635636059999, -43.80706145599993],
              [-176.6725968089999, -43.809665622999944],
              [-176.68305416599992, -43.80584075299993],
              [-176.69050045499992, -43.81324635199991],
              [-176.68525143099993, -43.82691822699991],
              [-176.69416256399992, -43.82903411299992],
              [-176.7097061839999, -43.828383070999905],
              [-176.72468014199993, -43.83367278399993],
              [-176.75422115799992, -43.82350025799991],
              [-176.82591712099992, -43.8396135399999],
              [-176.8549698559999, -43.8200822899999],
              [-176.84028072799993, -43.80120208099993],
              [-176.8209122389999, -43.79461028399993],
              [-176.7997533839999, -43.79045989399992],
              [-176.7792862619999, -43.7790666649999],
              [-176.77948971299992, -43.77206796699994],
              [-176.78534908799992, -43.76376718499995],
              [-176.7864884109999, -43.75628020599993],
              [-176.7724503249999, -43.75115325299993],
              [-176.77000891799992, -43.75465260199991],
              [-176.7452286449999, -43.76848723799992],
              [-176.7346085279999, -43.77166106599992],
              [-176.64484615799992, -43.764336846999925],
              [-176.62474524599992, -43.754571221999925],
              [-176.61375891799992, -43.73552825299993],
              [-176.60956783799992, -43.719008070999905],
              [-176.60199947799993, -43.70761484199994],
              [-176.58063717399992, -43.703383070999905],
              [-176.5721329419999, -43.705336195999905],
              [-176.55048580599993, -43.71428801899992],
              [-176.5396622389999, -43.71697356599992],
              [-176.4979141919999, -43.71559010199991],
              [-176.48444576699993, -43.71697356599992],
              [-176.41706295499992, -43.74146900799991],
              [-176.3919571609999, -43.74488697699991],
              [-176.16913814999992, -43.73137786299992],
              [-176.16913814999992, -43.73748137799993],
              [-176.18488521999993, -43.73772551899992],
              [-176.19648189999992, -43.74431731599992],
              [-176.2029923169999, -43.75603606599992],
              [-176.20331783799992, -43.77166106599992],
              [-176.24445553299992, -43.75432708099993],
              [-176.28510494699992, -43.76970794099992],
              [-176.32062740799992, -43.80169036299992],
              [-176.36982174399992, -43.86272551899992],
              [-176.37852942599991, -43.879164320999905],
              [-176.38202877499992, -43.89861419099992],
            ],
          ],
          [
            [
              [-177.9095352859999, -29.27857838299991],
              [-177.92487545499992, -29.284356377999927],
              [-177.92747962099992, -29.277113539999903],
              [-177.9256485669999, -29.26458098799992],
              [-177.92756100199992, -29.254652601999908],
              [-177.94587154899992, -29.24032968499995],
              [-177.95282955599993, -29.233086846999925],
              [-177.9579971999999, -29.22275155999995],
              [-177.9407852859999, -29.22193775799991],
              [-177.9224747389999, -29.22389088299991],
              [-177.90485592399992, -29.228122653999947],
              [-177.8893936839999, -29.233819268999923],
              [-177.87462317599991, -29.242364190999922],
              [-177.86542721299992, -29.251153252999927],
              [-177.84813391799992, -29.27857838299991],
              [-177.8632706369999, -29.27117278399993],
              [-177.87800045499992, -29.27239348799992],
              [-177.8896378249999, -29.280043226999908],
              [-177.8958634109999, -29.292168877999927],
              [-177.9084366529999, -29.27939218499995],
              [-177.9095352859999, -29.27857838299991],
            ],
          ],
          [
            [
              [-171.19066321499992, -9.35637786299992],
              [-171.19550533799992, -9.350681247999944],
              [-171.19969641799992, -9.344333591999941],
              [-171.20319576699993, -9.33766041499996],
              [-171.2057999339999, -9.33098723799992],
              [-171.19770260299993, -9.336358330999929],
              [-171.19135494699992, -9.343357028999947],
              [-171.18732662699992, -9.351739190999922],
              [-171.18565833199992, -9.361260674999926],
              [-171.18830318899992, -9.361748955999929],
              [-171.1889542309999, -9.360446872999944],
              [-171.1893204419999, -9.358168226999908],
              [-171.19066321499992, -9.35637786299992],
            ],
          ],
          [
            [
              [-172.48607337099992, -8.56536223799992],
              [-172.49494381399992, -8.55478280999995],
              [-172.5025528639999, -8.543226820999905],
              [-172.4916886059999, -8.551853122999944],
              [-172.4830216139999, -8.56259530999995],
              [-172.47935950399992, -8.574476820999905],
              [-172.48363196499992, -8.586521091999941],
              [-172.48383541599992, -8.58131275799991],
              [-172.48607337099992, -8.56536223799992],
            ],
          ],
          [
            [
              [166.6372176440001, -47.99358489399992],
              [166.63209069100003, -48.00017669099992],
              [166.6235457690001, -48.02092864399992],
              [166.6294051440001, -48.02988046699994],
              [166.63428795700008, -48.03997161299992],
              [166.63746178500003, -48.05087655999995],
              [166.6372176440001, -48.062432549999926],
              [166.62777754, -48.05877044099992],
              [166.62232506600003, -48.052992445999905],
              [166.61304772200003, -48.03826262799993],
              [166.604828321, -48.03533294099992],
              [166.5683699880001, -48.04192473799992],
              [166.5683699880001, -48.03443775799991],
              [166.61882571700005, -47.997979424999926],
              [166.6372176440001, -47.99358489399992],
            ],
          ],
          [
            [
              [167.41871178500003, -47.23259856599992],
              [167.4306746750001, -47.2185197899999],
              [167.45427493600005, -47.20745208099993],
              [167.47730553500003, -47.20566171699994],
              [167.48698978000004, -47.21892669099992],
              [167.47388756600003, -47.22730885199991],
              [167.44947350400003, -47.23943450299993],
              [167.4267684250001, -47.24456145599993],
              [167.41871178500003, -47.23259856599992],
            ],
          ],
          [
            [
              [167.70923912900003, -46.78411223799992],
              [167.6977645190001, -46.79176197699991],
              [167.6826278000001, -46.79509856599992],
              [167.66944420700008, -46.79159921699994],
              [167.66285241000003, -46.77849700299993],
              [167.6670028000001, -46.76523202899995],
              [167.6787215500001, -46.75855885199991],
              [167.6933699880001, -46.75725676899992],
              [167.70671634200005, -46.759698174999926],
              [167.7197371750001, -46.76718515399995],
              [167.70923912900003, -46.78411223799992],
            ],
          ],
          [
            [
              [168.59001712300005, -46.732354424999926],
              [168.60572350400003, -46.754571221999925],
              [168.59351647200003, -46.775323174999926],
              [168.572601759, -46.79176197699991],
              [168.56324303500003, -46.80120208099993],
              [168.56788170700008, -46.79070403399993],
              [168.56120853000004, -46.78183359199994],
              [168.55030358200008, -46.77223072699991],
              [168.54216556100005, -46.759698174999926],
              [168.5576278000001, -46.75855885199991],
              [168.57211347700002, -46.754164320999905],
              [168.58375084700003, -46.74570077899995],
              [168.59001712300005, -46.732354424999926],
            ],
          ],
          [
            [
              [168.19947350400003, -47.04762135199991],
              [168.2446395190001, -47.068617445999905],
              [168.25757897200003, -47.078383070999905],
              [168.25928795700008, -47.08473072699991],
              [168.25171959700003, -47.08798593499995],
              [168.2412215500001, -47.088962497999944],
              [168.23365319100003, -47.088555596999925],
              [168.22828209700003, -47.08513762799993],
              [168.2207137380001, -47.072198174999926],
              [168.21314537900003, -47.0681291649999],
              [168.19109134200005, -47.06715260199991],
              [168.18580162900003, -47.07431405999995],
              [168.19206790500004, -47.09889088299991],
              [168.181000196, -47.10393645599993],
              [168.1464949880001, -47.0935197899999],
              [168.15796959700003, -47.10906340899993],
              [168.083343946, -47.10906340899993],
              [168.02125084700003, -47.11646900799991],
              [167.99626712300005, -47.12444426899992],
              [167.93376712300005, -47.16448333099993],
              [167.91521243600005, -47.18108489399992],
              [167.90186608200008, -47.18840911299992],
              [167.884125196, -47.18808359199994],
              [167.86670983200008, -47.18254973799992],
              [167.8535262380001, -47.17424895599993],
              [167.8379012380001, -47.16838958099993],
              [167.801605665, -47.17245859199994],
              [167.78923587300005, -47.17115650799991],
              [167.77955162900003, -47.15911223799992],
              [167.77312259200005, -47.14470794099992],
              [167.76490319100003, -47.13746510199991],
              [167.7441512380001, -47.150648695999905],
              [167.727386915, -47.15349700299993],
              [167.7197371750001, -47.156914971999925],
              [167.71941165500004, -47.16057708099993],
              [167.7129012380001, -47.18482838299991],
              [167.69703209700003, -47.17693450299993],
              [167.64576256600003, -47.20517343499995],
              [167.61670983200008, -47.21217213299991],
              [167.63461347700002, -47.22551848799992],
              [167.66578209700003, -47.22144947699991],
              [167.7265731130001, -47.20525481599992],
              [167.71461022200003, -47.2243791649999],
              [167.70329837300005, -47.23723723799992],
              [167.6718856130001, -47.26051197699991],
              [167.67212975400003, -47.2360979149999],
              [167.65943444100003, -47.23642343499995],
              [167.64177493600005, -47.24928150799991],
              [167.6274520190001, -47.263604424999926],
              [167.60922285200002, -47.27044036299992],
              [167.57569420700008, -47.27597421699994],
              [167.541351759, -47.277601820999905],
              [167.52100670700008, -47.27304452899995],
              [167.51547285200002, -47.2536760399999],
              [167.521820509, -47.2282854149999],
              [167.53402754, -47.20403411299992],
              [167.54558353000004, -47.18824635199991],
              [167.55583743600005, -47.18173593499995],
              [167.57545006600003, -47.17978280999995],
              [167.5957137380001, -47.168633721999925],
              [167.63038170700008, -47.156914971999925],
              [167.61304772200003, -47.14861419099992],
              [167.61280358200008, -47.13941822699991],
              [167.61980228000004, -47.12900155999995],
              [167.62476647200003, -47.11646900799991],
              [167.62322024800005, -47.1013322899999],
              [167.61988366000003, -47.089776299999926],
              [167.61980228000004, -47.07870859199994],
              [167.6274520190001, -47.064711195999905],
              [167.6377059250001, -47.054620049999926],
              [167.64820397200003, -47.04802825299993],
              [167.6718856130001, -47.037041924999926],
              [167.68824303500003, -47.03289153399993],
              [167.7011824880001, -47.03557708099993],
              [167.71306399800005, -47.03997161299992],
              [167.7265731130001, -47.0407854149999],
              [167.74382571700005, -47.027276299999926],
              [167.74000084700003, -47.00335051899992],
              [167.73226972700002, -46.97673919099992],
              [167.73707116000003, -46.95517343499995],
              [167.749359571, -46.949883721999925],
              [167.77881920700008, -46.949883721999925],
              [167.7920028000001, -46.94182708099993],
              [167.8086043630001, -46.92205169099992],
              [167.81421959700003, -46.911228122999944],
              [167.81657962300005, -46.89739348799992],
              [167.81137129, -46.8747697899999],
              [167.798187696, -46.853448174999926],
              [167.76441491000003, -46.818291924999926],
              [167.7583113940001, -46.80738697699991],
              [167.762543165, -46.7985979149999],
              [167.77027428500003, -46.79119231599992],
              [167.774261915, -46.783868096999925],
              [167.7739363940001, -46.77743905999995],
              [167.77214603000004, -46.772556247999944],
              [167.76905358200008, -46.768243096999925],
              [167.76441491000003, -46.76336028399993],
              [167.7602645190001, -46.75603606599992],
              [167.76189212300005, -46.75042083099993],
              [167.76587975400003, -46.74537525799991],
              [167.7680770190001, -46.73984140399995],
              [167.77361087300005, -46.71168385199991],
              [167.787445509, -46.697198174999926],
              [167.80974368600005, -46.692071221999925],
              [167.84009850400003, -46.691338799999926],
              [167.86695397200003, -46.69817473799992],
              [167.88233483200008, -46.699883721999925],
              [167.89527428500003, -46.69475676899992],
              [167.9091903000001, -46.68482838299991],
              [167.92058353000004, -46.68303801899992],
              [167.96753991000003, -46.69980234199994],
              [167.986664259, -46.71103280999995],
              [168.00407962300005, -46.72470468499995],
              [168.09327233200008, -46.81145598799992],
              [168.1074324880001, -46.82146575299993],
              [168.12427819100003, -46.82952239399992],
              [168.13843834700003, -46.83879973799992],
              [168.14421634200005, -46.85247161299992],
              [168.15650475400003, -46.8552385399999],
              [168.17920983200008, -46.86443450299993],
              [168.19125410200002, -46.87704843499995],
              [168.17164147200003, -46.88990650799991],
              [168.19206790500004, -46.89739348799992],
              [168.19206790500004, -46.90357838299991],
              [168.167328321, -46.90984465899993],
              [168.076508009, -46.90357838299991],
              [168.083343946, -46.88990650799991],
              [168.02702884200005, -46.8884416649999],
              [168.008148634, -46.89511484199994],
              [168.01823978000004, -46.91448333099993],
              [168.01539147200003, -46.9255510399999],
              [167.96664472700002, -46.972588799999926],
              [167.99187259200005, -46.9704729149999],
              [168.026703321, -46.93954843499995],
              [168.04867597700002, -46.931573174999926],
              [168.05884850400003, -46.93474700299993],
              [168.0864363940001, -46.94890715899993],
              [168.1118270190001, -46.95370859199994],
              [168.15113366000003, -46.96575286299992],
              [168.14730879, -46.97275155999995],
              [168.14380944100003, -46.97795989399992],
              [168.139008009, -46.98211028399993],
              [168.13111412900003, -46.98560963299991],
              [168.13111412900003, -46.992445570999905],
              [168.1425887380001, -46.99277109199994],
              [168.19654381600003, -46.97926197699991],
              [168.209320509, -46.97869231599992],
              [168.2226668630001, -46.97323984199994],
              [168.23023522200003, -46.97161223799992],
              [168.23365319100003, -46.975681247999944],
              [168.236664259, -46.98357512799993],
              [168.24431399800005, -46.99081796699994],
              [168.25318444100003, -46.99618905999995],
              [168.26099694100003, -46.99920012799993],
              [168.25611412900003, -47.00872161299992],
              [168.24984785200002, -47.03411223799992],
              [168.24732506600003, -47.0407854149999],
              [168.23609459700003, -47.045586846999925],
              [168.22486412900003, -47.04461028399993],
              [168.21306399800005, -47.041680596999925],
              [168.19947350400003, -47.0407854149999],
              [168.19947350400003, -47.04762135199991],
            ],
          ],
          [
            [
              [166.7114363940001, -45.616306247999944],
              [166.73015384200005, -45.62656015399995],
              [166.743500196, -45.64576588299991],
              [166.75171959700003, -45.66871510199991],
              [166.75464928500003, -45.690118096999925],
              [166.75066165500004, -45.71209075299993],
              [166.7392684250001, -45.72795989399992],
              [166.7216903000001, -45.73707447699991],
              [166.69939212300005, -45.73919036299992],
              [166.6972762380001, -45.73398202899995],
              [166.6899520190001, -45.72389088299991],
              [166.68181399800005, -45.71884530999995],
              [166.6748153000001, -45.73691171699994],
              [166.66667728000004, -45.74081796699994],
              [166.65739993600005, -45.74114348799992],
              [166.65007571700005, -45.73919036299992],
              [166.64421634200005, -45.72869231599992],
              [166.63892662900003, -45.708916924999926],
              [166.63599694100003, -45.68873463299991],
              [166.6372176440001, -45.67717864399992],
              [166.6230574880001, -45.65829843499995],
              [166.60572350400003, -45.65984465899993],
              [166.5434676440001, -45.71152109199994],
              [166.5273543630001, -45.71965911299992],
              [166.506195509, -45.724867445999905],
              [166.51148522200003, -45.71168385199991],
              [166.52100670700008, -45.69353606599992],
              [166.53288821700005, -45.67734140399995],
              [166.54444420700008, -45.67034270599993],
              [166.5473738940001, -45.66725025799991],
              [166.558929884, -45.65195077899995],
              [166.56666100400003, -45.63713958099993],
              [166.5786238940001, -45.63494231599992],
              [166.60377037900003, -45.63551197699991],
              [166.68384850400003, -45.61598072699991],
              [166.702484571, -45.615166924999926],
              [166.7114363940001, -45.616306247999944],
            ],
          ],
          [
            [
              [166.9736434250001, -45.16326262799993],
              [166.982758009, -45.19939544099992],
              [166.9970809250001, -45.23316822699991],
              [167.03443444100003, -45.30046965899993],
              [167.0009871750001, -45.304945570999905],
              [166.98747806100005, -45.30234140399995],
              [166.96989993600005, -45.28948333099993],
              [166.9536238940001, -45.282321872999944],
              [166.93181399800005, -45.2771135399999],
              [166.91228274800005, -45.269789320999905],
              [166.90414472700002, -45.25603606599992],
              [166.89332116000003, -45.24342213299991],
              [166.890961134, -45.23560963299991],
              [166.90113366000003, -45.23211028399993],
              [166.89918053500003, -45.22771575299993],
              [166.90577233200008, -45.21795012799993],
              [166.966156446, -45.14959075299993],
              [166.96631920700008, -45.15447356599992],
              [166.96827233200008, -45.157321872999944],
              [166.97087649800005, -45.15976327899995],
              [166.9736434250001, -45.16326262799993],
            ],
          ],
          [
            [
              [174.3808699880001, -41.10637786299992],
              [174.39730879, -41.10833098799992],
              [174.399750196, -41.115899346999925],
              [174.39795983200008, -41.127211195999905],
              [174.4013778000001, -41.140557549999926],
              [174.39380944100003, -41.15357838299991],
              [174.3877059250001, -41.183526299999926],
              [174.3808699880001, -41.1950822899999],
              [174.36597741000003, -41.20256926899992],
              [174.34839928500003, -41.203383070999905],
              [174.32976321700005, -41.20191822699991],
              [174.31202233200008, -41.20256926899992],
              [174.29835045700008, -41.20794036299992],
              [174.27361087300005, -41.22478606599992],
              [174.2636824880001, -41.22991301899992],
              [174.2480574880001, -41.23211028399993],
              [174.1972762380001, -41.23007577899995],
              [174.19752037900003, -41.22975025799991],
              [174.202484571, -41.225681247999944],
              [174.213226759, -41.21770598799992],
              [174.21648196700005, -41.21624114399992],
              [174.22722415500004, -41.21542734199994],
              [174.25114993600005, -41.21721770599993],
              [174.26050866000003, -41.212823174999926],
              [174.31202233200008, -41.16855234199994],
              [174.3291121750001, -41.18173593499995],
              [174.35124759200005, -41.17546965899993],
              [174.367523634, -41.158868096999925],
              [174.36670983200008, -41.140557549999926],
              [174.35425866000003, -41.14592864399992],
              [174.342133009, -41.14470794099992],
              [174.3320418630001, -41.13795338299991],
              [174.32569420700008, -41.126885674999926],
              [174.34359785200002, -41.12574635199991],
              [174.3564559250001, -41.11882903399993],
              [174.36793053500003, -41.11077239399992],
              [174.3808699880001, -41.10637786299992],
            ],
          ],
          [
            [
              [173.78443444100003, -40.90715911299992],
              [173.79615319100003, -40.9021135399999],
              [173.80250084700003, -40.8943010399999],
              [173.8032332690001, -40.88437265399995],
              [173.79810631600003, -40.87314218499995],
              [173.78728274800005, -40.88298919099992],
              [173.78443444100003, -40.886651299999926],
              [173.778656446, -40.87517669099992],
              [173.776703321, -40.86256275799991],
              [173.778656446, -40.85019296699994],
              [173.78443444100003, -40.838962497999944],
              [173.79965254, -40.849867445999905],
              [173.81137129, -40.86174895599993],
              [173.825043165, -40.87078215899993],
              [173.84587649800005, -40.87314218499995],
              [173.84587649800005, -40.86679452899995],
              [173.83350670700008, -40.85881926899992],
              [173.822601759, -40.84856536299992],
              [173.81470787900003, -40.83538176899992],
              [173.81177819100003, -40.819024346999925],
              [173.81421959700003, -40.80437590899993],
              [173.82683353000004, -40.766289971999925],
              [173.83228600400003, -40.7575822899999],
              [173.83773847700002, -40.75896575299993],
              [173.83904056100005, -40.76702239399992],
              [173.84197024800005, -40.775323174999926],
              [173.85271243600005, -40.77752044099992],
              [173.8564559250001, -40.76384856599992],
              [173.86158287900003, -40.75448984199994],
              [173.8701278000001, -40.75017669099992],
              [173.8847762380001, -40.75628020599993],
              [173.885101759, -40.77092864399992],
              [173.88249759200005, -40.788995049999926],
              [173.88746178500003, -40.805352471999925],
              [173.8950301440001, -40.79583098799992],
              [173.92652428500003, -40.78801848799992],
              [173.94214928500003, -40.77752044099992],
              [173.90796959700003, -40.77752044099992],
              [173.93043053500003, -40.76262786299992],
              [173.939789259, -40.754571221999925],
              [173.94890384200005, -40.74334075299993],
              [173.95980879, -40.714776299999926],
              [173.9648543630001, -40.7087541649999],
              [173.96941165500004, -40.72340260199991],
              [173.969086134, -40.73772551899992],
              [173.96558678500003, -40.75164153399993],
              [173.95573978000004, -40.77752044099992],
              [173.9619246750001, -40.78769296699994],
              [173.96371504, -40.79436614399992],
              [173.95915774800005, -40.79729583099993],
              [173.9536238940001, -40.79998137799993],
              [173.93897545700008, -40.813571872999944],
              [173.9345809250001, -40.819024346999925],
              [173.93148847700002, -40.82935963299991],
              [173.9277449880001, -40.8552385399999],
              [173.92164147200003, -40.86679452899995],
              [173.91749108200008, -40.86777109199994],
              [173.8974715500001, -40.86679452899995],
              [173.8916121750001, -40.86931731599992],
              [173.879730665, -40.88176848799992],
              [173.87378991000003, -40.886651299999926],
              [173.84929446700005, -40.89348723799992],
              [173.8422957690001, -40.896416924999926],
              [173.83814537900003, -40.903008721999925],
              [173.83521569100003, -40.910088799999926],
              [173.83228600400003, -40.91464609199994],
              [173.819672071, -40.92156340899993],
              [173.8051863940001, -40.92636484199994],
              [173.79053795700008, -40.92701588299991],
              [173.77759850400003, -40.92148202899995],
              [173.78150475400003, -40.91806405999995],
              [173.78272545700008, -40.91464609199994],
              [173.78305097700002, -40.911228122999944],
              [173.78443444100003, -40.90715911299992],
            ],
          ],
          [
            [
              [172.7486944484964, -43.27969352453431],
              [172.75603274800005, -43.29257577899989],
              [172.74870853000016, -43.316664320999905],
              [172.74480228000004, -43.34189218499995],
              [172.74293053500003, -43.39495208099987],
              [172.73617597700002, -43.40113697699985],
              [172.72965876044975, -43.41484690966547],
              [172.73218834700026, -43.436211846999925],
              [172.750336134, -43.498630466999884],
              [172.77898196700005, -43.55779387799993],
              [172.77711022200003, -43.57366301899992],
              [172.76441491000014, -43.56226978999979],
              [172.75261478000004, -43.56064218499995],
              [172.74773196700005, -43.56715260199985],
              [172.75603274800005, -43.58114999799989],
              [172.77116946700005, -43.58928801899992],
              [172.83228600400003, -43.60165780999995],
              [172.80396569100003, -43.61101653399987],
              [172.73796634200005, -43.614190362999864],
              [172.70818118600016, -43.62151458099993],
              [172.68140709700003, -43.639336846999925],
              [172.69312584700015, -43.64706796699994],
              [172.72087649800005, -43.65048593499995],
              [172.74293053500003, -43.65553150799991],
              [172.7636824880001, -43.63591887799993],
              [172.80095462300017, -43.62900155999995],
              [172.83676191500012, -43.62932708099993],
              [172.85279381600003, -43.63144296699994],
              [172.85710696700016, -43.64657968499995],
              [172.86646569100003, -43.66082122199987],
              [172.87574303500003, -43.66887786299992],
              [172.88013756600014, -43.665459893999866],
              [172.88493899800005, -43.63982512799993],
              [172.89380944100026, -43.6145158829998],
              [172.920258009, -43.62664153399987],
              [172.92611738400012, -43.635023695999905],
              [172.92790774800005, -43.65195077899989],
              [172.9248153000002, -43.679620049999926],
              [172.92839603000016, -43.68572356599992],
              [172.94214928500014, -43.682875257999854],
              [172.95085696700005, -43.67522551899992],
              [172.9580184250002, -43.6633440079998],
              [172.96648196700005, -43.65276458099993],
              [172.97950280000032, -43.648125908999816],
              [172.99439537900003, -43.64934661299992],
              [173.0092879570002, -43.65390390399995],
              [173.02068118600005, -43.662367445999905],
              [173.02466881600014, -43.67603932099985],
              [173.05290774800017, -43.65325286299992],
              [173.0649520190001, -43.648125908999816],
              [173.06910241000003, -43.66570403399993],
              [173.08073978000016, -43.67587655999995],
              [173.0947371750002, -43.68401458099987],
              [173.10613040500016, -43.695977471999925],
              [173.10710696700016, -43.703789971999925],
              [173.10425866000026, -43.71200937299983],
              [173.1005965500001, -43.719008070999905],
              [173.09929446700016, -43.72380950299987],
              [173.10181725400003, -43.72975025799991],
              [173.11011803500003, -43.740004164999846],
              [173.11280358200008, -43.74488697699991],
              [173.11646569100014, -43.772149346999925],
              [173.11353600400014, -43.80120208099987],
              [173.1054793630001, -43.829359632999854],
              [173.09294681100005, -43.854180596999925],
              [173.0805770190001, -43.84059010199985],
              [173.05591881600003, -43.86419036299992],
              [173.03777103000004, -43.86101653399993],
              [173.03150475400014, -43.88225676899992],
              [173.03093509200005, -43.88892994599979],
              [173.022797071, -43.88054778399993],
              [173.01400800900024, -43.878838799999926],
              [173.00513756600003, -43.88225676899992],
              [172.99683678500003, -43.88892994599979],
              [172.99252363400012, -43.87623463299991],
              [172.97974694100003, -43.853773695999905],
              [172.97575931100016, -43.84059010199985],
              [172.97584069100014, -43.82512786299992],
              [172.97868899800017, -43.816664320999905],
              [172.97730553500014, -43.80901458099987],
              [172.9658309250002, -43.796156507999854],
              [172.9604598320002, -43.7829729149999],
              [172.9624129570002, -43.768243096999925],
              [172.96168053500003, -43.756117445999905],
              [172.948578321, -43.75115325299993],
              [172.93311608200008, -43.75554778399993],
              [172.92652428500014, -43.765557549999926],
              [172.92937259200016, -43.777113539999846],
              [172.94214928500014, -43.78590260199991],
              [172.92790774800005, -43.81292083099987],
              [172.9267684250001, -43.84026458099993],
              [172.93734785200013, -43.867120049999926],
              [172.96892337300005, -43.903252862999864],
              [172.96558678500003, -43.90545012799993],
              [172.94214928500014, -43.90203215899993],
              [172.87671959700003, -43.90203215899993],
              [172.86304772200015, -43.8962541649999],
              [172.84009850400003, -43.87623463299991],
              [172.817230665, -43.881442966999884],
              [172.8051863940001, -43.87460702899989],
              [172.78394616000003, -43.854180596999925],
              [172.7451278000002, -43.82488372199981],
              [172.7441512380002, -43.81145598799992],
              [172.76343834700003, -43.792738539999846],
              [172.74586022200003, -43.79371510199991],
              [172.71851647200015, -43.80339934699987],
              [172.63689212300017, -43.811944268999866],
              [172.60906009200005, -43.82268645599993],
              [172.55111738400012, -43.826836846999925],
              [172.46314537900014, -43.849867445999905],
              [172.42261803500014, -43.854587497999944],
              [172.4140731130001, -43.85076262799993],
              [172.4179793630002, -43.84010182099979],
              [172.42790774800005, -43.83269622199987],
              [172.44019616000014, -43.82830169099992],
              [172.46705162900003, -43.82512786299992],
              [172.6176863940001, -43.787367445999905],
              [172.63306725400014, -43.78590260199991],
              [172.64771569100003, -43.782647393999866],
              [172.64014733200008, -43.77507903399993],
              [172.61247806100005, -43.76181405999989],
              [172.6001082690001, -43.75969817499987],
              [172.5683699880001, -43.763116143999866],
              [172.55111738400012, -43.757989190999865],
              [172.54420006600026, -43.75237395599987],
              [172.53199303500003, -43.73837655999989],
              [172.5239363940002, -43.73137786299992],
              [172.4970809250001, -43.72185637799993],
              [172.47144616000014, -43.72503020599993],
              [172.44548587300005, -43.733086846999925],
              [172.417328321, -43.73748137799993],
              [172.40064537900003, -43.74797942499987],
              [172.3911238940001, -43.77288176899992],
              [172.38697350400025, -43.80234140399989],
              [172.38656660200002, -43.826836846999925],
              [172.3891707690001, -43.841566664999846],
              [172.3911238940001, -43.8474260399999],
              [172.38843834700003, -43.85247161299992],
              [172.37631269600013, -43.86443450299993],
              [172.36557050900012, -43.86842213299991],
              [172.28239993600005, -43.87810637799987],
              [172.2705184250001, -43.876397393999866],
              [172.249840448624, -43.88126092449164],
              [172.2319944910803, -43.896251528828316],
              [172.18588300900012, -43.90781015399989],
              [172.16521243600005, -43.92107512799993],
              [172.06120853000004, -43.95663827899989],
              [171.86833743600027, -44.058526299999926],
              [171.838226759, -44.06210702899989],
              [171.8218943867255, -44.059720499928915],
              [171.80666583628806, -44.06114817653241],
              [171.7939559250002, -44.067071221999925],
              [171.7197371750002, -44.104587497999944],
              [171.6826278000001, -44.11052825299987],
              [171.66724694100014, -44.11492278399987],
              [171.65503991000003, -44.12322356599992],
              [171.64437910200013, -44.13241952899995],
              [171.63314863400012, -44.13982512799993],
              [171.60499108200008, -44.14592864399992],
              [171.57837975400003, -44.160088799999926],
              [171.5673934250001, -44.16326262799987],
              [171.55063583206083, -44.16727213739239],
              [171.5325519284164, -44.18297658003087],
              [171.52255819219204, -44.19059085524958],
              [171.51587975400003, -44.1989885399999],
              [171.49000084700015, -44.20598723799992],
              [171.47779381600026, -44.21298593499995],
              [171.41667728000004, -44.26034921699994],
              [171.39234459700015, -44.270603122999944],
              [171.37240644600024, -44.26506926899992],
              [171.35808353000004, -44.272067966999884],
              [171.34600218555943, -44.2786309124653],
              [171.33765709700003, -44.289727471999925],
              [171.33423912900003, -44.29949309699987],
              [171.28003991000003, -44.37151458099987],
              [171.27613366000014, -44.38298919099992],
              [171.27613366000014, -44.440118096999925],
              [171.27068118600005, -44.4587541649999],
              [171.25733483200008, -44.473565362999864],
              [171.22836347700013, -44.49846770599993],
              [171.22624759200005, -44.50750090899993],
              [171.22584069100026, -44.51881275799991],
              [171.22250410200002, -44.52849700299987],
              [171.21111087300005, -44.53264739399992],
              [171.20281009200016, -44.53443775799991],
              [171.1738387380002, -44.54697030999989],
              [171.19597415500004, -44.56682708099987],
              [171.2011824880001, -44.60125090899993],
              [171.2011824880001, -44.67652760199991],
              [171.21265709700015, -44.72470468499995],
              [171.21412194100003, -44.74187590899987],
              [171.2089949880001, -44.76067473799992],
              [171.19711347700013, -44.76824309699987],
              [171.1836043630001, -44.77361419099992],
              [171.1738387380002, -44.785821221999925],
              [171.20248457100013, -44.789320570999905],
              [171.2124129570002, -44.81357187299989],
              [171.2114363940001, -44.84628671699994],
              [171.2031356130003, -44.90553150799991],
              [171.19263756600003, -44.925713799999926],
              [171.18074861870446, -44.94012107208613],
              [171.17253947823428, -44.95332708066843],
              [171.16290266116073, -44.96831768500522],
              [171.1587020190002, -44.983493747999944],
              [171.091156446, -45.07366301899992],
              [170.98031660200002, -45.15496184699987],
              [170.926117384, -45.23837655999995],
              [170.90219160200013, -45.30966562299989],
              [170.88892662900003, -45.33049895599993],
              [170.8769637380001, -45.35588958099987],
              [170.89087975400014, -45.368259372999944],
              [170.9082137380001, -45.37981536299992],
              [170.9062606130001, -45.40276458099993],
              [170.8691512380001, -45.43385182099985],
              [170.8598738940001, -45.44736093499989],
              [170.85971113400012, -45.45826588299991],
              [170.86353600400003, -45.46917083099987],
              [170.86597741000003, -45.48202890399989],
              [170.8520613940001, -45.50017669099981],
              [170.8242293630001, -45.51360442499987],
              [170.80355879000012, -45.5290666649999],
              [170.81072024800005, -45.55364348799992],
              [170.7988387380002, -45.565524997999944],
              [170.78679446700005, -45.57146575299987],
              [170.77312259200016, -45.57040780999995],
              [170.75611412900003, -45.561130466999884],
              [170.7573348320002, -45.572035414999846],
              [170.7607528000002, -45.58220794099992],
              [170.76978600400014, -45.601495049999926],
              [170.75310306100005, -45.61256275799991],
              [170.7402449880002, -45.6164690079998],
              [170.70427493600005, -45.61565520599987],
              [170.6840926440002, -45.62070077899989],
              [170.68458092500032, -45.63103606599992],
              [170.6992293630002, -45.64072030999995],
              [170.72201582100013, -45.64299895599993],
              [170.69841556100016, -45.67929452899995],
              [170.69060306100016, -45.68466562299989],
              [170.67937259200005, -45.686944268999866],
              [170.66675866000003, -45.69255950299987],
              [170.64625084700003, -45.70517343499995],
              [170.63795006600003, -45.70728932099985],
              [170.6313582690001, -45.705743096999925],
              [170.62671959700015, -45.70631275799991],
              [170.62517337300005, -45.715020440999865],
              [170.62517337300005, -45.72454192499987],
              [170.62614993600016, -45.729750257999854],
              [170.63038170700008, -45.73202890399995],
              [170.63941491000014, -45.73235442499987],
              [170.65455162900014, -45.736260674999926],
              [170.66781660200013, -45.742445570999905],
              [170.6806746750001, -45.74382903399993],
              [170.69402103000004, -45.73235442499987],
              [170.712250196, -45.74342213299991],
              [170.73853600400003, -45.75310637799993],
              [170.7587996750002, -45.763441664999846],
              [170.75928795700008, -45.776788018999866],
              [170.741547071, -45.78630950299987],
              [170.69288170700008, -45.79322682099979],
              [170.6728621750001, -45.800713799999926],
              [170.653656446, -45.82236093499995],
              [170.64625084700003, -45.82870859199994],
              [170.637543165, -45.83098723799992],
              [170.62614993600016, -45.832696221999925],
              [170.6162215500001, -45.83635833099987],
              [170.60368899800017, -45.86174895599993],
              [170.5664168630001, -45.879164320999905],
              [170.55681399800005, -45.8962541649999],
              [170.57553144600013, -45.889336846999925],
              [170.61158287900003, -45.8825822899999],
              [170.64193769600013, -45.86402760199991],
              [170.68718509200005, -45.85165780999995],
              [170.70101972700013, -45.84221770599993],
              [170.71615644600013, -45.81943124799989],
              [170.72828209700003, -45.807549737999864],
              [170.74203535200002, -45.80103932099985],
              [170.75456790500016, -45.79876067499987],
              [170.765961134, -45.79404062299989],
              [170.77662194100003, -45.780205987999864],
              [170.78687584700003, -45.792901299999926],
              [170.79078209700003, -45.80836353999979],
              [170.78728274800005, -45.8630510399999],
              [170.77857506600014, -45.87615325299987],
              [170.76384524800028, -45.88128020599987],
              [170.74244225400003, -45.8825822899999],
              [170.72201582100013, -45.88160572699991],
              [170.71794681100005, -45.883070570999905],
              [170.70769290500004, -45.88884856599992],
              [170.70240319100003, -45.89544036299992],
              [170.70264733200008, -45.902276299999926],
              [170.70045006600003, -45.90781015399995],
              [170.49341881600026, -45.922946872999944],
              [170.40796959700015, -45.943291924999926],
              [170.33375084700015, -45.98154062299989],
              [170.275726759, -46.04029713299991],
              [170.26002037900003, -46.06365325299987],
              [170.2563582690001, -46.07512786299992],
              [170.25318444100003, -46.10515715899987],
              [170.2441512380002, -46.123630466999884],
              [170.2421981130001, -46.132745049999926],
              [170.2348738940001, -46.15398528399987],
              [170.21697024800005, -46.17294687299989],
              [170.19450931100016, -46.188083591999884],
              [170.17335045700008, -46.197930596999925],
              [170.12045332100013, -46.213148695999905],
              [170.0957137380001, -46.22421640399995],
              [170.07398522200015, -46.24260833099987],
              [170.05681399800017, -46.260837497999944],
              [170.03785241000014, -46.276055596999925],
              [169.8994246750001, -46.34490325299993],
              [169.86475670700008, -46.378350518999866],
              [169.85124759200028, -46.430759372999944],
              [169.85368899800017, -46.457289320999905],
              [169.848968946, -46.46754322699991],
              [169.82081139400032, -46.47478606599992],
              [169.7973738940002, -46.48894622199987],
              [169.78931725400003, -46.492120049999926],
              [169.77214603000004, -46.4900041649999],
              [169.73845462300028, -46.480645440999865],
              [169.72144616000014, -46.47844817499981],
              [169.70427493600016, -46.480157158999816],
              [169.67546634200016, -46.48902760199985],
              [169.65935306100005, -46.492120049999926],
              [169.67505944100003, -46.49675872199987],
              [169.75554446700016, -46.49960702899989],
              [169.73552493600005, -46.53411223799992],
              [169.7041121750001, -46.549004815999865],
              [169.66814212300017, -46.558851820999905],
              [169.635101759, -46.57838307099985],
              [169.62086022200003, -46.57740650799991],
              [169.59498131600003, -46.57000090899993],
              [169.5669051440001, -46.56503671699994],
              [169.54607181100005, -46.571547132999854],
              [169.53337649800005, -46.58001067499987],
              [169.4804793630002, -46.60198333099993],
              [169.48617597700013, -46.60670338299991],
              [169.4961043630002, -46.61834075299993],
              [169.50171959700026, -46.62314218499989],
              [169.4746199880001, -46.62908294099992],
              [169.44109134200005, -46.622002862999864],
              [169.41032962300005, -46.620375257999854],
              [169.39177493600005, -46.643649997999944],
              [169.37086022200003, -46.63209400799991],
              [169.36451256600014, -46.629978122999944],
              [169.3300887380001, -46.625664971999925],
              [169.3125106130001, -46.6267229149999],
              [169.29908287900003, -46.63298919099992],
              [169.27857506600003, -46.648695570999905],
              [169.2666121750001, -46.65471770599993],
              [169.25464928500003, -46.65732187299989],
              [169.21973717500032, -46.660739841999884],
              [169.20630944100003, -46.659112237999864],
              [169.19320722700013, -46.64983489399992],
              [169.19703209700003, -46.629815362999864],
              [169.19450931100005, -46.61834075299993],
              [169.19271894600013, -46.61801523199989],
              [169.1801863940002, -46.61565520599993],
              [169.17107181100005, -46.62273528399993],
              [169.1718856130002, -46.64511484199994],
              [169.15943444100014, -46.65203215899993],
              [169.157562696, -46.65691497199981],
              [169.15495853000004, -46.66179778399987],
              [169.1489363940001, -46.66415780999989],
              [169.11841881600014, -46.66415780999989],
              [169.1005965500002, -46.6599260399999],
              [169.090179884, -46.65081145599993],
              [169.08350670700008, -46.641289971999925],
              [169.07650800900012, -46.63616301899992],
              [169.06364993600016, -46.637383721999925],
              [169.063324415, -46.64617278399987],
              [169.0664168630001, -46.65846119599985],
              [169.062836134, -46.670993747999944],
              [169.03598066500012, -46.681898695999905],
              [169.00220787900014, -46.675713799999926],
              [168.96794681100005, -46.66375090899993],
              [168.9399520190001, -46.65732187299989],
              [168.90748131600014, -46.658135674999926],
              [168.8891707690001, -46.6560197899999],
              [168.8774520190002, -46.64421965899993],
              [168.85230553500003, -46.58147551899992],
              [168.8505965500001, -46.571547132999854],
              [168.84489993600005, -46.56015390399989],
              [168.83122806100005, -46.56015390399989],
              [168.8017684250001, -46.56780364399992],
              [168.6992293630002, -46.58171965899987],
              [168.6650496750001, -46.58147551899992],
              [168.6733504570002, -46.57097747199987],
              [168.68539472700002, -46.56755950299987],
              [168.6992293630002, -46.56601327899995],
              [168.7129012380003, -46.56113046699994],
              [168.69288170700008, -46.552666924999926],
              [168.66773522200003, -46.548597914999846],
              [168.61784915500004, -46.54745859199994],
              [168.62574303500003, -46.561455987999864],
              [168.6386824880001, -46.57040780999989],
              [168.6445418630001, -46.5778947899999],
              [168.63152103000016, -46.58831145599987],
              [168.6352645190002, -46.59140390399995],
              [168.6416121750001, -46.59889088299991],
              [168.64519290500016, -46.60198333099993],
              [168.59148196700016, -46.614353122999944],
              [168.41920006600014, -46.60198333099993],
              [168.43181399800005, -46.58473072699991],
              [168.4375106130002, -46.57976653399993],
              [168.44581139400032, -46.57529062299989],
              [168.46013431100016, -46.572035414999846],
              [168.49586022200003, -46.572523695999905],
              [168.50798587300005, -46.57529062299989],
              [168.51832116000003, -46.58668385199985],
              [168.54721113400012, -46.59075286299992],
              [168.56511478000016, -46.585056247999944],
              [168.54216556100016, -46.56780364399992],
              [168.51319420700008, -46.55966562299989],
              [168.42603600400014, -46.56113046699994],
              [168.3857528000001, -46.54338958099987],
              [168.3657332690002, -46.54021575299993],
              [168.35710696700016, -46.557712497999944],
              [168.36345462300028, -46.578057549999926],
              [168.39380944100026, -46.60507577899989],
              [168.40552819100003, -46.62314218499989],
              [168.37810306100016, -46.61980559699987],
              [168.3418074880002, -46.58904387799993],
              [168.31918379000024, -46.58147551899992],
              [168.31568444100003, -46.577243747999944],
              [168.31381269600013, -46.56780364399992],
              [168.30779056100005, -46.5583635399999],
              [168.28150475400003, -46.55234140399989],
              [168.27409915500004, -46.5466447899999],
              [168.26978600400014, -46.53785572699985],
              [168.26783287900003, -46.52629973799992],
              [168.29859459700015, -46.51970794099992],
              [168.30933678500003, -46.52011484199994],
              [168.31983483200008, -46.52255624799989],
              [168.32162519600013, -46.525323174999926],
              [168.32154381600014, -46.52971770599993],
              [168.32642662900025, -46.53679778399987],
              [168.33277428500003, -46.53004322699985],
              [168.38510175900012, -46.49960702899989],
              [168.39437910200002, -46.472914320999905],
              [168.38746178500014, -46.440524997999944],
              [168.36890709700003, -46.41692473799992],
              [168.34351647200003, -46.41708749799989],
              [168.3515731130001, -46.442315362999864],
              [168.34148196700005, -46.46575286299992],
              [168.3222762380003, -46.48007577899983],
              [168.30193118600005, -46.47844817499981],
              [168.29021243600016, -46.46477629999987],
              [168.2695418630001, -46.42351653399993],
              [168.21607506600014, -46.35442473799992],
              [168.19947350400003, -46.341973565999865],
              [168.17115319100003, -46.33668385199991],
              [168.0732528000002, -46.34880950299981],
              [168.05884850400014, -46.354180596999925],
              [168.05827884200005, -46.36581796699994],
              [168.06177819100014, -46.37753671699994],
              [168.05925540500016, -46.38290780999989],
              [168.04468834700026, -46.37965260199985],
              [168.02702884200005, -46.373711846999925],
              [168.00993899800005, -46.369805596999925],
              [167.99740644600013, -46.373304945999905],
              [167.967133009, -46.36988697699991],
              [167.94792728000016, -46.37029387799993],
              [167.9394637380001, -46.37981536299992],
              [167.933929884, -46.39031340899987],
              [167.92212975400014, -46.39299895599987],
              [167.9101668630002, -46.391696872999944],
              [167.8999129570002, -46.38909270599987],
              [167.8857528000002, -46.38388437299989],
              [167.8779403000002, -46.38290780999989],
              [167.8711043630001, -46.38518645599987],
              [167.8559676440001, -46.39462655999989],
              [167.8501082690001, -46.39657968499995],
              [167.83863366000003, -46.393243096999925],
              [167.82886803500003, -46.38640715899987],
              [167.81959069100003, -46.37664153399993],
              [167.80844160200002, -46.372816664999846],
              [167.79957116000014, -46.36394622199981],
              [167.78541100400003, -46.34539153399987],
              [167.77572675900012, -46.33863697699985],
              [167.75220787900003, -46.329034112999864],
              [167.7402449880001, -46.3220354149999],
              [167.75407962300017, -46.316176039999846],
              [167.76775149800005, -46.312269789999846],
              [167.7797957690002, -46.30632903399993],
              [167.78923587300005, -46.29412200299993],
              [167.73804772200015, -46.246758721999925],
              [167.71314537900003, -46.21795012799987],
              [167.7129012380002, -46.197930596999925],
              [167.69792728000004, -46.188734632999854],
              [167.65723717500032, -46.185804945999905],
              [167.63705488400012, -46.18124765399995],
              [167.59001712300028, -46.159600518999866],
              [167.57545006600003, -46.156914971999925],
              [167.4609481130002, -46.1482072899999],
              [167.45281009200016, -46.15016041499979],
              [167.44678795700008, -46.15732187299989],
              [167.44597415500004, -46.173597914999846],
              [167.44214928500014, -46.18124765399995],
              [167.4306746750002, -46.19695403399993],
              [167.42660566500012, -46.210707289999846],
              [167.42457116000014, -46.224053643999866],
              [167.41871178500014, -46.23886484199994],
              [167.40577233200008, -46.25115325299981],
              [167.39047285200002, -46.25432708099987],
              [167.35670006600003, -46.252536716999884],
              [167.3403426440002, -46.25628020599993],
              [167.309906446, -46.26970794099992],
              [167.29517662900014, -46.27361419099992],
              [167.27523847700002, -46.272149346999925],
              [167.23422285200013, -46.26100025799991],
              [167.21257571700005, -46.26002369599985],
              [167.19597415500027, -46.26327890399989],
              [167.1879988940001, -46.26620859199983],
              [167.18181399800005, -46.27019622199987],
              [167.1748153000001, -46.27312590899993],
              [167.169281446, -46.26913827899995],
              [167.16488691500012, -46.26311614399992],
              [167.16114342500032, -46.26002369599985],
              [167.14966881600014, -46.258070570999905],
              [167.08570397200015, -46.236911716999884],
              [167.06861412900003, -46.23723723799992],
              [167.05160566500012, -46.239353122999944],
              [167.03443444100026, -46.23886484199994],
              [166.966156446, -46.225844007999854],
              [166.82886803500003, -46.2282854149999],
              [166.76197350400003, -46.21998463299991],
              [166.7055770190002, -46.19109465899987],
              [166.6757918630001, -46.16301848799992],
              [166.67123457100013, -46.1535783829998],
              [166.6772567070003, -46.14714934699987],
              [166.7055770190002, -46.138116143999866],
              [166.715668165, -46.132745049999926],
              [166.7539168630002, -46.10230885199985],
              [166.7880965500002, -46.068129164999846],
              [166.81625410200024, -46.02141692499987],
              [166.83228600400003, -46.001071872999944],
              [166.852875196, -45.99244557099985],
              [166.88217207100013, -45.987237237999864],
              [166.92790774800005, -45.96087004999987],
              [166.952484571, -45.950290622999944],
              [166.952484571, -45.94402434699987],
              [166.9306746750001, -45.946221612999864],
              [166.86988366000003, -45.97193775799991],
              [166.82634524800017, -45.983330987999864],
              [166.80290774800017, -45.992771091999884],
              [166.7880965500002, -46.00554778399993],
              [166.78443444100014, -46.01685963299991],
              [166.78687584700003, -46.024102471999925],
              [166.78988691500012, -46.03069426899992],
              [166.7880965500002, -46.04029713299991],
              [166.78394616000014, -46.04241301899992],
              [166.75277754, -46.06633879999987],
              [166.7509871750001, -46.07040780999995],
              [166.74838300900012, -46.07000090899993],
              [166.739593946, -46.06129322699991],
              [166.74040774800005, -46.05624765399989],
              [166.744476759, -46.0485979149999],
              [166.744476759, -46.04021575299993],
              [166.7334090500001, -46.03289153399993],
              [166.72006269600013, -46.06414153399987],
              [166.6884871750001, -46.077080987999864],
              [166.61605879, -46.08806731599992],
              [166.61597741000003, -46.07073333099993],
              [166.61939537900014, -46.05478280999995],
              [166.62826582100013, -46.04697030999995],
              [166.64405358200008, -46.05388762799993],
              [166.6474715500001, -46.02190520599993],
              [166.65853925900012, -46.000176690999865],
              [166.67758222700024, -45.98479583099993],
              [166.7055770190002, -45.97193775799991],
              [166.76587975400014, -45.96184661299992],
              [166.79184004000012, -45.95305754999987],
              [166.8086043630003, -45.93043385199991],
              [166.7744246750001, -45.94215260199991],
              [166.739593946, -45.950290622999944],
              [166.72584069100014, -45.94939544099992],
              [166.70679772200003, -45.94573333099987],
              [166.69125410200002, -45.94019947699985],
              [166.6884871750001, -45.933851820999905],
              [166.74301191500012, -45.886976820999905],
              [166.7519637380003, -45.87656015399989],
              [166.7539168630002, -45.868910414999846],
              [166.74390709700015, -45.86093515399989],
              [166.73259524800005, -45.862399997999944],
              [166.72144616000003, -45.86882903399987],
              [166.71225019600013, -45.875746351999794],
              [166.70818118600005, -45.88030364399992],
              [166.70386803500003, -45.886976820999905],
              [166.700531446, -45.89413827899983],
              [166.69939212300005, -45.89967213299991],
              [166.68083743600005, -45.90894947699991],
              [166.6748153000002, -45.91326262799987],
              [166.64763431100005, -45.94443124799989],
              [166.64405358200008, -45.95427825299993],
              [166.629242384, -45.96526458099993],
              [166.53419030000032, -45.98503997199987],
              [166.52100670700008, -45.99081796699994],
              [166.49740644600024, -46.00904713299991],
              [166.48975670700008, -46.01295338299991],
              [166.4824324880001, -46.007745049999926],
              [166.47478274800005, -45.996026299999926],
              [166.46941165500004, -45.983493747999944],
              [166.46941165500004, -45.97535572699991],
              [166.4731551440001, -45.96379973799992],
              [166.47185306100005, -45.950290622999944],
              [166.46648196700016, -45.93043385199991],
              [166.4668074880003, -45.840508721999925],
              [166.47339928500014, -45.81731536299992],
              [166.48975670700008, -45.807549737999864],
              [166.55453535200002, -45.800713799999926],
              [166.6235457690002, -45.800713799999926],
              [166.61605879, -45.807549737999864],
              [166.6235457690002, -45.81503671699994],
              [166.64828535200013, -45.80006275799991],
              [166.67790774800005, -45.79412200299987],
              [166.7402449880001, -45.79387786299992],
              [166.76596113400012, -45.79070403399993],
              [166.81910241000003, -45.77654387799993],
              [166.84644616000026, -45.77337004999987],
              [166.87598717500032, -45.77695077899995],
              [166.8896590500001, -45.776462497999944],
              [166.90113366000003, -45.76995208099993],
              [166.90943444100003, -45.762383721999925],
              [166.91911868600005, -45.755791924999926],
              [166.93881269600013, -45.745375257999854],
              [166.9873153000001, -45.730238539999846],
              [167.00847415500004, -45.718519789999846],
              [167.02084394600013, -45.69768645599987],
              [166.97820071700005, -45.70956796699994],
              [166.96273847700024, -45.71135833099993],
              [166.890961134, -45.70517343499995],
              [166.79753665500027, -45.7243791649999],
              [166.77426191500012, -45.71884530999989],
              [166.79281660200013, -45.68954843499995],
              [166.80486087300005, -45.67888762799993],
              [166.8222762380001, -45.67034270599993],
              [166.8754988940002, -45.659274997999944],
              [166.890961134, -45.649834893999866],
              [166.79460696700016, -45.6599260399999],
              [166.777679884, -45.65667083099987],
              [166.7700301440002, -45.632745049999926],
              [166.77076256600003, -45.61060963299991],
              [166.78199303500014, -45.59417083099993],
              [166.8051863940001, -45.587823174999926],
              [166.8320418630001, -45.58342864399992],
              [166.88217207100013, -45.564629815999865],
              [166.91163170700008, -45.561130466999884],
              [166.9643660820002, -45.57431405999995],
              [166.99195397200003, -45.575453382999854],
              [167.01343834700015, -45.561130466999884],
              [166.97974694100014, -45.56170012799993],
              [166.96461022200015, -45.557712497999944],
              [166.952484571, -45.546807549999926],
              [167.01710045700008, -45.53240325299993],
              [167.0463973320002, -45.51685963299991],
              [167.05494225400003, -45.491631768999866],
              [166.9218856130001, -45.541273695999905],
              [166.83961022200003, -45.552911065999865],
              [166.78451582100013, -45.57480234199994],
              [166.7734481130001, -45.57561614399992],
              [166.75171959700015, -45.580010674999926],
              [166.7402449880001, -45.58098723799981],
              [166.7226668630001, -45.57968515399989],
              [166.71461022200003, -45.57561614399992],
              [166.70240319100014, -45.55738697699985],
              [166.70248457100013, -45.54241301899992],
              [166.739593946, -45.48544687299989],
              [166.75749759200005, -45.42522551899992],
              [166.7675887380001, -45.40960051899992],
              [166.81226647200003, -45.392836195999905],
              [166.86109459700003, -45.40732187299989],
              [166.90935306100005, -45.42978280999995],
              [166.952484571, -45.43694426899992],
              [166.94117272200015, -45.41326262799993],
              [166.92562910200002, -45.388604424999926],
              [166.91000410200002, -45.379571221999925],
              [166.89779707100013, -45.40276458099993],
              [166.8794051440001, -45.39218515399989],
              [166.84001712300005, -45.37786223799992],
              [166.8222762380001, -45.36874765399989],
              [166.80925540500004, -45.3571916649999],
              [166.806000196, -45.346286716999884],
              [166.81177819100003, -45.33367278399993],
              [166.82553144600013, -45.31715260199985],
              [166.85954837300017, -45.291436455999815],
              [166.8813582690001, -45.27955494599985],
              [166.890961134, -45.282972914999846],
              [166.8989363940001, -45.29998137799993],
              [166.91773522200003, -45.312676690999865],
              [166.95932050900024, -45.32708098799992],
              [166.9502059250002, -45.331963799999926],
              [166.94214928500003, -45.33806731599992],
              [166.93580162900014, -45.345635674999926],
              [166.93213951900032, -45.35507577899995],
              [166.96404056100016, -45.352471612999864],
              [166.99203535200002, -45.343031507999854],
              [167.0190535820003, -45.341241143999866],
              [167.04753665500004, -45.361911716999884],
              [167.0546981130002, -45.37127044099992],
              [167.05884850400014, -45.38005950299987],
              [167.05697675900024, -45.38990650799991],
              [167.04753665500004, -45.40276458099993],
              [167.021820509, -45.41716887799993],
              [167.01107832100013, -45.426446221999925],
              [167.02027428500014, -45.430759372999944],
              [167.0542098320002, -45.42929452899989],
              [167.06617272200003, -45.424086195999905],
              [167.0791121750001, -45.41334400799991],
              [167.0859481130002, -45.40048593499995],
              [167.09001712300005, -45.387465101999794],
              [167.09717858200008, -45.38209400799991],
              [167.12435957100024, -45.39959075299987],
              [167.13689212300017, -45.40553150799991],
              [167.1469832690001, -45.41375090899987],
              [167.153656446, -45.437269789999846],
              [167.17164147200003, -45.47112395599993],
              [167.17595462300017, -45.4685197899999],
              [167.17847741000003, -45.46493905999995],
              [167.1860457690002, -45.46884530999995],
              [167.19906660200013, -45.47380950299987],
              [167.20573978000016, -45.47861093499995],
              [167.2002059250001, -45.445977471999925],
              [167.1484481130001, -45.39812590899993],
              [167.04753665500004, -45.32708098799992],
              [167.0620223320002, -45.31316497199987],
              [167.07886803500003, -45.30632903399993],
              [167.18051191500012, -45.28476327899995],
              [167.19898522200015, -45.28606536299992],
              [167.20915774800017, -45.29404062299989],
              [167.2265731130002, -45.3181291649999],
              [167.240570509, -45.32708098799992],
              [167.259125196, -45.33163827899989],
              [167.2797957690001, -45.33212655999995],
              [167.2978621750001, -45.32659270599987],
              [167.30884850400025, -45.31340911299992],
              [167.29273522200003, -45.309828382999854],
              [167.25757897200015, -45.31113046699994],
              [167.24366295700008, -45.30388762799993],
              [167.2338973320002, -45.29338958099993],
              [167.23121178500014, -45.28875090899993],
              [167.23308353000004, -45.26970794099992],
              [167.2387801440001, -45.258884372999944],
              [167.24732506600014, -45.25432708099987],
              [167.24724368600016, -45.25310637799987],
              [167.20972741000003, -45.25359465899993],
              [167.17164147200003, -45.266289971999925],
              [167.14625084700003, -45.27092864399992],
              [167.06478925900024, -45.27695077899995],
              [167.04753665500004, -45.26970794099992],
              [167.0454207690001, -45.25652434699987],
              [167.03638756600014, -45.236586195999905],
              [167.0302840500001, -45.2165666649999],
              [167.01197350400003, -45.20566171699994],
              [167.00766035200002, -45.194268487999864],
              [167.0048934250001, -45.14959075299993],
              [167.012054884, -45.13290780999989],
              [167.03443444100026, -45.12224700299993],
              [167.06421959700003, -45.12273528399993],
              [167.0879012380002, -45.13494231599992],
              [167.1269637380002, -45.173760674999926],
              [167.13843834700003, -45.18027109199994],
              [167.1552840500002, -45.18474700299987],
              [167.17074629, -45.18474700299987],
              [167.17847741000003, -45.177504164999846],
              [167.17302493600027, -45.17115650799991],
              [167.13697350400003, -45.14959075299993],
              [167.1005965500001, -45.11598072699991],
              [167.07960045700008, -45.10320403399993],
              [167.05494225400003, -45.10173919099992],
              [167.09441165500004, -45.05592213299991],
              [167.11850019600013, -45.039239190999865],
              [167.1406356130001, -45.043145440999865],
              [167.17847741000003, -45.08814869599985],
              [167.1806746750001, -45.10263437299989],
              [167.179047071, -45.115899346999925],
              [167.1806746750001, -45.12712981599992],
              [167.19214928500003, -45.13591887799987],
              [167.19743899800005, -45.12224700299993],
              [167.19450931100005, -45.102146091999884],
              [167.19898522200015, -45.09441497199981],
              [167.21404056100016, -45.08953215899993],
              [167.27466881600003, -45.09441497199981],
              [167.25953209700003, -45.0818010399999],
              [167.20281009200005, -45.06682708099987],
              [167.18181399800005, -45.05706145599993],
              [167.16488691500012, -45.04070403399993],
              [167.15308678500003, -45.024021091999884],
              [167.15154056100016, -45.0075822899999],
              [167.16480553500014, -44.99187590899993],
              [167.18913821700005, -44.98528411299992],
              [167.2148543630001, -44.990899346999925],
              [167.24146569100003, -45.00042083099993],
              [167.26783287900003, -45.00554778399993],
              [167.28874759200016, -45.013441664999846],
              [167.3134871750001, -45.02849700299993],
              [167.33570397200003, -45.03720468499995],
              [167.34986412900025, -45.026055596999925],
              [167.3310653000001, -45.02223072699991],
              [167.21062259200005, -44.97258879999987],
              [167.19898522200015, -44.96404387799987],
              [167.20346113400024, -44.94996510199991],
              [167.22022545700008, -44.93613046699994],
              [167.27019290500016, -44.90553150799991],
              [167.28663170700008, -44.89934661299992],
              [167.30543053500003, -44.89657968499995],
              [167.32927493600016, -44.89568450299987],
              [167.32374108200008, -44.89120859199994],
              [167.31413821700016, -44.88005950299993],
              [167.30884850400025, -44.875258070999905],
              [167.3857528000001, -44.84238046699994],
              [167.41871178500014, -44.840915622999944],
              [167.43230228000027, -44.87184010199991],
              [167.4355574880003, -44.87623463299991],
              [167.44255618600016, -44.88201262799993],
              [167.4497176440001, -44.88941822699991],
              [167.45281009200016, -44.89910247199981],
              [167.4502059250001, -44.90862395599987],
              [167.44027754000024, -44.92782968499995],
              [167.43913821700005, -44.937269789999846],
              [167.44711347700002, -44.95077890399995],
              [167.45923912900003, -44.96103280999995],
              [167.46648196700005, -44.97323984199994],
              [167.45964603000016, -44.99187590899993],
              [167.49675540500004, -44.99472421699994],
              [167.5141707690001, -44.99260833099993],
              [167.511078321, -44.9817033829998],
              [167.5068465500001, -44.97625090899993],
              [167.50342858200008, -44.96917083099987],
              [167.50131269600013, -44.96135833099987],
              [167.50066165500004, -44.954034112999864],
              [167.49781334700003, -44.948011976999794],
              [167.47706139400032, -44.933526299999926],
              [167.47437584700003, -44.92351653399993],
              [167.47641035200013, -44.909112237999864],
              [167.476898634, -44.89316171699994],
              [167.46998131600003, -44.87859465899993],
              [167.46265709700003, -44.868259372999944],
              [167.44809004, -44.835870049999926],
              [167.4453231130002, -44.82366301899992],
              [167.45769290500016, -44.789320570999905],
              [167.48715254, -44.76718515399995],
              [167.52328535200002, -44.76376718499989],
              [167.5551863940001, -44.785821221999925],
              [167.56226647200003, -44.79924895599993],
              [167.559418165, -44.80608489399992],
              [167.5512801440002, -44.81324635199985],
              [167.54216556100016, -44.82740650799991],
              [167.53728274800005, -44.84587981599992],
              [167.5400496750001, -44.86052825299993],
              [167.55014082100013, -44.87224700299993],
              [167.56812584700003, -44.88201262799993],
              [167.57007897200003, -44.85947030999995],
              [167.5786238940001, -44.84465911299992],
              [167.58912194100014, -44.83147551899992],
              [167.59685306100016, -44.813734632999854],
              [167.5947371750002, -44.79338958099993],
              [167.56853274800017, -44.77255624799989],
              [167.56202233200008, -44.75514088299991],
              [167.551117384, -44.741957289999846],
              [167.5488387380001, -44.73447030999989],
              [167.56804446700005, -44.72747161299992],
              [167.5781356130001, -44.72031015399995],
              [167.58871504000012, -44.71624114399992],
              [167.59986412900003, -44.721612237999864],
              [167.61866295700008, -44.74081796699994],
              [167.63502037900014, -44.75261809699981],
              [167.65357506600014, -44.75986093499989],
              [167.67937259200016, -44.765394789999846],
              [167.662445509, -44.75855885199991],
              [167.62476647200015, -44.72503020599987],
              [167.5991317070002, -44.70818450299987],
              [167.5947371750002, -44.69768645599993],
              [167.60303795700008, -44.6833635399999],
              [167.61890709700003, -44.674004815999865],
              [167.6718856130002, -44.66301848799992],
              [167.67896569100014, -44.65699635199991],
              [167.6870223320002, -44.64275481599992],
              [167.6923934250002, -44.63632577899989],
              [167.69898522200003, -44.633396091999884],
              [167.71599368600005, -44.62957122199987],
              [167.7231551440002, -44.62542083099993],
              [167.7519637380001, -44.60320403399987],
              [167.7812606130001, -44.59433359199994],
              [167.81080162900003, -44.59921640399989],
              [167.85499108200008, -44.62810637799993],
              [167.8886824880001, -44.6423479149999],
              [167.90186608200008, -44.65276458099993],
              [167.9326278000001, -44.697035414999846],
              [167.93970787900003, -44.685479424999926],
              [167.9419051440002, -44.67058684699987],
              [167.9394637380001, -44.65520598799992],
              [167.9326278000001, -44.64251067499987],
              [167.927093946, -44.63860442499987],
              [167.90455162900014, -44.628838799999926],
              [167.8779403000002, -44.608330987999864],
              [167.87191816500024, -44.60475025799991],
              [167.86695397200015, -44.60393645599993],
              [167.86207116000003, -44.60198333099993],
              [167.85678144600024, -44.59465911299992],
              [167.85523522200003, -44.58717213299991],
              [167.85678144600024, -44.56047942499987],
              [167.85043379000012, -44.53150807099985],
              [167.84441165500004, -44.51677825299987],
              [167.8364363940002, -44.50530364399992],
              [167.86003665500004, -44.480726820999905],
              [167.94288170700008, -44.41285572699991],
              [167.97193444100014, -44.39421965899993],
              [168.008148634, -44.37615325299993],
              [168.0332137380001, -44.3532854149999],
              [168.02816816500012, -44.32040780999989],
              [168.1181746750001, -44.32040780999989],
              [168.1274520190001, -44.31658294099992],
              [168.13949629, -44.29924895599993],
              [168.13990319100003, -44.28394947699985],
              [168.1367293630002, -44.28077564899991],
              [168.1279403000001, -44.272067966999884],
              [168.10328209700015, -44.26506926899992],
              [168.10328209700015, -44.25823333099993],
              [168.15007571700005, -44.24684010199985],
              [168.1689559250001, -44.238213799999926],
              [168.20533287900014, -44.207289320999905],
              [168.26783287900003, -44.17693450299993],
              [168.30713951900032, -44.14885833099993],
              [168.34009850400003, -44.11834075299987],
              [168.34148196700005, -44.11223723799992],
              [168.3422957690002, -44.10173919099992],
              [168.34522545700008, -44.08928801899992],
              [168.35336347700002, -44.07732512799987],
              [168.3637801440001, -44.06926848799992],
              [168.37484785200002, -44.062432549999926],
              [168.38656660200024, -44.05706145599987],
              [168.39812259200005, -44.053399346999925],
              [168.39136803500003, -44.05087655999989],
              [168.37086022200015, -44.03915780999989],
              [168.39039147200003, -44.03191497199987],
              [168.41032962300005, -44.027927341999884],
              [168.47217858200008, -44.02499765399989],
              [168.5092879570002, -44.018649997999944],
              [168.5429793630002, -44.00611744599985],
              [168.5634871750002, -43.99553801899992],
              [168.57309004000012, -43.98821379999981],
              [168.586761915, -43.982354424999926],
              [168.61247806100005, -43.98447030999995],
              [168.62126712300005, -43.981540622999944],
              [168.64584394600024, -43.96453215899987],
              [168.66285241000014, -43.97136809699981],
              [168.67855879000012, -43.989190362999864],
              [168.6992293630002, -44.00505950299981],
              [168.74675540500004, -44.01034921699994],
              [168.8037215500001, -43.99724700299993],
              [168.85816491000014, -43.97275155999995],
              [168.9184676440002, -43.92888762799993],
              [168.9648543630001, -43.90593840899993],
              [168.98406009200005, -43.892022393999866],
              [169.00163821700005, -43.88241952899995],
              [169.06544030000032, -43.85751718499995],
              [169.08127078386542, -43.84680272027691],
              [169.08632713850284, -43.83817717413069],
              [169.08708743600016, -43.828220309999836],
              [169.0908309250002, -43.8200822899999],
              [169.09831790500004, -43.814629815999865],
              [169.12566165500016, -43.80201588299991],
              [169.13550866000014, -43.79957447699985],
              [169.15414472700013, -43.79208749799989],
              [169.19214928500014, -43.75872161299992],
              [169.21021569100014, -43.75115325299993],
              [169.22999108200008, -43.7458635399999],
              [169.30250084700003, -43.71013762799993],
              [169.352875196, -43.69793059699987],
              [169.38013756600014, -43.687269789999846],
              [169.39177493600005, -43.67262135199991],
              [169.39633222700013, -43.66480885199985],
              [169.407074415, -43.656833591999884],
              [169.41960696700005, -43.65056731599992],
              [169.42945397200015, -43.648125908999816],
              [169.45655358200008, -43.64592864399992],
              [169.465179884, -43.64763762799993],
              [169.47388184982765, -43.64871259154148],
              [169.48250739597393, -43.64722542841281],
              [169.49431399800028, -43.64128997199987],
              [169.50912519600013, -43.63054778399987],
              [169.54916425900012, -43.62216562299989],
              [169.58326256600014, -43.60295989399992],
              [169.62370853000016, -43.60947030999995],
              [169.64576256600003, -43.60767994599985],
              [169.69752037900003, -43.577894789999846],
              [169.7177840500002, -43.57366301899992],
              [169.73365319100003, -43.5656877579998],
              [169.7675887380001, -43.52809010199991],
              [169.78248131600003, -43.51531340899993],
              [169.78845650921915, -43.50431400896059],
              [169.7890731130002, -43.49179452899995],
              [169.80925540500016, -43.4743791649999],
              [169.83529707100013, -43.47079843499995],
              [169.84627741166082, -43.461483710855646],
              [169.84791100400025, -43.447930596999925],
              [169.85425866000003, -43.42620208099993],
              [169.8750106130001, -43.40748463299991],
              [169.89682050900024, -43.394463799999926],
              [170.03012129000012, -43.34579843499995],
              [170.0429793630001, -43.330010674999926],
              [170.05144290500004, -43.30348072699985],
              [170.07327799161726, -43.298014739755104],
              [170.08826859595376, -43.28802100353056],
              [170.09750410200013, -43.27206796699994],
              [170.1049910820002, -43.25807057099985],
              [170.11491946700016, -43.251722914999846],
              [170.1391707690002, -43.244073174999926],
              [170.1645613940002, -43.23040129999987],
              [170.1782332690001, -43.22551848799992],
              [170.19410241000014, -43.223565362999864],
              [170.2055770190002, -43.22584400799991],
              [170.22722415500004, -43.235609632999854],
              [170.2387801440002, -43.23788827899995],
              [170.30355879, -43.16220468499995],
              [170.27165774800005, -43.15764739399992],
              [170.2465926440002, -43.17815520599987],
              [170.22437584700003, -43.20427825299993],
              [170.20053144600024, -43.216729424999926],
              [170.2197371750001, -43.17327239399981],
              [170.25367272200003, -43.14373137799993],
              [170.27957726082263, -43.12954890054232],
              [170.28931725400014, -43.114353122999944],
              [170.28931725400014, -43.106866143999866],
              [170.36309634212716, -43.1031368833776],
              [170.3852253294814, -43.095284662058305],
              [170.3930770190002, -43.08904387799987],
              [170.38502037900025, -43.07968515399995],
              [170.4028426440001, -43.069431247999944],
              [170.41675866000003, -43.054945570999905],
              [170.4321395190002, -43.04615650799991],
              [170.45386803500014, -43.05291106599992],
              [170.45720462300017, -43.03606536299992],
              [170.46803057248428, -43.032466891504384],
              [170.47429446700005, -43.02499765399989],
              [170.51441491000003, -43.00660572699985],
              [170.60377037900003, -42.983086846999925],
              [170.6425887380002, -42.96013762799993],
              [170.6743270190001, -42.95671965899993],
              [170.69003428432836, -42.95608619321723],
              [170.7007418588546, -42.95465851661379],
              [170.70923912900003, -42.947198174999926],
              [170.72201582100013, -42.936211846999925],
              [170.73316491000003, -42.9294572899999],
              [170.76978600400014, -42.915704033999816],
              [170.78728274800005, -42.90113697699985],
              [170.82309004, -42.862237237999864],
              [170.84148196700005, -42.85426197699991],
              [170.8584090500002, -42.84335702899995],
              [170.94385826900032, -42.73381926899981],
              [170.95679772200003, -42.72405364399992],
              [170.96648196700028, -42.72136809699987],
              [170.9869910178561, -42.71480884722604],
              [171.00464928500026, -42.70574309699987],
              [171.01246178500003, -42.69296640399995],
              [171.02719160200002, -42.67400481599992],
              [171.03663170700008, -42.66545989399992],
              [171.0468856130001, -42.66179778399993],
              [171.0629988940001, -42.65398528399987],
              [171.07984459700003, -42.63551197699985],
              [171.1049910820002, -42.60035572699991],
              [171.12281334700015, -42.59238046699994],
              [171.1943465500001, -42.48365650799991],
              [171.21501712300005, -42.46550872199987],
              [171.22541301064018, -42.450688675578874],
              [171.22836347700013, -42.418877862999864],
              [171.2348738940001, -42.39568450299993],
              [171.2837020190001, -42.33977629999987],
              [171.30486087300005, -42.29461028399993],
              [171.33155358200008, -42.14723072699985],
              [171.34937584700015, -42.11028411299992],
              [171.35377037900025, -42.08806731599992],
              [171.36394290500016, -42.06340911299992],
              [171.36898847700002, -42.05543385199991],
              [171.403168165, -42.02402109199994],
              [171.41781660200002, -42.00628020599987],
              [171.4277449880001, -41.983493747999944],
              [171.44459069100003, -41.920668226999794],
              [171.45866946700005, -41.90097421699994],
              [171.46827233200008, -41.86834075299987],
              [171.4887801440001, -41.830336195999905],
              [171.48226972700013, -41.819024346999925],
              [171.47486412900003, -41.826429945999905],
              [171.47055097700002, -41.81910572699991],
              [171.4692488940001, -41.81340911299992],
              [171.468109571, -41.766289971999925],
              [171.48389733200008, -41.75750090899993],
              [171.54371178500014, -41.764336846999925],
              [171.6132918630002, -41.756931247999944],
              [171.63200931100005, -41.75790780999995],
              [171.63941491000026, -41.75750090899993],
              [171.68897545700008, -41.74163176899992],
              [171.78337649800017, -41.69605885199985],
              [171.8086043630002, -41.673760674999926],
              [171.8173934250002, -41.66814544099992],
              [171.83220462300017, -41.665785414999846],
              [171.84555097700024, -41.66765715899993],
              [171.85523522200015, -41.66545989399992],
              [171.86215254000012, -41.642022393999866],
              [171.8701278000001, -41.636000257999854],
              [171.88013756600003, -41.63079192499987],
              [171.88982181100005, -41.623711846999925],
              [171.9038192070002, -41.60686614399992],
              [171.94092858200008, -41.54461028399993],
              [171.94629967500032, -41.53948333099987],
              [171.95093834700026, -41.53875090899993],
              [171.95411217500032, -41.534926039999846],
              [171.95573978000004, -41.51425546699994],
              [171.95728600400014, -41.511895440999865],
              [171.96021569100014, -41.510430596999925],
              [171.96517988400012, -41.50709400799991],
              [171.97331790500027, -41.49814218499995],
              [171.9785262380002, -41.48845794099992],
              [171.98170006600003, -41.47771575299987],
              [171.98267662900014, -41.465752862999864],
              [171.9941512380002, -41.451104424999926],
              [172.0205184250002, -41.43417734199994],
              [172.05005944100014, -41.42009856599992],
              [172.0708113940001, -41.414239190999865],
              [172.06706790500004, -41.404961846999925],
              [172.06617272200015, -41.395114841999884],
              [172.0683699880002, -41.385674737999864],
              [172.08187910200013, -41.366306247999944],
              [172.08383222700013, -41.35458749799989],
              [172.0844832690002, -41.33294036299981],
              [172.08765709700003, -41.308770440999865],
              [172.09253991000003, -41.29924895599987],
              [172.1020613940002, -41.30193450299987],
              [172.10670006600014, -41.3005510399999],
              [172.11589603000004, -41.29607512799993],
              [172.12761478000027, -41.29176197699991],
              [172.1396590500001, -41.29143645599987],
              [172.1201278000002, -41.26327890399989],
              [172.11443118600016, -41.250909112999864],
              [172.1054793630001, -41.140557549999926],
              [172.10792076900032, -41.12835051899992],
              [172.1167098320002, -41.10556405999989],
              [172.118500196, -41.09628671699994],
              [172.1123153000001, -41.044366143999866],
              [172.1123153000001, -40.93572356599992],
              [172.1064559250001, -40.90447356599992],
              [172.10678144600013, -40.88689544099992],
              [172.11540774800017, -40.879164320999905],
              [172.12810306100005, -40.87859465899993],
              [172.13689212300005, -40.875909112999864],
              [172.14380944100003, -40.86988697699985],
              [172.15674889400032, -40.85003020599993],
              [172.1806746750001, -40.82586028399993],
              [172.1840926440002, -40.820245049999926],
              [172.18588300900012, -40.80974700299987],
              [172.1879988940001, -40.80535247199987],
              [172.1948348320003, -40.800225518999866],
              [172.20150800900012, -40.799493096999925],
              [172.2080184250002, -40.79957447699991],
              [172.21469160200013, -40.79729583099993],
              [172.21794681100005, -40.7927385399999],
              [172.221039259, -40.78622812299989],
              [172.22535241000026, -40.78004322699985],
              [172.23210696700005, -40.77752044099992],
              [172.2334090500002, -40.777601820999905],
              [172.24683678500003, -40.77809010199991],
              [172.25407962300017, -40.7771135399999],
              [172.2675887380001, -40.767754815999865],
              [172.29558353000004, -40.75302499799989],
              [172.30746504000012, -40.750176690999865],
              [172.31169681100005, -40.74635182099985],
              [172.36353600400014, -40.71591562299989],
              [172.46355228000016, -40.62175872199987],
              [172.50709069100003, -40.58945077899995],
              [172.54428144600024, -40.57822030999995],
              [172.52800540500016, -40.611260674999926],
              [172.526703321, -40.622328382999854],
              [172.54086347700002, -40.62664153399993],
              [172.5459090500001, -40.62175872199987],
              [172.55152428500014, -40.61248137799993],
              [172.55884850400014, -40.60588958099993],
              [172.5752059250002, -40.612237237999864],
              [172.58415774800005, -40.609307549999926],
              [172.59262129000012, -40.60409921699994],
              [172.59888756600003, -40.59929778399987],
              [172.59441165500016, -40.58473072699985],
              [172.62525475400014, -40.57431405999995],
              [172.62614993600016, -40.56511809699987],
              [172.614593946, -40.555108330999815],
              [172.6113387380003, -40.55152760199991],
              [172.5986434250002, -40.561130466999884],
              [172.58423912900014, -40.567315362999864],
              [172.56999759200016, -40.56910572699985],
              [172.55738366000003, -40.56511809699987],
              [172.59587649800017, -40.52776458099993],
              [172.64144941500012, -40.509698174999926],
              [172.83961022200015, -40.502129815999865],
              [172.90447024800028, -40.50847747199987],
              [172.96412194100003, -40.52157968499995],
              [172.99683678500003, -40.52418385199985],
              [172.973968946, -40.531182549999926],
              [172.7578231130003, -40.51767343499995],
              [172.7421981130002, -40.52092864399992],
              [172.7319442070003, -40.53093840899987],
              [172.72234134200005, -40.55152760199991],
              [172.71168053500003, -40.591078382999854],
              [172.702484571, -40.61003997199987],
              [172.68775475400003, -40.619805596999925],
              [172.69678795700008, -40.640557549999926],
              [172.6914168630001, -40.648370049999926],
              [172.67750084700015, -40.649102471999925],
              [172.66041100400003, -40.647719007999854],
              [172.67408287900014, -40.674411716999884],
              [172.6796981130001, -40.67782968499989],
              [172.69654381600003, -40.68287525799991],
              [172.70134524800017, -40.68743254999987],
              [172.7011824880002, -40.704359632999854],
              [172.68913821700005, -40.73406340899987],
              [172.69450931100005, -40.750176690999865],
              [172.70093834700015, -40.74521249799989],
              [172.72234134200005, -40.73650481599992],
              [172.73609459700003, -40.764906507999854],
              [172.7705184250002, -40.791680596999925],
              [172.8564559250001, -40.843682549999926],
              [172.86931399800005, -40.84726327899989],
              [172.88233483200008, -40.84319426899992],
              [172.90650475400003, -40.82854583099993],
              [172.91146894600013, -40.82675546699994],
              [172.92448978000004, -40.82586028399993],
              [172.92839603000016, -40.82301197699991],
              [172.9262801440001, -40.80999114399992],
              [172.92790774800005, -40.80535247199987],
              [172.9438582690001, -40.793226820999905],
              [172.9516707690001, -40.79404062299989],
              [172.96208743600016, -40.80535247199987],
              [172.9751082690001, -40.78997161299992],
              [172.989105665, -40.78085702899995],
              [173.0034285820002, -40.78199635199991],
              [173.01734459700026, -40.79729583099993],
              [173.0224715500002, -40.809828382999854],
              [173.022797071, -40.819024346999925],
              [173.01734459700026, -40.83896249799989],
              [173.02320397200003, -40.848321221999925],
              [173.0219832690002, -40.856540622999944],
              [173.0097762380003, -40.86679452899995],
              [173.02654056100016, -40.869073174999926],
              [173.04135175900012, -40.868259372999944],
              [173.05420983200008, -40.871758721999925],
              [173.0649520190001, -40.88665129999987],
              [173.06202233200008, -40.89153411299992],
              [173.05201256600003, -40.93572356599992],
              [173.0556746750002, -40.95427825299993],
              [173.05827884200016, -40.963067315999865],
              [173.056000196, -40.96990325299993],
              [173.04460696700016, -40.98300546699994],
              [173.02214603000004, -41.00139739399992],
              [172.99683678500003, -41.01702239399992],
              [173.00619550900012, -41.02141692499987],
              [173.0136824880001, -41.02312590899987],
              [173.02125084700003, -41.021742445999905],
              [173.03093509200005, -41.01702239399992],
              [173.04273522200015, -41.06682708099987],
              [173.04460696700016, -41.08220794099992],
              [173.0503035820002, -41.0974260399999],
              [173.0615340500002, -41.110609632999854],
              [173.06934655000032, -41.12420012799981],
              [173.0649520190001, -41.140557549999926],
              [173.06120853000004, -41.131117445999905],
              [173.05502363400012, -41.12322356599992],
              [173.04721113400012, -41.1169572899999],
              [173.03777103000004, -41.113213799999926],
              [173.03093509200005, -41.149102471999925],
              [173.03435306100016, -41.157891533999816],
              [173.04997806100016, -41.17017994599985],
              [173.05543053500026, -41.177504164999846],
              [173.05827884200016, -41.18889739399992],
              [173.0649520190001, -41.18889739399992],
              [173.0756942070002, -41.176446221999925],
              [173.0835067070002, -41.189222914999846],
              [173.09294681100005, -41.22991301899992],
              [173.10531660200002, -41.25693124799989],
              [173.10613040500016, -41.264743747999944],
              [173.10043379, -41.27092864399992],
              [173.08318118600016, -41.2771135399999],
              [173.07927493600005, -41.284600518999866],
              [173.0864363940002, -41.29941171699994],
              [173.10385175900012, -41.30779387799993],
              [173.12598717500032, -41.31170012799993],
              [173.1723738940001, -41.31194426899992],
              [173.19361412900014, -41.30901458099993],
              [173.21273847700024, -41.30185312299989],
              [173.24976647200003, -41.27743905999995],
              [173.28435306100027, -41.26140715899993],
              [173.30152428500014, -41.247002862999864],
              [173.34009850400014, -41.205987237999864],
              [173.40219160200013, -41.15960051899992],
              [173.427093946, -41.15154387799987],
              [173.43832441500024, -41.13697682099985],
              [173.4487410820002, -41.13372161299992],
              [173.45492597700002, -41.13697682099985],
              [173.45541425900012, -41.144789320999905],
              [173.452484571, -41.15390390399995],
              [173.4487410820002, -41.161065362999864],
              [173.48324629, -41.14999765399995],
              [173.50017337300017, -41.14137135199991],
              [173.51384524800005, -41.130303643999866],
              [173.53003991000014, -41.10637786299992],
              [173.5380965500001, -41.09970468499995],
              [173.5468856130003, -41.09921640399995],
              [173.555511915, -41.103285414999846],
              [173.5639754570002, -41.103773695999905],
              [173.57211347700013, -41.092868747999944],
              [173.5620223320003, -41.08196379999987],
              [173.57113691500012, -41.0681291649999],
              [173.58863366000003, -41.05632903399993],
              [173.60320071700028, -41.05120208099987],
              [173.62086022200015, -41.05624765399995],
              [173.63656660200013, -41.06926848799992],
              [173.64673912900003, -41.08700937299989],
              [173.64795983200008, -41.10637786299992],
              [173.6547957690002, -41.10637786299992],
              [173.6596785820003, -41.09685637799993],
              [173.66472415500004, -41.09368254999987],
              [173.66968834700015, -41.09685637799993],
              [173.67457116000014, -41.10637786299992],
              [173.688812696, -41.09970468499995],
              [173.6748153000001, -41.075941664999846],
              [173.68897545700008, -41.06471119599985],
              [173.71599368600027, -41.05803801899992],
              [173.73975670700008, -41.04802825299993],
              [173.74756920700008, -41.03720468499995],
              [173.7465926440002, -41.027113539999846],
              [173.73861738400012, -41.01978932099985],
              [173.7260848320002, -41.01702239399992],
              [173.68767337300017, -41.037367445999905],
              [173.68140709700003, -41.034437757999854],
              [173.68116295700008, -41.02109140399995],
              [173.68238366000026, -41.01572030999989],
              [173.69874108200008, -40.999932549999926],
              [173.70728600400014, -40.99423593499995],
              [173.73023522200003, -40.98528411299992],
              [173.73975670700008, -40.979587497999944],
              [173.75066165500004, -40.975681247999944],
              [173.80152428500003, -40.96917083099987],
              [173.80681399800005, -40.96493905999995],
              [173.82886803500026, -40.938571872999944],
              [173.8535262380001, -40.92587655999989],
              [173.84978274800017, -40.97185637799993],
              [173.87378991000003, -40.97600676899981],
              [173.8774520190001, -40.97234465899993],
              [173.90796959700003, -40.94882577899989],
              [173.91049238400012, -40.94378020599993],
              [173.9130965500001, -40.93084075299993],
              [173.91423587300017, -40.92766692499987],
              [173.91968834700003, -40.92506275799991],
              [173.9345809250002, -40.92148202899989],
              [173.98365319100003, -40.90097421699994],
              [173.99203535200002, -40.89999765399989],
              [174.0039168630002, -40.89999765399989],
              [174.01579837300005, -40.90203215899993],
              [174.02409915500027, -40.90715911299992],
              [174.03484134200016, -40.933526299999926],
              [174.0175887380001, -40.93718840899987],
              [173.96941165500016, -40.92766692499987],
              [173.97584069100003, -40.94085051899992],
              [173.96998131600014, -40.94793059699987],
              [173.96045983200008, -40.95525481599992],
              [173.95573978000004, -40.96917083099987],
              [173.94450931100016, -40.965915622999944],
              [173.93376712300005, -40.965508721999925],
              [173.92367597700013, -40.96884530999995],
              [173.91423587300017, -40.97600676899981],
              [173.92025800900012, -40.98202890399989],
              [173.92237389400032, -40.98593515399989],
              [173.9257918630001, -40.98845794099992],
              [173.9345809250002, -40.98984140399989],
              [173.9179793630001, -41.001885674999926],
              [173.88550866000026, -41.01018645599987],
              [173.85385175900012, -41.010837497999944],
              [173.83961022200015, -40.999932549999926],
              [173.82439212300017, -40.998304945999905],
              [173.79574629, -41.00139739399992],
              [173.78052819100003, -41.011407158999816],
              [173.80494225400014, -41.03134530999989],
              [173.79078209700015, -41.03850676899992],
              [173.78077233200008, -41.04656340899987],
              [173.7812606130001, -41.05388762799987],
              [173.79810631600014, -41.05868905999995],
              [173.79468834700003, -41.07146575299993],
              [173.78825931100005, -41.08294036299992],
              [173.77955162900014, -41.09254322699991],
              [173.77027428500003, -41.09970468499995],
              [173.778656446, -41.107679945999905],
              [173.79021243600016, -41.11012135199985],
              [173.80054772200015, -41.10475025799991],
              [173.80494225400014, -41.08904387799993],
              [173.8281356130001, -41.063409112999864],
              [173.82886803500026, -41.05868905999995],
              [173.89478600400014, -41.049411716999884],
              [173.92994225400003, -41.048272393999866],
              [173.95573978000004, -41.05868905999995],
              [173.9448348320003, -41.05738697699985],
              [173.9360457690001, -41.059502862999864],
              [173.93043053500003, -41.06536223799992],
              [173.92847741000014, -41.07537200299981],
              [173.92505944100003, -41.084649346999925],
              [173.9170028000002, -41.08407968499995],
              [173.90772545700008, -41.08017343499989],
              [173.90056399800005, -41.07903411299992],
              [173.8955184250001, -41.07781340899993],
              [173.8886824880003, -41.07431405999995],
              [173.88257897200015, -41.0739885399999],
              [173.88013756600014, -41.08220794099992],
              [173.881195509, -41.086195570999905],
              [173.88624108200008, -41.09205494599985],
              [173.88746178500014, -41.09628671699994],
              [173.88599694100003, -41.10588958099993],
              [173.88152103000004, -41.11012135199985],
              [173.87476647200015, -41.11003997199987],
              [173.86646569100003, -41.10637786299992],
              [173.85914147200003, -41.12948984199994],
              [173.84489993600005, -41.13616301899992],
              [173.8291121750002, -41.14006926899992],
              [173.81861412900003, -41.154880466999884],
              [173.83415774800017, -41.15496184699987],
              [173.85230553500003, -41.160821221999925],
              [173.86744225400003, -41.17115650799991],
              [173.87378991000003, -41.18523528399987],
              [173.8715926440001, -41.195570570999905],
              [173.8618270190001, -41.217868747999944],
              [173.85954837300017, -41.22991301899992],
              [173.8471785820003, -41.241469007999854],
              [173.818695509, -41.252536716999884],
              [173.76392662900014, -41.264743747999944],
              [173.76734459700015, -41.276055596999925],
              [173.77426191500012, -41.28394947699991],
              [173.78296959700015, -41.28875090899993],
              [173.79127037900003, -41.29143645599987],
              [173.8969832690001, -41.244398695999905],
              [173.9345809250002, -41.23674895599993],
              [173.9345809250002, -41.22991301899992],
              [173.9199324880001, -41.226332289999846],
              [173.90650475400003, -41.22665780999989],
              [173.89535566500012, -41.22503020599987],
              [173.88746178500014, -41.21624114399992],
              [173.92937259200016, -41.21217213299991],
              [173.95045006600003, -41.2126604149999],
              [173.96599368600005, -41.21965911299992],
              [173.981781446, -41.22421640399995],
              [174.00603274800017, -41.2219377579998],
              [174.03012129, -41.21607838299991],
              [174.04566491000003, -41.20956796699994],
              [174.0395613940002, -41.206475518999866],
              [174.02409915500027, -41.1950822899999],
              [174.08334394600013, -41.199476820999905],
              [174.11215254, -41.19345468499995],
              [174.13396243600016, -41.17538827899995],
              [174.02125084700015, -41.177504164999846],
              [174.00407962300017, -41.181573174999926],
              [174.0014754570003, -41.18474700299987],
              [174.0014754570003, -41.189222914999846],
              [173.999359571, -41.19345468499995],
              [173.9902449880001, -41.1950822899999],
              [173.98357181100005, -41.19500090899993],
              [173.9790145190001, -41.194268487999864],
              [173.97486412900014, -41.19231536299992],
              [173.96941165500016, -41.18889739399992],
              [173.97632897200003, -41.17538827899995],
              [173.922699415, -41.192640882999854],
              [173.89633222700024, -41.191664320999905],
              [173.88746178500014, -41.161065362999864],
              [173.8925887380001, -41.145196221999925],
              [173.90300540500016, -41.13583749799989],
              [173.91578209700003, -41.129082940999865],
              [173.92847741000014, -41.12070077899989],
              [173.93043053500003, -41.11443450299993],
              [173.92839603000016, -41.10735442499981],
              [173.92790774800005, -41.10198333099993],
              [173.93531334700003, -41.09970468499995],
              [173.94410241000014, -41.09872812299989],
              [173.94898522200003, -41.095635674999926],
              [173.95045006600003, -41.089288018999866],
              [173.94890384200005, -41.07903411299992],
              [173.98365319100003, -41.08521900799991],
              [173.9731551440002, -41.10116952899995],
              [173.97055097700013, -41.11663176899992],
              [173.97632897200003, -41.14739348799992],
              [173.99382571700028, -41.12322356599992],
              [174.0024520190001, -41.10409921699994],
              [174.01539147200003, -41.09295012799993],
              [174.04566491000003, -41.092868747999944],
              [174.0288192070002, -41.07317473799992],
              [174.02426191500024, -41.063409112999864],
              [174.04135175900012, -41.04306405999995],
              [174.0420028000001, -41.02825286299992],
              [174.0337020190001, -41.01718515399995],
              [174.01726321700005, -41.01702239399992],
              [174.0107528000001, -41.02678801899992],
              [174.00660241000003, -41.04241301899992],
              [174.00017337300005, -41.05291106599992],
              [173.98707116000003, -41.04802825299993],
              [173.95630944100003, -41.02263762799993],
              [173.94890384200005, -41.010837497999944],
              [173.98365319100003, -41.010837497999944],
              [173.9755965500002, -40.997979424999926],
              [173.97437584700003, -40.98796965899993],
              [173.98121178500003, -40.98406340899993],
              [173.99675540500004, -40.98984140399989],
              [173.9985457690002, -40.96884530999995],
              [174.01587975400014, -40.974541924999926],
              [174.05201256600014, -41.003350518999866],
              [174.0732528000002, -41.01425546699994],
              [174.0942488940002, -41.01913827899989],
              [174.11312910200002, -41.014336846999925],
              [174.128265821, -40.99651458099993],
              [174.14527428500003, -41.00937265399995],
              [174.16195722700002, -41.003838799999926],
              [174.17172285200002, -40.98788827899995],
              [174.1679793630002, -40.96917083099987],
              [174.1831160820002, -40.97307708099987],
              [174.19890384200016, -40.98455169099992],
              [174.2114363940001, -40.99960702899995],
              [174.21648196700016, -41.013929945999905],
              [174.21648196700016, -41.025648695999905],
              [174.21534264400032, -41.03289153399993],
              [174.210297071, -41.036553643999866],
              [174.1889754570003, -41.03915780999995],
              [174.18433678500003, -41.043389580999815],
              [174.1845809250002, -41.04998137799987],
              [174.18913821700028, -41.05868905999995],
              [174.20720462300017, -41.070570570999905],
              [174.2265731130001, -41.06519947699985],
              [174.24341881600003, -41.052178643999866],
              [174.26441491000003, -41.031426690999865],
              [174.30453535200013, -41.000583591999884],
              [174.3188582690001, -40.99651458099993],
              [174.32642662900014, -41.00937265399995],
              [174.31869550900012, -41.0266252579998],
              [174.26734459700003, -41.08904387799993],
              [174.26148522200003, -41.09880950299987],
              [174.26042728000016, -41.118259372999944],
              [174.25733483200008, -41.12688567499987],
              [174.25407962300005, -41.12444426899992],
              [174.24000084700015, -41.13046640399995],
              [174.22779381600003, -41.138116143999866],
              [174.23015384200016, -41.140557549999926],
              [174.22624759200005, -41.143161716999884],
              [174.2168074880002, -41.14739348799992],
              [174.20720462300017, -41.14723072699985],
              [174.20281009200005, -41.13713958099993],
              [174.20281009200005, -41.09628671699994],
              [174.1997176440002, -41.091566664999846],
              [174.19288170700008, -41.09880950299987],
              [174.18572024800005, -41.11093515399995],
              [174.18230228000004, -41.12070077899989],
              [174.167328321, -41.115899346999925],
              [174.1670028000001, -41.12420012799981],
              [174.17448978000004, -41.137383721999925],
              [174.18230228000004, -41.14739348799992],
              [174.20329837300005, -41.164727471999925],
              [174.210297071, -41.173597914999846],
              [174.21648196700016, -41.18889739399992],
              [174.2119246750001, -41.19060637799993],
              [174.1992293630002, -41.19394296699994],
              [174.19597415500016, -41.1950822899999],
              [174.19556725400014, -41.19304778399987],
              [174.17546634200016, -41.202569268999866],
              [174.1674910820002, -41.20907968499995],
              [174.1621199880001, -41.21559010199985],
              [174.15495853000016, -41.220961195999905],
              [174.140961134, -41.22307708099993],
              [174.08855228000004, -41.22332122199987],
              [174.061859571, -41.229180596999925],
              [174.04566491000003, -41.243584893999866],
              [174.0337020190001, -41.23723723799992],
              [174.02165774800017, -41.235772393999866],
              [174.0112410820002, -41.2400041649999],
              [174.00407962300017, -41.25042083099987],
              [173.988617384, -41.24570077899995],
              [173.9702254570002, -41.24944426899992],
              [173.95232181100016, -41.25798919099992],
              [173.938324415, -41.267754815999865],
              [173.93523196700005, -41.27955494599985],
              [173.95875084700003, -41.279066664999846],
              [173.9868270190001, -41.27304452899995],
              [173.99732506600003, -41.267754815999865],
              [174.01921634200016, -41.27337004999987],
              [174.03402754000012, -41.26881275799991],
              [174.047699415, -41.25945403399987],
              [174.06560306100027, -41.25042083099987],
              [174.07699629, -41.249769789999846],
              [174.08773847700002, -41.25237395599993],
              [174.0986434250001, -41.25302499799989],
              [174.1181746750001, -41.243096612999864],
              [174.13892662900014, -41.23951588299991],
              [174.14820397200026, -41.23674895599993],
              [174.15870201900032, -41.246351820999905],
              [174.1723738940001, -41.255303643999866],
              [174.18677819100003, -41.26213958099987],
              [174.19947350400003, -41.264743747999944],
              [174.21176191500012, -41.262383721999925],
              [174.22624759200005, -41.25261809699987],
              [174.23658287900014, -41.25042083099987],
              [174.26335696700016, -41.24773528399993],
              [174.28443444100003, -41.240329684999836],
              [174.32569420700008, -41.21624114399992],
              [174.31324303500003, -41.24130624799989],
              [174.297699415, -41.264743747999944],
              [174.29021243600005, -41.271661065999865],
              [174.27035566500012, -41.28557708099993],
              [174.26050866000014, -41.29509856599992],
              [174.25554446700016, -41.30478280999989],
              [174.2519637380001, -41.31462981599992],
              [174.24529056100016, -41.32244231599992],
              [174.21404056100016, -41.328789971999925],
              [174.19027754, -41.34335702899995],
              [174.17546634200016, -41.34661223799992],
              [174.18043053500014, -41.336602471999925],
              [174.19752037900003, -41.31487395599987],
              [174.19947350400003, -41.308770440999865],
              [174.1894637380001, -41.30624765399995],
              [174.16863040500004, -41.3220354149999],
              [174.15503991000014, -41.31943124799983],
              [174.16187584700003, -41.30494557099985],
              [174.13306725400003, -41.320082289999846],
              [174.1137801440001, -41.34498463299991],
              [174.09799238400012, -41.37379322699991],
              [174.07927493600005, -41.40056731599992],
              [174.055511915, -41.42457447699991],
              [174.05062910200024, -41.43694426899992],
              [174.05201256600014, -41.45582447699985],
              [174.062836134, -41.486260674999926],
              [174.06470787900014, -41.50066497199987],
              [174.05811608200008, -41.51726653399993],
              [174.07691491000003, -41.52044036299992],
              [174.08871504, -41.532647393999866],
              [174.0932723320002, -41.54583098799992],
              [174.0898543630001, -41.55201588299991],
              [174.09351647200015, -41.55592213299991],
              [174.10434004, -41.56121184699987],
              [174.11540774800005, -41.55852629999987],
              [174.12029056100005, -41.538344007999854],
              [174.11508222700002, -41.533786716999884],
              [174.1059676440001, -41.5134416649999],
              [174.10320071700005, -41.49797942499981],
              [174.1171981130002, -41.50709400799991],
              [174.1723738940001, -41.57822030999995],
              [174.17403634887523, -41.59240659350667],
              [174.17902811678448, -41.605187499364604],
              [174.18319217354463, -41.615300208639496],
              [174.18913821700028, -41.63396575299993],
              [174.1899520190001, -41.64462655999995],
              [174.2109481130001, -41.699395440999865],
              [174.21648196700016, -41.705987237999864],
              [174.225922071, -41.72340260199991],
              [174.24822024800017, -41.73333098799992],
              [174.2734481130002, -41.73560963299991],
              [174.29216556100005, -41.73015715899987],
              [174.28638756600014, -41.754571221999925],
              [174.215179884, -41.8567033829998],
              [174.19792728000016, -41.87607187299989],
              [174.08171634200005, -41.969089450999945],
              [174.00407962300017, -42.031182549999926],
              [173.9751082690001, -42.067152601999794],
              [173.9614363940001, -42.09010182099985],
              [173.95573978000004, -42.110446872999944],
              [173.956390821, -42.14080169099992],
              [173.9541121750001, -42.15878671699994],
              [173.9446512077102, -42.16793002724347],
              [173.93870255519562, -42.17804273651825],
              [173.9311629570002, -42.19085051899992],
              [173.9292098320002, -42.19557057099985],
              [173.9101668630001, -42.21453215899987],
              [173.89087975400003, -42.240817966999884],
              [173.87134850400014, -42.25505950299987],
              [173.82634524800017, -42.276788018999866],
              [173.80494225400014, -42.291924737999864],
              [173.7739363940001, -42.329766533999816],
              [173.76807701900032, -42.33318450299993],
              [173.76124108200008, -42.334161065999865],
              [173.7470809250002, -42.33359140399989],
              [173.73707116000003, -42.3513322899999],
              [173.7329207690001, -42.35711028399987],
              [173.7216903000002, -42.36484140399989],
              [173.71111087300017, -42.37037525799991],
              [173.7036238940002, -42.378594658999816],
              [173.70191491000003, -42.39495208099993],
              [173.70582116000003, -42.4040666649999],
              [173.72291100400014, -42.4196916649999],
              [173.72974694100003, -42.42913176899992],
              [173.7231551440001, -42.43670012799993],
              [173.71558678500014, -42.44345468499989],
              [173.69507897200015, -42.422946872999944],
              [173.68376712300005, -42.41741301899992],
              [173.6684676440001, -42.415459893999866],
              [173.65552819100003, -42.418633721999925],
              [173.634125196, -42.43279387799993],
              [173.62370853000004, -42.43596770599993],
              [173.61109459700026, -42.44345468499989],
              [173.5586043630001, -42.491143487999864],
              [173.53874759200016, -42.529473565999865],
              [173.52320397200015, -42.573337497999944],
              [173.4995223320002, -42.61012135199991],
              [173.45541425900012, -42.627129815999865],
              [173.45541425900012, -42.63453541499979],
              [173.46241295700008, -42.634942315999865],
              [173.467133009, -42.63681405999995],
              [173.4712020190001, -42.63909270599993],
              [173.4765731130002, -42.64137135199991],
              [173.3989363940001, -42.7653947899999],
              [173.38795006600003, -42.80022551899992],
              [173.37289472700002, -42.82154713299991],
              [173.35377037900003, -42.83945077899995],
              [173.32252037900003, -42.8513322899999],
              [173.32056725400003, -42.861586195999905],
              [173.3252059250001, -42.88095468499995],
              [173.32488040500016, -42.89226653399993],
              [173.3261824880001, -42.897719007999854],
              [173.32545006600026, -42.90349700299993],
              [173.3183699880001, -42.915704033999816],
              [173.30884850400014, -42.924411716999884],
              [173.30005944100003, -42.92782968499989],
              [173.2934676440001, -42.93287525799991],
              [173.2910262380001, -42.94687265399989],
              [173.28728274800017, -42.95387135199985],
              [173.27800540500016, -42.9607072899999],
              [173.2343856130001, -42.98072682099985],
              [173.22339928500003, -42.98357512799987],
              [173.19507897200003, -42.98674895599993],
              [173.153656446, -43.002536716999884],
              [173.1479598320002, -43.01246510199991],
              [173.14437910200002, -43.023695570999905],
              [173.1401473320002, -43.03240325299987],
              [173.13152103000016, -43.03923919099992],
              [173.08326256600014, -43.066989841999884],
              [172.9482528000002, -43.09148528399993],
              [172.9150496750002, -43.10279713299991],
              [172.88795006600014, -43.12786223799992],
              [172.81120853000027, -43.169040622999944],
              [172.7968856130001, -43.18865325299993],
              [172.77409915500004, -43.2302385399999],
              [172.75049889400032, -43.257256768999866],
              [172.745453321, -43.2653947899999],
              [172.7486944484964, -43.27969352453431],
            ],
          ],
          [
            [
              [175.16863040500004, -36.74114348799992],
              [175.19060306100005, -36.73121510199991],
              [175.19597415500004, -36.7341447899999],
              [175.206390821, -36.744805596999925],
              [175.215179884, -36.758477471999925],
              [175.2075301440001, -36.763604424999926],
              [175.19320722700002, -36.76685963299991],
              [175.1821395190001, -36.775323174999926],
              [175.18116295700008, -36.785088799999926],
              [175.18873131600003, -36.805352471999925],
              [175.189789259, -36.815118096999925],
              [175.18718509200005, -36.822523695999905],
              [175.1826278000001, -36.82496510199991],
              [175.16968834700003, -36.82366301899992],
              [175.16187584700003, -36.82390715899993],
              [175.1416121750001, -36.82976653399993],
              [175.12086022200003, -36.831963799999926],
              [175.09937584700003, -36.82935963299991],
              [175.05876712300005, -36.81682708099993],
              [175.06617272200003, -36.80934010199991],
              [175.044281446, -36.79265715899993],
              [175.03394616000003, -36.790948174999926],
              [175.0214949880001, -36.79973723799992],
              [175.0117293630001, -36.802666924999926],
              [175.0078231130001, -36.7907854149999],
              [175.0097762380001, -36.773695570999905],
              [175.01832116000003, -36.7614885399999],
              [175.0258895190001, -36.76246510199991],
              [175.07642662900003, -36.7614885399999],
              [175.08741295700008, -36.76702239399992],
              [175.09546959700003, -36.77703215899993],
              [175.1059676440001, -36.781914971999925],
              [175.12452233200008, -36.772149346999925],
              [175.16863040500004, -36.74114348799992],
            ],
          ],
          [
            [
              [175.8476668630001, -36.62509530999995],
              [175.84131920700008, -36.627211195999905],
              [175.83513431100005, -36.62859465899993],
              [175.8286238940001, -36.62908294099992],
              [175.82211347700002, -36.628838799999926],
              [175.81788170700008, -36.62851327899995],
              [175.80974368600005, -36.62664153399993],
              [175.79753665500004, -36.621758721999925],
              [175.7949324880001, -36.61834075299993],
              [175.79639733200008, -36.61451588299991],
              [175.799164259, -36.61012135199991],
              [175.80054772200003, -36.607354424999926],
              [175.80144290500004, -36.60426197699991],
              [175.80103600400003, -36.60084400799991],
              [175.799164259, -36.59710051899992],
              [175.79281660200002, -36.59319426899992],
              [175.784515821, -36.59148528399993],
              [175.77686608200008, -36.58749765399995],
              [175.7719832690001, -36.57659270599993],
              [175.799164259, -36.56975676899992],
              [175.80583743600005, -36.57773202899995],
              [175.81666100400003, -36.60393645599993],
              [175.82781009200005, -36.60507577899995],
              [175.836273634, -36.60857512799993],
              [175.8427840500001, -36.615166924999926],
              [175.8476668630001, -36.62509530999995],
            ],
          ],
          [
            [
              [174.85328209700003, -36.391696872999944],
              [174.866547071, -36.384698174999926],
              [174.88233483200008, -36.389743747999944],
              [174.8955184250001, -36.40154387799993],
              [174.90113366000003, -36.41521575299993],
              [174.90796959700003, -36.439385674999926],
              [174.90601647200003, -36.449151299999926],
              [174.89087975400003, -36.45322030999995],
              [174.85523522200003, -36.45240650799991],
              [174.84546959700003, -36.44850025799991],
              [174.86011803500003, -36.43954843499995],
              [174.86060631600003, -36.428399346999925],
              [174.85075931100005, -36.40374114399992],
              [174.85328209700003, -36.391696872999944],
            ],
          ],
          [
            [
              [175.13453209700003, -36.17595794099992],
              [175.1386824880001, -36.182305596999925],
              [175.14763431100005, -36.190524997999944],
              [175.15495853000004, -36.20086028399993],
              [175.15495853000004, -36.213555596999925],
              [175.14600670700008, -36.22193775799991],
              [175.1308699880001, -36.22665780999995],
              [175.11394290500004, -36.2282854149999],
              [175.10035241000003, -36.22779713299991],
              [175.08082116000003, -36.20566171699994],
              [175.09538821700005, -36.186618747999944],
              [175.12086022200003, -36.17522551899992],
              [175.13453209700003, -36.17595794099992],
            ],
          ],
          [
            [
              [175.538422071, -36.28240325299993],
              [175.55779056100005, -36.30429452899995],
              [175.56592858200008, -36.30974700299993],
              [175.546234571, -36.34335702899995],
              [175.53687584700003, -36.35076262799993],
              [175.522797071, -36.35214609199994],
              [175.51514733200008, -36.34465911299992],
              [175.5117293630001, -36.33261484199994],
              [175.51124108200008, -36.32000090899993],
              [175.50554446700005, -36.309258721999925],
              [175.49244225400003, -36.31267669099992],
              [175.4775496750001, -36.31975676899992],
              [175.4668074880001, -36.32000090899993],
              [175.46159915500004, -36.309665622999944],
              [175.45923912900003, -36.28435637799993],
              [175.45590254, -36.27556731599992],
              [175.44800866000003, -36.27068450299993],
              [175.43970787900003, -36.27092864399992],
              [175.41553795700008, -36.27556731599992],
              [175.4189559250001, -36.26677825299993],
              [175.41871178500003, -36.26067473799992],
              [175.41521243600005, -36.25505950299993],
              [175.40805097700002, -36.24765390399995],
              [175.38493899800005, -36.25400155999995],
              [175.3564559250001, -36.2439104149999],
              [175.33375084700003, -36.223728122999944],
              [175.32691491000003, -36.199883721999925],
              [175.35279381600003, -36.22519296699994],
              [175.3603621750001, -36.22779713299991],
              [175.3696395190001, -36.21965911299992],
              [175.369476759, -36.20712655999995],
              [175.36736087300005, -36.193617445999905],
              [175.37061608200008, -36.18279387799993],
              [175.37907962300005, -36.16545989399992],
              [175.36540774800005, -36.15683359199994],
              [175.34522545700008, -36.14853280999995],
              [175.33375084700003, -36.13160572699991],
              [175.36353600400003, -36.131931247999944],
              [175.37663821700005, -36.128024997999944],
              [175.3877059250001, -36.11793385199991],
              [175.36793053500003, -36.1013322899999],
              [175.364105665, -36.08131275799991],
              [175.3754988940001, -36.06585051899992],
              [175.4013778000001, -36.06267669099992],
              [175.41138756600003, -36.06585051899992],
              [175.420258009, -36.07195403399993],
              [175.4267684250001, -36.08123137799993],
              [175.42920983200008, -36.09384530999995],
              [175.4336043630001, -36.09978606599992],
              [175.4633895190001, -36.11793385199991],
              [175.4438582690001, -36.125664971999925],
              [175.44597415500004, -36.13713958099993],
              [175.460297071, -36.149102471999925],
              [175.48650149800005, -36.16228606599992],
              [175.512054884, -36.170993747999944],
              [175.52173912900003, -36.172539971999925],
              [175.530609571, -36.17636484199994],
              [175.525726759, -36.18523528399993],
              [175.51636803500003, -36.195570570999905],
              [175.51124108200008, -36.20354583099993],
              [175.50766035200002, -36.218682549999926],
              [175.50212649800005, -36.229587497999944],
              [175.50180097700002, -36.241306247999944],
              [175.5146590500001, -36.258477471999925],
              [175.518890821, -36.26213958099993],
              [175.52418053500003, -36.26523202899995],
              [175.5297957690001, -36.2673479149999],
              [175.53541100400003, -36.26816171699994],
              [175.53874759200005, -36.269789320999905],
              [175.53874759200005, -36.27385833099993],
              [175.5376082690001, -36.27849700299993],
              [175.538422071, -36.28240325299993],
            ],
          ],
          [
            [
              [172.14599548378376, -34.14465801207878],
              [172.15087316550614, -34.14445477534034],
              [172.15717350439755, -34.14445477534034],
              [172.15839292482815, -34.14811303663213],
              [172.15473466353637, -34.15197453466235],
              [172.14579224704534, -34.152381008139216],
              [172.1461987205222, -34.15583603269257],
              [172.14884079812182, -34.16193313484555],
              [172.1482310879065, -34.16498168592204],
              [172.15168611245988, -34.16681081656793],
              [172.1486375613834, -34.16762376352166],
              [172.14477606335316, -34.16904642069069],
              [172.137662777508, -34.16924965742912],
              [172.13156567535503, -34.1659978696142],
              [172.12770417732483, -34.16152666136868],
              [172.12181031191028, -34.15644574290787],
              [172.1163229199726, -34.152381008139216],
              [172.11469702606513, -34.146487142724666],
              [172.1163229199726, -34.14425153860191],
              [172.1199811812644, -34.14506448555564],
              [172.12546857320206, -34.1473000896784],
              [172.1388821979386, -34.14912922032429],
              [172.14355664292256, -34.1466903794631],
              [172.14599548378376, -34.14465801207878],
            ],
          ],
          [
            [
              [176.9537118373879, -39.60751275685698],
              [176.96070397200003, -39.624444268999866],
              [176.967133009, -39.62420012799993],
              [176.9731551440001, -39.62997812299989],
              [176.98959394600013, -39.636651299999926],
              [177.01547285200013, -39.65203215899987],
              [177.02263431100016, -39.65740325299993],
              [177.0356551440001, -39.663832289999846],
              [177.05307050900012, -39.664239190999865],
              [177.08716881600014, -39.66082122199987],
              [177.11890709700026, -39.667250257999854],
              [177.1152449880001, -39.68092213299991],
              [177.0976668630002, -39.70077890399989],
              [177.08716881600014, -39.72535572699991],
              [177.0825301440002, -39.733086846999925],
              [177.0717879570002, -39.74081796699994],
              [177.05933678500026, -39.746677341999884],
              [177.03638756600026, -39.75359465899987],
              [177.02857506600014, -39.76474374799989],
              [177.0058699880003, -39.831475518999866],
              [177.0058699880003, -39.83521900799991],
              [177.00709069100003, -39.840020440999865],
              [177.00766035200013, -39.84587981599992],
              [177.0058699880003, -39.852634372999944],
              [177.0019637380001, -39.8547502579998],
              [176.98650149800005, -39.85979583099993],
              [176.98121178500014, -39.862562757999854],
              [176.9677840500002, -39.88201262799987],
              [176.93458092500032, -39.970147393999866],
              [176.9130965500002, -40.01067473799992],
              [176.8994246750001, -40.02743905999989],
              [176.8950301440002, -40.03671640399995],
              [176.89421634200005, -40.04989999799983],
              [176.89600670700008, -40.075127862999864],
              [176.895355665, -40.081801039999846],
              [176.89340254, -40.08652109199994],
              [176.88054446700005, -40.10173919099992],
              [176.87761478000004, -40.10637786299992],
              [176.8618270190002, -40.14072030999989],
              [176.837250196, -40.17791106599981],
              [176.79704837300017, -40.22283294099992],
              [176.7534285820002, -40.253838799999926],
              [176.7451278000001, -40.25676848799992],
              [176.73552493600016, -40.25310637799987],
              [176.7270613940001, -40.24529387799981],
              [176.71794681100005, -40.24081796699994],
              [176.7070418630002, -40.24675872199987],
              [176.68181399800017, -40.27459075299993],
              [176.67302493600016, -40.291192315999865],
              [176.66944420700008, -40.31129322699991],
              [176.67603600400025, -40.302504164999846],
              [176.6840926440002, -40.29566822699985],
              [176.69312584700003, -40.29143645599993],
              [176.7036238940001, -40.29021575299993],
              [176.63941491000014, -40.390883070999905],
              [176.62842858200008, -40.46209075299993],
              [176.6113387380001, -40.48455169099992],
              [176.5869246750002, -40.48577239399992],
              [176.561859571, -40.48121510199991],
              [176.5424910820002, -40.48601653399987],
              [176.4843856130001, -40.558363539999846],
              [176.4248153000002, -40.603936455999815],
              [176.41618899800005, -40.616631768999866],
              [176.4145613940002, -40.6267229149999],
              [176.41041100400014, -40.63836028399993],
              [176.40503991000003, -40.64934661299981],
              [176.38510175900012, -40.67815520599993],
              [176.37826582100013, -40.68173593499989],
              [176.36207116000014, -40.6833635399999],
              [176.35474694100014, -40.68743254999987],
              [176.347992384, -40.696547132999854],
              [176.30974368600005, -40.771416924999926],
              [176.28663170700008, -40.800225518999866],
              [176.25171959700003, -40.86679452899995],
              [176.23560631600003, -40.913995049999926],
              [176.22038821700005, -40.93328215899987],
              [176.1709090500002, -40.94890715899987],
              [176.14975019600013, -40.96705494599985],
              [176.13249759200005, -40.98992278399987],
              [176.12134850400003, -41.010837497999944],
              [176.08936608200008, -41.10198333099993],
              [176.06812584700003, -41.13982512799987],
              [175.9668074880002, -41.247002862999864],
              [175.81421959700003, -41.34189218499989],
              [175.7773543630002, -41.37151458099987],
              [175.72722415500016, -41.39885833099993],
              [175.66871178500014, -41.421644789999846],
              [175.44841556100005, -41.551853122999944],
              [175.3798934250001, -41.572442315999865],
              [175.36345462300017, -41.58163827899995],
              [175.33033287900003, -41.60979583099993],
              [175.31413821700016, -41.61484140399995],
              [175.23747806100027, -41.62029387799987],
              [175.2216903000001, -41.61370208099993],
              [175.21241295700008, -41.58245208099993],
              [175.19654381600003, -41.57252369599985],
              [175.20191491000003, -41.55754973799992],
              [175.1972762380001, -41.54656340899993],
              [175.18873131600026, -41.53639088299991],
              [175.1821395190001, -41.524102471999925],
              [175.18132571700005, -41.510023695999905],
              [175.19743899800005, -41.435642184999836],
              [175.192718946, -41.42489999799989],
              [175.18181399800005, -41.417901299999926],
              [175.06226647200015, -41.383070570999905],
              [175.0351668630001, -41.380791924999926],
              [175.00953209700003, -41.385674737999864],
              [174.98658287900003, -41.397881768999866],
              [174.9375106130001, -41.43808359199994],
              [174.92790774800005, -41.443617445999905],
              [174.91716556100005, -41.44500090899993],
              [174.90113366000003, -41.44215260199991],
              [174.87907962300005, -41.429864190999865],
              [174.865570509, -41.41952890399995],
              [174.86353600400014, -41.411228122999944],
              [174.87663821700005, -41.39218515399995],
              [174.87476647200015, -41.375664971999925],
              [174.8681746750002, -41.357354424999926],
              [174.86687259200016, -41.33294036299981],
              [174.8745223320002, -41.31178150799991],
              [174.8964949880001, -41.272556247999944],
              [174.90113366000003, -41.247002862999864],
              [174.8896590500001, -41.22454192499987],
              [174.8632918630001, -41.218682549999926],
              [174.83375084700015, -41.222588799999926],
              [174.8129988940001, -41.22991301899992],
              [174.79721113400012, -41.23943450299993],
              [174.78541100400003, -41.24944426899992],
              [174.77702884200016, -41.26165129999987],
              [174.77133222700002, -41.27776458099993],
              [174.81812584700015, -41.28671640399989],
              [174.83228600400003, -41.29648202899995],
              [174.82593834700015, -41.31943124799983],
              [174.8193465500002, -41.32732512799987],
              [174.8100692070002, -41.3337541649999],
              [174.7993270190001, -41.33554452899989],
              [174.7880965500002, -41.32927825299993],
              [174.77759850400003, -41.32634856599992],
              [174.7661238940001, -41.33294036299981],
              [174.75375410200013, -41.34197356599992],
              [174.74057050900012, -41.34661223799992],
              [174.6948348320002, -41.33953215899987],
              [174.6460067070002, -41.32040780999989],
              [174.6093856130001, -41.291924737999864],
              [174.599945509, -41.25725676899992],
              [174.61150149800005, -41.23739999799989],
              [174.629730665, -41.22991301899992],
              [174.675140821, -41.22307708099993],
              [174.69166100400014, -41.212009372999944],
              [174.73023522200003, -41.17620208099987],
              [174.75554446700005, -41.158786716999884],
              [174.78003991000003, -41.116143487999864],
              [174.795258009, -41.10637786299992],
              [174.8169051440001, -41.09921640399995],
              [174.82992597700002, -41.08757903399987],
              [174.84009850400003, -41.087172132999854],
              [174.85328209700003, -41.113213799999926],
              [174.86597741000003, -41.104180596999925],
              [174.87126712300005, -41.09531015399989],
              [174.87086022200003, -41.085056247999944],
              [174.86687259200016, -41.07170989399992],
              [174.86150149800005, -41.06902434699987],
              [174.84945722700013, -41.05689869599979],
              [174.84197024800017, -41.04371510199991],
              [174.84986412900003, -41.03753020599993],
              [174.8613387380001, -41.03329843499995],
              [174.8789168630001, -41.01506926899992],
              [174.89087975400003, -41.010837497999944],
              [174.9023543630001, -41.00807057099979],
              [174.9150496750001, -41.001234632999854],
              [174.926605665, -40.99212004999987],
              [174.93523196700005, -40.98300546699994],
              [174.942718946, -40.970635674999926],
              [174.94556725400014, -40.960707289999846],
              [174.94890384200016, -40.93572356599992],
              [174.96998131600014, -40.890069268999866],
              [174.97917728000016, -40.87493254999987],
              [175.03825931100005, -40.82586028399993],
              [175.09424889400032, -40.75432708099987],
              [175.14128665500016, -40.674411716999884],
              [175.1684676440002, -40.60621510199985],
              [175.179047071, -40.58904387799993],
              [175.1875106130001, -40.56878020599993],
              [175.19117272200015, -40.51238372199987],
              [175.19654381600003, -40.48943450299981],
              [175.19703209700003, -40.48430754999987],
              [175.19613691500024, -40.47771575299993],
              [175.1962996750002, -40.471937757999854],
              [175.199554884, -40.46949635199991],
              [175.20687910200013, -40.469414971999925],
              [175.2163192070002, -40.46819426899992],
              [175.2226668630001, -40.46502044099992],
              [175.2163192070002, -40.44947682099985],
              [175.21314537900014, -40.43425872199987],
              [175.21208743600005, -40.41936614399992],
              [175.21363366000014, -40.41090260199985],
              [175.22234134200028, -40.39332447699985],
              [175.2348738940002, -40.33603280999989],
              [175.2387801440001, -40.296319268999866],
              [175.2371446828132, -40.28591517352356],
              [175.23129316500012, -40.27727629999981],
              [175.21558678500003, -40.253676039999846],
              [175.20264733200008, -40.188409112999864],
              [175.18376712300017, -40.13445403399993],
              [175.17066491000003, -40.10800546699994],
              [175.15495853000027, -40.08538176899992],
              [175.07886803500003, -40.02459075299987],
              [175.05876712300005, -39.99667734199994],
              [174.9672957690002, -39.91643645599993],
              [174.8974715500001, -39.882582289999846],
              [174.84197024800017, -39.86248137799987],
              [174.81609134200016, -39.85881926899992],
              [174.77230879, -39.859144789999846],
              [174.73503665500016, -39.85947030999989],
              [174.65455162900003, -39.83635833099993],
              [174.59327233200008, -39.831475518999866],
              [174.56763756600003, -39.82675546699994],
              [174.54371178500003, -39.814629815999865],
              [174.43726647200003, -39.73691171699994],
              [174.41814212300028, -39.7185197899999],
              [174.3598738940001, -39.647149346999925],
              [174.31902103000016, -39.61386484199994],
              [174.26905358200008, -39.59189218499989],
              [174.21509850400003, -39.578545830999815],
              [174.04460696700016, -39.557549737999864],
              [173.98658287900003, -39.54225025799991],
              [173.85124759200005, -39.46396249799983],
              [173.81470787900003, -39.4333635399999],
              [173.78443444100003, -39.39324309699987],
              [173.76531009200005, -39.34693775799991],
              [173.7592879570002, -39.30136484199994],
              [173.76441491000014, -39.25546640399995],
              [173.77759850400003, -39.207696221999925],
              [173.8071395190001, -39.163018487999864],
              [173.85271243600005, -39.13445403399987],
              [173.95573978000004, -39.09840260199991],
              [174.21159915500016, -38.97332122199987],
              [174.23357181100005, -38.96819426899992],
              [174.36670983200008, -38.97568124799983],
              [174.4150496750002, -38.96306731599992],
              [174.4589949880002, -38.9372697899999],
              [174.57886803500014, -38.83945077899995],
              [174.59400475400014, -38.81861744599985],
              [174.60222415500016, -38.78199635199985],
              [174.61150149800005, -38.758396091999884],
              [174.613617384, -38.74529387799993],
              [174.61353600400003, -38.71453215899993],
              [174.6176050140001, -38.70737070099989],
              [174.61947675900012, -38.704034112999864],
              [174.6347762380001, -38.700616143999866],
              [174.62818444100014, -38.6828752579998],
              [174.63111412900003, -38.6677385399999],
              [174.63746178500014, -38.652927341999884],
              [174.64087975400003, -38.63543059699987],
              [174.6435653000001, -38.462823174999926],
              [174.65186608200008, -38.42546965899993],
              [174.6870223320002, -38.362237237999864],
              [174.6997176440001, -38.32708098799992],
              [174.70736738400012, -38.28850676899992],
              [174.7124129570002, -38.22966887799987],
              [174.72234134200005, -38.194024346999925],
              [174.723480665, -38.17302825299987],
              [174.71851647200015, -38.15504322699991],
              [174.71013431100016, -38.13689544099992],
              [174.7050887380002, -38.119724216999884],
              [174.70980879000012, -38.104750257999854],
              [174.7255965500001, -38.11150481599992],
              [174.74431399800017, -38.11288827899989],
              [174.76295006600003, -38.110039971999925],
              [174.77881920700008, -38.104750257999854],
              [174.78012129, -38.11598072699985],
              [174.78532962300017, -38.12558359199994],
              [174.79224694100014, -38.13323333099987],
              [174.79859459700003, -38.13892994599985],
              [174.80486087300005, -38.13892994599985],
              [174.80486087300005, -38.12468840899993],
              [174.82016035200002, -38.133721612999864],
              [174.8325301440001, -38.146661065999865],
              [174.8466903000001, -38.15374114399992],
              [174.86687259200016, -38.14568450299981],
              [174.8593856130002, -38.14137135199991],
              [174.83904056100027, -38.12468840899993],
              [174.86540774800028, -38.11687590899987],
              [174.89633222700002, -38.12004973799992],
              [174.92448978000004, -38.11842213299991],
              [174.94263756600003, -38.09734465899987],
              [174.9238387380002, -38.09726327899989],
              [174.9160262380002, -38.09929778399993],
              [174.90845787900003, -38.104750257999854],
              [174.90113366000003, -38.09734465899987],
              [174.90398196700005, -38.077569268999866],
              [174.88396243600005, -38.06267669099992],
              [174.8559676440001, -38.05575937299989],
              [174.83578535200002, -38.06015390399989],
              [174.82837975400025, -38.071547132999854],
              [174.82447350400003, -38.081475518999866],
              [174.8178817070002, -38.08847421699994],
              [174.8017684250001, -38.09107838299991],
              [174.7920028000001, -38.08473072699991],
              [174.79078209700003, -38.070245049999926],
              [174.79411868600005, -38.054131768999866],
              [174.79859459700003, -38.043226820999905],
              [174.8076278000001, -38.03281015399983],
              [174.81625410200013, -38.02939218499989],
              [174.8261824880002, -38.02809010199991],
              [174.83904056100027, -38.02353280999995],
              [174.87037194100003, -37.99553801899992],
              [174.88689212300005, -37.98626067499987],
              [174.88803144600024, -37.96689218499995],
              [174.87614993600005, -37.94980234199994],
              [174.85328209700003, -37.947849216999884],
              [174.836761915, -37.96502044099992],
              [174.8281356130001, -37.98853932099985],
              [174.81568444100014, -38.00115325299993],
              [174.7880965500002, -37.98528411299992],
              [174.78443444100014, -37.96689218499995],
              [174.79184004000012, -37.87200286299992],
              [174.8188582690002, -37.824883721999925],
              [174.8662215500001, -37.81113046699994],
              [174.9228621750001, -37.81072356599992],
              [174.97681725400014, -37.80380624799983],
              [174.972992384, -37.795179945999905],
              [174.9668074880001, -37.788995049999926],
              [174.95875084700003, -37.7849260399999],
              [174.94890384200016, -37.78329843499995],
              [174.96273847700013, -37.77499765399989],
              [174.973480665, -37.763604424999926],
              [174.9770613940001, -37.74993254999987],
              [174.96998131600014, -37.73479583099987],
              [174.92839603000016, -37.75530364399992],
              [174.92359459700015, -37.75986093499989],
              [174.91976972700002, -37.77117278399987],
              [174.91480553500003, -37.77581145599987],
              [174.91081790500027, -37.77483489399992],
              [174.90495853000016, -37.771661065999865],
              [174.8979598320002, -37.76970794099992],
              [174.86744225400003, -37.78085702899995],
              [174.85035241000003, -37.76490650799991],
              [174.78638756600003, -37.568536065999865],
              [174.7285262380002, -37.45777760199991],
              [174.7177840500001, -37.4118791649999],
              [174.71794681100016, -37.40113697699991],
              [174.726898634, -37.38909270599987],
              [174.7382918630002, -37.38355885199985],
              [174.7675887380003, -37.377618096999925],
              [174.77881920700008, -37.371758721999925],
              [174.78972415500016, -37.35295989399992],
              [174.79851321700005, -37.33017343499995],
              [174.81169681100005, -37.310804945999905],
              [174.83578535200002, -37.30282968499995],
              [174.8379012380001, -37.29900481599992],
              [174.8330184250001, -37.291680596999925],
              [174.82260175900012, -37.28769296699994],
              [174.80884850400003, -37.293226820999905],
              [174.79908287900014, -37.299899997999944],
              [174.77955162900025, -37.30982838299991],
              [174.77133222700002, -37.31650155999989],
              [174.7426863940001, -37.357354424999926],
              [174.7285262380002, -37.36296965899993],
              [174.706390821, -37.34783294099992],
              [174.69166100400014, -37.32935963299991],
              [174.65121504000012, -37.25261809699987],
              [174.64087975400003, -37.22087981599992],
              [174.61744225400014, -37.18499114399992],
              [174.613617384, -37.17620208099993],
              [174.60767662900003, -37.154880466999884],
              [174.56527754, -37.09050872199987],
              [174.55827884200016, -37.062758070999905],
              [174.5747176440002, -37.06145598799992],
              [174.60279381600026, -37.06682708099987],
              [174.64275149800005, -37.05706145599993],
              [174.65739993600005, -37.061130466999884],
              [174.667328321, -37.06951262799993],
              [174.66521243600005, -37.080010674999926],
              [174.655609571, -37.09091562299989],
              [174.65398196700016, -37.09685637799993],
              [174.70427493600005, -37.176039320999905],
              [174.70826256600003, -37.20826588299991],
              [174.7226668630001, -37.23333098799992],
              [174.74000084700003, -37.244398695999905],
              [174.75074303500014, -37.22087981599992],
              [174.73845462300017, -37.1950822899999],
              [174.7358504570002, -37.1794572899999],
              [174.74732506600003, -37.172539971999925],
              [174.77702884200016, -37.177015882999854],
              [174.7900496750001, -37.17587655999995],
              [174.80486087300005, -37.16627369599985],
              [174.78484134200016, -37.16692473799992],
              [174.73454837300005, -37.15935637799993],
              [174.71664472700002, -37.152601820999905],
              [174.73161868600005, -37.146742445999905],
              [174.78589928500003, -37.10865650799991],
              [174.79273522200015, -37.11101653399993],
              [174.79184004000012, -37.132745049999926],
              [174.83326256600014, -37.092705987999864],
              [174.8559676440001, -37.07830169099992],
              [174.88054446700028, -37.076348565999865],
              [174.91863040500004, -37.11174895599987],
              [174.93181399800017, -37.11785247199987],
              [174.9458113940001, -37.1130510399999],
              [174.94841556100005, -37.10173919099981],
              [174.94361412900014, -37.088067315999865],
              [174.93523196700005, -37.076348565999865],
              [174.93702233200008, -37.065524997999944],
              [174.88599694100003, -37.049086195999905],
              [174.86687259200016, -37.03590260199991],
              [174.85132897200015, -37.040459893999866],
              [174.84197024800017, -37.02760182099985],
              [174.83497155000032, -37.00847747199987],
              [174.82593834700015, -36.99374765399989],
              [174.8003035820002, -37.01832447699991],
              [174.78581790500004, -37.00847747199987],
              [174.78386478000016, -36.986260674999926],
              [174.795258009, -36.97380950299981],
              [174.80681399800005, -36.97112395599993],
              [174.81902103000004, -36.96379973799992],
              [174.82878665500004, -36.953789971999925],
              [174.83277428500014, -36.942803643999866],
              [174.76832116000003, -36.933526299999926],
              [174.70069420700008, -36.93629322699991],
              [174.667328321, -36.94410572699985],
              [174.64087975400003, -36.960219007999854],
              [174.63233483200008, -36.97258879999987],
              [174.62614993600005, -36.99675872199987],
              [174.6211043630003, -37.007989190999865],
              [174.61150149800005, -37.01832447699991],
              [174.60328209700003, -37.01873137799993],
              [174.5796004570003, -37.00115325299987],
              [174.56560306100005, -37.01873137799993],
              [174.54411868600005, -37.03411223799992],
              [174.5205184250002, -37.04070403399993],
              [174.500336134, -37.03215911299992],
              [174.48894290500016, -37.014580987999864],
              [174.44841556100027, -36.90048593499995],
              [174.42644290500004, -36.80632903399993],
              [174.40756269600024, -36.761488539999846],
              [174.35572350400003, -36.685316664999846],
              [174.21794681100005, -36.54509856599992],
              [174.1884871750001, -36.499118747999944],
              [174.18230228000004, -36.45322030999995],
              [174.18506920700008, -36.44166432099985],
              [174.18921959700026, -36.432712497999944],
              [174.19695071700028, -36.42701588299991],
              [174.20972741000003, -36.42587655999989],
              [174.1987410820002, -36.453057549999926],
              [174.19752037900003, -36.466729424999926],
              [174.20281009200005, -36.48105234199994],
              [174.21900475400014, -36.45435963299991],
              [174.22868899800005, -36.44378020599993],
              [174.2431746750002, -36.43954843499995],
              [174.257172071, -36.44695403399993],
              [174.27214603000004, -36.47975025799991],
              [174.29216556100005, -36.49488697699991],
              [174.314789259, -36.52800872199987],
              [174.3291121750001, -36.535739841999884],
              [174.34587649800017, -36.53948333099993],
              [174.35564212300017, -36.54876067499987],
              [174.35466556100005, -36.559991143999866],
              [174.33936608200008, -36.56975676899992],
              [174.379730665, -36.58196379999987],
              [174.39047285200002, -36.58342864399992],
              [174.3916121750001, -36.5857072899999],
              [174.38160241000003, -36.59091562299989],
              [174.36670983200008, -36.595635674999926],
              [174.3530379570002, -36.597100518999866],
              [174.36247806100005, -36.60320403399987],
              [174.36638431100005, -36.611260674999926],
              [174.3652449880001, -36.62078215899987],
              [174.3598738940001, -36.63128020599987],
              [174.37183678500003, -36.6320940079998],
              [174.38119550900024, -36.63469817499987],
              [174.4013778000001, -36.645603122999944],
              [174.4008895190001, -36.63860442499987],
              [174.4018660820002, -36.62444426899992],
              [174.4013778000001, -36.61760833099993],
              [174.41130618600005, -36.631524346999925],
              [174.42139733200008, -36.65439218499989],
              [174.43140709700003, -36.66562265399983],
              [174.441742384, -36.645603122999944],
              [174.45240319100003, -36.64641692499987],
              [174.45655358200008, -36.63518645599987],
              [174.4585067070002, -36.61882903399993],
              [174.4629012380001, -36.60393645599987],
              [174.46941165500004, -36.59726327899995],
              [174.48536217500032, -36.58611419099992],
              [174.4907332690001, -36.57659270599993],
              [174.4751082690001, -36.581149997999944],
              [174.4697371750002, -36.58342864399992],
              [174.46111087300017, -36.563897393999866],
              [174.47055097700002, -36.519219658999816],
              [174.4629012380001, -36.507745049999926],
              [174.453949415, -36.52271900799991],
              [174.44988040500016, -36.51531340899993],
              [174.4497176440001, -36.463148695999905],
              [174.4492293630001, -36.45989348799992],
              [174.45297285200002, -36.45476653399993],
              [174.4697371750002, -36.43954843499995],
              [174.4619246750002, -36.428643487999864],
              [174.44988040500016, -36.4177385399999],
              [174.4414168630001, -36.406508070999905],
              [174.44556725400003, -36.39511484199994],
              [174.46762129, -36.37900155999995],
              [174.46599368600016, -36.373223565999865],
              [174.4345809250001, -36.35735442499987],
              [174.42790774800017, -36.35784270599993],
              [174.41130618600005, -36.37493254999987],
              [174.3989363940001, -36.38445403399987],
              [174.389984571, -36.38892994599985],
              [174.33122806100005, -36.392510674999926],
              [174.29957116000003, -36.38665129999987],
              [174.27759850400014, -36.369724216999884],
              [174.2710067070002, -36.3376604149999],
              [174.28467858200008, -36.343926690999865],
              [174.292328321, -36.32000090899993],
              [174.3032332690001, -36.317640882999854],
              [174.3169051440001, -36.32512786299992],
              [174.3325301440002, -36.33025481599992],
              [174.3750106130001, -36.32781340899987],
              [174.39519290500004, -36.32268645599987],
              [174.41130618600005, -36.31316497199987],
              [174.4272567070002, -36.30006275799991],
              [174.4399520190001, -36.293226820999905],
              [174.4697371750002, -36.28240325299993],
              [174.49691816500012, -36.26189544099992],
              [174.5068465500001, -36.25839609199994],
              [174.51531009200016, -36.257989190999865],
              [174.5214949880001, -36.25448984199994],
              [174.5249129570002, -36.2414690079998],
              [174.51905358200008, -36.23691171699994],
              [174.5166121750001, -36.23601653399993],
              [174.51490319100014, -36.234307549999926],
              [174.51124108200008, -36.227797132999854],
              [174.50066165500004, -36.23674895599987],
              [174.487640821, -36.24293385199985],
              [174.4736434250001, -36.24651458099993],
              [174.4697371750002, -36.24684010199991],
              [174.45948326900032, -36.24765390399995],
              [174.4497176440001, -36.25156015399995],
              [174.42603600400003, -36.269789320999905],
              [174.4150496750002, -36.275567315999865],
              [174.4072371750001, -36.263929945999905],
              [174.39087975400014, -36.27263762799987],
              [174.37126712300017, -36.28785572699985],
              [174.3530379570002, -36.29607512799993],
              [174.32781009200016, -36.29216887799993],
              [174.3134871750001, -36.28777434699987],
              [174.30518639400032, -36.28240325299993],
              [174.300140821, -36.26458098799992],
              [174.31006920700008, -36.26051197699985],
              [174.33936608200008, -36.268161716999884],
              [174.35613040500004, -36.28085702899995],
              [174.36353600400003, -36.281914971999925],
              [174.36890709700015, -36.25652434699981],
              [174.3842879570003, -36.224379164999846],
              [174.40756269600024, -36.199883721999925],
              [174.41374759200005, -36.18889739399992],
              [174.41570071700005, -36.18173593499989],
              [174.41684004000012, -36.17302825299993],
              [174.42139733200008, -36.15829843499995],
              [174.4379988940002, -36.16480885199991],
              [174.45045006600014, -36.16326262799987],
              [174.453461134, -36.15422942499987],
              [174.441742384, -36.13836028399993],
              [174.43181399800005, -36.132989190999865],
              [174.39389082100013, -36.12420012799993],
              [174.39877363400012, -36.15488046699994],
              [174.38550866000003, -36.18873463299991],
              [174.36117597700013, -36.21624114399992],
              [174.3325301440002, -36.227797132999854],
              [174.34791100400003, -36.211195570999905],
              [174.3530379570002, -36.207289320999905],
              [174.3418074880001, -36.20403411299992],
              [174.33073978000004, -36.20566171699994],
              [174.3222762380002, -36.205254815999865],
              [174.3188582690001, -36.19646575299987],
              [174.31617272200003, -36.180759372999944],
              [174.30974368600027, -36.17782968499989],
              [174.30111738400012, -36.179945570999905],
              [174.29216556100005, -36.17937590899993],
              [174.2812606130002, -36.176039320999905],
              [174.27491295700008, -36.17636484199994],
              [174.271820509, -36.172946872999944],
              [174.2710067070002, -36.15886809699981],
              [174.27214603000004, -36.147719007999854],
              [174.27564537900014, -36.13738372199987],
              [174.28467858200008, -36.11793385199985],
              [174.26880944100003, -36.11874765399995],
              [174.25798587300017, -36.12517669099981],
              [174.23698978000016, -36.14519622199987],
              [174.24122155000032, -36.117445570999905],
              [174.22608483200008, -36.11687590899993],
              [174.18230228000004, -36.14519622199987],
              [174.19288170700008, -36.153415622999944],
              [174.19288170700008, -36.175062757999854],
              [174.20630944100014, -36.17937590899993],
              [174.22437584700015, -36.1794572899999],
              [174.23707116000014, -36.18124765399989],
              [174.24691816500012, -36.18718840899993],
              [174.25733483200008, -36.199883721999925],
              [174.25114993600005, -36.21412525799991],
              [174.25114993600005, -36.22372812299989],
              [174.26050866000014, -36.227797132999854],
              [174.26791425900012, -36.22576262799993],
              [174.2729598320002, -36.220961195999905],
              [174.28101647200015, -36.21054452899995],
              [174.29021243600005, -36.21062590899993],
              [174.30111738400012, -36.21941497199987],
              [174.3188582690001, -36.2414690079998],
              [174.28288821700005, -36.249281507999854],
              [174.27719160200002, -36.251397393999866],
              [174.27491295700008, -36.261000257999854],
              [174.26905358200008, -36.266289971999925],
              [174.26059004000012, -36.26824309699987],
              [174.25066165500004, -36.268161716999884],
              [174.2426863940002, -36.26458098799992],
              [174.22966556100016, -36.25074635199991],
              [174.21989993600005, -36.24765390399995],
              [174.20883222700002, -36.24635182099985],
              [174.20240319100003, -36.242771091999884],
              [174.17847741000026, -36.21412525799991],
              [174.16960696700005, -36.199476820999905],
              [174.158539259, -36.18523528399987],
              [174.14136803500003, -36.172539971999925],
              [174.12289472700002, -36.169366143999866],
              [174.0752059250001, -36.16806405999995],
              [174.06560306100027, -36.16204192499987],
              [174.05933678500014, -36.15260182099985],
              [174.0444442070002, -36.13990650799991],
              [174.02711022200015, -36.12900155999989],
              [174.01384524800017, -36.12420012799993],
              [173.9980574880001, -36.11638762799993],
              [173.9912215500002, -36.09807708099987],
              [173.99040774800005, -36.059258721999925],
              [173.98406009200005, -36.04412200299993],
              [173.95533287900003, -36.01970794099992],
              [173.9438582690001, -35.98984140399989],
              [173.93148847700013, -35.97812265399995],
              [173.90056399800005, -35.959649346999925],
              [173.93726647200015, -35.931898695999905],
              [173.9467879570002, -35.916436455999815],
              [173.94214928500003, -35.89137135199991],
              [173.93637129000012, -35.884698174999926],
              [173.9257918630001, -35.875909112999864],
              [173.914886915, -35.869724216999884],
              [173.90796959700003, -35.87029387799987],
              [173.90593509200016, -35.883477471999925],
              [173.91325931100016, -35.893161716999884],
              [173.92310631600003, -35.900160414999846],
              [173.92847741000014, -35.90504322699991],
              [173.92237389400032, -35.92685312299989],
              [173.88428795700008, -35.94353606599992],
              [173.88013756600014, -35.959649346999925],
              [173.93148847700013, -36.01816171699994],
              [173.938324415, -36.02849700299987],
              [173.95915774800005, -36.03875090899987],
              [173.9677840500001, -36.06218840899987],
              [173.9721785820002, -36.08855559699987],
              [173.9799910820002, -36.10711028399987],
              [173.98707116000003, -36.11581796699994],
              [173.99952233200008, -36.13795338299991],
              [174.00733483200008, -36.148614190999865],
              [174.01677493600027, -36.15422942499987],
              [174.02955162900003, -36.15886809699981],
              [174.04086347700002, -36.16529713299991],
              [174.04957116000014, -36.184665622999944],
              [174.05844160200002, -36.19158294099992],
              [174.06861412900003, -36.19768645599993],
              [174.0761824880003, -36.20354583099993],
              [174.13111412900014, -36.27190520599993],
              [174.14372806100005, -36.27792734199994],
              [174.15894616000003, -36.27613697699985],
              [174.1733504570002, -36.276625257999854],
              [174.18230228000004, -36.28923919099992],
              [174.16187584700003, -36.29680754999987],
              [174.17156009200005, -36.308851820999905],
              [174.191742384, -36.32577890399995],
              [174.20281009200005, -36.347588799999926],
              [174.194672071, -36.368584893999866],
              [174.1748153000001, -36.38209400799991],
              [174.128265821, -36.39853280999995],
              [174.07984459700003, -36.39950937299989],
              [174.05591881600003, -36.36451588299991],
              [174.02409915500027, -36.268161716999884],
              [173.89421634200005, -36.12420012799993],
              [173.85824629, -36.06560637799987],
              [173.63274173250022, -35.81841399549984],
              [173.4072371750001, -35.57122161299981],
              [173.4008895190001, -35.5525041649999],
              [173.4082137380001, -35.536390882999854],
              [173.44117272200015, -35.500258070999905],
              [173.4487410820002, -35.48357512799987],
              [173.45085696700016, -35.46103280999989],
              [173.457855665, -35.43792083099993],
              [173.4707137380001, -35.424899997999944],
              [173.4902449880003, -35.432712497999944],
              [173.49586022200003, -35.42278411299992],
              [173.4970809250001, -35.41838958099993],
              [173.50709069100014, -35.42734140399989],
              [173.516449415, -35.43865325299987],
              [173.52719160200002, -35.44841887799993],
              [173.5415145190002, -35.45256926899992],
              [173.54371178500026, -35.445489190999865],
              [173.54184004, -35.41073984199994],
              [173.5449324880001, -35.39788176899992],
              [173.57211347700013, -35.432712497999944],
              [173.57781009200005, -35.41562265399989],
              [173.57846113400012, -35.395928643999866],
              [173.58277428500003, -35.37712981599992],
              [173.6001082690002, -35.363213799999926],
              [173.60954837300005, -35.36288827899989],
              [173.6152449880002, -35.36777109199994],
              [173.621429884, -35.37021249799989],
              [173.634125196, -35.363213799999926],
              [173.6381942070002, -35.356540622999944],
              [173.6445418630003, -35.33562590899993],
              [173.66089928500014, -35.31292083099987],
              [173.62427819100003, -35.32195403399987],
              [173.61304772200015, -35.31910572699991],
              [173.6132918630002, -35.30730559699987],
              [173.61215254000012, -35.29989999799989],
              [173.6074324880001, -35.29599374799989],
              [173.59636478000004, -35.294854424999926],
              [173.5927840500002, -35.30022551899992],
              [173.59262129000024, -35.336521091999884],
              [173.5815535820002, -35.321547132999854],
              [173.56527754, -35.274509372999944],
              [173.547699415, -35.28948333099987],
              [173.55193118600005, -35.30787525799991],
              [173.5644637380002, -35.32659270599993],
              [173.57211347700013, -35.342705987999864],
              [173.5664168630002, -35.36052825299993],
              [173.55030358200008, -35.36931731599992],
              [173.5307723320002, -35.36907317499987],
              [173.50513756600014, -35.355401299999926],
              [173.4951278000002, -35.354424737999864],
              [173.48959394600013, -35.358086846999925],
              [173.4990340500001, -35.377699476999794],
              [173.4926863940002, -35.38250090899987],
              [173.48161868600016, -35.384698174999926],
              [173.47291100400003, -35.387790622999944],
              [173.46363366000014, -35.39226653399993],
              [173.4570418630001, -35.38884856599992],
              [173.4453231130001, -35.373711846999925],
              [173.43775475400014, -35.37346770599993],
              [173.42652428500003, -35.37851327899989],
              [173.40699303500014, -35.39120859199994],
              [173.41578209700026, -35.405368747999944],
              [173.4091903000001, -35.412041924999926],
              [173.39665774800005, -35.416680596999925],
              [173.3872176440002, -35.425225518999866],
              [173.38697350400003, -35.43108489399992],
              [173.38941491000026, -35.436211846999925],
              [173.39234459700015, -35.439222914999846],
              [173.3940535820002, -35.43889739399992],
              [173.3906356130001, -35.51311614399992],
              [173.3872176440002, -35.521416924999926],
              [173.37810306100005, -35.52304452899995],
              [173.36996504, -35.51653411299992],
              [173.2841903000001, -35.41838958099993],
              [173.27214603000004, -35.39137135199991],
              [173.2773543630001, -35.37468840899987],
              [173.3115340500001, -35.342705987999864],
              [173.3046981130002, -35.34303150799991],
              [173.2910262380001, -35.34221770599987],
              [173.2841903000001, -35.342705987999864],
              [173.30404707100013, -35.32390715899993],
              [173.3125106130002, -35.31357187299983],
              [173.3183699880001, -35.30234140399989],
              [173.28785241000003, -35.30632903399987],
              [173.26970462300005, -35.32195403399987],
              [173.25847415500004, -35.34482187299989],
              [173.249359571, -35.37070077899989],
              [173.238617384, -35.363213799999926],
              [173.20728600400003, -35.33342864399992],
              [173.2016707690001, -35.32284921699994],
              [173.20980879, -35.314629815999865],
              [173.2451278000001, -35.29314544099992],
              [173.2568465500002, -35.28134530999995],
              [173.24203535200002, -35.27743905999995],
              [173.2133895190001, -35.291273695999905],
              [173.19483483200008, -35.294854424999926],
              [173.17750084700003, -35.290459893999866],
              [173.16374759200028, -35.280531507999854],
              [173.1401473320002, -35.25457122199987],
              [173.10027103000004, -35.219984632999854],
              [173.09294681100005, -35.2068010399999],
              [173.09522545700008, -35.187269789999846],
              [173.10954837300017, -35.18173593499995],
              [173.12907962300005, -35.18523528399993],
              [173.1469832690001, -35.19304778399993],
              [173.17937259200005, -35.1560197899999],
              [173.19841556100005, -35.10906340899993],
              [173.20199629000024, -35.05779387799993],
              [173.18864993600016, -35.00750090899993],
              [173.1567488940001, -34.94500090899993],
              [173.1435653000002, -34.928399346999925],
              [173.08334394600013, -34.87802499799989],
              [173.0649520190001, -34.85662200299987],
              [173.03394616000014, -34.791273695999905],
              [173.02100670700008, -34.78093840899987],
              [173.00318444100003, -34.77320728999979],
              [172.79932701900032, -34.55095794099992],
              [172.75896243600005, -34.52214934699987],
              [172.67408287900014, -34.47991301899992],
              [172.68433678500014, -34.47185637799993],
              [172.69092858200008, -34.46445077899995],
              [172.70134524800017, -34.44589609199994],
              [172.69947350400014, -34.437758070999905],
              [172.69809004000012, -34.42180754999987],
              [172.70281009200016, -34.41179778399993],
              [172.71900475400003, -34.42131926899992],
              [172.7417098320002, -34.43124765399989],
              [172.8003035820002, -34.4333635399999],
              [172.82545006600003, -34.44589609199994],
              [172.838226759, -34.4348283829998],
              [172.86947675900012, -34.42896900799991],
              [172.89966881600003, -34.41228606599992],
              [173.01335696700005, -34.42058684699987],
              [173.03093509200005, -34.41790129999981],
              [173.0420028000001, -34.410088799999926],
              [173.0522567070002, -34.4001604149999],
              [173.06373131600003, -34.39763762799987],
              [173.07927493600005, -34.41171640399995],
              [173.05046634200016, -34.426853122999944],
              [173.04273522200015, -34.44687265399989],
              [173.04460696700016, -34.500420830999815],
              [173.0420028000001, -34.51376718499989],
              [173.0380965500002, -34.522067966999884],
              [173.02955162900003, -34.52654387799993],
              [173.01351972700002, -34.52776458099987],
              [173.00863691500012, -34.52223072699985],
              [173.00464928500003, -34.510349216999884],
              [172.997406446, -34.49846770599993],
              [172.98316491000014, -34.493584893999866],
              [172.98511803500014, -34.488946221999925],
              [172.98796634200005, -34.47722747199987],
              [172.99000084700003, -34.4724260399999],
              [172.97006269600013, -34.466566664999846],
              [172.96257571700016, -34.468438408999816],
              [172.9550887380002, -34.493584893999866],
              [172.9516707690001, -34.51555754999981],
              [172.9443465500001, -34.52190520599993],
              [172.92790774800005, -34.5134416649999],
              [172.92701256600014, -34.52353280999995],
              [172.92310631600003, -34.53142669099992],
              [172.91667728000004, -34.537286065999865],
              [172.90748131600003, -34.54143645599993],
              [172.917328321, -34.55046965899993],
              [172.94898522200003, -34.56991952899989],
              [172.95183353000016, -34.55877044099992],
              [172.95671634200005, -34.549493096999925],
              [172.96436608200008, -34.543226820999905],
              [172.97575931100016, -34.54143645599993],
              [172.97046959700015, -34.55632903399993],
              [172.96705162900014, -34.56316497199987],
              [172.96208743600016, -34.56991952899989],
              [172.97291100400025, -34.5759416649999],
              [172.98308353000016, -34.57659270599987],
              [172.99146569100026, -34.57195403399993],
              [172.99683678500003, -34.56178150799991],
              [173.002289259, -34.57366301899992],
              [173.00407962300017, -34.586602471999925],
              [173.00367272200015, -34.64421965899993],
              [173.00749759200005, -34.65113697699991],
              [173.01734459700026, -34.64446379999987],
              [173.02857506600003, -34.62102629999987],
              [173.03109785200002, -34.5915666649999],
              [173.02507571700028, -34.56275807099979],
              [173.0097762380003, -34.54143645599993],
              [173.03581790500004, -34.55234140399989],
              [173.0507918630003, -34.601332289999846],
              [173.06072024800017, -34.65984465899993],
              [173.07178795700008, -34.698988539999846],
              [173.10425866000026, -34.72966887799993],
              [173.1455184250002, -34.75969817499981],
              [173.17920983200008, -34.793633721999925],
              [173.18864993600016, -34.83562590899993],
              [173.13998457100013, -34.78785572699991],
              [173.1191512380001, -34.77410247199987],
              [173.1230574880001, -34.809665622999944],
              [173.164886915, -34.84482187299989],
              [173.298187696, -34.909437757999854],
              [173.295258009, -34.920993747999944],
              [173.2739363940002, -34.94231536299992],
              [173.26775149800005, -34.95077890399995],
              [173.26449629, -34.960870049999926],
              [173.26384524800017, -35.00221119599979],
              [173.2666121750002, -35.00774504999987],
              [173.27312259200005, -35.00701262799987],
              [173.2841903000001, -35.00750090899993],
              [173.31714928500014, -35.0153947899999],
              [173.3252059250001, -35.01490650799991],
              [173.3330184250001, -35.006036065999865],
              [173.33619225400003, -34.99423593499989],
              [173.34148196700005, -34.98406340899987],
              [173.35580488400024, -34.97966887799987],
              [173.36850019600013, -34.96721770599987],
              [173.3662215500001, -34.93914153399987],
              [173.352386915, -34.890801690999865],
              [173.3579207690001, -34.86874765399995],
              [173.37671959700015, -34.86191171699994],
              [173.4013778000001, -34.858330987999864],
              [173.4248153000001, -34.84644947699991],
              [173.4316512380001, -34.83310312299989],
              [173.42945397200003, -34.821384372999944],
              [173.4248153000001, -34.811781507999854],
              [173.4248153000001, -34.80527109199994],
              [173.43572024800017, -34.79648202899989],
              [173.44410241000003, -34.79631926899992],
              [173.45053144600013, -34.803317966999884],
              [173.45541425900012, -34.81568775799991],
              [173.45639082100013, -34.82463958099987],
              [173.45492597700002, -34.833754164999846],
              [173.4487410820002, -34.849867445999905],
              [173.4790145190001, -34.83733489399992],
              [173.4902449880003, -34.83562590899993],
              [173.48511803500003, -34.84587981599992],
              [173.48812910200002, -34.85409921699994],
              [173.50318444100003, -34.869805596999925],
              [173.462250196, -34.88396575299993],
              [173.4204207690002, -34.88396575299993],
              [173.41089928500003, -34.887383721999925],
              [173.40406334700003, -34.903415622999944],
              [173.40894616000003, -34.92229583099987],
              [173.41895592500032, -34.94003671699994],
              [173.4282332690002, -34.9528947899999],
              [173.4419051440001, -34.96803150799991],
              [173.45875084700015, -34.98121510199991],
              [173.47828209700003, -34.99041106599992],
              [173.50017337300017, -34.99382903399993],
              [173.54867597700013, -34.989190362999864],
              [173.56788170700008, -34.99456145599993],
              [173.5864363940001, -35.01490650799991],
              [173.59782962300017, -34.99871184699987],
              [173.6001082690002, -34.99382903399993],
              [173.589203321, -34.98259856599992],
              [173.57634524800005, -34.97275155999989],
              [173.56666100400003, -34.96119557099985],
              [173.56527754, -34.94548919099992],
              [173.575043165, -34.92815520599993],
              [173.588226759, -34.927504164999846],
              [173.60189863400012, -34.937758070999905],
              [173.61304772200015, -34.9528947899999],
              [173.6250106130001, -34.94280364399992],
              [173.6386824880002, -34.94133879999987],
              [173.65007571700005, -34.94646575299987],
              [173.6606551440001, -34.96851978999979],
              [173.67497806100027, -34.97332122199987],
              [173.70533287900025, -34.97340260199985],
              [173.70866946700028, -34.97128671699994],
              [173.71111087300017, -34.96648528399993],
              [173.71509850400014, -34.96184661299992],
              [173.7226668630001, -34.95973072699991],
              [173.7324324880001, -34.962009372999944],
              [173.73414147200015, -34.967461846999925],
              [173.73357181100016, -34.974053643999866],
              [173.73601321700016, -34.97966887799987],
              [173.74146569100014, -34.9860979149999],
              [173.74439537900003, -34.993096612999864],
              [173.74830162900014, -34.998630466999884],
              [173.7568465500001, -35.000664971999925],
              [173.7646590500001, -35.00123463299991],
              [173.77125084700003, -35.00286223799992],
              [173.78443444100003, -35.00750090899993],
              [173.7714949880001, -35.01311614399992],
              [173.76547285200002, -35.02214934699987],
              [173.76197350400003, -35.03240325299987],
              [173.75660241000014, -35.041680596999925],
              [173.73414147200015, -35.05559661299992],
              [173.72445722700002, -35.0642229149999],
              [173.7260848320002, -35.07268645599987],
              [173.7602645190002, -35.096937757999854],
              [173.78109785200002, -35.095635674999926],
              [173.78581790500004, -35.091729424999926],
              [173.78386478000004, -35.08513762799987],
              [173.78443444100003, -35.07577890399995],
              [173.80494225400014, -35.041680596999925],
              [173.80583743600016, -35.03557708099993],
              [173.80347741000003, -35.0207658829998],
              [173.80494225400014, -35.01490650799991],
              [173.81202233200008, -35.009698174999926],
              [173.82886803500026, -35.00750090899993],
              [173.84685306100016, -34.999769789999846],
              [173.8618270190001, -34.99895598799992],
              [173.89087975400003, -35.000664971999925],
              [173.8881942070002, -35.006036065999865],
              [173.89673912900003, -35.017754815999865],
              [173.91391035200013, -35.03476327899995],
              [173.95427493600016, -35.05999114399992],
              [173.96998131600014, -35.07586028399993],
              [173.97632897200003, -35.10035572699985],
              [173.99000084700003, -35.11874765399989],
              [174.02165774800017, -35.122816664999846],
              [174.07927493600005, -35.11736419099992],
              [174.10328209700003, -35.12265390399989],
              [174.1279403000002, -35.1364885399999],
              [174.14714603000016, -35.15715911299992],
              [174.15503991000014, -35.18230559699981],
              [174.11345462300005, -35.19304778399993],
              [174.1020613940002, -35.189385674999926],
              [174.09888756600014, -35.18027109199994],
              [174.09791100400014, -35.16912200299993],
              [174.09351647200015, -35.15894947699991],
              [174.08863366000003, -35.160332940999865],
              [174.08033287900014, -35.16545989399981],
              [174.06999759200016, -35.16529713299991],
              [174.05811608200008, -35.15154387799993],
              [174.03386478000016, -35.16253020599987],
              [174.02361087300005, -35.16912200299993],
              [174.03305097700002, -35.17546965899987],
              [174.05201256600014, -35.19939544099992],
              [174.0180770190001, -35.2028947899999],
              [174.014984571, -35.216973565999865],
              [174.03052819100003, -35.227227471999925],
              [174.05201256600014, -35.21982187299989],
              [174.06177819100003, -35.226006768999866],
              [174.07252037900014, -35.22812265399989],
              [174.0835067070002, -35.226006768999866],
              [174.09351647200015, -35.21982187299989],
              [174.10572350400014, -35.23552825299987],
              [174.10368899800017, -35.249118747999944],
              [174.09644616000003, -35.26181405999989],
              [174.09351647200015, -35.274509372999944],
              [174.09986412900003, -35.287041924999926],
              [174.137543165, -35.31910572699991],
              [174.14283287900003, -35.32781340899993],
              [174.14600670700008, -35.34002044099992],
              [174.14820397200026, -35.36687590899987],
              [174.15113366000003, -35.36972421699994],
              [174.15796959700015, -35.35898202899989],
              [174.16480553500014, -35.342868747999944],
              [174.1679793630002, -35.32903411299992],
              [174.18775475400014, -35.338148695999905],
              [174.1982528000001, -35.341566664999846],
              [174.20972741000003, -35.342705987999864],
              [174.20753014400032, -35.33831145599987],
              [174.20460045700008, -35.32732512799993],
              [174.20281009200005, -35.32284921699994],
              [174.2172957690002, -35.322035414999846],
              [174.22575931100005, -35.32708098799981],
              [174.2319442070002, -35.33342864399992],
              [174.24000084700015, -35.336521091999884],
              [174.24919681100005, -35.33220794099992],
              [174.25163821700005, -35.32252369599985],
              [174.24822024800017, -35.31292083099987],
              [174.24000084700015, -35.30868905999995],
              [174.2177840500002, -35.30673593499989],
              [174.18913821700028, -35.3005510399999],
              [174.1645613940001, -35.290134372999944],
              [174.15503991000014, -35.274509372999944],
              [174.16187584700003, -35.28134530999995],
              [174.1757918630002, -35.26978932099985],
              [174.1997176440002, -35.26864999799989],
              [174.25066165500004, -35.274509372999944],
              [174.2456160820003, -35.26441822699991],
              [174.2431746750002, -35.260837497999944],
              [174.25359134200005, -35.25986093499995],
              [174.266937696, -35.26148853999979],
              [174.27711022200003, -35.26441822699991],
              [174.27719160200002, -35.26767343499995],
              [174.28834069100014, -35.262302341999884],
              [174.289886915, -35.258884372999944],
              [174.28972415500004, -35.254082940999865],
              [174.2949324880001, -35.24431731599992],
              [174.3222762380002, -35.22014739399992],
              [174.3530379570002, -35.19939544099992],
              [174.3608504570002, -35.22405364399992],
              [174.35222415500016, -35.244398695999905],
              [174.33871504, -35.26474374799983],
              [174.3325301440002, -35.28801848799992],
              [174.34017988400024, -35.31178150799991],
              [174.35710696700005, -35.32195403399987],
              [174.3789168630002, -35.32390715899993],
              [174.4013778000001, -35.32284921699994],
              [174.4013778000001, -35.32903411299992],
              [174.39177493600016, -35.343194268999866],
              [174.4223738940001, -35.373711846999925],
              [174.40756269600024, -35.38437265399995],
              [174.40162194100014, -35.381117445999905],
              [174.3735457690001, -35.35702890399995],
              [174.34213300900012, -35.33709075299987],
              [174.3325301440002, -35.32903411299992],
              [174.34913170700008, -35.35125090899987],
              [174.3857528000001, -35.41855234199994],
              [174.4082137380001, -35.432712497999944],
              [174.4287215500002, -35.43466562299989],
              [174.4492293630001, -35.43889739399992],
              [174.44841556100027, -35.437432549999926],
              [174.44947350400003, -35.43466562299989],
              [174.45199629, -35.43238697699991],
              [174.4560653000001, -35.432712497999944],
              [174.46013431100005, -35.43613046699994],
              [174.46363366000026, -35.44459400799991],
              [174.4663192070002, -35.44638437299989],
              [174.47478274800028, -35.45378997199987],
              [174.49830162900003, -35.488946221999925],
              [174.50375410200002, -35.501071872999944],
              [174.46436608200008, -35.50562916499979],
              [174.46892337300017, -35.51767343499995],
              [174.52116946700005, -35.5525041649999],
              [174.56950931100005, -35.59433359199994],
              [174.57837975400014, -35.61793385199991],
              [174.56527754, -35.65178801899992],
              [174.55005944100003, -35.64478932099985],
              [174.50513756600026, -35.63876718499995],
              [174.48707116000003, -35.63811614399992],
              [174.4765731130002, -35.643243096999925],
              [174.49317467500032, -35.65471770599987],
              [174.53101647200026, -35.671644789999846],
              [174.525726759, -35.672946872999944],
              [174.51124108200008, -35.67913176899992],
              [174.53687584700003, -35.68401458099987],
              [174.5473738940001, -35.68792083099987],
              [174.551605665, -35.69646575299993],
              [174.54810631600014, -35.7068010399999],
              [174.53931725400003, -35.713962497999944],
              [174.5283309250002, -35.71835702899995],
              [174.51742597700013, -35.72079843499995],
              [174.5761824880001, -35.75025807099985],
              [174.5864363940001, -35.761000257999854],
              [174.58725019600013, -35.773370049999926],
              [174.5805770190001, -35.79729583099987],
              [174.58301842500032, -35.80632903399987],
              [174.606781446, -35.8435197899999],
              [174.57927493600016, -35.84954192499987],
              [174.55884850400003, -35.83904387799993],
              [174.53988691500012, -35.82244231599992],
              [174.51742597700013, -35.81015390399989],
              [174.5244246750001, -35.79143645599993],
              [174.49577884200005, -35.78460051899992],
              [174.49691816500012, -35.76848723799992],
              [174.4819442070003, -35.769463799999926],
              [174.45622806100027, -35.778415622999944],
              [174.441742384, -35.781508070999905],
              [174.43474368600016, -35.77996184699987],
              [174.42448978000016, -35.77068450299993],
              [174.41814212300028, -35.76848723799992],
              [174.41130618600005, -35.77166106599992],
              [174.40593509200005, -35.78573984199994],
              [174.4013778000001, -35.78899504999987],
              [174.38550866000003, -35.78948333099987],
              [174.38347415500016, -35.78753020599993],
              [174.3867293630002, -35.779229424999926],
              [174.387054884, -35.761000257999854],
              [174.38396243600016, -35.74684010199985],
              [174.3789168630002, -35.73479583099993],
              [174.37094160200013, -35.72380950299987],
              [174.3598738940001, -35.71331145599993],
              [174.35523522200003, -35.73528411299992],
              [174.36003665500016, -35.78948333099987],
              [174.3564559250002, -35.80632903399987],
              [174.35124759200005, -35.81658294099992],
              [174.34994550900012, -35.82968515399995],
              [174.35271243600016, -35.84197356599992],
              [174.3598738940001, -35.84978606599992],
              [174.37525475400014, -35.85182057099985],
              [174.38404381600014, -35.84343840899987],
              [174.39014733200008, -35.83049895599987],
              [174.39771569100003, -35.819431247999944],
              [174.41586347700002, -35.81682708099993],
              [174.48218834700026, -35.82382577899995],
              [174.50375410200002, -35.830010674999926],
              [174.52027428500026, -35.84742603999979],
              [174.5161238940001, -35.867120049999926],
              [174.4990340500001, -35.886976820999905],
              [174.4765731130002, -35.90504322699991],
              [174.493011915, -35.91936614399992],
              [174.4965926440001, -35.94378020599987],
              [174.49537194100003, -35.969414971999925],
              [174.49691816500012, -35.98756275799991],
              [174.509125196, -36.00009530999995],
              [174.55396569100026, -36.0271135399999],
              [174.5727645190001, -36.035332940999865],
              [174.5849715500002, -36.03720468499995],
              [174.61019941500024, -36.03720468499995],
              [174.6211043630003, -36.04225025799991],
              [174.6308699880002, -36.05510833099993],
              [174.62964928500003, -36.06438567499987],
              [174.6240340500002, -36.07293059699987],
              [174.6211043630003, -36.0837541649999],
              [174.62614993600005, -36.107354424999926],
              [174.6367293630001, -36.11956145599987],
              [174.65154056100027, -36.12916432099985],
              [174.6689559250001, -36.14519622199987],
              [174.72494550900012, -36.21550872199987],
              [174.75700931100005, -36.24488697699991],
              [174.79859459700003, -36.268161716999884],
              [174.82447350400003, -36.27703215899993],
              [174.8252059250001, -36.28264739399992],
              [174.81910241000003, -36.29607512799993],
              [174.819672071, -36.298760674999926],
              [174.82300866000014, -36.30006275799991],
              [174.8252059250001, -36.30185312299989],
              [174.82252037900014, -36.30632903399987],
              [174.81902103000004, -36.30787525799991],
              [174.81568444100014, -36.306817315999865],
              [174.81332441500024, -36.30462004999987],
              [174.8129988940001, -36.302911065999865],
              [174.8076278000001, -36.30624765399989],
              [174.8037215500002, -36.30462004999987],
              [174.8007918630002, -36.30559661299992],
              [174.79859459700003, -36.31658294099992],
              [174.80640709700003, -36.334893487999864],
              [174.82878665500004, -36.34221770599987],
              [174.85661868600016, -36.34531015399995],
              [174.88054446700028, -36.351332289999846],
              [174.85035241000003, -36.35556405999995],
              [174.76783287900003, -36.35198333099993],
              [174.75074303500014, -36.35442473799992],
              [174.753265821, -36.36834075299993],
              [174.76726321700016, -36.409600518999866],
              [174.78337649800005, -36.436211846999925],
              [174.78532962300017, -36.453301690999865],
              [174.78305097700024, -36.471286716999884],
              [174.77881920700008, -36.48723723799992],
              [174.75847415500016, -36.43987395599987],
              [174.7426863940001, -36.42001718499995],
              [174.71664472700002, -36.41155364399992],
              [174.7348738940001, -36.455661716999884],
              [174.73259524800005, -36.47258879999987],
              [174.70980879000012, -36.473565362999864],
              [174.70980879000012, -36.48105234199994],
              [174.719574415, -36.48357512799993],
              [174.72828209700015, -36.48788827899995],
              [174.7363387380002, -36.49358489399992],
              [174.74398847700013, -36.50090911299992],
              [174.7368270190002, -36.51132577899995],
              [174.7158309250002, -36.52190520599987],
              [174.70980879000012, -36.52890390399995],
              [174.70964603000016, -36.54208749799989],
              [174.72055097700013, -36.55974700299993],
              [174.723480665, -36.57317473799992],
              [174.72291100400025, -36.59368254999987],
              [174.72771243600016, -36.59644947699991],
              [174.74057050900012, -36.607354424999926],
              [174.7504988940001, -36.61288827899995],
              [174.76441491000026, -36.61598072699991],
              [174.79184004000012, -36.61760833099993],
              [174.8344832690002, -36.604180596999925],
              [174.84644616000014, -36.60393645599987],
              [174.8569442070002, -36.61093515399995],
              [174.85230553500003, -36.61638762799993],
              [174.80616295700008, -36.63795338299991],
              [174.78158613400012, -36.645603122999944],
              [174.76539147200003, -36.64421965899987],
              [174.723480665, -36.63128020599987],
              [174.74398847700013, -36.648614190999865],
              [174.7592879570002, -36.67327239399992],
              [174.81910241000003, -36.82366301899992],
              [174.7973738940001, -36.818617445999905],
              [174.78443444100014, -36.80925872199987],
              [174.77019290500004, -36.80535247199987],
              [174.74398847700013, -36.81682708099993],
              [174.73560631600014, -36.81178150799991],
              [174.73194420700008, -36.80559661299992],
              [174.73259524800005, -36.798109632999854],
              [174.73715254, -36.78948333099993],
              [174.7177840500001, -36.78590260199991],
              [174.70362389400032, -36.758477471999925],
              [174.68913821700005, -36.758477471999925],
              [174.65357506600014, -36.77304452899995],
              [174.63786868600016, -36.78167083099987],
              [174.6211043630003, -36.796319268999866],
              [174.6211043630003, -36.80315520599987],
              [174.629730665, -36.80396900799991],
              [174.6650496750002, -36.79957447699991],
              [174.6826278000002, -36.80315520599987],
              [174.67335045700008, -36.81047942499981],
              [174.65902754000024, -36.81804778399993],
              [174.6494246750002, -36.8259416649999],
              [174.654633009, -36.83391692499987],
              [174.67058353000004, -36.84172942499987],
              [174.67530358200008, -36.84539153399993],
              [174.67457116000003, -36.85125090899993],
              [174.6757918630001, -36.89381275799991],
              [174.6801863940002, -36.90740325299987],
              [174.69255618600027, -36.913018487999864],
              [174.70069420700008, -36.90789153399993],
              [174.70199629000012, -36.89568450299987],
              [174.7011824880001, -36.881931247999944],
              [174.7031356130002, -36.871351820999905],
              [174.70980879000012, -36.87900155999995],
              [174.7182723320002, -36.86760833099987],
              [174.727386915, -36.858005466999884],
              [174.73812910200002, -36.85035572699985],
              [174.75074303500014, -36.844821872999944],
              [174.76644941500012, -36.84270598799992],
              [174.8129988940001, -36.85100676899992],
              [174.87566165500004, -36.85100676899992],
              [174.8974715500001, -36.86248137799987],
              [174.89421634200005, -36.89267343499995],
              [174.884125196, -36.90471770599987],
              [174.87427819100014, -36.91122812299989],
              [174.8691512380001, -36.92001718499995],
              [174.87378991000003, -36.93914153399993],
              [174.8794051440001, -36.95208098799992],
              [174.8847762380002, -36.95907968499989],
              [174.891449415, -36.95777760199991],
              [174.90113366000003, -36.94654713299991],
              [174.92839603000016, -36.837334893999866],
              [174.93523196700005, -36.837334893999866],
              [174.9570418630002, -36.884535414999846],
              [174.9648543630002, -36.90740325299987],
              [174.96314537900003, -36.933526299999926],
              [174.98585045700008, -36.92864348799992],
              [175.01140384200016, -36.92782968499995],
              [175.0239363940002, -36.92034270599987],
              [175.00757897200003, -36.89592864399992],
              [175.00367272200015, -36.87932708099987],
              [175.02711022200026, -36.87460702899995],
              [175.05884850400014, -36.87761809699987],
              [175.07984459700003, -36.884535414999846],
              [175.0918074880001, -36.90740325299987],
              [175.0805770190002, -36.953057549999926],
              [175.09343509200016, -36.97047291499979],
              [175.1088973320002, -36.97380950299981],
              [175.1211043630001, -36.969821872999944],
              [175.13233483200008, -36.963474216999884],
              [175.14909915500016, -36.95907968499989],
              [175.17261803500014, -36.94589609199994],
              [175.1787215500002, -36.94793059699987],
              [175.18409264400032, -36.95191822699985],
              [175.18897545700008, -36.953383070999905],
              [175.2216903000001, -36.94085051899992],
              [175.23072350400003, -36.93914153399993],
              [175.24097741000003, -36.942315362999864],
              [175.26246178500014, -36.956801039999846],
              [175.2754012380002, -36.960219007999854],
              [175.283539259, -36.96412525799991],
              [175.31902103000016, -36.99960702899995],
              [175.32601972700002, -37.00945403399993],
              [175.3310653000001, -37.0212541649999],
              [175.33375084700003, -37.03590260199991],
              [175.33269290500004, -37.05901458099987],
              [175.32007897200026, -37.128676039999846],
              [175.3247176440002, -37.151625257999854],
              [175.33627363400012, -37.17327239399992],
              [175.35173587300005, -37.19215260199985],
              [175.3671981130001, -37.207207940999865],
              [175.4033309250001, -37.22380950299993],
              [175.44792728000027, -37.224867445999905],
              [175.493500196, -37.21550872199987],
              [175.5322371750001, -37.20037200299987],
              [175.54021243600016, -37.19394296699994],
              [175.5434676440002, -37.18718840899993],
              [175.5488387380003, -37.18206145599993],
              [175.56275475400014, -37.179945570999905],
              [175.57097415500016, -37.18450286299992],
              [175.57398522200015, -37.1950822899999],
              [175.5732528000001, -37.217461846999925],
              [175.5786238940001, -37.23723723799992],
              [175.5918074880002, -37.24920012799987],
              [175.60954837300005, -37.25156015399983],
              [175.6279403000001, -37.241957289999846],
              [175.6123153000001, -37.23845794099992],
              [175.60173587300005, -37.227959893999866],
              [175.5957137380001, -37.213148695999905],
              [175.59148196700016, -37.181410414999846],
              [175.58228600400003, -37.15471770599993],
              [175.5800887380001, -37.142022393999866],
              [175.56275475400014, -37.11191171699994],
              [175.55958092500032, -37.09734465899993],
              [175.56072024800005, -37.04461028399993],
              [175.55591881600014, -37.03215911299992],
              [175.55144290500004, -37.02410247199987],
              [175.5278426440002, -36.96249765399989],
              [175.520843946, -36.95086028399993],
              [175.51124108200008, -36.93914153399993],
              [175.4990340500001, -36.92937590899987],
              [175.47388756600026, -36.914646091999884],
              [175.4633895190002, -36.90553150799991],
              [175.45728600400014, -36.894789320999905],
              [175.4541121750002, -36.88420989399992],
              [175.44890384200005, -36.874118747999944],
              [175.43620853000004, -36.86467864399992],
              [175.45728600400014, -36.85849374799989],
              [175.48129316500012, -36.86199309699987],
              [175.50318444100003, -36.86174895599993],
              [175.517914259, -36.844821872999944],
              [175.485199415, -36.84539153399993],
              [175.46973717500032, -36.84343840899987],
              [175.45590254, -36.837334893999866],
              [175.4682723320002, -36.83359140399995],
              [175.48072350400014, -36.83123137799987],
              [175.4912215500001, -36.82691822699991],
              [175.49756920700008, -36.81682708099993],
              [175.48894290500027, -36.816582940999865],
              [175.48226972700002, -36.81438567499987],
              [175.47641035200013, -36.811455987999864],
              [175.47022545700008, -36.80934010199985],
              [175.5205184250002, -36.79794687299989],
              [175.5371199880001, -36.78606536299992],
              [175.5322371750001, -36.761488539999846],
              [175.51628665500016, -36.770440362999864],
              [175.51124108200008, -36.775323174999926],
              [175.5044051440002, -36.76555754999987],
              [175.49935957100013, -36.755303643999866],
              [175.49878991000014, -36.74504973799992],
              [175.50505618600005, -36.73495859199994],
              [175.4824324880001, -36.70476653399993],
              [175.48951256600003, -36.67815520599993],
              [175.5024520190002, -36.65390390399995],
              [175.49756920700008, -36.63128020599987],
              [175.48910566500024, -36.627862237999864],
              [175.47779381600003, -36.62623463299991],
              [175.4677840500001, -36.62297942499987],
              [175.4633895190002, -36.61419036299992],
              [175.4604598320002, -36.611586195999905],
              [175.4423934250001, -36.59091562299989],
              [175.42457116000014, -36.582940362999864],
              [175.38721764400032, -36.57154713299991],
              [175.3706160820002, -36.559258721999925],
              [175.36207116000003, -36.54599374799989],
              [175.35710696700005, -36.529554945999905],
              [175.35425866000003, -36.49098072699991],
              [175.36247806100016, -36.476820570999905],
              [175.38257897200003, -36.476820570999905],
              [175.4072371750002, -36.48040129999987],
              [175.4404403000002, -36.47470468499989],
              [175.44695071700005, -36.47966887799993],
              [175.4511824880003, -36.487725518999866],
              [175.45728600400014, -36.496758721999925],
              [175.46119225400003, -36.50465260199985],
              [175.4633895190002, -36.507745049999926],
              [175.4672957690001, -36.510837497999944],
              [175.47535241000014, -36.514580987999864],
              [175.49594160200002, -36.53045012799993],
              [175.50611412900014, -36.53150807099985],
              [175.5322371750001, -36.507745049999926],
              [175.55046634200016, -36.526462497999944],
              [175.56202233200008, -36.551690362999864],
              [175.56031334700003, -36.57740650799991],
              [175.538422071, -36.597100518999866],
              [175.55933678500003, -36.61077239399992],
              [175.5820418630002, -36.611097914999846],
              [175.599945509, -36.61581796699994],
              [175.6074324880002, -36.64218515399995],
              [175.61011803500003, -36.66757577899995],
              [175.6074324880002, -36.680596612999864],
              [175.59693444100014, -36.67620208099987],
              [175.58383222700013, -36.6677385399999],
              [175.57406660200013, -36.669854424999926],
              [175.57064863400012, -36.67839934699987],
              [175.5766707690002, -36.68987395599993],
              [175.58814537900014, -36.694024346999925],
              [175.61695397200003, -36.690524997999944],
              [175.6279403000001, -36.693291924999926],
              [175.63445071700005, -36.70452239399992],
              [175.63103274800017, -36.71493905999989],
              [175.62427819100003, -36.72478606599992],
              [175.6211043630001, -36.73495859199994],
              [175.62810306100027, -36.763848565999865],
              [175.64210045700008, -36.766696872999944],
              [175.68246504, -36.74114348799992],
              [175.66814212300005, -36.73601653399993],
              [175.6621199880001, -36.73495859199994],
              [175.66911868600027, -36.72576262799993],
              [175.6816512380002, -36.72234465899987],
              [175.695648634, -36.72421640399995],
              [175.70679772200003, -36.73113372199987],
              [175.71900475400003, -36.73593515399995],
              [175.73365319100003, -36.73015715899987],
              [175.75814863400012, -36.713799737999864],
              [175.7763778000001, -36.70842864399992],
              [175.79070071700005, -36.707614841999884],
              [175.80339603000004, -36.712172132999854],
              [175.81666100400003, -36.72405364399992],
              [175.82781009200016, -36.725681247999944],
              [175.8413192070002, -36.71941497199987],
              [175.85173587300017, -36.71835702899989],
              [175.85377037900025, -36.73495859199994],
              [175.84831790500016, -36.748142184999836],
              [175.83806399800005, -36.75164153399993],
              [175.80974368600016, -36.748630466999884],
              [175.80494225400025, -36.75351327899995],
              [175.7856551440001, -36.78281015399989],
              [175.77263431100005, -36.789727471999925],
              [175.74683678500003, -36.79802825299987],
              [175.7343856130001, -36.80632903399993],
              [175.71843509200005, -36.82390715899987],
              [175.7036238940001, -36.844821872999944],
              [175.71558678500003, -36.85271575299993],
              [175.7148543630002, -36.85995859199994],
              [175.71111087300005, -36.86728280999995],
              [175.71355228000004, -36.87517669099992],
              [175.72478274800005, -36.88420989399992],
              [175.7368270190001, -36.8903947899999],
              [175.74488366000003, -36.88990650799991],
              [175.74390709700015, -36.87900155999995],
              [175.7597762380001, -36.86858489399992],
              [175.7519637380001, -36.83717213299991],
              [175.764984571, -36.82366301899992],
              [175.78695722700013, -36.83294036299992],
              [175.82781009200016, -36.82577890399995],
              [175.85075931100016, -36.84099700299993],
              [175.8545028000002, -36.85198333099987],
              [175.85320071700005, -36.87786223799992],
              [175.85759524800005, -36.888604424999926],
              [175.87322024800005, -36.904961846999925],
              [175.87761478000004, -36.91285572699991],
              [175.8818465500001, -36.92603932099985],
              [175.88795006600003, -36.97380950299981],
              [175.88461347700013, -37.005629164999846],
              [175.88493899800017, -37.01140715899987],
              [175.88689212300005, -37.0212541649999],
              [175.88054446700005, -37.03199635199991],
              [175.87232506600026, -37.04306405999995],
              [175.868011915, -37.05339934699987],
              [175.8730574880001, -37.0603166649999],
              [175.8837996750001, -37.05478280999995],
              [175.89527428500003, -37.04412200299993],
              [175.90162194100003, -37.03590260199991],
              [175.91968834700003, -37.05462004999981],
              [175.91627037900003, -37.07976653399987],
              [175.90162194100003, -37.10613372199987],
              [175.88493899800017, -37.128676039999846],
              [175.8837996750001, -37.137139580999815],
              [175.893890821, -37.140394789999846],
              [175.9072371750001, -37.14226653399993],
              [175.91586347700013, -37.14576588299991],
              [175.919281446, -37.158135674999926],
              [175.91781660200002, -37.18718840899993],
              [175.92269941500012, -37.20037200299987],
              [175.9130965500001, -37.19500090899993],
              [175.90560957100013, -37.18710702899995],
              [175.90007571700016, -37.17717864399992],
              [175.8955184250002, -37.16627369599985],
              [175.88795006600003, -37.16627369599985],
              [175.89242597700013, -37.191338799999926],
              [175.8999129570002, -37.213148695999905],
              [175.90137780000032, -37.230645440999865],
              [175.88795006600003, -37.241957289999846],
              [175.9218856130001, -37.254815362999864],
              [175.9336043630002, -37.26409270599993],
              [175.94312584700003, -37.28240325299987],
              [175.95297285200002, -37.32154713299991],
              [175.95679772200015, -37.361504815999865],
              [175.96111087300005, -37.37737395599993],
              [175.97934004000012, -37.40862395599987],
              [175.98357181100005, -37.423272393999866],
              [175.98658287900014, -37.430352471999925],
              [176.00066165500004, -37.43914153399993],
              [176.00464928500014, -37.447442315999865],
              [176.004242384, -37.46054452899995],
              [175.99927819100003, -37.45867278399987],
              [175.99170983200008, -37.4528947899999],
              [175.98357181100005, -37.45427825299993],
              [175.97543379, -37.46990325299987],
              [175.9848738940001, -37.47649504999987],
              [176.02507571700005, -37.48162200299987],
              [176.04175866000003, -37.487399997999944],
              [176.05974368600027, -37.49635182099985],
              [176.07650800900012, -37.50725676899992],
              [176.09017988400024, -37.518812757999854],
              [176.10043379000012, -37.532159112999864],
              [176.1162215500001, -37.56170012799993],
              [176.12452233200008, -37.57382577899995],
              [176.15308678500003, -37.59531015399995],
              [176.16521243600027, -37.607679945999905],
              [176.16911868600005, -37.624932549999926],
              [176.1333113940001, -37.602634372999944],
              [176.12134850400003, -37.59775155999989],
              [176.1059676440002, -37.596612237999864],
              [176.09099368600005, -37.59856536299992],
              [176.07569420700008, -37.59644947699991],
              [176.05925540500016, -37.58407968499995],
              [176.06950931100016, -37.57952239399992],
              [176.10084069100014, -37.57040780999995],
              [176.06592858200008, -37.55087655999995],
              [176.04916425900024, -37.53850676899992],
              [176.03541100400014, -37.525648695999905],
              [176.01587975400003, -37.51588307099985],
              [175.98991946700016, -37.51482512799987],
              [175.94312584700003, -37.52190520599993],
              [175.9492293630002, -37.52792734199994],
              [175.958343946, -37.538995049999926],
              [175.96306399800005, -37.54306405999995],
              [175.9594832690002, -37.548760674999926],
              [175.9565535820002, -37.55584075299993],
              [175.95525149800005, -37.56324635199991],
              [175.95679772200015, -37.57040780999995],
              [175.9633895190001, -37.57781340899993],
              [175.96941165500016, -37.57887135199985],
              [175.97445722700013, -37.57740650799991],
              [175.97730553500026, -37.577243747999944],
              [175.98259524800017, -37.58049895599987],
              [175.9931746750002, -37.58220794099992],
              [175.99724368600016, -37.58407968499995],
              [175.99903405000032, -37.58953215899993],
              [175.9965926440001, -37.59563567499987],
              [175.99252363400024, -37.60100676899992],
              [175.99097741000003, -37.604424737999864],
              [175.9956160820003, -37.62688567499987],
              [175.99724368600016, -37.63176848799992],
              [176.00228925900012, -37.636488539999846],
              [176.00749759200005, -37.638604424999926],
              [176.02507571700005, -37.639255466999884],
              [176.03296959700003, -37.636976820999905],
              [176.03834069100014, -37.63201262799987],
              [176.04216556100005, -37.627048434999836],
              [176.04566491000003, -37.624932549999926],
              [176.063324415, -37.63201262799987],
              [176.071625196, -37.64413827899995],
              [176.07740319100014, -37.65862395599993],
              [176.08716881600014, -37.67343515399989],
              [176.10271243600016, -37.664727471999925],
              [176.112640821, -37.670586846999925],
              [176.1211043630002, -37.68132903399993],
              [176.1313582690001, -37.68710702899995],
              [176.14568118600005, -37.68181731599992],
              [176.150726759, -37.67148202899995],
              [176.15739993600027, -37.66334400799991],
              [176.17652428500003, -37.665948174999926],
              [176.1899520190001, -37.67278411299992],
              [176.19556725400025, -37.68173593499995],
              [176.19678795700008, -37.694024346999925],
              [176.19646243600005, -37.710870049999926],
              [176.201508009, -37.71990325299993],
              [176.21412194100026, -37.71949635199991],
              [176.22999108200008, -37.71575286299992],
              [176.24488366000003, -37.71428801899992],
              [176.23121178500014, -37.665948174999926],
              [176.20875084700015, -37.63616301899992],
              [176.203461134, -37.62200286299981],
              [176.2168074880002, -37.618259372999944],
              [176.2363387380001, -37.63176848799992],
              [176.27173912900014, -37.682549737999864],
              [176.29607181100016, -37.69394296699994],
              [176.32341556100005, -37.69931405999989],
              [176.3837996750002, -37.72275155999995],
              [176.41277103000004, -37.72812265399995],
              [176.42416425900012, -37.7321916649999],
              [176.4482528000002, -37.751071872999944],
              [176.46062259200016, -37.75530364399992],
              [176.49057050900012, -37.75530364399992],
              [176.49537194100003, -37.75937265399989],
              [176.49976647200003, -37.76580169099992],
              [176.50660241000014, -37.76881275799991],
              [176.5185653000001, -37.76213958099993],
              [176.71827233200008, -37.87769947699991],
              [176.7587996750002, -37.89316171699994],
              [176.82195071700005, -37.90146249799983],
              [176.88217207100013, -37.91985442499987],
              [176.9502059250001, -37.927666924999926],
              [177.0048934250001, -37.95533619599985],
              [177.09791100400003, -37.96526458099993],
              [177.13550866000014, -37.98186614399992],
              [177.07691491000014, -37.98186614399992],
              [177.06592858200008, -37.984551690999865],
              [177.07195071700016, -37.990899346999925],
              [177.1181746750001, -38.01685963299991],
              [177.13103274800017, -38.02166106599992],
              [177.1455184250001, -38.02353280999995],
              [177.15837649800005, -38.01824309699987],
              [177.16081790500004, -38.006117445999905],
              [177.15650475400014, -37.99228280999989],
              [177.14918053500026, -37.98186614399992],
              [177.1660262380001, -37.978448174999926],
              [177.1757918630001, -37.983086846999925],
              [177.1840926440001, -37.99041106599992],
              [177.19703209700003, -37.99553801899992],
              [177.26246178500003, -37.99553801899992],
              [177.26490319100014, -37.99765390399995],
              [177.2758895190002, -38.01262786299981],
              [177.2817488940001, -38.01588307099985],
              [177.28638756600003, -38.01433684699981],
              [177.29078209700015, -38.01091887799987],
              [177.29664147200003, -38.009209893999866],
              [177.30062910200013, -38.00603606599992],
              [177.29997806100005, -37.998955987999864],
              [177.30005944100003, -37.99187590899987],
              [177.30681399800028, -37.98870208099993],
              [177.31804446700005, -37.98796965899987],
              [177.34791100400003, -37.98186614399992],
              [177.4375106130002, -37.97673919099992],
              [177.4614363940001, -37.96477629999987],
              [177.4795028000001, -37.95191822699985],
              [177.55681399800005, -37.913832289999846],
              [177.58741295700008, -37.89316171699994],
              [177.59782962300005, -37.88241952899995],
              [177.60181725400003, -37.873304945999905],
              [177.60173587300017, -37.84783294099992],
              [177.61841881600003, -37.82341887799987],
              [177.6215926440001, -37.81365325299993],
              [177.62761478000004, -37.80754973799992],
              [177.669281446, -37.78948333099993],
              [177.68474368600005, -37.771905205999815],
              [177.69613691500012, -37.735284112999864],
              [177.7075301440002, -37.71770598799992],
              [177.7226668630002, -37.70387135199985],
              [177.72885175900012, -37.69500090899987],
              [177.7314559250001, -37.68328215899993],
              [177.7387801440001, -37.67620208099993],
              [177.8383895190002, -37.653415622999944],
              [177.85865319100014, -37.65227629999987],
              [177.87663821700016, -37.64788176899992],
              [177.88990319100003, -37.63681405999995],
              [177.91358483200008, -37.60784270599987],
              [177.92896569100003, -37.60125090899987],
              [177.97339928500014, -37.5974260399999],
              [177.99203535200013, -37.59091562299989],
              [178.00521894600013, -37.57952239399992],
              [178.008636915, -37.569756768999866],
              [178.0039168630001, -37.55877044099992],
              [177.99203535200013, -37.54306405999995],
              [178.03150475400003, -37.54957447699985],
              [178.277679884, -37.559258721999925],
              [178.30103600400003, -37.56503671699994],
              [178.3134871750001, -37.573337497999944],
              [178.29997806100016, -37.58407968499995],
              [178.29997806100016, -37.59091562299989],
              [178.31218509200005, -37.5954729149999],
              [178.3305770190001, -37.6110979149999],
              [178.34148196700016, -37.618259372999944],
              [178.35808353000004, -37.62322356599992],
              [178.3750106130002, -37.625176690999865],
              [178.4101668630001, -37.624932549999926],
              [178.42253665500004, -37.62810637799987],
              [178.44174238400024, -37.642266533999816],
              [178.45484459700015, -37.645440362999864],
              [178.48560631600014, -37.64495208099987],
              [178.4980574880002, -37.64690520599993],
              [178.51286868600005, -37.65227629999987],
              [178.5288192070002, -37.66236744599985],
              [178.55054772200003, -37.68059661299992],
              [178.56617272200003, -37.70086028399993],
              [178.56430097700002, -37.71770598799992],
              [178.55591881600003, -37.72673919099992],
              [178.53695722700013, -37.751885674999926],
              [178.49927819100003, -37.78329843499995],
              [178.4790145190001, -37.82976653399993],
              [178.465179884, -37.85442473799992],
              [178.4292098320002, -37.874444268999866],
              [178.41480553500003, -37.89641692499987],
              [178.3867293630001, -37.959161065999865],
              [178.37574303500003, -37.97503020599987],
              [178.35914147200003, -37.9919572899999],
              [178.3515731130002, -38.0017229149999],
              [178.34831790500016, -38.01262786299981],
              [178.355804884, -38.036065362999864],
              [178.37061608200008, -38.05689869599985],
              [178.38111412900003, -38.078708591999884],
              [178.37574303500003, -38.104750257999854],
              [178.35954837300017, -38.118096612999864],
              [178.3393660820003, -38.13014088299991],
              [178.32960045700008, -38.14592864399992],
              [178.35466556100027, -38.188083591999884],
              [178.35124759200005, -38.208103122999944],
              [178.3393660820003, -38.22779713299991],
              [178.32406660200013, -38.24504973799992],
              [178.31853274800017, -38.26572030999989],
              [178.332367384, -38.28557708099993],
              [178.35173587300017, -38.302992445999905],
              [178.36207116000014, -38.31650155999995],
              [178.35889733200008, -38.32773202899995],
              [178.3501082690002, -38.33733489399992],
              [178.3339949880002, -38.35125090899993],
              [178.32960045700008, -38.36394622199987],
              [178.3271590500002, -38.38591887799993],
              [178.32048587300005, -38.39902109199994],
              [178.33277428500003, -38.40243905999995],
              [178.34294681100005, -38.40960051899992],
              [178.34888756600014, -38.42017994599979],
              [178.34831790500016, -38.43434010199991],
              [178.3413192070002, -38.442640882999854],
              [178.3037215500002, -38.458265882999854],
              [178.2993270190001, -38.46697356599992],
              [178.30014082100013, -38.53167083099987],
              [178.29460696700005, -38.53980885199991],
              [178.18181399800005, -38.63836028399987],
              [178.07984459700015, -38.70907968499989],
              [178.06226647200003, -38.716485283999816],
              [178.02279707100013, -38.68775807099985],
              [177.99732506600014, -38.68328215899987],
              [177.97217858200008, -38.68840911299992],
              [177.9511824880002, -38.700616143999866],
              [177.9423934250001, -38.70387135199991],
              [177.93620853000004, -38.701755466999884],
              [177.93238366000014, -38.702406507999854],
              [177.93132571700005, -38.71428801899992],
              [177.9316512380001, -38.71949635199991],
              [177.93474368600005, -38.73007577899995],
              [177.936859571, -38.73479583099987],
              [177.95541425900012, -38.750258070999905],
              [177.96404056100027, -38.76140715899993],
              [177.96168053500003, -38.77288176899992],
              [177.94410241000003, -38.797784112999864],
              [177.93775475400014, -38.8200822899999],
              [177.936859571, -38.87265390399995],
              [177.926117384, -38.93124765399989],
              [177.912445509, -38.9607072899999],
              [177.90984134200016, -38.999932549999926],
              [177.902679884, -39.016534112999864],
              [177.91138756600003, -39.03630950299987],
              [177.90333092500032, -39.05087655999989],
              [177.89014733200008, -39.065524997999944],
              [177.8828231130001, -39.08554452899989],
              [177.95191491000003, -39.09140390399995],
              [177.9848738940002, -39.10458749799989],
              [177.99887129, -39.12981536299992],
              [177.9443465500002, -39.17351653399993],
              [177.92066491000003, -39.223890882999854],
              [177.91195722700002, -39.25595468499995],
              [177.89958743600016, -39.26726653399993],
              [177.8837996750001, -39.277276299999926],
              [177.86850019600013, -39.29021575299993],
              [177.841156446, -39.22893645599993],
              [177.83366946700005, -39.19687265399995],
              [177.8344832690001, -39.16741301899992],
              [177.83961022200003, -39.15097421699994],
              [177.84734134200005, -39.134698174999926],
              [177.85621178500003, -39.120212497999944],
              [177.86540774800005, -39.10906340899993],
              [177.8662215500001, -39.09734465899993],
              [177.8520613940001, -39.08928801899992],
              [177.83326256600003, -39.09042734199994],
              [177.82016035200013, -39.10588958099987],
              [177.8095809250001, -39.10198333099987],
              [177.77914472700013, -39.08554452899989],
              [177.76392662900003, -39.08098723799992],
              [177.6059676440001, -39.075290622999944],
              [177.44402103000016, -39.07187265399995],
              [177.4316512380002, -39.06804778399993],
              [177.42261803500003, -39.06129322699991],
              [177.41325931100016, -39.05901458099993],
              [177.38738040500016, -39.077406507999854],
              [177.2021590500001, -39.14812590899993],
              [177.0649520190002, -39.19939544099992],
              [177.05290774800005, -39.21152109199994],
              [177.04867597700013, -39.23357512799993],
              [177.0380965500001, -39.25554778399993],
              [177.02458743600005, -39.2751604149999],
              [177.00025475400003, -39.30087655999995],
              [176.96420332100013, -39.33123137799993],
              [176.9409285820002, -39.345472914999846],
              [176.9375106130001, -39.34872812299989],
              [176.92644290500004, -39.37623463299991],
              [176.91391035200002, -39.388929945999905],
              [176.90691165500016, -39.400323174999926],
              [176.90357506600003, -39.41334400799991],
              [176.9028426440002, -39.43084075299987],
              [176.9062606130001, -39.447523695999905],
              [176.91488691500012, -39.45647551899992],
              [176.926117384, -39.463555596999925],
              [176.9375106130001, -39.47470468499995],
              [176.944672071, -39.49504973799992],
              [176.950531446, -39.588148695999905],
              [176.9537118373879, -39.60751275685698],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'New Caledonia',
        iso3: 'NCL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [163.98511803500003, -20.047621351999908],
              [163.98609459700003, -20.05754973799992],
              [163.9853621750001, -20.066664320999905],
              [163.9829207690001, -20.075290622999944],
              [163.97820071700005, -20.083103122999944],
              [163.97136478000004, -20.06878020599993],
              [163.956390821, -20.073663018999923],
              [163.94711347700002, -20.066013278999947],
              [163.93726647200003, -20.04159921699994],
              [163.93726647200003, -20.033949476999908],
              [163.94410241000003, -20.02597421699994],
              [163.9497176440001, -20.002211195999905],
              [163.95769290500004, -19.999932549999926],
              [163.967133009, -20.008070570999905],
              [163.9751082690001, -20.035414320999905],
              [163.98511803500003, -20.047621351999908],
            ],
          ],
          [
            [
              [167.52100670700008, -22.56959400799991],
              [167.53150475400003, -22.587090752999927],
              [167.54468834700003, -22.59823984199994],
              [167.5546981130001, -22.61223723799992],
              [167.5551863940001, -22.63844166499996],
              [167.5429793630001, -22.63014088299991],
              [167.53093509200005, -22.60556405999995],
              [167.52100670700008, -22.603692315999922],
              [167.5161238940001, -22.611260674999926],
              [167.5166121750001, -22.624118747999944],
              [167.52100670700008, -22.648695570999905],
              [167.50733483200008, -22.670668226999908],
              [167.47584069100003, -22.667087497999944],
              [167.41871178500003, -22.645277601999908],
              [167.42400149800005, -22.620293877999927],
              [167.42448978000004, -22.561700127999927],
              [167.43230228000004, -22.54225025799991],
              [167.4502059250001, -22.53801848799992],
              [167.476898634, -22.54338958099993],
              [167.50342858200008, -22.554945570999905],
              [167.52100670700008, -22.56959400799991],
            ],
          ],
          [
            [
              [166.8017684250001, -22.39885833099993],
              [166.814789259, -22.39511484199994],
              [166.82545006600003, -22.395684502999927],
              [166.834320509, -22.401462497999944],
              [166.84327233200008, -22.41253020599993],
              [166.84343509200005, -22.42441171699994],
              [166.84058678500003, -22.431247653999947],
              [166.83570397200003, -22.43206145599993],
              [166.828949415, -22.42555103999996],
              [166.8212996750001, -22.43141041499996],
              [166.815765821, -22.43482838299991],
              [166.8017684250001, -22.43987395599993],
              [166.8017684250001, -22.445977471999925],
              [166.82097415500004, -22.448825778999947],
              [166.8188582690001, -22.455824476999908],
              [166.80811608200008, -22.462334893999923],
              [166.8017684250001, -22.463067315999922],
              [166.79444420700008, -22.460544528999947],
              [166.7802840500001, -22.45761484199994],
              [166.77076256600003, -22.450616143999923],
              [166.777679884, -22.43645598799992],
              [166.7851668630001, -22.42473723799992],
              [166.78638756600003, -22.415134372999944],
              [166.789398634, -22.40667083099993],
              [166.8017684250001, -22.39885833099993],
            ],
          ],
          [
            [
              [168.13746178500003, -21.431817315999922],
              [168.14421634200005, -21.452732028999947],
              [168.14372806100005, -21.48870208099993],
              [168.13648522200003, -21.527276299999926],
              [168.12378991000003, -21.555352471999925],
              [168.12907962300005, -21.60133228999996],
              [168.12680097700002, -21.622247002999927],
              [168.114105665, -21.631036065999922],
              [168.101898634, -21.632989190999922],
              [168.06421959700003, -21.64299895599993],
              [168.03541100400003, -21.658461195999905],
              [167.99293053500003, -21.654961846999925],
              [167.95818118600005, -21.63844166499996],
              [167.9599715500001, -21.61060963299991],
              [167.93897545700008, -21.60165780999995],
              [167.9126082690001, -21.595635674999926],
              [167.8857528000001, -21.59539153399993],
              [167.863617384, -21.603692315999922],
              [167.86117597700002, -21.600681247999944],
              [167.85922285200002, -21.59734465899993],
              [167.857758009, -21.59384530999995],
              [167.856781446, -21.58953215899993],
              [167.86744225400003, -21.582777601999908],
              [167.8798934250001, -21.57268645599993],
              [167.88949629, -21.55901458099993],
              [167.8916121750001, -21.541680596999925],
              [167.88640384200005, -21.533461195999905],
              [167.86394290500004, -21.51067473799992],
              [167.856781446, -21.500746351999908],
              [167.85084069100003, -21.48284270599993],
              [167.84791100400003, -21.456231377999927],
              [167.84392337300005, -21.43922291499996],
              [167.83611087300005, -21.422621351999908],
              [167.80844160200002, -21.383965752999927],
              [167.82300866000003, -21.37704843499995],
              [167.8359481130001, -21.37428150799991],
              [167.84880618600005, -21.37476978999996],
              [167.863617384, -21.377211195999905],
              [167.8891707690001, -21.388604424999926],
              [167.90495853000004, -21.392754815999922],
              [167.922211134, -21.37818775799991],
              [167.98780358200008, -21.33562590899993],
              [167.99040774800005, -21.348728122999944],
              [167.97193444100003, -21.375258070999905],
              [167.96664472700002, -21.39430103999996],
              [167.97193444100003, -21.411228122999944],
              [167.98365319100003, -21.42937590899993],
              [167.99732506600003, -21.44459400799991],
              [168.00766035200002, -21.45289478999996],
              [168.03874759200005, -21.459730726999908],
              [168.07447350400003, -21.455743096999925],
              [168.10922285200002, -21.44500090899993],
              [168.13746178500003, -21.431817315999922],
            ],
          ],
          [
            [
              [166.42497806100005, -20.719903252999927],
              [166.432953321, -20.719008070999905],
              [166.45850670700008, -20.719903252999927],
              [166.45337975400003, -20.72893645599993],
              [166.44353274800005, -20.733493747999944],
              [166.41814212300005, -20.740411065999922],
              [166.4126082690001, -20.735121351999908],
              [166.40739993600005, -20.731540622999944],
              [166.40064537900003, -20.72893645599993],
              [166.39087975400003, -20.726739190999922],
              [166.3984481130001, -20.72193775799991],
              [166.40642337300005, -20.71965911299992],
              [166.41521243600005, -20.719008070999905],
              [166.42497806100005, -20.719903252999927],
            ],
          ],
          [
            [
              [167.43230228000004, -21.02776458099993],
              [167.44483483200008, -21.03679778399993],
              [167.4594832690001, -21.05087655999995],
              [167.46469160200002, -21.063653252999927],
              [167.43181399800005, -21.074883721999925],
              [167.42530358200008, -21.08912525799991],
              [167.42546634200005, -21.12737395599993],
              [167.42335045700008, -21.147556247999944],
              [167.4170028000001, -21.160088799999926],
              [167.40609785200002, -21.169040622999944],
              [167.39079837300005, -21.17864348799992],
              [167.37387129, -21.171807549999926],
              [167.35108483200008, -21.171807549999926],
              [167.3310653000001, -21.16415780999995],
              [167.32243899800005, -21.134209893999923],
              [167.3149520190001, -21.129571221999925],
              [167.29859459700003, -21.12737395599993],
              [167.282074415, -21.12346770599993],
              [167.27466881600003, -21.11370208099993],
              [167.27295983200008, -21.09693775799991],
              [167.2675887380001, -21.09148528399993],
              [167.17603600400003, -21.082207940999922],
              [167.14633222700002, -21.073011976999908],
              [167.1201278000001, -21.051934502999927],
              [167.09644616000003, -21.02776458099993],
              [167.09392337300005, -21.02076588299991],
              [167.0922957690001, -21.011651299999926],
              [167.0883895190001, -21.003838799999926],
              [167.0673934250001, -20.996351820999905],
              [167.0615340500001, -20.986260674999926],
              [167.06202233200008, -20.97307708099993],
              [167.06861412900003, -20.95956796699994],
              [167.02849368600005, -20.925388278999947],
              [167.020843946, -20.911716403999947],
              [167.08220462300005, -20.916192315999922],
              [167.10271243600005, -20.911716403999947],
              [167.1215926440001, -20.901543877999927],
              [167.13347415500004, -20.890069268999923],
              [167.15113366000003, -20.863213799999926],
              [167.18116295700008, -20.82984791499996],
              [167.19092858200008, -20.809991143999923],
              [167.18531334700003, -20.788181247999944],
              [167.1728621750001, -20.781426690999922],
              [167.1201278000001, -20.76018645599993],
              [167.04444420700008, -20.768243096999925],
              [167.04249108200008, -20.758558851999908],
              [167.04704837300005, -20.73723723799992],
              [167.05884850400003, -20.715997002999927],
              [167.0791121750001, -20.706231377999927],
              [167.11312910200002, -20.701104424999926],
              [167.1201278000001, -20.70281340899993],
              [167.1269637380001, -20.70867278399993],
              [167.13428795700008, -20.711683851999908],
              [167.1430770190001, -20.71298593499995],
              [167.1543074880001, -20.713067315999922],
              [167.16431725400003, -20.710137627999927],
              [167.1718856130001, -20.702569268999923],
              [167.1767684250001, -20.692559502999927],
              [167.17847741000003, -20.68206145599993],
              [167.21257571700005, -20.672133070999905],
              [167.28777103000004, -20.71152109199994],
              [167.3012801440001, -20.713067315999922],
              [167.30827884200005, -20.73088958099993],
              [167.30046634200005, -20.74814218499995],
              [167.28793379, -20.765557549999926],
              [167.28150475400003, -20.78443775799991],
              [167.2822371750001, -20.796319268999923],
              [167.28834069100003, -20.82236093499995],
              [167.3012801440001, -20.84970468499995],
              [167.29753665500004, -20.86223723799992],
              [167.28435306100005, -20.882256768999923],
              [167.28150475400003, -20.89430103999996],
              [167.28467858200008, -20.901788018999923],
              [167.29249108200008, -20.905694268999923],
              [167.30250084700003, -20.90911223799992],
              [167.31226647200003, -20.914808851999908],
              [167.32252037900003, -20.923760674999926],
              [167.3310653000001, -20.92945728999996],
              [167.35670006600003, -20.93840911299992],
              [167.36841881600003, -20.93954843499995],
              [167.37818444100003, -20.939060153999947],
              [167.38550866000003, -20.941664320999905],
              [167.39079837300005, -20.952732028999947],
              [167.39437910200002, -20.957696221999925],
              [167.4004012380001, -20.967950127999927],
              [167.40503991000003, -20.97242603999996],
              [167.393890821, -20.98992278399993],
              [167.39039147200003, -20.999444268999923],
              [167.39079837300005, -21.00790780999995],
              [167.39918053500003, -21.01921965899993],
              [167.40984134200005, -21.02320728999996],
              [167.42139733200008, -21.024509372999944],
              [167.43230228000004, -21.02776458099993],
            ],
          ],
          [
            [
              [166.6372176440001, -20.42506275799991],
              [166.64828535200002, -20.432793877999927],
              [166.67335045700008, -20.44573333099993],
              [166.6782332690001, -20.45240650799991],
              [166.6738387380001, -20.463636976999908],
              [166.6630965500001, -20.46738046699994],
              [166.63347415500004, -20.465997002999927],
              [166.62077884200005, -20.46933359199994],
              [166.6113387380001, -20.477227471999925],
              [166.60572350400003, -20.487399997999944],
              [166.60377037900003, -20.497165622999944],
              [166.600922071, -20.499932549999926],
              [166.58570397200003, -20.53801848799992],
              [166.57927493600005, -20.549574476999908],
              [166.5786238940001, -20.56487395599993],
              [166.5820418630001, -20.592950127999927],
              [166.58765709700003, -20.599867445999905],
              [166.600922071, -20.60019296699994],
              [166.629730665, -20.596368096999925],
              [166.59148196700005, -20.665134372999944],
              [166.5752059250001, -20.685153903999947],
              [166.5595809250001, -20.69508228999996],
              [166.53728274800005, -20.704685153999947],
              [166.51351972700002, -20.71152109199994],
              [166.49390709700003, -20.713067315999922],
              [166.48585045700008, -20.706231377999927],
              [166.47966556100005, -20.699395440999922],
              [166.4951278000001, -20.69345468499995],
              [166.50896243600005, -20.683526299999926],
              [166.5341903000001, -20.658461195999905],
              [166.5507918630001, -20.63713958099993],
              [166.55827884200005, -20.624444268999923],
              [166.56137129, -20.606622002999927],
              [166.5595809250001, -20.545668226999908],
              [166.5649520190001, -20.531508070999905],
              [166.576508009, -20.51726653399993],
              [166.5888778000001, -20.497653903999947],
              [166.59888756600003, -20.476739190999922],
              [166.60377037900003, -20.458591403999947],
              [166.59937584700003, -20.439629815999922],
              [166.58033287900003, -20.414727471999925],
              [166.57146243600005, -20.40593840899993],
              [166.567230665, -20.407321872999944],
              [166.56137129, -20.410821221999925],
              [166.56373131600003, -20.401950778999947],
              [166.574554884, -20.39234791499996],
              [166.58952884200005, -20.385430596999925],
              [166.60377037900003, -20.383477471999925],
              [166.61597741000003, -20.389418226999908],
              [166.6235457690001, -20.400648695999905],
              [166.62964928500003, -20.41375090899993],
              [166.6372176440001, -20.42506275799991],
            ],
          ],
          [
            [
              [167.03443444100003, -22.237481377999927],
              [167.0317488940001, -22.24667734199994],
              [167.02556399800005, -22.24814218499995],
              [167.01832116000003, -22.24846770599993],
              [167.01343834700003, -22.25481536299992],
              [167.01579837300005, -22.261163018999923],
              [167.02214603000004, -22.268243096999925],
              [167.02711022200003, -22.276462497999944],
              [167.0239363940001, -22.28557708099993],
              [167.0205184250001, -22.292168877999927],
              [167.01343834700003, -22.316338799999926],
              [167.0058699880001, -22.32976653399993],
              [167.00074303500003, -22.336683851999908],
              [166.99341881600003, -22.34433359199994],
              [166.991547071, -22.33953215899993],
              [166.98853600400003, -22.335056247999944],
              [166.98267662900003, -22.33757903399993],
              [166.9775496750001, -22.342461846999925],
              [166.96558678500003, -22.347263278999947],
              [166.96078535200002, -22.350762627999927],
              [166.9619246750001, -22.35588958099993],
              [166.966156446, -22.364678643999923],
              [166.9345809250001, -22.38844166499996],
              [166.91570071700005, -22.395603122999944],
              [166.890961134, -22.392022393999923],
              [166.91163170700008, -22.385023695999905],
              [166.91968834700003, -22.380059502999927],
              [166.92530358200008, -22.37086353999996],
              [166.90984134200005, -22.371270440999922],
              [166.90308678500003, -22.373304945999905],
              [166.89527428500003, -22.36492278399993],
              [166.88982181100005, -22.35198333099993],
              [166.88160241000003, -22.33766041499996],
              [166.8774520190001, -22.33367278399993],
              [166.87427819100003, -22.32203541499996],
              [166.86793053500003, -22.329278252999927],
              [166.8618270190001, -22.34303150799991],
              [166.86003665500004, -22.35051848799992],
              [166.85181725400003, -22.346449476999908],
              [166.84652754, -22.337090752999927],
              [166.8418074880001, -22.32586028399993],
              [166.83578535200002, -22.316338799999926],
              [166.840179884, -22.315118096999925],
              [166.84945722700002, -22.310153903999947],
              [166.8403426440001, -22.297946872999944],
              [166.831390821, -22.30087655999995],
              [166.8247176440001, -22.31422291499996],
              [166.82097415500004, -22.34303150799991],
              [166.81918379, -22.34807708099993],
              [166.8188582690001, -22.35361093499995],
              [166.8222762380001, -22.364678643999923],
              [166.825043165, -22.365980726999908],
              [166.84327233200008, -22.378350518999923],
              [166.83228600400003, -22.380791924999926],
              [166.81853274800005, -22.37859465899993],
              [166.8066512380001, -22.375176690999922],
              [166.8017684250001, -22.37468840899993],
              [166.79908287900003, -22.37981536299992],
              [166.79273522200003, -22.385511976999908],
              [166.78484134200005, -22.390069268999923],
              [166.777679884, -22.392022393999923],
              [166.75261478000004, -22.386651299999926],
              [166.7392684250001, -22.37428150799991],
              [166.740570509, -22.360446872999944],
              [166.76002037900003, -22.35051848799992],
              [166.76002037900003, -22.34433359199994],
              [166.74195397200003, -22.34612395599993],
              [166.71998131600003, -22.34384530999995],
              [166.7060653000001, -22.334730726999908],
              [166.712250196, -22.316338799999926],
              [166.7055770190001, -22.310153903999947],
              [166.69060306100005, -22.315118096999925],
              [166.66749108200008, -22.30722421699994],
              [166.6464949880001, -22.29273853999996],
              [166.6372176440001, -22.278741143999923],
              [166.6328231130001, -22.276950778999947],
              [166.61003665500004, -22.286309502999927],
              [166.5996199880001, -22.288995049999926],
              [166.59164472700002, -22.28720468499995],
              [166.56657962300005, -22.27711353999996],
              [166.557953321, -22.27190520599993],
              [166.55445397200003, -22.26213958099993],
              [166.56120853000004, -22.256524346999925],
              [166.56568444100003, -22.250664971999925],
              [166.55453535200002, -22.24065520599993],
              [166.54558353000004, -22.23756275799991],
              [166.51628665500004, -22.233575127999927],
              [166.506195509, -22.23447030999995],
              [166.4951278000001, -22.249118747999944],
              [166.4882918630001, -22.271416924999926],
              [166.47836347700002, -22.28720468499995],
              [166.45850670700008, -22.28215911299992],
              [166.45826256600003, -22.286228122999944],
              [166.45777428500003, -22.28801848799992],
              [166.4560653000001, -22.288669528999947],
              [166.45232181100005, -22.288995049999926],
              [166.46013431100005, -22.307712497999944],
              [166.44988040500004, -22.312432549999926],
              [166.43669681100005, -22.308038018999923],
              [166.43474368600005, -22.29924895599993],
              [166.43767337300005, -22.290622653999947],
              [166.43930097700002, -22.265232028999947],
              [166.44605553500003, -22.25481536299992],
              [166.44605553500003, -22.24814218499995],
              [166.43140709700003, -22.24895598799992],
              [166.41814212300005, -22.245700778999947],
              [166.4067488940001, -22.23837655999995],
              [166.39763431100005, -22.226820570999905],
              [166.430023634, -22.228122653999947],
              [166.44410241000003, -22.22437916499996],
              [166.45232181100005, -22.213962497999944],
              [166.43425540500004, -22.21298593499995],
              [166.4282332690001, -22.204278252999927],
              [166.43181399800005, -22.17229583099993],
              [166.4218856130001, -22.173028252999927],
              [166.40023847700002, -22.16969166499996],
              [166.39087975400003, -22.17229583099993],
              [166.387543165, -22.17815520599993],
              [166.3833113940001, -22.196384372999944],
              [166.38054446700005, -22.200290622999944],
              [166.36793053500003, -22.20208098799992],
              [166.36304772200003, -22.20712655999995],
              [166.36011803500003, -22.21453215899993],
              [166.35328209700003, -22.223809502999927],
              [166.34400475400003, -22.22747161299992],
              [166.33936608200008, -22.221368096999925],
              [166.34099368600005, -22.21062590899993],
              [166.34986412900003, -22.200290622999944],
              [166.33961022200003, -22.194431247999944],
              [166.31511478000004, -22.17229583099993],
              [166.31511478000004, -22.16611093499995],
              [166.32154381600003, -22.162774346999925],
              [166.32488040500004, -22.15911223799992],
              [166.32683353000004, -22.153497002999927],
              [166.3281356130001, -22.14495208099993],
              [166.32195071700005, -22.14495208099993],
              [166.31202233200008, -22.15471770599993],
              [166.28589928500003, -22.14934661299992],
              [166.28777103000004, -22.15862395599993],
              [166.26872806100005, -22.16578541499996],
              [166.25212649800005, -22.15992603999996],
              [166.23617597700002, -22.151788018999923],
              [166.2187606130001, -22.151788018999923],
              [166.21794681100005, -22.132745049999926],
              [166.20883222700002, -22.11777109199994],
              [166.1953231130001, -22.107679945999905],
              [166.18132571700005, -22.10409921699994],
              [166.1689559250001, -22.097588799999926],
              [166.15748131600003, -22.086683851999908],
              [166.14527428500003, -22.08456796699994],
              [166.13013756600003, -22.10409921699994],
              [166.11931399800005, -22.09807708099993],
              [166.10889733200008, -22.09042734199994],
              [166.11353600400003, -22.08521900799991],
              [166.11589603000004, -22.07984791499996],
              [166.116547071, -22.07268645599993],
              [166.11646569100003, -22.062432549999926],
              [166.12273196700005, -22.062432549999926],
              [166.13111412900003, -22.071465752999927],
              [166.14210045700008, -22.07586028399993],
              [166.1504012380001, -22.07195403399993],
              [166.15064537900003, -22.056247653999947],
              [166.1445418630001, -22.04656340899993],
              [166.1250106130001, -22.038506768999923],
              [166.11646569100003, -22.028415622999944],
              [166.14372806100005, -22.02857838299991],
              [166.15503991000003, -22.030694268999923],
              [166.16431725400003, -22.035088799999926],
              [166.16334069100003, -22.024590752999927],
              [166.15894616000003, -22.018324476999908],
              [166.15121504, -22.01539478999996],
              [166.14039147200003, -22.014743747999944],
              [166.1352645190001, -22.008558851999908],
              [166.13689212300005, -21.995538018999923],
              [166.140961134, -21.983575127999927],
              [166.14380944100003, -21.98056405999995],
              [166.1357528000001, -21.95826588299991],
              [166.1230574880001, -21.948825778999947],
              [166.08855228000004, -21.938897393999923],
              [166.07642662900003, -21.94589609199994],
              [166.06999759200005, -21.94304778399993],
              [166.0712996750001, -21.93482838299991],
              [166.08228600400003, -21.925225518999923],
              [166.07178795700008, -21.92050546699994],
              [166.0644637380001, -21.91301848799992],
              [166.06072024800005, -21.90325286299992],
              [166.06120853000004, -21.89120859199994],
              [166.04558353000004, -21.900648695999905],
              [166.039886915, -21.90992603999996],
              [166.04078209700003, -21.935479424999926],
              [166.0361434250001, -21.941582940999922],
              [166.02556399800005, -21.94150155999995],
              [166.014008009, -21.939385674999926],
              [166.00660241000003, -21.938897393999923],
              [166.01042728000004, -21.94378020599993],
              [166.00961347700002, -21.955824476999908],
              [166.00318444100003, -21.963962497999944],
              [165.98951256600003, -21.95631275799991],
              [165.9751082690001, -21.937676690999922],
              [165.96599368600005, -21.928887627999927],
              [165.934906446, -21.91773853999996],
              [165.91431725400003, -21.884942315999922],
              [165.89991295700008, -21.87753671699994],
              [165.8930770190001, -21.875746351999908],
              [165.88550866000003, -21.871351820999905],
              [165.87281334700003, -21.86101653399993],
              [165.86670983200008, -21.85784270599993],
              [165.86158287900003, -21.859633070999905],
              [165.85621178500003, -21.863213799999926],
              [165.8496199880001, -21.864434502999927],
              [165.82056725400003, -21.863946221999925],
              [165.810883009, -21.858575127999927],
              [165.8086043630001, -21.843357028999947],
              [165.82960045700008, -21.85214609199994],
              [165.82292728000004, -21.84221770599993],
              [165.7949324880001, -21.816664320999905],
              [165.7949324880001, -21.808851820999905],
              [165.799164259, -21.799574476999908],
              [165.80030358200008, -21.792087497999944],
              [165.79127037900003, -21.78875090899993],
              [165.78077233200008, -21.79111093499995],
              [165.77662194100003, -21.797133070999905],
              [165.77711022200003, -21.806084893999923],
              [165.78077233200008, -21.816664320999905],
              [165.764008009, -21.811211846999925],
              [165.76059004, -21.799899997999944],
              [165.76197350400003, -21.785088799999926],
              [165.75953209700003, -21.76881275799991],
              [165.75114993600005, -21.75872161299992],
              [165.7407332690001, -21.750258070999905],
              [165.7329207690001, -21.738946221999925],
              [165.7329207690001, -21.719821872999944],
              [165.72535241000003, -21.719821872999944],
              [165.7172957690001, -21.735528252999927],
              [165.70687910200002, -21.748304945999905],
              [165.6938582690001, -21.757419528999947],
              [165.6777449880001, -21.76140715899993],
              [165.67855879, -21.740899346999925],
              [165.67750084700003, -21.72942473799992],
              [165.6699324880001, -21.725274346999925],
              [165.6508895190001, -21.726739190999922],
              [165.65023847700002, -21.72893645599993],
              [165.65064537900003, -21.73365650799991],
              [165.6494246750001, -21.738457940999922],
              [165.64340254, -21.740899346999925],
              [165.63795006600003, -21.740166924999926],
              [165.50456790500004, -21.67815520599993],
              [165.47388756600003, -21.651788018999923],
              [165.48585045700008, -21.631036065999922],
              [165.48585045700008, -21.62363046699994],
              [165.47152754, -21.628513278999947],
              [165.46314537900003, -21.62590911299992],
              [165.46461022200003, -21.620538018999923],
              [165.4790145190001, -21.61687590899993],
              [165.46314537900003, -21.605645440999922],
              [165.44654381600003, -21.609307549999926],
              [165.42986087300005, -21.618584893999923],
              [165.413422071, -21.62363046699994],
              [165.39600670700008, -21.620538018999923],
              [165.29078209700003, -21.57675546699994],
              [165.27702884200005, -21.56617603999996],
              [165.26880944100003, -21.552666924999926],
              [165.25953209700003, -21.52117278399993],
              [165.2568465500001, -21.515069268999923],
              [165.23796634200005, -21.51295338299991],
              [165.2255965500001, -21.50709400799991],
              [165.1977645190001, -21.487074476999908],
              [165.18970787900003, -21.485039971999925],
              [165.1806746750001, -21.48479583099993],
              [165.17351321700005, -21.48300546699994],
              [165.17058353000004, -21.476495049999926],
              [165.15699303500003, -21.46217213299991],
              [165.15381920700008, -21.459730726999908],
              [165.116547071, -21.39771900799991],
              [165.11475670700008, -21.38836028399993],
              [165.118011915, -21.38339609199994],
              [165.118500196, -21.378838799999926],
              [165.111664259, -21.37314218499995],
              [165.10914147200003, -21.371026299999926],
              [165.10222415500004, -21.37118905999995],
              [165.09327233200008, -21.374444268999923],
              [165.08708743600005, -21.377618096999925],
              [165.0879012380001, -21.377211195999905],
              [165.0844832690001, -21.391371351999908],
              [165.07569420700008, -21.396091403999947],
              [165.06666100400003, -21.39120859199994],
              [165.061859571, -21.377211195999905],
              [165.05437259200005, -21.38339609199994],
              [165.04664147200003, -21.38836028399993],
              [165.03785241000003, -21.389418226999908],
              [165.02662194100003, -21.383965752999927],
              [165.0454207690001, -21.364678643999923],
              [165.04314212300005, -21.34807708099993],
              [165.02751712300005, -21.33912525799991],
              [165.00554446700005, -21.34303150799991],
              [165.01392662900003, -21.328057549999926],
              [165.00928795700008, -21.31804778399993],
              [164.98552493600005, -21.30201588299991],
              [164.9765731130001, -21.315524997999944],
              [164.97966556100005, -21.336602471999925],
              [164.97193444100003, -21.349867445999905],
              [164.96119225400003, -21.35605234199994],
              [164.95142662900003, -21.353773695999905],
              [164.9433699880001, -21.34628671699994],
              [164.93775475400003, -21.33562590899993],
              [164.941742384, -21.327732028999947],
              [164.9423934250001, -21.319105726999908],
              [164.945648634, -21.310479424999926],
              [164.95142662900003, -21.30201588299991],
              [164.9438582690001, -21.29338958099993],
              [164.93677819100003, -21.291273695999905],
              [164.92920983200008, -21.290215752999927],
              [164.9204207690001, -21.285088799999926],
              [164.91480553500003, -21.278741143999923],
              [164.90796959700003, -21.26734791499996],
              [164.83415774800005, -21.18328215899993],
              [164.82927493600005, -21.169528903999947],
              [164.82781009200005, -21.14812590899993],
              [164.828461134, -21.132419528999947],
              [164.8271590500001, -21.114678643999923],
              [164.81918379, -21.10409921699994],
              [164.80005944100003, -21.11028411299992],
              [164.8012801440001, -21.097263278999947],
              [164.80290774800005, -21.09417083099993],
              [164.80738366000003, -21.089776299999926],
              [164.80738366000003, -21.082289320999905],
              [164.8007918630001, -21.082207940999922],
              [164.79607181100005, -21.08066171699994],
              [164.78638756600003, -21.07626718499995],
              [164.79224694100003, -21.068536065999922],
              [164.7910262380001, -21.064385674999926],
              [164.78394616000003, -21.064385674999926],
              [164.77271569100003, -21.069431247999944],
              [164.77027428500003, -21.08098723799992],
              [164.75896243600005, -21.08245208099993],
              [164.74976647200003, -21.07480234199994],
              [164.74594160200002, -21.05917734199994],
              [164.739593946, -21.05836353999996],
              [164.72730553500003, -21.06023528399993],
              [164.7192488940001, -21.065850518999923],
              [164.72543379, -21.07626718499995],
              [164.71900475400003, -21.083428643999923],
              [164.711761915, -21.089776299999926],
              [164.6933699880001, -21.042901299999926],
              [164.6806746750001, -21.023695570999905],
              [164.6640731130001, -21.01409270599993],
              [164.68327884200005, -21.001153252999927],
              [164.67457116000003, -20.99260833099993],
              [164.65357506600003, -20.98447030999995],
              [164.6367293630001, -20.97242603999996],
              [164.65251712300005, -20.97112395599993],
              [164.66081790500004, -20.964776299999926],
              [164.66187584700003, -20.95566171699994],
              [164.656586134, -20.94589609199994],
              [164.64421634200005, -20.93914153399993],
              [164.6313582690001, -20.937758070999905],
              [164.62281334700003, -20.933526299999926],
              [164.622406446, -20.917901299999926],
              [164.6162215500001, -20.917901299999926],
              [164.6005965500001, -20.927666924999926],
              [164.5849715500001, -20.920586846999925],
              [164.5610457690001, -20.898044528999947],
              [164.55054772200003, -20.895277601999908],
              [164.53003991000003, -20.894707940999922],
              [164.51937910200002, -20.890557549999926],
              [164.51514733200008, -20.88534921699994],
              [164.50261478000004, -20.863213799999926],
              [164.48031660200002, -20.85914478999996],
              [164.46241295700008, -20.84856536299992],
              [164.418793165, -20.806247653999947],
              [164.38892662900003, -20.787367445999905],
              [164.3754988940001, -20.77402109199994],
              [164.365570509, -20.758070570999905],
              [164.3720809250001, -20.757256768999923],
              [164.38689212300005, -20.759698174999926],
              [164.402679884, -20.754082940999922],
              [164.41041100400003, -20.738457940999922],
              [164.4043074880001, -20.725355726999908],
              [164.3896590500001, -20.716403903999947],
              [164.3720809250001, -20.713067315999922],
              [164.35718834700003, -20.702325127999927],
              [164.33513431100005, -20.655450127999927],
              [164.316742384, -20.644789320999905],
              [164.28663170700008, -20.57586028399993],
              [164.28101647200003, -20.579522393999923],
              [164.2763778000001, -20.58049895599993],
              [164.27173912900003, -20.581149997999944],
              [164.2661238940001, -20.582696221999925],
              [164.25603274800005, -20.56503671699994],
              [164.19255618600005, -20.52581145599993],
              [164.17741946700005, -20.50400155999995],
              [164.16586347700002, -20.463067315999922],
              [164.16374759200005, -20.44898853999996],
              [164.1587020190001, -20.43254973799992],
              [164.1469832690001, -20.42506275799991],
              [164.13347415500004, -20.420098565999922],
              [164.123383009, -20.410821221999925],
              [164.11866295700008, -20.39031340899993],
              [164.13013756600003, -20.388116143999923],
              [164.15699303500003, -20.397149346999925],
              [164.1665145190001, -20.386651299999926],
              [164.1704207690001, -20.36972421699994],
              [164.17058353000004, -20.33912525799991],
              [164.1665145190001, -20.33212655999995],
              [164.1562606130001, -20.319024346999925],
              [164.14380944100003, -20.306573174999926],
              [164.13249759200005, -20.300957940999922],
              [164.08545983200008, -20.298760674999926],
              [164.07374108200008, -20.294122002999927],
              [164.080414259, -20.28093840899993],
              [164.08122806100005, -20.267836195999905],
              [164.07488040500004, -20.261163018999923],
              [164.06072024800005, -20.266778252999927],
              [164.0649520190001, -20.276788018999923],
              [164.05933678500003, -20.28801848799992],
              [164.04948978000004, -20.297133070999905],
              [164.04021243600005, -20.300957940999922],
              [164.0254012380001, -20.297051690999922],
              [164.02076256600003, -20.287774346999925],
              [164.0180770190001, -20.278497002999927],
              [164.00953209700003, -20.274183851999908],
              [163.99480228000004, -20.26425546699994],
              [163.99822024800005, -20.24456145599993],
              [164.0166121750001, -20.23105234199994],
              [164.04712975400003, -20.239434502999927],
              [164.05640709700003, -20.227634372999944],
              [164.05250084700003, -20.215508721999925],
              [164.03345787900003, -20.19231536299992],
              [164.04517662900003, -20.18759530999995],
              [164.05250084700003, -20.17782968499995],
              [164.0537215500001, -20.16497161299992],
              [164.04712975400003, -20.151462497999944],
              [164.0322371750001, -20.14031340899993],
              [164.02027428500003, -20.14234791499996],
              [164.00766035200002, -20.14885833099993],
              [163.99195397200003, -20.151462497999944],
              [163.99195397200003, -20.14381275799991],
              [163.9970809250001, -20.139825127999927],
              [164.000336134, -20.13534921699994],
              [164.00554446700005, -20.12346770599993],
              [163.99105879, -20.11891041499996],
              [163.98601321700005, -20.109633070999905],
              [163.98715254, -20.097263278999947],
              [163.99195397200003, -20.083103122999944],
              [163.99968509200005, -20.084161065999922],
              [164.01351972700002, -20.083103122999944],
              [164.0322371750001, -20.09384530999995],
              [164.0517684250001, -20.109307549999926],
              [164.0673934250001, -20.126071872999944],
              [164.07740319100003, -20.149834893999923],
              [164.086761915, -20.155450127999927],
              [164.10914147200003, -20.16497161299992],
              [164.182953321, -20.24732838299991],
              [164.19792728000004, -20.260511976999908],
              [164.24431399800005, -20.285332940999922],
              [164.26433353000004, -20.288669528999947],
              [164.28663170700008, -20.28101978999996],
              [164.29281660200002, -20.28101978999996],
              [164.30591881600003, -20.308770440999922],
              [164.31657962300005, -20.319105726999908],
              [164.3344832690001, -20.321465752999927],
              [164.32545006600003, -20.30917734199994],
              [164.310883009, -20.27516041499996],
              [164.30437259200005, -20.24277109199994],
              [164.30648847700002, -20.235039971999925],
              [164.315765821, -20.23479583099993],
              [164.49561608200008, -20.300225518999923],
              [164.52751712300005, -20.32659270599993],
              [164.58082116000003, -20.390883070999905],
              [164.59522545700008, -20.40357838299991],
              [164.6152449880001, -20.417087497999944],
              [164.63624108200008, -20.42750416499996],
              [164.65349368600005, -20.431817315999922],
              [164.6845809250001, -20.458591403999947],
              [164.69483483200008, -20.463067315999922],
              [164.72543379, -20.472832940999922],
              [164.73975670700008, -20.485528252999927],
              [164.76775149800005, -20.52076588299991],
              [164.7832137380001, -20.528090101999908],
              [164.79175866000003, -20.535088799999926],
              [164.82781009200005, -20.582696221999925],
              [164.87964928500003, -20.626560153999947],
              [164.88941491000003, -20.62737395599993],
              [164.91976972700002, -20.64511484199994],
              [164.93523196700005, -20.65911223799992],
              [164.93034915500004, -20.672133070999905],
              [164.94792728000004, -20.68368905999995],
              [164.98853600400003, -20.68531666499996],
              [165.00554446700005, -20.699395440999922],
              [165.0244246750001, -20.705743096999925],
              [165.0615340500001, -20.73406340899993],
              [165.16716556100005, -20.754082940999922],
              [165.17017662900003, -20.756036065999922],
              [165.1782332690001, -20.76531340899993],
              [165.1840926440001, -20.768243096999925],
              [165.1875106130001, -20.767022393999923],
              [165.19255618600005, -20.763604424999926],
              [165.198578321, -20.760511976999908],
              [165.20525149800005, -20.76018645599993],
              [165.21753991000003, -20.764418226999908],
              [165.222015821, -20.76799895599993],
              [165.2251082690001, -20.772881768999923],
              [165.23267662900003, -20.780694268999923],
              [165.2568465500001, -20.80006275799991],
              [165.26441491000003, -20.813246351999908],
              [165.25993899800005, -20.82854583099993],
              [165.2700301440001, -20.86956145599993],
              [165.28044681100005, -20.883884372999944],
              [165.29558353000004, -20.89421965899993],
              [165.3110457690001, -20.902601820999905],
              [165.3232528000001, -20.912774346999925],
              [165.32829837300005, -20.928399346999925],
              [165.33668053500003, -20.931573174999926],
              [165.3896590500001, -20.93840911299992],
              [165.40772545700008, -20.94394296699994],
              [165.4130965500001, -20.949151299999926],
              [165.40886478000004, -20.98251718499995],
              [165.40251712300005, -21.005059502999927],
              [165.39991295700008, -21.01100025799991],
              [165.3955184250001, -21.018243096999925],
              [165.39714603000004, -21.024834893999923],
              [165.40113366000003, -21.03134530999995],
              [165.4033309250001, -21.038262627999927],
              [165.4067488940001, -21.055433851999908],
              [165.4150496750001, -21.066338799999926],
              [165.44809004, -21.08953215899993],
              [165.47624759200005, -21.103773695999905],
              [165.4892684250001, -21.11370208099993],
              [165.50220787900003, -21.127129815999922],
              [165.5097762380001, -21.129978122999944],
              [165.5356551440001, -21.131524346999925],
              [165.5429793630001, -21.134698174999926],
              [165.5449324880001, -21.14120859199994],
              [165.5410262380001, -21.151950778999947],
              [165.5468856130001, -21.14967213299991],
              [165.54948978000004, -21.149183851999908],
              [165.5512801440001, -21.14812590899993],
              [165.55486087300005, -21.144463799999926],
              [165.58545983200008, -21.16838958099993],
              [165.5986434250001, -21.18173593499995],
              [165.6025496750001, -21.192152601999908],
              [165.607758009, -21.19540780999995],
              [165.61052493600005, -21.198337497999944],
              [165.61540774800005, -21.206475518999923],
              [165.5986434250001, -21.206231377999927],
              [165.58326256600003, -21.202325127999927],
              [165.5688582690001, -21.195489190999922],
              [165.55486087300005, -21.18613046699994],
              [165.55925540500004, -21.195570570999905],
              [165.56861412900003, -21.206963799999926],
              [165.5805770190001, -21.216241143999923],
              [165.5922957690001, -21.220147393999923],
              [165.6025496750001, -21.226495049999926],
              [165.61011803500003, -21.24114348799992],
              [165.61646569100003, -21.257256768999923],
              [165.6230574880001, -21.26799895599993],
              [165.64625084700003, -21.277601820999905],
              [165.70655358200008, -21.292168877999927],
              [165.72535241000003, -21.30950286299992],
              [165.7544051440001, -21.302341403999947],
              [165.7812606130001, -21.31617603999996],
              [165.801117384, -21.34026458099993],
              [165.8086043630001, -21.363539320999905],
              [165.8261824880001, -21.359633070999905],
              [165.83668053500003, -21.40203215899993],
              [165.856293165, -21.418715101999908],
              [165.84587649800005, -21.39885833099993],
              [165.84489993600005, -21.391371351999908],
              [165.8496199880001, -21.383965752999927],
              [165.858734571, -21.378838799999926],
              [165.8681746750001, -21.379164320999905],
              [165.87680097700002, -21.385430596999925],
              [165.883636915, -21.39771900799991],
              [165.8891707690001, -21.388848565999922],
              [165.89039147200003, -21.378024997999944],
              [165.88640384200005, -21.366794528999947],
              [165.87614993600005, -21.35670338299991],
              [165.89405358200008, -21.36109791499996],
              [165.90837649800005, -21.378024997999944],
              [165.94312584700003, -21.43873463299991],
              [165.94988040500004, -21.455743096999925],
              [165.9453231130001, -21.464288018999923],
              [165.92408287900003, -21.459730726999908],
              [165.93132571700005, -21.470147393999923],
              [165.97234134200005, -21.49382903399993],
              [165.96648196700005, -21.503024997999944],
              [165.97445722700002, -21.50400155999995],
              [165.986664259, -21.500746351999908],
              [165.99293053500003, -21.497247002999927],
              [165.99040774800005, -21.48447030999995],
              [165.98454837300005, -21.47503020599993],
              [165.97771243600005, -21.46738046699994],
              [165.97234134200005, -21.459730726999908],
              [165.96404056100005, -21.435804945999905],
              [165.9619246750001, -21.417413018999923],
              [165.96941165500004, -21.410414320999905],
              [165.98951256600003, -21.42156340899993],
              [166.02027428500003, -21.45289478999996],
              [166.030609571, -21.45566171699994],
              [166.05543053500003, -21.458591403999947],
              [166.06462649800005, -21.463148695999905],
              [166.066742384, -21.469903252999927],
              [166.05974368600005, -21.47307708099993],
              [166.05103600400003, -21.475355726999908],
              [166.048187696, -21.479668877999927],
              [166.05250084700003, -21.483982028999947],
              [166.05925540500004, -21.485935153999947],
              [166.06804446700005, -21.487074476999908],
              [166.07048587300005, -21.497653903999947],
              [166.0722762380001, -21.51620859199994],
              [166.07488040500004, -21.528008721999925],
              [166.097992384, -21.51734791499996],
              [166.11646569100003, -21.51726653399993],
              [166.133148634, -21.52597421699994],
              [166.18474368600005, -21.56959400799991],
              [166.19092858200008, -21.57268645599993],
              [166.2041121750001, -21.576104424999926],
              [166.20883222700002, -21.579522393999923],
              [166.2187606130001, -21.59693775799991],
              [166.2539168630001, -21.618747653999947],
              [166.2910262380001, -21.635430596999925],
              [166.37037194100003, -21.658949476999908],
              [166.37037194100003, -21.665215752999927],
              [166.34245853000004, -21.665215752999927],
              [166.34245853000004, -21.672051690999922],
              [166.3496199880001, -21.676527601999908],
              [166.35181725400003, -21.682305596999925],
              [166.35303795700008, -21.688246351999908],
              [166.35670006600003, -21.69312916499996],
              [166.3632918630001, -21.695977471999925],
              [166.3769637380001, -21.69703541499996],
              [166.41130618600005, -21.70549895599993],
              [166.42554772200003, -21.712334893999923],
              [166.43702233200008, -21.731540622999944],
              [166.47584069100003, -21.75839609199994],
              [166.48023522200003, -21.76539478999996],
              [166.48365319100003, -21.783461195999905],
              [166.48975670700008, -21.792168877999927],
              [166.49577884200005, -21.796075127999927],
              [166.5136824880001, -21.802992445999905],
              [166.506195509, -21.809258721999925],
              [166.52914472700002, -21.82789478999996],
              [166.57341556100005, -21.874932549999926],
              [166.59253991000003, -21.884372653999947],
              [166.61060631600003, -21.897637627999927],
              [166.63746178500003, -21.923435153999947],
              [166.66138756600003, -21.939629815999922],
              [166.671234571, -21.925225518999923],
              [166.7060653000001, -21.948011976999908],
              [166.719086134, -21.952569268999923],
              [166.719086134, -21.960056247999944],
              [166.7114363940001, -21.96493905999995],
              [166.70329837300005, -21.968682549999926],
              [166.69450931100005, -21.971368096999925],
              [166.68506920700008, -21.97307708099993],
              [166.68506920700008, -21.98056405999995],
              [166.69320722700002, -21.98406340899993],
              [166.72250410200002, -21.98056405999995],
              [166.73552493600005, -21.983168226999908],
              [166.7461043630001, -21.98805103999996],
              [166.754242384, -21.99081796699994],
              [166.76002037900003, -21.98674895599993],
              [166.76734459700003, -22.00481536299992],
              [166.7783309250001, -22.01458098799992],
              [166.79420006600003, -22.019138278999947],
              [166.8154403000001, -22.02157968499995],
              [166.87370853000004, -22.035088799999926],
              [166.88795006600003, -22.042575778999947],
              [166.938812696, -22.07984791499996],
              [166.9482528000001, -22.092054945999905],
              [166.959320509, -22.110935153999947],
              [166.96078535200002, -22.11923593499995],
              [166.959320509, -22.14495208099993],
              [166.95525149800005, -22.150648695999905],
              [166.9482528000001, -22.157810153999947],
              [166.94800866000003, -22.163669528999947],
              [166.96273847700002, -22.16611093499995],
              [166.97152754, -22.170179945999905],
              [166.97974694100003, -22.18010833099993],
              [166.99341881600003, -22.200290622999944],
              [167.02881920700008, -22.226820570999905],
              [167.03443444100003, -22.237481377999927],
            ],
          ],
          [
            [
              [164.2246199880001, -20.13762786299992],
              [164.2402449880001, -20.15829843499995],
              [164.221039259, -20.153497002999927],
              [164.19263756600003, -20.13909270599993],
              [164.16920006600003, -20.123304945999905],
              [164.16431725400003, -20.105075778999947],
              [164.16374759200005, -20.061944268999923],
              [164.17058353000004, -20.061944268999923],
              [164.21501712300005, -20.117852471999925],
              [164.2246199880001, -20.13762786299992],
            ],
          ],
          [
            [
              [163.68279056100005, -19.739841403999947],
              [163.6938582690001, -19.75750090899993],
              [163.696136915, -19.765069268999923],
              [163.66968834700003, -19.78769296699994],
              [163.639984571, -19.723728122999944],
              [163.636078321, -19.70159270599993],
              [163.63786868600005, -19.66057708099993],
              [163.63233483200008, -19.645928643999923],
              [163.6157332690001, -19.636163018999923],
              [163.62183678500003, -19.623711846999925],
              [163.63795006600003, -19.63176848799992],
              [163.64966881600003, -19.64625416499996],
              [163.67017662900003, -19.693291924999926],
              [163.677093946, -19.72551848799992],
              [163.68279056100005, -19.739841403999947],
            ],
          ],
          [
            [
              [171.34060495900007, -22.344761434999953],
              [171.343765287, -22.346341597999924],
              [171.34192176200008, -22.34923856499995],
              [171.339024795, -22.347658401999922],
              [171.34060495900007, -22.344761434999953],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Pitcairn Is.',
        iso3: 'PCN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-130.12035071499992, -25.068291924999926],
              [-130.11046301999994, -25.064385674999926],
              [-130.1011449859999, -25.064385674999926],
              [-130.09300696499992, -25.067966403999947],
              [-130.0862524079999, -25.07512786299992],
              [-130.0959366529999, -25.07708098799992],
              [-130.10533606699994, -25.07675546699994],
              [-130.11367753799993, -25.073825778999947],
              [-130.12035071499992, -25.068291924999926],
            ],
          ],
          [
            [
              [-124.7861628899999, -24.66456471099991],
              [-124.79710852799991, -24.667087497999944],
              [-124.78652910099993, -24.663995049999926],
              [-124.78551184799994, -24.663995049999926],
              [-124.7805883449999, -24.66464609199994],
              [-124.77892005099994, -24.667413018999923],
              [-124.77806555899991, -24.672539971999925],
              [-124.77879798099991, -24.668715101999908],
              [-124.7805883449999, -24.66659921699994],
              [-124.78538977799991, -24.66448333099993],
              [-124.7861628899999, -24.66456471099991],
            ],
          ],
          [
            [
              [-128.33018958199995, -24.32431405999995],
              [-128.3037003249999, -24.334649346999925],
              [-128.2908422519999, -24.36565520599993],
              [-128.29015051999994, -24.398370049999926],
              [-128.3001195949999, -24.413669528999947],
              [-128.32066809799994, -24.400648695999905],
              [-128.34219316299993, -24.371758721999925],
              [-128.35024980399993, -24.341241143999923],
              [-128.33018958199995, -24.32431405999995],
            ],
          ],
          [
            [
              [-130.74526933499993, -23.92441171699994],
              [-130.74136308499993, -23.92441171699994],
              [-130.74209550699993, -23.92782968499995],
              [-130.74697831899994, -23.932793877999927],
              [-130.75084387899994, -23.934665622999944],
              [-130.75308183499993, -23.929620049999926],
              [-130.75084387899994, -23.927178643999923],
              [-130.7480362619999, -23.927341403999947],
              [-130.74526933499993, -23.92441171699994],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Fr. Polynesia',
        iso3: 'PYF',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-136.16576087099992, -22.02434661299992],
              [-136.17568925699993, -22.02988046699994],
              [-136.1858617829999, -22.03443775799991],
              [-136.1635636059999, -22.013604424999926],
              [-136.1638891269999, -22.016371351999908],
              [-136.16576087099992, -22.02434661299992],
            ],
          ],
          [
            [
              [-136.3771866529999, -21.468357028999947],
              [-136.38634192599994, -21.463636976999908],
              [-136.3958227199999, -21.462823174999926],
              [-136.4050186839999, -21.46542734199994],
              [-136.4134008449999, -21.471368096999925],
              [-136.40493730399993, -21.46021900799991],
              [-136.39146887899994, -21.456149997999944],
              [-136.3798721999999, -21.45907968499995],
              [-136.3771866529999, -21.468357028999947],
            ],
          ],
          [
            [
              [-136.5493871739999, -21.33684661299992],
              [-136.5322159499999, -21.33131275799991],
              [-136.5257055329999, -21.338067315999922],
              [-136.52944902299993, -21.349867445999905],
              [-136.54312089799993, -21.35979583099993],
              [-136.5342504549999, -21.34889088299991],
              [-136.5357152989999, -21.34238046699994],
              [-136.54238847599993, -21.33879973799992],
              [-136.5493871739999, -21.33684661299992],
            ],
          ],
          [
            [
              [-136.6362198559999, -21.34156666499996],
              [-136.6467992829999, -21.327243747999944],
              [-136.65160071499992, -21.322930596999925],
              [-136.64391028599994, -21.32284921699994],
              [-136.63988196499992, -21.326429945999905],
              [-136.63792883999992, -21.333103122999944],
              [-136.6362198559999, -21.34156666499996],
            ],
          ],
          [
            [
              [-136.7343643869999, -21.312107028999947],
              [-136.73916581899994, -21.308526299999926],
              [-136.7422582669999, -21.30445728999996],
              [-136.74575761599993, -21.303399346999925],
              [-136.7521866529999, -21.308526299999926],
              [-136.74596106699994, -21.299493096999925],
              [-136.73863684799994, -21.299493096999925],
              [-136.73232988199993, -21.306247653999947],
              [-136.72911536399994, -21.31804778399993],
              [-136.7312719389999, -21.31731536299992],
              [-136.73216712099992, -21.31568775799991],
              [-136.73281816299993, -21.313897393999923],
              [-136.7343643869999, -21.312107028999947],
            ],
          ],
          [
            [
              [-140.41397050699993, -19.61419036299992],
              [-140.40737870999993, -19.610121351999908],
              [-140.39517167899993, -19.615411065999922],
              [-140.38316809799994, -19.62542083099993],
              [-140.3770238919999, -19.636325778999947],
              [-140.37905839799993, -19.648614190999922],
              [-140.38735917899993, -19.656996351999908],
              [-140.39928137899994, -19.661716403999947],
              [-140.4124242829999, -19.66383228999996],
              [-140.39683997299994, -19.651055596999925],
              [-140.38662675699993, -19.64031340899993],
              [-140.38980058499993, -19.628838799999926],
              [-140.41397050699993, -19.61419036299992],
            ],
          ],
          [
            [
              [-139.20225989499994, -19.350681247999944],
              [-139.2040909499999, -19.34612395599993],
              [-139.2050675119999, -19.34148528399993],
              [-139.20767167899993, -19.337334893999923],
              [-139.2148331369999, -19.33456796699994],
              [-139.2029516269999, -19.33489348799992],
              [-139.19591223899994, -19.340915622999944],
              [-139.19591223899994, -19.349786065999922],
              [-139.2051895819999, -19.35914478999996],
              [-139.20225989499994, -19.350681247999944],
            ],
          ],
          [
            [
              [-138.79674231699994, -19.29029713299991],
              [-138.8059789699999, -19.28883228999996],
              [-138.8093969389999, -19.287286065999922],
              [-138.81212317599994, -19.28378671699994],
              [-138.80239824099993, -19.281996351999908],
              [-138.79458574099993, -19.28167083099993],
              [-138.7917374339999, -19.283868096999925],
              [-138.79674231699994, -19.29029713299991],
            ],
          ],
          [
            [
              [-141.2661840489999, -19.20354583099993],
              [-141.25234941299993, -19.189711195999905],
              [-141.23717200399994, -19.193617445999905],
              [-141.2275284499999, -19.208428643999923],
              [-141.23037675699993, -19.22714609199994],
              [-141.2337133449999, -19.211683851999908],
              [-141.24278723899994, -19.202243747999944],
              [-141.25475012899994, -19.199395440999922],
              [-141.2661840489999, -19.20354583099993],
            ],
          ],
          [
            [
              [-140.72183183499993, -19.13372161299992],
              [-140.69619706899994, -19.119317315999922],
              [-140.6701554029999, -19.13176848799992],
              [-140.6608780589999, -19.15243905999995],
              [-140.6858617829999, -19.161553643999923],
              [-140.6700333319999, -19.142754815999922],
              [-140.68138587099992, -19.132256768999923],
              [-140.70396887899994, -19.12932708099993],
              [-140.72183183499993, -19.13372161299992],
            ],
          ],
          [
            [
              [-138.8015844389999, -18.765232028999947],
              [-138.7952367829999, -18.770928643999923],
              [-138.79332434799994, -18.77402109199994],
              [-138.7932022779999, -18.778903903999947],
              [-138.82974199099993, -18.759942315999922],
              [-138.82286536399994, -18.76034921699994],
              [-138.8157445949999, -18.76140715899993],
              [-138.8015844389999, -18.765232028999947],
            ],
          ],
          [
            [
              [-143.0921117829999, -17.85328541499996],
              [-143.0808813139999, -17.83757903399993],
              [-143.0722550119999, -17.84042734199994],
              [-143.0598852199999, -17.86581796699994],
              [-143.06029212099992, -17.86777109199994],
              [-143.06484941299993, -17.86370208099993],
              [-143.07022050699993, -17.85515715899993],
              [-143.0728246739999, -17.84433359199994],
              [-143.0776261059999, -17.852227471999925],
              [-143.08238684799994, -17.85751718499995],
              [-143.08714758999992, -17.858493747999944],
              [-143.0921117829999, -17.85328541499996],
            ],
          ],
          [
            [
              [-150.6552628249999, -17.668715101999908],
              [-150.6431778639999, -17.655450127999927],
              [-150.64032955599993, -17.66611093499995],
              [-150.64496822799993, -17.677992445999905],
              [-150.6552628249999, -17.668715101999908],
            ],
          ],
          [
            [
              [-141.4385473299999, -17.36809661299992],
              [-141.44249426999994, -17.360121351999908],
              [-141.4538468089999, -17.352308851999908],
              [-141.46743730399993, -17.348809502999927],
              [-141.48184160099993, -17.34856536299992],
              [-141.4607641269999, -17.344821872999944],
              [-141.44517981699994, -17.351739190999922],
              [-141.4362686839999, -17.367364190999922],
              [-141.4360652329999, -17.370700778999947],
              [-141.4353328119999, -17.383558851999908],
              [-141.43496660099993, -17.389336846999925],
              [-141.4368383449999, -17.385837497999944],
              [-141.4368383449999, -17.382745049999926],
              [-141.4385473299999, -17.36809661299992],
            ],
          ],
          [
            [
              [-138.4417211579999, -17.366387627999927],
              [-138.46141516799992, -17.36565520599993],
              [-138.46349036399994, -17.35995859199994],
              [-138.46373450399994, -17.356947523999906],
              [-138.4609268869999, -17.350355726999908],
              [-138.44692949099993, -17.332696221999925],
              [-138.42613684799994, -17.324883721999925],
              [-138.4549047519999, -17.349786065999922],
              [-138.4588110019999, -17.356866143999923],
              [-138.4578344389999, -17.358819268999923],
              [-138.4536840489999, -17.359551690999922],
              [-138.44774329299992, -17.361586195999905],
              [-138.4417211579999, -17.366387627999927],
            ],
          ],
          [
            [
              [-143.08482825399994, -17.004571221999925],
              [-143.0938207669999, -16.997979424999926],
              [-143.0977270169999, -16.994317315999922],
              [-143.10122636599993, -16.990166924999926],
              [-143.0904027989999, -16.98951588299991],
              [-143.07982337099992, -16.993340752999927],
              [-143.07017981699994, -17.000176690999922],
              [-143.0620011059999, -17.008965752999927],
              [-143.06753495999993, -17.010023695999905],
              [-143.07315019399994, -17.009372653999947],
              [-143.0789281889999, -17.007419528999947],
              [-143.08482825399994, -17.004571221999925],
            ],
          ],
          [
            [
              [-149.58360755099991, -16.987074476999908],
              [-149.57591712099992, -16.98365650799991],
              [-149.57209225199992, -16.982598565999922],
              [-149.5682266919999, -16.98219166499996],
              [-149.57233639199993, -16.987399997999944],
              [-149.58686275899993, -17.00042083099993],
              [-149.58698482999992, -16.99667734199994],
              [-149.58613033799992, -16.993584893999923],
              [-149.58360755099991, -16.987074476999908],
            ],
          ],
          [
            [
              [-153.9339900379999, -16.797539971999925],
              [-153.92853756399992, -16.806898695999905],
              [-153.92280025899993, -16.82089609199994],
              [-153.9201554029999, -16.83171965899993],
              [-153.92426510299993, -16.83180103999996],
              [-153.93321692599991, -16.819105726999908],
              [-153.9432266919999, -16.78753020599993],
              [-153.9506729809999, -16.77385833099993],
              [-153.94298255099991, -16.774590752999927],
              [-153.9377335279999, -16.779473565999922],
              [-153.93476314999992, -16.787367445999905],
              [-153.9339900379999, -16.797539971999925],
            ],
          ],
          [
            [
              [-144.2006729809999, -16.648370049999926],
              [-144.19810950399992, -16.642185153999947],
              [-144.18814042899993, -16.645684502999927],
              [-144.1766658189999, -16.655368747999944],
              [-144.1695857409999, -16.66725025799991],
              [-144.17784583199992, -16.66375090899993],
              [-144.1859024729999, -16.659356377999927],
              [-144.2006729809999, -16.648370049999926],
            ],
          ],
          [
            [
              [-152.24469967399992, -16.44378020599993],
              [-152.25629635299993, -16.45126718499995],
              [-152.26362057199992, -16.447198174999926],
              [-152.26146399599992, -16.44150155999995],
              [-152.24469967399992, -16.44378020599993],
            ],
          ],
          [
            [
              [-145.89891516799992, -15.888116143999923],
              [-145.95051021999993, -15.83961353999996],
              [-145.9142960279999, -15.863539320999905],
              [-145.89858964799993, -15.878350518999923],
              [-145.89891516799992, -15.888116143999923],
            ],
          ],
          [
            [
              [-140.8889867829999, -15.819756768999923],
              [-140.8614395819999, -15.815524997999944],
              [-140.8523656889999, -15.815524997999944],
              [-140.85985266799992, -15.819919528999947],
              [-140.8797094389999, -15.838311455999929],
              [-140.88902747299994, -15.837334893999923],
              [-140.89500891799992, -15.83294036299992],
              [-140.89561926999994, -15.826836846999925],
              [-140.8889867829999, -15.819756768999923],
            ],
          ],
          [
            [
              [-148.25084387899992, -15.867445570999905],
              [-148.2717179029999, -15.85320403399993],
              [-148.27936764199993, -15.830498955999929],
              [-148.27558346299992, -15.809991143999923],
              [-148.2620743479999, -15.80242278399993],
              [-148.25763912699992, -15.80787525799991],
              [-148.24616451699993, -15.831638278999947],
              [-148.2390030589999, -15.83961353999996],
              [-148.22992916599992, -15.848077080999929],
              [-148.23078365799992, -15.856866143999923],
              [-148.23871822799993, -15.863946221999925],
              [-148.25084387899992, -15.867445570999905],
            ],
          ],
          [
            [
              [-146.48664303299992, -15.803399346999925],
              [-146.4826554029999, -15.814873955999929],
              [-146.48167883999992, -15.820570570999905],
              [-146.4819229809999, -15.826918226999908],
              [-146.4905899729999, -15.80828215899993],
              [-146.49616451699993, -15.799493096999925],
              [-146.5030411449999, -15.791680596999925],
              [-146.49885006399992, -15.794040622999944],
              [-146.48664303299992, -15.803399346999925],
            ],
          ],
          [
            [
              [-154.52318274599992, -15.819431247999944],
              [-154.5206192699999, -15.808526299999926],
              [-154.5220841139999, -15.80046965899993],
              [-154.52753658799992, -15.794854424999926],
              [-154.5369766919999, -15.79225025799991],
              [-154.5247696609999, -15.789320570999905],
              [-154.51911373599992, -15.795586846999925],
              [-154.51728268099993, -15.80641041499996],
              [-154.5163468089999, -15.81731536299992],
              [-154.51923580599993, -15.823418877999927],
              [-154.52546139199993, -15.827732028999947],
              [-154.5287979809999, -15.827243747999944],
              [-154.52318274599992, -15.819431247999944],
            ],
          ],
          [
            [
              [-144.64981035099993, -15.73015715899993],
              [-144.6328018869999, -15.728448174999926],
              [-144.62193762899992, -15.73601653399993],
              [-144.62043209499993, -15.74700286299992],
              [-144.63133704299992, -15.755303643999923],
              [-144.64191646999993, -15.75514088299991],
              [-144.64891516799992, -15.74928150799991],
              [-144.6517227859999, -15.740166924999926],
              [-144.64981035099993, -15.73015715899993],
            ],
          ],
          [
            [
              [-145.45588131399992, -15.479587497999944],
              [-145.4439591139999, -15.479668877999927],
              [-145.4354141919999, -15.483005466999941],
              [-145.43268795499992, -15.488539320999905],
              [-145.4378555979999, -15.496351820999905],
              [-145.45734615799992, -15.48170338299991],
              [-145.52391516799992, -15.47047291499996],
              [-145.54963131399992, -15.45208098799992],
              [-145.48151607999992, -15.474786065999922],
              [-145.45588131399992, -15.479587497999944],
            ],
          ],
          [
            [
              [-146.19416256399992, -15.35947030999995],
              [-146.2029923169999, -15.388848565999922],
              [-146.19863847599993, -15.369805596999925],
              [-146.19615637899992, -15.347588799999926],
              [-146.19831295499992, -15.338718356999948],
              [-146.20360266799992, -15.331475518999923],
              [-146.2074275379999, -15.328627210999912],
              [-146.2171931629999, -15.323663018999923],
              [-146.2139786449999, -15.323093356999948],
              [-146.2049861319999, -15.327732028999947],
              [-146.2005509109999, -15.329685153999947],
              [-146.19668535099993, -15.33562590899993],
              [-146.19277910099993, -15.346286716999941],
              [-146.19416256399992, -15.35947030999995],
            ],
          ],
          [
            [
              [-146.62083899599992, -15.239841403999947],
              [-146.6390274729999, -15.232598565999922],
              [-146.62385006399992, -15.235039971999925],
              [-146.6117244129999, -15.24391041499996],
              [-146.60293535099993, -15.256931247999944],
              [-146.59776770699992, -15.27157968499995],
              [-146.6100968089999, -15.256442966999941],
              [-146.62083899599992, -15.239841403999947],
            ],
          ],
          [
            [
              [-147.2562556629999, -15.23251718499995],
              [-147.24225826699993, -15.232354424999926],
              [-147.2385147779999, -15.23528411299992],
              [-147.2374161449999, -15.24423593499995],
              [-147.24181067599991, -15.239027601999908],
              [-147.24620520699992, -15.236748955999929],
              [-147.2508845689999, -15.235039971999925],
              [-147.2562556629999, -15.23251718499995],
            ],
          ],
          [
            [
              [-147.7789607409999, -15.216403903999947],
              [-147.77407792899993, -15.213474216999941],
              [-147.76341712099992, -15.219414971999925],
              [-147.7499893869999, -15.228692315999922],
              [-147.73713131399992, -15.23528411299992],
              [-147.7789607409999, -15.216403903999947],
            ],
          ],
          [
            [
              [-147.4589737619999, -15.121351820999905],
              [-147.51203365799992, -15.080010674999926],
              [-147.53087317599991, -15.069024346999925],
              [-147.5108536449999, -15.07789478999996],
              [-147.49250240799992, -15.09107838299991],
              [-147.4589737619999, -15.121351820999905],
            ],
          ],
          [
            [
              [-147.93195553299992, -15.080824476999908],
              [-147.9343155589999, -15.076918226999908],
              [-147.9366755849999, -15.07390715899993],
              [-147.93781490799992, -15.070896091999941],
              [-147.93659420499992, -15.066338799999926],
              [-147.93195553299992, -15.080824476999908],
            ],
          ],
          [
            [
              [-145.92243404899992, -14.433770440999922],
              [-145.9327693349999, -14.43840911299992],
              [-145.9437149729999, -14.441827080999929],
              [-145.95490475199992, -14.443536065999922],
              [-145.9661759109999, -14.44312916499996],
              [-145.93321692599991, -14.43759530999995],
              [-145.92243404899992, -14.433770440999922],
            ],
          ],
          [
            [
              [-141.1745499339999, -14.189629815999922],
              [-141.1795141269999, -14.196465752999927],
              [-141.1892797519999, -14.190199476999908],
              [-141.21279863199993, -14.16497161299992],
              [-141.20274817599994, -14.170179945999905],
              [-141.1745499339999, -14.189629815999922],
            ],
          ],
          [
            [
              [-147.72423255099991, -23.871758721999925],
              [-147.72423255099991, -23.86492278399993],
              [-147.70588131399992, -23.858575127999927],
              [-147.68797766799992, -23.854587497999944],
              [-147.64785722599993, -23.851820570999905],
              [-147.65123450399992, -23.858575127999927],
              [-147.65587317599991, -23.86386484199994],
              [-147.6617732409999, -23.86809661299992],
              [-147.6689346999999, -23.871758721999925],
              [-147.69896399599992, -23.878024997999944],
              [-147.71263587099992, -23.877211195999905],
              [-147.72423255099991, -23.871758721999925],
            ],
          ],
          [
            [
              [-149.48167883999992, -23.35784270599993],
              [-149.45649166599992, -23.36532968499995],
              [-149.45091712099992, -23.381117445999905],
              [-149.4632462229999, -23.39576588299991],
              [-149.5078018869999, -23.40048593499995],
              [-149.51874752499992, -23.39495208099993],
              [-149.5247696609999, -23.383965752999927],
              [-149.5267227859999, -23.36809661299992],
              [-149.52143307199992, -23.362725518999923],
              [-149.5089005199999, -23.359551690999922],
              [-149.48167883999992, -23.35784270599993],
            ],
          ],
          [
            [
              [-135.0193578769999, -23.11760833099993],
              [-134.99795488199993, -23.116306247999944],
              [-134.96548417899993, -23.090508721999925],
              [-134.94298255099994, -23.083591403999947],
              [-134.95055091099994, -23.09693775799991],
              [-134.98452714799993, -23.13876718499995],
              [-134.99522864499994, -23.13713958099993],
              [-135.00454667899993, -23.133884372999944],
              [-135.0193578769999, -23.12509530999995],
              [-135.0193578769999, -23.11760833099993],
            ],
          ],
          [
            [
              [-151.38687089799993, -22.42245859199994],
              [-151.3776749339999, -22.423272393999923],
              [-151.36750240799992, -22.43417734199994],
              [-151.3592423169999, -22.447523695999905],
              [-151.35590572799993, -22.456638278999947],
              [-151.35749264199993, -22.48170338299991],
              [-151.36274166599992, -22.508070570999905],
              [-151.36872311099992, -22.513116143999923],
              [-151.37177486899992, -22.514418226999908],
              [-151.3763321609999, -22.514336846999925],
              [-151.38044186099992, -22.48870208099993],
              [-151.39110266799992, -22.46453215899993],
              [-151.39704342399992, -22.442152601999908],
              [-151.38687089799993, -22.42245859199994],
            ],
          ],
          [
            [
              [-140.6719457669999, -21.658949476999908],
              [-140.65318762899994, -21.64706796699994],
              [-140.63418535099993, -21.660821221999925],
              [-140.60366777299993, -21.70680103999996],
              [-140.63052324099993, -21.72161223799992],
              [-140.6582738919999, -21.71266041499996],
              [-140.6757706369999, -21.688897393999923],
              [-140.6719457669999, -21.658949476999908],
            ],
          ],
          [
            [
              [-140.6787817049999, -17.780368747999944],
              [-140.72716223899994, -17.80706145599993],
              [-140.7580460279999, -17.831638278999947],
              [-140.7852270169999, -17.858575127999927],
              [-140.7959692049999, -17.862725518999923],
              [-140.81212317599994, -17.86305103999996],
              [-140.82778886599993, -17.860121351999908],
              [-140.83702551999994, -17.85475025799991],
              [-140.8386938139999, -17.84343840899993],
              [-140.8342992829999, -17.830010674999926],
              [-140.82274329299992, -17.80706145599993],
              [-140.8023168609999, -17.786553643999923],
              [-140.78246008999992, -17.75164153399993],
              [-140.74583899599992, -17.729587497999944],
              [-140.6719457669999, -17.69784921699994],
              [-140.65208899599992, -17.68417734199994],
              [-140.62466386599993, -17.68726978999996],
              [-140.6198624339999, -17.70671965899993],
              [-140.6284887359999, -17.728448174999926],
              [-140.64830481699994, -17.74391041499996],
              [-140.6787817049999, -17.780368747999944],
            ],
          ],
          [
            [
              [-149.1834610669999, -17.731215101999908],
              [-149.16063391799992, -17.756931247999944],
              [-149.14911861899992, -17.80201588299991],
              [-149.15644283799992, -17.84628671699994],
              [-149.19029700399992, -17.869073174999926],
              [-149.2064102859999, -17.866631768999923],
              [-149.2608536449999, -17.851739190999922],
              [-149.27594967399992, -17.844903252999927],
              [-149.30866451699993, -17.80364348799992],
              [-149.33429928299992, -17.759209893999923],
              [-149.34345455599993, -17.724867445999905],
              [-149.34797115799992, -17.718194268999923],
              [-149.35753333199992, -17.717868747999944],
              [-149.36253821499992, -17.725274346999925],
              [-149.3662003249999, -17.734307549999926],
              [-149.3718155589999, -17.73870208099993],
              [-149.39191646999993, -17.741387627999927],
              [-149.45038814999992, -17.759209893999923],
              [-149.4720352859999, -17.760511976999908],
              [-149.48786373599992, -17.757989190999922],
              [-149.51923580599993, -17.74618905999995],
              [-149.57612057199992, -17.73756275799991],
              [-149.58751380099991, -17.731215101999908],
              [-149.60505123599992, -17.671807549999926],
              [-149.61176510299993, -17.66301848799992],
              [-149.62120520699992, -17.656182549999926],
              [-149.63097083199992, -17.639336846999925],
              [-149.6386612619999, -17.61891041499996],
              [-149.64216061099992, -17.60084400799991],
              [-149.63276119699992, -17.553399346999925],
              [-149.60431881399992, -17.52581145599993],
              [-149.56407630099991, -17.510023695999905],
              [-149.51923580599993, -17.49846770599993],
              [-149.4749649729999, -17.494073174999926],
              [-149.42951412699992, -17.501560153999947],
              [-149.38764400899993, -17.51799895599993],
              [-149.3541153639999, -17.540134372999944],
              [-149.34406490799992, -17.550713799999926],
              [-149.33556067599991, -17.564060153999947],
              [-149.32966061099992, -17.57984791499996],
              [-149.32746334499993, -17.597832940999922],
              [-149.33027096299992, -17.66375090899993],
              [-149.32746334499993, -17.68417734199994],
              [-149.30394446499992, -17.712090752999927],
              [-149.26329505099991, -17.722832940999922],
              [-149.1834610669999, -17.731215101999908],
            ],
          ],
          [
            [
              [-149.79670162699992, -17.464450778999947],
              [-149.7861221999999, -17.468926690999922],
              [-149.78563391799992, -17.479180596999925],
              [-149.80475826699993, -17.523370049999926],
              [-149.82245846299992, -17.54973723799992],
              [-149.8427628249999, -17.567559502999927],
              [-149.86188717399992, -17.56682708099993],
              [-149.88520260299993, -17.555352471999925],
              [-149.9140518869999, -17.535332940999922],
              [-149.9374893869999, -17.512465101999908],
              [-149.94440670499992, -17.492364190999922],
              [-149.93407141799992, -17.481540622999944],
              [-149.9155167309999, -17.47356536299992],
              [-149.89777584499993, -17.472263278999947],
              [-149.88984127499992, -17.481540622999944],
              [-149.8858536449999, -17.491794528999947],
              [-149.87763424399992, -17.49195728999996],
              [-149.86998450399992, -17.487725518999923],
              [-149.86811275899993, -17.48495859199994],
              [-149.86021887899992, -17.483168226999908],
              [-149.85362708199992, -17.479180596999925],
              [-149.84581458199992, -17.477959893999923],
              [-149.8345841139999, -17.48495859199994],
              [-149.83165442599991, -17.47275155999995],
              [-149.82310950399992, -17.46656666499996],
              [-149.81086178299992, -17.46461353999996],
              [-149.79670162699992, -17.464450778999947],
            ],
          ],
          [
            [
              [-151.00580807199992, -16.76921965899993],
              [-151.00239010299993, -16.760837497999944],
              [-150.99433346299992, -16.761895440999922],
              [-150.9853409499999, -16.76921965899993],
              [-150.9791153639999, -16.77971770599993],
              [-150.9783829419999, -16.78801848799992],
              [-150.97956295499992, -16.800388278999947],
              [-150.9838761059999, -16.809258721999925],
              [-150.9927872389999, -16.80706145599993],
              [-150.99482174399992, -16.813571872999944],
              [-150.99889075399992, -16.817966403999947],
              [-151.0049942699999, -16.82040780999995],
              [-151.01325436099992, -16.82073333099993],
              [-151.03136145699992, -16.80632903399993],
              [-151.03758704299992, -16.799574476999908],
              [-151.03990637899992, -16.78997161299992],
              [-151.03461666599992, -16.77703215899993],
              [-151.02289791599992, -16.772881768999923],
              [-151.0110977859999, -16.772149346999925],
              [-151.00580807199992, -16.76921965899993],
            ],
          ],
          [
            [
              [-151.4787491529999, -16.738213799999926],
              [-151.46467037699992, -16.73642343499995],
              [-151.44652258999992, -16.740492445999905],
              [-151.4307755199999, -16.74781666499996],
              [-151.42414303299992, -16.755303643999923],
              [-151.41279049399992, -16.77971770599993],
              [-151.35248775899993, -16.858575127999927],
              [-151.36408443899992, -16.86646900799991],
              [-151.40086829299992, -16.88534921699994],
              [-151.4139298169999, -16.888929945999905],
              [-151.42426510299993, -16.881931247999944],
              [-151.42939205599993, -16.881931247999944],
              [-151.43158932199992, -16.892185153999947],
              [-151.43415279899992, -16.897637627999927],
              [-151.4405411449999, -16.901136976999908],
              [-151.44916744699992, -16.90292734199994],
              [-151.45824133999992, -16.902601820999905],
              [-151.4778946609999, -16.88958098799992],
              [-151.48810787699992, -16.85637786299992],
              [-151.4947403639999, -16.76458098799992],
              [-151.4912003249999, -16.750258070999905],
              [-151.4787491529999, -16.738213799999926],
            ],
          ],
          [
            [
              [-151.0262751939999, -16.708103122999944],
              [-151.00755774599992, -16.740492445999905],
              [-151.00951087099992, -16.745700778999947],
              [-151.0163468089999, -16.748711846999925],
              [-151.0241593089999, -16.75562916499996],
              [-151.0341690749999, -16.76262786299992],
              [-151.04743404899992, -16.76604583099993],
              [-151.05321204299992, -16.75359465899993],
              [-151.05402584499993, -16.741794528999947],
              [-151.0515030589999, -16.730075778999947],
              [-151.04222571499992, -16.70549895599993],
              [-151.0351456369999, -16.69426848799992],
              [-151.02900143099993, -16.692478122999944],
              [-151.0262751939999, -16.708103122999944],
            ],
          ],
          [
            [
              [-151.45824133999992, -16.62900155999995],
              [-151.45982825399992, -16.66106536299992],
              [-151.4632462229999, -16.674086195999905],
              [-151.47260494699992, -16.669854424999926],
              [-151.48053951699993, -16.66497161299992],
              [-151.5346573559999, -16.641696872999944],
              [-151.5403946609999, -16.63648853999996],
              [-151.5408829419999, -16.631036065999922],
              [-151.5361221999999, -16.594903252999927],
              [-151.52375240799992, -16.58294036299992],
              [-151.5026749339999, -16.58017343499995],
              [-151.47260494699992, -16.58049895599993],
              [-151.4765518869999, -16.590508721999925],
              [-151.4787491529999, -16.59417083099993],
              [-151.4595841139999, -16.59343840899993],
              [-151.4495743479999, -16.59465911299992],
              [-151.44526119699992, -16.597588799999926],
              [-151.4439591139999, -16.602227471999925],
              [-151.43871008999992, -16.609307549999926],
              [-151.43781490799992, -16.614678643999923],
              [-151.44115149599992, -16.619805596999925],
              [-151.44819088399993, -16.624200127999927],
              [-151.45824133999992, -16.62900155999995],
            ],
          ],
          [
            [
              [-151.7804255849999, -16.478122653999947],
              [-151.76378333199992, -16.47234465899993],
              [-151.75361080599993, -16.483819268999923],
              [-151.74836178299992, -16.50432708099993],
              [-151.74693762899992, -16.52597421699994],
              [-151.76264400899993, -16.52581145599993],
              [-151.7768448559999, -16.51181405999995],
              [-151.78449459499993, -16.492933851999908],
              [-151.7804255849999, -16.478122653999947],
            ],
          ],
          [
            [
              [-146.38727779899992, -16.108168226999908],
              [-146.3593643869999, -16.10019296699994],
              [-146.33771725199992, -16.11337655999995],
              [-146.32876542899993, -16.13762786299992],
              [-146.3388565749999, -16.162774346999925],
              [-146.3670955069999, -16.15878671699994],
              [-146.3917537099999, -16.147230726999908],
              [-146.40208899599992, -16.129978122999944],
              [-146.38727779899992, -16.108168226999908],
            ],
          ],
          [
            [
              [-138.6988012359999, -10.426446221999925],
              [-138.66519120999993, -10.427341403999947],
              [-138.6504613919999, -10.43141041499996],
              [-138.6367081369999, -10.440606377999927],
              [-138.6204320949999, -10.471856377999927],
              [-138.62022864499994, -10.510837497999944],
              [-138.6369522779999, -10.542168877999927],
              [-138.67149817599994, -10.55046965899993],
              [-138.6856176419999, -10.542087497999944],
              [-138.6934301419999, -10.526136976999908],
              [-138.69444739499994, -10.50790780999995],
              [-138.67959550699993, -10.47356536299992],
              [-138.6816300119999, -10.45826588299991],
              [-138.6988012359999, -10.426446221999925],
            ],
          ],
          [
            [
              [-139.08238684799994, -9.899509372999944],
              [-139.0691625639999, -9.903903903999947],
              [-139.0556534499999, -9.913181247999944],
              [-139.04775956899994, -9.922539971999925],
              [-139.0513402989999, -9.92669036299992],
              [-139.0550024079999, -9.928399346999925],
              [-139.0576065749999, -9.932386976999908],
              [-139.05972245999993, -9.937107028999947],
              [-139.06187903599994, -9.94036223799992],
              [-139.0666397779999, -9.943291924999926],
              [-139.07664954299992, -9.94459400799991],
              [-139.08238684799994, -9.947198174999926],
              [-139.09585527299993, -9.961683851999908],
              [-139.1184789699999, -10.000176690999922],
              [-139.13076738199993, -10.01490650799991],
              [-139.1438695949999, -9.99781666499996],
              [-139.1426895819999, -9.978936455999929],
              [-139.1389867829999, -9.959405205999929],
              [-139.14443925699993, -9.94036223799992],
              [-139.1338598299999, -9.928317966999941],
              [-139.1206762359999, -9.90439218499995],
              [-139.1038305329999, -9.888278903999947],
              [-139.08238684799994, -9.899509372999944],
            ],
          ],
          [
            [
              [-138.83657792899993, -9.74114348799992],
              [-138.8140356109999, -9.73951588299991],
              [-138.81847083199995, -9.748711846999925],
              [-138.86925208199995, -9.791599216999941],
              [-138.8920792309999, -9.800713799999926],
              [-138.91661536399994, -9.806573174999926],
              [-138.95567786399994, -9.809991143999923],
              [-139.00942949099993, -9.809014580999929],
              [-139.02090410099993, -9.80632903399993],
              [-139.02623450399994, -9.803399346999925],
              [-139.03799394399994, -9.80242278399993],
              [-139.04971269399994, -9.803480726999908],
              [-139.05504309799994, -9.80632903399993],
              [-139.05504309799994, -9.837334893999923],
              [-139.06191972599993, -9.853936455999929],
              [-139.0713598299999, -9.85475025799991],
              [-139.0855199859999, -9.848809502999927],
              [-139.1262914699999, -9.840101820999905],
              [-139.14346269399994, -9.828871351999908],
              [-139.15689042899993, -9.815199476999908],
              [-139.16490637899994, -9.803317966999941],
              [-139.17031816299993, -9.790134372999944],
              [-139.17324785099993, -9.774183851999908],
              [-139.1694229809999, -9.76100025799991],
              [-139.13841712099992, -9.75090911299992],
              [-139.05138098899994, -9.701429945999905],
              [-139.01537024599992, -9.694431247999944],
              [-138.98452714799993, -9.699476820999905],
              [-138.97252356699994, -9.720635674999926],
              [-138.96129309799994, -9.733819268999923],
              [-138.94273841099994, -9.742364190999922],
              [-138.9212133449999, -9.747165622999944],
              [-138.90078691299993, -9.748630466999941],
              [-138.8769425119999, -9.754327080999929],
              [-138.8666886059999, -9.755466403999947],
              [-138.8554581369999, -9.753513278999947],
              [-138.84801184799994, -9.74895598799992],
              [-138.8423559239999, -9.74423593499995],
              [-138.83657792899993, -9.74114348799992],
            ],
          ],
          [
            [
              [-140.0767309239999, -9.323418877999927],
              [-140.05386308499993, -9.346286716999941],
              [-140.04141191299993, -9.351006768999923],
              [-140.02769934799994, -9.343926690999922],
              [-140.04063880099994, -9.374118747999944],
              [-140.0489395819999, -9.408135674999926],
              [-140.06289628799993, -9.435967705999929],
              [-140.0928442049999, -9.447523695999905],
              [-140.1113988919999, -9.437758070999905],
              [-140.15859941299993, -9.371840101999908],
              [-140.1394750639999, -9.357842705999929],
              [-140.12144934799994, -9.340264580999929],
              [-140.1016332669999, -9.32626718499995],
              [-140.0767309239999, -9.323418877999927],
            ],
          ],
          [
            [
              [-139.5143936839999, -8.883965752999927],
              [-139.50316321499992, -8.899021091999941],
              [-139.50841223899994, -8.912041924999926],
              [-139.5234268869999, -8.92156340899993],
              [-139.54165605399993, -8.926202080999929],
              [-139.58560136599993, -8.92945728999996],
              [-139.6030981109999, -8.936944268999923],
              [-139.6167699859999, -8.954196872999944],
              [-139.61270097599993, -8.93922291499996],
              [-139.61803137899994, -8.924981377999927],
              [-139.62621008999992, -8.910821221999925],
              [-139.6304418609999, -8.89544036299992],
              [-139.59691321499992, -8.858005466999941],
              [-139.58946692599994, -8.858005466999941],
              [-139.5823461579999, -8.86891041499996],
              [-139.5744522779999, -8.870212497999944],
              [-139.5584203769999, -8.864678643999923],
              [-139.5469864569999, -8.867120049999926],
              [-139.5143936839999, -8.883965752999927],
            ],
          ],
          [
            [
              [-140.04942786399994, -8.82317473799992],
              [-140.0222875639999, -8.846774997999944],
              [-140.01598059799994, -8.859307549999926],
              [-140.01402747299994, -8.881117445999905],
              [-140.01915442599994, -8.896416924999926],
              [-140.0313207669999, -8.894463799999926],
              [-140.05557206899994, -8.878513278999947],
              [-140.0605362619999, -8.899997653999947],
              [-140.07664954299992, -8.915215752999927],
              [-140.0960180329999, -8.919040622999944],
              [-140.11021887899994, -8.905694268999923],
              [-140.11766516799992, -8.905694268999923],
              [-140.12999426999994, -8.916436455999929],
              [-140.1699112619999, -8.92945728999996],
              [-140.1785375639999, -8.93678150799991],
              [-140.18321692599994, -8.953708591999941],
              [-140.1943253249999, -8.950372002999927],
              [-140.2070206369999, -8.939385674999926],
              [-140.22769120999993, -8.92701588299991],
              [-140.23477128799993, -8.912855726999908],
              [-140.2451879549999, -8.86687590899993],
              [-140.24742591099994, -8.84734465899993],
              [-140.2495824859999, -8.838636976999908],
              [-140.25894120999993, -8.830498955999929],
              [-140.2610570949999, -8.82317473799992],
              [-140.24779212099992, -8.78687916499996],
              [-140.21670488199993, -8.78101978999996],
              [-140.08971106699994, -8.80201588299991],
              [-140.05899003799993, -8.80201588299991],
              [-140.05142167899993, -8.80046965899993],
              [-140.0374242829999, -8.79225025799991],
              [-140.02769934799994, -8.788995049999926],
              [-140.02774003799993, -8.793715101999908],
              [-140.0295304029999, -8.796482028999947],
              [-140.0322159499999, -8.798760674999926],
              [-140.03941809799994, -8.807061455999929],
              [-140.04942786399994, -8.82317473799992],
            ],
          ],
          [
            [
              [-140.6924535799999, -8.015069268999923],
              [-140.69888261599993, -8.02898528399993],
              [-140.7078344389999, -8.039727471999925],
              [-140.7177628249999, -8.041273695999905],
              [-140.72716223899994, -8.028090101999908],
              [-140.72777258999992, -7.99146900799991],
              [-140.7063695949999, -7.963067315999922],
              [-140.6731664699999, -7.950127862999921],
              [-140.63841712099992, -7.959730726999908],
              [-140.6530655589999, -7.970798434999949],
              [-140.6583145819999, -7.973402601999908],
              [-140.67564856699994, -7.976739190999922],
              [-140.6839086579999, -7.985284112999921],
              [-140.6924535799999, -8.015069268999923],
            ],
          ],
          [
            [
              [-144.28376217399992, -27.579196872999944],
              [-144.2882380849999, -27.584242445999905],
              [-144.30134029899992, -27.59539153399993],
              [-144.3041886059999, -27.59970468499995],
              [-144.30353756399992, -27.60051848799992],
              [-144.3002823559999, -27.62004973799992],
              [-144.29743404899992, -27.62078215899993],
              [-144.30443274599992, -27.632419528999947],
              [-144.3127335279999, -27.640069268999923],
              [-144.32363847599993, -27.64120859199994],
              [-144.33836829299992, -27.63372161299992],
              [-144.3465876939999, -27.61532968499995],
              [-144.34797115799992, -27.585544528999947],
              [-144.33942623599992, -27.559258721999925],
              [-144.3178604809999, -27.55120208099993],
              [-144.29816646999993, -27.56292083099993],
              [-144.2899470689999, -27.570082289999903],
              [-144.28376217399992, -27.579196872999944],
            ],
          ],
          [
            [
              [-138.8495987619999, -21.871270440999922],
              [-138.9321996739999, -21.871270440999922],
              [-138.91185462099992, -21.863946221999925],
              [-138.8915909499999, -21.865899346999925],
              [-138.87096106699994, -21.87037525799991],
              [-138.8495987619999, -21.871270440999922],
            ],
          ],
          [
            [
              [-135.45750891799992, -21.528008721999925],
              [-135.52578691299993, -21.487074476999908],
              [-135.50377356699994, -21.48951588299991],
              [-135.4849340489999, -21.496840101999908],
              [-135.46934973899994, -21.50945403399993],
              [-135.45750891799992, -21.528008721999925],
            ],
          ],
          [
            [
              [-138.53490149599992, -20.876885674999926],
              [-138.51943925699993, -20.860935153999947],
              [-138.51732337099992, -20.849216403999947],
              [-138.54072018099993, -20.789727471999925],
              [-138.54466712099992, -20.784681898999906],
              [-138.5501195949999, -20.78256601399994],
              [-138.5684301419999, -20.788181247999944],
              [-138.5642797519999, -20.78484465899993],
              [-138.55435136599993, -20.78093840899993],
              [-138.5488988919999, -20.779961846999925],
              [-138.54263261599993, -20.780368747999944],
              [-138.5197647779999, -20.81454843499995],
              [-138.51284745999993, -20.857679945999905],
              [-138.53490149599992, -20.876885674999926],
            ],
          ],
          [
            [
              [-136.31407630099994, -18.56731536299992],
              [-136.3135473299999, -18.565606377999927],
              [-136.3127335279999, -18.56096770599993],
              [-136.31309973899994, -18.554294528999947],
              [-136.31607011599993, -18.546319268999923],
              [-136.32213294199994, -18.53875090899993],
              [-136.33128821499992, -18.532647393999923],
              [-136.34365800699993, -18.52743905999995],
              [-136.37389075399994, -18.518649997999944],
              [-136.38296464799993, -18.514743747999944],
              [-136.38902747299994, -18.51018645599993],
              [-136.39427649599992, -18.504082940999922],
              [-136.4026586579999, -18.49667734199994],
              [-136.44888261599993, -18.471856377999927],
              [-136.4612524079999, -18.468682549999926],
              [-136.46544348899994, -18.47429778399993],
              [-136.46519934799994, -18.48211028399993],
              [-136.46426347599993, -18.48601653399993],
              [-136.4677628249999, -18.481866143999923],
              [-136.46996008999992, -18.47779713299991],
              [-136.4728897779999, -18.47429778399993],
              [-136.4785863919999, -18.471856377999927],
              [-136.45872962099992, -18.464288018999923],
              [-136.42613684799994, -18.475355726999908],
              [-136.3958227199999, -18.49423593499995],
              [-136.3823949859999, -18.509942315999922],
              [-136.33043372299994, -18.527601820999905],
              [-136.3047582669999, -18.545668226999908],
              [-136.31407630099994, -18.56731536299992],
            ],
          ],
          [
            [
              [-140.6719457669999, -18.417168877999927],
              [-140.6748347649999, -18.41375090899993],
              [-140.6809789699999, -18.402276299999926],
              [-140.6951391269999, -18.39039478999996],
              [-140.7520645819999, -18.363946221999925],
              [-140.7700902989999, -18.350274346999925],
              [-140.7792862619999, -18.33953215899993],
              [-140.7818090489999, -18.33521900799991],
              [-140.7561742829999, -18.353692315999922],
              [-140.6870824859999, -18.390557549999926],
              [-140.67861894399994, -18.403008721999925],
              [-140.6719457669999, -18.417168877999927],
            ],
          ],
          [
            [
              [-136.9714249339999, -18.36191171699994],
              [-137.06761633999992, -18.266289971999925],
              [-137.04234778599994, -18.277601820999905],
              [-137.01024329299992, -18.30437590899993],
              [-136.98277747299994, -18.335870049999926],
              [-136.9714249339999, -18.36191171699994],
            ],
          ],
          [
            [
              [-140.82274329299992, -18.217950127999927],
              [-140.8483780589999, -18.18254973799992],
              [-140.8954971999999, -18.14902109199994],
              [-140.9180395169999, -18.108168226999908],
              [-140.93028723899994, -18.095635674999926],
              [-140.9736221999999, -18.06023528399993],
              [-140.96446692599994, -18.066582940999922],
              [-140.92516028599994, -18.084730726999908],
              [-140.8985082669999, -18.129082940999922],
              [-140.87730872299994, -18.150567315999922],
              [-140.85130774599992, -18.169528903999947],
              [-140.82994544199994, -18.19036223799992],
              [-140.82274329299992, -18.217950127999927],
            ],
          ],
          [
            [
              [-142.5774633449999, -17.621351820999905],
              [-142.5651749339999, -17.60165780999995],
              [-142.63951575399994, -17.532647393999923],
              [-142.61245683499993, -17.54697030999995],
              [-142.5776261059999, -17.571709893999923],
              [-142.5581762359999, -17.599216403999947],
              [-142.5774633449999, -17.621351820999905],
            ],
          ],
          [
            [
              [-143.4135636059999, -17.456963799999926],
              [-143.43785559799994, -17.438897393999923],
              [-143.47496497299994, -17.43027109199994],
              [-143.4566137359999, -17.429294528999947],
              [-143.43765214799993, -17.433200778999947],
              [-143.42202714799993, -17.442152601999908],
              [-143.4135636059999, -17.456963799999926],
            ],
          ],
          [
            [
              [-145.38048255099991, -17.48495859199994],
              [-145.43512936099992, -17.417168877999927],
              [-145.4194229809999, -17.426934502999927],
              [-145.40558834499993, -17.442966403999947],
              [-145.38048255099991, -17.48495859199994],
            ],
          ],
          [
            [
              [-145.5784805979999, -17.383070570999905],
              [-145.58649654899992, -17.37037525799991],
              [-145.59137936099992, -17.357679945999905],
              [-145.5934138659999, -17.34303150799991],
              [-145.5928848949999, -17.32480234199994],
              [-145.5784805979999, -17.383070570999905],
            ],
          ],
          [
            [
              [-143.3862198559999, -16.669854424999926],
              [-143.45400956899994, -16.624607028999947],
              [-143.5061742829999, -16.627129815999922],
              [-143.55068925699993, -16.622165622999944],
              [-143.46475175699993, -16.614678643999923],
              [-143.44058183499993, -16.62078215899993],
              [-143.42027747299994, -16.63567473799992],
              [-143.3862198559999, -16.669854424999926],
            ],
          ],
          [
            [
              [-143.57115637899994, -16.635837497999944],
              [-143.62035071499992, -16.632012627999927],
              [-143.66006425699993, -16.602227471999925],
              [-143.70152747299994, -16.58049895599993],
              [-143.6662491529999, -16.58847421699994],
              [-143.60952714799993, -16.629978122999944],
              [-143.57115637899994, -16.635837497999944],
            ],
          ],
          [
            [
              [-143.81761633999992, -16.53964609199994],
              [-143.82144120999993, -16.53769296699994],
              [-143.84874426999994, -16.492933851999908],
              [-143.87979081899994, -16.469414971999925],
              [-143.91397050699993, -16.457370700999945],
              [-143.93423417899993, -16.450290622999944],
              [-143.93032792899993, -16.449965101999908],
              [-143.91034908799992, -16.455336195999905],
              [-143.8775121739999, -16.459730726999908],
              [-143.86196855399993, -16.46721770599993],
              [-143.8327530589999, -16.49846770599993],
              [-143.8229874339999, -16.516371351999908],
              [-143.81761633999992, -16.53964609199994],
            ],
          ],
          [
            [
              [-144.2564591139999, -16.478122653999947],
              [-144.25865637899992, -16.457696221999925],
              [-144.2608536449999, -16.45086028399993],
              [-144.29116777299993, -16.41611093499995],
              [-144.27570553299992, -16.42555103999996],
              [-144.2601212229999, -16.44231536299992],
              [-144.2513321609999, -16.46135833099993],
              [-144.2564591139999, -16.478122653999947],
            ],
          ],
          [
            [
              [-144.37311764199993, -16.34042734199994],
              [-144.4061173169999, -16.329196872999944],
              [-144.4260147779999, -16.332777601999908],
              [-144.4345596999999, -16.319919528999947],
              [-144.4283341139999, -16.320570570999905],
              [-144.42715410099993, -16.322442315999922],
              [-144.4277237619999, -16.32659270599993],
              [-144.41222083199992, -16.32122161299992],
              [-144.3961482409999, -16.324476820999905],
              [-144.3823136059999, -16.332289320999905],
              [-144.37311764199993, -16.34042734199994],
            ],
          ],
          [
            [
              [-145.4822891919999, -16.347832940999922],
              [-145.50226803299992, -16.336602471999925],
              [-145.52961178299992, -16.279473565999922],
              [-145.5531306629999, -16.252129815999922],
              [-145.5767716139999, -16.202569268999923],
              [-145.59040279899992, -16.15162525799991],
              [-145.6065567699999, -16.12932708099993],
              [-145.6138809889999, -16.080254815999922],
              [-145.61095130099991, -16.09734465899993],
              [-145.60358639199993, -16.120293877999927],
              [-145.59337317599991, -16.14039478999996],
              [-145.58218339799993, -16.149102471999925],
              [-145.5771378249999, -16.160821221999925],
              [-145.5682673819999, -16.21257903399993],
              [-145.56208248599992, -16.22429778399993],
              [-145.5591934889999, -16.23300546699994],
              [-145.5170792309999, -16.278903903999947],
              [-145.49396725199992, -16.33521900799991],
              [-145.4822891919999, -16.347832940999922],
            ],
          ],
          [
            [
              [-145.6138809889999, -16.052911065999922],
              [-145.7088516919999, -16.060479424999926],
              [-145.6575821609999, -16.042575778999947],
              [-145.6312556629999, -16.03834400799991],
              [-145.6138809889999, -16.052911065999922],
            ],
          ],
          [
            [
              [-142.52965247299994, -16.108168226999908],
              [-142.52208411399994, -16.084161065999922],
              [-142.5097550119999, -16.05901458099993],
              [-142.49526933499993, -16.036309502999927],
              [-142.4812719389999, -16.01881275799991],
              [-142.52965247299994, -16.108168226999908],
            ],
          ],
          [
            [
              [-140.11021887899994, -15.977227471999925],
              [-140.1171768869999, -15.961683851999908],
              [-140.14321855399993, -15.960544528999947],
              [-140.17227128799993, -15.977227471999925],
              [-140.1516820949999, -15.957696221999925],
              [-140.12547766799992, -15.953301690999922],
              [-140.10708574099993, -15.96062590899993],
              [-140.11021887899994, -15.977227471999925],
            ],
          ],
          [
            [
              [-145.16759192599991, -15.95045338299991],
              [-145.23591061099992, -15.88844166499996],
              [-145.21996008999992, -15.898370049999926],
              [-145.16759192599991, -15.95045338299991],
            ],
          ],
          [
            [
              [-145.0577286449999, -15.90211353999996],
              [-145.07648678299992, -15.85865650799991],
              [-145.1298721999999, -15.778008721999925],
              [-145.1607559889999, -15.758070570999905],
              [-145.13361568899992, -15.763116143999923],
              [-145.1175430979999, -15.780694268999923],
              [-145.0925186839999, -15.826348565999922],
              [-145.0670059889999, -15.85637786299992],
              [-145.05870520699992, -15.87590911299992],
              [-145.0577286449999, -15.90211353999996],
            ],
          ],
          [
            [
              [-148.04576575399992, -14.99773528399993],
              [-148.05431067599991, -14.984633070999905],
              [-148.0662735669999, -14.971123955999929],
              [-148.0843399729999, -14.955010674999926],
              [-148.1107071609999, -14.94036223799992],
              [-148.17609615799992, -14.922051690999922],
              [-148.13410396999993, -14.925225518999923],
              [-148.08906002499992, -14.93678150799991],
              [-148.05500240799992, -14.95989348799992],
              [-148.04576575399992, -14.99773528399993],
            ],
          ],
          [
            [
              [-148.62800045499992, -14.894707940999922],
              [-148.6479386059999, -14.871758721999925],
              [-148.69066321499992, -14.853773695999905],
              [-148.66771399599992, -14.856622002999927],
              [-148.64057369699992, -14.86492278399993],
              [-148.62275143099993, -14.87786223799992],
              [-148.62800045499992, -14.894707940999922],
            ],
          ],
          [
            [
              [-145.19493567599991, -14.662041924999926],
              [-145.2054337229999, -14.675225518999923],
              [-145.22297115799992, -14.68840911299992],
              [-145.2427872389999, -14.698418877999927],
              [-145.26040605399993, -14.702325127999927],
              [-145.2639054029999, -14.690118096999925],
              [-145.25324459499993, -14.663181247999944],
              [-145.2296443349999, -14.62037525799991],
              [-145.24982662699992, -14.670668226999908],
              [-145.2547908189999, -14.693291924999926],
              [-145.2335098949999, -14.688246351999908],
              [-145.19493567599991, -14.662041924999926],
            ],
          ],
          [
            [
              [-146.25690670499992, -14.497491143999923],
              [-146.2457576159999, -14.476006768999923],
              [-146.23949133999992, -14.455824476999908],
              [-146.2711482409999, -14.435479424999926],
              [-146.2432755199999, -14.43922291499996],
              [-146.23176021999993, -14.45680103999996],
              [-146.2363175119999, -14.479180596999925],
              [-146.25690670499992, -14.497491143999923],
            ],
          ],
          [
            [
              [-145.0030818349999, -14.511163018999923],
              [-144.95466061099992, -14.463474216999941],
              [-144.91071529899992, -14.43954843499995],
              [-144.8880509109999, -14.418145440999922],
              [-144.9131973949999, -14.428155205999929],
              [-144.95588131399992, -14.432061455999929],
              [-145.0030818349999, -14.442966403999947],
              [-144.9850968089999, -14.432305596999925],
              [-144.96231035099993, -14.426202080999929],
              [-144.91779537699992, -14.422458591999941],
              [-144.8973689439999, -14.412286065999922],
              [-144.88508053299992, -14.40797291499996],
              [-144.8796280589999, -14.41179778399993],
              [-144.88060462099992, -14.422133070999905],
              [-144.88329016799992, -14.42742278399993],
              [-144.9027400379999, -14.442152601999908],
              [-144.93496660099993, -14.459730726999908],
              [-144.94473222599993, -14.463311455999929],
              [-144.95466061099992, -14.469821872999944],
              [-144.9858292309999, -14.500583591999941],
              [-145.0030818349999, -14.511163018999923],
            ],
          ],
          [
            [
              [-145.8465876939999, -14.367120049999926],
              [-145.84260006399992, -14.34661223799992],
              [-145.86017818899992, -14.344170830999929],
              [-145.9142960279999, -14.34661223799992],
              [-145.8583878249999, -14.337334893999923],
              [-145.8354386059999, -14.34270598799992],
              [-145.8465876939999, -14.367120049999926],
            ],
          ],
          [
            [
              [-136.73875891799992, -21.317152601999908],
              [-136.7402237619999, -21.32000090899993],
              [-136.74233964799993, -21.32008228999996],
              [-136.74693762899994, -21.31617603999996],
              [-136.74478105399993, -21.315850518999923],
              [-136.7409561839999, -21.31698984199994],
              [-136.73875891799992, -21.317152601999908],
            ],
          ],
          [
            [
              [-139.13536536399994, -20.79973723799992],
              [-139.14146887899994, -20.80315520599993],
              [-139.1445206369999, -20.80437590899993],
              [-139.14785722599993, -20.804945570999905],
              [-139.1358129549999, -20.79973723799992],
              [-139.13536536399994, -20.79973723799992],
            ],
          ],
          [
            [
              [-144.10684160099993, -16.72389088299991],
              [-144.0800675119999, -16.71721770599993],
              [-144.0630997389999, -16.730726820999905],
              [-144.0540665359999, -16.74968840899993],
              [-144.05089270699992, -16.75945403399993],
              [-144.06281490799992, -16.74863046699994],
              [-144.0756729809999, -16.730401299999926],
              [-144.09113521999993, -16.721856377999927],
              [-144.1107071609999, -16.739678643999923],
              [-144.11139889199993, -16.73528411299992],
              [-144.1105037099999, -16.73170338299991],
              [-144.10684160099993, -16.72389088299991],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Kiribati',
        iso3: 'KIR',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [173.03825931100005, 1.341050523000092],
              [173.0244246750001, 1.336615302000041],
              [173.0180770190001, 1.335923570000091],
              [173.01124108200008, 1.33734772300005],
              [173.0595809250001, 1.359767971000053],
              [173.08472741000003, 1.366685289000088],
              [173.15154056100005, 1.37181224200009],
              [173.1606551440001, 1.374945380000042],
              [173.14332116000003, 1.38031647300005],
              [173.153168165, 1.386542059000078],
              [173.16431725400003, 1.383246161000045],
              [173.17172285200002, 1.374172268000052],
              [173.17139733200008, 1.362372137000079],
              [173.16293379, 1.356512762000079],
              [173.15064537900003, 1.356431382000039],
              [173.12647545700008, 1.361070054000038],
              [173.1045028000001, 1.36196523600006],
              [173.0786238940001, 1.36001211100006],
              [173.05445397200003, 1.353583075000074],
              [173.03825931100005, 1.341050523000092],
            ],
          ],
          [
            [
              [-151.8077286449999, -11.385918877999927],
              [-151.79792232999992, -11.401462497999944],
              [-151.78449459499993, -11.42937590899993],
              [-151.78095455599993, -11.454685153999947],
              [-151.80089270699992, -11.461114190999922],
              [-151.8124893869999, -11.443536065999922],
              [-151.81952877499992, -11.420993747999944],
              [-151.81891842399992, -11.39967213299991],
              [-151.8077286449999, -11.385918877999927],
            ],
          ],
          [
            [
              [-155.8993220689999, -5.616794528999947],
              [-155.8796280589999, -5.609470309999949],
              [-155.86506100199992, -5.615166924999926],
              [-155.85981197799993, -5.625095309999949],
              [-155.86799068899992, -5.630303643999923],
              [-155.90644283799992, -5.635349216999941],
              [-155.9224747389999, -5.629978122999944],
              [-155.9334610669999, -5.609144789999959],
              [-155.92389889199993, -5.608086846999925],
              [-155.91498775899993, -5.60906340899993],
              [-155.90680904899992, -5.611993096999925],
              [-155.8993220689999, -5.616794528999947],
            ],
          ],
          [
            [
              [-155.0117081369999, -4.047051690999922],
              [-154.9622696609999, -4.032159112999921],
              [-154.94029700399992, -4.031996351999908],
              [-154.94660396999993, -4.053155205999929],
              [-154.95360266799992, -4.060723565999922],
              [-154.95856686099992, -4.071221612999921],
              [-154.9592179029999, -4.083184502999927],
              [-154.9533585279999, -4.094821872999944],
              [-154.96479244699992, -4.09498463299991],
              [-154.9775284499999, -4.078708591999941],
              [-154.99091549399992, -4.074314059999949],
              [-154.99848385299993, -4.07000090899993],
              [-155.01081295499992, -4.060642184999949],
              [-155.01842200399992, -4.051202080999929],
              [-155.0117081369999, -4.047051690999922],
            ],
          ],
          [
            [
              [-171.67780514199993, -2.833184502999927],
              [-171.70787512899992, -2.825127862999921],
              [-171.71210689999992, -2.823011976999908],
              [-171.71271725199992, -2.822198174999926],
              [-171.69318600199992, -2.828301690999922],
              [-171.66401119699992, -2.835381768999923],
              [-171.6580704419999, -2.838555596999925],
              [-171.65282141799992, -2.843194268999923],
              [-171.65160071499992, -2.844577731999948],
              [-171.63324947799993, -2.862074476999908],
              [-171.63312740799992, -2.862074476999908],
              [-171.63080807199992, -2.858575127999927],
              [-171.62975012899992, -2.857598565999922],
              [-171.62848873599992, -2.857028903999947],
              [-171.6269425119999, -2.855726820999962],
              [-171.6273087229999, -2.851901950999945],
              [-171.65387936099992, -2.80592213299991],
              [-171.66669674399992, -2.793145440999922],
              [-171.6787003249999, -2.784926039999959],
              [-171.69745846299992, -2.775323174999926],
              [-171.71458899599992, -2.772881768999923],
              [-171.72191321499992, -2.786309502999927],
              [-171.72785396999993, -2.778415622999944],
              [-171.72760982999992, -2.771905205999929],
              [-171.72276770699992, -2.765801690999922],
              [-171.7150772779999, -2.75904713299991],
              [-171.6802872389999, -2.775811455999929],
              [-171.64985104099992, -2.797295830999929],
              [-171.6296280589999, -2.827243747999944],
              [-171.62568111899992, -2.847181898999906],
              [-171.62446041599992, -2.856133721999925],
              [-171.6257218089999, -2.868910414999959],
              [-171.63935299399992, -2.862074476999908],
              [-171.6484268869999, -2.849786065999922],
              [-171.66010494699992, -2.840508721999925],
              [-171.67414303299992, -2.834161065999922],
              [-171.67780514199993, -2.833184502999927],
            ],
          ],
          [
            [
              [176.7861434250001, -2.608168226999908],
              [176.81316165500004, -2.614434502999927],
              [176.838226759, -2.633884372999944],
              [176.850922071, -2.654066664999959],
              [176.840668165, -2.662774346999925],
              [176.82732181100005, -2.656182549999926],
              [176.77230879, -2.608168226999908],
              [176.77898196700005, -2.60515715899993],
              [176.7822371750001, -2.604913018999923],
              [176.7861434250001, -2.608168226999908],
            ],
          ],
          [
            [
              [175.98170006600003, -2.505954684999949],
              [175.97681725400003, -2.497816664999959],
              [175.9731551440001, -2.489678643999923],
              [175.97999108200008, -2.493584893999923],
              [175.98511803500003, -2.498304945999962],
              [175.9892684250001, -2.503838799999926],
              [175.9931746750001, -2.510349216999941],
              [175.98943118600005, -2.510918877999927],
              [175.98698978000004, -2.509860934999949],
              [175.984711134, -2.507907809999949],
              [175.98170006600003, -2.505954684999949],
            ],
          ],
          [
            [
              [175.59148196700005, -1.874200127999927],
              [175.599945509, -1.895114841999941],
              [175.586273634, -1.922458591999941],
              [175.58326256600003, -1.911065362999921],
              [175.586273634, -1.87078215899993],
              [175.5761824880001, -1.856052341999941],
              [175.5590926440001, -1.832289320999962],
              [175.55225670700008, -1.819268487999921],
              [175.5595809250001, -1.826104424999926],
              [175.59148196700005, -1.874200127999927],
            ],
          ],
          [
            [
              [175.05876712300005, -1.436293226999908],
              [175.06666100400003, -1.461032809999949],
              [175.06861412900003, -1.497002862999921],
              [175.0605574880001, -1.531670830999929],
              [175.03825931100005, -1.55242278399993],
              [175.012543165, -1.549248955999929],
              [175.00847415500004, -1.526788018999923],
              [175.020843946, -1.499932549999926],
              [175.04509524800005, -1.484144789999959],
              [175.04509524800005, -1.490980726999908],
              [175.0361434250001, -1.497165622999944],
              [175.0258895190001, -1.507256768999923],
              [175.0185653000001, -1.519626559999949],
              [175.01832116000003, -1.531914971999925],
              [175.02800540500004, -1.541192315999922],
              [175.03785241000003, -1.535251559999949],
              [175.04566491000003, -1.524183851999908],
              [175.0488387380001, -1.518243096999925],
              [175.05827884200005, -1.506768487999921],
              [175.05884850400003, -1.480564059999949],
              [175.0517684250001, -1.452732028999947],
              [175.03825931100005, -1.436293226999908],
              [175.04509524800005, -1.428887627999927],
              [175.04810631600003, -1.432793877999927],
              [175.051117384, -1.434502862999921],
              [175.05876712300005, -1.436293226999908],
            ],
          ],
          [
            [
              [176.40935306100005, -1.332696221999925],
              [176.42644290500004, -1.347100518999923],
              [176.44483483200008, -1.373793226999908],
              [176.459320509, -1.405857028999947],
              [176.46404056100005, -1.436293226999908],
              [176.44988040500004, -1.425388278999947],
              [176.44214928500003, -1.408786716999941],
              [176.43677819100003, -1.390394789999959],
              [176.42986087300005, -1.37428150799991],
              [176.41032962300005, -1.350355726999908],
              [176.40113366000003, -1.336358330999929],
              [176.39568118600005, -1.31959400799991],
              [176.4023543630001, -1.320489190999922],
              [176.40544681100005, -1.32350025799991],
              [176.40935306100005, -1.332696221999925],
            ],
          ],
          [
            [
              [176.00928795700008, -1.334242445999962],
              [176.0234481130001, -1.362888278999947],
              [176.01832116000003, -1.387872002999927],
              [176.01197350400003, -1.381280205999929],
              [176.00277754, -1.375583591999941],
              [175.98357181100005, -1.367445570999962],
              [175.98357181100005, -1.36060963299991],
              [175.9931746750001, -1.36256275799991],
              [176.01832116000003, -1.37428150799991],
              [176.01490319100003, -1.356540622999944],
              [176.0063582690001, -1.342705987999921],
              [175.98357181100005, -1.31959400799991],
              [175.9658309250001, -1.295179945999962],
              [175.95590254, -1.286553643999923],
              [175.94312584700003, -1.28484465899993],
              [175.9443465500001, -1.289320570999962],
              [175.94556725400003, -1.292168877999927],
              [175.94939212300005, -1.29851653399993],
              [175.93702233200008, -1.293064059999949],
              [175.94214928500003, -1.28484465899993],
              [175.9580184250001, -1.280205987999921],
              [175.97730553500003, -1.28484465899993],
              [175.9892684250001, -1.306817315999922],
              [176.00928795700008, -1.334242445999962],
            ],
          ],
          [
            [
              [174.76514733200008, -1.202894789999959],
              [174.77271569100003, -1.24773528399993],
              [174.77881920700008, -1.264418226999908],
              [174.7558699880001, -1.25750090899993],
              [174.74830162900003, -1.237481377999927],
              [174.75074303500003, -1.199476820999962],
              [174.74675540500004, -1.185967705999929],
              [174.71664472700002, -1.134698174999926],
              [174.72535241000003, -1.135511976999908],
              [174.73161868600005, -1.13795338299991],
              [174.73747806100005, -1.14226653399993],
              [174.74398847700002, -1.148370049999926],
              [174.74756920700008, -1.166110934999949],
              [174.76514733200008, -1.202894789999959],
            ],
          ],
          [
            [
              [174.4765731130001, -0.709567966999941],
              [174.47934004, -0.72039153399993],
              [174.4907332690001, -0.747165622999944],
              [174.498383009, -0.789157809999949],
              [174.497976108, -0.795830987999921],
              [174.49789472700002, -0.796482028999947],
              [174.49732506600003, -0.805108330999929],
              [174.4834090500001, -0.819431247999944],
              [174.47388756600003, -0.812758070999962],
              [174.4697371750001, -0.806735934999949],
              [174.47234134200005, -0.801853122999944],
              [174.4834090500001, -0.798923434999949],
              [174.48113040500004, -0.804620049999926],
              [174.480804884, -0.805759372999944],
              [174.48194420700008, -0.806817315999922],
              [174.4834090500001, -0.812595309999949],
              [174.49756920700008, -0.796888929999909],
              [174.49773196700005, -0.796319268999923],
              [174.49773196700005, -0.794773044999943],
              [174.49390709700003, -0.775485934999949],
              [174.4765731130001, -0.740329684999949],
              [174.4629012380001, -0.64812590899993],
              [174.4765731130001, -0.669122002999927],
              [174.4765731130001, -0.709567966999941],
            ],
          ],
          [
            [
              [174.43873131600003, -0.627618096999925],
              [174.44711347700002, -0.630791924999926],
              [174.45866946700005, -0.637872002999927],
              [174.46363366000003, -0.644789320999962],
              [174.45264733200008, -0.64812590899993],
              [174.43718509200005, -0.640801690999922],
              [174.3916121750001, -0.605645440999922],
              [174.3808699880001, -0.592868747999944],
              [174.393890821, -0.592868747999944],
              [174.40259850400003, -0.602227471999925],
              [174.42994225400003, -0.623467705999929],
              [174.43873131600003, -0.627618096999925],
            ],
          ],
          [
            [
              [173.62061608200008, 0.133368231000077],
              [173.6098738940001, 0.143052476000094],
              [173.61451256600003, 0.155096747000073],
              [173.634125196, 0.174017645000049],
              [173.63835696700005, 0.195217190000051],
              [173.6337996750001, 0.200873114000046],
              [173.62330162900003, 0.207993882000039],
              [173.60621178500003, 0.215969143000052],
              [173.62867272200003, 0.219142971000053],
              [173.63648522200003, 0.216742255000042],
              [173.6411238940001, 0.20844147300005],
              [173.64136803500003, 0.200018622000073],
              [173.64079837300005, 0.19212474200009],
              [173.637543165, 0.17649974200009],
              [173.62061608200008, 0.133368231000077],
            ],
          ],
          [
            [
              [173.83228600400003, 0.44867584800005],
              [173.89087975400003, 0.418402411000045],
              [173.91724694100003, 0.399481512000079],
              [173.92164147200003, 0.379787502000056],
              [173.8676863940001, 0.419582424000055],
              [173.8320418630001, 0.436346747000073],
              [173.80494225400003, 0.434393622000073],
              [173.80876712300005, 0.441595770000049],
              [173.81324303500003, 0.446926174000055],
              [173.81861412900003, 0.451320705000057],
              [173.82545006600003, 0.455511786000045],
              [173.83228600400003, 0.44867584800005],
            ],
          ],
          [
            [
              [172.98715254, 0.83234284100007],
              [172.98894290500004, 0.833197333000044],
              [172.9902449880001, 0.833970445000091],
              [172.99000084700003, 0.830267645000049],
              [172.98975670700008, 0.828029690000051],
              [172.99000084700003, 0.825425523000092],
              [172.9863387380001, 0.829169012000079],
              [172.9834090500001, 0.831284898000092],
              [172.98715254, 0.83234284100007],
            ],
          ],
          [
            [
              [172.97779381600003, 0.836330471000053],
              [172.9795028000001, 0.834214585000041],
              [172.9824324880001, 0.83116282800006],
              [172.97934004, 0.830755927000041],
              [172.97535241000003, 0.831691799000055],
              [172.97217858200008, 0.834540106000077],
              [172.96941165500004, 0.839667059000078],
              [172.97575931100005, 0.839667059000078],
              [172.97779381600003, 0.836330471000053],
            ],
          ],
          [
            [
              [173.07593834700003, 0.965887762000079],
              [173.07992597700002, 0.96039459800005],
              [173.07927493600005, 0.945217190000051],
              [173.06120853000004, 0.914211330000057],
              [173.0498153000001, 0.904201565000051],
              [173.01124108200008, 0.85415273600006],
              [172.99097741000003, 0.834418036000045],
              [172.9965926440001, 0.845038153000075],
              [173.0136824880001, 0.860337632000039],
              [173.02271569100003, 0.882717190000051],
              [173.04664147200003, 0.901516018000052],
              [173.05591881600003, 0.927720445000091],
              [173.06413821700005, 0.938299872000073],
              [173.0712996750001, 0.949896552000041],
              [173.07178795700008, 0.962591864000046],
              [173.06226647200003, 0.975165106000077],
              [173.0449324880001, 0.987779039000088],
              [173.02556399800005, 0.998032945000091],
              [173.0097762380001, 1.003607489000046],
              [173.00953209700003, 1.000230210000041],
              [173.0097762380001, 0.989935614000046],
              [173.00367272200003, 0.989935614000046],
              [173.00342858200008, 1.00141022300005],
              [173.0004988940001, 1.010646877000056],
              [172.99561608200008, 1.018052476000094],
              [172.99000084700003, 1.02407461100006],
              [173.00367272200003, 1.02407461100006],
              [173.0146590500001, 1.008856512000079],
              [173.0649520190001, 0.976263739000046],
              [173.07593834700003, 0.965887762000079],
            ],
          ],
          [
            [
              [172.98316491000003, 1.531195380000042],
              [172.97828209700003, 1.531195380000042],
              [172.97535241000003, 1.532945054000038],
              [172.972992384, 1.535589911000045],
              [172.96941165500004, 1.537990627000056],
              [172.96314537900003, 1.560248114000046],
              [172.95915774800005, 1.60968659100007],
              [172.94898522200003, 1.627346096000053],
              [172.9629012380001, 1.620591539000088],
              [172.97234134200005, 1.590236721000053],
              [172.98316491000003, 1.531195380000042],
            ],
          ],
          [
            [
              [173.0361434250001, 1.777167059000078],
              [173.03834069100003, 1.742377020000049],
              [173.0293074880001, 1.716294664000088],
              [173.00367272200003, 1.70929596600007],
              [172.99634850400003, 1.710679429000038],
              [172.9931746750001, 1.712062893000052],
              [172.99000084700003, 1.715521552000041],
              [173.023773634, 1.721096096000053],
              [173.035492384, 1.743557033000059],
              [173.03337649800005, 1.774318752000056],
              [173.02466881600003, 1.804877020000049],
              [173.0258895190001, 1.806138414000088],
              [173.02662194100003, 1.807521877000056],
              [173.02711022200003, 1.80890534100007],
              [173.0273543630001, 1.810451565000051],
              [173.0361434250001, 1.777167059000078],
            ],
          ],
          [
            [
              [172.98031660200002, 1.882025458000044],
              [173.02027428500003, 1.828070380000042],
              [173.0234481130001, 1.821437893000052],
              [172.97575931100005, 1.87376536700009],
              [172.9614363940001, 1.899644273000092],
              [172.9550887380001, 1.907945054000038],
              [172.9384871750001, 1.923163153000075],
              [172.9336043630001, 1.931463934000078],
              [172.93474368600005, 1.942694403000075],
              [172.941742384, 1.926947333000044],
              [172.96941165500004, 1.907049872000073],
              [172.97575931100005, 1.897650458000044],
              [172.98031660200002, 1.882025458000044],
            ],
          ],
          [
            [
              [-157.19098873599992, 1.763902085000041],
              [-157.17939205599993, 1.753892320000091],
              [-157.17463131399992, 1.733791408000059],
              [-157.17878170499992, 1.718491929000038],
              [-157.1940811839999, 1.72296784100007],
              [-157.20307369699992, 1.717474677000041],
              [-157.2132462229999, 1.712795315000051],
              [-157.2241104809999, 1.70970286700009],
              [-157.23505611899992, 1.70929596600007],
              [-157.24640865799992, 1.713324286000045],
              [-157.2546280589999, 1.720282294000071],
              [-157.2608536449999, 1.72687409100007],
              [-157.27118893099993, 1.732977606000077],
              [-157.28156490799992, 1.747056382000039],
              [-157.28685462099992, 1.750230210000041],
              [-157.30927486899992, 1.751898505000042],
              [-157.41059322799993, 1.781927802000041],
              [-157.44896399599992, 1.80023834800005],
              [-157.4826554029999, 1.825384833000044],
              [-157.50861568899992, 1.849595445000091],
              [-157.52826900899993, 1.862494208000044],
              [-157.53730221299992, 1.856675523000092],
              [-157.54682369699992, 1.856431382000039],
              [-157.56602942599991, 1.863755601000094],
              [-157.5811661449999, 1.88031647300005],
              [-157.57823645699992, 1.907945054000038],
              [-157.57233639199993, 1.912787177000041],
              [-157.54352779899992, 1.929022528000075],
              [-157.53014075399992, 1.930568752000056],
              [-157.52122962099992, 1.927679755000042],
              [-157.5175675119999, 1.923651434000078],
              [-157.5198868479999, 1.921576239000046],
              [-157.53282630099991, 1.916083075000074],
              [-157.54535885299993, 1.902329820000091],
              [-157.54950924399992, 1.884466864000046],
              [-157.53730221299992, 1.866359768000052],
              [-157.52692623599992, 1.864813544000071],
              [-157.5130509109999, 1.866603908000059],
              [-157.50092525899993, 1.86587148600006],
              [-157.49571692599991, 1.856675523000092],
              [-157.49067135299993, 1.850165106000077],
              [-157.47883053299992, 1.84796784100007],
              [-157.45478268099993, 1.847072658000059],
              [-157.4346817699999, 1.83852773600006],
              [-157.42853756399992, 1.838568427000041],
              [-157.4373673169999, 1.850165106000077],
              [-157.44794674399992, 1.857489325000074],
              [-157.45860755099991, 1.862127997000073],
              [-157.46808834499993, 1.868353583000044],
              [-157.4752091139999, 1.880601304000038],
              [-157.46235104099992, 1.876288153000075],
              [-157.45164954299992, 1.87641022300005],
              [-157.44579016799992, 1.883734442000048],
              [-157.44733639199993, 1.90110911700009],
              [-157.43659420499992, 1.893866278000075],
              [-157.43248450399992, 1.883734442000048],
              [-157.43000240799992, 1.872788804000038],
              [-157.4236954419999, 1.863226630000042],
              [-157.4119766919999, 1.858465887000079],
              [-157.40794837099992, 1.866156317000048],
              [-157.4100235669999, 1.879380601000094],
              [-157.4244278639999, 1.901841539000088],
              [-157.4263809889999, 1.912054755000042],
              [-157.42438717399992, 1.921210028000075],
              [-157.41999264199993, 1.929022528000075],
              [-157.40831458199992, 1.921454169000071],
              [-157.40314693899992, 1.924221096000053],
              [-157.40632076699993, 1.942694403000075],
              [-157.39472408799992, 1.935736395000049],
              [-157.39399166599992, 1.926743882000039],
              [-157.3958634109999, 1.916978257000039],
              [-157.3920792309999, 1.907945054000038],
              [-157.38206946499992, 1.902167059000078],
              [-157.3771866529999, 1.905259507000039],
              [-157.37397213399993, 1.911363023000092],
              [-157.36384029899992, 1.917385158000059],
              [-157.35846920499992, 1.923895575000074],
              [-157.3541153639999, 1.931830145000049],
              [-157.35236568899992, 1.938950914000088],
              [-157.35505123599992, 1.947658596000053],
              [-157.3616837229999, 1.95148346600007],
              [-157.3796280589999, 1.95571523600006],
              [-157.40888424399992, 1.969305731000077],
              [-157.4453018869999, 1.994370835000041],
              [-157.4510391919999, 1.997300523000092],
              [-157.45539303299992, 2.002997137000079],
              [-157.4662979809999, 2.013332424000055],
              [-157.4775284499999, 2.018133856000077],
              [-157.4826554029999, 2.007228908000059],
              [-157.48790442599991, 2.000555731000077],
              [-157.49889075399992, 2.002183335000041],
              [-157.5084122389999, 2.010687567000048],
              [-157.50938880099991, 2.024603583000044],
              [-157.49628658799992, 2.034409898000092],
              [-157.4745987619999, 2.033351955000057],
              [-157.4238175119999, 2.020453192000048],
              [-157.3858536449999, 1.990464585000041],
              [-157.32184811099992, 1.97211334800005],
              [-157.31012936099992, 1.973089911000045],
              [-157.31139075399992, 1.962591864000046],
              [-157.3150528639999, 1.952785549000055],
              [-157.3206680979999, 1.945502020000049],
              [-157.3361710279999, 1.939113674000055],
              [-157.3404434889999, 1.930243231000077],
              [-157.34491939999992, 1.907945054000038],
              [-157.34772701699993, 1.86078522300005],
              [-157.32542883999992, 1.835842190000051],
              [-157.2897843089999, 1.818752346000053],
              [-157.25243079299992, 1.795314846000053],
              [-157.23839270699992, 1.783636786000045],
              [-157.22297115799992, 1.773586330000057],
              [-157.2068985669999, 1.766546942000048],
              [-157.19098873599992, 1.763902085000041],
            ],
          ],
          [
            [
              [172.750336134, 3.03196849200009],
              [172.7714949880001, 3.023871161000045],
              [172.78825931100005, 3.029038804000038],
              [172.80225670700008, 3.041693427000041],
              [172.81462649800005, 3.056219794000071],
              [172.8291121750001, 3.064276434000078],
              [172.868011915, 3.067775783000059],
              [172.88697350400003, 3.072943427000041],
              [172.88689212300005, 3.066392320000091],
              [172.8857528000001, 3.061916408000059],
              [172.88013756600003, 3.052476304000038],
              [172.84441165500004, 3.059800523000092],
              [172.81226647200003, 3.04047272300005],
              [172.786468946, 3.016913153000075],
              [172.77027428500003, 3.011460679000038],
              [172.76335696700005, 3.014593817000048],
              [172.75757897200003, 3.019029039000088],
              [172.75342858200008, 3.024807033000059],
              [172.750336134, 3.03196849200009],
            ],
          ],
          [
            [
              [172.96208743600005, 3.141831773000092],
              [172.96705162900003, 3.13540273600006],
              [172.96827233200008, 3.132391669000071],
              [172.96941165500004, 3.128159898000092],
              [172.94703209700003, 3.123032945000091],
              [172.899750196, 3.10024648600006],
              [172.88697350400003, 3.10024648600006],
              [172.94418379, 3.127386786000045],
              [172.96208743600005, 3.141831773000092],
            ],
          ],
          [
            [
              [-159.2845352859999, 3.874823309000078],
              [-159.27790279899992, 3.866441148000092],
              [-159.26642818899992, 3.845363674000055],
              [-159.2532852859999, 3.828680731000077],
              [-159.2499893869999, 3.81976959800005],
              [-159.25263424399992, 3.810044664000088],
              [-159.26341712099992, 3.79913971600007],
              [-159.28376217399992, 3.790187893000052],
              [-159.30870520699992, 3.784654039000088],
              [-159.33344479099992, 3.786444403000075],
              [-159.35285396999993, 3.79913971600007],
              [-159.36078854099992, 3.819403387000079],
              [-159.3427628249999, 3.819566148000092],
              [-159.2947891919999, 3.805975653000075],
              [-159.28522701699993, 3.811428127000056],
              [-159.28388424399992, 3.823919989000046],
              [-159.28718014199993, 3.837836005000042],
              [-159.2913712229999, 3.847601630000042],
              [-159.29967200399992, 3.854641018000052],
              [-159.32514400899993, 3.865301825000074],
              [-159.3354386059999, 3.871486721000053],
              [-159.3420304029999, 3.88149648600006],
              [-159.34784908799992, 3.902777411000045],
              [-159.35285396999993, 3.909002997000073],
              [-159.36615963399993, 3.911444403000075],
              [-159.37824459499993, 3.907171942000048],
              [-159.38788814999992, 3.89874909100007],
              [-159.39378821499992, 3.888576565000051],
              [-159.36713619699992, 3.84015534100007],
              [-159.4100235669999, 3.86204661700009],
              [-159.40632076699993, 3.902573960000041],
              [-159.3768204419999, 3.933294989000046],
              [-159.34227454299992, 3.925767320000091],
              [-159.33136959499993, 3.910711981000077],
              [-159.3267716139999, 3.901190497000073],
              [-159.32489986899992, 3.891669012000079],
              [-159.31989498599992, 3.879095770000049],
              [-159.3080948559999, 3.876450914000088],
              [-159.29466712099992, 3.87726471600007],
              [-159.2845352859999, 3.874823309000078],
            ],
          ],
          [
            [
              [-172.22276770699992, -4.506280205999929],
              [-172.2147110669999, -4.517347914999959],
              [-172.20201575399992, -4.520684502999927],
              [-172.18769283799992, -4.518487237999921],
              [-172.17438717399992, -4.513116143999923],
              [-172.20343990799992, -4.532159112999921],
              [-172.2271622389999, -4.518731377999927],
              [-172.2296036449999, -4.49732838299991],
              [-172.2004695299999, -4.49342213299991],
              [-172.20160885299993, -4.496270440999922],
              [-172.2010391919999, -4.500095309999949],
              [-172.20685787699992, -4.501071872999944],
              [-172.22276770699992, -4.506280205999929],
            ],
          ],
          [
            [
              [-174.50641842399992, -4.68914153399993],
              [-174.50068111899992, -4.694268487999921],
              [-174.50153561099992, -4.697360934999949],
              [-174.51215572799993, -4.691989841999941],
              [-174.52155514199993, -4.683851820999905],
              [-174.5167130199999, -4.684258721999925],
              [-174.50641842399992, -4.68914153399993],
            ],
          ],
          [
            [
              [-174.5292862619999, -4.682712497999944],
              [-174.52790279899992, -4.683526299999926],
              [-174.52765865799992, -4.683851820999905],
              [-174.53388424399992, -4.680759372999944],
              [-174.5417374339999, -4.672784112999921],
              [-174.54010982999992, -4.672051690999922],
              [-174.5358780589999, -4.677504164999959],
              [-174.5292862619999, -4.682712497999944],
            ],
          ],
          [
            [
              [-174.50084387899992, -4.69109465899993],
              [-174.51398678299992, -4.676202080999929],
              [-174.5282690089999, -4.667413018999923],
              [-174.5380753249999, -4.665215752999927],
              [-174.54340572799993, -4.660251559999949],
              [-174.53840084499993, -4.656508070999905],
              [-174.5244034499999, -4.664483330999929],
              [-174.50153561099992, -4.687676690999922],
              [-174.50084387899992, -4.69109465899993],
            ],
          ],
          [
            [
              [-171.25995846299992, -4.444105726999908],
              [-171.24498450399992, -4.441338799999926],
              [-171.2338761059999, -4.448988539999959],
              [-171.23005123599992, -4.460544528999947],
              [-171.23652096299992, -4.468519789999959],
              [-171.24958248599992, -4.469821872999944],
              [-171.2596329419999, -4.465264580999929],
              [-171.2640274729999, -4.45631275799991],
              [-171.25995846299992, -4.444105726999908],
            ],
          ],
          [
            [
              [-171.09357662699992, -3.131442966999941],
              [-171.09003658799992, -3.120863539999959],
              [-171.0854386059999, -3.111260674999926],
              [-171.0831192699999, -3.129978122999944],
              [-171.0872696609999, -3.143161716999941],
              [-171.09247799399992, -3.145440362999921],
              [-171.09357662699992, -3.131442966999941],
            ],
          ],
          [
            [
              [169.53891035200002, -0.874607028999947],
              [169.535492384, -0.872002862999921],
              [169.5337020190001, -0.871514580999929],
              [169.5302840500001, -0.871514580999929],
              [169.52759850400003, -0.872491143999923],
              [169.52507571700005, -0.870863539999959],
              [169.52320397200003, -0.868259372999944],
              [169.52214603000004, -0.865004164999959],
              [169.52263431100005, -0.860528252999927],
              [169.52295983200008, -0.859307549999926],
              [169.523773634, -0.856622002999927],
              [169.524750196, -0.854668877999927],
              [169.52507571700005, -0.853773695999962],
              [169.52759850400003, -0.85084400799991],
              [169.53248131600003, -0.849541924999926],
              [169.53638756600003, -0.847914320999962],
              [169.54070071700005, -0.847914320999962],
              [169.54517662900003, -0.847914320999962],
              [169.54908287900003, -0.851820570999962],
              [169.55225670700008, -0.854180596999925],
              [169.55445397200003, -0.856052341999941],
              [169.55591881600003, -0.859144789999959],
              [169.55591881600003, -0.859795830999929],
              [169.5556746750001, -0.860772393999923],
              [169.55534915500004, -0.863376559999949],
              [169.55534915500004, -0.866143487999921],
              [169.55445397200003, -0.869317315999922],
              [169.55347741000003, -0.872247002999927],
              [169.55250084700003, -0.873793226999908],
              [169.55054772200003, -0.875583591999941],
              [169.54810631600003, -0.876885674999926],
              [169.545258009, -0.877211195999962],
              [169.54314212300005, -0.878024997999944],
              [169.54127037900003, -0.877618096999925],
              [169.5400496750001, -0.87664153399993],
              [169.53891035200002, -0.874607028999947],
            ],
          ],
          [
            [
              [173.28972415500004, 2.03384023600006],
              [173.2871199880001, 2.038560289000088],
              [173.28467858200008, 2.040269273000092],
              [173.281586134, 2.041815497000073],
              [173.27702884200005, 2.04437897300005],
              [173.2705184250001, 2.04555898600006],
              [173.2661238940001, 2.043850002000056],
              [173.2646590500001, 2.036769924000055],
              [173.266937696, 2.020412502000056],
              [173.2685653000001, 2.011419989000046],
              [173.26677493600005, 2.004299221000053],
              [173.2627059250001, 1.997463283000059],
              [173.2578231130001, 1.997015692000048],
              [173.25806725400003, 1.997626044000071],
              [173.25928795700008, 2.000881252000056],
              [173.2602645190001, 2.007228908000059],
              [173.26050866000003, 2.012844143000052],
              [173.26002037900003, 2.018784898000092],
              [173.25749759200005, 2.028469143000052],
              [173.25806725400003, 2.034002997000073],
              [173.25961347700002, 2.043402411000045],
              [173.262054884, 2.049872137000079],
              [173.2646590500001, 2.055161851000094],
              [173.2685653000001, 2.05931224200009],
              [173.27361087300005, 2.059556382000039],
              [173.27800540500004, 2.058661200000074],
              [173.28288821700005, 2.056341864000046],
              [173.2890731130001, 2.050360419000071],
              [173.2934676440001, 2.043443101000094],
              [173.29371178500003, 2.042303778000075],
              [173.2959090500001, 2.033636786000045],
              [173.29835045700008, 2.01398346600007],
              [173.30543053500003, 1.993312893000052],
              [173.309418165, 1.984320380000042],
              [173.3125106130001, 1.982082424000055],
              [173.31568444100003, 1.979966539000088],
              [173.3183699880001, 1.976996161000045],
              [173.31804446700005, 1.974025783000059],
              [173.31788170700008, 1.970770575000074],
              [173.31592858200008, 1.967759507000039],
              [173.3129988940001, 1.965521552000041],
              [173.31072024800005, 1.964178778000075],
              [173.30884850400003, 1.963120835000041],
              [173.30445397200003, 1.96157461100006],
              [173.2973738940001, 1.96157461100006],
              [173.28484134200005, 1.963771877000056],
              [173.26921634200005, 1.967718817000048],
              [173.2602645190001, 1.971136786000045],
              [173.25749759200005, 1.974595445000091],
              [173.2558699880001, 1.985663153000075],
              [173.256195509, 1.989976304000038],
              [173.25847415500004, 1.99282461100006],
              [173.26148522200003, 1.993231512000079],
              [173.263031446, 1.991400458000044],
              [173.26392662900003, 1.988470770000049],
              [173.26351972700002, 1.983587958000044],
              [173.26392662900003, 1.978013414000088],
              [173.27165774800005, 1.974839585000041],
              [173.28931725400003, 1.970038153000075],
              [173.29371178500003, 1.969142971000053],
              [173.30152428500003, 1.968695380000042],
              [173.3046981130001, 1.969549872000073],
              [173.30591881600003, 1.969875393000052],
              [173.30787194100003, 1.97329336100006],
              [173.30681399800005, 1.976467190000051],
              [173.30591881600003, 1.980698960000041],
              [173.3007918630001, 1.985663153000075],
              [173.2973738940001, 1.989894924000055],
              [173.29761803500003, 1.991441148000092],
              [173.29672285200002, 1.993719794000071],
              [173.29615319100003, 1.997015692000048],
              [173.29371178500003, 2.005438544000071],
              [173.2915145190001, 2.015122789000088],
              [173.29184004, 2.019476630000042],
              [173.2915145190001, 2.026678778000075],
              [173.28972415500004, 2.03384023600006],
            ],
          ],
          [
            [
              [-160.4103897779999, 4.709173895000049],
              [-160.4166153639999, 4.71710846600007],
              [-160.41181393099993, 4.721625067000048],
              [-160.40119381399992, 4.723089911000045],
              [-160.3900040359999, 4.72101471600007],
              [-160.3788956369999, 4.713283596000053],
              [-160.38276119699992, 4.706976630000042],
              [-160.39537512899992, 4.704779364000046],
              [-160.4103897779999, 4.709173895000049],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Marshall Is.',
        iso3: 'MHL',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [168.10108483200008, 5.599310614000046],
              [168.10132897200003, 5.599595445000091],
              [168.10726972700002, 5.597235419000071],
              [168.1152449880001, 5.595404364000046],
              [168.1211043630001, 5.597357489000046],
              [168.12566165500004, 5.605698960000041],
              [168.12761478000004, 5.614243882000039],
              [168.127289259, 5.622788804000038],
              [168.12452233200008, 5.631048895000049],
              [168.13200931100005, 5.618557033000059],
              [168.1279403000001, 5.601629950000074],
              [168.1162215500001, 5.591376044000071],
              [168.10108483200008, 5.599310614000046],
            ],
          ],
          [
            [
              [171.7246199880001, 6.101711330000057],
              [171.7285262380001, 6.097642320000091],
              [171.7324324880001, 6.09210846600007],
              [171.7431746750001, 6.083197333000044],
              [171.7451278000001, 6.079128322000088],
              [171.73845462300005, 6.079169012000079],
              [171.72820071700005, 6.079291083000044],
              [171.72282962300005, 6.08344147300005],
              [171.7216903000001, 6.090969143000052],
              [171.7246199880001, 6.101711330000057],
            ],
          ],
          [
            [
              [171.90967858200008, 7.098781643000052],
              [171.91773522200003, 7.105129299000055],
              [171.9218856130001, 7.111761786000045],
              [171.921234571, 7.118475653000075],
              [171.915375196, 7.125148830000057],
              [171.92888431100005, 7.118312893000052],
              [171.9238387380001, 7.104396877000056],
              [171.90894616000003, 7.092271226000094],
              [171.89210045700008, 7.090806382000039],
              [171.89600670700008, 7.093898830000057],
              [171.90023847700002, 7.095770575000074],
              [171.90967858200008, 7.098781643000052],
            ],
          ],
          [
            [
              [168.68539472700002, 4.573797919000071],
              [168.73503665500004, 4.590521552000041],
              [168.74431399800005, 4.598618882000039],
              [168.7680770190001, 4.629055080000057],
              [168.75847415500004, 4.604641018000052],
              [168.74138431100005, 4.585842190000051],
              [168.7168074880001, 4.574774481000077],
              [168.68539472700002, 4.573797919000071],
            ],
          ],
          [
            [
              [169.5903426440001, 5.800930080000057],
              [169.61011803500003, 5.811916408000059],
              [169.617523634, 5.818264065000051],
              [169.6235457690001, 5.827297268000052],
              [169.62964928500003, 5.84015534100007],
              [169.6386824880001, 5.870347398000092],
              [169.64519290500004, 5.917141018000052],
              [169.65552819100003, 5.942857164000088],
              [169.67603600400003, 5.961004950000074],
              [169.7002059250001, 5.97601959800005],
              [169.71859785200002, 5.993109442000048],
              [169.73454837300005, 6.01312897300005],
              [169.72144616000003, 5.976629950000074],
              [169.66521243600005, 5.938788153000075],
              [169.65251712300005, 5.89984772300005],
              [169.647797071, 5.870021877000056],
              [169.63502037900003, 5.829046942000048],
              [169.6152449880001, 5.798773505000042],
              [169.5903426440001, 5.800930080000057],
            ],
          ],
          [
            [
              [172.0297957690001, 6.05414459800005],
              [172.0083113940001, 6.056219794000071],
              [171.98414147200003, 6.051703192000048],
              [171.96241295700008, 6.051825262000079],
              [171.94841556100005, 6.067775783000059],
              [171.950531446, 6.066595770000049],
              [171.95679772200003, 6.064154364000046],
              [171.96648196700005, 6.061997789000088],
              [171.9961043630001, 6.060980536000045],
              [172.0297957690001, 6.05414459800005],
            ],
          ],
          [
            [
              [171.75668379, 6.97211334800005],
              [171.73031660200002, 6.975572007000039],
              [171.68873131600003, 7.00657786700009],
              [171.66041100400003, 7.013088283000059],
              [171.61394290500004, 7.006089585000041],
              [171.59262129, 7.015285549000055],
              [171.57732181100005, 7.04718659100007],
              [171.587250196, 7.034084377000056],
              [171.597992384, 7.024725653000075],
              [171.61117597700002, 7.019924221000053],
              [171.676117384, 7.022853908000059],
              [171.6894637380001, 7.019924221000053],
              [171.73406009200005, 6.98468659100007],
              [171.75668379, 6.97211334800005],
            ],
          ],
          [
            [
              [171.3935653000001, 7.109930731000077],
              [171.36687259200005, 7.09446849200009],
              [171.2934676440001, 7.083685614000046],
              [171.26319420700008, 7.067694403000075],
              [171.235199415, 7.067694403000075],
              [171.2021590500001, 7.072455145000049],
              [171.060883009, 7.13540273600006],
              [171.0356551440001, 7.155096747000073],
              [171.05030358200008, 7.170721747000073],
              [171.05054772200003, 7.161037502000056],
              [171.05225670700008, 7.154852606000077],
              [171.0571395190001, 7.143459377000056],
              [171.22641035200002, 7.075751044000071],
              [171.23747806100005, 7.075913804000038],
              [171.26335696700005, 7.08079661700009],
              [171.28484134200005, 7.088324286000045],
              [171.3935653000001, 7.109930731000077],
            ],
          ],
          [
            [
              [168.7578231130001, 7.307928778000075],
              [168.8300887380001, 7.307928778000075],
              [168.81527754, 7.292466539000088],
              [168.7915145190001, 7.293402411000045],
              [168.7461043630001, 7.304185289000088],
              [168.6958113940001, 7.313381252000056],
              [168.67505944100003, 7.320868231000077],
              [168.67920983200008, 7.335191148000092],
              [168.69402103000004, 7.321763414000088],
              [168.71631920700008, 7.315375067000048],
              [168.7382918630001, 7.309068101000094],
              [168.7578231130001, 7.307928778000075],
            ],
          ],
          [
            [
              [168.57683353000004, 7.404120184000078],
              [168.56397545700008, 7.41274648600006],
              [168.5551863940001, 7.43032461100006],
              [168.5537215500001, 7.44985586100006],
              [168.5625106130001, 7.464341539000088],
              [168.5664168630001, 7.450995184000078],
              [168.57252037900003, 7.417792059000078],
              [168.57683353000004, 7.404120184000078],
            ],
          ],
          [
            [
              [166.90414472700002, 11.17291901200008],
              [166.89421634200005, 11.155178127000056],
              [166.87525475400003, 11.144964911000045],
              [166.85336347700002, 11.145412502000056],
              [166.83578535200002, 11.15924713700008],
              [166.87183678500003, 11.162298895000049],
              [166.90414472700002, 11.17291901200008],
            ],
          ],
          [
            [
              [169.11451256600003, 5.63812897300005],
              [169.11646569100003, 5.649237372000073],
              [169.12061608200008, 5.647406317000048],
              [169.11451256600003, 5.63812897300005],
            ],
          ],
          [
            [
              [171.79224694100003, 7.05499909100007],
              [171.79444420700008, 7.057766018000052],
              [171.7959090500001, 7.060207424000055],
              [171.7978621750001, 7.061916408000059],
              [171.80095462300005, 7.062689520000049],
              [171.79444420700008, 7.049750067000048],
              [171.785980665, 7.038234768000052],
              [171.7758895190001, 7.028143622000073],
              [171.7641707690001, 7.019517320000091],
              [171.77019290500004, 7.028876044000071],
              [171.79224694100003, 7.05499909100007],
            ],
          ],
          [
            [
              [168.96558678500003, 7.574652411000045],
              [168.96762129, 7.580633856000077],
              [168.968109571, 7.584499416000085],
              [168.96208743600005, 7.591701565000051],
              [168.95134524800005, 7.595689195000091],
              [168.9384871750001, 7.596380927000041],
              [168.94410241000003, 7.598089911000045],
              [168.95183353000004, 7.599188544000071],
              [168.95964603000004, 7.598578192000048],
              [168.96558678500003, 7.595363674000055],
              [168.9692488940001, 7.586737372000073],
              [168.9697371750001, 7.583889065000051],
              [168.9692488940001, 7.578680731000077],
              [168.96859785200002, 7.571234442000048],
              [168.96558678500003, 7.574652411000045],
            ],
          ],
          [
            [
              [167.401703321, 8.31781647300005],
              [167.40772545700008, 8.30727773600006],
              [167.39966881600003, 8.31077708500004],
              [167.401703321, 8.31781647300005],
            ],
          ],
          [
            [
              [167.73161868600005, 8.72459544500009],
              [167.73072350400003, 8.73037344000005],
              [167.73031660200002, 8.735256252000056],
              [167.73308353000004, 8.73969147300005],
              [167.7402449880001, 8.743841864000046],
              [167.741547071, 8.737697658000059],
              [167.74000084700003, 8.733221747000073],
              [167.73161868600005, 8.72459544500009],
            ],
          ],
          [
            [
              [170.85173587300005, 8.897772528000075],
              [170.8447371750001, 8.886501369000086],
              [170.83912194100003, 8.888169664000088],
              [170.83855228000004, 8.888373114000046],
              [170.8379012380001, 8.88865794500009],
              [170.83741295700008, 8.889064846000053],
              [170.83716881600003, 8.889593817000048],
              [170.84131920700008, 8.898586330000057],
              [170.844574415, 8.900783596000053],
              [170.8501082690001, 8.90143463700008],
              [170.85173587300005, 8.897772528000075],
            ],
          ],
          [
            [
              [170.2402449880001, 9.449774481000077],
              [170.2387801440001, 9.46670156500005],
              [170.24390709700003, 9.466376044000071],
              [170.2470809250001, 9.45774974200009],
              [170.2402449880001, 9.449774481000077],
            ],
          ],
          [
            [
              [170.87468509200005, 10.274603583000044],
              [170.87452233200008, 10.286607164000088],
              [170.87859134200005, 10.287176825000074],
              [170.87875410200002, 10.275091864000046],
              [170.87468509200005, 10.274603583000044],
            ],
          ],
          [
            [
              [165.54021243600005, 11.63377513200004],
              [165.54281660200002, 11.633002020000049],
              [165.5468856130001, 11.631008205000057],
              [165.55062910200002, 11.62693919500009],
              [165.5537215500001, 11.619818427000041],
              [165.54021243600005, 11.63377513200004],
            ],
          ],
          [
            [
              [165.2822371750001, 11.695786851000037],
              [165.2822371750001, 11.70844147300005],
              [165.28679446700005, 11.710882880000042],
              [165.28891035200002, 11.705959377000056],
              [165.2822371750001, 11.695786851000037],
            ],
          ],
          [
            [
              [169.0107528000001, 14.610174872000073],
              [169.0136824880001, 14.610500393000052],
              [169.00733483200008, 14.602769273000092],
              [168.996918165, 14.593085028000075],
              [168.9873153000001, 14.586859442000048],
              [168.99830162900003, 14.599025783000059],
              [169.0107528000001, 14.610174872000073],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Norfolk Island',
        iso3: 'NFK',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [167.98414147200003, -29.017836195999905],
            [167.99634850400003, -29.025648695999905],
            [167.9946395190001, -29.042575778999947],
            [167.98503665500004, -29.059258721999925],
            [167.973480665, -29.066338799999926],
            [167.970062696, -29.06894296699994],
            [167.96794681100005, -29.072035414999903],
            [167.96648196700005, -29.075778903999947],
            [167.96664472700002, -29.080010674999926],
            [167.96070397200003, -29.065606377999927],
            [167.95045006600003, -29.056573174999926],
            [167.93970787900003, -29.055759372999944],
            [167.9326278000001, -29.066338799999926],
            [167.92644290500004, -29.066338799999926],
            [167.9243270190001, -29.05559661299992],
            [167.92017662900003, -29.04550546699994],
            [167.918304884, -29.03639088299991],
            [167.9223738940001, -29.028741143999923],
            [167.92994225400003, -29.019463799999926],
            [167.930511915, -29.01213958099993],
            [167.92457116000003, -29.00872161299992],
            [167.9121199880001, -29.011651299999926],
            [167.92652428500003, -28.997491143999923],
            [167.94556725400003, -29.00123463299991],
            [167.9658309250001, -29.01181405999995],
            [167.98414147200003, -29.017836195999905],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Cook Is.',
        iso3: 'COK',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-157.9345596999999, -21.87753671699994],
              [-157.92133541599992, -21.882256768999923],
              [-157.91034908799992, -21.891696872999944],
              [-157.88988196499992, -21.91529713299991],
              [-157.8870743479999, -21.92636484199994],
              [-157.89850826699993, -21.93368905999995],
              [-157.91510982999992, -21.937676690999922],
              [-157.9277237619999, -21.938897393999923],
              [-157.94245357999992, -21.93718840899993],
              [-157.95287024599992, -21.932305596999925],
              [-157.96104895699992, -21.92392343499995],
              [-157.96869869699992, -21.912286065999922],
              [-157.96406002499992, -21.90048593499995],
              [-157.95514889199993, -21.888848565999922],
              [-157.9444473949999, -21.880466403999947],
              [-157.9345596999999, -21.87753671699994],
            ],
          ],
          [
            [
              [-157.7079971999999, -19.767185153999947],
              [-157.7099503249999, -19.78834400799991],
              [-157.70722408799992, -19.815850518999923],
              [-157.70824133999992, -19.841241143999923],
              [-157.7216690749999, -19.85588958099993],
              [-157.7216690749999, -19.84221770599993],
              [-157.72687740799992, -19.832289320999905],
              [-157.73371334499993, -19.82594166499996],
              [-157.7396134109999, -19.81845468499995],
              [-157.74213619699992, -19.804620049999926],
              [-157.73753821499992, -19.79656340899993],
              [-157.7155655589999, -19.77320728999996],
              [-157.7079971999999, -19.767185153999947],
            ],
          ],
          [
            [
              [-157.94074459499993, -8.980726820999905],
              [-157.96186275899993, -8.980726820999905],
              [-157.97862708199992, -8.976006768999923],
              [-157.99714107999992, -8.96461353999996],
              [-158.00829016799992, -8.95289478999996],
              [-158.00287838399993, -8.946709893999923],
              [-157.94074459499993, -8.974541924999926],
              [-157.94074459499993, -8.980726820999905],
            ],
          ],
          [
            [
              [-159.7978409499999, -21.18613046699994],
              [-159.7784317699999, -21.186944268999923],
              [-159.7584122389999, -21.19182708099993],
              [-159.74274654899992, -21.20159270599993],
              [-159.73639889199993, -21.216729424999926],
              [-159.73603268099993, -21.236993096999925],
              [-159.73786373599992, -21.246270440999922],
              [-159.74323482999992, -21.25432708099993],
              [-159.7708634109999, -21.250176690999922],
              [-159.77428137899992, -21.25090911299992],
              [-159.79328365799992, -21.241631768999923],
              [-159.83307857999992, -21.24456145599993],
              [-159.84626217399992, -21.233819268999923],
              [-159.83881588399993, -21.22633228999996],
              [-159.83283443899992, -21.20761484199994],
              [-159.8314102859999, -21.195570570999905],
              [-159.82343502499992, -21.189060153999947],
              [-159.7978409499999, -21.18613046699994],
            ],
          ],
          [
            [
              [-157.31281490799992, -20.15520598799992],
              [-157.31798255099991, -20.171807549999926],
              [-157.32856197799993, -20.179131768999923],
              [-157.34032141799992, -20.175713799999926],
              [-157.34935462099992, -20.16073984199994],
              [-157.3489884109999, -20.143324476999908],
              [-157.33857174399992, -20.137383721999925],
              [-157.32441158799992, -20.141696872999944],
              [-157.31281490799992, -20.15520598799992],
            ],
          ],
          [
            [
              [-158.07831783799992, -19.99423593499995],
              [-158.08177649599992, -20.012790622999944],
              [-158.09654700399992, -20.019707940999922],
              [-158.1151016919999, -20.01572030999995],
              [-158.12995357999992, -20.000746351999908],
              [-158.13520260299993, -19.976495049999926],
              [-158.12031002499992, -19.972832940999922],
              [-158.09736080599993, -19.981540622999944],
              [-158.07831783799992, -19.99423593499995],
            ],
          ],
          [
            [
              [-158.2682999339999, -19.83261484199994],
              [-158.28107662699992, -19.82195403399993],
              [-158.2763565749999, -19.82350025799991],
              [-158.2733048169999, -19.82626718499995],
              [-158.2682999339999, -19.83261484199994],
            ],
          ],
          [
            [
              [-158.28766842399992, -19.81064218499995],
              [-158.29377193899992, -19.816582940999922],
              [-158.29735266799992, -19.81731536299992],
              [-158.29596920499992, -19.81454843499995],
              [-158.28766842399992, -19.81064218499995],
            ],
          ],
          [
            [
              [-158.9251602859999, -19.26921965899993],
              [-158.93744869699992, -19.26425546699994],
              [-158.9501846999999, -19.25448984199994],
              [-158.95555579299992, -19.245293877999927],
              [-158.9456680979999, -19.242120049999926],
              [-158.94066321499992, -19.24732838299991],
              [-158.93797766799992, -19.25709400799991],
              [-158.93219967399992, -19.26425546699994],
              [-158.91808020699992, -19.261163018999923],
              [-158.91889400899993, -19.26409270599993],
              [-158.92035885299993, -19.26604583099993],
              [-158.9251602859999, -19.26921965899993],
            ],
          ],
          [
            [
              [-165.82453365799992, -10.88176848799992],
              [-165.81586666599992, -10.880303643999923],
              [-165.81175696499992, -10.88014088299991],
              [-165.80768795499992, -10.881280205999929],
              [-165.81403561099992, -10.889092705999929],
              [-165.8187149729999, -10.89153411299992],
              [-165.82209225199992, -10.889092705999929],
              [-165.82453365799992, -10.88176848799992],
            ],
          ],
          [
            [
              [-160.9862361319999, -10.38209400799991],
              [-160.99433346299992, -10.37468840899993],
              [-160.99640865799992, -10.371514580999929],
              [-160.97992916599992, -10.38095468499995],
              [-160.9380997389999, -10.42278411299992],
              [-160.9862361319999, -10.38209400799991],
            ],
          ],
          [
            [
              [-161.08800208199992, -10.035088799999926],
              [-161.07005774599992, -10.02743905999995],
              [-161.0755509109999, -10.03639088299991],
              [-161.0872696609999, -10.04461028399993],
              [-161.08800208199992, -10.035088799999926],
            ],
          ],
          [
            [
              [-159.78510494699992, -18.830824476999908],
              [-159.7726130849999, -18.828952731999948],
              [-159.7619929679999, -18.83725351399994],
              [-159.7613826159999, -18.84539153399993],
              [-159.76496334499993, -18.841729424999926],
              [-159.76663163999993, -18.83521900799991],
              [-159.76968339799993, -18.834323825999945],
              [-159.77924557199992, -18.85287851399994],
              [-159.77961178299992, -18.85637786299992],
              [-159.7764786449999, -18.87818775799991],
              [-159.7828669909999, -18.88795338299991],
              [-159.7936091789999, -18.887465101999908],
              [-159.8008113269999, -18.87818775799991],
              [-159.80231686099992, -18.86581796699994],
              [-159.79788163999993, -18.846530856999948],
              [-159.7938533189999, -18.83993905999995],
              [-159.78510494699992, -18.830824476999908],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Tonga',
        iso3: 'TON',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-173.95636959499993, -18.56731536299992],
              [-173.9412735669999, -18.57284921699994],
              [-173.93427486899992, -18.579278252999927],
              [-173.9279679029999, -18.586683851999908],
              [-173.9153946609999, -18.595310153999947],
              [-173.91425533799992, -18.606133721999925],
              [-173.9151505199999, -18.626885674999926],
              [-173.9229630199999, -18.636976820999905],
              [-173.94208736899992, -18.61581796699994],
              [-173.95295162699992, -18.620700778999947],
              [-173.95860755099991, -18.62672291499996],
              [-173.9576309889999, -18.634209893999923],
              [-173.94896399599992, -18.64316171699994],
              [-173.95722408799992, -18.653008721999925],
              [-173.96259518099993, -18.663506768999923],
              [-173.97663326699993, -18.66057708099993],
              [-173.98595130099991, -18.670993747999944],
              [-173.9905899729999, -18.68808359199994],
              [-173.99054928299992, -18.70517343499995],
              [-174.0030411449999, -18.69850025799991],
              [-174.00995846299992, -18.687107028999947],
              [-174.01720130099991, -18.663506768999923],
              [-174.00116939999992, -18.657403252999927],
              [-174.0003555979999, -18.645684502999927],
              [-174.0064591139999, -18.634372653999947],
              [-174.01097571499992, -18.62948984199994],
              [-174.02232825399992, -18.638848565999922],
              [-174.0256241529999, -18.653741143999923],
              [-174.03014075399992, -18.66334400799991],
              [-174.0451554029999, -18.65683359199994],
              [-174.04613196499992, -18.662367445999905],
              [-174.0490616529999, -18.663506768999923],
              [-174.05357825399992, -18.663181247999944],
              [-174.05943762899992, -18.663506768999923],
              [-174.0724991529999, -18.633965752999927],
              [-174.05357825399992, -18.619073174999926],
              [-174.02546139199993, -18.604913018999923],
              [-174.01097571499992, -18.57789478999996],
              [-174.0041397779999, -18.570977471999925],
              [-173.98810787699992, -18.56731536299992],
              [-173.9698380199999, -18.56617603999996],
              [-173.95636959499993, -18.56731536299992],
            ],
          ],
          [
            [
              [-174.91474361899992, -21.292168877999927],
              [-174.90851803299992, -21.32935963299991],
              [-174.90904700399992, -21.344496351999908],
              [-174.91474361899992, -21.38144296699994],
              [-174.9139298169999, -21.444105726999908],
              [-174.9202774729999, -21.454196872999944],
              [-174.93586178299992, -21.445489190999922],
              [-174.94220943899992, -21.43027109199994],
              [-174.95490475199992, -21.41806405999995],
              [-174.98363196499992, -21.39771900799991],
              [-174.98363196499992, -21.390883070999905],
              [-174.97968502499992, -21.389418226999908],
              [-174.96996008999992, -21.383965752999927],
              [-174.97581946499992, -21.37314218499995],
              [-174.97687740799992, -21.359551690999922],
              [-174.97175045499992, -21.347914320999905],
              [-174.95185299399992, -21.339776299999926],
              [-174.94550533799992, -21.33212655999995],
              [-174.93586178299992, -21.31568775799991],
              [-174.93354244699992, -21.30950286299992],
              [-174.9261368479999, -21.29461028399993],
              [-174.91840572799993, -21.28443775799991],
              [-174.91474361899992, -21.292168877999927],
            ],
          ],
          [
            [
              [-175.0655411449999, -21.12395598799992],
              [-175.05463619699992, -21.131524346999925],
              [-175.05089270699992, -21.139336846999925],
              [-175.0518692699999, -21.154961846999925],
              [-175.06049557199992, -21.16375090899993],
              [-175.11738033799992, -21.203057549999926],
              [-175.1209610669999, -21.211683851999908],
              [-175.11933346299992, -21.22234465899993],
              [-175.11591549399992, -21.233575127999927],
              [-175.11396236899992, -21.244073174999926],
              [-175.11762447799993, -21.25595468499995],
              [-175.12653561099992, -21.262790622999944],
              [-175.1378067699999, -21.26620859199994],
              [-175.14875240799992, -21.26799895599993],
              [-175.17035885299993, -21.26336028399993],
              [-175.18049068899992, -21.255059502999927],
              [-175.19652258999992, -21.22633228999996],
              [-175.20966549399992, -21.214450778999947],
              [-175.2573136059999, -21.192152601999908],
              [-175.26484127499992, -21.19963958099993],
              [-175.28962154899992, -21.18596770599993],
              [-175.30378170499992, -21.180759372999944],
              [-175.3162735669999, -21.17864348799992],
              [-175.32575436099992, -21.17359791499996],
              [-175.35045325399992, -21.14104583099993],
              [-175.36481686099992, -21.113946221999925],
              [-175.35529537699992, -21.08961353999996],
              [-175.33214270699992, -21.07122161299992],
              [-175.3057755199999, -21.06259530999995],
              [-175.3182266919999, -21.076836846999925],
              [-175.33405514199993, -21.08961353999996],
              [-175.3408096999999, -21.102634372999944],
              [-175.32624264199993, -21.117120049999926],
              [-175.3154190749999, -21.121351820999905],
              [-175.3065079419999, -21.12167734199994],
              [-175.24982662699992, -21.111260674999926],
              [-175.2405899729999, -21.11370208099993],
              [-175.23310299399992, -21.119317315999922],
              [-175.2252091139999, -21.123793226999908],
              [-175.21886145699992, -21.130059502999927],
              [-175.21637936099992, -21.14104583099993],
              [-175.23131262899992, -21.15007903399993],
              [-175.23822994699992, -21.158379815999922],
              [-175.23407955599993, -21.168633721999925],
              [-175.2235815089999, -21.172539971999925],
              [-175.21357174399992, -21.16838958099993],
              [-175.20356197799993, -21.161553643999923],
              [-175.19310462099992, -21.158135674999926],
              [-175.1807755199999, -21.160088799999926],
              [-175.1630753249999, -21.169366143999923],
              [-175.15497799399992, -21.171807549999926],
              [-175.1401261059999, -21.16838958099993],
              [-175.13422604099992, -21.15789153399993],
              [-175.1284073559999, -21.144138278999947],
              [-175.11396236899992, -21.130791924999926],
              [-175.10370846299992, -21.12623463299991],
              [-175.0908096999999, -21.12273528399993],
              [-175.07738196499992, -21.12151458099993],
              [-175.0655411449999, -21.12395598799992],
            ],
          ],
          [
            [
              [-174.36107337099992, -19.80136484199994],
              [-174.3475235669999, -19.796807549999926],
              [-174.33698482999992, -19.787774346999925],
              [-174.32966061099992, -19.774997653999947],
              [-174.3256729809999, -19.759698174999926],
              [-174.32074947799993, -19.76067473799992],
              [-174.30980383999992, -19.764743747999944],
              [-174.30585689999992, -19.767185153999947],
              [-174.31379146999993, -19.784763278999947],
              [-174.31513424399992, -19.80445728999996],
              [-174.3201798169999, -19.81926848799992],
              [-174.3393448559999, -19.821872653999947],
              [-174.34699459499993, -19.81812916499996],
              [-174.35313880099991, -19.81373463299991],
              [-174.35785885299993, -19.80836353999996],
              [-174.36107337099992, -19.80136484199994],
            ],
          ],
          [
            [
              [-175.0692846339999, -19.712009372999944],
              [-175.0533341139999, -19.723809502999927],
              [-175.0460098949999, -19.751153252999927],
              [-175.0478409499999, -19.781182549999926],
              [-175.0593155589999, -19.80136484199994],
              [-175.0593155589999, -19.79387786299992],
              [-175.0655411449999, -19.80136484199994],
              [-175.07050533799992, -19.795586846999925],
              [-175.07575436099992, -19.79225025799991],
              [-175.0872696609999, -19.78769296699994],
              [-175.08649654899992, -19.787286065999922],
              [-175.08763587099992, -19.784763278999947],
              [-175.0872696609999, -19.780857028999947],
              [-175.0994766919999, -19.74976978999996],
              [-175.1003311839999, -19.739841403999947],
              [-175.0966690749999, -19.72079843499995],
              [-175.09064693899992, -19.71266041499996],
              [-175.08165442599991, -19.71135833099993],
              [-175.0692846339999, -19.712009372999944],
            ],
          ],
          [
            [
              [-174.3058162099999, -19.73300546699994],
              [-174.2881973949999, -19.723728122999944],
              [-174.27818762899992, -19.71062590899993],
              [-174.26996822799993, -19.696872653999947],
              [-174.25743567599991, -19.684665622999944],
              [-174.2521866529999, -19.69931405999995],
              [-174.25519771999993, -19.71217213299991],
              [-174.26105709499993, -19.72429778399993],
              [-174.2642716139999, -19.73642343499995],
              [-174.27167721299992, -19.749118747999944],
              [-174.28754635299993, -19.75058359199994],
              [-174.30219479099992, -19.744073174999926],
              [-174.3058162099999, -19.73300546699994],
            ],
          ],
          [
            [
              [-174.2608536449999, -19.63054778399993],
              [-174.24799557199992, -19.635918877999927],
              [-174.2440079419999, -19.64625416499996],
              [-174.24925696499992, -19.653741143999923],
              [-174.2642716139999, -19.65048593499995],
              [-174.27521725199992, -19.63567473799992],
              [-174.2884415359999, -19.61109791499996],
              [-174.29303951699993, -19.59270598799992],
              [-174.27790279899992, -19.595879815999922],
              [-174.27277584499993, -19.604261976999908],
              [-174.26777096299992, -19.626153252999927],
              [-174.2608536449999, -19.63054778399993],
            ],
          ],
          [
            [
              [-175.63133704299992, -15.55950286299992],
              [-175.61261959499993, -15.573337497999944],
              [-175.6177872389999, -15.601495049999926],
              [-175.63914954299992, -15.62428150799991],
              [-175.6688940089999, -15.621514580999929],
              [-175.6862686839999, -15.602308851999908],
              [-175.68333899599992, -15.58212655999995],
              [-175.66376705599993, -15.566013278999947],
              [-175.63133704299992, -15.55950286299992],
            ],
          ],
          [
            [
              [-176.2134903639999, -22.32390715899993],
              [-176.2042130199999, -22.326918226999908],
              [-176.19810950399992, -22.331963799999926],
              [-176.20185299399992, -22.336114190999922],
              [-176.2070206369999, -22.33879973799992],
              [-176.21019446499992, -22.33879973799992],
              [-176.21589107999992, -22.335137627999927],
              [-176.21930904899992, -22.32984791499996],
              [-176.2182511059999, -22.324883721999925],
              [-176.2134903639999, -22.32390715899993],
            ],
          ],
          [
            [
              [-174.6537979809999, -18.817478122999944],
              [-174.66413326699993, -18.80136484199994],
              [-174.6612442699999, -18.78687916499996],
              [-174.64960689999992, -18.779554945999905],
              [-174.63385982999992, -18.785332940999922],
              [-174.6268204419999, -18.797539971999925],
              [-174.6302384109999, -18.80901458099993],
              [-174.64045162699992, -18.816582940999922],
              [-174.6537979809999, -18.817478122999944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Wallis and Futuna Is.',
        iso3: 'WLF',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-178.14232337099992, -14.243584893999923],
              [-178.1081436839999, -14.27898528399993],
              [-178.10509192599991, -14.28525155999995],
              [-178.09247799399992, -14.288995049999926],
              [-178.0467423169999, -14.31259530999995],
              [-178.0467423169999, -14.319431247999944],
              [-178.10004635299993, -14.316013278999947],
              [-178.10883541599992, -14.319431247999944],
              [-178.1214493479999, -14.313897393999923],
              [-178.14692135299993, -14.310153903999947],
              [-178.1566055979999, -14.305108330999929],
              [-178.17524166599992, -14.27703215899993],
              [-178.18573971299992, -14.248223565999922],
              [-178.17804928299992, -14.232598565999922],
              [-178.14232337099992, -14.243584893999923],
            ],
          ],
          [
            [
              [-176.15546627499992, -13.208916924999926],
              [-176.14301510299993, -13.230726820999905],
              [-176.13056393099993, -13.247653903999947],
              [-176.1255997389999, -13.264092705999929],
              [-176.13560950399992, -13.284763278999947],
              [-176.13215084499993, -13.288506768999923],
              [-176.13056393099993, -13.291192315999922],
              [-176.12816321499992, -13.298272393999923],
              [-176.14447994699992, -13.30087655999995],
              [-176.14765377499992, -13.310479424999926],
              [-176.14183508999992, -13.335870049999926],
              [-176.14716549399992, -13.34775155999995],
              [-176.15949459499993, -13.350274346999925],
              [-176.1732071609999, -13.346449476999908],
              [-176.18281002499992, -13.339288018999923],
              [-176.18390865799992, -13.323825778999947],
              [-176.19477291599992, -13.30673593499995],
              [-176.1995743479999, -13.290622653999947],
              [-176.18281002499992, -13.277927341999941],
              [-176.1901749339999, -13.257012627999927],
              [-176.18403072799993, -13.237888278999947],
              [-176.17039954299992, -13.221449476999908],
              [-176.15546627499992, -13.208916924999926],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Samoa',
        iso3: 'WSM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-172.2010391919999, -13.592543226999908],
              [-172.19758053299992, -13.603122653999947],
              [-172.1956680979999, -13.613864841999941],
              [-172.19489498599992, -13.636895440999922],
              [-172.19025631399992, -13.65601978999996],
              [-172.18138587099992, -13.66765715899993],
              [-172.1756485669999, -13.680271091999941],
              [-172.1806127589999, -13.70240650799991],
              [-172.19066321499992, -13.717950127999927],
              [-172.2021378249999, -13.73015715899993],
              [-172.21149654899992, -13.744561455999929],
              [-172.21532141799992, -13.76767343499995],
              [-172.21235104099992, -13.790622653999947],
              [-172.21296139199993, -13.800957940999922],
              [-172.21906490799992, -13.805352471999925],
              [-172.2427872389999, -13.805108330999929],
              [-172.25324459499993, -13.802911065999922],
              [-172.26378333199992, -13.798028252999927],
              [-172.2795304029999, -13.78484465899993],
              [-172.2877091139999, -13.774997653999947],
              [-172.29755611899992, -13.769789320999905],
              [-172.31843014199993, -13.77125416499996],
              [-172.3686417309999, -13.788995049999926],
              [-172.52318274599992, -13.805352471999925],
              [-172.53290768099993, -13.79859791499996],
              [-172.54316158799992, -13.78525155999995],
              [-172.5511368479999, -13.777520440999922],
              [-172.5673721999999, -13.76881275799991],
              [-172.5751440089999, -13.762790622999944],
              [-172.5784805979999, -13.75400155999995],
              [-172.58055579299992, -13.744805596999925],
              [-172.58995520699992, -13.724786065999922],
              [-172.59211178299992, -13.71266041499996],
              [-172.59711666599992, -13.700616143999923],
              [-172.60895748599992, -13.69304778399993],
              [-172.6225479809999, -13.687758070999905],
              [-172.6330460279999, -13.681898695999905],
              [-172.6545304029999, -13.649183851999908],
              [-172.6674698559999, -13.633884372999944],
              [-172.6933487619999, -13.624118747999944],
              [-172.7034805979999, -13.616631768999923],
              [-172.7187393869999, -13.60279713299991],
              [-172.72187252499992, -13.597832940999922],
              [-172.7230118479999, -13.587334893999923],
              [-172.7255753249999, -13.581963799999926],
              [-172.73127193899992, -13.578871351999908],
              [-172.7444962229999, -13.580010674999926],
              [-172.74974524599992, -13.578301690999922],
              [-172.76117916599992, -13.565036716999941],
              [-172.7764786449999, -13.542087497999944],
              [-172.7825821609999, -13.520277601999908],
              [-172.7665502589999, -13.510511976999908],
              [-172.73237057199992, -13.510511976999908],
              [-172.69513912699992, -13.524183851999908],
              [-172.66120357999992, -13.52516041499996],
              [-172.63898678299992, -13.522067966999941],
              [-172.61534583199992, -13.509372653999947],
              [-172.60399329299992, -13.506442966999941],
              [-172.58185787699992, -13.504489841999941],
              [-172.56920325399992, -13.501397393999923],
              [-172.54222571499992, -13.487888278999947],
              [-172.5306290359999, -13.483982028999947],
              [-172.45185299399992, -13.483982028999947],
              [-172.43146725199992, -13.480889580999929],
              [-172.38923092399992, -13.466973565999922],
              [-172.3661596339999, -13.462823174999926],
              [-172.34443111899992, -13.46298593499995],
              [-172.32237708199992, -13.46689218499995],
              [-172.3007706369999, -13.476495049999926],
              [-172.28050696499992, -13.493584893999923],
              [-172.22276770699992, -13.55836353999996],
              [-172.22187252499992, -13.56259530999995],
              [-172.2235815089999, -13.57390715899993],
              [-172.22276770699992, -13.578301690999922],
              [-172.2175186839999, -13.582777601999908],
              [-172.2053116529999, -13.58766041499996],
              [-172.2010391919999, -13.592543226999908],
            ],
          ],
          [
            [
              [-171.56427975199992, -13.949395440999922],
              [-171.51947994699992, -13.944756768999923],
              [-171.4693497389999, -13.969414971999925],
              [-171.43769283799992, -14.006117445999905],
              [-171.4481908839999, -14.037530205999929],
              [-171.4453018869999, -14.041436455999929],
              [-171.44074459499993, -14.051853122999944],
              [-171.4661759109999, -14.05282968499995],
              [-171.53693600199992, -14.045668226999908],
              [-171.5792130199999, -14.049493096999925],
              [-171.59882564999992, -14.04778411299992],
              [-171.6194962229999, -14.037530205999929],
              [-171.63581295499992, -14.04615650799991],
              [-171.65241451699993, -14.045179945999905],
              [-171.68403072799993, -14.037530205999929],
              [-171.7001440089999, -14.038995049999926],
              [-171.74299068899992, -14.051853122999944],
              [-171.7532852859999, -14.051527601999908],
              [-171.76203365799992, -14.048760674999926],
              [-171.76805579299992, -14.043226820999905],
              [-171.77033443899992, -14.03484465899993],
              [-171.7745255199999, -14.02629973799992],
              [-171.78437252499992, -14.022230726999908],
              [-171.80443274599992, -14.017754815999922],
              [-171.82221432199992, -14.008477471999925],
              [-171.83796139199993, -14.00318775799991],
              [-171.85407467399992, -14.001885674999926],
              [-171.8935033839999, -14.007012627999927],
              [-171.9111221999999, -14.006442966999941],
              [-171.92662512899992, -14.001153252999927],
              [-171.94098873599992, -13.990411065999922],
              [-171.9619034499999, -13.958103122999944],
              [-171.97240149599992, -13.94622161299992],
              [-171.98200436099992, -13.949395440999922],
              [-171.98884029899992, -13.949395440999922],
              [-172.00629635299993, -13.924981377999927],
              [-172.01801510299993, -13.917901299999926],
              [-172.04063880099991, -13.915215752999927],
              [-172.06102454299992, -13.906182549999926],
              [-172.06366939999992, -13.885023695999905],
              [-172.0556127589999, -13.861911716999941],
              [-172.0440567699999, -13.846368096999925],
              [-171.9651993479999, -13.818536065999922],
              [-171.88019771999993, -13.805352471999925],
              [-171.83454342399992, -13.807386976999908],
              [-171.79230709499993, -13.81650155999995],
              [-171.65021725199992, -13.871270440999922],
              [-171.6069229809999, -13.876153252999927],
              [-171.58515377499992, -13.883884372999944],
              [-171.56757564999992, -13.896742445999905],
              [-171.55744381399992, -13.915215752999927],
              [-171.55907141799992, -13.925388278999947],
              [-171.56574459499993, -13.93141041499996],
              [-171.57001705599993, -13.938164971999925],
              [-171.56427975199992, -13.949395440999922],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Solomon Is.',
        iso3: 'SLB',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [160.50367272200003, -11.73601653399993],
              [160.5644637380001, -11.773044528999947],
              [160.58220462300005, -11.794854424999926],
              [160.55884850400003, -11.811211846999925],
              [160.5468856130001, -11.811293226999908],
              [160.5380965500001, -11.80836353999996],
              [160.529633009, -11.806817315999922],
              [160.51783287900003, -11.811211846999925],
              [160.51246178500003, -11.81812916499996],
              [160.50456790500004, -11.838311455999929],
              [160.49732506600003, -11.845879815999922],
              [160.48316491000003, -11.84498463299991],
              [160.47095787900003, -11.83171965899993],
              [160.46013431100005, -11.815036716999941],
              [160.449554884, -11.80437590899993],
              [160.43433678500003, -11.810967705999929],
              [160.42847741000003, -11.811211846999925],
              [160.42261803500003, -11.808526299999926],
              [160.3852645190001, -11.783786716999941],
              [160.38005618600005, -11.77703215899993],
              [160.36890709700003, -11.734551690999922],
              [160.36011803500003, -11.71689218499995],
              [160.33969160200002, -11.701348565999922],
              [160.32935631600003, -11.698337497999944],
              [160.30811608200008, -11.69703541499996],
              [160.29810631600003, -11.694512627999927],
              [160.28581790500004, -11.686944268999923],
              [160.28337649800005, -11.680840752999927],
              [160.2851668630001, -11.67473723799992],
              [160.2851668630001, -11.667168877999927],
              [160.28394616000003, -11.657321872999944],
              [160.28484134200005, -11.649509372999944],
              [160.282074415, -11.64185963299991],
              [160.27076256600003, -11.632989190999922],
              [160.26246178500003, -11.629164320999905],
              [160.25180097700002, -11.626153252999927],
              [160.240570509, -11.62468840899993],
              [160.2304793630001, -11.626153252999927],
              [160.22584069100003, -11.631036065999922],
              [160.21631920700008, -11.648044528999947],
              [160.2099715500001, -11.653497002999927],
              [160.20101972700002, -11.65520598799992],
              [160.18930097700002, -11.655368747999944],
              [160.1684676440001, -11.653497002999927],
              [160.15121504, -11.647149346999925],
              [160.11247806100005, -11.626071872999944],
              [160.09262129, -11.619398695999905],
              [160.0976668630001, -11.60906340899993],
              [160.10075931100005, -11.605075778999947],
              [160.0825301440001, -11.592217705999929],
              [160.0664168630001, -11.59351978999996],
              [160.0527449880001, -11.600762627999927],
              [160.041351759, -11.605075778999947],
              [160.02369225400003, -11.600681247999944],
              [160.01059004, -11.589450778999947],
              [159.98194420700008, -11.554294528999947],
              [159.97779381600003, -11.540215752999927],
              [159.97291100400003, -11.533379815999922],
              [159.96550540500004, -11.525811455999929],
              [159.9633895190001, -11.520603122999944],
              [159.9692488940001, -11.50318775799991],
              [159.97608483200008, -11.491387627999927],
              [159.9961043630001, -11.473077080999929],
              [160.003265821, -11.461114190999922],
              [160.00668379, -11.465101820999905],
              [160.010101759, -11.46648528399993],
              [160.0136824880001, -11.467217705999929],
              [160.0175887380001, -11.46851978999996],
              [160.03199303500003, -11.483575127999927],
              [160.04175866000003, -11.490492445999905],
              [160.05241946700005, -11.495212497999944],
              [160.0634871750001, -11.496026299999926],
              [160.08716881600003, -11.494805596999925],
              [160.0966903000001, -11.499200127999927],
              [160.11670983200008, -11.516696872999944],
              [160.13738040500004, -11.529880466999941],
              [160.1933699880001, -11.55632903399993],
              [160.222992384, -11.578383070999905],
              [160.25847415500004, -11.59547291499996],
              [160.287445509, -11.617364190999922],
              [160.30811608200008, -11.62664153399993],
              [160.35279381600003, -11.639825127999927],
              [160.393890821, -11.657810153999947],
              [160.50367272200003, -11.73601653399993],
            ],
          ],
          [
            [
              [159.8046981130001, -11.290459893999923],
              [159.8222762380001, -11.29265715899993],
              [159.83936608200008, -11.297621351999908],
              [159.85108483200008, -11.307712497999944],
              [159.85320071700005, -11.324476820999905],
              [159.82992597700002, -11.31536223799992],
              [159.8105574880001, -11.310479424999926],
              [159.793304884, -11.30242278399993],
              [159.7773543630001, -11.283623955999929],
              [159.78532962300005, -11.282810153999947],
              [159.7920028000001, -11.283949476999908],
              [159.79835045700008, -11.286553643999923],
              [159.8046981130001, -11.290459893999923],
            ],
          ],
          [
            [
              [161.74097741000003, -10.272556247999944],
              [161.74586022200003, -10.263278903999947],
              [161.74195397200003, -10.25904713299991],
              [161.73503665500004, -10.257419528999947],
              [161.73064212300005, -10.25562916499996],
              [161.7172957690001, -10.23137786299992],
              [161.71705162900003, -10.218194268999923],
              [161.73064212300005, -10.20671965899993],
              [161.7524520190001, -10.224216403999947],
              [161.76880944100003, -10.252211195999905],
              [161.7705184250001, -10.278415622999944],
              [161.74781334700003, -10.289808851999908],
              [161.7407332690001, -10.288506768999923],
              [161.73698978000004, -10.284600518999923],
              [161.736664259, -10.279229424999926],
              [161.74097741000003, -10.272556247999944],
            ],
          ],
          [
            [
              [162.37484785200002, -10.823663018999923],
              [162.38550866000003, -10.818780205999929],
              [162.3925887380001, -10.826918226999908],
              [162.3916121750001, -10.83879973799992],
              [162.378265821, -10.844821872999944],
              [162.36500084700003, -10.842543226999908],
              [162.35328209700003, -10.838962497999944],
              [162.341156446, -10.838148695999905],
              [162.3271590500001, -10.844821872999944],
              [162.319672071, -10.840264580999929],
              [162.30925540500004, -10.838474216999941],
              [162.292328321, -10.83798593499995],
              [162.278656446, -10.835544528999947],
              [162.2070418630001, -10.808038018999923],
              [162.183929884, -10.810967705999929],
              [162.16195722700002, -10.831149997999944],
              [162.150726759, -10.82512786299992],
              [162.138031446, -10.82317473799992],
              [162.11085045700008, -10.823663018999923],
              [162.10108483200008, -10.821465752999927],
              [162.09392337300005, -10.815850518999923],
              [162.08765709700003, -10.809340101999908],
              [162.0800887380001, -10.803806247999944],
              [162.03589928500003, -10.786553643999923],
              [162.019867384, -10.773370049999926],
              [162.01124108200008, -10.76962655999995],
              [161.9985457690001, -10.771661065999922],
              [161.96941165500004, -10.78134530999995],
              [161.96013431100005, -10.779554945999905],
              [161.95069420700008, -10.774102471999925],
              [161.90886478000004, -10.762139580999929],
              [161.91032962300005, -10.764092705999929],
              [161.904633009, -10.766696872999944],
              [161.89177493600005, -10.76962655999995],
              [161.8852645190001, -10.76734791499996],
              [161.8750106130001, -10.75758228999996],
              [161.87134850400003, -10.755303643999923],
              [161.86150149800005, -10.752618096999925],
              [161.854828321, -10.745700778999947],
              [161.84685306100005, -10.728122653999947],
              [161.84131920700008, -10.742771091999941],
              [161.84050540500004, -10.749200127999927],
              [161.81861412900003, -10.733168226999908],
              [161.806976759, -10.730075778999947],
              [161.79216556100005, -10.734958591999941],
              [161.7895613940001, -10.728692315999922],
              [161.7822371750001, -10.72039153399993],
              [161.77849368600005, -10.715020440999922],
              [161.76921634200005, -10.71884530999995],
              [161.76099694100003, -10.712334893999923],
              [161.7563582690001, -10.70208098799992],
              [161.75806725400003, -10.694512627999927],
              [161.74870853000004, -10.682793877999927],
              [161.7368270190001, -10.681817315999922],
              [161.723480665, -10.68368905999995],
              [161.71021569100003, -10.680271091999941],
              [161.70297285200002, -10.670668226999908],
              [161.7002059250001, -10.659356377999927],
              [161.69483483200008, -10.649997653999947],
              [161.67945397200003, -10.64617278399993],
              [161.6743270190001, -10.63990650799991],
              [161.6611434250001, -10.627618096999925],
              [161.6474715500001, -10.618584893999923],
              [161.64136803500003, -10.622247002999927],
              [161.63656660200002, -10.631036065999922],
              [161.625824415, -10.624444268999923],
              [161.60718834700003, -10.605726820999905],
              [161.6074324880001, -10.597263278999947],
              [161.60303795700008, -10.591241143999923],
              [161.5957137380001, -10.587497653999947],
              [161.58668053500003, -10.584649346999925],
              [161.58871504, -10.57708098799992],
              [161.58668053500003, -10.57000090899993],
              [161.58130944100003, -10.563164971999925],
              [161.57300866000003, -10.556817315999922],
              [161.56470787900003, -10.566664320999905],
              [161.5527449880001, -10.57000090899993],
              [161.53874759200005, -10.56845468499995],
              [161.52466881600003, -10.56422291499996],
              [161.54517662900003, -10.502129815999922],
              [161.5341903000001, -10.495212497999944],
              [161.53296959700003, -10.48560963299991],
              [161.53345787900003, -10.475030205999929],
              [161.5283309250001, -10.46453215899993],
              [161.52214603000004, -10.463067315999922],
              [161.5019637380001, -10.467461846999925],
              [161.49040774800005, -10.467950127999927],
              [161.49968509200005, -10.45631275799991],
              [161.50749759200005, -10.440036716999941],
              [161.50668379, -10.425713799999926],
              [161.49040774800005, -10.420179945999905],
              [161.50066165500004, -10.395114841999941],
              [161.50749759200005, -10.383477471999925],
              [161.5146590500001, -10.37859465899993],
              [161.5200301440001, -10.376397393999923],
              [161.5180770190001, -10.371677341999941],
              [161.51099694100003, -10.36492278399993],
              [161.50554446700005, -10.363539320999905],
              [161.48975670700008, -10.365411065999922],
              [161.48365319100003, -10.36492278399993],
              [161.47681725400003, -10.359551690999922],
              [161.47234134200005, -10.352715752999927],
              [161.46599368600005, -10.34693775799991],
              [161.45264733200008, -10.344496351999908],
              [161.42546634200005, -10.344496351999908],
              [161.41374759200005, -10.34156666499996],
              [161.4091903000001, -10.334242445999905],
              [161.4028426440001, -10.330010674999926],
              [161.38884524800005, -10.329196872999944],
              [161.367523634, -10.330824476999908],
              [161.3613387380001, -10.33375416499996],
              [161.35694420700008, -10.338474216999941],
              [161.35173587300005, -10.342543226999908],
              [161.34400475400003, -10.344496351999908],
              [161.3369246750001, -10.34343840899993],
              [161.3300887380001, -10.33879973799992],
              [161.30388431100005, -10.335381768999923],
              [161.29314212300005, -10.331231377999927],
              [161.28492272200003, -10.32390715899993],
              [161.28077233200008, -10.308851820999905],
              [161.289398634, -10.287041924999926],
              [161.28492272200003, -10.276136976999908],
              [161.28980553500003, -10.271416924999926],
              [161.29224694100003, -10.268161716999941],
              [161.29444420700008, -10.26539478999996],
              [161.2993270190001, -10.263116143999923],
              [161.292328321, -10.247491143999923],
              [161.29184004, -10.225762627999927],
              [161.30005944100003, -10.20712655999995],
              [161.31910241000003, -10.20045338299991],
              [161.32447350400003, -10.203301690999922],
              [161.3300887380001, -10.205336195999905],
              [161.33570397200003, -10.20867278399993],
              [161.3408309250001, -10.214043877999927],
              [161.39600670700008, -10.20403411299992],
              [161.50220787900003, -10.250746351999908],
              [161.60954837300005, -10.316827080999929],
              [161.66863040500004, -10.36492278399993],
              [161.68726647200003, -10.357598565999922],
              [161.7002059250001, -10.365492445999905],
              [161.72038821700005, -10.396091403999947],
              [161.73511803500003, -10.405368747999944],
              [161.750824415, -10.406996351999908],
              [161.76587975400003, -10.405857028999947],
              [161.77849368600005, -10.406508070999905],
              [161.7910262380001, -10.41179778399993],
              [161.82056725400003, -10.42978280999995],
              [161.8261824880001, -10.43718840899993],
              [161.83570397200003, -10.44695403399993],
              [161.85726972700002, -10.447930596999925],
              [161.88054446700005, -10.442803643999923],
              [161.89519290500004, -10.433770440999922],
              [161.93246504, -10.445977471999925],
              [161.94947350400003, -10.44695403399993],
              [161.96355228000004, -10.440606377999927],
              [161.97234134200005, -10.44850025799991],
              [161.98707116000003, -10.467217705999929],
              [161.99756920700008, -10.474786065999922],
              [162.00928795700008, -10.478448174999926],
              [162.04184004, -10.474786065999922],
              [162.05884850400003, -10.47828541499996],
              [162.06397545700008, -10.47584400799991],
              [162.06853274800005, -10.45476653399993],
              [162.0752059250001, -10.449639580999929],
              [162.08423912900003, -10.447686455999929],
              [162.0937606130001, -10.447523695999905],
              [162.113617384, -10.456475518999923],
              [162.14039147200003, -10.493747653999947],
              [162.151703321, -10.502129815999922],
              [162.1630965500001, -10.50872161299992],
              [162.17139733200008, -10.524021091999941],
              [162.191742384, -10.57789478999996],
              [162.1962996750001, -10.584649346999925],
              [162.2036238940001, -10.590427341999941],
              [162.21021569100003, -10.592461846999925],
              [162.2153426440001, -10.596774997999944],
              [162.22046959700003, -10.629571221999925],
              [162.228851759, -10.64462655999995],
              [162.24195397200003, -10.656182549999926],
              [162.27751712300005, -10.679620049999926],
              [162.28777103000004, -10.691989841999941],
              [162.29175866000003, -10.707696221999925],
              [162.2920028000001, -10.764743747999944],
              [162.28891035200002, -10.76962655999995],
              [162.282562696, -10.771742445999905],
              [162.27523847700002, -10.776950778999947],
              [162.26880944100003, -10.783379815999922],
              [162.264984571, -10.789483330999929],
              [162.27173912900003, -10.814385674999926],
              [162.30347741000003, -10.819431247999944],
              [162.34343509200005, -10.81804778399993],
              [162.37484785200002, -10.823663018999923],
            ],
          ],
          [
            [
              [167.17335045700008, -9.88640715899993],
              [167.16578209700003, -9.868340752999927],
              [167.17017662900003, -9.85914478999996],
              [167.18083743600005, -9.860121351999908],
              [167.192230665, -9.872979424999926],
              [167.19597415500004, -9.885918877999927],
              [167.1933699880001, -9.893731377999927],
              [167.18531334700003, -9.89462655999995],
              [167.17335045700008, -9.88640715899993],
            ],
          ],
          [
            [
              [167.0918074880001, -9.803317966999941],
              [167.1045028000001, -9.801853122999944],
              [167.10824629, -9.804620049999926],
              [167.1040145190001, -9.806573174999926],
              [167.0918074880001, -9.803317966999941],
            ],
          ],
          [
            [
              [161.97779381600003, -9.851006768999923],
              [161.96363366000003, -9.839288018999923],
              [161.950043165, -9.816827080999929],
              [161.94019616000003, -9.790134372999944],
              [161.92847741000003, -9.720147393999923],
              [161.92994225400003, -9.706963799999926],
              [161.94019616000003, -9.692152601999908],
              [161.9521590500001, -9.69036223799992],
              [161.96509850400003, -9.691827080999929],
              [161.97779381600003, -9.686618747999944],
              [161.9785262380001, -9.694756768999923],
              [161.97681725400003, -9.699965101999908],
              [161.97087649800005, -9.706963799999926],
              [161.969086134, -9.71453215899993],
              [161.96753991000003, -9.71770598799992],
              [161.96355228000004, -9.720635674999926],
              [161.9697371750001, -9.734958591999941],
              [161.9824324880001, -9.817559502999927],
              [161.9824324880001, -9.834161065999922],
              [161.97779381600003, -9.851006768999923],
            ],
          ],
          [
            [
              [161.39478600400003, -9.412774346999925],
              [161.39039147200003, -9.414727471999925],
              [161.379242384, -9.41765715899993],
              [161.3750106130001, -9.41961028399993],
              [161.3750106130001, -9.398695570999905],
              [161.36841881600003, -9.379571221999925],
              [161.347015821, -9.343926690999922],
              [161.35434004, -9.338555596999925],
              [161.35914147200003, -9.339288018999923],
              [161.367523634, -9.35133228999996],
              [161.3808699880001, -9.365166924999926],
              [161.41521243600005, -9.38600025799991],
              [161.422211134, -9.39576588299991],
              [161.4262801440001, -9.411716403999947],
              [161.45630944100003, -9.453789971999925],
              [161.48170006600003, -9.504652601999908],
              [161.49390709700003, -9.518975518999923],
              [161.49927819100003, -9.527276299999926],
              [161.50668379, -9.549493096999925],
              [161.5146590500001, -9.56023528399993],
              [161.524261915, -9.570489190999922],
              [161.532074415, -9.581475518999923],
              [161.54517662900003, -9.604668877999927],
              [161.55193118600005, -9.622979424999926],
              [161.55396569100003, -9.64031340899993],
              [161.55250084700003, -9.676364841999941],
              [161.55591881600003, -9.69304778399993],
              [161.57048587300005, -9.72633228999996],
              [161.57300866000003, -9.748630466999941],
              [161.56820722700002, -9.77117278399993],
              [161.5586043630001, -9.788995049999926],
              [161.549164259, -9.792575778999947],
              [161.54517662900003, -9.772230726999908],
              [161.50407962300005, -9.72747161299992],
              [161.4946395190001, -9.703057549999926],
              [161.4882918630001, -9.692071221999925],
              [161.477386915, -9.686618747999944],
              [161.46648196700005, -9.689873955999929],
              [161.459320509, -9.717868747999944],
              [161.44890384200005, -9.734958591999941],
              [161.4326278000001, -9.717950127999927],
              [161.4150496750001, -9.69459400799991],
              [161.400726759, -9.67001718499995],
              [161.39478600400003, -9.649021091999941],
              [161.39478600400003, -9.587823174999926],
              [161.39478600400003, -9.529473565999922],
              [161.39234459700003, -9.50758228999996],
              [161.392914259, -9.494886976999908],
              [161.4091903000001, -9.465997002999927],
              [161.40609785200002, -9.449965101999908],
              [161.39820397200003, -9.433526299999926],
              [161.39478600400003, -9.412774346999925],
            ],
          ],
          [
            [
              [160.82634524800005, -9.837334893999923],
              [160.8247176440001, -9.86728280999995],
              [160.79851321700005, -9.88404713299991],
              [160.72331790500004, -9.899509372999944],
              [160.68425540500004, -9.91187916499996],
              [160.66293379, -9.922946872999944],
              [160.64478600400003, -9.937107028999947],
              [160.57252037900003, -9.91920338299991],
              [160.508636915, -9.889255466999941],
              [160.4868270190001, -9.885186455999929],
              [160.4458113940001, -9.89267343499995],
              [160.43287194100003, -9.889092705999929],
              [160.424164259, -9.88014088299991],
              [160.41675866000003, -9.869073174999926],
              [160.40796959700003, -9.858493747999944],
              [160.403656446, -9.85751718499995],
              [160.391937696, -9.859307549999926],
              [160.387543165, -9.858493747999944],
              [160.38502037900003, -9.854913018999923],
              [160.37842858200008, -9.842054945999905],
              [160.37378991000003, -9.837334893999923],
              [160.3442488940001, -9.825616143999923],
              [160.3359481130001, -9.820245049999926],
              [160.3203231130001, -9.815118096999925],
              [160.20826256600003, -9.810153903999947],
              [160.12387129, -9.82317473799992],
              [160.0791121750001, -9.823825778999947],
              [160.05152428500003, -9.820489190999922],
              [160.040375196, -9.820570570999905],
              [160.0312606130001, -9.823825778999947],
              [160.02458743600005, -9.820245049999926],
              [160.003265821, -9.816827080999929],
              [159.98113040500004, -9.810967705999929],
              [159.9589949880001, -9.809340101999908],
              [159.93726647200003, -9.80559661299992],
              [159.90308678500003, -9.787855726999908],
              [159.8872176440001, -9.782810153999947],
              [159.86784915500004, -9.785739841999941],
              [159.85181725400003, -9.79273853999996],
              [159.83562259200005, -9.79387786299992],
              [159.8149520190001, -9.77898528399993],
              [159.76872806100005, -9.73219166499996],
              [159.75074303500003, -9.720635674999926],
              [159.72339928500003, -9.706963799999926],
              [159.72234134200005, -9.70281340899993],
              [159.723968946, -9.69109465899993],
              [159.72339928500003, -9.686618747999944],
              [159.71941165500004, -9.682386976999908],
              [159.71111087300005, -9.680271091999941],
              [159.70590254, -9.676364841999941],
              [159.7021590500001, -9.667575778999947],
              [159.7011824880001, -9.657403252999927],
              [159.69906660200002, -9.649102471999925],
              [159.69206790500004, -9.645603122999944],
              [159.67530358200008, -9.643243096999925],
              [159.67212975400003, -9.636976820999905],
              [159.6748153000001, -9.628106377999927],
              [159.67497806100005, -9.617608330999929],
              [159.66570071700005, -9.595147393999923],
              [159.65398196700005, -9.574802341999941],
              [159.6396590500001, -9.55641041499996],
              [159.623383009, -9.539727471999925],
              [159.6084090500001, -9.528903903999947],
              [159.60181725400003, -9.521905205999929],
              [159.59913170700008, -9.512383721999925],
              [159.61215254, -9.505791924999926],
              [159.62175540500004, -9.498223565999922],
              [159.62720787900003, -9.48796965899993],
              [159.62525475400003, -9.477634372999944],
              [159.61109459700003, -9.45712655999995],
              [159.60670006600003, -9.447523695999905],
              [159.606293165, -9.435804945999905],
              [159.61353600400003, -9.409356377999927],
              [159.61247806100005, -9.398858330999929],
              [159.607758009, -9.385511976999908],
              [159.60670006600003, -9.374932549999926],
              [159.596039259, -9.364434502999927],
              [159.592133009, -9.361504815999922],
              [159.59644616000003, -9.354913018999923],
              [159.60670006600003, -9.343926690999922],
              [159.60954837300005, -9.30982838299991],
              [159.61597741000003, -9.295342705999929],
              [159.63062584700003, -9.289239190999922],
              [159.64616946700005, -9.284763278999947],
              [159.7089949880001, -9.24773528399993],
              [159.74366295700008, -9.25953541499996],
              [159.77898196700005, -9.281996351999908],
              [159.83269290500004, -9.330254815999922],
              [159.87330162900003, -9.35947030999995],
              [159.879730665, -9.36809661299992],
              [159.884125196, -9.382419528999947],
              [159.89470462300005, -9.399590752999927],
              [159.9082137380001, -9.415622653999947],
              [159.92139733200008, -9.426446221999925],
              [159.93970787900003, -9.43287525799991],
              [159.9609481130001, -9.434665622999944],
              [159.99984785200002, -9.43328215899993],
              [160.0102645190001, -9.431817315999922],
              [160.01978600400003, -9.427666924999926],
              [160.02800540500004, -9.422133070999905],
              [160.03467858200008, -9.416192315999922],
              [160.0434676440001, -9.41415780999995],
              [160.05616295700008, -9.417413018999923],
              [160.0791121750001, -9.426446221999925],
              [160.09913170700008, -9.431898695999905],
              [160.1098738940001, -9.433526299999926],
              [160.12061608200008, -9.43328215899993],
              [160.13038170700008, -9.429294528999947],
              [160.14795983200008, -9.41570403399993],
              [160.15772545700008, -9.412774346999925],
              [160.179047071, -9.41497161299992],
              [160.21119225400003, -9.424248955999929],
              [160.2304793630001, -9.426446221999925],
              [160.23715254, -9.424574476999908],
              [160.24561608200008, -9.41570403399993],
              [160.2509871750001, -9.412774346999925],
              [160.25652103000004, -9.413262627999927],
              [160.26514733200008, -9.418715101999908],
              [160.27076256600003, -9.41961028399993],
              [160.34595787900003, -9.41961028399993],
              [160.34986412900003, -9.418552341999941],
              [160.36011803500003, -9.413506768999923],
              [160.36638431100005, -9.412774346999925],
              [160.36793053500003, -9.41497161299992],
              [160.37232506600003, -9.41961028399993],
              [160.37818444100003, -9.424248955999929],
              [160.3984481130001, -9.43287525799991],
              [160.41920006600003, -9.461114190999922],
              [160.459320509, -9.475030205999929],
              [160.4755965500001, -9.493259372999944],
              [160.50367272200003, -9.536309502999927],
              [160.54078209700003, -9.531426690999922],
              [160.5864363940001, -9.551364841999941],
              [160.62842858200008, -9.582289320999905],
              [160.65447024800005, -9.610772393999923],
              [160.661468946, -9.627618096999925],
              [160.66570071700005, -9.64812590899993],
              [160.6679793630001, -9.690036716999941],
              [160.67302493600005, -9.698011976999908],
              [160.683929884, -9.698337497999944],
              [160.69996178500003, -9.69345468499995],
              [160.71265709700003, -9.69540780999995],
              [160.722992384, -9.70045338299991],
              [160.74382571700005, -9.713962497999944],
              [160.77711022200003, -9.722832940999922],
              [160.78541100400003, -9.72747161299992],
              [160.78785241000003, -9.73756275799991],
              [160.78695722700002, -9.751560153999947],
              [160.7895613940001, -9.763848565999922],
              [160.802093946, -9.769138278999947],
              [160.805511915, -9.774021091999941],
              [160.80648847700002, -9.78492603999996],
              [160.80583743600005, -9.80632903399993],
              [160.80827884200005, -9.816013278999947],
              [160.81364993600005, -9.82203541499996],
              [160.8203231130001, -9.82789478999996],
              [160.82634524800005, -9.837334893999923],
            ],
          ],
          [
            [
              [159.82886803500003, -9.172621351999908],
              [159.81470787900003, -9.166192315999922],
              [159.80616295700008, -9.150323174999926],
              [159.80445397200003, -9.13014088299991],
              [159.8115340500001, -9.11109791499996],
              [159.81763756600003, -9.109795830999929],
              [159.82252037900003, -9.109958591999941],
              [159.82732181100005, -9.10865650799991],
              [159.83269290500004, -9.103692315999922],
              [159.84009850400003, -9.12273528399993],
              [159.8447371750001, -9.14544036299992],
              [159.84253991000003, -9.164646091999941],
              [159.82886803500003, -9.172621351999908],
            ],
          ],
          [
            [
              [160.25407962300005, -9.158949476999908],
              [160.26514733200008, -9.155694268999923],
              [160.27662194100003, -9.147881768999923],
              [160.285980665, -9.138929945999905],
              [160.2920028000001, -9.131605726999908],
              [160.3046981130001, -9.082614841999941],
              [160.3149520190001, -9.061700127999927],
              [160.33228600400003, -9.06340911299992],
              [160.35922285200002, -9.110935153999947],
              [160.3701278000001, -9.117933851999908],
              [160.3852645190001, -9.11842213299991],
              [160.39722741000003, -9.120212497999944],
              [160.40642337300005, -9.124444268999923],
              [160.41423587300005, -9.131605726999908],
              [160.40202884200005, -9.144138278999947],
              [160.3872176440001, -9.17083098799992],
              [160.37378991000003, -9.17937590899993],
              [160.36638431100005, -9.186211846999925],
              [160.34498131600003, -9.179294528999947],
              [160.3247176440001, -9.167413018999923],
              [160.30494225400003, -9.15984465899993],
              [160.2851668630001, -9.16578541499996],
              [160.28931725400003, -9.177992445999905],
              [160.2744246750001, -9.18645598799992],
              [160.25147545700008, -9.191338799999926],
              [160.2304793630001, -9.19304778399993],
              [160.2353621750001, -9.185153903999947],
              [160.23462975400003, -9.178806247999944],
              [160.22828209700003, -9.174493096999925],
              [160.216156446, -9.172621351999908],
              [160.22193444100003, -9.162774346999925],
              [160.2304793630001, -9.158868096999925],
              [160.25407962300005, -9.158949476999908],
            ],
          ],
          [
            [
              [159.19516035200002, -9.056573174999926],
              [159.20533287900003, -9.055108330999929],
              [159.22584069100003, -9.031426690999922],
              [159.23609459700003, -9.023044528999947],
              [159.23585045700008, -9.027520440999922],
              [159.23422285200002, -9.03020598799992],
              [159.23170006600003, -9.032647393999923],
              [159.22925866000003, -9.03606536299992],
              [159.22925866000003, -9.046075127999927],
              [159.227386915, -9.04859791499996],
              [159.22925866000003, -9.056573174999926],
              [159.21949303500003, -9.06617603999996],
              [159.217133009, -9.07512786299992],
              [159.22250410200002, -9.079685153999947],
              [159.23609459700003, -9.076348565999922],
              [159.23324629, -9.101006768999923],
              [159.2187606130001, -9.117364190999922],
              [159.17408287900003, -9.13844166499996],
              [159.17497806100005, -9.11142343499995],
              [159.17839603000004, -9.09270598799992],
              [159.19516035200002, -9.056573174999926],
            ],
          ],
          [
            [
              [160.0966903000001, -9.056573174999926],
              [160.08936608200008, -9.055352471999925],
              [160.08375084700003, -9.05201588299991],
              [160.08033287900003, -9.04664478999996],
              [160.0791121750001, -9.039483330999929],
              [160.08716881600003, -9.037041924999926],
              [160.10515384200005, -9.035088799999926],
              [160.12387129, -9.02939218499995],
              [160.13428795700008, -9.015557549999926],
              [160.1411238940001, -9.023044528999947],
              [160.145843946, -9.015069268999923],
              [160.14763431100005, -9.00872161299992],
              [160.14600670700008, -9.002536716999941],
              [160.1411238940001, -8.994398695999905],
              [160.1450301440001, -8.99000416499996],
              [160.14771569100003, -8.989678643999923],
              [160.154633009, -8.994398695999905],
              [160.17253665500004, -9.002211195999905],
              [160.19092858200008, -9.000420830999929],
              [160.20850670700008, -9.002699476999908],
              [160.222992384, -9.023044528999947],
              [160.2304793630001, -9.023044528999947],
              [160.2402449880001, -9.006280205999929],
              [160.25798587300005, -9.00904713299991],
              [160.27800540500004, -9.023044528999947],
              [160.29509524800005, -9.039483330999929],
              [160.30144290500004, -9.061618747999944],
              [160.29468834700003, -9.08993905999995],
              [160.28052819100003, -9.115980726999908],
              [160.26449629, -9.131605726999908],
              [160.261078321, -9.12395598799992],
              [160.25757897200003, -9.12078215899993],
              [160.252289259, -9.12118905999995],
              [160.2441512380001, -9.124200127999927],
              [160.24293053500003, -9.112399997999944],
              [160.2373153000001, -9.103448174999926],
              [160.22820071700005, -9.098321221999925],
              [160.216156446, -9.097588799999926],
              [160.21859785200002, -9.102959893999923],
              [160.222992384, -9.117933851999908],
              [160.216156446, -9.117933851999908],
              [160.19988040500004, -9.091729424999926],
              [160.1875106130001, -9.08180103999996],
              [160.1718856130001, -9.087009372999944],
              [160.1567488940001, -9.094008070999905],
              [160.13819420700008, -9.094821872999944],
              [160.11996504, -9.090590101999908],
              [160.106293165, -9.08375416499996],
              [160.10425866000003, -9.07789478999996],
              [160.103851759, -9.068780205999929],
              [160.10230553500003, -9.06023528399993],
              [160.0966903000001, -9.056573174999926],
            ],
          ],
          [
            [
              [159.16716556100005, -9.017998955999929],
              [159.1748153000001, -9.01653411299992],
              [159.19516035200002, -9.023044528999947],
              [159.16163170700008, -9.090020440999922],
              [159.14730879, -9.103692315999922],
              [159.0996199880001, -9.117933851999908],
              [159.09099368600005, -9.111993096999925],
              [159.0839949880001, -9.101739190999922],
              [159.0761824880001, -9.095961195999905],
              [159.064789259, -9.103692315999922],
              [159.03931725400003, -9.068536065999922],
              [159.0410262380001, -9.057305596999925],
              [159.0722762380001, -9.056573174999926],
              [159.06609134200005, -9.043226820999905],
              [159.0693465500001, -9.033786716999941],
              [159.07886803500003, -9.03053150799991],
              [159.092133009, -9.03606536299992],
              [159.092133009, -9.023044528999947],
              [159.09693444100003, -9.024834893999923],
              [159.11255944100003, -9.029229424999926],
              [159.11117597700002, -9.018731377999927],
              [159.10726972700002, -9.00953541499996],
              [159.10084069100003, -9.001397393999923],
              [159.092133009, -8.994398695999905],
              [159.1064559250001, -8.994398695999905],
              [159.1162215500001, -8.99928150799991],
              [159.1240340500001, -8.999932549999926],
              [159.1298934250001, -8.996351820999905],
              [159.133636915, -8.98837655999995],
              [159.14039147200003, -9.001885674999926],
              [159.141937696, -9.012383721999925],
              [159.14437910200002, -9.020928643999923],
              [159.1543074880001, -9.029229424999926],
              [159.15935306100005, -9.02906666499996],
              [159.16716556100005, -9.017998955999929],
            ],
          ],
          [
            [
              [160.0791121750001, -9.023044528999947],
              [160.06666100400003, -9.013604424999926],
              [160.06804446700005, -9.003350518999923],
              [160.07496178500003, -8.991794528999947],
              [160.0791121750001, -8.977715752999927],
              [160.07439212300005, -8.951348565999922],
              [160.07764733200008, -8.94312916499996],
              [160.09262129, -8.940524997999944],
              [160.1084090500001, -8.961195570999905],
              [160.1137801440001, -8.97429778399993],
              [160.11312910200002, -8.994398695999905],
              [160.09913170700008, -8.988457940999922],
              [160.0908309250001, -8.99578215899993],
              [160.0791121750001, -9.023044528999947],
            ],
          ],
          [
            [
              [157.61548912900003, -8.73447030999995],
              [157.63550866000003, -8.744073174999926],
              [157.64991295700008, -8.765232028999947],
              [157.6489363940001, -8.786228122999944],
              [157.62232506600003, -8.79583098799992],
              [157.61353600400003, -8.79306405999995],
              [157.57764733200008, -8.77467213299991],
              [157.5297957690001, -8.76181405999995],
              [157.47673587300005, -8.73951588299991],
              [157.45240319100003, -8.721856377999927],
              [157.45533287900003, -8.706475518999923],
              [157.4926863940001, -8.712009372999944],
              [157.5087996750001, -8.71257903399993],
              [157.52369225400003, -8.706475518999923],
              [157.5297957690001, -8.713962497999944],
              [157.53825931100005, -8.70086028399993],
              [157.543793165, -8.694919528999947],
              [157.54965254, -8.692152601999908],
              [157.55884850400003, -8.693780205999929],
              [157.56462649800005, -8.698825778999947],
              [157.5688582690001, -8.70403411299992],
              [157.57390384200005, -8.706475518999923],
              [157.59058678500003, -8.710870049999926],
              [157.600922071, -8.72039153399993],
              [157.60824629, -8.730075778999947],
              [157.61548912900003, -8.73447030999995],
            ],
          ],
          [
            [
              [158.22877037900003, -8.77467213299991],
              [158.25668379, -8.785577080999929],
              [158.25562584700003, -8.794854424999926],
              [158.25220787900003, -8.802666924999926],
              [158.24675540500004, -8.808038018999923],
              [158.223968946, -8.81373463299991],
              [158.2031356130001, -8.83098723799992],
              [158.18718509200005, -8.83684661299992],
              [158.16822350400003, -8.807224216999941],
              [158.16358483200008, -8.80201588299991],
              [158.153656446, -8.79656340899993],
              [158.153656446, -8.78411223799992],
              [158.160492384, -8.758396091999941],
              [158.16521243600005, -8.749200127999927],
              [158.19459069100003, -8.726983330999929],
              [158.19996178500003, -8.71803150799991],
              [158.20427493600005, -8.706638278999947],
              [158.20720462300005, -8.69345468499995],
              [158.20826256600003, -8.679131768999923],
              [158.21509850400003, -8.679131768999923],
              [158.21509850400003, -8.700290622999944],
              [158.22339928500003, -8.71493905999995],
              [158.23023522200003, -8.73796965899993],
              [158.23267662900003, -8.760837497999944],
              [158.22877037900003, -8.77467213299991],
            ],
          ],
          [
            [
              [158.05689537900003, -8.52825286299992],
              [158.07764733200008, -8.52353280999995],
              [158.10279381600003, -8.523614190999922],
              [158.12378991000003, -8.530368747999944],
              [158.13249759200005, -8.545505466999941],
              [158.13502037900003, -8.566827080999929],
              [158.13347415500004, -8.574151299999926],
              [158.12574303500003, -8.58294036299992],
              [158.11638431100005, -8.58562590899993],
              [158.10515384200005, -8.584649346999925],
              [158.09555097700002, -8.585544528999947],
              [158.09156334700003, -8.59351978999996],
              [158.0869246750001, -8.597100518999923],
              [158.06755618600005, -8.604668877999927],
              [158.0649520190001, -8.610935153999947],
              [158.07097415500004, -8.61687590899993],
              [158.09058678500003, -8.619805596999925],
              [158.09839928500003, -8.624607028999947],
              [158.1040145190001, -8.621026299999926],
              [158.10824629, -8.619561455999929],
              [158.11890709700003, -8.617771091999941],
              [158.10621178500003, -8.63453541499996],
              [158.0996199880001, -8.640232028999947],
              [158.09156334700003, -8.645114841999941],
              [158.1142684250001, -8.66773853999996],
              [158.10572350400003, -8.69109465899993],
              [158.0649520190001, -8.726983330999929],
              [158.05250084700003, -8.74578215899993],
              [158.04761803500003, -8.751397393999923],
              [158.03858483200008, -8.75676848799992],
              [158.02116946700005, -8.760837497999944],
              [158.01335696700005, -8.765232028999947],
              [157.9990340500001, -8.76726653399993],
              [157.976898634, -8.76262786299992],
              [157.9570418630001, -8.75595468499995],
              [157.9482528000001, -8.751397393999923],
              [157.94556725400003, -8.744724216999941],
              [157.9394637380001, -8.740166924999926],
              [157.9277449880001, -8.73447030999995],
              [157.92335045700008, -8.72942473799992],
              [157.91749108200008, -8.719008070999905],
              [157.91334069100003, -8.713962497999944],
              [157.884125196, -8.688246351999908],
              [157.879242384, -8.68254973799992],
              [157.879242384, -8.631442966999941],
              [157.886078321, -8.59661223799992],
              [157.89014733200008, -8.590590101999908],
              [157.89600670700008, -8.584730726999908],
              [157.9004012380001, -8.576429945999905],
              [157.899750196, -8.562432549999926],
              [157.9267684250001, -8.578871351999908],
              [157.93767337300005, -8.57935963299991],
              [157.9414168630001, -8.562432549999926],
              [157.9482528000001, -8.56340911299992],
              [157.9516707690001, -8.566338799999926],
              [157.9550887380001, -8.576755466999941],
              [157.96314537900003, -8.56373463299991],
              [157.96045983200008, -8.554131768999923],
              [157.9550887380001, -8.543715101999908],
              [157.9550887380001, -8.52825286299992],
              [157.96119225400003, -8.52157968499995],
              [157.99594160200002, -8.50790780999995],
              [158.00359134200005, -8.506442966999941],
              [158.00652103000004, -8.505059502999927],
              [158.00961347700002, -8.501071872999944],
              [158.01710045700008, -8.50790780999995],
              [158.01710045700008, -8.514743747999944],
              [158.008636915, -8.520928643999923],
              [158.005218946, -8.528497002999927],
              [158.0068465500001, -8.53687916499996],
              [158.01335696700005, -8.545505466999941],
              [158.0263778000001, -8.550957940999922],
              [158.03728274800005, -8.545505466999941],
              [158.04704837300005, -8.535821221999925],
              [158.05689537900003, -8.52825286299992],
            ],
          ],
          [
            [
              [157.35865319100003, -8.576755466999941],
              [157.35425866000003, -8.576755466999941],
              [157.34986412900003, -8.57390715899993],
              [157.3447371750001, -8.572523695999905],
              [157.33806399800005, -8.576755466999941],
              [157.33668053500003, -8.58180103999996],
              [157.33806399800005, -8.604099216999941],
              [157.3305770190001, -8.63290780999995],
              [157.32935631600003, -8.649102471999925],
              [157.33464603000004, -8.662367445999905],
              [157.37086022200003, -8.70086028399993],
              [157.3911238940001, -8.715020440999922],
              [157.41382897200003, -8.72079843499995],
              [157.41382897200003, -8.726983330999929],
              [157.39820397200003, -8.73056405999995],
              [157.37956790500004, -8.72975025799991],
              [157.361664259, -8.725274346999925],
              [157.34831790500004, -8.717380466999941],
              [157.33668053500003, -8.70598723799992],
              [157.32960045700008, -8.701836846999925],
              [157.320648634, -8.700290622999944],
              [157.31226647200003, -8.69622161299992],
              [157.31072024800005, -8.686618747999944],
              [157.3115340500001, -8.675225518999923],
              [157.31080162900003, -8.666192315999922],
              [157.30420983200008, -8.654717705999929],
              [157.2778426440001, -8.618584893999923],
              [157.2661238940001, -8.610935153999947],
              [157.2500106130001, -8.605726820999905],
              [157.22836347700002, -8.59343840899993],
              [157.20915774800005, -8.578383070999905],
              [157.20093834700003, -8.565850518999923],
              [157.2036238940001, -8.551527601999908],
              [157.21013431100005, -8.539239190999922],
              [157.21892337300005, -8.529229424999926],
              [157.22820071700005, -8.52157968499995],
              [157.2548934250001, -8.50750090899993],
              [157.2700301440001, -8.496514580999929],
              [157.2890731130001, -8.459161065999922],
              [157.317230665, -8.43173593499995],
              [157.34750410200002, -8.412530205999929],
              [157.36597741000003, -8.412855726999908],
              [157.38404381600003, -8.424981377999927],
              [157.399261915, -8.444024346999925],
              [157.40992272200003, -8.468926690999922],
              [157.41382897200003, -8.497979424999926],
              [157.41041100400003, -8.504327080999929],
              [157.395843946, -8.52117278399993],
              [157.38542728000004, -8.554620049999926],
              [157.3828231130001, -8.559340101999908],
              [157.38005618600005, -8.562676690999922],
              [157.37818444100003, -8.56926848799992],
              [157.3759871750001, -8.573011976999908],
              [157.36980228000004, -8.57789478999996],
              [157.3652449880001, -8.57822030999995],
              [157.36158287900003, -8.576755466999941],
              [157.35865319100003, -8.576755466999941],
            ],
          ],
          [
            [
              [159.68864993600005, -8.50790780999995],
              [159.70036868600005, -8.51848723799992],
              [159.69947350400003, -8.524997653999947],
              [159.68864993600005, -8.53525155999995],
              [159.67953535200002, -8.540134372999944],
              [159.670258009, -8.541436455999929],
              [159.65992272200003, -8.539646091999941],
              [159.64771569100003, -8.53525155999995],
              [159.63624108200008, -8.529229424999926],
              [159.6279403000001, -8.522637627999927],
              [159.61353600400003, -8.50790780999995],
              [159.60141035200002, -8.488864841999941],
              [159.59302819100003, -8.48528411299992],
              [159.57935631600003, -8.494805596999925],
              [159.56527754, -8.479099216999941],
              [159.5498153000001, -8.47079843499995],
              [159.53882897200003, -8.458916924999926],
              [159.53785241000003, -8.432793877999927],
              [159.54517662900003, -8.406426690999922],
              [159.55827884200005, -8.389418226999908],
              [159.57829837300005, -8.38014088299991],
              [159.60670006600003, -8.377536716999941],
              [159.63591556100005, -8.384209893999923],
              [159.64405358200008, -8.400323174999926],
              [159.64087975400003, -8.44703541499996],
              [159.6469832690001, -8.46843840899993],
              [159.658539259, -8.48251718499995],
              [159.68864993600005, -8.50790780999995],
            ],
          ],
          [
            [
              [162.738617384, -8.38836028399993],
              [162.7304793630001, -8.37818775799991],
              [162.7348738940001, -8.373793226999908],
              [162.74561608200008, -8.37428150799991],
              [162.75757897200003, -8.378513278999947],
              [162.75407962300005, -8.38250090899993],
              [162.74984785200002, -8.385186455999929],
              [162.744476759, -8.386976820999905],
              [162.738617384, -8.38836028399993],
            ],
          ],
          [
            [
              [161.360687696, -9.617608330999929],
              [161.308929884, -9.581638278999947],
              [161.2993270190001, -9.580743096999925],
              [161.29656009200005, -9.56373463299991],
              [161.289398634, -9.54859791499996],
              [161.24976647200003, -9.497165622999944],
              [161.2446395190001, -9.48796965899993],
              [161.2421981130001, -9.478122653999947],
              [161.24048912900003, -9.45867278399993],
              [161.23715254, -9.447523695999905],
              [161.22632897200003, -9.430433851999908],
              [161.17920983200008, -9.38176848799992],
              [161.110687696, -9.347263278999947],
              [161.086761915, -9.31959400799991],
              [161.0400496750001, -9.313246351999908],
              [161.0454207690001, -9.296075127999927],
              [161.01742597700002, -9.264743747999944],
              [161.0039168630001, -9.25514088299991],
              [160.99626712300005, -9.25367603999996],
              [160.98015384200005, -9.25514088299991],
              [160.9731551440001, -9.251397393999923],
              [160.96998131600003, -9.244073174999926],
              [160.97152754, -9.227634372999944],
              [160.9697371750001, -9.22039153399993],
              [160.94646243600005, -9.20012786299992],
              [160.88990319100003, -9.174981377999927],
              [160.86793053500003, -9.15211353999996],
              [160.795258009, -9.01930103999996],
              [160.777679884, -8.970310153999947],
              [160.76433353000004, -8.946709893999923],
              [160.76970462300005, -8.939060153999947],
              [160.77133222700002, -8.93336353999996],
              [160.76970462300005, -8.927666924999926],
              [160.76433353000004, -8.92001718499995],
              [160.7636824880001, -8.905450127999927],
              [160.74822024800005, -8.85515715899993],
              [160.7343856130001, -8.83367278399993],
              [160.69312584700003, -8.75123463299991],
              [160.68930097700002, -8.73756275799991],
              [160.68873131600003, -8.68368905999995],
              [160.686859571, -8.674574476999908],
              [160.65447024800005, -8.604099216999941],
              [160.67204837300005, -8.592380466999941],
              [160.701508009, -8.567152601999908],
              [160.71989993600005, -8.562432549999926],
              [160.71998131600003, -8.553399346999925],
              [160.69597415500004, -8.501071872999944],
              [160.65642337300005, -8.44931405999995],
              [160.6513778000001, -8.439629815999922],
              [160.63843834700003, -8.43328215899993],
              [160.60434004, -8.399997653999947],
              [160.59351647200003, -8.384942315999922],
              [160.5810653000001, -8.340508721999925],
              [160.60132897200003, -8.32545338299991],
              [160.63843834700003, -8.32976653399993],
              [160.67554772200003, -8.343357028999947],
              [160.6953231130001, -8.361586195999905],
              [160.70281009200005, -8.36451588299991],
              [160.71314537900003, -8.362399997999944],
              [160.723968946, -8.356866143999923],
              [160.73023522200003, -8.349053643999923],
              [160.72681725400003, -8.340264580999929],
              [160.69597415500004, -8.32008228999996],
              [160.69874108200008, -8.313083591999941],
              [160.70573978000004, -8.306247653999947],
              [160.71461022200003, -8.30201588299991],
              [160.72331790500004, -8.302992445999905],
              [160.72331790500004, -8.309258721999925],
              [160.7465926440001, -8.309665622999944],
              [160.75896243600005, -8.316664320999905],
              [160.7778426440001, -8.343357028999947],
              [160.7900496750001, -8.35320403399993],
              [160.80046634200005, -8.358819268999923],
              [160.80982506600003, -8.36728280999995],
              [160.81950931100005, -8.384942315999922],
              [160.82398522200003, -8.397149346999925],
              [160.82569420700008, -8.40553150799991],
              [160.82634524800005, -8.415948174999926],
              [160.8291121750001, -8.42083098799992],
              [160.84294681100005, -8.429294528999947],
              [160.84742272200003, -8.432793877999927],
              [160.88103274800005, -8.483982028999947],
              [160.93287194100003, -8.539320570999905],
              [160.9731551440001, -8.573011976999908],
              [160.99683678500003, -8.603773695999905],
              [161.00660241000003, -8.62281666499996],
              [161.01059004, -8.64153411299992],
              [161.00269616000003, -8.662367445999905],
              [160.983734571, -8.674086195999905],
              [160.96119225400003, -8.682224216999941],
              [160.9423934250001, -8.692152601999908],
              [160.94906660200002, -8.705336195999905],
              [160.95337975400003, -8.71851978999996],
              [160.95297285200002, -8.731622002999927],
              [160.93702233200008, -8.758884372999944],
              [160.93677819100003, -8.771661065999922],
              [160.94019616000003, -8.78443775799991],
              [160.9423934250001, -8.799004815999922],
              [160.946625196, -8.81373463299991],
              [160.9653426440001, -8.831231377999927],
              [160.9697371750001, -8.840508721999925],
              [160.975922071, -8.850274346999925],
              [160.99008222700002, -8.847832940999922],
              [161.014008009, -8.83684661299992],
              [161.02295983200008, -8.84075286299992],
              [161.05030358200008, -8.861260674999926],
              [161.0590926440001, -8.871026299999926],
              [161.05974368600005, -8.878024997999944],
              [161.055511915, -8.883477471999925],
              [161.053070509, -8.889743747999944],
              [161.0590926440001, -8.898858330999929],
              [161.06714928500003, -8.903497002999927],
              [161.07374108200008, -8.903008721999925],
              [161.0781356130001, -8.90048593499995],
              [161.07960045700008, -8.898858330999929],
              [161.10303795700008, -8.90984465899993],
              [161.12810306100005, -8.92742278399993],
              [161.15113366000003, -8.949639580999929],
              [161.1689559250001, -8.974541924999926],
              [161.15593509200005, -8.969496351999908],
              [161.14576256600003, -8.977308851999908],
              [161.14283287900003, -8.988702080999929],
              [161.15154056100005, -8.994398695999905],
              [161.16358483200008, -8.999444268999923],
              [161.175140821, -9.011651299999926],
              [161.18091881600003, -9.027520440999922],
              [161.1757918630001, -9.042901299999926],
              [161.1845809250001, -9.04778411299992],
              [161.1884871750001, -9.054131768999923],
              [161.18962649800005, -9.06226978999996],
              [161.1894637380001, -9.072930596999925],
              [161.19125410200002, -9.083428643999923],
              [161.1962996750001, -9.08603280999995],
              [161.20289147200003, -9.086195570999905],
              [161.2099715500001, -9.090020440999922],
              [161.2158309250001, -9.094170830999929],
              [161.22282962300005, -9.09775155999995],
              [161.22868899800005, -9.103692315999922],
              [161.2309676440001, -9.11451588299991],
              [161.2275496750001, -9.119073174999926],
              [161.202484571, -9.13844166499996],
              [161.2207137380001, -9.146661065999922],
              [161.2270613940001, -9.151788018999923],
              [161.2309676440001, -9.158949476999908],
              [161.24398847700002, -9.153903903999947],
              [161.25570722700002, -9.156914971999925],
              [161.2617293630001, -9.165948174999926],
              [161.2583113940001, -9.17937590899993],
              [161.26587975400003, -9.180352471999925],
              [161.28492272200003, -9.186211846999925],
              [161.28492272200003, -9.19304778399993],
              [161.2578231130001, -9.19931405999995],
              [161.24781334700003, -9.199883721999925],
              [161.24431399800005, -9.205254815999922],
              [161.2451278000001, -9.216973565999922],
              [161.24927819100003, -9.228692315999922],
              [161.25464928500003, -9.23406340899993],
              [161.26099694100003, -9.24187590899993],
              [161.26685631600003, -9.278008721999925],
              [161.27881920700008, -9.289239190999922],
              [161.26531009200005, -9.29656340899993],
              [161.25904381600003, -9.29029713299991],
              [161.25416100400003, -9.280368747999944],
              [161.2446395190001, -9.275648695999905],
              [161.2353621750001, -9.281182549999926],
              [161.23755944100003, -9.29192473799992],
              [161.24586022200003, -9.303887627999927],
              [161.28532962300005, -9.344414971999925],
              [161.29664147200003, -9.36028411299992],
              [161.3281356130001, -9.438571872999944],
              [161.33716881600003, -9.447523695999905],
              [161.3476668630001, -9.455824476999908],
              [161.3618270190001, -9.474867445999905],
              [161.38111412900003, -9.50904713299991],
              [161.3930770190001, -9.58766041499996],
              [161.3925887380001, -9.60906340899993],
              [161.38640384200005, -9.621758721999925],
              [161.37566165500004, -9.624932549999926],
              [161.360687696, -9.617608330999929],
            ],
          ],
          [
            [
              [157.12517337300005, -8.27507903399993],
              [157.13062584700003, -8.30828215899993],
              [157.138031446, -8.32236093499995],
              [157.15251712300005, -8.32976653399993],
              [157.15251712300005, -8.33717213299991],
              [157.1235457690001, -8.32040780999995],
              [157.10906009200005, -8.28329843499995],
              [157.09058678500003, -8.249118747999944],
              [157.05005944100003, -8.240899346999925],
              [157.05355879, -8.23796965899993],
              [157.06006920700008, -8.23056405999995],
              [157.06373131600003, -8.227308851999908],
              [157.0473738940001, -8.219903252999927],
              [157.02995853000004, -8.20631275799991],
              [157.02263431100005, -8.192803643999923],
              [157.03638756600003, -8.185723565999922],
              [157.04997806100005, -8.196709893999923],
              [157.07585696700005, -8.19850025799991],
              [157.10084069100003, -8.203545830999929],
              [157.11207116000003, -8.22389088299991],
              [157.113617384, -8.236748955999929],
              [157.12517337300005, -8.27507903399993],
            ],
          ],
          [
            [
              [157.20769290500004, -8.28875090899993],
              [157.20093834700003, -8.28875090899993],
              [157.19898522200003, -8.274590752999927],
              [157.1914168630001, -8.271905205999929],
              [157.18181399800005, -8.272556247999944],
              [157.17302493600005, -8.26881275799991],
              [157.16911868600005, -8.26140715899993],
              [157.15992272200003, -8.233493747999944],
              [157.1504012380001, -8.215915622999944],
              [157.1391707690001, -8.20094166499996],
              [157.12452233200008, -8.188653252999927],
              [157.10466556100005, -8.178887627999927],
              [157.11207116000003, -8.172621351999908],
              [157.10181725400003, -8.17164478999996],
              [157.09717858200008, -8.169122002999927],
              [157.09644616000003, -8.16497161299992],
              [157.09782962300005, -8.158949476999908],
              [157.12232506600003, -8.167413018999923],
              [157.14568118600005, -8.16570403399993],
              [157.167328321, -8.167413018999923],
              [157.18726647200003, -8.185723565999922],
              [157.19678795700008, -8.20671965899993],
              [157.2041121750001, -8.232842705999929],
              [157.20826256600003, -8.261325778999947],
              [157.20769290500004, -8.28875090899993],
            ],
          ],
          [
            [
              [156.8105574880001, -8.055352471999925],
              [156.81421959700003, -8.07203541499996],
              [156.8247176440001, -8.06959400799991],
              [156.84131920700008, -8.11296965899993],
              [156.8154403000001, -8.111993096999925],
              [156.7856551440001, -8.086195570999905],
              [156.789886915, -8.055352471999925],
              [156.8105574880001, -8.055352471999925],
            ],
          ],
          [
            [
              [157.7973738940001, -8.562432549999926],
              [157.8110457690001, -8.570733330999929],
              [157.82048587300005, -8.583184502999927],
              [157.823578321, -8.599216403999947],
              [157.81788170700008, -8.617771091999941],
              [157.8110457690001, -8.617771091999941],
              [157.80884850400003, -8.60133228999996],
              [157.80152428500003, -8.590915622999944],
              [157.79363040500004, -8.584242445999905],
              [157.789886915, -8.57984791499996],
              [157.786468946, -8.565524997999944],
              [157.7778426440001, -8.551527601999908],
              [157.75570722700002, -8.52825286299992],
              [157.72934004, -8.513929945999905],
              [157.6748153000001, -8.509209893999923],
              [157.64966881600003, -8.497979424999926],
              [157.60564212300005, -8.467461846999925],
              [157.5820418630001, -8.439385674999926],
              [157.57764733200008, -8.436211846999925],
              [157.57601972700002, -8.42156340899993],
              [157.56788170700008, -8.398858330999929],
              [157.56462649800005, -8.384942315999922],
              [157.56462649800005, -8.32350025799991],
              [157.57203209700003, -8.335056247999944],
              [157.57593834700003, -8.346856377999927],
              [157.57764733200008, -8.374444268999923],
              [157.5830184250001, -8.38648853999996],
              [157.6064559250001, -8.392998955999929],
              [157.6118270190001, -8.40203215899993],
              [157.61500084700003, -8.412367445999905],
              [157.6220809250001, -8.410739841999941],
              [157.62907962300005, -8.401136976999908],
              [157.63233483200008, -8.38836028399993],
              [157.6269637380001, -8.378024997999944],
              [157.60336347700002, -8.355726820999905],
              [157.5937606130001, -8.323337497999944],
              [157.58269290500004, -8.299411716999941],
              [157.56706790500004, -8.27629973799992],
              [157.54965254, -8.26140715899993],
              [157.53736412900003, -8.258396091999941],
              [157.528168165, -8.26100025799991],
              [157.5180770190001, -8.265801690999922],
              [157.50261478000004, -8.26881275799991],
              [157.4961043630001, -8.264743747999944],
              [157.48894290500004, -8.257419528999947],
              [157.481781446, -8.25595468499995],
              [157.47584069100003, -8.26881275799991],
              [157.4648543630001, -8.262302341999941],
              [157.45655358200008, -8.262302341999941],
              [157.44109134200005, -8.26881275799991],
              [157.44011478000004, -8.269707940999922],
              [157.4321395190001, -8.273614190999922],
              [157.42750084700003, -8.27507903399993],
              [157.39340254, -8.275567315999922],
              [157.3564559250001, -8.272067966999941],
              [157.34489993600005, -8.27507903399993],
              [157.33619225400003, -8.289320570999905],
              [157.32960045700008, -8.308038018999923],
              [157.3188582690001, -8.32586028399993],
              [157.29712975400003, -8.33717213299991],
              [157.27955162900003, -8.333428643999923],
              [157.24537194100003, -8.313653252999927],
              [157.23503665500004, -8.316664320999905],
              [157.22820071700005, -8.316664320999905],
              [157.22193444100003, -8.22389088299991],
              [157.22486412900003, -8.21770598799992],
              [157.2392684250001, -8.197523695999905],
              [157.24537194100003, -8.19312916499996],
              [157.25961347700002, -8.19304778399993],
              [157.27125084700003, -8.191664320999905],
              [157.28101647200003, -8.18759530999995],
              [157.29029381600003, -8.178887627999927],
              [157.29509524800005, -8.191827080999929],
              [157.30201256600003, -8.195733330999929],
              [157.309906446, -8.192966403999947],
              [157.3169051440001, -8.185723565999922],
              [157.31999759200005, -8.176527601999908],
              [157.32007897200003, -8.154961846999925],
              [157.32439212300005, -8.144789320999905],
              [157.32097415500004, -8.132989190999922],
              [157.326508009, -8.119398695999905],
              [157.34831790500004, -8.093194268999923],
              [157.35824629, -8.07822030999995],
              [157.37322024800005, -8.04461028399993],
              [157.3828231130001, -8.031508070999905],
              [157.42546634200005, -7.989841403999947],
              [157.44109134200005, -7.979668877999927],
              [157.45720462300005, -7.973565362999921],
              [157.48747806100005, -7.965590101999908],
              [157.50261478000004, -7.959730726999908],
              [157.50212649800005, -7.964450778999947],
              [157.50342858200008, -7.965590101999908],
              [157.50611412900003, -7.965752862999921],
              [157.50945071700005, -7.966566664999959],
              [157.57886803500003, -8.00554778399993],
              [157.60564212300005, -8.00758228999996],
              [157.5986434250001, -8.025567315999922],
              [157.60173587300005, -8.038262627999927],
              [157.60816491000003, -8.050388278999947],
              [157.6118270190001, -8.06617603999996],
              [157.61052493600005, -8.104180596999925],
              [157.61247806100005, -8.12273528399993],
              [157.61931399800005, -8.13795338299991],
              [157.6098738940001, -8.15634530999995],
              [157.61312910200002, -8.169122002999927],
              [157.63599694100003, -8.189385674999926],
              [157.64470462300005, -8.20517343499995],
              [157.64177493600005, -8.21770598799992],
              [157.63697350400003, -8.229099216999941],
              [157.6396590500001, -8.240899346999925],
              [157.6464949880001, -8.23365650799991],
              [157.6523543630001, -8.235121351999908],
              [157.6587020190001, -8.23951588299991],
              [157.6670028000001, -8.240899346999925],
              [157.67335045700008, -8.238457940999922],
              [157.68539472700002, -8.23056405999995],
              [157.6943465500001, -8.227308851999908],
              [157.7138778000001, -8.22356536299992],
              [157.73015384200005, -8.223402601999908],
              [157.74586022200003, -8.228692315999922],
              [157.77458743600005, -8.24928150799991],
              [157.77849368600005, -8.253350518999923],
              [157.7837020190001, -8.26140715899993],
              [157.78589928500003, -8.267754815999922],
              [157.789886915, -8.28875090899993],
              [157.80225670700008, -8.305352471999925],
              [157.8281356130001, -8.322849216999941],
              [157.8383895190001, -8.33717213299991],
              [157.836761915, -8.36223723799992],
              [157.8383895190001, -8.371270440999922],
              [157.84400475400003, -8.380303643999923],
              [157.85954837300005, -8.392510674999926],
              [157.865570509, -8.398614190999922],
              [157.87387129, -8.415459893999923],
              [157.88038170700008, -8.450290622999944],
              [157.886078321, -8.467461846999925],
              [157.8906356130001, -8.47079843499995],
              [157.89714603000004, -8.471368096999925],
              [157.9033309250001, -8.47356536299992],
              [157.9072371750001, -8.481133721999925],
              [157.90691165500004, -8.490899346999925],
              [157.9033309250001, -8.499118747999944],
              [157.88355553500003, -8.531996351999908],
              [157.88111412900003, -8.537774346999925],
              [157.879242384, -8.54892343499995],
              [157.8789168630001, -8.558200778999947],
              [157.88013756600003, -8.566989841999941],
              [157.88257897200003, -8.57512786299992],
              [157.886078321, -8.58294036299992],
              [157.82447350400003, -8.558851820999905],
              [157.7973738940001, -8.55632903399993],
              [157.7973738940001, -8.562432549999926],
            ],
          ],
          [
            [
              [156.61117597700002, -8.072686455999929],
              [156.61597741000003, -8.09856536299992],
              [156.61646569100003, -8.112481377999927],
              [156.61117597700002, -8.124932549999926],
              [156.61898847700002, -8.14617278399993],
              [156.61597741000003, -8.170668226999908],
              [156.60466556100005, -8.191013278999947],
              [156.58741295700008, -8.199395440999922],
              [156.57837975400003, -8.187107028999947],
              [156.5532332690001, -8.114027601999908],
              [156.538422071, -8.09148528399993],
              [156.535980665, -8.06926848799992],
              [156.5429793630001, -8.02117278399993],
              [156.532074415, -7.970635674999926],
              [156.53239993600005, -7.94890715899993],
              [156.5498153000001, -7.939222914999959],
              [156.56470787900003, -7.952080987999921],
              [156.5771590500001, -7.966566664999959],
              [156.58155358200008, -7.977146091999941],
              [156.58765709700003, -8.000664971999925],
              [156.60108483200008, -8.023370049999926],
              [156.6064559250001, -8.040622653999947],
              [156.61003665500004, -8.058526299999926],
              [156.61117597700002, -8.072686455999929],
            ],
          ],
          [
            [
              [157.10466556100005, -8.124932549999926],
              [157.05420983200008, -8.129082940999922],
              [157.002289259, -8.08684661299992],
              [156.96216881600003, -8.02743905999995],
              [156.94703209700003, -7.979668877999927],
              [156.94874108200008, -7.967054945999905],
              [156.9521590500001, -7.955010674999926],
              [156.961273634, -7.932549737999921],
              [156.98511803500003, -7.896091403999947],
              [156.98853600400003, -7.888116143999923],
              [157.0019637380001, -7.875176690999922],
              [157.03272545700008, -7.86296965899993],
              [157.06706790500004, -7.854099216999941],
              [157.09107506600003, -7.850518487999921],
              [157.137543165, -7.874769789999959],
              [157.1704207690001, -7.909926039999959],
              [157.19125410200002, -7.952894789999959],
              [157.20093834700003, -8.000746351999908],
              [157.20232181100005, -8.048272393999923],
              [157.19947350400003, -8.065199476999908],
              [157.18433678500003, -8.10670338299991],
              [157.16724694100003, -8.135511976999908],
              [157.14625084700003, -8.148614190999922],
              [157.12517337300005, -8.124932549999926],
              [157.11670983200008, -8.128106377999927],
              [157.11255944100003, -8.12859465899993],
              [157.10466556100005, -8.124932549999926],
            ],
          ],
          [
            [
              [156.8071395190001, -7.720147393999923],
              [156.81470787900003, -7.734551690999922],
              [156.79948978000004, -7.766534112999921],
              [156.7627059250001, -7.816501559999949],
              [156.74398847700002, -7.831963799999926],
              [156.7197371750001, -7.857028903999947],
              [156.7041121750001, -7.885023695999905],
              [156.71119225400003, -7.908868096999925],
              [156.72055097700002, -7.921075127999927],
              [156.7207137380001, -7.931817315999922],
              [156.7133895190001, -7.940362237999921],
              [156.70069420700008, -7.945489190999922],
              [156.69752037900003, -7.941989841999941],
              [156.68921959700003, -7.93523528399993],
              [156.678070509, -7.932305596999925],
              [156.666351759, -7.939222914999959],
              [156.65967858200008, -7.939222914999959],
              [156.65748131600003, -7.919122002999927],
              [156.66179446700005, -7.899102471999925],
              [156.65894616000003, -7.883965752999927],
              [156.6118270190001, -7.871189059999949],
              [156.6084090500001, -7.854587497999944],
              [156.61866295700008, -7.813083591999941],
              [156.61475670700008, -7.805108330999929],
              [156.605804884, -7.798435153999947],
              [156.59636478000004, -7.792738539999959],
              [156.5908309250001, -7.788506768999923],
              [156.57781009200005, -7.761651299999926],
              [156.57097415500004, -7.754327080999929],
              [156.554047071, -7.748630466999941],
              [156.5532332690001, -7.747491143999923],
              [156.54517662900003, -7.746514580999929],
              [156.54420006600003, -7.743584893999923],
              [156.545258009, -7.739353122999944],
              [156.53484134200005, -7.716566664999959],
              [156.52881920700008, -7.713311455999929],
              [156.5156356130001, -7.720147393999923],
              [156.4970809250001, -7.674981377999927],
              [156.50416100400003, -7.630059502999927],
              [156.53077233200008, -7.592461846999925],
              [156.57097415500004, -7.569431247999944],
              [156.5839949880001, -7.572442315999922],
              [156.59327233200008, -7.576836846999925],
              [156.6015731130001, -7.577569268999923],
              [156.61117597700002, -7.569431247999944],
              [156.614105665, -7.57781340899993],
              [156.61939537900003, -7.585137627999927],
              [156.63168379, -7.596774997999944],
              [156.634125196, -7.601820570999905],
              [156.63306725400003, -7.606215101999908],
              [156.63396243600005, -7.609307549999926],
              [156.64958743600005, -7.611260674999926],
              [156.65259850400003, -7.614190362999921],
              [156.65308678500003, -7.619398695999905],
              [156.6528426440001, -7.627373955999929],
              [156.657074415, -7.631442966999941],
              [156.66675866000003, -7.635430596999925],
              [156.67644290500004, -7.64226653399993],
              [156.68482506600003, -7.66570403399993],
              [156.69459069100003, -7.672295830999929],
              [156.7148543630001, -7.678643487999921],
              [156.7075301440001, -7.686130466999941],
              [156.721039259, -7.700372002999927],
              [156.74366295700008, -7.691827080999929],
              [156.7661238940001, -7.699883721999925],
              [156.7876082690001, -7.713148695999905],
              [156.8071395190001, -7.720147393999923],
            ],
          ],
          [
            [
              [155.5703231130001, -7.322930596999925],
              [155.586273634, -7.331231377999927],
              [155.59742272200003, -7.342054945999905],
              [155.60670006600003, -7.353692315999922],
              [155.6181746750001, -7.363946221999925],
              [155.59742272200003, -7.382907809999949],
              [155.5761824880001, -7.387872002999927],
              [155.52523847700002, -7.383884372999944],
              [155.50798587300005, -7.375746351999908],
              [155.51441491000003, -7.357517184999949],
              [155.542328321, -7.322930596999925],
              [155.5493270190001, -7.325290622999944],
              [155.55494225400003, -7.325127862999921],
              [155.5703231130001, -7.322930596999925],
            ],
          ],
          [
            [
              [155.816742384, -7.020684502999927],
              [155.8466903000001, -7.027927341999941],
              [155.85425866000003, -7.031508070999905],
              [155.868011915, -7.04851653399993],
              [155.86793053500003, -7.061944268999923],
              [155.86207116000003, -7.075778903999947],
              [155.85824629, -7.092950127999927],
              [155.850922071, -7.09929778399993],
              [155.83415774800005, -7.104180596999925],
              [155.81560306100005, -7.105889580999929],
              [155.803070509, -7.10320403399993],
              [155.78663170700008, -7.117852471999925],
              [155.7700301440001, -7.117608330999929],
              [155.7529403000001, -7.115492445999905],
              [155.7348738940001, -7.12428150799991],
              [155.7255965500001, -7.119561455999929],
              [155.71412194100003, -7.108575127999927],
              [155.70687910200002, -7.10320403399993],
              [155.67855879, -7.094496351999908],
              [155.6728621750001, -7.08953215899993],
              [155.67448978000004, -7.075941664999959],
              [155.70069420700008, -7.020684502999927],
              [155.70883222700002, -7.025485934999949],
              [155.7119246750001, -7.010674737999921],
              [155.71794681100005, -6.992445570999905],
              [155.7348738940001, -6.986504815999922],
              [155.7314559250001, -6.978610934999949],
              [155.73194420700008, -6.972426039999959],
              [155.7348738940001, -6.96607838299991],
              [155.747406446, -6.970879815999922],
              [155.782562696, -7.000746351999908],
              [155.816742384, -7.020684502999927],
            ],
          ],
          [
            [
              [156.11841881600003, -6.918226820999905],
              [156.126312696, -6.922458591999941],
              [156.14527428500003, -6.927911065999922],
              [156.15259850400003, -6.93132903399993],
              [156.14275149800005, -6.937269789999959],
              [156.13209069100003, -6.93873463299991],
              [156.121429884, -6.936455987999921],
              [156.11158287900003, -6.93132903399993],
              [156.10914147200003, -6.946872653999947],
              [156.10434004, -6.962090752999927],
              [156.09636478000004, -6.975762627999927],
              [156.08366946700005, -6.986504815999922],
              [156.0825301440001, -6.978773695999905],
              [156.08073978000004, -6.974786065999922],
              [156.0786238940001, -6.971449476999908],
              [156.07683353000004, -6.96607838299991],
              [156.07007897200003, -6.974053643999923],
              [156.06226647200003, -6.979099216999941],
              [156.05298912900003, -6.981133721999925],
              [156.04273522200003, -6.980401299999926],
              [156.0586043630001, -6.969414971999925],
              [156.07341556100005, -6.955743096999925],
              [156.0766707690001, -6.947523695999905],
              [156.07203209700003, -6.94068775799991],
              [156.06568444100003, -6.933770440999922],
              [156.06373131600003, -6.92506275799991],
              [156.06714928500003, -6.910902601999908],
              [156.07146243600005, -6.906426690999922],
              [156.08025149800005, -6.904554945999905],
              [156.08716881600003, -6.90162525799991],
              [156.08179772200003, -6.895684502999927],
              [156.0732528000001, -6.890801690999922],
              [156.06999759200005, -6.890883070999905],
              [156.0571395190001, -6.872002862999921],
              [156.0468856130001, -6.851657809999949],
              [156.04965254, -6.83171965899993],
              [156.07683353000004, -6.815199476999908],
              [156.09791100400003, -6.815199476999908],
              [156.09791100400003, -6.822035414999959],
              [156.08415774800005, -6.82545338299991],
              [156.07341556100005, -6.833184502999927],
              [156.0664168630001, -6.844903252999927],
              [156.06373131600003, -6.859633070999905],
              [156.07252037900003, -6.867933851999908],
              [156.08969160200002, -6.87232838299991],
              [156.1025496750001, -6.87818775799991],
              [156.09791100400003, -6.890883070999905],
              [156.11280358200008, -6.912692966999941],
              [156.11841881600003, -6.918226820999905],
            ],
          ],
          [
            [
              [166.92391983100003, -11.640971530999934],
              [166.92519697300008, -11.65489905399994],
              [166.9240164150001, -11.674288607999927],
              [166.97844818300007, -11.670487411999943],
              [166.98414885900002, -11.709863308999957],
              [166.909277362, -11.714936541999919],
              [166.88824117500008, -11.71742209499996],
              [166.87152398800004, -11.716865791999908],
              [166.84302083900002, -11.713315820999924],
              [166.82810604100007, -11.693353071999923],
              [166.81617272200003, -11.682305596999925],
              [166.80250084700003, -11.677178643999923],
              [166.79707518200007, -11.669793317999961],
              [166.77967890800005, -11.648618],
              [166.767248257, -11.633490164999955],
              [166.76720340400004, -11.617119510999942],
              [166.775225267, -11.606793230999926],
              [166.7851253030001, -11.601316001999919],
              [166.80553196900007, -11.591568312999925],
              [166.8241092720001, -11.591526288999944],
              [166.84701321500006, -11.592680611999924],
              [166.86988366000003, -11.588962497999944],
              [166.893445229, -11.593783980999945],
              [166.9355595090001, -11.60881300299991],
              [166.92391983100003, -11.640971530999934],
            ],
          ],
          [
            [
              [166.557251608, -11.28364365799996],
              [166.53416335500003, -11.308094010999923],
              [166.52652088000002, -11.30889579999996],
              [166.516451952, -11.31127930799994],
              [166.50882668000008, -11.309319081999945],
              [166.5004818550001, -11.304603408999924],
              [166.50020672000005, -11.297913562999952],
              [166.50076424400004, -11.288876229999914],
              [166.50684756500004, -11.28140389899994],
              [166.51031904500007, -11.274680456999931],
              [166.50912724900002, -11.260914753999941],
              [166.49496605000002, -11.269270890999906],
              [166.48344922400008, -11.278662434999944],
              [166.47769368900003, -11.269983340999943],
              [166.4797598890001, -11.247421582999948],
              [166.494266315, -11.229276881999908],
              [166.51185567000005, -11.213424037999914],
              [166.52510941700007, -11.209051679999959],
              [166.54042407400004, -11.214563966999947],
              [166.5557598590001, -11.22679070299995],
              [166.5639000660001, -11.241026076999958],
              [166.56471155100007, -11.259934441999917],
              [166.557251608, -11.28364365799996],
            ],
          ],
          [
            [
              [166.1479045860001, -10.694046401999913],
              [166.137015238, -10.705320459999939],
              [166.13298587300005, -10.724786065999922],
              [166.095687633, -10.739230041999917],
              [166.083719955, -10.74983680999992],
              [166.06538683300005, -10.758285702999956],
              [166.0545014600001, -10.766732049999916],
              [166.03500410200002, -10.76539478999996],
              [166.028168165, -10.76726653399993],
              [166.00237615100002, -10.757215739999936],
              [165.98978341200007, -10.766809691999924],
              [165.980804884, -10.773370049999926],
              [165.969574415, -10.770196221999925],
              [165.934219654, -10.775741309999944],
              [165.89180492800006, -10.824105366999959],
              [165.86196457200003, -10.868540143999951],
              [165.849358252, -10.856151121999915],
              [165.85239241600004, -10.828618244999916],
              [165.840417741, -10.814567534999924],
              [165.82836962200008, -10.812300544999914],
              [165.80008040300004, -10.837543283999935],
              [165.770235328, -10.835823172999937],
              [165.75647434100006, -10.812161111999956],
              [165.75362772000005, -10.772741720999932],
              [165.75303038800007, -10.751887720999946],
              [165.772150054, -10.738498526999933],
              [165.78117098000007, -10.724901682999928],
              [165.79263405300003, -10.70913670799996],
              [165.8018129080001, -10.708588093999936],
              [165.79741707000005, -10.743064641999922],
              [165.81216988000006, -10.759318133999955],
              [165.82194985400008, -10.762164557999938],
              [165.8270938820001, -10.749212321999948],
              [165.828210097, -10.733987447999937],
              [165.83121829800007, -10.707651219999946],
              [165.84784080400004, -10.684607855999957],
              [165.87806236100005, -10.656846509999923],
              [165.92334342200002, -10.653539278999915],
              [165.99452654000004, -10.661139485999911],
              [166.02666374600005, -10.647016063999956],
              [166.061174328, -10.654032591999908],
              [166.0781356130001, -10.66301848799992],
              [166.08090254, -10.66765715899993],
              [166.0849715500001, -10.672051690999922],
              [166.11466989100006, -10.668155578999915],
              [166.142757318, -10.669251218999932],
              [166.1479045860001, -10.694046401999913],
            ],
          ],
          [
            [
              [158.48609459700003, -7.610284112999921],
              [158.50066165500004, -7.61646900799991],
              [158.5166121750001, -7.630954684999949],
              [158.52654056100005, -7.647067966999941],
              [158.52361087300005, -7.658135674999926],
              [158.5078231130001, -7.65984465899993],
              [158.49293053500003, -7.651055596999925],
              [158.4814559250001, -7.637302341999941],
              [158.4751082690001, -7.623955987999921],
              [158.46461022200003, -7.637383721999925],
              [158.44556725400003, -7.633070570999905],
              [158.40691165500004, -7.610284112999921],
              [158.40886478000004, -7.619805596999925],
              [158.42115319100003, -7.64381275799991],
              [158.41138756600003, -7.643649997999944],
              [158.38648522200003, -7.637627862999921],
              [158.36215254, -7.637627862999921],
              [158.363617384, -7.631280205999929],
              [158.3593856130001, -7.617120049999926],
              [158.34791100400003, -7.603122653999947],
              [158.32797285200002, -7.596774997999944],
              [158.3242293630001, -7.59343840899993],
              [158.31918379, -7.586521091999941],
              [158.3169051440001, -7.57935963299991],
              [158.321136915, -7.576267184999949],
              [158.33073978000004, -7.577325127999927],
              [158.3466903000001, -7.581801039999959],
              [158.35222415500004, -7.582452080999929],
              [158.3540145190001, -7.584405205999929],
              [158.36247806100005, -7.586195570999905],
              [158.3681746750001, -7.58367278399993],
              [158.36215254, -7.572849216999941],
              [158.36215254, -7.567071221999925],
              [158.3691512380001, -7.562758070999905],
              [158.37875410200002, -7.562676690999922],
              [158.38648522200003, -7.569431247999944],
              [158.39795983200008, -7.574639580999929],
              [158.42261803500003, -7.579685153999947],
              [158.43433678500003, -7.595147393999923],
              [158.45101972700002, -7.603122653999947],
              [158.47046959700003, -7.608493747999944],
              [158.48609459700003, -7.610284112999921],
            ],
          ],
          [
            [
              [159.8593856130001, -8.511325778999947],
              [159.88884524800005, -8.533786716999941],
              [159.9004012380001, -8.550713799999926],
              [159.8872176440001, -8.562432549999926],
              [159.878265821, -8.560723565999922],
              [159.84636478000004, -8.542087497999944],
              [159.84156334700003, -8.54111093499995],
              [159.82992597700002, -8.54273853999996],
              [159.825043165, -8.542087497999944],
              [159.82007897200003, -8.53679778399993],
              [159.817718946, -8.529961846999925],
              [159.81470787900003, -8.524021091999941],
              [159.7973738940001, -8.51726653399993],
              [159.785492384, -8.49895598799992],
              [159.76482181100005, -8.49228280999995],
              [159.7578231130001, -8.485528252999927],
              [159.74390709700003, -8.467461846999925],
              [159.71241295700008, -8.44312916499996],
              [159.70289147200003, -8.432793877999927],
              [159.70069420700008, -8.423028252999927],
              [159.70281009200005, -8.414239190999922],
              [159.70036868600005, -8.40789153399993],
              [159.68523196700005, -8.405450127999927],
              [159.6738387380001, -8.398695570999905],
              [159.62720787900003, -8.357598565999922],
              [159.5439559250001, -8.340020440999922],
              [159.5083113940001, -8.318536065999922],
              [159.4834090500001, -8.30828215899993],
              [159.46111087300005, -8.289727471999925],
              [159.44483483200008, -8.281182549999926],
              [159.4277449880001, -8.277276299999926],
              [159.41431725400003, -8.281914971999925],
              [159.38062584700003, -8.261651299999926],
              [159.3623153000001, -8.256280205999929],
              [159.34538821700005, -8.26140715899993],
              [159.335297071, -8.23837655999995],
              [159.3261824880001, -8.22584400799991],
              [159.31470787900003, -8.22047291499996],
              [159.3007918630001, -8.219333591999941],
              [159.2876082690001, -8.21493905999995],
              [159.27849368600005, -8.206638278999947],
              [159.27711022200003, -8.19312916499996],
              [159.25538170700008, -8.200372002999927],
              [159.23389733200008, -8.19622161299992],
              [159.21363366000003, -8.18531666499996],
              [159.11996504, -8.117445570999905],
              [159.1137801440001, -8.116387627999927],
              [159.09839928500003, -8.118584893999923],
              [159.092133009, -8.117445570999905],
              [159.0879012380001, -8.11101653399993],
              [159.08708743600005, -8.102146091999941],
              [159.087250196, -8.093926690999922],
              [159.0859481130001, -8.08953215899993],
              [159.07797285200002, -8.088148695999905],
              [159.07390384200005, -8.09189218499995],
              [159.07048587300005, -8.096286716999941],
              [159.064789259, -8.09693775799991],
              [159.037445509, -8.08326588299991],
              [159.03101647200003, -8.082289320999905],
              [159.0166121750001, -8.084161065999922],
              [159.010101759, -8.08326588299991],
              [159.00993899800005, -8.080498955999929],
              [159.00554446700005, -8.066827080999929],
              [159.003265821, -8.062758070999905],
              [158.99203535200002, -8.05754973799992],
              [158.98357181100005, -8.055108330999929],
              [158.97803795700008, -8.049574476999908],
              [158.97608483200008, -8.03492603999996],
              [158.96941165500004, -8.03997161299992],
              [158.94809004, -8.049086195999905],
              [158.9462996750001, -8.029229424999926],
              [158.93734785200002, -8.013929945999905],
              [158.9228621750001, -8.004164320999905],
              [158.90406334700003, -8.000746351999908],
              [158.8457137380001, -7.973402601999908],
              [158.8403426440001, -7.93523528399993],
              [158.8320418630001, -7.917901299999926],
              [158.8149520190001, -7.922539971999925],
              [158.78443444100003, -7.915215752999927],
              [158.769867384, -7.905857028999947],
              [158.7773543630001, -7.891534112999921],
              [158.76636803500003, -7.879327080999929],
              [158.7563582690001, -7.871026299999926],
              [158.74952233200008, -7.871026299999926],
              [158.73902428500003, -7.884535414999959],
              [158.7285262380001, -7.872002862999921],
              [158.7148543630001, -7.836195570999905],
              [158.7036238940001, -7.822930596999925],
              [158.6884871750001, -7.811211846999925],
              [158.67115319100003, -7.805108330999929],
              [158.65398196700005, -7.809665622999944],
              [158.64429772200003, -7.791761976999908],
              [158.60075931100005, -7.767754815999922],
              [158.5849715500001, -7.754327080999929],
              [158.5800887380001, -7.740817966999941],
              [158.5805770190001, -7.730238539999959],
              [158.58326256600003, -7.720635674999926],
              [158.5849715500001, -7.710056247999944],
              [158.5849715500001, -7.668633721999925],
              [158.5068465500001, -7.603610934999949],
              [158.45533287900003, -7.576267184999949],
              [158.44654381600003, -7.560723565999922],
              [158.44507897200003, -7.543552341999941],
              [158.45199629, -7.531996351999908],
              [158.46892337300005, -7.534600518999923],
              [158.48951256600003, -7.546970309999949],
              [158.58773847700002, -7.580336195999905],
              [158.59595787900003, -7.585870049999926],
              [158.60572350400003, -7.586195570999905],
              [158.614593946, -7.574314059999949],
              [158.62525475400003, -7.56414153399993],
              [158.6396590500001, -7.569431247999944],
              [158.64332116000003, -7.565606377999927],
              [158.64616946700005, -7.563571872999944],
              [158.649261915, -7.562432549999926],
              [158.65398196700005, -7.561293226999908],
              [158.66130618600005, -7.580987237999921],
              [158.6757918630001, -7.593845309999949],
              [158.7148543630001, -7.610284112999921],
              [158.7187606130001, -7.604424737999921],
              [158.7255965500001, -7.597426039999959],
              [158.73308353000004, -7.591566664999959],
              [158.7392684250001, -7.589288018999923],
              [158.75171959700003, -7.59343840899993],
              [158.75700931100005, -7.603610934999949],
              [158.7602645190001, -7.615980726999908],
              [158.7666121750001, -7.627373955999929],
              [158.7861434250001, -7.645684502999927],
              [158.798187696, -7.654473565999922],
              [158.80811608200008, -7.658135674999926],
              [158.8144637380001, -7.664727471999925],
              [158.83025149800005, -7.693780205999929],
              [158.84839928500003, -7.70435963299991],
              [158.8637801440001, -7.724867445999905],
              [158.87232506600003, -7.733819268999923],
              [158.8847762380001, -7.741306247999944],
              [158.92074629, -7.754327080999929],
              [158.93864993600005, -7.765069268999923],
              [158.9687606130001, -7.79070403399993],
              [158.98975670700008, -7.802178643999923],
              [158.9795028000001, -7.82195403399993],
              [158.98707116000003, -7.839613539999959],
              [159.00269616000003, -7.84889088299991],
              [159.016937696, -7.843682549999926],
              [159.05689537900003, -7.859958591999941],
              [159.06861412900003, -7.867608330999929],
              [159.07545006600003, -7.880303643999923],
              [159.07935631600003, -7.894952080999929],
              [159.08570397200003, -7.90357838299991],
              [159.0996199880001, -7.898370049999926],
              [159.12680097700002, -7.919528903999947],
              [159.1494246750001, -7.908868096999925],
              [159.1679793630001, -7.904880466999941],
              [159.18628991000003, -7.906182549999926],
              [159.20826256600003, -7.911879164999959],
              [159.19556725400003, -7.91765715899993],
              [159.19874108200008, -7.926853122999944],
              [159.20923912900003, -7.935479424999926],
              [159.2187606130001, -7.939222914999959],
              [159.235687696, -7.940850518999923],
              [159.2451278000001, -7.945570570999905],
              [159.25074303500003, -7.954196872999944],
              [159.2558699880001, -7.966566664999959],
              [159.27295983200008, -7.954034112999921],
              [159.28305097700002, -7.962660414999959],
              [159.2910262380001, -7.978692315999922],
              [159.3012801440001, -7.987074476999908],
              [159.33383222700002, -7.989841403999947],
              [159.34717858200008, -7.986097914999959],
              [159.35279381600003, -7.973402601999908],
              [159.37134850400003, -7.981866143999923],
              [159.3789168630001, -7.986748955999929],
              [159.38697350400003, -7.993910414999959],
              [159.40259850400003, -7.982354424999926],
              [159.41293379, -7.99342213299991],
              [159.42156009200005, -8.014255466999941],
              [159.4316512380001, -8.031508070999905],
              [159.44792728000004, -8.04387786299992],
              [159.47632897200003, -8.05950286299992],
              [159.48943118600005, -8.06959400799991],
              [159.49203535200002, -8.071058851999908],
              [159.50367272200003, -8.07586028399993],
              [159.5058699880001, -8.07903411299992],
              [159.5083113940001, -8.087090752999927],
              [159.50993899800005, -8.08953215899993],
              [159.55640709700003, -8.126397393999923],
              [159.6489363940001, -8.181247653999947],
              [159.84205162900003, -8.325616143999923],
              [159.84644616000003, -8.335381768999923],
              [159.825043165, -8.357598565999922],
              [159.80420983200008, -8.386163018999923],
              [159.79664147200003, -8.391778252999927],
              [159.78785241000003, -8.38681405999995],
              [159.77662194100003, -8.38404713299991],
              [159.76539147200003, -8.385349216999941],
              [159.7568465500001, -8.391778252999927],
              [159.75757897200003, -8.397556247999944],
              [159.77328535200002, -8.408623955999929],
              [159.781586134, -8.425388278999947],
              [159.7910262380001, -8.425388278999947],
              [159.80046634200005, -8.420668226999908],
              [159.8086043630001, -8.41179778399993],
              [159.81788170700008, -8.420098565999922],
              [159.84791100400003, -8.461602471999925],
              [159.8559676440001, -8.47665780999995],
              [159.858734571, -8.490980726999908],
              [159.8593856130001, -8.511325778999947],
            ],
          ],
          [
            [
              [158.3652449880001, -7.548272393999923],
              [158.35710696700005, -7.539727471999925],
              [158.3486434250001, -7.528415622999944],
              [158.33765709700003, -7.518324476999908],
              [158.30779056100005, -7.510918877999927],
              [158.28663170700008, -7.496840101999908],
              [158.27320397200003, -7.493747653999947],
              [158.26579837300005, -7.488213799999926],
              [158.26441491000003, -7.476820570999905],
              [158.2685653000001, -7.466973565999922],
              [158.27662194100003, -7.466403903999947],
              [158.28630618600005, -7.472832940999922],
              [158.29664147200003, -7.476820570999905],
              [158.3056746750001, -7.482517184999949],
              [158.31128991000003, -7.493747653999947],
              [158.32439212300005, -7.489678643999923],
              [158.33611087300005, -7.494561455999929],
              [158.35906009200005, -7.514092705999929],
              [158.37134850400003, -7.504164320999905],
              [158.3930770190001, -7.505791924999926],
              [158.41675866000003, -7.51490650799991],
              [158.43482506600003, -7.527764580999929],
              [158.425140821, -7.532810153999947],
              [158.4184676440001, -7.539727471999925],
              [158.41667728000004, -7.549086195999905],
              [158.42115319100003, -7.561293226999908],
              [158.37671959700003, -7.552504164999959],
              [158.3652449880001, -7.548272393999923],
            ],
          ],
          [
            [
              [157.61158287900003, -7.404229424999926],
              [157.61898847700002, -7.41179778399993],
              [157.61280358200008, -7.419366143999923],
              [157.61060631600003, -7.429782809999949],
              [157.61280358200008, -7.441338799999926],
              [157.61898847700002, -7.452080987999921],
              [157.59164472700002, -7.432224216999941],
              [157.59058678500003, -7.447198174999926],
              [157.580414259, -7.45281340899993],
              [157.54948978000004, -7.452080987999921],
              [157.54948978000004, -7.445896091999941],
              [157.555511915, -7.442559502999927],
              [157.56421959700003, -7.435642184999949],
              [157.56999759200005, -7.432224216999941],
              [157.53052819100003, -7.420668226999908],
              [157.51937910200002, -7.414808851999908],
              [157.51140384200005, -7.413506768999923],
              [157.48585045700008, -7.414727471999925],
              [157.4755965500001, -7.41179778399993],
              [157.49195397200003, -7.40007903399993],
              [157.509125196, -7.390557549999926],
              [157.53541100400003, -7.395603122999944],
              [157.56373131600003, -7.39226653399993],
              [157.5888778000001, -7.393324476999908],
              [157.60523522200003, -7.41179778399993],
              [157.61158287900003, -7.404229424999926],
            ],
          ],
          [
            [
              [158.2832137380001, -7.41179778399993],
              [158.2793074880001, -7.420830987999921],
              [158.27662194100003, -7.430759372999944],
              [158.27564537900003, -7.441338799999926],
              [158.27621504, -7.452080987999921],
              [158.26140384200005, -7.443536065999922],
              [158.2563582690001, -7.438409112999921],
              [158.2490340500001, -7.473239841999941],
              [158.235199415, -7.463311455999929],
              [158.2265731130001, -7.449802341999941],
              [158.2153426440001, -7.43914153399993],
              [158.1943465500001, -7.438409112999921],
              [158.1943465500001, -7.432224216999941],
              [158.2080184250001, -7.417901299999926],
              [158.2148543630001, -7.417901299999926],
              [158.22429446700005, -7.41961028399993],
              [158.25025475400003, -7.394952080999929],
              [158.26937910200002, -7.390557549999926],
              [158.26937910200002, -7.417901299999926],
              [158.27320397200003, -7.416110934999949],
              [158.2797957690001, -7.41375090899993],
              [158.2832137380001, -7.41179778399993],
            ],
          ],
          [
            [
              [157.77621504, -7.407972914999959],
              [157.77808678500003, -7.422946872999944],
              [157.789886915, -7.459649346999925],
              [157.7973738940001, -7.473239841999941],
              [157.77027428500003, -7.474786065999922],
              [157.75603274800005, -7.47389088299991],
              [157.7392684250001, -7.466892184999949],
              [157.732758009, -7.46843840899993],
              [157.72584069100003, -7.471449476999908],
              [157.71827233200008, -7.473239841999941],
              [157.71070397200003, -7.470961195999905],
              [157.70435631600003, -7.461602471999925],
              [157.6977645190001, -7.459567966999941],
              [157.67855879, -7.448174737999921],
              [157.68897545700008, -7.423028252999927],
              [157.7216903000001, -7.383884372999944],
              [157.76929772200003, -7.400811455999929],
              [157.77621504, -7.407972914999959],
            ],
          ],
          [
            [
              [157.5297957690001, -7.333184502999927],
              [157.5297957690001, -7.357598565999922],
              [157.5263778000001, -7.370863539999959],
              [157.51343834700003, -7.376560153999947],
              [157.48552493600005, -7.377618096999925],
              [157.473480665, -7.384698174999926],
              [157.44792728000004, -7.432224216999941],
              [157.44605553500003, -7.420505466999941],
              [157.441742384, -7.414239190999922],
              [157.4355574880001, -7.413506768999923],
              [157.42750084700003, -7.417901299999926],
              [157.414398634, -7.40748463299991],
              [157.39014733200008, -7.40203215899993],
              [157.34489993600005, -7.398044528999947],
              [157.32545006600003, -7.391778252999927],
              [157.31202233200008, -7.378838799999926],
              [157.307953321, -7.360284112999921],
              [157.3169051440001, -7.336602471999925],
              [157.30844160200002, -7.339613539999959],
              [157.30250084700003, -7.344333591999941],
              [157.29029381600003, -7.35711028399993],
              [157.282562696, -7.353448174999926],
              [157.27800540500004, -7.356540622999944],
              [157.27662194100003, -7.37078215899993],
              [157.25757897200003, -7.359795830999929],
              [157.22193444100003, -7.347832940999922],
              [157.20093834700003, -7.336602471999925],
              [157.14795983200008, -7.332289320999905],
              [157.13892662900003, -7.333184502999927],
              [157.13249759200005, -7.342950127999927],
              [157.11833743600005, -7.342461846999925],
              [157.10425866000003, -7.332207940999922],
              [157.09343509200005, -7.30201588299991],
              [157.08269290500004, -7.287530205999929],
              [157.06910241000003, -7.274346612999921],
              [157.05689537900003, -7.268324476999908],
              [157.04802493600005, -7.27312590899993],
              [157.02849368600005, -7.281019789999959],
              [157.0146590500001, -7.282647393999923],
              [157.022797071, -7.268324476999908],
              [157.01351972700002, -7.251885674999926],
              [156.9985457690001, -7.238702080999929],
              [156.97925866000003, -7.229913018999923],
              [156.9575301440001, -7.226739190999922],
              [156.9438582690001, -7.221612237999921],
              [156.9277449880001, -7.208754164999959],
              [156.834320509, -7.099786065999922],
              [156.8300887380001, -7.090508721999925],
              [156.82764733200008, -7.078057549999926],
              [156.8232528000001, -7.067071221999925],
              [156.81397545700008, -7.062269789999959],
              [156.80062910200002, -7.058770440999922],
              [156.79322350400003, -7.050225518999923],
              [156.78305097700002, -7.028090101999908],
              [156.74390709700003, -6.97389088299991],
              [156.73170006600003, -6.96607838299991],
              [156.722015821, -6.956475518999923],
              [156.68702233200008, -6.897149346999925],
              [156.67058353000004, -6.885674737999921],
              [156.6230574880001, -6.860935153999947],
              [156.60816491000003, -6.856215101999908],
              [156.5962020190001, -6.850762627999927],
              [156.48462975400003, -6.753838799999926],
              [156.48218834700003, -6.750420830999929],
              [156.46111087300005, -6.733330987999921],
              [156.454437696, -6.719414971999925],
              [156.446625196, -6.664971612999921],
              [156.44695071700005, -6.644789320999905],
              [156.454437696, -6.630791924999926],
              [156.48780358200008, -6.602959893999923],
              [156.5048934250001, -6.599867445999905],
              [156.52800540500004, -6.603122653999947],
              [156.54802493600005, -6.610528252999927],
              [156.55982506600003, -6.623467705999929],
              [156.566742384, -6.626722914999959],
              [156.57398522200003, -6.631931247999944],
              [156.5771590500001, -6.640801690999922],
              [156.58155358200008, -6.64967213299991],
              [156.59107506600003, -6.649834893999923],
              [156.60084069100003, -6.646254164999959],
              [156.60515384200005, -6.643975518999923],
              [156.6430770190001, -6.655043226999908],
              [156.66960696700005, -6.674981377999927],
              [156.721039259, -6.733330987999921],
              [156.73511803500003, -6.745538018999923],
              [156.7802840500001, -6.775811455999929],
              [156.82309004, -6.787286065999922],
              [156.88550866000003, -6.829522393999923],
              [156.92725670700008, -6.849379164999959],
              [156.9633895190001, -6.856052341999941],
              [156.9804793630001, -6.864678643999923],
              [156.99284915500004, -6.86882903399993],
              [157.00375410200002, -6.875258070999905],
              [157.00847415500004, -6.887302341999941],
              [157.01238040500004, -6.894626559999949],
              [157.0214949880001, -6.89576588299991],
              [157.03272545700008, -6.895196221999925],
              [157.04265384200005, -6.897149346999925],
              [157.05250084700003, -6.905450127999927],
              [157.07398522200003, -6.934991143999923],
              [157.11207116000003, -6.96607838299991],
              [157.120453321, -6.980726820999905],
              [157.12330162900003, -6.998223565999922],
              [157.12517337300005, -7.041192315999922],
              [157.13624108200008, -7.086114190999922],
              [157.15251712300005, -7.12428150799991],
              [157.16228274800005, -7.136976820999905],
              [157.172699415, -7.147637627999927],
              [157.18189537900003, -7.160414320999905],
              [157.18726647200003, -7.178887627999927],
              [157.20264733200008, -7.169691664999959],
              [157.20769290500004, -7.164727471999925],
              [157.21558678500003, -7.182224216999941],
              [157.22877037900003, -7.195245049999926],
              [157.2461043630001, -7.203545830999929],
              [157.2661238940001, -7.206231377999927],
              [157.279633009, -7.212497653999947],
              [157.28931725400003, -7.226820570999905],
              [157.29517662900003, -7.243910414999959],
              [157.29712975400003, -7.257745049999926],
              [157.3027449880001, -7.266371351999908],
              [157.31592858200008, -7.272637627999927],
              [157.34489993600005, -7.281996351999908],
              [157.35621178500003, -7.288506768999923],
              [157.368500196, -7.298272393999923],
              [157.3794051440001, -7.31023528399993],
              [157.38648522200003, -7.322930596999925],
              [157.39275149800005, -7.322930596999925],
              [157.39519290500004, -7.30632903399993],
              [157.40259850400003, -7.305759372999944],
              [157.4130965500001, -7.311944268999923],
              [157.42408287900003, -7.31609465899993],
              [157.44556725400003, -7.316176039999959],
              [157.4555770190001, -7.314222914999959],
              [157.49187259200005, -7.300957940999922],
              [157.51140384200005, -7.300225518999923],
              [157.52491295700008, -7.309991143999923],
              [157.5297957690001, -7.333184502999927],
            ],
          ],
          [
            [
              [168.81226647200003, -12.266289971999925],
              [168.82292728000004, -12.26726653399993],
              [168.82585696700005, -12.281508070999905],
              [168.81861412900003, -12.28492603999996],
              [168.80241946700005, -12.290622653999947],
              [168.7978621750001, -12.281914971999925],
              [168.8056746750001, -12.274102471999925],
              [168.81226647200003, -12.266289971999925],
            ],
          ],
          [
            [
              [165.74529056100005, -10.42164478999996],
              [165.73560631600003, -10.424574476999908],
              [165.72779381600003, -10.422458591999941],
              [165.72291100400003, -10.412855726999908],
              [165.72380618600005, -10.401543877999927],
              [165.72624759200005, -10.39462655999995],
              [165.73218834700003, -10.38990650799991],
              [165.74634850400003, -10.39348723799992],
              [165.75505618600005, -10.406914971999925],
              [165.7529403000001, -10.416761976999908],
              [165.74529056100005, -10.42164478999996],
            ],
          ],
          [
            [
              [160.6357528000001, -7.891045830999929],
              [160.64795983200008, -7.926853122999944],
              [160.64087975400003, -7.928399346999925],
              [160.63200931100005, -7.92701588299991],
              [160.61304772200003, -7.901136976999908],
              [160.60759524800005, -7.888848565999922],
              [160.61207116000003, -7.876722914999959],
              [160.62330162900003, -7.874444268999923],
              [160.6298934250001, -7.880303643999923],
              [160.6357528000001, -7.891045830999929],
            ],
          ],
          [
            [
              [166.9848738940001, -11.614353122999944],
              [166.98552493600005, -11.623304945999905],
              [166.97966556100005, -11.638604424999926],
              [166.963226759, -11.650323174999926],
              [166.945648634, -11.65325286299992],
              [166.93897545700008, -11.642022393999923],
              [166.9443465500001, -11.625420830999929],
              [166.95769290500004, -11.61256275799991],
              [166.97584069100003, -11.61101653399993],
              [166.9848738940001, -11.614353122999944],
            ],
          ],
          [
            [
              [166.2524520190001, -10.26490650799991],
              [166.26710045700008, -10.264255466999941],
              [166.27995853000004, -10.273044528999947],
              [166.2700301440001, -10.29192473799992],
              [166.25147545700008, -10.309177341999941],
              [166.2373153000001, -10.311130466999941],
              [166.23609459700003, -10.29656340899993],
              [166.23804772200003, -10.283461195999905],
              [166.2314559250001, -10.28289153399993],
              [166.22868899800005, -10.276055596999925],
              [166.23585045700008, -10.255303643999923],
              [166.2392684250001, -10.234307549999926],
              [166.23853600400003, -10.215020440999922],
              [166.242523634, -10.22079843499995],
              [166.24244225400003, -10.268975518999923],
              [166.2490340500001, -10.266696872999944],
              [166.2524520190001, -10.26490650799991],
            ],
          ],
          [
            [
              [156.5454207690001, -7.791680596999925],
              [156.54908287900003, -7.795017184999949],
              [156.559418165, -7.80242278399993],
              [156.55543053500003, -7.817315362999921],
              [156.53484134200005, -7.82740650799991],
              [156.51685631600003, -7.818129164999959],
              [156.517914259, -7.809258721999925],
              [156.5258895190001, -7.799411716999941],
              [156.53638756600003, -7.791110934999949],
              [156.5454207690001, -7.791680596999925],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Tuvalu',
        iso3: 'TUV',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [179.19125410200002, -8.542087497999944],
              [179.200043165, -8.529554945999905],
              [179.2041121750001, -8.518975518999923],
              [179.20232181100005, -8.509698174999926],
              [179.19809004, -8.49781666499996],
              [179.19752037900003, -8.481540622999944],
              [179.19939212300005, -8.46062590899993],
              [179.206390821, -8.474053643999923],
              [179.20720462300005, -8.498467705999929],
              [179.21550540500004, -8.511325778999947],
              [179.21753991000003, -8.520603122999944],
              [179.20972741000003, -8.529961846999925],
              [179.19125410200002, -8.542087497999944],
            ],
          ],
          [
            [
              [178.38054446700005, -8.07000090899993],
              [178.37330162900003, -8.069024346999925],
              [178.3754988940001, -8.056084893999923],
              [178.383148634, -8.039239190999922],
              [178.3906356130001, -8.026543877999927],
              [178.38054446700005, -8.07000090899993],
            ],
          ],
          [
            [
              [177.15259850400003, -7.197360934999949],
              [177.1523543630001, -7.195082289999959],
              [177.1504012380001, -7.190362237999921],
              [177.15007571700005, -7.188164971999925],
              [177.15300540500004, -7.19500090899993],
              [177.1533309250001, -7.199151299999926],
              [177.15259850400003, -7.200290622999944],
              [177.15259850400003, -7.197360934999949],
            ],
          ],
          [
            [
              [176.31430097700002, -6.302341403999947],
              [176.31918379, -6.289239190999922],
              [176.32292728000004, -6.288832289999959],
              [176.32243899800005, -6.295098565999922],
              [176.31430097700002, -6.302341403999947],
            ],
          ],
          [
            [
              [177.344086134, -6.121026299999926],
              [177.3398543630001, -6.11451588299991],
              [177.33814537900003, -6.11101653399993],
              [177.33716881600003, -6.108168226999908],
              [177.34880618600005, -6.110528252999927],
              [177.35661868600005, -6.11451588299991],
              [177.356293165, -6.118747653999947],
              [177.344086134, -6.121026299999926],
            ],
          ],
          [
            [
              [176.1352645190001, -5.692803643999923],
              [176.12525475400003, -5.679131768999923],
              [176.1298934250001, -5.677504164999959],
              [176.14039147200003, -5.68718840899993],
              [176.1484481130001, -5.70671965899993],
              [176.1352645190001, -5.692803643999923],
            ],
          ],
          [
            [
              [179.9067488940001, -9.39934661299992],
              [179.90609785200002, -9.418633721999925],
              [179.9052840500001, -9.420668226999908],
              [179.90406334700003, -9.40048593499995],
              [179.89861087300005, -9.38681405999995],
              [179.90121504, -9.38795338299991],
              [179.9067488940001, -9.39934661299992],
            ],
          ],
          [
            [
              [179.86784915500004, -9.343194268999923],
              [179.87330162900003, -9.346856377999927],
              [179.87842858200008, -9.360772393999923],
              [179.8769637380001, -9.36296965899993],
              [179.87175540500004, -9.350192966999941],
              [179.86744225400003, -9.344333591999941],
              [179.86784915500004, -9.343194268999923],
            ],
          ],
          [
            [
              [178.68279056100005, -7.49146900799991],
              [178.6679793630001, -7.463636976999908],
              [178.66521243600005, -7.454034112999921],
              [178.688324415, -7.474379164999959],
              [178.69109134200005, -7.475355726999908],
              [178.6933699880001, -7.483982028999947],
              [178.69410241000003, -7.49382903399993],
              [178.6914168630001, -7.498630466999941],
              [178.68279056100005, -7.49146900799991],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Nauru',
        iso3: 'NRU',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [166.938812696, -0.490411065999922],
            [166.9555770190001, -0.497979424999926],
            [166.95826256600003, -0.517673434999949],
            [166.95134524800005, -0.539157809999949],
            [166.938812696, -0.551853122999944],
            [166.916351759, -0.547539971999925],
            [166.90699303500003, -0.524834893999923],
            [166.913422071, -0.500176690999922],
            [166.938812696, -0.490411065999922],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Micronesia',
        iso3: 'FSM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [163.02605228000004, 5.340887762000079],
              [163.03044681100005, 5.335679429000038],
              [163.03728274800005, 5.333685614000046],
              [163.04371178500003, 5.330959377000056],
              [163.04656009200005, 5.323553778000075],
              [163.0429793630001, 5.310939846000053],
              [163.025726759, 5.28001536700009],
              [163.01921634200005, 5.272691148000092],
              [163.00554446700005, 5.269761460000041],
              [162.99341881600003, 5.272853908000059],
              [162.9814559250001, 5.27765534100007],
              [162.96762129, 5.280178127000056],
              [162.94597415500004, 5.28001536700009],
              [162.93132571700005, 5.281927802000041],
              [162.91618899800005, 5.286932684000078],
              [162.9121199880001, 5.304185289000088],
              [162.92408287900003, 5.32103099200009],
              [162.97144616000003, 5.361761786000045],
              [162.9907332690001, 5.374823309000078],
              [163.01059004, 5.379706122000073],
              [163.02605228000004, 5.368841864000046],
              [163.0273543630001, 5.362697658000059],
              [163.025726759, 5.347601630000042],
              [163.02605228000004, 5.340887762000079],
            ],
          ],
          [
            [
              [158.29078209700003, 6.937974351000094],
              [158.296234571, 6.928127346000053],
              [158.3046981130001, 6.924383856000077],
              [158.31470787900003, 6.925767320000091],
              [158.32496178500003, 6.931138414000088],
              [158.338226759, 6.879095770000049],
              [158.33863366000003, 6.869086005000042],
              [158.33073978000004, 6.866603908000059],
              [158.30884850400003, 6.868475653000075],
              [158.30445397200003, 6.86595286700009],
              [158.30640709700003, 6.855210679000038],
              [158.31560306100005, 6.836615302000041],
              [158.31755618600005, 6.824693101000094],
              [158.313812696, 6.808661200000074],
              [158.30453535200002, 6.799302476000094],
              [158.29249108200008, 6.795070705000057],
              [158.244476759, 6.788275458000044],
              [158.22535241000003, 6.789496161000045],
              [158.21509850400003, 6.800767320000091],
              [158.19353274800005, 6.793443101000094],
              [158.1801863940001, 6.802476304000038],
              [158.17058353000004, 6.817531643000052],
              [158.160492384, 6.828111070000091],
              [158.1645613940001, 6.841213283000059],
              [158.1660262380001, 6.853989976000094],
              [158.16293379, 6.865790106000077],
              [158.15308678500003, 6.875921942000048],
              [158.15593509200005, 6.879868882000039],
              [158.160492384, 6.890204169000071],
              [158.13298587300005, 6.891913153000075],
              [158.125824415, 6.907416083000044],
              [158.13249759200005, 6.941351630000042],
              [158.14185631600003, 6.950995184000078],
              [158.1611434250001, 6.951361395000049],
              [158.1782332690001, 6.956040757000039],
              [158.18091881600003, 6.978949286000045],
              [158.2016707690001, 6.970038153000075],
              [158.20826256600003, 6.965277411000045],
              [158.21802819100003, 6.970851955000057],
              [158.22527103000004, 6.970200914000088],
              [158.2324324880001, 6.96710846600007],
              [158.24236087300005, 6.965277411000045],
              [158.26734459700003, 6.966376044000071],
              [158.27662194100003, 6.965277411000045],
              [158.2773543630001, 6.96320221600007],
              [158.2939559250001, 6.952297268000052],
              [158.29704837300005, 6.951646226000094],
              [158.30347741000003, 6.942857164000088],
              [158.3007918630001, 6.940741278000075],
              [158.29078209700003, 6.937974351000094],
            ],
          ],
          [
            [
              [151.58863366000003, 7.383612372000073],
              [151.622406446, 7.391750393000052],
              [151.63640384200005, 7.387111721000053],
              [151.65015709700003, 7.369370835000041],
              [151.650726759, 7.35423411700009],
              [151.6445418630001, 7.336086330000057],
              [151.63428795700008, 7.327866929000038],
              [151.62273196700005, 7.342678127000056],
              [151.61589603000004, 7.342678127000056],
              [151.6074324880001, 7.336127020000049],
              [151.59595787900003, 7.336737372000073],
              [151.58269290500004, 7.340399481000077],
              [151.56812584700003, 7.342678127000056],
              [151.571136915, 7.346258856000077],
              [151.5742293630001, 7.347723700000074],
              [151.58179772200003, 7.348863023000092],
              [151.59107506600003, 7.353420315000051],
              [151.61736087300005, 7.358954169000071],
              [151.62273196700005, 7.365912177000041],
              [151.61841881600003, 7.375881252000056],
              [151.59693444100003, 7.372748114000046],
              [151.58863366000003, 7.383612372000073],
            ],
          ],
          [
            [
              [151.87671959700003, 7.458726304000038],
              [151.8837996750001, 7.463568427000041],
              [151.89226321700005, 7.462469794000071],
              [151.903168165, 7.459540106000077],
              [151.91765384200005, 7.458726304000038],
              [151.90748131600003, 7.446926174000055],
              [151.8906356130001, 7.435248114000046],
              [151.871918165, 7.426743882000039],
              [151.85621178500003, 7.424627997000073],
              [151.85564212300005, 7.43695709800005],
              [151.856781446, 7.447170315000051],
              [151.86304772200003, 7.46556224200009],
              [151.86744225400003, 7.464748440000051],
              [151.87029056100005, 7.46352773600006],
              [151.87671959700003, 7.458726304000038],
            ],
          ],
          [
            [
              [138.1923934250001, 9.575873114000046],
              [138.1816512380001, 9.558742580000057],
              [138.18425540500004, 9.54437897300005],
              [138.19752037900003, 9.539007880000042],
              [138.21900475400003, 9.548570054000038],
              [138.21412194100003, 9.537054755000042],
              [138.20240319100003, 9.521185614000046],
              [138.18873131600003, 9.50682200700004],
              [138.17798912900003, 9.500189520000049],
              [138.1640731130001, 9.504828192000048],
              [138.156586134, 9.525783596000053],
              [138.14380944100003, 9.521307684000078],
              [138.13445071700005, 9.511867580000057],
              [138.07984459700003, 9.425441799000055],
              [138.06812584700003, 9.412054755000042],
              [138.063812696, 9.436102606000077],
              [138.07300866000003, 9.470404364000046],
              [138.08912194100003, 9.501166083000044],
              [138.1059676440001, 9.514471747000073],
              [138.11296634200005, 9.52147044500009],
              [138.12126712300005, 9.554877020000049],
              [138.12623131600003, 9.565985419000071],
              [138.1411238940001, 9.574367580000057],
              [138.14722741000003, 9.56736888200004],
              [138.15007571700005, 9.541164455000057],
              [138.15186608200008, 9.550848700000074],
              [138.15495853000004, 9.560736395000049],
              [138.1591903000001, 9.569525458000044],
              [138.164398634, 9.575873114000046],
              [138.173187696, 9.58234284100007],
              [138.184906446, 9.588812567000048],
              [138.19361412900003, 9.58885325700004],
              [138.1923934250001, 9.575873114000046],
            ],
          ],
          [
            [
              [154.80811608200008, 0.927801825000074],
              [154.81430097700002, 0.925767320000091],
              [154.81763756600003, 0.92218659100007],
              [154.812836134, 0.918158270000049],
              [154.8017684250001, 0.918198960000041],
              [154.79859459700003, 0.92446523600006],
              [154.80298912900003, 0.927069403000075],
              [154.80811608200008, 0.927801825000074],
            ],
          ],
          [
            [
              [154.7148543630001, 0.96556224200009],
              [154.72193444100003, 0.969183661000045],
              [154.7329207690001, 0.967027085000041],
              [154.72681725400003, 0.960638739000046],
              [154.71509850400003, 0.961371161000045],
              [154.7148543630001, 0.96556224200009],
            ],
          ],
          [
            [
              [154.79314212300005, 0.97211334800005],
              [154.79656009200005, 0.965806382000039],
              [154.792328321, 0.962876695000091],
              [154.7837020190001, 0.963690497000073],
              [154.778168165, 0.968817450000074],
              [154.77849368600005, 0.973700262000079],
              [154.78435306100005, 0.975490627000056],
              [154.79314212300005, 0.97211334800005],
            ],
          ],
          [
            [
              [154.879242384, 3.751939195000091],
              [154.87671959700003, 3.767971096000053],
              [154.89185631600003, 3.778794664000088],
              [154.89429772200003, 3.762844143000052],
              [154.879242384, 3.751939195000091],
            ],
          ],
          [
            [
              [154.78931725400003, 3.791815497000073],
              [154.79175866000003, 3.776556708000044],
              [154.77369225400003, 3.76626211100006],
              [154.77125084700003, 3.781480210000041],
              [154.78931725400003, 3.791815497000073],
            ],
          ],
          [
            [
              [153.66773522200003, 5.286037502000056],
              [153.67172285200002, 5.297674872000073],
              [153.68531334700003, 5.309719143000052],
              [153.70085696700005, 5.316961981000077],
              [153.71070397200003, 5.314601955000057],
              [153.70769290500004, 5.305365302000041],
              [153.69410241000003, 5.296454169000071],
              [153.6782332690001, 5.289496161000045],
              [153.66773522200003, 5.286037502000056],
            ],
          ],
          [
            [
              [157.16187584700003, 5.773871161000045],
              [157.1606551440001, 5.776190497000073],
              [157.15894616000003, 5.777899481000077],
              [157.15845787900003, 5.779201565000051],
              [157.16089928500003, 5.77993398600006],
              [157.16391035200002, 5.778713283000059],
              [157.16382897200003, 5.777289130000042],
              [157.162445509, 5.775824286000045],
              [157.16187584700003, 5.773871161000045],
            ],
          ],
          [
            [
              [149.315765821, 6.696926174000055],
              [149.31609134200005, 6.703924872000073],
              [149.3169051440001, 6.709906317000048],
              [149.3188582690001, 6.715073960000041],
              [149.32349694100003, 6.71946849200009],
              [149.32569420700008, 6.712551174000055],
              [149.3247176440001, 6.707098700000074],
              [149.32105553500003, 6.702215887000079],
              [149.315765821, 6.696926174000055],
            ],
          ],
          [
            [
              [157.93637129, 6.717189846000053],
              [157.93921959700003, 6.727362372000073],
              [157.94206790500004, 6.730536200000074],
              [157.94890384200005, 6.731675523000092],
              [157.9482528000001, 6.725775458000044],
              [157.9458113940001, 6.722601630000042],
              [157.93637129, 6.717189846000053],
            ],
          ],
          [
            [
              [151.856781446, 7.316595770000049],
              [151.85320071700005, 7.35382721600007],
              [151.8545028000001, 7.370062567000048],
              [151.862640821, 7.361761786000045],
              [151.865570509, 7.350653387000079],
              [151.8652449880001, 7.338771877000056],
              [151.8618270190001, 7.327134507000039],
              [151.856781446, 7.316595770000049],
            ],
          ],
          [
            [
              [149.18572024800005, 7.371649481000077],
              [149.18083743600005, 7.38117096600007],
              [149.18726647200003, 7.38157786700009],
              [149.18824303500003, 7.379787502000056],
              [149.18669681100005, 7.376125393000052],
              [149.18572024800005, 7.371649481000077],
            ],
          ],
          [
            [
              [150.40748131600003, 8.575506903000075],
              [150.404633009, 8.586004950000074],
              [150.40935306100005, 8.584662177000041],
              [150.40984134200005, 8.58234284100007],
              [150.40845787900003, 8.579291083000044],
              [150.40748131600003, 8.575506903000075],
            ],
          ],
          [
            [
              [149.66871178500003, 8.574693101000037],
              [149.66529381600003, 8.587591864000046],
              [149.66781660200002, 8.60423411700009],
              [149.67554772200003, 8.616441148000092],
              [149.68726647200003, 8.616034247000073],
              [149.688812696, 8.60732656500005],
              [149.682953321, 8.594305731000077],
              [149.67448978000004, 8.581732489000046],
              [149.66871178500003, 8.574693101000037],
            ],
          ],
          [
            [
              [150.1181746750001, 8.976304429000038],
              [150.12427819100003, 8.985500393000052],
              [150.1274520190001, 8.987494208000044],
              [150.13298587300005, 8.986070054000038],
              [150.13054446700005, 8.980943101000037],
              [150.12712649800005, 8.97915273600006],
              [150.12281334700003, 8.978216864000046],
              [150.1181746750001, 8.976304429000038],
            ],
          ],
          [
            [
              [140.5141707690001, 9.76780833500004],
              [140.52173912900003, 9.774725653000075],
              [140.5312606130001, 9.775580145000049],
              [140.53288821700005, 9.771918036000045],
              [140.52466881600003, 9.764471747000073],
              [140.51539147200003, 9.76117584800005],
              [140.5141707690001, 9.76780833500004],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Vanuatu',
        iso3: 'VUT',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [169.8403426440001, -20.140801690999922],
              [169.86052493600005, -20.15553150799991],
              [169.87614993600005, -20.16415780999995],
              [169.88884524800005, -20.17392343499995],
              [169.8989363940001, -20.19231536299992],
              [169.88843834700003, -20.217461846999925],
              [169.88160241000003, -20.229587497999944],
              [169.8715926440001, -20.239434502999927],
              [169.86052493600005, -20.244398695999905],
              [169.83814537900003, -20.24863046699994],
              [169.8300887380001, -20.253106377999927],
              [169.82048587300005, -20.244398695999905],
              [169.80787194100003, -20.238946221999925],
              [169.7822371750001, -20.232679945999905],
              [169.75180097700002, -20.219008070999905],
              [169.73796634200005, -20.208916924999926],
              [169.7363387380001, -20.185804945999905],
              [169.74341881600003, -20.16057708099993],
              [169.75554446700005, -20.14381275799991],
              [169.76840254, -20.140232028999947],
              [169.7939559250001, -20.13600025799991],
              [169.821136915, -20.135023695999905],
              [169.8403426440001, -20.140801690999922],
            ],
          ],
          [
            [
              [169.43279056100005, -19.492852471999925],
              [169.465179884, -19.509372653999947],
              [169.48064212300005, -19.52011484199994],
              [169.50171959700003, -19.527520440999922],
              [169.49561608200008, -19.539808851999908],
              [169.46013431100005, -19.582207940999922],
              [169.45329837300005, -19.626153252999927],
              [169.445648634, -19.648044528999947],
              [169.43620853000004, -19.657321872999944],
              [169.41684004, -19.655450127999927],
              [169.37419681100005, -19.643731377999927],
              [169.35767662900003, -19.636163018999923],
              [169.3164168630001, -19.589776299999926],
              [169.30616295700008, -19.582207940999922],
              [169.2861434250001, -19.581231377999927],
              [169.2783309250001, -19.578301690999922],
              [169.27507571700005, -19.572198174999926],
              [169.2719832690001, -19.56096770599993],
              [169.26490319100003, -19.552992445999905],
              [169.2578231130001, -19.54778411299992],
              [169.25464928500003, -19.544366143999923],
              [169.25212649800005, -19.536553643999923],
              [169.21851647200003, -19.490166924999926],
              [169.21436608200008, -19.47975025799991],
              [169.213226759, -19.464776299999926],
              [169.21452884200005, -19.43914153399993],
              [169.21998131600003, -19.414808851999908],
              [169.23113040500004, -19.40398528399993],
              [169.23894290500004, -19.39853280999995],
              [169.23894290500004, -19.38567473799992],
              [169.234711134, -19.362481377999927],
              [169.2387801440001, -19.350681247999944],
              [169.24341881600003, -19.341973565999922],
              [169.2504988940001, -19.335056247999944],
              [169.26148522200003, -19.328301690999922],
              [169.28150475400003, -19.322930596999925],
              [169.32007897200003, -19.322442315999922],
              [169.33659915500004, -19.314629815999922],
              [169.352875196, -19.328057549999926],
              [169.35377037900003, -19.34156666499996],
              [169.34791100400003, -19.358168226999908],
              [169.34400475400003, -19.38014088299991],
              [169.35767662900003, -19.455254815999922],
              [169.36646569100003, -19.46965911299992],
              [169.38746178500003, -19.477959893999923],
              [169.41228274800005, -19.48414478999996],
              [169.43279056100005, -19.492852471999925],
            ],
          ],
          [
            [
              [169.33659915500004, -18.93482838299991],
              [169.32781009200005, -18.960381768999923],
              [169.30787194100003, -18.972832940999922],
              [169.28695722700002, -18.982354424999926],
              [169.27507571700005, -18.99928150799991],
              [169.2548934250001, -18.98479583099993],
              [169.1665145190001, -18.93922291499996],
              [169.15447024800005, -18.936211846999925],
              [169.14226321700005, -18.941338799999926],
              [169.134125196, -18.940850518999923],
              [169.10279381600003, -18.93222421699994],
              [169.09392337300005, -18.927992445999905],
              [169.08350670700008, -18.918633721999925],
              [169.05925540500004, -18.901950778999947],
              [169.04249108200008, -18.894138278999947],
              [168.9873153000001, -18.876560153999947],
              [168.98552493600005, -18.859633070999905],
              [169.0019637380001, -18.81503671699994],
              [169.00220787900003, -18.80169036299992],
              [168.9985457690001, -18.790215752999927],
              [168.99236087300005, -18.77988046699994],
              [168.98406009200005, -18.76995208099993],
              [168.98226972700002, -18.76262786299992],
              [168.9887801440001, -18.690606377999927],
              [168.99488366000003, -18.66969166499996],
              [169.008148634, -18.649997653999947],
              [169.038422071, -18.629164320999905],
              [169.07781009200005, -18.618259372999944],
              [169.11841881600003, -18.619398695999905],
              [169.1523543630001, -18.636325778999947],
              [169.162445509, -18.652276299999926],
              [169.1665145190001, -18.672051690999922],
              [169.1665145190001, -18.70826588299991],
              [169.17212975400003, -18.726495049999926],
              [169.18677819100003, -18.73495859199994],
              [169.22730553500003, -18.739353122999944],
              [169.226898634, -18.73796965899993],
              [169.23170006600003, -18.73560963299991],
              [169.238617384, -18.733493747999944],
              [169.24398847700002, -18.73251718499995],
              [169.2480574880001, -18.73447030999995],
              [169.247406446, -18.74342213299991],
              [169.25611412900003, -18.748223565999922],
              [169.26156660200002, -18.75481536299992],
              [169.26628665500004, -18.76295338299991],
              [169.26832116000003, -18.76995208099993],
              [169.25660241000003, -18.770684502999927],
              [169.19320722700002, -18.787041924999926],
              [169.21745853000004, -18.81536223799992],
              [169.22046959700003, -18.824965101999908],
              [169.2270613940001, -18.826836846999925],
              [169.25806725400003, -18.841973565999922],
              [169.26832116000003, -18.849216403999947],
              [169.29859459700003, -18.86419036299992],
              [169.31983483200008, -18.882012627999927],
              [169.332367384, -18.90488046699994],
              [169.33659915500004, -18.93482838299991],
            ],
          ],
          [
            [
              [168.54957116000003, -17.691013278999947],
              [168.55974368600005, -17.69312916499996],
              [168.56983483200008, -17.691582940999922],
              [168.57837975400003, -17.688164971999925],
              [168.58375084700003, -17.68417734199994],
              [168.58545983200008, -17.70126718499995],
              [168.5556746750001, -17.759209893999923],
              [168.54761803500003, -17.784600518999923],
              [168.54021243600005, -17.79664478999996],
              [168.52686608200008, -17.801934502999927],
              [168.50114993600005, -17.80706145599993],
              [168.4990340500001, -17.809340101999908],
              [168.49626712300005, -17.814060153999947],
              [168.491547071, -17.818617445999905],
              [168.48414147200003, -17.82073333099993],
              [168.4790145190001, -17.818536065999922],
              [168.4726668630001, -17.813897393999923],
              [168.4677840500001, -17.809258721999925],
              [168.46697024800005, -17.80706145599993],
              [168.39600670700008, -17.82350025799991],
              [168.38835696700005, -17.823663018999923],
              [168.37086022200003, -17.813897393999923],
              [168.36695397200003, -17.80641041499996],
              [168.36475670700008, -17.79664478999996],
              [168.3603621750001, -17.793715101999908],
              [168.3496199880001, -17.80706145599993],
              [168.34880618600005, -17.798760674999926],
              [168.344574415, -17.788669528999947],
              [168.34351647200003, -17.780368747999944],
              [168.33912194100003, -17.78183359199994],
              [168.33855228000004, -17.782321872999944],
              [168.33855228000004, -17.783461195999905],
              [168.33668053500003, -17.786553643999923],
              [168.328461134, -17.784274997999944],
              [168.320648634, -17.784600518999923],
              [168.31421959700003, -17.787855726999908],
              [168.30933678500003, -17.794040622999944],
              [168.31560306100005, -17.759209893999923],
              [168.30933678500003, -17.759209893999923],
              [168.29908287900003, -17.77190520599993],
              [168.28305097700002, -17.77857838299991],
              [168.24732506600003, -17.786553643999923],
              [168.24732506600003, -17.780368747999944],
              [168.2646590500001, -17.767836195999905],
              [168.28687584700003, -17.761325778999947],
              [168.3046981130001, -17.75204843499995],
              [168.30933678500003, -17.731215101999908],
              [168.30103600400003, -17.736260674999926],
              [168.29420006600003, -17.73674895599993],
              [168.28980553500003, -17.732028903999947],
              [168.28663170700008, -17.710870049999926],
              [168.2822371750001, -17.70761484199994],
              [168.27564537900003, -17.70680103999996],
              [168.26783287900003, -17.70403411299992],
              [168.25171959700003, -17.695570570999905],
              [168.23845462300005, -17.69378020599993],
              [168.22624759200005, -17.69695403399993],
              [168.21314537900003, -17.70403411299992],
              [168.2060653000001, -17.71135833099993],
              [168.19255618600005, -17.732598565999922],
              [168.18580162900003, -17.73870208099993],
              [168.1748153000001, -17.740980726999908],
              [168.16814212300005, -17.736993096999925],
              [168.16521243600005, -17.726820570999905],
              [168.15113366000003, -17.718194268999923],
              [168.15414472700002, -17.705824476999908],
              [168.17896569100003, -17.656182549999926],
              [168.19068444100003, -17.643975518999923],
              [168.21648196700005, -17.62623463299991],
              [168.22681725400003, -17.615166924999926],
              [168.2666121750001, -17.558526299999926],
              [168.29273522200003, -17.53769296699994],
              [168.32300866000003, -17.532647393999923],
              [168.3281356130001, -17.53883228999996],
              [168.33171634200005, -17.54924895599993],
              [168.33668053500003, -17.55559661299992],
              [168.35417728000004, -17.54534270599993],
              [168.42310631600003, -17.534274997999944],
              [168.43921959700003, -17.537041924999926],
              [168.45337975400003, -17.546319268999923],
              [168.45573978000004, -17.55250416499996],
              [168.45915774800005, -17.570570570999905],
              [168.463226759, -17.57431405999995],
              [168.4716903000001, -17.57586028399993],
              [168.4775496750001, -17.58017343499995],
              [168.48747806100005, -17.594821872999944],
              [168.49561608200008, -17.61337655999995],
              [168.50114993600005, -17.632989190999922],
              [168.51042728000004, -17.64885833099993],
              [168.52906334700003, -17.656182549999926],
              [168.5351668630001, -17.66611093499995],
              [168.54314212300005, -17.684991143999923],
              [168.54957116000003, -17.691013278999947],
            ],
          ],
          [
            [
              [168.205414259, -17.581149997999944],
              [168.207855665, -17.550388278999947],
              [168.23894290500004, -17.52190520599993],
              [168.27564537900003, -17.509372653999947],
              [168.2954207690001, -17.526462497999944],
              [168.28272545700008, -17.530694268999923],
              [168.26042728000004, -17.542901299999926],
              [168.2470809250001, -17.546319268999923],
              [168.22380618600005, -17.56145598799992],
              [168.2133895190001, -17.57008228999996],
              [168.205414259, -17.581149997999944],
            ],
          ],
          [
            [
              [168.3227645190001, -17.44736093499995],
              [168.32740319100003, -17.419366143999923],
              [168.33855228000004, -17.41448333099993],
              [168.3520613940001, -17.424981377999927],
              [168.3637801440001, -17.44394296699994],
              [168.3720809250001, -17.47909921699994],
              [168.356293165, -17.48414478999996],
              [168.33415774800005, -17.46998463299991],
              [168.3227645190001, -17.44736093499995],
            ],
          ],
          [
            [
              [168.3911238940001, -17.067152601999908],
              [168.3857528000001, -17.073337497999944],
              [168.3818465500001, -17.080010674999926],
              [168.37647545700008, -17.085381768999923],
              [168.34327233200008, -17.09343840899993],
              [168.3330184250001, -17.094414971999925],
              [168.3227645190001, -17.089450778999947],
              [168.32781009200005, -17.078057549999926],
              [168.33952884200005, -17.06617603999996],
              [168.34937584700003, -17.059665622999944],
              [168.38835696700005, -17.041192315999922],
              [168.40202884200005, -17.040948174999926],
              [168.425140821, -17.04664478999996],
              [168.41675866000003, -17.05315520599993],
              [168.3911238940001, -17.067152601999908],
            ],
          ],
          [
            [
              [168.55925540500004, -16.943617445999905],
              [168.5429793630001, -16.94231536299992],
              [168.53272545700008, -16.93792083099993],
              [168.5297957690001, -16.92945728999996],
              [168.53500410200002, -16.91570403399993],
              [168.53394616000003, -16.894463799999926],
              [168.5527449880001, -16.879082940999922],
              [168.57837975400003, -16.876885674999926],
              [168.597015821, -16.895196221999925],
              [168.5703231130001, -16.93759530999995],
              [168.55925540500004, -16.943617445999905],
            ],
          ],
          [
            [
              [168.19206790500004, -16.813897393999923],
              [168.17937259200005, -16.80632903399993],
              [168.14991295700008, -16.77857838299991],
              [168.14421634200005, -16.76921965899993],
              [168.1464949880001, -16.741631768999923],
              [168.14421634200005, -16.73137786299992],
              [168.12842858200008, -16.718357028999947],
              [168.12037194100003, -16.709161065999922],
              [168.12061608200008, -16.700616143999923],
              [168.12484785200002, -16.688653252999927],
              [168.12671959700003, -16.65162525799991],
              [168.13111412900003, -16.635837497999944],
              [168.13746178500003, -16.62859465899993],
              [168.14380944100003, -16.623711846999925],
              [168.14909915500004, -16.61695728999996],
              [168.15113366000003, -16.60442473799992],
              [168.15064537900003, -16.594821872999944],
              [168.14918053500003, -16.588067315999922],
              [168.14421634200005, -16.573011976999908],
              [168.15406334700003, -16.579196872999944],
              [168.1601668630001, -16.57854583099993],
              [168.16627037900003, -16.57512786299992],
              [168.17530358200008, -16.573011976999908],
              [168.18506920700008, -16.575372002999927],
              [168.1899520190001, -16.580254815999922],
              [168.19263756600003, -16.585137627999927],
              [168.1958113940001, -16.587334893999923],
              [168.20281009200005, -16.595879815999922],
              [168.22022545700008, -16.633477471999925],
              [168.23023522200003, -16.642022393999923],
              [168.23218834700003, -16.649102471999925],
              [168.23454837300005, -16.664727471999925],
              [168.23894290500004, -16.681247653999947],
              [168.24732506600003, -16.69036223799992],
              [168.25513756600003, -16.689385674999926],
              [168.27165774800005, -16.679131768999923],
              [168.28150475400003, -16.676853122999944],
              [168.29021243600005, -16.678399346999925],
              [168.29810631600003, -16.68206145599993],
              [168.3046981130001, -16.68645598799992],
              [168.30933678500003, -16.69036223799992],
              [168.31983483200008, -16.70549895599993],
              [168.32634524800005, -16.720961195999905],
              [168.33521569100003, -16.733168226999908],
              [168.35336347700002, -16.738213799999926],
              [168.35661868600005, -16.743584893999923],
              [168.36085045700008, -16.755303643999923],
              [168.37029056100005, -16.767022393999923],
              [168.38819420700008, -16.772230726999908],
              [168.44117272200003, -16.77044036299992],
              [168.46412194100003, -16.778008721999925],
              [168.48072350400003, -16.800225518999923],
              [168.46753991000003, -16.80592213299991],
              [168.46998131600003, -16.819512627999927],
              [168.475922071, -16.83521900799991],
              [168.47388756600003, -16.84807708099993],
              [168.4633895190001, -16.84351978999996],
              [168.45337975400003, -16.84807708099993],
              [168.4004012380001, -16.819105726999908],
              [168.384125196, -16.80250416499996],
              [168.3676863940001, -16.794854424999926],
              [168.34831790500004, -16.788995049999926],
              [168.33326256600003, -16.786716403999947],
              [168.29167728000004, -16.79534270599993],
              [168.262054884, -16.812107028999947],
              [168.2329207690001, -16.822930596999925],
              [168.19206790500004, -16.813897393999923],
            ],
          ],
          [
            [
              [168.32960045700008, -16.53964609199994],
              [168.31592858200008, -16.535821221999925],
              [168.3076278000001, -16.524590752999927],
              [168.2954207690001, -16.497979424999926],
              [168.32447350400003, -16.49228280999995],
              [168.337250196, -16.49187590899993],
              [168.34937584700003, -16.497979424999926],
              [168.36117597700002, -16.51425546699994],
              [168.3613387380001, -16.52939218499995],
              [168.35043379, -16.539239190999922],
              [168.32960045700008, -16.53964609199994],
            ],
          ],
          [
            [
              [168.21314537900003, -16.478122653999947],
              [168.2226668630001, -16.440606377999927],
              [168.23414147200003, -16.432305596999925],
              [168.26099694100003, -16.42978280999995],
              [168.25171959700003, -16.444756768999923],
              [168.250824415, -16.479587497999944],
              [168.24382571700005, -16.49456145599993],
              [168.22624759200005, -16.50481536299992],
              [168.21013431100005, -16.504652601999908],
              [168.2031356130001, -16.49537525799991],
              [168.21314537900003, -16.478122653999947],
            ],
          ],
          [
            [
              [168.18238366000003, -16.347832940999922],
              [168.16863040500004, -16.35125090899993],
              [168.15406334700003, -16.35784270599993],
              [168.139984571, -16.36191171699994],
              [168.1274520190001, -16.357354424999926],
              [168.11589603000004, -16.347832940999922],
              [168.1025496750001, -16.33993905999995],
              [168.08912194100003, -16.33652109199994],
              [168.076508009, -16.34042734199994],
              [168.05005944100003, -16.322442315999922],
              [168.03663170700008, -16.32008228999996],
              [168.0219832690001, -16.32659270599993],
              [168.01238040500004, -16.314711195999905],
              [167.97917728000004, -16.295179945999905],
              [167.9633895190001, -16.282647393999923],
              [167.94898522200003, -16.27434661299992],
              [167.9316512380001, -16.267510674999926],
              [167.9209090500001, -16.258884372999944],
              [167.92644290500004, -16.244805596999925],
              [167.91285241000003, -16.233086846999925],
              [167.9257918630001, -16.219821872999944],
              [167.95036868600005, -16.208916924999926],
              [167.97966556100005, -16.202243747999944],
              [167.994476759, -16.19231536299992],
              [168.004242384, -16.190118096999925],
              [168.04867597700002, -16.190118096999925],
              [168.06950931100005, -16.17978280999995],
              [168.10694420700008, -16.14299895599993],
              [168.12061608200008, -16.134942315999922],
              [168.1254988940001, -16.129082940999922],
              [168.140961134, -16.089776299999926],
              [168.14991295700008, -16.08570728999996],
              [168.17164147200003, -16.080254815999922],
              [168.1914168630001, -16.10125090899993],
              [168.20728600400003, -16.13445403399993],
              [168.22681725400003, -16.19695403399993],
              [168.23072350400003, -16.227715752999927],
              [168.24968509200005, -16.24618905999995],
              [168.3212996750001, -16.28289153399993],
              [168.3286238940001, -16.29143645599993],
              [168.32984459700003, -16.306247653999947],
              [168.3222762380001, -16.318291924999926],
              [168.28825931100005, -16.344008070999905],
              [168.18238366000003, -16.347832940999922],
            ],
          ],
          [
            [
              [167.8125106130001, -16.419528903999947],
              [167.8227645190001, -16.419040622999944],
              [167.8305770190001, -16.43141041499996],
              [167.83716881600003, -16.44736093499995],
              [167.84392337300005, -16.457696221999925],
              [167.8203231130001, -16.48105234199994],
              [167.8125106130001, -16.484307549999926],
              [167.79957116000003, -16.486993096999925],
              [167.7934676440001, -16.494073174999926],
              [167.788422071, -16.503838799999926],
              [167.77800540500004, -16.515069268999923],
              [167.77165774800005, -16.524509372999944],
              [167.7724715500001, -16.53297291499996],
              [167.7719832690001, -16.540459893999923],
              [167.76059004, -16.546319268999923],
              [167.74439537900003, -16.546482028999947],
              [167.7373153000001, -16.538181247999944],
              [167.7334090500001, -16.526788018999923],
              [167.7265731130001, -16.517836195999905],
              [167.7172957690001, -16.51531340899993],
              [167.69092858200008, -16.51100025799991],
              [167.6855574880001, -16.508884372999944],
              [167.67937259200005, -16.499932549999926],
              [167.6650496750001, -16.49976978999996],
              [167.64991295700008, -16.50237395599993],
              [167.64087975400003, -16.50164153399993],
              [167.621918165, -16.49423593499995],
              [167.59978274800005, -16.502129815999922],
              [167.57984459700003, -16.515801690999922],
              [167.56812584700003, -16.52597421699994],
              [167.57488040500004, -16.531914971999925],
              [167.577484571, -16.53573984199994],
              [167.5810653000001, -16.53801848799992],
              [167.59001712300005, -16.53964609199994],
              [167.58025149800005, -16.552178643999923],
              [167.5683699880001, -16.556817315999922],
              [167.54216556100005, -16.560153903999947],
              [167.52100670700008, -16.58049895599993],
              [167.51514733200008, -16.57935963299991],
              [167.5083113940001, -16.574476820999905],
              [167.5029403000001, -16.574395440999922],
              [167.50066165500004, -16.587334893999923],
              [167.49439537900003, -16.587334893999923],
              [167.48617597700002, -16.57708098799992],
              [167.45875084700003, -16.567966403999947],
              [167.44654381600003, -16.54501718499995],
              [167.43311608200008, -16.534356377999927],
              [167.42107181100005, -16.520196221999925],
              [167.41871178500003, -16.497979424999926],
              [167.42546634200005, -16.497979424999926],
              [167.42945397200003, -16.504571221999925],
              [167.43572024800005, -16.51034921699994],
              [167.44361412900003, -16.51490650799991],
              [167.45281009200005, -16.517836195999905],
              [167.4502059250001, -16.501885674999926],
              [167.4443465500001, -16.481866143999923],
              [167.43572024800005, -16.462823174999926],
              [167.41081790500004, -16.430840752999927],
              [167.40650475400003, -16.42001718499995],
              [167.40503991000003, -16.40520598799992],
              [167.40577233200008, -16.38681405999995],
              [167.40503991000003, -16.38128020599993],
              [167.4004012380001, -16.374932549999926],
              [167.39380944100003, -16.37151458099993],
              [167.387543165, -16.36972421699994],
              [167.38453209700003, -16.368259372999944],
              [167.38152103000004, -16.346774997999944],
              [167.38257897200003, -16.285414320999905],
              [167.3877059250001, -16.272637627999927],
              [167.37712649800005, -16.22429778399993],
              [167.37647545700008, -16.21843840899993],
              [167.37712649800005, -16.200616143999923],
              [167.37484785200002, -16.192966403999947],
              [167.37029056100005, -16.190606377999927],
              [167.365570509, -16.18987395599993],
              [167.36345462300005, -16.186700127999927],
              [167.35816491000003, -16.169122002999927],
              [167.32243899800005, -16.11500416499996],
              [167.30648847700002, -16.12428150799991],
              [167.3012801440001, -16.12867603999996],
              [167.29517662900003, -16.121270440999922],
              [167.27906334700003, -16.140069268999923],
              [167.23308353000004, -16.16961028399993],
              [167.209320509, -16.14885833099993],
              [167.19597415500004, -16.143649997999944],
              [167.18531334700003, -16.149102471999925],
              [167.17855879, -16.138929945999905],
              [167.176117384, -16.129082940999922],
              [167.1748153000001, -16.11891041499996],
              [167.17164147200003, -16.108168226999908],
              [167.16391035200002, -16.09807708099993],
              [167.15503991000003, -16.090997002999927],
              [167.1474715500001, -16.08294036299992],
              [167.14421634200005, -16.07000090899993],
              [167.1484481130001, -16.046319268999923],
              [167.17847741000003, -15.990899346999925],
              [167.174164259, -15.924899997999944],
              [167.17505944100003, -15.912041924999926],
              [167.1801863940001, -15.903903903999947],
              [167.18181399800005, -15.89625416499996],
              [167.18531334700003, -15.89072030999995],
              [167.19556725400003, -15.88844166499996],
              [167.22624759200005, -15.867364190999922],
              [167.33611087300005, -15.908949476999908],
              [167.33480879, -15.944105726999908],
              [167.39470462300005, -16.01799895599993],
              [167.37712649800005, -16.052911065999922],
              [167.389984571, -16.057793877999927],
              [167.4004012380001, -16.064711195999905],
              [167.4043074880001, -16.074395440999922],
              [167.39763431100005, -16.087090752999927],
              [167.40650475400003, -16.09433359199994],
              [167.41521243600005, -16.10361093499995],
              [167.42448978000004, -16.111586195999905],
              [167.4443465500001, -16.11809661299992],
              [167.45964603000004, -16.13176848799992],
              [167.46998131600003, -16.134942315999922],
              [167.47339928500003, -16.131036065999922],
              [167.47185306100005, -16.12200286299992],
              [167.46648196700005, -16.10442473799992],
              [167.4707137380001, -16.10279713299991],
              [167.48015384200005, -16.113213799999926],
              [167.49439537900003, -16.134942315999922],
              [167.49341881600003, -16.14381275799991],
              [167.485687696, -16.15488046699994],
              [167.48698978000004, -16.162774346999925],
              [167.50953209700003, -16.173028252999927],
              [167.51490319100003, -16.176446221999925],
              [167.52100670700008, -16.176446221999925],
              [167.52418053500003, -16.170993747999944],
              [167.52719160200002, -16.168145440999922],
              [167.530609571, -16.16611093499995],
              [167.53467858200008, -16.162774346999925],
              [167.537445509, -16.17424895599993],
              [167.54175866000003, -16.185479424999926],
              [167.54761803500003, -16.19589609199994],
              [167.5551863940001, -16.20435963299991],
              [167.56666100400003, -16.21152109199994],
              [167.5898543630001, -16.217950127999927],
              [167.60303795700008, -16.22429778399993],
              [167.6254988940001, -16.244886976999908],
              [167.63843834700003, -16.262465101999908],
              [167.652679884, -16.269707940999922],
              [167.67937259200005, -16.258965752999927],
              [167.68873131600003, -16.263848565999922],
              [167.6923934250001, -16.265232028999947],
              [167.6923934250001, -16.272637627999927],
              [167.68572024800005, -16.287041924999926],
              [167.7036238940001, -16.306247653999947],
              [167.746918165, -16.34042734199994],
              [167.7724715500001, -16.33603280999995],
              [167.7861434250001, -16.358575127999927],
              [167.79468834700003, -16.40797291499996],
              [167.7758895190001, -16.44117603999996],
              [167.7739363940001, -16.45956796699994],
              [167.78923587300005, -16.470635674999926],
              [167.790375196, -16.451348565999922],
              [167.79444420700008, -16.438653252999927],
              [167.80152428500003, -16.429131768999923],
              [167.8125106130001, -16.419528903999947],
            ],
          ],
          [
            [
              [167.20573978000004, -15.75123463299991],
              [167.185883009, -15.750746351999908],
              [167.17204837300005, -15.74423593499995],
              [167.14421634200005, -15.724053643999923],
              [167.1294051440001, -15.718357028999947],
              [167.10141035200002, -15.711195570999905],
              [167.08912194100003, -15.703545830999929],
              [167.0722762380001, -15.676202080999929],
              [167.07569420700008, -15.649590752999927],
              [167.09498131600003, -15.629571221999925],
              [167.1269637380001, -15.621514580999929],
              [167.1977645190001, -15.629978122999944],
              [167.23357181100005, -15.64153411299992],
              [167.2368270190001, -15.659356377999927],
              [167.224945509, -15.690036716999941],
              [167.23210696700005, -15.719008070999905],
              [167.233734571, -15.741387627999927],
              [167.20573978000004, -15.75123463299991],
            ],
          ],
          [
            [
              [167.15739993600005, -15.538995049999926],
              [167.17644290500004, -15.531508070999905],
              [167.19019616000003, -15.531670830999929],
              [167.192718946, -15.535414320999905],
              [167.17847741000003, -15.538995049999926],
              [167.17847741000003, -15.54583098799992],
              [167.18873131600003, -15.54851653399993],
              [167.19263756600003, -15.553887627999927],
              [167.19109134200005, -15.560479424999926],
              [167.18531334700003, -15.566989841999941],
              [167.208343946, -15.57903411299992],
              [167.2094832690001, -15.596368096999925],
              [167.19483483200008, -15.60751718499995],
              [167.17164147200003, -15.601006768999923],
              [167.168304884, -15.605075778999947],
              [167.1650496750001, -15.606540622999944],
              [167.15739993600005, -15.608005466999941],
              [167.14283287900003, -15.605889580999929],
              [167.13233483200008, -15.602227471999925],
              [167.10954837300005, -15.587497653999947],
              [167.15739993600005, -15.538995049999926],
            ],
          ],
          [
            [
              [168.18580162900003, -15.517836195999905],
              [168.19255618600005, -15.526950778999947],
              [168.19890384200005, -15.529554945999905],
              [168.20378665500004, -15.53443775799991],
              [168.20573978000004, -15.549574476999908],
              [168.19792728000004, -15.610935153999947],
              [168.19947350400003, -15.627699476999908],
              [168.21314537900003, -15.659356377999927],
              [168.21314537900003, -15.689873955999929],
              [168.21607506600003, -15.703789971999925],
              [168.23951256600003, -15.768161716999941],
              [168.24732506600003, -15.819512627999927],
              [168.25212649800005, -15.834242445999905],
              [168.264008009, -15.85711028399993],
              [168.26783287900003, -15.87476978999996],
              [168.270355665, -15.914239190999922],
              [168.26775149800005, -15.949151299999926],
              [168.2548934250001, -15.975762627999927],
              [168.22681725400003, -15.990899346999925],
              [168.20427493600005, -15.992445570999905],
              [168.1923934250001, -15.985528252999927],
              [168.1875106130001, -15.971123955999929],
              [168.18384850400003, -15.930840752999927],
              [168.1660262380001, -15.87037525799991],
              [168.15503991000003, -15.793633721999925],
              [168.13111412900003, -15.73756275799991],
              [168.12224368600005, -15.70208098799992],
              [168.1196395190001, -15.662774346999925],
              [168.12452233200008, -15.621351820999905],
              [168.1489363940001, -15.543226820999905],
              [168.15455162900003, -15.463311455999929],
              [168.17652428500003, -15.461602471999925],
              [168.18287194100003, -15.507989190999922],
              [168.18580162900003, -15.517836195999905],
            ],
          ],
          [
            [
              [167.9394637380001, -15.39185963299991],
              [167.93620853000004, -15.41025155999995],
              [167.92790774800005, -15.42359791499996],
              [167.86158287900003, -15.476739190999922],
              [167.83855228000004, -15.484795830999929],
              [167.73414147200003, -15.484307549999926],
              [167.7129012380001, -15.477634372999944],
              [167.6787215500001, -15.46103280999995],
              [167.6728621750001, -15.449802341999941],
              [167.68238366000003, -15.43254973799992],
              [167.80445397200003, -15.32000090899993],
              [167.8261824880001, -15.313083591999941],
              [167.843109571, -15.31031666499996],
              [167.8916121750001, -15.29192473799992],
              [167.976898634, -15.277764580999929],
              [168.0024520190001, -15.281833591999941],
              [168.003265821, -15.291599216999941],
              [167.98031660200002, -15.313083591999941],
              [167.9672957690001, -15.328301690999922],
              [167.953949415, -15.348809502999927],
              [167.94361412900003, -15.37118905999995],
              [167.9394637380001, -15.39185963299991],
            ],
          ],
          [
            [
              [167.12322024800005, -14.963636976999908],
              [167.10108483200008, -14.939629815999922],
              [167.09644616000003, -14.928887627999927],
              [167.114105665, -14.933851820999905],
              [167.13982181100005, -14.953301690999922],
              [167.15739993600005, -14.956231377999927],
              [167.14861087300005, -14.965590101999908],
              [167.1396590500001, -14.96965911299992],
              [167.13103274800005, -14.968926690999922],
              [167.12322024800005, -14.963636976999908],
            ],
          ],
          [
            [
              [168.09644616000003, -14.980401299999926],
              [168.0981551440001, -14.972588799999926],
              [168.10084069100003, -14.967543226999908],
              [168.10043379, -14.962090752999927],
              [168.09327233200008, -14.953057549999926],
              [168.09050540500004, -14.943536065999922],
              [168.094086134, -14.93141041499996],
              [168.10173587300005, -14.92083098799992],
              [168.110687696, -14.91578541499996],
              [168.12289472700002, -14.92278411299992],
              [168.133636915, -14.94036223799992],
              [168.14136803500003, -14.960137627999927],
              [168.14421634200005, -14.97356536299992],
              [168.145843946, -14.996677341999941],
              [168.15796959700003, -15.05242278399993],
              [168.15837649800005, -15.062676690999922],
              [168.15699303500003, -15.08367278399993],
              [168.15796959700003, -15.093926690999922],
              [168.16976972700002, -15.126560153999947],
              [168.17164147200003, -15.13795338299991],
              [168.17164147200003, -15.17278411299992],
              [168.1748153000001, -15.18141041499996],
              [168.188812696, -15.197523695999905],
              [168.19206790500004, -15.20631275799991],
              [168.18897545700008, -15.274590752999927],
              [168.1943465500001, -15.28915780999995],
              [168.19255618600005, -15.308038018999923],
              [168.18580162900003, -15.336358330999929],
              [168.184906446, -15.365492445999905],
              [168.17896569100003, -15.395114841999941],
              [168.1660262380001, -15.39031340899993],
              [168.1552840500001, -15.39031340899993],
              [168.13111412900003, -15.395114841999941],
              [168.13689212300005, -15.371840101999908],
              [168.13542728000004, -15.346856377999927],
              [168.12378991000003, -15.299411716999941],
              [168.13054446700005, -15.264743747999944],
              [168.13013756600003, -15.157647393999923],
              [168.12061608200008, -15.134942315999922],
              [168.09644616000003, -14.980401299999926],
            ],
          ],
          [
            [
              [167.1406356130001, -15.535577080999929],
              [167.10271243600005, -15.580010674999926],
              [167.094086134, -15.586358330999929],
              [167.08570397200003, -15.590508721999925],
              [167.07642662900003, -15.592868747999944],
              [167.06519616000003, -15.593682549999926],
              [167.0532332690001, -15.59189218499995],
              [167.03638756600003, -15.583184502999927],
              [167.02711022200003, -15.580010674999926],
              [166.989105665, -15.575616143999923],
              [166.9462996750001, -15.576755466999941],
              [166.90796959700003, -15.586358330999929],
              [166.88347415500004, -15.608005466999941],
              [166.89323978000004, -15.617771091999941],
              [166.885101759, -15.61891041499996],
              [166.8637801440001, -15.614841403999947],
              [166.85141035200002, -15.622653903999947],
              [166.84644616000003, -15.63095468499995],
              [166.84294681100005, -15.639743747999944],
              [166.83578535200002, -15.648858330999929],
              [166.81560306100005, -15.65829843499995],
              [166.79314212300005, -15.65634530999995],
              [166.7714949880001, -15.645196221999925],
              [166.7539168630001, -15.627699476999908],
              [166.766449415, -15.608819268999923],
              [166.76677493600005, -15.583916924999926],
              [166.756195509, -15.562432549999926],
              [166.7216903000001, -15.547295830999929],
              [166.70720462300005, -15.532810153999947],
              [166.68506920700008, -15.49814218499995],
              [166.67408287900003, -15.46803150799991],
              [166.66781660200002, -15.460137627999927],
              [166.64136803500003, -15.434747002999927],
              [166.6372176440001, -15.425713799999926],
              [166.63404381600003, -15.413181247999944],
              [166.61939537900003, -15.39462655999995],
              [166.61605879, -15.385023695999905],
              [166.61833743600005, -15.376071872999944],
              [166.62761478000004, -15.355645440999922],
              [166.6328231130001, -15.326348565999922],
              [166.64616946700005, -15.285577080999929],
              [166.65007571700005, -15.264743747999944],
              [166.64918053500003, -15.218357028999947],
              [166.64380944100003, -15.195245049999926],
              [166.61980228000004, -15.161553643999923],
              [166.61394290500004, -15.14185963299991],
              [166.6098738940001, -15.100274346999925],
              [166.5996199880001, -15.062107028999947],
              [166.60035241000003, -15.048435153999947],
              [166.6098738940001, -15.031914971999925],
              [166.59262129, -15.02629973799992],
              [166.5820418630001, -15.01140715899993],
              [166.5766707690001, -14.99228280999995],
              [166.5752059250001, -14.97356536299992],
              [166.5708113940001, -14.956231377999927],
              [166.5493270190001, -14.92506275799991],
              [166.5410262380001, -14.908379815999922],
              [166.52263431100005, -14.83212655999995],
              [166.5239363940001, -14.815850518999923],
              [166.53109785200002, -14.799493096999925],
              [166.53467858200008, -14.775323174999926],
              [166.5337020190001, -14.75164153399993],
              [166.5273543630001, -14.737074476999908],
              [166.55453535200002, -14.682386976999908],
              [166.55258222700002, -14.657647393999923],
              [166.55616295700008, -14.645928643999923],
              [166.58765709700003, -14.63640715899993],
              [166.5937606130001, -14.62859465899993],
              [166.59839928500003, -14.625258070999905],
              [166.6098738940001, -14.634698174999926],
              [166.61394290500004, -14.642836195999905],
              [166.62370853000004, -14.669366143999923],
              [166.62671959700003, -14.674981377999927],
              [166.63502037900003, -14.67945728999996],
              [166.64031009200005, -14.690036716999941],
              [166.64323978000004, -14.702569268999923],
              [166.64405358200008, -14.713148695999905],
              [166.64795983200008, -14.715020440999922],
              [166.671234571, -14.74391041499996],
              [166.680023634, -14.76848723799992],
              [166.68620853000004, -14.779961846999925],
              [166.706390821, -14.789727471999925],
              [166.7470809250001, -14.81959400799991],
              [166.7373153000001, -14.829522393999923],
              [166.74195397200003, -14.852715752999927],
              [166.76002037900003, -14.901543877999927],
              [166.769867384, -14.947930596999925],
              [166.774261915, -14.99773528399993],
              [166.77295983200008, -15.009698174999926],
              [166.77808678500003, -15.016289971999925],
              [166.78467858200008, -15.021416924999926],
              [166.7880965500001, -15.028497002999927],
              [166.8017684250001, -15.152276299999926],
              [166.81316165500004, -15.160414320999905],
              [166.8388778000001, -15.160902601999908],
              [166.88347415500004, -15.15601978999996],
              [166.9091903000001, -15.156914971999925],
              [166.91976972700002, -15.15593840899993],
              [166.926117384, -15.14812590899993],
              [166.938812696, -15.128106377999927],
              [166.94695071700005, -15.119886976999908],
              [166.95590254, -15.11296965899993],
              [166.963226759, -15.104180596999925],
              [166.966156446, -15.090264580999929],
              [166.97193444100003, -14.979913018999923],
              [166.96989993600005, -14.967054945999905],
              [166.96452884200005, -14.951348565999922],
              [166.975922071, -14.93726978999996],
              [166.99390709700003, -14.926853122999944],
              [167.00766035200002, -14.922051690999922],
              [167.082855665, -14.928887627999927],
              [167.082855665, -14.936293226999908],
              [167.06470787900003, -14.93922291499996],
              [167.05616295700008, -14.947686455999929],
              [167.054047071, -14.960381768999923],
              [167.05681399800005, -15.00204843499995],
              [167.05290774800005, -15.012302341999941],
              [167.04127037900003, -15.02507903399993],
              [167.05787194100003, -15.026950778999947],
              [167.06462649800005, -15.03883228999996],
              [167.06861412900003, -15.072930596999925],
              [167.08570397200003, -15.12200286299992],
              [167.08912194100003, -15.141208591999941],
              [167.1132918630001, -15.124200127999927],
              [167.12574303500003, -15.121351820999905],
              [167.14421634200005, -15.128106377999927],
              [167.13941491000003, -15.146416924999926],
              [167.15739993600005, -15.226820570999905],
              [167.15259850400003, -15.242771091999941],
              [167.14421634200005, -15.246351820999905],
              [167.14079837300005, -15.24976978999996],
              [167.15113366000003, -15.264743747999944],
              [167.155609571, -15.267185153999947],
              [167.17164147200003, -15.272881768999923],
              [167.17847741000003, -15.277764580999929],
              [167.1821395190001, -15.28329843499995],
              [167.191742384, -15.30559661299992],
              [167.1894637380001, -15.324639580999929],
              [167.18506920700008, -15.340997002999927],
              [167.17888431100005, -15.34661223799992],
              [167.17164147200003, -15.33294036299992],
              [167.16480553500003, -15.33294036299992],
              [167.17172285200002, -15.366387627999927],
              [167.1894637380001, -15.417168877999927],
              [167.2129012380001, -15.463555596999925],
              [167.2368270190001, -15.483819268999923],
              [167.24537194100003, -15.48805103999996],
              [167.24724368600005, -15.498223565999922],
              [167.2446395190001, -15.50953541499996],
              [167.240570509, -15.517836195999905],
              [167.2334090500001, -15.523614190999922],
              [167.2275496750001, -15.523044528999947],
              [167.22038821700005, -15.519789320999905],
              [167.20915774800005, -15.517836195999905],
              [167.17172285200002, -15.517836195999905],
              [167.15739993600005, -15.522881768999923],
              [167.1406356130001, -15.535577080999929],
            ],
          ],
          [
            [
              [167.51490319100003, -14.140557549999926],
              [167.52507571700005, -14.143324476999908],
              [167.5864363940001, -14.172458591999941],
              [167.59538821700005, -14.17937590899993],
              [167.60303795700008, -14.189060153999947],
              [167.59644616000003, -14.241794528999947],
              [167.59343509200005, -14.250420830999929],
              [167.58773847700002, -14.256524346999925],
              [167.56202233200008, -14.29892343499995],
              [167.54802493600005, -14.313083591999941],
              [167.5371199880001, -14.318942966999941],
              [167.52613366000003, -14.319919528999947],
              [167.4589949880001, -14.314385674999926],
              [167.4453231130001, -14.319431247999944],
              [167.43091881600003, -14.31845468499995],
              [167.41863040500004, -14.31340911299992],
              [167.40845787900003, -14.307712497999944],
              [167.40121504, -14.305108330999929],
              [167.396820509, -14.299574476999908],
              [167.40105228000004, -14.287530205999929],
              [167.4111434250001, -14.267836195999905],
              [167.40503991000003, -14.21298593499995],
              [167.40748131600003, -14.194919528999947],
              [167.41423587300005, -14.186211846999925],
              [167.42408287900003, -14.18059661299992],
              [167.44792728000004, -14.16139088299991],
              [167.4550887380001, -14.160088799999926],
              [167.4638778000001, -14.16187916499996],
              [167.48072350400003, -14.16106536299992],
              [167.48951256600003, -14.156914971999925],
              [167.5048934250001, -14.143649997999944],
              [167.51490319100003, -14.140557549999926],
            ],
          ],
          [
            [
              [167.45281009200005, -13.918633721999925],
              [167.4521590500001, -13.897881768999923],
              [167.44841556100005, -13.885023695999905],
              [167.43824303500003, -13.874444268999923],
              [167.41871178500003, -13.860039971999925],
              [167.3950301440001, -13.824965101999908],
              [167.3891707690001, -13.804294528999947],
              [167.39079837300005, -13.777520440999922],
              [167.39861087300005, -13.756036065999922],
              [167.41228274800005, -13.73951588299991],
              [167.430511915, -13.726739190999922],
              [167.47380618600005, -13.708428643999923],
              [167.48894290500004, -13.708184502999927],
              [167.50310306100005, -13.71689218499995],
              [167.52100670700008, -13.736504815999922],
              [167.54965254, -13.789483330999929],
              [167.56202233200008, -13.798028252999927],
              [167.54957116000003, -13.814060153999947],
              [167.54216556100005, -13.818536065999922],
              [167.54859459700003, -13.832777601999908],
              [167.55681399800005, -13.838067315999922],
              [167.56617272200003, -13.840508721999925],
              [167.57569420700008, -13.846368096999925],
              [167.5810653000001, -13.848728122999944],
              [167.58570397200003, -13.847588799999926],
              [167.58871504, -13.848402601999908],
              [167.59001712300005, -13.856622002999927],
              [167.58716881600003, -13.860528252999927],
              [167.5810653000001, -13.86028411299992],
              [167.57374108200008, -13.85906340899993],
              [167.56812584700003, -13.860039971999925],
              [167.5517684250001, -13.871840101999908],
              [167.5337020190001, -13.880466403999947],
              [167.51246178500003, -13.885511976999908],
              [167.48698978000004, -13.887383721999925],
              [167.49040774800005, -13.890232028999947],
              [167.49366295700008, -13.89185963299991],
              [167.49341881600003, -13.894952080999929],
              [167.48698978000004, -13.901055596999925],
              [167.4985457690001, -13.924493096999925],
              [167.4848738940001, -13.942152601999908],
              [167.4638778000001, -13.943942966999941],
              [167.45281009200005, -13.918633721999925],
            ],
          ],
          [
            [
              [167.70264733200008, -13.619805596999925],
              [167.711761915, -13.62590911299992],
              [167.71648196700005, -13.640232028999947],
              [167.71664472700002, -13.65634530999995],
              [167.7129012380001, -13.668226820999905],
              [167.70427493600005, -13.672539971999925],
              [167.6875106130001, -13.677992445999905],
              [167.66765384200005, -13.682061455999929],
              [167.650726759, -13.681898695999905],
              [167.6435653000001, -13.692803643999923],
              [167.63502037900003, -13.693536065999922],
              [167.63347415500004, -13.684258721999925],
              [167.6699324880001, -13.63648853999996],
              [167.683929884, -13.62468840899993],
              [167.70264733200008, -13.619805596999925],
            ],
          ],
          [
            [
              [167.32927493600005, -13.510511976999908],
              [167.336761915, -13.52353280999995],
              [167.34693444100003, -13.528008721999925],
              [167.35865319100003, -13.525567315999922],
              [167.37086022200003, -13.51734791499996],
              [167.36866295700008, -13.543389580999929],
              [167.35670006600003, -13.553399346999925],
              [167.33806399800005, -13.55396900799991],
              [167.31560306100005, -13.551527601999908],
              [167.3051863940001, -13.536716403999947],
              [167.29704837300005, -13.520603122999944],
              [167.29664147200003, -13.504489841999941],
              [167.30884850400003, -13.490166924999926],
              [167.33480879, -13.483575127999927],
              [167.35132897200003, -13.492933851999908],
              [167.35141035200002, -13.50595468499995],
              [167.32927493600005, -13.510511976999908],
            ],
          ],
          [
            [
              [166.5752059250001, -13.236260674999926],
              [166.590668165, -13.22275155999995],
              [166.61158287900003, -13.215264580999929],
              [166.63152103000004, -13.216729424999926],
              [166.64405358200008, -13.230075778999947],
              [166.64283287900003, -13.24773528399993],
              [166.63054446700005, -13.261651299999926],
              [166.61304772200003, -13.268243096999925],
              [166.5957137380001, -13.264255466999941],
              [166.58814537900003, -13.258477471999925],
              [166.58277428500003, -13.252536716999941],
              [166.57878665500004, -13.245293877999927],
              [166.5752059250001, -13.236260674999926],
            ],
          ],
          [
            [
              [166.5752059250001, -13.15439218499995],
              [166.5693465500001, -13.15715911299992],
              [166.56812584700003, -13.161309502999927],
              [166.56861412900003, -13.167168877999927],
              [166.5683699880001, -13.174899997999944],
              [166.5664168630001, -13.17896900799991],
              [166.563812696, -13.18254973799992],
              [166.56006920700008, -13.18564218499995],
              [166.55453535200002, -13.18840911299992],
              [166.538422071, -13.179945570999905],
              [166.529633009, -13.169854424999926],
              [166.52662194100003, -13.155368747999944],
              [166.5273543630001, -13.133884372999944],
              [166.5332137380001, -13.10637786299992],
              [166.5341903000001, -13.095635674999926],
              [166.5317488940001, -13.088148695999905],
              [166.5263778000001, -13.083184502999927],
              [166.52165774800005, -13.076755466999941],
              [166.5205184250001, -13.064873955999929],
              [166.55445397200003, -13.07398853999996],
              [166.56137129, -13.078708591999941],
              [166.56666100400003, -13.08912525799991],
              [166.5708113940001, -13.111748955999929],
              [166.5752059250001, -13.120212497999944],
              [166.5752059250001, -13.126397393999923],
              [166.5703231130001, -13.13209400799991],
              [166.5683699880001, -13.138278903999947],
              [166.569672071, -13.145277601999908],
              [166.5752059250001, -13.15439218499995],
            ],
          ],
          [
            [
              [166.672699415, -13.455010674999926],
              [166.65845787900003, -13.415459893999923],
              [166.6738387380001, -13.407647393999923],
              [166.68873131600003, -13.423435153999947],
              [166.672699415, -13.455010674999926],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Niue',
        iso3: 'NIU',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-169.85114498599992, -18.965101820999905],
            [-169.8253067699999, -18.967950127999927],
            [-169.8226212229999, -18.972588799999926],
            [-169.79426021999993, -19.047133070999905],
            [-169.78290768099993, -19.06894296699994],
            [-169.7968643869999, -19.07390715899993],
            [-169.80597896999993, -19.081963799999926],
            [-169.82384192599991, -19.102308851999908],
            [-169.86542721299992, -19.129652601999908],
            [-169.87299557199992, -19.12590911299992],
            [-169.88097083199992, -19.129082940999922],
            [-169.89891516799992, -19.142754815999922],
            [-169.90204830599993, -19.132989190999922],
            [-169.90998287699992, -19.12859465899993],
            [-169.92109127499992, -19.128024997999944],
            [-169.93370520699992, -19.129652601999908],
            [-169.93053137899992, -19.126397393999923],
            [-169.9279679029999, -19.12281666499996],
            [-169.9247940749999, -19.119317315999922],
            [-169.9194229809999, -19.115980726999908],
            [-169.9240616529999, -19.09937916499996],
            [-169.92625891799992, -19.094903252999927],
            [-169.95042883999992, -19.087334893999923],
            [-169.94770260299993, -19.069431247999944],
            [-169.92625891799992, -19.03753020599993],
            [-169.9279679029999, -19.03183359199994],
            [-169.93158932199992, -19.026543877999927],
            [-169.93439693899992, -19.020928643999923],
            [-169.93370520699992, -19.013604424999926],
            [-169.93024654899992, -19.00839609199994],
            [-169.9263809889999, -19.007419528999947],
            [-169.92182369699992, -19.007012627999927],
            [-169.9160050119999, -19.003106377999927],
            [-169.89582271999993, -18.965101820999905],
            [-169.86371822799993, -18.964043877999927],
            [-169.85114498599992, -18.965101820999905],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'American Samoa',
        iso3: 'ASM',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-170.59101314999992, -14.264825127999927],
              [-170.57624264199993, -14.252536716999941],
              [-170.56725012899992, -14.258558851999908],
              [-170.56847083199992, -14.270928643999923],
              [-170.58417721299992, -14.277764580999929],
              [-170.64232337099992, -14.280694268999923],
              [-170.6592911449999, -14.28525155999995],
              [-170.6835831369999, -14.30282968499995],
              [-170.7217911449999, -14.353448174999926],
              [-170.7486466139999, -14.37468840899993],
              [-170.75548255099991, -14.367120049999926],
              [-170.79645748599992, -14.33993905999995],
              [-170.82282467399992, -14.326755466999941],
              [-170.83124752499992, -14.319431247999944],
              [-170.78864498599992, -14.294528903999947],
              [-170.7725723949999, -14.291436455999929],
              [-170.73786373599992, -14.292087497999944],
              [-170.72150631399992, -14.289239190999922],
              [-170.69847571499992, -14.260511976999908],
              [-170.66144771999993, -14.252373955999929],
              [-170.62006588399993, -14.254571221999925],
              [-170.59101314999992, -14.264825127999927],
            ],
          ],
          [
            [
              [-169.4638565749999, -14.223239841999941],
              [-169.44404049399992, -14.230645440999922],
              [-169.44013424399992, -14.245293877999927],
              [-169.4471329419999, -14.25562916499996],
              [-169.46015377499992, -14.250420830999929],
              [-169.46808834499993, -14.25872161299992],
              [-169.47618567599991, -14.262383721999925],
              [-169.4849747389999, -14.261976820999905],
              [-169.4948624339999, -14.257256768999923],
              [-169.49836178299992, -14.266045830999929],
              [-169.5042618479999, -14.270603122999944],
              [-169.51252193899992, -14.271742445999905],
              [-169.5228165359999, -14.270928643999923],
              [-169.52550208199992, -14.258965752999927],
              [-169.5292862619999, -14.248793226999908],
              [-169.53477942599991, -14.24114348799992],
              [-169.54267330599993, -14.236748955999929],
              [-169.52753658799992, -14.226006768999923],
              [-169.5064591139999, -14.222263278999947],
              [-169.4638565749999, -14.223239841999941],
            ],
          ],
          [
            [
              [-168.16156979099992, -14.53289153399993],
              [-168.17308508999992, -14.523695570999905],
              [-168.16352291599992, -14.519789320999905],
              [-168.16047115799992, -14.520928643999923],
              [-168.16156979099992, -14.53289153399993],
            ],
          ],
          [
            [
              [-169.67621822799993, -14.174899997999944],
              [-169.66816158799992, -14.169122002999927],
              [-169.6581925119999, -14.16887786299992],
              [-169.64716549399992, -14.172133070999905],
              [-169.63560950399992, -14.17701588299991],
              [-169.6601456369999, -14.18914153399993],
              [-169.66974850199992, -14.187920830999929],
              [-169.67621822799993, -14.174899997999944],
            ],
          ],
          [
            [
              [-171.07282467399992, -11.05250416499996],
              [-171.07347571499992, -11.062107028999947],
              [-171.0815323559999, -11.06609465899993],
              [-171.0865372389999, -11.06031666499996],
              [-171.08564205599993, -11.051364841999941],
              [-171.07282467399992, -11.05250416499996],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Palau',
        iso3: 'PLW',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [134.2714949880001, 7.07453034100007],
              [134.2793074880001, 7.072739976000094],
              [134.2832137380001, 7.068752346000053],
              [134.28443444100003, 7.062648830000057],
              [134.28500410200002, 7.054632880000042],
              [134.28093509200005, 7.049627997000073],
              [134.2714949880001, 7.033596096000053],
              [134.27995853000004, 7.020493882000039],
              [134.27605228000004, 7.016913153000075],
              [134.266449415, 7.016424872000073],
              [134.2578231130001, 7.013088283000059],
              [134.24333743600005, 6.99282461100006],
              [134.2343856130001, 6.984320380000042],
              [134.2304793630001, 6.989203192000048],
              [134.235687696, 7.008490302000041],
              [134.2714949880001, 7.07453034100007],
            ],
          ],
          [
            [
              [134.4638778000001, 7.294256903000075],
              [134.4492293630001, 7.290025132000039],
              [134.45093834700003, 7.281642971000053],
              [134.4589949880001, 7.271877346000053],
              [134.4638778000001, 7.263576565000051],
              [134.458343946, 7.256740627000056],
              [134.446136915, 7.253810940000051],
              [134.42595462300005, 7.253322658000059],
              [134.4165145190001, 7.247951565000051],
              [134.392914259, 7.224514065000051],
              [134.3779403000001, 7.219142971000053],
              [134.36491946700005, 7.221502997000073],
              [134.35523522200003, 7.228013414000088],
              [134.34913170700008, 7.237779039000088],
              [134.34717858200008, 7.249904690000051],
              [134.34791100400003, 7.267808335000041],
              [134.35084069100003, 7.271185614000046],
              [134.38257897200003, 7.237941799000055],
              [134.389008009, 7.23891836100006],
              [134.401703321, 7.246486721000053],
              [134.436859571, 7.277899481000077],
              [134.4438582690001, 7.28742096600007],
              [134.44459069100003, 7.299221096000053],
              [134.4414168630001, 7.310248114000046],
              [134.44109134200005, 7.31671784100007],
              [134.44947350400003, 7.31476471600007],
              [134.45484459700003, 7.311590887000079],
              [134.4589949880001, 7.307684637000079],
              [134.46216881600003, 7.302150783000059],
              [134.4638778000001, 7.294256903000075],
            ],
          ],
          [
            [
              [134.47136478000004, 7.362494208000044],
              [134.488617384, 7.357855536000045],
              [134.51189212300005, 7.347316799000055],
              [134.5273543630001, 7.331529039000088],
              [134.52222741000003, 7.311346747000073],
              [134.51189212300005, 7.308579820000091],
              [134.503265821, 7.319322007000039],
              [134.4965926440001, 7.333807684000078],
              [134.4912215500001, 7.342678127000056],
              [134.47779381600003, 7.346869208000044],
              [134.46802819100003, 7.343817450000074],
              [134.44947350400003, 7.328355210000041],
              [134.4477645190001, 7.34320709800005],
              [134.449554884, 7.355414130000042],
              [134.45687910200002, 7.362697658000059],
              [134.47136478000004, 7.362494208000044],
            ],
          ],
          [
            [
              [134.64820397200003, 7.719427802000041],
              [134.6601668630001, 7.686021226000037],
              [134.66334069100003, 7.638576565000051],
              [134.6582137380001, 7.591050523000092],
              [134.645355665, 7.557440497000073],
              [134.62574303500003, 7.530503648000092],
              [134.62484785200002, 7.523911851000094],
              [134.63599694100003, 7.509466864000046],
              [134.63599694100003, 7.503159898000092],
              [134.6313582690001, 7.49868398600006],
              [134.62289472700002, 7.472805080000057],
              [134.5996199880001, 7.442572333000044],
              [134.5942488940001, 7.421128648000092],
              [134.60108483200008, 7.383612372000073],
              [134.5962020190001, 7.369940497000073],
              [134.59164472700002, 7.366888739000046],
              [134.58668053500003, 7.36859772300005],
              [134.57496178500003, 7.369574286000045],
              [134.56560306100005, 7.37531159100007],
              [134.55933678500003, 7.376166083000044],
              [134.5546981130001, 7.372544664000088],
              [134.54420006600003, 7.358547268000052],
              [134.53882897200003, 7.355698960000041],
              [134.52800540500004, 7.357570705000057],
              [134.523773634, 7.361029364000046],
              [134.52230879, 7.367010809000078],
              [134.51343834700003, 7.391791083000044],
              [134.5058699880001, 7.424017645000049],
              [134.49927819100003, 7.43821849200009],
              [134.4912215500001, 7.444566148000092],
              [134.48552493600005, 7.444159247000073],
              [134.4829207690001, 7.445786851000094],
              [134.4843856130001, 7.458726304000038],
              [134.48755944100003, 7.469916083000044],
              [134.49333743600005, 7.480129299000055],
              [134.501312696, 7.488348700000074],
              [134.51156660200002, 7.493475653000075],
              [134.51547285200002, 7.480536200000074],
              [134.5244246750001, 7.47882721600007],
              [134.53386478000004, 7.485988674000055],
              [134.53882897200003, 7.499701239000046],
              [134.5361434250001, 7.507961330000057],
              [134.5283309250001, 7.516099351000094],
              [134.51156660200002, 7.52765534100007],
              [134.51929772200003, 7.534857489000046],
              [134.53272545700008, 7.553697007000039],
              [134.54476972700002, 7.561835028000075],
              [134.54639733200008, 7.56118398600006],
              [134.547211134, 7.56671784100007],
              [134.54712975400003, 7.58038971600007],
              [134.54639733200008, 7.581610419000071],
              [134.556976759, 7.601141669000071],
              [134.56910241000003, 7.613714911000045],
              [134.58611087300005, 7.62055084800005],
              [134.61117597700002, 7.622544664000088],
              [134.63502037900003, 7.629339911000045],
              [134.640961134, 7.645982164000088],
              [134.63298587300005, 7.698187567000048],
              [134.62370853000004, 7.717962958000044],
              [134.621429884, 7.729681708000044],
              [134.625336134, 7.734076239000046],
              [134.63428795700008, 7.732163804000038],
              [134.64332116000003, 7.726467190000051],
              [134.64820397200003, 7.719427802000041],
            ],
          ],
          [
            [
              [131.14210045700008, 3.047308661000045],
              [131.16089928500003, 3.058783270000049],
              [131.1836043630001, 3.060288804000038],
              [131.19206790500004, 3.048814195000091],
              [131.18043053500003, 3.033270575000074],
              [131.160492384, 3.022772528000075],
              [131.13843834700003, 3.018947658000059],
              [131.13111412900003, 3.029486395000049],
              [131.14210045700008, 3.047308661000045],
            ],
          ],
          [
            [
              [132.22038821700005, 5.292222398000092],
              [132.2138778000001, 5.307114976000094],
              [132.22022545700008, 5.310248114000046],
              [132.22673587300005, 5.304348049000055],
              [132.22038821700005, 5.292222398000092],
            ],
          ],
          [
            [
              [134.15967858200008, 6.884466864000046],
              [134.14527428500003, 6.89915599200009],
              [134.1367293630001, 6.919094143000052],
              [134.1396590500001, 6.934271552000041],
              [134.15984134200005, 6.93500397300005],
              [134.173187696, 6.924872137000079],
              [134.1777449880001, 6.909165757000039],
              [134.17335045700008, 6.893744208000044],
              [134.15967858200008, 6.884466864000046],
            ],
          ],
          [
            [
              [131.7915145190001, 2.977728583000044],
              [131.80640709700003, 2.974269924000055],
              [131.8129988940001, 2.960435289000088],
              [131.79517662900003, 2.949042059000078],
              [131.77881920700008, 2.952826239000046],
              [131.7754012380001, 2.964056708000044],
              [131.78500410200002, 2.97406647300005],
              [131.7915145190001, 2.977728583000044],
            ],
          ],
          [
            [
              [134.70967643427375, 8.09661782863137],
              [134.7222477435953, 8.096466184369348],
              [134.7273429907992, 8.08287885849227],
              [134.7181078552421, 8.058676434273728],
              [134.70124501330537, 8.050245013305364],
              [134.69252546823918, 8.060799453942021],
              [134.69281359233702, 8.075539276210458],
              [134.70967643427375, 8.09661782863137],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Guam',
        iso3: 'GUM',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [144.88640384200005, 13.640204169000071],
            [144.89665774800005, 13.617987372000073],
            [144.91431725400003, 13.605414130000042],
            [144.934418165, 13.59983958500004],
            [144.95191491000003, 13.598578192000048],
            [144.9521590500001, 13.586859442000048],
            [144.93767337300005, 13.56053294500009],
            [144.90699303500003, 13.51666901200008],
            [144.87183678500003, 13.485174872000073],
            [144.80827884200005, 13.445786851000037],
            [144.78345787900003, 13.420477606000077],
            [144.76937910200002, 13.37913646000004],
            [144.760101759, 13.285630601000037],
            [144.73560631600003, 13.249172268000052],
            [144.71802819100003, 13.241848049000055],
            [144.69752037900003, 13.241034247000073],
            [144.6806746750001, 13.246771552000041],
            [144.6704207690001, 13.264837958000044],
            [144.6567488940001, 13.282049872000073],
            [144.65357506600003, 13.28701406500005],
            [144.6474715500001, 13.324896552000041],
            [144.64429772200003, 13.331610419000071],
            [144.63949629, 13.337469794000071],
            [144.633636915, 13.34210846600007],
            [144.626312696, 13.345363674000055],
            [144.63656660200002, 13.355414130000042],
            [144.6430770190001, 13.365708726000037],
            [144.6464949880001, 13.378485419000071],
            [144.6474715500001, 13.396226304000038],
            [144.6455184250001, 13.404486395000049],
            [144.64047285200002, 13.41478099200009],
            [144.6347762380001, 13.423529364000046],
            [144.62419681100005, 13.431219794000071],
            [144.62867272200003, 13.438788153000075],
            [144.63648522200003, 13.443101304000038],
            [144.6406356130001, 13.43781159100007],
            [144.65447024800005, 13.439154364000046],
            [144.7148543630001, 13.473456122000073],
            [144.72877037900003, 13.485581773000092],
            [144.78345787900003, 13.51666901200008],
            [144.79411868600005, 13.527085679000038],
            [144.8032332690001, 13.539129950000074],
            [144.81120853000004, 13.553615627000056],
            [144.83220462300005, 13.620672919000071],
            [144.83863366000003, 13.632757880000042],
            [144.85043379, 13.643744208000044],
            [144.86670983200008, 13.653021552000041],
            [144.88062584700003, 13.654120184000078],
            [144.88640384200005, 13.640204169000071],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'N. Mariana Is.',
        iso3: 'MNP',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [145.20573978000004, 14.181382554000038],
              [145.2524520190001, 14.200384833000044],
              [145.27995853000004, 14.202785549000055],
              [145.29053795700008, 14.181382554000038],
              [145.28736412900003, 14.169582424000055],
              [145.282074415, 14.161037502000056],
              [145.27361087300005, 14.155829169000071],
              [145.26042728000004, 14.154120184000078],
              [145.24984785200002, 14.150051174000055],
              [145.24284915500004, 14.140366929000038],
              [145.2368270190001, 14.129095770000049],
              [145.2290145190001, 14.119940497000073],
              [145.2099715500001, 14.110663153000075],
              [145.19947350400003, 14.11391836100006],
              [145.18962649800005, 14.121771552000041],
              [145.17164147200003, 14.126166083000044],
              [145.14226321700005, 14.122707424000055],
              [145.12623131600003, 14.123236395000049],
              [145.11931399800005, 14.129584052000041],
              [145.13070722700002, 14.146918036000045],
              [145.1572371750001, 14.163763739000046],
              [145.18637129, 14.17641836100006],
              [145.20573978000004, 14.181382554000038],
            ],
          ],
          [
            [
              [145.64730879, 15.072088934000078],
              [145.65259850400003, 15.059271552000041],
              [145.65121504, 15.046576239000046],
              [145.64795983200008, 15.032945054000038],
              [145.64730879, 15.01748281500005],
              [145.6513778000001, 15.008734442000048],
              [145.6650496750001, 14.992987372000073],
              [145.66781660200002, 14.98273346600007],
              [145.66138756600003, 14.956976630000042],
              [145.64576256600003, 14.929754950000074],
              [145.625824415, 14.915269273000092],
              [145.6064559250001, 14.928127346000053],
              [145.60181725400003, 14.941107489000046],
              [145.59791100400003, 14.96865469000005],
              [145.592133009, 14.98273346600007],
              [145.57984459700003, 14.998602606000077],
              [145.5771590500001, 15.00584544500009],
              [145.578461134, 15.01748281500005],
              [145.59009850400003, 15.040432033000059],
              [145.61109459700003, 15.066799221000053],
              [145.63306725400003, 15.082098700000074],
              [145.64730879, 15.072088934000078],
            ],
          ],
          [
            [
              [145.78785241000003, 15.267279364000046],
              [145.801117384, 15.272162177000041],
              [145.81657962300005, 15.27016836100006],
              [145.82374108200008, 15.262396552000041],
              [145.811859571, 15.25023021000004],
              [145.80046634200005, 15.24323151200008],
              [145.79273522200003, 15.232245184000078],
              [145.7758895190001, 15.189520575000074],
              [145.77654056100005, 15.180853583000044],
              [145.784515821, 15.16828034100007],
              [145.7797957690001, 15.15916575700004],
              [145.77361087300005, 15.15460846600007],
              [145.7661238940001, 15.15501536700009],
              [145.757172071, 15.160834052000041],
              [145.74496504, 15.14984772300005],
              [145.7387801440001, 15.136664130000042],
              [145.73943118600005, 15.122707424000055],
              [145.746918165, 15.109320380000042],
              [145.75261478000004, 15.09601471600007],
              [145.73853600400003, 15.09642161700009],
              [145.721039259, 15.102362372000073],
              [145.71631920700008, 15.105617580000057],
              [145.69410241000003, 15.100490627000056],
              [145.6855574880001, 15.102484442000048],
              [145.6821395190001, 15.116522528000075],
              [145.68384850400003, 15.131293036000045],
              [145.6958113940001, 15.16828034100007],
              [145.69695071700005, 15.182562567000048],
              [145.69646243600005, 15.19367096600007],
              [145.6982528000001, 15.203192450000074],
              [145.70582116000003, 15.21234772300005],
              [145.71111087300005, 15.215521552000041],
              [145.72999108200008, 15.22288646000004],
              [145.7334090500001, 15.227687893000052],
              [145.73406009200005, 15.23924388200004],
              [145.73609459700003, 15.243394273000092],
              [145.748383009, 15.249335028000075],
              [145.7744246750001, 15.257391669000071],
              [145.78785241000003, 15.267279364000046],
            ],
          ],
          [
            [
              [145.7094832690001, 16.36749909100007],
              [145.71762129, 16.35260651200008],
              [145.71119225400003, 16.344956773000092],
              [145.69703209700003, 16.34178294500009],
              [145.66911868600005, 16.339178778000075],
              [145.65601647200003, 16.340277411000045],
              [145.64380944100003, 16.344631252000056],
              [145.6337996750001, 16.353216864000046],
              [145.62818444100003, 16.364081122000073],
              [145.6294051440001, 16.37368398600006],
              [145.6377059250001, 16.37995026200008],
              [145.65414472700002, 16.38117096600007],
              [145.66716556100005, 16.377427476000037],
              [145.69792728000004, 16.37372467700004],
              [145.7094832690001, 16.36749909100007],
            ],
          ],
          [
            [
              [145.77111816800004, 18.175209014000075],
              [145.81169681100005, 18.173895575000074],
              [145.82496178500003, 18.167710679000038],
              [145.83521569100003, 18.157945054000038],
              [145.83912194100003, 18.145086981000077],
              [145.83562259200005, 18.12832265800006],
              [145.82642662900003, 18.11933014500005],
              [145.81430097700002, 18.113023179000038],
              [145.80201256600003, 18.10419342700004],
              [145.758148634, 18.06118398600006],
              [145.74366295700008, 18.053290106000077],
              [145.71949303500003, 18.05418528900009],
              [145.71306743700006, 18.077465158000052],
              [145.73951256600003, 18.090969143000052],
              [145.75076626300006, 18.113725642000077],
              [145.75669677200005, 18.161750803000075],
              [145.77111816800004, 18.175209014000075],
            ],
          ],
          [
            [
              [145.66163170700008, 18.724269924000055],
              [145.63551721600004, 18.747217909000085],
              [145.6325550360001, 18.786913627000047],
              [145.650371791, 18.808902361000037],
              [145.688324415, 18.80735911700009],
              [145.70191491000003, 18.79165273600006],
              [145.7080184250001, 18.779689846000053],
              [145.70964603000004, 18.766831773000035],
              [145.7094832690001, 18.748439846000053],
              [145.7050887380001, 18.737127997000073],
              [145.69361412900003, 18.727728583000044],
              [145.6782332690001, 18.722601630000042],
              [145.66163170700008, 18.724269924000055],
            ],
          ],
          [
            [
              [145.78923587300005, 16.675482489000046],
              [145.76905358200008, 16.69476959800005],
              [145.78589928500003, 16.700100002000056],
              [145.80453535200002, 16.693060614000046],
              [145.78923587300005, 16.675482489000046],
            ],
          ],
          [
            [
              [145.85499108200008, 17.28579336100006],
              [145.8359481130001, 17.305161851000037],
              [145.85124759200005, 17.309393622000073],
              [145.8681746750001, 17.30174388200004],
              [145.85499108200008, 17.28579336100006],
            ],
          ],
          [
            [
              [145.85425866000003, 17.566880601000037],
              [145.83220462300005, 17.577460028000075],
              [145.82691491000003, 17.59320709800005],
              [145.83423912900003, 17.60578034100007],
              [145.8505965500001, 17.60687897300005],
              [145.86296634200005, 17.598537502000056],
              [145.86890709700003, 17.586737372000073],
              [145.86695397200003, 17.575018622000073],
              [145.85425866000003, 17.566880601000037],
            ],
          ],
          [
            [
              [145.405609571, 19.652777411000045],
              [145.39177493600005, 19.660549221000053],
              [145.38209069100003, 19.672796942000048],
              [145.38209069100003, 19.684149481000077],
              [145.39722741000003, 19.68891022300005],
              [145.40992272200003, 19.684475002000056],
              [145.415375196, 19.674383856000077],
              [145.41374759200005, 19.66242096600007],
              [145.405609571, 19.652777411000045],
            ],
          ],
          [
            [
              [145.25074303500003, 20.009711005000042],
              [145.24000084700003, 20.01325104400007],
              [145.23113040500004, 20.02020905200004],
              [145.22673587300005, 20.029771226000037],
              [145.22925866000003, 20.040961005000042],
              [145.2387801440001, 20.050441799000055],
              [145.24341881600003, 20.04555898600006],
              [145.24537194100003, 20.03579336100006],
              [145.24586022200003, 20.030422268000052],
              [145.2524520190001, 20.03143952000005],
              [145.26148522200003, 20.03461334800005],
              [145.26937910200002, 20.03620026200008],
              [145.272797071, 20.032375393000052],
              [145.27076256600003, 20.02415599200009],
              [145.26579837300005, 20.01756419500009],
              [145.258636915, 20.012640692000048],
              [145.25074303500003, 20.009711005000042],
            ],
          ],
          [
            [
              [144.91570071700005, 20.51715729400007],
              [144.90512129, 20.526597398000035],
              [144.90211022200003, 20.54002513200004],
              [144.9067488940001, 20.55149974200009],
              [144.91968834700003, 20.55540599200009],
              [144.93181399800005, 20.549221096000053],
              [144.93246504, 20.537502346000053],
              [144.9257918630001, 20.525336005000042],
              [144.91570071700005, 20.51715729400007],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Coral Sea Is.',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [154.39128665500004, -21.030043226999908],
            [154.38851972700002, -21.02906666499996],
            [154.39128665500004, -21.028741143999923],
            [154.39128665500004, -21.030043226999908],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Ashmore and Cartier Is.',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [123.59701582100013, -12.428317966999884],
            [123.59774824300007, -12.438571872999887],
            [123.57561282600011, -12.43678150799991],
            [123.57504316500001, -12.426608981999891],
            [123.59701582100013, -12.428317966999884],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Antarctica',
        iso3: 'ATA',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-51.730641334999916, -82.06255653699992],
              [-51.24689693949992, -82.01067473749993],
              [-50.76317298099991, -81.9587541649999],
              [-50.73338782499991, -81.95956796699994],
              [-50.557932094999956, -81.99382903399993],
              [-50.122417772199945, -81.97312590899993],
              [-49.686903449399935, -81.95242278399994],
              [-49.25138912659993, -81.93171965899992],
              [-48.81587480379992, -81.91101653399993],
              [-48.38036048099991, -81.89031340899993],
              [-48.229400193999936, -81.9182268209999],
              [-48.22008216099994, -81.91562265399995],
              [-48.20689856699994, -81.8986955709999],
              [-48.198882615999935, -81.8928361959999],
              [-48.18822180899991, -81.89153411299992],
              [-47.88768469999991, -81.92197030999995],
              [-47.43122311099995, -81.91765715899993],
              [-47.38044186099995, -81.92351653399993],
              [-47.34487870999993, -81.95012786299992],
              [-47.350819464999915, -81.9548479149999],
              [-47.36196855399993, -81.96624114399992],
              [-47.36815344999991, -81.97031015399995],
              [-47.263783331999946, -81.96998463299991],
              [-47.42373613199993, -82.00750090899993],
              [-47.58458411399994, -82.02044036299992],
              [-47.56200110599991, -82.03753020599993],
              [-47.52757727799991, -82.04762135199991],
              [-47.49058997299994, -82.05234140399995],
              [-47.46031653599994, -82.05282968499995],
              [-47.39631100199995, -82.04501718499995],
              [-47.36310787699995, -82.0446916649999],
              [-47.29552161399994, -82.06951262799993],
              [-47.255523240999935, -82.07219817499993],
              [-47.21519934799994, -82.06568775799991],
              [-47.17568925699993, -82.05331796699994],
              [-47.08702551999994, -82.0036760399999],
              [-47.05504309799994, -81.99325937299994],
              [-46.667123989999936, -81.95151132599995],
              [-46.27920488199993, -81.90976327899995],
              [-46.22931881399995, -81.91692473799992],
              [-46.25157630099994, -81.94378020599993],
              [-46.25340735599991, -81.9553361959999],
              [-46.24669348899994, -81.97323984199994],
              [-46.23460852799991, -81.98894622199992],
              [-46.21694902299993, -82.00318775799991],
              [-46.196929490999935, -82.01433684699992],
              [-46.136057094999956, -82.03630950299993],
              [-46.053944464999915, -82.08326588299991],
              [-46.012562628999945, -82.09441497199992],
              [-46.02708899599992, -82.10222747199992],
              [-46.03819739499994, -82.11272551899992],
              [-46.04474850199995, -82.12615325299993],
              [-46.04556230399993, -82.14251067499993],
              [-45.97301184799994, -82.12542083099993],
              [-45.94884192599994, -82.12574635199991],
              [-46.02721106699994, -82.15447356599992],
              [-46.04942786399994, -82.17099374799994],
              [-46.064442511999914, -82.19182708099993],
              [-46.074777798999946, -82.21005624799994],
              [-46.088775193999936, -82.2243791649999],
              [-46.300770636999914, -82.30592213299991],
              [-46.688791469999956, -82.40545012799993],
              [-46.632801886999914, -82.43084075299993],
              [-46.45299231699994, -82.47079843499995],
              [-46.46353105399993, -82.48739999799994],
              [-46.47948157499991, -82.49618905999995],
              [-46.51829993399991, -82.50335051899992],
              [-46.053618943999936, -82.55486419099992],
              [-46.025054490999935, -82.55217864399992],
              [-46.042225714999915, -82.5407854149999],
              [-45.94688880099994, -82.49212004999993],
              [-45.83250891799992, -82.45175546699994],
              [-45.71939042899993, -82.4436174459999],
              [-45.579335089999915, -82.52214934699992],
              [-45.520415818999936, -82.52662525799991],
              [-45.02881832549994, -82.45346445099992],
              [-44.537220831999946, -82.38030364399992],
              [-44.305246548999946, -82.31552499799994],
              [-44.19859778599994, -82.25546640399995],
              [-44.13707434799994, -82.24472421699994],
              [-44.073475714999915, -82.24846770599993],
              [-44.01353919199994, -82.26295338299991],
              [-44.01915442599994, -82.27548593499995],
              [-44.02651933499993, -82.28484465899993],
              [-44.03587805899991, -82.29265715899993],
              [-44.046986456999946, -82.29949309699992],
              [-44.054676886999914, -82.30950286299992],
              [-44.05386308499993, -82.33733489399992],
              [-44.05699622299994, -82.34978606599992],
              [-44.07437089799993, -82.36337655999995],
              [-44.10142981699994, -82.37460702899995],
              [-44.15298417899993, -82.38933684699992],
              [-44.08495032499991, -82.40243905999995],
              [-44.01109778599994, -82.39120859199994],
              [-43.682138638499936, -82.30030689899993],
              [-43.353179490999935, -82.20940520599993],
              [-43.34642493399991, -82.19931405999995],
              [-43.34422766799992, -82.17962004999993],
              [-43.33336341099994, -82.16985442499993],
              [-43.264230923999946, -82.14226653399993],
              [-43.15977942599994, -82.12468840899993],
              [-43.147775844999956, -82.11419036299992],
              [-43.15538489499994, -82.09677499799994],
              [-43.170765753999945, -82.07968515399995],
              [-43.181752081999946, -82.07024504999993],
              [-43.19859778599994, -82.06210702899995],
              [-43.255848761999914, -82.04753997199992],
              [-43.23452714799993, -82.02971770599993],
              [-43.19237219999991, -82.00920989399992],
              [-43.16901607999995, -81.99285247199992],
              [-43.21515865799995, -81.96445077899995],
              [-43.223500128999945, -81.95663827899995],
              [-43.22256425699993, -81.9411760399999],
              [-43.21349036399994, -81.92522551899992],
              [-43.190297003999945, -81.89967213299991],
              [-43.16563880099994, -81.88600025799991],
              [-43.13194739499994, -81.87851327899995],
              [-42.99632727799991, -81.86736419099992],
              [-42.95970618399991, -81.86044687299994],
              [-42.906361456999946, -81.83017343499995],
              [-42.79979407499991, -81.8186174459999],
              [-42.51748613199993, -81.75497812299992],
              [-42.23517818899995, -81.69133879999993],
              [-42.27887936099995, -81.67791106599992],
              [-42.22305253799993, -81.64316171699994],
              [-42.20653235599991, -81.63640715899993],
              [-41.98619544199994, -81.61956145599993],
              [-41.941395636999914, -81.61142343499995],
              [-41.89989173099991, -81.58359140399995],
              [-41.92520097599993, -81.56145598799992],
              [-41.93932044199994, -81.55380624799994],
              [-41.95612545499995, -81.55087655999995],
              [-41.92223059799994, -81.53476327899995],
              [-41.876210089999915, -81.49285247199992],
              [-41.84679114499994, -81.47714609199994],
              [-41.841135219999956, -81.47144947699991],
              [-41.84129798099991, -81.4631486959999],
              [-41.84251868399991, -81.45468515399995],
              [-41.84007727799991, -81.44850025799991],
              [-41.831695115999935, -81.44475676899992],
              [-41.82188880099994, -81.44296640399995],
              [-41.783192511999914, -81.44158294099992],
              [-41.77383378799993, -81.4397111959999],
              [-41.76891028599994, -81.43434010199991],
              [-41.766468878999945, -81.41806405999995],
              [-41.76382402299993, -81.4104143209999],
              [-41.75845292899993, -81.40691497199992],
              [-41.724598761999914, -81.39959075299993],
              [-41.587880011999914, -81.3401018209999],
              [-41.11949622299994, -81.22616952899995],
              [-41.10496985599991, -81.22039153399993],
              [-41.06297766799992, -81.18792083099993],
              [-41.04670162699995, -81.1814104149999],
              [-40.87950598899994, -81.1579729149999],
              [-40.912993943999936, -81.16936614399992],
              [-40.94798743399991, -81.17538827899995],
              [-40.91563880099994, -81.18987395599993],
              [-40.56932532499991, -81.15488046699994],
              [-40.39801998599995, -81.16985442499993],
              [-40.141265428499935, -81.12070077899992],
              [-39.88451087099992, -81.07154713299991],
              [-39.84919186099995, -81.04802825299993],
              [-39.83849036399994, -81.04355234199994],
              [-39.69908606699994, -81.02141692499993],
              [-39.646555141999954, -81.02263762799993],
              [-39.619984503999945, -81.02044036299992],
              [-39.54918372299994, -80.9963518209999],
              [-39.24095618399994, -80.95151132599992],
              [-38.93272864499994, -80.90667083099993],
              [-38.82241777299993, -80.90536874799994],
              [-38.77228756399995, -80.89226653399993],
              [-38.82005774599992, -80.88616301899992],
              [-38.813384568999936, -80.87249114399992],
              [-38.803578253999945, -80.86321379999993],
              [-38.791127081999946, -80.85955169099992],
              [-38.77676347599993, -80.8630510399999],
              [-38.75536048099991, -80.87102629999993],
              [-38.54662024599992, -80.91350676899992],
              [-38.392241990999935, -80.91204192499993],
              [-38.00751705599993, -80.95403411249993],
              [-37.62279212099992, -80.99602629999993],
              [-37.63780676999994, -81.00514088299991],
              [-37.65367591099994, -81.00994231599992],
              [-37.68789628799993, -81.0134416649999],
              [-37.47105872299994, -81.03134530999995],
              [-37.37218176999994, -81.06991952899995],
              [-37.33690344999991, -81.07805754999993],
              [-37.23029537699995, -81.08928801899992],
              [-37.21202551999994, -81.0881486959999],
              [-37.19399980399993, -81.08416106599992],
              [-37.13980058499993, -81.05950286299992],
              [-37.12376868399991, -81.05624765399995],
              [-36.978505011999914, -81.05242278399993],
              [-36.908192511999914, -81.03142669099992],
              [-36.86123613199993, -80.98626067499993],
              [-36.816965298999946, -80.97503020599993],
              [-36.590728318999936, -81.00497812299994],
              [-36.59508216099994, -80.97258879999993],
              [-36.55410722599993, -80.95134856599992],
              [-36.457875128999945, -80.93466562299994],
              [-36.033192511999914, -80.92066822699991],
              [-36.014515753999945, -80.91130950299993],
              [-35.99754798099991, -80.89202239399992],
              [-35.982411261999914, -80.8845354149999],
              [-35.88243567599994, -80.86785247199992],
              [-35.82774817599994, -80.83977629999993],
              [-35.79259192599994, -80.83098723799992],
              [-35.78258216099994, -80.82659270599993],
              [-35.780588344999956, -80.80803801899992],
              [-35.77806555899991, -80.80152760199991],
              [-35.77326412699995, -80.80046965899993],
              [-35.76707923099991, -80.8010393209999],
              [-35.75999915299991, -80.79957447699991],
              [-35.72166907499991, -80.78606536299992],
              [-35.46831214099993, -80.74073658649993],
              [-35.214955206999946, -80.69540780999995],
              [-35.466786261999914, -80.64812590899993],
              [-35.35838782499991, -80.61532968499995],
              [-34.88783728774992, -80.61535003024994],
              [-34.417286750499926, -80.61537037549994],
              [-33.946736213249935, -80.61539072074993],
              [-33.47618567599994, -80.61541106599992],
              [-33.17756100199995, -80.55462004999993],
              [-33.42552649599992, -80.52361419099992],
              [-33.46475175699993, -80.49765390399995],
              [-33.41307532499991, -80.49765390399995],
              [-33.125111456999946, -80.53199635199991],
              [-33.06973222599993, -80.53045012799993],
              [-32.93150794199994, -80.54159921699994],
              [-32.48100745349993, -80.48841725049994],
              [-32.030506964999915, -80.43523528399993],
              [-31.649342414249915, -80.44597747149993],
              [-31.268177863499915, -80.45671965899993],
              [-30.887013312749914, -80.46746184649993],
              [-30.505848761999914, -80.47820403399993],
              [-30.387847459999932, -80.4983049459999],
              [-30.350209113999938, -80.49993254999993],
              [-30.387115037999934, -80.4690080709999],
              [-30.456857876999948, -80.45818450299993],
              [-30.58690344999991, -80.45842864399992],
              [-30.95319576749992, -80.38364023249991],
              [-31.319488084999932, -80.3088518209999],
              [-31.27887936099995, -80.2971330709999],
              [-30.827314148333283, -80.29287417333325],
              [-30.37574893566661, -80.28861527566659],
              [-29.924183722999942, -80.28435637799993],
              [-29.91551673099991, -80.28142669099992],
              [-29.895741339999915, -80.26913827899995],
              [-29.884755011999914, -80.26490650799991],
              [-29.872670050999943, -80.2634416649999],
              [-29.72093665299991, -80.2619768209999],
              [-29.790638800999943, -80.23349374799994],
              [-29.863840298999946, -80.21542734199994],
              [-29.816070115999935, -80.18743254999993],
              [-29.76081295499995, -80.1755510399999],
              [-29.271107551285663, -80.16790130042848],
              [-28.781402147571377, -80.16025156085705],
              [-28.29169674385709, -80.15260182128563],
              [-27.801991340142802, -80.1449520817142],
              [-27.312285936428516, -80.13730234214277],
              [-26.82258053271423, -80.12965260257134],
              [-26.332875128999945, -80.12200286299992],
              [-26.30577551999994, -80.11858489399992],
              [-26.228260870999918, -80.09636809699992],
              [-26.195139126999948, -80.09148528399993],
              [-25.70988928974994, -80.08759937924992],
              [-25.22463945249993, -80.08371347449992],
              [-24.73938961524992, -80.07982756974991],
              [-24.25413977799991, -80.0759416649999],
              [-24.20921790299991, -80.06975676899992],
              [-24.106190558999913, -80.01970794099992],
              [-24.06859290299991, -80.00994231599992],
              [-23.680938280666584, -80.00090911266659],
              [-23.293283658333262, -79.99187590933326],
              [-22.905629035999937, -79.98284270599993],
              [-22.82408606699994, -79.96347421699994],
              [-22.828846808999913, -79.95916106599992],
              [-22.83690344999991, -79.94866301899992],
              [-22.841542120999918, -79.94426848799992],
              [-22.766835089999915, -79.92620208099993],
              [-22.60924231699994, -79.92913176899992],
              [-22.532460089999915, -79.91708749799994],
              [-22.93455969933325, -79.88806189033328],
              [-23.336659308666583, -79.8590362826666],
              [-23.738758917999917, -79.83001067499993],
              [-23.765980597999942, -79.82089609199994],
              [-23.79133053299995, -79.81560637799993],
              [-23.82095292899993, -79.81715260199991],
              [-23.877837693999936, -79.82708098799992],
              [-23.930816209999932, -79.8303361959999],
              [-24.08975175699993, -79.81959400799991],
              [-24.20148678299995, -79.8264299459999],
              [-24.26203365799995, -79.82236093499995],
              [-24.303130662999934, -79.80380624799994],
              [-24.28311113199993, -79.79013437299994],
              [-24.274322068999936, -79.78183359199994],
              [-24.271148240999935, -79.77255624799994],
              [-24.272328253999945, -79.75603606599992],
              [-24.27171790299991, -79.74146900799991],
              [-24.26707923099991, -79.72820403399993],
              [-24.256214972999942, -79.7151018209999],
              [-24.729847785999937, -79.78199635199991],
              [-25.225131124749936, -79.76583559899991],
              [-25.720414463499935, -79.7496748459999],
              [-26.215697802249935, -79.73351409299991],
              [-26.710981140999934, -79.71735333999992],
              [-27.206264479749933, -79.70119258699991],
              [-27.701547818499932, -79.68503183399991],
              [-28.19683115724993, -79.66887108099992],
              [-28.69211449599993, -79.65271032799991],
              [-29.18739783474993, -79.63654957499992],
              [-29.68268117349993, -79.62038882199992],
              [-30.17796451224993, -79.60422806899992],
              [-30.67324785099993, -79.58806731599992],
              [-30.652088995999918, -79.56316497199992],
              [-30.28184973833326, -79.46879105699992],
              [-29.9116104806666, -79.37441714199991],
              [-29.541371222999942, -79.28004322699991],
              [-29.585316535999937, -79.26767343499995],
              [-29.63036048099991, -79.26816171699994],
              [-29.78892981699994, -79.31308359199994],
              [-29.82917232999995, -79.31943124799994],
              [-29.849232550999943, -79.30730559699992],
              [-29.84829667899993, -79.29851653399993],
              [-29.833811001999948, -79.27605559699992],
              [-30.059803839999915, -79.26279062299994],
              [-30.524728969999956, -79.28639088299991],
              [-30.541493292999917, -79.27507903399993],
              [-30.55622311099995, -79.24822356599992],
              [-30.44945227799991, -79.21721770599993],
              [-30.008656378999945, -79.14446379999993],
              [-29.941761847999942, -79.11142343499995],
              [-29.98965410099993, -79.09148528399993],
              [-30.19562740799995, -79.10442473799992],
              [-30.18301347599993, -79.09392669099992],
              [-30.16934160099993, -79.08513762799993],
              [-30.154652472999942, -79.0783830709999],
              [-30.13898678299995, -79.0739885399999],
              [-30.18382727799991, -79.04420338299991],
              [-30.239165818999936, -79.03427499799994],
              [-30.29751542899993, -79.03728606599992],
              [-30.457834438999953, -79.06536223799992],
              [-30.468088344999956, -79.07000090899993],
              [-30.484852667999917, -79.08587004999993],
              [-30.494862433999913, -79.0915666649999],
              [-30.51073157499991, -79.09612395599993],
              [-30.573597785999937, -79.10588958099993],
              [-30.582875128999945, -79.10507577899995],
              [-30.588449673999946, -79.09905364399992],
              [-30.59170488199993, -79.08521900799991],
              [-30.598133917999917, -79.07781340899993],
              [-30.61119544199994, -79.07496510199991],
              [-31.05299231699994, -79.1087541645999],
              [-31.49478919199994, -79.14254322719991],
              [-31.93658606699994, -79.1763322897999],
              [-32.37838294199994, -79.21012135239991],
              [-32.82017981699994, -79.2439104149999],
              [-33.286162889999936, -79.20864565799991],
              [-33.75214596299994, -79.17338090099992],
              [-34.21812903599994, -79.13811614399992],
              [-34.186105923999946, -79.12420012799993],
              [-34.16942298099991, -79.12004973799992],
              [-34.15184485599991, -79.11760833099993],
              [-34.20075436099995, -79.09107838299991],
              [-34.25845292899993, -79.07659270599993],
              [-34.65702877539993, -79.03160572679994],
              [-35.05560462179993, -78.98661874759993],
              [-35.45418046819994, -78.94163176839994],
              [-35.85275631459994, -78.89664478919994],
              [-36.25133216099994, -78.85165780999995],
              [-36.344634568999936, -78.81519947699991],
              [-36.41128495999993, -78.75351327899995],
              [-36.41966712099992, -78.73154062299994],
              [-36.42528235599991, -78.68417734199994],
              [-36.44375566299993, -78.63404713299991],
              [-36.44115149599992, -78.61126067499993],
              [-36.42711341099994, -78.59099700299993],
              [-36.40404212099992, -78.57089609199994],
              [-36.39940344999991, -78.5642229149999],
              [-36.39561926999994, -78.54762135199991],
              [-36.391835089999915, -78.54021575299993],
              [-36.32469641799992, -78.45712655999995],
              [-36.30724036399994, -78.43962981599992],
              [-36.283314581999946, -78.42392343499995],
              [-36.277455206999946, -78.41814544099992],
              [-36.26699785099993, -78.40007903399993],
              [-36.26016191299993, -78.3923479149999],
              [-36.057850714999915, -78.26506926899992],
              [-36.03844153599994, -78.24651458099993],
              [-36.03270423099991, -78.2365861959999],
              [-36.02769934799994, -78.22551848799992],
              [-36.02179928299995, -78.21591562299994],
              [-36.01309160099993, -78.21054452899995],
              [-35.92747962099992, -78.18572356599992],
              [-35.85020911399994, -78.18466562299994],
              [-35.83885657499991, -78.18238697699991],
              [-35.83250891799992, -78.17669036299992],
              [-35.82384192599994, -78.15569426899992],
              [-35.817250128999945, -78.15203215899993],
              [-35.80601966099994, -78.15276458099993],
              [-35.783314581999946, -78.15764739399992],
              [-35.63239498599995, -78.16139088299991],
              [-35.606027798999946, -78.15862395599993],
              [-35.580962693999936, -78.15048593499995],
              [-35.59557044199994, -78.13974374799994],
              [-35.61095130099994, -78.12127044099992],
              [-35.62149003799993, -78.10027434699992],
              [-35.621205206999946, -78.08171965899993],
              [-35.60732988199993, -78.07284921699994],
              [-35.582875128999945, -78.06731536299992],
              [-35.50080318899995, -78.05852629999993],
              [-35.49054928299995, -78.05071379999993],
              [-35.47565670499995, -77.98691171699994],
              [-35.466460740999935, -77.96795012799993],
              [-35.416086391999954, -77.92457447699991],
              [-35.38752193899995, -77.89137135199991],
              [-35.35619055899991, -77.86199309699992],
              [-35.31285559799994, -77.84441497199992],
              [-35.05646725199995, -77.82341887799993],
              [-34.66429602799991, -77.85361093499995],
              [-34.59788977799991, -77.8459611959999],
              [-34.50845292899993, -77.85312265399995],
              [-34.499663865999935, -77.85198333099993],
              [-34.489491339999915, -77.84587981599992],
              [-34.47166907499991, -77.82781340899993],
              [-34.459095831999946, -77.82195403399993],
              [-34.65029863199993, -77.79387786299992],
              [-34.64533443899995, -77.76376718499995],
              [-34.679798956999946, -77.7517229149999],
              [-34.75926673099991, -77.74773528399993],
              [-34.74120032499991, -77.73105234199994],
              [-34.73888098899994, -77.71217213299991],
              [-34.75039628799993, -77.69605885199991],
              [-34.77391516799992, -77.68743254999993],
              [-34.711496548999946, -77.62948984199994],
              [-34.68830318899995, -77.61858489399992],
              [-34.60142981699994, -77.60637786299992],
              [-34.57266191299993, -77.59889088299991],
              [-34.521555141999954, -77.57561614399992],
              [-34.47423255099994, -77.54599374799994],
              [-34.434803839999915, -77.52939218499995],
              [-34.42625891799992, -77.52361419099992],
              [-34.41344153599994, -77.50896575299993],
              [-34.40135657499991, -77.49879322699991],
              [-34.36994381399995, -77.48259856599992],
              [-34.32054602799991, -77.46640390399995],
              [-34.13540605399993, -77.44255950299993],
              [-34.085601365999935, -77.4299455709999],
              [-33.975453253999945, -77.41887786299992],
              [-33.86359615799995, -77.38811614399992],
              [-33.839507615999935, -77.37818775799991],
              [-33.72109941299993, -77.31096770599993],
              [-33.69676673099991, -77.30584075299993],
              [-33.64513098899994, -77.30527109199994],
              [-33.621937628999945, -77.29892343499995],
              [-33.59357662699995, -77.28785572699991],
              [-33.563710089999915, -77.28248463299991],
              [-33.53343665299991, -77.28232187299994],
              [-33.504017706999946, -77.28679778399993],
              [-33.48228919199994, -77.2868791649999],
              [-33.40705318899995, -77.26702239399992],
              [-33.34634355399993, -77.25945403399993],
              [-33.173817511999914, -77.26132577899995],
              [-33.120432094999956, -77.25310637799993],
              [-32.95457923099991, -77.18889739399992],
              [-32.50064042899993, -77.12615325299993],
              [-32.11945553299995, -77.17066822699991],
              [-31.91502844999991, -77.15081145599993],
              [-31.894276495999918, -77.14324309699992],
              [-31.88182532499991, -77.12753671699994],
              [-31.86864173099991, -77.06764088299991],
              [-31.85142981699994, -77.05095794099992],
              [-31.74909420499995, -76.9943986959999],
              [-31.696115688999953, -76.97665780999995],
              [-31.361453145666605, -76.9343672286666],
              [-31.02679060233326, -76.89207664733327],
              [-30.692128058999913, -76.84978606599992],
              [-30.661366339999915, -76.85165780999995],
              [-30.65070553299995, -76.84734465899993],
              [-30.642567511999914, -76.83473072699991],
              [-30.635161912999934, -76.82040780999995],
              [-30.62686113199993, -76.80999114399992],
              [-30.614003058999913, -76.80437590899993],
              [-30.567697719999956, -76.79558684699992],
              [-30.539173956999946, -76.7854143209999],
              [-30.456288214999915, -76.74553801899992],
              [-30.405100063999953, -76.7360979149999],
              [-30.395863410999937, -76.72991301899992],
              [-30.384917772999927, -76.7068010399999],
              [-30.37608801999994, -76.6994768209999],
              [-30.22647050699993, -76.66708749799994],
              [-30.153472459999932, -76.63534921699994],
              [-29.65807044199994, -76.57691822699991],
              [-29.626576300999943, -76.56943124799994],
              [-29.557932094999956, -76.5432268209999],
              [-29.561390753999945, -76.53818124799994],
              [-29.566761847999942, -76.52605559699992],
              [-29.570423956999946, -76.52092864399992],
              [-29.556996222999942, -76.51523202899995],
              [-29.53697669199994, -76.49732838299991],
              [-29.52676347599993, -76.49138762799993],
              [-29.513783331999946, -76.48984140399995],
              [-29.48534094999991, -76.49163176899992],
              [-29.471547003999945, -76.49016692499993],
              [-29.411040818999936, -76.47470468499995],
              [-29.385243292999917, -76.46347421699994],
              [-29.358265753999945, -76.44378020599993],
              [-29.339507615999935, -76.43954843499995],
              [-29.15733801999994, -76.42538827899995],
              [-28.859120245999918, -76.3532854149999],
              [-28.5126304456666, -76.31134748099991],
              [-28.166140645333275, -76.26940954699991],
              [-27.819650844999956, -76.22747161299992],
              [-27.597645636999914, -76.22747161299992],
              [-27.337635870999918, -76.17205169099992],
              [-27.22020423099991, -76.16122812299994],
              [-26.985178188999953, -76.1696916649999],
              [-26.889800584999932, -76.14885833099993],
              [-26.859730597999942, -76.13583749799994],
              [-26.854115363999938, -76.13250090899993],
              [-26.851673956999946, -76.12769947699991],
              [-26.849964972999942, -76.11296965899993],
              [-26.847401495999918, -76.10816822699991],
              [-26.822865363999938, -76.09734465899993],
              [-26.79405676999994, -76.0920549459999],
              [-26.62653561099995, -76.09514739399992],
              [-26.595326300999943, -76.0896135399999],
              [-26.507435675999943, -76.0549455709999],
              [-26.40461178299995, -76.04094817499993],
              [-26.37368730399993, -76.03232187299994],
              [-26.287709113999938, -75.99667734199994],
              [-26.23155676999994, -75.98503997199992],
              [-26.117176886999914, -75.97389088299991],
              [-25.948150193999936, -75.93303801899992],
              [-25.542510545749934, -75.89474863099993],
              [-25.136870897499932, -75.85645924299993],
              [-24.73123124924993, -75.81816985499994],
              [-24.32559160099993, -75.77988046699994],
              [-24.213734503999945, -75.75644296699994],
              [-23.741546190499946, -75.74720631299994],
              [-23.269357876999948, -75.73796965899993],
              [-23.244699673999946, -75.72991301899992],
              [-23.215199347999942, -75.71599700299993],
              [-23.18846594999991, -75.71209075299993],
              [-23.16120357999995, -75.71160247199992],
              [-23.105091925999943, -75.70468515399995],
              [-22.84707597599993, -75.70761484199994],
              [-22.72960364499994, -75.69003671699994],
              [-22.650746222999942, -75.69068775799991],
              [-22.622425910999937, -75.68482838299991],
              [-22.59601803299995, -75.67473723799992],
              [-22.560943162999934, -75.64381275799991],
              [-22.533355272999927, -75.64202239399992],
              [-22.378529425999943, -75.67815520599993],
              [-22.365630662999934, -75.67620208099993],
              [-22.351958787999934, -75.66855234199994],
              [-22.32762610599991, -75.64999765399995],
              [-22.31554114499994, -75.64519622199992],
              [-22.30186926999994, -75.64462655999995],
              [-22.073963995999918, -75.70582447699991],
              [-22.06932532499991, -75.68499114399992],
              [-22.050892706999946, -75.68157317499993],
              [-21.86278235599991, -75.70956796699994],
              [-21.81163489499994, -75.70867278399993],
              [-21.761830206999946, -75.69996510199991],
              [-21.680531378999945, -75.67115650799991],
              [-21.269642706999946, -75.71428801899992],
              [-21.173939581999946, -75.70501067499993],
              [-21.080148891999954, -75.68035247199992],
              [-20.993763800999943, -75.6447893209999],
              [-20.94749915299991, -75.63298919099992],
              [-20.85968990799995, -75.63665129999993],
              [-20.81672115799995, -75.62607187299994],
              [-20.77525794199994, -75.60751718499995],
              [-20.755848761999914, -75.6052385399999],
              [-20.731190558999913, -75.60898202899995],
              [-20.68700110599991, -75.62078215899993],
              [-20.665272589999915, -75.62127044099992],
              [-20.644154425999943, -75.61207447699991],
              [-20.72166907499991, -75.57822030999995],
              [-20.73582923099991, -75.56357187299994],
              [-20.730295376999948, -75.54159921699994],
              [-20.705474412999934, -75.52841562299994],
              [-20.49445553299995, -75.49667734199994],
              [-20.44562740799995, -75.48137786299992],
              [-20.39948482999995, -75.47210051899992],
              [-20.08356686099995, -75.51079680799992],
              [-19.767648891999954, -75.54949309699992],
              [-19.742543097999942, -75.54615650799991],
              [-19.694081183999913, -75.5295549459999],
              [-19.67218990799995, -75.52752044099992],
              [-19.59243730399993, -75.53997161299992],
              [-19.388050910999937, -75.54583098799992],
              [-19.373890753999945, -75.54314544099992],
              [-19.347279425999943, -75.53240325299993],
              [-19.338246222999942, -75.53053150799991],
              [-19.24046790299991, -75.54843515399995],
              [-19.23778235599991, -75.5251604149999],
              [-19.23778235599991, -75.50204843499995],
              [-19.005970831999946, -75.52068450299993],
              [-18.967152472999942, -75.51490650799991],
              [-18.935617641999954, -75.49098072699991],
              [-19.028472459999932, -75.45427825299993],
              [-18.987131313999953, -75.44280364399992],
              [-18.653635219999956, -75.48211028399993],
              [-18.625477667999917, -75.48235442499993],
              [-18.578724738999938, -75.46746184699992],
              [-18.550892706999946, -75.46396249799994],
              [-18.528146938999953, -75.46607838299991],
              [-18.46051998599995, -75.4802385399999],
              [-18.408273891999954, -75.48088958099993],
              [-18.25137285099993, -75.46021900799991],
              [-18.50649980399993, -75.41570403399993],
              [-18.53148352799991, -75.40740325299993],
              [-18.551177537999934, -75.3767229149999],
              [-18.573068813999953, -75.35849374799994],
              [-18.61481686099995, -75.33066171699994],
              [-18.638661261999914, -75.31959400799991],
              [-18.663807745999918, -75.31210702899995],
              [-18.73770097599993, -75.29998137799993],
              [-18.77497311099995, -75.28004322699991],
              [-18.796498175999943, -75.27434661299992],
              [-18.81981360599991, -75.27117278399993],
              [-18.852040167999917, -75.26311614399992],
              [-18.873524542999917, -75.24944426899992],
              [-18.864857550999943, -75.22893645599993],
              [-18.84557044199994, -75.2248674459999],
              [-18.78473873599995, -75.23007577899995],
              [-18.760975714999915, -75.22844817499993],
              [-18.749745245999918, -75.22389088299991],
              [-18.74014238199993, -75.21884530999995],
              [-18.721099412999934, -75.20549895599993],
              [-18.71475175699993, -75.19597747199992],
              [-18.710275844999956, -75.17131926899992],
              [-18.70494544199994, -75.16155364399992],
              [-18.682932094999956, -75.15129973799992],
              [-18.65416419199994, -75.1501604149999],
              [-18.600087042999917, -75.15829843499995],
              [-18.54629472599993, -75.14690520599993],
              [-18.53661048099991, -75.1032854149999],
              [-18.535878058999913, -75.05315520599993],
              [-18.509429490999935, -75.02255624799994],
              [-18.484730597999942, -75.02141692499993],
              [-18.46198482999995, -75.02581145599993],
              [-18.439808722999942, -75.02752044099992],
              [-18.416493292999917, -75.01913827899995],
              [-18.393381313999953, -75.00554778399993],
              [-18.369618292999917, -74.99480559699992],
              [-18.31899980399993, -74.97926197699991],
              [-18.30882727799991, -74.97926197699991],
              [-18.27367102799991, -74.9880510399999],
              [-18.257964647999927, -74.98845794099992],
              [-18.248117641999954, -74.98381926899992],
              [-18.226551886999914, -74.96624114399992],
              [-18.20494544199994, -74.95598723799992],
              [-18.180490688999953, -74.94833749799994],
              [-18.13109290299991, -74.93873463299991],
              [-18.150502081999946, -74.92424895599993],
              [-18.146148240999935, -74.90374114399992],
              [-18.12804114499994, -74.88420989399992],
              [-18.106271938999953, -74.87265390399995],
              [-18.055897589999915, -74.85881926899992],
              [-18.033314581999946, -74.84823984199994],
              [-18.013783331999946, -74.83163827899995],
              [-17.996978318999936, -74.82268645599993],
              [-17.915638800999943, -74.80185312299994],
              [-17.855824347999942, -74.79810963299991],
              [-17.82648678299995, -74.79143645599993],
              [-17.80215410099993, -74.77654387799993],
              [-17.822092251999948, -74.76775481599992],
              [-17.83775794199994, -74.75701262799993],
              [-17.85057532499991, -74.74325937299994],
              [-17.861683722999942, -74.72503020599993],
              [-17.87173417899993, -74.71396249799994],
              [-17.884388800999943, -74.70989348799992],
              [-17.898182745999918, -74.70818450299993],
              [-17.911854620999918, -74.70387135199991],
              [-17.918080206999946, -74.69931405999995],
              [-17.926340298999946, -74.68808359199994],
              [-17.93106035099993, -74.68287525799991],
              [-17.959828253999945, -74.66676197699991],
              [-17.965199347999942, -74.65894947699991],
              [-17.965687628999945, -74.63787200299993],
              [-17.95498613199993, -74.63250090899993],
              [-17.92137610599991, -74.63445403399993],
              [-17.810373501999948, -74.6169572899999],
              [-17.708322719999956, -74.58684661299992],
              [-17.675770636999914, -74.58635833099993],
              [-17.641102667999917, -74.59465911299992],
              [-17.623158331999946, -74.58521900799991],
              [-17.617339647999927, -74.55152760199991],
              [-17.604807094999956, -74.51921965899993],
              [-17.566761847999942, -74.51384856599992],
              [-17.575917120999918, -74.49911874799994],
              [-17.58731035099993, -74.48642343499995],
              [-17.60106360599991, -74.47665780999995],
              [-17.617339647999927, -74.4704729149999],
              [-17.609934048999946, -74.46526458099993],
              [-17.596547003999945, -74.45224374799994],
              [-17.589222785999937, -74.44687265399995],
              [-17.612049933999913, -74.40252044099992],
              [-17.570790167999917, -74.36956145599993],
              [-17.505482550999943, -74.34783294099992],
              [-17.456288214999915, -74.33717213299991],
              [-17.02678382049993, -74.32227955499991],
              [-16.597279425999943, -74.30738697699991],
              [-16.261952277499944, -74.34246184699992],
              [-15.926625128999945, -74.37753671699994],
              [-15.753081834999932, -74.43043385199991],
              [-15.639027472999942, -74.43084075299993],
              [-15.616688605999911, -74.42302825299993],
              [-15.616566535999937, -74.40195077899995],
              [-15.610951300999943, -74.4001604149999],
              [-15.59788977799991, -74.39999765399995],
              [-15.583241339999915, -74.3982072899999],
              [-15.560536261999914, -74.39967213299991],
              [-15.19554602799991, -74.36052825299993],
              [-15.280873175999943, -74.33847421699994],
              [-15.319569464999915, -74.31910572699991],
              [-15.333159959999932, -74.28875090899993],
              [-15.330230272999927, -74.28093840899993],
              [-15.324696417999917, -74.27548593499995],
              [-15.309803839999915, -74.26620859199994],
              [-15.304351365999935, -74.25676848799992],
              [-15.305409308999913, -74.23121510199991],
              [-15.302113410999937, -74.22144947699991],
              [-15.287098761999914, -74.21591562299994],
              [-15.22329667899993, -74.21298593499995],
              [-15.208363410999937, -74.20631275799991],
              [-15.206288214999915, -74.20029062299994],
              [-15.20767167899993, -74.19394296699994],
              [-15.202870245999918, -74.18670012799993],
              [-15.19322669199994, -74.18132903399993],
              [-15.152902798999946, -74.1682268209999],
              [-15.137928839999915, -74.16668059699992],
              [-15.13072669199994, -74.16375090899993],
              [-15.122792120999918, -74.15593840899993],
              [-15.114084438999953, -74.13730234199994],
              [-15.109527147999927, -74.13152434699992],
              [-15.089995897999927, -74.12615325299993],
              [-15.019276495999918, -74.12932708099993],
              [-15.003529425999943, -74.12590911299992],
              [-14.970204230999911, -74.10906340899993],
              [-14.953724738999938, -74.1032854149999],
              [-14.82799231699994, -74.08123137799993],
              [-14.789051886999914, -74.06503671699994],
              [-14.73460852799991, -74.02157968499995],
              [-14.713449673999946, -74.00920989399992],
              [-14.692982550999943, -74.00164153399993],
              [-14.611683722999942, -73.98626067499993],
              [-14.575795050999943, -73.98707447699991],
              [-14.525054490999935, -73.97568124799994],
              [-14.517730272999927, -73.97136809699992],
              [-14.517160610999952, -73.96282317499993],
              [-14.522206183999913, -73.94011809699992],
              [-14.51821855399993, -73.93401458099993],
              [-14.433013475999928, -73.90829843499995],
              [-14.39671790299991, -73.8884416649999],
              [-14.361805792999917, -73.8576799459999],
              [-14.41633053299995, -73.84197356599992],
              [-14.595773891999954, -73.84270598799992],
              [-14.62718665299991, -73.83912525799991],
              [-14.653675910999937, -73.82870859199994],
              [-14.676625128999945, -73.81178150799991],
              [-14.69713294199994, -73.78964609199994],
              [-14.717640753999945, -73.78053150799991],
              [-14.745716925999943, -73.78460051899992],
              [-14.796498175999943, -73.80291106599992],
              [-15.241383429999928, -73.87570566199992],
              [-15.686268683999913, -73.94850025799991],
              [-16.175933397999927, -73.9392229149999],
              [-16.19912675699993, -73.93124765399995],
              [-16.243031378999945, -73.90178801899992],
              [-16.262440558999913, -73.8947893209999],
              [-16.462147589999915, -73.89462655999995],
              [-16.51699785099993, -73.88518645599993],
              [-16.554432745999918, -73.86484140399995],
              [-16.512277798999946, -73.85702890399995],
              [-16.43464107999995, -73.87639739399992],
              [-16.391957160999937, -73.87932708099993],
              [-16.19640051999994, -73.83407968499995],
              [-15.909820115999935, -73.81698984199994],
              [-15.865956183999913, -73.80820077899995],
              [-15.825754360999952, -73.78866952899995],
              [-15.875477667999917, -73.76336028399993],
              [-15.929676886999914, -73.75017669099992],
              [-16.330799933999913, -73.7092424459999],
              [-16.376291469999956, -73.71998463299991],
              [-16.39940344999991, -73.7224260399999],
              [-16.494699673999946, -73.71379973799992],
              [-16.558990037999934, -73.69654713299991],
              [-16.583241339999915, -73.68629322699991],
              [-16.598255988999938, -73.6677385399999],
              [-16.602853969999956, -73.63355885199991],
              [-16.59862219999991, -73.60149504999993],
              [-16.587717251999948, -73.57350025799991],
              [-16.57022050699993, -73.54941171699994],
              [-16.54674231699994, -73.52898528399993],
              [-16.562163865999935, -73.50253671699994],
              [-16.56012936099995, -73.48406340899993],
              [-16.543568488999938, -73.46868254999993],
              [-16.43846594999991, -73.41326262799993],
              [-15.976185675999943, -73.30380624799994],
              [-15.957753058999913, -73.29013437299994],
              [-15.961659308999913, -73.26580169099992],
              [-15.980458136999914, -73.23951588299991],
              [-15.993072068999936, -73.21477629999993],
              [-15.978871222999942, -73.19459400799991],
              [-15.897694464999915, -73.14999765399995],
              [-15.869699673999946, -73.13909270599993],
              [-15.640126105999911, -73.1018205709999],
              [-15.566558397999927, -73.07927825299993],
              [-15.541411912999934, -73.07683684699992],
              [-15.426747199999909, -73.09107838299991],
              [-15.256906704999949, -73.07878997199992],
              [-15.24205481699994, -73.07219817499993],
              [-15.215402798999946, -73.05315520599993],
              [-15.20299231699994, -73.04697030999995],
              [-15.17992102799991, -73.04412200299993],
              [-14.984038865999935, -73.0525041649999],
              [-14.883208787999934, -73.04241301899992],
              [-14.61241614499994, -73.08220794099992],
              [-14.509266730999911, -73.12037525799991],
              [-14.457875128999945, -73.15894947699991],
              [-14.441477016999954, -73.16472747199992],
              [-14.428089972999942, -73.16057708099993],
              [-14.380970831999946, -73.13144296699994],
              [-14.366769985999952, -73.13095468499995],
              [-14.34015865799995, -73.14544036299992],
              [-14.322743292999917, -73.14128997199992],
              [-14.295033331999946, -73.12851327899995],
              [-14.26280676999994, -73.12070077899995],
              [-14.229807094999956, -73.11760833099993],
              [-14.199330206999946, -73.11931731599992],
              [-14.131703253999945, -73.13095468499995],
              [-14.097482876999948, -73.13298919099992],
              [-14.047596808999913, -73.1247697899999],
              [-14.016468878999945, -73.12957122199992],
              [-13.99828040299991, -73.12818775799991],
              [-13.936390753999945, -73.11370208099993],
              [-13.916818813999953, -73.10588958099993],
              [-13.94131425699993, -73.09319426899992],
              [-13.989979620999918, -73.07781340899993],
              [-14.014637824999909, -73.06633879999993],
              [-13.980865037999934, -73.04306405999995],
              [-13.959787563999953, -73.01604583099993],
              [-13.936390753999945, -72.99431731599992],
              [-13.895253058999913, -72.98674895599993],
              [-14.029774542999917, -72.9084611959999],
              [-14.17296301999994, -72.84693775799991],
              [-14.20693925699993, -72.83660247199992],
              [-14.222645636999914, -72.82830169099992],
              [-14.227162238999938, -72.81633879999993],
              [-14.226673956999946, -72.79762135199991],
              [-14.235829230999911, -72.78573984199994],
              [-14.251535610999952, -72.77743905999995],
              [-14.307484503999945, -72.75872161299992],
              [-14.386138475999928, -72.74228280999995],
              [-14.418324347999942, -72.72380950299993],
              [-14.390736456999946, -72.7131486959999],
              [-14.364816860999952, -72.70891692499993],
              [-14.221099412999934, -72.71168385199991],
              [-14.014027472999942, -72.73870208099993],
              [-13.899566209999932, -72.77109140399995],
              [-13.790272589999915, -72.78671640399995],
              [-13.653065558999913, -72.79168059699992],
              [-13.630360480999911, -72.79892343499995],
              [-13.576527472999942, -72.8259416649999],
              [-13.51939856699994, -72.84539153399993],
              [-13.491037563999953, -72.84628671699994],
              [-13.437896287999934, -72.83212655999995],
              [-13.379383917999917, -72.83611419099992],
              [-13.34947669199994, -72.83074309699992],
              [-13.28897050699993, -72.81023528399993],
              [-13.264027472999942, -72.80575937299994],
              [-13.181263800999943, -72.80388762799993],
              [-13.154774542999917, -72.79949309699992],
              [-13.128488735999952, -72.78923919099992],
              [-13.05500240799995, -72.7497697899999],
              [-13.02798417899993, -72.74041106599992],
              [-13.000396287999934, -72.73447030999995],
              [-12.973784959999932, -72.73259856599992],
              [-12.96275794199994, -72.72893645599993],
              [-12.945423956999946, -72.71111419099992],
              [-12.934925910999937, -72.70623137799993],
              [-12.91592363199993, -72.70378997199992],
              [-12.902333136999914, -72.70037200299993],
              [-12.89053300699993, -72.69353606599992],
              [-12.877105272999927, -72.68059661299992],
              [-12.869252081999946, -72.66863372199992],
              [-12.866444464999915, -72.65984465899993],
              [-12.86119544199994, -72.65349700299993],
              [-12.578968878999945, -72.58464934699992],
              [-12.537464972999942, -72.58513762799993],
              [-12.517160610999952, -72.58310312299994],
              [-12.456044074999909, -72.55966562299994],
              [-12.435047980999911, -72.5549455709999],
              [-12.411732550999943, -72.55527109199994],
              [-12.341297980999911, -72.56357187299994],
              [-12.321156378999945, -72.56178150799991],
              [-12.24437415299991, -72.54070403399993],
              [-11.900441047499925, -72.49216073999992],
              [-11.55650794199994, -72.4436174459999],
              [-11.505238410999937, -72.44638437299994],
              [-11.464019334999932, -72.44150155999995],
              [-11.387521938999953, -72.41806405999995],
              [-11.37022864499994, -72.40911223799992],
              [-11.35655676999994, -72.39641692499993],
              [-11.34788977799991, -72.38014088299991],
              [-11.335316535999937, -72.34449635199991],
              [-11.325347459999932, -72.3278947899999],
              [-11.338286912999934, -72.32805754999993],
              [-11.380360480999911, -72.32122161299992],
              [-11.407622850999928, -72.30527109199994],
              [-11.409738735999952, -72.30193450299993],
              [-11.377756313999953, -72.29412200299993],
              [-11.36827551999994, -72.28948333099993],
              [-11.360340949999909, -72.28142669099992],
              [-11.347767706999946, -72.2614885399999],
              [-11.341420050999943, -72.25652434699992],
              [-11.299224412999934, -72.24675872199992],
              [-11.286610480999911, -72.23967864399992],
              [-11.28156490799995, -72.2321916649999],
              [-11.27452551999994, -72.21868254999993],
              [-11.270375128999945, -72.20631275799991],
              [-11.273426886999914, -72.20224374799994],
              [-11.249745245999918, -72.19068775799991],
              [-11.239979620999918, -72.17652760199991],
              [-11.246978318999936, -72.16545989399992],
              [-11.273793097999942, -72.16375090899993],
              [-11.358998175999943, -72.17734140399995],
              [-11.382964647999927, -72.1721330709999],
              [-11.361317511999914, -72.16269296699994],
              [-11.253285285999937, -72.13884856599992],
              [-11.245716925999943, -72.13404713299991],
              [-11.245472785999937, -72.12639739399992],
              [-11.252349412999934, -72.1213518209999],
              [-11.272043423999946, -72.11419036299992],
              [-11.250355597999942, -72.10076262799993],
              [-11.149891730999911, -72.08171965899993],
              [-11.124745245999918, -72.0681291649999],
              [-11.113880988999938, -72.06454843499995],
              [-11.032297329999949, -72.04892343499995],
              [-11.05260169199994, -72.03630950299993],
              [-11.073841925999943, -72.03573984199994],
              [-11.095814581999946, -72.03875090899993],
              [-11.117909308999913, -72.03777434699992],
              [-11.109201626999948, -72.02556731599992],
              [-11.09593665299991, -72.01864999799994],
              [-11.036203579999949, -72.00497812299994],
              [-10.981190558999913, -71.9807268209999],
              [-10.974110480999911, -71.97340260199991],
              [-10.974720831999946, -71.97128671699994],
              [-10.976551886999914, -71.9670549459999],
              [-10.978098110999952, -71.96200937299994],
              [-10.97720292899993, -71.9568010399999],
              [-10.974354620999918, -71.95354583099993],
              [-10.936390753999945, -71.92278411299992],
              [-10.923817511999914, -71.9099260399999],
              [-10.91783606699994, -71.89576588299991],
              [-10.922922329999949, -71.8786760399999],
              [-10.944162563999953, -71.86541106599992],
              [-10.939198370999918, -71.8513322899999],
              [-10.919585740999935, -71.8318010399999],
              [-10.847157355999911, -71.78085702899995],
              [-10.888783331999946, -71.7541643209999],
              [-10.94908606699994, -71.74285247199992],
              [-11.238250291999947, -71.74907805799992],
              [-11.527414516999954, -71.75530364399992],
              [-11.753529425999943, -71.70566171699994],
              [-11.987904425999943, -71.6794572899999],
              [-12.15029863199993, -71.63640715899993],
              [-12.175160285999937, -71.62395598799992],
              [-12.330922003999945, -71.49480559699992],
              [-12.367665167999917, -71.45077890399995],
              [-12.38072669199994, -71.39544036299992],
              [-12.349232550999943, -71.35637786299992],
              [-12.295480923999946, -71.32935963299991],
              [-12.208566860999952, -71.30266692499993],
              [-12.06432044199994, -71.29705169099992],
              [-11.879505988999938, -71.26034921699994],
              [-11.80650794199994, -71.25986093499995],
              [-11.660145636999914, -71.27646249799994],
              [-11.698068813999953, -71.3049455709999],
              [-11.716786261999914, -71.32870859199994],
              [-11.712880011999914, -71.3552385399999],
              [-11.682606574999909, -71.39226653399993],
              [-11.651112433999913, -71.40976327899995],
              [-11.609486456999946, -71.41692473799992],
              [-11.370594855999911, -71.42343515399995],
              [-11.295806443999936, -71.43743254999993],
              [-11.218129035999937, -71.46648528399993],
              [-11.072092251999948, -71.54900481599992],
              [-11.036610480999911, -71.56121184699992],
              [-10.960682745999918, -71.57634856599992],
              [-10.839995897999927, -71.58489348799992],
              [-10.75812740799995, -71.57740650799991],
              [-10.678089972999942, -71.55828215899993],
              [-10.600331183999913, -71.52703215899993],
              [-10.62096106699994, -71.50058359199994],
              [-10.641590949999909, -71.48015715899993],
              [-10.721180792999917, -71.42742278399993],
              [-10.733143683999913, -71.40960051899992],
              [-10.72765051999994, -71.38909270599993],
              [-10.703724738999938, -71.36223723799992],
              [-10.653472459999932, -71.32496510199991],
              [-10.59561113199993, -71.29729583099993],
              [-10.348337368999921, -71.23919036249993],
              [-10.101063605999911, -71.18108489399992],
              [-10.036854620999918, -71.15545012799993],
              [-9.988758917999917, -71.11931731599992],
              [-10.03307044199994, -71.08587004999993],
              [-10.094105597999942, -71.0642229149999],
              [-10.215402798999946, -71.04021575299993],
              [-10.351185675999943, -71.03232187299994],
              [-10.425160285999937, -71.01921965899993],
              [-10.450062628999945, -70.99098072699991],
              [-10.430816209999932, -70.97470468499995],
              [-10.39439856699994, -70.96111419099992],
              [-10.266835089999915, -70.9314104149999],
              [-10.069650844999956, -70.9118791649999],
              [-10.00226803299995, -70.9196916649999],
              [-9.943104620999918, -70.94451262799993],
              [-9.981312628999945, -70.98788827899995],
              [-9.975819464999915, -71.02857838299991],
              [-9.939523891999954, -71.06243254999993],
              [-9.885243292999917, -71.08416106599992],
              [-9.833607550999943, -71.09286874799994],
              [-9.451649542999917, -71.09921640399995],
              [-9.105051235999952, -71.1853166649999],
              [-9.054514126999948, -71.20671965899993],
              [-9.011219855999911, -71.23691171699994],
              [-8.991444464999915, -71.25904713299991],
              [-8.987945115999935, -71.27654387799993],
              [-9.000477667999917, -71.29241301899992],
              [-9.02961178299995, -71.30974700299993],
              [-9.066029425999943, -71.3225236959999],
              [-9.129953579999949, -71.35995859199994],
              [-9.140044725999928, -71.36777109199994],
              [-9.142933722999942, -71.38079192499993],
              [-9.140451626999948, -71.39373137799993],
              [-9.134510870999918, -71.40569426899992],
              [-9.12682044199994, -71.41562265399995],
              [-9.11392167899993, -71.42522551899992],
              [-9.101633266999954, -71.42693450299993],
              [-9.070708787999934, -71.41920338299991],
              [-9.046131964999915, -71.4182268209999],
              [-8.994740363999938, -71.42791106599992],
              [-8.968861456999946, -71.42831796699994],
              [-8.911284959999932, -71.42131926899992],
              [-8.85342363199993, -71.42066822699991],
              [-8.824208136999914, -71.4275041649999],
              [-8.750721808999913, -71.47356536299992],
              [-8.829823370999918, -71.53329843499995],
              [-8.767404751999948, -71.55242278399993],
              [-8.735259568999936, -71.56658294099992],
              [-8.715443488999938, -71.5857072899999],
              [-8.687123175999943, -71.64006926899992],
              [-8.684885219999956, -71.65618254999993],
              [-8.694488084999932, -71.66887786299992],
              [-8.746490037999934, -71.70077890399995],
              [-8.718576626999948, -71.7048479149999],
              [-8.69399980399993, -71.70501067499993],
              [-8.642201300999943, -71.6994768209999],
              [-8.614125128999945, -71.69988372199992],
              [-8.566761847999942, -71.71249765399995],
              [-8.428618943999936, -71.73040129999993],
              [-8.409738735999952, -71.72991301899992],
              [-8.39289303299995, -71.72380950299993],
              [-8.382476365999935, -71.70916106599992],
              [-8.38272050699993, -71.70387135199991],
              [-8.388010219999956, -71.69605885199991],
              [-8.388498501999948, -71.69207122199992],
              [-8.382313605999911, -71.68238697699991],
              [-8.372059699999909, -71.67595794099992],
              [-8.350331183999913, -71.66611093499995],
              [-8.310129360999952, -71.63469817499993],
              [-8.29523678299995, -71.62615325299993],
              [-8.226673956999946, -71.60466887799993],
              [-8.182850714999915, -71.58310312299994],
              [-8.162587042999917, -71.57659270599993],
              [-8.141835089999915, -71.5759416649999],
              [-8.117990688999953, -71.58147551899992],
              [-8.089182094999956, -71.59441497199992],
              [-8.072255011999914, -71.6110979149999],
              [-8.071685350999928, -71.63201262799993],
              [-8.091175910999937, -71.65764739399992],
              [-7.816761847999942, -71.67197030999995],
              [-7.788563605999911, -71.66692473799992],
              [-7.763824022999927, -71.65545012799993],
              [-7.739369269999941, -71.64739348799992],
              [-7.708851691999939, -71.64788176899992],
              [-7.651356574999909, -71.65789153399993],
              [-7.62922115799995, -71.65195077899995],
              [-7.603911912999934, -71.63396575299993],
              [-7.588693813999953, -71.61199309699992],
              [-7.596587693999936, -71.5940080709999],
              [-7.622425910999937, -71.5837541649999],
              [-7.709787563999953, -71.56292083099993],
              [-7.733998175999943, -71.55144622199992],
              [-7.758371548999946, -71.53590260199991],
              [-7.775786912999934, -71.51669687299994],
              [-7.779164191999939, -71.49407317499993],
              [-7.773833787999934, -71.44687265399995],
              [-7.765207485999952, -71.42839934699992],
              [-7.63540605399993, -71.35556405999995],
              [-7.58853105399993, -71.34514739399992],
              [-7.568511522999927, -71.33464934699992],
              [-7.563628709999932, -71.31096770599993],
              [-7.559315558999913, -71.20134856599992],
              [-7.564198370999918, -71.15056731599992],
              [-7.594593878999945, -71.11370208099993],
              [-7.688628709999932, -71.06316497199992],
              [-7.804269985999952, -71.02939218499995],
              [-7.853423631999931, -71.00603606599992],
              [-7.87564042899993, -70.98992278399993],
              [-7.892486131999931, -70.97063567499993],
              [-7.941151495999918, -70.89373137799993],
              [-7.961903449999909, -70.87314218499995],
              [-7.912220831999946, -70.84368254999993],
              [-7.85578365799995, -70.82586028399993],
              [-7.492054816999939, -70.78476327899995],
              [-7.284291144999941, -70.79119231599992],
              [-6.951283332499941, -70.85759856599992],
              [-6.618275519999941, -70.92400481599992],
              [-6.604318813999953, -70.91423919099992],
              [-6.572092251999948, -70.83757903399993],
              [-6.553334113999938, -70.81503671699994],
              [-6.429758266999954, -70.73788827899995],
              [-6.37531490799995, -70.71965911299992],
              [-6.317860480999911, -70.70794036299992],
              [-6.013579881999931, -70.67978280999995],
              [-5.675282355999911, -70.7326799459999],
              [-5.655629035999937, -70.74325937299994],
              [-5.574696417999917, -70.80380624799994],
              [-5.564361131999931, -70.82048919099992],
              [-5.56663977799991, -70.84172942499993],
              [-5.577504035999937, -70.8615861959999],
              [-5.592884894999941, -70.87428150799991],
              [-5.615712042999917, -70.88469817499993],
              [-5.630360480999911, -70.89421965899993],
              [-5.686919725999928, -70.95794036299992],
              [-5.698557094999956, -70.97568124799994],
              [-5.712147589999915, -71.01685963299991],
              [-5.721791144999941, -71.02996184699992],
              [-5.735707160999937, -71.0388322899999],
              [-6.019886847999942, -71.10898202899995],
              [-6.043690558999913, -71.11825937299994],
              [-6.077300584999932, -71.1467424459999],
              [-6.099720831999946, -71.15683359199994],
              [-6.06314042899993, -71.17457447699991],
              [-6.045399542999917, -71.18816497199992],
              [-6.042836066999939, -71.20159270599993],
              [-6.057972785999937, -71.21917083099993],
              [-6.07453365799995, -71.23137786299992],
              [-6.193918423999946, -71.29143645599993],
              [-6.236439581999946, -71.30592213299991],
              [-6.281117316999939, -71.31064218499995],
              [-6.179554816999939, -71.35816822699991],
              [-6.149769660999937, -71.36630624799994],
              [-6.123402472999942, -71.36296965899993],
              [-6.068186001999948, -71.34734465899993],
              [-5.892933722999942, -71.3610979149999],
              [-5.820057745999918, -71.34107838299991],
              [-5.592518683999913, -71.35312265399995],
              [-5.579904751999948, -71.35214609199994],
              [-5.539662238999938, -71.33977629999993],
              [-5.527455206999946, -71.34107838299991],
              [-5.496083136999914, -71.34872812299994],
              [-5.411610480999911, -71.33993905999995],
              [-5.298410610999952, -71.35515715899993],
              [-5.270619269999941, -71.35418059699992],
              [-5.221058722999942, -71.33489348799992],
              [-5.193837042999917, -71.33082447699991],
              [-4.795969204999949, -71.34490325299993],
              [-4.709136522999927, -71.33473072699991],
              [-4.599598761999914, -71.34498463299991],
              [-4.387277798999946, -71.32293059699992],
              [-4.345448370999918, -71.32610442499993],
              [-4.173695441999939, -71.37004973799992],
              [-4.169667120999918, -71.34514739399992],
              [-4.140370245999918, -71.34221770599993],
              [-4.075917120999918, -71.3576799459999],
              [-3.937570766999954, -71.3674455709999],
              [-3.972320115999935, -71.34286874799994],
              [-3.990386522999927, -71.31560637799993],
              [-3.981922980999911, -71.29599374799994],
              [-3.937163865999935, -71.29412200299993],
              [-3.888295050999943, -71.30657317499993],
              [-3.75454667899993, -71.36516692499993],
              [-3.729481574999909, -71.3728166649999],
              [-3.718169725999928, -71.37859465899993],
              [-3.709584113999938, -71.38762786299992],
              [-3.706450975999928, -71.39918385199991],
              [-3.709584113999938, -71.40927499799994],
              [-3.714019334999932, -71.41936614399992],
              [-3.714751756999931, -71.43075937299994],
              [-3.712228969999956, -71.4533830709999],
              [-3.707102016999954, -71.45712655999995],
              [-3.645334438999953, -71.46412525799991],
              [-3.621896938999953, -71.47144947699991],
              [-3.591297980999911, -71.49822356599992],
              [-3.571603969999956, -71.50994231599992],
              [-3.550689256999931, -71.5153947899999],
              [-3.492176886999914, -71.52271900799991],
              [-3.47093665299991, -71.52117278399993],
              [-3.495961066999939, -71.48479583099993],
              [-3.499094204999949, -71.4685197899999],
              [-3.489409959999932, -71.4509416649999],
              [-3.46898352799991, -71.43767669099992],
              [-3.446278449999909, -71.43482838299991],
              [-3.399891730999911, -71.4436174459999],
              [-3.375355597999942, -71.4455705709999],
              [-3.352650519999941, -71.43962981599992],
              [-3.337798631999931, -71.42522551899992],
              [-3.334584113999938, -71.32488372199992],
              [-3.32258053299995, -71.30242278399993],
              [-3.308990037999934, -71.29021575299993],
              [-3.290150519999941, -71.28720468499995],
              [-3.263335740999935, -71.29225025799991],
              [-3.239247199999909, -71.30152760199991],
              [-3.171498175999943, -71.34319426899992],
              [-3.132801886999914, -71.35662200299993],
              [-2.991200324999909, -71.3610979149999],
              [-2.998402472999942, -71.3361955709999],
              [-3.01235917899993, -71.31519947699991],
              [-3.016102667999917, -71.2971330709999],
              [-2.992298956999946, -71.28093840899993],
              [-2.966297980999911, -71.2736955709999],
              [-2.940297003999945, -71.2697893209999],
              [-2.887074347999942, -71.26799895599993],
              [-2.778065558999913, -71.28476327899995],
              [-2.727650519999941, -71.28394947699991],
              [-2.677479620999918, -71.25741952899995],
              [-2.650502081999946, -71.28818124799994],
              [-2.485259568999936, -71.3693986959999],
              [-2.436390753999945, -71.38225676899992],
              [-2.336822068999936, -71.39006926899992],
              [-2.273426886999914, -71.37737395599993],
              [-2.252552863999938, -71.37753671699994],
              [-2.236724412999934, -71.38730234199994],
              [-2.214588995999918, -71.42693450299993],
              [-2.196603969999956, -71.44605885199991],
              [-2.154367641999954, -71.47323984199994],
              [-2.131255662999934, -71.48259856599992],
              [-2.106800910999937, -71.48544687299994],
              [-2.087554490999935, -71.4826799459999],
              [-2.039540167999917, -71.46795012799993],
              [-2.020985480999911, -71.45794036299992],
              [-1.986683722999942, -71.42522551899992],
              [-1.972035285999937, -71.42253997199992],
              [-1.926340298999946, -71.44060637799993],
              [-1.903391079999949, -71.44638437299994],
              [-1.880034959999932, -71.4489885399999],
              [-1.861073370999918, -71.44695403399993],
              [-1.785267706999946, -71.41985442499993],
              [-1.761830206999946, -71.41472747199992],
              [-1.736236131999931, -71.41545989399992],
              [-1.615589972999942, -71.44150155999995],
              [-1.595570441999939, -71.43889739399992],
              [-1.577788865999935, -71.4279924459999],
              [-1.560170050999943, -71.42644622199992],
              [-1.489247199999909, -71.4587541649999],
              [-1.46743730399993, -71.45842864399992],
              [-1.395375128999945, -71.44345468499995],
              [-1.372059699999909, -71.4338518209999],
              [-1.328724738999938, -71.40862395599993],
              [-1.306263800999943, -71.40276458099993],
              [-1.324818488999938, -71.35930754999993],
              [-1.32453365799995, -71.34002044099992],
              [-1.310699022999927, -71.31959400799991],
              [-1.272450324999909, -71.29176197699991],
              [-1.230376756999931, -71.26799895599993],
              [-1.186024542999917, -71.25546640399995],
              [-1.137562628999945, -71.25530364399992],
              [-0.953968878999945, -71.30046965899993],
              [-0.912668423999946, -71.3186174459999],
              [-0.81281490799995, -71.37753671699994],
              [-0.804269985999952, -71.3947893209999],
              [-0.806019660999937, -71.42156340899993],
              [-0.817697719999956, -71.43645598799992],
              [-0.838002081999946, -71.44410572699991],
              [-0.86554928299995, -71.4489885399999],
              [-0.845285610999952, -71.50318775799991],
              [-0.870757615999935, -71.5451799459999],
              [-0.915150519999941, -71.58277760199991],
              [-0.952137824999909, -71.62363046699994],
              [-0.899403449999909, -71.63339609199994],
              [-0.876088019999941, -71.64055754999993],
              [-0.854603644999941, -71.6565080709999],
              [-0.836089647999927, -71.66334400799991],
              [-0.78189042899993, -71.65593840899993],
              [-0.755970831999946, -71.6565080709999],
              [-0.621937628999945, -71.6853166649999],
              [-0.599273240999935, -71.69443124799994],
              [-0.580922003999945, -71.71013762799993],
              [-0.560943162999934, -71.73674895599993],
              [-0.518462693999936, -71.76523202899995],
              [-0.469309048999946, -71.75400155999995],
              [-0.22687740799995, -71.62220631299994],
              [0.015554233000046, -71.49041106599992],
              [0.035004102000073, -71.47389088299991],
              [0.059174024000072, -71.43718840899993],
              [0.078745964000063, -71.4201799459999],
              [0.23218834700009, -71.3498674459999],
              [0.291758660000085, -71.3361955709999],
              [0.410817905000044, -71.32659270599993],
              [0.437754754000082, -71.31975676899992],
              [0.517832879000082, -71.27304452899995],
              [0.547129754000082, -71.26181405999995],
              [0.635508660000085, -71.25554778399993],
              [0.650889519000089, -71.25042083099993],
              [0.691579623000052, -71.22421640399995],
              [0.710948113000086, -71.21819426899992],
              [0.796397332000083, -71.21282317499993],
              [0.933767123000052, -71.17937590899993],
              [1.192841016500068, -71.14881764099994],
              [1.451914910000085, -71.11825937299994],
              [1.459157748000052, -71.1150041649999],
              [1.472666863000086, -71.09783294099992],
              [1.48414147200009, -71.09221770599993],
              [1.531911655000044, -71.09099700299993],
              [1.543223504000082, -71.0861955709999],
              [1.567393425000091, -71.06951262799993],
              [1.588715040000068, -71.06519947699991],
              [1.611338738000086, -71.06519947699991],
              [1.638845248000052, -71.06072356599992],
              [1.726735873000052, -71.03337981599992],
              [1.86882571700005, -71.01816171699994],
              [1.94857832100007, -70.99114348799992],
              [2.15015709700009, -70.9782854149999],
              [2.164724155000044, -70.97380950299993],
              [2.185069207000083, -70.95916106599992],
              [2.198741082000083, -70.95435963299991],
              [2.45834394600007, -70.92034270599993],
              [2.499196811000047, -70.90439218499995],
              [2.519704623000052, -70.90056731599992],
              [2.530121290000068, -70.9021135399999],
              [2.551524285000085, -70.90960051899992],
              [2.562022332000083, -70.91122812299994],
              [2.574392123000052, -70.90935637799993],
              [2.611582879000082, -70.89690520599993],
              [2.63257897200009, -70.89348723799992],
              [2.691254102000073, -70.8962541649999],
              [2.714040561000047, -70.89462655999995],
              [2.755381707000083, -70.88534921699994],
              [2.823252800000091, -70.89055754999993],
              [2.97828209700009, -70.88420989399992],
              [3.074066602000073, -70.89462655999995],
              [3.187998894000089, -70.87249114399992],
              [3.203623894000089, -70.86532968499995],
              [3.222666863000086, -70.85955169099992],
              [3.260915561000047, -70.86646900799991],
              [3.281586134000065, -70.86565520599993],
              [3.327159050000091, -70.85654062299994],
              [3.574717644000089, -70.85214609199994],
              [3.62273196700005, -70.84107838299991],
              [3.692230665000068, -70.83733489399992],
              [3.775645379000082, -70.81601327899995],
              [3.821543816000087, -70.81747812299994],
              [3.80827884200005, -70.80201588299991],
              [3.82789147200009, -70.79843515399995],
              [3.847178582000083, -70.79851653399993],
              [3.886241082000083, -70.80339934699992],
              [3.907399936000047, -70.80380624799994],
              [4.010752800000091, -70.78289153399993],
              [4.096527540000068, -70.7751604149999],
              [4.22396894600007, -70.78378671699994],
              [4.271983269000089, -70.77605559699992],
              [4.319021030000044, -70.76246510199991],
              [4.336436394000089, -70.7536760399999],
              [4.341970248000052, -70.74871184699992],
              [4.351084832000083, -70.73772551899992],
              [4.357595248000052, -70.73381926899992],
              [4.372894727000073, -70.7321916649999],
              [4.389333530000044, -70.73235442499993],
              [4.39975019600007, -70.72747161299992],
              [4.397634311000047, -70.71087004999993],
              [4.414073113000086, -70.71249765399995],
              [4.446787957000083, -70.72144947699991],
              [4.463389519000089, -70.72405364399992],
              [4.475271030000044, -70.72372812299994],
              [4.507823113000086, -70.71795012799993],
              [4.62476647200009, -70.72079843499995],
              [4.853037957000083, -70.68466562299994],
              [4.909027540000068, -70.68222421699994],
              [4.94857832100007, -70.68873463299991],
              [4.962901238000086, -70.68865325299993],
              [4.976573113000086, -70.68425872199992],
              [4.99187259200005, -70.67538827899995],
              [5.000824415000068, -70.6638322899999],
              [5.002614780000044, -70.65227629999993],
              [5.006114129000082, -70.64267343499995],
              [5.020762566000087, -70.6369768209999],
              [5.073741082000083, -70.63372161299992],
              [5.209727410000085, -70.6501604149999],
              [5.217539910000085, -70.64771900799991],
              [5.224457227000073, -70.64421965899993],
              [5.234873894000089, -70.6423479149999],
              [5.314707879000082, -70.64967213299991],
              [5.341970248000052, -70.64918385199991],
              [5.41732832100007, -70.63079192499993],
              [5.441742384000065, -70.62981536299992],
              [5.587738477000073, -70.64918385199991],
              [5.61296634200005, -70.64023202899995],
              [5.63648522200009, -70.62639739399992],
              [5.667165561000047, -70.61402760199991],
              [5.679860873000052, -70.61296965899993],
              [5.706065300000091, -70.61614348799992],
              [5.735850457000083, -70.6130510399999],
              [5.746592644000089, -70.61825937299994],
              [5.756521030000044, -70.62574635199991],
              [5.770762566000087, -70.63201262799993],
              [5.801117384000065, -70.63355885199991],
              [5.974457227000073, -70.60995859199994],
              [5.999278191000087, -70.6130510399999],
              [6.045664910000085, -70.62574635199991],
              [6.060394727000073, -70.6252580709999],
              [6.10132897200009, -70.60979583099993],
              [6.113291863000086, -70.60865650799991],
              [6.18336022200009, -70.61728280999995],
              [6.203135613000086, -70.62704843499995],
              [6.19898522200009, -70.62167734199994],
              [6.188324415000068, -70.60279713299991],
              [6.224131707000083, -70.60198333099993],
              [6.297373894000089, -70.62004973799992],
              [6.334971550000091, -70.6154924459999],
              [6.340993686000047, -70.61060963299991],
              [6.35124759200005, -70.59612395599993],
              [6.357269727000073, -70.59107838299991],
              [6.36491946700005, -70.58904387799993],
              [6.382009311000047, -70.58847421699994],
              [6.42904707100007, -70.58123137799993],
              [6.448008660000085, -70.58245208099993],
              [6.46851647200009, -70.58757903399993],
              [6.483897332000083, -70.58831145599993],
              [6.519053582000083, -70.57781340899993],
              [6.536387566000087, -70.57529062299994],
              [6.559092644000089, -70.5778947899999],
              [6.625661655000044, -70.59905364399992],
              [6.645681186000047, -70.60214609199994],
              [6.705332879000082, -70.59368254999993],
              [6.72437584700009, -70.59368254999993],
              [6.761729363000086, -70.59880950299993],
              [6.78060957100007, -70.5993791649999],
              [6.785655144000089, -70.59368254999993],
              [6.79273522200009, -70.58912525799991],
              [6.807871941000087, -70.58310312299994],
              [6.795909050000091, -70.55787525799991],
              [6.81023196700005, -70.53980885199991],
              [6.83765709700009, -70.53378671699994],
              [6.865082227000073, -70.54412200299993],
              [6.88453209700009, -70.55828215899993],
              [6.898773634000065, -70.56047942499993],
              [6.968028191000087, -70.52629973799992],
              [6.985199415000068, -70.52255624799994],
              [7.001800977000073, -70.52402109199994],
              [7.109629754000082, -70.54680754999993],
              [7.145274285000085, -70.56096770599993],
              [7.153168165000068, -70.56072356599992],
              [7.159434441000087, -70.55413176899992],
              [7.165293816000087, -70.54631926899992],
              [7.172211134000065, -70.54192473799992],
              [7.181813998000052, -70.54192473799992],
              [7.228526238000086, -70.54705169099992],
              [7.242442254000082, -70.54412200299993],
              [7.250498894000089, -70.53460051899992],
              [7.250254754000082, -70.51620859199994],
              [7.26303144600007, -70.52141692499993],
              [7.335459832000083, -70.52646249799994],
              [7.348643425000091, -70.52361419099992],
              [7.373789910000085, -70.51360442499993],
              [7.386892123000052, -70.51034921699994],
              [7.403005405000044, -70.51034921699994],
              [7.44890384200005, -70.5217424459999],
              [7.514414910000085, -70.52092864399992],
              [7.553721550000091, -70.52849700299993],
              [7.567393425000091, -70.52434661299992],
              [7.578868035000085, -70.51295338299991],
              [7.592784050000091, -70.49602629999993],
              [7.611827019000089, -70.48601653399993],
              [7.62867272200009, -70.49570077899995],
              [7.646332227000073, -70.51100025799991],
              [7.668304884000065, -70.51816171699994],
              [7.666188998000052, -70.48788827899995],
              [7.656993035000085, -70.47356536299992],
              [7.475108269000089, -70.37688567499993],
              [7.455332879000082, -70.35865650799991],
              [7.43921959700009, -70.33749765399995],
              [7.42750084700009, -70.31218840899993],
              [7.415049675000091, -70.25359465899993],
              [7.414235873000052, -70.22144947699991],
              [7.42351321700005, -70.20435963299991],
              [7.479014519000089, -70.18987395599993],
              [7.83529707100007, -70.16366952899995],
              [7.893565300000091, -70.17742278399993],
              [7.917002800000091, -70.19402434699992],
              [7.92514082100007, -70.2170549459999],
              [7.921885613000086, -70.2439104149999],
              [7.895762566000087, -70.30999114399992],
              [7.888926629000082, -70.31943124799994],
              [7.877289259000065, -70.32537200299993],
              [7.846446160000085, -70.33342864399992],
              [7.836924675000091, -70.33993905999995],
              [7.834157748000052, -70.36614348799992],
              [7.844981316000087, -70.3982072899999],
              [7.862478061000047, -70.42815520599993],
              [7.879079623000052, -70.44768645599993],
              [7.904795769000089, -70.46445077899995],
              [7.930430535000085, -70.47234465899993],
              [8.10523522200009, -70.47527434699992],
              [8.225271030000044, -70.4943986959999],
              [8.254730665000068, -70.49260833099993],
              [8.302744988000086, -70.47405364399992],
              [8.328786655000044, -70.46786874799994],
              [8.354991082000083, -70.46892669099992],
              [8.44312584700009, -70.48235442499993],
              [8.549652540000068, -70.47234465899993],
              [8.654551629000082, -70.44801197699991],
              [8.666026238000086, -70.44198984199994],
              [8.683441602000073, -70.42522551899992],
              [8.693858269000089, -70.42107512799993],
              [8.75367272200009, -70.42156340899993],
              [8.784678582000083, -70.41757577899995],
              [8.812754754000082, -70.40488046699994],
              [8.832041863000086, -70.38347747199992],
              [8.837168816000087, -70.35393645599993],
              [8.971853061000047, -70.37249114399992],
              [8.983571811000047, -70.37232838299991],
              [8.996918165000068, -70.36874765399995],
              [9.024180535000085, -70.3576799459999],
              [9.037771030000044, -70.35686614399992],
              [9.115570509000065, -70.37590911299992],
              [9.136729363000086, -70.37542083099993],
              [9.157481316000087, -70.35955169099992],
              [9.168711785000085, -70.33416106599992],
              [9.167816602000073, -70.30803801899992],
              [9.151377800000091, -70.29029713299991],
              [9.126231316000087, -70.28167083099993],
              [9.10132897200009, -70.27654387799993],
              [9.019786004000082, -70.27076588299991],
              [8.938243035000085, -70.24675872199992],
              [8.887461785000085, -70.21550872199992],
              [8.898448113000086, -70.18547942499993],
              [9.080577019000089, -70.08928801899992],
              [9.128754102000073, -70.0759416649999],
              [9.182627800000091, -70.07089609199994],
              [9.29428144600007, -70.07878997199992],
              [9.403575066000087, -70.10426197699991],
              [9.41537519600007, -70.1091447899999],
              [9.422129754000082, -70.11516692499993],
              [9.431162957000083, -70.13665129999993],
              [9.439463738000086, -70.14910247199992],
              [9.45053144600007, -70.1565080709999],
              [9.53101647200009, -70.18621184699992],
              [9.553070509000065, -70.19801197699991],
              [9.575205925000091, -70.21721770599993],
              [9.592946811000047, -70.22893645599993],
              [9.636241082000083, -70.2400041649999],
              [9.655772332000083, -70.2478166649999],
              [9.671885613000086, -70.2678361959999],
              [9.670664910000085, -70.29143645599993],
              [9.662119988000086, -70.31698984199994],
              [9.656504754000082, -70.34303150799991],
              [9.713389519000089, -70.33896249799994],
              [9.76498457100007, -70.34856536299992],
              [9.867198113000086, -70.39202239399992],
              [9.955332879000082, -70.44426848799992],
              [9.979258660000085, -70.45354583099993],
              [10.28687584700009, -70.52402109199994],
              [10.322764519000089, -70.53679778399993],
              [10.33920332100007, -70.53899504999993],
              [10.392832879000082, -70.53964609199994],
              [10.421153191000087, -70.54705169099992],
              [10.476817254000082, -70.57219817499993],
              [10.53296959700009, -70.57830169099992],
              [10.599945509000065, -70.60466887799993],
              [10.656748894000089, -70.61150481599992],
              [10.705821160000085, -70.63201262799993],
              [10.722666863000086, -70.63689544099992],
              [10.809580925000091, -70.64657968499995],
              [10.968923373000052, -70.68873463299991],
              [11.067393425000091, -70.70126718499995],
              [11.106700066000087, -70.6970354149999],
              [11.118174675000091, -70.70045338299991],
              [11.158539259000065, -70.7287736959999],
              [11.209483269000089, -70.74968840899993],
              [11.237559441000087, -70.75701262799993],
              [11.260427280000044, -70.75652434699992],
              [11.321055535000085, -70.74041106599992],
              [11.351573113000086, -70.7365861959999],
              [11.641368035000085, -70.7732072899999],
              [11.70085696700005, -70.7717424459999],
              [11.822927280000044, -70.78313567499993],
              [11.853526238000086, -70.7815080709999],
              [11.861175977000073, -70.77605559699992],
              [11.884043816000087, -70.75237395599993],
              [11.894379102000073, -70.7443986959999],
              [11.914235873000052, -70.73788827899995],
              [11.993662957000083, -70.72535572699991],
              [12.00554446700005, -70.72087981599992],
              [12.01498457100007, -70.71298593499995],
              [12.032074415000068, -70.6858049459999],
              [12.046071811000047, -70.67929452899995],
              [12.08171634200005, -70.67400481599992],
              [12.074473504000082, -70.65146249799994],
              [12.091319207000083, -70.60320403399993],
              [12.087738477000073, -70.54534270599993],
              [12.107758009000065, -70.53004322699991],
              [12.167816602000073, -70.51441822699991],
              [12.14234459700009, -70.48544687299994],
              [12.163340691000087, -70.47087981599992],
              [12.184336785000085, -70.46184661299992],
              [12.231944207000083, -70.4528947899999],
              [12.252126498000052, -70.44605885199991],
              [12.267425977000073, -70.43254973799992],
              [12.27906334700009, -70.41464609199994],
              [12.288584832000083, -70.3947893209999],
              [12.32203209700009, -70.37029387799993],
              [12.38021894600007, -70.35857512799993],
              [12.530772332000083, -70.35165780999995],
              [12.608571811000047, -70.3205705709999],
              [12.648936394000089, -70.31487395599993],
              [12.715017123000052, -70.32170989399992],
              [12.736582879000082, -70.32000090899993],
              [12.801442905000044, -70.29827239399992],
              [12.824961785000085, -70.29501718499995],
              [12.837901238000086, -70.2639299459999],
              [12.897146030000044, -70.24822356599992],
              [13.018321160000085, -70.24179452899995],
              [13.041026238000086, -70.23447030999995],
              [13.029551629000082, -70.21770598799992],
              [12.969493035000085, -70.17294687299994],
              [12.939789259000065, -70.16497161299992],
              [12.483083530000044, -70.12688567499993],
              [12.435883009000065, -70.10515715899993],
              [12.426524285000085, -70.08538176899992],
              [12.444590691000087, -70.07024504999993],
              [12.47396894600007, -70.05999114399992],
              [12.49781334700009, -70.05527109199994],
              [12.559336785000085, -70.05380624799994],
              [12.735118035000085, -70.07146575299993],
              [12.969248894000089, -70.04615650799991],
              [13.026215040000068, -70.0510393209999],
              [13.084971550000091, -70.07512786299992],
              [13.108164910000085, -70.09140390399995],
              [13.164805535000085, -70.1506486959999],
              [13.186534050000091, -70.16643645599993],
              [13.236175977000073, -70.1877580709999],
              [13.29232832100007, -70.24732838299991],
              [13.342784050000091, -70.27271900799991],
              [13.399668816000087, -70.28622812299994],
              [13.570323113000086, -70.28997161299992],
              [13.598480665000068, -70.29892343499995],
              [13.650401238000086, -70.32341887799993],
              [13.848806186000047, -70.34783294099992],
              [14.016774936000047, -70.34148528399993],
              [14.080577019000089, -70.3459611959999],
              [14.093272332000083, -70.3435197899999],
              [14.120941602000073, -70.3303361959999],
              [14.135264519000089, -70.32626718499995],
              [14.167816602000073, -70.32732512799993],
              [14.187998894000089, -70.33220794099992],
              [14.204925977000073, -70.3278947899999],
              [14.227793816000087, -70.30144622199992],
              [14.247569207000083, -70.29501718499995],
              [14.340098504000082, -70.30608489399992],
              [14.344574415000068, -70.3025041649999],
              [14.346690300000091, -70.29631926899992],
              [14.34937584700009, -70.29045989399992],
              [14.355967644000089, -70.28753020599993],
              [14.38640384200005, -70.28590260199991],
              [14.40015709700009, -70.28818124799994],
              [14.427012566000087, -70.29558684699992],
              [14.44117272200009, -70.29697030999995],
              [14.468760613000086, -70.29420338299991],
              [14.495127800000091, -70.28630950299993],
              [14.510508660000085, -70.28386809699992],
              [14.539805535000085, -70.28997161299992],
              [14.555918816000087, -70.29159921699994],
              [14.573252800000091, -70.29111093499995],
              [14.585134311000047, -70.29257577899995],
              [14.595957879000082, -70.29729583099993],
              [14.609629754000082, -70.30681731599992],
              [14.618662957000083, -70.30950286299992],
              [14.629893425000091, -70.30771249799994],
              [14.65202884200005, -70.30169036299992],
              [14.683116082000083, -70.30380624799994],
              [14.747080925000091, -70.32496510199991],
              [14.780039910000085, -70.3298479149999],
              [14.836680535000085, -70.32773202899995],
              [14.86500084700009, -70.32284921699994],
              [14.880381707000083, -70.31340911299992],
              [14.897959832000083, -70.29876067499993],
              [15.03687584700009, -70.29094817499993],
              [15.144867384000065, -70.31023528399993],
              [15.53484134200005, -70.3376604149999],
              [15.599864129000082, -70.33123137799993],
              [15.630869988000086, -70.3337541649999],
              [15.70248457100007, -70.3650041649999],
              [15.766856316000087, -70.37835051899992],
              [15.826914910000085, -70.37761809699992],
              [15.85710696700005, -70.35361093499995],
              [15.86264082100007, -70.3239885399999],
              [15.859873894000089, -70.31308359199994],
              [15.84929446700005, -70.30185312299994],
              [15.84538821700005, -70.2932268209999],
              [15.846934441000087, -70.28118254999993],
              [15.851817254000082, -70.26913827899995],
              [15.857920769000089, -70.2600236959999],
              [15.905039910000085, -70.21640390399995],
              [15.93132571700005, -70.20086028399993],
              [15.96257571700005, -70.18962981599992],
              [16.129567905000044, -70.17253997199992],
              [16.140147332000083, -70.16725025799991],
              [16.16187584700009, -70.14739348799992],
              [16.174978061000047, -70.14120859199994],
              [16.200368686000047, -70.13990650799991],
              [16.284434441000087, -70.14902109199994],
              [16.519867384000065, -70.1267229149999],
              [16.577321811000047, -70.13144296699994],
              [16.62631269600007, -70.15178801899992],
              [16.63843834700009, -70.16155364399992],
              [16.647715691000087, -70.17302825299993],
              [16.65333092500009, -70.18596770599993],
              [16.65406334700009, -70.20110442499993],
              [16.65015709700009, -70.22079843499995],
              [16.643321160000085, -70.23105234199994],
              [16.630869988000086, -70.23691171699994],
              [16.610606316000087, -70.24334075299993],
              [16.622243686000047, -70.27825286299992],
              [16.626149936000047, -70.31121184699992],
              [16.619313998000052, -70.34295012799993],
              [16.59815514400009, -70.37420012799993],
              [16.57471764400009, -70.3962541649999],
              [16.545664910000085, -70.41765715899993],
              [16.514414910000085, -70.43547942499993],
              [16.484629754000082, -70.44605885199991],
              [16.505137566000087, -70.45419687299994],
              [16.871104363000086, -70.43938567499993],
              [16.925954623000052, -70.46363697699991],
              [16.910004102000073, -70.47698333099993],
              [16.927012566000087, -70.48447030999995],
              [16.943695509000065, -70.48398202899995],
              [16.960948113000086, -70.48056405999995],
              [17.126800977000073, -70.48088958099993],
              [17.194021030000044, -70.46550872199992],
              [17.216970248000052, -70.46396249799994],
              [17.48406009200005, -70.47893645649992],
              [17.751149936000047, -70.4939104149999],
              [17.789398634000065, -70.51083749799994],
              [17.875824415000068, -70.51726653399993],
              [17.908376498000052, -70.51409270599993],
              [18.093760613000086, -70.54241301899992],
              [18.32984459700009, -70.54013437299994],
              [18.331879102000073, -70.53508879999993],
              [18.33171634200005, -70.52800872199992],
              [18.339121941000087, -70.52019622199992],
              [18.375824415000068, -70.50750090899993],
              [18.417165561000047, -70.50204843499995],
              [18.498220248000052, -70.50253671699994],
              [18.31031334700009, -70.37371184699992],
              [18.304698113000086, -70.36614348799992],
              [18.300629102000073, -70.3576799459999],
              [18.29590905000009, -70.35019296699994],
              [18.28809655000009, -70.34531015399995],
              [18.26921634200005, -70.33798593499995],
              [18.260996941000087, -70.33294036299992],
              [18.252777540000068, -70.3259416649999],
              [18.31617272200009, -70.32439544099992],
              [18.44703209700009, -70.30006275799991],
              [18.50684655000009, -70.27874114399992],
              [18.573008660000085, -70.2639299459999],
              [18.71461022200009, -70.25986093499995],
              [18.78296959700009, -70.23894622199992],
              [18.806488477000073, -70.21949635199991],
              [18.821055535000085, -70.19866301899992],
              [18.83887780000009, -70.18132903399993],
              [18.871836785000085, -70.1721330709999],
              [18.941661004000082, -70.17099374799994],
              [19.153493686000047, -70.20354583099993],
              [19.290537957000083, -70.24814218499995],
              [19.27588951900009, -70.25156015399995],
              [19.26148522200009, -70.25188567499993],
              [19.232269727000073, -70.24879322699991],
              [19.215017123000052, -70.24944426899992],
              [19.201182488000086, -70.25457122199992],
              [19.17351321700005, -70.27385833099993],
              [19.200043165000068, -70.28826262799993],
              [19.269379102000073, -70.34124114399992],
              [19.29664147200009, -70.36809661299992],
              [19.281504754000082, -70.38160572699991],
              [19.251149936000047, -70.38925546699994],
              [19.23292076900009, -70.39885833099993],
              [19.22787519600007, -70.4143205709999],
              [19.221853061000047, -70.42058684699992],
              [19.196543816000087, -70.42620208099993],
              [19.17872155000009, -70.43238697699991],
              [19.170176629000082, -70.43808359199994],
              [19.14747155000009, -70.47429778399993],
              [19.142914259000065, -70.48503997199992],
              [19.13721764400009, -70.49504973799992],
              [19.016286655000044, -70.59677499799994],
              [18.991465691000087, -70.61060963299991],
              [18.93653405000009, -70.6233049459999],
              [18.915212436000047, -70.63404713299991],
              [18.920664910000085, -70.6526018209999],
              [18.931813998000052, -70.67831796699994],
              [18.930918816000087, -70.73601653399993],
              [18.945485873000052, -70.75237395599993],
              [18.959239129000082, -70.75432708099993],
              [18.982269727000073, -70.74968840899993],
              [18.995616082000083, -70.74895598799992],
              [19.012380405000044, -70.75335051899992],
              [19.028493686000047, -70.76140715899993],
              [19.057790561000047, -70.78118254999993],
              [19.07585696700005, -70.79957447699991],
              [19.111582879000082, -70.84710051899992],
              [19.13054446700005, -70.86012135199991],
              [19.289235873000052, -70.9143205709999],
              [19.56739342500009, -70.94605885199991],
              [19.628184441000087, -70.94085051899992],
              [19.732758009000065, -70.89267343499995],
              [19.788910352000073, -70.89332447699991],
              [19.903575066000087, -70.91253020599993],
              [20.033213738000086, -70.91904062299994],
              [20.076345248000052, -70.92929452899995],
              [20.11231530000009, -70.93092213299991],
              [20.190114780000044, -70.90878671699994],
              [20.228526238000086, -70.90536874799994],
              [20.40398196700005, -70.92343515399995],
              [20.422618035000085, -70.92253997199992],
              [20.49854576900009, -70.90243905999995],
              [20.56031334700009, -70.90439218499995],
              [20.578868035000085, -70.9021135399999],
              [20.617930535000085, -70.88933684699992],
              [20.63770592500009, -70.88591887799993],
              [20.705251498000052, -70.8830705709999],
              [20.84424889400009, -70.85662200299993],
              [20.886892123000052, -70.85556405999995],
              [21.005381707000083, -70.8708635399999],
              [21.043142123000052, -70.86370208099993],
              [21.201182488000086, -70.81218840899993],
              [21.172618035000085, -70.78476327899995],
              [21.15951582100007, -70.75603606599992],
              [21.166758660000085, -70.72812265399995],
              [21.19898522200009, -70.70191822699991],
              [21.170176629000082, -70.67848072699991],
              [21.158539259000065, -70.66464609199994],
              [21.156097852000073, -70.64999765399995],
              [21.166840040000068, -70.6325822899999],
              [21.184255405000044, -70.62232838299991],
              [21.224457227000073, -70.61239999799994],
              [21.20281009200005, -70.5940080709999],
              [21.208506707000083, -70.5764299459999],
              [21.289805535000085, -70.50701262799993],
              [21.317230665000068, -70.49032968499995],
              [21.34148196700005, -70.48170338299991],
              [21.43132571700005, -70.47966887799993],
              [21.45167076900009, -70.46843840899993],
              [21.47201582100007, -70.43954843499995],
              [21.471446160000085, -70.43466562299994],
              [21.46461022200009, -70.4221330709999],
              [21.464366082000083, -70.41757577899995],
              [21.47396894600007, -70.40667083099993],
              [21.50245201900009, -70.38396575299993],
              [21.611338738000086, -70.27214934699992],
              [21.63648522200009, -70.25774504999993],
              [21.69434655000009, -70.2346330709999],
              [21.745616082000083, -70.22616952899995],
              [21.801605665000068, -70.23593515399995],
              [21.993662957000083, -70.30217864399992],
              [22.01929772200009, -70.31796640399995],
              [22.030039910000085, -70.32781340899993],
              [22.03565514400009, -70.33562590899993],
              [22.042979363000086, -70.34221770599993],
              [22.05827884200005, -70.34880950299993],
              [22.181488477000073, -70.3850236959999],
              [22.283213738000086, -70.43670012799993],
              [22.338063998000052, -70.45525481599992],
              [22.447927280000044, -70.47779713299991],
              [22.47559655000009, -70.48845794099992],
              [22.525645379000082, -70.51531340899993],
              [22.553477410000085, -70.52499765399995],
              [22.579274936000047, -70.54021575299993],
              [22.575694207000083, -70.56121184699992],
              [22.555511915000068, -70.58171965899993],
              [22.53223717500009, -70.59563567499993],
              [22.48096764400009, -70.61003997199992],
              [22.166880730000088, -70.62420012799993],
              [21.852793816000087, -70.63836028399993],
              [21.826426629000082, -70.65504322699991],
              [22.028493686000047, -70.68303801899992],
              [22.24935957100007, -70.6858049459999],
              [22.294200066000087, -70.69597747199992],
              [22.348887566000087, -70.69329192499993],
              [22.367360873000052, -70.69459400799991],
              [22.326914910000085, -70.75945403399993],
              [22.34424889400009, -70.76181405999995],
              [22.38054446700005, -70.7614885399999],
              [22.416188998000052, -70.76946379999993],
              [22.433116082000083, -70.76482512799993],
              [22.450043165000068, -70.7575822899999],
              [22.471039259000065, -70.75432708099993],
              [22.488617384000065, -70.75774504999993],
              [22.54851321700005, -70.77752044099992],
              [22.563324415000068, -70.77825286299992],
              [22.595550977000073, -70.77288176899992],
              [22.724945509000065, -70.7693010399999],
              [22.761729363000086, -70.7776018209999],
              [22.832692905000044, -70.80413176899992],
              [22.85523522200009, -70.8083635399999],
              [22.91773522200009, -70.81292083099993],
              [22.926036004000082, -70.81601327899995],
              [22.941742384000065, -70.82634856599992],
              [22.949880405000044, -70.82919687299994],
              [22.957286004000082, -70.82854583099993],
              [22.972504102000073, -70.82350025799991],
              [23.18067467500009, -70.81308359199994],
              [23.259043816000087, -70.82301197699991],
              [23.29265384200005, -70.82122161299992],
              [23.323008660000085, -70.80974700299993],
              [23.41260826900009, -70.74374765399995],
              [23.437836134000065, -70.71770598799992],
              [23.43523196700005, -70.6911760399999],
              [23.448090040000068, -70.68694426899992],
              [23.460948113000086, -70.68466562299994],
              [23.48764082100007, -70.68320077899995],
              [23.502289259000065, -70.67929452899995],
              [23.512868686000047, -70.67083098799992],
              [23.52247155000009, -70.66008879999993],
              [23.53492272200009, -70.64950937299994],
              [23.553070509000065, -70.6291643209999],
              [23.557790561000047, -70.60556405999995],
              [23.54786217500009, -70.58513762799993],
              [23.522146030000044, -70.57488372199992],
              [23.55241946700005, -70.5681291649999],
              [23.61687259200005, -70.56519947699991],
              [23.64356530000009, -70.55136484199994],
              [23.66732832100007, -70.52385833099993],
              [23.686208530000044, -70.49358489399992],
              [23.712412957000083, -70.42669036299992],
              [23.75245201900009, -70.4026018209999],
              [24.108897332000083, -70.40943775799991],
              [24.17546634200005, -70.42424895599993],
              [24.277517123000052, -70.46054452899995],
              [24.408864780000044, -70.53394947699991],
              [24.419444207000083, -70.54485442499993],
              [24.428396030000044, -70.56357187299994],
              [24.433116082000083, -70.58171965899993],
              [24.43995201900009, -70.59905364399992],
              [24.455414259000065, -70.61451588299991],
              [24.346527540000068, -70.6735979149999],
              [24.319509311000047, -70.68010833099993],
              [24.29151451900009, -70.6818986959999],
              [24.26531009200005, -70.67864348799992],
              [24.29151451900009, -70.71795012799993],
              [24.31934655000009, -70.74032968499995],
              [24.479177280000044, -70.79656340899993],
              [24.499196811000047, -70.80917734199994],
              [24.533864780000044, -70.83782317499993],
              [24.55518639400009, -70.84677499799994],
              [24.968028191000087, -70.94548919099992],
              [25.260590040000068, -70.98088958099993],
              [25.44044030000009, -70.98015715899993],
              [25.524587436000047, -70.99431731599992],
              [25.567556186000047, -70.99342213299991],
              [25.562510613000086, -70.98943450299993],
              [25.553396030000044, -70.97958749799994],
              [25.54851321700005, -70.97535572699991],
              [25.576914910000085, -70.97144947699991],
              [25.599131707000083, -70.97747161299992],
              [25.62012780000009, -70.98796965899993],
              [25.645762566000087, -70.99749114399992],
              [25.66187584700009, -71.00042083099993],
              [25.674571160000085, -71.00017669099992],
              [25.702972852000073, -70.99114348799992],
              [25.71583092500009, -70.9900041649999],
              [25.730642123000052, -70.99334075299993],
              [25.758555535000085, -71.00269947699991],
              [25.782725457000083, -71.00660572699991],
              [25.82789147200009, -71.00823333099993],
              [25.916026238000086, -71.03435637799993],
              [25.982676629000082, -71.04192473799992],
              [26.10132897200009, -71.04265715899993],
              [26.159353061000047, -71.03435637799993],
              [26.215993686000047, -71.01555754999993],
              [26.267832879000082, -71.00839609199994],
              [26.39031009200005, -71.03045012799993],
              [26.445648634000065, -71.03240325299993],
              [26.478851759000065, -71.01897551899992],
              [26.489756707000083, -71.0193010399999],
              [26.50440514400009, -71.02263762799993],
              [26.517832879000082, -71.02263762799993],
              [26.606618686000047, -71.0080705709999],
              [26.63526451900009, -70.99920012799993],
              [26.674001498000052, -70.96550872199992],
              [26.699229363000086, -70.96135833099993],
              [26.767751498000052, -70.96103280999995],
              [26.794118686000047, -70.9646135399999],
              [26.804860873000052, -70.96379973799992],
              [26.82195071700005, -70.95476653399993],
              [26.829925977000073, -70.94654713299991],
              [26.839366082000083, -70.94198984199994],
              [26.861501498000052, -70.9436174459999],
              [26.888845248000052, -70.94198984199994],
              [26.90756269600007, -70.93157317499993],
              [26.92628014400009, -70.92392343499995],
              [26.953379754000082, -70.92937590899993],
              [26.979177280000044, -70.93865325299993],
              [27.27507571700005, -70.98967864399992],
              [27.296722852000073, -70.98479583099993],
              [27.303396030000044, -70.96843840899993],
              [27.298838738000086, -70.95208098799992],
              [27.298838738000086, -70.9372697899999],
              [27.31885826900009, -70.9255510399999],
              [27.302256707000083, -70.91139088299991],
              [27.283050977000073, -70.90740325299993],
              [27.241709832000083, -70.90837981599992],
              [27.217458530000044, -70.90439218499995],
              [27.19703209700009, -70.89706796699994],
              [27.178477410000085, -70.88591887799993],
              [27.159353061000047, -70.87070077899995],
              [27.18213951900009, -70.8557268209999],
              [27.20281009200005, -70.84498463299991],
              [27.224619988000086, -70.83928801899992],
              [27.25131269600007, -70.83879973799992],
              [27.297048373000052, -70.84677499799994],
              [27.31739342500009, -70.84319426899992],
              [27.32862389400009, -70.82439544099992],
              [27.351817254000082, -70.83863697699991],
              [27.371267123000052, -70.8342424459999],
              [27.389903191000087, -70.82154713299991],
              [27.412445509000065, -70.81129322699991],
              [27.44304446700005, -70.80901458099993],
              [27.471446160000085, -70.81096770599993],
              [27.500336134000065, -70.80950286299992],
              [27.545176629000082, -70.79306405999995],
              [27.574392123000052, -70.78915780999995],
              [27.585134311000047, -70.78313567499993],
              [27.604665561000047, -70.75847747199992],
              [27.616384311000047, -70.74700286299992],
              [27.628428582000083, -70.74130624799994],
              [28.02906334700009, -70.72649504999993],
              [28.055349155000044, -70.72275155999995],
              [28.08529707100007, -70.71217213299991],
              [28.114024285000085, -70.7072893209999],
              [28.173106316000087, -70.7170549459999],
              [28.20248457100007, -70.71526458099993],
              [28.231618686000047, -70.70281340899993],
              [28.25635826900009, -70.68865325299993],
              [28.282074415000068, -70.67848072699991],
              [28.31495201900009, -70.67848072699991],
              [28.45167076900009, -70.69402434699992],
              [28.473643425000034, -70.68767669099992],
              [28.494802280000044, -70.67782968499995],
              [28.55250084700009, -70.65894947699991],
              [28.60987389400009, -70.63298919099992],
              [28.641449415000068, -70.62346770599993],
              [28.721853061000047, -70.61012135199991],
              [28.772959832000083, -70.5940080709999],
              [28.833262566000087, -70.59498463299991],
              [29.021820509000065, -70.5720354149999],
              [29.034678582000083, -70.56878020599993],
              [29.048838738000086, -70.56161874799994],
              [29.07553144600007, -70.54241301899992],
              [29.08920332100007, -70.53704192499993],
              [29.14503014400009, -70.5290666649999],
              [29.150726759000065, -70.52402109199994],
              [29.163584832000083, -70.50017669099992],
              [29.174652540000068, -70.49114348799992],
              [29.201508009000065, -70.48170338299991],
              [29.294444207000083, -70.46152109199994],
              [29.33139082100007, -70.46160247199992],
              [29.34620201900009, -70.45647551899992],
              [29.364105665000068, -70.4397111959999],
              [29.376231316000087, -70.43287525799991],
              [29.440684441000087, -70.41090260199991],
              [29.44385826900009, -70.40732187299994],
              [29.448252800000034, -70.39568450299993],
              [29.451426629000082, -70.39226653399993],
              [29.45948326900009, -70.39104583099993],
              [29.477386915000068, -70.39251067499993],
              [29.48601321700005, -70.39202239399992],
              [29.602712436000047, -70.37249114399992],
              [29.748789910000085, -70.3654924459999],
              [29.76335696700005, -70.36296965899993],
              [29.771820509000065, -70.35564544099992],
              [29.778819207000083, -70.33879973799992],
              [29.785492384000065, -70.32903411299992],
              [29.79542076900009, -70.32301197699991],
              [29.812510613000086, -70.31715260199991],
              [29.84115644600007, -70.31129322699991],
              [30.165212436000047, -70.28557708099993],
              [30.170583530000044, -70.28289153399993],
              [30.180837436000047, -70.2732072899999],
              [30.186289910000085, -70.27109140399995],
              [30.192637566000087, -70.27361419099992],
              [30.205332879000082, -70.28525155999995],
              [30.211680535000085, -70.28801848799992],
              [30.23959394600007, -70.28704192499993],
              [30.295583530000044, -70.2776018209999],
              [30.355316602000073, -70.27857838299991],
              [30.439300977000073, -70.26677825299993],
              [30.631683790000068, -70.26132577899995],
              [30.707774285000085, -70.27507903399993],
              [30.737803582000083, -70.27353280999995],
              [30.93531334700009, -70.2146135399999],
              [30.965017123000052, -70.21404387799993],
              [31.01734459700009, -70.22763437299994],
              [31.044118686000047, -70.23162200299993],
              [31.280446811000047, -70.23707447699991],
              [31.411631707000083, -70.22332122199992],
              [31.49577884200005, -70.20435963299991],
              [31.60906009200005, -70.20012786299992],
              [31.844411655000044, -70.14690520599993],
              [31.994395379000082, -70.13445403399993],
              [32.04517662900008, -70.11842213299991],
              [32.266368035000085, -70.08652109199994],
              [32.313487175000034, -70.06552499799994],
              [32.33920332100007, -70.05803801899992],
              [32.365896030000044, -70.05331796699994],
              [32.56885826900009, -70.05152760199991],
              [32.62419681100005, -70.04029713299991],
              [32.671885613000086, -70.0232072899999],
              [32.69548587300005, -70.01824309699992],
              [32.72201582100007, -70.01767343499995],
              [32.74529056100005, -70.0134416649999],
              [32.75945071700005, -69.9997697899999],
              [32.77068118600005, -69.98202890399995],
              [32.78541100400008, -69.9651018209999],
              [32.80640709700009, -69.95566171699994],
              [32.85108483200008, -69.94548919099992],
              [32.86866295700008, -69.93027109199994],
              [32.877289259000065, -69.90488046699994],
              [32.871104363000086, -69.88404713299991],
              [32.852549675000034, -69.87037525799991],
              [32.824229363000086, -69.86614348799992],
              [32.83033287900008, -69.85662200299993],
              [32.84929446700005, -69.8342424459999],
              [32.853851759000065, -69.82626718499995],
              [32.85173587300005, -69.81845468499995],
              [32.84001712300005, -69.79599374799994],
              [32.83757571700005, -69.78476327899995],
              [32.851898634000065, -69.78525155999995],
              [32.86280358200008, -69.78167083099993],
              [32.86841881600009, -69.7732072899999],
              [32.86744225400008, -69.7595354149999],
              [32.88795006600009, -69.76034921699994],
              [32.89763431100005, -69.75107187299994],
              [32.903330925000034, -69.7360979149999],
              [32.91260826900009, -69.71998463299991],
              [32.92351321700005, -69.7107072899999],
              [32.949880405000044, -69.69500090899993],
              [32.96176191500007, -69.68596770599993],
              [32.97575931100005, -69.6721330709999],
              [32.98568769600007, -69.65935637799993],
              [32.992198113000086, -69.64462655999995],
              [32.99586022200009, -69.62542083099993],
              [32.99545332100007, -69.61809661299992],
              [32.993174675000034, -69.61256275799991],
              [32.98406009200005, -69.60149504999993],
              [32.98161868600005, -69.59335702899995],
              [32.98601321700005, -69.58684661299992],
              [32.992523634000065, -69.5803361959999],
              [32.99626712300005, -69.57219817499993],
              [33.00180097700007, -69.51921965899993],
              [33.00049889400009, -69.50481536299992],
              [32.997080925000034, -69.49765390399995],
              [32.98064212300005, -69.47673919099992],
              [32.97828209700009, -69.46982187299994],
              [32.97999108200008, -69.46355559699992],
              [32.98267662900008, -69.4572893209999],
              [32.98292076900009, -69.45029062299994],
              [32.96697024800005, -69.38681405999995],
              [32.95199629000007, -69.35947030999995],
              [32.92790774800005, -69.34368254999993],
              [32.79078209700009, -69.29094817499993],
              [32.75220787900008, -69.26262786299992],
              [32.70134524800005, -69.24358489399992],
              [32.53248131600009, -69.11882903399993],
              [32.52100670700008, -69.1071916649999],
              [32.51343834700009, -69.09449635199991],
              [32.50440514400009, -69.08464934699992],
              [32.48764082100007, -69.08163827899995],
              [32.524180535000085, -69.05527109199994],
              [32.53060957100007, -69.04851653399993],
              [32.52955162900008, -69.03630950299993],
              [32.51140384200005, -68.99212004999993],
              [32.502940300000034, -68.96160247199992],
              [32.49887129000007, -68.93092213299991],
              [32.50570722700007, -68.90309010199991],
              [32.56226647200009, -68.85637786299992],
              [32.57211347700007, -68.85230885199991],
              [32.58570397200009, -68.85068124799994],
              [32.61060631600009, -68.84368254999993],
              [32.83806399800005, -68.75212981599992],
              [33.21599368600005, -68.66961028399993],
              [33.71509850350006, -68.67376067499993],
              [34.21420332100007, -68.67791106599992],
              [34.30062910200007, -68.68816497199992],
              [34.36304772200009, -68.72551848799992],
              [34.38493899800005, -68.79420338299991],
              [34.37126712300005, -68.80632903399993],
              [34.09115644600007, -68.85247161299992],
              [34.08285566500007, -68.85955169099992],
              [34.07601972700007, -68.88632577899995],
              [34.06397545700008, -68.88909270599993],
              [34.04908287900008, -68.8869768209999],
              [34.03435306100005, -68.89934661299992],
              [34.00945071700005, -68.92742278399993],
              [33.97486412900008, -68.94744231599992],
              [33.83057701900009, -69.00937265399995],
              [33.60368899800005, -69.05242278399993],
              [33.62818444100009, -69.06096770599993],
              [33.77125084700009, -69.05348072699991],
              [33.781260613000086, -69.0583635399999],
              [33.80054772200009, -69.08212655999995],
              [33.811208530000044, -69.09140390399995],
              [33.865896030000044, -69.11256275799991],
              [33.92164147200009, -69.12224700299993],
              [34.36150149800005, -69.13290780999995],
              [34.38795006600009, -69.12712981599992],
              [34.45085696700005, -69.08798593499995],
              [34.46794681100005, -69.08163827899995],
              [34.58725019600007, -69.06682708099993],
              [34.61996504000007, -69.07073333099993],
              [34.65259850400008, -69.08342864399992],
              [34.610362175000034, -69.09124114399992],
              [34.650726759000065, -69.11142343499995],
              [34.66553795700008, -69.11492278399993],
              [34.73462975400008, -69.1130510399999],
              [34.754649285000085, -69.11858489399992],
              [34.77458743600005, -69.12688567499993],
              [34.838877800000034, -69.14226653399993],
              [34.856211785000085, -69.14983489399992],
              [34.88949629000007, -69.17229583099993],
              [34.943695509000065, -69.19150155999995],
              [35.01189212300005, -69.2287736959999],
              [35.12549889400009, -69.2595354149999],
              [35.199880405000044, -69.29412200299993],
              [35.17562910200007, -69.31178150799991],
              [35.154958530000044, -69.32382577899995],
              [35.14698326900009, -69.34026458099993],
              [35.160817905000044, -69.37175872199992],
              [35.16765384200005, -69.40048593499995],
              [35.154958530000044, -69.4260393209999],
              [35.13111412900008, -69.44646575299993],
              [35.10474694100009, -69.45964934699992],
              [35.125743035000085, -69.49480559699992],
              [35.13795006600009, -69.5080705709999],
              [35.15674889400009, -69.51653411299992],
              [35.22877037900008, -69.53671640399995],
              [35.204112175000034, -69.57976653399993],
              [35.15772545700008, -69.5954729149999],
              [35.108164910000085, -69.6057268209999],
              [35.07349694100009, -69.63193124799994],
              [35.07935631600009, -69.67058684699992],
              [35.12330162900008, -69.69939544099992],
              [35.24398847700007, -69.73560963299991],
              [35.268565300000034, -69.73691171699994],
              [35.31771894600007, -69.7341447899999],
              [35.34262129000007, -69.72966887799993],
              [35.38599694100009, -69.71575286299992],
              [35.43482506600009, -69.71168385199991],
              [35.483409050000034, -69.70134856599992],
              [35.559580925000034, -69.6994768209999],
              [35.70834394600007, -69.66611093499995],
              [35.90455162900008, -69.66725025799991],
              [36.00318444100009, -69.65341562299994],
              [36.05250084700009, -69.63884856599992],
              [36.07960045700008, -69.63665129999993],
              [36.101573113000086, -69.64495208099993],
              [36.14568118600005, -69.70077890399995],
              [36.16065514400009, -69.70452239399992],
              [36.21208743600005, -69.68840911299992],
              [36.37061608200008, -69.6579729149999],
              [36.33253014400009, -69.61923593499995],
              [36.37037194100009, -69.60556405999995],
              [36.41627037900008, -69.60654062299994],
              [36.50407962300005, -69.62151458099993],
              [36.705739780000044, -69.62981536299992],
              [36.750987175000034, -69.63746510199991],
              [36.756602410000085, -69.64226653399993],
              [36.75733483200008, -69.6506486959999],
              [36.756602410000085, -69.66073984199994],
              [36.75733483200008, -69.67009856599992],
              [36.76921634200005, -69.69402434699992],
              [36.783864780000044, -69.70419687299994],
              [36.91570071700005, -69.75042083099993],
              [36.97380618600005, -69.79062265399995],
              [36.995127800000034, -69.79729583099993],
              [36.97193444100009, -69.81454843499995],
              [36.96892337300005, -69.83831145599993],
              [36.98170006600009, -69.86223723799992],
              [37.00635826900009, -69.88054778399993],
              [37.03630618600005, -69.88665129999993],
              [37.05681399800005, -69.87883879999993],
              [37.076508009000065, -69.86785247199992],
              [37.10336347700007, -69.86394622199992],
              [37.13062584700009, -69.86296965899993],
              [37.21216881600009, -69.84295012799993],
              [37.24048912900008, -69.8318010399999],
              [37.23780358200008, -69.81609465899993],
              [37.21729576900009, -69.7985979149999],
              [37.19255618600005, -69.78199635199991],
              [37.28101647200009, -69.72844817499993],
              [37.49146569100009, -69.75457122199992],
              [37.596446160000085, -69.73007577899995],
              [37.54997806100005, -69.7146135399999],
              [37.52751712300005, -69.70468515399995],
              [37.50831139400009, -69.69019947699991],
              [37.540049675000034, -69.68474700299993],
              [37.78630618600005, -69.6818986959999],
              [37.78174889400009, -69.68629322699991],
              [37.774180535000085, -69.69719817499993],
              [37.76978600400008, -69.70183684699992],
              [37.77719160200007, -69.70452239399992],
              [37.79184004000007, -69.71233489399992],
              [37.799489780000044, -69.7151018209999],
              [37.79053795700008, -69.72283294099992],
              [37.78044681100005, -69.72763437299994],
              [37.76937910200007, -69.72966887799993],
              [37.75757897200009, -69.72909921699994],
              [37.78565514400009, -69.75709400799991],
              [37.84156334700009, -69.75904713299991],
              [38.03842207100007, -69.71746184699992],
              [38.059580925000034, -69.71803150799991],
              [38.21810957100007, -69.7561174459999],
              [38.24073326900009, -69.76653411299992],
              [38.25025475400008, -69.78167083099993],
              [38.24463951900009, -69.79566822699991],
              [38.22152754000007, -69.80266692499993],
              [38.119151238000086, -69.8186174459999],
              [38.020192905000044, -69.8493791649999],
              [38.042979363000086, -69.86272551899992],
              [38.06657962300005, -69.86793385199991],
              [38.11695397200009, -69.87297942499993],
              [38.139333530000044, -69.88144296699994],
              [38.20622806100005, -69.92571379999993],
              [38.24626712300005, -69.9416643209999],
              [38.255869988000086, -69.94915129999993],
              [38.26531009200005, -69.96721770599993],
              [38.261729363000086, -69.97747161299992],
              [38.251963738000086, -69.98503997199992],
              [38.22282962300005, -70.01409270599993],
              [38.219737175000034, -70.02402109199994],
              [38.23658287900008, -70.02841562299994],
              [38.295909050000034, -70.03394947699991],
              [38.32976321700005, -70.03004322699991],
              [38.358164910000085, -70.02263762799993],
              [38.38599694100009, -70.01848723799992],
              [38.418711785000085, -70.02467213299991],
              [38.447276238000086, -70.03753020599993],
              [38.46989993600005, -70.05217864399992],
              [38.53793379000007, -70.10857512799993],
              [38.56275475400008, -70.12037525799991],
              [38.68506920700008, -70.14983489399992],
              [38.71119225400008, -70.16350676899992],
              [38.71404056100005, -70.18873463299991],
              [38.78923587300005, -70.18792083099993],
              [38.94027754000007, -70.20468515399995],
              [39.01587975400008, -70.19833749799994],
              [39.05046634200005, -70.18857187299994],
              [39.06804446700005, -70.18108489399992],
              [39.07642662900008, -70.17262135199991],
              [39.075205925000034, -70.1545549459999],
              [39.06592858200008, -70.14609140399995],
              [38.92107181100005, -70.10857512799993],
              [38.815196160000085, -70.05535247199992],
              [38.79704837300005, -70.02874114399992],
              [38.80355879000007, -69.98772551899992],
              [39.07960045700008, -69.90585702899995],
              [39.158864780000044, -69.90374114399992],
              [39.19263756600009, -69.89251067499993],
              [39.19450931100005, -69.86077239399992],
              [39.208018425000034, -69.86207447699991],
              [39.22120201900009, -69.86093515399995],
              [39.23389733200008, -69.85702890399995],
              [39.24586022200003, -69.85051848799992],
              [39.178396030000044, -69.8474260399999],
              [39.158213738000086, -69.8435197899999],
              [39.13607832100007, -69.82952239399992],
              [39.12940514400009, -69.81113046699994],
              [39.13689212300005, -69.76376718499995],
              [39.16146894600007, -69.72665780999995],
              [39.20883222700007, -69.70663827899995],
              [39.495127800000034, -69.68629322699991],
              [39.53598066500007, -69.66838958099993],
              [39.56104576900009, -69.62900155999995],
              [39.58871504000007, -69.59880950299993],
              [39.63843834700003, -69.60857512799993],
              [39.62525475400008, -69.63616301899992],
              [39.64421634200005, -69.65097421699994],
              [39.67741946700005, -69.65691497199992],
              [39.70720462300005, -69.65829843499995],
              [39.692067905000044, -69.6482072899999],
              [39.64283287900008, -69.62607187299994],
              [39.66879316500007, -69.60344817499993],
              [39.70337975400008, -69.60003020599993],
              [39.77865644600007, -69.61142343499995],
              [39.76644941500007, -69.59490325299993],
              [39.75733483200008, -69.5861955709999],
              [39.74626712300005, -69.58464934699992],
              [39.727549675000034, -69.5896135399999],
              [39.71306399800005, -69.58684661299992],
              [39.70036868600005, -69.57341887799993],
              [39.69068444100009, -69.55584075299993],
              [39.68604576900009, -69.54111093499995],
              [39.76644941500007, -69.52548593499995],
              [39.79623457100007, -69.52646249799994],
              [39.74000084700003, -69.4904924459999],
              [39.76905358200008, -69.48902760199991],
              [39.783213738000086, -69.48601653399993],
              [39.79070071700005, -69.47844817499993],
              [39.795909050000034, -69.46355559699992],
              [39.81763756600009, -69.4221330709999],
              [39.82545006600009, -69.41204192499993],
              [39.84489993600005, -69.39324309699992],
              [39.84791100400008, -69.38469817499993],
              [39.84205162900008, -69.36825937299994],
              [39.83155358200008, -69.35955169099992],
              [39.715586785000085, -69.31552499799994],
              [39.70167076900009, -69.30681731599992],
              [39.71273847700007, -69.29070403399993],
              [39.746836785000085, -69.28378671699994],
              [39.814789259000065, -69.27996184699992],
              [39.803396030000044, -69.24773528399993],
              [39.786143425000034, -69.23015715899993],
              [39.73617597700007, -69.19597747199992],
              [39.811289910000085, -69.18092213299991],
              [39.735362175000034, -69.10800546699994],
              [39.707367384000065, -69.06796640399995],
              [39.708994988000086, -69.02117278399993],
              [39.72315514400009, -68.99342213299991],
              [39.73780358200008, -68.97625090899993],
              [39.803477410000085, -68.9255510399999],
              [39.819102410000085, -68.90504322699991],
              [39.84400475400008, -68.85556405999995],
              [39.85141035200007, -68.83359140399995],
              [39.85792076900009, -68.82952239399992],
              [39.899099155000044, -68.8225236959999],
              [40.26286868600005, -68.80217864399992],
              [40.37273196700005, -68.77532317499993],
              [40.39861087300005, -68.7639299459999],
              [40.44613691500007, -68.73544687299994],
              [40.47055097700007, -68.72616952899995],
              [40.52393639400009, -68.71917083099993],
              [40.701833530000044, -68.7268205709999],
              [40.71461022200003, -68.73154062299994],
              [40.740244988000086, -68.74627044099992],
              [40.75220787900008, -68.75066497199992],
              [40.760427280000044, -68.74797942499993],
              [40.76880944100009, -68.74146900799991],
              [40.78077233200008, -68.7346330709999],
              [40.88884524800005, -68.70940520599993],
              [40.99195397200003, -68.65146249799994],
              [41.03825931100005, -68.63420989399992],
              [41.03891035200007, -68.6213518209999],
              [41.01482181100005, -68.59644947699991],
              [41.02849368600005, -68.59238046699994],
              [41.05551191500007, -68.59002044099992],
              [41.06861412900008, -68.58749765399995],
              [41.078786655000044, -68.58294036299992],
              [41.097666863000086, -68.57089609199994],
              [41.10792076900009, -68.56609465899993],
              [41.11931399800005, -68.56389739399992],
              [41.20687910200007, -68.56015390399995],
              [41.23031660200007, -68.55510833099993],
              [41.27198326900009, -68.53704192499993],
              [41.35629316500007, -68.5158830709999],
              [41.45199629000007, -68.50660572699991],
              [41.50367272200003, -68.49309661299992],
              [41.543955925000034, -68.47210051899992],
              [41.98072350400008, -68.40634530999995],
              [42.10914147200003, -68.41090260199991],
              [42.194102410000085, -68.38762786299992],
              [42.28923587300005, -68.37769947699991],
              [42.536143425000034, -68.37957122199992],
              [42.526052280000044, -68.35116952899995],
              [42.52320397200003, -68.3361955709999],
              [42.52759850400008, -68.32756926899992],
              [42.54265384200005, -68.31910572699991],
              [42.580414259000065, -68.28557708099993],
              [42.55241946700005, -68.27898528399993],
              [42.54273522200003, -68.26490650799991],
              [42.54704837300005, -68.24578215899993],
              [42.56031334700003, -68.22372812299994],
              [42.57081139400009, -68.21445077899995],
              [42.583018425000034, -68.20916106599992],
              [42.59595787900008, -68.20517343499995],
              [42.608409050000034, -68.19980234199994],
              [42.63461347700007, -68.17717864399992],
              [42.64478600400008, -68.17099374799994],
              [42.65943444100009, -68.1657854149999],
              [42.84791100400008, -68.13689544099992],
              [42.82862389400009, -68.09644947699991],
              [42.859385613000086, -68.1037736959999],
              [42.99586022200003, -68.09148528399993],
              [43.107432488000086, -68.06414153399993],
              [43.40552819100009, -68.03460051899992],
              [43.44166100400008, -68.03997161299992],
              [43.50766035200007, -68.05934010199991],
              [43.776052280000044, -68.04648202899995],
              [43.81072024800005, -68.03899504999993],
              [43.85596764400009, -68.01043059699992],
              [43.87663821700005, -68.00497812299994],
              [43.93995201900009, -67.99863046699994],
              [43.95484459700003, -67.99114348799992],
              [43.96859785200007, -67.98137786299992],
              [43.98747806100005, -67.97193775799991],
              [44.00220787900008, -67.9685197899999],
              [44.155039910000085, -67.97844817499993],
              [44.496429884000065, -67.95940520599993],
              [44.52320397200003, -67.96298593499995],
              [44.60075931100005, -68.00335051899992],
              [44.629893425000034, -68.00937265399995],
              [44.654958530000044, -68.00497812299994],
              [44.689463738000086, -67.9826799459999],
              [44.71436608200008, -67.97616952899995],
              [44.80323326900009, -67.9763322899999],
              [44.82862389400009, -67.96591562299994],
              [44.78109785200007, -67.93320077899995],
              [44.61801191500007, -67.86044687299994],
              [44.660492384000065, -67.81145598799992],
              [44.717133009000065, -67.78362395599993],
              [44.97315514400009, -67.73113372199992],
              [45.03956139400009, -67.73186614399992],
              [45.10401451900009, -67.74472421699994],
              [45.131602410000085, -67.74716562299994],
              [45.16130618600005, -67.74130624799994],
              [45.21762129000007, -67.72136809699992],
              [45.248708530000044, -67.71502044099992],
              [45.34693444100009, -67.71542734199994],
              [45.36117597700007, -67.71135833099993],
              [45.39039147200003, -67.69597747199992],
              [45.40381920700008, -67.6950822899999],
              [45.451914910000085, -67.70907968499995],
              [45.500987175000034, -67.7131486959999],
              [45.52955162900008, -67.71933359199994],
              [45.55681399800005, -67.72966887799993],
              [45.58529707100007, -67.74488697699991],
              [45.57309004000007, -67.76409270599993],
              [45.55746504000007, -67.77996184699992],
              [45.53858483200008, -67.79168059699992],
              [45.51693769600007, -67.79794687299994],
              [45.544932488000086, -67.81755950299993],
              [45.582774285000085, -67.82439544099992],
              [45.65984134200005, -67.81747812299994],
              [45.68864993600005, -67.80331796699994],
              [45.71436608200008, -67.78004322699991],
              [45.740896030000044, -67.76091887799993],
              [45.772227410000085, -67.75855885199991],
              [45.750010613000086, -67.71965911299992],
              [45.73951256600009, -67.70867278399993],
              [45.819346550000034, -67.66521575299993],
              [45.848643425000034, -67.65748463299991],
              [46.21697024800005, -67.65300872199992],
              [46.24537194100009, -67.66375090899993],
              [46.29086347700007, -67.70403411299992],
              [46.30844160200007, -67.71502044099992],
              [46.37077884200005, -67.74342213299991],
              [46.40162194100009, -67.74537525799991],
              [46.433604363000086, -67.72958749799994],
              [46.400726759000065, -67.69736093499995],
              [46.38843834700003, -67.67929452899995],
              [46.38526451900009, -67.65886809699992],
              [46.392914259000065, -67.6325822899999],
              [46.40601647200003, -67.6193986959999],
              [46.42562910200007, -67.6150041649999],
              [46.556976759000065, -67.61858489399992],
              [46.612071160000085, -67.61207447699991],
              [46.62273196700005, -67.59002044099992],
              [46.590586785000085, -67.57870859199994],
              [46.350352410000085, -67.56878020599993],
              [46.30600019600007, -67.55925872199992],
              [46.29737389400009, -67.55584075299993],
              [46.29314212300005, -67.54941171699994],
              [46.289073113000086, -67.5232072899999],
              [46.28345787900008, -67.51279062299994],
              [46.27230879000007, -67.50400155999995],
              [46.31169681100005, -67.47380950299993],
              [46.23454837300005, -67.44866301899992],
              [46.25912519600007, -67.4162736959999],
              [46.24822024800005, -67.39959075299993],
              [46.25180097700007, -67.3733049459999],
              [46.264659050000034, -67.34823984199994],
              [46.28077233200008, -67.3342424459999],
              [46.377940300000034, -67.29615650799991],
              [46.426768425000034, -67.28329843499995],
              [46.47999108200008, -67.27532317499993],
              [46.583994988000086, -67.27450937299994],
              [46.66179446700005, -67.28777434699992],
              [46.68775475400008, -67.28915780999995],
              [46.766286655000044, -67.27548593499995],
              [46.817149285000085, -67.27898528399993],
              [46.86801191500007, -67.26751067499993],
              [46.89242597700007, -67.26458098799992],
              [46.914398634000065, -67.26702239399992],
              [46.938161655000044, -67.27263762799993],
              [46.98170006600009, -67.2893205709999],
              [46.95492597700007, -67.31308359199994],
              [46.963552280000044, -67.33269622199992],
              [46.99170983200008, -67.34644947699991],
              [47.02426191500007, -67.35271575299993],
              [47.305674675000034, -67.36980559699992],
              [47.44109134200005, -67.40943775799991],
              [47.327159050000034, -67.4338518209999],
              [47.30876712300005, -67.44036223799992],
              [47.27914472700007, -67.45891692499993],
              [47.26286868600005, -67.46648528399993],
              [47.249034050000034, -67.46786874799994],
              [47.20240319100009, -67.4626604149999],
              [46.91960696700005, -67.50652434699992],
              [46.95753014400009, -67.51458098799992],
              [46.97291100400008, -67.52337004999993],
              [46.98129316500007, -67.53866952899995],
              [46.97445722700007, -67.54615650799991],
              [46.95687910200007, -67.5529924459999],
              [46.93897545700008, -67.56340911299992],
              [46.930349155000044, -67.58163827899995],
              [46.97779381600009, -67.57968515399995],
              [47.127940300000034, -67.54436614399992],
              [47.228851759000065, -67.54648202899995],
              [47.327159050000034, -67.56650155999995],
              [47.30518639400009, -67.58367278399993],
              [47.270192905000044, -67.5998674459999],
              [47.23267662900008, -67.61126067499993],
              [47.20394941500007, -67.61435312299994],
              [47.167979363000086, -67.6115861959999],
              [47.139333530000044, -67.61541106599992],
              [47.115977410000085, -67.6291643209999],
              [47.095713738000086, -67.65699635199991],
              [47.19483483200008, -67.65878671699994],
              [47.12826582100007, -67.6799455709999],
              [47.096364780000044, -67.68425872199992],
              [47.05909264400009, -67.68499114399992],
              [47.093760613000086, -67.70517343499995],
              [47.13209069100009, -67.7053361959999],
              [47.170583530000044, -67.69402434699992],
              [47.22234134200005, -67.6716447899999],
              [47.24854576900009, -67.65536874799994],
              [47.26490319100009, -67.6506486959999],
              [47.63445071700005, -67.66033294099992],
              [47.61060631600009, -67.69182708099993],
              [47.56999759200005, -67.71021900799991],
              [47.30689537900008, -67.74342213299991],
              [47.32276451900009, -67.7619768209999],
              [47.35865319100009, -67.77312590899993],
              [47.48267662900008, -67.79355234199994],
              [47.502614780000044, -67.79225025799991],
              [47.545664910000085, -67.78435637799993],
              [47.55209394600007, -67.7795549459999],
              [47.555349155000044, -67.77361419099992],
              [47.559336785000085, -67.76816171699994],
              [47.646820509000065, -67.74749114399992],
              [47.87517337300005, -67.65520598799992],
              [47.91130618600005, -67.64902109199994],
              [48.133148634000065, -67.6526018209999],
              [48.16822350400008, -67.65813567499993],
              [48.30974368600005, -67.7185197899999],
              [48.38111412900008, -67.72942473799992],
              [48.45460045700008, -67.73015715899993],
              [48.44516035200007, -67.74765390399995],
              [48.42953535200007, -67.75351327899995],
              [48.41065514400009, -67.75465260199991],
              [48.39144941500007, -67.75872161299992],
              [48.17115319100009, -67.88884856599992],
              [48.201182488000086, -67.90894947699991],
              [48.22779381600009, -67.93320077899995],
              [48.21998131600009, -67.93759530999995],
              [48.205088738000086, -67.94850025799991],
              [48.197276238000086, -67.95273202899995],
              [48.217458530000044, -67.96298593499995],
              [48.23015384200005, -68.00505950299993],
              [48.24935957100007, -68.02076588299991],
              [48.27475019600007, -68.02556731599992],
              [48.38266035200007, -68.02337004999993],
              [48.40007571700005, -68.01238372199992],
              [48.414073113000086, -67.99667734199994],
              [48.43189537900008, -67.98064544099992],
              [48.52393639400009, -67.9416643209999],
              [48.572927280000044, -67.91171640399995],
              [48.614024285000085, -67.87932708099993],
              [48.65007571700005, -67.8415666649999],
              [48.70883222700007, -67.75115325299993],
              [48.71810957100007, -67.72926197699991],
              [48.72478274800005, -67.70370859199994],
              [48.71827233200008, -67.6818986959999],
              [48.69678795700008, -67.66716887799993],
              [48.64730879000007, -67.64544036299992],
              [48.63851972700007, -67.63787200299993],
              [48.62256920700008, -67.62037525799991],
              [48.59978274800005, -67.60149504999993],
              [48.59506269600007, -67.59059010199991],
              [48.59009850400008, -67.55974700299993],
              [48.569102410000085, -67.51767343499995],
              [48.56657962300005, -67.49529387799993],
              [48.582041863000086, -67.47478606599992],
              [48.605804884000065, -67.46087004999993],
              [48.62940514400009, -67.45191822699991],
              [49.01107832100007, -67.39446379999993],
              [49.06820722700007, -67.37712981599992],
              [49.094493035000085, -67.37273528399993],
              [49.121429884000065, -67.37167734199994],
              [49.17465254000007, -67.37704843499995],
              [49.18091881600009, -67.36825937299994],
              [49.19947350400008, -67.35686614399992],
              [49.20753014400009, -67.3493791649999],
              [49.198008660000085, -67.33806731599992],
              [49.20533287900008, -67.32529062299994],
              [49.21998131600009, -67.31373463299991],
              [49.233164910000085, -67.30632903399993],
              [49.25611412900008, -67.29843515399995],
              [49.328461134000065, -67.2888322899999],
              [49.324880405000044, -67.28118254999993],
              [49.30160566500007, -67.24667734199994],
              [49.289805535000085, -67.23788827899995],
              [49.31299889400009, -67.22234465899993],
              [49.343760613000086, -67.22177499799994],
              [49.37663821700005, -67.22576262799993],
              [49.405284050000034, -67.22332122199992],
              [49.349619988000086, -67.18238697699991],
              [49.25733483200008, -67.17351653399993],
              [49.08741295700008, -67.19410572699991],
              [49.11451256600009, -67.17148202899995],
              [49.09009850400008, -67.15667083099993],
              [49.06804446700005, -67.15081145599993],
              [49.04468834700003, -67.15203215899993],
              [48.73161868600005, -67.22079843499995],
              [48.64087975400008, -67.21892669099992],
              [48.584646030000044, -67.2092424459999],
              [48.531993035000085, -67.19247812299994],
              [48.47584069100009, -67.18808359199994],
              [48.44874108200008, -67.18173593499995],
              [48.394541863000086, -67.15927499799994],
              [48.370127800000034, -67.14299895599993],
              [48.35466556100005, -67.12151458099993],
              [48.34538821700005, -67.09563567499993],
              [48.338877800000034, -67.06487395599993],
              [48.34205162900008, -67.03622812299994],
              [48.36109459700003, -67.01637135199991],
              [48.58806399800005, -66.9372697899999],
              [49.059336785000085, -66.88486093499995],
              [49.111989780000044, -66.86736419099992],
              [49.16382897200003, -66.8381486959999],
              [49.21648196700005, -66.81894296699994],
              [49.27125084700003, -66.83074309699992],
              [49.287771030000044, -66.84246184699992],
              [49.32797285200007, -66.88347747199992],
              [49.336599155000044, -66.90292734199994],
              [49.33529707100007, -66.93914153399993],
              [49.34750410200007, -66.95468515399995],
              [49.25245201900009, -66.97234465899993],
              [49.15992272200003, -67.00090911299992],
              [49.21143639400009, -66.99928150799991],
              [49.22673587300005, -67.00156015399995],
              [49.24000084700003, -67.0095354149999],
              [49.26417076900009, -67.03427499799994],
              [49.277679884000065, -67.04241301899992],
              [49.311534050000034, -67.04615650799991],
              [49.48910566500007, -67.02288176899992],
              [49.793304884000065, -67.02809010199991],
              [49.826833530000044, -67.03728606599992],
              [49.85564212300005, -67.05348072699991],
              [49.882823113000086, -67.07822030999995],
              [49.89307701900003, -67.10662200299993],
              [49.87232506600009, -67.13404713299991],
              [49.83033287900008, -67.16611093499995],
              [49.79428144600007, -67.20973072699991],
              [49.78288821700005, -67.21843840899993],
              [49.66570071700005, -67.27841562299994],
              [49.69752037900008, -67.28850676899992],
              [49.733164910000085, -67.28639088299991],
              [49.76677493600005, -67.27459075299993],
              [49.79249108200008, -67.25514088299991],
              [49.82154381600009, -67.24098072699991],
              [49.90088951900003, -67.23626067499993],
              [49.934580925000034, -67.22535572699991],
              [49.94548587300005, -67.21526458099993],
              [49.969493035000085, -67.18613046699994],
              [49.98218834700003, -67.17376067499993],
              [49.99586022200003, -67.16545989399992],
              [50.009776238000086, -67.16090260199991],
              [50.024424675000034, -67.15911223799992],
              [50.07789147200003, -67.15976327899995],
              [50.09327233200008, -67.15471770599993],
              [50.111989780000044, -67.12639739399992],
              [50.12859134200005, -67.11858489399992],
              [50.14771569100009, -67.11532968499995],
              [50.164724155000044, -67.11467864399992],
              [50.20167076900003, -67.12070077899995],
              [50.30209394600007, -67.1618791649999],
              [50.40186608200008, -67.17099374799994],
              [50.47120201900003, -67.19524504999993],
              [50.585948113000086, -67.21640390399995],
              [50.60181725400008, -67.22177499799994],
              [50.62623131600009, -67.23650481599992],
              [50.64242597700007, -67.2419572899999],
              [50.661143425000034, -67.24358489399992],
              [50.720713738000086, -67.23821379999993],
              [50.694346550000034, -67.22234465899993],
              [50.64014733200008, -67.20745208099993],
              [50.61963951900003, -67.18474700299993],
              [50.64991295700008, -67.17766692499993],
              [50.682627800000034, -67.17652760199991],
              [50.74724368600005, -67.18303801899992],
              [50.76449629000007, -67.18767669099992],
              [50.81104576900003, -67.21111419099992],
              [50.82789147200003, -67.21453215899993],
              [50.881195509000065, -67.21624114399992],
              [50.81853274800005, -67.17782968499995],
              [50.85377037900008, -67.16415780999995],
              [50.89616946700005, -67.16130950299993],
              [50.97820071700005, -67.16814544099992],
              [50.96070397200003, -67.15691497199992],
              [50.94711347700007, -67.14592864399992],
              [50.94353274800005, -67.13241952899995],
              [50.955414259000065, -67.11402760199991],
              [50.92693118600005, -67.12029387799993],
              [50.89820397200003, -67.11541106599992],
              [50.84001712300005, -67.09685637799993],
              [50.692393425000034, -67.08171965899993],
              [50.655284050000034, -67.06462981599992],
              [50.637054884000065, -67.06161874799994],
              [50.60238691500007, -67.05974700299993],
              [50.58480879000007, -67.05608489399992],
              [50.556651238000086, -67.05364348799992],
              [50.459320509000065, -67.06878020599993],
              [50.473399285000085, -67.05982838299991],
              [50.47982832100007, -67.04941171699994],
              [50.481130405000044, -67.03655364399992],
              [50.47966556100005, -67.02117278399993],
              [50.48226972700007, -67.00725676899992],
              [50.492198113000086, -67.00066497199992],
              [50.52361087300005, -66.99488697699991],
              [50.45101972700007, -66.97869231599992],
              [50.427744988000086, -66.96257903399993],
              [50.44581139400003, -66.94011809699992],
              [50.49382571700005, -66.90203215899993],
              [50.512461785000085, -66.89226653399993],
              [50.52784264400003, -66.88876718499995],
              [50.53931725400008, -66.88746510199991],
              [50.54851321700005, -66.88339609199994],
              [50.56690514400003, -66.85808684699992],
              [50.57960045700008, -66.85051848799992],
              [50.761729363000086, -66.82105885199991],
              [50.78435306100005, -66.80982838299991],
              [50.82984459700003, -66.77467213299991],
              [50.775726759000065, -66.75481536299992],
              [50.76490319100009, -66.75514088299991],
              [50.744802280000044, -66.7673479149999],
              [50.73406009200005, -66.76775481599992],
              [50.706065300000034, -66.76067473799992],
              [50.674815300000034, -66.75847747199992],
              [50.61378014400003, -66.7619768209999],
              [50.58545983200008, -66.7678361959999],
              [50.537771030000044, -66.78630950299993],
              [50.510427280000044, -66.79225025799991],
              [50.50025475400008, -66.7907854149999],
              [50.469737175000034, -66.7756486959999],
              [50.454112175000034, -66.77255624799994],
              [50.34701582100007, -66.77499765399995],
              [50.286143425000034, -66.76897551899992],
              [50.23951256600009, -66.74309661299992],
              [50.22120201900003, -66.68613046699994],
              [50.21664472700007, -66.66057708099993],
              [50.196055535000085, -66.61101653399993],
              [50.191416863000086, -66.58652109199994],
              [50.19361412900008, -66.57048919099992],
              [50.19971764400003, -66.55828215899993],
              [50.22087649800005, -66.53484465899993],
              [50.227549675000034, -66.52223072699991],
              [50.234385613000086, -66.49032968499995],
              [50.240977410000085, -66.47535572699991],
              [50.32203209700003, -66.39381275799991],
              [50.424489780000044, -66.33782317499993],
              [50.53736412900008, -66.30388762799993],
              [50.79497317800008, -66.27992115649994],
              [51.05258222700007, -66.25595468499995],
              [51.103526238000086, -66.24236419099992],
              [51.15552819100009, -66.22226327899995],
              [51.18116295700008, -66.21575286299992],
              [51.20875084700003, -66.21355559699992],
              [51.323252800000034, -66.22795989399992],
              [51.352305535000085, -66.22177499799994],
              [51.368174675000034, -66.20427825299993],
              [51.38168379000007, -66.18230559699992],
              [51.40357506600009, -66.16220468499995],
              [51.47828209700003, -66.12053801899992],
              [51.61378014400003, -66.0940080709999],
              [51.772146030000044, -66.03720468499995],
              [52.221690300000034, -65.9729143209999],
              [52.53467858150006, -65.96750253699992],
              [52.847666863000086, -65.96209075299993],
              [53.278005405000044, -65.89999765399995],
              [53.40023847700007, -65.90195077899995],
              [53.73454837300005, -65.84587981599992],
              [53.79021243600005, -65.84539153399993],
              [53.95785566500007, -65.88437265399995],
              [54.01335696700005, -65.88974374799994],
              [54.24105879000007, -65.87639739399992],
              [54.71225019600007, -65.90365976349992],
              [55.18344160200007, -65.93092213299991],
              [55.61158287900008, -66.02792734199994],
              [55.75082441500007, -66.10784270599993],
              [55.770518425000034, -66.11565520599993],
              [55.79078209700003, -66.11907317499993],
              [55.84327233200008, -66.11687590899993],
              [55.861338738000086, -66.11980559699992],
              [55.844737175000034, -66.14910247199992],
              [55.871755405000044, -66.18132903399993],
              [55.915049675000034, -66.20907968499995],
              [55.947276238000086, -66.22478606599992],
              [56.036143425000034, -66.24700286299992],
              [56.05396569100009, -66.25701262799993],
              [56.10670006600009, -66.30038827899995],
              [56.12623131600009, -66.30974700299993],
              [56.14535566500007, -66.31552499799994],
              [56.16553795700008, -66.31804778399993],
              [56.18734785200007, -66.31715260199991],
              [56.21070397200003, -66.31991952899995],
              [56.21957441500007, -66.33196379999993],
              [56.22608483200008, -66.34929778399993],
              [56.24195397200003, -66.36809661299992],
              [56.26295006600009, -66.37997812299994],
              [56.30982506600009, -66.3986955709999],
              [56.332041863000086, -66.41155364399992],
              [56.37720787900008, -66.45281340899993],
              [56.399099155000044, -66.4626604149999],
              [56.40967858200008, -66.42831796699994],
              [56.424489780000044, -66.4079729149999],
              [56.447276238000086, -66.39714934699992],
              [56.51677493600005, -66.38795338299991],
              [56.80779056100005, -66.40545012799993],
              [57.207692905000044, -66.53118254999993],
              [57.23780358200008, -66.54745859199994],
              [57.256846550000034, -66.56161874799994],
              [57.276052280000044, -66.58123137799993],
              [57.28695722700007, -66.60369231599992],
              [57.28142337300005, -66.62639739399992],
              [57.24952233200008, -66.65341562299994],
              [57.248057488000086, -66.66497161299992],
              [57.28370201900003, -66.69296640399995],
              [57.287771030000044, -66.7014299459999],
              [57.28142337300005, -66.7087541649999],
              [57.26392662900008, -66.71550872199992],
              [57.24244225400008, -66.71892669099992],
              [57.014659050000034, -66.72926197699991],
              [57.00147545700008, -66.7268205709999],
              [56.96631920700008, -66.71087004999993],
              [56.95476321700005, -66.70842864399992],
              [56.79639733200008, -66.7146135399999],
              [56.74366295700008, -66.70940520599993],
              [56.62224368600005, -66.68132903399993],
              [56.565196160000085, -66.65243905999995],
              [56.56470787900008, -66.61288827899995],
              [56.531586134000065, -66.62037525799991],
              [56.514659050000034, -66.63298919099992],
              [56.50554446700005, -66.65390390399995],
              [56.49659264400003, -66.68572356599992],
              [56.37720787900008, -66.63201262799993],
              [56.344737175000034, -66.62444426899992],
              [56.277679884000065, -66.62037525799991],
              [56.24724368600005, -66.61207447699991],
              [56.20826256600009, -66.58749765399995],
              [56.193369988000086, -66.58294036299992],
              [56.17505944100009, -66.58171965899993],
              [56.13990319100009, -66.58367278399993],
              [56.05640709700003, -66.57390715899993],
              [56.024424675000034, -66.57545338299991],
              [55.99187259200005, -66.5857072899999],
              [56.07113691500007, -66.60035572699991],
              [56.087901238000086, -66.61101653399993],
              [56.08741295700008, -66.63290780999995],
              [56.06576582100007, -66.6467424459999],
              [56.01254316500007, -66.66090260199991],
              [56.08676191500007, -66.67652760199991],
              [56.12086022200003, -66.67717864399992],
              [56.13453209700003, -66.67962004999993],
              [56.15064537900008, -66.69085051899992],
              [56.15992272200003, -66.7033830709999],
              [56.17017662900008, -66.71103280999995],
              [56.208018425000034, -66.7014299459999],
              [56.22641035200007, -66.70086028399993],
              [56.35865319100009, -66.72323984199994],
              [56.41732832100007, -66.74309661299992],
              [56.47901451900003, -66.74138762799993],
              [56.50953209700003, -66.74382903399993],
              [56.48462975400008, -66.75847747199992],
              [56.35710696700005, -66.77556731599992],
              [56.37159264400003, -66.79697030999995],
              [56.38054446700005, -66.80608489399992],
              [56.38982181100005, -66.80787525799991],
              [56.40552819100009, -66.80429452899995],
              [56.444346550000034, -66.8049455709999],
              [56.51644941500007, -66.7907854149999],
              [56.54232832100007, -66.79168059699992],
              [56.39210045700008, -66.8322893209999],
              [56.46615644600007, -66.85849374799994],
              [56.50082441500007, -66.86150481599992],
              [56.61996504000007, -66.84823984199994],
              [56.65967858200008, -66.8513322899999],
              [56.69556725400008, -66.86256275799991],
              [56.65935306100005, -66.89031340899993],
              [56.70679772200003, -66.89967213299991],
              [56.68018639400003, -66.92034270599993],
              [56.658213738000086, -66.93328215899993],
              [56.63404381600009, -66.94036223799992],
              [56.60124759200005, -66.94345468499995],
              [56.43295332100007, -66.9279924459999],
              [56.417979363000086, -66.9235979149999],
              [56.40935306100005, -66.91668059699992],
              [56.40211022200003, -66.90829843499995],
              [56.39234459700003, -66.89950937299994],
              [56.36312910200007, -66.88396575299993],
              [56.33448326900003, -66.87623463299991],
              [56.27165774800005, -66.87566497199992],
              [56.32203209700003, -66.90886809699992],
              [56.29273522200003, -66.9294572899999],
              [56.194346550000034, -66.9338518209999],
              [56.15406334700003, -66.95183684699992],
              [56.27271569100009, -66.96502044099992],
              [56.30884850400008, -66.97747161299992],
              [56.29517662900008, -66.98064544099992],
              [56.28174889400003, -66.98528411299992],
              [56.25668379000007, -66.99863046699994],
              [56.342133009000065, -67.00107187299994],
              [56.367198113000086, -67.01018645599993],
              [56.28956139400003, -67.05282968499995],
              [56.20875084700003, -67.08294036299992],
              [55.855479363000086, -67.17034270599993],
              [55.76221764400003, -67.20761484199994],
              [55.73218834700003, -67.26360442499993],
              [56.15349368600005, -67.19605885199991],
              [56.143565300000034, -67.22958749799994],
              [56.08838951900003, -67.34840260199991],
              [56.092133009000065, -67.35808684699992],
              [56.10515384200005, -67.37444426899992],
              [56.11882571700005, -67.3869768209999],
              [56.13526451900003, -67.39592864399992],
              [56.170664910000085, -67.40894947699991],
              [56.17937259200005, -67.38128020599993],
              [56.19255618600005, -67.35759856599992],
              [56.209971550000034, -67.33668385199991],
              [56.262461785000085, -67.2946916649999],
              [56.29615319100009, -67.27605559699992],
              [56.30827884200005, -67.26718515399995],
              [56.32829837300005, -67.24260833099993],
              [56.33961022200003, -67.23202890399995],
              [56.44556725400008, -67.16472747199992],
              [56.55844160200007, -67.10979583099993],
              [56.68140709700003, -67.07415129999993],
              [56.838552280000044, -67.05706145599993],
              [56.851898634000065, -67.0588518209999],
              [56.86736087300005, -67.06454843499995],
              [56.884776238000086, -67.0681291649999],
              [56.89625084700003, -67.0622697899999],
              [56.906586134000065, -67.05339934699992],
              [56.92042076900003, -67.04778411299992],
              [56.96794681100005, -67.04615650799991],
              [57.27751712300005, -67.08489348799992],
              [57.34424889400003, -67.08416106599992],
              [57.35914147200003, -67.08782317499993],
              [57.308929884000065, -67.04257577899995],
              [57.34302819100009, -67.03386809699992],
              [57.37525475400008, -67.03004322699991],
              [57.493174675000034, -67.03443775799991],
              [57.50806725400008, -67.03183359199994],
              [57.52621504000007, -67.02288176899992],
              [57.54664147200003, -67.00269947699991],
              [57.56275475400008, -66.99423593499995],
              [57.59351647200003, -66.98992278399993],
              [57.63021894600007, -66.99358489399992],
              [57.66618899800005, -67.00261809699992],
              [57.72120201900003, -67.02361419099992],
              [57.82781009200005, -67.03337981599992],
              [57.84034264400003, -67.03801848799992],
              [57.86150149800005, -67.05608489399992],
              [57.87387129000007, -67.06064218499995],
              [57.957041863000086, -67.07431405999995],
              [57.97193444100009, -67.08131275799991],
              [57.99463951900003, -67.10198333099993],
              [58.00513756600009, -67.10833098799992],
              [58.02361087300005, -67.10947030999995],
              [58.07349694100009, -67.0940080709999],
              [58.123789910000085, -67.09392669099992],
              [58.13648522200003, -67.09840260199991],
              [58.146494988000086, -67.11028411299992],
              [58.15170332100007, -67.12590911299992],
              [58.14991295700008, -67.14120859199994],
              [58.13884524800005, -67.15203215899993],
              [58.071299675000034, -67.17791106599992],
              [58.038096550000034, -67.19605885199991],
              [58.020274285000085, -67.21892669099992],
              [58.046885613000086, -67.22503020599993],
              [58.06999759200005, -67.2204729149999],
              [58.270274285000085, -67.14804452899995],
              [58.42628014400003, -67.14861419099992],
              [58.420664910000085, -67.18678150799991],
              [58.45533287900008, -67.19491952899995],
              [58.68873131600009, -67.15699635199991],
              [58.87061608200008, -67.16513437299994],
              [58.91586347700007, -67.1775041649999],
              [59.04411868600005, -67.23691171699994],
              [59.093760613000086, -67.24472421699994],
              [59.045664910000085, -67.28850676899992],
              [59.019867384000065, -67.3049455709999],
              [58.988617384000065, -67.31015390399995],
              [58.722992384000065, -67.27483489399992],
              [58.58220462300005, -67.23211028399993],
              [58.548838738000086, -67.2302385399999],
              [58.56861412900008, -67.27467213299991],
              [58.593760613000086, -67.29851653399993],
              [58.67237389400003, -67.32586028399993],
              [58.67701256600009, -67.33049895599993],
              [58.67855879000007, -67.33733489399992],
              [58.68100019600007, -67.34303150799991],
              [58.68832441500007, -67.34433359199994],
              [58.72592207100007, -67.3381486959999],
              [58.757823113000086, -67.33684661299992],
              [58.793304884000065, -67.34124114399992],
              [58.93913821700005, -67.37623463299991],
              [59.051524285000085, -67.42864348799992],
              [59.09327233200008, -67.43670012799993],
              [59.126963738000086, -67.42498137799993],
              [59.12875410200007, -67.44654713299991],
              [59.11646569100009, -67.45907968499995],
              [59.096364780000044, -67.46502044099992],
              [59.03012129000007, -67.47144947699991],
              [59.009776238000086, -67.47730885199991],
              [58.98585045700008, -67.48739999799994],
              [59.02947024800005, -67.49041106599992],
              [59.038096550000034, -67.49374765399995],
              [59.05298912900008, -67.5061174459999],
              [59.06169681100005, -67.50847747199992],
              [59.208994988000086, -67.49814218499995],
              [59.250010613000086, -67.48430754999993],
              [59.26490319100009, -67.48430754999993],
              [59.29867597700007, -67.50164153399993],
              [59.41179446700005, -67.54420338299991],
              [59.480479363000086, -67.59465911299992],
              [59.51295006600009, -67.60637786299992],
              [59.54851321700005, -67.60515715899993],
              [59.59343509200005, -67.59433359199994],
              [59.54908287900008, -67.5622697899999],
              [59.50912519600007, -67.52434661299992],
              [59.526133660000085, -67.51458098799992],
              [59.541351759000065, -67.5134416649999],
              [59.574880405000044, -67.5217424459999],
              [59.59498131600009, -67.52337004999993],
              [59.61508222700007, -67.52076588299991],
              [59.655039910000085, -67.51083749799994],
              [59.64535566500007, -67.48601653399993],
              [59.64014733200008, -67.46111419099992],
              [59.645274285000085, -67.43873463299991],
              [59.666677280000044, -67.42156340899993],
              [59.64812259200005, -67.41594817499993],
              [59.64625084700003, -67.40618254999993],
              [59.65748131600009, -67.39723072699991],
              [59.67855879000007, -67.39413827899995],
              [59.916026238000086, -67.40048593499995],
              [60.09498131600009, -67.40536874799994],
              [60.234385613000086, -67.38176848799992],
              [60.328786655000044, -67.37712981599992],
              [60.39307701900003, -67.38388437299994],
              [60.46664472700007, -67.36980559699992],
              [60.47592207100007, -67.37216562299994],
              [60.49000084700003, -67.38567473799992],
              [60.49919681100005, -67.38884856599992],
              [60.61890709700003, -67.40056731599992],
              [60.65739993600005, -67.42009856599992],
              [60.67750084700003, -67.4275041649999],
              [60.74773196700005, -67.4431291649999],
              [60.793304884000065, -67.44353606599992],
              [60.82927493600005, -67.46200937299994],
              [60.85336347700007, -67.46965911299992],
              [60.87468509200005, -67.46949635199991],
              [60.894541863000086, -67.46599700299993],
              [60.914073113000086, -67.46477629999993],
              [60.955739780000044, -67.48121510199991],
              [60.97413170700008, -67.48284270599993],
              [60.992523634000065, -67.47722747199992],
              [61.01335696700005, -67.4651018209999],
              [61.018565300000034, -67.48381926899992],
              [61.033864780000044, -67.49114348799992],
              [61.074880405000044, -67.4919572899999],
              [61.142914259000065, -67.50457122199992],
              [61.167002800000034, -67.50530364399992],
              [61.16334069100003, -67.51970794099992],
              [61.15544681100005, -67.53085702899995],
              [61.14389082100007, -67.53818124799994],
              [61.129242384000065, -67.54143645599993],
              [61.14087975400008, -67.55087655999995],
              [61.15219160200007, -67.5564104149999],
              [61.16391035200007, -67.55779387799993],
              [61.17701256600003, -67.55437590899993],
              [61.18572024800005, -67.55575937299994],
              [61.21615644600007, -67.57952239399992],
              [61.243174675000034, -67.59050872199992],
              [61.27320397200003, -67.59319426899992],
              [61.608083530000044, -67.53964609199994],
              [61.86276289200006, -67.55095794099992],
              [62.11744225400008, -67.5622697899999],
              [62.14625084700003, -67.5681291649999],
              [62.201508009000065, -67.58611419099992],
              [62.23064212300005, -67.58953215899993],
              [62.32943769600007, -67.58928801899992],
              [62.35726972700007, -67.59807708099993],
              [62.41065514400003, -67.6252580709999],
              [62.492198113000086, -67.63355885199991],
              [62.61736087300005, -67.66008879999993],
              [62.66716556100005, -67.65300872199992],
              [62.68897545700008, -67.64723072699991],
              [62.77084394600007, -67.64299895599993],
              [63.08716881600003, -67.53850676899992],
              [63.11264082100007, -67.53378671699994],
              [63.38176517000005, -67.51856861799993],
              [63.65088951900003, -67.50335051899992],
              [63.84327233200008, -67.52743905999995],
              [63.96062259200005, -67.52703215899993],
              [64.42546634200005, -67.59050872199992],
              [64.47657311300009, -67.60784270599993],
              [64.52759850400008, -67.61541106599992],
              [64.55323326900003, -67.6228166649999],
              [64.56544030000003, -67.62468840899993],
              [64.59115644600007, -67.61980559699992],
              [64.60385175900007, -67.61972421699994],
              [64.62134850400008, -67.62420012799993],
              [64.65162194100003, -67.63681405999995],
              [64.72095787900008, -67.65309010199991],
              [65.12175540500007, -67.68085702919991],
              [65.52255293100008, -67.70862395639992],
              [65.92335045700007, -67.73639088359991],
              [66.32414798300007, -67.76415781079992],
              [66.72494550900007, -67.79192473799992],
              [66.73658287900008, -67.78980885199991],
              [66.75961347700007, -67.77654387799993],
              [66.77344811300009, -67.77312590899993],
              [66.86426842500003, -67.78639088299991],
              [66.88648522200003, -67.78460051899992],
              [66.94157962300005, -67.7673479149999],
              [67.00554446700005, -67.75888437299994],
              [67.12891686300009, -67.75904713299991],
              [67.28581790500004, -67.78679778399993],
              [67.30014082100007, -67.79208749799994],
              [67.32642662900008, -67.80632903399993],
              [67.33961022200003, -67.8108049459999],
              [67.70521080800003, -67.8293596334999],
              [68.07081139400003, -67.8479143209999],
              [68.18165123800009, -67.87656015399995],
              [68.37671959700003, -67.89519622199992],
              [68.71062259200005, -67.87346770599993],
              [68.77711022200003, -67.88600025799991],
              [69.10678144600007, -67.84628671699994],
              [69.15414472700007, -67.83261484199994],
              [69.18995201900003, -67.81113046699994],
              [69.19410241000008, -67.80396900799991],
              [69.20297285200007, -67.7815080709999],
              [69.20769290500004, -67.77304452899995],
              [69.21697024800005, -67.76458098799992],
              [69.22901451900003, -67.75855885199991],
              [69.30258222700007, -67.7360979149999],
              [69.35238691500007, -67.73007577899995],
              [69.55518639400003, -67.73845794099992],
              [69.61101321700005, -67.75058359199994],
              [69.63900800900007, -67.76327890399995],
              [69.64861087300005, -67.77996184699992],
              [69.64625084700003, -67.80413176899992],
              [69.65040123800009, -67.8303361959999],
              [69.66228274800005, -67.85247161299992],
              [69.68295332100007, -67.86443450299993],
              [69.63233483200008, -67.93857187299994],
              [69.60108483200008, -68.01873137799993],
              [69.59546959700003, -68.04306405999995],
              [69.60181725400008, -68.06991952899995],
              [69.63477623800009, -68.12216562299994],
              [69.81364993600005, -68.28525155999995],
              [69.98747806100005, -68.37167734199994],
              [69.99773196700005, -68.37965260199991],
              [70.00220787900008, -68.3889299459999],
              [70.00912519600007, -68.39804452899995],
              [70.02662194100003, -68.40536874799994],
              [70.03825931100005, -68.41334400799991],
              [70.04883873800009, -68.42815520599993],
              [70.06592858200008, -68.45810312299994],
              [70.08936608200008, -68.48300546699994],
              [70.11540774800005, -68.49358489399992],
              [70.17969811300009, -68.49480559699992],
              [70.12354576900003, -68.50888437299994],
              [70.10670006600003, -68.51653411299992],
              [70.09034264400003, -68.52117278399993],
              [70.05404707100007, -68.5197893209999],
              [70.03891035200007, -68.52532317499993],
              [70.00806725400008, -68.5451799459999],
              [69.97022545700008, -68.56170012799993],
              [69.93051191500007, -68.57390715899993],
              [69.89421634200005, -68.58066171699994],
              [69.86182701900003, -68.58098723799992],
              [69.79379316500007, -68.57382577899995],
              [69.66325931100005, -68.57887135199991],
              [69.63160241000008, -68.58863697699991],
              [69.65170332100007, -68.59587981599992],
              [69.67221113400007, -68.60027434699992],
              [69.60035241000008, -68.61012135199991],
              [69.57309004000007, -68.62200286299992],
              [69.62387129000007, -68.63160572699991],
              [69.67530358200008, -68.63347747199992],
              [69.65170332100007, -68.65113697699991],
              [69.62631269600007, -68.70232512799993],
              [69.60466556100005, -68.71884530999995],
              [69.62175540500004, -68.72039153399993],
              [69.63835696700005, -68.71941497199992],
              [69.67204837300005, -68.71363697699991],
              [69.62110436300009, -68.73552825299993],
              [69.43604576900003, -68.78240325299993],
              [69.36133873800009, -68.81308359199994],
              [69.30632571700005, -68.82138437299994],
              [69.28126061300009, -68.83131275799991],
              [69.27116946700005, -68.85068124799994],
              [69.30827884200005, -68.84970468499995],
              [69.29200280000003, -68.86541106599992],
              [69.32585696700005, -68.87004973799992],
              [69.38591556100005, -68.88494231599992],
              [69.71802819100003, -68.86239999799994],
              [69.85759524800005, -68.87249114399992],
              [69.82545006600003, -68.89495208099993],
              [69.71208743600005, -68.93808359199994],
              [69.74024498800009, -68.94280364399992],
              [69.76905358200008, -68.94296640399995],
              [69.71957441500007, -68.9670549459999],
              [69.66098066500007, -68.98430754999993],
              [69.30388431100005, -69.04729583099993],
              [69.32007897200003, -69.05282968499995],
              [69.37077884200005, -69.05706145599993],
              [69.35954837300005, -69.06536223799992],
              [69.34978274800005, -69.07537200299993],
              [69.34180748800009, -69.08700937299994],
              [69.33570397200003, -69.09970468499995],
              [69.38656660200007, -69.10198333099993],
              [69.72641035200007, -69.1696916649999],
              [69.76010175900007, -69.19784921699994],
              [69.76156660200007, -69.2463518209999],
              [69.74008222700007, -69.29607512799993],
              [69.70557701900003, -69.32732512799993],
              [69.65674889400003, -69.34303150799991],
              [69.60450280000003, -69.35198333099993],
              [69.55152428500008, -69.35312265399995],
              [69.39730879000007, -69.32146575299993],
              [69.34376061300009, -69.32187265399995],
              [69.25953209700003, -69.36793385199991],
              [69.21387780000003, -69.36736419099992],
              [68.97055097700007, -69.30925872199992],
              [68.92066491000008, -69.30901458099993],
              [68.89437910200007, -69.31560637799993],
              [68.87256920700008, -69.32740650799991],
              [68.83155358200008, -69.36101653399993],
              [68.81120853000004, -69.37363046699994],
              [68.78907311300009, -69.38079192499993],
              [68.74203535200007, -69.38925546699994],
              [68.77849368600005, -69.40829843499995],
              [68.86166425900007, -69.4338518209999],
              [68.89771569100003, -69.45468515399995],
              [68.74708092500003, -69.4924455709999],
              [68.73340905000003, -69.50261809699992],
              [68.73096764400003, -69.52027760199991],
              [68.73340905000003, -69.55087655999995],
              [68.88795006600003, -69.54355234199994],
              [69.04615319100003, -69.55730559699992],
              [69.35523522200003, -69.61712004999993],
              [69.30591881600003, -69.6584611959999],
              [69.25652103000004, -69.68816497199992],
              [69.20167076900003, -69.70566171699994],
              [69.13640384200005, -69.71054452899995],
              [69.00066165500004, -69.70427825299993],
              [68.93002363400007, -69.71257903399993],
              [68.88266035200007, -69.74089934699992],
              [69.02662194100003, -69.77353280999995],
              [69.17400149800005, -69.78622812299994],
              [69.20687910200007, -69.79794687299994],
              [69.20484459700003, -69.82317473799992],
              [69.18246504000007, -69.85222747199992],
              [69.15528405000003, -69.87566497199992],
              [69.02222741000008, -69.94850025799991],
              [68.89258873800009, -69.99382903399993],
              [68.75806725400008, -70.01832447699991],
              [68.60629316500007, -70.02695077899995],
              [68.57260175900007, -70.02092864399992],
              [68.52857506600003, -70.0022111959999],
              [68.49642988400007, -69.97820403399993],
              [68.49952233200008, -69.95671965899993],
              [68.36150149800005, -69.89609140399995],
              [68.31137129000007, -69.86142343499995],
              [68.28956139400003, -69.85222747199992],
              [68.28077233200008, -69.84636809699992],
              [68.27084394600007, -69.83473072699991],
              [68.22950280000003, -69.77076588299991],
              [68.21762129000007, -69.74553801899992],
              [68.20240319100003, -69.72600676899992],
              [68.17701256600003, -69.71965911299992],
              [68.14763431100005, -69.72503020599993],
              [68.13526451900003, -69.73552825299993],
              [68.13249759200005, -69.75335051899992],
              [68.13119550900007, -69.78004322699991],
              [68.12842858200008, -69.79648202899995],
              [68.12525475400008, -69.80803801899992],
              [68.12378991000008, -69.8200822899999],
              [68.12623131600003, -69.83782317499993],
              [68.12338300900007, -69.84856536299992],
              [68.11255944100003, -69.85564544099992],
              [68.09937584700003, -69.86142343499995],
              [68.05713951900003, -69.89373137799993],
              [68.00904381600003, -69.90894947699991],
              [67.91049238400007, -69.92392343499995],
              [67.91358483200008, -69.97893645599993],
              [67.86540774800005, -70.00204843499995],
              [67.60547936300009, -70.01482512799993],
              [67.57129967500003, -70.02450937299994],
              [67.55836022200003, -70.03964609199994],
              [67.55925540500004, -70.06292083099993],
              [67.56617272200003, -70.09661223799992],
              [67.53793379000007, -70.10263437299994],
              [67.50635826900003, -70.11589934699992],
              [67.48194420700008, -70.13640715899993],
              [67.47584069100003, -70.16423919099992],
              [67.48047936300009, -70.18873463299991],
              [67.47868899800005, -70.20175546699994],
              [67.46745853000004, -70.20826588299991],
              [67.22461998800009, -70.25261809699992],
              [67.21794681100005, -70.26279062299994],
              [67.21697024800005, -70.28069426899992],
              [67.22095787900008, -70.29762135199991],
              [67.22917728000004, -70.3044572899999],
              [67.68067467500003, -70.27312590899993],
              [67.71273847700007, -70.27548593499995],
              [67.74586022200003, -70.28704192499993],
              [67.72885175900007, -70.30006275799991],
              [67.65788821700005, -70.32333749799994],
              [67.67790774800005, -70.34579843499995],
              [67.70020592500003, -70.34929778399993],
              [67.72461998800009, -70.34823984199994],
              [67.75025475400008, -70.35670338299991],
              [67.75456790500004, -70.36589934699992],
              [67.75668379000007, -70.37981536299992],
              [67.76246178500008, -70.39251067499993],
              [67.77767988400007, -70.3982072899999],
              [67.87037194100003, -70.39169687299994],
              [67.87623131600003, -70.39714934699992],
              [67.88021894600007, -70.4060197899999],
              [67.88941491000008, -70.41676197699991],
              [67.90796959700003, -70.4318986959999],
              [67.91716556100005, -70.43743254999993],
              [67.96094811300009, -70.45208098799992],
              [67.97608483200008, -70.45419687299994],
              [67.99236087300005, -70.45378997199992],
              [68.00831139400003, -70.4494768209999],
              [68.02165774800005, -70.44378020599993],
              [68.03467858200008, -70.44085051899992],
              [68.07667076900003, -70.45354583099993],
              [68.09978274800005, -70.45175546699994],
              [68.14942467500003, -70.4338518209999],
              [68.38689212300005, -70.40154387799993],
              [68.42212975400008, -70.40195077899995],
              [68.44385826900003, -70.41228606599992],
              [68.48698978000004, -70.45232512799993],
              [68.51059004000007, -70.46575286299992],
              [68.53630618600005, -70.47234465899993],
              [68.56267337300005, -70.4724260399999],
              [68.58838951900003, -70.46697356599992],
              [68.62045332100007, -70.45240650799991],
              [68.63257897200003, -70.44882577899995],
              [68.63965905000003, -70.44036223799992],
              [68.65088951900003, -70.38860442499993],
              [68.68799889400003, -70.35369231599992],
              [68.74838300900007, -70.33440520599993],
              [68.92351321700005, -70.30462004999993],
              [69.14633222700007, -70.3088518209999],
              [69.16797936300009, -70.31658294099992],
              [69.24838300900007, -70.40691497199992],
              [69.25749759200005, -70.43157317499993],
              [69.25652103000004, -70.46111419099992],
              [69.22925866000008, -70.56389739399992],
              [69.21290123800009, -70.67180754999993],
              [69.20541425900007, -70.6931291649999],
              [69.19214928500008, -70.71087004999993],
              [69.10385175900007, -70.7673479149999],
              [69.07927493600005, -70.77727629999993],
              [69.09978274800005, -70.7932268209999],
              [69.09156334700003, -70.81210702899995],
              [69.02906334700003, -70.8557268209999],
              [69.01758873800009, -70.87371184699992],
              [69.01628665500004, -70.89446379999993],
              [69.02662194100003, -70.91855234199994],
              [69.00766035200007, -70.94207122199992],
              [68.85434004000007, -71.02483489399992],
              [68.86410566500007, -71.03004322699991],
              [68.87452233200008, -71.03378671699994],
              [68.88526451900003, -71.03582122199992],
              [68.89649498800009, -71.03622812299994],
              [68.80990644600007, -71.07968515399995],
              [68.58741295700008, -71.14950937299994],
              [68.56950931100005, -71.16155364399992],
              [68.54786217500003, -71.18092213299991],
              [68.59050540500004, -71.19817473799992],
              [68.60320071700005, -71.20037200299993],
              [68.65308678500008, -71.19980234199994],
              [68.66968834700003, -71.20370859199994],
              [68.52230879000007, -71.24773528399993],
              [68.33912194100003, -71.25750090899993],
              [68.31910241000008, -71.26441822699991],
              [68.31234785200007, -71.28004322699991],
              [68.32309004000007, -71.30917734199994],
              [68.25945071700005, -71.32708098799992],
              [68.05502363400007, -71.35466887799993],
              [68.06226647200003, -71.35654062299994],
              [68.08326256600003, -71.36541106599992],
              [68.06755618600005, -71.37965260199991],
              [68.03101647200003, -71.40048593499995],
              [67.92318769600007, -71.48056405999995],
              [67.86215254000007, -71.50937265399995],
              [67.84400475400008, -71.52214934699992],
              [67.83253014400003, -71.53850676899992],
              [67.83570397200003, -71.55185312299994],
              [67.86011803500008, -71.55575937299994],
              [67.85401451900003, -71.56853606599992],
              [67.84457441500007, -71.57830169099992],
              [67.83253014400003, -71.58538176899992],
              [67.81918379000007, -71.59042734199994],
              [67.83619225400008, -71.59929778399993],
              [67.85482832100007, -71.60295989399992],
              [67.89421634200005, -71.60369231599992],
              [67.88917076900003, -71.61980559699992],
              [67.87907962300005, -71.63005950299993],
              [67.86475670700008, -71.63551197699991],
              [67.84799238400007, -71.63665129999993],
              [67.87631269600007, -71.64934661299992],
              [67.88233483200008, -71.66529713299991],
              [67.87061608200008, -71.68222421699994],
              [67.84522545700008, -71.6975236959999],
              [67.78882897200003, -71.71591562299994],
              [67.78199303500008, -71.72087981599992],
              [67.77279707100007, -71.73967864399992],
              [67.76295006600003, -71.74814218499995],
              [67.70932050900007, -71.76751067499993],
              [67.53337649800005, -71.79745859199994],
              [67.54786217500003, -71.81568775799991],
              [67.56625410200007, -71.82415129999993],
              [67.61117597700007, -71.82683684699992],
              [67.47266686300009, -71.87232838299991],
              [67.44906660200007, -71.89592864399992],
              [67.47331790500004, -71.90496184699992],
              [67.51002037900008, -71.93629322699991],
              [67.53191165500004, -71.94548919099992],
              [67.51685631600003, -71.95574309699992],
              [67.51303144600007, -71.96697356599992],
              [67.51246178500008, -71.97926197699991],
              [67.50700931100005, -71.99334075299993],
              [67.49675540500004, -72.0036760399999],
              [67.48389733200008, -72.01091887799993],
              [67.45622806100005, -72.02117278399993],
              [67.44760175900007, -72.02727629999993],
              [67.43482506600003, -72.0451799459999],
              [67.42652428500008, -72.05193450299993],
              [67.39869225400008, -72.06373463299991],
              [67.36988366000008, -72.07195403399993],
              [67.28386478000004, -72.07170989399992],
              [67.26221764400003, -72.08123137799993],
              [67.25196373800009, -72.10711028399993],
              [67.27198326900003, -72.12029387799993],
              [67.33179772200003, -72.12908294099992],
              [67.32699629000007, -72.13958098799992],
              [67.32683353000004, -72.14837004999993],
              [67.32984459700003, -72.1565080709999],
              [67.33570397200003, -72.16529713299991],
              [67.33716881600003, -72.17262135199991],
              [67.33301842500003, -72.18027109199994],
              [67.32129967500003, -72.19524504999993],
              [67.31560306100005, -72.21624114399992],
              [67.31519616000008, -72.26384856599992],
              [67.30494225400008, -72.30331796699994],
              [67.30860436300009, -72.31072356599992],
              [67.31381269600007, -72.31707122199992],
              [67.31511478000004, -72.3278947899999],
              [67.31039472700007, -72.34172942499993],
              [67.30274498800009, -72.35491301899992],
              [67.29314212300005, -72.36712004999993],
              [67.22917728000004, -72.42148202899995],
              [67.21322675900007, -72.43938567499993],
              [67.23064212300005, -72.45029062299994],
              [67.21509850400008, -72.4607072899999],
              [67.20240319100003, -72.47380950299993],
              [67.19312584700003, -72.48902760199991],
              [67.18002363400007, -72.52613697699991],
              [67.17188561300009, -72.53915780999995],
              [67.13200931100005, -72.57691822699991],
              [67.08383222700007, -72.63404713299991],
              [67.08521569100003, -72.6462541649999],
              [67.09131920700008, -72.65943775799991],
              [67.09034264400003, -72.68027109199994],
              [67.07878665500004, -72.71965911299992],
              [67.07081139400003, -72.73772551899992],
              [67.04802493600005, -72.7732072899999],
              [67.03248131600003, -72.83855559699992],
              [66.99976647200003, -72.90349700299993],
              [66.97738691500007, -72.92644622199992],
              [66.94239342500003, -72.94784921699994],
              [66.86109459700003, -72.97576262799993],
              [66.69418379000007, -72.99814218499995],
              [66.55730228000004, -73.03655364399992],
              [66.54232832100007, -73.04338958099993],
              [66.50049889400003, -73.08025481599992],
              [66.48292076900003, -73.09050872199992],
              [66.34603925900007, -73.12900155999995],
              [66.32593834700003, -73.13144296699994],
              [66.33676191500007, -73.13567473799992],
              [66.34603925900007, -73.14120859199994],
              [66.35425866000008, -73.14812590899993],
              [66.36198978000004, -73.15634530999995],
              [66.36931399800005, -73.16765715899993],
              [66.37989342500003, -73.19296640399995],
              [66.38542728000004, -73.20183684699992],
              [66.40593509200005, -73.21542734199994],
              [66.43043053500008, -73.22039153399993],
              [66.55836022200003, -73.23154062299994],
              [66.58448326900003, -73.23056405999995],
              [66.64112389400003, -73.22014739399992],
              [66.65349368600005, -73.22161223799992],
              [66.66439863400007, -73.22812265399995],
              [66.67505944100003, -73.2360979149999],
              [66.68653405000003, -73.24187590899993],
              [66.73389733200008, -73.24472421699994],
              [66.91814212300005, -73.19768645599993],
              [66.94613691500007, -73.19670989399992],
              [66.97339928500008, -73.20134856599992],
              [67.00001061300009, -73.21282317499993],
              [67.02295983200008, -73.21754322699991],
              [67.05005944100003, -73.21331145599993],
              [67.10059655000003, -73.19784921699994],
              [67.10181725400008, -73.2243791649999],
              [67.07886803500008, -73.2439104149999],
              [67.01644941500007, -73.27092864399992],
              [67.04997806100005, -73.28460051899992],
              [67.08765709700003, -73.28329843499995],
              [67.16325931100005, -73.2658830709999],
              [67.16570071700005, -73.30169036299992],
              [67.22315514400003, -73.31243254999993],
              [67.34197024800005, -73.30234140399995],
              [67.82178795700008, -73.18377044099992],
              [67.87696373800009, -73.17913176899992],
              [67.90105228000004, -73.1701799459999],
              [67.93165123800009, -73.15439218499995],
              [67.95915774800005, -73.14657968499995],
              [67.98796634200005, -73.14462655999995],
              [68.02230879000007, -73.1467424459999],
              [68.02857506600003, -73.11598072699991],
              [68.04493248800009, -73.08562590899993],
              [68.05567467500003, -73.05706145599993],
              [68.04428144600007, -73.03142669099992],
              [68.08985436300009, -73.01384856599992],
              [68.10279381600003, -73.00058359199994],
              [68.11207116000008, -72.9763322899999],
              [68.11736087300005, -72.95273202899995],
              [68.11500084700003, -72.9436174459999],
              [68.10767662900008, -72.92913176899992],
              [68.10010826900003, -72.9201799459999],
              [68.08228600400008, -72.90496184699992],
              [68.07488040500004, -72.87623463299991],
              [68.05437259200005, -72.86581796699994],
              [67.99968509200005, -72.8557268209999],
              [67.97584069100003, -72.84490325299993],
              [67.95972741000008, -72.82732512799993],
              [67.95362389400003, -72.80510833099993],
              [67.96908613400007, -72.75318775799991],
              [67.96070397200003, -72.73919036299992],
              [67.94157962300005, -72.7282854149999],
              [67.91863040500004, -72.7111955709999],
              [67.92107181100005, -72.69304778399993],
              [67.94800866000008, -72.6740861959999],
              [68.01482181100005, -72.64666106599992],
              [68.03158613400007, -72.63103606599992],
              [68.04118899800005, -72.62444426899992],
              [68.05469811300009, -72.62021249799994],
              [68.08350670700008, -72.61589934699992],
              [68.12354576900003, -72.60222747199992],
              [68.20191491000008, -72.58928801899992],
              [68.19564863400007, -72.58668385199991],
              [68.17823326900003, -72.57675546699994],
              [68.33277428500008, -72.50750090899993],
              [68.41358483200008, -72.48162200299993],
              [68.49431399800005, -72.4748674459999],
              [68.62183678500008, -72.4821916649999],
              [68.70850670700008, -72.49814218499995],
              [68.75228925900007, -72.49358489399992],
              [69.04216556100005, -72.42034270599993],
              [69.08383222700007, -72.4162736959999],
              [69.15503991000008, -72.42595794099992],
              [69.34717858200008, -72.41643645599993],
              [69.51514733200008, -72.4318986959999],
              [69.50831139400003, -72.44150155999995],
              [69.50017337300005, -72.44988372199992],
              [69.49089603000004, -72.45696379999993],
              [69.48064212300005, -72.46298593499995],
              [69.51758873800009, -72.46949635199991],
              [69.55925540500004, -72.46396249799994],
              [69.59913170700008, -72.44980234199994],
              [69.63184655000003, -72.43075937299994],
              [69.58985436300009, -72.39714934699992],
              [69.60914147200003, -72.36988697699991],
              [69.62029056100005, -72.3596330709999],
              [69.63656660200007, -72.35556405999995],
              [69.63013756600003, -72.35361093499995],
              [69.61744225400008, -72.34685637799993],
              [69.61101321700005, -72.34441497199992],
              [69.63868248800009, -72.32073333099993],
              [69.66879316500007, -72.30315520599993],
              [69.70232181100005, -72.29062265399995],
              [69.73812910200007, -72.28199635199991],
              [69.78272545700008, -72.27841562299994],
              [69.79737389400003, -72.27548593499995],
              [69.84457441500007, -72.25481536299992],
              [69.86247806100005, -72.2522111959999],
              [69.93091881600003, -72.26555754999993],
              [69.95045006600003, -72.2580705709999],
              [69.94019616000008, -72.21982187299994],
              [69.91602623800009, -72.19988372199992],
              [69.87916100400008, -72.19304778399993],
              [69.80494225400008, -72.18767669099992],
              [69.81983483200008, -72.15618254999993],
              [69.83529707100007, -72.13404713299991],
              [69.85694420700008, -72.11931731599992],
              [69.89039147200003, -72.10979583099993],
              [69.90796959700003, -72.11028411299992],
              [69.91700280000003, -72.11443450299993],
              [69.92383873800009, -72.11296965899993],
              [69.94646243600005, -72.08074309699992],
              [69.95411217500003, -72.07724374799994],
              [69.96404056100005, -72.07878997199992],
              [70.17204837300005, -72.06259530999995],
              [70.27003014400003, -72.0720354149999],
              [70.36475670700008, -72.05462004999993],
              [70.49708092500003, -72.05234140399995],
              [70.53003991000008, -72.04794687299994],
              [70.65455162900008, -71.99537525799991],
              [70.70020592500003, -71.95956796699994],
              [70.72950280000003, -71.94605885199991],
              [70.72315514400003, -71.94101327899995],
              [70.71176191500007, -71.92839934699992],
              [70.70541425900007, -71.92310963299991],
              [70.71241295700008, -71.92066822699991],
              [70.72624759200005, -71.91399504999993],
              [70.73340905000003, -71.91204192499993],
              [70.71111087300005, -71.90618254999993],
              [70.64307701900003, -71.90536874799994],
              [70.62859134200005, -71.9021135399999],
              [70.59050540500004, -71.88095468499995],
              [70.56690514400003, -71.87460702899995],
              [70.44239342500003, -71.86223723799992],
              [70.43287194100003, -71.85637786299992],
              [70.43246504000007, -71.83896249799994],
              [70.44695071700005, -71.83017343499995],
              [70.46664472700007, -71.82724374799994],
              [70.68726647200003, -71.83163827899995],
              [70.84913170700008, -71.80348072699991],
              [70.88054446700005, -71.79314544099992],
              [70.97120201900003, -71.75139739399992],
              [71.03630618600005, -71.7463518209999],
              [71.12110436300009, -71.73056405999995],
              [71.14966881600003, -71.73544687299994],
              [71.18279056100005, -71.75269947699991],
              [71.21241295700008, -71.75383879999993],
              [71.27816816500007, -71.7282854149999],
              [71.25025475400008, -71.7185197899999],
              [71.13461347700007, -71.6975236959999],
              [71.08204186300009, -71.67791106599992],
              [71.05347741000008, -71.67099374799994],
              [71.06576582100007, -71.6599260399999],
              [71.06983483200008, -71.64706796699994],
              [71.07203209700003, -71.6350236959999],
              [71.07789147200003, -71.6272111959999],
              [71.09546959700003, -71.6213518209999],
              [71.11011803500008, -71.62175872199992],
              [71.14258873800009, -71.6272111959999],
              [71.16211998800009, -71.6272111959999],
              [71.17644290500004, -71.62468840899993],
              [71.18995201900003, -71.61882903399993],
              [71.20671634200005, -71.60849374799994],
              [71.21900475400008, -71.60751718499995],
              [71.41049238400007, -71.63933684699992],
              [71.44304446700005, -71.63665129999993],
              [71.53980553500008, -71.61028411299992],
              [71.41374759200005, -71.56853606599992],
              [71.40007571700005, -71.56194426899992],
              [71.38209069100003, -71.5446916649999],
              [71.36817467500003, -71.53964609199994],
              [71.31267337300005, -71.5334611959999],
              [71.18043053500008, -71.49228280999995],
              [71.15951582100007, -71.47258879999993],
              [71.15821373800009, -71.45614999799994],
              [71.16700280000003, -71.44719817499993],
              [71.19947350400008, -71.43352629999993],
              [71.21363366000008, -71.42205169099992],
              [71.23698978000004, -71.39641692499993],
              [71.25342858200008, -71.38795338299991],
              [71.22437584700003, -71.3650041649999],
              [71.21273847700007, -71.3518205709999],
              [71.20248457100007, -71.33505624799994],
              [71.22885175900007, -71.33001067499993],
              [71.24781334700003, -71.32350025799991],
              [71.26417076900003, -71.3122697899999],
              [71.28370201900003, -71.29363372199992],
              [71.30062910200007, -71.28630950299993],
              [71.43555748800009, -71.27695077899995],
              [71.49382571700005, -71.25318775799991],
              [71.51189212300005, -71.24846770599993],
              [71.53589928500008, -71.24553801899992],
              [71.52605228000004, -71.2268205709999],
              [71.53345787900008, -71.22454192499993],
              [71.54818769600007, -71.21770598799992],
              [71.55583743600005, -71.21591562299994],
              [71.53386478000004, -71.20435963299991],
              [71.50953209700003, -71.2014299459999],
              [71.42945397200003, -71.20037200299993],
              [71.37037194100003, -71.19158294099992],
              [71.34156334700003, -71.18206145599993],
              [71.34896894600007, -71.16676197699991],
              [71.36068769600007, -71.15699635199991],
              [71.37549889400003, -71.15195077899995],
              [71.39234459700003, -71.15081145599993],
              [71.39519290500004, -71.11809661299992],
              [71.54175866000008, -70.96013762799993],
              [71.58383222700007, -70.95110442499993],
              [71.63103274800005, -70.95582447699991],
              [71.68604576900003, -70.95370859199994],
              [71.65235436300009, -70.91220468499995],
              [71.66732832100007, -70.90935637799993],
              [71.69809004000007, -70.9084611959999],
              [71.70573978000004, -70.9021135399999],
              [71.71436608200008, -70.89055754999993],
              [71.73047936300009, -70.88103606599992],
              [71.74887129000007, -70.87493254999993],
              [71.79932701900003, -70.87656015399995],
              [71.82764733200008, -70.86679452899995],
              [71.84815514400003, -70.84465911299992],
              [71.85938561300003, -70.80966562299994],
              [71.78126061300003, -70.79998137799993],
              [71.76758873800009, -70.79550546699994],
              [71.74170983200008, -70.77890390399995],
              [71.72681725400008, -70.77402109199994],
              [71.79623457100007, -70.71640390399995],
              [71.82154381600003, -70.70419687299994],
              [71.85035241000008, -70.69850025799991],
              [71.91114342500003, -70.69451262799993],
              [71.94011478000004, -70.68873463299991],
              [71.95069420700008, -70.68377044099992],
              [71.97071373800003, -70.67131926899992],
              [71.98324629000007, -70.6662736959999],
              [71.99952233200008, -70.66269296699994],
              [72.01343834700003, -70.66130950299993],
              [72.04371178500008, -70.66448333099993],
              [72.07292728000004, -70.6735979149999],
              [72.12525475400008, -70.69768645599993],
              [72.15552819100003, -70.7048479149999],
              [72.14844811300003, -70.66741301899992],
              [72.19223066500007, -70.65292734199994],
              [72.25277754000007, -70.65553150799991],
              [72.29607181100005, -70.66985442499993],
              [72.34595787900008, -70.67546965899993],
              [72.40251712300005, -70.64609140399995],
              [72.44109134200005, -70.6037736959999],
              [72.43734785200007, -70.5700822899999],
              [72.45101972700007, -70.56462981599992],
              [72.46558678500008, -70.56096770599993],
              [72.49496504000007, -70.55738697699991],
              [72.47738691500007, -70.54631926899992],
              [72.61207116000008, -70.51165129999993],
              [72.61882571700005, -70.50595468499995],
              [72.62232506600003, -70.48552825299993],
              [72.62647545700008, -70.47730885199991],
              [72.64576256600003, -70.46754322699991],
              [72.67058353000004, -70.46396249799994],
              [72.69564863400007, -70.46445077899995],
              [72.74268639400003, -70.47128671699994],
              [72.76547285200007, -70.46917083099993],
              [72.85279381600003, -70.44475676899992],
              [72.86963951900003, -70.4333635399999],
              [72.86622155000003, -70.41594817499993],
              [72.85222415500004, -70.39788176899992],
              [72.84400475400008, -70.38941822699991],
              [72.82154381600003, -70.37883879999993],
              [72.81812584700003, -70.37167734199994],
              [72.81755618600005, -70.36174895599993],
              [72.81283613400007, -70.34823984199994],
              [72.78003991000008, -70.31129322699991],
              [72.69434655000003, -70.26327890399995],
              [72.65642337300005, -70.22975025799991],
              [72.62745201900003, -70.19459400799991],
              [72.62566165500004, -70.17913176899992],
              [72.63949629000007, -70.16025155999995],
              [72.65528405000003, -70.14763762799993],
              [72.69776451900003, -70.12224700299993],
              [72.72901451900003, -70.1091447899999],
              [72.73682701900003, -70.10312265399995],
              [72.74219811300003, -70.09417083099993],
              [72.74838300900007, -70.08098723799992],
              [72.75538170700008, -70.07382577899995],
              [72.76628665500004, -70.06902434699992],
              [72.87916100400008, -70.04029713299991],
              [72.90642337300005, -70.02695077899995],
              [72.91627037900008, -70.02581145599993],
              [72.94312584700003, -70.02849700299993],
              [72.95582116000008, -70.02792734199994],
              [72.96949303500008, -70.02548593499995],
              [72.98015384200005, -70.01995208099993],
              [73.00098717500003, -70.00310637799993],
              [73.00855553500008, -69.99895598799992],
              [73.01929772200003, -70.00107187299994],
              [73.04322350400008, -70.01262786299992],
              [73.05616295700008, -70.01458098799992],
              [73.07276451900003, -70.00693124799994],
              [73.09083092500003, -69.99325937299994],
              [73.10938561300003, -69.98235442499993],
              [73.12826582100007, -69.98300546699994],
              [73.15837649800005, -69.99374765399995],
              [73.17953535200007, -69.99277109199994],
              [73.23072350400008, -69.97893645599993],
              [73.21078535200007, -69.9533830709999],
              [73.20801842500003, -69.94247812299994],
              [73.21745853000004, -69.93254973799992],
              [73.23316491000008, -69.91033294099992],
              [73.23975670700008, -69.88836028399993],
              [73.24097741000008, -69.8713518209999],
              [73.24887129000007, -69.85857512799993],
              [73.27556399800005, -69.84840260199991],
              [73.34644616000008, -69.83717213299991],
              [73.36768639400003, -69.8298479149999],
              [73.37769616000008, -69.82293059699992],
              [73.39551842500003, -69.80462004999993],
              [73.40552819100003, -69.79753997199992],
              [73.41732832100007, -69.79485442499993],
              [73.43897545700008, -69.7951799459999],
              [73.47299238400007, -69.78093840899993],
              [73.48812910200007, -69.7868791649999],
              [73.50049889400003, -69.79778411299992],
              [73.51392662900008, -69.80331796699994],
              [73.53736412900008, -69.80331796699994],
              [73.56055748800003, -69.80632903399993],
              [73.58041425900007, -69.81552499799994],
              [73.60889733200008, -69.85125090899993],
              [73.62907962300005, -69.85816822699991],
              [73.70484459700003, -69.86248137799993],
              [73.72673587300005, -69.85214609199994],
              [73.74659264400003, -69.83757903399993],
              [73.81283613400007, -69.80266692499993],
              [73.88404381600003, -69.7458635399999],
              [73.92798912900008, -69.72991301899992],
              [73.98650149800005, -69.71892669099992],
              [74.02833092500003, -69.71843840899993],
              [74.07488040500004, -69.7126604149999],
              [74.22136478000004, -69.73357512799993],
              [74.23519941500007, -69.73756275799991],
              [74.24105879000007, -69.74431731599992],
              [74.24488366000008, -69.75383879999993],
              [74.25326582100007, -69.76555754999993],
              [74.31690514400003, -69.80681731599992],
              [74.32829837300005, -69.81975676899992],
              [74.32260175900007, -69.83798593499995],
              [74.27458743600005, -69.90740325299993],
              [74.30274498800003, -69.91961028399993],
              [74.33619225400008, -69.91545989399992],
              [74.40316816500007, -69.89739348799992],
              [74.41228274800005, -69.92791106599992],
              [74.46705162900008, -69.92522551899992],
              [74.57496178500008, -69.89364999799994],
              [74.67017662900008, -69.84840260199991],
              [74.71745853000004, -69.83538176899992],
              [74.77198326900003, -69.8420549459999],
              [74.72022545700008, -69.88005950299993],
              [74.75220787900008, -69.90203215899993],
              [74.77588951900003, -69.90886809699992],
              [74.80005944100003, -69.90252044099992],
              [74.86719811300003, -69.86858489399992],
              [74.90398196700005, -69.85808684699992],
              [74.94019616000008, -69.85670338299991],
              [74.97201582100007, -69.86834075299993],
              [75.02857506600003, -69.91122812299994],
              [75.06072024800005, -69.93010833099993],
              [75.09107506600003, -69.93710702899995],
              [75.12354576900003, -69.92449309699992],
              [75.17994225400008, -69.87737395599993],
              [75.21729576900003, -69.86785247199992],
              [75.21062259200005, -69.84124114399992],
              [75.22413170700008, -69.8225236959999],
              [75.24887129000007, -69.8122697899999],
              [75.27523847700007, -69.81047942499993],
              [75.30160566500007, -69.81796640399995],
              [75.31788170700008, -69.83245208099993],
              [75.34205162900008, -69.88014088299991],
              [75.35132897200003, -69.88616301899992],
              [75.37826582100007, -69.88632577899995],
              [75.38624108200008, -69.89267343499995],
              [75.39470462300005, -69.92278411299992],
              [75.40267988400007, -69.93523528399993],
              [75.41684004000007, -69.94198984199994],
              [75.43824303500008, -69.93743254999993],
              [75.52475019600007, -69.90146249799994],
              [75.55648847700007, -69.89324309699992],
              [75.58253014400003, -69.89739348799992],
              [75.59327233200008, -69.89788176899992],
              [75.60287519600007, -69.89495208099993],
              [75.63819420700008, -69.86842213299991],
              [75.66138756600003, -69.86003997199992],
              [75.71802819100003, -69.84978606599992],
              [75.76059004000007, -69.83171965899993],
              [75.77466881600003, -69.83212655999995],
              [75.79957116000008, -69.83700937299994],
              [75.81397545700008, -69.83489348799992],
              [75.84034264400003, -69.81731536299992],
              [75.86101321700005, -69.79452890399995],
              [75.88331139400003, -69.77890390399995],
              [75.91627037900008, -69.78281015399995],
              [75.83529707100007, -69.73064544099992],
              [75.82203209700003, -69.71640390399995],
              [75.81462649800005, -69.69109465899993],
              [75.79859459700003, -69.66122812299994],
              [75.77735436300003, -69.63534921699994],
              [75.75391686300003, -69.62175872199992],
              [75.76498457100007, -69.61492278399993],
              [75.78931725400008, -69.60361093499995],
              [75.79948978000004, -69.59677499799994],
              [75.80396569100003, -69.58684661299992],
              [75.80372155000003, -69.5764299459999],
              [75.80795332100007, -69.56715260199991],
              [75.82545006600003, -69.56072356599992],
              [75.81763756600003, -69.55868905999995],
              [75.79395592500003, -69.54957447699991],
              [75.82048587300005, -69.52507903399993],
              [75.85678144600007, -69.52361419099992],
              [75.89600670700008, -69.5290666649999],
              [75.93116295700008, -69.52613697699991],
              [75.94646243600005, -69.5158830709999],
              [75.97299238400007, -69.48992278399993],
              [75.98975670700008, -69.48381926899992],
              [76.03565514400003, -69.47926197699991],
              [76.07992597700007, -69.46868254999993],
              [76.21566816500007, -69.42066822699991],
              [76.37818444100003, -69.40536874799994],
              [76.36597741000008, -69.42791106599992],
              [76.35718834700003, -69.44963958099993],
              [76.36060631600003, -69.46721770599993],
              [76.38445071700005, -69.47779713299991],
              [76.40601647200003, -69.47503020599993],
              [76.43262780000003, -69.46428801899992],
              [76.45777428500008, -69.45045338299991],
              [76.51775149800005, -69.40398528399993],
              [76.55958092500003, -69.38030364399992],
              [76.60515384200005, -69.36516692499993],
              [76.68295332100007, -69.35312265399995],
              [76.73316491000008, -69.35076262799993],
              [76.75668379000007, -69.35507577899995],
              [76.78353925900007, -69.3635393209999],
              [76.79566491000008, -69.36435312299994],
              [76.80958092500003, -69.36060963299991],
              [76.82813561300003, -69.35198333099993],
              [76.83236738400007, -69.34628671699994],
              [76.83082116000008, -69.33717213299991],
              [76.83236738400007, -69.31951262799993],
              [76.83187910200007, -69.30559661299992],
              [76.82748457100007, -69.29656340899993],
              [76.82748457100007, -69.28972747199992],
              [76.83985436300003, -69.2829729149999],
              [76.86833743600005, -69.27483489399992],
              [76.89771569100003, -69.27206796699994],
              [76.92676842500003, -69.27483489399992],
              [76.94483483200008, -69.27857838299991],
              [76.96127363400007, -69.27597421699994],
              [76.98658287900008, -69.2595354149999],
              [76.97999108200008, -69.25505950299993],
              [76.96778405000003, -69.24358489399992],
              [76.96119225400008, -69.23935312299994],
              [77.00049889400003, -69.21168385199991],
              [77.06348717500003, -69.20183684699992],
              [77.23796634200005, -69.20378997199992],
              [77.26441491000008, -69.19890715899993],
              [77.31869550900007, -69.18287525799991],
              [77.43165123800003, -69.18466562299994],
              [77.44312584700003, -69.18962981599992],
              [77.45777428500008, -69.19980234199994],
              [77.47071373800003, -69.20574309699992],
              [77.48218834700003, -69.20403411299992],
              [77.50782311300003, -69.18873463299991],
              [77.53321373800003, -69.17986419099992],
              [77.84164472700007, -69.13005950299993],
              [77.82683353000004, -69.11174895599993],
              [77.82349694100003, -69.09661223799992],
              [77.83130944100003, -69.08318450299993],
              [77.84913170700008, -69.0700822899999],
              [77.87964928500008, -69.05331796699994],
              [77.88900800900007, -69.04583098799992],
              [77.91228274800005, -69.01531340899993],
              [77.92261803500008, -69.0075822899999],
              [77.94849694100003, -69.00123463299991],
              [78.04395592500003, -69.00261809699992],
              [77.94776451900003, -68.97763437299994],
              [77.96705162900008, -68.95631275799991],
              [77.98414147200003, -68.94280364399992],
              [78.00440514400003, -68.93368905999995],
              [78.03191165500004, -68.92506275799991],
              [77.93620853000004, -68.9196916649999],
              [77.94361412900008, -68.8986955709999],
              [77.93978925900007, -68.87607187299994],
              [77.93962649800005, -68.85613372199992],
              [77.95753014400003, -68.84343840899993],
              [77.96558678500008, -68.83928801899992],
              [77.97803795700008, -68.82537200299993],
              [77.98560631600003, -68.8200822899999],
              [78.11866295700008, -68.7639299459999],
              [78.14291425900007, -68.75896575299993],
              [78.35084069100003, -68.75204843499995],
              [78.37623131600003, -68.74602629999993],
              [78.41846764400003, -68.72600676899992],
              [78.44410241000008, -68.71917083099993],
              [78.66993248800003, -68.69850025799991],
              [78.62647545700008, -68.67050546699994],
              [78.57146243600005, -68.65447356599992],
              [78.51270592500003, -68.64853280999995],
              [78.45826256600003, -68.65007903399993],
              [78.47738691500007, -68.64397551899992],
              [78.53158613400007, -68.61484140399995],
              [78.54460696700005, -68.60100676899992],
              [78.54249108200008, -68.5920549459999],
              [78.52418053500008, -68.57691822699991],
              [78.51612389400003, -68.56715260199991],
              [78.51148522200003, -68.55193450299993],
              [78.51148522200003, -68.53460051899992],
              [78.51612389400003, -68.51848723799992],
              [78.52670332100007, -68.50628020599993],
              [78.51148522200003, -68.50042083099993],
              [78.49634850400008, -68.49879322699991],
              [78.46436608200008, -68.50164153399993],
              [78.46168053500008, -68.48552825299993],
              [78.46729576900003, -68.47649504999993],
              [78.47877037900008, -68.47161223799992],
              [78.49390709700003, -68.46754322699991],
              [78.50147545700008, -68.46062590899993],
              [78.50652103000004, -68.4358049459999],
              [78.51124108200008, -68.42506275799991],
              [78.53199303500008, -68.40097421699994],
              [78.54981530000003, -68.37468840899993],
              [78.55990644600007, -68.36467864399992],
              [78.60401451900003, -68.34880950299993],
              [78.74659264400003, -68.26246510199991],
              [79.13135826900003, -68.14771900799991],
              [79.44422448000003, -68.09295012799993],
              [79.75709069100003, -68.03818124799994],
              [79.86703535200007, -68.03191497199992],
              [80.30205325600008, -67.95830657349993],
              [80.73707116000008, -67.88469817499993],
              [80.79493248800003, -67.88201262799993],
              [80.87623131600003, -67.8923479149999],
              [81.19288170650003, -67.8330217429999],
              [81.50953209700003, -67.7736955709999],
              [81.56869550900007, -67.77337004999993],
              [81.87671959700003, -67.70012786299992],
              [81.88819420700008, -67.70045338299991],
              [81.91553795700008, -67.70777760199991],
              [81.93018639400003, -67.7092424459999],
              [81.94304446700005, -67.70631275799991],
              [81.99805748800003, -67.68466562299994],
              [82.05941816500007, -67.67180754999993],
              [82.12175540500004, -67.66961028399993],
              [82.23585045700008, -67.68938567499993],
              [82.24366295700008, -67.6936174459999],
              [82.25049889400003, -67.69939544099992],
              [82.26091556100005, -67.70517343499995],
              [82.27881920700008, -67.71021900799991],
              [82.28825931100005, -67.70810312299994],
              [82.29712975400008, -67.7033830709999],
              [82.31299889400003, -67.70045338299991],
              [82.34880618600005, -67.70598723799992],
              [82.36198978000004, -67.70419687299994],
              [82.39625084700003, -67.67229583099993],
              [82.42310631600003, -67.6584611959999],
              [82.51441491000008, -67.62818775799991],
              [82.52808678500008, -67.62656015399995],
              [82.54420006600003, -67.62232838299991],
              [82.57105553500008, -67.60735442499993],
              [82.58619225400008, -67.60344817499993],
              [82.67009524800005, -67.60955169099992],
              [82.78150475400008, -67.59856536299992],
              [82.80762780000003, -67.60320403399993],
              [82.85385175900007, -67.6267229149999],
              [82.87728925900007, -67.63567473799992],
              [82.90503991000003, -67.63681405999995],
              [82.99594160200007, -67.6096330709999],
              [83.02955162900008, -67.6057268209999],
              [83.08204186300003, -67.6110979149999],
              [83.10613040500004, -67.61060963299991],
              [83.16000410200007, -67.58855559699992],
              [83.18726647200003, -67.58114999799994],
              [83.21534264400003, -67.57903411299992],
              [83.24610436300003, -67.5822893209999],
              [83.29590905000003, -67.59628671699994],
              [83.32048587300005, -67.60759856599992],
              [83.36255944100003, -67.63543059699992],
              [83.38868248800003, -67.64421965899993],
              [83.47266686300003, -67.65781015399995],
              [83.61597741000003, -67.63836028399993],
              [83.62761478000004, -67.63250090899993],
              [83.63412519600007, -67.62224700299993],
              [83.64039147200003, -67.61003997199992],
              [83.65056399800005, -67.59823984199994],
              [83.65642337300005, -67.5935197899999],
              [83.58179772200003, -67.57089609199994],
              [83.50196373800003, -67.56552499799994],
              [83.43091881600003, -67.54558684699992],
              [83.38257897200003, -67.47958749799994],
              [83.38672936300003, -67.44654713299991],
              [83.41684004000007, -67.42815520599993],
              [83.58472741000003, -67.39885833099993],
              [83.62330162900008, -67.38339609199994],
              [83.64926191500007, -67.35295989399992],
              [83.67676842500003, -67.32935963299991],
              [83.72413170700008, -67.31365325299993],
              [84.10157311300003, -67.26189544099992],
              [84.24968509200005, -67.22405364399992],
              [84.26189212300005, -67.21770598799992],
              [84.29127037900008, -67.1911760399999],
              [84.30543053500003, -67.18173593499995],
              [84.33448326900003, -67.16912200299993],
              [84.41407311300003, -67.12379322699991],
              [84.43873131600003, -67.11598072699991],
              [84.49146569100003, -67.11012135199991],
              [84.59669030000003, -67.11239999799994],
              [84.96216881600003, -67.07610442499993],
              [85.07032311300003, -67.08855559699992],
              [85.01563561300003, -67.12900155999995],
              [85.04102623800003, -67.13103606599992],
              [85.09489993600005, -67.12607187299994],
              [85.11622155000003, -67.13494231599992],
              [85.14112389400003, -67.15162525799991],
              [85.16700280000003, -67.15911223799992],
              [85.31177819100003, -67.16871510199991],
              [85.36011803500003, -67.18157317499993],
              [85.41895592500003, -67.19036223799992],
              [85.44288170700008, -67.18938567499993],
              [85.45484459700003, -67.18499114399992],
              [85.47413170700008, -67.17310963299991],
              [85.48747806100005, -67.17156340899993],
              [85.61646569100003, -67.18816497199992],
              [85.64234459700003, -67.18328215899993],
              [85.69727623800003, -67.16513437299994],
              [85.72632897200003, -67.16033294099992],
              [85.77881920700008, -67.16220468499995],
              [85.88005618600005, -67.13779062299994],
              [85.89014733200008, -67.13209400799991],
              [85.90593509200005, -67.11028411299992],
              [85.91423587300005, -67.10116952899995],
              [85.92562910200007, -67.09465911299992],
              [85.97917728000004, -67.0764299459999],
              [86.00684655000003, -67.07341887799993],
              [86.01937910200007, -67.06959400799991],
              [86.03296959700003, -67.06113046699994],
              [86.04175866000003, -67.0529924459999],
              [86.05128014400003, -67.04607512799993],
              [86.06714928500003, -67.04094817499993],
              [86.12281334700003, -67.03753020599993],
              [86.23511803500003, -67.04827239399992],
              [86.55827884200005, -67.02809010199991],
              [86.58716881600003, -67.03394947699991],
              [86.64380944100003, -67.05828215899993],
              [86.66814212300005, -67.06454843499995],
              [86.69678795700008, -67.06389739399992],
              [86.91627037900008, -67.01181405999995],
              [87.01319420700008, -66.96502044099992],
              [87.10865319100003, -66.93328215899993],
              [87.47527103000004, -66.87395598799992],
              [87.58204186300003, -66.84254322699991],
              [87.63990319100003, -66.83684661299992],
              [87.69857832100007, -66.82366301899992],
              [87.72901451900003, -66.82048919099992],
              [87.81771894600007, -66.82431405999995],
              [87.84473717500003, -66.81902434699992],
              [87.91431725400008, -66.78394947699991],
              [87.93930097700007, -66.77507903399993],
              [87.96566816500007, -66.77027760199991],
              [88.13510175900007, -66.77263762799993],
              [88.16325931100005, -66.77792734199994],
              [88.18669681100005, -66.78639088299991],
              [88.19825280000003, -66.79265715899993],
              [88.20753014400003, -66.79973723799992],
              [88.21566816500007, -66.81308359199994],
              [88.22510826900003, -66.84465911299992],
              [88.23015384200005, -66.85393645599993],
              [88.25123131600003, -66.85955169099992],
              [88.33432050900007, -66.84628671699994],
              [88.38819420700008, -66.84661223799992],
              [88.44117272200003, -66.84124114399992],
              [88.61101321700005, -66.79680754999993],
              [88.68441816500007, -66.7951799459999],
              [88.73471113400007, -66.7849260399999],
              [88.74480228000004, -66.7849260399999],
              [88.89307701900003, -66.80950286299992],
              [88.92115319100003, -66.8068986959999],
              [89.00342858200008, -66.78826262799993],
              [89.03516686300003, -66.78866952899995],
              [89.12875410200007, -66.80950286299992],
              [89.18767337300005, -66.81292083099993],
              [89.30534915500004, -66.80584075299993],
              [89.36459394600007, -66.81218840899993],
              [89.44654381600003, -66.83709075299993],
              [89.47575931100005, -66.8415666649999],
              [89.59986412900008, -66.8459611959999],
              [89.65430748800003, -66.84042734199994],
              [89.75904381600003, -66.80120208099993],
              [89.81072024800005, -66.78875090899993],
              [89.88591556100005, -66.78704192499993],
              [89.94092858200008, -66.79387786299992],
              [90.08757571700005, -66.77019622199992],
              [90.14893639400003, -66.77117278399993],
              [90.20964603000004, -66.78004322699991],
              [90.27702884200005, -66.80136484199994],
              [90.29151451900003, -66.80266692499993],
              [90.32325280000003, -66.79949309699992],
              [90.33521569100003, -66.80120208099993],
              [90.34839928500003, -66.8068986959999],
              [90.37232506600003, -66.82073333099993],
              [90.39869225400008, -66.81959400799991],
              [90.42709394600007, -66.80038827899995],
              [90.47103925900007, -66.7536760399999],
              [90.49170983200008, -66.74285247199992],
              [90.54444420700008, -66.74407317499993],
              [90.56641686300003, -66.73951588299991],
              [90.61841881600003, -66.71819426899992],
              [90.67383873800003, -66.70517343499995],
              [90.71119225400008, -66.70867278399993],
              [90.72242272200003, -66.70623137799993],
              [90.80128014400003, -66.67343515399995],
              [91.00342858200008, -66.61394622199992],
              [91.05925540500004, -66.58611419099992],
              [91.08611087300005, -66.57805754999993],
              [91.14519290500004, -66.57382577899995],
              [91.37940514400003, -66.60027434699992],
              [91.43677819100003, -66.5959611959999],
              [91.64226321700005, -66.55820077899995],
              [91.69678795700008, -66.53728606599992],
              [91.78174889400003, -66.53785572699991],
              [91.96013431100005, -66.49822356599992],
              [92.06527754000007, -66.51441822699991],
              [92.16797936300003, -66.51165129999993],
              [92.21697024800005, -66.52027760199991],
              [92.36980228000004, -66.59498463299991],
              [92.42269941500007, -66.60230885199991],
              [92.50684655000003, -66.59758879999993],
              [92.64421634200005, -66.62623463299991],
              [92.76026451900003, -66.63388437299994],
              [92.81592858200008, -66.62753671699994],
              [92.87476647200003, -66.61272551899992],
              [92.97217858200008, -66.57415129999993],
              [93.02133222700007, -66.56218840899993],
              [93.07447350400008, -66.56536223799992],
              [93.18572024800005, -66.58953215899993],
              [93.21306399800005, -66.59042734199994],
              [93.29615319100003, -66.5803361959999],
              [93.45826256600003, -66.58700937299994],
              [93.56755618600005, -66.57935963299991],
              [93.62354576900003, -66.58261484199994],
              [93.73121178500003, -66.60426197699991],
              [93.71127363400007, -66.63250090899993],
              [93.69922936300003, -66.64364999799994],
              [93.68336022200003, -66.65178801899992],
              [93.68913821700005, -66.65545012799993],
              [93.69955488400007, -66.66464609199994],
              [93.70557701900003, -66.66814544099992],
              [93.69109134200005, -66.68287525799991],
              [93.70053144600007, -66.70623137799993],
              [93.72071373800003, -66.7302385399999],
              [93.73926842500003, -66.74716562299994],
              [93.75375410200007, -66.74431731599992],
              [93.88786868600005, -66.68670012799993],
              [93.91504967500003, -66.68572356599992],
              [93.93824303500003, -66.69198984199994],
              [93.96119225400008, -66.70452239399992],
              [93.96924889400003, -66.71998463299991],
              [93.94825280000003, -66.73430754999993],
              [93.99708092500003, -66.73137786299992],
              [94.07813561300003, -66.71795012799993],
              [94.09506269600007, -66.71233489399992],
              [94.10499108200003, -66.70378997199992],
              [94.11280358200003, -66.68718840899993],
              [94.12012780000003, -66.67815520599993],
              [94.13103274800005, -66.67343515399995],
              [94.29542076900003, -66.65341562299994],
              [94.42603600400008, -66.62167734199994],
              [94.44556725400008, -66.61003997199992],
              [94.46509850400008, -66.59042734199994],
              [94.49097741000003, -66.56975676899992],
              [94.51905358200003, -66.5525041649999],
              [94.54509524800005, -66.54314544099992],
              [94.70394941500007, -66.51279062299994],
              [94.78565514400003, -66.50701262799993],
              [94.90528405000003, -66.47698333099993],
              [94.91716556100005, -66.47535572699991],
              [94.93100019600007, -66.47861093499995],
              [94.95557701900003, -66.48796965899993],
              [94.99732506600003, -66.4885393209999],
              [95.02116946700005, -66.49260833099993],
              [95.06910241000003, -66.50888437299994],
              [95.09587649800005, -66.51433684699992],
              [95.17465254000007, -66.50725676899992],
              [95.22681725400008, -66.51116301899992],
              [95.27865644600007, -66.5271135399999],
              [95.32105553500003, -66.55673593499995],
              [95.34506269600007, -66.60076262799993],
              [95.34457441500007, -66.61321379999993],
              [95.34245853000004, -66.62623463299991],
              [95.34506269600007, -66.63730234199994],
              [95.35914147200003, -66.6423479149999],
              [95.49317467500003, -66.65398528399993],
              [95.52133222700007, -66.65154387799993],
              [95.51197350400008, -66.6599260399999],
              [95.48194420700003, -66.70818450299993],
              [95.49675540500004, -66.70029062299994],
              [95.51734459700003, -66.70208098799992],
              [95.55616295700003, -66.71062590899993],
              [95.57667076900003, -66.70631275799991],
              [95.63697350400008, -66.67913176899992],
              [95.65211022200003, -66.67685312299994],
              [95.68376712300005, -66.67652760199991],
              [95.69939212300005, -66.67489999799994],
              [95.76091556100005, -66.65911223799992],
              [95.82593834700003, -66.64999765399995],
              [95.85889733200003, -66.65081145599993],
              [95.89079837300005, -66.65740325299993],
              [95.95020592500003, -66.65748463299991],
              [96.00424238400007, -66.63005950299993],
              [96.05600019600007, -66.59441497199992],
              [96.10865319100003, -66.5700822899999],
              [96.13461347700007, -66.57333749799994],
              [96.18051191500007, -66.60588958099993],
              [96.20720462300005, -66.6135393209999],
              [96.23552493600005, -66.61003997199992],
              [96.29224694100003, -66.59531015399995],
              [96.40739993600005, -66.5837541649999],
              [96.43376712300005, -66.58700937299994],
              [96.55347741000003, -66.61532968499995],
              [96.61036217500003, -66.61484140399995],
              [96.97413170700003, -66.50839609199994],
              [97.08073978000004, -66.49228280999995],
              [97.19011478000004, -66.49944426899992],
              [97.23519941500007, -66.50798919099992],
              [97.25562584700003, -66.51653411299992],
              [97.27051842500003, -66.53167083099993],
              [97.33708743600005, -66.58131275799991],
              [97.41773522200003, -66.56731536299992],
              [97.43881269600007, -66.57195403399993],
              [97.44809004000007, -66.60247161299992],
              [97.45191491000003, -66.61101653399993],
              [97.46322675900007, -66.62444426899992],
              [97.47169030000003, -66.63128020599993],
              [97.48178144600007, -66.6350236959999],
              [97.49773196700005, -66.6389299459999],
              [97.52369225400008, -66.6423479149999],
              [97.57691491000003, -66.64177825299993],
              [97.60271243600005, -66.64527760199991],
              [97.67204837300005, -66.67717864399992],
              [97.69532311300003, -66.67864348799992],
              [97.74057050900007, -66.65829843499995],
              [97.80437259200005, -66.59140390399995],
              [97.84009850400008, -66.56609465899993],
              [97.88550866000003, -66.55527109199994],
              [97.97738691500007, -66.5471330709999],
              [98.06910241000003, -66.50823333099993],
              [98.16700280000003, -66.48406340899993],
              [98.21208743600005, -66.4607072899999],
              [98.24781334700003, -66.44793059699992],
              [98.52759850400008, -66.4489885399999],
              [98.53711998800003, -66.45435963299991],
              [98.55355879000007, -66.47356536299992],
              [98.56324303500003, -66.4807268209999],
              [98.57536868600005, -66.48601653399993],
              [98.54249108200003, -66.55348072699991],
              [98.52003014400003, -66.58407968499995],
              [98.49073326900003, -66.6037736959999],
              [98.53980553500003, -66.62273528399993],
              [98.62330162900008, -66.60930754999993],
              [98.91374759200005, -66.50457122199992],
              [98.99431399800005, -66.4919572899999],
              [99.06934655000003, -66.48992278399993],
              [99.05323326900003, -66.5251604149999],
              [99.00733483200003, -66.55291106599992],
              [98.71648196700005, -66.64275481599992],
              [98.75619550900007, -66.65007903399993],
              [98.77328535200007, -66.65740325299993],
              [98.78598066500007, -66.67131926899992],
              [98.80616295700003, -66.71347421699994],
              [98.81763756600003, -66.7282854149999],
              [98.70525149800005, -66.77434661299992],
              [98.73226972700007, -66.7873674459999],
              [98.74594160200007, -66.79176197699991],
              [98.76099694100003, -66.79387786299992],
              [98.77588951900003, -66.79876067499993],
              [98.78093509200005, -66.8103166649999],
              [98.78012129000007, -66.84539153399993],
              [98.78638756600003, -66.87851327899995],
              [98.80250084700003, -66.9006486959999],
              [98.82618248800003, -66.9099260399999],
              [98.85645592500003, -66.90422942499993],
              [98.88453209700003, -66.88274504999993],
              [98.88135826900003, -66.86060963299991],
              [98.87134850400008, -66.8361955709999],
              [98.87973066500007, -66.80730559699992],
              [98.90503991000003, -66.78329843499995],
              [98.99138431100005, -66.72429778399993],
              [99.00367272200003, -66.70940520599993],
              [99.00912519600007, -66.69963958099993],
              [99.01726321700005, -66.69451262799993],
              [99.03736412900008, -66.69426848799992],
              [99.04932701900003, -66.69866301899992],
              [99.06177819100003, -66.70818450299993],
              [99.08350670700003, -66.72909921699994],
              [99.09555097700007, -66.73796965899993],
              [99.10759524800005, -66.74325937299994],
              [99.15707441500007, -66.75261809699992],
              [99.16944420700003, -66.75310637799993],
              [99.17676842500003, -66.7458635399999],
              [99.18246504000007, -66.7263322899999],
              [99.19922936300003, -66.71005624799994],
              [99.23170006600003, -66.70134856599992],
              [99.29712975400008, -66.69719817499993],
              [99.33204186300003, -66.70012786299992],
              [99.34717858200003, -66.69882577899995],
              [99.36394290500004, -66.69101327899995],
              [99.38965905000003, -66.66936614399992],
              [99.40284264400003, -66.66277434699992],
              [99.42253665500004, -66.66220468499995],
              [99.42286217500003, -66.61874765399995],
              [99.46851647200003, -66.5822893209999],
              [99.52955162900008, -66.55738697699991],
              [99.57618248800003, -66.54851653399993],
              [99.54525800900007, -66.5959611959999],
              [99.53630618600005, -66.62216562299994],
              [99.53956139400003, -66.6482072899999],
              [99.56023196700005, -66.67205169099992],
              [99.58399498800003, -66.66904062299994],
              [99.60767662900008, -66.6506486959999],
              [99.62728925900007, -66.62908294099992],
              [99.67839603000004, -66.59221770599993],
              [99.80713951900003, -66.55282968499995],
              [99.86752363400007, -66.52646249799994],
              [99.89918053500003, -66.50823333099993],
              [99.92318769600007, -66.49968840899993],
              [99.94890384200005, -66.49814218499995],
              [99.98536217500003, -66.5002580709999],
              [100.00123131600003, -66.49871184699992],
              [100.03646894600007, -66.49065520599993],
              [100.05030358200003, -66.49089934699992],
              [100.06983483200003, -66.49529387799993],
              [100.08545983200003, -66.49521249799994],
              [100.10132897200003, -66.49130624799994],
              [100.13607832100007, -66.47763437299994],
              [100.16627037900008, -66.46021900799991],
              [100.18132571700005, -66.4548479149999],
              [100.20045006600003, -66.45273202899995],
              [100.21534264400003, -66.45240650799991],
              [100.22982832100007, -66.45045338299991],
              [100.27963300900007, -66.43108489399992],
              [100.30827884200005, -66.43254973799992],
              [100.32276451900003, -66.44915129999993],
              [100.31226647200003, -66.48357512799993],
              [100.33448326900003, -66.4821916649999],
              [100.42139733200003, -66.45305754999993],
              [100.44703209700003, -66.45566171699994],
              [100.46631920700003, -66.47144947699991],
              [100.50001061300003, -66.51873137799993],
              [100.53044681100005, -66.49309661299992],
              [100.56625410200007, -66.47665780999995],
              [100.64389082100007, -66.45769622199992],
              [100.61890709700003, -66.44817473799992],
              [100.52800540500004, -66.4514299459999],
              [100.56723066500007, -66.42457447699991],
              [100.54428144600007, -66.41472747199992],
              [100.47055097700007, -66.39739348799992],
              [100.82154381600003, -66.3845354149999],
              [100.85499108200003, -66.37965260199991],
              [100.88770592500003, -66.36663176899992],
              [101.07146243600005, -66.26702239399992],
              [101.09986412900008, -66.24529387799993],
              [101.12232506600003, -66.21933359199994],
              [101.12989342500003, -66.20191822699991],
              [101.13445071700005, -66.18718840899993],
              [101.14258873800003, -66.17693450299993],
              [101.16138756600003, -66.17351653399993],
              [101.20142662900008, -66.1721330709999],
              [101.21957441500007, -66.16790129999993],
              [101.26579837300005, -66.14690520599993],
              [101.27491295700003, -66.1384416649999],
              [101.29444420700003, -66.11199309699992],
              [101.30616295700003, -66.10019296699994],
              [101.31902103000004, -66.09002044099992],
              [101.33106530000003, -66.08391692499993],
              [101.44011478000004, -66.06894296699994],
              [101.47624759200005, -66.0583635399999],
              [101.16871178500003, -66.02947356599992],
              [101.18287194100003, -66.02361419099992],
              [101.19752037900008, -66.0193010399999],
              [101.22779381600003, -66.01458098799992],
              [101.21851647200003, -66.00741952899995],
              [101.20818118600005, -66.00253671699994],
              [101.19662519600007, -66.00017669099992],
              [101.18482506600003, -66.00009530999995],
              [101.23943118600005, -65.98406340899993],
              [101.28728274800005, -65.96135833099993],
              [101.33643639400003, -65.94402434699992],
              [101.57422936300003, -65.9489885399999],
              [101.68311608200003, -65.96721770599993],
              [102.01050866000003, -65.95924244549994],
              [102.33790123800003, -65.95126718499995],
              [102.51107832100007, -65.89120859199994],
              [102.59986412900008, -65.87102629999993],
              [102.71371504000007, -65.86126067499993],
              [102.91065514400003, -65.87932708099993],
              [102.96705162900008, -65.87761809699992],
              [103.05095462300005, -65.88884856599992],
              [103.06576582100007, -65.89299895599993],
              [103.07129967500003, -65.90252044099992],
              [103.07496178500003, -65.91415780999995],
              [103.08513431100005, -65.92489999799994],
              [103.09669030000003, -65.92571379999993],
              [103.14551842500003, -65.91619231599992],
              [103.15853925900007, -65.91676197699991],
              [103.20134524800005, -65.92839934699992],
              [103.27808678500003, -65.92424895599993],
              [103.30600019600007, -65.92815520599993],
              [103.31804446700005, -65.93287525799991],
              [103.33887780000003, -65.94548919099992],
              [103.34913170700003, -65.94988372199992],
              [103.41358483200003, -65.95745208099993],
              [103.55990644600007, -66.0022111959999],
              [103.61052493600005, -66.00994231599992],
              [103.64063561300003, -66.00798919099992],
              [103.72925866000003, -65.9821916649999],
              [103.75928795700003, -65.97698333099993],
              [103.90821373800003, -65.9787736959999],
              [104.16211998800003, -66.01974863099991],
              [104.41602623800003, -66.06072356599992],
              [104.57325280000003, -66.13103606599992],
              [104.63021894600007, -66.14120859199994],
              [104.86304772200003, -66.14299895599993],
              [105.29053795700003, -66.21607838299991],
              [105.35084069100003, -66.20859140399995],
              [105.36182701900003, -66.21062590899993],
              [105.40552819100003, -66.2307268209999],
              [105.44800866000003, -66.23259856599992],
              [105.46045983200003, -66.23707447699991],
              [105.48560631600003, -66.25400155999995],
              [105.49854576900003, -66.25994231599992],
              [105.90056399800005, -66.31996021949993],
              [106.30258222700007, -66.37997812299994],
              [106.32309004000007, -66.3889299459999],
              [106.32553144600007, -66.39723072699991],
              [106.32439212300005, -66.40886809699992],
              [106.32496178500003, -66.42083098799992],
              [106.33228600400003, -66.43092213299991],
              [106.34571373800003, -66.4333635399999],
              [106.36150149800005, -66.42880624799994],
              [106.37631269600007, -66.42034270599993],
              [106.38697350400003, -66.41179778399993],
              [106.41041100400003, -66.40162525799991],
              [106.59864342500003, -66.41415780999995],
              [106.64429772200003, -66.42636484199994],
              [106.69874108200003, -66.47031015399995],
              [106.72234134200005, -66.46892669099992],
              [106.76783287900003, -66.45574309699992],
              [107.11695397200003, -66.46257903399993],
              [107.33277428500003, -66.4983049459999],
              [107.43425540500004, -66.52849700299993],
              [107.77914472700007, -66.55169036299992],
              [107.80111738400007, -66.56178150799991],
              [107.84652754000007, -66.59295012799993],
              [107.86988366000003, -66.61394622199992],
              [107.87916100400003, -66.6330705709999],
              [107.86703535200007, -66.65276458099993],
              [107.84058678500003, -66.66668059699992],
              [107.78711998800003, -66.68287525799991],
              [107.76490319100003, -66.69402434699992],
              [107.70191491000003, -66.73772551899992],
              [107.71387780000003, -66.75660572699991],
              [107.71566816500007, -66.7873674459999],
              [107.70980879000007, -66.84758879999993],
              [107.72510826900003, -66.84295012799993],
              [107.73780358200003, -66.83587004999993],
              [107.78484134200005, -66.79729583099993],
              [107.79297936300003, -66.79208749799994],
              [107.80054772200003, -66.79094817499993],
              [107.81812584700003, -66.79355234199994],
              [107.82536868600005, -66.79208749799994],
              [107.83838951900003, -66.77947356599992],
              [107.85914147200003, -66.74684010199991],
              [107.87142988400007, -66.7341447899999],
              [107.88559004000007, -66.72771575299993],
              [108.04322350400003, -66.67896900799991],
              [108.13575280000003, -66.6247697899999],
              [108.16504967500003, -66.6213518209999],
              [108.20704186300003, -66.6267229149999],
              [108.20215905000003, -66.65341562299994],
              [108.21306399800005, -66.67066822699991],
              [108.25294030000003, -66.69695403399993],
              [108.27003014400003, -66.71697356599992],
              [108.28272545700003, -66.73837655999995],
              [108.29818769600007, -66.75644296699994],
              [108.32341556100005, -66.76628997199992],
              [108.35238691500007, -66.76702239399992],
              [108.37720787900003, -66.76474374799994],
              [108.40186608200003, -66.76555754999993],
              [108.47657311300003, -66.79461028399993],
              [108.50066165500004, -66.79957447699991],
              [108.57642662900003, -66.80584075299993],
              [108.62191816500007, -66.81804778399993],
              [108.66187584700003, -66.84221770599993],
              [108.69629967500003, -66.88298919099992],
              [108.70883222700007, -66.91912200299993],
              [108.71387780000003, -66.92742278399993],
              [108.72315514400003, -66.93254973799992],
              [108.76172936300003, -66.94150155999995],
              [108.83277428500003, -66.96803150799991],
              [108.85865319100003, -66.97136809699992],
              [108.88184655000003, -66.96843840899993],
              [108.95045006600003, -66.9509416649999],
              [108.98650149800005, -66.95330169099992],
              [108.99708092500003, -66.9514299459999],
              [108.99878991000003, -66.9475236959999],
              [108.99773196700005, -66.94085051899992],
              [108.99740644600007, -66.9338518209999],
              [109.00131269600007, -66.92896900799991],
              [109.07984459700003, -66.8967424459999],
              [109.12501061300003, -66.88469817499993],
              [109.14958743600005, -66.88534921699994],
              [109.22348066500007, -66.90471770599993],
              [109.24830162900003, -66.90398528399993],
              [109.27084394600007, -66.90097421699994],
              [109.29297936300003, -66.90056731599992],
              [109.31690514400003, -66.90732187299994],
              [109.36231530000003, -66.92701588299991],
              [109.38575280000003, -66.93271249799994],
              [109.60987389400003, -66.9196916649999],
              [109.60352623800003, -66.91334400799991],
              [109.59253991000003, -66.89861419099992],
              [109.58627363400007, -66.89218515399995],
              [109.61915123800003, -66.87704843499995],
              [109.84782962300005, -66.85442473799992],
              [109.80518639400003, -66.82927825299993],
              [109.90552819100003, -66.80771249799994],
              [109.88217207100007, -66.79924895599993],
              [110.09978274800005, -66.76604583099993],
              [110.15609785200007, -66.74797942499993],
              [110.25391686300003, -66.69695403399993],
              [110.39031009200005, -66.65976327899995],
              [110.41765384200005, -66.65593840899993],
              [110.44516035200007, -66.65829843499995],
              [110.50318444100003, -66.6716447899999],
              [110.55518639400003, -66.69019947699991],
              [110.60531660200007, -66.71697356599992],
              [110.63054446700005, -66.72576262799993],
              [110.65739993600005, -66.72795989399992],
              [110.74415123800003, -66.71453215899993],
              [110.73357181100005, -66.69573333099993],
              [110.71534264400003, -66.68352629999993],
              [110.67261803500003, -66.66765715899993],
              [110.70541425900007, -66.62460702899995],
              [110.67107181100005, -66.61207447699991],
              [110.65121504000007, -66.59392669099992],
              [110.64478600400003, -66.56796640399995],
              [110.65072675900007, -66.53191497199992],
              [110.62647545700003, -66.5290666649999],
              [110.60189863400007, -66.52947356599992],
              [110.68873131600003, -66.48902760199991],
              [110.70508873800003, -66.47234465899993],
              [110.71029707100007, -66.42620208099993],
              [110.72494550900007, -66.40545012799993],
              [110.63599694100003, -66.3850236959999],
              [110.61166425900007, -66.37265390399995],
              [110.59498131600003, -66.3615861959999],
              [110.58008873800003, -66.3557268209999],
              [110.54444420700003, -66.3518205709999],
              [110.52637780000003, -66.34726327899995],
              [110.51197350400003, -66.33717213299991],
              [110.49984785200007, -66.32382577899995],
              [110.48902428500003, -66.30877044099992],
              [110.51856530000003, -66.29566822699991],
              [110.54867597700007, -66.27507903399993],
              [110.59986412900003, -66.22779713299991],
              [110.62330162900003, -66.21697356599992],
              [110.68409264400003, -66.21062590899993],
              [110.70728600400003, -66.19402434699992],
              [110.71159915500004, -66.18059661299992],
              [110.71070397200003, -66.16855234199994],
              [110.71192467500003, -66.15781015399995],
              [110.72242272200003, -66.14804452899995],
              [110.76026451900003, -66.1291643209999],
              [110.80079186300003, -66.11598072699991],
              [110.92709394600007, -66.05462004999993],
              [110.95435631600003, -66.04827239399992],
              [111.01417076900003, -66.04387786299992],
              [111.31487063900005, -65.98837656049992],
              [111.61557050900007, -65.93287525799991],
              [111.84742272200003, -65.93474700299993],
              [112.30640709700003, -65.88034433399991],
              [112.76539147200003, -65.8259416649999],
              [112.87867272200003, -65.79843515399995],
              [113.20362389400009, -65.7653947899999],
              [113.22217858200008, -65.77255624799994],
              [113.25342858200008, -65.81511809699992],
              [113.27564537900003, -65.83212655999995],
              [113.30616295700008, -65.84238046699994],
              [113.42359459700003, -65.86012135199991],
              [113.52833092500009, -65.89657968499995],
              [113.66260826900009, -65.91513437299994],
              [113.77556399800005, -65.94850025799991],
              [113.79737389400009, -65.96021900799991],
              [113.84310957100001, -65.99334075299993],
              [113.89478600400003, -66.02166106599992],
              [114.00367272200003, -66.06129322699991],
              [114.06299889400009, -66.06845468499995],
              [114.08773847700002, -66.07577890399995],
              [114.13502037900003, -66.11834075299993],
              [114.16138756600003, -66.12835051899992],
              [114.19076582100001, -66.12981536299992],
              [114.22380618600005, -66.12664153399993],
              [114.25456790500004, -66.13437265399995],
              [114.29078209700003, -66.17986419099992],
              [114.31934655000009, -66.18816497199992],
              [114.34034264400009, -66.18767669099992],
              [114.35124759200005, -66.1916643209999],
              [114.36068769600001, -66.19915129999993],
              [114.37769616000003, -66.20891692499993],
              [114.39087975400003, -66.2126604149999],
              [114.40300540500004, -66.21404387799993],
              [114.41578209700003, -66.2170549459999],
              [114.42986087300005, -66.22600676899992],
              [114.40674889400009, -66.23593515399995],
              [114.40259850400003, -66.25359465899993],
              [114.40137780000009, -66.27353280999995],
              [114.38770592500009, -66.28980885199991],
              [114.33871504000001, -66.31414153399993],
              [114.32056725400003, -66.33114999799994],
              [114.30941816500001, -66.35702890399995],
              [114.33366946700005, -66.3518205709999],
              [114.41602623800009, -66.36785247199992],
              [114.40886478000004, -66.37078215899993],
              [114.38795006600003, -66.38241952899995],
              [114.42953535200002, -66.40178801899992],
              [114.42408287900003, -66.4060197899999],
              [114.41391035200002, -66.4157854149999],
              [114.40821373800009, -66.41961028399993],
              [114.48340905000009, -66.41521575299993],
              [114.351898634, -66.47771575299993],
              [114.32243899800005, -66.50904713299991],
              [114.67465254000001, -66.4787736959999],
              [114.76628665500004, -66.49382903399993],
              [114.81202233200008, -66.49521249799994],
              [114.89625084700003, -66.4724260399999],
              [115.039398634, -66.4826799459999],
              [115.08806399800005, -66.47763437299994],
              [115.11345462300005, -66.47812265399995],
              [115.13257897200003, -66.48796965899993],
              [115.15186608200008, -66.50660572699991],
              [115.17164147200003, -66.51873137799993],
              [115.19385826900009, -66.5251604149999],
              [115.26514733200008, -66.53264739399992],
              [115.34961998800009, -66.55575937299994],
              [115.43458092500009, -66.55917734199994],
              [115.59896894600001, -66.59286874799994],
              [115.64942467500009, -66.61451588299991],
              [115.68189537900003, -66.64275481599992],
              [115.66895592500009, -66.67343515399995],
              [115.68262780000009, -66.68572356599992],
              [115.69809004000001, -66.69622161299992],
              [115.70826256600003, -66.70566171699994],
              [115.70785566500001, -66.71412525799991],
              [115.705414259, -66.72283294099992],
              [115.70915774800005, -66.73186614399992],
              [115.719086134, -66.73837655999995],
              [115.74244225400003, -66.74667734199994],
              [115.75196373800009, -66.75448984199994],
              [115.76547285200002, -66.77214934699992],
              [115.78077233200008, -66.78826262799993],
              [115.69410241000003, -66.86077239399992],
              [115.59742272200003, -66.91952890399995],
              [115.38738040500004, -67.00383879999993],
              [115.16016686300009, -67.05396900799991],
              [114.76539147200003, -67.07170989399992],
              [114.59815514400009, -67.11736419099992],
              [114.48210696700005, -67.13095468499995],
              [114.39795983200008, -67.12249114399992],
              [114.03012129000001, -67.19068775799991],
              [114.00456790500004, -67.20273202899995],
              [113.90528405000009, -67.28337981599992],
              [113.87891686300009, -67.29827239399992],
              [113.81641686300009, -67.31829192499993],
              [113.85027103000004, -67.32610442499993],
              [113.88493899800005, -67.33001067499993],
              [113.86841881600003, -67.36223723799992],
              [113.83594811300009, -67.37900155999995],
              [113.76140384200005, -67.39511484199994],
              [113.74268639400009, -67.40439218499995],
              [113.71461022200003, -67.42864348799992],
              [113.69849694100003, -67.43792083099993],
              [113.65992272200003, -67.45191822699991],
              [113.64673912900003, -67.46428801899992],
              [113.64649498800009, -67.48357512799993],
              [113.66627037900003, -67.48162200299993],
              [113.67872155000009, -67.48707447699991],
              [113.68946373800009, -67.49504973799992],
              [113.70435631600003, -67.50017669099992],
              [113.722992384, -67.49968840899993],
              [113.78256269600001, -67.48601653399993],
              [113.81226647200003, -67.48365650799991],
              [113.90007571700005, -67.49041106599992],
              [114.03150475400003, -67.47844817499993],
              [114.35080000100004, -67.41094329199993],
              [114.67009524800005, -67.34343840899993],
              [114.60254967500009, -67.39373137799993],
              [114.58253014400009, -67.41619231599992],
              [114.62574303500003, -67.4275041649999],
              [114.66895592500009, -67.42424895599993],
              [114.75464928500003, -67.40447356599992],
              [114.77556399800005, -67.39706796699994],
              [114.79078209700003, -67.3752580709999],
              [114.81202233200008, -67.3669572899999],
              [115.06397545700008, -67.32830169099992],
              [115.21216881600003, -67.32586028399993],
              [115.25416100400003, -67.31308359199994],
              [115.20785566500001, -67.29094817499993],
              [115.24097741000003, -67.25823333099993],
              [115.28687584700003, -67.23349374799994],
              [115.33790123800009, -67.21949635199991],
              [115.52849368600005, -67.22380950299993],
              [115.58887780000009, -67.21135833099993],
              [115.67188561300009, -67.20956796699994],
              [115.72364342500009, -67.20126718499995],
              [115.77670332100001, -67.18157317499993],
              [115.79965254000001, -67.18124765399995],
              [115.80836022200003, -67.20281340899993],
              [115.81959069100003, -67.22128671699994],
              [115.84750410200002, -67.22503020599993],
              [115.96550540500004, -67.19931405999995],
              [115.98389733200008, -67.18596770599993],
              [115.99732506600003, -67.1560197899999],
              [116.01384524800005, -67.14446379999993],
              [116.04468834700003, -67.14421965899993],
              [116.07732181100005, -67.1506486959999],
              [116.12940514400009, -67.16961028399993],
              [116.15699303500003, -67.16513437299994],
              [116.18034915500004, -67.14967213299991],
              [116.21461022200003, -67.10426197699991],
              [116.23259524800005, -67.0959611959999],
              [116.25310306100005, -67.10051848799992],
              [116.30941816500001, -67.13836028399993],
              [116.33334394600001, -67.14918385199991],
              [116.35889733200008, -67.14967213299991],
              [116.50001061300009, -67.12428150799991],
              [116.53126061300009, -67.11321379999993],
              [116.58529707100001, -67.08066171699994],
              [116.69255618600005, -67.04404062299994],
              [116.79688561300009, -66.98845794099992],
              [116.94288170700008, -66.94817473799992],
              [116.94190514400009, -66.97600676899992],
              [116.93091881600003, -67.00628020599993],
              [116.90316816500001, -67.06178150799991],
              [116.86247806100005, -67.10149504999993],
              [116.85377037900003, -67.12273528399993],
              [116.88306725400003, -67.13681405999995],
              [116.99341881600003, -67.14560312299994],
              [117.09107506600003, -67.13079192499993],
              [117.15552819100003, -67.13160572699991],
              [117.23585045700008, -67.11337655999995],
              [117.295258009, -67.10686614399992],
              [117.46241295700008, -67.10784270599993],
              [117.49439537900003, -67.0993791649999],
              [117.52084394600001, -67.08652109199994],
              [117.54493248800009, -67.08318450299993],
              [117.56934655000009, -67.10442473799992],
              [117.58725019600001, -67.11484140399995],
              [117.64519290500004, -67.12444426899992],
              [117.668304884, -67.13616301899992],
              [117.67505944100003, -67.14544036299992],
              [117.68043053500003, -67.1560197899999],
              [117.68653405000009, -67.16529713299991],
              [117.69556725400003, -67.17050546699994],
              [117.71412194100003, -67.17180754999993],
              [117.73047936300009, -67.1682268209999],
              [117.86402428500003, -67.10165780999995],
              [117.91431725400003, -67.08310312299994],
              [118.36793053500003, -67.04648202899995],
              [118.428070509, -67.03183359199994],
              [118.39828535200002, -67.0720354149999],
              [118.38070722700002, -67.0901018209999],
              [118.36036217500009, -67.10295989399992],
              [118.25318444100003, -67.14771900799991],
              [118.26929772200003, -67.14967213299991],
              [118.28239993600005, -67.15520598799992],
              [118.28988691500001, -67.16545989399992],
              [118.29004967500009, -67.18157317499993],
              [118.42448978000004, -67.15837981599992],
              [118.43482506600003, -67.16139088299991],
              [118.45997155000009, -67.18425872199992],
              [118.47169030000009, -67.18320077899995],
              [118.48462975400003, -67.1760393209999],
              [118.50269616000003, -67.16985442499993],
              [118.60482832100001, -67.16318124799994],
              [118.61996504000001, -67.16545989399992],
              [118.66553795700008, -67.17896900799991],
              [118.67904707100001, -67.1794572899999],
              [118.709320509, -67.17197030999995],
              [118.77979576900009, -67.16611093499995],
              [118.80437259200005, -67.16904062299994],
              [118.84229576900009, -67.18474700299993],
              [118.85523522200003, -67.18718840899993],
              [118.86850019600001, -67.18694426899992],
              [118.881195509, -67.1838518209999],
              [118.88168379000001, -67.18035247199992],
              [118.87989342500009, -67.16619231599992],
              [118.88038170700008, -67.16253020599993],
              [118.88917076900009, -67.16033294099992],
              [118.92017662900003, -67.15976327899995],
              [119.14975019600001, -67.11638762799993],
              [119.18148847700002, -67.11394622199992],
              [119.26677493600005, -67.12965260199991],
              [119.29769941500001, -67.13054778399993],
              [119.32837975400003, -67.12761809699992],
              [119.43832441500001, -67.09531015399995],
              [119.59831790500004, -67.07708098799992],
              [119.67204837300005, -67.04705169099992],
              [119.96159915500004, -67.01327890399995],
              [120.017914259, -66.99260833099993],
              [120.35173587300005, -66.93482838299991],
              [120.40162194100003, -66.94500090899993],
              [120.44597415500004, -66.97771575299993],
              [120.34131920700008, -67.01238372199992],
              [119.93903649200007, -67.07901376749993],
              [119.53675377700006, -67.14564381299994],
              [119.13447106200005, -67.21227385849994],
              [118.73218834700003, -67.27890390399995],
              [118.74586022200003, -67.28427499799994],
              [118.76026451900009, -67.28753020599993],
              [118.78956139400009, -67.2893205709999],
              [118.78386478000004, -67.29461028399993],
              [118.77442467500009, -67.30820077899995],
              [118.76889082100001, -67.31389739399992],
              [118.81373131600003, -67.3518205709999],
              [118.82764733200008, -67.35621510199991],
              [118.86540774800005, -67.35035572699991],
              [118.88396243600005, -67.34970468499995],
              [118.90284264400009, -67.35247161299992],
              [118.89975019600001, -67.3571916649999],
              [118.89503014400009, -67.36793385199991],
              [118.89193769600001, -67.37265390399995],
              [118.96241295700008, -67.38046640399995],
              [118.89047285200002, -67.4196916649999],
              [118.92359459700003, -67.42294687299994],
              [118.95671634200005, -67.42245859199994],
              [119.02222741000003, -67.41179778399993],
              [119.10320071700005, -67.38290780999995],
              [119.12875410200002, -67.38209400799991],
              [119.13363691500001, -67.38420989399992],
              [119.14332116000003, -67.39128997199992],
              [119.14869225400003, -67.39373137799993],
              [119.16504967500009, -67.39544036299992],
              [119.18311608200008, -67.39324309699992],
              [119.20053144600001, -67.38827890399995],
              [119.24439537900003, -67.37029387799993],
              [119.26978600400003, -67.36345794099992],
              [119.29615319100003, -67.35995859199994],
              [119.35645592500009, -67.35865650799991],
              [119.414398634, -67.3650041649999],
              [119.44353274800005, -67.36443450299993],
              [119.72738691500001, -67.31698984199994],
              [119.80250084700003, -67.32341887799993],
              [119.93189537900003, -67.29143645599993],
              [120.21558678500003, -67.26226165149993],
              [120.49927819100003, -67.23308684699992],
              [120.55396569100003, -67.21575286299992],
              [120.61622155000009, -67.20826588299991],
              [120.92066491000003, -67.13152434699992],
              [120.94971764400009, -67.13079192499993],
              [121.00684655000009, -67.14267343499995],
              [121.03777103000004, -67.14202239399992],
              [121.404633009, -67.08831145599993],
              [121.51531009200005, -67.09295012799993],
              [121.66309655000009, -67.05046965899993],
              [121.67741946700005, -67.04827239399992],
              [121.70134524800005, -67.05120208099993],
              [121.71607506600003, -67.04607512799993],
              [121.73031660200002, -67.03915780999995],
              [121.744476759, -67.0349260399999],
              [121.77540123800009, -67.02988046699994],
              [121.77320397200003, -67.02434661299992],
              [121.77084394600001, -67.01213958099993],
              [121.76872806100005, -67.00660572699991],
              [121.78419030000009, -67.00497812299994],
              [121.79688561300009, -67.00798919099992],
              [121.80836022200003, -67.01474374799994],
              [121.82007897200003, -67.02385833099993],
              [121.82837975400003, -67.02467213299991],
              [121.85084069100003, -67.0158830709999],
              [121.86426842500009, -67.01873137799993],
              [121.85230553500003, -66.99456145599993],
              [121.83375084700003, -66.99228280999995],
              [121.81495201900009, -66.99236419099992],
              [121.80193118600005, -66.97527434699992],
              [121.82984459700003, -66.96754322699991],
              [121.90837649800005, -66.92791106599992],
              [121.93775475400003, -66.91757577899995],
              [122.08204186300009, -66.89177825299993],
              [122.18848717500009, -66.85507577899995],
              [122.24439537900003, -66.84498463299991],
              [122.43653405000009, -66.83212655999995],
              [122.49293053500003, -66.81536223799992],
              [122.52051842500009, -66.8108049459999],
              [122.61060631600003, -66.81023528399993],
              [122.88025963650006, -66.77170175549992],
              [123.14991295700008, -66.73316822699991],
              [123.20915774800005, -66.73495859199994],
              [123.32764733200008, -66.75115325299993],
              [123.51612389400009, -66.75408294099992],
              [123.55787194100003, -66.74863046699994],
              [123.59253991000003, -66.73788827899995],
              [123.66374759200005, -66.70501067499993],
              [123.69353274800005, -66.68417734199994],
              [123.70240319100003, -66.67376067499993],
              [123.70655358200008, -66.66529713299991],
              [123.713226759, -66.6579729149999],
              [123.73031660200002, -66.65032317499993],
              [123.93148847700002, -66.60816822699991],
              [123.96241295700008, -66.61012135199991],
              [123.96762129000001, -66.60702890399995],
              [123.97193444100003, -66.60198333099993],
              [123.98161868600005, -66.59677499799994],
              [123.99976647200003, -66.59107838299991],
              [124.01514733200008, -66.58879973799992],
              [124.03044681100005, -66.59091562299994],
              [124.04867597700002, -66.59872812299994],
              [124.01954186300009, -66.61321379999993],
              [124.03663170700008, -66.61435312299994],
              [124.05079186300009, -66.60995859199994],
              [124.09392337300005, -66.59091562299994],
              [124.10352623800009, -66.58863697699991],
              [124.26050866000003, -66.59498463299991],
              [124.26124108200008, -66.62322356599992],
              [124.28394616000003, -66.63632577899995],
              [124.36524498800009, -66.65178801899992],
              [124.37126712300005, -66.65837981599992],
              [124.37305748800009, -66.67424895599993],
              [124.36931399800005, -66.68523528399993],
              [124.36011803500003, -66.69793059699992],
              [124.340179884, -66.71786874799994],
              [124.35873457100001, -66.71998463299991],
              [124.37696373800009, -66.71892669099992],
              [124.41358483200008, -66.71233489399992],
              [124.42847741000003, -66.7131486959999],
              [124.455414259, -66.72087981599992],
              [124.47144616000003, -66.71721770599993],
              [124.46729576900009, -66.72258879999993],
              [124.46070397200003, -66.73455169099992],
              [124.45655358200008, -66.73992278399993],
              [124.48389733200008, -66.73381926899992],
              [124.51392662900003, -66.73137786299992],
              [124.57178795700008, -66.73406340899993],
              [124.57813561300009, -66.73308684699992],
              [124.59156334700003, -66.72730885199991],
              [124.59717858200008, -66.72722747199992],
              [124.60336347700002, -66.73211028399993],
              [124.61638431100005, -66.74968840899993],
              [124.62281334700003, -66.75644296699994],
              [124.63738040500004, -66.76311614399992],
              [124.65406334700003, -66.76572030999995],
              [124.67115319100003, -66.76572030999995],
              [124.71680748800009, -66.75920989399992],
              [124.77955162900003, -66.74114348799992],
              [124.80591881600003, -66.72779713299991],
              [124.81381269600001, -66.71754322699991],
              [124.81739342500009, -66.70623137799993],
              [124.82520592500009, -66.69768645599993],
              [124.84571373800009, -66.69597747199992],
              [124.85157311300009, -66.6994768209999],
              [124.86296634200005, -66.7131486959999],
              [124.86850019600001, -66.7165666649999],
              [124.87777754000001, -66.71591562299994],
              [125.02475019600001, -66.6794572899999],
              [125.12208092500009, -66.66765715899993],
              [125.14812259200005, -66.65960051899992],
              [125.20036868600005, -66.63128020599993],
              [125.22478274800005, -66.61223723799992],
              [125.23812910200002, -66.5901018209999],
              [125.24878991000003, -66.5622697899999],
              [125.26587975400003, -66.53948333099993],
              [125.28956139400009, -66.5236955709999],
              [125.32007897200003, -66.51702239399992],
              [125.33472741000003, -66.44890715899993],
              [125.41041100400003, -66.41765715899993],
              [125.70484459700003, -66.39137135199991],
              [125.73658287900003, -66.37802499799994],
              [125.77003014400009, -66.35808684699992],
              [125.89779707100001, -66.30624765399995],
              [125.91911868600005, -66.3029924459999],
              [125.94060306100005, -66.30234140399995],
              [125.95850670700008, -66.30510833099993],
              [125.97339928500003, -66.31259530999995],
              [125.98731530000009, -66.3225236959999],
              [126.00310306100005, -66.33098723799992],
              [126.06763756600003, -66.33993905999995],
              [126.09376061300009, -66.36101653399993],
              [126.10816491000003, -66.39495208099993],
              [126.11638431100005, -66.43906015399995],
              [126.17595462300005, -66.46998463299991],
              [126.19483483200008, -66.45956796699994],
              [126.21509850400003, -66.4533830709999],
              [126.25847415500004, -66.44817473799992],
              [126.297211134, -66.45354583099993],
              [126.32837975400003, -66.46990325299993],
              [126.33277428500003, -66.4880510399999],
              [126.29127037900003, -66.49911874799994],
              [126.30518639400009, -66.51474374799994],
              [126.35401451900009, -66.55315520599993],
              [126.37232506600003, -66.56161874799994],
              [126.39258873800009, -66.55266692499993],
              [126.40235436300009, -66.52695077899995],
              [126.40870201900009, -66.46786874799994],
              [126.39991295700008, -66.3889299459999],
              [126.40308678500003, -66.37200286299992],
              [126.43043053500003, -66.35466887799993],
              [126.45679772200003, -66.3571916649999],
              [126.48422285200002, -66.36728280999995],
              [126.51441491000003, -66.37265390399995],
              [126.49561608200008, -66.4045549459999],
              [126.49048912900003, -66.42302825299993],
              [126.50049889400009, -66.43043385199991],
              [126.51783287900003, -66.43254973799992],
              [126.553070509, -66.44304778399993],
              [126.56853274800005, -66.44459400799991],
              [126.58090254000001, -66.44052499799994],
              [126.63038170700008, -66.41594817499993],
              [126.648773634, -66.41033294099992],
              [126.68677819100003, -66.40447356599992],
              [126.70606530000009, -66.40471770599993],
              [126.66749108200008, -66.4221330709999],
              [126.68458092500009, -66.44304778399993],
              [126.70386803500003, -66.4455705709999],
              [126.75001061300009, -66.43466562299994],
              [126.77670332100001, -66.43499114399992],
              [126.85425866000003, -66.44931405999995],
              [126.83073978000004, -66.4787736959999],
              [126.82195071700005, -66.48626067499993],
              [126.80884850400003, -66.49138762799993],
              [126.77995853000004, -66.49675872199992],
              [126.76661217500009, -66.50269947699991],
              [126.74870853000004, -66.52206796699994],
              [126.74903405000009, -66.53753020599993],
              [126.75123131600003, -66.55437590899993],
              [126.73951256600003, -66.57691822699991],
              [126.71892337300005, -66.59286874799994],
              [126.69459069100003, -66.6013322899999],
              [126.64380944100003, -66.61101653399993],
              [126.61841881600003, -66.6193986959999],
              [126.60092207100001, -66.6306291649999],
              [126.56950931100005, -66.6657854149999],
              [126.67090905000009, -66.64348723799992],
              [126.70411217500009, -66.64128997199992],
              [126.76587975400003, -66.65243905999995],
              [126.779633009, -66.65894947699991],
              [126.80494225400003, -66.68230559699992],
              [126.81918379000001, -66.69133879999993],
              [126.79672285200002, -66.71575286299992],
              [126.71501712300005, -66.73919036299992],
              [126.68051191500001, -66.75693124799994],
              [126.67465254000001, -66.7697893209999],
              [126.66456139400009, -66.8166643209999],
              [126.66570071700005, -66.8318010399999],
              [126.68213951900009, -66.84539153399993],
              [126.70386803500003, -66.8459611959999],
              [126.96827233200008, -66.80787525799991],
              [126.98178144600001, -66.80982838299991],
              [127.06275475400003, -66.84872812299994],
              [127.03565514400009, -66.89511484199994],
              [127.01889082100001, -66.91643645599993],
              [126.99870853000004, -66.93279387799993],
              [127.08285566500001, -66.95631275799991],
              [127.06592858200008, -66.96933359199994],
              [127.05876712300005, -66.98333098799992],
              [127.05730228000004, -67.00009530999995],
              [127.05787194100003, -67.02109140399995],
              [127.05665123800009, -67.02874114399992],
              [127.053070509, -67.03622812299994],
              [127.04444420700008, -67.04998137799993],
              [127.04517662900003, -67.05738697699991],
              [127.05388431100005, -67.06267669099992],
              [127.06470787900003, -67.06747812299994],
              [127.07154381600003, -67.07341887799993],
              [127.06967207100001, -67.08709075299993],
              [127.06413821700005, -67.10637786299992],
              [127.06462649800005, -67.12468840899993],
              [127.08139082100001, -67.13543059699992],
              [127.09888756600003, -67.13372161299992],
              [127.11231530000009, -67.12444426899992],
              [127.14942467500009, -67.08082447699991],
              [127.15699303500003, -67.06804778399993],
              [127.15788821700005, -67.05396900799991],
              [127.15170332100001, -67.03443775799991],
              [127.15455162900003, -67.02027760199991],
              [127.16773522200003, -67.00335051899992],
              [127.18458092500009, -66.98845794099992],
              [127.19874108200008, -66.97975025799991],
              [127.363617384, -66.93108489399992],
              [127.33423912900003, -66.98162200299993],
              [127.35678144600001, -66.99163176899992],
              [127.36736087300005, -66.9983049459999],
              [127.37029056100005, -67.00554778399993],
              [127.35962975400003, -67.03337981599992],
              [127.36101321700005, -67.04387786299992],
              [127.37134850400003, -67.05437590899993],
              [127.40113366000003, -67.06755950299993],
              [127.43238366000003, -67.07040780999995],
              [127.61548912900003, -67.04900481599992],
              [127.69450931100005, -67.05673593499995],
              [127.83643639400009, -67.02117278399993],
              [127.86573326900009, -67.0197893209999],
              [127.92261803500003, -67.0290666649999],
              [128.074554884, -67.02239348799992],
              [128.08187910200002, -67.02613697699991],
              [128.08814537900003, -67.03573984199994],
              [128.10303795700008, -67.07586028399993],
              [128.1093856130001, -67.08318450299993],
              [128.16391035200002, -67.10125090899993],
              [128.18531334700003, -67.10418059699992],
              [128.20671634200005, -67.10035572699991],
              [128.2959090500001, -67.07431405999995],
              [128.33090254, -67.07187265399995],
              [128.35710696700005, -67.0783830709999],
              [128.36597741000003, -67.08831145599993],
              [128.37517337300005, -67.11101653399993],
              [128.382172071, -67.11793385199991],
              [128.49293053500003, -67.1443010399999],
              [128.5205184250001, -67.14576588299991],
              [128.6250106130001, -67.12322356599992],
              [128.682953321, -67.11874765399995],
              [128.707367384, -67.10833098799992],
              [128.72429446700005, -67.08896249799994],
              [128.73308353000004, -67.05917734199994],
              [128.76351972700002, -67.02581145599993],
              [128.82390384200005, -67.03427499799994],
              [129.01286868600005, -67.11174895599993],
              [129.021820509, -67.12265390399995],
              [129.03687584700003, -67.15553150799991],
              [129.06462649800005, -67.17441171699994],
              [129.0996199880001, -67.1677385399999],
              [129.20264733200008, -67.10035572699991],
              [129.21119225400003, -67.09254322699991],
              [129.21371504, -67.08521900799991],
              [129.2138778000001, -67.06747812299994],
              [129.21599368600005, -67.05966562299994],
              [129.22217858200008, -67.05022551899992],
              [129.2465926440001, -67.02418385199991],
              [129.272797071, -67.00741952899995],
              [129.4340926440001, -66.96721770599993],
              [129.44450931100005, -66.9592424459999],
              [129.444672071, -66.94426848799992],
              [129.43637129, -66.92766692499993],
              [129.4243270190001, -66.91326262799993],
              [129.38461347700002, -66.87786223799992],
              [129.392914259, -66.85808684699992],
              [129.42212975400003, -66.84303150799991],
              [129.4790145190001, -66.82317473799992],
              [129.49366295700008, -66.81536223799992],
              [129.504730665, -66.80348072699991],
              [129.51677493600005, -66.78386809699992],
              [129.52686608200008, -66.77507903399993],
              [129.57585696700005, -66.75017669099992],
              [129.58472741000003, -66.72918059699992],
              [129.54957116000003, -66.71884530999995],
              [129.50074303500003, -66.71591562299994],
              [129.46900475400003, -66.71746184699992],
              [129.4746199880001, -66.69101327899995],
              [129.5087996750001, -66.65252044099992],
              [129.51978600400003, -66.62957122199992],
              [129.532562696, -66.61443450299993],
              [129.5590926440001, -66.60027434699992],
              [129.63786868600005, -66.57463958099993],
              [129.65503991000003, -66.56145598799992],
              [129.670258009, -66.54631926899992],
              [129.69157962300005, -66.53215911299992],
              [129.71045983200008, -66.51523202899995],
              [129.72543379, -66.48772551899992],
              [129.7309676440001, -66.45916106599992],
              [129.7216903000001, -66.43824635199991],
              [129.80201256600003, -66.4060197899999],
              [129.87671959700003, -66.36239999799994],
              [129.91423587300005, -66.35149504999993],
              [130.00896243600005, -66.34612395599993],
              [130.0351668630001, -66.33098723799992],
              [130.06430097700002, -66.29404062299994],
              [130.10271243600005, -66.27678801899992],
              [130.23609459700003, -66.26067473799992],
              [130.25464928500003, -66.26295338299991],
              [130.29175866000003, -66.27996184699992],
              [130.3105574880001, -66.27809010199991],
              [130.34839928500003, -66.26572030999995],
              [130.34644616000003, -66.27288176899992],
              [130.344574415, -66.28818124799994],
              [130.34245853000004, -66.2951799459999],
              [130.462250196, -66.25204843499995],
              [130.52995853000004, -66.24163176899992],
              [130.562836134, -66.26165129999993],
              [130.58082116000003, -66.24187590899993],
              [130.6040145190001, -66.1970354149999],
              [130.62378991000003, -66.18515390399995],
              [130.70484459700003, -66.14959075299993],
              [130.72999108200008, -66.14714934699992],
              [130.84009850400003, -66.17848072699991],
              [130.8715926440001, -66.18328215899993],
              [131.02100670700008, -66.18710702899995],
              [131.0708113940001, -66.19841887799993],
              [131.09888756600003, -66.20134856599992],
              [131.1572371750001, -66.19524504999993],
              [131.18482506600003, -66.19915129999993],
              [131.1962996750001, -66.20566171699994],
              [131.2177840500001, -66.22332122199992],
              [131.23023522200003, -66.23007577899995],
              [131.2431746750001, -66.23398202899995],
              [131.26929772200003, -66.23796965899993],
              [131.3242293630001, -66.24041106599992],
              [131.3383895190001, -66.23796965899993],
              [131.352386915, -66.23202890399995],
              [131.38160241000003, -66.21502044099992],
              [131.3945418630001, -66.21168385199991],
              [131.7578231130001, -66.24334075299993],
              [132.05030358200008, -66.2170549459999],
              [132.147797071, -66.17815520599993],
              [132.47828209700003, -66.1506486959999],
              [132.50359134200005, -66.15553150799991],
              [132.55689537900003, -66.17522551899992],
              [132.60670006600003, -66.18645598799992],
              [132.82691491000003, -66.19036223799992],
              [133.01636803500003, -66.14544036299992],
              [133.09131920700008, -66.10540129999993],
              [133.12037194100003, -66.09677499799994],
              [133.27564537900003, -66.08017343499995],
              [133.50074303500003, -66.08326588299991],
              [133.60710696700005, -66.10816822699991],
              [133.792328321, -66.10540129999993],
              [133.82447350400003, -66.1135393209999],
              [133.85425866000003, -66.12753671699994],
              [133.8735457690001, -66.14568450299993],
              [133.89079837300005, -66.16904062299994],
              [133.910492384, -66.18401458099993],
              [133.93384850400003, -66.1931291649999],
              [133.962250196, -66.19817473799992],
              [133.9755965500001, -66.19833749799994],
              [134.002289259, -66.19500090899993],
              [134.01514733200008, -66.19548919099992],
              [134.07585696700005, -66.21738046699994],
              [134.1269637380001, -66.22714609199994],
              [134.1489363940001, -66.23723723799992],
              [134.19109134200005, -66.27947356599992],
              [134.2114363940001, -66.27996184699992],
              [134.23308353000004, -66.27467213299991],
              [134.25945071700005, -66.2795549459999],
              [134.2646590500001, -66.28606536299992],
              [134.2714949880001, -66.30608489399992],
              [134.27808678500003, -66.31357187299994],
              [134.29078209700003, -66.31894296699994],
              [134.30144290500004, -66.32024504999993],
              [134.37663821700005, -66.3064104149999],
              [134.40357506600003, -66.30527109199994],
              [134.42652428500003, -66.31145598799992],
              [134.438812696, -66.32919687299994],
              [134.42058353000004, -66.34319426899992],
              [134.3462020190001, -66.3669572899999],
              [134.26124108200008, -66.41285572699991],
              [134.229828321, -66.44198984199994],
              [134.1093856130001, -66.50457122199992],
              [134.1640731130001, -66.51279062299994],
              [134.33904056100005, -66.48308684699992],
              [134.3271590500001, -66.48919036299992],
              [134.3164168630001, -66.49716562299994],
              [134.306976759, -66.50660572699991],
              [134.2988387380001, -66.5173479149999],
              [134.3501082690001, -66.51995208099993],
              [134.42066491000003, -66.49651458099993],
              [134.76677493600005, -66.3376604149999],
              [134.7392684250001, -66.36728280999995],
              [134.87370853000004, -66.35702890399995],
              [134.93580162900003, -66.34172942499993],
              [134.9575301440001, -66.34335702899995],
              [134.98658287900003, -66.35808684699992],
              [135.01059004, -66.36541106599992],
              [135.035492384, -66.36467864399992],
              [135.17847741000003, -66.33147551899992],
              [135.17644290500004, -66.3108049459999],
              [135.17920983200008, -66.29159921699994],
              [135.17847741000003, -66.27467213299991],
              [135.1665145190001, -66.26132577899995],
              [135.18726647200003, -66.25888437299994],
              [135.22836347700002, -66.24716562299994],
              [135.28858483200008, -66.22283294099992],
              [135.29761803500003, -66.21575286299992],
              [135.30241946700005, -66.16269296699994],
              [135.3193465500001, -66.12664153399993],
              [135.33171634200005, -66.10816822699991],
              [135.34302819100003, -66.10068124799994],
              [135.48845462300005, -66.11101653399993],
              [135.49431399800005, -66.11467864399992],
              [135.49732506600003, -66.12224700299993],
              [135.49976647200003, -66.1311174459999],
              [135.5039168630001, -66.13860442499993],
              [135.53825931100005, -66.17498137799993],
              [135.5449324880001, -66.18027109199994],
              [135.56080162900003, -66.18523528399993],
              [135.56812584700003, -66.19003671699994],
              [135.61158287900003, -66.24521249799994],
              [135.64730879, -66.27809010199991],
              [135.64966881600003, -66.30071379999993],
              [135.641449415, -66.32439544099992],
              [135.62964928500003, -66.3474260399999],
              [135.66627037900003, -66.35426197699991],
              [135.69890384200005, -66.32919687299994],
              [135.7285262380001, -66.2951799459999],
              [135.7563582690001, -66.27597421699994],
              [135.80884850400003, -66.26767343499995],
              [135.817230665, -66.26864999799994],
              [135.8330184250001, -66.27727629999993],
              [135.84099368600005, -66.2790666649999],
              [135.86215254, -66.27548593499995],
              [135.9052840500001, -66.26140715899993],
              [135.927093946, -66.25693124799994],
              [135.98072350400003, -66.26091887799993],
              [135.99683678500003, -66.25920989399992],
              [136.08375084700003, -66.23756275799991],
              [136.12842858200008, -66.23552825299993],
              [136.159515821, -66.24537525799991],
              [136.22527103000004, -66.28728606599992],
              [136.28435306100005, -66.31658294099992],
              [136.30225670700008, -66.32805754999993],
              [136.33415774800005, -66.35702890399995],
              [136.3520613940001, -66.36809661299992],
              [136.38851972700002, -66.37965260199991],
              [136.51124108200008, -66.39544036299992],
              [136.526703321, -66.40007903399993],
              [136.54468834700003, -66.40984465899993],
              [136.55982506600003, -66.42245859199994],
              [136.56714928500003, -66.43547942499993],
              [136.57211347700002, -66.45696379999993],
              [136.58090254, -66.47332122199992],
              [136.639008009, -66.52947356599992],
              [136.6567488940001, -66.5407854149999],
              [136.67164147200003, -66.54062265399995],
              [136.70622806100005, -66.51287200299993],
              [136.7192488940001, -66.49732838299991],
              [136.73194420700008, -66.47722747199992],
              [136.70769290500004, -66.47454192499993],
              [136.66089928500003, -66.46038176899992],
              [136.63648522200003, -66.45647551899992],
              [136.6562606130001, -66.40007903399993],
              [136.68962649800005, -66.36638762799993],
              [136.73601321700005, -66.34872812299994],
              [136.94459069100003, -66.32822030999995],
              [137.414886915, -66.35027434699992],
              [137.457855665, -66.34482187299994],
              [137.46949303500003, -66.34775155999995],
              [137.49000084700003, -66.36174895599993],
              [137.50147545700008, -66.36541106599992],
              [137.66911868600005, -66.37769947699991],
              [137.71070397200003, -66.36882903399993],
              [137.72055097700002, -66.36809661299992],
              [137.73194420700008, -66.37420012799993],
              [137.75513756600003, -66.39560312299994],
              [137.7675887380001, -66.40309010199991],
              [137.78101647200003, -66.40667083099993],
              [137.82243899800005, -66.40960051899992],
              [137.84636478000004, -66.41562265399995],
              [137.91138756600003, -66.44231536299992],
              [137.92139733200008, -66.44793059699992],
              [137.927093946, -66.45476653399993],
              [137.933929884, -66.46103280999995],
              [137.9589949880001, -66.46575286299992],
              [137.9707137380001, -66.46949635199991],
              [137.9926863940001, -66.48040129999993],
              [138.01872806100005, -66.4885393209999],
              [138.1416121750001, -66.49871184699992],
              [138.148773634, -66.50400155999995],
              [138.16293379, -66.52532317499993],
              [138.1718856130001, -66.53313567499993],
              [138.18433678500003, -66.53834400799991],
              [138.1333113940001, -66.62395598799992],
              [138.180023634, -66.61581796699994],
              [138.221039259, -66.60076262799993],
              [138.2993270190001, -66.55315520599993],
              [138.3330184250001, -66.53997161299992],
              [138.37810306100005, -66.5334611959999],
              [138.60710696700005, -66.54168059699992],
              [138.616547071, -66.53915780999995],
              [138.63347415500004, -66.52532317499993],
              [138.64136803500003, -66.52288176899992],
              [138.64869225400003, -66.52743905999995],
              [138.66293379, -66.54534270599993],
              [138.66960696700005, -66.55185312299994],
              [138.67896569100003, -66.55575937299994],
              [138.73210696700005, -66.56959400799991],
              [138.75277754, -66.56731536299992],
              [138.77361087300005, -66.56259530999995],
              [138.92644290500004, -66.55624765399995],
              [138.96859785200002, -66.55982838299991],
              [139.02955162900003, -66.57586028399993],
              [139.0459090500001, -66.5759416649999],
              [139.091156446, -66.56658294099992],
              [139.17693118600005, -66.57122161299992],
              [139.25171959700003, -66.56715260199991],
              [139.45492597700002, -66.5940080709999],
              [139.441742384, -66.6233049459999],
              [139.452484571, -66.64185963299991],
              [139.477386915, -66.65056731599992],
              [139.50700931100005, -66.65032317499993],
              [139.52491295700008, -66.64592864399992],
              [139.57349694100003, -66.62769947699991],
              [139.5903426440001, -66.62558359199994],
              [139.67758222700002, -66.63046640399995],
              [139.71168053500003, -66.64080169099992],
              [139.77702884200005, -66.6701799459999],
              [139.81218509200005, -66.67937590899993],
              [139.84131920700008, -66.68222421699994],
              [139.86703535200002, -66.69182708099993],
              [139.89185631600003, -66.72161223799992],
              [139.86736087300005, -66.73349374799994],
              [139.84156334700003, -66.7502580709999],
              [139.82374108200008, -66.77157968499995],
              [139.8227645190001, -66.79697030999995],
              [139.86451256600003, -66.77597421699994],
              [139.91553795700008, -66.7575822899999],
              [139.96550540500004, -66.75188567499993],
              [140.02173912900003, -66.77450937299994],
              [140.04086347700002, -66.76238372199992],
              [140.06080162900003, -66.74456145599993],
              [140.08155358200008, -66.73316822699991],
              [140.110199415, -66.72918059699992],
              [140.284515821, -66.72909921699994],
              [140.3144637380001, -66.73544687299994],
              [140.33570397200003, -66.74716562299994],
              [140.376312696, -66.78460051899992],
              [140.3847762380001, -66.78704192499993],
              [140.39405358200008, -66.78289153399993],
              [140.41081790500004, -66.76751067499993],
              [140.41724694100003, -66.75318775799991],
              [140.413422071, -66.7439104149999],
              [140.41472415500004, -66.73723723799992],
              [140.43628991000003, -66.73088958099993],
              [140.46273847700002, -66.72673919099992],
              [140.51742597700002, -66.72503020599993],
              [140.69548587300005, -66.74920012799993],
              [140.90162194100003, -66.75302499799994],
              [141.00367272200003, -66.7673479149999],
              [141.2602645190001, -66.85702890399995],
              [141.28101647200003, -66.86150481599992],
              [141.29656009200005, -66.8537736959999],
              [141.3056746750001, -66.82740650799991],
              [141.33562259200005, -66.83717213299991],
              [141.36207116000003, -66.83945077899995],
              [141.388031446, -66.83456796699994],
              [141.44459069100003, -66.81243254999993],
              [141.5781356130001, -66.77996184699992],
              [141.98170006600003, -66.79998137799993],
              [142.0927840500001, -66.82740650799991],
              [142.19874108200008, -66.87590911299992],
              [142.21892337300005, -66.89226653399993],
              [142.24927819100003, -66.93124765399995],
              [142.26775149800005, -66.94841887799993],
              [142.2739363940001, -66.95012786299992],
              [142.28972415500004, -66.94939544099992],
              [142.29639733200008, -66.95012786299992],
              [142.30241946700005, -66.95419687299994],
              [142.31316165500004, -66.96559010199991],
              [142.31902103000004, -66.96949635199991],
              [142.33578535200002, -66.97323984199994],
              [142.3462020190001, -66.97380950299993],
              [142.3564559250001, -66.97779713299991],
              [142.37256920700008, -66.99187590899993],
              [142.415375196, -67.01425546699994],
              [142.4770613940001, -67.02597421699994],
              [142.82203209700003, -67.01970794099992],
              [142.88103274800005, -67.00872161299992],
              [142.99878991000003, -66.96209075299993],
              [143.4707137380001, -66.84563567499993],
              [143.5083113940001, -66.84465911299992],
              [143.750824415, -66.88030364399992],
              [143.823578321, -66.90113697699991],
              [143.86101321700005, -66.9196916649999],
              [143.87614993600005, -66.94036223799992],
              [143.86345462300005, -66.9958635399999],
              [143.8652449880001, -67.0139299459999],
              [143.8750106130001, -67.03281015399995],
              [143.884125196, -67.04143645599993],
              [143.8872176440001, -67.05136484199994],
              [143.87859134200005, -67.07366301899992],
              [143.85531660200002, -67.09417083099993],
              [143.78109785200002, -67.12070077899995],
              [143.75147545700008, -67.13941822699991],
              [144.04420006600003, -67.0876604149999],
              [144.06910241000003, -67.0861955709999],
              [144.07569420700008, -67.09221770599993],
              [144.07878665500004, -67.1057268209999],
              [144.08130944100003, -67.13445403399993],
              [144.08855228000004, -67.15374114399992],
              [144.10084069100003, -67.17156340899993],
              [144.11475670700008, -67.17742278399993],
              [144.12712649800005, -67.16106536299992],
              [144.14527428500003, -67.09270598799992],
              [144.154633009, -67.07333749799994],
              [144.184906446, -67.0446916649999],
              [144.22681725400003, -67.0236955709999],
              [144.272797071, -67.00986093499995],
              [144.31560306100005, -67.00269947699991],
              [144.41431725400003, -67.00123463299991],
              [144.51246178500003, -67.01572030999995],
              [144.5459090500001, -67.03134530999995],
              [144.6455184250001, -67.09539153399993],
              [144.66236412900003, -67.11663176899992],
              [144.63013756600003, -67.16057708099993],
              [144.59693444100003, -67.18564218499995],
              [144.556000196, -67.19597747199992],
              [144.5009871750001, -67.19670989399992],
              [144.45728600400003, -67.18759530999995],
              [144.40943444100003, -67.1721330709999],
              [144.362640821, -67.16277434699992],
              [144.32146243600005, -67.1716447899999],
              [144.340179884, -67.19491952899995],
              [144.35857181100005, -67.2072893209999],
              [144.38103274800005, -67.21103280999995],
              [144.43726647200003, -67.20761484199994],
              [144.46436608200008, -67.21355559699992],
              [144.49089603000004, -67.22323984199994],
              [144.5141707690001, -67.23455169099992],
              [144.506195509, -67.24911874799994],
              [144.4843856130001, -67.26873137799993],
              [144.4755965500001, -67.28069426899992],
              [144.45573978000004, -67.32268645599993],
              [144.44646243600005, -67.3337541649999],
              [144.43238366000003, -67.34343840899993],
              [144.38746178500003, -67.3591447899999],
              [144.37647545700008, -67.36532968499995],
              [144.3252059250001, -67.40553150799991],
              [144.30103600400003, -67.41741301899992],
              [144.27515709700003, -67.42131926899992],
              [144.2480574880001, -67.4138322899999],
              [144.2251082690001, -67.3923479149999],
              [144.20183353000004, -67.36386484199994],
              [144.177093946, -67.34710051899992],
              [144.14966881600003, -67.3610979149999],
              [144.1435653000001, -67.37411874799994],
              [144.1455184250001, -67.38323333099993],
              [144.14633222700002, -67.3928361959999],
              [144.137054884, -67.40699635199991],
              [144.11784915500004, -67.41708749799994],
              [144.09880618600005, -67.41904062299994],
              [144.08570397200003, -67.42473723799992],
              [144.0844832690001, -67.44548919099992],
              [144.09156334700003, -67.45077890399995],
              [144.12330162900003, -67.45387135199991],
              [144.137543165, -67.45745208099993],
              [144.15544681100005, -67.46803150799991],
              [144.1645613940001, -67.47844817499993],
              [144.16675866000003, -67.4919572899999],
              [144.16391035200002, -67.51262786299992],
              [144.1645613940001, -67.52605559699992],
              [144.16968834700003, -67.53980885199991],
              [144.1845809250001, -67.56438567499993],
              [144.1919051440001, -67.58123137799993],
              [144.18970787900003, -67.59563567499993],
              [144.18091881600003, -67.6091447899999],
              [144.14437910200002, -67.64568450299993],
              [144.11939537900003, -67.66423919099992],
              [144.0927840500001, -67.67962004999993],
              [144.04908287900003, -67.69817473799992],
              [143.983734571, -67.7165666649999],
              [143.9091903000001, -67.7561174459999],
              [143.88013756600003, -67.7810197899999],
              [143.85670006600003, -67.81194426899992],
              [143.84058678500003, -67.84726327899995],
              [143.86939537900003, -67.84758879999993],
              [143.95476321700005, -67.83326588299991],
              [143.92017662900003, -67.84970468499995],
              [143.91163170700008, -67.86101653399993],
              [143.91358483200008, -67.87965260199991],
              [143.91179446700005, -67.89251067499993],
              [143.9023543630001, -67.90748463299991],
              [143.88070722700002, -67.9338518209999],
              [143.95264733200008, -67.94589609199994],
              [144.02027428500003, -67.93572356599992],
              [144.15593509200005, -67.88551197699991],
              [144.1406356130001, -67.91838958099993],
              [144.13648522200003, -67.93564218499995],
              [144.13851972700002, -67.9533830709999],
              [144.18580162900003, -67.93987395599993],
              [144.20679772200003, -67.94019947699991],
              [144.2295028000001, -67.95037200299993],
              [144.24870853000004, -67.95435963299991],
              [144.26921634200005, -67.94687265399995],
              [144.35173587300005, -67.89999765399995],
              [144.4257918630001, -67.82488372199992],
              [144.469086134, -67.79436614399992],
              [144.55583743600005, -67.76132577899995],
              [144.60181725400003, -67.75115325299993],
              [144.64730879, -67.74765390399995],
              [144.809418165, -67.75497812299994],
              [144.8632918630001, -67.74968840899993],
              [144.90503991000003, -67.73772551899992],
              [144.94206790500004, -67.71892669099992],
              [145.05437259200005, -67.63518645599993],
              [145.23812910200002, -67.52825286299992],
              [145.2797957690001, -67.51572030999995],
              [145.32300866000003, -67.51043059699992],
              [145.42139733200008, -67.50920989399992],
              [145.4443465500001, -67.51482512799993],
              [145.46062259200005, -67.53411223799992],
              [145.48422285200002, -67.5764299459999],
              [145.48894290500004, -67.59661223799992],
              [145.4814559250001, -67.62346770599993],
              [145.5063582690001, -67.63014088299991],
              [145.529633009, -67.64104583099993],
              [145.53663170700008, -67.65129973799992],
              [145.53345787900003, -67.66464609199994],
              [145.5278426440001, -67.67839934699992],
              [145.52662194100003, -67.69052499799994],
              [145.5459090500001, -67.71209075299993],
              [145.579437696, -67.72820403399993],
              [145.61589603000004, -67.73707447699991],
              [145.64429772200003, -67.73699309699992],
              [145.688324415, -67.7009416649999],
              [145.70777428500003, -67.64413827899995],
              [145.7334090500001, -67.59295012799993],
              [145.79704837300005, -67.5739885399999],
              [145.91724694100003, -67.58904387799993],
              [146.04810631600003, -67.58660247199992],
              [146.075043165, -67.5920549459999],
              [146.13013756600003, -67.61402760199991],
              [146.19068444100003, -67.6228166649999],
              [146.20191491000003, -67.64397551899992],
              [146.2080184250001, -67.66920338299991],
              [146.228851759, -67.68710702899995],
              [146.20240319100003, -67.70574309699992],
              [146.109711134, -67.74960702899995],
              [146.12647545700008, -67.76482512799993],
              [146.17530358200008, -67.76913827899995],
              [146.1972762380001, -67.78248463299991],
              [146.21306399800005, -67.79794687299994],
              [146.24919681100005, -67.82146575299993],
              [146.26343834700003, -67.83505624799994],
              [146.30095462300005, -67.8513322899999],
              [146.34441165500004, -67.83131275799991],
              [146.3837996750001, -67.79265715899993],
              [146.4087020190001, -67.75351327899995],
              [146.44157962300005, -67.73113372199992],
              [146.489105665, -67.74179452899995],
              [146.52898196700005, -67.77027760199991],
              [146.53793379, -67.80242278399993],
              [146.51091556100005, -67.84148528399993],
              [146.4736434250001, -67.87379322699991],
              [146.43043053500003, -67.8986955709999],
              [146.38542728000004, -67.91521575299993],
              [146.4101668630001, -67.95175546699994],
              [146.45476321700005, -67.94939544099992],
              [146.504242384, -67.93564218499995],
              [146.54444420700008, -67.93759530999995],
              [146.5302840500001, -67.94939544099992],
              [146.5278426440001, -67.96087004999993],
              [146.53345787900003, -67.97323984199994],
              [146.54322350400003, -67.98739999799994],
              [146.55298912900003, -67.98894622199992],
              [146.56804446700005, -67.98105234199994],
              [146.59498131600003, -67.96152109199994],
              [146.6157332690001, -67.95134856599992],
              [146.64079837300005, -67.94378020599993],
              [146.66675866000003, -67.93938567499993],
              [146.68970787900003, -67.93889739399992],
              [146.68246504, -67.94231536299992],
              [146.6621199880001, -67.95476653399993],
              [146.71111087300005, -67.95973072699991],
              [146.81983483200008, -67.92058684699992],
              [146.87281334700003, -67.93759530999995],
              [146.80445397200003, -68.00066497199992],
              [146.63428795700008, -68.08709075299993],
              [146.55827884200005, -68.14324309699992],
              [146.58090254, -68.1506486959999],
              [146.60230553500003, -68.17848072699991],
              [146.61939537900003, -68.18320077899995],
              [146.70427493600005, -68.1696916649999],
              [146.79517662900003, -68.13909270599993],
              [146.97136478000004, -68.05217864399992],
              [147.02458743600005, -68.03394947699991],
              [147.06470787900003, -68.03875090899993],
              [147.07398522200003, -68.05429452899995],
              [147.07781009200005, -68.07756926899992],
              [147.076508009, -68.10116952899995],
              [147.0712996750001, -68.1174455709999],
              [147.05494225400003, -68.13469817499993],
              [147.03467858200008, -68.14885833099993],
              [146.9912215500001, -68.17107512799993],
              [146.85954837300005, -68.20916106599992],
              [146.8056746750001, -68.24285247199992],
              [146.7451278000001, -68.27068450299993],
              [146.7212020190001, -68.28769296699994],
              [146.71802819100003, -68.30339934699992],
              [146.73218834700003, -68.31601327899995],
              [146.76002037900003, -68.32317473799992],
              [146.8056746750001, -68.31943124799994],
              [146.89372806100005, -68.2932268209999],
              [146.93572024800005, -68.29615650799991],
              [146.9438582690001, -68.30282968499995],
              [146.9443465500001, -68.31015390399995],
              [146.94711347700002, -68.31560637799993],
              [146.96241295700008, -68.31658294099992],
              [147.1079207690001, -68.29404062299994],
              [147.09782962300005, -68.31129322699991],
              [147.09717858200008, -68.34099700299993],
              [147.08277428500003, -68.35947030999995],
              [147.04997806100005, -68.38046640399995],
              [147.038422071, -68.39275481599992],
              [147.03044681100005, -68.41562265399995],
              [147.06039472700002, -68.42278411299992],
              [147.08863366000003, -68.4196916649999],
              [147.17448978000004, -68.39470794099992],
              [147.18620853000004, -68.39511484199994],
              [147.2148543630001, -68.40984465899993],
              [147.2304793630001, -68.41204192499993],
              [147.26246178500003, -68.40894947699991],
              [147.38738040500004, -68.37639739399992],
              [147.40495853000004, -68.37590911299992],
              [147.421234571, -68.3786760399999],
              [147.45484459700003, -68.38909270599993],
              [147.46851647200003, -68.38925546699994],
              [147.51726321700005, -68.37517669099992],
              [147.62867272200003, -68.35605234199994],
              [147.66236412900003, -68.35662200299993],
              [147.7251082690001, -68.37053801899992],
              [147.759125196, -68.37297942499993],
              [147.8203231130001, -68.36712004999993],
              [147.84937584700003, -68.37037525799991],
              [147.8857528000001, -68.40642669099992],
              [147.917328321, -68.41716887799993],
              [147.98422285200002, -68.42310963299991],
              [147.97966556100005, -68.43515390399995],
              [147.97974694100003, -68.44475676899992],
              [147.98389733200008, -68.45354583099993],
              [147.991547071, -68.46209075299993],
              [148.0009871750001, -68.46404387799993],
              [148.012054884, -68.45777760199991],
              [148.02328535200002, -68.44882577899995],
              [148.03345787900003, -68.44247812299994],
              [148.0610457690001, -68.43824635199991],
              [148.11491946700005, -68.44638437299994],
              [148.1411238940001, -68.44605885199991],
              [148.2148543630001, -68.41912200299993],
              [148.24146569100003, -68.41415780999995],
              [148.26685631600003, -68.41708749799994],
              [148.29273522200003, -68.42742278399993],
              [148.3046981130001, -68.44443124799994],
              [148.28825931100005, -68.46648528399993],
              [148.43539472700002, -68.47332122199992],
              [148.5185653000001, -68.45191822699991],
              [148.6113387380001, -68.46819426899992],
              [148.62037194100003, -68.45720794099992],
              [148.620453321, -68.44736093499995],
              [148.61939537900003, -68.43840911299992],
              [148.62427819100003, -68.43035247199992],
              [148.64039147200003, -68.41912200299993],
              [148.65577233200008, -68.41106536299992],
              [148.67204837300005, -68.40569426899992],
              [148.6919051440001, -68.40300872199992],
              [148.72144616000003, -68.40536874799994],
              [148.74724368600005, -68.41448333099993],
              [148.79761803500003, -68.4416643209999],
              [148.830414259, -68.4528947899999],
              [148.85726972700002, -68.45370859199994],
              [148.918304884, -68.44646575299993],
              [148.9804793630001, -68.44573333099993],
              [149.00766035200002, -68.4392229149999],
              [149.0615340500001, -68.41220468499995],
              [149.0937606130001, -68.40496184699992],
              [149.1269637380001, -68.40162525799991],
              [149.15406334700003, -68.40252044099992],
              [149.12061608200008, -68.42099374799994],
              [149.1591903000001, -68.45012786299992],
              [149.2075301440001, -68.46038176899992],
              [149.25538170700008, -68.45077890399995],
              [149.31006920700008, -68.40683359199994],
              [149.337250196, -68.39568450299993],
              [149.36646569100003, -68.38787200299993],
              [149.39031009200005, -68.38437265399995],
              [149.414398634, -68.38713958099993],
              [149.481781446, -68.41814544099992],
              [149.78492272200003, -68.48691171699994],
              [149.83578535200002, -68.48430754999993],
              [149.883636915, -68.46363697699991],
              [149.83765709700003, -68.43124765399995],
              [149.8129988940001, -68.41790129999993],
              [149.78728274800005, -68.41220468499995],
              [149.758148634, -68.40927499799994],
              [149.73064212300005, -68.40154387799993],
              [149.705414259, -68.38836028399993],
              [149.6836043630001, -68.36931731599992],
              [149.735687696, -68.35247161299992],
              [149.7783309250001, -68.36451588299991],
              [149.86475670700008, -68.41277434699992],
              [149.91334069100003, -68.42343515399995],
              [150.2739363940001, -68.42766692499993],
              [150.35181725400003, -68.4397111959999],
              [150.3779403000001, -68.43987395599993],
              [150.6513778000001, -68.41082122199992],
              [150.852875196, -68.35076262799993],
              [150.90650475400003, -68.34270598799992],
              [150.95655358200008, -68.34295012799993],
              [151.01286868600005, -68.35068124799994],
              [151.062836134, -68.37037525799991],
              [151.0942488940001, -68.40699635199991],
              [151.114105665, -68.45614999799994],
              [151.10954837300005, -68.47356536299992],
              [151.065765821, -68.51482512799993],
              [151.05062910200002, -68.53777434699992],
              [151.05193118600005, -68.55901458099993],
              [151.0800887380001, -68.5739885399999],
              [151.00163821700005, -68.68954843499995],
              [150.9707137380001, -68.71721770599993],
              [150.99195397200003, -68.72763437299994],
              [151.0024520190001, -68.74407317499993],
              [151.01050866000003, -68.7619768209999],
              [151.02491295700008, -68.77695077899995],
              [151.10515384200005, -68.82683684699992],
              [151.1469832690001, -68.86614348799992],
              [151.16358483200008, -68.87761809699992],
              [151.17204837300005, -68.87004973799992],
              [151.23975670700008, -68.83163827899995],
              [151.28467858200008, -68.82870859199994],
              [151.3227645190001, -68.84172942499993],
              [151.3989363940001, -68.88567473799992],
              [151.41960696700005, -68.89397551899992],
              [151.438812696, -68.89853280999995],
              [151.500336134, -68.90203215899993],
              [151.5669051440001, -68.91676197699991],
              [151.57683353000004, -68.84335702899995],
              [151.57398522200003, -68.80803801899992],
              [151.5527449880001, -68.7834611959999],
              [151.5586043630001, -68.78199635199991],
              [151.569672071, -68.77695077899995],
              [151.575531446, -68.77532317499993],
              [151.552093946, -68.72763437299994],
              [151.5532332690001, -68.70720794099992],
              [151.5732528000001, -68.69255950299993],
              [151.5879012380001, -68.69133879999993],
              [151.61451256600003, -68.69841887799993],
              [151.9238387380001, -68.66676197699991],
              [151.933929884, -68.66871510199991],
              [151.95264733200008, -68.6814104149999],
              [151.96314537900003, -68.68320077899995],
              [151.97584069100003, -68.68206145599993],
              [151.98511803500003, -68.68401458099993],
              [152.005218946, -68.69426848799992],
              [152.03150475400003, -68.70191822699991],
              [152.09107506600003, -68.71054452899995],
              [152.15650475400003, -68.73642343499995],
              [152.2148543630001, -68.73503997199992],
              [152.40308678500003, -68.69866301899992],
              [152.4306746750001, -68.70086028399993],
              [152.44060306100005, -68.70525481599992],
              [152.45728600400003, -68.71965911299992],
              [152.46705162900003, -68.72405364399992],
              [152.4829207690001, -68.72421640399995],
              [152.51148522200003, -68.71599700299993],
              [152.5263778000001, -68.71493905999995],
              [152.5546981130001, -68.7224260399999],
              [152.59538821700005, -68.75139739399992],
              [152.62134850400003, -68.76572030999995],
              [152.648773634, -68.77019622199992],
              [152.735199415, -68.75660572699991],
              [152.76124108200008, -68.75945403399993],
              [152.86353600400003, -68.78997161299992],
              [152.8852645190001, -68.80169036299992],
              [152.9301863940001, -68.83318450299993],
              [152.9834090500001, -68.8615861959999],
              [153.03728274800005, -68.87590911299992],
              [153.09302819100003, -68.8791643209999],
              [153.17750084700003, -68.8733049459999],
              [153.2275496750001, -68.87883879999993],
              [153.25066165500004, -68.87818775799991],
              [153.25855553500003, -68.87460702899995],
              [153.26392662900003, -68.86825937299994],
              [153.27027428500003, -68.86239999799994],
              [153.28142337300005, -68.8596330709999],
              [153.30779056100005, -68.86126067499993],
              [153.3203231130001, -68.85930754999993],
              [153.3271590500001, -68.85222747199992],
              [153.34009850400003, -68.79119231599992],
              [153.34009850400003, -68.78655364399992],
              [153.34359785200002, -68.78386809699992],
              [153.3574324880001, -68.77678801899992],
              [153.3818465500001, -68.76881275799991],
              [153.4067488940001, -68.76913827899995],
              [153.50025475400003, -68.7907854149999],
              [153.54835045700008, -68.79599374799994],
              [153.59644616000003, -68.79363372199992],
              [153.692718946, -68.76620859199994],
              [153.74146569100003, -68.76083749799994],
              [153.84498131600003, -68.76043059699992],
              [153.83025149800005, -68.73251718499995],
              [153.79558353000004, -68.64080169099992],
              [153.778168165, -68.61598072699991],
              [153.70045006600003, -68.54566822699991],
              [153.74138431100005, -68.53313567499993],
              [153.78891035200002, -68.52939218499995],
              [153.83350670700008, -68.52068450299993],
              [153.8652449880001, -68.49374765399995],
              [153.82146243600005, -68.47551848799992],
              [153.72925866000003, -68.44866301899992],
              [153.6977645190001, -68.4201799459999],
              [153.681976759, -68.37607187299994],
              [153.68580162900003, -68.33407968499995],
              [153.70826256600003, -68.30006275799991],
              [153.7490340500001, -68.28036874799994],
              [153.79314212300005, -68.27402109199994],
              [153.8359481130001, -68.27361419099992],
              [153.87842858200008, -68.27898528399993],
              [153.9218856130001, -68.28923919099992],
              [153.99293053500003, -68.31560637799993],
              [154.0586043630001, -68.3220354149999],
              [154.07960045700008, -68.32870859199994],
              [154.1162215500001, -68.34872812299994],
              [154.1347762380001, -68.35556405999995],
              [154.17164147200003, -68.35808684699992],
              [154.17465254, -68.36386484199994],
              [154.175140821, -68.37102629999993],
              [154.18311608200008, -68.37656015399995],
              [154.36101321700005, -68.42245859199994],
              [154.43246504, -68.45663827899995],
              [154.47681725400003, -68.46998463299991],
              [154.5224715500001, -68.47861093499995],
              [154.56031334700003, -68.47975025799991],
              [154.61312910200002, -68.47429778399993],
              [154.621429884, -68.47722747199992],
              [154.62818444100003, -68.48552825299993],
              [154.63428795700008, -68.49521249799994],
              [154.640961134, -68.50237395599993],
              [154.6582137380001, -68.51181405999995],
              [154.6992293630001, -68.52532317499993],
              [154.71851647200003, -68.52825286299992],
              [154.711273634, -68.55779387799993],
              [154.71013431100005, -68.57317473799992],
              [154.71509850400003, -68.58261484199994],
              [154.7451278000001, -68.59832122199992],
              [154.75806725400003, -68.60849374799994],
              [154.76921634200005, -68.62184010199991],
              [154.714203321, -68.64251067499993],
              [154.69711347700002, -68.6462541649999],
              [154.67644290500004, -68.64397551899992],
              [154.63550866000003, -68.63014088299991],
              [154.45036868600005, -68.62574635199991],
              [154.46404056100005, -68.6526018209999],
              [154.49675540500004, -68.67636484199994],
              [154.56804446700005, -68.70647551899992],
              [154.58757571700005, -68.7263322899999],
              [154.57203209700003, -68.75432708099993],
              [154.51832116000003, -68.80396900799991],
              [154.5693465500001, -68.80559661299992],
              [154.61198978000004, -68.78899504999993],
              [154.69263756600003, -68.73015715899993],
              [154.742523634, -68.70973072699991],
              [154.79468834700003, -68.71087004999993],
              [154.8447371750001, -68.72771575299993],
              [154.9511824880001, -68.80291106599992],
              [154.96021569100003, -68.81715260199991],
              [154.96168053500003, -68.84392669099992],
              [154.9697371750001, -68.86712004999993],
              [154.98552493600005, -68.88591887799993],
              [155.011078321, -68.89885833099993],
              [155.0371199880001, -68.90178801899992],
              [155.060883009, -68.89568450299993],
              [155.10670006600003, -68.8747697899999],
              [155.1328231130001, -68.87021249799994],
              [155.3086043630001, -68.89332447699991],
              [155.337250196, -68.90471770599993],
              [155.34945722700002, -68.91253020599993],
              [155.36011803500003, -68.92148202899995],
              [155.36898847700002, -68.93181731599992],
              [155.37680097700002, -68.94426848799992],
              [155.38054446700005, -68.96054452899995],
              [155.378265821, -68.99358489399992],
              [155.38656660200002, -69.01034921699994],
              [155.31226647200003, -69.02499765399995],
              [155.28882897200003, -69.03590260199991],
              [155.39210045700008, -69.04070403399993],
              [155.41081790500004, -69.04363372199992],
              [155.43132571700005, -69.06438567499993],
              [155.45590254, -69.08114999799994],
              [155.51050866000003, -69.10654062299994],
              [155.637543165, -69.13420989399992],
              [155.6626082690001, -69.13225676899992],
              [155.75709069100003, -69.10116952899995],
              [155.74561608200008, -69.08456796699994],
              [155.731293165, -69.08212655999995],
              [155.71412194100003, -69.08513762799993],
              [155.69450931100005, -69.08521900799991],
              [155.68148847700002, -69.07927825299993],
              [155.64234459700003, -69.04843515399995],
              [155.57146243600005, -69.0295549459999],
              [155.5415145190001, -69.0134416649999],
              [155.53679446700005, -68.98357512799993],
              [155.558929884, -68.9568010399999],
              [155.59343509200005, -68.94695403399993],
              [155.739593946, -68.94394296699994],
              [155.7754012380001, -68.94687265399995],
              [155.812836134, -68.95623137799993],
              [155.81861412900003, -68.96038176899992],
              [155.82789147200003, -68.97234465899993],
              [155.83472741000003, -68.9748674459999],
              [155.86443118600005, -68.97421640399995],
              [155.873383009, -68.97576262799993],
              [155.888031446, -68.98259856599992],
              [155.95630944100003, -69.02809010199991],
              [155.96697024800005, -69.03948333099993],
              [155.97087649800005, -69.05413176899992],
              [155.9677840500001, -69.07659270599993],
              [155.97185306100005, -69.0881486959999],
              [155.98462975400003, -69.10076262799993],
              [156.0009871750001, -69.11142343499995],
              [156.01441491000003, -69.11663176899992],
              [156.031586134, -69.11679452899995],
              [156.08171634200005, -69.10125090899993],
              [156.1020613940001, -69.09880950299993],
              [156.11703535200002, -69.10271575299993],
              [156.1489363940001, -69.11646900799991],
              [156.226898634, -69.13543059699992],
              [156.26246178500003, -69.15292734199994],
              [156.26490319100003, -69.17685312299994],
              [156.30437259200005, -69.19247812299994],
              [156.3501082690001, -69.20191822699991],
              [156.48414147200003, -69.20663827899995],
              [156.56430097700002, -69.1970354149999],
              [156.65455162900003, -69.17066822699991],
              [156.67505944100003, -69.17001718499995],
              [156.72242272200003, -69.17351653399993],
              [156.76783287900003, -69.17107512799993],
              [156.78874759200005, -69.17278411299992],
              [156.79835045700008, -69.17693450299993],
              [156.81519616000003, -69.18987395599993],
              [156.8266707690001, -69.19353606599992],
              [156.8598738940001, -69.19426848799992],
              [156.89283287900003, -69.19052499799994],
              [157.02320397200003, -69.1447893209999],
              [157.04444420700008, -69.1447893209999],
              [157.13982181100005, -69.16130950299993],
              [157.15772545700008, -69.17058684699992],
              [157.2094832690001, -69.2204729149999],
              [157.26286868600005, -69.25579192499993],
              [157.34359785200002, -69.32317473799992],
              [157.3735457690001, -69.35466887799993],
              [157.38884524800005, -69.38795338299991],
              [157.39470462300005, -69.41122812299994],
              [157.40601647200003, -69.43059661299992],
              [157.42253665500004, -69.43718840899993],
              [157.461761915, -69.40837981599992],
              [157.4790145190001, -69.41106536299992],
              [157.496918165, -69.42148202899995],
              [157.51823978000004, -69.43027109199994],
              [157.53101647200003, -69.41220468499995],
              [157.5683699880001, -69.3982072899999],
              [157.64616946700005, -69.38241952899995],
              [157.5879012380001, -69.3708635399999],
              [157.540375196, -69.36760833099993],
              [157.51905358200008, -69.36248137799993],
              [157.504730665, -69.34954192499993],
              [157.49878991000003, -69.32415129999993],
              [157.494476759, -69.27947356599992],
              [157.49870853000004, -69.26132577899995],
              [157.51441491000003, -69.24472421699994],
              [157.53345787900003, -69.23202890399995],
              [157.56763756600003, -69.21445077899995],
              [157.61085045700008, -69.19866301899992],
              [157.6254988940001, -69.19540780999995],
              [157.7089949880001, -69.19402434699992],
              [157.7270613940001, -69.19850025799991],
              [157.74496504, -69.21445077899995],
              [157.76189212300005, -69.22429778399993],
              [157.78589928500003, -69.22698333099993],
              [157.81080162900003, -69.22323984199994],
              [157.8305770190001, -69.21404387799993],
              [157.84986412900003, -69.19459400799991],
              [157.85922285200002, -69.18043385199991],
              [157.8730574880001, -69.17205169099992],
              [157.9052840500001, -69.16952890399995],
              [157.9921981130001, -69.1721330709999],
              [158.0117293630001, -69.17742278399993],
              [158.08082116000003, -69.20989348799992],
              [158.12680097700002, -69.21689218499995],
              [158.22193444100003, -69.2170549459999],
              [158.26832116000003, -69.22503020599993],
              [158.39820397200003, -69.28329843499995],
              [158.401703321, -69.29070403399993],
              [158.40381920700008, -69.2990861959999],
              [158.41138756600003, -69.30877044099992],
              [158.44654381600003, -69.32675546699994],
              [158.49724368600005, -69.34197356599992],
              [158.54867597700002, -69.35068124799994],
              [158.58716881600003, -69.34880950299993],
              [158.58179772200003, -69.34644947699991],
              [158.56592858200008, -69.33749765399995],
              [158.58375084700003, -69.32708098799992],
              [158.6020613940001, -69.32586028399993],
              [158.6211043630001, -69.32708098799992],
              [158.66667728000004, -69.31764088299991],
              [158.68677819100003, -69.3186174459999],
              [158.7314559250001, -69.32545338299991],
              [158.79444420700008, -69.31487395599993],
              [158.81714928500003, -69.31633879999993],
              [158.83863366000003, -69.32317473799992],
              [158.85914147200003, -69.33261484199994],
              [158.94117272200003, -69.38176848799992],
              [158.9599715500001, -69.39812590899993],
              [158.9829207690001, -69.43499114399992],
              [159.01050866000003, -69.45818450299993],
              [159.04070071700005, -69.49065520599993],
              [159.05787194100003, -69.49765390399995],
              [159.07691491000003, -69.50204843499995],
              [159.1001082690001, -69.51287200299993],
              [159.1196395190001, -69.51628997199992],
              [159.13152103000004, -69.50164153399993],
              [159.1494246750001, -69.46135833099993],
              [159.1879988940001, -69.4353166649999],
              [159.2353621750001, -69.42791106599992],
              [159.28467858200008, -69.43303801899992],
              [159.5122176440001, -69.49911874799994],
              [159.55445397200003, -69.5017229149999],
              [159.63933353000004, -69.49675872199992],
              [159.75359134200005, -69.50188567499993],
              [159.77328535200002, -69.50652434699992],
              [159.82300866000003, -69.52752044099992],
              [159.83765709700003, -69.53720468499995],
              [159.88070722700002, -69.5744768209999],
              [159.9751082690001, -69.62265390399995],
              [159.9961043630001, -69.6291643209999],
              [160.03923587300005, -69.63616301899992],
              [160.05876712300005, -69.64364999799994],
              [160.07545006600003, -69.6579729149999],
              [160.08765709700003, -69.67351653399993],
              [160.10230553500003, -69.68499114399992],
              [160.125824415, -69.68792083099993],
              [160.14380944100003, -69.6931291649999],
              [160.20232181100005, -69.73691171699994],
              [160.29127037900003, -69.77027760199991],
              [160.3344832690001, -69.79607512799993],
              [160.34107506600003, -69.8283830709999],
              [160.3242293630001, -69.84880950299993],
              [160.303070509, -69.8615861959999],
              [160.2783309250001, -69.86931731599992],
              [160.2504988940001, -69.87411874799994],
              [160.1728621750001, -69.87517669099992],
              [160.12134850400003, -69.88591887799993],
              [160.09302819100003, -69.88762786299992],
              [159.984711134, -69.87224700299993],
              [159.88111412900003, -69.88152434699992],
              [159.805511915, -69.87273528399993],
              [159.78003991000003, -69.87460702899995],
              [159.76124108200008, -69.88518645599993],
              [159.76099694100003, -69.90894947699991],
              [159.770355665, -69.91765715899993],
              [159.78500410200002, -69.9201799459999],
              [159.800140821, -69.92099374799994],
              [159.8110457690001, -69.9235979149999],
              [159.821625196, -69.93401458099993],
              [159.83765709700003, -69.95427825299993],
              [159.85962975400003, -69.96884530999995],
              [159.87281334700003, -69.98577239399992],
              [159.878265821, -69.99041106599992],
              [159.8916121750001, -69.99236419099992],
              [159.9394637380001, -69.9885393209999],
              [160.01482181100005, -69.99602629999993],
              [160.04070071700005, -69.99179452899995],
              [160.1171981130001, -69.96917083099993],
              [160.14283287900003, -69.96884530999995],
              [160.2168074880001, -69.98772551899992],
              [160.63648522200003, -70.04876067499993],
              [160.64242597700002, -70.05429452899995],
              [160.644867384, -70.06406015399995],
              [160.6494246750001, -70.07431405999995],
              [160.66138756600003, -70.08163827899995],
              [160.59595787900003, -70.10466887799993],
              [160.72331790500004, -70.09579843499995],
              [160.7597762380001, -70.10198333099993],
              [160.79363040500004, -70.11825937299994],
              [160.8271590500001, -70.13974374799994],
              [160.85865319100003, -70.16497161299992],
              [160.9033309250001, -70.20956796699994],
              [160.919281446, -70.21990325299993],
              [160.98585045700008, -70.24130624799994],
              [160.99626712300005, -70.24960702899995],
              [161.00416100400003, -70.26140715899993],
              [161.01970462300005, -70.27947356599992],
              [161.05534915500004, -70.30217864399992],
              [161.09050540500004, -70.31902434699992],
              [161.10759524800005, -70.34140390399995],
              [161.08936608200008, -70.38030364399992],
              [161.18677819100003, -70.41204192499993],
              [161.20281009200005, -70.42278411299992],
              [161.2490340500001, -70.46217213299991],
              [161.2583113940001, -70.47763437299994],
              [161.2480574880001, -70.49570077899995],
              [161.22584069100003, -70.50945403399993],
              [161.2016707690001, -70.52076588299991],
              [161.18539472700002, -70.53199635199991],
              [161.17505944100003, -70.55632903399993],
              [161.17920983200008, -70.57529062299994],
              [161.1938582690001, -70.58147551899992],
              [161.214203321, -70.56796640399995],
              [161.23031660200002, -70.54851653399993],
              [161.24683678500003, -70.53289153399993],
              [161.26384524800005, -70.52825286299992],
              [161.2817488940001, -70.54176197699991],
              [161.29070071700005, -70.5666643209999],
              [161.2739363940001, -70.60222747199992],
              [161.28150475400003, -70.62566497199992],
              [161.31421959700003, -70.65007903399993],
              [161.36109459700003, -70.66659921699994],
              [161.4516707690001, -70.68596770599993],
              [161.3808699880001, -70.75164153399993],
              [161.3222762380001, -70.78525155999995],
              [161.30982506600003, -70.79607512799993],
              [161.3110457690001, -70.80754973799992],
              [161.32349694100003, -70.82341887799993],
              [161.33171634200005, -70.84197356599992],
              [161.3286238940001, -70.85670338299991],
              [161.30681399800005, -70.86044687299994],
              [161.329437696, -70.87607187299994],
              [161.34441165500004, -70.89023202899995],
              [161.36117597700002, -70.90097421699994],
              [161.38949629, -70.90569426899992],
              [161.41627037900003, -70.90447356599992],
              [161.5449324880001, -70.8811174459999],
              [161.59400475400003, -70.88201262799993],
              [161.606781446, -70.87932708099993],
              [161.634125196, -70.8650041649999],
              [161.64633222700002, -70.86345794099992],
              [161.65552819100003, -70.87078215899993],
              [161.67302493600005, -70.89861419099992],
              [161.68246504, -70.90894947699991],
              [161.7275496750001, -70.9255510399999],
              [161.77719160200002, -70.92587655999995],
              [161.875336134, -70.90764739399992],
              [161.932953321, -70.90732187299994],
              [161.99008222700002, -70.92253997199992],
              [162.04460696700005, -70.94744231599992],
              [162.094086134, -70.9768205709999],
              [162.086761915, -70.98739999799994],
              [162.07797285200002, -70.99675872199992],
              [162.06804446700005, -71.00497812299994],
              [162.056976759, -71.0114885399999],
              [162.09107506600003, -71.0407854149999],
              [162.1445418630001, -71.06414153399993],
              [162.2021590500001, -71.07830169099992],
              [162.27458743600005, -71.07903411299992],
              [162.2968856130001, -71.08456796699994],
              [162.3408309250001, -71.10947030999995],
              [162.36158287900003, -71.11142343499995],
              [162.389984571, -71.10279713299991],
              [162.41667728000004, -71.08806731599992],
              [162.43246504, -71.07105885199991],
              [162.42139733200008, -71.06552499799994],
              [162.4126082690001, -71.05706145599993],
              [162.40609785200002, -71.04656340899993],
              [162.4023543630001, -71.03435637799993],
              [162.4218856130001, -71.0315080709999],
              [162.42847741000003, -71.03167083099993],
              [162.31666100400003, -70.93368905999995],
              [162.3076278000001, -70.92986419099992],
              [162.27361087300005, -70.92896900799991],
              [162.25570722700002, -70.92636484199994],
              [162.24480228000004, -70.91952890399995],
              [162.23194420700008, -70.89275481599992],
              [162.225922071, -70.8635393209999],
              [162.21859785200002, -70.85466887799993],
              [162.20337975400003, -70.84783294099992],
              [162.1728621750001, -70.83896249799994],
              [162.1450301440001, -70.83611419099992],
              [162.09107506600003, -70.8493791649999],
              [162.06039472700002, -70.84661223799992],
              [162.04664147200003, -70.83945077899995],
              [162.0380965500001, -70.82952239399992],
              [162.02556399800005, -70.80136484199994],
              [162.02230879, -70.78834400799991],
              [162.02719160200002, -70.78378671699994],
              [162.03484134200005, -70.77996184699992],
              [162.039398634, -70.76970794099992],
              [162.04070071700005, -70.74260833099993],
              [162.04281660200002, -70.72893645599993],
              [162.04802493600005, -70.71868254999993],
              [162.07203209700003, -70.69329192499993],
              [162.0830184250001, -70.67693450299993],
              [162.08562259200005, -70.66228606599992],
              [162.07740319100003, -70.65520598799992],
              [162.04558353000004, -70.64446379999993],
              [162.03532962300005, -70.63836028399993],
              [162.03101647200003, -70.62566497199992],
              [162.03288821700005, -70.61516692499993],
              [162.03248131600003, -70.60466887799993],
              [162.0122176440001, -70.57919687299994],
              [162.0161238940001, -70.56910572699991],
              [162.024750196, -70.5608049459999],
              [162.0302840500001, -70.55282968499995],
              [162.03003991000003, -70.53525155999995],
              [162.02507571700005, -70.51913827899995],
              [162.01710045700008, -70.50408294099992],
              [162.00733483200008, -70.49016692499993],
              [161.9961043630001, -70.46428801899992],
              [161.99789472700002, -70.43840911299992],
              [162.02027428500003, -70.38518645599993],
              [162.02898196700005, -70.37623463299991],
              [162.0434676440001, -70.3689104149999],
              [162.07195071700005, -70.35833098799992],
              [162.08179772200003, -70.34734465899993],
              [162.0864363940001, -70.31959400799991],
              [162.09441165500004, -70.31414153399993],
              [162.20460045700008, -70.32805754999993],
              [162.22828209700003, -70.32415129999993],
              [162.3188582690001, -70.28394947699991],
              [162.37281334700003, -70.27581145599993],
              [162.59522545700008, -70.26913827899995],
              [162.65577233200008, -70.27646249799994],
              [162.68506920700008, -70.28525155999995],
              [162.7075301440001, -70.29973723799992],
              [162.78003991000003, -70.37835051899992],
              [162.8007918630001, -70.39381275799991],
              [162.82146243600005, -70.40398528399993],
              [162.84693444100003, -70.40715911299992],
              [162.8720809250001, -70.40553150799991],
              [162.8955184250001, -70.40886809699992],
              [162.91553795700008, -70.42652760199991],
              [162.9013778000001, -70.43206145599993],
              [162.88648522200003, -70.43425872199992],
              [162.8715926440001, -70.43352629999993],
              [162.85670006600003, -70.4299455709999],
              [162.87818444100003, -70.47185637799993],
              [162.92017662900003, -70.50253671699994],
              [162.97087649800005, -70.52190520599993],
              [163.017914259, -70.52996184699992],
              [163.07252037900003, -70.52988046699994],
              [163.10027103000004, -70.5329729149999],
              [163.12452233200008, -70.5427385399999],
              [163.13347415500004, -70.5505510399999],
              [163.158539259, -70.58114999799994],
              [163.170258009, -70.58757903399993],
              [163.36158287900003, -70.62428150799991],
              [163.42212975400003, -70.65357838299991],
              [163.450043165, -70.65748463299991],
              [163.47877037900003, -70.65764739399992],
              [163.52719160200002, -70.6526018209999],
              [163.6333113940001, -70.66513437299994],
              [163.657074415, -70.66326262799993],
              [163.6796981130001, -70.65691497199992],
              [163.73113040500004, -70.63241952899995],
              [163.78695722700002, -70.63152434699992],
              [163.84644616000003, -70.62273528399993],
              [163.866547071, -70.62656015399995],
              [163.87370853000004, -70.64177825299993],
              [163.8642684250001, -70.67107512799993],
              [163.8618270190001, -70.69003671699994],
              [163.8652449880001, -70.75269947699991],
              [163.87061608200008, -70.76946379999993],
              [163.8950301440001, -70.78199635199991],
              [163.91920006600003, -70.78386809699992],
              [163.94499759200005, -70.78183359199994],
              [163.97437584700003, -70.78289153399993],
              [163.999359571, -70.78964609199994],
              [164.012054884, -70.79111093499995],
              [164.01921634200005, -70.78655364399992],
              [164.02361087300005, -70.77499765399995],
              [164.0297957690001, -70.76555754999993],
              [164.03834069100003, -70.75823333099993],
              [164.0498153000001, -70.75286223799992],
              [164.05811608200008, -70.74570077899995],
              [164.05974368600005, -70.72389088299991],
              [164.06910241000003, -70.71306731599992],
              [164.09148196700005, -70.69687265399995],
              [164.10035241000003, -70.68767669099992],
              [164.10954837300005, -70.67595794099992],
              [164.126312696, -70.66155364399992],
              [164.1508895190001, -70.64999765399995],
              [164.17741946700005, -70.64202239399992],
              [164.19988040500004, -70.63933684699992],
              [164.04314212300005, -70.55185312299994],
              [164.02759850400003, -70.53232187299994],
              [164.0957137380001, -70.50676848799992],
              [164.167328321, -70.49382903399993],
              [164.24040774800005, -70.49114348799992],
              [164.49390709700003, -70.52044036299992],
              [164.56177819100003, -70.54013437299994],
              [164.5962020190001, -70.54607512799993],
              [164.70045006600003, -70.54656340899993],
              [164.75766035200002, -70.53785572699991],
              [164.7705184250001, -70.54062265399995],
              [164.78142337300005, -70.54729583099993],
              [164.8007918630001, -70.55575937299994],
              [164.83814537900003, -70.56682708099993],
              [164.87647545700008, -70.57382577899995],
              [165.11198978000004, -70.56357187299994],
              [165.1411238940001, -70.58700937299994],
              [165.18230228000004, -70.58538176899992],
              [165.268890821, -70.56536223799992],
              [165.31226647200003, -70.5603166649999],
              [165.342133009, -70.5647111959999],
              [165.36394290500004, -70.56511809699992],
              [165.3711043630001, -70.56959400799991],
              [165.3769637380001, -70.57463958099993],
              [165.3852645190001, -70.57708098799992],
              [165.39665774800005, -70.57545338299991],
              [165.41667728000004, -70.56755950299993],
              [165.42701256600003, -70.56503671699994],
              [165.43677819100003, -70.5661760399999],
              [165.46078535200002, -70.57293059699992],
              [165.46851647200003, -70.57268645599993],
              [165.43539472700002, -70.59303150799991],
              [165.4599715500001, -70.60173919099992],
              [165.5258895190001, -70.5974260399999],
              [165.55616295700008, -70.59872812299994],
              [165.55201256600003, -70.60230885199991],
              [165.544281446, -70.6110979149999],
              [165.5400496750001, -70.61484140399995],
              [165.9257918630001, -70.68425872199992],
              [165.92505944100003, -70.66375090899993],
              [165.9375106130001, -70.65309010199991],
              [165.95687910200002, -70.64918385199991],
              [166.01937910200002, -70.64885833099993],
              [166.03777103000004, -70.64446379999993],
              [166.09693444100003, -70.61728280999995],
              [166.369476759, -70.58391692499993],
              [166.40984134200005, -70.58896249799994],
              [166.41814212300005, -70.59417083099993],
              [166.43181399800005, -70.60881926899992],
              [166.4414168630001, -70.61126067499993],
              [166.72445722700002, -70.61825937299994],
              [166.76775149800005, -70.63046640399995],
              [166.809418165, -70.65105559699992],
              [166.82992597700002, -70.66480885199991],
              [166.83741295700008, -70.67669036299992],
              [166.825043165, -70.69255950299993],
              [166.8017684250001, -70.7009416649999],
              [166.75318444100003, -70.70623137799993],
              [166.746429884, -70.70468515399995],
              [166.73585045700008, -70.69605885199991],
              [166.72974694100003, -70.6936174459999],
              [166.6962996750001, -70.69963958099993],
              [166.68620853000004, -70.69687265399995],
              [166.66325931100005, -70.68759530999995],
              [166.64332116000003, -70.68824635199991],
              [166.59750410200002, -70.70077890399995],
              [166.50359134200005, -70.70224374799994],
              [166.4575301440001, -70.70916106599992],
              [166.42644290500004, -70.73308684699992],
              [166.44711347700002, -70.74423593499995],
              [166.45850670700008, -70.75676848799992],
              [166.4707137380001, -70.76628997199992],
              [166.4941512380001, -70.76897551899992],
              [166.5586043630001, -70.76482512799993],
              [166.57203209700003, -70.76653411299992],
              [166.59392337300005, -70.77809010199991],
              [166.6064559250001, -70.7829729149999],
              [166.62761478000004, -70.78533294099992],
              [166.722015821, -70.77703215899993],
              [166.77458743600005, -70.76482512799993],
              [166.79867597700002, -70.76653411299992],
              [166.8369246750001, -70.78362395599993],
              [166.85718834700003, -70.7888322899999],
              [166.8774520190001, -70.78484465899993],
              [166.90162194100003, -70.77548593499995],
              [166.92790774800005, -70.77044036299992],
              [166.954437696, -70.76970794099992],
              [167.00261478000004, -70.77418385199991],
              [167.071625196, -70.76441822699991],
              [167.41618899800005, -70.75904713299991],
              [167.46021569100003, -70.7634416649999],
              [167.55046634200005, -70.78443775799991],
              [167.70085696700005, -70.7912736959999],
              [167.73894290500004, -70.8103166649999],
              [167.74236087300005, -70.82024504999993],
              [167.74382571700005, -70.83326588299991],
              [167.74634850400003, -70.84441497199992],
              [167.75375410200002, -70.84783294099992],
              [167.78101647200003, -70.84441497199992],
              [167.7934676440001, -70.84531015399995],
              [167.80787194100003, -70.84856536299992],
              [167.8330184250001, -70.86142343499995],
              [167.84546959700003, -70.8786760399999],
              [167.85466556100005, -70.89983489399992],
              [167.8701278000001, -70.92392343499995],
              [167.82878665500004, -70.94264088299991],
              [167.47771243600005, -70.94939544099992],
              [167.418793165, -70.9626604149999],
              [167.2129012380001, -70.97975025799991],
              [167.16521243600005, -70.99285247199992],
              [167.139984571, -70.9963518209999],
              [167.18327884200005, -71.03093840899993],
              [167.25554446700005, -71.03834400799991],
              [167.513031446, -71.0041643209999],
              [167.8779403000001, -71.01433684699992],
              [167.903656446, -71.02459075299993],
              [167.94898522200003, -71.0642229149999],
              [167.97681725400003, -71.07740650799991],
              [168.10132897200003, -71.10849374799994],
              [168.083343946, -71.12590911299992],
              [168.06519616000003, -71.13762786299992],
              [168.044281446, -71.14373137799993],
              [168.0185653000001, -71.14462655999995],
              [167.98585045700008, -71.13681405999995],
              [167.974945509, -71.13551197699991],
              [167.96265709700003, -71.13746510199991],
              [167.9394637380001, -71.14560312299994],
              [167.92790774800005, -71.14755624799994],
              [167.90886478000004, -71.14299895599993],
              [167.88786868600005, -71.1350236959999],
              [167.86833743600005, -71.13225676899992],
              [167.8535262380001, -71.14364999799994],
              [167.8364363940001, -71.16171640399995],
              [167.8129988940001, -71.17156340899993],
              [167.76002037900003, -71.18377044099992],
              [167.74333743600005, -71.19451262799993],
              [167.73617597700002, -71.20964934699992],
              [167.74105879, -71.22283294099992],
              [167.75993899800005, -71.22795989399992],
              [168.1123153000001, -71.19548919099992],
              [168.16334069100003, -71.20159270599993],
              [168.18930097700002, -71.19980234199994],
              [168.26286868600005, -71.18434010199991],
              [168.35857181100005, -71.19719817499993],
              [168.38111412900003, -71.19459400799991],
              [168.44800866000003, -71.17652760199991],
              [168.48389733200008, -71.16220468499995],
              [168.50025475400003, -71.16106536299992],
              [168.561859571, -71.17066822699991],
              [168.58716881600003, -71.18279387799993],
              [168.59546959700003, -71.18523528399993],
              [168.6450301440001, -71.18124765399995],
              [168.66976972700002, -71.18279387799993],
              [168.69214928500003, -71.19052499799994],
              [168.73267662900003, -71.2229143209999],
              [168.754242384, -71.23691171699994],
              [168.77621504, -71.23992278399993],
              [168.76148522200003, -71.27556731599992],
              [169.0166121750001, -71.32488372199992],
              [169.03874759200005, -71.33456796699994],
              [169.06072024800005, -71.34710051899992],
              [169.071625196, -71.35165780999995],
              [169.084320509, -71.35466887799993],
              [169.0966903000001, -71.35247161299992],
              [169.12061608200008, -71.33749765399995],
              [169.13453209700003, -71.33538176899992],
              [169.140961134, -71.34026458099993],
              [169.14673912900003, -71.34970468499995],
              [169.15381920700008, -71.35930754999993],
              [169.16480553500003, -71.36467864399992],
              [169.25147545700008, -71.37444426899992],
              [169.26921634200005, -71.37997812299994],
              [169.3261824880001, -71.4235979149999],
              [169.345062696, -71.43352629999993],
              [169.3657332690001, -71.43808359199994],
              [169.39177493600005, -71.43808359199994],
              [169.41863040500004, -71.44255950299993],
              [169.46371504, -71.46355559699992],
              [169.49529056100005, -71.46347421699994],
              [169.48601321700005, -71.46868254999993],
              [169.47779381600003, -71.47503020599993],
              [169.47055097700002, -71.48251718499995],
              [169.46461022200003, -71.49114348799992],
              [169.4804793630001, -71.49472421699994],
              [169.504242384, -71.51034921699994],
              [169.515961134, -71.51506926899992],
              [169.55201256600003, -71.51970794099992],
              [169.5879012380001, -71.52011484199994],
              [169.72055097700002, -71.5061174459999],
              [169.7602645190001, -71.50790780999995],
              [169.7915145190001, -71.51946379999993],
              [169.869476759, -71.55974700299993],
              [169.879242384, -71.56829192499993],
              [169.88949629, -71.57512786299992],
              [169.9047957690001, -71.57756926899992],
              [169.977386915, -71.56292083099993],
              [169.974945509, -71.58114999799994],
              [169.98617597700002, -71.59531015399995],
              [170.02263431100005, -71.6154924459999],
              [170.0410262380001, -71.62900155999995],
              [170.05827884200005, -71.6443010399999],
              [170.07585696700005, -71.6560197899999],
              [170.09538821700005, -71.65878671699994],
              [170.1201278000001, -71.65764739399992],
              [170.18279056100005, -71.67441171699994],
              [170.2050887380001, -71.67400481599992],
              [170.22877037900003, -71.66887786299992],
              [170.25147545700008, -71.66073984199994],
              [170.27173912900003, -71.65081145599993],
              [170.25359134200005, -71.64169687299994],
              [170.2490340500001, -71.62656015399995],
              [170.25700931100005, -71.61296965899993],
              [170.27654056100005, -71.60898202899995],
              [170.26319420700008, -71.59335702899995],
              [170.31080162900003, -71.56552499799994],
              [170.3618270190001, -71.54404062299994],
              [170.313812696, -71.4416643209999],
              [170.29908287900003, -71.42400481599992],
              [170.24488366000003, -71.38274504999993],
              [170.23064212300005, -71.36736419099992],
              [170.22152754, -71.35165780999995],
              [170.20866946700005, -71.3142229149999],
              [170.21607506600003, -71.30291106599992],
              [170.238617384, -71.29461028399993],
              [170.2646590500001, -71.29225025799991],
              [170.28239993600005, -71.29876067499993],
              [170.32178795700008, -71.3474260399999],
              [170.3310653000001, -71.35418059699992],
              [170.35043379, -71.3557268209999],
              [170.36011803500003, -71.3596330709999],
              [170.3754988940001, -71.37509530999995],
              [170.402679884, -71.40886809699992],
              [170.45850670700008, -71.45037200299993],
              [170.49170983200008, -71.48162200299993],
              [170.53638756600003, -71.53850676899992],
              [170.55225670700008, -71.55087655999995],
              [170.58961022200003, -71.57317473799992],
              [170.69117272200003, -71.65699635199991],
              [170.671234571, -71.67538827899995],
              [170.66423587300005, -71.68059661299992],
              [170.81373131600003, -71.69980234199994],
              [170.80730228000004, -71.70191822699991],
              [170.78923587300005, -71.71209075299993],
              [170.80876712300005, -71.73365650799991],
              [170.83090254, -71.74684010199991],
              [170.85613040500004, -71.75448984199994],
              [170.8847762380001, -71.75896575299993],
              [170.86540774800005, -71.76824309699992],
              [170.86451256600003, -71.78248463299991],
              [170.87452233200008, -71.79778411299992],
              [170.887543165, -71.8103166649999],
              [170.90357506600003, -71.82000090899993],
              [170.92546634200005, -71.82887135199991],
              [170.94800866000003, -71.83464934699992],
              [170.96607506600003, -71.83464934699992],
              [170.9458113940001, -71.86077239399992],
              [170.9170028000001, -71.87835051899992],
              [170.85328209700003, -71.90545012799993],
              [170.77361087300005, -71.95086028399993],
              [170.74439537900003, -71.95859140399995],
              [170.67253665500004, -71.96087004999993],
              [170.63892662900003, -71.96819426899992],
              [170.62086022200003, -71.98796965899993],
              [170.6137801440001, -71.99797942499993],
              [170.6005965500001, -72.00448984199994],
              [170.585297071, -72.00741952899995],
              [170.57252037900003, -72.00628020599993],
              [170.55738366000003, -71.9983049459999],
              [170.54851321700005, -71.9860979149999],
              [170.5376082690001, -71.95419687299994],
              [170.54965254, -71.95517343499995],
              [170.56120853000004, -71.95273202899995],
              [170.57097415500004, -71.9470354149999],
              [170.5791121750001, -71.93808359199994],
              [170.4980574880001, -71.89592864399992],
              [170.44483483200008, -71.88250090899993],
              [170.44011478000004, -71.87363046699994],
              [170.43897545700008, -71.86451588299991],
              [170.430511915, -71.85784270599993],
              [170.39177493600005, -71.84335702899995],
              [170.3754988940001, -71.83220794099992],
              [170.36247806100005, -71.8161760399999],
              [170.3339949880001, -71.80087655999995],
              [170.30241946700005, -71.82105885199991],
              [170.25570722700002, -71.87216562299994],
              [170.13843834700003, -71.9318986959999],
              [170.22966556100005, -71.93938567499993],
              [170.2563582690001, -71.95077890399995],
              [170.2382918630001, -71.97714609199994],
              [170.21851647200003, -72.00009530999995],
              [170.1958113940001, -72.02019622199992],
              [170.16871178500003, -72.03753020599993],
              [170.13843834700003, -72.04371510199991],
              [170.07960045700008, -72.02418385199991],
              [170.04574629, -72.01995208099993],
              [170.05201256600003, -72.03167083099993],
              [170.0532332690001, -72.04306405999995],
              [170.04957116000003, -72.05339934699992],
              [170.0400496750001, -72.0622697899999],
              [170.089203321, -72.08440520599993],
              [170.0771590500001, -72.08896249799994],
              [170.07097415500004, -72.09498463299991],
              [170.0693465500001, -72.1032854149999],
              [170.071136915, -72.11435312299994],
              [170.06763756600003, -72.12363046699994],
              [170.0293074880001, -72.14381275799991],
              [170.020843946, -72.15520598799992],
              [170.01970462300005, -72.16366952899995],
              [170.01636803500003, -72.17083098799992],
              [170.00180097700002, -72.17880624799994],
              [169.98951256600003, -72.18084075299993],
              [169.94988040500004, -72.17831796699994],
              [169.92554772200003, -72.18466562299994],
              [169.8789168630001, -72.20330169099992],
              [169.85499108200008, -72.20745208099993],
              [169.79712975400003, -72.20956796699994],
              [169.77263431100005, -72.22014739399992],
              [169.76539147200003, -72.24480559699992],
              [169.78272545700008, -72.24334075299993],
              [169.7949324880001, -72.24814218499995],
              [169.80616295700008, -72.25505950299993],
              [169.8203231130001, -72.26018645599993],
              [169.89177493600005, -72.26531340899993],
              [169.90642337300005, -72.27092864399992],
              [169.9199324880001, -72.27800872199992],
              [169.9340926440001, -72.28248463299991],
              [169.95045006600003, -72.28045012799993],
              [169.96461022200003, -72.28036874799994],
              [169.991547071, -72.29119231599992],
              [170.00993899800005, -72.28777434699992],
              [169.99170983200008, -72.3068986959999],
              [169.86670983200008, -72.39706796699994],
              [169.85767662900003, -72.41326262799993],
              [169.8852645190001, -72.4299455709999],
              [169.94288170700008, -72.42620208099993],
              [170.04639733200008, -72.40195077899995],
              [170.0634871750001, -72.39299895599993],
              [170.09937584700003, -72.36394622199992],
              [170.1181746750001, -72.3532854149999],
              [170.244476759, -72.32048919099992],
              [170.26628665500004, -72.3186174459999],
              [170.28239993600005, -72.32634856599992],
              [170.29216556100005, -72.3650041649999],
              [170.302093946, -72.36834075299993],
              [170.3129988940001, -72.3693986959999],
              [170.31918379, -72.37810637799993],
              [170.32593834700003, -72.40642669099992],
              [170.33155358200008, -72.41806405999995],
              [170.34050540500004, -72.43124765399995],
              [170.33961022200003, -72.43889739399992],
              [170.33090254, -72.44793059699992],
              [170.31137129, -72.46249765399995],
              [170.30225670700008, -72.47356536299992],
              [170.29851321700005, -72.48552825299993],
              [170.295258009, -72.5139299459999],
              [170.28199303500003, -72.56389739399992],
              [170.2705184250001, -72.58896249799994],
              [170.25538170700008, -72.60295989399992],
              [170.203949415, -72.61541106599992],
              [170.151703321, -72.61777109199994],
              [170.0996199880001, -72.61199309699992],
              [170.04802493600005, -72.60019296699994],
              [169.97234134200005, -72.57317473799992],
              [169.92261803500003, -72.56780364399992],
              [169.87964928500003, -72.55429452899995],
              [169.8574324880001, -72.55087655999995],
              [169.72730553500003, -72.55201588299991],
              [169.7002059250001, -72.54827239399992],
              [169.68726647200003, -72.54452890399995],
              [169.67505944100003, -72.53850676899992],
              [169.63550866000003, -72.51279062299994],
              [169.61451256600003, -72.50359465899993],
              [169.58912194100003, -72.50017669099992],
              [169.58179772200003, -72.50286223799992],
              [169.56714928500003, -72.51425546699994],
              [169.559906446, -72.51677825299993],
              [169.54859459700003, -72.51506926899992],
              [169.43246504, -72.47283294099992],
              [169.39210045700008, -72.46689218499995],
              [169.3105574880001, -72.48902760199991],
              [169.12647545700008, -72.48503997199992],
              [168.70671634200005, -72.35906340899993],
              [168.67790774800005, -72.3630510399999],
              [168.6416121750001, -72.38241952899995],
              [168.5942488940001, -72.38681405999995],
              [168.40788821700005, -72.36882903399993],
              [168.31617272200003, -72.37363046699994],
              [168.59176679750004, -72.47478606599992],
              [168.86736087300005, -72.5759416649999],
              [168.918793165, -72.58326588299991],
              [169.3017684250001, -72.57732512799993],
              [169.3486434250001, -72.5954729149999],
              [169.38640384200005, -72.61785247199992],
              [169.39625084700003, -72.6267229149999],
              [169.4023543630001, -72.64006926899992],
              [169.4004012380001, -72.64812590899993],
              [169.40211022200003, -72.65488046699994],
              [169.41944420700008, -72.66415780999995],
              [169.47022545700008, -72.68230559699992],
              [169.49724368600005, -72.68718840899993],
              [169.52173912900003, -72.68482838299991],
              [169.5727645190001, -72.6716447899999],
              [169.62566165500004, -72.66464609199994],
              [169.67888431100005, -72.66562265399995],
              [169.88404381600003, -72.71168385199991],
              [169.93246504, -72.73593515399995],
              [169.84880618600005, -72.80022551899992],
              [169.7568465500001, -72.85271575299993],
              [169.72087649800005, -72.8674455709999],
              [169.71404056100005, -72.87420012799993],
              [169.7021590500001, -72.90154387799993],
              [169.6943465500001, -72.91228606599992],
              [169.68230228000004, -72.92115650799991],
              [169.6098738940001, -72.95549895599993],
              [169.5844832690001, -72.96217213299991],
              [169.60816491000003, -72.99334075299993],
              [169.60035241000003, -72.99724700299993],
              [169.58513431100005, -73.00741952899995],
              [169.57732181100005, -73.01116301899992],
              [169.631195509, -73.04371510199991],
              [169.60718834700003, -73.06454843499995],
              [169.58228600400003, -73.08049895599993],
              [169.555023634, -73.09124114399992],
              [169.40121504, -73.11028411299992],
              [169.38941491000003, -73.11028411299992],
              [169.37867272200003, -73.1057268209999],
              [169.36931399800005, -73.09840260199991],
              [169.36052493600005, -73.09026458099993],
              [169.3466903000001, -73.0798479149999],
              [169.33375084700003, -73.0764299459999],
              [169.266449415, -73.07919687299994],
              [169.172211134, -73.10312265399995],
              [169.21989993600005, -73.13250090899993],
              [169.24952233200008, -73.19068775799991],
              [169.25114993600005, -73.24846770599993],
              [169.21461022200003, -73.27646249799994],
              [169.07309004, -73.26653411299992],
              [169.0078231130001, -73.27109140399995],
              [168.97974694100003, -73.2639299459999],
              [168.982758009, -73.23886484199994],
              [168.9345809250001, -73.24098072699991],
              [168.91163170700008, -73.23650481599992],
              [168.893890821, -73.22340260199991],
              [168.89828535200002, -73.22031015399995],
              [168.906586134, -73.21249765399995],
              [168.91130618600005, -73.20940520599993],
              [168.8877059250001, -73.19394296699994],
              [168.87907962300005, -73.17839934699992],
              [168.88689212300005, -73.16318124799994],
              [168.91325931100005, -73.1482072899999],
              [168.94507897200003, -73.13551197699991],
              [168.94800866000003, -73.13160572699991],
              [168.95183353000004, -73.11923593499995],
              [168.95484459700003, -73.11541106599992],
              [168.9658309250001, -73.11272551899992],
              [169.00570722700002, -73.11044687299994],
              [168.9751082690001, -73.09148528399993],
              [168.94117272200003, -73.08798593499995],
              [168.85108483200008, -73.10271575299993],
              [168.81470787900003, -73.11874765399995],
              [168.79460696700005, -73.1233049459999],
              [168.75464928500003, -73.12395598799992],
              [168.71452884200005, -73.12004973799992],
              [168.7246199880001, -73.1110979149999],
              [168.73585045700008, -73.10418059699992],
              [168.7485457690001, -73.09954192499993],
              [168.7617293630001, -73.0974260399999],
              [168.75261478000004, -73.07691822699991],
              [168.72820071700005, -73.07170989399992],
              [168.672699415, -73.0744768209999],
              [168.63892662900003, -73.06780364399992],
              [168.6142684250001, -73.05592213299991],
              [168.56625410200002, -73.02068450299993],
              [168.54053795700008, -73.00855885199991],
              [168.39405358200008, -72.97193775799991],
              [168.36744225400003, -72.9690080709999],
              [168.3349715500001, -72.97031015399995],
              [168.29761803500003, -72.99032968499995],
              [168.32488040500004, -73.02654387799993],
              [168.37427819100003, -73.06780364399992],
              [168.40251712300005, -73.10295989399992],
              [168.39795983200008, -73.12900155999995],
              [168.38111412900003, -73.14788176899992],
              [168.3579207690001, -73.1599260399999],
              [168.33415774800005, -73.16545989399992],
              [168.30420983200008, -73.16399504999993],
              [168.25611412900003, -73.14462655999995],
              [168.226898634, -73.13779062299994],
              [168.21208743600005, -73.13909270599993],
              [168.18930097700002, -73.14999765399995],
              [168.17595462300005, -73.15357838299991],
              [168.16293379, -73.15300872199992],
              [168.06983483200008, -73.12297942499993],
              [168.0415145190001, -73.1174455709999],
              [168.0141707690001, -73.12118905999995],
              [167.97999108200008, -73.13241952899995],
              [167.95533287900003, -73.13551197699991],
              [167.8964949880001, -73.12835051899992],
              [167.86589603000004, -73.12932708099993],
              [167.81137129, -73.14755624799994],
              [167.78077233200008, -73.15292734199994],
              [167.72193444100003, -73.15178801899992],
              [167.693695509, -73.1447893209999],
              [167.64478600400003, -73.11467864399992],
              [167.61670983200008, -73.11793385199991],
              [167.557953321, -73.1403947899999],
              [167.50407962300005, -73.14861419099992],
              [167.17139733200008, -73.15300872199992],
              [167.05844160200002, -73.12908294099992],
              [167.05103600400003, -73.1233049459999],
              [167.0283309250001, -73.08977629999993],
              [166.9912215500001, -73.0525041649999],
              [166.9712020190001, -73.03655364399992],
              [166.9462996750001, -73.02385833099993],
              [166.83545983200008, -72.99732838299991],
              [166.61646569100003, -72.9729143209999],
              [166.56397545700008, -72.95647551899992],
              [166.5205184250001, -72.92978280999995],
              [166.56910241000003, -72.89666106599992],
              [166.582855665, -72.88201262799993],
              [166.54021243600005, -72.88201262799993],
              [166.45484459700003, -72.89999765399995],
              [166.36540774800005, -72.90048593499995],
              [166.3408309250001, -72.90390390399995],
              [166.33082116000003, -72.91366952899995],
              [166.3388778000001, -72.92962004999993],
              [166.35621178500003, -72.94768645599993],
              [166.39421634200005, -72.97763437299994],
              [166.4140731130001, -72.98674895599993],
              [166.45850670700008, -72.99504973799992],
              [166.549164259, -73.02849700299993],
              [166.76677493600005, -73.06487395599993],
              [166.7578231130001, -73.08700937299994],
              [166.74634850400003, -73.10540129999993],
              [166.72974694100003, -73.11777109199994],
              [166.7055770190001, -73.1208635399999],
              [166.73845462300005, -73.1618791649999],
              [166.7763778000001, -73.18914153399993],
              [166.820648634, -73.20745208099993],
              [166.8720809250001, -73.22136809699992],
              [166.73951256600003, -73.32919687299994],
              [166.77759850400003, -73.36532968499995],
              [166.82252037900003, -73.35426197699991],
              [166.9130965500001, -73.29989999799994],
              [166.9751082690001, -73.27499765399995],
              [167.09522545700008, -73.25212981599992],
              [167.3115340500001, -73.27361419099992],
              [167.3071395190001, -73.28069426899992],
              [167.30030358200008, -73.29656340899993],
              [167.2959090500001, -73.30364348799992],
              [167.331390821, -73.31365325299993],
              [167.44597415500004, -73.30388762799993],
              [167.92937259200005, -73.35865650799991],
              [167.7568465500001, -73.36842213299991],
              [167.62289472700002, -73.3591447899999],
              [167.6411238940001, -73.38209400799991],
              [167.67855879, -73.4026018209999],
              [167.75318444100003, -73.43206145599993],
              [167.71648196700005, -73.44687265399995],
              [167.67896569100003, -73.44719817499993],
              [167.5200301440001, -73.4196916649999],
              [167.48267662900003, -73.40146249799994],
              [167.46469160200002, -73.39804452899995],
              [167.4423934250001, -73.40398528399993],
              [167.4262801440001, -73.40536874799994],
              [167.3828231130001, -73.39519622199992],
              [167.36312910200002, -73.3943010399999],
              [167.24968509200005, -73.40545012799993],
              [167.2304793630001, -73.41090260199991],
              [167.22193444100003, -73.41814544099992],
              [167.22584069100003, -73.43434010199991],
              [167.23853600400003, -73.44353606599992],
              [167.2754012380001, -73.45273202899995],
              [167.2236434250001, -73.47698333099993],
              [167.2500106130001, -73.48162200299993],
              [167.30534915500004, -73.4768205709999],
              [167.32960045700008, -73.48186614399992],
              [167.35523522200003, -73.49163176899992],
              [167.43474368600005, -73.50318775799991],
              [167.3818465500001, -73.52304452899995],
              [167.32699629, -73.53248463299991],
              [167.272797071, -73.52800872199992],
              [167.19459069100003, -73.4919572899999],
              [167.02173912900003, -73.46233489399992],
              [166.9892684250001, -73.4651018209999],
              [167.0566512380001, -73.49911874799994],
              [167.07691491000003, -73.51262786299992],
              [167.053070509, -73.54705169099992],
              [167.03296959700003, -73.56609465899993],
              [167.00668379, -73.57154713299991],
              [166.92530358200008, -73.56015390399995],
              [166.88542728000004, -73.56129322699991],
              [166.87671959700003, -73.5642229149999],
              [166.8701278000001, -73.5700822899999],
              [166.8584090500001, -73.58513762799993],
              [166.84913170700008, -73.59050872199992],
              [166.8383895190001, -73.58863697699991],
              [166.8154403000001, -73.57773202899995],
              [166.821625196, -73.57350025799991],
              [166.83318118600005, -73.56267669099992],
              [166.83961022200003, -73.5583635399999],
              [166.82732181100005, -73.54827239399992],
              [166.8129988940001, -73.54208749799994],
              [166.797699415, -73.5393205709999],
              [166.7817488940001, -73.53948333099993],
              [166.83277428500003, -73.52206796699994],
              [166.79216556100005, -73.49732838299991],
              [166.74732506600003, -73.48642343499995],
              [166.70191491000003, -73.49236419099992],
              [166.6601668630001, -73.51864999799994],
              [166.6445418630001, -73.53899504999993],
              [166.63054446700005, -73.56170012799993],
              [166.6142684250001, -73.58082447699991],
              [166.5903426440001, -73.59042734199994],
              [166.558929884, -73.59075286299992],
              [166.47217858200008, -73.58123137799993],
              [166.46216881600003, -73.58391692499993],
              [166.4575301440001, -73.58912525799991],
              [166.45142662900003, -73.59270598799992],
              [166.43767337300005, -73.59042734199994],
              [166.42505944100003, -73.58538176899992],
              [166.39136803500003, -73.56536223799992],
              [166.19483483200008, -73.48984140399995],
              [166.13982181100005, -73.48202890399995],
              [166.09343509200005, -73.49342213299991],
              [166.1196395190001, -73.51620859199994],
              [166.21851647200003, -73.5661760399999],
              [166.13941491000003, -73.57382577899995],
              [165.87370853000004, -73.56585051899992],
              [165.81706790500004, -73.57822030999995],
              [165.82545006600003, -73.59832122199992],
              [165.8447371750001, -73.6071916649999],
              [165.99634850400003, -73.62273528399993],
              [166.20085696700005, -73.67180754999993],
              [166.19117272200003, -73.6833635399999],
              [166.17920983200008, -73.69158294099992],
              [166.16521243600005, -73.69719817499993],
              [166.15064537900003, -73.70086028399993],
              [166.2275496750001, -73.70322030999995],
              [166.266449415, -73.70891692499993],
              [166.29420006600003, -73.72576262799993],
              [166.27133222700002, -73.73284270599993],
              [166.2353621750001, -73.75920989399992],
              [166.2153426440001, -73.76490650799991],
              [166.20386803500003, -73.76262786299992],
              [166.19214928500003, -73.75896575299993],
              [166.18091881600003, -73.75741952899995],
              [166.17017662900003, -73.76213958099993],
              [166.1665145190001, -73.7693010399999],
              [166.16358483200008, -73.79045989399992],
              [166.160492384, -73.79900481599992],
              [166.15219160200002, -73.80917734199994],
              [166.14437910200002, -73.81340911299992],
              [166.02995853000004, -73.80917734199994],
              [166.0048934250001, -73.81389739399992],
              [165.96461022200003, -73.82976653399993],
              [165.93775475400003, -73.83342864399992],
              [165.670258009, -73.79697030999995],
              [165.5830184250001, -73.80510833099993],
              [165.63160241000003, -73.83407968499995],
              [165.68311608200008, -73.85344817499993],
              [165.79314212300005, -73.87249114399992],
              [165.77507571700005, -73.8791643209999],
              [165.71843509200005, -73.8869768209999],
              [165.700043165, -73.89202239399992],
              [165.669281446, -73.90886809699992],
              [165.65186608200008, -73.91366952899995],
              [165.571136915, -73.91326262799993],
              [165.49097741000003, -73.90154387799993],
              [165.26059004, -73.89332447699991],
              [165.19898522200003, -73.85906340899993],
              [165.19214928500003, -73.83017343499995],
              [165.24537194100003, -73.77792734199994],
              [165.25603274800005, -73.74407317499993],
              [165.25171959700003, -73.73821379999993],
              [165.235199415, -73.72795989399992],
              [165.23064212300005, -73.72226327899995],
              [165.2329207690001, -73.71640390399995],
              [165.24537194100003, -73.70378997199992],
              [165.24496504, -73.69744231599992],
              [165.21599368600005, -73.66106536299992],
              [165.21509850400003, -73.64568450299993],
              [165.22828209700003, -73.62460702899995],
              [165.236664259, -73.60662200299993],
              [165.23121178500003, -73.59303150799991],
              [165.21697024800005, -73.58277760199991],
              [165.19841556100005, -73.57480234199994],
              [165.1801863940001, -73.56373463299991],
              [165.16749108200008, -73.54924895599993],
              [165.14795983200008, -73.51230234199994],
              [165.13355553500003, -73.47568124799994],
              [165.1250106130001, -73.46217213299991],
              [165.05258222700002, -73.41668059699992],
              [165.03199303500003, -73.41090260199991],
              [165.17750084700003, -73.35100676899992],
              [165.22185306100005, -73.34246184699992],
              [165.35816491000003, -73.34002044099992],
              [165.30884850400003, -73.32781340899993],
              [165.25220787900003, -73.32138437299994],
              [165.19516035200002, -73.32219817499993],
              [165.1455184250001, -73.33261484199994],
              [165.03305097700002, -73.37379322699991],
              [164.97722415500004, -73.38632577899995],
              [164.91391035200002, -73.38787200299993],
              [164.55884850400003, -73.32439544099992],
              [164.52613366000003, -73.33017343499995],
              [164.44320722700002, -73.36874765399995],
              [164.48951256600003, -73.39788176899992],
              [164.53874759200005, -73.41716887799993],
              [164.591156446, -73.42571379999993],
              [164.70240319100003, -73.41904062299994],
              [164.7666121750001, -73.42376067499993],
              [164.8291121750001, -73.4377580709999],
              [164.88013756600003, -73.46160247199992],
              [164.89380944100003, -73.48349374799994],
              [164.87810306100005, -73.52695077899995],
              [164.91195722700002, -73.57195403399993],
              [164.915375196, -73.60076262799993],
              [164.90593509200005, -73.65715911299992],
              [164.889984571, -73.68271249799994],
              [164.86198978000004, -73.69768645599993],
              [164.828461134, -73.70468515399995],
              [164.797211134, -73.70598723799992],
              [164.77556399800005, -73.7146135399999],
              [164.7504988940001, -73.73601653399993],
              [164.72828209700003, -73.76132577899995],
              [164.71461022200003, -73.78167083099993],
              [164.77621504, -73.80934010199991],
              [164.79078209700003, -73.81406015399995],
              [164.82488040500004, -73.81601327899995],
              [164.84099368600005, -73.82390715899993],
              [164.84986412900003, -73.83668385199991],
              [164.85531660200002, -73.85116952899995],
              [164.86280358200008, -73.86402760199991],
              [164.87818444100003, -73.87249114399992],
              [164.952484571, -73.8908830709999],
              [164.892914259, -73.92506275799991],
              [164.87086022200003, -73.93157317499993],
              [164.89039147200003, -73.94687265399995],
              [164.91138756600003, -73.95419687299994],
              [165.0000106130001, -73.9748674459999],
              [165.01978600400003, -73.97568124799994],
              [165.04664147200003, -73.97258879999993],
              [165.01937910200002, -73.94378020599993],
              [165.13347415500004, -73.97893645599993],
              [165.2602645190001, -74.00115325299993],
              [165.239105665, -74.0100236959999],
              [165.30884850400003, -74.03036874799994],
              [165.28248131600003, -74.04265715899993],
              [165.255218946, -74.04607512799993],
              [165.20036868600005, -74.04680754999993],
              [165.1098738940001, -74.05787525799991],
              [165.075531446, -74.05478280999995],
              [165.067718946, -74.04802825299993],
              [165.06413821700005, -74.0236955709999],
              [165.05681399800005, -74.01799895599993],
              [164.89600670700008, -73.99960702899995],
              [164.82374108200008, -73.96477629999993],
              [164.59148196700005, -73.92669036299992],
              [164.52955162900003, -73.92392343499995],
              [164.46827233200008, -73.92913176899992],
              [164.41081790500004, -73.94329192499993],
              [164.43702233200008, -73.95045338299991],
              [164.52125084700003, -73.96013762799993],
              [164.58773847700002, -73.97966887799993],
              [164.59555097700002, -73.98674895599993],
              [164.596039259, -73.99871184699992],
              [164.59327233200008, -74.01946379999993],
              [164.67253665500004, -73.99960702899995],
              [164.66749108200008, -74.01718515399995],
              [164.66968834700003, -74.03329843499995],
              [164.679047071, -74.04436614399992],
              [164.69548587300005, -74.04745859199994],
              [164.7158309250001, -74.04119231599992],
              [164.73943118600005, -74.02223072699991],
              [164.75652103000004, -74.01653411299992],
              [164.78793379, -74.0217424459999],
              [164.81820722700002, -74.04021575299993],
              [164.844574415, -74.0647111959999],
              [164.86443118600005, -74.08863697699991],
              [164.81812584700003, -74.10198333099993],
              [164.8344832690001, -74.11272551899992],
              [164.8535262380001, -74.11712004999993],
              [164.89380944100003, -74.12037525799991],
              [164.875824415, -74.13241952899995],
              [164.85572350400003, -74.13958098799992],
              [164.81275475400003, -74.14592864399992],
              [164.88233483200008, -74.17083098799992],
              [164.8598738940001, -74.20916106599992],
              [164.8989363940001, -74.22747161299992],
              [165.04468834700003, -74.24879322699991],
              [165.06275475400003, -74.25660572699991],
              [165.07740319100003, -74.27312590899993],
              [165.08073978000004, -74.2834611959999],
              [165.08521569100003, -74.30779387799993],
              [165.08863366000003, -74.31316497199992],
              [165.11394290500004, -74.3200822899999],
              [165.12281334700003, -74.32740650799991],
              [165.12818444100003, -74.34091562299994],
              [165.1074324880001, -74.34286874799994],
              [165.1005965500001, -74.34246184699992],
              [165.121918165, -74.35466887799993],
              [165.15381920700008, -74.38982512799993],
              [165.17701256600003, -74.40252044099992],
              [165.20826256600003, -74.41008879999993],
              [165.2236434250001, -74.4157854149999],
              [165.23511803500003, -74.42473723799992],
              [165.2465926440001, -74.43873463299991],
              [165.258148634, -74.44996510199991],
              [165.27165774800005, -74.4587541649999],
              [165.2880965500001, -74.46526458099993],
              [165.40512129, -74.47779713299991],
              [165.45777428500003, -74.4943986959999],
              [165.46355228000004, -74.52996184699992],
              [165.45582116000003, -74.55348072699991],
              [165.44809004, -74.60686614399992],
              [165.43474368600005, -74.62900155999995],
              [165.410980665, -74.64031340899993],
              [165.3872176440001, -74.63396575299993],
              [165.34058678500003, -74.60165780999995],
              [165.23853600400003, -74.5466447899999],
              [165.17693118600005, -74.52629973799992],
              [165.1308699880001, -74.53004322699991],
              [165.105804884, -74.54485442499993],
              [165.08269290500004, -74.55429452899995],
              [165.05827884200005, -74.55828215899993],
              [165.00310306100005, -74.55673593499995],
              [164.9492293630001, -74.56560637799993],
              [164.92172285200002, -74.56454843499995],
              [164.8974715500001, -74.56682708099993],
              [164.84839928500003, -74.58521900799991],
              [164.81918379, -74.58147551899992],
              [164.79224694100003, -74.57317473799992],
              [164.76490319100003, -74.56959400799991],
              [164.58741295700008, -74.57488372199992],
              [164.55054772200003, -74.56560637799993],
              [164.5039168630001, -74.56878020599993],
              [164.48853600400003, -74.56731536299992],
              [164.46461022200003, -74.55934010199991],
              [164.36312910200002, -74.50823333099993],
              [164.3408309250001, -74.50212981599992],
              [164.3183699880001, -74.50261809699992],
              [164.11296634200005, -74.54851653399993],
              [163.92505944100003, -74.55771249799994],
              [163.96168053500003, -74.58513762799993],
              [163.84734134200005, -74.61760833099993],
              [163.78728274800005, -74.62444426899992],
              [163.72022545700008, -74.61239999799994],
              [163.69646243600005, -74.61646900799991],
              [163.68474368600005, -74.61565520599993],
              [163.6684676440001, -74.60702890399995],
              [163.66285241000003, -74.59661223799992],
              [163.6621199880001, -74.5842424459999],
              [163.65943444100003, -74.56975676899992],
              [163.64991295700008, -74.54452890399995],
              [163.64283287900003, -74.51580169099992],
              [163.64714603000004, -74.49032968499995],
              [163.6718856130001, -74.4743791649999],
              [163.603851759, -74.45403411299992],
              [163.570648634, -74.44817473799992],
              [163.53337649800005, -74.45647551899992],
              [163.53272545700008, -74.43206145599993],
              [163.55534915500004, -74.38420989399992],
              [163.555511915, -74.36044687299994],
              [163.53541100400003, -74.34075286299992],
              [163.50367272200003, -74.33700937299994],
              [163.46989993600005, -74.34197356599992],
              [163.39527428500003, -74.3630510399999],
              [163.30583743600005, -74.40056731599992],
              [163.25660241000003, -74.41301848799992],
              [163.23316491000003, -74.41415780999995],
              [163.18637129, -74.40927499799994],
              [163.12134850400003, -74.40935637799993],
              [163.1084090500001, -74.41269296699994],
              [163.0986434250001, -74.41887786299992],
              [163.08969160200002, -74.42831796699994],
              [163.08757571700005, -74.43808359199994],
              [163.09750410200002, -74.4450822899999],
              [163.181976759, -74.4470354149999],
              [163.19678795700008, -74.45574309699992],
              [163.208343946, -74.48064544099992],
              [163.22722415500004, -74.50261809699992],
              [163.27076256600003, -74.54176197699991],
              [163.215179884, -74.58660247199992],
              [163.2021590500001, -74.59441497199992],
              [163.16684004, -74.60735442499993],
              [163.08912194100003, -74.65829843499995],
              [163.07927493600005, -74.67107512799993],
              [163.07105553500003, -74.68629322699991],
              [163.0610457690001, -74.69988372199992],
              [163.045258009, -74.70777760199991],
              [163.01189212300005, -74.7014299459999],
              [162.98853600400003, -74.6755510399999],
              [162.95337975400003, -74.61541106599992],
              [162.93775475400003, -74.60475025799991],
              [162.9189559250001, -74.60214609199994],
              [162.89918053500003, -74.60426197699991],
              [162.8808699880001, -74.60865650799991],
              [162.8637801440001, -74.61028411299992],
              [162.83073978000004, -74.60475025799991],
              [162.8129988940001, -74.6037736959999],
              [162.83423912900003, -74.63616301899992],
              [162.83871504, -74.65105559699992],
              [162.8310653000001, -74.66480885199991],
              [162.82252037900003, -74.66985442499993],
              [162.8032332690001, -74.67595794099992],
              [162.79460696700005, -74.68084075299993],
              [162.78777103000004, -74.68857187299994],
              [162.77662194100003, -74.70598723799992],
              [162.7705184250001, -74.71282317499993],
              [162.730804884, -74.73137786299992],
              [162.59148196700005, -74.75017669099992],
              [162.59441165500004, -74.76604583099993],
              [162.60132897200003, -74.77898528399993],
              [162.6123153000001, -74.78777434699992],
              [162.62818444100003, -74.79111093499995],
              [162.60718834700003, -74.82634856599992],
              [162.583343946, -74.85019296699994],
              [162.55258222700002, -74.86443450299993],
              [162.51148522200003, -74.87078215899993],
              [162.47478274800005, -74.86467864399992],
              [162.40455162900003, -74.83782317499993],
              [162.3637801440001, -74.8415666649999],
              [162.3847762380001, -74.85507577899995],
              [162.4550887380001, -74.88241952899995],
              [162.45199629, -74.92115650799991],
              [162.489593946, -74.9436174459999],
              [162.54314212300005, -74.95370859199994],
              [162.6894637380001, -74.95940520599993],
              [162.74195397200003, -74.9704729149999],
              [162.7861434250001, -74.9900041649999],
              [162.75749759200005, -75.01628997199992],
              [162.71045983200008, -75.02825286299992],
              [162.61784915500004, -75.03093840899993],
              [162.6318465500001, -75.04241301899992],
              [162.64861087300005, -75.04729583099993],
              [162.68572024800005, -75.05071379999993],
              [162.65805097700002, -75.08098723799992],
              [162.62378991000003, -75.09303150799991],
              [162.546234571, -75.10116952899995],
              [162.55787194100003, -75.12184010199991],
              [162.5791121750001, -75.13746510199991],
              [162.60417728000004, -75.14788176899992],
              [162.62777754, -75.15349700299993],
              [162.655609571, -75.16741301899992],
              [162.64600670700008, -75.18889739399992],
              [162.6191512380001, -75.21038176899992],
              [162.59522545700008, -75.22372812299994],
              [162.5434676440001, -75.24016692499993],
              [162.262543165, -75.27117278399993],
              [162.02955162900003, -75.25986093499995],
              [161.920258009, -75.23626067499993],
              [161.89795983200008, -75.22714609199994],
              [161.8540145190001, -75.20305754999993],
              [161.831390821, -75.19443124799994],
              [161.80445397200003, -75.18987395599993],
              [161.7763778000001, -75.18889739399992],
              [161.66684004, -75.19996510199991],
              [161.6142684250001, -75.21428801899992],
              [161.59058678500003, -75.22893645599993],
              [161.5546981130001, -75.2639299459999],
              [161.528656446, -75.27613697699991],
              [161.47486412900003, -75.28557708099993],
              [160.975922071, -75.28720468499995],
              [160.91032962300005, -75.30144622199992],
              [160.87842858200008, -75.30396900799991],
              [160.848480665, -75.31023528399993],
              [160.79957116000003, -75.34042734199994],
              [160.70777428500003, -75.3654924459999],
              [160.582367384, -75.37835051899992],
              [160.6386824880001, -75.39763762799993],
              [160.92530358200008, -75.4279924459999],
              [160.97673587300005, -75.42205169099992],
              [161.08708743600005, -75.38437265399995],
              [161.45508873800006, -75.38551197699995],
              [161.82309004000004, -75.38665129999994],
              [162.19109134200005, -75.38779062299994],
              [162.20875084700003, -75.39771900799991],
              [162.2622176440001, -75.4416643209999],
              [162.2734481130001, -75.45671965899993],
              [162.283539259, -75.47820403399993],
              [162.301117384, -75.50505950299993],
              [162.3066512380001, -75.52939218499995],
              [162.28077233200008, -75.54265715899993],
              [162.1445418630001, -75.53655364399992],
              [162.073578321, -75.5427385399999],
              [162.02955162900003, -75.57415129999993],
              [162.05779056100005, -75.58521900799991],
              [162.0844832690001, -75.5920549459999],
              [162.1118270190001, -75.59498463299991],
              [162.21648196700005, -75.59197356599992],
              [162.22584069100003, -75.59840260199991],
              [162.2231551440001, -75.6130510399999],
              [162.21314537900003, -75.6286760399999],
              [162.200531446, -75.63787200299993],
              [162.21452884200005, -75.6384416649999],
              [162.22535241000003, -75.64267343499995],
              [162.23406009200005, -75.65007903399993],
              [162.24170983200008, -75.66057708099993],
              [162.250336134, -75.66692473799992],
              [162.26343834700003, -75.66904062299994],
              [162.2895613940001, -75.66871510199991],
              [162.297699415, -75.67253997199992],
              [162.30811608200008, -75.68889739399992],
              [162.3149520190001, -75.69443124799994],
              [162.4594832690001, -75.71298593499995],
              [162.46892337300005, -75.71257903399993],
              [162.47917728000004, -75.71062590899993],
              [162.48780358200008, -75.71087004999993],
              [162.49284915500004, -75.7165666649999],
              [162.49781334700003, -75.73528411299992],
              [162.50310306100005, -75.74488697699991],
              [162.51319420700008, -75.74879322699991],
              [162.53248131600003, -75.75066497199992],
              [162.55844160200002, -75.7502580709999],
              [162.58464603000004, -75.74675872199992],
              [162.59522545700008, -75.74765390399995],
              [162.62427819100003, -75.76140715899993],
              [162.843109571, -75.79306405999995],
              [162.90007571700005, -75.82293059699992],
              [162.8833113940001, -75.83733489399992],
              [162.8427840500001, -75.85312265399995],
              [162.81714928500003, -75.86834075299993],
              [162.809906446, -75.87037525799991],
              [162.805023634, -75.87363046699994],
              [162.805511915, -75.88005950299993],
              [162.809906446, -75.89104583099993],
              [162.809418165, -75.89714934699992],
              [162.80388431100005, -75.90154387799993],
              [162.79273522200003, -75.90715911299992],
              [162.75953209700003, -75.91480885199991],
              [162.57732181100005, -75.90927499799994],
              [162.55787194100003, -75.91253020599993],
              [162.54053795700008, -75.92180754999993],
              [162.5439559250001, -75.93206145599993],
              [162.559906446, -75.94003671699994],
              [162.57992597700002, -75.94304778399993],
              [162.60718834700003, -75.94296640399995],
              [162.62680097700002, -75.94548919099992],
              [162.70687910200002, -75.98105234199994],
              [162.70923912900003, -75.99334075299993],
              [162.69605553500003, -76.0197893209999],
              [162.71216881600003, -76.02743905999995],
              [162.722992384, -76.04045989399992],
              [162.73609459700003, -76.07390715899993],
              [162.65007571700005, -76.09107838299991],
              [162.39421634200005, -76.05982838299991],
              [162.42448978000004, -76.07431405999995],
              [162.521820509, -76.09823984199994],
              [162.4834090500001, -76.10898202899995],
              [162.44109134200005, -76.1057268209999],
              [162.39918053500003, -76.09384530999995],
              [162.3618270190001, -76.07805754999993],
              [162.35572350400003, -76.08310312299994],
              [162.301117384, -76.10051848799992],
              [162.33350670700008, -76.11394622199992],
              [162.447601759, -76.12818775799991],
              [162.4140731130001, -76.14812590899993],
              [162.36304772200003, -76.15162525799991],
              [162.2646590500001, -76.14723072699991],
              [162.16578209700003, -76.15496184699992],
              [162.115570509, -76.1701799459999],
              [162.0922957690001, -76.20224374799994],
              [162.1254988940001, -76.20208098799992],
              [162.14861087300005, -76.20501067499993],
              [162.16228274800005, -76.2185197899999],
              [162.16627037900003, -76.2502580709999],
              [162.262543165, -76.25644296699994],
              [162.329437696, -76.27629973799992],
              [162.34587649800005, -76.2756486959999],
              [162.434906446, -76.23430754999993],
              [162.48226972700002, -76.22063567499993],
              [162.57154381600003, -76.21477629999993],
              [162.58472741000003, -76.21672942499993],
              [162.59546959700003, -76.22144947699991],
              [162.6025496750001, -76.22747161299992],
              [162.6103621750001, -76.23251718499995],
              [162.62281334700003, -76.23430754999993],
              [162.730804884, -76.23154062299994],
              [162.75147545700008, -76.23512135199991],
              [162.772797071, -76.24374765399995],
              [162.78728274800005, -76.25945403399993],
              [162.78728274800005, -76.28484465899993],
              [162.7724715500001, -76.30185312299994],
              [162.7480574880001, -76.30852629999993],
              [162.70045006600003, -76.30771249799994],
              [162.70590254, -76.30934010199991],
              [162.72234134200005, -76.31755950299993],
              [162.7387801440001, -76.35857512799993],
              [162.82252037900003, -76.39666106599992],
              [162.88428795700008, -76.43906015399995],
              [162.8344832690001, -76.49334075299993],
              [162.72388756600003, -76.54265715899993],
              [162.68620853000004, -76.55006275799991],
              [162.56430097700002, -76.53460051899992],
              [162.53443444100003, -76.54697030999995],
              [162.54053795700008, -76.54989999799994],
              [162.55250084700003, -76.55771249799994],
              [162.55876712300005, -76.5603166649999],
              [162.54021243600005, -76.56462981599992],
              [162.5024520190001, -76.56731536299992],
              [162.48454837300005, -76.57244231599992],
              [162.47779381600003, -76.59148528399993],
              [162.47331790500004, -76.5979143209999],
              [162.4677840500001, -76.59905364399992],
              [162.46159915500004, -76.59921640399995],
              [162.4550887380001, -76.60247161299992],
              [162.423187696, -76.63925546699994],
              [162.45386803500003, -76.6501604149999],
              [162.49195397200003, -76.65683359199994],
              [162.756195509, -76.64934661299992],
              [162.843109571, -76.66472747199992],
              [162.87419681100005, -76.67636484199994],
              [162.93140709700003, -76.70745208099993],
              [162.94166100400003, -76.72063567499993],
              [162.9536238940001, -76.75725676899992],
              [162.96265709700003, -76.77361419099992],
              [162.9746199880001, -76.78972747199992],
              [162.9550887380001, -76.79094817499993],
              [162.9384871750001, -76.79892343499995],
              [162.9248153000001, -76.81145598799992],
              [162.91277103000004, -76.82724374799994],
              [162.89958743600005, -76.84107838299991],
              [162.88396243600005, -76.84807708099993],
              [162.86597741000003, -76.85003020599993],
              [162.84587649800005, -76.84856536299992],
              [162.79859459700003, -76.8342424459999],
              [162.78288821700005, -76.83245208099993],
              [162.74040774800005, -76.83261484199994],
              [162.698578321, -76.82659270599993],
              [162.62614993600005, -76.82488372199992],
              [162.42253665500004, -76.89918385199991],
              [162.5454207690001, -76.90439218499995],
              [162.58562259200005, -76.91806405999995],
              [162.52019290500004, -76.93694426899992],
              [162.3017684250001, -76.95134856599992],
              [162.526703321, -76.96021900799991],
              [162.50066165500004, -76.97649504999993],
              [162.46168053500003, -76.98512135199991],
              [162.38697350400003, -76.98845794099992],
              [162.42937259200005, -77.01165129999993],
              [162.46900475400003, -77.01531340899993],
              [162.61744225400003, -77.00139739399992],
              [162.64633222700002, -77.0036760399999],
              [162.69166100400003, -77.02613697699991],
              [162.716156446, -77.0276018209999],
              [162.81999759200005, -77.0158830709999],
              [162.92164147200003, -77.02117278399993],
              [163.02076256600003, -77.01409270599993],
              [163.06950931100005, -77.01873137799993],
              [163.16285241000003, -77.04363372199992],
              [163.144867384, -77.06487395599993],
              [163.124359571, -77.08391692499993],
              [163.18506920700008, -77.1076799459999],
              [163.21045983200008, -77.12216562299994],
              [163.23715254, -77.14470794099992],
              [163.26710045700008, -77.15911223799992],
              [163.344086134, -77.16497161299992],
              [163.377289259, -77.17669036299992],
              [163.38843834700003, -77.18808359199994],
              [163.40642337300005, -77.21502044099992],
              [163.41814212300005, -77.22568124799994],
              [163.43384850400003, -77.23154062299994],
              [163.466156446, -77.23943450299993],
              [163.4795028000001, -77.24944426899992],
              [163.50114993600005, -77.27857838299991],
              [163.5127059250001, -77.29013437299994],
              [163.52955162900003, -77.30071379999993],
              [163.5429793630001, -77.31316497199992],
              [163.54810631600003, -77.32976653399993],
              [163.5454207690001, -77.3474260399999],
              [163.5356551440001, -77.36256275799991],
              [163.570648634, -77.37786223799992],
              [163.6035262380001, -77.38795338299991],
              [163.63738040500004, -77.39332447699991],
              [163.7158309250001, -77.39657968499995],
              [163.7295028000001, -77.40398528399993],
              [163.7451278000001, -77.42107512799993],
              [163.7597762380001, -77.42864348799992],
              [163.78191165500004, -77.43108489399992],
              [163.82406660200002, -77.43084075299993],
              [163.774261915, -77.44784921699994],
              [163.81820722700002, -77.47665780999995],
              [163.83130944100003, -77.49578215899993],
              [163.82178795700008, -77.51832447699991],
              [163.80054772200003, -77.52800872199992],
              [163.548187696, -77.54900481599992],
              [163.50513756600003, -77.56943124799994],
              [163.66749108200008, -77.59514739399992],
              [163.7187606130001, -77.61492278399993],
              [163.65577233200008, -77.64666106599992],
              [163.58570397200003, -77.66130950299993],
              [163.44011478000004, -77.66855234199994],
              [163.5341903000001, -77.71550872199992],
              [163.5571395190001, -77.71998463299991],
              [163.90650475400003, -77.69638437299994],
              [163.9150496750001, -77.70110442499993],
              [163.9223738940001, -77.70769622199992],
              [163.93531334700003, -77.71331145599993],
              [164.24333743600005, -77.78191497199992],
              [164.19898522200003, -77.80803801899992],
              [164.11996504, -77.81218840899993],
              [163.97535241000003, -77.8025041649999],
              [163.83757571700005, -77.81585051899992],
              [163.70264733200008, -77.84978606599992],
              [163.7285262380001, -77.8791643209999],
              [163.78077233200008, -77.87883879999993],
              [163.87907962300005, -77.85947030999995],
              [164.18991132900004, -77.85670338299994],
              [164.50074303500003, -77.85393645599993],
              [164.52654056100005, -77.86492278399993],
              [164.54411868600005, -77.87493254999993],
              [164.5566512380001, -77.88958098799992],
              [164.5673934250001, -77.9143205709999],
              [164.52711022200003, -77.91912200299993],
              [164.5337020190001, -77.98707447699991],
              [164.48357181100005, -78.01897551899992],
              [164.40845787900003, -78.02857838299991],
              [164.33952884200005, -78.02996184699992],
              [164.35808353000004, -78.04314544099992],
              [164.3774520190001, -78.05185312299994],
              [164.420258009, -78.06308359199994],
              [164.40113366000003, -78.08603280999995],
              [164.36866295700008, -78.0979143209999],
              [164.2998153000001, -78.10751718499995],
              [164.18311608200008, -78.14364999799994],
              [164.03077233200008, -78.17083098799992],
              [163.88266035200002, -78.2209611959999],
              [163.84205162900003, -78.22698333099993],
              [163.93433678500003, -78.23088958099993],
              [164.116547071, -78.21428801899992],
              [164.207855665, -78.22576262799993],
              [164.3740340500001, -78.2790666649999],
              [164.446136915, -78.28337981599992],
              [164.46745853000004, -78.28850676899992],
              [164.5317488940001, -78.31715260199991],
              [164.55543053500003, -78.32138437299994],
              [164.6396590500001, -78.32561614399992],
              [164.6787215500001, -78.32024504999993],
              [164.75855553500003, -78.29143645599993],
              [165.09717858200008, -78.25400155999995],
              [165.11394290500004, -78.24724700299993],
              [165.14576256600003, -78.21990325299993],
              [165.16334069100003, -78.20826588299991],
              [165.1875106130001, -78.19915129999993],
              [165.21265709700003, -78.19378020599993],
              [165.23454837300005, -78.19345468499995],
              [165.216156446, -78.18320077899995],
              [165.155609571, -78.16562265399995],
              [165.22681725400003, -78.11760833099993],
              [165.306000196, -78.08782317499993],
              [165.41618899800005, -78.02532317499993],
              [165.444672071, -78.01873137799993],
              [165.49439537900003, -78.01864999799994],
              [165.54273522200003, -78.02646249799994],
              [165.561859571, -78.03337981599992],
              [165.58521569100003, -78.04485442499993],
              [165.60613040500004, -78.05934010199991],
              [165.61866295700008, -78.07512786299992],
              [165.6196395190001, -78.10222747199992],
              [165.60434004, -78.12249114399992],
              [165.58082116000003, -78.13632577899995],
              [165.33708743600005, -78.19890715899993],
              [165.36207116000003, -78.21152109199994],
              [165.45045006600003, -78.22730885199991],
              [165.50749759200005, -78.24456145599993],
              [165.56609134200005, -78.25457122199992],
              [165.65609785200002, -78.25546640399995],
              [165.68523196700005, -78.26083749799994],
              [165.70850670700008, -78.27117278399993],
              [165.73715254, -78.28972747199992],
              [165.75171959700003, -78.30974700299993],
              [165.732758009, -78.3244768209999],
              [165.74000084700003, -78.32626718499995],
              [165.7539168630001, -78.33212655999995],
              [165.76124108200008, -78.33407968499995],
              [165.745453321, -78.34628671699994],
              [165.726898634, -78.35361093499995],
              [165.68824303500003, -78.36443450299993],
              [165.73023522200003, -78.39959075299993],
              [165.78687584700003, -78.42066822699991],
              [166.12907962300005, -78.46998463299991],
              [166.34587649800005, -78.47258879999993],
              [166.56519616000003, -78.50709400799991],
              [167.00147545700008, -78.50107187299994],
              [167.05811608200008, -78.50904713299991],
              [167.106293165, -78.52752044099992],
              [167.215668165, -78.60068124799994],
              [167.2353621750001, -78.62363046699994],
              [167.243011915, -78.64804452899995],
              [167.22779381600003, -78.66920338299991],
              [167.2021590500001, -78.6814104149999],
              [167.1464949880001, -78.69573333099993],
              [167.06820722700002, -78.70671965899993],
              [166.80746503950002, -78.70936451599994],
              [166.54672285200002, -78.71200937299994],
              [166.41863040500004, -78.68547942499993],
              [166.37281334700003, -78.65878671699994],
              [166.1982528000001, -78.58782317499993],
              [166.08961022200003, -78.56682708099993],
              [165.76661217550003, -78.56524016699993],
              [165.44361412900003, -78.56365325299993],
              [165.45199629, -78.57293059699992],
              [165.46208743600005, -78.57976653399993],
              [165.473480665, -78.58416106599992],
              [165.48585045700008, -78.5857072899999],
              [165.30974368600005, -78.6052385399999],
              [164.85971113400007, -78.60458749799992],
              [164.40967858200008, -78.60393645599993],
              [164.07178795700008, -78.68710702899995],
              [163.98658287900003, -78.6858049459999],
              [164.07203209700003, -78.70614999799994],
              [164.04371178500003, -78.71217213299991],
              [163.986664259, -78.70663827899995],
              [163.96021569100003, -78.70810312299994],
              [163.94418379, -78.71493905999995],
              [163.917328321, -78.73235442499993],
              [163.899750196, -78.73674895599993],
              [163.85173587300005, -78.73707447699991],
              [163.64177493600005, -78.7165666649999],
              [163.577484571, -78.72079843499995],
              [163.5825301440001, -78.72421640399995],
              [163.5918074880001, -78.73259856599992],
              [163.59693444100003, -78.7360979149999],
              [163.5839949880001, -78.74146900799991],
              [163.57056725400003, -78.74456145599993],
              [163.55681399800005, -78.74537525799991],
              [163.5429793630001, -78.74374765399995],
              [163.547211134, -78.74960702899995],
              [163.55420983200008, -78.7634416649999],
              [163.5586043630001, -78.76962655999995],
              [163.484711134, -78.78191497199992],
              [163.47087649800005, -78.77988046699994],
              [163.44459069100003, -78.74260833099993],
              [163.43474368600005, -78.73381926899992],
              [163.42652428500003, -78.73455169099992],
              [163.4170028000001, -78.73967864399992],
              [163.403656446, -78.7439104149999],
              [163.3554793630001, -78.74480559699992],
              [163.25855553500003, -78.73300546699994],
              [163.2119246750001, -78.73284270599993],
              [163.13851972700002, -78.7458635399999],
              [163.11703535200002, -78.74488697699991],
              [163.08716881600003, -78.73821379999993],
              [163.0649520190001, -78.73691171699994],
              [163.04460696700005, -78.74382903399993],
              [163.01970462300005, -78.76165129999993],
              [162.9868270190001, -78.79119231599992],
              [162.96998131600003, -78.80144622199992],
              [162.9477645190001, -78.80828215899993],
              [162.90984134200005, -78.81145598799992],
              [162.9013778000001, -78.81438567499993],
              [162.89714603000004, -78.82301197699991],
              [162.89730879, -78.83464934699992],
              [162.89478600400003, -78.84685637799993],
              [162.88209069100003, -78.85735442499993],
              [162.90357506600003, -78.87639739399992],
              [162.91130618600005, -78.88176848799992],
              [162.881195509, -78.88860442499993],
              [162.80591881600003, -78.92620208099993],
              [162.74927819100003, -78.94060637799993],
              [162.69109134200005, -78.94654713299991],
              [162.6215926440001, -78.94524504999993],
              [162.5918074880001, -78.93450286299992],
              [162.56714928500003, -78.91025155999995],
              [162.5434676440001, -78.89511484199994],
              [162.47974694100003, -78.89251067499993],
              [162.45281009200005, -78.87802499799994],
              [162.46461022200003, -78.8654924459999],
              [162.46241295700008, -78.85100676899992],
              [162.45687910200002, -78.83782317499993],
              [162.45850670700008, -78.8298479149999],
              [162.5244246750001, -78.79631926899992],
              [162.48194420700008, -78.77898528399993],
              [162.43327884200005, -78.7810197899999],
              [162.3369246750001, -78.79534270599993],
              [162.12574303500003, -78.75986093499995],
              [162.1040145190001, -78.74920012799993],
              [162.0629988940001, -78.71884530999995],
              [161.97185306100005, -78.67701588299991],
              [161.952484571, -78.67343515399995],
              [161.90447024800005, -78.67034270599993],
              [161.85279381600003, -78.65536874799994],
              [161.76050866000003, -78.61044687299994],
              [161.78101647200003, -78.59970468499995],
              [161.82309004, -78.55462004999993],
              [161.86475670700008, -78.53582122199992],
              [161.8750106130001, -78.52288176899992],
              [161.86394290500004, -78.50074635199991],
              [161.82398522200003, -78.48121510199991],
              [161.78101647200003, -78.49277109199994],
              [161.73796634200005, -78.51327890399995],
              [161.6982528000001, -78.52109140399995],
              [161.602386915, -78.50644296699994],
              [161.55290774800005, -78.50554778399993],
              [161.50733483200008, -78.51572030999995],
              [161.49878991000003, -78.52206796699994],
              [161.4848738940001, -78.53964609199994],
              [161.47445722700002, -78.54599374799994],
              [161.36158287900003, -78.5783830709999],
              [161.3359481130001, -78.58123137799993],
              [161.37224368600005, -78.59075286299992],
              [161.39047285200002, -78.6135393209999],
              [161.40552819100003, -78.64169687299994],
              [161.431000196, -78.66741301899992],
              [161.44841556100005, -78.67929452899995],
              [161.46314537900003, -78.69198984199994],
              [161.48943118600005, -78.72323984199994],
              [161.5024520190001, -78.73430754999993],
              [161.556000196, -78.74960702899995],
              [161.54175866000003, -78.77532317499993],
              [161.53239993600005, -78.78639088299991],
              [161.52076256600003, -78.79534270599993],
              [161.54639733200008, -78.80584075299993],
              [161.63550866000003, -78.80396900799991],
              [161.66814212300005, -78.80779387799993],
              [161.697601759, -78.8147111959999],
              [161.75538170700008, -78.83945077899995],
              [161.72999108200008, -78.85947030999995],
              [161.698578321, -78.86679452899995],
              [161.63257897200003, -78.87102629999993],
              [161.79175866000003, -78.9099260399999],
              [161.80534915500004, -78.91757577899995],
              [161.81755618600005, -78.92864348799992],
              [161.8261824880001, -78.94052499799994],
              [161.83611087300005, -78.94996510199991],
              [161.8759871750001, -78.96282317499993],
              [161.9165145190001, -78.99765390399995],
              [162.0654403000001, -79.0686174459999],
              [161.77759850400003, -79.06951262799993],
              [161.49341881600003, -79.01962655999995],
              [161.49537194100003, -78.99089934699992],
              [161.46753991000003, -78.9724260399999],
              [161.43091881600003, -78.95777760199991],
              [161.38404381600003, -78.92180754999993],
              [161.34888756600003, -78.91497161299992],
              [161.27955162900003, -78.91594817499993],
              [161.26343834700003, -78.91838958099993],
              [161.251312696, -78.92489999799994],
              [161.23975670700008, -78.93287525799991],
              [161.22527103000004, -78.9397111959999],
              [161.20679772200003, -78.94296640399995],
              [161.00367272200003, -78.93368905999995],
              [161.19809004, -78.96217213299991],
              [161.16749108200008, -78.97909921699994],
              [161.15552819100003, -78.98943450299993],
              [161.14625084700003, -79.00432708099993],
              [161.13038170700008, -79.04941171699994],
              [161.098480665, -79.05999114399992],
              [161.0610457690001, -79.06340911299992],
              [160.69507897200003, -79.03753020599993],
              [160.74724368600005, -79.07488372199992],
              [160.71013431100005, -79.09726327899995],
              [160.38697350400003, -79.16814544099992],
              [160.4951278000001, -79.1994768209999],
              [160.49203535200002, -79.20566171699994],
              [160.48804772200003, -79.21949635199991],
              [160.4848738940001, -79.22535572699991],
              [160.51978600400003, -79.2404924459999],
              [160.51050866000003, -79.25750090899993],
              [160.4770613940001, -79.2712541649999],
              [160.43897545700008, -79.27695077899995],
              [160.46013431100005, -79.3029924459999],
              [160.49634850400003, -79.31145598799992],
              [160.57740319100003, -79.31023528399993],
              [160.65406334700003, -79.32000090899993],
              [160.72877037900003, -79.34059010199991],
              [160.70671634200005, -79.35759856599992],
              [160.680023634, -79.3674455709999],
              [160.6240340500001, -79.37859465899993],
              [160.6377059250001, -79.39324309699992],
              [160.66195722700002, -79.40536874799994],
              [160.71070397200003, -79.41920338299991],
              [160.96265709700003, -79.42766692499993],
              [161.02759850400003, -79.44215260199991],
              [161.0341903000001, -79.47478606599992],
              [161.01246178500003, -79.48316822699991],
              [160.7558699880001, -79.46770598799992],
              [160.6875106130001, -79.45012786299992],
              [160.6235457690001, -79.44996510199991],
              [160.5058699880001, -79.46526458099993],
              [160.48406009200005, -79.47649504999993],
              [160.46452884200005, -79.49749114399992],
              [160.44507897200003, -79.51327890399995],
              [160.41724694100003, -79.5232072899999],
              [160.24561608200008, -79.53980885199991],
              [160.21656334700003, -79.54827239399992],
              [160.16765384200005, -79.57138437299994],
              [160.14079837300005, -79.57854583099993],
              [160.07764733200008, -79.57968515399995],
              [159.63502037900003, -79.5256486959999],
              [159.6469832690001, -79.53826262799993],
              [159.66228274800005, -79.54509856599992],
              [159.695648634, -79.55144622199992],
              [159.71827233200008, -79.56178150799991],
              [159.72095787900003, -79.57529062299994],
              [159.7172957690001, -79.58977629999993],
              [159.7197371750001, -79.60263437299994],
              [159.73707116000003, -79.61728280999995],
              [159.7568465500001, -79.62574635199991],
              [159.80152428500003, -79.63551197699991],
              [159.86117597700002, -79.65911223799992],
              [159.8754988940001, -79.66204192499993],
              [160.35800214950007, -79.64023202899992],
              [160.84050540500004, -79.61842213299991],
              [160.76148522200003, -79.65081145599993],
              [160.42383873800003, -79.71143971149993],
              [160.08619225400003, -79.77206796699994],
              [159.78858483200008, -79.77988046699994],
              [159.66814212300005, -79.8064104149999],
              [159.4961043630001, -79.81951262799993],
              [159.5380965500001, -79.82529062299994],
              [159.62419681100005, -79.82529062299994],
              [159.664886915, -79.83440520599993],
              [159.63599694100003, -79.85320403399993],
              [159.598480665, -79.86394622199992],
              [159.52369225400003, -79.87493254999993],
              [159.670258009, -79.90943775799991],
              [159.82195071700005, -79.92571379999993],
              [159.97429446700005, -79.9221330709999],
              [160.32886803500003, -79.86126067499993],
              [160.3701278000001, -79.8615861959999],
              [160.4575301440001, -79.89657968499995],
              [160.62720787900003, -79.91277434699992],
              [160.7934676440001, -79.95501067499993],
              [160.850922071, -79.95745208099993],
              [161.32016035200002, -79.87753671699994],
              [161.47055097700002, -79.90162525799991],
              [161.4472762380001, -79.91139088299991],
              [161.4062606130001, -79.93694426899992],
              [161.3833113940001, -79.9470354149999],
              [160.94982615100008, -79.99902380466658],
              [160.51634090800007, -80.05101219433324],
              [160.08285566500007, -80.10300058399991],
              [159.64937042200006, -80.15498897366659],
              [159.21588517900005, -80.20697736333325],
              [158.78239993600005, -80.25896575299993],
              [158.78695722700002, -80.29949309699992],
              [158.73308353000004, -80.32463958099993],
              [158.47018476700003, -80.36528899499993],
              [158.20728600400003, -80.40593840899993],
              [158.17302493600005, -80.41952890399995],
              [158.19125410200002, -80.44443124799994],
              [158.2563582690001, -80.4533830709999],
              [158.531586134, -80.45761484199994],
              [158.5459090500001, -80.46184661299992],
              [158.57447350400003, -80.47470468499995],
              [158.5879012380001, -80.47698333099993],
              [159.02066490980008, -80.45759856539993],
              [159.45342858160006, -80.43821379979993],
              [159.88619225340005, -80.41882903419993],
              [160.31895592520004, -80.39944426859992],
              [160.75171959700003, -80.38005950299993],
              [160.77491295700008, -80.38323333099993],
              [160.81267337300005, -80.39495208099993],
              [160.84058678500003, -80.40935637799993],
              [160.851898634, -80.41806405999995],
              [160.86695397200003, -80.43808359199994],
              [160.87427819100003, -80.44353606599992],
              [160.8930770190001, -80.44817473799992],
              [160.93336022200003, -80.44548919099992],
              [160.95264733200008, -80.44801197699991],
              [160.97575931100005, -80.45818450299993],
              [161.0400496750001, -80.49797942499993],
              [160.98991946700005, -80.52263762799993],
              [160.93238366000003, -80.5232072899999],
              [160.6240340500001, -80.4704729149999],
              [160.5566512380001, -80.47380950299993],
              [160.607758009, -80.50872161299992],
              [160.63591556100005, -80.52304452899995],
              [160.664886915, -80.52971770599993],
              [160.61207116000003, -80.54680754999993],
              [160.35617109500004, -80.56886158649993],
              [160.10027103000004, -80.59091562299994],
              [160.03736412900003, -80.58562590899993],
              [159.9614363940001, -80.55291106599992],
              [159.93376712300005, -80.54973723799992],
              [159.817230665, -80.56845468499995],
              [159.75416100400003, -80.57073333099993],
              [159.82390384200005, -80.60662200299993],
              [159.85515384200005, -80.64218515399995],
              [159.87761478000004, -80.6501604149999],
              [160.260101759, -80.67880624799994],
              [160.55876712350005, -80.64462656049994],
              [160.8574324880001, -80.61044687299994],
              [160.9638778000001, -80.61972421699994],
              [161.09937584700003, -80.64771900799991],
              [161.12370853000004, -80.64527760199991],
              [161.1508895190001, -80.6384416649999],
              [161.17994225400003, -80.63779062299994],
              [161.20093834700003, -80.6482072899999],
              [161.203461134, -80.67473723799992],
              [161.195648634, -80.6833635399999],
              [161.18238366000003, -80.68474700299993],
              [161.16724694100003, -80.68401458099993],
              [161.15455162900003, -80.68678150799991],
              [161.14600670700008, -80.69638437299994],
              [161.1337996750001, -80.7224260399999],
              [161.1254988940001, -80.73235442499993],
              [161.10173587300005, -80.7419572899999],
              [161.00928795700008, -80.75855885199991],
              [161.34644616000003, -80.78435637799993],
              [161.24097741000003, -80.8029924459999],
              [160.88062584733336, -80.79583098766658],
              [160.5202742846667, -80.78866952933323],
              [160.15992272200003, -80.7815080709999],
              [160.04127037900003, -80.79648202899995],
              [159.746429884, -80.79208749799994],
              [159.57829837300005, -80.76799895599993],
              [159.5297957690001, -80.78036874799994],
              [159.54712975400003, -80.78785572699991],
              [159.5654403000001, -80.79265715899993],
              [159.60279381600003, -80.79810963299991],
              [159.5761824880001, -80.80624765399995],
              [159.52564537900003, -80.83318450299993],
              [159.49756920700008, -80.84303150799991],
              [159.5317488940001, -80.85393645599993],
              [159.74984785200002, -80.82919687299994],
              [160.17571048250005, -80.84913502399993],
              [160.6015731130001, -80.86907317499993],
              [160.598968946, -80.87411874799994],
              [160.595062696, -80.88543059699992],
              [160.59253991000003, -80.8903947899999],
              [160.87614993600005, -80.91464609199994],
              [160.71656334700003, -80.94646575299993],
              [160.6977645190001, -80.94304778399993],
              [160.66032962300005, -80.93206145599993],
              [160.64079837300005, -80.93425872199992],
              [160.66570071700005, -80.95305754999993],
              [160.70191491000003, -80.95818450299993],
              [160.8584090500001, -80.94784921699994],
              [160.8769637380001, -80.95086028399993],
              [160.933929884, -80.97226327899995],
              [160.90748131600003, -80.99285247199992],
              [160.5473738940001, -81.00676848799992],
              [160.60523522200003, -81.02581145599993],
              [160.62281334700003, -81.0388322899999],
              [160.61605879, -81.04062265399995],
              [160.60303795700008, -81.04558684699992],
              [160.59636478000004, -81.04705169099992],
              [160.64918053500003, -81.06731536299992],
              [160.82447350400003, -81.09823984199994],
              [160.774750196, -81.12509530999995],
              [160.5415145190001, -81.11923593499995],
              [160.75904381600003, -81.15781015399995],
              [160.79411868600005, -81.17229583099993],
              [160.8144637380001, -81.1897111959999],
              [160.76587975400003, -81.1994768209999],
              [160.60865319100003, -81.1931291649999],
              [160.8779403000001, -81.22429778399993],
              [161.0820418630001, -81.2190080709999],
              [161.14242597700002, -81.2443986959999],
              [160.91944420700008, -81.27019622199992],
              [160.52572675900007, -81.23695240699993],
              [160.13200931100005, -81.20370859199994],
              [160.1567488940001, -81.22283294099992],
              [160.19117272200003, -81.2346330709999],
              [160.2607528000001, -81.24960702899995],
              [160.28736412900003, -81.26043059699992],
              [160.33521569100003, -81.28679778399993],
              [160.3632918630001, -81.29363372199992],
              [160.61312910200002, -81.31755950299993],
              [160.62623131600003, -81.3166643209999],
              [160.59107506600003, -81.32431405999995],
              [160.40251712300005, -81.32561614399992],
              [160.36451256600003, -81.33635833099993],
              [160.36109459700003, -81.36077239399992],
              [160.30779056100005, -81.37981536299992],
              [160.34986412900003, -81.3928361959999],
              [160.40162194100003, -81.39251067499993],
              [160.49919681100005, -81.37607187299994],
              [160.88689212300005, -81.35702890399995],
              [161.0727645190001, -81.38486093499995],
              [160.99000084700003, -81.41668059699992],
              [160.9580184250001, -81.42262135199991],
              [160.84205162900003, -81.42848072699991],
              [160.88257897200003, -81.43914153399993],
              [160.8515731130001, -81.45940520599993],
              [160.88982181100005, -81.47087981599992],
              [160.931976759, -81.46672942499993],
              [161.01547285200002, -81.44841887799993],
              [161.4541121750001, -81.42351653399993],
              [161.51921634200005, -81.45208098799992],
              [161.49439537900003, -81.47698333099993],
              [161.47144616000003, -81.48967864399992],
              [161.01148522200003, -81.54876067499993],
              [161.30201256600003, -81.56011321399993],
              [161.59253991000003, -81.57146575299993],
              [161.57146243600005, -81.57781340899993],
              [161.5058699880001, -81.58416106599992],
              [161.56397545700008, -81.60466887799993],
              [161.99732506600003, -81.61858489399992],
              [161.95582116000003, -81.62851327899995],
              [161.91374759200005, -81.63388437299994],
              [161.980804884, -81.64723072699991],
              [162.230072462, -81.66818613049992],
              [162.47934004, -81.68914153399993],
              [162.47771243600005, -81.69426848799992],
              [162.475922071, -81.70549895599993],
              [162.47429446700005, -81.71054452899995],
              [162.53052819100003, -81.7190080709999],
              [162.4458113940001, -81.72722747199992],
              [162.46762129, -81.73113372199992],
              [162.5068465500001, -81.74675872199992],
              [162.5742293630001, -81.7483049459999],
              [162.62037194100003, -81.75432708099993],
              [162.39014733200008, -81.79802825299993],
              [162.4697371750001, -81.80754973799992],
              [162.35434004, -81.82268645599993],
              [162.23747806100005, -81.82480234199994],
              [162.26978600400003, -81.83798593499995],
              [162.29810631600003, -81.84612395599993],
              [162.3271590500001, -81.84978606599992],
              [162.63648522200003, -81.83603280999995],
              [162.767914259, -81.84840260199991],
              [162.76441491000003, -81.84449635199991],
              [162.75855553500003, -81.83521900799991],
              [162.755218946, -81.83114999799994],
              [162.7915145190001, -81.81292083099993],
              [162.84253991000003, -81.8044572899999],
              [162.89372806100005, -81.80722421699994],
              [162.94654381600003, -81.82878997199992],
              [163.01099694100003, -81.83733489399992],
              [163.0576278000001, -81.85214609199994],
              [163.10222415500004, -81.87371184699992],
              [163.04021243600005, -81.88713958099993],
              [162.97730553500003, -81.89316171699994],
              [162.72608483200008, -81.88762786299992],
              [162.69703209700003, -81.8908830709999],
              [162.6103621750001, -81.91228606599992],
              [162.6606551440001, -81.92294687299994],
              [162.8447371750001, -81.91480885199991],
              [162.89820397200003, -81.91985442499993],
              [162.9497176440001, -81.93474700299993],
              [163.03484134200005, -81.94019947699991],
              [163.004730665, -81.95086028399993],
              [162.96998131600003, -81.9533830709999],
              [162.90219160200002, -81.95012786299992],
              [163.07300866000003, -81.99993254999993],
              [163.2485457690001, -82.02353280999995],
              [163.2275496750001, -82.0295549459999],
              [163.20728600400003, -82.03850676899992],
              [163.59734134200005, -82.09042734199994],
              [163.56560306100005, -82.09921640399995],
              [163.46607506600003, -82.10279713299991],
              [163.5410262380001, -82.12249114399992],
              [163.77654056100005, -82.12859465899993],
              [163.74170983200008, -82.14218515399995],
              [163.62281334700003, -82.14755624799994],
              [163.91675866000003, -82.19011809699992],
              [163.883636915, -82.21648528399993],
              [163.83871504, -82.23105234199994],
              [163.3817070414286, -82.2584658464285],
              [162.92469904285718, -82.28587935085709],
              [162.46769104428577, -82.31329285528565],
              [162.01068304571433, -82.34070635971423],
              [161.55367504714292, -82.3681198641428],
              [161.0966670485715, -82.39553336857138],
              [160.6396590500001, -82.42294687299994],
              [160.688812696, -82.45077890399995],
              [160.74439537900003, -82.47454192499993],
              [160.802093946, -82.4919572899999],
              [160.85767662900003, -82.50090911299992],
              [161.25381513800002, -82.49924081849993],
              [161.64995364700002, -82.49757252399993],
              [162.04609215600001, -82.49590422949994],
              [162.442230665, -82.49423593499995],
              [162.49878991000003, -82.47926197699991],
              [162.528656446, -82.47665780999995],
              [162.7685653000001, -82.48699309699992],
              [162.9340926440001, -82.53093840899993],
              [163.08187910200002, -82.5446916649999],
              [163.0996199880001, -82.54168059699992],
              [163.1215926440001, -82.52141692499993],
              [163.145355665, -82.51482512799993],
              [163.4394637380001, -82.5451799459999],
              [163.40300540500004, -82.51238372199992],
              [163.3188582690001, -82.48300546699994],
              [163.16480553500003, -82.4494768209999],
              [163.28003991000003, -82.42636484199994],
              [163.74442250533335, -82.39717647399993],
              [164.2088051006667, -82.36798810599993],
              [164.673187696, -82.33879973799992],
              [164.7309676440001, -82.35564544099992],
              [164.88233483200008, -82.38014088299991],
              [165.23015384200005, -82.3928361959999],
              [165.351898634, -82.43425872199992],
              [165.408539259, -82.46672942499993],
              [165.43824303500003, -82.47649504999993],
              [165.55925540500004, -82.49342213299991],
              [165.53728274800005, -82.5075822899999],
              [165.47836347700002, -82.51580169099992],
              [165.46452884200005, -82.52532317499993],
              [165.4404403000001, -82.55706145599993],
              [165.39576256600003, -82.57366301899992],
              [165.34538821700005, -82.57968515399995],
              [165.30494225400003, -82.57952239399992],
              [165.37330162900003, -82.60613372199992],
              [165.74109948050005, -82.62953053199993],
              [166.10889733200008, -82.65292734199994],
              [166.1875106130001, -82.64202239399992],
              [166.22681725400003, -82.64364999799994],
              [166.5297957690001, -82.70273202899995],
              [166.45630944100003, -82.74187590899993],
              [166.4301863940001, -82.75042083099993],
              [166.44654381600003, -82.75074635199991],
              [166.4648543630001, -82.75652434699992],
              [166.49781334700003, -82.7712541649999],
              [166.51823978000004, -82.77776458099993],
              [166.53825931100005, -82.7815080709999],
              [166.5800887380001, -82.7829729149999],
              [166.90577233200008, -82.7575822899999],
              [167.30648847700002, -82.81707122199992],
              [167.3437606130001, -82.82927825299993],
              [167.35075931100005, -82.84384530999995],
              [167.33326256600003, -82.85849374799994],
              [167.1992293630001, -82.89755624799994],
              [167.1665145190001, -82.90032317499993],
              [167.40845787900003, -82.92498137799993],
              [167.36597741000003, -82.94540780999995],
              [167.3447371750001, -82.95281340899993],
              [167.06275475400003, -82.95614999799994],
              [167.10694420700008, -82.96965911299992],
              [167.4580184250001, -82.98113372199992],
              [167.45850670700008, -82.99797942499993],
              [167.45183353000004, -83.01067473799992],
              [167.4399520190001, -83.0197893209999],
              [167.424164259, -83.02605559699992],
              [167.5380965500001, -83.04013437299994],
              [167.61540774800005, -83.05820077899995],
              [167.656586134, -83.06170012799993],
              [167.738617384, -83.05559661299992],
              [167.890961134, -83.02450937299994],
              [168.044281446, -82.97136809699992],
              [168.11898847700002, -82.96111419099992],
              [168.5927840500001, -82.99895598799992],
              [168.623383009, -83.00603606599992],
              [168.6157332690001, -83.00798919099992],
              [168.60515384200005, -83.01490650799991],
              [168.59498131600003, -83.0232072899999],
              [168.58969160200002, -83.0295549459999],
              [168.60084069100003, -83.05543385199991],
              [168.64527428500003, -83.0720354149999],
              [168.77165774800005, -83.09319426899992],
              [168.8051863940001, -83.10784270599993],
              [168.86882571700005, -83.14592864399992],
              [168.86085045700008, -83.14804452899995],
              [168.82683353000004, -83.17115650799991],
              [168.796234571, -83.18377044099992],
              [168.76392662900003, -83.19133879999993],
              [168.42042076950003, -83.18759531049992],
              [168.07691491000003, -83.1838518209999],
              [168.18091881600003, -83.22275155999995],
              [168.5341903000001, -83.23365650799991],
              [168.50310306100005, -83.24871184699992],
              [168.41521243600005, -83.26685963299991],
              [168.15133711050004, -83.25001392999991],
              [167.88746178500003, -83.23316822699991],
              [167.86508222700002, -83.23552825299993],
              [167.80005944100003, -83.25188567499993],
              [167.74878991000003, -83.25514088299991],
              [167.49288984500004, -83.22348398199992],
              [167.23698978000004, -83.19182708099993],
              [166.99878991000003, -83.19915129999993],
              [167.02418053500003, -83.21738046699994],
              [167.05811608200008, -83.22584400799991],
              [167.54639733200008, -83.26645273199992],
              [168.03467858200008, -83.30706145599993],
              [167.9550887380001, -83.32854583099993],
              [167.987640821, -83.35035572699991],
              [168.0317488940001, -83.3596330709999],
              [168.16138756600003, -83.36842213299991],
              [168.28467858200008, -83.35312265399995],
              [168.33871504, -83.36484140399995],
              [168.35914147200003, -83.36516692499993],
              [168.47445722700002, -83.35295989399992],
              [168.52361087300005, -83.35800546699994],
              [168.5673934250001, -83.36777109199994],
              [168.61793053500003, -83.39055754999993],
              [168.63152103000004, -83.3943010399999],
              [168.66089928500003, -83.39714934699992],
              [169.02218672000004, -83.36699797999992],
              [169.38347415500004, -83.33684661299992],
              [169.3964949880001, -83.33993905999995],
              [169.40357506600003, -83.34677499799994],
              [169.40796959700003, -83.35588958099993],
              [169.41431725400003, -83.36484140399995],
              [169.427093946, -83.37078215899993],
              [169.4121199880001, -83.38486093499995],
              [169.3789168630001, -83.4079729149999],
              [169.364105665, -83.42205169099992],
              [169.39909915500004, -83.43368905999995],
              [169.466156446, -83.44736093499995],
              [169.54314212300005, -83.45012786299992],
              [169.560883009, -83.44695403399993],
              [169.57691491000003, -83.43694426899992],
              [169.5888778000001, -83.42571379999993],
              [169.59986412900003, -83.41814544099992],
              [169.61280358200008, -83.4143205709999],
              [169.63005618600005, -83.41480885199991],
              [169.58472741000003, -83.3986955709999],
              [169.59913170700008, -83.3928361959999],
              [169.61882571700005, -83.37346770599993],
              [169.62964928500003, -83.36907317499993],
              [170.1025496750001, -83.40471770599993],
              [170.05925540500004, -83.41318124799994],
              [170.06910241000003, -83.4216447899999],
              [170.0805770190001, -83.42717864399992],
              [170.09294681100005, -83.42978280999995],
              [170.1059676440001, -83.42913176899992],
              [170.1005965500001, -83.43352629999993],
              [170.09148196700005, -83.44402434699992],
              [170.0864363940001, -83.44850025799991],
              [170.12761478000004, -83.46331145599993],
              [170.223480665, -83.48398202899995],
              [170.4033309250001, -83.49163176899992],
              [170.41285241000003, -83.48984140399995],
              [170.42164147200003, -83.48349374799994],
              [170.437836134, -83.46624114399992],
              [170.447601759, -83.46249765399995],
              [170.73414147200003, -83.45183684699992],
              [170.7441512380001, -83.44817473799992],
              [170.7465926440001, -83.43954843499995],
              [170.74781334700003, -83.43075937299994],
              [170.75407962300005, -83.42636484199994],
              [170.8129988940001, -83.42327239399992],
              [171.19312584700003, -83.4455705709999],
              [171.2607528000001, -83.46331145599993],
              [171.38404381600003, -83.47014739399992],
              [171.47877037900003, -83.48943450299993],
              [171.55290774800005, -83.49472421699994],
              [171.57691491000003, -83.5002580709999],
              [171.50147545700008, -83.51897551899992],
              [171.4262801440001, -83.52898528399993],
              [171.1753035815001, -83.53163014099994],
              [170.9243270190001, -83.53427499799994],
              [170.94743899800005, -83.54216887799993],
              [170.97144616000003, -83.54558684699992],
              [171.02076256600003, -83.54631926899992],
              [170.97820071700005, -83.56178150799991],
              [171.00310306100005, -83.56878020599993],
              [171.33122806100005, -83.55543385199991],
              [171.7021590500001, -83.58587004999993],
              [171.73194420700008, -83.59172942499993],
              [171.78923587300005, -83.61028411299992],
              [171.95972741000003, -83.62021249799994],
              [171.9399520190001, -83.63323333099993],
              [171.91578209700003, -83.6389299459999],
              [171.8662215500001, -83.64413827899995],
              [172.04672285200002, -83.6584611959999],
              [172.0141707690001, -83.67058684699992],
              [171.9824324880001, -83.67848072699991],
              [171.914886915, -83.6877580709999],
              [172.00114993600005, -83.71689218499995],
              [172.09791100400003, -83.71803150799991],
              [172.368500196, -83.6775041649999],
              [172.820648634, -83.66790129999993],
              [173.23023522200003, -83.71233489399992],
              [173.31959069100003, -83.73202890399995],
              [173.31625410200002, -83.73674895599993],
              [173.31120853000004, -83.7478166649999],
              [173.30787194100003, -83.75261809699992],
              [173.41041100400003, -83.76140715899993],
              [173.61898847700002, -83.74928150799991],
              [173.72136478000004, -83.76360442499993],
              [173.68034915500004, -83.79119231599992],
              [173.29127037900003, -83.85637786299992],
              [173.40902754, -83.87810637799993],
              [173.83415774800005, -83.87363046699994],
              [173.86841881600003, -83.86288827899995],
              [173.88200931100005, -83.86126067499993],
              [173.9121199880001, -83.86394622199992],
              [173.92595462300005, -83.8674455709999],
              [173.95093834700003, -83.8791643209999],
              [173.96216881600003, -83.88176848799992],
              [174.29940839933337, -83.86467864399992],
              [174.6366479826667, -83.84758879999993],
              [174.97388756600003, -83.83049895599993],
              [175.12281334700003, -83.86923593499995],
              [175.44312584700003, -83.90325286299992],
              [175.3774520190001, -83.9279924459999],
              [175.16179446700005, -83.9572893209999],
              [175.18930097700002, -83.95761484199994],
              [175.26823978000004, -83.98040129999993],
              [175.30103600400003, -83.98447030999995],
              [175.6777449880001, -83.96160247199992],
              [176.1421004567501, -83.98567066849992],
              [176.6064559255001, -84.00973886499992],
              [177.0708113942501, -84.03380706149991],
              [177.5351668630001, -84.05787525799991],
              [177.616547071, -84.07341887799993],
              [177.55811608200008, -84.08001067499993],
              [177.61394290500004, -84.09238046699994],
              [177.87191816500007, -84.10426197749993],
              [178.1298934250001, -84.11614348799992],
              [178.15739993600005, -84.12265390399995],
              [178.19841556100005, -84.14251067499993],
              [178.21794681100005, -84.14462655999995],
              [178.4052840500001, -84.11760833099993],
              [178.52759850400003, -84.1213518209999],
              [178.4062606130001, -84.15545012799993],
              [178.48015384200005, -84.17913176899992],
              [178.5673934250001, -84.18377044099992],
              [178.78003991000003, -84.17131926899992],
              [178.86882571700005, -84.18328215899993],
              [179.35499108200008, -84.19736093499995],
              [179.7504988940001, -84.26921965899993],
              [179.78785241000003, -84.28394947699991],
              [179.695648634, -84.30364348799992],
              [179.6015731130001, -84.31129322699991],
              [179.6982528000001, -84.33131275799991],
              [180, -84.35279635299992],
              [180, -84.35338166999992],
              [180, -84.5152354569999],
              [180, -85.01385041599991],
              [180, -85.51246537399993],
              [180, -86.01108033199995],
              [180, -86.5096952909999],
              [180, -87.00831024899992],
              [180, -87.50692520799993],
              [180, -88.00554016599995],
              [180, -88.5041551249999],
              [180, -89.00277008299992],
              [180, -89.50138504199992],
              [180, -90],
              [179.5006934810001, -90],
              [179.00138696300007, -90],
              [178.50208044400006, -90],
              [178.00277392500004, -90],
              [177.50346740600003, -90],
              [177.004160888, -90],
              [176.5048543690001, -90],
              [176.00554785000008, -90],
              [175.50624133100007, -90],
              [175.00693481300004, -90],
              [174.50762829400003, -90],
              [174.008321775, -90],
              [173.5090152570001, -90],
              [173.00970873800009, -90],
              [172.51040221900007, -90],
              [172.01109570000006, -90],
              [171.51178918200003, -90],
              [171.01248266300001, -90],
              [170.513176144, -90],
              [170.0138696260001, -90],
              [169.51456310700007, -90],
              [169.01525658800006, -90],
              [168.51595006900004, -90],
              [168.01664355100002, -90],
              [167.517337032, -90],
              [167.0180305130001, -90],
              [166.51872399400008, -90],
              [166.01941747600006, -90],
              [165.52011095700004, -90],
              [165.02080443800003, -90],
              [164.52149792, -90],
              [164.0221914010001, -90],
              [163.52288488200008, -90],
              [163.02357836300007, -90],
              [162.52427184500004, -90],
              [162.02496532600003, -90],
              [161.525658807, -90],
              [161.026352288, -90],
              [160.5270457700001, -90],
              [160.02773925100007, -90],
              [159.52843273200006, -90],
              [159.02912621400003, -90],
              [158.52981969500001, -90],
              [158.030513176, -90],
              [157.5312066570001, -90],
              [157.03190013900007, -90],
              [156.53259362000006, -90],
              [156.03328710100004, -90],
              [155.53398058300002, -90],
              [155.034674064, -90],
              [154.5353675450001, -90],
              [154.03606102600008, -90],
              [153.53675450800006, -90],
              [153.03744798900004, -90],
              [152.53814147000003, -90],
              [152.038834951, -90],
              [151.5395284330001, -90],
              [151.04022191400009, -90],
              [150.54091539500007, -90],
              [150.04160887700004, -90],
              [149.54230235800003, -90],
              [149.042995839, -90],
              [148.54368932, -90],
              [148.0443828020001, -90],
              [147.54507628300007, -90],
              [147.04576976400006, -90],
              [146.54646324500004, -90],
              [146.04715672700002, -90],
              [145.547850208, -90],
              [145.0485436890001, -90],
              [144.54923717100007, -90],
              [144.04993065200006, -90],
              [143.55062413300004, -90],
              [143.05131761400003, -90],
              [142.552011096, -90],
              [142.0527045770001, -90],
              [141.55339805800008, -90],
              [141.05409154000006, -90],
              [140.55478502100004, -90],
              [140.05547850200003, -90],
              [139.556171983, -90],
              [139.0568654650001, -90],
              [138.55755894600009, -90],
              [138.05825242700007, -90],
              [137.55894590800006, -90],
              [137.05963939000003, -90],
              [136.560332871, -90],
              [136.061026352, -90],
              [135.5617198340001, -90],
              [135.06241331500007, -90],
              [134.56310679600006, -90],
              [134.06380027700004, -90],
              [133.56449375900002, -90],
              [133.06518724, -90],
              [132.5658807210001, -90],
              [132.06657420200008, -90],
              [131.56726768400006, -90],
              [131.06796116500004, -90],
              [130.56865464600003, -90],
              [130.069348128, -90],
              [129.5700416090001, -90],
              [129.07073509000008, -90],
              [128.57142857100007, -90],
              [128.07212205300004, -90],
              [127.57281553400003, -90],
              [127.07350901500001, -90],
              [126.5742024970001, -90],
              [126.07489597800009, -90],
              [125.57558945900007, -90],
              [125.07628294000006, -90],
              [124.57697642200003, -90],
              [124.07766990300001, -90],
              [123.578363384, -90],
              [123.0790568650001, -90],
              [122.57975034700007, -90],
              [122.08044382800006, -90],
              [121.58113730900004, -90],
              [121.08183079100002, -90],
              [120.582524272, -90],
              [120.0832177530001, -90],
              [119.58391123400008, -90],
              [119.08460471600006, -90],
              [118.58529819700004, -90],
              [118.08599167800003, -90],
              [117.58668516, -90],
              [117.0873786410001, -90],
              [116.58807212200009, -90],
              [116.08876560300007, -90],
              [115.58945908500004, -90],
              [115.09015256600003, -90],
              [114.59084604700001, -90],
              [114.091539528, -90],
              [113.59223301000009, -90],
              [113.09292649100007, -90],
              [112.59361997200006, -90],
              [112.09431345400003, -90],
              [111.59500693500007, -90],
              [111.09570041600006, -90],
              [110.59639389700004, -90],
              [110.09708737900007, -90],
              [109.59778086000006, -90],
              [109.09847434100004, -90],
              [108.59916782200003, -90],
              [108.09986130400006, -90],
              [107.60055478500004, -90],
              [107.10124826600003, -90],
              [106.60194174800006, -90],
              [106.10263522900004, -90],
              [105.60332871000003, -90],
              [105.10402219100007, -90],
              [104.60471567300004, -90],
              [104.10540915400003, -90],
              [103.60610263500007, -90],
              [103.10679611700004, -90],
              [102.60748959800003, -90],
              [102.10818307900007, -90],
              [101.60887656000006, -90],
              [101.10957004200003, -90],
              [100.61026352300007, -90],
              [100.11095700400006, -90],
              [99.61165048500004, -90],
              [99.11234396700007, -90],
              [98.61303744800006, -90],
              [98.11373092900004, -90],
              [97.61442441100007, -90],
              [97.11511789200006, -90],
              [96.61581137300004, -90],
              [96.11650485400003, -90],
              [95.61719833600006, -90],
              [95.11789181700004, -90],
              [94.61858529800003, -90],
              [94.11927877900007, -90],
              [93.61997226100004, -90],
              [93.12066574200003, -90],
              [92.62135922300007, -90],
              [92.12205270500004, -90],
              [91.62274618600003, -90],
              [91.12343966700007, -90],
              [90.62413314800006, -90],
              [90.12482663000003, -90],
              [89.62552011100007, -90],
              [89.12621359200006, -90],
              [88.62690707400003, -90],
              [88.12760055500007, -90],
              [87.62829403600006, -90],
              [87.12898751700004, -90],
              [86.62968099900007, -90],
              [86.13037448000006, -90],
              [85.63106796100004, -90],
              [85.13176144200008, -90],
              [84.63245492400006, -90],
              [84.13314840500004, -90],
              [83.63384188600008, -90],
              [83.13453536800006, -90],
              [82.63522884900004, -90],
              [82.13592233000003, -90],
              [81.63661581100007, -90],
              [81.13730929300004, -90],
              [80.63800277400003, -90],
              [80.13869625500007, -90],
              [79.63938973600006, -90],
              [79.14008321800003, -90],
              [78.64077669900007, -90],
              [78.14147018000006, -90],
              [77.64216366200003, -90],
              [77.14285714300007, -90],
              [76.64355062400006, -90],
              [76.14424410500004, -90],
              [75.64493758700007, -90],
              [75.14563106800006, -90],
              [74.64632454900004, -90],
              [74.14701803100007, -90],
              [73.64771151200006, -90],
              [73.14840499300004, -90],
              [72.64909847400008, -90],
              [72.14979195600006, -90],
              [71.65048543700004, -90],
              [71.15117891800008, -90],
              [70.65187239900007, -90],
              [70.15256588100004, -90],
              [69.65325936200009, -90],
              [69.15395284300007, -90],
              [68.65464632500004, -90],
              [68.15533980600009, -90],
              [67.65603328700007, -90],
              [67.15672676800006, -90],
              [66.65742025000003, -90],
              [66.15811373100007, -90],
              [65.65880721200006, -90],
              [65.15950069300004, -90],
              [64.66019417500007, -90],
              [64.16088765600006, -90],
              [63.66158113700004, -90],
              [63.16227461900007, -90],
              [62.66296810000006, -90],
              [62.16366158100004, -90],
              [61.664355062000084, -90],
              [61.65187463400008, -90],
              [61.16504854400006, -90],
              [60.66574202500004, -90],
              [60.166435506000084, -90],
              [59.66712898800006, -90],
              [59.16782246900004, -90],
              [58.668515950000085, -90],
              [58.16920943100007, -90],
              [57.669902913000044, -90],
              [57.170596394000086, -90],
              [56.67128987500007, -90],
              [56.171983356000055, -90],
              [55.672676838000086, -90],
              [55.17337031900007, -90],
              [54.674063800000056, -90],
              [54.17475728200009, -90],
              [53.67545076300007, -90],
              [53.17614424400006, -90],
              [52.67683772500004, -90],
              [52.17753120700007, -90],
              [51.67822468800006, -90],
              [51.17891816900004, -90],
              [50.67961165000008, -90],
              [50.18030513200006, -90],
              [49.68099861300004, -90],
              [49.181692094000084, -90],
              [48.68238557600006, -90],
              [48.18307905700004, -90],
              [47.683772538000085, -90],
              [47.18446601900007, -90],
              [46.685159501000044, -90],
              [46.185852982000085, -90],
              [45.68654646300007, -90],
              [45.187239945000044, -90],
              [44.687933426000086, -90],
              [44.18862690700007, -90],
              [43.689320388000056, -90],
              [43.19001387000009, -90],
              [42.69070735100007, -90],
              [42.191400832000056, -90],
              [41.69209431300004, -90],
              [41.19278779500007, -90],
              [40.69348127600006, -90],
              [40.19417475700004, -90],
              [39.69486823900007, -90],
              [39.19556172000006, -90],
              [38.69625520100004, -90],
              [38.196948682000084, -90],
              [37.69764216400006, -90],
              [37.19833564500004, -90],
              [36.699029126000084, -90],
              [36.19972260700007, -90],
              [35.70041608900004, -90],
              [35.201109570000085, -90],
              [34.70180305100007, -90],
              [34.202496533000044, -90],
              [33.703190014000086, -90],
              [33.20388349500007, -90],
              [32.704576976000055, -90],
              [32.205270458000086, -90],
              [31.70596393900007, -90],
              [31.206657420000056, -90],
              [30.707350902000087, -90],
              [30.20804438300007, -90],
              [29.708737864000057, -90],
              [29.20943134500004, -90],
              [28.710124827000072, -90],
              [28.210818308000057, -90],
              [27.711511789000042, -90],
              [27.212205270000084, -90],
              [26.712898752000058, -90],
              [26.213592233000043, -90],
              [25.714285714000084, -90],
              [25.21497919600006, -90],
              [24.715672677000043, -90],
              [24.216366158000085, -90],
              [23.71705963900007, -90],
              [23.217753121000044, -90],
              [22.718446602000085, -90],
              [22.21914008300007, -90],
              [21.719833564000055, -90],
              [21.220527046000086, -90],
              [20.72122052700007, -90],
              [20.221914008000056, -90],
              [19.722607490000087, -90],
              [19.22330097100007, -90],
              [18.723994452000056, -90],
              [18.22468793300004, -90],
              [17.725381415000072, -90],
              [17.226074896000057, -90],
              [16.72676837700004, -90],
              [16.227461859000073, -90],
              [15.728155340000058, -90],
              [15.228848821000042, -90],
              [14.729542302000084, -90],
              [14.230235784000058, -90],
              [13.730929265000043, -90],
              [13.231622746000085, -90],
              [12.73231622700007, -90],
              [12.233009709000044, -90],
              [11.733703190000085, -90],
              [11.23439667100007, -90],
              [10.735090153000044, -90],
              [10.235783634000086, -90],
              [9.73647711500007, -90],
              [9.237170596000055, -90],
              [8.737864078000086, -90],
              [8.238557559000071, -90],
              [7.739251040000056, -90],
              [7.239944521000041, -90],
              [6.740638003000072, -90],
              [6.241331484000057, -90],
              [5.742024965000041, -90],
              [5.242718447000073, -90],
              [4.743411928000057, -90],
              [4.244105409000042, -90],
              [3.744798890000084, -90],
              [3.245492372000058, -90],
              [2.746185853000043, -90],
              [2.246879334000084, -90],
              [1.747572816000059, -90],
              [1.248266297000043, -90],
              [0.748959778000085, -90],
              [0.24965325900007, -90],
              [-0.249653258999956, -90],
              [-0.748959777999914, -90],
              [-1.24826629699993, -90],
              [-1.747572815999945, -90],
              [-2.246879333999914, -90],
              [-2.746185852999929, -90],
              [-3.245492371999944, -90],
              [-3.744798889999913, -90],
              [-4.244105408999928, -90],
              [-4.743411927999944, -90],
              [-5.242718446999959, -90],
              [-5.742024964999928, -90],
              [-6.241331483999943, -90],
              [-6.740638002999958, -90],
              [-7.239944520999927, -90],
              [-7.739251039999942, -90],
              [-8.238557558999958, -90],
              [-8.737864077999916, -90],
              [-9.237170595999942, -90],
              [-9.736477114999957, -90],
              [-10.235783633999915, -90],
              [-10.73509015299993, -90],
              [-11.234396670999956, -90],
              [-11.733703189999915, -90],
              [-12.23300970899993, -90],
              [-12.732316226999956, -90],
              [-13.231622745999914, -90],
              [-13.73092926499993, -90],
              [-14.230235783999944, -90],
              [-14.729542301999913, -90],
              [-15.228848820999929, -90],
              [-15.728155339999944, -90],
              [-16.22746185899996, -90],
              [-16.726768376999928, -90],
              [-17.226074895999943, -90],
              [-17.72538141499996, -90],
              [-18.224687932999927, -90],
              [-18.723994451999943, -90],
              [-19.223300970999958, -90],
              [-19.722607489999916, -90],
              [-20.221914007999942, -90],
              [-20.721220526999957, -90],
              [-21.220527045999916, -90],
              [-21.71983356399994, -90],
              [-22.219140082999957, -90],
              [-22.718446601999915, -90],
              [-23.21775312099993, -90],
              [-23.717059638999956, -90],
              [-24.216366157999914, -90],
              [-24.71567267699993, -90],
              [-25.214979195999945, -90],
              [-25.714285713999914, -90],
              [-26.21359223299993, -90],
              [-26.712898751999944, -90],
              [-27.212205269999913, -90],
              [-27.71151178899993, -90],
              [-28.210818307999943, -90],
              [-28.71012482699996, -90],
              [-29.209431344999928, -90],
              [-29.708737863999943, -90],
              [-30.208044382999958, -90],
              [-30.707350901999916, -90],
              [-31.206657419999942, -90],
              [-31.705963938999957, -90],
              [-32.205270457999916, -90],
              [-32.70457697599994, -90],
              [-33.20388349499996, -90],
              [-33.703190013999915, -90],
              [-34.20249653299993, -90],
              [-34.701803050999956, -90],
              [-35.201109569999915, -90],
              [-35.70041608899993, -90],
              [-36.199722606999956, -90],
              [-36.699029125999914, -90],
              [-37.19833564499993, -90],
              [-37.697642163999944, -90],
              [-38.19694868199991, -90],
              [-38.69625520099993, -90],
              [-39.195561719999944, -90],
              [-39.6948682389999, -90],
              [-40.19417475699993, -90],
              [-40.69348127599994, -90],
              [-41.1927877949999, -90],
              [-41.69209431299993, -90],
              [-42.19140083199994, -90],
              [-42.6907073509999, -90],
              [-43.190013869999916, -90],
              [-43.68932038799994, -90],
              [-44.18862690699996, -90],
              [-44.687933425999915, -90],
              [-45.18723994499993, -90],
              [-45.68654646299996, -90],
              [-46.185852981999915, -90],
              [-46.68515950099993, -90],
              [-47.184466018999956, -90],
              [-47.683772537999914, -90],
              [-48.18307905699993, -90],
              [-48.682385575999945, -90],
              [-49.181692093999914, -90],
              [-49.68099861299993, -90],
              [-50.180305131999944, -90],
              [-50.67961164999991, -90],
              [-51.17891816899993, -90],
              [-51.67822468799994, -90],
              [-52.11771846599993, -90],
              [-52.1775312069999, -90],
              [-52.67683772499993, -90],
              [-53.17614424399994, -90],
              [-53.6754507629999, -90],
              [-54.174757281999916, -90],
              [-54.67406379999994, -90],
              [-55.1733703189999, -90],
              [-55.672676837999916, -90],
              [-56.17198335599994, -90],
              [-56.6712898749999, -90],
              [-57.170596393999915, -90],
              [-57.66990291299993, -90],
              [-58.1692094309999, -90],
              [-58.668515949999914, -90],
              [-59.16782246899993, -90],
              [-59.667128987999945, -90],
              [-60.166435505999914, -90],
              [-60.66574202499993, -90],
              [-61.165048543999944, -90],
              [-61.66435506199991, -90],
              [-62.16366158099993, -90],
              [-62.662968099999944, -90],
              [-63.1622746189999, -90],
              [-63.66158113699993, -90],
              [-64.16088765599994, -90],
              [-64.6601941749999, -90],
              [-65.15950069299993, -90],
              [-65.65880721199994, -90],
              [-66.1581137309999, -90],
              [-66.65742024999992, -90],
              [-67.15672676799994, -90],
              [-67.6560332869999, -90],
              [-68.15533980599992, -90],
              [-68.65464632499993, -90],
              [-69.1539528429999, -90],
              [-69.65325936199991, -90],
              [-70.15256588099993, -90],
              [-70.6518723989999, -90],
              [-71.15117891799991, -90],
              [-71.65048543699993, -90],
              [-72.14979195599994, -90],
              [-72.64909847399991, -90],
              [-73.14840499299993, -90],
              [-73.64771151199994, -90],
              [-74.1470180309999, -90],
              [-74.64632454899993, -90],
              [-75.14563106799994, -90],
              [-75.6449375869999, -90],
              [-76.14424410499993, -90],
              [-76.64355062399994, -90],
              [-77.1428571429999, -90],
              [-77.64216366199992, -90],
              [-78.14147017999994, -90],
              [-78.6407766989999, -90],
              [-79.14008321799992, -90],
              [-79.63938973599994, -90],
              [-80.1386962549999, -90],
              [-80.63800277399992, -90],
              [-81.13730929299993, -90],
              [-81.6366158109999, -90],
              [-82.13592232999991, -90],
              [-82.63522884899993, -90],
              [-83.13453536799994, -90],
              [-83.63384188599991, -90],
              [-84.13314840499993, -90],
              [-84.63245492399994, -90],
              [-85.13176144199991, -90],
              [-85.63106796099993, -90],
              [-86.13037447999994, -90],
              [-86.6296809989999, -90],
              [-87.12898751699993, -90],
              [-87.62829403599994, -90],
              [-88.1276005549999, -90],
              [-88.62690707399992, -90],
              [-89.12621359199994, -90],
              [-89.6255201109999, -90],
              [-90.12482662999992, -90],
              [-90.62413314799994, -90],
              [-91.1234396669999, -90],
              [-91.62274618599992, -90],
              [-92.12205270499993, -90],
              [-92.6213592229999, -90],
              [-93.12066574199991, -90],
              [-93.61997226099993, -90],
              [-94.1192787789999, -90],
              [-94.61858529799991, -90],
              [-95.11789181699993, -90],
              [-95.61719833599994, -90],
              [-96.11650485399991, -90],
              [-96.61581137299993, -90],
              [-97.11511789199994, -90],
              [-97.6144244109999, -90],
              [-98.11373092899993, -90],
              [-98.61303744799994, -90],
              [-99.1123439669999, -90],
              [-99.61165048499993, -90],
              [-100.11095700399994, -90],
              [-100.6102635229999, -90],
              [-101.10957004199992, -90],
              [-101.60887655999994, -90],
              [-102.1081830789999, -90],
              [-102.60748959799992, -90],
              [-103.10679611699993, -90],
              [-103.6061026349999, -90],
              [-104.10540915399991, -90],
              [-104.60471567299993, -90],
              [-105.1040221909999, -90],
              [-105.60332870999991, -90],
              [-106.10263522899993, -90],
              [-106.60194174799994, -90],
              [-107.10124826599991, -90],
              [-107.60055478499993, -90],
              [-108.09986130399994, -90],
              [-108.59916782199991, -90],
              [-109.09847434099993, -90],
              [-109.59778085999994, -90],
              [-110.0970873789999, -90],
              [-110.59639389699993, -90],
              [-111.09570041599994, -90],
              [-111.5950069349999, -90],
              [-112.09431345399992, -90],
              [-112.59361997199994, -90],
              [-113.0929264909999, -90],
              [-113.59223300999992, -90],
              [-114.09153952799994, -90],
              [-114.5908460469999, -90],
              [-115.09015256599992, -90],
              [-115.58945908499993, -90],
              [-116.0887656029999, -90],
              [-116.58807212199991, -90],
              [-117.08737864099993, -90],
              [-117.58668515999994, -90],
              [-118.08599167799991, -90],
              [-118.58529819699993, -90],
              [-119.08460471599994, -90],
              [-119.58391123399991, -90],
              [-120.08321775299993, -90],
              [-120.58252427199994, -90],
              [-121.0818307909999, -90],
              [-121.58113730899993, -90],
              [-122.08044382799994, -90],
              [-122.5797503469999, -90],
              [-123.07905686499993, -90],
              [-123.57836338399994, -90],
              [-124.0776699029999, -90],
              [-124.57697642199992, -90],
              [-125.07628293999994, -90],
              [-125.5755894589999, -90],
              [-126.07489597799992, -90],
              [-126.57420249699993, -90],
              [-127.0735090149999, -90],
              [-127.57281553399991, -90],
              [-128.07212205299993, -90],
              [-128.5714285709999, -90],
              [-129.0707350899999, -90],
              [-129.57004160899993, -90],
              [-130.06934812799994, -90],
              [-130.5686546459999, -90],
              [-131.06796116499993, -90],
              [-131.56726768399994, -90],
              [-132.0665742019999, -90],
              [-132.56588072099993, -90],
              [-133.06518723999994, -90],
              [-133.5644937589999, -90],
              [-134.06380027699993, -90],
              [-134.56310679599994, -90],
              [-135.0624133149999, -90],
              [-135.56171983399992, -90],
              [-136.06102635199994, -90],
              [-136.5603328709999, -90],
              [-137.05963938999992, -90],
              [-137.55894590799994, -90],
              [-138.0582524269999, -90],
              [-138.55755894599992, -90],
              [-139.05686546499993, -90],
              [-139.5561719829999, -90],
              [-140.05547850199991, -90],
              [-140.55478502099993, -90],
              [-141.05409153999994, -90],
              [-141.5533980579999, -90],
              [-142.05270457699993, -90],
              [-142.55201109599994, -90],
              [-143.0513176139999, -90],
              [-143.55062413299993, -90],
              [-144.04993065199992, -90],
              [-144.54923717099993, -90],
              [-145.04854368899993, -90],
              [-145.54785020799991, -90],
              [-146.04715672699993, -90],
              [-146.54646324499993, -90],
              [-147.0457697639999, -90],
              [-147.54507628299993, -90],
              [-148.04438280199992, -90],
              [-148.5436893199999, -90],
              [-149.04299583899993, -90],
              [-149.54230235799992, -90],
              [-150.0416088769999, -90],
              [-150.54091539499993, -90],
              [-151.04022191399991, -90],
              [-151.53952843299993, -90],
              [-152.03883495099993, -90],
              [-152.5381414699999, -90],
              [-153.03744798899993, -90],
              [-153.53675450799992, -90],
              [-154.0360610259999, -90],
              [-154.53536754499993, -90],
              [-155.03467406399992, -90],
              [-155.5339805829999, -90],
              [-156.03328710099993, -90],
              [-156.53259361999991, -90],
              [-157.0319001389999, -90],
              [-157.53120665699993, -90],
              [-158.0305131759999, -90],
              [-158.5298196949999, -90],
              [-159.02912621399992, -90],
              [-159.5284327319999, -90],
              [-160.02773925099993, -90],
              [-160.52704576999992, -90],
              [-161.0263522879999, -90],
              [-161.52565880699993, -90],
              [-162.02496532599991, -90],
              [-162.5242718449999, -90],
              [-163.02357836299993, -90],
              [-163.52288488199991, -90],
              [-164.0221914009999, -90],
              [-164.52149791999992, -90],
              [-165.0208044379999, -90],
              [-165.5201109569999, -90],
              [-166.01941747599992, -90],
              [-166.5187239939999, -90],
              [-167.0180305129999, -90],
              [-167.51733703199992, -90],
              [-168.0166435509999, -90],
              [-168.51595006899993, -90],
              [-169.01525658799991, -90],
              [-169.5145631069999, -90],
              [-170.01386962599992, -90],
              [-170.5131761439999, -90],
              [-171.0124826629999, -90],
              [-171.51178918199992, -90],
              [-172.0110956999999, -90],
              [-172.5104022189999, -90],
              [-173.00970873799992, -90],
              [-173.5090152569999, -90],
              [-174.0083217749999, -90],
              [-174.50762829399991, -90],
              [-175.0069348129999, -90],
              [-175.50624133099993, -90],
              [-176.0055478499999, -90],
              [-176.5048543689999, -90],
              [-177.00416088799992, -90],
              [-177.5034674059999, -90],
              [-178.0027739249999, -90],
              [-178.50208044399992, -90],
              [-179.0013869629999, -90],
              [-179.5006934809999, -90],
              [-180, -90],
              [-180, -89.50138504199992],
              [-180, -89.00277008299992],
              [-180, -88.5041551249999],
              [-180, -88.00554016599995],
              [-180, -87.50692520799993],
              [-180, -87.00831024899992],
              [-180, -86.5096952909999],
              [-180, -86.01108033199995],
              [-180, -85.51246537399993],
              [-180, -85.01385041599991],
              [-180, -84.5152354569999],
              [-180, -84.35279600099994],
              [-179.9691055979999, -84.35540129999993],
              [-179.55121822824992, -84.34347909949993],
              [-179.1333308584999, -84.33155689899993],
              [-178.7154434887499, -84.31963469849994],
              [-178.29755611899992, -84.30771249799994],
              [-178.18195553299992, -84.32146575299993],
              [-178.17157955599993, -84.32382577899995],
              [-178.1810196609999, -84.3303361959999],
              [-178.1913956369999, -84.33416106599992],
              [-178.20238196499992, -84.33554452899995],
              [-178.2138565749999, -84.33513762799993],
              [-178.03246008999992, -84.35654062299994],
              [-178.0030411449999, -84.36663176899992],
              [-177.99799557199992, -84.38616301899992],
              [-177.70470130099991, -84.41838958099993],
              [-177.53954016799992, -84.4001604149999],
              [-177.32502193899992, -84.40553150799991],
              [-177.1068009109999, -84.38355885199991],
              [-176.75930742133323, -84.38768211599991],
              [-176.4118139316666, -84.39180537999992],
              [-176.0643204419999, -84.39592864399992],
              [-176.11603756399992, -84.40781015399995],
              [-176.45771236899992, -84.41985442499993],
              [-176.51060950399992, -84.43547942499993],
              [-176.2546687489999, -84.46143971149993],
              [-175.99872799399992, -84.48739999799994],
              [-176.02021236899992, -84.49212004999993],
              [-176.04222571499992, -84.49342213299991],
              [-176.01642818899992, -84.49911874799994],
              [-175.96300208199992, -84.51702239399992],
              [-175.91218014199993, -84.54257577899995],
              [-175.88133704299992, -84.54745859199994],
              [-175.56511389849993, -84.52247486799993],
              [-175.24889075399992, -84.49749114399992],
              [-175.18989010299993, -84.48512135199991],
              [-175.14289303299992, -84.45232512799993],
              [-175.16327877499992, -84.44500090899993],
              [-175.18317623599992, -84.44150155999995],
              [-175.22480221299992, -84.44019947699991],
              [-175.20722408799992, -84.42001718499995],
              [-175.17804928299992, -84.41480885199991],
              [-174.6835250084285, -84.43148016899991],
              [-174.18900073385706, -84.4481514859999],
              [-173.69447645928562, -84.4648228029999],
              [-173.19995218471422, -84.48149411999991],
              [-172.7054279101428, -84.49816543699991],
              [-172.21090363557136, -84.5148367539999],
              [-171.71637936099992, -84.5315080709999],
              [-171.2218550864285, -84.54817938799991],
              [-170.72733081185706, -84.5648507049999],
              [-170.23280653728563, -84.5815220219999],
              [-169.73828226271422, -84.5981933389999],
              [-169.2437579881428, -84.61486465599991],
              [-168.74923371357136, -84.6315359729999],
              [-168.25470943899992, -84.6482072899999],
              [-168.2099503249999, -84.65691497199992],
              [-168.1459854809999, -84.69003671699994],
              [-168.1236466139999, -84.6950822899999],
              [-168.16486568899992, -84.72185637799993],
              [-168.05675208199992, -84.77076588299991],
              [-168.01862545499992, -84.7810197899999],
              [-167.7634374664999, -84.79648202949991],
              [-167.50824947799993, -84.81194426899992],
              [-167.48009192599991, -84.83635833099993],
              [-167.55500240799992, -84.84840260199991],
              [-167.4417618479999, -84.8674455709999],
              [-167.17648271399992, -84.84384531049992],
              [-166.91120357999992, -84.82024504999993],
              [-166.4339086581666, -84.82954952049992],
              [-165.95661373633325, -84.83885399099994],
              [-165.47931881449992, -84.84815846149993],
              [-165.00202389266659, -84.85746293199993],
              [-164.52472897083325, -84.86676740249995],
              [-164.04743404899992, -84.87607187299994],
              [-163.93464107999992, -84.89519622199992],
              [-163.4643652009999, -84.90467701599994],
              [-162.99408932199992, -84.91415780999995],
              [-162.95750891799992, -84.90943775799991],
              [-162.84894771999993, -84.8830705709999],
              [-162.3517604234999, -84.90723032037491],
              [-161.85457312699992, -84.93139006974991],
              [-161.35738583049994, -84.95554981912491],
              [-160.86019853399992, -84.97970956849991],
              [-160.3630112374999, -85.00386931787492],
              [-159.86582394099992, -85.02802906724992],
              [-159.36863664449993, -85.05218881662492],
              [-158.8714493479999, -85.07634856599992],
              [-158.67316646999993, -85.13250090899993],
              [-158.46576900899993, -85.15520598799992],
              [-158.48444576699993, -85.13420989399992],
              [-158.50995846299992, -85.11972421699994],
              [-158.5650528639999, -85.09929778399993],
              [-158.4974259109999, -85.09124114399992],
              [-158.42393958199992, -85.09221770599993],
              [-158.35151119699992, -85.10295989399992],
              [-158.1967667309999, -85.15911223799992],
              [-158.16331946499992, -85.16472747199992],
              [-157.73233801979993, -85.17616952919992],
              [-157.3013565745999, -85.18761158639992],
              [-156.87037512939992, -85.19905364359991],
              [-156.4393936841999, -85.21049570079991],
              [-156.0084122389999, -85.22193775799991],
              [-156.05549068899992, -85.20378997199992],
              [-156.4914851549999, -85.19951751099993],
              [-156.92747962099992, -85.19524504999993],
              [-156.45909583199992, -85.19072844849993],
              [-155.99071204299992, -85.18621184699992],
              [-155.94225012899992, -85.17937590899993],
              [-155.9011124339999, -85.15764739399992],
              [-155.94456946499992, -85.14348723799992],
              [-156.09972083199992, -85.1423479149999],
              [-156.0694473949999, -85.13445403399993],
              [-155.78671220599992, -85.13026295349994],
              [-155.50397701699993, -85.12607187299994],
              [-155.98226206499993, -85.08638545799994],
              [-156.4605471129999, -85.04669904299993],
              [-156.9388321609999, -85.00701262799993],
              [-156.95872962099992, -85.00017669099992],
              [-157.0091446609999, -84.96892669099992],
              [-157.04662024599992, -84.95720794099992],
              [-157.34190833199992, -84.92721933399991],
              [-157.63719641799992, -84.89723072699991],
              [-157.5810440749999, -84.88298919099992],
              [-157.1328222324999, -84.88838062974992],
              [-156.6846003899999, -84.89377206849991],
              [-156.23637854749992, -84.89916350724991],
              [-155.78815670499992, -84.9045549459999],
              [-155.75666256399992, -84.90032317499993],
              [-155.74962317599991, -84.90032317499993],
              [-155.79047604099992, -84.89104583099993],
              [-156.1097305979999, -84.88534921699994],
              [-155.70343990799992, -84.8791643209999],
              [-155.74030514199993, -84.86598072699991],
              [-155.86729895699992, -84.86060963299991],
              [-155.5892227859999, -84.84050872199992],
              [-155.64264889199993, -84.82781340899993],
              [-156.09947669149992, -84.8213843726666],
              [-156.55630449099993, -84.81495533633326],
              [-157.01313229049993, -84.80852629999993],
              [-157.46996008999992, -84.8020972636666],
              [-157.92678788949993, -84.79566822733325],
              [-158.38361568899992, -84.78923919099992],
              [-158.27729244699992, -84.78093840899993],
              [-158.24958248599992, -84.76718515399995],
              [-158.71735592349992, -84.74907805766661],
              [-159.18512936099992, -84.73097096133328],
              [-159.65290279849992, -84.71286386499995],
              [-160.12067623599992, -84.69475676866661],
              [-160.58844967349992, -84.67664967233328],
              [-161.05622311099992, -84.65854257599995],
              [-161.52399654849992, -84.6404354796666],
              [-161.99176998599992, -84.62232838333328],
              [-162.45954342349992, -84.60422128699994],
              [-162.92731686099992, -84.5861141906666],
              [-163.39509029849992, -84.56800709433328],
              [-163.86286373599992, -84.54989999799994],
              [-163.8931778639999, -84.54534270599993],
              [-163.91218014199993, -84.53045012799993],
              [-163.90949459499993, -84.52776458099993],
              [-163.90436764199993, -84.52068450299993],
              [-163.9017227859999, -84.51799895599993],
              [-163.91083736899992, -84.51327890399995],
              [-164.09662838399993, -84.48056405999995],
              [-163.68106035049993, -84.48617929449995],
              [-163.2654923169999, -84.49179452899995],
              [-163.31720943899992, -84.47698333099993],
              [-163.66022701699993, -84.42913176899992],
              [-164.1503800119999, -84.42603932099992],
              [-164.64053300699993, -84.42294687299993],
              [-165.13068600199992, -84.41985442499993],
              [-165.17658443899992, -84.43271249799994],
              [-165.19420325399992, -84.43466562299994],
              [-165.60395260299993, -84.41320837466661],
              [-166.0137019519999, -84.39175112633326],
              [-166.42345130099991, -84.37029387799993],
              [-165.96403967999993, -84.38445403449992],
              [-165.5046280589999, -84.39861419099992],
              [-165.51459713399993, -84.3811174459999],
              [-165.40973873599992, -84.36451588299991],
              [-164.92800859279993, -84.36420663819992],
              [-164.44627844959993, -84.36389739339992],
              [-163.9645483063999, -84.36358814859992],
              [-163.4828181631999, -84.36327890379992],
              [-163.0010880199999, -84.36296965899993],
              [-163.01740475199992, -84.35979583099993],
              [-163.04352779899992, -84.34612395599993],
              [-163.0579727859999, -84.34050872199992],
              [-163.42421084999992, -84.32436831399993],
              [-163.7904489139999, -84.30822790599994],
              [-164.15668697799993, -84.29208749799994],
              [-164.17121334499993, -84.28899504999993],
              [-164.18285071499992, -84.28232187299994],
              [-164.16380774599992, -84.27206796699994],
              [-164.1159561839999, -84.2712541649999],
              [-164.09833736899992, -84.26262786299992],
              [-164.1104630199999, -84.26425546699994],
              [-164.2233780589999, -84.25017669099992],
              [-164.27228756399992, -84.23845794099992],
              [-164.2308243479999, -84.23455169099992],
              [-164.19029700399992, -84.22551848799992],
              [-164.62336178299992, -84.1853166649999],
              [-164.7402237619999, -84.15618254999993],
              [-165.15440833199992, -84.13795338299991],
              [-165.12800045499992, -84.11793385199991],
              [-165.09190833199992, -84.11256275799991],
              [-165.0185440749999, -84.1189104149999],
              [-165.06029212099992, -84.10165780999995],
              [-165.07892818899992, -84.08896249799994],
              [-165.09345455599993, -84.07219817499993],
              [-165.00971432199992, -84.05673593499995],
              [-164.57408606666658, -84.05445728933329],
              [-164.13845781133327, -84.05217864366661],
              [-163.70282955599993, -84.04989999799994],
              [-163.74311275899993, -84.03191497199992],
              [-164.03901119699992, -83.99065520599993],
              [-164.02997799399992, -83.98919036299992],
              [-163.99775143099993, -83.97714609199994],
              [-163.97431393099993, -83.97421640399995],
              [-163.91828365799992, -83.97307708099993],
              [-163.90050208199992, -83.9704729149999],
              [-163.8901261059999, -83.96355559699992],
              [-163.9036759109999, -83.9572893209999],
              [-163.9485977859999, -83.95224374799994],
              [-163.99388587099992, -83.93906015399995],
              [-164.45260576049992, -83.88103606549993],
              [-164.91132564999992, -83.82301197699991],
              [-164.96178137899992, -83.80136484199994],
              [-164.9796036449999, -83.79648202899995],
              [-165.42072506399992, -83.76677825299993],
              [-165.4842423169999, -83.74960702899995],
              [-165.5143936839999, -83.74570077899995],
              [-165.93537350199992, -83.78573984199994],
              [-165.95441646999993, -83.78972747199992],
              [-165.99042721299992, -83.80282968499995],
              [-166.0682266919999, -83.81796640399995],
              [-166.4709671704999, -83.80600351349995],
              [-166.87370764899993, -83.79404062299994],
              [-167.27644812749992, -83.78207773249994],
              [-167.6791886059999, -83.77011484199994],
              [-167.6253555979999, -83.79029713299991],
              [-167.25352942599991, -83.81113046699994],
              [-167.1951798169999, -83.82545338299991],
              [-167.2995499339999, -83.83782317499993],
              [-167.69107011649993, -83.80868906049992],
              [-168.08259029899992, -83.7795549459999],
              [-167.9885147779999, -83.76677825299993],
              [-168.05357825399992, -83.7536760399999],
              [-168.25951087099992, -83.74358489399992],
              [-167.96835283099992, -83.74391041449994],
              [-167.67719479099992, -83.74423593499995],
              [-167.73334713399993, -83.72258879999993],
              [-168.21637936099992, -83.7131486959999],
              [-168.33747311099992, -83.69280364399992],
              [-168.45527096299992, -83.65447356599992],
              [-168.6097305979999, -83.62249114399992],
              [-168.63434811099992, -83.60458749799994],
              [-168.55866451699993, -83.5783830709999],
              [-168.5341690749999, -83.57301197699991],
              [-168.54771887899992, -83.54257577899995],
              [-168.5826309889999, -83.53036874799994],
              [-169.01655025899993, -83.51555754999993],
              [-169.0499161449999, -83.5080705709999],
              [-169.0756729809999, -83.48919036299992],
              [-169.0057266919999, -83.47454192499993],
              [-168.7798966139999, -83.47568124799994],
              [-169.06267249249993, -83.45907968549994],
              [-169.34544837099992, -83.44247812299994],
              [-169.36103268099993, -83.43914153399993],
              [-169.41808020699992, -83.41334400799991],
              [-169.43305416599992, -83.40943775799991],
              [-169.89463456959993, -83.37299570079992],
              [-170.3562149731999, -83.33655364359991],
              [-170.81779537679992, -83.30011158639992],
              [-171.2793757803999, -83.26366952919992],
              [-171.7409561839999, -83.22722747199992],
              [-171.6944473949999, -83.21689218499995],
              [-171.3255509104999, -83.23939381299994],
              [-170.95665442599991, -83.26189544099992],
              [-171.39535769057133, -83.21236977128564],
              [-171.83406095514277, -83.16284410157135],
              [-172.2727642197142, -83.11331843185707],
              [-172.71146748428563, -83.06379276214278],
              [-173.15017074885705, -83.0142670924285],
              [-173.5888740134285, -82.96474142271421],
              [-174.0275772779999, -82.91521575299993],
              [-174.33747311099992, -82.81210702899995],
              [-174.36961829299992, -82.77890390399995],
              [-174.3398331369999, -82.75888437299994],
              [-174.26899166599992, -82.75579192499993],
              [-173.90633433099993, -82.80934010199992],
              [-173.5436769959999, -82.86288827899993],
              [-173.1810196609999, -82.91643645599993],
              [-172.74176998599992, -82.91838958099993],
              [-172.5124405589999, -82.86988697699991],
              [-172.14439856666658, -82.89785464199991],
              [-171.77635657433325, -82.92582230699992],
              [-171.40831458199992, -82.95378997199992],
              [-170.95539303299992, -83.05527109199994],
              [-170.92979895699992, -83.06414153399993],
              [-170.8350723949999, -83.12818775799991],
              [-170.79340572799993, -83.16887786299992],
              [-170.76915442599991, -83.18287525799991],
              [-170.7194718089999, -83.19695403399993],
              [-170.34620791999993, -83.23479583099993],
              [-169.9729440309999, -83.27263762799993],
              [-169.59968014199993, -83.31047942499993],
              [-169.53534908799992, -83.30193450299993],
              [-169.73456783799992, -83.2443986959999],
              [-169.3223770827499, -83.24718596799991],
              [-168.9101863274999, -83.24997323999992],
              [-168.49799557224992, -83.25276051199992],
              [-168.0858048169999, -83.25554778399993],
              [-168.06366939999992, -83.24684010199991],
              [-168.02814693899992, -83.2151018209999],
              [-168.00938880099991, -83.20810312299994],
              [-167.72622636599993, -83.21729908649993],
              [-167.44306393099993, -83.22649504999993],
              [-167.4283341139999, -83.22421640399995],
              [-167.35834713399993, -83.20086028399993],
              [-167.33320064999992, -83.19801197699991],
              [-166.88381913959992, -83.19882577919991],
              [-166.43443762919992, -83.19963958139991],
              [-165.98505611879992, -83.20045338359992],
              [-165.53567460839992, -83.20126718579992],
              [-165.0862930979999, -83.20208098799992],
              [-164.8541153639999, -83.2502580709999],
              [-164.8734024729999, -83.26531340899993],
              [-164.8936661449999, -83.26962655999995],
              [-164.9151505199999, -83.27076588299991],
              [-164.9380997389999, -83.27613697699991],
              [-164.94318600199992, -83.27857838299991],
              [-164.94770260299993, -83.28134530999995],
              [-164.9511612619999, -83.28484465899993],
              [-164.9533585279999, -83.28948333099993],
              [-164.95323645699992, -83.29420338299991],
              [-164.94884192599991, -83.3005510399999],
              [-164.94794674399992, -83.30478280999995],
              [-164.95555579299992, -83.31796640399995],
              [-164.98322506399992, -83.34026458099993],
              [-164.9858292309999, -83.35588958099993],
              [-164.95282955599993, -83.35507577899995],
              [-164.8222550119999, -83.37712981599992],
              [-164.77961178299992, -83.3908830709999],
              [-164.7025040359999, -83.43857187299994],
              [-164.6761368479999, -83.44736093499995],
              [-164.66808020699992, -83.45208098799992],
              [-164.67467200399992, -83.45696379999993],
              [-164.69037838399993, -83.46379973799992],
              [-164.69652258999992, -83.46819426899992],
              [-164.69102942599991, -83.48503997199992],
              [-164.6573380199999, -83.49814218499995],
              [-164.61725826699993, -83.50693124799994],
              [-164.17731686099992, -83.5271135399999],
              [-164.11396236899992, -83.50644296699994],
              [-164.15973873599992, -83.48040129999993],
              [-164.17316646999993, -83.46998463299991],
              [-164.1951798169999, -83.44654713299991],
              [-164.20323645699992, -83.43173593499995],
              [-164.2034805979999, -83.41692473799992],
              [-164.18976803299992, -83.40357838299991],
              [-164.1662491529999, -83.39609140399995],
              [-163.88180497949992, -83.38184986749994],
              [-163.59736080599993, -83.36760833099993],
              [-163.4650772779999, -83.33709075299993],
              [-163.28412838399993, -83.33855559699992],
              [-163.13398189999992, -83.31552499799994],
              [-162.86994381399992, -83.32146575299993],
              [-162.8279923169999, -83.33326588299991],
              [-162.8037003249999, -83.36614348799992],
              [-162.80964107999992, -83.36736419099992],
              [-162.82123775899993, -83.37184010199991],
              [-162.82701575399992, -83.3728166649999],
              [-162.80357825399992, -83.39185963299991],
              [-162.76878821499992, -83.39861419099992],
              [-162.3701065749999, -83.42400481599992],
              [-162.26008053299992, -83.44988372199992],
              [-162.30829830599993, -83.46257903399993],
              [-162.4572647779999, -83.47380950299993],
              [-162.40644283799992, -83.49537525799991],
              [-162.1690567699999, -83.52467213299991],
              [-161.74924882719992, -83.51557382579992],
              [-161.32944088439993, -83.50647551859991],
              [-160.9096329415999, -83.49737721139992],
              [-160.48982499879992, -83.48827890419992],
              [-160.07001705599993, -83.47918059699992],
              [-159.7771296864999, -83.51238372199992],
              [-159.4842423169999, -83.54558684699992],
              [-159.19343014199993, -83.54436614399992],
              [-159.10167395699992, -83.53337981599992],
              [-159.0912979809999, -83.52695077899995],
              [-159.06956946499992, -83.4997697899999],
              [-159.04466712099992, -83.47600676899992],
              [-158.9998673169999, -83.45712655999995],
              [-158.51834062433323, -83.43482838299995],
              [-158.0368139316666, -83.41253020599994],
              [-157.5552872389999, -83.39023202899995],
              [-157.5296524729999, -83.38420989399992],
              [-157.4831436839999, -83.3532854149999],
              [-157.45270748599992, -83.34172942499993],
              [-157.18519039599994, -83.28594329199993],
              [-156.91767330599993, -83.23015715899993],
              [-157.02448482999992, -83.20582447699991],
              [-157.50415334133325, -83.19293927733325],
              [-157.98382185266658, -83.18005407766658],
              [-158.4634903639999, -83.16716887799993],
              [-158.52192135299993, -83.15837981599992],
              [-158.55793209499993, -83.13274504999993],
              [-158.4971817699999, -83.11793385199991],
              [-158.01302378383326, -83.10595739799992],
              [-157.52886579766658, -83.09398094399991],
              [-157.0447078114999, -83.08200448999992],
              [-156.56054982533325, -83.07002803599993],
              [-156.0763918391666, -83.05805158199992],
              [-155.59223385299993, -83.04607512799993],
              [-155.43639075399992, -83.00774504999993],
              [-155.49677486899992, -82.95549895599993],
              [-155.13451087099992, -82.87753671699994],
              [-155.1099747389999, -82.86296965899993],
              [-155.08214270699992, -82.81715260199991],
              [-155.05878658799992, -82.80193450299993],
              [-154.63947506449992, -82.75963035799992],
              [-154.22016354099992, -82.71732621299992],
              [-153.80085201749992, -82.67502206799992],
              [-153.38154049399992, -82.63271792299992],
              [-152.96222897049992, -82.59041377799991],
              [-152.54291744699992, -82.54810963299991],
              [-152.5554093089999, -82.52654387799993],
              [-152.57970130099991, -82.51287200299993],
              [-152.63166256399992, -82.4963518209999],
              [-152.65473385299993, -82.48447030999995],
              [-152.69819088399993, -82.45525481599992],
              [-152.72118079299992, -82.44304778399993],
              [-152.81366939999992, -82.41318124799994],
              [-152.89679928299992, -82.37411874799994],
              [-153.33614390099993, -82.2913008226666],
              [-153.7754885189999, -82.20848289733327],
              [-154.2148331369999, -82.12566497199992],
              [-154.25560462099992, -82.10149504999993],
              [-154.11143958199992, -82.07154713299991],
              [-154.45773271349992, -82.01877206799992],
              [-154.80402584499993, -81.96599700299993],
              [-154.83893795499992, -81.94475676899992],
              [-154.77497311099992, -81.92294687299994],
              [-154.53205318899992, -81.87908294099992],
              [-154.4238175119999, -81.83847421699994],
              [-154.3519180979999, -81.82350025799991],
              [-154.0908503894999, -81.80787525799991],
              [-153.82978268099993, -81.79225025799991],
              [-153.7580460279999, -81.77662525799991],
              [-153.6923721999999, -81.74700286299992],
              [-153.71869869699992, -81.73626067499993],
              [-153.79035396999993, -81.69101327899995],
              [-153.8163956369999, -81.68124765399995],
              [-153.8448380199999, -81.67791106599992],
              [-153.98322506399992, -81.67693450299993],
              [-154.00580807199992, -81.66871510199991],
              [-154.03461666599992, -81.65357838299991],
              [-154.0648087229999, -81.64324309699992],
              [-154.29845130099991, -81.60881926899992],
              [-154.31342525899993, -81.6013322899999],
              [-154.3421524729999, -81.58245208099993],
              [-154.35785885299993, -81.57488372199992],
              [-154.4100235669999, -81.56210702899995],
              [-154.81920325399992, -81.53362395599993],
              [-154.99657141799992, -81.48919036299992],
              [-155.40859941279993, -81.46161874839991],
              [-155.82062740759991, -81.43404713379991],
              [-156.23265540239993, -81.40647551919992],
              [-156.6446833971999, -81.37890390459991],
              [-157.05671139199993, -81.3513322899999],
              [-157.1458634109999, -81.31902434699992],
              [-157.1432999339999, -81.30868905999995],
              [-157.13825436099992, -81.30006275799991],
              [-157.1229141919999, -81.28435637799993],
              [-157.09581458199992, -81.26637135199991],
              [-157.06391354099992, -81.25579192499993],
              [-156.75702877499992, -81.20224374799992],
              [-156.45014400899993, -81.1486955709999],
              [-155.9600249226666, -81.1360002584999],
              [-155.46990583633325, -81.1233049459999],
              [-154.97978674999993, -81.1106096334999],
              [-154.48966766366658, -81.0979143209999],
              [-153.99954857733326, -81.0852190084999],
              [-153.50942949099993, -81.0725236959999],
              [-153.01931040466658, -81.0598283834999],
              [-152.52919131833326, -81.0471330709999],
              [-152.0390722319999, -81.0344377584999],
              [-151.5489531456666, -81.0217424459999],
              [-151.05883405933326, -81.0090471334999],
              [-150.5687149729999, -80.9963518209999],
              [-150.0785958866666, -80.9836565084999],
              [-149.58847680033327, -80.9709611959999],
              [-149.09835771399992, -80.9582658834999],
              [-148.6082386276666, -80.9455705709999],
              [-148.11811954133324, -80.9328752584999],
              [-147.62800045499992, -80.9201799459999],
              [-147.58478756399992, -80.90740325299993],
              [-147.5483292309999, -80.88689544099992],
              [-147.5827530589999, -80.86060963299991],
              [-147.62555904899992, -80.84726327899995],
              [-147.93879147049992, -80.83489348749993],
              [-148.25202389199993, -80.8225236959999],
              [-148.29877682199992, -80.81308359199994],
              [-148.0909317699999, -80.80706145599993],
              [-148.18016516799992, -80.79192473799992],
              [-148.4515274729999, -80.78215911299992],
              [-148.43000240799992, -80.77605559699992],
              [-148.40876217399992, -80.77288176899992],
              [-148.36481686099992, -80.77092864399992],
              [-148.4066055979999, -80.74602629999993],
              [-148.75829016833325, -80.73707447699992],
              [-149.10997473866658, -80.72812265399993],
              [-149.4616593089999, -80.71917083099993],
              [-149.17343095599992, -80.70989348749993],
              [-148.88520260299993, -80.70061614399992],
              [-149.16535397049992, -80.69190846149993],
              [-149.44550533799992, -80.68320077899995],
              [-149.4224747389999, -80.68222421699994],
              [-149.37897701699993, -80.66765715899993],
              [-149.35492916599992, -80.66326262799993],
              [-149.03559322799993, -80.66122812299994],
              [-149.24836178299992, -80.6428361959999],
              [-149.19025631399992, -80.62656015399995],
              [-148.72396806549992, -80.63144296649995],
              [-148.2576798169999, -80.63632577899995],
              [-148.34333248599992, -80.62493254999993],
              [-148.61605790899992, -80.62306080499994],
              [-148.88878333199992, -80.62118905999995],
              [-148.9904679029999, -80.59449635199991],
              [-149.01874752499992, -80.59148528399993],
              [-149.3496191069999, -80.59075286249993],
              [-149.68049068899992, -80.59002044099992],
              [-149.72704016799992, -80.58245208099993],
              [-149.5026749339999, -80.56878020599993],
              [-149.57465572799993, -80.55754973799992],
              [-149.79454505099991, -80.55380624799994],
              [-149.62267005099991, -80.53704192499993],
              [-149.6651505199999, -80.52703215899993],
              [-149.95053056549992, -80.52752044049993],
              [-150.23591061099992, -80.52800872199992],
              [-150.3221329419999, -80.51482512799993],
              [-150.27167721299992, -80.4958635399999],
              [-150.08490963399993, -80.49627044099992],
              [-150.44867916599992, -80.45614999799994],
              [-150.4350479809999, -80.44638437299994],
              [-150.41987057199992, -80.44011809699992],
              [-150.40363521999993, -80.43718840899993],
              [-150.38683020699992, -80.43710702899995],
              [-150.4222305979999, -80.42962004999993],
              [-150.7169083324999, -80.42953866999991],
              [-151.0115860669999, -80.4294572899999],
              [-150.94501705599993, -80.41122812299994],
              [-150.7232559889999, -80.41277434699992],
              [-150.89081783799992, -80.39804452899995],
              [-150.42953447199992, -80.39588795349994],
              [-149.9682511059999, -80.39373137799993],
              [-150.01642818899992, -80.37908294099992],
              [-150.21214758999992, -80.35507577899995],
              [-150.30134029899992, -80.33066171699994],
              [-150.39545650899993, -80.31633879999993],
              [-150.72577877499992, -80.32040780999995],
              [-150.57188880099991, -80.30584075299993],
              [-150.60912024599992, -80.26970794099992],
              [-150.67467200399992, -80.2536760399999],
              [-150.80321204299992, -80.24553801899992],
              [-150.72626705599993, -80.21648528399993],
              [-150.64472408799992, -80.21160247199992],
              [-150.4772843089999, -80.22193775799991],
              [-150.13373775899993, -80.18572356599992],
              [-150.15587317599991, -80.16253020599993],
              [-150.18016516799992, -80.14413827899995],
              [-150.2076309889999, -80.13054778399993],
              [-150.31159420499992, -80.10865650799991],
              [-150.34727942599991, -80.0959611959999],
              [-150.36969967399992, -80.07463958099993],
              [-149.98579871349992, -80.08879973724993],
              [-149.60189775299992, -80.10295989349993],
              [-149.21799679249992, -80.11712004974993],
              [-148.83409583199992, -80.13128020599993],
              [-148.8287247389999, -80.12900155999995],
              [-148.8245743479999, -80.12420012799993],
              [-148.8182266919999, -80.11288827899995],
              [-148.81159420499992, -80.10670338299991],
              [-148.80292721299992, -80.10409921699994],
              [-148.66303463399993, -80.0935197899999],
              [-148.54621334499993, -80.07154713299991],
              [-148.05048580599993, -80.06137460699992],
              [-147.55475826699993, -80.05120208099993],
              [-147.60952714799993, -80.04029713299991],
              [-148.03229732999992, -80.03224049249991],
              [-148.4550675119999, -80.02418385199991],
              [-148.5117081369999, -80.00798919099992],
              [-148.1953629219999, -80.00550709449993],
              [-147.87901770699992, -80.00302499799994],
              [-147.93496660099993, -79.98544687299994],
              [-148.27327769033326, -79.9811608486666],
              [-148.6115887796666, -79.97687482433327],
              [-148.94989986899992, -79.97258879999993],
              [-148.90558834499993, -79.96306731599992],
              [-148.54993648949994, -79.96717701649993],
              [-148.19428463399993, -79.97128671699994],
              [-148.2493790359999, -79.96282317499993],
              [-148.64696204299992, -79.95403411299992],
              [-148.58027096299992, -79.94963958099993],
              [-148.51488196499992, -79.93613046699994],
              [-148.53681393099993, -79.92880624799994],
              [-148.60899817599991, -79.92327239399992],
              [-148.58234615799992, -79.9162736959999],
              [-148.4998673169999, -79.91285572699991],
              [-148.84776770699992, -79.90056731599992],
              [-148.83124752499992, -79.89462655999995],
              [-148.81403561099992, -79.89226653399993],
              [-148.7787979809999, -79.89185963299991],
              [-148.88060462099992, -79.8733049459999],
              [-148.97154700399992, -79.87021249799994],
              [-148.99974524599992, -79.86077239399992],
              [-148.7040909499999, -79.86394622199992],
              [-148.51862545499992, -79.88681405999995],
              [-148.04377193899992, -79.89023202899995],
              [-148.07880611899992, -79.90585702899995],
              [-148.20750891799992, -79.90683359199994],
              [-148.15693111899992, -79.91757577899995],
              [-147.9940486319999, -79.91725025799991],
              [-148.02875729099992, -79.92913176899992],
              [-147.9769180979999, -79.93767669099992],
              [-147.56609046149993, -79.94178639149993],
              [-147.1552628249999, -79.94589609199994],
              [-147.18179277299993, -79.91741301899992],
              [-147.0671280589999, -79.90862395599993],
              [-147.11607825399992, -79.89999765399995],
              [-147.1685684889999, -79.89666106599992],
              [-147.27090410099993, -79.90162525799991],
              [-147.34137936099992, -79.92148202899995],
              [-147.36803137899992, -79.92498137799993],
              [-147.3924454419999, -79.92538827899995],
              [-147.57013912699992, -79.89999765399995],
              [-147.8974503249999, -79.90113697699991],
              [-147.86375891799992, -79.88990650799991],
              [-147.58519446499992, -79.87460702899995],
              [-148.05903072799993, -79.83505624799994],
              [-148.14118404899992, -79.8108049459999],
              [-148.0146378249999, -79.81438567499993],
              [-147.98273678299992, -79.81161874799994],
              [-147.9197891919999, -79.79892343499995],
              [-147.88882402299993, -79.80046965899993],
              [-147.9456680979999, -79.78655364399992],
              [-147.7731013659999, -79.77947356599992],
              [-148.1825116309999, -79.74838632633326],
              [-148.59192189599992, -79.71729908666659],
              [-149.0013321609999, -79.68621184699992],
              [-149.0724991529999, -79.66611093499995],
              [-149.03974361899992, -79.64910247199992],
              [-149.0923966139999, -79.63030364399992],
              [-149.5438940096666, -79.60659487666659],
              [-149.99539140533324, -79.58288610933327],
              [-150.44688880099991, -79.55917734199994],
              [-150.53441321499992, -79.53411223799992],
              [-151.0241999989999, -79.47022877433325],
              [-151.51398678299992, -79.4063453106666],
              [-152.0037735669999, -79.34246184699992],
              [-151.8665665359999, -79.31340911299992],
              [-151.75788326699993, -79.27792734199994],
              [-151.73603268099993, -79.27450937299994],
              [-151.69526119699992, -79.27337004999993],
              [-151.6548966139999, -79.26767343499995],
              [-151.6979874339999, -79.25164153399993],
              [-151.74815833199992, -79.24675872199992],
              [-152.2142227859999, -79.31015390399995],
              [-152.26488196499992, -79.30917734199994],
              [-152.31615149599992, -79.29876067499993],
              [-152.41417395699992, -79.2639299459999],
              [-152.31196041599992, -79.23642343499995],
              [-151.98957271999993, -79.20403411299992],
              [-152.10700436099992, -79.2014299459999],
              [-151.97508704299992, -79.17034270599993],
              [-151.98204505099991, -79.16594817499993],
              [-151.9951065749999, -79.15536874799994],
              [-152.00206458199992, -79.15097421699994],
              [-151.7200821609999, -79.0837541649999],
              [-151.7855118479999, -79.08098723799992],
              [-152.07477779899992, -79.1071916649999],
              [-152.1061905589999, -79.1057268209999],
              [-152.22211666599992, -79.07480234199994],
              [-152.2568253249999, -79.07708098799992],
              [-152.23200436099992, -79.09856536299992],
              [-152.2342423169999, -79.11093515399995],
              [-152.33751380099991, -79.14267343499995],
              [-152.5644425119999, -79.17506275799991],
              [-152.59162350199992, -79.17245859199994],
              [-152.61412512899992, -79.1560197899999],
              [-152.70466061099992, -79.11386484199994],
              [-152.93500729099992, -79.17009856599992],
              [-153.03852291599992, -79.15154387799993],
              [-153.07933508999992, -79.13941822699991],
              [-153.55195064999992, -79.11325448999992],
              [-154.02456620999993, -79.08709075299993],
              [-154.4971817699999, -79.06092701599994],
              [-154.96979732999992, -79.03476327899995],
              [-155.00800533799992, -79.02068450299993],
              [-155.04063880099991, -78.9997697899999],
              [-155.0527237619999, -78.99407317499993],
              [-155.42161007374992, -78.91147226349993],
              [-155.79049638549992, -78.82887135199994],
              [-156.15938269724992, -78.74627044049994],
              [-156.52826900899993, -78.66366952899995],
              [-156.5467423169999, -78.65081145599993],
              [-156.54999752499992, -78.62363046699994],
              [-156.5295304029999, -78.6052385399999],
              [-156.49925696499992, -78.59433359199994],
              [-156.08759518099993, -78.55730559699992],
              [-156.03937740799992, -78.54208749799994],
              [-156.0549210279999, -78.52654387799993],
              [-156.07367916599992, -78.51685963299991],
              [-156.11603756399992, -78.5075822899999],
              [-156.05284583199992, -78.49407317499993],
              [-155.70645097533324, -78.48571814033325],
              [-155.3600561186666, -78.47736310566658],
              [-155.0136612619999, -78.4690080709999],
              [-154.97826087099992, -78.45696379999993],
              [-155.0502823559999, -78.42587655999995],
              [-154.8908585279999, -78.42392343499995],
              [-154.79649817599991, -78.44866301899992],
              [-154.7303360669999, -78.45468515399995],
              [-154.52289791599992, -78.43401458099993],
              [-154.58214270699992, -78.41692473799992],
              [-154.5097550119999, -78.40618254999993],
              [-154.36139889199993, -78.40536874799994],
              [-154.29084225199992, -78.3889299459999],
              [-154.3326309889999, -78.37411874799994],
              [-154.30353756399992, -78.35222747199992],
              [-154.18110104099992, -78.33521900799991],
              [-154.2097061839999, -78.30966562299994],
              [-154.23530025899993, -78.2810197899999],
              [-154.1365860669999, -78.2483049459999],
              [-153.9179581369999, -78.24944426899992],
              [-153.8150528639999, -78.23316822699991],
              [-154.2097061839999, -78.22177499799994],
              [-154.2210587229999, -78.2190080709999],
              [-154.23652096299992, -78.21135833099993],
              [-154.24445553299992, -78.20322030999995],
              [-154.25116939999992, -78.19402434699992],
              [-154.26313229099992, -78.18417734199994],
              [-154.27778072799993, -78.17717864399992],
              [-154.31956946499992, -78.16920338299991],
              [-154.3327530589999, -78.16285572699991],
              [-154.35724850199992, -78.14609140399995],
              [-154.3693741529999, -78.14006926899992],
              [-154.39618893099993, -78.13591887799993],
              [-154.56794186099992, -78.13437265399995],
              [-154.71772213399993, -78.15398528399993],
              [-154.65050208199992, -78.17522551899992],
              [-154.66722571499992, -78.18450286299992],
              [-154.75214596299992, -78.20891692499993],
              [-154.75951087099992, -78.21412525799991],
              [-154.7670792309999, -78.22975025799991],
              [-154.77411861899992, -78.23447030999995],
              [-155.11998450399992, -78.25701262799993],
              [-155.21406002499992, -78.2463518209999],
              [-155.25157630099991, -78.20501067499993],
              [-155.09198971299992, -78.19353606599992],
              [-154.9776505199999, -78.20671965899993],
              [-154.99604244699992, -78.19182708099993],
              [-155.02643795499992, -78.16033294099992],
              [-155.04267330599993, -78.15398528399993],
              [-155.1816300119999, -78.16253020599993],
              [-155.27363033799992, -78.19231536299992],
              [-155.32274329299992, -78.19988372199992],
              [-155.3466690749999, -78.19589609199994],
              [-155.39610755099991, -78.17685312299994],
              [-155.42149817599991, -78.17083098799992],
              [-155.44819088399993, -78.17253997199992],
              [-155.49425208199992, -78.1892229149999],
              [-155.51915442599991, -78.19410572699991],
              [-155.74689693899992, -78.20387135199991],
              [-155.93321692599991, -78.18873463299991],
              [-156.02717037699992, -78.19915129999993],
              [-156.3480118479999, -78.19988372199992],
              [-156.3732804029999, -78.19451262799993],
              [-156.44526119699992, -78.16814544099992],
              [-156.45238196499992, -78.16090260199991],
              [-156.45295162699992, -78.14568450299993],
              [-156.5696915359999, -78.15113697699991],
              [-156.6252335279999, -78.1428361959999],
              [-156.64854895699992, -78.14544036299992],
              [-156.67975826699993, -78.15837981599992],
              [-156.67292232999992, -78.16008879999993],
              [-156.65949459499993, -78.16643645599993],
              [-156.6526993479999, -78.16855234199994],
              [-156.68183346299992, -78.19394296699994],
              [-156.74091549399992, -78.21331145599993],
              [-156.9673966139999, -78.25335051899992],
              [-157.1995743479999, -78.25269947699991],
              [-157.2571915359999, -78.24114348799992],
              [-157.35383053299992, -78.19589609199994],
              [-157.6687312489999, -78.12440357899993],
              [-157.98363196499992, -78.05291106599992],
              [-158.0078018869999, -78.04257577899995],
              [-158.0579727859999, -78.01433684699992],
              [-158.08881588399993, -78.00530364399992],
              [-158.1800430979999, -78.0061174459999],
              [-158.2532852859999, -77.98170338299991],
              [-158.31110592399992, -77.98064544099992],
              [-158.34386145699992, -77.9743791649999],
              [-158.37507076699993, -77.9631486959999],
              [-158.4018448559999, -77.94850025799991],
              [-158.42267818899992, -77.93010833099993],
              [-158.4373673169999, -77.91285572699991],
              [-158.45502682199992, -77.89934661299992],
              [-158.6370743479999, -77.86451588299991],
              [-158.63996334499993, -77.84856536299992],
              [-158.62462317599991, -77.82976653399993],
              [-158.5334366529999, -77.76490650799991],
              [-158.51105709499993, -77.75693124799994],
              [-158.45380611899992, -77.74602629999993],
              [-158.42695064999992, -77.73626067499993],
              [-158.40082760299993, -77.72226327899995],
              [-158.38117428299992, -77.70427825299993],
              [-158.34565182199992, -77.65691497199992],
              [-158.32489986899992, -77.6364885399999],
              [-158.27436275899993, -77.61581796699994],
              [-158.1573380199999, -77.5901018209999],
              [-158.11811275899993, -77.55584075299993],
              [-158.28632564999992, -77.5139299459999],
              [-158.25336666599992, -77.48398202899995],
              [-158.21869869699992, -77.46282317499993],
              [-158.14020748599992, -77.42791106599992],
              [-158.1815079419999, -77.40048593499995],
              [-158.29181881399992, -77.37558359199994],
              [-158.3294571609999, -77.34286874799994],
              [-158.32538814999992, -77.29607512799993],
              [-158.28083248599992, -77.2575822899999],
              [-158.17747962099992, -77.20582447699991],
              [-158.20844479099992, -77.18279387799993],
              [-158.22435462099992, -77.17473723799992],
              [-158.28217525899993, -77.15390390399995],
              [-158.30162512899992, -77.14364999799994],
              [-158.31171627499992, -77.13241952899995],
              [-158.30089270699992, -77.10564544099992],
              [-158.26447506399992, -77.0861955709999],
              [-158.2202042309999, -77.07366301899992],
              [-157.92540442599991, -77.05632903399993],
              [-157.84308834499993, -77.07496510199991],
              [-157.69330807199992, -77.14275481599992],
              [-157.62787838399993, -77.15203215899993],
              [-157.6093643869999, -77.15829843499995],
              [-157.59430904899992, -77.16920338299991],
              [-157.58454342399992, -77.17929452899995],
              [-157.57306881399992, -77.18710702899995],
              [-157.51166744699992, -77.20183684699992],
              [-157.3940323559999, -77.25074635199991],
              [-157.2507218089999, -77.27304452899995],
              [-157.2635391919999, -77.27825286299992],
              [-157.27708899599992, -77.2815080709999],
              [-157.2910050119999, -77.28281015399995],
              [-157.3049210279999, -77.28199635199991],
              [-157.25633704299992, -77.30217864399992],
              [-157.08307857999992, -77.35125090899993],
              [-157.0218399729999, -77.35865650799991],
              [-157.0052384109999, -77.35556405999995],
              [-156.9808243479999, -77.34246184699992],
              [-156.92988033799992, -77.35393645599993],
              [-156.9033096999999, -77.34840260199991],
              [-156.89696204299992, -77.33782317499993],
              [-156.89924068899992, -77.32708098799992],
              [-156.89606686099992, -77.31926848799992],
              [-156.8212784499999, -77.31910572699991],
              [-156.46711178299992, -77.26067473799992],
              [-156.51166744699992, -77.24773528399993],
              [-156.69635982999992, -77.23495859199994],
              [-156.7366837229999, -77.22551848799992],
              [-156.81098385299993, -77.19150155999995],
              [-156.83356686099992, -77.18767669099992],
              [-156.7823380199999, -77.1657854149999],
              [-156.65514075399992, -77.15715911299992],
              [-156.59028072799993, -77.11239999799994],
              [-156.51060950399992, -77.1052385399999],
              [-156.4146622389999, -77.0778947899999],
              [-156.32384192599991, -77.06609465899993],
              [-155.86554928299992, -77.05974700299993],
              [-155.69501705599993, -77.08171965899993],
              [-155.58259029899992, -77.11321379999993],
              [-155.4999893869999, -77.16130950299993],
              [-155.47504635299993, -77.16790129999993],
              [-155.35688229099992, -77.16497161299992],
              [-155.3299454419999, -77.16985442499993],
              [-155.3157852859999, -77.1701799459999],
              [-155.3088272779999, -77.1638322899999],
              [-155.30870520699992, -77.15032317499993],
              [-155.30585689999992, -77.1364885399999],
              [-155.2905167309999, -77.12883879999993],
              [-154.8943985669999, -77.10369231599992],
              [-154.83910071499992, -77.11239999799994],
              [-154.81635494699992, -77.12249114399992],
              [-154.77497311099992, -77.14763762799993],
              [-154.75031490799992, -77.15349700299993],
              [-154.40522213399993, -77.15292734199994],
              [-154.19562740799992, -77.17587655999995],
              [-154.16864986899992, -77.18425872199992],
              [-154.12446041599992, -77.20745208099993],
              [-154.0967911449999, -77.21379973799992],
              [-153.8154190744999, -77.23398202949991],
              [-153.53404700399992, -77.2541643209999],
              [-153.31720943899992, -77.3381486959999],
              [-153.37901770699992, -77.38079192499993],
              [-153.45539303299992, -77.39837004999993],
              [-153.90510006399992, -77.40520598799992],
              [-153.94184322799993, -77.41594817499993],
              [-153.90705318899992, -77.43499114399992],
              [-153.8624161449999, -77.44255950299993],
              [-153.5552262034999, -77.44451262799993],
              [-153.2480362619999, -77.44646575299993],
              [-153.08063717399992, -77.47307708099993],
              [-152.9963272779999, -77.4724260399999],
              [-152.93464107999992, -77.48015715899993],
              [-152.91547604099992, -77.47795989399992],
              [-152.8724259109999, -77.46786874799994],
              [-152.85167395699992, -77.46607838299991],
              [-152.82856197799993, -77.46786874799994],
              [-152.8088272779999, -77.47234465899993],
              [-152.77196204299992, -77.48577239399992],
              [-152.75263424399992, -77.49032968499995],
              [-152.57542883999992, -77.50204843499995],
              [-152.5795792309999, -77.48284270599993],
              [-152.5889786449999, -77.46697356599992],
              [-152.61493893099993, -77.43857187299994],
              [-152.58055579299992, -77.4260393209999],
              [-152.47638912699992, -77.40789153399993],
              [-152.50239010299993, -77.38746510199991],
              [-152.4678848949999, -77.3420549459999],
              [-152.4854630199999, -77.31910572699991],
              [-152.4185684889999, -77.30437590899993],
              [-152.3506973949999, -77.30266692499993],
              [-152.21686764199993, -77.3244768209999],
              [-152.18565833199992, -77.33318450299993],
              [-152.1756485669999, -77.33928801899992],
              [-152.1335343089999, -77.37574635199991],
              [-152.11925208199992, -77.38355885199991],
              [-152.09654700399992, -77.39104583099993],
              [-152.06086178299992, -77.39527760199991],
              [-151.98761959499993, -77.38795338299991],
              [-151.51459713399993, -77.41643645599993],
              [-151.37116451699993, -77.45061614399992],
              [-151.4167374339999, -77.47470468499995],
              [-151.44062252499992, -77.48349374799994],
              [-151.46613521999993, -77.48650481599992],
              [-151.4208878249999, -77.50896575299993],
              [-151.0010880199999, -77.55852629999993],
              [-150.91181393099993, -77.59075286299992],
              [-150.45405025899993, -77.68059661299992],
              [-150.4252823559999, -77.68987395599993],
              [-150.37425696499992, -77.71795012799993],
              [-150.3183487619999, -77.73601653399993],
              [-150.27289791599992, -77.76580169099992],
              [-150.24767005099991, -77.77312590899993],
              [-150.09906979099992, -77.77922942499993],
              [-150.0521134109999, -77.79159921699994],
              [-150.00361080599993, -77.81096770599993],
              [-149.9749649729999, -77.8161760399999],
              [-149.8568009109999, -77.8200822899999],
              [-149.6155899729999, -77.80242278399993],
              [-149.50243079299992, -77.77255624799994],
              [-149.24531002499992, -77.75750090899993],
              [-149.2620743479999, -77.75261809699992],
              [-149.30353756399992, -77.72771575299993],
              [-149.3228653639999, -77.72275155999995],
              [-149.38312740799992, -77.71933359199994],
              [-149.40119381399992, -77.71363697699991],
              [-149.43403072799993, -77.69687265399995],
              [-149.45091712099992, -77.69101327899995],
              [-149.50837154899992, -77.67717864399992],
              [-149.52619381399992, -77.66904062299994],
              [-149.5908096999999, -77.64934661299992],
              [-149.81427975199992, -77.64788176899992],
              [-149.80243893099993, -77.64470794099992],
              [-149.7901505199999, -77.64275481599992],
              [-149.77790279899992, -77.6423479149999],
              [-149.76557369699992, -77.64324309699992],
              [-149.7708634109999, -77.63909270599993],
              [-149.78547115799992, -77.62460702899995],
              [-149.64305579299992, -77.60849374799994],
              [-149.49852454299992, -77.60947030999995],
              [-149.22763017449992, -77.65846119549994],
              [-148.95673580599993, -77.70745208099993],
              [-148.88451087099992, -77.70720794099992],
              [-148.6736954419999, -77.67489999799994],
              [-148.8015030589999, -77.5837541649999],
              [-148.7816055979999, -77.5798479149999],
              [-148.7900284499999, -77.57577890399995],
              [-148.80622311099992, -77.56560637799993],
              [-148.8146866529999, -77.56145598799992],
              [-148.75214596299992, -77.55201588299991],
              [-148.55939693899992, -77.55999114399992],
              [-148.28903154199992, -77.52788665149993],
              [-148.0186661449999, -77.49578215899993],
              [-147.87173417899993, -77.49895598799992],
              [-147.79308020699992, -77.49032968499995],
              [-147.7582087879999, -77.46168385199991],
              [-148.17909366233323, -77.42039695966658],
              [-148.59997853666658, -77.37911006733326],
              [-149.0208634109999, -77.33782317499993],
              [-149.0410050119999, -77.33310312299994],
              [-149.05553137899992, -77.32024504999993],
              [-149.06208248599992, -77.29387786299992],
              [-149.05011959499993, -77.2756486959999],
              [-149.02745520699992, -77.2639299459999],
              [-149.00190182199992, -77.25725676899992],
              [-148.8027237619999, -77.23430754999993],
              [-148.97118079299992, -77.22747161299992],
              [-148.95628821499992, -77.21363697699991],
              [-148.91352291599992, -77.18645598799992],
              [-148.86738033799992, -77.13738372199992],
              [-148.85118567599991, -77.12574635199991],
              [-148.81183834499993, -77.11207447699991],
              [-148.76972408799992, -77.10475025799991],
              [-148.5130509109999, -77.10759856599992],
              [-148.1799413729999, -77.18568287549994],
              [-147.8468318349999, -77.26376718499995],
              [-147.7699275379999, -77.31178150799991],
              [-147.7779434889999, -77.36972421699994],
              [-147.7011612619999, -77.40943775799991],
              [-147.66144771999993, -77.42302825299993],
              [-147.6213272779999, -77.41741301899992],
              [-147.6932266919999, -77.37297942499993],
              [-147.71426347599993, -77.35556405999995],
              [-147.68691972599993, -77.34905364399992],
              [-147.6600235669999, -77.35670338299991],
              [-147.60651607999992, -77.38404713299991],
              [-147.5795792309999, -77.38534921699994],
              [-147.49054928299992, -77.35369231599992],
              [-147.3917130199999, -77.34099700299993],
              [-147.29670162699992, -77.3161760399999],
              [-147.26646887899992, -77.31308359199994],
              [-147.2330216139999, -77.31373463299991],
              [-147.26382402299993, -77.28671640399995],
              [-147.27521725199992, -77.2693010399999],
              [-147.26414954299992, -77.2595354149999],
              [-146.97618567599991, -77.23593515399995],
              [-146.8898005849999, -77.25579192499993],
              [-146.4689835279999, -77.43987395599993],
              [-146.39659583199992, -77.49521249799994],
              [-146.37511145699992, -77.50310637799993],
              [-146.3535050119999, -77.50400155999995],
              [-146.30988521999993, -77.49993254999993],
              [-146.02550208199992, -77.51921965899993],
              [-145.9326065749999, -77.50009530999995],
              [-145.9687393869999, -77.49651458099993],
              [-145.9853409499999, -77.49130624799994],
              [-145.9996638659999, -77.48007577899995],
              [-145.7869766919999, -77.47812265399995],
              [-145.4984024729999, -77.5251604149999],
              [-145.4627986319999, -77.5232072899999],
              [-145.42983964799993, -77.50660572699991],
              [-145.43732662699992, -77.5041643209999],
              [-145.4518936839999, -77.49716562299994],
              [-145.4593806629999, -77.49480559699992],
              [-145.4472550119999, -77.48796965899993],
              [-145.4341934889999, -77.48300546699994],
              [-145.42056230399993, -77.48007577899995],
              [-145.4066462879999, -77.47926197699991],
              [-145.55817623599992, -77.45126718499995],
              [-145.5689591139999, -77.44589609199994],
              [-145.5685929029999, -77.43987395599993],
              [-145.56566321499992, -77.4333635399999],
              [-145.56899980399993, -77.42701588299991],
              [-145.66535396999993, -77.38567473799992],
              [-145.7347305979999, -77.36874765399995],
              [-145.9550675119999, -77.36337655999995],
              [-145.9373673169999, -77.36003997199992],
              [-145.90245520699992, -77.34823984199994],
              [-145.8856501939999, -77.3459611959999],
              [-145.80980383999992, -77.3479143209999],
              [-145.83088131399992, -77.3376604149999],
              [-145.8535050119999, -77.33261484199994],
              [-145.9003800119999, -77.32878997199992],
              [-145.8949275379999, -77.32561614399992],
              [-145.8846736319999, -77.31764088299991],
              [-145.8793025379999, -77.31438567499993],
              [-145.9389542309999, -77.27988046699994],
              [-145.96446692599991, -77.25448984199994],
              [-145.95343990799992, -77.23308684699992],
              [-145.92003333199992, -77.22730885199991],
              [-145.8857315749999, -77.23398202899995],
              [-145.8512263659999, -77.24480559699992],
              [-145.81720943899992, -77.25156015399995],
              [-145.70909583199992, -77.24342213299991],
              [-145.56407630099991, -77.25156015399995],
              [-145.55597896999993, -77.2502580709999],
              [-145.55020097599993, -77.24700286299992],
              [-145.5405167309999, -77.23870208099993],
              [-145.53457597599993, -77.23560963299991],
              [-145.5253800119999, -77.23455169099992],
              [-145.4272354809999, -77.24700286299992],
              [-145.2459610669999, -77.23235442499993],
              [-145.27501380099991, -77.22112395599993],
              [-145.6059464184999, -77.14373137799993],
              [-145.9368790359999, -77.06633879999993],
              [-145.9732559889999, -77.06340911299992],
              [-146.04963131399992, -77.06633879999993],
              [-146.16291256399992, -77.05852629999993],
              [-146.30907141799992, -77.03020598799992],
              [-146.38141842399992, -77.00310637799993],
              [-146.3192439439999, -76.9904924459999],
              [-145.9276220364999, -77.02280038849992],
              [-145.53600012899992, -77.05510833099993],
              [-145.5311173169999, -77.05917734199994],
              [-145.5273331369999, -77.07333749799994],
              [-145.52407792899993, -77.07724374799994],
              [-145.5069473949999, -77.07952239399992],
              [-145.3453669909999, -77.05706145599993],
              [-145.30996660099993, -77.05868905999995],
              [-145.32827714799993, -77.04013437299994],
              [-145.3616837229999, -77.02841562299994],
              [-145.5693253249999, -76.98259856599992],
              [-145.54523678299992, -76.96998463299991],
              [-145.54670162699992, -76.94784921699994],
              [-145.5651749339999, -76.92652760199991],
              [-145.5925186839999, -76.91676197699991],
              [-145.81037350199992, -76.91985442499993],
              [-145.88243567599991, -76.90829843499995],
              [-145.91486568899992, -76.89755624799994],
              [-145.94774329299992, -76.88014088299991],
              [-145.9636124339999, -76.85751718499995],
              [-145.94505774599992, -76.83025481599992],
              [-145.9135636059999, -76.81796640399995],
              [-145.87824459499993, -76.81682708099993],
              [-145.8096817699999, -76.82724374799994],
              [-145.73949133999992, -76.82822030999995],
              [-145.5244034499999, -76.79892343499995],
              [-145.51105709499993, -76.79534270599993],
              [-145.48790442599991, -76.7815080709999],
              [-145.4757380849999, -76.77849700299993],
              [-145.3983455069999, -76.77947356599992],
              [-145.46263587099992, -76.75164153399993],
              [-145.53425045499992, -76.73796965899993],
              [-145.82211259699992, -76.72356536249993],
              [-146.1099747389999, -76.70916106599992],
              [-146.12547766799992, -76.70476653399993],
              [-146.13752193899992, -76.69931405999995],
              [-146.18512936099992, -76.66253020599993],
              [-146.3109024729999, -76.63005950299993],
              [-146.3446345689999, -76.6267229149999],
              [-146.4166153639999, -76.62737395599993],
              [-146.4503067699999, -76.61785247199992],
              [-146.47012285099993, -76.59270598799992],
              [-146.43268795499992, -76.57024504999993],
              [-146.4128311839999, -76.56194426899992],
              [-146.3912247389999, -76.55868905999995],
              [-146.4464412099999, -76.54778411299992],
              [-146.6180720689999, -76.53240325299993],
              [-147.0816951159999, -76.43279387799993],
              [-147.5606176419999, -76.44064706799992],
              [-148.03954016799992, -76.44850025799991],
              [-148.11497962099992, -76.46363697699991],
              [-148.19542395699992, -76.46550872199992],
              [-148.45282955599993, -76.50603606599992],
              [-148.84847300233326, -76.48067256766659],
              [-149.24411644866657, -76.45530906933324],
              [-149.6397598949999, -76.4299455709999],
              [-149.68769283799992, -76.41643645599993],
              [-149.71406002499992, -76.39771900799991],
              [-149.7089737619999, -76.3767229149999],
              [-149.6862686839999, -76.35605234199994],
              [-149.65977942599991, -76.3381486959999],
              [-149.60631262899992, -76.31389739399992],
              [-149.54576575399992, -76.30038827899995],
              [-149.48334713399993, -76.2932268209999],
              [-149.03327389199993, -76.30193450299993],
              [-148.87409420499992, -76.26572030999995],
              [-148.5396622389999, -76.2282854149999],
              [-148.64582271999993, -76.20907968499995],
              [-148.69029700399992, -76.19150155999995],
              [-148.68927975199992, -76.16106536299992],
              [-148.6486710279999, -76.13469817499993],
              [-148.59142005099991, -76.11687590899993],
              [-148.42540442599991, -76.08945077899995],
              [-148.19709225199992, -76.08709075299993],
              [-147.85288109733324, -76.13545772366659],
              [-147.5086699426666, -76.18382469433324],
              [-147.1644587879999, -76.2321916649999],
              [-147.1769099599999, -76.23772551899992],
              [-147.18976803299992, -76.24114348799992],
              [-147.20295162699992, -76.24228280999995],
              [-147.2162979809999, -76.24089934699992],
              [-147.16730709499993, -76.2575822899999],
              [-146.95665442599991, -76.29892343499995],
              [-146.76097571499992, -76.3122697899999],
              [-146.5975642569999, -76.3596330709999],
              [-146.57160396999993, -76.3552385399999],
              [-146.5467830069999, -76.34026458099993],
              [-146.52110755099991, -76.32919687299994],
              [-146.49445553299992, -76.32675546699994],
              [-146.4664607409999, -76.33806731599992],
              [-146.4183650379999, -76.37566497199992],
              [-146.39305579299992, -76.39023202899995],
              [-146.2507218089999, -76.42376067499993],
              [-146.22223873599992, -76.42131926899992],
              [-146.16917883999992, -76.40862395599993],
              [-146.00544186099992, -76.41676197699991],
              [-145.93407141799992, -76.44280364399992],
              [-145.71837317599991, -76.46493905999995],
              [-145.3546443349999, -76.43450286299992],
              [-145.3817439439999, -76.40976327899995],
              [-145.47907467399992, -76.35393645599993],
              [-145.5046280589999, -76.33025481599992],
              [-145.5179744129999, -76.32195403399993],
              [-145.53864498599992, -76.31552499799994],
              [-145.9090876939999, -76.25920989399992],
              [-146.2043554349999, -76.17310963349993],
              [-146.49962317599991, -76.08700937299994],
              [-146.46955318899992, -76.06308359199994],
              [-146.43765214799993, -76.05006275799991],
              [-146.36339270699992, -76.03785572699991],
              [-146.3674210279999, -76.03240325299993],
              [-146.3736466139999, -76.01970794099992],
              [-146.37759355399993, -76.01433684699992],
              [-146.2905167309999, -75.99480559699992],
              [-146.29426021999993, -75.98796965899993],
              [-146.2995499339999, -75.97234465899993],
              [-146.3034561839999, -75.96550872199992],
              [-146.2092179029999, -75.91545989399992],
              [-145.9508357409999, -75.8825822899999],
              [-145.56558183499993, -75.89487070149991],
              [-145.18032792899993, -75.90715911299992],
              [-145.2136124339999, -75.89348723799992],
              [-145.1852107409999, -75.88323333099993],
              [-145.05728105399993, -75.87517669099992],
              [-144.8912247389999, -75.84091562299994],
              [-144.59040279899992, -75.84335702899995],
              [-144.38792883999992, -75.81267669099992],
              [-144.32046464799993, -75.8142229149999],
              [-144.27110755099991, -75.82390715899993],
              [-144.2213028639999, -75.82122161299992],
              [-144.20470130099991, -75.81764088299991],
              [-144.17731686099992, -75.80396900799991],
              [-144.1603897779999, -75.80396900799991],
              [-144.20470130099991, -75.74944426899992],
              [-144.21051998599992, -75.7346330709999],
              [-144.2025040359999, -75.7185197899999],
              [-144.18781490799992, -75.71282317499993],
              [-143.97183183499993, -75.69605885199991],
              [-143.9955948559999, -75.67489999799994],
              [-144.04735266799992, -75.66643645599993],
              [-144.19904537699992, -75.66122812299994],
              [-144.3076065749999, -75.6423479149999],
              [-144.35724850199992, -75.62395598799992],
              [-144.30606035099993, -75.61451588299991],
              [-144.0889786449999, -75.61419036299992],
              [-143.74040686749993, -75.57622649549992],
              [-143.39183508999992, -75.53826262799993],
              [-143.03563391799992, -75.55002206799992],
              [-142.67943274599992, -75.56178150799991],
              [-142.65493730399993, -75.55868905999995],
              [-142.6399633449999, -75.55242278399993],
              [-142.6282445949999, -75.54558684699992],
              [-142.61607825399994, -75.54021575299993],
              [-142.5996801419999, -75.53801848799992],
              [-142.5574438139999, -75.54208749799994],
              [-142.5449112619999, -75.54045989399992],
              [-142.5371801419999, -75.53679778399993],
              [-142.5286352199999, -75.5310197899999],
              [-142.51402747299994, -75.51881275799991],
              [-142.53380286399994, -75.50465260199991],
              [-142.5496313139999, -75.48845794099992],
              [-142.5782364569999, -75.45126718499995],
              [-142.5263565749999, -75.43759530999995],
              [-142.4670304029999, -75.43173593499995],
              [-142.1301977199999, -75.46087004999993],
              [-142.0312393869999, -75.49553801899992],
              [-141.91185462099992, -75.50359465899993],
              [-141.8613988919999, -75.52117278399993],
              [-141.7363175119999, -75.62639739399992],
              [-141.69054114499994, -75.65374114399992],
              [-141.6740616529999, -75.67034270599993],
              [-141.66173255099994, -75.69524504999993],
              [-141.6474503249999, -75.7068010399999],
              [-141.59166419199994, -75.7307268209999],
              [-141.5540258449999, -75.76165129999993],
              [-141.5271703769999, -75.76751067499993],
              [-141.4278051419999, -75.7658830709999],
              [-141.4162491529999, -75.76409270599993],
              [-141.3985489569999, -75.7536760399999],
              [-141.38955644399994, -75.7443986959999],
              [-141.37950598899994, -75.73951588299991],
              [-141.3017471999999, -75.75074635199991],
              [-140.91295325399994, -75.76238372199992],
              [-140.89736894399994, -75.76702239399992],
              [-140.85875403599994, -75.79241301899992],
              [-140.8425186839999, -75.79778411299992],
              [-140.82607988199993, -75.8010393209999],
              [-140.6464737619999, -75.80722421699994],
              [-140.77647864499994, -75.7439104149999],
              [-140.7537328769999, -75.74114348799992],
              [-140.6848852199999, -75.74602629999993],
              [-140.8372289699999, -75.68287525799991],
              [-141.23843339799993, -75.59872812299994],
              [-141.2981664699999, -75.5661760399999],
              [-141.32652747299994, -75.52678801899992],
              [-141.2988175119999, -75.50164153399993],
              [-141.2304581369999, -75.49236419099992],
              [-140.92747962099992, -75.5114885399999],
              [-140.8693741529999, -75.52556731599992],
              [-140.8196508449999, -75.53093840899993],
              [-140.54832923049992, -75.48174407349993],
              [-140.27700761599993, -75.43254973799992],
              [-140.2173559239999, -75.41025155999995],
              [-140.1985570949999, -75.39251067499993],
              [-140.2188207669999, -75.37517669099992],
              [-140.18932044199994, -75.35515715899993],
              [-140.1570531889999, -75.34059010199991],
              [-139.8497208319999, -75.24065520599993],
              [-139.81484941299993, -75.23544687299994],
              [-139.7674047519999, -75.23626067499993],
              [-139.75694739499994, -75.23406340899993],
              [-139.7366430329999, -75.22714609199994],
              [-139.67418372299994, -75.2185197899999],
              [-139.67699133999992, -75.19638437299994],
              [-139.65941321499992, -75.17636484199994],
              [-139.6335343089999, -75.16130950299993],
              [-139.61123613199993, -75.15349700299993],
              [-139.5666397779999, -75.14804452899995],
              [-139.35142981699994, -75.14771900799991],
              [-139.20425370999993, -75.12493254999993],
              [-139.0342504549999, -75.14072030999995],
              [-138.6575957239999, -75.12900155999995],
              [-138.28094099299992, -75.11728280999995],
              [-137.9042862619999, -75.10556405999995],
              [-137.8487035799999, -75.09587981599992],
              [-137.7859594389999, -75.06959400799991],
              [-137.76333574099993, -75.06292083099993],
              [-137.74233964799993, -75.06064218499995],
              [-137.47744706899994, -75.0881486959999],
              [-137.09487870999993, -75.17986419099992],
              [-137.07164466099994, -75.17791106599992],
              [-137.05508378799993, -75.16765715899993],
              [-137.03921464799993, -75.15520598799992],
              [-137.0183813139999, -75.14609140399995],
              [-136.99522864499994, -75.1447893209999],
              [-136.9189346999999, -75.15618254999993],
              [-136.6324763664999, -75.16700611749994],
              [-136.3460180329999, -75.17782968499995],
              [-136.36241614499994, -75.15789153399993],
              [-136.38198808499993, -75.14609140399995],
              [-136.43008378799993, -75.13388437299994],
              [-136.40660559799994, -75.12810637799993],
              [-136.3350317049999, -75.12542083099993],
              [-136.37437903599994, -75.10808684699992],
              [-136.62598629499993, -75.07313404749993],
              [-136.87759355399993, -75.03818124799994],
              [-136.96475175699993, -75.01360442499993],
              [-137.00987708199995, -75.00986093499995],
              [-136.9976293609999, -75.00725676899992],
              [-136.9585668609999, -74.99309661299992],
              [-136.88560950399994, -74.98137786299992],
              [-136.8725479809999, -74.97527434699992],
              [-136.8643285799999, -74.9646135399999],
              [-136.8631078769999, -74.94793059699992],
              [-136.8689672519999, -74.93092213299991],
              [-136.88719641799992, -74.89983489399992],
              [-136.89122473899994, -74.88030364399992],
              [-136.8893936839999, -74.86988697699991],
              [-136.88540605399993, -74.86256275799991],
              [-136.88243567599994, -74.85475025799991],
              [-136.88487708199995, -74.82830169099992],
              [-136.88170325399994, -74.8166643209999],
              [-136.86681067599994, -74.79257577899995],
              [-136.8342992829999, -74.76043059699992],
              [-136.79430091099994, -74.74993254999993],
              [-136.56529700399994, -74.75855885199991],
              [-136.4177953769999, -74.73919036299992],
              [-136.34927324099993, -74.71770598799992],
              [-136.2248429029999, -74.7014299459999],
              [-136.12295488199993, -74.70110442499993],
              [-135.93614661399994, -74.72356536299992],
              [-135.87474524599992, -74.74618905999995],
              [-135.85606848899994, -74.7497697899999],
              [-135.71605383999992, -74.74920012799993],
              [-135.70181230399993, -74.74732838299991],
              [-135.69151770699995, -74.74187590899993],
              [-135.68150794199994, -74.73455169099992],
              [-135.6682022779999, -74.72779713299991],
              [-135.64781653599994, -74.71347421699994],
              [-135.65664628799993, -74.6994768209999],
              [-135.70010331899994, -74.6779924459999],
              [-135.6337784499999, -74.64055754999993],
              [-135.49547278599994, -74.58123137799993],
              [-135.4199926419999, -74.56511809699992],
              [-135.34239661399994, -74.56015390399995],
              [-134.93051103449992, -74.60169850049994],
              [-134.5186254549999, -74.64324309699992],
              [-134.48892167899993, -74.65748463299991],
              [-134.50137285099993, -74.67685312299994],
              [-134.52330481699994, -74.69345468499995],
              [-134.57087154899995, -74.7170549459999],
              [-134.5862524079999, -74.73626067499993],
              [-134.56810462099992, -74.7561174459999],
              [-134.53746497299994, -74.77239348799992],
              [-134.51524817599994, -74.78085702899995],
              [-134.39224199099993, -74.80152760199991],
              [-134.3730362619999, -74.81170012799993],
              [-134.37755286399994, -74.82919687299994],
              [-134.39509029899995, -74.84734465899993],
              [-134.41470292899993, -74.85898202899995],
              [-134.35562089799993, -74.87037525799991],
              [-134.23814856699994, -74.85564544099992],
              [-134.17613684799994, -74.85491301899992],
              [-134.09040279899995, -74.88103606599992],
              [-134.05899003799993, -74.88494231599992],
              [-133.9291886059999, -74.88420989399992],
              [-133.94322669199994, -74.88779062299994],
              [-133.95372473899994, -74.89576588299991],
              [-133.9566137359999, -74.90715911299992],
              [-133.94810950399994, -74.92034270599993],
              [-133.9382218089999, -74.92400481599992],
              [-133.8655492829999, -74.92831796699994],
              [-133.59188798749992, -74.88160572749993],
              [-133.31822669199994, -74.83489348799992],
              [-133.19981848899994, -74.84026458099993],
              [-132.79116777299993, -74.76864999799994],
              [-132.7612198559999, -74.76848723799992],
              [-132.7390030589999, -74.77678801899992],
              [-132.7156469389999, -74.79257577899995],
              [-132.69001217399995, -74.80348072699991],
              [-132.6357315749999, -74.81894296699994],
              [-132.57872473899994, -74.82577890399995],
              [-132.09312903599994, -74.76327890399995],
              [-131.7787979809999, -74.78093840899993],
              [-131.57408606699994, -74.8435197899999],
              [-131.5554093089999, -74.8459611959999],
              [-131.28410803949993, -74.83123137799993],
              [-131.01280676999994, -74.81650155999995],
              [-130.9748429029999, -74.82830169099992],
              [-130.9546606109999, -74.83114999799994],
              [-130.81582597599993, -74.81568775799991],
              [-130.77041581899994, -74.82333749799994],
              [-130.74193274599992, -74.83562590899993],
              [-130.7319229809999, -74.83863697699991],
              [-130.3535050119999, -74.87594980249992],
              [-129.97508704299992, -74.91326262799993],
              [-129.62486731649992, -74.87700774549992],
              [-129.27464758999992, -74.84075286299992],
              [-129.2632543609999, -74.83782317499993],
              [-129.23912512899994, -74.82390715899993],
              [-129.2276098299999, -74.8205705709999],
              [-129.1868383449999, -74.8264299459999],
              [-128.71149654899995, -74.8225236959999],
              [-128.6502172519999, -74.81292083099993],
              [-128.5327042309999, -74.77304452899995],
              [-128.47301184799994, -74.7634416649999],
              [-128.00503495999993, -74.74130624799994],
              [-127.9929906889999, -74.73707447699991],
              [-127.97126217399995, -74.72144947699991],
              [-127.95913652299993, -74.71770598799992],
              [-127.90208899599992, -74.71843840899993],
              [-127.85049394399994, -74.7263322899999],
              [-127.8391820949999, -74.72356536299992],
              [-127.8108617829999, -74.70842864399992],
              [-127.79596920499989, -74.70387135199991],
              [-127.74046790299991, -74.70435963299991],
              [-127.62987219999991, -74.71982187299994],
              [-127.3523656889999, -74.7068010399999],
              [-127.32408606699994, -74.70126718499995],
              [-127.2708227199999, -74.68401458099993],
              [-127.24474036399994, -74.68010833099993],
              [-127.1258031889999, -74.6897111959999],
              [-126.93907630099994, -74.67669036299992],
              [-126.87804114499994, -74.68238697699991],
              [-126.79710852799991, -74.70435963299991],
              [-126.67613684799994, -74.71998463299991],
              [-126.59463456899994, -74.7424455709999],
              [-126.11343339799993, -74.7614885399999],
              [-126.05606035099993, -74.74822356599992],
              [-126.02529863199993, -74.74716562299994],
              [-125.96141516799992, -74.75318775799991],
              [-125.93358313699991, -74.75253671699994],
              [-125.82140051999994, -74.72812265399995],
              [-125.76846269399994, -74.70777760199991],
              [-125.74006100199989, -74.70476653399993],
              [-125.33800208249991, -74.70993417749992],
              [-124.93594316299993, -74.7151018209999],
              [-124.85435950399994, -74.73316822699991],
              [-124.82632402299993, -74.73601653399993],
              [-124.47642981699994, -74.71363697699991],
              [-124.43610592399995, -74.72112395599993],
              [-124.42300370999993, -74.72144947699991],
              [-124.4085180329999, -74.71835702899995],
              [-124.38060462099992, -74.70907968499995],
              [-124.36563066299993, -74.70696379999993],
              [-124.30736243399991, -74.71233489399992],
              [-124.19985917899993, -74.74732838299991],
              [-124.07628333199995, -74.80706145599993],
              [-124.05134029899995, -74.81113046699994],
              [-123.75873775949992, -74.79648202949994],
              [-123.4661352199999, -74.78183359199994],
              [-123.34414628799993, -74.75644296699994],
              [-123.21784420499989, -74.7556291649999],
              [-123.22443600199995, -74.77483489399992],
              [-123.16954505099994, -74.78899504999993],
              [-123.11823482999989, -74.79631926899992],
              [-123.00987708199995, -74.79648202899995],
              [-122.8362524079999, -74.76572030999995],
              [-122.72337805899991, -74.77605559699992],
              [-122.45482337099992, -74.75335051899992],
              [-122.42357337099992, -74.75514088299991],
              [-122.33311926999994, -74.77662525799991],
              [-122.30553137899994, -74.77629973799992],
              [-122.22793535099993, -74.75628020599993],
              [-122.2000219389999, -74.75383879999993],
              [-122.00389563699991, -74.7751604149999],
              [-121.91283118399991, -74.76555754999993],
              [-121.8294164699999, -74.78411223799992],
              [-121.8020727199999, -74.78655364399992],
              [-121.77253170499989, -74.78606536299992],
              [-121.76504472599993, -74.78199635199991],
              [-121.75462805899991, -74.76425546699994],
              [-121.7434789699999, -74.75709400799991],
              [-121.71568762899994, -74.75107187299994],
              [-121.70140540299991, -74.7502580709999],
              [-121.63589433499993, -74.75904713299991],
              [-121.4749242829999, -74.75579192499993],
              [-121.46056067599994, -74.75269947699991],
              [-121.44322669199994, -74.7380510399999],
              [-121.43382727799991, -74.73503997199992],
              [-121.25462805899991, -74.72470468499995],
              [-121.2688695949999, -74.73398202899995],
              [-121.28441321499992, -74.74081796699994],
              [-121.3008520169999, -74.74521249799994],
              [-121.3176977199999, -74.74773528399993],
              [-121.26211503799993, -74.75652434699992],
              [-121.20311438699991, -74.75595468499995],
              [-121.14549719999991, -74.74504973799992],
              [-121.09410559799994, -74.72323984199994],
              [-121.07164466099994, -74.71640390399995],
              [-121.04336503799993, -74.71607838299991],
              [-121.01646887899994, -74.72185637799993],
              [-120.97565670499989, -74.7463518209999],
              [-120.94664466099994, -74.7478166649999],
              [-120.82933508999992, -74.73984140399995],
              [-120.71703040299991, -74.71331145599993],
              [-120.43549557199992, -74.68670012799993],
              [-120.15396074099993, -74.66008879999993],
              [-120.04271399599992, -74.67742278399993],
              [-119.89732825399994, -74.6818986959999],
              [-119.5437719389999, -74.64226653399993],
              [-119.42105058499993, -74.65764739399992],
              [-119.40143795499989, -74.65496184699992],
              [-119.38084876199991, -74.6462541649999],
              [-119.34080969999991, -74.62273528399993],
              [-119.32115637899994, -74.61663176899992],
              [-119.13499915299991, -74.59807708099993],
              [-119.05451412699995, -74.60515715899993],
              [-118.98228919199994, -74.59531015399995],
              [-118.9104711579999, -74.60271575299993],
              [-118.86705481699994, -74.60247161299992],
              [-118.67959550699993, -74.56373463299991],
              [-118.62913977799991, -74.5451799459999],
              [-118.6165258449999, -74.52223072699991],
              [-118.64708411399994, -74.50945403399993],
              [-119.1382543609999, -74.50335051899992],
              [-119.0696508449999, -74.43962981599992],
              [-118.97549394399994, -74.40422942499993],
              [-118.54969234899994, -74.35849374799992],
              [-118.12389075399994, -74.3127580709999],
              [-118.03726152299993, -74.28313567499993],
              [-117.99364173099991, -74.26287200299993],
              [-117.97081458199995, -74.2580705709999],
              [-117.94692949099993, -74.26100025799991],
              [-117.92275956899994, -74.27214934699992],
              [-117.8491918609999, -74.31633879999993],
              [-117.8411352199999, -74.3376604149999],
              [-117.8836156889999, -74.36288827899995],
              [-117.97813880099994, -74.39983489399992],
              [-117.91392981699994, -74.41961028399993],
              [-117.89150956899994, -74.42009856599992],
              [-117.83592688699991, -74.4118791649999],
              [-117.80919348899994, -74.41472747199992],
              [-117.79283606699994, -74.4314104149999],
              [-117.88272050699993, -74.46982187299994],
              [-117.84398352799991, -74.5100236959999],
              [-117.78575598899994, -74.51751067499993],
              [-117.66234290299991, -74.50335051899992],
              [-117.60407467399995, -74.50937265399995],
              [-117.48997962099992, -74.53476327899995],
              [-117.34121660099993, -74.54680754999993],
              [-117.14244544199994, -74.53484465899993],
              [-116.69347083199995, -74.55787525799991],
              [-116.5188695949999, -74.51767343499995],
              [-116.46288001199991, -74.51116301899992],
              [-116.29605058499993, -74.51921965899993],
              [-116.21190344999991, -74.49456145599993],
              [-116.18675696499992, -74.49627044099992],
              [-116.15184485599991, -74.5041643209999],
              [-116.05020097599993, -74.49732838299991],
              [-116.08486894399994, -74.47966887799993],
              [-116.09752356699994, -74.46689218499995],
              [-116.10098222599993, -74.44768645599993],
              [-116.09536699099993, -74.43010833099993],
              [-116.08413652299993, -74.41912200299993],
              [-116.06924394399994, -74.41204192499993],
              [-116.05239824099993, -74.4065080709999],
              [-115.98029537699995, -74.39177825299993],
              [-115.90672766799992, -74.38543059699992],
              [-115.91844641799992, -74.3982072899999],
              [-115.92715410099993, -74.41025155999995],
              [-115.92821204299992, -74.42245859199994],
              [-115.91710364499994, -74.43596770599993],
              [-115.88829505099994, -74.45598723799992],
              [-115.79356848899994, -74.50115325299993],
              [-115.72667395699995, -74.5217424459999],
              [-115.64932206899994, -74.53093840899993],
              [-115.41685950399994, -74.51116301899992],
              [-115.23717200399994, -74.51506926899992],
              [-115.02391516799992, -74.48251718499995],
              [-114.8743383449999, -74.48162200299993],
              [-114.83849036399994, -74.47144947699991],
              [-114.85366777299993, -74.46363697699991],
              [-114.86998450399994, -74.45134856599992],
              [-114.88365637899994, -74.43661874799994],
              [-114.89110266799992, -74.42115650799991],
              [-114.89110266799992, -74.3982072899999],
              [-114.88060462099992, -74.38787200299993],
              [-114.86314856699994, -74.3850236959999],
              [-114.84239661399994, -74.3850236959999],
              [-114.85374915299991, -74.37786223799992],
              [-114.8655492829999, -74.37371184699992],
              [-114.89118404899995, -74.36923593499995],
              [-114.90282141799992, -74.36443450299993],
              [-114.92308508999992, -74.34807708099993],
              [-114.93472245999993, -74.3435197899999],
              [-114.96971594999991, -74.33635833099993],
              [-114.99449622299994, -74.32463958099993],
              [-115.06798255099994, -74.25644296699994],
              [-115.07567298099991, -74.24472421699994],
              [-115.09146074099993, -74.20582447699991],
              [-115.12376868399991, -74.17302825299993],
              [-115.12608801999994, -74.15105559699992],
              [-115.11095130099994, -74.13103606599992],
              [-115.08267167899993, -74.11296965899993],
              [-115.12486731699994, -74.09490325299993],
              [-115.02220618399991, -74.0466447899999],
              [-114.9129125639999, -74.01685963299991],
              [-114.94497636599993, -73.9943986959999],
              [-114.81334387899994, -73.96363697699991],
              [-114.79686438699991, -73.93889739399992],
              [-114.73399817599994, -73.92685312299994],
              [-114.50536048099991, -73.92001718499995],
              [-114.45107988199993, -73.90781015399995],
              [-114.37437903599994, -73.88152434699992],
              [-114.21003170499989, -73.86345794099992],
              [-114.18224036399994, -73.8669572899999],
              [-114.10171464799993, -73.89202239399992],
              [-113.95177161399994, -73.91464609199994],
              [-113.97744706899994, -73.94833749799994],
              [-114.0113012359999, -73.96835702899995],
              [-114.28600012899994, -74.05917734199994],
              [-114.24233964799993, -74.07830169099992],
              [-114.18814042899993, -74.07708098799992],
              [-113.89248613199993, -74.02271900799991],
              [-113.61119544199994, -74.0251604149999],
              [-113.58340410099993, -74.02849700299993],
              [-113.56200110599991, -74.03525155999995],
              [-113.43960527299993, -74.09970468499995],
              [-113.42613684799994, -74.11988697699991],
              [-113.44554602799991, -74.12664153399993],
              [-113.44701087099992, -74.14275481599992],
              [-113.43700110599991, -74.16130950299993],
              [-113.42202714799993, -74.17489999799994],
              [-113.88320878799993, -74.23707447699991],
              [-113.94782467399995, -74.25644296699994],
              [-113.91942298099991, -74.2653947899999],
              [-113.80455481699994, -74.27662525799991],
              [-113.74990800699993, -74.2732072899999],
              [-113.73379472599993, -74.27597421699994],
              [-113.70238196499992, -74.29208749799994],
              [-113.68517005099994, -74.29656340899993],
              [-113.78954016799992, -74.33326588299991],
              [-113.80532792899993, -74.34270598799992],
              [-113.80919348899994, -74.35540129999993],
              [-113.80223548099991, -74.39275481599992],
              [-113.79491126199991, -74.40056731599992],
              [-113.77944902299993, -74.40553150799991],
              [-113.7483617829999, -74.41130950299993],
              [-113.80125891799992, -74.45183684699992],
              [-113.73106848899994, -74.46982187299994],
              [-113.65746008999992, -74.46640390399995],
              [-113.51244055899991, -74.43124765399995],
              [-113.22508704299992, -74.4021135399999],
              [-113.2630102199999, -74.45086028399993],
              [-113.31094316299993, -74.4807268209999],
              [-113.56362870999993, -74.55413176899992],
              [-113.62193762899994, -74.58114999799994],
              [-113.64928137899994, -74.58798593499995],
              [-114.05923417899993, -74.62835051899992],
              [-114.12466386599993, -74.65520598799992],
              [-114.14610755099994, -74.6604143209999],
              [-114.32579505099994, -74.6818986959999],
              [-114.3570043609999, -74.69589609199994],
              [-114.30382239499994, -74.71135833099993],
              [-114.26573645699995, -74.71607838299991],
              [-114.15298417899993, -74.71526458099993],
              [-113.97085527299993, -74.68254973799992],
              [-113.9153539699999, -74.6799455709999],
              [-113.86180579299992, -74.68906015399995],
              [-113.83975175699993, -74.69915129999993],
              [-113.82673092399995, -74.71298593499995],
              [-113.82628333199995, -74.72975025799991],
              [-113.84239661399994, -74.74871184699992],
              [-113.86058508999992, -74.75937265399995],
              [-113.91954505099994, -74.78289153399993],
              [-113.9356176419999, -74.80201588299991],
              [-113.95421301999994, -74.8596330709999],
              [-113.96963456899994, -74.88486093499995],
              [-114.01903235599991, -74.91220468499995],
              [-114.14207923099991, -74.9358049459999],
              [-114.26968339799993, -75.00383879999993],
              [-114.27806555899991, -75.01970794099992],
              [-114.26284745999993, -75.04265715899993],
              [-114.23863684799994, -75.05339934699992],
              [-114.1057836579999, -75.06894296699994],
              [-114.08096269399994, -75.0666643209999],
              [-113.9644262359999, -75.03777434699992],
              [-113.88829505099994, -75.03590260199991],
              [-113.86327063699991, -75.02629973799992],
              [-113.78966223899994, -74.97747161299992],
              [-113.76341712099992, -74.96591562299994],
              [-113.73493404899995, -74.96038176899992],
              [-113.65489661399994, -74.96550872199992],
              [-113.50121008999992, -74.94801197699991],
              [-113.44391842399995, -74.9489885399999],
              [-113.18085690049995, -74.91106536249993],
              [-112.91779537699995, -74.87314218499995],
              [-112.86717688699991, -74.87590911299992],
              [-112.72598222599993, -74.89934661299992],
              [-112.67577063699991, -74.89804452899995],
              [-112.65664628799993, -74.88982512799993],
              [-112.64354407499991, -74.8747697899999],
              [-112.63369706899994, -74.85995859199994],
              [-112.6243383449999, -74.85214609199994],
              [-112.57017981699994, -74.84636809699992],
              [-112.24575761599993, -74.86256275799991],
              [-112.2298070949999, -74.85393645599993],
              [-112.21373450399994, -74.83717213299991],
              [-112.19033769399994, -74.83131275799991],
              [-112.13902747299994, -74.82659270599993],
              [-112.09626217399995, -74.81292083099993],
              [-112.0757543609999, -74.8088518209999],
              [-111.80919348849991, -74.8051897114999],
              [-111.54263261599993, -74.80152760199991],
              [-111.56021074099993, -74.78134530999995],
              [-111.55760657499991, -74.76230234199994],
              [-111.5405981109999, -74.74765390399995],
              [-111.5149633449999, -74.73992278399993],
              [-111.5501195949999, -74.72283294099992],
              [-111.66685950399994, -74.73626067499993],
              [-111.71043860599991, -74.72144947699991],
              [-111.75405839799993, -74.68417734199994],
              [-111.80630449099993, -74.65642669099992],
              [-111.9168188139999, -74.61842213299991],
              [-111.9116918609999, -74.60230885199991],
              [-111.91612708199995, -74.58700937299994],
              [-111.92324785099993, -74.5705705709999],
              [-111.92613684799994, -74.55120208099993],
              [-111.91795813699991, -74.53508879999993],
              [-111.9004613919999, -74.52190520599993],
              [-111.86253821499992, -74.5036760399999],
              [-111.81818600199995, -74.49089934699992],
              [-111.48521887899994, -74.50107187299994],
              [-111.41982988199993, -74.48593515399995],
              [-111.32555091099994, -74.47551848799992],
              [-111.35753333199995, -74.4592424459999],
              [-111.47850501199991, -74.4553361959999],
              [-111.69709225199995, -74.42294687299994],
              [-111.74079342399995, -74.40976327899995],
              [-111.78229732999995, -74.39080169099992],
              [-111.88711503799993, -74.31536223799992],
              [-111.90477454299992, -74.28240325299993],
              [-111.87706458199995, -74.25253671699994],
              [-111.88442949099993, -74.25058359199994],
              [-111.89891516799992, -74.2439104149999],
              [-111.9063207669999, -74.2419572899999],
              [-111.8870336579999, -74.22861093499995],
              [-111.86375891799992, -74.2248674459999],
              [-111.81517493399991, -74.22275155999995],
              [-111.64981035099993, -74.17489999799994],
              [-111.59264075399994, -74.17245859199994],
              [-111.45311438699991, -74.18596770599993],
              [-111.40172278599994, -74.18173593499995],
              [-111.3762914699999, -74.1838518209999],
              [-111.34658769399994, -74.1897111959999],
              [-111.2307836579999, -74.19670989399992],
              [-111.15245520699995, -74.22128671699994],
              [-111.04637610599991, -74.23943450299993],
              [-111.03600012899994, -74.24472421699994],
              [-111.01720130099994, -74.25855885199991],
              [-111.00625566299993, -74.2634416649999],
              [-110.94566809799994, -74.2693010399999],
              [-110.88829505099994, -74.28199635199991],
              [-110.86180579299992, -74.29436614399992],
              [-110.84496008999992, -74.3127580709999],
              [-110.8274633449999, -74.32350025799991],
              [-110.79662024599992, -74.32675546699994],
              [-110.76402747299994, -74.32463958099993],
              [-110.74136308499993, -74.32024504999993],
              [-110.72264563699991, -74.30413176899992],
              [-110.6897680329999, -74.25286223799992],
              [-110.66881262899994, -74.2404924459999],
              [-110.55492102799991, -74.24407317499993],
              [-110.44859778599994, -74.2712541649999],
              [-110.24819902299993, -74.37224700299993],
              [-110.39891516799992, -74.39519622199992],
              [-110.44554602799991, -74.40935637799993],
              [-110.42979895699995, -74.41871510199991],
              [-110.40953528599994, -74.42717864399992],
              [-110.37035071499992, -74.43824635199991],
              [-110.35179602799991, -74.44019947699991],
              [-110.2266332669999, -74.42717864399992],
              [-110.19286048099991, -74.43230559699992],
              [-110.1311742829999, -74.46843840899993],
              [-110.12218176999994, -74.4782854149999],
              [-110.12368730399993, -74.48202890399995],
              [-110.13365637899994, -74.49309661299992],
              [-110.13532467399995, -74.49684010199991],
              [-110.13068600199995, -74.5036760399999],
              [-110.11099199099993, -74.52288176899992],
              [-110.10313880099994, -74.5485979149999],
              [-110.11440995999993, -74.57724374799994],
              [-110.13670813699991, -74.60019296699994],
              [-110.16173255099994, -74.60955169099992],
              [-110.21890214799993, -74.60654062299994],
              [-110.24356035099993, -74.61142343499995],
              [-110.31704667899993, -74.65545012799993],
              [-110.32070878799993, -74.6662736959999],
              [-110.29279537699995, -74.68173593499995],
              [-110.26598059799994, -74.69280364399992],
              [-110.24840247299994, -74.70468515399995],
              [-110.24160722599993, -74.72283294099992],
              [-110.24722245999993, -74.75253671699994],
              [-110.26366126199991, -74.76832447699991],
              [-110.29442298099991, -74.78191497199992],
              [-110.47232011599993, -74.82187265399995],
              [-110.59365800699993, -74.83131275799991],
              [-110.64736894399994, -74.8278947899999],
              [-110.67544511599993, -74.82935963299991],
              [-110.69713294199994, -74.83879973799992],
              [-110.72313391799992, -74.85800546699994],
              [-110.85020911399994, -74.93108489399992],
              [-110.93423417899993, -74.95582447699991],
              [-110.98912512899994, -74.98105234199994],
              [-111.0178930329999, -74.98902760199991],
              [-111.2566625639999, -75.01995208099993],
              [-111.3008520169999, -75.0334611959999],
              [-111.38272050699993, -75.07350025799991],
              [-111.52684485599991, -75.10800546699994],
              [-111.57835852799991, -75.12883879999993],
              [-111.60073808499993, -75.15520598799992],
              [-111.51821855399993, -75.15357838299991],
              [-111.49083411399994, -75.15764739399992],
              [-111.51992753799993, -75.17343515399995],
              [-111.6187231109999, -75.19736093499995],
              [-111.56110592399995, -75.20037200299993],
              [-111.48106848899994, -75.19573333099993],
              [-111.46251380099994, -75.2009416649999],
              [-111.42406165299991, -75.21786874799994],
              [-111.36412512899994, -75.23430754999993],
              [-111.30418860599991, -75.24089934699992],
              [-111.27391516799992, -75.23837655999995],
              [-111.18932044199994, -75.20989348799992],
              [-111.12987219999991, -75.20208098799992],
              [-110.78789221949992, -75.19752369599993],
              [-110.44591223899994, -75.19296640399995],
              [-110.4182836579999, -75.19963958099993],
              [-110.36302649599992, -75.22161223799992],
              [-110.33788001199991, -75.22665780999995],
              [-110.17284094999991, -75.23919036299992],
              [-109.99425208199995, -75.22031015399995],
              [-109.90021725199995, -75.23211028399993],
              [-109.86717688699991, -75.23064544099992],
              [-109.83877519399994, -75.22340260199991],
              [-109.81566321499992, -75.2131486959999],
              [-109.71825110599991, -75.15593840899993],
              [-109.69286048099991, -75.14609140399995],
              [-109.66234290299991, -75.14714934699992],
              [-109.63272050699993, -75.15252044099992],
              [-109.25045732349993, -75.17852141749992],
              [-108.86819413999993, -75.20452239399992],
              [-108.48593095649993, -75.23052337049992],
              [-108.10366777299993, -75.25652434699992],
              [-108.06468665299991, -75.26637135199991],
              [-108.02733313699991, -75.28378671699994],
              [-107.86607825399994, -75.32350025799991],
              [-107.38768469999991, -75.31292083099993],
              [-107.36290442599994, -75.3186174459999],
              [-107.31627356699994, -75.33684661299992],
              [-107.29076087099992, -75.34099700299993],
              [-107.1929418609999, -75.34303150799991],
              [-107.16405188699991, -75.33668385199991],
              [-107.15094967399995, -75.32952239399992],
              [-107.12905839799993, -75.31365325299993],
              [-107.11432857999995, -75.3088518209999],
              [-106.90489661399994, -75.30999114399992],
              [-106.81517493399991, -75.33049895599993],
              [-106.71450761599993, -75.33359140399995],
              [-106.65538489499994, -75.37037525799991],
              [-106.59129798099991, -75.37859465899993],
              [-106.52521725199995, -75.3728166649999],
              [-106.48102779899995, -75.3552385399999],
              [-106.45787512899994, -75.32154713299991],
              [-106.44912675699993, -75.31682708099993],
              [-106.08303788999993, -75.28423430749993],
              [-105.71694902299993, -75.25164153399993],
              [-105.70225989499994, -75.24480559699992],
              [-105.67540442599994, -75.2268205709999],
              [-105.6616918609999, -75.22031015399995],
              [-105.40172278549991, -75.20081959399994],
              [-105.14175370999993, -75.18132903399993],
              [-105.12047278599994, -75.17636484199994],
              [-105.10415605399993, -75.16708749799994],
              [-105.09911048099991, -75.16057708099993],
              [-105.09972083199995, -75.15699635199991],
              [-105.10301673099991, -75.15341562299994],
              [-105.10631262899994, -75.14641692499993],
              [-105.09630286399994, -75.12411874799994],
              [-105.06407630099994, -75.11248137799993],
              [-105.02647864499994, -75.10784270599993],
              [-104.8362524079999, -75.10662200299993],
              [-104.81615149599992, -75.1110979149999],
              [-104.81126868399991, -75.11386484199994],
              [-104.79873613199993, -75.1247697899999],
              [-104.78062903599994, -75.13486093499995],
              [-104.76085364499994, -75.14128997199992],
              [-104.63263912699995, -75.1599260399999],
              [-104.55064856699994, -75.16073984199994],
              [-104.33482825399994, -75.1247697899999],
              [-104.10138912699995, -75.12078215899993],
              [-103.93114173099991, -75.15390390399995],
              [-103.81216386599993, -75.15300872199992],
              [-103.55406653549994, -75.11919524549992],
              [-103.29596920499995, -75.08538176899992],
              [-102.94625810449995, -75.10719166449994],
              [-102.59654700399994, -75.12900155999995],
              [-102.43887285099993, -75.1091447899999],
              [-102.34072831899994, -75.13046640399995],
              [-102.17223059799994, -75.1228166649999],
              [-102.07750403599994, -75.12957122199992],
              [-101.85928300699993, -75.10564544099992],
              [-101.78490149599992, -75.08407968499995],
              [-101.76073157499991, -75.08294036299992],
              [-101.65428626199991, -75.10035572699991],
              [-101.59862219999991, -75.11882903399993],
              [-101.56419837099992, -75.1467424459999],
              [-101.55304928299995, -75.17498137799993],
              [-101.55443274599992, -75.19670989399992],
              [-101.56745357999995, -75.21591562299994],
              [-101.59105383999992, -75.23707447699991],
              [-101.62230383999992, -75.25554778399993],
              [-101.63141842399995, -75.26279062299994],
              [-101.6382543609999, -75.27239348799992],
              [-101.64932206899994, -75.29509856599992],
              [-101.65684973899994, -75.30535247199992],
              [-101.53441321499992, -75.34832122199992],
              [-101.14858964799993, -75.37175872199992],
              [-101.16002356699994, -75.39381275799991],
              [-101.15477454299992, -75.41366952899995],
              [-101.1375219389999, -75.4275041649999],
              [-101.11270097599993, -75.43206145599993],
              [-101.02489173099991, -75.42050546699994],
              [-100.93984941299993, -75.42205169099992],
              [-100.62857011599993, -75.39169687299994],
              [-100.54670162699995, -75.36638762799993],
              [-100.43569902299993, -75.35051848799992],
              [-100.32388261599993, -75.35003020599993],
              [-100.22227942599994, -75.36012135199991],
              [-100.13744055899991, -75.38445403399993],
              [-100.10993404899995, -75.38640715899993],
              [-100.09585527299993, -75.38339609199994],
              [-100.0520727199999, -75.3669572899999],
              [-100.04015051999994, -75.36581796699994],
              [-100.01598059799994, -75.36712004999993],
              [-100.00454667899993, -75.36467864399992],
              [-99.97618567599994, -75.35540129999993],
              [-99.8316137359999, -75.3298479149999],
              [-99.43138587099992, -75.30339934699992],
              [-99.01431230399993, -75.33953215899993],
              [-99.00104732999995, -75.33668385199991],
              [-98.96031653599994, -75.32048919099992],
              [-98.94566809799994, -75.31707122199992],
              [-98.77204342399995, -75.32097747199992],
              [-98.64195716099994, -75.30950286299992],
              [-98.6265356109999, -75.30282968499995],
              [-98.59626217399995, -75.28199635199991],
              [-98.57933508999992, -75.27361419099992],
              [-98.56273352799991, -75.26962655999995],
              [-98.48119055899991, -75.25888437299994],
              [-98.40221106699994, -75.23642343499995],
              [-98.42983964799993, -75.21786874799994],
              [-98.4785863919999, -75.21559010199991],
              [-98.57140051999994, -75.22584400799991],
              [-98.7442113919999, -75.22454192499993],
              [-98.43431555899991, -75.13339609199994],
              [-98.54771887899994, -75.12346770599993],
              [-98.89907792899993, -75.17498137799993],
              [-98.92662512899994, -75.17253997199992],
              [-99.04002844999991, -75.14617278399993],
              [-99.3797094389999, -75.11272551899992],
              [-99.35260982999995, -75.09384530999995],
              [-99.33543860599991, -75.07634856599992],
              [-99.32787024599992, -75.05413176899992],
              [-99.32896887899994, -75.00701262799993],
              [-99.32310950399994, -74.9743791649999],
              [-99.32396399599992, -74.96257903399993],
              [-99.33409583199995, -74.95159270599993],
              [-99.38341223899994, -74.92669036299992],
              [-99.43846594999991, -74.91326262799993],
              [-99.60204016799992, -74.94654713299991],
              [-99.63048255099994, -74.94597747199992],
              [-99.74128170499995, -74.92489999799994],
              [-99.88442949099993, -74.92197030999995],
              [-100.10509192599994, -74.9431291649999],
              [-100.34105383999992, -74.92652760199991],
              [-100.5222875639999, -74.8908830709999],
              [-100.53636633999992, -74.88437265399995],
              [-100.54381262899994, -74.87371184699992],
              [-100.53693600199995, -74.85800546699994],
              [-100.5286352199999, -74.8552385399999],
              [-100.36310787699995, -74.84042734199994],
              [-100.3074438139999, -74.84303150799991],
              [-100.20384680899991, -74.86012135199991],
              [-100.14915930899991, -74.8591447899999],
              [-100.08336341099994, -74.84612395599993],
              [-100.05699622299994, -74.83196379999993],
              [-100.03197180899991, -74.80681731599992],
              [-100.01231848899994, -74.79566822699991],
              [-99.91930091099994, -74.7697893209999],
              [-99.96532141799992, -74.74480559699992],
              [-100.01060950399994, -74.73186614399992],
              [-100.1101781889999, -74.71624114399992],
              [-100.10708574099993, -74.71111419099992],
              [-100.07713782499991, -74.6911760399999],
              [-100.05125891799992, -74.67839934699992],
              [-100.03941809799994, -74.66920338299991],
              [-100.01789303299995, -74.64364999799994],
              [-100.04019120999993, -74.63738372199992],
              [-100.11343339799993, -74.63103606599992],
              [-100.08507239499994, -74.61077239399992],
              [-100.0528051419999, -74.60173919099992],
              [-99.87661699099993, -74.57732512799993],
              [-99.81578528599994, -74.53785572699991],
              [-99.8008520169999, -74.53671640399995],
              [-99.81672115799995, -74.52605559699992],
              [-99.83315995999993, -74.52223072699991],
              [-99.85049394399994, -74.52288176899992],
              [-99.86896725199995, -74.52597421699994],
              [-99.88194739499994, -74.52459075299993],
              [-99.91319739499994, -74.51189544099992],
              [-99.92813066299993, -74.50774504999993],
              [-100.00621497299994, -74.51116301899992],
              [-100.03197180899991, -74.50839609199994],
              [-100.04771887899994, -74.50261809699992],
              [-100.0926000639999, -74.47966887799993],
              [-100.11172441299993, -74.4748674459999],
              [-100.13072669199994, -74.47340260199991],
              [-100.24640865799995, -74.48967864399992],
              [-100.33047441299993, -74.48064544099992],
              [-100.39981035099993, -74.4826799459999],
              [-100.42247473899994, -74.47722747199992],
              [-100.43578040299991, -74.47568124799994],
              [-100.46532141799992, -74.48211028399993],
              [-100.47972571499992, -74.48333098799992],
              [-100.54100501199991, -74.48056405999995],
              [-100.59951738199993, -74.48455169099992],
              [-100.9273168609999, -74.5505510399999],
              [-101.39590410099993, -74.50269947699991],
              [-101.46263587099992, -74.47625090899993],
              [-101.41710364499994, -74.45525481599992],
              [-101.39590410099993, -74.44231536299992],
              [-101.37718665299991, -74.4255510399999],
              [-101.40355383999992, -74.4216447899999],
              [-101.42422441299993, -74.41277434699992],
              [-101.43431555899991, -74.39723072699991],
              [-101.42870032499991, -74.37428150799991],
              [-101.41193600199995, -74.35588958099993],
              [-101.3894750639999, -74.34392669099992],
              [-101.34227454299992, -74.32708098799992],
              [-101.30663001199991, -74.30657317499993],
              [-101.29832923099991, -74.29729583099993],
              [-101.29352779899995, -74.28476327899995],
              [-101.29503333199995, -74.27483489399992],
              [-101.30565344999991, -74.27288176899992],
              [-101.36554928299995, -74.28118254999993],
              [-101.42638098899994, -74.27996184699992],
              [-101.40611731699994, -74.26832447699991],
              [-101.38048255099994, -74.2580705709999],
              [-101.35993404899995, -74.24529387799993],
              [-101.35496985599991, -74.22576262799993],
              [-101.36546790299991, -74.19890715899993],
              [-101.38219153599994, -74.17595794099992],
              [-101.40501868399991, -74.16008879999993],
              [-101.43370520699995, -74.15447356599992],
              [-101.42711341099994, -74.12900155999995],
              [-101.43919837099992, -74.11646900799991],
              [-101.4871313139999, -74.10279713299991],
              [-101.51431230399993, -74.08945077899995],
              [-101.53514563699991, -74.07317473799992],
              [-101.54942786399994, -74.05193450299993],
              [-101.55679277299993, -74.02304452899995],
              [-101.58922278599994, -74.00017669099992],
              [-101.65835527299993, -73.99529387799993],
              [-101.7859594389999, -74.00351327899995],
              [-101.90143795499995, -73.99724700299993],
              [-102.06371008999992, -73.95745208099993],
              [-102.22940019399994, -73.96249765399995],
              [-102.39366614499994, -73.93181731599992],
              [-102.73326575399994, -73.93718840899993],
              [-102.84862219999991, -73.92156340899993],
              [-102.89639238199993, -73.9021135399999],
              [-102.92332923099991, -73.85751718499995],
              [-102.88272050699993, -73.81658294099992],
              [-102.82217363199993, -73.78004322699991],
              [-102.78897050699993, -73.74879322699991],
              [-102.80394446499992, -73.71697356599992],
              [-102.84609941299993, -73.70110442499993],
              [-102.96190344999991, -73.68629322699991],
              [-102.97826087099992, -73.68222421699994],
              [-102.98688717399995, -73.67498137799993],
              [-102.9871313139999, -73.65504322699991],
              [-102.98224850199995, -73.63665129999993],
              [-102.98265540299991, -73.62102629999993],
              [-102.99864661399994, -73.6096330709999],
              [-102.95099850199995, -73.58912525799991],
              [-102.88975989499994, -73.58554452899995],
              [-102.40086829349994, -73.61097584399994],
              [-101.91197669199994, -73.63640715899993],
              [-101.80052649599992, -73.66326262799993],
              [-101.38536536399994, -73.66716887799993],
              [-101.36034094999991, -73.6701799459999],
              [-101.27342688699991, -73.6955705709999],
              [-101.2637426419999, -73.70077890399995],
              [-101.25918535099993, -73.70916106599992],
              [-101.26097571499992, -73.72258879999993],
              [-101.26085364499994, -73.7385393209999],
              [-101.25059973899994, -73.7483049459999],
              [-101.23452714799993, -73.75457122199992],
              [-101.16392981699994, -73.77068450299993],
              [-100.89799964099993, -73.77642180799992],
              [-100.63206946499992, -73.78215911299992],
              [-100.62059485599991, -73.77898528399993],
              [-100.61204993399991, -73.77239348799992],
              [-100.59675045499995, -73.7536760399999],
              [-100.5872289699999, -73.74749114399992],
              [-100.57420813699991, -73.7458635399999],
              [-100.53355872299994, -73.75188567499993],
              [-100.51817786399994, -73.74911874799994],
              [-100.49889075399994, -73.73601653399993],
              [-100.48574785099993, -73.7302385399999],
              [-100.45860755099994, -73.72616952899995],
              [-100.16301428949993, -73.72962818799994],
              [-99.86742102799991, -73.73308684699992],
              [-99.66860917899993, -73.70240650799991],
              [-99.58454342399995, -73.70696379999993],
              [-99.55573482999995, -73.70110442499993],
              [-99.50059973899994, -73.68206145599993],
              [-99.47207597599993, -73.6755510399999],
              [-99.49864661399994, -73.66155364399992],
              [-99.58592688699991, -73.63486093499995],
              [-99.49730383999992, -73.61858489399992],
              [-99.21011308499993, -73.64421965899993],
              [-98.81436113199993, -73.63225676899992],
              [-98.85008704299992, -73.60418059699992],
              [-98.86774654899995, -73.59392669099992],
              [-98.89122473899994, -73.58847421699994],
              [-99.18824215399994, -73.56796640449994],
              [-99.48525956899994, -73.54745859199994],
              [-99.58771725199995, -73.52263762799993],
              [-99.5515844389999, -73.4997697899999],
              [-99.50234941299993, -73.48935312299994],
              [-99.4055883449999, -73.4865861959999],
              [-99.60024980399993, -73.44817473799992],
              [-99.63621985599991, -73.44784921699994],
              [-99.67174231699994, -73.45419687299994],
              [-99.69994055899991, -73.46542734199994],
              [-99.7149145169999, -73.46770598799992],
              [-99.72752844999991, -73.46200937299994],
              [-99.73045813699991, -73.44841887799993],
              [-99.71349036399994, -73.41529713299991],
              [-99.71133378799993, -73.39885833099993],
              [-99.7200414699999, -73.38339609199994],
              [-99.73412024599992, -73.37297942499993],
              [-99.75104732999995, -73.3669572899999],
              [-99.76805579299992, -73.36419036299992],
              [-100.21882076699991, -73.35263437333326],
              [-100.66958574099992, -73.34107838366658],
              [-101.12035071499992, -73.32952239399992],
              [-101.21263587099992, -73.31536223799992],
              [-101.69420325399994, -73.33587004999993],
              [-101.85659745999993, -73.3044572899999],
              [-102.22960364499994, -73.31760019349991],
              [-102.60260982999995, -73.33074309699992],
              [-102.87364661399994, -73.30820077899995],
              [-102.88589433499993, -73.30364348799992],
              [-102.89342200399994, -73.29697030999995],
              [-102.90021725199995, -73.28915780999995],
              [-102.91014563699991, -73.2810197899999],
              [-102.98688717399995, -73.23796965899993],
              [-103.04405676999994, -73.22454192499993],
              [-103.1175024079999, -73.18596770599993],
              [-103.1477758449999, -73.17734140399995],
              [-103.24693762899994, -73.17083098799992],
              [-103.2664281889999, -73.16725025799991],
              [-103.28831946499992, -73.15935637799993],
              [-103.3067113919999, -73.14714934699992],
              [-103.31590735599991, -73.13095468499995],
              [-103.30748450399994, -73.11630624799994],
              [-103.28506425699993, -73.10100676899992],
              [-103.2395727199999, -73.07781340899993],
              [-103.24998938699991, -73.06804778399993],
              [-103.26162675699993, -73.05966562299994],
              [-103.27440344999991, -73.05291106599992],
              [-103.28783118399991, -73.04778411299992],
              [-103.28294837099992, -73.03655364399992],
              [-103.27684485599991, -73.02581145599993],
              [-103.26134192599994, -73.00660572699991],
              [-103.31200110599991, -72.9787736959999],
              [-103.33385169199994, -72.96152109199994],
              [-103.35460364499994, -72.9397111959999],
              [-103.38565019399994, -72.88730234199994],
              [-103.40379798099991, -72.8635393209999],
              [-103.42992102799991, -72.8493791649999],
              [-103.33433997299994, -72.77459075299993],
              [-103.29857337099992, -72.7575822899999],
              [-103.04141191299993, -72.70761484199994],
              [-102.68500729049993, -72.72283294099992],
              [-102.32860266799992, -72.7380510399999],
              [-102.26992753799993, -72.75465260199991],
              [-102.09398352799991, -72.7717424459999],
              [-102.11620032499991, -72.78289153399993],
              [-102.14964758999992, -72.7946916649999],
              [-102.16881262899994, -72.80982838299991],
              [-102.14830481699994, -72.83049895599993],
              [-102.15855872299994, -72.84107838299991],
              [-102.17048092399995, -72.84978606599992],
              [-102.18358313699991, -72.85637786299992],
              [-102.19766191299993, -72.86060963299991],
              [-102.16120357999995, -72.88030364399992],
              [-102.18862870999993, -72.89446379999993],
              [-102.2598363919999, -72.90162525799991],
              [-102.29185950399994, -72.90894947699991],
              [-102.30736243399991, -72.91765715899993],
              [-102.32042395699995, -72.92693450299993],
              [-102.33389238199993, -72.93466562299994],
              [-102.3511449859999, -72.93840911299992],
              [-102.42756100199995, -72.94036223799992],
              [-102.43993079299992, -72.9431291649999],
              [-102.46979732999995, -72.95769622199992],
              [-102.48485266799992, -72.96209075299993],
              [-102.5542699859999, -72.96347421699994],
              [-102.71690833199995, -72.99773528399993],
              [-102.67674719999991, -73.00530364399992],
              [-102.37669837149991, -72.99187590949992],
              [-102.07664954299992, -72.97844817499993],
              [-101.98399817599994, -72.98699309699992],
              [-101.99705969999991, -73.03972747199992],
              [-101.96031653599994, -73.05559661299992],
              [-101.67876135999992, -73.03451913899991],
              [-101.39720618399991, -73.0134416649999],
              [-101.31017005099994, -72.99081796699994],
              [-101.03805497949995, -72.98341236799993],
              [-100.76593990799995, -72.97600676899992],
              [-100.65868079299992, -73.01051197699991],
              [-100.37686113199993, -73.06585051899992],
              [-100.31826738199993, -73.06878020599993],
              [-100.26227779899995, -73.06064218499995],
              [-100.14195716099994, -73.02263762799993],
              [-100.11278235599991, -73.01897551899992],
              [-100.02326412699995, -73.02402109199994],
              [-99.8535863919999, -72.99553801899992],
              [-99.68224036399994, -73.01726653399993],
              [-99.19103959899994, -73.01928069424993],
              [-98.69983883399993, -73.02129485449993],
              [-98.20863806899993, -73.02330901474993],
              [-97.71743730399993, -73.02532317499993],
              [-97.80223548099991, -73.09189218499995],
              [-97.83543860599991, -73.11044687299994],
              [-97.98119055899991, -73.16936614399992],
              [-97.92882239499994, -73.18840911299992],
              [-97.87328040299991, -73.19915129999993],
              [-97.81663977799991, -73.20126718499995],
              [-97.76113847599993, -73.19410572699991],
              [-97.60260982999995, -73.13616301899992],
              [-97.45018469999991, -73.12371184699992],
              [-97.41885331899994, -73.12493254999993],
              [-97.33507239499994, -73.14934661299992],
              [-97.30825761599993, -73.15007903399993],
              [-97.28392493399991, -73.14763762799993],
              [-97.25438391799992, -73.14812590899993],
              [-97.22573808499993, -73.15309010199991],
              [-97.18065344999991, -73.18027109199994],
              [-97.15656490799995, -73.18596770599993],
              [-96.99209550699993, -73.19198984199994],
              [-96.96320553299995, -73.20134856599992],
              [-96.91209876199991, -73.22918059699992],
              [-96.70506751199991, -73.2673479149999],
              [-96.58828691299993, -73.27605559699992],
              [-96.47496497299994, -73.29949309699992],
              [-96.15882320849994, -73.31548430799992],
              [-95.84268144399994, -73.33147551899992],
              [-95.83128821499992, -73.32496510199991],
              [-95.82119706899994, -73.31210702899995],
              [-95.80524654899995, -73.28443775799991],
              [-95.79458574099993, -73.2756486959999],
              [-95.74657141799992, -73.25505950299993],
              [-95.68858801999994, -73.2443986959999],
              [-95.51134192599994, -73.24480559699992],
              [-95.39622962099992, -73.22372812299994],
              [-95.33861243399991, -73.22014739399992],
              [-95.27830969999991, -73.22714609199994],
              [-95.26789303299995, -73.22616952899995],
              [-95.24547278599994, -73.21493905999995],
              [-95.23379472599993, -73.21103280999995],
              [-95.19375566299993, -73.20907968499995],
              [-95.00316321499992, -73.24407317499993],
              [-94.57799231699994, -73.23552825299993],
              [-94.53115800699993, -73.24602629999993],
              [-94.38703365799995, -73.30934010199991],
              [-94.33580481699994, -73.32154713299991],
              [-94.13101152299993, -73.31259530999995],
              [-93.93590247299994, -73.27947356599992],
              [-93.79881751199991, -73.22275155999995],
              [-93.77432206899994, -73.21624114399992],
              [-93.74860592399995, -73.21257903399993],
              [-93.69701087099992, -73.21233489399992],
              [-93.65550696499992, -73.22193775799991],
              [-93.63426673099991, -73.22380950299993],
              [-93.61628170499995, -73.2165666649999],
              [-93.61070716099994, -73.2087541649999],
              [-93.60464433499993, -73.19068775799991],
              [-93.59902910099993, -73.18303801899992],
              [-93.58702551999994, -73.17742278399993],
              [-93.57164466099994, -73.17522551899992],
              [-93.29716956299993, -73.18417734199991],
              [-93.02269446499992, -73.1931291649999],
              [-92.96971594999991, -73.17962004999993],
              [-92.91722571499992, -73.17302825299993],
              [-92.8640844389999, -73.15520598799992],
              [-92.80138098899994, -73.14275481599992],
              [-92.78929602799991, -73.14324309699992],
              [-92.76984615799995, -73.14910247199992],
              [-92.76183020699995, -73.15740325299993],
              [-92.75572669199994, -73.16741301899992],
              [-92.74229895699995, -73.17831796699994],
              [-92.7183324859999, -73.18377044099992],
              [-92.5398656889999, -73.16611093499995],
              [-92.2468562489999, -73.17530689899993],
              [-91.95384680899991, -73.18450286299992],
              [-91.9336645169999, -73.1911760399999],
              [-91.92491614499994, -73.20256926899992],
              [-91.92308508999992, -73.21404387799993],
              [-91.91930091099994, -73.22421640399995],
              [-91.85635331899994, -73.25212981599992],
              [-91.84361731699994, -73.25505950299993],
              [-91.66299394399994, -73.24521249799994],
              [-91.38892574749994, -73.27296314899993],
              [-91.11485755099994, -73.30071379999993],
              [-91.10350501199991, -73.30348072699991],
              [-91.09707597599993, -73.31121184699992],
              [-91.09434973899994, -73.32724374799994],
              [-91.08901933499993, -73.33464934699992],
              [-91.07738196499992, -73.33660247199992],
              [-90.75991777299993, -73.30820077899995],
              [-90.64891516799992, -73.2776018209999],
              [-90.62319902299993, -73.27581145599993],
              [-90.55955969999991, -73.28378671699994],
              [-90.53429114499994, -73.28020598799992],
              [-90.36042232999995, -73.22275155999995],
              [-90.2950557019999, -73.19174653199991],
              [-90.20669511599993, -73.14983489399992],
              [-90.1868383449999, -73.14324309699992],
              [-90.16079667899993, -73.13974374799994],
              [-90.07030188699991, -73.14299895599993],
              [-89.94684811099995, -73.1272111959999],
              [-89.90074622299994, -73.12761809699992],
              [-89.79967200399994, -73.14373137799993],
              [-89.74559485599991, -73.14226653399993],
              [-89.53673255099994, -73.10426197699991],
              [-89.51203365799995, -73.10540129999993],
              [-89.44318600199995, -73.1208635399999],
              [-89.28380286399994, -73.10662200299993],
              [-89.23029537699995, -73.11126067499993],
              [-89.26081295499995, -73.08806731599992],
              [-89.28172766799992, -73.06259530999995],
              [-89.28001868399991, -73.03769296699994],
              [-89.24258378799993, -73.01677825299993],
              [-89.0879613919999, -72.96005624799994],
              [-89.07648678299995, -72.95330169099992],
              [-89.06175696499992, -72.94133879999993],
              [-89.05406653599994, -72.92913176899992],
              [-89.06358801999994, -72.92156340899993],
              [-89.10631262899994, -72.91334400799991],
              [-89.11925208199995, -72.90252044099992],
              [-89.11839758999992, -72.88209400799991],
              [-89.10680091099994, -72.82634856599992],
              [-89.09951738199993, -72.8083635399999],
              [-89.11050370999993, -72.76433684699992],
              [-89.17137610599991, -72.73056405999995],
              [-89.35826575399994, -72.67701588299991],
              [-89.42471269399994, -72.64348723799992],
              [-89.34850012899994, -72.6345354149999],
              [-88.97350012899994, -72.66046857466658],
              [-88.59850012899994, -72.68640173433324],
              [-88.22350012899994, -72.71233489399992],
              [-88.17349199099993, -72.73211028399993],
              [-88.13890540299991, -72.76213958099993],
              [-88.13121497299994, -72.78329843499995],
              [-88.12852942599994, -72.80527109199994],
              [-88.12352454299992, -72.8259416649999],
              [-88.10875403599994, -72.84335702899995],
              [-88.19570878799993, -72.87664153399993],
              [-88.28612219999991, -72.89959075299993],
              [-88.36485755099994, -72.90886809699992],
              [-88.4063207669999, -72.91838958099993],
              [-88.43358313699991, -72.93596770599993],
              [-88.44123287699995, -72.95614999799994],
              [-88.43276933499993, -72.96941497199992],
              [-88.39366614499994, -72.9904924459999],
              [-88.41930091099994, -73.02109140399995],
              [-88.45539303299995, -73.03826262799993],
              [-88.71401933499993, -73.11980559699992],
              [-88.70421301999994, -73.12704843499995],
              [-88.6106664699999, -73.14918385199991],
              [-88.56639563699991, -73.16529713299991],
              [-88.53563391799992, -73.18710702899995],
              [-88.47834225199995, -73.24293385199991],
              [-88.44383704299992, -73.26360442499993],
              [-88.40689042899993, -73.27060312299994],
              [-88.36913001199991, -73.2658830709999],
              [-88.26305091099994, -73.22039153399993],
              [-88.22972571499992, -73.21282317499993],
              [-88.1868383449999, -73.20891692499993],
              [-88.15233313699991, -73.20989348799992],
              [-88.11807206899994, -73.21453215899993],
              [-88.10252844999991, -73.22031015399995],
              [-88.07461503799993, -73.2385393209999],
              [-88.05776933499993, -73.24342213299991],
              [-87.92149817599994, -73.25269947699991],
              [-87.88560950399994, -73.24651458099993],
              [-87.82477779899995, -73.22112395599993],
              [-87.64879309799994, -73.19451262799993],
              [-87.50495357999995, -73.20110442499993],
              [-87.47044837099992, -73.19605885199991],
              [-87.36754309799994, -73.16952890399995],
              [-87.34951738199993, -73.16961028399993],
              [-87.3321020169999, -73.17400481599992],
              [-87.3235570949999, -73.18425872199992],
              [-87.33234615799995, -73.20208098799992],
              [-87.34561113199993, -73.21282317499993],
              [-87.36034094999991, -73.2190080709999],
              [-87.39366614499994, -73.22625090899993],
              [-87.35830644399994, -73.2561174459999],
              [-87.3184301419999, -73.26864999799994],
              [-87.1817113919999, -73.27752044099992],
              [-87.13451087099992, -73.28720468499995],
              [-87.11074785099993, -73.30974700299993],
              [-87.13345292899993, -73.35247161299992],
              [-87.08999589799993, -73.36712004999993],
              [-87.04133053299995, -73.3772111959999],
              [-86.94652258999992, -73.38355885199991],
              [-86.66661536399994, -73.37200286299992],
              [-86.59459387899994, -73.34880950299993],
              [-86.46035722599993, -73.33733489399992],
              [-86.43370520699995, -73.32773202899995],
              [-86.41388912699995, -73.31194426899992],
              [-86.38548743399991, -73.27459075299993],
              [-86.36774654899995, -73.26279062299994],
              [-86.34349524599992, -73.25798919099992],
              [-86.31700598899994, -73.25798919099992],
              [-86.29141191299993, -73.26311614399992],
              [-86.27013098899994, -73.27361419099992],
              [-86.24925696499992, -73.27988046699994],
              [-86.22227942599994, -73.2776018209999],
              [-86.07119706899994, -73.24732838299991],
              [-85.98607337099992, -73.20183684699992],
              [-85.88683020699995, -73.17693450299993],
              [-85.78258216099994, -73.16912200299993],
              [-85.67861894399994, -73.1775041649999],
              [-85.58039303299995, -73.20045338299991],
              [-85.64395097599993, -73.21355559699992],
              [-85.65859941299993, -73.22210051899992],
              [-85.66856848899994, -73.24114348799992],
              [-85.66490637899994, -73.25505950299993],
              [-85.65257727799991, -73.26458098799992],
              [-85.61042232999995, -73.27662525799991],
              [-85.59471594999991, -73.2834611959999],
              [-85.58458411399994, -73.29631926899992],
              [-85.57530676999994, -73.32073333099993],
              [-85.56407630099994, -73.33489348799992],
              [-85.54531816299993, -73.34295012799993],
              [-85.50373287699995, -73.35295989399992],
              [-85.54287675699993, -73.37184010199991],
              [-85.53160559799994, -73.38534921699994],
              [-85.51667232999995, -73.38787200299993],
              [-85.49982662699995, -73.38762786299992],
              [-85.48298092399995, -73.39267343499995],
              [-85.45913652299993, -73.40569426899992],
              [-85.43984941299993, -73.41008879999993],
              [-85.4199926419999, -73.40683359199994],
              [-85.39419511599993, -73.39690520599993],
              [-85.36717688699991, -73.39202239399992],
              [-85.33950761599993, -73.3962541649999],
              [-85.22940019399994, -73.44068775799991],
              [-85.16930091099994, -73.45663827899995],
              [-85.10147050699993, -73.48707447699991],
              [-85.0540258449999, -73.49163176899992],
              [-85.00942949099993, -73.50269947699991],
              [-84.91917883999992, -73.51327890399995],
              [-84.85033118399991, -73.53232187299994],
              [-84.46690833199995, -73.56943124799994],
              [-84.17747962099992, -73.55722421699994],
              [-84.13353430899991, -73.54998137799993],
              [-84.11302649599992, -73.54957447699991],
              [-84.04100501199991, -73.56796640399995],
              [-84.01911373599995, -73.56503671699994],
              [-83.97264563699991, -73.54989999799994],
              [-83.94896399599992, -73.54599374799994],
              [-83.92772376199991, -73.54900481599992],
              [-83.88585364499994, -73.5627580709999],
              [-83.86461341099994, -73.56536223799992],
              [-83.75169837099992, -73.56023528399993],
              [-83.7520238919999, -73.61256275799991],
              [-83.75975501199991, -73.63494231599992],
              [-83.78526770699995, -73.64202239399992],
              [-83.8118383449999, -73.64120859199994],
              [-83.83608964799993, -73.64495208099993],
              [-83.85903886599993, -73.65341562299994],
              [-83.88158118399991, -73.66668059699992],
              [-83.86660722599993, -73.67913176899992],
              [-83.82713782499991, -73.68564218499995],
              [-83.80874589799993, -73.69378020599993],
              [-83.81314042899993, -73.6970354149999],
              [-83.8176977199999, -73.70891692499993],
              [-83.8203832669999, -73.72283294099992],
              [-83.81920325399994, -73.73284270599993],
              [-83.80931555899991, -73.74130624799994],
              [-83.79670162699995, -73.74358489399992],
              [-83.69102942599994, -73.72665780999995],
              [-83.66576087099992, -73.72844817499993],
              [-83.65733801999994, -73.73398202899995],
              [-83.64061438699991, -73.75074635199991],
              [-83.6316625639999, -73.7522111959999],
              [-83.57835852799991, -73.7346330709999],
              [-83.55345618399991, -73.73064544099992],
              [-83.54320227799991, -73.73251718499995],
              [-83.53026282499991, -73.73837655999995],
              [-83.51919511599993, -73.73707447699991],
              [-83.50767981699994, -73.72673919099992],
              [-83.48863684799994, -73.70191822699991],
              [-83.45010331899994, -73.68523528399993],
              [-83.39614824099993, -73.68759530999995],
              [-83.29576575399994, -73.70614999799994],
              [-82.93370520699995, -73.71038176899992],
              [-82.71426347599993, -73.74423593499995],
              [-82.67398027299993, -73.77011484199994],
              [-82.64948482999995, -73.77166106599992],
              [-82.60118567599994, -73.76873137799993],
              [-82.34829667899993, -73.82634856599992],
              [-82.27489173099991, -73.8596330709999],
              [-82.20921790299991, -73.88005950299993],
              [-82.13707434799994, -73.88974374799994],
              [-82.06476803299995, -73.8869768209999],
              [-81.99840247299994, -73.87037525799991],
              [-81.91515051999994, -73.82626718499995],
              [-81.89268958199995, -73.81829192499993],
              [-81.87303626199991, -73.81780364399992],
              [-81.7884008449999, -73.82756926899992],
              [-81.70718339799993, -73.82683684699992],
              [-81.23399817599994, -73.7302385399999],
              [-81.18468176999994, -73.70419687299994],
              [-81.14683997299994, -73.66594817499993],
              [-81.12559973899994, -73.6213518209999],
              [-81.11164303299995, -73.60442473799992],
              [-81.08625240799995, -73.59449635199991],
              [-81.11546790299991, -73.56951262799993],
              [-81.15501868399991, -73.55510833099993],
              [-81.23631751199991, -73.53639088299991],
              [-81.27257239499994, -73.5217424459999],
              [-81.30626380099994, -73.50212981599992],
              [-81.32823645699995, -73.48007577899995],
              [-81.33551998599995, -73.4572893209999],
              [-81.3321020169999, -73.43320077899995],
              [-81.31094316299993, -73.37737395599993],
              [-81.30947831899994, -73.35361093499995],
              [-81.32266191299993, -73.33562590899993],
              [-81.35545813699991, -73.32382577899995],
              [-81.31118730399993, -73.27304452899995],
              [-81.23468990799995, -73.24797942499993],
              [-81.14928137899994, -73.23992278399993],
              [-80.81017005099994, -73.26311614399992],
              [-80.77456620999993, -73.27597421699994],
              [-80.7605688139999, -73.28557708099993],
              [-80.7395727199999, -73.30730559699992],
              [-80.72740637899994, -73.31698984199994],
              [-80.70929928299995, -73.32439544099992],
              [-80.61196855399993, -73.3337541649999],
              [-80.39378821499992, -73.41423919099992],
              [-80.27139238199993, -73.42253997199992],
              [-80.23253333199995, -73.41765715899993],
              [-80.19684811099995, -73.40195077899995],
              [-80.22545325399994, -73.39959075299993],
              [-80.32469641799992, -73.36256275799991],
              [-80.35179602799991, -73.3454729149999],
              [-80.35692298099991, -73.33416106599992],
              [-80.35732988199993, -73.32382577899995],
              [-80.35667883999992, -73.31308359199994],
              [-80.35814368399991, -73.30095794099992],
              [-80.36384029899995, -73.28639088299991],
              [-80.41787675699993, -73.20794036299992],
              [-80.43675696499992, -73.18816497199992],
              [-80.46426347599993, -73.17376067499993],
              [-80.50694739499994, -73.16033294099992],
              [-80.51939856699994, -73.15325286299992],
              [-80.55215410099993, -73.11630624799994],
              [-80.56419837099992, -73.10979583099993],
              [-80.62376868399991, -73.09823984199994],
              [-80.65099036399994, -73.08440520599993],
              [-80.65880286399994, -73.06194426899992],
              [-80.65859941299993, -73.04599374799994],
              [-80.66266842399995, -73.03427499799994],
              [-80.66437740799995, -73.02288176899992],
              [-80.65709387899994, -73.0080705709999],
              [-80.64647376199991, -72.99675872199992],
              [-80.63418535099993, -72.98748137799993],
              [-80.62071692599994, -72.98007577899995],
              [-80.60631262899994, -72.97478606599992],
              [-80.49254309799994, -72.95330169099992],
              [-80.37767493399991, -72.94996510199991],
              [-80.01256262949991, -72.99431731549993],
              [-79.64745032499991, -73.03866952899995],
              [-79.62559973899994, -73.04851653399993],
              [-79.58141028599994, -73.07952239399992],
              [-79.23253333199995, -73.1955705709999],
              [-79.14256751199991, -73.24724700299993],
              [-79.09227454299992, -73.26531340899993],
              [-78.99201412699995, -73.28679778399993],
              [-78.93492591099994, -73.28948333099993],
              [-78.91860917899993, -73.2927385399999],
              [-78.88133704299992, -73.3108049459999],
              [-78.78189042899993, -73.33798593499995],
              [-78.74404863199993, -73.36492278399993],
              [-78.74250240799995, -73.41334400799991],
              [-78.7637426419999, -73.44548919099992],
              [-78.79308020699995, -73.46697356599992],
              [-78.82461503799993, -73.48512135199991],
              [-78.85260982999995, -73.50750090899993],
              [-78.86050370999993, -73.51962655999995],
              [-78.86082923099991, -73.52792734199994],
              [-78.85838782499991, -73.53443775799991],
              [-78.85814368399991, -73.54159921699994],
              [-78.87181555899991, -73.58318450299993],
              [-78.86742102799991, -73.59929778399993],
              [-78.84496008999992, -73.60881926899992],
              [-78.78270423099991, -73.61174895599993],
              [-78.58462480399993, -73.58212655999995],
              [-78.52892005099994, -73.56064218499995],
              [-78.50137285099993, -73.55657317499993],
              [-78.2012426419999, -73.55632903399993],
              [-77.97325598899994, -73.52353280999995],
              [-77.85187740799995, -73.52255624799994],
              [-77.53115800699993, -73.46746184699992],
              [-77.50084387899994, -73.4665666649999],
              [-77.44196529899995, -73.47234465899993],
              [-77.36046301999994, -73.50359465899993],
              [-77.33120683499993, -73.50839609199994],
              [-77.24404863199993, -73.51262786299992],
              [-77.21458899599992, -73.50920989399992],
              [-77.16087805899991, -73.49277109199994],
              [-77.11025956899994, -73.47063567499993],
              [-77.07921301999994, -73.46249765399995],
              [-76.87975012899994, -73.45859140399995],
              [-76.84666907499991, -73.46493905999995],
              [-76.78010006399995, -73.48902760199991],
              [-76.71825110599991, -73.52353280999995],
              [-76.69871985599991, -73.54753997199992],
              [-76.70547441299993, -73.57154713299991],
              [-76.72817949099993, -73.59172942499993],
              [-76.94090735599991, -73.66790129999993],
              [-76.95523027299993, -73.67766692499993],
              [-76.98184160099993, -73.70045338299991],
              [-76.99478105399993, -73.70867278399993],
              [-77.24242102799991, -73.81243254999993],
              [-77.20588131399995, -73.8342424459999],
              [-77.12242591099994, -73.87078215899993],
              [-77.08079993399991, -73.87932708099993],
              [-77.04849199099993, -73.87835051899992],
              [-77.01976477799991, -73.87070077899995],
              [-76.93130449099993, -73.83269622199992],
              [-76.77830969999991, -73.79029713299991],
              [-76.60387122299994, -73.7873674459999],
              [-76.57860266799992, -73.79021575299993],
              [-76.53453528599994, -73.8108049459999],
              [-76.5098363919999, -73.81585051899992],
              [-76.30284583199995, -73.82341887799993],
              [-76.27721106699994, -73.82089609199994],
              [-76.26353919199994, -73.81414153399993],
              [-76.23810787699995, -73.79363372199992],
              [-76.22459876199991, -73.78590260199991],
              [-76.21174068899995, -73.78281015399995],
              [-75.96605383999992, -73.75164153399993],
              [-75.95274817599994, -73.74578215899993],
              [-75.94082597599993, -73.73845794099992],
              [-75.92393958199995, -73.73121510199991],
              [-75.89781653599994, -73.72714609199994],
              [-75.81607011599993, -73.73064544099992],
              [-75.70726477799991, -73.71209075299993],
              [-75.67870032499991, -73.71054452899995],
              [-75.59337317599994, -73.71591562299994],
              [-75.56069902299993, -73.71379973799992],
              [-75.53294837099992, -73.70810312299994],
              [-75.35667883999992, -73.63551197699991],
              [-75.31273352799991, -73.62493254999993],
              [-75.26813717399995, -73.62118905999995],
              [-74.90762285099993, -73.6423479149999],
              [-74.78172766799992, -73.66920338299991],
              [-74.73802649599992, -73.68816497199992],
              [-74.70152747299994, -73.71477629999993],
              [-74.66283118399991, -73.73528411299992],
              [-74.61229407499991, -73.7360979149999],
              [-74.51280676999994, -73.71689218499995],
              [-74.49185136599993, -73.70769622199992],
              [-74.45372473899994, -73.68499114399992],
              [-74.43333899599992, -73.67587655999995],
              [-74.41161048099991, -73.67156340899993],
              [-74.3411352199999, -73.67351653399993],
              [-74.27717037699995, -73.66269296699994],
              [-74.25780188699991, -73.66545989399992],
              [-74.10513261599993, -73.71607838299991],
              [-74.02529863199993, -73.72389088299991],
              [-73.94912675699993, -73.70964934699992],
              [-73.86351477799991, -73.66659921699994],
              [-73.80264238199993, -73.65862395599993],
              [-73.76943925699993, -73.6486955709999],
              [-73.73863684799994, -73.63404713299991],
              [-73.68651282499991, -73.58904387799993],
              [-73.65729732999995, -73.58326588299991],
              [-73.62669837099992, -73.59270598799992],
              [-73.59203040299991, -73.6110979149999],
              [-73.59919186099995, -73.62802499799994],
              [-73.58946692599994, -73.64031340899993],
              [-73.57286536399994, -73.64519622199992],
              [-73.55907141799992, -73.64055754999993],
              [-73.51520748599995, -73.59392669099992],
              [-73.49746660099993, -73.58196379999993],
              [-73.45042883999992, -73.56503671699994],
              [-73.40518144399994, -73.56259530999995],
              [-73.31029212099992, -73.56959400799991],
              [-73.22850501199991, -73.55974700299993],
              [-73.20714270699995, -73.54843515399995],
              [-73.15819251199991, -73.48406340899993],
              [-73.13906816299993, -73.46892669099992],
              [-73.11876380099994, -73.45769622199992],
              [-73.09683183499993, -73.44980234199994],
              [-73.07310950399994, -73.44443124799994],
              [-72.82892818899995, -73.44378020599993],
              [-72.64342200399994, -73.46965911299992],
              [-72.51353919199994, -73.46087004999993],
              [-72.42906653599994, -73.46998463299991],
              [-72.38451087099992, -73.46982187299994],
              [-72.35578365799995, -73.45403411299992],
              [-72.41734778599994, -73.43613046699994],
              [-72.23924719999991, -73.38884856599992],
              [-72.00161699099993, -73.3733049459999],
              [-71.86363684799994, -73.37883879999993],
              [-71.7493383449999, -73.35165780999995],
              [-71.54238847599993, -73.36126067499993],
              [-71.42296301999994, -73.3537736959999],
              [-71.06200110599991, -73.26637135199991],
              [-70.88292395699995, -73.25603606599992],
              [-70.50772050699993, -73.27548593499995],
              [-70.45287024599992, -73.26873137799993],
              [-70.42642167899993, -73.26921965899993],
              [-70.34675045499995, -73.29045989399992],
              [-70.3184301419999, -73.29485442499993],
              [-70.29295813699991, -73.29338958099993],
              [-69.91885331899994, -73.2185197899999],
              [-69.62791907449994, -73.19931406049992],
              [-69.33698482999995, -73.18010833099993],
              [-68.91673743399991, -73.10361093499995],
              [-68.84154212099992, -73.11223723799992],
              [-68.77969316299993, -73.10800546699994],
              [-68.66734778599994, -73.0881486959999],
              [-68.64488684799994, -73.07976653399993],
              [-68.62083899599992, -73.06519947699991],
              [-68.59675045499995, -73.05738697699991],
              [-68.53750566299993, -73.05380624799994],
              [-68.46686764199995, -73.01572030999995],
              [-68.20468095599995, -72.97193775799994],
              [-67.94249426999994, -72.92815520599993],
              [-67.91307532499991, -72.91806405999995],
              [-67.83690344999991, -72.86956145599993],
              [-67.78892981699994, -72.85369231599992],
              [-67.76402747299994, -72.85068124799994],
              [-67.73875891799992, -72.85214609199994],
              [-67.71328691299993, -72.86012135199991],
              [-67.68814042899993, -72.87118905999995],
              [-67.66270911399994, -72.87786223799992],
              [-67.63621985599991, -72.87273528399993],
              [-67.60952714799993, -72.86077239399992],
              [-67.58682206899994, -72.8532854149999],
              [-67.53555253799993, -72.84514739399992],
              [-67.51109778599994, -72.83407968499995],
              [-67.51520748599995, -72.81454843499995],
              [-67.52896074099993, -72.79094817499993],
              [-67.53380286399994, -72.76816171699994],
              [-67.52940833199995, -72.76555754999993],
              [-67.50723222599993, -72.74098072699991],
              [-67.50405839799993, -72.73642343499995],
              [-67.49278723899994, -72.7302385399999],
              [-67.45295162699995, -72.71412525799991],
              [-67.37531490799995, -72.66464609199994],
              [-67.26642818899995, -72.62102629999993],
              [-67.22191321499992, -72.59368254999993],
              [-67.22061113199993, -72.58733489399992],
              [-67.21841386599993, -72.55396900799991],
              [-67.21996008999992, -72.51864999799994],
              [-67.21841386599993, -72.5002580709999],
              [-67.20881100199995, -72.4826799459999],
              [-67.18956458199995, -72.4611955709999],
              [-67.15127519399994, -72.42888762799993],
              [-67.13857988199993, -72.42327239399992],
              [-67.09536699099993, -72.41277434699992],
              [-67.08381100199995, -72.40691497199992],
              [-67.05284583199995, -72.38079192499993],
              [-66.99941972599993, -72.36248137799993],
              [-66.97826087099992, -72.34954192499993],
              [-66.97252356699994, -72.30828215899993],
              [-66.95738684799994, -72.29900481599992],
              [-66.93919837099992, -72.29143645599993],
              [-66.92804928299995, -72.27752044099992],
              [-66.92772376199991, -72.26140715899993],
              [-66.93024654899995, -72.2483049459999],
              [-66.92951412699995, -72.23626067499993],
              [-66.91942298099991, -72.22380950299993],
              [-66.90274003799993, -72.21331145599993],
              [-66.81224524599992, -72.1716447899999],
              [-66.79051673099991, -72.15740325299993],
              [-66.77171790299991, -72.13925546699994],
              [-66.75084387899994, -72.1130510399999],
              [-66.74795488199993, -72.0920549459999],
              [-66.76113847599993, -72.06991952899995],
              [-66.77814693899995, -72.0471330709999],
              [-66.78648841099994, -72.02532317499993],
              [-66.77904212099992, -71.98544687299994],
              [-66.78164628799993, -71.9743791649999],
              [-66.79214433499993, -71.96062590899993],
              [-66.80016028599994, -71.95549895599993],
              [-66.80968176999994, -71.9533830709999],
              [-66.82506262899994, -71.94801197699991],
              [-66.83893795499995, -71.94540780999995],
              [-66.84870357999995, -71.94670989399992],
              [-66.85570227799991, -71.94459400799991],
              [-66.86115475199995, -71.93157317499993],
              [-66.86546790299991, -71.91472747199992],
              [-66.86929277299993, -71.90748463299991],
              [-66.89004472599993, -71.89812590899993],
              [-66.91657467399995, -71.89031340899993],
              [-66.97069251199991, -71.88600025799991],
              [-66.99502519399994, -71.87712981599992],
              [-67.18126380099994, -71.76685963299991],
              [-67.16222083199995, -71.76132577899995],
              [-67.10289466099994, -71.75302499799994],
              [-67.14216061099995, -71.72258879999993],
              [-67.42414303299995, -71.62053801899992],
              [-67.48131262899994, -71.58709075299993],
              [-67.50108801999994, -71.54029713299991],
              [-67.5247289699999, -71.5075822899999],
              [-67.57848059799994, -71.4743791649999],
              [-67.62262936099995, -71.4333635399999],
              [-67.61742102799991, -71.3772111959999],
              [-67.60114498599995, -71.35320403399993],
              [-67.59186764199995, -71.34343840899993],
              [-67.56700598899994, -71.32561614399992],
              [-67.53624426999994, -71.29615650799991],
              [-67.49909420499995, -71.28085702899995],
              [-67.49046790299991, -71.27239348799992],
              [-67.48192298099991, -71.2580705709999],
              [-67.47297115799995, -71.2483049459999],
              [-67.46108964799993, -71.24228280999995],
              [-67.44395911399994, -71.23894622199992],
              [-67.4583227199999, -71.22226327899995],
              [-67.48648027299993, -71.21306731599992],
              [-67.54458574099993, -71.20745208099993],
              [-67.52306067599994, -71.19882577899995],
              [-67.45815995999993, -71.18987395599993],
              [-67.46727454299992, -71.16725025799991],
              [-67.50666256399995, -71.13144296699994],
              [-67.51402747299994, -71.11126067499993],
              [-67.49840247299994, -71.09075286299992],
              [-67.46572831899994, -71.07854583099993],
              [-67.40143795499995, -71.07048919099992],
              [-67.42088782499991, -71.05535247199992],
              [-67.42528235599991, -71.03622812299994],
              [-67.42003333199995, -71.01482512799993],
              [-67.41112219999991, -70.99285247199992],
              [-67.51219641799992, -70.95322030999995],
              [-67.52489173099991, -70.94133879999993],
              [-67.55125891799992, -70.90886809699992],
              [-67.56989498599995, -70.8967424459999],
              [-67.61310787699995, -70.88005950299993],
              [-67.63121497299994, -70.86874765399995],
              [-67.64268958199995, -70.85475025799991],
              [-67.65998287699995, -70.82244231599992],
              [-67.67039954299992, -70.80730559699992],
              [-67.69139563699991, -70.7873674459999],
              [-67.70124264199995, -70.77532317499993],
              [-67.70457923099991, -70.76336028399993],
              [-67.69489498599995, -70.7483049459999],
              [-67.67813066299993, -70.73479583099993],
              [-67.66759192599994, -70.71998463299991],
              [-67.68399003799993, -70.68759530999995],
              [-67.68008378799993, -70.6740861959999],
              [-67.67381751199991, -70.65894947699991],
              [-67.67446855399993, -70.63982512799993],
              [-67.68358313699991, -70.62615325299993],
              [-67.75926673099991, -70.55396900799991],
              [-67.79246985599991, -70.53191497199992],
              [-67.84634355399993, -70.51034921699994],
              [-67.85586503799993, -70.50090911299992],
              [-67.8841039699999, -70.44378020599993],
              [-67.90050208199995, -70.3903947899999],
              [-67.92153886599993, -70.34889088299991],
              [-67.94937089799993, -70.31178150799991],
              [-67.98037675699993, -70.28769296699994],
              [-67.98729407499991, -70.28630950299993],
              [-68.01276607999995, -70.28622812299994],
              [-68.02415930899991, -70.28240325299993],
              [-68.04133053299995, -70.26775481599992],
              [-68.05138098899994, -70.26132577899995],
              [-68.06859290299991, -70.25554778399993],
              [-68.19066321499992, -70.23495859199994],
              [-68.20628821499992, -70.2248674459999],
              [-68.23542232999995, -70.19019947699991],
              [-68.25186113199993, -70.17636484199994],
              [-68.27159583199995, -70.16399504999993],
              [-68.28579667899993, -70.15203215899993],
              [-68.30577551999994, -70.12249114399992],
              [-68.32310950399994, -70.1091447899999],
              [-68.34341386599993, -70.10084400799991],
              [-68.42796790299991, -70.08652109199994],
              [-68.45055091099994, -70.07773202899995],
              [-68.47130286399994, -70.06585051899992],
              [-68.48375403599994, -70.05266692499993],
              [-68.48643958199995, -70.03281015399995],
              [-68.48322506399995, -70.0061174459999],
              [-68.47496497299994, -69.98235442499993],
              [-68.46263587099992, -69.97063567499993],
              [-68.47720292899993, -69.95175546699994],
              [-68.48729407499991, -69.93482838299991],
              [-68.48729407499991, -69.91790129999993],
              [-68.47191321499992, -69.89861419099992],
              [-68.45384680899991, -69.8889299459999],
              [-68.43236243399991, -69.88420989399992],
              [-68.38951575399994, -69.88014088299991],
              [-68.38011633999992, -69.86931731599992],
              [-68.37901770699995, -69.84693775799991],
              [-68.39297441299993, -69.77353280999995],
              [-68.39061438699991, -69.76165129999993],
              [-68.36241614499994, -69.71697356599992],
              [-68.35741126199991, -69.70086028399993],
              [-68.36188717399995, -69.6833635399999],
              [-68.37604732999995, -69.66920338299991],
              [-68.39671790299991, -69.65911223799992],
              [-68.48314368399991, -69.63836028399993],
              [-68.49828040299991, -69.62835051899992],
              [-68.50609290299991, -69.60784270599993],
              [-68.51512610599991, -69.59905364399992],
              [-68.57201087099992, -69.58635833099993],
              [-68.58580481699994, -69.57284921699994],
              [-68.60448157499991, -69.5388322899999],
              [-68.62193762899994, -69.52353280999995],
              [-68.63833574099993, -69.51628997199992],
              [-68.67808997299994, -69.50432708099993],
              [-68.73180091099994, -69.48113372199992],
              [-68.74502519399994, -69.47193775799991],
              [-68.75743567599994, -69.45476653399993],
              [-68.76878821499992, -69.44622161299992],
              [-68.82485917899993, -69.43132903399993],
              [-68.81395423099991, -69.41106536299992],
              [-68.80695553299995, -69.40398528399993],
              [-68.65379798099991, -69.38209400799991],
              [-68.46666419199994, -69.38339609199994],
              [-68.36790930899991, -69.40398528399993],
              [-68.33462480399993, -69.40683359199994],
              [-68.30882727799991, -69.40398528399993],
              [-68.29556230399993, -69.39983489399992],
              [-68.28917395699995, -69.39316171699994],
              [-68.28465735599991, -69.36435312299994],
              [-68.28587805899991, -69.3498674459999],
              [-68.29344641799992, -69.34091562299994],
              [-68.32526607999995, -69.32170989399992],
              [-68.33238684799994, -69.30380624799994],
              [-68.31639563699991, -69.2893205709999],
              [-68.27887936099995, -69.28134530999995],
              [-68.24453691299993, -69.28590260199991],
              [-68.18203691299993, -69.31365325299993],
              [-68.15196692599994, -69.3186174459999],
              [-68.11611894399994, -69.31780364399992],
              [-68.09959876199991, -69.32122161299992],
              [-68.08348548099991, -69.32919687299994],
              [-68.06802324099993, -69.33326588299991],
              [-68.00877844999991, -69.32708098799992],
              [-68.00153561099995, -69.36598072699991],
              [-67.95327714799993, -69.37460702899995],
              [-67.85578365799995, -69.3635393209999],
              [-67.80687415299991, -69.36874765399995],
              [-67.52749589799993, -69.43368905999995],
              [-67.49327551999994, -69.45378997199992],
              [-67.45881100199995, -69.4860979149999],
              [-67.43846594999991, -69.49960702899995],
              [-67.41787675699993, -69.50595468499995],
              [-67.39232337099992, -69.50269947699991],
              [-67.35326087099992, -69.48113372199992],
              [-67.30821692599994, -69.46786874799994],
              [-67.28429114499994, -69.45696379999993],
              [-67.27440344999991, -69.44378020599993],
              [-67.29369055899991, -69.43092213299991],
              [-67.31794186099995, -69.42205169099992],
              [-67.33503170499995, -69.41033294099992],
              [-67.3391820949999, -69.3947893209999],
              [-67.32437089799993, -69.37468840899993],
              [-67.31501217399995, -69.37070077899995],
              [-67.30431067599994, -69.3693986959999],
              [-67.29499264199995, -69.36712004999993],
              [-67.28978430899991, -69.35995859199994],
              [-67.27936764199995, -69.30966562299994],
              [-67.26964270699995, -69.28785572699991],
              [-67.25304114499994, -69.27304452899995],
              [-67.23204505099994, -69.26384856599992],
              [-67.20909583199995, -69.25904713299991],
              [-67.00959225199995, -69.26246510199991],
              [-66.89403235599991, -69.23235442499993],
              [-66.87462317599994, -69.22087981599992],
              [-66.85985266799992, -69.20240650799991],
              [-66.84455318899995, -69.17546965899993],
              [-66.87328040299991, -69.16350676899992],
              [-66.92756100199995, -69.1330705709999],
              [-66.9563695949999, -69.12249114399992],
              [-66.93521074099993, -69.10979583099993],
              [-66.91051184799994, -69.10035572699991],
              [-66.83397376199991, -69.08928801899992],
              [-66.78425045499995, -69.0720354149999],
              [-66.75914466099994, -69.07122161299992],
              [-66.78929602799991, -69.03606536299992],
              [-66.84203040299991, -69.03508879999993],
              [-66.89976966099994, -69.04697030999995],
              [-66.94497636599993, -69.05038827899995],
              [-66.92072506399995, -69.03004322699991],
              [-66.89073645699995, -69.0139299459999],
              [-66.85850989499994, -69.00286223799992],
              [-66.82705644399994, -68.99749114399992],
              [-66.84496008999992, -68.9729143209999],
              [-66.87816321499992, -68.96445077899995],
              [-67.27326412699995, -68.94329192499993],
              [-67.35000566299993, -68.9162736959999],
              [-67.45563717399995, -68.86581796699994],
              [-67.4719945949999, -68.85475025799991],
              [-67.48070227799991, -68.84189218499995],
              [-67.47769120999993, -68.82390715899993],
              [-67.46275794199994, -68.81454843499995],
              [-67.38418535099993, -68.79338958099993],
              [-67.05654863199993, -68.78582122199992],
              [-67.03799394399994, -68.78753020599993],
              [-67.01618404899995, -68.78573984199994],
              [-66.99640865799995, -68.77597421699994],
              [-66.95921790299991, -68.74814218499995],
              [-66.97744706899994, -68.7346330709999],
              [-66.98395748599995, -68.71965911299992],
              [-66.98814856699994, -68.70378997199992],
              [-66.99950110599991, -68.68808359199994],
              [-67.00572669199994, -68.6716447899999],
              [-67.00348873599995, -68.62883879999993],
              [-67.01463782499991, -68.61467864399992],
              [-67.10301673099991, -68.5818010399999],
              [-67.14818274599992, -68.55730559699992],
              [-67.17471269399994, -68.52532317499993],
              [-67.16315670499995, -68.48984140399995],
              [-67.11294511599993, -68.47673919099992],
              [-66.98912512899994, -68.47779713299991],
              [-66.96768144399994, -68.47210051899992],
              [-66.95164954299992, -68.4607072899999],
              [-66.94078528599994, -68.42506275799991],
              [-66.92149817599994, -68.41806405999995],
              [-66.87425696499992, -68.41814544099992],
              [-66.92784583199995, -68.4001604149999],
              [-66.95384680899991, -68.38616301899992],
              [-66.95913652299993, -68.3674455709999],
              [-66.94131425699993, -68.35816822699991],
              [-66.91112219999991, -68.35881926899992],
              [-66.8606664699999, -68.36760833099993],
              [-66.90444902299993, -68.3518205709999],
              [-67.06065833199995, -68.33863697699991],
              [-67.12584387899994, -68.34197356599992],
              [-67.15225175699993, -68.3318010399999],
              [-67.16136633999992, -68.31707122199992],
              [-67.15709387899994, -68.30217864399992],
              [-67.14439856699994, -68.28964609199994],
              [-67.12808183499993, -68.28142669099992],
              [-67.10822506399995, -68.27809010199991],
              [-66.76561438699991, -68.31357187299994],
              [-66.73106848899994, -68.3029924459999],
              [-66.7200414699999, -68.29420338299991],
              [-66.70396887899994, -68.27499765399995],
              [-66.69054114499994, -68.2678361959999],
              [-66.62507076699995, -68.24667734199994],
              [-66.67593339799993, -68.19817473799992],
              [-66.68944251199991, -68.19011809699992],
              [-66.75251217399995, -68.18889739399992],
              [-66.79674231699994, -68.1970354149999],
              [-66.83983313699991, -68.21347421699994],
              [-66.86025956899994, -68.22519296699994],
              [-66.87897701699995, -68.23007577899995],
              [-66.94587154899995, -68.22283294099992],
              [-66.94688880099994, -68.20077890399995],
              [-66.98013261599993, -68.17620208099993],
              [-67.10912024599992, -68.11825937299994],
              [-67.13988196499992, -68.08993905999995],
              [-67.16173255099994, -68.0822893209999],
              [-67.21056067599994, -68.07512786299992],
              [-67.19395911399994, -68.06389739399992],
              [-67.17674719999991, -68.06218840899993],
              [-67.13951575399994, -68.07000090899993],
              [-67.11876380099994, -68.07024504999993],
              [-67.10024980399993, -68.06406015399995],
              [-67.06501217399995, -68.04143645599993],
              [-67.15469316299993, -68.02556731599992],
              [-67.18028723899994, -68.01620859199994],
              [-67.19017493399991, -68.00514088299991],
              [-67.18968665299991, -67.99504973799992],
              [-67.19310462099992, -67.98748137799993],
              [-67.24254309799994, -67.97958749799994],
              [-67.26870683499993, -67.96868254999993],
              [-67.01545162699995, -67.92506275799991],
              [-66.87376868399991, -67.91806405999995],
              [-66.85057532499991, -67.91366952899995],
              [-66.83885657499991, -67.90618254999993],
              [-66.83397376199991, -67.89267343499995],
              [-66.83153235599991, -67.86988697699991],
              [-66.89122473899994, -67.82903411299992],
              [-66.85757402299993, -67.81389739399992],
              [-66.82652747299994, -67.80877044099992],
              [-66.79674231699994, -67.80046965899993],
              [-66.76707923099991, -67.7751604149999],
              [-66.80272376199991, -67.77849700299993],
              [-66.91087805899991, -67.76897551899992],
              [-67.08031165299991, -67.77988046699994],
              [-67.03107662699995, -67.74667734199994],
              [-67.01602128799993, -67.74114348799992],
              [-66.77953040299991, -67.72210051899992],
              [-66.73790442599994, -67.73064544099992],
              [-66.78026282499991, -67.69622161299992],
              [-66.91441809799994, -67.70574309699992],
              [-66.96764075399994, -67.6931291649999],
              [-66.92320716099994, -67.66155364399992],
              [-66.81920325399994, -67.60458749799994],
              [-66.76724199099993, -67.58879973799992],
              [-66.70710201699995, -67.58635833099993],
              [-66.59235592399995, -67.60662200299993],
              [-66.53376217399995, -67.6091447899999],
              [-66.54332434799994, -67.5842424459999],
              [-66.54222571499992, -67.57439544099992],
              [-66.53302975199995, -67.56715260199991],
              [-66.51817786399994, -67.55038827899995],
              [-66.51024329299992, -67.52792734199994],
              [-66.51748613199993, -67.51360442499993],
              [-66.53514563699991, -67.50741952899995],
              [-66.55817623599995, -67.50872161299992],
              [-66.57217363199993, -67.51490650799991],
              [-66.59780839799993, -67.53525155999995],
              [-66.61310787699995, -67.54208749799994],
              [-66.63206946499992, -67.54355234199994],
              [-66.73314368399991, -67.52809010199991],
              [-66.80089270699995, -67.50058359199994],
              [-66.83820553299995, -67.4943986959999],
              [-66.86119544199994, -67.49358489399992],
              [-66.97423255099994, -67.4690080709999],
              [-66.99274654899995, -67.46868254999993],
              [-67.47215735599991, -67.54900481599992],
              [-67.59268144399994, -67.55087655999995],
              [-67.61074785099993, -67.54697030999995],
              [-67.56688391799992, -67.52166106599992],
              [-67.54474850199995, -67.51360442499993],
              [-67.5188695949999, -67.50725676899992],
              [-67.55353756399995, -67.49114348799992],
              [-67.58726966099994, -67.4826799459999],
              [-67.62222245999993, -67.48056405999995],
              [-67.66079667899993, -67.48284270599993],
              [-67.53587805899991, -67.35808684699992],
              [-67.48330644399994, -67.32887135199991],
              [-67.54600989499994, -67.31047942499993],
              [-67.56248938699991, -67.2932268209999],
              [-67.55479895699995, -67.26425546699994],
              [-67.53294837099992, -67.23992278399993],
              [-67.50470943899995, -67.22039153399993],
              [-67.44383704299992, -67.18938567499993],
              [-67.48395748599995, -67.18173593499995],
              [-67.57140051999994, -67.19068775799991],
              [-67.60773678299995, -67.17831796699994],
              [-67.59260006399995, -67.16594817499993],
              [-67.54039466099994, -67.13876718499995],
              [-67.50499426999994, -67.11199309699992],
              [-67.47496497299994, -67.07935963299991],
              [-67.47179114499994, -67.06829192499993],
              [-67.47565670499995, -67.0603166649999],
              [-67.47618567599994, -67.05413176899992],
              [-67.46304277299993, -67.04810963299991],
              [-67.4544164699999, -67.04680754999993],
              [-67.44473222599993, -67.04705169099992],
              [-67.43578040299991, -67.04949309699992],
              [-67.42918860599991, -67.0544572899999],
              [-67.41128495999993, -67.0725236959999],
              [-67.39342200399994, -67.08082447699991],
              [-67.30308997299994, -67.09929778399993],
              [-67.28970292899993, -67.09335702899995],
              [-67.24498450399994, -67.05730559699992],
              [-67.23253333199995, -67.04176197699991],
              [-67.22720292899993, -67.02271900799991],
              [-67.22549394399994, -66.99260833099993],
              [-67.21654212099992, -66.97340260199991],
              [-67.19713294199994, -66.97551848799992],
              [-67.17544511599993, -66.9880510399999],
              [-67.15973873599995, -67.00090911299992],
              [-67.13906816299993, -67.01425546699994],
              [-67.11896725199995, -67.01677825299993],
              [-67.09776770699995, -67.01116301899992],
              [-67.07396399599992, -67.00066497199992],
              [-67.10732988199993, -66.97128671699994],
              [-67.12018795499995, -66.95427825299993],
              [-67.11904863199993, -66.93613046699994],
              [-67.10399329299992, -66.92782968499995],
              [-67.07730058499993, -66.92278411299992],
              [-67.04971269399994, -66.92083098799992],
              [-67.03189042899993, -66.9216447899999],
              [-66.95067298099991, -66.93889739399992],
              [-66.9173070949999, -66.9568010399999],
              [-66.92784583199995, -66.98284270599993],
              [-66.92589270699995, -66.99114348799992],
              [-66.90746008999992, -67.03777434699992],
              [-66.91030839799993, -67.05364348799992],
              [-66.91763261599993, -67.06764088299991],
              [-66.93919837099992, -67.09172942499993],
              [-66.94220943899995, -67.10263437299994],
              [-66.93932044199994, -67.11825937299994],
              [-66.92992102799991, -67.14666106599992],
              [-66.92389889199995, -67.15789153399993],
              [-66.91413326699995, -67.16326262799993],
              [-66.88752193899995, -67.16814544099992],
              [-66.93903561099995, -67.20387135199991],
              [-66.95026607999995, -67.21493905999995],
              [-66.95881100199995, -67.23821379999993],
              [-66.96849524599992, -67.25066497199992],
              [-66.98086503799993, -67.27629973799992],
              [-66.94977779899995, -67.28427499799994],
              [-66.87682044199994, -67.28476327899995],
              [-66.81639563699991, -67.31113046699994],
              [-66.78563391799992, -67.31145598799992],
              [-66.76447506399995, -67.28866952899995],
              [-66.76353919199994, -67.28142669099992],
              [-66.76573645699995, -67.26799895599993],
              [-66.76451575399994, -67.26140715899993],
              [-66.75560462099992, -67.25009530999995],
              [-66.72996985599991, -67.23259856599992],
              [-66.72020423099991, -67.22177499799994],
              [-66.71540279899995, -67.2072893209999],
              [-66.71377519399994, -67.19605885199991],
              [-66.70885169199994, -67.19052499799994],
              [-66.69420325399994, -67.1936174459999],
              [-66.64757239499994, -67.22063567499993],
              [-66.60667883999992, -67.2385393209999],
              [-66.59581458199995, -67.24521249799994],
              [-66.56436113199993, -67.2771135399999],
              [-66.55785071499992, -67.28777434699992],
              [-66.54246985599991, -67.32756926899992],
              [-66.53575598899994, -67.34002044099992],
              [-66.52330481699994, -67.34514739399992],
              [-66.49742591099994, -67.34677499799994],
              [-66.46279863199993, -67.33660247199992],
              [-66.45103919199994, -67.30852629999993],
              [-66.45352128799993, -67.21559010199991],
              [-66.45653235599991, -67.19882577899995],
              [-66.47435462099992, -67.16139088299991],
              [-66.48534094999991, -67.14771900799991],
              [-66.51390540299991, -67.1267229149999],
              [-66.52684485599991, -67.11394622199992],
              [-66.44416256399995, -67.08538176899992],
              [-66.46580969999991, -67.07740650799991],
              [-66.52171790299991, -67.04892343499995],
              [-66.54491126199991, -67.04452890399995],
              [-66.59080969999991, -67.04355234199994],
              [-66.61416581899994, -67.03801848799992],
              [-66.59898841099994, -67.01311614399992],
              [-66.58315995999993, -66.9943986959999],
              [-66.49494381399995, -66.91838958099993],
              [-66.48534094999991, -66.91611093499995],
              [-66.47496497299994, -66.91570403399993],
              [-66.46153723899994, -66.91350676899992],
              [-66.43883216099994, -66.90146249799994],
              [-66.42031816299993, -66.88193124799994],
              [-66.41722571499992, -66.8610979149999],
              [-66.44058183499993, -66.84563567499993],
              [-66.55190995999993, -66.81064218499995],
              [-66.53307044199994, -66.77556731599992],
              [-66.52798417899993, -66.74480559699992],
              [-66.53498287699995, -66.71404387799993],
              [-66.5520727199999, -66.67929452899995],
              [-66.54792232999995, -66.6501604149999],
              [-66.51207434799994, -66.63014088299991],
              [-66.29214433499993, -66.58587004999993],
              [-66.25682532499991, -66.58318450299993],
              [-66.09190833199995, -66.59140390399995],
              [-66.07603919199994, -66.59636809699992],
              [-66.07054602799991, -66.60271575299993],
              [-66.06265214799993, -66.62078215899993],
              [-66.05703691299993, -66.6267229149999],
              [-66.04845130099994, -66.6291643209999],
              [-66.01891028599994, -66.63095468499995],
              [-66.00047766799992, -66.63600025799991],
              [-65.98859615799995, -66.64218515399995],
              [-65.96141516799992, -66.66326262799993],
              [-65.94399980399993, -66.67310963299991],
              [-65.93130449099993, -66.67571379999993],
              [-65.89549719999991, -66.67571379999993],
              [-65.83950761599993, -66.68824635199991],
              [-65.82848059799994, -66.69304778399993],
              [-65.81395423099991, -66.7087541649999],
              [-65.80036373599995, -66.71575286299992],
              [-65.78482011599993, -66.71550872199992],
              [-65.76488196499992, -66.70916106599992],
              [-65.74986731699994, -66.70037200299993],
              [-65.73814856699994, -66.69052499799994],
              [-65.72545325399994, -66.68352629999993],
              [-65.68936113199993, -66.68368905999995],
              [-65.67463131399995, -66.67693450299993],
              [-65.64614824099993, -66.65300872199992],
              [-65.76207434799994, -66.6096330709999],
              [-65.76671301999994, -66.6018205709999],
              [-65.75169837099992, -66.59441497199992],
              [-65.73460852799991, -66.59392669099992],
              [-65.71719316299993, -66.59661223799992],
              [-65.70107988199993, -66.5959611959999],
              [-65.68797766799992, -66.58603280999995],
              [-65.69188391799992, -66.58163827899995],
              [-65.72069251199991, -66.56438567499993],
              [-65.72240149599992, -66.55437590899993],
              [-65.71882076699995, -66.54607512799993],
              [-65.70543372299994, -66.52809010199991],
              [-65.68936113199993, -66.49618905999995],
              [-65.66470292899993, -66.46249765399995],
              [-65.66075598899994, -66.44988372199992],
              [-65.66270911399994, -66.43401458099993],
              [-65.63621985599991, -66.42278411299992],
              [-65.57803300699993, -66.40984465899993],
              [-65.55036373599995, -66.4001604149999],
              [-65.60155188699991, -66.37851327899995],
              [-65.61188717399995, -66.37688567499993],
              [-65.63560950399994, -66.37851327899995],
              [-65.64293372299994, -66.37712981599992],
              [-65.65762285099993, -66.36028411299992],
              [-65.66218014199995, -66.34392669099992],
              [-65.6692602199999, -66.33001067499993],
              [-65.69163977799991, -66.32048919099992],
              [-65.74014238199993, -66.31853606599992],
              [-65.78482011599993, -66.32333749799994],
              [-65.82811438699991, -66.32122161299992],
              [-65.87242591099994, -66.29892343499995],
              [-65.78571529899995, -66.27402109199994],
              [-65.76512610599991, -66.27166106599992],
              [-65.7454320949999, -66.27206796699994],
              [-65.7259008449999, -66.27011484199994],
              [-65.64053300699993, -66.21477629999993],
              [-65.63369706899994, -66.20061614399992],
              [-65.64683997299994, -66.18173593499995],
              [-65.66356360599991, -66.17050546699994],
              [-65.70547441299993, -66.14999765399995],
              [-65.61294511599993, -66.12566497199992],
              [-65.60846920499995, -66.12029387799993],
              [-65.60033118399991, -66.10263437299994],
              [-65.59581458199995, -66.09840260199991],
              [-65.58267167899993, -66.10076262799993],
              [-65.54482988199993, -66.12151458099993],
              [-65.53038489499994, -66.12346770599993],
              [-65.50145423099991, -66.1213518209999],
              [-65.48696855399993, -66.1228166649999],
              [-65.43561764199995, -66.14495208099993],
              [-65.41441809799994, -66.14755624799994],
              [-65.31997636599993, -66.14706796699994],
              [-65.18740800699993, -66.17253997199992],
              [-65.13866126199991, -66.16985442499993],
              [-65.09093176999994, -66.15007903399993],
              [-65.24986731699994, -66.06658294099992],
              [-65.30052649599992, -66.04998137799993],
              [-65.31916256399995, -66.03826262799993],
              [-65.33202063699991, -66.02117278399993],
              [-65.33592688699991, -66.00123463299991],
              [-65.32774817599994, -65.98113372199992],
              [-65.31407630099994, -65.97014739399992],
              [-65.29625403599994, -65.96331145599993],
              [-65.25975501199991, -65.95745208099993],
              [-65.05215410099993, -65.9626604149999],
              [-65.03978430899991, -65.96021900799991],
              [-65.01402747299994, -65.94475676899992],
              [-65.00084387899994, -65.93938567499993],
              [-64.91657467399995, -65.92693450299993],
              [-64.88662675699993, -65.92839934699992],
              [-64.82335364499994, -65.94036223799992],
              [-64.81786048099991, -65.94638437299994],
              [-64.80939693899995, -65.97112395599993],
              [-64.79971269399994, -65.98056405999995],
              [-64.78693600199995, -65.98455169099992],
              [-64.77399654899995, -65.98691171699994],
              [-64.76244055899991, -65.99089934699992],
              [-64.74079342399995, -66.01238372199992],
              [-64.71263587099992, -66.01718515399995],
              [-64.70352128799993, -66.0329729149999],
              [-64.68651282499991, -66.03834400799991],
              [-64.58409583199995, -66.0334611959999],
              [-64.57201087099992, -66.0295549459999],
              [-64.53807532499991, -66.00554778399993],
              [-64.50837154899995, -65.99098072699991],
              [-64.49600175699993, -65.98088958099993],
              [-64.48770097599993, -65.96559010199991],
              [-64.48770097599993, -65.95045338299991],
              [-64.49583899599992, -65.93938567499993],
              [-64.52122962099992, -65.92262135199991],
              [-64.55638587099992, -65.88876718499995],
              [-64.55606035099993, -65.88209400799991],
              [-64.5950414699999, -65.88339609199994],
              [-64.63023841099994, -65.87883879999993],
              [-64.66270911399994, -65.8654924459999],
              [-64.69367428299995, -65.84050872199992],
              [-64.67198645699995, -65.81406015399995],
              [-64.67137610599991, -65.75261809699992],
              [-64.65794837099992, -65.73723723799992],
              [-64.62559973899994, -65.7385393209999],
              [-64.56309973899994, -65.76425546699994],
              [-64.39639238199993, -65.80934010199991],
              [-64.37669837099992, -65.80535247199992],
              [-64.36900794199994, -65.79778411299992],
              [-64.36827551999994, -65.76474374799994],
              [-64.3704320949999, -65.75701262799993],
              [-64.37474524599992, -65.74895598799992],
              [-64.37718665299991, -65.74179452899995],
              [-64.37352454299992, -65.73642343499995],
              [-64.3352758449999, -65.7165666649999],
              [-64.44420325399994, -65.65732187299994],
              [-64.47866777299993, -65.63144296699994],
              [-64.30500240799995, -65.63193124799994],
              [-64.25096594999991, -65.64218515399995],
              [-64.22594153599994, -65.65642669099992],
              [-64.20909583199995, -65.67343515399995],
              [-64.19058183499993, -65.68466562299994],
              [-64.13442949099993, -65.68035247199992],
              [-64.07481848899994, -65.69304778399993],
              [-64.04507402299993, -65.6931291649999],
              [-64.06627356699994, -65.6696916649999],
              [-64.12222245999993, -65.64316171699994],
              [-64.14513098899994, -65.62395598799992],
              [-64.12319902299993, -65.61467864399992],
              [-64.11660722599993, -65.61052825299993],
              [-64.14037024599992, -65.58668385199991],
              [-64.16454016799992, -65.56804778399993],
              [-64.19229081899994, -65.5564104149999],
              [-64.22687740799995, -65.55331796699994],
              [-64.08189856699994, -65.51482512799993],
              [-64.00373287699995, -65.5153947899999],
              [-63.97447669199994, -65.55592213299991],
              [-63.97345943899995, -65.5700822899999],
              [-63.96617591099994, -65.57496510199991],
              [-63.93883216099994, -65.57935963299991],
              [-63.88048255099994, -65.59905364399992],
              [-63.806304490999935, -65.60800546699994],
              [-63.79515540299991, -65.6057268209999],
              [-63.7923070949999, -65.59124114399992],
              [-63.80256100199995, -65.57537200299993],
              [-63.828684048999946, -65.54753997199992],
              [-63.795480923999946, -65.53134530999995],
              [-63.68228105399993, -65.52385833099993],
              [-63.701161261999914, -65.50465260199991],
              [-63.75438391799992, -65.49618905999995],
              [-63.76231848899994, -65.47161223799992],
              [-63.82998613199993, -65.4841447899999],
              [-63.82730058499993, -65.4787736959999],
              [-63.823882615999935, -65.46689218499995],
              [-63.82140051999994, -65.46152109199994],
              [-63.92202714799993, -65.4685197899999],
              [-64.05972245999993, -65.42937590899993],
              [-64.08995520699995, -65.41334400799991],
              [-64.06297766799992, -65.40943775799991],
              [-64.03429114499994, -65.39934661299992],
              [-64.0071508449999, -65.38534921699994],
              [-63.984486456999946, -65.36988697699991],
              [-63.99746660099993, -65.3537736959999],
              [-64.01329505099994, -65.34303150799991],
              [-64.04954993399991, -65.32675546699994],
              [-64.10366777299993, -65.27654387799993],
              [-64.10985266799992, -65.26775481599992],
              [-64.07909094999991, -65.27011484199994],
              [-64.06419837099992, -65.26946379999993],
              [-64.05492102799991, -65.26246510199991],
              [-64.05622311099995, -65.24138762799993],
              [-64.08214270699995, -65.1936174459999],
              [-64.07970130099994, -65.16529713299991],
              [-64.05589758999992, -65.1443010399999],
              [-63.99445553299995, -65.14739348799992],
              [-63.969593878999945, -65.13355885199991],
              [-63.96914628799993, -65.12948984199994],
              [-63.97423255099994, -65.12053801899992],
              [-63.97435462099992, -65.11679452899995],
              [-63.97032630099994, -65.11256275799991],
              [-63.96499589799993, -65.1096330709999],
              [-63.94448808499993, -65.1018205709999],
              [-63.92145748599995, -65.09636809699992],
              [-63.91307532499991, -65.09148528399993],
              [-63.90599524599992, -65.08171965899993],
              [-63.896595831999946, -65.0627580709999],
              [-63.88768469999991, -65.05388762799993],
              [-63.873890753999945, -65.04599374799994],
              [-63.82697506399995, -65.03020598799992],
              [-63.80622311099995, -65.02646249799994],
              [-63.79063880099994, -65.02874114399992],
              [-63.758697068999936, -65.04159921699994],
              [-63.73932857999995, -65.04387786299992],
              [-63.72227942599994, -65.04119231599992],
              [-63.706288214999915, -65.04062265399995],
              [-63.69017493399991, -65.04827239399992],
              [-63.67296301999994, -65.06682708099993],
              [-63.663319464999915, -65.0720354149999],
              [-63.65339107999995, -65.07529062299994],
              [-63.589955206999946, -65.0837541649999],
              [-63.556711391999954, -65.08310312299994],
              [-63.53673255099994, -65.07968515399995],
              [-63.526600714999915, -65.07976653399993],
              [-63.499989386999914, -65.09286874799994],
              [-63.451730923999946, -65.09319426899992],
              [-63.42735755099994, -65.09612395599993],
              [-63.38243567599994, -65.11093515399995],
              [-63.35973059799994, -65.11142343499995],
              [-63.31615149599992, -65.09148528399993],
              [-63.28815670499995, -65.08269622199992],
              [-63.26130123599995, -65.0803361959999],
              [-63.24640865799995, -65.09075286299992],
              [-63.237172003999945, -65.11736419099992],
              [-63.22419186099995, -65.13665129999993],
              [-63.20482337099992, -65.1462541649999],
              [-63.15074622299994, -65.1428361959999],
              [-63.10789954299992, -65.1638322899999],
              [-63.08360755099994, -65.16611093499995],
              [-63.06041419199994, -65.15748463299991],
              [-63.01805579299992, -65.13274504999993],
              [-62.99201412699995, -65.12542083099993],
              [-63.02301998599995, -65.08521900799991],
              [-62.99974524599992, -65.07488372199992],
              [-62.99181067599994, -65.07236093499995],
              [-62.99876868399991, -65.06853606599992],
              [-63.011830206999946, -65.05852629999993],
              [-63.0188695949999, -65.05478280999995],
              [-63.00332597599993, -65.04363372199992],
              [-63.00544186099995, -65.0354143209999],
              [-63.01716061099995, -65.03036874799994],
              [-63.03087317599994, -65.02776458099993],
              [-63.048939581999946, -65.02857838299991],
              [-63.08580481699994, -65.03679778399993],
              [-63.10399329299992, -65.03728606599992],
              [-63.138742641999954, -65.02776458099993],
              [-63.17369544199994, -65.01018645599993],
              [-63.23375403599994, -64.96526458099993],
              [-63.20881100199995, -64.94939544099992],
              [-63.09862219999991, -64.93401458099993],
              [-63.08836829299992, -64.93035247199992],
              [-63.07966061099995, -64.92253997199992],
              [-63.06712805899991, -64.90683359199994],
              [-63.05650794199994, -64.90439218499995],
              [-63.03978430899991, -64.90878671699994],
              [-63.01162675699993, -64.92066822699991],
              [-62.99722245999993, -64.9235979149999],
              [-62.985991990999935, -64.92115650799991],
              [-62.974720831999946, -64.91716887799993],
              [-62.95995032499991, -64.91497161299992],
              [-62.943348761999914, -64.91757577899995],
              [-62.91466223899994, -64.92888762799993],
              [-62.89785722599993, -64.93108489399992],
              [-62.86790930899991, -64.92099374799994],
              [-62.82209225199995, -64.87769947699991],
              [-62.78880774599992, -64.86663176899992],
              [-62.824777798999946, -64.85475025799991],
              [-62.839833136999914, -64.84563567499993],
              [-62.85431881399995, -64.83163827899995],
              [-62.79409745999993, -64.81267669099992],
              [-62.74010169199994, -64.82301197699991],
              [-62.59552975199995, -64.90642669099992],
              [-62.583973761999914, -64.91073984199994],
              [-62.56480872299994, -64.90927499799994],
              [-62.55296790299991, -64.90097421699994],
              [-62.5423070949999, -64.89031340899993],
              [-62.52603105399993, -64.88193124799994],
              [-62.49819902299993, -64.87883879999993],
              [-62.43740800699993, -64.88152434699992],
              [-62.40721594999991, -64.87664153399993],
              [-62.673817511999914, -64.77727629999993],
              [-62.65314693899995, -64.76311614399992],
              [-62.63072669199994, -64.75920989399992],
              [-62.58161373599995, -64.7600236959999],
              [-62.55919348899994, -64.75335051899992],
              [-62.51805579299992, -64.73186614399992],
              [-62.49718176999994, -64.73186614399992],
              [-62.54088294199994, -64.70175546699994],
              [-62.557199673999946, -64.68572356599992],
              [-62.57408606699994, -64.65667083099993],
              [-62.57201087099992, -64.64959075299993],
              [-62.56314042899993, -64.6423479149999],
              [-62.55186926999994, -64.63713958099993],
              [-62.54279537699995, -64.63632577899995],
              [-62.522694464999915, -64.64104583099993],
              [-62.50731360599991, -64.64169687299994],
              [-62.49205481699994, -64.63836028399993],
              [-62.47248287699995, -64.6311174459999],
              [-62.48322506399995, -64.62232838299991],
              [-62.49494381399995, -64.61614348799992],
              [-62.50763912699995, -64.61248137799993],
              [-62.521148240999935, -64.61223723799992],
              [-62.49551347599993, -64.59856536299992],
              [-62.47020423099991, -64.59335702899995],
              [-62.44416256399995, -64.59482187299994],
              [-62.41649329299992, -64.60125090899993],
              [-62.42345130099994, -64.60662200299993],
              [-62.43602454299992, -64.61923593499995],
              [-62.44298255099994, -64.62460702899995],
              [-62.39159094999991, -64.65984465899993],
              [-62.36632239499994, -64.66912200299993],
              [-62.36538652299993, -64.64560312299994],
              [-62.34276282499991, -64.64739348799992],
              [-62.32046464799993, -64.65162525799991],
              [-62.31094316299993, -64.6565080709999],
              [-62.30418860599991, -64.66464609199994],
              [-62.30382239499994, -64.67294687299994],
              [-62.31285559799994, -64.6779924459999],
              [-62.337961391999954, -64.68710702899995],
              [-62.353627081999946, -64.70256926899992],
              [-62.36278235599991, -64.72356536299992],
              [-62.36900794199994, -64.74911874799994],
              [-62.141835089999915, -64.78484465899993],
              [-62.159820115999935, -64.77068450299993],
              [-62.200835740999935, -64.75302499799994],
              [-62.22008216099994, -64.7380510399999],
              [-62.19611568899995, -64.7346330709999],
              [-62.17422441299993, -64.73593515399995],
              [-62.128895636999914, -64.74602629999993],
              [-62.13418535099993, -64.73088958099993],
              [-62.13703365799995, -64.71526458099993],
              [-62.136830206999946, -64.68328215899993],
              [-62.05492102799991, -64.71786874799994],
              [-62.04482988199993, -64.71453215899993],
              [-62.028228318999936, -64.70126718499995],
              [-62.01520748599995, -64.69573333099993],
              [-61.98452714799993, -64.6950822899999],
              [-61.97085527299993, -64.69036223799992],
              [-61.95579993399991, -64.67864348799992],
              [-61.943348761999914, -64.66659921699994],
              [-61.92072506399995, -64.63779062299994],
              [-61.966786261999914, -64.61223723799992],
              [-61.94570878799993, -64.59978606599992],
              [-61.93154863199993, -64.58554452899995],
              [-61.915679490999935, -64.57488372199992],
              [-61.89024817599994, -64.57366301899992],
              [-61.878895636999914, -64.57683684699992],
              [-61.844634568999936, -64.59303150799991],
              [-61.834868943999936, -64.59303150799991],
              [-61.795033331999946, -64.58277760199991],
              [-61.812570766999954, -64.57284921699994],
              [-61.82945716099994, -64.53582122199992],
              [-61.843739386999914, -64.51824309699992],
              [-61.83039303299995, -64.51384856599992],
              [-61.81407630099994, -64.49716562299994],
              [-61.80573482999995, -64.49285247199992],
              [-61.78490149599992, -64.49293385199991],
              [-61.77965247299994, -64.49716562299994],
              [-61.77798417899993, -64.50530364399992],
              [-61.768788214999915, -64.51824309699992],
              [-61.721587693999936, -64.56292083099993],
              [-61.71239173099991, -64.58123137799993],
              [-61.709055141999954, -64.59693775799991],
              [-61.70327714799993, -64.6091447899999],
              [-61.68651282499991, -64.61712004999993],
              [-61.67210852799991, -64.62053801899992],
              [-61.66124426999994, -64.62509530999995],
              [-61.65587317599994, -64.63290780999995],
              [-61.65733801999994, -64.64576588299991],
              [-61.65314693899995, -64.65398528399993],
              [-61.638783331999946, -64.66057708099993],
              [-61.608306443999936, -64.66757577899995],
              [-61.57884680899991, -64.66204192499993],
              [-61.49103756399995, -64.61451588299991],
              [-61.56899980399993, -64.5842424459999],
              [-61.60431881399995, -64.56072356599992],
              [-61.60578365799995, -64.53215911299992],
              [-61.574208136999914, -64.52223072699991],
              [-61.52049719999991, -64.52499765399995],
              [-61.46617591099994, -64.53460051899992],
              [-61.43228105399993, -64.54558684699992],
              [-61.445423956999946, -64.53191497199992],
              [-61.446929490999935, -64.51091887799993],
              [-61.444203253999945, -64.48723723799992],
              [-61.44469153599994, -64.4651018209999],
              [-61.52481035099993, -64.48406340899993],
              [-61.55931555899991, -64.47795989399992],
              [-61.582875128999945, -64.44264088299991],
              [-61.56688391799992, -64.43808359199994],
              [-61.54161536399994, -64.42058684699992],
              [-61.52765865799995, -64.41570403399993],
              [-61.496164516999954, -64.41228606599992],
              [-61.48546301999994, -64.40789153399993],
              [-61.47166907499991, -64.39788176899992],
              [-61.46125240799995, -64.38323333099993],
              [-61.46076412699995, -64.37314218499995],
              [-61.45612545499995, -64.36834075299993],
              [-61.41559811099995, -64.37127044099992],
              [-61.398548956999946, -64.36923593499995],
              [-61.36506100199995, -64.35898202899995],
              [-61.37169348899994, -64.37615325299993],
              [-61.38621985599991, -64.38445403399993],
              [-61.42341061099995, -64.39275481599992],
              [-61.416574673999946, -64.40764739399992],
              [-61.40257727799991, -64.40935637799993],
              [-61.384755011999914, -64.40569426899992],
              [-61.36668860599991, -64.40447356599992],
              [-61.34984290299991, -64.40960051899992],
              [-61.29531816299993, -64.43238697699991],
              [-61.29523678299995, -64.40520598799992],
              [-61.27131100199995, -64.39470794099992],
              [-61.14997311099995, -64.39397551899992],
              [-61.090687628999945, -64.38632577899995],
              [-61.11318925699993, -64.38144296699994],
              [-61.12474524599992, -64.37070077899995],
              [-61.13044186099995, -64.35442473799992],
              [-61.13516191299993, -64.33310312299994],
              [-61.11733964799993, -64.33342864399992],
              [-61.11050370999993, -64.32480234199994],
              [-61.10619055899991, -64.31292083099993],
              [-61.095814581999946, -64.30291106599992],
              [-61.08023027299993, -64.29802825299993],
              [-61.064442511999914, -64.29583098799992],
              [-61.00218665299991, -64.29876067499993],
              [-60.96865800699993, -64.29566822699991],
              [-60.94172115799995, -64.28191497199992],
              [-60.93081620999993, -64.25139739399992],
              [-60.95384680899991, -64.2478166649999],
              [-60.97598222599993, -64.24089934699992],
              [-60.96743730399993, -64.22193775799991],
              [-60.955962693999936, -64.21306731599992],
              [-60.940663214999915, -64.21021900799991],
              [-60.920480923999946, -64.21005624799994],
              [-60.962880011999914, -64.15634530999995],
              [-60.87018795499995, -64.16692473799992],
              [-60.84080969999991, -64.16423919099992],
              [-60.84752356699994, -64.15398528399993],
              [-60.855539516999954, -64.14739348799992],
              [-60.86506100199995, -64.14348723799992],
              [-60.87637285099993, -64.14137135199991],
              [-60.887277798999946, -64.13665129999993],
              [-60.90444902299993, -64.11777109199994],
              [-60.91454016799992, -64.11044687299994],
              [-61.01943925699993, -64.08245208099993],
              [-60.9856664699999, -64.06454843499995],
              [-60.924672003999945, -64.05608489399992],
              [-60.89037024599992, -64.04705169099992],
              [-60.87718665299991, -64.04745859199994],
              [-60.86148027299993, -64.05462004999993],
              [-60.83311926999994, -64.0725236959999],
              [-60.81867428299995, -64.07545338299991],
              [-60.80040442599994, -64.07333749799994],
              [-60.76716061099995, -64.0647111959999],
              [-60.77285722599993, -64.08505624799994],
              [-60.74640865799995, -64.07919687299994],
              [-60.72736568899995, -64.06218840899993],
              [-60.72020423099991, -64.03826262799993],
              [-60.72931881399995, -64.0114885399999],
              [-60.52847245999993, -63.98601653399993],
              [-60.30646725199995, -63.91545989399992],
              [-60.25230872299994, -63.92009856599992],
              [-60.20148678299995, -63.91375090899993],
              [-60.17422441299993, -63.91611093499995],
              [-59.99518795499995, -63.95867278399993],
              [-59.98200436099995, -63.95973072699991],
              [-59.969960089999915, -63.958103122999944],
              [-59.95620683499993, -63.95191822699991],
              [-59.95384680899991, -63.94670989399992],
              [-59.9563695949999, -63.94036223799992],
              [-59.957102016999954, -63.93084075299993],
              [-59.95230058499993, -63.921807549999926],
              [-59.93700110599991, -63.90715911299992],
              [-59.93333899599992, -63.898370049999926],
              [-59.93537350199995, -63.89267343499995],
              [-59.94517981699994, -63.88339609199994],
              [-59.94709225199995, -63.876885674999926],
              [-59.94286048099991, -63.86565520599993],
              [-59.93390865799995, -63.85702890399995],
              [-59.92235266799992, -63.85116952899995],
              [-59.91087805899991, -63.847914320999905],
              [-59.88621985599991, -63.849867445999905],
              [-59.864898240999935, -63.857354424999926],
              [-59.84447180899991, -63.85947030999995],
              [-59.82249915299991, -63.8454729149999],
              [-59.83901933499993, -63.83131275799991],
              [-59.84845943899995, -63.81894296699994],
              [-59.84837805899991, -63.80527109199994],
              [-59.83633378799993, -63.787041924999926],
              [-59.82249915299991, -63.77597421699994],
              [-59.80744381399995, -63.77166106599992],
              [-59.79161536399994, -63.774102471999925],
              [-59.77562415299991, -63.78215911299992],
              [-59.76073157499991, -63.79957447699991],
              [-59.76781165299991, -63.81178150799991],
              [-59.78258216099994, -63.82236093499995],
              [-59.79063880099994, -63.83473072699991],
              [-59.78490149599992, -63.85271575299993],
              [-59.77017167899993, -63.85995859199994],
              [-59.71328691299993, -63.86101653399993],
              [-59.662953253999945, -63.87346770599993],
              [-59.607411261999914, -63.87379322699991],
              [-59.566477016999954, -63.88827890399995],
              [-59.54873613199993, -63.891289971999925],
              [-59.53087317599994, -63.88909270599993],
              [-59.50999915299991, -63.881524346999925],
              [-59.48900305899991, -63.87908294099992],
              [-59.46751868399991, -63.88640715899993],
              [-59.42910722599993, -63.9099260399999],
              [-59.40119381399995, -63.861993096999925],
              [-59.41388912699995, -63.858086846999925],
              [-59.42495683499993, -63.85125090899993],
              [-59.43407141799992, -63.84197356599992],
              [-59.44058183499993, -63.83025481599992],
              [-59.34520423099991, -63.79241301899992],
              [-59.33975175699993, -63.78533294099992],
              [-59.33812415299991, -63.77361419099992],
              [-59.34410559799994, -63.76189544099992],
              [-59.366851365999935, -63.733493747999944],
              [-59.36888587099992, -63.72323984199994],
              [-59.35228430899991, -63.70859140399995],
              [-59.32835852799991, -63.698337497999944],
              [-59.25381425699993, -63.68181731599992],
              [-59.23127193899995, -63.68059661299992],
              [-59.20921790299991, -63.68303801899992],
              [-59.186431443999936, -63.69003671699994],
              [-59.14122473899994, -63.71054452899995],
              [-59.11546790299991, -63.71843840899993],
              [-59.09630286399994, -63.71624114399992],
              [-59.01203365799995, -63.67156340899993],
              [-58.98766028599994, -63.66765715899993],
              [-58.96051998599995, -63.670993747999944],
              [-58.93614661399994, -63.66920338299991],
              [-58.920765753999945, -63.65097421699994],
              [-58.92259680899991, -63.63103606599992],
              [-58.94176184799994, -63.58562590899993],
              [-58.940337693999936, -63.564385674999926],
              [-58.923898891999954, -63.54892343499995],
              [-58.898548956999946, -63.54021575299993],
              [-58.57752438049994, -63.497206312999936],
              [-58.25649980399993, -63.454196872999944],
              [-58.16519120999993, -63.46298593499995],
              [-58.14484615799995, -63.45859140399995],
              [-58.131703253999945, -63.444431247999944],
              [-58.12653561099995, -63.41611093499995],
              [-58.14289303299995, -63.41676197699991],
              [-58.16510982999995, -63.41521575299993],
              [-58.182850714999915, -63.40789153399993],
              [-58.18614661399994, -63.39153411299992],
              [-58.169911261999914, -63.37656015399995],
              [-58.14476477799991, -63.37932708099993],
              [-58.11961829299992, -63.39120859199994],
              [-58.10342363199993, -63.402601820999905],
              [-58.0891820949999, -63.41033294099992],
              [-58.06969153599994, -63.414727471999925],
              [-58.04942786399994, -63.41570403399993],
              [-58.03294837099992, -63.413181247999944],
              [-58.02257239499994, -63.407321872999944],
              [-58.003895636999914, -63.39153411299992],
              [-57.99278723899994, -63.38762786299992],
              [-57.9680883449999, -63.38518645599993],
              [-57.95856686099995, -63.381117445999905],
              [-57.88027910099993, -63.314711195999905],
              [-57.86278235599991, -63.306573174999926],
              [-57.79710852799991, -63.30722421699994],
              [-57.49181067599994, -63.25156015399995],
              [-57.41173255099994, -63.22503020599993],
              [-57.36872311099995, -63.217868747999944],
              [-57.28661048099991, -63.214776299999926],
              [-57.10586503799993, -63.24138762799993],
              [-57.029408331999946, -63.2810197899999],
              [-57.03620357999995, -63.34726327899995],
              [-57.02782141799992, -63.35035572699991],
              [-57.01146399599992, -63.35947030999995],
              [-57.00291907499991, -63.36223723799992],
              [-57.01634680899991, -63.37395598799992],
              [-57.02749589799993, -63.38689544099992],
              [-57.04759680899991, -63.41562265399995],
              [-56.96580969999991, -63.39527760199991],
              [-56.94440670499995, -63.39853280999995],
              [-56.92886308499993, -63.420179945999905],
              [-56.94180253799993, -63.43889739399992],
              [-56.96776282499991, -63.45281340899993],
              [-56.99132239499994, -63.46038176899992],
              [-56.98005123599995, -63.470635674999926],
              [-56.968861456999946, -63.47356536299992],
              [-56.95750891799992, -63.47478606599992],
              [-56.94570878799993, -63.47975025799991],
              [-56.93394934799994, -63.49081796699994],
              [-56.92552649599992, -63.501071872999944],
              [-56.916086391999954, -63.50986093499995],
              [-56.90119381399995, -63.51637135199991],
              [-56.82437089799993, -63.5310197899999],
              [-56.79963131399995, -63.54306405999995],
              [-56.77603105399993, -63.56308359199994],
              [-56.768137173999946, -63.58294036299992],
              [-56.77578691299993, -63.603773695999905],
              [-56.79906165299991, -63.62623463299991],
              [-56.821603969999956, -63.63811614399992],
              [-56.84780839799993, -63.64373137799993],
              [-56.87486731699994, -63.64267343499995],
              [-56.89940344999991, -63.6345354149999],
              [-56.945423956999946, -63.61296965899993],
              [-56.96837317599994, -63.61142343499995],
              [-57.020375128999945, -63.63298919099992],
              [-57.09593665299991, -63.65178801899992],
              [-57.12441972599993, -63.65447356599992],
              [-57.146473761999914, -63.643243096999925],
              [-57.163319464999915, -63.62249114399992],
              [-57.17552649599992, -63.59685637799993],
              [-57.169992641999954, -63.57976653399993],
              [-57.14663652299993, -63.567071221999925],
              [-57.118072068999936, -63.55974700299993],
              [-57.096547003999945, -63.558526299999926],
              [-57.10415605399993, -63.54648202899995],
              [-57.11461341099994, -63.537041924999926],
              [-57.126942511999914, -63.52988046699994],
              [-57.140288865999935, -63.524509372999944],
              [-57.13658606699994, -63.51962655999995],
              [-57.13068600199995, -63.50823333099993],
              [-57.12677975199995, -63.50351327899995],
              [-57.14513098899994, -63.498711846999925],
              [-57.17731686099995, -63.476820570999905],
              [-57.201283331999946, -63.47307708099993],
              [-57.294260219999956, -63.48137786299992],
              [-57.343006964999915, -63.47234465899993],
              [-57.39468339799993, -63.454196872999944],
              [-57.445383266999954, -63.444431247999944],
              [-57.49103756399995, -63.460056247999944],
              [-57.457915818999936, -63.49236419099992],
              [-57.45099850199995, -63.510837497999944],
              [-57.45840410099993, -63.53378671699994],
              [-57.38609778599994, -63.541680596999925],
              [-57.42072506399995, -63.56194426899992],
              [-57.48216712099992, -63.565524997999944],
              [-57.686390753999945, -63.5525041649999],
              [-57.71556555899991, -63.55413176899992],
              [-57.72883053299995, -63.566664320999905],
              [-57.74058997299994, -63.580743096999925],
              [-57.765614386999914, -63.587009372999944],
              [-57.72642981699994, -63.598728122999944],
              [-57.604400193999936, -63.60247161299992],
              [-57.61851966099994, -63.606133721999925],
              [-57.65575110599991, -63.62509530999995],
              [-57.67324785099993, -63.63046640399995],
              [-57.69969641799992, -63.630791924999926],
              [-57.70807857999995, -63.63250090899993],
              [-57.71597245999993, -63.636651299999926],
              [-57.72769120999993, -63.647556247999944],
              [-57.73399817599994, -63.65195077899995],
              [-57.750884568999936, -63.65634530999995],
              [-57.7669164699999, -63.65447356599992],
              [-57.783314581999946, -63.6501604149999],
              [-57.80182857999995, -63.647556247999944],
              [-57.84292558499993, -63.6482072899999],
              [-57.864165818999936, -63.65178801899992],
              [-57.88133704299992, -63.65943775799991],
              [-57.877023891999954, -63.66106536299992],
              [-57.86823482999995, -63.66529713299991],
              [-57.86367753799993, -63.66676197699991],
              [-57.86538652299993, -63.66936614399992],
              [-57.886708136999914, -63.681898695999905],
              [-57.895375128999945, -63.68377044099992],
              [-57.905140753999945, -63.684665622999944],
              [-57.92406165299991, -63.68401458099993],
              [-57.991118943999936, -63.670993747999944],
              [-58.03359941299993, -63.67327239399992],
              [-58.077056443999936, -63.66285572699991],
              [-58.097727016999954, -63.663995049999926],
              [-58.117176886999914, -63.674493096999925],
              [-58.15416419199994, -63.705010674999926],
              [-58.17528235599991, -63.71640390399995],
              [-58.29246985599991, -63.75359465899993],
              [-58.32921301999994, -63.77654387799993],
              [-58.38121497299994, -63.83066171699994],
              [-58.400461391999954, -63.84221770599993],
              [-58.41978919199994, -63.84343840899993],
              [-58.439564581999946, -63.840508721999925],
              [-58.45726477799991, -63.84254322699991],
              [-58.470692511999914, -63.85865650799991],
              [-58.46515865799995, -63.861586195999905],
              [-58.45470130099994, -63.869398695999905],
              [-58.44908606699994, -63.87200286299992],
              [-58.49913489499994, -63.91033294099992],
              [-58.61900794199994, -63.94475676899992],
              [-58.659087693999936, -63.96404387799993],
              [-58.70470130099994, -63.994805596999925],
              [-58.733306443999936, -64.03142669099992],
              [-58.72305253799993, -64.06764088299991],
              [-58.70738684799994, -64.0876604149999],
              [-58.71328691299993, -64.09775155999995],
              [-58.75177975199995, -64.11467864399992],
              [-58.77131100199995, -64.13152434699992],
              [-58.784413214999915, -64.14755624799994],
              [-58.80650794199994, -64.18694426899992],
              [-58.80899003799993, -64.19540780999995],
              [-58.81090247299994, -64.20574309699992],
              [-58.81383216099994, -64.21477629999993],
              [-58.81989498599995, -64.21868254999993],
              [-58.874989386999914, -64.21835702899995],
              [-58.89671790299991, -64.21404387799993],
              [-58.93919837099992, -64.20012786299992],
              [-59.03343665299991, -64.18889739399992],
              [-59.054798956999946, -64.19198984199994],
              [-59.06212317599994, -64.19801197699991],
              [-59.07266191299993, -64.21445077899995],
              [-59.08165442599994, -64.21786874799994],
              [-59.093861456999946, -64.22063567499993],
              [-59.10789954299992, -64.22730885199991],
              [-59.11628170499995, -64.23650481599992],
              [-59.11164303299995, -64.24651458099993],
              [-59.08897864499994, -64.25628020599993],
              [-58.76992753799993, -64.28240325299993],
              [-58.75454667899993, -64.29338958099993],
              [-58.74868730399993, -64.31650155999995],
              [-58.761382615999935, -64.33220794099992],
              [-58.791127081999946, -64.33863697699991],
              [-58.84752356699994, -64.33847421699994],
              [-58.87340247299994, -64.3415666649999],
              [-58.92259680899991, -64.35735442499993],
              [-58.94945227799991, -64.35735442499993],
              [-58.93317623599995, -64.3806291649999],
              [-58.90587317599994, -64.40007903399993],
              [-58.87474524599992, -64.41285572699991],
              [-58.810658331999946, -64.41741301899992],
              [-58.77989661399994, -64.43173593499995],
              [-58.76203365799995, -64.45867278399993],
              [-58.76402747299994, -64.49863046699994],
              [-58.78392493399991, -64.5276018209999],
              [-58.81578528599994, -64.5427385399999],
              [-58.889881964999915, -64.55152760199991],
              [-58.91706295499995, -64.54656340899993],
              [-58.954741990999935, -64.53248463299991],
              [-58.99083411399994, -64.51433684699992],
              [-59.01305091099994, -64.49675872199992],
              [-58.992746548999946, -64.48357512799993],
              [-58.98607337099992, -64.46347421699994],
              [-58.993031378999945, -64.44345468499995],
              [-59.013661261999914, -64.43043385199991],
              [-59.03624426999994, -64.43027109199994],
              [-59.1712133449999, -64.45916106599992],
              [-59.223215298999946, -64.46103280999995],
              [-59.27529863199993, -64.4548479149999],
              [-59.33088131399995, -64.44003671699994],
              [-59.36750240799995, -64.41155364399992],
              [-59.417632615999935, -64.33082447699991],
              [-59.46393795499995, -64.31064218499995],
              [-59.48778235599991, -64.31161874799994],
              [-59.516468878999945, -64.31715260199991],
              [-59.54393469999991, -64.3264299459999],
              [-59.5637914699999, -64.33879973799992],
              [-59.607533331999946, -64.37859465899993],
              [-59.63239498599995, -64.39072030999995],
              [-59.662180141999954, -64.39153411299992],
              [-59.649281378999945, -64.40691497199992],
              [-59.62218176999994, -64.43108489399992],
              [-59.6106664699999, -64.44801197699991],
              [-59.61156165299991, -64.46624114399992],
              [-59.64098059799994, -64.50237395599993],
              [-59.64924068899995, -64.52027760199991],
              [-59.6243383449999, -64.5134416649999],
              [-59.604359503999945, -64.51067473799992],
              [-59.58556067599994, -64.51425546699994],
              [-59.5637914699999, -64.52662525799991],
              [-59.550892706999946, -64.5446916649999],
              [-59.55540930899991, -64.56259530999995],
              [-59.57079016799992, -64.57781340899993],
              [-59.591053839999915, -64.58798593499995],
              [-59.635609503999945, -64.59433359199994],
              [-59.67992102799991, -64.58855559699992],
              [-59.76891028599994, -64.56698984199994],
              [-59.75914466099994, -64.55462004999993],
              [-59.75544186099995, -64.54216887799993],
              [-59.74909420499995, -64.49618905999995],
              [-59.75422115799995, -64.43629322699991],
              [-59.77017167899993, -64.42473723799992],
              [-59.78986568899995, -64.41985442499993],
              [-59.83079993399991, -64.41716887799993],
              [-59.91759192599994, -64.39348723799992],
              [-59.95750891799992, -64.38746510199991],
              [-60.00731360599991, -64.39837004999993],
              [-59.989125128999945, -64.42848072699991],
              [-59.987212693999936, -64.44198984199994],
              [-59.99583899599992, -64.45647551899992],
              [-60.00951087099992, -64.46803150799991],
              [-60.02452551999994, -64.47625090899993],
              [-60.04076087099992, -64.48170338299991],
              [-60.18228105399993, -64.51336028399993],
              [-60.223866339999915, -64.5158830709999],
              [-60.234486456999946, -64.52068450299993],
              [-60.24571692599994, -64.53606536299992],
              [-60.25275631399995, -64.55291106599992],
              [-60.26195227799991, -64.56609465899993],
              [-60.279286261999914, -64.57073333099993],
              [-60.34683183499993, -64.5373674459999],
              [-60.364165818999936, -64.53142669099992],
              [-60.421986456999946, -64.52483489399992],
              [-60.38776607999995, -64.59295012799993],
              [-60.37596594999991, -64.6071916649999],
              [-60.36286373599995, -64.61760833099993],
              [-60.355539516999954, -64.62818775799991],
              [-60.36091061099995, -64.64364999799994],
              [-60.37462317599994, -64.64804452899995],
              [-60.39745032499991, -64.64617278399993],
              [-60.43724524599992, -64.63876718499995],
              [-60.45665442599994, -64.63909270599993],
              [-60.46890214799993, -64.64519622199992],
              [-60.48033606699994, -64.65439218499995],
              [-60.49718176999994, -64.66399504999993],
              [-60.63630123599995, -64.69654713299991],
              [-60.66588294199994, -64.70867278399993],
              [-60.70262610599991, -64.73154062299994],
              [-60.72325598899994, -64.7580705709999],
              [-60.70494544199994, -64.7810197899999],
              [-60.73517818899995, -64.81096770599993],
              [-60.819569464999915, -64.8435197899999],
              [-60.85606848899994, -64.8635393209999],
              [-61.00829016799992, -64.98748137799993],
              [-61.05174719999991, -65.01091887799993],
              [-61.09752356699994, -65.00872161299992],
              [-61.14513098899994, -64.99879322699991],
              [-61.19432532499991, -64.9997697899999],
              [-61.38121497299994, -65.05331796699994],
              [-61.39000403599994, -65.05169036299992],
              [-61.39834550699993, -65.04599374799994],
              [-61.42292232999995, -65.02166106599992],
              [-61.42804928299995, -65.01474374799994],
              [-61.43541419199994, -65.00888437299994],
              [-61.518462693999936, -64.97909921699994],
              [-61.54141191299993, -64.97421640399995],
              [-61.72874915299991, -64.96868254999993],
              [-61.75031490799995, -64.97535572699991],
              [-61.75621497299994, -64.99293385199991],
              [-61.74445553299995, -65.07390715899993],
              [-61.73936926999994, -65.08782317499993],
              [-61.73265540299991, -65.09254322699991],
              [-61.723500128999945, -65.09490325299993],
              [-61.69310462099992, -65.11256275799991],
              [-61.67463131399995, -65.11907317499993],
              [-61.63438880099994, -65.12558359199994],
              [-61.58348548099991, -65.12509530999995],
              [-61.568470831999946, -65.13209400799991],
              [-61.55577551999994, -65.15789153399993],
              [-61.60814368399991, -65.16985442499993],
              [-61.626210089999915, -65.1701799459999],
              [-61.60448157499991, -65.19963958099993],
              [-61.60643469999991, -65.22478606599992],
              [-61.62755286399994, -65.24138762799993],
              [-61.662993943999936, -65.24537525799991],
              [-61.73355058499993, -65.24098072699991],
              [-61.80370032499991, -65.24675872199992],
              [-61.83039303299995, -65.24187590899993],
              [-61.931630011999914, -65.19329192499993],
              [-61.96117102799991, -65.19133879999993],
              [-61.99657141799992, -65.19939544099992],
              [-62.0305883449999, -65.21331145599993],
              [-62.05573482999995, -65.22926197699991],
              [-62.02171790299991, -65.24911874799994],
              [-62.03888912699995, -65.26165129999993],
              [-62.125070766999954, -65.2927385399999],
              [-62.14875240799995, -65.29843515399995],
              [-62.19831295499995, -65.3044572899999],
              [-62.18732662699995, -65.3303361959999],
              [-62.1751195949999, -65.3440080709999],
              [-62.15733801999994, -65.35027434699992],
              [-62.032093878999945, -65.37224700299993],
              [-62.045765753999945, -65.38347747199992],
              [-62.058583136999914, -65.38990650799991],
              [-62.07241777299993, -65.3928361959999],
              [-62.08946692599994, -65.39348723799992],
              [-62.09544837099992, -65.40309010199991],
              [-62.09825598899994, -65.42489999799994],
              [-62.097767706999946, -65.44817473799992],
              [-62.094309048999946, -65.46249765399995],
              [-62.06737219999991, -65.47730885199991],
              [-61.99083411399994, -65.48503997199992],
              [-61.96084550699993, -65.49358489399992],
              [-61.950062628999945, -65.50497812299994],
              [-61.93390865799995, -65.53289153399993],
              [-61.92210852799991, -65.54119231599992],
              [-61.88145911399994, -65.54876067499993],
              [-61.839955206999946, -65.54794687299994],
              [-61.7669164699999, -65.53085702899995],
              [-61.72996985599991, -65.52947356599992],
              [-61.70099850199995, -65.54566822699991],
              [-61.724720831999946, -65.56210702899995],
              [-61.75015214799993, -65.5700822899999],
              [-61.87417558499993, -65.57935963299991],
              [-61.905506964999915, -65.5764299459999],
              [-61.93814042899993, -65.56414153399993],
              [-61.95750891799992, -65.56487395599993],
              [-62.04637610599991, -65.59050872199992],
              [-62.06582597599993, -65.59254322699991],
              [-62.07994544199994, -65.59636809699992],
              [-62.08690344999991, -65.60621510199991],
              [-62.084828253999945, -65.6267229149999],
              [-62.077788865999935, -65.63591887799993],
              [-62.06700598899994, -65.64080169099992],
              [-62.05772864499994, -65.64853280999995],
              [-62.05492102799991, -65.6662736959999],
              [-62.066070115999935, -65.69198984199994],
              [-62.08971106699994, -65.71160247199992],
              [-62.11929277299993, -65.72576262799993],
              [-62.14826412699995, -65.73503997199992],
              [-62.19102942599994, -65.74146900799991],
              [-62.206288214999915, -65.74667734199994],
              [-62.21812903599994, -65.75448984199994],
              [-62.24461829299992, -65.77629973799992],
              [-62.25352942599994, -65.78118254999993],
              [-62.313710089999915, -65.78630950299993],
              [-62.34166419199994, -65.79509856599992],
              [-62.361887173999946, -65.8142229149999],
              [-62.36245683499993, -65.82740650799991],
              [-62.35301673099991, -65.83855559699992],
              [-62.34129798099991, -65.84872812299994],
              [-62.3352758449999, -65.8591447899999],
              [-62.339955206999946, -65.87118905999995],
              [-62.37242591099994, -65.91570403399993],
              [-62.28258216099994, -65.9221330709999],
              [-62.26431230399993, -65.92864348799992],
              [-62.26235917899993, -65.93889739399992],
              [-62.26642818899995, -65.97177499799994],
              [-62.266184048999946, -65.9841447899999],
              [-62.25877844999991, -65.99928150799991],
              [-62.24840247299994, -66.0095354149999],
              [-62.0227758449999, -66.11150481599992],
              [-61.91486568899995, -66.13339609199994],
              [-61.86119544199994, -66.13339609199994],
              [-61.80931555899991, -66.12029387799993],
              [-61.775949673999946, -66.10654062299994],
              [-61.75291907499991, -66.10222747199992],
              [-61.73387610599991, -66.11174895599993],
              [-61.712147589999915, -66.13958098799992],
              [-61.694243943999936, -66.14617278399993],
              [-61.59601803299995, -66.16562265399995],
              [-61.600453253999945, -66.13860442499993],
              [-61.61266028599994, -66.1130510399999],
              [-61.64391028599994, -66.06568775799991],
              [-61.64712480399993, -66.03362395599993],
              [-61.61799068899995, -66.02190520599993],
              [-61.57762610599991, -66.02271900799991],
              [-61.33934485599991, -66.0876604149999],
              [-61.30907141799992, -66.08660247199992],
              [-61.31598873599995, -66.06308359199994],
              [-61.32013912699995, -66.03980885199991],
              [-61.316477016999954, -66.01816171699994],
              [-61.30016028599994, -65.99911874799994],
              [-61.32188880099994, -65.98113372199992],
              [-61.34609941299993, -65.95582447699991],
              [-61.35537675699993, -65.93230559699992],
              [-61.33275305899991, -65.9196916649999],
              [-61.275502081999946, -65.91253020599993],
              [-61.24461829299992, -65.91285572699991],
              [-61.22398841099994, -65.9221330709999],
              [-61.20030676999994, -65.94231536299992],
              [-61.116078253999945, -65.98447030999995],
              [-61.10684160099993, -65.99537525799991],
              [-61.09015865799995, -66.02337004999993],
              [-61.080189581999946, -66.03036874799994],
              [-61.063343878999945, -66.03362395599993],
              [-61.031239386999914, -66.03590260199991],
              [-61.01406816299993, -66.03435637799993],
              [-61.016835089999915, -66.0139299459999],
              [-61.01838131399995, -65.92441171699994],
              [-61.006703253999945, -65.91277434699992],
              [-60.9856664699999, -65.91171640399995],
              [-60.93276933499993, -65.91659921699994],
              [-60.86986243399991, -65.91122812299994],
              [-60.57750403599994, -65.94011809699992],
              [-60.54710852799991, -65.95826588299991],
              [-60.563384568999936, -65.99675872199992],
              [-60.60187740799995, -66.03573984199994],
              [-60.63776607999995, -66.05510833099993],
              [-60.65733801999994, -66.05022551899992],
              [-60.681304490999935, -66.0412736959999],
              [-60.69985917899993, -66.04192473799992],
              [-60.70287024599992, -66.06560637799993],
              [-60.69823157499991, -66.09140390399995],
              [-60.69790605399993, -66.11630624799994],
              [-60.70836341099994, -66.13079192499993],
              [-60.73595130099994, -66.12493254999993],
              [-60.794585740999935, -66.09856536299992],
              [-60.815012173999946, -66.08473072699991],
              [-60.82066809799994, -66.07659270599993],
              [-60.82648678299995, -66.05510833099993],
              [-60.83177649599992, -66.04753997199992],
              [-60.84019934799994, -66.04534270599993],
              [-60.900461391999954, -66.03948333099993],
              [-60.91030839799993, -66.04021575299993],
              [-60.91641191299993, -66.0466447899999],
              [-60.921538865999935, -66.05999114399992],
              [-60.926991339999915, -66.06609465899993],
              [-60.935658331999946, -66.06845468499995],
              [-61.00454667899993, -66.07350025799991],
              [-61.02407792899993, -66.08277760199991],
              [-61.03897050699993, -66.10662200299993],
              [-61.02220618399991, -66.1325822899999],
              [-60.97061113199993, -66.15618254999993],
              [-60.875884568999936, -66.18759530999995],
              [-60.88353430899991, -66.19841887799993],
              [-60.90615800699993, -66.22112395599993],
              [-60.90990149599992, -66.22763437299994],
              [-60.90387936099995, -66.24529387799993],
              [-60.90465247299994, -66.25823333099993],
              [-60.91197669199994, -66.26962655999995],
              [-60.970773891999954, -66.32586028399993],
              [-60.99474036399994, -66.34148528399993],
              [-61.0286352199999, -66.34954192499993],
              [-61.09024003799993, -66.35222747199992],
              [-61.119699673999946, -66.34661223799992],
              [-61.14631100199995, -66.33245208099993],
              [-61.167632615999935, -66.30478280999995],
              [-61.16388912699995, -66.28053150799991],
              [-61.15086829299992, -66.25481536299992],
              [-61.14395097599993, -66.22283294099992],
              [-61.15737870999993, -66.20037200299993],
              [-61.18740800699993, -66.1814104149999],
              [-61.24876868399991, -66.15878671699994],
              [-61.28477942599994, -66.15447356599992],
              [-61.35570227799991, -66.15943775799991],
              [-61.391509568999936, -66.15545012799993],
              [-61.417958136999914, -66.14137135199991],
              [-61.44383704299992, -66.12314218499995],
              [-61.46865800699993, -66.11435312299994],
              [-61.49242102799991, -66.12859465899993],
              [-61.50047766799992, -66.15374114399992],
              [-61.50365149599992, -66.19255950299993],
              [-61.50137285099993, -66.23211028399993],
              [-61.49351966099994, -66.25986093499995],
              [-61.52196204299992, -66.25107187299994],
              [-61.573109503999945, -66.22600676899992],
              [-61.60118567599994, -66.21843840899993],
              [-61.73127193899995, -66.20045338299991],
              [-61.76439368399991, -66.2028947899999],
              [-61.78038489499994, -66.21298593499995],
              [-61.778553839999915, -66.2302385399999],
              [-61.757923956999946, -66.25481536299992],
              [-61.72883053299995, -66.28004322699991],
              [-61.69676673099991, -66.30095794099992],
              [-61.68236243399991, -66.31658294099992],
              [-61.68903561099995, -66.33131275799991],
              [-61.70270748599995, -66.34417083099993],
              [-61.709095831999946, -66.35426197699991],
              [-61.70132402299993, -66.36679452899995],
              [-61.66930091099994, -66.3923479149999],
              [-61.68529212099992, -66.44394296699994],
              [-61.69408118399991, -66.45810312299994],
              [-61.71788489499994, -66.47234465899993],
              [-61.750884568999936, -66.47771575299993],
              [-61.78490149599992, -66.47478606599992],
              [-61.81163489499994, -66.46445077899995],
              [-61.834095831999946, -66.44264088299991],
              [-61.846547003999945, -66.41887786299992],
              [-61.856312628999945, -66.39251067499993],
              [-61.89244544199994, -66.32830169099992],
              [-61.899281378999945, -66.3225236959999],
              [-61.91738847599993, -66.31894296699994],
              [-61.92552649599992, -66.31511809699992],
              [-61.95079505099994, -66.28785572699991],
              [-61.9641820949999, -66.27654387799993],
              [-61.98232988199993, -66.26995208099993],
              [-61.963002081999946, -66.24081796699994],
              [-61.95498613199993, -66.22283294099992],
              [-61.955637173999946, -66.20777760199991],
              [-61.97020423099991, -66.19841887799993],
              [-61.99266516799992, -66.19687265399995],
              [-62.11168372299994, -66.20663827899995],
              [-62.14708411399994, -66.20387135199991],
              [-62.188710089999915, -66.18434010199991],
              [-62.22032630099994, -66.17424895599993],
              [-62.25804602799991, -66.17538827899995],
              [-62.33079993399991, -66.18743254999993],
              [-62.39517167899993, -66.18450286299992],
              [-62.416127081999946, -66.18629322699991],
              [-62.47402910099993, -66.20761484199994],
              [-62.494984503999945, -66.21184661299992],
              [-62.66828365799995, -66.22747161299992],
              [-62.7005102199999, -66.23756275799991],
              [-62.73851477799991, -66.26051197699991],
              [-62.76463782499991, -66.28899504999993],
              [-62.76089433499993, -66.31609465899993],
              [-62.69408118399991, -66.3552385399999],
              [-62.61758378799993, -66.37981536299992],
              [-62.55113684799994, -66.41318124799994],
              [-62.51447506399995, -66.47820403399993],
              [-62.63149980399993, -66.49236419099992],
              [-62.69041907499991, -66.50994231599992],
              [-62.7219945949999, -66.54290129999993],
              [-62.70372473899994, -66.58074309699992],
              [-62.64199785099993, -66.59246184699992],
              [-62.51968339799993, -66.59392669099992],
              [-62.54759680899991, -66.62493254999993],
              [-62.55443274599992, -66.64185963299991],
              [-62.55549068899995, -66.66472747199992],
              [-62.50568600199995, -66.66057708099993],
              [-62.48375403599994, -66.6545549459999],
              [-62.457915818999936, -66.64332447699991],
              [-62.4602758449999, -66.67115650799991],
              [-62.46642005099994, -66.69003671699994],
              [-62.480580206999946, -66.70273202899995],
              [-62.50694739499994, -66.71249765399995],
              [-62.534087693999936, -66.7185197899999],
              [-62.58901933499993, -66.72454192499993],
              [-62.6438695949999, -66.72454192499993],
              [-62.665679490999935, -66.71884530999995],
              [-62.78823808499993, -66.6643205709999],
              [-62.800445115999935, -66.6486955709999],
              [-62.80101477799991, -66.60898202899995],
              [-62.80410722599993, -66.59889088299991],
              [-62.81615149599992, -66.58953215899993],
              [-62.828684048999946, -66.58652109199994],
              [-62.83922278599994, -66.58171965899993],
              [-62.84544837099992, -66.56698984199994],
              [-62.85147050699993, -66.53720468499995],
              [-62.86168372299994, -66.51327890399995],
              [-62.87865149599992, -66.49374765399995],
              [-62.905140753999945, -66.47673919099992],
              [-63.162993943999936, -66.35295989399992],
              [-63.177398240999935, -66.3342424459999],
              [-63.183257615999935, -66.3244768209999],
              [-63.19766191299993, -66.30575937299994],
              [-63.2024633449999, -66.29566822699991],
              [-63.20327714799993, -66.27996184699992],
              [-63.19957434799994, -66.26962655999995],
              [-63.199330206999946, -66.26051197699991],
              [-63.21084550699993, -66.24871184699992],
              [-63.23460852799991, -66.23943450299993],
              [-63.25739498599995, -66.24277109199994],
              [-63.302845831999946, -66.26311614399992],
              [-63.31899980399993, -66.26628997199992],
              [-63.33043372299994, -66.26311614399992],
              [-63.34142005099994, -66.25855885199991],
              [-63.356312628999945, -66.25701262799993],
              [-63.40298417899993, -66.25750090899993],
              [-63.41893469999991, -66.25457122199992],
              [-63.430572068999936, -66.24993254999993],
              [-63.44717363199993, -66.23699309699992],
              [-63.456288214999915, -66.23235442499993],
              [-63.46947180899991, -66.2302385399999],
              [-63.49649003799993, -66.23113372199992],
              [-63.50890051999994, -66.22926197699991],
              [-63.52183997299994, -66.2224260399999],
              [-63.546864386999914, -66.20322030999995],
              [-63.56012936099995, -66.19784921699994],
              [-63.57335364499994, -66.19841887799993],
              [-63.61266028599994, -66.21200937299994],
              [-63.66319739499994, -66.21445077899995],
              [-63.81159420499995, -66.18889739399992],
              [-63.78433183499993, -66.2033830709999],
              [-63.75576738199993, -66.2146135399999],
              [-63.78648841099994, -66.23186614399992],
              [-63.76915442599994, -66.24130624799994],
              [-63.712147589999915, -66.25042083099993],
              [-63.752023891999954, -66.26181405999995],
              [-63.83458411399994, -66.26360442499993],
              [-63.87413489499994, -66.27263762799993],
              [-63.836781378999945, -66.2907854149999],
              [-63.79751542899993, -66.29851653399993],
              [-63.71524003799993, -66.30022551899992],
              [-63.72105872299994, -66.3044572899999],
              [-63.7317602199999, -66.31503671699994],
              [-63.737538214999915, -66.31943124799994],
              [-63.63809160099993, -66.3337541649999],
              [-63.58608964799993, -66.35222747199992],
              [-63.57371985599991, -66.35898202899995],
              [-63.56973222599993, -66.37004973799992],
              [-63.57335364499994, -66.39120859199994],
              [-63.583241339999915, -66.3943010399999],
              [-63.90330969999991, -66.38160572699991],
              [-63.886382615999935, -66.40943775799991],
              [-63.845814581999946, -66.42449309699992],
              [-63.76130123599995, -66.43499114399992],
              [-63.8509008449999, -66.44215260199991],
              [-63.87657630099994, -66.44784921699994],
              [-63.891835089999915, -66.45940520599993],
              [-63.90196692599994, -66.47763437299994],
              [-63.91197669199994, -66.50261809699992],
              [-63.804798956999946, -66.52971770599993],
              [-63.82335364499994, -66.54387786299992],
              [-63.82555091099994, -66.55917734199994],
              [-63.815337693999936, -66.57415129999993],
              [-63.79702714799993, -66.58847421699994],
              [-63.87242591099994, -66.59734465899993],
              [-63.89683997299994, -66.60320403399993],
              [-63.92642167899993, -66.60711028399993],
              [-63.95099850199995, -66.59889088299991],
              [-63.99624589799993, -66.56658294099992],
              [-64.02122962099992, -66.55754973799992],
              [-64.04157467399995, -66.56454843499995],
              [-64.05760657499991, -66.58131275799991],
              [-64.06993567599994, -66.60198333099993],
              [-64.07966061099995, -66.62664153399993],
              [-64.08653723899994, -66.63160572699991],
              [-64.11286373599995, -66.63290780999995],
              [-64.12608801999994, -66.63616301899992],
              [-64.13491777299993, -66.64316171699994],
              [-64.13255774599992, -66.65447356599992],
              [-64.11115475199995, -66.6779924459999],
              [-64.09080969999991, -66.68840911299992],
              [-63.984038865999935, -66.6955705709999],
              [-63.93618730399993, -66.70419687299994],
              [-63.84137936099995, -66.73894622199992],
              [-63.75133216099994, -66.78769296699994],
              [-63.75617428299995, -66.79241301899992],
              [-63.76431230399993, -66.80388762799993],
              [-63.769195115999935, -66.8083635399999],
              [-63.71983801999994, -66.86207447699991],
              [-63.755523240999935, -66.89763762799993],
              [-63.831288214999915, -66.91790129999993],
              [-64.04442298099991, -66.93621184699992],
              [-64.11339270699995, -66.92815520599993],
              [-64.19347083199995, -66.88591887799993],
              [-64.22545325399994, -66.8733049459999],
              [-64.25536048099991, -66.84823984199994],
              [-64.27196204299992, -66.8415666649999],
              [-64.30882727799991, -66.83652109199994],
              [-64.33389238199993, -66.85149504999993],
              [-64.34959876199991, -66.88494231599992],
              [-64.36851966099994, -66.91122812299994],
              [-64.43423417899993, -66.89853280999995],
              [-64.51598059799994, -66.90496184699992],
              [-64.54076087099992, -66.89462655999995],
              [-64.55093339799993, -66.8733049459999],
              [-64.54869544199994, -66.86248137799993],
              [-64.54076087099992, -66.85198333099993],
              [-64.53359941299993, -66.8318010399999],
              [-64.52692623599995, -66.75676848799992],
              [-64.59911048099991, -66.77410247199992],
              [-64.60627193899995, -66.7732072899999],
              [-64.61221269399994, -66.7697893209999],
              [-64.61790930899991, -66.7678361959999],
              [-64.62385006399995, -66.7717424459999],
              [-64.64903723899994, -66.80242278399993],
              [-64.67829342399995, -66.82105885199991],
              [-64.77379309799994, -66.84563567499993],
              [-64.75731360599991, -66.86687590899993],
              [-64.71654212099992, -66.90496184699992],
              [-64.70295162699995, -66.9279924459999],
              [-64.70156816299993, -66.93914153399993],
              [-64.70392818899995, -66.97926197699991],
              [-64.71051998599995, -66.98707447699991],
              [-64.72760982999995, -66.99130624799994],
              [-64.76203365799995, -66.99293385199991],
              [-64.79088294199994, -66.98699309699992],
              [-64.81037350199995, -66.97234465899993],
              [-64.82803300699993, -66.9533830709999],
              [-64.85167395699995, -66.93523528399993],
              [-64.90489661399994, -66.9099260399999],
              [-64.93236243399991, -66.90203215899993],
              [-64.96377519399994, -66.89666106599992],
              [-64.91543535099993, -66.92489999799994],
              [-64.89195716099994, -66.94345468499995],
              [-64.88223222599993, -66.9631486959999],
              [-64.89289303299995, -66.9841447899999],
              [-64.91706295499995, -67.00448984199994],
              [-64.96629798099991, -67.03386809699992],
              [-64.95230058499993, -67.04265715899993],
              [-64.92186438699991, -67.05722421699994],
              [-64.90884355399993, -67.06609465899993],
              [-64.89785722599993, -67.08114999799994],
              [-64.88902747299994, -67.09734465899993],
              [-64.87621008999992, -67.10947030999995],
              [-64.85334225199995, -67.11223723799992],
              [-64.83804277299993, -67.10808684699992],
              [-64.80842037699995, -67.09441497199992],
              [-64.79124915299991, -67.09050872199992],
              [-64.77497311099995, -67.09050872199992],
              [-64.72541256399995, -67.09856536299992],
              [-64.73131262899994, -67.1169572899999],
              [-64.72288977799991, -67.12908294099992],
              [-64.69009355399993, -67.14837004999993],
              [-64.76512610599991, -67.16253020599993],
              [-64.85309811099995, -67.16961028399993],
              [-64.87336178299995, -67.16594817499993],
              [-64.89053300699993, -67.19198984199994],
              [-64.95055091099994, -67.2009416649999],
              [-65.06590735599991, -67.20208098799992],
              [-65.00767981699994, -67.23723723799992],
              [-64.79116777299993, -67.26213958099993],
              [-64.74913489499994, -67.30730559699992],
              [-64.83576412699995, -67.32675546699994],
              [-64.88149980399993, -67.3318010399999],
              [-64.92145748599995, -67.32463958099993],
              [-64.95588131399995, -67.30657317499993],
              [-64.97362219999991, -67.29957447699991],
              [-64.99323482999995, -67.29745859199994],
              [-65.01113847599993, -67.30266692499993],
              [-65.03722083199995, -67.32219817499993],
              [-65.05565344999991, -67.32691822699991],
              [-65.02448482999995, -67.34042734199994],
              [-65.05504309799994, -67.36060963299991],
              [-65.08893795499995, -67.36402760199991],
              [-65.12083899599992, -67.35222747199992],
              [-65.14541581899994, -67.32732512799993],
              [-65.15851803299995, -67.32317473799992],
              [-65.17780514199995, -67.33098723799992],
              [-65.21715247299994, -67.35995859199994],
              [-65.22288977799991, -67.36337655999995],
              [-65.22923743399991, -67.3650041649999],
              [-65.23843339799993, -67.36638762799993],
              [-65.24425208199995, -67.37102629999993],
              [-65.24107825399994, -67.38884856599992],
              [-65.24608313699991, -67.39462655999995],
              [-65.28506425699993, -67.40105559699992],
              [-65.32689368399991, -67.39910247199992],
              [-65.36388098899994, -67.38396575299993],
              [-65.38849850199995, -67.35076262799993],
              [-65.38829505099994, -67.33668385199991],
              [-65.3841039699999, -67.3200822899999],
              [-65.38341223899994, -67.30429452899995],
              [-65.39362545499995, -67.29192473799992],
              [-65.47687740799995, -67.26360442499993],
              [-65.47012285099993, -67.27703215899993],
              [-65.44688880099994, -67.2985979149999],
              [-65.44127356699994, -67.30624765399995],
              [-65.44322669199994, -67.32187265399995],
              [-65.45140540299991, -67.33554452899995],
              [-65.46361243399991, -67.34587981599992],
              [-65.47765051999994, -67.35222747199992],
              [-65.50544186099995, -67.35279713299991],
              [-65.53526770699995, -67.34303150799991],
              [-65.56297766799992, -67.32781340899993],
              [-65.58429928299995, -67.31129322699991],
              [-65.61595618399991, -67.3689104149999],
              [-65.57689368399991, -67.38486093499995],
              [-65.5364477199999, -67.39641692499993],
              [-65.51846269399994, -67.40748463299991],
              [-65.51451575399994, -67.44524504999993],
              [-65.50145423099991, -67.46233489399992],
              [-65.52538001199991, -67.46941497199992],
              [-65.57408606699994, -67.47730885199991],
              [-65.59666907499991, -67.48398202899995],
              [-65.61497962099992, -67.49504973799992],
              [-65.62108313699991, -67.50725676899992],
              [-65.61266028599994, -67.51775481599992],
              [-65.58763587099992, -67.52361419099992],
              [-65.58873450399994, -67.55437590899993],
              [-65.55272376199991, -67.57439544099992],
              [-65.45376542899993, -67.59978606599992],
              [-65.43846594999991, -67.60214609199994],
              [-65.43053137899994, -67.60711028399993],
              [-65.42739824099993, -67.61728280999995],
              [-65.42528235599991, -67.62851327899995],
              [-65.42027747299994, -67.63713958099993],
              [-65.40269934799994, -67.64568450299993],
              [-65.33747311099995, -67.6579729149999],
              [-65.34878495999993, -67.66920338299991],
              [-65.35968990799995, -67.69695403399993],
              [-65.36587480399993, -67.70330169099992],
              [-65.55016028599994, -67.72031015399995],
              [-65.57673092399995, -67.7287736959999],
              [-65.59215247299994, -67.75448984199994],
              [-65.56224524599992, -67.81218840899993],
              [-65.57607988199993, -67.84441497199992],
              [-65.60374915299991, -67.85711028399993],
              [-65.63927161399994, -67.86101653399993],
              [-65.70669511599993, -67.85947030999995],
              [-65.67284094999991, -67.88836028399993],
              [-65.56932532499991, -67.91423919099992],
              [-65.50177975199995, -67.94817473799992],
              [-65.47883053299995, -67.95175546699994],
              [-65.42955481699994, -67.95224374799994],
              [-65.40404212099992, -67.95769622199992],
              [-65.32917232999995, -67.98381926899992],
              [-65.38036048099991, -68.01165129999993],
              [-65.52171790299991, -68.0446916649999],
              [-65.5833227199999, -68.04412200299993],
              [-65.61644446499992, -68.04843515399995],
              [-65.63145911399994, -68.05478280999995],
              [-65.65005449099993, -68.0764299459999],
              [-65.66364498599995, -68.08660247199992],
              [-65.69334876199991, -68.0935197899999],
              [-65.75108801999994, -68.08709075299993],
              [-65.78091386599993, -68.09482187299994],
              [-65.76402747299994, -68.12851327899995],
              [-65.76016191299993, -68.14560312299994],
              [-65.76073157499991, -68.16570403399993],
              [-65.51537024599992, -68.14275481599992],
              [-65.50670325399994, -68.14690520599993],
              [-65.49876868399991, -68.15300872199992],
              [-65.48493404899995, -68.15813567499993],
              [-65.47130286399994, -68.15878671699994],
              [-65.37926184799994, -68.13933684699992],
              [-65.35163326699995, -68.14006926899992],
              [-65.27513587099992, -68.17107512799993],
              [-65.22642981699994, -68.16301848799992],
              [-65.12926184799994, -68.11337655999995],
              [-65.02562415299991, -68.0739885399999],
              [-65.01561438699991, -68.06536223799992],
              [-64.99901282499991, -68.04371510199991],
              [-64.98863684799994, -68.03671640399995],
              [-64.93740800699993, -68.02214934699992],
              [-64.94591223899994, -68.04216887799993],
              [-64.98908443899995, -68.08912525799991],
              [-64.9524633449999, -68.10051848799992],
              [-64.82921301999994, -68.10068124799994],
              [-64.83088131399995, -68.09343840899993],
              [-64.83169511599993, -68.07781340899993],
              [-64.83356686099995, -68.07048919099992],
              [-64.81118730399993, -68.07683684699992],
              [-64.79259192599994, -68.08464934699992],
              [-64.75584876199991, -68.10808684699992],
              [-64.76642818899995, -68.11598072699991],
              [-64.77139238199993, -68.12517669099992],
              [-64.77017167899993, -68.13486093499995],
              [-64.76211503799993, -68.14470794099992],
              [-64.80077063699991, -68.16375090899993],
              [-65.0051977199999, -68.22421640399995],
              [-65.04898027299993, -68.23064544099992],
              [-65.08926347599993, -68.22551848799992],
              [-65.12873287699995, -68.21005624799994],
              [-65.14745032499991, -68.20794036299992],
              [-65.16661536399994, -68.21502044099992],
              [-65.20661373599995, -68.23919036299992],
              [-65.24986731699994, -68.25660572699991],
              [-65.27049719999991, -68.25725676899992],
              [-65.28856360599991, -68.25286223799992],
              [-65.30394446499992, -68.25310637799993],
              [-65.31631425699993, -68.26799895599993],
              [-65.32872473899994, -68.27890390399995],
              [-65.35106360599991, -68.28826262799993],
              [-65.39419511599993, -68.29892343499995],
              [-65.48106848899994, -68.3083635399999],
              [-65.49388587099992, -68.31707122199992],
              [-65.49282792899993, -68.33473072699991],
              [-65.48412024599992, -68.35369231599992],
              [-65.4739477199999, -68.36589934699992],
              [-65.43639075399994, -68.38144296699994],
              [-65.39159094999991, -68.38616301899992],
              [-65.18163001199991, -68.36296965899993],
              [-65.12026933499993, -68.3669572899999],
              [-65.08112545499995, -68.36451588299991],
              [-65.06114661399994, -68.36785247199992],
              [-64.97569739499994, -68.40781015399995],
              [-64.99771074099993, -68.42351653399993],
              [-65.07713782499991, -68.46184661299992],
              [-65.17772376199991, -68.48593515399995],
              [-65.20457923099991, -68.5036760399999],
              [-65.22996985599991, -68.51653411299992],
              [-65.33926347599993, -68.52597421699994],
              [-65.34740149599992, -68.53378671699994],
              [-65.34605872299994, -68.54827239399992],
              [-65.33853105399993, -68.56340911299992],
              [-65.32799231699994, -68.5725236959999],
              [-65.31102454299992, -68.57740650799991],
              [-65.25698808499993, -68.58440520599993],
              [-65.26260331899994, -68.61834075299993],
              [-65.24380449099993, -68.62948984199994],
              [-65.18565833199995, -68.62590911299992],
              [-65.16649329299992, -68.62859465899993],
              [-65.15485592399995, -68.6350236959999],
              [-65.14411373599995, -68.64332447699991],
              [-65.12759355399993, -68.65203215899993],
              [-65.11241614499994, -68.65439218499995],
              [-65.06090247299994, -68.65032317499993],
              [-64.81615149599992, -68.68962981599992],
              [-64.78351803299995, -68.68873463299991],
              [-64.72520911399994, -68.67620208099993],
              [-64.67422441299993, -68.67107512799993],
              [-64.66148841099994, -68.67262135199991],
              [-64.65257727799991, -68.68059661299992],
              [-64.64338131399995, -68.69882577899995],
              [-64.63508053299995, -68.7107072899999],
              [-64.58726966099994, -68.7517229149999],
              [-64.57494055899991, -68.7580705709999],
              [-64.52798417899993, -68.77353280999995],
              [-64.51500403599994, -68.77239348799992],
              [-64.50186113199993, -68.76832447699991],
              [-64.48241126199991, -68.76474374799994],
              [-64.45238196499992, -68.7658830709999],
              [-64.35944576699995, -68.78443775799991],
              [-64.36864173099991, -68.76775481599992],
              [-64.38166256399995, -68.75579192499993],
              [-64.41388912699995, -68.73756275799991],
              [-64.37315833199995, -68.73837655999995],
              [-64.2747289699999, -68.77874114399992],
              [-64.08486894399994, -68.82952239399992],
              [-64.03302975199995, -68.83131275799991],
              [-64.04076087099992, -68.8103166649999],
              [-64.05288652299993, -68.79900481599992],
              [-64.13654537699995, -68.77011484199994],
              [-64.18016516799992, -68.74765390399995],
              [-64.13438880099994, -68.74749114399992],
              [-64.04670162699995, -68.75872161299992],
              [-64.00059973899994, -68.75432708099993],
              [-64.07738196499992, -68.71493905999995],
              [-64.24547278599994, -68.67229583099993],
              [-64.32583574099993, -68.64218515399995],
              [-64.28160559799994, -68.63290780999995],
              [-64.18106035099993, -68.64910247199992],
              [-64.14561926999994, -68.63176848799992],
              [-64.17495683499993, -68.61874765399995],
              [-64.20669511599993, -68.60849374799994],
              [-64.23574785099993, -68.59539153399993],
              [-64.25731360599991, -68.57382577899995],
              [-64.22838294199994, -68.57122161299992],
              [-64.13963782499991, -68.58538176899992],
              [-64.14476477799991, -68.55999114399992],
              [-64.12783769399994, -68.54501718499995],
              [-64.07640540299991, -68.52996184699992],
              [-63.989165818999936, -68.49138762799993],
              [-63.96239173099991, -68.48772551899992],
              [-63.905913865999935, -68.48894622199992],
              [-63.61719723199994, -68.45204029749993],
              [-63.32848059799994, -68.41513437299994],
              [-62.87173417899993, -68.42066822699991],
              [-62.85757402299993, -68.43328215899993],
              [-62.87319902299993, -68.45973072699991],
              [-62.90566972599993, -68.4958635399999],
              [-62.92446855399993, -68.50579192499993],
              [-62.95417232999995, -68.50750090899993],
              [-62.98216712099992, -68.5022111959999],
              [-63.11986243399991, -68.45720794099992],
              [-63.178618943999936, -68.44793059699992],
              [-63.23790442599994, -68.44646575299993],
              [-63.29238847599993, -68.45525481599992],
              [-63.32892818899995, -68.47144947699991],
              [-63.43146725199995, -68.53866952899995],
              [-63.46544348899994, -68.54753997199992],
              [-63.6634008449999, -68.5485979149999],
              [-63.70152747299994, -68.55738697699991],
              [-63.74181067599994, -68.57170989399992],
              [-63.760609503999945, -68.58098723799992],
              [-63.77757727799991, -68.59246184699992],
              [-63.80894934799994, -68.61972421699994],
              [-63.82404537699995, -68.63982512799993],
              [-63.820301886999914, -68.6526018209999],
              [-63.803618943999936, -68.66171640399995],
              [-63.77989661399994, -68.67009856599992],
              [-63.79649817599994, -68.67766692499993],
              [-63.81322180899991, -68.6799455709999],
              [-63.848500128999945, -68.67742278399993],
              [-63.81289628799993, -68.71795012799993],
              [-63.370757615999935, -68.77410247199992],
              [-63.28579667899993, -68.79973723799992],
              [-63.21231035099993, -68.83863697699991],
              [-63.27635657499991, -68.85833098799992],
              [-63.43809973899994, -68.81715260199991],
              [-63.51268469999991, -68.81324635199991],
              [-63.488392706999946, -68.83709075299993],
              [-63.38857988199993, -68.88046640399995],
              [-63.40925045499995, -68.8982072899999],
              [-63.46361243399991, -68.90292734199994],
              [-63.477121548999946, -68.92392343499995],
              [-63.40510006399995, -68.9358049459999],
              [-63.446522589999915, -68.94654713299991],
              [-63.650054490999935, -68.96013762799993],
              [-63.8098852199999, -68.94158294099992],
              [-63.82921301999994, -68.94255950299993],
              [-63.88829505099994, -68.95720794099992],
              [-63.90249589799993, -68.96697356599992],
              [-63.89708411399994, -68.98259856599992],
              [-63.8821508449999, -68.9978166649999],
              [-63.86754309799994, -69.00701262799993],
              [-63.84902910099993, -69.01043059699992],
              [-63.80703691299993, -69.01018645599993],
              [-63.62462317599994, -69.04387786299992],
              [-63.32079016799992, -69.05006275799991],
              [-63.30353756399995, -69.05559661299992],
              [-63.30508378799993, -69.07154713299991],
              [-63.3294164699999, -69.09685637799993],
              [-63.36432857999995, -69.12184010199991],
              [-63.435536261999914, -69.1579729149999],
              [-63.39635169199994, -69.18629322699991],
              [-63.34312903599994, -69.19638437299994],
              [-63.23867753799993, -69.18865325299993],
              [-63.21353105399993, -69.1794572899999],
              [-63.193918423999946, -69.16765715899993],
              [-63.17267818899995, -69.16253020599993],
              [-63.14289303299995, -69.1740861959999],
              [-63.12132727799991, -69.19133879999993],
              [-63.06037350199995, -69.25351327899995],
              [-63.05964107999995, -69.26555754999993],
              [-63.067250128999945, -69.28443775799991],
              [-63.07054602799991, -69.3064104149999],
              [-63.05699622299994, -69.32822030999995],
              [-63.01231848899994, -69.36012135199991],
              [-62.986317511999914, -69.37363046699994],
              [-62.96251380099994, -69.37900155999995],
              [-62.798939581999946, -69.34840260199991],
              [-62.74522864499994, -69.35222747199992],
              [-62.69371497299994, -69.36793385199991],
              [-62.65343176999994, -69.3889299459999],
              [-62.62157141799992, -69.42050546699994],
              [-62.595814581999946, -69.46795012799993],
              [-62.558583136999914, -69.49277109199994],
              [-62.43960527299993, -69.48723723799992],
              [-62.39728756399995, -69.51523202899995],
              [-62.39338131399995, -69.53655364399992],
              [-62.40221106699994, -69.57935963299991],
              [-62.39549719999991, -69.60507577899995],
              [-62.385609503999945, -69.62957122199992],
              [-62.38182532499991, -69.65504322699991],
              [-62.38418535099993, -69.68108489399992],
              [-62.39289303299995, -69.7068010399999],
              [-62.400949673999946, -69.71998463299991],
              [-62.41950436099995, -69.74065520599993],
              [-62.42804928299995, -69.75237395599993],
              [-62.43276933499993, -69.76409270599993],
              [-62.43423417899993, -69.77337004999993],
              [-62.437611456999946, -69.7829729149999],
              [-62.45693925699993, -69.80722421699994],
              [-62.46125240799995, -69.81552499799994],
              [-62.46788489499994, -69.82268645599993],
              [-62.51024329299992, -69.84303150799991],
              [-62.52086341099994, -69.85165780999995],
              [-62.52965247299994, -69.86394622199992],
              [-62.32725989499994, -69.91155364399992],
              [-62.31330318899995, -69.91920338299991],
              [-62.295480923999946, -69.94150155999995],
              [-62.28237870999993, -69.95183684699992],
              [-62.2962133449999, -69.95501067499993],
              [-62.30817623599995, -69.96168385199991],
              [-62.31859290299991, -69.97128671699994],
              [-62.32725989499994, -69.98259856599992],
              [-62.295480923999946, -69.99480559699992],
              [-62.26414954299992, -70.00058359199994],
              [-62.19798743399991, -70.00042083099993],
              [-62.17031816299993, -70.00676848799992],
              [-62.07396399599992, -70.05478280999995],
              [-62.00926673099991, -70.07586028399993],
              [-61.985991990999935, -70.0940080709999],
              [-61.96788489499994, -70.12542083099993],
              [-61.94835364499994, -70.1447893209999],
              [-61.88267981699994, -70.18865325299993],
              [-61.86872311099995, -70.20826588299991],
              [-61.88361568899995, -70.23170338299991],
              [-61.9173070949999, -70.25123463299991],
              [-62.014556443999936, -70.29257577899995],
              [-62.02830969999991, -70.29176197699991],
              [-62.05231686099995, -70.26458098799992],
              [-62.07103430899991, -70.25709400799991],
              [-62.114165818999936, -70.25042083099993],
              [-62.18317623599995, -70.24724700299993],
              [-62.19688880099994, -70.24309661299992],
              [-62.22508704299992, -70.22527434699992],
              [-62.23985755099994, -70.21933359199994],
              [-62.259429490999935, -70.21835702899995],
              [-62.31932532499991, -70.22454192499993],
              [-62.37437903599994, -70.21550872199992],
              [-62.393462693999936, -70.21884530999995],
              [-62.378895636999914, -70.24032968499995],
              [-62.361887173999946, -70.25318775799991],
              [-62.32217363199993, -70.27695077899995],
              [-62.346913214999915, -70.29159921699994],
              [-62.40733801999994, -70.29802825299993],
              [-62.436390753999945, -70.30478280999995],
              [-62.43016516799992, -70.31902434699992],
              [-62.419911261999914, -70.32675546699994],
              [-62.40957597599993, -70.33171965899993],
              [-62.40343176999994, -70.33782317499993],
              [-62.40416419199994, -70.35295989399992],
              [-62.41274980399993, -70.3908830709999],
              [-62.40721594999991, -70.40545012799993],
              [-62.38048255099994, -70.41399504999993],
              [-62.202788865999935, -70.41594817499993],
              [-62.17027747299994, -70.42156340899993],
              [-62.14793860599991, -70.43759530999995],
              [-62.13438880099994, -70.46868254999993],
              [-62.13646399599992, -70.49537525799991],
              [-62.15379798099991, -70.51816171699994],
              [-62.18545488199993, -70.53720468499995],
              [-62.14488684799994, -70.5525041649999],
              [-62.089833136999914, -70.54762135199991],
              [-61.93517005099994, -70.49944426899992],
              [-61.53233801999994, -70.50107187299994],
              [-61.47411048099991, -70.49309661299992],
              [-61.445423956999946, -70.49358489399992],
              [-61.41637122299994, -70.5022111959999],
              [-61.39338131399995, -70.51799895599993],
              [-61.35423743399991, -70.56113046699994],
              [-61.42943274599992, -70.59050872199992],
              [-61.68114173099991, -70.61882903399993],
              [-61.64997311099995, -70.63339609199994],
              [-61.62755286399994, -70.65007903399993],
              [-61.62539628799993, -70.67009856599992],
              [-61.65501868399991, -70.69475676899992],
              [-61.68789628799993, -70.70712655999995],
              [-61.83999589799993, -70.73691171699994],
              [-61.88223222599993, -70.7380510399999],
              [-62.00963294199994, -70.71998463299991],
              [-62.12926184799994, -70.72340260199991],
              [-62.11758378799993, -70.73691171699994],
              [-62.11620032499991, -70.74944426899992],
              [-62.12352454299992, -70.76083749799994],
              [-62.13809160099993, -70.77060312299994],
              [-62.03774980399993, -70.78476327899995],
              [-62.00576738199993, -70.79314544099992],
              [-62.01520748599995, -70.80681731599992],
              [-62.01829993399991, -70.83603280999995],
              [-62.02554277299993, -70.84677499799994],
              [-62.0403539699999, -70.85930754999993],
              [-62.046538865999935, -70.87224700299993],
              [-62.04401607999995, -70.8864885399999],
              [-62.03258216099994, -70.90300872199992],
              [-62.00377356699994, -70.92131926899992],
              [-61.97020423099991, -70.92498137799993],
              [-61.90208899599992, -70.91790129999993],
              [-61.793039516999954, -70.91961028399993],
              [-61.75845292899993, -70.90976327899995],
              [-61.74559485599991, -70.90032317499993],
              [-61.72052975199995, -70.87314218499995],
              [-61.70421301999994, -70.86207447699991],
              [-61.68517005099994, -70.85458749799994],
              [-61.66681881399995, -70.84970468499995],
              [-61.55443274599992, -70.84124114399992],
              [-61.30500240799995, -70.85605234199994],
              [-61.27651933499993, -70.86988697699991],
              [-61.261708136999914, -70.89421965899993],
              [-61.26695716099994, -70.93092213299991],
              [-61.283273891999954, -70.96103280999995],
              [-61.30728105399993, -70.98845794099992],
              [-61.337147589999915, -71.00839609199994],
              [-61.371205206999946, -71.01572030999995],
              [-61.35000566299993, -71.03378671699994],
              [-61.33385169199994, -71.03997161299992],
              [-61.2610570949999, -71.02800872199992],
              [-61.23257402299993, -71.02743905999995],
              [-61.17658443899995, -71.03337981599992],
              [-61.18455969999991, -71.0564104149999],
              [-61.216786261999914, -71.08294036299992],
              [-61.20860755099994, -71.10051848799992],
              [-61.18968665299991, -71.10906340899993],
              [-61.115793423999946, -71.11337655999995],
              [-61.020090298999946, -71.13518645599993],
              [-60.97085527299993, -71.15504322699991],
              [-60.93455969999991, -71.18222421699994],
              [-60.92536373599995, -71.22014739399992],
              [-60.966867641999954, -71.23430754999993],
              [-61.22533118399991, -71.21795012799993],
              [-61.277414516999954, -71.2243791649999],
              [-61.24364173099991, -71.2502580709999],
              [-61.20091712099992, -71.2614885399999],
              [-61.11204993399991, -71.26751067499993],
              [-61.01121985599991, -71.28606536299992],
              [-60.965402798999946, -71.30608489399992],
              [-60.92418372299994, -71.33863697699991],
              [-60.98375403599994, -71.36679452899995],
              [-61.03897050699993, -71.36687590899993],
              [-61.291900193999936, -71.31438567499993],
              [-61.361887173999946, -71.30917734199994],
              [-61.41738847599993, -71.3225236959999],
              [-61.38267981699994, -71.33277760199991],
              [-61.36538652299993, -71.34042734199994],
              [-61.33706620999993, -71.36467864399992],
              [-61.32005774599992, -71.36980559699992],
              [-61.27904212099992, -71.37363046699994],
              [-61.12930253799993, -71.41480885199991],
              [-61.15538489499994, -71.41806405999995],
              [-61.22378495999993, -71.44101327899995],
              [-61.33580481699994, -71.46591562299994],
              [-61.39000403599994, -71.46607838299991],
              [-61.5540258449999, -71.44736093499995],
              [-61.542225714999915, -71.50554778399993],
              [-61.59312903599994, -71.52988046699994],
              [-61.725819464999915, -71.53281015399995],
              [-61.70689856699994, -71.5861955709999],
              [-61.71011308499993, -71.59685637799993],
              [-61.724598761999914, -71.60466887799993],
              [-61.81362870999993, -71.62704843499995],
              [-61.87242591099994, -71.63152434699992],
              [-62.05492102799991, -71.62232838299991],
              [-62.070301886999914, -71.62517669099992],
              [-62.094634568999936, -71.63909270599993],
              [-62.112212693999936, -71.63982512799993],
              [-62.09683183499993, -71.65960051899992],
              [-62.084095831999946, -71.66985442499993],
              [-62.06822669199994, -71.6735979149999],
              [-61.673491990999935, -71.68108489399992],
              [-61.59532630099994, -71.69443124799994],
              [-61.55724036399994, -71.69060637799993],
              [-61.28380286399994, -71.59335702899995],
              [-61.270090298999946, -71.58196379999993],
              [-61.26821855399993, -71.5759416649999],
              [-61.270090298999946, -71.56926848799992],
              [-61.27065995999993, -71.56316497199992],
              [-61.26512610599991, -71.55852629999993],
              [-61.180531378999945, -71.53329843499995],
              [-61.16051184799994, -71.5315080709999],
              [-61.14126542899993, -71.53289153399993],
              [-61.11904863199993, -71.5393205709999],
              [-61.111439581999946, -71.54827239399992],
              [-61.107085740999935, -71.55966562299994],
              [-61.09483801999994, -71.57366301899992],
              [-61.06212317599994, -71.58945077899995],
              [-60.983631964999915, -71.60515715899993],
              [-60.94579016799992, -71.61907317499993],
              [-60.95970618399991, -71.62184010199991],
              [-60.97325598899994, -71.62664153399993],
              [-60.99852454299992, -71.63982512799993],
              [-60.98033606699994, -71.66082122199992],
              [-60.955067511999914, -71.66545989399992],
              [-60.900380011999914, -71.65878671699994],
              [-60.83824622299994, -71.66277434699992],
              [-60.77794348899994, -71.67701588299991],
              [-60.78652910099993, -71.69198984199994],
              [-60.80101477799991, -71.70061614399992],
              [-60.8352758449999, -71.71152109199994],
              [-60.81541907499991, -71.72844817499993],
              [-60.78587805899991, -71.74358489399992],
              [-60.771555141999954, -71.7600236959999],
              [-60.79784094999991, -71.7815080709999],
              [-60.82799231699994, -71.78899504999993],
              [-60.86180579299992, -71.7888322899999],
              [-60.957102016999954, -71.77206796699994],
              [-61.04865475199995, -71.73984140399995],
              [-61.061390753999945, -71.73308684699992],
              [-61.08702551999994, -71.71168385199991],
              [-61.09703528599994, -71.70810312299994],
              [-61.16274980399993, -71.71884530999995],
              [-61.15054277299993, -71.7287736959999],
              [-61.138335740999935, -71.75351327899995],
              [-61.12913977799991, -71.76336028399993],
              [-61.05606035099993, -71.79697030999995],
              [-61.10309811099995, -71.80559661299992],
              [-61.08804277299993, -71.81926848799992],
              [-61.06871497299994, -71.82610442499993],
              [-61.02721106699994, -71.8322893209999],
              [-61.0657445949999, -71.84531015399995],
              [-61.07331295499995, -71.85149504999993],
              [-61.08462480399993, -71.8674455709999],
              [-61.091786261999914, -71.87102629999993],
              [-61.3196508449999, -71.87509530999995],
              [-61.49722245999993, -71.85491301899992],
              [-61.77603105399993, -71.86874765399995],
              [-61.85179602799991, -71.89120859199994],
              [-61.89045162699995, -71.89763762799993],
              [-62.16567949149993, -71.90862395599993],
              [-62.44090735599991, -71.91961028399993],
              [-62.397368943999936, -71.96062590899993],
              [-62.29759680899991, -71.98748137799993],
              [-62.112212693999936, -72.0095354149999],
              [-62.13312740799995, -72.02825286299992],
              [-62.16234290299991, -72.03777434699992],
              [-62.22325598899994, -72.0505510399999],
              [-62.34911048099991, -72.09758879999993],
              [-62.31265214799993, -72.13160572699991],
              [-62.25430253799993, -72.13518645599993],
              [-62.13540605399993, -72.11126067499993],
              [-61.90811113199993, -72.09221770599993],
              [-61.73265540299991, -72.04900481599992],
              [-61.67430579299992, -72.04656340899993],
              [-61.427398240999935, -72.06519947699991],
              [-61.376210089999915, -72.07805754999993],
              [-61.28669186099995, -72.13347747199992],
              [-61.19237219999991, -72.16594817499993],
              [-61.16698157499991, -72.16985442499993],
              [-61.148548956999946, -72.15471770599993],
              [-61.15367591099994, -72.12932708099993],
              [-61.176625128999945, -72.10751718499995],
              [-61.19180253799993, -72.08733489399992],
              [-61.17369544199994, -72.06698984199994],
              [-61.11701412699995, -72.05006275799991],
              [-61.05378170499995, -72.04648202899995],
              [-60.92931067599994, -72.05331796699994],
              [-60.87059485599991, -72.04656340899993],
              [-60.75332597599993, -72.00888437299994],
              [-60.69383704299992, -71.9978166649999],
              [-60.66832434799994, -72.01018645599993],
              [-60.65453040299991, -72.04159921699994],
              [-60.652455206999946, -72.07822030999995],
              [-60.66234290299991, -72.10613372199992],
              [-60.68862870999993, -72.12021249799994],
              [-60.80060787699995, -72.13347747199992],
              [-60.86864173099991, -72.1501604149999],
              [-60.93785559799994, -72.15837981599992],
              [-60.993072068999936, -72.15081145599993],
              [-61.00938880099994, -72.15357838299991],
              [-61.07188880099994, -72.19133879999993],
              [-61.016468878999945, -72.19670989399992],
              [-60.900461391999954, -72.18645598799992],
              [-60.843006964999915, -72.18857187299994],
              [-60.74962317599994, -72.2048479149999],
              [-60.68724524599992, -72.23088958099993],
              [-60.67096920499995, -72.24228280999995],
              [-60.661773240999935, -72.25579192499993],
              [-60.66242428299995, -72.27239348799992],
              [-60.66787675699993, -72.28622812299994],
              [-60.66844641799992, -72.29892343499995],
              [-60.654408331999946, -72.31259530999995],
              [-60.674387173999946, -72.32537200299993],
              [-60.68984941299993, -72.33131275799991],
              [-60.70645097599993, -72.3318010399999],
              [-60.77163652299993, -72.31796640399995],
              [-60.81480872299994, -72.31340911299992],
              [-60.861398891999954, -72.31698984199994],
              [-60.998036261999914, -72.35621510199991],
              [-60.96593176999994, -72.36931731599992],
              [-60.69220943899995, -72.37468840899993],
              [-60.65611731699994, -72.38600025799991],
              [-60.63731848899994, -72.40732187299994],
              [-60.642567511999914, -72.4299455709999],
              [-60.6790258449999, -72.4455705709999],
              [-60.823475714999915, -72.4651018209999],
              [-61.14207923099991, -72.45419687299994],
              [-61.46467037699995, -72.40732187299994],
              [-61.45718339799993, -72.42896900799991],
              [-61.432850714999915, -72.44231536299992],
              [-61.376616990999935, -72.45720794099992],
              [-61.36563066299993, -72.46599700299993],
              [-61.373036261999914, -72.47421640399995],
              [-61.38809160099993, -72.4807268209999],
              [-61.40025794199994, -72.48447030999995],
              [-61.47101803299995, -72.4978166649999],
              [-61.43626868399991, -72.52255624799994],
              [-61.40176347599993, -72.53362395599993],
              [-61.36473548099991, -72.53329843499995],
              [-61.32168535099993, -72.52402109199994],
              [-61.275502081999946, -72.52605559699992],
              [-61.25072180899991, -72.55592213299991],
              [-61.21544348899994, -72.63811614399992],
              [-61.25796464799993, -72.65292734199994],
              [-61.42027747299994, -72.64576588299991],
              [-61.39289303299995, -72.67001718499995],
              [-61.25926673099991, -72.69133879999993],
              [-61.224598761999914, -72.70818450299993],
              [-61.20848548099991, -72.72063567499993],
              [-61.2063695949999, -72.73211028399993],
              [-61.218861456999946, -72.75269947699991],
              [-61.21532141799992, -72.7639299459999],
              [-61.20055091099994, -72.76970794099992],
              [-61.13658606699994, -72.78329843499995],
              [-61.11986243399991, -72.78045012799993],
              [-61.099598761999914, -72.76767343499995],
              [-61.084095831999946, -72.75212981599992],
              [-61.05846106699994, -72.71786874799994],
              [-61.04181881399995, -72.70159270599993],
              [-61.00438391799992, -72.68661874799994],
              [-60.863392706999946, -72.68132903399993],
              [-60.73607337099992, -72.65439218499995],
              [-60.59679114499994, -72.64999765399995],
              [-60.552398240999935, -72.65585702899995],
              [-60.520415818999936, -72.68271249799994],
              [-60.50035559799994, -72.7209611959999],
              [-60.48936926999994, -72.75628020599993],
              [-60.49168860599991, -72.79119231599992],
              [-60.51158606699994, -72.82822030999995],
              [-60.54320227799991, -72.86199309699992],
              [-60.57970130099994, -72.8903947899999],
              [-60.60033118399991, -72.90129973799992],
              [-60.66441809799994, -72.91562265399995],
              [-60.65660559799994, -72.92636484199994],
              [-60.64671790299991, -72.93474700299993],
              [-60.63512122299994, -72.94019947699991],
              [-60.62214107999995, -72.94231536299992],
              [-60.63825436099995, -72.95842864399992],
              [-60.76992753799993, -73.0354143209999],
              [-60.78221594999991, -73.04989999799994],
              [-60.76353919199994, -73.0744768209999],
              [-60.70750891799992, -73.06438567499993],
              [-60.60496985599991, -73.02239348799992],
              [-60.58885657499991, -73.00969817499993],
              [-60.57144120999993, -72.9924455709999],
              [-60.55223548099991, -72.98056405999995],
              [-60.53038489499994, -72.98357512799993],
              [-60.50536048099991, -72.99553801899992],
              [-60.42638098899994, -73.01864999799994],
              [-60.3567602199999, -73.05201588299991],
              [-60.33389238199993, -73.05559661299992],
              [-60.27574622299994, -73.04599374799994],
              [-60.246978318999936, -73.03394947699991],
              [-60.22789466099994, -73.0153947899999],
              [-60.21544348899994, -72.99537525799991],
              [-60.18374589799993, -72.9572893209999],
              [-60.10732988199993, -72.88811614399992],
              [-60.082102016999954, -72.8747697899999],
              [-60.06045488199993, -72.8693986959999],
              [-60.03555253799993, -72.86882903399993],
              [-60.010650193999936, -72.87175872199992],
              [-59.96580969999991, -72.88323333099993],
              [-59.954335089999915, -72.88836028399993],
              [-59.94937089799993, -72.89519622199992],
              [-59.9485570949999, -72.91090260199991],
              [-59.946156378999945, -72.92205169099992],
              [-59.94078528599994, -72.9318986959999],
              [-59.93114173099991, -72.94443124799994],
              [-59.90412350199995, -72.99342213299991],
              [-59.91543535099993, -73.02499765399995],
              [-59.99718176999994, -73.08163827899995],
              [-60.01553300699993, -73.09954192499993],
              [-60.03010006399995, -73.12127044099992],
              [-60.03815670499995, -73.14519622199992],
              [-60.037098761999914, -73.16985442499993],
              [-60.02798417899993, -73.18767669099992],
              [-60.01154537699995, -73.20867278399993],
              [-59.99233964799993, -73.22730885199991],
              [-59.97520911399994, -73.23821379999993],
              [-60.026600714999915, -73.27898528399993],
              [-60.09357662699995, -73.29924895599993],
              [-60.29076087099992, -73.32219817499993],
              [-60.37828528599994, -73.32170989399992],
              [-60.450428839999915, -73.30193450299993],
              [-60.46934973899994, -73.22730885199991],
              [-60.49526933499993, -73.21257903399993],
              [-60.59862219999991, -73.18482838299991],
              [-60.624663865999935, -73.19548919099992],
              [-60.63898678299995, -73.22372812299994],
              [-60.66633053299995, -73.33456796699994],
              [-60.683664516999954, -73.37127044099992],
              [-60.703114386999914, -73.39104583099993],
              [-60.734445766999954, -73.39804452899995],
              [-60.769520636999914, -73.39934661299992],
              [-60.80426998599995, -73.39511484199994],
              [-60.83462480399993, -73.38494231599992],
              [-60.82689368399991, -73.36296965899993],
              [-60.81993567599994, -73.34880950299993],
              [-60.816965298999946, -73.3337541649999],
              [-60.82066809799994, -73.30917734199994],
              [-60.87791907499991, -73.2419572899999],
              [-60.89468339799993, -73.24895598799992],
              [-60.90367591099994, -73.27019622199992],
              [-60.90990149599992, -73.29599374799994],
              [-60.91832434799994, -73.31633879999993],
              [-60.93236243399991, -73.33114999799994],
              [-60.94961503799993, -73.34286874799994],
              [-60.96906490799995, -73.35035572699991],
              [-60.98961341099994, -73.35295989399992],
              [-61.08275305899991, -73.3474260399999],
              [-61.13068600199995, -73.3376604149999],
              [-61.167632615999935, -73.31975676899992],
              [-61.21642005099994, -73.27304452899995],
              [-61.25544186099995, -73.2443986959999],
              [-61.26244055899991, -73.22673919099992],
              [-61.25454667899993, -73.2111955709999],
              [-61.22964433499993, -73.20183684699992],
              [-61.283273891999954, -73.19866301899992],
              [-61.33690344999991, -73.20387135199991],
              [-61.369984503999945, -73.20370859199994],
              [-61.397328253999945, -73.19410572699991],
              [-61.44709225199995, -73.15813567499993],
              [-61.45783443899995, -73.16318124799994],
              [-61.54442298099991, -73.17595794099992],
              [-62.00169837099992, -73.10418059699992],
              [-62.01475989499994, -73.1052385399999],
              [-62.02794348899994, -73.1115861959999],
              [-62.037993943999936, -73.12053801899992],
              [-62.04898027299993, -73.12802499799994],
              [-62.06509355399993, -73.13046640399995],
              [-61.98908443899995, -73.17351653399993],
              [-61.96133378799993, -73.18466562299994],
              [-61.64606686099995, -73.25204843499995],
              [-61.62653561099995, -73.28508879999993],
              [-61.67039954299992, -73.26848723799992],
              [-61.76610266799992, -73.24618905999995],
              [-61.95531165299991, -73.22389088299991],
              [-62.00182044199994, -73.23056405999995],
              [-61.81631425699993, -73.26018645599993],
              [-61.71125240799995, -73.30396900799991],
              [-61.63573157499991, -73.32561614399992],
              [-61.568470831999946, -73.35312265399995],
              [-61.53929602799991, -73.39218515399995],
              [-61.587880011999914, -73.3928361959999],
              [-61.68809973899994, -73.37509530999995],
              [-61.8860570949999, -73.3650041649999],
              [-61.934803839999915, -73.37216562299994],
              [-61.92674719999991, -73.39511484199994],
              [-61.91930091099994, -73.40878671699994],
              [-61.90689042899993, -73.41619231599992],
              [-61.88377844999991, -73.42058684699992],
              [-61.814442511999914, -73.42457447699991],
              [-61.729074673999946, -73.45029062299994],
              [-61.712880011999914, -73.46013762799993],
              [-61.71434485599991, -73.47779713299991],
              [-61.72012285099993, -73.49846770599993],
              [-61.71760006399995, -73.51718515399995],
              [-61.68781490799995, -73.53590260199991],
              [-61.642689581999946, -73.54371510199991],
              [-61.596262173999946, -73.54355234199994],
              [-61.562570766999954, -73.53769296699994],
              [-61.549387173999946, -73.52874114399992],
              [-61.52391516799992, -73.49879322699991],
              [-61.507801886999914, -73.48748137799993],
              [-61.48932857999995, -73.48105234199994],
              [-61.47093665299991, -73.47795989399992],
              [-61.45230058499993, -73.47779713299991],
              [-61.30211341099994, -73.49529387799993],
              [-61.27281653599994, -73.51116301899992],
              [-61.25796464799993, -73.52678801899992],
              [-61.24181067599994, -73.53582122199992],
              [-61.22297115799995, -73.53834400799991],
              [-61.1614477199999, -73.52450937299994],
              [-61.14427649599992, -73.52304452899995],
              [-61.12018795499995, -73.52402109199994],
              [-60.79954993399991, -73.5778947899999],
              [-60.844960089999915, -73.6213518209999],
              [-60.90282141799992, -73.6462541649999],
              [-61.030913865999935, -73.67294687299994],
              [-61.024322068999936, -73.67937590899993],
              [-61.012928839999915, -73.69443124799994],
              [-61.00649980399993, -73.70110442499993],
              [-61.14561926999994, -73.73788827899995],
              [-60.98623613199993, -73.74732838299991],
              [-60.93333899599992, -73.73544687299994],
              [-60.86270097599993, -73.7033830709999],
              [-60.838775193999936, -73.69833749799994],
              [-60.78425045499995, -73.69451262799993],
              [-60.76231848899994, -73.69988372199992],
              [-60.73473059799994, -73.71575286299992],
              [-60.775949673999946, -73.7404924459999],
              [-60.81395423099991, -73.77141692499993],
              [-60.87995357999995, -73.84286874799994],
              [-60.88695227799991, -73.8532854149999],
              [-60.90282141799992, -73.8889299459999],
              [-60.91079667899993, -73.89983489399992],
              [-60.96743730399993, -73.94402434699992],
              [-60.98656165299991, -73.9553361959999],
              [-61.00772050699993, -73.96200937299994],
              [-61.031239386999914, -73.96502044099992],
              [-61.232411261999914, -73.95818450299993],
              [-61.34829667899993, -73.92644622199992],
              [-61.359445766999954, -73.9201799459999],
              [-61.36656653599994, -73.91122812299994],
              [-61.37083899599992, -73.90081145599993],
              [-61.37657630099994, -73.8903947899999],
              [-61.38809160099993, -73.88176848799992],
              [-61.43773352799991, -73.87322356599992],
              [-61.54063880099994, -73.89267343499995],
              [-61.644642706999946, -73.88250090899993],
              [-61.691965298999946, -73.88616301899992],
              [-61.791005011999914, -73.90667083099993],
              [-61.746978318999936, -73.93084075299993],
              [-61.58193925699993, -73.96990325299993],
              [-61.64883378799993, -73.99293385199991],
              [-61.85928300699993, -74.02988046699994],
              [-61.77513587099992, -74.04257577899995],
              [-61.49046790299991, -74.01555754999993],
              [-61.44591223899994, -74.01995208099993],
              [-61.405181443999936, -74.03264739399992],
              [-61.37804114499994, -74.05575937299994],
              [-61.350453253999945, -74.0661760399999],
              [-61.08413652299993, -74.06324635199991],
              [-61.05577551999994, -74.07317473799992],
              [-61.05540930899991, -74.10312265399995],
              [-61.08897864499994, -74.13583749799994],
              [-61.13345292899993, -74.16415780999995],
              [-61.24156653599994, -74.20973072699991],
              [-61.404408331999946, -74.24863046699994],
              [-61.48473059799994, -74.2541643209999],
              [-61.48062089799993, -74.24374765399995],
              [-61.47398841099994, -74.23512135199991],
              [-61.46544348899994, -74.22861093499995],
              [-61.45498613199993, -74.22421640399995],
              [-61.47647050699993, -74.22063567499993],
              [-61.51073157499991, -74.23088958099993],
              [-61.52977454299992, -74.23211028399993],
              [-61.55117753799993, -74.22527434699992],
              [-61.566477016999954, -74.21249765399995],
              [-61.56940670499995, -74.1950822899999],
              [-61.55386308499993, -74.17506275799991],
              [-61.63829505099994, -74.1818986959999],
              [-61.663726365999935, -74.19052499799994],
              [-61.730132615999935, -74.24114348799992],
              [-61.75694739499994, -74.25123463299991],
              [-61.813059048999946, -74.25448984199994],
              [-61.92223059799994, -74.24325937299994],
              [-61.97809811099995, -74.24423593499995],
              [-61.950062628999945, -74.25774504999993],
              [-61.91738847599993, -74.26620859199994],
              [-61.8880102199999, -74.2776018209999],
              [-61.86937415299991, -74.29949309699992],
              [-61.87743079299992, -74.30095794099992],
              [-61.893422003999945, -74.30673593499995],
              [-61.901600714999915, -74.3083635399999],
              [-61.88463294199994, -74.32545338299991],
              [-61.85659745999993, -74.32870859199994],
              [-61.644195115999935, -74.29753997199992],
              [-61.49103756399995, -74.32887135199991],
              [-61.27871660099993, -74.3298479149999],
              [-61.068023240999935, -74.3005510399999],
              [-60.85814368399991, -74.24521249799994],
              [-60.75133216099994, -74.23552825299993],
              [-60.69115149599992, -74.23894622199992],
              [-60.65001380099994, -74.25400155999995],
              [-60.64024817599994, -74.29265715899993],
              [-60.68195553299995, -74.32480234199994],
              [-60.780140753999945, -74.3591447899999],
              [-60.883656378999945, -74.3786760399999],
              [-60.89500891799992, -74.38445403399993],
              [-60.91584225199995, -74.3982072899999],
              [-60.92422441299993, -74.40081145599993],
              [-60.93846594999991, -74.40252044099992],
              [-60.95213782499991, -74.40764739399992],
              [-60.97838294199994, -74.42115650799991],
              [-60.95885169199994, -74.42424895599993],
              [-60.940012173999946, -74.42978280999995],
              [-60.92218990799995, -74.43792083099993],
              [-60.90599524599992, -74.44915129999993],
              [-60.97789466099994, -74.49716562299994],
              [-61.06786048099991, -74.51962655999995],
              [-61.54271399599992, -74.54404062299994],
              [-61.59561113199993, -74.53728606599992],
              [-61.64293372299994, -74.49863046699994],
              [-61.66437740799995, -74.4983049459999],
              [-61.68732662699995, -74.50351327899995],
              [-61.70750891799992, -74.50579192499993],
              [-62.11278235599991, -74.46428801899992],
              [-62.205148891999954, -74.4314104149999],
              [-62.36388098899994, -74.40349700299993],
              [-62.33421790299991, -74.45810312299994],
              [-62.277455206999946, -74.49212004999993],
              [-62.21198482999995, -74.51946379999993],
              [-62.13731848899994, -74.56511809699992],
              [-62.113840298999946, -74.57000090899993],
              [-62.06509355399993, -74.57480234199994],
              [-62.033314581999946, -74.58391692499993],
              [-62.007883266999954, -74.59612395599993],
              [-61.95840410099993, -74.63250090899993],
              [-61.93517005099994, -74.65504322699991],
              [-61.92320716099994, -74.6604143209999],
              [-61.89806067599994, -74.66806405999995],
              [-61.88581295499995, -74.67327239399992],
              [-61.876942511999914, -74.68092213299991],
              [-61.86668860599991, -74.6950822899999],
              [-61.85838782499991, -74.70208098799992],
              [-61.847727016999954, -74.70427825299993],
              [-61.81704667899993, -74.70427825299993],
              [-61.80142167899993, -74.70671965899993],
              [-61.78815670499995, -74.71209075299993],
              [-61.782134568999936, -74.72177499799994],
              [-61.792225714999915, -74.77898528399993],
              [-61.825103318999936, -74.82105885199991],
              [-61.87295488199993, -74.85149504999993],
              [-62.13190670499995, -74.95159270599993],
              [-62.46727454299992, -74.99773528399993],
              [-62.52599036399994, -74.99724700299993],
              [-62.57526607999995, -74.97673919099992],
              [-62.591053839999915, -74.95110442499993],
              [-62.587147589999915, -74.92498137799993],
              [-62.57957923099991, -74.89885833099993],
              [-62.58446204299992, -74.8728166649999],
              [-62.59874426999994, -74.84832122199992],
              [-62.60895748599995, -74.82097747199992],
              [-62.60773678299995, -74.7946916649999],
              [-62.58775794199994, -74.77385833099993],
              [-62.61046301999994, -74.76336028399993],
              [-62.62604732999995, -74.76116301899992],
              [-62.66486568899995, -74.76181405999995],
              [-62.68907630099994, -74.75310637799993],
              [-62.69908606699994, -74.7365861959999],
              [-62.69399980399993, -74.71819426899992],
              [-62.6731664699999, -74.70330169099992],
              [-62.701283331999946, -74.6779924459999],
              [-62.73546301999994, -74.6779924459999],
              [-62.80724036399994, -74.70378997199992],
              [-62.84439042899993, -74.70842864399992],
              [-62.88198808499993, -74.7048479149999],
              [-63.11900794199994, -74.65227629999993],
              [-63.13849850199995, -74.65162525799991],
              [-63.15111243399991, -74.65504322699991],
              [-63.17454993399991, -74.66562265399995],
              [-63.187611456999946, -74.66863372199992],
              [-63.246937628999945, -74.66513437299994],
              [-63.265695766999954, -74.66814544099992],
              [-63.26353919199994, -74.6740861959999],
              [-63.292958136999914, -74.72014739399992],
              [-63.148426886999914, -74.78850676899992],
              [-63.10692298099991, -74.8220354149999],
              [-63.07017981699994, -74.86809661299992],
              [-63.06224524599992, -74.89251067499993],
              [-63.07689368399991, -74.9084611959999],
              [-63.10236568899995, -74.91448333099993],
              [-63.18122311099995, -74.91936614399992],
              [-63.40493730399993, -74.8986955709999],
              [-63.520090298999946, -74.86777109199994],
              [-63.573109503999945, -74.8713518209999],
              [-63.606312628999945, -74.9162736959999],
              [-63.586496548999946, -74.92229583099993],
              [-63.60973059799994, -74.93678150799991],
              [-63.642567511999914, -74.94378020599993],
              [-64.02139238199993, -74.97942473799992],
              [-64.08560136599993, -74.99863046699994],
              [-64.05479895699995, -75.00725676899992],
              [-63.99461829299992, -75.00896575299993],
              [-63.964507615999935, -75.01311614399992],
              [-63.920033331999946, -75.03183359199994],
              [-63.900380011999914, -75.03525155999995],
              [-63.62218176999991, -75.02133554449995],
              [-63.34398352799991, -75.00741952899995],
              [-63.277902798999946, -75.0153947899999],
              [-63.243804490999935, -75.02532317499993],
              [-63.06818600199995, -75.12078215899993],
              [-63.04092363199993, -75.14723072699991],
              [-63.303618943999936, -75.17742278399993],
              [-63.39000403599994, -75.17522551899992],
              [-63.470814581999946, -75.16155364399992],
              [-63.50963294199994, -75.15935637799993],
              [-63.834238247999934, -75.19182708099993],
              [-64.15884355399993, -75.22429778399993],
              [-64.20506751199991, -75.23626067499993],
              [-64.24982662699995, -75.23707447699991],
              [-64.27232825399994, -75.24114348799992],
              [-64.35716712099992, -75.27988046699994],
              [-64.40062415299991, -75.2912736959999],
              [-64.42007402299993, -75.30095794099992],
              [-64.43443762899994, -75.31755950299993],
              [-64.41201738199993, -75.32740650799991],
              [-64.39004472599993, -75.3298479149999],
              [-64.37169348899994, -75.33489348799992],
              [-64.36009680899991, -75.35198333099993],
              [-64.34898841099994, -75.36451588299991],
              [-64.32994544199994, -75.36638762799993],
              [-64.22020423099991, -75.33782317499993],
              [-64.19676673099991, -75.3357072899999],
              [-64.11143958199995, -75.3498674459999],
              [-63.76211503799993, -75.32463958099993],
              [-63.42332923099994, -75.33814869549994],
              [-63.084543423999946, -75.35165780999995],
              [-63.106678839999915, -75.38551197699991],
              [-63.16161048099991, -75.40943775799991],
              [-63.62392127199992, -75.50389983499991],
              [-64.08623206299993, -75.59836191199992],
              [-64.54854285399993, -75.69282398899992],
              [-65.01085364499994, -75.78728606599992],
              [-65.26475989499994, -75.79143645599993],
              [-65.28978430899991, -75.79697030999995],
              [-65.35562089799993, -75.83367278399993],
              [-65.37710527299993, -75.84286874799994],
              [-65.75959225199992, -75.91423919049993],
              [-66.14207923099991, -75.98560963299991],
              [-66.21861731699994, -76.01083749799994],
              [-66.69004269124994, -76.04509856574994],
              [-67.16146806549995, -76.07935963349993],
              [-67.63289343974995, -76.11362070124993],
              [-68.10431881399995, -76.14788176899992],
              [-68.12767493399991, -76.15447356599992],
              [-68.14671790299991, -76.16570403399993],
              [-68.0989477199999, -76.18206145599993],
              [-68.08324133999992, -76.1897111959999],
              [-68.05475826699995, -76.21062590899993],
              [-68.03954016799992, -76.21819426899992],
              [-68.01813717399995, -76.22112395599993],
              [-67.94920813699991, -76.21591562299994],
              [-68.33061682849991, -76.24718596799994],
              [-68.71202551999991, -76.27845631299994],
              [-69.09343421149991, -76.30972665799993],
              [-69.47484290299991, -76.34099700299993],
              [-69.48631751199991, -76.33757903399993],
              [-69.50096594999991, -76.33017343499995],
              [-69.51500403599994, -76.32675546699994],
              [-69.54678300699993, -76.32691822699991],
              [-69.60472571499992, -76.33700937299994],
              [-69.71548417899993, -76.36931731599992],
              [-69.79775956899994, -76.37688567499993],
              [-69.85265051999994, -76.39348723799992],
              [-69.87706458199995, -76.39544036299992],
              [-69.9270727199999, -76.39137135199991],
              [-70.10081946499992, -76.42392343499995],
              [-70.15387936099995, -76.44402434699992],
              [-70.18089758999992, -76.45061614399992],
              [-70.13459225199995, -76.46803150799991],
              [-70.07384192599994, -76.47323984199994],
              [-69.85407467399995, -76.45110442499993],
              [-69.8008520169999, -76.45574309699992],
              [-69.74632727799991, -76.46949635199991],
              [-70.04991614499994, -76.49871184699992],
              [-69.99673417899993, -76.52060312299994],
              [-69.81615149599992, -76.52223072699991],
              [-69.85362708199995, -76.53329843499995],
              [-69.97838294199994, -76.53460051899992],
              [-70.05695553299995, -76.54851653399993],
              [-70.09951738199993, -76.56519947699991],
              [-70.11925208199995, -76.58904387799993],
              [-70.08047441299993, -76.61736419099992],
              [-69.98802649599992, -76.62363046699994],
              [-69.82738196499992, -76.61394622199992],
              [-69.86168372299994, -76.62314218499995],
              [-69.96548417899993, -76.63225676899992],
              [-70.03018144399994, -76.6482072899999],
              [-70.09430904899995, -76.67506275799991],
              [-69.97813880099994, -76.66301848799992],
              [-69.94176184799994, -76.66716887799993],
              [-69.97134355399993, -76.68621184699992],
              [-70.01402747299994, -76.6936174459999],
              [-70.33214270699995, -76.67766692499993],
              [-70.58079993399991, -76.71087004999993],
              [-70.52892005099994, -76.71933359199994],
              [-70.36949622299994, -76.71526458099993],
              [-70.39342200399994, -76.72616952899995],
              [-70.42031816299993, -76.73064544099992],
              [-70.50283769399994, -76.73430754999993],
              [-70.58674068899995, -76.74944426899992],
              [-70.77481035099993, -76.73349374799994],
              [-70.78115800699993, -76.7360979149999],
              [-70.78746497299994, -76.7483049459999],
              [-70.79381262899994, -76.75139739399992],
              [-70.96434485599991, -76.73894622199992],
              [-71.3366999989999, -76.75086842249993],
              [-71.7090551419999, -76.76279062299994],
              [-72.0576472644999, -76.72608814899993],
              [-72.40623938699991, -76.68938567499993],
              [-72.57054602799991, -76.70452239399992],
              [-72.88141842399995, -76.6721330709999],
              [-72.89476477799991, -76.67457447699991],
              [-72.90294348899994, -76.68059661299992],
              [-72.91047115799995, -76.69475676899992],
              [-72.91738847599993, -76.70281340899993],
              [-72.92699133999992, -76.70720794099992],
              [-72.94253495999993, -76.71062590899993],
              [-72.97435462099992, -76.71257903399993],
              [-73.06045488199993, -76.69150155999995],
              [-73.49864661349991, -76.67225514099994],
              [-73.9368383449999, -76.65300872199992],
              [-73.91950436099995, -76.67148202899995],
              [-73.89940344999991, -76.68027109199994],
              [-73.79381262899994, -76.68572356599992],
              [-73.77074133999992, -76.69548919099992],
              [-73.76659094999991, -76.7190080709999],
              [-73.98155676999994, -76.69451262799993],
              [-74.08202063699991, -76.6936174459999],
              [-74.45810570633324, -76.65081145633324],
              [-74.83419077566657, -76.60800546666657],
              [-75.2102758449999, -76.56519947699991],
              [-75.25914466099994, -76.56487395599993],
              [-75.2715551419999, -76.59677499799994],
              [-75.33263098899994, -76.60312265399995],
              [-75.61343339799993, -76.56096770599993],
              [-75.66673743399991, -76.56129322699991],
              [-75.60912024599992, -76.57976653399993],
              [-75.59740149599992, -76.5876604149999],
              [-75.59260006399995, -76.60816822699991],
              [-75.60362708199995, -76.62102629999993],
              [-75.62242591099994, -76.62900155999995],
              [-75.67992102799991, -76.6447893209999],
              [-75.81041419199994, -76.63811614399992],
              [-75.89427649599992, -76.62102629999993],
              [-76.05382239499994, -76.56170012799993],
              [-76.1380102199999, -76.54900481599992],
              [-76.29906165299991, -76.56780364399992],
              [-76.37706458199995, -76.5681291649999],
              [-76.49925696499992, -76.52499765399995],
              [-76.54161536399994, -76.51677825299993],
              [-76.58397376199991, -76.52044036299992],
              [-76.6250707669999, -76.53899504999993],
              [-76.63003495999993, -76.54607512799993],
              [-76.63023841099994, -76.55364348799992],
              [-76.63182532499991, -76.56023528399993],
              [-76.64110266799992, -76.56511809699992],
              [-76.77049719999991, -76.57870859199994],
              [-76.76646887899994, -76.60751718499995],
              [-76.74986731699994, -76.62957122199992],
              [-76.72809811099995, -76.6501604149999],
              [-76.7083227199999, -76.67441171699994],
              [-76.75177975199995, -76.67009856599992],
              [-76.92906653599994, -76.6037736959999],
              [-77.11815344999991, -76.56064218499995],
              [-77.26451575399994, -76.56373463299991],
              [-77.31558183499993, -76.55486419099992],
              [-77.36489824099993, -76.53411223799992],
              [-77.45689856699994, -76.48007577899995],
              [-77.44107011599993, -76.49749114399992],
              [-77.38487708199995, -76.54501718499995],
              [-77.41437740799995, -76.55608489399992],
              [-77.50926673099991, -76.55608489399992],
              [-77.49229895699995, -76.58025481599992],
              [-77.47297115799995, -76.59644947699991],
              [-77.42589270699995, -76.6272111959999],
              [-77.49681555899991, -76.61028411299992],
              [-77.53164628799993, -76.59644947699991],
              [-77.55996660099993, -76.57708098799992],
              [-77.5918676419999, -76.54973723799992],
              [-77.69347083199995, -76.48756275799991],
              [-77.69701087099992, -76.51628997199992],
              [-77.67540442599994, -76.53508879999993],
              [-77.61432857999995, -76.55877044099992],
              [-77.50845292899993, -76.63046640399995],
              [-77.52013098899994, -76.63876718499995],
              [-77.52497311099995, -76.64910247199992],
              [-77.52521725199995, -76.67546965899993],
              [-77.53042558499993, -76.6838518209999],
              [-77.54287675699993, -76.69019947699991],
              [-77.56908118399991, -76.69882577899995],
              [-77.52358964799993, -76.72975025799991],
              [-77.18687903599994, -76.82659270599993],
              [-77.03888912699995, -76.92522551899992],
              [-76.98375403599994, -76.94784921699994],
              [-76.86790930899991, -76.97356536299992],
              [-76.83804277299993, -76.98593515399995],
              [-76.8223363919999, -77.00546640399995],
              [-76.83189856699994, -77.02605559699992],
              [-76.8633520169999, -77.0295549459999],
              [-76.97101803299995, -77.01018645599993],
              [-76.98452714799993, -77.01165129999993],
              [-76.99494381399995, -77.01482512799993],
              [-77.00649980399993, -77.02027760199991],
              [-77.0110570949999, -77.0276018209999],
              [-76.99986731699994, -77.03639088299991],
              [-76.85912024599992, -77.08562590899993],
              [-76.75035559799994, -77.07952239399992],
              [-76.72232011599993, -77.08196379999993],
              [-76.4739477199999, -77.16399504999993],
              [-76.32258053299995, -77.26287200299993],
              [-76.26671301999994, -77.28582122199992],
              [-76.08828691299993, -77.33171965899993],
              [-75.92129472599993, -77.33660247199992],
              [-75.87157141799992, -77.34954192499993],
              [-75.91055253799993, -77.36467864399992],
              [-75.81761633999992, -77.41464609199994],
              [-75.78661048099991, -77.42522551899992],
              [-75.69220943899995, -77.43710702899995],
              [-75.66812089799993, -77.44638437299994],
              [-75.5989477199999, -77.48935312299994],
              [-75.56484941299993, -77.50310637799993],
              [-75.55768795499995, -77.51091887799993],
              [-75.54967200399994, -77.52507903399993],
              [-75.53945878799993, -77.5349260399999],
              [-75.52660071499992, -77.54119231599992],
              [-75.45881100199995, -77.55201588299991],
              [-75.43667558499993, -77.54810963299991],
              [-75.36424719999991, -77.49960702899995],
              [-75.30870520699995, -77.47307708099993],
              [-75.25413977799991, -77.45761484199994],
              [-75.08039303299995, -77.43710702899995],
              [-74.60877031159995, -77.46480885199995],
              [-74.13714759019994, -77.49251067499993],
              [-73.66552486879995, -77.52021249799994],
              [-73.19390214739994, -77.54791432099992],
              [-72.72227942599994, -77.57561614399992],
              [-72.79670162699995, -77.60076262799993],
              [-72.7735082669999, -77.61980559699992],
              [-72.75987708199995, -77.63689544099992],
              [-72.76097571499992, -77.65618254999993],
              [-72.78180904899995, -77.68157317499993],
              [-72.80451412699995, -77.6989885399999],
              [-73.04328365799995, -77.80038827899995],
              [-73.08983313699991, -77.83001067499993],
              [-73.10879472599993, -77.84832122199992],
              [-73.11974036399994, -77.85637786299992],
              [-73.13117428299995, -77.8596330709999],
              [-73.15135657499991, -77.86028411299992],
              [-73.16315670499995, -77.8630510399999],
              [-73.18651282499991, -77.87664153399993],
              [-73.21104895699995, -77.88779062299994],
              [-73.3997289699999, -77.94931405999995],
              [-73.43321692599994, -77.96998463299991],
              [-73.44933020699995, -77.9743791649999],
              [-73.48127193899995, -77.97918059699992],
              [-73.49815833199995, -77.98650481599992],
              [-73.43106035099993, -77.99944426899992],
              [-73.46564693899995, -78.01474374799994],
              [-73.47760982999995, -78.0178361959999],
              [-73.49925696499992, -78.01848723799992],
              [-73.50548255099994, -78.01213958099993],
              [-73.50747636599993, -78.00359465899993],
              [-73.51646887899994, -77.99765390399995],
              [-73.54255123599995, -77.99863046699994],
              [-73.62730872299994, -78.02499765399995],
              [-73.94837398999994, -78.07708098749993],
              [-74.26943925699993, -78.1291643209999],
              [-74.18687903599994, -78.13494231599992],
              [-74.01675370999993, -78.11256275799991],
              [-73.93325761599993, -78.11239999799994],
              [-74.05565344999991, -78.13713958099993],
              [-74.47380530549992, -78.15260182049994],
              [-74.89195716099994, -78.16806405999995],
              [-74.96153723899994, -78.18222421699994],
              [-74.99787350199995, -78.18434010199991],
              [-74.99217688699991, -78.18767669099992],
              [-74.97618567599994, -78.2009416649999],
              [-74.99575761599993, -78.21998463299991],
              [-75.02025305899991, -78.22991301899992],
              [-75.04735266799992, -78.23162200299993],
              [-75.07433020699995, -78.2263322899999],
              [-75.08755449099993, -78.21965911299992],
              [-75.09386145699995, -78.21152109199994],
              [-75.09886633999992, -78.20175546699994],
              [-75.10802161399994, -78.19052499799994],
              [-75.11978105399993, -78.18181731599992],
              [-75.14903723899994, -78.16716887799993],
              [-75.21764075399994, -78.14462655999995],
              [-75.71119544159994, -78.10167408619995],
              [-76.20475012919994, -78.05872161239994],
              [-76.69830481679995, -78.01576913859994],
              [-77.19185950439994, -77.97281666479992],
              [-77.68541419199994, -77.92986419099992],
              [-77.75792395699995, -77.94589609199994],
              [-77.78331458199995, -77.94841887799993],
              [-78.23740258133328, -77.91383228966659],
              [-78.69149058066661, -77.87924570133326],
              [-79.14557857999995, -77.84465911299992],
              [-79.17349199099993, -77.8459611959999],
              [-79.31525631399995, -77.87656015399995],
              [-79.42369544199994, -77.87802499799994],
              [-79.69552568299994, -77.84547291449994],
              [-79.96735592399995, -77.81292083099993],
              [-80.02245032499991, -77.81560637799993],
              [-80.22716223899994, -77.79778411299992],
              [-80.38609778599994, -77.75156015399995],
              [-80.57640540299991, -77.72372812299994],
              [-80.76935787699995, -77.66985442499993],
              [-80.74962317599994, -77.69003671699994],
              [-80.71930904899995, -77.7048479149999],
              [-80.65689042899993, -77.7248674459999],
              [-80.70498613199993, -77.76409270599993],
              [-80.76227779899995, -77.78997161299992],
              [-81.15709387899994, -77.85230885199991],
              [-81.3985082669999, -77.83310312299994],
              [-81.66746985599991, -77.84148528399993],
              [-81.61620032499991, -77.86207447699991],
              [-81.14912314033324, -77.92402289999991],
              [-80.68204595566658, -77.98597132299992],
              [-80.21496877099992, -78.04791974599992],
              [-79.74789158633325, -78.10986816899992],
              [-79.28081440166659, -78.17181659199991],
              [-78.81373721699993, -78.23376501499992],
              [-78.34666003233326, -78.29571343799992],
              [-77.8795828476666, -78.35766186099993],
              [-77.41250566299993, -78.41961028399993],
              [-77.36656653599994, -78.44793059699992],
              [-77.36432857999995, -78.5017229149999],
              [-77.35610917899993, -78.51100025799991],
              [-77.33511308499993, -78.5251604149999],
              [-77.33071855399993, -78.53378671699994],
              [-77.33747311099995, -78.55828215899993],
              [-77.33751380099994, -78.57000090899993],
              [-77.33088131399995, -78.58806731599992],
              [-77.3294164699999, -78.59783294099992],
              [-77.33462480399993, -78.60540129999993],
              [-77.34805253799993, -78.61646900799991],
              [-77.36119544199994, -78.62444426899992],
              [-77.66344153599994, -78.7053361959999],
              [-77.70140540299991, -78.72535572699991],
              [-77.72398841099994, -78.73137786299992],
              [-77.75401770699995, -78.73577239399992],
              [-78.17755421966662, -78.75427282799993],
              [-78.60109073233328, -78.77277326199993],
              [-79.02462724499995, -78.79127369599993],
              [-79.44816375766662, -78.80977412999994],
              [-79.87170027033328, -78.82827456399994],
              [-80.29523678299995, -78.84677499799994],
              [-80.71706295479994, -78.77151458139994],
              [-81.13888912659993, -78.69625416479992],
              [-81.56071529839991, -78.62099374819992],
              [-81.9825414701999, -78.5457333315999],
              [-82.4043676419999, -78.4704729149999],
              [-82.46007239499994, -78.46998463299991],
              [-82.48704993399991, -78.46575286299992],
              [-82.88388695666659, -78.31433142199991],
              [-83.28072397933327, -78.16290998099991],
              [-83.67756100199995, -78.0114885399999],
              [-83.73570716099994, -77.97958749799994],
              [-83.7676488919999, -77.96803150799991],
              [-83.79987545499995, -77.96738046699994],
              [-83.81200110599991, -77.96982187299994],
              [-83.82412675699993, -77.97389088299991],
              [-83.8313695949999, -77.9821916649999],
              [-83.82860266799992, -77.99667734199994],
              [-83.81704667899993, -78.0119768209999],
              [-83.79010982999995, -78.03484465899993],
              [-83.78001868399991, -78.04753997199992],
              [-83.74649003799993, -78.11003997199992],
              [-83.72508704299992, -78.13567473799992],
              [-83.69530188699991, -78.15545012799993],
              [-83.66177324099993, -78.1677385399999],
              [-83.62946529899995, -78.17424895599993],
              [-83.55996660099993, -78.17717864399992],
              [-83.56773841099994, -78.18466562299994],
              [-83.59666907499991, -78.20208098799992],
              [-83.59797115799995, -78.21738046699994],
              [-83.59129798099991, -78.22625090899993],
              [-83.3797094389999, -78.29851653399993],
              [-83.30565344999991, -78.30266692499993],
              [-83.26284745999993, -78.32122161299992],
              [-83.21788489499994, -78.33456796699994],
              [-83.18163001199991, -78.36093515399995],
              [-83.02098548099991, -78.42848072699991],
              [-83.01366126199991, -78.4377580709999],
              [-83.00401770699995, -78.4607072899999],
              [-82.99498450399994, -78.46624114399992],
              [-82.94493567599994, -78.47332122199992],
              [-82.98570716099994, -78.49187590899993],
              [-83.04588782499991, -78.50481536299992],
              [-83.10533606699994, -78.50514088299991],
              [-83.14378821499992, -78.48626067499993],
              [-83.13621985599991, -78.48251718499995],
              [-83.12157141799992, -78.47283294099992],
              [-83.11375891799992, -78.46941497199992],
              [-83.15029863199993, -78.44198984199994],
              [-83.19347083199995, -78.41668059699992],
              [-83.23981686099995, -78.39853280999995],
              [-83.28579667899993, -78.39218515399995],
              [-83.37389075399994, -78.40447356599992],
              [-83.41738847599993, -78.40593840899993],
              [-83.46182206899994, -78.39275481599992],
              [-83.44758053299995, -78.37908294099992],
              [-83.42829342399995, -78.37118905999995],
              [-83.38687089799993, -78.36467864399992],
              [-83.40709387899994, -78.3518205709999],
              [-83.42886308499993, -78.34840260199991],
              [-83.4754125639999, -78.35173919099992],
              [-83.68126380099994, -78.32724374799994],
              [-83.70213782499991, -78.3342424459999],
              [-83.71190344999991, -78.34172942499993],
              [-83.73525956899994, -78.3552385399999],
              [-83.73997962099992, -78.36093515399995],
              [-83.73912512899994, -78.37542083099993],
              [-83.73473059799994, -78.38583749799994],
              [-83.72545325399994, -78.39267343499995],
              [-83.71003170499995, -78.39723072699991],
              [-83.74425208199995, -78.41814544099992],
              [-83.79234778599994, -78.42294687299994],
              [-83.88613847599993, -78.41936614399992],
              [-83.85635331899994, -78.44443124799994],
              [-83.80394446499992, -78.50107187299994],
              [-83.71963456899994, -78.56015390399995],
              [-83.54100501199991, -78.6291643209999],
              [-83.44005286399994, -78.69622161299992],
              [-83.40339107999995, -78.71493905999995],
              [-83.25352942599994, -78.77271900799991],
              [-82.91808020699995, -78.85857512799993],
              [-82.72838294199994, -78.87566497199992],
              [-82.63247636599993, -78.86394622199992],
              [-82.58568274599992, -78.86785247199992],
              [-82.56663977799991, -78.89470794099992],
              [-82.60716712099992, -78.91139088299991],
              [-82.60704505099994, -78.92962004999993],
              [-82.57949785099993, -78.94459400799991],
              [-82.51744544199994, -78.9553361959999],
              [-82.47984778599994, -78.9670549459999],
              [-82.45970618399991, -78.96982187299994],
              [-82.38902747299994, -78.96933359199994],
              [-82.06590735599994, -79.01734791499993],
              [-81.74278723899994, -79.06536223799992],
              [-81.71837317599994, -79.08074309699992],
              [-81.70689856699994, -79.09124114399992],
              [-81.68854732999995, -79.0959611959999],
              [-81.65111243399991, -79.10076262799993],
              [-81.45132402299993, -79.16725025799991],
              [-81.41014563699991, -79.1735979149999],
              [-81.45335852799991, -79.18857187299994],
              [-81.41063391799992, -79.20818450299993],
              [-81.38825436099995, -79.21550872199992],
              [-81.36782792899993, -79.21559010199991],
              [-81.3001195949999, -79.19736093499995],
              [-81.27721106699994, -79.19451262799993],
              [-81.10570227799991, -79.2033830709999],
              [-81.22215735599991, -79.23333098799992],
              [-81.27497311099995, -79.25481536299992],
              [-81.31932532499991, -79.29851653399993],
              [-81.3015844389999, -79.32488372199992],
              [-81.16852779899995, -79.44817473799992],
              [-81.11733964799993, -79.46990325299993],
              [-80.80483964799993, -79.52389902149991],
              [-80.49233964799993, -79.5778947899999],
              [-80.46816972599993, -79.57463958099993],
              [-80.43911699099993, -79.56552499799994],
              [-80.41193600199995, -79.55193450299993],
              [-80.39317786399994, -79.53525155999995],
              [-80.38597571499992, -79.50823333099993],
              [-80.40143795499995, -79.48902760199991],
              [-80.50706946499992, -79.44597747199992],
              [-80.53087317599994, -79.4314104149999],
              [-80.54539954299992, -79.4143205709999],
              [-80.54686438699991, -79.3923479149999],
              [-80.53722083199995, -79.32366301899992],
              [-80.53042558499993, -79.30429452899995],
              [-80.48656165299991, -79.27361419099992],
              [-80.42935136599993, -79.25847747199992],
              [-79.94225521537493, -79.26528289187493],
              [-79.45515906474994, -79.27208831174993],
              [-78.96806291412494, -79.27889373162492],
              [-78.48096676349994, -79.28569915149993],
              [-77.99387061287493, -79.29250457137493],
              [-77.50677446224994, -79.29930999124993],
              [-77.01967831162494, -79.30611541112492],
              [-76.53258216099994, -79.31292083099993],
              [-76.32730058499993, -79.3772111959999],
              [-76.21637936099995, -79.39177825299993],
              [-76.18000240799995, -79.40162525799991],
              [-76.13141842399995, -79.42327239399992],
              [-76.11351477799991, -79.42506275799991],
              [-76.06627356699994, -79.4353166649999],
              [-76.03587805899991, -79.46331145599993],
              [-76.00841223899994, -79.49675872199992],
              [-75.97020423099991, -79.52337004999993],
              [-75.95555579299992, -79.52206796699994],
              [-75.93765214799993, -79.51726653399993],
              [-75.92463131399995, -79.52027760199991],
              [-75.92446855399993, -79.54225025799991],
              [-75.93854732999995, -79.56878020599993],
              [-75.96129309799994, -79.58904387799993],
              [-76.01154537699995, -79.62184010199991],
              [-76.03563391799992, -79.64714934699992],
              [-76.07469641799992, -79.70631275799991],
              [-76.09764563699991, -79.73357512799993],
              [-76.14940344999991, -79.76881275799991],
              [-76.26195227799991, -79.80681731599992],
              [-76.42039954299992, -79.87981536299992],
              [-76.63219153599994, -79.9392229149999],
              [-77.02562415299994, -79.97653574049991],
              [-77.41905676999994, -80.01384856599992],
              [-77.87271074139994, -80.00759856599993],
              [-78.32636471279994, -80.00134856599992],
              [-78.78001868419994, -79.99509856599992],
              [-79.23367265559995, -79.98884856599992],
              [-79.68732662699995, -79.98259856599992],
              [-79.64541581899994, -80.0212541649999],
              [-79.2211672296666, -80.06427716833325],
              [-78.79691864033327, -80.10730017166658],
              [-78.37267005099994, -80.15032317499993],
              [-78.29625403599994, -80.17546965899993],
              [-78.27318274599992, -80.17815520599993],
              [-77.90054277299993, -80.14902109199994],
              [-77.77904212099992, -80.1618791649999],
              [-77.70327714799993, -80.17831796699994],
              [-77.66612708199995, -80.18173593499995],
              [-77.20224633133328, -80.14820728933329],
              [-76.73836558066661, -80.11467864366661],
              [-76.27448482999995, -80.08114999799994],
              [-76.24657141799992, -80.0896135399999],
              [-76.2539770169999, -80.10947030999995],
              [-76.27188066299993, -80.13323333099993],
              [-76.27574622299994, -80.15447356599992],
              [-76.2539770169999, -80.18417734199994],
              [-76.23338782499991, -80.20256926899992],
              [-76.17638098899994, -80.23105234199994],
              [-76.15245520699995, -80.24627044099992],
              [-76.11534583199995, -80.28191497199992],
              [-76.09508216099994, -80.29412200299993],
              [-76.08165442599994, -80.2946916649999],
              [-76.06704667899993, -80.28997161299992],
              [-76.04027258999992, -80.27581145599993],
              [-76.02745520699995, -80.27206796699994],
              [-76.01276607999995, -80.2712541649999],
              [-75.96524003799993, -80.27483489399992],
              [-75.95653235599991, -80.27776458099993],
              [-75.94782467399995, -80.28264739399992],
              [-75.98717200399994, -80.30315520599993],
              [-75.96715247299994, -80.31340911299992],
              [-75.90151933499993, -80.30632903399993],
              [-75.87205969999991, -80.30771249799994],
              [-75.57843990799995, -80.40349700299993],
              [-75.56554114499994, -80.41090260199991],
              [-75.54613196499992, -80.43474700299993],
              [-75.53018144399994, -80.4416643209999],
              [-75.51231848899994, -80.44670989399992],
              [-75.49673417899993, -80.4548479149999],
              [-75.46666419199994, -80.47649504999993],
              [-75.45396887899994, -80.48137786299992],
              [-75.41405188699991, -80.4885393209999],
              [-75.40172278599994, -80.51921965899993],
              [-75.42398027299993, -80.54159921699994],
              [-75.46007239499994, -80.55632903399993],
              [-75.51988684799994, -80.5705705709999],
              [-75.64753170499995, -80.58635833099993],
              [-75.67100989499994, -80.59531015399995],
              [-75.69050045499995, -80.61150481599992],
              [-75.71198482999995, -80.63811614399992],
              [-75.64818274599992, -80.66277434699992],
              [-75.46979732999995, -80.70370859199994],
              [-75.39142818899995, -80.7048479149999],
              [-75.37022864499994, -80.71111419099992],
              [-75.34780839799993, -80.72185637799993],
              [-75.24714107999995, -80.74114348799992],
              [-75.13011633999992, -80.74423593499995],
              [-75.02953040299991, -80.77206796699994],
              [-74.94945227799991, -80.77019622199992],
              [-74.98814856699994, -80.79045989399992],
              [-75.04112708199995, -80.79363372199992],
              [-75.19245357999995, -80.7712541649999],
              [-75.34898841099994, -80.80006275799991],
              [-75.72508704299992, -80.81853606599992],
              [-75.77090410099993, -80.83757903399993],
              [-75.65347245999993, -80.84172942499993],
              [-75.64232337099992, -80.84490325299993],
              [-75.63170325399994, -80.85247161299992],
              [-75.61266028599994, -80.87021249799994],
              [-75.59992428299995, -80.87810637799993],
              [-75.58478756399995, -80.88372161299992],
              [-75.55406653599994, -80.89137135199991],
              [-75.49860592399995, -80.89657968499995],
              [-75.38109290299991, -80.88079192499993],
              [-75.24103756399995, -80.88201262799993],
              [-75.14883378799993, -80.86345794099992],
              [-75.13906816299993, -80.86565520599993],
              [-75.09683183499993, -80.88323333099993],
              [-75.08438066299993, -80.88355885199991],
              [-75.06118730399993, -80.8791643209999],
              [-75.04938717399995, -80.8786760399999],
              [-74.98721269399994, -80.89609140399995],
              [-74.96214758999992, -80.89397551899992],
              [-74.93175208199995, -80.88762786299992],
              [-74.90249589799993, -80.88591887799993],
              [-74.83828691299993, -80.91936614399992],
              [-74.78331458199995, -80.90789153399993],
              [-74.72472083199995, -80.88543059699992],
              [-74.67149817599994, -80.87346770599993],
              [-74.61925208199995, -80.87379322699991],
              [-74.59422766799992, -80.87078215899993],
              [-74.47915605399993, -80.83440520599993],
              [-74.27696692599994, -80.82333749799994],
              [-74.16258704299992, -80.80006275799991],
              [-74.10423743399991, -80.79615650799991],
              [-74.04686438699991, -80.80413176899992],
              [-73.99063066299993, -80.82659270599993],
              [-73.95107988199993, -80.83733489399992],
              [-73.86436926999994, -80.83131275799991],
              [-73.82262122299994, -80.83562590899993],
              [-73.77818762899994, -80.84840260199991],
              [-73.44185679133328, -80.88865867833324],
              [-73.1055259536666, -80.9289147546666],
              [-72.76919511599993, -80.96917083099993],
              [-72.58885657499991, -80.96135833099993],
              [-72.60374915299991, -80.9314104149999],
              [-72.61408443899995, -80.91961028399993],
              [-72.6289770169999, -80.9104143209999],
              [-72.58372962099992, -80.8322893209999],
              [-72.55703691299993, -80.7985979149999],
              [-72.51598059799994, -80.77027760199991],
              [-72.46231035099993, -80.75042083099993],
              [-72.41100012899994, -80.74407317499993],
              [-72.35948645699995, -80.74863046699994],
              [-72.27757727799991, -80.76555754999993],
              [-71.95807857999992, -80.73276132599992],
              [-71.63857988199993, -80.69996510199991],
              [-71.60716712099992, -80.70175546699994],
              [-71.54857337099992, -80.71502044099992],
              [-71.52660071499992, -80.71542734199994],
              [-71.28180904899995, -80.66350676899992],
              [-71.12580318899995, -80.60263437299994],
              [-71.06773841099994, -80.6018205709999],
              [-70.97427324099993, -80.62395598799992],
              [-70.94127356699994, -80.62509530999995],
              [-70.82062740799995, -80.61012135199991],
              [-70.43370520699995, -80.65732187299994],
              [-70.40151933499993, -80.66806405999995],
              [-70.37564042899993, -80.68434010199991],
              [-70.36412512899994, -80.70769622199992],
              [-70.36790930899991, -80.72307708099993],
              [-70.3880102199999, -80.74944426899992],
              [-70.39354407499991, -80.76376718499995],
              [-70.3906957669999, -80.78118254999993],
              [-70.38438880099994, -80.79485442499993],
              [-70.38353430899991, -80.80803801899992],
              [-70.39712480399993, -80.82333749799994],
              [-70.38817298099991, -80.82724374799994],
              [-70.32457434799994, -80.84042734199994],
              [-70.19863847599993, -80.88941822699991],
              [-70.15689042899993, -80.89527760199991],
              [-70.03416907499991, -80.89267343499995],
              [-70.05549068899995, -80.91326262799993],
              [-70.06175696499992, -80.92913176899992],
              [-70.05272376199991, -80.94345468499995],
              [-70.02822831899994, -80.95964934699992],
              [-70.00206458199995, -80.97079843499995],
              [-69.97581946499992, -80.97600676899992],
              [-69.77843176999994, -80.98528411299992],
              [-69.68545488199993, -80.97600676899992],
              [-69.42979895749994, -81.00286223749993],
              [-69.17414303299995, -81.02971770599993],
              [-69.11636308499993, -81.02556731599992],
              [-68.95250403599994, -80.98479583099993],
              [-68.68032792899993, -80.96087004999993],
              [-68.44871985599991, -80.97714609199994],
              [-68.30626380099994, -81.00318775799991],
              [-68.23485266799992, -81.00351327899995],
              [-68.17027747299994, -81.0256486959999],
              [-68.05711829299992, -81.03826262799993],
              [-68.08771725199995, -81.0510393209999],
              [-68.29735266799992, -81.08993905999995],
              [-68.42100989499994, -81.08782317499993],
              [-68.37165279899995, -81.11028411299992],
              [-67.91488894099994, -81.16771528857136],
              [-67.45812508299994, -81.22514646414278],
              [-67.00136122499994, -81.28257763971422],
              [-66.54459736699992, -81.34000881528564],
              [-66.08783350899992, -81.39743999085708],
              [-65.63106965099992, -81.4548711664285],
              [-65.17430579299992, -81.51230234199994],
              [-64.92332923049992, -81.51336028449992],
              [-64.67235266799992, -81.51441822699991],
              [-64.6184789699999, -81.53036874799994],
              [-64.58958899599992, -81.53443775799991],
              [-64.15450598819993, -81.53906015399991],
              [-63.719422980399926, -81.54368254999991],
              [-63.28433997259994, -81.54830494599992],
              [-62.84925696479994, -81.55292734199992],
              [-62.414173956999946, -81.55754973799992],
              [-62.281320766999954, -81.58668385199991],
              [-62.21133378799993, -81.5920549459999],
              [-62.18919837099992, -81.5993791649999],
              [-62.18049068899995, -81.60751718499995],
              [-62.16173255099994, -81.6311174459999],
              [-62.14785722599993, -81.64023202899995],
              [-62.13125566299993, -81.64560312299994],
              [-62.11636308499993, -81.64763762799993],
              [-62.08360755099994, -81.64568450299993],
              [-62.114491339999915, -81.67131926899992],
              [-62.15916907499991, -81.6853166649999],
              [-62.20734615799995, -81.69255950299993],
              [-62.59780839766662, -81.70056189033325],
              [-62.98827063733328, -81.70856427766658],
              [-63.37873287699995, -81.7165666649999],
              [-63.46125240799995, -81.70077890399995],
              [-63.29539954299992, -81.64902109199994],
              [-63.391184048999946, -81.63209400799991],
              [-63.49299068899995, -81.64072030999995],
              [-63.73737545499995, -81.68938567499993],
              [-64.03425045499995, -81.6970354149999],
              [-64.08438066299993, -81.68889739399992],
              [-63.84390214799993, -81.62216562299994],
              [-63.878163214999915, -81.60084400799991],
              [-63.9368383449999, -81.60955169099992],
              [-64.09215247299994, -81.66611093499995],
              [-64.19863847599993, -81.68840911299992],
              [-64.45567786399994, -81.69329192549992],
              [-64.71271725199995, -81.69817473799992],
              [-64.66527258999992, -81.67734140399995],
              [-64.51349850199995, -81.63884856599992],
              [-64.55931555899991, -81.62175872199992],
              [-64.61676998599995, -81.61931731599992],
              [-64.77847245999993, -81.6369768209999],
              [-64.97923743399991, -81.69500090899993],
              [-65.30378170499995, -81.71754322699991],
              [-65.41722571499992, -81.70110442499993],
              [-65.69172115799995, -81.71054452899995],
              [-65.70555579299992, -81.71453215899993],
              [-65.71304277299993, -81.71998463299991],
              [-65.71475175699993, -81.72918059699992],
              [-65.70616614499994, -81.7614885399999],
              [-65.70152747299994, -81.76995208099993],
              [-65.69347083199995, -81.77361419099992],
              [-65.67756100199995, -81.77727629999993],
              [-65.62486731699994, -81.78411223799992],
              [-65.26799475849992, -81.79021575349992],
              [-64.91112219999991, -81.79631926899992],
              [-64.96483313699991, -81.81511809699992],
              [-64.91755123599995, -81.81951262799993],
              [-64.7512914699999, -81.79794687299994],
              [-64.68553626199991, -81.80022551899992],
              [-64.63361568899995, -81.79338958099993],
              [-64.24887719066662, -81.78894079633325],
              [-63.86413869233328, -81.78449201166659],
              [-63.479400193999936, -81.78004322699991],
              [-63.51203365799995, -81.80242278399993],
              [-63.54088294199994, -81.82927825299993],
              [-63.50877844999991, -81.83562590899993],
              [-63.47606360599991, -81.83733489399992],
              [-63.51789303299995, -81.86207447699991],
              [-63.57721920499995, -81.87184010199991],
              [-64.02239335859994, -81.87514413839992],
              [-64.46756751219995, -81.87844817479991],
              [-64.91274166579994, -81.88175221119992],
              [-65.35791581939995, -81.88505624759992],
              [-65.80308997299994, -81.88836028399993],
              [-66.25576738199993, -81.94801197699991],
              [-65.97864742749994, -81.95846933399991],
              [-65.70152747299994, -81.96892669099992],
              [-65.62979081899994, -81.9865861959999],
              [-65.65298417899993, -82.00579192499993],
              [-65.68179277299993, -82.0158830709999],
              [-65.74282792899993, -82.02678801899992],
              [-65.92031816299993, -82.07968515399995],
              [-65.94371497299994, -82.09579843499995],
              [-65.98558508999992, -82.1501604149999],
              [-66.00576738199993, -82.16814544099992],
              [-66.06240800699993, -82.19540780999995],
              [-66.03355872299994, -82.21445077899995],
              [-65.86685136599993, -82.20989348799992],
              [-65.8938695949999, -82.22722747199992],
              [-65.94033769399994, -82.23503997199992],
              [-66.02814693899995, -82.23967864399992],
              [-65.98985755099994, -82.24944426899992],
              [-65.86270097599993, -82.24480559699992],
              [-65.91344153599994, -82.26311614399992],
              [-66.08006751199991, -82.29168059699992],
              [-66.03026282499991, -82.31161874799994],
              [-65.75922604099992, -82.30250416449994],
              [-65.48818925699993, -82.29338958099993],
              [-65.37498938699991, -82.26311614399992],
              [-65.23346920499995, -82.25693124799994],
              [-65.21861731699994, -82.25994231599992],
              [-65.20763098899994, -82.26580169099992],
              [-65.20067298099991, -82.27361419099992],
              [-65.19456946499992, -82.28232187299994],
              [-65.18610592399995, -82.29070403399993],
              [-65.17882239499994, -82.29404062299994],
              [-65.16218014199995, -82.29753997199992],
              [-65.15440833199995, -82.30120208099993],
              [-65.14659583199995, -82.3083635399999],
              [-65.14484615799995, -82.31406015399995],
              [-65.14806067599994, -82.31951262799993],
              [-65.15538489499994, -82.3259416649999],
              [-65.16734778599994, -82.34026458099993],
              [-65.16454016799992, -82.34970468499995],
              [-65.15111243399991, -82.35564544099992],
              [-65.10777747299994, -82.36370208099993],
              [-65.09434973899994, -82.36793385199991],
              [-65.09190833199995, -82.37411874799994],
              [-65.10130774599992, -82.39275481599992],
              [-65.09203040299991, -82.40252044099992],
              [-65.07258053299995, -82.4060197899999],
              [-64.76475989499994, -82.38022226399991],
              [-64.45693925699993, -82.35442473799992],
              [-64.49054928299995, -82.36858489399992],
              [-64.52574622299994, -82.37786223799992],
              [-64.48827063699991, -82.40390390399995],
              [-64.43960527299993, -82.41033294099992],
              [-64.14069576749992, -82.35625579249992],
              [-63.841786261999914, -82.30217864399992],
              [-63.587574836499925, -82.32146575349992],
              [-63.33336341099994, -82.34075286299992],
              [-63.28673255099994, -82.33025481599992],
              [-63.195871548999946, -82.29461028399993],
              [-63.23473059799994, -82.26913827899995],
              [-63.18883216099994, -82.2575822899999],
              [-63.04137122299994, -82.25204843499995],
              [-63.035145636999914, -82.2736955709999],
              [-63.009877081999946, -82.27971770599993],
              [-62.74089514849993, -82.26808033649993],
              [-62.471913214999915, -82.25644296699994],
              [-62.07298743399991, -82.28753020599993],
              [-61.618234829666584, -82.24526675133326],
              [-61.16348222533325, -82.20300329666661],
              [-60.70872962099992, -82.16073984199994],
              [-60.64728756399995, -82.16668059699992],
              [-60.69286048099991, -82.19768645599993],
              [-60.401234503999945, -82.1701799459999],
              [-60.50617428299995, -82.2151018209999],
              [-60.813201463999945, -82.27971770649992],
              [-61.12022864499994, -82.34433359199994],
              [-61.29019120999993, -82.34221770599993],
              [-61.75841223899994, -82.4026018209999],
              [-61.99567623599995, -82.45916106599992],
              [-62.39535478399995, -82.48943450349992],
              [-62.795033331999946, -82.51970794099992],
              [-62.76512610599991, -82.55429452899995],
              [-62.729074673999946, -82.57781340899993],
              [-62.49518795499995, -82.68173593499995],
              [-62.51109778599994, -82.70956796699994],
              [-62.52208411399994, -82.71819426899992],
              [-62.53868567599994, -82.72063567499993],
              [-62.5188695949999, -82.72576262799993],
              [-62.481678839999915, -82.71941497199992],
              [-62.46202551999994, -82.71941497199992],
              [-62.44359290299991, -82.72568124799994],
              [-62.40314693899995, -82.74553801899992],
              [-62.10069739499994, -82.84970468499995],
              [-62.09325110599991, -82.85442473799992],
              [-62.089955206999946, -82.86248137799993],
              [-62.09121660099993, -82.87127044099992],
              [-62.090728318999936, -82.88079192499993],
              [-62.08238684799994, -82.89120859199994],
              [-61.932484503999945, -82.97234465899993],
              [-61.99722245999993, -83.00123463299991],
              [-62.066395636999914, -83.01327890399995],
              [-62.20933997299994, -83.01881275799991],
              [-62.18077551999994, -83.03411223799992],
              [-62.13853919199994, -83.0368791649999],
              [-61.94163977799991, -83.02841562299994],
              [-61.90534420499995, -83.02011484199994],
              [-61.854400193999936, -82.99537525799991],
              [-61.83348548099991, -82.9924455709999],
              [-61.81578528599994, -82.99456145599993],
              [-61.65782630099994, -83.05771249799994],
              [-61.62022864499994, -83.06340911299992],
              [-61.60191809799994, -83.05999114399992],
              [-61.587147589999915, -83.05071379999993],
              [-61.56358801999994, -83.0232072899999],
              [-61.549387173999946, -83.01034921699994],
              [-61.532134568999936, -83.00212981599992],
              [-61.38499915299991, -82.96640390399995],
              [-61.364898240999935, -82.94980234199994],
              [-61.34935462099992, -82.90894947699991],
              [-61.33706620999993, -82.89812590899993],
              [-61.314116990999935, -82.89023202899995],
              [-61.2942602199999, -82.88738372199992],
              [-61.27651933499993, -82.88982512799993],
              [-61.26073157499991, -82.89763762799993],
              [-61.21825110599991, -82.93906015399995],
              [-61.18468176999994, -82.9592424459999],
              [-61.14793860599991, -82.96477629999993],
              [-61.11017818899995, -82.9489885399999],
              [-61.132883266999954, -82.91790129999993],
              [-61.096547003999945, -82.90504322699991],
              [-61.0657445949999, -82.90976327899995],
              [-61.00658118399991, -82.94605885199991],
              [-60.97834225199995, -82.97519296699994],
              [-60.97492428299995, -83.00546640399995],
              [-61.00023352799991, -83.07301197699991],
              [-61.04010982999995, -83.11956145599993],
              [-61.112538214999915, -83.16480885199991],
              [-61.19249426999994, -83.19850025799991],
              [-61.25430253799993, -83.21005624799994],
              [-61.32656816299993, -83.21355559699992],
              [-61.48473059799994, -83.25465260199991],
              [-61.62482662699995, -83.31218840899993],
              [-61.85147050699993, -83.36760833099993],
              [-61.82469641799992, -83.37444426899992],
              [-61.79527747299994, -83.37273528399993],
              [-61.7376195949999, -83.36174895599993],
              [-61.541127081999946, -83.35084400799991],
              [-61.52961178299995, -83.35759856599992],
              [-61.52424068899995, -83.37444426899992],
              [-61.52065995999993, -83.39275481599992],
              [-61.51447506399995, -83.40398528399993],
              [-61.48888098899994, -83.40691497199992],
              [-61.41905676999994, -83.39120859199994],
              [-61.25523841099994, -83.37574635199991],
              [-61.186390753999945, -83.37981536299992],
              [-61.147694464999915, -83.4084611959999],
              [-61.11042232999995, -83.41326262799993],
              [-60.899647589999915, -83.38795338299991],
              [-61.00503495999993, -83.42400481599992],
              [-61.11363684799994, -83.44793059699992],
              [-60.95225989499994, -83.47625090899993],
              [-60.90013587099992, -83.47421640399995],
              [-60.66783606699994, -83.43027109199994],
              [-60.60806230399993, -83.42839934699992],
              [-60.44611568899995, -83.46868254999993],
              [-60.16010494699995, -83.44809335749991],
              [-59.87409420499995, -83.4275041649999],
              [-59.86270097599993, -83.43328215899993],
              [-59.8450414699999, -83.45427825299993],
              [-59.83360755099994, -83.45867278399993],
              [-59.469960089999915, -83.46013762799993],
              [-59.07662919824992, -83.34734465924993],
              [-58.68329830649992, -83.23455169049993],
              [-58.289967414749924, -83.12175872174993],
              [-57.89663652299993, -83.00896575299993],
              [-57.698882615999935, -82.91025155999995],
              [-57.24526933499993, -82.82198116099994],
              [-56.79165605399993, -82.73371076199993],
              [-56.33804277299993, -82.64544036299992],
              [-56.319203253999945, -82.63681405999995],
              [-56.29637610599991, -82.62118905999995],
              [-55.99233964799993, -82.54094817499993],
              [-55.93187415299991, -82.51409270599993],
              [-55.925852016999954, -82.50994231599992],
              [-55.92491614499994, -82.50457122199992],
              [-55.928293423999946, -82.48821379999993],
              [-55.92723548099991, -82.48308684699992],
              [-55.916127081999946, -82.47698333099993],
              [-55.850168423999946, -82.46209075299993],
              [-55.84365800699993, -82.46721770599993],
              [-55.84044348899994, -82.4763322899999],
              [-55.826242641999954, -82.48512135199991],
              [-55.77692623599995, -82.48756275799991],
              [-55.68106035099993, -82.46168385199991],
              [-55.55894934799994, -82.4611955709999],
              [-55.49779212099992, -82.47429778399993],
              [-55.44098873599995, -82.47673919099992],
              [-55.42845618399991, -82.47991301899992],
              [-55.42491614499994, -82.48601653399993],
              [-55.42300370999993, -82.49309661299992],
              [-55.41510982999995, -82.4997697899999],
              [-55.39293372299994, -82.50652434699992],
              [-55.22484290299991, -82.51775481599992],
              [-55.17642167899993, -82.51043059699992],
              [-55.143869594999956, -82.49065520599993],
              [-55.187611456999946, -82.45826588299991],
              [-55.14142818899995, -82.44451262799993],
              [-55.130116339999915, -82.43906015399995],
              [-55.121978318999936, -82.4260393209999],
              [-55.11082923099991, -82.39413827899995],
              [-55.09976152299993, -82.38437265399995],
              [-55.01549231699994, -82.35230885199991],
              [-54.98786373599995, -82.34685637799993],
              [-54.85757402299993, -82.3479143209999],
              [-54.84837805899991, -82.34319426899992],
              [-54.83116614499994, -82.32341887799993],
              [-54.82054602799991, -82.31633879999993],
              [-54.76154537699995, -82.29973723799992],
              [-54.50055904849995, -82.28740813599993],
              [-54.239572719999956, -82.27507903399993],
              [-54.173898891999954, -82.26295338299991],
              [-54.20091712099992, -82.2541643209999],
              [-54.29320227799991, -82.25351327899995],
              [-53.924672003999945, -82.20614999799994],
              [-53.969960089999915, -82.19850025799991],
              [-54.25767981699994, -82.20159270599993],
              [-54.30345618399991, -82.1916643209999],
              [-53.90929114499994, -82.17839934699992],
              [-53.79963131399995, -82.19402434699992],
              [-53.31395423099991, -82.15276458099993],
              [-53.28758704299992, -82.14714934699992],
              [-53.275461391999954, -82.14185963299991],
              [-53.25544186099995, -82.13014088299991],
              [-53.240345831999946, -82.12639739399992],
              [-53.22492428299995, -82.12509530999995],
              [-52.93403072849995, -82.14275481549993],
              [-52.643137173999946, -82.1604143209999],
              [-52.18687903599994, -82.11150481549993],
              [-51.730641334999916, -82.06255653699992],
            ],
          ],
          [
            [
              [167.66374759200005, -78.12737395599993],
              [167.66187584700003, -78.1286760399999],
              [167.661468946, -78.12981536299992],
              [167.66277103000004, -78.13054778399993],
              [167.66570071700005, -78.13095468499995],
              [167.5791121750001, -78.1872697899999],
              [167.49683678500003, -78.22698333099993],
              [167.40552819100003, -78.24920012799993],
              [167.29127037900003, -78.25269947699991],
              [166.9472762380001, -78.22226327899995],
              [166.903168165, -78.22747161299992],
              [166.72974694100003, -78.27703215899993],
              [166.31511478000004, -78.3103166649999],
              [166.19418379, -78.29924895599993],
              [166.1411238940001, -78.28720468499995],
              [166.09782962300005, -78.2678361959999],
              [166.03484134200005, -78.19654713299991],
              [165.98609459700003, -78.10955169099992],
              [166.0454207690001, -78.09002044099992],
              [166.09343509200005, -78.08318450299993],
              [166.13233483200008, -78.09050872199992],
              [166.16431725400003, -78.11288827899995],
              [166.31031334700003, -78.11239999799994],
              [166.652679884, -78.16139088299991],
              [166.77361087300005, -78.2014299459999],
              [166.79566491000003, -78.21160247199992],
              [167.06788170700008, -78.15496184699992],
              [167.34839928500003, -78.05877044099992],
              [167.4111434250001, -78.01116301899992],
              [167.4560653000001, -77.99627044099992],
              [167.5117293630001, -77.9924455709999],
              [167.56527754, -78.00269947699991],
              [167.60328209700003, -78.03020598799992],
              [167.6098738940001, -78.05632903399993],
              [167.62419681100005, -78.08196379999993],
              [167.66374759200005, -78.12737395599993],
            ],
          ],
          [
            [
              [163.6142684250001, -74.84343840899993],
              [163.6508895190001, -74.84661223799992],
              [163.67367597700002, -74.85857512799993],
              [163.68702233200008, -74.87517669099992],
              [163.69516035200002, -74.89226653399993],
              [163.6587020190001, -74.91497161299992],
              [163.62647545700008, -74.91375090899993],
              [163.6035262380001, -74.89690520599993],
              [163.595062696, -74.87273528399993],
              [163.60377037900003, -74.86256275799991],
              [163.61296634200005, -74.85751718499995],
              [163.6176863940001, -74.85271575299993],
              [163.6142684250001, -74.84343840899993],
            ],
          ],
          [
            [
              [163.80347741000003, -74.68954843499995],
              [164.01636803500003, -74.60320403399993],
              [164.27328535200002, -74.5505510399999],
              [164.30241946700005, -74.55266692499993],
              [164.293304884, -74.55917734199994],
              [164.2627059250001, -74.57146575299993],
              [164.253265821, -74.57927825299993],
              [164.24488366000003, -74.58993905999995],
              [164.23804772200003, -74.60165780999995],
              [164.23308353000004, -74.61288827899995],
              [164.23780358200008, -74.61874765399995],
              [164.24040774800005, -74.62566497199992],
              [164.24431399800005, -74.63128020599993],
              [164.08765709700003, -74.62542083099993],
              [164.0380965500001, -74.63632577899995],
              [164.0590926440001, -74.6482072899999],
              [164.0590926440001, -74.66920338299991],
              [164.04639733200008, -74.68816497199992],
              [164.0302840500001, -74.69394296699994],
              [164.067230665, -74.7053361959999],
              [164.09839928500003, -74.7190080709999],
              [164.10718834700003, -74.7360979149999],
              [164.07740319100003, -74.75750090899993],
              [164.04021243600005, -74.76490650799991],
              [163.92603600400003, -74.77223072699991],
              [163.98796634200005, -74.78785572699991],
              [164.03777103000004, -74.80632903399993],
              [163.9809676440001, -74.84026458099993],
              [163.98707116000003, -74.84026458099993],
              [163.99293053500003, -74.84148528399993],
              [163.9985457690001, -74.8435197899999],
              [164.00375410200002, -74.84644947699991],
              [163.97828209700003, -74.86101653399993],
              [163.9633895190001, -74.86638762799993],
              [163.950531446, -74.86638762799993],
              [163.94410241000003, -74.86223723799992],
              [163.9433699880001, -74.85702890399995],
              [163.94459069100003, -74.85116952899995],
              [163.94418379, -74.84482187299994],
              [163.9404403000001, -74.83367278399993],
              [163.93718509200005, -74.83074309699992],
              [163.92920983200008, -74.82675546699994],
              [163.89177493600005, -74.81991952899995],
              [163.8696395190001, -74.81926848799992],
              [163.86052493600005, -74.8244768209999],
              [163.8618270190001, -74.82634856599992],
              [163.86866295700008, -74.83342864399992],
              [163.83659915500004, -74.8337541649999],
              [163.80486087300005, -74.8283830709999],
              [163.77125084700003, -74.8127580709999],
              [163.75993899800005, -74.80966562299994],
              [163.7656356130001, -74.80828215899993],
              [163.77125084700003, -74.80575937299994],
              [163.77613366000003, -74.80193450299993],
              [163.7793074880001, -74.79697030999995],
              [163.75114993600005, -74.79355234199994],
              [163.73707116000003, -74.78948333099993],
              [163.72673587300005, -74.78248463299991],
              [163.72339928500003, -74.77597421699994],
              [163.71794681100005, -74.75847747199992],
              [163.71404056100005, -74.75066497199992],
              [163.69263756600003, -74.72861093499995],
              [163.68775475400003, -74.72551848799992],
              [163.7177840500001, -74.71640390399995],
              [163.81324303500003, -74.7009416649999],
              [163.80347741000003, -74.68954843499995],
            ],
          ],
          [
            [
              [163.340179884, -70.37395598799992],
              [163.34888756600003, -70.3669572899999],
              [163.39568118600005, -70.34539153399993],
              [163.45533287900003, -70.33912525799991],
              [163.51628665500004, -70.3459611959999],
              [163.56666100400003, -70.36394622199992],
              [163.5156356130001, -70.37818775799991],
              [163.3462020190001, -70.39527760199991],
              [163.3095809250001, -70.38640715899993],
              [163.3193465500001, -70.38420989399992],
              [163.3271590500001, -70.38152434699992],
              [163.3339949880001, -70.37818775799991],
              [163.340179884, -70.37395598799992],
            ],
          ],
          [
            [
              [164.8403426440001, -67.33928801899992],
              [164.8369246750001, -67.36272551899992],
              [164.85718834700003, -67.37590911299992],
              [164.8877059250001, -67.38689544099992],
              [164.91391035200002, -67.40439218499995],
              [164.92603600400003, -67.43108489399992],
              [164.91618899800005, -67.45427825299993],
              [164.889008009, -67.47673919099992],
              [164.848968946, -67.50090911299992],
              [164.854828321, -67.5041643209999],
              [164.85889733200008, -67.50741952899995],
              [164.86443118600005, -67.51083749799994],
              [164.8750106130001, -67.51506926899992],
              [164.81983483200008, -67.55022551899992],
              [164.76042728000004, -67.57040780999995],
              [164.70378665500004, -67.5686174459999],
              [164.6572371750001, -67.53834400799991],
              [164.656586134, -67.52459075299993],
              [164.65186608200008, -67.51140715899993],
              [164.64380944100003, -67.49928150799991],
              [164.6328231130001, -67.48870208099993],
              [164.6591903000001, -67.47323984199994],
              [164.6821395190001, -67.44784921699994],
              [164.6962996750001, -67.41676197699991],
              [164.69605553500003, -67.38518645599993],
              [164.6899520190001, -67.37200286299992],
              [164.669281446, -67.34319426899992],
              [164.659515821, -67.33359140399995],
              [164.6601668630001, -67.32724374799994],
              [164.66228274800005, -67.32138437299994],
              [164.66570071700005, -67.31633879999993],
              [164.6704207690001, -67.31210702899995],
              [164.65699303500003, -67.27874114399992],
              [164.6572371750001, -67.26083749799994],
              [164.67457116000003, -67.25774504999993],
              [164.71216881600003, -67.26848723799992],
              [164.82374108200008, -67.32561614399992],
              [164.8403426440001, -67.33928801899992],
            ],
          ],
          [
            [
              [163.29371178500003, -66.83806731599992],
              [163.29509524800005, -66.88486093499995],
              [163.24919681100005, -66.87737395599993],
              [163.190765821, -66.84384530999995],
              [163.15503991000003, -66.8122697899999],
              [163.08269290500004, -66.71233489399992],
              [163.0820418630001, -66.71087004999993],
              [163.08187910200002, -66.70777760199991],
              [163.08130944100003, -66.70647551899992],
              [163.11475670700008, -66.6872697899999],
              [163.1699324880001, -66.69019947699991],
              [163.2255965500001, -66.70378997199992],
              [163.26050866000003, -66.71624114399992],
              [163.262054884, -66.73211028399993],
              [163.26547285200002, -66.74041106599992],
              [163.26531009200005, -66.74846770599993],
              [163.25700931100005, -66.76327890399995],
              [163.29249108200008, -66.77629973799992],
              [163.31226647200003, -66.77898528399993],
              [163.31080162900003, -66.78020598799992],
              [163.31039472700002, -66.78118254999993],
              [163.31120853000004, -66.7815080709999],
              [163.31324303500003, -66.7815080709999],
              [163.31120853000004, -66.78329843499995],
              [163.31072024800005, -66.78435637799993],
              [163.31137129, -66.7849260399999],
              [163.31364993600005, -66.7849260399999],
              [163.2861434250001, -66.79778411299992],
              [163.30225670700008, -66.82040780999995],
              [163.31039472700002, -66.82732512799993],
              [163.30974368600005, -66.82805754999993],
              [163.30974368600005, -66.82870859199994],
              [163.31080162900003, -66.82878997199992],
              [163.3125106130001, -66.82870859199994],
              [163.2968856130001, -66.83513762799993],
              [163.29371178500003, -66.83806731599992],
            ],
          ],
          [
            [
              [-45.053944464999915, -60.703057549999926],
              [-45.078114386999914, -60.686211846999925],
              [-45.08336341099994, -60.684665622999944],
              [-45.07363847599993, -60.67229583099993],
              [-45.06899980399993, -60.66025155999995],
              [-45.06712805899991, -60.631117445999905],
              [-45.06187903599994, -60.63551197699991],
              [-45.02961178299995, -60.65683359199994],
              [-45.028553839999915, -60.66179778399993],
              [-45.02769934799994, -60.67131926899992],
              [-45.02574622299994, -60.68181731599992],
              [-45.020415818999936, -60.69036223799992],
              [-45.015695766999954, -60.69345468499995],
              [-45.00503495999993, -60.69801197699991],
              [-45.00023352799991, -60.70086028399993],
              [-45.01081295499995, -60.70859140399995],
              [-45.02562415299991, -60.71021900799991],
              [-45.041086391999954, -60.70777760199991],
              [-45.053944464999915, -60.703057549999926],
            ],
          ],
          [
            [
              [-59.286773240999935, -80.20964934699992],
              [-59.28038489499994, -80.21542734199994],
              [-59.30060787699995, -80.2185197899999],
              [-59.31818600199995, -80.21624114399992],
              [-59.35326087099992, -80.20525481599992],
              [-59.37938391799992, -80.20208098799992],
              [-59.58039303299995, -80.21135833099993],
              [-59.592640753999945, -80.21396249799994],
              [-59.59996497299994, -80.21738046699994],
              [-59.60509192599994, -80.22340260199991],
              [-59.61042232999995, -80.23381926899992],
              [-59.61961829299992, -80.24651458099993],
              [-59.62319902299993, -80.25351327899995],
              [-59.62262936099995, -80.25969817499993],
              [-59.61656653599994, -80.26376718499995],
              [-59.598866339999915, -80.26506926899992],
              [-59.591786261999914, -80.26653411299992],
              [-59.586008266999954, -80.27117278399993],
              [-59.58023027299993, -80.28134530999995],
              [-59.57457434799994, -80.28582122199992],
              [-59.59715735599991, -80.28915780999995],
              [-59.63731848899994, -80.28460051899992],
              [-59.65770423099991, -80.29241301899992],
              [-59.66974850199995, -80.30315520599993],
              [-59.68809973899994, -80.32390715899993],
              [-59.69969641799992, -80.33066171699994],
              [-59.718861456999946, -80.33261484199994],
              [-59.738840298999946, -80.3318010399999],
              [-59.75743567599994, -80.3357072899999],
              [-59.77253170499995, -80.35165780999995],
              [-59.77334550699993, -80.35491301899992],
              [-59.77424068899995, -80.36402760199991],
              [-59.77525794199994, -80.36809661299992],
              [-59.777414516999954, -80.37102629999993],
              [-59.783314581999946, -80.37615325299993],
              [-59.785227016999954, -80.3791643209999],
              [-59.784087693999936, -80.3982072899999],
              [-59.76988684799994, -80.40699635199991],
              [-59.73086503799993, -80.41415780999995],
              [-59.77440344999991, -80.41920338299991],
              [-59.78587805899991, -80.42392343499995],
              [-59.79259192599994, -80.42937590899993],
              [-59.79434160099993, -80.43377044099992],
              [-59.79161536399994, -80.44784921699994],
              [-59.79564368399991, -80.46941497199992],
              [-59.80882727799991, -80.49456145599993],
              [-59.82725989499994, -80.51637135199991],
              [-59.84683183499993, -80.52825286299992],
              [-59.80923417899993, -80.53264739399992],
              [-59.68154863199993, -80.51506926899992],
              [-59.67007402299993, -80.51116301899992],
              [-59.65965735599991, -80.50546640399995],
              [-59.65221106699994, -80.49716562299994],
              [-59.65892493399991, -80.49065520599993],
              [-59.66673743399991, -80.48479583099993],
              [-59.64728756399995, -80.47942473799992],
              [-59.62633216099994, -80.47698333099993],
              [-59.585194464999915, -80.47869231599992],
              [-59.57408606699994, -80.48162200299993],
              [-59.552805141999954, -80.49016692499993],
              [-59.541859503999945, -80.49309661299992],
              [-59.53551184799994, -80.49358489399992],
              [-59.519602016999954, -80.48967864399992],
              [-59.50625566299993, -80.48845794099992],
              [-59.46654212099992, -80.49089934699992],
              [-59.47614498599995, -80.49578215899993],
              [-59.490223761999914, -80.50725676899992],
              [-59.50186113199993, -80.52019622199992],
              [-59.503895636999914, -80.52947356599992],
              [-59.56436113199993, -80.54159921699994],
              [-59.58185787699995, -80.5388322899999],
              [-59.58462480399993, -80.53679778399993],
              [-59.59093176999994, -80.52971770599993],
              [-59.59170488199993, -80.52841562299994],
              [-59.60024980399993, -80.52727629999993],
              [-59.610585089999915, -80.5276018209999],
              [-59.62059485599991, -80.5295549459999],
              [-59.62852942599994, -80.5334611959999],
              [-59.64122473899994, -80.54599374799994],
              [-59.64720618399991, -80.55046965899993],
              [-59.74132239499994, -80.57626718499995],
              [-59.8333227199999, -80.58326588299991],
              [-59.84756425699993, -80.58709075299993],
              [-59.85924231699994, -80.59498463299991],
              [-59.868397589999915, -80.60881926899992],
              [-59.88426673099991, -80.64592864399992],
              [-59.793812628999945, -80.65569426899992],
              [-59.71499589799993, -80.64120859199994],
              [-59.69017493399991, -80.64104583099993],
              [-59.66592363199993, -80.64641692499993],
              [-59.68472245999993, -80.66423919099992],
              [-59.69180253799993, -80.66912200299993],
              [-59.699289516999954, -80.67229583099993],
              [-59.72345943899995, -80.67913176899992],
              [-59.75560462099992, -80.69459400799991],
              [-59.785227016999954, -80.71404387799993],
              [-59.809152798999946, -80.73821379999993],
              [-59.81899980399993, -80.74488697699991],
              [-60.09019934799994, -80.83049895599993],
              [-60.361398891999954, -80.91611093499995],
              [-60.65265865799995, -80.96038176899992],
              [-61.12001502199995, -80.93651702274992],
              [-61.587371385999944, -80.91265227649993],
              [-62.05472774999994, -80.88878753024993],
              [-62.52208411399994, -80.86492278399993],
              [-62.95848548099991, -80.77532317499993],
              [-62.983631964999915, -80.75969817499993],
              [-62.98810787699995, -80.73699309699992],
              [-62.97996985599991, -80.72673919099992],
              [-62.96971594999991, -80.71835702899995],
              [-62.96507727799991, -80.70916106599992],
              [-62.97362219999991, -80.69687265399995],
              [-62.988270636999914, -80.68857187299994],
              [-63.04010982999995, -80.67449309699992],
              [-63.051625128999945, -80.66863372199992],
              [-63.0559789699999, -80.66253020599993],
              [-63.05650794199994, -80.64055754999993],
              [-63.06114661399994, -80.62517669099992],
              [-63.07184811099995, -80.61467864399992],
              [-63.08629309799994, -80.60751718499995],
              [-63.14110266799992, -80.59246184699992],
              [-63.46672522699993, -80.59929778449992],
              [-63.79234778599994, -80.60613372199992],
              [-63.80504309799994, -80.60979583099993],
              [-63.81602942599994, -80.61614348799992],
              [-63.836822068999936, -80.63144296699994],
              [-63.85020911399994, -80.63860442499993],
              [-63.86367753799993, -80.6428361959999],
              [-63.87800045499995, -80.64519622199992],
              [-64.12751217399995, -80.65357838299991],
              [-64.16563880099994, -80.66480885199991],
              [-64.15880286399994, -80.66643645599993],
              [-64.15233313699991, -80.66920338299991],
              [-64.14659583199995, -80.67310963299991],
              [-64.14220130099994, -80.67839934699992],
              [-64.17731686099995, -80.69646575299993],
              [-64.18374589799993, -80.70769622199992],
              [-64.17080644399994, -80.7268205709999],
              [-64.17609615799995, -80.73316822699991],
              [-64.21833248599995, -80.74472421699994],
              [-64.28477942599994, -80.75115325299993],
              [-64.76800696499994, -80.68339609159992],
              [-65.25123450399994, -80.61563893019992],
              [-65.73446204299992, -80.54788176879991],
              [-66.21768958199992, -80.48012460739992],
              [-66.70091712099992, -80.4123674459999],
              [-66.75137285099993, -80.39381275799991],
              [-66.75885982999995, -80.38909270599993],
              [-66.76724199099993, -80.37932708099993],
              [-66.77635657499991, -80.35759856599992],
              [-66.78286699099993, -80.3474260399999],
              [-66.78872636599993, -80.34303150799991],
              [-66.79556230399993, -80.33953215899993],
              [-66.80158443899995, -80.33521900799991],
              [-66.80475826699995, -80.32854583099993],
              [-66.79645748599995, -80.30820077899995],
              [-66.76911373599995, -80.28972747199992],
              [-66.57664954299992, -80.22730885199991],
              [-66.33096269399994, -80.21917083099993],
              [-66.27696692599994, -80.21152109199994],
              [-66.26622473899994, -80.21249765399995],
              [-66.27009029899995, -80.19988372199992],
              [-66.25788326699995, -80.19491952899995],
              [-66.23989824099993, -80.19443124799994],
              [-66.21056067599994, -80.19719817499993],
              [-66.19440670499995, -80.20110442499993],
              [-66.17955481699994, -80.20777760199991],
              [-66.16722571499992, -80.21819426899992],
              [-66.16978919199994, -80.22747161299992],
              [-66.18468176999994, -80.23756275799991],
              [-66.21178137899994, -80.24993254999993],
              [-66.20710201699995, -80.25628020599993],
              [-66.18932044199994, -80.27255624799994],
              [-66.21263587099992, -80.29436614399992],
              [-66.22386633999992, -80.31389739399992],
              [-66.22883053299995, -80.31959400799991],
              [-66.20348059799994, -80.34368254999993],
              [-66.1653539699999, -80.35735442499993],
              [-65.91844641799992, -80.39495208099993],
              [-65.45532521577769, -80.39199526677771],
              [-64.99220401355548, -80.38903845255548],
              [-64.52908281133325, -80.38608163833327],
              [-64.06596160911104, -80.38312482411104],
              [-63.60284040688882, -80.38016800988882],
              [-63.1397192046666, -80.37721119566659],
              [-62.67659800244438, -80.37425438144437],
              [-62.21347680022216, -80.37129756722214],
              [-61.75035559799994, -80.36834075299993],
              [-61.486459927499936, -80.32073333099993],
              [-61.22256425699993, -80.27312590899993],
              [-61.194569464999915, -80.25505950299993],
              [-61.18455969999991, -80.25261809699992],
              [-61.447255011999914, -80.25115325299993],
              [-61.51585852799991, -80.24187590899993],
              [-61.535267706999946, -80.23560963299991],
              [-61.54454505099994, -80.23007577899995],
              [-61.555897589999915, -80.21672942499993],
              [-61.56297766799992, -80.21005624799994],
              [-61.57677161399994, -80.20354583099993],
              [-61.65807044199994, -80.1794572899999],
              [-61.66307532499991, -80.1755510399999],
              [-61.662668423999946, -80.1701799459999],
              [-61.65835527299993, -80.16611093499995],
              [-61.652902798999946, -80.16220468499995],
              [-61.64867102799991, -80.15789153399993],
              [-61.65013587099992, -80.14364999799994],
              [-61.66779537699995, -80.13534921699994],
              [-61.70645097599993, -80.12493254999993],
              [-61.71446692599994, -80.11728280999995],
              [-61.72765051999994, -80.09905364399992],
              [-61.73607337099992, -80.0915666649999],
              [-61.749989386999914, -80.08440520599993],
              [-61.795765753999945, -80.06658294099992],
              [-61.807850714999915, -80.05754973799992],
              [-61.80614173099991, -80.05087655999995],
              [-61.795480923999946, -80.04607512799993],
              [-61.78010006399995, -80.04241301899992],
              [-61.74986731699994, -80.03899504999993],
              [-61.65884355399993, -80.03801848799992],
              [-61.66978919199994, -80.03590260199991],
              [-61.70075436099995, -80.0153947899999],
              [-61.29051673099991, -80.01490650799991],
              [-61.26675370999993, -80.00847747199992],
              [-61.25894120999993, -80.00335051899992],
              [-61.23810787699995, -79.98495859199994],
              [-61.235585089999915, -79.97966887799993],
              [-61.24445553299995, -79.97389088299991],
              [-61.308705206999946, -79.94589609199994],
              [-61.468006964999915, -79.91334400799991],
              [-61.515288865999935, -79.89446379999993],
              [-61.522694464999915, -79.89299895599993],
              [-61.49474036399994, -79.88567473799992],
              [-61.466053839999915, -79.88160572699991],
              [-61.120757615999935, -79.87346770599993],
              [-61.09483801999994, -79.83245208099993],
              [-61.02692623599995, -79.80608489399992],
              [-60.551787889499934, -79.73105234199991],
              [-60.07664954299992, -79.6560197899999],
              [-60.04076087099992, -79.66008879999993],
              [-60.04450436099995, -79.66985442499993],
              [-60.05333411399994, -79.67986419099992],
              [-60.06419837099992, -79.68840911299992],
              [-60.07445227799991, -79.69410572699991],
              [-60.082102016999954, -79.69548919099992],
              [-60.099598761999914, -79.69443124799994],
              [-60.10765540299991, -79.69524504999993],
              [-60.14940344999991, -79.70566171699994],
              [-60.22687740799995, -79.70614999799994],
              [-60.48656165299991, -79.73772551899992],
              [-60.40314693899995, -79.75725676899992],
              [-60.11188717349995, -79.76323821399993],
              [-59.82062740799995, -79.76921965899993],
              [-59.79914303299995, -79.77434661299992],
              [-59.810658331999946, -79.78769296699994],
              [-59.82363847599993, -79.79941171699994],
              [-59.838002081999946, -79.80925872199992],
              [-59.853627081999946, -79.81715260199991],
              [-59.837147589999915, -79.82293059699992],
              [-59.81810462099992, -79.82634856599992],
              [-59.79906165299991, -79.8264299459999],
              [-59.749989386999914, -79.8181291649999],
              [-59.71784420499995, -79.82626718499995],
              [-59.65640214799993, -79.85035572699991],
              [-59.783192511999914, -79.83367278399993],
              [-59.83580481699994, -79.83416106599992],
              [-59.854400193999936, -79.83757903399993],
              [-59.87450110599991, -79.84587981599992],
              [-59.884836391999954, -79.85881926899992],
              [-59.87441972599993, -79.87639739399992],
              [-59.8762914699999, -79.87802499799994],
              [-59.88048255099994, -79.88225676899992],
              [-59.88316809799994, -79.88396575299993],
              [-59.86278235599991, -79.90325286299992],
              [-59.82656816299993, -79.90683359199994],
              [-59.78758704299992, -79.90105559699992],
              [-59.7591039699999, -79.89299895599993],
              [-59.74746660099993, -79.88632577899995],
              [-59.73094641799992, -79.88404713299991],
              [-59.677723761999914, -79.8864885399999],
              [-59.655181443999936, -79.89072030999995],
              [-59.625559048999946, -79.90634530999995],
              [-59.718006964999915, -79.90683359199994],
              [-59.73216712099992, -79.91375090899993],
              [-59.727406378999945, -79.92205169099992],
              [-59.71987870999993, -79.92685312299994],
              [-59.702015753999945, -79.93352629999993],
              [-59.69444739499994, -79.93906015399995],
              [-59.68439693899995, -79.9514299459999],
              [-59.67760169199994, -79.95720794099992],
              [-59.708648240999935, -79.9611955709999],
              [-59.71939042899993, -79.96005624799994],
              [-59.729359503999945, -79.95623137799993],
              [-59.75763912699995, -79.94068775799991],
              [-59.77403723899994, -79.93645598799992],
              [-59.791005011999914, -79.9353166649999],
              [-59.84666907499991, -79.9436174459999],
              [-59.85269120999993, -79.94963958099993],
              [-59.85130774599992, -79.9611955709999],
              [-59.86270097599993, -79.96819426899992],
              [-59.85496985599991, -79.97861093499995],
              [-59.82787024599992, -79.99684010199991],
              [-59.82209225199995, -80.00188567499993],
              [-59.791127081999946, -80.02271900799991],
              [-59.77993730399993, -80.03329843499995],
              [-59.775949673999946, -80.0451799459999],
              [-59.78433183499993, -80.05779387799993],
              [-59.799387173999946, -80.06389739399992],
              [-59.93541419199994, -80.07577890399995],
              [-59.96133378799993, -80.08391692499993],
              [-59.92015540299991, -80.10857512799993],
              [-59.909413214999915, -80.1130510399999],
              [-59.89793860599991, -80.11581796699994],
              [-59.51988684799994, -80.11191171699994],
              [-59.43333899599992, -80.1286760399999],
              [-59.42162024599992, -80.13616301899992],
              [-59.43297278599994, -80.14714934699992],
              [-59.44786536399994, -80.1560197899999],
              [-59.47996985599991, -80.16952890399995],
              [-59.366078253999945, -80.16090260199991],
              [-59.34947669199994, -80.16171640399995],
              [-59.334868943999936, -80.16611093499995],
              [-59.332915818999936, -80.16855234199994],
              [-59.33238684799994, -80.17506275799991],
              [-59.33116614499994, -80.17734140399995],
              [-59.32795162699995, -80.17831796699994],
              [-59.286366339999915, -80.1794572899999],
              [-59.287953253999945, -80.18450286299992],
              [-59.290679490999935, -80.18889739399992],
              [-59.29442298099991, -80.19247812299994],
              [-59.29873613199993, -80.19548919099992],
              [-59.286773240999935, -80.20964934699992],
            ],
          ],
          [
            [
              [-66.14907792899993, -79.62818775799991],
              [-65.85781816299993, -79.60214609199994],
              [-65.81940670499995, -79.60800546699994],
              [-65.78856360599991, -79.62460702899995],
              [-65.81338456899994, -79.62753671699994],
              [-65.93789628799993, -79.65894947699991],
              [-65.96564693899995, -79.65976327899995],
              [-65.99181067599994, -79.65536874799994],
              [-65.99242102799991, -79.65422942499993],
              [-65.99840247299994, -79.64837004999993],
              [-66.00206458199995, -79.64617278399993],
              [-66.00975501199991, -79.64544036299992],
              [-66.25649980399993, -79.67327239399992],
              [-66.65623938699991, -79.6604143209999],
              [-66.67870032499991, -79.66285572699991],
              [-66.70075436099995, -79.66806405999995],
              [-66.64586341099994, -79.69019947699991],
              [-66.58409583199995, -79.70183684699992],
              [-66.27179928299995, -79.72144947699991],
              [-66.1145727199999, -79.76685963299991],
              [-66.01659094999991, -79.77483489399992],
              [-65.69127356699994, -79.75188567499993],
              [-65.65103105399993, -79.75896575299993],
              [-65.60094153599994, -79.77654387799993],
              [-65.57111568899995, -79.78281015399995],
              [-65.55406653599994, -79.77743905999995],
              [-65.55858313699991, -79.78289153399993],
              [-65.57945716099994, -79.79461028399993],
              [-65.56045488199993, -79.79876067499993],
              [-65.55150305899991, -79.80266692499993],
              [-65.54478919199994, -79.8083635399999],
              [-65.56578528599994, -79.81267669099992],
              [-65.86851966099994, -79.83098723799992],
              [-65.89549719999991, -79.83912525799991],
              [-65.90127519399994, -79.83953215899993],
              [-65.87498938699991, -79.84921640399995],
              [-65.53038489499994, -79.88274504999993],
              [-65.51699785099993, -79.88640715899993],
              [-65.50584876199991, -79.89332447699991],
              [-65.49974524599992, -79.90422942499993],
              [-65.50121008999992, -79.91399504999993],
              [-65.50389563699991, -79.92343515399995],
              [-65.50161699099993, -79.93352629999993],
              [-65.49229895699995, -79.94060637799993],
              [-65.4778539699999, -79.94597747199992],
              [-65.45010331899994, -79.95240650799991],
              [-65.46336829299992, -79.95273202899995],
              [-65.51158606699994, -79.96453215899993],
              [-65.72740637899994, -79.99041106599992],
              [-65.74168860599991, -79.99553801899992],
              [-65.75377356699994, -80.00212981599992],
              [-65.77676347599993, -80.01848723799992],
              [-65.79474850199995, -80.02743905999995],
              [-66.22272701699995, -80.08635833099993],
              [-66.31045488199993, -80.08074309699992],
              [-66.39537512899994, -80.05982838299991],
              [-66.38589433499993, -80.05201588299991],
              [-66.38206946499992, -80.05006275799991],
              [-66.38585364499994, -80.04216887799993],
              [-66.39513098899994, -80.03728606599992],
              [-66.40615800699993, -80.03362395599993],
              [-66.41527258999992, -80.02947356599992],
              [-66.35440019399994, -80.01620859199994],
              [-66.33584550699993, -80.01628997199992],
              [-66.34203040299991, -80.00066497199992],
              [-66.35777747299994, -79.9865861959999],
              [-66.37669837099992, -79.97551848799992],
              [-66.39244544199994, -79.9685197899999],
              [-66.41930091099994, -79.96038176899992],
              [-66.72203528599994, -79.93661874799994],
              [-66.76943925699993, -79.91961028399993],
              [-66.97301184799994, -79.9216447899999],
              [-67.00894120999993, -79.91326262799993],
              [-67.02574622299994, -79.89837004999993],
              [-67.00072180899991, -79.87623463299991],
              [-66.84626217399995, -79.8220354149999],
              [-66.83763587099992, -79.81536223799992],
              [-66.81920325399994, -79.7966447899999],
              [-66.8118383449999, -79.79192473799992],
              [-66.87157141799992, -79.79810963299991],
              [-66.93333899599992, -79.79257577899995],
              [-67.31187903549991, -79.71542734149995],
              [-67.69041907499991, -79.63827890399995],
              [-67.76012122299994, -79.59368254999993],
              [-67.77647864499994, -79.58847421699994],
              [-67.80577551999994, -79.58660247199992],
              [-67.83210201699995, -79.57935963299991],
              [-67.83983313699991, -79.55877044099992],
              [-67.82803300699993, -79.54599374799994],
              [-67.80540930899991, -79.53850676899992],
              [-67.70734615799995, -79.5256486959999],
              [-67.68008378799993, -79.52743905999995],
              [-67.65392005099994, -79.53411223799992],
              [-67.65729732999995, -79.53679778399993],
              [-67.68114173099991, -79.55136484199994],
              [-67.61725826699995, -79.54420338299991],
              [-67.56265214799993, -79.55144622199992],
              [-67.51964270699995, -79.54876067499993],
              [-67.45006262899994, -79.56698984199994],
              [-67.18407141799995, -79.56654225049994],
              [-66.91808020699995, -79.56609465899993],
              [-66.91075598899994, -79.56519947699991],
              [-66.92516028599994, -79.57268645599993],
              [-66.97516842399995, -79.58318450299993],
              [-66.88825436099995, -79.58603280999995],
              [-66.87096106699994, -79.58855559699992],
              [-66.83348548099991, -79.60149504999993],
              [-66.75096594999991, -79.61679452899995],
              [-66.45002193949992, -79.62249114349993],
              [-66.14907792899993, -79.62818775799991],
            ],
          ],
          [
            [
              [-32.14329993399991, -79.66106536299992],
              [-32.16869055899991, -79.66912200299993],
              [-32.496652798999946, -79.67327239399992],
              [-32.601226365999935, -79.66106536299992],
              [-32.52965247299994, -79.65447356599992],
              [-32.48546301999994, -79.64511484199994],
              [-32.49449622299994, -79.64177825299993],
              [-32.521148240999935, -79.6403947899999],
              [-32.555897589999915, -79.62769947699991],
              [-32.56460527299993, -79.62688567499993],
              [-32.539906378999945, -79.62322356599992],
              [-32.48965410099993, -79.62542083099993],
              [-32.46475175699993, -79.62363046699994],
              [-32.45030676999994, -79.61956145599993],
              [-32.447255011999914, -79.61492278399993],
              [-32.44823157499991, -79.6071916649999],
              [-32.44546464799993, -79.59441497199992],
              [-32.44172115799995, -79.59002044099992],
              [-32.430531378999945, -79.58212655999995],
              [-32.42788652299993, -79.57805754999993],
              [-32.430246548999946, -79.56764088299991],
              [-32.437611456999946, -79.56170012799993],
              [-32.44684811099995, -79.55706145599993],
              [-32.454741990999935, -79.55071379999993],
              [-32.42446855399993, -79.54794687299994],
              [-32.36070716099994, -79.5315080709999],
              [-32.294178839999915, -79.52190520599993],
              [-32.22227942599994, -79.52019622199992],
              [-31.933338995999918, -79.56308359199994],
              [-31.91348222599993, -79.57284921699994],
              [-31.924549933999913, -79.59978606599992],
              [-31.96442623599995, -79.61093515399995],
              [-32.19131425699993, -79.62037525799991],
              [-32.20555579299992, -79.62704843499995],
              [-32.208648240999935, -79.64275481599992],
              [-32.19880123599995, -79.65715911299992],
              [-32.18101966099994, -79.66253020599993],
              [-32.14329993399991, -79.66106536299992],
            ],
          ],
          [
            [
              [-68.23306230399993, -79.28590260199991],
              [-68.13829505099994, -79.26881275799991],
              [-68.1223852199999, -79.26140715899993],
              [-68.09361731699994, -79.24212004999993],
              [-68.07754472599993, -79.23503997199992],
              [-68.01768958199995, -79.22584400799991],
              [-67.61310787699995, -79.21152109199994],
              [-67.33608964749993, -79.23642343549994],
              [-67.05907141799992, -79.26132577899995],
              [-67.04820716099994, -79.26482512799993],
              [-67.06908118399991, -79.28264739399992],
              [-67.09732011599993, -79.29412200299993],
              [-67.19823157499991, -79.3186174459999],
              [-67.21275794199994, -79.31926848799992],
              [-67.22329667899993, -79.31764088299991],
              [-67.25206458199995, -79.30828215899993],
              [-67.27147376199991, -79.30820077899995],
              [-67.33446204299992, -79.32488372199992],
              [-67.5110570949999, -79.39723072699991],
              [-67.49901282499991, -79.40545012799993],
              [-67.48232988199993, -79.4099260399999],
              [-67.33950761599993, -79.42197030999995],
              [-67.31281490799995, -79.42742278399993],
              [-67.28941809799994, -79.43824635199991],
              [-67.29320227799991, -79.4416643209999],
              [-67.30650794199994, -79.44980234199994],
              [-67.29259192599994, -79.4548479149999],
              [-67.24217688699991, -79.45582447699991],
              [-67.25788326699995, -79.46135833099993],
              [-67.33128821499992, -79.47405364399992],
              [-67.37734941299993, -79.49041106599992],
              [-67.42320716099994, -79.50090911299992],
              [-67.46788489499994, -79.50603606599992],
              [-67.93028723849994, -79.48841725049994],
              [-68.39268958199995, -79.47079843499995],
              [-68.45449785099993, -79.4475236959999],
              [-68.55028235599991, -79.44296640399995],
              [-68.57213294199994, -79.43661874799994],
              [-68.56224524599992, -79.42546965899993],
              [-68.53669186099995, -79.41472747199992],
              [-68.50401770699995, -79.40536874799994],
              [-68.00892086499994, -79.36516692499993],
              [-67.51382402299993, -79.32496510199991],
              [-67.46934973899994, -79.30803801899992],
              [-67.50357011599993, -79.30185312299994],
              [-67.67601477799991, -79.30339934699992],
              [-67.69664466099994, -79.30046965899993],
              [-67.70555579299992, -79.29705169099992],
              [-67.71007239499994, -79.29241301899992],
              [-67.70958411399994, -79.28655364399992],
              [-67.70348059799994, -79.27996184699992],
              [-67.71068274599992, -79.28191497199992],
              [-67.79979407499991, -79.28997161299992],
              [-67.85334225199995, -79.28093840899993],
              [-68.26915442599994, -79.32773202899995],
              [-68.43297278599994, -79.32773202899995],
              [-68.44701087099992, -79.32382577899995],
              [-68.41592363199993, -79.31267669099992],
              [-68.23306230399993, -79.28590260199991],
            ],
          ],
          [
            [
              [-67.7122289699999, -79.13681405999995],
              [-67.70225989499994, -79.13437265399995],
              [-67.60252844999991, -79.13665129999993],
              [-67.89293372299991, -79.15996672949993],
              [-68.18333899599992, -79.18328215899993],
              [-68.22594153599994, -79.16814544099992],
              [-68.03473873599995, -79.13396575299993],
              [-67.72032630099994, -79.1189104149999],
              [-67.68814042899993, -79.12517669099992],
              [-67.7122289699999, -79.13681405999995],
            ],
          ],
          [
            [
              [-33.91649329299992, -79.31259530999995],
              [-33.987538214999915, -79.34823984199994],
              [-34.070871548999946, -79.36150481599992],
              [-34.51345781199995, -79.35093895216659],
              [-34.956044074999944, -79.34037308833325],
              [-35.39863033799995, -79.32980722449992],
              [-35.84121660099995, -79.31924136066658],
              [-36.283802863999945, -79.30867549683325],
              [-36.72638912699995, -79.29810963299991],
              [-36.84479732999995, -79.25986093499995],
              [-36.93846594999991, -79.18124765399995],
              [-36.88316809799994, -79.19264088299991],
              [-36.72325598899994, -79.26531340899993],
              [-36.61107337099992, -79.27060312299994],
              [-36.59007727799991, -79.27556731599992],
              [-36.604074673999946, -79.25937265399995],
              [-36.62205969999991, -79.24382903399993],
              [-36.641468878999945, -79.23113372199992],
              [-36.65957597599993, -79.22307708099993],
              [-36.25186113199993, -79.19585540149993],
              [-35.84414628799993, -79.16863372199992],
              [-35.78783118399991, -79.15349700299993],
              [-35.68407141799992, -79.10784270599993],
              [-35.62865149599992, -79.09392669099992],
              [-35.50340735599991, -79.0901018209999],
              [-35.00922604099992, -79.14956362666658],
              [-34.51504472599993, -79.20902543233325],
              [-34.02086341099994, -79.26848723799992],
              [-33.91649329299992, -79.31259530999995],
            ],
          ],
          [
            [
              [-75.58836829299992, -78.75790780999995],
              [-75.50584876199991, -78.73512135199991],
              [-75.44692949099993, -78.73007577899995],
              [-75.39366614499994, -78.74098072699991],
              [-75.39557857999995, -78.7419572899999],
              [-75.39635169199994, -78.74285247199992],
              [-75.39614824099993, -78.74374765399995],
              [-75.39488684799994, -78.74456145599993],
              [-75.4434301419999, -78.76140715899993],
              [-75.46507727799991, -78.77206796699994],
              [-75.47378495999993, -78.78508879999993],
              [-75.49705969999991, -78.79013437299994],
              [-75.51439368399991, -78.79705169099992],
              [-75.52497311099995, -78.80592213299991],
              [-75.52794348899994, -78.81715260199991],
              [-75.52000891799992, -78.8244768209999],
              [-75.48753821499992, -78.84002044099992],
              [-75.48119055899991, -78.85230885199991],
              [-75.49128170499995, -78.8630510399999],
              [-75.51235917899993, -78.86679452899995],
              [-75.55174719999991, -78.86467864399992],
              [-75.60301673099991, -78.85466887799993],
              [-75.62865149599992, -78.8454729149999],
              [-75.64989173099991, -78.83318450299993],
              [-75.66055253799993, -78.80974700299993],
              [-75.64338131399995, -78.78769296699994],
              [-75.61392167899993, -78.76946379999993],
              [-75.58836829299992, -78.75790780999995],
            ],
          ],
          [
            [
              [-66.73436438699991, -78.44182708099993],
              [-66.76866614499994, -78.45029062299994],
              [-66.87507076699995, -78.4587541649999],
              [-67.05675208199995, -78.49529387799993],
              [-67.05215410099993, -78.49863046699994],
              [-67.02269446499992, -78.51433684699992],
              [-67.05614173099991, -78.52792734199994],
              [-67.15941321499992, -78.55348072699991],
              [-67.26455644399994, -78.60515715899993],
              [-67.30199133999992, -78.61834075299993],
              [-67.34203040299991, -78.62493254999993],
              [-67.35472571499992, -78.62900155999995],
              [-67.36803137899994, -78.63689544099992],
              [-67.38817298099991, -78.65593840899993],
              [-67.39952551999994, -78.66423919099992],
              [-67.78625444249994, -78.77249521299993],
              [-68.17298336499994, -78.88075123499993],
              [-68.55971228749993, -78.98900725699994],
              [-68.94644120999993, -79.09726327899995],
              [-68.96312415299991, -79.10849374799994],
              [-68.96442623599995, -79.11321379999993],
              [-68.95938066299993, -79.12167734199994],
              [-68.95962480399993, -79.12558359199994],
              [-68.97606360599991, -79.13811614399992],
              [-68.99860592399995, -79.14666106599992],
              [-69.29600989499994, -79.21770598799992],
              [-69.30776933499993, -79.22454192499993],
              [-69.31493079299992, -79.23154062299994],
              [-69.32433020699995, -79.2458635399999],
              [-69.33047441299993, -79.25310637799993],
              [-69.36009680899991, -79.27117278399993],
              [-69.46446692599994, -79.29802825299993],
              [-69.59821529899995, -79.37420012799993],
              [-69.60374915299991, -79.37932708099993],
              [-69.61310787699995, -79.39177825299993],
              [-69.61913001199991, -79.39706796699994],
              [-69.62975012899994, -79.40227629999993],
              [-69.66478430899991, -79.41179778399993],
              [-69.64745032499991, -79.41594817499993],
              [-69.60627193899995, -79.41765715899993],
              [-69.52424068899995, -79.41179778399993],
              [-69.50332597599993, -79.41513437299994],
              [-69.78050696499992, -79.44247812299994],
              [-69.82201087099992, -79.45842864399992],
              [-69.8008520169999, -79.46884530999995],
              [-69.66795813699991, -79.48691171699994],
              [-69.64683997299994, -79.49334075299993],
              [-69.58731035099993, -79.52019622199992],
              [-69.56305904899995, -79.52605559699992],
              [-69.49156653599994, -79.53264739399992],
              [-69.69188391799992, -79.54119231599992],
              [-69.70409094999991, -79.54509856599992],
              [-69.71593176999994, -79.5510393209999],
              [-69.72679602799991, -79.55852629999993],
              [-69.73615475199995, -79.56715260199991],
              [-69.6465551419999, -79.6037736959999],
              [-69.9941707019999, -79.65032317499993],
              [-70.34178626199991, -79.69687265399995],
              [-70.70924502933326, -79.68222421666661],
              [-71.0767037966666, -79.66757577933328],
              [-71.44416256399995, -79.65292734199994],
              [-71.55890865799995, -79.6233049459999],
              [-71.67039954299992, -79.58114999799994],
              [-71.78107662699995, -79.52402109199994],
              [-71.80516516799992, -79.50042083099993],
              [-71.81330318899995, -79.4885393209999],
              [-71.81566321499992, -79.47918059699992],
              [-71.81480872299994, -79.45330169099992],
              [-71.80337480399993, -79.42782968499995],
              [-71.78624426999994, -79.40422942499993],
              [-71.76838131399995, -79.3850236959999],
              [-71.75291907499991, -79.32512786299992],
              [-71.68846594999991, -79.26043059699992],
              [-71.59959876199991, -79.19996510199991],
              [-71.39541581899994, -79.10173919099992],
              [-70.99408932199992, -78.99382903449992],
              [-70.59276282499991, -78.88591887799993],
              [-70.41124426999994, -78.8825822899999],
              [-70.36611894399994, -78.87297942499993],
              [-70.27594967399995, -78.84059010199991],
              [-69.83336341099994, -78.79973723799992],
              [-69.69668535099993, -78.75286223799992],
              [-69.60850989499994, -78.74570077899995],
              [-69.57754472599993, -78.73943450299993],
              [-69.47321529899995, -78.70273202899995],
              [-69.45189368399991, -78.69150155999995],
              [-69.43724524599992, -78.68710702899995],
              [-69.01046708849992, -78.62041594824994],
              [-68.58368893099993, -78.55372486749994],
              [-68.15691077349993, -78.48703378674993],
              [-67.73013261599993, -78.42034270599993],
              [-67.62637285099993, -78.38347747199992],
              [-67.57762610599991, -78.37184010199991],
              [-67.28526770749991, -78.33928801849993],
              [-66.99290930899991, -78.30673593499995],
              [-66.73086503799993, -78.32146575299993],
              [-66.66392981699994, -78.33668385199991],
              [-66.60553951699995, -78.36370208099993],
              [-66.62905839799993, -78.37957122199992],
              [-66.65929114499994, -78.38909270599993],
              [-66.83568274599992, -78.41415780999995],
              [-66.87254798099991, -78.4279924459999],
              [-66.83360755099994, -78.43661874799994],
              [-66.79405676999994, -78.44101327899995],
              [-66.77855383999992, -78.43962981599992],
              [-66.76349850199995, -78.43645598799992],
              [-66.74885006399995, -78.43572356599992],
              [-66.73436438699991, -78.44182708099993],
            ],
          ],
          [
            [
              [-52.518788214999915, -80.20012786299992],
              [-52.39635169199994, -80.18499114399992],
              [-51.939706997999934, -80.05559661249993],
              [-51.48306230399993, -79.92620208099993],
              [-51.33897864499994, -79.8650041649999],
              [-51.062570766999954, -79.79941171699994],
              [-50.91616777299993, -79.73300546699994],
              [-50.54137122299994, -79.63787200299993],
              [-50.40306555899991, -79.57097747199992],
              [-50.35334225199995, -79.55437590899993],
              [-50.282134568999936, -79.54485442499993],
              [-50.263661261999914, -79.53573984199994],
              [-50.25365149599992, -79.52263762799993],
              [-50.24038652299993, -79.49472421699994],
              [-50.22630774599992, -79.48040129999993],
              [-50.245432094999956, -79.46591562299994],
              [-50.25348873599995, -79.4626604149999],
              [-50.25177975199995, -79.45777760199991],
              [-50.25104732999995, -79.45322030999995],
              [-50.24962317599994, -79.44841887799993],
              [-50.246205206999946, -79.44329192499993],
              [-50.28075110599991, -79.42669036299992],
              [-50.32408606699994, -79.41521575299993],
              [-50.350168423999946, -79.39853280999995],
              [-50.33307857999995, -79.36614348799992],
              [-50.389230923999946, -79.33082447699991],
              [-50.46007239499994, -79.31210702899995],
              [-50.71312415299991, -79.28167083099993],
              [-50.73973548099991, -79.28443775799991],
              [-50.65103105399993, -79.24325937299994],
              [-50.54430091099994, -79.16171640399995],
              [-50.49791419199994, -79.13836028399993],
              [-50.484364386999914, -79.12932708099993],
              [-50.480458136999914, -79.11598072699991],
              [-50.49242102799991, -79.09563567499993],
              [-50.48037675699993, -79.07968515399995],
              [-50.45547441299993, -79.02214934699992],
              [-50.45299231699994, -79.00383879999993],
              [-50.474680141999954, -78.98357512799993],
              [-50.540679490999935, -78.9748674459999],
              [-50.56135006399995, -78.95956796699994],
              [-50.51866614499994, -78.94573333099993],
              [-50.37905839799993, -78.92986419099992],
              [-50.33429928299995, -78.9138322899999],
              [-50.29088294199994, -78.89153411299992],
              [-50.25035559799994, -78.86402760199991],
              [-50.21442623599995, -78.83294036299992],
              [-50.32469641799992, -78.83831145599993],
              [-50.38027910099993, -78.83171965899993],
              [-50.430531378999945, -78.81259530999995],
              [-50.26732337099992, -78.72323984199994],
              [-50.28172766799992, -78.72128671699994],
              [-50.309478318999936, -78.72185637799993],
              [-50.323475714999915, -78.71998463299991],
              [-50.36351477799991, -78.69622161299992],
              [-50.36742102799991, -78.69052499799994],
              [-50.34194902299993, -78.68303801899992],
              [-50.28868567599994, -78.67937590899993],
              [-50.26390540299991, -78.67131926899992],
              [-50.24974524599992, -78.65748463299991],
              [-50.23281816299993, -78.62070077899995],
              [-50.22109941299993, -78.60442473799992],
              [-50.20409094999991, -78.59303150799991],
              [-50.05654863199993, -78.53411223799992],
              [-50.04210364499994, -78.52337004999993],
              [-50.01707923099991, -78.49871184699992],
              [-50.00308183499993, -78.48796965899993],
              [-49.97105872299994, -78.47332122199992],
              [-49.89488684799994, -78.45322030999995],
              [-49.58647620349993, -78.32704029699994],
              [-49.27806555899991, -78.20086028399993],
              [-49.25072180899991, -78.1794572899999],
              [-49.24767005099994, -78.17205169099992],
              [-49.24600175699993, -78.15243905999995],
              [-49.234445766999954, -78.13982512799993],
              [-49.220814581999946, -78.13160572699991],
              [-49.11558997299994, -78.09465911299992],
              [-49.10301673099991, -78.07976653399993],
              [-49.138742641999954, -78.06975676899992],
              [-49.110991990999935, -78.05291106599992],
              [-49.072336391999954, -78.04216887799993],
              [-48.60988318574995, -77.97478606549993],
              [-48.14742997949995, -77.90740325299993],
              [-47.68497677324994, -77.84002044049993],
              [-47.22252356699994, -77.77263762799993],
              [-46.79303951733326, -77.78744882599993],
              [-46.36355546766659, -77.80226002399992],
              [-45.93407141799992, -77.81707122199992],
              [-45.89517167899993, -77.82854583099993],
              [-45.4349666006666, -77.89975351333327],
              [-44.97476152233327, -77.97096119566659],
              [-44.514556443999936, -78.04216887799993],
              [-44.16669674349993, -78.14523691199992],
              [-43.81883704299992, -78.2483049459999],
              [-43.76854407499991, -78.27418385199991],
              [-43.73106848899994, -78.31178150799991],
              [-43.71825110599991, -78.3674455709999],
              [-43.72508704299992, -78.39495208099993],
              [-43.74014238199993, -78.41448333099993],
              [-43.78258216099994, -78.44736093499995],
              [-43.799387173999946, -78.4646135399999],
              [-43.82774817599994, -78.50400155999995],
              [-43.89981035099993, -78.5842424459999],
              [-43.92027747299994, -78.59628671699994],
              [-43.96312415299991, -78.6032854149999],
              [-44.36066647066658, -78.6228166649999],
              [-44.75820878833324, -78.6423479149999],
              [-45.15575110599991, -78.6618791649999],
              [-45.302723761999914, -78.68035247199992],
              [-45.34996497299994, -78.69329192499993],
              [-45.224598761999914, -78.73560963299991],
              [-45.37047278599994, -78.78606536299992],
              [-45.298166469999956, -78.81072356599992],
              [-45.21898352799991, -78.81894296699994],
              [-44.72565670499991, -78.8128123246666],
              [-44.23232988199991, -78.80668168233325],
              [-43.73900305899991, -78.8005510399999],
              [-43.71231035099993, -78.80877044099992],
              [-43.55345618399991, -78.88054778399993],
              [-43.50064042899993, -78.9138322899999],
              [-43.459868943999936, -78.95549895599993],
              [-43.44432532499991, -78.9885393209999],
              [-43.43081620999993, -79.03785572699991],
              [-43.43004309799994, -79.08489348799992],
              [-43.45254472599993, -79.11077239399992],
              [-43.405588344999956, -79.10035572699991],
              [-43.38158118399991, -79.09832122199992],
              [-43.35777747299994, -79.10076262799993],
              [-43.34357662699995, -79.1076799459999],
              [-43.305531378999945, -79.13600025799991],
              [-43.19985917899993, -79.1584611959999],
              [-43.14883378799993, -79.1794572899999],
              [-43.13353430899991, -79.1818986959999],
              [-43.188343878999945, -79.18906015399995],
              [-43.34845943899995, -79.23919036299992],
              [-43.309803839999915, -79.26751067499993],
              [-43.150949673999946, -79.31511809699992],
              [-43.106678839999915, -79.3342424459999],
              [-43.069650844999956, -79.3557268209999],
              [-43.07022050699993, -79.36288827899995],
              [-43.065744594999956, -79.37151458099993],
              [-43.05939693899995, -79.38079192499993],
              [-43.05459550699993, -79.38958098799992],
              [-43.04149329299992, -79.40056731599992],
              [-42.98965410099993, -79.4201799459999],
              [-42.971547003999945, -79.4299455709999],
              [-42.96157792899993, -79.44085051899992],
              [-42.95352128799993, -79.45256926899992],
              [-42.94713294199994, -79.46542734199994],
              [-42.94237219999991, -79.47909921699994],
              [-42.93907630099994, -79.49293385199991],
              [-42.936431443999936, -79.52206796699994],
              [-42.962228969999956, -79.71607838299991],
              [-42.98151607999995, -79.78655364399992],
              [-43.015736456999946, -79.84978606599992],
              [-43.072824673999946, -79.90894947699991],
              [-43.13744055899991, -79.95175546699994],
              [-43.207142706999946, -79.97812265399995],
              [-43.281239386999914, -79.98796965899993],
              [-43.59618079299992, -79.96347421699994],
              [-43.856678839999915, -79.99602629999993],
              [-43.85313880099994, -79.99627044099992],
              [-43.85195878799993, -79.99667734199994],
              [-43.85309811099995, -79.99700286299992],
              [-43.85651607999995, -79.99749114399992],
              [-43.477121548999946, -80.09465911299992],
              [-43.43797766799992, -80.10947030999995],
              [-43.42341061099995, -80.13152434699992],
              [-43.452381964999915, -80.16448333099993],
              [-43.53156490799995, -80.19996510199991],
              [-44.00753896646149, -80.2373248776153],
              [-44.48351302492302, -80.27468465323068],
              [-44.95948708338456, -80.31204442884606],
              [-45.43546114184609, -80.34940420446146],
              [-45.91143520030763, -80.38676398007685],
              [-46.38740925876917, -80.42412375569224],
              [-46.8633833172307, -80.46148353130762],
              [-47.33935737569224, -80.498843306923],
              [-47.81533143415378, -80.53620308253839],
              [-48.29130549261531, -80.57356285815379],
              [-48.76727955107685, -80.61092263376918],
              [-49.24325360953838, -80.64828240938456],
              [-49.71922766799992, -80.68564218499995],
              [-49.74266516799992, -80.6950822899999],
              [-49.75625566299993, -80.70696379999993],
              [-49.759103969999956, -80.72185637799993],
              [-49.75047766799992, -80.74032968499995],
              [-49.74156653599994, -80.74236419099992],
              [-49.69953365799995, -80.7619768209999],
              [-49.69595292899993, -80.76799895599993],
              [-49.79800370999993, -80.79094817499993],
              [-50.28284890677771, -80.80052391288882],
              [-50.767694103555485, -80.8100996507777],
              [-51.25253930033326, -80.8196753886666],
              [-51.73738449711104, -80.82925112655548],
              [-52.222229693888806, -80.83882686444437],
              [-52.70707489066658, -80.84840260233325],
              [-53.19192008744436, -80.85797834022215],
              [-53.676765284222135, -80.86755407811103],
              [-54.16161048099991, -80.87712981599992],
              [-54.25841223899994, -80.85507577899995],
              [-54.29002844999991, -80.83855559699992],
              [-54.34911048099991, -80.78248463299991],
              [-54.36318925699993, -80.77206796699994],
              [-54.396555141999954, -80.75253671699994],
              [-54.40782630099994, -80.7400041649999],
              [-54.412953253999945, -80.71746184699992],
              [-54.411000128999945, -80.68938567499993],
              [-54.40465247299994, -80.66139088299991],
              [-54.39639238199993, -80.63941822699991],
              [-54.38329016799992, -80.6233049459999],
              [-54.36896725199995, -80.61012135199991],
              [-54.36363684799994, -80.59612395599993],
              [-54.37759355399993, -80.57740650799991],
              [-54.273101365999935, -80.53606536299992],
              [-54.21751868399991, -80.5217424459999],
              [-54.16380774599992, -80.53004322699991],
              [-54.146148240999935, -80.54501718499995],
              [-54.134429490999935, -80.56121184699992],
              [-54.12067623599995, -80.56894296699994],
              [-54.09650631399995, -80.5583635399999],
              [-54.08165442599994, -80.5432268209999],
              [-54.06383216099994, -80.50847747199992],
              [-54.05101477799991, -80.4919572899999],
              [-54.01935787699995, -80.47063567499993],
              [-53.78941809799994, -80.36060963299991],
              [-53.58946692599994, -80.23211028399993],
              [-53.42365475199995, -80.19304778399993],
              [-53.43016516799992, -80.18230559699992],
              [-53.43691972599993, -80.1735979149999],
              [-53.44546464799993, -80.16668059699992],
              [-53.45763098899994, -80.16090260199991],
              [-53.40705318899995, -80.1076799459999],
              [-53.342640753999945, -80.1071916649999],
              [-53.21320553299995, -80.16139088299991],
              [-53.15147864499994, -80.17595794099992],
              [-53.088002081999946, -80.18181731599992],
              [-52.89024817599994, -80.17701588299991],
              [-52.69432532499991, -80.14373137799993],
              [-52.606678839999915, -80.10759856599992],
              [-52.40933183499993, -80.05510833099993],
              [-52.351551886999914, -80.0529924459999],
              [-52.30235755099994, -80.06121184699992],
              [-52.27989661399994, -80.07830169099992],
              [-52.28758704299992, -80.10165780999995],
              [-52.329009568999936, -80.12835051899992],
              [-52.4761042959999, -80.19272226399994],
              [-52.52281653599994, -80.1989885399999],
              [-52.518788214999915, -80.20012786299992],
            ],
          ],
          [
            [
              [-49.258656378999945, -77.87249114399992],
              [-49.39122473899994, -77.88054778399993],
              [-49.41519120999993, -77.87802499799994],
              [-49.44505774599992, -77.86467864399992],
              [-49.45079505099994, -77.8630510399999],
              [-49.430897589999915, -77.85312265399995],
              [-49.33641516799992, -77.82976653399993],
              [-48.98900305899991, -77.78427499799994],
              [-48.846913214999915, -77.74423593499995],
              [-48.81419837099992, -77.73886484199994],
              [-48.78160559799994, -77.73919036299992],
              [-48.75035559799994, -77.74765390399995],
              [-48.77090410099993, -77.75017669099992],
              [-49.24547278599994, -77.86565520599993],
              [-49.258656378999945, -77.87249114399992],
            ],
          ],
          [
            [
              [-20.366566535999937, -74.42538827899995],
              [-20.369130011999914, -74.43368905999995],
              [-20.372710740999935, -74.4416643209999],
              [-20.377674933999913, -74.44939544099992],
              [-20.403675910999937, -74.4763322899999],
              [-20.414784308999913, -74.48381926899992],
              [-20.428456183999913, -74.48919036299992],
              [-20.47809811099995, -74.49871184699992],
              [-20.528553839999915, -74.50261809699992],
              [-20.806630011999914, -74.47519296699994],
              [-20.843006964999915, -74.46282317499993],
              [-20.865712042999917, -74.43906015399995],
              [-20.867014126999948, -74.43157317499993],
              [-20.864979620999918, -74.41806405999995],
              [-20.865712042999917, -74.41033294099992],
              [-20.869618292999917, -74.40162525799991],
              [-20.887440558999913, -74.3752580709999],
              [-20.959828253999945, -74.2385393209999],
              [-20.981190558999913, -74.21103280999995],
              [-21.01195227799991, -74.18718840899993],
              [-21.062652147999927, -74.16318124799994],
              [-21.122425910999937, -74.1428361959999],
              [-21.29946855399993, -74.10588958099993],
              [-21.713449673999946, -74.08847421699994],
              [-22.021148240999935, -74.11402760199991],
              [-22.04015051999994, -74.10556405999995],
              [-21.89395097599993, -74.04168059699992],
              [-21.614999966499937, -74.02267831849991],
              [-21.336048956999946, -74.0036760399999],
              [-21.234852667999917, -73.98064544099992],
              [-21.145375128999945, -73.95012786299992],
              [-21.069569464999915, -73.91301848799992],
              [-21.009510870999918, -73.87053801899992],
              [-21.01073157499991, -73.8259416649999],
              [-20.94090735599991, -73.75107187299994],
              [-20.924387173999946, -73.70435963299991],
              [-20.890370245999918, -73.67896900799991],
              [-20.853586391999954, -73.66008879999993],
              [-20.814198370999918, -73.64641692499993],
              [-20.648793097999942, -73.6193986959999],
              [-20.640736456999946, -73.61581796699994],
              [-20.637603318999936, -73.61003997199992],
              [-20.635324673999946, -73.60084400799991],
              [-20.635609503999945, -73.5920549459999],
              [-20.640248175999943, -73.58749765399995],
              [-20.611154751999948, -73.59465911299992],
              [-20.582875128999945, -73.6057268209999],
              [-20.556630011999914, -73.62078215899993],
              [-20.53311113199993, -73.63958098799992],
              [-20.51585852799991, -73.65976327899995],
              [-20.50918535099993, -73.67766692499993],
              [-20.51268469999991, -73.6955705709999],
              [-20.525461391999954, -73.71575286299992],
              [-20.53502356699994, -73.73951588299991],
              [-20.528187628999945, -73.75920989399992],
              [-20.495838995999918, -73.79371510199991],
              [-20.54320227799991, -73.81894296699994],
              [-20.56627356699994, -73.83603280999995],
              [-20.58311926999994, -73.85409921699994],
              [-20.584462042999917, -73.86516692499993],
              [-20.578724738999938, -73.87607187299994],
              [-20.575835740999935, -73.88746510199991],
              [-20.59992428299995, -73.91765715899993],
              [-20.600087042999917, -73.93417734199994],
              [-20.594349738999938, -73.95134856599992],
              [-20.59121660099993, -73.97128671699994],
              [-20.59862219999991, -73.9904924459999],
              [-20.61432857999995, -74.0002580709999],
              [-20.632476365999935, -74.0075822899999],
              [-20.647368943999936, -74.01946379999993],
              [-20.650786912999934, -74.02776458099993],
              [-20.650990363999938, -74.04509856599992],
              [-20.65225175699993, -74.05388762799993],
              [-20.658762173999946, -74.06715260199991],
              [-20.66901607999995, -74.08066171699994],
              [-20.68106035099993, -74.09286874799994],
              [-20.69286048099991, -74.10198333099993],
              [-20.661732550999943, -74.12851327899995],
              [-20.609527147999927, -74.19264088299991],
              [-20.579904751999948, -74.2209611959999],
              [-20.42564856699994, -74.30901458099993],
              [-20.39948482999995, -74.33171965899993],
              [-20.378651495999918, -74.36077239399992],
              [-20.36668860599991, -74.39299895599993],
              [-20.366566535999937, -74.42538827899995],
            ],
          ],
          [
            [
              [-73.82384192599994, -73.38746510199991],
              [-73.80357825399994, -73.37249114399992],
              [-73.7793676419999, -73.3591447899999],
              [-73.75523841099994, -73.35564544099992],
              [-73.73509680899991, -73.37004973799992],
              [-73.7461645169999, -73.37908294099992],
              [-73.75926673099991, -73.38730234199994],
              [-73.77342688699991, -73.39332447699991],
              [-73.78758704299992, -73.39641692499993],
              [-73.79503333199995, -73.39609140399995],
              [-73.82192949099993, -73.39169687299994],
              [-73.82384192599994, -73.38746510199991],
            ],
          ],
          [
            [
              [-71.79653886599993, -73.21982187299994],
              [-71.85448157499991, -73.24553801899992],
              [-71.92027747299994, -73.25855885199991],
              [-71.98737545499995, -73.25839609199994],
              [-72.04906165299991, -73.24374765399995],
              [-72.09618079299992, -73.21453215899993],
              [-72.08092200399994, -73.19459400799991],
              [-72.0325414699999, -73.18368905999995],
              [-71.98082434799994, -73.18108489399992],
              [-71.88565019399994, -73.18889739399992],
              [-71.84044348899994, -73.20012786299992],
              [-71.79653886599993, -73.21982187299994],
            ],
          ],
          [
            [
              [-73.88683020699995, -73.12004973799992],
              [-73.69815019399994, -73.09880950299993],
              [-73.65001380099994, -73.1013322899999],
              [-73.60240637899994, -73.1091447899999],
              [-73.53864498599995, -73.13014088299991],
              [-73.52253170499995, -73.13014088299991],
              [-73.67357337099992, -73.20427825299993],
              [-73.69212805899991, -73.21697356599992],
              [-73.70567786399994, -73.23650481599992],
              [-73.70152747299994, -73.2385393209999],
              [-73.69448808499993, -73.24822356599992],
              [-73.68846594999991, -73.26116301899992],
              [-73.68773352799991, -73.27304452899995],
              [-73.69530188699991, -73.28281015399995],
              [-73.70836341099994, -73.29159921699994],
              [-73.76060950399994, -73.31438567499993],
              [-73.83893795499995, -73.33464934699992],
              [-73.89167232999995, -73.3654924459999],
              [-73.91038977799991, -73.37314218499995],
              [-73.93390865799995, -73.37371184699992],
              [-73.95734615799995, -73.36923593499995],
              [-73.9798070949999, -73.36834075299993],
              [-74.00055904899995, -73.38030364399992],
              [-73.99958248599995, -73.39788176899992],
              [-74.01471920499995, -73.40634530999995],
              [-74.03587805899991, -73.40699635199991],
              [-74.05308997299994, -73.40154387799993],
              [-74.06200110599991, -73.39185963299991],
              [-74.06680253799993, -73.3791643209999],
              [-74.06729081899994, -73.36565520599993],
              [-74.06314042899993, -73.35320403399993],
              [-74.14561926999994, -73.32350025799991],
              [-74.15916907499991, -73.30803801899992],
              [-74.15794837099992, -73.3005510399999],
              [-74.15453040299991, -73.29550546699994],
              [-74.15143795499995, -73.2893205709999],
              [-74.15086829299992, -73.27922942499993],
              [-74.12999426999994, -73.27206796699994],
              [-74.00291907499991, -73.25156015399995],
              [-74.01748613199993, -73.24814218499995],
              [-74.04784094999991, -73.22625090899993],
              [-74.06358801999994, -73.22031015399995],
              [-74.04576575399994, -73.21770598799992],
              [-73.99010169199994, -73.21803150799991],
              [-73.91124426999994, -73.20525481599992],
              [-73.88731848899994, -73.19646575299993],
              [-73.87486731699994, -73.1897111959999],
              [-73.86790930899991, -73.18222421699994],
              [-73.86636308499993, -73.16887786299992],
              [-73.87328040299991, -73.16253020599993],
              [-73.88512122299994, -73.15764739399992],
              [-73.89830481699994, -73.14918385199991],
              [-73.88683020699995, -73.12004973799992],
            ],
          ],
          [
            [
              [-104.68712317599994, -73.09653085699995],
              [-104.63760331899994, -73.11646900799991],
              [-104.59105383999992, -73.12965260199991],
              [-104.55394446499992, -73.14576588299991],
              [-104.53270423099991, -73.17449309699992],
              [-104.63048255099994, -73.21135833099993],
              [-104.74693762899994, -73.2185197899999],
              [-104.85948645699995, -73.20671965899993],
              [-104.94566809799994, -73.18621184699992],
              [-104.99889075399994, -73.16448333099993],
              [-105.03766842399995, -73.1403947899999],
              [-105.09886633999992, -73.08668385199991],
              [-105.11953691299993, -73.06259530999995],
              [-105.14073645699995, -73.02060312299994],
              [-105.15538489499994, -73.00530364399992],
              [-105.06102454299992, -72.95419687299994],
              [-105.01414954299992, -72.94052499799994],
              [-104.95860755099994, -72.94264088299991],
              [-104.93569902299993, -72.95086028399993],
              [-104.88182532499991, -72.98943450299993],
              [-104.68712317599994, -73.09644947699991],
              [-104.68712317599994, -73.09653085699995],
            ],
          ],
          [
            [
              [-89.89244544199994, -72.88461679499994],
              [-89.89244544199994, -72.8845354149999],
              [-89.88206946499992, -72.87411874799994],
              [-89.8692113919999, -72.8654924459999],
              [-89.85216223899994, -72.85881926899992],
              [-89.82917232999995, -72.85409921699994],
              [-89.78551184799994, -72.85027434699992],
              [-89.57152258999992, -72.86296965899993],
              [-89.40562903599994, -72.89568450299993],
              [-89.33067786399994, -72.9279924459999],
              [-89.35936438699991, -72.94597747199992],
              [-89.47874915299991, -72.97576262799993],
              [-89.50772050699993, -72.99716562299994],
              [-89.55524654899995, -73.05071379999993],
              [-89.58507239499994, -73.07040780999995],
              [-89.63329016799992, -73.0837541649999],
              [-89.68911699099993, -73.09059010199991],
              [-89.79637610599991, -73.09238046699994],
              [-89.99567623599995, -73.06764088299991],
              [-90.13247636599993, -73.09441497199992],
              [-90.21914628799993, -73.0842424459999],
              [-90.29596920499995, -73.04949309699992],
              [-90.33629309799994, -72.98739999799994],
              [-90.28246008999992, -72.94133879999993],
              [-90.21568762899994, -72.94451262799993],
              [-90.09390214799993, -72.98650481599992],
              [-90.0508520169999, -72.98626067499993],
              [-90.00552324099993, -72.97673919099992],
              [-89.96336829299992, -72.95826588299991],
              [-89.92935136599993, -72.93157317499993],
              [-89.89244544199994, -72.88461679499994],
            ],
          ],
          [
            [
              [-74.84679114499994, -72.86663176899992],
              [-74.5039770169999, -72.88209400799991],
              [-74.30955969999991, -72.92107512799993],
              [-74.21857662699995, -72.99081796699994],
              [-74.23989824099993, -73.02011484199994],
              [-74.38609778599994, -73.10271575299993],
              [-74.39509029899995, -73.11825937299994],
              [-74.40575110599991, -73.15243905999995],
              [-74.41470292899993, -73.16765715899993],
              [-74.43297278599994, -73.1818986959999],
              [-74.50023352799991, -73.20794036299992],
              [-74.50841223899994, -73.25237395599993],
              [-74.69469153599994, -73.27654387799993],
              [-74.75804602799991, -73.30315520599993],
              [-74.71703040299991, -73.30934010199991],
              [-74.59190833199995, -73.30877044099992],
              [-74.55459550699993, -73.3166643209999],
              [-74.53237870999993, -73.33171965899993],
              [-74.53010006399995, -73.35491301899992],
              [-74.55235755099994, -73.38738372199992],
              [-74.50194251199991, -73.39324309699992],
              [-74.47451738199993, -73.40195077899995],
              [-74.45856686099995, -73.41529713299991],
              [-74.44123287699995, -73.43377044099992],
              [-74.36091061099995, -73.46038176899992],
              [-74.38194739499994, -73.48015715899993],
              [-74.40322831899994, -73.52532317499993],
              [-74.41844641799992, -73.54827239399992],
              [-74.43956458199995, -73.5666643209999],
              [-74.46532141799992, -73.58294036299992],
              [-74.51939856699994, -73.60605234199994],
              [-74.59312903599994, -73.61451588299991],
              [-75.02028018599994, -73.52521466799992],
              [-75.44743133599995, -73.43591345299991],
              [-75.87458248599995, -73.34661223799992],
              [-76.03099524599992, -73.28386809699992],
              [-76.05211341099994, -73.26213958099993],
              [-76.11432857999995, -73.17962004999993],
              [-76.12612870999993, -73.15878671699994],
              [-76.10313880099994, -73.1228166649999],
              [-76.07412675699993, -73.09880950299993],
              [-76.03917395699995, -73.0842424459999],
              [-75.85822506399995, -73.04762135199991],
              [-75.74815833199995, -73.05771249799994],
              [-75.52452551999994, -73.11337655999995],
              [-75.41681881399995, -73.10670338299991],
              [-75.46092688699991, -73.07350025799991],
              [-75.43321692599994, -73.05478280999995],
              [-75.37279212099992, -73.04631926899992],
              [-75.09630286399994, -73.05584075299993],
              [-75.03819739499994, -73.04143645599993],
              [-75.03978430899991, -73.03997161299992],
              [-75.04002844999991, -73.03899504999993],
              [-75.03892981699994, -73.03875090899993],
              [-75.0364477199999, -73.03899504999993],
              [-75.21104895699995, -73.00554778399993],
              [-75.40672766799992, -73.00253671699994],
              [-75.50108801999994, -72.98935312299994],
              [-75.7044164699999, -72.92278411299992],
              [-75.76154537699995, -72.89641692499993],
              [-75.77574622299994, -72.89364999799994],
              [-75.69664466099994, -72.87859465899993],
              [-75.57323157499991, -72.86956145599993],
              [-75.55532792899993, -72.87151458099993],
              [-75.5410863919999, -72.86142343499995],
              [-75.4473363919999, -72.8283830709999],
              [-75.40387936099995, -72.8220354149999],
              [-75.29580644399994, -72.81951262799993],
              [-74.94640051999994, -72.86541106599992],
              [-74.84679114499994, -72.86663176899992],
            ],
          ],
          [
            [
              [-93.7508031889999, -72.88860442499993],
              [-93.74998938699991, -72.90553150799991],
              [-93.77354895699995, -72.9182268209999],
              [-93.81354732999995, -72.92620208099993],
              [-93.86204993399991, -72.92815520599993],
              [-94.00011145699995, -72.91904062299994],
              [-94.0703832669999, -72.90276458099993],
              [-94.12816321499992, -72.87297942499993],
              [-94.06834876199991, -72.82586028399993],
              [-93.98289954299992, -72.81902434699992],
              [-93.81822669199994, -72.85637786299992],
              [-93.77306067599994, -72.87322356599992],
              [-93.75926673099991, -72.8811174459999],
              [-93.7508031889999, -72.88860442499993],
            ],
          ],
          [
            [
              [-98.13076738199993, -72.69231536299992],
              [-98.04234778599994, -72.66228606599992],
              [-97.9402563139999, -72.65740325299993],
              [-97.74868730399993, -72.68328215899993],
              [-97.83128821499992, -72.71697356599992],
              [-97.94123287699995, -72.72503020599993],
              [-98.05044511599993, -72.71445077899995],
              [-98.13076738199993, -72.69231536299992],
            ],
          ],
          [
            [
              [-90.90160071499992, -72.81975676899992],
              [-90.91812089799993, -72.83359140399995],
              [-90.93053137899994, -72.8479143209999],
              [-90.90562903599994, -72.83847421699994],
              [-90.86107337099992, -72.83562590899993],
              [-90.78587805899991, -72.84099700299993],
              [-90.75918535099993, -72.85068124799994],
              [-90.73989824099993, -72.86443450299993],
              [-90.72826087099992, -72.88445403399993],
              [-90.72447669199994, -72.91277434699992],
              [-90.73534094999991, -72.94540780999995],
              [-90.7610570949999, -72.98007577899995],
              [-90.81948808499993, -73.03630950299993],
              [-90.91771399599992, -73.10125090899993],
              [-91.02538001199991, -73.14983489399992],
              [-91.20579993399991, -73.19443124799994],
              [-91.39037024599992, -73.21282317499993],
              [-91.50633704299992, -73.19784921699994],
              [-91.52464758999992, -73.19255950299993],
              [-91.48631751199991, -73.12460702899995],
              [-91.47752844999991, -73.0837541649999],
              [-91.47667395699995, -73.07301197699991],
              [-91.47793535099993, -73.06210702899995],
              [-91.46544348899994, -73.03411223799992],
              [-91.45807857999995, -72.97535572699991],
              [-91.44908606699994, -72.95183684699992],
              [-91.41616777299993, -72.94215260199991],
              [-91.38670813699991, -72.92913176899992],
              [-91.33340410099993, -72.89755624799994],
              [-91.52847245999993, -72.78313567499993],
              [-91.5562231109999, -72.75725676899992],
              [-91.62047278599994, -72.66936614399992],
              [-91.66624915299991, -72.63250090899993],
              [-91.68651282499991, -72.60995859199994],
              [-91.39004472599993, -72.55006275799991],
              [-91.04417883999992, -72.54314544099992],
              [-90.91519120999993, -72.56218840899993],
              [-90.86388098899994, -72.57903411299992],
              [-90.81639563699991, -72.60344817499993],
              [-90.77961178299995, -72.63616301899992],
              [-90.75796464799993, -72.69744231599992],
              [-90.78766842399995, -72.74456145599993],
              [-90.90160071499992, -72.81975676899992],
            ],
          ],
          [
            [
              [-93.35936438699991, -72.57976653399993],
              [-93.32681230399993, -72.56023528399993],
              [-93.27651933499993, -72.54558684699992],
              [-93.21910559799994, -72.54176197699991],
              [-93.16148841099994, -72.54729583099993],
              [-93.11058508999992, -72.55982838299991],
              [-93.12987219999991, -72.59270598799992],
              [-93.16079667899993, -72.61419036299992],
              [-93.19798743399991, -72.62753671699994],
              [-93.23631751199991, -72.63551197699991],
              [-93.27448482999995, -72.6369768209999],
              [-93.31468665299991, -72.63046640399995],
              [-93.35383053299995, -72.61809661299992],
              [-93.38878333199995, -72.60247161299992],
              [-93.35936438699991, -72.57976653399993],
            ],
          ],
          [
            [
              [-60.77513587099992, -72.56243254999993],
              [-60.7981664699999, -72.57626718499995],
              [-60.827015753999945, -72.58440520599993],
              [-60.94668535099993, -72.59807708099993],
              [-60.968861456999946, -72.59197356599992],
              [-60.95555579299992, -72.57170989399992],
              [-60.917958136999914, -72.54509856599992],
              [-60.90929114499994, -72.54111093499995],
              [-60.840687628999945, -72.54615650799991],
              [-60.77513587099992, -72.56243254999993],
            ],
          ],
          [
            [
              [-94.49144446499992, -72.52239348799992],
              [-94.48900305899991, -72.53378671699994],
              [-94.48668372299994, -72.53964609199994],
              [-94.48326575399994, -72.54558684699992],
              [-94.40953528599994, -72.59726327899995],
              [-94.39981035099993, -72.60735442499993],
              [-94.50475012899994, -72.63274504999993],
              [-94.85299638549992, -72.65504322699994],
              [-95.2012426419999, -72.67734140399995],
              [-95.27428137899994, -72.65178801899992],
              [-95.26927649599992, -72.63600025799991],
              [-95.24413001199991, -72.61565520599993],
              [-95.19782467399995, -72.58863697699991],
              [-95.16616777299993, -72.58098723799992],
              [-94.81045488199993, -72.53460051899992],
              [-94.5808813139999, -72.46892669099992],
              [-94.55016028599994, -72.46591562299994],
              [-94.52208411399994, -72.46941497199992],
              [-94.50206458199995, -72.47926197699991],
              [-94.49380449099993, -72.49146900799991],
              [-94.49144446499992, -72.52239348799992],
            ],
          ],
          [
            [
              [-16.186146613999938, -72.59050872199992],
              [-16.131703253999945, -72.6325822899999],
              [-16.109852667999917, -72.65837981599992],
              [-16.102772589999915, -72.68743254999993],
              [-16.198841925999943, -72.7092424459999],
              [-16.296254035999937, -72.70761484199994],
              [-16.381581183999913, -72.69003671699994],
              [-16.441558397999927, -72.66375090899993],
              [-16.487538214999915, -72.62232838299991],
              [-16.517201300999943, -72.57024504999993],
              [-16.516346808999913, -72.51913827899995],
              [-16.470692511999914, -72.48064544099992],
              [-16.40957597599993, -72.45663827899995],
              [-16.390980597999942, -72.45354583099993],
              [-16.36351477799991, -72.45525481599992],
              [-16.338002081999946, -72.46062590899993],
              [-16.31403561099995, -72.4704729149999],
              [-16.29124915299991, -72.48528411299992],
              [-16.186146613999938, -72.59050872199992],
            ],
          ],
          [
            [
              [-70.55028235599991, -72.22185637799993],
              [-70.44652258999992, -72.22812265399995],
              [-70.41763261599993, -72.23837655999995],
              [-70.53848222599993, -72.27825286299992],
              [-70.60118567599994, -72.28004322699991],
              [-70.65355383999992, -72.25074635199991],
              [-70.60895748599995, -72.23170338299991],
              [-70.58446204299992, -72.22503020599993],
              [-70.55028235599991, -72.22185637799993],
            ],
          ],
          [
            [
              [-60.25845292899993, -72.20403411299992],
              [-60.23843339799993, -72.17742278399993],
              [-60.188059048999946, -72.17595794099992],
              [-60.134877081999946, -72.19353606599992],
              [-60.10655676999994, -72.22405364399992],
              [-60.12677975199995, -72.25253671699994],
              [-60.18138587099992, -72.25579192499993],
              [-60.236439581999946, -72.23837655999995],
              [-60.25845292899993, -72.20403411299992],
            ],
          ],
          [
            [
              [-12.659413214999915, -72.05950286299992],
              [-12.56554114499994, -72.10149504999993],
              [-12.522694464999915, -72.12835051899992],
              [-12.489654100999928, -72.16708749799994],
              [-12.56663977799991, -72.19638437299994],
              [-12.653960740999935, -72.19931405999995],
              [-12.742298956999946, -72.18515390399995],
              [-12.87759355399993, -72.14381275799991],
              [-12.921050584999932, -72.12118905999995],
              [-12.951324022999927, -72.09295012799993],
              [-12.967355923999946, -72.05632903399993],
              [-12.897328253999945, -72.00212981599992],
              [-12.810210740999935, -72.00066497199992],
              [-12.724964972999942, -72.02800872199992],
              [-12.659494594999956, -72.05950286299992],
              [-12.659413214999915, -72.05950286299992],
            ],
          ],
          [
            [
              [-95.49921627499992, -72.31560637799993],
              [-95.42886308499993, -72.3342424459999],
              [-95.43740800699993, -72.3552385399999],
              [-95.48094641799992, -72.37802499799994],
              [-95.51549231699994, -72.40203215899993],
              [-95.75527910099993, -72.4377580709999],
              [-96.02257239499994, -72.43645598799992],
              [-96.09679114499994, -72.46111419099992],
              [-96.05174719999991, -72.45566171699994],
              [-95.99063066299993, -72.47031015399995],
              [-95.94440670499995, -72.50156015399995],
              [-95.94391842399995, -72.54615650799991],
              [-95.98794511599993, -72.57431405999995],
              [-96.0547582669999, -72.58367278399993],
              [-96.3295385404999, -72.57223886499992],
              [-96.6043188139999, -72.5608049459999],
              [-96.65469316299993, -72.54534270599993],
              [-96.68932044199994, -72.5271135399999],
              [-96.71483313699991, -72.51702239399992],
              [-96.73997962099992, -72.5197893209999],
              [-96.77334550699993, -72.54045989399992],
              [-96.78750566299993, -72.56650155999995],
              [-96.85594641799992, -72.57781340899993],
              [-96.93610592399995, -72.58017343499995],
              [-97.12604732999995, -72.56121184699992],
              [-97.16881262899994, -72.5466447899999],
              [-97.19351152299993, -72.53264739399992],
              [-97.21190344999991, -72.51946379999993],
              [-97.2312719389999, -72.50994231599992],
              [-97.25902258999992, -72.50709400799991],
              [-97.59935462099992, -72.55722421699994],
              [-98.08975175649991, -72.56503671699994],
              [-98.5801488919999, -72.57284921699994],
              [-98.67300370999993, -72.54216887799993],
              [-98.62437903599994, -72.52971770599993],
              [-98.59178626199991, -72.51100025799991],
              [-98.53547115799995, -72.46412525799991],
              [-98.96601314999992, -72.48117441199992],
              [-99.3965551419999, -72.49822356599992],
              [-99.4680883449999, -72.46135833099993],
              [-99.40127519399994, -72.42782968499995],
              [-99.25104732999995, -72.40976327899995],
              [-99.18643144399994, -72.37542083099993],
              [-99.47553463449992, -72.37444426849993],
              [-99.76463782499991, -72.37346770599993],
              [-99.89195716099994, -72.33269622199992],
              [-99.98037675699993, -72.32122161299992],
              [-100.14049231699994, -72.27996184699992],
              [-100.20531165299991, -72.2712541649999],
              [-100.32803300699993, -72.28655364399992],
              [-100.37718665299991, -72.28484465899993],
              [-100.41576087099992, -72.2595354149999],
              [-100.8135880196666, -72.23593515433323],
              [-101.21141516833326, -72.21233489366658],
              [-101.60924231699994, -72.18873463299991],
              [-101.68834387899994, -72.16659921699994],
              [-101.72520911399994, -72.16301848799992],
              [-101.89932206899994, -72.19247812299994],
              [-101.96727454299992, -72.19329192499993],
              [-102.18260657499991, -72.16497161299992],
              [-102.29222571499992, -72.1267229149999],
              [-102.32371985599991, -72.06406015399995],
              [-102.3040258449999, -72.03573984199994],
              [-102.27358964799993, -72.0178361959999],
              [-102.08702551999994, -71.97389088299991],
              [-101.67461096924994, -71.95024993249991],
              [-101.26219641849994, -71.92660898199992],
              [-100.84978186774994, -71.90296803149992],
              [-100.43736731699994, -71.87932708099993],
              [-100.23989824099993, -71.82577890399995],
              [-100.13255774599992, -71.82187265399995],
              [-100.02879798099991, -71.84270598799992],
              [-99.94440670499995, -71.89381275799991],
              [-99.99327551999994, -71.93279387799993],
              [-100.05313066299993, -71.94329192499993],
              [-100.32164466099994, -71.95468515399995],
              [-100.39146887899994, -71.96746184699992],
              [-100.4519750639999, -71.9983049459999],
              [-100.02358964799993, -71.97275155999995],
              [-99.9453832669999, -71.97861093499995],
              [-99.86831620999993, -71.99627044099992],
              [-99.90269934799994, -72.03004322699991],
              [-99.89537512899994, -72.04607512799993],
              [-99.86115475199995, -72.04941171699994],
              [-99.74950110599991, -72.04029713299991],
              [-99.7176000639999, -72.03232187299994],
              [-99.69139563699991, -72.01490650799991],
              [-99.63109290299991, -71.95525481599992],
              [-99.59683183499993, -71.93873463299991],
              [-99.54800370999993, -71.93075937299994],
              [-99.49901282499991, -71.93043385199991],
              [-99.40135657499991, -71.94329192499993],
              [-99.20470130099994, -71.99749114399992],
              [-99.04137122299994, -72.07154713299991],
              [-99.00039628799993, -72.08391692499993],
              [-98.82282467399995, -72.09140390399995],
              [-98.73595130099994, -72.10588958099993],
              [-98.68553626199991, -72.10735442499993],
              [-98.63402258999992, -72.09807708099993],
              [-98.74876868399991, -72.0193010399999],
              [-98.78547115799995, -72.00237395599993],
              [-98.95970618399991, -71.96982187299994],
              [-99.10407467399995, -71.9216447899999],
              [-99.15257727799991, -71.91619231599992],
              [-99.12669837099992, -71.88827890399995],
              [-99.08971106699994, -71.87118905999995],
              [-99.01138261599993, -71.85312265399995],
              [-98.9702856109999, -71.83863697699991],
              [-98.88052324099993, -71.77418385199991],
              [-98.8562719389999, -71.76523202899995],
              [-98.82811438699991, -71.76051197699991],
              [-98.53164628799993, -71.75676848799992],
              [-98.25702877499992, -71.80820077949991],
              [-97.98241126199991, -71.8596330709999],
              [-98.04019120999993, -71.91562265399995],
              [-98.11522376199991, -71.94654713299991],
              [-98.29088294199994, -71.97421640399995],
              [-98.26646887899994, -72.0080705709999],
              [-98.25283769399994, -72.01653411299992],
              [-98.24323482999995, -72.02548593499995],
              [-98.22862708199995, -72.04501718499995],
              [-98.24250240799995, -72.05234140399995],
              [-98.26585852799991, -72.07048919099992],
              [-98.28148352799991, -72.07919687299994],
              [-98.30874589799993, -72.1286760399999],
              [-98.3184301419999, -72.13681405999995],
              [-98.35260982999995, -72.15642669099992],
              [-98.29784094999991, -72.15536874799994],
              [-98.27354895699995, -72.14950937299994],
              [-98.16250566299993, -72.09319426899992],
              [-98.1323949859999, -72.08342864399992],
              [-98.06908118399991, -72.07822030999995],
              [-97.99364173099991, -72.08505624799994],
              [-97.85252844999991, -72.1169572899999],
              [-97.86978105399993, -72.12249114399992],
              [-97.9519750639999, -72.16399504999993],
              [-97.82559160099993, -72.16179778399993],
              [-97.76431230399993, -72.14251067499993],
              [-97.75373287699995, -72.0940080709999],
              [-97.77306067599994, -72.07138437299994],
              [-97.79987545499995, -72.06462981599992],
              [-97.82872473899994, -72.06170012799993],
              [-97.85423743399991, -72.05006275799991],
              [-97.86392167899993, -72.02044036299992],
              [-97.85602779899995, -71.9807268209999],
              [-97.84089107999995, -71.94646575299993],
              [-97.82884680899991, -71.9333635399999],
              [-97.89207923099991, -71.91073984199994],
              [-97.84349524599992, -71.89544036299992],
              [-97.73973548099991, -71.88339609199994],
              [-97.60277258999992, -71.88811614399992],
              [-97.49254309799994, -71.90927499799994],
              [-97.47232011599993, -71.9079729149999],
              [-97.62267005099994, -71.95045338299991],
              [-97.40786699099993, -71.9865861959999],
              [-97.36497962099992, -71.97991301899992],
              [-97.38963782499991, -72.01425546699994],
              [-97.41250566299993, -72.03460051899992],
              [-97.44139563699991, -72.0471330709999],
              [-97.59093176999994, -72.08407968499995],
              [-97.61831620999993, -72.09612395599993],
              [-97.58812415299991, -72.10621510199991],
              [-97.56810462099992, -72.1208635399999],
              [-97.5305883449999, -72.15943775799991],
              [-97.51720130099994, -72.16855234199994],
              [-97.47325598899994, -72.1911760399999],
              [-97.3941137359999, -72.20842864399992],
              [-97.30565344999991, -72.17685312299994],
              [-97.22313391799992, -72.12029387799993],
              [-97.16161048099991, -72.06324635199991],
              [-97.13707434799994, -72.03289153399993],
              [-97.11583411399994, -71.99895598799992],
              [-97.08446204299992, -71.92766692499993],
              [-97.04820716099994, -71.87639739399992],
              [-96.99010169199994, -71.84734465899993],
              [-96.92210852799991, -71.83489348799992],
              [-96.85651607999995, -71.83359140399995],
              [-96.82494055899991, -71.83806731599992],
              [-96.73623613199993, -71.86093515399995],
              [-96.36046301999994, -71.83505624799994],
              [-96.28233801999994, -71.84254322699991],
              [-96.20881100199995, -71.86060963299991],
              [-96.06533769399994, -71.9138322899999],
              [-96.09581458199995, -71.96965911299992],
              [-96.11506100199995, -71.99578215899993],
              [-96.1394750639999, -72.01360442499993],
              [-96.16869055899991, -72.02166106599992],
              [-96.20026607999995, -72.0236955709999],
              [-96.42284094999991, -72.00457122199992],
              [-96.50959225199995, -72.01376718499995],
              [-96.40729732999995, -72.05510833099993],
              [-96.3821508449999, -72.0568986959999],
              [-96.44005286399994, -72.0783830709999],
              [-96.49893144399994, -72.09197356599992],
              [-96.62010657499991, -72.10662200299993],
              [-96.99998938699991, -72.21428801899992],
              [-96.91600501199991, -72.24911874799994],
              [-96.82070878799993, -72.2653947899999],
              [-96.72378495999993, -72.26409270599993],
              [-96.44127356699994, -72.19345468499995],
              [-95.95327714799993, -72.14381275799991],
              [-95.73717200399994, -72.05632903399993],
              [-95.65811113199993, -72.04762135199991],
              [-95.59316972599993, -72.07683684699992],
              [-95.68936113199993, -72.09335702899995],
              [-95.71910559799994, -72.1032854149999],
              [-95.71715247299994, -72.10279713299991],
              [-95.71593176999994, -72.10279713299991],
              [-95.71548417899993, -72.10361093499995],
              [-95.71593176999994, -72.10458749799994],
              [-95.50291907499991, -72.15162525799991],
              [-95.54100501199991, -72.17685312299994],
              [-95.58983313699991, -72.19443124799994],
              [-95.64098059799994, -72.20663827899995],
              [-95.93628902899994, -72.22039153449992],
              [-96.23159745999993, -72.2341447899999],
              [-96.33617102799991, -72.25514088299991],
              [-96.37783769399994, -72.26970794099992],
              [-96.41576087099992, -72.28980885199991],
              [-96.41372636599993, -72.2893205709999],
              [-96.41246497299994, -72.2893205709999],
              [-96.41201738199993, -72.28980885199991],
              [-96.41242428299995, -72.29111093499995],
              [-96.3491918609999, -72.29566822699991],
              [-96.03880774599992, -72.25750090899993],
              [-95.97618567599994, -72.25920989399992],
              [-95.92198645699995, -72.27743905999995],
              [-95.86327063699991, -72.31780364399992],
              [-95.83849036399994, -72.32683684699992],
              [-95.81037350199995, -72.33171965899993],
              [-95.75328528599994, -72.33294036299992],
              [-95.55565344999991, -72.31267669099992],
              [-95.49921627499992, -72.31560637799993],
            ],
          ],
          [
            [
              [-60.53066972599993, -71.0510393209999],
              [-60.61742102799991, -71.06308359199994],
              [-60.75658118399991, -71.04998137799993],
              [-60.88947506399995, -71.01881275799991],
              [-60.95734615799995, -70.97730885199991],
              [-60.91429602799991, -70.94158294099992],
              [-60.813343878999945, -70.91708749799994],
              [-60.69176184799994, -70.90943775799991],
              [-60.58702551999994, -70.92506275799991],
              [-60.53888912699995, -70.95427825299993],
              [-60.51659094999991, -70.99163176899992],
              [-60.51545162699995, -71.02743905999995],
              [-60.53066972599993, -71.0510393209999],
            ],
          ],
          [
            [
              [-74.91266842399995, -71.02337004999993],
              [-75.31859290299995, -71.06153736766659],
              [-75.72451738199995, -71.09970468533326],
              [-76.13044186099995, -71.13787200299993],
              [-76.34557044199994, -71.12297942499993],
              [-76.40587317599994, -71.10751718499995],
              [-76.43268795499995, -71.09612395599993],
              [-76.45099850199995, -71.08440520599993],
              [-76.46556555899991, -71.07073333099993],
              [-76.53209387899994, -70.97332122199992],
              [-76.54255123599995, -70.96559010199991],
              [-76.46910559799994, -70.91920338299991],
              [-76.38206946499992, -70.88827890399995],
              [-76.10899817599994, -70.8376604149999],
              [-75.65440833249994, -70.8071428364999],
              [-75.19981848899994, -70.77662525799991],
              [-75.13158118399991, -70.7556291649999],
              [-75.07721920499995, -70.72714609199994],
              [-75.03929602799991, -70.6911760399999],
              [-75.03237870999993, -70.67034270599993],
              [-75.03278561099995, -70.62200286299992],
              [-75.02944902299993, -70.60808684699992],
              [-74.99974524599992, -70.59286874799994],
              [-74.95445716099994, -70.58456796699994],
              [-74.90392005099994, -70.5837541649999],
              [-74.85806230399993, -70.59172942499993],
              [-74.82087154899995, -70.60702890399995],
              [-74.67430579299992, -70.70240650799991],
              [-74.59609941299993, -70.79412200299993],
              [-74.56720943899995, -70.79241301899992],
              [-74.48908443899995, -70.76311614399992],
              [-74.46987870999993, -70.75139739399992],
              [-74.46515865799995, -70.65683359199994],
              [-74.48355058499993, -70.59343840899993],
              [-74.46336829299992, -70.57683684699992],
              [-74.3899633449999, -70.57545338299991],
              [-74.31883704299992, -70.58684661299992],
              [-74.24844316299993, -70.60654062299994],
              [-74.1751195949999, -70.64324309699992],
              [-74.1563207669999, -70.64983489399992],
              [-74.10069739499994, -70.65862395599993],
              [-74.14818274599992, -70.59482187299994],
              [-74.1575414699999, -70.58587004999993],
              [-74.13084876199991, -70.56511809699992],
              [-74.10155188699991, -70.55331796699994],
              [-74.06989498599995, -70.54827239399992],
              [-74.03612219999991, -70.54810963299991],
              [-73.88390051999994, -70.5705705709999],
              [-73.61790930899991, -70.66961028399993],
              [-73.54747473899994, -70.71624114399992],
              [-73.55923417899993, -70.74968840899993],
              [-73.61888587099992, -70.77499765399995],
              [-74.00969397649993, -70.87513600049994],
              [-74.40050208199995, -70.97527434699992],
              [-74.65658525299995, -70.99932219849993],
              [-74.91266842399995, -71.02337004999993],
            ],
          ],
          [
            [
              [-60.43529212099992, -70.59677499799994],
              [-60.44688880099994, -70.62175872199992],
              [-60.46914628799993, -70.63982512799993],
              [-60.543527798999946, -70.67115650799991],
              [-60.71654212099992, -70.71062590899993],
              [-60.81289628799993, -70.7146135399999],
              [-60.857533331999946, -70.70916106599992],
              [-60.88556881399995, -70.70012786299992],
              [-60.906809048999946, -70.68670012799993],
              [-60.98224850199995, -70.6208635399999],
              [-60.98110917899993, -70.61003997199992],
              [-60.97520911399994, -70.59661223799992],
              [-60.96825110599991, -70.58611419099992],
              [-60.96336829299992, -70.5837541649999],
              [-60.97093665299991, -70.57089609199994],
              [-60.97370357999995, -70.55877044099992],
              [-60.96939042899993, -70.54762135199991],
              [-60.95567786399994, -70.53777434699992],
              [-60.900461391999954, -70.52076588299991],
              [-60.834543423999946, -70.51238372199992],
              [-60.569976365999935, -70.50725676899992],
              [-60.50487219999991, -70.51751067499993],
              [-60.45335852799991, -70.5412736959999],
              [-60.44762122299994, -70.55046965899993],
              [-60.436756964999915, -70.58359140399995],
              [-60.43529212099992, -70.59677499799994],
            ],
          ],
          [
            [
              [-3.430409308999913, -70.53850676899992],
              [-3.476185675999943, -70.53045012799993],
              [-3.494536912999934, -70.52385833099993],
              [-3.509917772999927, -70.51441822699991],
              [-3.49250240799995, -70.48105234199994],
              [-3.461822068999936, -70.4587541649999],
              [-3.392486131999931, -70.42376067499993],
              [-3.296498175999943, -70.34970468499995],
              [-3.260487433999913, -70.33123137799993],
              [-3.144154425999943, -70.30071379999993],
              [-2.98859615799995, -70.28053150799991],
              [-2.833811001999948, -70.28142669099992],
              [-2.71939042899993, -70.31389739399992],
              [-2.696034308999913, -70.34319426899992],
              [-2.680572068999936, -70.38836028399993],
              [-2.676136847999942, -70.43596770599993],
              [-2.685047980999911, -70.47234465899993],
              [-2.71125240799995, -70.49724700299993],
              [-2.747059699999909, -70.51181405999995],
              [-2.829823370999918, -70.5236955709999],
              [-3.130116339999915, -70.53110116999991],
              [-3.430409308999913, -70.53850676899992],
            ],
          ],
          [
            [
              [-71.7110082669999, -70.42978280999995],
              [-71.71104895699995, -70.42742278399993],
              [-71.71031653599994, -70.42498137799993],
              [-71.70995032499991, -70.42229583099993],
              [-71.71108964799993, -70.4196916649999],
              [-71.72622636599993, -70.40862395599993],
              [-71.74380449099993, -70.39902109199994],
              [-71.75894120999993, -70.38730234199994],
              [-71.76667232999995, -70.36972421699994],
              [-71.76598059799994, -70.36256275799991],
              [-71.76134192599994, -70.35100676899992],
              [-71.76162675699993, -70.34319426899992],
              [-71.76475989499994, -70.33652109199994],
              [-71.76984615799995, -70.33082447699991],
              [-71.81651770699995, -70.29583098799992],
              [-71.73167883999992, -70.27011484199994],
              [-71.68285071499992, -70.26482512799993],
              [-71.66763261599993, -70.29583098799992],
              [-71.58836829299992, -70.29810963299991],
              [-71.50035559799994, -70.27678801899992],
              [-71.40876217399995, -70.26555754999993],
              [-71.31859290299991, -70.29876067499993],
              [-71.33934485599991, -70.32439544099992],
              [-71.37002519399994, -70.35222747199992],
              [-71.4055883449999, -70.37802499799994],
              [-71.53453528599994, -70.43621184699992],
              [-71.6016332669999, -70.45077890399995],
              [-71.64195716099994, -70.45273202899995],
              [-71.68089758999992, -70.44695403399993],
              [-71.7110082669999, -70.42978280999995],
            ],
          ],
          [
            [
              [-70.76891028599994, -70.30348072699991],
              [-70.7649633449999, -70.28240325299993],
              [-70.75885982999995, -70.2639299459999],
              [-70.7461645169999, -70.2497697899999],
              [-70.72227942599994, -70.24081796699994],
              [-70.69871985599991, -70.2385393209999],
              [-70.67617753799993, -70.24081796699994],
              [-70.65420488199993, -70.24651458099993],
              [-70.63243567599994, -70.25497812299994],
              [-70.64167232999995, -70.26132577899995],
              [-70.64928137899994, -70.26848723799992],
              [-70.65355383999992, -70.27678801899992],
              [-70.65249589799993, -70.2868791649999],
              [-70.64826412699995, -70.29314544099992],
              [-70.63890540299991, -70.30136484199994],
              [-70.63817298099991, -70.30673593499995],
              [-70.64834550699993, -70.3186174459999],
              [-70.66710364499994, -70.32683684699992],
              [-70.70343990799995, -70.3342424459999],
              [-70.74010169199994, -70.33440520599993],
              [-70.77611243399991, -70.32756926899992],
              [-70.76891028599994, -70.30348072699991],
            ],
          ],
          [
            [
              [-61.10537675699993, -69.96379973799992],
              [-61.17617753799993, -69.98113372199992],
              [-61.24669348899994, -69.98707447699991],
              [-61.28848222599993, -69.98430754999993],
              [-61.32966061099995, -69.97649504999993],
              [-61.369252081999946, -69.96282317499993],
              [-61.40599524599992, -69.94280364399992],
              [-61.39976966099994, -69.90593840899993],
              [-61.39435787699995, -69.89470794099992],
              [-61.384836391999954, -69.8830705709999],
              [-61.37340247299994, -69.8733049459999],
              [-61.360585089999915, -69.86532968499995],
              [-61.34683183499993, -69.8591447899999],
              [-61.30919348899994, -69.85125090899993],
              [-61.26821855399993, -69.85198333099993],
              [-61.190012173999946, -69.86785247199992],
              [-61.15501868399991, -69.87997812299994],
              [-61.138335740999935, -69.88860442499993],
              [-61.12417558499993, -69.89983489399992],
              [-61.11587480399993, -69.90984465899993],
              [-61.112945115999935, -69.91545989399992],
              [-61.11115475199995, -69.92180754999993],
              [-61.11164303299995, -69.92636484199994],
              [-61.11583411399994, -69.93401458099993],
              [-61.11656653599994, -69.93816497199992],
              [-61.114898240999935, -69.94475676899992],
              [-61.10537675699993, -69.96379973799992],
            ],
          ],
          [
            [
              [-75.48350989499994, -70.13372161299992],
              [-75.69310462099992, -70.1130510399999],
              [-75.78571529899995, -70.07968515399995],
              [-75.83169511599993, -70.01637135199991],
              [-75.80304928299995, -69.99358489399992],
              [-75.79491126199991, -69.95989348799992],
              [-75.77879798099991, -69.92327239399992],
              [-75.72622636599993, -69.8908830709999],
              [-75.60431881399995, -69.86492278399993],
              [-75.23013261599993, -69.84172942499993],
              [-75.23916581899994, -69.83668385199991],
              [-75.26988684799994, -69.80095794099992],
              [-75.28473873599995, -69.79306405999995],
              [-75.29938717399995, -69.7893205709999],
              [-75.38882402299993, -69.79208749799994],
              [-75.41755123599995, -69.78630950299993],
              [-75.43553626199991, -69.76881275799991],
              [-74.96279863199993, -69.71689218499995],
              [-74.78701738199993, -69.73601653399993],
              [-74.71792558499993, -69.76295338299991],
              [-74.71776282499991, -69.80380624799994],
              [-74.54792232999995, -69.85491301899992],
              [-74.53547115799995, -69.86101653399993],
              [-74.52415930899991, -69.86980559699992],
              [-74.50401770699995, -69.8903947899999],
              [-74.49290930899991, -69.89959075299993],
              [-74.47691809799994, -69.90813567499993],
              [-74.42690995999993, -69.92498137799993],
              [-74.41437740799995, -69.93124765399995],
              [-74.40713456899994, -69.93767669099992],
              [-74.40233313699991, -69.9470354149999],
              [-74.39708411399994, -69.96184661299992],
              [-74.40819251199991, -69.96249765399995],
              [-74.44448808499993, -69.97389088299991],
              [-74.57335364499994, -69.98601653399993],
              [-74.6094457669999, -69.98349374799994],
              [-74.62767493399991, -69.98455169099992],
              [-74.64244544199994, -69.99187590899993],
              [-74.64997311099995, -70.00546640399995],
              [-74.64830481699994, -70.01995208099993],
              [-74.64077714799993, -70.03394947699991],
              [-74.6309301419999, -70.04599374799994],
              [-74.61978105399993, -70.05478280999995],
              [-74.57925370999993, -70.07333749799994],
              [-74.58901933499993, -70.09107838299991],
              [-74.60216223899994, -70.10426197699991],
              [-74.61823482999995, -70.11435312299994],
              [-74.63683020699995, -70.12224700299993],
              [-74.71149654899995, -70.14153411299992],
              [-74.75731360599991, -70.16545989399992],
              [-74.77611243399991, -70.17099374799994],
              [-74.87315833199995, -70.18352629999993],
              [-75.17827307849993, -70.15862395649992],
              [-75.48338782499991, -70.13372161299992],
              [-75.48350989499994, -70.13372161299992],
            ],
          ],
          [
            [
              [-72.84552975199995, -69.58562590899993],
              [-72.87889563699991, -69.5686174459999],
              [-72.95677649599992, -69.54029713299991],
              [-72.98192298099991, -69.5139299459999],
              [-72.96800696499992, -69.48544687299994],
              [-72.92943274599992, -69.46005624799994],
              [-72.83340410099993, -69.4255510399999],
              [-72.74762936099995, -69.41350676899992],
              [-72.66185462099992, -69.41611093499995],
              [-72.39854895699995, -69.46526458099993],
              [-72.30870520699995, -69.50212981599992],
              [-72.2942602199999, -69.52076588299991],
              [-72.27122962099992, -69.53875090899993],
              [-72.23517818899995, -69.56064218499995],
              [-72.19261633999992, -69.57333749799994],
              [-72.18114173099991, -69.58017343499995],
              [-72.17503821499992, -69.58855559699992],
              [-72.16710364499994, -69.60670338299991],
              [-72.16038977799991, -69.61451588299991],
              [-72.15160071499992, -69.61972421699994],
              [-72.14037024599992, -69.62411874799994],
              [-72.00804602799991, -69.64999765399995],
              [-71.95734615799995, -69.66985442499993],
              [-71.94969641799992, -69.68279387799993],
              [-72.01846269399994, -69.71103280999995],
              [-72.01016191299993, -69.71599700299993],
              [-71.97036699099993, -69.7517229149999],
              [-72.00255286399994, -69.7517229149999],
              [-72.03465735599991, -69.74065520599993],
              [-72.10912024599992, -69.70126718499995],
              [-72.14150956899994, -69.68840911299992],
              [-72.15851803299995, -69.68474700299993],
              [-72.16759192599994, -69.68401458099993],
              [-72.17894446499992, -69.68450286299992],
              [-72.18993079299992, -69.68645598799992],
              [-72.19774329299992, -69.69085051899992],
              [-72.20311438699991, -69.70045338299991],
              [-72.19904537699995, -69.70623137799993],
              [-72.19098873599995, -69.71135833099993],
              [-72.18472245999993, -69.71917083099993],
              [-72.18517005099994, -69.72926197699991],
              [-72.19347083199995, -69.73365650799991],
              [-72.20531165299991, -69.73447030999995],
              [-72.48855546799993, -69.69215260199994],
              [-72.77179928299995, -69.64983489399992],
              [-72.79893958199995, -69.63982512799993],
              [-72.82721920499995, -69.61980559699992],
              [-72.83608964799993, -69.61191171699994],
              [-72.84007727799991, -69.60735442499993],
              [-72.84300696499992, -69.60214609199994],
              [-72.84552975199995, -69.58562590899993],
            ],
          ],
          [
            [
              [-61.75548255099994, -69.45427825299993],
              [-61.74624589799993, -69.46453215899993],
              [-61.73851477799991, -69.47535572699991],
              [-61.73420162699995, -69.48552825299993],
              [-61.73542232999995, -69.49325937299994],
              [-61.748605923999946, -69.50123463299991],
              [-61.76744544199994, -69.50457122199992],
              [-61.80231686099995, -69.50660572699991],
              [-61.7962133449999, -69.52743905999995],
              [-61.825062628999945, -69.53069426899992],
              [-61.88658606699994, -69.52418385199991],
              [-61.88634192599994, -69.52434661299992],
              [-61.91974850199995, -69.53777434699992],
              [-61.901234503999945, -69.57048919099992],
              [-61.88780676999994, -69.5881486959999],
              [-61.876210089999915, -69.59335702899995],
              [-61.885650193999936, -69.59880950299993],
              [-61.90990149599992, -69.61760833099993],
              [-61.93712317599994, -69.63014088299991],
              [-61.94505774599992, -69.63746510199991],
              [-61.92520097599993, -69.65829843499995],
              [-61.91893469999991, -69.66090260199991],
              [-61.94102942599994, -69.6643205709999],
              [-61.95840410099993, -69.67131926899992],
              [-61.96629798099991, -69.68499114399992],
              [-61.95995032499991, -69.70842864399992],
              [-61.97838294199994, -69.71941497199992],
              [-62.013335740999935, -69.7287736959999],
              [-62.05540930899991, -69.73316822699991],
              [-62.09512285099993, -69.72966887799993],
              [-62.12865149599992, -69.71795012799993],
              [-62.132069464999915, -69.70826588299991],
              [-62.12352454299992, -69.69915129999993],
              [-62.12083899599992, -69.68889739399992],
              [-62.137277798999946, -69.66912200299993],
              [-62.183583136999914, -69.6272111959999],
              [-62.199208136999914, -69.60613372199992],
              [-62.20018469999991, -69.59726327899995],
              [-62.19481360599991, -69.59197356599992],
              [-62.18712317599994, -69.58798593499995],
              [-62.18126380099994, -69.58269622199992],
              [-62.17882239499994, -69.57350025799991],
              [-62.18228105399993, -69.56804778399993],
              [-62.18785559799994, -69.56340911299992],
              [-62.191477016999954, -69.5564104149999],
              [-62.19090735599991, -69.54900481599992],
              [-62.185617641999954, -69.53533294099992],
              [-62.18569902299993, -69.5271135399999],
              [-62.19884192599994, -69.5080705709999],
              [-62.26797441299993, -69.45989348799992],
              [-62.31167558499993, -69.41570403399993],
              [-62.46865800699993, -69.3225236959999],
              [-62.51036536399994, -69.27459075299993],
              [-62.53929602799991, -69.22918059699992],
              [-62.57917232999995, -69.18914153399993],
              [-62.53351803299995, -69.15878671699994],
              [-62.46304277299993, -69.14641692499993],
              [-62.37954667899993, -69.14861419099992],
              [-62.19204667899993, -69.18621184699992],
              [-62.09325110599991, -69.22568124799994],
              [-62.049712693999936, -69.2522111959999],
              [-62.01797441299993, -69.28199635199991],
              [-61.85973059799994, -69.35979583099993],
              [-61.81940670499995, -69.37029387799993],
              [-61.830922003999945, -69.38396575299993],
              [-61.83039303299995, -69.39706796699994],
              [-61.82127844999991, -69.40927499799994],
              [-61.80695553299995, -69.42066822699991],
              [-61.77643795499995, -69.43694426899992],
              [-61.76720130099994, -69.44304778399993],
              [-61.75548255099994, -69.45427825299993],
            ],
          ],
          [
            [
              [-71.46007239499994, -72.6291643209999],
              [-71.93417314349992, -72.65182870899991],
              [-72.4082738919999, -72.67449309699992],
              [-72.51475989499994, -72.63933684699992],
              [-72.51089433499993, -72.62517669099992],
              [-72.50495357999995, -72.61239999799994],
              [-72.49689693899995, -72.60076262799993],
              [-72.48680579299992, -72.59026458099993],
              [-72.43211829299992, -72.55348072699991],
              [-72.50792395699995, -72.55510833099993],
              [-72.5462133449999, -72.56178150799991],
              [-72.64712480399993, -72.59929778399993],
              [-72.68126380099994, -72.60613372199992],
              [-72.71776282499991, -72.60751718499995],
              [-72.79971269399994, -72.59417083099993],
              [-73.10924231699994, -72.47340260199991],
              [-73.14671790299991, -72.45273202899995],
              [-73.16417395699995, -72.43124765399995],
              [-73.15428626199991, -72.42278411299992],
              [-73.09162350199995, -72.38339609199994],
              [-72.81956946499992, -72.29216887799993],
              [-72.67674719999991, -72.2712541649999],
              [-72.45392818899995, -72.27695077899995],
              [-72.32062740799995, -72.29599374799994],
              [-72.29259192599994, -72.30331796699994],
              [-72.27208411399994, -72.31560637799993],
              [-72.25816809799994, -72.3322893209999],
              [-72.25072180899991, -72.33945077899995],
              [-72.23985755099994, -72.34563567499993],
              [-72.23045813699991, -72.3493791649999],
              [-72.17967688699991, -72.36248137799993],
              [-72.11872311099995, -72.36003997199992],
              [-72.13512122299994, -72.34693775799991],
              [-72.13833574099993, -72.33953215899993],
              [-72.13337154899995, -72.33025481599992],
              [-72.12389075399994, -72.32431405999995],
              [-72.11204993399991, -72.32089609199994],
              [-72.09972083199995, -72.31910572699991],
              [-72.06493079299992, -72.3181291649999],
              [-71.87108313699991, -72.34880950299993],
              [-71.48395748599991, -72.3646786436666],
              [-71.09683183499992, -72.38054778433326],
              [-70.70970618399991, -72.39641692499993],
              [-70.65074622299994, -72.38884856599992],
              [-70.62804114499994, -72.38323333099993],
              [-70.62462317599994, -72.38103606599992],
              [-70.62189693899995, -72.37566497199992],
              [-70.62246660099993, -72.37078215899993],
              [-70.62376868399991, -72.36598072699991],
              [-70.62319902299993, -72.36142343499995],
              [-70.61473548099991, -72.3532854149999],
              [-70.60265051999994, -72.35027434699992],
              [-70.57453365799995, -72.34880950299993],
              [-70.18333899599992, -72.27385833099993],
              [-70.17398027299993, -72.26832447699991],
              [-70.15062415299991, -72.24822356599992],
              [-70.14248613199993, -72.24472421699994],
              [-70.12486731699994, -72.24130624799994],
              [-70.11632239499994, -72.2385393209999],
              [-70.18297278599994, -72.22226327899995],
              [-70.30223548099991, -72.21021900799991],
              [-70.31920325399994, -72.1989885399999],
              [-70.32795162699995, -72.17506275799991],
              [-70.36351477799991, -72.15642669099992],
              [-70.41161048099991, -72.14421965899993],
              [-70.45767167899993, -72.14023202899995],
              [-70.73619544199994, -72.17848072699991],
              [-71.04377193899995, -72.2575822899999],
              [-71.36717688699991, -72.28785572699991],
              [-71.55264238199993, -72.27841562299994],
              [-71.69522050699993, -72.23447030999995],
              [-71.68993079299992, -72.2326799459999],
              [-71.66397050699993, -72.21868254999993],
              [-72.05524654899995, -72.15813567499993],
              [-72.04295813699991, -72.13445403399993],
              [-72.01158606699994, -72.11972421699994],
              [-71.54928544849994, -72.08464934699992],
              [-71.08698482999995, -72.04957447699991],
              [-70.76976477799991, -71.98967864399992],
              [-70.74185136599993, -71.98105234199994],
              [-70.7344457669999, -71.96795012799993],
              [-70.73949133999992, -71.96249765399995],
              [-70.75377356699994, -71.95419687299994],
              [-70.75894120999993, -71.94939544099992],
              [-70.76268469999991, -71.93230559699992],
              [-70.75291907499991, -71.9201799459999],
              [-70.73631751199991, -71.91171640399995],
              [-70.71971594999991, -71.90569426899992],
              [-70.73525956899994, -71.89568450299993],
              [-70.80508378799993, -71.87216562299994],
              [-70.83714758999992, -71.85084400799991],
              [-70.85651607999995, -71.84563567499993],
              [-70.87975012899994, -71.84636809699992],
              [-71.06578528599994, -71.88201262799993],
              [-71.11636308499993, -71.8845354149999],
              [-71.16657467399995, -71.87981536299992],
              [-71.30540930899991, -71.84091562299994],
              [-71.39419511599993, -71.83342864399992],
              [-71.48428300699993, -71.84059010199991],
              [-71.78844153599994, -71.89861419099992],
              [-71.82974199099993, -71.89861419099992],
              [-71.85594641799992, -71.88713958099993],
              [-71.85350501199991, -71.88144296699994],
              [-71.85806230399993, -71.87232838299991],
              [-71.85704505099994, -71.86736419099992],
              [-71.85094153599994, -71.86321379999993],
              [-71.83458411399994, -71.85955169099992],
              [-71.82787024599992, -71.85515715899993],
              [-71.82363847599993, -71.84498463299991],
              [-71.82404537699995, -71.83294036299992],
              [-71.83055579299992, -71.80282968499995],
              [-71.83218339799993, -71.7990861959999],
              [-71.83674068899995, -71.79794687299994],
              [-71.86949622299994, -71.79957447699991],
              [-71.87755286399994, -71.79794687299994],
              [-71.88560950399994, -71.79355234199994],
              [-71.89956620999993, -71.78142669099992],
              [-71.90713456899994, -71.77613697699991],
              [-71.91690019399994, -71.77223072699991],
              [-72.00133216099994, -71.7541643209999],
              [-72.00499426999994, -71.75164153399993],
              [-72.00670325399994, -71.74684010199991],
              [-72.01252193899995, -71.73845794099992],
              [-72.01622473899994, -71.73479583099993],
              [-72.01862545499995, -71.73349374799994],
              [-72.13719641799992, -71.70175546699994],
              [-72.16612708199995, -71.69988372199992],
              [-72.1887914699999, -71.70777760199991],
              [-72.18374589799993, -71.70110442499993],
              [-72.17528235599991, -71.68238697699991],
              [-72.16958574099993, -71.67498137799993],
              [-72.26305091099994, -71.64202239399992],
              [-72.25926673099991, -71.63795338299991],
              [-72.25206458199995, -71.62810637799993],
              [-72.24771074099993, -71.62411874799994],
              [-72.33893795499995, -71.61345794099992],
              [-72.34447180899991, -71.61492278399993],
              [-72.35016842399995, -71.6208635399999],
              [-72.35594641799992, -71.63355885199991],
              [-72.36363684799994, -71.63933684699992],
              [-72.37482662699995, -71.64324309699992],
              [-72.41026770699995, -71.65097421699994],
              [-72.42723548099991, -71.65764739399992],
              [-72.44107011599993, -71.66643645599993],
              [-72.44725501199991, -71.67888762799993],
              [-72.44098873599995, -71.69654713299991],
              [-72.54063880099994, -71.73154062299994],
              [-72.54930579299992, -71.74822356599992],
              [-72.63817298099991, -71.73259856599992],
              [-72.67129472599993, -71.73333098799992],
              [-72.68309485599991, -71.73984140399995],
              [-72.68887285099993, -71.75351327899995],
              [-72.69029700399994, -71.76921965899993],
              [-72.68907630099994, -71.78248463299991],
              [-72.68700110599991, -71.78394947699991],
              [-72.67503821499992, -71.79062265399995],
              [-72.68268795499995, -71.80429452899995],
              [-72.69933020699995, -71.82683684699992],
              [-72.71149654899995, -71.85898202899995],
              [-72.71153723899994, -71.86093515399995],
              [-72.7415258449999, -71.88543059699992],
              [-72.77989661399994, -71.90243905999995],
              [-72.85936438699991, -71.92099374799994],
              [-72.94701087099992, -71.92896900799991],
              [-73.03506425699993, -71.92644622199992],
              [-73.22370357999995, -71.89763762799993],
              [-73.40843665299991, -71.84929778399993],
              [-73.50462805899991, -71.83554452899995],
              [-73.78905188699991, -71.83855559699992],
              [-73.87889563699991, -71.86419036299992],
              [-73.50133216099994, -72.01246510199991],
              [-73.7852270169999, -72.09490325299993],
              [-73.80626380099994, -72.13144296699994],
              [-73.89256751199991, -72.15683359199994],
              [-74.00475012899994, -72.17351653399993],
              [-74.12132727799991, -72.17245859199994],
              [-74.2207738919999, -72.14446379999993],
              [-74.31212317599994, -72.06568775799991],
              [-74.35781816299993, -72.04436614399992],
              [-74.39679928299995, -72.04029713299991],
              [-74.6582738919999, -72.07496510199991],
              [-74.81598873599995, -72.06487395599993],
              [-75.08600826749995, -71.99423593549992],
              [-75.35602779899995, -71.9235979149999],
              [-75.39976966099994, -71.90252044099992],
              [-75.42870032499991, -71.87493254999993],
              [-75.43834387899994, -71.83684661299992],
              [-75.4024145169999, -71.8010393209999],
              [-75.34707597599993, -71.78948333099993],
              [-75.28709876199991, -71.78704192499993],
              [-75.23717200399994, -71.77874114399992],
              [-75.24998938699991, -71.76051197699991],
              [-75.17715410099993, -71.75261809699992],
              [-75.18846594999991, -71.74212004999993],
              [-75.20759029899995, -71.73430754999993],
              [-75.24469967399995, -71.7243791649999],
              [-75.24071204299992, -71.71965911299992],
              [-75.23591061099995, -71.71559010199991],
              [-75.23033606699994, -71.71249765399995],
              [-75.22423255099994, -71.71054452899995],
              [-75.24351966099994, -71.69833749799994],
              [-75.26891028599994, -71.69304778399993],
              [-75.31891842399995, -71.69133879999993],
              [-75.40371660099993, -71.67083098799992],
              [-75.4141332669999, -71.66090260199991],
              [-75.38198808499993, -71.63600025799991],
              [-75.33202063699991, -71.62249114399992],
              [-75.19945227799991, -71.60491301899992],
              [-75.19123287699995, -71.58896249799994],
              [-75.17015540299991, -71.57105885199991],
              [-75.14500891799992, -71.55527109199994],
              [-75.12466386599993, -71.54534270599993],
              [-75.07876542899993, -71.53394947699991],
              [-75.01642818899995, -71.52654387799993],
              [-74.88585364499994, -71.52841562299994],
              [-74.79344641799992, -71.55364348799992],
              [-74.64403235599991, -71.62656015399995],
              [-74.39024817599994, -71.66814544099992],
              [-74.35440019399994, -71.66725025799991],
              [-74.28954016799992, -71.65789153399993],
              [-74.2786352199999, -71.65081145599993],
              [-74.27879798099991, -71.63600025799991],
              [-74.29588782499991, -71.6252580709999],
              [-74.33592688699991, -71.61272551899992],
              [-74.39704342399995, -71.58367278399993],
              [-74.38463294199994, -71.56113046699994],
              [-74.3887426419999, -71.53826262799993],
              [-74.40656490799995, -71.51580169099992],
              [-74.43545488199993, -71.4939104149999],
              [-74.41152910099993, -71.4748674459999],
              [-74.43663489499994, -71.4509416649999],
              [-74.42275956899994, -71.42831796699994],
              [-74.36815344999991, -71.4084611959999],
              [-74.22248287699995, -71.38193124799994],
              [-74.12218176999994, -71.38298919099992],
              [-73.85220292899993, -71.45566171699994],
              [-73.78848222599993, -71.48674895599993],
              [-73.75690670499995, -71.51034921699994],
              [-73.58067786399994, -71.56804778399993],
              [-73.52521725199995, -71.60621510199991],
              [-73.45881100199995, -71.59531015399995],
              [-73.33641516799992, -71.53679778399993],
              [-73.40444902299993, -71.49846770599993],
              [-73.58307857999995, -71.45631275799991],
              [-73.66006425699993, -71.41057708099993],
              [-73.67251542899993, -71.38884856599992],
              [-73.66930091099994, -71.36793385199991],
              [-73.65396074099993, -71.34954192499993],
              [-73.63048255099994, -71.33521900799991],
              [-73.58531653599994, -71.32293059699992],
              [-73.40794837099992, -71.31536223799992],
              [-73.08267167849993, -71.35995859199991],
              [-72.75739498599995, -71.4045549459999],
              [-72.64590410099993, -71.40341562299994],
              [-72.62718665299991, -71.39967213299991],
              [-72.61001542899993, -71.3747697899999],
              [-72.56745357999995, -71.36419036299992],
              [-72.18895423099991, -71.37314218499995],
              [-72.20807857999995, -71.35995859199994],
              [-72.21690833199995, -71.35149504999993],
              [-72.21873938699991, -71.3420549459999],
              [-72.21133378799993, -71.3361955709999],
              [-72.19741777299993, -71.3318010399999],
              [-72.18297278599994, -71.32968515399995],
              [-72.17381751199991, -71.33025481599992],
              [-72.31529700399994, -71.2888322899999],
              [-72.60558020749994, -71.25961679499991],
              [-72.89586341099994, -71.23040129999993],
              [-73.05353756399995, -71.18173593499995],
              [-73.12458248599995, -71.14397551899992],
              [-73.10081946499992, -71.11565520599993],
              [-73.06493079299992, -71.10279713299991],
              [-72.91649329299992, -71.10165780999995],
              [-72.85997473899994, -71.09498463299991],
              [-72.85016842399995, -71.09107838299991],
              [-72.82673092399995, -71.07268645599993],
              [-72.81700598899994, -71.06845468499995],
              [-72.78612219999991, -71.0627580709999],
              [-72.53213456899994, -71.07577890399995],
              [-72.39541581899994, -71.06511809699992],
              [-72.04273434149994, -71.11199309699992],
              [-71.69005286399994, -71.15886809699992],
              [-71.54629472599993, -71.13665129999993],
              [-71.35968990799995, -71.06910572699991],
              [-71.34455318899995, -71.05934010199991],
              [-71.33535722599993, -71.05071379999993],
              [-71.31969153599994, -71.03183359199994],
              [-71.30992591099994, -71.0232072899999],
              [-71.32921301999994, -71.01775481599992],
              [-71.35073808499993, -71.00603606599992],
              [-71.36363684799994, -70.9900041649999],
              [-71.35704505099994, -70.97136809699992],
              [-71.34357662699995, -70.96607838299991],
              [-71.32461503799993, -70.96607838299991],
              [-71.18663489499994, -70.99521249799994],
              [-71.15172278599994, -70.99749114399992],
              [-71.11961829299992, -70.99114348799992],
              [-71.05483964799993, -70.96689218499995],
              [-71.02550208199995, -70.96217213299991],
              [-70.80451412699995, -70.9978166649999],
              [-70.71788489499994, -70.99846770599993],
              [-70.41120357999995, -70.94540780999995],
              [-70.29918372299994, -70.95240650799991],
              [-70.20848548099991, -70.98796965899993],
              [-70.13341223899994, -71.04013437299994],
              [-70.01195227799991, -71.1447893209999],
              [-69.99681555899991, -71.15178801899992],
              [-69.93321692599994, -71.16025155999995],
              [-69.88744055899991, -71.15935637799993],
              [-69.8789770169999, -71.15683359199994],
              [-69.87889563699991, -71.14837004999993],
              [-69.86607825399994, -71.14739348799992],
              [-69.83800208199995, -71.15195077899995],
              [-69.83910071499992, -71.14519622199992],
              [-69.83861243399991, -71.12444426899992],
              [-69.83739173099991, -71.12078215899993],
              [-69.83336341099994, -71.11370208099993],
              [-69.83299719999991, -71.10947030999995],
              [-69.83438066299993, -71.10654062299994],
              [-69.8391820949999, -71.10051848799992],
              [-69.84019934799994, -71.09840260199991],
              [-69.83633378799993, -71.0822893209999],
              [-69.82628333199995, -71.06462981599992],
              [-69.81224524599992, -71.05006275799991],
              [-69.79674231699994, -71.04363372199992],
              [-69.82388261599993, -71.00579192499993],
              [-69.83336341099994, -70.9841447899999],
              [-69.83653723899994, -70.96184661299992],
              [-69.83161373599995, -70.94247812299994],
              [-69.82013912699995, -70.92571379999993],
              [-69.78917395699995, -70.89934661299992],
              [-69.80504309799994, -70.88884856599992],
              [-69.80968176999994, -70.88437265399995],
              [-69.7891332669999, -70.87493254999993],
              [-69.78014075399994, -70.86760833099993],
              [-69.77627519399994, -70.85808684699992],
              [-69.78669186099995, -70.85344817499993],
              [-69.83657792899993, -70.83798593499995],
              [-69.85366777299993, -70.83554452899995],
              [-69.86485755099994, -70.83863697699991],
              [-69.87450110599991, -70.84384530999995],
              [-69.90953528599994, -70.87265390399995],
              [-69.91930091099994, -70.87835051899992],
              [-69.93032792899993, -70.88152434699992],
              [-69.95254472599993, -70.87883879999993],
              [-69.99673417899993, -70.85686614399992],
              [-70.01992753799993, -70.84978606599992],
              [-70.15392005099994, -70.85800546699994],
              [-70.17027747299994, -70.85605234199994],
              [-70.21263587099992, -70.8401018209999],
              [-70.40269934799994, -70.81910572699991],
              [-70.70128333199995, -70.8318010399999],
              [-70.78693600199995, -70.8200822899999],
              [-71.00218665299991, -70.76555754999993],
              [-71.1660863919999, -70.75595468499995],
              [-71.19920813699991, -70.74480559699992],
              [-71.20982825399994, -70.73845794099992],
              [-71.21646074099993, -70.73121510199991],
              [-71.22105872299994, -70.72275155999995],
              [-71.23037675699993, -70.69850025799991],
              [-71.23395748599995, -70.69345468499995],
              [-71.24022376199991, -70.68824635199991],
              [-71.26650956899994, -70.68010833099993],
              [-71.25234941299993, -70.64885833099993],
              [-71.22134355399993, -70.62607187299994],
              [-71.07632402299993, -70.56064218499995],
              [-71.06590735599991, -70.54762135199991],
              [-71.05772864499994, -70.54013437299994],
              [-71.01598059799994, -70.51767343499995],
              [-71.00308183499993, -70.51376718499995],
              [-71.02212480399993, -70.48447030999995],
              [-70.99860592399995, -70.46575286299992],
              [-70.55805416599995, -70.39775969849993],
              [-70.11750240799995, -70.32976653399993],
              [-70.0781957669999, -70.33245208099993],
              [-69.69456946499992, -70.42058684699992],
              [-69.59605872299994, -70.42343515399995],
              [-69.57648678299995, -70.41708749799994],
              [-69.58849036399994, -70.39348723799992],
              [-69.61400305899991, -70.37558359199994],
              [-69.66950436099995, -70.35393645599993],
              [-70.11119544199994, -70.24277109199994],
              [-70.23180091099994, -70.23512135199991],
              [-70.24205481699994, -70.22975025799991],
              [-70.23741614499994, -70.22405364399992],
              [-70.23648027299993, -70.22332122199992],
              [-70.24400794199994, -70.19207122199992],
              [-70.21776282499991, -70.17913176899992],
              [-70.18399003799993, -70.17473723799992],
              [-70.1692602199999, -70.16863372199992],
              [-70.17308508999992, -70.15886809699992],
              [-70.17833411399994, -70.15056731599992],
              [-70.18565833199995, -70.14413827899995],
              [-70.19566809799994, -70.14006926899992],
              [-70.23070227799991, -70.13632577899995],
              [-70.47362219999991, -70.16790129999993],
              [-70.54088294199994, -70.16619231599992],
              [-70.57140051999994, -70.15862395599993],
              [-70.65217037699995, -70.12029387799993],
              [-70.67422441299993, -70.11581796699994],
              [-70.69806881399995, -70.11484140399995],
              [-70.77977454299992, -70.12566497199992],
              [-70.79653886599993, -70.13437265399995],
              [-70.80101477799991, -70.14910247199992],
              [-70.79930579299992, -70.15146249799994],
              [-70.7930395169999, -70.15748463299991],
              [-70.79173743399991, -70.15927499799994],
              [-70.82111568899995, -70.16480885199991],
              [-70.93927975199995, -70.21640390399995],
              [-70.96369381399995, -70.22031015399995],
              [-70.97956295499995, -70.21249765399995],
              [-70.99986731699994, -70.21184661299992],
              [-71.05919348899994, -70.22405364399992],
              [-71.07673092399995, -70.22226327899995],
              [-71.09040279899995, -70.21575286299992],
              [-71.11823482999995, -70.19850025799991],
              [-71.15184485599991, -70.18816497199992],
              [-71.31688391799992, -70.17734140399995],
              [-71.33486894399994, -70.17083098799992],
              [-71.34732011599993, -70.1623674459999],
              [-71.36949622299994, -70.14169687299994],
              [-71.38194739499994, -70.13347747199992],
              [-71.39964758999992, -70.12786223799992],
              [-71.5481664699999, -70.11060963299991],
              [-71.69749915299991, -70.07545338299991],
              [-71.7844945949999, -70.04225025799991],
              [-71.81110592399995, -70.0276018209999],
              [-71.81932532499991, -70.01970794099992],
              [-71.8333227199999, -70.0017229149999],
              [-71.84178626199991, -69.9943986959999],
              [-71.85033118399991, -69.99041106599992],
              [-71.87970943899995, -69.98064544099992],
              [-71.91222083199995, -69.96591562299994],
              [-71.92764238199993, -69.95419687299994],
              [-71.93211829299992, -69.94052499799994],
              [-71.92593339799993, -69.93271249799994],
              [-71.89232337099992, -69.91025155999995],
              [-71.91071529899995, -69.8943010399999],
              [-71.89395097599993, -69.87997812299994],
              [-71.86489824099993, -69.86532968499995],
              [-71.84642493399991, -69.84840260199991],
              [-71.83897864499994, -69.80380624799994],
              [-71.83462480399993, -69.79957447699991],
              [-71.84300696499992, -69.79265715899993],
              [-71.86359615799995, -69.78476327899995],
              [-71.87242591099994, -69.77825286299992],
              [-71.87938391799992, -69.76775481599992],
              [-71.87954667899993, -69.75986093499995],
              [-71.87352454299992, -69.75448984199994],
              [-71.86143958199995, -69.75164153399993],
              [-71.87535559799994, -69.7380510399999],
              [-71.89769446499992, -69.72283294099992],
              [-71.91161048099991, -69.70826588299991],
              [-71.89989173099991, -69.69695403399993],
              [-71.89053300699993, -69.68287525799991],
              [-71.86148027299993, -69.67156340899993],
              [-71.74205481699994, -69.64690520599993],
              [-71.72313391799992, -69.64072030999995],
              [-71.73302161399994, -69.63665129999993],
              [-71.74303137899994, -69.63095468499995],
              [-71.75104732999995, -69.62322356599992],
              [-71.75475012899994, -69.61321379999993],
              [-71.75279700399994, -69.60759856599992],
              [-71.74339758999992, -69.59295012799993],
              [-71.74103756399995, -69.59042734199994],
              [-71.74128170499995, -69.56658294099992],
              [-71.72288977799991, -69.54615650799991],
              [-71.67560787699995, -69.51083749799994],
              [-71.67931067599994, -69.50693124799994],
              [-71.68358313699991, -69.50359465899993],
              [-71.68822180899991, -69.50107187299994],
              [-71.69318600199995, -69.49911874799994],
              [-71.68122311099995, -69.48154062299994],
              [-71.67418372299994, -69.47372812299994],
              [-71.6653539699999, -69.46770598799992],
              [-71.65343176999994, -69.46306731599992],
              [-71.61587480399993, -69.4548479149999],
              [-71.63646399599992, -69.44597747199992],
              [-71.68980872299994, -69.41130950299993],
              [-71.68224036399994, -69.40471770599993],
              [-71.67251542899993, -69.39950937299994],
              [-71.66201738199993, -69.39576588299991],
              [-71.65192623599995, -69.3943010399999],
              [-71.67735755099994, -69.38632577899995],
              [-71.80329342399995, -69.37493254999993],
              [-71.82494055899991, -69.36907317499993],
              [-71.84178626199991, -69.35751718499995],
              [-71.85260982999995, -69.3518205709999],
              [-71.92658443899995, -69.34050872199992],
              [-71.95295162699995, -69.33074309699992],
              [-71.96198482999995, -69.31894296699994],
              [-71.98265540299991, -69.31536223799992],
              [-72.07998613199993, -69.31780364399992],
              [-72.09797115799995, -69.31267669099992],
              [-72.05378170499995, -69.30462004999993],
              [-72.04185950399994, -69.29599374799994],
              [-72.05744381399995, -69.27922942499993],
              [-72.14207923099991, -69.23235442499993],
              [-72.15876217399995, -69.22665780999995],
              [-72.14329993399991, -69.21021900799991],
              [-72.12246660099993, -69.17449309699992],
              [-72.10435950399994, -69.16171640399995],
              [-72.11587480399993, -69.15715911299992],
              [-72.16307532499991, -69.11988697699991],
              [-72.19033769399994, -69.1071916649999],
              [-72.19888261599993, -69.09775155999995],
              [-72.19701087099992, -69.08245208099993],
              [-72.18545488199993, -69.06796640399995],
              [-72.16812089799993, -69.05575937299994],
              [-72.04613196499992, -68.99187590899993],
              [-72.01353919199994, -68.96103280999995],
              [-72.01268469999991, -68.95549895599993],
              [-71.70824134049991, -68.90776946399993],
              [-71.40379798099991, -68.86003997199992],
              [-71.01085364499994, -68.85906340899993],
              [-70.92178300699993, -68.84246184699992],
              [-70.90367591099994, -68.82333749799994],
              [-70.87246660099993, -68.81406015399995],
              [-70.59679114499994, -68.80396900799991],
              [-70.46955318899995, -68.78118254999993],
              [-70.43496660099993, -68.78004322699991],
              [-70.40208899599992, -68.78679778399993],
              [-70.31314042899993, -68.83757903399993],
              [-70.16038977799991, -68.8635393209999],
              [-70.10558020699995, -68.89072030999995],
              [-70.09666907499991, -68.90252044099992],
              [-70.09357662699995, -68.91326262799993],
              [-70.09422766799992, -68.93792083099993],
              [-70.09166419199994, -68.95232512799993],
              [-70.08507239499994, -68.96477629999993],
              [-70.06615149599992, -68.98642343499995],
              [-70.09996497299994, -68.99968840899993],
              [-70.10651607999995, -69.00090911299992],
              [-70.07754472599993, -69.04924895599993],
              [-70.06924394399994, -69.05559661299992],
              [-70.03189042899993, -69.07122161299992],
              [-69.99429277299993, -69.09368254999993],
              [-70.02696692599994, -69.0974260399999],
              [-70.05939693899995, -69.10588958099993],
              [-70.07119706899994, -69.11174895599993],
              [-70.0794164699999, -69.11842213299991],
              [-70.09434973899994, -69.13616301899992],
              [-70.05284583199995, -69.14617278399993],
              [-70.03490149599992, -69.15683359199994],
              [-70.02334550699993, -69.17457447699991],
              [-70.02183997299994, -69.19158294099992],
              [-70.03099524599992, -69.19426848799992],
              [-70.04466712099992, -69.19264088299991],
              [-70.0567113919999, -69.19695403399993],
              [-70.05797278599994, -69.20183684699992],
              [-70.05451412699995, -69.21363697699991],
              [-70.05459550699993, -69.21933359199994],
              [-70.05821692599994, -69.2248674459999],
              [-70.06383216099994, -69.22975025799991],
              [-70.07591712099992, -69.23699309699992],
              [-70.0918676419999, -69.24293385199991],
              [-70.10899817599994, -69.24529387799993],
              [-70.12612870999993, -69.24334075299993],
              [-70.14195716099994, -69.23699309699992],
              [-70.10448157499991, -69.2693010399999],
              [-70.09170488199993, -69.27743905999995],
              [-70.09479732999995, -69.28069426899992],
              [-70.10826575399994, -69.30095794099992],
              [-70.07721920499995, -69.29111093499995],
              [-70.04409745999993, -69.28915780999995],
              [-69.86969967399995, -69.30413176899992],
              [-69.76716061099995, -69.28728606599992],
              [-69.73900305899991, -69.29371510199991],
              [-69.70278886599993, -69.31609465899993],
              [-69.56338456899994, -69.43670012799993],
              [-69.5462133449999, -69.4455705709999],
              [-69.53799394399994, -69.4514299459999],
              [-69.53490149599992, -69.45891692499993],
              [-69.53734290299991, -69.46306731599992],
              [-69.55215410099993, -69.47478606599992],
              [-69.51329505099994, -69.50693124799994],
              [-69.48200436099995, -69.52271900799991],
              [-69.47520911399994, -69.52898528399993],
              [-69.47370357999995, -69.53866952899995],
              [-69.47671464799993, -69.5471330709999],
              [-69.47838294199994, -69.55575937299994],
              [-69.4727270169999, -69.56519947699991],
              [-69.46003170499995, -69.57293059699992],
              [-69.41380774599992, -69.5857072899999],
              [-69.31712805899991, -69.62590911299992],
              [-69.32823645699995, -69.64690520599993],
              [-69.32974199099993, -69.65471770599993],
              [-69.32848059799994, -69.66179778399993],
              [-69.31476803299995, -69.6950822899999],
              [-69.3137914699999, -69.70175546699994],
              [-69.31476803299995, -69.70826588299991],
              [-69.31786048099991, -69.71298593499995],
              [-69.32388261599993, -69.71941497199992],
              [-69.33023027299993, -69.72470468499995],
              [-69.33438066299993, -69.72519296699994],
              [-69.32266191299993, -69.74504973799992],
              [-69.31818600199995, -69.76287200299993],
              [-69.32127844999991, -69.77809010199991],
              [-69.3321020169999, -69.79045989399992],
              [-69.33120683499993, -69.80559661299992],
              [-69.31387285099993, -69.8283830709999],
              [-69.27961178299995, -69.86288827899995],
              [-69.26545162699995, -69.88054778399993],
              [-69.26329505099994, -69.89381275799991],
              [-69.27057857999995, -69.90683359199994],
              [-69.28477942599994, -69.92310963299991],
              [-69.25645911399994, -69.93482838299991],
              [-69.24315344999991, -69.94231536299992],
              [-69.23277747299994, -69.95354583099993],
              [-69.22850501199991, -69.96453215899993],
              [-69.22581946499992, -69.97665780999995],
              [-69.22154700399994, -69.98796965899993],
              [-69.21251380099994, -69.99700286299992],
              [-69.14118404899995, -70.0485979149999],
              [-69.02745520699995, -70.15976327899995],
              [-68.72036699099993, -70.36907317499993],
              [-68.65982011599993, -70.43035247199992],
              [-68.63585364499994, -70.46453215899993],
              [-68.60472571499992, -70.52874114399992],
              [-68.58478756399995, -70.55282968499995],
              [-68.55955969999991, -70.56780364399992],
              [-68.50397701699995, -70.58945077899995],
              [-68.47858639199995, -70.60418059699992],
              [-68.4700414699999, -70.61052825299993],
              [-68.46629798099991, -70.61451588299991],
              [-68.46450761599993, -70.6193986959999],
              [-68.46629798099991, -70.6252580709999],
              [-68.47545325399994, -70.6350236959999],
              [-68.47663326699995, -70.63941822699991],
              [-68.47061113199993, -70.6447893209999],
              [-68.44001217399995, -70.65178801899992],
              [-68.42650305899991, -70.66863372199992],
              [-68.42739824099993, -70.7072893209999],
              [-68.41006425699993, -70.7229143209999],
              [-68.40269934799994, -70.72454192499993],
              [-68.39533443899995, -70.72527434699992],
              [-68.38902747299994, -70.72730885199991],
              [-68.38467363199993, -70.73316822699991],
              [-68.38560950399994, -70.7385393209999],
              [-68.39273027299993, -70.75351327899995],
              [-68.39391028599994, -70.75709400799991],
              [-68.38589433499993, -70.76287200299993],
              [-68.35708574099993, -70.77499765399995],
              [-68.33507239499994, -70.79631926899992],
              [-68.33018958199995, -70.79973723799992],
              [-68.4700414699999, -70.81096770599993],
              [-68.48119055899991, -70.80950286299992],
              [-68.45409094999991, -70.82317473799992],
              [-68.34569251199991, -70.83554452899995],
              [-68.30866451699995, -70.85418059699992],
              [-68.29918372299994, -70.86907317499993],
              [-68.30801347599993, -70.90300872199992],
              [-68.29385331899994, -70.99032968499995],
              [-68.29649817599994, -70.99667734199994],
              [-68.30996660099993, -71.01653411299992],
              [-68.28075110599991, -71.05673593499995],
              [-68.27257239499994, -71.07439544099992],
              [-68.27379309799994, -71.08025481599992],
              [-68.27916419199994, -71.08709075299993],
              [-68.28697669199994, -71.09343840899993],
              [-68.29572506399995, -71.09783294099992],
              [-68.28355872299994, -71.11565520599993],
              [-68.23810787699995, -71.16887786299992],
              [-68.24327551999994, -71.19670989399992],
              [-68.24339758999992, -71.23560963299991],
              [-68.23639889199995, -71.30022551899992],
              [-68.23737545499995, -71.30917734199994],
              [-68.23729407499991, -71.31755950299993],
              [-68.23444576699995, -71.32773202899995],
              [-68.22679602799991, -71.34124114399992],
              [-68.25812740799995, -71.35084400799991],
              [-68.26732337099992, -71.36785247199992],
              [-68.26341712099992, -71.3884416649999],
              [-68.25560462099992, -71.40886809699992],
              [-68.26500403599994, -71.41529713299991],
              [-68.26878821499992, -71.42205169099992],
              [-68.27049719999991, -71.42913176899992],
              [-68.27391516799992, -71.43661874799994],
              [-68.25352942599994, -71.45826588299991],
              [-68.23696855399993, -71.48105234199994],
              [-68.22378495999993, -71.5056291649999],
              [-68.20665442599994, -71.55193450299993],
              [-68.19737708199995, -71.56959400799991],
              [-68.18932044199994, -71.58001067499993],
              [-68.16124426999994, -71.60637786299992],
              [-68.19220943899995, -71.63339609199994],
              [-68.20734615799995, -71.66366952899995],
              [-68.21174068899995, -71.69931405999995],
              [-68.20864824099993, -71.82105885199991],
              [-68.22052975199995, -71.85833098799992],
              [-68.24974524599992, -71.8830705709999],
              [-68.30736243399991, -71.89527760199991],
              [-68.42552649599992, -71.89080169099992],
              [-68.48314368399991, -71.89690520599993],
              [-68.46471106699994, -71.90976327899995],
              [-68.44513912699995, -71.92782968499995],
              [-68.42882239499994, -71.94841887799993],
              [-68.42052161399994, -71.96892669099992],
              [-68.41869055899991, -71.98202890399995],
              [-68.41612708199995, -71.98894622199992],
              [-68.40982011599993, -71.99358489399992],
              [-68.36717688699991, -72.01425546699994],
              [-68.35863196499992, -72.02117278399993],
              [-68.34943600199995, -72.03199635199991],
              [-68.34382076699995, -72.04404062299994],
              [-68.34186764199995, -72.05706145599993],
              [-68.34365800699993, -72.07105885199991],
              [-68.35098222599993, -72.08342864399992],
              [-68.39028886599993, -72.12029387799993],
              [-68.40884355399993, -72.15398528399993],
              [-68.41413326699995, -72.21965911299992],
              [-68.43610592399995, -72.24081796699994],
              [-68.49669348899994, -72.25164153399993],
              [-68.55540930899991, -72.2439104149999],
              [-68.66869055899991, -72.21672942499993],
              [-68.71642005099994, -72.21396249799994],
              [-68.74107825399994, -72.21640390399995],
              [-68.76276607999995, -72.22340260199991],
              [-68.77407792899993, -72.23455169099992],
              [-68.77269446499992, -72.24675872199992],
              [-68.76325436099995, -72.25750090899993],
              [-68.75059973899994, -72.26482512799993],
              [-68.77017167899993, -72.27434661299992],
              [-68.85423743399991, -72.29363372199992],
              [-68.91283118399991, -72.29306405999995],
              [-68.91075598899994, -72.2985979149999],
              [-68.90461178299995, -72.30982838299991],
              [-68.90294348899994, -72.31536223799992],
              [-68.90387936099995, -72.31959400799991],
              [-68.90868079299992, -72.32708098799992],
              [-68.90953528599994, -72.33212655999995],
              [-68.90762285099993, -72.33587004999993],
              [-68.9004613919999, -72.34579843499995],
              [-68.90005449099993, -72.34889088299991],
              [-68.91539466099994, -72.3610979149999],
              [-68.93187415299991, -72.36809661299992],
              [-68.94969641799992, -72.37053801899992],
              [-69.00609290299991, -72.36614348799992],
              [-69.13878333199995, -72.37542083099993],
              [-69.14647376199991, -72.37810637799993],
              [-69.15294348899994, -72.38323333099993],
              [-69.15737870999993, -72.39137135199991],
              [-69.15746008999992, -72.3986955709999],
              [-69.15636145699995, -72.40618254999993],
              [-69.1575414699999, -72.41448333099993],
              [-69.17027747299994, -72.42180754999993],
              [-69.19408118399991, -72.42571379999993],
              [-69.22744706899994, -72.42669036299992],
              [-69.21336829299992, -72.46949635199991],
              [-69.19180253799993, -72.47527434699992],
              [-69.14028886599993, -72.50212981599992],
              [-69.21816972599993, -72.54290129999993],
              [-69.64399166599992, -72.58879973749993],
              [-70.06981360599991, -72.63469817499993],
              [-70.25649980399993, -72.63054778399993],
              [-70.52383378799993, -72.66757577899995],
              [-70.64614824099993, -72.66708749799994],
              [-70.67088782499991, -72.65976327899995],
              [-70.69005286399994, -72.64275481599992],
              [-70.69554602799991, -72.61980559699992],
              [-70.69823157499991, -72.59490325299993],
              [-70.70929928299995, -72.57219817499993],
              [-70.72484290299991, -72.56178150799991],
              [-70.74331620999993, -72.55877044099992],
              [-70.76256262899994, -72.56072356599992],
              [-70.7805883449999, -72.56552499799994],
              [-70.80528723899994, -72.57626718499995],
              [-70.81354732999995, -72.57870859199994],
              [-70.83934485599991, -72.57903411299992],
              [-70.84788977799991, -72.58098723799992],
              [-70.86168372299994, -72.5915666649999],
              [-70.86510169199994, -72.60515715899993],
              [-70.86636308499993, -72.61980559699992],
              [-70.87385006399995, -72.63372161299992],
              [-70.89468339799993, -72.64609140399995],
              [-70.92308508999992, -72.65097421699994],
              [-71.19155839749993, -72.64006926899992],
              [-71.46007239499994, -72.6291643209999],
            ],
          ],
          [
            [
              [-60.89411373599995, -68.75994231599992],
              [-60.99644934799994, -68.72307708099993],
              [-61.021148240999935, -68.70671965899993],
              [-60.96861731699994, -68.68238697699991],
              [-60.88304602799991, -68.67937590899993],
              [-60.79051673099991, -68.69198984199994],
              [-60.71715247299994, -68.71526458099993],
              [-60.66783606699994, -68.74716562299994],
              [-60.652007615999935, -68.77581145599993],
              [-60.675892706999946, -68.7951799459999],
              [-60.746083136999914, -68.79892343499995],
              [-60.78359941299993, -68.79363372199992],
              [-60.89411373599995, -68.75994231599992],
            ],
          ],
          [
            [
              [-67.13499915299991, -68.13811614399992],
              [-67.16299394399994, -68.1579729149999],
              [-67.20075436099995, -68.17262135199991],
              [-67.23550370999993, -68.1716447899999],
              [-67.25495357999995, -68.1447893209999],
              [-67.24010169199994, -68.1330705709999],
              [-67.20201575399994, -68.13160572699991],
              [-67.13499915299991, -68.13811614399992],
            ],
          ],
          [
            [
              [-67.04002844999991, -67.86142343499995],
              [-66.94554602799991, -67.84889088299991],
              [-66.89834550699993, -67.8532854149999],
              [-66.85537675699993, -67.87224700299993],
              [-66.87547766799992, -67.88396575299993],
              [-66.90111243399991, -67.88836028399993],
              [-66.99864661399994, -67.88209400799991],
              [-67.02098548099991, -67.87444426899992],
              [-67.04002844999991, -67.86142343499995],
            ],
          ],
          [
            [
              [-67.08307857999995, -67.83269622199992],
              [-67.10460364499994, -67.85068124799994],
              [-67.12734941299993, -67.86484140399995],
              [-67.17747962099992, -67.88494231599992],
              [-67.21153723899994, -67.8923479149999],
              [-67.24640865799995, -67.89397551899992],
              [-67.27501380099994, -67.88445403399993],
              [-67.29063880099994, -67.87623463299991],
              [-67.29255123599995, -67.86882903399993],
              [-67.25377356699994, -67.84954192499993],
              [-67.23509680899991, -67.83391692499993],
              [-67.23379472599993, -67.83082447699991],
              [-67.33678137899994, -67.81829192499993],
              [-67.23729407499991, -67.79827239399992],
              [-67.18594316299993, -67.79412200299993],
              [-67.15103105399993, -67.79843515399995],
              [-67.1341039699999, -67.80339934699992],
              [-67.08307857999995, -67.83269622199992],
            ],
          ],
          [
            [
              [-64.95433508999992, -67.66139088299991],
              [-64.94737708199995, -67.65886809699992],
              [-64.93858801999994, -67.64902109199994],
              [-64.93101966099994, -67.63730234199994],
              [-64.92756100199995, -67.6291643209999],
              [-64.92853756399995, -67.62029387799993],
              [-64.93224036399994, -67.61248137799993],
              [-64.94050045499995, -67.59880950299993],
              [-64.89565995999993, -67.59921640399995],
              [-64.75609290299991, -67.61541106599992],
              [-64.76138261599993, -67.61060963299991],
              [-64.77660071499992, -67.5920549459999],
              [-64.74974524599992, -67.59221770599993],
              [-64.58731035099993, -67.61077239399992],
              [-64.56371008999992, -67.62037525799991],
              [-64.65094967399995, -67.66106536299992],
              [-64.67788652299993, -67.66920338299991],
              [-64.70714270699995, -67.67424895599993],
              [-64.73615475199995, -67.67343515399995],
              [-64.76252193899995, -67.66448333099993],
              [-64.74583899599992, -67.65178801899992],
              [-64.77403723899994, -67.64153411299992],
              [-64.79987545499995, -67.63779062299994],
              [-64.82607988199993, -67.64023202899995],
              [-64.90461178299995, -67.66562265399995],
              [-64.93000240799995, -67.6682268209999],
              [-64.95433508999992, -67.66139088299991],
            ],
          ],
          [
            [
              [-67.28819739499994, -67.73007577899995],
              [-67.33458411399994, -67.76287200299993],
              [-67.39244544199994, -67.78053150799991],
              [-67.51048743399991, -67.78948333099993],
              [-67.64708411399994, -67.77695077899995],
              [-67.70885169199994, -67.76034921699994],
              [-67.74205481699994, -67.74651458099993],
              [-67.75104732999995, -67.73235442499993],
              [-67.74225826699995, -67.72747161299992],
              [-67.70392818899995, -67.72454192499993],
              [-67.69371497299994, -67.7204729149999],
              [-67.68932044199994, -67.71559010199991],
              [-67.68614661399994, -67.70940520599993],
              [-67.68004309799994, -67.70134856599992],
              [-67.67198645699995, -67.69622161299992],
              [-67.65233313699991, -67.68954843499995],
              [-67.64362545499995, -67.68368905999995],
              [-67.66014563699991, -67.68206145599993],
              [-67.67747962099992, -67.68515390399995],
              [-67.72667395699995, -67.69939544099992],
              [-67.74669348899994, -67.70191822699991],
              [-67.76463782499991, -67.69890715899993],
              [-67.77476966099994, -67.6858049459999],
              [-67.76626542899993, -67.66765715899993],
              [-67.73997962099992, -67.65488046699994],
              [-67.49571692599994, -67.58904387799993],
              [-67.18370520699995, -67.59978606599992],
              [-67.15111243399991, -67.61077239399992],
              [-67.12218176999994, -67.64251067499993],
              [-67.23127193899995, -67.67734140399995],
              [-67.25316321499992, -67.71005624799994],
              [-67.27013098899994, -67.7087541649999],
              [-67.32054602799991, -67.71103280999995],
              [-67.29133053299995, -67.72584400799991],
              [-67.28819739499994, -67.73007577899995],
            ],
          ],
          [
            [
              [-66.81053626199991, -67.52353280999995],
              [-66.83088131399995, -67.53394947699991],
              [-66.85240637899994, -67.54192473799992],
              [-66.87523352799991, -67.54387786299992],
              [-66.92585201699995, -67.56894296699994],
              [-66.99937903599994, -67.59148528399993],
              [-67.08360755099994, -67.60214609199994],
              [-67.16026770699995, -67.58806731599992],
              [-67.08153235599991, -67.55754973799992],
              [-67.02310136599993, -67.5466447899999],
              [-67.00625566299993, -67.53850676899992],
              [-66.99058997299994, -67.52548593499995],
              [-66.98253333199995, -67.52068450299993],
              [-66.97118079299992, -67.51702239399992],
              [-66.93358313699991, -67.5114885399999],
              [-66.89313717399995, -67.51238372199992],
              [-66.81053626199991, -67.52353280999995],
            ],
          ],
          [
            [
              [-67.74445553299995, -67.36077239399992],
              [-67.72801673099991, -67.3396135399999],
              [-67.69054114499994, -67.31878020599993],
              [-67.64492753799993, -67.30738697699991],
              [-67.60415605399993, -67.31462981599992],
              [-67.63117428299995, -67.33489348799992],
              [-67.66869055899991, -67.35711028399993],
              [-67.70909583199995, -67.36972421699994],
              [-67.74445553299995, -67.36077239399992],
            ],
          ],
          [
            [
              [-67.57579505099994, -67.21445077899995],
              [-67.62608801999994, -67.25139739399992],
              [-67.69334876199991, -67.28427499799994],
              [-67.76040605399993, -67.29452890399995],
              [-67.81021074099993, -67.2634416649999],
              [-67.70083574099993, -67.21363697699991],
              [-67.67088782499991, -67.20501067499993],
              [-67.63719641799992, -67.19980234199994],
              [-67.60407467399995, -67.20159270599993],
              [-67.57579505099994, -67.21445077899995],
            ],
          ],
          [
            [
              [-67.65660559799994, -67.08879973799992],
              [-67.65038001199991, -67.08082447699991],
              [-67.64118404899995, -67.07610442499993],
              [-67.63109290299991, -67.07244231599992],
              [-67.62254798099991, -67.06796640399995],
              [-67.60952714799993, -67.05413176899992],
              [-67.60265051999994, -67.0490861959999],
              [-67.5911352199999, -67.04607512799993],
              [-67.57274329299992, -67.04680754999993],
              [-67.55817623599995, -67.05380624799994],
              [-67.54796301999994, -67.06633879999993],
              [-67.54259192599994, -67.0837541649999],
              [-67.5403539699999, -67.09889088299991],
              [-67.54283606699994, -67.10426197699991],
              [-67.55036373599995, -67.11207447699991],
              [-67.55797278599994, -67.11834075299993],
              [-67.56647701699995, -67.12395598799992],
              [-67.58433997299994, -67.13290780999995],
              [-67.60863196499992, -67.14023202899995],
              [-67.63341223899994, -67.14153411299992],
              [-67.65786699099993, -67.13746510199991],
              [-67.68146725199995, -67.12810637799993],
              [-67.67271887899994, -67.12574635199991],
              [-67.66295325399994, -67.12200286299992],
              [-67.65416419199994, -67.11663176899992],
              [-67.64850826699995, -67.10947030999995],
              [-67.6477758449999, -67.10165780999995],
              [-67.65074622299994, -67.09514739399992],
              [-67.65660559799994, -67.08879973799992],
            ],
          ],
          [
            [
              [-67.38121497299994, -66.90243905999995],
              [-67.43517005099994, -66.90813567499993],
              [-67.49339758999992, -66.90447356599992],
              [-67.60313880099994, -66.87997812299994],
              [-67.56383216099994, -66.86646900799991],
              [-67.52757727799991, -66.82105885199991],
              [-67.49022376199991, -66.7990861959999],
              [-67.50210527299993, -66.78875090899993],
              [-67.50837154899995, -66.77947356599992],
              [-67.51284745999993, -66.77076588299991],
              [-67.51988684799994, -66.76213958099993],
              [-67.48395748599995, -66.74260833099993],
              [-67.44595292899993, -66.73495859199994],
              [-67.40664628799993, -66.73650481599992],
              [-67.30679277299993, -66.76067473799992],
              [-67.29002844999991, -66.76897551899992],
              [-67.28522701699995, -66.77353280999995],
              [-67.28258216099994, -66.77825286299992],
              [-67.28042558499993, -66.7829729149999],
              [-67.27700761599993, -66.78801848799992],
              [-67.27196204299992, -66.79290129999993],
              [-67.26158606699994, -66.80087655999995],
              [-67.25690670499995, -66.80575937299994],
              [-67.24571692599994, -66.82496510199991],
              [-67.24071204299992, -66.83082447699991],
              [-67.27110755099994, -66.85491301899992],
              [-67.30614173099991, -66.8752580709999],
              [-67.34361731699994, -66.89128997199992],
              [-67.38121497299994, -66.90243905999995],
            ],
          ],
          [
            [
              [-69.10928300699993, -67.62615325299993],
              [-69.1321508449999, -67.60491301899992],
              [-69.15322831899994, -67.58977629999993],
              [-69.16478430899991, -67.57927825299993],
              [-69.17369544199994, -67.5666643209999],
              [-69.17894446499992, -67.55169036299992],
              [-69.17833411399994, -67.5251604149999],
              [-69.16917883999992, -67.49944426899992],
              [-69.15489661399994, -67.47568124799994],
              [-69.11644446499992, -67.43043385199991],
              [-69.06607011599993, -67.38762786299992],
              [-68.83747311099995, -67.26677825299993],
              [-68.79942786399994, -67.2346330709999],
              [-68.79531816299993, -67.23040129999993],
              [-68.79157467399995, -67.22332122199992],
              [-68.78416907499991, -67.20126718499995],
              [-68.70702063699991, -67.1096330709999],
              [-68.37783769399994, -66.82073333099993],
              [-68.32095292899993, -66.78923919099992],
              [-67.86046301999994, -66.62566497199992],
              [-67.83055579299992, -66.62029387799993],
              [-67.80020097599993, -66.61809661299992],
              [-67.76968339799993, -66.61923593499995],
              [-67.74103756399995, -66.62420012799993],
              [-67.65941321499992, -66.64861419099992],
              [-67.66193600199995, -66.66155364399992],
              [-67.66022701699995, -66.67050546699994],
              [-67.65371660099993, -66.67717864399992],
              [-67.64195716099994, -66.68320077899995],
              [-67.66633053299995, -66.69687265399995],
              [-67.67162024599992, -66.70191822699991],
              [-67.68101966099994, -66.71347421699994],
              [-67.68667558499993, -66.71819426899992],
              [-67.74421139199995, -66.73365650799991],
              [-67.75218665299991, -66.73967864399992],
              [-67.74966386599993, -66.74342213299991],
              [-67.74657141799992, -66.74684010199991],
              [-67.73936926999994, -66.75261809699992],
              [-67.76146399599992, -66.76360442499993],
              [-67.81212317599994, -66.77141692499993],
              [-67.83421790299991, -66.78240325299993],
              [-67.83096269399994, -66.78753020599993],
              [-67.81916256399995, -66.80136484199994],
              [-67.88414466099994, -66.81072356599992],
              [-67.9134008449999, -66.81145598799992],
              [-67.92870032499991, -66.81503671699994],
              [-67.93854732999995, -66.82341887799993],
              [-67.94005286399994, -66.83074309699992],
              [-67.93602454299992, -66.84107838299991],
              [-67.93757076699995, -66.8479143209999],
              [-67.94859778599994, -66.85654062299994],
              [-67.96422278599994, -66.86191171699994],
              [-67.97769120999993, -66.8689104149999],
              [-67.98224850199995, -66.88274504999993],
              [-67.98648027299993, -66.88591887799993],
              [-68.01325436099995, -66.90007903399993],
              [-68.01927649599992, -66.90960051899992],
              [-68.02306067599994, -66.9299455709999],
              [-68.02623450399994, -66.94060637799993],
              [-68.01211503799993, -66.95029062299994],
              [-67.94155839799993, -66.98259856599992],
              [-67.92324785099993, -66.99724700299993],
              [-67.92552649599992, -67.00644296699994],
              [-67.93350175699993, -67.01181405999995],
              [-67.94029700399994, -67.01767343499995],
              [-67.93871008999992, -67.02800872199992],
              [-67.94981848899994, -67.03215911299992],
              [-67.99421139199995, -67.03997161299992],
              [-67.99071204299992, -67.05396900799991],
              [-67.98542232999995, -67.06267669099992],
              [-67.97642981699994, -67.06650155999995],
              [-67.92210852799991, -67.06340911299992],
              [-67.88320878799993, -67.06658294099992],
              [-67.84463456899994, -67.07480234199994],
              [-67.80614173099991, -67.0876604149999],
              [-67.79198157499991, -67.09490325299993],
              [-67.78530839799993, -67.10312265399995],
              [-67.78677324099993, -67.1130510399999],
              [-67.79698645699995, -67.12509530999995],
              [-67.76756751199991, -67.1330705709999],
              [-67.70616614499994, -67.13990650799991],
              [-67.67682857999995, -67.14804452899995],
              [-67.68179277299993, -67.15129973799992],
              [-67.73875891799992, -67.17310963299991],
              [-67.76854407499991, -67.19019947699991],
              [-67.78600012899994, -67.19280364399992],
              [-67.82066809799994, -67.19150155999995],
              [-67.83226477799991, -67.19345468499995],
              [-67.8391820949999, -67.19524504999993],
              [-67.84569251199991, -67.19817473799992],
              [-67.85098222599993, -67.20240650799991],
              [-67.85435950399994, -67.2087541649999],
              [-67.85464433499993, -67.21428801899992],
              [-67.85301673099991, -67.22527434699992],
              [-67.85460364499994, -67.23056405999995],
              [-67.86489824099993, -67.23821379999993],
              [-67.88158118399991, -67.24407317499993],
              [-67.91250566299993, -67.25074635199991],
              [-67.95995032499991, -67.2502580709999],
              [-67.97398841099994, -67.25465260199991],
              [-67.98155676999994, -67.26246510199991],
              [-67.98033606699994, -67.27011484199994],
              [-67.97581946499992, -67.27800872199992],
              [-67.97378495999993, -67.2873674459999],
              [-67.97736568899995, -67.29404062299994],
              [-67.98477128799993, -67.29892343499995],
              [-68.00153561099995, -67.30462004999993],
              [-68.10655676999994, -67.31780364399992],
              [-68.25096594999991, -67.36931731599992],
              [-68.18765214799993, -67.38420989399992],
              [-68.12279212099992, -67.38876718499995],
              [-68.01878821499992, -67.38388437299994],
              [-67.96515865799995, -67.39462655999995],
              [-67.94766191299993, -67.42880624799994],
              [-67.95714270699995, -67.44996510199991],
              [-67.97378495999993, -67.46843840899993],
              [-68.06700598899994, -67.52841562299994],
              [-68.09968014199995, -67.54029713299991],
              [-68.10863196499992, -67.54705169099992],
              [-68.11359615799995, -67.55437590899993],
              [-68.11766516799992, -67.56218840899993],
              [-68.12271074099993, -67.5686174459999],
              [-68.13068600199995, -67.57244231599992],
              [-68.13902747299994, -67.57146575299993],
              [-68.21450761599993, -67.54599374799994],
              [-68.22769120999993, -67.53826262799993],
              [-68.23802649599992, -67.53004322699991],
              [-68.24901282499991, -67.5236955709999],
              [-68.26414954299992, -67.52117278399993],
              [-68.28359941299993, -67.52271900799991],
              [-68.39000403599994, -67.54924895599993],
              [-68.41368567599994, -67.55917734199994],
              [-68.43236243399991, -67.57390715899993],
              [-68.41608639199995, -67.5822893209999],
              [-68.39976966099994, -67.5935197899999],
              [-68.39069576699995, -67.60784270599993],
              [-68.3958227199999, -67.62517669099992],
              [-68.41266842399995, -67.64104583099993],
              [-68.47638912699995, -67.6775041649999],
              [-68.54161536399994, -67.73202890399995],
              [-68.55858313699991, -67.74146900799991],
              [-68.57518469999991, -67.7439104149999],
              [-68.59203040299991, -67.74065520599993],
              [-68.64378821499992, -67.71477629999993],
              [-68.66299394399994, -67.71021900799991],
              [-68.67857825399994, -67.71721770599993],
              [-68.67357337099992, -67.71949635199991],
              [-68.65611731699994, -67.72356536299992],
              [-68.66600501199991, -67.72991301899992],
              [-68.67926998599995, -67.73512135199991],
              [-68.7415258449999, -67.74944426899992],
              [-68.88459225199995, -67.76246510199991],
              [-68.89932206899994, -67.76051197699991],
              [-68.91270911399994, -67.75497812299994],
              [-68.92137610599991, -67.7478166649999],
              [-68.93089758999992, -67.73723723799992],
              [-68.93724524599992, -67.72527434699992],
              [-68.93663489499994, -67.71453215899993],
              [-68.93350175699993, -67.71135833099993],
              [-68.92983964799993, -67.70907968499995],
              [-68.92735755099994, -67.70598723799992],
              [-68.92772376199991, -67.70134856599992],
              [-68.93187415299991, -67.6975236959999],
              [-68.93883216099994, -67.6955705709999],
              [-68.95201575399994, -67.69329192499993],
              [-68.99400794199994, -67.67156340899993],
              [-69.00999915299991, -67.66806405999995],
              [-69.03888912699995, -67.66692473799992],
              [-69.05321204299992, -67.66448333099993],
              [-69.06627356699994, -67.65927499799994],
              [-69.0716039699999, -67.65471770599993],
              [-69.07945716099994, -67.6443010399999],
              [-69.08385169199994, -67.64006926899992],
              [-69.10928300699993, -67.62615325299993],
            ],
          ],
          [
            [
              [-67.16104081899994, -66.38876718499995],
              [-67.13853919199994, -66.37818775799991],
              [-67.12718665299991, -66.37053801899992],
              [-67.12271074099993, -66.36256275799991],
              [-67.12730872299994, -66.35637786299992],
              [-67.14659583199995, -66.34905364399992],
              [-67.15306555899991, -66.34319426899992],
              [-67.15412350199995, -66.33196379999993],
              [-67.14745032499991, -66.32529062299994],
              [-67.13683020699995, -66.3220354149999],
              [-67.12572180899991, -66.32097747199992],
              [-67.09764563699991, -66.3225236959999],
              [-67.05825761599993, -66.32927825299993],
              [-67.02708899599992, -66.34189218499995],
              [-67.02383378799993, -66.36126067499993],
              [-67.03722083199995, -66.37127044099992],
              [-67.05638587099992, -66.37835051899992],
              [-67.09337317599994, -66.3864885399999],
              [-67.12706458199995, -66.38958098799992],
              [-67.16104081899994, -66.38876718499995],
            ],
          ],
          [
            [
              [-67.10175533799992, -66.26173267999991],
              [-67.10187740799995, -66.26165129999993],
              [-67.11969967399995, -66.25139739399992],
              [-67.12157141799992, -66.25090911299992],
              [-67.11021887899994, -66.24098072699991],
              [-67.09162350199995, -66.2360979149999],
              [-67.0716039699999, -66.23495859199994],
              [-67.05638587099992, -66.23626067499993],
              [-67.05125891799992, -66.25408294099992],
              [-67.02708899599992, -66.25986093499995],
              [-66.92373613199993, -66.25286223799992],
              [-66.88463294199994, -66.26287200299993],
              [-66.87682044199994, -66.26376718499995],
              [-66.90892493399991, -66.27776458099993],
              [-66.9426977199999, -66.28573984199994],
              [-66.97736568899995, -66.28801848799992],
              [-67.01231848899994, -66.28590260199991],
              [-67.08177649599992, -66.27361419099992],
              [-67.10175533799992, -66.26173267999991],
            ],
          ],
          [
            [
              [-66.77253170499995, -66.13779062299994],
              [-66.77822831899994, -66.13437265399995],
              [-66.78990637899994, -66.12908294099992],
              [-66.79539954299992, -66.12574635199991],
              [-66.77358964799993, -66.1071916649999],
              [-66.73981686099995, -66.09303150799991],
              [-66.64028886599993, -66.06853606599992],
              [-66.60484778599994, -66.06601327899995],
              [-66.59080969999991, -66.06747812299994],
              [-66.57799231699994, -66.07154713299991],
              [-66.56631425699993, -66.07822030999995],
              [-66.55557206899994, -66.08700937299994],
              [-66.56891842399995, -66.09921640399995],
              [-66.59260006399995, -66.11451588299991],
              [-66.61758378799993, -66.12623463299991],
              [-66.63475501199991, -66.12802499799994],
              [-66.60016842399995, -66.14983489399992],
              [-66.58726966099994, -66.15585702899995],
              [-66.57599850199995, -66.18035247199992],
              [-66.60045325399994, -66.20623137799993],
              [-66.60187740799995, -66.2087541649999],
              [-66.66209876199991, -66.23528411299992],
              [-66.75145423099991, -66.28923919099992],
              [-66.84105383999992, -66.32195403399993],
              [-66.86408443899995, -66.32626718499995],
              [-66.88866126199991, -66.32577890399995],
              [-66.89077714799993, -66.32073333099993],
              [-66.90379798099991, -66.31047942499993],
              [-66.91079667899993, -66.30193450299993],
              [-66.89171301999994, -66.28753020599993],
              [-66.79287675699993, -66.24065520599993],
              [-66.77403723899994, -66.22698333099993],
              [-66.77037512899994, -66.22177499799994],
              [-66.76943925699993, -66.20387135199991],
              [-66.76618404899995, -66.18482838299991],
              [-66.76634680899991, -66.17896900799991],
              [-66.76891028599994, -66.1735979149999],
              [-66.77700761599993, -66.16448333099993],
              [-66.77940833199995, -66.15927499799994],
              [-66.77940833199995, -66.15300872199992],
              [-66.77769934799994, -66.14804452899995],
              [-66.77253170499995, -66.13779062299994],
            ],
          ],
          [
            [
              [-65.74079342399995, -65.96843840899993],
              [-65.72769120999993, -65.98935312299994],
              [-65.73741614499994, -65.99146900799991],
              [-65.80199133999992, -65.99260833099993],
              [-65.78795325399994, -65.97763437299994],
              [-65.78473873599995, -65.97185637799993],
              [-65.78404700399994, -65.96502044099992],
              [-65.78506425699993, -65.95859140399995],
              [-65.78477942599994, -65.9528947899999],
              [-65.77985592399995, -65.94801197699991],
              [-65.76915442599994, -65.94597747199992],
              [-65.75885982999995, -65.94988372199992],
              [-65.74925696499992, -65.95810312299994],
              [-65.74079342399995, -65.96843840899993],
            ],
          ],
          [
            [
              [-65.90009518099993, -65.8767229149999],
              [-65.89476477799991, -65.87859465899993],
              [-65.89102128799993, -65.88144296699994],
              [-65.88902747299994, -65.88551197699991],
              [-65.88882402299993, -65.8908830709999],
              [-65.90074622299994, -65.91106536299992],
              [-65.91437740799995, -65.91692473799992],
              [-65.99840247299994, -65.92929452899995],
              [-66.01650956899994, -65.92831796699994],
              [-66.03384355399993, -65.92457447699991],
              [-66.0051977199999, -65.90545012799993],
              [-65.97069251199991, -65.88811614399992],
              [-65.93439693899995, -65.87704843499995],
              [-65.90009518099993, -65.8767229149999],
            ],
          ],
          [
            [
              [-65.31777910099993, -65.86589934699992],
              [-65.34243730399993, -65.84238046699994],
              [-65.34434973899994, -65.83953215899993],
              [-65.30614173099991, -65.83700937299994],
              [-65.24779212099992, -65.84140390399995],
              [-65.20010331899994, -65.85613372199992],
              [-65.19399980399993, -65.88388437299994],
              [-65.20596269399994, -65.89462655999995],
              [-65.22126217399995, -65.90032317499993],
              [-65.23790442599994, -65.90178801899992],
              [-65.25401770699995, -65.9001604149999],
              [-65.26813717399995, -65.8962541649999],
              [-65.28172766799992, -65.89031340899993],
              [-65.30699622299994, -65.87517669099992],
              [-65.31777910099993, -65.86589934699992],
            ],
          ],
          [
            [
              [-66.19017493399991, -65.8237443989999],
              [-66.19310462099992, -65.82154713299991],
              [-66.19538326699995, -65.81902434699992],
              [-66.19652258999992, -65.81536223799992],
              [-66.19595292899993, -65.81047942499993],
              [-66.19237219999991, -65.80266692499993],
              [-66.17479407499991, -65.78508879999993],
              [-66.16344153599994, -65.76637135199991],
              [-66.15977942599994, -65.76246510199991],
              [-66.14370683499993, -65.76034921699994],
              [-66.10069739499994, -65.76816171699994],
              [-66.08218339799993, -65.76832447699991],
              [-66.07192949099993, -65.76311614399992],
              [-66.03795325399994, -65.73894622199992],
              [-66.05361894399994, -65.73316822699991],
              [-66.07087154899995, -65.72275155999995],
              [-66.08275305899991, -65.70891692499993],
              [-66.08234615799995, -65.69280364399992],
              [-66.07917232999995, -65.68865325299993],
              [-66.07184811099995, -65.68222421699994],
              [-66.06924394399994, -65.6775041649999],
              [-66.06989498599995, -65.67376067499993],
              [-66.07298743399991, -65.67148202899995],
              [-66.07542883999992, -65.66887786299992],
              [-66.07404537699995, -65.66399504999993],
              [-66.06607011599993, -65.65935637799993],
              [-66.02940833199995, -65.65398528399993],
              [-66.01895097599993, -65.64967213299991],
              [-65.99327551999994, -65.62859465899993],
              [-65.97728430899991, -65.62249114399992],
              [-65.96996008999992, -65.61858489399992],
              [-65.96446692599994, -65.61174895599993],
              [-65.96304277299993, -65.59905364399992],
              [-65.96934973899994, -65.59026458099993],
              [-65.97728430899991, -65.58269622199992],
              [-65.98070227799991, -65.57341887799993],
              [-65.97834225199995, -65.57170989399992],
              [-65.96572831899994, -65.55624765399995],
              [-65.96003170499995, -65.55331796699994],
              [-65.79157467399995, -65.51995208099993],
              [-65.76463782499991, -65.52214934699992],
              [-65.71646074099993, -65.53785572699991],
              [-65.69054114499994, -65.54265715899993],
              [-65.63475501199991, -65.53866952899995],
              [-65.62482662699995, -65.5349260399999],
              [-65.63255774599992, -65.54949309699992],
              [-65.65562903599994, -65.5720354149999],
              [-65.66246497299994, -65.58603280999995],
              [-65.66417395699995, -65.61272551899992],
              [-65.66877193899995, -65.62314218499995],
              [-65.68211829299992, -65.63290780999995],
              [-65.68049068899995, -65.63396575299993],
              [-65.67992102799991, -65.63486093499995],
              [-65.68057206899994, -65.63534921699994],
              [-65.68244381399995, -65.63534921699994],
              [-65.66551673099991, -65.66008879999993],
              [-65.85993404899995, -65.69019947699991],
              [-65.91295325399994, -65.70582447699991],
              [-65.83804277299993, -65.7341447899999],
              [-65.82534745999993, -65.7541643209999],
              [-65.82017981699994, -65.76490650799991],
              [-65.81822669199994, -65.77581145599993],
              [-65.82127844999991, -65.78573984199994],
              [-65.83336341099994, -65.80242278399993],
              [-65.83568274599992, -65.81170012799993],
              [-65.83067786399994, -65.82073333099993],
              [-65.81973222599993, -65.82537200299993],
              [-65.79698645699995, -65.83025481599992],
              [-65.81354732999995, -65.83993905999995],
              [-65.83495032499991, -65.84335702899995],
              [-65.87657630099994, -65.84392669099992],
              [-66.05150305899991, -65.88103606599992],
              [-66.10130774599992, -65.8845354149999],
              [-66.17471269399994, -65.87175872199992],
              [-66.18590247299994, -65.86516692499993],
              [-66.17845618399991, -65.84775155999995],
              [-66.17780514199995, -65.84050872199992],
              [-66.18187415299991, -65.83082447699991],
              [-66.18358313699991, -65.82854583099993],
              [-66.18565833199995, -65.82683684699992],
              [-66.19009355399993, -65.82382577899995],
              [-66.19017493399991, -65.8237443989999],
            ],
          ],
          [
            [
              [-65.52700761599993, -65.4729143209999],
              [-65.54857337099992, -65.48707447699991],
              [-65.57738196499992, -65.49716562299994],
              [-65.65998287699995, -65.5114885399999],
              [-65.68614661399994, -65.50945403399993],
              [-65.71068274599992, -65.50123463299991],
              [-65.73224850199995, -65.48528411299992],
              [-65.72223873599995, -65.47087981599992],
              [-65.70539303299995, -65.47323984199994],
              [-65.68553626199991, -65.48162200299993],
              [-65.66657467399995, -65.48560963299991],
              [-65.65355383999992, -65.48308684699992],
              [-65.61644446499992, -65.46835702899995],
              [-65.59601803299995, -65.4670549459999],
              [-65.54234778599994, -65.47519296699994],
              [-65.52700761599993, -65.4729143209999],
            ],
          ],
          [
            [
              [-59.43545488199993, -65.23381926899992],
              [-59.51463782499991, -65.24570077899995],
              [-59.64875240799995, -65.21990325299993],
              [-59.77774003799993, -65.17441171699994],
              [-59.84154212099992, -65.12737395599993],
              [-59.77139238199993, -65.08611419099992],
              [-59.646148240999935, -65.12184010199991],
              [-59.43545488199993, -65.23381926899992],
            ],
          ],
          [
            [
              [-62.92145748599995, -64.87712981599992],
              [-62.925445115999935, -64.88054778399993],
              [-62.959095831999946, -64.89495208099993],
              [-62.987945115999935, -64.8967424459999],
              [-63.07648678299995, -64.88990650799991],
              [-63.10806230399993, -64.88290780999995],
              [-63.12954667899993, -64.8693986959999],
              [-63.123890753999945, -64.8630510399999],
              [-63.12144934799994, -64.85173919099992],
              [-63.11701412699995, -64.84710051899992],
              [-63.097727016999954, -64.84238046699994],
              [-63.06993567599994, -64.84140390399995],
              [-63.042632615999935, -64.84417083099993],
              [-63.02489173099991, -64.85084400799991],
              [-63.02090410099993, -64.85637786299992],
              [-63.01866614499994, -64.86598072699991],
              [-63.01439368399991, -64.86972421699994],
              [-63.00890051999994, -64.87004973799992],
              [-62.989491339999915, -64.86288827899995],
              [-62.97130286399994, -64.85955169099992],
              [-62.95490475199995, -64.86174895599993],
              [-62.938710089999915, -64.86793385199991],
              [-62.92145748599995, -64.87712981599992],
            ],
          ],
          [
            [
              [-62.84675045499995, -64.80901458099993],
              [-62.900461391999954, -64.82390715899993],
              [-63.00523841099994, -64.8166643209999],
              [-63.01927649599992, -64.81308359199994],
              [-63.03099524599992, -64.8064104149999],
              [-62.99461829299992, -64.7971330709999],
              [-62.957102016999954, -64.79485442499993],
              [-62.84675045499995, -64.80901458099993],
            ],
          ],
          [
            [
              [-63.27769934799994, -64.80624765399995],
              [-63.28237870999993, -64.81568775799991],
              [-63.29002844999991, -64.8493791649999],
              [-63.30654863199993, -64.85930754999993],
              [-63.32494055899991, -64.86638762799993],
              [-63.381743943999936, -64.87769947699991],
              [-63.43073482999995, -64.89885833099993],
              [-63.45327714799993, -64.90471770599993],
              [-63.53791256399995, -64.91643645599993],
              [-63.57140051999994, -64.91643645599993],
              [-63.59447180899991, -64.90740325299993],
              [-63.58238684799994, -64.89950937299994],
              [-63.540679490999935, -64.88689544099992],
              [-63.490345831999946, -64.86345794099992],
              [-63.44367428299995, -64.8337541649999],
              [-63.48192298099991, -64.82244231599992],
              [-63.50226803299995, -64.81894296699994],
              [-63.520090298999946, -64.8220354149999],
              [-63.44790605399993, -64.78948333099993],
              [-63.42210852799991, -64.7849260399999],
              [-63.400461391999954, -64.78704192499993],
              [-63.357980923999946, -64.79705169099992],
              [-63.336781378999945, -64.79534270599993],
              [-63.32530676999994, -64.79029713299991],
              [-63.23322506399995, -64.72975025799991],
              [-63.205148891999954, -64.71746184699992],
              [-63.17715410099993, -64.71298593499995],
              [-63.157134568999936, -64.72454192499993],
              [-63.154408331999946, -64.73495859199994],
              [-63.15807044199994, -64.74358489399992],
              [-63.16563880099994, -64.75107187299994],
              [-63.17454993399991, -64.75741952899995],
              [-63.25544186099995, -64.79070403399993],
              [-63.27769934799994, -64.80624765399995],
            ],
          ],
          [
            [
              [-62.63752193899995, -64.72616952899995],
              [-62.65461178299995, -64.73796965899993],
              [-62.67955481699994, -64.7463518209999],
              [-62.70482337099992, -64.74765390399995],
              [-62.72256425699993, -64.73821379999993],
              [-62.723500128999945, -64.73455169099992],
              [-62.720814581999946, -64.72779713299991],
              [-62.72252356699994, -64.72332122199992],
              [-62.731027798999946, -64.71738046699994],
              [-62.76431230399993, -64.70964934699992],
              [-62.73306230399993, -64.70086028399993],
              [-62.72044837099992, -64.69378020599993],
              [-62.70860755099994, -64.68328215899993],
              [-62.69717363199993, -64.67506275799991],
              [-62.682850714999915, -64.67050546699994],
              [-62.66779537699995, -64.66985442499993],
              [-62.65420488199993, -64.67327239399992],
              [-62.64468339799993, -64.67880624799994],
              [-62.641835089999915, -64.68368905999995],
              [-62.641835089999915, -64.70077890399995],
              [-62.64110266799992, -64.70501067499993],
              [-62.63947506399995, -64.70859140399995],
              [-62.63646399599992, -64.71200937299994],
              [-62.63149980399993, -64.71550872199992],
              [-62.63263912699995, -64.71843840899993],
              [-62.634022589999915, -64.72112395599993],
              [-62.63752193899995, -64.72616952899995],
            ],
          ],
          [
            [
              [-62.02281653599994, -64.62493254999993],
              [-62.028960740999935, -64.6330705709999],
              [-62.032093878999945, -64.64104583099993],
              [-62.0305883449999, -64.64804452899995],
              [-62.0227758449999, -64.65300872199992],
              [-62.03669186099995, -64.66122812299994],
              [-62.05874589799993, -64.65960051899992],
              [-62.07697506399995, -64.65105559699992],
              [-62.07909094999991, -64.63876718499995],
              [-62.068918423999946, -64.63250090899993],
              [-62.05150305899991, -64.62664153399993],
              [-62.03380286399994, -64.62346770599993],
              [-62.02281653599994, -64.62493254999993],
            ],
          ],
          [
            [
              [-62.148996548999946, -64.58025481599992],
              [-62.137928839999915, -64.5764299459999],
              [-62.111887173999946, -64.57537200299993],
              [-62.1009008449999, -64.57187265399995],
              [-62.09471594999991, -64.56609465899993],
              [-62.09349524599992, -64.56072356599992],
              [-62.09357662699995, -64.55592213299991],
              [-62.09129798099991, -64.55152760199991],
              [-62.0872289699999, -64.54924895599993],
              [-62.07884680899991, -64.54892343499995],
              [-62.074330206999946, -64.54762135199991],
              [-62.06045488199993, -64.53972747199992],
              [-62.05378170499995, -64.53801848799992],
              [-62.04454505099994, -64.53923919099992],
              [-62.01463782499991, -64.55291106599992],
              [-62.01524817599994, -64.5588518209999],
              [-62.04173743399991, -64.58082447699991],
              [-62.045806443999936, -64.58863697699991],
              [-62.05150305899991, -64.60393645599993],
              [-62.05724036399994, -64.61052825299993],
              [-62.06436113199993, -64.61402760199991],
              [-62.093006964999915, -64.6208635399999],
              [-62.106312628999945, -64.62078215899993],
              [-62.11681067599994, -64.61630624799994],
              [-62.13654537699995, -64.60263437299994],
              [-62.12726803299995, -64.59734465899993],
              [-62.12364661399994, -64.59368254999993],
              [-62.121652798999946, -64.58904387799993],
              [-62.14244544199994, -64.58310312299994],
              [-62.148996548999946, -64.58025481599992],
            ],
          ],
          [
            [
              [-57.652455206999946, -64.45029062299994],
              [-57.58458411399994, -64.41765715899993],
              [-57.56395423099991, -64.44231536299992],
              [-57.58751380099994, -64.4709611959999],
              [-57.652455206999946, -64.45029062299994],
            ],
          ],
          [
            [
              [-61.62653561099995, -64.35955169099992],
              [-61.61314856699994, -64.35507577899995],
              [-61.5676977199999, -64.34929778399993],
              [-61.54625403599994, -64.35027434699992],
              [-61.527414516999954, -64.36052825299993],
              [-61.50914466099994, -64.37379322699991],
              [-61.48924719999991, -64.3845354149999],
              [-61.49583899599992, -64.38551197699991],
              [-61.52562415299991, -64.39592864399992],
              [-61.545765753999945, -64.39706796699994],
              [-61.56582597599993, -64.39560312299994],
              [-61.598866339999915, -64.38827890399995],
              [-61.611439581999946, -64.38079192499993],
              [-61.603627081999946, -64.37175872199992],
              [-61.60850989499994, -64.3674455709999],
              [-61.62653561099995, -64.35955169099992],
            ],
          ],
          [
            [
              [-57.314564581999946, -64.43645598799992],
              [-57.25841223899994, -64.42701588299991],
              [-56.94395911399994, -64.32878997199992],
              [-56.92267818899995, -64.3278947899999],
              [-56.90176347599993, -64.3303361959999],
              [-56.87840735599991, -64.3357072899999],
              [-56.94635982999995, -64.37558359199994],
              [-56.95352128799993, -64.38534921699994],
              [-56.93781490799995, -64.41912200299993],
              [-56.96788489499994, -64.45549895599993],
              [-57.017567511999914, -64.48788827899995],
              [-57.060536261999914, -64.50937265399995],
              [-57.21910559799994, -64.56536223799992],
              [-57.304758266999954, -64.57496510199991],
              [-57.391184048999946, -64.56194426899992],
              [-57.42723548099991, -64.54810963299991],
              [-57.44758053299995, -64.53435637799993],
              [-57.45641028599994, -64.51832447699991],
              [-57.45815995999993, -64.4983049459999],
              [-57.457915818999936, -64.48723723799992],
              [-57.455922003999945, -64.47405364399992],
              [-57.45099850199995, -64.46160247199992],
              [-57.441965298999946, -64.45224374799994],
              [-57.416859503999945, -64.44329192499993],
              [-57.314564581999946, -64.43645598799992],
            ],
          ],
          [
            [
              [-62.90644283799992, -64.52117278399993],
              [-62.90025794199994, -64.52450937299994],
              [-62.84227454299992, -64.56365325299993],
              [-62.82982337099992, -64.56975676899992],
              [-62.85655676999994, -64.58220794099992],
              [-63.02318274599992, -64.61793385199991],
              [-63.045765753999945, -64.61834075299993],
              [-63.05650794199994, -64.62078215899993],
              [-63.064116990999935, -64.62509530999995],
              [-63.077381964999915, -64.63640715899993],
              [-63.08458411399994, -64.64080169099992],
              [-63.091908331999946, -64.6428361959999],
              [-63.09788977799991, -64.64316171699994],
              [-63.11156165299991, -64.64169687299994],
              [-63.153553839999915, -64.64381275799991],
              [-63.17601477799991, -64.64918385199991],
              [-63.19155839799993, -64.65943775799991],
              [-63.19371497299994, -64.66448333099993],
              [-63.19489498599995, -64.67636484199994],
              [-63.19717363199993, -64.68206145599993],
              [-63.20152747299994, -64.68613046699994],
              [-63.250843878999945, -64.71038176899992],
              [-63.28400631399995, -64.72039153399993],
              [-63.288319464999915, -64.72323984199994],
              [-63.30288652299993, -64.73935312299994],
              [-63.31851152299993, -64.75042083099993],
              [-63.33580481699994, -64.75896575299993],
              [-63.35171464799993, -64.76360442499993],
              [-63.374256964999915, -64.76751067499993],
              [-63.396148240999935, -64.76767343499995],
              [-63.410145636999914, -64.76083749799994],
              [-63.41258704299992, -64.74960702899995],
              [-63.40925045499995, -64.74032968499995],
              [-63.41002356699994, -64.73259856599992],
              [-63.424672003999945, -64.72584400799991],
              [-63.44399980399993, -64.72258879999993],
              [-63.46369381399995, -64.72226327899995],
              [-63.558257615999935, -64.7321916649999],
              [-63.57298743399991, -64.74130624799994],
              [-63.55622311099995, -64.74578215899993],
              [-63.523996548999946, -64.75066497199992],
              [-63.50853430899991, -64.75986093499995],
              [-63.53001868399991, -64.76181405999995],
              [-63.55060787699995, -64.76685963299991],
              [-63.57054602799991, -64.77450937299994],
              [-63.65070553299995, -64.81650155999995],
              [-63.660267706999946, -64.82626718499995],
              [-63.66563880099994, -64.84775155999995],
              [-63.68211829299992, -64.85320403399993],
              [-63.70352128799993, -64.8493791649999],
              [-63.74087480399993, -64.83863697699991],
              [-63.748117641999954, -64.83505624799994],
              [-63.754017706999946, -64.8283830709999],
              [-63.75812740799995, -64.81878020599993],
              [-63.75951087099992, -64.81129322699991],
              [-63.76231848899994, -64.80462004999993],
              [-63.77065995999993, -64.79762135199991],
              [-63.778553839999915, -64.79387786299992],
              [-63.804798956999946, -64.7868791649999],
              [-63.98379472599993, -64.77206796699994],
              [-64.01512610599991, -64.77548593499995],
              [-64.02916419199994, -64.77450937299994],
              [-64.04369055899991, -64.76726653399993],
              [-64.08999589799993, -64.73593515399995],
              [-64.12970943899995, -64.71640390399995],
              [-64.28209387899994, -64.70989348799992],
              [-64.29112708199995, -64.70745208099993],
              [-64.29759680899991, -64.70419687299994],
              [-64.30109615799995, -64.69988372199992],
              [-64.30109615799995, -64.69443124799994],
              [-64.29503333199995, -64.68840911299992],
              [-64.28482011599993, -64.68718840899993],
              [-64.26528886599993, -64.68914153399993],
              [-64.25007076699995, -64.6858049459999],
              [-64.24266516799992, -64.6779924459999],
              [-64.23680579299992, -64.66806405999995],
              [-64.22630774599992, -64.65781015399995],
              [-64.2161352199999, -64.65398528399993],
              [-64.20588131399995, -64.65227629999993],
              [-64.19627844999991, -64.64902109199994],
              [-64.18854732999995, -64.63990650799991],
              [-64.18724524599992, -64.62932708099993],
              [-64.18862870999993, -64.61248137799993],
              [-64.1926977199999, -64.5974260399999],
              [-64.19953365799995, -64.5920549459999],
              [-64.15599524599992, -64.57927825299993],
              [-64.1419164699999, -64.57773202899995],
              [-64.08592688699991, -64.55559661299992],
              [-63.90294348899994, -64.53476327899995],
              [-63.85529537699995, -64.50286223799992],
              [-63.86620032499991, -64.49553801899992],
              [-63.93614661399994, -64.46575286299992],
              [-63.93081620999993, -64.45940520599993],
              [-63.922434048999946, -64.45745208099993],
              [-63.91283118399991, -64.4568010399999],
              [-63.90412350199995, -64.4548479149999],
              [-63.87051347599993, -64.43808359199994],
              [-63.85651607999995, -64.43564218499995],
              [-63.72085527299993, -64.43621184699992],
              [-63.68773352799991, -64.42978280999995],
              [-63.657460089999915, -64.41765715899993],
              [-63.67686926999994, -64.40195077899995],
              [-63.681304490999935, -64.39983489399992],
              [-63.668039516999954, -64.38787200299993],
              [-63.66315670499995, -64.38445403399993],
              [-63.656809048999946, -64.3825822899999],
              [-63.64981035099993, -64.38160572699991],
              [-63.64329993399991, -64.37997812299994],
              [-63.63809160099993, -64.37558359199994],
              [-63.63902747299994, -64.36272551899992],
              [-63.65510006399995, -64.35475025799991],
              [-63.69098873599995, -64.34929778399993],
              [-63.68797766799992, -64.3459611959999],
              [-63.65977942599994, -64.32732512799993],
              [-63.576283331999946, -64.31658294099992],
              [-63.563710089999915, -64.31324635199991],
              [-63.55443274599992, -64.30722421699994],
              [-63.54922441299993, -64.29371510199991],
              [-63.55614173099991, -64.28427499799994],
              [-63.567290818999936, -64.27556731599992],
              [-63.57494055899991, -64.26523202899995],
              [-63.36074785099993, -64.2575822899999],
              [-63.36473548099991, -64.24846770599993],
              [-63.36095130099994, -64.24285247199992],
              [-63.35252844999991, -64.24032968499995],
              [-63.34288489499994, -64.2400041649999],
              [-63.33446204299992, -64.24228280999995],
              [-63.31322180899991, -64.25497812299994],
              [-63.28477942599994, -64.26140715899993],
              [-63.27570553299995, -64.26490650799991],
              [-63.27253170499995, -64.2673479149999],
              [-63.267689581999946, -64.27337004999993],
              [-63.26353919199994, -64.27581145599993],
              [-63.23595130099994, -64.27996184699992],
              [-63.20734615799995, -64.2776018209999],
              [-63.17926998599995, -64.27849700299993],
              [-63.15343176999994, -64.29159921699994],
              [-63.15770423099991, -64.29745859199994],
              [-63.15640214799993, -64.30006275799991],
              [-63.15298417899993, -64.30266692499993],
              [-63.15099036399994, -64.30828215899993],
              [-63.192616339999915, -64.31113046699994],
              [-63.16193600199995, -64.32512786299992],
              [-63.15526282499991, -64.32634856599992],
              [-63.173085089999915, -64.33513762799993],
              [-63.2786352199999, -64.35621510199991],
              [-63.30215410099993, -64.36402760199991],
              [-63.319243943999936, -64.37664153399993],
              [-63.307199673999946, -64.37997812299994],
              [-63.266184048999946, -64.38054778399993],
              [-63.27131100199995, -64.3850236959999],
              [-63.28612219999991, -64.38933684699992],
              [-63.29332434799994, -64.39275481599992],
              [-63.298491990999935, -64.3982072899999],
              [-63.3040258449999, -64.41008879999993],
              [-63.30850175699993, -64.41611093499995],
              [-63.319569464999915, -64.42310963299991],
              [-63.359934048999946, -64.43621184699992],
              [-63.331695115999935, -64.4450822899999],
              [-63.30353756399995, -64.44491952899995],
              [-63.27578691299993, -64.43743254999993],
              [-63.219960089999915, -64.40976327899995],
              [-63.18903561099995, -64.39837004999993],
              [-63.169585740999935, -64.39576588299991],
              [-63.11119544199994, -64.39804452899995],
              [-63.14244544199994, -64.4084611959999],
              [-63.223540818999936, -64.45745208099993],
              [-63.242298956999946, -64.47820403399993],
              [-63.21987870999993, -64.4782854149999],
              [-63.19839433499993, -64.47600676899992],
              [-63.12205969999991, -64.45598723799992],
              [-63.103586391999954, -64.45370859199994],
              [-63.08958899599992, -64.45859140399995],
              [-63.105132615999935, -64.4768205709999],
              [-63.12913977799991, -64.49285247199992],
              [-63.23517818899995, -64.54119231599992],
              [-63.28498287699995, -64.55388762799993],
              [-63.29873613199993, -64.56357187299994],
              [-63.28010006399995, -64.57683684699992],
              [-63.270375128999945, -64.58123137799993],
              [-63.25694739499994, -64.58359140399995],
              [-63.13076738199993, -64.57756926899992],
              [-63.11583411399994, -64.58066171699994],
              [-63.12413489499994, -64.57146575299993],
              [-63.12743079299992, -64.56650155999995],
              [-63.12987219999991, -64.56072356599992],
              [-63.07603919199994, -64.54558684699992],
              [-63.02965247299994, -64.52117278399993],
              [-63.01406816299993, -64.51718515399995],
              [-62.99547278599994, -64.5158830709999],
              [-63.01545162699995, -64.53183359199994],
              [-62.975819464999915, -64.53639088299991],
              [-62.96621660099993, -64.53460051899992],
              [-62.929798956999946, -64.52027760199991],
              [-62.92088782499991, -64.51873137799993],
              [-62.913319464999915, -64.51913827899995],
              [-62.90644283799992, -64.52117278399993],
            ],
          ],
          [
            [
              [-56.84947669199994, -64.27996184699992],
              [-56.71434485599991, -64.23512135199991],
              [-56.63524329299992, -64.22161223799992],
              [-56.58250891799992, -64.23512135199991],
              [-56.63320878799993, -64.2751604149999],
              [-56.71446692599994, -64.30657317499993],
              [-56.80882727799991, -64.32268645599993],
              [-56.898548956999946, -64.31731536299992],
              [-56.88023841099994, -64.3103166649999],
              [-56.86392167899993, -64.30201588299991],
              [-56.852772589999915, -64.29192473799992],
              [-56.84947669199994, -64.27996184699992],
            ],
          ],
          [
            [
              [-61.659087693999936, -64.17156340899993],
              [-61.700428839999915, -64.17245859199994],
              [-61.715687628999945, -64.17001718499995],
              [-61.73306230399993, -64.16480885199991],
              [-61.74913489499994, -64.15732187299994],
              [-61.76040605399993, -64.14714934699992],
              [-61.753895636999914, -64.13860442499993],
              [-61.75373287699995, -64.13054778399993],
              [-61.75523841099994, -64.12265390399995],
              [-61.75373287699995, -64.11419036299992],
              [-61.74718176999994, -64.10808684699992],
              [-61.73619544199994, -64.1018205709999],
              [-61.72443600199995, -64.09710051899992],
              [-61.715687628999945, -64.09514739399992],
              [-61.689564581999946, -64.10271575299993],
              [-61.67613684799994, -64.12265390399995],
              [-61.659087693999936, -64.17156340899993],
            ],
          ],
          [
            [
              [-62.65656490799995, -64.50302499799994],
              [-62.68976803299995, -64.49871184699992],
              [-62.72642981699994, -64.50115325299993],
              [-62.76109778599994, -64.4997697899999],
              [-62.78848222599993, -64.48381926899992],
              [-62.76195227799991, -64.46884530999995],
              [-62.73029537699995, -64.46803150799991],
              [-62.69717363199993, -64.47234465899993],
              [-62.66637122299994, -64.47226327899995],
              [-62.60338294199994, -64.45232512799993],
              [-62.585601365999935, -64.45370859199994],
              [-62.636789516999954, -64.44198984199994],
              [-62.66079667899993, -64.43173593499995],
              [-62.67369544199994, -64.41008879999993],
              [-62.67373613199993, -64.40203215899993],
              [-62.67096920499995, -64.39641692499993],
              [-62.66584225199995, -64.39218515399995],
              [-62.65868079299992, -64.38836028399993],
              [-62.65379798099991, -64.38665129999993],
              [-62.642689581999946, -64.38437265399995],
              [-62.637277798999946, -64.38241952899995],
              [-62.63296464799993, -64.37948984199994],
              [-62.625070766999954, -64.37216562299994],
              [-62.62071692599994, -64.36882903399993],
              [-62.589833136999914, -64.3576799459999],
              [-62.58071855399993, -64.35051848799992],
              [-62.575835740999935, -64.34238046699994],
              [-62.57054602799991, -64.32634856599992],
              [-62.56550045499995, -64.3186174459999],
              [-62.55601966099994, -64.31145598799992],
              [-62.52228756399995, -64.29705169099992],
              [-62.50999915299991, -64.28915780999995],
              [-62.48741614499994, -64.2697893209999],
              [-62.469309048999946, -64.24846770599993],
              [-62.463775193999936, -64.23674895599993],
              [-62.46361243399991, -64.22470468499995],
              [-62.47134355399993, -64.21282317499993],
              [-62.48302161399994, -64.2068010399999],
              [-62.51016191299993, -64.2048479149999],
              [-62.52285722599993, -64.20240650799991],
              [-62.52721106699994, -64.1994768209999],
              [-62.54137122299994, -64.18523528399993],
              [-62.546538865999935, -64.18254973799992],
              [-62.557525193999936, -64.17864348799992],
              [-62.562489386999914, -64.17546965899993],
              [-62.56550045499995, -64.17058684699992],
              [-62.573882615999935, -64.15227629999993],
              [-62.609486456999946, -64.14104583099993],
              [-62.62340247299994, -64.13054778399993],
              [-62.61668860599991, -64.1174455709999],
              [-62.609486456999946, -64.11541106599992],
              [-62.58429928299995, -64.11874765399995],
              [-62.564442511999914, -64.11598072699991],
              [-62.515695766999954, -64.10222747199992],
              [-62.48810787699995, -64.08896249799994],
              [-62.49474036399994, -64.0857072899999],
              [-62.52839107999995, -64.06340911299992],
              [-62.562163865999935, -64.05771249799994],
              [-62.57209225199995, -64.05242278399993],
              [-62.56012936099995, -64.04599374799994],
              [-62.49640865799995, -64.03232187299994],
              [-62.48985755099994, -64.02857838299991],
              [-62.478505011999914, -64.01653411299992],
              [-62.478179490999935, -64.01458098799992],
              [-62.37132727799991, -64.00994231599992],
              [-62.31468665299991, -64.01604583099993],
              [-62.26537024599992, -64.03248463299991],
              [-62.27306067599994, -64.03850676899992],
              [-62.279855923999946, -64.05738697699991],
              [-62.28282630099994, -64.07919687299994],
              [-62.27944902299993, -64.09368254999993],
              [-62.2669164699999, -64.09929778399993],
              [-62.00894120999993, -64.14169687299994],
              [-62.02603105399993, -64.15520598799992],
              [-62.05304928299995, -64.16008879999993],
              [-62.131703253999945, -64.16228606599992],
              [-62.18602454299992, -64.16985442499993],
              [-62.211496548999946, -64.17839934699992],
              [-62.19481360599991, -64.18962981599992],
              [-62.171864386999914, -64.19353606599992],
              [-62.10326087099992, -64.19060637799993],
              [-62.09605872299994, -64.19207122199992],
              [-62.09137936099995, -64.1955705709999],
              [-62.08503170499995, -64.20175546699994],
              [-62.080189581999946, -64.20769622199992],
              [-62.08031165299991, -64.21013762799993],
              [-62.056630011999914, -64.21209075299993],
              [-62.04898027299993, -64.21445077899995],
              [-62.06037350199995, -64.22730885199991],
              [-62.16783606699994, -64.28655364399992],
              [-62.18960527299993, -64.2907854149999],
              [-62.20103919199994, -64.29436614399992],
              [-62.20750891799992, -64.3005510399999],
              [-62.20641028599994, -64.30754973799992],
              [-62.19395911399994, -64.3200822899999],
              [-62.19102942599994, -64.32822030999995],
              [-62.19408118399991, -64.3361955709999],
              [-62.20034745999993, -64.34270598799992],
              [-62.20531165299991, -64.34905364399992],
              [-62.204335089999915, -64.35654062299994],
              [-62.197824673999946, -64.36012135199991],
              [-62.18712317599994, -64.36174895599993],
              [-62.16746985599991, -64.36207447699991],
              [-62.24063066299993, -64.39316171699994],
              [-62.24901282499991, -64.3943010399999],
              [-62.25804602799991, -64.39316171699994],
              [-62.275461391999954, -64.38600025799991],
              [-62.28351803299995, -64.38388437299994],
              [-62.29430091099994, -64.38372161299992],
              [-62.33580481699994, -64.39413827899995],
              [-62.330962693999936, -64.3962541649999],
              [-62.32453365799995, -64.40227629999993],
              [-62.31875566299993, -64.40927499799994],
              [-62.31615149599992, -64.41448333099993],
              [-62.31720943899995, -64.4216447899999],
              [-62.32091223899994, -64.42644622199992],
              [-62.32648678299995, -64.4299455709999],
              [-62.35484778599994, -64.44345468499995],
              [-62.37775631399995, -64.46347421699994],
              [-62.38548743399991, -64.46599700299993],
              [-62.42731686099995, -64.4646135399999],
              [-62.44200598899994, -64.46640390399995],
              [-62.45417232999995, -64.47226327899995],
              [-62.45641028599994, -64.47649504999993],
              [-62.45360266799992, -64.48447030999995],
              [-62.45531165299991, -64.48870208099993],
              [-62.476673956999946, -64.49521249799994],
              [-62.494252081999946, -64.48284270599993],
              [-62.49990800699993, -64.46559010199991],
              [-62.48542232999995, -64.45761484199994],
              [-62.515736456999946, -64.45435963299991],
              [-62.53111731699994, -64.4548479149999],
              [-62.54434160099993, -64.46021900799991],
              [-62.55190995999993, -64.46949635199991],
              [-62.55117753799993, -64.47763437299994],
              [-62.548085089999915, -64.48552825299993],
              [-62.54845130099994, -64.49472421699994],
              [-62.55650794199994, -64.50261809699992],
              [-62.58751380099994, -64.51962655999995],
              [-62.598500128999945, -64.52353280999995],
              [-62.61363684799994, -64.52271900799991],
              [-62.62852942599994, -64.51726653399993],
              [-62.65656490799995, -64.50302499799994],
            ],
          ],
          [
            [
              [-61.93626868399991, -63.991306247999944],
              [-61.92491614499994, -63.98650481599992],
              [-61.91368567599994, -63.984633070999905],
              [-61.87954667899993, -63.98455169099992],
              [-61.83348548099991, -63.97820403399993],
              [-61.836008266999954, -63.97503020599993],
              [-61.83971106699994, -63.96795012799993],
              [-61.84227454299992, -63.96453215899993],
              [-61.82921301999994, -63.95973072699991],
              [-61.813343878999945, -63.96038176899992],
              [-61.79735266799992, -63.96428801899992],
              [-61.78429114499994, -63.96949635199991],
              [-61.79824785099993, -63.97625090899993],
              [-61.83429928299995, -64.00204843499995],
              [-61.846587693999936, -64.00676848799992],
              [-61.87865149599992, -64.01360442499993],
              [-61.887603318999936, -64.01775481599992],
              [-61.912953253999945, -64.03866952899995],
              [-61.920033331999946, -64.04998137799993],
              [-61.90672766799992, -64.05486419099992],
              [-61.92454993399991, -64.05779387799993],
              [-61.9368383449999, -64.06519947699991],
              [-61.961822068999936, -64.08513762799993],
              [-61.982533331999946, -64.09091562299994],
              [-62.008656378999945, -64.09059010199991],
              [-62.03490149599992, -64.08603280999995],
              [-62.05573482999995, -64.07830169099992],
              [-62.06403561099995, -64.07097747199992],
              [-62.06541907499991, -64.06243254999993],
              [-62.060658331999946, -64.05388762799993],
              [-62.05064856699994, -64.0466447899999],
              [-62.04466712099992, -64.04501718499995],
              [-62.032866990999935, -64.04485442499993],
              [-62.02708899599992, -64.04306405999995],
              [-62.023548956999946, -64.03964609199994],
              [-62.021555141999954, -64.03557708099993],
              [-62.01911373599995, -64.03167083099993],
              [-62.013661261999914, -64.02890390399995],
              [-62.02061926999994, -64.01946379999993],
              [-62.023548956999946, -64.01669687299994],
              [-62.00914466099994, -64.01181405999995],
              [-61.96519934799994, -64.00448984199994],
              [-61.95734615799995, -64.0022111959999],
              [-61.93626868399991, -63.991306247999944],
            ],
          ],
          [
            [
              [-57.513335740999935, -64.34099700299993],
              [-57.49583899599992, -64.3552385399999],
              [-57.48713131399995, -64.36679452899995],
              [-57.49242102799991, -64.37379322699991],
              [-57.51634680899991, -64.3752580709999],
              [-57.51622473899994, -64.37102629999993],
              [-57.52452551999994, -64.36126067499993],
              [-57.535227016999954, -64.35116952899995],
              [-57.542307094999956, -64.34563567499993],
              [-57.55577551999994, -64.34148528399993],
              [-57.57095292899993, -64.33879973799992],
              [-57.58641516799992, -64.33798593499995],
              [-57.600453253999945, -64.33928801899992],
              [-57.57217363199993, -64.35686614399992],
              [-57.587554490999935, -64.35654062299994],
              [-57.60069739499994, -64.35369231599992],
              [-57.63902747299994, -64.33521900799991],
              [-57.65135657499991, -64.33147551899992],
              [-57.664051886999914, -64.33123137799993],
              [-57.67747962099992, -64.33603280999995],
              [-57.65770423099991, -64.35735442499993],
              [-57.652333136999914, -64.3693986959999],
              [-57.6575414699999, -64.3830705709999],
              [-57.67284094999991, -64.39316171699994],
              [-57.69102942599994, -64.39421965899993],
              [-57.70978756399995, -64.3923479149999],
              [-57.72704016799992, -64.39364999799994],
              [-57.72752844999991, -64.3811174459999],
              [-57.72630774599992, -64.36728280999995],
              [-57.723215298999946, -64.3532854149999],
              [-57.718006964999915, -64.34172942499993],
              [-57.70653235599991, -64.33074309699992],
              [-57.68651282499991, -64.31601327899995],
              [-57.66616777299993, -64.30396900799991],
              [-57.65420488199993, -64.30152760199991],
              [-57.68529212099992, -64.2893205709999],
              [-57.71979732999995, -64.2951799459999],
              [-57.75450598899994, -64.30787525799991],
              [-57.786000128999945, -64.31560637799993],
              [-57.80296790299991, -64.31259530999995],
              [-57.83763587099992, -64.2990861959999],
              [-57.85521399599992, -64.29949309699992],
              [-57.85252844999991, -64.30388762799993],
              [-57.84911048099991, -64.30722421699994],
              [-57.82762610599991, -64.32301197699991],
              [-57.82457434799994, -64.32773202899995],
              [-57.82363847599993, -64.33391692499993],
              [-57.825835740999935, -64.3479143209999],
              [-57.82526607999995, -64.35466887799993],
              [-57.821522589999915, -64.36239999799994],
              [-57.816070115999935, -64.36956145599993],
              [-57.80313066299993, -64.38128020599993],
              [-57.81720943899995, -64.39104583099993],
              [-57.82274329299992, -64.39657968499995],
              [-57.82664954299992, -64.40504322699991],
              [-57.83946692599994, -64.40154387799993],
              [-57.85309811099995, -64.40325286299992],
              [-57.85997473899994, -64.40862395599993],
              [-57.85252844999991, -64.41668059699992],
              [-57.86558997299994, -64.41952890399995],
              [-57.90147864499994, -64.41716887799993],
              [-57.95555579299992, -64.40422942499993],
              [-57.96751868399991, -64.39853280999995],
              [-57.95653235599991, -64.3884416649999],
              [-57.95152747299994, -64.3825822899999],
              [-57.94798743399991, -64.37615325299993],
              [-57.94688880099994, -64.37029387799993],
              [-57.94579016799992, -64.35068124799994],
              [-57.94701087099992, -64.34661223799992],
              [-57.92593339799993, -64.34449635199991],
              [-57.91539466099994, -64.34221770599993],
              [-57.90684973899994, -64.3376604149999],
              [-57.93309485599991, -64.32284921699994],
              [-57.96239173099991, -64.31601327899995],
              [-58.048817511999914, -64.31796640399995],
              [-58.06078040299991, -64.32138437299994],
              [-58.06908118399991, -64.32903411299992],
              [-58.07103430899991, -64.33863697699991],
              [-58.06932532499991, -64.36012135199991],
              [-58.07363847599993, -64.36980559699992],
              [-58.08804277299993, -64.38103606599992],
              [-58.10692298099991, -64.38990650799991],
              [-58.126942511999914, -64.39470794099992],
              [-58.144602016999954, -64.39381275799991],
              [-58.13320878799993, -64.38144296699994],
              [-58.10313880099994, -64.36272551899992],
              [-58.08967037699995, -64.35198333099993],
              [-58.11432857999995, -64.34880950299993],
              [-58.13385982999995, -64.34954192499993],
              [-58.15249589799993, -64.35613372199992],
              [-58.18382727799991, -64.37623463299991],
              [-58.193470831999946, -64.38103606599992],
              [-58.20376542899993, -64.38372161299992],
              [-58.21499589799993, -64.3845354149999],
              [-58.23033606699994, -64.38014088299991],
              [-58.23228919199994, -64.37167734199994],
              [-58.22899329299992, -64.36288827899995],
              [-58.228505011999914, -64.35808684699992],
              [-58.31330318899995, -64.32138437299994],
              [-58.29800370999993, -64.30754973799992],
              [-58.278187628999945, -64.29843515399995],
              [-58.236398891999954, -64.28866952899995],
              [-58.180531378999945, -64.28199635199991],
              [-58.164621548999946, -64.28362395599993],
              [-58.160145636999914, -64.28264739399992],
              [-58.15587317599994, -64.27922942499993],
              [-58.15469316299993, -64.27605559699992],
              [-58.15453040299991, -64.27304452899995],
              [-58.15294348899994, -64.2697893209999],
              [-58.13784745999993, -64.26279062299994],
              [-58.075835740999935, -64.2600236959999],
              [-58.04198157499991, -64.25505950299993],
              [-58.02578691299993, -64.24911874799994],
              [-58.01268469999991, -64.23902760199991],
              [-58.05190995999993, -64.22869231599992],
              [-58.14293372299994, -64.22112395599993],
              [-58.18321692599994, -64.21306731599992],
              [-58.17365475199995, -64.18816497199992],
              [-58.13524329299992, -64.1189104149999],
              [-58.13109290299991, -64.10222747199992],
              [-58.19522050699993, -64.08660247199992],
              [-58.256743943999936, -64.10035572699991],
              [-58.31330318899995, -64.12428150799991],
              [-58.36192786399994, -64.13909270599993],
              [-58.42015540299991, -64.13713958099993],
              [-58.46076412699995, -64.12948984199994],
              [-58.45767167899993, -64.12753671699994],
              [-58.44395911399994, -64.1135393209999],
              [-58.43708248599995, -64.11052825299993],
              [-58.41486568899995, -64.10605234199994],
              [-58.45384680899991, -64.08945077899995],
              [-58.46035722599993, -64.0857072899999],
              [-58.451242641999954, -64.06951262799993],
              [-58.43431555899991, -64.06064218499995],
              [-58.41421464799993, -64.05380624799994],
              [-58.39586341099994, -64.04404062299994],
              [-58.38255774599992, -64.02890390399995],
              [-58.37344316299993, -64.01376718499995],
              [-58.362172003999945, -64.00058359199994],
              [-58.341786261999914, -63.99179452899995],
              [-58.31200110599991, -63.99098072699991],
              [-58.29963131399995, -63.98772551899992],
              [-58.296986456999946, -63.97747161299992],
              [-58.30313066299993, -63.97161223799992],
              [-58.33263098899994, -63.95427825299993],
              [-58.303944464999915, -63.92498137799993],
              [-58.25767981699994, -63.90683359199994],
              [-58.16633053299995, -63.89275481599992],
              [-58.141468878999945, -63.89381275799991],
              [-58.12828528599994, -63.89788176899992],
              [-58.11864173099991, -63.89804452899995],
              [-58.10391191299993, -63.88730234199994],
              [-58.10334225199995, -63.88160572699991],
              [-58.109038865999935, -63.87664153399993],
              [-58.109038865999935, -63.86834075299993],
              [-58.09117591099994, -63.85295989399992],
              [-58.076283331999946, -63.846774997999944],
              [-58.02334550699993, -63.83684661299992],
              [-57.95262610599991, -63.85995859199994],
              [-57.94701087099992, -63.85361093499995],
              [-57.94318600199995, -63.84685637799993],
              [-57.941965298999946, -63.839776299999926],
              [-57.94448808499993, -63.83171965899993],
              [-57.94945227799991, -63.82732512799993],
              [-57.96812903599994, -63.81609465899993],
              [-57.973540818999936, -63.81462981599992],
              [-57.95181230399993, -63.80510833099993],
              [-57.92723548099991, -63.80046965899993],
              [-57.79466712099992, -63.79143645599993],
              [-57.79332434799994, -63.793633721999925],
              [-57.821522589999915, -63.80917734199994],
              [-57.82795162699995, -63.80974700299993],
              [-57.82335364499994, -63.812758070999905],
              [-57.812163865999935, -63.815524997999944],
              [-57.807199673999946, -63.8181291649999],
              [-57.77049719999991, -63.879978122999944],
              [-57.75544186099995, -63.89609140399995],
              [-57.80182857999995, -63.903415622999944],
              [-57.81578528599994, -63.9099260399999],
              [-57.82363847599993, -63.91725025799991],
              [-57.82331295499995, -63.92351653399993],
              [-57.816517706999946, -63.92937590899993],
              [-57.80540930899991, -63.936211846999925],
              [-57.81297766799992, -63.9431291649999],
              [-57.82359778599994, -63.949151299999926],
              [-57.887928839999915, -63.975681247999944],
              [-57.83478756399995, -63.9939104149999],
              [-57.81822669199994, -64.0041643209999],
              [-57.82575436099995, -64.0119768209999],
              [-57.830637173999946, -64.01604583099993],
              [-57.83438066299993, -64.0173479149999],
              [-57.825062628999945, -64.02166106599992],
              [-57.81794186099995, -64.02922942499993],
              [-57.81476803299995, -64.03866952899995],
              [-57.817290818999936, -64.04876067499993],
              [-57.82652747299994, -64.05608489399992],
              [-57.85309811099995, -64.0622697899999],
              [-57.86436926999994, -64.06658294099992],
              [-57.82957923099991, -64.07480234199994],
              [-57.79137122299994, -64.07927825299993],
              [-57.75308183499993, -64.07968515399995],
              [-57.717681443999936, -64.07537200299993],
              [-57.74437415299991, -64.02996184699992],
              [-57.72809811099995, -64.01946379999993],
              [-57.62523352799991, -63.982354424999926],
              [-57.54238847599993, -63.9392229149999],
              [-57.49351966099994, -63.92620208099993],
              [-57.49937903599994, -63.928806247999944],
              [-57.50560462099992, -63.93417734199994],
              [-57.515695766999954, -63.94491952899995],
              [-57.50743567599994, -63.95354583099993],
              [-57.49673417899993, -63.95989348799992],
              [-57.47345943899995, -63.9685197899999],
              [-57.504790818999936, -63.98365650799991],
              [-57.51113847599993, -63.988213799999926],
              [-57.51382402299993, -63.995212497999944],
              [-57.511789516999954, -63.999932549999926],
              [-57.50914466099994, -64.0041643209999],
              [-57.50963294199994, -64.0095354149999],
              [-57.513661261999914, -64.01360442499993],
              [-57.52000891799992, -64.01685963299991],
              [-57.53258216099994, -64.02141692499993],
              [-57.52122962099992, -64.02092864399992],
              [-57.15538489499994, -64.08513762799993],
              [-57.18980872299994, -64.09384530999995],
              [-57.19546464799993, -64.09636809699992],
              [-57.191395636999914, -64.1037736959999],
              [-57.18346106699994, -64.10857512799993],
              [-57.173939581999946, -64.11126067499993],
              [-57.16470292899993, -64.11248137799993],
              [-57.19603430899991, -64.12509530999995],
              [-57.229725714999915, -64.12900155999995],
              [-57.33104407499991, -64.12574635199991],
              [-57.36375891799992, -64.12948984199994],
              [-57.37287350199995, -64.13274504999993],
              [-57.39370683499993, -64.14332447699991],
              [-57.400380011999914, -64.14560312299994],
              [-57.343413865999935, -64.1467424459999],
              [-57.326242641999954, -64.15097421699994],
              [-57.319976365999935, -64.15813567499993],
              [-57.30736243399991, -64.15911223799992],
              [-57.29328365799995, -64.15862395599993],
              [-57.28278561099995, -64.16171640399995],
              [-57.31627356699994, -64.1794572899999],
              [-57.32559160099993, -64.18181731599992],
              [-57.30125891799992, -64.18238697699991],
              [-57.25609290299991, -64.17734140399995],
              [-57.21312415299991, -64.16765715899993],
              [-57.14956620999993, -64.16399504999993],
              [-57.13735917899993, -64.16936614399992],
              [-57.12140865799995, -64.15960051899992],
              [-57.09203040299991, -64.15398528399993],
              [-57.07022050699993, -64.15960051899992],
              [-57.07725989499994, -64.18377044099992],
              [-57.09312903599994, -64.19768645599993],
              [-57.11302649599992, -64.20696379999993],
              [-57.203968878999945, -64.22226327899995],
              [-57.22842363199993, -64.22161223799992],
              [-57.252023891999954, -64.21599700299993],
              [-57.242746548999946, -64.22527434699992],
              [-57.25255286399994, -64.23479583099993],
              [-57.26447506399995, -64.24032968499995],
              [-57.277455206999946, -64.24260833099993],
              [-57.291086391999954, -64.24277109199994],
              [-57.30821692599994, -64.24081796699994],
              [-57.39220130099994, -64.21803150799991],
              [-57.42332923099991, -64.21363697699991],
              [-57.45360266799992, -64.21754322699991],
              [-57.484486456999946, -64.2326799459999],
              [-57.47642981699994, -64.23211028399993],
              [-57.34666907499991, -64.25139739399992],
              [-57.32575436099995, -64.25888437299994],
              [-57.306630011999914, -64.2697893209999],
              [-57.370432094999956, -64.27800872199992],
              [-57.51231848899994, -64.25554778399993],
              [-57.564564581999946, -64.28720468499995],
              [-57.55117753799993, -64.29225025799991],
              [-57.386708136999914, -64.30584075299993],
              [-57.368397589999915, -64.31064218499995],
              [-57.35142981699994, -64.31780364399992],
              [-57.29954993399991, -64.34677499799994],
              [-57.29084225199995, -64.35418059699992],
              [-57.28429114499994, -64.36191171699994],
              [-57.29552161399994, -64.37118905999995],
              [-57.384103969999956, -64.38876718499995],
              [-57.414173956999946, -64.38811614399992],
              [-57.43049068899995, -64.38591887799993],
              [-57.442250128999945, -64.38079192499993],
              [-57.44758053299995, -64.37232838299991],
              [-57.449208136999914, -64.3532854149999],
              [-57.45457923099991, -64.3454729149999],
              [-57.46739661399994, -64.33993905999995],
              [-57.48338782499991, -64.33757903399993],
              [-57.499663865999935, -64.33806731599992],
              [-57.513335740999935, -64.34099700299993],
            ],
          ],
          [
            [
              [-57.64305579299992, -63.8493791649999],
              [-57.69517981699994, -63.816664320999905],
              [-57.647694464999915, -63.80478280999995],
              [-57.369984503999945, -63.78826262799993],
              [-57.36595618399991, -63.7888322899999],
              [-57.36196855399993, -63.791273695999905],
              [-57.35814368399991, -63.798760674999926],
              [-57.35724850199995, -63.80706145599993],
              [-57.354807094999956, -63.815118096999925],
              [-57.34618079299992, -63.82146575299993],
              [-57.38980058499993, -63.833103122999944],
              [-57.40249589799993, -63.83912525799991],
              [-57.367298956999946, -63.84197356599992],
              [-57.22301184799994, -63.81113046699994],
              [-57.184885219999956, -63.80917734199994],
              [-57.171131964999915, -63.810804945999905],
              [-57.143422003999945, -63.81975676899992],
              [-57.12059485599991, -63.83025481599992],
              [-57.089100714999915, -63.83945077899995],
              [-57.095692511999914, -63.84539153399993],
              [-57.10728919199994, -63.84783294099992],
              [-57.148996548999946, -63.85100676899992],
              [-57.154408331999946, -63.85312265399995],
              [-57.16006425699993, -63.8571916649999],
              [-57.162220831999946, -63.86060963299991],
              [-57.163319464999915, -63.864353122999944],
              [-57.17056230399993, -63.876071872999944],
              [-57.17292232999995, -63.87753671699994],
              [-57.17955481699994, -63.88005950299993],
              [-57.20067298099991, -63.88486093499995],
              [-57.24396725199995, -63.902276299999926],
              [-57.23696855399993, -63.88339609199994],
              [-57.23680579299992, -63.873304945999905],
              [-57.24290930899991, -63.86687590899993],
              [-57.249663865999935, -63.86638762799993],
              [-57.31004798099991, -63.87078215899993],
              [-57.35289466099994, -63.88396575299993],
              [-57.36595618399991, -63.88486093499995],
              [-57.37930253799993, -63.88372161299992],
              [-57.48713131399995, -63.854587497999944],
              [-57.50108801999994, -63.85857512799993],
              [-57.513742641999954, -63.87517669099992],
              [-57.53233801999994, -63.86679452899995],
              [-57.54767818899995, -63.86402760199991],
              [-57.55190995999993, -63.86272551899992],
              [-57.55821692599994, -63.85898202899995],
              [-57.562570766999954, -63.85564544099992],
              [-57.56720943899995, -63.85320403399993],
              [-57.574330206999946, -63.85173919099992],
              [-57.61461341099994, -63.85491301899992],
              [-57.62852942599994, -63.85409921699994],
              [-57.63609778599994, -63.85214609199994],
              [-57.64305579299992, -63.8493791649999],
            ],
          ],
          [
            [
              [-61.72606360599991, -63.75090911299992],
              [-61.74596106699994, -63.74179452899995],
              [-61.808257615999935, -63.72893645599993],
              [-61.784820115999935, -63.72283294099992],
              [-61.636382615999935, -63.72616952899995],
              [-61.62140865799995, -63.732354424999926],
              [-61.61375891799992, -63.763604424999926],
              [-61.62718665299991, -63.78785572699991],
              [-61.65339107999995, -63.803399346999925],
              [-61.68419348899994, -63.80787525799991],
              [-61.684437628999945, -63.80396900799991],
              [-61.69322669199994, -63.78045012799993],
              [-61.69985917899993, -63.772149346999925],
              [-61.708241339999915, -63.76409270599993],
              [-61.72606360599991, -63.75090911299992],
            ],
          ],
          [
            [
              [-60.88658606699994, -63.85857512799993],
              [-60.91079667899993, -63.856133721999925],
              [-60.9680883449999, -63.85947030999995],
              [-60.98452714799993, -63.85588958099993],
              [-60.98452714799993, -63.842461846999925],
              [-60.979400193999936, -63.8396135399999],
              [-60.97207597599993, -63.839776299999926],
              [-60.95860755099994, -63.84295012799993],
              [-60.923085089999915, -63.84726327899995],
              [-60.847320115999935, -63.84685637799993],
              [-60.80776933499993, -63.84042734199994],
              [-60.78746497299994, -63.83473072699991],
              [-60.777455206999946, -63.830010674999926],
              [-60.77025305899991, -63.82317473799992],
              [-60.76667232999995, -63.81454843499995],
              [-60.76797441299993, -63.808526299999926],
              [-60.77183997299994, -63.803399346999925],
              [-60.775380011999914, -63.79697030999995],
              [-60.79076087099992, -63.790948174999926],
              [-60.80296790299991, -63.78167083099993],
              [-60.807525193999936, -63.769463799999926],
              [-60.799712693999936, -63.75448984199994],
              [-60.790272589999915, -63.75139739399992],
              [-60.71328691299993, -63.751071872999944],
              [-60.69908606699994, -63.746351820999905],
              [-60.68586178299995, -63.73495859199994],
              [-60.68455969999991, -63.732679945999905],
              [-60.682484503999945, -63.73007577899995],
              [-60.67682857999995, -63.72673919099992],
              [-60.66515051999994, -63.72226327899995],
              [-60.69127356699994, -63.71502044099992],
              [-60.75690670499995, -63.72283294099992],
              [-60.768788214999915, -63.72185637799993],
              [-60.778187628999945, -63.717461846999925],
              [-60.77135169199994, -63.70973072699991],
              [-60.77285722599993, -63.70012786299992],
              [-60.779408331999946, -63.690118096999925],
              [-60.78726152299993, -63.68181731599992],
              [-60.79141191299993, -63.67937590899993],
              [-60.80256100199995, -63.67457447699991],
              [-60.80532792899993, -63.67131926899992],
              [-60.80223548099991, -63.6657854149999],
              [-60.79198157499991, -63.66692473799992],
              [-60.75625566299993, -63.679945570999905],
              [-60.72451738199993, -63.68767669099992],
              [-60.591053839999915, -63.69003671699994],
              [-60.552845831999946, -63.69931405999995],
              [-60.56362870999993, -63.70208098799992],
              [-60.613392706999946, -63.72747161299992],
              [-60.61432857999995, -63.73601653399993],
              [-60.62409420499995, -63.740492445999905],
              [-60.64549719999991, -63.74537525799991],
              [-60.65648352799991, -63.755791924999926],
              [-60.66982988199993, -63.78289153399993],
              [-60.67959550699993, -63.794854424999926],
              [-60.69546464799993, -63.805759372999944],
              [-60.69884192599994, -63.809665622999944],
              [-60.693348761999914, -63.82512786299992],
              [-60.67174231699994, -63.841729424999926],
              [-60.6458227199999, -63.854587497999944],
              [-60.62791907499991, -63.85857512799993],
              [-60.68008378799993, -63.8728166649999],
              [-60.72887122299994, -63.89470794099992],
              [-60.73997962099992, -63.90390390399995],
              [-60.74478105399993, -63.904961846999925],
              [-60.75072180899991, -63.9040666649999],
              [-60.75255286399994, -63.90178801899992],
              [-60.75332597599993, -63.89885833099993],
              [-60.755970831999946, -63.8962541649999],
              [-60.76821855399993, -63.891696872999944],
              [-60.77969316299993, -63.890557549999926],
              [-60.79059811099995, -63.89316171699994],
              [-60.80113684799994, -63.89967213299991],
              [-60.81554114499994, -63.912774346999925],
              [-60.821156378999945, -63.91350676899992],
              [-60.88353430899991, -63.90349700299993],
              [-60.89903723899994, -63.89690520599993],
              [-60.87022864499994, -63.88600025799991],
              [-60.86461341099994, -63.87900155999995],
              [-60.86497962099992, -63.8708635399999],
              [-60.870350714999915, -63.86484140399995],
              [-60.8782445949999, -63.86060963299991],
              [-60.88658606699994, -63.85857512799993],
            ],
          ],
          [
            [
              [-57.53892981699994, -63.68311939899991],
              [-57.55231686099995, -63.65593840899993],
              [-57.56086178299995, -63.64568450299993],
              [-57.57213294199994, -63.64275481599992],
              [-57.486317511999914, -63.623711846999925],
              [-57.44041907499991, -63.61923593499995],
              [-57.40208899599992, -63.628024997999944],
              [-57.412668423999946, -63.63250090899993],
              [-57.44640051999994, -63.67815520599993],
              [-57.46385657499991, -63.68865325299993],
              [-57.48741614499994, -63.69605885199991],
              [-57.51154537699995, -63.698337497999944],
              [-57.53087317599994, -63.6931291649999],
              [-57.53307044199994, -63.69150155999995],
              [-57.535145636999914, -63.68914153399993],
              [-57.53892981699994, -63.68320077899995],
              [-57.53892981699994, -63.68311939899991],
            ],
          ],
          [
            [
              [-56.68919837099992, -63.592868747999944],
              [-56.66283118399991, -63.567478122999944],
              [-56.60269120999993, -63.557305596999925],
              [-56.53042558499993, -63.55828215899993],
              [-56.46792558499993, -63.56568775799991],
              [-56.57787024599992, -63.61101653399993],
              [-56.64801998599995, -63.623304945999905],
              [-56.68919837099992, -63.592868747999944],
            ],
          ],
          [
            [
              [-59.83751380099994, -63.554620049999926],
              [-59.83861243399991, -63.553399346999925],
              [-59.84166419199994, -63.54648202899995],
              [-59.842355923999946, -63.54420338299991],
              [-59.81720943899995, -63.54648202899995],
              [-59.80117753799993, -63.55152760199991],
              [-59.79735266799992, -63.553399346999925],
              [-59.79405676999994, -63.55608489399992],
              [-59.79283606699994, -63.55974700299993],
              [-59.79482988199993, -63.56650155999995],
              [-59.7942602199999, -63.56959400799991],
              [-59.77603105399993, -63.58993905999995],
              [-59.77794348899994, -63.594821872999944],
              [-59.794178839999915, -63.59840260199991],
              [-59.815337693999936, -63.60084400799991],
              [-59.83470618399991, -63.60035572699991],
              [-59.853179490999935, -63.59531015399995],
              [-59.87157141799992, -63.5837541649999],
              [-59.87441972599993, -63.57268645599993],
              [-59.86204993399991, -63.563571872999944],
              [-59.83751380099994, -63.554620049999926],
            ],
          ],
          [
            [
              [-55.719593878999945, -63.47535572699991],
              [-55.71910559799994, -63.499118747999944],
              [-55.92373613199993, -63.54924895599993],
              [-55.93236243399991, -63.57935963299991],
              [-55.964914516999954, -63.58147551899992],
              [-56.15778561099995, -63.52629973799992],
              [-56.23379472599993, -63.484633070999905],
              [-56.24046790299991, -63.47869231599992],
              [-56.24014238199993, -63.472588799999926],
              [-56.23672441299993, -63.46884530999995],
              [-56.232411261999914, -63.46559010199991],
              [-56.22948157499991, -63.46152109199994],
              [-56.21971594999991, -63.44345468499995],
              [-56.20665442599994, -63.436211846999925],
              [-56.01280676999994, -63.41130950299993],
              [-55.80638587099992, -63.40740325299993],
              [-55.746978318999936, -63.428399346999925],
              [-55.719593878999945, -63.47535572699991],
            ],
          ],
          [
            [
              [-61.951730923999946, -63.31178150799991],
              [-61.97573808499993, -63.33359140399995],
              [-62.011789516999954, -63.34514739399992],
              [-62.08307857999995, -63.352634372999944],
              [-62.27749589799993, -63.35230885199991],
              [-62.26716061099995, -63.34880950299993],
              [-62.25617428299995, -63.34026458099993],
              [-62.24689693899995, -63.32935963299991],
              [-62.24156653599994, -63.31926848799992],
              [-62.240223761999914, -63.30388762799993],
              [-62.244699673999946, -63.29216887799993],
              [-62.25340735599991, -63.28240325299993],
              [-62.26431230399993, -63.27312590899993],
              [-62.255523240999935, -63.27190520599993],
              [-62.21108964799993, -63.25546640399995],
              [-62.21007239499994, -63.25123463299991],
              [-62.21361243399991, -63.24456145599993],
              [-62.213775193999936, -63.23886484199994],
              [-62.20270748599995, -63.23707447699991],
              [-62.18700110599991, -63.240166924999926],
              [-62.15412350199995, -63.25009530999995],
              [-62.03551184799994, -63.258070570999905],
              [-62.019520636999914, -63.261651299999926],
              [-62.012277798999946, -63.26482512799993],
              [-62.00649980399993, -63.269789320999905],
              [-62.002797003999945, -63.2771135399999],
              [-61.99909420499995, -63.29159921699994],
              [-61.99388587099992, -63.29851653399993],
              [-61.985259568999936, -63.30331796699994],
              [-61.97370357999995, -63.30722421699994],
              [-61.951730923999946, -63.31178150799991],
            ],
          ],
          [
            [
              [-56.698557094999956, -63.20623137799993],
              [-56.70287024599992, -63.1892229149999],
              [-56.69172115799995, -63.17546965899993],
              [-56.673085089999915, -63.16529713299991],
              [-56.654855923999946, -63.15829843499995],
              [-56.63223222599993, -63.1521135399999],
              [-56.60985266799992, -63.15056731599992],
              [-56.58763587099992, -63.1540666649999],
              [-56.56598873599995, -63.16285572699991],
              [-56.58495032499991, -63.20126718499995],
              [-56.591867641999954, -63.20859140399995],
              [-56.615345831999946, -63.21542734199994],
              [-56.64671790299991, -63.21949635199991],
              [-56.67723548099991, -63.21754322699991],
              [-56.698557094999956, -63.20623137799993],
            ],
          ],
          [
            [
              [-55.159372524999924, -63.20387135199991],
              [-55.126616990999935, -63.20867278399993],
              [-55.08576412699995, -63.22161223799992],
              [-55.05247962099992, -63.24537525799991],
              [-55.04283606699994, -63.2829729149999],
              [-55.06395423099991, -63.31926848799992],
              [-55.10912024599992, -63.343682549999926],
              [-55.172718878999945, -63.35759856599992],
              [-55.24868730399993, -63.36207447699991],
              [-55.31191972599993, -63.35686614399992],
              [-55.42418372299994, -63.33277760199991],
              [-55.48591061099995, -63.32691822699991],
              [-55.583241339999915, -63.337823174999926],
              [-55.62523352799991, -63.33416106599992],
              [-55.791900193999936, -63.28557708099993],
              [-55.77839107999995, -63.30217864399992],
              [-55.77554277299993, -63.30982838299991],
              [-55.78034420499995, -63.31959400799991],
              [-55.79173743399991, -63.32496510199991],
              [-55.80821692599994, -63.32545338299991],
              [-55.82494055899991, -63.323337497999944],
              [-55.83731035099993, -63.32000090899993],
              [-55.849720831999946, -63.31324635199991],
              [-55.860666469999956, -63.304945570999905],
              [-55.87214107999995, -63.29802825299993],
              [-55.88662675699993, -63.29501718499995],
              [-55.90135657499991, -63.2966447899999],
              [-55.90656490799995, -63.301446221999925],
              [-55.90835527299993, -63.30828215899993],
              [-55.91307532499991, -63.31658294099992],
              [-55.92235266799992, -63.324883721999925],
              [-55.94640051999994, -63.34124114399992],
              [-55.99640865799995, -63.333916924999926],
              [-56.022368943999936, -63.34661223799992],
              [-56.04747473899994, -63.36842213299991],
              [-56.09487870999993, -63.38876718499995],
              [-56.24201412699995, -63.40667083099993],
              [-56.28844153599994, -63.41741301899992],
              [-56.33617102799991, -63.43678150799991],
              [-56.355132615999935, -63.439711195999905],
              [-56.392689581999946, -63.43873463299991],
              [-56.45026607999995, -63.42929452899995],
              [-56.459095831999946, -63.42587655999995],
              [-56.46792558499993, -63.42009856599992],
              [-56.47435462099992, -63.412774346999925],
              [-56.48473059799994, -63.396742445999905],
              [-56.49323482999995, -63.3903947899999],
              [-56.508656378999945, -63.385430596999925],
              [-56.52476966099994, -63.38201262799993],
              [-56.54019120999993, -63.37704843499995],
              [-56.55378170499995, -63.36728280999995],
              [-56.54751542899993, -63.346368096999925],
              [-56.50454667899993, -63.330336195999905],
              [-56.42564856699994, -63.31462981599992],
              [-56.47085527299993, -63.29802825299993],
              [-56.477406378999945, -63.294040622999944],
              [-56.43179277299993, -63.25628020599993],
              [-56.36953691299993, -63.22812265399995],
              [-56.24526933499993, -63.192071221999925],
              [-55.97451738199993, -63.14690520599993],
              [-55.72305253799993, -63.147556247999944],
              [-55.63158118399991, -63.13030364399992],
              [-55.57567298099991, -63.12908294099992],
              [-55.506703253999945, -63.148695570999905],
              [-55.477853969999956, -63.15252044099992],
              [-55.49299068899995, -63.15447356599992],
              [-55.50885982999995, -63.16073984199994],
              [-55.523426886999914, -63.16952890399995],
              [-55.53498287699995, -63.17913176899992],
              [-55.443430141999954, -63.20777760199991],
              [-55.42983964799993, -63.20745208099993],
              [-55.42023678299995, -63.2028947899999],
              [-55.411447719999956, -63.19654713299991],
              [-55.40070553299995, -63.19068775799991],
              [-55.38418535099993, -63.1872697899999],
              [-55.159372524999924, -63.20387135199991],
            ],
          ],
          [
            [
              [-56.54596920499995, -63.09929778399993],
              [-56.603586391999954, -63.070245049999926],
              [-56.618031378999945, -63.051446221999925],
              [-56.60265051999994, -63.03053150799991],
              [-56.57762610599991, -63.01921965899993],
              [-56.524281378999945, -63.00318775799991],
              [-56.49941972599993, -62.99163176899992],
              [-56.49315344999991, -62.98650481599992],
              [-56.48985755099994, -62.98259856599992],
              [-56.485666469999956, -62.97926197699991],
              [-56.47679602799991, -62.97665780999995],
              [-56.468739386999914, -62.9763322899999],
              [-56.31387285099993, -63.00432708099993],
              [-56.10423743399991, -63.004164320999905],
              [-56.047718878999945, -63.01702239399992],
              [-56.03502356699994, -63.05754973799992],
              [-56.068348761999914, -63.08684661299992],
              [-56.21580969999991, -63.16106536299992],
              [-56.273508266999954, -63.17848072699991],
              [-56.336048956999946, -63.17457447699991],
              [-56.40843665299991, -63.15553150799991],
              [-56.54596920499995, -63.09929778399993],
            ],
          ],
          [
            [
              [-60.49787350199995, -62.96428801899992],
              [-60.52599036399994, -62.98105234199994],
              [-60.56432044199994, -62.97771575299993],
              [-60.59544837099992, -62.95989348799992],
              [-60.60204016799992, -62.93368905999995],
              [-60.62409420499995, -62.92636484199994],
              [-60.64468339799993, -62.92262135199991],
              [-60.66470292899993, -62.92262135199991],
              [-60.68529212099992, -62.92620208099993],
              [-60.68659420499995, -62.930352471999925],
              [-60.69762122299994, -62.94931405999995],
              [-60.70030676999994, -62.95273202899995],
              [-60.70018469999991, -62.95940520599993],
              [-60.69798743399991, -62.96363697699991],
              [-60.69351152299993, -62.96689218499995],
              [-60.673898891999954, -62.976495049999926],
              [-60.557484503999945, -63.0075822899999],
              [-60.58250891799992, -63.01718515399995],
              [-60.618804490999935, -63.01653411299992],
              [-60.683664516999954, -63.00335051899992],
              [-60.70604407499991, -62.994805596999925],
              [-60.726551886999914, -62.98186614399992],
              [-60.74156653599994, -62.96404387799993],
              [-60.746978318999936, -62.94060637799993],
              [-60.69220943899995, -62.895196221999925],
              [-60.619252081999946, -62.89666106599992],
              [-60.54784094999991, -62.92595794099992],
              [-60.49787350199995, -62.96428801899992],
            ],
          ],
          [
            [
              [-62.60126705599993, -63.06560637799993],
              [-62.65684973899994, -63.084649346999925],
              [-62.68578040299991, -63.09042734199994],
              [-62.71231035099993, -63.08928801899992],
              [-62.686756964999915, -63.07830169099992],
              [-62.68040930899991, -63.07268645599993],
              [-62.67756100199995, -63.066664320999905],
              [-62.67601477799991, -63.0564104149999],
              [-62.67170162699995, -63.05095794099992],
              [-62.66047115799995, -63.04566822699991],
              [-62.63418535099993, -63.03964609199994],
              [-62.62486731699994, -63.03053150799991],
              [-62.61583411399994, -63.01482512799993],
              [-62.60509192599994, -63.000258070999905],
              [-62.59276282499991, -62.98707447699991],
              [-62.57884680899991, -62.975681247999944],
              [-62.550445115999935, -62.962009372999944],
              [-62.54332434799994, -62.95631275799991],
              [-62.53970292899993, -62.94931405999995],
              [-62.53897050699993, -62.934665622999944],
              [-62.53701738199993, -62.92693450299993],
              [-62.51927649599992, -62.91253020599993],
              [-62.48940995999993, -62.90325286299992],
              [-62.39012610599991, -62.891289971999925],
              [-62.3801977199999, -62.88795338299991],
              [-62.361317511999914, -62.87859465899993],
              [-62.35114498599995, -62.87542083099993],
              [-62.30626380099994, -62.87517669099992],
              [-62.3567602199999, -62.9333635399999],
              [-62.429798956999946, -62.98577239399992],
              [-62.60126705599993, -63.06560637799993],
            ],
          ],
          [
            [
              [-61.50731360599991, -62.813571872999944],
              [-61.513335740999935, -62.80999114399992],
              [-61.51817786399994, -62.80559661299992],
              [-61.52188066299993, -62.80022551899992],
              [-61.52391516799992, -62.793633721999925],
              [-61.52358964799993, -62.78378671699994],
              [-61.52017167899993, -62.774509372999944],
              [-61.51463782499991, -62.76620859199994],
              [-61.50772050699993, -62.75920989399992],
              [-61.48607337099992, -62.74570077899995],
              [-61.46068274599992, -62.73723723799992],
              [-61.40880286399994, -62.72942473799992],
              [-61.198882615999935, -62.72771575299993],
              [-61.22801673099991, -62.73381926899992],
              [-61.24705969999991, -62.74236419099992],
              [-61.25548255099994, -62.753838799999926],
              [-61.252837693999936, -62.76873137799993],
              [-61.40925045499995, -62.823337497999944],
              [-61.46507727799991, -62.8239885399999],
              [-61.496978318999936, -62.81755950299993],
              [-61.50731360599991, -62.813571872999944],
            ],
          ],
          [
            [
              [-61.16038977799991, -62.66334400799991],
              [-61.13744055899991, -62.638929945999905],
              [-61.14175370999993, -62.619073174999926],
              [-61.16388912699995, -62.60369231599992],
              [-61.19448808499993, -62.593682549999926],
              [-61.15086829299992, -62.584649346999925],
              [-61.01707923099991, -62.60800546699994],
              [-60.96231035099993, -62.611586195999905],
              [-60.90184485599991, -62.60084400799991],
              [-60.843006964999915, -62.58367278399993],
              [-60.82380123599995, -62.57577890399995],
              [-60.814564581999946, -62.56951262799993],
              [-60.81012936099995, -62.56145598799992],
              [-60.81525631399995, -62.55169036299992],
              [-60.82750403599994, -62.542087497999944],
              [-60.84024003799993, -62.535088799999926],
              [-60.84666907499991, -62.533135674999926],
              [-60.81582597599993, -62.50432708099993],
              [-60.8020727199999, -62.48642343499995],
              [-60.80182857999995, -62.46892669099992],
              [-60.79662024599992, -62.46892669099992],
              [-60.71031653599994, -62.4997697899999],
              [-60.70645097599993, -62.50212981599992],
              [-60.70352128799993, -62.50595468499995],
              [-60.702788865999935, -62.51018645599993],
              [-60.70287024599992, -62.516696872999944],
              [-60.703684048999946, -62.52206796699994],
              [-60.705148891999954, -62.5232072899999],
              [-60.67479407499991, -62.5485979149999],
              [-60.64175370999993, -62.5642229149999],
              [-60.60484778599994, -62.572523695999905],
              [-60.491078253999945, -62.57708098799992],
              [-60.45181230399993, -62.56910572699991],
              [-60.43211829299992, -62.54924895599993],
              [-60.38117428299995, -62.552666924999926],
              [-60.32970130099994, -62.54998137799993],
              [-60.27879798099991, -62.541273695999905],
              [-60.22996985599991, -62.526462497999944],
              [-60.19200598899994, -62.5095354149999],
              [-60.17406165299991, -62.49846770599993],
              [-60.15843665299991, -62.48528411299992],
              [-60.13890540299991, -62.46152109199994],
              [-60.129465298999946, -62.460056247999944],
              [-60.103627081999946, -62.47584400799991],
              [-60.08067786399994, -62.49374765399995],
              [-60.07339433499993, -62.49732838299991],
              [-60.03575598899994, -62.51189544099992],
              [-60.01085364499994, -62.525648695999905],
              [-60.06289628799993, -62.55095794099992],
              [-60.07957923099991, -62.56365325299993],
              [-60.07070878799993, -62.57976653399993],
              [-60.045765753999945, -62.61532968499995],
              [-60.02452551999994, -62.62704843499995],
              [-59.98940995999993, -62.63014088299991],
              [-59.80296790299991, -62.611260674999926],
              [-60.12755286399994, -62.71648528399993],
              [-60.14606686099995, -62.727227471999925],
              [-60.24596106699994, -62.75286223799992],
              [-60.29059811099995, -62.7575822899999],
              [-60.31432044199994, -62.74138762799993],
              [-60.320301886999914, -62.740166924999926],
              [-60.326283331999946, -62.740166924999926],
              [-60.332142706999946, -62.739353122999944],
              [-60.33747311099995, -62.7360979149999],
              [-60.2981664699999, -62.691338799999926],
              [-60.29824785099993, -62.681898695999905],
              [-60.33238684799994, -62.67815520599993],
              [-60.36681067599994, -62.689385674999926],
              [-60.400949673999946, -62.70549895599993],
              [-60.433664516999954, -62.71624114399992],
              [-60.41120357999995, -62.67693450299993],
              [-60.40074622299994, -62.66725025799991],
              [-60.39305579299992, -62.66423919099992],
              [-60.37580318899995, -62.660821221999925],
              [-60.36778723899994, -62.65748463299991],
              [-60.33653723899994, -62.634698174999926],
              [-60.32359778599994, -62.62851327899995],
              [-60.37922115799995, -62.61012135199991],
              [-60.599598761999914, -62.6403947899999],
              [-60.679798956999946, -62.61646900799991],
              [-60.71031653599994, -62.61402760199991],
              [-60.744699673999946, -62.62184010199991],
              [-60.75820878799993, -62.633884372999944],
              [-60.76309160099993, -62.64690520599993],
              [-60.771555141999954, -62.65740325299993],
              [-60.811756964999915, -62.67197030999995],
              [-61.05622311099995, -62.68287525799991],
              [-61.11042232999995, -62.67831796699994],
              [-61.16038977799991, -62.66334400799991],
            ],
          ],
          [
            [
              [-59.74567623599995, -62.54501718499995],
              [-59.75047766799992, -62.5446916649999],
              [-59.75527910099993, -62.544040622999944],
              [-59.76012122299994, -62.54257577899995],
              [-59.76471920499995, -62.540134372999944],
              [-59.7708227199999, -62.53476327899995],
              [-59.77839107999995, -62.521742445999905],
              [-59.78368079299992, -62.516289971999925],
              [-59.79906165299991, -62.5095354149999],
              [-59.932199673999946, -62.48943450299993],
              [-59.996083136999914, -62.45256926899992],
              [-59.93228105399993, -62.440118096999925],
              [-59.72248287699995, -62.45191822699991],
              [-59.76520748599995, -62.472914320999905],
              [-59.77696692599994, -62.48088958099993],
              [-59.76911373599995, -62.48723723799992],
              [-59.76012122299994, -62.49277109199994],
              [-59.75059973899994, -62.497165622999944],
              [-59.726551886999914, -62.5036760399999],
              [-59.711822068999936, -62.50481536299992],
              [-59.70091712099992, -62.50318775799991],
              [-59.64232337099992, -62.48259856599992],
              [-59.610585089999915, -62.48007577899995],
              [-59.57982337099992, -62.48560963299991],
              [-59.55370032499991, -62.50123463299991],
              [-59.564564581999946, -62.50725676899992],
              [-59.58999589799993, -62.51018645599993],
              [-59.60195878799993, -62.513929945999905],
              [-59.59919186099995, -62.53435637799993],
              [-59.61823482999995, -62.5446916649999],
              [-59.67023678299995, -62.54957447699991],
              [-59.72496497299994, -62.54452890399995],
              [-59.74567623599995, -62.54501718499995],
            ],
          ],
          [
            [
              [-59.69416256399995, -62.37851327899995],
              [-59.69595292899993, -62.37574635199991],
              [-59.69684811099995, -62.37273528399993],
              [-59.69664466099994, -62.36931731599992],
              [-59.69505774599992, -62.36565520599993],
              [-59.68919837099992, -62.3610979149999],
              [-59.679676886999914, -62.35800546699994],
              [-59.60387122299994, -62.34734465899993],
              [-59.436756964999915, -62.35507577899995],
              [-59.38231360599991, -62.37273528399993],
              [-59.34740149599992, -62.406508070999905],
              [-59.35187740799995, -62.409274997999944],
              [-59.37149003799993, -62.43596770599993],
              [-59.376616990999935, -62.4411760399999],
              [-59.38133704299992, -62.44459400799991],
              [-59.38687089799993, -62.44687265399995],
              [-59.39492753799993, -62.44841887799993],
              [-59.44896399599992, -62.44817473799992],
              [-59.49819902299993, -62.45720794099992],
              [-59.50877844999991, -62.456963799999926],
              [-59.55744381399995, -62.44500090899993],
              [-59.57530676999994, -62.44353606599992],
              [-59.591867641999954, -62.42896900799991],
              [-59.62572180899991, -62.408135674999926],
              [-59.61554928299995, -62.40056731599992],
              [-59.6106664699999, -62.39373137799993],
              [-59.607411261999914, -62.387383721999925],
              [-59.60216223899994, -62.381524346999925],
              [-59.612945115999935, -62.3845354149999],
              [-59.66388912699995, -62.38876718499995],
              [-59.67149817599994, -62.38811614399992],
              [-59.68000240799995, -62.38632577899995],
              [-59.68809973899994, -62.38298919099992],
              [-59.69416256399995, -62.37851327899995],
            ],
          ],
          [
            [
              [-58.98314368399991, -62.2653947899999],
              [-58.97362219999991, -62.26921965899993],
              [-58.926991339999915, -62.261976820999905],
              [-58.89915930899991, -62.26311614399992],
              [-58.87189693899995, -62.27092864399992],
              [-58.84902910099993, -62.28606536299992],
              [-58.83433997299994, -62.30934010199991],
              [-59.029855923999946, -62.34807708099993],
              [-59.06940670499995, -62.34905364399992],
              [-59.088734503999945, -62.34644947699991],
              [-59.10431881399995, -62.34140390399995],
              [-59.14293372299994, -62.323337497999944],
              [-59.15737870999993, -62.31951262799993],
              [-59.16421464799993, -62.31698984199994],
              [-59.20295162699995, -62.29697030999995],
              [-59.21776282499991, -62.292087497999944],
              [-59.1887914699999, -62.27239348799992],
              [-59.15660559799994, -62.26018645599993],
              [-59.03294837099992, -62.233493747999944],
              [-59.00454667899993, -62.23316822699991],
              [-58.978586391999954, -62.24114348799992],
              [-58.98257402299993, -62.2497697899999],
              [-58.98452714799993, -62.25660572699991],
              [-58.98468990799995, -62.26181405999995],
              [-58.98314368399991, -62.2653947899999],
            ],
          ],
          [
            [
              [-58.466908331999946, -62.160414320999905],
              [-58.44611568899995, -62.18865325299993],
              [-58.447377081999946, -62.20476653399993],
              [-58.46751868399991, -62.215508721999925],
              [-58.58462480399993, -62.24895598799992],
              [-58.62254798099991, -62.247979424999926],
              [-58.633371548999946, -62.22714609199994],
              [-58.67609615799995, -62.223728122999944],
              [-58.74571692599994, -62.23691171699994],
              [-58.78311113199993, -62.22503020599993],
              [-58.76081295499995, -62.21998463299991],
              [-58.750070766999954, -62.21575286299992],
              [-58.74087480399993, -62.210056247999944],
              [-58.75454667899993, -62.20452239399992],
              [-58.79800370999993, -62.19784921699994],
              [-58.79588782499991, -62.19548919099992],
              [-58.79434160099993, -62.18962981599992],
              [-58.79377193899995, -62.18303801899992],
              [-58.79405676999994, -62.17888762799993],
              [-58.79751542899993, -62.1735979149999],
              [-58.8020727199999, -62.17115650799991],
              [-58.80736243399991, -62.170179945999905],
              [-58.82518469999991, -62.16936614399992],
              [-58.94200598899994, -62.1931291649999],
              [-58.95571855399993, -62.200290622999944],
              [-58.959868943999936, -62.21062590899993],
              [-58.94912675699993, -62.225681247999944],
              [-58.963449673999946, -62.22747161299992],
              [-58.98005123599995, -62.22625090899993],
              [-59.01073157499991, -62.21965911299992],
              [-58.98281816299993, -62.18450286299992],
              [-58.94603430899991, -62.15878671699994],
              [-58.71279863199993, -62.052666924999926],
              [-58.70132402299993, -62.04045989399992],
              [-58.70164954299992, -62.03484465899993],
              [-58.70445716099994, -62.03045012799993],
              [-58.70677649599992, -62.02556731599992],
              [-58.70555579299992, -62.01913827899995],
              [-58.69908606699994, -62.012383721999925],
              [-58.68907630099994, -62.0075822899999],
              [-58.67821204299992, -62.00400155999995],
              [-58.46532141799992, -61.96648528399993],
              [-58.45588131399995, -61.961602471999925],
              [-58.44953365799995, -61.95582447699991],
              [-58.43980872299994, -61.94215260199991],
              [-58.434478318999936, -61.9372697899999],
              [-58.414051886999914, -61.93328215899993],
              [-58.387603318999936, -61.936618747999944],
              [-58.339914516999954, -61.947930596999925],
              [-58.22443600199995, -61.96021900799991],
              [-58.175770636999914, -61.95126718499995],
              [-58.052805141999954, -61.91253020599993],
              [-58.007883266999954, -61.90447356599992],
              [-57.89024817599994, -61.93840911299992],
              [-57.83580481699994, -61.94198984199994],
              [-57.70547441299993, -61.91570403399993],
              [-57.669911261999914, -61.91350676899992],
              [-57.656320766999954, -61.917087497999944],
              [-57.64753170499995, -61.92620208099993],
              [-57.64565995999993, -61.93759530999995],
              [-57.64956620999993, -61.94890715899993],
              [-57.65770423099991, -61.95818450299993],
              [-57.67039954299992, -61.96445077899995],
              [-57.68077551999994, -61.967461846999925],
              [-57.68496660099993, -61.97144947699991],
              [-57.678578253999945, -61.98088958099993],
              [-57.660715298999946, -61.99553801899992],
              [-57.63719641799992, -62.00937265399995],
              [-57.61229407499991, -62.019789320999905],
              [-57.589833136999914, -62.02548593499995],
              [-57.76577714799993, -62.00709400799991],
              [-57.78844153599994, -62.00872161299992],
              [-57.81265214799993, -62.01384856599992],
              [-57.84837805899991, -62.02857838299991],
              [-57.918039516999954, -62.06658294099992],
              [-57.954009568999936, -62.078057549999926],
              [-57.98908443899995, -62.0798479149999],
              [-58.1399633449999, -62.05624765399995],
              [-58.15526282499991, -62.058526299999926],
              [-58.168039516999954, -62.06389739399992],
              [-58.17145748599995, -62.070245049999926],
              [-58.17096920499995, -62.07887135199991],
              [-58.17259680899991, -62.09124114399992],
              [-58.177398240999935, -62.09978606599992],
              [-58.18301347599993, -62.10588958099993],
              [-58.18586178299995, -62.11191171699994],
              [-58.18211829299992, -62.11988697699991],
              [-58.169992641999954, -62.12835051899992],
              [-58.123158331999946, -62.14006926899992],
              [-58.13825436099995, -62.156914971999925],
              [-58.16307532499991, -62.16757577899995],
              [-58.24282792899993, -62.181573174999926],
              [-58.2727758449999, -62.18092213299991],
              [-58.291900193999936, -62.17538827899995],
              [-58.30846106699994, -62.16521575299993],
              [-58.33885657499991, -62.14031340899993],
              [-58.36790930899991, -62.12395598799992],
              [-58.37531490799995, -62.11687590899993],
              [-58.379017706999946, -62.10605234199994],
              [-58.37222245999993, -62.101820570999905],
              [-58.3294164699999, -62.10361093499995],
              [-58.313343878999945, -62.10035572699991],
              [-58.27920488199993, -62.08261484199994],
              [-58.30654863199993, -62.07463958099993],
              [-58.335601365999935, -62.075290622999944],
              [-58.391468878999945, -62.08489348799992],
              [-58.404408331999946, -62.08440520599993],
              [-58.44188391799992, -62.072198174999926],
              [-58.458648240999935, -62.06975676899992],
              [-58.47618567599994, -62.07040780999995],
              [-58.493397589999915, -62.074151299999926],
              [-58.50890051999994, -62.08098723799992],
              [-58.47496497299994, -62.09238046699994],
              [-58.46776282499991, -62.09840260199991],
              [-58.46812903599994, -62.11419036299992],
              [-58.48184160099993, -62.12737395599993],
              [-58.50059973899994, -62.137383721999925],
              [-58.62124589799993, -62.17107512799993],
              [-58.63394120999993, -62.17791106599992],
              [-58.613840298999946, -62.18287525799991],
              [-58.59239661399994, -62.18450286299992],
              [-58.55016028599994, -62.18173593499995],
              [-58.466908331999946, -62.160414320999905],
            ],
          ],
          [
            [
              [-54.036040818999936, -61.24570077899995],
              [-54.043812628999945, -61.26873137799993],
              [-54.05703691299993, -61.2888322899999],
              [-54.07530676999994, -61.30396900799991],
              [-54.09801184799994, -61.31210702899995],
              [-54.12124589799993, -61.30868905999995],
              [-54.20287024599992, -61.28411223799992],
              [-54.227406378999945, -61.27011484199994],
              [-54.20718339799993, -61.25253671699994],
              [-54.08690344999991, -61.180352471999925],
              [-54.07408606699994, -61.16765715899993],
              [-54.06944739499994, -61.15943775799991],
              [-54.05776933499993, -61.13290780999995],
              [-54.05736243399991, -61.12704843499995],
              [-54.023426886999914, -61.13054778399993],
              [-54.00885982999995, -61.13762786299992],
              [-54.00645911399994, -61.1521135399999],
              [-54.016916469999956, -61.16375090899993],
              [-54.03278561099995, -61.16887786299992],
              [-54.04820716099994, -61.175713799999926],
              [-54.057484503999945, -61.19255950299993],
              [-54.057199673999946, -61.20240650799991],
              [-54.05296790299991, -61.207289320999905],
              [-54.04629472599993, -61.210870049999926],
              [-54.03888912699995, -61.217054945999905],
              [-54.03425045499995, -61.223728122999944],
              [-54.03294837099992, -61.229180596999925],
              [-54.036040818999936, -61.24570077899995],
            ],
          ],
          [
            [
              [-55.07795162699995, -61.09319426899992],
              [-54.973500128999945, -61.10711028399993],
              [-54.65151933499993, -61.106540622999944],
              [-54.66771399599992, -61.11142343499995],
              [-54.696522589999915, -61.13836028399993],
              [-54.71056067599994, -61.14804452899995],
              [-54.72956295499995, -61.152276299999926],
              [-55.03457597599993, -61.15642669099992],
              [-55.05370032499991, -61.15976327899995],
              [-55.067616339999915, -61.16757577899995],
              [-55.07164466099994, -61.17473723799992],
              [-55.073150193999936, -61.188571872999944],
              [-55.07730058499993, -61.19589609199994],
              [-55.085926886999914, -61.202243747999944],
              [-55.095773891999954, -61.20468515399995],
              [-55.13166256399995, -61.206963799999926],
              [-55.13971920499995, -61.21111419099992],
              [-55.152333136999914, -61.22966887799993],
              [-55.178944464999915, -61.25546640399995],
              [-55.21141516799992, -61.26726653399993],
              [-55.24669348899994, -61.26702239399992],
              [-55.28148352799991, -61.256931247999944],
              [-55.343739386999914, -61.22747161299992],
              [-55.36986243399991, -61.20720794099992],
              [-55.39122473899994, -61.17848072699991],
              [-55.35895748599995, -61.15976327899995],
              [-55.34544837099992, -61.155368747999944],
              [-55.34634355399993, -61.15488046699994],
              [-55.34666907499991, -61.15439218499995],
              [-55.34605872299994, -61.15398528399993],
              [-55.34483801999994, -61.15374114399992],
              [-55.37340247299994, -61.1403947899999],
              [-55.43049068899995, -61.12420012799993],
              [-55.44904537699995, -61.1150041649999],
              [-55.414051886999914, -61.08359140399995],
              [-55.37804114499994, -61.07048919099992],
              [-55.07795162699995, -61.09319426899992],
            ],
          ],
          [
            [
              [-44.51854407499991, -60.71843840899993],
              [-44.535227016999954, -60.73650481599992],
              [-44.56627356699994, -60.74504973799992],
              [-44.64126542899993, -60.74863046699994],
              [-44.69758053299995, -60.744398695999905],
              [-44.71971594999991, -60.75042083099993],
              [-44.71784420499995, -60.77271900799991],
              [-44.73615475199995, -60.76441822699991],
              [-44.81993567599994, -60.7400041649999],
              [-44.82774817599994, -60.73577239399992],
              [-44.83283443899995, -60.73121510199991],
              [-44.843088344999956, -60.719008070999905],
              [-44.847320115999935, -60.715508721999925],
              [-44.805246548999946, -60.73015715899993],
              [-44.78302975199995, -60.73381926899992],
              [-44.760975714999915, -60.73333098799992],
              [-44.72280839799993, -60.725681247999944],
              [-44.70384680899991, -60.72470468499995],
              [-44.694569464999915, -60.72275155999995],
              [-44.68651282499991, -60.71835702899995],
              [-44.68077551999994, -60.70859140399995],
              [-44.68211829299992, -60.69801197699991],
              [-44.69025631399995, -60.67620208099993],
              [-44.67658443899995, -60.68474700299993],
              [-44.60928300699993, -60.708916924999926],
              [-44.60301673099991, -60.70916106599992],
              [-44.598500128999945, -60.70663827899995],
              [-44.59154212099992, -60.69866301899992],
              [-44.58731035099993, -60.69573333099993],
              [-44.58275305899991, -60.69491952899995],
              [-44.57396399599992, -60.69605885199991],
              [-44.569650844999956, -60.69573333099993],
              [-44.552723761999914, -60.68808359199994],
              [-44.53921464799993, -60.679945570999905],
              [-44.52481035099993, -60.67473723799992],
              [-44.50523841099994, -60.6755510399999],
              [-44.45164954299992, -60.70330169099992],
              [-44.508656378999945, -60.71363697699991],
              [-44.51854407499991, -60.71843840899993],
            ],
          ],
          [
            [
              [-46.00698808499993, -60.61272551899992],
              [-46.008697068999936, -60.608086846999925],
              [-46.00890051999994, -60.602634372999944],
              [-46.007476365999935, -60.59579843499995],
              [-46.00405839799993, -60.58757903399993],
              [-45.999989386999914, -60.58066171699994],
              [-45.99461829299992, -60.5739885399999],
              [-45.98814856699994, -60.56853606599992],
              [-45.98094641799992, -60.56462981599992],
              [-45.97179114499994, -60.56292083099993],
              [-45.957142706999946, -60.56601327899995],
              [-45.94831295499995, -60.566338799999926],
              [-45.957102016999954, -60.53411223799992],
              [-45.955067511999914, -60.52776458099993],
              [-45.93512936099995, -60.52467213299991],
              [-45.91673743399991, -60.52613697699991],
              [-45.85195878799993, -60.54729583099993],
              [-45.84284420499995, -60.54843515399995],
              [-45.833973761999914, -60.5466447899999],
              [-45.80809485599991, -60.535821221999925],
              [-45.793039516999954, -60.53435637799993],
              [-45.76121985599991, -60.53557708099993],
              [-45.746978318999936, -60.532321872999944],
              [-45.746652798999946, -60.53085702899995],
              [-45.74437415299991, -60.52678801899992],
              [-45.741118943999936, -60.52223072699991],
              [-45.73729407499991, -60.51897551899992],
              [-45.729725714999915, -60.51677825299993],
              [-45.72057044199994, -60.51620859199994],
              [-45.70335852799991, -60.5173479149999],
              [-45.66576087099992, -60.524102471999925],
              [-45.56753495999993, -60.55364348799992],
              [-45.54572506399995, -60.55486419099992],
              [-45.48704993399991, -60.5446916649999],
              [-45.47716223899994, -60.545586846999925],
              [-45.44741777299993, -60.553806247999944],
              [-45.39098059799994, -60.57927825299993],
              [-45.372385219999956, -60.59726327899995],
              [-45.389515753999945, -60.61223723799992],
              [-45.381703253999945, -60.61370208099993],
              [-45.34943600199995, -60.62859465899993],
              [-45.32921301999994, -60.63241952899995],
              [-45.27183997299994, -60.6267229149999],
              [-45.190663214999915, -60.63290780999995],
              [-45.21165930899991, -60.65252044099992],
              [-45.21784420499995, -60.654554945999905],
              [-45.17808997299994, -60.666680596999925],
              [-45.15404212099992, -60.68238697699991],
              [-45.14679928299995, -60.685804945999905],
              [-45.16502844999991, -60.68238697699991],
              [-45.175770636999914, -60.68206145599993],
              [-45.182932094999956, -60.683851820999905],
              [-45.18732662699995, -60.69890715899993],
              [-45.174672003999945, -60.71428801899992],
              [-45.14102128799993, -60.7360979149999],
              [-45.16242428299995, -60.73748137799993],
              [-45.18464107999995, -60.73333098799992],
              [-45.22594153599994, -60.71689218499995],
              [-45.26187089799993, -60.69296640399995],
              [-45.28380286399994, -60.6833635399999],
              [-45.307484503999945, -60.67888762799993],
              [-45.35529537699995, -60.675713799999926],
              [-45.353586391999954, -60.67351653399993],
              [-45.35655676999994, -60.66838958099993],
              [-45.36310787699995, -60.660414320999905],
              [-45.36681067599994, -60.658868096999925],
              [-45.40851803299995, -60.64804452899995],
              [-45.42145748599995, -60.64657968499995],
              [-45.46580969999991, -60.65129973799992],
              [-45.49791419199994, -60.64934661299992],
              [-45.54401607999995, -60.641696872999944],
              [-45.59056555899991, -60.63925546699994],
              [-45.680531378999945, -60.649102471999925],
              [-45.718861456999946, -60.645603122999944],
              [-45.74258378799993, -60.62623463299991],
              [-45.75234941299993, -60.614353122999944],
              [-45.759103969999956, -60.6110979149999],
              [-45.76012122299994, -60.608086846999925],
              [-45.75259355399993, -60.596368096999925],
              [-45.78929602799991, -60.58407968499995],
              [-45.82469641799992, -60.58611419099992],
              [-45.932932094999956, -60.6228166649999],
              [-45.95225989499994, -60.62558359199994],
              [-45.97207597599993, -60.62542083099993],
              [-45.99364173099991, -60.621758721999925],
              [-46.00177975199995, -60.618259372999944],
              [-46.00698808499993, -60.61272551899992],
            ],
          ],
          [
            [
              [-162.3398331369999, -82.92376067499993],
              [-162.26740475199992, -82.94654713299991],
              [-161.92159990149992, -82.98544687299992],
              [-161.57579505099991, -83.02434661299992],
              [-161.81330318899992, -83.03866952899995],
              [-161.84418697799993, -83.04550546699994],
              [-161.87311764199993, -83.05828215899993],
              [-161.93732662699992, -83.10051848799992],
              [-161.97004146999993, -83.11630624799994],
              [-162.0126846999999, -83.12607187299994],
              [-162.40241451699993, -83.14837004999993],
              [-162.83185787649992, -83.11467864399992],
              [-163.26130123599992, -83.08098723799992],
              [-163.28388424399992, -83.06308359199994],
              [-163.28107662699992, -83.05771249799994],
              [-163.27021236899992, -83.05120208099993],
              [-163.26862545499992, -83.04566822699991],
              [-163.29560299399992, -83.02662525799991],
              [-163.50706946499992, -83.01091887799993],
              [-163.6015518869999, -82.99016692499993],
              [-163.61945553299992, -82.98170338299991],
              [-163.62958736899992, -82.97063567499993],
              [-163.62511145699992, -82.95281340899993],
              [-163.60521399599992, -82.94036223799992],
              [-163.56232662699992, -82.9240861959999],
              [-163.5784805979999, -82.9138322899999],
              [-163.60240637899992, -82.90789153399993],
              [-163.73041744699992, -82.88982512799993],
              [-163.75275631399992, -82.87997812299994],
              [-163.72114010299993, -82.87322356599992],
              [-163.68879146999993, -82.87151458099993],
              [-163.71003170499992, -82.86142343499995],
              [-163.81139075399992, -82.84693775799991],
              [-163.74970455599993, -82.83359140399995],
              [-163.32697506399992, -82.84794144733327],
              [-162.90424557199992, -82.8622914906666],
              [-162.48151607999992, -82.87664153399993],
              [-162.40904700399992, -82.89641692499993],
              [-162.3398331369999, -82.92376067499993],
            ],
          ],
          [
            [
              [-169.03034420499992, -83.15422942499993],
              [-168.89863033799992, -83.18889739399992],
              [-168.81017005099991, -83.20183684699992],
              [-168.7873429029999, -83.21379973799992],
              [-168.8471573559999, -83.2268205709999],
              [-169.3246964184999, -83.20541757599992],
              [-169.8022354809999, -83.18401458099993],
              [-169.81611080599993, -83.18027109199994],
              [-169.82823645699992, -83.17294687299994],
              [-169.8499649729999, -83.15447356599992],
              [-169.8631485669999, -83.14739348799992],
              [-170.3551122712499, -83.07640960124992],
              [-170.8470759754999, -83.00542571449992],
              [-171.3390396797499, -82.93444182774992],
              [-171.8310033839999, -82.86345794099992],
              [-171.9013565749999, -82.8420549459999],
              [-171.82050533799992, -82.82463958099993],
              [-171.3554784824999, -82.8795712216666],
              [-170.89045162699992, -82.93450286233326],
              [-170.42542477149993, -82.98943450299993],
              [-169.96039791599992, -83.0443661436666],
              [-169.4953710604999, -83.09929778433326],
              [-169.03034420499992, -83.15422942499993],
            ],
          ],
          [
            [
              [-158.3468318349999, -81.90146249799994],
              [-158.3467911449999, -81.90154387799993],
              [-158.30414791599992, -81.9299455709999],
              [-158.24653072799993, -81.95452239399992],
              [-157.91490637899992, -82.01824309699992],
              [-157.85663814999992, -82.0197893209999],
              [-157.82746334499993, -82.02467213299991],
              [-157.8085831369999, -82.03915780999995],
              [-157.92076575399992, -82.08473072699991],
              [-157.99091549399992, -82.09783294099992],
              [-158.06720943899992, -82.10222747199992],
              [-158.09850012899992, -82.09579843499995],
              [-158.0850723949999, -82.08709075299993],
              [-158.06928463399993, -82.08147551899992],
              [-158.0369766919999, -82.07561614399992],
              [-158.0670059889999, -82.0485979149999],
              [-158.10968990799992, -82.03533294099992],
              [-158.3936661449999, -81.99374765399995],
              [-158.69711259699992, -81.90610116949995],
              [-159.00055904899992, -81.81845468499995],
              [-159.01915442599991, -81.78769296699994],
              [-159.0030411449999, -81.78036874799994],
              [-158.97858639199993, -81.77800872199992],
              [-158.89220130099991, -81.78183359199994],
              [-158.6389664379999, -81.83123137849992],
              [-158.3857315749999, -81.8806291649999],
              [-158.3714493479999, -81.8864885399999],
              [-158.3468318349999, -81.90146249799994],
            ],
          ],
          [
            [
              [-160.57111568899992, -81.59889088299991],
              [-161.02217130657135, -81.58213818585706],
              [-161.47322692414278, -81.5653854887142],
              [-161.9242825417142, -81.54863279157135],
              [-162.37533815928563, -81.53188009442849],
              [-162.82639377685706, -81.51512739728564],
              [-163.2774493944285, -81.49837470014278],
              [-163.7285050119999, -81.48162200299993],
              [-163.75316321499992, -81.4704729149999],
              [-163.74860592399992, -81.46868254999993],
              [-163.6710098949999, -81.46542734199994],
              [-163.6581925119999, -81.46160247199992],
              [-163.6701554029999, -81.45435963299991],
              [-163.94884192599991, -81.41887786299992],
              [-163.99006100199992, -81.40349700299993],
              [-163.9698380199999, -81.39316171699994],
              [-163.9492081369999, -81.37835051899992],
              [-163.93211829299992, -81.36101653399993],
              [-163.92267818899992, -81.34335702899995],
              [-163.85118567599991, -81.31894296699994],
              [-163.4175308909999, -81.29461028449992],
              [-162.9838761059999, -81.27027760199991],
              [-162.5222468741999, -81.30878671659991],
              [-162.0606176423999, -81.34729583119992],
              [-161.59898841059993, -81.38580494579992],
              [-161.13735917879993, -81.42431406039992],
              [-160.67572994699992, -81.46282317499993],
              [-160.63227291599992, -81.49089934699992],
              [-160.62852942599991, -81.49675872199992],
              [-160.67149817599991, -81.50798919099992],
              [-160.68512936099992, -81.51474374799994],
              [-160.6472061839999, -81.5178361959999],
              [-160.44220943899992, -81.56023528399993],
              [-160.41388912699992, -81.57366301899992],
              [-160.44538326699993, -81.59050872199992],
              [-160.4876602859999, -81.59710051899992],
              [-160.57111568899992, -81.59889088299991],
            ],
          ],
          [
            [
              [-154.1142471999999, -80.03704192499993],
              [-154.36188717399992, -80.03053150799991],
              [-154.33539791599992, -80.02532317499993],
              [-154.30980383999992, -80.01669687299994],
              [-154.36766516799992, -80.00701262799993],
              [-154.40973873599992, -80.00920989399992],
              [-154.4232071609999, -80.00465260199991],
              [-154.43049068899992, -79.99895598799992],
              [-154.44294186099992, -79.98642343499995],
              [-154.4526261059999, -79.98121510199991],
              [-154.5139054029999, -79.96428801899992],
              [-154.98786373599992, -79.92937590899993],
              [-155.02863521999993, -79.91570403399993],
              [-155.0182999339999, -79.89617278399993],
              [-155.4787491529999, -79.85759856599992],
              [-155.66527258999992, -79.81682708099993],
              [-155.66185462099992, -79.81609465899993],
              [-155.64826412699992, -79.80999114399992],
              [-155.6135147779999, -79.80282968499995],
              [-155.57697506399992, -79.80038827899995],
              [-155.16228186749993, -79.85180022574994],
              [-154.7475886709999, -79.90321217249993],
              [-154.3328954744999, -79.95462411924993],
              [-153.9182022779999, -80.00603606599992],
              [-153.89460201699993, -80.02092864399992],
              [-153.94257564999992, -80.03875090899993],
              [-154.11412512899992, -80.03704192499993],
              [-154.1142471999999, -80.03704192499993],
            ],
          ],
          [
            [
              [-155.7193497389999, -79.76913827899995],
              [-155.58165442599991, -79.78289153399993],
              [-155.61644446499992, -79.79534270599993],
              [-155.65412350199992, -79.80388762799993],
              [-155.79308020699992, -79.8200822899999],
              [-155.82787024599992, -79.81552499799994],
              [-155.85541744699992, -79.79745859199994],
              [-155.8235977859999, -79.77825286299992],
              [-155.79047604099992, -79.77011484199994],
              [-155.7193497389999, -79.76913827899995],
            ],
          ],
          [
            [
              [-163.09972083199992, -79.74529387799993],
              [-162.7342423169999, -79.79387786299992],
              [-162.7076309889999, -79.80201588299991],
              [-162.6873673169999, -79.81487395599993],
              [-162.73200436099992, -79.83505624799994],
              [-162.78266354099992, -79.84172942499993],
              [-163.06582597599993, -79.81975676899992],
              [-163.3489884109999, -79.79778411299992],
              [-163.40013587099992, -79.78289153399993],
              [-163.30915279899992, -79.77898528399993],
              [-163.24799557199992, -79.76832447699991],
              [-163.15160071499992, -79.76775481599992],
              [-163.06566321499992, -79.78199635199991],
              [-163.0380753249999, -79.7771135399999],
              [-163.04877682199992, -79.76832447699991],
              [-163.0624893869999, -79.76490650799991],
              [-163.07734127499992, -79.76384856599992],
              [-163.14679928299992, -79.74822356599992],
              [-163.16291256399992, -79.73992278399993],
              [-163.09972083199992, -79.74529387799993],
            ],
          ],
          [
            [
              [-29.618316209999932, -79.91122812299994],
              [-29.679798956999946, -79.9279924459999],
              [-29.701242641999954, -79.93132903399993],
              [-29.77961178299995, -79.92962004999993],
              [-29.861724412999934, -79.91904062299994],
              [-29.877797003999945, -79.9123674459999],
              [-29.889556443999936, -79.90178801899992],
              [-29.90929114499994, -79.87769947699991],
              [-29.92369544199994, -79.86980559699992],
              [-30.00890051999994, -79.85361093499995],
              [-30.053456183999913, -79.85198333099993],
              [-30.095448370999918, -79.85621510199991],
              [-30.163400844999956, -79.87688567499993],
              [-30.252349412999934, -79.88616301899992],
              [-30.14590410099993, -79.93108489399992],
              [-30.03465735599991, -79.94085051899992],
              [-30.021962042999917, -79.94345468499995],
              [-30.014475063999953, -79.94784921699994],
              [-29.994618292999917, -79.9626604149999],
              [-29.989084438999953, -79.96559010199991],
              [-30.184722459999932, -80.00497812299994],
              [-30.366444464999915, -80.01775481599992],
              [-30.425526495999918, -80.01091887799993],
              [-30.47166907499991, -79.98870208099993],
              [-30.324208136999914, -79.98479583099993],
              [-30.287261522999927, -79.97584400799991],
              [-30.27798417899993, -79.97584400799991],
              [-30.310902472999942, -79.96721770599993],
              [-30.48265540299991, -79.94500090899993],
              [-30.49600175699993, -79.93759530999995],
              [-30.501616990999935, -79.92913176899992],
              [-30.505482550999943, -79.91961028399993],
              [-30.513661261999914, -79.90894947699991],
              [-30.521473761999914, -79.9040666649999],
              [-30.52920488199993, -79.9026018209999],
              [-30.63117428299995, -79.90642669099992],
              [-30.652495897999927, -79.91692473799992],
              [-30.64606686099995, -79.91936614399992],
              [-30.635975714999915, -79.92742278399993],
              [-30.632435675999943, -79.93889739399992],
              [-30.645659959999932, -79.9514299459999],
              [-30.66112219999991, -79.95566171699994],
              [-30.678944464999915, -79.95631275799991],
              [-30.88768469999991, -79.9255510399999],
              [-31.21471106699991, -79.91204192499993],
              [-31.541737433999913, -79.89853280999995],
              [-31.751942511999914, -79.8591447899999],
              [-31.851714647999927, -79.85263437299994],
              [-31.872425910999937, -79.84710051899992],
              [-31.855824347999942, -79.83798593499995],
              [-31.83580481699994, -79.83245208099993],
              [-31.737172003999945, -79.81682708099993],
              [-31.718902147999927, -79.80950286299992],
              [-31.80968176999994, -79.80095794099992],
              [-31.998199022999927, -79.82024504999993],
              [-32.04478919199994, -79.81902434699992],
              [-32.08946692599994, -79.80925872199992],
              [-31.91633053299995, -79.77214934699992],
              [-31.89671790299991, -79.76482512799993],
              [-31.87877356699994, -79.75448984199994],
              [-31.924387173999946, -79.74765390399995],
              [-31.93932044199994, -79.74374765399995],
              [-31.950795050999943, -79.73772551899992],
              [-31.97166907499991, -79.72307708099993],
              [-31.983143683999913, -79.71754322699991],
              [-31.998036261999914, -79.71396249799994],
              [-32.161773240999935, -79.70964934699992],
              [-31.996693488999938, -79.6970354149999],
              [-31.96776282499991, -79.69011809699992],
              [-31.98460852799991, -79.68515390399995],
              [-32.037220831999946, -79.68132903399993],
              [-32.07725989499994, -79.66659921699994],
              [-32.06387285099993, -79.6638322899999],
              [-32.02440344999991, -79.64967213299991],
              [-31.787709113999938, -79.63079192499993],
              [-31.64476477799991, -79.63689544099992],
              [-31.59166419199994, -79.6486955709999],
              [-31.443959113999938, -79.70859140399995],
              [-31.189279751999948, -79.76572030999995],
              [-31.134510870999918, -79.79753997199992],
              [-31.11514238199993, -79.80575937299994],
              [-31.095448370999918, -79.81072356599992],
              [-30.654123501999948, -79.84612395599993],
              [-30.492298956999946, -79.84189218499995],
              [-30.357899542999917, -79.85540129999993],
              [-30.29051673099991, -79.85320403399993],
              [-30.22557532499991, -79.83749765399995],
              [-30.522877570999924, -79.79290129999993],
              [-30.82017981699994, -79.7483049459999],
              [-30.847482876999948, -79.74065520599993],
              [-30.870716925999943, -79.72722747199992],
              [-30.877837693999936, -79.71965911299992],
              [-30.89049231699994, -79.70281340899993],
              [-30.898182745999918, -79.69597747199992],
              [-30.90575110599991, -79.69255950299993],
              [-30.921498175999943, -79.68857187299994],
              [-30.928944464999915, -79.68425872199992],
              [-30.88857988199993, -79.66480885199991],
              [-30.843373175999943, -79.65252044099992],
              [-30.797352667999917, -79.65007903399993],
              [-30.75487219999991, -79.66033294099992],
              [-30.740589972999942, -79.67099374799994],
              [-30.722035285999937, -79.69890715899993],
              [-30.707020636999914, -79.71160247199992],
              [-30.662831183999913, -79.73455169099992],
              [-30.647084113999938, -79.73967864399992],
              [-30.276661750499926, -79.77735768049993],
              [-29.906239386999914, -79.81503671699994],
              [-29.76512610599991, -79.85198333099993],
              [-29.61286373599995, -79.91025155999995],
              [-29.618316209999932, -79.91122812299994],
            ],
          ],
          [
            [
              [-159.8421524729999, -79.34856536299992],
              [-159.5663956369999, -79.43254973799992],
              [-159.56025143099993, -79.43572356599992],
              [-159.55573482999992, -79.44003671699994],
              [-159.54893958199992, -79.44988372199992],
              [-159.54474850199992, -79.45435963299991],
              [-159.53917395699992, -79.45769622199992],
              [-159.5264786449999, -79.46233489399992],
              [-159.52110755099991, -79.46559010199991],
              [-159.5076798169999, -79.4821916649999],
              [-159.50206458199992, -79.48650481599992],
              [-159.4941300119999, -79.48886484199994],
              [-159.46605383999992, -79.49089934699992],
              [-159.3349503249999, -79.52825286299992],
              [-159.3216446609999, -79.53679778399993],
              [-159.32380123599992, -79.5471330709999],
              [-159.33478756399992, -79.55169036299992],
              [-159.3495987619999, -79.55266692499993],
              [-159.3771866529999, -79.5505510399999],
              [-159.25316321499992, -79.58163827899995],
              [-159.23517818899992, -79.58904387799993],
              [-159.21503658799992, -79.6018205709999],
              [-159.20478268099993, -79.61785247199992],
              [-159.21650143099993, -79.63445403399993],
              [-159.2044571609999, -79.64421965899993],
              [-159.18915768099993, -79.65276458099993],
              [-158.9748429029999, -79.72234465899993],
              [-158.95844479099992, -79.73992278399993],
              [-158.9620255199999, -79.74570077899995],
              [-158.97667395699992, -79.75514088299991],
              [-158.97846432199992, -79.7619768209999],
              [-158.97431393099993, -79.7653947899999],
              [-158.96662350199992, -79.76767343499995],
              [-158.95307369699992, -79.76970794099992],
              [-158.99042721299992, -79.79021575299993],
              [-159.0032852859999, -79.79509856599992],
              [-159.0280655589999, -79.79949309699992],
              [-159.03595943899992, -79.80266692499993],
              [-159.05072994699992, -79.81292083099993],
              [-159.0579727859999, -79.81633879999993],
              [-159.0698136059999, -79.81878020599993],
              [-159.4805802074999, -79.82773202899993],
              [-159.8913468089999, -79.83668385199994],
              [-160.3021134104999, -79.84563567499994],
              [-160.7128800119999, -79.85458749799994],
              [-161.1743193566666, -79.79376935566661],
              [-161.63575870133326, -79.73295121333327],
              [-162.0971980459999, -79.67213307099993],
              [-162.55863739066658, -79.6113149286666],
              [-163.02007673533325, -79.55049678633326],
              [-163.48151607999992, -79.48967864399992],
              [-163.57087154899992, -79.45468515399995],
              [-163.9366348949999, -79.41171640399995],
              [-164.16095943899992, -79.33342864399992],
              [-164.30089270699992, -79.30193450299993],
              [-164.3265274729999, -79.2873674459999],
              [-164.31843014199993, -79.28801848799992],
              [-164.27643795499992, -79.2810197899999],
              [-164.2226456369999, -79.28573984199994],
              [-164.23395748599992, -79.27361419099992],
              [-164.24726314999992, -79.26279062299994],
              [-164.2978409499999, -79.23007577899995],
              [-164.30536861899992, -79.22014739399992],
              [-164.3007706369999, -79.20956796699994],
              [-164.28880774599992, -79.20256926899992],
              [-164.2806290359999, -79.19939544099992],
              [-164.2764786449999, -79.19378020599993],
              [-164.2768448559999, -79.17888762799993],
              [-164.28831946499992, -79.14267343499995],
              [-164.2892960279999, -79.13567473799992],
              [-164.2858780589999, -79.13225676899992],
              [-164.27513587099992, -79.12615325299993],
              [-164.27159583199992, -79.12078215899993],
              [-164.2708634109999, -79.11541106599992],
              [-164.2717179029999, -79.11012135199991],
              [-164.27546139199993, -79.09954192499993],
              [-164.23615475199992, -79.0993791649999],
              [-164.21532141799992, -79.09514739399992],
              [-164.2026261059999, -79.08407968499995],
              [-164.20470130099991, -79.07105885199991],
              [-164.21690833199992, -79.05868905999995],
              [-164.2327774729999, -79.04876067499993],
              [-164.24567623599992, -79.0432268209999],
              [-164.2385147779999, -79.03972747199992],
              [-164.21479244699992, -79.03142669099992],
              [-164.20148678299992, -79.02271900799991],
              [-164.17780514199993, -79.00351327899995],
              [-164.16315670499992, -78.99627044099992],
              [-164.14806067599991, -78.99212004999993],
              [-163.9924210279999, -78.96803150799991],
              [-163.98412024599992, -78.96542734199994],
              [-163.9772843089999, -78.96152109199994],
              [-163.96479244699992, -78.95183684699992],
              [-163.95787512899992, -78.94833749799994],
              [-163.94037838399993, -78.94353606599992],
              [-163.7940567699999, -78.93401458099993],
              [-163.7786759109999, -78.93035247199992],
              [-163.77521725199992, -78.92107512799993],
              [-163.83360755099991, -78.90691497199992],
              [-163.81830807199992, -78.89853280999995],
              [-163.77167721299992, -78.88738372199992],
              [-163.7366837229999, -78.87200286299992],
              [-163.7244766919999, -78.86858489399992],
              [-163.69102942599991, -78.86467864399992],
              [-163.67979895699992, -78.86207447699991],
              [-163.63849850199992, -78.84482187299994],
              [-163.48395748599992, -78.81121184699992],
              [-163.4706925119999, -78.8025041649999],
              [-163.3002823559999, -78.77337004999993],
              [-163.2650040359999, -78.75725676899992],
              [-163.27277584499993, -78.75302499799994],
              [-163.31098385299993, -78.7209611959999],
              [-163.24299068899992, -78.70631275799991],
              [-162.7981054349999, -78.72946542749992],
              [-162.35322018099993, -78.75261809699992],
              [-162.34186764199993, -78.75497812299994],
              [-162.3338516919999, -78.75994231599992],
              [-162.32160396999993, -78.77337004999993],
              [-162.31427975199992, -78.7790666649999],
              [-162.29649817599991, -78.78386809699992],
              [-162.14411373599992, -78.79241301899992],
              [-161.76301022049992, -78.87582773249991],
              [-161.38190670499992, -78.9592424459999],
              [-161.35614986899992, -78.9743791649999],
              [-161.35326087099992, -78.97771575299993],
              [-161.3666886059999, -78.98211028399993],
              [-161.37250729099992, -78.98577239399992],
              [-161.37336178299992, -78.99114348799992],
              [-161.36408443899992, -78.99684010199991],
              [-160.94300289599994, -79.09177011499992],
              [-160.52192135299993, -79.18670012799993],
              [-160.29487057199992, -79.26580169099992],
              [-160.11408443899992, -79.29290129999993],
              [-159.99335689999992, -79.32732512799993],
              [-159.8421524729999, -79.34856536299992],
            ],
          ],
          [
            [
              [-149.0186661449999, -77.48007577899995],
              [-149.20771236899992, -77.45671965899993],
              [-149.17467200399992, -77.44833749799994],
              [-149.1928604809999, -77.44654713299991],
              [-149.20160885299993, -77.44410572699991],
              [-149.2088516919999, -77.43987395599993],
              [-149.0947159499999, -77.42310963299991],
              [-149.05585689999992, -77.42156340899993],
              [-148.8320206369999, -77.44833749799994],
              [-148.8780411449999, -77.46233489399992],
              [-148.96996008999992, -77.47893645599993],
              [-149.0186661449999, -77.48007577899995],
            ],
          ],
          [
            [
              [-148.91889400899993, -77.38486093499995],
              [-148.9359024729999, -77.39332447699991],
              [-148.95893307199992, -77.39739348799992],
              [-149.39167232999992, -77.38225676899992],
              [-149.5799454419999, -77.33993905999995],
              [-149.6697891919999, -77.30437590899993],
              [-149.64008541599992, -77.29485442499993],
              [-149.62507076699993, -77.29558684699992],
              [-149.5815323559999, -77.30486419099992],
              [-149.5397843089999, -77.30429452899995],
              [-149.52802486899992, -77.30706145599993],
              [-149.54780025899993, -77.29802825299993],
              [-149.5971573559999, -77.28289153399993],
              [-149.49262447799993, -77.27337004999993],
              [-149.33641516799992, -77.2834611959999],
              [-149.25279700399992, -77.29843515399995],
              [-149.2361954419999, -77.30510833099993],
              [-149.2252091139999, -77.31552499799994],
              [-149.2249649729999, -77.31943124799994],
              [-149.2285050119999, -77.32724374799994],
              [-149.22797604099992, -77.33074309699992],
              [-149.2148331369999, -77.33953215899993],
              [-148.92988033799992, -77.37509530999995],
              [-148.91889400899993, -77.38486093499995],
            ],
          ],
          [
            [
              [-150.48379472599993, -77.34319426899992],
              [-150.45136471299992, -77.3479143209999],
              [-150.3499649729999, -77.3454729149999],
              [-150.36164303299992, -77.3557268209999],
              [-150.37511145699992, -77.36386484199994],
              [-150.3897598949999, -77.3693986959999],
              [-150.40448971299992, -77.37232838299991],
              [-150.49848385299993, -77.37558359199994],
              [-150.8307321169999, -77.34829409533326],
              [-151.16298038099993, -77.32100459866659],
              [-151.4952286449999, -77.29371510199991],
              [-151.51227779899992, -77.28525155999995],
              [-151.51146399599992, -77.27076588299991],
              [-151.49909420499992, -77.26311614399992],
              [-151.47992916599992, -77.2580705709999],
              [-151.1308487619999, -77.21738046699994],
              [-150.98517818899992, -77.22234465899993],
              [-150.54511471299992, -77.31487395599993],
              [-150.49982662699992, -77.33806731599992],
              [-150.48379472599993, -77.34319426899992],
            ],
          ],
          [
            [
              [-153.0472305979999, -77.2400041649999],
              [-153.04816646999993, -77.24325937299994],
              [-153.0502823559999, -77.24651458099993],
              [-153.05365963399993, -77.24993254999993],
              [-153.05842037699992, -77.25335051899992],
              [-153.08128821499992, -77.2619768209999],
              [-153.1087540359999, -77.26490650799991],
              [-153.41633053299992, -77.23162200299993],
              [-153.46760006399992, -77.21111419099992],
              [-153.43659420499992, -77.20281340899993],
              [-153.11628170499992, -77.20614999799994],
              [-153.07506262899992, -77.2165666649999],
              [-153.0549210279999, -77.2268205709999],
              [-153.0472305979999, -77.2400041649999],
            ],
          ],
          [
            [
              [-147.24958248599992, -77.18857187299994],
              [-147.1877335279999, -77.21021900799991],
              [-147.20376542899993, -77.21591562299994],
              [-147.3272598949999, -77.23235442499993],
              [-147.32355709499993, -77.23650481599992],
              [-147.3189591139999, -77.2400041649999],
              [-147.3136287099999, -77.24293385199991],
              [-147.30768795499992, -77.24472421699994],
              [-147.3441055979999, -77.25595468499995],
              [-147.38337154899992, -77.25904713299991],
              [-147.46076412699992, -77.2497697899999],
              [-147.45645097599993, -77.2483049459999],
              [-147.4527888659999, -77.2463518209999],
              [-147.44635982999992, -77.24138762799993],
              [-147.4759415359999, -77.23544687299994],
              [-147.4847712879999, -77.23186614399992],
              [-147.48884029899992, -77.22820403399993],
              [-147.4945369129999, -77.22144947699991],
              [-147.4975479809999, -77.21542734199994],
              [-147.49347896999993, -77.21363697699991],
              [-147.59113521999993, -77.1931291649999],
              [-147.60163326699993, -77.18434010199991],
              [-147.56651770699992, -77.16562265399995],
              [-147.51524817599991, -77.16130950299993],
              [-147.24958248599992, -77.18857187299994],
            ],
          ],
          [
            [
              [169.2734481130001, -77.45452239399992],
              [169.30933678500003, -77.46542734199994],
              [169.33961022200003, -77.47966887799993],
              [169.3593856130001, -77.49822356599992],
              [169.36443118600005, -77.52206796699994],
              [169.31820722700002, -77.53720468499995],
              [169.05030358200008, -77.56991952899995],
              [168.91228274800005, -77.63030364399992],
              [168.87256920700008, -77.6403947899999],
              [168.4008895190001, -77.69622161299992],
              [168.08741295700008, -77.64560312299994],
              [167.74773196700005, -77.64478932099993],
              [167.40805097700002, -77.64397551899992],
              [167.34498131600003, -77.66692473799992],
              [167.2837020190001, -77.70671965899993],
              [167.25766035200002, -77.71591562299994],
              [167.0688582690001, -77.74537525799991],
              [166.8935653000001, -77.79371510199991],
              [166.778656446, -77.84482187299994],
              [166.67725670700008, -77.85995859199994],
              [166.66480553500003, -77.85784270599993],
              [166.61451256600003, -77.83635833099993],
              [166.651703321, -77.80901458099993],
              [166.78931725400003, -77.76995208099993],
              [166.86540774800005, -77.71868254999993],
              [166.8906356130001, -77.71249765399995],
              [166.511078321, -77.72177499799994],
              [166.45337975400003, -77.71005624799994],
              [166.51050866000003, -77.70419687299994],
              [166.62777754, -77.70671965899993],
              [166.68311608200008, -77.69646575299993],
              [166.81421959700003, -77.69158294099992],
              [166.88038170700008, -77.67636484199994],
              [166.89568118600005, -77.67571379999993],
              [166.87525475400003, -77.67034270599993],
              [166.3886824880001, -77.61337655999995],
              [166.36540774800005, -77.60702890399995],
              [166.34839928500003, -77.59856536299992],
              [166.3169051440001, -77.57773202899995],
              [166.2998153000001, -77.56951262799993],
              [166.27849368600005, -77.56585051899992],
              [166.23511803500003, -77.56731536299992],
              [166.21371504, -77.56365325299993],
              [166.176605665, -77.53679778399993],
              [166.16553795700008, -77.53484465899993],
              [166.21648196700005, -77.52092864399992],
              [166.37061608200008, -77.49822356599992],
              [166.40162194100003, -77.48544687299994],
              [166.47681725400003, -77.43124765399995],
              [166.65447024800005, -77.36256275799991],
              [166.676117384, -77.35995859199994],
              [166.601898634, -77.33652109199994],
              [166.57585696700005, -77.33212655999995],
              [166.5478621750001, -77.31340911299992],
              [166.40007571700005, -77.26653411299992],
              [166.45191491000003, -77.21233489399992],
              [166.5244246750001, -77.18303801899992],
              [166.67945397200003, -77.16334400799991],
              [166.8271590500001, -77.16090260199991],
              [166.97331790500004, -77.18222421699994],
              [167.02906334700003, -77.20378997199992],
              [167.08814537900003, -77.24065520599993],
              [167.11312910200002, -77.28191497199992],
              [167.065765821, -77.31633879999993],
              [167.0688582690001, -77.31585051899992],
              [167.070648634, -77.31601327899995],
              [167.07097415500004, -77.31658294099992],
              [167.069672071, -77.31764088299991],
              [167.139008009, -77.34189218499995],
              [167.56812584700003, -77.41326262799993],
              [167.89385013100002, -77.39279550549992],
              [168.219574415, -77.37232838299991],
              [168.68181399850005, -77.40203215899993],
              [169.14405358200008, -77.43173593499995],
              [169.2734481130001, -77.45452239399992],
            ],
          ],
          [
            [
              [-154.5618790359999, -77.1135393209999],
              [-154.5529679029999, -77.10051848799992],
              [-154.52464758999992, -77.0896135399999],
              [-154.43354244699992, -77.0725236959999],
              [-154.28400631399992, -77.06414153399993],
              [-154.12824459499993, -77.07822030999995],
              [-154.05512447799993, -77.09726327899995],
              [-154.0494278639999, -77.10027434699992],
              [-154.04523678299992, -77.10466887799993],
              [-154.04023189999992, -77.11207447699991],
              [-154.0357559889999, -77.13005950299993],
              [-154.04816646999993, -77.13746510199991],
              [-154.18712317599991, -77.15439218499995],
              [-154.5124405589999, -77.13551197699991],
              [-154.5417374339999, -77.12688567499993],
              [-154.54987545499992, -77.12346770599993],
              [-154.5557755199999, -77.12004973799992],
              [-154.55976314999992, -77.11687590899993],
              [-154.5618790359999, -77.1135393209999],
            ],
          ],
          [
            [
              [166.9150496750001, -76.93132903399993],
              [166.95655358200008, -76.93840911299992],
              [166.97730553500003, -76.95061614399992],
              [166.97730553500003, -76.9626604149999],
              [166.87224368600005, -76.9729143209999],
              [166.87232506600003, -76.9626604149999],
              [166.86646569100003, -76.94793059699992],
              [166.85328209700003, -76.93621184699992],
              [166.85466556100005, -76.92913176899992],
              [166.8740340500001, -76.92644622199992],
              [166.9150496750001, -76.93132903399993],
            ],
          ],
          [
            [
              [-148.5335587229999, -76.94963958099993],
              [-148.44574947799993, -76.9729143209999],
              [-148.43517005099991, -76.97372812299994],
              [-148.45380611899992, -76.99163176899992],
              [-148.4811905589999, -77.00115325299993],
              [-148.93993079299992, -77.02800872199992],
              [-149.2390030589999, -76.9963518209999],
              [-149.26264400899993, -76.98723723799992],
              [-149.27497311099992, -76.97014739399992],
              [-149.2718399729999, -76.96559010199991],
              [-149.27009029899992, -76.95696379999993],
              [-149.26764889199993, -76.95077890399995],
              [-149.28339596299992, -76.94101327899995],
              [-149.29576575399992, -76.93092213299991],
              [-149.30341549399992, -76.92115650799991],
              [-149.30479895699992, -76.91204192499993],
              [-149.21589107999992, -76.89763762799993],
              [-148.87472490149992, -76.92363860449993],
              [-148.5335587229999, -76.94963958099993],
            ],
          ],
          [
            [
              [-149.7287491529999, -77.12948984199994],
              [-149.83735104099992, -77.12314218499995],
              [-149.80512447799993, -77.11012135199991],
              [-149.79539954299992, -77.10442473799992],
              [-149.80964107999992, -77.10654062299994],
              [-149.87201900899993, -77.09840260199991],
              [-150.14679928249993, -77.09408945099992],
              [-150.42157955599993, -77.08977629999993],
              [-150.5826309889999, -77.0373674459999],
              [-150.78266354099992, -77.00693124799994],
              [-150.8011368479999, -76.9900041649999],
              [-150.7962540359999, -76.97869231599992],
              [-150.78254146999993, -76.97079843499995],
              [-150.64622962099992, -76.94247812299994],
              [-150.41901607999992, -76.92205169099992],
              [-150.42829342399992, -76.91179778399993],
              [-150.4439591139999, -76.90007903399993],
              [-150.46100826699993, -76.89137135199991],
              [-150.4748429029999, -76.89080169099992],
              [-150.45612545499992, -76.88486093499995],
              [-150.3947647779999, -76.87753671699994],
              [-150.39240475199992, -76.88152434699992],
              [-150.3929337229999, -76.90715911299992],
              [-149.96259518099993, -76.87070077899995],
              [-149.84003658799992, -76.87802499799994],
              [-149.77326412699992, -76.8943010399999],
              [-149.75865637899992, -76.92538827899995],
              [-149.69465084499993, -76.93621184699992],
              [-149.4428604809999, -77.02499765399995],
              [-149.44550533799992, -77.02988046699994],
              [-149.44880123599992, -77.03427499799994],
              [-149.45685787699992, -77.04241301899992],
              [-149.45124264199993, -77.04989999799994],
              [-149.44306393099993, -77.05510833099993],
              [-149.42487545499992, -77.0622697899999],
              [-149.43464107999992, -77.07089609199994],
              [-149.4448136059999, -77.07822030999995],
              [-149.33149166599992, -77.08513762799993],
              [-149.2740372389999, -77.09726327899995],
              [-149.22435462099992, -77.11809661299992],
              [-149.2499893869999, -77.13201262799993],
              [-149.30805416599992, -77.13958098799992],
              [-149.72866777299993, -77.12948984199994],
              [-149.7287491529999, -77.12948984199994],
            ],
          ],
          [
            [
              [-146.1647843089999, -76.93132903399993],
              [-146.1542048819999, -76.93792083099993],
              [-146.1429337229999, -76.94296640399995],
              [-146.1190486319999, -76.94963958099993],
              [-146.1376846999999, -76.95777760199991],
              [-146.1581925119999, -76.95867278399993],
              [-146.2724503249999, -76.94060637799993],
              [-146.29698645699992, -76.93254973799992],
              [-146.33287512899992, -76.91326262799993],
              [-146.3284805979999, -76.91179778399993],
              [-146.32428951699993, -76.90976327899995],
              [-146.31672115799992, -76.90496184699992],
              [-146.32233639199993, -76.90488046699994],
              [-146.34618079299992, -76.8947893209999],
              [-146.36876380099991, -76.89120859199994],
              [-146.3862198559999, -76.8908830709999],
              [-146.3956599599999, -76.89218515399995],
              [-146.4046931629999, -76.89495208099993],
              [-146.41331946499992, -76.89999765399995],
              [-146.4096573559999, -76.90829843499995],
              [-146.4071345689999, -76.91179778399993],
              [-146.4036759109999, -76.91480885199991],
              [-146.41380774599992, -76.92262135199991],
              [-146.4173477859999, -76.92449309699992],
              [-146.4155167309999, -76.9260393209999],
              [-146.4125056629999, -76.93027109199994],
              [-146.4111221999999, -76.93173593499995],
              [-146.4792374339999, -76.94988372199992],
              [-146.9648331369999, -77.00709400799991],
              [-147.0314835279999, -77.00530364399992],
              [-147.09479732999992, -76.98992278399993],
              [-147.05142167899993, -76.97926197699991],
              [-147.0405167309999, -76.97478606599992],
              [-147.00934811099992, -76.95663827899995],
              [-147.03254146999993, -76.9294572899999],
              [-147.04381262899992, -76.92148202899995],
              [-147.13019771999993, -76.88176848799992],
              [-147.10065670499992, -76.86101653399993],
              [-147.0900772779999, -76.8552385399999],
              [-147.1260880199999, -76.83945077899995],
              [-147.10399329299992, -76.82854583099993],
              [-147.0721329419999, -76.82390715899993],
              [-146.6609390939999, -76.85243092199994],
              [-146.24974524599992, -76.88095468499995],
              [-146.24107825399992, -76.88632577899995],
              [-146.2366837229999, -76.89324309699992],
              [-146.22907467399992, -76.89609140399995],
              [-146.2120255199999, -76.89763762799993],
              [-146.2025040359999, -76.90154387799993],
              [-146.19465084499993, -76.90642669099992],
              [-146.1647843089999, -76.93132903399993],
            ],
          ],
          [
            [
              [-148.5295304029999, -76.79656340899993],
              [-148.71625729099992, -76.80535247199992],
              [-148.7303360669999, -76.80917734199994],
              [-148.73993893099993, -76.81487395599993],
              [-148.75654049399992, -76.82976653399993],
              [-148.7658585279999, -76.83562590899993],
              [-148.77717037699992, -76.83904387799993],
              [-148.9271134109999, -76.84978606599992],
              [-149.15448971299992, -76.8361955709999],
              [-149.49071204299992, -76.76685963299991],
              [-149.4037979809999, -76.73186614399992],
              [-149.35236568899992, -76.71941497199992],
              [-149.30980383999992, -76.71404387799993],
              [-149.0552262034999, -76.72539641699993],
              [-148.8006485669999, -76.73674895599993],
              [-148.78795325399992, -76.73447030999995],
              [-148.77912350199992, -76.7307268209999],
              [-148.76325436099992, -76.7209611959999],
              [-148.7546280589999, -76.7170549459999],
              [-148.7470596999999, -76.71599700299993],
              [-148.40937252499992, -76.73870208099993],
              [-148.32648678299992, -76.75676848799992],
              [-148.30890865799992, -76.76555754999993],
              [-148.35676021999993, -76.79412200299993],
              [-148.41376705599993, -76.80185312299994],
              [-148.5295304029999, -76.79656340899993],
            ],
          ],
          [
            [
              [-150.23261471299992, -76.77752044099992],
              [-150.6017960279999, -76.7966447899999],
              [-150.8155411449999, -76.7697893209999],
              [-150.87547766799992, -76.7404924459999],
              [-150.86774654899992, -76.72942473799992],
              [-150.85118567599991, -76.71892669099992],
              [-150.8276261059999, -76.71038176899992],
              [-150.51681474499992, -76.69858163849992],
              [-150.20600338399993, -76.68678150799991],
              [-150.0917862619999, -76.7087541649999],
              [-150.0939835279999, -76.71428801899992],
              [-150.09727942599991, -76.71965911299992],
              [-150.10509192599991, -76.72926197699991],
              [-150.0989884109999, -76.73259856599992],
              [-150.07807369699992, -76.73845794099992],
              [-150.11302649599992, -76.75660572699991],
              [-150.15253658799992, -76.76702239399992],
              [-150.23261471299992, -76.77752044099992],
            ],
          ],
          [
            [
              [-148.71747799399992, -76.70720794099992],
              [-148.7374161449999, -76.70330169099992],
              [-148.77399654899992, -76.70012786299992],
              [-148.78986568899992, -76.70191822699991],
              [-148.94379635299993, -76.68523528399993],
              [-149.13569088399993, -76.63811614399992],
              [-149.14850826699993, -76.6369768209999],
              [-148.99693762899992, -76.60751718499995],
              [-148.81147213399993, -76.61191171699994],
              [-148.4678848949999, -76.67717864399992],
              [-148.47077389199993, -76.67742278399993],
              [-148.4720352859999, -76.67766692499993],
              [-148.47162838399993, -76.67815520599993],
              [-148.4694718089999, -76.67880624799994],
              [-148.51813717399992, -76.69597747199992],
              [-148.57770748599992, -76.70549895599993],
              [-148.71747799399992, -76.70720794099992],
            ],
          ],
          [
            [
              [-147.7297664049999, -76.65447356599992],
              [-147.99233964799993, -76.59905364399992],
              [-147.99087480399993, -76.59758879999993],
              [-147.9877823559999, -76.59343840899993],
              [-147.98607337099992, -76.59189218499995],
              [-147.99469967399992, -76.58066171699994],
              [-148.0007218089999, -76.57512786299992],
              [-148.00617428299992, -76.57366301899992],
              [-147.94684811099992, -76.55982838299991],
              [-147.88402258999992, -76.55868905999995],
              [-147.7315974599999, -76.58440520599993],
              [-147.6216934889999, -76.62102629999993],
              [-147.55980383999992, -76.66285572699991],
              [-147.63634192599991, -76.66659921699994],
              [-147.7297664049999, -76.65447356599992],
            ],
          ],
          [
            [
              [-146.81033281199993, -76.5959611959999],
              [-146.8104141919999, -76.5959611959999],
              [-146.8198136059999, -76.60222747199992],
              [-146.7971085279999, -76.6096330709999],
              [-146.7759903639999, -76.62118905999995],
              [-146.7592667309999, -76.63339609199994],
              [-146.7498673169999, -76.6384416649999],
              [-146.74034583199992, -76.63990650799991],
              [-146.78579667899993, -76.64885833099993],
              [-146.80109615799992, -76.65007903399993],
              [-147.0638321609999, -76.62810637799993],
              [-147.04987545499992, -76.63420989399992],
              [-146.9349259109999, -76.65545012799993],
              [-146.9518936839999, -76.65862395599993],
              [-147.00519771999993, -76.6599260399999],
              [-146.9957576159999, -76.66415780999995],
              [-146.9655655589999, -76.66936614399992],
              [-146.91966712099992, -76.68434010199991],
              [-146.8397110669999, -76.70110442499993],
              [-146.8932999339999, -76.71453215899993],
              [-146.95128333199992, -76.71697356599992],
              [-147.0646866529999, -76.70517343499995],
              [-147.2736710279999, -76.66090260199991],
              [-147.28441321499992, -76.65496184699992],
              [-147.30247962099992, -76.63925546699994],
              [-147.31261145699992, -76.63209400799991],
              [-147.32506262899992, -76.62664153399993],
              [-147.3654679029999, -76.6174455709999],
              [-147.34316972599993, -76.60507577899995],
              [-147.33039303299992, -76.60003020599993],
              [-147.3198136059999, -76.60027434699992],
              [-147.3434138659999, -76.58668385199991],
              [-147.35212154899992, -76.58318450299993],
              [-147.34162350199992, -76.58074309699992],
              [-147.3102107409999, -76.5798479149999],
              [-147.26960201699993, -76.57048919099992],
              [-147.26008053299992, -76.57244231599992],
              [-147.27940833199992, -76.55584075299993],
              [-147.27074133999992, -76.54753997199992],
              [-147.26134192599991, -76.54119231599992],
              [-147.31956946499992, -76.53191497199992],
              [-147.2980037099999, -76.51718515399995],
              [-147.2701309889999, -76.50896575299993],
              [-147.2406306629999, -76.50546640399995],
              [-147.1600235669999, -76.50465260199991],
              [-147.0932511059999, -76.51409270599993],
              [-147.07990475199992, -76.51864999799994],
              [-147.08796139199993, -76.52499765399995],
              [-147.0980525379999, -76.53036874799994],
              [-147.10895748599992, -76.53329843499995],
              [-147.11921139199993, -76.53215911299992],
              [-147.08600826699993, -76.54802825299993],
              [-147.06602942599991, -76.55217864399992],
              [-147.04523678299992, -76.55234140399995],
              [-146.93960527299993, -76.54168059699992],
              [-146.9197891919999, -76.54583098799992],
              [-146.95750891799992, -76.56308359199994],
              [-146.97044837099992, -76.56707122199992],
              [-146.9482315749999, -76.56511809699992],
              [-146.81582597599993, -76.58074309699992],
              [-146.79841061099992, -76.58831145599993],
              [-146.81033281199993, -76.5959611959999],
            ],
          ],
          [
            [
              [-147.4604792959999, -76.09775155999995],
              [-147.43879146999993, -76.07870859199994],
              [-147.4075821609999, -76.06853606599992],
              [-147.3450821609999, -76.0622697899999],
              [-147.0714005199999, -76.0759416649999],
              [-146.90831458199992, -76.10702890399995],
              [-146.89464270699992, -76.11443450299993],
              [-146.8857315749999, -76.12395598799992],
              [-146.87779700399992, -76.1345354149999],
              [-146.86729895699992, -76.14519622199992],
              [-146.85773678299992, -76.15113697699991],
              [-146.7030330069999, -76.20468515399995],
              [-146.7010798819999, -76.21949635199991],
              [-146.6710505849999, -76.25847747199992],
              [-146.6612849599999, -76.27556731599992],
              [-146.70929928299992, -76.2927385399999],
              [-146.7601619129999, -76.29802825299993],
              [-146.81183834499993, -76.29485442499993],
              [-147.0620011059999, -76.24675872199992],
              [-147.08604895699992, -76.23560963299991],
              [-147.07542883999992, -76.23739999799994],
              [-147.0595596999999, -76.23479583099993],
              [-147.03209387899992, -76.2268205709999],
              [-147.07355709499993, -76.20964934699992],
              [-147.3819473949999, -76.16057708099993],
              [-147.40412350199992, -76.15007903399993],
              [-147.3974503249999, -76.15032317499993],
              [-147.3714493479999, -76.14251067499993],
              [-147.32697506399992, -76.14128997199992],
              [-147.4380997389999, -76.09775155999995],
              [-147.4604792959999, -76.09775155999995],
            ],
          ],
          [
            [
              [162.91716556100005, -75.55828215899993],
              [162.95671634200005, -75.55315520599993],
              [162.97234134200005, -75.55486419099992],
              [162.9775496750001, -75.56503671699994],
              [162.97193444100003, -75.57317473799992],
              [162.89861087300005, -75.61980559699992],
              [162.8872176440001, -75.63005950299993],
              [162.8837996750001, -75.63632577899995],
              [162.8808699880001, -75.64902109199994],
              [162.87818444100003, -75.65439218499995],
              [162.87183678500003, -75.65886809699992],
              [162.85474694100003, -75.66399504999993],
              [162.84717858200008, -75.66725025799991],
              [162.84050540500004, -75.67278411299992],
              [162.82886803500003, -75.68466562299994],
              [162.82211347700002, -75.68962981599992],
              [162.8134871750001, -75.69329192499993],
              [162.80347741000003, -75.69573333099993],
              [162.7421981130001, -75.70183684699992],
              [162.635101759, -75.69003671699994],
              [162.60271243600005, -75.67962004999993],
              [162.576508009, -75.66277434699992],
              [162.7177840500001, -75.60344817499993],
              [162.73552493600005, -75.58660247199992],
              [162.76783287900003, -75.57610442499993],
              [162.9170028000001, -75.55828215899993],
              [162.91716556100005, -75.55828215899993],
            ],
          ],
          [
            [
              [-145.44037838399993, -75.58001067499993],
              [-145.40876217399992, -75.58993905999995],
              [-145.3486221999999, -75.61630624799994],
              [-145.26378333199992, -75.66814544099992],
              [-145.2307022779999, -75.6814104149999],
              [-145.20079505099991, -75.6858049459999],
              [-145.2189835279999, -75.70452239399992],
              [-145.2445369129999, -75.71477629999993],
              [-145.27285722599993, -75.71933359199994],
              [-145.3830460279999, -75.71803150799991],
              [-145.69939124249993, -75.6694475239999],
              [-146.01573645699992, -75.6208635399999],
              [-146.1240128249999, -75.58896249799994],
              [-146.15477454299992, -75.5744768209999],
              [-146.15977942599991, -75.56975676899992],
              [-146.13735917899993, -75.55462004999993],
              [-146.11115475199992, -75.5427385399999],
              [-145.9697159499999, -75.50945403399993],
              [-145.8707576159999, -75.50457122199992],
              [-145.72423255099991, -75.51832447699991],
              [-145.44037838399993, -75.58001067499993],
            ],
          ],
          [
            [
              [162.48796634200005, -75.45720794099992],
              [162.53150475400003, -75.42652760199991],
              [162.5708113940001, -75.42294687299994],
              [162.60124759200005, -75.43678150799991],
              [162.61784915500004, -75.45916106599992],
              [162.5722762380001, -75.48113372199992],
              [162.5337020190001, -75.48406340899993],
              [162.50464928500003, -75.47405364399992],
              [162.48796634200005, -75.45720794099992],
            ],
          ],
          [
            [
              [-132.57115637899994, -74.3884416649999],
              [-132.49657141799992, -74.3850236959999],
              [-132.4217016269999, -74.39853280999995],
              [-132.35781816299993, -74.40195077899995],
              [-132.34227454299992, -74.40447356599992],
              [-132.36953691299993, -74.41643645599993],
              [-132.37730872299994, -74.42180754999993],
              [-132.36754309799994, -74.42734140399995],
              [-132.36367753799993, -74.42831796699994],
              [-132.37584387899994, -74.43816497199992],
              [-132.4378149079999, -74.45745208099993],
              [-132.47720292899993, -74.48650481599992],
              [-132.53184973899994, -74.49895598799992],
              [-132.58975175699993, -74.50107187299994],
              [-132.85753333199995, -74.4709611959999],
              [-132.8835343089999, -74.45989348799992],
              [-132.8662817049999, -74.45029062299994],
              [-132.85594641799992, -74.44687265399995],
              [-132.84776770699995, -74.44687265399995],
              [-132.88585364499994, -74.42962004999993],
              [-132.8985082669999, -74.42636484199994],
              [-132.86583411399994, -74.42839934699992],
              [-132.83702551999994, -74.42636484199994],
              [-132.81554114499994, -74.42099374799994],
              [-132.80516516799992, -74.41269296699994],
              [-132.74600175699993, -74.41545989399992],
              [-132.57115637899994, -74.3884416649999],
            ],
          ],
          [
            [
              [-130.92048092399995, -74.44426848799992],
              [-130.92747962099992, -74.44890715899993],
              [-130.9356176419999, -74.4528947899999],
              [-130.95230058499993, -74.45891692499993],
              [-130.9514054029999, -74.47014739399992],
              [-130.9577530589999, -74.49928150799991],
              [-130.95665442599994, -74.51376718499995],
              [-130.96475175699993, -74.5193010399999],
              [-130.96861731699994, -74.52019622199992],
              [-130.97183183499993, -74.52044036299992],
              [-130.9780167309999, -74.5236955709999],
              [-130.97695878799993, -74.52597421699994],
              [-130.9734594389999, -74.53045012799993],
              [-130.9727270169999, -74.53248463299991],
              [-131.0385636059999, -74.56910572699991],
              [-131.0808813139999, -74.58220794099992],
              [-131.07896887899994, -74.58326588299991],
              [-131.08067786399994, -74.58863697699991],
              [-131.0842992829999, -74.59490325299993],
              [-131.08824622299994, -74.59905364399992],
              [-131.09805253799993, -74.60230885199991],
              [-131.20592200399994, -74.60711028399993],
              [-131.46729488849994, -74.57219817499993],
              [-131.72866777299993, -74.53728606599992],
              [-131.7666723299999, -74.53972747199992],
              [-131.81847083199995, -74.55234140399995],
              [-131.84605872299994, -74.55429452899995],
              [-131.86709550699993, -74.5446916649999],
              [-131.8714086579999, -74.53655364399992],
              [-131.88341223899994, -74.52792734199994],
              [-131.8975317049999, -74.52076588299991],
              [-131.90807044199994, -74.51751067499993],
              [-132.0283096999999, -74.50465260199991],
              [-132.0827530589999, -74.49114348799992],
              [-132.08055579299992, -74.48886484199994],
              [-132.0576065749999, -74.4782854149999],
              [-132.02204342399995, -74.46998463299991],
              [-132.01207434799994, -74.46542734199994],
              [-132.02871660099993, -74.46786874799994],
              [-132.04991614499994, -74.46160247199992],
              [-132.1070043609999, -74.43629322699991],
              [-132.15908769399994, -74.42392343499995],
              [-132.18126380099994, -74.42376067499993],
              [-132.01675370999993, -74.38152434699992],
              [-132.0143936839999, -74.37859465899993],
              [-132.00357011599993, -74.37037525799991],
              [-131.98167883999992, -74.35955169099992],
              [-131.80626380099994, -74.32195403399993],
              [-131.72191321499992, -74.32439544099992],
              [-131.68370520699995, -74.32048919099992],
              [-131.67125403599994, -74.32122161299992],
              [-131.64248613199993, -74.3318010399999],
              [-131.6323136059999, -74.3337541649999],
              [-131.58145097599993, -74.32976653399993],
              [-131.56411699099993, -74.33123137799993],
              [-131.5742895169999, -74.3376604149999],
              [-131.6123754549999, -74.34889088299991],
              [-131.58836829299992, -74.3650041649999],
              [-131.55321204299992, -74.37509530999995],
              [-131.12755286399994, -74.42791106599992],
              [-130.98375403599994, -74.41082122199992],
              [-130.9689835279999, -74.41277434699992],
              [-130.95954342399995, -74.41659921699994],
              [-130.95738684799994, -74.42083098799992],
              [-130.95669511599993, -74.42644622199992],
              [-130.95181230399993, -74.43434010199991],
              [-130.94517981699994, -74.43873463299991],
              [-130.92048092399995, -74.44426848799992],
            ],
          ],
          [
            [
              [-127.1284887359999, -74.46941497199992],
              [-127.12901770699995, -74.47665780999995],
              [-127.13385982999989, -74.48308684699992],
              [-127.1414281889999, -74.48821379999993],
              [-127.19041907499991, -74.5114885399999],
              [-127.22667395699995, -74.52271900799991],
              [-127.2339574859999, -74.53093840899993],
              [-127.17381751199991, -74.55429452899995],
              [-127.17935136599993, -74.56113046699994],
              [-127.20425370999993, -74.57350025799991],
              [-127.20348059799994, -74.5744768209999],
              [-127.2007543609999, -74.57732512799993],
              [-127.21593176999994, -74.5881486959999],
              [-127.41588294199994, -74.63551197699991],
              [-127.50625566299993, -74.64617278399993],
              [-127.55174719999991, -74.64364999799994],
              [-127.90562903599994, -74.5529924459999],
              [-127.89964758999992, -74.5485979149999],
              [-127.8958227199999, -74.54192473799992],
              [-127.89513098899994, -74.53443775799991],
              [-127.8985082669999, -74.5276018209999],
              [-127.91063391799992, -74.52157968499995],
              [-127.94326738199993, -74.51425546699994],
              [-127.95417232999989, -74.50497812299994],
              [-127.97765051999994, -74.49928150799991],
              [-127.98884029899995, -74.49488697699991],
              [-127.99290930899991, -74.49114348799992],
              [-127.99522864499994, -74.48772551899992],
              [-128.01870683499993, -74.4821916649999],
              [-128.08824622299994, -74.4885393209999],
              [-128.10912024599992, -74.47779713299991],
              [-128.10220292899993, -74.47714609199994],
              [-128.0733129549999, -74.46738046699994],
              [-128.0659073559999, -74.46233489399992],
              [-128.06924394399994, -74.45045338299991],
              [-128.08324133999992, -74.44068775799991],
              [-128.0996801419999, -74.43271249799994],
              [-128.11070716099994, -74.4255510399999],
              [-128.1083878249999, -74.42180754999993],
              [-128.10142981699994, -74.41765715899993],
              [-128.09874426999994, -74.41204192499993],
              [-128.10899817599994, -74.40447356599992],
              [-128.13927161399994, -74.40203215899993],
              [-128.13255774599992, -74.39397551899992],
              [-128.1328832669999, -74.3884416649999],
              [-128.1487524079999, -74.36736419099992],
              [-128.15542558499993, -74.35035572699991],
              [-128.15953528599994, -74.34441497199992],
              [-128.18248450399994, -74.3239885399999],
              [-128.18919837099992, -74.31609465899993],
              [-128.17540442599994, -74.30510833099993],
              [-128.13784745999993, -74.30348072699991],
              [-127.75804602799991, -74.34270598799992],
              [-127.50401770699995, -74.40471770599993],
              [-127.43419348899994, -74.41106536299992],
              [-127.36856035099993, -74.40374114399992],
              [-127.3379613919999, -74.4045549459999],
              [-127.23599199099993, -74.42343515399995],
              [-127.22435462099992, -74.4275041649999],
              [-127.21727454299992, -74.43271249799994],
              [-127.20714270699995, -74.44540780999995],
              [-127.20059160099993, -74.45045338299991],
              [-127.1851293609999, -74.45387135199991],
              [-127.15184485599991, -74.45256926899992],
              [-127.13719641799992, -74.45818450299993],
              [-127.13385982999989, -74.46103280999995],
              [-127.13125566299993, -74.46396249799994],
              [-127.12954667899993, -74.46672942499993],
              [-127.1284887359999, -74.46941497199992],
            ],
          ],
          [
            [
              [-117.16852779899995, -74.35637786299992],
              [-117.28213456899994, -74.37737395599993],
              [-117.3386938139999, -74.37753671699994],
              [-117.39557857999989, -74.36614348799992],
              [-117.36123613199993, -74.32878997199992],
              [-117.31151282499991, -74.30925872199992],
              [-117.02505449099993, -74.28093840899993],
              [-116.99396725199995, -74.2829729149999],
              [-116.96812903599994, -74.29192473799992],
              [-117.06607011599993, -74.33025481599992],
              [-117.16852779899995, -74.35637786299992],
            ],
          ],
          [
            [
              [-132.1218969389999, -74.14959075299993],
              [-132.1440323559999, -74.16757577899995],
              [-132.17467200399994, -74.17310963299991],
              [-132.23497473899994, -74.16708749799994],
              [-132.2744034499999, -74.15764739399992],
              [-132.2951554029999, -74.14788176899992],
              [-132.30052649599992, -74.13494231599992],
              [-132.2769262359999, -74.12981536299992],
              [-132.22866777299993, -74.12590911299992],
              [-132.1848852199999, -74.12932708099993],
              [-132.13902747299994, -74.14080169099992],
              [-132.1218969389999, -74.14959075299993],
            ],
          ],
          [
            [
              [-116.1406957669999, -73.90252044099992],
              [-116.19810950399994, -73.93840911299992],
              [-116.33495032499991, -73.97356536299992],
              [-116.4903051419999, -74.03378671699994],
              [-116.61925208199995, -74.05592213299991],
              [-116.64964758999992, -74.06560637799993],
              [-116.50426184799994, -74.08196379999993],
              [-116.48574785099993, -74.08147551899992],
              [-116.52212480399993, -74.10540129999993],
              [-116.59935462099992, -74.14177825299993],
              [-116.78506425699993, -74.17424895599993],
              [-117.19640051999994, -74.20029062299994],
              [-117.29723059799994, -74.18417734199994],
              [-117.33218339799993, -74.17441171699994],
              [-117.3733617829999, -74.15789153399993],
              [-117.40025794199994, -74.13250090899993],
              [-117.39273027299993, -74.09628671699994],
              [-117.37108313699991, -74.07976653399993],
              [-116.8872371084999, -73.97352467199994],
              [-116.40339107999989, -73.86728280999995],
              [-116.31517493399991, -73.86484140399995],
              [-116.1406957669999, -73.90252044099992],
            ],
          ],
          [
            [
              [-119.82103430899991, -74.12078215899993],
              [-119.88914954299992, -74.11191171699994],
              [-119.92292232999989, -74.1013322899999],
              [-119.92955481699994, -74.08464934699992],
              [-119.91148841099994, -74.07097747199992],
              [-119.88658606699994, -74.06503671699994],
              [-119.83702551999994, -74.05950286299992],
              [-119.83739173099991, -74.05722421699994],
              [-119.8355199859999, -74.05144622199992],
              [-119.83071855399993, -74.04143645599993],
              [-119.82721920499989, -74.03834400799991],
              [-119.8186742829999, -74.03435637799993],
              [-119.80150305899991, -74.02874114399992],
              [-119.78823808499993, -74.02629973799992],
              [-119.6966039699999, -74.02044036299992],
              [-119.66421464799993, -74.01458098799992],
              [-119.63609778599994, -74.00123463299991],
              [-119.64785722599993, -73.98935312299994],
              [-119.66567949099993, -73.97926197699991],
              [-119.7610570949999, -73.94719817499993],
              [-119.7766820949999, -73.9392229149999],
              [-119.7835180329999, -73.92986419099992],
              [-119.79067949099993, -73.90667083099993],
              [-119.79747473899994, -73.89666106599992],
              [-119.81163489499994, -73.88795338299991],
              [-119.85814368399991, -73.87656015399995],
              [-119.83576412699995, -73.86907317499993],
              [-119.78905188699991, -73.86199309699992],
              [-119.76768958199995, -73.85116952899995],
              [-119.88939368399991, -73.83310312299994],
              [-119.90355383999992, -73.82496510199991],
              [-119.69847571499992, -73.81829192499993],
              [-119.5808813139999, -73.78630950299993],
              [-119.4949438139999, -73.77255624799994],
              [-119.12340247299994, -73.78085702899995],
              [-118.97443600199995, -73.80486419099992],
              [-118.9141332669999, -73.82740650799991],
              [-118.90542558499993, -73.83277760199991],
              [-118.8997289699999, -73.83945077899995],
              [-118.89806067599994, -73.84807708099993],
              [-118.9019262359999, -73.86484140399995],
              [-118.90078691299993, -73.87322356599992],
              [-118.89517167899993, -73.87981536299992],
              [-118.88744055899991, -73.8825822899999],
              [-118.87083899599992, -73.88567473799992],
              [-118.94786536399994, -73.92156340899993],
              [-118.96349036399994, -73.93092213299991],
              [-118.96328691299993, -73.93710702899995],
              [-118.94566809799994, -73.94988372199992],
              [-118.97248287699995, -73.96868254999993],
              [-119.00377356699994, -73.98357512799993],
              [-119.22313391799992, -74.04412200299993],
              [-119.43138587099992, -74.06731536299992],
              [-119.4475805329999, -74.07236093499995],
              [-119.45860755099994, -74.08066171699994],
              [-119.46849524599992, -74.09026458099993],
              [-119.48106848899994, -74.09970468499995],
              [-119.5000707669999, -74.10662200299993],
              [-119.69570878799993, -74.12558359199994],
              [-119.82103430899991, -74.12078215899993],
            ],
          ],
          [
            [
              [-120.26121985599991, -73.92782968499995],
              [-120.26756751199991, -73.93010833099993],
              [-120.29051673099991, -73.94638437299994],
              [-120.29588782499991, -73.95232512799993],
              [-120.25845292899993, -73.9587541649999],
              [-120.24079342399995, -73.96672942499993],
              [-120.23729407499991, -73.98154062299994],
              [-120.24364173099991, -73.98919036299992],
              [-120.25426184799994, -73.99537525799991],
              [-120.27554277299993, -74.00318775799991],
              [-120.63978023999994, -74.07577890399992],
              [-121.00401770699995, -74.14837004999993],
              [-121.02721106699994, -74.15585702899995],
              [-121.04710852799991, -74.16708749799994],
              [-121.05406653599994, -74.17669036299992],
              [-121.05186926999994, -74.19443124799994],
              [-121.05724036399994, -74.2033830709999],
              [-121.0386449859999, -74.21648528399993],
              [-121.03359941299993, -74.22307708099993],
              [-121.03966223899994, -74.23040129999993],
              [-121.04954993399991, -74.23308684699992],
              [-121.07445227799991, -74.2326799459999],
              [-121.08543860599991, -74.2346330709999],
              [-121.08018958199995, -74.24480559699992],
              [-121.05772864499994, -74.25676848799992],
              [-121.04942786399994, -74.26555754999993],
              [-121.06017005099994, -74.27117278399993],
              [-121.07188880099994, -74.27556731599992],
              [-121.05882727799991, -74.28362395599993],
              [-120.9700414699999, -74.29810963299991],
              [-120.94896399599992, -74.30738697699991],
              [-120.94424394399994, -74.30868905999995],
              [-121.09902910099993, -74.34807708099993],
              [-121.48051239066659, -74.3698055966666],
              [-121.86199568033324, -74.39153411233326],
              [-122.2434789699999, -74.41326262799993],
              [-122.46068274599992, -74.3791643209999],
              [-122.57209225199995, -74.3864885399999],
              [-122.62637285099993, -74.38209400799991],
              [-122.68732662699995, -74.36532968499995],
              [-122.90379798099991, -74.33700937299994],
              [-122.93643144399994, -74.32561614399992],
              [-122.98875891799992, -74.29778411299992],
              [-123.01109778599994, -74.27841562299994],
              [-123.00511633999992, -74.2634416649999],
              [-123.02818762899994, -74.2483049459999],
              [-122.99453691299993, -74.2346330709999],
              [-122.9551488919999, -74.2287736959999],
              [-122.76219641799992, -74.22625090899993],
              [-122.72915605399993, -74.21575286299992],
              [-122.73619544199994, -74.20745208099993],
              [-122.74657141799992, -74.20370859199994],
              [-122.76939856699994, -74.20086028399993],
              [-122.7969457669999, -74.19329192499993],
              [-122.80955969999991, -74.18670012799993],
              [-122.8308813139999, -74.16708749799994],
              [-122.93956458199995, -74.14023202899995],
              [-122.94635982999989, -74.13518645599993],
              [-122.94481360599991, -74.1286760399999],
              [-122.94570878799993, -74.11467864399992],
              [-122.94530188699991, -74.11028411299992],
              [-122.92418372299994, -74.0915666649999],
              [-122.90990149599992, -74.08717213299991],
              [-122.89468339799993, -74.0857072899999],
              [-122.86436926999994, -74.08652109199994],
              [-122.82046464799993, -74.07927825299993],
              [-122.8152563139999, -74.07537200299993],
              [-122.81753495999993, -74.06373463299991],
              [-122.8040258449999, -74.05852629999993],
              [-122.75674394399994, -74.0568986959999],
              [-122.74901282499991, -74.05559661299992],
              [-122.74429277299993, -74.05169036299992],
              [-122.74474036399994, -74.04607512799993],
              [-122.7520238919999, -74.0334611959999],
              [-122.75283769399994, -74.02613697699991],
              [-122.75104732999989, -74.0236955709999],
              [-122.7444555329999, -74.02044036299992],
              [-122.7425024079999, -74.01881275799991],
              [-122.74242102799991, -74.01620859199994],
              [-122.74303137899994, -74.01230234199994],
              [-122.74404863199993, -74.00896575299993],
              [-122.74510657499991, -74.00823333099993],
              [-122.74107825399994, -74.00359465899993],
              [-122.73656165299991, -74.00017669099992],
              [-122.73106848899994, -73.99773528399993],
              [-122.60765540299991, -73.96428801899992],
              [-122.55256100199995, -73.96160247199992],
              [-122.34984290299991, -73.92498137799993],
              [-122.33169511599993, -73.91659921699994],
              [-122.32738196499992, -73.91570403399993],
              [-122.36461341099994, -73.90740325299993],
              [-122.4363500639999, -73.89967213299991],
              [-122.59129798099991, -73.90732187299994],
              [-122.93407141799992, -73.87932708099993],
              [-122.94359290299991, -73.87590911299992],
              [-122.95018469999991, -73.86980559699992],
              [-122.95360266799992, -73.86321379999993],
              [-122.9563695949999, -73.85605234199994],
              [-122.96092688699991, -73.84832122199992],
              [-122.9722387359999, -73.83977629999993],
              [-122.98696855399993, -73.83489348799992],
              [-123.01695716099994, -73.83082447699991],
              [-123.34927324099993, -73.84840260199991],
              [-123.34923255099994, -73.84539153399993],
              [-123.34976152299993, -73.83879973799992],
              [-123.34951738199993, -73.83611419099992],
              [-123.33726966099994, -73.83123137799993],
              [-123.24889075399994, -73.82333749799994],
              [-123.23737545499989, -73.82024504999993],
              [-123.2307836579999, -73.81511809699992],
              [-123.23424231699994, -73.8049455709999],
              [-123.24860592399995, -73.79656340899993],
              [-123.2769262359999, -73.78573984199994],
              [-123.2891332669999, -73.77450937299994],
              [-123.28677324099993, -73.7639299459999],
              [-123.27538001199991, -73.75383879999993],
              [-123.19302324099993, -73.7068010399999],
              [-123.12022864499994, -73.68279387799993],
              [-123.06558183499993, -73.67538827899995],
              [-122.66897538949993, -73.67880624799994],
              [-122.27236894399994, -73.68222421699994],
              [-122.05577551999994, -73.71575286299992],
              [-121.59932749466661, -73.73292408666659],
              [-121.14287946933327, -73.75009531033326],
              [-120.68643144399994, -73.76726653399993],
              [-120.54015051999994, -73.75335051899992],
              [-120.42906653599994, -73.77255624799994],
              [-120.3758031889999, -73.79648202899995],
              [-120.37804114499994, -73.83098723799992],
              [-120.3946020169999, -73.84091562299994],
              [-120.41510982999989, -73.84685637799993],
              [-120.69570878799993, -73.86809661299992],
              [-120.72716223899994, -73.87883879999993],
              [-120.7351781889999, -73.87948984199994],
              [-120.64736894399994, -73.8967424459999],
              [-120.28571529899995, -73.91741301899992],
              [-120.26121985599991, -73.92782968499995],
            ],
          ],
          [
            [
              [169.96168053500003, -73.51441822699991],
              [169.94353274800005, -73.53191497199992],
              [169.9179793630001, -73.54387786299992],
              [169.8584090500001, -73.56308359199994],
              [169.86646569100003, -73.56536223799992],
              [169.86980228000004, -73.57626718499995],
              [169.86931399800005, -73.58928801899992],
              [169.86597741000003, -73.59823984199994],
              [169.8540145190001, -73.60686614399992],
              [169.83814537900003, -73.61223723799992],
              [169.66618899800005, -73.63103606599992],
              [169.6494246750001, -73.62908294099992],
              [169.65121504, -73.61646900799991],
              [169.6508895190001, -73.60588958099993],
              [169.6464949880001, -73.59685637799993],
              [169.63640384200005, -73.58863697699991],
              [169.62281334700003, -73.58277760199991],
              [169.60816491000003, -73.57903411299992],
              [169.5068465500001, -73.56747812299994],
              [169.45875084700003, -73.5549455709999],
              [169.5420028000001, -73.49700286299992],
              [169.66675866000003, -73.43035247199992],
              [169.67750084700003, -73.42180754999993],
              [169.65113366000003, -73.40715911299992],
              [169.637054884, -73.39544036299992],
              [169.63697350400003, -73.38551197699991],
              [169.67058353000004, -73.36435312299994],
              [169.672211134, -73.34140390399995],
              [169.70525149800005, -73.32577890399995],
              [169.75163821700005, -73.3200822899999],
              [169.79371178500003, -73.32724374799994],
              [169.81373131600003, -73.34856536299992],
              [169.81470787900003, -73.37566497199992],
              [169.81918379, -73.40081145599993],
              [169.85027103000004, -73.41611093499995],
              [169.86150149800005, -73.44158294099992],
              [169.89576256600003, -73.47128671699994],
              [169.96168053500003, -73.51441822699991],
            ],
          ],
          [
            [
              [-127.47317460799991, -73.54957447699991],
              [-127.43883216099994, -73.54225025799991],
              [-127.41820227799991, -73.53460051899992],
              [-127.41519120999993, -73.52556731599992],
              [-127.42080644399994, -73.51767343499995],
              [-127.42129472599993, -73.50986093499995],
              [-127.42027747299994, -73.50188567499993],
              [-127.42137610599991, -73.49325937299994],
              [-127.42516028599994, -73.48593515399995],
              [-127.42943274599992, -73.48284270599993],
              [-127.44322669199994, -73.47844817499993],
              [-127.47183183499993, -73.46233489399992],
              [-127.48648027299993, -73.45126718499995],
              [-127.4949438139999, -73.44011809699992],
              [-127.4954320949999, -73.42962004999993],
              [-127.48912512899994, -73.42441171699994],
              [-127.4260961579999, -73.39853280999995],
              [-127.37409420499989, -73.3571916649999],
              [-127.30321204299992, -73.3181291649999],
              [-127.22638912699989, -73.29216887799993],
              [-127.14899654899995, -73.27727629999993],
              [-127.1070043609999, -73.2776018209999],
              [-127.07457434799994, -73.29070403399993],
              [-127.08458411399994, -73.29534270599993],
              [-127.10513261599993, -73.30152760199991],
              [-127.11400305899991, -73.30559661299992],
              [-127.02989661399994, -73.30925872199992],
              [-126.77853349549991, -73.28879159949992],
              [-126.52717037699989, -73.26832447699991],
              [-126.10407467399995, -73.29615650799991],
              [-126.08438066299993, -73.30413176899992],
              [-126.00259355399993, -73.35173919099992],
              [-125.94249426999994, -73.37590911299992],
              [-125.59927324099993, -73.42937590899993],
              [-125.56578528599994, -73.44378020599993],
              [-125.57144120999993, -73.4611955709999],
              [-125.59870357999989, -73.47909921699994],
              [-125.6297094389999, -73.49456145599993],
              [-125.62572180899991, -73.50318775799991],
              [-125.60606848899994, -73.51726653399993],
              [-125.5217992829999, -73.5608049459999],
              [-125.46996008999992, -73.57887135199991],
              [-125.24632727799991, -73.61052825299993],
              [-125.22598222599993, -73.62167734199994],
              [-125.21279863199993, -73.63982512799993],
              [-125.21019446499992, -73.66057708099993],
              [-125.22175045499989, -73.6799455709999],
              [-125.2434789699999, -73.69215260199991],
              [-125.27000891799992, -73.69882577899995],
              [-125.7307836579999, -73.71640390399995],
              [-125.82583574099993, -73.70370859199994],
              [-125.87804114499994, -73.70476653399993],
              [-125.91226152299993, -73.72340260199991],
              [-125.90713456899994, -73.75505950299993],
              [-125.8653051419999, -73.7810197899999],
              [-125.77643795499989, -73.8103166649999],
              [-125.68350175699993, -73.82610442499993],
              [-125.5894262359999, -73.82390715899993],
              [-125.37002519399994, -73.79176197699991],
              [-125.2605688139999, -73.79192473799992],
              [-125.23985755099994, -73.79705169099992],
              [-125.20348059799994, -73.81414153399993],
              [-125.18382727799991, -73.8205705709999],
              [-125.12657630099994, -73.82463958099993],
              [-125.0821020169999, -73.83277760199991],
              [-125.0601293609999, -73.84295012799993],
              [-125.05719967399995, -73.85833098799992],
              [-125.06289628799993, -73.86142343499995],
              [-125.09007727799991, -73.86541106599992],
              [-125.07005774599992, -73.87607187299994],
              [-125.0432836579999, -73.88095468499995],
              [-124.99242102799991, -73.88225676899992],
              [-124.9260961579999, -73.87021249799994],
              [-124.91295325399994, -73.86988697699991],
              [-124.92992102799991, -73.8596330709999],
              [-124.93517005099994, -73.85426197699991],
              [-124.93960527299993, -73.84514739399992],
              [-124.93594316299993, -73.83245208099993],
              [-124.93541419199994, -73.82854583099993],
              [-124.93748938699991, -73.82586028399993],
              [-124.94884192599994, -73.81438567499993],
              [-124.90274003799993, -73.79550546699994],
              [-124.75816809799994, -73.77483489399992],
              [-124.62950598899994, -73.7307268209999],
              [-124.57957923099991, -73.7243791649999],
              [-124.53429114499994, -73.72763437299994],
              [-124.51577714799993, -73.7365861959999],
              [-124.50845292899993, -73.75318775799991],
              [-124.11217200399994, -73.83269622199992],
              [-124.09626217399995, -73.84295012799993],
              [-124.06041419199994, -73.84734465899993],
              [-124.02745520699995, -73.8552385399999],
              [-124.01992753799993, -73.87574635199991],
              [-124.03652910099993, -73.88958098799992],
              [-124.20881100199989, -73.93434010199991],
              [-124.1770727199999, -73.96062590899993],
              [-124.13219153599994, -73.97616952899995],
              [-123.93106035099993, -74.00269947699991],
              [-123.93932044199994, -74.01051197699991],
              [-123.97252356699994, -74.02385833099993],
              [-123.94904537699995, -74.02402109199994],
              [-123.89464270699995, -74.03118254999993],
              [-123.87295488199993, -74.0388322899999],
              [-123.86607825399994, -74.04412200299993],
              [-123.85558020699995, -74.0564104149999],
              [-123.84886633999992, -74.06145598799992],
              [-123.83950761599993, -74.06487395599993],
              [-123.75438391799992, -74.0725236959999],
              [-123.77700761599993, -74.08757903399993],
              [-123.77643795499989, -74.08993905999995],
              [-123.77733313699991, -74.09661223799992],
              [-123.7796117829999, -74.10426197699991],
              [-123.78302975199995, -74.1096330709999],
              [-123.78770911399994, -74.11077239399992],
              [-123.80874589799993, -74.11028411299992],
              [-123.83714758999992, -74.11443450299993],
              [-123.85204016799992, -74.11980559699992],
              [-123.86021887899994, -74.12851327899995],
              [-123.85924231699994, -74.13730234199994],
              [-123.85293535099993, -74.14267343499995],
              [-123.84581458199995, -74.14666106599992],
              [-123.84215247299994, -74.15162525799991],
              [-123.84829667899993, -74.16399504999993],
              [-123.86432857999989, -74.17205169099992],
              [-123.88353430899991, -74.17652760199991],
              [-123.89928137899994, -74.17815520599993],
              [-123.80626380099994, -74.21502044099992],
              [-123.83348548099991, -74.23121510199991],
              [-123.86510169199994, -74.24456145599993],
              [-123.92829342399995, -74.26181405999995],
              [-124.00743567599994, -74.2634416649999],
              [-124.24498450399994, -74.21477629999993],
              [-124.51461747949992, -74.22039153449992],
              [-124.78425045499989, -74.22600676899992],
              [-125.2034399079999, -74.16301848799992],
              [-125.23924719999991, -74.15162525799991],
              [-125.23729407499991, -74.15105559699992],
              [-125.23680579299992, -74.15056731599992],
              [-125.23778235599991, -74.1501604149999],
              [-125.24022376199991, -74.15007903399993],
              [-125.10928300699993, -74.1228166649999],
              [-125.41409257749993, -74.0815568989999],
              [-125.71890214799993, -74.04029713299991],
              [-125.74913489499994, -74.02467213299991],
              [-125.7532445949999, -74.01848723799992],
              [-125.75454667899993, -74.00628020599993],
              [-125.7581274079999, -74.00066497199992],
              [-125.76952063699991, -73.99456145599993],
              [-125.79893958199995, -73.98821379999993],
              [-125.81139075399994, -73.98316822699991],
              [-125.80504309799994, -73.98186614399992],
              [-125.79898027299993, -73.97966887799993],
              [-125.79352779899995, -73.97665780999995],
              [-125.78892981699994, -73.9729143209999],
              [-125.81273352799991, -73.9665666649999],
              [-125.92784583199995, -73.9568010399999],
              [-125.93834387899994, -73.9528947899999],
              [-125.96642005099994, -73.93694426899992],
              [-126.01134192599994, -73.92131926899992],
              [-126.47545325399994, -73.84221770599993],
              [-126.45177161399994, -73.83489348799992],
              [-126.42178300699993, -73.82154713299991],
              [-126.4011938139999, -73.8025041649999],
              [-126.40550696499992, -73.77841562299994],
              [-126.42910722599993, -73.7673479149999],
              [-126.4961645169999, -73.75750090899993],
              [-126.51463782499991, -73.74260833099993],
              [-126.51183020699995, -73.73064544099992],
              [-126.4988500639999, -73.72389088299991],
              [-126.4719945949999, -73.71599700299993],
              [-126.46349036399994, -73.70566171699994],
              [-126.46816972599993, -73.70029062299994],
              [-126.56110592399995, -73.68466562299994],
              [-126.55060787699989, -73.67327239399992],
              [-126.54653886599993, -73.67034270599993],
              [-126.72516842399995, -73.66521575299993],
              [-126.83543860599991, -73.64617278399993],
              [-126.87267005099994, -73.6467424459999],
              [-126.91323808499993, -73.65439218499995],
              [-126.95213782499991, -73.66765715899993],
              [-126.98424231699994, -73.68547942499993],
              [-126.9546606109999, -73.71990325299993],
              [-126.95254472599993, -73.72665780999995],
              [-127.00523841099994, -73.74041106599992],
              [-127.22940019399994, -73.7326799459999],
              [-127.25121008999992, -73.72893645599993],
              [-127.26211503799993, -73.72454192499993],
              [-127.2688695949999, -73.71786874799994],
              [-127.26866614499994, -73.70769622199992],
              [-127.2605688139999, -73.67864348799992],
              [-127.26121985599991, -73.66562265399995],
              [-127.25426184799994, -73.64413827899995],
              [-127.22508704299992, -73.62615325299993],
              [-127.16600501199991, -73.60263437299994],
              [-127.18814042899993, -73.59449635199991],
              [-127.36733964799993, -73.5627580709999],
              [-127.42210852799991, -73.5627580709999],
              [-127.45055091099994, -73.55982838299991],
              [-127.47317460799991, -73.54957447699991],
            ],
          ],
          [
            [
              [68.77873782600005, -72.11646900799991],
              [68.77881920700008, -72.11646900799991],
              [68.78484134200005, -72.11858489399992],
              [68.80494225400008, -72.12883879999993],
              [68.84001712300005, -72.15536874799994],
              [68.85417728000004, -72.1701799459999],
              [68.86255944100003, -72.19345468499995],
              [68.85230553500008, -72.21257903399993],
              [68.83171634200005, -72.22795989399992],
              [68.80909264400003, -72.23984140399995],
              [68.74203535200007, -72.26458098799992],
              [68.45191491000008, -72.31414153399993],
              [68.41765384200005, -72.31243254999993],
              [68.39470462300005, -72.29705169099992],
              [68.44996178500008, -72.24968840899993],
              [68.60499108200008, -72.1716447899999],
              [68.62614993600005, -72.14967213299991],
              [68.63184655000003, -72.12200286299992],
              [68.64747155000003, -72.10930754999993],
              [68.68490644600007, -72.09644947699991],
              [68.72584069100003, -72.08855559699992],
              [68.75180097700007, -72.09042734199994],
              [68.75554446700005, -72.09482187299994],
              [68.75863691500007, -72.10515715899993],
              [68.76099694100003, -72.10881926899992],
              [68.76482181100005, -72.11150481599992],
              [68.76921634200005, -72.11345794099992],
              [68.77873782600005, -72.11646900799991],
            ],
          ],
          [
            [
              [69.92448978000004, -71.90894947699991],
              [69.91358483200008, -71.93035247199992],
              [69.89991295700008, -71.94833749799994],
              [69.80616295700008, -72.02434661299992],
              [69.79615319100003, -72.04216887799993],
              [69.79867597700007, -72.04306405999995],
              [69.80095462300005, -72.04404062299994],
              [69.80298912900008, -72.04534270599993],
              [69.80486087300005, -72.04705169099992],
              [69.79664147200003, -72.05193450299993],
              [69.78736412900008, -72.05543385199991],
              [69.76840254000007, -72.0603166649999],
              [69.75953209700003, -72.06015390399995],
              [69.73324629000007, -72.05657317499993],
              [69.72689863400007, -72.0564104149999],
              [69.74919681100005, -72.04143645599993],
              [69.70297285200007, -71.9880510399999],
              [69.68279056100005, -71.97503020599993],
              [69.69874108200008, -71.96754322699991],
              [69.72201582100007, -71.95208098799992],
              [69.72584069100003, -71.94850025799991],
              [69.72787519600007, -71.94394296699994],
              [69.72754967500003, -71.94133879999993],
              [69.72584069100003, -71.93328215899993],
              [69.72478274800005, -71.9318986959999],
              [69.75375410200007, -71.91611093499995],
              [69.76246178500008, -71.90976327899995],
              [69.76531009200005, -71.90593840899993],
              [69.76636803500008, -71.90300872199992],
              [69.76840254000007, -71.89999765399995],
              [69.77409915500004, -71.89657968499995],
              [69.79346764400003, -71.89137135199991],
              [69.81723066500007, -71.88933684699992],
              [69.86207116000008, -71.89023202899995],
              [69.92448978000004, -71.90894947699991],
            ],
          ],
          [
            [
              [-3.228098110999952, -71.05282968499995],
              [-3.179066535999937, -71.11012135199991],
              [-2.986398891999954, -71.18434010199991],
              [-2.944569464999915, -71.22503020599993],
              [-3.036610480999911, -71.23739999799994],
              [-3.132720506999931, -71.2385393209999],
              [-3.224476691999939, -71.22893645599993],
              [-3.304188605999911, -71.20859140399995],
              [-3.337717251999948, -71.19296640399995],
              [-3.370838995999918, -71.17205169099992],
              [-3.398345506999931, -71.14999765399995],
              [-3.415028449999909, -71.12997812299994],
              [-3.40070553299995, -71.12265390399995],
              [-3.389556443999936, -71.11451588299991],
              [-3.370350714999915, -71.09384530999995],
              [-3.372385219999956, -71.09433359199994],
              [-3.373524542999917, -71.0940080709999],
              [-3.373890753999945, -71.09319426899992],
              [-3.37328040299991, -71.0915666649999],
              [-3.409291144999941, -71.06650155999995],
              [-3.368031378999945, -71.05291106599992],
              [-3.29320227799991, -71.04892343499995],
              [-3.228098110999952, -71.05282968499995],
            ],
          ],
          [
            [
              [-2.717681443999936, -70.8200822899999],
              [-2.61156165299991, -70.84091562299994],
              [-2.298451300999943, -70.7927385399999],
              [-2.126942511999914, -70.81072356599992],
              [-2.08071855399993, -70.82561614399992],
              [-2.091297980999911, -70.83025481599992],
              [-2.131825324999909, -70.86679452899995],
              [-2.147328253999945, -70.87411874799994],
              [-2.196603969999956, -70.88779062299994],
              [-2.215931769999941, -70.8962541649999],
              [-2.234038865999935, -70.90699635199991],
              [-2.250884568999936, -70.9196916649999],
              [-2.265736456999946, -70.93450286299992],
              [-2.290598110999952, -70.96843840899993],
              [-2.297963019999941, -70.9885393209999],
              [-2.293120897999927, -71.00514088299991],
              [-2.303863084999932, -71.01637135199991],
              [-2.564320441999939, -71.1325822899999],
              [-2.734486456999946, -71.17099374799994],
              [-2.799956834999932, -71.1677385399999],
              [-2.817738410999937, -71.15618254999993],
              [-2.822336391999954, -71.12664153399993],
              [-2.843617316999939, -71.11207447699991],
              [-2.839100714999915, -71.09441497199992],
              [-2.840891079999949, -71.08001067499993],
              [-2.848784959999932, -71.06698984199994],
              [-2.862172003999945, -71.05348072699991],
              [-2.843617316999939, -71.05559661299992],
              [-2.818023240999935, -71.04501718499995],
              [-2.77570553299995, -71.02011484199994],
              [-2.752756313999953, -71.01132577899995],
              [-2.690825975999928, -70.99504973799992],
              [-2.667307094999956, -70.99374765399995],
              [-2.984974738999938, -70.9358049459999],
              [-2.963286912999934, -70.93328215899993],
              [-2.948394334999932, -70.91936614399992],
              [-2.942779100999928, -70.89950937299994],
              [-2.948597785999937, -70.87908294099992],
              [-2.964588995999918, -70.86532968499995],
              [-2.987294074999909, -70.85605234199994],
              [-3.011463995999918, -70.8498674459999],
              [-3.18773352799991, -70.82463958099993],
              [-3.440337693999936, -70.75188567499993],
              [-3.585560675999943, -70.73837655999995],
              [-3.571034308999913, -70.69280364399992],
              [-3.52570553299995, -70.68157317499993],
              [-3.410715298999946, -70.69247812299994],
              [-3.180775519999941, -70.66806405999995],
              [-2.899423794499938, -70.68287525799994],
              [-2.618072068999936, -70.69768645599993],
              [-2.559559699999909, -70.71062590899993],
              [-2.504628058999913, -70.73154062299994],
              [-2.568267381999931, -70.7575822899999],
              [-2.734364386999914, -70.79241301899992],
              [-2.717681443999936, -70.8200822899999],
            ],
          ],
          [
            [
              [1.951345248000052, -70.60426197699991],
              [1.99935957100007, -70.5974260399999],
              [2.065277540000068, -70.60100676899992],
              [2.12281334700009, -70.61760833099993],
              [2.145192905000044, -70.65007903399993],
              [2.115570509000065, -70.6755510399999],
              [2.05404707100007, -70.67351653399993],
              [1.989431186000047, -70.65447356599992],
              [1.950450066000087, -70.62900155999995],
              [1.951345248000052, -70.62322356599992],
              [1.953135613000086, -70.61785247199992],
              [1.953868035000085, -70.61191171699994],
              [1.951345248000052, -70.60426197699991],
            ],
          ],
          [
            [
              [-5.939849412999934, -70.42262135199991],
              [-5.978423631999931, -70.4651018209999],
              [-5.965972459999932, -70.49846770599993],
              [-5.884917772999927, -70.54941171699994],
              [-5.921701626999948, -70.56503671699994],
              [-6.119252081999946, -70.61288827899995],
              [-6.150054490999935, -70.61484140399995],
              [-6.174387173999946, -70.60605234199994],
              [-6.193104620999918, -70.58342864399992],
              [-6.190052863999938, -70.57887135199991],
              [-6.182728644999941, -70.57545338299991],
              [-6.179107225999928, -70.57154713299991],
              [-6.41624915299991, -70.47161223799992],
              [-6.45376542899993, -70.44443124799994],
              [-6.350819464999915, -70.45956796699994],
              [-6.295887824999909, -70.46021900799991],
              [-6.086903449999909, -70.40634530999995],
              [-6.012318488999938, -70.40357838299991],
              [-5.939849412999934, -70.42262135199991],
            ],
          ],
          [
            [
              [3.219899936000047, -70.3923479149999],
              [3.262380405000044, -70.43759530999995],
              [3.252614780000044, -70.48674895599993],
              [3.210948113000086, -70.53134530999995],
              [3.15788821700005, -70.5627580709999],
              [3.063243035000085, -70.59343840899993],
              [2.957855665000068, -70.61345794099992],
              [2.743662957000083, -70.62932708099993],
              [2.682383660000085, -70.62297942499993],
              [2.631602410000085, -70.60271575299993],
              [2.596039259000065, -70.56951262799993],
              [2.580821160000085, -70.52434661299992],
              [2.648448113000086, -70.49374765399995],
              [3.049815300000091, -70.38543059699992],
              [3.139170769000089, -70.37395598799992],
              [3.219899936000047, -70.3923479149999],
            ],
          ],
          [
            [
              [72.20036868600005, -70.60702890399995],
              [72.21680748800003, -70.62379322699991],
              [72.22022545700008, -70.63046640399995],
              [72.19361412900008, -70.64381275799991],
              [72.16456139400003, -70.65105559699992],
              [72.08448326900003, -70.65398528399993],
              [71.82691491000008, -70.62493254999993],
              [71.78695722700007, -70.60784270599993],
              [71.67359459700003, -70.51718515399995],
              [71.66049238400007, -70.50310637799993],
              [71.65137780000003, -70.48748137799993],
              [71.63689212300005, -70.45305754999993],
              [71.63135826900003, -70.42864348799992],
              [71.63086998800009, -70.37883879999993],
              [71.62330162900008, -70.35475025799991],
              [71.63428795700008, -70.34124114399992],
              [71.64177493600005, -70.3357072899999],
              [71.65381920700008, -70.33114999799994],
              [71.67611738400007, -70.30437590899993],
              [71.71469160200007, -70.2790666649999],
              [71.76124108200008, -70.26360442499993],
              [71.80836022200003, -70.2658830709999],
              [71.81910241000008, -70.27678801899992],
              [71.82341556100005, -70.29501718499995],
              [71.82984459700003, -70.31438567499993],
              [71.84791100400008, -70.32903411299992],
              [71.84750410200007, -70.36174895599993],
              [71.86207116000008, -70.38941822699991],
              [71.88599694100003, -70.41228606599992],
              [71.91325931100005, -70.42986419099992],
              [71.94654381600003, -70.44605885199991],
              [71.98170006600003, -70.45769622199992],
              [72.01775149800005, -70.46168385199991],
              [72.03541100400008, -70.46607838299991],
              [72.04932701900003, -70.47665780999995],
              [72.05827884200005, -70.4924455709999],
              [72.06462649800005, -70.50847747199992],
              [72.07300866000008, -70.52271900799991],
              [72.08814537900008, -70.53313567499993],
              [72.10474694100003, -70.53704192499993],
              [72.18620853000004, -70.53769296699994],
              [72.20085696700005, -70.54119231599992],
              [72.21119225400008, -70.54949309699992],
              [72.21404056100005, -70.56324635199991],
              [72.20866946700005, -70.57512786299992],
              [72.20085696700005, -70.58635833099993],
              [72.19703209700003, -70.5979143209999],
              [72.19743899800005, -70.60035572699991],
              [72.19800866000008, -70.60271575299993],
              [72.19906660200007, -70.60491301899992],
              [72.20036868600005, -70.60702890399995],
            ],
          ],
          [
            [
              [4.048838738000086, -70.3029924459999],
              [4.132660352000073, -70.25603606599992],
              [4.297211134000065, -70.23723723799992],
              [4.468760613000086, -70.24456145599993],
              [4.574392123000052, -70.27613697699991],
              [4.621755405000044, -70.35271575299993],
              [4.604746941000087, -70.42058684699992],
              [4.545583530000044, -70.47258879999993],
              [4.466807488000086, -70.50123463299991],
              [4.33139082100007, -70.50448984199994],
              [4.20484459700009, -70.46949635199991],
              [4.104665561000047, -70.40081145599993],
              [4.048838738000086, -70.3029924459999],
            ],
          ],
          [
            [
              [5.465586785000085, -70.25530364399992],
              [5.560069207000083, -70.22926197699991],
              [5.654633009000065, -70.22568124799994],
              [5.744802280000044, -70.24879322699991],
              [5.82585696700005, -70.30396900799991],
              [5.747325066000087, -70.34091562299994],
              [5.642914259000065, -70.32952239399992],
              [5.539886915000068, -70.29314544099992],
              [5.465586785000085, -70.25530364399992],
            ],
          ],
          [
            [
              [161.811859571, -70.24146900799991],
              [161.8344832690001, -70.22210051899992],
              [161.8676863940001, -70.21746184699992],
              [161.90007571700005, -70.22454192499993],
              [161.9204207690001, -70.24065520599993],
              [161.888031446, -70.25725676899992],
              [161.85572350400003, -70.26116301899992],
              [161.82878665500004, -70.25514088299991],
              [161.811859571, -70.24146900799991],
            ],
          ],
          [
            [
              [6.272715691000087, -70.12273528399993],
              [6.343272332000083, -70.12297942499993],
              [6.451670769000089, -70.1369768209999],
              [6.53646894600007, -70.16497161299992],
              [6.53646894600007, -70.20720794099992],
              [6.50367272200009, -70.22258879999993],
              [6.46810957100007, -70.22332122199992],
              [6.432465040000068, -70.21453215899993],
              [6.329112175000091, -70.16920338299991],
              [6.29460696700005, -70.14763762799993],
              [6.272715691000087, -70.12273528399993],
            ],
          ],
          [
            [
              [26.765635613000086, -70.22429778399993],
              [26.817230665000068, -70.27654387799993],
              [26.86695397200009, -70.30478280999995],
              [26.87989342500009, -70.31894296699994],
              [26.881683790000068, -70.33131275799991],
              [26.87671959700009, -70.34644947699991],
              [26.850433790000068, -70.39641692499993],
              [26.839854363000086, -70.41204192499993],
              [26.817881707000083, -70.4240861959999],
              [26.775726759000065, -70.43059661299992],
              [26.73764082100007, -70.42815520599993],
              [26.66342207100007, -70.41318124799994],
              [26.623301629000082, -70.41122812299994],
              [26.56544030000009, -70.42009856599992],
              [26.507823113000086, -70.44540780999995],
              [26.457774285000085, -70.45012786299992],
              [26.057302280000044, -70.39104583099993],
              [25.98804772200009, -70.36825937299994],
              [25.975352410000085, -70.34661223799992],
              [25.95020592500009, -70.33261484199994],
              [25.932383660000085, -70.3166643209999],
              [25.920258009000065, -70.30046965899993],
              [25.912282748000052, -70.2849260399999],
              [25.939626498000052, -70.26295338299991],
              [25.937673373000052, -70.2478166649999],
              [25.940928582000083, -70.23455169099992],
              [25.94890384200005, -70.22258879999993],
              [25.96029707100007, -70.21111419099992],
              [25.98731530000009, -70.19500090899993],
              [26.115082227000073, -70.15309010199991],
              [26.136566602000073, -70.14299895599993],
              [26.188161655000044, -70.10979583099993],
              [26.221934441000087, -70.09441497199992],
              [26.26921634200005, -70.07887135199991],
              [26.327403191000087, -70.06658294099992],
              [26.458262566000087, -70.05999114399992],
              [26.589691602000073, -70.07480234199994],
              [26.65015709700009, -70.09270598799992],
              [26.673106316000087, -70.10263437299994],
              [26.691579623000052, -70.11435312299994],
              [26.70606530000009, -70.12965260199991],
              [26.737478061000047, -70.18718840899993],
              [26.765635613000086, -70.22429778399993],
            ],
          ],
          [
            [
              [1.410980665000068, -70.04021575299993],
              [1.435394727000073, -70.06438567499993],
              [1.44890384200005, -70.09539153399993],
              [1.465017123000052, -70.15048593499995],
              [1.463226759000065, -70.14983489399992],
              [1.462168816000087, -70.14999765399995],
              [1.461761915000068, -70.15048593499995],
              [1.461761915000068, -70.15154387799993],
              [1.369883660000085, -70.20322030999995],
              [1.275726759000065, -70.27385833099993],
              [1.256846550000091, -70.30282968499995],
              [1.223480665000068, -70.3791643209999],
              [1.197764519000089, -70.40642669099992],
              [1.16382897200009, -70.41708749799994],
              [1.150726759000065, -70.39804452899995],
              [1.141612175000091, -70.36093515399995],
              [1.119313998000052, -70.31747812299994],
              [1.060394727000073, -70.26873137799993],
              [1.00163821700005, -70.2365861959999],
              [0.95679772200009, -70.1916643209999],
              [0.939707879000082, -70.10491301899992],
              [0.979502800000091, -70.06560637799993],
              [1.042491082000083, -70.04599374799994],
              [1.299571160000085, -70.02337004999993],
              [1.360850457000083, -70.02507903399993],
              [1.410980665000068, -70.04021575299993],
            ],
          ],
          [
            [
              [10.98804772200009, -70.04599374799994],
              [11.000824415000068, -70.0764299459999],
              [10.921885613000086, -70.08294036299992],
              [10.812022332000083, -70.07586028399993],
              [10.576182488000086, -70.0315080709999],
              [10.539805535000085, -70.0114885399999],
              [10.634613477000073, -70.00457122199992],
              [10.89421634200005, -70.0178361959999],
              [10.98804772200009, -70.04599374799994],
            ],
          ],
          [
            [
              [72.63990319100003, -69.99570077899995],
              [72.66130618600005, -70.00652434699992],
              [72.71810957100007, -70.00074635199991],
              [72.73015384200005, -70.00481536299992],
              [72.73113040500004, -70.02255624799994],
              [72.56072024800005, -70.09026458099993],
              [72.45932050900007, -70.10865650799991],
              [72.41195722700007, -70.07480234199994],
              [72.43555748800003, -70.06047942499993],
              [72.45606530000003, -70.05185312299994],
              [72.47193444100003, -70.05087655999995],
              [72.48170006600003, -70.0588518209999],
              [72.50554446700005, -70.05315520599993],
              [72.52662194100003, -70.04363372199992],
              [72.54615319100003, -70.03085702899995],
              [72.59799238400007, -69.98796965899993],
              [72.61597741000008, -69.9782854149999],
              [72.63705488400007, -69.96982187299994],
              [72.63591556100005, -69.97795989399992],
              [72.63607832100007, -69.98503997199992],
              [72.63746178500008, -69.99089934699992],
              [72.63990319100003, -69.99570077899995],
            ],
          ],
          [
            [
              [16.246836785000085, -69.70598723799992],
              [16.55209394600007, -69.71803150799991],
              [16.63721764400009, -69.74285247199992],
              [16.590179884000065, -69.77662525799991],
              [16.330414259000065, -69.82887135199991],
              [16.308441602000073, -69.83863697699991],
              [16.28874759200005, -69.8498674459999],
              [16.271739129000082, -69.86248137799993],
              [16.25879967500009, -69.87574635199991],
              [16.247243686000047, -69.89788176899992],
              [16.248871290000068, -69.91521575299993],
              [16.254079623000052, -69.93474700299993],
              [16.252207879000082, -69.96363697699991],
              [16.23959394600007, -69.98739999799994],
              [16.189626498000052, -70.05510833099993],
              [16.17156009200005, -70.07293059699992],
              [16.122243686000047, -70.07350025799991],
              [15.897227410000085, -69.98935312299994],
              [15.688243035000085, -69.96404387799993],
              [15.589121941000087, -69.93206145599993],
              [15.554942254000082, -69.87273528399993],
              [15.58570397200009, -69.83709075299993],
              [15.630707227000073, -69.80510833099993],
              [15.67945397200009, -69.77971770599993],
              [15.721853061000047, -69.7639299459999],
              [15.972178582000083, -69.71795012799993],
              [16.246836785000085, -69.70598723799992],
            ],
          ],
          [
            [
              [47.875661655000044, -67.56446705499991],
              [47.875743035000085, -67.56454843499995],
              [47.914724155000044, -67.58587004999993],
              [47.92335045700008, -67.58660247199992],
              [47.791677280000044, -67.61972421699994],
              [47.53248131600009, -67.64169687299994],
              [47.469411655000044, -67.63738372199992],
              [47.41130618600005, -67.62175872199992],
              [47.46013431100005, -67.55901458099993],
              [47.48487389400009, -67.54070403399993],
              [47.51742597700007, -67.5271135399999],
              [47.55884850400008, -67.52092864399992],
              [47.609711134000065, -67.52418385199991],
              [47.59310957100007, -67.5407854149999],
              [47.557627800000034, -67.5564104149999],
              [47.51905358200008, -67.56804778399993],
              [47.492930535000085, -67.57268645599993],
              [47.69752037900008, -67.59343840899993],
              [47.735036655000044, -67.59050872199992],
              [47.77100670700008, -67.58212655999995],
              [47.83415774800005, -67.55820077899995],
              [47.84538821700005, -67.5564104149999],
              [47.86060631600009, -67.55771249799994],
              [47.863617384000065, -67.55852629999993],
              [47.875661655000044, -67.56446705499991],
            ],
          ],
          [
            [
              [120.66504967500009, -66.89657968499995],
              [120.67042076900009, -66.9006486959999],
              [120.67847741000003, -66.90520598799992],
              [120.68409264400009, -66.90715911299992],
              [120.689789259, -66.90837981599992],
              [120.71176191500001, -66.91057708099993],
              [120.74317467500009, -66.90837981599992],
              [120.83863366000003, -66.88795338299991],
              [120.86638431100005, -66.88681405999995],
              [120.53199303500003, -66.9690080709999],
              [120.51197350400003, -66.96933359199994],
              [120.49244225400003, -66.96233489399992],
              [120.47999108200008, -66.95012786299992],
              [120.47852623800009, -66.93515390399995],
              [120.49138431100005, -66.92001718499995],
              [120.50001061300009, -66.9123674459999],
              [120.51498457100001, -66.89495208099993],
              [120.52369225400003, -66.88779062299994],
              [120.54004967500009, -66.88128020599993],
              [120.55884850400003, -66.87859465899993],
              [120.60743248800009, -66.87957122199992],
              [120.65113366000003, -66.88713958099993],
              [120.656586134, -66.88974374799994],
              [120.66504967500009, -66.89657968499995],
            ],
          ],
          [
            [
              [121.12777754000001, -66.77947356599992],
              [121.19288170700008, -66.77890390399995],
              [121.19516035200002, -66.78639088299991],
              [121.168304884, -66.80592213299991],
              [121.109711134, -66.82878997199992],
              [121.02320397200003, -66.84832122199992],
              [120.93775475400003, -66.85702890399995],
              [120.883148634, -66.84644947699991],
              [120.94507897200003, -66.83074309699992],
              [121.04810631600003, -66.7888322899999],
              [121.12777754000001, -66.77947356599992],
            ],
          ],
          [
            [
              [85.65927168100006, -66.7436662739999],
              [85.76986738400007, -66.75969817499993],
              [85.79607181100005, -66.76962655999995],
              [85.83692467500003, -66.79371510199991],
              [85.94117272200003, -66.88990650799991],
              [85.92741946700005, -66.91073984199994],
              [85.87614993600005, -66.93645598799992],
              [85.78736412900008, -66.96892669099992],
              [85.61304772200003, -66.9865861959999],
              [85.58985436300003, -66.98170338299991],
              [85.61304772200003, -66.95769622199992],
              [85.62614993600005, -66.94784921699994],
              [85.64128665500004, -66.93938567499993],
              [85.61890709700003, -66.94036223799992],
              [85.37476647200003, -66.8772111959999],
              [85.33855228000004, -66.85759856599992],
              [85.30689537900008, -66.83220794099992],
              [85.28003991000003, -66.80152760199991],
              [85.25863691500007, -66.76620859199994],
              [85.27540123800003, -66.73772551899992],
              [85.30762780000003, -66.72372812299994],
              [85.34538821700005, -66.71917083099993],
              [85.48365319100003, -66.7209611959999],
              [85.56592858200008, -66.73642343499995],
              [85.62208092500003, -66.7380510399999],
              [85.65886478000004, -66.74358489399992],
              [85.65927168100006, -66.7436662739999],
            ],
          ],
          [
            [
              [48.77369225400008, -66.7204729149999],
              [48.808929884000065, -66.7673479149999],
              [48.76335696700005, -66.78329843499995],
              [48.594737175000034, -66.77752044099992],
              [48.39991295700008, -66.80803801899992],
              [48.31218509200005, -66.80950286299992],
              [48.281586134000065, -66.76718515399995],
              [48.281260613000086, -66.75164153399993],
              [48.287852410000085, -66.73626067499993],
              [48.305023634000065, -66.72161223799992],
              [48.33643639400009, -66.70777760199991],
              [48.37525475400008, -66.69915129999993],
              [48.725352410000085, -66.70305754999993],
              [48.77369225400008, -66.7204729149999],
            ],
          ],
          [
            [
              [86.54859459700003, -66.70305754999993],
              [86.58082116000003, -66.71795012799993],
              [86.61085045700008, -66.72161223799992],
              [86.67579186300003, -66.71965911299992],
              [86.61703535200007, -66.74602629999993],
              [86.49724368600005, -66.78476327899995],
              [86.40316816500007, -66.79599374799994],
              [86.34376061300003, -66.79257577899995],
              [86.31478925900007, -66.78630950299993],
              [86.26539147200003, -66.76262786299992],
              [86.23764082100007, -66.74472421699994],
              [86.23047936300003, -66.73040129999993],
              [86.25953209700003, -66.70427825299993],
              [86.29428144600007, -66.68759530999995],
              [86.33228600400008, -66.67815520599993],
              [86.51612389400003, -66.66716887799993],
              [86.53638756600003, -66.66912200299993],
              [86.53174889400003, -66.6779924459999],
              [86.53288821700005, -66.68670012799993],
              [86.53874759200005, -66.6950822899999],
              [86.54859459700003, -66.70305754999993],
            ],
          ],
          [
            [
              [85.20240319100003, -66.56796640399995],
              [85.23365319100003, -66.58114999799994],
              [85.34253991000003, -66.60475025799991],
              [85.28646894600007, -66.63762786299992],
              [85.20118248800003, -66.6467424459999],
              [85.11443118600005, -66.63534921699994],
              [85.05486087300005, -66.60621510199991],
              [85.07911217500003, -66.57732512799993],
              [85.09205162900008, -66.54485442499993],
              [85.11068769600007, -66.52068450299993],
              [85.15211022200003, -66.51637135199991],
              [85.16895592500003, -66.52459075299993],
              [85.18799889400003, -66.55478280999995],
              [85.20240319100003, -66.56796640399995],
            ],
          ],
          [
            [
              [98.58855228000004, -66.38795338299991],
              [98.59717858200003, -66.37851327899995],
              [98.62029056100005, -66.37078215899993],
              [98.66000410200007, -66.36345794099992],
              [98.71168053500003, -66.36402760199991],
              [98.85938561300003, -66.38925546699994],
              [98.95329837300005, -66.41814544099992],
              [98.93962649800005, -66.4314104149999],
              [98.83757571700005, -66.47714609199994],
              [98.81495201900003, -66.48398202899995],
              [98.79118899800005, -66.48739999799994],
              [98.73072350400008, -66.48235442499993],
              [98.66814212300005, -66.46249765399995],
              [98.61622155000003, -66.43010833099993],
              [98.58855228000004, -66.38795338299991],
            ],
          ],
          [
            [
              [97.40552819100003, -66.40349700299993],
              [97.42432701900003, -66.42310963299991],
              [97.39372806100005, -66.43027109199994],
              [97.06763756600003, -66.40471770599993],
              [97.03785241000003, -66.39511484199994],
              [97.01050866000003, -66.38103606599992],
              [97.04810631600003, -66.34417083099993],
              [97.10531660200007, -66.32830169099992],
              [97.16773522200003, -66.3259416649999],
              [97.28467858200003, -66.34075286299992],
              [97.34685306100005, -66.36052825299993],
              [97.36304772200003, -66.36874765399995],
              [97.37818444100003, -66.37900155999995],
              [97.40552819100003, -66.40349700299993],
            ],
          ],
          [
            [
              [162.62614993600005, -66.46249765399995],
              [162.61597741000003, -66.46835702899995],
              [162.56804446700005, -66.52613697699991],
              [162.55811608200008, -66.5329729149999],
              [162.54639733200008, -66.53460051899992],
              [162.53150475400003, -66.53020598799992],
              [162.51636803500003, -66.52312590899993],
              [162.478851759, -66.51091887799993],
              [162.471039259, -66.50660572699991],
              [162.34050540500004, -66.41025155999995],
              [162.32781009200005, -66.40520598799992],
              [162.29021243600005, -66.39763762799993],
              [162.325043165, -66.38347747199992],
              [162.34294681100005, -66.37249114399992],
              [162.34945722700002, -66.36044687299994],
              [162.34546959700003, -66.35426197699991],
              [162.33033287900003, -66.35125090899993],
              [162.32447350400003, -66.34677499799994],
              [162.32341556100005, -66.33855559699992],
              [162.32976321700005, -66.32170989399992],
              [162.32886803500003, -66.3127580709999],
              [162.32154381600003, -66.30510833099993],
              [162.31023196700005, -66.29973723799992],
              [162.2876082690001, -66.29404062299994],
              [162.2978621750001, -66.25481536299992],
              [162.31470787900003, -66.25139739399992],
              [162.55632571700005, -66.43661874799994],
              [162.57341556100005, -66.44589609199994],
              [162.62614993600005, -66.46249765399995],
            ],
          ],
          [
            [
              [100.30648847700007, -66.13014088299991],
              [100.31039472700007, -66.13713958099993],
              [100.31592858200003, -66.15105559699992],
              [100.31714928500003, -66.15715911299992],
              [100.31055748800003, -66.17302825299993],
              [100.29175866000003, -66.18010833099993],
              [100.25123131600003, -66.18434010199991],
              [100.25505618600005, -66.18621184699992],
              [100.26954186300003, -66.19548919099992],
              [100.27491295700003, -66.19793059699992],
              [100.28272545700003, -66.19890715899993],
              [100.29908287900008, -66.19817473799992],
              [100.30730228000004, -66.1989885399999],
              [100.29802493600005, -66.20183684699992],
              [100.25367272200003, -66.22283294099992],
              [100.18287194100003, -66.2326799459999],
              [100.11654707100007, -66.22991301899992],
              [100.08073978000004, -66.22112395599993],
              [100.06478925900007, -66.20427825299993],
              [100.08008873800003, -66.18401458099993],
              [100.15512129000007, -66.13860442499993],
              [100.20582116000003, -66.11467864399992],
              [100.23511803500003, -66.1071916649999],
              [100.26449629000007, -66.1052385399999],
              [100.28931725400008, -66.11150481599992],
              [100.29379316500007, -66.11451588299991],
              [100.29835045700003, -66.1189104149999],
              [100.30648847700007, -66.13014088299991],
            ],
          ],
          [
            [
              [96.91716556100005, -66.05437590899993],
              [96.97486412900008, -66.0744768209999],
              [97.01587975400008, -66.10556405999995],
              [97.03093509200005, -66.14055754999993],
              [97.01050866000003, -66.17310963299991],
              [96.90845787900008, -66.21135833099993],
              [96.65792890750006, -66.21949635199994],
              [96.40739993600005, -66.22763437299994],
              [96.35596764400003, -66.22161223799992],
              [96.33863366000003, -66.19719817499993],
              [96.29656009200005, -66.18352629999993],
              [96.34652754000007, -66.11882903399993],
              [96.37582441500007, -66.09140390399995],
              [96.41797936300003, -66.06707122199992],
              [96.46762129000007, -66.05071379999993],
              [96.52930748800003, -66.03980885199991],
              [96.59644616000003, -66.03582122199992],
              [96.66146894600007, -66.04013437299994],
              [96.68392988400007, -66.04607512799993],
              [96.72559655000003, -66.06365325299993],
              [96.74927819100003, -66.06910572699991],
              [96.79135175900007, -66.0681291649999],
              [96.87842858200003, -66.05348072699991],
              [96.91716556100005, -66.05437590899993],
            ],
          ],
          [
            [
              [100.79769941500007, -65.77727629999993],
              [100.97331790500004, -65.7873674459999],
              [101.00668379000007, -65.79615650799991],
              [101.02556399800005, -65.81259530999995],
              [101.01124108200003, -65.83879973799992],
              [100.96322675900007, -65.86492278399993],
              [100.90455162900008, -65.87810637799993],
              [100.75879967500003, -65.88176848799992],
              [100.70020592500003, -65.87395598799992],
              [100.67164147200003, -65.8654924459999],
              [100.63526451900003, -65.8591447899999],
              [100.52540123800003, -65.87444426899992],
              [100.46021569100003, -65.87566497199992],
              [100.42790774800005, -65.86931731599992],
              [100.39966881600003, -65.85466887799993],
              [100.53492272200003, -65.79062265399995],
              [100.55860436300003, -65.78435637799993],
              [100.60718834700003, -65.77849700299993],
              [100.71208743600005, -65.78590260199991],
              [100.79769941500007, -65.77727629999993],
            ],
          ],
          [
            [
              [92.49626712300005, -65.70313892999991],
              [92.49634850400008, -65.70322030999995],
              [92.62110436300003, -65.72600676899992],
              [92.67164147200003, -65.74920012799993],
              [92.66895592500003, -65.78484465899993],
              [92.57886803500003, -65.81755950299993],
              [92.43441816500007, -65.82439544099992],
              [92.29916425900007, -65.80291106599992],
              [92.23585045700008, -65.75066497199992],
              [92.28532962300005, -65.71217213299991],
              [92.35027103000004, -65.69475676899992],
              [92.42335045700008, -65.69329192499993],
              [92.49626712300005, -65.70313892999991],
            ],
          ],
          [
            [
              [100.56592858200003, -65.40300872199992],
              [100.72966556100005, -65.38046640399995],
              [100.93458092500003, -65.3786760399999],
              [101.12671959700003, -65.4118791649999],
              [101.25180097700007, -65.49374765399995],
              [101.26140384200005, -65.54029713299991],
              [101.23072350400008, -65.5739885399999],
              [101.02491295700003, -65.66545989399992],
              [100.96705162900008, -65.68287525799991],
              [100.55787194100003, -65.70403411299992],
              [100.51392662900008, -65.69719817499993],
              [100.53842207100007, -65.68613046699994],
              [100.53638756600003, -65.68287525799991],
              [100.52491295700003, -65.67864348799992],
              [100.50367272200003, -65.67310963299991],
              [100.36817467500003, -65.67896900799991],
              [100.32984459700003, -65.67343515399995],
              [100.29802493600005, -65.65862395599993],
              [100.27621504000007, -65.6330705709999],
              [100.26823978000004, -65.59465911299992],
              [100.30372155000003, -65.53606536299992],
              [100.38510175900007, -65.47861093499995],
              [100.48243248800003, -65.43124765399995],
              [100.56592858200003, -65.40300872199992],
            ],
          ],
          [
            [
              [103.29127037900008, -65.39202239399992],
              [103.38998457100007, -65.41562265399995],
              [103.40853925900007, -65.4235979149999],
              [103.41911868600005, -65.43474700299993],
              [103.41602623800003, -65.44866301899992],
              [103.40064537900008, -65.45794036299992],
              [103.38135826900003, -65.46355559699992],
              [103.32252037900008, -65.47161223799992],
              [103.21273847700007, -65.46884530999995],
              [103.17221113400007, -65.46062590899993],
              [103.13965905000003, -65.44475676899992],
              [103.13013756600003, -65.43092213299991],
              [103.13843834700003, -65.38298919099992],
              [103.14551842500003, -65.3630510399999],
              [103.13933353000004, -65.33831145599993],
              [103.10401451900003, -65.30462004999993],
              [103.08472741000003, -65.29461028399993],
              [103.03785241000003, -65.28036874799994],
              [102.82699629000007, -65.25058359199994],
              [102.77613366000003, -65.23251718499995],
              [102.77458743600005, -65.22600676899992],
              [102.75220787900008, -65.17831796699994],
              [102.78158613400007, -65.14072030999995],
              [102.83936608200003, -65.12769947699991],
              [102.91065514400003, -65.13176848799992],
              [103.09310957100007, -65.1735979149999],
              [103.15137780000003, -65.19768645599993],
              [103.18881269600007, -65.22966887799993],
              [103.19662519600007, -65.26336028399993],
              [103.16773522200003, -65.30242278399993],
              [103.17741946700005, -65.33473072699991],
              [103.19825280000003, -65.35613372199992],
              [103.22584069100003, -65.37184010199991],
              [103.29127037900008, -65.39202239399992],
            ],
          ],
          [
            [
              [-90.60692298099991, -68.81747812299994],
              [-90.61021887899994, -68.81552499799994],
              [-90.61497962099992, -68.81113046699994],
              [-90.62490800699993, -68.80242278399993],
              [-90.6336156889999, -68.79387786299992],
              [-90.63857988199993, -68.78508879999993],
              [-90.63459225199995, -68.7736955709999],
              [-90.62376868399991, -68.76864999799994],
              [-90.62328040299991, -68.76140715899993],
              [-90.62328040299991, -68.75212981599992],
              [-90.61803137899994, -68.7439104149999],
              [-90.61497962099992, -68.73552825299993],
              [-90.61571204299992, -68.73064544099992],
              [-90.61229407499991, -68.72795989399992],
              [-90.60334225199995, -68.72625090899993],
              [-90.58665930899991, -68.72649504999993],
              [-90.5762426419999, -68.72722747199992],
              [-90.55719967399995, -68.72812265399995],
              [-90.54820716099994, -68.72918059699992],
              [-90.53502356699994, -68.73259856599992],
              [-90.52196204299992, -68.74260833099993],
              [-90.51170813699991, -68.75261809699992],
              [-90.51170813699991, -68.75709400799991],
              [-90.50942949099993, -68.76295338299991],
              [-90.50772050699993, -68.76995208099993],
              [-90.50572669199994, -68.77841562299994],
              [-90.50121008999992, -68.7854143209999],
              [-90.50475012899994, -68.79745859199994],
              [-90.51244055899991, -68.80917734199994],
              [-90.51943925699993, -68.81145598799992],
              [-90.52269446499992, -68.81194426899992],
              [-90.53368079299992, -68.81243254999993],
              [-90.55313066299993, -68.8122697899999],
              [-90.56745357999995, -68.8127580709999],
              [-90.58177649599992, -68.8142229149999],
              [-90.59569251199991, -68.81601327899995],
              [-90.60391191299993, -68.81747812299994],
              [-90.60692298099991, -68.81747812299994],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Fr. S. Antarctic Lands',
        iso3: 'ATF',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [42.75180097700007, -17.076104424999926],
              [42.72437584700003, -17.063571872999944],
              [42.73812910200007, -17.057305596999925],
              [42.758799675000034, -17.06064218499995],
              [42.75180097700007, -17.076104424999926],
            ],
          ],
          [
            [
              [69.94564863400007, -49.54216887799993],
              [69.92847741000008, -49.541273695999905],
              [69.91675866000008, -49.53630950299993],
              [69.90560957100007, -49.52898528399993],
              [69.89112389400003, -49.521742445999905],
              [69.87533613400007, -49.517836195999905],
              [69.84782962300005, -49.514336846999925],
              [69.83578535200007, -49.50798919099992],
              [69.83578535200007, -49.50115325299993],
              [69.87964928500008, -49.492445570999905],
              [69.92058353000004, -49.49700286299992],
              [69.97299238400007, -49.53533294099992],
              [70.00456790500004, -49.551446221999925],
              [70.01612389400003, -49.5642229149999],
              [70.00709069100003, -49.57634856599992],
              [69.99301191500007, -49.57463958099993],
              [69.94564863400007, -49.54216887799993],
            ],
          ],
          [
            [
              [68.79509524800005, -49.3435197899999],
              [68.78614342500003, -49.35702890399995],
              [68.77320397200003, -49.36370208099993],
              [68.75733483200008, -49.363539320999905],
              [68.73975670700008, -49.35662200299993],
              [68.68921959700003, -49.35662200299993],
              [68.66553795700008, -49.35247161299992],
              [68.64340254000007, -49.3435197899999],
              [68.66277103000004, -49.32244231599992],
              [68.67359459700003, -49.31682708099993],
              [68.69125410200007, -49.31560637799993],
              [68.70875084700003, -49.31853606599992],
              [68.74187259200005, -49.32870859199994],
              [68.75953209700003, -49.3298479149999],
              [68.79135175900007, -49.32366301899992],
              [68.79835045700008, -49.32732512799993],
              [68.79509524800005, -49.3435197899999],
            ],
          ],
          [
            [
              [69.58952884200005, -49.19963958099993],
              [69.57504316500007, -49.20435963299991],
              [69.56023196700005, -49.20623137799993],
              [69.54623457100007, -49.2028947899999],
              [69.53419030000003, -49.19280364399992],
              [69.64161217500003, -49.1540666649999],
              [69.67807050900007, -49.15178801899992],
              [69.67807050900007, -49.15862395599993],
              [69.65544681100005, -49.16887786299992],
              [69.64177493600005, -49.191664320999905],
              [69.62403405000003, -49.20826588299991],
              [69.58952884200005, -49.19963958099993],
            ],
          ],
          [
            [
              [69.19214928500008, -48.986586195999905],
              [69.19874108200008, -48.97576262799993],
              [69.20899498800009, -48.968682549999926],
              [69.22006269600007, -48.962823174999926],
              [69.22934004000007, -48.95598723799992],
              [69.26392662900008, -48.921807549999926],
              [69.28484134200005, -48.9060197899999],
              [69.31275475400008, -48.892510674999926],
              [69.34294681100005, -48.88420989399992],
              [69.37037194100003, -48.88420989399992],
              [69.35889733200008, -48.905368747999944],
              [69.32764733200008, -48.92392343499995],
              [69.31511478000004, -48.93889739399992],
              [69.39779707100007, -48.92848072699991],
              [69.41130618600005, -48.92864348799992],
              [69.40626061300009, -48.9431291649999],
              [69.39429772200003, -48.9587541649999],
              [69.38062584700003, -48.97234465899993],
              [69.37037194100003, -48.98056405999995],
              [69.33521569100003, -48.997979424999926],
              [69.32178795700008, -49.01034921699994],
              [69.32536868600005, -49.02483489399992],
              [69.33480879000007, -49.043633721999925],
              [69.32203209700003, -49.05364348799992],
              [69.29981530000003, -49.0603166649999],
              [69.31128991000008, -49.069431247999944],
              [69.22250410200007, -49.09433359199994],
              [69.20582116000008, -49.086602471999925],
              [69.20582116000008, -49.035088799999926],
              [69.20289147200003, -49.02190520599993],
              [69.19361412900008, -48.99374765399995],
              [69.19214928500008, -48.986586195999905],
            ],
          ],
          [
            [
              [69.22632897200003, -48.85702890399995],
              [69.23096764400003, -48.87786223799992],
              [69.24195397200003, -48.8767229149999],
              [69.24683678500008, -48.880791924999926],
              [69.24390709700003, -48.89006926899992],
              [69.23666425900007, -48.89462655999995],
              [69.22771243600005, -48.898370049999926],
              [69.21892337300005, -48.90471770599993],
              [69.20932050900007, -48.91887786299992],
              [69.19459069100003, -48.94817473799992],
              [69.17790774800005, -48.96917083099993],
              [69.16618899800005, -48.9782854149999],
              [69.15357506600003, -48.98316822699991],
              [69.14380944100003, -48.98056405999995],
              [69.13705488400007, -48.97112395599993],
              [69.13990319100003, -48.96819426899992],
              [69.15162194100003, -48.9333635399999],
              [69.15064537900008, -48.93206145599993],
              [69.16277103000004, -48.906508070999905],
              [69.18083743600005, -48.88103606599992],
              [69.20281009200005, -48.86223723799992],
              [69.22632897200003, -48.85702890399995],
            ],
          ],
          [
            [
              [69.46599368600005, -48.88420989399992],
              [69.44662519600007, -48.87623463299991],
              [69.42839603000004, -48.86443450299993],
              [69.41358483200008, -48.84880950299993],
              [69.40447024800005, -48.82903411299992],
              [69.43767337300005, -48.82927825299993],
              [69.48601321700005, -48.85564544099992],
              [69.51986738400007, -48.85702890399995],
              [69.51221764400003, -48.87004973799992],
              [69.49952233200008, -48.87835051899992],
              [69.48365319100003, -48.882745049999926],
              [69.46599368600005, -48.88420989399992],
            ],
          ],
          [
            [
              [70.54883873800009, -49.18320077899995],
              [70.56853274800005, -49.219414971999925],
              [70.55600019600007, -49.26685963299991],
              [70.52369225400008, -49.30754973799992],
              [70.46387780000003, -49.35662200299993],
              [70.39177493600005, -49.348728122999944],
              [70.35938561300009, -49.33806731599992],
              [70.33594811300009, -49.351820570999905],
              [70.33130944100003, -49.369073174999926],
              [70.31153405000003, -49.37851327899995],
              [70.39380944100003, -49.4040666649999],
              [70.46648196700005, -49.43914153399993],
              [70.37566165500004, -49.430352471999925],
              [70.28834069100003, -49.43914153399993],
              [70.24341881600003, -49.35995859199994],
              [70.13990319100003, -49.33879973799992],
              [70.10132897200003, -49.347588799999926],
              [70.06275475400008, -49.358493747999944],
              [70.01636803500008, -49.360039971999925],
              [69.96998131600003, -49.35320403399993],
              [69.89535566500007, -49.34148528399993],
              [69.82227623800009, -49.34978606599992],
              [69.87484785200007, -49.367120049999926],
              [69.92530358200008, -49.391289971999925],
              [69.91285241000008, -49.39568450299993],
              [69.90040123800009, -49.40007903399993],
              [69.92253665500004, -49.41659921699994],
              [69.94564863400007, -49.432305596999925],
              [69.92139733200008, -49.43889739399992],
              [69.89844811300009, -49.4431291649999],
              [69.86890709700003, -49.421807549999926],
              [69.84066816500007, -49.39723072699991],
              [69.81544030000003, -49.39153411299992],
              [69.79493248800009, -49.40447356599992],
              [69.79737389400003, -49.42131926899992],
              [69.81544030000003, -49.453383070999905],
              [69.75619550900007, -49.42302825299993],
              [69.69190514400003, -49.40447356599992],
              [69.71452884200005, -49.427666924999926],
              [69.74415123800009, -49.44198984199994],
              [69.76596113400007, -49.45663827899995],
              [69.77409915500004, -49.47161223799992],
              [69.78858483200008, -49.47893645599993],
              [69.80176842500003, -49.48756275799991],
              [69.80543053500008, -49.51140715899993],
              [69.81381269600007, -49.53248463299991],
              [69.89283287900008, -49.56023528399993],
              [69.97771243600005, -49.570570570999905],
              [70.05697675900007, -49.59465911299992],
              [70.13697350400008, -49.617852471999925],
              [70.06527754000007, -49.57350025799991],
              [70.04908287900008, -49.52044036299992],
              [70.09262129000007, -49.510430596999925],
              [70.13835696700005, -49.5056291649999],
              [70.18002363400007, -49.5134416649999],
              [70.21998131600003, -49.52597421699994],
              [70.29590905000003, -49.530368747999944],
              [70.32398522200003, -49.574476820999905],
              [70.25668379000007, -49.61484140399995],
              [70.16480553500008, -49.617852471999925],
              [70.22836347700007, -49.63030364399992],
              [70.27605228000004, -49.6540666649999],
              [70.24431399800005, -49.685479424999926],
              [70.19239342500003, -49.68482838299991],
              [70.15365644600007, -49.69264088299991],
              [70.12322024800005, -49.713555596999925],
              [70.06804446700005, -49.71502044099992],
              [70.01270592500003, -49.69890715899993],
              [69.92872155000003, -49.70159270599993],
              [69.85564212300005, -49.67913176899992],
              [69.82064863400007, -49.64080169099992],
              [69.78793379000007, -49.60369231599992],
              [69.78296959700003, -49.561618747999944],
              [69.77857506600003, -49.52027760199991],
              [69.73853600400008, -49.49879322699991],
              [69.69190514400003, -49.50115325299993],
              [69.70720462300005, -49.51531340899993],
              [69.70557701900003, -49.53533294099992],
              [69.67310631600003, -49.51262786299992],
              [69.63721764400003, -49.504571221999925],
              [69.67212975400008, -49.54452890399995],
              [69.71501712300005, -49.58171965899993],
              [69.71241295700008, -49.636976820999905],
              [69.66391035200007, -49.66497161299992],
              [69.62680097700007, -49.65683359199994],
              [69.59229576900003, -49.64397551899992],
              [69.53093509200005, -49.64080169099992],
              [69.46973717500003, -49.63144296699994],
              [69.41895592500003, -49.60165780999995],
              [69.37338300900007, -49.56609465899993],
              [69.32585696700005, -49.563164971999925],
              [69.28101647200003, -49.56267669099992],
              [69.25806725400008, -49.52206796699994],
              [69.22738691500007, -49.48845794099992],
              [69.20362389400003, -49.49627044099992],
              [69.21225019600007, -49.51726653399993],
              [69.20533287900008, -49.519463799999926],
              [69.19841556100005, -49.521742445999905],
              [69.21810957100007, -49.54566822699991],
              [69.23194420700008, -49.57301197699991],
              [69.18409264400003, -49.555352471999925],
              [69.14380944100003, -49.514336846999925],
              [69.15577233200008, -49.54176197699991],
              [69.16724694100003, -49.56959400799991],
              [69.17798912900008, -49.5837541649999],
              [69.15381920700008, -49.59880950299993],
              [69.15064537900008, -49.624118747999944],
              [69.11451256600003, -49.60312265399995],
              [69.10580488400007, -49.5603166649999],
              [69.08545983200008, -49.54029713299991],
              [69.07227623800009, -49.58171965899993],
              [69.10401451900003, -49.6443010399999],
              [69.06657962300005, -49.69101327899995],
              [69.02564537900008, -49.70989348799992],
              [68.98194420700008, -49.72161223799992],
              [68.97095787900008, -49.71738046699994],
              [68.96290123800009, -49.7126604149999],
              [68.94703209700003, -49.71379973799992],
              [68.92823326900003, -49.71542734199994],
              [68.87956790500004, -49.71648528399993],
              [68.83171634200005, -49.71721770599993],
              [68.79102623800009, -49.710056247999944],
              [68.76449629000007, -49.67498137799993],
              [68.76563561300009, -49.65113697699991],
              [68.77662194100003, -49.63054778399993],
              [68.77816816500007, -49.592461846999925],
              [68.79883873800009, -49.564711195999905],
              [68.82390384200005, -49.535088799999926],
              [68.84278405000003, -49.50798919099992],
              [68.82243899800005, -49.48447030999995],
              [68.86524498800009, -49.46233489399992],
              [68.90170332100007, -49.43108489399992],
              [68.87525475400008, -49.39690520599993],
              [68.86915123800009, -49.36793385199991],
              [68.84693444100003, -49.36337655999995],
              [68.80648847700007, -49.36581796699994],
              [68.85718834700003, -49.32830169099992],
              [68.92408287900008, -49.32244231599992],
              [68.92066491000008, -49.30527109199994],
              [68.92408287900008, -49.28826262799993],
              [68.89185631600003, -49.29648202899995],
              [68.83611087300005, -49.303399346999925],
              [68.81478925900007, -49.28142669099992],
              [68.83204186300009, -49.27662525799991],
              [68.84961998800009, -49.27467213299991],
              [68.79281660200007, -49.24814218499995],
              [68.77377363400007, -49.205743096999925],
              [68.76433353000004, -49.18889739399992],
              [68.77035566500007, -49.175713799999926],
              [68.78598066500007, -49.190118096999925],
              [68.80860436300009, -49.205743096999925],
              [68.85775800900007, -49.173760674999926],
              [68.93091881600003, -49.14495208099993],
              [68.85434004000007, -49.14902109199994],
              [68.80111738400007, -49.13128020599993],
              [68.82398522200003, -49.11793385199991],
              [68.84961998800009, -49.11077239399992],
              [68.81055748800009, -49.110446872999944],
              [68.77198326900003, -49.11077239399992],
              [68.77621504000007, -49.09685637799993],
              [68.78060957100007, -49.08294036299992],
              [68.74878991000008, -49.07675546699994],
              [68.75554446700005, -49.04762135199991],
              [68.79468834700003, -49.0407854149999],
              [68.82740319100003, -49.05413176899992],
              [68.81299889400003, -49.016696872999944],
              [68.81324303500008, -48.965101820999905],
              [68.86060631600003, -48.96575286299992],
              [68.90308678500008, -48.97470468499995],
              [68.87867272200003, -48.94459400799991],
              [68.85035241000008, -48.91643645599993],
              [68.82292728000004, -48.88909270599993],
              [68.79810631600003, -48.86451588299991],
              [68.79175866000008, -48.84628671699994],
              [68.81527754000007, -48.83798593499995],
              [68.85572350400008, -48.82170989399992],
              [68.89682050900007, -48.82284921699994],
              [68.89812259200005, -48.80136484199994],
              [68.90300540500004, -48.78134530999995],
              [68.93132571700005, -48.76620859199994],
              [68.93474368600005, -48.73642343499995],
              [68.92066491000008, -48.72283294099992],
              [68.93832441500007, -48.69866301899992],
              [68.95679772200003, -48.67148202899995],
              [69.01563561300009, -48.654554945999905],
              [69.07545006600003, -48.65837981599992],
              [69.06072024800005, -48.67107512799993],
              [69.08228600400008, -48.692478122999944],
              [69.07545006600003, -48.71298593499995],
              [69.11646569100003, -48.72665780999995],
              [68.98292076900003, -48.79851653399993],
              [68.90821373800009, -48.89397551899992],
              [68.92310631600003, -48.88396575299993],
              [68.93726647200003, -48.873304945999905],
              [68.96045983200008, -48.86874765399995],
              [68.98609459700003, -48.87737395599993],
              [68.97364342500003, -48.84335702899995],
              [69.00749759200005, -48.83277760199991],
              [69.02027428500008, -48.85702890399995],
              [69.07422936300009, -48.79045989399992],
              [69.15064537900008, -48.754571221999925],
              [69.17432701900003, -48.75660572699991],
              [69.18881269600007, -48.77304452899995],
              [69.15357506600003, -48.79257577899995],
              [69.10906009200005, -48.808526299999926],
              [69.13656660200007, -48.83147551899992],
              [69.16431725400008, -48.808526299999926],
              [69.16374759200005, -48.84612395599993],
              [69.13070722700007, -48.880791924999926],
              [69.08057701900003, -48.90642669099992],
              [69.05445397200003, -48.946384372999944],
              [69.08228600400008, -48.93124765399995],
              [69.11150149800005, -48.91912200299993],
              [69.08375084700003, -48.97340260199991],
              [69.02222741000008, -49.01018645599993],
              [69.00749759200005, -49.047539971999925],
              [68.99976647200003, -49.09042734199994],
              [69.03435306100005, -49.10035572699991],
              [69.06812584700003, -49.11077239399992],
              [69.05689537900008, -49.03915780999995],
              [69.10572350400008, -48.99342213299991],
              [69.14372806100005, -49.00839609199994],
              [69.16911868600005, -49.04355234199994],
              [69.17367597700007, -49.07952239399992],
              [69.17847741000008, -49.11060963299991],
              [69.21452884200005, -49.12127044099992],
              [69.24659264400003, -49.109633070999905],
              [69.35206139400003, -49.08098723799992],
              [69.43799889400003, -49.01458098799992],
              [69.45093834700003, -49.02988046699994],
              [69.45736738400007, -49.04851653399993],
              [69.44874108200008, -49.06894296699994],
              [69.43767337300005, -49.07887135199991],
              [69.45248457100007, -49.088962497999944],
              [69.47152754000007, -49.08123137799993],
              [69.52133222700007, -48.99537525799991],
              [69.58952884200005, -48.95256926899992],
              [69.58912194100003, -48.97975025799991],
              [69.59791100400008, -49.00603606599992],
              [69.61605879000007, -49.01458098799992],
              [69.58204186300009, -49.02825286299992],
              [69.56820722700007, -49.048760674999926],
              [69.61801191500007, -49.047946872999944],
              [69.65772545700008, -49.062432549999926],
              [69.62614993600005, -49.07577890399995],
              [69.58204186300009, -49.09042734199994],
              [69.64405358200008, -49.100274346999925],
              [69.64405358200008, -49.12444426899992],
              [69.58716881600003, -49.13339609199994],
              [69.53077233200008, -49.13811614399992],
              [69.50798587300005, -49.13103606599992],
              [69.48487389400003, -49.12420012799993],
              [69.39991295700008, -49.11370208099993],
              [69.33985436300009, -49.150323174999926],
              [69.31226647200003, -49.16692473799992],
              [69.28248131600003, -49.184258721999925],
              [69.29704837300005, -49.195245049999926],
              [69.32406660200007, -49.184258721999925],
              [69.35181725400008, -49.17083098799992],
              [69.41993248800009, -49.13689544099992],
              [69.47217858200008, -49.15178801899992],
              [69.42725670700008, -49.16920338299991],
              [69.38103274800005, -49.18254973799992],
              [69.44548587300005, -49.19622161299992],
              [69.43775475400008, -49.215101820999905],
              [69.47217858200008, -49.21998463299991],
              [69.49594160200007, -49.23967864399992],
              [69.53419030000003, -49.23992278399993],
              [69.53419030000003, -49.24374765399995],
              [69.53419030000003, -49.24732838299991],
              [69.47193444100003, -49.253838799999926],
              [69.41130618600005, -49.27467213299991],
              [69.49610436300009, -49.269789320999905],
              [69.58082116000008, -49.26482512799993],
              [69.65650475400008, -49.25400155999995],
              [69.72592207100007, -49.24732838299991],
              [69.66382897200003, -49.284274997999944],
              [69.58204186300009, -49.30201588299991],
              [69.64893639400003, -49.308851820999905],
              [69.71225019600007, -49.30681731599992],
              [69.75098717500003, -49.28134530999995],
              [69.78793379000007, -49.254164320999905],
              [69.79232832100007, -49.27223072699991],
              [69.80176842500003, -49.28826262799993],
              [69.82943769600007, -49.25872161299992],
              [69.86085045700008, -49.24041106599992],
              [69.85743248800009, -49.22323984199994],
              [69.85377037900008, -49.20907968499995],
              [69.87525475400008, -49.20452239399992],
              [69.89779707100007, -49.205743096999925],
              [69.89747155000003, -49.187432549999926],
              [69.91814212300005, -49.18027109199994],
              [69.94125410200007, -49.174899997999944],
              [69.95573978000004, -49.15943775799991],
              [69.99293053500008, -49.14706796699994],
              [70.03174889400003, -49.134698174999926],
              [70.09001712300005, -49.121026299999926],
              [70.15113366000008, -49.13811614399992],
              [70.14730879000007, -49.14902109199994],
              [70.14307701900003, -49.15935637799993],
              [70.19402103000004, -49.156914971999925],
              [70.23519941500007, -49.13241952899995],
              [70.27295983200008, -49.076429945999905],
              [70.33594811300009, -49.05396900799991],
              [70.40821373800009, -49.05632903399993],
              [70.47706139400003, -49.073337497999944],
              [70.52198326900003, -49.09587981599992],
              [70.52857506600003, -49.14495208099993],
              [70.54883873800009, -49.18320077899995],
            ],
          ],
          [
            [
              [68.67074629000007, -48.62420012799993],
              [68.68148847700007, -48.63640715899993],
              [68.66797936300009, -48.64527760199991],
              [68.64405358200008, -48.64861419099992],
              [68.62305748800009, -48.64413827899995],
              [68.61011803500008, -48.63762786299992],
              [68.62598717500003, -48.62981536299992],
              [68.65235436300009, -48.62420012799993],
              [68.67074629000007, -48.62420012799993],
            ],
          ],
          [
            [
              [68.80860436300009, -48.60369231599992],
              [68.79004967500003, -48.615899346999925],
              [68.78003991000008, -48.60475025799991],
              [68.78101647200003, -48.58456796699994],
              [68.79509524800005, -48.569024346999925],
              [68.81861412900008, -48.566664320999905],
              [68.83082116000008, -48.57740650799991],
              [68.82862389400003, -48.59270598799992],
              [68.80860436300009, -48.60369231599992],
            ],
          ],
          [
            [
              [51.83415774800005, -46.37664153399993],
              [51.84457441500007, -46.382745049999926],
              [51.85279381600009, -46.390557549999926],
              [51.868174675000034, -46.41025155999995],
              [51.82349694100009, -46.45126718499995],
              [51.78874759200005, -46.44589609199994],
              [51.772146030000044, -46.445245049999926],
              [51.75831139400003, -46.45126718499995],
              [51.728526238000086, -46.44744231599992],
              [51.70557701900003, -46.43759530999995],
              [51.68677819100009, -46.42245859199994],
              [51.66960696700005, -46.40398528399993],
              [51.65650475400008, -46.37835051899992],
              [51.66749108200008, -46.363539320999905],
              [51.73601321700005, -46.32740650799991],
              [51.75953209700003, -46.32935963299991],
              [51.778086785000085, -46.342868747999944],
              [51.78565514400003, -46.36614348799992],
              [51.792979363000086, -46.37232838299991],
              [51.80909264400003, -46.375258070999905],
              [51.83415774800005, -46.37664153399993],
            ],
          ],
          [
            [
              [50.17554772200003, -46.064711195999905],
              [50.18970787900008, -46.05681731599992],
              [50.26807701900003, -46.04371510199991],
              [50.28142337300005, -46.05803801899992],
              [50.29314212300005, -46.07634856599992],
              [50.29835045700008, -46.09644947699991],
              [50.29224694100009, -46.11598072699991],
              [50.277679884000065, -46.12704843499995],
              [50.260752800000034, -46.12712981599992],
              [50.223317905000044, -46.11598072699991],
              [50.201182488000086, -46.11345794099992],
              [50.18637129000007, -46.10320403399993],
              [50.178070509000065, -46.086602471999925],
              [50.17554772200003, -46.064711195999905],
            ],
          ],
          [
            [
              [77.50375410200007, -37.82350025799991],
              [77.54395592500003, -37.820245049999926],
              [77.57471764400003, -37.8435197899999],
              [77.58521569100003, -37.87420012799993],
              [77.56527754000007, -37.89316171699994],
              [77.53663170700008, -37.90113697699991],
              [77.50464928500008, -37.88241952899995],
              [77.48755944100003, -37.85165780999995],
              [77.50375410200007, -37.82350025799991],
            ],
          ],
          [
            [
              [77.53288821700005, -38.70916106599992],
              [77.54525800900007, -38.72340260199991],
              [77.54932701900003, -38.731133721999925],
              [77.54468834700003, -38.73748137799993],
              [77.53614342500003, -38.73845794099992],
              [77.51636803500008, -38.735446872999944],
              [77.51246178500008, -38.72991301899992],
              [77.50652103000004, -38.713148695999905],
              [77.51091556100005, -38.705743096999925],
              [77.51905358200008, -38.70240650799991],
              [77.52751712300005, -38.705743096999925],
              [77.53288821700005, -38.70916106599992],
            ],
          ],
          [
            [
              [40.37973066500007, -22.32390715899993],
              [40.37916100400008, -22.31487395599993],
              [40.385508660000085, -22.317803643999923],
              [40.38599694100009, -22.339450778999947],
              [40.36866295700008, -22.36256275799991],
              [40.34888756600009, -22.365492445999905],
              [40.33912194100009, -22.359633070999905],
              [40.33179772200003, -22.34807708099993],
              [40.32960045700008, -22.331231377999927],
              [40.33643639400009, -22.320489190999922],
              [40.347992384000065, -22.317071221999925],
              [40.35865319100009, -22.316013278999947],
              [40.364268425000034, -22.31894296699994],
              [40.367198113000086, -22.329685153999947],
              [40.36345462300005, -22.33489348799992],
              [40.35857181100005, -22.338636976999908],
              [40.35523522200003, -22.34498463299991],
              [40.36109459700003, -22.35084400799991],
              [40.374034050000034, -22.34970468499995],
              [40.38168379000007, -22.339043877999927],
              [40.37973066500007, -22.32390715899993],
            ],
          ],
          [
            [
              [39.72828209700009, -21.44459400799991],
              [39.72909589900013, -21.44190846099991],
              [39.731130405000044, -21.44418710699989],
              [39.72828209700009, -21.44459400799991],
            ],
          ],
          [
            [
              [54.514496290000125, -15.889580987999864],
              [54.520925326000054, -15.885186455999872],
              [54.52133222700007, -15.894056898999906],
              [54.514496290000125, -15.889580987999864],
            ],
          ],
          [
            [
              [47.287933790000125, -11.565524997999944],
              [47.29957116000003, -11.550632419999886],
              [47.30640709700015, -11.569919528999947],
              [47.287933790000125, -11.565524997999944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Seychelles',
        iso3: 'SYC',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [46.509776238000086, -9.71998463299991],
              [46.50757897200003, -9.731866143999923],
              [46.500661655000044, -9.746514580999929],
              [46.49048912900008, -9.75554778399993],
              [46.47966556100005, -9.751071872999944],
              [46.478526238000086, -9.740411065999922],
              [46.486989780000044, -9.73015715899993],
              [46.49935957100007, -9.72275155999995],
              [46.509776238000086, -9.71998463299991],
            ],
          ],
          [
            [
              [47.50733483200008, -9.713067315999922],
              [47.50733483200008, -9.69817473799992],
              [47.51295006600009, -9.694431247999944],
              [47.51579837300005, -9.70012786299992],
              [47.50733483200008, -9.713067315999922],
            ],
          ],
          [
            [
              [53.333994988000086, -5.420179945999905],
              [53.34164472700007, -5.429945570999905],
              [53.344086134000065, -5.434747002999927],
              [53.344737175000034, -5.441013278999947],
              [53.340505405000044, -5.436211846999925],
              [53.337901238000086, -5.431247653999947],
              [53.333994988000086, -5.420179945999905],
            ],
          ],
          [
            [
              [55.65967858200008, -3.791110934999949],
              [55.66586347700007, -3.81178150799991],
              [55.658539259000065, -3.811700127999927],
              [55.65186608200008, -3.801202080999929],
              [55.65967858200008, -3.791110934999949],
            ],
          ],
          [
            [
              [46.49545332100007, -9.357598565999922],
              [46.515961134000065, -9.371758721999925],
              [46.52515709700003, -9.381280205999929],
              [46.52003014400009, -9.385511976999908],
              [46.50709069100009, -9.39072030999995],
              [46.47291100400008, -9.416436455999929],
              [46.45460045700008, -9.426446221999925],
              [46.38070722700007, -9.424574476999908],
              [46.299815300000034, -9.44931405999995],
              [46.234385613000086, -9.452325127999927],
              [46.207367384000065, -9.385511976999908],
              [46.230479363000086, -9.413669528999947],
              [46.274099155000044, -9.426364841999941],
              [46.32048587300005, -9.423760674999926],
              [46.351573113000086, -9.40593840899993],
              [46.36898847700007, -9.406833591999941],
              [46.39600670700008, -9.398370049999926],
              [46.42156009200005, -9.386895440999922],
              [46.434580925000034, -9.378106377999927],
              [46.44076582100007, -9.385511976999908],
              [46.44776451900009, -9.378106377999927],
              [46.457692905000044, -9.382989190999922],
              [46.468760613000086, -9.385511976999908],
              [46.468760613000086, -9.378106377999927],
              [46.45875084700003, -9.371677341999941],
              [46.45281009200005, -9.362399997999944],
              [46.449554884000065, -9.35084400799991],
              [46.44776451900009, -9.33766041499996],
              [46.49545332100007, -9.357598565999922],
            ],
          ],
          [
            [
              [46.283864780000044, -9.35133228999996],
              [46.28207441500007, -9.348077080999929],
              [46.28256269600007, -9.34579843499995],
              [46.28174889400009, -9.344496351999908],
              [46.276377800000034, -9.343926690999922],
              [46.276133660000085, -9.339288018999923],
              [46.278005405000044, -9.338474216999941],
              [46.28093509200005, -9.33879973799992],
              [46.315196160000085, -9.326429945999905],
              [46.35368899800005, -9.328871351999908],
              [46.39307701900009, -9.335870049999926],
              [46.42709394600007, -9.33766041499996],
              [46.41065514400009, -9.35328541499996],
              [46.37940514400009, -9.357028903999947],
              [46.347992384000065, -9.352634372999944],
              [46.331065300000034, -9.343926690999922],
              [46.318369988000086, -9.35084400799991],
              [46.295664910000085, -9.347588799999926],
              [46.283864780000044, -9.35133228999996],
            ],
          ],
          [
            [
              [56.247080925000034, -7.19264088299991],
              [56.258799675000034, -7.140232028999947],
              [56.26937910200007, -7.119805596999925],
              [56.287445509000065, -7.110039971999925],
              [56.28296959700003, -7.131931247999944],
              [56.272471550000034, -7.15357838299991],
              [56.247080925000034, -7.19264088299991],
            ],
          ],
          [
            [
              [55.401702493555085, -4.660533556469527],
              [55.394427124719506, -4.657864036267465],
              [55.394896710379044, -4.653859894000115],
              [55.40007972536198, -4.652940803449829],
              [55.39752693797505, -4.649840990194281],
              [55.38950389190187, -4.647288202807359],
              [55.3796574262666, -4.649476306281864],
              [55.371269696281, -4.646923518894941],
              [55.36561709563853, -4.642729653902141],
              [55.36725817324441, -4.639265156734175],
              [55.37491653540517, -4.63999452455901],
              [55.3776516647483, -4.637806421084505],
              [55.374734193448965, -4.632700846310661],
              [55.38840984016462, -4.619572225463633],
              [55.39460946667571, -4.617019438076711],
              [55.40685147395924, -4.616065089342696],
              [55.41761752389521, -4.611384198066187],
              [55.422298415171724, -4.603426682896123],
              [55.426117384000065, -4.595472914999959],
              [55.431651238000086, -4.591566664999959],
              [55.434336785000085, -4.579522393999923],
              [55.43369823758125, -4.562544654049493],
              [55.44061383349883, -4.560510655250204],
              [55.447529429416406, -4.561120854889991],
              [55.454897187657004, -4.56223443264989],
              [55.46385965948858, -4.571383622644619],
              [55.46722058642541, -4.583426944168291],
              [55.46311278683594, -4.587908180084076],
              [55.45993682209207, -4.598546432796902],
              [55.45993682209207, -4.606479028114127],
              [55.45884595359554, -4.618115330384728],
              [55.46176742101143, -4.622547618628507],
              [55.457189711794115, -4.623999701602007],
              [55.45668242401321, -4.62580201670737],
              [55.4644116194505, -4.625395216947512],
              [55.47566057572392, -4.639937634852889],
              [55.49766076472351, -4.655384576065368],
              [55.51638432982954, -4.668022982511941],
              [55.52855464714847, -4.680193299830863],
              [55.5215333102337, -4.707810558362264],
              [55.52527802325491, -4.713895717021725],
              [55.52808655802082, -4.736832084276617],
              [55.5196609537231, -4.739172529914872],
              [55.51685241895719, -4.750406668978492],
              [55.52574611238256, -4.770066412339828],
              [55.52719160200007, -4.783786716999941],
              [55.53463980580793, -4.789726155701165],
              [55.53791642970148, -4.80376882953069],
              [55.5196609537231, -4.80376882953069],
              [55.50421401251062, -4.795811314360625],
              [55.491107516936395, -4.772874947105733],
              [55.48689471478754, -4.762108897169764],
              [55.478001021362175, -4.758832273276208],
              [55.47097968444741, -4.763513164552716],
              [55.463490258404995, -4.759768451531509],
              [55.4681711496815, -4.741512975553126],
              [55.48477817233816, -4.741601501378046],
              [55.491575606064046, -4.736363995148967],
              [55.485022358276936, -4.7274703017236],
              [55.48034146700043, -4.721385143064139],
              [55.48174573438338, -4.712959538766423],
              [55.478001021362175, -4.706406290979311],
              [55.4681711496815, -4.70547011272401],
              [55.45834127800084, -4.690959349766833],
              [55.44897949544782, -4.677852854192609],
              [55.435404910745945, -4.676448586809657],
              [55.41808561302286, -4.666150626001337],
              [55.40919682317241, -4.660781507566805],
              [55.401702493555085, -4.660533556469527],
            ],
          ],
          [
            [
              [55.26026451900003, -4.500095309999949],
              [55.24195397200003, -4.504001559999949],
              [55.22803795700008, -4.487481377999927],
              [55.221446160000085, -4.463474216999941],
              [55.22543379000007, -4.444919528999947],
              [55.24203535200007, -4.450372002999927],
              [55.25993899800005, -4.462985934999949],
              [55.26921634200005, -4.48015715899993],
              [55.26026451900003, -4.500095309999949],
            ],
          ],
          [
            [
              [55.71763486357105, -4.330116463929826],
              [55.704101781285985, -4.327859605229037],
              [55.6920080130026, -4.326297434962822],
              [55.68457102446101, -4.318860446421231],
              [55.68376657952329, -4.311549502559813],
              [55.67717478252329, -4.296412783559815],
              [55.69011423552323, -4.291774111559817],
              [55.696950173523284, -4.290553408559815],
              [55.70443715252325, -4.290227887559836],
              [55.718678688523234, -4.303248720559821],
              [55.73215057185158, -4.308817604088369],
              [55.74666987878329, -4.31142345787964],
              [55.75447871675196, -4.321091542983709],
              [55.764518651283105, -4.316629349858754],
              [55.77716153180381, -4.318488596994151],
              [55.787038063523234, -4.330592470559821],
              [55.77092478252329, -4.331324892559819],
              [55.76823923552323, -4.339625673559822],
              [55.76799509552328, -4.350286481559833],
              [55.75912465252325, -4.358424502559813],
              [55.74675486052323, -4.358098981559833],
              [55.73275746452325, -4.352239606559833],
              [55.72331736052323, -4.342555361559817],
              [55.71763486357105, -4.330116463929826],
            ],
          ],
          [
            [
              [52.74187259200005, -6.994317315999922],
              [52.74724368600005, -7.005059502999927],
              [52.74341881600009, -7.004082940999922],
              [52.742198113000086, -7.001722914999959],
              [52.742198113000086, -6.998467705999929],
              [52.74187259200005, -6.994317315999922],
            ],
          ],
          [
            [
              [55.382823113000086, -5.853936455999929],
              [55.381846550000034, -5.865492445999905],
              [55.38005618600005, -5.869073174999926],
              [55.379893425000034, -5.86492278399993],
              [55.382823113000086, -5.853936455999929],
            ],
          ],
          [
            [
              [55.362699624339186, -4.659322771917135],
              [55.366164121507154, -4.660599165610596],
              [55.370540328456165, -4.663881320822353],
              [55.37382248366792, -4.666434108209275],
              [55.37291077388688, -4.667892843858945],
              [55.36981096063133, -4.666616450165484],
              [55.364887727813695, -4.665887082340649],
              [55.361970256514354, -4.663698978866144],
              [55.360511520864684, -4.661328533435431],
              [55.362699624339186, -4.659322771917135],
            ],
          ],
          [
            [
              [55.39898567362472, -4.66862221168378],
              [55.401173777099224, -4.669533921464823],
              [55.404820616223404, -4.671722024939328],
              [55.406826377741695, -4.675004180151085],
              [55.40591466796065, -4.678103993406634],
              [55.40536764209203, -4.679927412968721],
              [55.404091248398565, -4.680292096881137],
              [55.40007972536198, -4.67573354797592],
              [55.39752693797505, -4.673363102545206],
              [55.39770927993126, -4.67135734102691],
              [55.396432886237804, -4.669716263421032],
              [55.397162254062636, -4.668439869727571],
              [55.39898567362472, -4.66862221168378],
            ],
          ],
          [
            [
              [55.50158949238337, -4.628853431034658],
              [55.504069342987805, -4.629728672424459],
              [55.50684094072218, -4.636876477107841],
              [55.50581982576741, -4.639648074842214],
              [55.502610607338134, -4.639939821972148],
              [55.49852614751906, -4.638481086322479],
              [55.49560867621972, -4.635709488588105],
              [55.491961837095545, -4.634250752938436],
              [55.49167008996561, -4.629874545989427],
              [55.49371231987515, -4.627978189644856],
              [55.497213285434356, -4.628124063209823],
              [55.49969313603879, -4.629874545989427],
              [55.50158949238337, -4.628853431034658],
            ],
          ],
          [
            [
              [55.50421521655277, -4.621413879221342],
              [55.50567395220244, -4.621705626351276],
              [55.50815380280688, -4.623893729825781],
              [55.51150889480112, -4.624768971215582],
              [55.51282175688582, -4.627248821820021],
              [55.51107127410622, -4.629582798859492],
              [55.508445549936816, -4.628415810339757],
              [55.50509045794257, -4.626227706865253],
              [55.50333997516297, -4.623601982695846],
              [55.50421521655277, -4.621413879221342],
            ],
          ],
          [
            [
              [55.497942653259194, -4.600845706560999],
              [55.49940138890886, -4.599678718041263],
              [55.50377759585787, -4.59836585595656],
              [55.508445549936816, -4.599386970911329],
              [55.51253000975589, -4.599386970911329],
              [55.51442636610046, -4.600553959431065],
              [55.51253000975589, -4.60463841925014],
              [55.509320791326616, -4.609014626199149],
              [55.5027564809031, -4.611640350368555],
              [55.498672021084026, -4.614411948102927],
              [55.49677566473945, -4.614703695232861],
              [55.496338044044556, -4.611786223933522],
              [55.49735915899932, -4.60653477559471],
              [55.49677566473945, -4.603033810035503],
              [55.497942653259194, -4.600845706560999],
            ],
          ],
          [
            [
              [55.71208743600005, -4.280368747999944],
              [55.71506267748153, -4.276841461161244],
              [55.722127816596036, -4.276841461161244],
              [55.738489191387536, -4.277957009442483],
              [55.742951384512494, -4.278328858869562],
              [55.74146398680418, -4.283162901421596],
              [55.732167751127186, -4.283162901421596],
              [55.73328329940843, -4.289112492254868],
              [55.732911449981344, -4.292459137098584],
              [55.72073014601726, -4.288270654353415],
              [55.71208743600005, -4.280368747999944],
            ],
          ],
          [
            [
              [55.66300375769039, -4.32815668209822],
              [55.66635040253411, -4.329272230379458],
              [55.66560670367995, -4.334106272931492],
              [55.66040081170084, -4.334849971785651],
              [55.660028962273756, -4.330387778660697],
              [55.66300375769039, -4.32815668209822],
            ],
          ],
          [
            [
              [55.64701423232597, -4.346749153452196],
              [55.64887347946137, -4.348608400587594],
              [55.65110457602385, -4.353442443139627],
              [55.64812978060721, -4.353442443139627],
              [55.643667587482255, -4.349352099441753],
              [55.64701423232597, -4.346749153452196],
            ],
          ],
          [
            [
              [55.66672225196119, -4.209908564286929],
              [55.67044074623198, -4.210652263141087],
              [55.675274788784016, -4.212139660849405],
              [55.6719281439403, -4.214742606838962],
              [55.664491155398714, -4.213998907984803],
              [55.6592852634196, -4.212883359703564],
              [55.66040081170084, -4.210280413714008],
              [55.66672225196119, -4.209908564286929],
            ],
          ],
          [
            [
              [55.831823397584515, -4.337452917775207],
              [55.84409442867813, -4.342658809754321],
              [55.85078771836557, -4.355301690275025],
              [55.85710915862592, -4.364969775379093],
              [55.85041586893849, -4.368316420222809],
              [55.84409442867813, -4.374266011056081],
              [55.84149148268858, -4.38281854787891],
              [55.834426343574066, -4.380959300743513],
              [55.82550195732416, -4.372034914493604],
              [55.82327086076168, -4.359763883399979],
              [55.8284767527408, -4.347492852306354],
              [55.831823397584515, -4.337452917775207],
            ],
          ],
          [
            [
              [55.868636490865384, -4.317373048712913],
              [55.87347053341742, -4.318488596994151],
              [55.883138618521485, -4.328900380952378],
              [55.8846260162298, -4.336709218921048],
              [55.878676425396534, -4.338196616629366],
              [55.87347053341742, -4.332618875223173],
              [55.866777243729985, -4.323322639546185],
              [55.868636490865384, -4.317373048712913],
            ],
          ],
          [
            [
              [55.86640539430291, -4.283162901421595],
              [55.869752039146626, -4.283534750848675],
              [55.87086758742786, -4.289856191109027],
              [55.8738423828445, -4.296177631369379],
              [55.8701238885737, -4.296549480796458],
              [55.86640539430291, -4.288740642827788],
              [55.86640539430291, -4.283162901421595],
            ],
          ],
          [
            [
              [55.91995171180236, -4.334106272931491],
              [55.924785754354396, -4.337081068348128],
              [55.923670206073155, -4.3430306591814],
              [55.92255465779192, -4.349723948868832],
              [55.91883616352112, -4.347864701733434],
              [55.91772061523989, -4.340427713191843],
              [55.91995171180236, -4.334106272931491],
            ],
          ],
          [
            [
              [55.94007392970612, -4.57865701180308],
              [55.944353720817894, -4.579915773894779],
              [55.949388769184694, -4.586461336771617],
              [55.950144026439716, -4.590992880301735],
              [55.94485722565457, -4.592755147230115],
              [55.93906692003276, -4.592251642393435],
              [55.9330248619926, -4.586209584353277],
              [55.93252135715592, -4.582433298078178],
              [55.93579413859434, -4.579915773894779],
              [55.94007392970612, -4.57865701180308],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Heard I. and McDonald Is.',
        iso3: 'HMD',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [73.73511803500008, -53.112399997999944],
            [73.76189212300005, -53.1189104149999],
            [73.78907311300003, -53.12053801899992],
            [73.81218509200005, -53.11850351399994],
            [73.66163170700008, -53.14666106599992],
            [73.60954837300005, -53.17986419099992],
            [73.58082116000008, -53.18759530999995],
            [73.50733483200008, -53.19255950299993],
            [73.47339928500008, -53.1892229149999],
            [73.44019616000008, -53.17327239399992],
            [73.43043053500008, -53.16529713299991],
            [73.40414472700007, -53.139336846999925],
            [73.37094160200007, -53.090508721999925],
            [73.36378014400003, -53.07480234199994],
            [73.37126712300005, -53.06462981599992],
            [73.35971113400007, -53.058851820999905],
            [73.35328209700003, -53.05169036299992],
            [73.35417728000004, -53.04420338299991],
            [73.36443118600005, -53.03728606599992],
            [73.34473717500003, -53.029229424999926],
            [73.32886803500008, -53.02507903399993],
            [73.27100670700008, -53.021742445999905],
            [73.25367272200003, -53.01506926899992],
            [73.24170983200008, -53.002211195999905],
            [73.23601321700005, -52.98202890399995],
            [73.26937910200007, -52.975274346999925],
            [73.29688561300003, -52.961602471999925],
            [73.33090254000007, -52.98479583099993],
            [73.33716881600003, -52.98577239399992],
            [73.34457441500007, -52.99651458099993],
            [73.36109459700003, -53.00920989399992],
            [73.37745201900003, -53.01702239399992],
            [73.38493899800005, -53.01311614399992],
            [73.38917076900003, -52.9978166649999],
            [73.39958743600005, -52.99098072699991],
            [73.41293379000007, -52.992852471999925],
            [73.42652428500008, -53.00318775799991],
            [73.41285241000008, -53.00937265399995],
            [73.42562910200007, -53.025323174999926],
            [73.44703209700003, -53.02809010199991],
            [73.47022545700008, -53.02157968499995],
            [73.48796634200005, -53.00937265399995],
            [73.50766035200007, -53.01531340899993],
            [73.56421959700003, -53.01677825299993],
            [73.58757571700005, -53.02678801899992],
            [73.59848066500007, -53.033868096999925],
            [73.62094160200007, -53.03964609199994],
            [73.63257897200003, -53.04412200299993],
            [73.64014733200008, -53.050713799999926],
            [73.65560957100007, -53.06796640399995],
            [73.66334069100003, -53.07146575299993],
            [73.68897545700008, -53.09026458099993],
            [73.69947350400008, -53.10084400799991],
            [73.73511803500008, -53.112399997999944],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Saint Helena',
        iso3: 'SHN',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-9.926380988999938, -40.34880950299993],
              [-9.906361456999946, -40.36419036299992],
              [-9.900013800999943, -40.372165622999944],
              [-9.895375128999945, -40.38640715899993],
              [-9.925160285999937, -40.39788176899992],
              [-9.96507727799991, -40.382745049999926],
              [-10.03937740799995, -40.33863697699991],
              [-10.03937740799995, -40.3318010399999],
              [-10.030018683999913, -40.31373463299991],
              [-10.022206183999913, -40.30722421699994],
              [-10.008656378999945, -40.3044572899999],
              [-9.96275794199994, -40.301853122999944],
              [-9.949940558999913, -40.3044572899999],
              [-9.943104620999918, -40.3122697899999],
              [-9.932362433999913, -40.33904387799993],
              [-9.926380988999938, -40.34880950299993],
            ],
          ],
          [
            [
              [-12.307362433999913, -37.0700822899999],
              [-12.296620245999918, -37.05917734199994],
              [-12.291900193999936, -37.055759372999944],
              [-12.244984503999945, -37.05917734199994],
              [-12.227935350999928, -37.0681291649999],
              [-12.21312415299991, -37.080010674999926],
              [-12.19127356699994, -37.090508721999925],
              [-12.195708787999934, -37.09856536299992],
              [-12.20030676999994, -37.10409921699994],
              [-12.205474412999934, -37.10800546699994],
              [-12.211740688999953, -37.11101653399993],
              [-12.24478105399993, -37.13787200299993],
              [-12.263783331999946, -37.14902109199994],
              [-12.276600714999915, -37.14918385199991],
              [-12.304107225999928, -37.12558359199994],
              [-12.335316535999937, -37.10426197699991],
              [-12.325591600999928, -37.09465911299992],
              [-12.307362433999913, -37.0700822899999],
            ],
          ],
          [
            [
              [-5.721831834999932, -15.908949476999908],
              [-5.709584113999938, -15.906996351999908],
              [-5.679676886999914, -15.907321872999944],
              [-5.66665605399993, -15.90211353999996],
              [-5.657704230999911, -15.919528903999947],
              [-5.651966925999943, -15.93450286299992],
              [-5.650380011999914, -15.94890715899993],
              [-5.653553839999915, -15.963555596999925],
              [-5.66274980399993, -15.979587497999944],
              [-5.673939581999946, -15.988213799999926],
              [-5.686919725999928, -15.994805596999925],
              [-5.701975063999953, -16.00514088299991],
              [-5.704335089999915, -15.999444268999923],
              [-5.707753058999913, -15.996351820999905],
              [-5.711659308999913, -15.994317315999922],
              [-5.715646938999953, -15.990899346999925],
              [-5.729888475999928, -16.00481536299992],
              [-5.746490037999934, -16.013848565999922],
              [-5.763742641999954, -16.01572030999995],
              [-5.780181443999936, -16.00823333099993],
              [-5.789540167999917, -15.995293877999927],
              [-5.787180141999954, -15.98447030999995],
              [-5.780384894999941, -15.973402601999908],
              [-5.776519334999932, -15.960137627999927],
              [-5.770130988999938, -15.945245049999926],
              [-5.755116339999915, -15.929945570999905],
              [-5.737049933999913, -15.917168877999927],
              [-5.721831834999932, -15.908949476999908],
            ],
          ],
          [
            [
              [-14.356271938999953, -7.884698174999926],
              [-14.347401495999918, -7.899834893999923],
              [-14.31041419199994, -7.927504164999959],
              [-14.29478919199994, -7.945489190999922],
              [-14.305246548999946, -7.952080987999921],
              [-14.328480597999942, -7.962334893999923],
              [-14.339466925999943, -7.96998463299991],
              [-14.350331183999913, -7.974704684999949],
              [-14.378529425999943, -7.976006768999923],
              [-14.391021287999934, -7.979668877999927],
              [-14.406402147999927, -7.97389088299991],
              [-14.411000128999945, -7.963067315999922],
              [-14.412261522999927, -7.950372002999927],
              [-14.417713995999918, -7.939222914999959],
              [-14.406605597999942, -7.924086195999905],
              [-14.390614386999914, -7.889336846999925],
              [-14.376698370999918, -7.877862237999921],
              [-14.373646613999938, -7.885349216999941],
              [-14.369984503999945, -7.889336846999925],
              [-14.364572719999956, -7.889336846999925],
              [-14.356271938999953, -7.884698174999926],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Mauritius',
        iso3: 'MUS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [57.79574629000007, -20.22275155999995],
              [57.793955925000034, -20.246758721999925],
              [57.78891035200007, -20.274183851999908],
              [57.77816816500007, -20.30478280999995],
              [57.77588951900003, -20.32040780999995],
              [57.78150475400008, -20.33570728999996],
              [57.75709069100009, -20.343357028999947],
              [57.729258660000085, -20.363946221999925],
              [57.71225019600007, -20.387465101999908],
              [57.71998131600009, -20.40398528399993],
              [57.720713738000086, -20.41106536299992],
              [57.72608483200008, -20.41961028399993],
              [57.72681725400008, -20.42506275799991],
              [57.723317905000044, -20.434258721999925],
              [57.71762129000007, -20.43613046699994],
              [57.711273634000065, -20.435804945999905],
              [57.705821160000085, -20.43873463299991],
              [57.692393425000034, -20.46152109199994],
              [57.68474368600005, -20.47161223799992],
              [57.672211134000065, -20.479668877999927],
              [57.58838951900003, -20.50481536299992],
              [57.50359134200005, -20.51734791499996],
              [57.473643425000034, -20.515069268999923],
              [57.42693118600005, -20.50090911299992],
              [57.39926191500007, -20.497979424999926],
              [57.37810306100005, -20.507012627999927],
              [57.32056725400008, -20.458184502999927],
              [57.30787194100009, -20.44426848799992],
              [57.303477410000085, -20.43092213299991],
              [57.319346550000034, -20.42506275799991],
              [57.344086134000065, -20.429864190999922],
              [57.357758009000065, -20.42742278399993],
              [57.36378014400003, -20.41448333099993],
              [57.36898847700007, -20.38640715899993],
              [57.367849155000044, -20.376153252999927],
              [57.35694420700008, -20.37037525799991],
              [57.36500084700003, -20.345961195999905],
              [57.365977410000085, -20.29078541499996],
              [57.37061608200008, -20.260511976999908],
              [57.37745201900003, -20.24309661299992],
              [57.40015709700003, -20.200616143999923],
              [57.40845787900008, -20.19231536299992],
              [57.410492384000065, -20.18922291499996],
              [57.432627800000034, -20.171807549999926],
              [57.44223066500007, -20.167413018999923],
              [57.463877800000034, -20.161553643999923],
              [57.473643425000034, -20.15748463299991],
              [57.49073326900003, -20.140801690999922],
              [57.49382571700005, -20.12232838299991],
              [57.494476759000065, -20.103692315999922],
              [57.50961347700007, -20.07740650799991],
              [57.52198326900003, -20.04159921699994],
              [57.528086785000085, -20.030857028999947],
              [57.53248131600009, -20.024834893999923],
              [57.56006920700008, -20.003838799999926],
              [57.56690514400003, -20.00090911299992],
              [57.58033287900008, -19.999932549999926],
              [57.58611087300005, -19.996758721999925],
              [57.590505405000044, -19.989678643999923],
              [57.59652754000007, -19.982598565999922],
              [57.60710696700005, -19.97942473799992],
              [57.62289472700007, -19.98170338299991],
              [57.66773522200003, -19.994073174999926],
              [57.679698113000086, -19.999932549999926],
              [57.68482506600009, -20.01100025799991],
              [57.67920983200008, -20.02825286299992],
              [57.68311608200008, -20.037774346999925],
              [57.690196160000085, -20.04729583099993],
              [57.69776451900003, -20.064060153999947],
              [57.70622806100005, -20.078383070999905],
              [57.70883222700007, -20.08993905999995],
              [57.713877800000034, -20.09612395599993],
              [57.71794681100005, -20.09693775799991],
              [57.72974694100009, -20.095147393999923],
              [57.73365319100009, -20.09612395599993],
              [57.744802280000044, -20.105075778999947],
              [57.74773196700005, -20.111504815999922],
              [57.744476759000065, -20.14381275799991],
              [57.75220787900008, -20.154229424999926],
              [57.76254316500007, -20.162041924999926],
              [57.772146030000044, -20.190524997999944],
              [57.791351759000065, -20.21217213299991],
              [57.79574629000007, -20.22275155999995],
            ],
          ],
          [
            [
              [56.524180535000085, -10.330010674999926],
              [56.52556399800005, -10.327325127999927],
              [56.527679884000065, -10.325372002999927],
              [56.53101647200003, -10.324151299999926],
              [56.53565514400003, -10.32390715899993],
              [56.54281660200007, -10.346449476999908],
              [56.56861412900008, -10.38640715899993],
              [56.569346550000034, -10.406508070999905],
              [56.54851321700005, -10.382012627999927],
              [56.52979576900003, -10.352959893999923],
              [56.52458743600005, -10.340020440999922],
              [56.524180535000085, -10.330010674999926],
            ],
          ],
          [
            [
              [63.47624759200005, -19.67782968499995],
              [63.49390709700003, -19.681898695999905],
              [63.48959394600007, -19.701429945999905],
              [63.469411655000044, -19.722914320999905],
              [63.43873131600003, -19.73300546699994],
              [63.41651451900003, -19.73642343499995],
              [63.40064537900008, -19.744886976999908],
              [63.38559004000007, -19.756036065999922],
              [63.36638431100005, -19.767185153999947],
              [63.33773847700007, -19.738457940999922],
              [63.33228600400008, -19.73642343499995],
              [63.33521569100003, -19.717868747999944],
              [63.34327233200008, -19.709730726999908],
              [63.35523522200003, -19.704685153999947],
              [63.38917076900003, -19.684747002999927],
              [63.42115319100003, -19.67441171699994],
              [63.45427493600005, -19.669854424999926],
              [63.47624759200005, -19.67782968499995],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Br. Indian Ocean Ter.',
        iso3: 'IOT',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [72.46753991000008, -7.383884372999944],
              [72.47152754000007, -7.379082940999922],
              [72.47478274800005, -7.376560153999947],
              [72.47771243600005, -7.372816664999959],
              [72.48031660200007, -7.364678643999923],
              [72.48316491000008, -7.370293877999927],
              [72.48462975400008, -7.375909112999921],
              [72.48414147200003, -7.38250090899993],
              [72.48064212300005, -7.390557549999926],
              [72.47266686300003, -7.399997653999947],
              [72.44410241000008, -7.424981377999927],
              [72.43287194100003, -7.432224216999941],
              [72.42693118600005, -7.40398528399993],
              [72.43287194100003, -7.346774997999944],
              [72.42603600400008, -7.322930596999925],
              [72.41944420700008, -7.317315362999921],
              [72.39665774800005, -7.304864190999922],
              [72.38819420700008, -7.302504164999959],
              [72.37924238400007, -7.296807549999926],
              [72.35767662900008, -7.268324476999908],
              [72.37094160200007, -7.270196221999925],
              [72.42017662900008, -7.303887627999927],
              [72.43287194100003, -7.31609465899993],
              [72.43897545700008, -7.340264580999929],
              [72.43287194100003, -7.425388278999947],
              [72.44320722700007, -7.416436455999929],
              [72.46753991000008, -7.383884372999944],
            ],
          ],
          [
            [
              [72.48422285200007, -7.278252862999921],
              [72.49463951900003, -7.29615650799991],
              [72.48959394600007, -7.30982838299991],
              [72.47934004000007, -7.323174737999921],
              [72.47380618600005, -7.340020440999922],
              [72.47429446700005, -7.34693775799991],
              [72.47535241000008, -7.35279713299991],
              [72.47901451900003, -7.361911716999941],
              [72.47494550900007, -7.356540622999944],
              [72.47046959700003, -7.34889088299991],
              [72.46802819100003, -7.340590101999908],
              [72.47071373800003, -7.333184502999927],
              [72.48650149800005, -7.30242278399993],
              [72.47722415500004, -7.278415622999944],
              [72.45679772200003, -7.25514088299991],
              [72.43970787900008, -7.226739190999922],
              [72.45045006600003, -7.234144789999959],
              [72.48422285200007, -7.278252862999921],
            ],
          ],
          [
            [
              [71.35035241000008, -6.652520440999922],
              [71.36207116000008, -6.652927341999941],
              [71.35523522200003, -6.656345309999949],
              [71.35173587300005, -6.655694268999923],
              [71.35035241000008, -6.653497002999927],
              [71.35035241000008, -6.652520440999922],
            ],
          ],
          [
            [
              [71.26140384200005, -6.388604424999926],
              [71.26099694100003, -6.378024997999944],
              [71.26238040500004, -6.373955987999921],
              [71.26734459700003, -6.370049737999921],
              [71.26880944100003, -6.378106377999927],
              [71.26758873800009, -6.382745049999926],
              [71.26482181100005, -6.385918877999927],
              [71.26140384200005, -6.388604424999926],
            ],
          ],
          [
            [
              [71.33838951900003, -6.195896091999941],
              [71.34229576900003, -6.188083591999941],
              [71.34701582100007, -6.182224216999941],
              [71.35328209700003, -6.178399346999925],
              [71.36052493600005, -6.177341403999947],
              [71.35670006600003, -6.18873463299991],
              [71.35108483200008, -6.200290622999944],
              [71.34473717500003, -6.204847914999959],
              [71.33838951900003, -6.195896091999941],
            ],
          ],
          [
            [
              [71.77320397200003, -5.440199476999908],
              [71.76465905000003, -5.433851820999905],
              [71.76238040500004, -5.431735934999949],
              [71.77173912900008, -5.433363539999959],
              [71.77458743600005, -5.435723565999922],
              [71.77418053500008, -5.438083591999941],
              [71.77320397200003, -5.440199476999908],
            ],
          ],
          [
            [
              [72.22144616000008, -5.32781340899993],
              [72.23096764400003, -5.319268487999921],
              [72.22828209700003, -5.324802341999941],
              [72.22535241000008, -5.327243747999944],
              [72.22291100400008, -5.327732028999947],
              [72.22144616000008, -5.32781340899993],
            ],
          ],
          [
            [
              [71.73707116000008, -5.285251559999949],
              [71.74708092500003, -5.269952080999929],
              [71.74545332100007, -5.278741143999923],
              [71.74236087300005, -5.283135674999926],
              [71.73894290500004, -5.284926039999959],
              [71.73707116000008, -5.285251559999949],
            ],
          ],
          [
            [
              [71.76026451900003, -5.236586195999905],
              [71.76856530000003, -5.234144789999959],
              [71.76644941500007, -5.239190362999921],
              [71.76449629000007, -5.239678643999923],
              [71.76270592500003, -5.23796965899993],
              [71.76026451900003, -5.236586195999905],
            ],
          ],
          [
            [
              [71.96615644600007, -5.234795830999929],
              [71.96461022200003, -5.232354424999926],
              [71.96273847700007, -5.231215101999908],
              [71.96168053500008, -5.230075778999947],
              [71.96273847700007, -5.226983330999929],
              [71.96648196700005, -5.227471612999921],
              [71.96705162900008, -5.229180596999925],
              [71.96615644600007, -5.23170338299991],
              [71.96615644600007, -5.234795830999929],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Maldives',
        iso3: 'MDV',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [73.16309655000003, -0.681817315999922],
              [73.17253665500004, -0.688571872999944],
              [73.16586347700007, -0.688409112999921],
              [73.16358483200008, -0.686618747999944],
              [73.16309655000003, -0.681817315999922],
            ],
          ],
          [
            [
              [73.20411217500003, -0.67115650799991],
              [73.20118248800003, -0.67506275799991],
              [73.19922936300003, -0.678643487999921],
              [73.19646243600005, -0.68132903399993],
              [73.19141686300003, -0.682793877999927],
              [73.19223066500007, -0.677178643999923],
              [73.19516035200007, -0.674493096999925],
              [73.20411217500003, -0.67115650799991],
            ],
          ],
          [
            [
              [73.12427819100003, -0.656182549999926],
              [73.12696373800003, -0.666273695999962],
              [73.12387129000007, -0.664727471999925],
              [73.12330162900008, -0.662530205999929],
              [73.12387129000007, -0.659763278999947],
              [73.12427819100003, -0.656182549999926],
            ],
          ],
          [
            [
              [73.24000084700003, -0.625583591999941],
              [73.22730553500008, -0.642836195999962],
              [73.22681725400008, -0.632582289999959],
              [73.22999108200008, -0.623304945999962],
              [73.23487389400003, -0.619398695999962],
              [73.24000084700003, -0.625583591999941],
            ],
          ],
          [
            [
              [73.24675540500004, -0.588636976999908],
              [73.24463951900003, -0.607191664999959],
              [73.23829186300003, -0.600355726999908],
              [73.23633873800003, -0.592380466999941],
              [73.23902428500008, -0.584405205999929],
              [73.24732506600003, -0.577894789999959],
              [73.24838300900007, -0.580824476999908],
              [73.24781334700003, -0.583184502999927],
              [73.24683678500008, -0.585544528999947],
              [73.24675540500004, -0.588636976999908],
            ],
          ],
          [
            [
              [73.43506920700008, -0.283623955999929],
              [73.44304446700005, -0.292738539999959],
              [73.44507897200003, -0.297539971999925],
              [73.44450931100005, -0.304294528999947],
              [73.43799889400003, -0.298597914999959],
              [73.43523196700005, -0.293633721999925],
              [73.43458092500003, -0.28875090899993],
              [73.43506920700008, -0.283623955999929],
            ],
          ],
          [
            [
              [73.09546959700003, 0.228013414000088],
              [73.09888756600003, 0.22492096600007],
              [73.10254967500003, 0.222805080000057],
              [73.10434004000007, 0.219631252000056],
              [73.10295657600005, 0.21352773600006],
              [73.10287519600007, 0.213446356000077],
              [73.09888756600003, 0.216376044000071],
              [73.09782962300005, 0.218776760000083],
              [73.09742272200003, 0.219712632000039],
              [73.09734134200005, 0.22024160400008],
              [73.09669030000003, 0.223700262000079],
              [73.09546959700003, 0.228013414000088],
            ],
          ],
          [
            [
              [73.20899498800003, 0.239976304000038],
              [73.21745853000004, 0.23773834800005],
              [73.21737714900007, 0.237697658000059],
              [73.21265709700003, 0.232082424000055],
              [73.21094811300003, 0.232163804000038],
              [73.21029707100007, 0.235663153000075],
              [73.20899498800003, 0.239976304000038],
            ],
          ],
          [
            [
              [73.03679446700005, 0.269924221000053],
              [73.03679446700005, 0.269680080000057],
              [73.04037519600007, 0.259466864000046],
              [73.04037519600007, 0.259344794000071],
              [73.03614342500003, 0.260931708000044],
              [73.03581790500004, 0.262071031000062],
              [73.03541100400008, 0.263169664000088],
              [73.03581790500004, 0.264675197000088],
              [73.03630618600005, 0.266180731000077],
              [73.03630618600005, 0.266506252000056],
              [73.03679446700005, 0.269924221000053],
            ],
          ],
          [
            [
              [73.37916100400008, 0.285223700000074],
              [73.37907962300005, 0.285183010000083],
              [73.36963951900003, 0.28001536700009],
              [73.37110436300003, 0.285956122000073],
              [73.37370853000004, 0.286932684000078],
              [73.37639407600005, 0.286078192000048],
              [73.37916100400008, 0.285223700000074],
            ],
          ],
          [
            [
              [72.98365319100003, 0.305243231000077],
              [72.98487389400003, 0.303412177000041],
              [72.98707116000008, 0.302801825000074],
              [72.98772220100005, 0.302232164000088],
              [72.98812910200007, 0.301906643000052],
              [72.98601321700005, 0.299627997000073],
              [72.98601321700005, 0.29954661700009],
              [72.98121178500008, 0.302069403000075],
              [72.98096764400003, 0.303615627000056],
              [72.98365319100003, 0.305243231000077],
            ],
          ],
          [
            [
              [73.51343834700003, 0.387762762000079],
              [73.51335696700005, 0.387681382000039],
              [73.50863691500007, 0.380682684000078],
              [73.50855553500008, 0.380560614000046],
              [73.50643964900007, 0.385036526000079],
              [73.50586998800003, 0.38617584800005],
              [73.50660241000008, 0.387762762000079],
              [73.50977623800003, 0.38743724200009],
              [73.51343834700003, 0.387762762000079],
            ],
          ],
          [
            [
              [72.95834394600007, 0.403306382000039],
              [72.95842532600005, 0.403143622000073],
              [72.96111087300005, 0.394273179000038],
              [72.96119225400008, 0.394029039000088],
              [72.95777428500008, 0.39679596600007],
              [72.95720462300005, 0.39915599200009],
              [72.95801842500003, 0.401353257000039],
              [72.95834394600007, 0.403306382000039],
            ],
          ],
          [
            [
              [72.94092858200008, 0.496283270000049],
              [72.94060306100005, 0.487290757000039],
              [72.93702233200008, 0.491441148000092],
              [72.93702233200008, 0.493638414000088],
              [72.94092858200008, 0.496283270000049],
            ],
          ],
          [
            [
              [73.49195397200003, 0.508002020000049],
              [73.49203535200007, 0.507798570000091],
              [73.49463951900003, 0.498968817000048],
              [73.49040774800005, 0.500677802000041],
              [73.48975670700008, 0.50259023600006],
              [73.49097741000008, 0.504950262000079],
              [73.49195397200003, 0.508002020000049],
            ],
          ],
          [
            [
              [73.38786868600005, 0.641750393000052],
              [73.38721764400003, 0.639105536000045],
              [73.38721764400003, 0.636786200000074],
              [73.38672936300003, 0.63540273600006],
              [73.38656660200007, 0.63540273600006],
              [73.38477623800003, 0.635565497000073],
              [73.38355553500008, 0.638902085000041],
              [73.38428795700008, 0.640326239000046],
              [73.38640384200005, 0.640814520000049],
              [73.38786868600005, 0.641750393000052],
            ],
          ],
          [
            [
              [73.37305748800003, 0.763088283000059],
              [73.37240644600007, 0.760443427000041],
              [73.37240644600007, 0.75812409100007],
              [73.37183678500008, 0.75657786700009],
              [73.37094160200007, 0.756822007000039],
              [73.36996504000007, 0.757025458000044],
              [73.36882571700005, 0.760443427000041],
              [73.36980228000004, 0.761664130000042],
              [73.36988366000008, 0.761704820000091],
              [73.37077884200005, 0.761948960000041],
              [73.37159264400003, 0.762152411000045],
              [73.37305748800003, 0.763088283000059],
            ],
          ],
          [
            [
              [73.35385175900007, 0.847723700000074],
              [73.35385175900007, 0.847560940000051],
              [73.35328209700003, 0.845607815000051],
              [73.35320071700005, 0.845282294000071],
              [73.35320071700005, 0.84320709800005],
              [73.35303795700008, 0.842393296000068],
              [73.35287519600007, 0.841538804000038],
              [73.35206139400003, 0.841131903000075],
              [73.35116621200007, 0.840684312000064],
              [73.35108483200008, 0.840643622000073],
              [73.34978274800005, 0.84406159100007],
              [73.35043379000007, 0.845689195000091],
              [73.35230553500008, 0.846625067000048],
              [73.35385175900007, 0.847723700000074],
            ],
          ],
          [
            [
              [72.83139082100007, 3.510565497000073],
              [72.83155358200008, 3.51040273600006],
              [72.83269290500004, 3.508246161000045],
              [72.83472741000008, 3.506781317000048],
              [72.83513431100005, 3.505438544000071],
              [72.83505293100006, 3.505438544000071],
              [72.83106530000003, 3.503566799000055],
              [72.82805423300005, 3.505438544000071],
              [72.82797285200007, 3.505438544000071],
              [72.82862389400003, 3.506781317000048],
              [72.83041425900007, 3.508246161000045],
              [72.83139082100007, 3.510565497000073],
            ],
          ],
          [
            [
              [72.79371178500008, 3.516913153000075],
              [72.79379316500007, 3.516750393000052],
              [72.79476972700007, 3.515326239000046],
              [72.79517662900008, 3.514634507000039],
              [72.79761803500008, 3.51312897300005],
              [72.79883873800003, 3.511948960000041],
              [72.79639733200008, 3.510891018000052],
              [72.79118899800005, 3.510891018000052],
              [72.79078209700003, 3.51203034100007],
              [72.79078209700003, 3.512111721000053],
              [72.79273522200003, 3.514227606000077],
              [72.79371178500008, 3.516913153000075],
            ],
          ],
          [
            [
              [72.92839603000004, 3.551906643000052],
              [72.91179446700005, 3.54173411700009],
              [72.91163170700008, 3.54165273600006],
              [72.91570071700005, 3.548976955000057],
              [72.91993248800003, 3.552150783000059],
              [72.92432701900003, 3.552476304000038],
              [72.92839603000004, 3.551906643000052],
            ],
          ],
          [
            [
              [72.94190514400003, 3.618841864000046],
              [72.94312584700003, 3.61664459800005],
              [72.94442793100006, 3.615708726000094],
              [72.94516035200007, 3.615139065000051],
              [72.94556725400008, 3.613714911000045],
              [72.94157962300005, 3.611883856000077],
              [72.93848717500003, 3.613714911000045],
              [72.93897545700008, 3.615139065000051],
              [72.94068444100003, 3.61664459800005],
              [72.94190514400003, 3.618841864000046],
            ],
          ],
          [
            [
              [72.69255618600005, 3.726955471000053],
              [72.69255618600005, 3.726752020000049],
              [72.69402103000004, 3.723334052000041],
              [72.69646243600005, 3.72101471600007],
              [72.69743899800005, 3.718817450000074],
              [72.69735761800007, 3.718817450000074],
              [72.69459069100003, 3.714992580000057],
              [72.69247480600006, 3.716294664000088],
              [72.68970787900008, 3.717962958000044],
              [72.68970787900008, 3.720851955000057],
              [72.69157962300005, 3.723578192000048],
              [72.69255618600005, 3.726955471000053],
            ],
          ],
          [
            [
              [73.47730553500008, 3.94212474200009],
              [73.47714277400007, 3.942002671000068],
              [73.46998131600003, 3.935126044000071],
              [73.46753991000008, 3.933661200000074],
              [73.46924889400003, 3.93695709800005],
              [73.47152754000007, 3.938706773000092],
              [73.47730553500008, 3.94212474200009],
            ],
          ],
          [
            [
              [72.70313561300003, 4.003322658000059],
              [72.70362389400003, 4.000921942000048],
              [72.70476321700005, 3.999904690000051],
              [72.70557701900003, 3.999212958000044],
              [72.70622806100005, 3.998439846000053],
              [72.70671634200005, 3.997951565000051],
              [72.70663496200007, 3.99791087400007],
              [72.70460045700008, 3.99640534100007],
              [72.69947350400008, 3.998114325000074],
              [72.69939212300005, 3.998195705000057],
              [72.69914798300005, 3.999335028000075],
              [72.69906660200007, 3.999497789000088],
              [72.70118248800003, 4.000921942000048],
              [72.70313561300003, 4.003322658000059],
            ],
          ],
          [
            [
              [73.50814863400007, 4.103583075000074],
              [73.50831139400003, 4.093410549000055],
              [73.50831139400003, 4.093329169000071],
              [73.50456790500004, 4.096584377000056],
              [73.50245201900003, 4.098537502000056],
              [73.50228925900007, 4.100775458000044],
              [73.50521894600007, 4.101996161000045],
              [73.50814863400007, 4.103583075000074],
            ],
          ],
          [
            [
              [72.97046959700003, 4.26593659100007],
              [72.97063235800005, 4.265814520000049],
              [72.97250410200007, 4.264146226000094],
              [72.97437584700003, 4.263251044000071],
              [72.97559655000003, 4.26235586100006],
              [72.97575931100005, 4.26040273600006],
              [72.97250410200007, 4.26040273600006],
              [72.97152754000007, 4.261623440000051],
              [72.97144616000008, 4.263576565000051],
              [72.97046959700003, 4.26593659100007],
            ],
          ],
          [
            [
              [73.70281009200005, 4.434719143000052],
              [73.70085696700005, 4.43227773600006],
              [73.69760175900007, 4.431463934000078],
              [73.69743899800005, 4.431382554000038],
              [73.70281009200005, 4.434719143000052],
            ],
          ],
          [
            [
              [73.70281009200005, 4.453029690000051],
              [73.70264733200008, 4.452907619000086],
              [73.69988040500004, 4.449164130000042],
              [73.69996178500008, 4.451646226000094],
              [73.70281009200005, 4.453029690000051],
            ],
          ],
          [
            [
              [73.37671959700003, 4.474432684000078],
              [73.37728925900007, 4.465277411000045],
              [73.37387129000007, 4.466986395000049],
              [73.37387129000007, 4.468817450000074],
              [73.37387129000007, 4.468898830000057],
              [73.37525475400008, 4.471177476000094],
              [73.37671959700003, 4.474432684000078],
            ],
          ],
          [
            [
              [73.40495853000004, 4.634995835000041],
              [73.40495853000004, 4.634751695000091],
              [73.40495853000004, 4.632228908000059],
              [73.40552819100003, 4.629950262000079],
              [73.40528405000003, 4.628404039000088],
              [73.40300540500004, 4.627427476000094],
              [73.40121504000007, 4.629828192000048],
              [73.40186608200008, 4.631333726000094],
              [73.40357506600003, 4.632757880000042],
              [73.40495853000004, 4.634995835000041],
            ],
          ],
          [
            [
              [73.49048912900008, 4.72337474200009],
              [73.49040774800005, 4.720607815000051],
              [73.49097741000008, 4.71828847900008],
              [73.49073326900003, 4.716742255000042],
              [73.48845462300005, 4.715969143000052],
              [73.48796634200005, 4.716538804000038],
              [73.48666425900007, 4.71820709800005],
              [73.48731530000003, 4.719794012000079],
              [73.48902428500008, 4.721177476000094],
              [73.49048912900008, 4.72337474200009],
            ],
          ],
          [
            [
              [72.97934004000007, 4.895453192000048],
              [72.97934004000007, 4.895371812000064],
              [72.96965579500005, 4.88072337400007],
              [72.96949303500008, 4.880519924000055],
              [72.97006269600007, 4.890366929000038],
              [72.97266686300003, 4.894354559000078],
              [72.97608483200008, 4.89516836100006],
              [72.97934004000007, 4.895453192000048],
            ],
          ],
          [
            [
              [72.91749108200008, 4.898586330000057],
              [72.92286217500003, 4.89907461100006],
              [72.92269941500007, 4.898993231000077],
              [72.92090905000003, 4.897853908000059],
              [72.91765384200005, 4.898504950000074],
              [72.91749108200008, 4.898586330000057],
            ],
          ],
          [
            [
              [73.44727623800003, 4.97134023600006],
              [73.43653405000003, 4.969875393000052],
              [73.43897545700008, 4.974554755000042],
              [73.44117272200003, 4.97492096600007],
              [73.44385826900003, 4.973049221000053],
              [73.44727623800003, 4.97134023600006],
            ],
          ],
          [
            [
              [72.91285241000008, 5.034084377000056],
              [72.90943444100003, 5.03078847900008],
              [72.90919030000003, 5.030585028000075],
              [72.91016686300003, 5.032700914000088],
              [72.91285241000008, 5.034084377000056],
            ],
          ],
          [
            [
              [72.92774498800003, 5.036525783000059],
              [72.92766360800005, 5.036281643000052],
              [72.92717532600005, 5.034247137000079],
              [72.92709394600007, 5.03392161700009],
              [72.92571048300005, 5.033474026000079],
              [72.92440839900007, 5.03306712400007],
              [72.92432701900003, 5.033026434000078],
              [72.92774498800003, 5.036525783000059],
            ],
          ],
          [
            [
              [73.04476972700007, 5.12181224200009],
              [73.04476972700007, 5.121649481000077],
              [73.04346764400003, 5.118841864000046],
              [73.04127037900008, 5.118394273000092],
              [73.04476972700007, 5.12181224200009],
            ],
          ],
          [
            [
              [73.04908287900008, 5.133286851000094],
              [73.04916425900007, 5.133164781000062],
              [73.04997806100005, 5.130357164000088],
              [73.05144290500004, 5.128078518000052],
              [73.05144290500004, 5.126654364000046],
              [73.04761803500008, 5.126369533000059],
              [73.04525800900007, 5.128892320000091],
              [73.04607181100005, 5.130275783000059],
              [73.04786217500003, 5.131293036000045],
              [73.04908287900008, 5.133286851000094],
            ],
          ],
          [
            [
              [73.09131920700008, 5.161363023000092],
              [73.09099368600005, 5.15851471600007],
              [73.08790123800003, 5.157985744000086],
              [73.08773847700007, 5.157945054000038],
              [73.09131920700008, 5.161363023000092],
            ],
          ],
          [
            [
              [73.10385175900007, 5.173041083000044],
              [73.10417728000004, 5.172919012000079],
              [73.10694420700008, 5.171779690000051],
              [73.11052493600005, 5.170314846000053],
              [73.11019941500007, 5.170355536000045],
              [73.10710696700005, 5.170965887000079],
              [73.10385175900007, 5.173041083000044],
            ],
          ],
          [
            [
              [72.86011803500008, 5.237941799000055],
              [72.86003665500004, 5.23781972900008],
              [72.85922285200007, 5.235500393000052],
              [72.85686282600005, 5.234564520000049],
              [72.85661868600005, 5.234442450000074],
              [72.86011803500008, 5.237941799000055],
            ],
          ],
          [
            [
              [73.13184655000003, 5.244574286000045],
              [73.13184655000003, 5.24249909100007],
              [73.12842858200008, 5.241156317000048],
              [73.13184655000003, 5.244574286000045],
            ],
          ],
          [
            [
              [73.49976647200003, 5.246893622000073],
              [73.49968509200005, 5.24681224200009],
              [73.49732506600003, 5.245062567000048],
              [73.49724368600005, 5.245021877000056],
              [73.49382571700005, 5.245998440000051],
              [73.49976647200003, 5.246893622000073],
            ],
          ],
          [
            [
              [73.59359785200007, 5.282700914000088],
              [73.58285566500007, 5.275580145000049],
              [73.57764733200008, 5.274562893000052],
              [73.57016035200007, 5.276678778000075],
              [73.56999759200005, 5.276760158000059],
              [73.57593834700003, 5.27993398600006],
              [73.58204186300003, 5.281805731000077],
              [73.58790123800003, 5.282619533000059],
              [73.59359785200007, 5.282700914000088],
            ],
          ],
          [
            [
              [73.11280358200008, 5.298570054000038],
              [73.11264082100007, 5.298447984000063],
              [73.10922285200007, 5.295152085000041],
              [73.10922285200007, 5.296698309000078],
              [73.11280358200008, 5.298570054000038],
            ],
          ],
          [
            [
              [73.47022545700008, 5.307766018000052],
              [73.47014407600005, 5.30772532800006],
              [73.46436608200008, 5.306870835000041],
              [73.46420332100007, 5.306830145000049],
              [73.46705162900008, 5.308335679000038],
              [73.46713300900007, 5.308335679000038],
              [73.46843509200005, 5.308091539000088],
              [73.47022545700008, 5.307766018000052],
            ],
          ],
          [
            [
              [73.62956790500004, 5.332831122000073],
              [73.62940514400003, 5.33274974200009],
              [73.62720787900008, 5.331122137000079],
              [73.62330162900008, 5.331854559000078],
              [73.62956790500004, 5.332831122000073],
            ],
          ],
          [
            [
              [73.64665774800005, 5.343247789000088],
              [73.64649498800003, 5.343247789000088],
              [73.64006595100005, 5.342189846000053],
              [73.63990319100003, 5.342189846000053],
              [73.64340254000007, 5.343939520000049],
              [73.64665774800005, 5.343247789000088],
            ],
          ],
          [
            [
              [72.95313561300003, 5.352769273000092],
              [72.95240319100003, 5.350083726000094],
              [72.94955488400007, 5.349310614000046],
              [72.95313561300003, 5.352769273000092],
            ],
          ],
          [
            [
              [73.39747155000003, 5.362209377000056],
              [73.39755293100006, 5.362005927000041],
              [73.39869225400008, 5.359605210000041],
              [73.40064537900008, 5.357652085000041],
              [73.40121504000007, 5.356146552000041],
              [73.39942467500003, 5.355454820000091],
              [73.39616946700005, 5.357123114000046],
              [73.39600670700008, 5.358465887000079],
              [73.39714603000004, 5.360174872000073],
              [73.39747155000003, 5.362209377000056],
            ],
          ],
          [
            [
              [73.32325280000003, 5.368231512000079],
              [73.32488040500004, 5.366766669000071],
              [73.32496178500008, 5.366766669000071],
              [73.32789147200003, 5.367010809000078],
              [73.32797285200007, 5.367010809000078],
              [73.32821699300007, 5.367010809000078],
              [73.33008873800003, 5.366848049000055],
              [73.32886803500008, 5.364243882000039],
              [73.31934655000003, 5.362941799000055],
              [73.31918379000007, 5.362941799000055],
              [73.31771894600007, 5.365790106000077],
              [73.31918379000007, 5.36664459800005],
              [73.32203209700003, 5.366888739000046],
              [73.32325280000003, 5.368231512000079],
            ],
          ],
          [
            [
              [73.35075931100005, 5.427679755000042],
              [73.34489993600005, 5.426825262000079],
              [73.34457441500007, 5.426743882000039],
              [73.34750410200007, 5.428778387000079],
              [73.35075931100005, 5.427679755000042],
            ],
          ],
          [
            [
              [73.53744550900007, 5.451402085000041],
              [73.53492272200003, 5.44985586100006],
              [73.53126061300003, 5.450425523000092],
              [73.53744550900007, 5.451402085000041],
            ],
          ],
          [
            [
              [73.36296634200005, 5.463080145000049],
              [73.36296634200005, 5.462795315000051],
              [73.36312910200007, 5.459377346000053],
              [73.36093183700007, 5.457953192000048],
              [73.36068769600007, 5.457831122000073],
              [73.36296634200005, 5.463080145000049],
            ],
          ],
          [
            [
              [72.94312584700003, 5.467596747000073],
              [72.94304446700005, 5.467474677000041],
              [72.94157962300005, 5.46556224200009],
              [72.94109134200005, 5.463568427000041],
              [72.94027754000007, 5.462144273000092],
              [72.93824303500008, 5.461493231000077],
              [72.93702233200008, 5.465521552000041],
              [72.93816165500004, 5.466701565000051],
              [72.94060306100005, 5.466782945000091],
              [72.94312584700003, 5.467596747000073],
            ],
          ],
          [
            [
              [73.01587975400008, 5.492865302000041],
              [73.01433353000004, 5.490912177000041],
              [73.01384524800005, 5.48891836100006],
              [73.01303144600007, 5.487453518000052],
              [73.01107832100007, 5.486843166000085],
              [73.01099694100003, 5.486802476000094],
              [73.00993899800005, 5.490220445000091],
              [73.00977623800003, 5.490912177000041],
              [73.01091556100005, 5.492132880000042],
              [73.01319420700008, 5.492132880000042],
              [73.01587975400008, 5.492865302000041],
            ],
          ],
          [
            [
              [73.46241295700008, 5.54360586100006],
              [73.45932050900007, 5.54173411700009],
              [73.45647220100005, 5.542629299000055],
              [73.45630944100003, 5.542669989000046],
              [73.46241295700008, 5.54360586100006],
            ],
          ],
          [
            [
              [73.00562584700003, 5.713324286000045],
              [73.00375410200007, 5.711127020000049],
              [73.00318444100003, 5.708726304000038],
              [73.00228925900007, 5.707098700000074],
              [72.99976647200003, 5.706976630000042],
              [72.99878991000008, 5.711981512000079],
              [73.00017337300005, 5.71320221600007],
              [73.00025475400008, 5.71320221600007],
              [73.00082441500007, 5.713120835000041],
              [73.00277754000007, 5.712836005000042],
              [73.00562584700003, 5.713324286000045],
            ],
          ],
          [
            [
              [72.94939212300005, 6.349798895000049],
              [72.94939212300005, 6.349676825000074],
              [72.95093834700003, 6.347723700000074],
              [72.95118248800003, 6.347601630000042],
              [72.95297285200007, 6.346625067000048],
              [72.95337975400008, 6.346258856000077],
              [72.95394941500007, 6.345607815000051],
              [72.95313561300003, 6.343491929000038],
              [72.94849694100003, 6.344427802000041],
              [72.94776451900003, 6.345933335000041],
              [72.94898522200003, 6.348049221000053],
              [72.94939212300005, 6.349798895000049],
            ],
          ],
          [
            [
              [72.89258873800003, 6.452093817000048],
              [72.89421634200005, 6.44993724200009],
              [72.89616946700005, 6.448879299000055],
              [72.89690188900005, 6.448187567000048],
              [72.89722741000008, 6.44790273600006],
              [72.89722741000008, 6.447821356000077],
              [72.89633222700007, 6.445786851000094],
              [72.89177493600005, 6.44672272300005],
              [72.89161217500003, 6.447007554000038],
              [72.89087975400008, 6.448228257000039],
              [72.89210045700008, 6.450262762000079],
              [72.89258873800003, 6.452093817000048],
            ],
          ],
          [
            [
              [73.09750410200007, -0.599704684999949],
              [73.10499108200008, -0.606540622999944],
              [73.11158287900008, -0.617120049999926],
              [73.11638431100005, -0.629571221999925],
              [73.11866295700008, -0.641289971999925],
              [73.11117597700007, -0.641289971999925],
              [73.09489993600005, -0.604668877999927],
              [73.09115644600007, -0.586032809999949],
              [73.10499108200008, -0.579196872999944],
              [73.10499108200008, -0.586602471999925],
              [73.09880618600005, -0.58717213299991],
              [73.09782962300005, -0.590020440999922],
              [73.09864342500003, -0.594333591999941],
              [73.09864342500003, -0.594414971999925],
              [73.09750410200007, -0.599704684999949],
            ],
          ],
          [
            [
              [73.36500084700003, 1.791083075000074],
              [73.36516360800005, 1.791042385000083],
              [73.37582441500007, 1.788560289000088],
              [73.37045332100007, 1.782538153000075],
              [73.36825605600006, 1.782945054000038],
              [73.36817467500003, 1.782945054000038],
              [73.36695397200003, 1.786688544000071],
              [73.36500084700003, 1.791083075000074],
            ],
          ],
          [
            [
              [73.40023847700007, 1.806341864000046],
              [73.40031985800005, 1.806138414000088],
              [73.40121504000007, 1.801703192000048],
              [73.40308678500008, 1.798000393000052],
              [73.40211022200003, 1.795599677000041],
              [73.40056399800005, 1.795436916000085],
              [73.39437910200007, 1.794745184000078],
              [73.39478600400008, 1.798651434000078],
              [73.39478600400008, 1.798773505000042],
              [73.39519290500004, 1.799343166000085],
              [73.39665774800005, 1.80141836100006],
              [73.39893639400003, 1.803534247000073],
              [73.40023847700007, 1.806341864000046],
            ],
          ],
          [
            [
              [73.45264733200008, 1.82680898600006],
              [73.46363366000008, 1.826320705000057],
              [73.45671634200005, 1.820379950000074],
              [73.45411217500003, 1.820542710000041],
              [73.45337975400008, 1.823716539000088],
              [73.45264733200008, 1.82680898600006],
            ],
          ],
          [
            [
              [73.51807701900003, 1.842718817000048],
              [73.51083418100006, 1.836940822000088],
              [73.49919681100005, 1.827785549000055],
              [73.49919681100005, 1.827704169000071],
              [73.49878991000008, 1.828111070000091],
              [73.49854576900003, 1.82843659100007],
              [73.49805748800003, 1.828802802000041],
              [73.49781334700003, 1.829250393000052],
              [73.50009199300007, 1.832058010000083],
              [73.50228925900007, 1.834906317000048],
              [73.50733483200008, 1.838364976000094],
              [73.51791425900007, 1.842678127000056],
              [73.51807701900003, 1.842718817000048],
            ],
          ],
          [
            [
              [73.53646894600007, 1.870103257000039],
              [73.53630618600005, 1.869737046000068],
              [73.53296959700003, 1.86163971600007],
              [73.53239993600005, 1.86009349200009],
              [73.53150475400008, 1.863511460000041],
              [73.53239993600005, 1.865668036000045],
              [73.53305097700007, 1.866359768000052],
              [73.53435306100005, 1.867580471000053],
              [73.53646894600007, 1.870103257000039],
            ],
          ],
          [
            [
              [73.25171959700003, 1.892401434000078],
              [73.24366295700008, 1.888739325000074],
              [73.24398847700007, 1.894110419000071],
              [73.24561608200008, 1.89484284100007],
              [73.24740644600007, 1.89398834800005],
              [73.24830162900008, 1.893540757000039],
              [73.25171959700003, 1.892401434000078],
            ],
          ],
          [
            [
              [73.55307050900007, 1.932440497000073],
              [73.54883873800003, 1.911363023000092],
              [73.54566491000008, 1.901556708000044],
              [73.54118899800005, 1.89288971600007],
              [73.54086347700007, 1.892401434000078],
              [73.54981530000003, 1.924994208000044],
              [73.55307050900007, 1.932440497000073],
            ],
          ],
          [
            [
              [73.55005944100003, 1.976385809000078],
              [73.54981530000003, 1.965684312000064],
              [73.54981530000003, 1.965521552000041],
              [73.54769941500007, 1.968329169000071],
              [73.54786217500003, 1.970607815000051],
              [73.55005944100003, 1.976385809000078],
            ],
          ],
          [
            [
              [73.31723066500007, 1.991400458000044],
              [73.31983483200008, 1.989203192000048],
              [73.32260175900007, 1.987982489000046],
              [73.32325280000003, 1.986476955000057],
              [73.31836998800003, 1.983099677000041],
              [73.31544030000003, 1.985052802000041],
              [73.31576582100007, 1.986802476000094],
              [73.31714928500008, 1.988836981000077],
              [73.31723066500007, 1.991400458000044],
            ],
          ],
          [
            [
              [73.54420006600003, 2.026597398000092],
              [73.54297936300003, 2.022162177000041],
              [73.54037519600007, 2.022528387000079],
              [73.54029381600003, 2.022528387000079],
              [73.54224694100003, 2.024562893000052],
              [73.54420006600003, 2.026597398000092],
            ],
          ],
          [
            [
              [73.38697350400008, 2.033026434000078],
              [73.38697350400008, 2.028631903000075],
              [73.38624108200008, 2.030340887000079],
              [73.38697350400008, 2.033026434000078],
            ],
          ],
          [
            [
              [73.55567467500003, 2.082505601000094],
              [73.55144290500004, 2.07257721600007],
              [73.55144290500004, 2.072414455000057],
              [73.55046634200005, 2.075873114000046],
              [73.55128014400003, 2.078070380000042],
              [73.55323326900003, 2.079901434000078],
              [73.55567467500003, 2.082505601000094],
            ],
          ],
          [
            [
              [73.56763756600003, 2.109930731000077],
              [73.58537845100005, 2.109605210000041],
              [73.58545983200008, 2.109605210000041],
              [73.58350670700008, 2.10814036700009],
              [73.58041425900007, 2.10578034100007],
              [73.56771894600007, 2.097805080000057],
              [73.56177819100003, 2.094712632000039],
              [73.56177819100003, 2.098781643000052],
              [73.56299889400003, 2.102362372000073],
              [73.56763756600003, 2.109930731000077],
            ],
          ],
          [
            [
              [73.04371178500008, 2.166449286000045],
              [73.04135175900007, 2.16469961100006],
              [73.03980553500008, 2.164618231000077],
              [73.03825931100005, 2.164536851000094],
              [73.03842207100007, 2.164618231000077],
              [73.04371178500008, 2.166449286000045],
            ],
          ],
          [
            [
              [73.10385175900007, 2.186590887000079],
              [73.10385175900007, 2.186509507000039],
              [73.10287519600007, 2.184393622000073],
              [73.10287519600007, 2.182114976000094],
              [73.10230553500008, 2.180975653000075],
              [73.09945722700007, 2.18195221600007],
              [73.09888756600003, 2.184637762000079],
              [73.09978274800005, 2.185532945000091],
              [73.10173587300005, 2.185695705000057],
              [73.10385175900007, 2.186590887000079],
            ],
          ],
          [
            [
              [73.11548912900008, 2.199693101000094],
              [73.11687259200005, 2.197658596000053],
              [73.12086022200003, 2.191799221000053],
              [73.11500084700003, 2.191799221000053],
              [73.11394290500004, 2.193508205000057],
              [73.11491946700005, 2.196437893000052],
              [73.11548912900008, 2.199693101000094],
            ],
          ],
          [
            [
              [72.94841556100005, 2.274888414000088],
              [72.94638105600006, 2.272406317000048],
              [72.94629967500003, 2.272365627000056],
              [72.94312584700003, 2.273016669000071],
              [72.94841556100005, 2.274888414000088],
            ],
          ],
          [
            [
              [72.92611738400007, 2.327460028000075],
              [72.92701256600003, 2.316066799000055],
              [72.92253665500004, 2.319566148000092],
              [72.92237389400003, 2.322088934000078],
              [72.92432701900003, 2.324448960000041],
              [72.92611738400007, 2.327460028000075],
            ],
          ],
          [
            [
              [73.34400475400008, 2.348049221000053],
              [73.34392337300005, 2.347438869000086],
              [73.34359785200007, 2.344183661000045],
              [73.34229576900003, 2.342393296000068],
              [73.34205162900008, 2.34210846600007],
              [73.34400475400008, 2.348049221000053],
            ],
          ],
          [
            [
              [73.35425866000008, 2.437201239000046],
              [73.36133873800003, 2.424709377000056],
              [73.36532636800007, 2.413885809000078],
              [73.36622155000003, 2.411525783000059],
              [73.36703535200007, 2.398016669000071],
              [73.36264082100007, 2.385117906000062],
              [73.36255944100003, 2.384914455000057],
              [73.35385175900007, 2.429022528000075],
              [73.35425866000008, 2.437201239000046],
            ],
          ],
          [
            [
              [73.31478925900007, 2.505804755000042],
              [73.31519616000008, 2.494126695000091],
              [73.31519616000008, 2.494045315000051],
              [73.31373131600003, 2.495184637000079],
              [73.31177819100003, 2.496771552000041],
              [73.31177819100003, 2.496893622000073],
              [73.31153405000003, 2.499253648000092],
              [73.31324303500008, 2.502101955000057],
              [73.31478925900007, 2.505804755000042],
            ],
          ],
          [
            [
              [73.14551842500003, 2.553290106000077],
              [73.14380944100003, 2.550360419000071],
              [73.14112389400003, 2.550360419000071],
              [73.14096113400007, 2.550360419000071],
              [73.14551842500003, 2.553290106000077],
            ],
          ],
          [
            [
              [72.90007571700005, 2.682196356000077],
              [72.90259850400008, 2.680975653000075],
              [72.90528405000003, 2.680812893000052],
              [72.90642337300005, 2.679673570000091],
              [72.90447024800005, 2.675726630000042],
              [72.90113366000008, 2.676174221000053],
              [72.90056399800005, 2.677557684000078],
              [72.90072675900007, 2.679754950000074],
              [72.90007571700005, 2.682196356000077],
            ],
          ],
          [
            [
              [72.87256920700008, 2.694159247000073],
              [72.87370853000004, 2.683661200000074],
              [72.87370853000004, 2.683579820000091],
              [72.86736087300005, 2.686672268000052],
              [72.86695397200003, 2.688950914000088],
              [72.86980228000004, 2.691229559000078],
              [72.87256920700008, 2.694159247000073],
            ],
          ],
          [
            [
              [73.02230879000007, 2.741685289000088],
              [73.03223717500003, 2.745103257000039],
              [73.03223717500003, 2.745021877000056],
              [73.02800540500004, 2.738226630000042],
              [73.02540123800003, 2.737616278000075],
              [73.02239017000005, 2.74164459800005],
              [73.02230879000007, 2.741685289000088],
            ],
          ],
          [
            [
              [73.35352623800003, 2.778265692000048],
              [73.35271243600005, 2.77570221600007],
              [73.35352623800003, 2.773627020000049],
              [73.35352623800003, 2.771918036000045],
              [73.35149173300005, 2.770738023000092],
              [73.35141035200007, 2.770697333000044],
              [73.34848066500007, 2.775376695000091],
              [73.34929446700005, 2.777167059000078],
              [73.35157311300003, 2.777533270000049],
              [73.35352623800003, 2.778265692000048],
            ],
          ],
          [
            [
              [73.39926191500007, 2.785711981000077],
              [73.39063561300003, 2.775376695000091],
              [73.39185631600003, 2.781480210000041],
              [73.39437910200007, 2.784328518000052],
              [73.39747155000003, 2.785305080000057],
              [73.39926191500007, 2.785711981000077],
            ],
          ],
          [
            [
              [73.54859459700003, 2.892726955000057],
              [73.54875735800005, 2.892604885000083],
              [73.55014082100007, 2.89134349200009],
              [73.55103600400008, 2.890611070000091],
              [73.54908287900008, 2.88812897300005],
              [73.54908287900008, 2.888739325000074],
              [73.54859459700003, 2.892726955000057],
            ],
          ],
          [
            [
              [73.36036217500003, 2.903876044000071],
              [73.36101321700005, 2.901516018000052],
              [73.36231530000003, 2.899725653000075],
              [73.36280358200008, 2.898382880000042],
              [73.36085045700008, 2.89756907800006],
              [73.36068769600007, 2.897528387000079],
              [73.35726972700007, 2.899807033000059],
              [73.35726972700007, 2.901190497000073],
              [73.35914147200003, 2.902289130000042],
              [73.36036217500003, 2.903876044000071],
            ],
          ],
          [
            [
              [73.00847415500004, 2.953314520000049],
              [73.01490319100003, 2.947414455000057],
              [73.01042728000004, 2.945257880000042],
              [73.00993899800005, 2.945705471000053],
              [73.00904381600003, 2.946437893000052],
              [73.00904381600003, 2.949448960000041],
              [73.00904381600003, 2.94953034100007],
              [73.00847415500004, 2.953314520000049],
            ],
          ],
          [
            [
              [73.56421959700003, 2.954738674000055],
              [73.56421959700003, 2.95461660400008],
              [73.56202233200008, 2.946112372000073],
              [73.56128991000008, 2.948472398000092],
              [73.56177819100003, 2.950384833000044],
              [73.56421959700003, 2.954738674000055],
            ],
          ],
          [
            [
              [73.58594811300003, 2.961615302000041],
              [73.58586673300005, 2.961533921000068],
              [73.57748457100007, 2.951157945000091],
              [73.57846113400007, 2.95734284100007],
              [73.58130944100003, 2.960150458000044],
              [73.58415774800005, 2.96124909100007],
              [73.58594811300003, 2.961615302000041],
            ],
          ],
          [
            [
              [72.87012780000003, 2.969183661000045],
              [72.87012780000003, 2.96906159100007],
              [72.86768639400003, 2.960882880000042],
              [72.86508222700007, 2.958156643000052],
              [72.86491946700005, 2.960882880000042],
              [72.87012780000003, 2.969183661000045],
            ],
          ],
          [
            [
              [72.90162194100003, 3.083807684000078],
              [72.90284264400003, 3.081854559000078],
              [72.90414472700007, 3.08148834800005],
              [72.90479576900003, 3.081284898000092],
              [72.90601647200003, 3.08038971600007],
              [72.90447024800005, 3.077378648000092],
              [72.89991295700008, 3.076849677000041],
              [72.89942467500003, 3.078192450000074],
              [72.90072675900007, 3.080633856000077],
              [72.90162194100003, 3.083807684000078],
            ],
          ],
          [
            [
              [73.61304772200003, 3.106756903000075],
              [73.61255944100003, 3.10297272300005],
              [73.60840905000003, 3.100409247000073],
              [73.61304772200003, 3.106756903000075],
            ],
          ],
          [
            [
              [72.97787519600007, 3.110174872000073],
              [72.97803795700008, 3.110052802000041],
              [72.97917728000004, 3.10805898600006],
              [72.98129316500007, 3.106634833000044],
              [72.98178144600007, 3.105047919000071],
              [72.97820071700005, 3.102728583000044],
              [72.97510826900003, 3.104193427000041],
              [72.97535241000008, 3.105698960000041],
              [72.97689863400007, 3.107652085000041],
              [72.97787519600007, 3.110174872000073],
            ],
          ],
          [
            [
              [73.04224694100003, 3.205471096000053],
              [73.04346764400003, 3.203517971000053],
              [73.04354902400007, 3.203477281000062],
              [73.04566491000008, 3.202866929000038],
              [73.04688561300003, 3.202053127000056],
              [73.04509524800005, 3.198919989000046],
              [73.04070071700005, 3.198472398000092],
              [73.04021243600005, 3.199774481000077],
              [73.04135175900007, 3.202297268000052],
              [73.04224694100003, 3.205471096000053],
            ],
          ],
          [
            [
              [73.03174889400003, 3.252997137000079],
              [73.03183027400007, 3.252875067000048],
              [73.03321373800003, 3.250881252000056],
              [73.03516686300003, 3.249335028000075],
              [73.03565514400003, 3.247788804000038],
              [73.03199303500008, 3.24555084800005],
              [73.03174889400003, 3.245672919000071],
              [73.02898196700005, 3.246893622000073],
              [73.02930748800003, 3.248439846000053],
              [73.03077233200008, 3.250474351000094],
              [73.03174889400003, 3.252997137000079],
            ],
          ],
          [
            [
              [72.83326256600003, 3.312486070000091],
              [72.83448326900003, 3.310532945000091],
              [72.83668053500008, 3.31000397300005],
              [72.83708743600005, 3.309637762000079],
              [72.83765709700003, 3.309068101000094],
              [72.83611087300005, 3.305975653000075],
              [72.83155358200008, 3.305609442000048],
              [72.83139082100007, 3.305609442000048],
              [72.83122806100005, 3.306830145000049],
              [72.83236738400007, 3.30931224200009],
              [72.83326256600003, 3.312486070000091],
            ],
          ],
          [
            [
              [73.51636803500008, 3.361232815000051],
              [73.51653079500005, 3.361070054000038],
              [73.51742597700007, 3.360296942000048],
              [73.51880944100003, 3.359116929000038],
              [73.51889082100007, 3.358872789000088],
              [73.51913496200007, 3.356594143000052],
              [73.51921634200005, 3.356390692000048],
              [73.51636803500008, 3.361232815000051],
            ],
          ],
          [
            [
              [73.74756920700008, 3.451117255000042],
              [73.74773196700005, 3.450995184000078],
              [73.75310306100005, 3.446437893000052],
              [73.75318444100003, 3.446356512000079],
              [73.75123131600003, 3.44712962400007],
              [73.74854576900003, 3.448187567000048],
              [73.74838300900007, 3.448635158000059],
              [73.74756920700008, 3.451117255000042],
            ],
          ],
          [
            [
              [73.50586998800003, 3.501206773000092],
              [73.50847415500004, 3.496568101000094],
              [73.50855553500008, 3.496486721000053],
              [73.50619550900007, 3.497626044000071],
              [73.50611412900008, 3.497707424000055],
              [73.50586998800003, 3.501206773000092],
            ],
          ],
          [
            [
              [72.95240319100003, 3.73383209800005],
              [72.95378665500004, 3.731634833000044],
              [72.95582116000008, 3.730129299000055],
              [72.95582116000008, 3.728705145000049],
              [72.95199629000007, 3.72687409100007],
              [72.94898522200003, 3.728583075000074],
              [72.94939212300005, 3.730047919000071],
              [72.95118248800003, 3.731512762000079],
              [72.95240319100003, 3.73383209800005],
            ],
          ],
          [
            [
              [72.94581139400003, 3.77212148600006],
              [72.94711347700007, 3.76984284100007],
              [72.94857832100007, 3.768784898000092],
              [72.94906660200007, 3.768377997000073],
              [72.94939212300005, 3.766994533000059],
              [72.94532311300003, 3.765204169000071],
              [72.94491621200007, 3.765448309000078],
              [72.94239342500003, 3.766953843000067],
              [72.94288170700008, 3.768377997000073],
              [72.94467207100007, 3.76984284100007],
              [72.94581139400003, 3.77212148600006],
            ],
          ],
          [
            [
              [72.94459069100003, 3.836859442000048],
              [72.94581139400003, 3.834662177000041],
              [72.94662519600007, 3.834011135000083],
              [72.94776451900003, 3.833075262000079],
              [72.94809004000007, 3.831691799000055],
              [72.94410241000008, 3.829901434000078],
              [72.94117272200003, 3.831691799000055],
              [72.94166100400008, 3.833075262000079],
              [72.94336998800003, 3.834662177000041],
              [72.94459069100003, 3.836859442000048],
            ],
          ],
          [
            [
              [73.43726647200003, 3.846625067000048],
              [73.43523196700005, 3.844916083000044],
              [73.43344160200007, 3.842718817000048],
              [73.43230228000004, 3.841742255000042],
              [73.43148847700007, 3.843695380000042],
              [73.43246504000007, 3.846828518000052],
              [73.43392988400007, 3.847398179000038],
              [73.43572024800005, 3.846828518000052],
              [73.43726647200003, 3.846625067000048],
            ],
          ],
          [
            [
              [73.44353274800005, 3.92055898600006],
              [73.44345136800007, 3.920477606000077],
              [73.44304446700005, 3.918768622000073],
              [73.43848717500003, 3.916612046000068],
              [73.43816165500004, 3.916449286000045],
              [73.44353274800005, 3.92055898600006],
            ],
          ],
          [
            [
              [73.34506269600007, 3.944728908000059],
              [73.34489993600005, 3.944566148000092],
              [73.34148196700005, 3.94204336100006],
              [73.34148196700005, 3.943101304000038],
              [73.34506269600007, 3.944728908000059],
            ],
          ],
          [
            [
              [73.42261803500008, 4.118353583000044],
              [73.42253665500004, 4.118190822000088],
              [73.42139733200008, 4.116359768000052],
              [73.41911868600005, 4.115749416000085],
              [73.41895592500003, 4.115708726000094],
              [73.42261803500008, 4.118353583000044],
            ],
          ],
          [
            [
              [73.54619719090421, 4.24303891168205],
              [73.55288301214804, 4.236798811854472],
              [73.55199156931553, 4.228330104945616],
              [73.549317240818, 4.212284133960416],
              [73.53817420541161, 4.183312241903804],
              [73.52658544858896, 4.171277763664904],
              [73.51089134292747, 4.162087459716128],
              [73.48691624254222, 4.164146221004814],
              [73.47666464996834, 4.16860343516737],
              [73.43120106551027, 4.184649406152571],
              [73.43209250834278, 4.189998063147637],
              [73.51201489529225, 4.186300883534724],
              [73.52053323825227, 4.191122568286097],
              [73.5261397271727, 4.20782691979786],
              [73.5332712698328, 4.23100443344315],
              [73.54619719090421, 4.24303891168205],
            ],
          ],
          [
            [
              [72.94516035200007, 4.266302802000041],
              [72.95866946700005, 4.262518622000073],
              [72.95858808700007, 4.262518622000073],
              [72.95443769600007, 4.261501369000086],
              [72.95435631600003, 4.261460679000038],
              [72.95118248800003, 4.26235586100006],
              [72.94516035200007, 4.266302802000041],
            ],
          ],
          [
            [
              [73.59587649800005, 4.342271226000094],
              [73.59571373800003, 4.342189846000053],
              [73.59245853000004, 4.34015534100007],
              [73.58936608200008, 4.34056224200009],
              [73.58912194100003, 4.34056224200009],
              [73.59587649800005, 4.342271226000094],
            ],
          ],
          [
            [
              [73.61150149800005, 4.363104559000078],
              [73.61150149800005, 4.362941799000055],
              [73.61133873800003, 4.360296942000048],
              [73.61198978000004, 4.358099677000041],
              [73.61182701900003, 4.356512762000079],
              [73.60954837300005, 4.355617580000057],
              [73.60767662900008, 4.358099677000041],
              [73.60824629000007, 4.359442450000074],
              [73.60987389400003, 4.360825914000088],
              [73.61150149800005, 4.363104559000078],
            ],
          ],
          [
            [
              [73.63795006600003, 4.37055084800005],
              [73.63786868600005, 4.370428778000075],
              [73.63705488400007, 4.368068752000056],
              [73.63746178500008, 4.365627346000053],
              [73.63746178500008, 4.365464585000041],
              [73.63705488400007, 4.36399974200009],
              [73.63575280000003, 4.364243882000039],
              [73.63379967500003, 4.364650783000059],
              [73.63363691500007, 4.36469147300005],
              [73.63168379000007, 4.368475653000075],
              [73.63298587300005, 4.369533596000053],
              [73.63542728000004, 4.369574286000045],
              [73.63795006600003, 4.37055084800005],
            ],
          ],
          [
            [
              [73.66797936300003, 4.393500067000048],
              [73.66781660200007, 4.390692450000074],
              [73.66846764400003, 4.388495184000078],
              [73.66830488400007, 4.386867580000057],
              [73.66618899800005, 4.385931708000044],
              [73.66431725400008, 4.388332424000055],
              [73.66488691500007, 4.389797268000052],
              [73.66651451900003, 4.391302802000041],
              [73.66797936300003, 4.393500067000048],
            ],
          ],
          [
            [
              [72.95704186300003, 4.438299872000073],
              [72.95606530000003, 4.422105210000041],
              [72.94890384200005, 4.422919012000079],
              [72.94711347700007, 4.423081773000092],
              [72.94336998800003, 4.431586005000042],
              [72.95704186300003, 4.438299872000073],
            ],
          ],
          [
            [
              [73.55355879000007, 4.620510158000059],
              [73.55355879000007, 4.620266018000052],
              [73.55347741000008, 4.617661851000094],
              [73.55404707100007, 4.615464585000041],
              [73.55388431100005, 4.61391836100006],
              [73.55160566500007, 4.612982489000046],
              [73.55095462300005, 4.613836981000077],
              [73.54981530000003, 4.615383205000057],
              [73.55046634200005, 4.616848049000055],
              [73.55201256600003, 4.618231512000079],
              [73.55355879000007, 4.620510158000059],
            ],
          ],
          [
            [
              [73.62956790500004, 5.418524481000077],
              [73.63453209700003, 5.410956122000073],
              [73.63672936300003, 5.402899481000077],
              [73.63591556100005, 5.394476630000042],
              [73.63249759200005, 5.38625722900008],
              [73.63249759200005, 5.386053778000075],
              [73.62777754000007, 5.413275458000044],
              [73.62956790500004, 5.418524481000077],
            ],
          ],
          [
            [
              [73.00562584700003, 5.46320221600007],
              [73.00554446700005, 5.463120835000041],
              [73.00416100400008, 5.461411851000094],
              [73.00261478000004, 5.457586981000077],
              [73.00098717500003, 5.456244208000044],
              [72.99903405000003, 5.461004950000074],
              [72.99903405000003, 5.461086330000057],
              [73.00001061300003, 5.462469794000071],
              [73.00277754000007, 5.462469794000071],
              [73.00562584700003, 5.46320221600007],
            ],
          ],
          [
            [
              [72.88396243600005, 5.494086005000042],
              [72.88249759200005, 5.492010809000078],
              [72.88184655000003, 5.490057684000078],
              [72.88111412900008, 5.488470770000049],
              [72.87916100400008, 5.487860419000071],
              [72.87769616000008, 5.492092190000051],
              [72.87875410200007, 5.493150132000039],
              [72.88119550900007, 5.493231512000079],
              [72.88396243600005, 5.494086005000042],
            ],
          ],
          [
            [
              [73.01905358200008, 5.61782461100006],
              [73.01897220100005, 5.617661851000094],
              [73.01734459700003, 5.615708726000094],
              [73.01685631600003, 5.613755601000094],
              [73.01612389400003, 5.612250067000048],
              [73.01417076900003, 5.611599026000079],
              [73.01400800900007, 5.611558335000041],
              [73.01286868600005, 5.615708726000094],
              [73.01392662900008, 5.616888739000046],
              [73.01644941500007, 5.616888739000046],
              [73.01905358200008, 5.61782461100006],
            ],
          ],
          [
            [
              [73.01465905000003, 5.676988023000092],
              [73.01319420700008, 5.675034898000092],
              [73.01246178500008, 5.673000393000052],
              [73.01189212300005, 5.671535549000055],
              [73.00977623800003, 5.670843817000048],
              [73.00855553500008, 5.675034898000092],
              [73.00977623800003, 5.67609284100007],
              [73.01205488400007, 5.676255601000094],
              [73.01465905000003, 5.676988023000092],
            ],
          ],
          [
            [
              [73.39283287900008, 5.737697658000059],
              [73.39242597700007, 5.736802476000094],
              [73.38070722700007, 5.714585679000038],
              [73.38062584700003, 5.714748440000051],
              [73.37989342500003, 5.715033270000049],
              [73.37981204500005, 5.715073960000041],
              [73.37956790500004, 5.71515534100007],
              [73.38257897200003, 5.72211334800005],
              [73.39283287900008, 5.737697658000059],
            ],
          ],
          [
            [
              [72.98682701900003, 5.770738023000092],
              [72.98585045700008, 5.765570380000042],
              [72.98283938900005, 5.762559312000064],
              [72.98275800900007, 5.762518622000073],
              [72.98682701900003, 5.770738023000092],
            ],
          ],
          [
            [
              [73.38233483200008, 5.794989325000074],
              [73.38233483200008, 5.794745184000078],
              [73.38266035200007, 5.791693427000041],
              [73.38428795700008, 5.789252020000049],
              [73.38453209700003, 5.787014065000051],
              [73.38453209700003, 5.786932684000078],
              [73.38070722700007, 5.784125067000048],
              [73.37680097700007, 5.787339585000041],
              [73.37769616000008, 5.789536851000094],
              [73.38021894600007, 5.791693427000041],
              [73.38233483200008, 5.794989325000074],
            ],
          ],
          [
            [
              [72.97657311300003, 5.813625393000052],
              [72.97657311300003, 5.813544012000079],
              [72.97510826900003, 5.80455149900007],
              [72.97510826900003, 5.804429429000038],
              [72.97242272200003, 5.807033596000053],
              [72.97095787900008, 5.808417059000078],
              [72.97103925900007, 5.810451565000051],
              [72.97380618600005, 5.811712958000044],
              [72.97657311300003, 5.813625393000052],
            ],
          ],
          [
            [
              [73.44988040500004, 5.840765692000048],
              [73.44979902400007, 5.840725002000056],
              [73.43376712300005, 5.830877997000073],
              [73.43344160200007, 5.83071523600006],
              [73.43897545700008, 5.838283596000053],
              [73.44312584700003, 5.84125397300005],
              [73.44654381600003, 5.841498114000046],
              [73.44988040500004, 5.840765692000048],
            ],
          ],
          [
            [
              [72.96363366000008, 5.864325262000079],
              [72.96371504000007, 5.864040432000081],
              [72.96648196700005, 5.850287177000041],
              [72.96265709700003, 5.853461005000042],
              [72.96192467500003, 5.856675523000092],
              [72.96363366000008, 5.864325262000079],
            ],
          ],
          [
            [
              [73.42904707100007, 5.911363023000092],
              [73.42904707100007, 5.911200262000079],
              [73.42847741000008, 5.908596096000053],
              [73.42847741000008, 5.90851471600007],
              [73.42847741000008, 5.906195380000042],
              [73.42847741000008, 5.904445705000057],
              [73.42628014400003, 5.903265692000048],
              [73.42318769600007, 5.90688711100006],
              [73.42408287900008, 5.908433335000041],
              [73.42660566500007, 5.909491278000075],
              [73.42904707100007, 5.911363023000092],
            ],
          ],
          [
            [
              [72.93165123800003, 5.96906159100007],
              [72.93018639400003, 5.956935940000051],
              [72.92579186300003, 5.963283596000053],
              [72.92644290500004, 5.966294664000088],
              [72.93165123800003, 5.96906159100007],
            ],
          ],
          [
            [
              [73.38982181100005, 5.970282294000071],
              [73.39533279100004, 5.957801545000052],
              [73.38672936300003, 5.961981512000079],
              [73.38453209700003, 5.964748440000051],
              [73.38982181100005, 5.970282294000071],
            ],
          ],
          [
            [
              [72.91570071700005, 5.981350002000056],
              [72.91561933700007, 5.981268622000073],
              [72.91382897200003, 5.979641018000052],
              [72.91342207100007, 5.977362372000073],
              [72.91285241000008, 5.976304429000038],
              [72.91138756600003, 5.977077541000085],
              [72.90984134200005, 5.977932033000059],
              [72.90967858200008, 5.982123114000046],
              [72.91089928500008, 5.98273346600007],
              [72.91309655000003, 5.981634833000044],
              [72.91570071700005, 5.981350002000056],
            ],
          ],
          [
            [
              [73.25074303500008, 6.083400783000059],
              [73.25066165500004, 6.083278713000084],
              [73.24903405000003, 6.07953522300005],
              [73.24545332100007, 6.079779364000046],
              [73.25074303500008, 6.083400783000059],
            ],
          ],
          [
            [
              [73.25212649800005, 6.111232815000051],
              [73.25196373800003, 6.111151434000078],
              [73.24724368600005, 6.107977606000077],
              [73.24683678500008, 6.10773346600007],
              [73.24887129000007, 6.110174872000073],
              [73.25212649800005, 6.111232815000051],
            ],
          ],
          [
            [
              [73.22046959700003, 6.132066148000092],
              [73.22038821700005, 6.131984768000052],
              [73.21900475400008, 6.129299221000053],
              [73.21517988400007, 6.128566799000055],
              [73.22046959700003, 6.132066148000092],
            ],
          ],
          [
            [
              [73.27027428500008, 6.156927802000041],
              [73.27019290500004, 6.156805731000077],
              [73.26880944100003, 6.154486395000049],
              [73.26807701900003, 6.152411200000074],
              [73.26726321700005, 6.150946356000077],
              [73.26531009200005, 6.150661526000079],
              [73.26514733200008, 6.150620835000041],
              [73.26539147200003, 6.153550523000092],
              [73.26661217500003, 6.154852606000077],
              [73.26823978000004, 6.155585028000075],
              [73.27027428500008, 6.156927802000041],
            ],
          ],
          [
            [
              [73.21908613400007, 6.172349351000094],
              [73.21892337300005, 6.172267971000053],
              [73.21404056100005, 6.168768622000073],
              [73.21583092500003, 6.171210028000075],
              [73.21908613400007, 6.172349351000094],
            ],
          ],
          [
            [
              [73.27084394600007, 6.189439195000091],
              [73.27084394600007, 6.189357815000051],
              [73.26807701900003, 6.178697007000039],
              [73.26539147200003, 6.182766018000052],
              [73.26596113400007, 6.18500397300005],
              [73.26840254000007, 6.186835028000075],
              [73.27084394600007, 6.189439195000091],
            ],
          ],
          [
            [
              [73.03419030000003, 6.222357489000046],
              [73.03402754000007, 6.222235419000071],
              [73.02914472700007, 6.218980210000041],
              [73.02898196700005, 6.218817450000074],
              [73.03044681100005, 6.22101471600007],
              [73.03419030000003, 6.222357489000046],
            ],
          ],
          [
            [
              [73.24170983200008, 6.23969147300005],
              [73.24219811300003, 6.236476955000057],
              [73.24366295700008, 6.234035549000055],
              [73.24390709700003, 6.231634833000044],
              [73.24024498800003, 6.228949286000045],
              [73.23633873800003, 6.232123114000046],
              [73.23707116000008, 6.234279690000051],
              [73.23975670700008, 6.236476955000057],
              [73.24170983200008, 6.23969147300005],
            ],
          ],
          [
            [
              [73.12842858200008, 6.286851304000038],
              [73.12614993600005, 6.284002997000073],
              [73.12305748800003, 6.283351955000057],
              [73.12289472700007, 6.283351955000057],
              [73.12842858200008, 6.286851304000038],
            ],
          ],
          [
            [
              [73.21517988400007, 6.294826565000051],
              [73.21517988400007, 6.294663804000038],
              [73.21306399800005, 6.289211330000057],
              [73.20915774800005, 6.286688544000071],
              [73.20875084700003, 6.286444403000075],
              [73.20932050900007, 6.286851304000038],
              [73.21517988400007, 6.294826565000051],
            ],
          ],
          [
            [
              [73.08334394600007, 6.308579820000091],
              [73.08326256600003, 6.30845774900007],
              [73.08139082100007, 6.305609442000048],
              [73.07846113400007, 6.305121161000045],
              [73.07813561300003, 6.305080471000053],
              [73.08334394600007, 6.308579820000091],
            ],
          ],
          [
            [
              [73.19703209700003, 6.327460028000075],
              [73.19711347700007, 6.327297268000052],
              [73.19825280000003, 6.324693101000094],
              [73.19931074300007, 6.324204820000091],
              [73.20036868600005, 6.323716539000088],
              [73.20191491000008, 6.322170315000051],
              [73.20101972700007, 6.318264065000051],
              [73.19507897200003, 6.319647528000075],
              [73.19499759200005, 6.319932359000063],
              [73.19418379000007, 6.321600653000075],
              [73.19597415500004, 6.324286200000074],
              [73.19703209700003, 6.327460028000075],
            ],
          ],
          [
            [
              [73.12452233200008, 6.332505601000094],
              [73.12419681100005, 6.332261460000041],
              [73.11963951900003, 6.329169012000079],
              [73.11931399800005, 6.328924872000073],
              [73.12094160200007, 6.331040757000039],
              [73.12452233200008, 6.332505601000094],
            ],
          ],
          [
            [
              [73.18726647200003, 6.350775458000044],
              [73.18490644600007, 6.34906647300005],
              [73.18360436300003, 6.347316799000055],
              [73.18213951900003, 6.34634023600006],
              [73.18018639400003, 6.34711334800005],
              [73.18100019600007, 6.349839585000041],
              [73.18262780000003, 6.350490627000056],
              [73.18482506600003, 6.35032786700009],
              [73.18726647200003, 6.350775458000044],
            ],
          ],
          [
            [
              [73.02051842500003, 6.368963934000078],
              [73.02182050900007, 6.366766669000071],
              [73.02393639400003, 6.36587148600006],
              [73.02491295700008, 6.364813544000071],
              [73.02418053500008, 6.362697658000059],
              [73.01929772200003, 6.36359284100007],
              [73.01872806100005, 6.365220445000091],
              [73.01986738400007, 6.367173570000091],
              [73.02051842500003, 6.368963934000078],
            ],
          ],
          [
            [
              [72.69092858200008, 6.411607164000088],
              [72.69084720100005, 6.41156647300005],
              [72.68881269600007, 6.409735419000071],
              [72.68718509200005, 6.407416083000044],
              [72.68588300900007, 6.406480210000041],
              [72.68482506600003, 6.408392645000049],
              [72.68588300900007, 6.411607164000088],
              [72.68751061300003, 6.412258205000057],
              [72.68913821700005, 6.411607164000088],
              [72.69092858200008, 6.411607164000088],
            ],
          ],
          [
            [
              [72.90284264400003, 6.44017161700009],
              [72.90447024800005, 6.437974351000094],
              [72.90642337300005, 6.436916408000059],
              [72.90691165500004, 6.436428127000056],
              [72.90748131600003, 6.435939846000053],
              [72.90748131600003, 6.43585846600007],
              [72.90658613400007, 6.433823960000041],
              [72.90202884200005, 6.434759833000044],
              [72.90186608200008, 6.435044664000088],
              [72.90113366000008, 6.436346747000073],
              [72.90219160200007, 6.438299872000073],
              [72.90284264400003, 6.44017161700009],
            ],
          ],
          [
            [
              [73.04881327800007, 6.441342196000051],
              [73.04623457100007, 6.43626536700009],
              [73.04330488400007, 6.433864651000079],
              [73.04314212300005, 6.433701890000066],
              [73.04881327800007, 6.441342196000051],
            ],
          ],
          [
            [
              [72.96208743600005, 6.559027411000045],
              [72.95997155000003, 6.557521877000056],
              [72.95899498800003, 6.555487372000073],
              [72.95801842500003, 6.554348049000055],
              [72.95582116000008, 6.55532461100006],
              [72.95679772200003, 6.56000397300005],
              [72.95834394600007, 6.560695705000057],
              [72.95842532600005, 6.560655015000066],
              [72.96021569100003, 6.559515692000048],
              [72.96208743600005, 6.559027411000045],
            ],
          ],
          [
            [
              [72.92400149800005, 6.565252997000073],
              [72.92554772200003, 6.563055731000077],
              [72.92750084700003, 6.562079169000071],
              [72.92872155000003, 6.561102606000077],
              [72.92774498800003, 6.55890534100007],
              [72.92310631600003, 6.559881903000075],
              [72.92253665500004, 6.561509507000039],
              [72.92351321700005, 6.563381252000056],
              [72.92400149800005, 6.565252997000073],
            ],
          ],
          [
            [
              [73.02995853000004, 6.58234284100007],
              [73.02987714900007, 6.582180080000057],
              [73.02947024800005, 6.579657294000071],
              [73.03012129000007, 6.577541408000059],
              [73.03036543100006, 6.576117255000042],
              [73.03044681100005, 6.576076565000051],
              [73.02816816500007, 6.575181382000039],
              [73.02735436300003, 6.57648346600007],
              [73.02556399800005, 6.579250393000052],
              [73.02613366000008, 6.58079661700009],
              [73.02833092500003, 6.581366278000075],
              [73.02995853000004, 6.58234284100007],
            ],
          ],
          [
            [
              [73.04476972700007, 6.621893622000073],
              [73.04265384200005, 6.620347398000092],
              [73.04151451900003, 6.618353583000044],
              [73.04070071700005, 6.617173570000091],
              [73.03842207100007, 6.618150132000039],
              [73.03939863400007, 6.622870184000078],
              [73.04102623800003, 6.623602606000077],
              [73.04110761800007, 6.623561916000085],
              [73.04297936300003, 6.62250397300005],
              [73.04476972700007, 6.621893622000073],
            ],
          ],
          [
            [
              [73.06950931100005, 6.667954820000091],
              [73.06177819100003, 6.660956122000073],
              [73.06226647200003, 6.666896877000056],
              [73.06413821700005, 6.668402411000045],
              [73.06666100400008, 6.668117580000057],
              [73.06950931100005, 6.667954820000091],
            ],
          ],
          [
            [
              [73.10596764400003, 6.709947007000039],
              [73.10352623800003, 6.705877997000073],
              [73.10230553500008, 6.702337958000044],
              [73.10043379000007, 6.699774481000077],
              [73.09595787900008, 6.698472398000092],
              [73.09587649800005, 6.698431708000044],
              [73.09669030000003, 6.706122137000079],
              [73.09929446700005, 6.708929755000042],
              [73.10596764400003, 6.709947007000039],
            ],
          ],
          [
            [
              [73.03663170700008, 6.759711005000042],
              [73.03663170700008, 6.75962962400007],
              [73.03614342500003, 6.757106838000084],
              [73.03622480600006, 6.756781317000048],
              [73.03679446700005, 6.755072333000044],
              [73.03687584700003, 6.753485419000071],
              [73.03467858200008, 6.75259023600006],
              [73.03386478000004, 6.753851630000042],
              [73.03199303500008, 6.75657786700009],
              [73.03288821700005, 6.758246161000045],
              [73.03484134200005, 6.758734442000048],
              [73.03663170700008, 6.759711005000042],
            ],
          ],
          [
            [
              [72.91846764400003, 6.76398346600007],
              [72.91651451900003, 6.76243724200009],
              [72.91537519600007, 6.760443427000041],
              [72.91431725400008, 6.75922272300005],
              [72.91236412900008, 6.76007721600007],
              [72.91228274800005, 6.760158596000053],
              [72.91325931100005, 6.764878648000092],
              [72.91488691500007, 6.765570380000042],
              [72.91675866000008, 6.764471747000073],
              [72.91846764400003, 6.76398346600007],
            ],
          ],
          [
            [
              [73.15951582100007, 6.786525783000059],
              [73.16423587300005, 6.787054755000042],
              [73.16553795700008, 6.785711981000077],
              [73.16553795700008, 6.785630601000094],
              [73.16553795700008, 6.783148505000042],
              [73.16651451900003, 6.780340887000079],
              [73.15284264400003, 6.749212958000044],
              [73.14478600400008, 6.735541083000044],
              [73.13184655000003, 6.725165106000077],
              [73.13168379000007, 6.725043036000045],
              [73.13599694100003, 6.741197007000039],
              [73.15251712300005, 6.76821523600006],
              [73.15951582100007, 6.786525783000059],
            ],
          ],
          [
            [
              [73.18165123800003, 6.830511786000045],
              [73.19727623800003, 6.828111070000091],
              [73.18946373800003, 6.822821356000077],
              [73.18376712300005, 6.821112372000073],
              [73.18083743600005, 6.823431708000044],
              [73.18165123800003, 6.830511786000045],
            ],
          ],
          [
            [
              [72.99577884200005, 6.841498114000046],
              [72.99569746200007, 6.841457424000055],
              [72.99366295700008, 6.839911200000074],
              [72.99244225400008, 6.837876695000091],
              [72.99154707100007, 6.836737372000073],
              [72.98951256600003, 6.837591864000046],
              [72.98943118600005, 6.837632554000038],
              [72.99024498800003, 6.84243398600006],
              [72.99203535200007, 6.843003648000092],
              [72.99390709700003, 6.841986395000049],
              [72.99577884200005, 6.841498114000046],
            ],
          ],
          [
            [
              [73.14437910200007, 6.843410549000055],
              [73.14226321700005, 6.841864325000074],
              [73.14128665500004, 6.839911200000074],
              [73.14031009200005, 6.838690497000073],
              [73.13803144600007, 6.839667059000078],
              [73.13900800900007, 6.844427802000041],
              [73.14063561300003, 6.845038153000075],
              [73.14258873800003, 6.843939520000049],
              [73.14437910200007, 6.843410549000055],
            ],
          ],
          [
            [
              [72.97608483200008, 6.852850653000075],
              [72.97559655000003, 6.850287177000041],
              [72.97624759200005, 6.848130601000094],
              [72.97624759200005, 6.848049221000053],
              [72.97632897200003, 6.846665757000039],
              [72.97421308700007, 6.845851955000057],
              [72.97413170700008, 6.845851955000057],
              [72.97152754000007, 6.849758205000057],
              [72.97234134200005, 6.851385809000078],
              [72.97437584700003, 6.851996161000045],
              [72.97608483200008, 6.852850653000075],
            ],
          ],
          [
            [
              [73.09815514400003, 6.85219961100006],
              [73.09807376400005, 6.852118231000077],
              [73.09603925900007, 6.850572007000039],
              [73.09506269600007, 6.848700262000079],
              [73.09400475400008, 6.847560940000051],
              [73.09278405000003, 6.84796784100007],
              [73.09180748800003, 6.848334052000041],
              [73.09294681100005, 6.853094794000071],
              [73.09449303500008, 6.85382721600007],
              [73.09636478000004, 6.852769273000092],
              [73.09644616000008, 6.852728583000044],
              [73.09815514400003, 6.85219961100006],
            ],
          ],
          [
            [
              [72.96469160200007, 6.860663153000075],
              [72.96265709700003, 6.859198309000078],
              [72.96143639400003, 6.857326565000051],
              [72.96062259200005, 6.856065171000068],
              [72.95875084700003, 6.856838283000059],
              [72.95850670700008, 6.85696035400008],
              [72.95834394600007, 6.857001044000071],
              [72.95923912900008, 6.86163971600007],
              [72.96111087300005, 6.862453518000052],
              [72.96290123800003, 6.861314195000091],
              [72.96469160200007, 6.860663153000075],
            ],
          ],
          [
            [
              [73.10621178500008, 6.896673895000049],
              [73.10572350400008, 6.894029039000088],
              [73.10629316500007, 6.891913153000075],
              [73.10653730600006, 6.890529690000051],
              [73.10661868600005, 6.890448309000078],
              [73.10434004000007, 6.889553127000056],
              [73.10173587300005, 6.893540757000039],
              [73.10230553500008, 6.895209052000041],
              [73.10450280000003, 6.895738023000092],
              [73.10621178500008, 6.896673895000049],
            ],
          ],
          [
            [
              [73.21404056100005, 6.91860586100006],
              [73.21404056100005, 6.918524481000077],
              [73.21306399800005, 6.90460846600007],
              [73.20875084700003, 6.891099351000094],
              [73.20394941500007, 6.884955145000049],
              [73.20101972700007, 6.893133856000077],
              [73.20191491000008, 6.902248440000051],
              [73.20492597700007, 6.911769924000055],
              [73.20915774800005, 6.91828034100007],
              [73.21404056100005, 6.91860586100006],
            ],
          ],
          [
            [
              [72.92595462300005, 6.957424221000053],
              [72.92595462300005, 6.957017320000091],
              [72.92628014400003, 6.953802802000041],
              [72.92458500800007, 6.951704061000044],
              [72.92595462300005, 6.957424221000053],
            ],
          ],
          [
            [
              [73.19849694100003, 6.97134023600006],
              [73.19467207100007, 6.951239325000074],
              [73.19385826900003, 6.950995184000078],
              [73.19336998800003, 6.950995184000078],
              [73.19320722700007, 6.950995184000078],
              [73.19304446700005, 6.951076565000051],
              [73.19255618600005, 6.951239325000074],
              [73.19190514400003, 6.951646226000094],
              [73.19117272200003, 6.961330471000053],
              [73.19190514400003, 6.967596747000073],
              [73.19410241000008, 6.970892645000049],
              [73.19849694100003, 6.97134023600006],
            ],
          ],
          [
            [
              [72.89193769600007, 6.991034247000073],
              [72.89193769600007, 6.987697658000059],
              [72.89055423300005, 6.98545970300006],
              [72.89047285200007, 6.985419012000079],
              [72.89193769600007, 6.991034247000073],
            ],
          ],
          [
            [
              [72.97974694100003, 7.027736721000053],
              [72.97974694100003, 7.027533270000049],
              [72.98145592500003, 7.01398346600007],
              [72.97730553500008, 7.019029039000088],
              [72.97722415500004, 7.022609768000052],
              [72.97722415500004, 7.022691148000092],
              [72.97974694100003, 7.027736721000053],
            ],
          ],
          [
            [
              [72.94996178500008, 7.056545315000051],
              [72.94996178500008, 7.056423244000086],
              [72.94849694100003, 7.050848700000074],
              [72.94776451900003, 7.053900458000044],
              [72.94996178500008, 7.056545315000051],
            ],
          ],
          [
            [
              [72.91285241000008, 7.092718817000048],
              [72.91285241000008, 7.092596747000073],
              [72.91187584700003, 7.083197333000044],
              [72.90642337300005, 7.089016018000052],
              [72.90658613400007, 7.091009833000044],
              [72.90967858200008, 7.091620184000078],
              [72.91285241000008, 7.092718817000048],
            ],
          ],
          [
            [
              [72.88379967500003, 7.107245184000078],
              [72.88453209700003, 7.105698960000041],
              [72.88453209700003, 7.103705145000049],
              [72.88249759200005, 7.101629950000074],
              [72.88379967500003, 7.107245184000078],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'S. Geo. and the Is.',
        iso3: 'SGS',
      },
      geometry: {
        type: 'MultiPolygon',
        coordinates: [
          [
            [
              [-27.25291907499991, -59.45826588299991],
              [-27.249989386999914, -59.44670989399992],
              [-27.243397589999915, -59.44068775799991],
              [-27.231312628999945, -59.43824635199991],
              [-27.136830206999946, -59.43718840899993],
              [-27.136830206999946, -59.444024346999925],
              [-27.14635169199994, -59.45273202899995],
              [-27.148182745999918, -59.46298593499995],
              [-27.152943488999938, -59.47079843499995],
              [-27.214222785999937, -59.47185637799993],
              [-27.23460852799991, -59.46795012799993],
              [-27.25291907499991, -59.45826588299991],
            ],
          ],
          [
            [
              [-27.328602667999917, -59.43718840899993],
              [-27.32323157499991, -59.44736093499995],
              [-27.321441209999932, -59.45777760199991],
              [-27.316477016999954, -59.4665666649999],
              [-27.301340298999946, -59.47193775799991],
              [-27.312123175999943, -59.47275155999995],
              [-27.322621222999942, -59.47185637799993],
              [-27.332753058999913, -59.46917083099993],
              [-27.342274542999917, -59.46453215899993],
              [-27.37140865799995, -59.45582447699991],
              [-27.399240688999953, -59.443617445999905],
              [-27.40721594999991, -59.43173593499995],
              [-27.377064581999946, -59.42351653399993],
              [-27.330922003999945, -59.42457447699991],
              [-27.32994544199994, -59.4275041649999],
              [-27.330962693999936, -59.43181731599992],
              [-27.328602667999917, -59.43718840899993],
            ],
          ],
          [
            [
              [-26.629750128999945, -59.00595468499995],
              [-26.595041469999956, -59.001885674999926],
              [-26.562652147999927, -59.00790780999995],
              [-26.499379035999937, -59.033135674999926],
              [-26.522084113999938, -59.0466447899999],
              [-26.54523678299995, -59.05722421699994],
              [-26.56944739499994, -59.06414153399993],
              [-26.59557044199994, -59.06731536299992],
              [-26.629790818999936, -59.062758070999905],
              [-26.653675910999937, -59.045586846999925],
              [-26.657053188999953, -59.023695570999905],
              [-26.629750128999945, -59.00595468499995],
            ],
          ],
          [
            [
              [-26.259836391999954, -58.43670012799993],
              [-26.255116339999915, -58.44491952899995],
              [-26.242014126999948, -58.461195570999905],
              [-26.23932857999995, -58.46770598799992],
              [-26.24567623599995, -58.488539320999905],
              [-26.246205206999946, -58.498711846999925],
              [-26.249379035999937, -58.49472421699994],
              [-26.252552863999938, -58.49358489399992],
              [-26.256011522999927, -58.49309661299992],
              [-26.30101477799991, -58.477227471999925],
              [-26.430287238999938, -58.45240650799991],
              [-26.457834438999953, -58.42669036299992],
              [-26.454701300999943, -58.42148202899995],
              [-26.447865363999938, -58.4138322899999],
              [-26.441029425999943, -58.40398528399993],
              [-26.437977667999917, -58.39226653399993],
              [-26.430897589999915, -58.385023695999905],
              [-26.414540167999917, -58.381931247999944],
              [-26.31236731699994, -58.38209400799991],
              [-26.27684485599991, -58.38689544099992],
              [-26.246205206999946, -58.40252044099992],
              [-26.259836391999954, -58.43670012799993],
            ],
          ],
          [
            [
              [-26.424305792999917, -57.812758070999905],
              [-26.452381964999915, -57.81178150799991],
              [-26.47874915299991, -57.802666924999926],
              [-26.499989386999914, -57.78850676899992],
              [-26.513050910999937, -57.772556247999944],
              [-26.47765051999994, -57.74488697699991],
              [-26.458729620999918, -57.73845794099992],
              [-26.437977667999917, -57.74456145599993],
              [-26.433216925999943, -57.75090911299992],
              [-26.42479407499991, -57.770603122999944],
              [-26.416859503999945, -57.77874114399992],
              [-26.403187628999945, -57.78435637799993],
              [-26.38817298099991, -57.78639088299991],
              [-26.356027798999946, -57.786228122999944],
              [-26.371937628999945, -57.79705169099992],
              [-26.388661261999914, -57.80348072699991],
              [-26.424305792999917, -57.812758070999905],
            ],
          ],
          [
            [
              [-26.732818162999934, -57.05934010199991],
              [-26.71320553299995, -57.04843515399995],
              [-26.690337693999936, -57.0505510399999],
              [-26.668120897999927, -57.062432549999926],
              [-26.65025794199994, -57.07976653399993],
              [-26.655018683999913, -57.080010674999926],
              [-26.657826300999943, -57.0818010399999],
              [-26.660267706999946, -57.084242445999905],
              [-26.663889126999948, -57.08668385199991],
              [-26.670725063999953, -57.07976653399993],
              [-26.683216925999943, -57.08131275799991],
              [-26.69953365799995, -57.07586028399993],
              [-26.732818162999934, -57.05934010199991],
            ],
          ],
          [
            [
              [-27.150502081999946, -56.675713799999926],
              [-27.134917772999927, -56.67864348799992],
              [-27.112212693999936, -56.68596770599993],
              [-27.094227667999917, -56.69589609199994],
              [-27.09243730399993, -56.70647551899992],
              [-27.107085740999935, -56.714776299999926],
              [-27.164173956999946, -56.72421640399995],
              [-27.19627844999991, -56.71949635199991],
              [-27.207590298999946, -56.713148695999905],
              [-27.21198482999995, -56.69963958099993],
              [-27.20457923099991, -56.69019947699991],
              [-27.18736731699994, -56.68254973799992],
              [-27.16698157499991, -56.6775041649999],
              [-27.150502081999946, -56.675713799999926],
            ],
          ],
          [
            [
              [-27.609771287999934, -56.29216887799993],
              [-27.59333248599995, -56.277276299999926],
              [-27.57249915299991, -56.272556247999944],
              [-27.54987545499995, -56.27556731599992],
              [-27.527902798999946, -56.28476327899995],
              [-27.527902798999946, -56.29216887799993],
              [-27.543120897999927, -56.297133070999905],
              [-27.556467251999948, -56.310804945999905],
              [-27.56899980399993, -56.320570570999905],
              [-27.582508917999917, -56.31324635199991],
              [-27.602162238999938, -56.29656340899993],
              [-27.609771287999934, -56.29216887799993],
            ],
          ],
          [
            [
              [-37.08307857999995, -54.465915622999944],
              [-37.06826738199993, -54.46428801899992],
              [-37.04873613199993, -54.474541924999926],
              [-37.01817786399994, -54.49651458099993],
              [-37.01817786399994, -54.50335051899992],
              [-37.025502081999946, -54.50286223799992],
              [-37.02993730399993, -54.504978122999944],
              [-37.03368079299992, -54.508070570999905],
              [-37.03868567599994, -54.510837497999944],
              [-37.063059048999946, -54.513929945999905],
              [-37.07457434799994, -54.51336028399993],
              [-37.086496548999946, -54.510837497999944],
              [-37.086496548999946, -54.50335051899992],
              [-37.06663977799991, -54.50335051899992],
              [-37.10757402299993, -54.48967864399992],
              [-37.10997473899994, -54.47698333099993],
              [-37.10293535099993, -54.471774997999944],
              [-37.09211178299995, -54.46949635199991],
              [-37.08307857999995, -54.465915622999944],
            ],
          ],
          [
            [
              [-38.08702551999994, -54.0036760399999],
              [-38.07799231699994, -53.9919572899999],
              [-38.06236731699994, -53.9880510399999],
              [-38.02619381399995, -53.98943450299993],
              [-38.06578528599994, -54.00237395599993],
              [-38.07632402299993, -54.003838799999926],
              [-38.08702551999994, -54.0036760399999],
            ],
          ],
          [
            [
              [-35.90880286399994, -54.6872697899999],
              [-35.93578040299991, -54.68906015399995],
              [-35.91478430899991, -54.71526458099993],
              [-35.87149003799993, -54.73691171699994],
              [-35.82241777299993, -54.75156015399995],
              [-35.78429114499994, -54.75725676899992],
              [-35.78429114499994, -54.764743747999944],
              [-35.79718990799995, -54.766696872999944],
              [-35.81094316299993, -54.77206796699994],
              [-35.82201087099992, -54.77947356599992],
              [-35.82652747299994, -54.78769296699994],
              [-35.83511308499993, -54.79070403399993],
              [-35.85460364499994, -54.789727471999925],
              [-35.88731848899994, -54.78443775799991],
              [-35.90733801999994, -54.804620049999926],
              [-35.93736731699994, -54.80999114399992],
              [-35.96983801999994, -54.80608489399992],
              [-35.99718176999994, -54.79810963299991],
              [-36.046864386999914, -54.77597421699994],
              [-36.07555091099994, -54.766696872999944],
              [-36.10643469999991, -54.764743747999944],
              [-36.096587693999936, -54.7751604149999],
              [-36.083973761999914, -54.78337981599992],
              [-36.06993567599994, -54.78875090899993],
              [-36.05581620999993, -54.79070403399993],
              [-36.043080206999946, -54.79412200299993],
              [-36.02301998599995, -54.81113046699994],
              [-36.01085364499994, -54.818617445999905],
              [-36.000070766999954, -54.822198174999926],
              [-35.989165818999936, -54.8239885399999],
              [-35.96304277299993, -54.824883721999925],
              [-35.95348059799994, -54.82781340899993],
              [-35.93382727799991, -54.8415666649999],
              [-35.92202714799993, -54.845961195999905],
              [-35.92202714799993, -54.852227471999925],
              [-35.93317623599995, -54.85312265399995],
              [-35.94383704299992, -54.85271575299993],
              [-35.95384680899991, -54.85051848799992],
              [-35.96304277299993, -54.845961195999905],
              [-35.961008266999954, -54.850681247999944],
              [-35.95807857999995, -54.86191171699994],
              [-35.95616614499994, -54.86646900799991],
              [-35.98517818899995, -54.8669572899999],
              [-35.996205206999946, -54.8630510399999],
              [-36.004017706999946, -54.852227471999925],
              [-36.00772050699993, -54.86532968499995],
              [-36.007476365999935, -54.87078215899993],
              [-36.004017706999946, -54.87948984199994],
              [-36.01667232999995, -54.87965260199991],
              [-36.03783118399991, -54.87468840899993],
              [-36.04898027299993, -54.873304945999905],
              [-36.05516516799992, -54.87623463299991],
              [-36.062611456999946, -54.88225676899992],
              [-36.07262122299994, -54.88730234199994],
              [-36.10179602799991, -54.88746510199991],
              [-36.11595618399991, -54.8845354149999],
              [-36.12730872299994, -54.877618096999925],
              [-36.13438880099994, -54.86646900799991],
              [-36.12515214799993, -54.865899346999925],
              [-36.11896725199995, -54.86419036299992],
              [-36.10643469999991, -54.85906340899993],
              [-36.147368943999936, -54.845961195999905],
              [-36.19237219999991, -54.811211846999925],
              [-36.211781378999945, -54.8064104149999],
              [-36.23501542899993, -54.79509856599992],
              [-36.271555141999954, -54.77092864399992],
              [-36.27306067599994, -54.75660572699991],
              [-36.28343665299991, -54.758477471999925],
              [-36.298817511999914, -54.74358489399992],
              [-36.294992641999954, -54.728448174999926],
              [-36.30382239499994, -54.71103280999995],
              [-36.31232662699995, -54.69036223799992],
              [-36.34642493399991, -54.654229424999926],
              [-36.42174231699994, -54.59335702899995],
              [-36.435658331999946, -54.585870049999926],
              [-36.448475714999915, -54.58489348799992],
              [-36.46446692599994, -54.58171965899993],
              [-36.47801673099991, -54.57634856599992],
              [-36.48375403599994, -54.56853606599992],
              [-36.480458136999914, -54.55754973799992],
              [-36.46629798099991, -54.54534270599993],
              [-36.46328691299993, -54.53753020599993],
              [-36.47443600199995, -54.52385833099993],
              [-36.49901282499991, -54.51051197699991],
              [-36.52529863199993, -54.50058359199994],
              [-36.54181881399995, -54.49651458099993],
              [-36.57013912699995, -54.49667734199994],
              [-36.58067786399994, -54.49960702899995],
              [-36.600819464999915, -54.51376718499995],
              [-36.61465410099993, -54.51604583099993],
              [-36.62913977799991, -54.51490650799991],
              [-36.641468878999945, -54.510837497999944],
              [-36.65851803299995, -54.49879322699991],
              [-36.670033331999946, -54.48723723799992],
              [-36.68431555899991, -54.47698333099993],
              [-36.78551184799994, -54.44866301899992],
              [-36.792632615999935, -54.448337497999944],
              [-36.80190995999993, -54.44931405999995],
              [-36.80996660099993, -54.4489885399999],
              [-36.813384568999936, -54.44500090899993],
              [-36.81224524599992, -54.440524997999944],
              [-36.80724036399994, -54.42929452899995],
              [-36.805978969999956, -54.427666924999926],
              [-36.805897589999915, -54.42262135199991],
              [-36.800445115999935, -54.41529713299991],
              [-36.79906165299991, -54.41090260199991],
              [-36.80028235599991, -54.40325286299992],
              [-36.80337480399993, -54.40276458099993],
              [-36.807932094999956, -54.40374114399992],
              [-36.813384568999936, -54.40097421699994],
              [-36.828236456999946, -54.39006926899992],
              [-36.84727942599994, -54.38355885199991],
              [-36.86815344999991, -54.38054778399993],
              [-36.88849850199995, -54.37981536299992],
              [-36.88101152299993, -54.372979424999926],
              [-36.90147864499994, -54.36679452899995],
              [-36.89565995999993, -54.35662200299993],
              [-36.88613847599993, -54.35198333099993],
              [-36.87413489499994, -54.35125090899993],
              [-36.86050370999993, -54.352634372999944],
              [-36.88451087099992, -54.33635833099993],
              [-36.92357337099992, -54.3357072899999],
              [-37.00145423099991, -54.34579843499995],
              [-37.01447506399995, -54.34343840899993],
              [-37.05296790299991, -54.33123137799993],
              [-37.07306881399995, -54.32170989399992],
              [-37.08242753799993, -54.31568775799991],
              [-37.086496548999946, -54.311618747999944],
              [-37.08568274599992, -54.30478280999995],
              [-37.08116614499994, -54.29550546699994],
              [-37.08023027299993, -54.28728606599992],
              [-37.089914516999954, -54.28362395599993],
              [-37.10301673099991, -54.281182549999926],
              [-37.11896725199995, -54.2751604149999],
              [-37.13426673099991, -54.267510674999926],
              [-37.145415818999936, -54.260023695999905],
              [-37.15339107999995, -54.25750090899993],
              [-37.17227128799993, -54.261651299999926],
              [-37.18297278599994, -54.260023695999905],
              [-37.200062628999945, -54.25318775799991],
              [-37.22362219999991, -54.24944426899992],
              [-37.24156653599994, -54.25042083099993],
              [-37.270375128999945, -54.26067473799992],
              [-37.33116614499994, -54.264743747999944],
              [-37.350168423999946, -54.26881275799991],
              [-37.36827551999994, -54.27743905999995],
              [-37.374256964999915, -54.27044036299992],
              [-37.38255774599992, -54.26653411299992],
              [-37.39220130099994, -54.26604583099993],
              [-37.402455206999946, -54.26995208099993],
              [-37.41368567599994, -54.25530364399992],
              [-37.40965735599991, -54.24846770599993],
              [-37.33458411399994, -54.22966887799993],
              [-37.319203253999945, -54.22909921699994],
              [-37.33849036399994, -54.21379973799992],
              [-37.39439856699994, -54.2009416649999],
              [-37.40925045499995, -54.18181731599992],
              [-37.36754309799994, -54.18238697699991],
              [-37.321197068999936, -54.173760674999926],
              [-37.23729407499991, -54.14771900799991],
              [-37.26211503799993, -54.14104583099993],
              [-37.35342363199993, -54.14120859199994],
              [-37.38809160099993, -54.14771900799991],
              [-37.40078691299993, -54.14511484199994],
              [-37.42430579299992, -54.13551197699991],
              [-37.43626868399991, -54.133477471999925],
              [-37.52904212099992, -54.133477471999925],
              [-37.55321204299992, -54.13762786299992],
              [-37.56200110599991, -54.14690520599993],
              [-37.55516516799992, -54.15642669099992],
              [-37.53270423099991, -54.16130950299993],
              [-37.55113684799994, -54.165948174999926],
              [-37.62970943899995, -54.17546965899993],
              [-37.66877193899995, -54.17310963299991],
              [-37.68980872299994, -54.17441171699994],
              [-37.68504798099991, -54.17001718499995],
              [-37.68040930899991, -54.16423919099992],
              [-37.67613684799994, -54.16130950299993],
              [-37.689442511999914, -54.156182549999926],
              [-37.72451738199993, -54.133477471999925],
              [-37.68814042899993, -54.12029387799993],
              [-37.67007402299993, -54.111260674999926],
              [-37.65562903599994, -54.09929778399993],
              [-37.67174231699994, -54.09612395599993],
              [-37.706288214999915, -54.098321221999925],
              [-37.72451738199993, -54.092461846999925],
              [-37.66128495999993, -54.07317473799992],
              [-37.63158118399991, -54.05901458099993],
              [-37.61465410099993, -54.03785572699991],
              [-37.734486456999946, -54.03785572699991],
              [-37.79283606699994, -54.044040622999944],
              [-37.807850714999915, -54.04119231599992],
              [-37.82917232999995, -54.03215911299992],
              [-37.84064693899995, -54.03045012799993],
              [-37.896595831999946, -54.043226820999905],
              [-37.927723761999914, -54.045586846999925],
              [-37.95360266799992, -54.03411223799992],
              [-37.973215298999946, -54.02809010199991],
              [-38.012277798999946, -54.05201588299991],
              [-38.03237870999993, -54.051446221999925],
              [-38.02989661399994, -54.04192473799992],
              [-38.02521725199995, -54.03289153399993],
              [-38.01732337099992, -54.02613697699991],
              [-38.005116339999915, -54.02361419099992],
              [-38.00991777299993, -54.01572030999995],
              [-38.014556443999936, -54.01116301899992],
              [-38.02139238199993, -54.00945403399993],
              [-38.03237870999993, -54.00994231599992],
              [-38.01585852799991, -54.00408294099992],
              [-37.964182094999956, -54.0036760399999],
              [-37.91246497299994, -53.99098072699991],
              [-37.891835089999915, -53.98943450299993],
              [-37.870432094999956, -53.99260833099993],
              [-37.83726966099994, -54.00676848799992],
              [-37.82013912699995, -54.00994231599992],
              [-37.798939581999946, -54.00790780999995],
              [-37.77684485599991, -54.00237395599993],
              [-37.755848761999914, -53.99374765399995],
              [-37.73818925699993, -53.98259856599992],
              [-37.738270636999914, -53.97323984199994],
              [-37.71666419199994, -53.9724260399999],
              [-37.688791469999956, -53.976820570999905],
              [-37.669911261999914, -53.98259856599992],
              [-37.67910722599993, -53.98495859199994],
              [-37.68423417899993, -53.98796965899993],
              [-37.687163865999935, -53.99374765399995],
              [-37.68980872299994, -54.0036760399999],
              [-37.49242102799991, -54.00042083099993],
              [-37.42162024599992, -53.98593515399995],
              [-37.38194739499994, -53.98259856599992],
              [-37.38194739499994, -53.98943450299993],
              [-37.443348761999914, -54.00994231599992],
              [-37.43651282499991, -54.0173479149999],
              [-37.443348761999914, -54.03045012799993],
              [-37.46385657499991, -54.03045012799993],
              [-37.44277910099993, -54.042901299999926],
              [-37.426340298999946, -54.049086195999905],
              [-37.40884355399993, -54.05136484199994],
              [-37.38499915299991, -54.051446221999925],
              [-37.376291469999956, -54.05038827899995],
              [-37.35924231699994, -54.045179945999905],
              [-37.35057532499991, -54.044040622999944],
              [-37.29255123599995, -54.044040622999944],
              [-37.23281816299993, -54.06755950299993],
              [-37.22362219999991, -54.06853606599992],
              [-37.21739661399994, -54.05242278399993],
              [-37.202381964999915, -54.04892343499995],
              [-37.18455969999991, -54.04900481599992],
              [-37.16966712099992, -54.044040622999944],
              [-37.17137610599991, -54.03411223799992],
              [-37.15599524599992, -54.03142669099992],
              [-37.13536536399994, -54.03183359199994],
              [-37.121205206999946, -54.03045012799993],
              [-37.13971920499995, -54.045993747999944],
              [-37.13345292899993, -54.05038827899995],
              [-37.11758378799993, -54.05006275799991],
              [-37.10757402299993, -54.051446221999925],
              [-37.10814368399991, -54.06218840899993],
              [-37.11778723899994, -54.06991952899995],
              [-37.14171301999994, -54.078789971999925],
              [-37.137562628999945, -54.08798593499995],
              [-37.13853919199994, -54.096774997999944],
              [-37.14293372299994, -54.1052385399999],
              [-37.14915930899991, -54.113539320999905],
              [-37.12242591099994, -54.11191171699994],
              [-37.10179602799991, -54.09880950299993],
              [-37.082590298999946, -54.08098723799992],
              [-37.059803839999915, -54.065118096999925],
              [-37.03726152299993, -54.05779387799993],
              [-37.00523841099994, -54.05201588299991],
              [-36.97813880099994, -54.05478280999995],
              [-36.970366990999935, -54.07195403399993],
              [-37.01329505099994, -54.09644947699991],
              [-37.03148352799991, -54.11052825299993],
              [-37.01817786399994, -54.119805596999925],
              [-36.99632727799991, -54.1169572899999],
              [-36.91576087099992, -54.08562590899993],
              [-36.921131964999915, -54.08245208099993],
              [-36.93101966099994, -54.074883721999925],
              [-36.93626868399991, -54.07195403399993],
              [-36.91478430899991, -54.06796640399995],
              [-36.89142818899995, -54.06951262799993],
              [-36.84007727799991, -54.078789971999925],
              [-36.81265214799993, -54.08847421699994],
              [-36.805978969999956, -54.092461846999925],
              [-36.80406653599994, -54.10312265399995],
              [-36.81627356699994, -54.11565520599993],
              [-36.813384568999936, -54.12664153399993],
              [-36.81822669199994, -54.13534921699994],
              [-36.81322180899991, -54.141289971999925],
              [-36.80296790299991, -54.14348723799992],
              [-36.79165605399993, -54.14031340899993],
              [-36.78807532499991, -54.13298919099992],
              [-36.78425045499995, -54.108086846999925],
              [-36.778635219999956, -54.09929778399993],
              [-36.75352942599994, -54.09392669099992],
              [-36.65510006399995, -54.106133721999925],
              [-36.66258704299992, -54.113539320999905],
              [-36.64293372299994, -54.11402760199991],
              [-36.63158118399991, -54.11565520599993],
              [-36.62157141799992, -54.119805596999925],
              [-36.62157141799992, -54.12664153399993],
              [-36.629790818999936, -54.13518645599993],
              [-36.63231360599991, -54.13941822699991],
              [-36.63524329299992, -54.14771900799991],
              [-36.65208899599992, -54.141289971999925],
              [-36.67007402299993, -54.14023202899995],
              [-36.68773352799991, -54.144463799999926],
              [-36.70348059799994, -54.15390390399995],
              [-36.67540442599994, -54.158135674999926],
              [-36.664133266999954, -54.16179778399993],
              [-36.66877193899995, -54.168226820999905],
              [-36.68049068899995, -54.170993747999944],
              [-36.705189581999946, -54.17050546699994],
              [-36.71715247299994, -54.17441171699994],
              [-36.69155839799993, -54.18417734199994],
              [-36.65916907499991, -54.18206145599993],
              [-36.59984290299991, -54.168226820999905],
              [-36.54181881399995, -54.16130950299993],
              [-36.53335527299993, -54.16692473799992],
              [-36.52440344999991, -54.17701588299991],
              [-36.51305091099994, -54.182712497999944],
              [-36.49746660099993, -54.17441171699994],
              [-36.49266516799992, -54.1814104149999],
              [-36.491118943999936, -54.18499114399992],
              [-36.49266516799992, -54.188571872999944],
              [-36.49746660099993, -54.19548919099992],
              [-36.512562628999945, -54.188164971999925],
              [-36.52887936099995, -54.187758070999905],
              [-36.55894934799994, -54.19548919099992],
              [-36.573109503999945, -54.20232512799993],
              [-36.657460089999915, -54.23943450299993],
              [-36.66429602799991, -54.24114348799992],
              [-36.669992641999954, -54.24358489399992],
              [-36.67564856699994, -54.24944426899992],
              [-36.67414303299995, -54.25400155999995],
              [-36.66893469999991, -54.25994231599992],
              [-36.66706295499995, -54.26767343499995],
              [-36.67564856699994, -54.27743905999995],
              [-36.650461391999954, -54.2790666649999],
              [-36.630848761999914, -54.27776458099993],
              [-36.613270636999914, -54.27271900799991],
              [-36.54507402299993, -54.23772551899992],
              [-36.51903235599991, -54.23186614399992],
              [-36.50426184799994, -54.24277109199994],
              [-36.491851365999935, -54.234633070999905],
              [-36.477406378999945, -54.23886484199994],
              [-36.468861456999946, -54.25090911299992],
              [-36.473866339999915, -54.26653411299992],
              [-36.481678839999915, -54.26970794099992],
              [-36.491851365999935, -54.27011484199994],
              [-36.500559048999946, -54.272149346999925],
              [-36.50426184799994, -54.28053150799991],
              [-36.50108801999994, -54.28630950299993],
              [-36.49518795499995, -54.28923919099992],
              [-36.49209550699993, -54.29387786299992],
              [-36.49746660099993, -54.30478280999995],
              [-36.48770097599993, -54.3142229149999],
              [-36.48582923099991, -54.324883721999925],
              [-36.48973548099991, -54.33562590899993],
              [-36.49746660099993, -54.34579843499995],
              [-36.45811926999994, -54.318291924999926],
              [-36.43663489499994, -54.31015390399995],
              [-36.41893469999991, -54.31462981599992],
              [-36.39281165299991, -54.34319426899992],
              [-36.375070766999954, -54.35605234199994],
              [-36.354074673999946, -54.359307549999926],
              [-36.33653723899994, -54.351495049999926],
              [-36.33849036399994, -54.338148695999905],
              [-36.34825598899994, -54.32073333099993],
              [-36.354074673999946, -54.301039320999905],
              [-36.357492641999954, -54.29355234199994],
              [-36.38072669199994, -54.27743905999995],
              [-36.38780676999994, -54.2693010399999],
              [-36.391916469999956, -54.26287200299993],
              [-36.393788214999915, -54.254978122999944],
              [-36.39443925699993, -54.24277109199994],
              [-36.32921301999994, -54.25725676899992],
              [-36.298898891999954, -54.26816171699994],
              [-36.29198157499991, -54.28362395599993],
              [-36.28034420499995, -54.28215911299992],
              [-36.26903235599991, -54.28215911299992],
              [-36.260609503999945, -54.285414320999905],
              [-36.25723222599993, -54.29420338299991],
              [-36.25548255099994, -54.30510833099993],
              [-36.25304114499994, -54.31292083099993],
              [-36.25462805899991, -54.31910572699991],
              [-36.26471920499995, -54.325290622999944],
              [-36.23468990799995, -54.33879973799992],
              [-36.23534094999991, -54.3435197899999],
              [-36.24885006399995, -54.350274346999925],
              [-36.25723222599993, -54.36988697699991],
              [-36.24388587099992, -54.375258070999905],
              [-36.16169186099995, -54.372979424999926],
              [-36.16445878799993, -54.38616301899992],
              [-36.165272589999915, -54.39934661299992],
              [-36.17100989499994, -54.40976327899995],
              [-36.18895423099991, -54.41464609199994],
              [-36.18394934799994, -54.42392343499995],
              [-36.17625891799992, -54.43027109199994],
              [-36.16637122299994, -54.433851820999905],
              [-36.154855923999946, -54.43515390399995],
              [-36.15501868399991, -54.44394296699994],
              [-36.14635169199994, -54.44980234199994],
              [-36.13341223899994, -54.453383070999905],
              [-36.12071692599994, -54.45566171699994],
              [-36.11481686099995, -54.4548479149999],
              [-36.10020911399994, -54.44866301899992],
              [-36.09292558499993, -54.45175546699994],
              [-36.07603919199994, -54.46249765399995],
              [-36.05150305899991, -54.461195570999905],
              [-36.04198157499991, -54.463962497999944],
              [-36.03815670499995, -54.472588799999926],
              [-36.03506425699993, -54.48406340899993],
              [-36.02725175699993, -54.49146900799991],
              [-36.01622473899994, -54.49537525799991],
              [-36.03351803299995, -54.50448984199994],
              [-36.05638587099992, -54.51482512799993],
              [-36.10020911399994, -54.54501718499995],
              [-36.088449673999946, -54.55152760199991],
              [-36.06981360599991, -54.566664320999905],
              [-36.05923417899993, -54.57170989399992],
              [-36.04328365799995, -54.57350025799991],
              [-35.95059160099993, -54.570570570999905],
              [-35.93578040299991, -54.565524997999944],
              [-35.910145636999914, -54.55201588299991],
              [-35.89830481699994, -54.5485979149999],
              [-35.88731848899994, -54.55120208099993],
              [-35.89122473899994, -54.562432549999926],
              [-35.90843665299991, -54.59270598799992],
              [-35.93179277299993, -54.61760833099993],
              [-35.93578040299991, -54.62004973799992],
              [-35.91193600199995, -54.66480885199991],
              [-35.90880286399994, -54.6872697899999],
            ],
          ],
          [
            [
              [-28.213286912999934, -56.713962497999944],
              [-28.193104620999918, -56.70403411299992],
              [-28.17145748599995, -56.7048479149999],
              [-28.168568488999938, -56.71599700299993],
              [-28.187123175999943, -56.72625090899993],
              [-28.210113084999932, -56.72503020599993],
              [-28.213286912999934, -56.713962497999944],
            ],
          ],
        ],
      },
    },
    {
      type: 'Feature',
      properties: {
        name: 'Clipperton I.',
        iso3: '-99',
      },
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-109.21202551999994, 10.302679755000042],
            [-109.21035722599993, 10.288723049000055],
            [-109.21857662699995, 10.28156159100007],
            [-109.22801673099991, 10.292141018000052],
            [-109.23424231699994, 10.307928778000075],
            [-109.22594153599994, 10.311021226000037],
            [-109.21202551999994, 10.302679755000042],
          ],
        ],
      },
    },
  ],
};
